// 2. This code loads the IFrame Player API code asynchronously.
var tag = document.createElement('script');

tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

// 3. This function creates an <iframe> (and YouTube player)
//    after the API code downloads.
var player;
function onYouTubeIframeAPIReady() {
  player = new YT.Player('player', {
    height: '',
    width: '',
    videoId: '',
    events: {
      'onReady': onPlayerReady,
      'onStateChange': onPlayerStateChange
    }
  });
}

// 4. The API will call this function when the video player is ready.
function onPlayerReady(event) {
  event.target.playVideo();
}

// 5. The API calls this function when the player's state changes.
//    The function indicates that when playing a video (state=1),
//    the player should play for six seconds and then stop.
var done = false;
function onPlayerStateChange(event) {
  if (event.data == YT.PlayerState.PLAYING && !done) {
    setTimeout(stopVideo, 6000);
    done = true;
  }
}
function stopVideo() {
  player.stopVideo();
}

/*!
 * MediaElement.js
 * http://www.mediaelementjs.com/
 *
 * Wrapper that mimics native HTML5 MediaElement (audio and video)
 * using a variety of technologies (pure JavaScript, Flash, iframe)
 *
 * Copyright 2010-2017, John Dyer (http://j.hn/)
 * License: MIT
 *
 */(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
'use strict';

var VrAPI = {
	isMediaStarted: false,

	isMediaLoaded: false,

	creationQueue: [],

	prepareSettings: function prepareSettings(settings) {
		if (VrAPI.isLoaded) {
			VrAPI.createInstance(settings);
		} else {
			VrAPI.loadScript(settings);
			VrAPI.creationQueue.push(settings);
		}
	},

	loadScript: function loadScript(settings) {
		if (!VrAPI.isMediaStarted) {

			if (typeof VRView !== 'undefined') {
				VrAPI.createInstance(settings);
			} else {
				var script = document.createElement('script'),
				    firstScriptTag = document.getElementsByTagName('script')[0];

				var done = false;

				settings.options.path = typeof settings.options.path === 'string' ? settings.options.path : 'https://storage.googleapis.com/vrview/2.0/build/vrview.min.js';

				script.src = settings.options.path;

				script.onload = script.onreadystatechange = function () {
					if (!done && (!this.readyState || this.readyState === undefined || this.readyState === 'loaded' || this.readyState === 'complete')) {
						done = true;
						VrAPI.mediaReady();
						script.onload = script.onreadystatechange = null;
					}
				};

				firstScriptTag.parentNode.insertBefore(script, firstScriptTag);
			}
			VrAPI.isMediaStarted = true;
		}
	},

	mediaReady: function mediaReady() {
		VrAPI.isLoaded = true;
		VrAPI.isMediaLoaded = true;

		while (VrAPI.creationQueue.length > 0) {
			var settings = VrAPI.creationQueue.pop();
			VrAPI.createInstance(settings);
		}
	},

	createInstance: function createInstance(settings) {
		var player = new VRView.Player('#' + settings.id, settings.options);
		window['__ready__' + settings.id](player);
	}
};

var VrRenderer = {
	name: 'vrview',

	options: {
		prefix: 'vrview'
	},

	canPlayType: function canPlayType(type) {
		return ~['video/mp4', 'application/x-mpegurl', 'vnd.apple.mpegurl', 'application/dash+xml'].indexOf(type.toLowerCase());
	},

	create: function create(mediaElement, options, mediaFiles) {
		var stack = [],
		    vr = {},
		    readyState = 4;

		var vrPlayer = null,
		    paused = true,
		    volume = 1,
		    oldVolume = volume,
		    bufferedTime = 0,
		    ended = false,
		    duration = 0,
		    url = '';

		vr.options = options;
		vr.id = mediaElement.id + '_' + options.prefix;
		vr.mediaElement = mediaElement;

		var props = mejs.html5media.properties,
		    assignGettersSetters = function assignGettersSetters(propName) {

			var capName = propName.substring(0, 1).toUpperCase() + propName.substring(1);

			vr['get' + capName] = function () {
				if (vrPlayer !== null) {
					var value = null;

					switch (propName) {
						case 'currentTime':
							return vrPlayer.getCurrentTime();
						case 'duration':
							return vrPlayer.getDuration();
						case 'volume':
							volume = vrPlayer.getVolume();
							return volume;
						case 'muted':
							return volume === 0;
						case 'paused':
							paused = vrPlayer.isPaused;
							return paused;
						case 'ended':
							return ended;
						case 'src':
							return url;
						case 'buffered':
							return {
								start: function start() {
									return 0;
								},
								end: function end() {
									return bufferedTime * duration;
								},
								length: 1
							};
						case 'readyState':
							return readyState;
					}

					return value;
				} else {
					return null;
				}
			};

			vr['set' + capName] = function (value) {

				if (vrPlayer !== null) {
					switch (propName) {

						case 'src':
							var _url = typeof value === 'string' ? value : value[0].src;
							vrPlayer.setContentInfo({ video: _url });
							break;

						case 'currentTime':
							vrPlayer.setCurrentTime(value);
							setTimeout(function () {
								var event = mejs.Utils.createEvent('timeupdate', vr);
								mediaElement.dispatchEvent(event);
							}, 50);
							break;

						case 'volume':
							vrPlayer.setVolume(value);
							setTimeout(function () {
								var event = mejs.Utils.createEvent('volumechange', vr);
								mediaElement.dispatchEvent(event);
							}, 50);
							break;
						case 'muted':
							volume = value ? 0 : oldVolume;
							vrPlayer.setVolume(volume);
							setTimeout(function () {
								var event = mejs.Utils.createEvent('volumechange', vr);
								mediaElement.dispatchEvent(event);
							}, 50);
							break;
						case 'readyState':
							var event = mejs.Utils.createEvent('canplay', vr);
							mediaElement.dispatchEvent(event);
							break;
						default:
							console.log('VRView ' + vr.id, propName, 'UNSUPPORTED property');
							break;
					}
				} else {
					stack.push({ type: 'set', propName: propName, value: value });
				}
			};
		};
		for (var i = 0, il = props.length; i < il; i++) {
			assignGettersSetters(props[i]);
		}

		var methods = mejs.html5media.methods,
		    assignMethods = function assignMethods(methodName) {
			vr[methodName] = function () {

				if (vrPlayer !== null) {
					switch (methodName) {
						case 'play':
							return vrPlayer.play();
						case 'pause':
							return vrPlayer.pause();
						case 'load':
							return null;

					}
				} else {
					stack.push({ type: 'call', methodName: methodName });
				}
			};
		};
		for (var _i = 0, _il = methods.length; _i < _il; _i++) {
			assignMethods(methods[_i]);
		}

		var vrContainer = document.createElement('div');
		vrContainer.setAttribute('id', vr.id);
		vrContainer.style.width = '100%';
		vrContainer.style.height = '100%';

		window['__ready__' + vr.id] = function (_vrPlayer) {

			mediaElement.vrPlayer = vrPlayer = _vrPlayer;

			var iframe = vrContainer.querySelector('iframe');
			iframe.style.width = '100%';
			iframe.style.height = '100%';

			if (stack.length) {
				for (var _i2 = 0, _il2 = stack.length; _i2 < _il2; _i2++) {

					var stackItem = stack[_i2];

					if (stackItem.type === 'set') {
						var propName = stackItem.propName,
						    capName = '' + propName.substring(0, 1).toUpperCase() + propName.substring(1);

						vr['set' + capName](stackItem.value);
					} else if (stackItem.type === 'call') {
						vr[stackItem.methodName]();
					}
				}
			}

			vrPlayer.on('ready', function () {

				var events = mejs.html5media.events.concat(['mouseover', 'mouseout']);

				var _loop = function _loop(_i3, _il3) {
					vrPlayer.on(events[_i3], function () {
						var event = mejs.Utils.createEvent(events[_i3], vr);
						mediaElement.dispatchEvent(event);
					});
				};

				for (var _i3 = 0, _il3 = events.length; _i3 < _il3; _i3++) {
					_loop(_i3, _il3);
				}
			});
		};

		mediaElement.originalNode.parentNode.insertBefore(vrContainer, mediaElement.originalNode);
		mediaElement.originalNode.style.display = 'none';

		var vrSettings = {
			path: options.vrPath,
			is_stereo: options.vrIsStereo,
			is_autopan_off: options.vrIsAutopanOff,
			is_debug: options.vrDebug,
			default_yaw: options.vrDefaultYaw,
			is_yaw_only: options.vrIsYawOnly,
			loop: options.loop
		};

		if (mediaFiles && mediaFiles.length > 0) {
			for (var _i4 = 0, _il4 = mediaFiles.length; _i4 < _il4; _i4++) {
				if (mejs.Renderers.renderers[options.prefix].canPlayType(mediaFiles[_i4].type)) {
					vrSettings.video = mediaFiles[_i4].src;
					vrSettings.width = '100%';
					vrSettings.height = '100%';
					break;
				}
			}
		}

		VrAPI.prepareSettings({
			options: vrSettings,
			id: vr.id
		});

		vr.hide = function () {
			vr.pause();
			if (vrPlayer) {
				vrContainer.style.display = 'none';
			}
		};

		vr.setSize = function () {};

		vr.show = function () {
			if (vrPlayer) {
				vrContainer.style.display = '';
			}
		};

		return vr;
	}
};

mejs.Renderers.add(VrRenderer);

Object.assign(mejs.MepDefaults, {
	vrPath: null,

	vrIsStereo: true,

	vrIsAutopanOff: true,

	vrDebug: false,

	vrDefaultYaw: 0,

	vrIsYawOnly: false
});

Object.assign(MediaElementPlayer.prototype, {
	buildvrview: function buildvrview(player, controls, layers, media) {

		var t = this;

		if (!t.isVideo || t.isVideo && t.media.rendererName !== null && !t.media.rendererName.match(/(native\_(dash|hls)|html5)/)) {
			return;
		}

		var button = document.createElement('div');

		player.detectFullscreenMode();

		button.className = t.options.classPrefix + 'button ' + t.options.classPrefix + 'vrview-button';
		button.innerHTML = '<button type="button" aria-controls="' + t.id + '" title="VR" aria-label="VR" tabindex="0"></button>';
		button.addEventListener('click', function () {
			var isFullScreen = mejs.Features.HAS_TRUE_NATIVE_FULLSCREEN && mejs.Features.IS_FULLSCREEN || player.isFullScreen;

			if (isFullScreen) {
				player.exitFullScreen();
			} else {
				player.enterFullScreen();
			}
		});

		t.globalBind('keydown', function (e) {
			var key = e.which || e.keyCode || 0;
			if (key === 27 && (mejs.Features.HAS_TRUE_NATIVE_FULLSCREEN && mejs.Features.IS_FULLSCREEN || player.isFullScreen)) {
				player.exitFullScreen();
			}
		});

		t.addControlElement(button, 'vrview');

		var url = media.getSrc(),
		    mediaFiles = [{ src: url, type: mejs.Utils.getTypeFromFile(url) }],
		    renderInfo = mejs.Renderers.select(mediaFiles, ['vrview']);

		media.changeRenderer(renderInfo.rendererName, mediaFiles);
	}
});

},{}]},{},[1]);

(function () {

    tinymce.PluginManager.add('qiupaste', function(editor) {
        function getSizes(editor) {
            var defaultSizes = [
                { text: '-',    value: '' },
                { text: 'Small',    value: 'img-25' },
                { text: 'Medium',   value: 'img-50' },
                { text: 'Large',    value: 'img-75' },
                { text: 'Full',     value: 'img-100' }
            ];

            return defaultSizes;
        }

        function showDialog() {
            var win = editor.windowManager.open({
                title: "Paste Embed",
                body: [
                    {
                        type: 'textbox',
                        name: 'code',
                        multiline: true,
                        minWidth: editor.getParam("code_dialog_width", 600),
                        minHeight: editor.getParam("code_dialog_height", Math.min(tinymce.DOM.getViewPort().h - 200, 500)),
                        spellcheck: false,
                        style: 'direction: ltr; text-align: left'
                    },
                    {
                        type: 'listbox',
                        name: 'size',
                        label: 'Size',
                        maxWidth: 200,
                        value: '',
                        values: getSizes(editor)
                    },
                ],
                onSubmit: function(e) {
                    // We get a lovely "Wrong document" error in IE 11 if we
                    // don't move the focus to the editor before creating an undo
                    // transation since it tries to make a bookmark for the current selection
                    editor.focus();

                    editor.undoManager.transact(function() {
                        var newContent  = '';
                        if (!e.data.size) {
                            newContent  = e.data.code;
                        } else {
                            $(e.data.code).each(function(index, elem) {
                                if ($(elem).prop('outerHTML')) {
                                    if ($(elem).is(':first-child')) {
                                        newContent = $(elem).addClass(e.data.size).attr('contentEditable','false').prop('outerHTML');
                                    } else {
                                        newContent += $(elem).prop('outerHTML');
                                    }
                                }
                            });
                        }
                        editor.insertContent(newContent);
                    });

                    editor.selection.setCursorLocation();
                    editor.nodeChanged();
                }
            });

            // Gecko has a major performance issue with textarea
            // contents so we need to set it when all reflows are done
            win.find('#code').value('');
        }

        editor.addButton('qiupaste', {
            icon: 'pastetext',
            tooltip: 'Insert Social Embed',
            onclick: showDialog,
            stateSelector: 'div[class="qiupaste"]'
        });

        editor.addCommand('mceQiuPaste', showDialog);

        this.showDialog = showDialog;

        editor.addMenuItem('qiupaste', {
            icon: 'pastetext',
            text: 'Insert Social Embed',
            onclick: showDialog,
            stateSelector: 'div[class="qiupaste"]',
            context: 'insert',
            prependToContext: true
        });
    });
})();
(function () {

    tinymce.PluginManager.add('qiumedia', function(editor) {
        function createQiuMediaList(callback) {
            return function() {
                var qiuMediaList = editor.settings.qiumedia_list;

                if (typeof qiuMediaList == "string") {
                    tinymce.util.XHR.send({
                        url: qiuMediaList,
                        success: function(text) {
                            callback(tinymce.util.JSON.parse(text));
                        }
                    });
                } else if (typeof qiuMediaList == "function") {
                    qiuMediaList(callback);
                } else {
                    callback(qiuMediaList);
                }
            };
        }

        function buildQiuMediaItems(inputQiuMedia, itemCallback, startItems) {
            function appendItems(values, output) {
                output = output || [];

                tinymce.each(values, function(item) {
                    var menuItem = {text: item.text || item.title};

                    if (item.menu) {
                        menuItem.menu = appendItems(item.menu);
                    } else {
                        menuItem.value = item.value;

                        if (itemCallback) {
                            itemCallback(menuItem);
                        }
                    }

                    output.push(menuItem);
                });

                return output;
            }

            return appendItems(inputQiuMedia, startItems || []);
        }

        function showDialog(linkQiuMedia) {
            var data = {}, selection = editor.selection, dom = editor.dom, selectedElm, anchorElm, initialText;
            var win, onlyText, textListCtrl, linkQiuMediaCtrl, relListCtrl, targetListCtrl, classListCtrl, linkTitleCtrl, value;

            function linkQiuMediaChangeHandler(e) {
                var textCtrl = win.find('#text');

                if (!textCtrl.value() || (e.lastControl && textCtrl.value() == e.lastControl.text())) {
                    textCtrl.value(e.control.text());
                }

                win.find('#href').value(e.control.value());
            }

            function buildAnchorListControl(url) {
                var anchorList = [];

                tinymce.each(editor.dom.select('a:not([href])'), function(anchor) {
                    var id = anchor.name || anchor.id;

                    if (id) {
                        anchorList.push({
                            text: id,
                            value: '#' + id,
                            selected: url.indexOf('#' + id) != -1
                        });
                    }
                });

                if (anchorList.length) {
                    anchorList.unshift({text: 'None', value: ''});

                    return {
                        name: 'anchor',
                        type: 'listbox',
                        label: 'Anchors',
                        values: anchorList,
                        onselect: linkQiuMediaChangeHandler
                    };
                }
            }

            function updateText() {
                if (!initialText && data.text.length === 0 && onlyText) {
                    this.parent().parent().find('#text')[0].value(this.value());
                }
            }

            function urlChange(e) {
                var meta = e.meta || {};

                if (linkQiuMediaCtrl) {
                    linkQiuMediaCtrl.value(editor.convertURL(this.value(), 'href'));
                }

                tinymce.each(e.meta, function(value, key) {
                    win.find('#' + key).value(value);
                });

                if (!meta.text) {
                    updateText.call(this);
                }
            }

            function isOnlyTextSelected(anchorElm) {
                var html = selection.getContent();

                // Partial html and not a fully selected anchor element
                if (/</.test(html) && (!/^<a [^>]+>[^<]+<\/a>$/.test(html) || html.indexOf('href=') == -1)) {
                    return false;
                }

                if (anchorElm) {
                    var nodes = anchorElm.childNodes, i;

                    if (nodes.length === 0) {
                        return false;
                    }

                    for (i = nodes.length - 1; i >= 0; i--) {
                        if (nodes[i].nodeType != 3) {
                            return false;
                        }
                    }
                }

                return true;
            }

            selectedElm = selection.getNode();
            anchorElm = dom.getParent(selectedElm, '.mce-content-body *[contentEditable=false]');
            onlyText = isOnlyTextSelected();

            data.text = anchorElm;
            data.qiumedia = anchorElm ? dom.getAttrib(anchorElm, 'data-qiumedia') : '';
            var qiuMediaData    = {
                mediaType: '',
                mediaSize: '',
                mediaAlign: '',
                mediaSort: '',
            };
            if (data.qiumedia) {
                var tinyOptions		= {
                    size: {
                        25: 1,
                        50: 1,
                        75: 1,
                        100: 1
                    },
                    align: {
                        left: 1,
                        center: 1,
                        right: 1
                    }
                }
                var qiuMediaExp = data.qiumedia.split('|')
                if (qiuMediaExp[0]  == 'imageid') {
                    qiuMediaData.mediaType = 1;
                } else if (qiuMediaExp[0]  == 'videoid') {
                    qiuMediaData.mediaType = 2;
                } else if (qiuMediaExp[0]  == 'audio') {
                    qiuMediaData.mediaType = 3;
                } else if (qiuMediaExp[0]  == 'file') {
                    qiuMediaData.mediaType = 4;
                }
                var toCheck = '';
                if (!angular.isUndefined(qiuMediaExp[1])) {
                    qiuMediaData.mediaSort  = qiuMediaExp[1];
                }
                for (i = 2; i <= qiuMediaExp.length; i++) {
                    if (!angular.isUndefined(qiuMediaExp[i])) {
                        toCheck = qiuMediaExp[i];
                        if (!angular.isUndefined(tinyOptions.size[toCheck])) {
                            qiuMediaData.mediaSize  = toCheck;
                        }
                        if (!angular.isUndefined(tinyOptions.align[toCheck])) {
                            qiuMediaData.mediaAlign  = toCheck;
                        }
                    }

                }
            }
            if (onlyText) {
                textListCtrl = {
                    name: 'text',
                    type: 'textbox',
                    size: 40,
                    label: 'Text to display',
                    onchange: function() {
                        data.text = this.value();
                    }
                };
            }

            if (linkQiuMedia) {
                linkQiuMediaCtrl = {
                    type: 'listbox',
                    label: 'Link list',
                    values: buildListItems(
                        linkQiuMedia,
                        function(item) {
                            item.value = data.qiumedia;
                        },
                        [{text: 'None', value: ''}]
                    ),
                    onselect: linkQiuMediaChangeHandler,
                    value: data.qiumedia,
                    onPostRender: function() {
                        /*eslint consistent-this:0*/
                        linkQiuMediaCtrl = this;
                    }
                };
            }

            //get your angular element
            var elem = angular.element(document.getElementById('content'));

            //get the scope.
            var $scope = elem.scope();

            //get the injector.
            var injector = elem.injector();

            //get the services.
            var $mdDialog       = injector.get('$mdDialog');
            var $state          = injector.get('$state');
            var $http           = injector.get('$http');
            var $document       = injector.get('$document');
            var contentService  = injector.get('contentService');
            var sessionService  = injector.get('sessionService');
            var $filter         = injector.get('$filter');
            var id              = $state.params.id;
            var vm              = $scope.vm;
            var zoneMedia      = {
                1: {},
                2: {},
                3: {},
                4:  {}
            };
            var typesMax        = {
                1: 0,
                2: 0,
                3: 0,
                4: 0
            };
            var currentSort     = 0;
            var currentType     = 0;
            var currentMedia    = vm.getCurrentMedia();
            if (vm.mediaZones) {
                var mediaZone   = 1;
            } else {
                var mediaZone   = '';
            }
            $mdDialog.show({
                controller          : 'MediaDialogController',
                controllerAs        : 'vm',
                locals              : {
                    autoUpload: '',
                    currentThread   : currentMedia,
                    section         : qiuMediaData,
                    mediazone       : mediaZone,
                    isTiny          : true,
                    maxAttach: undefined,
                    showViews: {
                    1: true,
                    2: true,
                    3: true,
                    4: true,
                    5: true,
                    upload: true,
                    import: true
                  }
                },
                templateUrl        : 'app/main/dialogs/media/media-dialog-tinymce.html',
                parent             : angular.element($document.body),
                clickOutsideToClose: true
            }).then(function (qiuMedia) {
              var showMedia = '';
              if (qiuMedia.mediaSort) {
                if (vm.mediaZones) {
                  var mediaFilterZone = $filter('filter')(vm.currentThread_Edit.Thumbnail, {'id_zone': 1}, true);
                } else {
                  var mediaFilterZone = angular.copy(vm.currentThread_Edit.Thumbnail);
                }
                for (var i = 0; i < mediaFilterZone.length; i++) {
                  currentType = vm.currentThread_Edit.Thumbnail[i]['media_type'];
                }
                var mediaFilter = $filter('filter')(mediaFilterZone, {media_type: qiuMedia.mediaType}, true);
                const found = Object.values(mediaFilter).find(x => x.id_media == qiuMedia.mediaSort)
                if (found) {
                  showMedia = found;
                }

                var media = ''
                var html = '';
                var classMedia = '';
                if (qiuMedia.mediaType == 1) {


                  if (showMedia.cropstatus.length) {
                    var container = sessionService.getContainerByID(showMedia.cropstatus[0].id_container);
                    var mediaUrl = container.view_url + showMedia.cropstatus[0].fileName;
                  } else {
                    var container = sessionService.getContainerByID(showMedia.cdnContainer);
                    var mediaUrl = container.view_url  + 'original/m' + showMedia.id_media + '_' + showMedia.filename;
                  }
                  html += 'imageid|';
                  media += '<img src="' + mediaUrl + '" class="qiumedia-image';
                  classMedia = 'qiumedia-image';
                } else if (qiuMedia.mediaType == 2) {
                  html += 'videoid|';
                  media += '<img src="' + showMedia.embed_thumb + '" class="qiumedia-video';
                  classMedia = 'qiumedia-video';
                } else if (qiuMedia.mediaType == 3) {
                  html += 'audio|';
                  media += 'AUDIO: ' + showMedia.filename + ' <span class="qiumedia-audio';
                } else if (qiuMedia.mediaType == 4) {
                  html += 'file|';
                  media += 'FILE: ' + showMedia.filename + ' <span class="qiumedia-file';
                }

                // html += qiuMedia.mediaSort;
                html += showMedia.id_media;
                if (qiuMedia.size.length > 0) {
                  html += '|' + qiuMedia.size;
                  media += ' size-' + qiuMedia.size;
                }
                if (qiuMedia.align.length > 0) {
                  html += '|' + qiuMedia.align;
                  media += ' align-' + qiuMedia.align;
                }
                if (media.length > 0) {
                  media += ' width-percent-100">';
                }
                if (anchorElm) {
                  var linkAttrs = {
                    "class": 'qiumedia align-' + qiuMedia.align+' size-' + qiuMedia.size + ' ' +classMedia,
                    "data-qiumedia": html
                  };
                  editor.focus();
                  anchorElm.innerHTML = media;
                  dom.setAttribs(anchorElm, linkAttrs);
                  selection.select(anchorElm);
                  editor.undoManager.add();
                } else {
                  var contentHtml = '<div contentEditable="false" class="qiumedia  align-' + qiuMedia.align +' size-' + qiuMedia.size + ' '+ classMedia +'" data-qiumedia="'+html+'">'+media+'</div>';
                  editor.insertContent(contentHtml);
                }
              }
            });
        }

        editor.addButton('qiumedia', {
            icon: 'image',
            tooltip: 'Insert Video/Image',
            onclick: createQiuMediaList(showDialog),
            stateSelector: '.mce-content-body div.qiumedia'
        });

        editor.addCommand('mceQiuMedia', createQiuMediaList(showDialog));

        this.showDialog = showDialog;

        editor.addMenuItem('qiumedia', {
            icon: 'media',
            text: 'Insert Video/Image',
            onclick: createQiuMediaList(showDialog),
            stateSelector: '.mce-content-body div[contentEditable=false]',
            context: 'insert',
            prependToContext: true
        });
    });
})();

/*!
 * MediaElement.js
 * http://www.mediaelementjs.com/
 *
 * Wrapper that mimics native HTML5 MediaElement (audio and video)
 * using a variety of technologies (pure JavaScript, Flash, iframe)
 *
 * Copyright 2010-2017, John Dyer (http://j.hn/)
 * License: MIT
 *
 */(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
'use strict';

mejs.i18n.en['mejs.source-chooser'] = 'Source Chooser';

Object.assign(mejs.MepDefaults, {
	sourcechooserText: null
});

Object.assign(MediaElementPlayer.prototype, {
	buildsourcechooser: function buildsourcechooser(player, controls, layers, media) {

		var t = this,
		    sourceTitle = mejs.Utils.isString(t.options.sourcechooserText) ? t.options.sourcechooserText : mejs.i18n.t('mejs.source-chooser'),
		    sources = [],
		    children = t.mediaFiles ? t.mediaFiles : t.node.children;

		var hoverTimeout = void 0;

		for (var i = 0, total = children.length; i < total; i++) {
			var s = children[i];

			if (t.mediaFiles) {
				sources.push(s);
			} else if (s.nodeName === 'SOURCE') {
				sources.push(s);
			}
		}

		if (sources.length <= 1) {
			return;
		}

		player.sourcechooserButton = document.createElement('div');
		player.sourcechooserButton.className = t.options.classPrefix + 'button ' + t.options.classPrefix + 'sourcechooser-button';
		player.sourcechooserButton.innerHTML = '<button type="button" role="button" aria-haspopup="true" aria-owns="' + t.id + '" title="' + sourceTitle + '" aria-label="' + sourceTitle + '" tabindex="0"></button>' + ('<div class="' + t.options.classPrefix + 'sourcechooser-selector ' + t.options.classPrefix + 'offscreen" role="menu" aria-expanded="false" aria-hidden="true"><ul></ul></div>');

		t.addControlElement(player.sourcechooserButton, 'sourcechooser');

		for (var _i = 0, _total = sources.length; _i < _total; _i++) {
			var src = sources[_i];
			if (src.type !== undefined && typeof media.canPlayType === 'function') {
				player.addSourceButton(src.src, src.title, src.type, media.src === src.src);
			}
		}

		player.sourcechooserButton.addEventListener('mouseover', function () {
			clearTimeout(hoverTimeout);
			player.showSourcechooserSelector();
		});
		player.sourcechooserButton.addEventListener('mouseout', function () {
			hoverTimeout = setTimeout(function () {
				player.hideSourcechooserSelector();
			}, 0);
		});

		player.sourcechooserButton.addEventListener('keydown', function (e) {

			if (t.options.keyActions.length) {
				var keyCode = e.which || e.keyCode || 0;

				switch (keyCode) {
					case 32:
						if (!mejs.MediaFeatures.isFirefox) {
							player.showSourcechooserSelector();
						}
						player.sourcechooserButton.querySelector('input[type=radio]:checked').focus();
						break;
					case 13:
						player.showSourcechooserSelector();
						player.sourcechooserButton.querySelector('input[type=radio]:checked').focus();
						break;
					case 27:
						player.hideSourcechooserSelector();
						player.sourcechooserButton.querySelector('button').focus();
						break;
					default:
						return true;
				}

				e.preventDefault();
				e.stopPropagation();
			}
		});

		player.sourcechooserButton.addEventListener('focusout', mejs.Utils.debounce(function () {
			setTimeout(function () {
				var parent = document.activeElement.closest('.' + t.options.classPrefix + 'sourcechooser-selector');
				if (!parent) {
					player.hideSourcechooserSelector();
				}
			}, 0);
		}, 100));

		var radios = player.sourcechooserButton.querySelectorAll('input[type=radio]');

		for (var _i2 = 0, _total2 = radios.length; _i2 < _total2; _i2++) {
			radios[_i2].addEventListener('click', function () {
				this.setAttribute('aria-selected', true);
				this.checked = true;

				var otherRadios = this.closest('.' + t.options.classPrefix + 'sourcechooser-selector').querySelectorAll('input[type=radio]');

				for (var j = 0, radioTotal = otherRadios.length; j < radioTotal; j++) {
					if (otherRadios[j] !== this) {
						otherRadios[j].setAttribute('aria-selected', 'false');
						otherRadios[j].removeAttribute('checked');
					}
				}

				var src = this.value;

				if (media.getSrc() !== src) {
					var currentTime = media.currentTime;

					var paused = media.paused,
					    canPlayAfterSourceSwitchHandler = function canPlayAfterSourceSwitchHandler() {
						if (!paused) {
							media.setCurrentTime(currentTime);
							media.play();
						}
						media.removeEventListener('canplay', canPlayAfterSourceSwitchHandler);
					};

					media.pause();
					media.setSrc(src);
					media.load();
					media.addEventListener('canplay', canPlayAfterSourceSwitchHandler);
				}
			});
		}

		player.sourcechooserButton.querySelector('button').addEventListener('click', function () {
			if (mejs.Utils.hasClass(mejs.Utils.siblings(this, '.' + t.options.classPrefix + 'sourcechooser-selector'), t.options.classPrefix + 'offscreen')) {
				player.showSourcechooserSelector();
				player.sourcechooserButton.querySelector('input[type=radio]:checked').focus();
			} else {
				player.hideSourcechooserSelector();
			}
		});
	},
	addSourceButton: function addSourceButton(src, label, type, isCurrent) {
		var t = this;
		if (label === '' || label === undefined) {
			label = src;
		}
		type = type.split('/')[1];

		t.sourcechooserButton.querySelector('ul').innerHTML += '<li>' + ('<input type="radio" name="' + t.id + '_sourcechooser" id="' + t.id + '_sourcechooser_' + label + type + '" ') + ('role="menuitemradio" value="' + src + '" ' + (isCurrent ? 'checked="checked"' : '') + ' aria-selected="' + isCurrent + '"/>') + ('<label for="' + t.id + '_sourcechooser_' + label + type + '" aria-hidden="true">' + label + ' (' + type + ')</label>') + '</li>';

		t.adjustSourcechooserBox();
	},
	adjustSourcechooserBox: function adjustSourcechooserBox() {
		var t = this;

		t.sourcechooserButton.querySelector('.' + t.options.classPrefix + 'sourcechooser-selector').style.height = parseFloat(t.sourcechooserButton.querySelector('.' + t.options.classPrefix + 'sourcechooser-selector ul').offsetHeight) + 'px';
	},
	hideSourcechooserSelector: function hideSourcechooserSelector() {

		var t = this;

		if (t.sourcechooserButton === undefined || !t.sourcechooserButton.querySelector('input[type=radio]')) {
			return;
		}

		var selector = t.sourcechooserButton.querySelector('.' + t.options.classPrefix + 'sourcechooser-selector'),
		    radios = selector.querySelectorAll('input[type=radio]');
		selector.setAttribute('aria-expanded', 'false');
		selector.setAttribute('aria-hidden', 'true');
		mejs.Utils.addClass(selector, t.options.classPrefix + 'offscreen');

		for (var i = 0, total = radios.length; i < total; i++) {
			radios[i].setAttribute('tabindex', '-1');
		}
	},
	showSourcechooserSelector: function showSourcechooserSelector() {

		var t = this;

		if (t.sourcechooserButton === undefined || !t.sourcechooserButton.querySelector('input[type=radio]')) {
			return;
		}

		var selector = t.sourcechooserButton.querySelector('.' + t.options.classPrefix + 'sourcechooser-selector'),
		    radios = selector.querySelectorAll('input[type=radio]');
		selector.setAttribute('aria-expanded', 'true');
		selector.setAttribute('aria-hidden', 'false');
		mejs.Utils.removeClass(selector, t.options.classPrefix + 'offscreen');

		for (var i = 0, total = radios.length; i < total; i++) {
			radios[i].setAttribute('tabindex', '0');
		}
	}
});

},{}]},{},[1]);

'use strict';

if (mejs.i18n.ca !== undefined) {
	mejs.i18n.ca['mejs.source-chooser']= 'Selector de font';
}
if (mejs.i18n.cs !== undefined) {
	mejs.i18n.cs['mejs.source-chooser']= 'Zdrojový výběr';
}
if (mejs.i18n.de !== undefined) {
	mejs.i18n.de['mejs.source-chooser']= 'Quellenauswahl';
}
if (mejs.i18n.es !== undefined) {
	mejs.i18n.es['mejs.source-chooser']= 'Selector de media';
}
if (mejs.i18n.fa !== undefined) {
	mejs.i18n.fa['mejs.source-chooser']= 'انتخاب کننده منبع';
}
if (mejs.i18n.fr !== undefined) {
	mejs.i18n.fr['mejs.source-chooser']= 'Sélecteur de média';
}
if (mejs.i18n.hr !== undefined) {
	mejs.i18n.hr['mejs.source-chooser']= 'Obabir izvora';
}
if (mejs.i18n.hu !== undefined) {
	mejs.i18n.hu['mejs.source-chooser']= 'Forrásválasztó';
}
if (mejs.i18n.it !== undefined) {
	mejs.i18n.it['mejs.source-chooser']= 'Selezionatore di origine';
}
if (mejs.i18n.ja !== undefined) {
	mejs.i18n.ja['mejs.source-chooser']= 'ソースセレクタ';
}
if (mejs.i18n.ko !== undefined) {
	mejs.i18n.ko['mejs.source-chooser']= '소스 선택기';
}
if (mejs.i18n.nl !== undefined) {
	mejs.i18n.nl['mejs.source-chooser']= 'Bronkeuze';
}
if (mejs.i18n.pl !== undefined) {
	mejs.i18n.pl['mejs.source-chooser']= 'Wybór źródła';
}
if (mejs.i18n.pt !== undefined) {
	mejs.i18n.pt['mejs.source-chooser']= 'Escolhedor de fontes';
}
if (mejs.i18n.ro !== undefined) {
	mejs.i18n.ro['mejs.source-chooser']= 'Sursă de selecție';
}
if (mejs.i18n.ru !== undefined) {
	mejs.i18n.ru['mejs.source-chooser']= 'Переключатель источника';
}
if (mejs.i18n.sk !== undefined) {
	mejs.i18n.sk['mejs.source-chooser']= 'Zdroj výberu';
}
if (mejs.i18n.sv !== undefined) {
	mejs.i18n.sv['mejs.source-chooser']= 'Välj källa';
}
if (mejs.i18n.uk !== undefined) {
	mejs.i18n.uk['mejs.source-chooser']= 'Вибір джерела';
}
if (mejs.i18n.zh !== undefined) {
	mejs.i18n.zh['mejs.source-chooser']= '源選擇器';
}
if (mejs.i18n['zh-CN'] !== undefined) {
	mejs.i18n['zh-CN']['mejs.source-chooser']= '源选择器';
}
/**
 * Copyright (C) 2012 by Matias Niemela
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */

(function (angular, window) {
    'use strict';

    angular.module('SafeApply', [])

        .factory('$safeApply', ['$rootScope', function ($rootScope) {
            $rootScope.$safeApply = function () {
                var $scope, fn, arg, force = false, args = arguments;

                if (args.length === 1) {
                    arg = args[0];
                    if (typeof arg === 'function') {
                        fn = arg;
                    } else {
                        $scope = arg;
                    }
                } else if (args.length > 0) {
                    $scope = args[0];
                    fn = args[1];
                    if (args.length === 3) {
                        force = !!args[2];
                    }
                }

                $scope = $scope || this || $rootScope;
                // Weird v8 bug where sometimes this === window
                // Doesn't happen if you set breakpoints either
                // used a try / catch with a debugger statement
                // before I could inspect an exception instance
                if ($scope === window) { $scope = $rootScope; }
                
                fn = fn || function () {};

                if (force || !($scope.$$phase ||
                        ($scope.$root && $scope.$root.$$phase))) {
                    $scope.$apply ? $scope.$apply(fn) : $scope.apply(fn);
                } else {
                    fn();
                }
            };

            return $rootScope.$safeApply;
        }])

        // Mix it into the root scope
        .run(['$safeApply', function () {}]);

}(this.angular, this));
/**
 * Satellizer 0.15.5
 * (c) 2016 Sahat Yalkabov 
 * License: MIT 
 */

(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global.satellizer = factory());
}(this, function () { 'use strict';

    var Config = (function () {
        function Config() {
            this.baseUrl = '/';
            this.loginUrl = '/auth/login';
            this.signupUrl = '/auth/signup';
            this.unlinkUrl = '/auth/unlink/';
            this.tokenName = 'token';
            this.tokenPrefix = 'satellizer';
            this.tokenHeader = 'Authorization';
            this.tokenType = 'Bearer';
            this.storageType = 'localStorage';
            this.tokenRoot = null;
            this.withCredentials = false;
            this.providers = {
                facebook: {
                    name: 'facebook',
                    url: '/auth/facebook',
                    authorizationEndpoint: 'https://www.facebook.com/v2.5/dialog/oauth',
                    redirectUri: window.location.origin + '/',
                    requiredUrlParams: ['display', 'scope'],
                    scope: ['email'],
                    scopeDelimiter: ',',
                    display: 'popup',
                    oauthType: '2.0',
                    popupOptions: { width: 580, height: 400 }
                },
                google: {
                    name: 'google',
                    url: '/auth/google',
                    authorizationEndpoint: 'https://accounts.google.com/o/oauth2/auth',
                    redirectUri: window.location.origin,
                    requiredUrlParams: ['scope'],
                    optionalUrlParams: ['display', 'state'],
                    scope: ['profile', 'email'],
                    scopePrefix: 'openid',
                    scopeDelimiter: ' ',
                    display: 'popup',
                    oauthType: '2.0',
                    popupOptions: { width: 452, height: 633 },
                    state: function () { return encodeURIComponent(Math.random().toString(36).substr(2)); }
                },
                github: {
                    name: 'github',
                    url: '/auth/github',
                    authorizationEndpoint: 'https://github.com/login/oauth/authorize',
                    redirectUri: window.location.origin,
                    optionalUrlParams: ['scope'],
                    scope: ['user:email'],
                    scopeDelimiter: ' ',
                    oauthType: '2.0',
                    popupOptions: { width: 1020, height: 618 }
                },
                instagram: {
                    name: 'instagram',
                    url: '/auth/instagram',
                    authorizationEndpoint: 'https://api.instagram.com/oauth/authorize',
                    redirectUri: window.location.origin,
                    requiredUrlParams: ['scope'],
                    scope: ['basic'],
                    scopeDelimiter: '+',
                    oauthType: '2.0'
                },
                linkedin: {
                    name: 'linkedin',
                    url: '/auth/linkedin',
                    authorizationEndpoint: 'https://www.linkedin.com/uas/oauth2/authorization',
                    redirectUri: window.location.origin,
                    requiredUrlParams: ['state'],
                    scope: ['r_emailaddress'],
                    scopeDelimiter: ' ',
                    state: 'STATE',
                    oauthType: '2.0',
                    popupOptions: { width: 527, height: 582 }
                },
                twitter: {
                    name: 'twitter',
                    url: '/auth/twitter',
                    authorizationEndpoint: 'https://api.twitter.com/oauth/authenticate',
                    redirectUri: window.location.origin,
                    oauthType: '1.0',
                    popupOptions: { width: 495, height: 645 }
                },
                twitch: {
                    name: 'twitch',
                    url: '/auth/twitch',
                    authorizationEndpoint: 'https://api.twitch.tv/kraken/oauth2/authorize',
                    redirectUri: window.location.origin,
                    requiredUrlParams: ['scope'],
                    scope: ['user_read'],
                    scopeDelimiter: ' ',
                    display: 'popup',
                    oauthType: '2.0',
                    popupOptions: { width: 500, height: 560 }
                },
                live: {
                    name: 'live',
                    url: '/auth/live',
                    authorizationEndpoint: 'https://login.live.com/oauth20_authorize.srf',
                    redirectUri: window.location.origin,
                    requiredUrlParams: ['display', 'scope'],
                    scope: ['wl.emails'],
                    scopeDelimiter: ' ',
                    display: 'popup',
                    oauthType: '2.0',
                    popupOptions: { width: 500, height: 560 }
                },
                yahoo: {
                    name: 'yahoo',
                    url: '/auth/yahoo',
                    authorizationEndpoint: 'https://api.login.yahoo.com/oauth2/request_auth',
                    redirectUri: window.location.origin,
                    scope: [],
                    scopeDelimiter: ',',
                    oauthType: '2.0',
                    popupOptions: { width: 559, height: 519 }
                },
                bitbucket: {
                    name: 'bitbucket',
                    url: '/auth/bitbucket',
                    authorizationEndpoint: 'https://bitbucket.org/site/oauth2/authorize',
                    redirectUri: window.location.origin + '/',
                    requiredUrlParams: ['scope'],
                    scope: ['email'],
                    scopeDelimiter: ' ',
                    oauthType: '2.0',
                    popupOptions: { width: 1028, height: 529 }
                },
                spotify: {
                    name: 'spotify',
                    url: '/auth/spotify',
                    authorizationEndpoint: 'https://accounts.spotify.com/authorize',
                    redirectUri: window.location.origin,
                    optionalUrlParams: ['state'],
                    requiredUrlParams: ['scope'],
                    scope: ['user-read-email'],
                    scopePrefix: '',
                    scopeDelimiter: ',',
                    oauthType: '2.0',
                    popupOptions: { width: 500, height: 530 },
                    state: function () { return encodeURIComponent(Math.random().toString(36).substr(2)); }
                }
            };
            this.httpInterceptor = function () { return true; };
        }
        Object.defineProperty(Config, "getConstant", {
            get: function () {
                return new Config();
            },
            enumerable: true,
            configurable: true
        });
        return Config;
    }());
    ;

    var AuthProvider = (function () {
        function AuthProvider(SatellizerConfig) {
            this.SatellizerConfig = SatellizerConfig;
        }
        Object.defineProperty(AuthProvider.prototype, "baseUrl", {
            get: function () { return this.SatellizerConfig.baseUrl; },
            set: function (value) { this.SatellizerConfig.baseUrl = value; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AuthProvider.prototype, "loginUrl", {
            get: function () { return this.SatellizerConfig.loginUrl; },
            set: function (value) { this.SatellizerConfig.loginUrl = value; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AuthProvider.prototype, "signupUrl", {
            get: function () { return this.SatellizerConfig.signupUrl; },
            set: function (value) { this.SatellizerConfig.signupUrl = value; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AuthProvider.prototype, "unlinkUrl", {
            get: function () { return this.SatellizerConfig.unlinkUrl; },
            set: function (value) { this.SatellizerConfig.unlinkUrl = value; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AuthProvider.prototype, "tokenRoot", {
            get: function () { return this.SatellizerConfig.tokenRoot; },
            set: function (value) { this.SatellizerConfig.tokenRoot = value; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AuthProvider.prototype, "tokenName", {
            get: function () { return this.SatellizerConfig.tokenName; },
            set: function (value) { this.SatellizerConfig.tokenName = value; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AuthProvider.prototype, "tokenPrefix", {
            get: function () { return this.SatellizerConfig.tokenPrefix; },
            set: function (value) { this.SatellizerConfig.tokenPrefix = value; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AuthProvider.prototype, "tokenHeader", {
            get: function () { return this.SatellizerConfig.tokenHeader; },
            set: function (value) { this.SatellizerConfig.tokenHeader = value; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AuthProvider.prototype, "tokenType", {
            get: function () { return this.SatellizerConfig.tokenType; },
            set: function (value) { this.SatellizerConfig.tokenType = value; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AuthProvider.prototype, "withCredentials", {
            get: function () { return this.SatellizerConfig.withCredentials; },
            set: function (value) { this.SatellizerConfig.withCredentials = value; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AuthProvider.prototype, "storageType", {
            get: function () { return this.SatellizerConfig.storageType; },
            set: function (value) { this.SatellizerConfig.storageType = value; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AuthProvider.prototype, "httpInterceptor", {
            get: function () { return this.SatellizerConfig.httpInterceptor; },
            set: function (value) {
                if (typeof value === 'function') {
                    this.SatellizerConfig.httpInterceptor = value;
                }
                else {
                    this.SatellizerConfig.httpInterceptor = function () { return value; };
                }
            },
            enumerable: true,
            configurable: true
        });
        AuthProvider.prototype.facebook = function (options) {
            angular.extend(this.SatellizerConfig.providers.facebook, options);
        };
        AuthProvider.prototype.google = function (options) {
            angular.extend(this.SatellizerConfig.providers.google, options);
        };
        AuthProvider.prototype.github = function (options) {
            angular.extend(this.SatellizerConfig.providers.github, options);
        };
        AuthProvider.prototype.instagram = function (options) {
            angular.extend(this.SatellizerConfig.providers.instagram, options);
        };
        AuthProvider.prototype.linkedin = function (options) {
            angular.extend(this.SatellizerConfig.providers.linkedin, options);
        };
        AuthProvider.prototype.twitter = function (options) {
            angular.extend(this.SatellizerConfig.providers.twitter, options);
        };
        AuthProvider.prototype.twitch = function (options) {
            angular.extend(this.SatellizerConfig.providers.twitch, options);
        };
        AuthProvider.prototype.live = function (options) {
            angular.extend(this.SatellizerConfig.providers.live, options);
        };
        AuthProvider.prototype.yahoo = function (options) {
            angular.extend(this.SatellizerConfig.providers.yahoo, options);
        };
        AuthProvider.prototype.bitbucket = function (options) {
            angular.extend(this.SatellizerConfig.providers.bitbucket, options);
        };
        AuthProvider.prototype.spotify = function (options) {
            angular.extend(this.SatellizerConfig.providers.spotify, options);
        };
        AuthProvider.prototype.oauth1 = function (options) {
            this.SatellizerConfig.providers[options.name] = angular.extend(options, {
                oauthType: '1.0'
            });
        };
        AuthProvider.prototype.oauth2 = function (options) {
            this.SatellizerConfig.providers[options.name] = angular.extend(options, {
                oauthType: '2.0'
            });
        };
        AuthProvider.prototype.$get = function (SatellizerShared, SatellizerLocal, SatellizerOAuth) {
            return {
                login: function (user, options) { return SatellizerLocal.login(user, options); },
                signup: function (user, options) { return SatellizerLocal.signup(user, options); },
                logout: function () { return SatellizerShared.logout(); },
                authenticate: function (name, data) { return SatellizerOAuth.authenticate(name, data); },
                link: function (name, data) { return SatellizerOAuth.authenticate(name, data); },
                unlink: function (name, options) { return SatellizerOAuth.unlink(name, options); },
                isAuthenticated: function () { return SatellizerShared.isAuthenticated(); },
                getPayload: function () { return SatellizerShared.getPayload(); },
                getToken: function () { return SatellizerShared.getToken(); },
                setToken: function (token) { return SatellizerShared.setToken({ access_token: token }); },
                removeToken: function () { return SatellizerShared.removeToken(); },
                setStorageType: function (type) { return SatellizerShared.setStorageType(type); }
            };
        };
        AuthProvider.$inject = ['SatellizerConfig'];
        return AuthProvider;
    }());
    AuthProvider.prototype.$get.$inject = ['SatellizerShared', 'SatellizerLocal', 'SatellizerOAuth'];

    function joinUrl(baseUrl, url) {
        if (/^(?:[a-z]+:)?\/\//i.test(url)) {
            return url;
        }
        var joined = [baseUrl, url].join('/');
        var normalize = function (str) {
            return str
                .replace(/[\/]+/g, '/')
                .replace(/\/\?/g, '?')
                .replace(/\/\#/g, '#')
                .replace(/\:\//g, '://');
        };
        return normalize(joined);
    }
    function getFullUrlPath(location) {
        var isHttps = location.protocol === 'https:';
        return location.protocol + '//' + location.hostname +
            ':' + (location.port || (isHttps ? '443' : '80')) +
            (/^\//.test(location.pathname) ? location.pathname : '/' + location.pathname);
    }
    function parseQueryString(str) {
        var obj = {};
        var key;
        var value;
        angular.forEach((str || '').split('&'), function (keyValue) {
            if (keyValue) {
                value = keyValue.split('=');
                key = decodeURIComponent(value[0]);
                obj[key] = angular.isDefined(value[1]) ? decodeURIComponent(value[1]) : true;
            }
        });
        return obj;
    }
    function decodeBase64(str) {
        var buffer;
        if (typeof module !== 'undefined' && module.exports) {
            try {
                buffer = require('buffer').Buffer;
            }
            catch (err) {
            }
        }
        var fromCharCode = String.fromCharCode;
        var re_btou = new RegExp([
            '[\xC0-\xDF][\x80-\xBF]',
            '[\xE0-\xEF][\x80-\xBF]{2}',
            '[\xF0-\xF7][\x80-\xBF]{3}'
        ].join('|'), 'g');
        var cb_btou = function (cccc) {
            switch (cccc.length) {
                case 4:
                    var cp = ((0x07 & cccc.charCodeAt(0)) << 18)
                        | ((0x3f & cccc.charCodeAt(1)) << 12)
                        | ((0x3f & cccc.charCodeAt(2)) << 6)
                        | (0x3f & cccc.charCodeAt(3));
                    var offset = cp - 0x10000;
                    return (fromCharCode((offset >>> 10) + 0xD800)
                        + fromCharCode((offset & 0x3FF) + 0xDC00));
                case 3:
                    return fromCharCode(((0x0f & cccc.charCodeAt(0)) << 12)
                        | ((0x3f & cccc.charCodeAt(1)) << 6)
                        | (0x3f & cccc.charCodeAt(2)));
                default:
                    return fromCharCode(((0x1f & cccc.charCodeAt(0)) << 6)
                        | (0x3f & cccc.charCodeAt(1)));
            }
        };
        var btou = function (b) {
            return b.replace(re_btou, cb_btou);
        };
        var _decode = buffer ? function (a) {
            return (a.constructor === buffer.constructor
                ? a : new buffer(a, 'base64')).toString();
        }
            : function (a) {
                return btou(atob(a));
            };
        return _decode(String(str).replace(/[-_]/g, function (m0) {
            return m0 === '-' ? '+' : '/';
        })
            .replace(/[^A-Za-z0-9\+\/]/g, ''));
    }

    var Shared = (function () {
        function Shared($q, $window, SatellizerConfig, SatellizerStorage) {
            this.$q = $q;
            this.$window = $window;
            this.SatellizerConfig = SatellizerConfig;
            this.SatellizerStorage = SatellizerStorage;
            var _a = this.SatellizerConfig, tokenName = _a.tokenName, tokenPrefix = _a.tokenPrefix;
            this.prefixedTokenName = tokenPrefix ? [tokenPrefix, tokenName].join('_') : tokenName;
        }
        Shared.prototype.getToken = function () {
            return this.SatellizerStorage.get(this.prefixedTokenName);
        };
        Shared.prototype.getPayload = function () {
            var token = this.SatellizerStorage.get(this.prefixedTokenName);
            if (token && token.split('.').length === 3) {
                try {
                    var base64Url = token.split('.')[1];
                    var base64 = base64Url.replace('-', '+').replace('_', '/');
                    return JSON.parse(decodeBase64(base64));
                }
                catch (e) {
                }
            }
        };
        Shared.prototype.setToken = function (response) {
            var tokenRoot = this.SatellizerConfig.tokenRoot;
            var tokenName = this.SatellizerConfig.tokenName;
            var accessToken = response && response.access_token;
            var token;
            if (accessToken) {
                if (angular.isObject(accessToken) && angular.isObject(accessToken.data)) {
                    response = accessToken;
                }
                else if (angular.isString(accessToken)) {
                    token = accessToken;
                }
            }
            if (!token && response) {
                var tokenRootData = tokenRoot && tokenRoot.split('.').reduce(function (o, x) { return o[x]; }, response.data);
                token = tokenRootData ? tokenRootData[tokenName] : response.data && response.data[tokenName];
            }
            if (token) {
                this.SatellizerStorage.set(this.prefixedTokenName, token);
            }
        };
        Shared.prototype.removeToken = function () {
            this.SatellizerStorage.remove(this.prefixedTokenName);
        };
        Shared.prototype.isAuthenticated = function () {
            var token = this.SatellizerStorage.get(this.prefixedTokenName);
            if (token) {
                if (token.split('.').length === 3) {
                    try {
                        var base64Url = token.split('.')[1];
                        var base64 = base64Url.replace('-', '+').replace('_', '/');
                        var exp = JSON.parse(this.$window.atob(base64)).exp;
                        if (typeof exp === 'number') {
                            return Math.round(new Date().getTime() / 1000) < exp;
                        }
                    }
                    catch (e) {
                        return true; // Pass: Non-JWT token that looks like JWT
                    }
                }
                return true; // Pass: All other tokens
            }
            return false; // Fail: No token at all
        };
        Shared.prototype.logout = function () {
            this.SatellizerStorage.remove(this.prefixedTokenName);
            return this.$q.when();
        };
        Shared.prototype.setStorageType = function (type) {
            this.SatellizerConfig.storageType = type;
        };
        Shared.$inject = ['$q', '$window', 'SatellizerConfig', 'SatellizerStorage'];
        return Shared;
    }());

    var Local = (function () {
        function Local($http, SatellizerConfig, SatellizerShared) {
            this.$http = $http;
            this.SatellizerConfig = SatellizerConfig;
            this.SatellizerShared = SatellizerShared;
        }
        Local.prototype.login = function (user, options) {
            var _this = this;
            if (options === void 0) { options = {}; }
            options.url = options.url ? options.url : joinUrl(this.SatellizerConfig.baseUrl, this.SatellizerConfig.loginUrl);
            options.data = user || options.data;
            options.method = options.method || 'POST';
            options.withCredentials = options.withCredentials || this.SatellizerConfig.withCredentials;
            return this.$http(options).then(function (response) {
                _this.SatellizerShared.setToken(response);
                return response;
            });
        };
        Local.prototype.signup = function (user, options) {
            if (options === void 0) { options = {}; }
            options.url = options.url ? options.url : joinUrl(this.SatellizerConfig.baseUrl, this.SatellizerConfig.signupUrl);
            options.data = user || options.data;
            options.method = options.method || 'POST';
            options.withCredentials = options.withCredentials || this.SatellizerConfig.withCredentials;
            return this.$http(options);
        };
        Local.$inject = ['$http', 'SatellizerConfig', 'SatellizerShared'];
        return Local;
    }());

    var Popup = (function () {
        function Popup($interval, $window, $q) {
            this.$interval = $interval;
            this.$window = $window;
            this.$q = $q;
            this.popup = null;
            this.defaults = {
                redirectUri: null
            };
        }
        Popup.prototype.stringifyOptions = function (options) {
            var parts = [];
            angular.forEach(options, function (value, key) {
                parts.push(key + '=' + value);
            });
            return parts.join(',');
        };
        Popup.prototype.open = function (url, name, popupOptions, redirectUri, dontPoll) {
            var width = popupOptions.width || 500;
            var height = popupOptions.height || 500;
            var options = this.stringifyOptions({
                width: width,
                height: height,
                top: this.$window.screenY + ((this.$window.outerHeight - height) / 2.5),
                left: this.$window.screenX + ((this.$window.outerWidth - width) / 2)
            });
            var popupName = this.$window['cordova'] || this.$window.navigator.userAgent.indexOf('CriOS') > -1 ? '_blank' : name;
            this.popup = this.$window.open(url, popupName, options);
            if (this.popup && this.popup.focus) {
                this.popup.focus();
            }
            if (dontPoll) {
                return;
            }
            if (this.$window['cordova']) {
                return this.eventListener(redirectUri);
            }
            else {
                if (url === 'about:blank') {
                    this.popup.location = url;
                }
                return this.polling(redirectUri);
            }
        };
        Popup.prototype.polling = function (redirectUri) {
            var _this = this;
            return this.$q(function (resolve, reject) {
                var redirectUriParser = document.createElement('a');
                redirectUriParser.href = redirectUri;
                var redirectUriPath = getFullUrlPath(redirectUriParser);
                var polling = _this.$interval(function () {
                    if (!_this.popup || _this.popup.closed || _this.popup.closed === undefined) {
                        _this.$interval.cancel(polling);
                        reject(new Error('The popup window was closed'));
                    }
                    try {
                        var popupWindowPath = getFullUrlPath(_this.popup.location);
                        if (popupWindowPath === redirectUriPath) {
                            if (_this.popup.location.search || _this.popup.location.hash) {
                                var query = parseQueryString(_this.popup.location.search.substring(1).replace(/\/$/, ''));
                                var hash = parseQueryString(_this.popup.location.hash.substring(1).replace(/[\/$]/, ''));
                                var params = angular.extend({}, query, hash);
                                if (params.error) {
                                    reject(new Error(params.error));
                                }
                                else {
                                    resolve(params);
                                }
                            }
                            else {
                                reject(new Error('OAuth redirect has occurred but no query or hash parameters were found. ' +
                                    'They were either not set during the redirect, or were removed—typically by a ' +
                                    'routing library—before Satellizer could read it.'));
                            }
                            _this.$interval.cancel(polling);
                            _this.popup.close();
                        }
                    }
                    catch (error) {
                    }
                }, 500);
            });
        };
        Popup.prototype.eventListener = function (redirectUri) {
            var _this = this;
            return this.$q(function (resolve, reject) {
                _this.popup.addEventListener('loadstart', function (event) {
                    if (event.url.indexOf(redirectUri) !== 0) {
                        return;
                    }
                    var parser = document.createElement('a');
                    parser.href = event.url;
                    if (parser.search || parser.hash) {
                        var query = parseQueryString(parser.search.substring(1).replace(/\/$/, ''));
                        var hash = parseQueryString(parser.hash.substring(1).replace(/[\/$]/, ''));
                        var params = angular.extend({}, query, hash);
                        if (params.error) {
                            reject(new Error(params.error));
                        }
                        else {
                            resolve(params);
                        }
                        _this.popup.close();
                    }
                });
                _this.popup.addEventListener('loaderror', function () {
                    reject(new Error('Authorization failed'));
                });
                _this.popup.addEventListener('exit', function () {
                    reject(new Error('The popup window was closed'));
                });
            });
        };
        Popup.$inject = ['$interval', '$window', '$q'];
        return Popup;
    }());

    var OAuth1 = (function () {
        function OAuth1($http, $window, SatellizerConfig, SatellizerPopup) {
            this.$http = $http;
            this.$window = $window;
            this.SatellizerConfig = SatellizerConfig;
            this.SatellizerPopup = SatellizerPopup;
            this.defaults = {
                name: null,
                url: null,
                authorizationEndpoint: null,
                scope: null,
                scopePrefix: null,
                scopeDelimiter: null,
                redirectUri: null,
                requiredUrlParams: null,
                defaultUrlParams: null,
                oauthType: '1.0',
                popupOptions: { width: null, height: null }
            };
        }
        ;
        OAuth1.prototype.init = function (options, userData) {
            var _this = this;
            angular.extend(this.defaults, options);
            var name = options.name, popupOptions = options.popupOptions;
            var redirectUri = this.defaults.redirectUri;
            // Should open an empty popup and wait until request token is received
            if (!this.$window['cordova']) {
                this.SatellizerPopup.open('about:blank', name, popupOptions, redirectUri, true);
            }
            return this.getRequestToken().then(function (response) {
                return _this.openPopup(options, response).then(function (popupResponse) {
                    return _this.exchangeForToken(popupResponse, userData);
                });
            });
        };
        OAuth1.prototype.openPopup = function (options, response) {
            var url = [options.authorizationEndpoint, this.buildQueryString(response.data)].join('?');
            var redirectUri = this.defaults.redirectUri;
            if (this.$window['cordova']) {
                return this.SatellizerPopup.open(url, options.name, options.popupOptions, redirectUri);
            }
            else {
                this.SatellizerPopup.popup.location = url;
                return this.SatellizerPopup.polling(redirectUri);
            }
        };
        OAuth1.prototype.getRequestToken = function () {
            var url = this.SatellizerConfig.baseUrl ? joinUrl(this.SatellizerConfig.baseUrl, this.defaults.url) : this.defaults.url;
            return this.$http.post(url, this.defaults);
        };
        OAuth1.prototype.exchangeForToken = function (oauthData, userData) {
            var payload = angular.extend({}, userData, oauthData);
            var exchangeForTokenUrl = this.SatellizerConfig.baseUrl ? joinUrl(this.SatellizerConfig.baseUrl, this.defaults.url) : this.defaults.url;
            return this.$http.post(exchangeForTokenUrl, payload, { withCredentials: this.SatellizerConfig.withCredentials });
        };
        OAuth1.prototype.buildQueryString = function (obj) {
            var str = [];
            angular.forEach(obj, function (value, key) {
                str.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
            });
            return str.join('&');
        };
        OAuth1.$inject = ['$http', '$window', 'SatellizerConfig', 'SatellizerPopup'];
        return OAuth1;
    }());

    var OAuth2 = (function () {
        function OAuth2($http, $window, $timeout, $q, SatellizerConfig, SatellizerPopup, SatellizerStorage) {
            this.$http = $http;
            this.$window = $window;
            this.$timeout = $timeout;
            this.$q = $q;
            this.SatellizerConfig = SatellizerConfig;
            this.SatellizerPopup = SatellizerPopup;
            this.SatellizerStorage = SatellizerStorage;
            this.defaults = {
                name: null,
                url: null,
                clientId: null,
                authorizationEndpoint: null,
                redirectUri: null,
                scope: null,
                scopePrefix: null,
                scopeDelimiter: null,
                state: null,
                requiredUrlParams: null,
                defaultUrlParams: ['response_type', 'client_id', 'redirect_uri'],
                responseType: 'code',
                responseParams: {
                    code: 'code',
                    clientId: 'clientId',
                    redirectUri: 'redirectUri'
                },
                oauthType: '2.0',
                popupOptions: { width: null, height: null }
            };
        }
        OAuth2.camelCase = function (name) {
            return name.replace(/([\:\-\_]+(.))/g, function (_, separator, letter, offset) {
                return offset ? letter.toUpperCase() : letter;
            });
        };
        OAuth2.prototype.init = function (options, userData) {
            var _this = this;
            return this.$q(function (resolve, reject) {
                angular.extend(_this.defaults, options);
                var stateName = _this.defaults.name + '_state';
                var _a = _this.defaults, name = _a.name, state = _a.state, popupOptions = _a.popupOptions, redirectUri = _a.redirectUri, responseType = _a.responseType;
                if (typeof state === 'function') {
                    _this.SatellizerStorage.set(stateName, state());
                }
                else if (typeof state === 'string') {
                    _this.SatellizerStorage.set(stateName, state);
                }
                var url = [_this.defaults.authorizationEndpoint, _this.buildQueryString()].join('?');
                _this.SatellizerPopup.open(url, name, popupOptions, redirectUri).then(function (oauth) {
                    if (responseType === 'token' || !url) {
                        return resolve(oauth);
                    }
                    if (oauth.state && oauth.state !== _this.SatellizerStorage.get(stateName)) {
                        return reject(new Error('The value returned in the state parameter does not match the state value from your original ' +
                            'authorization code request.'));
                    }
                    resolve(_this.exchangeForToken(oauth, userData));
                }).catch(function (error) { return reject(error); });
            });
        };
        OAuth2.prototype.exchangeForToken = function (oauthData, userData) {
            var _this = this;
            var payload = angular.extend({}, userData);
            angular.forEach(this.defaults.responseParams, function (value, key) {
                switch (key) {
                    case 'code':
                        payload[value] = oauthData.code;
                        break;
                    case 'clientId':
                        payload[value] = _this.defaults.clientId;
                        break;
                    case 'redirectUri':
                        payload[value] = _this.defaults.redirectUri;
                        break;
                    default:
                        payload[value] = oauthData[key];
                }
            });
            if (oauthData.state) {
                payload.state = oauthData.state;
            }
            var exchangeForTokenUrl = this.SatellizerConfig.baseUrl ?
                joinUrl(this.SatellizerConfig.baseUrl, this.defaults.url) :
                this.defaults.url;
            return this.$http.post(exchangeForTokenUrl, payload, { withCredentials: this.SatellizerConfig.withCredentials });
        };
        OAuth2.prototype.buildQueryString = function () {
            var _this = this;
            var keyValuePairs = [];
            var urlParamsCategories = ['defaultUrlParams', 'requiredUrlParams', 'optionalUrlParams'];
            angular.forEach(urlParamsCategories, function (paramsCategory) {
                angular.forEach(_this.defaults[paramsCategory], function (paramName) {
                    var camelizedName = OAuth2.camelCase(paramName);
                    var paramValue = angular.isFunction(_this.defaults[paramName]) ? _this.defaults[paramName]() : _this.defaults[camelizedName];
                    if (paramName === 'redirect_uri' && !paramValue) {
                        return;
                    }
                    if (paramName === 'state') {
                        var stateName = _this.defaults.name + '_state';
                        paramValue = encodeURIComponent(_this.SatellizerStorage.get(stateName));
                    }
                    if (paramName === 'scope' && Array.isArray(paramValue)) {
                        paramValue = paramValue.join(_this.defaults.scopeDelimiter);
                        if (_this.defaults.scopePrefix) {
                            paramValue = [_this.defaults.scopePrefix, paramValue].join(_this.defaults.scopeDelimiter);
                        }
                    }
                    keyValuePairs.push([paramName, paramValue]);
                });
            });
            return keyValuePairs.map(function (pair) { return pair.join('='); }).join('&');
        };
        OAuth2.$inject = ['$http', '$window', '$timeout', '$q', 'SatellizerConfig', 'SatellizerPopup', 'SatellizerStorage'];
        return OAuth2;
    }());

    var OAuth = (function () {
        function OAuth($http, $window, $timeout, $q, SatellizerConfig, SatellizerPopup, SatellizerStorage, SatellizerShared, SatellizerOAuth1, SatellizerOAuth2) {
            this.$http = $http;
            this.$window = $window;
            this.$timeout = $timeout;
            this.$q = $q;
            this.SatellizerConfig = SatellizerConfig;
            this.SatellizerPopup = SatellizerPopup;
            this.SatellizerStorage = SatellizerStorage;
            this.SatellizerShared = SatellizerShared;
            this.SatellizerOAuth1 = SatellizerOAuth1;
            this.SatellizerOAuth2 = SatellizerOAuth2;
        }
        OAuth.prototype.authenticate = function (name, userData) {
            var _this = this;
            return this.$q(function (resolve, reject) {
                var provider = _this.SatellizerConfig.providers[name];
                var oauth = null;
                switch (provider.oauthType) {
                    case '1.0':
                        oauth = new OAuth1(_this.$http, _this.$window, _this.SatellizerConfig, _this.SatellizerPopup);
                        break;
                    case '2.0':
                        oauth = new OAuth2(_this.$http, _this.$window, _this.$timeout, _this.$q, _this.SatellizerConfig, _this.SatellizerPopup, _this.SatellizerStorage);
                        break;
                    default:
                        return reject(new Error('Invalid OAuth Type'));
                }
                return oauth.init(provider, userData).then(function (response) {
                    if (provider.url) {
                        _this.SatellizerShared.setToken(response);
                    }
                    resolve(response);
                }).catch(function (error) {
                    reject(error);
                });
            });
        };
        OAuth.prototype.unlink = function (provider, httpOptions) {
            if (httpOptions === void 0) { httpOptions = {}; }
            httpOptions.url = httpOptions.url ? httpOptions.url : joinUrl(this.SatellizerConfig.baseUrl, this.SatellizerConfig.unlinkUrl);
            httpOptions.data = { provider: provider } || httpOptions.data;
            httpOptions.method = httpOptions.method || 'POST';
            httpOptions.withCredentials = httpOptions.withCredentials || this.SatellizerConfig.withCredentials;
            return this.$http(httpOptions);
        };
        OAuth.$inject = [
            '$http',
            '$window',
            '$timeout',
            '$q',
            'SatellizerConfig',
            'SatellizerPopup',
            'SatellizerStorage',
            'SatellizerShared',
            'SatellizerOAuth1',
            'SatellizerOAuth2'
        ];
        return OAuth;
    }());

    var Storage = (function () {
        function Storage($window, SatellizerConfig) {
            this.$window = $window;
            this.SatellizerConfig = SatellizerConfig;
            this.memoryStore = {};
        }
        Storage.prototype.get = function (key) {
            try {
                return this.$window[this.SatellizerConfig.storageType].getItem(key);
            }
            catch (e) {
                return this.memoryStore[key];
            }
        };
        Storage.prototype.set = function (key, value) {
            try {
                this.$window[this.SatellizerConfig.storageType].setItem(key, value);
            }
            catch (e) {
                this.memoryStore[key] = value;
            }
        };
        Storage.prototype.remove = function (key) {
            try {
                this.$window[this.SatellizerConfig.storageType].removeItem(key);
            }
            catch (e) {
                delete this.memoryStore[key];
            }
        };
        Storage.$inject = ['$window', 'SatellizerConfig'];
        return Storage;
    }());

    var Interceptor = (function () {
        function Interceptor(SatellizerConfig, SatellizerShared, SatellizerStorage) {
            var _this = this;
            this.SatellizerConfig = SatellizerConfig;
            this.SatellizerShared = SatellizerShared;
            this.SatellizerStorage = SatellizerStorage;
            this.request = function (config) {
                if (config['skipAuthorization']) {
                    return config;
                }
                if (_this.SatellizerShared.isAuthenticated() && _this.SatellizerConfig.httpInterceptor()) {
                    var tokenName = _this.SatellizerConfig.tokenPrefix ?
                        [_this.SatellizerConfig.tokenPrefix, _this.SatellizerConfig.tokenName].join('_') : _this.SatellizerConfig.tokenName;
                    var token = _this.SatellizerStorage.get(tokenName);
                    if (_this.SatellizerConfig.tokenHeader && _this.SatellizerConfig.tokenType) {
                        token = _this.SatellizerConfig.tokenType + ' ' + token;
                    }
                    config.headers[_this.SatellizerConfig.tokenHeader] = token;
                }
                return config;
            };
        }
        Interceptor.Factory = function (SatellizerConfig, SatellizerShared, SatellizerStorage) {
            return new Interceptor(SatellizerConfig, SatellizerShared, SatellizerStorage);
        };
        Interceptor.$inject = ['SatellizerConfig', 'SatellizerShared', 'SatellizerStorage'];
        return Interceptor;
    }());
    Interceptor.Factory.$inject = ['SatellizerConfig', 'SatellizerShared', 'SatellizerStorage'];

    var HttpProviderConfig = (function () {
        function HttpProviderConfig($httpProvider) {
            this.$httpProvider = $httpProvider;
            $httpProvider.interceptors.push(Interceptor.Factory);
        }
        HttpProviderConfig.$inject = ['$httpProvider'];
        return HttpProviderConfig;
    }());

    angular.module('satellizer', [])
        .provider('$auth', ['SatellizerConfig', function (SatellizerConfig) { return new AuthProvider(SatellizerConfig); }])
        .constant('SatellizerConfig', Config.getConstant)
        .service('SatellizerShared', Shared)
        .service('SatellizerLocal', Local)
        .service('SatellizerPopup', Popup)
        .service('SatellizerOAuth', OAuth)
        .service('SatellizerOAuth2', OAuth2)
        .service('SatellizerOAuth1', OAuth1)
        .service('SatellizerStorage', Storage)
        .service('SatellizerInterceptor', Interceptor)
        .config(['$httpProvider', function ($httpProvider) { return new HttpProviderConfig($httpProvider); }]);
    var ng1 = 'satellizer';

    return ng1;

}));

/*!
 * MediaElement.js
 * http://www.mediaelementjs.com/
 *
 * Wrapper that mimics native HTML5 MediaElement (audio and video)
 * using a variety of technologies (pure JavaScript, Flash, iframe)
 *
 * Copyright 2010-2017, John Dyer (http://j.hn/)
 * License: MIT
 *
 */(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
'use strict';

mejs.i18n.en['mejs.quality-chooser'] = 'Quality Chooser';

Object.assign(mejs.MepDefaults, {
	defaultQuality: 'auto',

	qualityText: null
});

Object.assign(MediaElementPlayer.prototype, {
	buildquality: function buildquality(player, controls, layers, media) {
		var t = this,
		    children = t.mediaFiles ? t.mediaFiles : t.node.children,
		    qualityMap = new Map();

		for (var i = 0, total = children.length; i < total; i++) {
			var mediaNode = children[i];
			var quality = mediaNode instanceof HTMLElement ? mediaNode.getAttribute('data-quality') : mediaNode['data-quality'];

			if (t.mediaFiles) {
				var source = document.createElement('source');
				source.src = mediaNode['src'];
				source.type = mediaNode['type'];

				t.addValueToKey(qualityMap, quality, source);
			} else if (mediaNode.nodeName === 'SOURCE') {
				t.addValueToKey(qualityMap, quality, mediaNode);
			}
		}

		if (qualityMap.size <= 1) {
			return;
		}

		t.cleanquality(player);

		var qualityTitle = mejs.Utils.isString(t.options.qualityText) ? t.options.qualityText : mejs.i18n.t('mejs.quality-quality'),
		    getQualityNameFromValue = function getQualityNameFromValue(value) {
			var label = void 0;
			if (value === 'auto') {
				var keyExist = t.keyExist(qualityMap, value);
				if (keyExist) {
					label = value;
				} else {
					var keyValue = t.getMapIndex(qualityMap, 0);
					label = keyValue.key;
				}
			} else {
				label = value;
			}
			return label;
		},
		    defaultValue = getQualityNameFromValue(t.options.defaultQuality);

		player.qualitiesButton = document.createElement('div');
		player.qualitiesButton.className = t.options.classPrefix + 'button ' + t.options.classPrefix + 'qualities-button';
		player.qualitiesButton.innerHTML = '<button type="button" aria-controls="' + t.id + '" title="' + qualityTitle + '" ' + ('aria-label="' + qualityTitle + '" tabindex="0">' + defaultValue + '</button>') + ('<div class="' + t.options.classPrefix + 'qualities-selector ' + t.options.classPrefix + 'offscreen">') + ('<ul class="' + t.options.classPrefix + 'qualities-selector-list"></ul>') + '</div>';

		t.addControlElement(player.qualitiesButton, 'qualities');

		media.setSrc(qualityMap.get(defaultValue)[0].src);
		media.load();

		qualityMap.forEach(function (value, key) {
			if (key !== 'map_keys_1') {
				var src = value[0],
				    _quality = key,
				    inputId = t.id + '-qualities-' + _quality;
				player.qualitiesButton.querySelector('ul').innerHTML += '<li class="' + t.options.classPrefix + 'qualities-selector-list-item">' + ('<input class="' + t.options.classPrefix + 'qualities-selector-input" type="radio" name="' + t.id + '_qualities"') + ('disabled="disabled" value="' + _quality + '" id="' + inputId + '"  ') + ((_quality === defaultValue ? ' checked="checked"' : '') + '/>') + ('<label for="' + inputId + '" class="' + t.options.classPrefix + 'qualities-selector-label') + ((_quality === defaultValue ? ' ' + t.options.classPrefix + 'qualities-selected' : '') + '">') + ((src.title || _quality) + '</label>') + '</li>';
			}
		});
		var inEvents = ['mouseenter', 'focusin'],
		    outEvents = ['mouseleave', 'focusout'],
		    radios = player.qualitiesButton.querySelectorAll('input[type="radio"]'),
		    labels = player.qualitiesButton.querySelectorAll('.' + t.options.classPrefix + 'qualities-selector-label'),
		    selector = player.qualitiesButton.querySelector('.' + t.options.classPrefix + 'qualities-selector');

		for (var _i = 0, _total = inEvents.length; _i < _total; _i++) {
			player.qualitiesButton.addEventListener(inEvents[_i], function () {
				mejs.Utils.removeClass(selector, t.options.classPrefix + 'offscreen');
				selector.style.height = selector.querySelector('ul').offsetHeight + 'px';
				selector.style.top = -1 * parseFloat(selector.offsetHeight) + 'px';
			});
		}

		for (var _i2 = 0, _total2 = outEvents.length; _i2 < _total2; _i2++) {
			player.qualitiesButton.addEventListener(outEvents[_i2], function () {
				mejs.Utils.addClass(selector, t.options.classPrefix + 'offscreen');
			});
		}

		for (var _i3 = 0, _total3 = radios.length; _i3 < _total3; _i3++) {
			var radio = radios[_i3];
			radio.disabled = false;
			radio.addEventListener('change', function () {
				var self = this,
				    newQuality = self.value;

				var selected = player.qualitiesButton.querySelectorAll('.' + t.options.classPrefix + 'qualities-selected');
				for (var _i4 = 0, _total4 = selected.length; _i4 < _total4; _i4++) {
					mejs.Utils.removeClass(selected[_i4], t.options.classPrefix + 'qualities-selected');
				}

				self.checked = true;
				var siblings = mejs.Utils.siblings(self, function (el) {
					return mejs.Utils.hasClass(el, t.options.classPrefix + 'qualities-selector-label');
				});
				for (var j = 0, _total5 = siblings.length; j < _total5; j++) {
					mejs.Utils.addClass(siblings[j], t.options.classPrefix + 'qualities-selected');
				}

				var currentTime = media.currentTime;

				var paused = media.paused;

				player.qualitiesButton.querySelector('button').innerHTML = newQuality;
				if (!paused) {
					media.pause();
				}
				t.updateVideoSource(media, qualityMap, newQuality);
				media.setSrc(qualityMap.get(newQuality)[0].src);
				media.load();
				media.dispatchEvent(mejs.Utils.createEvent('seeking', media));
				if (!paused) {
					media.play();
				}
				media.addEventListener('canplay', function canPlayAfterSourceSwitchHandler() {
					media.setCurrentTime(currentTime);
					media.removeEventListener('canplay', canPlayAfterSourceSwitchHandler);
				});
			});
		}
		for (var _i5 = 0, _total6 = labels.length; _i5 < _total6; _i5++) {
			labels[_i5].addEventListener('click', function () {
				var radio = mejs.Utils.siblings(this, function (el) {
					return el.tagName === 'INPUT';
				})[0],
				    event = mejs.Utils.createEvent('click', radio);
				radio.dispatchEvent(event);
			});
		}

		selector.addEventListener('keydown', function (e) {
			e.stopPropagation();
		});
		media.setSrc(qualityMap.get(defaultValue)[0].src);
	},
	cleanquality: function cleanquality(player) {
		if (player) {
			if (player.qualitiesButton) {
				player.qualitiesButton.remove();
			}
		}
	},
	addValueToKey: function addValueToKey(map, key, value) {
		if (map.has('map_keys_1')) {
			map.get('map_keys_1').push(key.toLowerCase());
		} else {
			map.set('map_keys_1', []);
		}
		if (map.has(key)) {
			map.get(key).push(value);
		} else {
			map.set(key, []);
			map.get(key).push(value);
		}
	},
	updateVideoSource: function updateVideoSource(media, map, key) {
		this.cleanMediaSource(media);
		var sources = map.get(key);

		var _loop = function _loop(i) {
			var mediaNode = media.children[i];
			if (mediaNode.tagName === 'VIDEO') {
				sources.forEach(function (sourceElement) {
					mediaNode.appendChild(sourceElement);
				});
			}
		};

		for (var i = 0; i < media.children.length; i++) {
			_loop(i);
		}
	},
	cleanMediaSource: function cleanMediaSource(media) {
		for (var i = 0; i < media.children.length; i++) {
			var _mediaNode = media.children[i];
			if (_mediaNode.tagName === 'VIDEO') {
				while (_mediaNode.firstChild) {
					_mediaNode.removeChild(_mediaNode.firstChild);
				}
			}
		}
	},
	getMapIndex: function getMapIndex(map, index) {
		var counter = -1;
		var keyValue = {};
		map.forEach(function (value, key) {

			if (counter === index) {
				keyValue.key = key;
				keyValue.value = value;
			}
			counter++;
		});
		return keyValue;
	},
	keyExist: function keyExist(map, searchKey) {
		return -1 < map.get('map_keys_1').indexOf(searchKey.toLowerCase());
	}
});

},{}]},{},[1]);

'use strict';

if (mejs.i18n.ca !== undefined) {
	mejs.i18n.ca['mejs.quality-chooser']= 'Selector de qualitat';
}
if (mejs.i18n.cs !== undefined) {
	mejs.i18n.cs['mejs.quality-chooser']= 'Kvalitní výběr';
}
if (mejs.i18n.de !== undefined) {
	mejs.i18n.de['mejs.quality-chooser']= 'Qualitätswähler';
}
if (mejs.i18n.es !== undefined) {
	mejs.i18n.es['mejs.quality-chooser']= 'Selector de calidad';
}
if (mejs.i18n.fa !== undefined) {
	mejs.i18n.fa['mejs.quality-chooser']= 'انتخاب کننده کیفیت';
}
if (mejs.i18n.fr !== undefined) {
	mejs.i18n.fr['mejs.quality-chooser']= 'Sélecteur de qualité';
}
if (mejs.i18n.hr !== undefined) {
	mejs.i18n.hr['mejs.quality-chooser']= 'Kvalitetni birač';
}
if (mejs.i18n.hu !== undefined) {
	mejs.i18n.hu['mejs.quality-chooser']= 'Minőségi választó';
}
if (mejs.i18n.it !== undefined) {
	mejs.i18n.it['mejs.quality-chooser']= 'Qualità scelto';
}
if (mejs.i18n.ja !== undefined) {
	mejs.i18n.ja['mejs.quality-chooser']= '品質チューザー';
}
if (mejs.i18n.ko !== undefined) {
	mejs.i18n.ko['mejs.quality-chooser']= '품질 선택자';
}
if (mejs.i18n.nl !== undefined) {
	mejs.i18n.nl['mejs.quality-chooser']= 'Kwaliteit kiezer';
}
if (mejs.i18n.pl !== undefined) {
	mejs.i18n.pl['mejs.quality-chooser']= 'Chooser jakości';
}
if (mejs.i18n.pt !== undefined) {
	mejs.i18n.pt['mejs.quality-chooser']= 'Escolha de qualidade';
}
if (mejs.i18n.ro !== undefined) {
	mejs.i18n.ro['mejs.quality-chooser']= 'Alegere de calitate';
}
if (mejs.i18n.ru !== undefined) {
	mejs.i18n.ru['mejs.quality-chooser']= 'Выбор качества';
}
if (mejs.i18n.sk !== undefined) {
	mejs.i18n.sk['mejs.quality-chooser']= 'Kvalitný výber';
}
if (mejs.i18n.sv !== undefined) {
	mejs.i18n.sv['mejs.quality-chooser']= 'Kvalitetsvalare';
}
if (mejs.i18n.uk !== undefined) {
	mejs.i18n.uk['mejs.quality-chooser']= 'Якісний вибір';
}
if (mejs.i18n.zh !== undefined) {
	mejs.i18n.zh['mejs.quality-chooser']= '質量選擇';
}
if (mejs.i18n['zh-CN'] !== undefined) {
	mejs.i18n['zh-CN']['mejs.quality-chooser']= '质量选择';
}
/*!
 * Fotorama 4.6.3 | http://fotorama.io/license/
 */
fotoramaVersion = '4.6.3';
(function (window, document, location, $, undefined) {
  "use strict";
  var _fotoramaClass = 'fotorama',
    _fullscreenClass = 'fullscreen',

    wrapClass = _fotoramaClass + '__wrap',
    wrapCss2Class = wrapClass + '--css2',
    wrapCss3Class = wrapClass + '--css3',
    wrapVideoClass = wrapClass + '--video',
    wrapFadeClass = wrapClass + '--fade',
    wrapSlideClass = wrapClass + '--slide',
    wrapNoControlsClass = wrapClass + '--no-controls',
    wrapNoShadowsClass = wrapClass + '--no-shadows',
    wrapPanYClass = wrapClass + '--pan-y',
    wrapRtlClass = wrapClass + '--rtl',
    wrapOnlyActiveClass = wrapClass + '--only-active',
    wrapNoCaptionsClass = wrapClass + '--no-captions',
    wrapToggleArrowsClass = wrapClass + '--toggle-arrows',

    stageClass = _fotoramaClass + '__stage',
    stageFrameClass = stageClass + '__frame',
    stageFrameVideoClass = stageFrameClass + '--video',
    stageShaftClass = stageClass + '__shaft',

    grabClass = _fotoramaClass + '__grab',
    pointerClass = _fotoramaClass + '__pointer',

    arrClass = _fotoramaClass + '__arr',
    arrDisabledClass = arrClass + '--disabled',
    arrPrevClass = arrClass + '--prev',
    arrNextClass = arrClass + '--next',
    arrArrClass = arrClass + '__arr',

    navClass = _fotoramaClass + '__nav',
    navWrapClass = navClass + '-wrap',
    navShaftClass = navClass + '__shaft',
    navDotsClass = navClass + '--dots',
    navThumbsClass = navClass + '--thumbs',
    navFrameClass = navClass + '__frame',
    navFrameDotClass = navFrameClass + '--dot',
    navFrameThumbClass = navFrameClass + '--thumb',

    fadeClass = _fotoramaClass + '__fade',
    fadeFrontClass = fadeClass + '-front',
    fadeRearClass = fadeClass + '-rear',

    shadowClass = _fotoramaClass + '__shadow',
    shadowsClass = shadowClass + 's',
    shadowsLeftClass = shadowsClass + '--left',
    shadowsRightClass = shadowsClass + '--right',

    activeClass = _fotoramaClass + '__active',
    selectClass = _fotoramaClass + '__select',

    hiddenClass = _fotoramaClass + '--hidden',

    fullscreenClass = _fotoramaClass + '--fullscreen',
    fullscreenIconClass = _fotoramaClass + '__fullscreen-icon',

    errorClass = _fotoramaClass + '__error',
    loadingClass = _fotoramaClass + '__loading',
    loadedClass = _fotoramaClass + '__loaded',
    loadedFullClass = loadedClass + '--full',
    loadedImgClass = loadedClass + '--img',

    grabbingClass = _fotoramaClass + '__grabbing',

    imgClass = _fotoramaClass + '__img',
    imgFullClass = imgClass + '--full',

    dotClass = _fotoramaClass + '__dot',
    thumbClass = _fotoramaClass + '__thumb',
    thumbBorderClass = thumbClass + '-border',

    htmlClass = _fotoramaClass + '__html',

    videoClass = _fotoramaClass + '__video',
    videoPlayClass = videoClass + '-play',
    videoCloseClass = videoClass + '-close',

    captionClass = _fotoramaClass + '__caption',
    captionWrapClass = _fotoramaClass + '__caption__wrap',

    spinnerClass = _fotoramaClass + '__spinner',

    buttonAttributes = '" tabindex="0" role="button';
  var JQUERY_VERSION = $ && $.fn.jquery.split('.');

  if (!JQUERY_VERSION
    || JQUERY_VERSION[0] < 1
    || (JQUERY_VERSION[0] == 1 && JQUERY_VERSION[1] < 8)) {
    throw 'Fotorama requires jQuery 1.8 or later and will not run without it.';
  }
// My Underscore :-)
  var _ = {};
  /* Modernizr 2.6.2 (Custom Build) | MIT & BSD
   * Build: http://modernizr.com/download/#-csstransforms3d-prefixed-teststyles-testprop-testallprops-prefixes-domprefixes
   */

  var Modernizr = (function (window, document, undefined) {

    var version = '2.6.2',

      Modernizr = {},

      docElement = document.documentElement,

      mod = 'modernizr',
      modElem = document.createElement(mod),
      mStyle = modElem.style,

      inputElem,

      toString = {}.toString,

      prefixes = ' -webkit- -moz- -o- -ms- '.split(' '),

      omPrefixes = 'Webkit Moz O ms',

      cssomPrefixes = omPrefixes.split(' '),

      domPrefixes = omPrefixes.toLowerCase().split(' '),

      tests = {},
      inputs = {},
      attrs = {},

      classes = [],

      slice = classes.slice,

      featureName,

      injectElementWithStyles = function (rule, callback, nodes, testnames) {

        var style, ret, node, docOverflow,
          div = document.createElement('div'),
          body = document.body,
          fakeBody = body || document.createElement('body');

        if (parseInt(nodes, 10)) {
          while (nodes--) {
            node = document.createElement('div');
            node.id = testnames ? testnames[nodes] : mod + (nodes + 1);
            div.appendChild(node);
          }
        }

        style = ['&#173;', '<style id="s', mod, '">', rule, '</style>'].join('');
        div.id = mod;
        (body ? div : fakeBody).innerHTML += style;
        fakeBody.appendChild(div);
        if (!body) {
          fakeBody.style.background = '';
          fakeBody.style.overflow = 'hidden';
          docOverflow = docElement.style.overflow;
          docElement.style.overflow = 'hidden';
          docElement.appendChild(fakeBody);
        }

        ret = callback(div, rule);
        if (!body) {
          fakeBody.parentNode.removeChild(fakeBody);
          docElement.style.overflow = docOverflow;
        } else {
          div.parentNode.removeChild(div);
        }

        return !!ret;

      },
      _hasOwnProperty = ({}).hasOwnProperty, hasOwnProp;

    if (!is(_hasOwnProperty, 'undefined') && !is(_hasOwnProperty.call, 'undefined')) {
      hasOwnProp = function (object, property) {
        return _hasOwnProperty.call(object, property);
      };
    }
    else {
      hasOwnProp = function (object, property) {
        return ((property in object) && is(object.constructor.prototype[property], 'undefined'));
      };
    }


    if (!Function.prototype.bind) {
      Function.prototype.bind = function bind (that) {

        var target = this;

        if (typeof target != "function") {
          throw new TypeError();
        }

        var args = slice.call(arguments, 1),
          bound = function () {

            if (this instanceof bound) {

              var F = function () {
              };
              F.prototype = target.prototype;
              var self = new F();

              var result = target.apply(
                self,
                args.concat(slice.call(arguments))
              );
              if (Object(result) === result) {
                return result;
              }
              return self;

            } else {

              return target.apply(
                that,
                args.concat(slice.call(arguments))
              );

            }

          };

        return bound;
      };
    }

    function setCss (str) {
      mStyle.cssText = str;
    }

    function setCssAll (str1, str2) {
      return setCss(prefixes.join(str1 + ';') + ( str2 || '' ));
    }

    function is (obj, type) {
      return typeof obj === type;
    }

    function contains (str, substr) {
      return !!~('' + str).indexOf(substr);
    }

    function testProps (props, prefixed) {
      for (var i in props) {
        var prop = props[i];
        if (!contains(prop, "-") && mStyle[prop] !== undefined) {
          return prefixed == 'pfx' ? prop : true;
        }
      }
      return false;
    }

    function testDOMProps (props, obj, elem) {
      for (var i in props) {
        var item = obj[props[i]];
        if (item !== undefined) {

          if (elem === false) return props[i];

          if (is(item, 'function')) {
            return item.bind(elem || obj);
          }

          return item;
        }
      }
      return false;
    }

    function testPropsAll (prop, prefixed, elem) {

      var ucProp = prop.charAt(0).toUpperCase() + prop.slice(1),
        props = (prop + ' ' + cssomPrefixes.join(ucProp + ' ') + ucProp).split(' ');

      if (is(prefixed, "string") || is(prefixed, "undefined")) {
        return testProps(props, prefixed);

      } else {
        props = (prop + ' ' + (domPrefixes).join(ucProp + ' ') + ucProp).split(' ');
        return testDOMProps(props, prefixed, elem);
      }
    }

    tests['csstransforms3d'] = function () {

      var ret = !!testPropsAll('perspective');

// Chrome fails that test, ignore
//		if (ret && 'webkitPerspective' in docElement.style) {
//
//			injectElementWithStyles('@media (transform-3d),(-webkit-transform-3d){#modernizr{left:9px;position:absolute;height:3px;}}', function (node, rule) {
//				ret = node.offsetLeft === 9 && node.offsetHeight === 3;
//			});
//		}
      return ret;
    };

    for (var feature in tests) {
      if (hasOwnProp(tests, feature)) {
        featureName = feature.toLowerCase();
        Modernizr[featureName] = tests[feature]();

        classes.push((Modernizr[featureName] ? '' : 'no-') + featureName);
      }
    }

    Modernizr.addTest = function (feature, test) {
      if (typeof feature == 'object') {
        for (var key in feature) {
          if (hasOwnProp(feature, key)) {
            Modernizr.addTest(key, feature[ key ]);
          }
        }
      } else {

        feature = feature.toLowerCase();

        if (Modernizr[feature] !== undefined) {
          return Modernizr;
        }

        test = typeof test == 'function' ? test() : test;

        if (typeof enableClasses !== "undefined" && enableClasses) {
          docElement.className += ' ' + (test ? '' : 'no-') + feature;
        }
        Modernizr[feature] = test;

      }

      return Modernizr;
    };


    setCss('');
    modElem = inputElem = null;


    Modernizr._version = version;

    Modernizr._prefixes = prefixes;
    Modernizr._domPrefixes = domPrefixes;
    Modernizr._cssomPrefixes = cssomPrefixes;

    Modernizr.testProp = function (prop) {
      return testProps([prop]);
    };

    Modernizr.testAllProps = testPropsAll;

    Modernizr.testStyles = injectElementWithStyles;
    Modernizr.prefixed = function (prop, obj, elem) {
      if (!obj) {
        return testPropsAll(prop, 'pfx');
      } else {
        return testPropsAll(prop, obj, elem);
      }
    };

    return Modernizr;
  })(window, document);
  var fullScreenApi = {
      ok: false,
      is: function () {
        return false;
      },
      request: function () {
      },
      cancel: function () {
      },
      event: '',
      prefix: ''
    },
    browserPrefixes = 'webkit moz o ms khtml'.split(' ');

// check for native support
  if (typeof document.cancelFullScreen != 'undefined') {
    fullScreenApi.ok = true;
  } else {
    // check for fullscreen support by vendor prefix
    for (var i = 0, il = browserPrefixes.length; i < il; i++) {
      fullScreenApi.prefix = browserPrefixes[i];
      if (typeof document[fullScreenApi.prefix + 'CancelFullScreen' ] != 'undefined') {
        fullScreenApi.ok = true;
        break;
      }
    }
  }

// update methods to do something useful
  if (fullScreenApi.ok) {
    fullScreenApi.event = fullScreenApi.prefix + 'fullscreenchange';
    fullScreenApi.is = function () {
      switch (this.prefix) {
        case '':
          return document.fullScreen;
        case 'webkit':
          return document.webkitIsFullScreen;
        default:
          return document[this.prefix + 'FullScreen'];
      }
    };
    fullScreenApi.request = function (el) {
      return (this.prefix === '') ? el.requestFullScreen() : el[this.prefix + 'RequestFullScreen']();
    };
    fullScreenApi.cancel = function (el) {
      return (this.prefix === '') ? document.cancelFullScreen() : document[this.prefix + 'CancelFullScreen']();
    };
  }

//fgnass.github.com/spin.js#v1.3.2

  /**
   * Copyright (c) 2011-2013 Felix Gnass
   * Licensed under the MIT license
   */

  var Spinner,
    spinnerDefaults = {
      lines: 12, // The number of lines to draw
      length: 5, // The length of each line
      width: 2, // The line thickness
      radius: 7, // The radius of the inner circle
      corners: 1, // Corner roundness (0..1)
      rotate: 15, // The rotation offset
      color: 'rgba(128, 128, 128, .75)',
      hwaccel: true
    },
    spinnerOverride = {
      top: 'auto',
      left: 'auto',
      className: ''
    };

  (function(root, factory) {

    /* CommonJS */
    //if (typeof exports == 'object')  module.exports = factory()

    /* AMD module */
    //else if (typeof define == 'function' && define.amd) define(factory)

    /* Browser global */
    //else root.Spinner = factory()

    Spinner = factory();
  }
  (this, function() {
    "use strict";

    var prefixes = ['webkit', 'Moz', 'ms', 'O'] /* Vendor prefixes */
      , animations = {} /* Animation rules keyed by their name */
      , useCssAnimations /* Whether to use CSS animations or setTimeout */

    /**
     * Utility function to create elements. If no tag name is given,
     * a DIV is created. Optionally properties can be passed.
     */
    function createEl(tag, prop) {
      var el = document.createElement(tag || 'div')
        , n

      for(n in prop) el[n] = prop[n]
      return el
    }

    /**
     * Appends children and returns the parent.
     */
    function ins(parent /* child1, child2, ...*/) {
      for (var i=1, n=arguments.length; i<n; i++)
        parent.appendChild(arguments[i])

      return parent
    }

    /**
     * Insert a new stylesheet to hold the @keyframe or VML rules.
     */
    var sheet = (function() {
      var el = createEl('style', {type : 'text/css'})
      ins(document.getElementsByTagName('head')[0], el)
      return el.sheet || el.styleSheet
    }())

    /**
     * Creates an opacity keyframe animation rule and returns its name.
     * Since most mobile Webkits have timing issues with animation-delay,
     * we create separate rules for each line/segment.
     */
    function addAnimation(alpha, trail, i, lines) {
      var name = ['opacity', trail, ~~(alpha*100), i, lines].join('-')
        , start = 0.01 + i/lines * 100
        , z = Math.max(1 - (1-alpha) / trail * (100-start), alpha)
        , prefix = useCssAnimations.substring(0, useCssAnimations.indexOf('Animation')).toLowerCase()
        , pre = prefix && '-' + prefix + '-' || ''

      if (!animations[name]) {
        sheet.insertRule(
          '@' + pre + 'keyframes ' + name + '{' +
          '0%{opacity:' + z + '}' +
          start + '%{opacity:' + alpha + '}' +
          (start+0.01) + '%{opacity:1}' +
          (start+trail) % 100 + '%{opacity:' + alpha + '}' +
          '100%{opacity:' + z + '}' +
          '}', sheet.cssRules.length)

        animations[name] = 1
      }

      return name
    }

    /**
     * Tries various vendor prefixes and returns the first supported property.
     */
    function vendor(el, prop) {
      var s = el.style
        , pp
        , i

      prop = prop.charAt(0).toUpperCase() + prop.slice(1)
      for(i=0; i<prefixes.length; i++) {
        pp = prefixes[i]+prop
        if(s[pp] !== undefined) return pp
      }
      if(s[prop] !== undefined) return prop
    }

    /**
     * Sets multiple style properties at once.
     */
    function css(el, prop) {
      for (var n in prop)
        el.style[vendor(el, n)||n] = prop[n]

      return el
    }

    /**
     * Fills in default values.
     */
    function merge(obj) {
      for (var i=1; i < arguments.length; i++) {
        var def = arguments[i]
        for (var n in def)
          if (obj[n] === undefined) obj[n] = def[n]
      }
      return obj
    }

    /**
     * Returns the absolute page-offset of the given element.
     */
    function pos(el) {
      var o = { x:el.offsetLeft, y:el.offsetTop }
      while((el = el.offsetParent))
        o.x+=el.offsetLeft, o.y+=el.offsetTop

      return o
    }

    /**
     * Returns the line color from the given string or array.
     */
    function getColor(color, idx) {
      return typeof color == 'string' ? color : color[idx % color.length]
    }

    // Built-in defaults

    var defaults = {
      lines: 12,            // The number of lines to draw
      length: 7,            // The length of each line
      width: 5,             // The line thickness
      radius: 10,           // The radius of the inner circle
      rotate: 0,            // Rotation offset
      corners: 1,           // Roundness (0..1)
      color: '#000',        // #rgb or #rrggbb
      direction: 1,         // 1: clockwise, -1: counterclockwise
      speed: 1,             // Rounds per second
      trail: 100,           // Afterglow percentage
      opacity: 1/4,         // Opacity of the lines
      fps: 20,              // Frames per second when using setTimeout()
      zIndex: 2e9,          // Use a high z-index by default
      className: 'spinner', // CSS class to assign to the element
      top: 'auto',          // center vertically
      left: 'auto',         // center horizontally
      position: 'relative'  // element position
    }

    /** The constructor */
    function Spinner(o) {
      if (typeof this == 'undefined') return new Spinner(o)
      this.opts = merge(o || {}, Spinner.defaults, defaults)
    }

    // Global defaults that override the built-ins:
    Spinner.defaults = {}

    merge(Spinner.prototype, {

      /**
       * Adds the spinner to the given target element. If this instance is already
       * spinning, it is automatically removed from its previous target b calling
       * stop() internally.
       */
      spin: function(target) {
        this.stop()

        var self = this
          , o = self.opts
          , el = self.el = css(createEl(0, {className: o.className}), {position: o.position, width: 0, zIndex: o.zIndex})
          , mid = o.radius+o.length+o.width
          , ep // element position
          , tp // target position

        if (target) {
          target.insertBefore(el, target.firstChild||null)
          tp = pos(target)
          ep = pos(el)
          css(el, {
            left: (o.left == 'auto' ? tp.x-ep.x + (target.offsetWidth >> 1) : parseInt(o.left, 10) + mid) + 'px',
            top: (o.top == 'auto' ? tp.y-ep.y + (target.offsetHeight >> 1) : parseInt(o.top, 10) + mid)  + 'px'
          })
        }

        el.setAttribute('role', 'progressbar')
        self.lines(el, self.opts)

        if (!useCssAnimations) {
          // No CSS animation support, use setTimeout() instead
          var i = 0
            , start = (o.lines - 1) * (1 - o.direction) / 2
            , alpha
            , fps = o.fps
            , f = fps/o.speed
            , ostep = (1-o.opacity) / (f*o.trail / 100)
            , astep = f/o.lines

          ;(function anim() {
            i++;
            for (var j = 0; j < o.lines; j++) {
              alpha = Math.max(1 - (i + (o.lines - j) * astep) % f * ostep, o.opacity)

              self.opacity(el, j * o.direction + start, alpha, o)
            }
            self.timeout = self.el && setTimeout(anim, ~~(1000/fps))
          })()
        }
        return self
      },

      /**
       * Stops and removes the Spinner.
       */
      stop: function() {
        var el = this.el
        if (el) {
          clearTimeout(this.timeout)
          if (el.parentNode) el.parentNode.removeChild(el)
          this.el = undefined
        }
        return this
      },

      /**
       * Internal method that draws the individual lines. Will be overwritten
       * in VML fallback mode below.
       */
      lines: function(el, o) {
        var i = 0
          , start = (o.lines - 1) * (1 - o.direction) / 2
          , seg

        function fill(color, shadow) {
          return css(createEl(), {
            position: 'absolute',
            width: (o.length+o.width) + 'px',
            height: o.width + 'px',
            background: color,
            boxShadow: shadow,
            transformOrigin: 'left',
            transform: 'rotate(' + ~~(360/o.lines*i+o.rotate) + 'deg) translate(' + o.radius+'px' +',0)',
            borderRadius: (o.corners * o.width>>1) + 'px'
          })
        }

        for (; i < o.lines; i++) {
          seg = css(createEl(), {
            position: 'absolute',
            top: 1+~(o.width/2) + 'px',
            transform: o.hwaccel ? 'translate3d(0,0,0)' : '',
            opacity: o.opacity,
            animation: useCssAnimations && addAnimation(o.opacity, o.trail, start + i * o.direction, o.lines) + ' ' + 1/o.speed + 's linear infinite'
          })

          if (o.shadow) ins(seg, css(fill('#000', '0 0 4px ' + '#000'), {top: 2+'px'}))
          ins(el, ins(seg, fill(getColor(o.color, i), '0 0 1px rgba(0,0,0,.1)')))
        }
        return el
      },

      /**
       * Internal method that adjusts the opacity of a single line.
       * Will be overwritten in VML fallback mode below.
       */
      opacity: function(el, i, val) {
        if (i < el.childNodes.length) el.childNodes[i].style.opacity = val
      }

    })


    function initVML() {

      /* Utility function to create a VML tag */
      function vml(tag, attr) {
        return createEl('<' + tag + ' xmlns="urn:schemas-microsoft.com:vml" class="spin-vml">', attr)
      }

      // No CSS transforms but VML support, add a CSS rule for VML elements:
      sheet.addRule('.spin-vml', 'behavior:url(#default#VML)')

      Spinner.prototype.lines = function(el, o) {
        var r = o.length+o.width
          , s = 2*r

        function grp() {
          return css(
            vml('group', {
              coordsize: s + ' ' + s,
              coordorigin: -r + ' ' + -r
            }),
            { width: s, height: s }
          )
        }

        var margin = -(o.width+o.length)*2 + 'px'
          , g = css(grp(), {position: 'absolute', top: margin, left: margin})
          , i

        function seg(i, dx, filter) {
          ins(g,
            ins(css(grp(), {rotation: 360 / o.lines * i + 'deg', left: ~~dx}),
              ins(css(vml('roundrect', {arcsize: o.corners}), {
                  width: r,
                  height: o.width,
                  left: o.radius,
                  top: -o.width>>1,
                  filter: filter
                }),
                vml('fill', {color: getColor(o.color, i), opacity: o.opacity}),
                vml('stroke', {opacity: 0}) // transparent stroke to fix color bleeding upon opacity change
              )
            )
          )
        }

        if (o.shadow)
          for (i = 1; i <= o.lines; i++)
            seg(i, -2, 'progid:DXImageTransform.Microsoft.Blur(pixelradius=2,makeshadow=1,shadowopacity=.3)')

        for (i = 1; i <= o.lines; i++) seg(i)
        return ins(el, g)
      }

      Spinner.prototype.opacity = function(el, i, val, o) {
        var c = el.firstChild
        o = o.shadow && o.lines || 0
        if (c && i+o < c.childNodes.length) {
          c = c.childNodes[i+o]; c = c && c.firstChild; c = c && c.firstChild
          if (c) c.opacity = val
        }
      }
    }

    var probe = css(createEl('group'), {behavior: 'url(#default#VML)'})

    if (!vendor(probe, 'transform') && probe.adj) initVML()
    else useCssAnimations = vendor(probe, 'animation')

    return Spinner

  }));


  /* Bez v1.0.10-g5ae0136
   * http://github.com/rdallasgray/bez
   *
   * A plugin to convert CSS3 cubic-bezier co-ordinates to jQuery-compatible easing functions
   *
   * With thanks to Nikolay Nemshilov for clarification on the cubic-bezier maths
   * See http://st-on-it.blogspot.com/2011/05/calculating-cubic-bezier-function.html
   *
   * Copyright 2011 Robert Dallas Gray. All rights reserved.
   * Provided under the FreeBSD license: https://github.com/rdallasgray/bez/blob/master/LICENSE.txt
   */
  function bez (coOrdArray) {
    var encodedFuncName = "bez_" + $.makeArray(arguments).join("_").replace(".", "p");
    if (typeof $['easing'][encodedFuncName] !== "function") {
      var polyBez = function (p1, p2) {
        var A = [null, null],
          B = [null, null],
          C = [null, null],
          bezCoOrd = function (t, ax) {
            C[ax] = 3 * p1[ax];
            B[ax] = 3 * (p2[ax] - p1[ax]) - C[ax];
            A[ax] = 1 - C[ax] - B[ax];
            return t * (C[ax] + t * (B[ax] + t * A[ax]));
          },
          xDeriv = function (t) {
            return C[0] + t * (2 * B[0] + 3 * A[0] * t);
          },
          xForT = function (t) {
            var x = t, i = 0, z;
            while (++i < 14) {
              z = bezCoOrd(x, 0) - t;
              if (Math.abs(z) < 1e-3) break;
              x -= z / xDeriv(x);
            }
            return x;
          };
        return function (t) {
          return bezCoOrd(xForT(t), 1);
        }
      };
      $['easing'][encodedFuncName] = function (x, t, b, c, d) {
        return c * polyBez([coOrdArray[0], coOrdArray[1]], [coOrdArray[2], coOrdArray[3]])(t / d) + b;
      }
    }
    return encodedFuncName;
  }
  var $WINDOW = $(window),
    $DOCUMENT = $(document),
    $HTML,
    $BODY,

    QUIRKS_FORCE = location.hash.replace('#', '') === 'quirks',
    TRANSFORMS3D = Modernizr.csstransforms3d,
    CSS3 = TRANSFORMS3D && !QUIRKS_FORCE,
    COMPAT = TRANSFORMS3D || document.compatMode === 'CSS1Compat',
    FULLSCREEN = fullScreenApi.ok,

    MOBILE = navigator.userAgent.match(/Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone/i),
    SLOW = !CSS3 || MOBILE,

    MS_POINTER = navigator.msPointerEnabled,

    WHEEL = "onwheel" in document.createElement("div") ? "wheel" : document.onmousewheel !== undefined ? "mousewheel" : "DOMMouseScroll",

    TOUCH_TIMEOUT = 250,
    TRANSITION_DURATION = 300,

    SCROLL_LOCK_TIMEOUT = 1400,

    AUTOPLAY_INTERVAL = 5000,
    MARGIN = 2,
    THUMB_SIZE = 64,

    WIDTH = 500,
    HEIGHT = 333,

    STAGE_FRAME_KEY = '$stageFrame',
    NAV_DOT_FRAME_KEY = '$navDotFrame',
    NAV_THUMB_FRAME_KEY = '$navThumbFrame',

    AUTO = 'auto',

    BEZIER = bez([.1, 0, .25, 1]),

    MAX_WIDTH = 99999,

    FIFTYFIFTY = '50%',

    OPTIONS = {
      // dimensions
      width: null, // 500 || '100%'
      minwidth: null,
      maxwidth: '100%', // '100%'
      height: null,
      minheight: null,
      maxheight: null,

      ratio: null, // '16/9' || 500/333 || 1.5

      margin: MARGIN,
      glimpse: 0,

      fit: 'contain', // 'cover' || 'scaledown' || 'none'

      position: FIFTYFIFTY,
      thumbposition: FIFTYFIFTY,

      // navigation, thumbs
      nav: 'dots', // 'thumbs' || false
      navposition: 'bottom', // 'top'
      navwidth: null,
      thumbwidth: THUMB_SIZE,
      thumbheight: THUMB_SIZE,
      thumbmargin: MARGIN,
      thumbborderwidth: MARGIN,
      thumbfit: 'cover', // 'contain' || 'scaledown' || 'none'

      allowfullscreen: false, // true || 'native'

      transition: 'slide', // 'crossfade' || 'dissolve'
      clicktransition: null,
      transitionduration: TRANSITION_DURATION,

      captions: true,

      hash: false,
      startindex: 0,

      loop: false,

      autoplay: false,
      stopautoplayontouch: true,

      keyboard: false,

      arrows: true,
      click: true,
      swipe: true,
      trackpad: false,

      enableifsingleframe: false,

      controlsonstart: true,

      shuffle: false,

      direction: 'ltr', // 'rtl'

      shadows: true,
      spinner: null
    },

    KEYBOARD_OPTIONS = {
      left: true,
      right: true,
      down: false,
      up: false,
      space: false,
      home: false,
      end: false
    };
  function noop () {}

  function minMaxLimit (value, min, max) {
    return Math.max(isNaN(min) ? -Infinity : min, Math.min(isNaN(max) ? Infinity : max, value));
  }

  function readTransform (css) {
    return css.match(/ma/) && css.match(/-?\d+(?!d)/g)[css.match(/3d/) ? 12 : 4];
  }

  function readPosition ($el) {
    if (CSS3) {
      return +readTransform($el.css('transform'));
    } else {
      return +$el.css('left').replace('px', '');
    }
  }

  function getTranslate (pos/*, _001*/) {
    var obj = {};
    if (CSS3) {
      obj.transform = 'translate3d(' + (pos/* + (_001 ? 0.001 : 0)*/) + 'px,0,0)'; // 0.001 to remove Retina artifacts
    } else {
      obj.left = pos;
    }
    return obj;
  }

  function getDuration (time) {
    return {'transition-duration': time + 'ms'};
  }

  function unlessNaN (value, alternative) {
    return isNaN(value) ? alternative : value;
  }

  function numberFromMeasure (value, measure) {
    return unlessNaN(+String(value).replace(measure || 'px', ''));
  }

  function numberFromPercent (value) {
    return /%$/.test(value) ? numberFromMeasure(value, '%') : undefined;
  }

  function numberFromWhatever (value, whole) {
    return unlessNaN(numberFromPercent(value) / 100 * whole, numberFromMeasure(value));
  }

  function measureIsValid (value) {
    return (!isNaN(numberFromMeasure(value)) || !isNaN(numberFromMeasure(value, '%'))) && value;
  }

  function getPosByIndex (index, side, margin, baseIndex) {
    //console.log('getPosByIndex', index, side, margin, baseIndex);
    //console.log((index - (baseIndex || 0)) * (side + (margin || 0)));

    return (index - (baseIndex || 0)) * (side + (margin || 0));
  }

  function getIndexByPos (pos, side, margin, baseIndex) {
    return -Math.round(pos / (side + (margin || 0)) - (baseIndex || 0));
  }

  function bindTransitionEnd ($el) {
    var elData = $el.data();

    if (elData.tEnd) return;

    var el = $el[0],
      transitionEndEvent = {
        WebkitTransition: 'webkitTransitionEnd',
        MozTransition: 'transitionend',
        OTransition: 'oTransitionEnd otransitionend',
        msTransition: 'MSTransitionEnd',
        transition: 'transitionend'
      };
    addEvent(el, transitionEndEvent[Modernizr.prefixed('transition')], function (e) {
      elData.tProp && e.propertyName.match(elData.tProp) && elData.onEndFn();
    });
    elData.tEnd = true;
  }

  function afterTransition ($el, property, fn, time) {
    var ok,
      elData = $el.data();

    if (elData) {
      elData.onEndFn = function () {
        if (ok) return;
        ok = true;
        clearTimeout(elData.tT);
        fn();
      };
      elData.tProp = property;

      // Passive call, just in case of fail of native transition-end event
      clearTimeout(elData.tT);
      elData.tT = setTimeout(function () {
        elData.onEndFn();
      }, time * 1.5);

      bindTransitionEnd($el);
    }
  }


  function stop ($el, left/*, _001*/) {
    if ($el.length) {
      var elData = $el.data();
      if (CSS3) {
        $el.css(getDuration(0));
        elData.onEndFn = noop;
        clearTimeout(elData.tT);
      } else {
        $el.stop();
      }
      var lockedLeft = getNumber(left, function () {
        return readPosition($el);
      });

      $el.css(getTranslate(lockedLeft/*, _001*/));//.width(); // `.width()` for reflow
      return lockedLeft;
    }
  }

  function getNumber () {
    var number;
    for (var _i = 0, _l = arguments.length; _i < _l; _i++) {
      number = _i ? arguments[_i]() : arguments[_i];
      if (typeof number === 'number') {
        break;
      }
    }

    return number;
  }

  function edgeResistance (pos, edge) {
    return Math.round(pos + ((edge - pos) / 1.5));
  }

  function getProtocol () {
    getProtocol.p = getProtocol.p || (location.protocol === 'https:' ? 'https://' : 'http://');
    return getProtocol.p;
  }

  function parseHref (href) {
    var a = document.createElement('a');
    a.href = href;
    return a;
  }

  function findVideoId (href, forceVideo) {
    if (typeof href !== 'string') return href;
    var source = href;
    href = parseHref(href);

    var id,
      type;

    if (href.host.match(/youtube\.com/) && href.search) {
      id = href.search.split('v=')[1];
      if (id) {
        var ampersandPosition = id.indexOf('&');
        if (ampersandPosition !== -1) {
          id = id.substring(0, ampersandPosition);
        }
        type = 'youtube';
      } else {
        id = href.pathname.split('embed/')[1];
        if (id) {
          type = 'youtube';
        }
      }
    } else if (href.host.match(/youtube\.com|youtu\.be/)) {
      id = href.pathname.replace(/^\/(embed\/|v\/)?/, '').replace(/\/.*/, '');
      type = 'youtube';
    } else if (href.host.match(/vimeo\.com/)) {
      type = 'vimeo';
      id = href.pathname.replace(/^\/(video\/)?/, '').replace(/\/.*/, '');
    } else if (href.pathname.match(/m3u8/)) {
      type = 'm3u8';
      id = href.pathname.substring(href.pathname.lastIndexOf('/')+1);
    }

    if ((!id || !type) && forceVideo) {
      id = href.href;
      type = 'custom';
    }
    return id ? {id: id, type: type, s: href.search.replace(/^\?/, ''), p: getProtocol(), href: source} : false;
  }

  function getVideoThumbs (dataFrame, data, fotorama) {
    var img, thumb, video = dataFrame.video;
    if (video.type === 'youtube') {
      thumb = getProtocol() + 'img.youtube.com/vi/' + video.id + '/default.jpg';
      img = thumb.replace(/\/default.jpg$/, '/hqdefault.jpg');
      dataFrame.thumbsReady = true;
    } else if (video.type === 'vimeo') {
      $.ajax({
        url: getProtocol() + 'vimeo.com/api/v2/video/' + video.id + '.json',
        dataType: 'jsonp',
        success: function (json) {
          dataFrame.thumbsReady = true;
          updateData(data, {img: json[0].thumbnail_large, thumb: json[0].thumbnail_small}, dataFrame.i, fotorama);
        }
      });
    } else {
      dataFrame.thumbsReady = true;
    }

    return {
      img: img,
      thumb: thumb
    }
  }

  function updateData (data, _dataFrame, i, fotorama) {
    for (var _i = 0, _l = data.length; _i < _l; _i++) {
      var dataFrame = data[_i];

      if (dataFrame.i === i && dataFrame.thumbsReady) {
        var clear = {videoReady: true};
        clear[STAGE_FRAME_KEY] = clear[NAV_THUMB_FRAME_KEY] = clear[NAV_DOT_FRAME_KEY] = false;

        fotorama.splice(_i, 1, $.extend(
          {},
          dataFrame,
          clear,
          _dataFrame
        ));

        break;
      }
    }
  }

  function getDataFromHtml ($el) {
    var data = [];

    function getDataFromImg ($img, imgData, checkVideo) {
      var $child = $img.children('img').eq(0),
        _imgHref = $img.attr('href'),
        _imgSrc = $img.attr('src'),
        _thumbSrc = $child.attr('src'),
        _video = imgData.video,
        video = checkVideo ? findVideoId(_imgHref, _video === true) : false;

      if (video) {
        _imgHref = false;
      } else {
        video = _video;
      }

      getDimensions($img, $child, $.extend(imgData, {
        video: video,
        img: imgData.img || _imgHref || _imgSrc || _thumbSrc,
        thumb: imgData.thumb || _thumbSrc || _imgSrc || _imgHref
      }));
    }

    function getDimensions ($img, $child, imgData) {
      var separateThumbFLAG = imgData.thumb && imgData.img !== imgData.thumb,
        width = numberFromMeasure(imgData.width || $img.attr('width')),
        height = numberFromMeasure(imgData.height || $img.attr('height'));

      $.extend(imgData, {
        width: width,
        height: height,
        thumbratio: getRatio(imgData.thumbratio || (numberFromMeasure(imgData.thumbwidth || ($child && $child.attr('width')) || separateThumbFLAG || width) / numberFromMeasure(imgData.thumbheight || ($child && $child.attr('height')) || separateThumbFLAG || height)))
      });
    }

    $el.children().each(function () {
      var $this = $(this),
        dataFrame = optionsToLowerCase($.extend($this.data(), {id: $this.attr('id')}));
      if ($this.is('a, img')) {
        getDataFromImg($this, dataFrame, true);
      } else if (!$this.is(':empty')) {
        getDimensions($this, null, $.extend(dataFrame, {
          html: this,
          _html: $this.html() // Because of IE
        }));
      } else return;

      data.push(dataFrame);
    });

    return data;
  }

  function isHidden (el) {
    return el.offsetWidth === 0 && el.offsetHeight === 0;
  }

  function isDetached (el) {
    return !$.contains(document.documentElement, el);
  }

  function waitFor (test, fn, timeout, i) {
    if (!waitFor.i) {
      waitFor.i = 1;
      waitFor.ii = [true];
    }

    i = i || waitFor.i;

    if (typeof waitFor.ii[i] === 'undefined') {
      waitFor.ii[i] = true;
    }

    if (test()) {
      fn();
    } else {
      waitFor.ii[i] && setTimeout(function () {
        waitFor.ii[i] && waitFor(test, fn, timeout, i);
      }, timeout || 100);
    }

    return waitFor.i++;
  }

  waitFor.stop = function (i) {
    waitFor.ii[i] = false;
  };

  function setHash (hash) {
    ////console.time('setHash ' + hash);
    location.replace(location.protocol
      + '//'
      + location.host
      + location.pathname.replace(/^\/?/, '/')
      + location.search
      + '#' + hash);
    ////console.timeEnd('setHash ' + hash);
  }

  function fit ($el, measuresToFit, method, position) {
    var elData = $el.data(),
      measures = elData.measures;

    if (measures && (!elData.l ||
      elData.l.W !== measures.width ||
      elData.l.H !== measures.height ||
      elData.l.r !== measures.ratio ||
      elData.l.w !== measuresToFit.w ||
      elData.l.h !== measuresToFit.h ||
      elData.l.m !== method ||
      elData.l.p !== position)) {

      var width = measures.width,
        height = measures.height,
        ratio = measuresToFit.w / measuresToFit.h,
        biggerRatioFLAG = measures.ratio >= ratio,
        fitFLAG = method === 'scaledown',
        containFLAG = method === 'contain',
        coverFLAG = method === 'cover',
        pos = parsePosition(position);

      if (biggerRatioFLAG && (fitFLAG || containFLAG) || !biggerRatioFLAG && coverFLAG) {
        width = minMaxLimit(measuresToFit.w, 0, fitFLAG ? width : Infinity);
        height = width / measures.ratio;
      } else if (biggerRatioFLAG && coverFLAG || !biggerRatioFLAG && (fitFLAG || containFLAG)) {
        height = minMaxLimit(measuresToFit.h, 0, fitFLAG ? height : Infinity);
        width = height * measures.ratio;
      }

      $el.css({
        width: width,
        height: height,
        left: numberFromWhatever(pos.x, measuresToFit.w - width),
        top: numberFromWhatever(pos.y, measuresToFit.h- height)
      });

      elData.l = {
        W: measures.width,
        H: measures.height,
        r: measures.ratio,
        w: measuresToFit.w,
        h: measuresToFit.h,
        m: method,
        p: position
      };
    }

    return true;
  }

  function setStyle ($el, style) {
    var el = $el[0];
    if (el.styleSheet) {
      el.styleSheet.cssText = style;
    } else {
      $el.html(style);
    }
  }

  function findShadowEdge (pos, min, max) {
    return min === max ? false : pos <= min ? 'left' : pos >= max ? 'right' : 'left right';
  }

  function getIndexFromHash (hash, data, ok, startindex) {
    if (!ok) return false;
    if (!isNaN(hash)) return hash - (startindex ? 0 : 1);

    var index;

    for (var _i = 0, _l = data.length; _i < _l; _i++) {
      var dataFrame = data[_i];

      if (dataFrame.id === hash) {
        index = _i;
        break;
      }
    }

    return index;
  }

  function smartClick ($el, fn, _options) {
    _options = _options || {};

    $el.each(function () {
      var $this = $(this),
        thisData = $this.data(),
        startEvent;

      if (thisData.clickOn) return;

      thisData.clickOn = true;

      $.extend(touch($this, {
        onStart: function (e) {
          startEvent = e;
          (_options.onStart || noop).call(this, e);
        },
        onMove: _options.onMove || noop,
        onTouchEnd: _options.onTouchEnd || noop,
        onEnd: function (result) {
          //console.log('smartClick → result.moved', result.moved);
          if (result.moved) return;
          fn.call(this, startEvent);
        }
      }), {noMove: true});
    });
  }

  function div (classes, child) {
    return '<div class="' + classes + '">' + (child || '') + '</div>';
  }

// Fisher–Yates Shuffle
// http://bost.ocks.org/mike/shuffle/
  function shuffle (array) {
    // While there remain elements to shuffle
    var l = array.length;
    while (l) {
      // Pick a remaining element
      var i = Math.floor(Math.random() * l--);

      // And swap it with the current element
      var t = array[l];
      array[l] = array[i];
      array[i] = t;
    }

    return array;
  }

  function clone (array) {
    return Object.prototype.toString.call(array) == '[object Array]'
      && $.map(array, function (frame) {
        return $.extend({}, frame);
      });
  }

  function lockScroll ($el, left, top) {
    $el
      .scrollLeft(left || 0)
      .scrollTop(top || 0);
  }

  function optionsToLowerCase (options) {
    if (options) {
      var opts = {};
      $.each(options, function (key, value) {
        opts[key.toLowerCase()] = value;
      });

      return opts;
    }
  }

  function getRatio (_ratio) {
    if (!_ratio) return;
    var ratio = +_ratio;
    if (!isNaN(ratio)) {
      return ratio;
    } else {
      ratio = _ratio.split('/');
      return +ratio[0] / +ratio[1] || undefined;
    }
  }

  function addEvent (el, e, fn, bool) {
    if (!e) return;
    el.addEventListener ? el.addEventListener(e, fn, !!bool) : el.attachEvent('on'+e, fn);
  }

  function elIsDisabled (el) {
    return !!el.getAttribute('disabled');
  }

  function disableAttr (FLAG) {
    return {tabindex: FLAG * -1 + '', disabled: FLAG};
  }

  function addEnterUp (el, fn) {
    addEvent(el, 'keyup', function (e) {
      elIsDisabled(el) || e.keyCode == 13 && fn.call(el, e);
    });
  }

  function addFocus (el, fn) {
    addEvent(el, 'focus', el.onfocusin = function (e) {
      fn.call(el, e);
    }, true);
  }

  function stopEvent (e, stopPropagation) {
    e.preventDefault ? e.preventDefault() : (e.returnValue = false);
    stopPropagation && e.stopPropagation && e.stopPropagation();
  }

  function getDirectionSign (forward) {
    return forward ? '>' : '<';
  }

  function parsePosition (rule) {
    rule = (rule + '').split(/\s+/);
    return {
      x: measureIsValid(rule[0]) || FIFTYFIFTY,
      y: measureIsValid(rule[1]) || FIFTYFIFTY
    }
  }
  function slide ($el, options) {
    var elData = $el.data(),
      elPos = Math.round(options.pos),
      onEndFn = function () {
        elData.sliding = false;
        (options.onEnd || noop)();
      };

    if (typeof options.overPos !== 'undefined' && options.overPos !== options.pos) {
      elPos = options.overPos;
      onEndFn = function () {
        slide($el, $.extend({}, options, {overPos: options.pos, time: Math.max(TRANSITION_DURATION, options.time / 2)}))
      };
    }

    //////console.time('var translate = $.extend');
    var translate = $.extend(getTranslate(elPos/*, options._001*/), options.width && {width: options.width});
    //////console.timeEnd('var translate = $.extend');

    elData.sliding = true;

    if (CSS3) {
      $el.css($.extend(getDuration(options.time), translate));
      if (options.time > 10) {
        //////console.time('afterTransition');
        afterTransition($el, 'transform', onEndFn, options.time);
        //////console.timeEnd('afterTransition');
      } else {
        onEndFn();
      }
    } else {
      $el.stop().animate(translate, options.time, BEZIER, onEndFn);
    }
  }

  function fade ($el1, $el2, $frames, options, fadeStack, chain) {
    var chainedFLAG = typeof chain !== 'undefined';
    if (!chainedFLAG) {
      fadeStack.push(arguments);
      Array.prototype.push.call(arguments, fadeStack.length);
      if (fadeStack.length > 1) return;
    }

    $el1 = $el1 || $($el1);
    $el2 = $el2 || $($el2);

    var _$el1 = $el1[0],
      _$el2 = $el2[0],
      crossfadeFLAG = options.method === 'crossfade',
      onEndFn = function () {
        if (!onEndFn.done) {
          onEndFn.done = true;
          var args = (chainedFLAG || fadeStack.shift()) && fadeStack.shift();
          args && fade.apply(this, args);
          (options.onEnd || noop)(!!args);
        }
      },
      time = options.time / (chain || 1);

    $frames.removeClass(fadeRearClass + ' ' + fadeFrontClass);

    $el1
      .stop()
      .addClass(fadeRearClass);
    $el2
      .stop()
      .addClass(fadeFrontClass);

    crossfadeFLAG && _$el2 && $el1.fadeTo(0, 0);

    $el1.fadeTo(crossfadeFLAG ? time : 0, 1, crossfadeFLAG && onEndFn);
    $el2.fadeTo(time, 0, onEndFn);

    (_$el1 && crossfadeFLAG) || _$el2 || onEndFn();
  }
  var lastEvent,
    moveEventType,
    preventEvent,
    preventEventTimeout;

  function extendEvent (e) {
    var touch = (e.touches || [])[0] || e;
    e._x = touch.pageX;
    e._y = touch.clientY;
    e._now = $.now();
  }

  function touch ($el, options) {
    var el = $el[0],
      tail = {},
      touchEnabledFLAG,
      startEvent,
      $target,
      controlTouch,
      touchFLAG,
      targetIsSelectFLAG,
      targetIsLinkFlag,
      tolerance,
      moved;

    function onStart (e) {
      $target = $(e.target);
      tail.checked = targetIsSelectFLAG = targetIsLinkFlag = moved = false;

      if (touchEnabledFLAG
        || tail.flow
        || (e.touches && e.touches.length > 1)
        || e.which > 1
        || (lastEvent && lastEvent.type !== e.type && preventEvent)
        || (targetIsSelectFLAG = options.select && $target.is(options.select, el))) return targetIsSelectFLAG;

      touchFLAG = e.type === 'touchstart';
      targetIsLinkFlag = $target.is('a, a *', el);
      controlTouch = tail.control;

      tolerance = (tail.noMove || tail.noSwipe || controlTouch) ? 16 : !tail.snap ? 4 : 0;

      extendEvent(e);

      startEvent = lastEvent = e;
      moveEventType = e.type.replace(/down|start/, 'move').replace(/Down/, 'Move');

      (options.onStart || noop).call(el, e, {control: controlTouch, $target: $target});

      touchEnabledFLAG = tail.flow = true;

      if (!touchFLAG || tail.go) stopEvent(e);
    }

    function onMove (e) {
      if ((e.touches && e.touches.length > 1)
        || (MS_POINTER && !e.isPrimary)
        || moveEventType !== e.type
        || !touchEnabledFLAG) {
        touchEnabledFLAG && onEnd();
        (options.onTouchEnd || noop)();
        return;
      }

      extendEvent(e);

      var xDiff = Math.abs(e._x - startEvent._x), // opt _x → _pageX
        yDiff = Math.abs(e._y - startEvent._y),
        xyDiff = xDiff - yDiff,
        xWin = (tail.go || tail.x || xyDiff >= 0) && !tail.noSwipe,
        yWin = xyDiff < 0;

      if (touchFLAG && !tail.checked) {
        if (touchEnabledFLAG = xWin) {
          stopEvent(e);
        }
      } else {
        //console.log('onMove e.preventDefault');
        stopEvent(e);
        (options.onMove || noop).call(el, e, {touch: touchFLAG});
      }

      if (!moved && Math.sqrt(Math.pow(xDiff, 2) + Math.pow(yDiff, 2)) > tolerance) {
        moved = true;
      }

      tail.checked = tail.checked || xWin || yWin;
    }

    function onEnd (e) {
      ////console.time('touch.js onEnd');

      (options.onTouchEnd || noop)();

      var _touchEnabledFLAG = touchEnabledFLAG;
      tail.control = touchEnabledFLAG = false;

      if (_touchEnabledFLAG) {
        tail.flow = false;
      }

      if (!_touchEnabledFLAG || (targetIsLinkFlag && !tail.checked)) return;

      e && stopEvent(e);

      preventEvent = true;
      clearTimeout(preventEventTimeout);
      preventEventTimeout = setTimeout(function () {
        preventEvent = false;
      }, 1000);

      (options.onEnd || noop).call(el, {moved: moved, $target: $target, control: controlTouch, touch: touchFLAG, startEvent: startEvent, aborted: !e || e.type === 'MSPointerCancel'});
      ////console.timeEnd('touch.js onEnd');
    }

    function onOtherStart () {
      if (tail.flow) return;
      setTimeout(function () {
        tail.flow = true;
      }, 10);
    }

    function onOtherEnd () {
      if (!tail.flow) return;
      setTimeout(function () {
        tail.flow = false;
      }, TOUCH_TIMEOUT);
    }

    if (MS_POINTER) {
      addEvent(el, 'MSPointerDown', onStart);
      addEvent(document, 'MSPointerMove', onMove);
      addEvent(document,'MSPointerCancel', onEnd);
      addEvent(document, 'MSPointerUp', onEnd);
    } else {
      addEvent(el, 'touchstart', onStart);
      addEvent(el, 'touchmove', onMove);
      addEvent(el, 'touchend', onEnd);

      addEvent(document, 'touchstart', onOtherStart);
      addEvent(document, 'touchend', onOtherEnd);
      addEvent(document, 'touchcancel', onOtherEnd);

      $WINDOW.on('scroll', onOtherEnd);

      $el.on('mousedown', onStart);
      $DOCUMENT
        .on('mousemove', onMove)
        .on('mouseup', onEnd);
    }

    $el.on('click', 'a', function (e) {
      tail.checked && stopEvent(e);
    });

    return tail;
  }

  function moveOnTouch ($el, options) {
    var el = $el[0],
      elData = $el.data(),
      tail = {},
      startCoo,
      coo,
      startElPos,
      moveElPos,
      edge,
      moveTrack,
      startTime,
      endTime,
      min,
      max,
      snap,
      slowFLAG,
      controlFLAG,
      moved,
      tracked;

    function startTracking (e, noStop) {
      tracked = true;
      startCoo = coo = e._x;
      startTime = e._now;

      moveTrack = [
        [startTime, startCoo]
      ];

      startElPos = moveElPos = tail.noMove || noStop ? 0 : stop($el, (options.getPos || noop)()/*, options._001*/);

      (options.onStart || noop).call(el, e);
    }

    function onStart (e, result) {
      min = tail.min;
      max = tail.max;
      snap = tail.snap;

      slowFLAG = e.altKey;
      tracked = moved = false;

      controlFLAG = result.control;

      if (!controlFLAG && !elData.sliding) {
        startTracking(e);
      }
    }

    function onMove (e, result) {
      if (!tail.noSwipe) {
        if (!tracked) {
          startTracking(e);
        }

        coo = e._x;

        moveTrack.push([e._now, coo]);

        moveElPos = startElPos - (startCoo - coo);

        edge = findShadowEdge(moveElPos, min, max);

        if (moveElPos <= min) {
          moveElPos = edgeResistance(moveElPos, min);
        } else if (moveElPos >= max) {
          moveElPos = edgeResistance(moveElPos, max);
        }

        if (!tail.noMove) {
          $el.css(getTranslate(moveElPos/*, options._001*/));
          if (!moved) {
            moved = true;
            // only for mouse
            result.touch || MS_POINTER || $el.addClass(grabbingClass);
          }

          (options.onMove || noop).call(el, e, {pos: moveElPos, edge: edge});
        }
      }
    }

    function onEnd (result) {
      ////console.time('moveontouch.js onEnd');
      if (tail.noSwipe && result.moved) return;

      if (!tracked) {
        startTracking(result.startEvent, true);
      }

      //console.log('onEnd');

      result.touch || MS_POINTER || $el.removeClass(grabbingClass);

      endTime = $.now();

      var _backTimeIdeal = endTime - TOUCH_TIMEOUT,
        _backTime,
        _timeDiff,
        _timeDiffLast,
        backTime = null,
        backCoo,
        virtualPos,
        limitPos,
        newPos,
        overPos,
        time = TRANSITION_DURATION,
        speed,
        friction = options.friction;

      for (var _i = moveTrack.length - 1; _i >= 0; _i--) {
        _backTime = moveTrack[_i][0];
        _timeDiff = Math.abs(_backTime - _backTimeIdeal);
        if (backTime === null || _timeDiff < _timeDiffLast) {
          backTime = _backTime;
          backCoo = moveTrack[_i][1];
        } else if (backTime === _backTimeIdeal || _timeDiff > _timeDiffLast) {
          break;
        }
        _timeDiffLast = _timeDiff;
      }

      newPos = minMaxLimit(moveElPos, min, max);

      var cooDiff = backCoo - coo,
        forwardFLAG = cooDiff >= 0,
        timeDiff = endTime - backTime,
        longTouchFLAG = timeDiff > TOUCH_TIMEOUT,
        swipeFLAG = !longTouchFLAG && moveElPos !== startElPos && newPos === moveElPos;

      if (snap) {
        newPos = minMaxLimit(Math[swipeFLAG ? (forwardFLAG ? 'floor' : 'ceil') : 'round'](moveElPos / snap) * snap, min, max);
        min = max = newPos;
      }

      if (swipeFLAG && (snap || newPos === moveElPos)) {
        speed = -(cooDiff / timeDiff);
        time *= minMaxLimit(Math.abs(speed), options.timeLow, options.timeHigh);
        virtualPos = Math.round(moveElPos + speed * time / friction);

        if (!snap) {
          newPos = virtualPos;
        }

        if (!forwardFLAG && virtualPos > max || forwardFLAG && virtualPos < min) {
          limitPos = forwardFLAG ? min : max;
          overPos = virtualPos - limitPos;
          if (!snap) {
            newPos = limitPos;
          }
          overPos = minMaxLimit(newPos + overPos * .03, limitPos - 50, limitPos + 50);
          time = Math.abs((moveElPos - overPos) / (speed / friction));
        }
      }

      time *= slowFLAG ? 10 : 1;

      (options.onEnd || noop).call(el, $.extend(result, {moved: result.moved || longTouchFLAG && snap, pos: moveElPos, newPos: newPos, overPos: overPos, time: time}));
    }

    tail = $.extend(touch(options.$wrap, $.extend({}, options, {
      onStart: onStart,
      onMove: onMove,
      onEnd: onEnd
    })), tail);

    return tail;
  }
  function wheel ($el, options) {
    var el = $el[0],
      lockFLAG,
      lastDirection,
      lastNow,
      tail = {
        prevent: {}
      };

    addEvent(el, WHEEL, function (e) {
      var yDelta = e.wheelDeltaY || -1 * e.deltaY || 0,
        xDelta = e.wheelDeltaX || -1 * e.deltaX || 0,
        xWin = Math.abs(xDelta) && !Math.abs(yDelta),
        direction = getDirectionSign(xDelta < 0),
        sameDirection = lastDirection === direction,
        now = $.now(),
        tooFast = now - lastNow < TOUCH_TIMEOUT;

      lastDirection = direction;
      lastNow = now;

      if (!xWin || !tail.ok || tail.prevent[direction] && !lockFLAG) {
        return;
      } else {
        stopEvent(e, true);
        if (lockFLAG && sameDirection && tooFast) {
          return;
        }
      }

      if (options.shift) {
        lockFLAG = true;
        clearTimeout(tail.t);
        tail.t = setTimeout(function () {
          lockFLAG = false;
        }, SCROLL_LOCK_TIMEOUT);
      }

      (options.onEnd || noop)(e, options.shift ? direction : xDelta);

    });

    return tail;
  }
  jQuery.Fotorama = function ($fotorama, opts) {
    $HTML = $('html');
    $BODY = $('body');

    var that = this,
      stamp = $.now(),
      stampClass = _fotoramaClass + stamp,
      fotorama = $fotorama[0],
      data,
      dataFrameCount = 1,
      fotoramaData = $fotorama.data(),
      size,

      $style = $('<style></style>'),

      $anchor = $(div(hiddenClass)),
      $wrap = $(div(wrapClass)),
      $stage = $(div(stageClass)).appendTo($wrap),
      stage = $stage[0],

      $stageShaft = $(div(stageShaftClass)).appendTo($stage),
      $stageFrame = $(),
      $arrPrev = $(div(arrClass + ' ' + arrPrevClass + buttonAttributes)),
      $arrNext = $(div(arrClass + ' ' + arrNextClass + buttonAttributes)),
      $arrs = $arrPrev.add($arrNext).appendTo($stage),
      $navWrap = $(div(navWrapClass)),
      $nav = $(div(navClass)).appendTo($navWrap),
      $navShaft = $(div(navShaftClass)).appendTo($nav),
      $navFrame,
      $navDotFrame = $(),
      $navThumbFrame = $(),

      stageShaftData = $stageShaft.data(),
      navShaftData = $navShaft.data(),

      $thumbBorder = $(div(thumbBorderClass)).appendTo($navShaft),

      $fullscreenIcon = $(div(fullscreenIconClass + buttonAttributes)),
      fullscreenIcon = $fullscreenIcon[0],
      $videoPlay = $(div(videoPlayClass)),
      $videoClose = $(div(videoCloseClass)).appendTo($stage),
      videoClose = $videoClose[0],

      spinner,
      $spinner = $(div(spinnerClass)),

      $videoPlaying,

      activeIndex = false,
      activeFrame,
      activeIndexes,
      repositionIndex,
      dirtyIndex,
      lastActiveIndex,
      prevIndex,
      nextIndex,
      nextAutoplayIndex,
      startIndex,

      o_loop,
      o_nav,
      o_navThumbs,
      o_navTop,
      o_allowFullScreen,
      o_nativeFullScreen,
      o_fade,
      o_thumbSide,
      o_thumbSide2,
      o_transitionDuration,
      o_transition,
      o_shadows,
      o_rtl,
      o_keyboard,
      lastOptions = {},

      measures = {},
      measuresSetFLAG,

      stageShaftTouchTail = {},
      stageWheelTail = {},
      navShaftTouchTail = {},
      navWheelTail = {},

      scrollTop,
      scrollLeft,

      showedFLAG,
      pausedAutoplayFLAG,
      stoppedAutoplayFLAG,

      toDeactivate = {},
      toDetach = {},

      measuresStash,

      touchedFLAG,

      hoverFLAG,

      navFrameKey,
      stageLeft = 0,

      fadeStack = [];

    $wrap[STAGE_FRAME_KEY] = $(div(stageFrameClass));
    $wrap[NAV_THUMB_FRAME_KEY] = $(div(navFrameClass + ' ' + navFrameThumbClass + buttonAttributes, div(thumbClass)));
    $wrap[NAV_DOT_FRAME_KEY] = $(div(navFrameClass + ' ' + navFrameDotClass + buttonAttributes, div(dotClass)));

    toDeactivate[STAGE_FRAME_KEY] = [];
    toDeactivate[NAV_THUMB_FRAME_KEY] = [];
    toDeactivate[NAV_DOT_FRAME_KEY] = [];
    toDetach[STAGE_FRAME_KEY] = {};

    $wrap
      .addClass(CSS3 ? wrapCss3Class : wrapCss2Class)
      .toggleClass(wrapNoControlsClass, !opts.controlsonstart);

    fotoramaData.fotorama = this;

    function checkForVideo () {
      $.each(data, function (i, dataFrame) {
        if (!dataFrame.i) {
          dataFrame.i = dataFrameCount++;
          var video = findVideoId(dataFrame.video, true);
          if (video) {
            var thumbs = {};
            dataFrame.video = video;
            if (!dataFrame.img && !dataFrame.thumb) {
              thumbs = getVideoThumbs(dataFrame, data, that);
            } else {
              dataFrame.thumbsReady = true;
            }
            updateData(data, {img: thumbs.img, thumb: thumbs.thumb}, dataFrame.i, that);
          }
        }
      });
    }

    function allowKey (key) {
      return o_keyboard[key] || that.fullScreen;
    }

    function bindGlobalEvents (FLAG) {
      var keydownCommon = 'keydown.' + _fotoramaClass,
        localStamp = _fotoramaClass + stamp,
        keydownLocal = 'keydown.' + localStamp,
        resizeLocal = 'resize.' + localStamp + ' ' + 'orientationchange.' + localStamp;

      if (FLAG) {
        $DOCUMENT
          .on(keydownLocal, function (e) {
            var catched,
              index;

            if ($videoPlaying && e.keyCode === 27) {
              catched = true;
              unloadVideo($videoPlaying, true, true);
            } else if (that.fullScreen || (opts.keyboard && !that.index)) {
              if (e.keyCode === 27) {
                catched = true;
                that.cancelFullScreen();
              } else if ((e.shiftKey && e.keyCode === 32 && allowKey('space')) || (e.keyCode === 37 && allowKey('left')) || (e.keyCode === 38 && allowKey('up'))) {
                index = '<';
              } else if ((e.keyCode === 32 && allowKey('space')) || (e.keyCode === 39 && allowKey('right')) || (e.keyCode === 40 && allowKey('down'))) {
                index = '>';
              } else if (e.keyCode === 36 && allowKey('home')) {
                index = '<<';
              } else if (e.keyCode === 35 && allowKey('end')) {
                index = '>>';
              }
            }

            (catched || index) && stopEvent(e);
            index && that.show({index: index, slow: e.altKey, user: true});
          });

        if (!that.index) {
          $DOCUMENT
            .off(keydownCommon)
            .on(keydownCommon, 'textarea, input, select', function (e) {
              !$BODY.hasClass(_fullscreenClass) && e.stopPropagation();
            });
        }

        $WINDOW.on(resizeLocal, that.resize);
      } else {
        $DOCUMENT.off(keydownLocal);
        $WINDOW.off(resizeLocal);
      }
    }

    function appendElements (FLAG) {
      if (FLAG === appendElements.f) return;

      if (FLAG) {
        $fotorama
          .html('')
          .addClass(_fotoramaClass + ' ' + stampClass)
          .append($wrap)
          .before($style)
          .before($anchor);

        addInstance(that);
      } else {
        $wrap.detach();
        $style.detach();
        $anchor.detach();
        $fotorama
          .html(fotoramaData.urtext)
          .removeClass(stampClass);

        hideInstance(that);
      }

      bindGlobalEvents(FLAG);
      appendElements.f = FLAG;
    }

    function setData () {
      data = that.data = data || clone(opts.data) || getDataFromHtml($fotorama);
      size = that.size = data.length;

      !ready.ok && opts.shuffle && shuffle(data);

      checkForVideo();

      activeIndex = limitIndex(activeIndex);

      size && appendElements(true);
    }

    function stageNoMove () {
      var _noMove = (size < 2 && !opts.enableifsingleframe) || $videoPlaying;
      stageShaftTouchTail.noMove = _noMove || o_fade;
      stageShaftTouchTail.noSwipe = _noMove || !opts.swipe;

      !o_transition && $stageShaft.toggleClass(grabClass, !opts.click && !stageShaftTouchTail.noMove && !stageShaftTouchTail.noSwipe);
      MS_POINTER && $wrap.toggleClass(wrapPanYClass, !stageShaftTouchTail.noSwipe);
    }

    function setAutoplayInterval (interval) {
      if (interval === true) interval = '';
      opts.autoplay = Math.max(+interval || AUTOPLAY_INTERVAL, o_transitionDuration * 1.5);
    }

    /**
     * Options on the fly
     * */
    function setOptions () {
      that.options = opts = optionsToLowerCase(opts);

      o_fade = (opts.transition === 'crossfade' || opts.transition === 'dissolve');

      o_loop = opts.loop && (size > 2 || (o_fade && (!o_transition || o_transition !== 'slide')));

      o_transitionDuration = +opts.transitionduration || TRANSITION_DURATION;

      o_rtl = opts.direction === 'rtl';

      o_keyboard = $.extend({}, opts.keyboard && KEYBOARD_OPTIONS, opts.keyboard);

      var classes = {add: [], remove: []};

      function addOrRemoveClass (FLAG, value) {
        classes[FLAG ? 'add' : 'remove'].push(value);
      }

      if (size > 1 || opts.enableifsingleframe) {
        o_nav = opts.nav;
        o_navTop = opts.navposition === 'top';
        classes.remove.push(selectClass);

        $arrs.toggle(!!opts.arrows);
      } else {
        o_nav = false;
        $arrs.hide();
      }

      spinnerStop();
      spinner = new Spinner($.extend(spinnerDefaults, opts.spinner, spinnerOverride, {direction: o_rtl ? -1 : 1}));

      arrsUpdate();
      stageWheelUpdate();

      if (opts.autoplay) setAutoplayInterval(opts.autoplay);

      o_thumbSide = numberFromMeasure(opts.thumbwidth) || THUMB_SIZE;
      o_thumbSide2 = numberFromMeasure(opts.thumbheight) || THUMB_SIZE;

      stageWheelTail.ok = navWheelTail.ok = opts.trackpad && !SLOW;

      stageNoMove();

      extendMeasures(opts, [measures]);

      o_navThumbs = o_nav === 'thumbs';

      if (o_navThumbs) {
        frameDraw(size, 'navThumb');

        $navFrame = $navThumbFrame;
        navFrameKey = NAV_THUMB_FRAME_KEY;

        setStyle($style, $.Fotorama.jst.style({w: o_thumbSide, h: o_thumbSide2, b: opts.thumbborderwidth, m: opts.thumbmargin, s: stamp, q: !COMPAT}));

        $nav
          .addClass(navThumbsClass)
          .removeClass(navDotsClass);
      } else if (o_nav === 'dots') {
        frameDraw(size, 'navDot');

        $navFrame = $navDotFrame;
        navFrameKey = NAV_DOT_FRAME_KEY;

        $nav
          .addClass(navDotsClass)
          .removeClass(navThumbsClass);
      } else {
        o_nav = false;
        $nav.removeClass(navThumbsClass + ' ' + navDotsClass);
      }

      if (o_nav) {
        if (o_navTop) {
          $navWrap.insertBefore($stage);
        } else {
          $navWrap.insertAfter($stage);
        }
        frameAppend.nav = false;
        frameAppend($navFrame, $navShaft, 'nav');
      }

      o_allowFullScreen = opts.allowfullscreen;

      if (o_allowFullScreen) {
        $fullscreenIcon.prependTo($stage);
        o_nativeFullScreen = FULLSCREEN && o_allowFullScreen === 'native';
      } else {
        $fullscreenIcon.detach();
        o_nativeFullScreen = false;
      }

      addOrRemoveClass(o_fade, wrapFadeClass);
      addOrRemoveClass(!o_fade, wrapSlideClass);
      addOrRemoveClass(!opts.captions, wrapNoCaptionsClass);
      addOrRemoveClass(o_rtl, wrapRtlClass);
      addOrRemoveClass(opts.arrows !== 'always', wrapToggleArrowsClass);

      o_shadows = opts.shadows && !SLOW;
      addOrRemoveClass(!o_shadows, wrapNoShadowsClass);

      $wrap
        .addClass(classes.add.join(' '))
        .removeClass(classes.remove.join(' '));

      lastOptions = $.extend({}, opts);
    }

    function normalizeIndex (index) {
      return index < 0 ? (size + (index % size)) % size : index >= size ? index % size : index;
    }

    function limitIndex (index) {
      return minMaxLimit(index, 0, size - 1);
    }

    function edgeIndex (index) {
      return o_loop ? normalizeIndex(index) : limitIndex(index);
    }

    function getPrevIndex (index) {
      return index > 0 || o_loop ? index - 1 : false;
    }

    function getNextIndex (index) {
      return index < size - 1 || o_loop ? index + 1 : false;
    }

    function setStageShaftMinmaxAndSnap () {
      stageShaftTouchTail.min = o_loop ? -Infinity : -getPosByIndex(size - 1, measures.w, opts.margin, repositionIndex);
      stageShaftTouchTail.max = o_loop ? Infinity : -getPosByIndex(0, measures.w, opts.margin, repositionIndex);
      stageShaftTouchTail.snap = measures.w + opts.margin;
    }

    function setNavShaftMinMax () {
      //////console.log('setNavShaftMinMax', measures.nw);
      navShaftTouchTail.min = Math.min(0, measures.nw - $navShaft.width());
      navShaftTouchTail.max = 0;
      $navShaft.toggleClass(grabClass, !(navShaftTouchTail.noMove = navShaftTouchTail.min === navShaftTouchTail.max));
    }

    function eachIndex (indexes, type, fn) {
      if (typeof indexes === 'number') {
        indexes = new Array(indexes);
        var rangeFLAG = true;
      }
      return $.each(indexes, function (i, index) {
        if (rangeFLAG) index = i;
        if (typeof index === 'number') {
          var dataFrame = data[normalizeIndex(index)];

          if (dataFrame) {
            var key = '$' + type + 'Frame',
              $frame = dataFrame[key];

            fn.call(this, i, index, dataFrame, $frame, key, $frame && $frame.data());
          }
        }
      });
    }

    function setMeasures (width, height, ratio, index) {
      if (!measuresSetFLAG || (measuresSetFLAG === '*' && index === startIndex)) {

        ////console.log('setMeasures', index, opts.width, opts.height);

        width = measureIsValid(opts.width) || measureIsValid(width) || WIDTH;
        height = measureIsValid(opts.height) || measureIsValid(height) || HEIGHT;
        that.resize({
          width: width,
          ratio: opts.ratio || ratio || width / height
        }, 0, index !== startIndex && '*');
      }
    }

    function loadImg (indexes, type, specialMeasures, method, position, again) {
      eachIndex(indexes, type, function (i, index, dataFrame, $frame, key, frameData) {

        if (!$frame) return;

        var fullFLAG = that.fullScreen && dataFrame.full && dataFrame.full !== dataFrame.img && !frameData.$full && type === 'stage';

        if (frameData.$img && !again && !fullFLAG) return;

        var img = new Image(),
          $img = $(img),
          imgData = $img.data();

        frameData[fullFLAG ? '$full' : '$img'] = $img;

        var srcKey = type === 'stage' ? (fullFLAG ? 'full' : 'img') : 'thumb',
          src = dataFrame[srcKey],
          dummy = fullFLAG ? null : dataFrame[type === 'stage' ? 'thumb' : 'img'];

        if (type === 'navThumb') $frame = frameData.$wrap;

        function triggerTriggerEvent (event) {
          var _index = normalizeIndex(index);
          triggerEvent(event, {
            index: _index,
            src: src,
            frame: data[_index]
          });
        }

        function error () {
          $img.remove();

          $.Fotorama.cache[src] = 'error';

          if ((!dataFrame.html || type !== 'stage') && dummy && dummy !== src) {
            dataFrame[srcKey] = src = dummy;
            loadImg([index], type, specialMeasures, method, position, true);
          } else {
            if (src && !dataFrame.html && !fullFLAG) {
              $frame
                .trigger('f:error')
                .removeClass(loadingClass)
                .addClass(errorClass);

              triggerTriggerEvent('error');
            } else if (type === 'stage') {
              $frame
                .trigger('f:load')
                .removeClass(loadingClass + ' ' + errorClass)
                .addClass(loadedClass);

              triggerTriggerEvent('load');
              setMeasures();
            }

            frameData.state = 'error';

            if (size > 1 && data[index] === dataFrame && !dataFrame.html && !dataFrame.deleted && !dataFrame.video && !fullFLAG) {
              dataFrame.deleted = true;
              that.splice(index, 1);
            }
          }
        }

        function loaded () {
          ////console.log('loaded: ' + src);

          //console.log('$.Fotorama.measures[src]', $.Fotorama.measures[src]);

          $.Fotorama.measures[src] = imgData.measures = $.Fotorama.measures[src] || {
            width: img.width,
            height: img.height,
            ratio: img.width / img.height
          };

          setMeasures(imgData.measures.width, imgData.measures.height, imgData.measures.ratio, index);

          $img
            .off('load error')
            .addClass(imgClass + (fullFLAG ? ' ' + imgFullClass : ''))
            .prependTo($frame);

          fit($img, ($.isFunction(specialMeasures) ? specialMeasures() : specialMeasures) || measures, method || dataFrame.fit || opts.fit, position || dataFrame.position || opts.position);

          $.Fotorama.cache[src] = frameData.state = 'loaded';

          setTimeout(function () {
            $frame
              .trigger('f:load')
              .removeClass(loadingClass + ' ' + errorClass)
              .addClass(loadedClass + ' ' + (fullFLAG ? loadedFullClass : loadedImgClass));

            if (type === 'stage') {
              triggerTriggerEvent('load');
            } else if (dataFrame.thumbratio === AUTO || !dataFrame.thumbratio && opts.thumbratio === AUTO) {
              // danger! reflow for all thumbnails
              dataFrame.thumbratio = imgData.measures.ratio;
              reset();
            }
          }, 0);
        }

        if (!src) {
          error();
          return;
        }

        function waitAndLoad () {
          var _i = 10;
          waitFor(function () {
            return !touchedFLAG || !_i-- && !SLOW;
          }, function () {
            loaded();
          });
        }

        if (!$.Fotorama.cache[src]) {
          $.Fotorama.cache[src] = '*';

          $img
            .on('load', waitAndLoad)
            .on('error', error);
        } else {
          (function justWait () {
            if ($.Fotorama.cache[src] === 'error') {
              error();
            } else if ($.Fotorama.cache[src] === 'loaded') {
              //console.log('take from cache: ' + src);
              setTimeout(waitAndLoad, 0);
            } else {
              setTimeout(justWait, 100);
            }
          })();
        }

        frameData.state = '';
        img.src = src;
      });
    }

    function spinnerSpin ($el) {
      $spinner.append(spinner.spin().el).appendTo($el);
    }

    function spinnerStop () {
      $spinner.detach();
      spinner && spinner.stop();
    }

    function updateFotoramaState () {
      var $frame = activeFrame[STAGE_FRAME_KEY];

      if ($frame && !$frame.data().state) {
        spinnerSpin($frame);
        $frame.on('f:load f:error', function () {
          $frame.off('f:load f:error');
          spinnerStop();
        });
      }
    }

    function addNavFrameEvents (frame) {
      addEnterUp(frame, onNavFrameClick);
      addFocus(frame, function () {

        setTimeout(function () {
          lockScroll($nav);
        }, 0);
        slideNavShaft({time: o_transitionDuration, guessIndex: $(this).data().eq, minMax: navShaftTouchTail});
      });
    }

    function frameDraw (indexes, type) {
      eachIndex(indexes, type, function (i, index, dataFrame, $frame, key, frameData) {
        if ($frame) return;

        $frame = dataFrame[key] = $wrap[key].clone();
        frameData = $frame.data();
        frameData.data = dataFrame;
        var frame = $frame[0];

        if (type === 'stage') {

          if (dataFrame.html) {
            $('<div class="' + htmlClass + '"></div>')
              .append(
                dataFrame._html ? $(dataFrame.html)
                    .removeAttr('id')
                    .html(dataFrame._html) // Because of IE
                  : dataFrame.html
              )
              .appendTo($frame);
          }

          dataFrame.caption && $(div(captionClass, div(captionWrapClass, dataFrame.caption))).appendTo($frame);

          try {
            var videoId = dataFrame.video.id
            if (videoId != dataFrame.img && !videoId.match(/[^/]+(jpg|png|gif)$/)) {
              dataFrame.video && $frame
                .addClass(stageFrameVideoClass)
                .append($videoPlay.clone());
            }
          } catch (e) {
          }
          // This solves tabbing problems
          addFocus(frame, function () {
            setTimeout(function () {
              lockScroll($stage);
            }, 0);
            clickToShow({index: frameData.eq, user: true});
          });

          $stageFrame = $stageFrame.add($frame);
        } else if (type === 'navDot') {
          addNavFrameEvents(frame);
          $navDotFrame = $navDotFrame.add($frame);
        } else if (type === 'navThumb') {
          addNavFrameEvents(frame);
          frameData.$wrap = $frame.children(':first');
          $navThumbFrame = $navThumbFrame.add($frame);
          try {
            var videoId = dataFrame.video.id
            if (dataFrame.video.id != dataFrame.img && !videoId.match(/[^/]+(jpg|png|gif)$/)) {
              frameData.$wrap.append($videoPlay.clone());
            }
          } catch (e) {
          }
        }
      });
    }

    function callFit ($img, measuresToFit, method, position) {
      return $img && $img.length && fit($img, measuresToFit, method, position);
    }

    function stageFramePosition (indexes) {
      eachIndex(indexes, 'stage', function (i, index, dataFrame, $frame, key, frameData) {
        if (!$frame) return;

        var normalizedIndex = normalizeIndex(index),
          method = dataFrame.fit || opts.fit,
          position = dataFrame.position || opts.position;
        frameData.eq = normalizedIndex;

        toDetach[STAGE_FRAME_KEY][normalizedIndex] = $frame.css($.extend({left: o_fade ? 0 : getPosByIndex(index, measures.w, opts.margin, repositionIndex)}, o_fade && getDuration(0)));

        if (isDetached($frame[0])) {
          $frame.appendTo($stageShaft);
          unloadVideo(dataFrame.$video);
        }

        callFit(frameData.$img, measures, method, position);
        callFit(frameData.$full, measures, method, position);
      });
    }

    function thumbsDraw (pos, loadFLAG) {
      if (o_nav !== 'thumbs' || isNaN(pos)) return;

      var leftLimit = -pos,
        rightLimit = -pos + measures.nw;

      $navThumbFrame.each(function () {
        var $this = $(this),
          thisData = $this.data(),
          eq = thisData.eq,
          getSpecialMeasures = function () {
            return {
              h: o_thumbSide2,
              w: thisData.w
            }
          },
          specialMeasures = getSpecialMeasures(),
          dataFrame = data[eq] || {},
          method = dataFrame.thumbfit || opts.thumbfit,
          position = dataFrame.thumbposition || opts.thumbposition;

        specialMeasures.w = thisData.w;

        if (thisData.l + thisData.w < leftLimit
          || thisData.l > rightLimit
          || callFit(thisData.$img, specialMeasures, method, position)) return;

        loadFLAG && loadImg([eq], 'navThumb', getSpecialMeasures, method, position);
      });
    }

    function frameAppend ($frames, $shaft, type) {
      if (!frameAppend[type]) {

        var thumbsFLAG = type === 'nav' && o_navThumbs,
          left = 0;

        $shaft.append(
          $frames
            .filter(function () {
              var actual,
                $this = $(this),
                frameData = $this.data();
              for (var _i = 0, _l = data.length; _i < _l; _i++) {
                if (frameData.data === data[_i]) {
                  actual = true;
                  frameData.eq = _i;
                  break;
                }
              }
              return actual || $this.remove() && false;
            })
            .sort(function (a, b) {
              return $(a).data().eq - $(b).data().eq;
            })
            .each(function () {

              if (!thumbsFLAG) return;

              var $this = $(this),
                frameData = $this.data(),
                thumbwidth = Math.round(o_thumbSide2 * frameData.data.thumbratio) || o_thumbSide;

              frameData.l = left;
              frameData.w = thumbwidth;

              $this.css({width: thumbwidth});

              left += thumbwidth + opts.thumbmargin;
            })
        );

        frameAppend[type] = true;
      }
    }

    function getDirection (x) {
      return x - stageLeft > measures.w / 3;
    }

    function disableDirrection (i) {
      return !o_loop && (!(activeIndex + i) || !(activeIndex - size + i)) && !$videoPlaying;
    }

    function arrsUpdate () {
      var disablePrev = disableDirrection(0),
        disableNext = disableDirrection(1);
      $arrPrev
        .toggleClass(arrDisabledClass, disablePrev)
        .attr(disableAttr(disablePrev));
      $arrNext
        .toggleClass(arrDisabledClass, disableNext)
        .attr(disableAttr(disableNext));
    }

    function stageWheelUpdate () {
      if (stageWheelTail.ok) {
        stageWheelTail.prevent = {'<': disableDirrection(0), '>': disableDirrection(1)};
      }
    }

    function getNavFrameBounds ($navFrame) {
      var navFrameData = $navFrame.data(),
        left,
        width;

      if (o_navThumbs) {
        left = navFrameData.l;
        width = navFrameData.w;
      } else {
        left = $navFrame.position().left;
        width = $navFrame.width();
      }

      return {
        c: left + width / 2,
        min: -left + opts.thumbmargin * 10,
        max: -left + measures.w - width - opts.thumbmargin * 10
      };
    }

    function slideThumbBorder (time) {
      var navFrameData = activeFrame[navFrameKey].data();
      slide($thumbBorder, {
        time: time * 1.2,
        pos: navFrameData.l,
        width: navFrameData.w - opts.thumbborderwidth * 2
      });
    }

    function slideNavShaft (options) {
      //console.log('slideNavShaft', options.guessIndex, options.keep, slideNavShaft.l);
      var $guessNavFrame = data[options.guessIndex][navFrameKey];
      if ($guessNavFrame) {
        var overflowFLAG = navShaftTouchTail.min !== navShaftTouchTail.max,
          minMax = options.minMax || overflowFLAG && getNavFrameBounds(activeFrame[navFrameKey]),
          l = overflowFLAG && (options.keep && slideNavShaft.l ? slideNavShaft.l : minMaxLimit((options.coo || measures.nw / 2) - getNavFrameBounds($guessNavFrame).c, minMax.min, minMax.max)),
          pos = overflowFLAG && minMaxLimit(l, navShaftTouchTail.min, navShaftTouchTail.max),
          time = options.time * 1.1;

        slide($navShaft, {
          time: time,
          pos: pos || 0,
          onEnd: function () {
            thumbsDraw(pos, true);
          }
        });

        //if (time) thumbsDraw(pos);

        setShadow($nav, findShadowEdge(pos, navShaftTouchTail.min, navShaftTouchTail.max));
        slideNavShaft.l = l;
      }
    }

    function navUpdate () {
      deactivateFrames(navFrameKey);
      toDeactivate[navFrameKey].push(activeFrame[navFrameKey].addClass(activeClass));
    }

    function deactivateFrames (key) {
      var _toDeactivate = toDeactivate[key];

      while (_toDeactivate.length) {
        _toDeactivate.shift().removeClass(activeClass);
      }
    }

    function detachFrames (key) {
      var _toDetach = toDetach[key];

      ////console.log('_toDetach', _toDetach);
      ////console.log('activeIndexes', activeIndexes);

      $.each(activeIndexes, function (i, index) {
        delete _toDetach[normalizeIndex(index)];
      });

      $.each(_toDetach, function (index, $frame) {
        delete _toDetach[index];
        ////console.log('Detach', index);
        $frame.detach();
      });
    }

    function stageShaftReposition (skipOnEnd) {

      repositionIndex = dirtyIndex = activeIndex;

      var $frame = activeFrame[STAGE_FRAME_KEY];

      if ($frame) {
        deactivateFrames(STAGE_FRAME_KEY);
        toDeactivate[STAGE_FRAME_KEY].push($frame.addClass(activeClass));

        skipOnEnd || that.show.onEnd(true);
        stop($stageShaft, 0, true);

        detachFrames(STAGE_FRAME_KEY);
        stageFramePosition(activeIndexes);
        setStageShaftMinmaxAndSnap();
        setNavShaftMinMax();
      }
    }

    function extendMeasures (options, measuresArray) {
      if (!options) return;

      $.each(measuresArray, function (i, measures) {
        if (!measures) return;

        $.extend(measures, {
          width: options.width || measures.width,
          height: options.height,
          minwidth: options.minwidth,
          maxwidth: options.maxwidth,
          minheight: options.minheight,
          maxheight: options.maxheight,
          ratio: getRatio(options.ratio)
        })
      });
    }

    function triggerEvent (event, extra) {
      $fotorama.trigger(_fotoramaClass + ':' + event, [that, extra]);
    }

    function onTouchStart () {
      clearTimeout(onTouchEnd.t);
      touchedFLAG = 1;

      if (opts.stopautoplayontouch) {
        that.stopAutoplay();
      } else {
        pausedAutoplayFLAG = true;
      }
    }

    function onTouchEnd () {
      if (!touchedFLAG) return;
      if (!opts.stopautoplayontouch) {
        releaseAutoplay();
        changeAutoplay();
      }

      onTouchEnd.t = setTimeout(function () {
        touchedFLAG = 0;
      }, TRANSITION_DURATION + TOUCH_TIMEOUT);
      ////console.timeEnd('onTouchEnd');
    }

    function releaseAutoplay () {
      //console.log('releaseAutoplay');
      pausedAutoplayFLAG = !!($videoPlaying || stoppedAutoplayFLAG);
    }

    function changeAutoplay () {
      //console.log('changeAutoplay');

      clearTimeout(changeAutoplay.t);
      waitFor.stop(changeAutoplay.w);

      if (!opts.autoplay || pausedAutoplayFLAG) {
        if (that.autoplay) {
          that.autoplay = false;
          triggerEvent('stopautoplay');
        }

        return;
      }

      //console.log('changeAutoplay continue');

      if (!that.autoplay) {
        that.autoplay = true;
        triggerEvent('startautoplay');
      }

      var _activeIndex = activeIndex;


      var frameData = activeFrame[STAGE_FRAME_KEY].data();
      changeAutoplay.w = waitFor(function () {
        //console.log('wait for the state of the current frame');
        return frameData.state || _activeIndex !== activeIndex;
      }, function () {
        //console.log('the current frame is ready');
        changeAutoplay.t = setTimeout(function () {
          //console.log('changeAutoplay.t setTimeout', pausedAutoplayFLAG, _activeIndex !== activeIndex);
          if (pausedAutoplayFLAG || _activeIndex !== activeIndex) return;

          var _nextAutoplayIndex = nextAutoplayIndex,
            nextFrameData = data[_nextAutoplayIndex][STAGE_FRAME_KEY].data();

          changeAutoplay.w = waitFor(function () {
            //console.log('wait for the state of the next frame');
            return nextFrameData.state || _nextAutoplayIndex !== nextAutoplayIndex;
          }, function () {
            if (pausedAutoplayFLAG || _nextAutoplayIndex !== nextAutoplayIndex) return;
            that.show(o_loop ? getDirectionSign(!o_rtl) : nextAutoplayIndex);
          });
        }, opts.autoplay);
      });

    }

    that.startAutoplay = function (interval) {
      if (that.autoplay) return this;
      pausedAutoplayFLAG = stoppedAutoplayFLAG = false;
      setAutoplayInterval(interval || opts.autoplay);
      changeAutoplay();

      return this;
    };

    that.stopAutoplay = function () {
      if (that.autoplay) {
        pausedAutoplayFLAG = stoppedAutoplayFLAG = true;
        changeAutoplay();
      }
      return this;
    };

    that.show = function (options) {
      //console.log('that.show');
      ////console.time('that.show prepare');
      var index;

      if (typeof options !== 'object') {
        index = options;
        options = {};
      } else {
        index = options.index;
      }

      index = index === '>' ? dirtyIndex + 1 : index === '<' ? dirtyIndex - 1 : index === '<<' ? 0 : index === '>>' ? size - 1 : index;
      index = isNaN(index) ? getIndexFromHash(index, data, true) : index;
      index = typeof index === 'undefined' ? activeIndex || 0 : index;

      that.activeIndex = activeIndex = edgeIndex(index);
      prevIndex = getPrevIndex(activeIndex);
      nextIndex = getNextIndex(activeIndex);
      nextAutoplayIndex = normalizeIndex(activeIndex + (o_rtl ? -1 : 1));
      activeIndexes = [activeIndex, prevIndex, nextIndex];

      dirtyIndex = o_loop ? index : activeIndex;

      var diffIndex = Math.abs(lastActiveIndex - dirtyIndex),
        time = getNumber(options.time, function () {
          return Math.min(o_transitionDuration * (1 + (diffIndex - 1) / 12), o_transitionDuration * 2);
        }),
        overPos = options.overPos;

      if (options.slow) time *= 10;

      var _activeFrame = activeFrame;
      that.activeFrame = activeFrame = data[activeIndex];
      ////console.timeEnd('that.show prepare');

      var silent = _activeFrame === activeFrame && !options.user;

      //setTimeout(function () {
      ////console.time('unloadVideo');
      unloadVideo($videoPlaying, activeFrame.i !== data[normalizeIndex(repositionIndex)].i);
      ////console.timeEnd('unloadVideo');
      ////console.time('frameDraw');
      frameDraw(activeIndexes, 'stage');
      ////console.timeEnd('frameDraw');
      ////console.time('stageFramePosition');
      stageFramePosition(SLOW ? [dirtyIndex] : [dirtyIndex, getPrevIndex(dirtyIndex), getNextIndex(dirtyIndex)]);
      ////console.timeEnd('stageFramePosition');
      ////console.time('updateTouchTails');
      updateTouchTails('go', true);
      ////console.timeEnd('updateTouchTails');
      ////console.time('triggerEvent');

      silent || triggerEvent('show', {
        user: options.user,
        time: time
      });
      ////console.timeEnd('triggerEvent');
      //}, 0);

      ////console.time('bind onEnd');

      pausedAutoplayFLAG = true;

      var onEnd = that.show.onEnd = function (skipReposition) {
        if (onEnd.ok) return;
        onEnd.ok = true;

        skipReposition || stageShaftReposition(true);

        if (!silent) {
          triggerEvent('showend', {
            user: options.user
          });
        }

        //console.log('o_transition', o_transition);

        if (!skipReposition && o_transition && o_transition !== opts.transition) {
          //console.log('set transition back to: ' + o_transition);
          that.setOptions({transition: o_transition});
          o_transition = false;
          return;
        }

        updateFotoramaState();
        loadImg(activeIndexes, 'stage');

        updateTouchTails('go', false);
        stageWheelUpdate();

        stageCursor();
        releaseAutoplay();
        changeAutoplay();
      };
      ////console.timeEnd('bind onEnd');

      if (!o_fade) {
        ////console.time('slide');
        slide($stageShaft, {
          pos: -getPosByIndex(dirtyIndex, measures.w, opts.margin, repositionIndex),
          overPos: overPos,
          time: time,
          onEnd: onEnd/*,
        _001: true*/
        });
        ////console.timeEnd('slide');
      } else {
        var $activeFrame = activeFrame[STAGE_FRAME_KEY],
          $prevActiveFrame = activeIndex !== lastActiveIndex ? data[lastActiveIndex][STAGE_FRAME_KEY] : null;

        fade($activeFrame, $prevActiveFrame, $stageFrame, {
          time: time,
          method: opts.transition,
          onEnd: onEnd
        }, fadeStack);
      }

      ////console.time('arrsUpdate');
      arrsUpdate();
      ////console.timeEnd('arrsUpdate');

      if (o_nav) {
        ////console.time('navUpdate');
        navUpdate();
        ////console.timeEnd('navUpdate');

        ////console.time('slideNavShaft');
        var guessIndex = limitIndex(activeIndex + minMaxLimit(dirtyIndex - lastActiveIndex, -1, 1));
        slideNavShaft({time: time, coo: guessIndex !== activeIndex && options.coo, guessIndex: typeof options.coo !== 'undefined' ? guessIndex : activeIndex, keep: silent});
        ////console.timeEnd('slideNavShaft');

        ////console.time('slideThumbBorder');
        if (o_navThumbs) slideThumbBorder(time);
        ////console.timeEnd('slideThumbBorder');
      }

      ////console.time('that.show end');
      showedFLAG = typeof lastActiveIndex !== 'undefined' && lastActiveIndex !== activeIndex;
      lastActiveIndex = activeIndex;
      opts.hash && showedFLAG && !that.eq && setHash(activeFrame.id || activeIndex + 1);
      ////console.timeEnd('that.show end');

      ////console.timeEnd('that.show');

      return this;
    };

    that.requestFullScreen = function () {
      if (o_allowFullScreen && !that.fullScreen) {
        scrollTop = $WINDOW.scrollTop();
        scrollLeft = $WINDOW.scrollLeft();

        lockScroll($WINDOW);

        updateTouchTails('x', true);

        measuresStash = $.extend({}, measures);

        $fotorama
          .addClass(fullscreenClass)
          .appendTo($BODY.addClass(_fullscreenClass));

        $HTML.addClass(_fullscreenClass);

        unloadVideo($videoPlaying, true, true);

        that.fullScreen = true;

        if (o_nativeFullScreen) {
          fullScreenApi.request(fotorama);
        }

        that.resize();
        loadImg(activeIndexes, 'stage');
        updateFotoramaState();

        triggerEvent('fullscreenenter');
      }

      return this;
    };

    function cancelFullScreen () {
      if (that.fullScreen) {
        that.fullScreen = false;

        if (FULLSCREEN) {
          fullScreenApi.cancel(fotorama);
        }

        $BODY.removeClass(_fullscreenClass);
        $HTML.removeClass(_fullscreenClass);

        $fotorama
          .removeClass(fullscreenClass)
          .insertAfter($anchor);

        measures = $.extend({}, measuresStash);

        unloadVideo($videoPlaying, true, true);

        updateTouchTails('x', false);

        that.resize();
        loadImg(activeIndexes, 'stage');

        lockScroll($WINDOW, scrollLeft, scrollTop);

        triggerEvent('fullscreenexit');
      }
    }

    that.cancelFullScreen = function () {
      if (o_nativeFullScreen && fullScreenApi.is()) {
        fullScreenApi.cancel(document);
      } else {
        cancelFullScreen();
      }

      return this;
    };

    that.toggleFullScreen = function () {
      return that[(that.fullScreen ? 'cancel' : 'request') + 'FullScreen']();
    };

    addEvent(document, fullScreenApi.event, function () {
      if (data && !fullScreenApi.is() && !$videoPlaying) {
        cancelFullScreen();
      }
    });

    that.resize = function (options) {
      if (!data) return this;

      var time = arguments[1] || 0,
        setFLAG = arguments[2];

      extendMeasures(!that.fullScreen ? optionsToLowerCase(options) : {width: '100%', maxwidth: null, minwidth: null, height: '100%', maxheight: null, minheight: null}, [measures, setFLAG || that.fullScreen || opts]);

      var width = measures.width,
        height = measures.height,
        ratio = measures.ratio,
        windowHeight = $WINDOW.height() - (o_nav ? $nav.height() : 0);

      if (measureIsValid(width)) {
        $wrap
          .addClass(wrapOnlyActiveClass)
          .css({width: width, minWidth: measures.minwidth || 0, maxWidth: measures.maxwidth || MAX_WIDTH});

        width = measures.W = measures.w = $wrap.width();
        measures.nw = o_nav && numberFromWhatever(opts.navwidth, width) || width;

        if (opts.glimpse) {
          // Glimpse
          measures.w -= Math.round((numberFromWhatever(opts.glimpse, width) || 0) * 2);
        }

        $stageShaft.css({width: measures.w, marginLeft: (measures.W - measures.w) / 2});

        ////console.log('measures.W', measures.W);
        ////console.log('measures.w', measures.w);

        height = numberFromWhatever(height, windowHeight);

        height = height || (ratio && width / ratio);

        if (height) {
          width = Math.round(width);
          height = measures.h = Math.round(minMaxLimit(height, numberFromWhatever(measures.minheight, windowHeight), numberFromWhatever(measures.maxheight, windowHeight)));

          $stage
            .stop()
            .animate({width: width, height: height}, time, function () {
              $wrap.removeClass(wrapOnlyActiveClass);
            });

          stageShaftReposition();

          if (o_nav) {
            $nav
              .stop()
              .animate({width: measures.nw}, time);

            slideNavShaft({guessIndex: activeIndex, time: time, keep: true});
            if (o_navThumbs && frameAppend.nav) slideThumbBorder(time);
          }

          measuresSetFLAG = setFLAG || true;

          ready();
        }
      }

      stageLeft = $stage.offset().left;

      return this;
    };

    that.setOptions = function (options) {
      $.extend(opts, options);
      reset();
      return this;
    };

    that.shuffle = function () {
      data && shuffle(data) && reset();
      return this;
    };

    function setShadow ($el, edge) {
      ////console.time('setShadow');
      if (o_shadows) {
        $el.removeClass(shadowsLeftClass + ' ' + shadowsRightClass);
        edge && !$videoPlaying && $el.addClass(edge.replace(/^|\s/g, ' ' + shadowsClass + '--'));
      }
      ////console.timeEnd('setShadow');
    }

    that.destroy = function () {
      that.cancelFullScreen();
      that.stopAutoplay();

      data = that.data = null;

      appendElements();

      activeIndexes = [];
      detachFrames(STAGE_FRAME_KEY);

      reset.ok = false;

      return this;
    };

    that.onYTPlayerStateChange = function (event) {
      if (event.data == YT.PlayerState.ENDED) {
        that.stopVideo()
      };
    }

    that.playVideo = function () {
      var dataFrame = activeFrame,
        video = dataFrame.video,
        _activeIndex = activeIndex;

      if (typeof video === 'object' && dataFrame.videoReady) {
        o_nativeFullScreen && that.fullScreen && that.cancelFullScreen();

        waitFor(function () {
          return !fullScreenApi.is() || _activeIndex !== activeIndex;
        }, function () {
          if (_activeIndex === activeIndex) {
            dataFrame.$video = dataFrame.$video || $($.Fotorama.jst.video(video));
            dataFrame.$video.appendTo(dataFrame[STAGE_FRAME_KEY]);
            $wrap.addClass(wrapVideoClass);
            $videoPlaying = dataFrame.$video;

            if (video.type == 'youtube') {
              var player = new YT.Player('fotorama-video-yt-' + video.id, {
                videoId: video.id,
                playerVars: {
                  autoplay: true,
                  rel: false,
                  enablejsapi: true,
                  iv_load_policy: 3,
                  origin: window.location.origin
                },
                events: {
                  'onStateChange': that.onYTPlayerStateChange
                }
              });
            } else if (video.type == 'm3u8') {
              new MediaElementPlayer('vp-m3u8',{
                features: ['playpause', 'current', 'progress', 'tracks', 'volume', 'fullscreen'],
                success: function (mediaElement, domObject) {
                  mediaElement.play();
                }
              });
            }
            stageNoMove();

            $arrs.blur();
            $fullscreenIcon.blur();

            triggerEvent('loadvideo');
          }
        });
      }

      return this;
    };

    that.stopVideo = function () {
      unloadVideo($videoPlaying, true, true);
      return this;
    };

    function unloadVideo ($video, unloadActiveFLAG, releaseAutoplayFLAG) {
      if (unloadActiveFLAG) {
        $wrap.removeClass(wrapVideoClass);
        $videoPlaying = false;

        stageNoMove();
      }
      if ($video && $video !== $videoPlaying) {
        $video.remove();
        triggerEvent('unloadvideo');
      }

      if (releaseAutoplayFLAG) {
        releaseAutoplay();
        changeAutoplay();
      }
    }

    function toggleControlsClass (FLAG) {
      $wrap.toggleClass(wrapNoControlsClass, FLAG);
    }

    function stageCursor (e) {
      if (stageShaftTouchTail.flow) return;

      var x = e ? e.pageX : stageCursor.x,
        pointerFLAG = x && !disableDirrection(getDirection(x)) && opts.click;

      if (stageCursor.p !== pointerFLAG
        && $stage.toggleClass(pointerClass, pointerFLAG)) {
        stageCursor.p = pointerFLAG;
        stageCursor.x = x;
      }
    }

    $stage.on('mousemove', stageCursor);

    function clickToShow (showOptions) {
      clearTimeout(clickToShow.t);

      if (opts.clicktransition && opts.clicktransition !== opts.transition) {
        //console.log('change transition to: ' + opts.clicktransition);

        // this timeout is for yield events flow
        setTimeout(function () {
          // save original transition for later
          var _o_transition = opts.transition;

          that.setOptions({transition: opts.clicktransition});

          // now safe to pass base transition to o_transition, so that.show will restor it
          o_transition = _o_transition;
          // this timeout is here to prevent jerking in some browsers
          clickToShow.t = setTimeout(function () {
            that.show(showOptions);
          }, 10);
        }, 0);
      } else {
        that.show(showOptions);
      }
    }

    function onStageTap (e, toggleControlsFLAG) {
      ////console.time('onStageTap');
      var target = e.target,
        $target = $(target);

      if ($target.hasClass(videoPlayClass)) {
        that.playVideo();
      } else if (target === fullscreenIcon) {
        that.toggleFullScreen();
      } else if ($videoPlaying) {
        target === videoClose && unloadVideo($videoPlaying, true, true);
      } else {
        if (toggleControlsFLAG) {
          toggleControlsClass();
        } else if (opts.click) {

          clickToShow({index: e.shiftKey || getDirectionSign(getDirection(e._x)), slow: e.altKey, user: true});
        }
      }
      ////console.timeEnd('onStageTap');
    }

    function updateTouchTails (key, value) {
      stageShaftTouchTail[key] = navShaftTouchTail[key] = value;
    }

    stageShaftTouchTail = moveOnTouch($stageShaft, {
      onStart: onTouchStart,
      onMove: function (e, result) {
        setShadow($stage, result.edge);
      },
      onTouchEnd: onTouchEnd,
      onEnd: function (result) {
        ////console.time('stageShaftTouchTail.onEnd');
        setShadow($stage);

        ////console.log('result', result);

        var toggleControlsFLAG = (MS_POINTER && !hoverFLAG || result.touch) && opts.arrows && opts.arrows !== 'always';

        if (result.moved || (toggleControlsFLAG && result.pos !== result.newPos && !result.control)) {
          var index = getIndexByPos(result.newPos, measures.w, opts.margin, repositionIndex);
          that.show({
            index: index,
            time: o_fade ? o_transitionDuration : result.time,
            overPos: result.overPos,
            user: true
          });
        } else if (!result.aborted && !result.control) {
          onStageTap(result.startEvent, toggleControlsFLAG);
        }
        ////console.timeEnd('stageShaftTouchTail.onEnd');
      },
//    getPos: function () {
//      return -getPosByIndex(dirtyIndex, measures.w, opts.margin, repositionIndex);
//    },
      //_001: true,
      timeLow: 1,
      timeHigh: 1,
      friction: 2,
      select: '.' + selectClass + ', .' + selectClass + ' *',
      $wrap: $stage
    });

    navShaftTouchTail = moveOnTouch($navShaft, {
      onStart: onTouchStart,
      onMove: function (e, result) {
        setShadow($nav, result.edge);
      },
      onTouchEnd: onTouchEnd,
      onEnd: function (result) {

        function onEnd () {
          slideNavShaft.l = result.newPos;
          releaseAutoplay();
          changeAutoplay();
          thumbsDraw(result.newPos, true);
        }

        if (!result.moved) {
          var target = result.$target.closest('.' + navFrameClass, $navShaft)[0];
          target && onNavFrameClick.call(target, result.startEvent);
        } else if (result.pos !== result.newPos) {
          pausedAutoplayFLAG = true;
          slide($navShaft, {
            time: result.time,
            pos: result.newPos,
            overPos: result.overPos,
            onEnd: onEnd
          });
          thumbsDraw(result.newPos);
          o_shadows && setShadow($nav, findShadowEdge(result.newPos, navShaftTouchTail.min, navShaftTouchTail.max));
        } else {
          onEnd();
        }
      },
      timeLow: .5,
      timeHigh: 2,
      friction: 5,
      $wrap: $nav
    });

    stageWheelTail = wheel($stage, {
      shift: true,
      onEnd: function (e, direction) {
        ////console.log('wheel $stage onEnd', direction);
        onTouchStart();
        onTouchEnd();
        that.show({index: direction, slow: e.altKey})
      }
    });

    navWheelTail = wheel($nav, {
      onEnd: function (e, direction) {
        ////console.log('wheel $nav onEnd', direction);
        onTouchStart();
        onTouchEnd();
        var newPos = stop($navShaft) + direction * .25;
        $navShaft.css(getTranslate(minMaxLimit(newPos, navShaftTouchTail.min, navShaftTouchTail.max)));
        o_shadows && setShadow($nav, findShadowEdge(newPos, navShaftTouchTail.min, navShaftTouchTail.max));
        navWheelTail.prevent = {'<': newPos >= navShaftTouchTail.max, '>': newPos <= navShaftTouchTail.min};
        clearTimeout(navWheelTail.t);
        navWheelTail.t = setTimeout(function () {
          slideNavShaft.l = newPos;
          thumbsDraw(newPos, true)
        }, TOUCH_TIMEOUT);
        thumbsDraw(newPos);
      }
    });

    $wrap.hover(
      function () {
        setTimeout(function () {
          if (touchedFLAG) return;
          toggleControlsClass(!(hoverFLAG = true));
        }, 0);
      }, function () {
        if (!hoverFLAG) return;
        toggleControlsClass(!(hoverFLAG = false));
      }
    );

    function onNavFrameClick (e) {
      var index = $(this).data().eq;
      clickToShow({index: index, slow: e.altKey, user: true, coo: e._x - $nav.offset().left});
    }

    function onArrClick (e) {
      clickToShow({index: $arrs.index(this) ? '>' : '<', slow: e.altKey, user: true});
    }

    smartClick($arrs, function (e) {
      stopEvent(e);
      onArrClick.call(this, e);
    }, {
      onStart: function () {
        onTouchStart();
        stageShaftTouchTail.control = true;
      },
      onTouchEnd: onTouchEnd
    });

    function addFocusOnControls (el) {
      addFocus(el, function () {
        setTimeout(function () {
          lockScroll($stage);
        }, 0);
        toggleControlsClass(false);
      });
    }

    $arrs.each(function () {
      addEnterUp(this, function (e) {
        onArrClick.call(this, e);
      });
      addFocusOnControls(this);
    });

    addEnterUp(fullscreenIcon, that.toggleFullScreen);
    addFocusOnControls(fullscreenIcon);

    function reset () {
      setData();
      setOptions();

      if (!reset.i) {
        reset.i = true;
        // Only once
        var _startindex = opts.startindex;
        if (_startindex || opts.hash && location.hash) {
          startIndex = getIndexFromHash(_startindex || location.hash.replace(/^#/, ''), data, that.index === 0 || _startindex, _startindex);
        }
        activeIndex = repositionIndex = dirtyIndex = lastActiveIndex = startIndex = edgeIndex(startIndex) || 0;/*(o_rtl ? size - 1 : 0)*///;
      }

      if (size) {
        if (changeToRtl()) return;

        if ($videoPlaying) {
          unloadVideo($videoPlaying, true);
        }

        activeIndexes = [];
        detachFrames(STAGE_FRAME_KEY);

        reset.ok = true;

        that.show({index: activeIndex, time: 0});
        that.resize();
      } else {
        that.destroy();
      }
    }

    function changeToRtl () {
      ////console.log('changeToRtl');
      if (!changeToRtl.f === o_rtl) {
        changeToRtl.f = o_rtl;
        activeIndex = size - 1 - activeIndex;
        ////console.log('changeToRtl execute, activeIndex is', activeIndex);
        that.reverse();

        return true;
      }
    }

    $.each('load push pop shift unshift reverse sort splice'.split(' '), function (i, method) {
      that[method] = function () {
        data = data || [];
        if (method !== 'load') {
          Array.prototype[method].apply(data, arguments);
        } else if (arguments[0] && typeof arguments[0] === 'object' && arguments[0].length) {
          data = clone(arguments[0]);
        }
        reset();
        return that;
      }
    });

    function ready () {
      if (!ready.ok) {
        ready.ok = true;
        triggerEvent('ready');
      }
    }

    reset();
  };


  $.fn.fotorama = function (opts) {
    return this.each(function () {
      var that = this,
        $fotorama = $(this),
        fotoramaData = $fotorama.data(),
        fotorama = fotoramaData.fotorama;

      if (!fotorama) {
        waitFor(function () {
          return !isHidden(that);
        }, function () {
          fotoramaData.urtext = $fotorama.html();
          new $.Fotorama($fotorama,
            /* Priority for options:
             * 1. <div data-loop="true"></div>
             * 2. $('div').fotorama({loop: false})
             * 3. Defaults */
            $.extend(
              {},
              OPTIONS,
              window.fotoramaDefaults,
              opts,
              fotoramaData
            )
          );
        });
      } else {
        fotorama.setOptions(opts, true);
      }
    });
  };
  $.Fotorama.instances = [];

  function calculateIndexes () {
    $.each($.Fotorama.instances, function (index, instance) {
      instance.index = index;
    });
  }

  function addInstance (instance) {
    $.Fotorama.instances.push(instance);
    calculateIndexes();
  }

  function hideInstance (instance) {
    $.Fotorama.instances.splice(instance.index, 1);
    calculateIndexes();
  }
  $.Fotorama.cache = {};
  $.Fotorama.measures = {};
  $ = $ || {};
  $.Fotorama = $.Fotorama || {};
  $.Fotorama.jst = $.Fotorama.jst || {};

  $.Fotorama.jst.style = function(v) {
    var __t, __p = '', __e = _.escape;
    __p += '.fotorama' +
      ((__t = ( v.s )) == null ? '' : __t) +
      ' .fotorama__nav--thumbs .fotorama__nav__frame{\npadding:' +
      ((__t = ( v.m )) == null ? '' : __t) +
      'px;\nheight:' +
      ((__t = ( v.h )) == null ? '' : __t) +
      'px}\n.fotorama' +
      ((__t = ( v.s )) == null ? '' : __t) +
      ' .fotorama__thumb-border{\nheight:' +
      ((__t = ( v.h - v.b * (v.q ? 0 : 2) )) == null ? '' : __t) +
      'px;\nborder-width:' +
      ((__t = ( v.b )) == null ? '' : __t) +
      'px;\nmargin-top:' +
      ((__t = ( v.m )) == null ? '' : __t) +
      'px}';
    return __p
  };

  $.Fotorama.jst.video = function(v) {
    var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
    function print() { __p += __j.call(arguments, '') }
    __p += '<div class="fotorama__video">';
    if (v.type == 'youtube') {
      __p += '<div id="fotorama-video-yt-' + v.id + '"></div>';
    } else if (v.type == 'm3u8') {
      __p += '<div id="fotorama-video-m3u8-' + v.id + '"><video width="100%" height="500" id="vp-m3u8" className="video-player mejs-ted ng-scope" autoPlay preload="none"><source type="application/x-mpegURL" src="' + v.href + '"></video></div>';
    } else {
      __p += '<iframe src="';
      print((v.type == 'youtube' ? v.p + 'www.youtube.com/embed/' + v.id + '?autoplay=1&rel=0&enablejsapi=1&iv_load_policy=3' : v.type == 'vimeo' ? v.p + 'player.vimeo.com/video/' + v.id + '?autoplay=1&badge=0' : v.id) + (v.s && v.type != 'custom' ? '&' + v.s : ''));
      __p += '" frameborder="0" allowfullscreen></iframe>';
    }
    __p += '</div>\n';
    return __p
  };
  $(function () {
    $('.' + _fotoramaClass + ':not([data-auto="false"])').fotorama();
  });
})(window, document, location, typeof jQuery !== 'undefined' && jQuery);

/*!
 * MediaElement.js
 * http://www.mediaelementjs.com/
 *
 * Wrapper that mimics native HTML5 MediaElement (audio and video)
 * using a variety of technologies (pure JavaScript, Flash, iframe)
 *
 * Copyright 2010-2017, John Dyer (http://j.hn/)
 * License: MIT
 *
 */(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
'use strict';

var _player = _dereq_(2);

var _player2 = _interopRequireDefault(_player);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

mejs.i18n.en['mejs.chromecast-legend'] = 'Casting to:';

Object.assign(mejs.MepDefaults, {
	castTitle: null,

	castAppID: null,

	castPolicy: 'origin',

	castEnableTracks: false,

	castIsLive: false

});

Object.assign(MediaElementPlayer.prototype, {
	buildchromecast: function buildchromecast(player, controls, layers, media) {

		var t = this,
		    button = document.createElement('div'),
		    castTitle = mejs.Utils.isString(t.options.castTitle) ? t.options.castTitle : 'Chromecast';

		player.chromecastLayer = document.createElement('div');
		player.chromecastLayer.className = t.options.classPrefix + 'chromecast-layer ' + t.options.classPrefix + 'layer';
		player.chromecastLayer.innerHTML = '<div class="' + t.options.classPrefix + 'chromecast-info"></div>';
		player.chromecastLayer.style.display = 'none';

		layers.insertBefore(player.chromecastLayer, layers.firstChild);

		button.className = t.options.classPrefix + 'button ' + t.options.classPrefix + 'chromecast-button';
		button.innerHTML = '<button type="button" is="google-cast-button" aria-controls="' + t.id + '" title="' + castTitle + '" aria-label="' + castTitle + '" tabindex="0"></button>';
		button.style.display = 'none';

		t.addControlElement(button, 'chromecast');
		t.castButton = button;

		player.chromecastLayer.innerHTML = '<div class="' + t.options.classPrefix + 'chromecast-container">' + ('<span class="' + t.options.classPrefix + 'chromecast-icon"></span>') + ('<span class="' + t.options.classPrefix + 'chromecast-info">' + mejs.i18n.t('mejs.chromecast-legend') + ' <span class="device"></span></span>') + '</div>';

		if (media.originalNode.getAttribute('poster')) {
			player.chromecastLayer.innerHTML += '<img src="' + media.originalNode.getAttribute('poster') + '" width="100%" height="100%">';
			player.chromecastLayer.querySelector('img').addEventListener('click', function () {
				if (player.options.clickToPlayPause) {
					var _button = t.container.querySelector('.' + t.options.classPrefix + 'overlay-button'),
					    pressed = _button.getAttribute('aria-pressed');

					if (player.paused) {
						player.play();
					} else {
						player.pause();
					}

					_button.setAttribute('aria-pressed', !!pressed);
					player.container.focus();
				}
			});
		}

		window.__onGCastApiAvailable = function (isAvailable) {
			var mediaType = mejs.Utils.getTypeFromFile(media.originalNode.src).toLowerCase(),
			    canPlay = mediaType && ['application/x-mpegurl', 'application/vnd.apple.mpegurl', 'application/dash+xml', 'video/mp4', 'audio/mp3', 'audio/mp4'].indexOf(mediaType) > -1;

			if (isAvailable && canPlay) {
				t._initializeCastPlayer();
			}
		};

		if (window.cast) {
			var _button2 = t.controls.querySelector('.' + t.options.classPrefix + 'chromecast-button>button');
			if (_button2 && _button2.style.display !== 'none') {
				t.controls.querySelector('.' + t.options.classPrefix + 'chromecast-button').style.display = '';
			}
			t._initializeCastPlayer();
			return;
		}
		mejs.Utils.loadScript('https://www.gstatic.com/cv/js/sender/v1/cast_sender.js?loadCastFramework=1');
	},
	cleanchromecast: function cleanchromecast(player) {
		if (window.cast) {
			var session = cast.framework.CastContext.getInstance().getCurrentSession();
			if (session) {
				session.endSession(true);
			}
		}

		if (player.castButton) {
			player.castButton.remove();
		}

		if (player.chromecastLayer) {
			player.chromecastLayer.remove();
		}
	},
	_initializeCastPlayer: function _initializeCastPlayer() {
		var t = this;

		var origin = void 0;

		switch (this.options.castPolicy) {
			case 'tab':
				origin = 'TAB_AND_ORIGIN_SCOPED';
				break;
			case 'page':
				origin = 'PAGE_SCOPED';
				break;
			default:
				origin = 'ORIGIN_SCOPED';
				break;
		}

		var context = cast.framework.CastContext.getInstance(),
		    session = context.getCurrentSession();
		context.setOptions({
			receiverApplicationId: t.options.castAppID || chrome.cast.media.DEFAULT_MEDIA_RECEIVER_APP_ID,
			autoJoinPolicy: chrome.cast.AutoJoinPolicy[origin]
		});
		context.addEventListener(cast.framework.CastContextEventType.CAST_STATE_CHANGED, t._checkCastButtonStatus.bind(t));

		t.remotePlayer = new cast.framework.RemotePlayer();
		t.remotePlayerController = new cast.framework.RemotePlayerController(t.remotePlayer);
		t.remotePlayerController.addEventListener(cast.framework.RemotePlayerEventType.IS_CONNECTED_CHANGED, t._switchToCastPlayer.bind(this));

		if (session) {
			var state = context.getCastState(),
			    button = t.controls.querySelector('.' + t.options.classPrefix + 'chromecast-button');

			if (button && state === cast.framework.CastState.NO_DEVICES_AVAILABLE) {
				button.style.display = 'none';
			} else if (button) {
				if (t.chromecastLayer) {
					t.chromecastLayer.style.display = state === cast.framework.CastState.CONNECTED ? '' : 'none';
				}
				button.style.display = '';
			}
			t._switchToCastPlayer();
		}
	},
	_checkCastButtonStatus: function _checkCastButtonStatus(e) {
		var t = this,
		    button = t.controls.querySelector('.' + t.options.classPrefix + 'chromecast-button');

		if (button && e.castState === cast.framework.CastState.NO_DEVICES_AVAILABLE) {
			button.style.display = 'none';
		} else if (button) {
			if (t.chromecastLayer) {
				t.chromecastLayer.style.display = e.castState === cast.framework.CastState.CONNECTED ? '' : 'none';
			}
			button.style.display = '';
		}

		setTimeout(function () {
			t.setPlayerSize(t.width, t.height);
			t.setControlsSize();
		}, 0);
	},
	_switchToCastPlayer: function _switchToCastPlayer() {
		var t = this;

		if (t.proxy) {
			t.proxy.pause();
		}
		if (cast && cast.framework) {
			var context = cast.framework.CastContext.getInstance();
			context.addEventListener(cast.framework.CastContextEventType.CAST_STATE_CHANGED, t._checkCastButtonStatus.bind(t));
			if (t.remotePlayer.isConnected) {
				t._setupCastPlayer();
				return;
			}
		}
		t._setDefaultPlayer();
	},
	_setupCastPlayer: function _setupCastPlayer() {
		var t = this,
		    context = cast.framework.CastContext.getInstance(),
		    castSession = context.getCurrentSession(),
		    deviceInfo = t.layers.querySelector('.' + t.options.classPrefix + 'chromecast-info');

		if (t.loadedChromecast === true) {
			return;
		}

		t.loadedChromecast = true;

		t.proxy = new _player2.default(t.remotePlayer, t.remotePlayerController, t.media, t.options);

		if (deviceInfo) deviceInfo.querySelector('.device').innerText = castSession.getCastDevice().friendlyName;
		if (t.chromecastLayer) {
			t.chromecastLayer.style.display = '';
		}

		if (t.options.castEnableTracks === true) {
			(function () {
				var captions = t.captionsButton !== undefined ? t.captionsButton.querySelectorAll('input[type=radio]') : null;

				if (captions !== null) {
					var _loop = function _loop(i, total) {
						captions[i].addEventListener('click', function () {
							var trackId = parseInt(captions[i].id.replace(/^.*?track_(\d+)_.*$/, "$1")),
							    setTracks = captions[i].value === 'none' ? [] : [trackId],
							    tracksInfo = new chrome.cast.media.EditTracksInfoRequest(setTracks);

							castSession.getMediaSession().editTracksInfo(tracksInfo, function () {}, function (e) {
								console.error(e);
							});
						});
					};

					for (var i = 0, total = captions.length; i < total; i++) {
						_loop(i, total);
					}
				}
			})();
		}

		t.media.addEventListener('loadedmetadata', function () {
			if (['SESSION_ENDING', 'SESSION_ENDED', 'NO_SESSION'].indexOf(castSession.getSessionState()) === -1 && t.proxy instanceof DefaultPlayer) {
				t.proxy.pause();
				t.proxy = new _player2.default(t.remotePlayer, t.remotePlayerController, t.media, t.options);
			}
		});

		t.media.addEventListener('timeupdate', function () {
			t.currentMediaTime = t.getCurrentTime();
		});
	}
});

},{"2":2}],2:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ChromecastPlayer = function () {
	function ChromecastPlayer(player, controller, media, options) {
		_classCallCheck(this, ChromecastPlayer);

		var t = this;
		t.player = player;
		t.controller = controller;
		t.media = media;
		t.endedMedia = false;
		t.enableTracks = options.castEnableTracks;
		t.isLive = options.castIsLive;

		t.controller.addEventListener(cast.framework.RemotePlayerEventType.IS_PAUSED_CHANGED, function () {
			if (t.paused) {
				t.pause();
			} else {
				t.play();
			}
			t.endedMedia = false;
		});
		t.controller.addEventListener(cast.framework.RemotePlayerEventType.IS_MUTED_CHANGED, function () {
			t.setMuted(t.player.isMuted);
			t.volume = 0;
		});
		t.controller.addEventListener(cast.framework.RemotePlayerEventType.IS_MEDIA_LOADED_CHANGED, function () {
			var event = mejs.Utils.createEvent('loadedmetadata', t.media);
			t.media.dispatchEvent(event);
		});
		t.controller.addEventListener(cast.framework.RemotePlayerEventType.VOLUME_LEVEL_CHANGED, function () {
			t.volume = t.player.volumeLevel;
			var event = mejs.Utils.createEvent('volumechange', t.media);
			t.media.dispatchEvent(event);
		});
		t.controller.addEventListener(cast.framework.RemotePlayerEventType.DURATION_CHANGED, function () {
			var event = mejs.Utils.createEvent('timeupdate', t.media);
			t.media.dispatchEvent(event);
		});
		t.controller.addEventListener(cast.framework.RemotePlayerEventType.CURRENT_TIME_CHANGED, function () {
			var event = mejs.Utils.createEvent('timeupdate', t.media);
			t.media.dispatchEvent(event);

			if (!t.isLive && t.getCurrentTime() >= t.getDuration()) {
				t.endedMedia = true;
				setTimeout(function () {
					var event = mejs.Utils.createEvent('ended', t.media);
					t.media.dispatchEvent(event);
				}, 50);
			}
		});
		t.controller.addEventListener(cast.framework.RemotePlayerEventType.IS_MUTED_CHANGED, function () {
			t.setMuted(t.player.isMuted);
		});

		t.load();
		return t;
	}

	_createClass(ChromecastPlayer, [{
		key: 'getSrc',
		value: function getSrc() {
			return this.media.originalNode.src;
		}
	}, {
		key: 'setSrc',
		value: function setSrc(value) {
			this.media.originalNode.src = typeof value === 'string' ? value : value[0].src;
			this.load();
		}
	}, {
		key: 'setCurrentTime',
		value: function setCurrentTime(value) {
			this.player.currentTime = value;
			this.controller.seek();
			var event = mejs.Utils.createEvent('timeupdate', this.media);
			this.media.dispatchEvent(event);
		}
	}, {
		key: 'getCurrentTime',
		value: function getCurrentTime() {
			return this.player.currentTime;
		}
	}, {
		key: 'getDuration',
		value: function getDuration() {
			return this.player.duration;
		}
	}, {
		key: 'setVolume',
		value: function setVolume(value) {
			this.player.volumeLevel = value;
			this.controller.setVolumeLevel();
			var event = mejs.Utils.createEvent('volumechange', this.media);
			this.media.dispatchEvent(event);
		}
	}, {
		key: 'getVolume',
		value: function getVolume() {
			return this.player.volumeLevel;
		}
	}, {
		key: 'play',
		value: function play() {
			if (this.player.isPaused) {
				this.controller.playOrPause();
				var event = mejs.Utils.createEvent('play', this.media);
				this.media.dispatchEvent(event);
			}
		}
	}, {
		key: 'pause',
		value: function pause() {
			if (!this.player.isPaused) {
				this.controller.playOrPause();
				var event = mejs.Utils.createEvent('pause', this.media);
				this.media.dispatchEvent(event);
			}
		}
	}, {
		key: 'load',
		value: function load() {
			var t = this,
			    url = this.media.originalNode.src,
			    type = mejs.Utils.getTypeFromFile(url),
			    mediaInfo = new chrome.cast.media.MediaInfo(url, type),
			    castSession = cast.framework.CastContext.getInstance().getCurrentSession();

			if (url === window.location.href || !castSession) {
				return;
			}

			if (t.enableTracks === true) {
				var tracks = [],
				    children = t.media.originalNode.children;

				var counter = 1;

				for (var i = 0, total = children.length; i < total; i++) {
					var child = children[i],
					    tag = child.tagName.toLowerCase();

					if (tag === 'track' && (child.getAttribute('kind') === 'subtitles' || child.getAttribute('kind') === 'captions')) {
						var el = new chrome.cast.media.Track(counter, chrome.cast.media.TrackType.TEXT);
						el.trackContentId = mejs.Utils.absolutizeUrl(child.getAttribute('src'));
						el.trackContentType = 'text/vtt';
						el.subtype = chrome.cast.media.TextTrackType.SUBTITLES;
						el.name = child.getAttribute('label');
						el.language = child.getAttribute('srclang');
						el.customData = null;
						tracks.push(el);
						counter++;
					}
				}
				mediaInfo.textTrackStyle = new chrome.cast.media.TextTrackStyle();
				mediaInfo.tracks = tracks;
			}

			mediaInfo.metadata = new chrome.cast.media.GenericMediaMetadata();
			mediaInfo.streamType = t.isLive ? chrome.cast.media.StreamType.LIVE : chrome.cast.media.StreamType.BUFFERED;
			mediaInfo.customData = null;
			mediaInfo.duration = null;
			mediaInfo.currentTime = t.isLive ? Infinity : 0;

			if (t.media.originalNode.getAttribute('data-cast-title')) {
				mediaInfo.metadata.title = t.media.originalNode.getAttribute('data-cast-title');
			}

			if (t.media.originalNode.getAttribute('data-cast-description')) {
				mediaInfo.metadata.subtitle = t.media.originalNode.getAttribute('data-cast-description');
			}

			if (t.media.originalNode.getAttribute('poster') || t.media.originalNode.getAttribute('data-cast-poster')) {
				var poster = t.media.originalNode.getAttribute('poster') || t.media.originalNode.getAttribute('data-cast-poster');
				mediaInfo.metadata.images = [{ 'url': mejs.Utils.absolutizeUrl(poster) }];
			}

			var request = new chrome.cast.media.LoadRequest(mediaInfo);

			castSession.loadMedia(request).then(function () {
				var currentTime = t.media.originalNode.currentTime;
				t.setCurrentTime(currentTime);
				t.play();

				var event = mejs.Utils.createEvent('play', t.media);
				t.media.dispatchEvent(event);
			}, function (error) {
				t._getErrorMessage(error);
			});
		}
	}, {
		key: 'setMuted',
		value: function setMuted(value) {
			var _this = this;

			if (value === true && !this.player.isMuted) {
				this.controller.muteOrUnmute();
			} else if (value === false && this.player.isMuted) {
				this.controller.muteOrUnmute();
			}
			setTimeout(function () {
				var event = mejs.Utils.createEvent('volumechange', _this.media);
				_this.media.dispatchEvent(event);
			}, 50);
		}
	}, {
		key: 'canPlayType',
		value: function canPlayType(type) {
			return ~['application/x-mpegurl', 'vnd.apple.mpegurl', 'application/dash+xml', 'video/mp4'].indexOf(type);
		}
	}, {
		key: '_getErrorMessage',
		value: function _getErrorMessage(error) {

			var description = error.description ? ' : ' + error.description : '.';

			var message = void 0;

			switch (error.code) {
				case chrome.cast.ErrorCode.API_NOT_INITIALIZED:
					message = 'The API is not initialized' + description;
					break;
				case chrome.cast.ErrorCode.CANCEL:
					message = 'The operation was canceled by the user' + description;
					break;
				case chrome.cast.ErrorCode.CHANNEL_ERROR:
					message = 'A channel to the receiver is not available' + description;
					break;
				case chrome.cast.ErrorCode.EXTENSION_MISSING:
					message = 'The Cast extension is not available' + description;
					break;
				case chrome.cast.ErrorCode.INVALID_PARAMETER:
					message = 'The parameters to the operation were not valid' + description;
					break;
				case chrome.cast.ErrorCode.RECEIVER_UNAVAILABLE:
					message = 'No receiver was compatible with the session request' + description;
					break;
				case chrome.cast.ErrorCode.SESSION_ERROR:
					message = 'A session could not be created, or a session was invalid' + description;
					break;
				case chrome.cast.ErrorCode.TIMEOUT:
					message = 'The operation timed out' + description;
					break;
				default:
					message = 'Unknown error: ' + error;
					break;
			}

			console.error(message);
		}
	}, {
		key: 'paused',
		get: function get() {
			return this.player.isPaused;
		}
	}, {
		key: 'muted',
		set: function set(value) {
			this.setMuted(value);
		},
		get: function get() {
			return this.player.isMuted;
		}
	}, {
		key: 'ended',
		get: function get() {
			return this.endedMedia;
		}
	}, {
		key: 'readyState',
		get: function get() {
			return this.media.originalNode.readyState;
		}
	}, {
		key: 'currentTime',
		set: function set(value) {
			this.setCurrentTime(value);
		},
		get: function get() {
			return this.getCurrentTime();
		}
	}, {
		key: 'duration',
		get: function get() {
			return this.getDuration();
		}
	}, {
		key: 'volume',
		set: function set(value) {
			this.setVolume(value);
		},
		get: function get() {
			return this.getVolume();
		}
	}, {
		key: 'src',
		set: function set(src) {
			this.setSrc(src);
		},
		get: function get() {
			return this.getSrc();
		}
	}]);

	return ChromecastPlayer;
}();

exports.default = ChromecastPlayer;


window.ChromecastPlayer = ChromecastPlayer;

},{}]},{},[1,2]);

'use strict';

if (mejs.i18n.ca !== undefined) {
	// mejs.i18n.ca["mejs.chromecast-title"] = "Chromecast";
	// mejs.i18n.ca["mejs.chromecast-subtitle"] = "Chromecast Subtitle";
}
if (mejs.i18n.cs !== undefined) {
	// mejs.i18n.cs["mejs.chromecast-title"] = "Chromecast";
	// mejs.i18n.cs["mejs.chromecast-subtitle"] = "Chromecast Subtitle";
}
if (mejs.i18n.de !== undefined) {
	// mejs.i18n.de["mejs.chromecast-title"] = "Chromecast";
	// mejs.i18n.de["mejs.chromecast-subtitle"] = "Chromecast Subtitle";
}
if (mejs.i18n.es !== undefined) {
	// mejs.i18n.es["mejs.chromecast-title"] = "Chromecast";
	// mejs.i18n.es["mejs.chromecast-subtitle"] = "Chromecast Subtitle";
}
if (mejs.i18n.fr !== undefined) {
	// mejs.i18n.fr["mejs.chromecast-title"] = "Chromecast";
	// mejs.i18n.fr["mejs.chromecast-subtitle"] = "Chromecast Subtitle";
}
if (mejs.i18n.hr !== undefined) {
	// mejs.i18n.hr["mejs.chromecast-title"] = "Chromecast";
	// mejs.i18n.hr["mejs.chromecast-subtitle"] = "Chromecast Subtitle";
}
if (mejs.i18n.hu !== undefined) {
	// mejs.i18n.hu["mejs.chromecast-title"] = "Chromecast";
	// mejs.i18n.hu["mejs.chromecast-subtitle"] = "Chromecast Subtitle";
}
if (mejs.i18n.it !== undefined) {
	// mejs.i18n.it["mejs.chromecast-title"] = "Chromecast";
	// mejs.i18n.it["mejs.chromecast-subtitle"] = "Chromecast Subtitle";
}
if (mejs.i18n.ja !== undefined) {
	// mejs.i18n.ja["mejs.chromecast-title"] = "Chromecast";
	// mejs.i18n.ja["mejs.chromecast-subtitle"] = "Chromecast Subtitle";
}
if (mejs.i18n.ko !== undefined) {
	// mejs.i18n.ko["mejs.chromecast-title"] = "Chromecast";
	// mejs.i18n.ko["mejs.chromecast-subtitle"] = "Chromecast Subtitle";
}
if (mejs.i18n.nl !== undefined) {
	// mejs.i18n.nl["mejs.chromecast-title"] = "Chromecast";
	// mejs.i18n.nl["mejs.chromecast-subtitle"] = "Chromecast Subtitle";
}
if (mejs.i18n.pl !== undefined) {
	// mejs.i18n.pl["mejs.chromecast-title"] = "Chromecast";
	// mejs.i18n.pl["mejs.chromecast-subtitle"] = "Chromecast Subtitle";
}
if (mejs.i18n.pt !== undefined) {
	// mejs.i18n.pt["mejs.chromecast-title"] = "Chromecast";
	// mejs.i18n.pt["mejs.chromecast-subtitle"] = "Chromecast Subtitle";
}
if (mejs.i18n['pt-BR'] !== undefined) {
	// mejs.i18n['pt-BR']["mejs.chromecast-title"] = "Chromecast";
	// mejs.i18n['pt-BR']["mejs.chromecast-subtitle"] = "Chromecast Subtitle";
}
if (mejs.i18n.ro !== undefined) {
	// mejs.i18n.ro["mejs.chromecast-title"] = "Chromecast";
	// mejs.i18n.ro["mejs.chromecast-subtitle"] = "Chromecast Subtitle";
}
if (mejs.i18n.ru !== undefined) {
	// mejs.i18n.ru["mejs.chromecast-title"] = "Chromecast";
	// mejs.i18n.ru["mejs.chromecast-subtitle"] = "Chromecast Subtitle";
}
if (mejs.i18n.sk !== undefined) {
	// mejs.i18n.sk["mejs.chromecast-title"] = "Chromecast";
	// mejs.i18n.sk["mejs.chromecast-subtitle"] = "Chromecast Subtitle";
}
if (mejs.i18n.sv !== undefined) {
	// mejs.i18n.sv["mejs.chromecast-title"] = "Chromecast";
	// mejs.i18n.sv["mejs.chromecast-subtitle"] = "Chromecast Subtitle";
}
if (mejs.i18n.uk !== undefined) {
	// mejs.i18n.uk["mejs.chromecast-title"] = "Chromecast";
	// mejs.i18n.uk["mejs.chromecast-subtitle"] = "Chromecast Subtitle";
}
if (mejs.i18n.zh !== undefined) {
	// mejs.i18n.zh["mejs.chromecast-title"] = "Chromecast";
	// mejs.i18n.zh["mejs.chromecast-subtitle"] = "Chromecast Subtitle";
}
if (mejs.i18n['zh-CN'] !== undefined) {
	// mejs.i18n['zh-CN']["mejs.chromecast-title"] = "Chromecast";
	// mejs.i18n['zh-CN']["mejs.chromecast-subtitle"] = "Chromecast Subtitle";
}
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard', [])
        .config(config)
        .run(run);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        $stateProvider
            .state('app.scrumboard', {
                abstract : true,
                url      : '/scrumboard',
                resolve  : {
                    BoardList: function (msApi)
                    {
                        return msApi.resolve('scrumboard.boardList@get');
                    }
                },
                bodyClass: 'scrumboard'
            })

            // Home
            .state('app.scrumboard.boards', {
                url  : '/boards',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/scrumboard/views/boards/boards-view.html',
                        controller : 'BoardsViewController as vm'
                    }
                }
            })

            // Board
            .state('app.scrumboard.boards.board', {
                    url    : '/:id/:uri',
                    views  : {
                        'content@app'                                  : {
                            templateUrl: 'app/main/apps/scrumboard/scrumboard.html',
                            controller : 'ScrumboardController as vm'
                        },
                        'scrumboardContent@app.scrumboard.boards.board': {
                            templateUrl: 'app/main/apps/scrumboard/views/board/board-view.html',
                            controller : 'BoardViewController as vm'
                        }
                    },
                    resolve: {
                        BoardData: function ($stateParams, BoardService)
                        {
                            return BoardService.getBoardData($stateParams.id);
                        }
                    }
                }
            )

            // Add board
            .state('app.scrumboard.boards.addBoard', {
                    url    : '/add',
                    views  : {
                        'content@app'                                     : {
                            templateUrl: 'app/main/apps/scrumboard/scrumboard.html',
                            controller : 'ScrumboardController as vm'
                        },
                        'scrumboardContent@app.scrumboard.boards.addBoard': {
                            templateUrl: 'app/main/apps/scrumboard/views/board/board-view.html',
                            controller : 'BoardViewController as vm'
                        }
                    },
                    resolve: {
                        BoardData: function ($stateParams, BoardService)
                        {
                            return BoardService.addNewBoard();
                        }
                    }
                }
            )

            // Calendar
            .state('app.scrumboard.boards.board.calendar', {
                url  : '/calendar',
                views: {
                    'scrumboardContent@app.scrumboard.boards.board': {
                        templateUrl: 'app/main/apps/scrumboard/views/calendar/calendar-view.html',
                        controller : 'CalendarViewController as vm'
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/scrumboard');

        // Api
        msApiProvider.register('scrumboard.boardList', ['app/data/scrumboard/board-list.json']);
        msApiProvider.register('scrumboard.board', ['app/data/scrumboard/boards/:id.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('apps.scrumboard', {
            title : 'Scrumboard',
            icon  : 'icon-trello',
            state : 'app.scrumboard.boards',
            weight: 6
        });
    }

    /** @ngInject */
    function run(editableThemes)
    {
        /**
         * Inline Edit Configuration
         * @type {string}
         */
        editableThemes.default.submitTpl = '<md-button class="md-icon-button" type="submit" aria-label="save"><md-icon md-font-icon="icon-checkbox-marked-circle" class="md-accent-fg md-hue-1"></md-icon></md-button>';
        editableThemes.default.cancelTpl = '<md-button class="md-icon-button" ng-click="$form.$cancel()" aria-label="cancel"><md-icon md-font-icon="icon-close-circle" class="icon-cancel"></md-icon></md-button>';
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('ScrumboardCalendarEventDialogController', ScrumboardCalendarEventDialogController);

    /** @ngInject */
    function ScrumboardCalendarEventDialogController($mdDialog, dueDate, BoardService, msUtils)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.dueDate = dueDate;
        vm.newCard = {
            name  : '',
            listId: ''
        };
        vm.selectedCards = [];

        // Methods
        vm.exists = msUtils.exists;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.closeDialog = closeDialog;
        vm.addNewCard = addNewCard;
        vm.assignDueDate = assignDueDate;

        //////////

        /**
         * Close Dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

        /**
         * Add New Card
         */
        function addNewCard()
        {
            var newCardId = msUtils.guidGenerator();

            vm.board.cards.push({
                'id'               : newCardId,
                'name'             : vm.newCard.name,
                'description'      : '',
                'idAttachmentCover': '',
                'idMembers'        : [],
                'idLabels'         : [],
                'attachments'      : [],
                'subscribed'       : false,
                'checklists'       : [],
                'checkItems'       : 0,
                'checkItemsChecked': 0,
                'comments'         : [],
                'activities'       : [],
                'due'              : vm.dueDate
            });

            vm.board.lists.getById(vm.newCard.listId).idCards.push(newCardId);

            // Reset the newCard object
            vm.newCard = {
                name: '',
                listId: ''
            };

            closeDialog();
        }

        /**
         * Assign Due Date
         */
        function assignDueDate()
        {
            angular.forEach(vm.selectedCards, function (cardId)
            {
                vm.board.cards.getById(cardId).due = vm.dueDate;
            });

            vm.selectedCards = [];

            closeDialog();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('MembersMenuController', MembersMenuController);

    /** @ngInject */
    function MembersMenuController($document, $mdDialog, BoardService)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.newMemberSearchInput = '';

        // Methods
        vm.addNewMember = addNewMember;
        vm.removeMember = removeMember;

        ////////

        /**
         * Add New Member
         */
        function addNewMember()
        {
            // Add new member
        }

        /**
         * Remove member
         *
         * @param ev
         * @param memberId
         */
        function removeMember(ev, memberId)
        {
            var confirm = $mdDialog.confirm({
                title              : 'Remove Member',
                parent             : $document.find('#scrumboard'),
                textContent        : 'Are you sure want to remove member?',
                ariaLabel          : 'remove member',
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true,
                ok                 : 'Remove',
                cancel             : 'Cancel'
            });

            $mdDialog.show(confirm).then(function ()
            {
                var arr = vm.board.members;
                arr.splice(arr.indexOf(arr.getById(memberId)), 1);

                angular.forEach(vm.board.cards, function (card)
                {
                    if ( card.idMembers && card.idMembers.indexOf(memberId) > -1 )
                    {
                        card.idMembers.splice(card.idMembers.indexOf(memberId), 1);
                    }
                });
            }, function ()
            {
                // Canceled
            });
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('LabelsMenuController', LabelsMenuController);

    /** @ngInject */
    function LabelsMenuController($document, $mdColorPalette, $mdDialog, QiuGenerator, msUtils, BoardService)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.palettes = $mdColorPalette;
        vm.rgba = QiuGenerator.rgba;
        vm.hue = 500;
        vm.newLabelColor = 'red';
        vm.newLabelName = '';

        // Methods
        vm.addNewLabel = addNewLabel;
        vm.removeLabel = removeLabel;

        ////////

        /**
         * Add New Label
         */
        function addNewLabel()
        {
            vm.board.labels.push({
                id   : msUtils.guidGenerator(),
                name : vm.newLabelName,
                color: vm.newLabelColor
            });
            vm.newLabelName = '';
        }

        /**
         * Remove label
         *
         * @param ev
         * @param labelId
         */
        function removeLabel(ev, labelId)
        {
            var confirm = $mdDialog.confirm({
                title              : 'Remove Label',
                parent             : $document.find('#scrumboard'),
                textContent        : 'Are you sure want to remove label?',
                ariaLabel          : 'remove label',
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true,
                ok                 : 'Remove',
                cancel             : 'Cancel'
            });

            $mdDialog.show(confirm).then(function ()
            {
                var arr = vm.board.labels;
                arr.splice(arr.indexOf(arr.getById(labelId)), 1);

                angular.forEach(vm.board.cards, function (card)
                {
                    if ( card.idLabels && card.idLabels.indexOf(labelId) > -1 )
                    {
                        card.idLabels.splice(card.idLabels.indexOf(labelId), 1);
                    }
                });
            }, function ()
            {
                // Canceled
            });
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('ColorMenuController', ColorMenuController);

    /** @ngInject */
    function ColorMenuController($mdColorPalette, BoardService)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.palettes = $mdColorPalette;

        // Methods

        ////////

    }
})();
(function () {
	'use strict';

	angular
		.module('app.users', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

		$stateProvider.state('app.users', {
			url: '/users',
			views: {
				'content@app': {
					templateUrl: 'app/main/apps/users/users.html',
					controller: 'UsersController as vm'
				}
			},
			bodyClass: 'content'
		});

		$stateProvider
			.state('app.site_overview.users', {
				abstract: true,
				url: '/users',
				// controller: 'siteContentController',
				// views: {
				// 	'content@app': {
				// 		templateUrl: 'app/main/apps/content/content.html',
				// 		controller: 'ContentController as vm'
				// 	}
				// },
				// templateUrl: '/modules/site/content/views/site_content.html',
				onEnter: function ($stateParams) {

				},
				data: {
					displayName: '{{section}}'
				},
				resolve: {
					section: function ($stateParams) {
						return $stateParams.section
					},
				},
			})
		$stateProvider
			.state('app.site_overview.users.activity', {
				url: '/activity',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/users/users-activity.html',
						controller: 'UsersActivityController as vm'
					}
				},
				onEnter: function ($stateParams) {
				},
				data: {
					displayName: '{{section}}'
				},
				resolve: {
					section: function ($stateParams) {
						return $stateParams.section
					},
				},
			})
			.state('app.site_overview.users.user_blacklist', {
				url: '/blacklist',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/users/users-blacklist/users-blacklist.html',
						controller: 'UsersBlackListedController as vm'
					}
				},
				onEnter: function ($stateParams) {
				},
				data: {
					displayName: '{{section}}'
				},
				resolve: {
					section: function ($stateParams) {
						return $stateParams.section
					},
				},
			})
			.state('app.site_overview.users.user_blacklist.list', {
				url: '',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/users/users-blacklist/users-blacklist.html',
						controller: 'UsersBlackListedController as vm'
					}
				},
				params: {
					groupTypeName: null,
					groupTypeId: null
				},
				// templateUrl: '/modules/site/content/views/site_content_list.html',
				// controller: 'siteContentListController',
				onEnter: function () {
				},
				data: {
					displayName: 'List {{section}}'
				},
				resolve: {
					// Cards: function (msApi)
					// {
					//	 return msApi.resolve('cards@get');
					// }
					//	 section: function ($stateParams) {
					//		 return $stateParams.section
					//	 }
				},
			})
			.state('app.site_overview.users.user_blacklist.list.thread', {
				url: '/:id',
				bodyClass: 'content'
			})
			.state('app.site_overview.users.user_temporary', {
				url: '/temporary',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/users/users-temporary/users-temporary.html',
						controller: 'UsersTemporaryController as vm'
					}
				},
				onEnter: function ($stateParams) {
				},
				data: {
					displayName: '{{section}}'
				},
				resolve: {
					section: function ($stateParams) {
						return $stateParams.section
					},
				},
			})
			.state('app.site_overview.users.user_temporary.list', {
				url: '/:groupTypeId/:groupTypeName',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/users/users-temporary/users-temporary.html',
						controller: 'UsersTemporaryController as vm'
					}
				},
				params: {
					groupTypeName: null,
					groupTypeId: null
				},
				// templateUrl: '/modules/site/content/views/site_content_list.html',
				// controller: 'siteContentListController',
				onEnter: function () {
				},
				data: {
					displayName: 'List {{section}}'
				},
				resolve: {
					// Cards: function (msApi)
					// {
					//	 return msApi.resolve('cards@get');
					// }
					//	 section: function ($stateParams) {
					//		 return $stateParams.section
					//	 }
				},
			})
			.state('app.site_overview.users.user_temporary.list.thread', {
				url: '/:id',
				bodyClass: 'content'
			})
		$stateProvider
			.state('app.site_overview.users.analytics', {
				url: '/analytics',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/users/analytics/analytics.html',
						controller: 'AnalyticsController as vm'
					}
				},
				onEnter: function ($stateParams) {
				},
				data: {
					displayName: '{{section}}'
				},
				resolve: {
					section: function ($stateParams) {
						return $stateParams.section
					},
				},
				params: {
					groupTypeName: 'analytics'
				},
			})
			.state('app.site_overview.users.analytics.thread', {
				url: '/:id',
				bodyClass: 'content'
			})
		$stateProvider
			.state('app.site_overview.users.accreditation', {
				url: '/accreditation',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/users/users-acreditation.html',
						controller: 'UsersActivityController as vm'
					}
				},
				onEnter: function ($stateParams) {
				},
				data: {
					displayName: '{{section}}'
				},
				resolve: {
					section: function ($stateParams) {
						return $stateParams.section
					},
				},
			})

			.state('app.site_overview.users.list', {
				url: '/:groupTypeId/:groupTypeName',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/users/users.html',
						controller: 'UsersController as vm'
					}
				},
				params: {
					groupTypeName: null,
					groupTypeId: null
				},
				// templateUrl: '/modules/site/content/views/site_content_list.html',
				// controller: 'siteContentListController',
				onEnter: function () {
				},
				data: {
					displayName: 'List {{section}}'
				},
				resolve: {
					// Cards: function (msApi)
					// {
					//	 return msApi.resolve('cards@get');
					// }
					//	 section: function ($stateParams) {
					//		 return $stateParams.section
					//	 }
				},
			})
			.state('app.site_overview.users.list.thread', {
				url: '/:id',
				bodyClass: 'content'
			})
			.state('app.site_overview.users.siteContentEdit', {
				url: '/:id/edit',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/users/views/edit/edit-view.html',
						controller: 'siteContentEditController as vm'
					}
				},
				// templateUrl: '/modules/site/content/views/site_content_edit.html',
				// controller: 'siteContentEditController',
				onEnter: function () {
				},
				data: {
					displayName: '{{dataItem.result.title}}'
				},
				resolve: {
					id: function ($stateParams) {
						return $stateParams.id
					},
					dataItem: function (requestContext, $stateParams, contentService) {
						// $scope.isLoading=true;
						var siteID = $stateParams.siteId;
						var id = $stateParams.id;
						var options = {
							site: $stateParams.siteId,
							id: $stateParams.id
						};
						return contentService.getByID(options);
						// return searchService.getSearchResults($route.current.params);
					}
				},
				// abstract:true,
			})

		$translatePartialLoaderProvider.addPart('app/main/apps/users');

	}
})();

(function () {
    'use strict';

    angular
        .module('app.users')
        .controller('CopyMoveToGroupDialogController', CopyMoveToGroupDialogController);

    /** @ngInject */
    function CopyMoveToGroupDialogController(
        $mdDialog,
        $document,
        sourceGroups,
        usersGroups,
        siteID,
        requestContext,
        $anchorScroll,
        $timeout,
        $scope,
        $sce,
        msUtils,
        COMMON,
        $log,
        $translate,
        usersService,
        $rootScope,
        $mdToast,
        $q,
        selectedAction
    ) {
        var vm = this;

        const ACTION_MOVE = "MOVE";
        const ACTION_COPY = "COPY";

        // Data
        vm.sourceGroups = sourceGroups;
        vm.siteID = siteID;
        vm.loading = false;
        vm.actionMove = ACTION_MOVE;
        vm.actionCopy = ACTION_COPY;
        vm.viewUsersGroup = 'app/main/apps/users/dialogs/groups/views/tree-view.html';
        vm.hideInGroupStatusSelect = true;
        vm.selectedAction = selectedAction

        // Methods
        vm.runAction = runAction;
        vm.closeDialog = cancel;


        vm.translate = function(text) {
            return $translate.instant(text);
        }

        init();
        /**
         * Initialize
         */
        function init() {
            vm.usersGroups = angular.copy(usersGroups);
        }

        function cancel() {
            vm.usersGroups = usersGroups;
            $mdDialog.hide(false);
        }

        function runAction() {
            vm.loading = true;
            let apiRequest = null;
            let message = null;

            let groups = getSelectedGroups(vm.usersGroups, []);

            if (groups.length < 1) {
                vm.loading = false;
                message = $translate.instant('USERS.NO_GROUP_SELECTED');
                $mdToast.show({
                    template: '<md-toast id="language-message"><span class="md-toast-text">' + message + '</span></md-toast>',
                    hideDelay: 7000,
                    position: 'top right',
                    parent: '#main'
                });
                return false;
            }

            let sourceGroupIDs = vm.sourceGroups.map(x => x.id_group);
            let targetGroupIDs = groups.map(x => x.id_group);
            let reloadUserList = false;
            let options = {
                siteID: siteID,
                data: {
                    source_groups: sourceGroupIDs,
                    target_groups: targetGroupIDs
                }
            };

            switch (vm.selectedAction) {
                case ACTION_MOVE :
                    apiRequest = usersService.moveUsersInGroupsToGroups(options);
                    if (targetGroupIDs.length == 1) {
                        message = $translate.instant('USERS.MOVETOGROUPS_SINGULAR');
                    } else {
                        message = $translate.instant('USERS.MOVETOGROUPS_PLURAL');
                    }
                    reloadUserList = true;
                    break;
                case ACTION_COPY :
                    apiRequest = usersService.copyUsersInGroupsToGroups(options);
                    if (targetGroupIDs.length == 1) {
                        message = $translate.instant('USERS.COPYTOGROUPS_SINGULAR');
                    } else {
                        message = $translate.instant('USERS.COPYTOGROUPS_PLURAL');
                    }
                    reloadUserList = false;
                    break;
                default: 
                    // TODO: Throw error message.
                    console.log('Error: Unknown action!');
                    return;
            }

            apiRequest.then(function (response) {
                vm.loading = false;
                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                    hideDelay: 5000,
                    position: 'top',
                    parent: '#content-container'
                });
                $mdDialog.hide(reloadUserList);
            }, function (error) {
                vm.loading = false;
                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-close" class="icon"></md-icon><span class="md-toast-text" flex>Error.</span></div></md-toast>',
                    hideDelay: 5000,
                    position: 'top',
                    parent: '#content-container'
                });
                $mdDialog.hide(false);
            });
        }

        function getSelectedGroups(groups, result) {
          angular.forEach(groups, function(group) {
            if(angular.isDefined(group.assigned_group) && group.assigned_group == true) {
              result.push(group);
            }
            if (typeof group.children !== 'undefined' && group.children.length >0) {
              getSelectedGroups(group.children, result);
            }
          });
          return result;
        }

    }
})();

(function () {
	'use strict';

	angular
		.module('app.sitemap', [])
        .constant('_', window._)
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

		$stateProvider.state('app.sitemap', {
			url: '/sitemap',
			views: {
				'content@app': {
					templateUrl: 'app/main/apps/sitemap/sitemap.html',
					controller: 'SitemapController as vm'
				}
			},
			bodyClass: 'content'
		});

		$stateProvider
			.state('app.site_overview.sitemap', {
				abstract: true,
				url: '/sitemap',
				onEnter: function ($stateParams) {

				},
				data: {
					displayName: '{{section}}'
				},
				resolve: {
					section: function ($stateParams) {
						return $stateParams.section
					},
				},
			})
			.state('app.site_overview.sitemap.full', {
				abstract: true,
				url: '/full',
				onEnter: function ($stateParams) {

				},
				data: {
					displayName: '{{section}}'
				},
				resolve: {
					section: function ($stateParams) {
						return $stateParams.section
					},
				},
			})
			.state('app.site_overview.sitemap.full.show', {
				url: '/show',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/sitemap/sitemap.html',
						controller: 'SitemapController as vm'
					}
				},
				// templateUrl: '/modules/site/content/views/site_content_list.html',
				// controller: 'siteContentListController',
				onEnter: function () {
				},
                params: {
                    isseosection: true
                },
				data: {
					displayName: 'List {{section}}'
				},
				resolve: {
					// Cards: function (msApi)
					// {
					//	 return msApi.resolve('cards@get');
					// }
					//	 section: function ($stateParams) {
					//		 return $stateParams.section
					//	 }
				},
			})
			.state('app.site_overview.sitemap.full.list', {
				url: '',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/sitemap/sitemap.html',
						controller: 'SitemapController as vm'
					}
				},
				// templateUrl: '/modules/site/content/views/site_content_list.html',
				// controller: 'siteContentListController',
				onEnter: function () {
				},
				data: {
					displayName: 'List {{section}}'
				},
				resolve: {
					// Cards: function (msApi)
					// {
					//	 return msApi.resolve('cards@get');
					// }
					//	 section: function ($stateParams) {
					//		 return $stateParams.section
					//	 }
				},
			})
			.state('app.site_overview.sitemap.seo', {
				url: '/seo',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/sitemap/sitemap.html',
						controller: 'SitemapController as vm'
					}
				},
				onEnter: function () {

				},
				params: {
                    isseosection: true
                },
				data: {
					displayName: 'List {{section}}'
				},
				resolve: {

				},
			})
			// Sitemap > Importer: Figma frame → page (tab action "importer" of the sitemap module)
			.state('app.site_overview.sitemap.importer', {
				url: '/importer',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/sitemap/importer/importer.html',
						controller: 'SitemapImporterController as vm'
					}
				},
				data: {
					displayName: 'Importer'
				},
				bodyClass: 'content'
			})
			.state('app.site_overview.sitemap.full.list.thread', {
				url: '/:id',
				bodyClass: 'content'
			});

		$stateProvider
			.state('app.site_overview.sitemap.lite', {
				abstract: true,
				url: '/lite',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/sitemap/sitemap.lite.html',
						controller: 'SitemapController as vm'
					}
				},
				bodyClass: 'content',
				params: {
					islite: true
				}
			})
			.state('app.site_overview.sitemap.lite.list', {
				url: '',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/sitemap/sitemap.lite.html',
						controller: 'SitemapController as vm'
					}
				},
				bodyClass: 'content'
			});
		$translatePartialLoaderProvider.addPart('app/main/apps/sitemap');

	}
})();

// app/main/apps/sitemap/layoutV2/components/layout-v2-sidebar/layout-v2-sidebar.component.js
(function () {
  'use strict';

  angular
    .module('app.sitemap')
    .component('layoutV2Sidebar', {
      templateUrl: 'app/main/apps/sitemap/layoutV2/components/layout-v2-sidebar/layout-v2-sidebar.html',
      controller: LayoutV2SidebarController,
      bindings: {
        library: '<',                 // { layouts, widgets, templates, elements }
        onApplyTemplate: '&?',        // callback({ template })
        onDropOnCanvas: '&?'          // reservado para drag&drop directo desde la lista
      }
    });

  /* @ngInject */
  function LayoutV2SidebarController($log) {
    var vm = this;

    // Tabs definition
    vm.tabs = [
      { id: 'layout',    label: 'LAYOUT' },
      { id: 'widgets',   label: 'WIDGETS' },
      { id: 'templates', label: 'TEMPLATES' },
      { id: 'elements',  label: 'ELEMENTS' }
    ];

    vm.activeTab = 'layout';
    vm.searchText = '';

    vm.$onInit = function () {
      // Ensure library object is always defined to avoid template errors
      vm.library = vm.library || {
        layouts: [],
        widgets: [],
        templates: [],
        elements: []
      };

      $log.debug('[LayoutV2 Sidebar] init', vm.library);
    };

    vm.setActiveTab = function (tabId) {
      vm.activeTab = tabId;
    };

    vm.isActiveTab = function (tabId) {
      return vm.activeTab === tabId;
    };

    vm.getItemsForActiveTab = function () {
      // NOTE: Simple switch based on active tab
      switch (vm.activeTab) {
        case 'layout':
          return vm.library.layouts || [];
        case 'widgets':
          return vm.library.widgets || [];
        case 'templates':
          return vm.library.templates || [];
        case 'elements':
          return vm.library.elements || [];
        default:
          return [];
      }
    };

    vm.filteredItems = function () {
      var items = vm.getItemsForActiveTab();
      if (!vm.searchText) {
        return items;
      }

      var query = (vm.searchText || '').toLowerCase();
      return items.filter(function (item) {
        // Basic search over name/label
        var label = (item.label || item.name || '').toLowerCase();
        return label.indexOf(query) !== -1;
      });
    };

    vm.applyTemplate = function (template) {
      // Only used when activeTab === 'templates'
      if (angular.isFunction(vm.onApplyTemplate)) {
        vm.onApplyTemplate({ template: template });
      }
    };

    // Placeholder for future drag handler
    vm.handleItemDragStart = function (item) {
      // This will be hooked to drag&drop directive later
      $log.debug('[LayoutV2 Sidebar] drag start', item);
    };
  }
})();

// app/main/apps/sitemap/layoutV2/sitemap-layout-v2.component.js
(function () {
  'use strict';

  angular
    .module('app.sitemap')
    .component('sitemapLayoutV2', {
      templateUrl: 'app/main/apps/sitemap/layoutV2/components/sitemap-layout-v2/sitemap-layout-v2.html',
      controller : SitemapLayoutV2Controller,
      bindings   : {
        page: '<'   // lo que ya tuvieses para la página actual
      }
    });

  /* @ngInject */
  function SitemapLayoutV2Controller(LayoutV2Store, LayoutV2Library, $log) {
    var vm = this;

    vm.$onInit = function () {
      // Modelo inicial a partir de la página
      vm.model   = LayoutV2Store.initFromPage(vm.page);
      // Librería para el sidebar (layouts/widgets/templates/elements)
      vm.library = LayoutV2Library;
      // Dispositivo por defecto para el canvas
      vm.device  = 'desktop';

      $log.debug('[LayoutV2] init', vm.model, vm.library);
    };

    // Drops que vienen del canvas (layouts a regiones, widgets a columnas, etc.)
    vm.handleDropOnCanvas = function (event) {
      vm.model = LayoutV2Store.applyDrop(vm.model, event);
    };

    // “Use” template desde la pestaña TEMPLATES del sidebar
    vm.handleApplyTemplate = function (template) {
      // Reutilizamos applyDrop pasando el template como payload
      vm.model = LayoutV2Store.applyDrop(vm.model, {
        region : 'content',
        payload: template       // type: 'template' dentro del propio objeto
      });
    };

    /**
     * Mover un layout dentro de una región (botones ↑ / ↓)
     */
    vm.moveLayout = function (region, index, offset) {
      if (!vm.model || !vm.model.regions || !vm.model.regions[region]) {
        return;
      }
      var newIndex = index + offset;
      vm.model = LayoutV2Store.moveLayout(vm.model, region, index, newIndex);
    };
  }
})();


// app/main/apps/sitemap/layoutV2/components/layout-v2-canvas/layout-v2-canvas.component.js
(function () {
  'use strict';

  angular
    .module('app.sitemap')
    .component('layoutV2Canvas', {
      templateUrl: 'app/main/apps/sitemap/layoutV2/components/layout-v2-canvas/layout-v2-canvas.html',
      controller: LayoutV2CanvasController,
      bindings: {
        model: '<',         // Layout model
        device: '<',        // 'desktop' | 'tablet' | 'phone'
        onDrop: '&?',       // callback({ $event })
        onMoveLayout: '&?'
      }
    });

  /* @ngInject */
  function LayoutV2CanvasController($mdDialog) {
    var vm = this;

    vm.$onInit = function () {

      vm.model = vm.model || {
        regions: {
          header: [],
          content: [],
          footer: []
        }
      };

      vm.device = vm.device || 'desktop';

      vm.theme = vm.theme || {
        background: '#ffffff',
        primary   : '#1976d2',
        secondary : '#555555',
        tertiary  : '#999999'
      }

    };

    vm.$onChanges = function (changes) {
      if (changes.device && !changes.device.isFirstChange()) {
        vm.device = changes.device.currentValue;
      }
    };

    // Generic drop handler: just bubble the event up
    vm.handleDrop = function (event) {
      if (angular.isFunction(vm.onDrop)) {
        vm.onDrop({ $event: event });
      }
    };

    vm.getBlocksForRegion = function (regionId) {
      var regions = (vm.model && vm.model.regions) || {};
      return regions[regionId] || [];
    };

    vm.editButton = function(widget){
      // Solo por seguridad
      if (!widget || widget.sourceId !== 'element-button') {
        return;
      }

      var initialConfig = angular.copy(widget.config || {
        text  : widget.label || 'Button',
        href  : '#',
        target: '_self'
      });

      $mdDialog.show({
        controller: ButtonDialogController,
        controllerAs: 'vm',
        templateUrl: 'app/main/apps/sitemap/layoutV2/components/layout-v2-canvas/layout-v2-button-dialog.html',
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          config: initialConfig
        }
      }).then(function (result) {
        // Guardar cambios en el widget
        widget.config = widget.config || {};
        widget.config.text   = result.text;
        widget.config.href   = result.href;
        widget.config.target = result.target;

        // Opcional: sincronizar el label del widget con el texto del botón
        widget.label = result.text || widget.label;
      }).catch(function () {
        // cancel -> no hacemos nada
      });
    };

    // Dialog controller
    /* @ngInject */
    function ButtonDialogController($mdDialog, config) {
      var vm = this;

      vm.form = config;
      vm.targets = ['_self', '_blank'];

      vm.save = function () {
        $mdDialog.hide(vm.form);
      };

      vm.cancel = function () {
        $mdDialog.cancel();
      };
    }

    // Mapea 'primary'|'secondary'|'tertiary' a color real de theme
    vm.resolveWidgetBg = function (widget) {
      if (!widget || !widget.style || !widget.style.bg) {
        return 'transparent';
      }
      return mapTokenToColor(widget.style.bg);
    };

    vm.resolveWidgetColor = function (widget) {
      if (!widget || !widget.style || !widget.style.color) {
        return 'inherit';
      }
      return mapTokenToColor(widget.style.color);
    };

    function mapTokenToColor(token) {
      switch (token) {
        case 'primary':   return vm.theme.primary;
        case 'secondary': return vm.theme.secondary;
        case 'tertiary':  return vm.theme.tertiary;
        default:          return 'transparent';
      }
    }

    vm.resolveWidgetAlignSelf = function (widget) {
      var align = widget && widget.style && widget.style.align ? widget.style.align : 'left';

      switch (align) {
        case 'center':
          return 'center';
        case 'right':
          return 'flex-end';
        case 'left':
        default:
          return 'flex-start';
      }
    };

    // Serializa {top,right,bottom,left} -> "Xpx Xpx Xpx Xpx"
    vm.serializeBox = function (box) {
      if (!box) {
        return '0 0 0 0';
      }
      return [
        (box.top    || 0) + 'px',
        (box.right  || 0) + 'px',
        (box.bottom || 0) + 'px',
        (box.left   || 0) + 'px'
      ].join(' ');
    };

    vm.editWidget = function (widget) {
      if (!widget) return;

      var initial = angular.copy(widget.style || {
        bg     : null,
        color  : null,
        width  : 100,
        margin : { top: 0, right: 0, bottom: 6, left: 0 },
        padding: { top: 6, right: 8, bottom: 6, left: 8 },
        align  : 'left'
      });

      $mdDialog.show({
        controller: WidgetStyleDialogController,
        controllerAs: 'vm',
        templateUrl: 'app/main/apps/sitemap/layoutV2/components/layout-v2-canvas/layout-v2-widget-style-dialog.html',
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          style: initial
        }
      }).then(function (result) {
        widget.style = result;
        
      }).catch(function () {
        // cancel
      });
    };

    /* @ngInject */
    function WidgetStyleDialogController($mdDialog, style) {
      var vm = this;

      vm.form = style;

      vm.save = function () {
        vm.form.width = clampNumber(vm.form.width, 1, 100);

        normalizeBox(vm.form.margin);
        normalizeBox(vm.form.padding);

        $mdDialog.hide(vm.form);
      };

      vm.cancel = function () {
        $mdDialog.cancel();
      };

      function clampNumber(val, min, max) {
        val = parseInt(val, 10);
        if (isNaN(val))  val = min;
        if (val < min)   val = min;
        if (val > max)   val = max;
        return val;
      }

      function normalizeBox(box) {
        if (!box) {
          box = {};
        }
        box.top    = parseInt(box.top, 10)    || 0;
        box.right  = parseInt(box.right, 10)  || 0;
        box.bottom = parseInt(box.bottom, 10) || 0;
        box.left   = parseInt(box.left, 10)   || 0;
      }
    }
  }
})();


(function () {
    'use strict';

    angular.module('app.users')
        .controller('mediaDialogControllerV2', mediaDialogControllerV2);

    /** @ngInject */
    function mediaDialogControllerV2($scope, $q, $rootScope, $document, $mdDialog, $mdMedia, $mdToast,
        $mdSidenav, $state, msApi, requestContext, $timeout,
        sharedFunctionsMailing, msUtils,
        $translate, sessionService, usersService, transformUsers, $stateParams,
        siteID, isAdmin, imagesToShow, imageSelected, imageSelectedCreatedAt, selectedUser, event, idEvent, client, apiUrl, images,
        eventVersion, RuntagEventService, $filter,
        cartEnabled, fetchProfilesForUser, assignPhotoToProfile) {

        var vm = this;
        vm.isAdmin = isAdmin;


        //functions
        vm.closeDialog = closeDialog;
        vm.changeImage = changeImage;
        vm.itsNotMe = itsNotMe;
        vm.closeEditUser = closeEditUser;
        vm.openEditUser = openEditUser;
        vm.searchEditUser = searchEditUser;
        vm.changeUserRecognized = changeUserRecognized;
        vm.addUserToImage = addUserToImage;
        vm.selectUserForAdd = selectUserForAdd;
        vm.closeProfilePicker = closeProfilePicker;
        vm.pickProfileForAssign = pickProfileForAssign;
        vm.editPerson = editPerson;
        vm.showFaceInfo = showFaceInfo;
        vm.lowQualitySharpnessClass = lowQualitySharpnessClass;
        vm.isSharpnessTierVisible = isSharpnessTierVisible;
        vm.toggleSharpnessTier = toggleSharpnessTier;
        vm.isLegendVisible = isLegendVisible;
        vm.toggleLegend = toggleLegend;
        vm.toggleSegments = toggleSegments;
        vm.toggleBoundingBoxes = toggleBoundingBoxes;
        vm.hoverSegment = hoverSegment;
        vm.clearHoveredSegment = clearHoveredSegment;
        vm.getPolygonPoints = getPolygonPoints;
        vm.getSegmentColor = getSegmentColor;
        vm.getKeypointList = getKeypointList;
        vm.searchByFace = searchByFace;
        vm.openJSON = openJSON;
        vm.downloadImage = downloadImage;
        vm.removeUnmatchedNumber = removeUnmatchedNumber;
        vm.addUnmatchedNumber = addUnmatchedNumber;
        vm.deleteChip = deleteChip;
        vm.formatDate = formatDate;
        vm.getUserNumber = getUserNumber;
        vm.updateWrapperStyle = updateWrapperStyle;
        //functions

        //variables
        vm.imageToShow = undefined;
        vm.selectedUser = selectedUser;
        vm.editUserDialog = false;
        vm.searchingUsers = false; // spinner mientras se busca el usuario en el modal edit-user
        vm.showJSON = false;
        vm.showingFaceInfo = false;
        vm.showSegments = false;
        vm.showBoundingBoxes = true;
        vm.sharpnessTierVisible = { t0: true, t1: true, t2: true, t3: true, t4: true };
        vm.legendVisible = { approved: true, ignored: true, rejected: true, USER_CLAIM: true, ADMIN_CLAIM: true, unmatchedNumber: true };
        vm.hoveredSegment = null;
        vm.imagesToShow = imagesToShow;
        vm.eventVersion = eventVersion;
        vm.cartEnabled = !!cartEnabled;   // en carrito, al elegir usuario se muestra su picker de perfiles
        vm.assignPicker = null;           // {user, profiles, loading, error, saving} mientras se elige perfil
        vm.loadingDownloads = false;
        vm.client = client;
        vm.wrapperStyle = {};
        //variables

        var siteID = requestContext.getParam("siteId");
        var section = requestContext.getParam("section");
        vm.tags = sessionService.site_operative.tags;

        init();
        function init() {
            selectedImage();
            if ($rootScope.reloadUser) {
                $rootScope.reloadUser = false;
            }

            // Keyboard arrow navigation
            function handleKeydown(e) {
                if (e.key === 'ArrowRight' || e.keyCode === 39) {
                    $scope.$apply(function () { changeImage('next'); });
                } else if (e.key === 'ArrowLeft' || e.keyCode === 37) {
                    $scope.$apply(function () { changeImage('previous'); });
                }
            }
            $document.on('keydown', handleKeydown);

            // Al redimensionar la ventana cambia la proporción del hueco, y con ella qué lado de la foto
            // manda: hay que recolocar el wrapper o los recuadros de las caras se quedan descuadrados.
            var ventana = angular.element(window);
            var recolocar = null;
            function alRedimensionar() {
                if (recolocar) { $timeout.cancel(recolocar); }
                recolocar = $timeout(function () {
                    recolocar = null;
                    updateWrapperStyle();   // usa el tamaño en caché, no vuelve a descargar la foto
                }, 150);
            }
            ventana.on('resize', alRedimensionar);

            $scope.$on('$destroy', function () {
                $document.off('keydown', handleKeydown);
                ventana.off('resize', alRedimensionar);
                if (recolocar) { $timeout.cancel(recolocar); }
            });
        }

        function formatDate(date, format) {
            var dateObject = new Date(date);
            return $filter('date')(dateObject, format);
        }

        function getUserNumber(user) {
            var ret = undefined;
            ensureParsed(user, 'user_params');
            let group = user.user_params?.events_data?.find(x => x.event_group_id === event);
            if (group) {
                ret = group.number;
            }
            return ret;
        }

        function openJSON() {
            vm.showJSON = !vm.showJSON;
        }

        function downloadImage() {
            var url      = vm.imageToShow.original || vm.imageToShow.urlImage;
            var filename = vm.imageToShow.mediaId  || url.split('/').pop();

            fetch(url)
                .then(function (res) { return res.blob(); })
                .then(function (blob) {
                    var a    = document.createElement('a');
                    a.href   = URL.createObjectURL(blob);
                    a.download = filename;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    URL.revokeObjectURL(a.href);
                })
                .catch(function () {
                    window.open(url, '_blank');
                });
        }

        function searchByFace() {
            vm.loadingSearchFaceId = true;
            var options = {
                apiUrl: apiUrl
            }
            switch (vm.eventVersion) {
                case 'v2':
                    options.version = vm.eventVersion;
                    options.faceId = vm.tagToEdit.face.faceId;
                    break;
                case 'v3':
                    options.version = vm.eventVersion;
                    options.faceId = vm.tagToEdit.face.faceId;
                    break;
                default:
                    options.face_id = vm.tagToEdit.face_id;
                    break;
            }
            RuntagEventService.searchByFacePablo(options).then(function (response) {
                if (response.length) {
                    response.map(x => {
                        var image = constructImage(x);
                        return image;
                    });
                    response = response.filter(x => x.reason != "PROFILE_PICTURE");
                    vm.loadingSearchFaceId = false;
                    $mdDialog.hide({
                        action: 'searchByFaceId',
                        data: response
                    });
                } else {
                    vm.loadingSearchFaceId = false;
                    $mdToast.show({
                        template: '<md-toast id="error" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-close" class="icon"></md-icon><span class="md-toast-text" flex>Not results</span></div></md-toast>',
                        hideDelay: 5000,
                        position: 'top',
                        parent: '#content-container'
                    });
                }
            });
        }

         function editPerson(tag) {
            vm.tagToEdit = tag;
        }

        function showFaceInfo() {
            vm.showingFaceInfo = true;
        }

        function sharpnessTier(tag) {
            var sharpness = tag.face && tag.face.quality && tag.face.quality.sharpness;
            if (sharpness <= 1) { return 't0'; }
            if (sharpness <= 2) { return 't1'; }
            if (sharpness <= 10) { return 't2'; }
            if (sharpness <= 20) { return 't3'; }
            return 't4';
        }

        function lowQualitySharpnessClass(tag) {
            return 'low-sharpness-' + sharpnessTier(tag);
        }

        function isSharpnessTierVisible(tag) {
            return !!vm.sharpnessTierVisible[sharpnessTier(tag)];
        }

        function toggleSharpnessTier(tier) {
            vm.sharpnessTierVisible[tier] = !vm.sharpnessTierVisible[tier];
        }

        // Resolves which legend category a bounding box belongs to.
        // isUnknown === true for tags coming from labels.unknownFaces.
        function legendCategory(tag, isUnknown) {
            var reason = tag.reason;
            if (reason === 'USER_CLAIM' || reason === 'USER_CLAIM_WITHOUT_FACE_ID') { return 'USER_CLAIM'; }
            if (reason === 'ADMIN_CLAIM' || reason === 'ADMIN_CLAIM_WITHOUT_FACE_ID') { return 'ADMIN_CLAIM'; }
            if (isUnknown) {
                return reason === 'IT_IS_NOT_ME' ? 'rejected' : 'ignored';
            }
            return tag.rejected ? 'rejected' : 'approved';
        }

        function isLegendVisible(tag, isUnknown) {
            return !!vm.legendVisible[legendCategory(tag, isUnknown)];
        }

        function toggleLegend(key) {
            vm.legendVisible[key] = !vm.legendVisible[key];
        }

        function toggleSegments() {
            vm.showSegments = !vm.showSegments;
            if (vm.showSegments) {
                prepareSegmentKeypoints(vm.imageToShow);
            }
        }

        function prepareSegmentKeypoints(image) {
            if (!image || !image.aiSegmentation) return;
            image.aiSegmentation.forEach(function (seg) {
                if (!seg.keypointList) {
                    seg.keypointList = getKeypointList(seg.keypoints);
                }
            });
        }

        function toggleBoundingBoxes() {
            vm.showBoundingBoxes = !vm.showBoundingBoxes;
        }

        function hoverSegment(seg) {
            vm.hoveredSegment = seg;
        }

        function clearHoveredSegment() {
            vm.hoveredSegment = null;
        }

        function getPolygonPoints(polygon) {
            return polygon.map(function (p) {
                return (p[0] * 100) + ',' + (p[1] * 100);
            }).join(' ');
        }

        // Returns an HSL color with hues evenly distributed across the full spectrum
        // so each person/segment gets a visually distinct colour.
        function getSegmentColor(index, total) {
            var hue = Math.round((index * 360) / (total || 1));
            return 'hsl(' + hue + ', 85%, 55%)';
        }

        // Converts the keypoints object { nose: [x,y], left_knee: [x,y], ... }
        // into a flat array, filtering out points outside the image bounds (0–1).
        function getKeypointList(keypoints) {
            if (!keypoints) return [];
            return Object.keys(keypoints).map(function (name) {
                var pt = keypoints[name];
                return { name: name, x: pt[0], y: pt[1] };
            }).filter(function (pt) {
                return pt.x >= 0 && pt.x <= 1 && pt.y >= 0 && pt.y <= 1;
            });
        }

        // Tamaño real de la foto, en caché para poder recolocar sin volver a descargarla.
        var tamanoNatural = null;
        var urlMedida = null;

        // El wrapper tiene que medir EXACTAMENTE lo que mide la foto pintada, porque los recuadros de las
        // caras se posicionan en % sobre él: cualquier franja negra los desplaza y los agranda.
        //
        // Qué lado manda se decide comparando la proporción de la FOTO con la del HUECO, no mirando si la
        // foto es apaisada. El hueco del diálogo es muy ancho y bajo (height: calc(90vh - 64px)), así que
        // una foto apaisada 3:2 sigue siendo más estrecha que él: al fijar width:100% por ser apaisada, la
        // altura se salía, max-height la recortaba y el ancho se quedaba clavado → el wrapper terminaba más
        // ancho que la foto, object-fit:contain metía barras negras a los lados y los recuadros aparecían
        // corridos. Comparando proporciones, el lado que manda nunca llega a tocar su max-* y el wrapper
        // coincide con la foto. Vale para los dos casos (apaisada en hueco ancho, vertical en hueco alto).
        function aplicarWrapperStyle(anchoNatural, altoNatural) {
            if (!anchoNatural || !altoNatural) {
                vm.wrapperStyle = {};
                return;
            }
            var hueco = $document[0].getElementById('image-container');
            var mandaElAncho;
            if (hueco && hueco.clientWidth > 0 && hueco.clientHeight > 0) {
                mandaElAncho = (anchoNatural / altoNatural) > (hueco.clientWidth / hueco.clientHeight);
            } else {
                // El hueco aún no está medido: se cae al criterio de orientación de siempre.
                mandaElAncho = anchoNatural > altoNatural;
            }
            vm.wrapperStyle = {
                'aspect-ratio': anchoNatural + ' / ' + altoNatural,
                'width': mandaElAncho ? '100%' : 'auto',
                'height': mandaElAncho ? 'auto' : '100%'
            };
        }

        function updateWrapperStyle() {
            if (!vm.imageToShow || !vm.imageToShow.urlImage) {
                vm.wrapperStyle = {};
                tamanoNatural = null;
                urlMedida = null;
                return;
            }
            if (tamanoNatural && urlMedida === vm.imageToShow.urlImage) {
                aplicarWrapperStyle(tamanoNatural.ancho, tamanoNatural.alto);
                return;
            }
            var img = new Image();
            img.onload = function () {
                $scope.$apply(function () {
                    tamanoNatural = { ancho: img.naturalWidth, alto: img.naturalHeight };
                    urlMedida = vm.imageToShow.urlImage;
                    aplicarWrapperStyle(img.naturalWidth, img.naturalHeight);
                });
            };
            img.src = vm.imageToShow.urlImage;
        }

        function removeUnmatchedNumber(tag) {
            var options = {
                apiUrl: apiUrl,
                mediaFile: vm.imageToShow.mediaId,
                createdAt: vm.imageToShow.createdAt
            }
            if (tag) {
                options.invalidNumber = tag.detectedText;
            } else {
                options.invalidNumber = vm.tagToEdit.detectedText;
            }
            RuntagEventService.removeUnmatchedNumber(options).then(function (response) {
                if (response.Item) {
                    var item = constructImage(response.Item);
                } else {
                    var item = constructImage(response);
                }
                vm.imagesToShow[vm.imagesToShow.findIndex(x => x.mediaId == item.mediaId)] = item;
                vm.imageToShow = item;
                closeEditUser();
            });
        }

        function addUnmatchedNumber() {
            removeUnmatchedNumber();
            addUserToImage('', vm.tagToEdit.detectedText);
        }

        function selectedImage() {
            // Referencia de la foto elegida. Preferimos createdAt (id único); mediaId/media_id como fallback.
            var selectedRef = { createdAt: imageSelectedCreatedAt || null, mediaId: imageSelected, media_id: imageSelected };
            for (var i = 0; i < vm.imagesToShow.length; i++) {
                if (!vm.imagesToShow[i].urlImage && vm.imagesToShow[i].crops) {
                    var selectedContainer = sessionService.getContainerByID(vm.imagesToShow[i].id_container);
                    if (selectedContainer.use_grid === 1) {
                        vm.imagesToShow[i].urlImage = selectedContainer.view_url + vm.imagesToShow[i].grid + '/' + vm.imagesToShow[i].fileName;
                    } else {
                        vm.imagesToShow[i].urlImage = selectedContainer.view_url + vm.imagesToShow[i].fileName;
                    }
                }
                switch (vm.eventVersion) {
                    case 'v2':
                        if (sameMedia(vm.imagesToShow[i], selectedRef)) {
                            if (!vm.imagesToShow[i].urlImage && !vm.imagesToShow[i].crops) {
                                vm.imageToshow = null;
                                let img = vm.imagesToShow[i];
                                RuntagEventService.getMediaIdPablo({
                                    apiUrl: apiUrl,
                                    version: 'v2',
                                    mediaId: img.mediaId
                                }).then(resp => {
                                    var variant = pickVariant(resp, img);
                                    const maxCrop = variant.crops.reduce((max, crop) => {
                                        return (crop.width > max.width) ? crop : max;
                                    }, variant.crops[0]);
                                    img.urlImage = maxCrop.url;
                                    vm.imageToShow = img;
                                    getFileDownloads();
                                });
                            } else {
                                vm.imageToShow = vm.imagesToShow[i];
                                updateWrapperStyle();
                                getFileDownloads();
                            }
                        }
                        break;
                    case 'v3':
                        if (sameMedia(vm.imagesToShow[i], selectedRef)) {
                            if (!vm.imagesToShow[i].urlImage && !vm.imagesToShow[i].crops) {
                                vm.imageToshow = null;
                                let img = vm.imagesToShow[i];
                                RuntagEventService.getMediaIdPablo({
                                    apiUrl: apiUrl,
                                    version: 'v2',
                                    mediaId: img.mediaId
                                }).then(resp => {
                                    var variant = pickVariant(resp, img);
                                    const maxCrop = variant.crops.reduce((max, crop) => {
                                        return (crop.width > max.width) ? crop : max;
                                    }, variant.crops[0]);
                                    img.urlImage = maxCrop.url;
                                    vm.imageToShow = img;
                                    getFileDownloads();
                                });
                            } else {
                                vm.imageToShow = vm.imagesToShow[i];
                                updateWrapperStyle();
                                getFileDownloads();
                            }
                        }
                        break;
                    default:
                        if (vm.imagesToShow[i].media_id == imageSelected) {
                            vm.imageToShow = vm.imagesToShow[i];
                            updateWrapperStyle();
                        }
                        break;
                }
                // if(!vm.imageToShow){
                //     vm.imageToShow = vm.imagesToShow[i];
                // }
            }
        }

        function getFileDownloads() {
            if (!vm.imageToShow.downloads) {
                vm.loadingDownloads = true;
                RuntagEventService.getFileDownloads(
                    {
                        domain: siteID,
                        filename: vm.imageToShow.mediaId,
                        event_id: idEvent,
                        event_group_id: event,
                        file_created_at: vm.imageToShow.createdAt
                    }
                ).then(response => {
                    vm.imageToShow.downloads = response;
                    vm.loadingDownloads = false;
                });
            }
        }

        function closeDialog() {
            $mdDialog.hide({
                action: 'closed',
                data: vm.imagesToShow
            });
        }

        function openEditUser(tag, type) {
            vm.editUserDialog = true;
            if (!vm.tagToEdit) {
                vm.tagToEdit = tag;
            }
            vm.editType = type;
        }

        function searchEditUser() {
            var options = {
                siteID: siteID,
                groupIds: event,
                searchStringFilter: vm.querySearch
            };
            vm.searchingUsers = true;
            usersService.getUsersByGroups(options).then(function (response) {
                if (response.result.total > 0) {
                    vm.querySearch = "";
                    angular.forEach(response.result.data, function (user) {
                        if (user.user_params) {
                            ensureParsed(user, 'user_params');
                            user.eventNumber = user.user_params?.events_data?.find(x => x.event_group_id == event)?.number;
                        } else {
                            user.eventNumber = user.current_number;
                        }
                    });
                    vm.usersToEdit = response.result.data;
                } else {
                    $mdToast.show({
                        template: '<md-toast layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-close" class="icon"></md-icon><span class="md-toast-text" flex>No results for ' + vm.querySearch + '</span></div></md-toast>',
                        hideDelay: 5000,
                        position: 'top',
                        parent: '#content-container'
                    });
                }
            }).finally(function () {
                vm.searchingUsers = false;
            });
        }

        function changeUserRecognized(user) {
            ensureParsed(user, 'user_params');
            var eventUser = user.user_params?.events_data?.find(x => x.event_group_id == event);
            var runnerNumber = "";
            var faceId = "";
            switch (vm.eventVersion) {
                case 'v2':
                    runnerNumber = vm.tagToEdit.runnerNumber.detectedText;
                    faceId = vm.tagToEdit.face.faceId;
                    break;
                case 'v3':
                    runnerNumber = vm.tagToEdit.runnerNumber.detectedText;
                    faceId = vm.tagToEdit.face.faceId;
                    break;
                default:
                    runnerNumber = vm.tagToEdit.runner_number;
                    faceId = vm.tagToEdit.face_id;
                    break;
            }
            if (runnerNumber.indexOf('unknown') == -1) {
                var options = {
                    apiUrl: apiUrl
                }
                switch (vm.eventVersion) {
                    case 'v2':
                        options.runnerNumber = runnerNumber;
                        options.faceId = faceId;
                        options.mediaFile = vm.imageToShow.mediaId;
                        options.createdAt = vm.imageToShow.createdAt;
                        options.version = 'v2';
                        break;
                    case 'v3':
                        options.runnerNumber = runnerNumber;
                        options.faceId = faceId;
                        options.mediaFile = vm.imageToShow.mediaId;
                        options.createdAt = vm.imageToShow.createdAt;
                        options.version = 'v2';
                        break;
                    default:
                        options.runner_number = runnerNumber;
                        options.face_id = faceId;
                        options.media_file = vm.imageToShow.media_id;
                        options.created_at = vm.imageToShow.created_at;
                        break;
                }
                RuntagEventService.notMePablo(options).then(function () {
                    addUserToImage(user);
                    var optionsFaces = {
                        apiUrl: apiUrl
                    }
                    switch (vm.eventVersion) {
                        case 'v2':
                            optionsFaces.version = 'v2';
                            optionsFaces.faceId = vm.tagToEdit.face.faceId;
                            break;
                        case 'v3':
                            optionsFaces.version = 'v2';
                            optionsFaces.faceId = vm.tagToEdit.face.faceId;
                            break;
                        default:
                            options.face_id = vm.tagToEdit.face_id;
                            break;
                    }
                    RuntagEventService.searchByFacePablo(optionsFaces).then(function (response) {
                        var newImages = [];
                        angular.forEach(response, function (image) {
                            switch (vm.eventVersion) {
                                case 'v2':
                                    var notAdd = image.labels.persons.find(x => x.runnerNumber == eventUser.number);
                                    break;
                                case 'v3':
                                    var notAdd = image.labels.persons.find(x => x.runnerNumber == eventUser.number);
                                    break;
                                default:
                                    var notAdd = image.labels.persons.find(x => x.runner_number == eventUser.number);
                                    break;
                            }
                            if (!notAdd) {
                                newImages.push(image);
                            }
                        });
                        if (newImages.length) {
                            var message = newImages.length > 1 ? $translate.instant('USERS.IN_EVENTS_TITLE_RESEARCH_PHOTOS_SINGULAR').replace(':X:', newImages.length) : $translate.instant('USERS.IN_EVENTS_TITLE_RESEARCH_PHOTOS_PLURAL').replace(':X:', newImages.length);
                            var confirm = $mdDialog.confirm()
                                .title('title')
                                .textContent(message)
                                .ariaLabel('title')
                                .ok('OK')
                                .multiple(true)
                                .cancel($translate.instant('CANCEL'));
                            $mdDialog.show(confirm).then(function () {
                                newImages.map(function (img) {
                                    constructImage(img);
                                });
                                vm.imagesToShow = newImages;
                                vm.imageToShow = vm.imagesToShow[0];
                            }).catch(function () {
                            });
                        }
                    });
                });
            } else {
                var options = {
                    apiUrl: apiUrl,
                    sort: 'desc',
                    limit: 250
                }
                switch (vm.eventVersion) {
                    case 'v2':
                        options.number = vm.tagToEdit.runnerNumber.detectedText;
                        break;
                    case 'v3':
                        options.number = vm.tagToEdit.runnerNumber.detectedText;
                        break;
                    default:
                        options.number = vm.tagToEdit.runner_number;
                        break;
                }
                RuntagEventService.getUserMediasPablo(options).then(function (response) {
                    addUserToImage(user);
                    var optionsFaces = {
                        apiUrl: apiUrl
                    }
                    switch (vm.eventVersion) {
                        case 'v2':
                            options.version = 'v2';
                            var newImages = response.data.filter(x => x.mediaId != vm.imageToShow.mediaId);
                            optionsFaces.faceId = vm.tagToEdit.face.faceId;
                            break;
                        case 'v3':
                            options.version = 'v2';
                            var newImages = response.data.filter(x => x.mediaId != vm.imageToShow.mediaId);
                            optionsFaces.faceId = vm.tagToEdit.face.faceId;
                            break;
                        default:
                            var newImages = response.data.filter(x => x.media_id != vm.imageToShow.media_id);
                            optionsFaces.face_id = vm.tagToEdit.face_id;
                            break;
                    }
                    RuntagEventService.searchByFacePablo(optionsFaces).then(function (response) {
                        angular.forEach(response, function (image) {
                            switch (vm.eventVersion) {
                                case 'v2':
                                    if (!newImages.find(x => x.mediaId == image.mediaId)) {
                                        var notAdd = image.labels.persons.find(x => x.runner_number == eventUser.number);
                                        if (!notAdd) {
                                            newImages.push(image);
                                        }
                                    }
                                    break;
                                case 'v3':
                                    if (!newImages.find(x => x.mediaId == image.mediaId)) {
                                        var notAdd = image.labels.persons.find(x => x.runner_number == eventUser.number);
                                        if (!notAdd) {
                                            newImages.push(image);
                                        }
                                    }
                                    break;
                                default:
                                    if (!newImages.find(x => x.media_id == image.media_id)) {
                                        var notAdd = image.labels.persons.find(x => x.runner_number == eventUser.number);
                                        if (!notAdd) {
                                            newImages.push(image);
                                        }
                                    }
                                    break;
                            }
                        });
                        if (newImages.length) {
                            var message = newImages.length > 1 ? $translate.instant('USERS.IN_EVENTS_TITLE_RESEARCH_PHOTOS_SINGULAR').replace(':X:', newImages.length) : $translate.instant('USERS.IN_EVENTS_TITLE_RESEARCH_PHOTOS_PLURAL').replace(':X:', newImages.length);
                            var confirm = $mdDialog.confirm()
                                .title('title')
                                .textContent(message)
                                .ariaLabel('title')
                                .ok('OK')
                                .multiple(true)
                                .cancel($translate.instant('CANCEL'));
                            $mdDialog.show(confirm).then(function () {
                                newImages.map(function (img) {
                                    constructImage(img);
                                });
                                vm.imagesToShow = newImages;
                                vm.imageToShow = vm.imagesToShow[0];
                            }).catch(function () {
                            });
                        }
                    });
                });
            }
        }

        function deleteChip(chip) {
            switch (chip.type) {
                case 'unmatchedNumber':
                    removeUnmatchedNumber(chip);
                    break;
                default:
                    itsNotMe(chip, true);
                    break;
            }
        }

        function itsNotMe(tag, rejected, user) {
            var options = {
                apiUrl: apiUrl
            }
            switch (vm.eventVersion) {
                case 'v2':
                    options.version = vm.eventVersion;
                    options.mediaFile = vm.imageToShow.mediaId;
                    options.createdAt = vm.imageToShow.createdAt;
                    if (vm.tagToEdit) {
                        options.faceId = vm.tagToEdit.face.faceId;
                    }
                    if (tag && tag.faceId) {
                        options.faceId = tag.faceId;
                    }
                    if (tag && tag.runnerNumber) {
                        options.runnerNumber = tag.runnerNumber.detectedText;
                    }
                    break;
                case 'v3':
                    options.version = vm.eventVersion;
                    options.mediaFile = vm.imageToShow.mediaId;
                    options.createdAt = vm.imageToShow.createdAt;
                    if (vm.tagToEdit) {
                        options.faceId = vm.tagToEdit.face.faceId;
                    }
                    if (tag && tag.face && tag.face.faceId) {
                        options.faceId = tag.face.faceId;
                    }
                    if (tag && tag.runnerNumber) {
                        options.runnerNumber = tag.runnerNumber.detectedText;
                    }
                    break;
                default:
                    options.media_file = vm.imageToShow.media_id;
                    options.created_at = vm.imageToShow.created_at;
                    if (vm.tagToEdit) {
                        options.face_id = vm.tagToEdit.face_id;
                    }
                    if (tag && tag.face_id) {
                        options.face_id = tag.face_id;
                    }
                    if (tag && tag.runner_number) {
                        options.runner_number = tag.runner_number;
                    }
                    break;
            }
            RuntagEventService.notMePablo(options).then(function (response) {
                let image = undefined;
                if (response.Item) {
                    image = constructImage(response.Item);
                } else {
                    image = constructImage(response);
                }
                vm.imageToShow = image;
                switch (vm.eventVersion) {
                    case 'v2':
                        var itemIndex = vm.imagesToShow.findIndex(x => x.mediaId === image.mediaId);
                        break;
                    case 'v3':
                        var itemIndex = vm.imagesToShow.findIndex(x => x.mediaId === image.mediaId);
                        break;
                    default:
                        var itemIndex = vm.imagesToShow.findIndex(x => x.media_id === image.media_id);
                        break;
                }
                vm.imagesToShow[itemIndex] = image;
                if (vm.selectedUser) {
                    var index = vm.selectedUser.newMedia.indexOf(image);
                    if (index) {
                        vm.selectedUser.newMedia.splice(index);
                    }
                }
                closeEditUser();
            })
        }

        function constructImage(item) {
            if (item.reason && item.reason == "PROFILE_PICTURE") {
                return null;
            }
            item.tags = [];
            item.ignored = [];

            var persons = item.labels?.persons;
            var unmatchedNumbers = item.labels?.unmatchedNumbers;

            switch (vm.eventVersion) {
                case 'v2':
                    var ignoredPersons = item.labels?.unknownFaces;
                    break;
                case 'v3':
                    var ignoredPersons = item.labels?.unknownFaces;
                    break;
                default:
                    var ignoredPersons = item.labels?.unknown_persons;
                    break;
            }

            if (unmatchedNumbers) {
                unmatchedNumbers.map(function (x) {
                    x.type = 'unmatchedNumber';
                    item.tags.push(x);
                    return x;
                });
            }

            if (persons) {
                for (var i = 0; i < persons.length; i++) {
                    if (persons[i] != null) {
                        switch (vm.eventVersion) {
                            case 'v2':
                                persons[i].id_user_face = item.mediaId;
                                break;
                            case 'v3':
                                persons[i].id_user_face = item.mediaId;
                                break;
                            default:
                                persons[i].id_user_face = item.media_id;
                                break;
                        }
                        item.tags.push(persons[i]);
                    }
                }
            }

            if (ignoredPersons && ignoredPersons.length > 0) {
                for (var i = 0; i < ignoredPersons.length; i++) {
                    if (ignoredPersons[i] != null) {
                        switch (vm.eventVersion) {
                            case 'v2':
                                var person = {
                                    boundingBox: {}
                                }
                                if (ignoredPersons[i].face) {
                                    person.boundingBox = ignoredPersons[i].face.boundingBox;
                                    item.ignored.push(person);
                                }
                                break;
                            case 'v3':
                                var person = {
                                    boundingBox: {}
                                }
                                if (ignoredPersons[i].face) {
                                    person.boundingBox = ignoredPersons[i].face.boundingBox;
                                    item.ignored.push(person);
                                }
                                break;
                            default:
                                if (ignoredPersons[i].label && ignoredPersons[i].label.BoundingBox) {
                                    var person = {
                                        BoundingBox: ignoredPersons[i].label.BoundingBox
                                    }
                                    item.ignored.push(person);
                                }
                                break;
                        }
                    }
                }
            }

            if (item.crops && item.crops.length) {
                item.preview = item.crops.find(x => x.id == 1001).url;
                item.urlImage = item.crops.find(x => x.id == 11015).url;
                const currentClient = vm.client;
                if (!isValidUrl(item.preview)) {
                    item.preview = currentClient.prefix_photos_url + item.preview;
                }
                if (!isValidUrl(item.urlImage)) {
                    item.urlImage = currentClient.prefix_photos_url + item.urlImage;
                }
            }

            switch (vm.eventVersion) {
                case 'v2':
                    item.createdAtTransform = transformDate(item.createdAt);
                    break;
                case 'v3':
                    item.createdAtTransform = transformDate(item.createdAt);
                    break;
                default:
                    item.createdAtTransform = transformDate(item.created_at);
                    break;
            }
            return item;
        }

        function isValidUrl(url) {
            try {
                new URL(url);
                return true;
            } catch (err) {
                return false;
            }
        }

        function addUserToImage(user, number) {
            if (user) {
                ensureParsed(user, 'user_params');
                var eventUserNumber = user.user_params?.events_data?.find(x => x.event_group_id == event)?.number;
            }
            var options = {
                apiUrl: apiUrl
            }
            switch (vm.eventVersion) {
                case 'v2':
                    options.faceId = user ? (vm.tagToEdit ? vm.tagToEdit.face.faceId : null) : null,
                        options.runnerNumber = user ? eventUserNumber : number;
                    options.mediaFile = vm.imageToShow.mediaId;
                    options.createdAt = vm.imageToShow.createdAt;
                    options.version = vm.eventVersion;
                    break;
                case 'v3':
                    options.faceId = user ? (vm.tagToEdit ? vm.tagToEdit.face.faceId : null) : null,
                        options.runnerNumber = user ? eventUserNumber : number;
                    options.mediaFile = vm.imageToShow.mediaId;
                    options.createdAt = vm.imageToShow.createdAt;
                    options.version = vm.eventVersion;
                    break;
                default:
                    options.face_id = vm.tagToEdit ? vm.tagToEdit.face_id : null,
                        options.runner_number = eventUserNumber;
                    options.media_file = vm.imageToShow.media_id;
                    options.created_at = vm.imageToShow.created_at;
                    break;
            }
            RuntagEventService.changeFacePablo(options).then(function (response) {
                let image = undefined;
                if (response.Item) {
                    image = constructImage(response.Item);
                } else {
                    image = constructImage(response);
                }
                vm.imageToShow = image;
                switch (vm.eventVersion) {
                    case 'v2':
                        var itemIndex = vm.imagesToShow.findIndex(x => x.mediaId === image.mediaId);
                        break;
                    case 'v3':
                        var itemIndex = vm.imagesToShow.findIndex(x => x.mediaId === image.mediaId);
                        break;
                    default:
                        var itemIndex = vm.imagesToShow.findIndex(x => x.media_id === image.media_id);
                        break;
                }
                vm.imagesToShow[itemIndex] = image;
                closeEditUser();
            });
        }

        // ── Carrito: al elegir un usuario, mostrar sus perfiles para elegir a cuál asignar la foto ──
        function selectUserForAdd(user) {
            if (vm.cartEnabled && fetchProfilesForUser) {
                openProfilePicker(user);
            } else {
                addUserToImage(user, false); // eventos normales: asigna al dorsal propio como siempre
            }
        }

        function openProfilePicker(user) {
            vm.assignPicker = { user: user, profiles: null, loading: true, error: false, saving: false };
            fetchProfilesForUser(user)
                .then(function (profiles) { if (vm.assignPicker) { vm.assignPicker.profiles = profiles || []; } })
                .catch(function () { if (vm.assignPicker) { vm.assignPicker.error = true; } })
                .finally(function () { if (vm.assignPicker) { vm.assignPicker.loading = false; } });
        }

        function closeProfilePicker() { vm.assignPicker = null; }

        function pickProfileForAssign(profile) {
            if (!vm.assignPicker || vm.assignPicker.saving || !assignPhotoToProfile) { return; }
            var user = vm.assignPicker.user;
            var createdAt = vm.imageToShow ? (vm.imageToShow.createdAt || vm.imageToShow.created_at) : null;
            var mediaId = vm.imageToShow ? (vm.imageToShow.mediaId || vm.imageToShow.media_id) : null;
            if (!createdAt) { return; }
            vm.assignPicker.saving = true;
            assignPhotoToProfile(user, profile.dorsal, createdAt, mediaId)
                .then(function () {
                    $mdToast.show($mdToast.simple().textContent('Foto asignada al perfil.').position('top right').hideDelay(2500));
                    closeProfilePicker();
                    closeEditUser();
                    $rootScope.reloadUser = true;
                })
                .catch(function () {
                    if (vm.assignPicker) { vm.assignPicker.saving = false; }
                    $mdToast.show($mdToast.simple().textContent('No se pudo asignar la foto.').position('top right').hideDelay(2500));
                });
        }

        function transformDate(date) {
            var dateToReturn = date;

            dateToReturn = dateToReturn.split("_")[0];

            return dateToReturn;
        }

        function closeEditUser() {
            vm.editUserDialog = false;
            vm.showJSON = false;
            vm.showingFaceInfo = false;
            vm.tagToEdit = undefined;
            vm.usersToEdit = [];
            vm.editType = undefined;
            vm.commentsToShow = undefined;
        }

        // El id ÚNICO de una foto es createdAt (mediaId/nombre de fichero puede repetirse entre fotos distintas).
        // Comparamos por createdAt cuando existe; si no (v1 antiguo), caemos a media_id/mediaId.
        function sameMedia(a, b) {
            if (!a || !b) return false;
            if (a.createdAt && b.createdAt) return a.createdAt === b.createdAt;
            if (a.media_id && b.media_id) return a.media_id === b.media_id;
            return a.mediaId === b.mediaId;
        }

        // getMediaIdPablo(mediaId) puede devolver varias variantes (mismo nombre, distinta foto). Elegimos la que
        // coincide por createdAt con la que estamos mostrando; si no hay createdAt, la primera (comportamiento previo).
        function pickVariant(resp, img) {
            if (!resp || !resp.length) return null;
            if (img && img.createdAt) {
                var match = resp.find(function (r) { return r.createdAt === img.createdAt; });
                if (match) return match;
            }
            return resp[0];
        }

        function changeImage(param) {
            closeEditUser();
            vm.commentsToShow = undefined;
            var total = vm.imagesToShow.length - 1;
            var position = 0;
            for (var i = 0; i < vm.imagesToShow.length; i++) {
                // Identidad por createdAt: con mediaId (nombre) varias fotos casaban y position acababa siendo
                // siempre la última coincidencia → next/prev se movían sin relación con la foto mostrada.
                if (sameMedia(vm.imagesToShow[i], vm.imageToShow)) {
                    position = i;
                    break;
                }
            }
            switch (param) {
                case "next":
                    position++;
                    if (position > total) {
                        position = 0;
                    }
                    break;
                case "previous":
                    position = position - 1;
                    if (position < 0) {
                        position = total;
                    }
                    break;
            }
            updateWrapperStyle();
            finishChangeImage(position);
        }

        function finishChangeImage(position) {
            if (!vm.imagesToShow[position].urlImage) {
                vm.imageToShow = null;
                let img = vm.imagesToShow[position];
                RuntagEventService.getMediaIdPablo({
                    apiUrl: apiUrl,
                    version: 'v2',
                    mediaId: img.mediaId
                }).then(resp => {
                    var variant = pickVariant(resp, img);
                    const maxCrop = variant.crops.reduce((max, crop) => {
                        return (crop.width > max.width) ? crop : max;
                    }, variant.crops[0]);
                    img.urlImage = maxCrop.url;
                    vm.imageToShow = img;
                    updateWrapperStyle();
                    getFileDownloads();
                    if (vm.showSegments) prepareSegmentKeypoints(img);
                });
            } else {
                vm.imageToShow = vm.imagesToShow[position];
                updateWrapperStyle();
                getFileDownloads();
                if (vm.showSegments) prepareSegmentKeypoints(vm.imageToShow);
            }
        }

        function ensureParsed(obj, field) {
            if (!obj || !obj[field] || typeof obj[field] !== 'string') return !!obj._corrupted;
            
            try {
                let parsed = angular.fromJson(obj[field]);
                if (parsed !== obj[field]) {
                    if (typeof parsed === 'string') {
                        // It was double encoded!
                        obj._corrupted = true;
                        obj[field] = parsed;
                        return ensureParsed(obj, field);
                    } else {
                        // Normal single encoded JSON
                        obj[field] = parsed;
                    }
                }
            } catch (e) {}
            return !!obj._corrupted;
        }
    }
})();
(function () {
    'use strict';

    angular.module('app.users')
        .controller('searchByFaceModalController', searchByFaceModalController);

    /** @ngInject */
    function searchByFaceModalController($mdDialog, $scope, $http, $timeout, siteID, section, event, apiUrl, uploadService, RuntagEventService) {

        var vm = this;

        //functions
        vm.closeDialog = closeDialog;
        //functions

        //variables
        vm.file = undefined;
        vm.uploading = false;
        vm.recognizing = false;
        vm.searching = false;
        vm.facesFound = undefined;
        vm.error = undefined;
        vm.noResults = false;
        $scope.log = '';
        //variables
        init();
        function init(){
            console.log('siteID', siteID);
            console.log('event', event);
            console.log('section', section);
            console.log('apiUrl', apiUrl);
        }

        vm.reset = function() {
            vm.file = undefined;
            vm.uploading = false;
            vm.recognizing = false;
            vm.searching = false;
            vm.facesFound = undefined;
            vm.error = undefined;
            vm.noResults = false;
        };

        vm.selectFace = function(face) {
            vm.searchFaces(face.faceId);
        };

        vm.handleCanvasClick = function(event) {
            if (!vm.facesFound || vm.facesFound.length === 0) return;

            const canvas = document.getElementById('facesCanvas');
            const rect = canvas.getBoundingClientRect();
            const scaleX = canvas.width / rect.width;
            const scaleY = canvas.height / rect.height;
            const clickX = (event.clientX - rect.left) * scaleX;
            const clickY = (event.clientY - rect.top) * scaleY;

            // Check if click is inside any face bounding box
            for (let i = 0; i < vm.facesFound.length; i++) {
                const face = vm.facesFound[i];
                const bbox = face.boundingBox;
                const x = bbox.left * canvas.width;
                const y = bbox.top * canvas.height;
                const width = bbox.width * canvas.width;
                const height = bbox.height * canvas.height;

                if (clickX >= x && clickX <= x + width &&
                    clickY >= y && clickY <= y + height) {
                    console.log('Selected face:', face.faceId);
                    vm.searchFaces(face.faceId);
                    return;
                }
            }
        };

        vm.drawFacesOnCanvas = function() {
            if (!vm.facesFound || vm.facesFound.length === 0 || !vm.uploadedImage) return;

            const canvas = document.getElementById('facesCanvas');
            if (!canvas) return;

            const ctx = canvas.getContext('2d');
            const img = vm.uploadedImage;

            // Calculate scaling to fit in container
            const maxWidth = 800;
            const maxHeight = 600;
            let scale = 1;

            if (img.width > maxWidth || img.height > maxHeight) {
                const scaleX = maxWidth / img.width;
                const scaleY = maxHeight / img.height;
                scale = Math.min(scaleX, scaleY);
            }

            // Set canvas size scaled appropriately
            canvas.width = img.width * scale;
            canvas.height = img.height * scale;

            // Draw image scaled
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

            // Draw bounding boxes and face IDs
            vm.facesFound.forEach(function(face, index) {
                const bbox = face.boundingBox;
                const x = bbox.left * canvas.width;
                const y = bbox.top * canvas.height;
                const width = bbox.width * canvas.width;
                const height = bbox.height * canvas.height;

                // Draw rectangle
                ctx.strokeStyle = '#00BCD4';
                ctx.lineWidth = 3;
                ctx.strokeRect(x, y, width, height);

                // Draw semi-transparent background for text
                const labelText = '#' + (index + 1) + ' (' + Math.round(face.confidence) + '%)';
                const fontSize = 14;
                ctx.font = 'bold ' + fontSize + 'px Arial';
                const textMetrics = ctx.measureText(labelText);
                const textWidth = textMetrics.width + 8;

                ctx.fillStyle = 'rgba(0, 188, 212, 0.8)';
                ctx.fillRect(x - 2, y - fontSize - 8, textWidth, fontSize + 8);

                // Draw text
                ctx.fillStyle = '#FFFFFF';
                ctx.fillText(labelText, x + 2, y - 2);
            });
        };

        vm.searchFaces = function(faceId) {
            vm.facesFound = undefined;
            vm.noResults = false;
            vm.searching = true;

            const searchOptions = {
                faceId: faceId,
                apiUrl: apiUrl,
                version: event.version ? event.version.toLowerCase() : 'v1'
            };

            RuntagEventService.searchByFacePablo(searchOptions).then(function(results) {
                console.log('=== SEARCH RESULTS FROM API ===');
                console.log('Search results:', results);

                // Transform results to match the expected format
                const transformedResults = transformSearchResults(results);

                console.log('=== TRANSFORMED RESULTS ===');
                console.log('Transformed results:', transformedResults);
                console.log('First item preview:', transformedResults[0] ? transformedResults[0].preview : 'undefined');
                console.log('First item crops:', transformedResults[0] ? transformedResults[0].crops : 'undefined');

                // Sin coincidencias: no cerramos el modal, mostramos el mensaje.
                if (!transformedResults || transformedResults.length === 0) {
                    vm.searching = false;
                    vm.noResults = true;
                    return;
                }

                $mdDialog.hide({
                    action: 'search_completed',
                    items: transformedResults,
                    faceId: faceId
                });
            }).catch(function(err) {
                console.error('Error in searchByFacePablo', err);
                vm.searching = false;
                vm.error = 'Error al buscar fotos similares.';
            });
        };

        function transformSearchResults(results) {
            return results.map(function(item) {
                // Extract S3 bucket info from original URL
                // Format: https://[bucket].s3.amazonaws.com/media/prefix/filename.jpg
                var s3BaseUrl = '';
                if (item.original && item.original.startsWith('http')) {
                    var originalUrl = new URL(item.original);
                    s3BaseUrl = originalUrl.protocol + '//' + originalUrl.hostname;
                }

                // Find the preview crop (400x400) and high_res crop (2048x2048)
                var previewCrop = item.crops ? item.crops.find(function(crop) { return crop.width === 400; }) : null;
                var highResCrop = item.crops ? item.crops.find(function(crop) { return crop.width === 2048; }) : null;

                // Build full S3 URLs for crops
                var getFullUrl = function(cropUrl) {
                    if (!cropUrl) return item.original;
                    if (cropUrl.startsWith('http')) return cropUrl;
                    // Crop URLs are like /media/prefix/filename.jpg, need to construct S3 URL
                    return s3BaseUrl + cropUrl;
                };

                var previewUrl = previewCrop ? getFullUrl(previewCrop.url) : item.original;
                var urlImage = highResCrop ? getFullUrl(highResCrop.url) : item.original;

                // Parse createdAt timestamp
                var createdAtTransform = item.createdAt ? item.createdAt.split('_')[0] : '';

                // Extract tags from labels.persons
                var tags = item.labels && item.labels.persons ? item.labels.persons : [];

                // Extract ignored faces (unknownFaces bounding boxes)
                var ignored = item.labels && item.labels.unknownFaces
                    ? item.labels.unknownFaces.map(function(face) { return { boundingBox: face.face.boundingBox }; })
                    : [];

                var result = {};
                for (var key in item) {
                    if (item.hasOwnProperty(key)) {
                        result[key] = item[key];
                    }
                }
                // STRING URLs (not objects) - this is what the template expects
                result.preview = previewUrl;
                result.urlImage = urlImage;
                result.id_media = item.mediaId;
                result.createdAtTransform = createdAtTransform;
                result.tags = tags;
                result.ignored = ignored;

                return result;
            });
        }

        $scope.$watch('vm.file', function (newFile) {
            if (newFile && !newFile.$error) {
                vm.uploading = true;
                vm.error = undefined;
                vm.facesFound = undefined;

                // Read file as data URL for local preview
                const reader = new FileReader();
                reader.onload = function(e) {
                    const img = new Image();
                    img.onload = function() {
                        vm.uploadedImage = img;

                        var uploadOptions = {
                            mediaName: vm.file.name.replace(/[^a-zA-Z0-9._-]/g, ''),
                            apiUrl: apiUrl,
                            version: event.version,
                            siteID: siteID // V2: qiu-api firma el presigned al bucket 'runtag' del tenant
                        };

                        RuntagEventService.getPresignedLambda(uploadOptions).then(function(presignedResp) {
                            if (presignedResp.uploadUrl && presignedResp.objectKey) {
                                // 1. Upload file to S3 using native XHR to bypass AngularJS interceptors
                                var xhr = new XMLHttpRequest();
                                xhr.open('PUT', presignedResp.uploadUrl, true);

                                xhr.onload = function () {
                                    if (xhr.status === 200 || xhr.status === 204) {
                                        $scope.$apply(function () {
                                            vm.uploading = false;
                                            vm.recognizing = true;

                                            // 2. Process image with add_profile endpoint
                                            // v2: POST {base}/v2/add_profile with prefix in body (no prefix in path)
                                            // v3+: POST {base}/v3/{prefix}/add_profile (prefix already in apiUrl)
                                            var addProfileVersion = event.version ? event.version.toLowerCase() : 'v1';
                                            var addProfilePrefix = apiUrl.substring(apiUrl.lastIndexOf('/') + 1);
                                            var addProfileUrl = addProfileVersion === 'v2'
                                                ? apiUrl.substring(0, apiUrl.lastIndexOf('/')) + '/add_profile'
                                                : apiUrl + '/add_profile';
                                            var recognitionXhr = new XMLHttpRequest();
                                            recognitionXhr.open('POST', addProfileUrl, true);
                                            recognitionXhr.setRequestHeader('Content-Type', 'application/json');

                                            recognitionXhr.onload = function () {
                                                $scope.$apply(function () {
                                                    vm.recognizing = false;
                                                    if (recognitionXhr.status === 200 || recognitionXhr.status === 422) {
                                                        try {
                                                            var profileResp = JSON.parse(recognitionXhr.responseText);
                                                            console.log('profileResp', profileResp);

                                                            // Normalize the 200 response across versions:
                                                            // v3 returns { detections: [{faceId, confidence, boundingBox}, ...] }
                                                            // v2 returns { success: true, faceId } for a single detected face
                                                            var detections = profileResp.detections;
                                                            if (!detections && profileResp.success && profileResp.faceId) {
                                                                detections = [{ faceId: profileResp.faceId, confidence: 100, boundingBox: null }];
                                                            }

                                                            // Handle successful face detection
                                                            if (recognitionXhr.status === 200 && detections && detections.length > 0) {
                                                                if (detections.length === 1) {
                                                                    // Single face found, proceed to search
                                                                    vm.searchFaces(detections[0].faceId);
                                                                } else {
                                                                    // Multiple faces found, show selection UI
                                                                    vm.facesFound = detections.map(function(detection) {
                                                                        return {
                                                                            faceId: detection.faceId,
                                                                            confidence: detection.confidence,
                                                                            boundingBox: detection.boundingBox
                                                                        };
                                                                    });
                                                                    // Draw canvas with faces
                                                                    $timeout(function() {
                                                                        vm.drawFacesOnCanvas();
                                                                    }, 100);
                                                                }
                                                            } else if (recognitionXhr.status === 422 && profileResp.reason) {
                                                                // Handle 422 response with multiple faces
                                                                if (profileResp.reason === 'MORE_THAN_ONE_PERSON_FOUND' && profileResp.faces) {
                                                                    vm.facesFound = profileResp.faces.map(function(detection) {
                                                                        return {
                                                                            faceId: detection.faceId,
                                                                            confidence: detection.confidence,
                                                                            boundingBox: detection.boundingBox
                                                                        };
                                                                    });
                                                                    // Draw canvas with faces
                                                                    $timeout(function() {
                                                                        vm.drawFacesOnCanvas();
                                                                    }, 100);
                                                                } else {
                                                                    vm.error = profileResp.reason || 'No se han detectado caras en la foto.';
                                                                }
                                                            } else {
                                                                vm.error = 'No se han detectado caras en la foto.';
                                                            }
                                                        } catch (e) {
                                                            console.error('Error parsing recognition response', e);
                                                            vm.error = 'Error al procesar la respuesta del reconocimiento.';
                                                        }
                                                    } else {
                                                        console.error('Recognition error status:', recognitionXhr.status);
                                                        vm.error = 'Error en el reconocimiento facial (Status: ' + recognitionXhr.status + ').';
                                                    }
                                                });
                                            };

                                            recognitionXhr.onerror = function () {
                                                $scope.$apply(function () {
                                                    vm.recognizing = false;
                                                    vm.error = 'Error de red en el reconocimiento facial.';
                                                });
                                            };

                                            var addProfileBody = {
                                                imagePath: presignedResp.objectKey,
                                                createdAt: new Date().toISOString(),
                                                runnerNumber: 'temp_search_' + Date.now(),
                                                saveToDB: false
                                            };
                                            if (addProfileVersion === 'v2') {
                                                // v2 needs the prefix in the body since it is not in the path
                                                addProfileBody.prefix = addProfilePrefix;
                                            }
                                            recognitionXhr.send(JSON.stringify(addProfileBody));
                                        });
                                    } else {
                                        $scope.$apply(function () {
                                            vm.uploading = false;
                                            vm.error = 'Error al subir la imagen a S3 (Status: ' + xhr.status + ').';
                                        });
                                    }
                                };

                                xhr.onerror = function () {
                                    $scope.$apply(function () {
                                        vm.uploading = false;
                                        vm.error = 'Error de red al intentar subir a S3.';
                                    });
                                };

                                xhr.send(vm.file);
                            } else {
                                console.error('Invalid presigned response', presignedResp);
                                vm.uploading = false;
                                vm.error = 'Error al generar la URL de subida.';
                            }
                        }).catch(function(err) {
                            console.error('Error getting presigned URL', err);
                            vm.uploading = false;
                            vm.error = 'Error al conectar con el servicio de subida.';
                        });
                    };
                    img.onerror = function() {
                        console.error('Error loading image');
                        vm.uploadedImage = null;
                    };
                    img.src = e.target.result;
                };
                reader.readAsDataURL(vm.file);
            }
        });

        function closeDialog(){
            $mdDialog.hide({
                action: 'closed'
            })
        }
    }
})();
(function () {
    'use strict';

    angular.module('app.users').directive('qiuJsonTree', qiuJsonTree);

    function qiuJsonTree() {

        function escapeHtml(str) {
            return String(str)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;');
        }

        function buildNode(value, depth, seen) {
            depth = depth || 0;
            seen  = seen  || new WeakSet();

            if (value === null)      return '<span class="jt-null">null</span>';
            if (value === undefined) return '<span class="jt-null">undefined</span>';

            var type = typeof value;

            if (type === 'boolean') return '<span class="jt-bool">' + value + '</span>';
            if (type === 'number')  return '<span class="jt-number">' + value + '</span>';
            if (type === 'string')  return '<span class="jt-string">&quot;' + escapeHtml(value) + '&quot;</span>';

            // Guard: circular reference or excessive depth
            if (seen.has(value)) return '<span class="jt-null">[Circular]</span>';
            if (depth > 30)      return '<span class="jt-null">[MaxDepth]</span>';
            seen.add(value);

            var isArr = Array.isArray(value);
            // Skip Angular internal keys ($$hashKey, $$ watchers, etc.)
            var keys  = Object.keys(value).filter(function (k) { return k.indexOf('$$') !== 0 && k.indexOf('$') !== 0; });
            var open  = isArr ? '[' : '{';
            var close = isArr ? ']' : '}';

            if (keys.length === 0) {
                seen.delete(value);
                return '<span class="jt-bracket">' + open + close + '</span>';
            }

            var html = '<span class="jt-collapsible" data-collapsed="false">';

            // toggle row
            html += '<span class="jt-toggle">';
            html +=   '<span class="jt-caret">&#9660;</span>';
            html +=   '<span class="jt-bracket">' + open + '</span>';
            html +=   '<span class="jt-summary">' + keys.length + (isArr ? ' item' : ' key') + (keys.length !== 1 ? 's' : '') + '</span>';
            html += '</span>';

            // children
            html += '<div class="jt-children">';
            keys.forEach(function (key, i) {
                html += '<div class="jt-item">';
                if (!isArr) {
                    html += '<span class="jt-key">&quot;' + escapeHtml(key) + '&quot;</span>';
                    html += '<span class="jt-colon">:&nbsp;</span>';
                }
                html += buildNode(value[key], depth + 1, seen);
                if (i < keys.length - 1) html += '<span class="jt-comma">,</span>';
                html += '</div>';
            });
            html += '</div>';

            html += '<span class="jt-bracket jt-close">' + close + '</span>';
            html += '</span>'; // .jt-collapsible

            seen.delete(value);
            return html;
        }

        return {
            restrict: 'E',
            scope: { value: '=' },
            link: function (scope, element) {

                element.addClass('qiu-json-tree');

                // Render when the value arrives (async data) and on each reference change
                scope.$watch('value', function (newVal) {
                    if (newVal === undefined || newVal === null) return;
                    element.html(buildNode(newVal));
                });

                // Event delegation — one listener for the whole tree
                element[0].addEventListener('click', function (e) {
                    var toggle = e.target.closest('.jt-toggle');
                    if (!toggle) return;
                    var collapsible = toggle.parentElement;
                    var collapsed   = collapsible.getAttribute('data-collapsed') === 'true';
                    collapsible.setAttribute('data-collapsed', !collapsed);
                });
            }
        };
    }

})();

(function () {
	'use strict';

	angular
		.module('app.runtag', [])
		.config(config)
		.run(toolbarTitle);

	/**
	 * Título de la barra superior en TODAS las pantallas de Runtag: "Runtag > <sección>".
	 * Va aquí, atado al cambio de estado, y no en cada controlador: Sales y Organizer no lo fijaban y se
	 * quedaban con el título de la pantalla de la que vinieras (o en blanco al entrar por URL). Una vista
	 * nueva solo tiene que añadir su estado a este mapa.
	 * La ficha de evento lo reescribe luego con "> <nombre del evento>" al abrir uno.
	 */
	/** @ngInject */
	function toolbarTitle($rootScope, $translate) {
		var SECCIONES = {
			'app.site_overview.runtag.runtag_events': 'RUNTAG.EVENTS',
			'app.site_overview.runtag.runtag_events-old': 'RUNTAG.EVENTS',
			'app.site_overview.runtag.runtag_sales': 'RUNTAG.SALES',
			'app.site_overview.runtag.runtag_sales-old': 'RUNTAG.SALES',
			'app.site_overview.runtag.runtag_commercial': 'RUNTAG.COMMERCIAL',
			'app.site_overview.runtag.runtag_organizer': 'RUNTAG.ORGANIZER',
			'app.site_overview.runtag.runtag_support': 'RUNTAG.SUPPORT'
		};
		var BASE = '<span class="material-symbols-outlined">directions_run</span> Runtag';
		var claveActual = null;

		function pintar() {
			if (claveActual === null) { return; }
			$rootScope.global = $rootScope.global || {};
			$rootScope.global.titleToolbar = claveActual
				? (BASE + ' > ' + $translate.instant(claveActual))
				: BASE;
		}

		$rootScope.$on('$stateChangeSuccess', function (event, toState) {
			if (!toState || !toState.name || toState.name.indexOf('app.site_overview.runtag') !== 0) {
				claveActual = null;
				return;
			}
			claveActual = SECCIONES[toState.name] || '';
			pintar();
		});

		// Entrando por URL directa, las traducciones de Runtag (partial) pueden no haber llegado todavía
		// cuando cambia el estado: sin esto el título se quedaría con la clave literal (RUNTAG.EVENTS).
		$rootScope.$on('$translateChangeSuccess', pintar);
		$rootScope.$on('$translatePartialLoaderStructureChanged', pintar);
	}

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

		$stateProvider.state('app.runtag', {
			url: '/runtag',
			views: {
				'content@app': {
					templateUrl: 'app/main/apps/runtag/runtag.html',
					controller: 'RuntagController as vm'
				}
			},
			bodyClass: 'content'
		});

		$stateProvider
			.state('app.site_overview.runtag', {
				abstract: true,
				url: '/runtag',
				onEnter: function ($stateParams) {

				},
				data: {
					displayName: '{{section}}'
				},
				resolve: {
					section: function ($stateParams) {
						return $stateParams.section
					},
				},
			});

		$stateProvider
			.state('app.site_overview.runtag.runtag_sales-old', {
				url: '/sales-old',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/runtag/sales/sales.html',
						controller: 'RuntagSalesController as vm'
					}
				},
				onEnter: function ($stateParams) {
				},
				data: {
					displayName: '{{section}}'
				},
				resolve: {
					section: function ($stateParams) {
						return $stateParams.section
					},
				},
			})
			.state('app.site_overview.runtag.runtag_sales', {
				url: '/sales',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/runtag/sales/sales-v2.html',
						controller: 'RuntagSalesV2Controller as vm'
					}
				},
				onEnter: function ($stateParams) {
				},
				data: {
					displayName: '{{section}}'
				},
				resolve: {
					section: function ($stateParams) {
						return $stateParams.section
					},
				},
			})
            .state('app.site_overview.runtag.runtag_commercial', {
				url: '/commercial',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/runtag/commercial/commercial.html',
						controller: 'RuntagSalesV2Controller as vm'
					}
				},
				onEnter: function ($stateParams) {
				},
				data: {
					displayName: '{{section}}'
				},
				resolve: {
					section: function ($stateParams) {
						return $stateParams.section
					},
				},
			})
            .state('app.site_overview.runtag.runtag_events-old', {
				url: '/event-old',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/runtag/event/event.html',
						controller: 'RuntagEventController as vm'
					}
				},
				onEnter: function ($stateParams) {
				},
				data: {
					displayName: '{{section}}'
				},
				resolve: {
					section: function ($stateParams) {
						return $stateParams.section
					},
				},
			})
            .state('app.site_overview.runtag.runtag_events', {
				url: '/event',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/runtag/event/event_v2.html',
						controller: 'RuntagEventControllerV2 as vm'
					}
				},
				onEnter: function ($stateParams) {
				},
				data: {
					displayName: '{{section}}'
				},
				resolve: {
					section: function ($stateParams) {
						return $stateParams.section
					},
				},
			})
			.state('app.site_overview.runtag.runtag_support', {
				url: '/support',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/runtag/support/support.html',
						controller: 'RuntagSupportController as vm'
					}
				},
				onEnter: function ($stateParams) {
				},
				data: {
					displayName: '{{section}}'
				},
				resolve: {
					section: function ($stateParams) {
						return $stateParams.section
					},
				},
			})
			.state('app.site_overview.runtag.runtag_organizer', {
				url: '/organizer',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/runtag/organizer/organizer.html',
						controller: 'RuntagOrganizerController as vm'
					}
				},
				onEnter: function ($stateParams) {
				},
				data: {
					displayName: '{{section}}'
				},
				resolve: {
					section: function ($stateParams) {
						return $stateParams.section
					},
				},
			})

		$translatePartialLoaderProvider.addPart('app/main/apps/runtag');

	}
})();

(function () {
    'use strict';

    angular.module('app.runtag')
        .controller('reprocessModalController', reprocessModalController);

    /** @ngInject */
    function reprocessModalController($mdDialog, status) {

        var vm = this;
        
        //functions
        vm.closeDialog = closeDialog;
        //functions
        
        //variables
        vm.status = status;
        //variables

        function closeDialog(cont) {
            $mdDialog.hide(cont);
		}

    }
})();
(function () {
    'use strict';

    angular.module('app.users')
        .controller('addTransactionsController', addTransactionsController);

    /** @ngInject */
    function addTransactionsController($scope, $rootScope, $document, $mdDialog, $mdMedia, $mdToast,
                                    $mdSidenav, $state, msApi, requestContext, $timeout,
                                    RuntagEventService, sharedFunctionsMailing, msUtils,
                                    $translate, sessionService, usersService, transformUsers, $stateParams,
                                    user, siteID, event, client, order, paymentMethods,
                                    cartEnabled, profiles, ensureProfilePhotos, profileLabel) {

        var vm = this;

        //functions
        vm.cancelAddTransaction = cancelAddTransaction;
        vm.saveAddTransaction = saveAddTransaction;
        // carrito
        vm.onCartProductChange = onCartProductChange;
        vm.onCartProfileChange = onCartProfileChange;
        vm.onCartModeChange = onCartModeChange;
        vm.toggleCartPhoto = toggleCartPhoto;
        vm.cartSelectedCount = cartSelectedCount;
        vm.cartCanSave = cartCanSave;
        //functions

        //variables
        vm.paymentMethods = paymentMethods;
        vm.products = [];
        vm.product = undefined;
        vm.selectedSubsec = '2';
        vm.isAdmin = false;
        // carrito
        vm.cartEnabled = !!cartEnabled;
        vm.cartProfiles = [];      // [{ ref, dorsal, label, is_face }]
        vm.cartProfile = undefined;
        vm.cartMode = 'all';       // 'all' = todas las fotos del perfil | 'photos' = fotos concretas
        vm.cartUnassigned = false; // compra SUELTA (sin perfil) → se asigna después (como una preventa)
        vm.cartPhotos = [];        // [{ id, created_at, thumb, selected }]
        vm.cartPhotosLoading = false;
        vm.cartPrice = undefined;
        //variables

        init();
        function init(){
            vm.isAdmin = sessionService.user.is_admin;
            vm.order = angular.copy(order);
            vm.paymentMethods.forEach((method) => {
                (method.products || []).forEach((product) => {
                    vm.products.push(product);
                });
            });
            if(vm.order){
                vm.product = vm.products.find(x => x.id === vm.order.product);
            }
            vm.user = user;
            vm.currentDate = moment().format('YYYY-MM-DD HH:mm:00');

            // Eventos de carrito: perfiles del usuario disponibles para asignar la compra.
            if (vm.cartEnabled) {
                vm.cartProfiles = (profiles || []).filter(function (p) { return p && p.dorsal != null && p.dorsal !== ''; })
                    .map(function (p) {
                        return {
                            ref: p,
                            dorsal: String(p.dorsal),
                            dorsalNumber: p.dorsalNumber || null,
                            is_face: !!p.is_face,
                            label: (profileLabel ? profileLabel(p) : (p.name || ('#' + p.dorsal)))
                        };
                    });
                if (vm.order) { initCartFromOrder(); } // editar: pre-rellenar perfil/modo/fotos/precio/estado
            }
        }

        // Reconstruye el estado editable (perfil, modo, fotos, precio, estado) desde el files de la orden.
        // Órdenes viejas "sin fotos" (files vacío) quedan sin preselección → el admin puede asignarlas ahora.
        function initCartFromOrder() {
            var f = vm.order.files;
            if (angular.isString(f)) { try { f = JSON.parse(f); } catch (e) { f = null; } }
            // Orden SUELTA (compra sin perfil, marcador unassigned) → reflejar el estado del checkbox.
            if (f && !angular.isArray(f) && f.unassigned === true) { vm.cartUnassigned = true; }
            var dorsal = null, mode = 'all', boughtCA = {};
            var type = (f && !angular.isArray(f) && f.type) || '';
            if (type === 'profile_cart') {
                var r0 = (f.runners || [])[0];
                mode = 'all'; dorsal = r0 && r0.dorsal;
            } else if (type === 'mixed_cart') {
                var allRunner = (f.runners || []).filter(function (x) { return x && (x.items_total === null || x.items_total === undefined); })[0];
                if (allRunner) { mode = 'all'; dorsal = allRunner.dorsal; }
                else {
                    mode = 'photos';
                    var phs = f.photos || [];
                    dorsal = phs.length ? phs[0].dorsal : null;
                    phs.forEach(function (p) { if (p && p.created_at) { boughtCA[String(p.created_at)] = true; } });
                }
            } else if (angular.isArray(f)) { // legacy: array de fotos sueltas
                mode = 'photos';
                dorsal = f.length ? f[0].dorsal : null;
                f.forEach(function (p) { if (p && p.created_at) { boughtCA[String(p.created_at)] = true; } });
            }
            vm.cartMode = mode;
            vm._editBoughtCA = boughtCA;
            if (dorsal != null && dorsal !== '') {
                vm.cartProfile = vm.cartProfiles.filter(function (x) { return x.dorsal === String(dorsal); })[0] || null;
            }
            vm.selectedSubsec = String(vm.order.id_subsec);
            vm.cartPrice = vm.order.price;
            var pid = vm.order.id_product || vm.order.product;
            vm.product = vm.products.filter(function (x) { return x.id === pid; })[0] || vm.product;
            if (vm.cartMode === 'photos' && vm.cartProfile) { loadCartPhotos(); }
        }

        function cancelAddTransaction() {
            $mdDialog.cancel();
        }

        // ── Carrito ──────────────────────────────────────────────────────────────────────
        function onCartProductChange() {
            // Precio por defecto = precio del producto elegido (el admin puede sobreescribirlo).
            if (vm.product) { vm.cartPrice = vm.product.price; }
        }

        function onCartProfileChange() {
            vm.cartPhotos = [];
            vm._editBoughtCA = null; // cambiar de perfil invalida la preselección de la orden editada
            if (vm.cartMode === 'photos') { loadCartPhotos(); }
        }

        function onCartModeChange() {
            if (vm.cartMode === 'photos' && vm.cartProfile) { loadCartPhotos(); }
        }

        function loadCartPhotos() {
            if (!vm.cartProfile || !ensureProfilePhotos) { return; }
            if (vm.cartPhotos.length) { return; } // ya cargadas para este perfil
            vm.cartPhotosLoading = true;
            ensureProfilePhotos(vm.cartProfile.ref)
                .then(function (photos) {
                    var bought = vm._editBoughtCA || {};
                    vm.cartPhotos = (photos || [])
                        .map(function (m) {
                            var ca = (m.created_at || m.createdAt) || null;
                            return {
                                id: (m.mediaId || m.media_id) || null,
                                created_at: ca,
                                thumb: (m.preview || m.thumb) || null,
                                // Editar: preseleccionar las fotos que ya cubría la orden.
                                selected: !!(ca && bought[String(ca)])
                            };
                        })
                        .filter(function (p) { return p.created_at || p.id; });
                })
                .finally(function () { vm.cartPhotosLoading = false; });
        }

        function toggleCartPhoto(p) { if (p) { p.selected = !p.selected; } }

        function cartSelectedCount() {
            return (vm.cartPhotos || []).filter(function (p) { return p.selected; }).length;
        }

        function cartCanSave() {
            // Compra SUELTA (sin perfil): basta producto (crear) o la propia orden (editar). Se asigna después.
            if (vm.cartUnassigned) { return !!(vm.order || vm.product); }
            if (!vm.cartProfile) { return false; }
            // Al CREAR hace falta producto (da moneda/precio); al EDITAR salen de la propia orden.
            if (!vm.order && !vm.product) { return false; }
            return vm.cartMode === 'all' || cartSelectedCount() > 0;
        }

        function buildCartOrder() {
            // ¿La orden que se edita venía de una PREVENTA? Preservar el marcador al reescribir el files
            // (si no, al reasignarla desde qiusystem dejaría de reconocerse como preventa). OJO: vm.order.files
            // puede llegar como STRING (initCartFromOrder parsea en local, no reescribe vm.order.files).
            var of = vm.order ? vm.order.files : null;
            if (angular.isString(of)) { try { of = JSON.parse(of); } catch (e) { of = null; } }
            var wasPresale = !!(of && !angular.isArray(of) && (of.presale === true ||
                (angular.isArray(of.runners) && of.runners.some(function (r) { return r && r.presale === true; }))));
            var files, itemsTotal;
            if (vm.cartUnassigned) {
                // Compra SUELTA (sin perfil): se comporta como una preventa sin asignar. La asigna luego el
                // corredor (web) o el admin. Marcador `unassigned:true` → getUnassignedPresalesForEvent la
                // detecta; runners vacío + items_total no-null ⇒ NO autoriza descargas hasta que se asigne.
                files = { type: 'profile_cart', presale: true, unassigned: true, runners: [] };
                itemsTotal = 1;
            } else if (vm.cartMode === 'all') {
                // Pack "todas las fotos" del perfil → profile_cart (items_total=null ⇒ all_photos).
                var dorsal = String(vm.cartProfile.dorsal);
                files = { type: 'profile_cart', runners: [{
                    dorsal: dorsal,
                    display_name: vm.cartProfile.label,
                    is_primary: false,
                    purchased: true,
                    all_photos: true,
                    items_total: null,
                    product_name: (vm.product && vm.product.product) || ''
                }] };
                if (wasPresale) { files.presale = true; files.runners[0].presale = true; }
                itemsTotal = 1;
            } else {
                // Fotos concretas → mixed_cart.photos[] (cada foto lleva su dorsal).
                var dorsalP = String(vm.cartProfile.dorsal);
                var sel = (vm.cartPhotos || []).filter(function (p) { return p.selected; });
                files = { type: 'mixed_cart', runners: [], photos: sel.map(function (p) {
                    return { id: p.id || null, created_at: p.created_at || null, dorsal: dorsalP, thumb: p.thumb || null };
                }) };
                if (wasPresale) { files.presale = true; }
                itemsTotal = sel.length;
            }
            // Moneda/producto: del producto elegido; si no hay (edición), de la propia orden.
            var currency = vm.product ? vm.product.currency_code : (vm.order ? vm.order.currency_code : null);
            var productId = vm.product ? vm.product.id : (vm.order ? (vm.order.id_product || vm.order.product) : null);
            var price = (vm.cartPrice !== undefined && vm.cartPrice !== null && vm.cartPrice !== '')
                ? Number(vm.cartPrice)
                : (vm.product ? vm.product.price : (vm.order ? vm.order.price : 0));
            return {
                created_at: vm.currentDate,
                id_subsec: parseInt(vm.selectedSubsec, 10),
                id_event: event.id_events,
                id_client: event.id_client,
                id_commercial: client ? client.id_commercial : null,
                id_payment_method: 10, // manual
                id_product: productId,
                user_id: user.id_user,
                user_email: user.email,
                user_name: (user.firstname || '') + ' ' + (user.lastname || ''),
                price: price,
                original_price: price,
                items_total: itemsTotal,
                currency_code: currency,
                tags: [],
                // files como OBJETO (qiu-api lo serializa; misma vía que buildAssignedProfileOrder).
                files: files
            };
        }

        function saveAddTransaction() {
            // ── Editar ──
            if (vm.order) {
                if (vm.cartEnabled) {
                    // Carrito: reconstruir el files (perfil/modo/fotos) y actualizar, preservando el resto de columnas.
                    if (!cartCanSave()) { return; }
                    var built = buildCartOrder();
                    var item = angular.copy(vm.order);
                    item.id_subsec = built.id_subsec;
                    item.price = built.price;
                    item.original_price = built.price;
                    item.items_total = built.items_total;
                    item.currency_code = built.currency_code;
                    item.id_product = built.id_product;
                    item.files = built.files; // objeto (qiu-api lo serializa)
                    RuntagEventService.updateOrder({ siteID: siteID, item: item, id: vm.order.id_orders })
                        .then(function () { $rootScope.changeView = 'shopping'; $mdDialog.hide(); });
                    return;
                }
                vm.order.id_subsec = parseInt(vm.order.id_subsec);
                RuntagEventService.updateOrder({ siteID: siteID, item: vm.order, id: vm.order.id_orders })
                    .then(function () { $rootScope.changeView = 'shopping'; $mdDialog.hide(); });
                return;
            }

            // ── Crear ──
            var newTransaction;
            if (vm.cartEnabled) {
                if (!cartCanSave()) { return; }
                newTransaction = buildCartOrder();
            } else {
                newTransaction = {
                    created_at: vm.currentDate,
                    id_subsec: parseInt(vm.selectedSubsec),
                    id_event: event.id_events,
                    id_client: event.id_client,
                    id_commercial: client.id_commercial,
                    id_payment_method: 10,
                    user_id: user.id_user,
                    id_product: vm.product.id,
                    price: vm.product.price,
                    items_total: vm.product.items_total,
                    tags: [],
                    user_email: user.email,
                    user_name: user.firstname + " " + user.lastname,
                    currency_code: vm.product.currency_code
                };
            }
            RuntagEventService.createOrder({ siteID: siteID, item: newTransaction })
                .then(function () { $rootScope.changeView = 'shopping'; $mdDialog.hide(); });
        }

    }
})();

(function () {
  'use strict';

  angular.module('app.runtag')
    .controller('EventNumbersDialogController', EventNumbersDialogController);

    /**@ngInject */
    function EventNumbersDialogController($mdDialog, $q, eventNumbers, userId, groupId){
        const dlg = this;

        // Work-copy para no mutar el array original hasta "Guardar"
        dlg.items = (eventNumbers || []).map(x => angular.copy(x));

        // Añadir un nuevo registro
        dlg.add = function(){
          dlg.items.push({
            id: null,
            event_group_id: groupId,
            number: '',
            label: ''
          });
        };

        // Eliminar visualmente (si existe en backend, marcamos para borrar)
        dlg.remove = function(idx){
          const item = dlg.items[idx];
          if (item?.id) item._delete = true; // marcamos para delete en el guardado
          else dlg.items.splice(idx, 1);      // nuevos sin id: se quitan del array
        };

        // Cerrar sin cambios
        dlg.cancel = function(){ $mdDialog.cancel(); };

        // Guardar: upserts + deletes
        dlg.save = function(){
          $mdDialog.hide(dlg.items);
        };
    }

})();

(function () {
    'use strict';

    /**
     * Photo delivery form ("photoForm") for free-photo events.
     *
     * The visitor finds their photos (selfie / number) and, before the photos are delivered, answers a
     * short form configured per event. This service owns the editor model and the JSON contract that
     * is stored in event_info.photoForm and consumed by the public Runtag web.
     */
    angular.module('app.runtag')
        .factory('RuntagPhotoFormService', RuntagPhotoFormService);

    /** @ngInject */
    function RuntagPhotoFormService() {
        var SCHEMA_VERSION = 1;

        var LANGUAGES = ['es', 'en', 'fr'];

        // Order matters: it is the order of the "add question" menu. Translate key: TYPES.<TYPE uppercased>.
        var QUESTION_TYPES = [
            { type: 'yes_no', icon: 'thumbs_up_down' },
            { type: 'single_choice', icon: 'radio_button_checked' },
            { type: 'multiple_choice', icon: 'check_box' },
            { type: 'short_text', icon: 'short_text' },
            { type: 'long_text', icon: 'notes' },
            { type: 'email', icon: 'alternate_email' }
        ];

        var CHOICE_TYPES = ['single_choice', 'multiple_choice'];
        var TEXT_TYPES = ['short_text', 'long_text', 'email'];
        // Types whose answer can drive a "show only if" condition.
        var CONDITION_SOURCE_TYPES = ['yes_no', 'single_choice', 'multiple_choice'];

        var YES_NO_VALUES = ['yes', 'no'];

        return {
            SCHEMA_VERSION: SCHEMA_VERSION,
            LANGUAGES: LANGUAGES,
            QUESTION_TYPES: QUESTION_TYPES,
            YES_NO_VALUES: YES_NO_VALUES,
            createForm: createForm,
            fromSaved: fromSaved,
            createQuestion: createQuestion,
            createOption: createOption,
            isChoice: isChoice,
            isText: isText,
            canBeConditionSource: canBeConditionSource,
            conditionOperatorFor: conditionOperatorFor,
            removeQuestion: removeQuestion,
            moveQuestion: moveQuestion,
            conditionIssue: conditionIssue,
            validate: validate,
            toJson: toJson
        };

        function newId(prefix) {
            return prefix + '_' + Math.random().toString(36).substr(2, 6);
        }

        // Always an object keyed by language code; tolerates a plain string from older/hand-made data.
        function i18nText(value, lang) {
            if (value && typeof value === 'object' && !Array.isArray(value)) { return angular.copy(value); }
            var out = {};
            if (typeof value === 'string' && value) { out[lang] = value; }
            return out;
        }

        function createForm() {
            return {
                version: SCHEMA_VERSION,
                enabled: false,
                defaultLanguage: 'es',
                screens: {
                    intro: { title: {}, text: {} },
                    outro: { title: {}, text: {}, linkUrl: '', linkLabel: {} }
                },
                questions: []
            };
        }

        // Editor model from a previously saved photoForm (event_info.photoForm). Unknown keys are dropped.
        function fromSaved(saved) {
            var form = createForm();
            if (!saved || typeof saved !== 'object') { return form; }
            var lang = LANGUAGES.indexOf(saved.defaultLanguage) !== -1 ? saved.defaultLanguage : 'es';
            var screens = saved.screens || {};
            var intro = screens.intro || {};
            var outro = screens.outro || {};

            form.enabled = !!saved.enabled;
            form.defaultLanguage = lang;
            form.screens.intro = { title: i18nText(intro.title, lang), text: i18nText(intro.text, lang) };
            form.screens.outro = {
                title: i18nText(outro.title, lang),
                text: i18nText(outro.text, lang),
                linkUrl: outro.linkUrl || '',
                linkLabel: i18nText(outro.linkLabel, lang)
            };
            form.questions = (Array.isArray(saved.questions) ? saved.questions : []).filter(function (q) {
                return q && QUESTION_TYPES.some(function (t) { return t.type === q.type; });
            }).map(function (q) {
                var question = createQuestion(q.type);
                question.id = q.id || question.id;
                question.required = !!q.required;
                question.label = i18nText(q.label, lang);
                if (isText(q.type)) { question.placeholder = i18nText(q.placeholder, lang); }
                if (isChoice(q.type)) {
                    question.options = (Array.isArray(q.options) ? q.options : []).map(function (o) {
                        return { id: o.id || newId('o'), label: i18nText(o.label, lang) };
                    });
                    question.allowOther = !!q.allowOther;
                    question.otherLabel = i18nText(q.otherLabel, lang);
                }
                if (q.type === 'email') { question.useForDelivery = !!q.useForDelivery; }
                if (q.showIf && q.showIf.questionId) {
                    question.hasCondition = true;
                    question.showIf = { questionId: q.showIf.questionId, value: q.showIf.value };
                }
                return question;
            });
            return form;
        }

        function createQuestion(type, form) {
            var question = {
                id: newId('q'),
                type: type,
                required: type === 'email',
                label: {},
                hasCondition: false,
                showIf: { questionId: null, value: null }
            };
            if (isText(type)) { question.placeholder = {}; }
            if (isChoice(type)) {
                question.options = [createOption(), createOption()];
                question.allowOther = false;
                question.otherLabel = {};
            }
            if (type === 'email') {
                // The first email question is the one used to send the photos.
                question.useForDelivery = !(form && form.questions.some(function (q) { return q.useForDelivery; }));
            }
            return question;
        }

        function createOption() {
            return { id: newId('o'), label: {} };
        }

        function isChoice(type) { return CHOICE_TYPES.indexOf(type) !== -1; }
        function isText(type) { return TEXT_TYPES.indexOf(type) !== -1; }
        function canBeConditionSource(question) { return !!question && CONDITION_SOURCE_TYPES.indexOf(question.type) !== -1; }

        // A multiple-choice answer is a list, so it "includes" the value; the rest are single values.
        function conditionOperatorFor(sourceQuestion) {
            return sourceQuestion && sourceQuestion.type === 'multiple_choice' ? 'includes' : 'equals';
        }

        // Removing a question also drops the conditions that depended on it.
        function removeQuestion(form, index) {
            var removed = form.questions.splice(index, 1)[0];
            if (!removed) { return; }
            form.questions.forEach(function (q) {
                if (q.showIf && q.showIf.questionId === removed.id) {
                    q.hasCondition = false;
                    q.showIf = { questionId: null, value: null };
                }
            });
        }

        function moveQuestion(form, index, delta) {
            var target = index + delta;
            if (target < 0 || target >= form.questions.length) { return; }
            var question = form.questions.splice(index, 1)[0];
            form.questions.splice(target, 0, question);
        }

        function hasText(i18n, lang) {
            return !!(i18n && typeof i18n[lang] === 'string' && i18n[lang].trim());
        }

        /**
         * Problems that would make the form unusable on the public web. Returned as translate keys +
         * params so the dialog can show them and the log stays readable.
         */
        function validate(form) {
            var issues = [];
            var lang = form.defaultLanguage;
            var deliveryCount = 0;

            form.questions.forEach(function (q, i) {
                var n = i + 1;
                if (!hasText(q.label, lang)) {
                    issues.push({ key: 'NO_LABEL', params: { n: n, lang: lang } });
                }
                if (isChoice(q.type)) {
                    var choices = q.options.length + (q.allowOther ? 1 : 0);
                    if (choices < 2) { issues.push({ key: 'FEW_OPTIONS', params: { n: n } }); }
                    if (q.options.some(function (o) { return !hasText(o.label, lang); })) {
                        issues.push({ key: 'EMPTY_OPTION', params: { n: n, lang: lang } });
                    }
                }
                if (q.type === 'email' && q.useForDelivery) { deliveryCount++; }
                var conditionProblem = conditionIssue(form, q);
                if (conditionProblem) { issues.push(conditionProblem); }
            });

            if (form.questions.length && deliveryCount === 0) { issues.push({ key: 'NO_DELIVERY_EMAIL', params: {} }); }
            if (deliveryCount > 1) { issues.push({ key: 'MANY_DELIVERY_EMAILS', params: {} }); }
            if (form.screens.outro.linkUrl && !/^https?:\/\//i.test(form.screens.outro.linkUrl)) {
                issues.push({ key: 'BAD_LINK', params: {} });
            }
            return issues;
        }

        /**
         * What is wrong with a question's "show only if" condition, or null. Reordering never touches
         * conditions, so a question can end up depending on one that now comes AFTER it
         * (CONDITION_ORDER); it is kept as is so moving the question back fixes it.
         */
        function conditionIssue(form, question) {
            if (!question.hasCondition) { return null; }
            var index = form.questions.indexOf(question);
            var n = index + 1;
            var sourceIndex = findIndex(form.questions, question.showIf.questionId);
            var source = form.questions[sourceIndex];
            if (!source || !canBeConditionSource(source)) {
                return { key: 'CONDITION_MISSING', params: { n: n } };
            }
            if (sourceIndex >= index) {
                return { key: 'CONDITION_ORDER', params: { n: n, m: sourceIndex + 1 } };
            }
            if (!conditionValueExists(source, question.showIf.value)) {
                return { key: 'CONDITION_VALUE', params: { n: n } };
            }
            return null;
        }

        function findIndex(questions, id) {
            for (var i = 0; i < questions.length; i++) {
                if (questions[i].id === id) { return i; }
            }
            return -1;
        }

        function conditionValueExists(source, value) {
            if (source.type === 'yes_no') { return YES_NO_VALUES.indexOf(value) !== -1; }
            if (value === 'other') { return !!source.allowOther; }
            return source.options.some(function (o) { return o.id === value; });
        }

        // Keeps only languages with content, so the stored JSON has no empty {"en": ""} noise.
        function cleanText(i18n) {
            var out = {};
            LANGUAGES.forEach(function (l) {
                if (hasText(i18n, l)) { out[l] = i18n[l].trim(); }
            });
            return out;
        }

        function collectLanguages(value, found) {
            if (!value || typeof value !== 'object') { return; }
            Object.keys(value).forEach(function (k) {
                if (LANGUAGES.indexOf(k) !== -1 && typeof value[k] === 'string') { found[k] = true; }
                else { collectLanguages(value[k], found); }
            });
        }

        /**
         * The JSON exactly as it is stored in event_info.photoForm and read by the public Runtag web.
         * Editor-only flags (hasCondition, $$hashKey…) never leave this function.
         */
        function toJson(form) {
            var questions = form.questions.map(function (q) {
                var out = {
                    id: q.id,
                    type: q.type,
                    required: !!q.required,
                    label: cleanText(q.label)
                };
                if (isText(q.type)) { out.placeholder = cleanText(q.placeholder); }
                if (isChoice(q.type)) {
                    out.options = q.options.map(function (o) { return { id: o.id, label: cleanText(o.label) }; });
                    out.allowOther = !!q.allowOther;
                    if (q.allowOther) { out.otherLabel = cleanText(q.otherLabel); }
                }
                if (q.type === 'email') { out.useForDelivery = !!q.useForDelivery; }
                var source = null;
                if (q.hasCondition && q.showIf.questionId) {
                    source = form.questions[findIndex(form.questions, q.showIf.questionId)];
                }
                out.showIf = source ? {
                    questionId: source.id,
                    operator: conditionOperatorFor(source),
                    value: q.showIf.value
                } : null;
                return out;
            });

            var json = {
                version: SCHEMA_VERSION,
                enabled: !!form.enabled,
                defaultLanguage: form.defaultLanguage,
                languages: [],
                screens: {
                    intro: { title: cleanText(form.screens.intro.title), text: cleanText(form.screens.intro.text) },
                    outro: {
                        title: cleanText(form.screens.outro.title),
                        text: cleanText(form.screens.outro.text),
                        linkUrl: (form.screens.outro.linkUrl || '').trim(),
                        linkLabel: cleanText(form.screens.outro.linkLabel)
                    }
                },
                questions: questions
            };

            var found = {};
            collectLanguages({ screens: json.screens, questions: questions }, found);
            found[form.defaultLanguage] = true;
            json.languages = LANGUAGES.filter(function (l) { return found[l]; });
            return json;
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.runtag')
        .controller('newEventModalController', newEventModalController);

    /** @ngInject */
    function newEventModalController($scope, $q, $rootScope, $document, $mdDialog, $mdMedia, $mdToast,
        $mdSidenav, $state, msApi, requestContext, $timeout, msUtils,
        $translate, sessionService, usersService, $stateParams,
        siteID, RuntagEventService, $filter, clients, paymentMethods, selectedEvent,
        products, apiUrl, uploadService, mediaService, $log, RuntagPhotoFormService) {

        var vm = this;

        //functions
        vm.closeDialog = closeDialog;
        vm.formatDate = formatDate;
        vm.selectProduct = selectProduct;
        vm.selectPhotographer = selectPhotographer;
        vm.selectLocation = selectLocation;
        vm.cancelProduct = cancelProduct;
        vm.cancelPhotographer = cancelPhotographer;
        vm.cancelLocation = cancelLocation;
        vm.saveProduct = saveProduct;
        vm.savePhotographer = savePhotographer;
        vm.saveLocation = saveLocation;
        vm.deleteLocation = deleteLocation;
        vm.saveEvent = saveEvent;
        vm.editRegex = editRegex;
        vm.cancelRegexOption = cancelRegexOption;
        vm.saveRegexOption = saveRegexOption;
        vm.deleteRegexOption = deleteRegexOption;
        vm.generateRegex = generateRegex;
        vm.triggerFileInput = triggerFileInput;
        vm.generateFolderPath = generateFolderPath;
        vm.generateBucket = generateBucket;
        vm.filteredPhotographers = filteredPhotographers;
        vm.clearSearch = clearSearch;
        vm.deletePhotographer = deletePhotographer;
        vm.notInEventPhotographers = notInEventPhotographers;
        vm.notInEventProducts = notInEventProducts;
        vm.changeClient = changeClient;
        vm.downloadPhotographerData = downloadPhotographerData;
        vm.selectDiscountCode = selectDiscountCode;
        vm.cancelDiscountCode = cancelDiscountCode;
        vm.saveDiscountCode = saveDiscountCode;
        vm.deleteDiscountCode = deleteDiscountCode;
        vm.stripHtml = stripHtml;
        vm.addPhotoFormQuestion = addPhotoFormQuestion;
        vm.removePhotoFormQuestion = removePhotoFormQuestion;
        vm.movePhotoFormQuestion = movePhotoFormQuestion;
        vm.addPhotoFormOption = addPhotoFormOption;
        vm.removePhotoFormOption = removePhotoFormOption;
        vm.photoFormConditionSources = photoFormConditionSources;
        vm.photoFormConditionValues = photoFormConditionValues;
        vm.photoFormConditionError = photoFormConditionError;
        vm.onPhotoFormConditionToggle = onPhotoFormConditionToggle;
        vm.logPhotoForm = logPhotoForm;
        //functions

        function tryParseJSON(val) {
            if (typeof val !== 'string') return val;
            try {
                const parsed = JSON.parse(val);
                // If it's still a string, try parsing again
                if (typeof parsed === 'string') {
                    return tryParseJSON(parsed);
                }
                return parsed;
            } catch (e) {
                return val;
            }
        }

        // La API devuelve las columnas TAL CUAL salen de MySQL, o sea como texto: '0' y '1'.
        // Y en JavaScript el texto '0' es TRUTHY, con dos consecuencias reales (eventos 888,
        // 910 y 920): el checkbox "Evento sin dorsal" lleva ng-if="!allow_searchby_number", que
        // con '0' no se dibujaba nunca; y syncEventFlags() entraba en su if y forzaba
        // without_dorsal = 0, asi que event_info.without_dorsal se guardaba a 0 aunque la
        // columna dijera 1. Se normalizan a numero ANTES de que nadie los lea.
        var FLAGS_EVENTO = [
            'without_dorsal', 'allow_searchby_number', 'allow_searchby_face',
            'allow_searchby_description', 'allow_event_code', 'ignore_letter',
            'all_free', 'longtime_event', 'cart_enabled', 'buy_all_requires_face',
            'profile_face_selection'
        ];

        function aFlag(valor) {
            if (valor === true) { return 1; }
            if (valor === false || valor === null || valor === undefined || valor === '') { return 0; }
            var n = Number(valor);
            if (!isNaN(n)) { return n ? 1 : 0; }
            return String(valor).toLowerCase() === 'false' ? 0 : 1;
        }

        function normalizeEventData(data) {
            FLAGS_EVENTO.forEach(function (k) {
                if (k in data) { data[k] = aFlag(data[k]); }
            });
            if (data.regex_options) {
                data.regex_options = tryParseJSON(data.regex_options);
                if (!Array.isArray(data.regex_options)) data.regex_options = [];
            } else {
                data.regex_options = [];
            }

            if (data.prefix_number) {
                data.prefix_number = tryParseJSON(data.prefix_number);
                if (!Array.isArray(data.prefix_number)) data.prefix_number = [];
            } else {
                data.prefix_number = [];
            }
            // Parse strings to numbers for input type="number" (the API returns these as strings).
            if (data.limit_assign_images != null && data.limit_assign_images !== '') {
                data.limit_assign_images = Number(data.limit_assign_images);
            }
            if (data.free_images != null && data.free_images !== '') {
                data.free_images = Number(data.free_images);
            }
            return data;
        }

        // Dual-write: while these options still live in their own section_events columns, ALSO mirror
        // them into the event_info JSON, preserving any existing event_info keys (cart.*, etc.).
        // Transition target: event_info eventually owns all event config and the columns are dropped.
        function buildEventInfo() {
            var info = {};
            var src = vm.eventData.event_info;
            if (src) {
                try { info = (typeof src === 'string') ? (JSON.parse(src) || {}) : angular.copy(src); }
                catch (e) { info = {}; }
            }
            if (!info || typeof info !== 'object' || Array.isArray(info)) info = {};
            info.ignore_letter       = vm.eventData.ignore_letter ? 1 : 0;
            info.allow_event_code    = vm.eventData.allow_event_code ? 1 : 0;
            info.all_free            = vm.eventData.all_free ? 1 : 0;
            info.longtime_event      = vm.eventData.longtime_event ? 1 : 0;
            info.without_dorsal      = vm.eventData.without_dorsal ? 1 : 0;
            info.limit_assign_images = (vm.eventData.limit_assign_images || vm.eventData.limit_assign_images === 0) ? Number(vm.eventData.limit_assign_images) : null;
            info.free_images         = (vm.eventData.free_images || vm.eventData.free_images === 0) ? Number(vm.eventData.free_images) : 0;
            // Config de carrito (event_info.cart.*). Se preserva el resto de claves cart.* existentes.
            info.cart = (info.cart && typeof info.cart === 'object' && !Array.isArray(info.cart)) ? info.cart : {};
            info.cart.enabled = vm.eventData.cart_enabled ? true : false;
            // "Comprar todas las fotos" solo con cara asignada — subordinado al carrito.
            info.cart.buyAllRequiresFace = (vm.eventData.cart_enabled && vm.eventData.buy_all_requires_face) ? 1 : 0;
            // Selección de cara del perfil (event_info.profileFaceSelection.*): la web del corredor le
            // ofrece elegir su cara entre las fotos que ya tiene asignadas. maxFaces 0 = sin límite.
            // Se preservan las demás claves que pueda tener la sección.
            info.profileFaceSelection = (info.profileFaceSelection && typeof info.profileFaceSelection === 'object' && !Array.isArray(info.profileFaceSelection)) ? info.profileFaceSelection : {};
            info.profileFaceSelection.enabled = vm.eventData.profile_face_selection ? true : false;
            var maxCaras = parseInt(vm.eventData.profile_face_max, 10);
            info.profileFaceSelection.maxFaces = (maxCaras > 0) ? maxCaras : 0;
            // Formulario antes de entregar las fotos (event_info.photoForm), solo para eventos con todas
            // las fotos gratis. Si se desactiva (o se quita "todas gratis") se guarda con enabled=false para
            // no perder las preguntas; un evento que nunca tuvo formulario no recibe la clave.
            if (vm.eventData.all_free && vm.photoForm.enabled) {
                info.photoForm = RuntagPhotoFormService.toJson(vm.photoForm);
            } else if (info.photoForm || vm.photoForm.questions.length) {
                info.photoForm = RuntagPhotoFormService.toJson(vm.photoForm);
                info.photoForm.enabled = false;
            }
            return info;
        }

        // Keep mutually-exclusive / dependent flags coherent before saving. Runs for BOTH create and
        // update so a field never behaves differently depending on the path.
        function syncEventFlags() {
            // Dorsal search implies the event HAS dorsals → it can't be "without dorsal".
            if (vm.eventData.allow_searchby_number) {
                vm.eventData.without_dorsal = 0;
            }
            // "All photos free" makes a per-event free-image count meaningless.
            if (vm.eventData.all_free) {
                vm.eventData.free_images = 0;
            }
            // Sin selección de cara, su tope no significa nada.
            if (!vm.eventData.profile_face_selection) {
                vm.eventData.profile_face_max = 0;
            }
            // Numeric fields can never be negative (defence in depth alongside the form's min="0").
            if (vm.eventData.limit_assign_images < 0) { vm.eventData.limit_assign_images = 0; }
            if (vm.eventData.free_images < 0) { vm.eventData.free_images = 0; }
            if (vm.eventData.profile_face_max < 0) { vm.eventData.profile_face_max = 0; }
        }

        // Single error handler for the save chain: surfaces a toast instead of leaving the modal
        // hanging on a rejected promise, and clears the blocking spinners.
        function handleSaveError(error) {
            vm.loadingRegex = false;
            vm.loadingImage = false;
            console.error('Error al guardar el evento', error);
            $mdToast.show({
                template: '<md-toast layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-close" class="icon"></md-icon><span class="md-toast-text" flex>Error al guardar el evento. Revisá los datos e intentá de nuevo.</span></div></md-toast>',
                hideDelay: 5000,
                position: 'top',
                parent: '#content-container'
            });
        }

        //variables
        vm.loadingDownloads = false;
        vm.selectedProduct = undefined;
        vm.selectedPhotographer = undefined;
        vm.selectedLocation = undefined;
        vm.regexOptions = [];
        vm.dbPhotographers = [];
        vm.defaultProducts = [];
        vm.activeRegex = undefined;
        vm.created = 0;
        vm.eventData = {
            id_subsec: 1,
            prefix_number: []
        };
        vm.prefixSeparatorKeys = [13, 188]; // Enter and Comma

        vm.transformPrefixChip = function (chip) {
            if (chip) {
                // Keep only letters and uppercase them
                var transformed = chip.replace(/[^a-zA-Z]/g, '').toUpperCase().trim();
                return transformed.length > 0 ? transformed : null;
            }
            return chip;
        };
        vm.selectedTab = 0;
        vm.clients = clients;
        vm.organizers = [];
        vm.paymentMethods = paymentMethods;
        vm.selectedEvent = selectedEvent;
        vm.products = products ? products.filter(x => x.id) : [];
        vm.photographers = [];
        vm.locations = [];
        vm.loadingDiscountCodes = false;
        vm.discountCodes = [];
        vm.selectedFile = {};
        vm.imagePreview = {};
        vm.activeUpload = null;
        vm.apiUrl = apiUrl;

        vm.arrayCurrencies = ['USD'];

        vm.config = undefined;

        vm.searchPhotographer = "";
        vm.selectedDiscountCode = undefined;
        vm.discountCodeData = {};

        // Photo delivery form (only for "all photos free" events), stored in event_info.photoForm.
        vm.photoFormService = RuntagPhotoFormService;
        vm.photoForm = RuntagPhotoFormService.createForm();
        vm.photoFormResult = null;
        vm.photoFormSortable = { handle: '.photo-form-handle', animation: 150 };

        //variables

        init();
        function init() {
            if (vm.clients && vm.clients.length === 1) {
                vm.eventData.id_client = vm.clients[0].id_clients;
                changeClient(vm.clients[0]);
            }
            if (vm.selectedEvent) {
                vm.eventData = normalizeEventData(angular.copy(vm.selectedEvent));
                // Reflejar en el toggle el flag de event_info.cart.buyAllRequiresFace (solo carrito): "comprar
                // todas las fotos" de un perfil solo si el perfil tiene una cara asignada.
                var _ei = vm.eventData.event_info;
                if (typeof _ei === 'string') { try { _ei = JSON.parse(_ei); } catch (e) { _ei = null; } }
                vm.eventData.cart_enabled = !!(_ei && _ei.cart && _ei.cart.enabled);
                vm.eventData.buy_all_requires_face = !!(_ei && _ei.cart && _ei.cart.buyAllRequiresFace);
                // Selección de cara del perfil y su tope (event_info.profileFaceSelection.*).
                var _pfs = (_ei && _ei.profileFaceSelection) ? _ei.profileFaceSelection : null;
                vm.eventData.profile_face_selection = !!(_pfs && _pfs.enabled);
                var _maxCaras = _pfs ? parseInt(_pfs.maxFaces, 10) : 0;
                vm.eventData.profile_face_max = (_maxCaras > 0) ? _maxCaras : 0;
                // Formulario de entrega de fotos (event_info.photoForm), si el evento ya lo tuviera.
                vm.photoForm = RuntagPhotoFormService.fromSaved(_ei && _ei.photoForm);
                        vm.regexOptions = vm.eventData.regex_options;
                vm.created = true;
                vm.products.forEach(product => {
                    product.price_total = product.price;
                    const method = vm.paymentMethods.find(m => m.id === product.id_payment_method);
                    product.payment_method_name = method?.name || 'Unknown';
                });
                if (vm.selectedEvent.photographers) {
                    vm.photographers = vm.selectedEvent.photographers;
                }
                if (vm.selectedEvent.locations) {
                    vm.locations = vm.selectedEvent.locations;
                }
                if (vm.selectedEvent.id_client) {
                    const client = vm.clients.find(x => x.id === vm.selectedEvent.id_client);
                    if (client) {
                        changeClient(client);
                    }
                }
                if (vm.regexOptions && vm.regexOptions.length > 0) {
                    updateRegexPreview();
                }
            }

            $scope.$watch('vm.regexOptions', function (newVal, oldVal) {
                if (newVal) {
                    updateRegexPreview();
                }
            }, true);

            $scope.$watch('vm.eventData.prefix_number', function (newVal, oldVal) {
                if (newVal) {
                    updateRegexPreview();
                }
            }, true);

            if (vm.eventData) {
                vm.loadingDiscountCodes = true;
                RuntagEventService.getContent({
                    siteID: siteID,
                    content: 'discount_codes',
                    resultsPerPage: 999,
                    filters: [
                        {
                            field: 'id_event',
                            values: [vm.eventData.id_events]
                        }
                    ]
                }).then(resp => {
                    if (resp && resp.result && angular.isArray(resp.result.data)) {
                        vm.discountCodes = resp.result.data;
                    }
                    vm.loadingDiscountCodes = false;
                }).catch(err => {
                    $log.error(err);
                    vm.loadingDiscountCodes = false;
                });

                RuntagEventService.getContent({
                    siteID: siteID,
                    content: 'photographer',
                    resultsPerPage: 999,
                    filters: [
                        {
                            field: 'id_clients',
                            values: [vm.eventData.id_client]
                        }
                    ]
                }).then(resp => {
                    vm.dbPhotographers = resp.result.data;
                    if (vm.photographers && vm.photographers.length > 0 && vm.dbPhotographers && vm.dbPhotographers.length > 0) {
                        vm.photographers.forEach(photographer => {
                            const dbPhotographer = vm.dbPhotographers.find(x => x.name == photographer.name && x.camera_name == photographer.camera_name);
                            Object.assign(photographer, dbPhotographer);
                        })
                    }
                });
                RuntagEventService.getContent({
                    siteID: siteID,
                    content: 'organizer',
                    filters: [
                        {
                            field: 'id_client',
                            values: [vm.eventData.id_client]
                        }
                    ]
                }).then(resp => {
                    vm.organizers = resp.result.data;
                    if (vm.organizers.length == 1) {
                        vm.eventData.id_organizer = vm.organizers[0].id_organizer;
                    }
                });
                if (vm.eventData.Thumbnail && vm.eventData.Thumbnail.length > 0) {
                    vm.eventData.Thumbnail.forEach(thumb => {
                        mediaService.getImageByID({
                            domain: siteID,
                            id_media: thumb.id_media
                        }).then(resp => {
                            if (resp.data && resp.data.length > 0) {
                                const image = resp.data[0];
                                const url = `${image.container.view_url}original/m${image.id_media}_${image.filename}`;
                                thumb.url = url;
                                switch (thumb.id_zone) {
                                    case 1:
                                        vm.imagePreview.image = url;
                                        break;
                                    case 2:
                                        vm.imagePreview.logo = url;
                                        break;
                                    case 3:
                                        vm.imagePreview.watermark = url;
                                        break;
                                }
                                if (!vm.imagePreview.watermark) {
                                    const client = vm.clients.find(x => x.id_clients === vm.eventData.id_client);
                                    if (client && client.watermark_default) {
                                        vm.imagePreview.watermark = client.watermark_default;
                                        if (!vm.config) {
                                            vm.config = {};
                                        }
                                        vm.config.cropFormats =
                                        {
                                            watermarkUrl: client.watermark_default
                                        }
                                    }
                                }
                            }
                        });
                    });
                } else {
                    const client = vm.clients.find(x => x.id_clients === vm.eventData.id_client);
                    if (client && client.watermark_default) {
                        vm.imagePreview.watermark = client.watermark_default;
                    }
                }
            }
        }

        // Descargar datos de fotógrafos a CSV
        function downloadPhotographerData() {
            if (!vm.photographers || vm.photographers.length === 0) {
                alert('No hay fotógrafos disponibles.');
                return;
            }

            const headers = ['name', 'email', 'camera_name', 'aws_access_key', 'aws_secret_key', 'path'];
            const rows = vm.photographers.map(p => [
                `"${p.name || ''}"`,
                `"${p.email || ''}"`,
                `"${p.camera_name || ''}"`,
                `"${p.aws_access_key || ''}"`,
                `"${p.aws_secret_key || ''}"`,
                `"${vm.generateFolderPath(p.camera_name)}"`
            ].join(','));

            const csvContent = [headers.join(','), ...rows].join('\n');
            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.setAttribute('download', 'photographers.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }

        function changeClient(client) {
            vm.arrayCurrencies = ['USD'];
            if (client.local_currency) {
                vm.arrayCurrencies.push(client.local_currency);
            }
            if (client.products_template) {
                const defaultProducts = angular.fromJson(client.products_template);
                if (defaultProducts && defaultProducts.length > 0) {
                    vm.defaultProducts = defaultProducts;
                }
            }
            RuntagEventService.getContent({
                siteID: siteID,
                content: 'photographer',
                resultsPerPage: 999,
                filters: [
                    {
                        field: 'id_clients',
                        values: [client.id_clients]
                    }
                ]
            }).then(resp => {
                if (resp && resp.result && resp.result.data && resp.result.data.length > 0) {
                    vm.dbPhotographers = resp.result.data;
                }
            });
            RuntagEventService.getContent({
                siteID: siteID,
                content: 'organizer',
                resultsPerPage: 999,
                filters: [
                    {
                        field: 'id_client',
                        values: [vm.eventData.id_client]
                    }
                ]
            }).then(resp => {
                vm.organizers = resp.result.data;
                if (vm.organizers.length == 1) {
                    vm.eventData.id_organizer = vm.organizers[0].id_organizer;
                }
            });
            if (client && client.watermark_default) {
                vm.imagePreview.watermark = client.watermark_default;
                if (!vm.config) {
                    vm.config = {};
                }
                vm.config.cropFormats =
                {
                    watermarkUrl: client.watermark_default
                }
            } else {
                vm.imagePreview.watermark = undefined;
                vm.config.cropFormats = undefined;
            }
        }

        vm.findPaymentMethodName = function (id) {
            $log.warn("Calling with ID:", id);
            return 'test'; // prueba rápida
        };

        function notInEventProducts() {
            if (vm.products) {
                return vm.products.find(x => x.id == vm.productData.id);
            } else {
                return null;
            }
        }

        function notInEventPhotographers() {
            if (vm.eventData.photographers) {
                return vm.eventData.photographers.find(x => x.camera_name == vm.photographerData.camera_name);
            } else {
                return null;
            }
        }

        function deletePhotographer(id, $event) {
            $event.stopPropagation();
            const photographerId = id || vm.photographerData.id_photographer;
            RuntagEventService.deletePhotographer({
                domain: siteID,
                id_event: vm.eventData.id,
                id_photographer: photographerId
            }).then(resp => {
                if (resp && resp.success) {
                    vm.eventData.photographers = vm.eventData.photographers.filter(x => x.id_photographer !== photographerId);
                    vm.photographers = vm.photographers.filter(x => x.id_photographer !== photographerId);
                    cancelPhotographer();
                }
            });
        }

        function deleteLocation(name, $event) {
            $event.stopPropagation();
            const locationName = name || vm.locationData.reference_name;

            RuntagEventService.deleteLocation({
                domain: siteID,
                id_event: vm.eventData.id,
                location: locationName
            }).then(resp => {
                if (resp) {
                    vm.eventData.locations = vm.eventData.locations.filter(x => x.reference_name !== locationName);
                    vm.locations = vm.locations.filter(x => x.reference_name !== locationName);
                    cancelLocation();
                }
            });
        }

        function filteredPhotographers(searchText) {
            let available = vm.dbPhotographers.filter(x => {
                return !vm.eventData.photographers ||
                    !vm.eventData.photographers.some(y => y.camera_name === x.camera_name);
            });

            if (searchText) {
                const lowerSearch = searchText.toLowerCase();
                available = available.filter(p =>
                    p.name.toLowerCase().includes(lowerSearch) ||
                    p.camera_name.toLowerCase().includes(lowerSearch)
                );
            }

            // Devolvemos la lista ordenada alfabéticamente por nombre
            return available.sort((a, b) => a.name.localeCompare(b.name));
        }

        function clearSearch() {
            vm.searchPhotographer = "";
        }

        vm.searchPhotographer = '';

        vm.clearSearch = function () {
            vm.searchPhotographer = '';
        };

        vm.focusSearchInput = function () {
            setTimeout(() => {
                const input = document.getElementById('search-photographer-input');
                if (input) input.focus();
            }, 100);
        };


        function generateFolderPath(cameraName) {
            const client = vm.clients.find(x => x.id_clients === vm.eventData.id_client);
            const folderPath = `${client.bucket_name}-upload/${vm.eventData.dynamo_db_code}/${vm.eventData.lang == 2 ? 'fotografos' : 'photographers'}/${cameraName || vm.photographerData.camera_name}`;
            return folderPath;
        }

        function generateBucket() {
            const client = vm.clients.find(x => x.id_clients === vm.eventData.id_client);
            return `${client.bucket_name}`;
        }

        function triggerFileInput(id) {
            document.getElementById(`fileInput-${id}`).click();
            vm.activeUpload = id;
        }

        $scope.fileChanged = function (element) {
            $scope.$apply(function () {
                vm.selectedFile[vm.activeUpload] = element.files[0];
                // Validar que se haya seleccionado un archivo
                if (vm.selectedFile[vm.activeUpload]) {
                    var reader = new FileReader();
                    reader.onload = function (event) {
                        $scope.$apply(function () {
                            vm.imagePreview[vm.activeUpload] = event.target.result;
                        });
                    };
                    reader.readAsDataURL(vm.selectedFile[vm.activeUpload]);
                    uploadImage();
                }
            });
        };

        function uploadImage() {
            vm.loadingImage = true;
            if (!vm.selectedFile[vm.activeUpload]) {
                alert("Por favor, selecciona una imagen.");
                return;
            }

            const uploadOptions = {
                siteID: siteID,
                filename: vm.selectedFile[vm.activeUpload].name,
                type: 'media'
            };
            uploadService.upload(vm.selectedFile[vm.activeUpload], uploadOptions).then(function (response) {
                const id_zone = vm.activeUpload === 'image' ? 1 : vm.activeUpload === 'logo' ? 2 : 3;

                if (!vm.eventData.Thumbnail) {
                    vm.eventData.Thumbnail = [];
                }

                const currentMedia = vm.eventData.Thumbnail.find(x => x.id_zone == id_zone);

                if (currentMedia) {
                    currentMedia.id_media = response.id_media;
                } else {
                    vm.eventData.Thumbnail.push(
                        {
                            id_media: response.id_media,
                            id_zone: id_zone
                        }
                    );
                }
                if (vm.activeUpload === 'watermark') {
                    if (!vm.config) {
                        vm.config = {};
                    }
                    mediaService.getImageByID({
                        domain: siteID,
                        id_media: response.id_media
                    }).then(resp => {
                        if (resp.data && resp.data.length > 0) {
                            const image = resp.data[0];
                            const url = `${image.container.view_url}original/m${image.id_media}_${image.filename}`;
                            vm.config.cropFormats =
                            {
                                watermarkUrl: url
                            }
                            if (vm.eventData.id) {
                                vm.loadingImage = false;
                                saveEvent();
                            }
                        }
                    });
                } else if (vm.eventData.id) {
                    vm.loadingImage = false;
                    saveEvent();
                } else {
                    vm.loadingImage = false;
                }
            }).catch(function (error) {
                alert("Error al subir la imagen");
                console.error(error);
            });
        }

        function formatDate(date, format) {
            var dateObject = new Date(date);
            return $filter('date')(dateObject, format);
        }

        // ── Photo delivery form builder ──────────────────────────────────────────────────────────

        function addPhotoFormQuestion(type) {
            vm.photoForm.questions.push(RuntagPhotoFormService.createQuestion(type, vm.photoForm));
        }

        function removePhotoFormQuestion(index) {
            RuntagPhotoFormService.removeQuestion(vm.photoForm, index);
        }

        function movePhotoFormQuestion(index, delta) {
            RuntagPhotoFormService.moveQuestion(vm.photoForm, index, delta);
        }

        function addPhotoFormOption(question) {
            question.options.push(RuntagPhotoFormService.createOption());
        }

        // Also clears conditions that pointed at the removed option.
        function removePhotoFormOption(question, index) {
            var removed = question.options.splice(index, 1)[0];
            vm.photoForm.questions.forEach(function (q) {
                if (q.showIf && q.showIf.questionId === question.id && q.showIf.value === removed.id) {
                    q.showIf.value = null;
                }
            });
        }

        // These lists feed md-select options from the template, so they are evaluated on every digest.
        // md-select never settles if it gets new arrays/objects each time ($rootScope:infdig), so the
        // same list is returned until its content actually changes.
        var photoFormListCache = {};

        function cachedPhotoFormList(key, list, signature) {
            var cached = photoFormListCache[key];
            if (cached && cached.signature === signature) { return cached.list; }
            photoFormListCache[key] = { signature: signature, list: list };
            return list;
        }

        // A question can only depend on an EARLIER yes/no or choice question. If reordering left the
        // selected source AFTER the question, it is still listed so the select keeps showing it (the
        // card flags the problem via photoFormConditionError).
        function photoFormConditionSources(question) {
            var index = vm.photoForm.questions.indexOf(question);
            var sources = vm.photoForm.questions.slice(0, index).filter(RuntagPhotoFormService.canBeConditionSource);
            var selected = vm.photoForm.questions.filter(function (q) { return q.id === question.showIf.questionId; })[0];
            if (selected && sources.indexOf(selected) === -1 && RuntagPhotoFormService.canBeConditionSource(selected)) {
                sources.push(selected);
            }
            return cachedPhotoFormList('sources:' + question.id, sources,
                sources.map(function (q) { return q.id; }).join(','));
        }

        function photoFormConditionValues(question) {
            var source = vm.photoForm.questions.filter(function (q) { return q.id === question.showIf.questionId; })[0];
            var lang = vm.photoForm.defaultLanguage;
            var values = [];
            if (source && source.type === 'yes_no') {
                values = [
                    { value: 'yes', label: $translate.instant('RUNTAG.PHOTO_FORM.YES') },
                    { value: 'no', label: $translate.instant('RUNTAG.PHOTO_FORM.NO') }
                ];
            } else if (source) {
                values = source.options.map(function (o, i) {
                    return { value: o.id, label: o.label[lang] || $translate.instant('RUNTAG.PHOTO_FORM.OPTION_N', { n: i + 1 }) };
                });
                if (source.allowOther) {
                    values.push({ value: 'other', label: source.otherLabel[lang] || $translate.instant('RUNTAG.PHOTO_FORM.OTHER') });
                }
            }
            return cachedPhotoFormList('values:' + question.id, values,
                values.map(function (v) { return v.value + '=' + v.label; }).join('|'));
        }

        // Inline card error for a broken condition (e.g. its source was dragged below it). A condition
        // still being filled in (no question or no answer picked yet) is not flagged here, only in
        // "Show result".
        function photoFormConditionError(question) {
            if (!question.hasCondition || !question.showIf.questionId) { return ''; }
            var issue = RuntagPhotoFormService.conditionIssue(vm.photoForm, question);
            if (!issue || issue.key === 'CONDITION_VALUE') { return ''; }
            return $translate.instant('RUNTAG.PHOTO_FORM.CARD_ISSUES.' + issue.key, issue.params);
        }

        function onPhotoFormConditionToggle(question) {
            if (!question.hasCondition) {
                question.showIf = { questionId: null, value: null };
            }
        }

        // Logs (and shows in the dialog) the JSON exactly as it would be stored in event_info.photoForm.
        function logPhotoForm() {
            var json = RuntagPhotoFormService.toJson(vm.photoForm);
            var issues = RuntagPhotoFormService.validate(vm.photoForm);
            vm.photoFormResult = {
                valid: issues.length === 0,
                json: json,
                text: JSON.stringify(json, null, 2),
                issues: issues.map(function (issue) {
                    return $translate.instant('RUNTAG.PHOTO_FORM.ISSUES.' + issue.key, issue.params);
                })
            };
            console.log('[Runtag] event_info.photoForm', json);
            if (!vm.photoFormResult.valid) {
                console.warn('[Runtag] photoForm is not valid, the event will not be saved', vm.photoFormResult.issues);
            }
            return json;
        }

        function closeDialog() {
            $mdDialog.hide({
                action: 'closed',
            });
        }

        function selectProduct(product) {
            vm.selectedProduct = product;
            if (product != 'new') {
                vm.productData = angular.copy(product);

                vm.productData.onoff = !!vm.productData.onoff;
                vm.productData.product_label = vm.productData.product_label || '';
            } else {
                vm.productData = {
                    onoff: true,
                    product_label: ''
                };
            }
        }

        function stripHtml(html) {
            if (!html) return '';
            var doc = new RegExp('(<([^>]+)>)', 'ig');
            return html.replace(doc, "");
        }

        function selectPhotographer(photographer) {
            vm.selectedPhotographer = photographer;
            if (photographer != 'new') {
                vm.photographerData = angular.copy(photographer);
            } else {
                vm.photographerData = {};
            }
        }

        function selectLocation(location) {
            vm.selectedLocation = location;
            if (location != 'new') {
                vm.locationData = angular.copy(location);
            } else {
                vm.locationData = {};
            }
        }

        function saveProduct() {
            vm.productData.onoff = vm.productData.onoff ? 1 : 0;
            vm.productData.price = vm.productData.price_total;
            if (vm.productData.id) {
                const options = {
                    siteID: siteID,
                    item: vm.productData,
                    id: vm.productData.id,
                    section: 'products'
                }
                RuntagEventService.updateItem(options).then(response => {
                    const product = vm.products.find(x => x.id === vm.productData.id);
                    const index = vm.products.indexOf(product);
                    angular.forEach(response.item, function (value, key) {
                        if (vm.productData.hasOwnProperty(key)) {
                            vm.productData[key] = value;
                        }
                    });
                    vm.products[index] = vm.productData;
                    vm.selectedProduct = undefined;
                    vm.productData = {};
                });
            } else {
                const client = vm.clients.find(x => x.id_clients === vm.eventData.id_client);
                vm.productData.id_event = vm.eventData.id;
                if (!vm.productData.lang) {
                    vm.productData.lang = client?.lang;
                }
                const options = {
                    siteID: siteID,
                    item: vm.productData,
                    section: 'products'
                }
                RuntagEventService.createItem(options).then(response => {
                    let product = response.item;
                    product.id = response.id;
                    vm.products.push(product);
                    vm.selectedProduct = undefined;
                    vm.productData = {};
                });
            }
        }

        function savePhotographer() {
            if (vm.photographerData.name && vm.photographerData.camera_name) {
                const currentPhotographer = vm.photographers.find(x => x.name == vm.photographerData.name || x.camera_name == vm.photographerData.camera_name);
                if (currentPhotographer) {
                    $mdToast.show({
                        template: '<md-toast layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-close" class="icon"></md-icon><span class="md-toast-text" flex>Los fotógrafos deben tener nombres diferentes y reconocibles.</span></div></md-toast>',
                        hideDelay: 5000,
                        position: 'top',
                        parent: '#content-container'
                    });
                    return;
                }
                if (!vm.photographerData.id_photographer) {
                    createPhotographer().then(photographer => {
                        if (!photographer.error) {
                            updatePhotographerToLambda(photographer);
                        }
                    });
                } else {
                    updatePhotographerToLambda(vm.photographerData);
                }
            }
        }

        function createPhotographer() {
            const currentPhotographer = vm.dbPhotographers.find(x => x.name == vm.photographerData.name || x.camera_name == vm.photographerData.camera_name);
            if (currentPhotographer) {
                $mdToast.show({
                    template: '<md-toast layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-close" class="icon"></md-icon><span class="md-toast-text" flex>Los fotógrafos deben tener nombres diferentes y reconocibles.</span></div></md-toast>',
                    hideDelay: 5000,
                    position: 'top',
                    parent: '#content-container'
                });
                return { error: true };
            }
            if (vm.photographerData && vm.photographerData.name && vm.photographerData.camera_name) {
                vm.photographerData.id_clients = vm.eventData.id_client;
                vm.photographerData.onoff = 1;
                return RuntagEventService.createItem({
                    siteID: siteID,
                    section: 'photographer',
                    resultsPerPage: 999,
                    item: vm.photographerData
                }).then(resp => {
                    if (resp) {
                        let photographer = resp.item;
                        photographer.id_photographer = resp.id;
                        vm.dbPhotographers.push(photographer);
                        return photographer;
                    }
                })
            }
        }

        function updatePhotographerToLambda(photographer) {
            RuntagEventService.putLambdaPhotographer({
                domain: siteID,
                id_event: vm.eventData.id,
                id_photographer: photographer.id_photographer
            }).then(resp => {
                if (resp) {
                    photographer.aws_access_key = resp.accessKeyId;
                    photographer.aws_secret_key = resp.secretAccessKey;
                    if (!vm.eventData.photographers) {
                        vm.eventData.photographers = [];
                    }
                    vm.eventData.photographers.push(photographer);
                    vm.photographers = vm.eventData.photographers;
                    vm.selectPhotographer(vm.photographers[vm.photographers.length - 1]);
                }
            })
        }

        function saveLocation() {
            if (vm.locationData.name && vm.locationData.reference_name) {
                const locationName = vm.locations.find(x => x.name == vm.locationData.name);
                const locationReferenceName = vm.locations.find(x => x.reference_name == vm.locationData.reference_name);
                if (locationName || locationReferenceName) {
                    $mdToast.show({
                        template: '<md-toast layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-close" class="icon"></md-icon><span class="md-toast-text" flex>Las localizaciones deben tener nombres diferentes y reconocibles.</span></div></md-toast>',
                        hideDelay: 5000,
                        position: 'top',
                        parent: '#content-container'
                    });
                    return;
                }
                RuntagEventService.postLambdaLocation(
                    {
                        domain: siteID,
                        id_event: vm.eventData.id,
                        name: vm.locationData.name,
                        reference_name: vm.locationData.reference_name
                    }
                ).then(resp => {
                    if (resp) {
                        if (!vm.eventData.locations) {
                            vm.eventData.locations = [];
                        }
                        vm.eventData.locations.push({
                            name: vm.locationData.name,
                            reference_name: vm.locationData.reference_name
                        });
                        vm.locations.push({
                            name: vm.locationData.name,
                            reference_name: vm.locationData.reference_name
                        });
                        vm.selectLocation(vm.locations[vm.locations.length - 1]);
                    }
                });
            }
        }

        function cancelProduct(del) {
            vm.selectedProduct = undefined;
        }

        function cancelPhotographer() {
            vm.selectedPhotographer = undefined;
        }

        function cancelLocation() {
            vm.selectedLocation = undefined;
        }

        function selectDiscountCode(code) {
            vm.selectedDiscountCode = code;
            if (code != 'new') {
                vm.discountCodeData = angular.copy(code);
                // Asegurar tipo booleano para el switch si viene como 1/0
                vm.discountCodeData.onoff = !!vm.discountCodeData.onoff;
                // Parse strings to numbers for input type="number"
                if (vm.discountCodeData.coupon_value) vm.discountCodeData.coupon_value = Number(vm.discountCodeData.coupon_value);
                if (vm.discountCodeData.total_codes) vm.discountCodeData.total_codes = Number(vm.discountCodeData.total_codes);
                if (vm.discountCodeData.used_codes) vm.discountCodeData.used_codes = Number(vm.discountCodeData.used_codes);
            } else {
                vm.discountCodeData = {
                    onoff: true,
                    used_codes: 0,
                    total_codes: 100 // Valor por defecto sugerido
                };
            }
        }

        function cancelDiscountCode() {
            vm.selectedDiscountCode = undefined;
            vm.discountCodeData = {};
        }

        function saveDiscountCode() {
            // Preparar datos
            vm.discountCodeData.onoff = vm.discountCodeData.onoff ? 1 : 0;

            // Validaciones básicas
            if (!vm.discountCodeData.name || !vm.discountCodeData.code) {
                return;
            }

            // Uppercase code
            vm.discountCodeData.code = vm.discountCodeData.code.toUpperCase();

            if (vm.discountCodeData.id) {
                // UPDATE
                const options = {
                    siteID: siteID,
                    item: vm.discountCodeData,
                    id: vm.discountCodeData.id,
                    section: 'discount_codes'
                };

                RuntagEventService.updateItem(options).then(response => {
                    // Actualizar lista local
                    const code = vm.discountCodes.find(x => x.id === vm.discountCodeData.id);
                    if (code) {
                        const index = vm.discountCodes.indexOf(code);
                        // Actualizar las propiedades del objeto existente
                        angular.merge(vm.discountCodes[index], vm.discountCodeData);
                    }

                    vm.selectedDiscountCode = undefined;
                    vm.discountCodeData = {};

                    $mdToast.show({
                        template: '<md-toast layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>Código actualizado correctamente</span></div></md-toast>',
                        hideDelay: 3000,
                        position: 'top',
                        parent: '#content-container'
                    });
                });
            } else {
                // CREATE
                const client = vm.clients.find(x => x.id_clients === vm.eventData.id_client);
                vm.discountCodeData.id_event = vm.eventData.id;
                vm.discountCodeData.id_client = vm.eventData.id_client;

                if (!vm.discountCodeData.lang) {
                    vm.discountCodeData.lang = client?.lang || 2; // Default to ES if not present
                }

                // Hardcoded values as requested
                vm.discountCodeData.id_subsec = 1;
                vm.discountCodeData.id_cat = 1;

                const options = {
                    siteID: siteID,
                    item: vm.discountCodeData,
                    section: 'discount_codes'
                };

                RuntagEventService.createItem(options).then(response => {
                    let newCode = response.item;
                    // El servicio devuelve item con el nuevo ID normalmente, o response.id
                    if (response.id) {
                        newCode.id = response.id;
                        newCode.id_discount_codes = response.id; // Por consistencia si el backend usa esto
                    }

                    vm.discountCodes.push(newCode);
                    vm.selectedDiscountCode = undefined;
                    vm.discountCodeData = {};

                    $mdToast.show({
                        template: '<md-toast layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>Código creado correctamente</span></div></md-toast>',
                        hideDelay: 3000,
                        position: 'top',
                        parent: '#content-container'
                    });
                });
            }
        }

        function deleteDiscountCode() {
            if (!vm.discountCodeData.id) return;

            // Confirmación antes de borrar
            var confirm = $mdDialog.confirm()
                .title($translate.instant('RUNTAG.DISCOUNT_CODES.DELETE_CONFIRM_TITLE'))
                .textContent($translate.instant('RUNTAG.DISCOUNT_CODES.DELETE_CONFIRM_CONTENT'))
                .ariaLabel($translate.instant('RUNTAG.DISCOUNT_CODES.DELETE'))
                .targetEvent(event)
                .ok($translate.instant('RUNTAG.DISCOUNT_CODES.DELETE'))
                .cancel($translate.instant('RUNTAG.DISCOUNT_CODES.CANCEL'))
                .multiple(true);

            $mdDialog.show(confirm).then(function () {
                const options = {
                    siteID: siteID,
                    id: vm.discountCodeData.id,
                    section: 'discount_codes'
                };

                RuntagEventService.deleteItem(options).then(resp => {
                    // Lo eliminamos de la lista local para que ya no aparezca
                    vm.discountCodes = vm.discountCodes.filter(c => c.id !== vm.discountCodeData.id);
                    vm.selectedDiscountCode = undefined;
                    vm.discountCodeData = {};

                    $mdToast.show({
                        template: '<md-toast layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>Código eliminado</span></div></md-toast>',
                        hideDelay: 3000,
                        position: 'top',
                        parent: '#content-container'
                    });
                }, err => {
                    console.error('Error deleting item', err);
                    $mdToast.show({
                        template: '<md-toast layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-close" class="icon"></md-icon><span class="md-toast-text" flex>Error al eliminar.</span></div></md-toast>',
                        hideDelay: 3000,
                        position: 'top',
                        parent: '#content-container'
                    });
                });
            });
        }

        /**
         * Normaliza un texto para usarlo como referencia/clave (grupo de usuarios, dynamo_db_code, cola del
         * api_url): sin espacios, minúsculas y sin acentos. Es la transformación que ya se le hacía al nombre
         * del evento, extraída para poder aplicarla también al prefix del cliente.
         */
        function slugifyRef(value) {
            if (!value) { return ''; }
            return String(value).replace(/ /g, '').toLowerCase().normalize("NFD").replace(/\p{Diacritic}/gu, "");
        }

        function saveEvent() {
            // An active photo form with errors is never saved: the public web could not render it.
            if (vm.eventData.all_free && vm.photoForm.enabled) {
                logPhotoForm();
                if (!vm.photoFormResult.valid) {
                    $mdToast.show({
                        template: '<md-toast layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-close" class="icon"></md-icon><span class="md-toast-text" flex>' +
                            $translate.instant('RUNTAG.PHOTO_FORM.SAVE_BLOCKED') + '</span></div></md-toast>',
                        hideDelay: 6000,
                        position: 'top',
                        parent: '#content-container'
                    });
                    return;
                }
            }
            syncEventFlags();
            if (!vm.eventData.id) {
                const eventNameRef = slugifyRef(vm.eventData.event_name);
                const eventOptions = {
                    domain: siteID,
                    event_name: vm.eventData.event_name,
                    from: new Date(0).toISOString(),
                    to: new Date(new Date().setFullYear(new Date().getFullYear() + 2)).toISOString()
                }
                RuntagEventService.getEventsStats(eventOptions).then(response => {
                    let next = true;
                    if (response.data.length > 0) {
                        const eventsResp = response.data;
                        const repEvent = eventsResp.find(x => x.event_name.toLowerCase() == vm.eventData.event_name.toLowerCase());
                        if (repEvent) {
                            next = false;
                        }
                    }
                    if (next) {
                        const client = vm.clients.find(x => x.id_clients === vm.eventData.id_client);
                        usersService.createUsersGroup(siteID, client.id_group, eventNameRef, 2).then(response => {
                            let noOrderGroupName = eventNameRef;
                            switch (client.lang) {
                                case 2:
                                    noOrderGroupName = noOrderGroupName + "_sin_compras";
                                    break;
                                default:
                                    noOrderGroupName = noOrderGroupName + "_no_orders";
                                    break;
                            }
                            usersService.createUsersGroup(siteID, client.id_group, noOrderGroupName, 2).then(noOrderResp => {
                                vm.eventData.id_user_group = response.id_group;
                                vm.eventData.id_user_group_no_orders = noOrderResp.id_group;
                                vm.eventData.onoff = 1;
                                vm.eventData.lang = client.lang;
                                // Código del evento PREFIJADO POR CLIENTE si section_clients.prefix tiene valor:
                                // `${prefix}_${eventNameRef}`. Sin prefix queda como siempre. El prefix se
                                // normaliza igual que el nombre del evento (sin espacios, minúsculas, sin
                                // acentos) porque es una clave de Dynamo, no un texto para leer.
                                // Lo usan dynamo_db_code Y la cola del api_url: la lambda toma de esa cola su
                                // prefijo de Dynamo (las fotos vuelven con `prefix` = ese trozo), así que los
                                // dos valores tienen que coincidir — hoy lo hacen en 740 de 746 eventos.
                                const clientPrefix = slugifyRef(client.prefix);
                                const eventCode = clientPrefix ? `${clientPrefix}_${eventNameRef}` : eventNameRef;
                                vm.eventData.dynamo_db_code = eventCode;
                                vm.eventData.api_url = `${client.cross_components_api_host}/${eventCode}`;
                                vm.eventData.version = 'V3';
                                vm.eventData.country = client.country;
                                vm.eventData.local_currency = client.local_currency;
                                vm.eventData.international_currency = client.international_currency;
                                vm.eventData.has_own_clound_account = client.id_container != 1 ? 1 : 0;
                                vm.eventData.last_updated = new Date();
                                vm.eventData.date = new Date(vm.eventData.date);
                                vm.eventData.date.setHours(12, 0, 0, 0);
                                vm.eventData.end_date = new Date(vm.eventData.end_date);
                                vm.eventData.end_date.setHours(12, 0, 0, 0);

                                let itemToSave = normalizeEventData(angular.copy(vm.eventData));

                                // Stringify ONCE
                                itemToSave.regex_options = JSON.stringify(itemToSave.regex_options);
                                itemToSave.prefix_number = JSON.stringify(itemToSave.prefix_number);
                                itemToSave.event_info = JSON.stringify(buildEventInfo());

                                const optionsSaveEvent = {
                                    siteID: siteID,
                                    item: itemToSave,
                                    section: 'events'
                                }
                                RuntagEventService.createItem(optionsSaveEvent).then(function (response) {
                                    if (response.id) {
                                        RuntagEventService.postLambdaEvent({
                                            domain: siteID,
                                            id_event: response.id
                                        }).then(function (lambdaResponse) {
                                            if (lambdaResponse && lambdaResponse.success) {
                                                // Backup the local Thumbnails before the backend response overwrites it
                                                const localThumbnails = angular.copy(vm.eventData.Thumbnail || []);

                                                vm.eventData = normalizeEventData(response.item);
                                                vm.eventData.id = response.id;
                                                vm.regexOptions = vm.eventData.regex_options;

                                                // Restore Thumbnails if we had any
                                                if (localThumbnails.length > 0) {
                                                    vm.eventData.Thumbnail = localThumbnails;
                                                }

                                                vm.apiUrl = vm.eventData.api_url;
                                                vm.created = 1;
                                                vm.selectedTab = 1;
                                                if (vm.config) {
                                                    if (vm.config.cropFormats && vm.config.cropFormats.watermarkUrl) {
                                                        const client = vm.clients.find(x => x.id_clients === vm.eventData.id_client);

                                                        if (client?.crops_config) {
                                                            try {
                                                                const cropsConfigStr = client.crops_config.replaceAll('%%WATERMARK%%', vm.config.cropFormats.watermarkUrl);
                                                                const cropsConfig = JSON.parse(cropsConfigStr);
                                                                vm.config.cropFormats = cropsConfig.crop_formats;
                                                            } catch (err) {
                                                                console.error("Error parsing crops_config JSON:", err);
                                                                setDefaultCropFormats();
                                                            }
                                                        } else {
                                                            setDefaultCropFormats();
                                                        }
                                                        RuntagEventService.postEventWatermark(
                                                            {
                                                                config: vm.config.cropFormats,
                                                                apiUrl: vm.apiUrl
                                                            }
                                                        ).then(resp => {
                                                            $log.warn('resp', resp);
                                                        });
                                                    }
                                                    if (vm.config.regexConfig) {
                                                        RuntagEventService.postEventRegex({
                                                            config: vm.config.regexConfig,
                                                            apiUrl: vm.apiUrl
                                                        })
                                                            .then(resp => {
                                                                vm.loadingRegex = false;
                                                                $mdToast.show({
                                                                    template: '<md-toast layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>{{\'RUNTAG.REGEX_GENERATED_SUCCESS\' | translate}}</span></div></md-toast>',
                                                                    hideDelay: 5000,
                                                                    position: 'top',
                                                                    parent: '#content-container'
                                                                });
                                                            })
                                                            .catch(error => {
                                                                vm.loadingRegex = false;
                                                                console.error('Error al generar regex', error);
                                                                $mdToast.show(
                                                                    $mdToast.simple()
                                                                        .textContent('Error al generar expresiones regulares.')
                                                                        .position('top')
                                                                        .hideDelay(5000)
                                                                );
                                                            });

                                                    }
                                                }
                                            } else {
                                                $mdToast.show({
                                                    template: '<md-toast layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-close" class="icon"></md-icon><span class="md-toast-text" flex>Error de lambda para la creación del evento "' + vm.eventData.event_name + '".</span></div></md-toast>',
                                                    hideDelay: 5000,
                                                    position: 'top',
                                                    parent: '#content-container'
                                                });
                                            }
                                        }).catch(error => {
                                            $mdToast.show({
                                                template: '<md-toast layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-close" class="icon"></md-icon><span class="md-toast-text" flex>Error de lambda para la creación del evento "' + vm.eventData.event_name + '".</span></div></md-toast>',
                                                hideDelay: 5000,
                                                position: 'top',
                                                parent: '#content-container'
                                            });
                                        });
                                    }
                                }).catch(handleSaveError);
                            }).catch(handleSaveError);
                        }).catch(handleSaveError);
                    } else {
                        $mdToast.show({
                            template: '<md-toast layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-close" class="icon"></md-icon><span class="md-toast-text" flex>Ya existe un evento con el nombre "' + vm.eventData.event_name + '".</span></div></md-toast>',
                            hideDelay: 5000,
                            position: 'top',
                            parent: '#content-container'
                        });
                    }
                }).catch(handleSaveError);
            } else {
                let item = angular.copy(vm.eventData);
                item = normalizeEventData(item);

                // Stringify ONCE
                item.regex_options = JSON.stringify(item.regex_options);
                item.prefix_number = JSON.stringify(item.prefix_number);
                item.event_info = JSON.stringify(buildEventInfo());

                if (Array.isArray(item.photographers)) {
                    item.photographers.forEach(x => {
                        delete x.aws_access_key;
                        delete x.aws_secret_key;
                    });
                }
                RuntagEventService.updateItem({
                    siteID: siteID,
                    id: item.id,
                    section: 'events',
                    keepOldMedia: (!item.Thumbnail || item.Thumbnail.length === 0) ? true : false,
                    item: item
                }).then(resp => {
                    $mdToast.show({
                        template: '<md-toast layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>Evento actualizado correctamente</span></div></md-toast>',
                        hideDelay: 3000,
                        position: 'top',
                        parent: '#content-container'
                    });
                }).catch(handleSaveError);
                if (vm.config) {
                    if (vm.config.cropFormats && vm.config.cropFormats.watermarkUrl) {
                        const client = vm.clients.find(x => x.id_clients === vm.eventData.id_client);

                        if (client?.crops_config) {
                            try {
                                const cropsConfigStr = client.crops_config.replaceAll('%%WATERMARK%%', vm.config.cropFormats.watermarkUrl);
                                const cropsConfig = JSON.parse(cropsConfigStr);
                                vm.config.cropFormats = cropsConfig.crop_formats;
                            } catch (err) {
                                console.error("Error parsing crops_config JSON:", err);
                                setDefaultCropFormats();
                            }
                        } else {
                            setDefaultCropFormats();
                        }
                        RuntagEventService.postEventWatermark(
                            {
                                config: vm.config.cropFormats,
                                apiUrl: vm.apiUrl
                            }
                        ).then(resp => {
                            $log.warn('resp', resp);
                        });
                    }
                    if (vm.config.regexConfig) {
                        RuntagEventService.postEventRegex({
                            config: vm.config.regexConfig,
                            apiUrl: vm.apiUrl
                        })
                            .then(resp => {
                                vm.loadingRegex = false;
                                $mdToast.show({
                                    template: '<md-toast layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>{{\'RUNTAG.REGEX_GENERATED_SUCCESS\' | translate}}</span></div></md-toast>',
                                    hideDelay: 5000,
                                    position: 'top',
                                    parent: '#content-container'
                                });
                            })
                            .catch(error => {
                                vm.loadingRegex = false;
                                console.error('Error al generar regex', error);
                                $mdToast.show(
                                    $mdToast.simple()
                                        .textContent('Error al generar expresiones regulares.')
                                        .position('top')
                                        .hideDelay(5000)
                                );
                            });

                    }
                }
            }
        }

        function setDefaultCropFormats() {
            vm.config.cropFormats = [
                {
                    id: "1001",
                    width: 400,
                    height: 400,
                    proportional: true,
                    watermark: false,
                    watermarkUrl: vm.config.cropFormats?.watermarlUrl ?? '',
                    watermarkCenterRatioX: 1.00,
                    watermarkCenterRatioY: 1.00,
                    watermarkSizeRatio: 0.10
                }
            ];
        }

        function editRegex(reg, index) {
            if (reg != 'new') {
                reg.index = index;
            } else {
                reg = { type: 'range' }; // Default to 'range' selection type
            }
            if (reg.end) {
                reg.type = 'range';
            } else {
                reg.type = reg.type || 'single';
            }
            vm.activeRegex = angular.copy(reg);
        }

        function saveRegexOption() {
            if (!Array.isArray(vm.regexOptions)) {
                vm.regexOptions = [];
            }
            delete vm.activeRegex.type;
            if (vm.activeRegex.index != undefined) {
                vm.regexOptions[vm.activeRegex.index] = vm.activeRegex;
                vm.activeRegex = undefined;
            } else {
                vm.regexOptions.push(vm.activeRegex);
                vm.activeRegex = undefined;
            }
        }

        function deleteRegexOption() {
            vm.regexOptions.splice(vm.activeRegex.index, 1);
            vm.activeRegex = undefined;
        }

        function cancelRegexOption() {
            vm.activeRegex = undefined;
        }

        function generateRegex() {
            vm.loadingRegex = true;
            updateRegexPreview();
            vm.saveEvent();
        }

        function updateRegexPreview() {
            if (!Array.isArray(vm.regexOptions)) {
                vm.regexOptions = [];
            }

            let includedPatterns = [];
            let excludedPatterns = [];

            let maxLength = 0;

            vm.regexOptions.forEach(option => {
                let reg = toRegexRange(option.start, option.end, { strictZeros: true });
                if (option.prefix) {
                    reg = option.prefix + reg;
                }
                if (option.exclude) {
                    excludedPatterns.push(reg);
                } else {
                    includedPatterns.push(reg);
                }
                const prefixLength = option.prefix ? option.prefix.length : 0;
                const endLength = option.end ? option.end.toString().length : 0;
                const maxOptionLength = Math.max(
                    option.start ? option.start.toString().length : 0,
                    endLength
                ) + prefixLength;

                if (maxOptionLength > maxLength) {
                    maxLength = maxOptionLength;
                }
            });
            const includeRegex = includedPatterns.length ? `(?:${includedPatterns.join('|')})` : '';
            const excludeRegex = excludedPatterns.length ? `(?!.*(?:${excludedPatterns.join('|')}))` : '';
            const finalReg = `^${excludeRegex}${includeRegex}$`;
            if (!vm.config) {
                vm.config = {};
            }
            vm.config.regexConfig = {
                fullMatch: finalReg,
                fullNumberLength: maxLength
            }
            vm.eventData.regex_options = vm.regexOptions;
        }

        vm.copyToClipboard = function (text) {
            const textarea = document.createElement('textarea');
            textarea.value = text;
            textarea.setAttribute('readonly', '');
            textarea.style.position = 'absolute';
            textarea.style.left = '-9999px';
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            document.body.removeChild(textarea);
            $mdToast.show({
                template: '<md-toast layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-close" class="icon"></md-icon><span class="md-toast-text" flex>Copiado al portapapeles.</span></div></md-toast>',
                hideDelay: 2000,
                position: 'top',
                parent: '#content-container'
            });
        };

        //REGEX GENERATOR======================================

        function isNumber(v) {
            return (typeof v === "number" && v - v === 0) || (typeof v === "string" && Number.isFinite(+v) && v.trim() !== "");
        }

        function toRegexRange(min, max, options) {
            if (!toRegexRange.cache) {
                toRegexRange.cache = {};
            }
            if (isNumber(min) === false) {
                throw new TypeError('toRegexRange: expected the first argument to be a number');
            }

            if (max === void 0 || min === max) {
                return String(min);
            }

            if (isNumber(max) === false) {
                throw new TypeError('toRegexRange: expected the second argument to be a number.');
            }

            var opts = Object.assign({ relaxZeros: true }, options);
            if (typeof opts.strictZeros === 'boolean') {
                opts.relaxZeros = opts.strictZeros === false;
            }

            var relax = String(opts.relaxZeros);
            var shorthand = String(opts.shorthand);
            var capture = String(opts.capture);
            var wrap = String(opts.wrap);
            var cacheKey = min + ':' + max + '=' + relax + shorthand + capture + wrap;

            if (Object.prototype.hasOwnProperty.call(toRegexRange.cache, cacheKey)) {
                return toRegexRange.cache[cacheKey].result;
            }

            var a = Math.min(min, max);
            var b = Math.max(min, max);

            if (Math.abs(a - b) === 1) {
                var result = min + '|' + max;
                if (opts.capture) return `(${result})`;
                if (opts.wrap === false) return result;
                return `(?:${result})`;
            }

            var isPadded = hasPadding(min) || hasPadding(max);
            var state = { min, max, a, b };
            var positives = [];
            var negatives = [];

            if (isPadded) {
                state.isPadded = isPadded;
                state.maxLen = String(state.max).length;
            }

            if (a < 0) {
                var newMin = b < 0 ? Math.abs(b) : 1;
                negatives = splitToPatterns(newMin, Math.abs(a), state, opts);
                a = state.a = 0;
            }

            if (b >= 0) {
                positives = splitToPatterns(a, b, state, opts);
            }

            state.negatives = negatives;
            state.positives = positives;
            state.result = collatePatterns(negatives, positives, opts);

            if (opts.capture === true) {
                state.result = `(${state.result})`;
            } else if (opts.wrap !== false && (positives.length + negatives.length) > 1) {
                state.result = `(?:${state.result})`;
            }

            toRegexRange.cache[cacheKey] = state;
            return state.result;
        }

        function collatePatterns(neg, pos, options) {
            let onlyNegative = filterPatterns(neg, pos, '-', false, options) || [];
            let onlyPositive = filterPatterns(pos, neg, '', false, options) || [];
            let intersected = filterPatterns(neg, pos, '-?', true, options) || [];
            let subpatterns = onlyNegative.concat(intersected).concat(onlyPositive);
            return subpatterns.join('|');
        }

        function splitToRanges(min, max) {
            let nines = 1;
            let zeros = 1;

            let stop = countNines(min, nines);
            let stops = new Set([max]);

            while (min <= stop && stop <= max) {
                stops.add(stop);
                nines += 1;
                stop = countNines(min, nines);
            }

            stop = countZeros(max + 1, zeros) - 1;

            while (min < stop && stop <= max) {
                stops.add(stop);
                zeros += 1;
                stop = countZeros(max + 1, zeros) - 1;
            }

            stops = [...stops];
            stops.sort(compare);
            return stops;
        }

        /**
         * Convert a range to a regex pattern
         * @param {Number} `start`
         * @param {Number} `stop`
         * @return {String}
         */

        function rangeToPattern(start, stop, options) {
            if (start === stop) {
                return { pattern: start, count: [], digits: 0 };
            }

            let zipped = zip(start, stop);
            let digits = zipped.length;
            let pattern = '';
            let count = 0;

            for (let i = 0; i < digits; i++) {
                let [startDigit, stopDigit] = zipped[i];

                if (startDigit === stopDigit) {
                    pattern += startDigit;

                } else if (startDigit !== '0' || stopDigit !== '9') {
                    pattern += toCharacterClass(startDigit, stopDigit, options);

                } else {
                    count++;
                }
            }

            if (count) {
                pattern += options.shorthand === true ? '\\d' : '[0-9]';
            }

            return { pattern, count: [count], digits };
        }

        function splitToPatterns(min, max, tok, options) {
            let ranges = splitToRanges(min, max);
            let tokens = [];
            let start = min;
            let prev;

            for (let i = 0; i < ranges.length; i++) {
                let max = ranges[i];
                let obj = rangeToPattern(String(start), String(max), options);
                let zeros = '';

                if (!tok.isPadded && prev && prev.pattern === obj.pattern) {
                    if (prev.count.length > 1) {
                        prev.count.pop();
                    }

                    prev.count.push(obj.count[0]);
                    prev.string = prev.pattern + toQuantifier(prev.count);
                    start = max + 1;
                    continue;
                }

                if (tok.isPadded) {
                    zeros = padZeros(max, tok, options);
                }

                obj.string = zeros + obj.pattern + toQuantifier(obj.count);
                tokens.push(obj);
                start = max + 1;
                prev = obj;
            }

            return tokens;
        }

        function filterPatterns(arr, comparison, prefix, intersection, options) {
            let result = [];

            for (let ele of arr) {
                let { string } = ele;

                // only push if _both_ are negative...
                if (!intersection && !contains(comparison, 'string', string)) {
                    result.push(prefix + string);
                }

                // or _both_ are positive
                if (intersection && contains(comparison, 'string', string)) {
                    result.push(prefix + string);
                }
            }
            return result;
        }

        /**
         * Zip strings
         */

        function zip(a, b) {
            let arr = [];
            for (let i = 0; i < a.length; i++) arr.push([a[i], b[i]]);
            return arr;
        }

        function compare(a, b) {
            return a > b ? 1 : b > a ? -1 : 0;
        }

        function contains(arr, key, val) {
            return arr.some(ele => ele[key] === val);
        }

        function countNines(min, len) {
            return Number(String(min).slice(0, -len) + '9'.repeat(len));
        }

        function countZeros(integer, zeros) {
            return integer - (integer % Math.pow(10, zeros));
        }

        function toQuantifier(digits) {
            let [start = 0, stop = ''] = digits;
            if (stop || start > 1) {
                return `{${start + (stop ? ',' + stop : '')}}`;
            }
            return '';
        }

        function toCharacterClass(a, b, options) {
            return `[${a}${(b - a === 1) ? '' : '-'}${b}]`;
        }

        function hasPadding(str) {
            return /^-?(0+)\d/.test(str);
        }

        function padZeros(value, tok, options) {
            if (!tok.isPadded) {
                return value;
            }

            let diff = Math.abs(tok.maxLen - String(value).length);
            let relax = options.relaxZeros !== false;

            switch (diff) {
                case 0:
                    return '';
                case 1:
                    return relax ? '0?' : '0';
                case 2:
                    return relax ? '0{0,2}' : '00';
                default: {
                    return relax ? `0{0,${diff}}` : `0{${diff}}`;
                }
            }
        }

        /**
         * Cache
         */

        toRegexRange.clearCache = () => (toRegexRange.cache = {});

    }
})();
(function () {
    'use strict';

    angular.module('app.runtag')
        .controller('changeSubsecEventController', changeSubsecEventController);

    /** @ngInject */
    function changeSubsecEventController($mdDialog, selectedSubsec, eventsSubsecs, selectedLanguage) {
        
        var vm = this;
        vm.selectedSubsec = selectedSubsec;
        vm.eventsSubsecs = eventsSubsecs;
        vm.selectedLanguage = selectedLanguage;

        vm.closeDialog = closeDialog;
        vm.saveDialog = saveDialog;

        function saveDialog() {
            $mdDialog.hide({
                selected: vm.selectedSubsec
            });
        }
        function closeDialog() {
            $mdDialog.hide({
                action: 'closed',
            });
		}
    }
})();
(function () {
    'use strict';

    angular
        .module('app.users')
        .controller('DeleteBlacklistUsersDialogController', DeleteBlacklistUsersDialogController);

    /** @ngInject */
    function DeleteBlacklistUsersDialogController(
        $mdDialog,
        $document,
        selectedThreads,
        siteID,
        section,
        requestContext,
        $anchorScroll,
        $timeout,
        $scope,
        $sce,
        msUtils,
        COMMON,
        $log,
        $translate,
        usersBlacklistService,
        $rootScope,
        $mdToast
    ) {
        var vm = this;

        // Data
        vm.selectedThreads = selectedThreads;
        vm.siteID = siteID;
        vm.isLoading = false;
        vm.mediaRelations = false;


        // Methods
        vm.delete = deleteItems;
        vm.cancel = cancel;

        
        vm.translate = function(text) {
            return $translate.instant(text);
        }

        init();
        /**
         * Initialize
         */
        function init() {

        }

        function cancel() {
            $mdDialog.hide(false);
        }


        function deleteItems() {

            vm.isLoading = true;
            var count = 0;

            for (var i = 0; i < vm.selectedThreads.length; i++) {
                var options = {
                    site: siteID,
                    section: section,
                    id: vm.selectedThreads[i].id_mailing_blacklist
                };
                usersBlacklistService.deleteItem(options).then(function (response) {
                    count++;
                    if (count == vm.selectedThreads.length) {
                        if (vm.selectedThreads.length == 1) {
                          var message = $translate.instant('USERS.DELETED');
                        } else {
                          var message = vm.selectedThreads.length + $translate.instant('USERS.DELETED_PLURAL');
                        }
                        $mdToast.show({
                          template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                          hideDelay: 5000,
                          position: 'top',
                          parent: '#content-container'
                        });
                        $mdDialog.hide(true);
                    }
                });
            }

        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.users')
        .controller('DeleteUsersDialogController', DeleteUsersDialogController);

    /** @ngInject */
    function DeleteUsersDialogController(
        $mdDialog,
        $document,
        selectedThreads,
        siteID,
        section,
        requestContext,
        $anchorScroll,
        $timeout,
        $scope,
        $sce,
        msUtils,
        COMMON,
        $log,
        $translate,
        usersService,
        $rootScope,
        $mdToast
    ) {
        var vm = this;

        // Data
        vm.selectedThreads = selectedThreads;
        vm.siteID = siteID;
        vm.isLoading = false;
        vm.mediaRelations = false;


        // Methods
        vm.delete = deleteItems;
        vm.cancel = cancel;

        
        vm.translate = function(text) {
            return $translate.instant(text);
        }

        init();
        /**
         * Initialize
         */
        function init() {

        }

        function cancel() {
            $mdDialog.hide(false);
        }


        function deleteItems() {

            vm.isLoading = true;
            var count = 0;

            for (var i = 0; i < vm.selectedThreads.length; i++) {
                var options = {
                    site: siteID,
                    section: section,
                    id: vm.selectedThreads[i].id_user
                };
                usersService.deleteItem(options).then(function (response) {
                    count++;
                    if (count == vm.selectedThreads.length) {
                        if (vm.selectedThreads.length == 1) {
                          var message = $translate.instant('USERS.DELETED');
                        } else {
                          var message = vm.selectedThreads.length + $translate.instant('USERS.DELETED_PLURAL');
                        }
                        $mdToast.show({
                          template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                          hideDelay: 5000,
                          position: 'top',
                          parent: '#content-container'
                        });
                        $mdDialog.hide(true);
                    }
                });
            }

        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.users')
        .controller('ChangeInGroupStatusDialogController', ChangeInGroupStatusDialogController);

    /** @ngInject */
    function ChangeInGroupStatusDialogController(
        $mdDialog,
        $document,
        ingroupStatus,
        isAccreditations,
        selectedUser,
        selectedGroup,
        selectedStatus,
        siteID,
        requestContext,
        $anchorScroll,
        $timeout,
        $scope,
        $sce,
        msUtils,
        COMMON,
        $log,
        $translate,
        usersService,
        $rootScope,
        $mdToast,
        $q
    ) {
        var vm = this;

        // Data
        vm.isAccreditations = isAccreditations;
        vm.ingroupStatus = ingroupStatus;
        vm.selectedUser = selectedUser;
        vm.selectedGroup = selectedGroup;
        vm.selectedStatus = selectedStatus;
        vm.siteID = siteID;
        vm.isLoading = false;
        vm.userGroup = null;
        vm.currentIngroupStatusId = 0;
        vm.formActions = null;

        vm.defaultLangTest = "en";
        vm.actionsTest = [
            {
                "type": "action",
                "action": "add_to_group",
                "options": {
                    "id_group": 12,
                    "id_ingroup_status": 2
                }
            },
            {
                "type": "action",
                "action": "link",
                "options": {
                    "url": "https://demo.qiumediacenter.com/api/accion_customizada"
                }
            },
            {
                "type": "checkbox",
                "field_type": "checkbox",
                "field": "welcome_email",
                "name": "Send Welcome email to user",
                "actions": [
                    {
                        "type": "action",
                        "action": "send_email",
                        "options": {
                            "languages": {
                                "en": {
                                    "id_communicator": 7
                                },
                                "es": {
                                    "id_communicator": 8
                                },
                                "fr": {
                                    "id_communicator": 9
                                }
                            }
                        }
                    }
                ],
                "languages": [
                    {
                        "value": "en",
                        "isDefault": true,
                        "name": "EN"
                    },
                    {
                        "value": "es",
                        "isDefault": false,
                        "name": "ES"
                    },
                    {
                        "value": "fr",
                        "isDefault": false,
                        "name": "FR"
                    }
                ],
                "childrenLabel": "Custom Texts",
                "children": [
                    {
                        "language": "en",
                        "isDefault": true,
                        "type": "variable",
                        "field_type": "text",
                        "field": "custom_text",
                        "name": "Custom Text",
                        "placeholder": "Insert custom text to send in email"
                    },
                    {
                        "language": "en",
                        "isDefault": true,
                        "type": "variable",
                        "field_type": "text",
                        "field": "custom_signature",
                        "name": "Custom Signature",
                        "placeholder": "Insert a custom signature"
                    }
                ]
            }
        ];

        // Methods
        vm.save = save;
        vm.cancel = cancel;
        vm.updateActions = updateActions;

        vm.translate = function (text) {
            return $translate.instant(text);
        }

        init();
        /**
         * Initialize
         */
        function init() {
            angular.forEach(vm.selectedUser.groups, function (userGroup) {
                if (userGroup.id_group == vm.selectedGroup.id_group) {
                    vm.currentIngroupStatusId = angular.copy(userGroup.users_ingroup.id_ingroup_status);
                }
            });
            //vm.actions = vm.selectedStatus.actions;
            vm.actions = angular.copy(vm.actionsTest);
            loadFormActions();
        }

        function cancel() {
            $mdDialog.hide(false);
        }

        function save() {
            vm.isLoading = true;
            if (vm.isAccreditations) {

                // Update user's ingroup status
                angular.forEach(vm.selectedUser.groups, function (userGroup) {
                    if (userGroup.id_group == vm.selectedGroup.id_group) {
                        userGroup.users_ingroup.id_ingroup_status = vm.currentIngroupStatusId;
                    }
                });
                var options = {
                    "siteID": vm.siteID,
                    "id": vm.selectedGroup.id_group,
                    "id_user": vm.selectedUser.id_user,
                    "id_ingroup_status": vm.currentIngroupStatusId
                }

                usersService.updateUsersFromGroup(options).then(function (res) {
                    $mdDialog.hide(vm.selectedUser);
                })
            } else {
                // Update user's ingroup status
                angular.forEach(vm.selectedUser.groups, function (userGroup) {
                    if (userGroup.id_group == vm.selectedGroup.id_group) {
                        userGroup.users_ingroup.id_ingroup_status = vm.currentIngroupStatusId;
                    }
                });

                // Execute default and selected actions
                angular.forEach(vm.actions, function (actionItem) {
                    var promiseQueue = processAction(actionItem, false, []);
                    $q.all(promiseQueue).then(function (responses) {
                        angular.forEach(responses, function (response) {
                            console.log(response.data);
                        });
                        $mdDialog.hide(vm.selectedUser);
                    });
                });
            }


        }

        function loadFormActions() {
            angular.forEach(vm.actions, function (action) {
                switch (action.type) {
                    case 'checkbox':
                        if (vm.formActions == null) {
                            vm.formActions = {};
                        }
                        vm.formActions[action.field] = action;
                        break;
                }
            });
        }

        function updateActions() {
            if (!vm.isAccreditations) {
                vm.formActions = null;
                vm.isLoading = true;
                angular.forEach(vm.ingroupStatus, function (ingroupStatus) {
                    if (ingroupStatus.id_ingroup_status == vm.currentIngroupStatusId) {
                        $timeout(function () {
                            //vm.actions = ingroupStatus.actions;
                            vm.actions = angular.copy(vm.actionsTest);
                            loadFormActions();
                            vm.isLoading = false;
                        }, 1000);
                    }
                });
            }
        }

        function processAction(action, parent, promiseQueue) {

            switch (action.type) {
                case 'action':
                    // hidden default actions, run always.
                    promiseQueue.push(runAction(action, parent));
                    break;
                case 'checkbox':
                    if (vm.formActions[action.field].formValue === true) {
                        var parent = action;
                        angular.forEach(action.actions, function (action) {
                            processAction(action, parent, promiseQueue);
                        });
                    }
                    break;
            }
            return promiseQueue;
        }

        function runAction(item, parent) {
            switch (item.action) {
                case 'add_to_group':
                    return actionAddToGroup(item, parent);
                    break;
                case 'link':
                    return actionLink(item, parent);
                    break;
                case 'send_email':
                    return actionSendEmail(item, parent);
                    break;
            }
        }

        function actionAddToGroup(item, parent) {
            // ajax mock
            var deferred = $q.defer();
            $timeout(function () {
                deferred.resolve({ data: ['Added user to group.', item, parent] });
            }, 1000);
            return deferred.promise;
        }

        function actionLink(item, parent) {
            // ajax mock
            var deferred = $q.defer();
            $timeout(function () {
                deferred.resolve({ data: ['Link called.', item.options.url, parent] });
            }, 1000);
            return deferred.promise;
        }

        function actionSendEmail(item, parent) {
            // ajax mock
            var deferred = $q.defer();
            $timeout(function () {
                deferred.resolve({ data: ['Email sent.', item, parent] });
            }, 1000);
            return deferred.promise;
        }
    }
})();

(function () {
	'use strict';

	angular
		.module('app.users')
		.controller('SaveTemplateExportDialogController', SaveTemplateExportDialogController)

	/** @ngInject */
	function SaveTemplateExportDialogController($mdDialog, usersService, siteID, data) {
		var vm = this;

		vm.closeDialog = closeDialog;
		vm.saveTemplate = saveTemplate;
		vm.siteID = siteID;
		vm.data = data;
		vm.name = '';
		vm.description = '';

		vm.translate = function (text) {
			return $translate.instant(text);
		}



		function closeDialog() {
			$mdDialog.hide();
		}

		function saveTemplate() {
			vm.saving = true;
			var options = {
				siteID: vm.siteID,
				item: {
					"name": vm.name,
					"description": vm.description,
					"fields": vm.data.map(x => {
						return {
							"name": x.title,
							"field": x.field_name
						}
					})
				}
			};
			usersService.saveTemplateExport(options).then((res) => {
				$mdDialog.hide(true);
			})
		}


	}


})();

(function () {
    'use strict';

    angular
        .module('app.users')
        .controller('ChangePriorityGroupDialogController', ChangePriorityGroupDialogController);

    /** @ngInject */
    function ChangePriorityGroupDialogController(
        $mdDialog,
        $document,
        siteID,
        sourceGroups,
        mailingPriorities,
        selectedThreads,
        $anchorScroll,
        $timeout,
        $scope,
        $sce,
        msUtils,
        COMMON,
        $log,
        $translate,
        usersService,
        transformUsers,
        $rootScope,
        $mdToast
    ) {
        var vm = this;

        // Data
        vm.groups = sourceGroups;
        vm.mailingPriorities = mailingPriorities;
        vm.selectedThreads = selectedThreads;
        vm.selectedPriority = undefined;
        // Methods
        vm.cancel = cancel;
        vm.save = save;
        vm.siteID = siteID;
        init();
        /**
         * Initialize
         */
        function init() {
        }
        
        function save(){
            if(vm.selectedThreads.length > 0){
                var response = {
                    users: vm.selectedThreads,
                    priority: vm.selectedPriority
                }
                $mdDialog.hide(response);
            }else{
                $scope.isLoading = true;
                var options = {
                    domain: vm.siteID,
                    mailing_priority: vm.selectedPriority,
                    groupID: vm.groups[0].id_group
                }
                usersService.changeGroupPriority(options).then(function(response){
                    $mdDialog.hide();
                    $scope.isLoading = false;
                }, function(error) {
                    $mdDialog.hide();
                    $scope.isLoading = false;
                });
            }
        }

        function cancel() {
            $mdDialog.hide();
        }
        
    }
})();

(function () {
    'use strict';

    angular
        .module('app.users')
        .controller('EditGroupDialogController', EditGroupDialogController)
        .directive('qiuUsersOnClickSelectParentGroup', ['usersService', SelectParentGroup]);

    /** @ngInject */
    function EditGroupDialogController($scope, $mdDialog, group, currentGroupTypeId, siteID, usersService, $mdToast, transformUsers, $translate, msUtils,
        hasAdvancedSettingsAccess, groupType) {

        var vm = this;

        vm.group = group;
        vm.groupName = group.name;
        vm.groupParentId = null;
        vm.groupParentName = '';
        vm.groupTypeId = angular.isDefined(group.id_group_type) ? group.id_group_type : currentGroupTypeId;
        vm.groupType = angular.isDefined(groupType) ? groupType : null;
        vm.groupStatusId = group.id_group_status;
        vm.groupSort = group.sort;
        vm.hasAdvancedSettingsAccess = hasAdvancedSettingsAccess;
        vm.isQiuRestricted = false;
        vm.isAdvancedSettingsShowing = false;
        vm.validJson = true;
        vm.groupSettings = {};
        vm.groupTypeFields = [];

        vm.setItemStatus = setItemStatus;
        vm.showSettings = showSettings;
        vm.showSettingsAdvanced = showSettingsAdvanced;
        vm.setValid = setValid;

        vm.translate = function (text) {
            return $translate.instant(text);
        }

        init();

        function init() {
            vm.groupRawSettings = JSON.stringify(group.raw_settings);
            // Use qiu-field templates in Advanced group tab if group's raw_settings define templates in a 'view_params' property.
            if (vm.groupType && vm.groupType.hasOwnProperty('raw_settings') && vm.groupType.raw_settings != null) {
                var groupTypeRawSettings = JSON.parse(vm.groupType.raw_settings);
                if (groupTypeRawSettings.hasOwnProperty('view_params') && angular.isArray(groupTypeRawSettings.view_params)) {
                    vm.groupTypeFields = groupTypeRawSettings.view_params;
                    vm.groupRawSettings = group.raw_settings ? group.raw_settings : {}; // Use empty object if raw_settings are null.
                }
            }
            vm.selectParentGroupRoot = selectParentGroupRoot;
            var opts = {
                siteID: siteID,
                withGroupType: true
            };
            if (currentGroupTypeId > 0) {
                opts.groupType = currentGroupTypeId;
            }
            usersService.getUsersGroups(opts).then(function (response) {
                var qiuRestrictions = response.qiuRestrictions;
                var groups = response.data;
                var nestedGroups = transformUsers.formatNestedGroups(groups, qiuRestrictions, true);

                if (angular.isArray(nestedGroups) &&
                    nestedGroups.length > 0 &&
                    nestedGroups[0].is_qiu_restricted_root
                ) {
                    vm.isQiuRestricted = true;
                    vm.groupParentName = nestedGroups[0].name;
                    vm.groupParentId = nestedGroups[0].id_group;
                }

                var options = { siteID: siteID, };
                usersService.getRef(options).then(function (ref) {
                    var found = ref.find(x => x.category === 'show_groups');
                    if (found) {
                        nestedGroups = cleanByType(nestedGroups, JSON.parse(found.field_name));
                    }
                    vm.groups = removeGroupFromNestedGroups(group, nestedGroups);
                    var unnestedGroups = getUnnestedGroups(groups, []);
                    angular.forEach(unnestedGroups, function (obj) {
                        if (obj.id_group == group.parent) {
                            vm.groupParentName = obj.name;
                            vm.groupParentId = obj.id_group;
                        }
                    });
                    $scope.isLoadingGroups = false;
                })
            }, function (error){
                if (error && error.data && error.data.detail) {
                    msUtils.showError(error.data.detail)
                }
            });
            usersService.getUsersGroupsTypes({ siteID: siteID }).then(function (response) {
                vm.groupTypes = response;
                if (currentGroupTypeId > 0) {
                    vm.groupTypes = vm.groupTypes.filter(x => x.id_group_type == currentGroupTypeId) 
                }
            });
        }

        function cleanByType(arrayGroups, groupTypes) {
            arrayGroups = arrayGroups.filter(x => groupTypes.find(y => y === x.id_group_type))
            for (let i = 0; i < arrayGroups.length; i++) {
                const group = arrayGroups[i];
                if (group.children) {
                    group.children = cleanByType(group.children, groupTypes);
                }
            }
            return arrayGroups;
        }

        $scope.hide = function () {
            $mdDialog.hide();
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        $scope.delete = function (group) {

            // TODO: show advice that users from group won't be deleted.

            var messageTitle = $translate.instant('GROUP.SURE_DELETED_SINGULAR');
            var messageBody = $translate.instant('GROUP.ITEM_WILL_DELETE');
            var confirm = $mdDialog.confirm()
                .title(messageTitle)
                .ariaLabel(messageTitle)
                .htmlContent(messageBody)
                .targetEvent(event)
                .ok($translate.instant('ACCOUNTS.OK'))
                .cancel($translate.instant('ACCOUNTS.CANCEL'))
                .multiple(true);
            $mdDialog.show(confirm).then(function () {
                usersService
                    .deleteUsersGroup(siteID, group.id_group)
                    .then(function (response) {
                        $mdDialog.hide(true);
                        usersService.triggerReloadGroups();
                    }).catch(function (err) {
                        var message = $translate.instant('GLOBAL.ERROR') + '<br>' + err.data.detail;

                        $mdToast.show({
                            template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                            hideDelay: 5000,
                            position: 'top',
                            parent: '#content-container'
                        });
                    });

            }, function () {
            });


        };

        $scope.save = function (group) {
            if (angular.equals({}, group)) {
                usersService
                    .createUsersGroup(siteID, vm.groupParentId, vm.groupName, vm.groupTypeId, vm.groupStatusId, vm.groupSort)
                    .then(function (response) {
                        // TODO: show success message
                        $mdDialog.hide(true);
                        usersService.triggerReloadGroups();
                    }, function(error) {
                        if (error && error.data && error.data.detail) {
                            msUtils.showError(error.data.detail)
                        }
                    });
            } else {
                var groupRawSettings = getGroupRawSettings();
                usersService
                    .editUsersGroup(siteID, group.id_group, vm.groupParentId, vm.groupName, vm.groupTypeId, vm.groupStatusId, vm.groupSort, groupRawSettings)
                    .then(function (response) {
                        // TODO: show success message
                        $mdDialog.hide(true);
                        usersService.triggerReloadGroups();
                    }, function (error) {
                        if (error && error.data && error.data.detail) {
                            msUtils.showError(error.data.detail)
                        }
                    });
            }
        };

        /**
         * Returns group raw settings as json object.
         */
        function getGroupRawSettings() {
            var result = null;
            if (typeof vm.groupRawSettings === 'string' || vm.groupRawSettings instanceof String) {
                // Raw settings are manipulated as a string by means of a text editor. Needs to be parsed.
                try {
                    result = JSON.parse(vm.groupRawSettings);
                } catch(e) {}
            } else {
                // Raw settings are properties of vm.groupRawSettings object,
                // and manipulated individually by means of qiu-field templates.Use as is.
                result = vm.groupRawSettings;
            }
            return result;
        }

        $scope.$on('selectParentGroup', function (event, parentGroup) {
            vm.groupParentId = parentGroup.id_group;
            vm.groupParentName = parentGroup.name;
        });


        function selectParentGroupRoot() {
            vm.groupParentName = $translate.instant('GROUP.ROOT');
            vm.groupParentId = null;
        }

        function getUnnestedGroups(groups, result) {
            angular.forEach(groups, function (group) {
                if (group.id_group) {
                    result.push(group);
                    if (typeof group.children !== 'undefined' && group.children.length > 0) {
                        getUnnestedGroups(group.children, result);
                    }
                }
            });
            return result;
        }

        function removeGroupFromNestedGroups(group, groups) {

            angular.forEach(groups, function (obj) {
                if (group.id_group == obj.id_group) {
                    var index = groups.indexOf(obj);
                    groups.splice(index, 1);
                }
                if (typeof obj.children !== 'undefined' && obj.children.length > 0) {
                    removeGroupFromNestedGroups(group, obj.children);
                }
            });
            return groups;
        }

        function setItemStatus(status) {
            vm.groupStatusId = status;
        }

        function showSettings() {
            vm.isAdvancedSettingsShowing = false;
        }

        function showSettingsAdvanced() {
            vm.isAdvancedSettingsShowing = true;
        }

        function setValid(form) {
          try {
            JSON.parse(vm.groupRawSettings);
            form.groupRawSettings.$setValidity('validJson', true);
          } catch (error) {
            form.groupRawSettings.$setValidity('validJson', false);
          }
        }
    }

    function SelectParentGroup(usersService) {

        function unselectAllGroups() {
            var elemList = document.querySelectorAll('.select-parent-group-row');
            elemList.forEach(function (elem) {
                elem.classList.remove('selected');
            });
        }

        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                $(element).on('click', function (e) {
                    var groupNode = false;
                    if (element.parent().hasClass('selected')) {
                        unselectAllGroups();
                    } else {
                        unselectAllGroups();
                        element.parent().addClass('selected');
                        groupNode = scope.node;
                    }
                    usersService.triggerSelectParentGroup(groupNode);
                });
            }
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.users')
        .controller('AddUsersToGroupsDialogController', AddUsersToGroupsDialogController)
        .controller('GridGroupsDialogController', GridGroupsDialogController)
        ;

    /**
     * Modal de gestión de grupos de UN usuario desde la rejilla Excel. Reutiliza el árbol
     * de grupos (tree-view.html) pre-marcado con los grupos actuales del usuario, y al
     * guardar calcula el diff: añade los nuevos (massInsertUsersIntoGroups) y quita los
     * desmarcados (removeUsersFromGroup). Luego recarga los grupos de esa fila.
     * @ngInject
     */
    function GridGroupsDialogController($scope, $mdDialog, $q, $timeout, user, siteID,
        CleanUsersGroups, ingroupStatus, usersService, transformUsers, $translate, $mdToast, msUtils) {

        var vm = this;
        vm.user = user;
        vm.loading = false;
        vm.saving = false;
        vm.viewUsersGroup = '';
        vm.closeDialog = closeDialog;
        vm.save = save;

        init();

        function init() {
            vm.originalGroupIds = (user.groups || []).map(function (g) { return g.id_group; });
            $timeout(function () {
                vm.usersGroups = transformUsers.initGroupsTree(angular.copy(CleanUsersGroups), user.groups || [], ingroupStatus);
                vm.viewUsersGroup = 'app/main/dialogs/users-group/tree-view.html';
                vm.treeIsLoaded = true;
            });
        }

        function closeDialog() { vm.viewUsersGroup = ''; $mdDialog.cancel(); }

        function getSelectedGroups(groups, result) {
            angular.forEach(groups, function (group) {
                if (group.assigned_group === true) { result.push(group); }
                if (group.children && group.children.length) { getSelectedGroups(group.children, result); }
            });
            return result;
        }

        function save() {
            vm.saving = true;
            var selected = getSelectedGroups(vm.usersGroups, []);
            var selectedIds = selected.map(function (g) { return g.id_group; });
            var toAdd = selected.filter(function (g) { return vm.originalGroupIds.indexOf(g.id_group) < 0; });
            var toRemove = vm.originalGroupIds.filter(function (id) { return selectedIds.indexOf(id) < 0; });

            var ops = [];
            if (toAdd.length) {
                ops.push(usersService.massInsertUsersIntoGroups({ siteID: siteID, data: { id_users: [user.id_user], groups: toAdd } }));
            }
            angular.forEach(toRemove, function (id) {
                ops.push(usersService.removeUsersFromGroup({ siteID: siteID, data: { id_group: id, id_user: [user.id_user] } }));
            });

            if (!ops.length) { vm.saving = false; $mdDialog.cancel(); return; }

            $q.all(ops).then(function () {
                // Recargamos los grupos reales de ESE usuario y los reflejamos en la fila.
                usersService.getUserByID({ site: siteID, id: user.id_user }).then(function (resp) {
                    var fresh = JSON.parse(angular.toJson(resp));
                    user.groups = fresh.groups || [];
                    vm.saving = false;
                    $mdDialog.hide({ groups: user.groups });
                }, function () { vm.saving = false; $mdDialog.hide({ groups: user.groups }); });
            }, function (err) {
                vm.saving = false;
                if (err && err.data && err.data.detail) { msUtils.showError(err.data.detail); }
            });
        }
    }

    /** @ngInject */
    function AddUsersToGroupsDialogController(
        $scope,
        $mdDialog,
        users,
        siteID,
        CleanUsersGroups,
        ingroupStatus,
        usersService,
        sharedFunctionsMailing,
        $translate,
        $mdToast,
        msUtils,
        transformUsers,
        $timeout
    ) {

        var vm = this;

        //Data
        
        vm.loading = false;

        // Methods
        vm.closeDialog = closeDialog;
        vm.save = save;

        init();

        function init() {
            $timeout(function(){
                vm.usersGroups = transformUsers.initGroupsTree(angular.copy(CleanUsersGroups), [], ingroupStatus);
                vm.viewUsersGroup = 'app/main/dialogs/users-group/tree-view.html';
                vm.users = users;
            })
        }

        function closeDialog() {
            vm.viewUsersGroup = '';
            $mdDialog.hide();
        }

        function save() {
            vm.loading = true;
            var groups = getSelectedGroups(vm.usersGroups, []);
            if (groups.length < 1) {
                    vm.loading = false;
                    var message = $translate.instant('USERS.NO_GROUP_SELECTED');
                    $mdToast.show({
                        template: '<md-toast id="language-message"><span class="md-toast-text" flex>' + message + '</span><md-button ng-click="closeToast()">X</md-button></md-toast>',
                        hideDelay: 7000,
                        position: 'top right',
                        parent: '#main'
                    });
                    return false;
            }

            var userIDs = [];
            angular.forEach(users, function(user){
                userIDs.push(user.id_user);
            });

            var options = {
                siteID: siteID,
                data: {
                    id_users: userIDs,
                    groups: groups
                }
            };

            usersService.massInsertUsersIntoGroups(options)
                .then(function (response) {
                    vm.reload = true;
                    if (userIDs.length == 1) {
                        var message = $translate.instant('USERS.ADDTOGROUPS_SINGULAR');
                    } else {
                        var message = userIDs.length + $translate.instant('USERS.ADDTOGROUPS_PLURAL');
                    }
                    vm.loading = false;
                    $mdToast.show({
                        template: '<md-toast id="language-message"><span class="md-toast-text" flex>' + message + '</span><md-button ng-click="closeToast()">X</md-button></md-toast>',
                        hideDelay: 7000,
                        position: 'top right',
                        parent: '#main'
                    });
                    vm.closeDialog();
                }, function(error){
                    if (error.data.detail) {
                        msUtils.showError(error.data.detail);
                    }
                });

            $mdDialog.hide();
        }


        function getSelectedGroups(groups, result) {

          angular.forEach(groups, function(group) {
            if(angular.isDefined(group.assigned_group) && group.assigned_group == true) {
              result.push(group);
            }
            if (typeof group.children !== 'undefined' && group.children.length >0) {
              getSelectedGroups(group.children, result);
            }
          });
          return result;
        }

    }

})();

(function () {
	'use strict';

	angular
		.module('app.users')
		.controller('ImportDialogController', ImportDialogController)
		.directive('qiuOnSelectParentUsersGroup', ['$rootScope', ToggleAssignedGroup])

	/** @ngInject */
	function ImportDialogController($mdDialog, $rootScope, $mdToast, $scope, $timeout, siteID, rootGroup, selectedGroup, $translate, Upload,
		usersService, uploadService, transformUsers) {
		var vm = this;

		vm.importUsers = importUsers;
		vm.closeDialog = closeDialog;
		vm.closeDialogAndUpdate = closeDialogAndUpdate;
		vm.resetForm = resetForm;
		vm.isHeaderMatch = isHeaderMatch;
		vm.siteID = siteID;
		vm.upload = upload;
		vm.rootGroup = rootGroup; // Qiu-restricted root group, only set if qiu-restricted user, else null.
		vm.selectedGroup = selectedGroup; // Currently selected group
		vm.usersGroupsFilters = [];
		vm.parentRootName = $translate.instant('GROUP.ROOT');
		vm.isQiuRestricted = false;

		if (vm.rootGroup) {
			vm.rootGroupName = vm.rootGroup.name;
			vm.rootGroupId = vm.rootGroup.id_group;
			vm.rootGroupRawSettings = vm.rootGroup.raw_settings;
			vm.isQiuRestricted = true;
		}
		if (vm.selectedGroup) {
			vm.groupSelectedName = vm.selectedGroup.name;
			vm.groupSelectedId = vm.selectedGroup.id_group;
			vm.groupSelectedRawSettings = vm.selectedGroup.raw_settings;
		} else {
			if (vm.rootGroup) {
				vm.groupSelectedName = vm.rootGroup.name;
				vm.groupSelectedId = vm.rootGroup.id_group;
				vm.groupSelectedRawSettings = vm.rootGroup.raw_settings;
			}
		}

		vm.resetForm();

		vm.translate = function (text) {
			return $translate.instant(text);
		}
		function importUsers() {
			var mailMapped = false;
			Object.keys(vm.mapping).forEach(function (key, index) {
				if (vm.mapping[key] == null) {
					delete vm.mapping[key];
				}
				if (vm.mapping[key] == 'email') {
					mailMapped = true;
				}
			});
			if (!mailMapped) {
				var message = vm.translate('USERS.MAIL_MAPPING_OBLIGATORY');
				$mdToast.show({
					template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg">' + message + '</div></md-toast>',
					hideDelay: 7000,
					position: 'top',
					parent: '#login-form-wrapper'
				});
				return;
			}
			var options = {
				siteID: vm.siteID,
				token: vm.token,
				targetGroup: vm.groupSelectedId,
				options: vm.optionsDefault,
				fieldMap: vm.mapping,
				primaryKey: 'email',
				ignoreDuplicates: !vm.udpateDuplicates
			}
			vm.isLoading = true;
			usersService.importUsers(options).then(function (response) {
				if (vm.rootGroupId && vm.rootGroupId != vm.groupSelectedId) {
					// All imported users must be in root group.
					let options = {
						siteID: vm.siteID,
						data: {
							source_groups: [vm.groupSelectedId],
							target_groups: [vm.rootGroupId]
						}
					};
					usersService.copyUsersInGroupsToGroups(options);
				}
				vm.isLoading = false;
				vm.importFinished = true;
				vm.resultImport = response;
			}, function (error) {
				vm.importError = error.data.detail;
				console.log(error)
			})
		}

		function resetForm() {
			vm.mapping = {};
			vm.isLoading = false;
			vm.primaryKey = 'email';
			vm.udpateDuplicates = true;
			vm.optionsDefault = {
				delimiter: ",",
				enclosure: "",
				escape: "\\",
				includeFirstRow: false
			}
			delete vm.importError;
			delete vm.importFinished;
			delete vm.resultImport;
			delete vm.fileInfo;
			delete vm.files;
		}



		usersService.getUsersGroups({
			siteID: vm.siteID,
			withGroupType: true
		}).then(function (response) {
			var qiuRestrictions = response.qiuRestrictions;
			var groups = response.data;
			var nestedGroups = transformUsers.formatNestedGroups(groups, qiuRestrictions, true);
			/*
			console.log('nestedGroup root', nestedGroups[0])
			console.log('rootGroup', vm.rootGroup)
			if (!vm.rootGroup &&
				angular.isArray(nestedGroups) &&
                nestedGroups.length > 0 &&
                nestedGroups[0].is_qiu_restricted_root
            ) {
                vm.isQiuRestricted = true;
                vm.rootGroupName = nestedGroups[0].name;
                vm.rootGroupId = nestedGroups[0].id_group;
                vm.rootGroupRawSettings = nestedGroups[0].raw_settings;
            }
            */
			vm.groups = nestedGroups;
		});

		usersService.getUsersGroupsTypes({ siteID: siteID }).then(function (response) {
			vm.groupTypes = response;
		});

		function selectParentGroupRoot() {
			vm.groupSelectedName = vm.parentRootName;
			vm.groupSelectedId = null;
			vm.groupSelectedRawSettings = null;
		}

		$scope.$watch('vm.files', function () {
			$scope.formUpload = false;
			if (vm.files != null) {
				// make files array for not multiple to be able to be used in ng-repeat in the ui
				if (!angular.isArray(vm.files)) {
					$timeout(function () {
						$scope.files = vm.files = [vm.files];
					});
					return;
				}
				for (var i = 0; i < vm.files.length; i++) {
					$scope.errorMsg = null;
					(function (f) {
						vm.isLoading = true;
						vm.upload(f, true);
					})(vm.files[i]);
				}
			}
		});
		
		$scope.log = '';
    
    	// function upload(file) {
		// 	if (!file.$error) {
		// 		file.processed = false;
		// 		var uploadOptions = {
		// 			siteID: siteID,
		// 			filename: file.name,
		// 			fileSizeKb: (angular.isDefined(file.size)) ? (parseInt(file.size) / 1000).toFixed(2) : null,
    	//   			log: $scope.log,
		// 			type: 'users'
		// 		}
		// 		//				console.debug("UPLOAD______****", file)
		// 		uploadService.upload(file, uploadOptions).then(function (resp) {
		// 			console.log('resp', resp);
    	//   			$scope.log = resp.log;
		// 			vm.token = resp.token;
    	  			
		// 			usersService.getFileInfo({
		// 				domain: vm.siteID,
		// 				token: vm.token,
		// 				options: vm.optionsDefault
		// 			}).then(function (fileInfo) {
		// 				vm.fileInfo = fileInfo;
		// 				for (var i = 0; i < vm.fileInfo.file.headers.length; i++) {
		// 					const header = vm.fileInfo.file.headers[i];
		// 					vm.mapping[header] = null;
		// 				}
		// 				vm.isLoading = false;
		// 				if (vm.selectedGroup) {
		// 					// Programmatically set selected group as target group and validate.
		// 					$scope.$broadcast('toggleAssignedGroup', vm.selectedGroup);
		// 				} else {
		// 					if (vm.isQiuRestricted) { 
		// 						validateMaxLimit().then(function(){}, function(error){
		// 							vm.groupSelectedId = null;
		// 							vm.groupSelectedName = null;
		// 							vm.groupSelectedRawSettings = null;
		// 						});
		// 					} else {
		// 						vm.selectParentGroupRoot = selectParentGroupRoot;
		// 					}
		// 				}
		// 			}, function (error) {
		// 				console.log('here', error);
		// 				var message = $translate.instant('USERS.FILE_INFO_ERROR');
		// 				showErrorToast(message);
		// 				vm.isLoading = false;
		// 				vm.files = [];
		// 			})
					
		// 		});
		// 	}
		// };

		function upload(file) {
			if (!file.$error) {
				//				console.debug("UPLOAD______****", file)
				usersService.getS3UploadPreSignedUrl({
					siteID: vm.siteID,
					fileName: file.name,
					fileSizeKb: (angular.isDefined(file.size)) ? (parseInt(file.size) / 1000).toFixed(2) : null
				})
					.then(function (resp) {
						vm.token = resp.token;
						file.upload = Upload.http({
							url: resp.url,
							skipAuthorization: true,
							method: 'PUT',
							headers: {
								"Content-Type": file.type != '' ? file.type : 'application/octet-stream'
							},
							data: file
						});
						file.upload.then(function (response) {
							file.result = response.data;
							$timeout(function () {
								$scope.log = 'file: ' +
									file.name +
									', Response: ' + JSON.stringify(response.data) +
									', ID: ' + file.id_media +
									'\n' + $scope.log;
							});
							usersService.getFileInfo({
								domain: vm.siteID,
								token: vm.token,
								options: vm.optionsDefault
							}).then(function (fileInfo) {
								vm.fileInfo = fileInfo;
								for (var i = 0; i < vm.fileInfo.file.headers.length; i++) {
									const header = vm.fileInfo.file.headers[i];
									vm.mapping[header] = null;
								}
								vm.isLoading = false;
								if (vm.selectedGroup) {
									// Programmatically set selected group as target group and validate.
									$scope.$broadcast('toggleAssignedGroup', vm.selectedGroup);
								} else {
									if (vm.isQiuRestricted) { 
										validateMaxLimit().then(function(){}, function(error){
											vm.groupSelectedId = null;
											vm.groupSelectedName = null;
											vm.groupSelectedRawSettings = null;
										});
									} else {
										vm.selectParentGroupRoot = selectParentGroupRoot;
									}
								}
							}, function (error) {
								console.log('here', error);
								var message = $translate.instant('USERS.FILE_INFO_ERROR');
								showErrorToast(message);
								vm.isLoading = false;
								vm.files = [];
							})
						}, function (response) {
							if (response.status > 0)
								$scope.errorMsg = response.status + ': ' + response.data;
						});
						file.upload.progress(function (evt) {
							file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
						});
					})
			}
		};

		$scope.$on('toggleAssignedGroup', function (event, selectedGroup) {
			vm.groupSelectedId = selectedGroup.id_group;
			vm.groupSelectedName = selectedGroup.name;
			vm.groupSelectedRawSettings = selectedGroup.raw_settings;
			validateMaxLimit().then(function(){}, function(error){
				vm.groupSelectedId = null;
				vm.groupSelectedName = null;
				vm.groupSelectedRawSettings = null;
				if (error.totalUsersAllowed) {
					var message = $translate.instant('USERS.ALLOW_LIMIT_EXCEEDED', { limit: error.totalUsersAllowed });
					showErrorToast(message);
				}
			});
		});

		function showErrorToast(message) {
			$mdToast.show({
				template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg">' + message + '</div></md-toast>',
				hideDelay: 7000,
				position: 'top',
				parent: '#login-form-wrapper'
			});
		}


		function validateMaxLimit() {
			vm.usersGroupsFilters = vm.fileInfo.db.usersGroupsFilters;
			if (vm.usersGroupsFilters) {
				var filter = vm.usersGroupsFilters.find(function(filter) {
					// valiate restricted root group from api against current root.
					return (filter.field == "id_group" || filter.field == "groups_sub") && filter.value == vm.rootGroupId
				})
				if (!filter) {
					return Promise.resolve();
				}
				if (vm.groupSelectedRawSettings &&
					vm.groupSelectedRawSettings.max_allowed_users &&
					vm.fileInfo.file.totalUsers
				) {
					// Compare max allowed users with sum of users already in group plus users in file.
					var options = {
						siteID: vm.siteID,
						groupIds: [vm.groupSelectedId],
					};
					return usersService.getUsersByGroupsCount(options).then(function (response) {
						var usersInGroupCount = response.result.total;
						var totalUsers = vm.fileInfo.file.totalUsers + usersInGroupCount;
						if(totalUsers > vm.groupSelectedRawSettings.max_allowed_users) {
							vm.totalUsersAllowed = angular.copy(vm.groupSelectedRawSettings.max_allowed_users);
							return Promise.reject({
								totalUsersAllowed: vm.totalUsersAllowed
							});
						} else {
							return Promise.resolve();
						}
					})
				} else {
					return Promise.resolve();
				}
			} else {
				return Promise.resolve();
			}
		}

		function isHeaderMatch(fieldDB, header) {
			// case-insensitive comparison.
			return fieldDB.toLowerCase() == header.toLowerCase();
		}

		function closeDialog() {
			$mdDialog.hide();
		}
		function closeDialogAndUpdate() {
			$mdDialog.hide({ update: true });
		}
	}

	function ToggleAssignedGroup($rootScope) {
		return {
			restrict: 'A',
			link: function (scope, element, attrs) {
				$(element).on('click', function (e) {
					$rootScope.$broadcast('toggleAssignedGroup', scope.node);
				});
			}
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('app.users')
		.controller('ImportContentDialogController', ImportContentDialogController)
		.directive('qiuOnSelectParentUsersGroup', ['$rootScope', ToggleAssignedGroup])

	/** @ngInject */
	function ImportContentDialogController($mdDialog, $rootScope, $mdToast, $scope, $timeout, siteID, section, usersGroups, rootGroup, selectedGroup, $translate, Upload,
		contentService, uploadService, transformUsers, backendService) {
		var vm = this;
        
		vm.importUsers = importUsers;
		vm.closeDialog = closeDialog;
		vm.closeDialogAndUpdate = closeDialogAndUpdate;
		vm.resetForm = resetForm;
		vm.isHeaderMatch = isHeaderMatch;
		vm.siteID = siteID;
		vm.section = section;
		vm.usersGroups = usersGroups;
		vm.upload = upload;
		vm.rootGroup = rootGroup; // Qiu-restricted root group, only set if qiu-restricted user, else null.
		vm.selectedGroup = selectedGroup; // Currently selected group
		vm.usersGroupsFilters = [];
		vm.parentRootName = $translate.instant('GROUP.ROOT');
		vm.isQiuRestricted = false;
		vm.contentImporter = true;

		backendService.getSectionRef({domain: vm.siteID, section:vm.section}).then(function (response){
			vm.primaryKey = response.find(x => x.mandatory == 1).title;
		});

		if (vm.rootGroup) {
			vm.rootGroupName = vm.rootGroup.name;
			vm.rootGroupId = vm.rootGroup.id_group;
			vm.rootGroupRawSettings = vm.rootGroup.raw_settings;
			vm.isQiuRestricted = true;
		}
		if (vm.selectedGroup) {
			vm.groupSelectedName = vm.selectedGroup.name;
			vm.groupSelectedId = vm.selectedGroup.id_group;
			vm.groupSelectedRawSettings = vm.selectedGroup.raw_settings;
		} else {
			if (vm.rootGroup) {
				vm.groupSelectedName = vm.rootGroup.name;
				vm.groupSelectedId = vm.rootGroup.id_group;
				vm.groupSelectedRawSettings = vm.rootGroup.raw_settings;
			}
		}

		vm.resetForm();

		vm.translate = function (text) {
			return $translate.instant(text);
		}
		function importUsers() {
			var mailMapped = false;
			Object.keys(vm.mapping).forEach(function (key, index) {
				if (vm.mapping[key] == null) {
					delete vm.mapping[key];
				}
				if (vm.mapping[key] == vm.primaryKey) {
					mailMapped = true;
				}
			});
			if (!mailMapped) {
				var message = vm.translate('USERS.MAIL_MAPPING_OBLIGATORY');
				$mdToast.show({
					template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg">Es necesario seleccionar la clave primaria ' + vm.primaryKey + '</div></md-toast>',
					hideDelay: 7000,
					position: 'top',
					parent: '#login-form-wrapper'
				});
				return;
			}
			var options = {
				domain: vm.siteID,
				content: vm.section,
				token: vm.token,
				targetGroup: vm.groupSelectedId,
				options: vm.optionsDefault,
				fieldMap: vm.mapping,
				primaryKey: vm.primaryKey,
				ignoreDuplicates: !vm.udpateDuplicates
			}
			vm.isLoading = true;
			contentService.importContent(options).then(function (response) {
				vm.isLoading = false;
				vm.importFinished = true;
				vm.resultImport = response;
			}, function (error) {
				vm.importError = error.data.detail;
				console.log(error)
			})
		}

		function resetForm() {
			vm.mapping = {};
			vm.isLoading = false;
			vm.primarykey = vm.primarykey;
			vm.udpateDuplicates = true;
			vm.optionsDefault = {
				delimiter: ",",
				enclosure: "",
				escape: "\\",
				includeFirstRow: false
			}
			delete vm.importError;
			delete vm.importFinished;
			delete vm.resultImport;
			delete vm.fileInfo;
			delete vm.files;
		}


		vm.groups = transformUsers.formatNestedGroups(vm.usersGroups.data, vm.usersGroups.qiuRestrictions, true);

		function selectParentGroupRoot() {
			vm.groupSelectedName = vm.parentRootName;
			vm.groupSelectedId = null;
			vm.groupSelectedRawSettings = null;
		}

		$scope.$watch('vm.files', function () {
			$scope.formUpload = false;
			if (vm.files != null) {
				// make files array for not multiple to be able to be used in ng-repeat in the ui
				if (!angular.isArray(vm.files)) {
					$timeout(function () {
						$scope.files = vm.files = [vm.files];
					});
					return;
				}
				for (var i = 0; i < vm.files.length; i++) {
					$scope.errorMsg = null;
					(function (f) {
						vm.isLoading = true;
						vm.upload(f, true);
					})(vm.files[i]);
				}
			}
		});
		
		$scope.log = '';

		function upload(file) {
			if (!file.$error) {
				contentService.getS3UploadPreSignedUrl({
					domain: vm.siteID,
					content: vm.section,
					fileName: file.name,
					fileSizeKb: (angular.isDefined(file.size)) ? (parseInt(file.size) / 1000).toFixed(2) : null
				})
					.then(function (resp) {
						vm.token = resp.token;
						file.upload = Upload.http({
							url: resp.url,
							skipAuthorization: true,
							method: 'PUT',
							headers: {
								"Content-Type": file.type != '' ? file.type : 'application/octet-stream'
							},
							data: file
						});
						file.upload.then(function (response) {
							file.result = response.data;
							$timeout(function () {
								$scope.log = 'file: ' +
									file.name +
									', Response: ' + JSON.stringify(response.data) +
									', ID: ' + file.id_media +
									'\n' + $scope.log;
							});
							contentService.getFileInfo({
								domain: vm.siteID,
								content: vm.section,
								token: vm.token,
								options: vm.optionsDefault
							}).then(function (fileInfo) {
								vm.fileInfo = fileInfo;
								for (var i = 0; i < vm.fileInfo.file.headers.length; i++) {
									const header = vm.fileInfo.file.headers[i];
									vm.mapping[header] = null;
								}
								vm.isLoading = false;
								if (vm.selectedGroup) {
									// Programmatically set selected group as target group and validate.
									$scope.$broadcast('toggleAssignedGroup', vm.selectedGroup);
								} else {
									if (vm.isQiuRestricted) { 
										validateMaxLimit().then(function(){}, function(error){
											vm.groupSelectedId = null;
											vm.groupSelectedName = null;
											vm.groupSelectedRawSettings = null;
										});
									} else {
										vm.selectParentGroupRoot = selectParentGroupRoot;
									}
								}
							}, function (error) {
								console.log('here', error);
								var message = $translate.instant('USERS.FILE_INFO_ERROR');
								showErrorToast(message);
								vm.isLoading = false;
								vm.files = [];
							})
						}, function (response) {
							if (response.status > 0)
								$scope.errorMsg = response.status + ': ' + response.data;
						});
						file.upload.progress(function (evt) {
							file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
						});
					})
			}
		};

		$scope.$on('toggleAssignedGroup', function (event, selectedGroup) {
			vm.groupSelectedId = selectedGroup.id_group;
			vm.groupSelectedName = selectedGroup.name;
			vm.groupSelectedRawSettings = selectedGroup.raw_settings;
			validateMaxLimit().then(function(){}, function(error){
				vm.groupSelectedId = null;
				vm.groupSelectedName = null;
				vm.groupSelectedRawSettings = null;
				if (error.totalUsersAllowed) {
					var message = $translate.instant('USERS.ALLOW_LIMIT_EXCEEDED', { limit: error.totalUsersAllowed });
					showErrorToast(message);
				}
			});
		});

		function showErrorToast(message) {
			$mdToast.show({
				template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg">' + message + '</div></md-toast>',
				hideDelay: 7000,
				position: 'top',
				parent: '#login-form-wrapper'
			});
		}


		function validateMaxLimit() {
			vm.usersGroupsFilters = vm.fileInfo.db.usersGroupsFilters;
			if (vm.usersGroupsFilters) {
				var filter = vm.usersGroupsFilters.find(function(filter) {
					// valiate restricted root group from api against current root.
					return (filter.field == "id_group" || filter.field == "groups_sub") && filter.value == vm.rootGroupId
				})
				if (!filter) {
					return Promise.resolve();
				}
				if (vm.groupSelectedRawSettings &&
					vm.groupSelectedRawSettings.max_allowed_users &&
					vm.fileInfo.file.totalUsers
				) {
					// Compare max allowed users with sum of users already in group plus users in file.
					var options = {
						siteID: vm.siteID,
						groupIds: [vm.groupSelectedId],
					};
					return contentService.getUsersByGroupsCount(options).then(function (response) {
						var usersInGroupCount = response.result.total;
						var totalUsers = vm.fileInfo.file.totalUsers + usersInGroupCount;
						if(totalUsers > vm.groupSelectedRawSettings.max_allowed_users) {
							vm.totalUsersAllowed = angular.copy(vm.groupSelectedRawSettings.max_allowed_users);
							return Promise.reject({
								totalUsersAllowed: vm.totalUsersAllowed
							});
						} else {
							return Promise.resolve();
						}
					})
				} else {
					return Promise.resolve();
				}
			} else {
				return Promise.resolve();
			}
		}

		function isHeaderMatch(fieldDB, header) {
			// case-insensitive comparison.
			return fieldDB.toLowerCase() == header.toLowerCase();
		}

		function closeDialog() {
			$mdDialog.hide();
		}
		function closeDialogAndUpdate() {
			$mdDialog.hide({ update: true });
		}
	}

	function ToggleAssignedGroup($rootScope) {
		return {
			restrict: 'A',
			link: function (scope, element, attrs) {
				$(element).on('click', function (e) {
					$rootScope.$broadcast('toggleAssignedGroup', scope.node);
				});
			}
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('app.users')
		.controller('ExportDialogController', ExportDialogController)

	/** @ngInject */
	function ExportDialogController($mdDialog, siteID, $translate, $mdToast, $document,
		refcolumns, selectedGroup, selectedMainGroup, selectedThreads, threads, groups, totalItems,
		includeSubgroups, sharedFunctionsMailing, usersService, currentGroupTypeId,
		selectedIngroupStatus) {
		var vm = this;

		vm.closeDialog = closeDialog;
		vm.exportAndCloseDialog = exportAndCloseDialog;
		vm.siteID = siteID;
		vm.refcolumns = [];
		for (var i = 0; i < refcolumns.length; i++) {
			const element = refcolumns[i];
			if (element.title && element.field_name) {
				vm.refcolumns.push(element);
			}
		}
		vm.refcolumns = vm.refcolumns.filter(x => x.exportable == 1);
		vm.refcolumns = vm.refcolumns.sort((a, b) => {
			return a.export_sort - b.export_sort;
		})
		vm.getTemplates = getTemplates;
		vm.saveTemplate = saveTemplate;
		vm.selectedGroup = selectedGroup;
		vm.selectedMainGroup = selectedMainGroup;
		vm.selectedThreads = selectedThreads;
		vm.toggleSelectField = toggleSelectField;
		vm.toggleSelectFields = toggleSelectFields;
		vm.includeSubgroups = includeSubgroups;
		vm.isSelected = isSelected;
		vm.threads = threads;
		vm.totalItems = totalItems;
		vm.isMultipleGroup = isMultipleGroup;
		vm.loadTemplate = loadTemplate;
		vm.groups = groups;
		vm.selectedFields = [];
		if (!vm.selectedGroup && !vm.selectedThreads) {
			vm.allUsers = true;
			vm.usersToExport = [];
		} else if (vm.selectedGroup && !vm.selectedThreads) {
			vm.isFullGroup = true;
		} else if (!vm.selectedThreads) {
			vm.usersToExport = vm.threads;
		} else {
			vm.usersToExport = vm.selectedThreads;
		}


		vm.getTemplates();

		function getTemplates() {
			var options = {
				siteID: vm.siteID
			}
			usersService.getTemplatesExport(options).then((res) => {
				vm.templates = res.data;
			})
		}


		function loadTemplate() {
			vm.selectedFields = [];
			for (let i = 0; i < vm.templateSelected.fields.length; i++) {
				const element = vm.templateSelected.fields[i];
				vm.selectedFields.push(vm.refcolumns.find(x => x.field_name == element.field && x.title == element.name));
			}
			vm.refcolumns = vm.refcolumns.sort((a, b) => {
				var indexA = vm.selectedFields.findIndex(x => x.id_ref == a.id_ref);
				var indexB = vm.selectedFields.findIndex(x => x.id_ref == b.id_ref);
				if (indexA >= 0 && indexB >= 0) {
					return indexA - indexB;
				}
				if (indexA >= 0 && indexB < 0) {
					return -1;
				}
				if (indexB >= 0 && indexA < 0) {
					return 1;
				}
			})
			vm.templateSelected = null;
		}


		function toggleSelectField(field, event) {
			vm.selectedFields = sharedFunctionsMailing.toggleSelectThread(vm.selectedFields, field, event);
		}

		function toggleSelectFields() {
			var result = sharedFunctionsMailing.toggleSelectThreads(vm.selectedFields, vm.refcolumns);
			vm.selectedFields = [];
			for (var i = 0; i < result.length; i++) {
				const field = result[i];
				if (field.exportable) {
					vm.selectedFields.push(field);
				}
			}
		}

		function isSelected(field) {
			return sharedFunctionsMailing.isSelected(vm.selectedFields, field);
		}

		vm.translate = function (text) {
			return $translate.instant(text);
		}



		function closeDialog() {
			$mdDialog.hide();
		}

		function saveTemplate(ev) {
			vm.selectedFields = vm.selectedFields.sort((a, b) => {
				var indexA = vm.refcolumns.findIndex(x => x.id_ref == a.id_ref);
				var indexB = vm.refcolumns.findIndex(x => x.id_ref == b.id_ref);
				if (indexA >= 0 && indexB >= 0) {
					return indexA - indexB;
				}
				if (indexA >= 0 && indexB < 0) {
					return -1;
				}
				if (indexB >= 0 && indexA < 0) {
					return 1;
				}
			})
			$mdDialog.show({
				controller: 'SaveTemplateExportDialogController',
				controllerAs: 'vm',
				locals: {
					siteID: vm.siteID,
					data: vm.selectedFields
				},
				templateUrl: 'app/main/apps/users/dialogs/save-template-export-dialog/save-template-export-dialog.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				multiple: true,
				clickOutsideToClose: true
			})
				.then(function (result) {
					if (result) {
						vm.getTemplates();
						$mdToast.show({
							template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg">' + vm.translate('USERS.TEMPLATE_SAVED_SUCCESSFULLY') + '</div></md-toast>',
							hideDelay: 3000,
							position: 'top',
							parent: '#login-form-wrapper'
						});
					}
				});
		}



		function exportAndCloseDialog() {
			var fields = [];
			var groups = [];
			for (var i = 0; i < vm.selectedFields.length; i++) {
				const field = vm.selectedFields[i];
				//if(field.type != "single"){
				//	fields.push(field.type);
				//}else{
					fields.push(field.title);
				//}
			}
			var users = [];
			if (vm.isFullGroup) {
				if (isMultipleGroup()) {
					groups.push(...vm.selectedGroup.map(x => x.id_group))
				} else {
					groups.push(vm.selectedGroup.id_group)
				}
			} else if (vm.allUsers) {
				for (var i = 0; i < vm.groups.length; i++) {
					const element = vm.groups[i];
					groups.push(element.id_group)
				}
			} else {
				for (var i = 0; i < vm.usersToExport.length; i++) {
					const user = vm.usersToExport[i];
					users.push(user.id_user);
				}
			}

			var selectedGroupId = (!isMultipleGroup() && vm.selectedGroup) ? vm.selectedGroup.id_group : null;
			if (vm.selectedMainGroup) {
				selectedGroupId = vm.selectedMainGroup.id_group;
			}


			var options = {
				siteID: vm.siteID,
				groups: groups,
				users: users,
				fields: fields,
				format: 'csv',
				users_group_type: currentGroupTypeId,
				selected_users_group_id: selectedGroupId,
				selected_ingroup_status_id: parseInt(selectedIngroupStatus) != 0 ? parseInt(selectedIngroupStatus) : null
			}
			if (groups.length > 0 && vm.includeSubgroups) {
				options.nestedGroups = true;
			}
			usersService.exportUsers(options).then(function (response) {
				window.open(response.url);
				$mdDialog.hide();
			}, function (error) {
				$mdToast.show({
					template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg">' + (error.data.detail.length > 0 ? error.data.detail : error.data.title) + '</div></md-toast>',
					hideDelay: 7000,
					position: 'top',
					parent: '#login-form-wrapper'
				});
			})
		}

		function isMultipleGroup() {
			return Array.isArray(vm.selectedGroup);
		}
	}


})();

(function () {
	'use strict';

	angular
		.module('app.content', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
		// State
		$stateProvider.state('app.content', {
			url: '/content',
			views: {
				'content@app': {
					templateUrl: 'app/main/apps/content/content.html',
					controller: 'ContentController as vm'
				}
			},
			// resolve: {
			// 	Inbox: function (msApi) {
			// 		return msApi.resolve('content.inbox@get');
			// 	}
			// },
			bodyClass: 'content'
		});


		$stateProvider
			.state('app.site_overview.content', {
				abstract: true,
				url: '/content/:section',
				// controller: 'siteContentController',
				// views: {
				// 	'content@app': {
				// 		templateUrl: 'app/main/apps/content/content.html',
				// 		controller: 'ContentController as vm'
				// 	}
				// },
				// templateUrl: '/modules/site/content/views/site_content.html',
				onEnter: function ($stateParams) {


				},
				data: {
					displayName: '{{section}}'
				},
				resolve: {
					section: function ($stateParams) {
						return $stateParams.section
					},
				},


			})
			.state('app.site_overview.content.users_permissions', {
				url: '/users_permissions',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/content/users-permissions/user-permissions.html',
						controller: 'UsersPermissionsController as vm'
					}
				},
				onEnter: function () {
				},
				data: {
					displayName: 'List {{section}}'
				},
				resolve: {
					section: function ($stateParams) {
						return $stateParams.section
					},
				},
				params: {
					name: null
				}
			})
			.state('app.site_overview.content.list', {
				url: '',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/content/content.html',
						controller: 'ContentController as vm'
					}
				},
				// templateUrl: '/modules/site/content/views/site_content_list.html',
				// controller: 'siteContentListController',
				onEnter: function () {
				},
				data: {
					displayName: 'List {{section}}'
				},
				resolve: {
					// Cards: function (msApi)
					// {
					//     return msApi.resolve('cards@get');
					// }
					section: function ($stateParams) {
						return $stateParams.section
					},
				},
				params: {
					name: null
				}
			})
      .state('app.site_overview.content.list.social_stream', {
        url: '/social_view',
        views: {
          'content@app': {
            templateUrl: 'app/main/apps/content/content-social-stream.html',
            controller: 'ContentSocialStreamController as vm'
          }
        },
        // templateUrl: '/modules/site/content/views/site_content_list.html',
        // controller: 'siteContentListController',
        onEnter: function () {
        },
        data: {
          displayName: 'List {{section}}'
        },
        resolve: {
          section: function ($stateParams) {
            return $stateParams.section
          },
        },
      })
      .state('app.site_overview.content.list.social_stream.thread', {
        url: 'social_view/:id',
        bodyClass: 'content',
        onEnter: function (args) {
        },
        resolve: {
          section: function ($stateParams) {
            return $stateParams.section
          },
        }
      })
      .state('app.site_overview.content.list.thread', {
        url: '/:id',
        bodyClass: 'content'
      })
      /*
      .state('app.site_overview.content.list.thread.edit', {
        url: '/edit',
        views: {
          'content@app': {
            templateUrl: 'app/main/apps/content/views/edit/edit-view.html',
            controller: 'siteContentEditController as vm'
          }
        },
        // templateUrl: '/modules/site/content/views/site_content_edit.html',
        // controller: 'siteContentEditController',

        data: {
          displayName: '{{dataItem.result.title}}'
        },
        resolve: {
          id: function ($stateParams) {
            return $stateParams.id
          },
          dataItem: function (requestContext, $stateParams, contentService) {
            // $scope.isLoading=true;
            var siteID = $stateParams.siteId;
            var section = $stateParams.section;
            var id = $stateParams.id;
            var options = {
              site: $stateParams.siteId,
              section: $stateParams.section,
              id: $stateParams.id
            };
            return contentService.getByID(options);
            // return searchService.getSearchResults($route.current.params);
          }
        },
        // abstract:true,

      })
      */
      .state('app.site_overview.backend', {
        url: '/backend/content',
        views: {
          'content@app': {
            templateUrl: 'app/main/apps/content/backend/sections.html',
            controller: 'ContentBackendController as vm'
          }
        },
        // templateUrl: '/modules/site/content/views/site_content_list.html',
        // controller: 'siteContentListController',
        onEnter: function () {
        },
        data: {
          displayName: 'List {{section}}'
        },
        resolve: {
          // Cards: function (msApi)
          // {
          //     return msApi.resolve('cards@get');
          // }
          //     section: function ($stateParams) {
          //         return $stateParams.section
          //     }
        },
      })

    // $stateProvider
		//   .state('router', {
		//     url: '/router',
		//     template: '<div class="lockscreen" style="height: 100%"></div>',
		//     controller: 'RouteCtrl'
		//   })
		//   .state('error', {
		//     url: '/error',
		//     template: '<div class="text-center alert alert-danger" style="margin: 100px">An error occurred.</div>'
		//   })
		//   .state('app', {
		//     abstract: true,
		//     url: '/app',
		//     templateUrl: 'modules/core/views/app.html',
		//     controller: 'MainCtrl'
		//   })
		//   .state('app.home', {
		//     url: '',
		//     templateUrl: 'modules/core/views/home.html',
		//     controller: 'HomeCtrl'
		//   });
		// $urlRouterProvider.otherwise('/router');

		// Translation
		$translatePartialLoaderProvider.addPart('app/main/apps/content');

		// Api
		// msApiProvider.register('mail.folders', ['app/data/mail/folders.json']);
		// msApiProvider.register('mail.labels', ['app/data/mail/labels.json']);

		// msApiProvider.register('mail.label.notes', ['app/data/mail/labels/notes.json']);
		// msApiProvider.register('mail.label.paypal', ['app/data/mail/labels/paypal.json']);
		// msApiProvider.register('mail.label.invoices', ['app/data/mail/labels/invoices.json']);
		// msApiProvider.register('mail.label.amazon', ['app/data/mail/labels/amazon.json']);

		// msApiProvider.register('mail.folder.inbox', ['app/data/mail/folders/inbox.json']);
		// msApiProvider.register('mail.folder.sent', ['app/data/mail/folders/sent.json']);
		// msApiProvider.register('mail.folder.drafts', ['app/data/mail/folders/drafts.json']);
		// msApiProvider.register('mail.folder.spam', ['app/data/mail/folders/spam.json']);
		// msApiProvider.register('mail.folder.trash', ['app/data/mail/folders/trash.json']);
		// msApiProvider.register('mail.folder.starred', ['app/data/mail/folders/starred.json']);
		// msApiProvider.register('mail.folder.important', ['app/data/mail/folders/important.json']);


		// Api
		// msApiProvider.register('content.inbox', ['app/data/mail/folders/inbox.json']);
		//       msApiProvider.register('cards', ['app/data/cards/cards.json']);

		// Navigation
		// msNavigationServiceProvider.saveItem('apps.content', {
		//     title : 'Mail',
		//     icon  : 'icon-econtent',
		//     state : 'app.content',
		//     badge : {
		//         content: 25,
		//         color  : '#F44336'
		//     },
		//     weight: 3
		// });
	}
})();

(function () {
    'use strict';

    angular
        .module('app.content')
        .controller('EditGroupDialogController', EditGroupDialogController)
        .directive('qiuOnClickSelectParentGroup', ['usersService', SelectParentGroup])  
        ;

    /** @ngInject */
    function EditGroupDialogController($scope, $mdDialog, group, siteID, usersService, $mdToast, transformUsers, $translate) {

        var vm = this;

        vm.group = group;
        vm.groupName = group.name;
        vm.groupParentId = null;
        vm.groupParentName = '';
        vm.groupTypeId = group.id_group_type;
        vm.isQiuRestricted = false;

        vm.translate = function (text) {
            return $translate.instant(text);
        }

        vm.selectParentGroupRoot = selectParentGroupRoot;
        usersService.getUsersGroups({
            siteID: siteID,
            withGroupType: true
        }).then(function (response) {
            var qiuRestrictions = response.qiuRestrictions;
            var groups = response.data;
            var nestedGroups = transformUsers.formatNestedGroups(groups, qiuRestrictions, true);
            if (angular.isArray(nestedGroups) &&
                nestedGroups.length > 0 &&
                nestedGroups[0].is_qiu_restricted_root
            ) {
                vm.isQiuRestricted = true;
                vm.groupParentName = nestedGroups[0].name;
                vm.groupParentId = nestedGroups[0].id_group;
            }
            vm.groups = removeGroupFromNestedGroups(group, nestedGroups);
            var unnestedGroups = getUnnestedGroups(groups, []);
            angular.forEach(unnestedGroups, function (obj) {
                if (obj.id_group == group.parent) {
                    vm.groupParentName = obj.name;
                    vm.groupParentId = obj.id_group;
                }
            });
        });

        usersService.getUsersGroupsTypes({ siteID: siteID }).then(function (response) {
            vm.groupTypes = response;
        });

        $scope.hide = function () {
            $mdDialog.hide();
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        $scope.delete = function (group) {

            // TODO: show advice that users from group won't be deleted.

            usersService
                .deleteUsersGroup(siteID, group.id_group)
                .then(function (response) {
                    $mdDialog.hide();
                    usersService.triggerReloadGroups();
                }).catch(function (err) {
                    var message = $translate.instant('GLOBAL.ERROR') + '<br>' + err.data.detail;

                    $mdToast.show({
                        template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                        hideDelay: 5000,
                        position: 'top',
                        parent: '#content-container'
                    });
                });
        };

        $scope.save = function (group) {
            if (angular.equals({}, group)) {
                usersService
                    .createUsersGroup(siteID, vm.groupParentId, vm.groupName, vm.groupTypeId)
                    .then(function (response) {
                        // TODO: show success message
                        $mdDialog.hide();
                        usersService.triggerReloadGroups();
                    });
            } else {
                usersService
                    .editUsersGroup(siteID, group.id_group, vm.groupParentId, vm.groupName, vm.groupTypeId)
                    .then(function (response) {
                        // TODO: show success message
                        $mdDialog.hide();
                        usersService.triggerReloadGroups();
                    });
            }

        };

        $scope.$on('selectParentGroup', function (event, parentGroup) {
            vm.groupParentId = parentGroup.id_group;
            vm.groupParentName = parentGroup.name;
        });


        function selectParentGroupRoot() {
            vm.groupParentName = $translate.instant('GROUP.ROOT');
            vm.groupParentId = null;
        }

        function getUnnestedGroups(groups, result) {
            angular.forEach(groups, function (group) {
                if (group.id_group) {
                    result.push(group);
                    if (typeof group.children !== 'undefined' && group.children.length > 0) {
                        getUnnestedGroups(group.children, result);
                    }
                }
            });
            return result;
        }

        function removeGroupFromNestedGroups(group, groups) {
            angular.forEach(groups, function (obj) {
                if (group.id_group == obj.id_group) {
                    var index = groups.indexOf(obj);
                    groups.splice(index, 1);
                }
                if (typeof obj.children !== 'undefined' && obj.children.length > 0) {
                    removeGroupFromNestedGroups(group, obj.children);
                }
            });
            return groups;
        }
    }


    function SelectParentGroup(usersService) {

        function unselectAllGroups() {
            var elemList = document.querySelectorAll('.select-parent-group-row');
            elemList.forEach(function (elem) {
                elem.classList.remove('selected');
            });
        }

        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                $(element).on('click', function (e) {
                    var groupNode = false;
                    if (element.parent().hasClass('selected')) {
                        unselectAllGroups();
                    } else {
                        unselectAllGroups();
                        element.parent().addClass('selected');
                        groupNode = scope.node;
                    }
                    usersService.triggerSelectParentGroup(groupNode);
                });
            }
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.content')
        .controller('AddUsersToGroupsDialogController', AddUsersToGroupsDialogController)
        ;

    /** @ngInject */
    function AddUsersToGroupsDialogController(
        $scope,
        $mdDialog,
        usersGroups,
        users,
        siteID,
        usersService,
        sharedFunctionsMailing,
        $translate,
        $mdToast
    ) {

        var vm = this;

        //Data
        vm.viewUsersGroup = 'app/main/apps/tasks/dialogs/groups/tree-view.html';
        vm.loading = false;

        // Methods
        vm.closeDialog = closeDialog;
        vm.save = save;

        init();

        function init() {
            vm.usersGroups = usersGroups;
            vm.users = users;
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        function save() {
            vm.loading = true;
            var groups = getSelectedGroups(vm.usersGroups, []);
            if (groups.length < 1) {
                    vm.loading = false;
                    var message = $translate.instant('USERS.NO_GROUP_SELECTED');
                    $mdToast.show({
                        template: '<md-toast id="language-message"><span class="md-toast-text" flex>' + message + '</span><md-button ng-click="closeToast()">X</md-button></md-toast>',
                        hideDelay: 7000,
                        position: 'top right',
                        parent: '#main'
                    });
                    return false;
            }

            var userIDs = [];
            angular.forEach(users, function(user){
                userIDs.push(user.id_user);
            });

            var options = {
                siteID: siteID,
                data: {
                    id_users: userIDs,
                    groups: groups
                }
            };

            usersService.massInsertUsersIntoGroups(options)
                .then(function (response) {
                    vm.reload = true;
                    if (userIDs.length == 1) {
                        var message = $translate.instant('USERS.ADDTOGROUPS_SINGULAR');
                    } else {
                        var message = userIDs.length + $translate.instant('USERS.ADDTOGROUPS_PLURAL');
                    }
                    vm.loading = false;
                    $mdToast.show({
                        template: '<md-toast id="language-message"><span class="md-toast-text" flex>' + message + '</span><md-button ng-click="closeToast()">X</md-button></md-toast>',
                        hideDelay: 7000,
                        position: 'top right',
                        parent: '#main'
                    });
                    vm.closeDialog();
                });

            $mdDialog.hide();
        }


        function getSelectedGroups(groups, result) {

          angular.forEach(groups, function(group) {
            if(angular.isDefined(group.assigned_group) && group.assigned_group == true) {
              result.push(group);
            }
            if (typeof group.children !== 'undefined' && group.children.length >0) {
              getSelectedGroups(group.children, result);
            }
          });
          return result;
        }

    }

})();

// app/main/apps/sitemap/layoutV2/layout-v2-store.service.js
(function () {
  'use strict';

  angular
    .module('app.sitemap')
    .service('LayoutV2Store', LayoutV2Store);

  /* @ngInject */
  function LayoutV2Store(LayoutV2Library, $log) {
    var service = {
      initFromPage: initFromPage,
      getLibrary: getLibrary,
      applyDrop: applyDrop,
      applyTemplate: applyTemplate,
      moveLayout: moveLayout
    };

    return service;

    // --- Public API implementation ---

    /**
     * Initialize internal layout model from the given page.
     * For now, use an empty base model.
     */
    function initFromPage(page) {
      // In the future, this will read page.layout_json or similar
      var model = {
        regions: {
          header: [],
          content: [],
          footer: []
        }
      };

      $log.debug('[LayoutV2Store] initFromPage', page, model);

      return model;
    }

    function moveLayout(model, region, fromIndex, toIndex) {
      if (!model || !model.regions || !model.regions[region]) {
        return model;
      }

      var newModel = angular.copy(model);
      var arr = newModel.regions[region];

      if (fromIndex < 0 || fromIndex >= arr.length ||
          toIndex   < 0 || toIndex   >= arr.length) {
        return newModel;
      }

      var moved = arr.splice(fromIndex, 1)[0];
      arr.splice(toIndex, 0, moved);

      return newModel;
    }

    /**
     * Return the library of layouts / widgets / templates / elements.
     */
    function getLibrary() {
      return LayoutV2Library;
    }

    /**
     * Apply a drag & drop operation to the current model.
     * For now, just add a simple block to the target region.
     */
    function applyDrop(model, event) {
        if (!model || !model.regions) {
            model = initFromPage(null);
        }

        var region   = event && event.region   ? event.region   : 'content';
        var columnId = event && event.columnId ? event.columnId : null;
        var payload  = event && event.payload  ? event.payload  : null;
        
        var newModel = angular.copy(model);

        // ----------------------------------------------------------
        // DELETE layout in region
        // ----------------------------------------------------------
        if (event && event.deleteLayoutId && !columnId) {
            var regionBlocks = (newModel.regions[region] || []).filter(Boolean);
            newModel.regions[region] = regionBlocks.filter(function (b) {
                return b && b.id !== event.deleteLayoutId;
            });
            return newModel;
        }

        // ----------------------------------------------------------
        // DELETE widget from a column
        // ----------------------------------------------------------
        if (event && event.deleteId && columnId) {
            var colDel = findColumn(newModel, region, columnId);
            if (colDel && colDel.widgets) {
                colDel.widgets = colDel.widgets.filter(function (w) {
                    return w && w.id !== event.deleteId;
                });
            }
            return newModel;
        }

        // ----------------------------------------------------------
        // REORDER widgets inside a column
        // ----------------------------------------------------------
        if (event && event.items && columnId) {
            var colReorder = findColumn(newModel, region, columnId);
            if (colReorder) {
                colReorder.widgets = (event.items || []).filter(Boolean);
            }
            return newModel;
        }

        // ----------------------------------------------------------
        // Standard drop (add layout / widget / element / template)
        // ----------------------------------------------------------
        if (!payload) {
            return newModel;
        }

        var payloadType = payload.type || payload.kind || 'unknown';

        // Drop on REGION -> layouts or templates
        if (!columnId) {
            if (payloadType === 'layout' && angular.isArray(payload.columns)) {

                if (!newModel.regions[region]) {
                    newModel.regions[region] = [];
                }

                var layoutBlock = {
                    id      : generateId(region, payload.id || payload.label),
                    kind    : 'layout',
                    label   : payload.label || payload.name || 'Layout',
                    sourceId: payload.id || null,
                    columns : payload.columns.map(function (span, idx) {
                        return {
                            id     : region + '-col-' + (idx + 1) + '-' + Math.floor(Math.random() * 100000),
                            span   : span,
                            widgets: []
                        };
                    })
                };

                newModel.regions[region].push(layoutBlock);
            }
            else if (payloadType === 'template' && payload.model) {
                newModel = applyTemplate(newModel, payload);
            }

            return newModel;
        }

        // Drop on COLUMN -> widgets / elements / templates (no layouts)
        var targetColumn = findColumn(newModel, region, columnId);
        if (!targetColumn) {
            return newModel;
        }

        if (payloadType === 'layout') {
            return newModel;
        }

        if (!targetColumn.widgets) {
            targetColumn.widgets = [];
        }

        var widgetInstance = {
            id      : generateId('col', payload.id || payload.label),
            kind    : payloadType,
            label   : payload.label || payload.name || 'Widget',
            sourceId: payload.id || null,
            meta    : { payload: payload },
            config  : angular.copy(payload.defaultConfig || null),
            style   : {
              bg     : null,        // 'primary' | 'secondary' | 'tertiary' | null
              color  : null,        // 'primary' | 'secondary' | 'tertiary' | null
              width  : 100,         // porcentaje
              margin : { top: 0, right: 0, bottom: 6, left: 0 },
              padding: { top: 6, right: 8, bottom: 6, left: 8 },
              align  : 'left'       // 'left' | 'center' | 'right'
            }
        };

        targetColumn.widgets.push(widgetInstance);

        return newModel;
    }

    /**
     * Find a column object by region and column id.
     */
    function findColumn(model, region, columnId) {
        if (!model || !model.regions) {
            return null;
        }

        var blocks = model.regions[region] || [];
        for (var i = 0; i < blocks.length; i++) {
            var block = blocks[i];
            if (block.kind !== 'layout' || !angular.isArray(block.columns)) {
                continue;
            }
            for (var j = 0; j < block.columns.length; j++) {
                var col = block.columns[j];
                if (col.id === columnId) {
                    return col;
                }
            }
        }

        return null;
    }


    /**
     * Apply a full template over the current model.
     * For now, completely replace the internal model with template.model.
     */
    function applyTemplate(model, template) {
      if (!template || !template.model) {
        return model;
      }

      var cloned = angular.copy(template.model);

      $log.debug('[LayoutV2Store] applyTemplate', template, cloned);

      return cloned;
    }

    // --- Private helpers ---

    function generateId(region, base) {
      var suffix = Math.floor(Math.random() * 100000);
      return region + '-' + (base || 'block') + '-' + suffix;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.sitemap')
    .service('LayoutV2SortableState', LayoutV2SortableState);

  /* @ngInject */
  function LayoutV2SortableState() {
    // Whether an internal sortable drag is active
    var _active = false;
    // Id of the sortable container where the drag started
    var _originId = null;

    /**
     * Start sortable drag in given container.
     * @param {string} originId - id of the sortable container
     */
    this.start = function (originId) {
      _active = true;
      _originId = originId || null;
    };

    /**
     * End sortable drag.
     */
    this.end = function () {
      _active = false;
      _originId = null;
    };

    /**
     * Returns true if there is an internal sortable drag.
     */
    this.isActive = function () {
      return _active;
    };

    /**
     * Returns the id of the container where drag started.
     */
    this.getOriginId = function () {
      return _originId;
    };
  }

})();

// app/main/apps/sitemap/layoutV2/layout-v2-layouts-state.service.js
(function () {
  'use strict';

  angular
    .module('app.sitemap')
    .service('LayoutV2LayoutsState', LayoutV2LayoutsState);

  /* @ngInject */
  function LayoutV2LayoutsState() {
    var _active = false;
    var _originId = null;

    this.start = function (originId) {
      _active = true;
      _originId = originId || null;
    };

    this.end = function () {
      _active = false;
      _originId = null;
    };

    this.isActive = function () {
      return _active;
    };

    this.getOriginId = function () {
      return _originId;
    };
  }

})();

// app/main/apps/sitemap/layoutV2/layout-v2-dnd-state.service.js
(function () {
  'use strict';

  angular
    .module('app.sitemap')
    .service('LayoutV2DndState', LayoutV2DndState);

  /* @ngInject */
  function LayoutV2DndState() {
    var currentPayload = null;

    this.startDrag = function (payload) {
      // Store full payload for later checks
      currentPayload = payload || null;
    };

    this.endDrag = function () {
      currentPayload = null;
    };

    this.getPayload = function () {
      return currentPayload;
    };

    this.getType = function () {
      if (!currentPayload) {
        return null;
      }
      return currentPayload.type || currentPayload.kind || 'unknown';
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.sitemap')
    .directive('layoutV2Sortable', layoutV2Sortable)
    .directive('layoutV2SortableItem', layoutV2SortableItem);

    /**
     * Container directive: handles dragover/drop and updates the items array
     * only when an internal sortable drag is active.
     */
    /* @ngInject */
    function layoutV2Sortable(LayoutV2SortableState) {
        return {
            restrict: 'A',
            scope: {
            items: '=',
            onReorder: '&'
            },
            link: function (scope, element) {

            // Unique id for this sortable container
            var containerId = 'sortable-' + scope.$id;
            element.attr('data-sortable-container-id', containerId);

            var currentTargetEl = null;

            element.on('dragover', function (event) {

                // Only handle if drag is internal AND comes from this container
                if (!LayoutV2SortableState.isActive() ||
                    LayoutV2SortableState.getOriginId() !== containerId) {
                return true; // let other handlers (column droppable, etc.) work
                }

                var e = event.originalEvent || event;
                if (e.preventDefault) {
                e.preventDefault();
                }
                if (e.dataTransfer) {
                e.dataTransfer.dropEffect = 'move';
                }

                // Highlight target widget
                var targetEl = e.target.closest('[layout-v2-sortable-item]');

                if (currentTargetEl && currentTargetEl !== targetEl) {
                currentTargetEl.classList.remove('layout-v2-sortable-target');
                }

                if (targetEl) {
                targetEl.classList.add('layout-v2-sortable-target');
                currentTargetEl = targetEl;
                } else {
                currentTargetEl = null;
                }

                return false;
            });

            element.on('dragleave', function () {
                if (currentTargetEl) {
                currentTargetEl.classList.remove('layout-v2-sortable-target');
                currentTargetEl = null;
                }
            });

            element.on('drop', function (event) {

                // Again, only handle drops from this same container
                if (!LayoutV2SortableState.isActive() ||
                    LayoutV2SortableState.getOriginId() !== containerId) {
                return true; // external drops handled by column droppable
                }

                var e = event.originalEvent || event;
                if (!e.dataTransfer) return;

                if (e.preventDefault) {
                e.preventDefault();
                }
                if (e.stopPropagation) {
                e.stopPropagation();
                }

                if (currentTargetEl) {
                currentTargetEl.classList.remove('layout-v2-sortable-target');
                currentTargetEl = null;
                }

                var fromIndexStr = e.dataTransfer.getData('text/plain');
                var fromIndex = parseInt(fromIndexStr, 10);
                if (isNaN(fromIndex)) {
                return;
                }

                var targetEl = e.target.closest('[layout-v2-sortable-item]');
                var toIndex = null;

                if (targetEl) {
                var idxStr = targetEl.getAttribute('data-sortable-index');
                toIndex = parseInt(idxStr, 10);
                }

                if (toIndex === null || isNaN(toIndex)) {
                toIndex = scope.items.length - 1;
                }

                if (fromIndex === toIndex) {
                return;
                }

                scope.$applyAsync(function () {
                var arr = scope.items;
                if (!arr || !arr.length) {
                    return;
                }

                var moved = arr.splice(fromIndex, 1)[0];
                if (toIndex > arr.length) {
                    toIndex = arr.length;
                }
                arr.splice(toIndex, 0, moved);

                if (angular.isFunction(scope.onReorder)) {
                    scope.onReorder({ items: arr });
                }
                });
            });

            scope.$on('$destroy', function () {
                element.off('dragover dragleave drop');
            });
            }
        };
    }

    /**
     * Item directive: makes each widget draggable and sets its index.
     */
    /* @ngInject */
    function layoutV2SortableItem(LayoutV2SortableState) {
        return {
            restrict: 'A',
            scope: {
            sortableIndex: '<'
            },
            link: function (scope, element) {

            // Make it draggable
            element.attr('draggable', 'true');
            element.attr('data-sortable-index', scope.sortableIndex);

            scope.$watch('sortableIndex', function (val) {
                if (typeof val === 'number') {
                element.attr('data-sortable-index', val);
                }
            });

            element.on('dragstart', function (event) {
                var e = event.originalEvent || event;
                if (!e.dataTransfer) return;

                // Find parent sortable container and get its id
                var container = element.parent().closest('[layout-v2-sortable]');
                var containerId = container && container.attr('data-sortable-container-id');

                // Tell state where the drag started
                LayoutV2SortableState.start(containerId);

                e.dataTransfer.effectAllowed = 'move';
                e.dataTransfer.setData('text/plain', String(scope.sortableIndex));

                element.addClass('layout-v2-dragging');
            });

            element.on('dragend', function () {
                element.removeClass('layout-v2-dragging');
                LayoutV2SortableState.end();
            });

            scope.$on('$destroy', function () {
                element.off('dragstart dragend');
            });
            }
        };
    }

})();

(function () {
  'use strict';

  angular
    .module('app.sitemap')
    .directive('layoutV2LayoutsSortable', layoutV2LayoutsSortable)
    .directive('layoutV2LayoutsSortableItem', layoutV2LayoutsSortableItem);

  /* @ngInject */
  function layoutV2LayoutsSortable(LayoutV2LayoutsState) {
    return {
      restrict: 'A',
      scope: {
        items: '=',        // array de layouts en la región
        onReorder: '&'     // callback({ layoutItems })
      },
      link: function (scope, element) {

        // id único para este contenedor de layouts
        var containerId = 'layouts-' + scope.$id;
        element.attr('data-layouts-container-id', containerId);

        var currentTargetEl = null;

        element.on('dragover', function (event) {

          // Solo actuamos si hay drag interno de layouts en ESTE contenedor
          if (!LayoutV2LayoutsState.isActive() ||
              LayoutV2LayoutsState.getOriginId() !== containerId) {
            return true; // dejamos pasar el drag al droppable de CONTENT
          }

          var e = event.originalEvent || event;
          if (e.preventDefault) {
            e.preventDefault();
          }
          if (e.dataTransfer) {
            e.dataTransfer.dropEffect = 'move';
          }

          var targetEl = e.target.closest('[layout-v2-layouts-sortable-item]');

          if (currentTargetEl && currentTargetEl !== targetEl) {
            currentTargetEl.classList.remove('layout-v2-layout-target');
          }

          if (targetEl) {
            targetEl.classList.add('layout-v2-layout-target');
            currentTargetEl = targetEl;
          } else {
            currentTargetEl = null;
          }

          return false;
        });

        element.on('dragleave', function () {
          if (currentTargetEl) {
            currentTargetEl.classList.remove('layout-v2-layout-target');
            currentTargetEl = null;
          }
        });

        element.on('drop', function (event) {

          // Igual: solo si es drag interno de layouts en ESTE contenedor
          if (!LayoutV2LayoutsState.isActive() ||
              LayoutV2LayoutsState.getOriginId() !== containerId) {
            return true; // lo manejará el droppable de la región
          }

          var e = event.originalEvent || event;
          if (!e.dataTransfer) return;

          if (e.preventDefault) {
            e.preventDefault();
          }
          if (e.stopPropagation) {
            e.stopPropagation();
          }

          if (currentTargetEl) {
            currentTargetEl.classList.remove('layout-v2-layout-target');
            currentTargetEl = null;
          }

          var fromIndexStr = e.dataTransfer.getData('text/plain');
          var fromIndex = parseInt(fromIndexStr, 10);
          if (isNaN(fromIndex)) {
            return;
          }

          var targetEl = e.target.closest('[layout-v2-layouts-sortable-item]');
          var toIndex = null;

          if (targetEl) {
            var idxStr = targetEl.getAttribute('data-layout-sortable-index');
            toIndex = parseInt(idxStr, 10);
          }

          if (toIndex === null || isNaN(toIndex)) {
            toIndex = scope.items.length - 1;
          }

          if (fromIndex === toIndex) {
            return;
          }

          scope.$applyAsync(function () {
            var arr = scope.items;
            if (!arr || !arr.length) {
              return;
            }

            var moved = arr.splice(fromIndex, 1)[0];
            if (toIndex > arr.length) {
              toIndex = arr.length;
            }
            arr.splice(toIndex, 0, moved);

            if (angular.isFunction(scope.onReorder)) {
              scope.onReorder({ layoutItems: arr });
            }
          });
        });

        scope.$on('$destroy', function () {
          element.off('dragover dragleave drop');
        });
      }
    };
  }

  /* @ngInject */
  function layoutV2LayoutsSortableItem(LayoutV2LayoutsState) {
    return {
      restrict: 'A',
      scope: {
        layoutSortableIndex: '<'
      },
      link: function (scope, element) {

        element.attr('draggable', 'true');
        element.attr('data-layout-sortable-index', scope.layoutSortableIndex);

        scope.$watch('layoutSortableIndex', function (val) {
          if (typeof val === 'number') {
            element.attr('data-layout-sortable-index', val);
          }
        });

        element.on('dragstart', function (event) {
          var e = event.originalEvent || event;
          if (!e.dataTransfer) return;

          // localizar el contenedor de layouts
          var container = element.parent().closest('[layout-v2-layouts-sortable]');
          var containerId = container && container.attr('data-layouts-container-id');

          // marcar drag interno de layouts en ese contenedor
          LayoutV2LayoutsState.start(containerId);

          e.dataTransfer.effectAllowed = 'move';
          e.dataTransfer.setData('text/plain', String(scope.layoutSortableIndex));

          element.addClass('layout-v2-dragging');
        });

        element.on('dragend', function () {
          element.removeClass('layout-v2-dragging');
          LayoutV2LayoutsState.end();
        });

        scope.$on('$destroy', function () {
          element.off('dragstart dragend');
        });
      }
    };
  }

})();

// app/main/apps/sitemap/layoutV2/layout-v2-dnd.directive.js
(function () {
  'use strict';

  angular
    .module('app.sitemap')
    .directive('layoutV2Draggable', layoutV2Draggable)
    .directive('layoutV2Droppable', layoutV2Droppable);

  /* @ngInject */
  function layoutV2Draggable(LayoutV2DndState) {
    return {
      restrict: 'A',
      scope: {
        dragData: '='
      },
      link: function (scope, element) {

        element.attr('draggable', 'true');

        element.on('dragstart', function (event) {
          var e = event.originalEvent || event;

          // Save current payload in shared DnD state
          LayoutV2DndState.startDrag(scope.dragData || null);

          try {
            var payload = angular.toJson(scope.dragData || {});
            e.dataTransfer.setData('application/json', payload);
          } catch (err) {
            e.dataTransfer.setData('text', scope.dragData || '');
          }

          e.dataTransfer.effectAllowed = 'copyMove';
          element.addClass('layout-v2-dragging');
        });

        element.on('dragend', function () {
          element.removeClass('layout-v2-dragging');
          LayoutV2DndState.endDrag();
        });

        scope.$on('$destroy', function () {
          element.off('dragstart dragend');
        });
      }
    };
  }

  /* @ngInject */
  function layoutV2Droppable($parse, LayoutV2DndState, LayoutV2SortableState, LayoutV2LayoutsState) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {

        var onDropExpr = attrs.onDrop ? $parse(attrs.onDrop) : null;
        var regionId = scope.$eval(attrs.dropRegion);
        var columnId = attrs.dropColumnId ? scope.$eval(attrs.dropColumnId) : null;

        // Allowed types for this droppable (layout, widget, element, template...)
        var acceptTypes = null;
        if (attrs.acceptTypes) {
          // accept-types can be array literal or single string
          acceptTypes = scope.$eval(attrs.acceptTypes);
          if (angular.isString(acceptTypes)) {
            acceptTypes = [acceptTypes];
          }
        }

        function isAcceptedCurrentDrag() {
          if (!acceptTypes || !acceptTypes.length) {
            // If no acceptTypes specified, accept everything
            return true;
          }
          var currentType = LayoutV2DndState.getType();
          return currentType && acceptTypes.indexOf(currentType) !== -1;
        }

        element.on('dragover', function (event) {
          if ((LayoutV2SortableState && LayoutV2SortableState.isActive && LayoutV2SortableState.isActive()) ||
              (LayoutV2LayoutsState && LayoutV2LayoutsState.isActive && LayoutV2LayoutsState.isActive())) {
            return true;
          }

          if (!isAcceptedCurrentDrag()) {
            return true;
          }

          var e = event.originalEvent || event;
          if (e.preventDefault) {
            e.preventDefault();
          }
          if (e.dataTransfer) {
            e.dataTransfer.dropEffect = 'copy';
          }
          element.addClass('layout-v2-droppable--over');
          return false;
        });

        element.on('dragenter', function () {
          if ((LayoutV2SortableState && LayoutV2SortableState.isActive && LayoutV2SortableState.isActive()) ||
              (LayoutV2LayoutsState && LayoutV2LayoutsState.isActive && LayoutV2LayoutsState.isActive())) {
            return;
          }

          if (!isAcceptedCurrentDrag()) {
            return;
          }
          
          element.addClass('layout-v2-droppable--over');
        });

        element.on('dragleave', function () {
          element.removeClass('layout-v2-droppable--over');
        });

        element.on('drop', function (event) {
          // If this drop is not allowed, ignore
          if (!isAcceptedCurrentDrag()) {
            element.removeClass('layout-v2-droppable--over');
            return true;
          }

          var e = event.originalEvent || event;

          if (e.preventDefault) { e.preventDefault(); }
          if (e.stopPropagation) { e.stopPropagation(); }

          element.removeClass('layout-v2-droppable--over');

          var payload = null;

          if (e.dataTransfer) {
            var json = e.dataTransfer.getData('application/json') ||
                       e.dataTransfer.getData('text');
            if (json) {
              try {
                payload = angular.fromJson(json);
              } catch (err) {
                payload = json;
              }
            }
          }

          var localEvent = {
            region: regionId,
            columnId: columnId,
            payload: payload,
            originalEvent: e
          };

          if (onDropExpr) {
            scope.$applyAsync(function () {
              onDropExpr(scope, { $event: localEvent });
            });
          }

          return false;
        });

        scope.$on('$destroy', function () {
          element.off('dragover dragenter dragleave drop');
        });
      }
    };
  }

})();

// app/main/apps/sitemap/layoutV2/layout-v2.constants.js
(function () {
  'use strict';

  angular
    .module('app.sitemap')
    .constant('LayoutV2Library', {
      layouts: [
        { id: 'layout-full-width',   type: 'layout', label: 'Full width',   description: 'Single column',             columns: [12] },
        { id: 'layout-two-columns',  type: 'layout', label: '2 columns',    description: '6/12 + 6/12',               columns: [6, 6] },
        { id: 'layout-three-columns',type: 'layout', label: '3 columns',    description: '4/12 + 4/12 + 4/12',        columns: [4, 4, 4] },
        { id: 'layout-four-columns', type: 'layout', label: '4 columns',    description: '3/12 + 3/12 + 3/12 + 3/12', columns: [3, 3, 3, 3] },
        { id: 'layout-three-plus-one', type: 'layout', label: '3 + 1',      description: '9/12 + 3/12',               columns: [9, 3] }
      ],
      widgets: [
        { id: 'widget-news-list',  type: 'widget',  label: 'News list',  description: 'List of news' },
        { id: 'widget-top-stories',type: 'widget',  label: 'Top stories',description: 'Highlighted stories' }
      ],
      templates: [
        {
          id: 'template-news-home',
          type: 'template',
          label: 'News home',
          description: 'Simple news layout',
          model: {
            regions: {
              header: [],
              content: [
                {
                  id: 'block-content-main',
                  kind: 'layout',
                  layoutId: 'layout-two-columns',
                  label: 'Main content (2 columns)',
                  columns: [
                    { id: 'content-col-1', span: 6, widgets: [] },
                    { id: 'content-col-2', span: 6, widgets: [] }
                  ]
                }
              ],
              footer: []
            }
          }
        }
      ],
      elements: [
        {
          id: 'element-headline',
          type: 'element',
          label: 'Headline',
          description: 'Section headline'
        },
        {
          id: 'element-body-text',
          type: 'element',
          label: 'Body text',
          description: 'Paragraph text block'
        },
        {
          id: 'element-button',
          type: 'element',
          label: 'Button',
          description: 'Primary call-to-action button',
          defaultConfig: {
            text  : 'Click me',
            href  : '#',
            target: '_self'
          }
        }
      ]
    });

})();

(function ()
{
    'use strict';

    angular
        .module('app.store',
            [
                'flow'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, COMMON, storeServiceProvider)
    {
        // State
        $stateProvider.state('app.store', {
            abstract: true,
            url     : '/store'
        });
        $stateProvider

        .state('app.site_overview.store', {
            abstract: true,
            url: '/store',
            onEnter: function ($stateParams) {
            },
            resolve: {

                Dashboard: function (msApi)
                {
                    return [];//msApi.resolve('store.dashboard@get');
                }
            },
        })

        .state('app.site_overview.store.orders', {
            url      : '/orders',
            views    : {
              'content@app': {
                  templateUrl: 'app/main/apps/store/orders.html',
                  controller: 'StoreController as vm'
              }
            },
            params: {
                section: 'orders',
                type: 'orders'
            },
            onEnter: function ($rootScope, $timeout, $stateParams, storeService) {
            },
            resolve  : {
            },
            bodyClass: 'store'
        })
        .state('app.site_overview.store.orders.detail', {
            url      : '/:id',
            bodyClass: 'store',
            onEnter: function () {
            },
        })
        .state('app.site_overview.store.abandoned', {
            url      : '/abandoned',
            views    : {
              'content@app': {
                  templateUrl: 'app/main/apps/store/orders.html',
                  controller: 'StoreController as vm'
              }
            },
            params: {
                section: 'orders',
                type: 'abandoned'
            },
            onEnter: function ($rootScope, $timeout, $stateParams, storeService) {
            },
            resolve  : {
            },
            bodyClass: 'store'
        })
        .state('app.site_overview.store.abandoned.detail', {
            url      : '/:id',
            bodyClass: 'store',
            onEnter: function () {
            },
        })
        .state('app.site_overview.store.activities', {
            url      : '/activities',
            views    : {
              'content@app': {
                  templateUrl: 'app/main/apps/store/orders.html',
                  controller: 'StoreController as vm'
              }
            },
            params: {
                section: 'orders',
                type: 'activities'
            },
            onEnter: function ($rootScope, $timeout, $stateParams, storeService) {
            },
            resolve  : {
            },
            bodyClass: 'store'
        })
                .state('app.site_overview.store.activities.detail', {
            url      : '/:id',
            bodyClass: 'store',
            onEnter: function () {
            },
        })
        .state('app.site_overview.store.subscriptions', {
            url      : '/subscriptions',
            views    : {
              'content@app': {
                  templateUrl: 'app/main/apps/store/orders.html',
                  controller: 'StoreController as vm'
              }
            },
            params: {
                section: 'subscriptions'
            },
            onEnter: function ($rootScope, $timeout, $stateParams, storeService) {
            },
            resolve  : {
            },
            bodyClass: 'store'
        })
        .state('app.site_overview.store.subscriptions.detail', {
            url      : '/:id',
            bodyClass: 'store',
            onEnter: function () {
            },
        })

        .state('app.site_overview.store.dashboard', {
            url      : '/dashboard',
            views    : {
                'storeDashboard@app.site_overview.store': {
                    templateUrl: 'app/main/apps/store/views/dashboard/dashboard.html',
                }
            },
            onEnter: function ($rootScope, $timeout, $stateParams, storeService) {
                $timeout(function() {
                    $rootScope.$broadcast('storeLoad', 'dashboard');
                })
            },
            resolve  : {
            },
            bodyClass: 'store'
        })



/*
        .state('app.site_overview.store.products', {
            url      : '/products',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/store/views/products/products.html',
                    controller : 'ProductsController as vm'
                }
            },
            resolve  : {
                Products: function (msApi)
                {
                    return msApi.resolve('store.products@get');
                }
            },
            bodyClass: 'store'
        })
        .state('app.site_overview.store.products.detail', {
            url      : '/:id',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/store/views/product/product.html',
                    controller : 'ProductController as vm'
                }
            },
            resolve  : {
                Product: function (msApi)
                {
                    return msApi.resolve('store.product@get');
                }
            },
            bodyClass: 'store'
        });
*/







        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/store');

        // Api
        //msApiProvider.register('store.dashboard', ['app/data/store/dashboard.json']);
        //msApiProvider.register('store.products', ['app/data/store/products.json']);
        //msApiProvider.register('store.product', ['app/data/store/product.json']);
        //        storeServiceProvider.register('store.orders');

        // Navigation
        /*
        msNavigationServiceProvider.saveItem('apps.store', {
            title : 'E-Commerce',
            icon  : 'icon-cart',
            weight: 3
        });

        msNavigationServiceProvider.saveItem('apps.store.dashboard', {
            title: 'Dashboard',
            state: 'app.store.dashboard'
        });

        msNavigationServiceProvider.saveItem('apps.store.products', {
            title: 'Products',
            state: 'app.store.products'
        });

        msNavigationServiceProvider.saveItem('apps.store.orders', {
            title: 'Orders',
            state: 'app.store.orders'
        });
        */
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.store')
        .controller('ProductsController', ProductsController);

    /** @ngInject */
    function ProductsController($state, Products)
    {
        var vm = this;

        // Data
        vm.products = Products.data;

        vm.dtInstance = {};
        vm.dtOptions = {
            dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            columnDefs  : [
                {
                    // Target the id column
                    targets: 0,
                    width  : '72px'
                },
                {
                    // Target the image column
                    targets   : 1,
                    filterable: false,
                    sortable  : false,
                    width     : '80px'
                },
                {
                    // Target the quantity column
                    targets: 5,
                    render : function (data, type)
                    {
                        if ( type === 'display' )
                        {
                            if ( parseInt(data) <= 5 )
                            {
                                return '<div layout="row" layout-align="start center"><div class="quantity-indicator md-red-500-bg"></div><div>' + data + '</div></div>';
                            }
                            else if ( parseInt(data) > 5 && parseInt(data) <= 25 )
                            {
                                return '<div layout="row" layout-align="start center"><div class="quantity-indicator md-amber-500-bg"></div><div>' + data + '</div></div>';
                            }
                            else
                            {
                                return '<div layout="row" layout-align="start center"><div class="quantity-indicator md-green-600-bg"></div><div>' + data + '</div></div>';
                            }
                        }

                        return data;
                    }
                },
                {
                    // Target the status column
                    targets   : 6,
                    filterable: false,
                    render    : function (data, type)
                    {
                        if ( type === 'display' )
                        {
                            if ( data === 'true' )
                            {
                                return '<i class="icon-checkbox-marked-circle green-500-fg"></i>';
                            }

                            return '<i class="icon-cancel red-500-fg"></i>';
                        }

                        if ( type === 'filter' )
                        {
                            if ( data )
                            {
                                return '1';
                            }

                            return '0';
                        }

                        return data;
                    }
                },
                {
                    // Target the actions column
                    targets           : 7,
                    responsivePriority: 1,
                    filterable        : false,
                    sortable          : false
                }
            ],
            initComplete: function ()
            {
                var api = this.api(),
                    searchBox = angular.element('body').find('#store-products-search');

                // Bind an external input as a table wide search box
                if ( searchBox.length > 0 )
                {
                    searchBox.on('keyup', function (event)
                    {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType  : 'simple',
            lengthMenu  : [10, 20, 30, 50, 100],
            pageLength  : 20,
            scrollY     : 'auto',
            responsive  : true
        };

        // Methods
        vm.gotoProductDetail = gotoProductDetail;

        //////////

        /**
         * Go to product detail
         *
         * @param id
         */
        function gotoProductDetail(id)
        {
            $state.go('app.site_overview.store.products.detail', {id: id});
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.store')
        .controller('ProductController', ProductController);

    /** @ngInject */
    function ProductController($document, $state, Product)
    {
        var vm = this;

        // Data
        vm.taToolbar = [
            ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote', 'bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
            ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent', 'html', 'insertImage', 'insertLink', 'insertVideo', 'wordcount', 'charcount']
        ];
        vm.product = Product.data;
        vm.categoriesSelectFilter = '';
        vm.ngFlowOptions = {
            // You can configure the ngFlow from here
            /*target                   : 'api/media/image',
             chunkSize                : 15 * 1024 * 1024,
             maxChunkRetries          : 1,
             simultaneousUploads      : 1,
             testChunks               : false,
             progressCallbacksInterval: 1000*/
        };
        vm.ngFlow = {
            // ng-flow will be injected into here through its directive
            flow: {}
        };
        vm.dropping = false;

        // Methods
        vm.gotoProducts = gotoProducts;
        vm.onCategoriesSelectorOpen = onCategoriesSelectorOpen;
        vm.onCategoriesSelectorClose = onCategoriesSelectorClose;
        vm.fileAdded = fileAdded;
        vm.upload = upload;
        vm.fileSuccess = fileSuccess;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Select the correct product from the data.
            // This is an unnecessary step for a real world app
            // because normally, you would request the product
            // with its id and you would get only one product.
            // For demo purposes, we are grabbing the entire
            // json file which have more than one product details
            // and then hand picking the requested product from
            // it.
            var id = $state.params.id;

            for ( var i = 0; i < vm.product.length; i++ )
            {
                if ( vm.product[i].id === parseInt(id) )
                {
                    vm.product = vm.product[i];
                    break;
                }
            }
            // END - Select the correct product from the data
        }

        /**
         * Go to products page
         */
        function gotoProducts()
        {
            $state.go('app.site_overview.store.products');
        }

        /**
         * On categories selector open
         */
        function onCategoriesSelectorOpen()
        {
            // The md-select directive eats keydown events for some quick select
            // logic. Since we have a search input here, we don't need that logic.
            $document.find('md-select-header input[type="search"]').on('keydown', function (e)
            {
                e.stopPropagation();
            });
        }

        /**
         * On categories selector close
         */
        function onCategoriesSelectorClose()
        {
            // Clear the filter
            vm.categoriesSelectFilter = '';

            // Unbind the input event
            $document.find('md-select-header input[type="search"]').unbind('keydown');
        }

        /**
         * File added callback
         * Triggers when files added to the uploader
         *
         * @param file
         */
        function fileAdded(file)
        {
            // Prepare the temp file data for media list
            var uploadingFile = {
                id  : file.uniqueIdentifier,
                file: file,
                type: 'uploading'
            };

            // Append it to the media list
            vm.product.images.unshift(uploadingFile);
        }

        /**
         * Upload
         * Automatically triggers when files added to the uploader
         */
        function upload()
        {
            // Set headers
            vm.ngFlow.flow.opts.headers = {
                'X-Requested-With': 'XMLHttpRequest',
                //'X-XSRF-TOKEN'    : $cookies.get('XSRF-TOKEN')
            };

            vm.ngFlow.flow.upload();
        }

        /**
         * File upload success callback
         * Triggers when single upload completed
         *
         * @param file
         * @param message
         */
        function fileSuccess(file, message)
        {
            // Iterate through the media list, find the one we
            // are added as a temp and replace its data
            // Normally you would parse the message and extract
            // the uploaded file data from it
            angular.forEach(vm.product.images, function (media, index)
            {
                if ( media.id === file.uniqueIdentifier )
                {
                    // Normally you would update the media item
                    // from database but we are cheating here!
                    var fileReader = new FileReader();
                    fileReader.readAsDataURL(media.file.file);
                    fileReader.onload = function (event)
                    {
                        media.url = event.target.result;
                    };

                    // Update the image type so the overlay can go away
                    media.type = 'image';
                }
            });
        }
    }
})();

(function () {
  'use strict';

  angular.module('app.sitemap')
    .directive('qiuSitemapOnSelect', ['$rootScope', openSitemap])
    .controller('selectSitemapDialogController', selectSitemapDialogController);

  /** @ngInject */
  function selectSitemapDialogController($scope, $rootScope, $translate, $mdDialog, dragulaService, sitemapService, sitemaps) {

    var vm = this;
    vm.sitemaps = sitemaps;
    vm.closeDialog = closeDialog;

    vm.msScrollOptions = {
      suppressScrollX: true
    };

    function closeDialog() {
      $mdDialog.hide();
    }

    $rootScope.$on('selectSitemap', function (event, id) {
      $mdDialog.hide(id);
    });

    $scope.filterItems = function (node) {
      var result = true;
      if (vm.searchQuery && vm.searchQuery !== '') {
        result = node.label.toLowerCase().indexOf(vm.searchQuery.toLowerCase()) >= 0;
      }
      return result;
    };
  }

  function openSitemap($rootScope) {

    return {
      restrict: 'A',
      link: function (scope, element, attrs) {

        $(element).on('click', function (e) {
          var id = attrs.rowid;

          $rootScope.$broadcast('selectSitemap', id);
        });
      }
    };
    vm.newSitemapTitle = false;
  }
})();

(function () {
  'use strict';

  angular.module('app.sitemap')
    .controller('copySitemapDialog', copySitemapDialog);

  /** @ngInject */
  function copySitemapDialog($scope, $rootScope, $translate, $mdDialog, sessionService) {

    var vm = this;
    vm.closeDialog = closeDialog;
    vm.saveDialog = saveDialog;
    vm.langs = Object.values(sessionService.getSiteLanguages()).map(x => {
      return {
        id: x.id_lang,
        name: x.lang_name
      }
    })

    vm.msScrollOptions = {
      suppressScrollX: true
    };
    vm.translate = function (text) {
      return $translate.instant(text);
    }

    function closeDialog() {
      $mdDialog.hide();
    }
    function saveDialog() {
      $mdDialog.hide(vm.langs.find(x => x.id == vm.langSelected));
    }

  }

})();

(function () {
  'use strict';

  angular.module('app.sitemap')
    .controller('duplicateSitemapDialog', duplicateSitemapDialog);

  /** @ngInject */
  function duplicateSitemapDialog($scope, $rootScope, $translate, $mdDialog, sitemapService, sitemaps) {

    var vm = this;
    vm.sitemaps = JSON.parse(JSON.stringify(sitemaps));
    vm.closeDialog = closeDialog;
    vm.saveDialog = saveDialog;

    vm.msScrollOptions = {
      suppressScrollX: true
    };
    vm.translate = function (text) {
      return $translate.instant(text);
    }
    vm.isDisabled = function () {
      return vm.sitemaps.find(x => {
        return !x.new_name || !x.new_url;
      })
    }
    function closeDialog() {
      $mdDialog.hide();
    }
    function saveDialog() {
      $mdDialog.hide(vm.sitemaps.map(x => {
        return {
          "id_sitemap": x.id_sitemap,
          "name": x.new_name,
          "url": x.new_url,
          "extension": x.new_extension,
          "parent_sitemap": x.parent_sitemap
        }
      }));
    }

  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('CalendarViewController', CalendarViewController);

    /** @ngInject */
    function CalendarViewController($scope, $document, $mdDialog, $mdSidenav, BoardService, DialogService)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.eventSources = [];

        vm.calendarUiConfig = {
            calendar: {
                editable                 : true,
                eventLimit               : true,
                header                   : '',
                handleWindowResize       : false,
                aspectRatio              : 1,
                dayNames                 : ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                dayNamesShort            : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                timezone                 : 'local',
                eventDurationEditable    : false,
                defaultTimedEventDuration: '01:00:00',
                viewRender               : function (view)
                {
                    vm.calendarView = view;
                    vm.calendar = vm.calendarView.calendar;
                    vm.currentMonthShort = vm.calendar.getDate().format('MMM');
                },
                columnFormat             : {
                    month: 'ddd',
                    week : 'ddd D',
                    day  : 'ddd D'
                },
                eventClick               : function eventDetail(calendarEvent, ev)
                {
                    vm.openCardDialog(ev, calendarEvent.idCard);
                },
                eventDrop                : function (event)
                {
                    vm.board.cards.getById(event.idCard).due = moment.utc(event.start).format('x');
                },
                selectable               : true,
                selectHelper             : true,
                dayClick                 : function (date, ev)
                {
                    var offset = moment().utcOffset();
                    var corrDate = '';

                    if ( offset < 0 )
                    {
                        corrDate = moment.utc(date).subtract(offset, 'm').format('x');
                    }
                    else
                    {
                        corrDate = moment.utc(date).add(offset, 'm').format('x');
                    }

                    eventDialog(corrDate, ev);
                }
            }
        };

        // Methods
        vm.next = next;
        vm.prev = prev;
        vm.goToDate = goToDate;
        vm.openCardDialog = DialogService.openCardDialog;
        vm.toggleSidenav = toggleSidenav;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            vm.cards = getScheduledCards();
            vm.eventSources[0] = vm.cards;
        }

        /**
         * Get scheduled cards and prepare
         * them to show on the calendar
         *
         * @returns {Array}
         */
        function getScheduledCards()
        {
            var cards = [];

            angular.forEach(vm.board.cards, function (card)
            {
                if ( card.due )
                {
                    cards.push({
                        idCard         : card.id,
                        title          : card.name,
                        start          : moment.utc(card.due, 'x'),
                        due            : card.due,
                        backgroundColor: getEventBgColor(card.due)
                    });
                }
            });

            return cards;
        }

        /**
         * Get background color
         *
         * @param cardDue
         * @returns {*}
         */
        function getEventBgColor(cardDue)
        {
            if ( moment() > moment(cardDue, 'x') )
            {
                return '#F44336';
            }

            return '#4CAF50';
        }

        /**
         * Watch board changes
         */
        $scope.$watch('vm.board', function (current, old)
        {
            if ( angular.equals(current, old) )
            {
                return;
            }

            init();

        }, true);

        /**
         * Go to Date
         *
         * @param date
         */
        function goToDate(date)
        {
            vm.calendarView.calendar.gotoDate(date);
            $mdSidenav('scheduled-tasks-sidenav').close();
        }

        /**
         * Go to next on current view (week, month etc.)
         */
        function next()
        {
            vm.calendarView.calendar.next();
        }

        /**
         * Go to previous on current view (week, month etc.)
         */
        function prev()
        {
            vm.calendarView.calendar.prev();
        }

        /**
         * Event Dialog
         */
        function eventDialog(date, ev)
        {
            $mdDialog.show({
                templateUrl        : 'app/main/apps/scrumboard/views/calendar/dialogs/event/event-dialog.html',
                controller         : 'ScrumboardCalendarEventDialogController',
                controllerAs       : 'vm',
                parent             : $document.find('#scrumboard'),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    dueDate: date
                }
            });
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('BoardsViewController', BoardsViewController);

    /** @ngInject */
    function BoardsViewController(BoardList)
    {
        var vm = this;

        // Data
        vm.boardList = BoardList.data;

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('BoardViewController', BoardViewController);

    /** @ngInject */
    function BoardViewController($document, $window, $timeout, $mdDialog, msUtils, BoardList, BoardService, CardFilters, DialogService)
    {
        var vm = this;

        // Data
        vm.currentView = 'board';
        vm.board = BoardService.data;
        vm.boardList = BoardList.data;
        vm.cardFilters = CardFilters;
        vm.card = {};
        vm.cardOptions = {};
        vm.newListName = '';
        vm.sortableListOptions = {
            axis       : 'x',
            delay      : 75,
            distance   : 7,
            items      : '> .list-wrapper',
            handle     : '.list-header',
            placeholder: 'list-wrapper list-sortable-placeholder',
            tolerance  : 'pointer',
            start      : function (event, ui)
            {
                var width = ui.item[0].children[0].clientWidth;
                var height = ui.item[0].children[0].clientHeight;
                ui.placeholder.css({
                    'min-width': width + 'px',
                    'width'    : width + 'px',
                    'height'   : height + 'px'
                });
            }
        };
        vm.sortableCardOptions = {
            appendTo            : 'body',
            connectWith         : '.list-cards',
            delay               : 75,
            distance            : 7,
            forceHelperSize     : true,
            forcePlaceholderSize: true,
            handle              : msUtils.isMobile() ? '.list-card-sort-handle' : false,
            helper              : function (event, el)
            {
                return el.clone().addClass('list-card-sort-helper');
            },
            placeholder         : 'list-card card-sortable-placeholder',
            tolerance           : 'pointer',
            scroll              : true,
            sort                : function (event, ui)
            {
                var listContentEl = ui.placeholder.closest('.list-content');
                var boardContentEl = ui.placeholder.closest('#board');

                if ( listContentEl )
                {
                    var listContentElHeight = listContentEl[0].clientHeight,
                        listContentElScrollHeight = listContentEl[0].scrollHeight;

                    if ( listContentElHeight !== listContentElScrollHeight )
                    {
                        var itemTop = ui.position.top,
                            itemBottom = itemTop + ui.item.height(),
                            listTop = listContentEl.offset().top,
                            listBottom = listTop + listContentElHeight;

                        if ( itemTop < listTop + 25 )
                        {
                            listContentEl.scrollTop(listContentEl.scrollTop() - 25);
                        }

                        if ( itemBottom > listBottom - 25 )
                        {
                            listContentEl.scrollTop(listContentEl.scrollTop() + 25);
                        }
                    }
                }

                if ( boardContentEl )
                {
                    var boardContentElWidth = boardContentEl[0].clientWidth;
                    var boardContentElScrollWidth = boardContentEl[0].scrollWidth;

                    if ( boardContentElWidth !== boardContentElScrollWidth )
                    {
                        var itemLeft = ui.position.left,
                            itemRight = itemLeft + ui.item.width(),
                            boardLeft = boardContentEl.offset().left,
                            boardRight = boardLeft + boardContentElWidth;

                        if ( itemLeft < boardLeft + 25 )
                        {
                            boardContentEl.scrollLeft(boardContentEl.scrollLeft() - 25);
                        }

                        if ( itemRight > boardRight )
                        {
                            boardContentEl.scrollLeft(boardContentEl.scrollLeft() + 25);
                        }
                    }
                }
            }
        };

        // Methods
        vm.openCardDialog = DialogService.openCardDialog;
        vm.addNewList = addNewList;
        vm.removeList = removeList;
        vm.cardFilter = cardFilter;
        vm.isOverdue = isOverdue;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {

            $timeout(function ()
            {
                // IE list-content max-height hack
                if ( angular.element('html').hasClass('explorer') )
                {
                    // Calculate the height for the first time
                    calculateListContentHeight();

                    // Attach calculateListContentHeight function to window resize
                    $window.onresize = function ()
                    {
                        calculateListContentHeight();
                    };
                }
            }, 0);

        }

        /**
         * IE ONLY
         * Calculate the list-content height
         * IE ONLY
         */
        function calculateListContentHeight()
        {
            var boardEl = angular.element('#board');
            var boardElHeight = boardEl.height();

            boardEl.find('.list-wrapper').each(function (index, el)
            {
                // Get the required heights for calculations
                var listWrapperEl = angular.element(el),
                    listHeaderElHeight = listWrapperEl.find('.list-header').height(),
                    listFooterElHeight = listWrapperEl.find('.list-footer').height();

                // Calculate the max height
                var maxHeight = boardElHeight - listHeaderElHeight - listFooterElHeight;

                // Add the max height
                listWrapperEl.find('.list-content').css({'max-height': maxHeight});
            });
        }

        /**
         * Add new list
         */
        function addNewList()
        {
            if ( vm.newListName === '' )
            {
                return;
            }

            vm.board.lists.push({
                id     : msUtils.guidGenerator(),
                name   : vm.newListName,
                idCards: []
            });

            vm.newListName = '';
        }

        /**
         * Remove list
         *
         * @param ev
         * @param list
         */
        function removeList(ev, list)
        {
            var confirm = $mdDialog.confirm({
                title              : 'Remove List',
                parent             : $document.find('#scrumboard'),
                textContent        : 'Are you sure want to remove list?',
                ariaLabel          : 'remove list',
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true,
                ok                 : 'Remove',
                cancel             : 'Cancel'
            });
            $mdDialog.show(confirm).then(function ()
            {
                vm.board.lists.splice(vm.board.lists.indexOf(list), 1);
            }, function ()
            {
                // Canceled
            });

        }

        /**
         * Card filter
         *
         * @param cardId
         * @returns {*}
         */
        function cardFilter(cardId)
        {
            var card = vm.board.cards.getById(cardId);

            try
            {
                if ( angular.lowercase(card.name).indexOf(angular.lowercase(vm.cardFilters.name)) < 0 )
                {
                    throw false;
                }

                angular.forEach(vm.cardFilters.labels, function (label)
                {
                    if ( !msUtils.exists(label, card.idLabels) )
                    {
                        throw false;
                    }
                });

                angular.forEach(vm.cardFilters.members, function (member)
                {
                    if ( !msUtils.exists(member, card.idMembers) )
                    {
                        throw false;
                    }
                });


            } catch ( err )
            {
                return err;
            }

            return true;
        }

        /**
         * Is the card overdue?
         *
         * @param cardDate
         * @returns {boolean}
         */
        function isOverdue(cardDate)
        {
            return moment() > moment(cardDate, 'x');
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('SettingsSidenavController', SettingsSidenavController);

    /** @ngInject */
    function SettingsSidenavController($mdColorPalette, BoardService)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.palettes = $mdColorPalette;
        vm.selectedMenu = 'Settings';

        // Methods

        ////////

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('FiltersSidenavController', FiltersSidenavController);

    /** @ngInject */
    function FiltersSidenavController(msUtils, BoardService, CardFilters)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.cardFilters = CardFilters;
        vm.labels = vm.board.labels;
        vm.members = vm.board.members;
        vm.selectedMenu = 'Settings';

        // Methods
        vm.exists = msUtils.exists;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.clearFilters = CardFilters.clear;
        vm.filteringIsOn = CardFilters.isOn;

        ////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('msSbAddCardController', msSbAddCardController)
        .directive('msSbAddCard', msSbAddCardDirective);

    /** @ngInject */
    function msSbAddCardController($scope, $timeout, BoardService, msUtils)
    {
        var vm = this;

        vm.newCardName = '';
        vm.listId = $scope.msListId;
        vm.board = BoardService.data;
        vm.cards = vm.board.cards;
        vm.list = vm.board.lists.getById(vm.listId);

        // Methods
        vm.addNewCard = addNewCard;

        /////

        /**
         * Add New Card
         */
        function addNewCard()
        {
            if ( vm.newCardName === '' )
            {
                return;
            }

            var newCardId = msUtils.guidGenerator();

            vm.cards.push({
                id               : newCardId,
                name             : vm.newCardName,
                description      : '',
                idAttachmentCover: '',
                idMembers        : [],
                idLabels         : [],
                attachments      : [],
                subscribed       : false,
                checklists       : [],
                checkItems       : 0,
                checkItemsChecked: 0,
                comments         : [],
                activities       : [],
                due              : null
            });

            vm.list.idCards.push(newCardId);

            $timeout(function ()
            {
                $scope.scrollListContentBottom();
            });

            vm.newCardName = '';
        }
    }

    /** @ngInject */
    function msSbAddCardDirective($document, $window, $timeout)
    {
        return {
            restrict   : 'E',
            controller : 'msSbAddCardController as vm',
            templateUrl: 'app/main/apps/scrumboard/directives/ms-sb-add-card/ms-sb-add-card.html',
            scope      : {
                msListId: '='
            },
            link       : function (scope, iElement)
            {
                scope.formActive = false;
                scope.toggleForm = toggleForm;
                scope.scrollListContentBottom = scrollListContentBottom;

                var buttonEl = iElement.find('.ms-sb-add-card-button'),
                    formEl = iElement.find('.ms-sb-add-card-form'),
                    listCards = iElement.parent().prev().find('.list-cards');

                /**
                 * Click Event
                 */
                buttonEl.on('click', toggleForm);

                /**
                 * Toggle Form
                 */
                function toggleForm()
                {
                    scope.$evalAsync(function ()
                    {
                        scope.formActive = !scope.formActive;

                        if ( scope.formActive )
                        {
                            $timeout(function ()
                            {
                                formEl.find('input').focus();

                                scrollListContentBottom();
                            });

                            $document.on('click', outSideClick);
                        }
                        else
                        {
                            PerfectScrollbar.update(listCards[0]);
                            $document.off('click', outSideClick);
                        }

                        $timeout(function ()
                        {
                            // IE list-content max-height hack
                            if ( angular.element('html').hasClass('explorer') )
                            {
                                angular.element($window).trigger('resize');
                            }
                        });

                    });
                }

                /**
                 * Scroll List to the Bottom
                 */
                function scrollListContentBottom()
                {
                    listCards[0].scrollTop = listCards[0].scrollHeight;
                }

                /**
                 * Click Outside Event Handler
                 * @param event
                 */
                var outSideClick = function (event)
                {
                    var isChild = formEl.has(event.target).length > 0;
                    var isSelf = formEl[0] === event.target;
                    var isInside = isChild || isSelf;

                    if ( !isInside )
                    {
                        toggleForm();
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('ScrumboardCardDialogController', ScrumboardCardDialogController);

    /** @ngInject */
    function ScrumboardCardDialogController($document, $mdDialog, QiuTheming, QiuGenerator, msUtils, BoardService, cardId)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.card = vm.board.cards.getById(cardId);
        vm.newLabelColor = 'red';
        vm.members = vm.board.members;
        vm.labels = vm.board.labels;

        // Methods
        vm.palettes = QiuTheming.getRegisteredPalettes();
        vm.rgba = QiuGenerator.rgba;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;
        vm.closeDialog = closeDialog;
        vm.getCardList = getCardList;
        vm.removeCard = removeCard;
        /* Attachment */
        vm.toggleCoverImage = toggleCoverImage;
        vm.removeAttachment = removeAttachment;
        /* Labels */
        vm.labelQuerySearch = labelQuerySearch;
        vm.filterLabel = filterLabel;
        vm.addNewLabel = addNewLabel;
        vm.removeLabel = removeLabel;
        /* Members */
        vm.memberQuerySearch = memberQuerySearch;
        vm.filterMember = filterMember;
        /* Checklist */
        vm.updateCheckedCount = updateCheckedCount;
        vm.addCheckItem = addCheckItem;
        vm.removeChecklist = removeChecklist;
        vm.createCheckList = createCheckList;
        /* Comment */
        vm.addNewComment = addNewComment;

        //////////

        /**
         * Close Dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

        /**
         * Get Card List
         */
        function getCardList()
        {
            var response;
            for ( var i = 0, len = vm.board.lists.length; i < len; i++ )
            {
                if ( vm.board.lists[i].idCards.indexOf(vm.card.id) > -1 )
                {
                    response = vm.board.lists[i];
                    break;
                }
            }
            return response;
        }

        /**
         * Remove card
         *
         * @param ev
         */
        function removeCard(ev)
        {
            var confirm = $mdDialog.confirm({
                title              : 'Remove Card',
                parent             : $document.find('#scrumboard'),
                textContent        : 'Are you sure want to remove card?',
                ariaLabel          : 'remove card',
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true,
                ok                 : 'Remove',
                cancel             : 'Cancel'
            });

            $mdDialog.show(confirm).then(function ()
            {
                var cardList = getCardList();

                cardList.idCards.splice(cardList.idCards.indexOf(vm.card.id), 1);

                vm.board.cards.splice(vm.board.cards.indexOf(vm.card), 1);

            }, function ()
            {
                // Canceled
            });
        }

        /**
         * Toggle cover image
         *
         * @param attachmentId
         */
        function toggleCoverImage(attachmentId)
        {
            if ( attachmentId === vm.card.idAttachmentCover )
            {
                vm.card.idAttachmentCover = null;
            }
            else
            {
                vm.card.idAttachmentCover = attachmentId;
            }
        }

        /**
         * Remove attachment
         *
         * @param item
         */
        function removeAttachment(item)
        {
            if ( vm.card.idAttachmentCover === item.id )
            {
                vm.card.idAttachmentCover = '';
            }
            vm.card.attachments.splice(vm.card.attachments.indexOf(item), 1);
        }

        /**
         * Add label chips
         *
         * @param query
         * @returns {filterFn}
         */
        function labelQuerySearch(query)
        {
            return query ? vm.labels.filter(createFilterFor(query)) : [];
        }

        /**
         * Label filter
         *
         * @param label
         * @returns {boolean}
         */
        function filterLabel(label)
        {
            if ( !vm.labelSearchText || vm.labelSearchText === '' )
            {
                return true;
            }

            return angular.lowercase(label.name).indexOf(angular.lowercase(vm.labelSearchText)) >= 0;
        }

        /**
         * Add new label
         */
        function addNewLabel()
        {
            vm.board.labels.push({
                id   : msUtils.guidGenerator(),
                name : vm.newLabelName,
                color: vm.newLabelColor
            });

            vm.newLabelName = '';
        }

        /**
         * Remove label
         */
        function removeLabel()
        {
            var arr = vm.board.labels;
            arr.splice(arr.indexOf(arr.getById(vm.editLabelId)), 1);

            angular.forEach(vm.board.cards, function (card)
            {
                if ( card.idLabels && card.idLabels.indexOf(vm.editLabelId) > -1 )
                {
                    card.idLabels.splice(card.idLabels.indexOf(vm.editLabelId), 1);
                }
            });

            vm.newLabelName = '';
        }

        /**
         * Add member chips
         *
         * @param query
         * @returns {Array}
         */
        function memberQuerySearch(query)
        {
            return query ? vm.members.filter(createFilterFor(query)) : [];
        }

        /**
         * Member filter
         *
         * @param member
         * @returns {boolean}
         */
        function filterMember(member)
        {
            if ( !vm.memberSearchText || vm.memberSearchText === '' )
            {
                return true;
            }

            return angular.lowercase(member.name).indexOf(angular.lowercase(vm.memberSearchText)) >= 0;
        }

        /**
         * Update check list stats
         * @param list
         */
        function updateCheckedCount(list)
        {
            var checkItems = list.checkItems;
            var checkedItems = 0;
            var allCheckedItems = 0;
            var allCheckItems = 0;

            angular.forEach(checkItems, function (checkItem)
            {
                if ( checkItem.checked )
                {
                    checkedItems++;
                }
            });

            list.checkItemsChecked = checkedItems;

            angular.forEach(vm.card.checklists, function (item)
            {
                allCheckItems += item.checkItems.length;
                allCheckedItems += item.checkItemsChecked;
            });

            vm.card.checkItems = allCheckItems;
            vm.card.checkItemsChecked = allCheckedItems;
        }

        /**
         * Add checklist item
         *
         * @param text
         * @param checkList
         */
        function addCheckItem(text, checkList)
        {
            if ( !text || text === '' )
            {
                return;
            }

            var newCheckItem = {
                'name'   : text,
                'checked': false
            };

            checkList.checkItems.push(newCheckItem);

            updateCheckedCount(checkList);
        }

        /**
         * Remove checklist
         *
         * @param item
         */
        function removeChecklist(item)
        {
            vm.card.checklists.splice(vm.card.checklists.indexOf(item), 1);

            angular.forEach(vm.card.checklists, function (list)
            {
                updateCheckedCount(list);
            });
        }

        /**
         * Create checklist
         */
        function createCheckList()
        {
            vm.card.checklists.push({
                id               : msUtils.guidGenerator(),
                name             : vm.newCheckListTitle,
                checkItemsChecked: 0,
                checkItems       : []
            });

            vm.newCheckListTitle = '';
        }

        /**
         * Add new comment
         *
         * @param newCommentText
         */
        function addNewComment(newCommentText)
        {
            var newComment = {
                idMember: '36027j1930450d8bf7b10158',
                message : newCommentText,
                time    : 'now'
            };

            vm.card.comments.unshift(newComment);
        }

        /**
         * Filter for chips
         *
         * @param query
         * @returns {filterFn}
         */
        function createFilterFor(query)
        {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(item)
            {
                return angular.lowercase(item.name).indexOf(lowercaseQuery) >= 0;
            };
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('app.mediahub', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {

    $stateProvider.state('app.site_overview.mediahub', {
      abstract: true,
      url: '/mediahub'
    });

    $stateProvider.state('app.site_overview.mediahub.tags', {
      url: '/tags',
      views: {
        'content@app': {
          templateUrl: 'app/main/apps/mediahub/tags/tags.html',
          controller: 'MediahubTagsController as vm'
        }
      },
      bodyClass: 'mediahub-tags'
    });

    $stateProvider.state('app.site_overview.mediahub.faces', {
      url: '/faces',
      views: {
        'content@app': {
          templateUrl: 'app/main/apps/mediahub/faces/faces.html',
          controller: 'MediahubFacesController as vm'
        }
      },
      bodyClass: 'mediahub-faces'
    });

    $stateProvider.state('app.site_overview.mediahub.type', {
      // NOTE: Make mediaType optional so /mediahub works
      url: '/{mediaType}',
      params: {
        // NOTE: Default route param to avoid empty string
        mediaType: { value: 'all', squash: false }
      },
      views: {
        'content@app': {
          templateUrl: 'app/main/apps/mediahub/mediahub.html',
          controller: 'MediahubController as vm'
        }
      },
      bodyClass: 'mediahub'
    }).state('app.site_overview.mediahub.type.edit', {
      url: '/:id',
      bodyClass: 'content'
    });

    $translatePartialLoaderProvider.addPart('app/main/apps/mediahub');
  }
})();

(function () {
    'use strict';

    angular
        .module('app.mediahub')
        .controller('MhUploadDialogController', MhUploadDialogController);

    /** @ngInject */
    function MhUploadDialogController($mdDialog, mediahubService, $q, msUtils, galleryId, siteID, $translate, $scope, sessionService, tagsService, $log) {
        var vm = this;

        // State
        vm.uploading = false;
        vm.uploaded = false;
        vm.files = [];
        vm.galleries = [];
        vm.loadingGalleries = true;

        // Multi-edit form: metadata + tags applied to every uploaded media on creation.
        vm.mediaData = {
            title: '', photographer: '', owner: '', caption: '',
            geoLat: null, geoLon: null, fileDate: null, dateUploaded: null
        };
        vm.modifiedFields = {};
        vm.currentTags = [];
        vm.tagMode = 'add';
        vm.showTagMode = false; // toggle only relevant when editing existing media
        vm.showGeoDates = false; // upload flow doesn't persist geolocation/dates yet
        vm.showTitle = false; // title is per-image; never bulk-set on upload
        vm.tags = sessionService.site_operative && sessionService.site_operative.tags ? sessionService.site_operative.tags : [];
        vm.searchTagText = null;
        vm.selectedTag = null;
        vm.newTagDisabled = false;

        // Methods
        vm.closeDialog = closeDialog;
        vm.upload = upload;
        vm.removeFile = removeFile;
        vm.getIconForFile = getIconForFile;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.existInArray = msUtils.existInArray;

        // Multi-edit form methods (shared with the edit-multiple-fields partial)
        vm.translate = function (key) { return $translate.instant(key); };
        vm.updateMapFromInputs = function () {};
        vm.markModified = function (field) { vm.modifiedFields[field] = true; };
        vm.clearField = function (field) { vm.mediaData[field] = null; vm.modifiedFields[field] = false; };
        vm.getpos = function (event) {
            if (!event || !event.latLng) return;
            var lat = event.latLng.lat(), lon = event.latLng.lng();
            $scope.$applyAsync(function () { vm.mediaData.geoLat = lat; vm.mediaData.geoLon = lon; });
        };
        vm.placeMarker = function (place) {
            var p = place || (this && typeof this.getPlace === 'function' ? this.getPlace() : null);
            if (p && p.geometry && p.geometry.location) {
                var lat = p.geometry.location.lat(), lon = p.geometry.location.lng();
                $scope.$applyAsync(function () { vm.mediaData.geoLat = lat; vm.mediaData.geoLon = lon; });
            }
        };
        vm.selectedItemChange = function () { vm.searchTagText = ''; vm.selectedTag = null; };
        vm.labelQuerySearch = function (query) {
            var ret = [];
            if (query) {
                var filtered = angular.copy(vm.tags.filter(vm.createFilterFor(query)));
                if (filtered.length > 0) { ret.push({ id_tag: 0, tag_name: '', order: 1 }); }
                angular.forEach(filtered, function (val) { ret.push(val); });
            }
            return ret;
        };
        vm.createFilterFor = function (query) {
            var lowercaseQuery = angular.lowercase(query).normalize('NFD').replace(/[̀-ͯ]/g, '');
            return function (item) {
                if (!item || angular.isUndefined(item.tag_name)) return false;
                var normItem = typeof item.tag_name === 'string' ? item.tag_name.normalize('NFD').replace(/[̀-ͯ]/g, '') : item.tag_name;
                return angular.lowercase(normItem.toString()).indexOf(lowercaseQuery) >= 0;
            };
        };
        vm.newTag = function (tagName) {
            if (vm.newTagDisabled || !tagName) return false;
            vm.newTagDisabled = true;
            var tagObj = { id_tag: '', tag_name: tagName };
            tagsService.saveItem({ site: siteID, item: tagObj }).then(function (response) {
                tagObj.id_tag = response.id_tag;
                vm.currentTags.push(tagObj);
                vm.searchTagText = '';
                vm.tags.push(tagObj);
            }).catch(function (err) {
                $log.error('[mediahub] Error creating tag:', err);
            }).finally(function () {
                vm.newTagDisabled = false;
            });
        };

        // Build the media metadata payload sent on creation (only edited fields + tags).
        vm.buildMediaMetadata = buildMediaMetadata;

        init();

        // ----- Implementation -----

        function init() {
            mediahubService.listGalleries().then(function (resp) {
                var flat = resp && resp.data ? resp.data : (resp || []);
                // Mark currently selected gallery as assigned
                vm.galleries = buildGalleryTree(flat, galleryId);
                vm.loadingGalleries = false;
            }).catch(function () {
                vm.loadingGalleries = false;
            });
        }

        function closeDialog() {
            $mdDialog.hide(vm.uploaded);
        }

        // Collect only edited metadata fields + tags to store on each new media.
        function buildMediaMetadata() {
            var payload = {};
            // 'title' intentionally excluded — it's per-image, never bulk-set on upload.
            ['photographer', 'owner', 'caption', 'geoLat', 'geoLon'].forEach(function (field) {
                var val = vm.mediaData[field];
                if (val !== null && val !== undefined && val !== '') {
                    if (field === 'geoLat' || field === 'geoLon') {
                        var parsed = parseFloat(val);
                        if (!isNaN(parsed)) payload[field] = parsed;
                        return;
                    }
                    payload[field] = val;
                }
            });
            if (vm.modifiedFields['fileDate'] && vm.mediaData.fileDate) {
                payload.fileDate = new Date(vm.mediaData.fileDate).toISOString();
            }
            if (vm.modifiedFields['dateUploaded'] && vm.mediaData.dateUploaded) {
                payload.dateUploaded = new Date(vm.mediaData.dateUploaded).toISOString();
            }
            if (vm.currentTags && vm.currentTags.length > 0) {
                payload.tags = vm.currentTags.map(function (t) { return t.tag_name || t; });
            }
            return payload;
        }

        function removeFile(file) {
            if (vm.uploading) return;
            var idx = vm.files.indexOf(file);
            if (idx > -1) vm.files.splice(idx, 1);
        }

        /**
         * Upload all staged files sequentially, each to every selected gallery.
         * After all uploads complete, close the dialog automatically.
         */
        function upload() {
            if (!vm.files || vm.files.length === 0) return;

            var selectedGalleryIds = getSelectedGalleryIds(vm.galleries, []);
            vm.uploading = true;

            var sequence = $q.resolve();
            angular.forEach(vm.files, function (file) {
                sequence = sequence.then(function () {
                    return uploadSingleFile(file, selectedGalleryIds);
                });
            });

            sequence.then(function () {
                vm.uploading = false;
                vm.uploaded = true;
                // Auto-close ONLY if everything succeeded
                $mdDialog.hide(true);
            }).catch(function() {
                vm.uploading = false;
                // Don't auto-close on error so user can see what failed
            });
        }

        vm.repeatedRemember = null;

        // ...

        function uploadSingleFile(file, galleryIds, action, targetMediaId) {
            // If we have a remembered action but no specific targetMediaId yet,
            // we still need to make the first call to get the 409/Conflict data 
            // so we can extract the correct ID for THIS specific file.
            // UNLESS the action is 'ignore' or 'duplicate', which don't need an ID.

            if (vm.repeatedRemember && !action) {
                if (vm.repeatedRemember === 'ignore') {
                    file._status = 'done';
                    return $q.resolve();
                }
                if (vm.repeatedRemember === 'duplicate') {
                    action = 'duplicate';
                }
                // If it's 'replace', we don't set action yet because we need the ID from the first 409 response.
            }

            file._status = 'uploading';
            file._progress = 0;
            file._error = null;

            var primaryGalleryId = galleryIds && galleryIds.length ? galleryIds[0] : null;
            var folder = null;
            if (primaryGalleryId) {
                var gallery = findGalleryInTree(vm.galleries, primaryGalleryId);
                if (gallery) {
                    var slug = gallery.slug || (gallery.name ? gallery.name.toLowerCase().replace(/[^\w-]+/g, '-') : 'untitled');
                    folder = primaryGalleryId + '-' + slug;
                }
            }

            return mediahubService
                .getPresignedUploadUrl(file.name, file.type, galleryIds, buildMediaMetadata(), folder, action, targetMediaId)
                .then(function (resp) {
                    var data = resp.data || resp;

                    if (data.success === false && data.action === 'conflict') {
                        // If we have a remembered 'replace' decision, apply it automatically using the ID we just got
                        if (vm.repeatedRemember === 'replace') {
                            return uploadSingleFile(file, galleryIds, 'replace', data.existingMedia.id);
                        }
                        
                        return openConflictDialog(file, galleryIds, data);
                    }

                    if (!data.uploadUrl) {
                        return $q.reject(new Error('No uploadUrl returned by API'));
                    }

                    file._status = 'uploading';
                    return putToS3(data.uploadUrl, file, file.type, function (pct) {
                        file._progress = pct;
                    });
                })
                .then(function () {
                    file._status = 'done';
                    file._progress = 100;
                })
                .catch(function (err) {
                    var data = (err && err.data) || err;
                    
                    if (data && data.action === 'conflict') {
                        if (vm.repeatedRemember === 'replace') {
                            return uploadSingleFile(file, galleryIds, 'replace', data.existingMedia.id);
                        }
                        return openConflictDialog(file, galleryIds, data);
                    }

                    if (err === undefined) return; 

                    file._status = 'error';
                    file._error = (err && err.message) || (data && data.message) || 'Upload failed';
                    return $q.reject(err);
                });
        }

        function openConflictDialog(file, galleryIds, data) {
            return $mdDialog.show({
                controller: 'MhRepeatedUploadFilesController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/mediahub/dialogs/upload/mh-repeated-upload-files.html',
                locals: {
                    uploadFile: file,
                    repeatedFiles: [data.existingMedia]
                },
                multiple: true,
                clickOutsideToClose: false
            }).then(function (result) {
                if (result.remember) {
                    vm.repeatedRemember = result.action;
                }

                if (result.action === 'ignore') {
                    file._status = 'done';
                    return $q.resolve();
                }

                // Retry with chosen action and the ID from the conflict data
                var targetId = (result.action === 'replace' && result.existingMedia) ? result.existingMedia.id : null;
                return uploadSingleFile(file, galleryIds, result.action, targetId);
            });
        }


        /**
         * PUT a File directly to S3 via native XHR.
         * Native XHR bypasses AngularJS HTTP interceptors so the app's
         * Authorization Bearer token is never injected (S3 rejects it).
         */
        function putToS3(url, file, contentType, onProgress) {
            var deferred = $q.defer();
            var xhr = new XMLHttpRequest();
            xhr.open('PUT', url, true);
            xhr.setRequestHeader('Content-Type', contentType || 'application/octet-stream');

            var tenant = mediahubService.getCurrentTenant && mediahubService.getCurrentTenant();
            if (tenant) {
                xhr.setRequestHeader('X-Tenant', tenant);
            }

            if (xhr.upload && onProgress) {
                xhr.upload.addEventListener('progress', function (e) {
                    if (e.lengthComputable) {
                        onProgress(Math.round((e.loaded / e.total) * 100));
                    }
                });
            }
            xhr.onload = function () {
                if (xhr.status >= 200 && xhr.status < 300) {
                    deferred.resolve();
                } else {
                    deferred.reject(new Error('S3 PUT failed: ' + xhr.status + '\n' + xhr.responseText));
                }
            };
            xhr.onerror = function () { deferred.reject(new Error('Network error uploading to S3')); };
            xhr.send(file);
            return deferred.promise;
        }

        // ----- Helpers -----

        function getSelectedGalleryIds(list, result) {
            angular.forEach(list, function (g) {
                if (g.assigned_gallery && !g.no_files_allowed) {
                    result.push(parseInt(g.id_gallery || g.id, 10));
                }
                if (g.children && g.children.length) {
                    getSelectedGalleryIds(g.children, result);
                }
            });
            return result;
        }

        function buildGalleryTree(flatList, preselectedId) {
            var byId = {};
            var roots = [];
            (flatList || []).forEach(function (g) {
                g.id_gallery = g.id_gallery || g.id;
                g.children = [];
                g.assigned_gallery = preselectedId && (g.id_gallery == preselectedId || g.id == preselectedId);
                g._collapsed = true; // start collapsed
                byId[g.id_gallery] = g;
            });
            Object.keys(byId).forEach(function (id) {
                var node = byId[id];
                if (node.parentId && byId[node.parentId]) {
                    byId[node.parentId].children.push(node);
                } else {
                    roots.push(node);
                }
            });
            return roots;
        }

        function getIconForFile(file) {
            if (!file || !file.type) return 'icon-file-document';
            if (file.type.indexOf('image/') === 0) return 'icon-image';
            if (file.type.indexOf('video/') === 0) return 'icon-video';
            if (file.type.indexOf('audio/') === 0) return 'icon-music-note';
            if (file.type === 'application/pdf') return 'icon-file-pdf';
            return 'icon-file-document';
        }

        function findGalleryInTree(list, id) {
            for (var i = 0; i < list.length; i++) {
                var g = list[i];
                if ((g.id_gallery || g.id) == id) return g;
                if (g.children && g.children.length) {
                    var found = findGalleryInTree(g.children, id);
                    if (found) return found;
                }
            }
            return null;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.mediahub')
        .controller('MhRepeatedUploadFilesController', MhRepeatedUploadFilesController);

    /** @ngInject */
    function MhRepeatedUploadFilesController($mdDialog, uploadFile, repeatedFiles) {
        var vm = this;

        // Data passed from parent
        vm.uploadFile = uploadFile;
        vm.repeatedFiles = repeatedFiles;
        vm.rememberDecision = false;

        // Methods
        vm.isImage = isImage;
        vm.isVideo = isVideo;
        vm.closeDialog = closeDialog;
        vm.maintainBoth = maintainBoth;
        vm.replaceImage = replaceImage;

        function isImage(f) {
            return f && f.type && f.type.startsWith("image");
        }

        function isVideo(f) {
            return f && f.type && f.type.startsWith("video");
        }

        function closeDialog() {
            $mdDialog.hide({
                action: 'ignore',
                remember: vm.rememberDecision,
                file: vm.uploadFile
            });
        }

        function maintainBoth() {
            $mdDialog.hide({
                action: 'duplicate',
                remember: vm.rememberDecision,
                file: vm.uploadFile
            });
        }

        function replaceImage() {
            $mdDialog.hide({
                action: 'replace',
                remember: vm.rememberDecision,
                file: vm.uploadFile,
                existingMedia: vm.repeatedFiles[0]
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.mediahub')
        .controller('MhSettingsDialogController', MhSettingsDialogController);

    /** @ngInject */
    function MhSettingsDialogController($mdDialog, usersService, $scope, $translate, $mdToast, $log, siteID, defaultPermissions) {
        var vm = this;
        vm.siteID = siteID;

        vm.saving = false;
        vm.loadingGroups = false;
        vm.mediahubGroups = [];
        
        // Presets Data
        vm.defaultPermissions = defaultPermissions && defaultPermissions.length > 0 ? angular.copy(defaultPermissions) : [
            { name: 'Default Permissions', groups: [] }
        ];
        vm.selectedPreset = vm.defaultPermissions[0];

        // Methods
        vm.save = save;
        vm.cancel = cancel;
        vm.addPreset = addPreset;
        vm.deletePreset = deletePreset;
        vm.selectPreset = selectPreset;
        vm.toggleGroupSelection = toggleGroupSelection;
        vm.isGroupSelected = isGroupSelected;
        vm.toggleAllGroups = toggleAllGroups;
        vm.isAllSelected = isAllSelected;

        // Init
        init();

        function init() {
            loadGroups();
            // TODO: Load existing presets from backend/settings if available
        }

        function loadGroups() {
            vm.loadingGroups = true;
            usersService.getUsersGroups({ siteID: vm.siteID }).then(function (response) {
                const groups = (response && response.data) ? response.data : response;
                if (!Array.isArray(groups)) return;

                const mediahubGroup = groups.find(function (g) { return g.raw_settings && g.raw_settings.mediahub_root === true; });
                vm.mediahubGroups = mediahubGroup ? mediahubGroup.children : [];

                if (vm.mediahubGroups) {
                    vm.mediahubGroups.sort(function (a, b) {
                        return (a.sort || 0) - (b.sort || 0) || (a.name || '').localeCompare(b.name || '');
                    });
                }
            }).catch(function (error) {
                $log.error('[MhSettingsDialogController] Error loading groups', error);
            }).finally(function () {
                vm.loadingGroups = false;
            });
        }

        function addPreset() {
            var newPreset = {
                name: 'New Preset ' + (vm.defaultPermissions.length + 1),
                groups: []
            };
            vm.defaultPermissions.push(newPreset);
            vm.selectedPreset = newPreset;
            if (vm.settingsForm) {
                vm.settingsForm.$setDirty();
            }
        }

        function deletePreset(preset, ev) {
            if (ev) {
                ev.stopPropagation();
            }
            
            var index = vm.defaultPermissions.indexOf(preset);
            if (index > -1) {
                vm.defaultPermissions.splice(index, 1);
                
                // Update selection if we deleted the selected one
                if (vm.selectedPreset === preset) {
                    if (vm.defaultPermissions.length > 0) {
                        vm.selectedPreset = vm.defaultPermissions[Math.max(0, index - 1)];
                    } else {
                        vm.selectedPreset = null;
                    }
                }
                
                if (vm.settingsForm) {
                    vm.settingsForm.$setDirty();
                }
            }
        }

        function selectPreset(preset) {
            vm.selectedPreset = preset;
        }

        function toggleGroupSelection(group) {
            if (!vm.selectedPreset) return;
            
            var index = vm.selectedPreset.groups.indexOf(group.id_group);
            if (index > -1) {
                vm.selectedPreset.groups.splice(index, 1);
            } else {
                vm.selectedPreset.groups.push(group.id_group);
            }
            vm.settingsForm.$setDirty();
        }

        function toggleAllGroups() {
            if (!vm.selectedPreset) return;

            if (isAllSelected()) {
                vm.selectedPreset.groups = [];
            } else {
                vm.selectedPreset.groups = vm.mediahubGroups.map(function (g) { return g.id_group; });
            }
            vm.settingsForm.$setDirty();
        }

        function isAllSelected() {
            if (!vm.selectedPreset || !vm.mediahubGroups || vm.mediahubGroups.length === 0) {
                return false;
            }
            return vm.selectedPreset.groups.length === vm.mediahubGroups.length;
        }

        function isGroupSelected(group) {
            if (!vm.selectedPreset) return false;
            return vm.selectedPreset.groups.indexOf(group.id_group) !== -1;
        }

        function save() {
            vm.saving = true;
            console.log('Saved Default Permissions Presets:', vm.defaultPermissions);
            // Return the configured presets
            $mdDialog.hide(vm.defaultPermissions);
        }

        function cancel() {
            $mdDialog.cancel();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.mediahub')
        .controller('MediahubShowDialogController', MediahubShowController);

    /** @ngInject */
    function MediahubShowController($mdDialog, sessionService, Images, ImageSelected, $document, Tags, cropFormats, MediaFull, CommonMediaService, $sce,
        $timeout, mediaService, requestContext, $scope, transformMedia) {
        var vm = this;
        vm.views = {
            fotorama: 'app/main/apps/mediahub/dialogs/media-show/views/fotorama-view.html',
            editmedia: 'app/main/apps/mediahub/dialogs/media-show/views/edit-media-view.html',
        };
        vm.viewsWithTags = {
            fotorama: 'app/main/apps/mediahub/dialogs/media-show/views/fotorama-view-with-tags.html',
        };
        vm.defaultView = 'fotorama';
        vm.currentView = 'fotorama';


        // Data
        vm.title = 'View Media';
        vm.images = [];
        vm.dataImages = [];
        vm.siteID = requestContext.getParam("siteId");
        vm.tags = sessionService.site_operative.tags;

        // Methods
        vm.closeDialog = closeDialog;
        vm.changeView = changeView;
        vm.initMejPlayer = initMejPlayer;
        vm.toggleSubstitles = toggleSubstitles;
        vm.edit = edit;
        vm.labelQuerySearch = labelQuerySearch;
        vm.createFilterFor = createFilterFor;
        vm.newTag = newTag;
        vm.removeTag = removeTag;
        vm.selectedItemChange = selectedItemChange;
        vm.showTagsEdit = Tags === true;
        vm.CleanMediaGalleriesWithMediaAssignment = [];

        function getAssignedGalleriesIds(galleries, result) {
            angular.forEach(galleries, function (gallery) {
                if (gallery.assigned_gallery) {
                    result.push(gallery.id_gallery);
                }
                if (gallery.children && gallery.children.length > 0) {
                    getAssignedGalleriesIds(gallery.children, result);
                }
            });
            return result;
        }

        // Load galleries for assignment
        var sortFieldGalleries = "sort";
        var sortDirGalleries = "ASC";
        if (sessionService.site_operative.mediaGalleriesDefaultSort) {
            sortFieldGalleries = sessionService.site_operative.mediaGalleriesDefaultSort.field || "sort";
            sortDirGalleries = sessionService.site_operative.mediaGalleriesDefaultSort.dir || "ASC";
        }
        mediaService.getNestedMediaGalleries({ siteID: vm.siteID, sortField: sortFieldGalleries, sortDir: sortDirGalleries })
            .then(function (response) {
                var nestedGalleries = transformMedia.formatNestedGalleries(response.data, response.qiuRestrictions, true);
                vm.CleanMediaGalleriesWithMediaAssignment = angular.copy(nestedGalleries);
            });


        vm.trustSrc = function (src) {
            return $sce.trustAsResourceUrl(src);
        }

        if (!_.isArray(Images) && (Images.media_type == 2)) {
            vm.isUniqueVideo = true;
            vm.isM3u8 = Images.media_type == 2 && Images.embed && Images.embed.endsWith('.m3u8');
            if (Images.meta_analyses && Images.meta_analyses.aws_transcription && Images.meta_analyses.aws_transcription.status == "COMPLETED") {
                vm.isSubtitlesAvailable = true;
                var vtt = awsTranscribeToVtt(Images.meta_analyses.aws_transcription);
                console.log(vtt);
                setTimeout(() => {
                    var blob = new Blob([vtt], { type: 'text/plain' });
                    var track = document.getElementById("track-subtitles");
                    track.kind = "captions";
                    track.label = "English";
                    track.srclang = "en";
                    var objectURL = URL.createObjectURL(blob);
                    track.src = objectURL;
                    track.addEventListener("load", function () {
                        this.mode = "showing";
                        document.getElementById('mp4-player').textTracks[0].mode = "showing"; // thanks Firefox
                    });
                }, 200);
            }

            // vm.isM3u8
        }

        // //////////


        /**
         * Close dialog
         */
        function closeDialog() {
            var $fotoramaDiv = $('#fotorama').fotorama();
            var fotorama = $fotoramaDiv.data('fotorama');
            if (fotorama) {
                fotorama.destroy();
            }
            $mdDialog.hide();
        }

        init();

        function init() {

            vm.loaded = false;
            vm.dataFotorama = [];
            vm.tagsToShow = [];
            var cropstatus;
            var urlImage;
            var cropContainer;
            var selected;
            var fit = (cropFormats) ? 'scaledown' : 'contain';

            vm.fotoramaoptions = {
                width: '100%',
                height: '80%',
                captions: true,
                loop: true,
                keyboard: true,
                allowfullscreen: true,
                autoplay: false,
                nav: 'thumbs',
                ratio: 16 / 9,
                fit: fit,
            };

            if (Tags === true) {
                $timeout(function () {
                    var fotorama = angular.element('.fotorama');
                    fotorama.on('fotorama:showend', function (e, fotorama, extra) {
                        var index = fotorama.activeFrame.i;
                        vm.currentItem = Images[index - 1];
                        loadMediaTagsToEdit();
                        $scope.$apply();
                    });
                    vm.currentItem = ImageSelected;
                    loadMediaTagsToEdit();
                }, 1000)
            }

            if (angular.isArray(Tags)) {
                for (var i = 0; i < Tags.length; i++) {
                    if (Tags[i].id_tag !== 1) {
                        vm.tagsToShow.push(Tags[i].tag_name);
                    }
                }
            }

            if (!cropFormats) {
                if (!_.isArray(Images)) {
                    var ImagesArray = [];
                    ImagesArray.push(Images);
                    Images = ImagesArray;
                }


                for (var i = 0; i < Images.length; i++) {

                    var attachment = Images[i];
                    var attachmentContainer = sessionService.getContainerByID(Images[i].id_container);
                    if (typeof attachment == 'object') {
                        var imagesCrops = [];

                        for (var iCrop = 0; iCrop < Images[i].cropstatus.length; iCrop++) {
                            var imageCrop = Images[i].cropstatus[iCrop];
                            imagesCrops.push(Images[i].cropstatus[iCrop]);
                        }
                        if (ImageSelected) {
                            selected = (Images[i].id_media === ImageSelected.id_media) ? true : false;
                        } else {
                            selected = false;
                        }

                        if (Images[i].media_type !== 1) {
                            // continue;
                        }

                        // .container.view_url}}{{image.cropstatus[0].fileName

                        if (attachment.media_type == 1) {

                            if (MediaFull) {

                                /*
                                                                cropstatus = _.find(Images[i].cropstatus, {
                                                                    'id_cropformats': sessionService.getMediaFullCropformatId()
                                                                });
                                */


                                if (cropstatus) {
                                    cropContainer = sessionService.getContainerByID(cropstatus.id_container);
                                    urlImage = cropContainer.view_url + cropstatus.fileName;
                                } else {
                                    urlImage = attachment.imageUrlOriginal || attachment.imageUrl;
                                }
                                if (!urlImage) {
                                    // if original not provided, use cropstatus
                                    var cropstat = _.find(Images[i].cropstatus, function (c) { return c.urlImage; });
                                    if (cropstat) {
                                        urlImage = cropstat.urlImage;
                                    } else {
                                        cropstat = _.find(Images[i].cropstatus, {
                                            'id_cropformats': sessionService.getMediaFullCropformatId()
                                        });
                                        if (cropstat) {
                                            cropContainer = sessionService.getContainerByID(cropstat.id_container);
                                            urlImage = cropContainer.view_url + cropstat.fileName;
                                        }
                                    }
                                }
                                vm.dataFotorama.push({
                                    imageUrl: urlImage,
                                    thumb: urlImage,
                                    dataCaption: '#' + attachment.id_media + ' | ' + urlImage,
                                    html: '<div>123</div>',
                                    selected: selected
                                });
                            } else {
                                cropstatus = _.find(attachment.cropstatus, {
                                    'id_cropformats': sessionService.getMediaFullCropformatId()
                                });
                                if (!cropstatus) {
                                    urlImage = attachmentContainer.view_url + 'original/m' + attachment.id_media + '_' + attachment.filename;
                                } else {
                                    cropContainer = sessionService.getContainerByID(cropstatus.id_container);
                                    urlImage = cropContainer.view_url + cropstatus.fileName;
                                }
                                vm.dataFotorama.push({
                                    imageUrl: urlImage,
                                    thumb: urlImage,
                                    dataCaption: '#' + attachment.id_media + ' | ' + urlImage,
                                    html: '<div>123</div>',
                                    selected: selected
                                });
                            }
                        }

                        if (attachment.media_type == 2) {
                            var videoUrl = '';
                            var imageUrl = attachment.embed_thumb || attachment.imageUrl;
                            if (!attachment.embed) {
                                videoUrl = attachmentContainer ? (attachmentContainer.view_url + 'videos/m' + attachment.id_media + '_' + attachment.filename) : (attachment.imageUrlOriginal || '');
                            } else {
                                if (attachment.embed.indexOf('yt|') !== -1) {
                                    var YT_VideoSource = attachment.embed.split('yt|')[1];
                                    videoUrl = 'https://www.youtube.com/embed/' + YT_VideoSource;
                                } else if (attachment.embed.indexOf('vimeo|') !== -1) {
                                    var Vimeo_VideoSource = attachment.embed.split('vimeo|')[1];
                                    videoUrl = 'https://player.vimeo.com/video/' + Vimeo_VideoSource;
                                } else if (attachment.embed.indexOf('fb|') !== -1) {
                                    var embed_url = angular.element(attachment.embed_url);
                                    videoUrl = embed_url.attr('src');
                                } else if (attachment.embed.indexOf('zc|') !== -1) {
                                    videoUrl = attachment.embed.split('zc|')[1];
                                } else if (attachment.embed.indexOf('x|') !== -1) {
                                    videoUrl = attachment.embed.split('x|')[1];
                                }
                            }
                            if (attachment.thumb) {
                                /*
                                                var cropFormatId = sessionService.getMediaThumbnailCropformatId();
                                                var options = {
                                                  id_media: [attachment.thumb]
                                                };
                                                CommonMediaService.getUrl(options)
                                                  .then(function (response) {
                                                    if (response.length > 0) {
                                                      var cropstatus = _.find(response, function (c) {
                                                        if (c.id_cropformats == cropFormatId) {
                                                          return true;
                                                        }
                                                      });
                                                      imageUrl = cropstatus.url;
                                                      vm.loaded = true;
                                                    }
                                                  })
                                */
                            }

                            vm.dataFotorama.push({
                                imageUrl: imageUrl,
                                thumb: imageUrl,
                                full: imageUrl, // Separate image for the fullscreen mode.
                                video: videoUrl, // Youtube, Vimeo or custom iframe URL
                                id: 'one', // Custom anchor is used with the hash:true option.
                                dataCaption: '#' + attachment.id_media + ' | ' + attachment.filename ? attachment.filename : '',
                                html: '<div></div>',
                                // html: $('selector'), // ...or '<div>123</div>'. Custom HTML inside the frame.
                                fit: 'cover', // Override the global fit option.
                                any: 'Any data relative to the frame you want to store',
                                selected: selected
                            });
                        }
                        if (attachment.media_type == 3) {
                            vm.isAudio = true;
                            var mediaContainer = sessionService.getContainerByID(attachment.cdnContainer);
                            vm.audioUrl = mediaContainer.view_url + 'audios/m' + attachment.id_media + '_' + attachment.filename;
                            console.log(vm.audioUrl)

                        }
                    } else {
                        vm.dataFotorama.push({
                            imageUrl: attachment,
                            thumb: attachment,
                            dataCaption: attachment,
                            html: '<div></div>',
                            selected: false
                        });
                    }
                }

            } else {

                var selectedContainer = sessionService.getContainerByID(ImageSelected.id_container);
                for (var i = 0; i < Images.length; i++) {
                    cropContainer = sessionService.getContainerByID(Images[i].id_container);

                    selected = (Images[i].id_cropformats === ImageSelected.id_cropformats && cropContainer.id_container === selectedContainer.id_container) ? true : false;

                    if (Images[i].urlImage) {
                        urlImage = Images[i].urlImage;
                    } else if (cropContainer.use_grid === 1) {
                        urlImage = cropContainer.view_url + Images[i].grid + '/' + Images[i].fileName;
                    } else {
                        urlImage = cropContainer.view_url + Images[i].fileName;
                    }
                    vm.dataFotorama.push({
                        imageUrl: urlImage,
                        thumb: urlImage,
                        dataCaption: '#' + Images[i].id_cropformats + ' | ' + urlImage,
                        html: '<div></div>',
                        selected: selected
                    });
                }
            }
        }

        function loadMediaTagsToEdit() {
            loadMediaWithTags(vm.currentItem).then(response => {
                if (response) {
                    vm.currentItem.tags = response.tags;
                    vm.currentItem.galleries = response.galleries;
                    vm.currentItem.meta_analyses = response.meta_analyses;
                    vm.currentItem.ai_recognition = response.ai_recognition;

                    if (vm.CleanMediaGalleriesWithMediaAssignment && vm.currentItem.galleries) {
                        var assignedIds = vm.currentItem.galleries.map(function (val) { return String(val.id_gallery || val); });
                        function applyAssignment(galleries) {
                            angular.forEach(galleries, function (g) {
                                g.assigned_gallery = assignedIds.indexOf(String(g.id_gallery)) !== -1;
                                if (g.children) applyAssignment(g.children);
                            });
                        }
                        applyAssignment(vm.CleanMediaGalleriesWithMediaAssignment);
                    }
                }
            })
        }

        function loadMediaWithTags(media) {
            if (media) {
                var options = {
                    siteID: vm.siteID,
                    withTags: true,
                    withCropstatus: true,
                    idMedia: media.id_media,
                    withGalleries: true
                };
                return mediaService.get(options).then(function (response) {
                    return response.data[0];
                });
            } else {
                return false;
            }
        }

        /**
             * Add label chips
             *
             * @param query
             * @returns {filterFn}
             */
        function labelQuerySearch(query) {
            var ret = [];
            if (query) {
                var filteredContent = angular.copy(vm.tags.filter(vm.createFilterFor(query)));
                if (filteredContent.length > 0) {
                    ret.push({
                        id_tag: 0,
                        tag_name: "",
                        order: 1
                    });
                }
                angular.forEach(filteredContent, function (val) {
                    ret.push(val);
                })
            }
            return ret;
        }

        /**
         * Filter for chips
         *
         * @param query
         * @returns {filterFn}
         */
        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(item) {
                if (angular.isUndefined(item.tag_name)) {
                    return false;
                }
                if (!item.tag_name) {
                    return false;
                }
                if (!angular.lowercase(item.tag_name.toString()).indexOf) {
                    return false;
                }
                return angular.lowercase(item.tag_name.toString()).indexOf(lowercaseQuery) >= 0;
            };
        }

        function newTag(tagName) {

            if (vm.newTagDisabled) {
                return false;
            }
            vm.newTagDisabled = true;

            var newTag = {
                id_tag: '',
                tag_name: tagName
            };
            var options = {
                site: $scope.siteID,
                item: newTag
            };
            tagsService.saveItem(options).then(function (response) {
                newTag.id_tag = response.id_tag;
                vm.image.tags.push(newTag);
                vm.searchTagText = '';
                vm.newTagDisabled = false;
            })
        }
        /*
                function removeTag(media, tag) {
                    console.log('removeTag',vm.currentItem.tags);
                    console.log('removeTag',media.tags);return;
                    saveMedia(media)
                        .finally(function(){
                            vm.searchTagText = '';
                            vm.selectedTag = null;
                        })
                }
        */
        function removeTag(media, tag, event) {
            event.stopImmediatePropagation(); // prevent mdChipRemove directive from removing a chip too.
            for (var i = media.tags.length - 1; i >= 0; i--) {
                if (media.tags[i].id_tag === tag.id_tag) {
                    media.tags.splice(i, 1);
                }
            }
            saveMedia(media)
                .finally(function () {
                    vm.searchTagText = '';
                    vm.selectedTag = null;
                })
        }

        function selectedItemChange() {
            saveMedia(vm.currentItem)
                .finally(function () {
                    vm.searchTagText = '';
                    vm.selectedTag = null;
                })
        }

        function saveMedia(mediaOrig) {
            var media = angular.copy(mediaOrig)
            media.tags = media.tags.map(t => t.id_tag);
            media.galleries = getAssignedGalleriesIds(vm.CleanMediaGalleriesWithMediaAssignment, []);
            var options = {
                site: vm.siteID,
                id: media.id_media,
                item: media
            };
            return mediaService.saveMedia(options);
        }

        function initMejPlayer() {
            setTimeout(() => {
                var player = new MediaElementPlayer('vp-m3u8', {
                    startVolume: 1,
                    alwaysShowControls: true,
                    features: ['playpause', 'current', 'progress', 'tracks', 'volume', 'fullscreen'],
                    success: (mediaElement, domObject) => {
                        mediaElement.play();
                    }
                });
            }, 200);
        }
        function changeView(view) {
            if (vm.views[view]) {
                vm.loadingView = true;
                vm.showSearchAndPaginator = false;
                vm.defaultView = view;
                vm.currentView = view;
            }
        }
        function toggleSubstitles() {
            vm.showSubtitles = !vm.showSubtitles;
        }


        function edit() {
            var $fotoramaDiv = angular.element("#fotorama1");
        }



        "use strict";

        function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

        function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

        function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

        function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

        function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

        function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

        function createMaxCharacterPerLineRule() {
            var characterPerLine = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 40;
            return function (element, newElement) {
                return element.content.length + 1 + newElement.content.length < characterPerLine;
            };
        }

        function createMaxTimeRule() {
            var maxTimeInMs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;
            return function (element, newElement) {
                return newElement.from - element.to < maxTimeInMs;
            };
        }

        function createMaxLinesRule() {
            var maxLines = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;
            return function (element, newElement) {
                return element.lines < maxLines;
            };
        } // similar to moment.duration but without having to pull in the entire moment library


        function duration(ms) {
            var millisecondsPerHour = 1000 * 3600;
            var millisecondsPerMinute = 1000 * 60;

            var _hours = Math.floor(ms / millisecondsPerHour);

            ms -= _hours * millisecondsPerHour;

            var _minutes = Math.floor(ms / millisecondsPerMinute);

            ms -= _minutes * millisecondsPerMinute;

            var _seconds = Math.floor(ms / 1000);

            ms -= _seconds * 1000;
            return {
                hours: function hours() {
                    return _hours;
                },
                minutes: function minutes() {
                    return _minutes;
                },
                seconds: function seconds() {
                    return _seconds;
                },
                milliseconds: function milliseconds() {
                    return ms;
                }
            };
        }

        function createTimeStamp(ms) {
            var dur = duration(ms);
            return "".concat(dur.hours() > 9 ? dur.hours() : '0' + dur.hours(), ":").concat(dur.minutes() > 9 ? dur.minutes() : '0' + dur.minutes(), ":").concat(dur.seconds() > 9 ? dur.seconds() : '0' + dur.seconds(), ".").concat(dur.milliseconds() > 99 ? dur.milliseconds() : dur.milliseconds() > 9 ? '0' + dur.milliseconds() : '00' + dur.milliseconds());
        }

        function awsTranscribeToVtt(event) {
            var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
                _ref$characterPerLine = _ref.characterPerLine,
                characterPerLine = _ref$characterPerLine === void 0 ? 40 : _ref$characterPerLine,
                _ref$maxLines = _ref.maxLines,
                maxLines = _ref$maxLines === void 0 ? 2 : _ref$maxLines,
                _ref$maxTimeInMs = _ref.maxTimeInMs,
                maxTimeInMs = _ref$maxTimeInMs === void 0 ? 1000 : _ref$maxTimeInMs;

            var wordsToLineMergeRules = [createMaxCharacterPerLineRule(characterPerLine), createMaxTimeRule(maxTimeInMs)];
            var multilineMergeRules = [createMaxLinesRule(maxLines), createMaxTimeRule(maxTimeInMs)];
            return 'WEBVTT\n\n' + event.results.items.map(function (e) {
                return {
                    content: e.alternatives[0].content,
                    from: Math.floor(parseFloat(e.start_time) * 1000),
                    to: Math.floor(parseFloat(e.end_time) * 1000),
                    characterCount: e.alternatives[0].content ? e.alternatives[0].content.length : 0,
                    type: e.type,
                    // pronunciation | punctuation
                    lines: 1
                };
            }).reduce(function (acc, cur) {
                if (acc.length === 0) return [cur];
                var last = acc[acc.length - 1];

                if (cur.type === 'pronunciation') {
                    var shouldMerge = wordsToLineMergeRules.reduce(function (shouldMerge, rule) {
                        return shouldMerge ? rule(last, cur) : false;
                    }, true);

                    if (shouldMerge) {
                        acc[acc.length - 1] = Object.assign({}, last, {
                            content: "".concat(last.content, " ").concat(cur.content),
                            to: cur.to,
                            characterCount: last.characterCount + 1 + cur.characterCount
                        });
                        return acc;
                    }

                    return [].concat(_toConsumableArray(acc), [cur]);
                } //cur.type === 'punctuation'
                else {
                    acc[acc.length - 1] = Object.assign({}, last, {
                        content: "".concat(last.content).concat(cur.content),
                        characterCount: last.characterCount + cur.characterCount
                    });
                    return acc;
                }
            }, []).reduce(function (acc, cur) {
                if (acc.length === 0) return [cur];
                var last = acc[acc.length - 1];
                var shouldMerge = multilineMergeRules.reduce(function (shouldMerge, rule) {
                    return shouldMerge ? rule(last, cur) : false;
                }, true);

                if (shouldMerge) {
                    acc[acc.length - 1] = Object.assign({}, last, {
                        content: "".concat(last.content, "\n").concat(cur.content),
                        to: cur.to,
                        characterCount: last.characterCount + cur.characterCount,
                        lines: ++last.lines
                    });
                    return acc;
                }

                return [].concat(_toConsumableArray(acc), [cur]);
            }, []).reduce(function (acc, cur, idx) {
                return [].concat(_toConsumableArray(acc), ["".concat(idx + 1, "\n") + "".concat(createTimeStamp(cur.from), " --> ").concat(createTimeStamp(cur.to), "\n") + "".concat(cur.content, "\n\n")]);
            }, []).join('');
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.media', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.site_overview.media', {
            abstract: true,
            url: '/media',
        });


        $stateProvider.state('app.site_overview.media.recognition', {
            url: '/faces',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/media/rekognition.html',
                    controller: 'RekognitionController as vm'
                }
            },
            bodyClass: 'rekognition'
        });

        $stateProvider.state('app.site_overview.media.type', {
            url: '/{mediaType}',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/media/media.html',
                    controller: 'MediaController as vm'
                }
            },
            resolve: {
                MediaType: function () { return '1' }
            },
            bodyClass: 'media'
        }).state('app.site_overview.media.type.edit', {
            url: '/:id',
            bodyClass: 'content'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/media');

    }

})();

(function () {
  'use strict';

  angular
    .module('app.media')
    .directive('qiuMediaDialogOnClickLoadMediaByGalleries2', ['mediaDialogService', LoadMediaDialogMediaByGalleries])
    .controller('MediahubTagDialogController', MediahubTagDialogController)
    ;

  /** @ngInject */
  function MediahubTagDialogController(
    $mdDialog,
    $document,
    mediaService,
    uploadService,
    requestContext,
    $anchorScroll,
    $mdToast,
    $timeout,
    $scope,
    $sce,
    Upload,
    mediazone,
    section,
    maxAttach,
    msUtils,
    showViews,
    COMMON,
    $log,
    transformMedia,
    $translate,
    sessionService,
    tagsService,
    $q,
    $mdSidenav,
    $rootScope
  ) {
    var vm = this;

    // Data

    vm.mediazone = mediazone;
    vm.defaultPage = 1;
    vm.defaultPerPage = 50;
    vm.PerPage = 50;
    vm.searchStringFilter = '';
    vm.searchQuery = '';
    vm.modelSearch = '';
    vm.pagination_search = pagination_search;

    vm.maxAttach = !angular.isUndefined(maxAttach) ? maxAttach : 99999;

    vm.title = '';
    vm.photo_tags = []
    vm.min_match = 90;
    vm.views = {
      1: 'app/main/dialogs/mediahub/views/photos-view.html',
      2: 'app/main/dialogs/mediahub/views/videos-view.html',
      3: 'app/main/dialogs/mediahub/views/files-view.html',
      4: 'app/main/dialogs/mediahub/views/audios-view.html',
      5: 'app/main/dialogs/mediahub/views/galleries-view.html',
      upload: 'app/main/apps/mediahub/dialogs/media-tags-dialog/upload-view-tags.html',
      import: 'app/main/dialogs/mediahub/views/import-view.html',
    };
    vm.processed = false;

    angular.forEach(vm.views, function (value, key) {
      if (!showViews.hasOwnProperty(key) || showViews[key] !== true) {
        delete vm.views[key];
      }
    });
    vm.defaultView = 1;
    vm.currentView = 1;
    vm.firstLoad = true;
    vm.media_type = 1;
    vm.showSearchAndPaginator = true;
    vm.import_field = '';
    vm.import_disabled = '';
    vm.importedFiles = [];
    vm.importPreview = false;
    vm.imported = false;
    vm.importing = false;
    vm.selectedGalleries = [];
    vm.files = [];
    vm.uploadFiles = [];
    vm.uploadedFiles = [];

    vm.searchTagText = '';
    vm.tags = sessionService.site_operative.tags;
    vm.currentTags = [];
    vm.image = {};
    vm.newTagDisabled = false;

    vm.fields = {
      geoLat: null,
      geoLon: null,
      title: null,
      photographer: null,
      credits: null,
      owner: null,
      caption: null,
      city: null,
      country: null,
      uses: null,
      extras: null,
      rating: null,
    };
    // If replying
    // if (angular.isDefined(selectedMail)) {
    //     vm.form.to = selectedMail.from.email;
    //     vm.form.subject = 'RE: ' + selectedMail.subject;
    //     vm.form.message = '<blockquote>' + selectedMail.message + '</blockquote>';
    // }

    // Methods
    vm.closeDialog = closeDialog;
    vm.changeView = changeView;
    vm.changeViewGallery = changeViewGallery;

    vm.nextPage = nextPage;
    vm.prevPage = prevPage;
    vm.morePages = morePages;
    vm.gotoPage = gotoPage;
    vm.firstPage = firstPage;
    vm.upload = upload;
    vm.search = search;

    vm.exists = msUtils.exists;
    vm.alreadySelectedbyZone = alreadySelectedbyZone;
    vm.existInArray = msUtils.existInArray;
    vm.toggleSelectOne = toggleSelectOne;

    vm.selectedItemChange = selectedItemChange;
    vm.labelQuerySearch = labelQuerySearch;
    vm.createFilterFor = createFilterFor;
    vm.newTag = newTag;
    vm.getpos = getpos;
    vm.placeMarker = placeMarker;
    vm.searchLatLon = searchLatLon;
    vm.toggleMediaDialogSidenav = toggleMediaDialogSidenav;
    vm.selectMedia = selectMedia;

    vm.isNumber = angular.isNumber;

    vm.translate = function (text) {
      return $translate.instant(text);
    }


    //////////


    var siteID = requestContext.getParam("siteId");
    var section = requestContext.getParam("section");
    init();

    /**
     * Initialize
     */
    function init() {

      vm.loading = true;
      var options = {
        section: section,
        media_type: vm.media_type,
        page: vm.defaultPage,
        perPage: vm.defaultPerPage
      };
      //
      getData(options);
      getMediaGalleries(vm.media_type);

    }


    $scope.$on('loadMediaDialogMediaByGalleries', function (event, galleries) {
      if (galleries) {
        loadMediaByGalleries(galleries);
      } else {
        unselectGalleries();
      }
    })


    function unselectGalleries() {
      vm.selectedGallery = false;
      vm.selectedContent = false;
      $rootScope.pagination_galleryIds = false;
      $rootScope.sortField = "fileDate"; // reset to default
      $rootScope.sortDir = "DESC"; // reset to default
      var elemList = document.querySelectorAll('.gallery-row');
      elemList.forEach(function (elem) {
        elem.classList.remove('selected');
      });
      var options = {
        section: section,
        media_type: vm.media_type,
        page: vm.defaultPage,
        perPage: vm.defaultPerPage
      };
      getData(options);
    }


    /**
     * Add label chips
     *
     * @param query
     * @returns {filterFn}
     */
    function labelQuerySearch(query) {
      var ret = [];
      if (query) {
        var filteredContent = angular.copy(vm.tags.filter(vm.createFilterFor(query)));
        if (filteredContent.length > 0) {
          ret.push({
            id_tag: 0,
            tag_name: "",
            order: 1
          });
        }
        angular.forEach(filteredContent, function (val) {
          ret.push(val);
        })
      }
      return ret;
    }


    function selectMedia(media) {
      // Retrieve single Media from api, since media from collections doesn't contain ai_recognition and meta_analyses data (for performance purpose).
      mediaService.get({
        siteID: siteID,
        withCropStatus: true,
        idMedia: media.id_media
      })
        .then(function (response) {
          media = response.data[0];

          if (media.ai_recognition && media.ai_recognition.faces && media.ai_recognition.faces[0].enabled) {
            alert("Not valid image: It's already a face uploaded");
            return;
          }

          vm.selectedMedia = media;
        })
    }

    function selectedItemChange() {
      vm.searchTagText = '';
      vm.selectedTag = null;
    }

    function newTag(tagName) {

      if (vm.newTagDisabled) {
        return false;
      }
      vm.newTagDisabled = true;

      var newTag = {
        id_tag: '',
        tag_name: tagName
      };
      var options = {
        site: siteID,
        item: newTag
      };
      tagsService.saveItem(options).then(function (response) {
        newTag.id_tag = response.id_tag;
        vm.photo_tags.push(newTag);
        vm.photo_tags = vm.photo_tags.filter(x => x.tag_name)
        vm.searchTagText = '';
        vm.newTagDisabled = false;
      })
    }

    function pagination_search(searchString) {

      vm.loading = true;
      scrollToTopOfDialog();

      if (vm.selectedGallery) {
        loadMediaByGalleries([vm.selectedGallery]);
      } else {
        var options = {
          section: section,
          media_type: vm.media_type,
          page: vm.defaultPage,
          perPage: vm.defaultPerPage,
          searchString: searchString,
          gallery_type: vm.media_type
        };
        if (vm.media_type) {
          options.mediaTypeFilter = {
            'media_type': {
              selected: [vm.media_type],
              field: 'media_type',
              name: 'media_type'
            }
          }
        };

        getData(options);
      }
    }

    function getMediaGalleries(mediaType) {

      if (sessionService.site_operative.mediaGalleriesDefaultSort) {
        vm.sortFieldGalleries = sessionService.site_operative.mediaGalleriesDefaultSort.field;
        if (!angular.isUndefined(sessionService.site_operative.mediaGalleriesDefaultSort.dir)) {
          vm.sortDirGalleries = sessionService.site_operative.mediaGalleriesDefaultSort.dir;
        }
      } else {
        vm.sortFieldGalleries = "sort";
        vm.sortDirGalleries = "ASC"
      }

      var options = {
        siteID: siteID,
        sortField: vm.sortFieldGalleries,
        sortDir: vm.sortDirGalleries
      };
      if (angular.isNumber(mediaType)) {
        options['gallery_type'] = [mediaType, 0];
      }
      mediaService.getNestedMediaGalleries(options)
        .then(function (response) {
          var qiuRestrictions = response.qiuRestrictions;
          var galleries = response.data;
          var nestedGalleries = transformMedia.formatNestedGalleries(galleries, qiuRestrictions, true);
          vm.CleanMediaGalleries = angular.copy(nestedGalleries);
          transformMedia.preAssignQiuRestrictedRoot(vm.CleanMediaGalleries);
        });
    }


    function loadMediaByGalleries(galleries) {

      vm.loading = true;

      var galleryIds = [];
      angular.forEach(galleries, function (gallery) {
        galleryIds.push(gallery.id_gallery);
      });
      vm.selectedGallery = galleries[0];

      var mediaTypeFilter = {
        'media_type': {
          selected: [vm.media_type],
          field: 'media_type',
          name: 'media_type'
        }
      };

      if (sessionService.site_operative.mediaInGalleriesDefaultSort) {
        $rootScope.sortField = sessionService.site_operative.mediaInGalleriesDefaultSort.field;
        if (!angular.isUndefined(sessionService.site_operative.mediaInGalleriesDefaultSort.dir)) {
          $rootScope.sortDir = sessionService.site_operative.mediaInGalleriesDefaultSort.dir;
        }
      } else {
        $rootScope.sortField = "sort";
      }

      var options = {
        siteID: siteID,
        page: vm.defaultPage,
        resultsPerPage: vm.defaultPerPage,
        search: vm.modelSearch,
        withCropStatus: true,
        withMediaChildren: true,
        sortField: $rootScope.sortField,
        sortDir: $rootScope.sortDir,
        gallery_type: vm.media_type,
        galleryIds: galleryIds
      };

      if (vm.media_type) {
        options.mediaTypeFilter = {
          'media_type': {
            selected: [vm.media_type],
            field: 'media_type',
            name: 'media_type'
          }
        }
      };

      mediaService.getMediaInGalleries(options).then(function (response) {
        vm.totalItems = response.total;
        vm.from = response.from;
        vm.to = response.to;
        vm.currentPage = response.current_page;
        vm.lastPage = response.last_page;
        vm.maxSize = 500;
        vm.bigTotalItems = 175;
        vm.items = response.data;
        vm.loading = false;
      });
    }

    function getData(options) {

      vm.loading = true;
      scrollToTopOfDialog();

      var arrayOptions = {
        siteID: siteID,
        page: options.page,
        resultsPerPage: options.perPage,
        media_type: options.media_type,
        search: vm.modelSearch,
        withCropStatus: true,
        withMediaChildren: true,
        sortField: 'fileDate',

      };

      if (vm.modelSearch && !_.isEmpty(vm.modelSearch)) {
        arrayOptions['searchStringFilter'] = vm.modelSearch;
        // console.log("arrayOptions ", arrayOptions)
      }

      mediaService.get(arrayOptions)
        .then(function (response) {
          // console.log("response ", response)
          vm.totalItems = response.total;
          vm.from = response.from;
          vm.to = response.to;
          vm.currentPage = response.current_page;
          vm.lastPage = response.last_page;
          vm.maxSize = 500;
          vm.bigTotalItems = 175;
          vm.items = response.data;

          //angular.forEach(response.data, function (item) {
          /*
          if (item.media_type == 1) {
              if (item.cropstatus.length < 1) {
                  console.log(item.id_media, 'noImg');
              } else {
                  console.log(item.id_media, 'hasImg');
              }
          } else {
              if (item.thumb) {
                  console.log(item.id_media, 'hasThumb');
              } else {
                  console.log(item.id_media, 'hasEmbedThumb');
              }
          }
          */
          //vm.items.push(item);
          // console.log('vm.items  ', vm.items)
          //})

          $('.md-button')
            .removeClass('active');
          $('[type=' + options.media_type + ']')
            .addClass('active');

          vm.loading = false;
          vm.firstLoad = false;
        })
    }
    function search(options) {
      // console.log(options, vm.searchStringFilter);
      /*

      vm.loading         = true;
      vm.items        =[];
      // Scroll to the top Dialog
      scrollToTopOfDialog();

      mediaService.get({
          siteID: siteID,
          page: options.page,
          paginate: options.perPage,
          media_type: options.media_type,
          withCropStatus: true,
          sortField: 'fileDate',
          searchStringFilter: options.searchString,

      })
          .then(function (response) {
              vm.totalItems = response.total;
              vm.pagination_totalItems = response.total;
              vm.from = response.from;
              vm.pagination_from = response.from;
              vm.to = response.to;
              vm.pagination_to = response.to;
              vm.currentPage = response.current_page;
              vm.lastPage = response.last_page;
              vm.maxSize = 500;
              vm.bigTotalItems = 175;

              vm.loading = false;

              vm.items = angular.copy(response.data);

              $('.md-button')
                  .removeClass('active');
              $('[type=' + options.media_type + ']')
                  .addClass('active');

          });




      vm.firstLoad = false;
*/
    }

    function closeDialog() {
      // delete from media_files if upload not terminated.
      if (vm.uploadFiles.length == 0 || vm.uploadedFiles.length == vm.uploadFiles.length) {
        $mdDialog.hide();
      } else {
        var messageConfirm = $translate.instant('MEDIA.UPLOADING_MEDIA_CLOSE_CONFIRM');
        var confirm = $mdDialog.confirm().multiple(true).title(messageConfirm)
          // .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' will be deleted.')
          .ariaLabel('Close dialog').ok('OK').cancel('CANCEL');

        $mdDialog.show(confirm)
          .then(function () {
            var deleteIds = [];
            for (var i = 0; i < vm.uploadFiles.length; i++) {
              var isFileUploaded = vm.uploadedFiles.some(function (el) {
                return el.id_media == vm.uploadFiles[i].id_media
              });
              if (!isFileUploaded) {
                deleteIds.push(vm.uploadFiles[i].id_media);
              }
            }
            if (deleteIds.length > 0) {
              var options = {
                site: siteID,
                id_media: deleteIds,
                force: true
              };
              mediaService.massDelete(options);
            }
            $mdDialog.hide();
          }, function () {

          })
      }
    }

    function changeView(view) {


      if (vm.views[view]) {

        vm.loading = true;
        scrollToTopOfDialog();

        // console.log(vm.views[view])
        //vm.items = [];
        vm.showSearchAndPaginator = false;
        vm.defaultView = view;
        vm.currentView = view;
        vm.currentViewGallery = false;
        vm.CleanMediaGalleries = [];


        vm.media_type = view;

        var options = {
          page: 1,
          perPage: vm.PerPage,
          media_type: view,

        };
        if (view == 1 || view == 2 || view == 3 || view == 4) {
          vm.showSearchAndPaginator = true;
        }

        if (view == 'upload' || view == 'import') {
          $mdSidenav('media-dialog-galleries-sidenav').close();
        }


        getData(options);
        getMediaGalleries(vm.media_type);
      }

    }

    function changeViewGallery(mediaType) {
      $mdSidenav('media-dialog-galleries-sidenav').close();

      vm.loadingView = true;
      vm.loading = true;
      scrollToTopOfDialog();

      vm.items = [];

      vm.totalItems = 0;
      vm.showSearchAndPaginator = false;

      vm.currentView = 5;
      vm.currentViewGallery = mediaType;

      getMediaGalleries(mediaType);
      $('.md-button')
        .removeClass('active');
      $('[type=5]')
        .addClass('active');

    }


    $scope.$watch('vm.files', function () {
      angular.forEach(vm.files, function (f) {
        vm.uploadFiles.push(f);
      });
      $scope.formUpload = false;
      // console.log("vm.files ", vm.files)
      if (vm.files != null) {
        // make files array for not multiple to be able to be used in ng-repeat in the ui
        if (!angular.isArray(vm.files)) {
          $timeout(function () {
            $scope.files = vm.files = [vm.files];
          });
          return;
        }
        for (var i = 0; i < vm.files.length; i++) {
          $scope.errorMsg = null;
          (function (f) {
            vm.upload(f, true);
          })(vm.files[i]);
        }
      }
    });



    $scope.log = '';

    function upload(file) {
      if (!file.$error) {
        file.processed = false;
        var uploadOptions = {
          siteID: siteID,
          filename: file.name,
          log: $scope.log,
          type: 'media'
        }
        //				console.debug("UPLOAD______****", file)
        uploadService.upload(file, uploadOptions).then(function (resp) {
          $scope.log = resp.log;
          mediaService.get({
            siteID: siteID,
            withCropStatus: true,
            withTags: true,
            idMedia: file.id_media
          })
            .then(function (response) {
              getMedia(file.id_media);
            });
        });
      }
    };

    function getMedia(id_media) {
      mediaService.get({
        siteID: siteID,
        withCropStatus: true,
        idMedia: id_media
      })
        .then(function (response) {
          if (response.data[0].meta_analyses) {
            vm.selectMedia(response.data[0]);
            vm.processed = true;
          } else {
            setTimeout(() => {
              getMedia(id_media);
            }, 5000);
          }
        });
    }


    function nextPage() {

      var options = {
        page: vm.currentPage + 1,
        perPage: vm.PerPage,
        media_type: vm.media_type,
        searchString: vm.modelSearch
      };
      //
      getData(options);

    }

    function prevPage() {
      var options = {
        page: vm.currentPage - 1,
        perPage: vm.PerPage,
        media_type: vm.media_type,
        searchString: vm.modelSearch
      };
      //
      getData(options);
    }

    function morePages() {
      if (vm.currentPage < vm.lastPage) return true;
      return false;
    }

    function firstPage() {
      if (vm.currentPage == 1) return true;
      return false;
    }

    function gotoPage(i) {

      var options = {
        page: i,
        perPage: vm.PerPage,
        media_type: vm.media_type,
        searchString: vm.modelSearch
      };
      //
      getData(options);
    }


    function alreadySelectedbyZone(array, item) {
      var ret = false;
      for (var i = 0, len = array.length; i < len; i++) {
        if (vm.mediazone) {
          if (array[i]['id_media'] === item.id_media && array[i]['id_zone'] === vm.mediazone.id_zone) {
            ret = true;
          }
        } else {
          if (array[i]['id_media'] === item.id_media) {
            ret = true;
          }

        }
      }

      return ret;
    }


    /**
     * Filter for chips
     *
     * @param query
     * @returns {filterFn}
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(item) {
        if (angular.isUndefined(item.tag_name)) {
          return false;
        }
        if (!item.tag_name) {
          return false;
        }
        if (!angular.lowercase(item.tag_name.toString()).indexOf) {
          return false;
        }
        return angular.lowercase(item.tag_name.toString()).indexOf(lowercaseQuery) >= 0;
      };
    }

    function getpos(event) {
      vm.fields.geoLat = event.latLng.lat();
      vm.fields.geoLon = event.latLng.lng();
      vm.latlng = [event.latLng.lat(), event.latLng.lng()];
    }

    function placeMarker() {
      var loc = this.getPlace()
        .geometry.location;
      vm.latlng = [loc.lat(), loc.lng()];
      vm.fields.geoLat = loc.lat();
      vm.fields.geoLon = loc.lng();
      vm.center = [loc.lat(), loc.lng()];
    }

    function searchLatLon() {
      vm.latlng = [vm.fields.geoLat, vm.fields.geoLon];
      vm.center = [vm.fields.geoLat, vm.fields.geoLon];
      vm.center = [40.74, -74.18];
    }



    function toggleSelectOne(photo, event) {
      vm.selectMedia(photo);
    }

    /**
     * Scroll Media Dialog Content to the top
     * @param speed
     */
    function scrollToTopOfDialog() {
      //$timeout(function () {
      var dialogContent = $document.find('md-dialog-content').filter(function () {
        return angular.element(this).hasClass('mediadialog-content');
      });
      if (!angular.isUndefined(dialogContent[0])) {
        dialogContent.animate({
          scrollTop: 0
        }, 1);
      }
      //}, 1000);

    }

    function toggleMediaDialogSidenav(sidenavId) {
      $mdSidenav(sidenavId)
        .toggle();
    }
  }

  function LoadMediaDialogMediaByGalleries(mediaDialogService) {

    function unselectAllGalleries() {
      var elemList = document.querySelectorAll('.gallery-row');
      elemList.forEach(function (elem) {
        elem.classList.remove('selected');
      });
    }

    return {
      restrict: 'A',
      link: function (scope, element, attrs) {

        $(element).on('click', function (e) {
          var galleryNode = false;
          if (element.parent().hasClass('selected')) {
            unselectAllGalleries();
          } else {
            unselectAllGalleries();
            element.parent().addClass('selected');
            galleryNode = scope.node;
          }

          var includeSubgalleries = $('#includeSubgalleries').attr("data-include-subgalleries") == 'true';
          mediaDialogService.triggerMediaDialogMediaByGalleries(galleryNode, includeSubgalleries);
        });
      }
    };
  }
})();




(function () {
    'use strict';

    angular
        .module('app.media')
        .controller('ShareMediahubDialogController', ShareMediahubDialogController);

    /** @ngInject */
    function ShareMediahubDialogController($mdDialog, $mdToast, $translate, $scope, sessionService, medias,
        mediaService) {
        var vm = this;
        vm.closeDialog = closeDialog;
        vm.fotoramaoptions = {
            width: '100%',
            height: '350px',
            captions: false,
            loop: true,
            keyboard: true,
            arrows: true,
            allowfullscreen: false,
            nav: false,
            ratio: 16 / 9,
            fit: 'contain',
        };
        vm.socialNetworks = [];
        vm.medias = medias;
        vm.mediasIds = medias.map(x => x.id_media);
        console.log(vm.medias)

        vm.dataFotorama = vm.medias.map(x => {
            if (x.media_type == 2) {
                var videoUrl = '';
                var imageUrl = x.embed_thumb;
                if (!x.embed) {
                    var attachmentContainer = sessionService.getContainerByID(x.cdnContainer);
                    videoUrl = attachmentContainer.view_url + 'videos/m' + x.id_media + '_' + x.filename;
                } else {
                    if (x.embed.indexOf('yt|') !== -1) {
                        var YT_VideoSource = x.embed.split('yt|')[1];
                        videoUrl = 'http://youtube.com/' + YT_VideoSource;
                    } else if (x.embed.indexOf('vimeo|') !== -1) {
                      var Vimeo_VideoSource = x.embed.split('vimeo|')[1];
                        videoUrl = 'https://player.vimeo.com/video/' + Vimeo_VideoSource;
                    } else if (x.embed.indexOf('fb|') !== -1) {
                        var embed_url = angular.element(x.embed_url);
                        videoUrl = embed_url.attr('src');
                    } else if (x.embed.indexOf('zc|') !== -1) {
                        videoUrl = x.embed.split('zc|')[1];
                    } else if (x.embed.indexOf('x|') !== -1) {
                        videoUrl = x.embed.split('x|')[1];
                    }
                }
                return {
                    imageUrl: imageUrl,
                    thumb: imageUrl,
                    full: imageUrl, // Separate image for the fullscreen mode.
                    video: videoUrl, // Youtube, Vimeo or custom iframe URL
                    id: 'one', // Custom anchor is used with the hash:true option.
                    dataCaption: '#' + x.id_media + ' | ' + x.filename ? x.filename : '',
                    html: '<div></div>',
                    // html: $('selector'), // ...or '<div>123</div>'. Custom HTML inside the frame.
                    fit: 'cover', // Override the global fit option.
                    any: 'Any data relative to the frame you want to store',
                }
            } else {
                var mediaContainer = sessionService.getContainerByID(x.cdnContainer);
                x.imageUrlOriginal = mediaContainer.view_url + 'original/m' + x.id_media + '_' + x.filename;
                return {
                    imageUrl: x.imageUrlOriginal,
                    thumb: x.imageUrlOriginal,
                    html: '<div>123</div>',
                    selected: 0
                }
            }
        })


        function closeDialog() {
            $mdDialog.hide(true);
        }

        $scope.$on('$destroy', function () {
        });
    }
})();


(function () {
	'use strict';

	angular
		.module('app.media')
		.controller('RepeatedUploadFilesMediahubController', RepeatedUploadFilesMediahubController);

	/** @ngInject */
	function RepeatedUploadFilesMediahubController(
		$mdDialog,
		$translate,
		$mdToast,
        uploadFile,
        repeatedFiles) {
		var vm = this;

        vm.uploadFile = uploadFile;
        vm.repeatedFiles = repeatedFiles;
		vm.rememberDecission = false;

		vm.isImage = isImage;
		vm.isVideo = isVideo;
        vm.closeDialog = closeDialog;
		vm.maintainBoth = maintainBoth;
		vm.replaceImage = replaceImage;
		vm.changeRememberDecission = changeRememberDecission;
		vm.checkSelectedRepeated = checkSelectedRepeated;
		vm.changeSelectedRepeated = changeSelectedRepeated;

		function checkSelectedRepeated(file){
			if(vm.selectedRepeated == file){
				return true;
			}else{
				return false;
			}
		}

		function changeSelectedRepeated(file){
			vm.selectedRepeated = file;
		}

		function isImage(f) {
			return f.type.startsWith("image");
		}

		function isVideo(f) {
			return f.type.startsWith("video");
		}

		function changeRememberDecission(){
			vm.rememberDecission = !vm.rememberDecission;
		}

        function closeDialog(){
            $mdDialog.hide(
				{
					action: 'delete',
					remember: vm.rememberDecission,
					file: vm.uploadFile
				}
			);
        }
		function maintainBoth(){
			$mdDialog.hide(
				{
					action: 'maintain',
					remember: vm.rememberDecission,
					file: vm.uploadFile
				}
			);
		}
		function replaceImage(){
			if(vm.repeatedFiles.length > 1){
				if(vm.selectedRepeated){
					var file = vm.selectedRepeated;
				}else{
					var message = $translate.instant('MEDIA.SELECT_ACT_MEDIA ');
					$mdToast.show({
						template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg">' + message + '</div></md-toast>',
						hideDelay: 2000,
						position: 'top',
						parent: '#login-form-wrapper'
					});
					return;
				}
			}else{
				var file = vm.repeatedFiles[0];
			}
			$mdDialog.hide(
				{
					action: 'replace',
					remember: vm.rememberDecission,
					file: vm.uploadFile,
					repeatedFiles: file
				}
			);
		}
	}
})();

(function () {
    'use strict';

    angular
        .module('app.mediahub')
        .controller('MhMediaDialogController', MhMediaDialogController);

    /** @ngInject */
    function MhMediaDialogController($mdDialog, mediahubService, $timeout, $document) {
        var vm = this;

        // Data
        vm.loading = true;
        vm.items = [];
        vm.galleries = [];
        vm.selectedGallery = null;
        vm.selectedMedia = null;

        vm.pagination = {
            totalItems: 0,
            currentPage: 1,
            perPage: 50,
            lastPage: 1
        };

        // Methods
        vm.closeDialog = closeDialog;
        vm.attachMedia = attachMedia;
        vm.toggleSelectMedia = toggleSelectMedia;
        vm.selectGalleryId = selectGalleryId;
        vm.loadMore = loadMore;

        init();

        function init() {
            mediahubService.listGalleries().then(function (resp) {
                var flat = resp && resp.data ? resp.data : (resp || []);
                vm.galleries = buildGalleryTree(flat);
            });
            loadMedia(false);
        }

        function selectGalleryId(id) {
            vm.selectedGallery = id;
            vm.pagination.currentPage = 1;
            vm.items = [];
            loadMedia(false);
        }

        function loadMedia(append) {
            vm.loading = true;
            if (!append) {
                scrollToTopOfDialog();
            }

            var options = {
                page: vm.pagination.currentPage,
                resultsPerPage: vm.pagination.perPage,
                galleryId: vm.selectedGallery || undefined,
                media_type: 1  // images only
            };

            mediahubService.get(options).then(function (response) {
                vm.pagination.totalItems = response.total;
                vm.pagination.currentPage = response.current_page;
                vm.pagination.lastPage = response.last_page;
                if (append) {
                    vm.items = vm.items.concat(response.data || []);
                } else {
                    vm.items = response.data || [];
                }
                vm.loading = false;
            }).catch(function () {
                if (!append) { vm.items = []; }
                vm.loading = false;
            });
        }

        function loadMore() {
            if (vm.pagination.currentPage < vm.pagination.lastPage) {
                vm.pagination.currentPage++;
                loadMedia(true);
            }
        }

        function toggleSelectMedia(item) {
            vm.selectedMedia = item;
        }

        function attachMedia() {
            if (vm.selectedMedia) {
                $mdDialog.hide([vm.selectedMedia]);
            }
        }

        function closeDialog() {
            $mdDialog.cancel();
        }

        function scrollToTopOfDialog() {
            var dialogContent = $document.find('md-dialog-content').filter(function () {
                return angular.element(this).hasClass('mediadialog-content');
            });
            if (!angular.isUndefined(dialogContent[0])) {
                dialogContent.animate({ scrollTop: 0 }, 1);
            }
        }

        function buildGalleryTree(list) {
            var byId = {};
            var roots = [];
            (list || []).forEach(function (g) {
                g.id_gallery = g.id;
                g.gallery_type = g.gallery_type || 0;
                g.children = [];
                byId[g.id] = g;
            });
            Object.keys(byId).forEach(function (id) {
                var node = byId[id];
                if (node.parentId && byId[node.parentId]) {
                    byId[node.parentId].children.push(node);
                } else {
                    roots.push(node);
                }
            });
            Object.keys(byId).forEach(function (id) {
                if (byId[id].children && byId[id].children.length === 0) {
                    delete byId[id].children;
                }
            });
            return roots;
        }
    }
})();

(function () {
	'use strict';

	angular
		.module('app.media')
		.controller('AddMediahubDialogControllerOld', AddMediahubDialogControllerOld);

	/** @ngInject */
	function AddMediahubDialogControllerOld(
		$mdDialog,
		$document,
		currentThread,
		mediaService,
		uploadService,
		requestContext,
		$anchorScroll,
		isReplace,
		item,
		$timeout,
		$scope,
		$rootScope,
		$sce,
		Upload,
		mediazone,
		section,
		msUtils,
		COMMON,
		isTiny,
		$log,
		$translate,
		CleanMediaGalleries,
		sessionService,
		$mdToast,
		tagsService,
		$q,
		preselectedTags) {
		var vm = this;

		// Data
		vm.currentThread = currentThread;

		vm.mediazone = mediazone;
		vm.defaultPage = 1;
		vm.defaultPerPage = 50;
		vm.PerPage = 50;
		vm.searchStringFilter = '';
		vm.searchQuery = '';
		vm.modelSearch = '';
		vm.pagination_search = pagination_search;
		vm.CleanMediaGalleries = angular.copy(CleanMediaGalleries);
		vm.isAttaching = false;
		vm.preselectedTags = preselectedTags;
		vm.showLargeUploadList = false;
		vm.repeatedFilesArray = [];

		vm.fields = {
			geoLat: null,
			geoLon: null,
			title: null,
			photographer: null,
			credits: null,
			owner: null,
			caption: null,
			city: null,
			country: null,
			uses: null,
			extras: null,
			rating: null,
		};

		vm.isTiny = isTiny;

		vm.views = {
			upload: 'app/main/dialogs/mediahub/views/upload-view.html',
			import: 'app/main/dialogs/mediahub/views/import-view.html',
		};
		vm.defaultView = 'upload';
		vm.currentView = 'upload';

		vm.viewsTiny = {
			1: 'app/main/dialogs/mediahub/views/tiny-attached.html',
			properties: 'app/main/dialogs/mediahub/views/tiny-properties.html',
			upload: 'app/main/dialogs/mediahub/views/upload-view.html',
		};
		vm.defaultViewTiny = '1';
		vm.currentViewTiny = '1';

		vm.isReplace = isReplace;
		vm.item = item;


		vm.allowedFilesPattern = "video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz,.json,.xml,.csv,.ttf,.eps,.ai,.psd,.aep,.indd,.idll,.heic,.mkv";

		vm.firstLoad = true;
		vm.media_type = '1';
		vm.showSearchAndPaginator = true;
		vm.import_field = '';
		vm.import_disabled = '';
		vm.importedFiles = [];
		vm.importPreview = false;
		vm.imported = false;
		vm.importing = false;
		vm.selectedContacts = [];
		vm.files = [];
		vm.uploadFiles = [];
		vm.uploadedFiles = [];
		vm.tinyProperties = {
			mediaType: '',
			mediaSort: '',
			mediaData: {},
			align: '',
			size: ''
		};
		vm.tinyOptions = {
			size: [
				{ value: 25, text: '25%' },
				{ value: 50, text: '50%' },
				{ value: 75, text: '75%' },
				{ value: 100, text: '100%' }
			],
			align: [
				{ value: 'left', text: 'left' },
				{ value: 'center', text: 'center' },
				{ value: 'right', text: 'right' }
			]
		}
		vm.searchTagText = '';
		vm.tags = sessionService.site_operative.tags;
		vm.currentTags = [];
		vm.selectedTag = null;
		vm.image = {};
		vm.newTagDisabled = false;
		vm.tagsTabSettings = false;
		vm.checkboxesGroupedByType = [];

		vm.checkRepeatedFiles = false;

		vm.isAdmin = false;

		// If replying
		// if (angular.isDefined(selectedMail)) {
		// 	vm.form.to = selectedMail.from.email;
		// 	vm.form.subject = 'RE: ' + selectedMail.subject;
		// 	vm.form.message = '<blockquote>' + selectedMail.message + '</blockquote>';
		// }

		// Methods
		vm.closeDialog = closeDialog;
		vm.changeView = changeView;
		vm.changeViewTiny = changeViewTiny;

		vm.nextPage = nextPage;
		vm.prevPage = prevPage;
		vm.morePages = morePages;
		vm.gotoPage = gotoPage;
		vm.firstPage = firstPage;
		vm.upload = upload;
		vm.attachMedia = attachMedia;
		vm.attachMediaTiny = attachMediaTiny;
		vm.selectMediaTiny = selectMediaTiny;
		vm.selectedMediaTiny = '';
		vm.search = search;

		vm.exists = msUtils.exists;
		vm.alreadySelectedbyZone = alreadySelectedbyZone;
		vm.existInArray = msUtils.existInArray;
		vm.toggleSelectContact = toggleSelectContact;
		vm.selectedItemChange = selectedItemChange;
		vm.labelQuerySearch = labelQuerySearch;
		vm.createFilterFor = createFilterFor;
		vm.newTag = newTag;
		vm.getpos = getpos;
		vm.placeMarker = placeMarker;
		vm.searchLatLon = searchLatLon;
		vm.radioOptionsFilter = radioOptionsFilter;
		vm.checkboxesFilter = checkboxesFilter;
		vm.updateCurrentTags = updateCurrentTags;
		vm.checkboxGroupTitleByTagTypes = checkboxGroupTitleByTagTypes;
		vm.radioChanged = radioChanged;
		vm.isCurrentTag = isCurrentTag;
		vm.deleteFromUpload = deleteFromUpload;

		vm.loadLargeUploadList = loadLargeUploadList;

		vm.translate = function (text) {
			return $translate.instant(text);
		}


		//////////

		if (!isTiny) {
			var siteID = requestContext.getParam("siteId");
			var section = requestContext.getParam("section");
			init();
		} else {
			vm.section = section;
			initTiny();
		}
		/**
		 * Initialize
		 */
		function init() {

			var siteID = requestContext.getParam("siteId");
			$scope.siteID = siteID;

			vm.loading = true;

			vm.isAdmin = sessionService.user.is_admin;

			// for (var i = 0; i < vm.currentThread.Thumbnail.length; i++) {
			// 	vm.selectedContacts.push(vm.currentThread.Thumbnail[i]);
			// }

			var options = {
				section: section,
				media_type: vm.media_type,
				page: vm.defaultPage,
				perPage: vm.defaultPerPage,

			};
			
			getData(options);

			sessionService.loadDomainResourceSettings($scope.siteID).then(function(response){
				if(response.public){
					var publicConfig = angular.fromJson(response.public);
					if(publicConfig.uploadRepeatCheck){
					  vm.checkRepeatedFiles = publicConfig.uploadRepeatCheck;
					}
				}
            });

			if (sessionService.site_operative.mediaUploadDialogSettings &&
				sessionService.site_operative.mediaUploadDialogSettings.tabs &&
				sessionService.site_operative.mediaUploadDialogSettings.tabs.tags
			) {
				vm.tagsTabSettings = sessionService.site_operative.mediaUploadDialogSettings.tabs.tags;
				setTagTypes();
				preselectTags();
			}
		}



		/**
		 * attachHiddenTags
		 **/
		function attachHiddenTags() {
			if (vm.tagsTabSettings) {
				// Get hidden tags settings
				let hiddenTagsTabSettings = vm.tagsTabSettings.filter(function(tagsTabSetting){
					return tagsTabSetting.field_type == 'hidden';
				})
				angular.forEach(hiddenTagsTabSettings, function(hiddenTagsTabSetting){
					angular.forEach(hiddenTagsTabSetting.tags_types, function(hiddenTagType){
						let hiddenTags = vm.tags.filter(function(tag) {return tag.id_type == hiddenTagType});
						angular.forEach(hiddenTags, function(hiddenTag){
							if (hiddenTagsTabSetting.requires_parent_attached) {
								// Check for the optional, boolean condition 'requires_parent_attached' to attach a hidden tag
								// only if its parent tag was attached too.
								// E.g. the 'Unmatched' tag needs to be attached if its parent tag 'is profile?' was attached.
								// This is because the 'Unmatched' tag is used in AI > Match Profile to filter for profile images
								// that have not been assigned with a Number tag. However if the uploaded image is NOT a profile image,
								// then it doesn't require the 'Unmatched' tag neither.
								let hasParentAttached = vm.currentTags.find(function(currentTag){
									return currentTag.id_tag == hiddenTag.id_parent
								})
								if (hasParentAttached) {
									vm.currentTags.push(hiddenTag)
								}
							} else {
								vm.currentTags.push(hiddenTag)
							}
						})
					})
				})
			}
		}

		/**
		 * Initialize Tinymce
		 */
		function initTiny() {
			vm.currentViewTiny = vm.defaultViewTiny;
			vm.showSearchAndPaginator = false;
			vm.loading = true;
			for (var i = 0; i < vm.currentThread.length; i++) {
				if (vm.mediazone) {
					if (vm.currentThread[i].id_zone == 1) {
						vm.selectedContacts.push(vm.currentThread[i]);
					}
				} else {
					vm.selectedContacts.push(vm.currentThread[i]);
				}
			}
			if (vm.section.mediaSort) {
				var currentSort = 0;
				var currentItem = '';
				for (var i = 0; i < vm.currentThread.length; i++) {
					if (vm.mediazone) {
						if (vm.currentThread[i]['id_zone'] == 1 && (vm.currentThread[i]['media_type'] == vm.section.mediaType)) {
							currentSort++;
							if (currentSort = vm.section.mediaSort) {
								currentItem = vm.currentThread[i];
							}
						}
					} else {
						if (vm.currentThread[i]['media_type'] == vm.section.mediaType) {
							currentSort++;
							if (currentSort = vm.section.mediaSort) {
								currentItem = vm.currentThread[i];
							}
						}

					}
				}

				vm.selectedMediaTiny = currentItem;
				vm.tinyProperties.mediaSort = vm.section.mediaSort;
				vm.tinyProperties.mediaType = currentItem.media_type;
				vm.tinyProperties.align = vm.section.mediaAlign;
				vm.tinyProperties.size = vm.section.mediaSize;
				vm.changeViewTiny('properties');


			}
			vm.loading = false;

		}

		function pagination_search(searchString) {
			var options = {
				section: section,
				media_type: vm.media_type,
				page: vm.defaultPage,
				perPage: vm.defaultPerPage,
				searchString: searchString
			};
			getData(options);
		}

		function getData(options) {

			vm.loading = true;
			vm.items = [];
			$log.info("get data");

			// Scroll to the top Dialog
			scrollToTopOfDialog();

			mediaService.get({
				siteID: siteID,
				page: options.page,
				paginate: options.perPage,
				media_type: options.media_type,
				withCropStatus: true,
				withMediaChildren: true,
				sortField: 'date_uploaded',
				searchStringFilter: options.searchString,

			})
				.then(function (response) {
					vm.totalItems = response.total;
					vm.pagination_totalItems = response.total;
					vm.from = response.from;
					vm.pagination_from = response.from;
					vm.to = response.to;
					vm.pagination_to = response.to;
					vm.currentPage = response.current_page;
					vm.lastPage = response.last_page;
					vm.maxSize = 500;
					vm.bigTotalItems = 175;

					vm.loading = false;

					vm.items = [];
					angular.forEach(response.data, function (item) {
						vm.items.push(item);
					})

					$('.md-button')
						.removeClass('active');
					$('[type=' + options.media_type + ']')
						.addClass('active');

				});

			vm.firstLoad = false;
		}

		function search(options) {
			/*

			vm.loading 		= true;
			vm.items		=[];
			// Scroll to the top Dialog
			scrollToTopOfDialog();

			mediaService.get({
				siteID: siteID,
				page: options.page,
				paginate: options.perPage,
				media_type: options.media_type,
				withCropStatus: true,
				sortField: 'date_uploaded',
				searchStringFilter: options.searchString,

			})
				.then(function (response) {
					vm.totalItems = response.total;
					vm.pagination_totalItems = response.total;
					vm.from = response.from;
					vm.pagination_from = response.from;
					vm.to = response.to;
					vm.pagination_to = response.to;
					vm.currentPage = response.current_page;
					vm.lastPage = response.last_page;
					vm.maxSize = 500;
					vm.bigTotalItems = 175;

					vm.loading = false;

					vm.items = angular.copy(response.data);

					$('.md-button')
						.removeClass('active');
					$('[type=' + options.media_type + ']')
						.addClass('active');

				});




			vm.firstLoad = false;
*/
		}

		function closeDialog(success) {
			// delete from media_files if upload not terminated.
			if (vm.uploadedFiles.length == 0) {
				$mdDialog.hide(vm.currentThread);
			} else if(vm.uploadedFiles.length != vm.uploadFiles.length){
				var messageConfirm = $translate.instant('MEDIA.UPLOADING_MEDIA_CLOSE_CONFIRM');
				var confirm = $mdDialog.confirm().multiple(true).title(messageConfirm)
					// .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' will be deleted.')
					.ariaLabel('Close dialog').ok('OK').cancel('CANCEL');

				$mdDialog.show(confirm)
					.then(function () {
						var deleteIds = [];
						for (var i = 0; i < vm.uploadedFiles.length; i++) {
							deleteIds.push(vm.uploadedFiles[i].id_media);
						}
						if (deleteIds.length > 0) {
							var options = {
								site: siteID,
								id_media: deleteIds,
								force: true
							};
							mediaService.massDelete(options);
						}
						$mdDialog.hide(vm.currentThread);
					}, function () {

					})
			}
			if(!success){
				$mdDialog.hide({
					action: 'delete',
					items: vm.uploadedFiles
				});
			}else{
				$mdDialog.hide({
					replaced: vm.repeatedFilesArray
				});
			}
		}

		function changeView(view) {
			if (vm.views[view]) {
				vm.items = [];
				vm.loadingView = true;
				vm.showSearchAndPaginator = false;
				vm.defaultView = view;
				vm.currentView = view;


				vm.media_type = view;

				var options = {
					page: 1,
					perPage: vm.PerPage,
					media_type: view,

				};
				if (view == 1 || view == 2 || view == 3 || view == 4) {
					vm.showSearchAndPaginator = true;
				}
				getData(options);

			}

		}

		function changeViewTiny(view) {

			if (vm.viewsTiny[view]) {
				vm.items = [];
				vm.loadingView = true;
				vm.showSearchAndPaginator = false;
				vm.defaultViewTiny = view;
				vm.currentViewTiny = view;
				/*
								vm.media_type=view;

								var options = {
									page: 1,
									perPage: vm.PerPage,
									media_type: view,

								};
								if (view == 1 || view == 2 || view == 3 || view == 4) {
									vm.showSearchAndPaginator	= true;
								}
								//
								getData(options);
				*/
			}
		}

		$scope.$watch('vm.files', function () {
			if (vm.files.name && vm.isReplace) {
				var ext1 = vm.files.name.split('.')[1];
				var ext2 = vm.item.filename.split('.')[1];
				if (ext1.toLowerCase() !== ext2.toLowerCase()) {
					var message = $translate.instant('FORMS.ERROR_DIF_EXTENSION');
					$mdToast.show({
						template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg">' + message + '</div></md-toast>',
						hideDelay: 2000,
						position: 'top',
						parent: '#login-form-wrapper'
					});
					return;
				}
			}
			angular.forEach(vm.files, function (f) {
				vm.uploadFiles.push(f);
			});
			$scope.formUpload = false;
			if(vm.files.length && !vm.isReplace){
				var filesFileNames = vm.files.map(x=>{
					return x.name;
				});
				var options = {
					domain: siteID,
					fileNames: filesFileNames
				}
				vm.repeatedUploadObjects = [];
				mediaService.getExistingMedia(options).then(function(response){
					if(response.length && vm.checkRepeatedFiles){
						for(var i=0; i<vm.files.length; i++){
							var repeated = response.filter(x => {
								let responseFileName = getFileNameWithoutExtension(x.filename);
								let vmFileName = getFileNameWithoutExtension(vm.files[i].name);
								return responseFileName === vmFileName;
							});
							if(repeated.length){
								var locals = {
									uploadFile: vm.files[i],
									repeatedFiles: repeated
								}
								vm.repeatedUploadObjects.push(locals);
							}else{
								$scope.errorMsg = null;
								(function (f) {
									vm.upload(f, true);
								})(vm.files[i]);
							}
							if(i+1 == vm.files.length){
								showRepeatedDialog();
							}
						}
					}else{
						if (vm.files != null) {
							// make files array for not multiple to be able to be used in ng-repeat in the ui
							if (!angular.isArray(vm.files)) {
								$timeout(function () {
									$scope.files = vm.files = [vm.files];
								});
								return;
							}
							for (var i = 0; i < vm.files.length; i++) {
								$scope.errorMsg = null;
								(function (f) {
									vm.upload(f, true);
								})(vm.files[i]);
							}
						}
					}
				});
			}else if(vm.isReplace){
				if (vm.files != null) {
					// make files array for not multiple to be able to be used in ng-repeat in the ui
					if (!angular.isArray(vm.files)) {
						$timeout(function () {
							$scope.files = vm.files = [vm.files];
						});
						return;
					}
					for (var i = 0; i < vm.files.length; i++) {
						$scope.errorMsg = null;
						(function (f) {
							vm.upload(f, true);
						})(vm.files[i]);
					}
				}
			}
		});

		function getFileNameWithoutExtension(filename) {
			return filename.substring(0, filename.lastIndexOf('.')).toLowerCase();
		}

		function showRepeatedDialog(multipleRepeated){
			var locals = vm.repeatedUploadObjects[0];
			if(vm.repeatedRemember && !multipleRepeated){
				switch(vm.repeatedRemember){
					case 'delete':
						vm.uploadFiles = vm.uploadFiles.filter(x => x.name != locals.uploadFile.name);
					break;
					case 'maintain':
						$scope.errorMsg = null;
						vm.upload(locals.uploadFile, true);
					break;
					case 'replace':
						if(locals.repeatedFiles.length > 1){
							showRepeatedDialog(vm.repeatedRemember);
						}else{
							$scope.errorMsg = null;
							vm.upload(locals.uploadFile, true, locals.repeatedFiles[0]);
						}
					break;
				}
				vm.repeatedUploadObjects.shift();
				if(vm.repeatedUploadObjects.length){
					showRepeatedDialog();
				}else{
					vm.repeatedRemember = false;
				}
			}else{
				$mdDialog.show({
					controller: 'RepeatedUploadFilesController',
					controllerAs: 'vm',
					locals: locals,
					templateUrl: 'app/main/apps/mediahub/dialogs/mediahub/repeated-upload-files.html',
					parent: angular.element($document.body),
					multiple: true,
					clickOutsideToClose: false
				}).then(function (resp) {
					switch(resp.action){
						case 'delete':
							vm.uploadFiles = vm.uploadFiles.filter(x => x.name != resp.file.name);
						break;
						case 'maintain':
							$scope.errorMsg = null;
							vm.upload(resp.file, true);
						break;
						case 'replace':
							$scope.errorMsg = null;
							vm.upload(resp.file, true, resp.repeatedFiles);
						break;
					}
					if(resp.remember){
						vm.repeatedRemember = resp.action;
					}
					if(multipleRepeated){
						vm.repeatedRemember = multipleRepeated;
					}
					vm.repeatedUploadObjects.shift();
					if(vm.repeatedUploadObjects.length){
						showRepeatedDialog();
					}else{
						vm.repeatedRemember = false;
					}
				});
			}
		}

		$scope.$watch('vm.import_field', function () {
			vm.importConfirm(false);
		});

		$scope.log = '';


		function upload(file, old, repeatFile) {
			if (!file.$error) {
				file.processed = false;
				var uploadOptions = {
					siteID: siteID,
					isReplace: vm.isReplace,
					item: vm.item,
					uploadedFiles: vm.uploadedFiles,
					filename: file.name.replaceAll('(', '').replaceAll(')', ''),
					fileSizeKb: (angular.isDefined(file.size)) ? (parseInt(file.size) / 1000).toFixed(2) : null,
					id_media: vm.isReplace ? vm.item.id_media : null,
					log: $scope.log,
					type: 'media'
				}
				if(repeatFile){
					uploadOptions.isReplace = true;
					uploadOptions.item = repeatFile;
					uploadOptions.id_media = repeatFile.id_media;
				}
				console.debug("UPLOAD______****", file)
				uploadService.upload(file, uploadOptions).then(function (resp) {
					$scope.log = file.log;
					vm.uploadedFiles.push(file);
					var galleriesAssignedIds = getAssignedGalleriesIds(vm.CleanMediaGalleries, []);
					if (angular.isArray(galleriesAssignedIds) && galleriesAssignedIds.length) {
						var options = {
							site: siteID,
							data: {
								id_media: [file.id_media],
								id_gallery: galleriesAssignedIds
							}
						};
						mediaService.insertIntoGallery(options).then(function(response){
							vm.selectedContacts.push(file)
							loadAndAttachMedia(file);
						})
					} else {
						loadAndAttachMedia(file);
					}
					if(vm.isReplace || repeatFile){
						vm.repeatedFilesArray.push(file.id_media);
					}
				});
			}
		};

		function showErrorDialog(message) {
			$mdToast.show({
				template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
				hideDelay: 5000,
				position: 'top',
				parent: '#content-container'
			});
		}

		function loadAndAttachMedia(file) {
			//						console.debug("LOAD_MEDIA_FROM_DB______****", file)
			mediaService.get({
				siteID: siteID,
				withCropStatus: true,
				idMedia: file.id_media
			})
				.then(function (response) {
					//if (response.total == 1) {
						var photo = response.data[0];
						toggleSelectContact(photo);
					//}
				});
		}

		vm.importConfirm = function (confirm) {
			vm.import_disabled = false;
			vm.imported = false;
			if (!confirm) {
				vm.importPreview = false;
			}
			if (vm.import_field.length > 10) {
				vm.importing = true;
				vm.import_disabled = true;

				$timeout(function () {
					var pastedUrl = vm.import_field;
					mediaService.importFromUrl({
						siteID: siteID,
						url: pastedUrl,
						execute: confirm
					})
						.then(function (response) {
							vm.importing = false;
							response.embedCodeSafe = $sce.trustAsHtml(response.metadata.embedCode);
							response.caption = response.metadata.caption;
							response.title = response.metadata.title;
							if (response.id_media) {
								// Attach media to selected gallery
								// For qiu-restricted users with limited gallery access we need to attach media
								// to the users root gallery before loading the media again from api,
								// otherwise the api won't return the media due to qiu restrictions.
								var galleriesAssignedIds = getAssignedGalleriesIds(vm.CleanMediaGalleries, []);
								if (angular.isArray(galleriesAssignedIds) && galleriesAssignedIds.length) {
									var options = {
										site: siteID,
										data: {
											id_media: [response.id_media],
											id_gallery: galleriesAssignedIds
										}
									};
									mediaService.insertIntoGallery(options).then(function(resp){
										vm.imported = true;
										vm.importPreview = false;
										mediaService.get({
											siteID: siteID,
											withCropStatus: true,
											idMedia: response.id_media
										}).then(function (response) {
											if (response.total == 1) {
												var photo = response.data[0];
												vm.importedFiles.push(photo);
												toggleSelectContact(photo);
											}
										});
									})
								} else {
									vm.imported = true;
									vm.importPreview = false;
									mediaService.get({
										siteID: siteID,
										withCropStatus: true,
										idMedia: response.id_media
									}).then(function (response) {
										if (response.total == 1) {
											var photo = response.data[0];
											vm.importedFiles.push(photo);
											toggleSelectContact(photo);
										}
									});
								}
							} else {
								vm.importPreview = response;
							}
							vm.import_disabled = false;
						});
				})
			}
		}

		function nextPage() {

			var options = {
				page: vm.currentPage + 1,
				perPage: vm.PerPage,
				media_type: vm.media_type,

			};
			getData(options);

		}

		function prevPage() {
			var options = {
				page: vm.currentPage - 1,
				perPage: vm.PerPage,
				media_type: vm.media_type,
			};
			getData(options);
		}

		function morePages() {
			if (vm.currentPage <= vm.lastPage) return true;
			return false;
		}

		function firstPage() {
			if (vm.currentPage == 1) return true;
			return false;
		}


		function gotoPage(i) {

			var options = {
				page: i,
				perPage: vm.PerPage,
				media_type: vm.media_type,
				searchString: vm.modelSearch
			};
			getData(options);
		}

		function alreadySelectedbyZone(array, item) {
			var ret = false;
			for (var i = 0, len = array.length; i < len; i++) {
				if (vm.mediazone) {
					if (array[i]['id_media'] === item.id_media && array[i]['id_zone'] === vm.mediazone.id_zone) {
						ret = true;
					}
				} else {
					if (array[i]['id_media'] === item.id_media) {
						ret = true;
					}

				}
			}

			return ret;
		}


		function toggleSelectedbyZone(item) {
			for (var i = 0; vm.selectedContacts.length < i; i++) {
				if (vm.mediazone && vm.selectedContacts[i]['id_media'] === item.id_media && vm.selectedContacts[i]['id_zone'] === vm.mediazone.id_zone) {
					vm.selectedContacts.splice(i, 1);
					return;
				}
			}
			if(vm.selectedContacts.indexOf(item) == -1){
				vm.selectedContacts.push(item);
			}
			return;
		}

		function selectMediaTiny(item) {
			var currentSort = 0;
			var mediaSort = 0;
			for (var i = 0; i < vm.currentThread.length; i++) {
				if (vm.mediazone) {
					if (vm.currentThread[i]['id_zone'] == 1 && (vm.currentThread[i]['media_type'] == item.media_type)) {
						currentSort++;
						if (item.id_media == vm.currentThread[i]['id_media']) {
							mediaSort = currentSort;
						}
					}
				} else {
					currentSort++;
					if (item.id_media == vm.currentThread[i]['id_media']) {
						mediaSort = currentSort;
					}
				}
			}

			vm.selectedMediaTiny = item;
			vm.tinyProperties.mediaSort = mediaSort;
			vm.tinyProperties.mediaType = item.media_type;
			vm.changeViewTiny('properties');
		}

		function deleteFromUpload(file){
			var newUploadFiles = vm.uploadFiles.filter(x => x.id_media != file.id_media);
			vm.uploadFiles = newUploadFiles;
			var newUploadedFiles = vm.uploadedFiles.filter(x => x.id_media != file.id_media);
			vm.uploadedFiles = newUploadedFiles;
			var newSelectedContacts = vm.selectedContacts.filter(x => x.id_media != file.id_media);
			vm.selectedContacts = newSelectedContacts;
			mediaService.massDelete({site: siteID, id_media:[file.id_media], foce:true});
		}

		function attachMedia() {
			var continueAttach = false;
			if (vm.uploadedFiles.length == vm.uploadFiles.length) {
				continueAttach = true;
			} else {
				var messageConfirm = $translate.instant('MEDIA.UPLOADING_MEDIA_CLOSE_CONFIRM');
				var confirm = $mdDialog.confirm().multiple(true).title(messageConfirm)
					// .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' will be deleted.')
					.ariaLabel('Close dialog').ok('OK').cancel('CANCEL');

				$mdDialog.show(confirm)
					.then(function () {
						var deleteIds = [];
						for (var i = 0; i < vm.uploadFiles.length; i++) {
							var isFileUploaded = vm.uploadedFiles.some(function (el) {
								return el.id_media == vm.uploadFiles[i].id_media
							});
							if (!isFileUploaded) {
								deleteIds.push(vm.uploadFiles[i].id_media);
							}
						}
						if (deleteIds.length > 0) {
							var options = {
								site: siteID,
								id_media: deleteIds,
								force: true
							};
							mediaService.massDelete(options);
						}
						continueAttach = true;
					}, function () {

					})
			}

			if (!continueAttach) {
				return false;
			}
			var mediaIDs = [];
			for (var i = 0; i < vm.selectedContacts.length; i++) {
				if (!mediaIDs.includes(vm.selectedContacts[i].id_media)) {
					mediaIDs.push(vm.selectedContacts[i].id_media);
				}
			}
			if (mediaIDs.length == 0) {
				// TODO: show alert
				if(vm.uploadedFiles.length > 0){
					vm.selectedContacts = vm.uploadedFiles;
					for (var i = 0; i < vm.selectedContacts.length; i++) {
						mediaIDs.push(vm.selectedContacts[i].id_media);
					}
				}else{
					console.log('No ID medias');
					return false;
				}
			}

			var uploadedFilesIDs = [];

			var message = (mediaIDs.length > 1) ? $translate.instant('MEDIA.ITEMS_UPLOADED_PLURAL') : $translate.instant('MEDIA.ITEMS_UPLOADED_SINGULAR');
			var fields = {};
			angular.forEach(vm.fields, function (value, key) {
				if (!_.isNull(value) && value != 0) {
					this[key] = value;
				}
			}, fields);
			var galleriesAssigned = getAssignedGalleries(vm.CleanMediaGalleries, []);
			if(vm.uploadedFiles.length > 0){
				vm.uploadedFiles.forEach(element => {
					uploadedFilesIDs.push(element.id_media);
				});
				var batchOptions = {
					siteID: siteID,
					id_medias: uploadedFilesIDs,
					fields: vm.fields,
					tags: vm.currentTags,
					id_galleries: []
				}
				galleriesAssigned.forEach(gallery => {
					batchOptions.id_galleries.push(gallery.id);
				});
				mediaService.finishedUploadingBatchToCdn(batchOptions).then(function(response){
				}).catch(function(error){
					console.log('error', error);
					vm.isAttaching = false;
				});
			}
			if (_.isEmpty(fields) && _.isEmpty(vm.currentTags) && galleriesAssigned.length == 0) {
				vm.reload = true;
				$mdToast.show({
					template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + mediaIDs.length + message + '</span></div></md-toast>',
					hideDelay: 5000,
					position: 'top',
					parent: '#content-container'
				});
				vm.closeDialog(true);
				return false;
			}

			vm.isAttaching = true;
			// Initial promise

			var sequence = $q.defer();
			sequence.resolve();
			sequence = sequence.promise;

			if (galleriesAssigned.length > 0) {

				var inserts = [];
				var mismatches = {};

				angular.forEach(galleriesAssigned, function (gallery) {

					var galleryTypeId = gallery.gallery_type;
					var validMediaIds = [];

					angular.forEach(vm.uploadedFiles, function (file) {
						var fileTypeId = msUtils.getFileTypeId(file.type);
						if (galleryTypeId == 0) {
							validMediaIds.push(file.id_media);
						} else if (galleryTypeId != 0 && fileTypeId && galleryTypeId == fileTypeId) {
							validMediaIds.push(file.id_media);
						} else {
							if (!angular.isArray(mismatches[file.name])) {
								mismatches[file.name] = [];
							}
							if (gallery.gallery_type != 0){
								mismatches[file.name].push(gallery.gallery_name + ' (' + msUtils.getGalleryTypeById(gallery.gallery_type) + ')');
							}
						}
					});
					if (validMediaIds.length > 0) {
						inserts.push({ id_gallery: [gallery.id_gallery], media_ids: validMediaIds });
					}
				});
				if (!_.isEmpty(mismatches)) {
					sequence = sequence.then(function () {
						console.log("seq 1 - confirm mismatch");
						var confirm = $mdDialog.confirm()
							.title($translate.instant('MEDIA.MISMATCH_DIALOG.TITLE'))
							.textContent($translate.instant('MEDIA.MISMATCH_DIALOG.CONTENT'))
							.ariaLabel($translate.instant('MEDIA.MISMATCH_DIALOG.LABEL'))
							.ok($translate.instant('MEDIA.MISMATCH_DIALOG.OK'))
							.cancel($translate.instant('MEDIA.MISMATCH_DIALOG.CANCEL'))
							.multiple(true);
						return $mdDialog.show(confirm);
					})
				}

				angular.forEach(inserts, function (insert) {
					sequence = sequence.then(function () {
						console.log('seq 1 - continue mismatch approved')
						var options = {
							site: siteID,
							data: {
								id_media: insert.media_ids,
								id_gallery: insert.id_gallery
							}
						};
						return mediaService.insertIntoGallery(options);
					});
				}, function () {
					console.log('seq 1 - continue mismatch rejected')
					vm.isAttaching = false;
					return Promise.reject();
				});
			}

			if (!_.isEmpty(fields) || !_.isEmpty(vm.currentTags)) {
				attachHiddenTags();
				sequence = sequence.then(function () {
					var options = {
						site: siteID,
						data: {
							id_media: mediaIDs,
							fields: fields,
							tags: vm.currentTags
							// fields: {
							//  geoLat: vm.fields.geoLat,
							//  geoLon: vm.fields.geoLon
							// }
						}
					};
					return mediaService.massUpdate(options);
				}, function () {
					console.log('seq 2 - reject')
					vm.isAttaching = false;
					return Promise.reject();
				});
			}

			sequence = sequence.then(function () {
				console.log("seq 4 - close dialog");
				vm.isAttaching = false;
				vm.reload = true;
				$mdToast.show({
					template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + mediaIDs.length + message + '</span></div></md-toast>',
					hideDelay: 5000,
					position: 'top',
					parent: '#content-container'
				});
				return vm.closeDialog(vm.selectedContacts);
			}, function () {
				console.log('seq 4 - reject')
				vm.isAttaching = false;
			});
		}

		function attachMediaTiny() {
			$mdDialog.hide(vm.tinyProperties);
		}

		function getAssignedGalleries(galleries, result) {

			angular.forEach(galleries, function (gallery) {
				if (gallery.assigned_gallery == true) {
					result.push(gallery);
				}
				if (typeof gallery.children !== 'undefined' && gallery.children.length > 0) {
					getAssignedGalleries(gallery.children, result);
				}
			});
			return result;
		}

		function getAssignedGalleriesIds(galleries, result) {
			angular.forEach(galleries, function(gallery) {
				if (gallery.assigned_gallery == true && !gallery.no_files_allowed) {
					result.push(gallery.id_gallery);
				}
				if (typeof gallery.children !== 'undefined' && gallery.children.length >0) {
					getAssignedGalleriesIds(gallery.children, result);
				}
			});
			return result;
		}

		vm.isImage = function (f) {
			return f.type.startsWith("image");
		}

		vm.isVideo = function (f) {
			return f.type.startsWith("video");
		}

		function selectedItemChange() {
			vm.searchTagText = '';
			vm.selectedTag = null;
		}

		/**
		* Add label chips
		*
		* @param query
		* @returns {filterFn}
		*/
		function labelQuerySearch(query, tagTypeIds) {
			var response = [];
			if (query) {
				response =  vm.tags.filter(vm.createFilterFor(query))
			}
			if (tagTypeIds) {
				response = response.filter(function(tag){
					return tagTypeIds.includes(tag.id_type);
				});
			}

			return response;
		}

		function radioOptionsFilter(tags, tagTypeIds) {
			return tags.filter(function(tag){
				return tagTypeIds.includes(tag.id_type);
			});
		}

		function radioChanged(activeTag, tagTypeIds) {
			// vm.currentTags may hold tags of types that are not included in this radio group,
			// for example tags that are added by a different radio or checkbox group.
			// Don't remove those tags!
			vm.currentTags = vm.currentTags.filter(function(tag) {
				let resp = tagTypeIds.includes(tag.id_type)
				return !resp;
			})

			// Finally add the selected tag
			vm.currentTags.push(activeTag[0]);
		}

		function checkboxesFilter(tags, tagTypeIds) {
			return tags.filter(function(tag){
				return tagTypeIds.includes(tag.id_type);
			});
		}

		function radioGroupTitleByTagTypes(tagTypeIds) {
			if (vm.tagsTypes) {
				return vm.tagsTypes
					.filter(function(tagType){return tagTypeIds.includes(tagType.id_type)})
					.map(function(tagType){return tagType.name})
					.join(" OR ");
			}
			return '';
		}

		function checkboxGroupTitleByTagTypes(tagTypeIds) {
			if (vm.tagsTypes) {
				return vm.tagsTypes
					.filter(function(tagType){return tagTypeIds.includes(tagType.id_type)})
					.map(function(tagType){return tagType.name})
					.join(" & ");
			}
			return '';
		}

		function setTagTypes() {
			var options = {
				siteID: siteID
			}
			tagsService.getTagsTypes(options).then(function(response) {
				vm.tagsTypes = response;
			})
		}
/*
		function setCheckboxesGroupByType(items) {

			var options = {
				siteID: siteID
			}
			return tagsService.getTagsTypes(options).then(function(response) {
				vm.tagsTypes = response;
				if (vm.tagsTabSettings) {
					angular.forEach(vm.tagsTabSettings, function(tagsTabSetting) {
						// Tag-type filter
						if (tagsTabSetting.tags_types && tagsTabSetting.field_type != 'hidden') {
							angular.forEach(tagsTabSetting.tags_types, function(typeId) {
								var tagType = vm.tagsTypes.find(function(tagsType) {
									return tagsType.id_type == typeId;
								})
								var item = {
									type: tagType
								}
								item.tags = items.filter(function(tag){
									return tag.id_type == typeId;
								});
								vm.checkboxesGroupedByType.push(item)
							})
						}
					})
				}
			})
		}
*/
		function preselectTags() {
			if (vm.tags && vm.preselectedTags && angular.isArray(vm.preselectedTags) && vm.preselectedTags.length > 0) {
				angular.forEach(vm.preselectedTags, function(pres) {
					let tag = vm.tags.find(function(tag) {return tag.id_tag == pres.id_tag})
					if (tag) {
						vm.currentTags.push(tag);
					}
				})
			}
		}

		function isCurrentTag(tag) {
			return vm.currentTags.includes(tag);
		}

		function updateCurrentTags(tag, ev) {
			if (vm.currentTags.includes(tag)) {
				vm.currentTags.splice(vm.currentTags.indexOf(tag), 1);
			} else {
				vm.currentTags.push(tag);
			}
		}

		function newTag(tagName) {

			if (vm.newTagDisabled) {
				return false;
			}
			vm.newTagDisabled = true;

			var newTag = {
				tag_name: tagName
			};
			var options = {
				site: siteID,
				item: newTag
			};
			tagsService.saveItem(options).then(function (response) {
				newTag.id_tag = response.id_tag
				vm.tags.push(newTag);
				vm.currentTags.push(newTag);
				vm.searchTagText = '';
				vm.newTagDisabled = false;
			});
		}

		/**
		 * Filter for chips
		 *
		 * @param query
		 * @returns {filterFn}
		 */
		function createFilterFor(query) {
			var lowercaseQuery = angular.lowercase(query);
			return function filterFn(item) {
				if (angular.isUndefined(item.tag_name)) {
					return false;
				}
				if (!item.tag_name) {
					return false;
				}
				if (!angular.lowercase(item.tag_name.toString()).indexOf) {
					return false;
				}
				return angular.lowercase(item.tag_name.toString()).indexOf(lowercaseQuery) >= 0;
			};
		}

		function getpos(event) {
			vm.fields.geoLat = event.latLng.lat();
			vm.fields.geoLon = event.latLng.lng();
			vm.latlng = [event.latLng.lat(), event.latLng.lng()];
		}

		function placeMarker() {
			var loc = this.getPlace()
				.geometry.location;
			vm.latlng = [loc.lat(), loc.lng()];
			vm.fields.geoLat = loc.lat();
			vm.fields.geoLon = loc.lng();
			vm.center = [loc.lat(), loc.lng()];
		}

		function searchLatLon() {
			vm.latlng = [vm.fields.geoLat, vm.fields.geoLon];
			vm.center = [vm.fields.geoLat, vm.fields.geoLon];
			vm.center = [40.74, -74.18];
		}

		/**
		 * Toggle selected status of the contact
		 *
		 * @param contact
		 * @param event
		 */

		function toggleSelectContact(photo, event) {
			if (event) {
				event.stopPropagation();
			}


			//		 else{
			if (vm.mediazone) {
				photo.id_zone = vm.mediazone.id_zone;
				photo.zone_name = vm.mediazone.zone_name;
			} else {
				photo.id_zone = null;
				photo.zone_name = null;
			}

			toggleSelectedbyZone(photo);
			// if(vm.alreadySelectedbyZone(vm.selectedContacts, photo)){
			// vm.selectedContacts.splice(vm.selectedContacts.indexOf(photo.id_media), 1);
			//		 }else{
			//		 	vm.selectedContacts.push(photo);
			//		 }
			// }

			// if ( vm.selectedContacts.indexOf(photo.id_media) > -1 )
			// {
			//	 vm.selectedContacts.splice(vm.selectedContacts.indexOf(photo.id_media), 1);
			// }
			// else
			// {
			//	 vm.selectedContacts.push(photo.id_media);
			// }
		}

		/**
		 * Scroll Media Dialog Content to the top
		 * @param speed
		 */
		function scrollToTopOfDialog() {
			$timeout(function () {
				var dialogContent = $document.find('md-dialog-content').filter(function () {
					return angular.element(this).hasClass('mediadialog-content');
				});
				if (angular.isDefined(dialogContent) && dialogContent.length) {
					dialogContent.animate({
						scrollTop: dialogContent[0].scrollHeight
					}, 1);
				}
			}, 0);

		}

		function loadLargeUploadList() {
			if(vm.showLargeUploadList == false){
				vm.showLargeUploadList = true;
			}else{
				vm.showLargeUploadList = false;
			}
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('app.media')
		.controller('AddMediaHubDialogController', AddMediaHubDialogController);

	/** @ngInject */
	function AddMediaHubDialogController(
		$mdDialog,
		$document,
		currentThread,
		mediaService,
		uploadService,
		requestContext,
		isReplace,
		item,
		$timeout,
		$scope,
		$sce,
		mediazone,
		section,
		msUtils,
		isTiny,
		$translate,
		CleanMediaGalleries,
		sessionService,
		$mdToast,
		tagsService,
		$q,
		preselectedTags) {
		var vm = this;

		// Data
		vm.currentThread = currentThread;

		vm.mediazone = mediazone;
		vm.defaultPage = 1;
		vm.defaultPerPage = 50;
		vm.PerPage = 50;
		vm.searchStringFilter = '';
		vm.searchQuery = '';
		vm.modelSearch = '';
		vm.CleanMediaGalleries = angular.copy(CleanMediaGalleries);
		vm.isAttaching = false;
		vm.preselectedTags = preselectedTags;
		vm.showLargeUploadList = false;
		vm.repeatedFilesArray = [];

		vm.fields = {
			geoLat: null,
			geoLon: null,
			title: null,
			photographer: null,
			credits: null,
			owner: null,
			caption: null,
			city: null,
			country: null,
			uses: null,
			extras: null,
			rating: null,
		};

		vm.isTiny = isTiny;

		vm.views = {
			upload: 'app/main/dialogs/mediahub/views/upload-view.html',
			import: 'app/main/dialogs/mediahub/views/import-view.html',
		};
		vm.defaultView = 'upload';
		vm.currentView = 'upload';

		vm.viewsTiny = {
			1: 'app/main/dialogs/mediahub/views/tiny-attached.html',
			properties: 'app/main/dialogs/mediahub/views/tiny-properties.html',
			upload: 'app/main/dialogs/mediahub/views/upload-view.html',
		};
		vm.defaultViewTiny = '1';
		vm.currentViewTiny = '1';

		vm.isReplace = isReplace;
		vm.item = item;


		vm.allowedFilesPattern = "video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz,.json,.xml,.csv,.ttf,.eps,.ai,.psd,.aep,.indd,.idll,.heic,.mkv,.gpx";

		vm.firstLoad = true;
		vm.media_type = '1';
		vm.showSearchAndPaginator = true;
		vm.import_field = '';
		vm.import_disabled = '';
		vm.importedFiles = [];
		vm.importPreview = false;
		vm.imported = false;
		vm.importing = false;
		vm.selectedContacts = [];
		vm.files = [];
		vm.uploadFiles = [];
		vm.uploadedFiles = [];
		vm.tinyProperties = {
			mediaType: '',
			mediaSort: '',
			mediaData: {},
			align: '',
			size: ''
		};
		vm.tinyOptions = {
			size: [
				{ value: 25, text: '25%' },
				{ value: 50, text: '50%' },
				{ value: 75, text: '75%' },
				{ value: 100, text: '100%' }
			],
			align: [
				{ value: 'left', text: 'left' },
				{ value: 'center', text: 'center' },
				{ value: 'right', text: 'right' }
			]
		}
		vm.searchTagText = '';
		vm.tags = sessionService.site_operative.tags;
		vm.currentTags = [];
		vm.selectedTag = null;
		vm.image = {};
		vm.newTagDisabled = false;
		vm.tagsTabSettings = false;
		vm.checkboxesGroupedByType = [];

		vm.checkRepeatedFiles = false;

		vm.isAdmin = false;

		// Methods
		vm.closeDialog = closeDialog;
		vm.changeView = changeView;
		vm.changeViewTiny = changeViewTiny;

		vm.morePages = morePages;
		vm.firstPage = firstPage;
		vm.upload = upload;
		vm.attachMedia = attachMedia;
		vm.attachMediaTiny = attachMediaTiny;
		vm.selectMediaTiny = selectMediaTiny;
		vm.selectedMediaTiny = '';

		vm.exists = msUtils.exists;
		vm.alreadySelectedbyZone = alreadySelectedbyZone;
		vm.existInArray = msUtils.existInArray;
		vm.toggleSelectContact = toggleSelectContact;
		vm.selectedItemChange = selectedItemChange;
		vm.labelQuerySearch = labelQuerySearch;
		vm.createFilterFor = createFilterFor;
		vm.newTag = newTag;
		vm.getpos = getpos;
		vm.placeMarker = placeMarker;
		vm.searchLatLon = searchLatLon;
		vm.radioOptionsFilter = radioOptionsFilter;
		vm.checkboxesFilter = checkboxesFilter;
		vm.updateCurrentTags = updateCurrentTags;
		vm.checkboxGroupTitleByTagTypes = checkboxGroupTitleByTagTypes;
		vm.radioChanged = radioChanged;
		vm.isCurrentTag = isCurrentTag;
		vm.deleteFromUpload = deleteFromUpload;

		vm.loadLargeUploadList = loadLargeUploadList;

		vm.translate = function (text) {
			return $translate.instant(text);
		}


		//////////

		if (!isTiny) {
			var siteID = requestContext.getParam("siteId");
			var section = requestContext.getParam("section");
			init();
		} else {
			vm.section = section;
			initTiny();
		}
		/**
		 * Initialize
		 */
		function init() {

			var siteID = requestContext.getParam("siteId");
			$scope.siteID = siteID;

			vm.isAdmin = sessionService.user.is_admin;

			sessionService.loadDomainResourceSettings($scope.siteID).then(function(response){
				if(response.public){
					var publicConfig = angular.fromJson(response.public);
					if(publicConfig.uploadRepeatCheck){
					  vm.checkRepeatedFiles = publicConfig.uploadRepeatCheck;
					}
				}
            });

			if (sessionService.site_operative.mediaUploadDialogSettings &&
				sessionService.site_operative.mediaUploadDialogSettings.tabs &&
				sessionService.site_operative.mediaUploadDialogSettings.tabs.tags
			) {
				vm.tagsTabSettings = sessionService.site_operative.mediaUploadDialogSettings.tabs.tags;
				setTagTypes();
				preselectTags();
			}
		}



		/**
		 * attachHiddenTags
		 **/
		function attachHiddenTags() {
			if (vm.tagsTabSettings) {
				// Get hidden tags settings
				let hiddenTagsTabSettings = vm.tagsTabSettings.filter(function(tagsTabSetting){
					return tagsTabSetting.field_type == 'hidden';
				})
				angular.forEach(hiddenTagsTabSettings, function(hiddenTagsTabSetting){
					angular.forEach(hiddenTagsTabSetting.tags_types, function(hiddenTagType){
						let hiddenTags = vm.tags.filter(function(tag) {return tag.id_type == hiddenTagType});
						angular.forEach(hiddenTags, function(hiddenTag){
							if (hiddenTagsTabSetting.requires_parent_attached) {
								// Check for the optional, boolean condition 'requires_parent_attached' to attach a hidden tag
								// only if its parent tag was attached too.
								// E.g. the 'Unmatched' tag needs to be attached if its parent tag 'is profile?' was attached.
								// This is because the 'Unmatched' tag is used in AI > Match Profile to filter for profile images
								// that have not been assigned with a Number tag. However if the uploaded image is NOT a profile image,
								// then it doesn't require the 'Unmatched' tag neither.
								let hasParentAttached = vm.currentTags.find(function(currentTag){
									return currentTag.id_tag == hiddenTag.id_parent
								})
								if (hasParentAttached) {
									vm.currentTags.push(hiddenTag)
								}
							} else {
								vm.currentTags.push(hiddenTag)
							}
						})
					})
				})
			}
		}

		/**
		 * Initialize Tinymce
		 */
		function initTiny() {
			vm.currentViewTiny = vm.defaultViewTiny;
			vm.showSearchAndPaginator = false;
			vm.loading = true;
			for (var i = 0; i < vm.currentThread.length; i++) {
				if (vm.mediazone) {
					if (vm.currentThread[i].id_zone == 1) {
						vm.selectedContacts.push(vm.currentThread[i]);
					}
				} else {
					vm.selectedContacts.push(vm.currentThread[i]);
				}
			}
			if (vm.section.mediaSort) {
				var currentSort = 0;
				var currentItem = '';
				for (var i = 0; i < vm.currentThread.length; i++) {
					if (vm.mediazone) {
						if (vm.currentThread[i]['id_zone'] == 1 && (vm.currentThread[i]['media_type'] == vm.section.mediaType)) {
							currentSort++;
							if (currentSort = vm.section.mediaSort) {
								currentItem = vm.currentThread[i];
							}
						}
					} else {
						if (vm.currentThread[i]['media_type'] == vm.section.mediaType) {
							currentSort++;
							if (currentSort = vm.section.mediaSort) {
								currentItem = vm.currentThread[i];
							}
						}

					}
				}

				vm.selectedMediaTiny = currentItem;
				vm.tinyProperties.mediaSort = vm.section.mediaSort;
				vm.tinyProperties.mediaType = currentItem.media_type;
				vm.tinyProperties.align = vm.section.mediaAlign;
				vm.tinyProperties.size = vm.section.mediaSize;
				vm.changeViewTiny('properties');


			}
			vm.loading = false;

		}

		function closeDialog(success) {
			// delete from media_files if upload not terminated.
			if (vm.uploadedFiles.length == 0) {
				$mdDialog.hide(vm.currentThread);
			} else if(vm.uploadedFiles.length != vm.uploadFiles.length){
				var messageConfirm = $translate.instant('MEDIA.UPLOADING_MEDIA_CLOSE_CONFIRM');
				var confirm = $mdDialog.confirm().multiple(true).title(messageConfirm)
					// .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' will be deleted.')
					.ariaLabel('Close dialog').ok('OK').cancel('CANCEL');

				$mdDialog.show(confirm)
					.then(function () {
						var deleteIds = [];
						for (var i = 0; i < vm.uploadedFiles.length; i++) {
							deleteIds.push(vm.uploadedFiles[i].id_media);
						}
						if (deleteIds.length > 0) {
							var options = {
								site: siteID,
								id_media: deleteIds,
								force: true
							};
							mediaService.massDelete(options);
						}
						$mdDialog.hide(vm.currentThread);
					}, function () {

					})
			}
			if(!success){
				$mdDialog.hide({
					action: 'delete',
					items: vm.uploadedFiles
				});
			}else{
				$mdDialog.hide({
					replaced: vm.repeatedFilesArray
				});
			}
		}

		function changeView(view) {
			if (vm.views[view]) {
				vm.items = [];
				vm.loadingView = true;
				vm.showSearchAndPaginator = false;
				vm.defaultView = view;
				vm.currentView = view;


				vm.media_type = view;

				if (view == 1 || view == 2 || view == 3 || view == 4) {
					vm.showSearchAndPaginator = true;
				}
			}

		}

		function changeViewTiny(view) {
			if (vm.viewsTiny[view]) {
				vm.items = [];
				vm.loadingView = true;
				vm.showSearchAndPaginator = false;
				vm.defaultViewTiny = view;
				vm.currentViewTiny = view;
			}
		}

		$scope.$watch('vm.files', function () {
			if (vm.files.name && vm.isReplace) {
				var ext1 = vm.files.name.split('.')[1];
				var ext2 = vm.item.filename.split('.')[1];
				if (ext1.toLowerCase() !== ext2.toLowerCase()) {
					var message = $translate.instant('FORMS.ERROR_DIF_EXTENSION');
					$mdToast.show({
						template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg">' + message + '</div></md-toast>',
						hideDelay: 2000,
						position: 'top',
						parent: '#login-form-wrapper'
					});
					return;
				}
			}
			angular.forEach(vm.files, function (f) {
				vm.uploadFiles.push(f);
			});
			$scope.formUpload = false;
			if(vm.files.length && !vm.isReplace){
				var filesFileNames = vm.files.map(x=>{
					return x.name;
				});
				var options = {
					domain: siteID,
					fileNames: filesFileNames
				}
				vm.repeatedUploadObjects = [];
				mediaService.getExistingMedia(options).then(function(response){
					if(response.length && vm.checkRepeatedFiles){
						for(var i=0; i<vm.files.length; i++){
							var repeated = response.filter(x => {
								let responseFileName = getFileNameWithoutExtension(x.filename);
								let vmFileName = getFileNameWithoutExtension(vm.files[i].name);
								return responseFileName === vmFileName;
							});
							if(repeated.length){
								var locals = {
									uploadFile: vm.files[i],
									repeatedFiles: repeated
								}
								vm.repeatedUploadObjects.push(locals);
							}else{
								$scope.errorMsg = null;
								(function (f) {
									vm.upload(f, true);
								})(vm.files[i]);
							}
							if(i+1 == vm.files.length){
								showRepeatedDialog();
							}
						}
					}else{
						if (vm.files != null) {
							// make files array for not multiple to be able to be used in ng-repeat in the ui
							if (!angular.isArray(vm.files)) {
								$timeout(function () {
									$scope.files = vm.files = [vm.files];
								});
								return;
							}
							for (var i = 0; i < vm.files.length; i++) {
								$scope.errorMsg = null;
								(function (f) {
									vm.upload(f, true);
								})(vm.files[i]);
							}
						}
					}
				});
			}else if(vm.isReplace){
				if (vm.files != null) {
					// make files array for not multiple to be able to be used in ng-repeat in the ui
					if (!angular.isArray(vm.files)) {
						$timeout(function () {
							$scope.files = vm.files = [vm.files];
						});
						return;
					}
					for (var i = 0; i < vm.files.length; i++) {
						$scope.errorMsg = null;
						(function (f) {
							vm.upload(f, true);
						})(vm.files[i]);
					}
				}
			}
		});

		function getFileNameWithoutExtension(filename) {
			return filename.substring(0, filename.lastIndexOf('.')).toLowerCase();
		}

		function showRepeatedDialog(multipleRepeated){
			var locals = vm.repeatedUploadObjects[0];
			if(vm.repeatedRemember && !multipleRepeated){
				switch(vm.repeatedRemember){
					case 'delete':
						vm.uploadFiles = vm.uploadFiles.filter(x => x.name != locals.uploadFile.name);
					break;
					case 'maintain':
						$scope.errorMsg = null;
						vm.upload(locals.uploadFile, true);
					break;
					case 'replace':
						if(locals.repeatedFiles.length > 1){
							showRepeatedDialog(vm.repeatedRemember);
						}else{
							$scope.errorMsg = null;
							vm.upload(locals.uploadFile, true, locals.repeatedFiles[0]);
						}
					break;
				}
				vm.repeatedUploadObjects.shift();
				if(vm.repeatedUploadObjects.length){
					showRepeatedDialog();
				}else{
					vm.repeatedRemember = false;
				}
			}else{
				$mdDialog.show({
					controller: 'RepeatedUploadFilesController',
					controllerAs: 'vm',
					locals: locals,
					templateUrl: 'app/main/apps/mediahub/dialogs/mediahub/repeated-upload-files.html',
					parent: angular.element($document.body),
					multiple: true,
					clickOutsideToClose: false
				}).then(function (resp) {
					switch(resp.action){
						case 'delete':
							vm.uploadFiles = vm.uploadFiles.filter(x => x.name != resp.file.name);
						break;
						case 'maintain':
							$scope.errorMsg = null;
							vm.upload(resp.file, true);
						break;
						case 'replace':
							$scope.errorMsg = null;
							vm.upload(resp.file, true, resp.repeatedFiles);
						break;
					}
					if(resp.remember){
						vm.repeatedRemember = resp.action;
					}
					if(multipleRepeated){
						vm.repeatedRemember = multipleRepeated;
					}
					vm.repeatedUploadObjects.shift();
					if(vm.repeatedUploadObjects.length){
						showRepeatedDialog();
					}else{
						vm.repeatedRemember = false;
					}
				});
			}
		}

		$scope.$watch('vm.import_field', function () {
			vm.importConfirm(false);
		});

		$scope.log = '';


		function upload(file, old, repeatFile) {
			if (!file.$error) {
				file.processed = false;
				var uploadOptions = {
					siteID: siteID,
					isReplace: vm.isReplace,
					item: vm.item,
					uploadedFiles: vm.uploadedFiles,
					filename: file.name.replaceAll('(', '').replaceAll(')', ''),
					fileSizeKb: (angular.isDefined(file.size)) ? (parseInt(file.size) / 1000).toFixed(2) : null,
					id_media: vm.isReplace ? vm.item.id_media : null,
					log: $scope.log,
					type: 'media'
				}
				if(repeatFile){
					uploadOptions.isReplace = true;
					uploadOptions.item = repeatFile;
					uploadOptions.id_media = repeatFile.id_media;
				}
				console.debug("UPLOAD______****", file)
				uploadService.upload(file, uploadOptions).then(function (resp) {
					if (file.cancelled) {
						// removed from the list while it was finishing: it must not be attached
						return;
					}
					$scope.log = file.log;
					vm.uploadedFiles.push(file);
					var galleriesAssignedIds = getAssignedGalleriesIds(vm.CleanMediaGalleries, []);
					if (angular.isArray(galleriesAssignedIds) && galleriesAssignedIds.length) {
						var options = {
							site: siteID,
							data: {
								id_media: [file.id_media],
								id_gallery: galleriesAssignedIds
							}
						};
						mediaService.insertIntoGallery(options).then(function(response){
							vm.selectedContacts.push(file)
							loadAndAttachMedia(file);
						})
					} else {
						loadAndAttachMedia(file);
					}
					if(vm.isReplace || repeatFile){
						vm.repeatedFilesArray.push(file.id_media);
					}
				});
			}
		};

		function showErrorDialog(message) {
			$mdToast.show({
				template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
				hideDelay: 5000,
				position: 'top',
				parent: '#content-container'
			});
		}

		function loadAndAttachMedia(file) {
			mediaService.get({
				siteID: siteID,
				withCropStatus: true,
				idMedia: file.id_media
			})
				.then(function (response) {
					//if (response.total == 1) {
						var photo = response.data[0];
						toggleSelectContact(photo);
					//}
				});
		}

		vm.importConfirm = function (confirm) {
			vm.import_disabled = false;
			vm.imported = false;
			if (!confirm) {
				vm.importPreview = false;
			}
			if (vm.import_field.length > 10) {
				vm.importing = true;
				vm.import_disabled = true;

				$timeout(function () {
					var pastedUrl = vm.import_field;
					mediaService.importFromUrl({
						siteID: siteID,
						url: pastedUrl,
						execute: confirm
					})
						.then(function (response) {
							vm.importing = false;
							response.embedCodeSafe = $sce.trustAsHtml(response.metadata.embedCode);
							response.caption = response.metadata.caption;
							response.title = response.metadata.title;
							if (response.id_media) {
								// Attach media to selected gallery
								// For qiu-restricted users with limited gallery access we need to attach media
								// to the users root gallery before loading the media again from api,
								// otherwise the api won't return the media due to qiu restrictions.
								var galleriesAssignedIds = getAssignedGalleriesIds(vm.CleanMediaGalleries, []);
								if (angular.isArray(galleriesAssignedIds) && galleriesAssignedIds.length) {
									var options = {
										site: siteID,
										data: {
											id_media: [response.id_media],
											id_gallery: galleriesAssignedIds
										}
									};
									mediaService.insertIntoGallery(options).then(function(resp){
										vm.imported = true;
										vm.importPreview = false;
										mediaService.get({
											siteID: siteID,
											withCropStatus: true,
											idMedia: response.id_media
										}).then(function (response) {
											if (response.total == 1) {
												var photo = response.data[0];
												vm.importedFiles.push(photo);
												toggleSelectContact(photo);
											}
										});
									})
								} else {
									vm.imported = true;
									vm.importPreview = false;
									mediaService.get({
										siteID: siteID,
										withCropStatus: true,
										idMedia: response.id_media
									}).then(function (response) {
										if (response.total == 1) {
											var photo = response.data[0];
											vm.importedFiles.push(photo);
											toggleSelectContact(photo);
										}
									});
								}
							} else {
								vm.importPreview = response;
							}
							vm.import_disabled = false;
						});
				})
			}
		}

		function morePages() {
			if (vm.currentPage <= vm.lastPage) return true;
			return false;
		}

		function firstPage() {
			if (vm.currentPage == 1) return true;
			return false;
		}

		function alreadySelectedbyZone(array, item) {
			var ret = false;
			for (var i = 0, len = array.length; i < len; i++) {
				if (vm.mediazone) {
					if (array[i]['id_media'] === item.id_media && array[i]['id_zone'] === vm.mediazone.id_zone) {
						ret = true;
					}
				} else {
					if (array[i]['id_media'] === item.id_media) {
						ret = true;
					}

				}
			}

			return ret;
		}


		function toggleSelectedbyZone(item) {
			for (var i = 0; vm.selectedContacts.length < i; i++) {
				if (vm.mediazone && vm.selectedContacts[i]['id_media'] === item.id_media && vm.selectedContacts[i]['id_zone'] === vm.mediazone.id_zone) {
					vm.selectedContacts.splice(i, 1);
					return;
				}
			}
			if(vm.selectedContacts.indexOf(item) == -1){
				vm.selectedContacts.push(item);
			}
			return;
		}

		function selectMediaTiny(item) {
			var currentSort = 0;
			var mediaSort = 0;
			for (var i = 0; i < vm.currentThread.length; i++) {
				if (vm.mediazone) {
					if (vm.currentThread[i]['id_zone'] == 1 && (vm.currentThread[i]['media_type'] == item.media_type)) {
						currentSort++;
						if (item.id_media == vm.currentThread[i]['id_media']) {
							mediaSort = currentSort;
						}
					}
				} else {
					currentSort++;
					if (item.id_media == vm.currentThread[i]['id_media']) {
						mediaSort = currentSort;
					}
				}
			}

			vm.selectedMediaTiny = item;
			vm.tinyProperties.mediaSort = mediaSort;
			vm.tinyProperties.mediaType = item.media_type;
			vm.changeViewTiny('properties');
		}

		function deleteFromUpload(file){
			// stops the upload in flight and deletes the media it may have already created
			uploadService.cancel(file);
			// filtered by reference: while uploading the file has no id_media yet
			vm.uploadFiles = vm.uploadFiles.filter(x => x !== file);
			vm.uploadedFiles = vm.uploadedFiles.filter(x => x !== file);
			if (file.id_media) {
				vm.selectedContacts = vm.selectedContacts.filter(x => x.id_media != file.id_media);
			}
		}

		function attachMedia() {
			var continueAttach = false;
			if (vm.uploadedFiles.length == vm.uploadFiles.length) {
				continueAttach = true;
			} else {
				var messageConfirm = $translate.instant('MEDIA.UPLOADING_MEDIA_CLOSE_CONFIRM');
				var confirm = $mdDialog.confirm().multiple(true).title(messageConfirm)
					// .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' will be deleted.')
					.ariaLabel('Close dialog').ok('OK').cancel('CANCEL');

				$mdDialog.show(confirm)
					.then(function () {
						var deleteIds = [];
						for (var i = 0; i < vm.uploadFiles.length; i++) {
							var isFileUploaded = vm.uploadedFiles.some(function (el) {
								return el.id_media == vm.uploadFiles[i].id_media
							});
							if (!isFileUploaded) {
								deleteIds.push(vm.uploadFiles[i].id_media);
							}
						}
						if (deleteIds.length > 0) {
							var options = {
								site: siteID,
								id_media: deleteIds,
								force: true
							};
							mediaService.massDelete(options);
						}
						continueAttach = true;
					}, function () {

					})
			}

			if (!continueAttach) {
				return false;
			}
			var mediaIDs = [];
			for (var i = 0; i < vm.selectedContacts.length; i++) {
				if (!mediaIDs.includes(vm.selectedContacts[i].id_media)) {
					mediaIDs.push(vm.selectedContacts[i].id_media);
				}
			}
			if (mediaIDs.length == 0) {
				// TODO: show alert
				if(vm.uploadedFiles.length > 0){
					vm.selectedContacts = vm.uploadedFiles;
					for (var i = 0; i < vm.selectedContacts.length; i++) {
						mediaIDs.push(vm.selectedContacts[i].id_media);
					}
				}else{
					console.log('No ID medias');
					return false;
				}
			}

			var uploadedFilesIDs = [];

			var message = (mediaIDs.length > 1) ? $translate.instant('MEDIA.ITEMS_UPLOADED_PLURAL') : $translate.instant('MEDIA.ITEMS_UPLOADED_SINGULAR');
			var fields = {};
			angular.forEach(vm.fields, function (value, key) {
				if (!_.isNull(value) && value != 0) {
					this[key] = value;
				}
			}, fields);
			var galleriesAssigned = getAssignedGalleries(vm.CleanMediaGalleries, []);
			if(vm.uploadedFiles.length > 0){
				vm.uploadedFiles.forEach(element => {
					uploadedFilesIDs.push(element.id_media);
				});
				var batchOptions = {
					siteID: siteID,
					id_medias: uploadedFilesIDs,
					fields: vm.fields,
					tags: vm.currentTags,
					id_galleries: []
				}
				galleriesAssigned.forEach(gallery => {
					batchOptions.id_galleries.push(gallery.id);
				});
				mediaService.finishedUploadingBatchToCdn(batchOptions).then(function(response){
				}).catch(function(error){
					console.log('error', error);
					vm.isAttaching = false;
				});
			}
			if (_.isEmpty(fields) && _.isEmpty(vm.currentTags) && galleriesAssigned.length == 0) {
				vm.reload = true;
				$mdToast.show({
					template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + mediaIDs.length + message + '</span></div></md-toast>',
					hideDelay: 5000,
					position: 'top',
					parent: '#content-container'
				});
				vm.closeDialog(true);
				return false;
			}

			vm.isAttaching = true;
			// Initial promise

			var sequence = $q.defer();
			sequence.resolve();
			sequence = sequence.promise;

			if (galleriesAssigned.length > 0) {

				var inserts = [];
				var mismatches = {};

				angular.forEach(galleriesAssigned, function (gallery) {

					var galleryTypeId = gallery.gallery_type;
					var validMediaIds = [];

					angular.forEach(vm.uploadedFiles, function (file) {
						var fileTypeId = msUtils.getFileTypeId(file.type);
						if (galleryTypeId == 0) {
							validMediaIds.push(file.id_media);
						} else if (galleryTypeId != 0 && fileTypeId && galleryTypeId == fileTypeId) {
							validMediaIds.push(file.id_media);
						} else {
							if (!angular.isArray(mismatches[file.name])) {
								mismatches[file.name] = [];
							}
							if (gallery.gallery_type != 0){
								mismatches[file.name].push(gallery.gallery_name + ' (' + msUtils.getGalleryTypeById(gallery.gallery_type) + ')');
							}
						}
					});
					if (validMediaIds.length > 0) {
						inserts.push({ id_gallery: [gallery.id_gallery], media_ids: validMediaIds });
					}
				});
				if (!_.isEmpty(mismatches)) {
					sequence = sequence.then(function () {
						console.log("seq 1 - confirm mismatch");
						var confirm = $mdDialog.confirm()
							.title($translate.instant('MEDIA.MISMATCH_DIALOG.TITLE'))
							.textContent($translate.instant('MEDIA.MISMATCH_DIALOG.CONTENT'))
							.ariaLabel($translate.instant('MEDIA.MISMATCH_DIALOG.LABEL'))
							.ok($translate.instant('MEDIA.MISMATCH_DIALOG.OK'))
							.cancel($translate.instant('MEDIA.MISMATCH_DIALOG.CANCEL'))
							.multiple(true);
						return $mdDialog.show(confirm);
					})
				}

				angular.forEach(inserts, function (insert) {
					sequence = sequence.then(function () {
						console.log('seq 1 - continue mismatch approved')
						var options = {
							site: siteID,
							data: {
								id_media: insert.media_ids,
								id_gallery: insert.id_gallery
							}
						};
						return mediaService.insertIntoGallery(options);
					});
				}, function () {
					console.log('seq 1 - continue mismatch rejected')
					vm.isAttaching = false;
					return Promise.reject();
				});
			}

			if (!_.isEmpty(fields) || !_.isEmpty(vm.currentTags)) {
				attachHiddenTags();
				sequence = sequence.then(function () {
					var options = {
						site: siteID,
						data: {
							id_media: mediaIDs,
							fields: fields,
							tags: vm.currentTags
							// fields: {
							//  geoLat: vm.fields.geoLat,
							//  geoLon: vm.fields.geoLon
							// }
						}
					};
					return mediaService.massUpdate(options);
				}, function () {
					console.log('seq 2 - reject')
					vm.isAttaching = false;
					return Promise.reject();
				});
			}

			sequence = sequence.then(function () {
				console.log("seq 4 - close dialog");
				vm.isAttaching = false;
				vm.reload = true;
				$mdToast.show({
					template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + mediaIDs.length + message + '</span></div></md-toast>',
					hideDelay: 5000,
					position: 'top',
					parent: '#content-container'
				});
				return vm.closeDialog(vm.selectedContacts);
			}, function () {
				console.log('seq 4 - reject')
				vm.isAttaching = false;
			});
		}

		function attachMediaTiny() {
			$mdDialog.hide(vm.tinyProperties);
		}

		function getAssignedGalleries(galleries, result) {

			angular.forEach(galleries, function (gallery) {
				if (gallery.assigned_gallery == true) {
					result.push(gallery);
				}
				if (typeof gallery.children !== 'undefined' && gallery.children.length > 0) {
					getAssignedGalleries(gallery.children, result);
				}
			});
			return result;
		}

		function getAssignedGalleriesIds(galleries, result) {
			angular.forEach(galleries, function(gallery) {
				if (gallery.assigned_gallery == true && !gallery.no_files_allowed) {
					result.push(gallery.id_gallery);
				}
				if (typeof gallery.children !== 'undefined' && gallery.children.length >0) {
					getAssignedGalleriesIds(gallery.children, result);
				}
			});
			return result;
		}

		vm.isImage = function (f) {
			return f.type.startsWith("image");
		}

		vm.isVideo = function (f) {
			return f.type.startsWith("video");
		}

		function selectedItemChange() {
			vm.searchTagText = '';
			vm.selectedTag = null;
		}

		/**
		* Add label chips
		*
		* @param query
		* @returns {filterFn}
		*/
		function labelQuerySearch(query, tagTypeIds) {
			var response = [];
			if (query) {
				response =  vm.tags.filter(vm.createFilterFor(query))
			}
			if (tagTypeIds) {
				response = response.filter(function(tag){
					return tagTypeIds.includes(tag.id_type);
				});
			}

			return response;
		}

		function radioOptionsFilter(tags, tagTypeIds) {
			return tags.filter(function(tag){
				return tagTypeIds.includes(tag.id_type);
			});
		}

		function radioChanged(activeTag, tagTypeIds) {
			// vm.currentTags may hold tags of types that are not included in this radio group,
			// for example tags that are added by a different radio or checkbox group.
			// Don't remove those tags!
			vm.currentTags = vm.currentTags.filter(function(tag) {
				let resp = tagTypeIds.includes(tag.id_type)
				return !resp;
			})

			// Finally add the selected tag
			vm.currentTags.push(activeTag[0]);
		}

		function checkboxesFilter(tags, tagTypeIds) {
			return tags.filter(function(tag){
				return tagTypeIds.includes(tag.id_type);
			});
		}

		function radioGroupTitleByTagTypes(tagTypeIds) {
			if (vm.tagsTypes) {
				return vm.tagsTypes
					.filter(function(tagType){return tagTypeIds.includes(tagType.id_type)})
					.map(function(tagType){return tagType.name})
					.join(" OR ");
			}
			return '';
		}

		function checkboxGroupTitleByTagTypes(tagTypeIds) {
			if (vm.tagsTypes) {
				return vm.tagsTypes
					.filter(function(tagType){return tagTypeIds.includes(tagType.id_type)})
					.map(function(tagType){return tagType.name})
					.join(" & ");
			}
			return '';
		}

		function setTagTypes() {
			var options = {
				siteID: siteID
			}
			tagsService.getTagsTypes(options).then(function(response) {
				vm.tagsTypes = response;
			})
		}

		function preselectTags() {
			if (vm.tags && vm.preselectedTags && angular.isArray(vm.preselectedTags) && vm.preselectedTags.length > 0) {
				angular.forEach(vm.preselectedTags, function(pres) {
					let tag = vm.tags.find(function(tag) {return tag.id_tag == pres.id_tag})
					if (tag) {
						vm.currentTags.push(tag);
					}
				})
			}
		}

		function isCurrentTag(tag) {
			return vm.currentTags.includes(tag);
		}

		function updateCurrentTags(tag, ev) {
			if (vm.currentTags.includes(tag)) {
				vm.currentTags.splice(vm.currentTags.indexOf(tag), 1);
			} else {
				vm.currentTags.push(tag);
			}
		}

		function newTag(tagName) {

			if (vm.newTagDisabled) {
				return false;
			}
			vm.newTagDisabled = true;

			var newTag = {
				tag_name: tagName
			};
			var options = {
				site: siteID,
				item: newTag
			};
			tagsService.saveItem(options).then(function (response) {
				newTag.id_tag = response.id_tag
				vm.tags.push(newTag);
				vm.currentTags.push(newTag);
				vm.searchTagText = '';
				vm.newTagDisabled = false;
			});
		}

		/**
		 * Filter for chips
		 *
		 * @param query
		 * @returns {filterFn}
		 */
		function createFilterFor(query) {
			var lowercaseQuery = angular.lowercase(query);
			return function filterFn(item) {
				if (angular.isUndefined(item.tag_name)) {
					return false;
				}
				if (!item.tag_name) {
					return false;
				}
				if (!angular.lowercase(item.tag_name.toString()).indexOf) {
					return false;
				}
				return angular.lowercase(item.tag_name.toString()).indexOf(lowercaseQuery) >= 0;
			};
		}

		function getpos(event) {
			vm.fields.geoLat = event.latLng.lat();
			vm.fields.geoLon = event.latLng.lng();
			vm.latlng = [event.latLng.lat(), event.latLng.lng()];
		}

		function placeMarker() {
			var loc = this.getPlace()
				.geometry.location;
			vm.latlng = [loc.lat(), loc.lng()];
			vm.fields.geoLat = loc.lat();
			vm.fields.geoLon = loc.lng();
			vm.center = [loc.lat(), loc.lng()];
		}

		function searchLatLon() {
			vm.latlng = [vm.fields.geoLat, vm.fields.geoLon];
			vm.center = [vm.fields.geoLat, vm.fields.geoLon];
			vm.center = [40.74, -74.18];
		}

		/**
		 * Toggle selected status of the contact
		 *
		 * @param contact
		 * @param event
		 */

		function toggleSelectContact(photo, event) {
			if (event) {
				event.stopPropagation();
			}


			//		 else{
			if (vm.mediazone) {
				photo.id_zone = vm.mediazone.id_zone;
				photo.zone_name = vm.mediazone.zone_name;
			} else {
				photo.id_zone = null;
				photo.zone_name = null;
			}

			toggleSelectedbyZone(photo);
		}

		/**
		 * Scroll Media Dialog Content to the top
		 * @param speed
		 */
		function scrollToTopOfDialog() {
			$timeout(function () {
				var dialogContent = $document.find('md-dialog-content').filter(function () {
					return angular.element(this).hasClass('mediadialog-content');
				});
				if (angular.isDefined(dialogContent) && dialogContent.length) {
					dialogContent.animate({
						scrollTop: dialogContent[0].scrollHeight
					}, 1);
				}
			}, 0);

		}

		function loadLargeUploadList() {
			if(vm.showLargeUploadList == false){
				vm.showLargeUploadList = true;
			}else{
				vm.showLargeUploadList = false;
			}
		}
	}
})();

(function () {
    'use strict';

    angular
        .module('app.media')
        .controller('DeleteMediahubDialogController', DeleteMediahubDialogController);

    /** @ngInject */
    function DeleteMediahubDialogController(
        $mdDialog,
        $document,
        selectedThreads,
        siteID,
        requestContext,
        $anchorScroll,
        $timeout,
        $scope,
        $sce,
        msUtils,
        COMMON,
        $log,
        $translate,
        mediaService,
        $rootScope,
        $mdToast
    ) {
        var vm = this;

        // Data
        vm.selectedThreads = selectedThreads;
        vm.selectedIds = [];
        vm.siteID = siteID;
        vm.isLoading = false;
        vm.mediaRelations = false;


        // Methods
        vm.delete = deleteItems;
        vm.cancel = cancel;

        
        vm.translate = function(text) {
            return $translate.instant(text);
        }

        init();
        /**
         * Initialize
         */
        function init() {

            vm.isLoading = true;

            for (var i = 0; i < vm.selectedThreads.length; i++) {
              vm.selectedIds.push(vm.selectedThreads[i].id_media);
            }

            var options = {
                siteID   : vm.siteID,
                id_media : vm.selectedIds
            };

            mediaService.getMediaRelations(options).then(function (response) {

                for (var i = 0; i < vm.selectedThreads.length; i++) {
                  for (var ii = 0; ii< response.data.length; ii++) {
                    if (response.data[ii].id_media == vm.selectedThreads[i].id_media) {
                      vm.selectedThreads[i].content =  response.data[ii].content;
                      vm.selectedThreads[i].galleries =  response.data[ii].galleries;
                    }
                  }
                }

                vm.mediaRelations = vm.selectedThreads;
                vm.isLoading = false;
            });
        }

        function cancel() {
            $mdDialog.hide(false);
        }


        function deleteItems() {
            vm.isLoading = true;

            if (vm.selectedIds.length == 1) {
              var message = $translate.instant('MEDIA.DELETED');
            } else {
              var message = vm.selectedIds.length + $translate.instant('MEDIA.DELETED_PLURAL');
            }

            var options = {
              site     : vm.siteID,
              id_media : vm.selectedIds,
              force    : true
            };

            mediaService.massDelete(options).then(function (response) {
                vm.isLoading = false;
                  //vm.closeMediaPreview();
                  //vm.deselectThreads();
                  $mdToast.show({
                      template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                      hideDelay: 5000,
                      position: 'top',
                      parent: '#content-container'
                  });
                  $mdDialog.hide(true);
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.mediahub')
        .controller('MHEditGalleryDialogController', MHEditGalleryDialogController);

    /** @ngInject */
    function MHEditGalleryDialogController($mdDialog, galleries, gallery, parentGallery, siteID, hasVertex,
        mediahubService, mediahubTagsService, msUtils, $translate, $mdToast, $log, usersService, transformUsers, $q, $filter) {

        var vm = this;

        // Data
        vm.galleries = galleries;
        vm.galleriesFiltered = angular.copy(vm.galleries);
        vm.isEditMode = !!(gallery && (gallery.id || gallery.id_gallery));
        vm.saving = false;
        vm.loadingGroups = false;
        vm.initialPermissions = [];

        // Snapshots of the settings that can be pushed down to the galleries inside this one.
        var initialOnoff = null;
        var initialDefaultSort = null;

        // How many galleries hang below this one. Read by the template to announce the
        // propagation before the user saves, so the confirm is never the first they hear of it.
        vm.descendants = [];

        // State of a propagation in flight. One gallery is written at a time and a deep branch
        // takes a while, so the dialog reports which one it is on rather than freezing silently.
        vm.bulk = { active: false, done: 0, failed: 0, total: 0, current: '' };

        // Default sort is stored as one token, `<field>_<asc|desc>`, but it is edited as two
        // choices. The field names are the API's vocabulary — it validates against exactly this
        // list, so anything else comes back as a 400.
        vm.sortFields = [
            { value: 'fileDate', label: 'Date' },
            { value: 'dateUploaded', label: 'Upload date' },
            { value: 'title', label: 'Title' },
            { value: 'originalFileName', label: 'File name' },
            // NOT a manual position: `sort_order` is set once, to the media id, as a cross-repo
            // dedup contract (a second junction write must replace the first). No endpoint
            // reorders it. Since ids grow over time, ordering by it means "order added to the
            // gallery" — which is what it is called here, rather than promising a manual sort
            // nothing in the system can produce.
            //
            // It lives on the gallery-media junction row, which a dynamic gallery has not got —
            // the API rejects it there, so it is hidden rather than offered and refused.
            { value: 'sortOrder', label: 'Order added to the gallery', manualOnly: true }
        ];

        vm.availableSortFields = [];
        vm.sortDirections = [
            { value: 'asc', label: 'ASC' },
            { value: 'desc', label: 'DESC' }
        ];

        // --- Dynamic gallery: membership defined by a filter (API task-177) ------------------
        //
        // The API stores the filter as `filters` and its PRESENCE is what makes a gallery dynamic:
        // there is no separate flag. So the switch below is not saved as such — on means "send a
        // filter", off means "send none" (or `null`, which turns an existing dynamic gallery back
        // into a static one).
        //
        // Contract (qiu-mediacenter-serverless-api, validateGalleryFilters):
        //   from / to   ISO `YYYY-MM-DD`, inclusive, compared against media `file_date`
        //   minRating   0-5, inclusive
        //   tags        tag NAMES, matched against the media's tags; tagsMode `any` (OR) | `all` (AND)
        //   words       free text, ONLY on tenants searched through Vertex (400 elsewhere)
        //   `{}` is rejected: a filter has to constrain something.
        vm.hasVertex = !!hasVertex;
        vm.dynamic = emptyDynamic();
        vm.wasDynamic = false;
        vm.ratingOptions = [1, 2, 3, 4, 5];
        vm.tagSearchText = '';
        vm.tagSelected = null;

        function emptyDynamic() {
            return { enabled: false, from: null, to: null, minRating: null, tags: [], tagsMode: 'any', words: [] };
        }

        /** The form's shape, from whatever the API stored. Tolerates a filter written elsewhere. */
        function dynamicFromFilters(filters) {
            var d = emptyDynamic();
            if (!filters) return d;
            d.enabled = true;
            d.from = parseIsoDate(filters.from);
            d.to = parseIsoDate(filters.to);
            d.minRating = (typeof filters.minRating === 'number') ? filters.minRating : null;
            d.tags = angular.isArray(filters.tags) ? filters.tags.slice() : [];
            d.tagsMode = filters.tagsMode === 'all' ? 'all' : 'any';
            d.words = angular.isArray(filters.words) ? filters.words.slice() : [];
            return d;
        }

        /**
         * `YYYY-MM-DD` as a LOCAL date. `new Date('2026-09-14')` is parsed as UTC midnight, which
         * the datepicker shows as the 13th anywhere west of Greenwich — an off-by-one that would
         * then be saved back.
         */
        function parseIsoDate(value) {
            var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(value || '');
            return m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : null;
        }

        /** Only the keys the user actually set: the API rejects unknown or empty constraints. */
        function buildFilters() {
            var d = vm.dynamic;
            var f = {};
            // Date and rating: NOT on Vertex tenants. The index has no file_date nor rating, so the
            // public front could not apply them; the fields are hidden there and a gallery that
            // arrives carrying them is saved without them — what is stored matches what is shown.
            if (!vm.hasVertex) {
                if (d.from) f.from = $filter('date')(d.from, 'yyyy-MM-dd');
                if (d.to) f.to = $filter('date')(d.to, 'yyyy-MM-dd');
                if (d.minRating) f.minRating = Number(d.minRating);
            }
            if (d.tags.length) {
                f.tags = d.tags.slice();
                f.tagsMode = d.tagsMode;
            }
            // Vertex-only. Not sent at all elsewhere, even if a gallery arrived carrying some:
            // the API would answer 400 on the first listing of it.
            if (vm.hasVertex && d.words.length) f.words = d.words.slice();
            return f;
        }

        vm.dynamicHasConstraint = function () {
            return Object.keys(buildFilters()).length > 0;
        };

        vm.dynamicRangeInvalid = function () {
            return !vm.hasVertex && !!(vm.dynamic.from && vm.dynamic.to && vm.dynamic.from > vm.dynamic.to);
        };

        /** A switched-on filter that could not be saved: blocks the save button. */
        vm.dynamicInvalid = function () {
            return vm.dynamic.enabled && (!vm.dynamicHasConstraint() || vm.dynamicRangeInvalid());
        };

        /**
         * The gallery order is hidden on a dynamic gallery ONLY on Vertex tenants (decision of
         * 14-sep-2026). There the API cannot order it: it hands `defaultSort` back to a client
         * that does not apply it yet. On other tenants the lambda runs the filter itself and does
         * honour the order, so the control stays.
         */
        vm.isSortHidden = function () {
            return vm.dynamic.enabled && vm.hasVertex;
        };

        /**
         * Hidden (Vertex): the form's sort values are left untouched, so switching dynamic off
         * brings back exactly what was there.
         *
         * Visible (no Vertex): "order added" (`sortOrder`) has no junction rows to order on a
         * dynamic gallery and the API rejects it, and refreshSortOptions() has just removed it from
         * the list. Left selected, the select would show blank and the save would fail, so it moves
         * to the order a photo gallery is normally read in.
         */
        vm.onDynamicToggle = function () {
            refreshSortOptions();
            if (vm.dynamic.enabled && !vm.hasVertex && vm.gallery.sortField === 'sortOrder') {
                vm.gallery.sortField = 'fileDate';
                vm.gallery.sortDirection = 'desc';
            }
        };

        /**
         * What `defaultSort` to send for a dynamic gallery, whose order the user cannot see.
         *
         * Whatever was stored is kept, so hiding the control never erases a setting behind the
         * user's back. The one exception is "order added" (`sortOrder_*`): the API answers 400 if
         * it is sent together with filters, so it is dropped — which is also what the API itself
         * does when a gallery is converted without sending a sort.
         */
        function hiddenDynamicSort() {
            return (initialDefaultSort && initialDefaultSort.indexOf('sortOrder_') === 0)
                ? null
                : initialDefaultSort;
        }

        // Tags are fetched once per dialog and filtered locally: the list is small and a request
        // per keystroke would flood the API for no gain.
        var allTagNames = null;

        vm.searchFilterTags = function (query) {
            var q = (query || '').toLowerCase().trim();
            if (!q) return [];
            var load = allTagNames
                ? $q.resolve(allTagNames)
                : mediahubTagsService.getTags(null).then(function (tags) {
                    allTagNames = (tags || []).map(function (t) { return t.tagName; }).filter(Boolean);
                    return allTagNames;
                }).catch(function (err) {
                    $log.error('[MHEditGalleryDialogController] Error loading tags:', err);
                    allTagNames = [];
                    return allTagNames;
                });
            return load.then(function (names) {
                return names.filter(function (name) {
                    return name.toLowerCase().indexOf(q) !== -1 && vm.dynamic.tags.indexOf(name) === -1;
                }).sort().slice(0, 30);
            });
        };

        /** Chips hold plain strings; blanks and duplicates never become a chip. */
        vm.transformTextChip = function (chip) {
            var value = angular.isString(chip) ? chip.trim() : '';
            return value ? value : null;
        };

        /** A gallery whose membership comes from filters cannot be ordered manually. */
        vm.isDynamicGallery = function () {
            return !!vm.dynamic.enabled;
        };

        /**
         * Resolved into properties, never called from ng-repeat: a function there rebuilds the
         * array on every digest, which is wasted work and a way to confuse md-select about which
         * option is selected.
         */
        function refreshSortOptions() {
            vm.availableSortFields = vm.sortFields.filter(function (o) {
                return !o.manualOnly || !vm.isDynamicGallery();
            });
        }

        /** Splits the stored `<field>_<direction>` token into the two selectors. */
        function readSortToken(token) {
            var match = /^(.+)_(asc|desc)$/.exec(token || '');
            return match
                ? { field: match[1], direction: match[2] }
                : { field: null, direction: null };
        }

        /**
         * The gallery orders itself, or it does not.
         *
         * Off is the resting state and saves `null`, letting the API serve its own default order.
         * Turning it on must land on a valid pair straight away — a field with no direction is not
         * a saveable token, so the most common ordering is preselected rather than left half set.
         */
        vm.onUseCustomSortChange = function () {
            if (!vm.gallery.useCustomSort) {
                vm.gallery.sortField = null;
                vm.gallery.sortDirection = null;
                return;
            }
            if (!vm.gallery.sortField) {
                vm.gallery.sortField = 'fileDate';
                vm.gallery.sortDirection = 'desc';
            }
        };

        vm.onSortFieldChange = function () {
            if (!vm.gallery.sortField) {
                vm.gallery.sortDirection = null;   // back to the API's own default order
                return;
            }
            // A field with no direction is not a saveable token, so default to the ordering
            // each field is normally read in: newest first for dates, A-Z for text.
            if (!vm.gallery.sortDirection) {
                vm.gallery.sortDirection =
                    (vm.gallery.sortField === 'fileDate' || vm.gallery.sortField === 'dateUploaded')
                        ? 'desc' : 'asc';
            }
        };

        // Form structure — map from actual API data
        if (vm.isEditMode) {
            vm.gallery = {
                name: gallery.name || '',
                description: gallery.description || '',
                parentId: gallery.parentId || null,
                onoff: gallery.hasOwnProperty('onoff') ? gallery.onoff : 1,
                isExternal: gallery.isExternal || 0,
                coverId: gallery.coverId || gallery.id_cover || null,
                permissions: gallery.permissions || [],
                date: gallery.date ? new Date(gallery.date) : new Date()
            };
            // `filters` is only present on dynamic galleries — its presence IS the flag (task-177).
            vm.dynamic = dynamicFromFilters(gallery.filters);
            vm.wasDynamic = vm.dynamic.enabled;
            var storedSort = readSortToken(gallery.defaultSort);
            vm.gallery.sortField = storedSort.field;
            vm.gallery.sortDirection = storedSort.direction;
            vm.gallery.useCustomSort = !!storedSort.field;
            refreshSortOptions();
            vm.galleryRawSettings = gallery.raw_settings || {};
            vm.coverMedia = gallery.cover_media || null;
            vm.galleryId = gallery.id || gallery.id_gallery;

            // What the gallery looked like when the dialog opened. Only the three settings that
            // are inherited downwards are snapshotted: the propagation offer is made for a
            // *change*, not for whatever the form happens to hold. Permissions get their own
            // snapshot in initGroups(), once the groups have loaded.
            initialOnoff = vm.gallery.onoff;
            initialDefaultSort = gallery.defaultSort || null;

            vm.descendants = collectDescendants(findTreeNode(vm.galleries, vm.galleryId));

            // If we have a coverId but no cover_media, fetch it to show the preview
            if (vm.gallery.coverId && !vm.coverMedia) {
                mediahubService.getById(vm.gallery.coverId).then(function (media) {
                    vm.coverMedia = media;
                }).catch(function () {
                    vm.coverMedia = null;
                });
            }
        } else {
            vm.gallery = {
                name: '',
                description: '',
                parentId: parentGallery ? (parentGallery.id || parentGallery.id_gallery) : null,
                onoff: 1,
                isExternal: 0,
                coverId: null,
                permissions: [],
                date: new Date()
            };
            vm.galleryRawSettings = {};
            vm.coverMedia = null;
            // A new gallery starts static; the "Dynamic filters" tab is where it becomes dynamic.
            vm.dynamic = emptyDynamic();
            vm.wasDynamic = false;
            vm.gallery.sortField = null;
            vm.gallery.sortDirection = null;
            vm.gallery.useCustomSort = false;
            refreshSortOptions();
        }

        vm.selectedUsersGroupsMediacenter = [];

        // Initialize Groups & Presets
        initGroups();
        loadPresets();


        function initGroups() {
            vm.loadingGroups = true;
            usersService.getUsersGroups({ siteID: siteID }).then(function (response) {
                // Defensive: handle both response.data and direct response
                const groups = (response && response.data) ? response.data : response;
                if (!Array.isArray(groups)) return;

                const mediahubGroup = groups.find(function (g) { return g.raw_settings && g.raw_settings.mediahub_root === true; });
                vm.mediahubGroups = mediahubGroup ? mediahubGroup.children : [];

                // Sort once in the controller to avoid orderBy filter overhead in template
                if (vm.mediahubGroups) {
                    vm.mediahubGroups.sort(function (a, b) {
                        return (a.sort || 0) - (b.sort || 0) || (a.name || '').localeCompare(b.name || '');
                    });
                }

                // Initialize selection
                if (vm.gallery.permissions && vm.gallery.permissions.length > 0) {
                    vm.mediahubGroups.forEach(function (group) {
                        if (vm.gallery.permissions.indexOf(group.id_group) !== -1) {
                            vm.selectedUsersGroupsMediacenter.push(group);
                        }
                    });
                } else if (vm.galleryRawSettings && vm.galleryRawSettings.mediacenter && vm.galleryRawSettings.mediacenter.permissions && vm.galleryRawSettings.mediacenter.permissions.user_groups) {
                    // Legacy fallback
                    var legacyIds = vm.galleryRawSettings.mediacenter.permissions.user_groups;
                    vm.mediahubGroups.forEach(function (group) {
                        if (legacyIds.indexOf(group.id_group) !== -1) {
                            vm.selectedUsersGroupsMediacenter.push(group);
                        }
                    });
                }

                vm.initialPermissions = vm.selectedUsersGroupsMediacenter.map(function (g) { return g.id_group; }).sort();
            }).finally(function () {
                vm.loadingGroups = false;
            });
        }

        function toggleGroupSelection(group) {
            var index = -1;
            for (var i = 0; i < vm.selectedUsersGroupsMediacenter.length; i++) {
                if (vm.selectedUsersGroupsMediacenter[i].id_group === group.id_group) {
                    index = i;
                    break;
                }
            }

            if (index > -1) {
                vm.selectedUsersGroupsMediacenter.splice(index, 1);
            } else {
                vm.selectedUsersGroupsMediacenter.push(group);
            }
            vm.basicForm.$setDirty();
        }

        function toggleAllGroups() {
            if (isAllSelected()) {
                vm.selectedUsersGroupsMediacenter = [];
            } else {
                vm.selectedUsersGroupsMediacenter = angular.copy(vm.mediahubGroups);
            }
            vm.basicForm.$setDirty();
        }

        function isAllSelected() {
            return vm.mediahubGroups && vm.mediahubGroups.length > 0 &&
                vm.selectedUsersGroupsMediacenter.length === vm.mediahubGroups.length;
        }

        function isGroupSelected(group) {
            return vm.selectedUsersGroupsMediacenter.some(function (g) {
                return g.id_group === group.id_group;
            });
        }

        // UI Helpers
        vm.galleryParentName = parentGallery ? (parentGallery.name || parentGallery.gallery_name || '') : '';
        vm.dialogTitle = vm.isEditMode ? 'GALLERY.EDIT_GALLERY' : 'GALLERY.CREATE_GALLERY';

        // Views
        vm.views = {
            'edit_gallery_main': 'app/main/apps/mediahub/dialogs/galleries/views/edit-gallery-main.html',
            'edit_gallery_dynamic': 'app/main/apps/mediahub/dialogs/galleries/views/edit-gallery-dynamic.html',
            'edit_gallery_permissions': 'app/main/apps/mediahub/dialogs/galleries/views/edit-gallery-users-groups-mediacenter.html'
        };
        vm.selectedView = 'edit_gallery_main';

        // Methods
        vm.save = save;
        vm.cancel = cancel;
        vm.deleteGallery = deleteGallery;
        vm.selectParentGalleryRoot = selectParentGalleryRoot;
        vm.selectParentGallery = selectParentGallery;
        vm.selectCover = selectCover;
        vm.removeCover = removeCover;
        vm.toggleGroupSelection = toggleGroupSelection;
        vm.isGroupSelected = isGroupSelected;
        vm.toggleAllGroups = toggleAllGroups;
        vm.isAllSelected = isAllSelected;
        vm.presets = [];
        vm.selectedPreset = null;
        vm.applyPreset = applyPreset;

        function loadPresets() {
            mediahubService.getGalleriesPermissions(siteID).then(function (permResponse) {
                if (permResponse && permResponse.result && permResponse.result.data) {
                    vm.presets = permResponse.result.data.map(function (item) {
                        return {
                            id: item.id_galleries_permissions,
                            name: item.name,
                            groups: typeof item.config === 'string' ? angular.fromJson(item.config) : (item.config || [])
                        };
                    });
                }
            }).catch(function (err) {
                $log.error('[MHEditGalleryDialogController] Error loading permission presets:', err);
            });
        }

        function applyPreset() {
            if (!vm.selectedPreset) return;
            vm.selectedUsersGroupsMediacenter = [];
            vm.mediahubGroups.forEach(function (group) {
                if (vm.selectedPreset.groups.indexOf(group.id_group) !== -1) {
                    vm.selectedUsersGroupsMediacenter.push(group);
                }
            });
            vm.basicForm.$setDirty();
        }

        // --- Propagating a change down the tree ---------------------------------------------
        //
        // Onoff, permissions and the default order are settings a whole branch usually shares, so
        // changing one on a folder that has folders inside it offers to push it down. The tree is
        // the one already on screen (`galleries`), so working out what is inside costs nothing.

        function galleryIdOf(node) {
            return node && (node.id || node.id_gallery);
        }

        /** Depth-first lookup by id in the tree the dialog was handed. */
        function findTreeNode(nodes, id) {
            for (var i = 0; i < (nodes || []).length; i++) {
                var node = nodes[i];
                if (galleryIdOf(node) == id) return node;
                var found = findTreeNode(node.children, id);
                if (found) return found;
            }
            return null;
        }

        /** Every gallery below `node`, children and grandchildren alike. */
        function collectDescendants(node, out) {
            out = out || [];
            (node && node.children ? node.children : []).forEach(function (child) {
                out.push(child);
                collectDescendants(child, out);
            });
            return out;
        }

        /**
         * The settings that changed in this save and are worth pushing down.
         *
         * Name, description, parent and cover are deliberately absent: they identify a gallery
         * rather than describe how it behaves, and copying them downwards would be destructive.
         */
        function propagatableChanges(payload, permissionsChanged) {
            var changes = {};
            // Compared as numbers: the switch writes 1/0 while the API may have answered "1",
            // and a type-only difference is not a change the user made.
            if (Number(payload.onoff) !== Number(initialOnoff)) {
                changes.onoff = payload.onoff;
            }
            if (permissionsChanged) {
                changes.permissions = payload.permissions;
            }
            if ((payload.defaultSort || null) !== initialDefaultSort) {
                changes.defaultSort = payload.defaultSort;
            }
            return changes;
        }

        /**
         * Asks once, before anything is written.
         *
         * Cancelling still saves the gallery itself — the question is only how far the change
         * reaches, so the safe answer (just this one) is the one Escape lands on.
         */
        function askPropagation(changes) {
            var count = vm.descendants.length;
            if (!vm.isEditMode || !count || !Object.keys(changes).length) {
                return $q.when(false);
            }

            var fields = Object.keys(changes).map(function (key) {
                return $translate.instant('GALLERY.PROPAGATE_FIELD_' + key.toUpperCase());
            }).join(', ');

            var confirm = $mdDialog.confirm()
                .title($translate.instant('GALLERY.PROPAGATE_TITLE'))
                .textContent($translate.instant('GALLERY.PROPAGATE_TEXT', { count: count, fields: fields }))
                .ariaLabel('Apply to sub-galleries')
                .ok($translate.instant('GALLERY.PROPAGATE_OK', { count: count }))
                .cancel($translate.instant('GALLERY.PROPAGATE_CANCEL'))
                .multiple(true);

            return $mdDialog.show(confirm).then(function () { return true; }, function () { return false; });
        }

        /**
         * ONLY the settings being propagated — never the descendant's other fields.
         *
         * PUT is a partial update: a key that is absent is left alone, and a key that is present
         * is written. Sending the descendant's whole row therefore rewrites fields nobody asked
         * to change, and `permissions: []` for a gallery that has no `permissions` attribute of
         * its own (its groups live in the legacy `raw_settings`) stores an explicit empty list —
         * which is how a gallery ends up visible to no one after a bulk change it should not
         * have been part of.
         */
        function payloadForDescendant(node, changes) {
            var payload = {};

            if (changes.hasOwnProperty('onoff')) {
                payload.onoff = changes.onoff;
            }
            if (changes.hasOwnProperty('permissions')) {
                payload.permissions = changes.permissions;
            }
            if (changes.hasOwnProperty('defaultSort')) {
                // `sortOrder` lives on the gallery-media junction row, which a dynamic gallery
                // has not got: the API answers 400. Such a child keeps the order it had, so the
                // key is left out rather than sent with a value it would reject.
                var isSortOrder = changes.defaultSort && changes.defaultSort.indexOf('sortOrder') === 0;
                if (!(isSortOrder && node.filters)) {
                    payload.defaultSort = changes.defaultSort;
                }
            }

            return payload;
        }

        /**
         * Writes the change to every descendant, one at a time.
         *
         * Sequential on purpose: a branch can hold dozens of galleries and firing them all at
         * once is a burst the API has no reason to absorb. A gallery that fails is counted and
         * the rest still go through — a half-applied branch the user is told about beats an
         * abort that leaves them guessing which ones made it.
         */
        function propagateToDescendants(changes) {
            vm.bulk = {
                active: true,
                done: 0,
                failed: 0,
                total: vm.descendants.length,
                current: ''
            };

            /** Advances the overlay after a gallery is finished, whichever way it went. */
            function settle(ok, node) {
                if (ok) { vm.bulk.done++; } else { vm.bulk.failed++; }
                vm.bulk.current = node.name || '';
            }

            return vm.descendants.reduce(function (chain, node) {
                return chain.then(function () {
                    var id = galleryIdOf(node);
                    var payload = payloadForDescendant(node, changes);

                    // Nothing this gallery can take (a dynamic one being handed `sortOrder`).
                    // An empty PUT is not a no-op worth risking, so it is simply not sent.
                    if (!Object.keys(payload).length) {
                        settle(true, node);
                        return null;
                    }

                    // Named before the write, not after: the name on screen is the one being
                    // saved right now, which is what makes the wait legible.
                    vm.bulk.current = node.name || '';

                    // No reindex per descendant: the endpoint reindexes the target AND all its
                    // descendants, so one call on the parent — fired once every child has been
                    // written — covers the whole branch. See the single call in save().
                    return mediahubService.updateGallery(id, payload)
                        .then(function () { settle(true, node); })
                        .catch(function (err) {
                            settle(false, node);
                            $log.error('[MHEditGalleryDialogController] Propagation failed for gallery ' + id, err);
                        });
                });
            }, $q.when()).then(function () {
                var result = { done: vm.bulk.done, failed: vm.bulk.failed, total: vm.bulk.total };
                vm.bulk.active = false;
                return result;
            });
        }

        // --- Implementation ---

        function save() {

            if (vm.basicForm.$invalid || vm.dynamicInvalid()) {
                return;
            }

            var permissions = vm.selectedUsersGroupsMediacenter.map(function (g) { return g.id_group; }).sort();
            var permissionsChanged = JSON.stringify(permissions) !== JSON.stringify(vm.initialPermissions);

            var payload = {
                name: vm.gallery.name,
                description: vm.gallery.description,
                parentId: vm.gallery.parentId,
                onoff: vm.gallery.onoff,
                isExternal: vm.gallery.isExternal ? 1 : 0,
                coverId: vm.gallery.coverId,
                permissions: permissions,
                date: $filter('date')(vm.gallery.date, 'yyyy-MM-dd HH:mm:ss'),
                // Recombined into the single token the API stores. null clears it and returns
                // the gallery to the API's own default order.
                defaultSort: (vm.gallery.useCustomSort && vm.gallery.sortField && vm.gallery.sortDirection)
                    ? (vm.gallery.sortField + '_' + vm.gallery.sortDirection)
                    : null
            };

            // Dynamic filter. Its presence is the flag, so the key is only sent when it means
            // something: a filter when on; `null` only to turn an existing dynamic gallery back to
            // static. A static gallery staying static sends no key at all — PUT is a partial update.
            //
            // Never propagated to the galleries inside: a filter defines THIS gallery's contents,
            // copying it down would make every child show the same photos.
            if (vm.dynamic.enabled) {
                payload.filters = buildFilters();
            } else if (vm.wasDynamic) {
                payload.filters = null;
            }

            // Order control hidden (dynamic gallery on a Vertex tenant): what the form holds is not
            // a choice the user just made, so the stored value is sent instead (hiddenDynamicSort).
            if (vm.isSortHidden()) {
                payload.defaultSort = hiddenDynamicSort();
            }

            var changes = vm.isEditMode ? propagatableChanges(payload, permissionsChanged) : {};

            // An order the user cannot see is never a change worth pushing down: dropping
            // `sortOrder_*` on conversion would otherwise offer to wipe the order of every gallery
            // inside, over a setting that was not on screen. A visible order propagates as usual.
            if (vm.isSortHidden()) {
                delete changes.defaultSort;
            }

            // Asked before the first write, so the answer covers the whole operation and the
            // gallery is not already saved by the time the user decides.
            askPropagation(changes).then(function (applyToChildren) {
                runSave(payload, permissionsChanged, applyToChildren ? changes : null);
            });
        }

        function runSave(payload, permissionsChanged, changesToPropagate) {

            vm.saving = true;

            var promise;
            if (vm.isEditMode) {
                promise = mediahubService.updateGallery(vm.galleryId, payload);
            } else {
                promise = mediahubService.createGallery(payload);
            }

            promise
                .then(function (response) {
                    // One reindex for the whole branch, and only for a permission change — it is
                    // the only edit that changes what Vertex may return.
                    //
                    // It runs AFTER the descendants are written, never before: the endpoint
                    // reindexes the target together with all its descendants, so firing it up
                    // front would index the children's OLD permissions and leave Vertex serving
                    // them. That ordering is the whole point of doing it here.
                    var reindexBranch = function () {
                        if (!(vm.isEditMode && permissionsChanged)) return;
                        mediahubService.vertexReindexGallery(vm.galleryId).catch(function (err) {
                            $log.error('[MHEditGalleryDialogController] Vertex Reindex failed:', err);
                        });
                    };

                    // The galleries inside only follow once this one is actually saved: if the
                    // gallery itself could not be written, there is no change to push down.
                    if (!changesToPropagate) {
                        reindexBranch();
                        return response;
                    }

                    return propagateToDescendants(changesToPropagate).then(function (result) {
                        reindexBranch();
                        if (result.failed) {
                            $mdToast.show({
                                template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-alert-circle" class="icon"></md-icon><span class="md-toast-text" flex>' +
                                    $translate.instant('GALLERY.PROPAGATE_PARTIAL', { done: result.done, total: result.total }) +
                                    '</span></div></md-toast>',
                                hideDelay: 6000,
                                position: 'top right',
                                parent: '#main'
                            });
                        }
                        return response;
                    });
                })
                .then(function (response) {

                    var msgFallback = vm.isEditMode ? 'Gallery Updated' : 'Gallery Created';
                    $mdToast.show({
                        template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + msgFallback + '</span></div></md-toast>',
                        hideDelay: 3000,
                        position: 'top right',
                        parent: '#main'
                    });
                    $mdDialog.hide(response);
                })
                .catch(function (error) {
                    $log.error('Error saving gallery', error);
                    $mdToast.show({
                        template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-alert-circle" class="icon"></md-icon><span class="md-toast-text" flex>Error saving gallery</span></div></md-toast>',
                        hideDelay: 3000,
                        position: 'top right',
                        parent: '#main'
                    });
                })
                .finally(function () {
                    vm.saving = false;
                });
        }

        function deleteGallery() {
            if (!vm.isEditMode) return;

            var confirmDialog = $mdDialog.confirm()
                .title($translate.instant('GALLERY.DELETE_GALLERY') || 'Delete Gallery')
                .textContent($translate.instant('GALLERY.DELETE_CONFIRM') || 'Are you sure you want to delete this gallery?')
                .ariaLabel('Delete Gallery')
                .ok($translate.instant('GALLERY.DELETE') || 'Delete')
                .cancel($translate.instant('GALLERY.CANCEL') || 'Cancel')
                .multiple(true);

            $mdDialog.show(confirmDialog).then(function () {
                vm.saving = true;
                mediahubService.deleteGallery(vm.galleryId)
                    .then(function () {
                        $mdToast.show({
                            template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>Gallery Deleted</span></div></md-toast>',
                            hideDelay: 3000,
                            position: 'top right',
                            parent: '#main'
                        });
                        $mdDialog.hide({ deleted: true });
                    })
                    .catch(function (error) {
                        $log.error('Error deleting gallery', error);
                        $mdToast.show({
                            template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-alert-circle" class="icon"></md-icon><span class="md-toast-text" flex>Error deleting gallery</span></div></md-toast>',
                            hideDelay: 3000,
                            position: 'top right',
                            parent: '#main'
                        });
                    })
                    .finally(function () {
                        vm.saving = false;
                    });
            });
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function selectParentGalleryRoot() {
            vm.gallery.parentId = null;
            vm.galleryParentName = '';
        }

        function selectParentGallery(item) {
            vm.gallery.parentId = item.id || item.id_gallery;
            vm.galleryParentName = item.name || item.gallery_name || '';
        }

        function selectCover(ev) {
            $mdDialog.show({
                controller: 'MhMediaDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/mediahub/dialogs/media/mh-media-dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                multiple: true // dialog within a dialog
            }).then(function (selectedFiles) {
                if (selectedFiles && selectedFiles.length > 0) {
                    var selected = selectedFiles[0];
                    vm.gallery.coverId = selected.id_media || selected.id;
                    vm.coverMedia = selected;
                    vm.basicForm.$setDirty();
                }
            });
        }

        function removeCover() {
            vm.gallery.coverId = null;
            vm.coverMedia = null;
            vm.basicForm.$setDirty();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.mediahub')
        .controller('MHEditMultipleFieldsDialogController', MHEditMultipleFieldsDialogController);

    /** @ngInject */
    function MHEditMultipleFieldsDialogController($mdDialog, selectedThreads, siteID, mediahubService, $translate, $mdToast, $log, $q, $scope, sessionService, tagsService) {
        var vm = this;

        // Data
        vm.selectedThreads = selectedThreads;
        vm.mediaData = {
            title: '',
            photographer: '',
            credits: '',
            owner: '',
            caption: '',
            city: '',
            country: '',
            uses: '',
            extra: '',
            rating: null,
            geoLat: null,
            geoLon: null,
            fileDate: null,
            dateUploaded: null
        };
        vm.modifiedFields = {};
        vm.isLoading = false;

        // Tags support
        vm.currentTags = [];
        // 'add' → merge with each item's existing tags; 'replace' → overwrite them.
        vm.tagMode = 'add';
        // Show the add/replace toggle here (editing existing media); hidden on upload.
        vm.showTagMode = true;
        // Geolocation + dates are persisted when editing existing media (hidden on upload).
        vm.showGeoDates = true;
        // Title is per-image; editable here but hidden on bulk upload.
        vm.showTitle = true;
        vm.tags = sessionService.site_operative && sessionService.site_operative.tags ? sessionService.site_operative.tags : [];
        vm.searchTagText = null;
        vm.selectedTag = null;
        vm.newTagDisabled = false;

        vm.translate = function (key) { return $translate.instant(key); };

        vm.getpos = function(event) {
            if (!event || !event.latLng) return;
            var lat = event.latLng.lat();
            var lon = event.latLng.lng();
            $scope.$applyAsync(function() {
                vm.mediaData.geoLat = lat;
                vm.mediaData.geoLon = lon;
            });
        };

        // Methods
        vm.closeDialog = closeDialog;
        vm.updateMapFromInputs = updateMapFromInputs;
        vm.placeMarker = placeMarker;
        vm.save = save;
        vm.selectedItemChange = selectedItemChange;
        vm.labelQuerySearch = labelQuerySearch;
        vm.createFilterFor = createFilterFor;
        vm.newTag = newTag;
        vm.markModified = markModified;
        vm.clearField = clearField;

        function closeDialog() {
            $mdDialog.hide(false);
        }

        function save() {
            vm.isLoading = true;

            var payload = {};
            var fieldsToUpdate = [
                'title', 'photographer', 'credits', 'owner', 'caption', 
                'city', 'country', 'uses', 'extra', 'rating', 'geoLat', 'geoLon'
            ];
            
            fieldsToUpdate.forEach(function (field) {
                var val = vm.mediaData[field];
                // Allow saving empty strings or numeric 0, but skip null/undefined or pure empty inputs if unedited
                if (val !== null && val !== undefined && val !== '') {
                    // Convert numeric fields if needed
                    if (field === 'rating' || field === 'geoLat' || field === 'geoLon') {
                        var parsedVal = parseFloat(val);
                        if (!isNaN(parsedVal)) {
                            payload[field] = parsedVal;
                        }
                        return;
                    }
                    payload[field] = vm.mediaData[field];
                }
            });

            if (vm.modifiedFields['fileDate'] && vm.mediaData.fileDate) {
                payload.fileDate = new Date(vm.mediaData.fileDate).toISOString();
            }

            if (vm.modifiedFields['dateUploaded'] && vm.mediaData.dateUploaded) {
                payload.dateUploaded = new Date(vm.mediaData.dateUploaded).toISOString();
            }

            // Format tags as expected by the Mediahub API (Array of strings)
            if (vm.currentTags && vm.currentTags.length > 0) {
                payload.tags = vm.currentTags.map(function(t) { return t.tag_name || t; });
            }

            // 'add' merges tags with each item's existing ones; 'replace' overwrites.
            var mergeTags = (vm.tagMode !== 'replace');

            var promises = [];
            angular.forEach(vm.selectedThreads, function(item) {
                var mediaId = item.id_media || item.id;
                promises.push(mediahubService.updateMedia(mediaId, angular.copy(payload), mergeTags));
            });

            $q.all(promises).then(function() {
                var message = $translate.instant('MEDIA.SAVE_SUCCESS') || 'Saved successfully';
                $mdToast.show($mdToast.simple().textContent(message).position('top right').hideDelay(3000));
                $mdDialog.hide(true);
            }).catch(function(err) {
                $log.error('Error updating media', err);
                var errorMsg = $translate.instant('MEDIA.SAVE_ERROR') || 'Error saving';
                $mdToast.show($mdToast.simple().textContent(errorMsg).position('top right').hideDelay(3000));
            }).finally(function() {
                vm.isLoading = false;
            });
        }

        function updateMapFromInputs() {
            // ng-map reactively watches vm.mediaData.geoLat & geoLon from the view directly
        }

        function markModified(field) {
            vm.modifiedFields[field] = true;
        }

        function clearField(field) {
            vm.mediaData[field] = null;
            vm.modifiedFields[field] = false;
        }

        function placeMarker(place) {
            var p = place || (this && typeof this.getPlace === 'function' ? this.getPlace() : null);
            if (p && p.geometry && p.geometry.location) {
                var lat = p.geometry.location.lat();
                var lon = p.geometry.location.lng();
                $scope.$applyAsync(function() {
                    vm.mediaData.geoLat = lat;
                    vm.mediaData.geoLon = lon;
                });
            }
        }

        function selectedItemChange() {
            vm.searchTagText = '';
            vm.selectedTag = null;
        }

        function labelQuerySearch(query) {
            var ret = [];
            if (query) {
                var filteredContent = angular.copy(vm.tags.filter(vm.createFilterFor(query)));
                if (filteredContent.length > 0) {
                    ret.push({ id_tag: 0, tag_name: "", order: 1 });
                }
                angular.forEach(filteredContent, function (val) {
                    ret.push(val);
                });
            }
            return ret;
        }

        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query).normalize("NFD").replace(/[\u0300-\u036f]/g, "");
            return function filterFn(item) {
                if (!item || angular.isUndefined(item.tag_name)) return false;
                var normItem = typeof item.tag_name == 'string' ? item.tag_name.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : item.tag_name;
                return angular.lowercase(normItem.toString()).indexOf(lowercaseQuery) >= 0;
            };
        }

        function newTag(tagName) {
            if (vm.newTagDisabled || !tagName) return false;
            vm.newTagDisabled = true;
            var tagObj = { id_tag: '', tag_name: tagName };
            tagsService.saveItem({ site: siteID, item: tagObj }).then(function (response) {
                tagObj.id_tag = response.id_tag;
                vm.currentTags.push(tagObj);
                vm.searchTagText = '';
                vm.tags.push(tagObj); // Update globally
            }).catch(function (err) {
                $log.error('[mediahub] Error creating tag:', err);
            }).finally(function () {
                vm.newTagDisabled = false;
            });
        }
    }
})();
(function () {
	'use strict';

	angular
		.module('app.mediahub')
		.controller('AddMediahubToGalleriesDialogController', AddMediahubToGalleriesDialogController);

	/** @ngInject */
	function AddMediahubToGalleriesDialogController(
		$mdDialog,
		$mdToast,
		$translate,
		$log,
		mediahubService,
		msUtils,
		selectedThreads,
		CleanMediaGalleries,
		sourceGalleryId) {

		var vm = this;

		// Data
		vm.selectedItems = selectedThreads;
		vm.reload = false;
		vm.isLoading = false;
		vm.treeSearch = null;
		vm.CleanMediaGalleries = angular.copy(CleanMediaGalleries);

		// Methods
		vm.toggleInArray = msUtils.toggleInArray;
		vm.existInArray = msUtils.existInArray;
		vm.exists = msUtils.exists;
		vm.saveMediaGalleries = saveMediaGalleries;
		vm.closeDialog = closeDialog;

		// --- Helpers ---

		function getAssignedGalleriesIds(galleries, result) {
			angular.forEach(galleries, function (gallery) {
				if (gallery.assigned_gallery === true && !gallery.no_files_allowed) {
					result.push(parseInt(gallery.id_gallery, 10));
				}
				if (typeof gallery.children !== 'undefined' && gallery.children.length > 0) {
					getAssignedGalleriesIds(gallery.children, result);
				}
			});
			return result;
		}

		/**
		 * Add Multiple Media Items to multiple Galleries
		 * Uses mediahubService.assignMediaToGalleries batch endpoint
		 */
		function saveMediaGalleries() {
			vm.isLoading = true;
			var galleriesAssigned = getAssignedGalleriesIds(vm.CleanMediaGalleries, []);

			if (!galleriesAssigned.length) {
				vm.isLoading = false;
				return;
			}

			var mediaIds = vm.selectedItems.map(function (item) {
				return item.id_media || item.id;
			});

			mediahubService.assignMediaToGalleries(mediaIds, galleriesAssigned, 'copy', sourceGalleryId)
				.then(function () {
					vm.reload = true;
					var message = $translate.instant('MEDIA.ADDTOGALLERIES_PLURAL');
					$mdToast.show({
						template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + vm.selectedItems.length + message + '</span></div></md-toast>',
						hideDelay: 3000,
						position: 'top right',
						parent: '#main'
					});
					vm.isLoading = false;
					vm.closeDialog();
				})
				.catch(function (err) {
					$log.error('Error adding media to galleries', err);
					$mdToast.show({
						template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-alert-circle" class="icon"></md-icon><span class="md-toast-text" flex>' + $translate.instant('MEDIA.CREATE_ERROR') + '</span></div></md-toast>',
						hideDelay: 3000,
						position: 'top right',
						parent: '#main'
					});
					vm.isLoading = false;
				});
		}

		function closeDialog() {
			$mdDialog.hide(vm.reload);
		}
	}
})();

(function ()
{
    'use strict';

    angular
        .module('app.mediahub')
        .directive('mhSearchBar', mhSearchBarDirective);

    /** @ngInject */
    function mhSearchBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope: {
              modelSearch: '=',
              onSearch: '&'
            },
            bindToController: true,
            controller: function() {},
            controllerAs: 'msb',
            templateUrl: 'app/main/apps/mediahub/directives/mh-search-bar/mh-search-bar.html',
            compile    : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar mh-search-bar');

                return function postLink(scope, iElement)
                {
                    var expanderEl,
                        collapserEl;

                    // Initialize
                    init();

                    function init()
                    {
                        expanderEl = iElement.find('#ms-search-bar-expander');
                        collapserEl = iElement.find('#ms-search-bar-collapser');

                        expanderEl.on('click', expand);
                        collapserEl.on('click', collapse);

                        // Run the search and collapse the bar afterwards (better UX:
                        // once a search is submitted the input folds away).
                        scope.msb.doSearch = function ()
                        {
                            scope.msb.onSearch({ query: scope.msb.modelSearch });
                            collapse();
                        };
                    }

                    /**
                     * Expand
                     */
                    function expand()
                    {
                        iElement.addClass('expanded');

                        // Esc key event
                        $document.on('keyup', escKeyEvent);
                    }

                    /**
                     * Collapse
                     */
                    function collapse()
                    {
                        iElement.removeClass('expanded');
                    }

                    /**
                     * Escape key event
                     *
                     * @param e
                     */
                    function escKeyEvent(e)
                    {
                        if ( e.keyCode === 27 )
                        {
                            collapse();
                            $document.off('keyup', escKeyEvent);
                        }
                    }
                };
            }
        };
    }
})();




(function () {
    'use strict';

    angular
        .module('app.media')
        .controller('ShareDialogController', ShareDialogController);

    /** @ngInject */
    function ShareDialogController($mdDialog, $mdToast, $translate, $scope, sessionService, medias,
        mediaService) {
        var vm = this;
        vm.closeDialog = closeDialog;
        vm.fotoramaoptions = {
            width: '100%',
            height: '350px',
            captions: false,
            loop: true,
            keyboard: true,
            arrows: true,
            allowfullscreen: false,
            nav: false,
            ratio: 16 / 9,
            fit: 'contain',
        };
        vm.socialNetworks = [];
        vm.medias = medias;
        vm.mediasIds = medias.map(x => x.id_media);
        console.log(vm.medias)

        vm.dataFotorama = vm.medias.map(x => {
            if (x.media_type == 2) {
                var videoUrl = '';
                var imageUrl = x.embed_thumb;
                if (!x.embed) {
                    var attachmentContainer = sessionService.getContainerByID(x.cdnContainer);
                    videoUrl = attachmentContainer.view_url + 'videos/m' + x.id_media + '_' + x.filename;
                } else {
                    if (x.embed.indexOf('yt|') !== -1) {
                        var YT_VideoSource = x.embed.split('yt|')[1];
                        videoUrl = 'http://youtube.com/' + YT_VideoSource;
                    } else if (x.embed.indexOf('vimeo|') !== -1) {
                      var Vimeo_VideoSource = x.embed.split('vimeo|')[1];
                        videoUrl = 'https://player.vimeo.com/video/' + Vimeo_VideoSource;
                    } else if (x.embed.indexOf('fb|') !== -1) {
                        var embed_url = angular.element(x.embed_url);
                        videoUrl = embed_url.attr('src');
                    } else if (x.embed.indexOf('zc|') !== -1) {
                        videoUrl = x.embed.split('zc|')[1];
                    } else if (x.embed.indexOf('x|') !== -1) {
                        videoUrl = x.embed.split('x|')[1];
                    }
                }
                return {
                    imageUrl: imageUrl,
                    thumb: imageUrl,
                    full: imageUrl, // Separate image for the fullscreen mode.
                    video: videoUrl, // Youtube, Vimeo or custom iframe URL
                    id: 'one', // Custom anchor is used with the hash:true option.
                    dataCaption: '#' + x.id_media + ' | ' + x.filename ? x.filename : '',
                    html: '<div></div>',
                    // html: $('selector'), // ...or '<div>123</div>'. Custom HTML inside the frame.
                    fit: 'cover', // Override the global fit option.
                    any: 'Any data relative to the frame you want to store',
                }
            } else {
                var mediaContainer = sessionService.getContainerByID(x.cdnContainer);
                x.imageUrlOriginal = mediaContainer.view_url + 'original/m' + x.id_media + '_' + x.filename;
                return {
                    imageUrl: x.imageUrlOriginal,
                    thumb: x.imageUrlOriginal,
                    html: '<div>123</div>',
                    selected: 0
                }
            }
        })


        function closeDialog() {
            $mdDialog.hide(true);
        }

        $scope.$on('$destroy', function () {
        });
    }
})();





(function () {
    'use strict';

    angular
        .module('app.media')
        .controller('RekognitionDialogController', RekognitionDialogController);

    /** @ngInject */
    function RekognitionDialogController($mdDialog, $mdToast, $translate, $scope, media, type, sessionService, requestContext,
        mediaService) {
        var vm = this;
        vm.closeDialog = closeDialog;
        vm.load = load;
        vm.media = media;
        vm.type = type;
        console.log(sessionService.getSiteLanguages());
        vm.siteID = requestContext.getParam("siteId");
        vm.isLoading = false;
        vm.languages = [
            {
                'title': 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code': 'en-GB'
            },
            {
                'title': 'Spanish',
                'translation': 'TOOLBAR.SPANISH',
                'code': 'es-ES'
            }
        ];
        vm.typesRekognition = [
            {
                'translation': 'AWS Transcription',
                'code': 'aws_transcription'
            },
            {
                'translation': 'Celebrety rekognition',
                'code': 'rekognition_recognize_celebrities'
            },
            {
                'translation': 'Content Moderation',
                'code': 'rekognition_moderate_content'
            },
            {
                'translation': 'Face detection',
                'code': 'rekognition_detect_faces'
            },
            {
                'translation': 'Labels detection',
                'code': 'rekognition_detect_labels'
            },
            {
                'translation': 'Person tracking',
                'code': 'rekognition_track_persons'
            },
            {
                'translation': 'Search faces',
                'code': 'rekognition_search_faces'
            }
        ];

        function load() {
            if (vm.type == "REKOGNITION") {
                loadRekognition();
            } else if (vm.type == "TRANSCRIPTION") {
                loadTranscription();
            }
        }

        function loadRekognition() {
            vm.isLoading = true;
            var options = {
                siteID: vm.siteID,
                item: {
                    id_media: [vm.media.id_media],
                    rekognition_service: vm.typeRekognitionSelected
                }
            };
            mediaService.loadRekognition(options).then(res => {
                console.log(res);
                vm.isLoading = false;
                $mdDialog.hide(true);
            })
        }

        function loadTranscription() {
            vm.isLoading = true;
            var options = {
                siteID: vm.siteID,
                item: {
                    id_media: [vm.media.id_media],
                    language_code: vm.langSeleted
                }
            };
            mediaService.loadTranscription(options).then(res => {
                console.log(res);
                vm.isLoading = false;
                $mdDialog.hide(true);
            })
        }

        function closeDialog() {
            $mdDialog.hide();
        }


    }
})();


(function () {
  'use strict';

  angular
    .module('app.media')
    .directive('qiuMediaDialogOnClickLoadMediaByGalleries2', ['mediaDialogService', LoadMediaDialogMediaByGalleries])
    .controller('MediaTagDialogController', MediaTagDialogController)
    ;

  /** @ngInject */
  function MediaTagDialogController(
    $mdDialog,
    $document,
    mediaService,
    uploadService,
    requestContext,
    $anchorScroll,
    $mdToast,
    $timeout,
    $scope,
    $sce,
    Upload,
    mediazone,
    section,
    maxAttach,
    msUtils,
    showViews,
    COMMON,
    $log,
    transformMedia,
    $translate,
    sessionService,
    tagsService,
    $q,
    $mdSidenav,
    $rootScope
  ) {
    var vm = this;

    // Data

    vm.mediazone = mediazone;
    vm.defaultPage = 1;
    vm.defaultPerPage = 50;
    vm.PerPage = 50;
    vm.searchStringFilter = '';
    vm.searchQuery = '';
    vm.modelSearch = '';
    vm.pagination_search = pagination_search;

    vm.maxAttach = !angular.isUndefined(maxAttach) ? maxAttach : 99999;

    vm.title = '';
    vm.photo_tags = []
    vm.min_match = 90;
    vm.views = {
      1: 'app/main/dialogs/media/views/photos-view.html',
      2: 'app/main/dialogs/media/views/videos-view.html',
      3: 'app/main/dialogs/media/views/files-view.html',
      4: 'app/main/dialogs/media/views/audios-view.html',
      5: 'app/main/dialogs/media/views/galleries-view.html',
      upload: 'app/main/apps/media/dialogs/media-tags-dialog/upload-view-tags.html',
      import: 'app/main/dialogs/media/views/import-view.html',
    };
    vm.processed = false;

    angular.forEach(vm.views, function (value, key) {
      if (!showViews.hasOwnProperty(key) || showViews[key] !== true) {
        delete vm.views[key];
      }
    });
    vm.defaultView = 1;
    vm.currentView = 1;
    vm.firstLoad = true;
    vm.media_type = 1;
    vm.showSearchAndPaginator = true;
    vm.import_field = '';
    vm.import_disabled = '';
    vm.importedFiles = [];
    vm.importPreview = false;
    vm.imported = false;
    vm.importing = false;
    vm.selectedGalleries = [];
    vm.files = [];
    vm.uploadFiles = [];
    vm.uploadedFiles = [];

    vm.searchTagText = '';
    vm.tags = sessionService.site_operative.tags;
    vm.currentTags = [];
    vm.image = {};
    vm.newTagDisabled = false;

    vm.fields = {
      geoLat: null,
      geoLon: null,
      title: null,
      photographer: null,
      credits: null,
      owner: null,
      caption: null,
      city: null,
      country: null,
      uses: null,
      extras: null,
      rating: null,
    };
    // If replying
    // if (angular.isDefined(selectedMail)) {
    //     vm.form.to = selectedMail.from.email;
    //     vm.form.subject = 'RE: ' + selectedMail.subject;
    //     vm.form.message = '<blockquote>' + selectedMail.message + '</blockquote>';
    // }

    // Methods
    vm.closeDialog = closeDialog;
    vm.changeView = changeView;
    vm.changeViewGallery = changeViewGallery;

    vm.nextPage = nextPage;
    vm.prevPage = prevPage;
    vm.morePages = morePages;
    vm.gotoPage = gotoPage;
    vm.firstPage = firstPage;
    vm.upload = upload;
    vm.search = search;

    vm.exists = msUtils.exists;
    vm.alreadySelectedbyZone = alreadySelectedbyZone;
    vm.existInArray = msUtils.existInArray;
    vm.toggleSelectOne = toggleSelectOne;

    vm.selectedItemChange = selectedItemChange;
    vm.labelQuerySearch = labelQuerySearch;
    vm.createFilterFor = createFilterFor;
    vm.newTag = newTag;
    vm.getpos = getpos;
    vm.placeMarker = placeMarker;
    vm.searchLatLon = searchLatLon;
    vm.toggleMediaDialogSidenav = toggleMediaDialogSidenav;
    vm.saveFace = saveFace;
    vm.selectMedia = selectMedia;

    vm.isNumber = angular.isNumber;

    vm.translate = function (text) {
      return $translate.instant(text);
    }


    //////////


    var siteID = requestContext.getParam("siteId");
    var section = requestContext.getParam("section");
    init();

    /**
     * Initialize
     */
    function init() {

      vm.loading = true;
      var options = {
        section: section,
        media_type: vm.media_type,
        page: vm.defaultPage,
        perPage: vm.defaultPerPage
      };
      //
      getData(options);
      getMediaGalleries(vm.media_type);

    }


    $scope.$on('loadMediaDialogMediaByGalleries', function (event, galleries) {
      if (galleries) {
        loadMediaByGalleries(galleries);
      } else {
        unselectGalleries();
      }
    })


    function unselectGalleries() {
      vm.selectedGallery = false;
      vm.selectedContent = false;
      $rootScope.pagination_galleryIds = false;
      $rootScope.sortField = "date_uploaded"; // reset to default
      $rootScope.sortDir = "DESC"; // reset to default
      var elemList = document.querySelectorAll('.gallery-row');
      elemList.forEach(function (elem) {
        elem.classList.remove('selected');
      });
      var options = {
        section: section,
        media_type: vm.media_type,
        page: vm.defaultPage,
        perPage: vm.defaultPerPage
      };
      getData(options);
    }


    /**
     * Add label chips
     *
     * @param query
     * @returns {filterFn}
     */
    function labelQuerySearch(query) {
      var ret = [];
      if (query) {
        var filteredContent = angular.copy(vm.tags.filter(vm.createFilterFor(query)));
        if (filteredContent.length > 0) {
          ret.push({
            id_tag: 0,
            tag_name: "",
            order: 1
          });
        }
        angular.forEach(filteredContent, function (val) {
          ret.push(val);
        })
      }
      return ret;
    }


    function selectMedia(media) {
      // Retrieve single Media from api, since media from collections doesn't contain ai_recognition and meta_analyses data (for performance purpose).
      mediaService.get({
        siteID: siteID,
        withCropStatus: true,
        idMedia: media.id_media
      })
      .then(function (response) {
          media = response.data[0];

        if (media.ai_recognition && media.ai_recognition.faces && media.ai_recognition.faces[0].enabled) {
          alert("Not valid image: It's already a face uploaded");
          return;
        }
        if (!media.meta_analyses || !media.meta_analyses.rekognition_index_faces || !media.meta_analyses.rekognition_index_faces.FaceRecords
          || !media.meta_analyses.rekognition_index_faces.FaceRecords.length > 0) {
          alert("Not valid image: no proccessed");
          return;
        }
        if (media.meta_analyses.rekognition_index_faces.FaceRecords.length > 1) {
          alert("Not valid image: More than one face");
          return;
        }

        vm.selectedMedia = media;
      })
    }


    function saveFace() {
      if (!vm.selectedMedia.ai_recognition) {
        vm.selectedMedia.ai_recognition = {}
      }
      vm.selectedMedia.title = vm.title;
      vm.selectedMedia.ai_recognition.faces = [{
        "id": vm.selectedMedia.meta_analyses.rekognition_index_faces.FaceRecords[0].Face.FaceId,
        "tags": vm.photo_tags.map(x => {
          return { name: x.tag_name, id: x.id_tag };
        }),
        "enabled": true,
        "min_match": vm.min_match
      }];
      delete vm.selectedMedia.media_children;
      delete vm.selectedMedia.cropstatus;
      delete vm.selectedMedia.meta_analyses;
      var options = {
        site: siteID,
        id: vm.selectedMedia.id_media,
        item: JSON.parse(angular.toJson(vm.selectedMedia))
      };

      mediaService.saveMedia(options)
        .then(function (response) {
          $mdDialog.hide(true);
        });
    }

    function selectedItemChange() {
      vm.searchTagText = '';
      vm.selectedTag = null;
    }

    function newTag(tagName) {

      if (vm.newTagDisabled) {
        return false;
      }
      vm.newTagDisabled = true;

      var newTag = {
        id_tag: '',
        tag_name: tagName
      };
      var options = {
        site: siteID,
        item: newTag
      };
      tagsService.saveItem(options).then(function (response) {
        newTag.id_tag = response.id_tag;
        vm.photo_tags.push(newTag);
        vm.photo_tags = vm.photo_tags.filter(x => x.tag_name)
        vm.searchTagText = '';
        vm.newTagDisabled = false;
      })
    }

    function pagination_search(searchString) {

      vm.loading = true;
      scrollToTopOfDialog();

      if (vm.selectedGallery) {
        loadMediaByGalleries([vm.selectedGallery]);
      } else {
        var options = {
          section: section,
          media_type: vm.media_type,
          page: vm.defaultPage,
          perPage: vm.defaultPerPage,
          searchString: searchString,
          gallery_type: vm.media_type
        };
        if (vm.media_type) {
          options.mediaTypeFilter = {
            'media_type': {
              selected: [vm.media_type],
              field: 'media_type',
              name: 'media_type'
            }
          }
        };

        getData(options);
      }
    }

    function getMediaGalleries(mediaType) {

      if (sessionService.site_operative.mediaGalleriesDefaultSort) {
        vm.sortFieldGalleries = sessionService.site_operative.mediaGalleriesDefaultSort.field;
        if (!angular.isUndefined(sessionService.site_operative.mediaGalleriesDefaultSort.dir)) {
          vm.sortDirGalleries = sessionService.site_operative.mediaGalleriesDefaultSort.dir;
        }
      } else {
        vm.sortFieldGalleries = "sort";
        vm.sortDirGalleries = "ASC"
      }

      var options = {
        siteID: siteID,
        sortField: vm.sortFieldGalleries,
        sortDir: vm.sortDirGalleries
      };
      if (angular.isNumber(mediaType)) {
        options['gallery_type'] = [mediaType, 0];
      }
      mediaService.getNestedMediaGalleries(options)
        .then(function (response) {
          var qiuRestrictions = response.qiuRestrictions;
          var galleries = response.data;
          var nestedGalleries = transformMedia.formatNestedGalleries(galleries, qiuRestrictions, true);
          vm.CleanMediaGalleries = angular.copy(nestedGalleries);
          transformMedia.preAssignQiuRestrictedRoot(vm.CleanMediaGalleries);
        });
    }


    function loadMediaByGalleries(galleries) {

      vm.loading = true;

      var galleryIds = [];
      angular.forEach(galleries, function (gallery) {
        galleryIds.push(gallery.id_gallery);
      });
      vm.selectedGallery = galleries[0];

      var mediaTypeFilter = {
        'media_type': {
          selected: [vm.media_type],
          field: 'media_type',
          name: 'media_type'
        }
      };

      if (sessionService.site_operative.mediaInGalleriesDefaultSort) {
        $rootScope.sortField = sessionService.site_operative.mediaInGalleriesDefaultSort.field;
        if (!angular.isUndefined(sessionService.site_operative.mediaInGalleriesDefaultSort.dir)) {
          $rootScope.sortDir = sessionService.site_operative.mediaInGalleriesDefaultSort.dir;
        }
      } else {
        $rootScope.sortField = "sort";
      }

      var options = {
        siteID: siteID,
        page: vm.defaultPage,
        resultsPerPage: vm.defaultPerPage,
        search: vm.modelSearch,
        withCropStatus: true,
        withMediaChildren: true,
        sortField: $rootScope.sortField,
        sortDir: $rootScope.sortDir,
        gallery_type: vm.media_type,
        galleryIds: galleryIds
      };

      if (vm.media_type) {
        options.mediaTypeFilter = {
          'media_type': {
            selected: [vm.media_type],
            field: 'media_type',
            name: 'media_type'
          }
        }
      };

      mediaService.getMediaInGalleries(options).then(function (response) {
        vm.totalItems = response.total;
        vm.from = response.from;
        vm.to = response.to;
        vm.currentPage = response.current_page;
        vm.lastPage = response.last_page;
        vm.maxSize = 500;
        vm.bigTotalItems = 175;
        vm.items = response.data;
        vm.loading = false;
      });
    }

    function getData(options) {

      vm.loading = true;
      scrollToTopOfDialog();

      var arrayOptions = {
        siteID: siteID,
        page: options.page,
        resultsPerPage: options.perPage,
        media_type: options.media_type,
        search: vm.modelSearch,
        withCropStatus: true,
        withMediaChildren: true,
        sortField: 'date_uploaded',

      };

      if (vm.modelSearch && !_.isEmpty(vm.modelSearch)) {
        arrayOptions['searchStringFilter'] = vm.modelSearch;
        // console.log("arrayOptions ", arrayOptions)
      }

      mediaService.get(arrayOptions)
        .then(function (response) {
          // console.log("response ", response)
          vm.totalItems = response.total;
          vm.from = response.from;
          vm.to = response.to;
          vm.currentPage = response.current_page;
          vm.lastPage = response.last_page;
          vm.maxSize = 500;
          vm.bigTotalItems = 175;
          vm.items = response.data;

          //angular.forEach(response.data, function (item) {
          /*
          if (item.media_type == 1) {
              if (item.cropstatus.length < 1) {
                  console.log(item.id_media, 'noImg');
              } else {
                  console.log(item.id_media, 'hasImg');
              }
          } else {
              if (item.thumb) {
                  console.log(item.id_media, 'hasThumb');
              } else {
                  console.log(item.id_media, 'hasEmbedThumb');
              }
          }
          */
          //vm.items.push(item);
          // console.log('vm.items  ', vm.items)
          //})

          $('.md-button')
            .removeClass('active');
          $('[type=' + options.media_type + ']')
            .addClass('active');

          vm.loading = false;
          vm.firstLoad = false;
        })
    }
    function search(options) {
      // console.log(options, vm.searchStringFilter);
      /*

      vm.loading         = true;
      vm.items        =[];
      // Scroll to the top Dialog
      scrollToTopOfDialog();

      mediaService.get({
          siteID: siteID,
          page: options.page,
          paginate: options.perPage,
          media_type: options.media_type,
          withCropStatus: true,
          sortField: 'date_uploaded',
          searchStringFilter: options.searchString,

      })
          .then(function (response) {
              vm.totalItems = response.total;
              vm.pagination_totalItems = response.total;
              vm.from = response.from;
              vm.pagination_from = response.from;
              vm.to = response.to;
              vm.pagination_to = response.to;
              vm.currentPage = response.current_page;
              vm.lastPage = response.last_page;
              vm.maxSize = 500;
              vm.bigTotalItems = 175;

              vm.loading = false;

              vm.items = angular.copy(response.data);

              $('.md-button')
                  .removeClass('active');
              $('[type=' + options.media_type + ']')
                  .addClass('active');

          });




      vm.firstLoad = false;
*/
    }

    function closeDialog() {
      // delete from media_files if upload not terminated.
      if (vm.uploadFiles.length == 0 || vm.uploadedFiles.length == vm.uploadFiles.length) {
        $mdDialog.hide();
      } else {
        var messageConfirm = $translate.instant('MEDIA.UPLOADING_MEDIA_CLOSE_CONFIRM');
        var confirm = $mdDialog.confirm().multiple(true).title(messageConfirm)
          // .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' will be deleted.')
          .ariaLabel('Close dialog').ok('OK').cancel('CANCEL');

        $mdDialog.show(confirm)
          .then(function () {
            var deleteIds = [];
            for (var i = 0; i < vm.uploadFiles.length; i++) {
              var isFileUploaded = vm.uploadedFiles.some(function (el) {
                return el.id_media == vm.uploadFiles[i].id_media
              });
              if (!isFileUploaded) {
                deleteIds.push(vm.uploadFiles[i].id_media);
              }
            }
            if (deleteIds.length > 0) {
              var options = {
                site: siteID,
                id_media: deleteIds,
                force: true
              };
              mediaService.massDelete(options);
            }
            $mdDialog.hide();
          }, function () {

          })
      }
    }

    function changeView(view) {


      if (vm.views[view]) {

        vm.loading = true;
        scrollToTopOfDialog();

        // console.log(vm.views[view])
        //vm.items = [];
        vm.showSearchAndPaginator = false;
        vm.defaultView = view;
        vm.currentView = view;
        vm.currentViewGallery = false;
        vm.CleanMediaGalleries = [];


        vm.media_type = view;

        var options = {
          page: 1,
          perPage: vm.PerPage,
          media_type: view,

        };
        if (view == 1 || view == 2 || view == 3 || view == 4) {
          vm.showSearchAndPaginator = true;
        }

        if (view == 'upload' || view == 'import') {
          $mdSidenav('media-dialog-galleries-sidenav').close();
        }


        getData(options);
        getMediaGalleries(vm.media_type);
      }

    }

    function changeViewGallery(mediaType) {
      $mdSidenav('media-dialog-galleries-sidenav').close();

      vm.loadingView = true;
      vm.loading = true;
      scrollToTopOfDialog();

      vm.items = [];

      vm.totalItems = 0;
      vm.showSearchAndPaginator = false;

      vm.currentView = 5;
      vm.currentViewGallery = mediaType;

      getMediaGalleries(mediaType);
      $('.md-button')
        .removeClass('active');
      $('[type=5]')
        .addClass('active');

    }


    $scope.$watch('vm.files', function () {
      angular.forEach(vm.files, function (f) {
        vm.uploadFiles.push(f);
      });
      $scope.formUpload = false;
      // console.log("vm.files ", vm.files)
      if (vm.files != null) {
        // make files array for not multiple to be able to be used in ng-repeat in the ui
        if (!angular.isArray(vm.files)) {
          $timeout(function () {
            $scope.files = vm.files = [vm.files];
          });
          return;
        }
        for (var i = 0; i < vm.files.length; i++) {
          $scope.errorMsg = null;
          (function (f) {
            vm.upload(f, true);
          })(vm.files[i]);
        }
      }
    });



    $scope.log = '';
    
    function upload(file) {
			if (!file.$error) {
				file.processed = false;
				var uploadOptions = {
					siteID: siteID,
					filename: file.name,
          log: $scope.log,
          type: 'media'
				}
				//				console.debug("UPLOAD______****", file)
				uploadService.upload(file, uploadOptions).then(function (resp) {
          $scope.log = resp.log;
          mediaService.get({
            siteID: siteID,
            withCropStatus: true,
            withTags: true,
            idMedia: file.id_media
          })
            .then(function (response) {
              getMedia(file.id_media);
            });
				});
			}
		};

    function getMedia(id_media) {
      mediaService.get({
        siteID: siteID,
        withCropStatus: true,
        idMedia: id_media
      })
        .then(function (response) {
          if (response.data[0].meta_analyses) {
            vm.selectMedia(response.data[0]);
            vm.processed = true;
          } else {
            setTimeout(() => {
              getMedia(id_media);
            }, 5000);
          }
        });
    }


    function nextPage() {

      var options = {
        page: vm.currentPage + 1,
        perPage: vm.PerPage,
        media_type: vm.media_type,
        searchString: vm.modelSearch
      };
      //
      getData(options);

    }

    function prevPage() {
      var options = {
        page: vm.currentPage - 1,
        perPage: vm.PerPage,
        media_type: vm.media_type,
        searchString: vm.modelSearch
      };
      //
      getData(options);
    }

    function morePages() {
      if (vm.currentPage < vm.lastPage) return true;
      return false;
    }

    function firstPage() {
      if (vm.currentPage == 1) return true;
      return false;
    }

    function gotoPage(i) {

      var options = {
        page: i,
        perPage: vm.PerPage,
        media_type: vm.media_type,
        searchString: vm.modelSearch
      };
      //
      getData(options);
    }


    function alreadySelectedbyZone(array, item) {
      var ret = false;
      for (var i = 0, len = array.length; i < len; i++) {
        if (vm.mediazone) {
          if (array[i]['id_media'] === item.id_media && array[i]['id_zone'] === vm.mediazone.id_zone) {
            ret = true;
          }
        } else {
          if (array[i]['id_media'] === item.id_media) {
            ret = true;
          }

        }
      }

      return ret;
    }


    /**
     * Filter for chips
     *
     * @param query
     * @returns {filterFn}
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(item) {
        if (angular.isUndefined(item.tag_name)) {
          return false;
        }
        if (!item.tag_name) {
          return false;
        }
        if (!angular.lowercase(item.tag_name.toString()).indexOf) {
          return false;
        }
        return angular.lowercase(item.tag_name.toString()).indexOf(lowercaseQuery) >= 0;
      };
    }

    function getpos(event) {
      vm.fields.geoLat = event.latLng.lat();
      vm.fields.geoLon = event.latLng.lng();
      vm.latlng = [event.latLng.lat(), event.latLng.lng()];
    }

    function placeMarker() {
      var loc = this.getPlace()
        .geometry.location;
      vm.latlng = [loc.lat(), loc.lng()];
      vm.fields.geoLat = loc.lat();
      vm.fields.geoLon = loc.lng();
      vm.center = [loc.lat(), loc.lng()];
    }

    function searchLatLon() {
      vm.latlng = [vm.fields.geoLat, vm.fields.geoLon];
      vm.center = [vm.fields.geoLat, vm.fields.geoLon];
      vm.center = [40.74, -74.18];
    }



    function toggleSelectOne(photo, event) {
      vm.selectMedia(photo);
    }

    /**
     * Scroll Media Dialog Content to the top
     * @param speed
     */
    function scrollToTopOfDialog() {
      //$timeout(function () {
      var dialogContent = $document.find('md-dialog-content').filter(function () {
        return angular.element(this).hasClass('mediadialog-content');
      });
      if (!angular.isUndefined(dialogContent[0])) {
        dialogContent.animate({
          scrollTop: 0
        }, 1);
      }
      //}, 1000);

    }

    function toggleMediaDialogSidenav(sidenavId) {
      $mdSidenav(sidenavId)
        .toggle();
    }
  }

  function LoadMediaDialogMediaByGalleries(mediaDialogService) {

    function unselectAllGalleries() {
      var elemList = document.querySelectorAll('.gallery-row');
      elemList.forEach(function (elem) {
        elem.classList.remove('selected');
      });
    }

    return {
      restrict: 'A',
      link: function (scope, element, attrs) {

        $(element).on('click', function (e) {
          var galleryNode = false;
          if (element.parent().hasClass('selected')) {
            unselectAllGalleries();
          } else {
            unselectAllGalleries();
            element.parent().addClass('selected');
            galleryNode = scope.node;
          }

          var includeSubgalleries = $('#includeSubgalleries').attr("data-include-subgalleries") == 'true';
          mediaDialogService.triggerMediaDialogMediaByGalleries(galleryNode, includeSubgalleries);
        });
      }
    };
  }
})();

(function () {
	'use strict';

	angular
		.module('app.media')
		.controller('RepeatedUploadFilesController', RepeatedUploadFilesController);

	/** @ngInject */
	function RepeatedUploadFilesController(
		$mdDialog,
		$translate,
		$mdToast,
        uploadFile,
        repeatedFiles) {
		var vm = this;

        vm.uploadFile = uploadFile;
        vm.repeatedFiles = repeatedFiles;
		vm.rememberDecission = false;

		vm.isImage = isImage;
		vm.isVideo = isVideo;
        vm.closeDialog = closeDialog;
		vm.maintainBoth = maintainBoth;
		vm.replaceImage = replaceImage;
		vm.changeRememberDecission = changeRememberDecission;
		vm.checkSelectedRepeated = checkSelectedRepeated;
		vm.changeSelectedRepeated = changeSelectedRepeated;

		function checkSelectedRepeated(file){
			if(vm.selectedRepeated == file){
				return true;
			}else{
				return false;
			}
		}

		function changeSelectedRepeated(file){
			vm.selectedRepeated = file;
		}

		function isImage(f) {
			return f.type.startsWith("image");
		}

		function isVideo(f) {
			return f.type.startsWith("video");
		}

		function changeRememberDecission(){
			vm.rememberDecission = !vm.rememberDecission;
		}

        function closeDialog(){
            $mdDialog.hide(
				{
					action: 'delete',
					remember: vm.rememberDecission,
					file: vm.uploadFile
				}
			);
        }
		function maintainBoth(){
			$mdDialog.hide(
				{
					action: 'maintain',
					remember: vm.rememberDecission,
					file: vm.uploadFile
				}
			);
		}
		function replaceImage(){
			if(vm.repeatedFiles.length > 1){
				if(vm.selectedRepeated){
					var file = vm.selectedRepeated;
				}else{
					var message = $translate.instant('MEDIA.SELECT_ACT_MEDIA ');
					$mdToast.show({
						template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg">' + message + '</div></md-toast>',
						hideDelay: 2000,
						position: 'top',
						parent: '#login-form-wrapper'
					});
					return;
				}
			}else{
				var file = vm.repeatedFiles[0];
			}
			$mdDialog.hide(
				{
					action: 'replace',
					remember: vm.rememberDecission,
					file: vm.uploadFile,
					repeatedFiles: file
				}
			);
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('app.media')
		.controller('AddMediaDialogControllerOld', AddMediaDialogControllerOld);

	/** @ngInject */
	function AddMediaDialogControllerOld(
		$mdDialog,
		$document,
		currentThread,
		mediaService,
		uploadService,
		requestContext,
		$anchorScroll,
		isReplace,
		item,
		$timeout,
		$scope,
		$rootScope,
		$sce,
		Upload,
		mediazone,
		section,
		msUtils,
		COMMON,
		isTiny,
		$log,
		$translate,
		CleanMediaGalleries,
		sessionService,
		$mdToast,
		tagsService,
		$q,
		preselectedTags) {
		var vm = this;

		// Data
		vm.currentThread = currentThread;

		vm.mediazone = mediazone;
		vm.defaultPage = 1;
		vm.defaultPerPage = 50;
		vm.PerPage = 50;
		vm.searchStringFilter = '';
		vm.searchQuery = '';
		vm.modelSearch = '';
		vm.pagination_search = pagination_search;
		vm.CleanMediaGalleries = angular.copy(CleanMediaGalleries);
		vm.isAttaching = false;
		vm.preselectedTags = preselectedTags;
		vm.showLargeUploadList = false;
		vm.repeatedFilesArray = [];

		vm.fields = {
			geoLat: null,
			geoLon: null,
			title: null,
			photographer: null,
			credits: null,
			owner: null,
			caption: null,
			city: null,
			country: null,
			uses: null,
			extras: null,
			rating: null,
		};

		vm.isTiny = isTiny;

		vm.views = {
			// 1: 'app/main/dialogs/media/views/photos-view.html',
			// 2: 'app/main/dialogs/media/views/videos-view.html',
			// 3: 'app/main/dialogs/media/views/files-view.html',
			// 4: 'app/main/dialogs/media/views/audios-view.html',
			upload: 'app/main/dialogs/media/views/upload-view.html',
			import: 'app/main/dialogs/media/views/import-view.html',
		};
		vm.defaultView = 'upload';
		vm.currentView = 'upload';

		vm.viewsTiny = {
			1: 'app/main/dialogs/media/views/tiny-attached.html',
			properties: 'app/main/dialogs/media/views/tiny-properties.html',
			upload: 'app/main/dialogs/media/views/upload-view.html',
		};
		vm.defaultViewTiny = '1';
		vm.currentViewTiny = '1';

		vm.isReplace = isReplace;
		vm.item = item;


		vm.allowedFilesPattern = "video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz,.json,.xml,.csv,.ttf,.eps,.ai,.psd,.aep,.indd,.idll,.heic,.mkv";

		vm.firstLoad = true;
		vm.media_type = '1';
		vm.showSearchAndPaginator = true;
		vm.import_field = '';
		vm.import_disabled = '';
		vm.importedFiles = [];
		vm.importPreview = false;
		vm.imported = false;
		vm.importing = false;
		vm.selectedContacts = [];
		vm.files = [];
		vm.uploadFiles = [];
		vm.uploadedFiles = [];
		vm.tinyProperties = {
			mediaType: '',
			mediaSort: '',
			mediaData: {},
			align: '',
			size: ''
		};
		vm.tinyOptions = {
			size: [
				{ value: 25, text: '25%' },
				{ value: 50, text: '50%' },
				{ value: 75, text: '75%' },
				{ value: 100, text: '100%' }
			],
			align: [
				{ value: 'left', text: 'left' },
				{ value: 'center', text: 'center' },
				{ value: 'right', text: 'right' }
			]
		}
		vm.searchTagText = '';
		vm.tags = sessionService.site_operative.tags;
		vm.currentTags = [];
		vm.selectedTag = null;
		vm.image = {};
		vm.newTagDisabled = false;
		vm.tagsTabSettings = false;
		vm.checkboxesGroupedByType = [];

		vm.checkRepeatedFiles = false;

		vm.isAdmin = false;

		// If replying
		// if (angular.isDefined(selectedMail)) {
		// 	vm.form.to = selectedMail.from.email;
		// 	vm.form.subject = 'RE: ' + selectedMail.subject;
		// 	vm.form.message = '<blockquote>' + selectedMail.message + '</blockquote>';
		// }

		// Methods
		vm.closeDialog = closeDialog;
		vm.changeView = changeView;
		vm.changeViewTiny = changeViewTiny;

		vm.nextPage = nextPage;
		vm.prevPage = prevPage;
		vm.morePages = morePages;
		vm.gotoPage = gotoPage;
		vm.firstPage = firstPage;
		vm.upload = upload;
		vm.attachMedia = attachMedia;
		vm.attachMediaTiny = attachMediaTiny;
		vm.selectMediaTiny = selectMediaTiny;
		vm.selectedMediaTiny = '';
		vm.search = search;

		vm.exists = msUtils.exists;
		vm.alreadySelectedbyZone = alreadySelectedbyZone;
		vm.existInArray = msUtils.existInArray;
		vm.toggleSelectContact = toggleSelectContact;
		vm.selectedItemChange = selectedItemChange;
		vm.labelQuerySearch = labelQuerySearch;
		vm.createFilterFor = createFilterFor;
		vm.newTag = newTag;
		vm.getpos = getpos;
		vm.placeMarker = placeMarker;
		vm.searchLatLon = searchLatLon;
		vm.radioOptionsFilter = radioOptionsFilter;
		vm.checkboxesFilter = checkboxesFilter;
		vm.updateCurrentTags = updateCurrentTags;
		vm.checkboxGroupTitleByTagTypes = checkboxGroupTitleByTagTypes;
		vm.radioChanged = radioChanged;
		vm.isCurrentTag = isCurrentTag;
		vm.deleteFromUpload = deleteFromUpload;

		vm.loadLargeUploadList = loadLargeUploadList;

		vm.translate = function (text) {
			return $translate.instant(text);
		}


		//////////

		if (!isTiny) {
			var siteID = requestContext.getParam("siteId");
			var section = requestContext.getParam("section");
			init();
		} else {
			vm.section = section;
			initTiny();
		}
		/**
		 * Initialize
		 */
		function init() {

			var siteID = requestContext.getParam("siteId");
			$scope.siteID = siteID;

			vm.loading = true;

			vm.isAdmin = sessionService.user.is_admin;

			// for (var i = 0; i < vm.currentThread.Thumbnail.length; i++) {
			// 	vm.selectedContacts.push(vm.currentThread.Thumbnail[i]);
			// }

			var options = {
				section: section,
				media_type: vm.media_type,
				page: vm.defaultPage,
				perPage: vm.defaultPerPage,

			};
			
			getData(options);

			sessionService.loadDomainResourceSettings($scope.siteID).then(function(response){
				if(response.public){
					var publicConfig = angular.fromJson(response.public);
					if(publicConfig.uploadRepeatCheck){
					  vm.checkRepeatedFiles = publicConfig.uploadRepeatCheck;
					}
				}
            });

			if (sessionService.site_operative.mediaUploadDialogSettings &&
				sessionService.site_operative.mediaUploadDialogSettings.tabs &&
				sessionService.site_operative.mediaUploadDialogSettings.tabs.tags
			) {
				vm.tagsTabSettings = sessionService.site_operative.mediaUploadDialogSettings.tabs.tags;
				setTagTypes();
				preselectTags();
			}
		}



		/**
		 * attachHiddenTags
		 **/
		function attachHiddenTags() {
			if (vm.tagsTabSettings) {
				// Get hidden tags settings
				let hiddenTagsTabSettings = vm.tagsTabSettings.filter(function(tagsTabSetting){
					return tagsTabSetting.field_type == 'hidden';
				})
				angular.forEach(hiddenTagsTabSettings, function(hiddenTagsTabSetting){
					angular.forEach(hiddenTagsTabSetting.tags_types, function(hiddenTagType){
						let hiddenTags = vm.tags.filter(function(tag) {return tag.id_type == hiddenTagType});
						angular.forEach(hiddenTags, function(hiddenTag){
							if (hiddenTagsTabSetting.requires_parent_attached) {
								// Check for the optional, boolean condition 'requires_parent_attached' to attach a hidden tag
								// only if its parent tag was attached too.
								// E.g. the 'Unmatched' tag needs to be attached if its parent tag 'is profile?' was attached.
								// This is because the 'Unmatched' tag is used in AI > Match Profile to filter for profile images
								// that have not been assigned with a Number tag. However if the uploaded image is NOT a profile image,
								// then it doesn't require the 'Unmatched' tag neither.
								let hasParentAttached = vm.currentTags.find(function(currentTag){
									return currentTag.id_tag == hiddenTag.id_parent
								})
								if (hasParentAttached) {
									vm.currentTags.push(hiddenTag)
								}
							} else {
								vm.currentTags.push(hiddenTag)
							}
						})
					})
				})
			}
		}

		/**
		 * Initialize Tinymce
		 */
		function initTiny() {
			vm.currentViewTiny = vm.defaultViewTiny;
			vm.showSearchAndPaginator = false;
			vm.loading = true;
			for (var i = 0; i < vm.currentThread.length; i++) {
				if (vm.mediazone) {
					if (vm.currentThread[i].id_zone == 1) {
						vm.selectedContacts.push(vm.currentThread[i]);
					}
				} else {
					vm.selectedContacts.push(vm.currentThread[i]);
				}
			}
			if (vm.section.mediaSort) {
				var currentSort = 0;
				var currentItem = '';
				for (var i = 0; i < vm.currentThread.length; i++) {
					if (vm.mediazone) {
						if (vm.currentThread[i]['id_zone'] == 1 && (vm.currentThread[i]['media_type'] == vm.section.mediaType)) {
							currentSort++;
							if (currentSort = vm.section.mediaSort) {
								currentItem = vm.currentThread[i];
							}
						}
					} else {
						if (vm.currentThread[i]['media_type'] == vm.section.mediaType) {
							currentSort++;
							if (currentSort = vm.section.mediaSort) {
								currentItem = vm.currentThread[i];
							}
						}

					}
				}

				vm.selectedMediaTiny = currentItem;
				vm.tinyProperties.mediaSort = vm.section.mediaSort;
				vm.tinyProperties.mediaType = currentItem.media_type;
				vm.tinyProperties.align = vm.section.mediaAlign;
				vm.tinyProperties.size = vm.section.mediaSize;
				vm.changeViewTiny('properties');


			}
			vm.loading = false;

		}

		function pagination_search(searchString) {
			var options = {
				section: section,
				media_type: vm.media_type,
				page: vm.defaultPage,
				perPage: vm.defaultPerPage,
				searchString: searchString
			};
			getData(options);
		}

		function getData(options) {

			vm.loading = true;
			vm.items = [];
			$log.info("get data");

			// Scroll to the top Dialog
			scrollToTopOfDialog();

			mediaService.get({
				siteID: siteID,
				page: options.page,
				paginate: options.perPage,
				media_type: options.media_type,
				withCropStatus: true,
				withMediaChildren: true,
				sortField: 'date_uploaded',
				searchStringFilter: options.searchString,

			})
				.then(function (response) {
					vm.totalItems = response.total;
					vm.pagination_totalItems = response.total;
					vm.from = response.from;
					vm.pagination_from = response.from;
					vm.to = response.to;
					vm.pagination_to = response.to;
					vm.currentPage = response.current_page;
					vm.lastPage = response.last_page;
					vm.maxSize = 500;
					vm.bigTotalItems = 175;

					vm.loading = false;

					vm.items = [];
					angular.forEach(response.data, function (item) {
						vm.items.push(item);
					})

					$('.md-button')
						.removeClass('active');
					$('[type=' + options.media_type + ']')
						.addClass('active');

				});

			vm.firstLoad = false;
		}

		function search(options) {
			/*

			vm.loading 		= true;
			vm.items		=[];
			// Scroll to the top Dialog
			scrollToTopOfDialog();

			mediaService.get({
				siteID: siteID,
				page: options.page,
				paginate: options.perPage,
				media_type: options.media_type,
				withCropStatus: true,
				sortField: 'date_uploaded',
				searchStringFilter: options.searchString,

			})
				.then(function (response) {
					vm.totalItems = response.total;
					vm.pagination_totalItems = response.total;
					vm.from = response.from;
					vm.pagination_from = response.from;
					vm.to = response.to;
					vm.pagination_to = response.to;
					vm.currentPage = response.current_page;
					vm.lastPage = response.last_page;
					vm.maxSize = 500;
					vm.bigTotalItems = 175;

					vm.loading = false;

					vm.items = angular.copy(response.data);

					$('.md-button')
						.removeClass('active');
					$('[type=' + options.media_type + ']')
						.addClass('active');

				});




			vm.firstLoad = false;
*/
		}

		function closeDialog(success) {
			// delete from media_files if upload not terminated.
			if (vm.uploadedFiles.length == 0) {
				$mdDialog.hide(vm.currentThread);
			} else if(vm.uploadedFiles.length != vm.uploadFiles.length){
				var messageConfirm = $translate.instant('MEDIA.UPLOADING_MEDIA_CLOSE_CONFIRM');
				var confirm = $mdDialog.confirm().multiple(true).title(messageConfirm)
					// .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' will be deleted.')
					.ariaLabel('Close dialog').ok('OK').cancel('CANCEL');

				$mdDialog.show(confirm)
					.then(function () {
						var deleteIds = [];
						for (var i = 0; i < vm.uploadedFiles.length; i++) {
							deleteIds.push(vm.uploadedFiles[i].id_media);
						}
						if (deleteIds.length > 0) {
							var options = {
								site: siteID,
								id_media: deleteIds,
								force: true
							};
							mediaService.massDelete(options);
						}
						$mdDialog.hide(vm.currentThread);
					}, function () {

					})
			}
			if(!success){
				$mdDialog.hide({
					action: 'delete',
					items: vm.uploadedFiles
				});
			}else{
				$mdDialog.hide({
					replaced: vm.repeatedFilesArray
				});
			}
		}

		function changeView(view) {
			if (vm.views[view]) {
				vm.items = [];
				vm.loadingView = true;
				vm.showSearchAndPaginator = false;
				vm.defaultView = view;
				vm.currentView = view;


				vm.media_type = view;

				var options = {
					page: 1,
					perPage: vm.PerPage,
					media_type: view,

				};
				if (view == 1 || view == 2 || view == 3 || view == 4) {
					vm.showSearchAndPaginator = true;
				}
				getData(options);

			}

		}

		function changeViewTiny(view) {

			if (vm.viewsTiny[view]) {
				vm.items = [];
				vm.loadingView = true;
				vm.showSearchAndPaginator = false;
				vm.defaultViewTiny = view;
				vm.currentViewTiny = view;
				/*
								vm.media_type=view;

								var options = {
									page: 1,
									perPage: vm.PerPage,
									media_type: view,

								};
								if (view == 1 || view == 2 || view == 3 || view == 4) {
									vm.showSearchAndPaginator	= true;
								}
								//
								getData(options);
				*/
			}
		}

		$scope.$watch('vm.files', function () {
			if (vm.files.name && vm.isReplace) {
				var ext1 = vm.files.name.split('.')[1];
				var ext2 = vm.item.filename.split('.')[1];
				if (ext1.toLowerCase() !== ext2.toLowerCase()) {
					var message = $translate.instant('FORMS.ERROR_DIF_EXTENSION');
					$mdToast.show({
						template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg">' + message + '</div></md-toast>',
						hideDelay: 2000,
						position: 'top',
						parent: '#login-form-wrapper'
					});
					return;
				}
			}
			angular.forEach(vm.files, function (f) {
				vm.uploadFiles.push(f);
			});
			$scope.formUpload = false;
			if(vm.files.length && !vm.isReplace){
				var filesFileNames = vm.files.map(x=>{
					return x.name;
				});
				var options = {
					domain: siteID,
					fileNames: filesFileNames
				}
				vm.repeatedUploadObjects = [];
				mediaService.getExistingMedia(options).then(function(response){
					if(response.length && vm.checkRepeatedFiles){
						for(var i=0; i<vm.files.length; i++){
							var repeated = response.filter(x => {
								let responseFileName = getFileNameWithoutExtension(x.filename);
								let vmFileName = getFileNameWithoutExtension(vm.files[i].name);
								return responseFileName === vmFileName;
							});
							if(repeated.length){
								var locals = {
									uploadFile: vm.files[i],
									repeatedFiles: repeated
								}
								vm.repeatedUploadObjects.push(locals);
							}else{
								$scope.errorMsg = null;
								(function (f) {
									vm.upload(f, true);
								})(vm.files[i]);
							}
							if(i+1 == vm.files.length){
								showRepeatedDialog();
							}
						}
					}else{
						if (vm.files != null) {
							// make files array for not multiple to be able to be used in ng-repeat in the ui
							if (!angular.isArray(vm.files)) {
								$timeout(function () {
									$scope.files = vm.files = [vm.files];
								});
								return;
							}
							for (var i = 0; i < vm.files.length; i++) {
								$scope.errorMsg = null;
								(function (f) {
									vm.upload(f, true);
								})(vm.files[i]);
							}
						}
					}
				});
			}else if(vm.isReplace){
				if (vm.files != null) {
					// make files array for not multiple to be able to be used in ng-repeat in the ui
					if (!angular.isArray(vm.files)) {
						$timeout(function () {
							$scope.files = vm.files = [vm.files];
						});
						return;
					}
					for (var i = 0; i < vm.files.length; i++) {
						$scope.errorMsg = null;
						(function (f) {
							vm.upload(f, true);
						})(vm.files[i]);
					}
				}
			}
		});

		function getFileNameWithoutExtension(filename) {
			return filename.substring(0, filename.lastIndexOf('.')).toLowerCase();
		}

		function showRepeatedDialog(multipleRepeated){
			var locals = vm.repeatedUploadObjects[0];
			if(vm.repeatedRemember && !multipleRepeated){
				switch(vm.repeatedRemember){
					case 'delete':
						vm.uploadFiles = vm.uploadFiles.filter(x => x.name != locals.uploadFile.name);
					break;
					case 'maintain':
						$scope.errorMsg = null;
						vm.upload(locals.uploadFile, true);
					break;
					case 'replace':
						if(locals.repeatedFiles.length > 1){
							showRepeatedDialog(vm.repeatedRemember);
						}else{
							$scope.errorMsg = null;
							vm.upload(locals.uploadFile, true, locals.repeatedFiles[0]);
						}
					break;
				}
				vm.repeatedUploadObjects.shift();
				if(vm.repeatedUploadObjects.length){
					showRepeatedDialog();
				}else{
					vm.repeatedRemember = false;
				}
			}else{
				$mdDialog.show({
					controller: 'RepeatedUploadFilesController',
					controllerAs: 'vm',
					locals: locals,
					templateUrl: 'app/main/apps/media/dialogs/media/repeated-upload-files.html',
					parent: angular.element($document.body),
					multiple: true,
					clickOutsideToClose: false
				}).then(function (resp) {
					switch(resp.action){
						case 'delete':
							vm.uploadFiles = vm.uploadFiles.filter(x => x.name != resp.file.name);
						break;
						case 'maintain':
							$scope.errorMsg = null;
							vm.upload(resp.file, true);
						break;
						case 'replace':
							$scope.errorMsg = null;
							vm.upload(resp.file, true, resp.repeatedFiles);
						break;
					}
					if(resp.remember){
						vm.repeatedRemember = resp.action;
					}
					if(multipleRepeated){
						vm.repeatedRemember = multipleRepeated;
					}
					vm.repeatedUploadObjects.shift();
					if(vm.repeatedUploadObjects.length){
						showRepeatedDialog();
					}else{
						vm.repeatedRemember = false;
					}
				});
			}
		}

		$scope.$watch('vm.import_field', function () {
			vm.importConfirm(false);
		});

		$scope.log = '';


		function upload(file, old, repeatFile) {
			if (!file.$error) {
				file.processed = false;
				var uploadOptions = {
					siteID: siteID,
					isReplace: vm.isReplace,
					item: vm.item,
					uploadedFiles: vm.uploadedFiles,
					filename: file.name.replaceAll('(', '').replaceAll(')', ''),
					fileSizeKb: (angular.isDefined(file.size)) ? (parseInt(file.size) / 1000).toFixed(2) : null,
					id_media: vm.isReplace ? vm.item.id_media : null,
					log: $scope.log,
					type: 'media'
				}
				if(repeatFile){
					uploadOptions.isReplace = true;
					uploadOptions.item = repeatFile;
					uploadOptions.id_media = repeatFile.id_media;
				}
				console.debug("UPLOAD______****", file)
				uploadService.upload(file, uploadOptions).then(function (resp) {
					$scope.log = file.log;
					vm.uploadedFiles.push(file);
					var galleriesAssignedIds = getAssignedGalleriesIds(vm.CleanMediaGalleries, []);
					if (angular.isArray(galleriesAssignedIds) && galleriesAssignedIds.length) {
						var options = {
							site: siteID,
							data: {
								id_media: [file.id_media],
								id_gallery: galleriesAssignedIds
							}
						};
						mediaService.insertIntoGallery(options).then(function(response){
							vm.selectedContacts.push(file)
							loadAndAttachMedia(file);
						})
					} else {
						loadAndAttachMedia(file);
					}
					if(vm.isReplace || repeatFile){
						vm.repeatedFilesArray.push(file.id_media);
					}
				});
			}
		};

		function showErrorDialog(message) {
			$mdToast.show({
				template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
				hideDelay: 5000,
				position: 'top',
				parent: '#content-container'
			});
		}

		function loadAndAttachMedia(file) {
			//						console.debug("LOAD_MEDIA_FROM_DB______****", file)
			mediaService.get({
				siteID: siteID,
				withCropStatus: true,
				idMedia: file.id_media
			})
				.then(function (response) {
					//if (response.total == 1) {
						var photo = response.data[0];
						toggleSelectContact(photo);
					//}
				});
		}

		vm.importConfirm = function (confirm) {
			vm.import_disabled = false;
			vm.imported = false;
			if (!confirm) {
				vm.importPreview = false;
			}
			if (vm.import_field.length > 10) {
				vm.importing = true;
				vm.import_disabled = true;

				$timeout(function () {
					var pastedUrl = vm.import_field;
					mediaService.importFromUrl({
						siteID: siteID,
						url: pastedUrl,
						execute: confirm
					})
						.then(function (response) {
							vm.importing = false;
							response.embedCodeSafe = $sce.trustAsHtml(response.metadata.embedCode);
							response.caption = response.metadata.caption;
							response.title = response.metadata.title;
							if (response.id_media) {
								// Attach media to selected gallery
								// For qiu-restricted users with limited gallery access we need to attach media
								// to the users root gallery before loading the media again from api,
								// otherwise the api won't return the media due to qiu restrictions.
								var galleriesAssignedIds = getAssignedGalleriesIds(vm.CleanMediaGalleries, []);
								if (angular.isArray(galleriesAssignedIds) && galleriesAssignedIds.length) {
									var options = {
										site: siteID,
										data: {
											id_media: [response.id_media],
											id_gallery: galleriesAssignedIds
										}
									};
									mediaService.insertIntoGallery(options).then(function(resp){
										vm.imported = true;
										vm.importPreview = false;
										mediaService.get({
											siteID: siteID,
											withCropStatus: true,
											idMedia: response.id_media
										}).then(function (response) {
											if (response.total == 1) {
												var photo = response.data[0];
												vm.importedFiles.push(photo);
												toggleSelectContact(photo);
											}
										});
									})
								} else {
									vm.imported = true;
									vm.importPreview = false;
									mediaService.get({
										siteID: siteID,
										withCropStatus: true,
										idMedia: response.id_media
									}).then(function (response) {
										if (response.total == 1) {
											var photo = response.data[0];
											vm.importedFiles.push(photo);
											toggleSelectContact(photo);
										}
									});
								}
							} else {
								vm.importPreview = response;
							}
							vm.import_disabled = false;
						});
				})
			}
		}

		function nextPage() {

			var options = {
				page: vm.currentPage + 1,
				perPage: vm.PerPage,
				media_type: vm.media_type,

			};
			getData(options);

		}

		function prevPage() {
			var options = {
				page: vm.currentPage - 1,
				perPage: vm.PerPage,
				media_type: vm.media_type,
			};
			getData(options);
		}

		function morePages() {
			if (vm.currentPage <= vm.lastPage) return true;
			return false;
		}

		function firstPage() {
			if (vm.currentPage == 1) return true;
			return false;
		}


		function gotoPage(i) {

			var options = {
				page: i,
				perPage: vm.PerPage,
				media_type: vm.media_type,
				searchString: vm.modelSearch
			};
			getData(options);
		}

		function alreadySelectedbyZone(array, item) {
			var ret = false;
			for (var i = 0, len = array.length; i < len; i++) {
				if (vm.mediazone) {
					if (array[i]['id_media'] === item.id_media && array[i]['id_zone'] === vm.mediazone.id_zone) {
						ret = true;
					}
				} else {
					if (array[i]['id_media'] === item.id_media) {
						ret = true;
					}

				}
			}

			return ret;
		}


		function toggleSelectedbyZone(item) {
			for (var i = 0; vm.selectedContacts.length < i; i++) {
				if (vm.mediazone && vm.selectedContacts[i]['id_media'] === item.id_media && vm.selectedContacts[i]['id_zone'] === vm.mediazone.id_zone) {
					vm.selectedContacts.splice(i, 1);
					return;
				}
			}
			if(vm.selectedContacts.indexOf(item) == -1){
				vm.selectedContacts.push(item);
			}
			return;
		}

		function selectMediaTiny(item) {
			var currentSort = 0;
			var mediaSort = 0;
			for (var i = 0; i < vm.currentThread.length; i++) {
				if (vm.mediazone) {
					if (vm.currentThread[i]['id_zone'] == 1 && (vm.currentThread[i]['media_type'] == item.media_type)) {
						currentSort++;
						if (item.id_media == vm.currentThread[i]['id_media']) {
							mediaSort = currentSort;
						}
					}
				} else {
					currentSort++;
					if (item.id_media == vm.currentThread[i]['id_media']) {
						mediaSort = currentSort;
					}
				}
			}

			vm.selectedMediaTiny = item;
			vm.tinyProperties.mediaSort = mediaSort;
			vm.tinyProperties.mediaType = item.media_type;
			vm.changeViewTiny('properties');
		}

		function deleteFromUpload(file){
			var newUploadFiles = vm.uploadFiles.filter(x => x.id_media != file.id_media);
			vm.uploadFiles = newUploadFiles;
			var newUploadedFiles = vm.uploadedFiles.filter(x => x.id_media != file.id_media);
			vm.uploadedFiles = newUploadedFiles;
			var newSelectedContacts = vm.selectedContacts.filter(x => x.id_media != file.id_media);
			vm.selectedContacts = newSelectedContacts;
			mediaService.massDelete({site: siteID, id_media:[file.id_media], foce:true});
		}

		function attachMedia() {
			var continueAttach = false;
			if (vm.uploadedFiles.length == vm.uploadFiles.length) {
				continueAttach = true;
			} else {
				var messageConfirm = $translate.instant('MEDIA.UPLOADING_MEDIA_CLOSE_CONFIRM');
				var confirm = $mdDialog.confirm().multiple(true).title(messageConfirm)
					// .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' will be deleted.')
					.ariaLabel('Close dialog').ok('OK').cancel('CANCEL');

				$mdDialog.show(confirm)
					.then(function () {
						var deleteIds = [];
						for (var i = 0; i < vm.uploadFiles.length; i++) {
							var isFileUploaded = vm.uploadedFiles.some(function (el) {
								return el.id_media == vm.uploadFiles[i].id_media
							});
							if (!isFileUploaded) {
								deleteIds.push(vm.uploadFiles[i].id_media);
							}
						}
						if (deleteIds.length > 0) {
							var options = {
								site: siteID,
								id_media: deleteIds,
								force: true
							};
							mediaService.massDelete(options);
						}
						continueAttach = true;
					}, function () {

					})
			}

			if (!continueAttach) {
				return false;
			}
			var mediaIDs = [];
			for (var i = 0; i < vm.selectedContacts.length; i++) {
				if (!mediaIDs.includes(vm.selectedContacts[i].id_media)) {
					mediaIDs.push(vm.selectedContacts[i].id_media);
				}
			}
			if (mediaIDs.length == 0) {
				// TODO: show alert
				if(vm.uploadedFiles.length > 0){
					vm.selectedContacts = vm.uploadedFiles;
					for (var i = 0; i < vm.selectedContacts.length; i++) {
						mediaIDs.push(vm.selectedContacts[i].id_media);
					}
				}else{
					console.log('No ID medias');
					return false;
				}
			}

			var uploadedFilesIDs = [];

			var message = (mediaIDs.length > 1) ? $translate.instant('MEDIA.ITEMS_UPLOADED_PLURAL') : $translate.instant('MEDIA.ITEMS_UPLOADED_SINGULAR');
			var fields = {};
			angular.forEach(vm.fields, function (value, key) {
				if (!_.isNull(value) && value != 0) {
					this[key] = value;
				}
			}, fields);
			var galleriesAssigned = getAssignedGalleries(vm.CleanMediaGalleries, []);
			if(vm.uploadedFiles.length > 0){
				vm.uploadedFiles.forEach(element => {
					uploadedFilesIDs.push(element.id_media);
				});
				var batchOptions = {
					siteID: siteID,
					id_medias: uploadedFilesIDs,
					fields: vm.fields,
					tags: vm.currentTags,
					id_galleries: []
				}
				galleriesAssigned.forEach(gallery => {
					batchOptions.id_galleries.push(gallery.id);
				});
				mediaService.finishedUploadingBatchToCdn(batchOptions).then(function(response){
				}).catch(function(error){
					console.log('error', error);
					vm.isAttaching = false;
				});
			}
			if (_.isEmpty(fields) && _.isEmpty(vm.currentTags) && galleriesAssigned.length == 0) {
				vm.reload = true;
				$mdToast.show({
					template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + mediaIDs.length + message + '</span></div></md-toast>',
					hideDelay: 5000,
					position: 'top',
					parent: '#content-container'
				});
				vm.closeDialog(true);
				return false;
			}

			vm.isAttaching = true;
			// Initial promise

			var sequence = $q.defer();
			sequence.resolve();
			sequence = sequence.promise;

			if (galleriesAssigned.length > 0) {

				var inserts = [];
				var mismatches = {};

				angular.forEach(galleriesAssigned, function (gallery) {

					var galleryTypeId = gallery.gallery_type;
					var validMediaIds = [];

					angular.forEach(vm.uploadedFiles, function (file) {
						var fileTypeId = msUtils.getFileTypeId(file.type);
						if (galleryTypeId == 0) {
							validMediaIds.push(file.id_media);
						} else if (galleryTypeId != 0 && fileTypeId && galleryTypeId == fileTypeId) {
							validMediaIds.push(file.id_media);
						} else {
							if (!angular.isArray(mismatches[file.name])) {
								mismatches[file.name] = [];
							}
							if (gallery.gallery_type != 0){
								mismatches[file.name].push(gallery.gallery_name + ' (' + msUtils.getGalleryTypeById(gallery.gallery_type) + ')');
							}
						}
					});
					if (validMediaIds.length > 0) {
						inserts.push({ id_gallery: [gallery.id_gallery], media_ids: validMediaIds });
					}
				});
				if (!_.isEmpty(mismatches)) {
					sequence = sequence.then(function () {
						console.log("seq 1 - confirm mismatch");
						var confirm = $mdDialog.confirm()
							.title($translate.instant('MEDIA.MISMATCH_DIALOG.TITLE'))
							.textContent($translate.instant('MEDIA.MISMATCH_DIALOG.CONTENT'))
							.ariaLabel($translate.instant('MEDIA.MISMATCH_DIALOG.LABEL'))
							.ok($translate.instant('MEDIA.MISMATCH_DIALOG.OK'))
							.cancel($translate.instant('MEDIA.MISMATCH_DIALOG.CANCEL'))
							.multiple(true);
						return $mdDialog.show(confirm);
					})
				}

				angular.forEach(inserts, function (insert) {
					sequence = sequence.then(function () {
						console.log('seq 1 - continue mismatch approved')
						var options = {
							site: siteID,
							data: {
								id_media: insert.media_ids,
								id_gallery: insert.id_gallery
							}
						};
						return mediaService.insertIntoGallery(options);
					});
				}, function () {
					console.log('seq 1 - continue mismatch rejected')
					vm.isAttaching = false;
					return Promise.reject();
				});
			}

			if (!_.isEmpty(fields) || !_.isEmpty(vm.currentTags)) {
				attachHiddenTags();
				sequence = sequence.then(function () {
					var options = {
						site: siteID,
						data: {
							id_media: mediaIDs,
							fields: fields,
							tags: vm.currentTags
							// fields: {
							//  geoLat: vm.fields.geoLat,
							//  geoLon: vm.fields.geoLon
							// }
						}
					};
					return mediaService.massUpdate(options);
				}, function () {
					console.log('seq 2 - reject')
					vm.isAttaching = false;
					return Promise.reject();
				});
			}

			sequence = sequence.then(function () {
				console.log("seq 4 - close dialog");
				vm.isAttaching = false;
				vm.reload = true;
				$mdToast.show({
					template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + mediaIDs.length + message + '</span></div></md-toast>',
					hideDelay: 5000,
					position: 'top',
					parent: '#content-container'
				});
				return vm.closeDialog(vm.selectedContacts);
			}, function () {
				console.log('seq 4 - reject')
				vm.isAttaching = false;
			});
		}

		function attachMediaTiny() {
			$mdDialog.hide(vm.tinyProperties);
		}

		function getAssignedGalleries(galleries, result) {

			angular.forEach(galleries, function (gallery) {
				if (gallery.assigned_gallery == true) {
					result.push(gallery);
				}
				if (typeof gallery.children !== 'undefined' && gallery.children.length > 0) {
					getAssignedGalleries(gallery.children, result);
				}
			});
			return result;
		}

		function getAssignedGalleriesIds(galleries, result) {
			angular.forEach(galleries, function(gallery) {
				if (gallery.assigned_gallery == true && !gallery.no_files_allowed) {
					result.push(gallery.id_gallery);
				}
				if (typeof gallery.children !== 'undefined' && gallery.children.length >0) {
					getAssignedGalleriesIds(gallery.children, result);
				}
			});
			return result;
		}

		vm.isImage = function (f) {
			return f.type.startsWith("image");
		}

		vm.isVideo = function (f) {
			return f.type.startsWith("video");
		}

		function selectedItemChange() {
			vm.searchTagText = '';
			vm.selectedTag = null;
		}

		/**
		* Add label chips
		*
		* @param query
		* @returns {filterFn}
		*/
		function labelQuerySearch(query, tagTypeIds) {
			var response = [];
			if (query) {
				response =  vm.tags.filter(vm.createFilterFor(query))
			}
			if (tagTypeIds) {
				response = response.filter(function(tag){
					return tagTypeIds.includes(tag.id_type);
				});
			}

			return response;
		}

		function radioOptionsFilter(tags, tagTypeIds) {
			return tags.filter(function(tag){
				return tagTypeIds.includes(tag.id_type);
			});
		}

		function radioChanged(activeTag, tagTypeIds) {
			// vm.currentTags may hold tags of types that are not included in this radio group,
			// for example tags that are added by a different radio or checkbox group.
			// Don't remove those tags!
			vm.currentTags = vm.currentTags.filter(function(tag) {
				let resp = tagTypeIds.includes(tag.id_type)
				return !resp;
			})

			// Finally add the selected tag
			vm.currentTags.push(activeTag[0]);
		}

		function checkboxesFilter(tags, tagTypeIds) {
			return tags.filter(function(tag){
				return tagTypeIds.includes(tag.id_type);
			});
		}

		function radioGroupTitleByTagTypes(tagTypeIds) {
			if (vm.tagsTypes) {
				return vm.tagsTypes
					.filter(function(tagType){return tagTypeIds.includes(tagType.id_type)})
					.map(function(tagType){return tagType.name})
					.join(" OR ");
			}
			return '';
		}

		function checkboxGroupTitleByTagTypes(tagTypeIds) {
			if (vm.tagsTypes) {
				return vm.tagsTypes
					.filter(function(tagType){return tagTypeIds.includes(tagType.id_type)})
					.map(function(tagType){return tagType.name})
					.join(" & ");
			}
			return '';
		}

		function setTagTypes() {
			var options = {
				siteID: siteID
			}
			tagsService.getTagsTypes(options).then(function(response) {
				vm.tagsTypes = response;
			})
		}
/*
		function setCheckboxesGroupByType(items) {

			var options = {
				siteID: siteID
			}
			return tagsService.getTagsTypes(options).then(function(response) {
				vm.tagsTypes = response;
				if (vm.tagsTabSettings) {
					angular.forEach(vm.tagsTabSettings, function(tagsTabSetting) {
						// Tag-type filter
						if (tagsTabSetting.tags_types && tagsTabSetting.field_type != 'hidden') {
							angular.forEach(tagsTabSetting.tags_types, function(typeId) {
								var tagType = vm.tagsTypes.find(function(tagsType) {
									return tagsType.id_type == typeId;
								})
								var item = {
									type: tagType
								}
								item.tags = items.filter(function(tag){
									return tag.id_type == typeId;
								});
								vm.checkboxesGroupedByType.push(item)
							})
						}
					})
				}
			})
		}
*/
		function preselectTags() {
			if (vm.tags && vm.preselectedTags && angular.isArray(vm.preselectedTags) && vm.preselectedTags.length > 0) {
				angular.forEach(vm.preselectedTags, function(pres) {
					let tag = vm.tags.find(function(tag) {return tag.id_tag == pres.id_tag})
					if (tag) {
						vm.currentTags.push(tag);
					}
				})
			}
		}

		function isCurrentTag(tag) {
			return vm.currentTags.includes(tag);
		}

		function updateCurrentTags(tag, ev) {
			if (vm.currentTags.includes(tag)) {
				vm.currentTags.splice(vm.currentTags.indexOf(tag), 1);
			} else {
				vm.currentTags.push(tag);
			}
		}

		function newTag(tagName) {

			if (vm.newTagDisabled) {
				return false;
			}
			vm.newTagDisabled = true;

			var newTag = {
				tag_name: tagName
			};
			var options = {
				site: siteID,
				item: newTag
			};
			tagsService.saveItem(options).then(function (response) {
				newTag.id_tag = response.id_tag
				vm.tags.push(newTag);
				vm.currentTags.push(newTag);
				vm.searchTagText = '';
				vm.newTagDisabled = false;
			});
		}

		/**
		 * Filter for chips
		 *
		 * @param query
		 * @returns {filterFn}
		 */
		function createFilterFor(query) {
			var lowercaseQuery = angular.lowercase(query);
			return function filterFn(item) {
				if (angular.isUndefined(item.tag_name)) {
					return false;
				}
				if (!item.tag_name) {
					return false;
				}
				if (!angular.lowercase(item.tag_name.toString()).indexOf) {
					return false;
				}
				return angular.lowercase(item.tag_name.toString()).indexOf(lowercaseQuery) >= 0;
			};
		}

		function getpos(event) {
			vm.fields.geoLat = event.latLng.lat();
			vm.fields.geoLon = event.latLng.lng();
			vm.latlng = [event.latLng.lat(), event.latLng.lng()];
		}

		function placeMarker() {
			var loc = this.getPlace()
				.geometry.location;
			vm.latlng = [loc.lat(), loc.lng()];
			vm.fields.geoLat = loc.lat();
			vm.fields.geoLon = loc.lng();
			vm.center = [loc.lat(), loc.lng()];
		}

		function searchLatLon() {
			vm.latlng = [vm.fields.geoLat, vm.fields.geoLon];
			vm.center = [vm.fields.geoLat, vm.fields.geoLon];
			vm.center = [40.74, -74.18];
		}

		/**
		 * Toggle selected status of the contact
		 *
		 * @param contact
		 * @param event
		 */

		function toggleSelectContact(photo, event) {
			if (event) {
				event.stopPropagation();
			}


			//		 else{
			if (vm.mediazone) {
				photo.id_zone = vm.mediazone.id_zone;
				photo.zone_name = vm.mediazone.zone_name;
			} else {
				photo.id_zone = null;
				photo.zone_name = null;
			}

			toggleSelectedbyZone(photo);
			// if(vm.alreadySelectedbyZone(vm.selectedContacts, photo)){
			// vm.selectedContacts.splice(vm.selectedContacts.indexOf(photo.id_media), 1);
			//		 }else{
			//		 	vm.selectedContacts.push(photo);
			//		 }
			// }

			// if ( vm.selectedContacts.indexOf(photo.id_media) > -1 )
			// {
			//	 vm.selectedContacts.splice(vm.selectedContacts.indexOf(photo.id_media), 1);
			// }
			// else
			// {
			//	 vm.selectedContacts.push(photo.id_media);
			// }
		}

		/**
		 * Scroll Media Dialog Content to the top
		 * @param speed
		 */
		function scrollToTopOfDialog() {
			$timeout(function () {
				var dialogContent = $document.find('md-dialog-content').filter(function () {
					return angular.element(this).hasClass('mediadialog-content');
				});
				if (angular.isDefined(dialogContent) && dialogContent.length) {
					dialogContent.animate({
						scrollTop: dialogContent[0].scrollHeight
					}, 1);
				}
			}, 0);

		}

		function loadLargeUploadList() {
			if(vm.showLargeUploadList == false){
				vm.showLargeUploadList = true;
			}else{
				vm.showLargeUploadList = false;
			}
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('app.media')
		.controller('AddMediaDialogController', AddMediaDialogController);

	/** @ngInject */
	function AddMediaDialogController(
		$mdDialog,
		$document,
		currentThread,
		mediaService,
		uploadService,
		requestContext,
		isReplace,
		item,
		$timeout,
		$scope,
		$sce,
		mediazone,
		section,
		msUtils,
		isTiny,
		$translate,
		CleanMediaGalleries,
		sessionService,
		$mdToast,
		tagsService,
		$q,
		preselectedTags) {
		var vm = this;

		// Data
		vm.currentThread = currentThread;

		vm.mediazone = mediazone;
		vm.defaultPage = 1;
		vm.defaultPerPage = 50;
		vm.PerPage = 50;
		vm.searchStringFilter = '';
		vm.searchQuery = '';
		vm.modelSearch = '';
		vm.CleanMediaGalleries = angular.copy(CleanMediaGalleries);
		vm.isAttaching = false;
		vm.preselectedTags = preselectedTags;
		vm.showLargeUploadList = false;
		vm.repeatedFilesArray = [];

		vm.fields = {
			geoLat: null,
			geoLon: null,
			title: null,
			photographer: null,
			credits: null,
			owner: null,
			caption: null,
			city: null,
			country: null,
			uses: null,
			extras: null,
			rating: null,
		};

		vm.isTiny = isTiny;

		vm.views = {
			upload: 'app/main/dialogs/media/views/upload-view.html',
			import: 'app/main/dialogs/media/views/import-view.html',
		};
		vm.defaultView = 'upload';
		vm.currentView = 'upload';

		vm.viewsTiny = {
			1: 'app/main/dialogs/media/views/tiny-attached.html',
			properties: 'app/main/dialogs/media/views/tiny-properties.html',
			upload: 'app/main/dialogs/media/views/upload-view.html',
		};
		vm.defaultViewTiny = '1';
		vm.currentViewTiny = '1';

		vm.isReplace = isReplace;
		vm.item = item;


		vm.allowedFilesPattern = "video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz,.json,.xml,.csv,.ttf,.eps,.ai,.psd,.aep,.indd,.idll,.heic,.mkv,.gpx,.mxf";

		vm.firstLoad = true;
		vm.media_type = '1';
		vm.showSearchAndPaginator = true;
		vm.import_field = '';
		vm.import_disabled = '';
		vm.importedFiles = [];
		vm.importPreview = false;
		vm.imported = false;
		vm.importing = false;
		vm.selectedContacts = [];
		vm.files = [];
		vm.uploadFiles = [];
		vm.uploadedFiles = [];
		vm.tinyProperties = {
			mediaType: '',
			mediaSort: '',
			mediaData: {},
			align: '',
			size: ''
		};
		vm.tinyOptions = {
			size: [
				{ value: 25, text: '25%' },
				{ value: 50, text: '50%' },
				{ value: 75, text: '75%' },
				{ value: 100, text: '100%' }
			],
			align: [
				{ value: 'left', text: 'left' },
				{ value: 'center', text: 'center' },
				{ value: 'right', text: 'right' }
			]
		}
		vm.searchTagText = '';
		vm.tags = sessionService.site_operative.tags;
		vm.currentTags = [];
		vm.selectedTag = null;
		vm.image = {};
		vm.newTagDisabled = false;
		vm.tagsTabSettings = false;
		vm.checkboxesGroupedByType = [];

		vm.checkRepeatedFiles = false;

		vm.isAdmin = false;

		// Methods
		vm.closeDialog = closeDialog;
		vm.changeView = changeView;
		vm.changeViewTiny = changeViewTiny;

		vm.morePages = morePages;
		vm.firstPage = firstPage;
		vm.upload = upload;
		vm.attachMedia = attachMedia;
		vm.attachMediaTiny = attachMediaTiny;
		vm.selectMediaTiny = selectMediaTiny;
		vm.selectedMediaTiny = '';

		vm.exists = msUtils.exists;
		vm.alreadySelectedbyZone = alreadySelectedbyZone;
		vm.existInArray = msUtils.existInArray;
		vm.toggleSelectContact = toggleSelectContact;
		vm.selectedItemChange = selectedItemChange;
		vm.labelQuerySearch = labelQuerySearch;
		vm.createFilterFor = createFilterFor;
		vm.newTag = newTag;
		vm.getpos = getpos;
		vm.placeMarker = placeMarker;
		vm.searchLatLon = searchLatLon;
		vm.radioOptionsFilter = radioOptionsFilter;
		vm.checkboxesFilter = checkboxesFilter;
		vm.updateCurrentTags = updateCurrentTags;
		vm.checkboxGroupTitleByTagTypes = checkboxGroupTitleByTagTypes;
		vm.radioChanged = radioChanged;
		vm.isCurrentTag = isCurrentTag;
		vm.deleteFromUpload = deleteFromUpload;

		vm.loadLargeUploadList = loadLargeUploadList;

		vm.translate = function (text) {
			return $translate.instant(text);
		}


		//////////

		if (!isTiny) {
			var siteID = requestContext.getParam("siteId");
			var section = requestContext.getParam("section");
			init();
		} else {
			vm.section = section;
			initTiny();
		}
		/**
		 * Initialize
		 */
		function init() {

			var siteID = requestContext.getParam("siteId");
			$scope.siteID = siteID;

			vm.isAdmin = sessionService.user.is_admin;

			sessionService.loadDomainResourceSettings($scope.siteID).then(function(response){
				if(response.public){
					var publicConfig = angular.fromJson(response.public);
					if(publicConfig.uploadRepeatCheck){
					  vm.checkRepeatedFiles = publicConfig.uploadRepeatCheck;
					}
				}
            });

			if (sessionService.site_operative.mediaUploadDialogSettings &&
				sessionService.site_operative.mediaUploadDialogSettings.tabs &&
				sessionService.site_operative.mediaUploadDialogSettings.tabs.tags
			) {
				vm.tagsTabSettings = sessionService.site_operative.mediaUploadDialogSettings.tabs.tags;
				setTagTypes();
				preselectTags();
			}
		}



		/**
		 * attachHiddenTags
		 **/
		function attachHiddenTags() {
			if (vm.tagsTabSettings) {
				// Get hidden tags settings
				let hiddenTagsTabSettings = vm.tagsTabSettings.filter(function(tagsTabSetting){
					return tagsTabSetting.field_type == 'hidden';
				})
				angular.forEach(hiddenTagsTabSettings, function(hiddenTagsTabSetting){
					angular.forEach(hiddenTagsTabSetting.tags_types, function(hiddenTagType){
						let hiddenTags = vm.tags.filter(function(tag) {return tag.id_type == hiddenTagType});
						angular.forEach(hiddenTags, function(hiddenTag){
							if (hiddenTagsTabSetting.requires_parent_attached) {
								// Check for the optional, boolean condition 'requires_parent_attached' to attach a hidden tag
								// only if its parent tag was attached too.
								// E.g. the 'Unmatched' tag needs to be attached if its parent tag 'is profile?' was attached.
								// This is because the 'Unmatched' tag is used in AI > Match Profile to filter for profile images
								// that have not been assigned with a Number tag. However if the uploaded image is NOT a profile image,
								// then it doesn't require the 'Unmatched' tag neither.
								let hasParentAttached = vm.currentTags.find(function(currentTag){
									return currentTag.id_tag == hiddenTag.id_parent
								})
								if (hasParentAttached) {
									vm.currentTags.push(hiddenTag)
								}
							} else {
								vm.currentTags.push(hiddenTag)
							}
						})
					})
				})
			}
		}

		/**
		 * Initialize Tinymce
		 */
		function initTiny() {
			vm.currentViewTiny = vm.defaultViewTiny;
			vm.showSearchAndPaginator = false;
			vm.loading = true;
			for (var i = 0; i < vm.currentThread.length; i++) {
				if (vm.mediazone) {
					if (vm.currentThread[i].id_zone == 1) {
						vm.selectedContacts.push(vm.currentThread[i]);
					}
				} else {
					vm.selectedContacts.push(vm.currentThread[i]);
				}
			}
			if (vm.section.mediaSort) {
				var currentSort = 0;
				var currentItem = '';
				for (var i = 0; i < vm.currentThread.length; i++) {
					if (vm.mediazone) {
						if (vm.currentThread[i]['id_zone'] == 1 && (vm.currentThread[i]['media_type'] == vm.section.mediaType)) {
							currentSort++;
							if (currentSort = vm.section.mediaSort) {
								currentItem = vm.currentThread[i];
							}
						}
					} else {
						if (vm.currentThread[i]['media_type'] == vm.section.mediaType) {
							currentSort++;
							if (currentSort = vm.section.mediaSort) {
								currentItem = vm.currentThread[i];
							}
						}

					}
				}

				vm.selectedMediaTiny = currentItem;
				vm.tinyProperties.mediaSort = vm.section.mediaSort;
				vm.tinyProperties.mediaType = currentItem.media_type;
				vm.tinyProperties.align = vm.section.mediaAlign;
				vm.tinyProperties.size = vm.section.mediaSize;
				vm.changeViewTiny('properties');


			}
			vm.loading = false;

		}

		function closeDialog(success) {
			// delete from media_files if upload not terminated.
			if (vm.uploadFiles.length == 0 || vm.uploadedFiles.length == vm.uploadFiles.length) {
				if (!success) {
					$mdDialog.hide({
						action: 'delete',
						items: vm.uploadedFiles
					});
				} else {
					if (angular.isArray(success)) { // If success is the selected items array
						$mdDialog.hide(success);
					} else {
						$mdDialog.hide({
							replaced: vm.repeatedFilesArray
						});
					}
				}
			} else {
				$mdDialog.show({
					templateUrl: 'app/main/dialogs/media/views/confirm-upload-close.html',
					controller: function ($mdDialog) {
						var vm = this;
						vm.answer = function (answer) {
							$mdDialog.hide(answer);
						};
					},
					controllerAs: 'vm',
					multiple: true,
					clickOutsideToClose: false
				}).then(function (answer) {
					if (answer === 'stay') {
						return;
					}
					if (answer === 'abort') {
						// Abort all ongoing uploads
						angular.forEach(vm.uploadFiles, function (file) {
							if (file.upload && file.upload.abort) {
								file.upload.abort();
							}
							file.uploadStatus = 'aborted';
						});

						// Delete all files (finished or not)
						var deleteIds = vm.uploadFiles.map(function (f) {
							return f.id_media;
						}).filter(function (id) {
							return !!id;
						});
						if (deleteIds.length > 0) {
							var options = {
								site: requestContext.getParam("siteId"),
								id_media: deleteIds,
								force: true
							};
							mediaService.massDelete(options);
						}
						$mdDialog.hide(vm.currentThread);
					}
				});
			}
		}

		function changeView(view) {
			if (vm.views[view]) {
				vm.items = [];
				vm.loadingView = true;
				vm.showSearchAndPaginator = false;
				vm.defaultView = view;
				vm.currentView = view;


				vm.media_type = view;

				if (view == 1 || view == 2 || view == 3 || view == 4) {
					vm.showSearchAndPaginator = true;
				}
			}

		}

		function changeViewTiny(view) {
			if (vm.viewsTiny[view]) {
				vm.items = [];
				vm.loadingView = true;
				vm.showSearchAndPaginator = false;
				vm.defaultViewTiny = view;
				vm.currentViewTiny = view;
			}
		}

		$scope.$watch('vm.files', function () {
			if (vm.files.name && vm.isReplace) {
				var ext1 = vm.files.name.split('.')[1];
				var ext2 = vm.item.filename.split('.')[1];
				if (ext1.toLowerCase() !== ext2.toLowerCase()) {
					var message = $translate.instant('FORMS.ERROR_DIF_EXTENSION');
					$mdToast.show({
						template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg">' + message + '</div></md-toast>',
						hideDelay: 2000,
						position: 'top',
						parent: '#login-form-wrapper'
					});
					return;
				}
			}
			angular.forEach(vm.files, function (f) {
				vm.uploadFiles.push(f);
			});
			$scope.formUpload = false;
			if(vm.files.length && !vm.isReplace){
				var filesFileNames = vm.files.map(x=>{
					return x.name;
				});
				var options = {
					domain: siteID,
					fileNames: filesFileNames
				}
				vm.repeatedUploadObjects = [];
				mediaService.getExistingMedia(options).then(function(response){
					if(response.length && vm.checkRepeatedFiles){
						for(var i=0; i<vm.files.length; i++){
							var repeated = response.filter(x => {
								let responseFileName = getFileNameWithoutExtension(x.filename);
								let vmFileName = getFileNameWithoutExtension(vm.files[i].name);
								return responseFileName === vmFileName;
							});
							if(repeated.length){
								var locals = {
									uploadFile: vm.files[i],
									repeatedFiles: repeated
								}
								vm.repeatedUploadObjects.push(locals);
							}else{
								$scope.errorMsg = null;
								(function (f) {
									vm.upload(f, true);
								})(vm.files[i]);
							}
							if(i+1 == vm.files.length){
								showRepeatedDialog();
							}
						}
					}else{
						if (vm.files != null) {
							// make files array for not multiple to be able to be used in ng-repeat in the ui
							if (!angular.isArray(vm.files)) {
								$timeout(function () {
									$scope.files = vm.files = [vm.files];
								});
								return;
							}
							for (var i = 0; i < vm.files.length; i++) {
								$scope.errorMsg = null;
								(function (f) {
									vm.upload(f, true);
								})(vm.files[i]);
							}
						}
					}
				});
			}else if(vm.isReplace){
				if (vm.files != null) {
					// make files array for not multiple to be able to be used in ng-repeat in the ui
					if (!angular.isArray(vm.files)) {
						$timeout(function () {
							$scope.files = vm.files = [vm.files];
						});
						return;
					}
					for (var i = 0; i < vm.files.length; i++) {
						$scope.errorMsg = null;
						(function (f) {
							vm.upload(f, true);
						})(vm.files[i]);
					}
				}
			}
		});

		function getFileNameWithoutExtension(filename) {
			return filename.substring(0, filename.lastIndexOf('.')).toLowerCase();
		}

		function showRepeatedDialog(multipleRepeated){
			var locals = vm.repeatedUploadObjects[0];
			if(vm.repeatedRemember && !multipleRepeated){
				switch(vm.repeatedRemember){
					case 'delete':
						vm.uploadFiles = vm.uploadFiles.filter(x => x.name != locals.uploadFile.name);
					break;
					case 'maintain':
						$scope.errorMsg = null;
						vm.upload(locals.uploadFile, true);
					break;
					case 'replace':
						if(locals.repeatedFiles.length > 1){
							showRepeatedDialog(vm.repeatedRemember);
						}else{
							$scope.errorMsg = null;
							vm.upload(locals.uploadFile, true, locals.repeatedFiles[0]);
						}
					break;
				}
				vm.repeatedUploadObjects.shift();
				if(vm.repeatedUploadObjects.length){
					showRepeatedDialog();
				}else{
					vm.repeatedRemember = false;
				}
			}else{
				$mdDialog.show({
					controller: 'RepeatedUploadFilesController',
					controllerAs: 'vm',
					locals: locals,
					templateUrl: 'app/main/apps/media/dialogs/media/repeated-upload-files.html',
					parent: angular.element($document.body),
					multiple: true,
					clickOutsideToClose: false
				}).then(function (resp) {
					switch(resp.action){
						case 'delete':
							vm.uploadFiles = vm.uploadFiles.filter(x => x.name != resp.file.name);
						break;
						case 'maintain':
							$scope.errorMsg = null;
							vm.upload(resp.file, true);
						break;
						case 'replace':
							$scope.errorMsg = null;
							vm.upload(resp.file, true, resp.repeatedFiles);
						break;
					}
					if(resp.remember){
						vm.repeatedRemember = resp.action;
					}
					if(multipleRepeated){
						vm.repeatedRemember = multipleRepeated;
					}
					vm.repeatedUploadObjects.shift();
					if(vm.repeatedUploadObjects.length){
						showRepeatedDialog();
					}else{
						vm.repeatedRemember = false;
					}
				});
			}
		}

		$scope.$watch('vm.import_field', function () {
			vm.importConfirm(false);
		});

		$scope.log = '';


		function upload(file, old, repeatFile) {
			if (!file.$error) {
				file.processed = false;
				var uploadOptions = {
					siteID: siteID,
					isReplace: vm.isReplace,
					item: vm.item,
					uploadedFiles: vm.uploadedFiles,
					filename: file.name.replaceAll('(', '').replaceAll(')', ''),
					fileSizeKb: (angular.isDefined(file.size)) ? (parseInt(file.size) / 1000).toFixed(2) : null,
					id_media: vm.isReplace ? vm.item.id_media : null,
					log: $scope.log,
					type: 'media'
				}
				if(repeatFile){
					uploadOptions.isReplace = true;
					uploadOptions.item = repeatFile;
					uploadOptions.id_media = repeatFile.id_media;
				}
				console.debug("UPLOAD______****", file)
				uploadService.upload(file, uploadOptions).then(function (resp) {
					if (file.cancelled) {
						// removed from the list while it was finishing: it must not be attached
						return;
					}
					$scope.log = file.log;
					vm.uploadedFiles.push(file);
					var galleriesAssignedIds = getAssignedGalleriesIds(vm.CleanMediaGalleries, []);
					if (angular.isArray(galleriesAssignedIds) && galleriesAssignedIds.length) {
						var options = {
							site: siteID,
							data: {
								id_media: [file.id_media],
								id_gallery: galleriesAssignedIds
							}
						};
						mediaService.insertIntoGallery(options).then(function(response){
							vm.selectedContacts.push(file)
							loadAndAttachMedia(file);
						})
					} else {
						loadAndAttachMedia(file);
					}
					if(vm.isReplace || repeatFile){
						vm.repeatedFilesArray.push(file.id_media);
					}
				});
			}
		};

		function showErrorDialog(message) {
			$mdToast.show({
				template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
				hideDelay: 5000,
				position: 'top',
				parent: '#content-container'
			});
		}

		function loadAndAttachMedia(file) {
			mediaService.get({
				siteID: siteID,
				withCropStatus: true,
				idMedia: file.id_media
			})
				.then(function (response) {
					//if (response.total == 1) {
						var photo = response.data[0];
						toggleSelectContact(photo);
					//}
				});
		}

		vm.importConfirm = function (confirm) {
			vm.import_disabled = false;
			vm.imported = false;
			if (!confirm) {
				vm.importPreview = false;
			}
			if (vm.import_field.length > 10) {
				vm.importing = true;
				vm.import_disabled = true;

				$timeout(function () {
					var pastedUrl = vm.import_field;
					mediaService.importFromUrl({
						siteID: siteID,
						url: pastedUrl,
						execute: confirm
					})
						.then(function (response) {
							vm.importing = false;
							response.embedCodeSafe = $sce.trustAsHtml(response.metadata.embedCode);
							response.caption = response.metadata.caption;
							response.title = response.metadata.title;
							if (response.id_media) {
								// Attach media to selected gallery
								// For qiu-restricted users with limited gallery access we need to attach media
								// to the users root gallery before loading the media again from api,
								// otherwise the api won't return the media due to qiu restrictions.
								var galleriesAssignedIds = getAssignedGalleriesIds(vm.CleanMediaGalleries, []);
								if (angular.isArray(galleriesAssignedIds) && galleriesAssignedIds.length) {
									var options = {
										site: siteID,
										data: {
											id_media: [response.id_media],
											id_gallery: galleriesAssignedIds
										}
									};
									mediaService.insertIntoGallery(options).then(function(resp){
										vm.imported = true;
										vm.importPreview = false;
										mediaService.get({
											siteID: siteID,
											withCropStatus: true,
											idMedia: response.id_media
										}).then(function (response) {
											if (response.total == 1) {
												var photo = response.data[0];
												vm.importedFiles.push(photo);
												toggleSelectContact(photo);
											}
										});
									})
								} else {
									vm.imported = true;
									vm.importPreview = false;
									mediaService.get({
										siteID: siteID,
										withCropStatus: true,
										idMedia: response.id_media
									}).then(function (response) {
										if (response.total == 1) {
											var photo = response.data[0];
											vm.importedFiles.push(photo);
											toggleSelectContact(photo);
										}
									});
								}
							} else {
								vm.importPreview = response;
							}
							vm.import_disabled = false;
						});
				})
			}
		}

		function morePages() {
			if (vm.currentPage <= vm.lastPage) return true;
			return false;
		}

		function firstPage() {
			if (vm.currentPage == 1) return true;
			return false;
		}

		function alreadySelectedbyZone(array, item) {
			var ret = false;
			for (var i = 0, len = array.length; i < len; i++) {
				if (vm.mediazone) {
					if (array[i]['id_media'] === item.id_media && array[i]['id_zone'] === vm.mediazone.id_zone) {
						ret = true;
					}
				} else {
					if (array[i]['id_media'] === item.id_media) {
						ret = true;
					}

				}
			}

			return ret;
		}


		function toggleSelectedbyZone(item) {
			for (var i = 0; vm.selectedContacts.length < i; i++) {
				if (vm.mediazone && vm.selectedContacts[i]['id_media'] === item.id_media && vm.selectedContacts[i]['id_zone'] === vm.mediazone.id_zone) {
					vm.selectedContacts.splice(i, 1);
					return;
				}
			}
			if(vm.selectedContacts.indexOf(item) == -1){
				vm.selectedContacts.push(item);
			}
			return;
		}

		function selectMediaTiny(item) {
			var currentSort = 0;
			var mediaSort = 0;
			for (var i = 0; i < vm.currentThread.length; i++) {
				if (vm.mediazone) {
					if (vm.currentThread[i]['id_zone'] == 1 && (vm.currentThread[i]['media_type'] == item.media_type)) {
						currentSort++;
						if (item.id_media == vm.currentThread[i]['id_media']) {
							mediaSort = currentSort;
						}
					}
				} else {
					currentSort++;
					if (item.id_media == vm.currentThread[i]['id_media']) {
						mediaSort = currentSort;
					}
				}
			}

			vm.selectedMediaTiny = item;
			vm.tinyProperties.mediaSort = mediaSort;
			vm.tinyProperties.mediaType = item.media_type;
			vm.changeViewTiny('properties');
		}

		function deleteFromUpload(file){
			// stops the upload in flight and deletes the media it may have already created
			uploadService.cancel(file);
			// filtered by reference: while uploading the file has no id_media yet
			vm.uploadFiles = vm.uploadFiles.filter(x => x !== file);
			vm.uploadedFiles = vm.uploadedFiles.filter(x => x !== file);
			if (file.id_media) {
				vm.selectedContacts = vm.selectedContacts.filter(x => x.id_media != file.id_media);
			}
		}

		function attachMedia() {
			var continueAttach = false;
			if (vm.uploadedFiles.length == vm.uploadFiles.length) {
				continueAttach = true;
			} else {
				$mdDialog.show({
					templateUrl: 'app/main/dialogs/media/views/confirm-upload-close.html',
					controller: function ($mdDialog) {
						var vm = this;
						vm.answer = function (answer) {
							$mdDialog.hide(answer);
						};
					},
					controllerAs: 'vm',
					multiple: true,
					clickOutsideToClose: false
				}).then(function (answer) {
					if (answer === 'stay') {
						return;
					}
					if (answer === 'abort') {
						// Abort all ongoing uploads
						angular.forEach(vm.uploadFiles, function (file) {
							if (file.upload && file.upload.abort) {
								file.upload.abort();
							}
							file.uploadStatus = 'aborted';
						});

						// Delete all files (finished or not)
						var deleteIds = vm.uploadFiles.map(function (f) {
							return f.id_media;
						}).filter(function (id) {
							return !!id;
						});
						if (deleteIds.length > 0) {
							var options = {
								site: requestContext.getParam("siteId"),
								id_media: deleteIds,
								force: true
							};
							mediaService.massDelete(options);
						}
						$mdDialog.hide(vm.currentThread);
					} else if (answer === 'background') {
						vm.closeDialog(vm.selectedContacts);
					}
				});
			}

			if (!continueAttach) {
				return false;
			}
			var mediaIDs = [];
			for (var i = 0; i < vm.selectedContacts.length; i++) {
				if (!mediaIDs.includes(vm.selectedContacts[i].id_media)) {
					mediaIDs.push(vm.selectedContacts[i].id_media);
				}
			}
			if (mediaIDs.length == 0) {
				// TODO: show alert
				if(vm.uploadedFiles.length > 0){
					vm.selectedContacts = vm.uploadedFiles;
					for (var i = 0; i < vm.selectedContacts.length; i++) {
						mediaIDs.push(vm.selectedContacts[i].id_media);
					}
				}else{
					console.log('No ID medias');
					return false;
				}
			}

			var uploadedFilesIDs = [];

			var message = (mediaIDs.length > 1) ? $translate.instant('MEDIA.ITEMS_UPLOADED_PLURAL') : $translate.instant('MEDIA.ITEMS_UPLOADED_SINGULAR');
			var fields = {};
			angular.forEach(vm.fields, function (value, key) {
				if (!_.isNull(value) && value != 0) {
					this[key] = value;
				}
			}, fields);
			var galleriesAssigned = getAssignedGalleries(vm.CleanMediaGalleries, []);
			if(vm.uploadedFiles.length > 0){
				vm.uploadedFiles.forEach(element => {
					uploadedFilesIDs.push(element.id_media);
				});
				var batchOptions = {
					siteID: siteID,
					id_medias: uploadedFilesIDs,
					fields: vm.fields,
					tags: vm.currentTags,
					id_galleries: []
				}
				galleriesAssigned.forEach(gallery => {
					batchOptions.id_galleries.push(gallery.id);
				});
				mediaService.finishedUploadingBatchToCdn(batchOptions).then(function(response){
				}).catch(function(error){
					console.log('error', error);
					vm.isAttaching = false;
				});
			}
			if (_.isEmpty(fields) && _.isEmpty(vm.currentTags) && galleriesAssigned.length == 0) {
				vm.reload = true;
				$mdToast.show({
					template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + mediaIDs.length + message + '</span></div></md-toast>',
					hideDelay: 5000,
					position: 'top',
					parent: '#content-container'
				});
				vm.closeDialog(true);
				return false;
			}

			vm.isAttaching = true;
			// Initial promise

			var sequence = $q.defer();
			sequence.resolve();
			sequence = sequence.promise;

			if (galleriesAssigned.length > 0) {

				var inserts = [];
				var mismatches = {};

				angular.forEach(galleriesAssigned, function (gallery) {

					var galleryTypeId = gallery.gallery_type;
					var validMediaIds = [];

					angular.forEach(vm.uploadedFiles, function (file) {
						var fileTypeId = msUtils.getFileTypeId(file.type);
						if (galleryTypeId == 0) {
							validMediaIds.push(file.id_media);
						} else if (galleryTypeId != 0 && fileTypeId && galleryTypeId == fileTypeId) {
							validMediaIds.push(file.id_media);
						} else {
							if (!angular.isArray(mismatches[file.name])) {
								mismatches[file.name] = [];
							}
							if (gallery.gallery_type != 0){
								mismatches[file.name].push(gallery.gallery_name + ' (' + msUtils.getGalleryTypeById(gallery.gallery_type) + ')');
							}
						}
					});
					if (validMediaIds.length > 0) {
						inserts.push({ id_gallery: [gallery.id_gallery], media_ids: validMediaIds });
					}
				});
				if (!_.isEmpty(mismatches)) {
					sequence = sequence.then(function () {
						console.log("seq 1 - confirm mismatch");
						var confirm = $mdDialog.confirm()
							.title($translate.instant('MEDIA.MISMATCH_DIALOG.TITLE'))
							.textContent($translate.instant('MEDIA.MISMATCH_DIALOG.CONTENT'))
							.ariaLabel($translate.instant('MEDIA.MISMATCH_DIALOG.LABEL'))
							.ok($translate.instant('MEDIA.MISMATCH_DIALOG.OK'))
							.cancel($translate.instant('MEDIA.MISMATCH_DIALOG.CANCEL'))
							.multiple(true);
						return $mdDialog.show(confirm);
					})
				}

				angular.forEach(inserts, function (insert) {
					sequence = sequence.then(function () {
						console.log('seq 1 - continue mismatch approved')
						var options = {
							site: siteID,
							data: {
								id_media: insert.media_ids,
								id_gallery: insert.id_gallery
							}
						};
						return mediaService.insertIntoGallery(options);
					});
				}, function () {
					console.log('seq 1 - continue mismatch rejected')
					vm.isAttaching = false;
					return Promise.reject();
				});
			}

			if (!_.isEmpty(fields) || !_.isEmpty(vm.currentTags)) {
				attachHiddenTags();
				sequence = sequence.then(function () {
					var options = {
						site: siteID,
						data: {
							id_media: mediaIDs,
							fields: fields,
							tags: vm.currentTags
							// fields: {
							//  geoLat: vm.fields.geoLat,
							//  geoLon: vm.fields.geoLon
							// }
						}
					};
					return mediaService.massUpdate(options);
				}, function () {
					console.log('seq 2 - reject')
					vm.isAttaching = false;
					return Promise.reject();
				});
			}

			sequence = sequence.then(function () {
				console.log("seq 4 - close dialog");
				vm.isAttaching = false;
				vm.reload = true;
				$mdToast.show({
					template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + mediaIDs.length + message + '</span></div></md-toast>',
					hideDelay: 5000,
					position: 'top',
					parent: '#content-container'
				});
				return vm.closeDialog(vm.selectedContacts);
			}, function () {
				console.log('seq 4 - reject')
				vm.isAttaching = false;
			});
		}

		function attachMediaTiny() {
			$mdDialog.hide(vm.tinyProperties);
		}

		function getAssignedGalleries(galleries, result) {

			angular.forEach(galleries, function (gallery) {
				if (gallery.assigned_gallery == true) {
					result.push(gallery);
				}
				if (typeof gallery.children !== 'undefined' && gallery.children.length > 0) {
					getAssignedGalleries(gallery.children, result);
				}
			});
			return result;
		}

		function getAssignedGalleriesIds(galleries, result) {
			angular.forEach(galleries, function(gallery) {
				if (gallery.assigned_gallery == true && !gallery.no_files_allowed) {
					result.push(gallery.id_gallery);
				}
				if (typeof gallery.children !== 'undefined' && gallery.children.length >0) {
					getAssignedGalleriesIds(gallery.children, result);
				}
			});
			return result;
		}

		vm.isImage = function (f) {
			return f.type.startsWith("image");
		}

		vm.isVideo = function (f) {
			return f.type.startsWith("video");
		}

		function selectedItemChange() {
			vm.searchTagText = '';
			vm.selectedTag = null;
		}

		/**
		* Add label chips
		*
		* @param query
		* @returns {filterFn}
		*/
		function labelQuerySearch(query, tagTypeIds) {
			var response = [];
			if (query) {
				response =  vm.tags.filter(vm.createFilterFor(query))
			}
			if (tagTypeIds) {
				response = response.filter(function(tag){
					return tagTypeIds.includes(tag.id_type);
				});
			}

			return response;
		}

		function radioOptionsFilter(tags, tagTypeIds) {
			return tags.filter(function(tag){
				return tagTypeIds.includes(tag.id_type);
			});
		}

		function radioChanged(activeTag, tagTypeIds) {
			// vm.currentTags may hold tags of types that are not included in this radio group,
			// for example tags that are added by a different radio or checkbox group.
			// Don't remove those tags!
			vm.currentTags = vm.currentTags.filter(function(tag) {
				let resp = tagTypeIds.includes(tag.id_type)
				return !resp;
			})

			// Finally add the selected tag
			vm.currentTags.push(activeTag[0]);
		}

		function checkboxesFilter(tags, tagTypeIds) {
			return tags.filter(function(tag){
				return tagTypeIds.includes(tag.id_type);
			});
		}

		function radioGroupTitleByTagTypes(tagTypeIds) {
			if (vm.tagsTypes) {
				return vm.tagsTypes
					.filter(function(tagType){return tagTypeIds.includes(tagType.id_type)})
					.map(function(tagType){return tagType.name})
					.join(" OR ");
			}
			return '';
		}

		function checkboxGroupTitleByTagTypes(tagTypeIds) {
			if (vm.tagsTypes) {
				return vm.tagsTypes
					.filter(function(tagType){return tagTypeIds.includes(tagType.id_type)})
					.map(function(tagType){return tagType.name})
					.join(" & ");
			}
			return '';
		}

		function setTagTypes() {
			var options = {
				siteID: siteID
			}
			tagsService.getTagsTypes(options).then(function(response) {
				vm.tagsTypes = response;
			})
		}

		function preselectTags() {
			if (vm.tags && vm.preselectedTags && angular.isArray(vm.preselectedTags) && vm.preselectedTags.length > 0) {
				angular.forEach(vm.preselectedTags, function(pres) {
					let tag = vm.tags.find(function(tag) {return tag.id_tag == pres.id_tag})
					if (tag) {
						vm.currentTags.push(tag);
					}
				})
			}
		}

		function isCurrentTag(tag) {
			return vm.currentTags.includes(tag);
		}

		function updateCurrentTags(tag, ev) {
			if (vm.currentTags.includes(tag)) {
				vm.currentTags.splice(vm.currentTags.indexOf(tag), 1);
			} else {
				vm.currentTags.push(tag);
			}
		}

		function newTag(tagName) {

			if (vm.newTagDisabled) {
				return false;
			}
			vm.newTagDisabled = true;

			var newTag = {
				tag_name: tagName
			};
			var options = {
				site: siteID,
				item: newTag
			};
			tagsService.saveItem(options).then(function (response) {
				newTag.id_tag = response.id_tag
				vm.tags.push(newTag);
				vm.currentTags.push(newTag);
				vm.searchTagText = '';
				vm.newTagDisabled = false;
			});
		}

		/**
		 * Filter for chips
		 *
		 * @param query
		 * @returns {filterFn}
		 */
		function createFilterFor(query) {
			var lowercaseQuery = angular.lowercase(query);
			return function filterFn(item) {
				if (angular.isUndefined(item.tag_name)) {
					return false;
				}
				if (!item.tag_name) {
					return false;
				}
				if (!angular.lowercase(item.tag_name.toString()).indexOf) {
					return false;
				}
				return angular.lowercase(item.tag_name.toString()).indexOf(lowercaseQuery) >= 0;
			};
		}

		function getpos(event) {
			vm.fields.geoLat = event.latLng.lat();
			vm.fields.geoLon = event.latLng.lng();
			vm.latlng = [event.latLng.lat(), event.latLng.lng()];
		}

		function placeMarker() {
			var loc = this.getPlace()
				.geometry.location;
			vm.latlng = [loc.lat(), loc.lng()];
			vm.fields.geoLat = loc.lat();
			vm.fields.geoLon = loc.lng();
			vm.center = [loc.lat(), loc.lng()];
		}

		function searchLatLon() {
			vm.latlng = [vm.fields.geoLat, vm.fields.geoLon];
			vm.center = [vm.fields.geoLat, vm.fields.geoLon];
			vm.center = [40.74, -74.18];
		}

		/**
		 * Toggle selected status of the contact
		 *
		 * @param contact
		 * @param event
		 */

		function toggleSelectContact(photo, event) {
			if (event) {
				event.stopPropagation();
			}


			//		 else{
			if (vm.mediazone) {
				photo.id_zone = vm.mediazone.id_zone;
				photo.zone_name = vm.mediazone.zone_name;
			} else {
				photo.id_zone = null;
				photo.zone_name = null;
			}

			toggleSelectedbyZone(photo);
		}

		/**
		 * Scroll Media Dialog Content to the top
		 * @param speed
		 */
		function scrollToTopOfDialog() {
			$timeout(function () {
				var dialogContent = $document.find('md-dialog-content').filter(function () {
					return angular.element(this).hasClass('mediadialog-content');
				});
				if (angular.isDefined(dialogContent) && dialogContent.length) {
					dialogContent.animate({
						scrollTop: dialogContent[0].scrollHeight
					}, 1);
				}
			}, 0);

		}

		function loadLargeUploadList() {
			if(vm.showLargeUploadList == false){
				vm.showLargeUploadList = true;
			}else{
				vm.showLargeUploadList = false;
			}
		}
	}
})();

(function () {
    'use strict';

    angular
        .module('app.media')
        .controller('DeleteMediaDialogController', DeleteMediaDialogController);

    /** @ngInject */
    function DeleteMediaDialogController(
        $mdDialog,
        $document,
        selectedThreads,
        siteID,
        requestContext,
        $anchorScroll,
        $timeout,
        $scope,
        $sce,
        msUtils,
        COMMON,
        $log,
        $translate,
        mediaService,
        $rootScope,
        $mdToast
    ) {
        var vm = this;

        // Data
        vm.selectedThreads = selectedThreads;
        vm.selectedIds = [];
        vm.siteID = siteID;
        vm.isLoading = false;
        vm.mediaRelations = false;


        // Methods
        vm.delete = deleteItems;
        vm.cancel = cancel;

        
        vm.translate = function(text) {
            return $translate.instant(text);
        }

        init();
        /**
         * Initialize
         */
        function init() {

            vm.isLoading = true;

            for (var i = 0; i < vm.selectedThreads.length; i++) {
              vm.selectedIds.push(vm.selectedThreads[i].id_media);
            }

            var options = {
                siteID   : vm.siteID,
                id_media : vm.selectedIds
            };

            mediaService.getMediaRelations(options).then(function (response) {

                for (var i = 0; i < vm.selectedThreads.length; i++) {
                  for (var ii = 0; ii< response.data.length; ii++) {
                    if (response.data[ii].id_media == vm.selectedThreads[i].id_media) {
                      vm.selectedThreads[i].content =  response.data[ii].content;
                      vm.selectedThreads[i].galleries =  response.data[ii].galleries;
                    }
                  }
                }

                vm.mediaRelations = vm.selectedThreads;
                vm.isLoading = false;
            });
        }

        function cancel() {
            $mdDialog.hide(false);
        }


        function deleteItems() {
            vm.isLoading = true;

            if (vm.selectedIds.length == 1) {
              var message = $translate.instant('MEDIA.DELETED');
            } else {
              var message = vm.selectedIds.length + $translate.instant('MEDIA.DELETED_PLURAL');
            }

            var options = {
              site     : vm.siteID,
              id_media : vm.selectedIds,
              force    : true
            };

            mediaService.massDelete(options).then(function (response) {
                vm.isLoading = false;
                  //vm.closeMediaPreview();
                  //vm.deselectThreads();
                  $mdToast.show({
                      template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                      hideDelay: 5000,
                      position: 'top',
                      parent: '#content-container'
                  });
                  $mdDialog.hide(true);
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.content')
        .controller('EditGalleryDialogController', EditGalleryDialogController)
        .directive('qiuOnClickSelectParentGallery', ['mediaService', SelectParentGallery])
        ;

    /** @ngInject */
    function EditGalleryDialogController($scope, $mdDialog, galleries, gallery, parentGallery, siteID, mediaType,
        mediaService, transformMedia, $translate, msUtils, sessionService, sortFieldGalleries, sortDirGalleries, $timeout,
        usersService, transformUsers, hasMediacenterSettingsAccess, hasLightboxSettingsAccess, tagsService, $mdToast, isAdmin) {

        var vm = this;
        
        vm.isAdmin = isAdmin;
        vm.hasMediacenterSettingsAccess = hasMediacenterSettingsAccess;
        vm.hasLightboxSettingsAccess = hasLightboxSettingsAccess;
        vm.gallery = gallery;
        vm.duplicateWithMedia = true;
        if (!vm.gallery.children) {
            vm.duplicatedGallery = angular.copy(vm.gallery);
            delete vm.duplicatedGallery.id_gallery;
            delete vm.duplicatedGallery.id;
            if (vm.duplicatedGallery.gallery_name) {
                vm.duplicatedGallery.gallery_name += ' Copy';
            }
        }
        vm.galleries = galleries;
        vm.galleriesFiltered = angular.copy(vm.galleries)
        vm.galleryParentId = null;
        vm.duplicatedGalleryParentId = null;
        vm.galleryParentName = '';
        vm.duplicatedGalleryParentName = '';
        vm.parentGallery = parentGallery;
        vm.isQiuRestricted = false;
        vm.isQiuRestrictedRootSelected = false;
        if (angular.isArray(vm.galleries) && vm.galleries.length > 0 && vm.galleries[0].is_qiu_restricted_root) {
            vm.isQiuRestricted = true;
            if (!vm.parentGallery) {
                vm.parentGallery = vm.galleries[0];
            }
            if (vm.gallery.hasOwnProperty('id_gallery') && vm.gallery.id_gallery == vm.galleries[0].id_gallery) {
                vm.isQiuRestrictedRootSelected = true;
            }
        }
        if (vm.parentGallery) {
            vm.galleryParentId = vm.parentGallery.id_gallery;
            vm.duplicatedGalleryParentId = vm.parentGallery.id_gallery;
            vm.galleryParentName = vm.parentGallery.gallery_name;
            vm.duplicatedGalleryParentName = vm.parentGallery.gallery_name;
        }
        vm.galleryName = gallery.gallery_name;
        vm.isdynamic = gallery.is_dynamic;
        vm.galleryStatus = gallery.hasOwnProperty('status') ? gallery.status : 1;
        vm.galleryType = gallery.hasOwnProperty('gallery_type') ? gallery.gallery_type : 0;
        vm.filesAllowed = gallery.hasOwnProperty('no_files_allowed') ? !gallery.no_files_allowed : true;

        if (!gallery.hasOwnProperty('date')) {
            vm.galleryDate = moment().format('YYYY-MM-DD');
        } else if (!vm.gallery.date || vm.gallery.date == '0000-00-00') {
            vm.galleryDate = '';
        } else {
            vm.galleryDate = vm.gallery.date;
        }

        vm.tags = sessionService.site_operative.tags.sort((a,b) => a.tag_name < b.tag_name ? -1 : +(a.tag_name > b.tag_name));
        vm.galleryTypes = [
            { id_gallery_type: 0, name: $translate.instant('GALLERY.TYPES.0') },
            { id_gallery_type: 1, name: $translate.instant('GALLERY.TYPES.1') },
            { id_gallery_type: 2, name: $translate.instant('GALLERY.TYPES.2') },
            { id_gallery_type: 3, name: $translate.instant('GALLERY.TYPES.3') },
            { id_gallery_type: 4, name: $translate.instant('GALLERY.TYPES.4') }
        ];
        vm.mediaRatings = [
            { media_rating: 0, name:"Not rating filter"},
            { media_rating: 1, name: "★" },
            { media_rating: 2, name: "★★" },
            { media_rating: 3, name: "★★★" },
            { media_rating: 4, name: "★★★★" },
            { media_rating: 5, name: "★★★★★" }
        ];
        vm.galleryShortText = gallery.short_text;
        vm.galleryCoverId = gallery.id_cover;
        vm.duplicatedGalleryCoverId = gallery.id_cover;
        vm.galleryCover = false;
        vm.duplicatedGalleryCover = false;
        vm.toggleItemStatusEdit = toggleItemStatusEdit;
        vm.setItemStatus = setItemStatus;
        vm.selectParentGalleryRoot = selectParentGalleryRoot;
        vm.selectParentGallery = selectParentGallery;
        vm.selectCover = selectCover;
        //vm.galleryTypes = [1,2,3,4];
        vm.downloadZipUrl = null;

        vm.labelQuerySearch = labelQuerySearch;
        vm.createFilterFor = createFilterFor;
        vm.selectedTag = null;
        vm.selectedItemChange = selectedItemChange;
        vm.searchTagText = null;
        vm.newTag = newTag;
        vm.addKeywordFilter = addKeywordFilter;
        vm.keyWords = keyWords;
        vm.removeKeywordFilter = removeKeywordFilter;
        vm.dateDynamic = 0;
        vm.ratingDynamic = false;
        vm.labelDynamic = 0;
        vm.keywordsDynamic = false;
        vm.dynamicTags = [];
        vm.fromGalleryDate = undefined;
        vm.toGalleryDate = undefined;
        vm.dateFilterType = "Date created";
        vm.tagFilterType = "Match all tags";
        vm.timeFromDateGallery = "00:00:00";
        vm.timeToDateGallery = "23:59:59";
        vm.setHour = setHour;
        vm.wordFilters = ["filename", "photographer", "credits", "owner", "caption", "city", "country", "extra", "label", "title"];
        vm.filterWordField = gallery.raw_settings?.filters?.withFilters?.field? gallery.raw_settings.filters.withFilters.field : undefined;
        
        vm.partnerAreaGalleries = [];
        vm.partnerAreaGallery =  false;
        vm.selectedGroup = undefined;
        vm.oldSelectedGroup = undefined;

        vm.partnerAreaUserGroups = [];

        vm.selectGroup = selectGroup;

        vm.filteredGalleriesByGroups = {};

        vm.selectedGroups = vm.selectedGroups || [];
        vm.selectedGroupIds = vm.selectedGroupIds || Object.create(null);

        // Seed selection map for the NEW multi-select (qiu-tree combo) from existing raw_settings
        var existingMediacenterIds =
            vm.gallery?.raw_settings?.mediacenter?.permissions?.user_groups || [];
            
        vm.selectedGroupIds = seedSelectionMapFromIds(existingMediacenterIds, vm.selectedGroupIds);

        function getPartnerAreaGalleries(gallery) {
            if (gallery.is_partnerarea) {
                vm.partnerAreaGalleries.push(gallery.id_gallery);
            }
        
            if (gallery.children && gallery.children.length > 0) {
                gallery.children.forEach((child) => {
                    const childGallerys = getPartnerAreaGalleries(child);
                    if (childGallerys) {
                        vm.partnerAreaGalleries = vm.partnerAreaGalleries.concat(childGallerys);
                    }
                });
            }
        }
        vm.galleries.forEach((gallery) => {
            getPartnerAreaGalleries(gallery);
        });
        if(vm.partnerAreaGalleries.indexOf(vm.gallery.id_parent) !== -1){
            usersService.getUsersGroups({
                siteID: siteID,
                withGroupType: true
            }).then((response) => {
                let partnerAreaGroup = response.data.find(x => x.id_group_type === 20);
                if(partnerAreaGroup && partnerAreaGroup.children && partnerAreaGroup.children.length > 0){
                    vm.partnerAreaGallery = true;
                    vm.partnerAreaUserGroups = partnerAreaGroup.children;
                    vm.groupsFiltered = angular.copy(vm.partnerAreaUserGroups);
                    mediaService.getDivisions({
                        domain: siteID,
                        id_a: vm.gallery.id_gallery,
                        division_type: 'media_gallery_users_groups'
                    }).then((response) => {
                        if(response.length > 0){
                            vm.oldSelectedGroup = vm.partnerAreaUserGroups.find(x => x.id_group === response[0].id_b);
                            vm.selectedGroup = vm.partnerAreaUserGroups.find(x => x.id_group === response[0].id_b);
                        }
                    });
                }
            });
        }

        sessionService.loadDomainResourceSettings(siteID).then(function(response) {
            if (!response.public) return;

            const publicConfig = angular.fromJson(response.public);
            if (!publicConfig.filteredGalleriesByGroups || publicConfig.filteredGalleriesByGroups.length === 0) return;

            const filteredGalleriesByGroups = publicConfig.filteredGalleriesByGroups;

            usersService.getUsersGroups({
                siteID: siteID,
                withGroupType: true
            }).then((response) => {

                const usersGroups = response.data || [];

                filteredGalleriesByGroups.forEach(f => {
                    if (!vm.filteredGalleriesByGroups[f.gallery_type]) {
                        vm.filteredGalleriesByGroups[f.gallery_type] = [];
                    }

                    f.users_group_types.forEach(g => {
                        // 1) match by group type
                        const matched = usersGroups.filter(ug => ug.id_group_type === g);

                        // 2) flatten parents + children into a single list
                        const flattened = matched.flatMap(ug => flattenGroupTree(ug));

                        // 3) push as separate items (no nested arrays)
                        vm.filteredGalleriesByGroups[f.gallery_type].push(...flattened);
                        vm.filteredGalleriesByGroups[f.gallery_type] = dedupeByIdGroup(vm.filteredGalleriesByGroups[f.gallery_type]);

                        // Keep vm.selectedGroups in sync once we have the flat list available
                        if (f.gallery_type === 'media_center') {
                            vm.selectedGroups = seedSelectedGroupsFromFlatList(
                                vm.filteredGalleriesByGroups['media_center'],
                                vm.selectedGroupIds
                            );
                        }
                    });
                });
            });
        });

        function flattenGroupTree(group) {
            // Returns a flat array: [group, ...all descendants]
            if (!group) return [];

            var out = [group];

            if (Array.isArray(group.children) && group.children.length) {
                group.children.forEach(function (child) {
                    out = out.concat(flattenGroupTree(child));
                });
            }

            return out;
        }

        function dedupeByIdGroup(list) {
            var seen = Object.create(null);
            return (list || []).filter(function (g) {
                var id = g && g.id_group;
                if (!id) return true;
                if (seen[id]) return false;
                seen[id] = true;
                return true;
            });
        }

        function ensurePath(obj, pathArr) {
            // Ensures nested objects exist: ensurePath(o, ['a','b','c']) -> o.a.b.c = o.a.b.c || {}
            var cur = obj;
            pathArr.forEach(function (k) {
                if (!cur[k] || typeof cur[k] !== 'object') cur[k] = {};
                cur = cur[k];
            });
            return cur;
        }

        function idsFromSelectionMap(map) {
            console.log('map', map);
            // Build an array of numeric ids from { [id]: true/false }
            if (!map) return [];
            return Object.keys(map)
                .filter(function (k) { return !!map[k]; })
                .map(function (k) { return parseInt(k, 10); })
                .filter(function (n) { return !isNaN(n); });
        }

        function seedSelectionMapFromIds(ids, targetMap) {
            // Fill vm.selectedGroupIds from an array of ids (numbers/strings)
            targetMap = targetMap || Object.create(null);
            (ids || []).forEach(function (id) {
                var n = parseInt(id, 10);
                if (!isNaN(n)) targetMap[n] = true;
            });
            return targetMap;
        }

        function seedSelectedGroupsFromFlatList(flatGroups, selectionMap) {
            // Build vm.selectedGroups from already-loaded group objects + the selection map
            if (!Array.isArray(flatGroups) || !selectionMap) return [];

            var out = [];
            var seen = Object.create(null);

            flatGroups.forEach(function (g) {
                var id = g && g.id_group;
                if (!id) return;

                if (selectionMap[id] && !seen[id]) {
                    out.push(g);
                    seen[id] = true;
                }
            });

            return out;
        }

        vm.searchFilteredGroups = function () {
            // Return media_center groups if the current gallery OR any of its parents is mediacenter
            if (!vm.filteredGalleriesByGroups || !vm.filteredGalleriesByGroups['media_center']) {
                return null;
            }

            if (isMediacenterInAncestry(vm.gallery, vm.galleries)) {
                return vm.filteredGalleriesByGroups['media_center'];
            }

            return null;
        };

        function isMediacenterInAncestry(gallery, galleriesTree) {
            // Walk up by id_parent. If any ancestor has is_mediacenter === true, return true.
            if (!gallery) return false;

            // Current gallery itself
            if (gallery.is_mediacenter) return true;

            var parentId = gallery.id_parent;
            if (!parentId) return false;

            var safety = 0; // avoid infinite loops if bad data
            while (parentId && safety < 50) {
                var parent = findGalleryById(parentId, galleriesTree);
                if (!parent) return false;

                if (parent.is_mediacenter) return true;

                parentId = parent.id_parent;
                safety++;
            }

            return false;
        }

        function findGalleryById(id_gallery, galleriesTree) {
            // DFS search in the galleries nested tree
            if (!id_gallery || !Array.isArray(galleriesTree)) return null;

            for (var i = 0; i < galleriesTree.length; i++) {
                var g = galleriesTree[i];
                if (!g) continue;

                if (String(g.id_gallery) === String(id_gallery)) {
                    return g;
                }

                if (Array.isArray(g.children) && g.children.length) {
                    var found = findGalleryById(id_gallery, g.children);
                    if (found) return found;
                }
            }

            return null;
        }

        vm.stringifySelectedUserGroups = function () {
            if (!vm.selectedGroups || !vm.selectedGroups.length) {
                return '';
            }

            return vm.selectedGroups
                .map(g => g.name)
                .join(', ');
        };

        vm.toggleGroupSelection = function (item, idField) {

            if (!item || !item[idField]) return;

            var id = item[idField];

            if (vm.selectedGroupIds[id]) {
                // Unselect
                vm.selectedGroupIds[id] = false;
                vm.selectedGroups = vm.selectedGroups.filter(function (g) {
                    return g[idField] !== id;
                });
            } else {
                // Select
                vm.selectedGroupIds[id] = true;
                vm.selectedGroups.push(item);
            }
        };

        function selectGroup(group){
            vm.selectedGroup = group;
        }

        function setHour(type, time){
            if(!time){
                time = moment().format('HH:mm:00');
            }
            switch (type){
                case 'from':
                    vm.timeFromDateGallery = time;
                    if(vm.fromGalleryDate != undefined && vm.fromGalleryDate.length > 10){
                        var newDate = vm.fromGalleryDate.slice(0, -9);
                        vm.fromGalleryDate = newDate;
                        vm.fromGalleryDate = vm.fromGalleryDate + " " + vm.timeFromDateGallery;
                    }else{
                        vm.fromGalleryDate = vm.fromGalleryDate + " " + vm.timeFromDateGallery;
                    }
                break;
                
                case 'to':
                    vm.timeToDateGallery = time;
                    if(vm.toGalleryDate != undefined && vm.toGalleryDate.length > 10){
                        var newDate = vm.toGalleryDate.slice(0, -9);
                        vm.toGalleryDate = newDate;
                        vm.toGalleryDate = vm.toGalleryDate + " " + vm.timeToDateGallery;
                    }else{
                        vm.toGalleryDate = vm.toGalleryDate + " " + vm.timeToDateGallery;
                    }
                break;
            }
        }

        var options = {
            domain: siteID,
            siteID: siteID,
            sortField: sortFieldGalleries,
            sortDir: sortDirGalleries
        }
        if (mediaType == 1 || mediaType == 2 || mediaType == 3 || mediaType == 4) {
            options.gallery_type = [0, mediaType];
        }

        if (vm.galleryCoverId && vm.galleryCoverId != '') {
            var options = {
                siteID: siteID,
                idMedia: vm.galleryCoverId
            }

            mediaService.get(options).then(function (response) {
                if (response.data[0]){
                    vm.galleryCover = response.data[0];
                    vm.duplicatedGalleryCover = response.data[0];
                    vm.galleryCoverId = response.data[0].id_media;
                    vm.duplicatedGalleryCoverId = response.data[0].id_media;
                }
            });
        }

        vm.views = {
            'edit_gallery_main'                    : 'app/main/apps/media/dialogs/galleries/views/edit-gallery-main.html',
            'duplicate_gallery'                    : 'app/main/apps/media/dialogs/galleries/views/duplicate-gallery.html',
            'edit_gallery_users_groups_mediacenter': 'app/main/apps/media/dialogs/galleries/views/edit-gallery-users-groups-mediacenter.html',
            'edit_gallery_users_groups_lightbox'   : 'app/main/apps/media/dialogs/galleries/views/edit-gallery-users-groups-lightbox.html',
            'edit_gallery_users_groups_tree'       : 'app/main/dialogs/users-group/tree-view.html',
        }

        vm.selectedView = 'edit_gallery_main';
        //vm.viewUsersGroupsTree  = 'app/main/dialogs/users-group/tree-view.html';
        //vm.viewUsersGroupsChips = 'app/main/apps/media/dialogs/galleries/views/users-groups-chips.html';

        vm.usersGroups = []; // Used internally by group tree only. Will be loaded in openGroupTree();
        vm.galleryRawSettings = vm.gallery.raw_settings;

        if (vm.hasMediacenterSettingsAccess) {

            vm.galleryUserGroupIdsMediacenter = [];
            vm.selectedUsersGroupsMediacenter = [];

            if (vm.galleryRawSettings &&
                    vm.galleryRawSettings.hasOwnProperty('mediacenter') &&
                        vm.galleryRawSettings.mediacenter.hasOwnProperty('permissions') &&
                            vm.galleryRawSettings.mediacenter.permissions.hasOwnProperty('user_groups')
            ) {
                vm.galleryUserGroupIdsMediacenter = vm.galleryRawSettings.mediacenter.permissions.user_groups;
            }
            var opts = {
                siteID: siteID
            };
            usersService.getUsersGroups(opts).then(function (response) {
                var qiuRestrictions = response.qiuRestrictions;
                var nestedGroups = response.data;
                preselectGroups(nestedGroups, vm.galleryUserGroupIdsMediacenter, vm.selectedUsersGroupsMediacenter);
                vm.nestedUsersGroupsMediacenter = transformUsers.formatNestedGroups(nestedGroups, qiuRestrictions, true);
            })
        }

        if (vm.hasLightboxSettingsAccess) {

            vm.galleryUserGroupIdsLightbox = [];
            vm.selectedUsersGroupsLightbox = [];
            vm.selectedUsersLightbox = [];
            vm.selectedOwnerLightbox;

            if (vm.galleryRawSettings && vm.galleryRawSettings.hasOwnProperty('lightbox')) {

                if (vm.galleryRawSettings.lightbox.hasOwnProperty('owner')) {
                    vm.galleryOwnerIdLightbox = vm.galleryRawSettings.lightbox.owner;
                }

                if(vm.galleryRawSettings.lightbox.hasOwnProperty('shared')) {
                    if (vm.galleryRawSettings.lightbox.shared.hasOwnProperty('users')){
                        vm.galleryUserIdsLightbox = vm.galleryRawSettings.lightbox.shared.users;
                    }
                    if (vm.galleryRawSettings.lightbox.shared.hasOwnProperty('users_groups')) {
                        vm.galleryUserGroupIdsLightbox = vm.galleryRawSettings.lightbox.shared.users_groups;
                    }
                }
            }
            var opts = {
                siteID: siteID
            };
            usersService.getUsersGroups(opts).then(function (response) {
                var qiuRestrictions = response.qiuRestrictions;
                var nestedGroups = response.data;
                preselectGroups(nestedGroups, vm.galleryUserGroupIdsLightbox, vm.selectedUsersGroupsLightbox);
                vm.nestedUsersGroupsLightbox = transformUsers.formatNestedGroups(nestedGroups, qiuRestrictions, true);
            })
            var ids = [];
            if (vm.galleryOwnerIdLightbox) {
             ids.push(vm.galleryOwnerIdLightbox);
            }
            for (var key in vm.galleryUserIdsLightbox) {
                ids.push(vm.galleryUserIdsLightbox[key]);
            }

            if (ids.length > 0) {
                getUsersByIds(ids).then(function(response){
                    var users = response.result.data;
                    vm.selectedUsersLightbox = users.filter(function(user) {
                        return vm.galleryUserIdsLightbox.includes(user.id_user);
                    });
                    vm.selectedOwnerLightbox = users.find(function(user) {
                        return vm.galleryOwnerIdLightbox == user.id_user;
                    });
                })
            }
        }

        keyWords();
        getRating();
        getDates();
        getDynamicTags();

        function keyWords() {
            vm.keyWords = [];
            var withFilterValues = vm.gallery?.raw_settings?.filters?.withFilters?.values;
            if (angular.isDefined(withFilterValues) && angular.isArray(withFilterValues) && withFilterValues.length > 0) {
                vm.keyWords = withFilterValues;
                vm.keywordsDynamic = 1;
            }

            /*
            if(!vm.gallery.raw_settings){
                vm.keyWords = [];
            }else{
                if(!vm.gallery.raw_settings.filters.withFilters){
                    vm.keyWords = [];
                }else if(!vm.gallery.raw_settings.filters.withFilters.values || vm.gallery.raw_settings.filters.withFilters.values.length == 0){
                    vm.keyWords = [];
                }else{
                    vm.keyWords = vm.gallery.raw_settings.filters.withFilters.values;
                    vm.keywordsDynamic = 1;
                }
            }
            */
        }

        function getRating() {
            vm.mediaRating = null;
            var filtersRating = vm.gallery?.raw_settings?.filters?.rating;
            if (angular.isDefined(filtersRating) && filtersRating != 0 && filtersRating != null) {
                vm.mediaRating = filtersRating;
                vm.ratingDynamic = 1;
            }
            /*
            if(!vm.gallery.raw_settings){
                vm.mediaRating = null;
            }else{
                if(vm.gallery.raw_settings.filters.rating!=0 && vm.gallery.raw_settings.filters.rating != null){
                    vm.mediaRating = vm.gallery.raw_settings.filters.rating;
                    vm.ratingDynamic = 1;
                }
            }
            */
        }

        function getDates() {
            vm.fromGalleryDate = moment().format('YYYY-MM-DD');
            vm.toGalleryDate   = moment().format('YYYY-MM-DD');

            var dateFrom     = vm.gallery?.raw_settings?.filters?.dateFrom;
            var dateTo       = vm.gallery?.raw_settings?.filters?.dateTo;
            var fileDateFrom = vm.gallery?.raw_settings?.filters?.filedateFrom;
            var fileDateTo   = vm.gallery?.raw_settings?.filters?.filedateTo;

            if (angular.isDefined(dateFrom) && angular.isDefined(dateTo)) {
                vm.fromGalleryDate = dateFrom;
                vm.toGalleryDate = dateTo;
                vm.dateDynamic = 1;
                vm.dateFilterType = "Date uploaded";
            } else if (angular.isDefined(fileDateFrom) && angular.isDefined(fileDateTo)) {
                vm.fromGalleryDate = fileDateFrom;
                vm.toGalleryDate = fileDateTo;
                vm.dateDynamic = 1;
            }
            if (vm.fromGalleryDate && vm.fromGalleryDate.length > 10) {
                vm.timeFromDateGallery = vm.fromGalleryDate.substring(10);
            }
            if (vm.toGalleryDate && vm.toGalleryDate.length > 10) {
                vm.timeToDateGallery = vm.toGalleryDate.substring(10);
            }
            /*
            if(!vm.gallery.raw_settings){
                vm.fromGalleryDate = moment().format('YYYY-MM-DD HH:mm:00');
                vm.toGalleryDate = moment().format('YYYY-MM-DD HH:mm:00');
            }else{
                if(vm.gallery.raw_settings.filters.dateFrom){
                    vm.fromGalleryDate = vm.gallery.raw_settings.filters.dateFrom;
                    vm.toGalleryDate = vm.gallery.raw_settings.filters.dateTo;
                    vm.dateDynamic = 1;
                    vm.dateFilterType = "Date uploaded";
                }else if(vm.gallery.raw_settings.filters.filedateFrom){
                    vm.fromGalleryDate = vm.gallery.raw_settings.filters.filedateFrom;
                    vm.toGalleryDate = vm.gallery.raw_settings.filters.filedateTo;
                    vm.dateDynamic = 1;
                }
                if(vm.gallery.raw_settings.filters.dateFrom || vm.gallery.raw_settings.filters.filedateFrom){
                    if(vm.fromGalleryDate.length > 10){
                        vm.timeFromDateGallery = vm.fromGalleryDate.substring(10);
                    }
                    if(vm.toGalleryDate.length > 10){
                        vm.timeToDateGallery = vm.toGalleryDate.substring(10);
                    }
                }
            }
            */
        }

        function getDynamicTags() {
            vm.labelDynamic = 0;
            var filtersIdTag    = vm.gallery?.raw_settings?.filters?.id_tag;
            var filtersIdTagAnd = vm.gallery?.raw_settings?.filters?.id_tag_and;

            if (angular.isDefined(filtersIdTag) && angular.isArray(filtersIdTag)) {
                vm.dynamicTags = vm.tags.filter(t => filtersIdTag.includes(t.id_tag));
                vm.tagFilterType = "Match at least one tag";
                vm.labelDynamic = 1;
            } else if (angular.isDefined(filtersIdTagAnd) && angular.isArray(filtersIdTagAnd)) {
                vm.dynamicTags = vm.tags.filter(t => filtersIdTagAnd.includes(t.id_tag));
                vm.labelDynamic = 1;
            }
            /*
            if(vm.gallery.raw_settings){
                if(vm.gallery.raw_settings.filters.id_tag || vm.gallery.raw_settings.filters.id_tag_and){
                    if(vm.gallery.raw_settings.filters.id_tag){
                        if(angular.isArray(vm.gallery.raw_settings.filters.id_tag)){
                            vm.dynamicTags = vm.tags.filter(t => vm.gallery.raw_settings.filters.id_tag.includes(t.id_tag));
                            vm.tagFilterType = "Match at least one tag";
                            vm.labelDynamic = 1;
                        }else{
                            vm.labelDynamic = undefined; 
                        }
                    }else if(vm.gallery.raw_settings.filters.id_tag_and){
                        if(angular.isArray(vm.gallery.raw_settings.filters.id_tag_and)){
                            vm.dynamicTags = vm.tags.filter(t => vm.gallery.raw_settings.filters.id_tag_and.includes(t.id_tag));
                            vm.labelDynamic = 1;
                        }else{
                            vm.labelDynamic = undefined;
                        }
                    }
                }else{
                    if(vm.gallery.raw_settings.filters && vm.gallery.raw_settings.filters.id_tag && angular.isArray(vm.gallery.raw_settings.filters.id_tag)){
                        vm.dynamicTags = vm.tags.filter(t => vm.gallery.raw_settings.filters.id_tag.includes(t.id_tag));
                        vm.labelDynamic = 1;
                    }
                    vm.labelDynamic = undefined;
                }
            }
            */
        }

        vm.selectedOwnerChange = function(item) {
            vm.selectedOwnerLightbox = item;
            if (!vm.selectedOwnerLightbox) {
                vm.basicForm.lightboxOwner.$error = true;
            }
        }

        vm.filesAllowedChange = function() {
             vm.basicForm.filesAllowed.$setValidity('gallery_must_be_empty', true);
            if (!vm.filesAllowed && gallery.id_gallery) {
                // Check if gallery contains files
              var options = {
                siteID: siteID,
                galleryIds: [gallery.id_gallery],
                resultsPerPage: 1,
              };
              mediaService.getMediaInGalleries(options).then(function (response) {
                  if (response.data && angular.isArray(response.data) && response.data.length > 0) {
                        // "Files allowed" can only be disabled if gallery is empty! Throw alert.
                        vm.basicForm.filesAllowed.$setValidity('gallery_must_be_empty', false);
                  }
              })
            }
        }

        vm.selectedUserChange = function(item) {
            if (!item) return;
            var contains = vm.selectedUsersLightbox.find(function(selUser) {
                return selUser.id_user == item.id_user;
            })
            if (!contains) {
                vm.selectedUsersLightbox.push(item);
            }
            vm.searchUserEmail = '';
        }

        vm.deselectGroup = function(group) {
            group.assigned_group = false;
        }

        vm.openGroupTree = function(selectedTab) {
            vm.selectedTab = selectedTab;
            if (vm.selectedTab == 'mediacenter') {
                vm.nestedUsersGroupsCached = angular.copy(vm.nestedUsersGroupsMediacenter); // For reset on cancel group view.
                vm.usersGroups = vm.nestedUsersGroupsMediacenter;
            }
            if (vm.selectedTab == 'lightbox') {
                vm.nestedUsersGroupsCached = angular.copy(vm.nestedUsersGroupsLightbox); // For reset on cancel group view.
                vm.usersGroups = vm.nestedUsersGroupsLightbox;
            }
            vm.returnView = angular.copy(vm.selectedView);
            vm.selectedView = 'edit_gallery_users_groups_tree';

        }

        vm.applyGroupSelection = function() {
            if (vm.selectedTab == 'mediacenter') {
                vm.nestedUsersGroupsMediacenter = vm.usersGroups;
                vm.selectedUsersGroupsMediacenter = getAssignedGroups(vm.nestedUsersGroupsMediacenter, [], false);

            }
            if (vm.selectedTab == 'lightbox') {
                vm.nestedUsersGroupsLightbox = vm.usersGroups;
                vm.selectedUsersGroupsLightbox = getAssignedGroups(vm.nestedUsersGroupsLightbox, [], false);
            }
            vm.usersGroups = [];
            vm.selectedView = vm.returnView;
        }

        vm.cancelGroupSelection = function() {
            if (vm.selectedTab == 'mediacenter') {
                vm.nestedUsersGroupsMediacenter = vm.nestedUsersGroupsCached;
                vm.selectedUsersGroupsMediacenter = getAssignedGroups(vm.nestedUsersGroupsMediacenter, [], false);
            }
            if (vm.selectedTab == 'lightbox') {
                vm.nestedUsersGroupsLightbox = vm.nestedUsersGroupsCached;
                vm.selectedUsersGroupsLightbox = getAssignedGroups(vm.nestedUsersGroupsLightbox, [], false);
            }
            vm.usersGroups = [];
            vm.selectedView = vm.returnView;
        }

        function addKeywordFilter(keyword) {
            if(keyword != ""){
                var repeatedKeyword = false;
                for(var i=0; i<vm.keyWords.length; i++){
                    if(keyword === vm.keyWords[i]){
                        repeatedKeyword = true;
                    }
                }
                if(!repeatedKeyword){
                    if(!vm.keyWords){
                        vm.keyWords = [];
                        vm.keyWords.push(keyword);
                        vm.keywordFilter = "";
                    }else if(vm.keyWords.length <= 0){
                        vm.keyWords = [];
                        vm.keyWords.push(keyword);
                        vm.keywordFilter = "";
                    }else{
                        vm.keyWords.push(keyword);
                        vm.keywordFilter = "";
                    }
                }else{
                    console.log("repited word");
                }
            }else{
                console.log("error, empty field");
            }
        }

        function removeKeywordFilter(key){
            for(var i=0; i<vm.keyWords.length; i++){
                if(vm.keyWords[i] === key){
                    vm.keyWords.splice(i, 1);
                }
            }
        }

        function selectedItemChange() {
            vm.searchTagText = '';
            vm.selectedTag = null;
        }

        /**
        * Add label chips
        *
        * @param query
        * @returns {filterFn}
        */
        function labelQuerySearch(query) {
          var ret = [];
          if (query) {
            var filteredContent = angular.copy(vm.tags.filter(vm.createFilterFor(query)));
            if (filteredContent.length > 0) {
              ret.push({
                id_tag: 0,
                tag_name: "",
                order: 1
              });
            }
            angular.forEach(filteredContent, function (val) {
              ret.push(val);
            })
          }
          return ret;
        }
        /**
        * Filter for chips
        *
        * @param query
        * @returns {filterFn}
        */
        function createFilterFor(query) {
          var lowercaseQuery = angular.lowercase(query);
          return function filterFn(item) {
            if (angular.isUndefined(item.tag_name)) {
              return false;
            }
            if (!item.tag_name) {
              return false;
            }
            if (!angular.lowercase(item.tag_name.toString()).indexOf) {
              return false;
            }
            return angular.lowercase(item.tag_name.toString()).indexOf(lowercaseQuery) >= 0;
          };
        }

        function newTag(tagName) {
          if (vm.newTagDisabled) {
            return false;
          }
          vm.newTagDisabled = true;

          var newTag = {
            id_tag: '',
            tag_name: tagName
          };
          var options = {
            site: siteID,
            item: newTag
          };
          tagsService.saveItem(options).then(function (response) {
            newTag.id_tag = response.id_tag;
            vm.dynamicTags.push(newTag);
            vm.searchTagText = '';
            vm.newTagDisabled = false;
            sessionService.loadDomainResourceSettings(siteID).then(function(response) {
                vm.tags = response.tags;
                sessionService.site_operative.tags = vm.tags;
            });
          })
        }

        function getUsersByIds(ids) {
            var options = {
                siteID: siteID,
                userIds: ids
            };
            return usersService.getUsers(options);
        }

        function preselectGroups(treeGroups, selectedGroupIds, selectedUsersGroups) {
            if (treeGroups) {
                for (var k = treeGroups.length - 1; k >= 0; k--) {
                    if (angular.isArray(selectedGroupIds) && selectedGroupIds.includes(treeGroups[k].id_group)) {
                        if (!selectedUsersGroups.includes(treeGroups[k])) {
                            selectedUsersGroups.push(treeGroups[k]);
                        }
                        treeGroups[k].assigned_group = true;
                    }
                    if (treeGroups[k].children) {
                        preselectGroups(treeGroups[k].children, selectedGroupIds, selectedUsersGroups);
                    }
                }
            }
        }

        function getAssignedGroups(treeGroups, result, onlyId) {
            if (treeGroups) {
                for (var k = treeGroups.length - 1; k >= 0; k--) {
                    if (treeGroups[k].assigned_group === true) {
                        if (onlyId) {
                            result.push(treeGroups[k].id_group);
                        } else {
                            result.push(treeGroups[k]);
                        }
                    }
                    if (treeGroups[k].children) {
                        getAssignedGroups(treeGroups[k].children, result, onlyId);
                    }
                }
            }
            return result;
        }

        $scope.hide = function () {
            $mdDialog.hide();
        };

        vm.cancel = function () {
            $mdDialog.cancel();
        };

        $scope.delete = function (ev, gallery) {

            var confirmTitle = $translate.instant('GALLERY.DELETE_CONFIRM_TITLE', { gallery_name: gallery.gallery_name });
            var confirmText = $translate.instant('GALLERY.DELETE_CONFIRM_TEXT');
            var confirm = $mdDialog.confirm()
                .title(confirmTitle)
                .textContent(confirmText)
                .ariaLabel(confirmTitle)
                .targetEvent(ev)
                .ok('OK')
                .cancel($translate.instant('CANCEL'))
                .multiple(true);

            $mdDialog.show(confirm).then(function () {
                mediaService
                    .deleteMediaGallery(siteID, gallery.id_gallery)
                    .then(function (response) {
                        var message = $translate.instant('GALLERY.GALLERY_DELETED');
                        $mdToast.show({
                            template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                            hideDelay: 5000,
                            position: 'top',
                            parent: '#content-container'
                        });
                        $mdDialog.hide();
                        mediaService.triggerReloadGalleries();
                    });
            },function(){

            })
        };


        $scope.downloadZip = function (ev, gallery) {
            vm.downloading = true;
            mediaService
                .downloadMediaGalleryZip(siteID, gallery.id_gallery, gallery.gallery_name)
                .then(function(response) {
                    if (response.zip_url) {
                        openZipDownloadDialog(ev, response)
                    } else {
                        msUtils.showError($translate.instant('GALLERY.ERRORS.ZIP_NOT_CREATED'));
                    }
                    vm.downloading = false;
                }, function(error) {
                    msUtils.showError($translate.instant('GALLERY.ERRORS.ZIP_NOT_CREATED'));
                    vm.downloading = false;
                })
        }

        vm.usersSearch = function (query) {
            var opts = {
                siteID: siteID,
                searchStringFilter: query,
                resultsPerPage: 999
            };
            return usersService.getUsers(opts).then(function(response){
                return Promise.resolve(response.result.data)
            })
        }

        function openZipDownloadDialog(ev, data) {
            vm.downloadZipUrl = data.zip_url;
            $mdDialog.show({
            controller: function () {
                return vm;
            },
            controllerAs: 'vm',
            templateUrl: 'app/main/apps/media/dialogs/gallery-zip-download/gallery-zip-download.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            multiple: true,
            clickOutsideToClose: true
          })
        }

        $scope.$watch('vm.treeSearch', function (newVal, oldVal) {
            vm.filterText = newVal;
            if (vm.filterText && vm.filterText.length > 0) {
                vm.galleriesFiltered = filterByName(vm.galleries, vm.filterText, 'gallery_name');
            } else {
                vm.galleriesFiltered = angular.copy(vm.galleries)
            }
        });

        $scope.$watch('vm.treeGroupsSearch', function (newVal, oldVal) {
            vm.filterGroupText = newVal;
            if (vm.filterGroupText && vm.filterGroupText.length > 0) {
                vm.groupsFiltered = filterByName(vm.partnerAreaUserGroups, vm.filterGroupText, 'name');
            } else {
                vm.groupsFiltered = angular.copy(vm.partnerAreaUserGroups);
            }
        });

        // Filtra el árbol de galerías conservando TODAS las coincidencias (no solo la
        // primera de cada rama) y las rutas que llevan a ellas.
        function filterByName(galleries, filterText, filterField){
            var q = (filterText || '').toLowerCase();
            var result = [];
            (galleries || []).forEach(function (node) {
                var selfMatch = node[filterField] &&
                    node[filterField].toLowerCase().indexOf(q) >= 0;
                if (selfMatch) {
                    // Coincide por nombre: se conserva con su subárbol completo.
                    result.push(node);
                } else if (node.children && node.children.length) {
                    // No coincide, pero puede tener descendientes que sí: conservamos la ruta.
                    var childMatches = filterByName(node.children, filterText, filterField);
                    if (childMatches.length) {
                        var clone = angular.extend({}, node);
                        clone.children = childMatches;
                        result.push(clone);
                    }
                }
            });
            return result;
        }

        function duplicateGallery() {
            vm.duplicatingGallery = true;
            vm.duplicatedGallery.id_cover = vm.duplicatedGalleryCoverId;
            vm.duplicatedGallery.id_parent = vm.duplicatedGalleryParentId;
            vm.duplicatedGallery.with_media = vm.duplicateWithMedia;

            mediaService.duplicateGallery({
                domain: siteID,
                id_gallery: vm.gallery.id,
                item: vm.duplicatedGallery
            }).then(response => {
                vm.duplicatingGallery = false;
                $mdDialog.hide();
                mediaService.triggerReloadGalleries();
            }).catch(error => {
                vm.duplicatingGallery = false;
                console.error('Error duplicando la galería:', error);
                // Opcional: muestra un mensaje de error al usuario
                vm.errorDuplicatingGallery = true;
            });
        }

        $scope.save = function (gallery) {
            if(vm.selectedView == 'duplicate_gallery'){
                vm.duplicatingGallery = true;
                duplicateGallery();
                return;
            }
            var options = {
                gallery_name: vm.galleryName.toString(),
                gallery_type: vm.galleryType,
                short_text: vm.galleryShortText ? vm.galleryShortText.toString() : '',
                status: vm.galleryStatus,
                id_parent: vm.galleryParentId,
                id_cover: vm.galleryCoverId,
                is_dynamic: vm.isdynamic,
                no_files_allowed: !vm.filesAllowed
            };

            if (vm.galleryDate != '') {
                options.date = moment.utc(vm.galleryDate).format('YYYY-MM-DD');
            }
            vm.galleryRawSettings = gallery.raw_settings;
            if(!vm.galleryRawSettings){
                vm.galleryRawSettings = {
                    filters: {
                        dateFrom: undefined,
                        dateTo: undefined,
                        filedateFrom: undefined,
                        id_tag: [],
                        id_tag_and: [],
                        rating: undefined
                    }
                }
            }
            if(vm.hasMediacenterSettingsAccess) {
                if (vm.selectedUsersGroupsMediacenter) {
                    var assignedGroupIdsMediacenter = vm.selectedUsersGroupsMediacenter.map(function(group){
                        return group.id_group;
                    })
                    if (!vm.galleryRawSettings) {
                        vm.galleryRawSettings = {};
                    }
                    if (vm.galleryRawSettings.hasOwnProperty('mediacenter') &&
                            vm.galleryRawSettings.mediacenter.hasOwnProperty('permissions')
                    ) {
                        if (vm.galleryRawSettings.mediacenter.permissions.hasOwnProperty('user_groups')) {
                            vm.galleryRawSettings.mediacenter.permissions.user_groups = assignedGroupIdsMediacenter;
                        } else {
                            vm.galleryRawSettings.mediacenter.permissions = {
                                user_groups: assignedGroupIdsMediacenter
                            }
                        }
                    } else {
                        vm.galleryRawSettings.mediacenter = {
                            permissions: {
                                user_groups: assignedGroupIdsMediacenter
                            }
                        }
                    }
                }
            }
            if(vm.hasLightboxSettingsAccess) {
                if (vm.selectedUsersGroupsLightbox) {
                    var assignedGroupIdsLightbox = vm.selectedUsersGroupsLightbox.map(function(group){
                        return group.id_group;
                    })
                    if (!vm.galleryRawSettings) {
                        vm.galleryRawSettings = {};
                    }
                    if (vm.galleryRawSettings.hasOwnProperty('lightbox')) {
                        if (vm.galleryRawSettings.lightbox.hasOwnProperty('shared')) {
                            vm.galleryRawSettings.lightbox.shared.users_groups = assignedGroupIdsLightbox;
                        } else {
                            vm.galleryRawSettings.lightbox.shared = {
                                users_groups: assignedGroupIdsLightbox
                            }
                        }
                    } else {
                        vm.galleryRawSettings.lightbox = {
                            shared: {
                                users_groups: assignedGroupIdsLightbox
                            }
                        }
                    }
                }
                
                if (vm.selectedUsersLightbox) {
                    var assignedUserIdsLightbox = vm.selectedUsersLightbox.map(function(user){
                        return user.id_user;
                    })
                    if (!vm.galleryRawSettings) {
                        vm.galleryRawSettings = {};
                    }
                    if (vm.galleryRawSettings.hasOwnProperty('lightbox')) {
                        if (vm.galleryRawSettings.lightbox.hasOwnProperty('shared')) {
                            vm.galleryRawSettings.lightbox.shared.users = assignedUserIdsLightbox;
                        } else {
                            vm.galleryRawSettings.lightbox.shared = {
                                users: assignedUserIdsLightbox
                            }
                        }
                    } else {
                        vm.galleryRawSettings.lightbox = {
                            shared: {
                                users: assignedUserIdsLightbox
                            }
                        }
                    }
                }
                if (vm.selectedOwnerLightbox) {
                    if (!vm.galleryRawSettings) {
                        vm.galleryRawSettings = {};
                    }
                    if (vm.galleryRawSettings.hasOwnProperty('lightbox')) {
                        vm.galleryRawSettings.lightbox.owner = vm.selectedOwnerLightbox.id_user;
                    } else {
                        vm.galleryRawSettings.lightbox = {
                            owner: vm.selectedOwnerLightbox.id_user
                        }
                    }
                }
            }

            if(vm.isdynamic){
                var dynamicOptions = {
                    filters: {
                        "filedateTo": undefined,
                        "dateTo": undefined,
                        "filedateFrom": undefined,
                        "dateFrom": undefined,
                        "id_tag_and": undefined,
                        "id_tag" : undefined,
                        "rating": undefined,
                        "withFilters": {
                            "field": undefined,
                            "values": undefined
                        }
                    }
                };
                if(vm.dateDynamic){
                    
                    switch (vm.dateFilterType) {
                        
                        case "Date created":
                            if(!vm.fromGalleryDate || !vm.toGalleryDate){
                                if(!vm.fromGalleryDate && vm.toGalleryDate){
                                    // dynamicOptions.filters.filedateFrom = vm.toGalleryDate + " " + vm.timeFromDateGallery;
                                    // if(vm.toGalleryDate.length < 19){
                                    //     vm.toGalleryDate = vm.toGalleryDate + " " + vm.timeToDateGallery;
                                    // }else{
                                    //     dynamicOptions.filters.filedateFrom = vm.toGalleryDate.slice(0, -9) + " " + vm.timeFromDateGallery;
                                    // }
                                    dynamicOptions.filters.filedateFrom = "2000-01-01 00:00:00";
                                    dynamicOptions.filters.filedateTo = vm.toGalleryDate;
                                }else if(vm.fromGalleryDate && !vm.toGalleryDate){
                                    // dynamicOptions.filters.filedateTo = vm.fromGalleryDate + " " + vm.timeToDateGallery;
                                    // if(vm.fromGalleryDate.length < 19){
                                    //     vm.fromGalleryDate = vm.fromGalleryDate + " " + vm.timeFromDateGallery;
                                    // }else{
                                    //     dynamicOptions.filters.filedateTo = vm.fromGalleryDate.slice(0, -9) + " " + vm.timeToDateGallery;
                                    // }
                                    dynamicOptions.filters.filedateFrom = vm.fromGalleryDate;
                                    dynamicOptions.filters.filedateTo = "2030-01-01 23:59:59";
                                }else if(!vm.fromGalleryDate && !vm.toGalleryDate){
                                    dynamicOptions.filters.filedateFrom = undefined;
                                    dynamicOptions.filters.filedateTo = undefined;
                                    dynamicOptions.filters.dateFrom = undefined;
                                    dynamicOptions.filters.dateTo = undefined;
                                    vm.dateDynamic = 0;
                                }
                            }else{
                                if(vm.fromGalleryDate > vm.toGalleryDate){
                                    dynamicOptions.filters.filedateFrom = undefined;
                                    dynamicOptions.filters.filedateTo = undefined;
                                    dynamicOptions.filters.dateFrom = undefined;
                                    dynamicOptions.filters.dateTo = undefined;
                                    vm.dateDynamic = 0;
                                }else{
                                    if(vm.fromGalleryDate.length < 19){
                                        vm.fromGalleryDate = vm.fromGalleryDate + " " + vm.timeFromDateGallery;
                                    }
                                    if(vm.toGalleryDate.length < 19){
                                        vm.toGalleryDate = vm.toGalleryDate + " " + vm.timeToDateGallery;
                                    }
                                    dynamicOptions.filters.filedateFrom = vm.fromGalleryDate;
                                    dynamicOptions.filters.filedateTo = vm.toGalleryDate;
                                }
                            }
                        break;
                        
                        case "Date uploaded":
                            if(!vm.fromGalleryDate || !vm.toGalleryDate){
                                if(!vm.fromGalleryDate && vm.toGalleryDate){
                                   // dynamicOptions.filters.filedateFrom = vm.toGalleryDate + " " + vm.timeFromDateGallery;
                                    // if(vm.toGalleryDate.length < 19){
                                    //     vm.toGalleryDate = vm.toGalleryDate + " " + vm.timeToDateGallery;
                                    // }else{
                                    //     dynamicOptions.filters.filedateFrom = vm.toGalleryDate.slice(0, -9) + " " + vm.timeFromDateGallery;
                                    // }
                                    dynamicOptions.filters.filedateFrom = "2000-01-01 00:00:00";
                                    dynamicOptions.filters.filedateTo = vm.toGalleryDate;
                                }else if(vm.fromGalleryDate && !vm.toGalleryDate){
                                    // dynamicOptions.filters.filedateTo = vm.fromGalleryDate + " " + vm.timeToDateGallery;
                                    // if(vm.fromGalleryDate.length < 19){
                                    //     vm.fromGalleryDate = vm.fromGalleryDate + " " + vm.timeFromDateGallery;
                                    // }else{
                                    //     dynamicOptions.filters.filedateTo = vm.fromGalleryDate.slice(0, -9) + " " + vm.timeToDateGallery;
                                    // }
                                    dynamicOptions.filters.filedateFrom = vm.fromGalleryDate;
                                    dynamicOptions.filters.filedateTo = "2030-01-01 23:59:59";
                                }else if(!vm.fromGalleryDate && !vm.toGalleryDate){
                                    dynamicOptions.filters.filedateFrom = undefined;
                                    dynamicOptions.filters.filedateTo = undefined;
                                    dynamicOptions.filters.dateFrom = undefined;
                                    dynamicOptions.filters.dateTo = undefined;
                                    vm.dateDynamic = 0;
                                }
                            }else{
                                if(vm.fromGalleryDate > vm.toGalleryDate){
                                    dynamicOptions.filters.filedateFrom = undefined;
                                    dynamicOptions.filters.filedateTo = undefined;
                                    dynamicOptions.filters.dateFrom = undefined;
                                    dynamicOptions.filters.dateTo = undefined;
                                    vm.dateDynamic = 0;
                                }else{
                                    if(vm.fromGalleryDate.length < 19){
                                        vm.fromGalleryDate = vm.fromGalleryDate + " " + vm.timeFromDateGallery;
                                    }
                                    if(vm.toGalleryDate.length < 19){
                                        vm.toGalleryDate = vm.toGalleryDate + " " + vm.timeToDateGallery;
                                    }
                                    dynamicOptions.filters.dateFrom = vm.fromGalleryDate;
                                    dynamicOptions.filters.dateTo = vm.toGalleryDate;
                                }
                            }
                        break;
                        
                    }
                    
                }else if(!vm.dateDynamic){
                    dynamicOptions.filters.filedateFrom = undefined;
                    dynamicOptions.filters.filedateTo = undefined;
                    dynamicOptions.filters.dateFrom = undefined;
                    dynamicOptions.filters.dateTo = undefined;
                }

                if(vm.mediaRating !== 0 && vm.ratingDynamic){
                    dynamicOptions.filters.rating = vm.mediaRating;
                }else{
                    dynamicOptions.filters.rating = undefined;
                }
                
                if(vm.dynamicTags.length > 0 && vm.labelDynamic) {
                    switch(vm.tagFilterType){
                        case "Match all tags":
                            dynamicOptions.filters.id_tag_and = vm.dynamicTags.map(t => t.id_tag);
                        break;
                        case "Match at least one tag":
                            dynamicOptions.filters.id_tag = vm.dynamicTags.map(t => t.id_tag);
                        break;
                    }
                } else {
                    dynamicOptions.filters.id_tag = undefined;
                    dynamicOptions.filters.id_tag_and = undefined;
                }
                
                if(vm.keywordsDynamic){
                    dynamicOptions.filters.withFilters.field = vm.filterWordField;
                    dynamicOptions.filters.withFilters.values = vm.keyWords;
                }else{
                    delete dynamicOptions.filters.withFilters;
                }
                if(vm.galleryRawSettings.hasOwnProperty('filters')){
                    vm.galleryRawSettings = dynamicOptions;
                }else{
                    vm.galleryRawSettings = {};
                    vm.galleryRawSettings = dynamicOptions;
                }
                options.raw_settings = vm.galleryRawSettings;
            }else{
                if(vm.galleryRawSettings){
                    vm.galleryRawSettings.filters = null;
                }
                options.raw_settings = vm.galleryRawSettings;
            }

            // Build raw list of selected group IDs directly from the fast lookup map.
            if (vm.selectedGroupIds) {
                // Persist NEW multi-select into raw_settings.mediacenter.permissions.user_groups
                // so PHP parseMediaGalleryPermissions() can read it and expand child groups.
                if (!options.raw_settings) options.raw_settings = {};

                var selectedIds = idsFromSelectionMap(vm.selectedGroupIds);

                ensurePath(options.raw_settings, ['mediacenter', 'permissions']);
                options.raw_settings.mediacenter.permissions.user_groups = selectedIds;
            }

            //options.is_dynamic = vm.isdynamic;
            if (angular.equals({}, gallery)) {
                mediaService
                    .createMediaGallery(siteID, options)
                    .then(function (response) {
                        // TODO: show success message
                        $mdDialog.hide();
                        mediaService.triggerReloadGalleries();
                    });
            } else {
                mediaService
                    .editMediaGallery(siteID, gallery.id_gallery, options)
                    .then(function (response) {
                        // TODO: show success message
                        $mdDialog.hide();
                        mediaService.triggerReloadGalleries();
                    });
            }
            if(vm.oldSelectedGroup != vm.selectedGroup){
                if(vm.oldSelectedGroup){
                    var filters = [
                        {
                            field: 'id_a',
                            values: [vm.gallery.id_gallery]
                        },
                        {
                            field: 'id_b',
                            values: [vm.oldSelectedGroup.id_group]
                        }
                    ];
                    
                    var updateItem = {
                        id_b: vm.selectedGroup.id_group
                    };
                    
                    mediaService.updateDivision({
                        domain: siteID,
                        filters: filters,
                        item: updateItem
                    }).then((response) => {
                        console.log('update division response', response);
                    });
                }else{
                    var divisions = {
                        division_type: 'media_gallery_users_groups',
                        id_a: vm.gallery.id_gallery,
                        id_b: vm.selectedGroup.id_group
                    }
                    mediaService.createNewDivision({
                        domain: siteID,
                        item: divisions
                    }).then((response) => {
                        console.log('newDivision response', response);
                    });
                }
            }
        };

        $scope.$on('selectParentGallery', function (event, parentGallery) {
            let parentId = 'galleryParentId';
            let parentName = 'galleryParentName';
            if(vm.selectedView == 'duplicate_gallery'){
                parentId = 'duplicatedGalleryParentId';
                parentName = 'duplicatedGalleryParentName';
            }
            vm[parentId] = parentGallery.id_gallery;
            vm[parentName] = parentGallery.gallery_name;

        });
        selectParentGallery(gallery, galleries, true);
        function selectParentGallery(parentGallery, galleriesFiltered, firstRoute) {
            let parentId = 'galleryParentId';
            let parentName = 'galleryParentName';
            if(vm.selectedView == 'duplicate_gallery'){
                parentId = 'duplicatedGalleryParentId';
                parentName = 'duplicatedGalleryParentName';
            }
            if(parentGallery.id_parent && parentGallery.id_parent != null){
                var parentsRoute = [];
                if(!firstRoute){
                    parentsRoute.push(parentGallery.gallery_name);
                }
                var galleriesWithChildrens = [];
                for(var i=0; i<galleriesFiltered.length; i++){
                    if(galleriesFiltered[i].children && galleriesFiltered[i].children.length){
                        galleriesWithChildrens.push(galleriesFiltered[i]);
                    }
                }
                searchParents(galleriesWithChildrens, parentGallery, parentsRoute);
            }else{
                vm[parentName] = parentGallery.gallery_name;
            }
            if(firstRoute){
                vm[parentId] = parentGallery.id_parent;
            }else{
                vm[parentId] = parentGallery.id_gallery;
            }
        }
        
        function searchParents(galleriesWithChildrens, parentGallery, parentsRoute){
            let parentName = 'galleryParentName';
            if(vm.selectedView == 'duplicate_gallery'){
                parentName = 'duplicatedGalleryParentName';
            }
            for(var i=0; i<galleriesWithChildrens.length; i++){
                if(galleriesWithChildrens[i].id_gallery == parentGallery.id_parent){
                    parentsRoute.unshift(galleriesWithChildrens[i].gallery_name);
                    if(galleriesWithChildrens[i].id_parent){
                        searchParents(galleriesWithChildrens, galleriesWithChildrens[i], parentsRoute);
                    }else{
                        vm[parentName] = parentsRoute.join(" > ");
                    }
                }else if(galleriesWithChildrens[i].children && galleriesWithChildrens[i].children.length){
                    searchOnChildrens(galleriesWithChildrens[i].children, parentGallery, parentsRoute, galleriesWithChildrens);
                }
            }
        }
        
        function searchOnChildrens(childrens, parentGallery, parentsRoute, galleriesWithChildrens){
            for(var i=0; i<childrens.length; i++){
                if(childrens[i].id_gallery == parentGallery.id_parent){
                    parentsRoute.unshift(childrens[i].gallery_name);
                    if(childrens[i].id_parent){
                        searchParents(galleriesWithChildrens, childrens[i], parentsRoute);
                    }
                    return childrens[i];
                }else if(childrens[i].children && childrens[i].children.length){
                    searchOnChildrens(childrens[i].children, parentGallery, parentsRoute, galleriesWithChildrens);
                }
            }
        }

        function selectCover(ev) {
            let galleryCover = 'galleryCover';
            let galleryCoverId = 'galleryCoverId';
            if(vm.selectedView == 'duplicate_gallery'){
                galleryCover = 'duplicatedGalleryCover';
                galleryCoverId = 'duplicatedGalleryCoverId';
            }
            var item = { Thumbnail: [] };
            if (vm[galleryCover]) {
                item.Thumbnail = [vm[galleryCover]];
            }
            $mdDialog.show({
                controller: 'MediaDialogController',
                controllerAs: 'vm',
                locals: {
                    autoUpload: '',
                    currentThread: item,
                    section: $scope.section,
                    mediazone: false,
                    isTiny: false,
                    maxAttach: 1,
                    showViews: {
                        1: true,
                        2: false,
                        3: false,
                        4: false,
                        5: false,
                        upload: false,
                        import: false
                    }
                },
                templateUrl: 'app/main/dialogs/media/media-dialog.html',
                targetEvent: ev,
                clickOutsideToClose: true,
                multiple: true
            }).then(function (response) {
                if (angular.isArray(response.Thumbnail) && response.Thumbnail[0] && response.Thumbnail[0].id_media) {
                    vm[galleryCover] = response.Thumbnail[0];
                    vm[galleryCoverId] = response.Thumbnail[0].id_media;
                }
            });
        }

        function toggleItemStatusEdit(status) {
            vm.galleryStatus = (status === 1) ? 0 : 1;
        }

        function setItemStatus(status) {
            vm.galleryStatus = status;
        }

        function selectParentGalleryRoot() {
            let parentId = 'galleryParentId';
            let parentName = 'galleryParentName';
            if(vm.selectedView == 'duplicate_gallery'){
                parentId = 'duplicatedGalleryParentId';
                parentName = 'duplicatedGalleryParentName';
            }
            vm[parentId] = null;
            vm[parentName] = $translate.instant('GALLERY.ROOT');
        }

        function getUnnestedGalleries(galleries, result) {
            angular.forEach(galleries, function (gallery) {
                if (gallery.id_gallery) {
                    result.push(gallery);
                    if (typeof gallery.children !== 'undefined' && gallery.children.length > 0) {
                        getUnnestedGalleries(gallery.children, result);
                    }
                }
            });
            return result;
        }

        function removeGalleryFromNestedGalleries(gallery, galleries) {
            angular.forEach(galleries, function (obj) {
                if (gallery.id_gallery == obj.id_gallery) {
                    var index = galleries.indexOf(obj);
                    galleries.splice(index, 1);
                }
                if (typeof obj.children !== 'undefined' && obj.children.length > 0) {
                    removeGalleryFromNestedGalleries(gallery, obj.children);
                }
            });
            return galleries;
        }
    }


    function SelectParentGallery(mediaService) {

        function unselectAllGalleries() {
            var elemList = document.querySelectorAll('.select-parent-gallery-row');
            elemList.forEach(function (elem) {
                elem.classList.remove('selected');
            });
        }

        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                $(element).on('click', function (e) {
                    var galleryNode = false;
                    if (element.parent().hasClass('selected')) {
                        unselectAllGalleries();
                    } else {
                        unselectAllGalleries();
                        element.parent().addClass('selected');
                        galleryNode = scope.node;
                    }
                    mediaService.triggerSelectParentGallery(galleryNode);
                });
            }
        };
    }

})();

(function () {
	'use strict';

	angular
		.module('app.media')
		.controller('EditMultipleFieldsDialogController', EditMultipleFieldsDialogController);

	/** @ngInject */
	function EditMultipleFieldsDialogController(
		$mdDialog,
		$document,
		mediaService,
		requestContext,
		$anchorScroll,
		$timeout,
		$scope,
		$mdToast,
		$translate,
		$sce,
		Upload,
		msUtils,
		COMMON,
		$log,
		NgMap,
		selectedThreads,
        sessionService,
        tagsService
		) {
		//
		var vm = this;

		// Data
		vm.selectedItems = selectedThreads;
		vm.reload = false;
		vm.views = {
			default: 'app/main/apps/media/dialogs/edit-multiple-fields/views/set-geolocation.html',
		};
		vm.defaultView = 'default';
		vm.currentView = 'default';
		vm.galleriesAsigned = [];

		vm.fields = {
				geoLat: null,
				geoLon: null,
				title: null,
				photographer: null,
				credits: null,
				owner: null,
				caption: null,
				city: null,
				country: null,
				uses: null,
				extras: null,
				rating: null,
			}
		// Methods
		//
		vm.toggleInArray = msUtils.toggleInArray;
		vm.existInArray = msUtils.existInArray;
		vm.exists = msUtils.exists;
		vm.saveMass = saveMass;
		vm.closeDialog = closeDialog;
		vm.changeView = changeView;

		vm.initGeolocation = initGeolocation;
		vm.placeMarker = placeMarker;
		vm.searchLatLon = searchLatLon;
		vm.getpos = getpos;
        vm.searchTagText = null;
        vm.selectedTag = null;
        vm.createFilterFor = createFilterFor;
        vm.selectedItemChange = selectedItemChange;
        vm.labelQuerySearch = labelQuerySearch;
        vm.translate = function(text) {
            return $translate.instant(text);
        }
        vm.newTag = newTag;
        vm.tags = sessionService.site_operative.tags;
		vm.currentTags = [];
		var siteID = requestContext.getParam("siteId");


		//////////

		function closeDialog() {
			$mdDialog.hide(vm.reload);
		}

		function changeView(view) {
			if (vm.views[view]) {
				vm.loadingView = true;
				vm.defaultView = view;
				vm.currentView = view;
				if (view === 'default') initGeolocation();
			}
		}

		function placeMarker() {
			var loc = this.getPlace()
				.geometry.location;
			vm.latlng = [loc.lat(), loc.lng()];
			vm.fields.geoLat = loc.lat();
			vm.fields.geoLon = loc.lng();
			vm.center = [loc.lat(), loc.lng()];
		}

		function searchLatLon() {

			vm.latlng = [vm.fields.geoLat, vm.fields.geoLon];
			vm.center = [vm.fields.geoLat, vm.fields.geoLon];
			vm.center = [40.74, -74.18];
			// NgMap.getMap({
			// 		id: 'mapa'
			// 	})
			// 	.then(function (map) {
			// 		google.maps.event.trigger(map, 'resize');
			// 	});
		}

		function getpos(event) {
			vm.fields.geoLat = event.latLng.lat();
			vm.fields.geoLon = event.latLng.lng();
			vm.latlng = [event.latLng.lat(), event.latLng.lng()];
		};

		function saveMass() {
			var mediaIDs = [];
			for (var i = 0; i < vm.selectedItems.length; i++) {
				mediaIDs.push(vm.selectedItems[i].id_media);
			}

			var fields = {};
			angular.forEach(vm.fields, function (value, key) {
				if (!_.isNull(value) && value != 0) {
					this[key] = value;
				}
			}, fields);

			if (_.isEmpty(fields) && _.isEmpty(vm.currentTags)) return false;
			var options = {
				site: siteID,
				data: {
					id_media: mediaIDs,
					fields: fields,
                    tags: vm.currentTags
					// fields: {
					// 	geoLat: vm.fields.geoLat,
					// 	geoLon: vm.fields.geoLon
					// }
				}
			};
			mediaService.massUpdate(options)
				.then(function (response) {
					vm.reload = true;
					var message = $translate.instant('MEDIA.ITEMS_UPDATED_PLURAL');
					$mdToast.show({
						template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + mediaIDs.length + message + '</span></div></md-toast>',
				    	hideDelay: 5000,
				    	position: 'top',
				    	parent: '#content-container'
					});
					vm.closeDialog();
				});
		}

		function initGeolocation() {
			vm.fields.geoLat = 0;
			vm.fields.geoLon = 0;
			vm.center = [vm.fields.geoLat, vm.fields.geoLon];
			vm.latlng = [vm.fields.geoLat, vm.fields.geoLon];
		}

        function selectedItemChange() {
            vm.searchTagText = '';
            vm.selectedTag = null;
        }


        /**
         * Add label chips
         *
         * @param query
         * @returns {filterFn}
         */
        function labelQuerySearch(query) {
          var ret = [];
          if (query) {
            var filteredContent = angular.copy(vm.tags.filter(vm.createFilterFor(query)));
            if (filteredContent.length > 0) {
              ret.push({
                id_tag: 0,
                tag_name: "",
                order: 1
              });
            }
            angular.forEach(filteredContent, function(val) {
              ret.push(val);
            })
          }
          return ret;
        }

        /**
         * Filter for chips
         *
         * @param query
         * @returns {filterFn}
         */
        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(item) {
                if (angular.isUndefined(item.tag_name))
                {
                    return false;
                }
                if (!item.tag_name)
                {
                    return false;
                }
                if (!angular.lowercase(item.tag_name.toString()).indexOf)
                {
                    return false;
                }
                return angular.lowercase(item.tag_name.toString()).indexOf(lowercaseQuery) >= 0;
            };
        }

        function newTag(tagName) {
            var newTag = {
                id_tag: '',
                tag_name: tagName
            };
            var options = {
                site: siteID,
                item: newTag
            };
            tagsService.saveItem(options).then(function (response) {
                newTag.id_tag = response.id_tag;
                vm.tags.push(newTag);
                vm.currentTags.push(newTag);
                vm.searchTagText = '';
            })
        }

    }
})();

(function () {
	'use strict';

	angular
		.module('app.match-center', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

		$stateProvider.state('app.fixture', {
			url: '/fixture',
			views: {
				'content@app': {
					templateUrl: 'app/main/apps/match-center/match-center.html',
					controller: 'MatchCenterController as vm'
				}
			},
			bodyClass: 'content'
		});

		$stateProvider
			.state('app.site_overview.fixture', {
				abstract: true,
				url: '/fixture',
				onEnter: function ($stateParams) {

				},
				data: {
					displayName: '{{section}}'
				},
				resolve: {
					section: function ($stateParams) {
						return $stateParams.section
					},
				},
			})

			.state('app.site_overview.fixture.livecenter', {
				url: '/livecenter',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/match-center/match-center-live.html',
						controller: 'MatchCenterController as vm'
					}
				},
				onEnter: function () {
				},
				data: {
					displayName: 'List {{section}}'
				},
				resolve: {
				},
			})
			.state('app.site_overview.fixture.list', {
				url: '',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/match-center/match-center.html',
						controller: 'MatchCenterController as vm'
					}
				},
				onEnter: function () {
				},
				data: {
					displayName: 'List {{section}}'
				},
				resolve: {
				},
			})
			.state('app.site_overview.match-center.list.thread', {
				url: '/:id',
				bodyClass: 'content'
			})

		$translatePartialLoaderProvider.addPart('app/main/apps/match-center');

	}
})();



(function () {
    'use strict';

    angular
        .module('app.match-center')
        .constant('_', window._)
        .controller('TeamsDialogController', TeamsDialogController);

    /** @ngInject */
    function TeamsDialogController($mdDialog, $translate, skipLoad, matchCenterService, teams, sectionTeams, sectionTeamsId, sectionTeamsName,
        ref, siteID, data, typesMatch, currentCompetitionSeason, sport, key, referenceSections, maxteams, $scope, transformMatchCenter, contentService, $filter) {
        var vm = this;
        vm.data = data;
        vm.currentCompetitionSeason = currentCompetitionSeason;
        vm.typesMatch = typesMatch;
        vm.key = key;
        vm.sport = sport;
        vm.siteID = siteID;
        vm.teams = teams;
        vm.teamsLoaded = teams;
        vm.sectionTeams = sectionTeams;
        vm.sectionTeamsId = sectionTeamsId;
        vm.sectionTeamsName = sectionTeamsName;
        vm.ref = ref;
        vm.skipLoad = skipLoad;
        vm.select = select;
        vm.isSelected = isSelected;
        vm.maxteams = maxteams;
        vm.referenceSections = referenceSections;
        vm.copyData = angular.copy(data);
        vm.saveDialog = saveDialog;
        vm.closeDialog = closeDialog;
        vm.maxTeamsValidation = maxTeamsValidation;
        vm.getReferenceSectionData = getReferenceSectionData;
        vm.showAllTeams = showAllTeams;
        vm.selected = [];
        vm.searchQuery = '';
        vm.getTeams = getTeams;
        vm.checkAllTeams = 0;
        vm.filterTeams = {};
        vm.filterTeams[vm.sectionTeamsName] = '';
        vm.showAll = false;
        vm.getTeams('');
        vm.firstLoadedTeams = teams;

        vm.translate = function (text) {
            return $translate.instant(text);
        }

        function getTeams(search) {
            vm.filterTeams['onoff'] = 1;
        
            if (!vm.skipLoad || vm.showAll) {
                vm.filterTeams[vm.sectionTeamsName] = '';
                $scope.loading = true;
        
                var options = {
                    site: vm.siteID,
                    search: search
                };
        
                matchCenterService.getContentSection(options, vm.sectionTeams).then(function (response) {
                    vm.teams = angular.copy(response.result.data);
                    vm.ref = response.ref;
                    vm.total = response.result.total;
        
                    vm.teamsLoaded = angular.copy(vm.teams);
        
                    filterTeams(search);
        
                    $scope.loading = false;
                });
        
            } else {
                if(vm.firstLoadedTeams) {
                    vm.teams = angular.copy(vm.firstLoadedTeams);
                } else {
                    vm.teams = angular.copy(teams);
                }
            }
        }
        
        function filterTeams(search) {
            if (vm.teamsLoaded && vm.teamsLoaded.length > 0) {
                vm.teams = angular.copy(vm.teamsLoaded);
        
                vm.teams = _.filter(vm.teams, function (team) {
                    return _.filter(vm.data[vm.key], function (_team) {
                        return _team[vm.sectionTeamsId] == team[vm.sectionTeamsId];
                    }).length == 0;
                });
        
                if (search) {
                    vm.teams = _.filter(vm.teams, function (team) {
                        return team.team_name.toLowerCase().includes(search.toLowerCase());
                    });
                }
        
                if (vm.filterTeams['onoff']) {
                    vm.teams = _.filter(vm.teams, function (team) {
                        return !team.hasOwnProperty('onoff') || team.onoff === 1;
                    });
                }
            }
        }
        
        function showAllTeams() {
            if (vm.filterTeams['onoff']) {
                delete vm.filterTeams['onoff'];
            } else {
                vm.filterTeams['onoff'] = 1;
            }
        
            filterTeams(vm.searchQuery);
        }
        
        $scope.onSearchChange = function(searchTerm) {
            filterTeams(searchTerm);
        };

        function select(item) {
            if (isSelected(item)) {
                vm.selected = _.filter(vm.selected, function (x) {
                    return x[vm.sectionTeamsId] != item[vm.sectionTeamsId]
                })
            } else {
                vm.selected.push(angular.copy(item));
            }
        }

        function isSelected(item) {
            var result = _.find(vm.selected, function (x) {
                return x[vm.sectionTeamsId] == item[vm.sectionTeamsId]
            }) != undefined;
            return result;
        }

        function maxTeamsValidation() {
            if (vm.maxteams) {
                var previousSelected = data[vm.key].length;
                var currentSelected = _.filter(vm.selected, function (item) {
                    return item;
                }).length;
                return vm.maxteams < previousSelected + currentSelected;
            } else {
                return false;
            }
        }

        function saveDialog() {
            if (!vm.data[vm.key]) {
                vm.data[vm.key] = [];
            }
            for (var i = 0; i < vm.selected.length; i++) {
              if (!vm.skipLoad || vm.showAll) {
                console.log(1);
                vm.data[vm.key].push(toTeamRef(vm.selected[i]));
              } else {
                console.log(2);
                vm.data[vm.key].push(toTeamInMatch(vm.selected[i]));
              }
            }
            data = vm.data;
            $mdDialog.hide(true);
        }

        function closeDialog() {
            data = vm.copyData;
            $mdDialog.hide();
        }

        function getReferenceSectionData(key, property, value) {
            switch (property) {
                case 'id_subsec':
                    var fieldReturn = 'subsec';
                    break;
                case 'id_cat':
                    var fieldReturn = 'cat';
                    break;
                case 'id_subcat':
                    var fieldReturn = 'subcat';
                    break;
                default:
                    var fieldReturn = 'cat';
            }

            if (!angular.isUndefined(vm.referenceSections[key])) {
                for (var i = 0, len = vm.referenceSections[key].length; i < len; i++) {
                    if (vm.referenceSections[key][i][property] === value) return vm.referenceSections[key][i][fieldReturn];
                }
            }
            return "--";

        }

        function toTeamRef(team) {
            var result = {}
            for (var i = 0; i < vm.ref.length; i++) {
                const element = vm.ref[i];
                if (element.in_json_object == 1) {
                    if (element.type == 'thumbnail') {
                      if (element.id_zone) {
                        var thumb = $filter('filter')(team.Thumbnail, {id_zone: element.id_zone}, true);
                        result[element.titleId] = thumb.length > 0 ? transformMatchCenter.setItemMedia(thumb[0], element) : team[element.titleId];
                      } else {
                        result[element.titleId] = team.Thumbnail && team.Thumbnail.length > 0 ? transformMatchCenter.setItemMedia(team.Thumbnail[0], element) : team[element.titleId];
                      }
                    } else if (element.type == 'id_subsec') {
                        result[element.titleId] = vm.getReferenceSectionData('subsection', element.type, team[element.titleId])
                    } else if (element.type == 'id_cat') {
                        result[element.titleId] = vm.getReferenceSectionData('cat', element.type, team[element.titleId])
                    } else if (element.type == 'id_subcat') {
                        result[element.titleId] = vm.getReferenceSectionData('subcat', element.type, team[element.titleId])
                    } else if (element.type == 'json') {
                        result[element.titleId] = angular.fromJson(team[element.titleId]);
                    } else if (element.type == 'jsondata') {
                        result[element.titleId] = angular.fromJson(team[element.titleId]);
                    } else {
                        result[element.titleId] = team[element.titleId];
                    }
                }
            }
            if (!result.team_name){
                result.team_name = result[vm.sectionTeamsName];
            }
            if (!result.id_teams){
                result.id_teams = result[vm.sectionTeamsId];
            }
            result.score = 0;
            result.points = 0;
            result.penalties = 0;
            if (vm.sport == 'tennis') {
                const matchType = vm.typesMatch.find(x => x.id === vm.currentCompetitionSeason.match_type);
                result.points = [];
                for (let i = 0; i < matchType.num_sets; i++) {
                    result.points.push(0);
                }
            }
            return result;
        }

        function toTeamInMatch(team) {
          team.score = 0;
          team.points = 0;
          team.penalties = 0;
          if (vm.sport == 'tennis') {
            const matchType = vm.typesMatch.find(x => x.id === vm.currentCompetitionSeason.match_type);
            team.points = [];
            for (let i = 0; i < matchType.num_sets; i++) {
              team.points.push(0);
            }
          }
          return team;
        }


    }
})();

(function () {
	'use strict';

	angular
		.module('app.media')
		.controller('AddMediaToGalleriesDialogController', AddMediaToGalleriesDialogController);

	/** @ngInject */
	function AddMediaToGalleriesDialogController(
		$mdDialog,
		$document,
		mediaService,
		requestContext,
		$anchorScroll,
		$timeout,
		$scope,
		$mdToast,
		$translate,
		$sce,
		Upload,
		msUtils,
		COMMON,
		$log,
		NgMap,
		selectedThreads,
		CleanMediaGalleries,
		transformMedia) {
		//
		var vm = this;

		// Data
		vm.selectedItems = selectedThreads;
		vm.reload = false;
		vm.views = {
			default: 'app/main/apps/media/dialogs/add-media-galleries/views/add-media-galleries.html',
		};
		vm.defaultView = 'default';
		vm.currentView = 'default';
		vm.CleanMediaGalleries = angular.copy(CleanMediaGalleries);
		transformMedia.preAssignQiuRestrictedRoot(vm.CleanMediaGalleries);
		vm.fields = {
				geoLat: null,
				geoLon: null,
				title: null,
				photographer: null,
				credits: null,
				owner: null,
				caption: null,
				city: null,
				country: null,
				uses: null,
				extras: null,
				rating: null
			}
		// Methods
		//
		vm.toggleInArray = msUtils.toggleInArray;
		vm.existInArray = msUtils.existInArray;
		vm.exists = msUtils.exists;
		vm.saveMediaGalleries = saveMediaGalleries;
		vm.closeDialog = closeDialog;
		vm.changeView = changeView;

		var siteID = requestContext.getParam("siteId");


	function getAssignedGalleriesIds (galleries, result) {

		angular.forEach(galleries, function(gallery) {
			if (gallery.assigned_gallery == true && !gallery.no_files_allowed) {
				result.push(gallery.id_gallery);
			}
			if (typeof gallery.children !== 'undefined' && gallery.children.length >0) {
				getAssignedGalleriesIds(gallery.children, result);
			}
		});
		return result;
	}

		//////////

		/**
		 * Add Multiple Media Items to multiple Galleries
		 * @return bool [description]
		 */
		function saveMediaGalleries() {
			vm.isLoading = true;
			var mediaIDs = [];
			for (var i = 0; i < vm.selectedItems.length; i++) {
				mediaIDs.push(vm.selectedItems[i].id_media);
			}
			var galleriesAssigned = getAssignedGalleriesIds(vm.CleanMediaGalleries, []);

			var options = {
				site: siteID,
				data: {
					id_media: mediaIDs,
					id_gallery: galleriesAssigned
				}
			};

			mediaService.insertIntoGallery(options)
				.then(function (response) {
					vm.reload = true;
					var message = $translate.instant('MEDIA.ADDTOGALLERIES_PLURAL');
					$mdToast.show({
						template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + mediaIDs.length + message + '</span></div></md-toast>',
						hideDelay: 7000,
						position: 'top right',
						parent: '#main'
					});
					vm.isLoading = false;
					vm.closeDialog();
				});
		}

		function closeDialog() {
			$mdDialog.hide(vm.reload);
		}

		function changeView(view) {
			if (vm.views[view]) {
				vm.loadingView = true;
				vm.defaultView = view;
				vm.currentView = view;
				if (view === 'setgeolocation') initGeolocation();
			}
		}

	}
})();



(function () {
    'use strict';

    angular
        .module('app.match-center')
        .constant('_', window._)
        .controller('VenuesDialogController', VenuesDialogController);

    /** @ngInject */
    function VenuesDialogController($mdDialog, $translate, msUtils, matchCenterService, data, siteID, settings, $scope, transformMatchCenter) {
        var vm = this;
        vm.data = data;
        vm.settings = settings;
        vm.siteID = siteID;
        vm.copyData = angular.copy(data);
        vm.saveDialog = saveDialog;
        vm.closeDialog = closeDialog;
        vm.select = select;
        vm.isSelected = isSelected;
        vm.getVenues = getVenues;
        vm.selected = [];
        $scope.loading = true;
        vm.searchQuery = '';
        vm.getVenues();
        vm.toggleAll = function () {
            var value = _.filter(vm.selected, function (item) {
                return item == true;
            }).length == 0;
            for (var i = 0; i < vm.selected.length; i++) {
                vm.selected[i] = value;
            }
        }

        function select(item) {
            if (isSelected(item)) {
                vm.selected = _.filter(vm.selected, function (x) {
                    return x.id_venues != item.id_venues
                })
            } else {
                vm.selected.push(angular.copy(item));
            }
        }

        function isSelected(item) {
            var result = _.find(vm.selected, function (x) {
                return x.id_venues == item.id_venues
            }) != undefined;
            return result;
        }


        function getVenues(search) {

            var options = {
                site: vm.siteID,
                search: search
            };
            matchCenterService.getContentSection(options, 'venues').then(function (response) {
                vm.venues = angular.copy(response.result.data);
                vm.ref = response.ref;
                vm.referenceSections = response.reference_sections;
                vm.venues = _.filter(vm.venues, function (venue) {
                    return _.filter(vm.data.venues, function (_venue) {
                        return _venue.id_venues == venue.id_venues;
                    }).length == 0;
                });

                $scope.loading = false;
            });
        }

        vm.translate = function (text) {
            return $translate.instant(text);
        }


        function saveDialog() {
            if (!vm.data.venues) {
                vm.data.venues = [];
            }
            for (var i = 0; i < vm.selected.length; i++) {
                vm.data.venues.push(toSectionRef(vm.selected[i], vm.ref));
            }
            data = vm.data;
            $mdDialog.hide(true);
        }

        function toSectionRef(data, ref) {
            var result = {}
            for (var i = 0; i < ref.length; i++) {
                const element = ref[i];
                if (element.in_json_object == 1) {
                    if (element.type == 'thumbnail') {
                        result[element.titleId] = data.Thumbnail && data.Thumbnail.length > 0 ? msUtils.setItemMedia(data.Thumbnail[0]) : data[element.titleId];
                    } else if (element.type == 'id_subsec') {
                        result[element.titleId] = getReferenceSectionData('subsection', element.type, data[element.titleId])
                    } else {
                        result[element.titleId] = data[element.titleId];
                    }
                }
            }
            return result;
        }


        function getReferenceSectionData(key, property, value) {
            switch (property) {
                case 'id_subsec':
                    var fieldReturn = 'subsec';
                    break;
                case 'id_cat':
                    var fieldReturn = 'cat';
                    break;
                case 'id_subcat':
                    var fieldReturn = 'subcat';
                    break;
                default:
                    var fieldReturn = 'cat';
            }

            if (!angular.isUndefined(vm.referenceSections[key])) {
                for (var i = 0, len = vm.referenceSections[key].length; i < len; i++) {
                    if (vm.referenceSections[key][i][property] === value) return vm.referenceSections[key][i][fieldReturn];
                }
            }
            return "--";

        }

        function closeDialog() {
            data = vm.copyData;
            $mdDialog.hide();
        }



    }
})();


(function () {
    'use strict';

    angular
        .module('app.match-center')
        .constant('_', window._)
        .controller('TitleClipDialogController', TitleClipDialogController);

    /** @ngInject */
    function TitleClipDialogController($mdDialog, $rootScope, create, $translate) {
        var vm = this;

        vm.title = "";
        vm.create = create;

        // vm.clipUrl = clipUrl;

        vm.saveDialog = saveDialog;
        vm.saveDialogAndEdit = saveDialogAndEdit;
        vm.closeDialog = closeDialog;

        vm.translate = function (text) {
            return $translate.instant(text);
        }


        function saveDialogAndEdit() {
            $mdDialog.hide({ title: vm.title, edit: true });
        }
        function saveDialog() {
            $mdDialog.hide({ title: vm.title, edit: false });
        }

        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();





(function () {
    'use strict';

    angular
        .module('app.match-center')
        .constant('_', window._)
        .controller('TeamEditController', TeamEditController);

    /** @ngInject */
    function TeamEditController($mdDialog, $translate, utilMatchCenterService, $document, data, siteId, id_subsec, $scope) {
        var vm = this;
        vm.team = angular.copy(data);

        vm.siteId = siteId;
        vm.copyData = angular.copy(data);
        vm.activeTab = 0;
        getSportFiles(id_subsec);
        vm.saveDialog = saveDialog;
        vm.closeDialog = closeDialog;
        vm.openDialog = openDialog;
        vm.translate = function (text) {
            return $translate.instant(text);
        }
        vm.templateSortable = {
            group: '.template',
            forceFallback: true,
            handle: '.drag',
            ghostClass: 'drag-item-placeholder',
            fallbackClass: 'drag-item-ghost',
            fallbackOnBody: true,
            sort: true
        }
        function saveDialog() {
            data = vm.team;
            $mdDialog.hide(data);
        }

        function closeDialog() {
            data = vm.copyData;
            $mdDialog.hide();
        }


        function getSportFiles(id_subsec) {
            var sport = utilMatchCenterService.getSport(id_subsec)
            if (sport) {
                utilMatchCenterService.getFile({ sport: sport, file: 'tabs-team.json' }, true).then(function (res) {
                    vm.tabs = res;
                    try {
                        if (typeof vm.team.lineup_type == "number") {
                            var optionsLineup = _.find(vm.tabs, function (x) {
                                return x.lineuptype != undefined
                            })
                            optionsLineup = optionsLineup.lineuptype.options;
                            var option = _.find(optionsLineup, function (x) {
                                return x.id == vm.team.lineup_type
                            });
                            vm.team.lineup_type = {
                                id: vm.team.lineup_type,
                                value: option.value
                            }
                        }
                    } catch (error) {
                        console.log(error)
                    }
                })
            }
        }

        function openDialog(ev, label, section) {
            if (!vm.team[label.section]) {
                vm.team[label.section] = [];
            }
            $mdDialog.show({
                controller: 'PeopleDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/match-center/dialogs/people/people-dialog.html',
                preserveScope: true,
                autoWrap: true,
                multiple: true,
                locals: {
                    siteId: vm.siteId,
                    peopleSection: section,
                    team: vm.team,
                    tabs: vm.tabs,
                    title: section,
                    data: vm.team[label.section],
                    label: label,
                    event: ev
                }
            })
              .then(function (response) {
                if (response) {
                  if (angular.isArray(vm.team[label.section])) {
                    angular.forEach(response, function(people) {
                      vm.team[label.section].push(people);
                    });
                  } else {
                    vm.team[label.section] = response;
                  }
                }
              });
        }


    }
})();



(function () {
    'use strict';

    angular
        .module('app.match-center')
        .constant('_', window._)
        .controller('TeamStatusDialogController', TeamStatusDialogController);

    /** @ngInject */
    function TeamStatusDialogController($mdDialog, $translate, team) {
        var vm = this;
        vm.team = angular.copy(team);
        if (!vm.team.status) {
            vm.team.status = {
                value: "",
                comment: ""
            };
        }
        vm.saveDialog = saveDialog;
        vm.closeDialog = closeDialog;
        vm.translate = function (text) {
            return $translate.instant(text);
        }

        function saveDialog() {
            $mdDialog.hide(vm.team);
        }

        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();


(function () {
    'use strict';

    angular
        .module('app.match-center')
        .constant('_', window._)
        .controller('SettingsTabsDialogController', SettingsTabsDialogController);

    /** @ngInject */
    function SettingsTabsDialogController($mdDialog, $filter, $translate, $mdToast, siteID, data, $scope, transformMatchCenter, contentService) {
        var vm = this;
        vm.data = $filter('orderBy')(data, 'sort');
        vm.siteID = siteID;
        vm.saveDialog = saveDialog;
        vm.closeDialog = closeDialog;
        vm.toggleItemStatusTab = toggleItemStatusTab;
        vm.translate = function (text) {
            return $translate.instant(text);
        }
        vm.templateSortable = {
            group: '.template',
            forceFallback: true,
            handle: '.drag',
            ghostClass: 'drag-item-placeholder',
            fallbackClass: 'drag-item-ghost',
            fallbackOnBody: true,
            sort: true
        }


        vm.templateSortable = {
            group: '.template',
            animation: 150,
            scroll: true,
            handle: '.drag',
            ghostClass: 'drag-item-placeholder',
            fallbackClass: 'drag-item-ghost',
            onEnd: function (evt) {
                var oldSort = evt.model.sort;
                var items = [];

                // Reassign sort values for affected items
                if (evt.newIndex > evt.oldIndex) {
                    evt.model.sort = evt.models[evt.newIndex - 1].sort;
                    for (var i = evt.newIndex - 1; i > evt.oldIndex; i--) {
                        evt.models[i].sort = evt.models[i - 1].sort;
                        items.push(evt.models[i]);
                    }
                }
                if (evt.newIndex < evt.oldIndex) {
                    evt.model.sort = evt.models[evt.newIndex + 1].sort;
                    for (var i = evt.newIndex + 1; i < evt.oldIndex; i++) {
                        evt.models[i].sort = evt.models[i + 1].sort;
                        items.push(evt.models[i]);
                    }
                }
                evt.models[evt.oldIndex].sort = oldSort;
                items.push(evt.models[evt.oldIndex]);
                items.push(evt.model);

                for (var i = 0; i < items.length; i++) {
                    const item = items[i];
                    var options = {
                        site: vm.siteID,
                        section: 'matches_tabs',
                        id: item.id,
                        item: item
                    };
                    contentService.saveItem(options).then(function (response) {
                        var message = $translate.instant('MATCH_CENTER.SAVED');
                        $mdToast.show({
                            template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                            hideDelay: 2000,
                            position: 'top',
                            parent: '#content-container'
                        });
                    });

                }
                console.log(items);
            }
        }


        function toggleItemStatusTab(tab) {
            event.stopPropagation();
            // vm.loadingCommentsPane = true;
            tab.onoff = (tab.onoff === 1)
                ? 0
                : 1;

            var options = {
                site: vm.siteID,
                section: 'matches_tabs',
                id: tab.id,
                item: tab,
            };
            contentService.saveItem(options).then(function (response) {
                var message = $translate.instant('MATCH_CENTER.SAVED');
                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                    hideDelay: 2000,
                    position: 'top',
                    parent: '#content-container'
                });
            });
        }



        function saveDialog() {
            $mdDialog.hide(true);
        }

        function closeDialog() {
            $mdDialog.hide();
        }



    }
})();

!function () { var t, n = document.createElement("pre"), h = document.createElement("canvas"), r = h.getContext("2d"), i = { font: "Sans-serif", align: "left", color: "#000000", size: 16, background: "rgba(0, 0, 0, 0)", stroke: 0, strokeColor: "#FFFFFF", lineHeight: "1.2em", bold: !1, italic: !1 }; function s(t) { t = String(t), n.innerText = t, n.setAttribute("style", this._style), document.body.append(n); var e = t.split("\n"), i = this.style.stroke, s = n.offsetHeight / e.length, l = .25 * s; h.width = n.offsetWidth + 2 * i, h.height = n.offsetHeight, r.clearRect(0, 0, h.width, h.height), r.fillStyle = this.style.background, r.beginPath(), r.fillRect(0, 0, h.width, h.height), r.fill(); var o = ""; switch (this.style.italic && (o += "italic "), this.style.bold && (o += "bold "), o += this.style.size + "pt " + this.style.font, r.font = o, r.textAlign = this.style.align, r.lineWidth = this.style.stroke, r.strokeStyle = this.style.strokeColor, r.fillStyle = this.style.color, r.textAlign) { case "center": i = h.width / 2; break; case "right": i = h.width - i }e.forEach(function (t, e) { this.style.stroke && r.strokeText(t, i, s * (e + 1) - l), r.fillText(t, i, s * (e + 1) - l) }.bind(this)), document.body.removeChild(n) } window.TextImage = function (t) { return this instanceof TextImage ? (this.setStyle(t), this) : new TextImage(t) }, (t = window.TextImage.prototype).setStyle = function (t) { for (var e in this.style = t || {}, i) this.style[e] || (this.style[e] = i[e]); return this._style = "font: ", this.style.italic && (this._style += "italic "), this.style.bold && (this._style += "bold "), this._style += this.style.size + "pt " + this.style.font + ";", this._style += "line-height:" + this.style.lineHeight + ";", this._style += "text-align: " + this.style.align + ";", this._style += "color: " + this.style.color + ";", this._style += "background-color: " + this.style.background + ";", this._style += ";padding: 0; display: block; position: fixed; top: 100%; overflow: hidden;", this }, t.toDataURL = function (t) { return t && s.call(this, t), h.toDataURL() }, t.toImage = function (t, e) { s.call(this, t); var i = new Image; return e && (i.onload = e), i.src = h.toDataURL(), i } }();




(function () {
  'use strict';

  angular
    .module('app.match-center')
    .constant('_', window._)
    .controller('SelectTextDialogController', SelectTextDialogController);

  /** @ngInject */
  function SelectTextDialogController($scope, $mdDialog, mediaService, $timeout, Upload, siteID, templateBuilderConfig) {
    var vm = this;
    $scope.isLoading = false;
    vm.text = "";
    vm.fontfamily = templateBuilderConfig.blocks.text.defaultOptions.font.family;
    vm.fontfamilyOptions = templateBuilderConfig.blocks.text.defaultOptions.font.familyOptions;
    vm.weight = 'bold';
    vm.weightOptions = ["bold", "bolder", "lighter", "inherit", "initial", "normal", 100, 200, 300, 400, 500, 600, 700, 800, 900];
    vm.fontsize = 14;
    vm.color = "#000000";
    vm.templateBuilderConfigOptions = templateBuilderConfig.defaults.emailOptions;
    console.log(vm.templateBuilderConfigOptions);
    vm.saveDialog = saveDialog;
    vm.closeDialog = closeDialog;

    function saveDialog() {
      $scope.isLoading = true;
      var item = {
        text: vm.text,
        weight: vm.weight,
        fontfamily: vm.fontfamily,
        fontsize: vm.fontsize,
        color: vm.color
      };
      var rgb = hexToRgb(item.color);
      var style = {
        "font": item.fontfamily,
        "color": "rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + ", 1)",
        "size": item.fontsize * 2,
        "background": "rgba(0, 0, 0, 0)",
        "stroke": 1,
        "strokeColor": "rgba(0, 0, 0, 1)",
        "lineHeight": "1",
        "bold": item.weight === 'bold' ? true : false,
        "italic": false
      };
      var textImage = TextImage(style);
      var dataUrl = textImage.toDataURL(item.text);
      var file = convertToBlob(dataUrl);
      file.name = item + '.png';
      upload(file, dataUrl, item);

    }

    function upload(file) {
      // console.log("file upload ", file)
      if (!file.$error) {

        //                console.debug("UPLOAD______****", file)
        mediaService.getS3UploadPreSignedUrlClip({
          siteID: siteID,
          fileName: file.name
        })
          .then(function (resp) {
            // console.log("resp upload ", resp)
            file.name = resp.fileName;
            file.url = resp.preSignedUrl;
            file.upload = Upload.http({
              url: resp.preSignedUrl,
              skipAuthorization: true,
              method: 'PUT',
              headers: {
                "Content-Type": file.type != '' ? file.type : 'application/octet-stream'
              },
              data: file
            });

            file.upload.then(function (response) {
              // console.log('full res ', response)

              $timeout(function () {
                $scope.log = 'file: ' +
                  file.name +
                  ', Response: ' + JSON.stringify(response.data) +
                  ', ID: ' + file.id_media +
                  '\n' + $scope.log;
              });
              //                        console.debug("SEND_TO_CROP______****", file)
              mediaService.finishedUploadingFileToCdnClip({
                siteID: siteID,
                filename: file.name
              }).then(response => {
                $scope.isLoading = false;
                $mdDialog.hide({
                  preSignedUrl: response.preSignedUrl,
                  s3Url: response.s3Url
                });
              })
            }, function (response) {
              if (response.status > 0)
                $scope.errorMsg = response.status + ': ' + response.data;
            });

            file.upload.progress(function (evt) {
              // console.log("evt ", evt)
              file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
            });

          })
      }
    };


    function hexToRgb(hex) {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      } : null;
    }



    function convertToBlob(imgData) {
      var byteString = atob(imgData.split(',')[1]);
      var mimeString = imgData.split(',')[0].split(':')[1].split(';')[0];
      var ab = new ArrayBuffer(byteString.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ab], { 'type': mimeString });
    }



    function closeDialog() {
      $mdDialog.hide();
    }


  }
})();


(function () {
    'use strict';

    angular
        .module('app.match-center')
        .service("selectMediaDialogService", SelectMediaDialogService);

    /** @ngInject */
    // I provide access to the session store.
    function SelectMediaDialogService($rootScope) {

        function unnestGalleries(node, galleries, includeSubgalleries) {
            galleries.push(node);
            if (includeSubgalleries && typeof node.children !== 'undefined' && node.children.length > 0) {
                angular.forEach(node.children, function (data) {
                    unnestGroups(data, galleries, includeSubgalleries);
                });
            }
            return galleries;
        }

        function triggerMediaDialogMediaByGalleries(galleryNode, includeSubgalleries) {
            var galleries = false;
            if (galleryNode) {
                var node = angular.fromJson(galleryNode);
                galleries = unnestGalleries(node, [], includeSubgalleries);
            }
            $rootScope.$broadcast('loadMediaDialogMediaByGalleries', galleries);
        }

        // Return the public API.
        return ({
            triggerMediaDialogMediaByGalleries: triggerMediaDialogMediaByGalleries
        });
    }
})();
(function () {
  'use strict';

  angular
    .module('app.match-center')
    .directive('qiuSelectMediaDialogOnClickLoadMediaByGalleries', ['selectMediaDialogService', loadSelectMediaDialogMediaByGalleries])
    .controller('SelectMediaDialogController', SelectMediaDialogController)
    ;

  /** @ngInject */
  function SelectMediaDialogController(
    $mdDialog,
    $document,
    currentThread,
    mediaService,
    requestContext,
    $anchorScroll,
    $timeout,
    $scope,
    $sce,
    Upload,
    mediazone,
    section,
    maxAttach,
    msUtils,
    showViews,
    COMMON,
    isTiny,
    $log,
    transformMedia,
    $translate,
    sessionService,
    tagsService,
    $q,
    $mdSidenav,
    $rootScope
  ) {
    var vm = this;

    // Data
    vm.currentThread = currentThread;
    vm.closeDialog = closeDialog;

    vm.mediazone = mediazone;
    vm.defaultPage = 1;
    vm.defaultPerPage = 50;
    vm.PerPage = 50;
    vm.searchStringFilter = '';
    vm.searchQuery = '';
    vm.modelSearch = '';
    vm.pagination_search = pagination_search;

    vm.maxAttach = !angular.isUndefined(maxAttach) ? maxAttach : 99999;

    vm.isTiny = isTiny;

    vm.views = {
      1: 'app/main/dialogs/media/views/photos-view.html',
      2: 'app/main/dialogs/media/views/videos-view.html'
    };


    angular.forEach(vm.views, function (value, key) {
      if (!showViews.hasOwnProperty(key) || showViews[key] !== true) {
        delete vm.views[key];
      }
    });

    vm.defaultView = showViews[1] ? 1 : 2;

    vm.currentView = 1;

    vm.viewsTiny = {
      1: 'app/main/dialogs/media/views/tiny-attached.html',
      properties: 'app/main/dialogs/media/views/tiny-properties.html',
      upload: 'app/main/dialogs/media/views/upload-view.html',
    };
    vm.defaultViewTiny = 1;
    vm.currentViewTiny = 1;

    vm.firstLoad = true;
    vm.media_type = 1;
    vm.showSearchAndPaginator = true;
    vm.import_field = '';
    vm.import_disabled = '';
    vm.importedFiles = [];
    vm.importPreview = false;
    vm.imported = false;
    vm.importing = false;
    vm.selectedContacts = [];
    vm.selectedGalleries = [];
    vm.files = [];
    vm.uploadFiles = [];
    vm.uploadedFiles = [];
    vm.tinyProperties = {
      mediaType: '',
      mediaSort: '',
      mediaData: {},
      align: '',
      size: ''
    };
    vm.tinyOptions = {
      size: [
        { value: 25, text: '25%' },
        { value: 50, text: '50%' },
        { value: 75, text: '75%' },
        { value: 100, text: '100%' }
      ],
      align: [
        { value: 'left', text: 'left' },
        { value: 'center', text: 'center' },
        { value: 'right', text: 'right' }
      ]
    }
    vm.searchTagText = '';
    vm.tags = sessionService.site_operative.tags;
    vm.currentTags = [];
    vm.selectedTag = null;
    vm.image = {};
    vm.newTagDisabled = false;

    vm.fields = {
      geoLat: null,
      geoLon: null,
      title: null,
      photographer: null,
      owner: null,
      caption: null,
      city: null,
      country: null,
      uses: null,
      extras: null,
      rating: null,
    };
    // If replying
    // if (angular.isDefined(selectedMail)) {
    //     vm.form.to = selectedMail.from.email;
    //     vm.form.subject = 'RE: ' + selectedMail.subject;
    //     vm.form.message = '<blockquote>' + selectedMail.message + '</blockquote>';
    // }

    // Methods
    vm.changeView = changeView;
    vm.changeViewTiny = changeViewTiny;
    vm.changeViewGallery = changeViewGallery;

    vm.nextPage = nextPage;
    vm.prevPage = prevPage;
    vm.morePages = morePages;
    vm.gotoPage = gotoPage;
    vm.firstPage = firstPage;
    vm.upload = upload;
    vm.attachMedia = attachMedia;
    vm.attachMediaTiny = attachMediaTiny;
    vm.selectMediaTiny = selectMediaTiny;
    vm.selectedMediaTiny = '';
    vm.search = search;

    vm.exists = msUtils.exists;
    vm.alreadySelectedbyZone = alreadySelectedbyZone;
    vm.existInArray = msUtils.existInArray;
    vm.toggleSelectContact = toggleSelectContact;
    vm.toggleSelectOne = toggleSelectOne;

    vm.selectedItemChange = selectedItemChange;
    vm.labelQuerySearch = labelQuerySearch;
    vm.createFilterFor = createFilterFor;
    vm.newTag = newTag;
    vm.getpos = getpos;
    vm.placeMarker = placeMarker;
    vm.searchLatLon = searchLatLon;
    vm.toggleMediaDialogSidenav = toggleMediaDialogSidenav;

    vm.isNumber = angular.isNumber;

    vm.translate = function (text) {
      return $translate.instant(text);
    }
    if (vm.defaultView == 2) {
      vm.changeView(2);
    }

    //////////

    if (!isTiny) {
      var siteID = requestContext.getParam("siteId");
      var section = requestContext.getParam("section");
      init();
    } else {
      vm.section = section;
      initTiny();
    }
    /**
     * Initialize
     */
    function init() {

      vm.loading = true;
      if (vm.currentThread.Thumbnail) {
        for (var i = 0; i < vm.currentThread.Thumbnail.length; i++) {
          vm.selectedContacts.push(vm.currentThread.Thumbnail[i]);
          if (angular.isDefined(vm.currentThread.Thumbnail[i].gallery_type)) {
            vm.selectedGalleries.push(vm.currentThread.Thumbnail[i]);
          }
        }
      }
      var options = {
        section: section,
        media_type: vm.media_type,
        page: vm.defaultPage,
        perPage: vm.defaultPerPage
      };
      //
      getData(options);
      getMediaGalleries(vm.media_type);

    }

    /**
     * Initialize Tinymce
     */
    function initTiny() {
      vm.currentViewTiny = vm.defaultViewTiny;
      vm.showSearchAndPaginator = false;
      vm.loading = true;
      for (var i = 0; i < vm.currentThread.length; i++) {
        if (vm.mediazone) {
          if (vm.currentThread[i].id_zone == 1) {
            vm.selectedContacts.push(vm.currentThread[i]);
          }
        } else {
          vm.selectedContacts.push(vm.currentThread[i]);
        }
      }
      if (vm.section.mediaSort) {
        var currentSort = 0;
        var currentItem = '';
        for (var i = 0; i < vm.currentThread.length; i++) {
          if (vm.mediazone) {
            if (vm.currentThread[i]['id_zone'] == 1 && (vm.currentThread[i]['media_type'] == vm.section.mediaType)) {
              currentSort++;
              if (currentSort == vm.section.mediaSort) {
                currentItem = vm.currentThread[i];
              }
            }
          } else {
            if (vm.currentThread[i]['media_type'] == vm.section.mediaType) {
              currentSort++;
              if (currentSort == vm.section.mediaSort) {
                currentItem = vm.currentThread[i];
              }
            }

          }
        }

        vm.selectedMediaTiny = currentItem;
        vm.tinyProperties.mediaSort = vm.section.mediaSort;
        vm.tinyProperties.mediaType = currentItem.media_type;
        vm.tinyProperties.align = vm.section.mediaAlign;
        vm.tinyProperties.size = vm.section.mediaSize;
        vm.changeViewTiny('properties');


      }
      vm.loading = false;

    }

    function closeDialog() {
      $mdDialog.hide();
    }

    $scope.$on('loadSelectMediaDialogMediaByGalleries', function (event, galleries) {
      if (galleries) {
        loadMediaByGalleries(galleries);
      } else {
        unselectGalleries();
      }
    })


    function unselectGalleries() {
      vm.selectedGallery = false;
      vm.selectedContent = false;
      $rootScope.pagination_galleryIds = false;
      $rootScope.sortField = "date_uploaded"; // reset to default
      $rootScope.sortDir = "DESC"; // reset to default
      var elemList = document.querySelectorAll('.gallery-row');
      elemList.forEach(function (elem) {
        elem.classList.remove('selected');
      });
      var options = {
        section: section,
        media_type: vm.media_type,
        page: vm.defaultPage,
        perPage: vm.defaultPerPage
      };
      getData(options);
    }

    function deselectFiles() {
      vm.files = [];
    }


    function pagination_search(searchString) {

      vm.loading = true;
      scrollToTopOfDialog();

      if (vm.selectedGallery) {
        loadMediaByGalleries([vm.selectedGallery]);
      } else {
        var options = {
          section: section,
          media_type: vm.media_type,
          page: vm.defaultPage,
          perPage: vm.defaultPerPage,
          searchString: searchString,
          gallery_type: vm.media_type
        };
        if (vm.media_type) {
          options.mediaTypeFilter = {
            'media_type': {
              selected: [vm.media_type],
              field: 'media_type',
              name: 'media_type'
            }
          }
        };

        getData(options);
      }
    }

    function getMediaGalleries(mediaType) {

      if (sessionService.site_operative.mediaGalleriesDefaultSort) {
        vm.sortFieldGalleries = sessionService.site_operative.mediaGalleriesDefaultSort.field;
        if (!angular.isUndefined(sessionService.site_operative.mediaGalleriesDefaultSort.dir)) {
          vm.sortDirGalleries = sessionService.site_operative.mediaGalleriesDefaultSort.dir;
        }
      } else {
        vm.sortFieldGalleries = "sort";
        vm.sortDirGalleries = "ASC"
      }

      var options = {
        siteID: siteID,
        sortField: vm.sortFieldGalleries,
        sortDir: vm.sortDirGalleries
      };
      if (angular.isNumber(mediaType)) {
        options['gallery_type'] = [mediaType, 0];
      }
      mediaService.getNestedMediaGalleries(options)
        .then(function (response) {
          var qiuRestrictions = response.qiuRestrictions;
          var galleries = response.data;
          /*
          vm.totalItems = response.total;
          vm.from = response.from;
          vm.to = response.to;
          vm.currentPage = response.current_page;
          vm.lastPage = response.last_page;
          vm.maxSize = 500;
          vm.bigTotalItems = 175;
          */

          var nestedGalleries = transformMedia.formatNestedGalleries(galleries, qiuRestrictions, true);
          vm.CleanMediaGalleries = angular.copy(nestedGalleries);
          transformMedia.preAssignQiuRestrictedRoot(vm.CleanMediaGalleries);
          if (vm.currentView == 5) {
            vm.items = getNestedGalleriesWithMediaAssignment(nestedGalleries, vm.selectedContacts);
            vm.loading = false;
          }
        });
    }


    function loadMediaByGalleries(galleries) {

      vm.loading = true;

      var galleryIds = [];
      angular.forEach(galleries, function (gallery) {
        galleryIds.push(gallery.id_gallery);
      });
      vm.selectedGallery = galleries[0];

      var mediaTypeFilter = {
        'media_type': {
          selected: [vm.media_type],
          field: 'media_type',
          name: 'media_type'
        }
      };

      if (sessionService.site_operative.mediaInGalleriesDefaultSort) {
        $rootScope.sortField = sessionService.site_operative.mediaInGalleriesDefaultSort.field;
        if (!angular.isUndefined(sessionService.site_operative.mediaInGalleriesDefaultSort.dir)) {
          $rootScope.sortDir = sessionService.site_operative.mediaInGalleriesDefaultSort.dir;
        }
      } else {
        $rootScope.sortField = "sort";
      }

      var options = {
        siteID: siteID,
        page: vm.defaultPage,
        resultsPerPage: vm.defaultPerPage,
        search: vm.modelSearch,
        withCropStatus: true,
        withMediaChildren: true,
        sortField: $rootScope.sortField,
        sortDir: $rootScope.sortDir,
        gallery_type: vm.media_type,
        galleryIds: galleryIds
      };

      if (vm.media_type) {
        options.mediaTypeFilter = {
          'media_type': {
            selected: [vm.media_type],
            field: 'media_type',
            name: 'media_type'
          }
        }
      };

      mediaService.getMediaInGalleries(options).then(function (response) {
        vm.totalItems = response.total;
        vm.from = response.from;
        vm.to = response.to;
        vm.currentPage = response.current_page;
        vm.lastPage = response.last_page;
        vm.maxSize = 500;
        vm.bigTotalItems = 175;
        vm.items = response.data;
        vm.loading = false;
      });
    }

    function getData(options) {

      vm.loading = true;
      scrollToTopOfDialog();

      var arrayOptions = {
        siteID: siteID,
        page: options.page,
        resultsPerPage: options.perPage,
        media_type: options.media_type,
        search: vm.modelSearch,
        withCropStatus: true,
        withMediaChildren: true,
        sortField: 'date_uploaded',

      };

      if (vm.modelSearch && !_.isEmpty(vm.modelSearch)) {
        arrayOptions['searchStringFilter'] = vm.modelSearch;
        // console.log("arrayOptions ", arrayOptions)
      }

      mediaService.get(arrayOptions)
        .then(function (response) {
          // console.log("response ", response)
          vm.totalItems = response.total;
          vm.from = response.from;
          vm.to = response.to;
          vm.currentPage = response.current_page;
          vm.lastPage = response.last_page;
          vm.maxSize = 500;
          vm.bigTotalItems = 175;
          vm.items = response.data;

          //angular.forEach(response.data, function (item) {
          /*
          if (item.media_type == 1) {
              if (item.cropstatus.length < 1) {
                  console.log(item.id_media, 'noImg');
              } else {
                  console.log(item.id_media, 'hasImg');
              }
          } else {
              if (item.thumb) {
                  console.log(item.id_media, 'hasThumb');
              } else {
                  console.log(item.id_media, 'hasEmbedThumb');
              }
          }
          */
          //vm.items.push(item);
          // console.log('vm.items  ', vm.items)
          //})

          $('.md-button')
            .removeClass('active');
          $('[type=' + options.media_type + ']')
            .addClass('active');

          vm.loading = false;
          vm.firstLoad = false;
        })
    }
    function search(options) {
      // console.log(options, vm.searchStringFilter);
      /*

      vm.loading         = true;
      vm.items        =[];
      // Scroll to the top Dialog
      scrollToTopOfDialog();

      mediaService.get({
          siteID: siteID,
          page: options.page,
          paginate: options.perPage,
          media_type: options.media_type,
          withCropStatus: true,
          sortField: 'date_uploaded',
          searchStringFilter: options.searchString,

      })
          .then(function (response) {
              vm.totalItems = response.total;
              vm.pagination_totalItems = response.total;
              vm.from = response.from;
              vm.pagination_from = response.from;
              vm.to = response.to;
              vm.pagination_to = response.to;
              vm.currentPage = response.current_page;
              vm.lastPage = response.last_page;
              vm.maxSize = 500;
              vm.bigTotalItems = 175;

              vm.loading = false;

              vm.items = angular.copy(response.data);

              $('.md-button')
                  .removeClass('active');
              $('[type=' + options.media_type + ']')
                  .addClass('active');

          });




      vm.firstLoad = false;
*/
    }



    function changeView(view) {


      if (vm.views[view]) {

        vm.loading = true;
        scrollToTopOfDialog();

        // console.log(vm.views[view])
        //vm.items = [];
        vm.showSearchAndPaginator = false;
        vm.defaultView = view;
        vm.currentView = view;
        vm.currentViewGallery = false;
        vm.CleanMediaGalleries = [];


        vm.media_type = view;

        var options = {
          page: 1,
          perPage: vm.PerPage,
          media_type: view,

        };
        if (view == 1 || view == 2 || view == 3 || view == 4) {
          vm.showSearchAndPaginator = true;
        }

        if (view == 'upload' || view == 'import') {
          $mdSidenav('media-dialog-galleries-sidenav').close();
        }


        getData(options);
        getMediaGalleries(vm.media_type);
      }

    }

    function changeViewTiny(view) {


      if (vm.viewsTiny[view]) {
        vm.items = [];
        vm.loadingView = true;
        vm.showSearchAndPaginator = false;
        vm.defaultViewTiny = view;
        vm.currentViewTiny = view;
        vm.currentViewGallery = false;
        /*
                        vm.media_type=view;

                        var options = {
                            page: 1,
                            perPage: vm.PerPage,
                            media_type: view,

                        };
                        if (view == 1 || view == 2 || view == 3 || view == 4) {
                            vm.showSearchAndPaginator    = true;
                        }
                        //
                        getData(options);
        */
      }

    }

    function changeViewGallery(mediaType) {
      $mdSidenav('media-dialog-galleries-sidenav').close();

      vm.loadingView = true;
      vm.loading = true;
      scrollToTopOfDialog();

      vm.items = [];

      vm.totalItems = 0;
      vm.showSearchAndPaginator = false;

      vm.currentView = 5;
      vm.currentViewGallery = mediaType;

      getMediaGalleries(mediaType);
      $('.md-button')
        .removeClass('active');
      $('[type=5]')
        .addClass('active');

    }


    function getNestedGalleriesWithMediaAssignment(nestedGalleries, selectedContacts) {
      angular.forEach(nestedGalleries, function (gallery) {
        gallery.assigned_gallery = false;
        selectedContacts.find(function (obj) {
          if (vm.mediazone) {
            if (angular.isDefined(obj.id_gallery) &&
              obj.id_gallery == gallery.id_gallery &&
              obj.id_zone == mediazone.id_zone) {
              gallery.assigned_gallery = true;
            }
          } else {
            if (angular.isDefined(obj.id_gallery) &&
              obj.id_gallery == gallery.id_gallery) {
              gallery.assigned_gallery = true;
            }
          }
        });
        if (typeof gallery.children !== 'undefined' && gallery.children.length > 0) {
          getNestedGalleriesWithMediaAssignment(gallery.children, selectedContacts);
        }
      });
      return nestedGalleries;
    }

    $scope.$watch('vm.files', function () {
      angular.forEach(vm.files, function (f) {
        vm.uploadFiles.push(f);
      });
      $scope.formUpload = false;
      // console.log("vm.files ", vm.files)
      if (vm.files != null) {
        // make files array for not multiple to be able to be used in ng-repeat in the ui
        if (!angular.isArray(vm.files)) {
          $timeout(function () {
            $scope.files = vm.files = [vm.files];
          });
          return;
        }
        for (var i = 0; i < vm.files.length; i++) {
          $scope.errorMsg = null;
          (function (f) {
            vm.upload(f, true);
          })(vm.files[i]);
        }
      }
    });

    $scope.$watch('vm.import_field', function () {
      vm.importConfirm(false);
    });


    $scope.log = '';

    function upload(file) {
      // console.log("file upload ", file)
      if (!file.$error) {

        //                console.debug("UPLOAD______****", file)
        mediaService.getS3UploadPreSignedUrl({
          siteID: siteID,
          fileName: file.name
        })
          .then(function (resp) {
            // console.log("resp upload ", resp)
            file.id_media = resp.id_media;

            file.upload = Upload.http({
              url: resp.url,
              skipAuthorization: true,
              method: 'PUT',
              headers: {
                "Content-Type": file.type != '' ? file.type : 'application/octet-stream'
              },
              data: file
            });

            file.upload.then(function (response) {
              // console.log('full res ', response)
              file.result = response.data;
              vm.uploadedFiles.push(file);
              $timeout(function () {
                $scope.log = 'file: ' +
                  file.name +
                  ', Response: ' + JSON.stringify(response.data) +
                  ', ID: ' + file.id_media +
                  '\n' + $scope.log;
              });
              //                        console.debug("SEND_TO_CROP______****", file)
              mediaService.finishedUploadingFileToCdn({
                siteID: siteID,
                idMedia: file.id_media
              })
              //                        console.debug("LOAD_MEDIA_FROM_DB______****", file)
              mediaService.get({
                siteID: siteID,
                withCropStatus: true,
                idMedia: file.id_media
              })
                .then(function (response) {

                  // console.log("LAST ", response)
                  if (response.total == 1) {
                    // $scope.show = false;
                    var photo = response.data[0];
                    toggleSelectContact(photo);
                  }
                });


            }, function (response) {
              if (response.status > 0)
                $scope.errorMsg = response.status + ': ' + response.data;
            });

            file.upload.progress(function (evt) {
              // console.log("evt ", evt)
              file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
            });

          })
      }
    };

    vm.importConfirm = function (confirm) {
      vm.import_disabled = false;
      vm.imported = false;
      if (!confirm) {
        vm.importPreview = false;
      }
      if (vm.import_field.length > 10) {
        vm.importing = true;
        vm.import_disabled = true;

        $timeout(function () {
          var pastedUrl = vm.import_field;
          mediaService.importFromUrl({
            siteID: siteID,
            url: pastedUrl,
            execute: confirm
          })
            .then(function (response) {
              vm.importing = false;
              response.embedCodeSafe = $sce.trustAsHtml(response.metadata.embedCode);
              if (response.id_media) {
                vm.imported = true;
                vm.importPreview = false;
                mediaService.get({
                  siteID: siteID,
                  withCropStatus: true,
                  idMedia: response.id_media
                })
                  .then(function (response) {
                    if (response.total == 1) {
                      var photo = response.data[0];
                      vm.importedFiles.push(photo);
                      toggleSelectContact(photo);
                    }
                  });

              } else {
                vm.importPreview = response;
              }
              vm.import_disabled = false;
            });
        })
      }
    }

    function nextPage() {

      var options = {
        page: vm.currentPage + 1,
        perPage: vm.PerPage,
        media_type: vm.media_type,
        searchString: vm.modelSearch
      };
      //
      getData(options);

    }

    function prevPage() {
      var options = {
        page: vm.currentPage - 1,
        perPage: vm.PerPage,
        media_type: vm.media_type,
        searchString: vm.modelSearch
      };
      //
      getData(options);
    }

    function morePages() {
      if (vm.currentPage < vm.lastPage) return true;
      return false;
    }

    function firstPage() {
      if (vm.currentPage == 1) return true;
      return false;
    }

    function gotoPage(i) {

      var options = {
        page: i,
        perPage: vm.PerPage,
        media_type: vm.media_type,
        searchString: vm.modelSearch
      };
      //
      getData(options);
    }


    function alreadySelectedbyZone(array, item) {


      return vm.selectedContacts.find(x => x.id_media === item.id_media);
    }


    function selectMediaTiny(item) {
      var currentSort = 0;
      var mediaSort = 0;
      for (var i = 0; i < vm.currentThread.length; i++) {
        if (vm.mediazone) {
          //                    console.log(vm.currentThread[i]['id_zone']);
          if (vm.currentThread[i]['id_zone'] == 1 && (vm.currentThread[i]['media_type'] == item.media_type)) {
            currentSort++;
            if (item.id_media == vm.currentThread[i]['id_media']) {
              mediaSort = currentSort;
            }
          }
        } else {
          currentSort++;
          if (item.id_media == vm.currentThread[i]['id_media']) {
            mediaSort = currentSort;
          }
        }
      }
      vm.selectedMediaTiny = item;
      vm.tinyProperties.mediaSort = mediaSort;
      vm.tinyProperties.mediaType = item.media_type;
      vm.changeViewTiny('properties');

    }

    function attachMedia() {
      $mdDialog.hide(vm.selectedContacts[0]);
    }

    function attachMediaTiny() {
      $mdDialog.hide(vm.tinyProperties);
    }



    function selectedItemChange() {
      vm.searchTagText = '';
      vm.selectedTag = null;
    }

    /**
     * Add label chips
     *
     * @param query
     * @returns {filterFn}
     */
    function labelQuerySearch(query) {
      var ret = [];
      if (query) {
        var filteredContent = angular.copy(vm.tags.filter(vm.createFilterFor(query)));
        if (filteredContent.length > 0) {
          ret.push({
            id_tag: 0,
            tag_name: "",
            order: 1
          });
        }
        angular.forEach(filteredContent, function (val) {
          ret.push(val);
        })
      }
      return ret;
    }

    function newTag(tagName) {

      if (vm.newTagDisabled) {
        return false;
      }
      vm.newTagDisabled = true;

      var newTag = {
        tag_name: tagName
      };
      var options = {
        site: siteID,
        item: newTag
      };
      tagsService.saveItem(options).then(function (response) {
        newTag.id_tag = response.id_tag
        vm.tags.push(newTag);
        vm.currentTags.push(newTag);
        vm.searchTagText = '';
        vm.newTagDisabled = false;
      });
    }

    /**
     * Filter for chips
     *
     * @param query
     * @returns {filterFn}
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(item) {
        if (angular.isUndefined(item.tag_name)) {
          return false;
        }
        if (!item.tag_name) {
          return false;
        }
        if (!angular.lowercase(item.tag_name.toString()).indexOf) {
          return false;
        }
        return angular.lowercase(item.tag_name.toString()).indexOf(lowercaseQuery) >= 0;
      };
    }

    function getpos(event) {
      vm.fields.geoLat = event.latLng.lat();
      vm.fields.geoLon = event.latLng.lng();
      vm.latlng = [event.latLng.lat(), event.latLng.lng()];
    }

    function placeMarker() {
      var loc = this.getPlace()
        .geometry.location;
      vm.latlng = [loc.lat(), loc.lng()];
      vm.fields.geoLat = loc.lat();
      vm.fields.geoLon = loc.lng();
      vm.center = [loc.lat(), loc.lng()];
    }

    function searchLatLon() {
      vm.latlng = [vm.fields.geoLat, vm.fields.geoLon];
      vm.center = [vm.fields.geoLat, vm.fields.geoLon];
      vm.center = [40.74, -74.18];
    }

    function removeDetachedGalleriesFromContacts(galleries, contacts) {
      for (var i = contacts.length - 1; i >= 0; i--) {
        if (vm.mediazone && contacts[i].id_zone != mediazone.id_zone) {
          continue;
        }
        if (angular.isUndefined(contacts[i].id_gallery) ||
          contacts[i].id_gallery == 0) {
          continue;
        }
        if (contacts[i].media_type) { // not a gallery!
          continue;
        }
        var remove = true;
        angular.forEach(galleries, function (gallery) {
          if (contacts[i].id_gallery == gallery.id_gallery) {
            if (vm.mediazone) {
              if (contacts[i].id_zone == gallery.id_zone) {
                remove = false;
              }
            } else {
              remove = false;
            }
          }
        });
        if (remove) {
          contacts.splice(i, 1);
        }
      }
      return contacts;
    }

    function cleanGalleryWhenMedia(contacts) {
      for (var i = 0; i < contacts.length; i++) {
        if (angular.isDefined(contacts[i].id_media) && angular.isDefined(contacts[i].id_gallery)) {
          delete contacts[i].id_gallery;
        }
      }
      return contacts;
    }

    function addAttachedGalleriesToContacts(galleries, contacts) {
      angular.forEach(galleries, function (gallery) {
        // console.log("ADDDD ", gallery)
        // console.log(vm.mediazone)
        if (vm.mediazone && angular.isDefined(gallery.id_zone) && gallery.id_zone != mediazone.id_zone) {
          return;
        }
        var add = true;
        for (var i = 0; i < contacts.length; i++) {
          if (angular.isDefined(contacts[i].id_gallery) &&
            contacts[i].id_gallery == gallery.id_gallery) {
            if (vm.mediazone) {
              if (contacts[i].id_zone == gallery.id_zone) {
                add = false;
              }
            } else {
              add = false;
            }
          }
        }
        if (add) {
          contacts.push(gallery);
        }
      });
      return contacts;
    }


    function updateSelectedGalleries(galleries, result) {

      angular.forEach(galleries, function (gallery) {
        if (angular.isDefined(gallery.assigned_gallery)) {
          if (gallery.assigned_gallery == true) {
            // assign checked gallery...
            var isAssigned = result.find(function (obj) {
              if (vm.mediazone) {
                return (obj.id_gallery == gallery.id_gallery && obj.id_zone == mediazone.id_zone);
              } else {
                return obj.id_gallery == gallery.id_gallery;
              }
            });
            // ... but only if not already assigned
            if (!isAssigned) {
              if (vm.mediazone) {
                gallery['id_zone'] = mediazone.id_zone;
              }
              result.push(gallery);
            }
          } else {
            // unassign unchecked gallery
            if (result.length > 0) {
              for (var ii = result.length - 1; ii >= 0; ii--) {
                if (vm.mediazone) {
                  if (result[ii].id_gallery == gallery.id_gallery &&
                    result[ii].id_zone == mediazone.id_zone) {
                    result.splice(ii, 1);
                  }
                } else {
                  if (result[ii].id_gallery == gallery.id_gallery) {
                    result.splice(ii, 1);
                  }
                }
              }
            }
          }
        }
        if (typeof gallery.children !== 'undefined' && gallery.children.length > 0) {
          updateSelectedGalleries(gallery.children, result);
        }
      });
      return result;
    }

    /**
     * Toggle selected status of the contact
     *
     * @param contact
     * @param event
     */
    function toggleSelectContact(photo, event) {
      vm.selectedContacts = [photo];
    }

    function toggleSelectOne(photo, event) {
      if (event) {
        event.stopPropagation();
      }

      if (vm.mediazone) {
        photo.id_zone = vm.mediazone.id_zone;
        photo.zone_name = vm.mediazone.zone_name;
      }
      else {
        photo.id_zone = null;
        photo.zone_name = null;
      }

      vm.selectedContacts = []

      vm.selectedContacts.push(photo);
      // console.log("called 1 ", vm.selectedContacts)
      vm.attachMedia();

    }

    /**
     * Scroll Media Dialog Content to the top
     * @param speed
     */
    function scrollToTopOfDialog() {
      //$timeout(function () {
      var dialogContent = $document.find('md-dialog-content').filter(function () {
        return angular.element(this).hasClass('mediadialog-content');
      });
      if (!angular.isUndefined(dialogContent[0])) {
        dialogContent.animate({
          scrollTop: 0
        }, 1);
      }
      //}, 1000);

    }

    function toggleMediaDialogSidenav(sidenavId) {
      $mdSidenav(sidenavId)
        .toggle();
    }
  }

  function loadSelectMediaDialogMediaByGalleries(selectMediaDialogService) {

    function unselectAllGalleries() {
      var elemList = document.querySelectorAll('.gallery-row');
      elemList.forEach(function (elem) {
        elem.classList.remove('selected');
      });
    }

    return {
      restrict: 'A',
      link: function (scope, element, attrs) {

        $(element).on('click', function (e) {
          var galleryNode = false;
          if (element.parent().hasClass('selected')) {
            unselectAllGalleries();
          } else {
            unselectAllGalleries();
            element.parent().addClass('selected');
            galleryNode = scope.node;
          }

          var includeSubgalleries = $('#includeSubgalleries').attr("data-include-subgalleries") == 'true';
          selectMediaDialogService.triggerMediaDialogMediaByGalleries(galleryNode, includeSubgalleries);
        });
      }
    };
  }
})();




(function () {
    'use strict';

    angular
        .module('app.match-center')
        .constant('_', window._)
        .controller('PreviewClipDialogController', PreviewClipDialogController);

    /** @ngInject */
    function PreviewClipDialogController($mdDialog, $mdToast, sessionService, idLiveStream, tinyMceService, $http, $translate, $document, $scope, id_media,
        mediaService, siteID, sharing, extra, clipUrl, $window) {
        var vm = this;
        vm.tinymceOptions = tinyMceService.getOptions($scope);

        vm.tinymceOptions.height = 50;
        vm.isUrlReady = false;
        vm.sharing = sharing;
        vm.idLiveStream = idLiveStream;
        vm.closeDialog = closeDialog;

        vm.clipUrl = clipUrl;
        vm.extra = extra;
        vm.socialNetworks = [];
        vm.id_media = id_media;
        initPlayer();



        function initPlayer() {
            if (vm.isUrlReady || vm.sharing) {
                if (!vm.sharing) {
                    $scope.$apply();
                }
                setTimeout(() => {
                    vm.isUrlReady = true;
                    $scope.$apply();
                    console.log(vm.clipUrl)
                    var player = new MediaElementPlayer('vp-m3u8-edit', {
                        features: ['playpause', 'current', 'progress', 'tracks', 'volume', 'fullscreen'],
                        success: (mediaElement, domObject) => {
                            var interval = 0;
                            mediaElement.play();
                        }
                    });
                }, 300);
            } else {
                console.log("check")
                $.ajax({
                    url: vm.clipUrl,
                    type: 'HEAD',
                    error: () => {
                        console.log("fail")
                        $scope.timeout = setTimeout(() => {
                            console.log("retry")
                            initPlayer()
                        }, 5000);
                    },
                    success: () => {
                        console.log("ready")
                        vm.isUrlReady = true;
                        $scope.$apply();
                        initPlayer()
                    }
                });
            }
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        $scope.$on('$destroy', function () {
            clearInterval($scope.timeout);
            clearInterval($scope.timeout2);
        });
    }
})();




(function () {
    'use strict';

    angular
        .module('app.match-center')
        .constant('_', window._)
        .controller('PeopleDialogController', PeopleDialogController);

    /** @ngInject */
    function PeopleDialogController($mdDialog, $translate, msUtils, transformMatchCenter, peopleSection, title, data, team, tabs, label, matchCenterService, siteId) {
        var vm = this;
        vm.siteId = siteId;
        vm.peopleSection = peopleSection;
        vm.data = data;
        vm.tabs = tabs;
        vm.label = label;
        vm.select = select;
        vm.isSelected = isSelected;
        vm.title = title;
        vm.team = team;
        vm.selected = [];
        vm.copyData = angular.copy(data);
        vm.loadingReadPane = true;
        vm.loadingReadPane = true;
        vm.showAll = false;



        vm.saveDialog = saveDialog;
        vm.closeDialog = closeDialog;
        vm.maxPeopleValidation = maxPeopleValidation;
        vm.getContentSection = getContentSection;


        function select(item) {
            if (isSelected(item)) {
                vm.selected = _.filter(vm.selected, function (x) {
                    return x.id_people != item.id_people
                })
            } else {
                vm.selected.push(angular.copy(item));
            }
        }

        function isSelected(item) {
            var result = _.find(vm.selected, function (x) {
                return x.id_people == item.id_people
            }) != undefined;
            return result;
        }


        vm.getContentSection()

        function getPeopleType() {
            switch (vm.peopleSection) {
                case 'headlines':
                    return 20
                case 'alternates':
                    return 20
                case 'coaches':
                    return 10
                case 'technical_staff':
                    return 10
                default:
                    break;
            }
        }
        function getContentSection(search) {
            vm.loadingReadPane = true;
            var options = {
                site: vm.siteId,
                search: search,
                // current_type: vm.showAll ? null : getPeopleType(),
                // current_team: (vm.showAll || getPeopleType() == 10) ? null : vm.team.id_teams,
                filters: []
            };

            if (!vm.showAll) {
              options.filters.push({
                field: 'current_type',
                name: 'current_type',
                selected: [getPeopleType()]
              })
              if (getPeopleType() != 10) {
                options.filters.push({
                  field: 'current_team',
                  name: 'current_team',
                  selected: [vm.team.id_teams]
                });
              }
            }

            vm.setCropFormat = function() {
              var mediaCrop = _.filter(vm.ref, {title: 'media'}, true);
              if (mediaCrop.length && mediaCrop[0].id_cropformats) {
                vm.cropFormat = mediaCrop[0].id_cropformats
              }
            }
            matchCenterService.getContentSection(options, 'people').then(function (response) {
                vm.people = angular.copy(response.result.data);
                vm.ref = angular.copy(response.ref);
                vm.setCropFormat();
                for (var i = 0; i < vm.tabs.length; i++) {
                    const tab = vm.tabs[i];
                    const label = tab.section;
                    vm.people = _.filter(vm.people, function (person) {
                        return _.filter(vm.team[label], function (_person) {
                            return _person.id_people == person.id_people;
                        }).length == 0;
                    });
                }
                if (!vm.showAll) {
                  vm.people = _.filter(vm.people, function (person) {
                    return person.current_team == vm.team.id_teams;
                  });
                }
                vm.loadingReadPane = false;
            });
        }


        function saveDialog() {
            if (!vm.data || angular.isObject(vm.data)) {
                vm.data = [];
            }
            for (var i = 0; i < vm.selected.length; i++) {
                vm.data.push(msUtils.toSectionRef(vm.selected[i], vm.ref));
            }
            $mdDialog.hide(vm.data);
        }

        function closeDialog() {
            data = vm.copyData;
            $mdDialog.hide();
        }

        function maxPeopleValidation() {
            var previousSelected = data.length;
            var currentSelected = _.filter(vm.selected, function (item) {
                return item;
            }).length;
            return vm.label.max < previousSelected + currentSelected;
        }



    }
})();



(function () {
    'use strict';

    angular
        .module('app.match-center')
        .constant('_', window._)
        .controller('JuryDialogController', JuryDialogController);

    /** @ngInject */
    function JuryDialogController($mdDialog, $translate, transformMatchCenter, jury, title, matchCenterService, siteID) {
        var vm = this;
        vm.siteId = siteID;
        vm.jury = jury;
        vm.title = title;
        vm.select = select;
        vm.isSelected = isSelected;
        vm.copyData = angular.copy(jury);
        vm.loadingReadPane = true;
        vm.saveDialog = saveDialog;
        vm.closeDialog = closeDialog;
        vm.getContentSection = getContentSection;
        vm.showAll = false;
        vm.selected = [];

        vm.translate = function (text) {
            return $translate.instant(text);
        }

        vm.getContentSection()

        function getContentSection(search) {
            vm.loadingReadPane = true;
            var options = {
                site: vm.siteId,
                search: search,
                filters: [
                  {
                    field: 'current_type',
                    name: 'current_type',
                    selected: [vm.showAll ? null : 1]
                  }
                ]
            };
            matchCenterService.getContentSection(options, 'people').then(function (response) {
                vm.people = angular.copy(response.result.data);
                vm.ref = angular.copy(response.ref);
                vm.people = _.filter(vm.people, function (person) {
                    return _.filter(vm.jury, function (_person) {
                        return _person.id_people == person.id_people;
                    }).length == 0;
                });
                vm.loadingReadPane = false;
            });
        }

        function select(item) {
            if (isSelected(item)) {
                vm.selected = _.filter(vm.selected, function (x) {
                    return x.id_people != item.id_people
                })
            } else {
                vm.selected.push(angular.copy(item));
            }
        }

        function isSelected(item) {
            var result = _.find(vm.selected, function (x) {
                return x.id_people == item.id_people
            }) != undefined;
            return result;
        }


        function saveDialog() {
            if (!vm.jury) {
                vm.jury = [];
            }
            for (var i = 0; i < vm.selected.length; i++) {
                vm.jury.push(toJuryRef(vm.selected[i]));
            }
            $mdDialog.hide(vm.jury);
        }

        function toJuryRef(people) {
            var result = {}
            for (var i = 0; i < vm.ref.length; i++) {
                const element = vm.ref[i];
                if (element.type == 'thumbnail') {
                    result[element.titleId] = people.Thumbnail && people.Thumbnail.length > 0 ? transformMatchCenter.setItemMedia(people.Thumbnail[0]) : people[element.titleId];
                } else {
                    result[element.titleId] = people[element.titleId];
                }
            }
            return result;
        }
        function closeDialog() {
            jury = vm.copyData;
            $mdDialog.hide();
        }



    }
})();



(function () {
    'use strict';

    angular
        .module('app.match-center')
        .constant('_', window._)
        .controller('EditClipDialogController', EditClipDialogController);

    /** @ngInject */
    function EditClipDialogController($mdDialog, $rootScope, $http, $timeout, $translate, $document, $scope, mediaService, siteID, name, sessionService, matchCenterService, title, idLiveStream, clip, clipUrl, extra, startPoint, endPoint) {
        var vm = this;
        var offset = 0;
        vm.leftItem = null;
        vm.rightItem = null;
        vm.getMaxHeight = getMaxHeight;
        vm.openPreview = openPreview;
        vm.startPoint = startPoint;
        vm.endPoint = endPoint;
        vm.extra = extra;
        vm.idLiveStream = idLiveStream;
        vm.title = title;
        // señor pintando y imagen con neblina
        if (clip) {
            vm.clip = clip;
            vm.isUrlReady = true;
            vm.clipUrl = clip.embed.split('|')[1];
            initMp4Player();
        } else {
            vm.clip = {
                crop_process: {
                    live_stream_clip: {
                        start_time: startPoint,
                        end_time: endPoint,
                        live_stream_name: name
                    }
                }
            }
            vm.clipUrl = clipUrl;
            initPlayer();
        }


        // vm.clipUrl = clipUrl;

        vm.saveDialog = saveDialog;
        vm.closeDialog = closeDialog;
        vm.sendEdit = sendEdit;
        vm.textDialog = textDialog;
        vm.mediaDialog = mediaDialog;
        vm.translate = function (text) {
            return $translate.instant(text);
        }

        function initMp4Player() {
            setTimeout(() => {
                var video = angular.element('#mp4-player');

                video.on('loadeddata', (e) => {
                    $scope.$apply(() => {
                        vm.start = 0;
                        vm.end = e.target.duration;
                        vm.current = vm.start;
                        vm.currentPercent = vm.start;
                        vm.duration = vm.end;
                    });
                });

                video.on('timeupdate', function (e) {
                    $scope.$apply(function () {
                        vm.current = (e.target.currentTime - vm.start);
                        vm.currentPercent = (vm.current / (vm.end - vm.start)) * 100;
                        if (e.target.currentTime < vm.start) {
                            e.target.currentTime = vm.start;
                        }
                        if (e.target.currentTime > vm.end) {
                            if (video[0].paused === false) {
                                e.target.pause();
                            } else {
                                e.target.currentTime = vm.start;
                            }
                        }
                    });
                });
                $scope.onTrimChange = function () {
                    video[0].pause();
                    video[0].currentTime = vm.start;
                };
                $scope.getFormatTime = function (seconds) {
                    return new Date(parseInt(seconds) * 1000).toISOString().substr(11, 8);
                }

            });
        }

        function initPlayer() {
            if (vm.isUrlReady) {
                $scope.$apply();
                setTimeout(() => {
                    $scope.$apply();
                    console.log(vm.clipUrl)
                    initMp4Player();
                }, 300);
            } else {
                console.log("check")
                $.ajax({
                    url: vm.clipUrl,
                    type: 'HEAD',
                    error: () => {
                        console.log("fail")
                        $scope.timeout = setTimeout(() => {
                            console.log("retry")
                            initPlayer()
                        }, 5000);
                    },
                    success: () => {
                        console.log("ready")
                        vm.isUrlReady = true;
                        $scope.$apply();
                        initPlayer()
                    }
                });
            }
        }

        function saveDialog() {
            $rootScope.$broadcast('EDIT_CLIP_WINDOW', { volume: 1 });
            $mdDialog.hide(true);
        }

        function closeDialog() {
            $rootScope.$broadcast('EDIT_CLIP_WINDOW', { volume: 1 });
            $mdDialog.hide();
        }

        function stringToSeconds(input) {
            return parseInt(input.split(':')[0]) * 60 * 60 + parseInt(input.split(':')[1]) * 60 + parseInt(input.split(':')[2]);
        }

        function secondsToString(seconds) {
            return new Date(parseInt(seconds) * 1000).toISOString().substr(11, 8);
        }

        function sendEdit(ev) {
            vm.isEditing = true;
            var newStartTime = stringToSeconds(vm.clip.crop_process.live_stream_clip.start_time) + parseInt(vm.start);
            var newEndTime = stringToSeconds(vm.clip.crop_process.live_stream_clip.start_time) + parseInt(vm.end);
            var duration = newEndTime - newStartTime;
            var options = {
                siteID: siteID,
                item: {
                    "name": vm.clip.crop_process.live_stream_clip.live_stream_name,
                    "id_live_stream": vm.idLiveStream,
                    "start_time": secondsToString(newStartTime),
                    "end_time": secondsToString(newEndTime),
                    "id_zone": 2,
                    "title": vm.title + ' EDITED'
                }
            }
            if (vm.overItems && vm.overItems.length > 0) {
                options.item.watermarks = vm.overItems.map((overItem, index) => {
                    var ratioy = 100 / (parseInt($('.video-container').css('height').split('px')[0]) - parseInt($('#overItem-' + index).css('height').split('px')[0])) * parseInt($('#overItem-' + index).css('top').split('px')[0]) / 100;
                    var ratiox = 100 / (parseInt($('.video-container').css('width').split('px')[0]) - parseInt($('#overItem-' + index).css('width').split('px')[0])) * parseInt($('#overItem-' + index).css('left').split('px')[0]) / 100
                    var sizeratio = 100 / parseInt($('.video-container').css('width').split('px')[0]) * parseInt($('#overItem-' + index).css('width').split('px')[0]) / 100;
                    return {
                        "url": overItem.s3Url,
                        "center_ratio_x": ratiox ? ratiox : 0,
                        "center_ratio_y": ratioy ? ratioy : 0,
                        "size_ratio": sizeratio > 1 ? 1 : (sizeratio < 0 ? 0 : sizeratio),
                        "opacity": 100,
                        "start": '00:00:00',
                        "duration_sec": duration
                    }
                })
            }
            if (vm.leftItem) {
                var cropContainerLeft = sessionService.getContainerByID(vm.leftItem.cdnContainer);
                options.item.intros = [
                    {
                        // "url": "s3://livestream-test-bucket/m1220_live_1_97750071574248204.mp4",
                        "url": "s3://" + cropContainerLeft.sourceBucket + "/videos/m" + vm.leftItem.id_media + '_' + vm.leftItem.filename,
                        "sort": 1
                    }
                ]
            }
            if (vm.rightItem) {
                var cropContainerRight = sessionService.getContainerByID(vm.rightItem.cdnContainer);
                options.item.outros = [
                    {
                        // "url": "s3://livestream-test-bucket/m1220_live_1_97750071574248204.mp4",
                        "url": "s3://" + cropContainerLeft.sourceBucket + "/videos/m" + vm.rightItem.id_media + '_' + vm.rightItem.filename,
                        "sort": 1
                    }
                ]
            }
            matchCenterService.createClip(options).then(function (response) {
                console.log(response.clipUrl)
                vm.isEditing = false;
                vm.openPreview(ev, response.clipUrl, response.extra)
            })
        }

        function openPreview(ev, clipUrl, extra) {
            $mdDialog.show({
                controller: 'PreviewClipDialogController',
                controllerAs: 'vm',
                locals: {
                    sharing: false,
                    clipUrl: clipUrl,
                    idLiveStream: vm.idLiveStream,
                    siteID: siteID,
                    id_media: null,
                    extra: extra
                },
                templateUrl: 'app/main/apps/match-center/dialogs/previewclip/previewclip-dialog.html',
                targetEvent: ev,
                multiple: true,
                clickOutsideToClose: false
            }).then(function (response) {
                if (response) {
                    $mdDialog.hide()
                    $rootScope.$broadcast('EDIT_CLIP_WINDOW', { volume: 1 });
                }
            });
        }

        function textDialog(ev) {
            $mdDialog.show({
                controller: 'SelectTextDialogController',
                controllerAs: 'vm',
                locals: {
                    siteID: siteID
                },
                templateUrl: 'app/main/apps/match-center/dialogs/selecttext/selecttext-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                multiple: true,
                clickOutsideToClose: true
            }).then((textItem) => {
                if (textItem) {
                    addOverImageMedia(null, 'text', textItem);
                }
            });
        }



        function addOverImageMedia(photo, type, textItem) {
            if (!vm.overItems) {
                vm.overItems = [];
            }
            if (textItem) {
                var overItem = {
                    type: type,
                    urlImage: textItem.preSignedUrl,
                    s3Url: textItem.s3Url
                };
                vm.overItems.push(overItem);
                var tmpImg = new Image();
                tmpImg.src = textItem.preSignedUrl;
                tmpImg.onload = function () {
                    const interval = setInterval(() => {
                        var index = vm.overItems.length - 1;
                        var container = $('#overItem-' + index.toString());
                        var newwidth = tmpImg.naturalWidth / 2;
                        console.log(container)
                        console.log(newwidth)
                        if (container.width()) {
                            container.css('width', newwidth + 'px');
                            clearInterval(interval);
                        }
                    }, 100);
                };
            } else {
                var cropContainer = sessionService.getContainerByID(photo.cdnContainer);
                var options = {
                    domain: siteID,
                    id_media: photo.id_media
                };
                mediaService.getImageOriginalByID(options).then(response => {
                    var overItem = {
                        type: type,
                        urlImage: response[0].url,
                        s3Url: 's3://' + cropContainer.sourceBucket + '/original/' + response[0].url.split('/').slice(-1).pop()
                    };
                    vm.overItems.push(overItem);
                });
            }

        }

        function getMaxHeight() {
            return "max-height:" + $('.video-container').css('height');
        }

        function mediaDialog(ev, itemSide) {
            $mdDialog.show({
                controller: 'SelectMediaDialogController',
                controllerAs: 'vm',
                locals: {
                    currentThread: {},
                    mediazone: false,
                    section: 'media',
                    isTiny: false,
                    maxAttach: undefined,
                    showViews: {
                        1: itemSide !== 'over' ? false : true,
                        2: itemSide == 'over' ? false : true
                    }
                },
                templateUrl: 'app/main/apps/match-center/dialogs/selectmedia/selectmedia-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                multiple: true,
                clickOutsideToClose: false
            }).then((item) => {
                if (item) {
                    if (itemSide == 'left') {
                        vm.leftItem = item;
                    } else if (itemSide == 'right') {
                        vm.rightItem = item;
                    } else if (itemSide == 'over') {
                        addOverImageMedia(item, 'image')
                    }
                }
            });
        }

        $scope.$on('$destroy', function () {
            clearInterval($scope.timeout);
        });

    }
})();



(function () {
    'use strict';

    angular
        .module('app.match-center')
        .controller('CreateMatchCenterDialogController', CreateMatchCenterDialogController);

    /** @ngInject */
    function CreateMatchCenterDialogController($scope, $mdDialog, utilMatchCenterService, siteID, $mdToast, contentService, sessionService, $translate) {

        var vm = this;
        vm.save = save;
        vm.newThread = newThread;
        vm.checkSportData = checkSportData;
        vm.saveItem = saveItem;
        vm.createObjects = createObjects;
        vm.createCompetitionSeason = createCompetitionSeason;
        vm.createSubCompetition = createSubCompetition;
        vm.isNewCompetition = false;
        vm.init = init;
        vm.types = [
            { id: 1, name: 'MATCH_CENTER.SEASON' },
            { id: 2, name: 'MATCH_CENTER.COMPETITION' },
            { id: 4, name: 'MATCH_CENTER.SUBCOMPETITION' }
        ]
        vm.competitions = [];
        vm.seasons = [];
        vm.creationtype = null;
        vm.creationObject = {};
        vm.competition_season = {};

        vm.init()


        function init() {
            var options = {
                siteID: siteID,
                per_page: 1000,
                section: 'competition'
            };
            contentService.get(options).then(function (res) {
                vm.competitions = res.result.data;
            })
            var options = {
                siteID: siteID,
                per_page: 1000,
                section: 'season'
            };
            contentService.get(options).then(function (res) {
                vm.seasons = res.result.data;
            })
            var options = {
                site: siteID,
                per_page: 1000,
                section: 'competition'
            };
            contentService.getFilters(options).then(function (res) {
                vm.filtersCompetitions = res;
                vm.sports = res.filters.id_subsec.values;
            })
            var options = {
                siteID: siteID,
                per_page: 1000,
                section: 'competition_season'
            };
            contentService.get(options).then(function (res) {
                vm.competitionsSeasons = res.result.data;
            })

        }


        vm.translate = function (text) {
            return $translate.instant(text);
        }

        $scope.hide = function () {
            $mdDialog.hide();
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        function save() {
            if (vm.creationtype == 1 || vm.isNewCompetition) {
                vm.saveItem(vm.creationObject)
            } else if (vm.creationtype == 4) {
                vm.competition_season.id_parent = vm.creationObject.id_competition_season;
                vm.createSubCompetition(vm.creationObject, vm.competition_season)
            } else {
                vm.createCompetitionSeason(vm.creationObject, vm.competition_season)
            }
        }


        function createObjects() {
            vm.newThread(vm.creationtype)
            if (vm.creationtype == 2) {
                vm.newThread(3)
            }
        }

        function getSection(id) {
            switch (id) {
                case 1:
                    return 'season';
                case 2:
                    return 'competition'
                case 3:
                    return 'competition_season'
                case 4:
                    return 'competition_season'
                default:
                    break;
            }
        }
        /**
                * New thread
                *
                */
        function newThread(sectionId) {
            var options = {
                site: siteID
            };
            options.section = getSection(sectionId);
            contentService.getNew(options).then(function (response) {
                var objectName;
                var objectRef;
                if (options.section == 'competition_season') {
                    objectName = 'competition_season'
                    objectRef = 'selectedContentCompSea_ref'
                } else {
                    objectName = 'creationObject'
                    objectRef = 'selectedContentObject_ref'
                }
                vm[objectName] = {
                    onoff: 1,
                    Thumbnail: [],
                    tags: []
                };
                for (var i = response.ref.length - 1; i >= 0; i--) {
                    if (response.ref[i].type.substr(0, 4) == 'date') {

                        var value = moment().utc().format("YYYY-MM-DD HH:mm:00");

                        var utcDate = moment.utc(value);

                        var siteDate = moment.utc(value).tz(sessionService.site_operative.timezone);

                        vm[objectName][response.ref[i].titleId] = {};
                        vm[objectName][response.ref[i].titleId]['value'] = value;
                        vm[objectName][response.ref[i].titleId]['date'] = new Date(siteDate.format());
                        vm[objectName][response.ref[i].titleId]['dateShow'] = siteDate.format(vm.dateTimeFormat);
                        vm[objectName][response.ref[i].titleId]['utcShow'] = utcDate.format(vm.dateTimeFormat);
                        vm[objectName][response.ref[i].titleId]['utcDate'] = utcDate;
                    }
                }
                vm[objectRef] = response.ref;
                console.log(vm[objectName])
            });
        }

        function saveItem(content) {
            console.log(content)
            vm.savingProcess = true;
            var newContent = angular.copy(content);
            //console.log(newContent);return;
            for (var i = vm.selectedContentObject_ref.length - 1; i >= 0; i--) {
                if (vm.selectedContentObject_ref[i].type.substr(0, 4) == 'date') {
                    newContent[vm.selectedContentObject_ref[i].titleId] = newContent[vm.selectedContentObject_ref[i].titleId].value;
                }
            }
            newContent.id_subsec = parseInt(newContent.id_subsec);
            var options = {
                site: siteID,
                section: getSection(vm.creationtype),
                id: !content.id ? 'new' : !content.id,
                item: newContent
            };
            contentService.saveItem(options).then(function (response) {
                afterCreate(response)
            });
        }

        function createCompetitionSeason(competition, competition_season) {
            vm.savingProcess = true;
            var newContent = angular.copy(competition_season);
            //console.log(newContent);return;
            for (var i = vm.selectedContentCompSea_ref.length - 1; i >= 0; i--) {
                if (vm.selectedContentCompSea_ref[i].type.substr(0, 4) == 'date') {
                    newContent[vm.selectedContentCompSea_ref[i].titleId] = newContent[vm.selectedContentCompSea_ref[i].titleId].value;
                }
            }
            newContent.id_competition = competition.id_competition;
            newContent.contain_results = newContent.has_results ? 1 : 0;
            newContent.id_season = competition_season.season.id;
            newContent.id_subsec = parseInt(competition.id_subsec);;
            newContent.reference_name = competition.title + ' ' + competition_season.season.season;
            delete newContent.has_results;
            delete newContent.season;
            var options = {
                site: siteID,
                section: 'competition_season',
                id: 'new',
                item: newContent
            };
            contentService.saveItem(options).then(function (response) {
                successAndClose()
            });
        }

        function createSubCompetition(competition, competition_season) {
            vm.savingProcess = true;
            var newContent = angular.copy(competition_season);
            for (var i = vm.selectedContentCompSea_ref.length - 1; i >= 0; i--) {
                if (vm.selectedContentCompSea_ref[i].type.substr(0, 4) == 'date') {
                    newContent[vm.selectedContentCompSea_ref[i].titleId] = newContent[vm.selectedContentCompSea_ref[i].titleId].value;
                }
            }
            newContent.id_competition = competition.id_competition;
            newContent.id_season = competition.id_season;
            newContent.id_subsec = parseInt(competition.id_subsec);
            var options = {
                site: siteID,
                section: 'competition_season',
                id: 'new',
                item: newContent
            };
            contentService.saveItem(options).then(function (response) {
                successAndClose()
            });
        }

        function afterCreate(response) {
            if (vm.creationtype == 1 || vm.creationtype == 4 || vm.creationtype == 3) {
                successAndClose()
            } else if (vm.creationtype == 2) {
                response.item.id_competition = response.id;
                vm.createCompetitionSeason(response.item, vm.competition_season)
            }

        }

        function successAndClose() {
            vm.savingProcess = false;
            var message = $translate.instant('CONTENT.SAVED');
            $mdToast.show({
                template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                hideDelay: 5000,
                position: 'top',
                parent: '#content-container'
            });
            $mdDialog.hide(true);
        }

        function getSportFiles(id_subsec) {
            var sport = utilMatchCenterService.getSport(id_subsec)
            if (sport) {
                utilMatchCenterService.getFile({ sport: sport, file: 'types-clasification.json' }, true).then(function (res) {
                    vm.typesClasification = res;
                })
                utilMatchCenterService.getFile({ sport: sport, file: 'types-match.json' }, true).then(function (res) {
                    vm.typesMatch = res;
                })
            }
        }

        function checkSportData() {
            if (vm.creationtype == 4) {
                var competition = _.find(vm.competitions, function (comp) {
                    return comp.id == vm.creationObject.id_competition;
                })
                getSportFiles(parseInt(competition.id_subsec));
            }
            if ((vm.creationObject.id_subsec && vm.isNewCompetition) || (!vm.isNewCompetition && vm.creationObject.id)) {
                getSportFiles(parseInt(vm.creationObject.id_subsec));
            } else {
                vm.typesClasification = [];
                vm.typesMatch = [];
            }
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.gantt-chart', [
            'gantt',
            'gantt.sortable',
            'gantt.movable',
            'gantt.drawtask',
            'gantt.tooltips',
            'gantt.bounds',
            'gantt.progress',
            'gantt.table',
            'gantt.tree',
            'gantt.groups',
            'gantt.dependencies',
            'gantt.overlap',
            'ngAnimate',
            'gantt.resizeSensor'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, msApiProvider)
    {

        $stateProvider.state('app.gantt-chart', {
            url    : '/gantt-chart',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/gantt-chart/gantt-chart.html',
                    controller : 'GanttChartController as vm'
                }
            },
            resolve: {
                Tasks    : function (msApi)
                {
                    return msApi.resolve('ganttChart.tasks@get');
                },
                Timespans: function (msApi)
                {
                    return msApi.resolve('ganttChart.timespans@get');
                }
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/gantt-chart');

        // Navigation
        msNavigationServiceProvider.saveItem('apps.gantt-chart', {
            title : 'Gantt Chart',
            icon  : 'icon-calendar-text',
            state : 'app.gantt-chart',
            weight: 5
        });

        // Api
        msApiProvider.register('ganttChart.tasks', ['app/data/gantt-chart/tasks.json']);
        msApiProvider.register('ganttChart.timespans', ['app/data/gantt-chart/timespans.json']);

    }

})();
(function ()
{
    'use strict';

    angular.module('app.gantt-chart')
        .controller('GanttChartAddEditDialogController', GanttChartAddEditDialogController);

    /** @ngInject */
    function GanttChartAddEditDialogController($mdDialog, ganttUtils, dialogData, QiuGenerator)
    {
        var vm = this;

        // Data
        vm.chartData = dialogData.chartData;
        vm.dialogType = dialogData.dialogType;

        /// Edit Dialog
        if ( vm.dialogType === 'edit' )
        {
            vm.formView = dialogData.formView;
            vm.row = vm.task = angular.copy(dialogData.formData.model);
        }

        /// Add Dialog
        else if ( vm.dialogType === 'add' )
        {
            vm.row = {
                id      : ganttUtils.randomUuid(),
                name    : '',
                tasks   : [],
                classes : ['', ''],
                sortable: true,
                parent  : ''
            };
            vm.task = {
                id      : ganttUtils.randomUuid(),
                name    : '',
                classes : ['', ''],
                from    : '',
                to      : '',
                progress: ''
            };
            vm.taskRowId = '';
        }

        // Methods
        vm.addNewRow = addNewRow;
        vm.saveRow = saveRow;
        vm.removeRow = removeRow;
        vm.addNewTask = addNewTask;
        vm.saveTask = saveTask;
        vm.removeTask = removeTask;
        vm.closeDialog = closeDialog;
        vm.rgba = QiuGenerator.rgba;

        //////////

        /**
         * Add New Row
         */
        function addNewRow()
        {
            vm.chartData.push(vm.row);

            closeDialog();
        }

        /**
         * Save Row
         */
        function saveRow()
        {
            dialogData.formData.model = vm.row;

            closeDialog();
        }

        /**
         * Remove Row
         */
        function removeRow()
        {
            vm.chartData.splice(vm.chartData.indexOf(vm.chartData.getById(vm.row.id)), 1);

            closeDialog();
        }

        /**
         * Add New Task
         */
        function addNewTask()
        {
            vm.chartData.getById(vm.taskRowId).tasks.push(vm.task);

            closeDialog();
        }

        /**
         * Save Task
         */
        function saveTask()
        {
            dialogData.formData.model = vm.task;

            closeDialog();
        }

        /**
         * Remove Task
         */
        function removeTask()
        {
            var taskRow = vm.chartData.getById(dialogData.formData.row.model.id);

            taskRow.tasks.splice(taskRow.tasks.indexOf(taskRow.tasks.getById(vm.task.id)), 1);

            closeDialog();
        }


        /**
         * Close Dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

        /**
         * Array prototype
         *
         * Get by id
         *
         * @param value
         * @returns {T}
         */
        Array.prototype.getById = function (value)
        {
            return this.filter(function (x)
            {
                return x.id === value;
            })[0];
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('app.mailing', [])
        .config(config);
    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, ivhTreeviewOptionsProvider) {
        // State

        ivhTreeviewOptionsProvider.set({
            defaultSelectedState: false,
            validate: true,
            expandToDepth: -1,
            twistieCollapsedTpl: '<md-icon md-svg-icon="assets/angular-material-assets/img/icons/ic_chevron_right_24px.svg"></md-icon>',
            twistieExpandedTpl: '<md-icon md-svg-icon="assets/angular-material-assets/img/icons/ic_expand_more_black_24px.svg"></md-icon>',
            twistieLeafTpl: '<span style="cursor: default;">&#8192;&#8192;</span>'
        });



        $stateProvider
            .state('app.site_overview.mailing', {
                abstract: true,
                url: '/mailing',
                onEnter: function($stateParams) {},
                data: {
                    displayName: ''
                },
                resolve: {
                    section: function() {
                        return 'mailing'
                    },
                },
            })
            .state('app.site_overview.mailing.push_notifications', {
              url: '/push_notifications',
              views: {
                'content@app':{
                  templateUrl: 'app/main/apps/mailing/pushNotifications/mailing.push_notifications.html',
                  controller: 'pushNotificationsController as vm'
                }
              },
              onEnter: function($stateParams) {},
              data:{
                displayName: '{{section}}'
              },
              resolve:{
                section: function($stateParams) {
                  return $stateParams.section
                }
              }
            })
            .state('app.site_overview.mailing.content', {
                abstract: true,
                url: '/content',
                onEnter: function($stateParams) {},
                data: {
                    displayName: ''
                },
                resolve: {
                    section: function() {
                        return 'content'
                    },
                },
            })
            .state('app.site_overview.mailing.massive-messages', {
              abstract: true,
              url: '/massive-message',
              onEnter: function($stateParams) {},
              data: {
                  displayName: ''
              },
              resolve: {
                  section: function() {
                      return 'massive-messages'
                  },
              },
            })
            .state('app.site_overview.mailing.template', {
                abstract: true,
                url: '/templates',
                onEnter: function($stateParams) {},
                data: {
                    displayName: ''
                },
                resolve: {
                    section: function() {
                        return 'templates'
                    },
                },
            })
            .state('app.site_overview.mailing.communications', {
                abstract: true,
                url: '/communications',
                onEnter: function($stateParams) {},
                data: {
                    displayName: ''
                },
                resolve: {
                    section: function() {
                        return 'communications'
                    },
                },
            })
            .state('app.site_overview.mailing.content.list', {
                url: '',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/mailing/mailing.content.html',
                        controller: 'MailingContentController as vm'
                    }
                },
                onEnter: function() {},
                data: {
                    displayName: 'List'
                },
              resolve: {
                section: function() {
                  return 'content'
                },
              },
            })
            .state('app.site_overview.mailing.massive-messages.list', {
              url: '',
              views: {
                  'content@app': {
                      templateUrl: 'app/main/apps/mailing/mailing.massive-messages.html',
                      controller: 'MailingMassiveMessagesController as vm'
                  }
              },
              onEnter: function() {},
              data: {
                  displayName: 'List'
              },
              resolve: {
                section: function() {
                  return 'massive-messages'
                },
              },
            })
            .state('app.site_overview.mailing.template.list', {
                url: '',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/mailing/mailing.template.html',
                        controller: 'TemplateController as vm'
                    }
                },
                onEnter: function() {},
                data: {
                    displayName: 'List'
                },
              resolve: {
                section: function() {
                  return 'templates'
                },
              },
            })
            .state('app.site_overview.mailing.communications.list', {
                url: '',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/mailing/mailing.communications.html',
                        controller: 'CommunicationsController as vm'
                    }
                },
                onEnter: function() {},
                data: {
                    displayName: 'List'
                },
              resolve: {
                section: function() {
                  return 'communications'
                },
              },
            })
            .state('app.site_overview.mailing.template.list.thread', {
                url: '/:id',
                bodyClass: 'mailing',
              resolve: {
                section: function() {
                  return 'templates'
                },
              },
            })
            .state('app.site_overview.mailing.communications.list.thread', {
                url: '/:id',
                bodyClass: 'mailing',
              resolve: {
                section: function() {
                  return 'communications'
                },
              },
            })
            .state('app.site_overview.mailing.content.list.templates', {
                url: '',
                bodyClass: 'mailing',
              resolve: {
                section: function() {
                  return 'templates'
                },
              },
            })
            .state('app.site_overview.mailing.massive-messages.list.templates', {
              url: '',
              bodyClass: 'mailing',
              resolve: {
                section: function() {
                  return 'templates'
                },
              },
            })
            .state('app.site_overview.mailing.massive-messages.list.channel', {
              url: '',
              bodyClass: 'mailing',
              resolve: {
                section: function() {
                  return 'channel'
                },
              },
            })
            .state('app.site_overview.mailing.content.list.communications', {
                url: '',
                bodyClass: 'mailing',
              resolve: {
                section: function() {
                  return 'communications'
                },
              },
            })
            .state('app.site_overview.mailing.massive-messages.list.communications', {
              url: '',
              bodyClass: 'mailing',
              resolve: {
                section: function() {
                  return 'communications'
                },
              },
            })
            .state('app.site_overview.mailing.content.list.templates.selectedTemplate', {
                url: '/new',
                bodyClass: 'mailing',
              resolve: {
                section: function() {
                  return 'templates'
                },
              },
            })
            .state('app.site_overview.mailing.massive-messages.list.templates.selectedTemplate', {
              url: '/new',
              bodyClass: 'mailing',
              resolve: {
                section: function() {
                  return 'templates'
                },
              },
            })
            .state('app.site_overview.mailing.content.list.communications.selectedTemplate', {
                url: '/new',
                bodyClass: 'mailing',
              resolve: {
                section: function() {
                  return 'communications'
                },
              },
            })
            .state('app.site_overview.mailing.massive-messages.list.communications.selectedTemplate', {
              url: '/new',
              bodyClass: 'mailing',
              resolve: {
                section: function() {
                  return 'communications'
                },
              },
            })
            .state('app.site_overview.mailing.content.list.templates.openedContent', {
                url: '/:id',
                bodyClass: 'mailing',
              resolve: {
                section: function() {
                  return 'content'
                },
              },
            })
            .state('app.site_overview.mailing.massive-messages.list.templates.openedContent', {
              url: '/:id',
              bodyClass: 'mailing',
              resolve: {
                section: function() {
                  return 'content'
                },
              },
            })
            .state('app.site_overview.mailing.content-plus', {
                url: '/content-plus',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/mailing/mailing.content-plus.html',
                        controller: 'MailingContentPlusController as vm'
                    }
                },
                data: {
                    displayName: 'Content Plus'
                },
                resolve: {
                    section: function () {
                        return 'content-plus'
                    }
                }
            })

            .state('app.site_overview.mailing.template-plus', {
                url: '/template-plus',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/mailing/mailing.template-plus.html',
                        controller: 'MailingTemplatePlusController as vm'
                    }
                },
                data: {
                    displayName: 'Template Plus'
                },
                resolve: {
                    section: function () {
                        return 'template-plus'
                    }
                }
            })

            // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/mailing');

    }

})();

(function () {
    'use strict';

    angular
        .module('app.mailing')
        .controller('UsersInGroupMailingController', UsersInGroupMailingController);

    /** @ngInject */
    function UsersInGroupMailingController($mdDialog, $document, $rootScope, usersService,
        requestContext, $anchorScroll, $timeout, $scope, $sce, _, Upload, msUtils,
        COMMON, $translate, $log, section, usersRef, groupId, groupName, siteID
    ) {
        var vm = this;

        //Data
        vm.currentView = 'app/main/apps/mailing/dialogs/users-ingroup/list/list-view.html';
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg',
            'red-bg', 'yellow-bg', 'light-blue-bg'];
        vm.groupName = $translate.instant('MAILING.USERS_INGROUP', { groupName: groupName });
        vm.isLoading = true;
        vm.selectedGroupId = groupId;
        vm.threads = [];
        vm.searchString = '';
        vm.paginationTotalPages = 1;
        vm.paginationPage = 1;
        vm.refcolumnsgrouped = _.groupBy(usersRef, function (m) {
            return m['list_position'];
        });

        // Methods
        vm.closeDialog = closeDialog;
        vm.loadMore = loadMore;
        vm.showDate = showDate;
        vm.search = search;
        vm.reload = reload;

        init();

        function init() {
            usersService.getUsersInGroupStatus(siteID).then(function (response) {
                vm.ingroupStatus = response.filter(x => x.id_group_type == 2);
                load();
            });
        }
        $scope.filterByStatusSub = function (user) {
            return user.status == 'acepted' || user.status == 'verified'
        };
        $scope.filterByStatusUnSub = function (user) {
            return user.status != 'acepted' && user.status != 'verified'
        };

        function search(query) {
            vm.threads = [];
            vm.paginationPage = 1;
            load();
            /*
            vm.isLoading = true;
            var options = {
                siteID: siteID,
                section: section,
                groupIds: [groupId],
                sortDir: $rootScope.sortDir,
                sortField: $rootScope.sortField,
                searchStringFilter: vm.searchString,
            };
            usersService.getUsersByGroups(options).then(function (response) {
                vm.threads = response.result.data;
                vm.paginationTotalPages = response.result.last_page;
                vm.paginationPage = response.result.current_page;
                vm.isLoading = false;
            });
            */
        }

        function loadMore() {
            vm.paginationPage = vm.paginationPage + 1;
            load();
        };

        function reload() {
            vm.searchString = null;
            vm.threads = [];
            vm.paginationPage = 1;
            load();
        }

        function load() {
            vm.isLoading = true;
            var options = {
                siteID: siteID,
                section: section,
                groupIds: [groupId],
                sortDir: $rootScope.sortDir,
                sortField: $rootScope.sortField,
                page: vm.paginationPage
            };
            if (vm.searchString) {
                options.searchStringFilter = vm.searchString;
            }
            usersService.getUsersByGroups(options).then(function (response) {
                vm.threads = vm.threads.concat(response.result.data);
                vm.refcolumnsgrouped = _.groupBy(response.ref, function (m) {
                    return m['list_position'];
                });
                vm.threads = vm.threads.map(x => {
                    const ingroup =  vm.ingroupStatus.find(y => y.id_ingroup_status == x.id_ingroup_status);
                    x.status = ingroup ? ingroup.name : '';
                    return x;
                });
                vm.paginationTotalPages = response.result.last_page;
                vm.paginationPage = response.result.current_page;
                vm.isLoading = false;
            });
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        function showDate(value) {
            if (angular.isObject(value)) {
                return value.dateShow;
            } else if (value == '0000-00-00 00:00:00' || !value) {
                return '-';
            } else {
                var tz = (sessionService.site_operative.timezone || moment.tz.guess() || 'UTC').toString().trim();
                return moment.utc(value).tz(tz).format(vm.dateTimeFormat || 'DD/MM/YYYY HH:mm');
            }
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.mailing')
        .controller('SendLaterController', SendLaterController);

    /** @ngInject */
    function SendLaterController($mdDialog, date, sessionService) {
        var vm = this;
        vm.schedule = {};
        if (date) {
            vm.date = date;
        } else {
            vm.date = moment.utc(new Date())/*.tz(sessionService.site_operative.timezone)*/.format('YYYY-MM-DD HH:mm:00');
        }
        vm.updateDatePicker = updateDatePicker;
        vm.changeDatePicker = changeDatePicker;
        vm.dateFormat = sessionService.site_operative.dateFormat;
        vm.dateTimeFormat = sessionService.site_operative.dateTimeFormat;
        vm.updateDatePicker();
        // Methods
        vm.closeDialog = closeDialog;
        vm.cancelDialog = cancelDialog;
        vm.saveDialog = saveDialog;



        function closeDialog() {
            $mdDialog.hide();
        }
        function cancelDialog() {
            $mdDialog.hide({ date: null });
        }
        function saveDialog() {
            $mdDialog.hide({ date: vm.schedule.dateValue });
        }


        function updateDatePicker() {
            var value = vm.date;
            console.log(value);
            var utcDate = moment.utc(value);
            console.log(utcDate);
            var siteDate = moment.utc(value);
            console.log(siteDate);
            vm.schedule.dateValue = value;
            vm.schedule.date = new Date(siteDate.format());
            vm.schedule.dateShow = siteDate.format(vm.dateTimeFormat);
            vm.schedule.utcShow = utcDate.format(vm.dateTimeFormat);
            vm.schedule.utcDate = utcDate;
        }

        function changeDatePicker() {
            var value = moment.utc(vm.schedule.date).format('YYYY-MM-DD HH:mm:00');
            var utcDate = moment.utc(value);
            var siteDate = moment.utc(value).tz(sessionService.site_operative.timezone);
            vm.schedule.dateValue = value;
            vm.schedule.date = new Date(siteDate.format());
            vm.schedule.dateShow = siteDate.format(vm.dateTimeFormat);
            vm.schedule.utcShow = utcDate.format(vm.dateTimeFormat);
            vm.schedule.utcDate = utcDate;
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.mailing')
        .controller('SelectSectionMailToCases', SelectSectionMailToCases);

    /** @ngInject */
    function SelectSectionMailToCases(
        $mdDialog,
        $translate,
        sections
    ) {
        var vm = this;

        // Data
        vm.sections = sections;
        vm.selection = "";

        vm.closeDialog = cancel;
        vm.save = save;

        init();
        /**
         * Initialize
         */
        function init() {
            
        }
        
        function save(){
            $mdDialog.hide(vm.selection);
        }

        function cancel() {
            $mdDialog.hide();
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.mailing')
        .controller('SelectDuplicateTemplateController', SelectDuplicateTemplateController);

    /** @ngInject */
    function SelectDuplicateTemplateController(
        $mdDialog,
        $translate,
        templates,
        currentContent
    ) {
        var vm = this;

        // Data
        vm.templates = templates;
        vm.currentContent = currentContent;
        vm.selection = currentContent.id_mailing_template;

        vm.closeDialog = cancel;
        vm.save = save;

        init();
        /**
         * Initialize
         */
        function init() {
            
        }
        
        function save(){
            $mdDialog.hide(vm.selection);
        }

        function cancel() {
            $mdDialog.hide();
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.mailing')
        .directive('qiuUsersOnSelectGroup', ['usersService', onSelectGroup])
        .controller('SelectGroupDialogController', SelectGroupDialogController);

    /** @ngInject */
    function SelectGroupDialogController(
        $mdDialog,
        sourceGroups,
        siteID,
        $scope,
        $translate,
        usersService,
        transformUsers
    ) {
        var vm = this;

        // Data
        vm.sourceGroups = sourceGroups;
        vm.siteID = siteID;
        vm.loading = false;
        vm.viewUsersGroup = 'app/main/apps/users/dialogs/groups/views/tree-view.html';

        vm.closeDialog = cancel;


        vm.translate = function (text) {
            return $translate.instant(text);
        }

        init();
        /**
         * Initialize
         */
        function init() {
            $scope.isLoadingGroups = true;
            var opts = {
                siteID: vm.siteID,
                groupType: 2,
                withGroupType: true
            };
            usersService.getUsersGroups(opts).then(function (response) {
                var qiuRestrictions = response.qiuRestrictions;
                var groups = response.data;
                vm.CleanUsersGroups = transformUsers.formatNestedGroups(groups, qiuRestrictions, true);
            });
        }

        function cancel() {
            $mdDialog.hide(false);
        }

        $scope.$on('loadUsersByGroups', function (event, groups) {
            console.log(groups)
            $mdDialog.hide(groups[0]);
        });

    }
})();

function onSelectGroup(usersService) {

    function unselectAllGroups() {
        var elemList = document.querySelectorAll('.group-row');
        elemList.forEach(function (elem) {
            elem.classList.remove('selected');
        });
    }

    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            $(element).on('click', function (e) {
                var groupNode = false;
                if (element.parent().hasClass('selected')) {
                    unselectAllGroups();
                } else {
                    unselectAllGroups();
                    element.parent().addClass('selected');
                    groupNode = scope.node;
                }
                var includeSubgroups = $('#includeSubgroups').attr("data-include-subgroups") == 'true';
                usersService.triggerUsersByGroups(groupNode, includeSubgroups);
            });
        }
    };
}
(function () {
    'use strict';

    angular
        .module('app.mailing')
        .controller('MailingToContentReviewController', MailingToContentReviewController);

    /** @ngInject */
    function MailingToContentReviewController(
        $mdDialog,
        $translate,
        $sce,
        $timeout,
        $document,
        $scope,
        sessionService,
        sitemapService,
        mailingToContentService,
        content,
        section
    ) {
        var vm = this;

        // Idiomas del site: el campo lang se elige de una lista, no escribiendo el id.
        vm.languages = buildLanguages();

        // Claves estructurales de un bloque de multiple_texts: no son texto editable.
        // 'template' es del formato legacy (template.id por tenant); 'type'/'style' son
        // del formato canónico unificado. El diálogo soporta ambos.
        var BLOCK_STRUCTURAL_KEYS = ['size', 'template', 'media', 'type', 'style'];
        // Campos de cabecera que no deben tocarse (enlazan el content con el mailing).
        var READONLY_HEADER_KEYS = ['unique_id'];

        // Trabajamos sobre una copia: si se cancela, no se ensucia el original.
        vm.content = angular.copy(content);
        vm.section = section;
        vm.sectionLabel = (section && (section.label || section.section)) || '';

        vm.headerFields = buildHeaderFields();
        vm.blocks = angular.isArray(vm.content.multiple_texts) ? vm.content.multiple_texts : [];
        vm.thumbnails = angular.isArray(vm.content.Thumbnail) ? vm.content.Thumbnail : [];

        // ── Previsualización con el CSS real del sitio ───────────────────────
        // Un tenant puede tener VARIOS templates (domains_templates) y cada uno con
        // su propio CSS compilado. Se preselecciona el marcado como default_template,
        // pero el selector siempre está visible para poder comparar diseños.
        vm.templates = [];
        vm.selectedTemplate = null;
        vm.onTemplateChange = renderPreview;
        // Al editar un campo, la previsualización se repinta para reflejarlo.
        vm.refreshPreview = renderPreview;

        loadTemplates();

        function loadTemplates() {
            var idDomain = sessionService.site_operative && sessionService.site_operative.id_domain;
            if (!idDomain) {
                renderPreview();
                return;
            }
            sitemapService.getSubDomains({ domain: idDomain }).then(function (response) {
                vm.templates = response || [];
                var byDefault = vm.templates.find(function (t) { return t.default_template; });
                vm.selectedTemplate = byDefault || vm.templates[0] || null;
                renderPreview();
            }, function () {
                renderPreview(); // sin templates: se previsualiza sin CSS del sitio
            });
        }

        /** URL del CSS publicado del template elegido. */
        function templateCssUrl() {
            if (!vm.selectedTemplate || !vm.selectedTemplate.template_name) {
                return null;
            }
            return 'https://' + vm.selectedTemplate.template_name + '.qiupreview.com/assets/css/style.css';
        }

        /**
         * Pinta los bloques dentro de un iframe con el CSS del sitio. El iframe aísla
         * ese CSS del admin (si no, se llevaría por delante el layout de qiusystem).
         * Como lo escribimos nosotros, es same-origin y podemos cablear los controles.
         */
        function renderPreview() {
            $timeout(function () {
                var frame = $document[0].getElementById('rc-preview-frame');
                if (!frame) {
                    return;
                }
                var doc = frame.contentDocument || frame.contentWindow.document;
                doc.open();
                doc.write(buildPreviewDocument());
                doc.close();
                wirePreviewActions(doc);
            });
        }

        /** Documento del iframe: CSS del sitio + bloques + controles de edición. */
        function buildPreviewDocument() {
            var css = templateCssUrl();
            var body = '';

            vm.blocks.forEach(function (block, index) {
                body +=
                    '<div class="qp-block" data-index="' + index + '">' +
                    '  <div class="qp-tools">' +
                    '    <button data-action="up" title="↑">↑</button>' +
                    '    <button data-action="down" title="↓">↓</button>' +
                    '    <button data-action="edit" title="✎">✎</button>' +
                    '    <button data-action="remove" title="✕">✕</button>' +
                    '  </div>' +
                    mailingToContentService.renderBlockHtml(block) +
                    '</div>';
            });

            return '<!doctype html><html><head><meta charset="utf-8">' +
                (css ? '<link rel="stylesheet" href="' + css + '">' : '') +
                '<style>' + previewChromeCss() + '</style>' +
                '</head><body class="qp-preview">' +
                '<div class="qp-canvas">' + body + '</div>' +
                '</body></html>';
        }

        /**
         * Estilos SOLO del andamiaje de edición (contorno y botones). Van con prefijo
         * qp- para no chocar con el CSS del sitio, que es quien maqueta el contenido.
         */
        function previewChromeCss() {
            return [
                '.qp-canvas{display:flex;flex-wrap:wrap;align-items:flex-start;}',
                '.qp-block{position:relative;outline:1px dashed transparent;box-sizing:border-box;}',
                '.qp-block:hover{outline-color:#039be5;}',
                '.qp-block:hover .qp-tools{display:flex;}',
                '.qp-tools{display:none;position:absolute;top:0;right:0;z-index:99;gap:2px;',
                'background:rgba(255,255,255,.95);border:1px solid #039be5;border-radius:3px;padding:2px;}',
                '.qp-tools button{cursor:pointer;border:0;background:transparent;font-size:13px;',
                'line-height:1;padding:3px 6px;}',
                '.qp-tools button:hover{background:#e1f5fe;}',
                // El ancho lo manda el CSS del sitio (size-N); esto es solo un apaño por
                // si ese CSS no define las clases de tamaño, para que no salga todo al 100%.
                '.qp-block:has(.size-50){width:50%;}',
                '.qp-block:has(.size-33){width:33.33%;}',
                '.qp-block:has(.size-25){width:25%;}',
                '.qp-block:has(.size-20){width:20%;}'
            ].join('');
        }

        /** Cablea los botones del iframe con las acciones de Angular. */
        function wirePreviewActions(doc) {
            doc.addEventListener('click', function (event) {
                var button = event.target.closest('[data-action]');
                if (!button) {
                    return;
                }
                var host = button.closest('.qp-block');
                var index = parseInt(host.getAttribute('data-index'), 10);
                var action = button.getAttribute('data-action');

                $scope.$apply(function () {
                    if (action === 'up') { moveBlock(index, -1); }
                    else if (action === 'down') { moveBlock(index, 1); }
                    else if (action === 'remove') { removeBlock(index); }
                    else if (action === 'edit') { vm.editingIndex = index; }
                });

                if (action !== 'edit') {
                    renderPreview();
                }
            });
        }

        // ── Editor visual ────────────────────────────────────────────────────
        // Índice del bloque en edición (-1 = ninguno). Se edita de uno en uno.
        vm.editingIndex = -1;
        vm.toggleEdit = toggleEdit;
        vm.isEditing = isEditing;
        vm.trustHtml = trustHtml;
        vm.hasVisualPreview = hasVisualPreview;

        // Reordenar arrastrando (mismo motor que el tab media de content).
        vm.blocksSortable = {
            animation: 150,
            handle: '.rc-block-drag',
            ghostClass: 'rc-block-ghost',
            onEnd: function () {
                // El binding de ng-sortable ya reordena vm.blocks; solo salimos de edición
                // para que el índice en edición no apunte a otro bloque.
                vm.editingIndex = -1;
            }
        };

        vm.getBlockFields = getBlockFields;
        vm.getBlockLabel = getBlockLabel;
        vm.getMediaPreview = getMediaPreview;
        vm.isReadOnly = isReadOnly;
        vm.isLanguageField = isLanguageField;
        vm.getLanguageLabel = getLanguageLabel;
        vm.moveBlock = moveBlock;
        vm.removeBlock = removeBlock;
        vm.removeThumbnail = removeThumbnail;
        vm.confirm = confirm;
        vm.cancel = cancel;

        /**
         * Campos de cabecera mapeados por raw_settings (title, lang, date, unique_id…).
         * Se derivan del propio content, saltando las estructuras (bloques e imágenes).
         */
        function buildHeaderFields() {
            var fields = [];
            angular.forEach(vm.content, function (value, key) {
                if (key === 'multiple_texts' || key === 'Thumbnail') {
                    return;
                }
                if (angular.isObject(value) || angular.isArray(value)) {
                    return; // solo campos escalares son editables aquí
                }
                fields.push({ key: key });
            });
            return fields;
        }

        function isReadOnly(key) {
            return READONLY_HEADER_KEYS.indexOf(key) !== -1;
        }

        /** Los campos de idioma se pintan como select en vez de input libre. */
        function isLanguageField(key) {
            return key === 'lang' || key === 'id_lang';
        }

        /** Idiomas del site como lista [{id_lang, name…}] para el desplegable. */
        function buildLanguages() {
            var langs = [];
            try {
                angular.forEach(sessionService.getSiteLanguages(), function (lang) {
                    langs.push(lang);
                });
            } catch (e) {
                return [];
            }
            return langs;
        }

        /** Etiqueta legible de un idioma, tolerando distintas formas del objeto. */
        function getLanguageLabel(lang) {
            if (!lang) {
                return '';
            }
            return lang.language || lang.name || lang.title || lang.iso || lang.id_lang;
        }

        /**
         * Campos de texto editables de un bloque. Los nombres dependen del mapeo del
         * tenant (mailing-templates), así que se descubren en runtime.
         */
        function getBlockFields(block) {
            var fields = [];
            angular.forEach(block, function (value, key) {
                if (BLOCK_STRUCTURAL_KEYS.indexOf(key) !== -1) {
                    return;
                }
                if (angular.isObject(value) || angular.isArray(value)) {
                    return;
                }
                fields.push({ key: key });
            });
            return fields;
        }

        function getBlockLabel(block, index) {
            // Canónico: el propio tipo describe el bloque (y lleva su ancho).
            if (block && block.type) {
                return block.size && block.size !== 100
                    ? block.type + ' · ' + block.size + '%'
                    : block.type;
            }
            // Legacy: nombre de la plantilla del tenant.
            if (block && block.template && block.template.name) {
                return block.template.name;
            }
            return $translate.instant('MAILING.REVIEW_BLOCK') + ' ' + (index + 1);
        }

        /** URL de preview de un media, tolerando las distintas formas del objeto. */
        function getMediaPreview(media) {
            if (!media) {
                return null;
            }
            if (media.container && media.container.view_url) {
                return media.container.view_url + (media.filename || '');
            }
            return media.thumbnail_url || media.image_url || media.permalink || null;
        }

        /** Abre/cierra la edición inline de un bloque. */
        function toggleEdit(index) {
            vm.editingIndex = (vm.editingIndex === index) ? -1 : index;
        }

        function isEditing(index) {
            return vm.editingIndex === index;
        }

        /** El texto de los bloques viene como HTML del mailing: se pinta tal cual. */
        function trustHtml(html) {
            return $sce.trustAsHtml(html || '');
        }

        /**
         * Un bloque tiene preview visual propia si es de los tipos canónicos que
         * sabemos pintar. El resto cae a una representación genérica.
         */
        function hasVisualPreview(block) {
            return ['text', 'title', 'image', 'divider', 'button'].indexOf(block && block.type) !== -1;
        }

        function moveBlock(index, offset) {
            var target = index + offset;
            if (target < 0 || target >= vm.blocks.length) {
                return;
            }
            var moved = vm.blocks.splice(index, 1)[0];
            vm.blocks.splice(target, 0, moved);
        }

        function removeBlock(index) {
            vm.blocks.splice(index, 1);
        }

        function removeThumbnail(index) {
            vm.thumbnails.splice(index, 1);
        }

        function confirm() {
            vm.content.multiple_texts = vm.blocks;
            vm.content.Thumbnail = vm.thumbnails;
            $mdDialog.hide(vm.content);
        }

        function cancel() {
            $mdDialog.cancel();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.mailing')
        .directive('qiuOnCheckToggleAssignedGroup', ToggleAssignedGroup)
        .controller('GroupsController', GroupsController);


    /** @ngInject */
    function GroupsController($mdDialog, groups) {
        var vm = this;

        vm.groups = groups;

        vm.closeDialog = closeDialog;
        vm.save = save;

        function closeDialog() {
            $mdDialog.hide();
        }
        function save() {
            $mdDialog.hide(true);
        }
    }

    function ToggleAssignedGroup(mailingService) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                $(element).on('click', function (e) {
                    mailingService.triggerSelectGroup(scope.node.id_group);
                });
            }
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('app.mailing')
        .controller('GroupMailingController', GroupMailingController);

    /** @ngInject */
    function GroupMailingController($mdDialog, $document, items, modeView,  mediaService, fieldsTemplateMailing, requestContext, $anchorScroll, $timeout, $scope, $sce, Upload, section, msUtils, COMMON, isTiny, $translate, $log) {

        var vm = this;
        var originatorEv;

        // Data
        vm.items = items;
        vm.viewGroupField = 'app/main/apps/mailing/dialogs/group/group-view.html';
        vm.typeFields = ['separator', 'relatedTable', 'textBox', 'htmlBox', 'colorPicker', 'checkbox', 'datePicker'];
        vm.basicForm = {};
        vm.currentView = '1';
        vm.modeView = modeView;

        vm.templateSortable = {
            group: '.template',
            animation: 150,
            scroll: true,
            handle: '.drag',
            filter: '.no-sort',
            ghostClass: "sort-drop",
            onStart: function(evt) {
                vm.copyMock = angular.copy(vm.items);
            },
            onEnd: function(evt) {
                if (typeof evt.oldIndex == 'undefined' || typeof evt.newIndex == 'undefined') {
                    return false
                }
                vm.copyMock = changePosition(evt.newIndex, evt.oldIndex, vm.copyMock);
                vm.items = vm.copyMock;
                return false;

            }
        }


        // Methods
        vm.addNewStructureFieldGroup = addNewStructureFieldGroup;
        vm.saveFieldStructure = saveFieldStructure;
        vm.cancelEditFieldStructure = cancelEditFieldStructure;
        vm.openMenu = openMenu;
        vm.removeFieldStructure = removeFieldStructure;
        vm.editFieldStructure = editFieldStructure;
        vm.closeDialog = closeDialog;
        vm.save = save;
        
        vm.translate    = instantTranslate;


        function init() {
            vm.loading = true;
        }


        function addNewStructureFieldGroup() {
            if (!vm.items){
                vm.items = [];
            }
            fieldsTemplateMailing.addNewStructureField(vm.items);
        }

        function saveFieldStructure(index) {
            fieldsTemplateMailing.saveFieldStructure(index, vm.items);
        }

        function cancelEditFieldStructure(index) {
            fieldsTemplateMailing.cancelEditFieldStructure(index, vm.items, vm.copyStructure);
        }

        function openMenu($mdMenu, ev) {
            originatorEv = ev;
            $mdMenu.open(ev);
        }

        function removeFieldStructure(index) {
            fieldsTemplateMailing.removeFieldStructure(index, vm.items, null);
        }

        function editFieldStructure(index) {
            vm.copyStructure;
            closeOthers();
            vm.copyStructure = angular.copy(vm.items[index]);
            vm.items[index].editing = true;
        }

        function closeOthers() {
            fieldsTemplateMailing.closeOthers(vm.items);
        }

        function changePosition(newIndex, oldIndex, array) {
            if (oldIndex < newIndex) {
                for (var i = oldIndex; i < newIndex; i++) {
                    var temp = array[i + 1];
                    array[i + 1] = array[i];
                    array[i] = temp;
                }
            }
            if (newIndex < oldIndex) {
                for (var i = oldIndex; i > newIndex; i--) {
                    var temp = array[i - 1];
                    array[i - 1] = array[i];
                    array[i] = temp;
                }
            }

            vm.basicForm.$setDirty();
            return array;
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        function save() {
            $mdDialog.hide(vm.items);
        }
        
        function instantTranslate(text)
        {
            return $translate.instant(text);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.content')
        .controller("siteContentEditController", Controller);


    // Define the constructor.
    /** @ngInject */
    function Controller(
        $scope,
        $rootScope,
        $window,
        $timeout,
        requestContext,
        $location,
        $auth,
        // Deferred,
        // Pawe,
        // screenService,
        $stateParams,
        contentService,
        // projectDetailPartial,
        // projectScreensPartial,
        // sessionService,
        // modelEvents,
        // moment,
        // Debouncer,
        // dateHelper,
        // userService,
        // validationService,
        // _,
        // config,
        // $q,
        $http,
        dataItem
        // analyticsService,
        // slackInterceptor
    ) {

        // I am the set of filters that can be applied to the projects list.
        $scope.filters = {
            projectFilter: $location.search().projectFilter || "",
            companyID: $scope.lastSelectedCompanyIDForProjects || "",
            teamID: $location.search().teamID || "",
            userID: $location.search().userID || "",
            platform: $location.search().platform || "",
            type: $location.search().type || "",
            sort: $scope.sort,
            searchCollaborators: ""
        };
        $scope.filters.projectFilterInput = $scope.filters.projectFilter;
        $scope.isLoading=true;

        $scope.today = new Date();

        $scope.status = {
            opened: false
        };

        $scope.open = function ($event) {
            $scope.status.opened = true;
        };

        $scope.dateFormat = "yyyy-MM-dd HH:mm:ss";


        function init() {

            $scope.itemID = requestContext.getParam("id");

            $scope.dataItem = dataItem;
            $scope.view_medialist = true;
            
            // $scope.bigCurrentPage = 1;
            // request the initial set of data
            // loadRemoteData();

            $scope.getList();

            // if(siteID=='volvooceanrace')
            //     loadCdnStatus();

        }

        function loadCdnStatus(){

             cdnContainersService.getCdnStatus($scope.siteID).then(
                function(data) {
                    $scope.cdn_status = data.data;
                    setTimeout(loadCdnStatus, 10000); // retry
                }
            )
            

        }

        function getContainerbyID(container) {

            // request the initial set of data
            loadRemoteData();

            cdnContainersService.getContainerByID($scope.siteID, container).then(
                function(response) {
                    $scope.cdn_container_list = response.data;
                    $scope.cdn_container_list_total = response.count;
                }
            )

        }


        // I load the remote data from the server (and from the local cache).
        function loadRemoteData() {
            // different activity indicator for the first request
            $scope.isLoading = !$scope.hasLoaded;

            // Flag that the remote data is being loaded.
            $scope.isBusy = true;

            // get the time for this request
            var requestedAt = +new Date;
            loadRemoteData.lastRequest = requestedAt;

            // send the request, but give a moment for the
            // UI to show the busy state
            $timeout(function() {
                // var params = shouldUsePagination() ? getFilterParams() : {
                //     sort: 'userSort'
                // };
            })

        }


        // gets filter parameters to send to the server
        function getFilterParams() {
            var params = _.clone($scope.filters);

            // get rename the search filter
            var filter = $.trim(params.projectFilter || params.projectFilterInput);
            if (filter.length > 0) params.filter = filter;
            delete params.projectFilterInput;
            delete params.projectFilter;

            // don't include zero IDs
            if (params.teamID === 0) delete params.teamID;
            if (params.userID === 0) delete params.userID;

            // require an archive param
            if (!params.archived) params.archived = false;

            // if params have been included, but not a page
            // number, make sure to set it to zero - by default
            // the server will use page zero, but this will make
            // sure that the cache is set to the same page number
            if (!('page' in params)) params.page = 0;
            if (!('platform' in params)) params.platform = 'all';

            return params;
        }



        // ---
        // PUBLIC METHODS.
        // ---

        $scope.getContainer = function(container) {

            getContainerbyID(container);
        }

        $scope.setPage = function (pageNo) {
            $scope.bigCurrentPage = pageNo;
        };

        $scope.pageChanged = function() {
            console.log('Page changed to: ' + $scope.currentPage)
                    $scope.getList();

            // $log.log('Page changed to: ' + $scope.currentPage);
        };

        $scope.getList = function(){


//          console.debug(dataItem.result)

                $scope.itemData = dataItem.result;
                $scope.refData = dataItem.ref;
                $scope.columns = dataItem.ref;
                $scope.totalItems = dataItem.total;
                $scope.numPages = dataItem.last_page;
                
                $scope.total = dataItem.total;
                $scope.currentPage = dataItem.current_page;
                $scope.pageSize = dataItem.per_page;

                $scope.isLoading=false;


                var options={site:$scope.siteID, section:$scope.section, id:$scope.itemID};

                contentService.getMediaByID(options).then(
                    function(response) {
                        $scope.itemMedia=response.data;
                    }
                );

            // var options={site:$scope.siteID, section:$scope.section, id:$scope.itemID};

            // contentService.getByID(options).then(
            // function(response) {

            //     $scope.medialist= [];

            //     $scope.itemData = response.result;
            //     $scope.refData = response.ref;
            //     $scope.columns = response.ref;
            //     $scope.totalItems = response.total;
            //     $scope.numPages = response.last_page;
                
            //     $scope.total = response.total;
            //     $scope.currentPage = response.current_page;
            //     $scope.pageSize = response.per_page;

            //     $scope.isLoading=false;
            //     // $scope.maxSize = 5;

                  
            //       // $scope.maxSize = 500;
            //       // $scope.bigTotalItems = 175;
            //       // $scope.bigCurrentPage = 1;
            // });
        }





        // finally, initialize
        init();


    }

})();
(function () {
    'use strict';

    angular.module('app.content')
        .directive('wbDraggable', function ($document) {
            return {
                restrict: 'A',
                scope: {
                    dragData: '='
                },
                link: function (scope, element) {
                    element.attr('draggable', true);
                    element.find('md-icon').css('pointer-events', 'none');

                    element.on('dragstart', function (e) {
                        var ev = e.originalEvent || e;
                        var doc = $document[0]; 
                        ev.stopPropagation();
                        if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
                        // Use Angular helpers
                        var payload = angular.toJson(scope.dragData);
                        ev.dataTransfer.setData('application/x-webbuilder', payload);
                        ev.dataTransfer.effectAllowed = 'copy';

                        // Block preview
                        var preview = element[0].cloneNode(true);
                        preview.style.position = 'fixed';
                        preview.style.top = '-1000px';
                        preview.style.left = '-1000px';
                        preview.style.opacity = '0.6';
                        preview.style.pointerEvents = 'none';
                        doc.body.appendChild(preview);

                        // Cursor center
                        ev.dataTransfer.setDragImage(
                            preview,
                            preview.offsetWidth / 2,
                            preview.offsetHeight / 2
                        );

                        // Clear
                        setTimeout(function () {
                            if (preview && preview.parentNode) {
                                preview.parentNode.removeChild(preview);
                            }
                        }, 0);


                        element.addClass('dragging').attr('aria-grabbed', 'true');
                    });

                    
                    element.on('dragend', function (e) {
                        var ev = e.originalEvent || e;
                        ev.stopPropagation();
                        if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
                        element.removeClass('dragging').attr('aria-grabbed', 'false');
                    });
                }
            };
        })
        .directive('wbDroppable', function ($log) {
            return {
                restrict: 'A',
                scope: {
                    dropHandler: '&'
                },
                link: function (scope, element) {
                    element.on('dragover', function (e) {
                        var ev = e.originalEvent || e;
                        ev.preventDefault();
                        ev.stopPropagation();
                        if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
                        ev.dataTransfer.dropEffect = 'copy';
                        element.addClass('drag-over');
                    });

                    element.on('dragleave', function (e) {
                        var ev = e.originalEvent || e;
                        ev.stopPropagation();
                        if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
                        element.removeClass('drag-over');
                    });

                    element.on('drop', function (e) {
                        var ev = e.originalEvent || e;
                        ev.preventDefault();
                        ev.stopPropagation();
                        element.removeClass('drag-over');

                        var raw = ev.dataTransfer.getData('application/x-webbuilder');
                        try {
                            var data = angular.fromJson(raw);
                            scope.$applyAsync(function () {
                                scope.dropHandler({ data: data });
                            });
                        } catch (err) {
                            $log.error('Invalid drop data', raw, err);
                        }
                    });
                }
            };
        })
        .directive('wbBlockDraggable', function ($document, $log) {
            return {
                restrict: 'A',
                scope: {
                    index: '=wbBlockIndex',
                    onMove: '&wbBlockMove',
                    onInsert: '&?wbBlockInsert'
                },
                link: function (scope, element) {
                    var dragEnabled = false;
                    var dragHandleSelector = '.wb-drag-handle';

                    function isFromHandle(ev) {
                        var target = ev.target || ev.srcElement;
                        if (!target) return false;
                        // Usamos angular.element para tener closest
                        return !!angular.element(target).closest(dragHandleSelector).length;
                    }

                    element.on('mousedown', function (e) {
                        if (isFromHandle(e)) {
                            dragEnabled = true;
                            element.attr('draggable', true);
                        } else {
                            dragEnabled = false;
                            element.removeAttr('draggable');
                        }
                    });

                    element.on('mouseup', function () {
                        dragEnabled = false;
                        element.removeAttr('draggable');
                    });

                    // DRAG START
                    element.on('dragstart', function (e) {
                        var ev = e.originalEvent || e;
                        if (!dragEnabled) {
                            ev.preventDefault();
                            return false;
                        }

                        ev.stopPropagation();
                        if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();

                        ev.dataTransfer.setData(
                            'application/x-webbuilder-block-index',
                            String(scope.index)
                        );

                        ev.dataTransfer.setData('text/plain', String(scope.index));

                        ev.dataTransfer.effectAllowed = 'move';

                        // Preview
                        var doc = $document[0];
                        var preview = element[0].cloneNode(true);
                        preview.style.position = 'fixed';
                        preview.style.top = '-1000px';
                        preview.style.left = '-1000px';
                        preview.style.opacity = '0.6';
                        preview.style.pointerEvents = 'none';
                        doc.body.appendChild(preview);

                        ev.dataTransfer.setDragImage(
                            preview,
                            preview.offsetWidth / 2,
                            preview.offsetHeight / 2
                        );

                        setTimeout(function () {
                            if (preview && preview.parentNode) {
                                preview.parentNode.removeChild(preview);
                            }
                        }, 0);

                        element.addClass('dragging');
                    });

                    // DRAG END
                    element.on('dragend', function (e) {
                        var ev = e.originalEvent || e;
                        ev.stopPropagation();
                        if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
                        element.removeClass('dragging');
                        element.removeClass('drag-over-block');
                        element.removeClass('drag-over-insert');
                        dragEnabled = false;
                        element.removeAttr('draggable');
                    });

                    // DRAG OVER
                    element.on('dragover', function (e) {
                        var ev = e.originalEvent || e;
                        ev.preventDefault();
                        ev.stopPropagation();
                        if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();

                        var types = ev.dataTransfer.types || [];
                        var hasBlockIndex = Array.prototype.indexOf.call(
                            types,
                            'application/x-webbuilder-block-index'
                        ) !== -1;
                        var hasTemplate = Array.prototype.indexOf.call(
                            types,
                            'application/x-webbuilder'
                        ) !== -1;

                        if (hasBlockIndex) {
                            ev.dataTransfer.dropEffect = 'move';
                            element.addClass('drag-over-block');
                            element.removeClass('drag-over-insert');
                        } else if (hasTemplate) {
                            ev.dataTransfer.dropEffect = 'copy';
                            element.addClass('drag-over-insert');
                            element.removeClass('drag-over-block');
                        } else {
                            ev.dataTransfer.dropEffect = 'none';
                            element.removeClass('drag-over-block');
                            element.removeClass('drag-over-insert');
                        }
                    });

                    element.on('dragleave', function (e) {
                        var ev = e.originalEvent || e;
                        ev.stopPropagation();
                        if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
                        element.removeClass('drag-over-block');
                        element.removeClass('drag-over-insert');
                    });

                    // DROP
                    element.on('drop', function (e) {
                        var ev = e.originalEvent || e;
                        ev.preventDefault();
                        ev.stopPropagation();
                        if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
                        element.removeClass('drag-over-block');
                        element.removeClass('drag-over-insert');

                        var rawBlockIndex = ev.dataTransfer.getData('application/x-webbuilder-block-index');
                        if (rawBlockIndex !== null && rawBlockIndex !== '') {
                            var fromIndex = parseInt(rawBlockIndex, 10);
                            var toIndex = scope.index;

                            if (!isNaN(fromIndex) && fromIndex !== toIndex) {
                                scope.$applyAsync(function () {
                                    scope.onMove({ from: fromIndex, to: toIndex });
                                });
                            }
                            return;
                        }

                        var rawTpl = ev.dataTransfer.getData('application/x-webbuilder');
                        if (rawTpl && scope.onInsert) {
                            try {
                                var data = angular.fromJson(rawTpl);
                                var idx = scope.index;
                                scope.$applyAsync(function () {
                                    scope.onInsert({ index: idx, data: data });
                                });
                            } catch (err) {
                                $log.error('Invalid drop data on block', rawTpl, err);
                            }
                        }
                    });
                }
            };
        })
        .controller('WebBuilderDialogController', WebBuilderDialogController);

    /**@ngInject */

    function WebBuilderDialogController($scope, $mdDialog, $log, ref, content){
        const vm = this;

        vm.webTemplate = {
            columns: 12,
            bgColor: '#ffffff',
            blocks: []
        };

        vm.webConfig = [
            {
                type: 'selector',
                label: 'Columns',
                value: 'columns',
                options: [
                    {
                        label: 4,
                        value: 4
                    },
                    {
                        label: 8,
                        value: 8
                    },
                    {
                        label: 12,
                        value: 12
                    },
                    {
                        label: 16,
                        value: 16
                    },
                    {
                        label: 20,
                        value: 20
                    },
                    {
                        label: 24,
                        value: 24
                    },
                ]
            },
            {
                type: 'color',
                label: 'Background Color',
                value: 'bgColor'
            }
        ];

        vm.webTemplates = [
            {
                type: 'empty',
                label: 'Empty block'
            },
            {
                type: 'text',
                label: 'Text'
            }
        ];

        vm.editorConfig = {
            placeholder: 'Escribe aquí...',
            // tools: puedes sobreescribir o añadir opciones por instancia
        };

        vm.selectedBlock = undefined;

        vm.isGridVisible = false;

        vm.webTemplateOptions = [];

        function buildNumberOptions(n) {
            n = Number(n) || 0;
            if (n < 1) return [];
            var out = [];
            for (var i = 1; i <= n; i++) out.push({ label: i, value: i });
            return out;
        }

        function clampInt(v, min, max) {
            v = Number(v);
            if (!Number.isFinite(v)) v = min;
            return Math.min(Math.max(v, min), max);
        }

        $scope.$watch(
            function () { return vm.webTemplate.columns; },
            function (n, o) {
                var maxCols = clampInt(n, 1, 999);

                // 1) Recalcula las opciones del selector (1..maxCols)
                vm.webTemplateOptions.columns = (function buildNumberOptions(k) {
                    var out = [];
                    for (var i = 1; i <= k; i++) out.push({ label: i, value: i });
                    return out;
                })(maxCols);

                // 2) Ajusta TODOS los bloques
                if (Array.isArray(vm.webTemplate.blocks)) {
                    vm.webTemplate.blocks.forEach(function (b) {
                        // span (columns) nunca > maxCols, al menos 1
                        var span = clampInt(b.columns || 1, 1, maxCols);

                        // si usas offset de inicio (b.start), corrige también
                        if (b.start != null) {
                            var start = clampInt(b.start, 1, maxCols);
                            // si start + span - 1 se sale, recorta span
                            if (start + span - 1 > maxCols) {
                                span = Math.max(1, maxCols - start + 1);
                            }
                            b.start = start;
                        }
                        b.columns = span;
                    });
                }

                // 3) Si hay bloque seleccionado, asegúrate de que queda válido también
                if (vm.selectedBlock) {
                    vm.selectedBlock.columns = clampInt(vm.selectedBlock.columns || 1, 1, maxCols);
                    if (vm.selectedBlock.start != null) {
                        vm.selectedBlock.start = clampInt(vm.selectedBlock.start, 1, maxCols);
                        if (vm.selectedBlock.start + vm.selectedBlock.columns - 1 > maxCols) {
                            vm.selectedBlock.columns = Math.max(1, maxCols - vm.selectedBlock.start + 1);
                        }
                    }
                }
            }
        );

        vm.webTemplateOptions.columns = buildNumberOptions(vm.webTemplate.columns || 12);

        function init() {
            $log.warn('ref', ref);
            $log.warn('content', content);
        }

        init();

        vm.addBlock = function (tpl) {
            var block = angular.copy(tpl);

            // Default margin/padding/columns if missing
            block.margin = block.margin || {
                top: 0, right: 0, bottom: 0, left: 0
            };
            block.padding = block.padding || {
                top: 0, right: 0, bottom: 0, left: 0
            };
            block.columns = block.columns || 1;
            block.bgColor = block.bgColor || '#ffffff';

            vm.webTemplate.blocks.push(block);
        };

        vm.moveBlock = function (from, to) {
            var list = vm.webTemplate.blocks;
            if (!Array.isArray(list)) return;

            if (from < 0 || from >= list.length || to < 0 || to >= list.length) {
                return;
            }
            if (from === to) return;

            var item = list.splice(from, 1)[0];
            list.splice(to, 0, item);
        };

        vm.insertBlockAt = function (index, tpl) {
            var list = vm.webTemplate.blocks;
            if (!Array.isArray(list)) return;

            index = Number(index);
            if (!Number.isFinite(index)) index = list.length;
            index = Math.max(0, Math.min(index, list.length));

            var block = angular.copy(tpl);

            block.margin = block.margin || {
                top: 0, right: 0, bottom: 0, left: 0
            };
            block.padding = block.padding || {
                top: 0, right: 0, bottom: 0, left: 0
            };
            block.columns = block.columns || 1;
            block.bgColor = block.bgColor || '#ffffff';

            list.splice(index, 0, block);
        };

        vm.cancel = function(){ $mdDialog.cancel(); };

    }

})();
(function () {
    'use strict';

    angular.module('app.content')
        .controller('aiTranslateController', aiTranslateController);
    
    /** @ngInject */
    function aiTranslateController($scope, $mdDialog, languages, siteID, threads, sessionService){
        var vm = this;
        vm.languages = [];
        vm.selectedLanguages = [];
        vm.closeDialog = closeDialog;
        vm.addLang = addLang;
        vm.threads = threads;
        console.log('vm.threads', vm.threads);
        vm.getServiceLangs = getServiceLangs;
        vm.save = save;
        vm.selectedProvider = "";
        vm.loading = true;
        vm.translateServices = [];
        vm.languagesByService = {
            "aws": [
              "AF", "SQ", "AM", "AR", "HY", "AZ", "BN", "BS", "BG", "CA", "ZH", "ZH-TW", "HR", "CS", "DA", "FA-AF",
              "NL", "EN", "ET", "FA", "TL", "FI", "FR", "FR-CA", "KA", "DE", "EL", "GU", "HT", "HA", "HE", "HI",
              "HU", "IS", "ID", "GA", "IT", "JA", "KN", "KK", "KO", "LV", "LT", "MK", "MS", "ML", "MT", "MR", "MN",
              "NO", "PS", "PL", "PT", "PT-PT", "PA", "RO", "RU", "SR", "SI", "SK", "SL", "SO", "ES", "ES-MX", "SW",
              "SV", "TA", "TE", "TH", "TR", "UK", "UR", "UZ", "VI", "CY"
            ],
            "deepl": [
              "AR", "BG", "CS", "DA", "DE", "EL", "EN", "ES", "ET", "FI", "FR", "HU", "ID", "IT", "JA", "KO",
              "LT", "LV", "NB", "NL", "PL", "PT", "RO", "RU", "SK", "SL", "SV", "TR", "UK", "ZH"
            ],
            "ai": [
              "EN", "ES", "PT", "IT", "FR", "ID", "DE", "AR", "ZH", "KO", "JA", "HI", "BN", "SW", "YO"
            ]
        };

        function init() {
            vm.languages = languages.filter(lang => {
                if(lang.lang_name === 'SR'){
                    lang.flag_code = 'RS';
                }
                if (lang.lang_name === 'OTHER') return false;
                if (vm.threads.length === 1) {
                    return lang.id_lang !== vm.threads[0].lang;
                }
                if (vm.threads.length > 1) {
                    const firstLang = vm.threads[0].lang;
                    const allSameLang = vm.threads.every(thread => thread.lang === firstLang);
                    if (allSameLang) {
                        return lang.id_lang !== firstLang;
                    }
                }
                return true;
            });
            
            sessionService.loadDomainResourceSettings(siteID).then(resp => {
                vm.translateServices = resp.translateServices;
                vm.loading = false;
            });
        }
        init();
        function closeDialog(){
            $mdDialog.hide({
                success: false
            });
        }
        function addLang(lang){
            const selectedLang = vm.languages.find(x => x.lang_name === lang);
            if(selectedLang){
                const langIndex = vm.selectedLanguages.findIndex(item => item === selectedLang.id_lang);
                if(langIndex != -1){
                    vm.selectedLanguages.splice(langIndex, 1);
                }else{
                    vm.selectedLanguages.push(selectedLang.id_lang);
                }
            }
        }
        function getServiceLangs(serviceName) {
            const availableLangs = vm.languages.map(l => l.lang_name.toUpperCase());
            return (vm.languagesByService[serviceName] || [])
            .filter(code => availableLangs.includes(code.toUpperCase()))
            .map(code => {
                return vm.languages.find(l => l.lang_name.toUpperCase() === code.toUpperCase());
            })
            .sort((a, b) => {
                const sortA = a.sort || 0;
                const sortB = b.sort || 0;

                if (!sortA && !sortB) return 0;
                if (!sortA) return 1; // a va después
                if (!sortB) return -1; // b va después
                return sortA - sortB;
            });
        }
        
        function save(){
            $mdDialog.hide({
                success: true,
                langs: vm.selectedLanguages,
                selectedProvider: vm.selectedProvider
            });
        }
    }
})();
(function () {
    'use strict';
  
    angular.module('app.content')
      .controller('addCaseTextDialog', addCaseTextDialog);
  
    /** @ngInject */
    function addCaseTextDialog($scope, $state, $rootScope, $translate, $mdDialog, sessionService, contentService, elements, requestContext) {
  
      var vm = this;
      vm.translate = function (text) {
        return $translate.instant(text);
      }
      vm.closeDialog = closeDialog;
      vm.viewEditInline = viewEditInline;
      
      function init(){
        var siteID = requestContext.getParam("siteId");
        var section = requestContext.getParam("section");
        $scope.section = section;
        $scope.siteID = siteID;
        newThread();
      }
      init();
      
      /**
        * New thread
        *
        */
      function newThread() {
        vm.selectedContentID = '';
        vm.editInline = false;
        vm.loadingReadPane = true;
        $state.go('app.site_overview.content.list.thread', {
            id: ''
        }, {
            notify: false,
            inherit: true,
            location: true
        });

        var options = {
            site: $scope.siteID,
            section: 'cases'
        };

        contentService.getNew(options).then(function (response) {
          vm.selectedContent = {
            Thumbnail: [],
            tags: [],
            multiple_texts: elements
          };
          vm.currentThread = '';
          vm.log = [];
          for (var i = response.ref.length - 1; i >= 0; i--) {
            if (response.ref[i].type.substr(0, 4) == 'date') {

              var value = moment().utc().format("YYYY-MM-DD HH:mm:00");

              var utcDate = moment.utc(value);

              var siteDate = moment.utc(value).tz(sessionService.site_operative.timezone);

              vm.selectedContent[response.ref[i].titleId] = {};
              vm.selectedContent[response.ref[i].titleId]['value'] = value;
              vm.selectedContent[response.ref[i].titleId]['date'] = new Date(siteDate.format());
              vm.selectedContent[response.ref[i].titleId]['dateShow'] = siteDate.format(vm.dateTimeFormat);
              vm.selectedContent[response.ref[i].titleId]['utcShow'] = utcDate.format(vm.dateTimeFormat);
              vm.selectedContent[response.ref[i].titleId]['utcDate'] = utcDate;
            }
            if (response.ref[i].type == 'status' && response.ref[i].raw_settings != '') {
              try {
                var rawSettings = JSON.parse(response.ref[i].raw_settings);
                vm.selectedContent[response.ref[i].titleId] = rawSettings.defaultValue ? 1 : 0;
              } catch(e) {
                console.error(e.message, response.ref[i].raw_settings)
              }
            }
          }
          vm.selectedContent_ref = response.ref;
          vm.selectedContent_refgrouped = _.groupBy(response.ref, function (m) {
            return m.preview_position;
          });
          vm.loadingReadPane = false;
          vm.viewEditInline();
        });
      }
      
      function viewEditInline() {
        vm.thumbnails_Edit = {};
        vm.editInline = true;
        vm.currentThread_Edit = angular.copy(vm.selectedContent);
        vm.currentThread_ref = angular.copy(vm.selectedContent_ref);
        if (vm.mediaZones) {
          angular.forEach(vm.mediaZones, function (mz) {
            if (angular.isUndefined(vm.thumbnails_Edit[mz.id_zone])) {
              vm.thumbnails_Edit[mz.id_zone] = [];
            }
          });
          angular.forEach(vm.currentThread_Edit.Thumbnail, function (thumb) {
            if (thumb.id_zone > 0) {
              vm.thumbnails_Edit[thumb.id_zone].push(thumb);
            }
          })
        }
        angular.forEach(vm.selectedContent_ref, function (refColumn) {
          switch (refColumn.type) {
            case 'date':
            case 'dateHm':
              var type = 'input';
            break;
            case 'single':
              var type = 'input';
            break;
              default:
            break;
          }
        });
      }
      
      function closeDialog() {
        $mdDialog.hide();
      }
  
    }
  
  })();
(function () {
	'use strict';

	angular
		.module('app.ai', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

		$stateProvider
			.state('app.site_overview.ai', {
				abstract: true,
				url: '/ai'
			})
			.state('app.site_overview.ai.match_profile', {
				url: '/match_profile',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/ai/match-profile.html',
						controller: 'AiController as vm'
					}
				},
				resolve: {
					section: function() {
						return 'match_profile'
					},
				},
			})
			.state('app.site_overview.ai.faces_upload', {
				url: '/faces_upload',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/ai/faces-upload.html',
						controller: 'AiController as vm'
					}
				},
				resolve: {
					section: function() {
						return 'faces_upload'
					},
				},
			});

		$translatePartialLoaderProvider.addPart('app/main/apps/ai');
	}
})();

(function () {
    'use strict';

    angular
        .module('app.ai')
        .controller('SelectEventController', SelectEventController);


    /** @ngInject */
    function SelectEventController($mdDialog, events) {
        var vm = this;

        vm.events = events;
        vm.currentThread = null;

        vm.closeDialog = closeDialog;
        vm.save = save;

        function closeDialog() {
            $mdDialog.cancel();
        }
        function save() {
            $mdDialog.hide(vm.currentThread);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.calendar', [
            'ui.calendar'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.calendar', {
            url      : '/calendar',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/calendar/calendar.html',
                    controller : 'CalendarController as vm'
                }
            },
            bodyClass: 'calendar'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/calendar');

        // Navigation
        msNavigationServiceProvider.saveItem('apps.calendar', {
            title : 'Calendar',
            icon  : 'icon-calendar-today',
            state : 'app.calendar',
            weight: 2
        });
    }
})();
(function ()
{
    'use strict';

    angular.module('app.calendar')
        .controller('EventFormDialogController', EventFormDialogController);

    /** @ngInject */
    function EventFormDialogController($mdDialog, dialogData)
    {
        var vm = this;

        // Data
        vm.dialogData = dialogData;
        vm.notifications = ['15 minutes before', '30 minutes before', '1 hour before'];

        // Methods
        vm.saveEvent = saveEvent;
        vm.closeDialog = closeDialog;

        init();

        //////////

        /**
         * Initialize
         */
        function init()
        {
            vm.dialogTitle = (vm.dialogData.type === 'add' ? 'Add Event' : 'Edit Event');

            // Edit
            if ( vm.dialogData.calendarEvent )
            {
                // Clone the calendarEvent object before doing anything
                // to make sure we are not going to brake the Full Calendar
                vm.calendarEvent = angular.copy(vm.dialogData.calendarEvent);

                // Convert moment.js dates to javascript date object
                if ( moment.isMoment(vm.calendarEvent.start) )
                {
                    vm.calendarEvent.start = vm.calendarEvent.start.toDate();
                }

                if ( moment.isMoment(vm.calendarEvent.end) )
                {
                    vm.calendarEvent.end = vm.calendarEvent.end.toDate();
                }
            }
            // Add
            else
            {
                // Convert moment.js dates to javascript date object
                if ( moment.isMoment(vm.dialogData.start) )
                {
                    vm.dialogData.start = vm.dialogData.start.toDate();
                }

                if ( moment.isMoment(vm.dialogData.end) )
                {
                    vm.dialogData.end = vm.dialogData.end.toDate();
                }

                vm.calendarEvent = {
                    start        : vm.dialogData.start,
                    end          : vm.dialogData.end,
                    notifications: []
                };
            }
        }

        function saveEvent()
        {
            var response = {
                type         : vm.dialogData.type,
                calendarEvent: vm.calendarEvent
            };

            $mdDialog.hide(response);
        }

        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();

(function ()
{
    'use strict';

    angular.module('app.calendar')
        .controller('EventDetailDialogController', EventDetailDialogController);

    /** @ngInject */
    function EventDetailDialogController($mdDialog, calendarEvent, showEventFormDialog, event)
    {
        var vm = this;

        // Data
        vm.calendarEvent = calendarEvent;

        // Methods
        vm.editEvent = editEvent;
        vm.closeDialog = closeDialog;

        //////////

        function closeDialog()
        {
            $mdDialog.hide();
        }

        function editEvent(calendarEvent)
        {
            showEventFormDialog('edit', calendarEvent, false, false, event);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.backend', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.site_overview.backendcontent', {
            url: '/backendcontent',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/backend/backend.html',
                    controller: 'BackendController as vm'
                }
            },
            resolve: {
                Tasks: function (msApi) {
                    return msApi.resolve('backend.tasks@get');
                },
                Tags: function (msApi) {
                    return msApi.resolve('backend.tags@get');
                }
            },
            bodyClass: 'backend'
        })
        $stateProvider.state('app.site_overview.backendcontent.thread', {
            url: '/:id',
            bodyClass: 'backend'
        })
        // .state('app.site_overview.backendcontent.detail', {
        //         url      : '/:section',
        //         views    : {
        //             'content@app': {
        //                 templateUrl: 'app/main/apps/backend/views/section/backend_section.html',
        //                 controller : 'BackendSectionController as vm'
        //             }
        //         },
        //         resolve  : {
        //             // Order   : function (msApi)
        //             // {
        //             //     return msApi.resolve('store.order@get');
        //             // },
        //             // Statuses: function (msApi)
        //             // {
        //             //     return msApi.resolve('store.statuses@get');
        //             // }
        //         },
        //         bodyClass: 'store'
        //     });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/backend');

        // Api
        msApiProvider.register('backend.tasks', ['app/backend/tasks.json']);
        msApiProvider.register('backend.tags', ['app/backend/tags.json']);


    }

})();
(function () {
	'use strict';

	angular
		.module('app.backend')
		.controller('BackendSectionController', BackendSectionController);

	/** @ngInject */
	function BackendSectionController($document, $state, $mdToast, $mdDialog, $mdSidenav, requestContext, BackendService, $scope) {
		var vm = this;


		vm.isLoading = true;
		vm.sectionName = null;
		vm.siteID = null;

		vm.tabs = [
			{ name: 'Preview', field: 'preview', icon: 'icon-eye' },
			{ name: 'Edit', field: 'edit', icon: 'icon-pencil' },
			{ name: 'Media', field: 'media', icon: 'icon-camera' },
			{ name: 'SEO', field: 'seo', icon: 'icon-magnify' },
			{ name: 'Activity', field: 'activity', icon: 'icon-chart-histogram' },
			{ name: 'Web preview', field: 'web_preview', icon: 'icon-web' }
		];

		// Methods
		vm.gotoSections = gotoSections;
		vm.openFieldDialog = openFieldDialog;
		vm.saveSectionSettings = saveSectionSettings;
		vm.populateRef = populateRef;
		vm.undoChangesSection = undoChangesSection;


		//////////
		refresh();
		init();

		function refresh() {
			vm.section = {
				section: null,
				name: null,
				ref: null,
				reference_sections: null,
			};

			vm.sectionBackup = {
				section: null,
				name: null,
				ref: null,
				reference_sections: null
			};
		}

		function init() {

			vm.section.name = requestContext.getParam("section");
			vm.siteID = requestContext.getParam("siteId");

			BackendService.getSection({
				section: vm.section.name,
				site: vm.siteID
			})
				.then(function (response) {
					vm.section.ref = (response.ref.length == 0) ? null : angular.copy(response.ref);
					vm.section.reference_sections = (response.reference_sections.length == 0) ? null : angular.copy(response.reference_sections);
					vm.section.section = (response.section.length == 0) ? null : angular.copy(response.section);
					vm.isLoading = false;

					angular.copy(vm.section, vm.sectionBackup);
				});
		}

		/**
		 * Go to sections page
		 */
		function gotoSections() {
			$state.go('app.site_overview.backendcontent');
		}

		/**
		 * Open new field dialog
		 *
		 * @param ev
		 * @param task
		 */
		function openFieldDialog(ev, task) {
			$mdDialog.show({
				controller: 'TaskDialogController',
				controllerAs: 'vm',
				templateUrl: 'app/main/apps/backend/dialogs/task/task-dialog.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: true,
				locals: {
					Field: task,
					Fields: vm.tasks,
					event: ev
				}
			});
		}

		function saveSectionSettings(form) {

			var options = {
				section: vm.section.name,
				site: vm.siteID,
				data: vm.section.section
			};

			BackendService.saveSectionSettings(options)
				.then(
					function (response) {
						// vm.viewPreview();
						// vm.openThread(mail);
						var message = "Saved";

						$mdToast.show({
							template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
							hideDelay: 5000,
							position: 'top',
							parent: '#content-container'
						});
						form.$setPristine();
						// refresh();
						// init();
						return true;
					});

		}

		function populateRef() {


			var options = {
				section: vm.section.name,
				site: vm.siteID,
				data: vm.section.section
			};

			BackendService.populateRef(options)
				.then(
					function (response) {
						// vm.viewPreview();
						// vm.openThread(mail);
						var message = "Success!";

						$mdToast.show({
							template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
							hideDelay: 7000,
							position: 'bottom right',
							parent: '#content'
						});

						return true;
					});

		}

		function undoChangesSection(form) {
			angular.copy(vm.sectionBackup, vm.section);
		}
	}
})();

(function () {
    'use strict';

    angular
        .module('app.backend')
        .controller('TaskDialogController', TaskDialogController);

    /** @ngInject */
    function TaskDialogController($mdDialog, Field, Fields, section, event, backendService, requestContext, $scope) {
        var vm = this;

        // Data
        vm.title = 'Edit Field';
        vm.field = angular.copy(Field);
        vm.fields = Fields;
        vm.section = section;
        vm.newTask = false;



        vm.categories = [{
            "name": "Input",
            "value": "input"
        },
        {
            "name": "id subsec",
            "value": "id_subsec"
        }]
        vm.typeOrder = [{
            "name": "ASC",
            "value": "ASC"
        },
        {
            "name": "DESC",
            "value": "DESC"
        }]

        vm.types = [
            {
                "name": "On-Off",
                "value": "onoff"
            },
            {
                "name": "Date",
                "value": "date"
            },
            {
                "name": "Date Hm",
                "value": "dateHm"
            },
            {
                "name": "Text",
                "value": "text"
            },
            {
                "name": "Single",
                "value": "single"
            },
            {
                "name": "Status",
                "value": "status"
            },
            {
                "name": "ID",
                "value": "id"
            },
            {
                "name": "HTML",
                "value": "html"
            },
            {
                "name": "Subsection",
                "value": "id_subsec"
            },
            {
                "name": "Category",
                "value": "id_cat"
            },
            {
                "name": "Subcategory",
                "value": "id_subcat"
            },
            {
                "name": "Media by zone",
                "value": "zone"
            }
        ];
        vm.statusesListPosition = [
            {
                "id": 0,
                "name": "--",
                "value": null,
                "color": "md-purple-500-bg"
            },
            {
                "id": 1,
                "name": "main",
                "value": "main",
                "color": "md-blue-500-bg"
            },
            {
                "id": 2,
                "name": "secondary",
                "value": "secondary",
                "color": "md-green-500-bg"
            },
            {
                "id": 3,
                "name": "left_center",
                "value": "left_center",
                "color": "md-orange-500-bg"
            },
            {
                "id": 4,
                "name": "right_center",
                "value": "right_center",
                "color": "md-purple-500-bg"
            }
        ];

        // Methods
        vm.addNewTask = addNewTask;
        vm.saveTask = saveTask;
        vm.deleteTask = deleteTask;
        vm.newTag = newTag;
        vm.toFieldDTO = toFieldDTO;
        vm.closeDialog = closeDialog;
        vm.onSelectSection = onSelectSection;
        vm.init = init;


        init();





        function init() {
            var siteID = requestContext.getParam("siteId");
            $scope.siteID = siteID;
            var section = requestContext.getParam("section");
            $scope.section = section;


            if (!vm.field) {
                vm.field = {};
                vm.title = 'New Field';
                vm.newTask = true;
                vm.field.tags = [];
            }


            backendService.getSection({
                site: $scope.siteID
            }).then(function (response) {
                console.log(response);
                vm.sections = response.sections;
            });
            if (!vm.field.raw_settings) {
                vm.field.raw_settings = {};
            } else {
                vm.field.raw_settings = JSON.parse(vm.field.raw_settings);
                if (vm.field.raw_settings.fromSection) {
                    vm.onSelectSection(vm.field.raw_settings.fromSection);
                }
            }
        }

        function onSelectSection(section) {
            backendService.getSection({
                section: section,
                site: $scope.siteID
            }).then(function (response) {
                vm.selectedSection = response.section;
                if (!vm.field.raw_settings.orderSort) {
                    vm.field.raw_settings.orderSort = 'ASC';
                }
                // Remove duplicates..
                response.ref = response.ref.filter((refItem, index, self) =>
                    index === self.findIndex((t) => (
                        t.field_name === refItem.field_name
                    ))
                )
                vm.selectedSectionFields = response.ref;
            });
        }

        //////////

        /**
         * Add new task
         */
        function addNewTask() {
            var options = {
                domain: $scope.siteID,
                section: vm.section,
                id: vm.field.id_ref,
            };
            vm.field = vm.toFieldDTO(vm.field);
            options.data = vm.field;
            backendService.createSectionsRef(options).then(function (response) {
                console.log(response);
                vm.fields.push(response)
                for (var i = 0; i < vm.fields.length; i++) {
                    if (vm.fields[i].id_ref === response.id_ref) {
                        vm.fields[i] = angular.copy(response);
                        break;
                    }
                }
            });

            closeDialog();
        }

        /**
         * Save task
         */
        function saveTask() {
            var options = {
                domain: $scope.siteID,
                section: vm.section,
                id: vm.field.id_ref,
            };
            vm.field = vm.toFieldDTO(vm.field);
            options.data = vm.field;
            backendService.saveSectionsRef(options).then(function (response) {
                for (var i = 0; i < vm.fields.length; i++) {
                    if (vm.fields[i].id_ref === response.id_ref) {
                        vm.fields[i] = angular.copy(response);
                        break;
                    }
                }
            });

            closeDialog();
        }


        /**
 * Delete task
 */
        function deleteTask() {
            var confirm = $mdDialog.confirm()
                .title('Are you sure?')
                .content('The Task will be deleted.')
                .ariaLabel('Delete Task')
                .ok('Delete')
                .cancel('Cancel')
                .targetEvent(event);

            $mdDialog.show(confirm).then(function () {
                // Dummy delete action
                var options = {
                    domain: $scope.siteID,
                    section: vm.section,
                    id: vm.field.id_ref,
                };
                backendService.deleteSectionRef(options).then(function (response) {
                    for (var i = 0; i < vm.fields.length; i++) {
                        if (vm.fields[i].id_ref === options.id) {
                            vm.fields.splice(i, 1);
                            break;
                        }
                    }
                });

                closeDialog();
            }, function () {
                // Cancel Action
            });
        }


        function toFieldDTO(field) {
            return {
                "category": field.category ? field.category : '',
                "field_name": field.field_name ? field.field_name : '',
                "title": field.title ? field.title : '',
                "type": field.type ? field.type : '',
                "showtype": field.showtype ? field.showtype : null,
                "mandatory": field.mandatory ? field.mandatory : null,
                "sort": field.sort ? field.sort : null,
                "primary": field.primary ? field.primary : null,
                "hide": field.hide ? field.hide : null,
                "description": field.description ? field.description : '',
                "date_format": field.date_format ? field.date_format : null,
                "list_position": field.list_position ? field.list_position : null,
                "list_sort": field.list_sort ? field.list_sort : null,
                "list_editable": field.list_editable ? field.list_editable : null,
                "preview_position": field.preview_position ? field.preview_position : null,
                "preview_sort": field.preview_sort ? field.preview_sort : null,
                "preview_editable": field.preview_editable ? field.preview_editable : null,
                "edit_position": field.edit_position ? field.edit_position : null,
                "edit_sort": field.edit_sort ? field.edit_sort : null,
                "edit_editable": field.edit_editable ? field.edit_editable : null,
                "lang_ref": field.lang_ref ? field.lang_ref : null,
                "lang_ref_description": field.lang_ref_description ? field.lang_ref_description : null,
                "options_tooltip": field.options_tooltip ? field.options_tooltip : null,
                "filterable": field.filterable ? field.filterable : 0,
                "sortable": field.sortable ? field.sortable : 0,
                "searchable": field.searchable ? field.searchable : 0,
                "sortable_default": field.sortable_default ? field.sortable_default : 0,
                "id_cropformats": field.id_cropformats ? field.id_cropformats : null,
                "id_zone": field.id_zone ? field.id_zone : null,
                "raw_settings": field.raw_settings ? JSON.stringify(field.raw_settings) : '',
                "searchable_web": field.searchable_web ? field.searchable_web : 0,
                "searchable_web_field_name": field.searchable_web_field_name ? field.searchable_web_field_name : '',
                "searchable_web_field_value": field.searchable_web_field_value ? field.searchable_web_field_value : '',
                "searchable_web_weight": field.searchable_web_weight ? field.searchable_web_weight : 0,
                "searchable_lang": field.searchable_lang ? field.searchable_lang : '',
            }
        }

        /**
         * New tag
         *
         * @param chip
         * @returns {{label: *, color: string}}
         */
        function newTag(chip) {
            var tagColors = ['#388E3C', '#F44336', '#FF9800', '#0091EA', '#9C27B0'];

            return {
                name: chip,
                label: chip,
                color: tagColors[Math.floor(Math.random() * (tagColors.length))]
            };
        }

        /**
         * Close dialog
         */
        function closeDialog() {
            $mdDialog.hide();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.accounts', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

        $stateProvider.state('app.accounts', {
            url: '/accounts',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/accounts/accounts.html',
                    controller: 'AccountsController as vm'
                }
            },
            bodyClass: 'content'
        });

        $stateProvider
            .state('app.site_overview.accounts', {
                abstract: true,
                url: '/accounts',
                onEnter: function ($stateParams) {
                },
                data: {
                    displayName: '{{section}}'
                },
                resolve: {
                    section: function ($stateParams) {
                        return $stateParams.section
                    },
                },


            })
            .state('app.site_overview.accounts.list', {
                url: '/list',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/accounts/accounts.html',
                        controller: 'AccountsController as vm'
                    }
                },
                onEnter: function () {
                },
                data: {
                    displayName: 'List {{section}}'
                },
                resolve: {},
            })
            .state('app.site_overview.accounts.list.thread', {
                url: '/:id',
                bodyClass: 'content'
            })
            .state('app.site_overview.accounts.activities', {
                url: '/activities',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/accounts/activities.html',
                        controller: 'AccountsController as vm'
                    }
                },
                onEnter: function () {
                },
                data: {
                    displayName: 'List {{section}}'
                },
                resolve: {},
            })

        $translatePartialLoaderProvider.addPart('app/main/apps/accounts');

    }
})();

(function () {
    'use strict';

    angular
        .module('app.accounts')
        .controller('TabsSelectController', TabsSelectController);

    function TabsSelectController($mdDialog, $document, userTabs, nestedTabs, virtualGroup, $mdToast, $scope, $translate, ivhTreeviewMgr, ivhTreeviewBfs) {

        var vm = this;
        vm.tabSearch = '';
        vm.virtualGroup = angular.copy(virtualGroup);
        vm.nestedTabs = angular.copy(nestedTabs);
        vm.userTabs = angular.copy(userTabs);
        vm.searchTabText = '';
        vm.nodesToSelect = [];
        vm.closeDialog  = closeDialog;

        function closeDialog() {
            $mdDialog.hide(vm.userTabs);
        }

        ivhTreeviewBfs(vm.nestedTabs, function (node) {
            angular.forEach(vm.userTabs, function (tab) {
                if (tab.id_virtualgroup == vm.virtualGroup.id_virtualgroup) {
                    if (node.id_tab == tab.id_tab && node.id_section == tab.id_section) {
                        vm.nodesToSelect.push(node);
                    }
                }
            })
        })


        ivhTreeviewMgr.selectEach(vm.nestedTabs, vm.nodesToSelect);

        vm.saveTabs = saveTabs;

        function saveTabs() {
            var newTab = {};
            var newTabs = [];
            var nextSort = 0;
            var tabExists = true;
            var nodesToCheck = [];

            angular.forEach(vm.userTabs, function (tab) {
                if (tab.id_virtualgroup != vm.virtualGroup.id_virtualgroup) {
                    newTabs.push(tab);
                }
            })

            ivhTreeviewBfs(vm.nestedTabs, function (node) {
                if (node.selected && node.id_tab) {
                    nodesToCheck.push(node);
                }
            })

            angular.forEach(vm.userTabs, function (tab) {
                if (tab.id_virtualgroup == vm.virtualGroup.id_virtualgroup) {
                    tabExists   = false;
                    angular.forEach(nodesToCheck, function (node) {
                        if (node.id_tab == tab.id_tab && node.id_section == tab.id_section) {
                            tabExists   = true;
                        }
                    })
                    if (tabExists) {
                        nextSort++;
                        newTab = {
                            id_user_tab: tab.id_user_tab,
                            id_virtualgroup: vm.virtualGroup.id_virtualgroup,
                            id_tab: tab.id_tab,
                            id_section: tab.id_section,
                            sort: tab.sort,
                        };
                        newTabs.push(newTab);
                    }
                }
            })

            angular.forEach(nodesToCheck, function (node) {
                tabExists   = false;
                angular.forEach(vm.userTabs, function (tab) {
                    if (tab.id_virtualgroup == vm.virtualGroup.id_virtualgroup && (node.id_tab == tab.id_tab && node.id_section == tab.id_section)) {
                        tabExists   = true;
                    }
                })
                if (!tabExists) {
                    nextSort++;
                    newTab = {
                        id_user_tab: '',
                        id_virtualgroup: vm.virtualGroup.id_virtualgroup,
                        id_tab: node.id_tab,
                        id_section: node.id_section,
                        sort: nextSort,
                    };
                    newTabs.push(newTab);

                }
            })

            vm.userTabs = newTabs;
            vm.closeDialog();
        }

    }
})
();

(function () {
    'use strict';

    angular
        .module('app.accounts')
        .controller('EditPermissionController', EditPermissionController);

    function EditPermissionController($mdDialog, requestContext, accountsService, tab) {

        var vm = this;
        vm.tab = tab;
        vm.valid = true;
        vm.siteID = requestContext.getParam("siteId");

        vm.permissionsJSON = JSON.parse(vm.tab.restrictions_json);

        vm.closeDialog = closeDialog;
        vm.saveTab = saveTab;
        vm.setValid = setValid;

        function closeDialog(tab) {
            $mdDialog.hide(tab);
        }



        function saveTab() {
            var options = {
                siteID: vm.siteID,
                item: {
                    id_user_tab: vm.tab.id_user_tab,
                    restrictions: JSON.parse(document.getElementById("text-area-json-edit").value)
                }
            };

            vm.tab.restrictions_json = JSON.stringify(options.item.restrictions);
            vm.closeDialog(options);
        }



        function setValid() {
            try {
                JSON.parse(document.getElementById("text-area-json-edit").value);
                vm.valid = true;
            } catch (error) {
                vm.valid = false;
            }
        }



    }
})
    ();

(function () {
    'use strict';

    angular
        .module('app.accounts')
        .controller('CopyPermissionController', CopyPermissionController);

    function CopyPermissionController($mdDialog, requestContext, sessionService, accountsService, $translate, threads, account) {

        var vm = this;
        vm.account = account;
        vm.threads = threads;
        vm.valid = true;
        vm.siteID = requestContext.getParam("siteId");


        vm.closeDialog = closeDialog;
        vm.saveRestrictions = saveRestrictions;

        function closeDialog() {
            $mdDialog.hide();
        }



        function saveRestrictions(thread) {
            console.log(sessionService.user)
            var confirm = $mdDialog.confirm()
                .multiple(true)
                .title($translate.instant('ACCOUNTS.ARE_YOU_SURE_TO_REPLACE_PERMISSIONS'))
                .targetEvent(event)
                .ok($translate.instant('ACCOUNTS.OK'))
                .cancel($translate.instant('ACCOUNTS.CANCEL'));


            $mdDialog.show(confirm).then(function (res) {
                var options = {
                    siteID: vm.siteID,
                    item: {
                        "id_user_from": thread.id_user,
                        "id_user_to": vm.account.id_user,
                        "id_domain": sessionService.user.domains_list.find(x => x.subdomain == vm.siteID).id_domain
                    }
                }
                accountsService.copyUserTabs(options).then(function (response) {
                    console.log(response);
                    $mdDialog.hide(true);
                });
            });
        }

    }
})
    ();

(function () {
    'use strict';

    angular
        .module('app.content')
        .controller('QiuGroupsEditGroupDialogController', EditGroupDialogController)
        //.directive('qiuOnClickSelectParentGroup', ['usersService', SelectParentGroup])  
        ;

    /** @ngInject */
    function EditGroupDialogController($scope, $mdDialog, group, siteID, nestedGroups, $mdToast, $translate) {

        var vm = this;

        vm.group = group;
        vm.groupName = group.name;
        vm.groupParentId = null;
        vm.groupParentName = '';
        vm.groupTypeId = group.id_group_type;
        vm.isQiuRestricted = false;

        vm.translate = function (text) {
            return $translate.instant(text);
        }

        vm.selectParentGroupRoot = selectParentGroupRoot;

        if (angular.isArray(nestedGroups) &&
            nestedGroups.length > 0 &&
            nestedGroups[0].is_qiu_restricted_root
        ) {
            vm.isQiuRestricted = true;
            vm.groupParentName = nestedGroups[0].name;
            vm.groupParentId = nestedGroups[0].id_group;
        }

        vm.groups = removeGroupFromNestedGroups(group, nestedGroups);
        var unnestedGroups = getUnnestedGroups(nestedGroups, []);
        angular.forEach(unnestedGroups, function (obj) {
            if (obj.id_group == group.parent) {
                vm.groupParentName = obj.name;
                vm.groupParentId = obj.id_group;
            }
        });

        $scope.hide = function () {
            $mdDialog.hide();
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };


        $scope.delete = function (group) {
            $mdDialog.hide({action:'delete', group: group});
        };

        $scope.save = function (group) {
            var response = {
                action: angular.equals({}, group) ? 'create' : 'edit',
                group: group,
                groupName: vm.groupName,
                groupParentId: vm.groupParentId
            }
            $mdDialog.hide(response);
        };

        $scope.$on('selectParentGroup', function (event, parentGroup) {
            vm.groupParentId = parentGroup.id_group;
            vm.groupParentName = parentGroup.name;
        });


        function selectParentGroupRoot() {
            vm.groupParentName = $translate.instant('GROUP.ROOT');
            vm.groupParentId = null;
        }

        function getUnnestedGroups(groups, result) {
            angular.forEach(groups, function (group) {
                if (group.id_group) {
                    result.push(group);
                    if (typeof group.children !== 'undefined' && group.children.length > 0) {
                        getUnnestedGroups(group.children, result);
                    }
                }
            });
            return result;
        }

        function removeGroupFromNestedGroups(group, groups) {
            angular.forEach(groups, function (obj) {
                if (group.id_group == obj.id_group) {
                    var index = groups.indexOf(obj);
                    groups.splice(index, 1);
                }
                if (typeof obj.children !== 'undefined' && obj.children.length > 0) {
                    removeGroupFromNestedGroups(group, obj.children);
                }
            });
            return groups;
        }
    }

/*
    function SelectParentGroup(usersService) {

        function unselectAllGroups() {
            var elemList = document.querySelectorAll('.select-parent-group-row');
            elemList.forEach(function (elem) {
                elem.classList.remove('selected');
            });
        }

        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                $(element).on('click', function (e) {
                    var groupNode = false;
                    if (element.parent().hasClass('selected')) {
                        unselectAllGroups();
                    } else {
                        unselectAllGroups();
                        element.parent().addClass('selected');
                        groupNode = scope.node;
                    }
                    usersService.triggerSelectParentGroup(groupNode);
                });
            }
        };
    }
*/
})();

(function ()
{
    'use strict';

    angular
        .module('app.users')
        .controller('AddSelectedItemsToGroupsDialogController', AddSelectedItemsToGroupsDialogController)
        .directive('addSelectedItemsToGroupOnCheckToggleAssignedGroup', AddSelectedItemsToGroupOnCheckToggleAssignedGroup)
        ;

    /** @ngInject */
    function AddSelectedItemsToGroupsDialogController(
        $scope,
        $mdDialog,
        groups,
        selectedItems,
        siteID,
        id_field,
        $translate,
        $mdToast
    ) {

        var vm = this;

        //Data
        vm.viewGroup = 'app/core/directives/qiu-groups/dialogs/add-selected-items-to-groups/tree-view.html';
        vm.loading = false;

        // Methods
        vm.closeDialog = closeDialog;
        vm.save = save;

        init();

        function init() {
            vm.groups = groups;
            vm.selectedItems = selectedItems;
        }

        function closeDialog() {
            uncheckAllGroups(vm.groups);
            $mdDialog.hide();
        }

        function save() {
            vm.loading = true;
            var groups = getSelectedGroups(vm.groups, []);
            if (groups.length < 1) {
                    vm.loading = false;
                    var message = $translate.instant('QIU_GROUPS.NO_GROUP_SELECTED');
                    $mdToast.show({
                        template: '<md-toast id="language-message"><span class="md-toast-text" flex>' + message + '</span><md-button ng-click="closeToast()">X</md-button></md-toast>',
                        hideDelay: 7000,
                        position: 'top right',
                        parent: '#main'
                    });
                    return false;
            }

            var selectedItemIds = [];
            angular.forEach(selectedItems, function(selectedItem){
                selectedItemIds.push(selectedItem[id_field]);
            });
            uncheckAllGroups(vm.groups);

            $mdDialog.hide({'itemIds': selectedItemIds, 'groups': groups});
        }


        function getSelectedGroups(groups, result) {
          angular.forEach(groups, function(group) {
            if(angular.isDefined(group.checked) && group.checked == true) {
              result.push(group);
            }
            if (typeof group.children !== 'undefined' && group.children.length >0) {
              getSelectedGroups(group.children, result);
            }
          });
          return result;
        }
        function uncheckAllGroups(groups) {
            angular.forEach(groups, function(group) {
                if(angular.isDefined(group.checked) && group.checked == true) {
                  group.checked = false; // clean up for next session.
                }
                if (typeof group.children !== 'undefined' && group.children.length >0) {
                  uncheckAllGroups(group.children);
                }
              });
            return
        }

    }

    function AddSelectedItemsToGroupOnCheckToggleAssignedGroup() {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                $(element).on('click', function (e) {
                    if (!scope.node.checked) {
                        scope.node.checked = true;
                    } else {
                        scope.node.checked = !scope.node.checked;
                    }
                });
            }
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('app.users')
        .factory("transformUsers", transformUsers);



    /** @ngInject */
    function transformUsers(mediaService, $filter) {

        var service = {
            getImageById: getImageById,
            userToDTO: userToDTO,
            DtoToUser: DtoToUser,
            formatNestedGroups: formatNestedGroups,
            initGroupsTree: initGroupsTree,
            getLabels: getLabels,
            getGroupsFromLabels: getGroupsFromLabels,
            updateThreadGroups: updateThreadGroups,
            colorizeGroupByType: colorizeGroupByType
        };

        function DtoToUser(user, siteID) {
            if (user.avatar)
                getImageById(user, siteID);

            if (user.groups) {
                var groupIds = [];
                for (var i = 0; i < user.groups.length; i++) {
                    groupIds.push(user.groups[i].id_group);
                }
                user.groupIds = groupIds;
            }
        }

        function userToDTO(user) {
            if (user.id_user !== '' && user.id_user !== undefined) {
                user.created_at = JSON.stringify(user.created_at);
                user.last_login = JSON.stringify(user.last_login);
                if(user.avatar && user.avatar.id_media){
                    user.avatar = user.avatar.id_media;
                }else if(user.avatar && user.avatar.url){
                    user.avatar = user.avatar.url;
                }
                return user;
            } else {
                delete user.created_at;
                delete user.last_login;
                if (user.avatar !== undefined) {
                    if(user.avatar.id_media){
                        user.avatar = user.avatar.id_media;
                    }else if(user.avatar.url){
                        user.avatar = user.avatar.url;
                    }
                } else {
                    delete user.avatar;
                }
                return user;
            }
        }

        function getImageById(user, siteID) {
            var options = {
                domain: siteID,
                id_media: user.avatar
            };
            mediaService.getImageByID(options)
                .then(function (response) {
                    user.avatar = response.data[0];
                });
        }

        function formatNestedGroups(groups, qiuRestrictions, isRootCycle, parentLabel) {
            if (groups) {
                for (var i = 0; i < groups.length; i++) {
                    var group = groups[i];
                    // 'name' is used as display name on group tree, while 'label' is used for group SEARCH only.
                    // To keep showing children of search result, we concatenate parent group(s) names with current group name into label.
                    group.label = parentLabel ?  parentLabel + '_' + group.name : group.name;
                    group.is_qiu_restricted = isGroupQiuRestricted(group.id_group, qiuRestrictions);
                    group.is_qiu_restricted_root = isRootCycle && group.is_qiu_restricted;
                    group.color = getGroupColor(group);
                    if (group.children) {
                        formatNestedGroups(group.children, qiuRestrictions, false, group.label);
                    }
                }
                return groups;
            }
            return [];
        }


        function colorizeGroupByType(group, groupTypes) {
            var groupType = groupTypes.find(function(type) {
                return type.id_group_type == group.id_group_type;
            })
            if (groupType) {
                group.group_type = groupType;
                group.color = getGroupColor(group);
                delete group.group_type;
            }
        }

        function getGroupColor(group) {
            if (group.color !== null) return group.color;
            if (group.hasOwnProperty('group_type') &&
                group.group_type !== null &&
                group.group_type.hasOwnProperty('color') &&
                group.group_type.color !== null) {
                return group.group_type.color
            }
            return 'orange-300';
        }

        function isGroupQiuRestricted(groupId, qiuRestrictions) {
            return (qiuRestrictions
                &&
                    (qiuRestrictions.hasOwnProperty('id_group') &&
                        Object.values(qiuRestrictions.id_group).indexOf(groupId) > -1
                    ||
                    qiuRestrictions.hasOwnProperty('groups_sub') &&
                        Object.values(qiuRestrictions.groups_sub).indexOf(groupId) > -1)
            )
        }

        /**
         * Initializes group tree selector
         *
         * Loads array of available ingroup status into each tree branch for status selection
         * Loads group assignment and ingroup status from corresponding thread group into each tree branch (if any)
         * 
         * @param  {list} treeGroups          Nested list of groups
         * @param  {list} threadGroups        Groups of selected thread
         * @param  {array} usersIngroupStatus Contains in-group status values used as options in status dropdown selector
         * @return {list}                     Nested list of groups with initial values
         */
        function initGroupsTree(treeGroups, threadGroups, usersIngroupStatus) {
            if (treeGroups) {
                treeGroups = formatNestedGroups(treeGroups);
                for (var k = treeGroups.length - 1; k >= 0; k--) {
                    treeGroups[k].ingroup_status = $filter('filter')(usersIngroupStatus, { id_group_type: treeGroups[k].id_group_type });
                    if (threadGroups) {
                        for (var i = threadGroups.length - 1; i >= 0; i--) {
                            if (treeGroups[k].id_group == threadGroups[i].id_group) {
                                treeGroups[k].assigned_group = true;
                                if (angular.isDefined(threadGroups[i].users_ingroup.id_ingroup_status)) {
                                    treeGroups[k].id_ingroup_status = threadGroups[i].users_ingroup.id_ingroup_status;
                                } else {
                                    treeGroups[k].id_ingroup_status = null;
                                }
                            }
                        }
                    }
                    if (treeGroups[k].children) {
                        initGroupsTree(treeGroups[k].children, threadGroups, usersIngroupStatus);
                    }
                }
                return treeGroups;
            }
        }

        function getLabels(treeGroups, result) {
            if (treeGroups) {
                for (var i = 0; i < treeGroups.length; i++) {
                    if (treeGroups[i].assigned_group === true) {
                        result.push({ label: treeGroups[i].label, group: treeGroups[i] });
                    }
                    if (treeGroups[i].children) {
                        getLabels(treeGroups[i].children, result);
                    }
                }
            }
            return result;
        }

        function getGroupsFromLabels(array) {
            var groups = [];
            for (var i = 0; i < array.length; i++) {
                groups.push(array[i].group);
            }
            return groups;
        }

        /**
         * updateThreadGroups
         *
         * updates list of thread groups by comparing groups from group tree selector
         * 
         * @param  {list}  treeGroups        Nested list of groups from group tree selector used for comparison
         * @param  {list}  threadGroups      List of thread groups to be updated
         * @param  {id}    idUser            Id from current thread
         * @param  {array} assignedGroupIds  Empty array filled over children iteartion with ids of assigned groups, used for final unassigned thread groups removal.
         */
        function updateThreadGroups(treeGroups, threadGroups, idUser, assignedGroupIds) {

            if (angular.isUndefined(threadGroups)) {
                threadGroups = [];
            }
            angular.forEach(treeGroups, function (treeGroup) {
                if (treeGroup.assigned_group == true) {
                    assignedGroupIds.push(treeGroup.id_group);
                    var isThreadGroup = false;
                    angular.forEach(threadGroups, function (threadGroup) {
                        if (threadGroup.id_group == treeGroup.id_group) {
                            isThreadGroup = true;
                            // update users_ingroup settings from thread group
                            threadGroup.users_ingroup = {
                                id_user: idUser,
                                id_group: treeGroup.id_group,
                                id_ingroup_status: treeGroup.id_ingroup_status || null
                            };
                        }
                    });
                    // add new thread group
                    if (!isThreadGroup) {
                        var newGroup = {
                            id_group: treeGroup.id_group,
                            parent: treeGroup.parent,
                            name: treeGroup.name,
                            id_group_type: treeGroup.id_group_type,
                            sort: treeGroup.sort,
                            users_ingroup: {
                                id_user: idUser,
                                id_group: treeGroup.id_group,
                                id_ingroup_status: treeGroup.id_ingroup_status || null
                            }
                        }
                        threadGroups.push(newGroup);
                    }
                }
                if (typeof treeGroup.children !== 'undefined' && treeGroup.children.length > 0) {
                    updateThreadGroups(treeGroup.children, threadGroups, idUser, assignedGroupIds);
                }
            })
            removeUnassignedThreadGroups(threadGroups, assignedGroupIds);
        }

        function removeUnassignedThreadGroups(threadGroups, assignedGroupIds) {
            for (var i = threadGroups.length - 1; i >= 0; i--) {
                if (assignedGroupIds.indexOf(threadGroups[i].id_group) === -1) {
                    threadGroups.splice(i, 1);
                }
            }
        }

        return service;
    }
})();



(function () {
    'use strict';

    angular.module('app.users')
        .controller('UsersBlackListedController', UsersBlackListedController)
        
        


    /** @ngInject */
    function UsersBlackListedController($scope, $rootScope, $document, $mdDialog, $mdMedia, $mdToast, $mdSidenav,
        $state, msApi, requestContext, $timeout, usersBlacklistService, contentService, msUtils, settingUserService,
        $anchorScroll, $translate, mailingService, sessionService, tinyMceService, sharedFunctionsMailing,
        transformUsers, ivhTreeviewMgr, $filter, $window, $q, $stateParams, formsService, $http) {
            
        
        var vm = this;
        vm.getSettingValue = settingUserService.getSettingValue;
        // vm.settingsSection = 'users-' + $stateParams.groupTypeName;
        vm.settingsSection = 'users-blacklist';
        vm.fieldOrder = vm.getSettingValue(vm.settingsSection, 'sortField', null);
        // vm.groupBy = vm.getSettingValue(vm.settingsSection, 'groupByField', undefined);
        
        $scope.validSelection = true;
        vm.page = 1;
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg', 'red-bg', 'yellow-bg', 'light-blue-bg'];
        vm.selectedColor = vm.colors[Math.floor(Math.random() * vm.colors.length)];
        $rootScope.pagination_groupIds = false;
        $rootScope.pagination_ingroupStatus = false;
        vm.includeAllGroups = false;
        vm.folders = [];
        vm.labels = [];
        vm.nextPageLog = 1;
        vm.enterfirst = true;
        vm.users = null;
        vm.searchUserText = null;
        vm.selectedUser = null;
        vm.createFilterFor = createFilterFor;
        vm.CleanUsersGroups = undefined;
        vm.eventsGroup = undefined;
        vm.currentLabelsEdit = undefined;
        vm.userGroupTypes = undefined;
        vm.currentTab = 'mailing';
        vm.countriesWithStates = undefined;
        vm.statesWithCities = undefined;
        vm.timeAgo = msUtils.timeAgo;
        vm.loginUrl = sessionService.site_operative.websiteLoginUrl;
        vm.userInvitationUrlPreview = sessionService.site_operative.userInvitationUrlPreview;
        vm.userInvitationUrlIndividual = sessionService.site_operative.userInvitationUrlIndividual;
        vm.userInvitationUrlMultiple = sessionService.site_operative.userInvitationUrlMultiple;
        vm.userCustomActions = sessionService.site_operative.userCustomActions;

        vm.scrollEl = angular.element('#thread-list')[0];

        vm.currentFilter = {
            type: $state.params.type,
            filter: $state.params.filter
        };
        vm.currentThread = null;
        vm.currentThread_Edit = null;
        vm.thumbnails_Edit = {};
        vm.selectedThreads = [];
        vm.selectedGroups = [];
        vm.selectedGroup = false;
        vm.basicForm = {};
        vm.treeSearch = '';
        vm.hideAcc = hideAcc

        vm.labelQuerySearch = labelQuerySearch;
        vm.filterActiveTypes = filterActiveTypes;
        vm.getGroupIcon = getGroupIcon;

        // vm.views = {
        // 	classic: 'app/main/apps/content/views/classic/classic-view.html',
        // 	outlook: 'app/main/apps/content/views/outlook/outlook-view.html'
        // };
        // vm.defaultView = 'outlook';
        // vm.currentView = 'outlook';

        vm.mediaZones = [];
        vm.usersGroups = undefined;
        vm.currentLabelsFilter = undefined;
        vm.ingroupStatus = [];
        vm.currentGroupTypeId = parseInt($stateParams.groupTypeId);
        vm.isAccreditations = vm.currentGroupTypeId === 6;
        if (vm.isAccreditations) {
            vm.pleaseSelectGroup = true;
        }
        $scope.isLoadingGroups = true;
        $scope.loadGroup = false;
        vm.includeSubgroups = false;
        vm.conversationMessage = {};
        vm.isQiuRestricted = false;
        vm.hasAdvancedSettingsAccess = false;

        vm.sortFieldUsersGroup = 'name';
        vm.sortDirUsersGroup = 'ASC';
        vm.orderByUsersGroup = {
          "USERS.NAME": "name",
          "USERS.UPDATED_AT": "updated_at",
          "USERS.ID": "id_group",
          "USERS.SORT": "sort"
        };

        vm.sendConversationMessage = sendConversationMessage;
        vm.deleteConversationMessage = deleteConversationMessage;

        // Methods
        vm.init = init;
        vm.$mdMedia = $mdMedia;
        vm.getInArray = msUtils.getInArray;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.toggleInGroup = msUtils.toggleInGroup;
        vm.getReferencesSections = contentService.getReferencesSections;
        vm.getExtension = msUtils.getExtension;
        vm.getExtensionIcon = msUtils.getExtensionIcon;
        vm.getValuesReferencesSections = contentService.getValuesReferencesSections;
        vm.updateModelShowGroupsAsField = updateModelShowGroupsAsField;

        vm.isShowingLabelGroup = isShowingLabelGroup;
        vm.isShowingLabelGroupTab = isShowingLabelGroupTab;
        vm.isTrueFalseChecked = isTrueFalseChecked;
        vm.toggleTrueFalseCheck = toggleTrueFalseCheck;
        vm.selectOrUnselect = selectOrUnselect;
        vm.showStatus = showStatus;

        // vm.loadFolder = loadFolder;
        // vm.loadLabel = loadLabel;
        vm.loadUsersByGroups = loadUsersByGroups;
        vm.isFolderActive = isFolderActive;
        vm.isLabelActive = isLabelActive;

        vm.getGroupNames = getGroupNames;

        vm.newThread = newThread;
        vm.openThread = openThread;
        vm.closeThread = closeThread;
        vm.closeThreadEdit = closeThreadEdit;
        vm.deleteThread = deleteThread;

        vm.closeUsers = closeUsers;

        vm.addToGroup = addToGroup;
        vm.removeFromGroup = removeFromGroup;
        vm.toggleSelectThread = toggleSelectThread;
        vm.toggleSelectThreads = toggleSelectThreads;
        vm.toggleSelectGroups = toggleSelectGroups;
        vm.toggleSelectGroup = toggleSelectGroup;
        vm.isSelected = isSelected;
        vm.deselectThreads = deselectThreads;
        vm.getCleanUsersGroup = getCleanUsersGroup;

        vm.isActiveGroupUser = isActiveGroupUser;

        vm.setThreadStatus = setThreadStatus;
        vm.toggleThreadStatus = toggleThreadStatus;
        vm.toggleItemStatus = toggleItemStatus;
        vm.toggleItemStatusEdit = toggleItemStatusEdit;

        vm.getLabel = getLabel;
        vm.getLabelColor = getLabelColor;
        vm.getLabelTitle = getLabelTitle;
        vm.toggleLabel = toggleLabel;
        vm.isLabelExist = isLabelExist;

        vm.getLogs = getLogs;

        vm.changeView = changeView;
        vm.viewEditInline = viewEditInline;
        vm.viewPreview = viewPreview;
        vm.saveItem = saveItem;
        vm.massActions = massActions;

        vm.composeDialog = composeDialog;
        vm.replyDialog = replyDialog;
        vm.openImageDialog = openImageDialog;
        vm.openFocalPoint = openFocalPoint;
        vm.siteLanguages = siteLanguages;
        vm.setTinyMceContent = setTinyMceContent;
        vm.getCurrentMedia = getCurrentMedia;
        vm.newUser = newUser;
        vm.getZoneCrop = getZoneCrop;

        vm.dateFormat = sessionService.site_operative.dateFormat;
        vm.dateTimeFormat = sessionService.site_operative.dateTimeFormat;
        vm.showDate = showDate;

        vm.getCountriesWithStates = getCountriesWithStates;
        vm.getCountryById = getCountryById;
        vm.getStatesByCountry = getStatesByCountry;
        vm.getCitiesByState = getCitiesByState;

        vm.duplicateUser = duplicateUser;
        vm.setSortField = setSortField;
        vm.resetSortField = resetSortField;
        vm.setSortOrder = setSortOrder;
        //vm.callback = callback;
        vm.cancelUsersGroups = cancelUsersGroups;
        vm.saveUsersGroups = saveUsersGroups;
        vm.deleteTargetFilter = deleteTargetFilter;
        vm.mediaDialog = mediaDialog;
        vm.resetFilters = resetFilters;
        vm.resetGroupby = resetGroupby;
        vm.setGroupBy = setGroupBy;
        vm.openUsersGroupsDialog = openUsersGroupsDialog;
        vm.openImportDialog = openImportDialog;
        // vm.openExportDialog = openExportDialog;
        vm.openCopyMoveDialog = openCopyMoveDialog;
        vm.deleteTargetEdit = deleteTargetEdit;

        vm.loadAllUsers = loadAllUsers;
        vm.loadBlacklistedUsers = loadBlacklistedUsers;
        // vm.getUsersByGroups = getUsersByGroups;
        vm.unselectGroups = unselectGroups;
        vm.createGroup = createGroup;
        vm.segmentGroupDialogNew = segmentGroupDialogNew;

        vm.toggleIncludeSubgroups = toggleIncludeSubgroups;
        vm.selectedIngroupStatus = "0";
        vm.changeSelectedIngroupStatus = changeSelectedIngroupStatus;
        vm.addUsersToGroupsDialog = addUsersToGroupsDialog;
        vm.removeUsersFromGroupDialog = removeUsersFromGroupDialog;
        vm.changeInGroupStatusDialog = changeInGroupStatusDialog;


        vm.isLarge = isLarge;
        vm.isMedium = isMedium;
        vm.isSmall = isSmall;
        vm.isMini = isMini;
        vm.orderByTableListSort = orderByTableListSort;

        vm.loginToWebsite = loginToWebsite;
        vm.inviteToGroupPreview = inviteToGroupPreview;
        vm.inviteToGroupIndividual = inviteToGroupIndividual;
        vm.inviteToGroupMultiple = inviteToGroupMultiple;
        vm.customActionEvent = customActionEvent;
        vm.filterIsMainOrSecondaryTableListPosition = filterIsMainOrSecondaryTableListPosition;
        
        vm.buttonClick = buttonClick;

        vm.JSONparse = JSON.parse;
        
        vm.changeGroupPriority = changeGroupPriority;
        
        function hideAcc() {
            vm.currentThread = false;
            vm.currentThread_Edit = false;
        }
        function showStatus(status) {
            if (vm.selectedGroupsAcc) {
                var parent = vm.acreditationsGroups.find(x => x.id_group === vm.selectedGroupsAcc[0].parent);
            }
            return vm.selectedGroupsAcc && vm.selectedGroupsAcc[0] && status.id_group_type == vm.selectedGroupsAcc[0].id_group_type || (parent && status.id_group_type == parent.id_group_type);
        }


        function orderByTableListSort(ref) {
            return parseInt(ref.table_list_sort);
        }

        function getIngroupStatusRef() {
            return vm.refcolumns.find(function (ref){
                return ref.type === 'ingroup_status';
            })
        }

        function isShowingLabelGroup(thread, status) {
            var result = false;
            if (vm.isAccreditations) {
                if (vm.selectedGroupsAcc) {
                    if (vm.selectedGroupsAcc[0].parent) {
                        var group = thread.groups.find(x => x.id_group == vm.selectedGroupsAcc[0].parent);
                    } else {
                        var group = thread.groups.find(x => x.id_group == vm.selectedGroupsAcc[0].id_group);
                    }
                    if (group) {
                        result = status.id_ingroup_status == group.users_ingroup.id_ingroup_status;
                    }
                }
            } else {
                var ingroupStatusRef = getIngroupStatusRef();
                if (vm.selectedGroup.parent &&
                    ingroupStatusRef &&
                    ingroupStatusRef.raw_settings &&
                    ingroupStatusRef.raw_settings.show_parent_ingroup_status
                ) {
                    var group = thread.groups.find(x => x.id_group == vm.selectedGroup.parent);
                } else {
                    var group = thread.groups.find(x => x.id_group == vm.selectedGroup.id_group);
                }
                if (group) {
                    result = status.id_ingroup_status == group.users_ingroup.id_ingroup_status && status.id_group_type == group.id_group_type;
                }
            }
            return result;
        }
        function isShowingLabelGroupTab(thread, status, selectedGroup) {
            if (thread && thread.groups && selectedGroup) {
                var group = thread.groups.find(x => x.id_group == selectedGroup.id_group);
                var result = group && group.id_group == selectedGroup.id_group && group.users_ingroup && status.id_ingroup_status == group.users_ingroup.id_ingroup_status
                return result;
            }
            return false;
        }
        function isCurrentGroupStatus(thread, status) {
            var result = false;
            if (vm.isAccreditations) {
                return true;
            } else {
                var ingroupStatusRef = getIngroupStatusRef();
                if (vm.selectedGroup.parent &&
                    ingroupStatusRef &&
                    ingroupStatusRef.raw_settings &&
                    ingroupStatusRef.raw_settings.show_parent_ingroup_status
                ) {
                    // Status is of parent group.
                    return false;
                }
                /*
                if (vm.isAccreditations) {
                    if (vm.selectedGroupsAcc) {
                        var group = thread.groups.find(x => x.id_group == vm.selectedGroupsAcc[0].id_group);
                        if (group) {
                            result = selectedStatus.id_ingroup_status == group.users_ingroup.id_ingroup_status;
                        }
                    }
                } else {
                */
                    var group = thread.groups.find(x => x.id_group == vm.selectedGroup.id_group);
                    if (group) {
                        result = status.id_ingroup_status == group.users_ingroup.id_ingroup_status && status.id_group_type == group.id_group_type;
                    }
                //}
            }
            return result;
        }


        vm.translate = function (text) {
            return $translate.instant(text);
        }

        function showDate(value) {
            if (angular.isObject(value)) {
                return value.dateShow;
            } else if (value == '0000-00-00 00:00:00' || !value) {
                return '-';
            } else {
                var tz = (sessionService.site_operative.timezone || moment.tz.guess() || 'UTC').toString().trim();
                return moment.utc(value).tz(tz).format(vm.dateTimeFormat || 'DD/MM/YYYY HH:mm');
            }
        }


        vm.updateDatePicker = function (fld) {
            var value = moment.utc(vm.currentThread_Edit[fld].date).format('YYYY-MM-DD HH:mm:00');

            if (value == 'Invalid date') {
                vm.currentThread_Edit[fld] = {};
                vm.currentThread_Edit[fld]['value'] = '';
                vm.currentThread_Edit[fld]['date'] = '';
                vm.currentThread_Edit[fld]['dateShow'] = '';
                vm.currentThread_Edit[fld]['utcShow'] = '';
                vm.currentThread_Edit[fld]['utcDate'] = '';
            } else {
                var tz = (sessionService.site_operative.timezone || moment.tz.guess() || 'UTC').toString().trim();
                var utcDate = moment.utc(value);
                var siteDate = moment.utc(value).tz(tz);
                vm.currentThread_Edit[fld] = {};
                vm.currentThread_Edit[fld]['value'] = value;
                vm.currentThread_Edit[fld]['date'] = new Date(siteDate.format());
                vm.currentThread_Edit[fld]['dateShow'] = siteDate.format(vm.dateTimeFormat || 'DD/MM/YYYY HH:mm');
                vm.currentThread_Edit[fld]['utcShow'] = utcDate.format(vm.dateTimeFormat || 'DD/MM/YYYY HH:mm');
                vm.currentThread_Edit[fld]['utcDate'] = utcDate;
            }
        };


        vm.mediaSortable = {
            group: 'media',
            animation: 150,
            scroll: true,
            filter: '.no-sort',
            ghostClass: "sort-drop",
            onEnd: function (evt) {
                if (typeof evt.oldIndex == 'undefined' || typeof evt.newIndex == 'undefined')
                    return;
                vm.currentThread_Edit.Thumbnail = [];
                angular.forEach(vm.thumbnails_Edit, function (thumbZone, idZone) {
                    var i = 1;
                    angular.forEach(thumbZone, function (data) {
                        if (data.id_zone != idZone) {
                            var dataOld = _.clone(data);
                            if (angular.isUndefined(vm.currentThread_Edit.ThumbnailRemove))
                                vm.currentThread_Edit.ThumbnailRemove = [];
                            vm.currentThread_Edit.ThumbnailRemove.push(dataOld);
                            data.id_zone = idZone * 1;
                        }
                        data.sort = i;
                        vm.currentThread_Edit.Thumbnail.push(data)
                        i = i + 1;
                    })
                })
                vm.basicForm.$setDirty()
            }
        };

        function setTinyMceContent(event) {
            var zoneMedia = {
                1: {},
                2: {},
                3: {},
                4: {}
            };
            var typesMax = {
                1: 0,
                2: 0,
                3: 0,
                4: 0
            };
            var currentSort = 0;
            var currentType = 0;
            for (var i = 0; i < vm.currentThread_Edit.Thumbnail.length; i++) {
                if (vm.currentThread_Edit.Thumbnail[i]['id_zone'] == 1) {
                    currentSort = vm.currentThread_Edit.Thumbnail[i]['sort'];
                    currentType = vm.currentThread_Edit.Thumbnail[i]['media_type'];
                    typesMax[currentType]++;
                    zoneMedia[currentType][typesMax[currentType]] = vm.currentThread_Edit.Thumbnail[i];
                }
            }
            return zoneMedia;
        }

        vm.tinymceOptions = tinyMceService.getOptions($scope);
        /*
                {
                    theme                  : 'modern',
                    height                 : 500,
                    remove_script_host     : false,
                    allow_script_urls      : true,
                    convert_urls           : false,
                    // external_filemanager_path:"/scripts/filemanager/",
                    // 	filemanager_title:"Responsive Filemanager" ,
                    // 	external_plugins: { "filemanager" : "/scripts/filemanager/plugin.min.js"},
                    // external_plugins: {
                    //   "myplugin": "/scripts/plugin.js"
                    // },
                    extended_valid_elements: 'script[language|type|src|async|charset]',
                    plugins                : [
                        'qiumedia media advlist autolink lists link image charmap preview hr anchor pagebreak', 'searchreplace wordcount visualblocks visualchars code fullscreen imagetools', 'nonbreaking table contextmenu directionality', 'template paste textcolor colorpicker textpattern'
                    ],
                    toolbar1               : ' insertfile undo redo | bold italic | alignleft aligncenter alignright alignjustify | forecolor backcolor | bullist numlist outdent indent | link unlink image media | code fullscreen buttonadv qiumedia',
                    toolbar2               : '',
                    content_style          : "#tinymce { font-size: 16px;line-height:1.6;font-family:'Helvetica Neue', sans-serif; }" +
                    ".align-left { text-align:left }" +
                    ".align-center { text-align:center }" +
                    ".align-right { text-align:right }" +
                    ".size-25 { width:25% }" +
                    ".size-50 { width:50% }" +
                    ".size-75 { width:75% }" +
                    ".size-100 { width:100% }",
                    image_advtab           : true,
                    menubar                : false,
                    setup                  : function (editor) {
                        editor.on('change', function (e) {
                            if (vm.basicForm)
                                vm.basicForm.$setDirty();
                        });
                        editor.on('BeforeSetcontent', function(event){
                            var zoneMedia      = {
                                1: {},
                                2: {},
                                3: {},
                                4:  {}
                            };
                            var typesMax        = {
                                1: 0,
                                2: 0,
                                3: 0,
                                4: 0
                            };
                            var currentSort     = 0;
                            var currentType     = 0;
                            for (var i = 0; i < vm.currentThread_Edit.Thumbnail.length; i++) {
                                if (vm.currentThread_Edit.Thumbnail[i]['id_zone'] == 1) {
                                    currentSort = vm.currentThread_Edit.Thumbnail[i]['sort'];
                                    currentType = vm.currentThread_Edit.Thumbnail[i]['media_type'];
                                    typesMax[currentType]++;
                                    zoneMedia[currentType][typesMax[currentType]]  = vm.currentThread_Edit.Thumbnail[i];
                                }
                            }

                            var cont	= event.content;
                            var newCont	= cont;
                            var regex = /(\[image\|([^\]]*)\])/g;
                            var validData	= {
                                left: 'align-left',
                                center: 'align-center',
                                right: 'align-right',
                                25: 'size-25',
                                50: 'size-50',
                                75: 'size-75',
                                100: 'size-100',
                            }
                            let m;

                            while ((m = regex.exec(cont)) !== null) {
                                var expCont	= '';
                                var mediaData	= {
                                    type: '',
                                    sort: '',
                                    class: ''
                                };
                                var mediaExtra	= '';
                                // This is necessary to avoid infinite loops with zero-width matches
                                if (m.index === regex.lastIndex) {
                                    regex.lastIndex++;
                                }
                                if (m[2]) {
                                    expCont	= m[2].split('|');
                                    mediaData.type	= 'image';
                                    console.log(expCont);
                                    for (var i = 0; i < expCont.length; i++) {
                                        if (i == 0) {
                                            mediaData.sort	= expCont[i];
                                        } else {
                                            mediaExtra	= expCont[i];
                                            if (!angular.isUndefined(validData[mediaExtra])) {
                                                mediaData.class	+= validData[mediaExtra] + ' ';
                                            }
                                        }
                                    }
                                    var newHtml = '<div class="qiumedia" data-qiumedia="' + m[0].substr(1,-1) + '"><img src="' + zoneMedia[1][mediaData.sort].cropstatus[0].container.view_url + zoneMedia[1][mediaData.sort].cropstatus[0].fileName + '" class="qiumedia-image ' + mediaData.class + '"></div>';
                                    newCont		= newCont.replace(m[0], newHtml);
                                    event.content = newCont;
                                }
                            }
                        });
                    }
                };
        */
        function updateDatePicker(ev) {

        }

        // Attachments
        vm.deleteAttachment = deleteAttachment;
        vm.mediaDialog = mediaDialog;
        vm.mediaDialogTiny = mediaDialogTiny;
        vm.renderTinyMedia = renderTinyMedia;

        vm.toggleSidenav = toggleSidenav;
        vm.isNumber = isNumber;
        vm.hasDateShow = hasDateShow;
        vm.updateThread = updateThread;

        //////////

        init();

        function init() {
            vm.views = {
                nosplit: 'app/main/apps/users/users-blacklist/views/list/nosplit-view.html',
                split: 'app/main/apps/users/users-blacklist/views/list/split-view.html',
                table: 'app/main/apps/users/users-blacklist/views/list/table-view.html',
                grid: 'app/main/apps/users/users-blacklist/views/grid/grid-view.html'
            };
            vm.defaultView = vm.getSettingValue(vm.settingsSection, 'defaultView', "split");
            vm.currentView = vm.getSettingValue(vm.settingsSection, 'defaultView', "split");
            vm.loadingView = true;

            //vm.getCountriesWithStates();

            var siteID = requestContext.getParam("siteId");
            //            var section = requestContext.getParam("section");

            var section = 'users';

            $scope.siteID = siteID;
            $scope.section = section;

            /*
            contentService.getFilters({section: section, site: siteID}).then(function (response) {
                vm.mediaZones = (response.media_zones.length == 0)
                    ? null
                    : angular.copy(response.media_zones);
            });*/

            sessionService.setActiveSection(section).then(function () {
                vm.ActiveSection = sessionService.ActiveSection;
            });

            loadBlacklistedUsers();
            getUserGroupTypes();
            getCleanUsersGroup();

            vm.viewSplit = true;
            vm.edit = false;
            vm.currentTab = 'mailing';
            vm.selectedUsers = [];
            vm.selectedGroups = [];

            $scope.view_medialist = true;
            $scope.siteID = siteID;
            $scope.section = section;
            $rootScope.global.titleToolbar = '<i class="icon s20 icon-people mr-15" ng-if="node.icon"></i> ' + $translate.instant('USERS');
            if (vm.isAccreditations) {
                $rootScope.global.titleToolbar = '<i class="icon s20 icon-people mr-15" ng-if="node.icon"></i> ' + $translate.instant('USERS.ACCREDITATIONS');
            }

            
            var options = {
                site: $scope.siteID,
                section: $scope.section
            };

            // $scope.page = 1;
            // request the initial set of data
            // loadRemoteData();
            $scope.page = 1;

            if ($state.params.id) {
                vm.loadingReadPane = true;
                // for (var i = 0; i < vm.threads.length; i++) {
                // if (vm.threads[i].id === $state.params.threadId) {
                //vm.openThread(null, $state.params.id);
                // break;
                // }
                // }
            }

            usersBlacklistService.getUsersInGroupStatus($scope.siteID).then(function (response) {
                vm.ingroupStatus = response;
            });
        }

        // Watch screen size to change view modes
        $scope.$watch(function () {
            return $mdMedia('lt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                vm.currentView = 'nosplit';
            }
        });

        $scope.$watch(function () {
            return $mdMedia('max-width: 960px');
        }, function (big) {

            if (big)
                vm.currentView = 'nosplit';

        });

        $scope.$watch(function () {
            return $mdMedia('min-width: 960px');
        }, function (small) {

            if (small && vm.defaultView === 'split')
                vm.currentView = vm.defaultView;

        });

        $scope.$watch(function () {
            return $mdMedia('gt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                if (vm.defaultView === 'split') {
                    vm.currentView = 'nosplit';
                }
            }
        });

        $scope.$on('$includeContentLoaded', function (event, target) {
            $timeout(function () {
                vm.loadingView = false;
            }, 1000);
        });

        $scope.$on('loadUsersByGroups', function (event, groups, selectedGroup) {
            vm.pleaseSelectGroup = false;
            if (groups) {
                var groupIds = [];
                angular.forEach(groups, function (group) {
                    groupIds.push(group.id_group);
                });
                vm.selectedGroup = selectedGroup;
                loadUsersByGroups(groupIds);
            } else {
                if (!vm.isQiuRestricted) {
                    unselectGroups();
                }
            }
            vm.selectedThreads = [];
        });
        $scope.$on('loadUsersByGroupsAcc', function (event, groups) {
            vm.pleaseSelectGroup = false;
            if (groups) {
                var groupIds = [];
                angular.forEach(groups, function (group) {
                    groupIds.push(group.id_group);
                });
                vm.selectedGroupsAcc = groups;
                loadUsersByGroups();
            } else {
                unselectGroups();
            }
            vm.selectedThreads = [];
        });
        $scope.$on('loadUsersByGroupsAccSub', function (event, groups) {
            vm.pleaseSelectGroup = false;
            if (groups) {
                var groupIds = [];
                angular.forEach(groups, function (group) {
                    groupIds.push(group.id_group);
                });
                vm.selectedGroupsAccSub = groups;
                loadUsersByGroups();
            } else {
                unselectGroups();
            }
            vm.selectedThreads = [];
        });


        $scope.$on('pagination:loadStart', function (event) {
            $scope.isLoading = true;
            // $anchorScroll();

            // Store the current scrollPos
            // vm.scrollPos = vm.scrollEl.scrollTop();
            
            // Scroll to the top
            // vm.scrollEl.scrollTop(0);
            if (!vm.enterfirst) {
                var elem = angular.element(document.getElementById('thread-list'));
                // elem.scrollTopAnimated(0, 10);
            }

            // angular.element("#thread-list").scrollTop=0;
            vm.enterfirst = false;
            $scope.isLoading = true;
        });

        $scope.$on('pagination:loadPage', function (event) {
            if (vm.currentGroupTypeId > 0 && !vm.selectedGroup && !vm.isAccreditations) {
                vm.threads = [];
                vm.pleaseSelectGroup = true;
            }
            if ($state.params.id && !vm.reloadFromUser) {
                vm.openThread(null, $state.params.id);
            }
            vm.reloadFromUser = false;
            $scope.isLoading = false;
            vm.dataAlreadyLoaded = true;
        });

        $scope.$on('closeSidenav', function (ev, sidenavId) {
            $mdSidenav(sidenavId).close();
        })

        $scope.$on('openGroupDialog', function (ev, group) {
            openGroupDialog(ev, group);
        });


        function getUserGroupTypes() {
            var options = {
                site: $scope.siteID
            };
            formsService.getUserGroupTypes(options).then(function (response) {
                vm.userGroupTypes = response;
            });
        }

        function toggleIncludeSubgroups() {
            vm.includeSubgroups = !vm.includeSubgroups;
            var element = $("#treeview-group-" + vm.selectedGroup.id_group);
            usersBlacklistService.triggerUsersByGroups(element.attr("data-group-node"), vm.includeSubgroups);
        }

        function unselectGroups() {
            $scope.validSelection = true;
            vm.selectedIngroupStatus = "0";
            vm.selectedGroupsAcc = false;
            vm.selectedGroupsAccSub = false;
            vm.selectedGroup = false;
            vm.selectedContent = false;
            $rootScope.pagination_groupIds = false;
            $rootScope.pagination_ingroupStatus = false;
            var elemList = document.querySelectorAll('.group-row');
            elemList.forEach(function (elem) {
                elem.classList.remove('selected');
            });
            if (vm.currentGroupTypeId == 0) {
                loadBlacklistedUsers();
            } else {
                $scope.isLoading = true;
                $timeout(function () {
                    vm.pleaseSelectGroup = true;
                    vm.threads = [];
                    $scope.isLoading = false;
                }, 1000);
            }
        }

        function loadAllUsers() {
            // $scope.isLoading = true;
            // var options = {
            //     siteID: $scope.siteID,
            //     section: $scope.section,
            //     sortDir: $rootScope.sortDir,
            //     sortField: $rootScope.sortField,
            // };
            // usersBlacklistService.getUsers(options).then(function (response) {
            //     vm.threads = response.result.data;
            //     $rootScope.pagination_totalItems = response.result.total;
            //     $rootScope.pagination_total_pages = response.result.last_page;
            //     $rootScope.pagination_page = response.result.current_page;
            //     $scope.isLoading = false;
            // });
        }

        function loadBlacklistedUsers() {
            $scope.isLoading = true;
            var options = {
                siteID: $scope.siteID,
                section: $scope.section,
                sortDir: $rootScope.sortDir,
                sortField: $rootScope.sortField,
            };
            usersBlacklistService.getUsers(options).then(function (response) {
                vm.threads = response.data;
                $rootScope.pagination_totalItems = response.total;
                $rootScope.pagination_total_pages = response.last_page;
                $rootScope.pagination_page = response.current_page;
                $scope.isLoading = false;
                vm.reloadFromUser = false;
                vm.dataAlreadyLoaded = true;
            })
        }

        function isSelectedIngroupStatusOfSelectedGroupType(groupId) {
            var selectedGroup = vm.allGroups.find(x => x.id_group === groupId);
            var selectedIngroupStatus = vm.ingroupStatus.find(y => y.id_ingroup_status === parseInt(vm.selectedIngroupStatus));
            if (selectedGroup && selectedIngroupStatus) {
                return selectedIngroupStatus.id_group_type === selectedGroup.id_group_type;
            }
            return false;
        }

        function loadUsersByGroups(groupIds) {

            $scope.validSelection = true;
            if (vm.isAccreditations) {
                groupIds = [];
                if (vm.selectedGroupsAcc) {
                    //groupIds.push(...vm.selectedGroupsAcc.map(x => x.id_group)) // Filter parent AND subgroups.
                    groupIds.push(vm.selectedGroupsAcc[0].id_group) // Only filter parent group, NO subgroups.
                }
                if (vm.selectedGroupsAccSub) {
                    groupIds = [];
                    if (vm.selectedGroupsAcc) {
                        var result = vm.selectedGroupsAccSub[0].users_groups.filter(x => vm.selectedGroupsAcc.find(y => y.id_group === x.parent))
                        groupIds.push(...result.map(x => x.id_group))
                    } else {
                        groupIds.push(...vm.selectedGroupsAccSub[0].users_groups.map(x => x.id_group))
                    }
                }
            }

            // The active ingroup status may have been set from a previously selected group.
            // Unset it if its type does not match the type of the _now_ selected group.
            if (!angular.isArray(groupIds) || groupIds.length === 0 || !isSelectedIngroupStatusOfSelectedGroupType(groupIds[0])) {
                $rootScope.pagination_ingroupStatus = false;
                vm.selectedIngroupStatus = false;
            }

            $scope.isLoading = true;
            var options = {
                siteID: $scope.siteID,
                section: $scope.section,
                groupIds: groupIds,
                sortDir: $rootScope.sortDir,
                sortField: $rootScope.sortField,
                withRelatedCountry: true,
                withRelatedCity: true,
                withRelatedState: true,
            };
            if (vm.selectedIngroupStatus != "0") {
                options.ingroupStatus = vm.selectedIngroupStatus;
            }
            if (!groupIds || groupIds.length == 0) {
                $scope.validSelection = false;
                const message = vm.translate('USERS.NO_VALID_SELECTION');
                $scope.isLoading = false;
                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-close" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                    hideDelay: 5000,
                    position: 'top',
                    parent: '#content-container'
                });
            } else {
                if (vm.refcolumns) {
                    var hasIngroupStatusTypeRef = vm.refcolumns.find(function (ref){
                        return ref.type === 'ingroup_status';
                    })
                    if (hasIngroupStatusTypeRef) {
                        vm.includeAllGroups = true;
                        options.allGroups = vm.includeAllGroups;
                    }
                }
                usersBlacklistService.getUsersByGroupsNoRef(options).then(function (response) {
                    // manageResponse(response, groupIds)
                });
            }
        }

        // function manageResponse(response, groupIds) {
        //     $rootScope.pagination_groupIds = groupIds;

        //     vm.threads = response.result.data;
        //     angular.forEach(vm.threads, function (user) {
        //         var selUserGroup = $filter('filter')(user.groups, { id_group: vm.selectedGroup.id_group });
        //         if (selUserGroup.length > 0) {
        //             var idIngroupStatus = selUserGroup[0].users_ingroup.id_ingroup_status;
        //             user.ingroup_status = $filter('filter')(vm.ingroupStatus, { id_ingroup_status: idIngroupStatus });
        //         }
        //     });
        //     $rootScope.pagination_totalItems = response.result.total;
        //     $rootScope.pagination_total_pages = response.result.last_page;
        //     $rootScope.pagination_page = response.result.current_page;
        //     $scope.isLoading = false;
        // }

        function getCleanUsersGroup() {
            $scope.isLoadingGroups = true;
            var opts = {
                siteID: $scope.siteID,
                withGroupType: true,
                sortField: vm.sortFieldUsersGroup,
                sortDir: vm.sortDirUsersGroup
            };
            if (vm.currentGroupTypeId > 0 && !vm.isAccreditations) {
                opts.groupType = vm.currentGroupTypeId;
            }
            if (vm.refcolumns) {
                var hasIngroupStatusTypeRef = vm.refcolumns.find(function (ref){
                    return ref.type === 'ingroup_status';
                })
                if (hasIngroupStatusTypeRef) {
                    vm.includeAllGroups = true;
                    opts.allGroups = vm.includeAllGroups;
                }
            }
            usersBlacklistService.getUsersGroups(opts).then(function (response) {
                var qiuRestrictions = response.qiuRestrictions;
                if (qiuRestrictions && qiuRestrictions.hasOwnProperty('advanced_settings_access')) {
                    vm.hasAdvancedSettingsAccess = qiuRestrictions.advanced_settings_access.includes(true);
                }
                var groups = response.data;
                vm.allGroups = getFlatGroups(groups, []);
                vm.CleanUsersGroups = transformUsers.formatNestedGroups(groups, qiuRestrictions, true);
                
                if (vm.isAccreditations) {
                    groupsByRefAccreditations();
                } else {
                    groupsByRef();
                }
                if (angular.isArray(vm.CleanUsersGroups) &&
                    vm.CleanUsersGroups.length > 0 &&
                    vm.CleanUsersGroups[0].is_qiu_restricted_root
                ) {
                    vm.isQiuRestricted = true;
                    if (vm.isAccreditations) {
                        //vm.selectedGroup = vm.CleanUsersGroups[0];
                        vm.rootGroup = vm.CleanUsersGroups[0];
                    } else {
                        vm.selectedGroup = vm.CleanUsersGroups[0];
                        vm.rootGroup = vm.CleanUsersGroups[0];
                    }
                }
                vm.flatGroups = getFlatGroups(vm.CleanUsersGroups, []);
                vm.eventsGroup = getEvents(vm.CleanUsersGroups);
            });

        }
        
        function getEvents(Groups){
            var groupsToReturn = [];
            if(Groups.length > 0){
                for(var i=0; i<Groups.length; i++){
                    if(Groups[i].id_group == 41){
                        groupsToReturn = Groups[i].children;
                    }
                }
            }
            return groupsToReturn;
        }

        function groupsByRefAccreditations() {
            var options = { siteID: $scope.siteID };
            usersBlacklistService.getRef(options).then(function (ref) {
                vm.groupTypes = ref.find(x => x.category === 'show_groups');
                vm.subGroupTypes = ref.find(x => x.category === 'show_groups_type');
                vm.acreditationsGroups = angular.copy(vm.CleanUsersGroups);
                const arrayGroupsTypes = JSON.parse(vm.groupTypes.field_name);
                const arraysubGroupsTypes = JSON.parse(vm.subGroupTypes.field_name);
                vm.acreditationsGroups = cleanByType(vm.acreditationsGroups, arrayGroupsTypes);

                usersBlacklistService.getGroupsAccreditations(options).then(function (groups) {
                    vm.groupsAccreditations = groups;
                    var copyGroups = getFlatGroups(angular.copy(vm.groupsAccreditations[0].children), []);
                    vm.subAcreditationsGroups = [];
                    for (let i = 0; i < copyGroups.length; i++) {
                        if (arraysubGroupsTypes.find(y => y === copyGroups[i].id_group_type)) {
                            transformUsers.colorizeGroupByType(copyGroups[i], vm.userGroupTypes)
                            vm.subAcreditationsGroups.push(copyGroups[i])
                        }
                    }
                    vm.subAcreditationsGroups = vm.subAcreditationsGroups.sort(function (a, b) {
                        return (a.id - b.id);
                    });
                    $scope.isLoadingGroups = false;
                })
            })
        }

        function groupsByRef() {
            var options = { siteID: $scope.siteID };
            usersBlacklistService.getRef(options).then(function (ref) {
                var found = ref.find(x => x.category === 'show_groups');
                if (found) {
                    vm.CleanUsersGroups = cleanByType(vm.CleanUsersGroups, JSON.parse(found.field_name));
                }
                $scope.isLoadingGroups = false;
            })
        }

        function addToGroup(group, groupParent) {
            var existParent = vm.selectedContent.groups ? vm.selectedContent.groups.find(x => x.id_group == groupParent.id_group) : null;
            var groups = [];
            if (!existParent) {
                var groupParentToInsert = { "id_group": groupParent.id_group, "id_ingroup_status": groupParent.default_ingroup_status };
                groups.push(groupParentToInsert)
            }
            groups.push({ "id_group": group.id_group });
            addGroup(vm.selectedContent.id_user, groups, true);
        }

        function addGroup(id_user, groups, update) {
            var options = {
                siteID: $scope.siteID,
                data: {
                    id_users: [id_user],
                    groups: groups
                }
            };
            usersBlacklistService.massInsertUsersIntoGroups(options)
                .then(function (response) {
                    var options = { site: $scope.siteID, section: $scope.section, id: $state.params.id, sortDir: $rootScope.sortDir, sortField: $rootScope.sortField };
                    usersBlacklistService.getUserByID(options).then(function (response) {
                        vm.selectedContent.groups = JSON.parse(angular.toJson(response)).groups;
                        vm.reloadFromUser = true;
                        if (update) {
                            $rootScope.pagination_resetquery();
                        } else {
                            getGroupsAsfield();
                        }
                    });
                }, function(error) {
                    if (error.data.detail) {
                        msUtils.showError(error.data.detail);
                    }
                });
        }
        function removeFromGroup(group, groupParent) {
            var removeParent = vm.selectedContent.groups ? (vm.selectedContent.groups.filter(x => x.parent == group.parent).length <= 1) : null;
            removeGroup(group.id_group, vm.selectedContent.id_user, true);
            if (removeParent) {
                removeGroup(groupParent.id_group, vm.selectedContent.id_user, true);
            }
        }
        function removeGroup(idgroup, iduser, update) {
            var options = {
                siteID: $scope.siteID,
                data: {
                    id_group: idgroup,
                    id_user: [iduser]
                }
            };
            usersBlacklistService.removeUsersFromGroup(options).then(function (response) {
                var options = { site: $scope.siteID, section: $scope.section, id: $state.params.id, sortDir: $rootScope.sortDir, sortField: $rootScope.sortField };
                usersBlacklistService.getUserByID(options).then(function (response) {
                    vm.selectedContent.groups = JSON.parse(angular.toJson(response)).groups;
                    vm.reloadFromUser = true;
                    if (update) {
                        $rootScope.pagination_resetquery();
                    } else {
                        getGroupsAsfield();
                    }
                });
            });
        }

        function isActiveGroupUser(group) {
            if (!vm.selectedContent || !vm.selectedContent.groups) return false;
            return vm.selectedContent && vm.selectedContent.groups.find(x => x.id_group === group.id_group);
        }
        function cleanByType(arrayGroups, groupTypes) {
            arrayGroups = arrayGroups.filter(x => groupTypes.find(y => y === x.id_group_type))
            for (let i = 0; i < arrayGroups.length; i++) {
                const group = arrayGroups[i];
                if (group.children) {
                    group.children = cleanByType(group.children, groupTypes);
                }
            }
            return arrayGroups;
        }
        function getByType(arrayGroups, groupTypes) {

            var result = arrayGroups.filter(x => groupTypes.find(y => y === x.id_group_type))
            for (let i = 0; i < arrayGroups.length; i++) {
                const group = arrayGroups[i];
                if (group.children) {
                    result.push(...getByType(group.children, groupTypes));
                }
            }
            return result;
        }

        function getFlatGroups(nestedGroups, groups) {
            angular.forEach(nestedGroups, function (group) {
                groups.push(group);
                if (group.children) {
                    getFlatGroups(group.children, groups)
                }
            });
            return groups;
        }

        function createGroup(ev) {
            openGroupDialog(ev, {});
        }

        function segmentGroupDialogNew($event) {
            var promiseList = [];
            promiseList.push(usersBlacklistService.getUsersGroups({
                siteID: $scope.siteID,
                withGroupType: true
            })
            );
            promiseList.push(usersBlacklistService.getUsersGroupsTypes({ siteID: $scope.siteID }));

            $q.all(promiseList).then(function (response) {
                var cleanUsersGroups = transformUsers.formatNestedGroups(response[0].data, response[0].qiuRestrictions, true);
                var usersGroupsTypes = response[1];
                if (vm.currentGroupTypeId > 0) {
                    usersGroupsTypes = usersGroupsTypes.filter(x => x.id_group_type == vm.currentGroupTypeId)
                }
                openSegmentGroupDialogNew(cleanUsersGroups, usersGroupsTypes);
            }).catch(function (error) {
                console.log('error', error);
            });
        }

        function openSegmentGroupDialogNew(cleanUsersGroups, usersGroupsTypes) {
            var groupsTree = angular.copy(cleanUsersGroups);
            var booleanOperations = [
                {
                    operation: 'add',
                    name: $translate.instant('GROUP.ACTIONS.ADD')
                },
                {
                    operation: 'intersect',
                    name: $translate.instant('GROUP.ACTIONS.INTERSECT')
                },
                {
                    operation: 'except',
                    name: $translate.instant('GROUP.ACTIONS.EXCEPT')
                },
                {
                    operation: 'difference',
                    name: $translate.instant('GROUP.ACTIONS.DIFFERENCE')
                },
                {
                    operation: 'filter',
                    name: $translate.instant('GROUP.ACTIONS.FILTER')
                }
            ];
            $mdDialog.show({
                controller: 'SegmentUsersGroupsController',
                controllerAs: 'vm',
                locals: {
                    usersGroups: cleanUsersGroups,
                    usersGroupsTypes: usersGroupsTypes,
                    booleanOperations: booleanOperations,
                    defaultGroupTypeId: false,
                    showGroupsTypes: true,
                    newGroupShow: false,
                    subscriptionGroupId: false,
                    subscriptionGroupName: ''
                },
                templateUrl: 'app/main/dialogs/segment-users-groups/segment-users-groups.html',
                parent: angular.element($document.body),
                targetEvent: 'ev',
                clickOutsideToClose: true

            }).then(function (result) {
                if (result) {
                    getCleanUsersGroup();
                }
            });
        }

        function changeInGroupStatusDialog(ev, selectedUser, selectedGroup, selectedStatus, isAccreditations) {
            if(!isCurrentGroupStatus(selectedUser, selectedStatus)) {
                return;
            }
            ev.stopPropagation();
            $mdDialog.show({
                controller: 'ChangeInGroupStatusDialogController',
                controllerAs: 'vm',
                locals: {
                    isAccreditations: isAccreditations,
                    ingroupStatus: vm.ingroupStatus,
                    selectedUser: selectedUser,
                    selectedGroup: selectedGroup,
                    selectedStatus: selectedStatus,
                    siteID: $scope.siteID
                },
                templateUrl: 'app/main/apps/users/dialogs/users/change-in-group-status.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            }).then(function (user) {
                if (user) {
                    if (isAccreditations) {
                        vm.selectedContent = user;
                        vm.reloadFromUser = true;
                        $rootScope.pagination_resetquery();
                    } else {
                        var options = {
                            site: $scope.siteID,
                            id: user.id_user,
                            item: transformUsers.userToDTO(user)
                        };
                        usersBlacklistService.saveItem(options).then(function () {
                            var message = $translate.instant('USERS.INGROUP_STATUS_SAVED');
                            $mdToast.show({
                                template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                                hideDelay: 5000,
                                position: 'top',
                                parent: '#content-container'
                            });
                            vm.reloadFromUser = true;
                            $rootScope.pagination_resetquery();
                        });
                    }
                }
            });
        }

        function filterActiveTypes(groups) {
            if (typeof groups === 'string') {
                groups = JSON.parse(groups)
            }
            return function (item) {
                return groups.find(x => x == item.id_group_type && vm.selectedGroupsAcc && vm.selectedGroupsAcc[0] && vm.selectedGroupsAcc[0].id_group === item.parent);
            };
        };

        function getGroupIcon(group) {
            return getByType(angular.copy(vm.CleanUsersGroups), [group.id_group_type]).find(x => x.id_group === group.id_group).group_type.icon;;
        }

        function deleteTargetEdit(item, index) {
            for (var i = vm.currentThread_Edit.groups.length - 1; i >= 0; i--) {
                if (vm.currentThread_Edit.groups[i].id_group == item.id_group) {
                    vm.currentThread_Edit.groups.splice(i, 1);
                    vm.currentLabelsEdit.splice(index, 1);
                }
            };
            for (var i = vm.currentThread_Edit.groupIds.length - 1; i >= 0; i--) {
                if (vm.currentThread_Edit.groupIds[i] == item.id_group) {
                    vm.currentThread_Edit.groupIds.splice(i, 1);
                }
            };
            for (var i = vm.groupTypesWithCurrentLabelsEdit.length - 1; i >= 0; i--) {
                if (vm.groupTypesWithCurrentLabelsEdit[i].hasOwnProperty('labelsEdit')) {
                    for (var k = vm.groupTypesWithCurrentLabelsEdit[i].labelsEdit.length - 1; k >= 0; k--) {
                        if (vm.groupTypesWithCurrentLabelsEdit[i].labelsEdit[k].group.id_group == item.id_group) {
                            vm.groupTypesWithCurrentLabelsEdit[i].labelsEdit.splice(k, 1);
                        }
                    }
                }
            }
            vm.basicForm.$setDirty();
        }

        function getCurrentLabelsEdit() {
            var usersGroupsAux = transformUsers.initGroupsTree(angular.copy(vm.CleanUsersGroups), vm.currentThread_Edit.groups, vm.ingroupStatus);
            vm.currentLabelsEdit = transformUsers.getLabels(usersGroupsAux, []);
            vm.groupTypesWithCurrentLabelsEdit = angular.copy(vm.userGroupTypes);
            angular.forEach(vm.groupTypesWithCurrentLabelsEdit, function (groupType) {
                angular.forEach(vm.currentLabelsEdit, function (labelEdit) {
                    if (labelEdit.group.id_group_type == groupType.id_group_type) {
                        if (!groupType.hasOwnProperty('labelsEdit')) {
                            groupType['labelsEdit'] = [];
                        }
                        if (labelEdit.group.parent != null) {
                            getGroupParent(labelEdit.group);
                        }
                        groupType.labelsEdit.push(labelEdit);
                    }
                });
            });
        }
        function getGroupParent(group) {
            for (var i = vm.flatGroups.length - 1; i >= 0; i--) {
                if (vm.flatGroups[i].id_group == group.parent) {
                    group.parentGroup = angular.copy(vm.flatGroups[i]);
                    if (group.parentGroup.parent != null) {
                        getGroupParent(group.parentGroup);
                    }
                }
            }
        }
        function isLarge(field) {
            return ['firstname', 'email', 'last_login', 'created_at'].includes(field);
        }
        function isMedium(field) {
            return ['mobile', 'skype', 'ingroup_status', 'country'].includes(field);
        }
        function isSmall(field) {
            return [].includes(field);
        }
        function isMini(field) {
            return ['status', 'media', 'id_user'].includes(field);
        }

        function changeSelectedIngroupStatus() {
            // TODO reload group users filtered by ingroup status
            var groupIds = $rootScope.pagination_groupIds;
            $rootScope.pagination_ingroupStatus = vm.selectedIngroupStatus;
            loadUsersByGroups(groupIds);
        }
        
        function changeGroupPriority(ev) {
            $mdDialog.show({
                controller: 'ChangePriorityGroupDialogController',
                controllerAs: 'vm',
                locals: {
                    siteID: $scope.siteID,
                    sourceGroups: [vm.selectedGroup],
                    mailingPriorities: vm.refcolumns.find(x => x.title == 'mailing_priority').raw_settings.values,
                    selectedThreads: vm.selectedThreads
                },
                templateUrl: 'app/main/apps/users/dialogs/priority/change-priority.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            }).then(function (response) {
               if(response){
                    $scope.isLoading = true;
                    var users = response.users;
                    var count = 0;
                    for(var i=0; i<users.length; i++){
                        var user = users[i];
                        user.mailing_priority = response.priority;
                        var options = {
                            site: $scope.siteID,
                            id: user.id_user,
                            item: transformUsers.userToDTO(user)
                        }
                        usersBlacklistService.saveItem(options).then(function (response){
                            count ++;
                            closeThread();
                            if(count == users.length){
                                $scope.isLoading = false;
                            }
                        }, function(error) {
                            if (error.detail && error.detail === 'The email has already been taken.') {
                                msUtils.showError($translate.instant('USERS.ERRORS.EMAIL_EXISTS'));
                            }
                        });
                    }
                }else{
                    closeThread();
                }
            });
        }

        function openCopyMoveDialog(ev, selectedAction) {
            $mdDialog.show({
                controller: 'CopyMoveToGroupDialogController',
                controllerAs: 'vm',
                locals: {
                    siteID: $scope.siteID,
                    sourceGroups: [vm.selectedGroup],
                    usersGroups: vm.CleanUsersGroups,
                    includeSubgroups: vm.includeSubgroups,
                    selectedAction: selectedAction
                },
                templateUrl: 'app/main/apps/users/dialogs/in-groups/copy-move-to-group-dialog/copy-move-to-group-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            }).then(function (reloadUserList) {
                if (reloadUserList) {
                    $rootScope.pagination_reload();
                }
            });
        }

        function addUsersToGroupsDialog(ev) {
            //var groupsTree = transformUsers.initGroupsTree(angular.copy(vm.CleanUsersGroups), [], vm.ingroupStatus);
            $mdDialog.show({
                controller: 'AddUsersToGroupsDialogController',
                controllerAs: 'vm',
                locals: {
                   
                    CleanUsersGroups: vm.CleanUsersGroups,
                    ingroupStatus: vm.ingroupStatus,
                    users: angular.copy(vm.selectedThreads),
                    siteID: $scope.siteID
                },
                templateUrl: 'app/main/apps/users/dialogs/groups/users-groups-view.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                multiple: true
            }).then(function (res) {
                if (res) {
                    getCleanUsersGroup();
                }
            });
            $scope.loadGroup = false;
       }

        function getMaxAllowedUsers() {

        }

        function openImportDialog(ev) {
            $mdDialog.show({
                controller: 'ImportDialogController',
                controllerAs: 'vm',
                locals: {
                    siteID: $scope.siteID,
                    rootGroup: vm.isQiuRestricted ? vm.rootGroup : null,
                    selectedGroup: vm.selectedGroup ? vm.selectedGroup : vm.selectedGroupsAcc ? vm.selectedGroupsAcc[0] : null
                },
                templateUrl: 'app/main/apps/users/dialogs/import/import-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            })
                .then(function (result) {
                    if (result && result.update) {
                        $rootScope.pagination_resetquery();
                    }
                });
        }

//         function openExportDialog(ev) {
//             var groups = vm.selectedGroup ? vm.selectedGroup : null;
//             var mainGroup = null;
//             if (vm.selectedGroupsAcc) {
//                 groups = vm.selectedGroupsAcc[0];
//                 if (vm.selectedGroupsAccSub) {
//                     mainGroup = vm.selectedGroupsAcc[0];
//                     groups = vm.selectedGroupsAccSub[0].users_groups.find(x => x.parent === vm.selectedGroupsAcc[0].id_group);
//                 }
//             } else {
//                 if (vm.selectedGroupsAccSub) {
//                     groups = vm.selectedGroupsAccSub[0].users_groups;
//                 }
//             }

// //            console.log(groups);
//             $mdDialog.show({
//                 controller: 'ExportDialogController',
//                 controllerAs: 'vm',
//                 locals: {
//                     siteID: $scope.siteID,
//                     refcolumns: vm.refcolumns,
//                     selectedGroup: groups,
//                     selectedMainGroup: mainGroup,
//                     selectedThreads: vm.selectedThreads.length > 0 ? vm.selectedThreads : null,
//                     threads: vm.threads,
//                     totalItems: $rootScope.pagination_totalItems,
//                     groups: vm.CleanUsersGroups,
//                     includeSubgroups: vm.includeSubgroups,
//                     currentGroupTypeId: vm.currentGroupTypeId,
//                     selectedIngroupStatus: vm.selectedIngroupStatus
//                 },
//                 templateUrl: 'app/main/apps/users/dialogs/export/export-dialog.html',
//                 parent: angular.element($document.body),
//                 targetEvent: ev,
//                 clickOutsideToClose: true
//             })
//                 .then(function (result) {
//                 });
//         }

        function removeUsersFromGroupDialog(ev) {

            var confirmTitle = $translate.instant('GROUP.REMOVE_CONFIRM_TITLE', { group_name: vm.selectedGroup.name });
            var confirmText = $translate.instant('GROUP.REMOVE_CONFIRM_TEXT');
            var confirm = $mdDialog.confirm()
                .title(confirmTitle)
                .textContent(confirmText)
                .ariaLabel(confirmTitle)
                .targetEvent(ev)
                .ok('OK')
                .cancel($translate.instant('CANCEL'));

            $mdDialog.show(confirm).then(function () {

                var removeUserIds = vm.selectedThreads.map(function (thread) { return thread.id_user });

                var options = {
                    siteID: $scope.siteID,
                    data: {
                        id_group: vm.selectedGroup.id_group,
                        id_user: removeUserIds
                    }
                }
                usersBlacklistService.removeUsersFromGroup(options).then(function (response) {
                    var element = $("#treeview-group-" + vm.selectedGroup.id_group);
                    usersBlacklistService.triggerUsersByGroups(element.attr("data-group-node"), vm.includeSubgroups);

                    if (removeUserIds.length == 1) {
                        var message = $translate.instant('GROUP.USER_REMOVED_SINGULAR');
                    } else {
                        var message = removeUserIds.length + $translate.instant('GROUP.USER_REMOVED_PLURAL');
                    }

                    $mdToast.show({
                        template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                        hideDelay: 5000,
                        position: 'top',
                        parent: '#content-container'
                    });
                });
            });

        }

        function openUsersGroupsDialog() {
            var groupsTree = transformUsers.initGroupsTree(angular.copy(vm.CleanUsersGroups), vm.currentThread_Edit.groups, vm.ingroupStatus);
            $mdDialog.show({
                controller: 'UsersGroupController',
                controllerAs: 'vm',
                locals: {
                    usersGroups: groupsTree,
                    isTiny: false
                },
                templateUrl: 'app/main/dialogs/users-group/users-group-view.html',
                parent: angular.element($document.body),
                targetEvent: 'ev',
                clickOutsideToClose: true,

            }).then(function (groupsTree) {
                if (angular.isDefined(groupsTree) && groupsTree.length > 0) {
                    if (angular.isUndefined(vm.currentThread_Edit.groups)) {
                        vm.currentThread_Edit.groups = [];
                    }
                    transformUsers.updateThreadGroups(groupsTree, vm.currentThread_Edit.groups, vm.currentThread_Edit.id_user, []);
                }
                getCurrentLabelsEdit();
                vm.basicForm.$setDirty();
            });
        }




        function setSortField(field) {
            vm.fieldOrder = field;
            settingUserService.setSetting(vm.settingsSection, 'sortField', field);
            $rootScope.pagination_setSortField(field, $rootScope.sortDir);
        }

        function setSortOrder(order) {
            $rootScope.sortDir = order;
            settingUserService.setSetting(vm.settingsSection, 'sortDir', order);
            $rootScope.pagination_setSortField(vm.fieldOrder, $rootScope.sortDir);
        }

        /**
         * Load folder
         *
         * @param name
         */
        // function loadFolder(name) {
        //     // If we are already in the selected folder and
        //     // there is an open thread just close it
        //     if (vm.isFolderActive(name)) {
        //         // Close the current thread if open
        //         if (vm.currentThread) {
        //             vm.closeThread();
        //         }

        //         return;
        //     }

        //     // Show loader
        //     $rootScope.loadingProgress = true;

        //     // Update the state without reloading the controller
        //     $state.go('app.users.threads', {
        //         type: null,
        //         filter: name
        //     }, { notify: false });

        //     // Build the API name
        //     var apiName = 'content.folder.' + name + '@get';

        //     // Make the call
        //     msApi.request(apiName).then(
        //         // Success
        //         function (response) {
        //             // Load new threads
        //             vm.threads = response.data;

        //             // Set the current filter
        //             vm.currentFilter = {
        //                 type: null,
        //                 filter: name
        //             };

        //             // Close the current thread if open
        //             if (vm.currentThread) {
        //                 vm.closeThread();
        //             }

        //             // Hide loader
        //             $rootScope.loadingProgress = false;
        //         });
        // }

        function selectOrUnselect(item, $event) {
            // var indexInTemp = $scope.temps.indexOf(item);
            var isRightClick = $event && $event.which == 3;
            var isDoubleClick = $event && $event.type == 'dblclick';

            // if ($event && $event.target.hasAttribute('prevent')) {
            //     $scope.temps = [];
            //     return;
            // }
            // if (! item || (isRightClick && $scope.isSelected(item))) {
            //     return;
            // }
            // if ($event && $event.shiftKey && !(isRightClick) && !(isDoubleClick)) {
            //     var list = $scope.fileList;
            //     var indexInList = list.indexOf(item);
            //     var lastSelected = $scope.temps[0];
            //     var i = list.indexOf(lastSelected);
            //     var current = undefined;
            //     if (lastSelected && list.indexOf(lastSelected) < indexInList) {
            //         $scope.temps = [];
            //         while (i <= indexInList) {
            //             current = list[i];
            //             !$scope.isSelected(current) && $scope.temps.push(current);
            //             i++;
            //         }
            //         return;
            //     }
            //     if (lastSelected && list.indexOf(lastSelected) > indexInList) {
            //         $scope.temps = [];
            //         while (i >= indexInList) {
            //             current = list[i];
            //             !$scope.isSelected(current) && $scope.temps.push(current);
            //             i--;
            //         }
            //         return;
            //     }
            // }
            // if ($event && !(isRightClick) && !(isDoubleClick) && ($event.ctrlKey || $event.metaKey)) {
            //     $scope.isSelected(item) ? $scope.temps.splice(indexInTemp, 1) : $scope.temps.push(item);
            //     return;
            // }
            // $scope.temps = [item];
        };

        /**
         * Toggle checked status of the content
         *
         * @param content
         * @param event
         */
        function toggleTrueFalseCheck(field, event) {
            if (event) {
                event.stopPropagation();
            }

            if (vm.selectedContent[field]) {
                vm.selectedContent[field] = false;
            } else {
                vm.selectedContent[field] = true;
            }

            // var idx = vm.checked.indexOf(content);

            // if (idx > -1) {
            // 	vm.checked.splice(idx, 1);
            // } else {
            // 	vm.checked.push(content);
            // }
        }

        /**
         * Return checked status of the content
         *
         * @param content
         * @returns {boolean}
         */
        function isTrueFalseChecked(fieldStatus) {
            return fieldStatus ?
                true :
                false;
            // return vm.checked.indexOf(content) > -1;
        }

        /**
         * Load label
         *
         * @param name
         */
        // function loadLabel(name) {
        //     // Update the state without reloading the controller
        //     $state.go('app.users.threads', {
        //         type: 'label',
        //         filter: name
        //     }, { notify: false });

        //     // If we are already in the selected folder and
        //     // there is an open thread just close it
        //     if (vm.isLabelActive(name)) {
        //         // Close the current thread if open
        //         if (vm.currentThread) {
        //             vm.closeThread();
        //         }

        //         return;
        //     }

        //     // Show loader
        //     $rootScope.loadingProgress = true;

        //     // Build the API name
        //     var apiName = 'content.label.' + name + '@get';

        //     // Make the call
        //     msApi.request(apiName).then(
        //         // Success
        //         function (response) {
        //             // Load new threads
        //             vm.threads = response.data;

        //             // Set the current filter
        //             vm.currentFilter = {
        //                 type: 'label',
        //                 filter: name
        //             };

        //             // Close the current thread if open
        //             if (vm.currentThread) {
        //                 vm.closeThread();
        //             }

        //             // Hide loader
        //             $rootScope.loadingProgress = false;
        //         });
        // }

        /**
         * Is the folder with the given name active?
         *
         * @param name
         * @returns {boolean}
         */
        function isFolderActive(name) {
            return (vm.currentFilter.type === null && vm.currentFilter.filter === name);
        }

        /**
         * Is the label with the given name active?
         *
         * @param name
         * @returns {boolean}
         */
        function isLabelActive(name) {
            return (vm.currentFilter.type === 'label' && vm.currentFilter.filter === name);
        }

        /**
         * Open thread
         *
         * @param thread
         */
        function openThread(thread, id) {
            cleanGroupsAsfield();
            // Set the read status on the thread
            // thread.read = true;
            if (vm.countriesWithStates == undefined) {
                vm.getCountriesWithStates();
            }
            if (angular.element(document.getElementById('thread-detail')).length) {
                var elem = angular.element(document.getElementById('thread-detail'));
                elem.scrollTopAnimated(0, 10);
            }
            // pagesShown = 1;
            if (thread) {
                vm.selectedContentID = thread.id_mailing_blacklisted;
            } else if (id) {
                vm.selectedContentID = id;
            }
            if (vm.selectedContentID != 'new') {
                vm.editInline = false;

                vm.loadingReadPane = true;

                var goToState = 'app.site_overview.users.user_blacklist.list.thread';



                $state.go(goToState, {
                    id: vm.selectedContentID
                }, {
                    notify: false,
                    inherit: true,
                    location: true
                });

                var options = {
                    site: $scope.siteID,
                    section: $scope.section,
                    id: vm.selectedContentID,
                    sortDir: $rootScope.sortDir,
                    sortField: $rootScope.sortField
                };

                /*
                if (angular.isUndefined(vm.tags) || vm.tags === null) {
                    contentService.getTags(options).then(function (response) {
                        vm.tags = angular.copy(response.tags);
                    });
                }*/
                usersBlacklistService.getUserByID(options).then(function (response) {
                    //vm.selectedContent = angular.copy(response);
                    vm.currentThread = JSON.parse(angular.toJson(response));
                    transformUsers.DtoToUser(vm.currentThread, $scope.siteID);
                    vm.selectedContent = angular.copy(vm.currentThread);
                    // vm.updateThread(vm.currentThread);
                    vm.log = response.log;
                    refColumnStuff();
                    vm.nextPageLog = 1;
                    vm.getLogs(vm.currentThread.email, vm.nextPageLog);
                    vm.loadingReadPane = false;
                    vm.currentThread_Edit = angular.copy(vm.selectedContent);
                    getCurrentLabelsEdit();
                    getGroupsAsfield();
                    if (vm.currentTab == 'edit') {
                        viewEditInline();
                    }
                });
                usersBlacklistService.getUsersAuditTrailByID(options).then(function (response) {
                    for (var i = 0; i < response.length; i++) {
                        response[i].dateWithoutHours = moment(response[i].date).format("MMM DD");
                        response[i].action_data = JSON.parse(response[i].action_data);
                        try {
                            response[i].action_brief = JSON.parse(response[i].action_brief);
                        } catch (e) { }
                    }
                    vm.userAuditTrailEvents = response;
                })

            };
        }

        function getGroupsAsfield() {
            var ref_group_as_field = vm.refcolumns.filter(x => x.category == 'show_groups_as_field')
            if (ref_group_as_field && ref_group_as_field.length > 0) {
                for (let i = 0; i < ref_group_as_field.length; i++) {
                    const element = ref_group_as_field[i];
                    const flatgroups = getFlatGroups(element.groups_as_field, []);;
                    element.model = vm.selectedContent.groups ? vm.selectedContent.groups.filter(x => flatgroups.find(y => y.id_group == x.id_group)).map(x => x.id_group) : [];
                    markSelected(element.model, element.groups_as_field)
                }

            }
        }
        function markSelected(selected, data) {
            for (let i = 0; i < data.length; i++) {
                data[i].selected = selected.find(x => x == data[i].id_group) != undefined;
                markSelected(selected, data[i].children)
            }
        }

        function cleanGroupsAsfield() {
            if (vm.refcolumns) {
                var ref_group_as_field = vm.refcolumns.filter(x => x.category == 'show_groups_as_field')
                if (ref_group_as_field && ref_group_as_field.length > 0) {
                    for (let i = 0; i < ref_group_as_field.length; i++) {
                        const element = ref_group_as_field[i];
                        element.model = [];
                    }
                }
            }
        }

        function getGroupNames(field) {
            if (!field.groups_as_field){
                return '';
            }
            if (Array.isArray(field.model)) {
                var groups = field.groups_as_field.filter(x => field.model.find(y => y == x.id_group))
                var result = '';
                for (let i = 0; i < groups.length; i++) {
                    result += groups[i].text;
                    if (i < (groups.length - 1)) {
                        result += ', '
                    }
                }
                return result.trim();
            } else {
                var found = field.groups_as_field.find(x => x.id_group === field.model);
                return found ? found.text.trim() : '';
            }

        }
        function getLogs(email, page) {
            vm.loadingLogsReadPane = true;
            mailingService.getLogByUser({
                site: $scope.siteID,
                email: email,
                page: page,
                resultsPerPage: 250
            }).then(function (response) {
                vm.pagination_total_log_pages = response.last_page;
                vm.pagination_log_page = response.current_page;
                if (vm.nextPageLog > 1) {
                    vm.logs = vm.logs.concat(response.data)
                } else {
                    vm.logs = response.data;
                }
                vm.loadingLogsReadPane = false;
                vm.nextPageLog++;
            });
        }

        function refColumnStuff() {
            for (var i = vm.refcolumns.length - 1; i >= 0; i--) {

                if (vm.refcolumns[i].category == 'json') {
                    var value = '';
                    if (vm.selectedContent.user_params && vm.selectedContent.user_params != 'null') {
                        if (typeof vm.selectedContent.user_params == 'string') {
                            var userParamsObj = JSON.parse(vm.selectedContent.user_params);
                        } else if (typeof vm.selectedContent.user_params == 'object') {
                            var userParamsObj = vm.selectedContent.user_params;
                        }
                        if (userParamsObj && userParamsObj.hasOwnProperty(vm.refcolumns[i].title)) {
                            value = userParamsObj[vm.refcolumns[i].title];
                        }
                    }
                    vm.selectedContent[vm.refcolumns[i].title] = value;
                }

                if (vm.refcolumns[i].type) {
                    if (vm.refcolumns[i].type.substr(0, 8) == 'datetime') {

                        var value = vm.selectedContent[vm.refcolumns[i].title];
                        if (value == '0000-00-00 00:00:00') {
                            value = moment().format("YYYY-MM-DD");
                        }

                        var utcDate = moment.utc(value);

                        var siteDate = moment.utc(value).tz(sessionService.site_operative.timezone);

                        vm.selectedContent[vm.refcolumns[i].title] = {};
                        vm.selectedContent[vm.refcolumns[i].title]['value'] = value;
                        vm.selectedContent[vm.refcolumns[i].title]['date'] = new Date(siteDate.format());
                        vm.selectedContent[vm.refcolumns[i].title]['dateShow'] = siteDate.format(vm.dateTimeFormat);
                        vm.selectedContent[vm.refcolumns[i].title]['utcShow'] = utcDate.format(vm.dateTimeFormat);
                        vm.selectedContent[vm.refcolumns[i].title]['utcDate'] = utcDate;
                    } else if (vm.refcolumns[i].type.substr(0, 4) == 'date') {
                        var format = "YYYY-MM-DD";
                        if (vm.refcolumns[i].type.split('-')[1]) {
                            format = vm.refcolumns[i].type.split('-')[1];
                        }
                        vm.selectedContent[vm.refcolumns[i].title] = moment.utc(vm.selectedContent[vm.refcolumns[i].title]).tz(sessionService.site_operative.timezone).format(format);
                    } else if (vm.refcolumns[i].type == 'state') {
                        if (vm.selectedContent.country) {
                            vm.getStatesByCountry(vm.selectedContent.country);

                        }
                    } else if (vm.refcolumns[i].type == 'files') {
                        if (vm.selectedContent.files) {
                            if (typeof vm.selectedContent.files === 'string') {
                                vm.selectedContent.files = JSON.parse(vm.selectedContent.files);
                            }
                        }
                    } else if (vm.refcolumns[i].type == 'mailing_priority'){
                        vm.mailingPriority = vm.refcolumns[i].raw_settings.values;
                    }
                }
                if (vm.refcolumns[i].category == 'show_groups_inprofile') {
                    if (typeof vm.refcolumns[i].title === 'string') {
                        vm.refcolumns[i].title = JSON.parse(vm.refcolumns[i].title)
                    }
                    vm.refcolumns[i].groups = getByType(angular.copy(vm.CleanUsersGroups), vm.refcolumns[i].title);
                }
            }
            vm.selectedContent_ref = vm.refcolumns;
            //TODO move to utils directive
            for (var i = 0; i < vm.refcolumns.length; i++) {
                var ref = vm.refcolumns[i];
                ref.preview_sort = parseInt(ref.preview_sort);
            }
            vm.selectedContent_refgrouped = _.groupBy(vm.refcolumns, function (m) {
                return m.preview_position;
            });
        }

        function deleteThread() {
            $mdDialog.show({
                controller: 'DeleteBlacklistUsersDialogController',
                controllerAs: 'vm',
                locals: {
                    selectedThreads: vm.selectedThreads,
                    section: $scope.section,
                    siteID: $scope.siteID,
                },
                templateUrl: 'app/main/apps/users/users-blacklist/dialogs/delete-users.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
            }).then(function (deleted) {
                if (deleted) {
                    vm.selectedContentID = '';
                    vm.closeThreadEdit();
                    vm.loadingReadPane = false;
                    vm.selectedContent = undefined;
                    vm.deselectThreads();
                    $rootScope.pagination_resetquery();
                }
            });
        }

        /**
         * New thread
         *
         */
        function newThread() {
            cleanGroupsAsfield();
            if (angular.element(document.getElementById('thread-detail')).length) {
                var elem = angular.element(document.getElementById('thread-detail'));
                elem.scrollTopAnimated(0, 10);
            }

            vm.selectedContentID = '';
            vm.editInline = false;
            vm.loadingReadPane = true;

            $state.go('app.site_overview.users.user_blacklist.list.thread', {
                id: ''
            }, {
                notify: false,
                inherit: true,
                location: true
            });

            vm.currentThread = '';
            vm.log = [];

            vm.selectedContent = {};
            refColumnStuff();
            vm.loadingReadPane = false;
            vm.viewEditInline();
            
            /*
            contentService.getNew(options).then(function (response) {
                vm.selectedContent = {
                    Thumbnail: []
                };
                vm.currentThread = '';
                vm.log = [];

                for (var i = response.ref.length - 1; i >= 0; i--) {
                    if (response.ref[i].type.substr(0, 4) == 'date') {
                        var value = moment().format("YYYY-MM-DD HH:mm:00");

                        var utcDate = moment.utc(value);

                        var siteDate = moment.utc(value).tz(sessionService.site_operative.timezone);

                        vm.selectedContent[response.ref[i].title] = {};
                        vm.selectedContent[response.ref[i].title]['value'] = value;
                        vm.selectedContent[response.ref[i].title]['date'] = new Date(siteDate.format());
                        vm.selectedContent[response.ref[i].title]['dateShow'] = siteDate.format(vm.dateTimeFormat);
                        vm.selectedContent[response.ref[i].title]['utcShow'] = utcDate.format(vm.dateTimeFormat);
                        vm.selectedContent[response.ref[i].title]['utcDate'] = utcDate;
                    }
                }
                vm.selectedContent_ref = response.ref;
                vm.selectedContent_refgrouped = _.groupBy(response.ref, function (m) {
                    return m.preview_position;
                });
                ;

                vm.loadingReadPane = false;
                vm.viewEditInline();
            });*/
        }

        /**
         * Close thread Edit
         */
        function closeThreadEdit() {
            resetScroll();
            vm.editInline = false;
            vm.selectedContent = false;
            vm.currentThread_Edit = false;
            vm.currentThread_ref = false;
            vm.currentThread = false;
            if (vm.selectedContentID === '') {
                vm.closeThread();
            }
        }

        function closeUsers() {
            vm.threads = [];
            vm.selectedContent = false;
            $state.go('app.site_overview.users.user_blacklist.groups', {
                type: vm.currentFilter.type,
                filter: vm.currentFilter.filter
            }, { notify: false });
        }

        /**
         * Close thread
         */
        function closeThread() {
            vm.currentThread = null;
            vm.selectedContent = null;
            vm.selectedContentID = null;
            vm.userAuditTrailEvents = null;
            cleanGroupsAsfield();

            // Update the state without reloading the controller
            $state.go('app.site_overview.users.user_blacklist.list', {
                type: vm.currentFilter.type,
                filter: vm.currentFilter.filter
            }, { notify: false });
        }

        /**
         * Add label chips
         *
         * @param query
         * @returns {filterFn}
         */
        function labelQuerySearch(query) {
            return query ?
                vm.users.filter(vm.createFilterFor(query)) : [];
        }

        /**
         * Filter for chips
         *
         * @param query
         * @returns {filterFn}
         */
        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(item) {
                if (angular.isUndefined(item.user_name))
                    return false;
                if (!angular.lowercase(item.user_name).indexOf)
                    return false;
                return angular.lowercase(item.user_name).indexOf(lowercaseQuery) >= 0;
            };
        }

        function duplicateUser() {
            for (var i = 0; i < vm.selectedThreads.length; i++) {
                vm.selectedThreads[i].id_user = '';
                delete vm.selectedThreads[i].created_at;
                vm.selectedThreads[i].firstname = vm.selectedThreads[i].firstname + ' Copy';
                saveItem(vm.selectedThreads[i]);
            }
            deselectThreads();
        }

        /**
         * Return checked status of the content
         *
         * @param content
         * @returns {boolean}
         */
        function saveItem(content) {
            var newContent = angular.copy(content);
            
            if (!newContent.id_user) {
                newContent.id_user = '';
            }

            var userParamsObj = {};
            if (vm.selectedContent.user_params) {
                if(typeof vm.selectedContent.user_params != 'object'){
                    var userParamsObj = JSON.parse(vm.selectedContent.user_params);
                    if(typeof userParamsObj != 'object'){
                        var userParamsObj = JSON.parse(userParamsObj);
                    }
                }else{
                    var userParamsObj = vm.selectedContent.user_params;
                }
                if (userParamsObj == null) {
                    userParamsObj = {};
                }
                userParamsObj.usersGroups = {};
                if(newContent.groups && angular.isArray(newContent.groups) && newContent.groups.length > 0){
                    for(var i=0; i<newContent.groups.length; i++){
                        var id_group = newContent.groups[i].id_group;
                        var id_ingroup_status = newContent.groups[i].users_ingroup.id_ingroup_status;
                        userParamsObj.usersGroups[id_group] = id_ingroup_status;
                    }
                }
            }
            for (var i = vm.refcolumns.length - 1; i >= 0; i--) {
                if (vm.refcolumns[i].category == 'json') {
                    if (newContent.hasOwnProperty(vm.refcolumns[i].title)) {
                        userParamsObj[vm.refcolumns[i].title] = newContent[vm.refcolumns[i].title];
                        newContent.user_params = JSON.stringify(userParamsObj);
                        delete newContent[vm.refcolumns[i].title];
                    }
                }
            }
            let selGroup = null;
            if (vm.selectedGroup) {
                selGroup = angular.copy(vm.selectedGroup);
            }
            if (vm.isAccreditations && angular.isArray(vm.selectedGroupsAcc) && vm.selectedGroupsAcc.length > 0) {
                selGroup = angular.copy(vm.selectedGroupsAcc[0]);
            }

            // Automatically add new users to selected group.
            if (selGroup && newContent.id_user == '') {
                var selectedGroupItem = {
                    users_ingroup: {
                        id_user: content.id_user,
                        id_group: selGroup.id_group,
                        id_ingroup_status: selGroup.default_ingroup_status
                    }
                };
                if (newContent.groups && angular.isArray(newContent.groups)) {
                    var containsSelectedGroup = newContent.groups.find(function(userGroup) {
                        return userGroup.id_group == selGroup.id_group;
                    })
                    if (!containsSelectedGroup) {
                        newContent.groups.push(selectedGroupItem)
                    }
                } else {
                    newContent.groups = [selectedGroupItem];
                }
            }
            if(newContent.mailing_priority != vm.selectedContent.mailing_priority){
                var currentPriority = vm.mailingPriority.find(x => x.default == vm.selectedContent.mailing_priority);
                var newPriority = vm.mailingPriority.find(x => x.default == newContent.mailing_priority);
                if(!currentPriority && ( vm.selectedContent.mailing_priority <= newPriority.max && vm.selectedContent.mailing_priority >= newPriority.min)){
                    newContent.mailing_priority = vm.selectedContent.mailing_priority;
                }
            }
            var options = {
                site: $scope.siteID,
                id: content.id_user,
                item: transformUsers.userToDTO(newContent)
            };
            usersBlacklistService.saveItem(options).then(function (response) {
                updateGrouopsAsField(response.id_user);
                if (content.id_user === '' || content.id_user === undefined) {
                    content.id_user = response.id_user;
                    deselectThreads();
                    $rootScope.pagination_resetquery();
                    vm.viewPreview();
                    vm.openThread(response);
                } else {
                    vm.viewPreview();
                    vm.openThread(response);
                }
                vm.closeThreadEdit();

                var message = $translate.instant('USERS.SAVED');
                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                    hideDelay: 5000,
                    position: 'top',
                    parent: '#content-container'
                });

                return true;
            }, function(error) {
                if (error.detail && error.detail === 'The email has already been taken.') {
                    msUtils.showError($translate.instant('USERS.ERRORS.EMAIL_EXISTS'));
                }
            });

        }
        function findInTree(tree, id) {
            var result = tree.find(x => x.id_group == id);
            if (!result) {
                for (let i = 0; i < tree.length; i++) {
                    result = findInTree(tree[i].children, id);
                    if (result) {
                        return result;
                    }
                }
            }
            return result;
        }

        function updateGrouopsAsField(id_user) {
            var groupsToAdd = [];
            var groupsToRemove = [];
            var ref_group_as_field = vm.currentThread_ref.filter(x => x.category == 'show_groups_as_field');
            if (ref_group_as_field && ref_group_as_field.length > 0) {
                for (let i = 0; i < ref_group_as_field.length; i++) {
                    const element = ref_group_as_field[i];
                    for (let j = 0; j < element.model.length; j++) {
                        const element2 = element.model[j];
                        var found = vm.selectedContent.groups ? vm.selectedContent.groups.find(x => x.id_group == element2) : null;
                        if (!found) {
                            var group = findInTree(element.groups_as_field, element2);
                            groupsToAdd.push({ id_group: group.id_group });
                        }
                    }
                    var groupsSelection = getFlatGroups(vm.allGroups.filter(x => element.groups_as_field.find(y => y.id_group == x.id_group)), []);
                    for (let i = 0; i < groupsSelection.length; i++) {
                        const element2 = groupsSelection[i];
                        var found = element.model.find(x => x == element2.id_group);
                        var foundInUser = vm.selectedContent.groups ? vm.selectedContent.groups.find(x => x.id_group == element2.id_group) : null;
                        if (!found && foundInUser) {
                            var group = findInTree(element.groups_as_field, element2.id_group);
                            groupsToRemove.push({ id_group: group.id_group });
                        }
                    }

                }
            }
            if (groupsToAdd.length > 0) {
                addGroup(id_user, groupsToAdd, false);
            }
            if (groupsToRemove.length > 0) {
                for (let i = 0; i < groupsToRemove.length; i++) {
                    removeGroup(groupsToRemove[i].id_group, vm.selectedContent.id_user);
                }
            }
        }

        /**
         * Return checked status of the content
         *
         * @param content
         * @returns {boolean}
         */
        function massActions(action) {

            if (vm.selectedThreads.length === 0) return false;
            var selectedIds = [];

            for (var i = 0; i < vm.selectedThreads.length; i++) {
                selectedIds.push(vm.selectedThreads[i].id);
            }
            switch (action) {
                case 'delete':
                    if (selectedIds.length == 1) {
                        var messageConfirm = $translate.instant('CONTENT.SURE_DELETED_SINGULAR');

                        var confirm = $mdDialog.confirm().title(messageConfirm).htmlContent('<b>This item will be deleted</b>.')
                            // .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' will be deleted.')
                            .ariaLabel('Delete item').targetEvent(event).ok('OK').cancel('CANCEL');
                        var message = $translate.instant('CONTENT.DELETED');
                    } else {
                        var messageConfirm = $translate.instant('CONTENT.SURE_DELETED_PLURAL');

                        var confirm = $mdDialog.confirm().title(messageConfirm).htmlContent('<b>This items will be deleted</b>.')
                            // .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' will be deleted.')
                            .ariaLabel('Delete item').targetEvent(event).ok('OK').cancel('CANCEL');
                        var message = $translate.instant('CONTENT.DELETED');
                    }
                    break;
                case 'duplicate':
                    if (selectedIds.length == 1) {
                        var confirm = $mdDialog.confirm().title(messageConfirm).htmlContent('<b>This item will be duplicated</b>.')
                            // .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' will be deleted.')
                            .ariaLabel('Duplicate item').targetEvent(event).ok('OK').cancel('CANCEL');
                        var message = $translate.instant('CONTENT.DUPLICATED');
                    } else {
                        var confirm = $mdDialog.confirm().title(messageConfirm).htmlContent('<b>This items will be duplicated</b>.')
                            // .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' will be deleted.')
                            .ariaLabel('Duplicate item').targetEvent(event).ok('OK').cancel('CANCEL');
                        var message = $translate.instant('CONTENT.DUPLICATED');
                    }
                    break;
            }


            
            $mdDialog.show(confirm).then(function () {

                var options = {
                    site   : $scope.siteID,
                    section: $scope.section,
                    action : action,
                    item   : selectedIds
                };

                usersBlacklistService.massActions(options).then(function (response) {
                    vm.toggleSelectThreads();
                    $rootScope.pagination_resetquery();
                    vm.closeThread();
                    $mdToast.show({
                        template : '<md-toast id="language-message"><span class="md-toast-text" flex>' + message + '</span><md-button ng-click="closeToast()">X</md-button></md-toast>',
                        hideDelay: 7000,
                        position : 'top right',
                        parent   : '#main'
                    });
                });
            });

        }

        $scope.closeToast = function () {
            if (isDlgOpen)
                return;

            $mdToast.hide().then(function () {
                isDlgOpen = false;
            });
        };

        /**
         * Return selected status of the thread
         *
         * @param thread
         * @returns {boolean}
         */
        /*function isSelected(thread) {
            return vm.selectedThreads.indexOf(thread) > -1;
        }*/
        function isSelected(thread) {
            return sharedFunctionsMailing.isSelected(vm.selectedThreads, thread);
        }

        /**
         * Toggle selected status of the thread
         *
         * @param thread
         * @param event
         */
        /*function toggleSelectThread(thread, event) {
            if (event) {
                event.stopPropagation();
            }

            if (vm.selectedThreads.indexOf(thread) > -1) {
                vm.selectedThreads.splice(vm.selectedThreads.indexOf(thread), 1);
            } else {
                vm.selectedThreads.push(thread);
            }
        }*/
        function toggleSelectThread(thread, event) {
            vm.selectedThreads = sharedFunctionsMailing.toggleSelectThread(vm.selectedThreads, thread, event);
        }

        /**
         * Select threads. If key/value pair given,
         * threads will be tested against them.
         *
         * @param [key]
         * @param [value]
         */
        function selectThreads(key, value) {

            // Make sure the current selection is cleared
            // before trying to select new threads
            vm.selectedThreads = [];

            for (var i = 0; i < vm.threads.length; i++) {
                if (angular.isUndefined(key) && angular.isUndefined(value)) {
                    vm.selectedThreads.push(vm.threads[i]);
                    continue;
                }

                if (angular.isDefined(key) && angular.isDefined(value) && vm.threads[i][key] === value) {
                    vm.selectedThreads.push(vm.threads[i]);
                }
            }
        }

        function toggleSelectGroups() {
            vm.selectedGroups = sharedFunctionsMailing.toggleSelectThreads(vm.selectedGroups, vm.groups);
            if (vm.selectedGroups == []) {
                ivhTreeviewMgr.selectAll(vm.CleanUsersGroups);
                vm.selectedGroups = vm.CleanUsersGroups;
            } else {
                ivhTreeviewMgr.deselectAll(vm.CleanUsersGroups);
                vm.selectedGroups = [];
            }
        }

        function toggleSelectGroup(group, event) {
            if (vm.selectedGroups) {
                vm.selectedGroups = sharedFunctionsMailing.toggleSelectThread(vm.selectedGroups, group, event);
            }
        }

        function selectGroups(key, value) {
            // Make sure the current selection is cleared
            // before trying to select new threads
            vm.selectedGroups = [];

            for (var i = 0; i < vm.threads.length; i++) {
                if (angular.isUndefined(key) && angular.isUndefined(value)) {
                    vm.selectedGroups.push(vm.threads[i]);
                    continue;
                }

                if (angular.isDefined(key) && angular.isDefined(value) && vm.threads[i][key] === value) {
                    vm.selectedGroups.push(vm.threads[i]);
                }
            }
        }

        /**
         * Deselect threads
         */
        function updateThread(itemThread) {
            for (var i = 0; i < vm.threads.length; i++) {
                if (vm.threads[i]['id_user'] == itemThread['id_user']) {
                    vm.threads[i] = itemThread;
                }
                // if (angular.isUndefined(key) && angular.isUndefined(value)) {
                // 	vm.selectedThreads.push(vm.threads[i]);
                // 	continue;
                // }

                // if (angular.isDefined(key) && angular.isDefined(value) && vm.threads[i][key] === value) {
                // 	vm.selectedThreads.push(vm.threads[i]);
                // }
            }
        }

        /**
         * Deselect threads
         */
        /*function deselectThreads() {
            vm.selectedThreads = [];
        }*/
        function deselectThreads() {
            vm.selectedThreads = sharedFunctionsMailing.deselectThreads();
        }

        /**
         * Toggle select threads
         */
        function toggleSelectThreads() {
            if (vm.selectedThreads.length > 0) {
                vm.deselectThreads();
            } else {
                vm.selectThreads();
            }
        }
        function toggleSelectThreads() {
            vm.selectedThreads = sharedFunctionsMailing.toggleSelectThreads(vm.selectedThreads, vm.threads);
        }

        function toggleSelectAllThreads() {

        }

        /**
         * Set the status on given thread, current thread or selected threads
         *
         * @param key
         * @param value
         * @param [thread]
         * @param [event]
         */
        function setThreadStatus(key, value, thread, event) {
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if (event) {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if (thread) {
                thread[key] = value;
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if (vm.currentThread) {
                vm.currentThread[key] = value;
                return;
            }

            // Otherwise do the status update on selected threads
            for (var x = 0; x < vm.selectedThreads.length; x++) {
                vm.selectedThreads[x][key] = value;
            }
        }

        /**
         * Toggle the value of the given key on given thread, current
         * thread or selected threads. Given key value must be boolean.
         *
         * @param key
         * @param thread
         * @param event
         */
        function toggleItemStatus(thread, event, key) {

            event.stopPropagation();

            var confirm = $mdDialog.confirm().title('Are you sure want to set the item?').htmlContent('<b>This item will be changed </b>.')
                // .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' will be deleted.')
                .ariaLabel('change item').targetEvent(event).ok('OK').cancel('CANCEL');

            $mdDialog.show(confirm).then(function () {

                switch (thread.status) {
                    case 0:
                        thread.status = 1;
                        break;
                    case 1:
                        thread.status = 2;
                        break;
                    case 2:
                        thread.status = 99;
                        break;
                    case 99:
                        thread.status = 0;
                        break;
                    default:
                        thread.status = 0;
                        break;
                }


                var options = {
                    site: $scope.siteID,
                    id: thread.id_user,
                    item: transformUsers.userToDTO(thread)
                };


                usersBlacklistService.saveItem(options).then(function (response) {
                    // vm.viewPreview();
                    // vm.selectContent(content);
                    var message = "Saved";

                    $mdToast.show({
                        template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                        hideDelay: 5000,
                        position: 'top',
                        parent: '#content-container'
                    });

                    return true;
                });

            }, function () {
                // alert("cancel")

            });

            return;
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if (event) {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if (thread) {
                if (typeof (thread[key]) !== 'boolean') {
                    return;
                }

                thread[key] = !thread[key];
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if (vm.currentThread) {
                if (typeof (vm.currentThread[key]) !== 'boolean') {
                    return;
                }

                vm.currentThread[key] = !vm.currentThread[key];
                return;
            }

            // Otherwise do the status update on selected threads
            for (var x = 0; x < vm.selectedThreads.length; x++) {
                if (typeof (vm.selectedThreads[x][key]) !== 'boolean') {
                    continue;
                }

                vm.selectedThreads[x][key] = !vm.selectedThreads[x][key];
            }
        }

        /**
         * Toggle the value of the given key on given thread, current
         * thread or selected threads. Given key value must be boolean.
         *
         * @param key
         * @param thread
         * @param event
         */
        function toggleItemStatusEdit(fieldName) {

            event.stopPropagation();
            var thread = vm.currentThread_Edit[fieldName];
            thread = (thread === 1) ?
                0 :
                1;

            vm.currentThread_Edit[fieldName] = thread;
            vm.basicForm.$setDirty()
        }

        function deleteAttachment(attachment) {

            if (attachment.id_zone) {
                for (var i = 0; i < vm.currentThread_Edit.Thumbnail.length; i++) {
                    if (vm.currentThread_Edit.Thumbnail[i].id_media === attachment.id_media && vm.currentThread_Edit.Thumbnail[i].id_zone === attachment.id_zone) {
                        if (angular.isUndefined(vm.currentThread_Edit.ThumbnailRemove))
                            vm.currentThread_Edit.ThumbnailRemove = [];
                        vm.currentThread_Edit.ThumbnailRemove.push(vm.currentThread_Edit.Thumbnail[i]);
                        vm.currentThread_Edit.Thumbnail.splice(i, 1);
                    }
                }

                for (var i = 0; i < vm.thumbnails_Edit[attachment.id_zone].length; i++) {
                    if (vm.thumbnails_Edit[attachment.id_zone][i].id_media === attachment.id_media) {
                        vm.thumbnails_Edit[attachment.id_zone].splice(i, 1);
                    }
                }

            } else {
                if (vm.currentThread_Edit.Thumbnail[i].id_media === attachment.id_media) {
                    if (angular.isUndefined(vm.currentThread_Edit.ThumbnailRemove))
                        vm.currentThread_Edit.ThumbnailRemove = [];
                    vm.currentThread_Edit.ThumbnailRemove.push(vm.currentThread_Edit.Thumbnail[i]);
                    vm.currentThread_Edit.Thumbnail.splice(i, 1);
                }
            }
            vm.basicForm.$setDirty()

        }

        /**
         * Toggle the value of the given key on given thread, current
         * thread or selected threads. Given key value must be boolean.
         *
         * @param key
         * @param thread
         * @param event
         */
        function toggleThreadStatus(key, thread, event) {
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if (event) {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if (thread) {
                if (typeof (thread[key]) !== 'boolean') {
                    return;
                }

                thread[key] = !thread[key];
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if (vm.currentThread) {
                if (typeof (vm.currentThread[key]) !== 'boolean') {
                    return;
                }

                vm.currentThread[key] = !vm.currentThread[key];
                return;
            }

            // Otherwise do the status update on selected threads
            for (var x = 0; x < vm.selectedThreads.length; x++) {
                if (typeof (vm.selectedThreads[x][key]) !== 'boolean') {
                    continue;
                }

                vm.selectedThreads[x][key] = !vm.selectedThreads[x][key];
            }
        }

        /**
         * Get label object content
         *
         * @param id
         * @returns {*}
         */
        function getLabel(id) {
            for (var i = 0; i < vm.labels.length; i++) {
                if (vm.labels[i].id === id) {
                    return vm.labels[i];
                }
            }
        }

        /**
         * Get label color from label object
         *
         * @param id
         * @returns {*}
         */
        function getLabelColor(id) {
            return vm.getLabel(id).color;
        }

        /**
         * Get label title from label object
         *
         * @param id
         * @returns {*}
         */
        function getLabelTitle(id) {
            return vm.getLabel(id).title;
        }

        /**
         * Toggle label
         *
         * @param label
         */
        function toggleLabel(label) {
            // Toggle label on the currently open thread
            if (vm.currentThread) {
                if (vm.currentThread.labels.indexOf(label.id) > -1) {
                    vm.currentThread.labels.splice(vm.currentThread.labels.indexOf(label.id), 1);
                } else {
                    vm.currentThread.labels.push(label.id);
                }

                return;
            }

            // Toggle labels on selected threads
            // Toggle action will be determined by the first thread from the selection.
            if (vm.selectedThreads.length > 0) {
                // Decide if we are going to remove or add labels
                var removeLabels = (vm.selectedThreads[0].labels.indexOf(label.id) > -1);

                for (var i = 0; i < vm.selectedThreads.length; i++) {
                    if (!removeLabels) {
                        vm.selectedThreads[i].labels.push(label.id);
                        continue;
                    }

                    if (vm.selectedThreads[i].labels.indexOf(label.id) > -1) {
                        vm.selectedThreads[i].labels.splice(vm.selectedThreads[i].labels.indexOf(label.id), 1);
                    }
                }
            }
        }

        /**
         * Is label exist?
         *
         * @param label
         * @returns {boolean}
         */
        function isLabelExist(label) {
            if (vm.currentThread && vm.currentThread.labels) {
                return (vm.currentThread.labels.indexOf(label.id) > -1);
            }
        }

        /**
         * Change the view
         *
         * @param view
         */
        function changeView(view) {
            if (vm.views[view]) {
                settingUserService.setSetting(vm.settingsSection, 'defaultView', view)
                vm.loadingView = true;
                vm.defaultView = view;
                vm.currentView = view;
                vm.closeThread();
                vm.closeThreadEdit();

            }
        }

        function orderRefFields() {
            var header = [];
            var main = [];
            var secondary = [];

            for (var i = 0; i < vm.currentThread_ref.length; i++) {
                if (vm.currentThread_ref[i].edit_position === 'header') {
                    header.push(vm.currentThread_ref[i]);
                } else if (vm.currentThread_ref[i].edit_position === 'main') {
                    main.push(vm.currentThread_ref[i]);
                } else if (vm.currentThread_ref[i].edit_position === 'secondary') {
                    secondary.push(vm.currentThread_ref[i]);
                }
            }


            header.sort(function (a, b) {
                return (a.edit_sort - b.edit_sort);
            });

            main.sort(function (a, b) {
                return (a.edit_sort - b.edit_sort);
            });

            secondary.sort(function (a, b) {
                return (a.edit_sort - b.edit_sort);
            });

            vm.currentThread_ref = [];

            for (var i = 0; i < header.length; i++) {
                vm.currentThread_ref.push(header[i]);
            }
            for (var i = 0; i < main.length; i++) {
                vm.currentThread_ref.push(main[i]);
            }
            for (var i = 0; i < secondary.length; i++) {
                vm.currentThread_ref.push(secondary[i]);
            }
        }

        /**
         * Toggle view Edit
         */
        function viewEditInline() {
            resetScroll();
            vm.currentTab = 'edit';
            if (!vm.editInline) {
                vm.editInline = true;
                vm.currentThread_Edit = angular.copy(vm.selectedContent);
                getCurrentLabelsEdit();
                if (vm.selectedContent_ref) {
                    vm.currentThread_ref = angular.copy(vm.selectedContent_ref);
                    orderRefFields();
                }
                angular.forEach(vm.selectedContent_ref, function (refColumn) {
                    switch (refColumn.type) {
                        case 'date':
                        case 'dateHm':
                            var type = 'input';
                            break;
                        case 'single':
                            var type = 'input';
                            break;
                        default:
                            break;
                    }
                });
                if (vm.countriesWithStates == undefined) {
                    getCountriesWithStates();
                }
            }
        }

        /**
         * Toggle view Edit
         */
        function viewPreview() {
            resetScroll();
            vm.editInline = false;
            vm.currentTab = 'preview';
        }

        function resetScroll() {
            if (angular.element(document.getElementById('thread-detail')).length) {
                var elem = angular.element(document.getElementById('thread-detail'));
                elem.scrollTopAnimated(0, 10);
            }
        }

        /**
         * Open compose dialog
         *
         * @param ev
         */

        function composeDialog(ev) {
            $mdDialog.show({
                controller: 'ComposeDialogController',
                controllerAs: 'vm',
                locals: {
                    selectedContent: undefined
                },
                templateUrl: 'app/main/dialogs/compose/compose-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        }

        /**
         * Open Image dialog
         *
         * @param ev
         * @param task
         */
        function openImageDialog(ev, images, ImageSelected) {
            $mdDialog.show({
                controller: 'MediaShowDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/dialogs/media-show/media-show-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Images: images,
                    ImageSelected: ImageSelected,
                    cropFormats: false,
                    MediaFull: false,
                    Tags: false,
                    // Tasks: vm.tasks,
                    // event: ev
                }
            });
        }

        /**
         * Open Image dialog
         *
         * @param ev
         * @param task
         */
        function openFocalPoint(ev, ImageSelected) {
            $mdDialog.show({
                controller: 'MediaFocalPointDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/dialogs/media-focal-point/media-focal-point-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    ImageSelected: ImageSelected,
                }
            }).then(function (item) {
                vm.basicForm.$setDirty()
                angular.forEach(vm.mediaZones, function (mediazone) {
                    angular.forEach(vm.thumbnails_Edit[mediazone.id_zone], function (attachment) {
                        if (item.id_media === attachment.id_media) {
                            attachment.imageCenterRatioX = item.imageCenterRatioX;
                            attachment.imageCenterRatioY = item.imageCenterRatioY;
                        }
                    })
                })
            });
        }

        /**
         * Open compose dialog
         *
         * @param ev
         */


        /**
         * Open TinyMCE media selector
         *
         * @param item
         */

        function mediaDialogTiny(item) {
            $mdDialog.show({
                controller: 'MediaDialogController',
                controllerAs: 'vm',
                locals: {
                    autoUpload: '',
                    currentThread: item,
                    section: $scope.section,
                    mediazone: 1,
                    isTiny: 1,
                    maxAttach: undefined,
                    showViews: {
                        1: true,
                        2: true,
                        3: true,
                        4: true,
                        5: true,
                        upload: true,
                        import: true
                    }
                },
                templateUrl: 'app/main/dialogs/media/media-dialog-tinymce.html',
                parent: angular.element($document.body),
                clickOutsideToClose: true
            }).then(function (item) {

                /*
                                vm.currentThread_Edit = item;

                                vm.basicForm.$setDirty()
                                vm.thumbnails_Edit = {};
                                angular.forEach(vm.mediaZones, function (mz) {
                                    if (angular.isUndefined(vm.thumbnails_Edit[mz.id_zone])) {
                                        vm.thumbnails_Edit[mz.id_zone] = [];
                                    }
                                })
                                angular.forEach(vm.currentThread_Edit.Thumbnail, function (thumb) {
                                    vm.thumbnails_Edit[thumb.id_zone].push(thumb);
                                })
                */
            });
        }


        function openGroupDialog(ev, group) {

            var groupType = undefined;
            if (angular.isDefined(vm.userGroupTypes)) {
                groupType = vm.userGroupTypes.find(function(groupType) {
                    return groupType.id_group_type == group.id_group_type;
                })
            }
            $mdDialog.show({
                controller: 'EditGroupDialogController',
                controllerAs: 'vm',
                locals: {
                    group: group,
                    siteID: $scope.siteID,
                    groupType: groupType,
                    currentGroupTypeId: vm.currentGroupTypeId,
                    hasAdvancedSettingsAccess: vm.hasAdvancedSettingsAccess
                    //nestedGroups:
                },
                templateUrl: 'app/main/apps/users/dialogs/groups/edit-group.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
            }).then(function (res) {
                if (res) {
                    getCleanUsersGroup();
                }
            });
        }

        /**
         * Open reply dialog
         *
         * @param ev
         */
        function replyDialog(ev) {
            $mdDialog.show({
                controller: 'ComposeDialogController',
                controllerAs: 'vm',
                locals: {
                    selectedContent: vm.selectedContent
                },
                templateUrl: 'app/main/dialogs/compose/compose-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        }

        function setGroupBy(field) {
            $rootScope.pagination_setSortField(field);
            vm.groupBy = field;
            settingUserService.setSetting(vm.settingsSection, 'groupByField', field)
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */

        function cancelUsersGroups(sidenavId) {
            vm.usersGroups = angular.copy(vm.copyUsersGroups);
            $mdSidenav(sidenavId).toggle();
            settingUserService.setSetting(vm.settingsSection, 'sidenavGroupsOpen', false)
        }



        function saveUsersGroups(sidenavId) {
            vm.copyUsersGroups = [];
            $mdSidenav(sidenavId).toggle();
            vm.currentLabelsFilter = transformUsers.getLabels(vm.usersGroups, []);

            if (vm.currentLabelsFilter.length > 0) {
                var array = transformUsers.getGroupsFromLabels(vm.currentLabelsFilter);
                if (array.length === 1) {
                    var copy = angular.copy(array[0]);
                    array[0] = -1;
                    array.push(copy);
                }
                var options = {
                    site: $scope.siteID,
                    section: $scope.section,
                    ids: array
                };
                // getUsersByGroups(options);
            } else {
                resetFilters();
            }
            vm.selectedContent = undefined;

        }

        // function getUsersByGroups(options) {
        //     if (vm.refcolumns) {
        //         var hasIngroupStatusTypeRef = vm.refcolumns.find(function (ref){
        //             return ref.type === 'ingroup_status';
        //         })
        //         if (hasIngroupStatusTypeRef) {
        //             vm.includeAllGroups = true;
        //             options.allGroups = vm.includeAllGroups;
        //         }
        //     }
        //     usersBlacklistService.getUsersByGroupsNoRef(options).then(function (response) {
        //         vm.threads = response.data;
        //         $rootScope.pagination_totalItems = response.total;
        //         $rootScope.pagination_total_pages = response.last_page;
        //     });
        // }

        function resetFilters() {
            vm.currentLabelsFilter = undefined;
            vm.usersGroups = transformUsers.formatNestedGroups(angular.copy(vm.refFilterables));
            $rootScope.pagination_resetquery();
        }

        function resetGroupby() {
            vm.groupBy = undefined;
            settingUserService.setSetting(vm.settingsSection, 'groupByField', null);
            $rootScope.pagination_setSortField(vm.fieldOrder ? vm.fieldOrder : 'id_user');
            $rootScope.pagination_resetquery();
        }

        function resetSortField() {
            vm.groupBy = undefined;
            vm.fieldOrder = undefined;
            settingUserService.setSetting(vm.settingsSection, 'sortField', null);
            settingUserService.setSetting(vm.settingsSection, 'groupByField', null);
            $rootScope.pagination_setSortField('id_user');
            $rootScope.pagination_resetquery();
        }




        function mediaDialog(ev, mediazone, item, type) {
            item.Thumbnail = [];

            $mdDialog.show({
                controller: 'MediaDialogController',
                controllerAs: 'vm',
                locals: {
                    autoUpload: '',
                    currentThread: item,
                    section: $scope.section,
                    mediazone: mediazone,
                    multipleSelection: false,
                    isTiny: false,
                    maxAttach: undefined,
                    showViews: {
                        1: true,
                        2: true,
                        3: true,
                        4: true,
                        5: true,
                        upload: true,
                        import: true
                    }
                },
                templateUrl: 'app/main/dialogs/media/media-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true

            }).then(function (item) {
                vm.currentThread_Edit.avatar = item.Thumbnail[0];
                vm.basicForm.$setDirty();
            });
        }

        function deleteTargetFilter(id, index) {

            vm.currentLabelsFilter.splice(index, 1);
            var groups = transformUsers.getGroupsFromLabels(vm.currentLabelsFilter);
            vm.usersGroups = transformUsers.initGroupsTree(angular.copy(vm.refFilterables), groups, vm.ingroupStatus);

            if (vm.currentLabelsFilter.length <= 0) {
                vm.currentLabelsFilter = undefined;
                $rootScope.pagination_resetquery();

            } else {

                var options = {
                    site: $scope.siteID,
                    section: $scope.section,
                    ids: arrayIds
                };
                // getUsersByGroups(options);
                vm.selectedContent = undefined;
            }

        }

        function toggleSidenav(sidenavId) {
            if (!vm.usersGroups) {
                vm.usersGroups = transformUsers.formatNestedGroups(angular.copy(vm.refFilterables));
            }
            vm.copyUsersGroups = angular.copy(vm.usersGroups);
            $mdSidenav(sidenavId).toggle();
            settingUserService.setSetting(vm.settingsSection, 'sidenavGroupsOpen', true)
        }

        function isNumber(value) {
            return angular.isNumber(value);
        }

        function hasDateShow(value) {
            if (value != null && !angular.isUndefined(value.dateShow)) {
                return value.dateShow;
            }
            return false;
        }

        function siteLanguages() {
            return sessionService.getSiteLanguages();
        }

        function getCurrentMedia() {
            return vm.currentThread_Edit.Thumbnail;
        }

        function getZoneCrop(field) {
            var cropId = '';
            if (!angular.isUndefined(field.id_cropformats)) {
                cropId = field.id_cropformats;
            }
            return cropId;
        }

        function newUser(userName) {
            var newUser = {
                id_user: '',
                user_name: userName
            }
            vm.users.push(newUser);
            vm.currentThread_Edit.users.push(newUser);
            vm.searchUserText = '';
        }


        $scope.$watch('vm.refcolumns', function (countryId) {
            if (vm.refcolumns) {
                var ref_group_as_field = vm.refcolumns.filter(x => x.category == 'show_groups_as_field')
                if (ref_group_as_field && ref_group_as_field.length > 0) {
                    for (let i = 0; i < ref_group_as_field.length; i++) {
                        const element = ref_group_as_field[i];
                        element.groups_as_field = [];
                        var found = vm.allGroups.find(x => x.id_group === JSON.parse(element.title)[0] && x.hasOwnProperty('children'));
                        if (found) {
                            element.groups_as_field = found.children.map(x => {
                                return {
                                    id_group: x.id_group,
                                    value: x.id_group,
                                    text: x.name,
                                    selected: false,
                                    children: getChildren(vm.allGroups, x.id_group)
                                }
                            });
                        }
                    }
                }
            }
        });

        function getChildren(groups, parent) {
            var result = [];
            result = groups.filter(y => y.parent === parent).map(x => {
                return {
                    id_group: x.id_group,
                    value: x.id_group,
                    text: x.name,
                    selected: false,
                    children: getChildren(groups, x.id_group)
                }
            });
            return result;
        }

        function updateModelShowGroupsAsField(data, field) {
            field.model = data.selectedValues;
        }

        $scope.$watch('vm.currentThread_Edit.country', function (countryId) {
            if (countryId) {
                getStatesByCountry(countryId);
            } else if (vm.currentThread_Edit) {
                vm.currentThread_Edit.state = "";
            }
        });

        $scope.$watch('vm.currentThread_Edit.state', function (stateId) {
            if (stateId) {
                getCitiesByState(stateId);
            } else if (vm.currentThread_Edit) {
                vm.currentThread_Edit.city = "";
            }
        });

        function getCountriesWithStates() {
            if (angular.isUndefined(vm.countriesWithStates)) {
                vm.countriesWithStates = [];
                var options = {
                    paginate: 99999,
                    resultsPerPage: 300
                };
                usersBlacklistService.getCountriesWithStates(options).then(function (response) {

                    if (response.total) {
                        angular.forEach(response.data, function (item) {
                            var resultId = item['id_country'];
                            var resultData = {
                                id: resultId,
                                code: item['code'],
                                name: item['country']
                            };
                            vm.countriesWithStates.push(resultData);
                        })
                    }
                })
            }
        }

        function getCountryById(id) {
            var country;
            angular.forEach(vm.countriesWithStates, function (item) {
                if (item.id == id) {
                    country = item;
                }
            })
            return country;
        }


        function getStatesByCountry(countryId) {

            if (angular.isDefined(countryId)) {
                vm.statesWithCities = [];
                var options = {
                    paginate: 99999,
                    resultsPerPage: 99999,
                    id_country: countryId
                };
                usersBlacklistService.getStatesWithCities(options).then(function (response) {
                    if (response.total) {
                        angular.forEach(response.data, function (item) {
                            var resultId = item['id_state'];
                            var resultData = {
                                id: resultId,
                                code: item['code'],
                                name: item['state'],
                                cities: item['cities']
                            };
                            vm.statesWithCities.push(resultData);
                            if (vm.selectedContent.state && vm.selectedContent.state == resultData.id) {
                                vm.selectedContent.related_state = resultData;
                                vm.getCitiesByState(vm.selectedContent.state);
                            }
                        })
                    }
                })
            }
        };

        function getCitiesByState(stateId) {
            if (angular.isDefined(stateId) && stateId !== '') {
                var item = ($filter('filter')(vm.statesWithCities, { id: stateId }));
                if (item && item.length > 0) {
                    vm.cities = item[0].cities;
                }
                if (vm.selectedContent.city) {
                    angular.forEach(vm.cities, function (item) {
                        if (item.id_city == vm.selectedContent.city) {
                            vm.selectedContent.related_city = item;
                        }
                    });
                }
            }
        }

        function loginToWebsite(user) {
            usersBlacklistService.getUserToken({
                siteID: $scope.siteID,
                id: user.id_user
            }).then(function (response) {
                $window.open(vm.loginUrl + response.token, 'website');
            })
        }

        function inviteToGroupPreview(user, group) {
            if (angular.isArray(group) && group.length > 0) {
                group = group[0]
            }
            usersBlacklistService.getUserToken({
                siteID: $scope.siteID,
                id: user.id_user,
                id_group: group.id_group
            }).then(function (response) {
                $window.open(vm.userInvitationUrlPreview + response.token, 'website');
            })
        }
        function inviteToGroupIndividual(user, group) {
            if (angular.isArray(group) && group.length > 0) {
                group = group[0]
            }
            usersBlacklistService.getUserToken({
                siteID: $scope.siteID,
                id: user.id_user,
                id_group: group.id_group
            }).then(function (response) {
                $window.open(vm.userInvitationUrlIndividual + response.token, 'website');
            })
        }
        function inviteToGroupMultiple(event, group) {
            if (angular.isArray(group) && group.length > 0){
                group = group[0]
            }
            var ids = [];
            angular.forEach(vm.selectedThreads, function(user){
                ids.push(user.id_user)
            })
            usersBlacklistService.getUserToken({
                siteID: $scope.siteID,
                id: 0,
                id_group: group.id_group,
                id_users: ids
            }).then(function (response) {
                $window.open(vm.userInvitationUrlMultiple + response.token, 'website');
            })
        }

        function customActionEvent(axn, event) {
          switch (axn.action) {
            case "openUrlWithTokenAndGroup":
              var group = '';
              if (!angular.isUndefined(vm.selectedGroupsAcc)) {
                group = vm.selectedGroupsAcc
              } else if (vm.selectedGroup) {
                group = vm.selectedGroup;
              }
              if (!group) {
                return;
              }
              if (angular.isArray(group) && group.length > 0) {
                group = group[0]
              }
              var ids = [];
              angular.forEach(vm.selectedThreads, function (user) {
                ids.push(user.id_user)
              })
              usersBlacklistService.getUserToken({
                siteID: $scope.siteID,
                id: 0,
                id_group: group.id_group,
                id_users: ids
              }).then(function (response) {
                $window.open(axn.url + response.token, 'website');
              })
              break;
          }
          /*
           */
        }

        function sendConversationMessage(conversationKey) {

            if (angular.isUndefined(vm.conversationMessage[conversationKey]) || vm.conversationMessage[conversationKey].length < 1) {
                return;
            }

            var currentUser = sessionService.user;
            var newMessage = {
                date_created: moment.utc().format('YYYY-MM-DD HH:mm:ss'),
                message: vm.conversationMessage[conversationKey],
                username: currentUser.first_name + " " + currentUser.last_name,
                user_id: currentUser.id_user
            }
            if (angular.isUndefined(vm.selectedContent.conversations)) {
                vm.selectedContent.conversations = {};
            }
            if (angular.isUndefined(vm.selectedContent.conversations[conversationKey])) {
                vm.selectedContent.conversations[conversationKey] = [];
            }
            vm.conversationMessage[conversationKey] = '';

            var options = {
                site: $scope.siteID,
                id: vm.selectedContent.id_user,
                messages: [newMessage],
                conversation: conversationKey,
                attach: true
            };
            usersBlacklistService.saveConversation(options).then(function (response) {
                vm.selectedContent.conversations[conversationKey].push(newMessage);

                var message = $translate.instant('USERS.COMMENT_SENT');
                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                    hideDelay: 5000,
                    position: 'top',
                    parent: '#content-container'
                });
                return true;
            });

        }

        function deleteConversationMessage(conversationKey, idx) {
            vm.selectedContent.conversations[conversationKey].splice(idx, 1);
            var options = {
                site: $scope.siteID,
                id: vm.selectedContent.id_user,
                messages: vm.selectedContent.conversations[conversationKey],
                conversation: conversationKey,
                attach: false
            };
            usersBlacklistService.saveConversation(options).then(function (response) {
                var message = $translate.instant('USERS.COMMENT_DELETED');
                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                    hideDelay: 5000,
                    position: 'top',
                    parent: '#content-container'
                });
                return true;
            });

        }

        function filterIsMainOrSecondaryTableListPosition(item) {
            return item.table_list_position == 'main' || item.table_list_position == 'secondary';
        }

        function buttonClick(event, settings, selectedUser) {
            if (settings && (settings.url || settings.url_from_field) && settings.method && settings.params) {
                vm.isSending = true;
                var params = {};
                angular.forEach(settings.params, function(param){
                    if (selectedUser[param.field]) {
                        params[param.name] = selectedUser[param.field];
                    }
                })
                var url = false;
                if (settings.url) {
                    url = settings.url;
                }
                if (settings.url_from_field) {
                    url = selectedUser[settings.url_from_field];
                }

                if (!url) {
                    vm.isSending = false;
                    return;
                }
                var config = {
                    url: url,
                    method: settings.method,
                    params: params
                }
                if (settings.open_in_browser) {
                    $window.open(url, '_blank');
                    vm.isSending = false;
                } else {
                    $http(config).then(function(response) {
                        vm.isSending = false;
                    },
                    function(error) {
                        vm.isSending = false;
                    })
                }
            }
        }
    }


    function LoadUsersByGroups(usersBlacklistService) {

        function unselectAllGroups() {
            var elemList = document.querySelectorAll('.group-row');
            elemList.forEach(function (elem) {
                elem.classList.remove('selected');
            });
        }

        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                $(element).on('click', function (e) {

                    var groupNode = false;
                    if (element.parent().hasClass('selected')) {
                        // With Qiu restriction active don't allow for unselecting groups.
                        if (scope.node.is_qiu_restricted) return;
                        unselectAllGroups();
                    } else {
                        unselectAllGroups();
                        element.parent().addClass('selected');
                        groupNode = scope.node;
                    }
                    var includeSubgroups = $('#includeSubgroups').attr("data-include-subgroups") == 'true';
                    usersBlacklistService.triggerUsersByGroups(groupNode, includeSubgroups);
                });
            }
        };
    }

    function LoadUsersByGroupsAcc(usersBlacklistService) {

        function unselectAllGroups() {
            var elemList = document.querySelectorAll('.group-row.acc');
            elemList.forEach(function (elem) {
                elem.classList.remove('selected');
            });
        }

        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                $(element).on('click', function (e) {
                    var groupNode = false;
                    if (element.parent().hasClass('selected')) {
                        unselectAllGroups();
                    } else {
                        unselectAllGroups();
                        element.parent().addClass('selected');
                        groupNode = scope.node;
                    }
                    usersBlacklistService.triggerUsersByGroupsAcc(groupNode);
                });
            }
        };
    }

    function LoadUsersByGroupsAccSub(usersBlacklistService) {

        function unselectAllGroups() {
            var elemList = document.querySelectorAll('.group-row.acc-sub');
            elemList.forEach(function (elem) {
                elem.classList.remove('selected');
            });
        }

        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                $(element).on('click', function (e) {
                    var groupNode = false;
                    if (element.parent().hasClass('selected')) {
                        unselectAllGroups();
                    } else {
                        unselectAllGroups();
                        element.parent().addClass('selected');
                        groupNode = scope.node;
                    }
                    usersBlacklistService.triggerUsersByGroupsAccSub(groupNode);
                });
            }
        };
    }

    function ToggleAssignedGroup() {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                $(element).on('click', function (e) {
                    scope.node.assigned_group = !scope.node.assigned_group;
                });
            }
        };
    }

    function SetInGroupStatus() {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                scope.$watch(attrs.ngModel, function (v) {
                    if (angular.isDefined(v)) {
                        scope.node.id_ingroup_status = v;
                    }
                });
            }
        };
    }

    function OpenGroupEditDialog(usersBlacklistService) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                $(element).on('click', function (e) {
                    var groupNode = scope.node;
                    usersBlacklistService.triggerGroupDialog(groupNode);
                });
            }
        };
    }

    function renderTinyMedia(content) { }

    function CloseSidenav(usersBlacklistService) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                $(element).on('click', function (e) {
                    usersBlacklistService.triggerCloseSidenav(attrs.sidenavId);
                });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.users')
        .service('usersBlacklistService', usersBlacklistService);

    /** @ngInject */
    // I provide access to the session store.
    function usersBlacklistService($rootScope, $q, $resource, $stateParams, settingUserService, userService, settingsDomainService, sessionService, COMMON, $window) {
        function get(options) {
            if (options.groupIds === undefined) {
                return getUsers(options);
            } else {
                return getUsersByGroups(options);
            }
        }

        function getUsers(options) {

            var deferred = $q.defer();
            
            var opts = {
                domain: options.siteID,
                page: options.page,
                search: options.searchStringFilter,
                paginate: options.paginate,
                filters: JSON.stringify(filters),
                resultsPerPage: options.resultsPerPage || 250
            };
            resourceBlacklisted.get( opts, 
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);

            var deferred = $q.defer();
            var filters = [];

            _.forEach(options, function (value, key, list) {
                if (_.isObject(list[key])) {
                    _.forEach(list[key], function (filter, keyFilter, listFilter) {
                        if (!_.isEmpty(filter.selected)) {
                            filters.push({
                                field: filter.field,
                                name: filter.name,
                                values: filter.selected
                            });
                        }

                    });

                }
            });

            var settingsSection = 'users-blacklist' + $stateParams.groupTypeName;

            var opts = {
                domain: options.siteID,
                page: options.page,
                search: options.searchStringFilter,
                paginate: options.paginate,
                sortField: settingUserService.getSettingValue(settingsSection, 'sortField', options.sortField),
                sortDir: settingUserService.getSettingValue(settingsSection, 'sortDir', options.sortDir),
                filters: JSON.stringify(filters),
                withRelatedCountry: true,
                withRelatedCity: true,
                withRelatedState: true,
                resultsPerPage: options.resultsPerPage || 250
            };

            if (options.userIds) {
                opts['id_user[]'] = options.userIds;
            }

            resourceUsers.get(opts,
                function (responseResult, headers) {
                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);
                    var ref = resourceUsersRef;
                    if ($stateParams.groupTypeId === "6") {
                        ref = resourceUSersAccreditationsRef;
                    }

                    ref.get({
                        domain: options.siteID,
                        page: options.page,
                        search: options.searchStringFilter,
                        paginate: options.paginate,
                        sort: options.sort,
                        filters: JSON.stringify(filters),
                    },
                        function (response) {
                            var promise = Promise.resolve();
                            var qiuRestrictions = JSON.parse(headers('qiu-restrictions'));
                            if (qiuRestrictions && qiuRestrictions.groups_sub) {
                                promise = promise.then(function () {
                                    options.groupIds = [Object.values(qiuRestrictions.groups_sub)[0]];
                                    var hasIngroupStatusTypeRef = response.find(function (ref){
                                        return ref.type === 'ingroup_status';
                                    })
                                    if (hasIngroupStatusTypeRef) {
                                        options.allGroups = true;
                                    }
                                    return getUsersByGroups(options).then(function(resp) {
                                        responseResult = resp.result;
                                        return Promise.resolve();
                                    });
                                    
                                })
                            }
                            promise.then(function() {
                                // angular.copy(response, modulecontent);
                                // setActiveDomain(domain);
                                deferred.resolve({
                                    ref: response,
                                    result: responseResult,
                                    qiuRestrictions: qiuRestrictions
                                });
                            })
                        },
                        function (e) {
                            console.error("ERROR =========================================!!!!!!")
                            console.error(e)
                            deferred.reject();
                        }
                    );

                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function getRef(options) {
            var deferred = $q.defer();
            var ref = resourceBlacklistRef;
            ref.get({
                domain: options.siteID
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }
        function getBlacklisted(options) {
            var deferred = $q.defer();
            resourceBlacklisted.get({
                domain: options.siteID
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);  
        }
        function getGroupsAccreditations(options) {
            var deferred = $q.defer();
            resourceGroupsAccreditations.get({
                domain: options.siteID
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function getUserByID(options) {
            var deferred = $q.defer();

            resourceUserById.get({
                domain: options.site,
                id: options.id,
                withRelatedCountry: true,
                withRelatedCity: true,
                withRelatedState: true,
                // lang: get("language")
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getUsersByGroups(options) {

            var deferred = $q.defer();
            var filters = [];

            _.forEach(options, function (value, key, list) {
                if (_.isObject(list[key])) {
                    _.forEach(list[key], function (filter, keyFilter, listFilter) {
                        if (!_.isEmpty(filter.selected)) {
                            filters.push({
                                field: filter.field,
                                name: filter.name,
                                values: filter.selected
                            });
                        }

                    });

                }
            });

            var opts = {
                domain: options.siteID,
                'id_group[]': options.groupIds,
                sortField: options.sortField,
                sortDir: options.sortDir,
                resultsPerPage: 250,
                page: options.page,
                search: options.searchStringFilter,
            };
            if (options.lastLoginNotNull) {
                opts.lastLoginNotNull = options.lastLoginNotNull;
            }
            if (options.lastLoginFrom) {
                opts.lastLoginFrom = options.lastLoginFrom;
            }
            if (options.currentNumber) {
                opts.currentNumber = options.currentNumber;
            }
            if (options.ingroupStatus && options.ingroupStatus != "0") {
                opts.ingroupStatus = parseInt(options.ingroupStatus);
            }
            if (options.allGroups) {
                opts.all_groups = options.allGroups
            }

            resource_user_by_users_groups.get(opts,
                function (responseResult) {
                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);
                    var ref = resourceUsersRef;
                    if ($stateParams.groupTypeId === "6") {
                        ref = resourceUSersAccreditationsRef;
                    }
                    ref.get({
                        domain: options.siteID,
                        page: options.page,
                        search: options.searchStringFilter,
                        paginate: options.paginate,
                        sort: options.sort,
                        filters: JSON.stringify(filters),
                    },
                        function (response) {
                            // angular.copy(response, modulecontent);
                            // setActiveDomain(domain);

                            deferred.resolve({
                                ref: response,
                                result: responseResult
                            });
                        },
                        function (e) {
                            console.error("ERROR =========================================!!!!!!")
                            console.error(e)
                            deferred.reject();
                        }
                    );

                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );

            return (deferred.promise);
        };
        function getUsersByGroupsCount(options) {
            var deferred = $q.defer();
            var filters = [];
            _.forEach(options, function (value, key, list) {
                if (_.isObject(list[key]) && !Array.isArray(list[key])) {
                    _.forEach(list[key], function (filter, keyFilter, listFilter) {
                        if (!_.isEmpty(filter.selected)) {
                            filters.push({
                                field: filter.field,
                                name: filter.name,
                                values: filter.selected
                            });
                        }

                    });

                }
            });

            var opts = {
                domain: options.siteID,
                'id_group[]': options.groupIds,
            };

            resource_user_by_users_groups_count.get(opts,
                function (responseResult) {
                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);
                    deferred.resolve({
                        result: responseResult
                    });
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );

            return (deferred.promise);
        };
        function getUsersByGroupsNoRef(options) {

            var deferred = $q.defer();
            var filters = [];

            _.forEach(options, function (value, key, list) {
                if (_.isObject(list[key])) {
                    _.forEach(list[key], function (filter, keyFilter, listFilter) {
                        if (!_.isEmpty(filter.selected)) {
                            filters.push({
                                field: filter.field,
                                name: filter.name,
                                values: filter.selected
                            });
                        }

                    });

                }
            });

            var opts = {
                domain: options.siteID,
                'id_group[]': options.groupIds,
                sortField: options.sortField,
                sortDir: options.sortDir,
                resultsPerPage: 250,
                page: options.page,
                search: options.searchStringFilter
            };
            if (options.ingroupStatus && options.ingroupStatus != "0") {
                opts.ingroupStatus = parseInt(options.ingroupStatus);
            }
            if (options.allGroups) {
                opts.all_groups = options.allGroups;
            }

            resource_user_by_users_groups.get(opts,
                function (responseResult) {

                    deferred.resolve({
                        result: responseResult
                    });

                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );

            return (deferred.promise);
        };


        function getUsersGroups(options) {
            var deferred = $q.defer();
            var params = {
                domain: options.siteID,
                groupType: options.groupType
            }
            if (options.withGroupType) {
                params.withGroupType = true;
            }
            params.sortDir = options.sortDir || 'ASC';
            params.sortField = options.sortField || 'name';
            resourceGroupsNested.get(params,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);

        }

        function getUsersGroupsTypes(options) {
            var deferred = $q.defer();
            resourceGroupsTypes.get({
                domain: options.siteID
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);

        }

        function getUsersInGroupStatus(siteID) {
            var deferred = $q.defer();
            resourceInGroupStatus.get({
                domain: siteID
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);

        }

        function getUnnestedUsersGroups(siteID) {
            var deferred = $q.defer();
            resourceGroups.get({
                domain: siteID
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);

        }


        function getUsersGroup(options) {
            var deferred = $q.defer();
            resourceGroups.get({
                domain: options.siteID,
                withoutUsers: options.withoutUsers,
                id: options.id
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    deferred.reject(e);
                }
            );
            return (deferred.promise);

        }

        function createUsersGroup(siteID, parentId, name, groupTypeId, groupStatusId, sort) {
            var deferred = $q.defer();
            resourceGroups.post({
                domain: siteID,
                parent: parentId,
                name: name,
                id_group_type: groupTypeId,
                id_group_status: groupStatusId,
                sort: sort
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    deferred.reject(e);
                }
            );
            return (deferred.promise);

        }

        function editUsersGroup(siteID, groupId, parentId, name, groupTypeId, groupStatusId, sort, rawSettings) {
            var deferred = $q.defer();
            resourceGroups.update({
                domain: siteID,
                parent: parentId,
                name: name,
                id_group_type: groupTypeId,
                id_group_status: groupStatusId,
                id: groupId,
                sort: sort,
                raw_settings: rawSettings
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    deferred.reject(e);
                }
            );
            return (deferred.promise);

        }

        function deleteUsersGroup(siteID, groupId) {
            var deferred = $q.defer();
            resourceGroups.delete({
                domain: siteID,
                id: groupId
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    deferred.reject(e);
                }
            );
            return (deferred.promise);

        }

        function massInsertUsersIntoGroups(options) {
            var deferred = $q.defer();
            resourceUsersInGroupsMassInsert.post({
                domain: options.siteID
            }, JSON.stringify(options.data),
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject(e);
                }
            );
            return (deferred.promise);
        }

        function copyUsersInGroupsToGroups(options) {
            var deferred = $q.defer();
            resourceUsersInGroupsCopyToGroup.post({
                domain: options.siteID
            }, JSON.stringify(options.data),
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function moveUsersInGroupsToGroups(options) {
            var deferred = $q.defer();
            resourceUsersInGroupsMoveToGroup.post({
                domain: options.siteID
            }, JSON.stringify(options.data),
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function insertUsersInGroupsBoolean(options) {
            var deferred = $q.defer();
            resourceUsersInGroupsBoolean.post({
                domain: options.siteID,
                boolean_operation: options.booleanOperation
            }, JSON.stringify(options.data),
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function segmentSubscriptionGroup(options) {
            var deferred = $q.defer();
            resourceSegmentSubscriptionGroup.post({
                domain: options.siteID
            }, JSON.stringify(options.data),
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function removeUsersFromGroup(options) {
            var deferred = $q.defer();
            resourceUsersInGroup.delete({
                domain: options.siteID,
                id: options.data.id_group,
                id_group: options.data.id_group,
                'id_user[]': options.data.id_user
            }, JSON.stringify(options.data),
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }
        function updateUsersFromGroup(options) {
            var deferred = $q.defer();
            resourceUsersInGroup.update({
                domain: options.siteID,
                id: options.id,
                id_ingroup_status: options.id_ingroup_status,
                'id_user': options.id_user
            }, options,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }



        function getUserGroups(options) {
            var deferred = $q.defer();
            resourceUserGroups.get({
                domain: options.site,
            },
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function deleteItem(options) {
            var deferred = $q.defer();
            resource_delete_blacklist_user_byID.delete({
                domain: options.site,
                id: options.id
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function triggerUsersByGroups(groupNode, includeSubgroups) {
            var groups = false;
            var selectedGroup = false;
            if (groupNode) {
                var node = angular.fromJson(groupNode);
                groups = unnestGroups(node, [], includeSubgroups);
                selectedGroup = node;
            }
            $rootScope.$broadcast('loadUsersByGroups', groups, selectedGroup);
        }
        function triggerUsersByGroupsAcc(groupNode) {
            var groups = false;
            if (groupNode) {
                var node = angular.fromJson(groupNode);
                groups = unnestGroups(node, [], includeSubgroups);
            }
            $rootScope.$broadcast('loadUsersByGroupsAcc', groups);
        }
        function triggerUsersByGroupsAccSub(groupNode) {
            var groups = false;
            if (groupNode) {
                var node = angular.fromJson(groupNode);
                groups = unnestGroups(node, []);
            }
            $rootScope.$broadcast('loadUsersByGroupsAccSub', groups);
        }

        function triggerReloadGroups() {
            $rootScope.$broadcast('reloadGroups');
        }

        function triggerSelectParentGroup(groupNode) {
            $rootScope.$broadcast('selectParentGroup', groupNode);
        }

        function triggerCloseSidenav(sidenavId) {
            $rootScope.$broadcast('closeSidenav', sidenavId);
        }

        function triggerSelectSegmentTargetGroup(groupNode) {
            $rootScope.$broadcast('selectSegmentTargetGroup', groupNode);
        }

        function unselectAllGroups() {
            var elemList = document.querySelectorAll('.group-row');
            elemList.forEach(function (elem) {
                elem.classList.remove('selected');
            });
        }

        function unnestGroups(node, groups, includeSubgroups) {
            groups.push(node);
            if (includeSubgroups && typeof node.children !== 'undefined' && node.children.length > 0) {
                angular.forEach(node.children, function (data) {
                    unnestGroups(data, groups, includeSubgroups);
                });
            }
            return groups;
        }

        function triggerGroupDialog(group) {
            $rootScope.$broadcast('openGroupDialog', group);
        }

        function getCountriesWithStates(options) {
            var deferred = $q.defer();
            resourceCountriesWithStates.get({
                resultsPerPage: options.paginate,
            },
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function getStatesWithCities(options) {
            var deferred = $q.defer();

            resourceStatesWithCities.get({
                resultsPerPage: options.paginate,
                id_country: options.id_country
            },
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );
            // Return the promise.
            return (deferred.promise);
        }

        function saveItem(options) {
            var deferred = $q.defer();

            if (options.id !== '' && options.id !== undefined) {
                resource_user_byID.update({
                    domain: options.site,
                    id: options.id,
                    verify: options.item.verify,
                }, options.item,
                    function (response) {

                        deferred.resolve(response);
                    },
                    function (e) {
                        console.error(e)
                        console.error("Database connection error")
                        deferred.reject();
                    }
                );
            } else {
                resource_user_post_byID.save({
                    domain: options.site,
                    verify: options.item.verify
                }, options.item,
                    function (response) {

                        // angular.copy(response, modulecontent);
                        // setActiveDomain(domain);

                        deferred.resolve(response);
                    },
                    function (e) {
                        console.error(e)
                        //console.error("Database connection error")
                        deferred.reject(e.data);
                    }
                );
            }

            // Return the promise.
            return (deferred.promise);
        }

        function saveConversation(options) {
            var deferred = $q.defer();

            resource_user_conversation.update({
                domain: options.site,
                id: options.id,
            },
                {
                    messages: options.messages,
                    conversation: options.conversation,
                    attach: options.attach ? true : false
                },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );
            // Return the promise.
            return (deferred.promise);
        }

        function getTemplatesExport(options) {
            var deferred = $q.defer();

            resource_user_template_export.get({
                domain: options.siteID,
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );
            // Return the promise.
            return (deferred.promise);
        }
        function saveTemplateExport(options) {
            var deferred = $q.defer();

            resource_user_template_export.post({
                domain: options.siteID,
            },
                options.item,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );
            // Return the promise.
            return (deferred.promise);
        }

        function getUsersAuditTrailByID(options) {

            var deferred = $q.defer();
            var params = {
                domain: options.site,
                user_id: options.id
            }
            resourceAuditTrailByID.get(params,
                function (response) {
                    deferred.resolve(response.data);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function getUsersAuditTrail(options) {

            var deferred = $q.defer();
            var params = {
                domain: options.site
            }
            resourceAuditTrail.get(params,
                function (response) {
                    deferred.resolve(response.data);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }
        function getUsersBetweenDates(options) {
            var deferred = $q.defer();
            var params = {
                domain: options.siteID,
                dateFrom: options.dateFrom,
                dateTo: options.dateTo,
                resultsPerPage: options.resultsPerPage ? options.resultsPerPage : 15
            }
            resourceBetweenDates.get(params,
                function (response) {
                    deferred.resolve(response.data);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function getUserToken(options) {

            var deferred = $q.defer();
            var params = {
                domain: options.siteID,
                id: options.id
            }
            if (options.id_group) {
                params.id_group = options.id_group;
            }
            if (options.id_users) {
                params['id_users[]'] = options.id_users;
            }
            resourceGenericUserToken.get(params,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function getFileInfo(options) {
            var deferred = $q.defer();
            resourceGetFileInfo.post({
                domain: options.domain,
                token: options.token,
                options: options.options,
                // lang: get("language")
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }


        function getS3UploadPreSignedUrl(options) {
            var deferred = $q.defer();

            resource_s3_presigned_url.get({
                domain: options.siteID,
                fileName: options.fileName,
                fileSizeKb: (angular.isDefined(options.fileSizeKb)) ? options.fileSizeKb : null
                // lang: get("language")
            },
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }



        function exportUsers(options) {
            var deferred = $q.defer();
            var options = {
                domain: options.siteID,
                users: options.users,
                groups: options.groups,
                fields: options.fields,
                format: options.format,
                nestedGroups: options.nestedGroups,
                users_group_type: options.users_group_type,
                selected_users_group_id: options.selected_users_group_id,
                selected_ingroup_status_id: options.selected_ingroup_status_id
            };
            resourceExportUsers.post(options,
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);

        }


        function importUsers(options) {
            var deferred = $q.defer();
            var options = {
                domain: options.siteID,
                token: options.token,
                targetGroup: options.targetGroup,
                options: options.options,
                fieldMap: options.fieldMap,
                primaryKey: options.primaryKey,
                ignoreDuplicates: options.ignoreDuplicates,
            }
            resourceImportUsers.post(options,
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        
        function changeGroupPriority(options){
            var deferred = $q.defer();
            resourceChagePriority.update(options,
                function (response){
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject(e); 
                }
            );
            
            return (deferred.promise);
        }
        
        var resourceChagePriority = $resource(
            COMMON.BASE_API + "/domain/:domain/users/byGroup/:groupID", {
            domain: '@domain',
            groupID: '@groupID'
            }, 
            {
                update: {
                    method: "PUT",
                }
            }
        )

        var resourceGetFileInfo = $resource(
            COMMON.BASE_API + "/domain/:domain/import/users/getFileInfo", {
            domain: '@domain',
        }, {
            post: {
                method: "POST",
                isArray: false
            }
        }
        );

        var resourceImportUsers = $resource(
            COMMON.BASE_API + "/domain/:domain/import/users/import", {
            domain: '@domain',
        }, {
            post: {
                method: "POST",
                isArray: false
            }
        }
        );
        var resourceExportUsers = $resource(
            COMMON.BASE_API + "/domain/:domain/export/users/export", {
            domain: '@domain',
        }, {
            post: {
                method: "POST",
                isArray: false
            }
        }
        );
        var resource_s3_presigned_url = $resource(
            COMMON.BASE_API + "/domain/:domain/import/users/getS3UploadPreSignedUrl", {
            // No default data.
        }, {
            get: {
                method: "GET",
                isArray: false
            }
        }
        );

        var resourceGroupsNested = $resource(
            COMMON.BASE_API + "/domain/:domain/usersGroupsNested", {
            // No default data.
        }, {
            get: {
                method: "GET",
                isArray: false,
                transformResponse: function(data, headers){
                    var response = {}
                    response.data = JSON.parse(data);
                    response.qiuRestrictions = JSON.parse(headers('qiu-restrictions'));
                    return response;
                }
            }
        }
        );
        var resourceAuditTrailByID = $resource(
            COMMON.BASE_API + "/domain/:domain/usersAuditTrail?user_id=:user_id", {
            // No default data.
        }, {
            get: {
                method: "GET",
                isArray: false
            }
        }
        );
        var resourceAuditTrail = $resource(
            COMMON.BASE_API + "/domain/:domain/usersAuditTrail?withUser", {
            // No default data.
        }, {
            get: {
                method: "GET",
                isArray: false
            }
        }
        );

        var resourceGenericUserToken = $resource(
            COMMON.BASE_API + "/domain/:domain/users/getGenericToken/:id", {
            // No default data.
        }, {
            get: {
                method: "GET",
                isArray: false
            }
        }
        );

        var resourceGroupsTypes = $resource(
            COMMON.BASE_API + "/domain/:domain/usersGroupsTypes", {
            // No default data.
        }, {
            get: {
                method: "GET",
                isArray: true
            }
        }
        );

        var resourceInGroupStatus = $resource(
            COMMON.BASE_API + "/domain/:domain/usersInGroupStatus", {
            // No default data.
        }, {
            get: {
                method: "GET",
                isArray: true
            }
        }
        );

        var resourceGroups = $resource(
            COMMON.BASE_API + "/domain/:domain/usersGroups/:id", {
            // No default data.
            domain: '@domain',
            id: '@id'
        }, {
            get: {
                method: "GET",
                isArray: false
            },
            post: {
                method: "POST"
            },
            update: {
                method: "PUT"
            },
            delete: {
                method: "DELETE",
                isArray: true
            }

        }
        );



        var resourceUsers = $resource(COMMON.BASE_API + "/domain/:domain/users", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false
            }
        });
        var resourceBlacklisted = $resource(COMMON.BASE_API + "/domain/:domain/mailing/getBlacklisted", {
            // No default data
        }, {
            get: {
                method: "GET",
                // isArray: true
            }
        });
        var resourceGroupsAccreditations = $resource(COMMON.BASE_API + "/domain/:domain/usersGroupsTypes?withChildren&groupTypes[]=6", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: true
            }
        });
        var resourceUsersRef = $resource(COMMON.BASE_API + "/domain/:domain/usersRef", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: true
            }
        });
        var resourceBlacklistRef = $resource(COMMON.BASE_API + "/domain/:domain/mailing/getBlacklistedRef", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: true
            }
        });
        var resourceUSersAccreditationsRef = $resource(COMMON.BASE_API + "/domain/:domain/usersRefAccreditations", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: true
            }
        });

        var resourceUserById = $resource(COMMON.BASE_API + "/domain/:domain/users/:id", {
            // No default data
        }, {
            get: {
                method: "GET",
                // isArray: true
            }
        });

        var resourceUserGroups = $resource(
            COMMON.BASE_API + "/domain/:domain/usersGroupsNested", {
            // No default data.
        }, {
            get: {
                method: "GET",
                isArray: true
            }
        }
        );

        var resource_user_by_users_groups = $resource(
            COMMON.BASE_API + "/domain/:domain/usersInGroup", {
            // No default data.

        }, {
            get: {
                method: "GET",
                //isArray: true
            }
        }
        );

        var resource_user_by_users_groups_count = $resource(
            COMMON.BASE_API + "/domain/:domain/usersInGroup/count", {
            // No default data.

        }, {
            get: {
                method: "GET",
                //isArray: true
            }
        }
        );

        var resourceUsersInGroup = $resource(
            COMMON.BASE_API + "/domain/:domain/usersInGroup/:id", {
            // No default data.
        }, {
            delete: {
                method: "DELETE",
                isArray: true
            },
            update: {
                method: "PUT",
                isArray: true
            }
        }
        );

        var resourceUsersInGroupsMassInsert = $resource(
            COMMON.BASE_API + "/domain/:domain/usersInGroups/massInsert", {
            // No default data.

        }, {
            post: {
                method: "POST",
                //isArray: true
            }
        }
        );

        var resourceUsersInGroupsCopyToGroup = $resource(
            COMMON.BASE_API + "/domain/:domain/usersInGroups/copyToGroup", {
            // No default data.

        }, {
            post: {
                method: "POST",
                //isArray: true
            }
        }
        );

        var resourceUsersInGroupsMoveToGroup = $resource(
            COMMON.BASE_API + "/domain/:domain/usersInGroups/moveToGroup", {
            // No default data.

        }, {
            post: {
                method: "POST",
                //isArray: true
            }
        }
        );

        var resourceUsersInGroupsBoolean = $resource(
            COMMON.BASE_API + "/domain/:domain/usersInGroups/boolean/:boolean_operation", {
            // No default data.

        }, {
            post: {
                method: "POST",
                //isArray: true
            }
        }
        );

        var resourceSegmentSubscriptionGroup = $resource(
            COMMON.BASE_API + "/domain/:domain/usersInGroups/segmentSubscriptionGroup", {
            // No default data.

        }, {
            post: {
                method: "POST",
                //isArray: true
            }
        }
        );
        var resource_user_template_export = $resource(
            COMMON.BASE_API + "/domain/:domain/users/export/templates", {
            // No default data.

        }, {
            get: {
                method: "GET",
                //isArray: true
            },
            post: {
                method: "POST",
                //isArray: true
            }
        }
        );

        var resource_user_post_byID = $resource(
            COMMON.BASE_API + "/domain/:domain/users", {
            domain: '@domain',
        }, {
            save: {
                method: "POST",
            },
        }
        );

        var resource_user_byID = $resource(
            COMMON.BASE_API + "/domain/:domain/users/:id", {
            domain: '@domain',
            id: '@id',
        }, {
            get: {
                method: "GET",
            },
            update: {
                method: "PUT",
            },
            delete: {
                method: "DELETE",
                isArray: true
            }
        }
        );
        var resource_delete_blacklist_user_byID = $resource(
            COMMON.BASE_API + "/domain/:domain/mailing/massDeleteBlacklisted?id_mailing_blacklisted[]=:id", {
            domain: '@domain',
            id: '@id',
        }, {
            get: {
                method: "GET",
            },
            update: {
                method: "PUT",
            },
            delete: {
                method: "DELETE",
                isArray: true
            }
        }
        );
        var resource_user_conversation = $resource(
            COMMON.BASE_API + "/domain/:domain/usersConversations/:id", {
            domain: '@domain',
            id: '@id',
        }, {
            update: {
                method: "PUT",
            }
        }
        );
        var resourceBetweenDates = $resource(
            COMMON.BASE_API + "/domain/:domain/users?sortDir=DESC&sortField=created_at&dateFrom=:dateFrom&dateTo=:dateTo", {
            domain: '@domain',
            id: '@id',
        }, {
            get: {
                method: "GET",
            },
            update: {
                method: "PUT",
            },
            delete: {
                method: "DELETE",
                isArray: true
            }
        }
        );

        var resourceCountriesWithStates = $resource(
            COMMON.BASE_API + "/location/countries?withStates", {
            // No default data.
        }, {
            get: {
                method: "GET",
                // isArray: true
            }
        }
        );

        var resourceStatesWithCities = $resource(
            COMMON.BASE_API + "/location/states?withCities", {
            // No default data.
        }, {
            get: {
                method: "GET",
                // isArray: true
            }
        }
        );

        return ({
            get: get,
            //get: getUsers,
            //get: getUsersByGroups,
            getUserByID: getUserByID,
            getFilters: getUserGroups,
            getRef: getRef,
            getBlacklisted: getBlacklisted,
            saveItem: saveItem,
            deleteItem: deleteItem,
            getUsers: getUsers,
            getUsersByGroups: getUsersByGroups,
            getUsersByGroupsCount: getUsersByGroupsCount,
            getUsersByGroupsNoRef: getUsersByGroupsNoRef,
            getUsersGroups: getUsersGroups,
            getUsersGroup: getUsersGroup,
            triggerUsersByGroups: triggerUsersByGroups,
            triggerUsersByGroupsAcc: triggerUsersByGroupsAcc,
            triggerUsersByGroupsAccSub: triggerUsersByGroupsAccSub,
            triggerGroupDialog: triggerGroupDialog,
            triggerSelectSegmentTargetGroup: triggerSelectSegmentTargetGroup,
            getCountriesWithStates: getCountriesWithStates,
            getStatesWithCities: getStatesWithCities,
            getUsersBetweenDates: getUsersBetweenDates,
            getUnnestedUsersGroups: getUnnestedUsersGroups,
            saveConversation: saveConversation,
            createUsersGroup: createUsersGroup,
            editUsersGroup: editUsersGroup,
            deleteUsersGroup: deleteUsersGroup,
            updateUsersFromGroup: updateUsersFromGroup,
            triggerSelectParentGroup: triggerSelectParentGroup,
            unnestGroups: unnestGroups,
            triggerReloadGroups: triggerReloadGroups,
            triggerCloseSidenav: triggerCloseSidenav,
            massInsertUsersIntoGroups: massInsertUsersIntoGroups,
            copyUsersInGroupsToGroups: copyUsersInGroupsToGroups,
            moveUsersInGroupsToGroups: moveUsersInGroupsToGroups,
            insertUsersInGroupsBoolean: insertUsersInGroupsBoolean,
            segmentSubscriptionGroup: segmentSubscriptionGroup,
            removeUsersFromGroup: removeUsersFromGroup,
            getUsersGroupsTypes: getUsersGroupsTypes,
            getUsersInGroupStatus: getUsersInGroupStatus,
            getUsersAuditTrailByID: getUsersAuditTrailByID,
            getUsersAuditTrail: getUsersAuditTrail,
            getS3UploadPreSignedUrl: getS3UploadPreSignedUrl,
            getGroupsAccreditations: getGroupsAccreditations,
            saveTemplateExport: saveTemplateExport,
            getTemplatesExport: getTemplatesExport,
            getFileInfo: getFileInfo,
            importUsers: importUsers,
            exportUsers: exportUsers,
            getUserToken: getUserToken,
            changeGroupPriority: changeGroupPriority
        });

    }

})();



(function () {
    'use strict';

    angular.module('app.users')
        .controller('UsersTemporaryController', UsersTemporaryController)

    /** @ngInject */
    function UsersTemporaryController($scope, $rootScope, $document, $mdDialog, $mdMedia, $mdToast, $mdSidenav, usersService, transformUsers,
        $state, msApi, requestContext, $timeout, $window, usersTemporaryService, sharedFunctionsMailing, msUtils, $translate, sessionService, $stateParams) {
        var vm = this;
        $scope.validSelection = true;
        vm.page = 1;
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg', 'red-bg', 'yellow-bg', 'light-blue-bg'];
        vm.selectedColor = vm.colors[Math.floor(Math.random() * vm.colors.length)];

        vm.nextPageLog = 1;
        vm.loadingThreads = true;
        vm.users = null;
        vm.selectedUser = null;
        vm.userGroupTypes = undefined;
        vm.currentTab = 'preview';
        vm.countriesWithStates = undefined;
        vm.statesWithCities = undefined;
        vm.timeAgo = msUtils.timeAgo;

        vm.selectedThreads = [];

        vm.init = init;

        vm.changeView = changeView;
        vm.toggleSelectThread = toggleSelectThread;
        vm.isSelected = isSelected;
        vm.toggleSelectThreads = toggleSelectThreads;
        vm.confirmWindow = confirmWindow;
        vm.getCountriesWithStates = getCountriesWithStates;
        vm.openThread = openThread;
        vm.getStatesByCountry = getStatesByCountry;
        vm.getCitiesByState = getCitiesByState;
        vm.resetFilters = resetFilters;



        vm.isLarge = isLarge;
        vm.isMedium = isMedium;
        vm.isSmall = isSmall;
        vm.isMini = isMini;

        vm.translate = function (text) {
            return $translate.instant(text);
        }


        //////////

        init();

        function init() {

            vm.views = {
                nosplit: 'app/main/apps/users/users-temporary/views/list/nosplit-view.html',
                split: 'app/main/apps/users/users-temporary/views/list/split-view.html',
                table: 'app/main/apps/users/users-temporary/views/list/table-view.html',
                grid: 'app/main/apps/users/users-temporary/views/grid/grid-view.html'
            };
            vm.defaultView = 'split';
            vm.currentView = 'split';
            vm.loadingView = true;


            var siteID = requestContext.getParam("siteId");

            var section = 'users';

            $scope.siteID = siteID;
            $scope.section = section;


            sessionService.setActiveSection(section).then(function () {
                vm.ActiveSection = sessionService.ActiveSection;
            });

            vm.viewSplit = true;
            vm.edit = false;
            vm.currentTab = 'preview';
            vm.selectedUsers = [];
            $scope.view_medialist = true;
            $scope.siteID = siteID;
            $scope.section = section;
            $scope.page = 1;
        }

        // Watch screen size to change view modes
        $scope.$watch(function () {
            return $mdMedia('lt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                vm.currentView = 'nosplit';
            }
        });

        $scope.$watch(function () {
            return $mdMedia('max-width: 960px');
        }, function (big) {

            if (big)
                vm.currentView = 'nosplit';

        });

        $scope.$watch(function () {
            return $mdMedia('min-width: 960px');
        }, function (small) {

            if (small)
                vm.currentView = 'split';

        });

        $scope.$watch(function () {
            return $mdMedia('gt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                if (vm.defaultView === 'split') {
                    vm.currentView = 'split';
                }
            }
        });

        $scope.$on('$includeContentLoaded', function (event, target) {
            $timeout(function () {
                vm.loadingView = false;
            }, 1000);
        });

        $scope.$on('pagination:loadStart', function (event) {
            $scope.isLoading = true;
        });

        $scope.$on('pagination:loadPage', function (event) {
            $scope.isLoading = false;
        });


        function toggleSelectThread(thread, event) {
            vm.selectedThreads = sharedFunctionsMailing.toggleSelectThread(vm.selectedThreads, thread, event);
        }
        function isSelected(thread) {
            return sharedFunctionsMailing.isSelected(vm.selectedThreads, thread);
        }
        function toggleSelectThreads() {
            vm.selectedThreads = sharedFunctionsMailing.toggleSelectThreads(vm.selectedThreads, vm.threads);
        }
        function confirmWindow(url) {
            window.open(url, 'Confirmation window', "height=400,width=400");
            $rootScope.pagination_resetquery();
            $window.location.reload();
        }
        function getCountriesWithStates() {
            if (angular.isUndefined(vm.countriesWithStates)) {
                vm.countriesWithStates = [];
                var options = {
                    paginate: 99999,
                    resultsPerPage: 300
                };
                usersService.getCountriesWithStates(options).then(function (response) {

                    if (response.total) {
                        angular.forEach(response.data, function (item) {
                            var resultId = item['id_country'];
                            var resultData = {
                                id: resultId,
                                code: item['code'],
                                name: item['country']
                            };
                            vm.countriesWithStates.push(resultData);
                        })
                    }
                })
            }
        }


        function openThread(thread, id) {
            if (vm.countriesWithStates == undefined) {
                vm.getCountriesWithStates();
            }
            if (angular.element(document.getElementById('thread-detail')).length) {
                var elem = angular.element(document.getElementById('thread-detail'));
                elem.scrollTopAnimated(0, 10);
            }
            // pagesShown = 1;
            if (thread) {
                vm.selectedContentID = thread.id_user;
            } else if (id) {
                vm.selectedContentID = id;
            }
            if (vm.selectedContentID != 'new') {
                vm.editInline = false;

                vm.loadingReadPane = true;

                var goToState = 'app.site_overview.users.user_temporary.list.thread';



                // $state.go(goToState, {
                //     id: vm.selectedContentID
                // }, {
                //     notify: false,
                //     inherit: true,
                //     location: true
                // });

                // var options = {
                //     site: $scope.siteID,
                //     section: $scope.section,
                //     id: vm.selectedContentID,
                //     sortDir: $rootScope.sortDir,
                //     sortField: $rootScope.sortField
                // };

                // usersService.getUserByID(options).then(function (response) {

                //vm.selectedContent = angular.copy(response);
                var found = vm.threads.find(x => {
                    return x == thread
                });
                vm.currentThread = JSON.parse(angular.toJson(found));
                transformUsers.DtoToUser(vm.currentThread, $scope.siteID);
                vm.selectedContent = angular.copy(vm.currentThread);
                // vm.updateThread(vm.currentThread);
                refColumnStuff();
                vm.nextPageLog = 1;
                vm.loadingReadPane = false;
                vm.currentThread_Edit = angular.copy(vm.selectedContent);
                // });
            };
        }

        function refColumnStuff() {

            for (var i = vm.refcolumns.length - 1; i >= 0; i--) {

                if (vm.refcolumns[i].category == 'json') {
                    var value = '';
                    if (vm.selectedContent.user_params && vm.selectedContent.user_params != 'null') {
                        var userParamsObj = JSON.parse(vm.selectedContent.user_params);
                        if (userParamsObj.hasOwnProperty(vm.refcolumns[i].title)) {
                            value = userParamsObj[vm.refcolumns[i].title];
                        }
                    }
                    vm.selectedContent[vm.refcolumns[i].title] = value;
                }

                if (vm.refcolumns[i].type) {
                    if (vm.refcolumns[i].type.substr(0, 8) == 'datetime') {

                        var value = vm.selectedContent[vm.refcolumns[i].title];
                        if (value == '0000-00-00 00:00:00') {
                            value = moment().format("YYYY-MM-DD");
                        }

                        var utcDate = moment.utc(value);

                        var siteDate = moment.utc(value).tz(sessionService.site_operative.timezone);

                        vm.selectedContent[vm.refcolumns[i].title] = {};
                        vm.selectedContent[vm.refcolumns[i].title]['value'] = value;
                        vm.selectedContent[vm.refcolumns[i].title]['date'] = new Date(siteDate.format());
                        vm.selectedContent[vm.refcolumns[i].title]['dateShow'] = siteDate.format(vm.dateTimeFormat);
                        vm.selectedContent[vm.refcolumns[i].title]['utcShow'] = utcDate.format(vm.dateTimeFormat);
                        vm.selectedContent[vm.refcolumns[i].title]['utcDate'] = utcDate;
                    } else if (vm.refcolumns[i].type.substr(0, 4) == 'date') {
                        var format = "YYYY-MM-DD";
                        if (vm.refcolumns[i].type.split('-')[1]) {
                            format = vm.refcolumns[i].type.split('-')[1];
                        }
                        vm.selectedContent[vm.refcolumns[i].title] = moment.utc(vm.selectedContent[vm.refcolumns[i].title]).tz(sessionService.site_operative.timezone).format(format);
                    } else if (vm.refcolumns[i].type == 'state') {
                        if (vm.selectedContent.country) {
                            vm.getStatesByCountry(vm.selectedContent.country);

                        }
                    } else if (vm.refcolumns[i].type == 'files') {
                        if (vm.selectedContent.files) {
                            if (typeof vm.selectedContent.files === 'string') {
                                vm.selectedContent.files = JSON.parse(vm.selectedContent.files);
                            }
                        }
                    }
                }
                if (vm.refcolumns[i].category == 'show_groups_inprofile') {
                    if (typeof vm.refcolumns[i].title === 'string') {
                        vm.refcolumns[i].title = JSON.parse(vm.refcolumns[i].title)
                    }
                    vm.refcolumns[i].groups = getByType(angular.copy(vm.CleanUsersGroups), vm.refcolumns[i].title);
                }

            }
            vm.selectedContent_ref = vm.refcolumns;
            //TODO move to utils directive
            for (var i = 0; i < vm.refcolumns.length; i++) {
                var ref = vm.refcolumns[i];
                ref.preview_sort = parseInt(ref.preview_sort);
            }
            vm.selectedContent_refgrouped = _.groupBy(vm.refcolumns, function (m) {
                return m.preview_position;
            });;
            //console.log('ref', vm.selectedContent_ref);
            //console.log('refGrouped', vm.selectedContent_refgrouped);
        }


        function getStatesByCountry(countryId) {

            if (angular.isDefined(countryId)) {
                vm.statesWithCities = [];
                var options = {
                    paginate: 99999,
                    resultsPerPage: 99999,
                    id_country: countryId
                };
                usersService.getStatesWithCities(options).then(function (response) {
                    if (response.total) {
                        angular.forEach(response.data, function (item) {
                            var resultId = item['id_state'];
                            var resultData = {
                                id: resultId,
                                code: item['code'],
                                name: item['state'],
                                cities: item['cities']
                            };
                            vm.statesWithCities.push(resultData);
                            if (vm.selectedContent.state && vm.selectedContent.state == resultData.id) {
                                vm.selectedContent.related_state = resultData;
                                vm.getCitiesByState(vm.selectedContent.state);
                            }
                        })
                    }
                })
            }
        };

        function resetFilters() {
            vm.currentLabelsFilter = undefined;
            vm.usersGroups = transformUsers.formatNestedGroups(angular.copy(vm.refFilterables));
            $rootScope.pagination_resetquery();
        }

        function getCitiesByState(stateId) {
            if (angular.isDefined(stateId) && stateId !== '') {
                var item = ($filter('filter')(vm.statesWithCities, { id: stateId }));
                if (item && item.length > 0) {
                    vm.cities = item[0].cities;
                }
                if (vm.selectedContent.city) {
                    angular.forEach(vm.cities, function (item) {
                        if (item.id_city == vm.selectedContent.city) {
                            vm.selectedContent.related_city = item;
                        }
                    });
                }
            }
        }

        function isLarge(field) {
            return ['firstname', 'email', 'last_login', 'created_at'].includes(field);
        }
        function isMedium(field) {
            return ['mobile', 'skype', 'ingroup_status', 'country'].includes(field);
        }
        function isSmall(field) {
            return [].includes(field);
        }
        function isMini(field) {
            return ['status', 'media', 'id_user'].includes(field);
        }



        /**
         * Change the view
         *
         * @param view
         */
        function changeView(view) {
            if (vm.views[view]) {
                vm.loadingView = true;
                vm.defaultView = view;
                vm.currentView = view;
            }
        }



    }

})();

(function () {
    'use strict';

    angular
        .module('app.users')
        .service('usersTemporaryService', usersTemporaryService);

    /** @ngInject */
    // I provide access to the session store.
    function usersTemporaryService($rootScope, $q, $resource, $stateParams, COMMON) {




        function getUsers(options) {

            var deferred = $q.defer();


            resourceUsers.get({
                domain: options.siteID,
                page: options.page,
                search: options.searchStringFilter,
                paginate: options.paginate,
                sortField: options.sortField,
                sortDir: options.sortDir,
                withConfirmLink: true,
                resultsPerPage: 250
            },
                function (responseResult) {
                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);
                    var ref = resourceUsersRef;
                    ref.get({
                        domain: options.siteID,
                        page: options.page,
                        search: options.searchStringFilter,
                        paginate: options.paginate,
                        sort: options.sort,
                    },
                        function (response) {
                            // angular.copy(response, modulecontent);
                            // setActiveDomain(domain);
                            deferred.resolve({
                                ref: response,
                                result: responseResult
                            });
                        },
                        function (e) {
                            console.error("ERROR =========================================!!!!!!")
                            console.error(e)
                            deferred.reject();
                        }
                    );

                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function getRef(options) {
            var deferred = $q.defer();
            var ref = resourceUsersTempRef;
            ref.get({
                domain: options.siteID
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function getFilters(options) {
            var deferred = $q.defer();
            return (deferred.promise);
        }



        var resourceUsers = $resource(COMMON.BASE_API + "/domain/:domain/users/temp", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false
            }
        });
        var resourceUsersTempRef = $resource(COMMON.BASE_API + "/domain/:domain/usersRefTemp", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: true
            }
        });

        var resourceUsersRef = $resource(COMMON.BASE_API + "/domain/:domain/usersRef", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: true
            }
        });


        return ({
            get: getUsers,
            getRef: getRef,
            getFilters: getFilters
        });

    }

})();

angular.module('app.users').filter('groupByUser', ['$parse', function ($parse) {
        return function (list, group_by) {
            var filtered = [];
            var prev_item = null;
            var group_changed = false;
            // this is a new field which is added to each item where we append "_CHANGED"
            // to indicate a field change in the list
            //was var new_field = group_by + '_CHANGED'; - JB 12/17/2013
            var new_field = 'group_by_CHANGED';

            if (group_by[0] === undefined) {
                return list;
            }

            // loop through each item in the list
            angular.forEach(list, function (item) {

                group_changed = false;

                // if not the first item
                if (prev_item !== null) {

                    // check if any of the group by field changed

                    //force group_by into Array
                    group_by = angular.isArray(group_by) ? group_by : [group_by];

                    //check each group by parameter
                    for (var i = 0, len = group_by.length; i < len; i++) {

                        if (prev_item.firstname !== '' && item.firstname !== '' && prev_item.firstname !== null && item.firstname !== null) {
                            if ($parse(group_by[i])(prev_item)[0].toUpperCase() !== $parse(group_by[i])(item)[0].toUpperCase()) {
                                group_changed = true;
                            }
                        } else if ($parse(group_by[i])(prev_item) !== $parse(group_by[i])(item)) {
                            group_changed = true;
                        }
                    }


                }// otherwise we have the first item in the list which is new
                else {
                    group_changed = true;
                }

                // if the group changed, then add a new field to the item
                // to indicate this
                if (group_changed) {
                    item[new_field] = true;
                } else {
                    item[new_field] = false;
                }

                filtered.push(item);
                prev_item = item;

            });

            return filtered;
        };
    }]);
(function () {
    'use strict';

    angular
        .module('app.users')
        .service('analyticsService', analyticsService);

    /** @ngInject */
    // I provide access to the session store.
    function analyticsService($rootScope, $q, $resource, COMMON) {

        function getUsers(options) {

            var deferred = $q.defer();

            let opts = {
                domain: options.siteID
            };

            if (options.dateFrom && options.dateTo) {
                opts.dateFrom = options.dateFrom;
                opts.dateTo = options.dateTo;
            }
            if (options.filters) {
                opts['filters[]'] = options.filters;
            }
            resourceUsers.get(opts,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getEvents(options) {

            var deferred = $q.defer();

            let opts = {
                domain: options.siteID
            };


            if (options.dateFrom && options.dateTo) {
                //opts.dateFrom = options.dateFrom;
                //opts.dateTo = options.dateTo;
            }
            if (options.userId) {
                opts.userId = options.userId
            }
            if (options.connectionId) {
                opts.connectionId = options.connectionId
            }
            resourceEvents.get(opts,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getRef(options) {

            var deferred = $q.defer();

            let opts = {
                domain: options.siteID
            };

            resourceRef.get(opts,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getOptions(options) {
            var deferred = $q.defer();

            // Return the promise.
            return (deferred.promise);
        }

        var resourceUsers = $resource(
            COMMON.BASE_API + "/domain/:domain/qiuAnalytics/users", {
                // No default data.
            }, {
                get: {
                    method: "GET",
                    isArray: true
                }
            }
        );

        var resourceEvents = $resource(
            COMMON.BASE_API + "/domain/:domain/qiuAnalytics/events", {
                // No default data.
            }, {
                get: {
                    method: "GET",
                    isArray: true
                }
            }
        );

        var resourceRef = $resource(
            COMMON.BASE_API + "/domain/:domain/qiuAnalyticsRef", {
                // No default data.
            }, {
                get: {
                    method: "GET",
                    isArray: true
                }
            }
        );

        var resourceQiuAnalyticsRef = $resource(COMMON.BASE_API + "/domain/:domain/qiuAnalyticsRef", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: true
            }
        });

        return ({
            getUsers: getUsers,
            getEvents: getEvents,
            getFilters: getOptions,
            getRef: getRef
        });

    }

})();



(function () {
    'use strict';

    angular.module('app.users')
        .controller('AnalyticsController', AnalyticsController);


    /** @ngInject */
    function AnalyticsController($scope, $rootScope, $document, $mdDialog, $mdMedia, $mdToast, $mdSidenav,
        $state, msApi, requestContext, $timeout, usersService, contentService, msUtils, settingUserService,
        $anchorScroll, $translate, sessionService, tinyMceService, $filter, $window, $q, $stateParams, 
        formsService, $http, analyticsService
    ) {

        var vm = this;

        vm.settingsSection = 'analytics';
        vm.getSettingValue = settingUserService.getSettingValue;
        vm.selectedRaces = [];
        vm.selectedTenants = [];
        vm.usersFilters = [];
        vm.eventsFilters = [];
        vm.filterColumnsRaces = [];
        vm.fieldOrder = 'name';
        vm.events = []; // Retrieved from analytics 'events' and displayed in user preview.

        vm.fromDate = null; // new Date('2021-04-19 00:00:00');
        vm.toDate = null; //new Date('2021-04-22 23:59:59');
        vm.searchQuery = '';
        vm.qiuRestrictedTenantGroup = null;


        vm.isLarge = isLarge;
        vm.isMedium = isMedium;
        vm.isSmall = isSmall;
        vm.isMini = isMini;
        vm.openThread = openThread;
        vm.closeThread = closeThread;
        vm.tenantsFilter = tenantsFilter;
        vm.setSortOrder = setSortOrder;
        vm.setSortField = setSortField;
        vm.resetSortField = resetSortField;
        vm.formatSeconds = formatSeconds;
        vm.orderByTableListSort = orderByTableListSort;
        vm.showExtra = showExtra;
        vm.exportAnalytics = exportAnalytics;


        init();

        function init() {

            vm.views = {
                nosplit: 'app/main/apps/users/analytics/views/list/nosplit-view.html',
                split: 'app/main/apps/users/analytics/views/list/split-view.html',
                table: 'app/main/apps/users/analytics/views/list/table-view.html',
                grid: 'app/main/apps/users/analytics/views/grid/grid-view.html'
            };
            ;
            vm.defaultView = vm.getSettingValue(vm.settingsSection, 'defaultView', "table");
            vm.currentView = vm.getSettingValue(vm.settingsSection, 'defaultView', "table");

            vm.loadingView = true;

            var siteID = requestContext.getParam("siteId");
            var section = 'users';

            $scope.siteID = siteID;
            $scope.section = section;

            sessionService.setActiveSection(section).then(function () {
                vm.ActiveSection = sessionService.ActiveSection;
            });

            vm.viewSplit = true;
            vm.edit = false;
            vm.currentTab = 'preview';
            vm.selectedUsers = [];
            vm.selectedGroups = [];

            $scope.view_medialist = true;

            $rootScope.global.titleToolbar = '<i class="icon s20 icon-people mr-15" ng-if="node.icon"></i> ' + $translate.instant('ANALYTICS_TITLE');

            usersService.getUsers({
                "siteID": $scope.siteID
            }).then(function(response){
                if (response.hasOwnProperty('qiuRestrictions')){
                    if (response.qiuRestrictions.hasOwnProperty('groups_sub')) {
                        vm.qiuRestrictedTenantGroup = response.qiuRestrictions.groups_sub[0];
                    }
                    if (response.qiuRestrictions.hasOwnProperty('id_group')) {
                        vm.qiuRestrictedTenantGroup = response.qiuRestrictions.id_group[0];
                    }
                }

                loadRef().then(function(response){
                    vm.Ref = response;

                    const refFilters = vm.Ref.filter(function(item) {
                        return item.category == 'filter';
                    })

                    /**
                     * vm.refFiltersGrouped - Used as filter options in toolbar filters.
                     */
                    vm.refFiltersGrouped = _.groupBy(refFilters, function (item) {
                        return item.type;
                    });

                    applyTenantRestrictions();

                    /**
                     * vm.refcolumns - Used as columns in list table view.
                     */
                    vm.refcolumns = vm.Ref.filter(function(item) {
                        return item.category != 'filter' && item.table_list_position != null;
                    })

                    /**
                     * vm.refcolumnsgrouped - Currently unused
                     */
                    vm.refcolumnsgrouped = _.groupBy(vm.refcolumns, function (item) {
                        return item.table_list_position;
                    });

                    const previewRef = vm.Ref.filter(function(item) {
                        return item.category != 'filter' && item.preview_position != null;
                    })

                    /**
                     * vm.selectedContent_refgrouped - Used for fields in thread preview
                     */
                    vm.selectedContent_refgrouped = _.groupBy(previewRef, function (item) {
                        return item.preview_position;
                    });

                    // By default, preselect all races to show analytics data on table.
                    vm.selectedRaces = vm.refFiltersGrouped.race.filter(function(race) {
                        var settings = JSON.parse(race.raw_settings);
                        return settings.hasOwnProperty('is_default_selected') && settings.is_default_selected;
                    });

                    vm.filterColumnsRaces = vm.selectedRaces;

                    // Excerp "fromDate" and "toDate" from selected races data.
                    updateDateRange();

                    loadUsers();
                    initWatchers();
                });
            });


            if ($state.params.id) {
                vm.loadingReadPane = true;
            }

        }


        /**
         * Retrieves Qiu Analytics Refs from api.
         */
        function loadRef() {
            var options = {
                siteID: $scope.siteID
            };
            return analyticsService.getRef(options);
        }

        /**
         * Users with qiu restricted group can only see users from tenant group.
         * Preselect Tenant filter.
         */
        function applyTenantRestrictions() {
            if (vm.qiuRestrictedTenantGroup) {
                var tenantRefs = vm.refFiltersGrouped.tenant.filter(function(ref) {
                    var settings = JSON.parse(ref.raw_settings);
                    return settings.hasOwnProperty('id_group') && settings.id_group == vm.qiuRestrictedTenantGroup;
                })
                vm.selectedTenants = tenantRefs.map(function(ref) {return ref.title});
            }
        }

        /**
         * Retrieves users from api, applying all selected filters.
         */
        function loadUsers() {
            var options = {};
            options.siteID = $scope.siteID;
            options.filters = getUsersFilters();
            options.dateFrom = getFromDate();
            options.dateTo = getToDate();

            analyticsService.getUsers(options).then(function(response){
                vm.threads = normalizeUsers(response);
            })
        }

        function normalizeUsers(users) {
            return users.map(function(item) {
                item.name = item.userData.firstname + ' ' + item.userData.lastname;
                item.email = item.userData.email;
                item.id_user = item.userId;
                item.connectedTimeInternal = item.connectedTime;
                item.connectedTime = formatSeconds(item.connectedTime);
                item.tenants = item.extra.Tenants.join(', ');
                return item;
            });
        }

        /**
         * Assembles and returns all filters as they are used in the users api request.
         */
        function getUsersFilters() {
            var filters = []
            // Races filters
            angular.forEach(vm.selectedRaces, function(column){
                filters.push(column.raw_settings)
            })
            // Tenant filter
            //if (vm.selectedTenants.length > 0) {
                filters.push({
                  "name": "Tenants",
                  "type": "EXTRAFIELDARRAY",
                  "field": "tenants"
                })
            //}
            return filters;
        }

        /**
         * Retrieve events from api
         */
        function loadEvents(options) {
            options.siteID = $scope.siteID;
            return analyticsService.getEvents(options);
        }

        /**
         * Opens Preview view for selected user
         */
        function openThread(thread) {
            vm.eventsGrouped = [];
            if (angular.element(document.getElementById('thread-detail')).length) {
                var elem = angular.element(document.getElementById('thread-detail'));
                elem.scrollTopAnimated(0, 10);
            }

            vm.selectedContentID = thread.id_user;

            vm.editInline = false;

            vm.loadingReadPane = true;

            var goToState = 'app.site_overview.users.analytics.thread';

            $state.go(goToState, {
                id: vm.selectedContentID
            }, {
                notify: false,
                inherit: true,
                location: true
            });

            vm.currentThread = thread;
            vm.loadingReadPane = false;
            vm.selectedContent = angular.copy(vm.currentThread);
            vm.currentThread_Edit = angular.copy(vm.selectedContent);

            var options = {
                userId: vm.selectedContentID
                //connectionId: 'eCUU8dsDoAMCFeg='
            };
            loadEvents(options).then(function(response) {
                vm.events = response;
                vm.eventsGrouped = groupEventsByRace();
            });
        }


        function groupEventsByRace() {
            vm.refFiltersGrouped.race;
            var result = [];
            for (var key in vm.refFiltersGrouped.race) {
                var race = vm.refFiltersGrouped.race[key];
                if (!race.hasOwnProperty('raw_settings')) continue;
                var settings = JSON.parse(race.raw_settings);
                var raceDateFrom = new Date(settings.dateFrom);
                var raceDateTo = new Date(settings.dateTo);
                var item = {
                    name: settings.name,
                    events: []
                }
                for (var key2 in vm.events) {
                    var event = vm.events[key2];
                    if (!event.hasOwnProperty('createdAt')) continue;
                    var eventDate = new Date(event.createdAt);
                    if (eventDate > raceDateFrom && eventDate < raceDateTo) {
                        event.date = eventDate;
                        item.events.push(event);
                    }
                };
                item.events.sort(function(a,b){
                    return a.date - b.date;
                })
                result.push(item);
            }
            return result;
        }

        function closeThread() {
            vm.currentThread = null;
            vm.selectedContent = null;
            vm.selectedContentID = null;
            vm.events = [];

            // Update the state without reloading the controller
            $state.go('app.site_overview.users.analytics', {}, { notify: false });
        }
/*
        // Watch screen size to change view modes
        $scope.$watch(function () {
            return $mdMedia('lt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                vm.currentView = 'split';
            }
        });

        $scope.$watch(function () {
            return $mdMedia('max-width: 960px');
        }, function (big) {

            if (big)
                vm.currentView = 'split';

        });

        $scope.$watch(function () {
            return $mdMedia('min-width: 960px');
        }, function (small) {

            if (small && vm.defaultView === 'split')
                vm.currentView = vm.defaultView;

        });

        $scope.$watch(function () {
            return $mdMedia('gt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }
            if (current) {
                if (vm.defaultView === 'split') {
                    vm.currentView = 'split';
                }
            }
        });
*/
        function initWatchers() {

            $scope.$watch(function(){
                return vm.fromDate;
            },function(current, old){
                if (angular.equals(current, old)) {
                    return;
                }
                loadUsers();
            })

            $scope.$watch(function(){
                return vm.toDate;
            },function(current, old){
                if (angular.equals(current, old)) {
                    return;
                }
                loadUsers();
            })

            $scope.$watch(function(){
                return vm.selectedTenants;
            },function(current, old){
                if (angular.equals(current, old)) {
                    return;
                }
                loadUsers();
            })

            $scope.$watch(function(){
                return vm.selectedRaces;
            },function(current, old){
                if (angular.equals(current, old)) {
                    return;
                }
                vm.filterColumnsRaces = current;
                updateDateRange();
                loadUsers();
            })
        }

        function setSortOrder(order) {
            vm.sortOrder = order;
        }

        function setSortField(field) {
            if (field == 'connectedTime') {
                field = 'connectedTimeInternal';
            }
            vm.fieldOrder = field;
        }

        function resetSortField() {
            vm.fieldOrder = undefined;
        }

        function exportAnalytics() {

            var exportData = [];

            // Assemble headers
            var mainColumns = angular.copy(vm.refcolumns);
            mainColumns = $filter('filter')(mainColumns, { table_list_position: 'main'});
            mainColumns = $filter('orderBy')(mainColumns, vm.orderByTableListSort);

            var headers = mainColumns.map(function(col) {
                return col.title;
            });
            angular.forEach(vm.filterColumnsRaces, function(col) {
                headers.push(col.title)
            });

            exportData.push(headers);

            // Assemble rows
            var rows = angular.copy(vm.threads);

            rows = $filter("filter")(rows, vm.tenantsFilter);
            rows = $filter("filter")(rows, vm.searchQuery);
            rows = $filter("orderBy")(rows, vm.fieldOrder, vm.sortOrder==='DESC');

            rows = rows.map(function(row) {
                var item = [];
                angular.forEach(mainColumns, function(col) {
                    if (row.hasOwnProperty(col.field_name)) {
                        item.push(row[col.field_name]);
                    }
                });
                angular.forEach(vm.filterColumnsRaces, function(col) {
                    angular.forEach(row.extra, function(val, key) {
                        if (col.field_name == key) {
                            item.push(formatSeconds(val));
                        }
                    })
                })
                return item;
             })
            Array.prototype.push.apply(exportData, rows);

            msUtils.exportToBrowser(exportData);
        }


        function updateDateRange() {
            let minMaxTimespan = getFromToTimespanByRaces(vm.selectedRaces);
            vm.fromDate = new Date(minMaxTimespan.dateFrom.replace(/-/g, '/'));
            vm.toDate = new Date(minMaxTimespan.dateTo.replace(/-/g, '/'));
        }

        /**
         * Used in users request. Returns 'fromDate' and 'toDate' properties as they are detected in the selected 'Races' filter options.
         */
        function getUsersTimespan() {
            return getFromToTimespanByRaces(vm.selectedRaces);
        }

        /**
         * Filter used in list-table-view to filter users which contains any of the selected 'Tenants' filter options.
         */
        function tenantsFilter(item) {
            if (vm.selectedTenants.length == 0 ||
                !item.hasOwnProperty('extra') || 
                !item.extra.hasOwnProperty('Tenants')
            ) {
                return true;
            }
            return item.extra.Tenants.some(r=> vm.selectedTenants.includes(r))
        }

        function orderByTableListSort(ref) {
            return parseInt(ref.table_list_sort);
        }

        function showExtra(extra) {
            var response = "";
            for (var key in extra) {
                response += msUtils.capitalize(key) + ': "' + extra[key] +'"';
            }
            return response;
        }


        /**
         * Returns object with 'dateFrom' and 'dateTo' properties,
         * where 'dateFrom' holds the earliest, 'dateTo' the latest identified dates in raceFilters.
         * @param raceFilters List of qiu_analytics_ref records of type 'race'.
         */
        function getFromToTimespanByRaces(raceFilters) {
            let fromDates = [];
            let toDates = [];
            angular.forEach(raceFilters, function(race) {
                let raw = JSON.parse(race.raw_settings);
                if (raw.hasOwnProperty('dateFrom')) {
                    fromDates.push(raw.dateFrom);
                }
                if (raw.hasOwnProperty('dateTo')) {
                    toDates.push(raw.dateTo);
                }
            })
            return {
                dateFrom: getMinMaxDate(fromDates, 'min'),
                dateTo: getMinMaxDate(toDates, 'max')
            }
        }


        /**
         * Returns min or max string date from list of string dates.
         * @param stringDates Array
         * @param minMax String 'max' | 'min'
         */
        function getMinMaxDate(stringDates, minMax) {
            var resultDateString = false;
            var resultDate = false;
            for (var i = stringDates.length - 1; i >= 0; i--) {
                var utcDateString = stringDates[i].replace(' ', 'T');
                var parsedDate = Date.parse(utcDateString);
                if (!resultDateString) {
                    resultDate = parsedDate;
                    resultDateString = stringDates[i];
                } else {
                    if (minMax == 'max') {
                        if (parsedDate > resultDate) {
                            resultDate = parsedDate;
                            resultDateString = stringDates[i];
                        }
                    } else {
                        if (parsedDate < resultDate) {
                            resultDate = parsedDate;
                            resultDateString = stringDates[i];
                        }
                    }
                } 
            }
            return resultDateString;
        }

        /**
         * Returns vm.fromDate as string with format 'yyyy-mm-dd 00:00:00'
         */
        function getFromDate() {
            return formatDate(angular.copy(vm.fromDate))  + ' 00:00:00';
        }

        /**
         * Returns vm.toDate as string with format 'yyyy-mm-dd 23:59:59'
         */
        function getToDate() {
            return formatDate(angular.copy(vm.toDate)) + ' 23:59:59';
        }

        /**
         * Returns date as 'yyyy-mm-dd' string
         */
        function formatDate(d) {
            var month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) 
                month = '0' + month;
            if (day.length < 2) 
                day = '0' + day;

            return [year, month, day].join('-');
        }

        /**
         * Returns time as '1 h 2 min' string
          */
        function formatSeconds(sec_num) {
            var hours   = Math.floor(sec_num / 3600);
            var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
            var seconds = sec_num - (hours * 3600) - (minutes * 60);

            var result = "";
            if (hours > 0) {
                //if (hours   < 10) {hours   = "0"+hours;}
                result += hours +" h";
            }
            if (minutes > 0) {
                if (result != "") result += " ";
                //if (minutes < 10) {minutes = "0"+minutes;}
                result += minutes +" min";
            }
            /*
            if (seconds > 0) {
                if (result != "") result += " ";
                //if (seconds < 10) {seconds = "0"+seconds;}
                result += seconds + " sec";
            }
            */
            if (result == "") result = "-";
            return result;
            //return new Date(seconds * 1000).toISOString().substr(11, 8)
        }

        $scope.$on('closeSidenav', function (ev, sidenavId) {
            $mdSidenav(sidenavId).close();
        })

        function isLarge(field) {
            return ['name', 'email', 'last_login', 'created_at'].includes(field);
        }
        function isMedium(field) {
            return ['mobile', 'skype', 'ingroup_status', 'country'].includes(field);
        }
        function isSmall(field) {
            return ['race_1', 'race_2'].includes(field);
        }
        function isMini(field) {
            return ['status', 'media', 'id_user'].includes(field);
        }

    }



})();

(function () {
	'use strict';

	angular
		.module('app.projects', ['ng-sortable'])
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
		$stateProvider.state('app.site_overview.projects.tasks', {
			url: '/tasks',
			views: {
				'content@app': {
					templateUrl: 'app/main/apps/tasks/tasks.html',
					controller: 'TasksController as vm'
				}
			},
			bodyClass: 'content'
		});

		$stateProvider
			.state('app.site_overview.projects', {
				abstract: true,
				url: '/projects',
				// controller: 'siteContentController',
				// views: {
				// 	'content@app': {
				// 		templateUrl: 'app/main/apps/content/content.html',
				// 		controller: 'ContentController as vm'
				// 	}
				// },
				// templateUrl: '/modules/site/content/views/site_content.html',
				onEnter: function ($stateParams) {
				},
				data: {
					displayName: '{{section}}'
				},
				resolve: {
					section: function ($stateParams) {
						return $stateParams.section
					},
				},
			})
		$stateProvider
			.state('app.site_overview.projects.tasks.list', {
				url: '',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/tasks/tasks.html',
						controller: 'TasksController as vm'
					}
				},
				// templateUrl: '/modules/site/content/views/site_content_list.html',
				// controller: 'siteContentListController',
				onEnter: function () {
				},
				data: {
					displayName: 'List {{section}}'
				},
				resolve: {
					// Cards: function (msApi)
					// {
					//	 return msApi.resolve('cards@get');
					// }
					//	 section: function ($stateParams) {
					//		 return $stateParams.section
					//	 }
				},
			})
			.state('app.site_overview.projects.tasks.list.thread', {
				url: '/:id',
				bodyClass: 'content'
			})
			.state('app.site_overview.projects.tasks.siteContentEdit', {
				url: '/:id/edit',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/tasks/views/edit/edit-view.html',
						controller: 'siteContentEditController as vm'
					}
				},
				// templateUrl: '/modules/site/content/views/site_content_edit.html',
				// controller: 'siteContentEditController',
				onEnter: function () {
				},
				data: {
					displayName: '{{dataItem.result.title}}'
				},
				resolve: {
					id: function ($stateParams) {
						return $stateParams.id
					},
					dataItem: function (requestContext, $stateParams, contentService) {
						// $scope.isLoading=true;
						var siteID = $stateParams.siteId;
						var id = $stateParams.id;
						var options = {
							site: $stateParams.siteId,
							id: $stateParams.id
						};
						return contentService.getByID(options);
						// return searchService.getSearchResults($route.current.params);
					}
				},
				// abstract:true,
			})

		$translatePartialLoaderProvider.addPart('app/main/apps/tasks');

	}
})();

(function () {
    'use strict';

    angular
        .module('app.projects')
        .factory("transformTasks", transformTasks);



    /** @ngInject */
    function transformTasks(mediaService) {

        var service = {
            getImageById: getImageById,
            userToDTO: userToDTO,
            DtoToUser: DtoToUser,
            formatNestedGroups: formatNestedGroups,
            initGroupsTree: initGroupsTree,
            getLabels: getLabels,
            getGroupsFromLabels: getGroupsFromLabels,
            updateThreadGroups: updateThreadGroups
        };

        function DtoToUser(user, siteID) {
            if (user.avatar)
                getImageById(user, siteID);
            
            var groupIds = [];
            for (var i = 0; i < user.groups.length; i++) {
                groupIds.push(user.groups[i].id_group);
            }
            user.groupIds = groupIds;
        }

        function userToDTO(user) {
            if (user.id_user !== '' && user.id_user !== undefined) {
                user.created_at = JSON.stringify(user.created_at);
                user.last_login = JSON.stringify(user.last_login);
                if (user.avatar)
                    user.avatar = user.avatar.id_media;
                return user;
            } else {
                delete user.created_at;
                delete user.last_login;
                if (user.avatar !== undefined) {
                    user.avatar = user.avatar.id_media;
                } else {
                    delete user.avatar;
                }
                return user;
            }
        }

        function getImageById(user, siteID) {
            var options = {
                domain: siteID,
                id_media: user.avatar
            };
            mediaService.getImageByID(options)
                .then(function (response) {
                    user.avatar = response.data[0];
                });
        }

        function formatNestedGroups(groups, qiuRestrictions, isRootCycle) {
            if (groups) {
                for (var i = 0; i < groups.length; i++) {
                    var group = groups[i];
                    group.label = group.name
                    group.is_qiu_restricted = isGroupQiuRestricted(group.id_group, qiuRestrictions);
                    group.is_qiu_restricted_root = isRootCycle && group.is_qiu_restricted;
                    if (group.children) {
                        formatNestedGroups(group.children, qiuRestrictions, false);
                    }
                }
                return groups;
            }
            return [];
        }

        function isGroupQiuRestricted(groupId, qiuRestrictions) {
            return (qiuRestrictions &&
                qiuRestrictions.hasOwnProperty('id_group') &&
                Object.values(qiuRestrictions.id_group).indexOf(groupId) > -1)
        }

        /**
         * Initializes group tree selector
         *
         * Loads array of available ingroup status into each tree branch for status selection
         * Loads group assignment and ingroup status from corresponding thread group into each tree branch (if any)
         * 
         * @param  {list} treeGroups          Nested list of groups
         * @param  {list} threadGroups        Groups of selected thread
         * @param  {array} usersIngroupStatus Contains in-group status values used as options in status dropdown selector
         * @return {list}                     Nested list of groups with initial values
         */
        function initGroupsTree(treeGroups, threadGroups, usersIngroupStatus) {
            if (treeGroups) {
                treeGroups = formatNestedGroups(treeGroups);
                for (var k = treeGroups.length-1; k >= 0; k--) {
                    treeGroups[k].ingroup_status = usersIngroupStatus;
                    if (threadGroups) {
                        for (var i =  threadGroups.length-1; i >= 0; i--) {
                            if (treeGroups[k].id_group == threadGroups[i].id_group) {
                                treeGroups[k].assigned_group = true;
                                treeGroups[k].id_ingroup_status = threadGroups[i].users_ingroup.id_ingroup_status;
                            }
                        }
                    }
                    if (treeGroups[k].children) {
                        initGroupsTree(treeGroups[k].children, threadGroups, usersIngroupStatus);
                    }
                }
                return treeGroups;
            }
        }

        function getLabels(treeGroups, result) {
            if (treeGroups) {
                for (var i = 0; i < treeGroups.length; i++) {
                    if (treeGroups[i].assigned_group === true) {
                        result.push({ label: treeGroups[i].label, group: treeGroups[i] });
                    }
                    if (treeGroups[i].children) {
                        getLabels(treeGroups[i].children, result);
                    }
                }
            }
            return result;
        }

        function getGroupsFromLabels(array) {
            var groups = [];
            for (var i = 0; i < array.length; i++) {
                groups.push(array[i].group);
            }
            return groups;
        }

        /**
         * updateThreadGroups
         *
         * updates list of thread groups by comparing groups from group tree selector
         * 
         * @param  {list}  treeGroups        Nested list of groups from group tree selector used for comparison
         * @param  {list}  threadGroups      List of thread groups to be updated
         * @param  {id}    idUser            Id from current thread
         * @param  {array} assignedGroupIds  Empty array filled over children iteartion with ids of assigned groups, used for final unassigned thread groups removal.
         */
        function updateThreadGroups(treeGroups, threadGroups, idUser, assignedGroupIds) {

            if (angular.isUndefined(threadGroups)) {
                threadGroups = [];
            }
            angular.forEach(treeGroups, function(treeGroup) { 
                if (treeGroup.assigned_group == true) {
                    assignedGroupIds.push(treeGroup.id_group);
                    var isThreadGroup = false;
                    angular.forEach(threadGroups, function(threadGroup) {
                        if (threadGroup.id_group == treeGroup.id_group) {
                            isThreadGroup = true;
                            // update users_ingroup settings from thread group
                            threadGroup.users_ingroup = {
                                id_user: idUser,
                                id_group: treeGroup.id_group,
                                id_ingroup_status: treeGroup.id_ingroup_status || null
                            };
                        }
                    });
                    // add new thread group
                    if (!isThreadGroup) {
                        var newGroup = {
                            id_group: treeGroup.id_group,
                            parent: treeGroup.parent,
                            name: treeGroup.name,
                            id_group_type: treeGroup.id_group_type,
                            sort: treeGroup.sort,
                            users_ingroup: {
                                id_user: idUser,
                                id_group: treeGroup.id_group,
                                id_ingroup_status: treeGroup.id_ingroup_status || null
                            }
                        }
                        threadGroups.push(newGroup);
                    }
                }
                if (typeof treeGroup.children !== 'undefined' && treeGroup.children.length >0) {
                    updateThreadGroups(treeGroup.children, threadGroups, idUser, assignedGroupIds);
                }
            })
            removeUnassignedThreadGroups(threadGroups, assignedGroupIds);
        }

        function removeUnassignedThreadGroups(threadGroups, assignedGroupIds){
            for (var i = threadGroups.length - 1; i >= 0; i--) {
                if (assignedGroupIds.indexOf(threadGroups[i].id_group) === -1) {
                    threadGroups.splice(i, 1);
                }
            }
        }

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.sitemap')
        .controller('SitemapImporterController', SitemapImporterController);

    /**
     * Sitemap > Importer: turns an annotated Figma frame into a sitemap page.
     *
     * 1. Simulate: dry run, shows the plan (widgets found, questions, errors, warnings). Nothing is written.
     * 2. Answer the questions (if any) and simulate again until the plan is ready.
     * 3. Import: writes the page. The first import creates a draft (onoff 0); importing the same frame again updates
     *    that page and keeps the blocks edited in the CMS since the last import (unless "overwrite" is checked).
     */
    /** Widget options that say where the content comes from: always visible in the plan. */
    var KEY_OPTIONS = ['Section', 'Show Fields', 'Main Title', 'reference_name'];

    /** name of the preview iframe (target of the POST to qiupreview). */
    var PREVIEW_FRAME = 'figma-import-preview';

    /**
     * Sitemap fields the importer sends (the Sitemap basic tab + name, language and URL); the API keeps the same
     * list (FigmaImport::PAGE_FIELDS).
     */
    var PAGE_FIELDS = ['name', 'lang', 'url', 'parent_sitemap', 'extension', 'external_url', 'cache_timeout', 'sub_item',
        'display_name', 'home', 'menu', 'menu_secondary', 'sort', 'sub_menu', 'id_section', 'id_subsec', 'id_cat',
        'id_subcat', 'show_cookiesbar', 'id_layout', 'header_sitemap', 'id_header', 'id_footer', 'body_class'];

    /** @ngInject */
    function SitemapImporterController($rootScope, $scope, $state, $timeout, $q, $document, $mdDialog, $translate,
                                       sessionService, sitemapService, settingUserService, backendService,
                                       contentService, figmaImportService) {
        var vm = this;

        // The active site (header selector): the templates listed and the import go to the same tenant, even if the
        // URL was opened for another one.
        vm.siteId = sessionService.site_operative.subdomain || $state.params.siteId;
        vm.form = {
            figma_url: '',
            id_template: null,
            force: false,
            refresh: false
        };
        vm.answers = {};
        vm.plan = null;
        vm.applied = null;
        vm.error = null;
        vm.loading = false;
        vm.templates = [];
        vm.summary = null;
        vm.open = {warnings: false, checks: false};
        vm.preview = null;
        vm.previewError = null;
        vm.previewLoading = false;
        vm.view = 'preview';
        vm.device = 'desktop';

        vm.simulate = simulate;
        vm.importPage = importPage;
        vm.reset = reset;
        vm.openSitemap = openSitemap;
        vm.isStatic = isStatic;
        vm.staticNames = staticNames;
        vm.formDirty = formDirty;
        vm.step = step;
        vm.templateHost = templateHost;
        vm.loadPreview = loadPreview;
        vm.openPreviewTab = openPreviewTab;

        // Breadcrumb like the other screens: SITEMAP > IMPORTER.
        $rootScope.global.titleToolbar = '<i class="icon s20 icon-sitemap mr-15"></i> <span class="hide show-gt-xs">Sitemap</span>'
            + ' <i class="mr-5 ml-5 icon s18 icon-chevron-right hide show-gt-xs"></i> Importer';

        // ---- Page configuration: app/main/apps/sitemap/views/edit/tabs/tab-basic.html is included as is, so this
        // controller offers what that template uses from SitemapController (same names, same behaviour).
        vm.currentSitemap = {type: 'static', url: '', name: '', home: 0, menu: 0, menu_secondary: 0, isHome: false,
                             isMenu: false, isMenuSecondary: false, id_section: [], id_subsec: []};
        vm.baseline = {};              // values the form was last filled with (template defaults or the imported page)
        vm.basicForm = {};
        vm.nolayout = false;
        vm.layoutSelected = null;
        vm.currentOptions = {layouts: [], footers: [], sub_menu_options: []};
        vm.typesSitemap = ['static', 'dynamic', 'external', 'redirect'];
        vm.dynamicStructures = [
            {value: 1, structure: 'Normal (ID+Slug)'},
            {value: 2, structure: '/LANG/URL/%slugs'},
            {value: 3, structure: '/LANG/URL/%url1/%slugs'},
            {value: 4, structure: '/LANG/URL/%url1/%url2/%slugs'},
            {value: 5, structure: '/LANG/URL/%url1/%url2/%url3/%slugs'}
        ];
        vm.langs = Object.values(sessionService.getSiteLanguages() || {}).map(function (x) {
            return {id: x.id_lang, name: x.lang_name};
        });
        vm.sections = [];
        vm.subsections = [];
        vm.categories = [];
        vm.subcategories = [];
        vm.sitemaps = [];
        vm.parentSitemap = null;
        vm.lookFrom = null;
        vm.translate = function (text) {
            return $translate.instant(text);
        };
        vm.changeLayout = changeLayout;
        vm.cleanValues = cleanValues;
        vm.editParentDialog = editParentDialog;
        vm.loadSectionReferences = loadSectionReferences;

        loadTemplates();
        loadPageOptions();
        // A template brings its own look (header, footer, classes…) and its own pages (for the parent).
        $scope.$watch(function () {
            return vm.form.id_template;
        }, function (idTemplate) {
            if (idTemplate) {
                loadTemplateDefaults(idTemplate);
                loadSitemaps(idTemplate);
            }
        });

        function loadTemplates() {
            sitemapService.getSubDomains({domain: sessionService.site_operative.id_domain}).then(function (subDomains) {
                vm.templates = (subDomains || []).filter(function (x) {
                    return x.id_template;
                });
                var byDefault = vm.templates.find(function (x) {
                    return x.default_template;
                });
                if (byDefault && !vm.form.id_template) {
                    vm.form.id_template = byDefault.id_template;
                }
            });
        }

        /** Layouts, footers and sub-menu pages (as SitemapController::init) and the sections for the callbacks. */
        function loadPageOptions() {
            sitemapService.getOptions({site: vm.siteId, lang: 1}).then(function (response) {
                response.layouts = unique(response.layouts, 'id_layout');
                response.headers = unique(response.headers, 'id_header');
                response.footers = unique(response.footers, 'id_footer');
                vm.currentOptions = response;
            });
            backendService.getSections({siteID: vm.siteId}).then(function (response) {
                vm.sections = response.data.map(function (x) {
                    return {id: x.id_section, name: x.section};
                });
                loadSectionReferences();
            });
        }

        function loadSitemaps(idTemplate) {
            sitemapService.get({siteID: vm.siteId, id_template: idTemplate, page: 1, searchStringFilter: '', groupIds: ''})
                .then(function (response) {
                    vm.sitemaps = response.data || [];
                    loadParentSitemap(vm.currentSitemap.parent_sitemap);
                });
        }

        function loadTemplateDefaults(idTemplate) {
            figmaImportService.pageDefaults(vm.siteId, idTemplate).then(function (defaults) {
                vm.lookFrom = defaults.reference;
                delete defaults.reference;
                applyBaseline(defaults);
            });
        }

        /**
         * Fills the page configuration with new starting values (a template's defaults, or the page a re-import
         * updates) without losing what the user changed: a field is replaced only while it still holds the previous
         * starting value.
         */
        function applyBaseline(values) {
            var page = vm.currentSitemap;
            angular.forEach(values, function (value, field) {
                if (PAGE_FIELDS.indexOf(field) === -1) {
                    return;
                }
                if (normalized(field, page[field]) === '' || normalized(field, page[field]) === normalized(field, vm.baseline[field])) {
                    page[field] = value;
                }
                vm.baseline[field] = value;
            });
            page.isHome = page.home == 1;
            page.isMenu = page.menu == 1;
            page.isMenuSecondary = page.menu_secondary == 1;
            page.id_section = toIdList(page.id_section);
            page.id_subsec = toIdList(page.id_subsec);
            vm.layoutSelected = page.id_layout !== null && page.id_layout !== undefined ? String(page.id_layout) : null;
            loadSectionReferences();
            loadParentSitemap(page.parent_sitemap);
        }

        /** A re-import updates an existing page: the form shows that page's own configuration. */
        function loadExistingPage(idSitemap) {
            if (!idSitemap || vm.existingPageId === idSitemap) {
                return;
            }
            vm.existingPageId = idSitemap;
            sitemapService.getSitemapByID({site: vm.siteId, id: idSitemap}).then(function (response) {
                var existing = response.sitemap || {};
                var values = {};
                PAGE_FIELDS.forEach(function (field) {
                    if (field in existing) {
                        values[field] = existing[field];
                    }
                });
                var sent = vm.lastBody ? vm.lastBody.page : {};
                applyBaseline(values);
                vm.currentSitemap.type = existing.type || vm.currentSitemap.type;
                // What the last simulation sent was already the page's own configuration: the plan is still current.
                var unchanged = Object.keys(sent || {}).every(function (field) {
                    return field === 'url' || normalized(field, sent[field]) === normalized(field, vm.baseline[field]);
                });
                if (unchanged && vm.lastBody) {
                    vm.lastBody = body(false);
                }
            });
        }

        /** Layout of the new page (no confirmation: unlike the Sitemap editor there are no widgets to lose here). */
        function changeLayout() {
            vm.currentSitemap.id_layout = vm.layoutSelected ? parseInt(vm.layoutSelected, 10) : null;
        }

        function cleanValues() {
            delete vm.currentSitemap.extension;
            delete vm.currentSitemap.external_url;
            delete vm.currentSitemap.sub_item;
        }

        function editParentDialog(ev) {
            $mdDialog.show({
                controller: 'selectSitemapDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/sitemap/dialogs/select-sitemap-dialog/select-sitemap-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {sitemaps: angular.copy(vm.sitemaps)}
            }).then(function (id) {
                if (id) {
                    vm.currentSitemap.parent_sitemap = id;
                    loadParentSitemap(id);
                }
            });
        }

        function loadParentSitemap(id) {
            vm.parentSitemap = id ? findNode(vm.sitemaps, id) : null;
        }

        function findNode(nodes, id) {
            for (var i = 0; i < (nodes || []).length; i++) {
                if (nodes[i].id_sitemap == id) {
                    return nodes[i];
                }
                var found = findNode(nodes[i].children, id);
                if (found) {
                    return found;
                }
            }
            return null;
        }

        /** Sub-sections, categories and sub-categories of the chosen callback sections (as SitemapController). */
        var sectionReferencesCache = {};

        function loadSectionReferences() {
            var ids = toIdList(vm.currentSitemap.id_section);
            if (!ids.length || !vm.sections.length) {
                vm.subsections = [];
                vm.categories = [];
                vm.subcategories = [];
                return;
            }
            $q.all(ids.map(function (id) {
                var section = vm.sections.find(function (x) {
                    return x.id == id;
                });
                if (!section) {
                    return $q.resolve({});
                }
                if (sectionReferencesCache[section.name]) {
                    return $q.resolve(sectionReferencesCache[section.name]);
                }
                return contentService.get({siteID: vm.siteId, section: section.name, resultsPerPage: 1}).then(function (response) {
                    return (sectionReferencesCache[section.name] = response.reference_sections || {});
                }, function () {
                    return {};
                });
            })).then(function (refs) {
                vm.subsections = merged(refs, 'subsection', 'id_subsec');
                vm.categories = merged(refs, 'cat', 'id_cat');
                vm.subcategories = merged(refs, 'subcat', 'id_subcat');
            });
        }

        function merged(refs, key, id) {
            return unique([].concat.apply([], refs.map(function (r) {
                return r[key] || [];
            })), id);
        }

        function unique(list, key) {
            var seen = {};
            return (list || []).filter(function (x) {
                return seen[x[key]] ? false : (seen[x[key]] = true);
            });
        }

        function toIdList(value) {
            if (Array.isArray(value)) {
                return value.map(String);
            }
            if (value === null || value === undefined || value === '') {
                return [];
            }
            return String(value).split(',').map(function (x) {
                return x.trim();
            }).filter(Boolean);
        }

        /**
         * What the page configuration changes, as the API expects it (same conversion as saving in the Sitemap
         * editor). Only the fields the user changed from the starting values: a new page gets the template's values
         * for the rest and a re-import keeps the page's own. The url always goes: it picks the page.
         */
        function pagePayload() {
            var page = sitemapService.sitemapToDTO(angular.copy(vm.currentSitemap));
            var out = {};
            PAGE_FIELDS.forEach(function (field) {
                if (field !== 'url' && normalized(field, page[field]) !== normalized(field, vm.baseline[field])) {
                    out[field] = Array.isArray(page[field]) ? page[field].join(',') : page[field];
                }
            });
            var url = String(page.url || '').trim().replace(/^\/+|\/+$/g, '');
            if (url) {
                out.url = url;
            }
            return out;
        }

        /** Comparable form of a field value: md-select gives strings, the API numbers; flags default to 0. */
        function normalized(field, value) {
            if (['home', 'menu', 'menu_secondary'].indexOf(field) !== -1) {
                return value == 1 ? '1' : '0';
            }
            if (Array.isArray(value)) {
                return value.join(',');
            }
            return value === null || value === undefined ? '' : String(value);
        }

        /** Request body shared by both steps. Answers left empty are sent as '' (= "none", e.g. cards without link). */
        function body(execute) {
            var b = {
                figma_url: vm.form.figma_url.trim(),
                id_template: vm.form.id_template,
                answers: angular.copy(vm.answers),
                refresh: vm.form.refresh,
                page: pagePayload()
            };
            if (execute) {
                b.execute = true;
                b.force = vm.form.force;
            }
            return b;
        }

        function simulate() {
            call(false);
        }

        function importPage() {
            call(true);
        }

        function call(execute) {
            vm.loading = true;
            vm.error = null;
            vm.applied = null;
            figmaImportService.run(vm.siteId, body(execute)).then(function (result) {
                setPlan(result.plan);
                vm.lastBody = body(false);
                // A download is reused for 10 minutes; ask for a fresh one only when the user ticks the box again.
                vm.form.refresh = false;
                if (result.applied) {
                    vm.applied = result.applied;
                    reveal('.result-card');
                } else {
                    vm.preview = result.preview || null;
                    vm.previewError = result.preview_error || null;
                    vm.view = vm.preview ? 'preview' : 'structure';
                    if (vm.preview) {
                        // After the digest, so the iframe of the new plan exists.
                        $timeout(loadPreview);
                        if (vm.preview.action === 'updated') {
                            loadExistingPage(vm.preview.id_sitemap);
                        }
                    }
                }
            }, function (e) {
                vm.error = e.message;
                reveal('.importer-banner.error');
            }).finally(function () {
                vm.loading = false;
            });
        }

        function setPlan(plan) {
            var summary = {widgets: 0, statics: 0, questions: plan.questions.length, errors: plan.errors.length,
                           warnings: plan.warnings.length};
            angular.forEach(plan.blocks, function (b) {
                if (isStatic(b)) {
                    summary.statics++;
                    return;
                }
                summary.widgets++;
                // Options worth showing: the ones with a value (a widget lists every option, most of them false).
                // Where the data comes from goes first; the rest stays folded.
                b.keyRows = [];
                b.moreRows = [];
                angular.forEach(b.instance && b.instance.data, function (v, k) {
                    if (v === false || v === 'false' || v === '' || v === null) {
                        return;
                    }
                    (KEY_OPTIONS.indexOf(k) !== -1 ? b.keyRows : b.moreRows).push({k: k, v: v});
                });
                b.showMore = false;
            });
            vm.summary = summary;
            vm.plan = plan;
            // Keep the answers already given and pre-fill the new questions with the API's suggestion.
            angular.forEach(plan.questions, function (q) {
                if (!(q.id in vm.answers)) {
                    vm.answers[q.id] = q.suggestion !== undefined ? q.suggestion : '';
                }
            });
        }

        /** The plan shown is stale when the form changed since the last simulation. */
        function formDirty() {
            return !!vm.plan && !angular.equals(vm.lastBody, body(false));
        }

        /**
         * The preview is the page qiupreview would render for this plan: its token (signed by the API, valid for 15
         * minutes) is POSTed to qiupreview into the iframe, or into a new tab. Nothing is stored.
         */
        function loadPreview() {
            var frame = document.querySelector('#sitemap-importer iframe[name="' + PREVIEW_FRAME + '"]');
            if (!frame || !postPreview(PREVIEW_FRAME)) {
                return;
            }
            vm.previewLoading = true;
            frame.onload = function () {
                $timeout(function () {
                    vm.previewLoading = false;
                });
            };
        }

        function openPreviewTab() {
            postPreview('_blank');
        }

        function postPreview(target) {
            if (!vm.preview) {
                return false;
            }
            // Built here instead of bound in the template: AngularJS treats form[action] as a resource URL.
            var form = document.createElement('form');
            form.method = 'POST';
            form.action = vm.preview.url;
            form.target = target;
            var input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'token';
            input.value = vm.preview.token;
            form.appendChild(input);
            document.body.appendChild(form);
            form.submit();
            document.body.removeChild(form);
            return true;
        }

        function reset() {
            vm.preview = null;
            vm.previewError = null;
            vm.previewLoading = false;
            vm.plan = null;
            vm.summary = null;
            vm.applied = null;
            vm.error = null;
            vm.answers = {};
            vm.lastBody = null;
        }

        /** 1 = link the frame, 2 = review the plan, 3 = imported. */
        function step() {
            if (vm.applied) {
                return 3;
            }
            return vm.plan ? 2 : 1;
        }

        /** Host of the selected template, shown before the page URL: the real one once a preview gave it. */
        function templateHost() {
            if (vm.preview && vm.preview.url) {
                var a = document.createElement('a');
                a.href = vm.preview.url;
                return a.host + '/';
            }
            var t = vm.templates.find(function (x) {
                return x.id_template === vm.form.id_template;
            });
            return t ? t.template_name + ' /' : '/';
        }

        /**
         * The Sitemap screen reopens the template filter and the page from the user settings (not from the URL), so
         * point both at the imported page before going there.
         */
        function openSitemap() {
            if (vm.plan.source.id_template) {
                settingUserService.setSetting('sitemap', 'subdomainFilter', vm.plan.source.id_template);
            }
            settingUserService.setSetting('sitemap', 'openedSitemapId', vm.applied.id_sitemap);
            $state.go('app.site_overview.sitemap.full.list', {siteId: vm.siteId});
        }

        function isStatic(block) {
            return block.type === 'static';
        }

        function staticNames(block) {
            var nodes = block.nodes || block.static || [];
            var names = nodes.slice(0, 4).map(function (n) {
                return n.name;
            });
            return names.join(', ') + (nodes.length > 4 ? ' … (+' + (nodes.length - 4) + ')' : '');
        }

        /** Brings the result or the error into view (they appear below a plan that can be long). */
        function reveal(selector) {
            $timeout(function () {
                var el = document.querySelector('#sitemap-importer ' + selector);
                if (el) {
                    el.scrollIntoView({behavior: 'smooth', block: 'center'});
                }
            });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.sitemap')
        .service('figmaImportService', FigmaImportService);

    /**
     * qiuv3-api FigmaImportController:
     *  - POST api/v1/domain/{domain}/figma/import: without execute it is a dry run that only returns the plan (and its
     *    preview); with execute it writes the page (a draft when it is created).
     *  - GET api/v1/domain/{domain}/figma/page-defaults: the sitemap fields a new page of a template starts with.
     */
    /** @ngInject */
    function FigmaImportService($http, $q, COMMON) {

        function url(domain, path) {
            return COMMON.BASE_API + '/domain/' + encodeURIComponent(domain) + '/figma/' + path;
        }

        function failure(response) {
            var data = response.data || {};
            return $q.reject({
                status: response.status,
                message: data.detail || data.message || data.title || ('HTTP ' + response.status)
            });
        }

        /**
         * @param {string} domain  subdomain of the site
         * @param {object} body    figma_url, id_template, answers, page (sitemap fields), execute, force, refresh
         * @return {Promise} resolves with {plan, preview?, applied?}; rejects with {status, message}
         */
        function run(domain, body) {
            return $http.post(url(domain, 'import'), body).then(function (response) {
                return response.data;
            }, failure);
        }

        /** @return {Promise} page fields (lang, id_layout, id_header, id_footer, body_class…) + reference url */
        function pageDefaults(domain, idTemplate) {
            return $http.get(url(domain, 'page-defaults'), {params: {id_template: idTemplate}}).then(function (response) {
                return response.data;
            }, failure);
        }

        return {
            run: run,
            pageDefaults: pageDefaults
        };
    }
})();

angular.module('app.users').filter('groupByUser', ['$parse', function ($parse) {
        return function (list, group_by) {
            var filtered = [];
            var prev_item = null;
            var group_changed = false;
            // this is a new field which is added to each item where we append "_CHANGED"
            // to indicate a field change in the list
            //was var new_field = group_by + '_CHANGED'; - JB 12/17/2013
            var new_field = 'group_by_CHANGED';

            if (group_by[0] === undefined) {
                return list;
            }

            // loop through each item in the list
            angular.forEach(list, function (item) {

                group_changed = false;

                // if not the first item
                if (prev_item !== null) {

                    // check if any of the group by field changed

                    //force group_by into Array
                    group_by = angular.isArray(group_by) ? group_by : [group_by];

                    //check each group by parameter
                    for (var i = 0, len = group_by.length; i < len; i++) {

                        if (prev_item.firstname !== '' && item.firstname !== '' && prev_item.firstname !== null && item.firstname !== null) {
                            if ($parse(group_by[i])(prev_item)[0].toUpperCase() !== $parse(group_by[i])(item)[0].toUpperCase()) {
                                group_changed = true;
                            }
                        } else if ($parse(group_by[i])(prev_item) !== $parse(group_by[i])(item)) {
                            group_changed = true;
                        }
                    }


                }// otherwise we have the first item in the list which is new
                else {
                    group_changed = true;
                }

                // if the group changed, then add a new field to the item
                // to indicate this
                if (group_changed) {
                    item[new_field] = true;
                } else {
                    item[new_field] = false;
                }

                filtered.push(item);
                prev_item = item;

            });

            return filtered;
        };
    }]);
(function () {
  'use strict';

  angular.module('app.sitemap')
    .controller('editWidgetDialogController', editWidgetDialogController);

  /** @ngInject */
  function editWidgetDialogController($scope, $rootScope, $translate, $mdDialog, $filter, dragulaService, sitemapService, usersService, backendService, site, widgets, widget, widgetsOptions, v2Widgets, sessionService, $http, tagsService, mediahubService, $q, COMMON) {

    var vm = this;
    $scope.global = $rootScope
    vm.widget = widget;
    vm.site = site;
    vm.selectedRef = [];
    vm.restrictions = undefined;

    vm.index = widgets.indexOf(widget);

    vm.widgetEditJson = false;
    vm.widgetEditTemplate = false;
    vm.showEdit = showEdit;
    vm.showEditJson = showEditJson;
    vm.showEditTemplate = showEditTemplate;
    vm.setValid = setValid;
    vm.isFilterMapingComplete = isFilterMapingComplete;
    vm.isNewFilterComplete = isNewFilterComplete;
    vm.valid = true;
    vm.closeDialog = closeDialog;
    vm.saveDialog = saveDialog;
    vm.selectChanged = selectChanged;
    vm.addFilterMapping = addFilterMapping;
    vm.cleanFilters = cleanFilters;
    vm.concatField = concatField;
    vm.deleteMapping = deleteMapping;
    vm.isMediaVisible = isMediaVisible;
    vm.editMapping = editMapping;
    vm.closeEdit = closeEdit;
    vm.pushFilter = pushFilter;
    vm.addCropformat = addCropformat;
    vm.constructWidget = constructWidget;
    vm.Math = window.Math;
    vm.filteredRestrictionStatus = filteredRestrictionStatus;
    vm.updateCrops = updateCrops;
    vm.queryTags = queryTags;
    vm.clearMediahubGallery = clearMediahubGallery;

    vm.mediahubTagsSelected = {};
    vm.teamsLayoutChips = {};
    vm.teamsSearchText = {};

    vm.updateTeamsLayout = updateTeamsLayout;
    vm.addTeamChip = addTeamChip;
    vm.removeTeamChip = removeTeamChip;
    vm.handleEnterKey = handleEnterKey;
    vm.addGroup = addGroup;
    vm.isField = function (v) { return v && (typeof v === 'string' || v.type === 'field'); };
    vm.isGroup = function (v) { return v && v.type === 'group'; };
    vm.removeSubChip = removeSubChip;

    init();

    function denormalizeChip(c) {
      if (!c) return '';
      if (typeof c === 'string') return c;
      if (c.type === 'field') return c.value;
      if (c.type === 'group') {
        return {
          type: 'group',
          class: c.class,
          id: c.id,
          fields: (c.fields || []).map(denormalizeChip)
        };
      }
      return c;
    }

    function clearMediahubGallery(fieldTitle) {
      if (vm.widget && vm.widget.data) {
        vm.widget.data[fieldTitle] = null;
        if (fieldTitle === 'Main Gallery') {
          vm.widget.data['Main Gallery Name'] = null;
        }
      }
    }

    function updateTeamsLayout(fieldTitle) {
      if (!vm.widget.data) vm.widget.data = {};
      var rawData = vm.teamsLayoutChips[fieldTitle] || [];

      var hasGroup = rawData.some(function (item) {
        return item && typeof item === 'object' && item.type === 'group';
      });

      if (hasGroup) {
        vm.widget.data[fieldTitle] = JSON.stringify(rawData.map(denormalizeChip));
      } else {
        vm.widget.data[fieldTitle] = rawData.map(function (item) {
          if (!item) return '';
          if (typeof item === 'string') return item;
          if (item.type === 'field') return item.value;
          return '';
        }).join(';');
      }
    }

    function addTeamChip(fieldTitle, chipValue) {
      if (chipValue) {
        if (!vm.teamsLayoutChips[fieldTitle]) {
          vm.teamsLayoutChips[fieldTitle] = [];
        }
        vm.teamsLayoutChips[fieldTitle].push({
          type: 'field',
          value: chipValue,
          _id: Math.random()
        });
        vm.updateTeamsLayout(fieldTitle);
      }
    }

    function removeTeamChip(fieldTitle, index) {
      if (vm.teamsLayoutChips[fieldTitle]) {
        vm.teamsLayoutChips[fieldTitle].splice(index, 1);
        vm.updateTeamsLayout(fieldTitle);
      }
    }

    function addGroup(fieldTitle) {
      if (!vm.teamsLayoutChips[fieldTitle]) {
        vm.teamsLayoutChips[fieldTitle] = [];
      }
      vm.teamsLayoutChips[fieldTitle].push({
        type: 'group',
        class: '',
        id: '',
        fields: [],
        _id: Math.random()
      });
      vm.updateTeamsLayout(fieldTitle);
    }

    function handleEnterKey(event, fieldTitle) {
      if (event.keyCode === 13) {
        event.preventDefault();
        event.stopPropagation();
        var text = vm.teamsSearchText[fieldTitle];
        if (text) {
          vm.addTeamChip(fieldTitle, text);
          vm.teamsSearchText[fieldTitle] = '';
        }
      }
    }

    function removeSubChip(fieldTitle, groupIndex, chipIndex) {
      if (vm.teamsLayoutChips[fieldTitle] && vm.teamsLayoutChips[fieldTitle][groupIndex]) {
        vm.teamsLayoutChips[fieldTitle][groupIndex].fields.splice(chipIndex, 1);
        vm.updateTeamsLayout(fieldTitle);
      }
    }

    function normalizeChip(c) {
      if (!c) return null;
      if (typeof c === 'string') return { type: 'field', value: c, _id: Math.random() };
      if (typeof c === 'object') {
        var copy = angular.copy(c);
        if (!copy._id) copy._id = Math.random();
        if (copy.type === 'group') {
          copy.fields = (copy.fields || []).map(normalizeChip);
        }
        return copy;
      }
      return c;
    }

    function processFields(fields) {
      if (!fields) return;
      fields.forEach(function (field) {
        if (field.type === 'tags') {
          if (vm.widget.data && vm.widget.data[field.title] && Array.isArray(vm.widget.data[field.title])) {
            vm.mediahubTagsSelected[field.title] = angular.copy(vm.widget.data[field.title]);
          } else if (!vm.mediahubTagsSelected[field.title]) {
            vm.mediahubTagsSelected[field.title] = [];
          }
        }
        if (field.type === 'teams-layout') {
          if (!vm.widget.data) vm.widget.data = {};
          var val = vm.widget.data[field.title];
          var chips = [];
          if (val && (val.indexOf('[') === 0 || val.indexOf('{') === 0)) {
            try {
              chips = JSON.parse(val);
            } catch (e) {
              chips = val.split(';').map(function (f) { return f.trim(); });
            }
          } else {
            chips = val ? val.split(';').map(function (f) { return f.trim(); }) : [];
          }
          vm.teamsLayoutChips[field.title] = chips.map(normalizeChip);
        }
        if (field.fields) {
          processFields(field.fields);
        }
      });
    }

    function init() {
      vm.mediahubGalleries = [];
      vm.searchTermGalleries = '';
      vm.mediahubError = false;
      vm.isLoadingGalleries = false;

      vm.mediahubCropformats = [];
      vm.mediahubCropformatsError = false;
      vm.isLoadingCropformats = false;

      vm.copyWidget = angular.copy(widget);

      // Pre-initialize fields from current widget data to avoid undefined chips in template
      if (vm.widget.fields) {
        processFields(vm.widget.fields);
      }

      // sitemapService.getSections not working some domains
      sitemapService.getSections({
        siteID: vm.site,
        mediaZones: 1,
        cropformats: 1,
        fields: 1,
        sub: 1
      }).then(function (response) {
        vm.sections = response;
        vm.optionsSection = {
          "name": "Section",
          "categories": [{ "value": 0, "name": "Content" }, { "value": 1, "name": "Media" }],
          "options": []
        };
        vm.sections.forEach(section => {
          section.category = 0;
          vm.optionsSection.options.push(section);
        });
        vm.optionsSection.options.push({ section: 'Files', "category": 1 });
        vm.optionsSection.options.push({ section: 'Galleries', "category": 1 });
        if (vm.widget.data && vm.widget.data.Section && vm.widget.data.Section.section) {
          getSelectedRef();
        }
        vm.gettedWidget = v2Widgets.find(getWidget => getWidget.id_widget == widget.id_widget);
        if (vm.gettedWidget) {
          constructWidget();
        } else {
          // Fallback if the widget type is not found in the global list
          vm.gettedWidget = { fields: vm.widget.fields || [] };
          constructWidget();
        }
      });
    }

    function constructWidget(replaceSection) {
      if (replaceSection) {
        vm.widget.data.Section = $rootScope.stringSection;
      }
      var widgetSections = (vm.optionsSection && vm.optionsSection.options) ? vm.optionsSection.options : [];
      if (!vm.widget.v1_layout) {
        vm.widget.v1_layout = vm.gettedWidget.v1_layout ? vm.gettedWidget.v1_layout : null;
      }
      if (vm.gettedWidget.fields) {
        vm.widget.fields = vm.gettedWidget.fields;
      }
      if (vm.widget.fields) {
        vm.showSourceAndFiltersTab = vm.widget.fields.filter(field => field.type === 'section' || field.title === 'Section').length > 0;
        vm.fieldsMapping = vm.widget.fields.find(field => field.type === 'fields' || field.type === 'show_fields');
        vm.mediacenterRestrictions = vm.widget.fields.find(field => field.type === 'mediacenter_restrictions');

        var hasMediahubGalleries = vm.widget.fields.some(f => f.type === 'mediahub galleries');
        var hasMediahubCropformats = vm.widget.fields.some(f => f.type === 'mediahub cropformats');

        if (hasMediahubGalleries || hasMediahubCropformats) {
          loadMediahubData(hasMediahubGalleries, hasMediahubCropformats);
        }
        if (vm.widget.fields.some(f => f.type === 'tags')) {
          loadTags();
        }
      }

      processFields(vm.widget.fields);

      vm.addTagBlock = function (fieldTitle) {
        if (!vm.mediahubTagsSelected[fieldTitle]) {
          vm.mediahubTagsSelected[fieldTitle] = [];
        }
        vm.mediahubTagsSelected[fieldTitle].push({ label: '', exclude: false, tags: [] });
      };

      vm.removeTagBlock = function (fieldTitle, index) {
        if (vm.mediahubTagsSelected[fieldTitle]) {
          vm.mediahubTagsSelected[fieldTitle].splice(index, 1);
        }
      };

      vm.cloneTag = function (chip) {
        if (angular.isObject(chip)) {
          var copy = angular.copy(chip);
          if (copy.exclude === undefined) { copy.exclude = false; }
          return copy;
        }
        return { tag_name: chip, exclude: false };
      };

      if (vm.widget.v1_layout) {
        if (vm.widget.data && vm.widget.data.Section && (typeof vm.widget.data.Section == 'string' || typeof vm.widget.data.Section == 'number')) {
          if (typeof vm.widget.data.Section == 'string') {
            $rootScope.stringSection = vm.widget.data.Section;
            var splitedSection = vm.widget.data.Section.split('|');
            var conditions = ["=", ">", "<", ">=", "<=", "!=", "IN", "NOT IN"];
            var sectionId = splitedSection[0];
            vm.widget.data.Section = {
              filters: [],
              section: ""
            };
            //Get section name
            vm.currentSection = widgetSections.find(x => x.id_section == sectionId);
            if (vm.currentSection) {
              vm.widget.data.Section.section = vm.currentSection.section;
            }
            //Get section filters
            var pushedSplitedSecions = [];
            for (var i = 1; i < splitedSection.length; i++) {
              for (var x = 0; x < conditions.length; x++) {
                if (splitedSection[i].indexOf(conditions[x]) != -1) {
                  if (!pushedSplitedSecions.includes(splitedSection[i])) {
                    pushedSplitedSecions.push(splitedSection[i]);
                    var splitCondition = splitedSection[i].split(conditions[x]);
                    var field = splitCondition[0];
                    var condition = conditions[x];
                    var value = splitCondition[1].substring(2);
                    if (value.indexOf(";") != -1) {
                      value = value.replace(";", "");
                    }
                    vm.widget.data.Section.filters.push({
                      field: field,
                      condition: condition,
                      value: value
                    });
                  }
                } else if (splitedSection[i].indexOf("order") != -1 || splitedSection[i].indexOf("limitCount") != -1) {
                  if (!pushedSplitedSecions.includes(splitedSection[i])) {
                    pushedSplitedSecions.push(splitedSection[i]);
                    var splitCondition = splitedSection[i].split(";");
                    var field = splitCondition[0];
                    if (splitCondition[1].indexOf(" ") != -1) {
                      var splitCondition = splitCondition[1].split(" ");
                      var condition = splitCondition[0];
                      var value = splitCondition[1];
                    } else {
                      var field = "limit";
                      var value = splitCondition[1];
                    }
                    var splitCondition = splitCondition[1].split(" ");
                    vm.widget.data.Section.filters.push({
                      field: field,
                      condition: condition,
                      value: value
                    });
                  }
                } else if (splitedSection[i].indexOf("onoff") != -1 || splitedSection[i].indexOf("lang") != -1) {
                  if (!pushedSplitedSecions.includes(splitedSection[i])) {
                    var splitCondition = splitedSection[i].split(";");
                    splitCondition[1] = splitCondition[1] ? splitCondition[1] = splitCondition[1] : "";
                    pushedSplitedSecions.push(splitedSection[i]);
                    vm.widget.data.Section.filters.push({
                      field: splitCondition[0],
                      value: splitCondition[1]
                    });
                  }
                } else {
                  if (!pushedSplitedSecions.includes(splitedSection[i])) {
                    if (splitedSection[i].indexOf(";") != -1) {
                      splitedSection[i] = splitedSection[i].replace(";", "");
                    }
                    pushedSplitedSecions.push(splitedSection[i]);
                    vm.widget.data.Section.filters.push({
                      field: "",
                      condition: "",
                      value: splitedSection[i]
                    });
                  }
                }
              }
            }
          } else if (typeof vm.widget.data.Section == 'number') {
            var sectionId = vm.widget.data.Section;
            vm.widget.data.Section = {
              filters: [],
              section: ""
            };
            //Get section name
            vm.currentSection = widgetSections.find(x => x.id_section == sectionId);
            if (vm.currentSection) {
              vm.widget.data.Section.section = vm.currentSection.section;
            }
          }
        } else if (vm.widget.data && vm.widget.data.Section && vm.widget.data.Section.section) {
          vm.currentSection = widgetSections.find(section => section.section == vm.widget.data.Section.section);
          if (vm.currentSection) {
            var id_section = vm.currentSection.id_section;
            var filters = [];
            if (vm.widget.data.Section.filters.length > 0) {
              for (var i = 0; i < vm.widget.data.Section.filters.length; i++) {
                var field = vm.widget.data.Section.filters[i].field;
                var condition = vm.widget.data.Section.filters[i].condition;
                var value = vm.widget.data.Section.filters[i].value;
                if (field == 'order' || field == 'limit') {
                  field = field == 'limit' ? field = 'limitCount' : field = field;
                  if (condition) {
                    var filter = field + ";" + condition + " " + value;
                  } else {
                    var filter = field + ";" + value;
                  }
                } else if (field == 'onoff' || field == 'lang') {
                  var filter = field + ";" + value;
                } else {
                  if (condition == "IN" || condition == "NOT IN") {
                    var filter = field + " " + condition + "(" + value + ")";
                  } else if (!condition) {
                    if (!value) {
                      var filter = field + ";";
                    } else {
                      var filter = field + "?;" + value;
                    }
                  } else {
                    var filter = field + condition + "?;" + value;
                  }
                }
                filters.push(filter);
              }
            }
            if (filters.length > 0) {
              $rootScope.stringSection = vm.currentSection.id_section + "|" + filters.join("|");
            } else {
              $rootScope.stringSection = vm.currentSection.id_section;
            }
          }
        } else if (!vm.widget.data) {
          vm.widget.data = {};
          vm.widget.data.Section = {
            filters: [],
            section: ""
          };
        }
        getSelectedRef();
      }
      if (vm.copyWidget.fields) {
        vm.template = vm.copyWidget.fields.find(x => x.type == 'template' && x.values.length > 0);
      }
      if (!vm.template) {
        vm.template = angular.copy(vm.gettedWidget.fields.find(x => x.type == 'template'));
        if (vm.template) {
          for (var i = 0; i < vm.template.values.length; i++) {
            if (!vm.template.values[i].position) {
              vm.template.values[i].position = i;
            }
          }
        }
      } else {
        for (var i = 0; i < vm.template.values.length; i++) {
          if (!vm.template.values[i].position) {
            vm.template.values[i].position = i;
          }
        }
      }

      if (vm.template && vm.widget.data && vm.widget.data["Show Fields"] && vm.widget.data["Show Fields"].length > 0) {
        var splitShowFields = vm.widget.data["Show Fields"].split("|");
        vm.widget.data["Show Fields"] = [];
        for (var i = 0; i < splitShowFields.length; i++) {
          if (splitShowFields[i].length > 0) {
            vm.template.values[i].onoff = 1;
            vm.template.values[i].value = splitShowFields[i];
          }
        }
      } else if (vm.widget.data && vm.widget.data["Show Fields"] && typeof vm.widget.data["Show Fields"] == 'string') {
        var splitShowFields = vm.widget.data["Show Fields"].split("|");
        vm.widget.data["Show Fields"] = [];
        for (var i = 0; i < splitShowFields.length; i++) {
          var showField = {
            type: "",
            value: splitShowFields[i]
          };
          if (i <= 9) {
            var position = 'position 0' + i;
          } else {
            var position = 'position ' + i;
          }
          if (vm.selectedRef) {
            var isFieldType = vm.selectedRef.filter(ref => ref.field == splitShowFields[i]).length > 0;
          } else {
            var section = vm.sections.find(x => x.section === vm.widget.data.Section.section).section;
            if (section) {
              backendService.getSectionRefFields({
                domain: vm.site,
                section: section
              }).then(function (response) {
                vm.selectedRef = response;
                var isFieldType = vm.selectedRef.filter(ref => ref.field == splitShowFields[i]).length > 0;
                if (isFieldType) {
                  showField.type = "field";
                }
              })
            }
          }
          if (isFieldType) {
            showField.type = "field";
          } else {
            showField.type = "text";
          }
          vm.widget.data["Show Fields"][position] = showField;
        }
        vm.fieldsMapping = vm.widget.fields.find(field => field.title === 'Show Fields');
        vm.mediacenterRestrictions = vm.widget.fields.find(field => field.type === 'mediacenter_restrictions');
      }

      if (vm.showSourceAndFiltersTab && !vm.widget.data) {
        vm.widget.data = {
          reference_name: "",
          Section: {
            section: "",
            filters: []
          }
        }
      }
      if (!vm.widget.config) {
        vm.widget.config = {
          tag: "div"
        }
      } else if (!vm.widget.config.tag) {
        vm.widget.config.tag = "div";
      }
      if (vm.mediacenterRestrictions) {
        vm.restrictionCrops = [];
        vm.sections.forEach(section => {
          if (Array.isArray(section.cropformats)) {
            const filteredCrops = section.cropformats.filter(item => item !== null);
            vm.restrictionCrops = vm.restrictionCrops.concat(filteredCrops);
          }
        });
        usersService.getUsersInGroupStatus(vm.site)
          .then(response => {
            vm.restrictionStatus = response;
            return usersService.getUsersGroup({
              siteID: vm.site,
              withoutUsers: true
            });
          })
          .then(response => {
            vm.restrictionGroups = response.data;
            vm.restrictions = vm.widget.data['Mediacenter Restrictions'] || [];
          })
          .catch(error => {
            console.error('Error occurred:', error);
          });
      }
    }

    function filteredRestrictionStatus(idGroup) {
      if (!vm.restrictionGroups || !vm.restrictionStatus) return [];
      let group = vm.restrictionGroups.find(x => x.id_group == idGroup);
      if (!group) return [];
      let status = vm.restrictionStatus.filter(x => x.id_group_type === group.id_group_type);
      return status;
    }

    function updateCrops(crop, res) {
      const index = res.cropformats.findIndex(element => element === crop.id_cropformats);
      if (index === -1) {
        res.cropformats.push(crop.id_cropformats);
      } else {
        res.cropformats.splice(index, 1);
      }
    }

    function addCropformat(widget, cropformatname, cropformatselected) {
      var crop = vm.cropFormatOptions.find(x => x.id_cropformats === cropformatselected);
      widget.cropformats.push(
        {
          name: cropformatname,
          id: crop.id_cropformats,
          width: crop.width,
          height: crop.height,
          proportional: crop.proportional
        }
      )
      vm.cropformatname = null;
      vm.cropformatselected = null;
    }

    function showEditJson() {
      vm.editjsonmodel = JSON.parse(JSON.stringify(vm.widget));
      vm.widgetEditJson = true;
    }

    function showEditTemplate() {
      vm.widgetEditTemplate = true;
      if (!vm.template) {
        vm.template = {
          type: "template",
          values: []
        };
      }
    }

    function isMediaVisible() {
      if (vm.widget.fields) {
        vm.showMedia = vm.widget.fields.filter(field => field.type === 'show_fields').length > 0;
        return vm.showMedia;
      } else {
        return false;
      }
    }

    function showEdit() {
      if (vm.template && vm.template.values.length == 0) {
        delete vm.template;
      } else if (vm.template && vm.template.values.length > 0) {
        vm.widget.fields.push(vm.template);
      }
      delete vm.editjsonmodel;
      vm.valid = true;
      vm.widgetEditJson = false;
      vm.widgetEditTemplate = false;
    }

    vm.fieldsConcat = [];
    vm.fieldsConcatTrue = [];
    vm.fieldsConcatFalse = [];
    vm.fieldFiltersIf = [];

    /**
     * Dragula configuration for builder elements
     */
    dragulaService.options($scope, 'crop', {
      copy: false,
      copySortSource: false,
      removeOnSpill: false,
      direction: 'vertical',
      moves: function (el, source, handle, sibling) {
        return handle.classList.contains('dragC');
      },
      invalid: function (el, handle) {
        return false; // don't prevent any drags from initiating by default
      }
    });

    dragulaService.options($scope, 'teams-layout-widget-bag', {
      copy: false,
      copySortSource: false,
      removeOnSpill: false,
      direction: 'vertical',
      moves: function (el, source, handle, sibling) {
        return handle.classList.contains('drag-handle') || handle.parentElement.classList.contains('drag-handle');
      }
    });

    /**
     * Drag and drop events for elements
     */
    $scope.$on('crop.drop', function (event, el, target, source, sibling) {

    });

    $scope.$on('teams-layout-widget-bag.drop-model', function () {
      function updateAllTeamsLayouts(fields) {
        if (!fields) return;
        fields.forEach(function (field) {
          if (field.type === 'teams-layout') {
            vm.updateTeamsLayout(field.title);
          }
          if (field.fields) {
            updateAllTeamsLayouts(field.fields);
          }
        });
      }
      updateAllTeamsLayouts(vm.widget.fields);
    });

    $scope.$on('$destroy', function () {
      if (dragulaService.find($scope, 'crop')) {
        dragulaService.destroy($scope, 'crop');
      }
      if (dragulaService.find($scope, 'teams-layout-widget-bag')) {
        dragulaService.destroy($scope, 'teams-layout-widget-bag');
      }
    });

    function setValid() {
      try {
        JSON.parse(document.getElementById("text-area-json-edit").value);
        vm.valid = true;
      } catch (error) {
        vm.valid = false;
      }
    }

    function concatField(array, field) {
      array.push({ field: field });
    }

    function pushFilter(filter) {
      vm.widget.data.Section.filters.push(filter);
    }

    function addFilterMapping(template) {
      if (template) {
        var newItem = {
          label: vm.labelToAdd,
          value: vm.valueToAdd
        }
        if (vm.positionToAdd) {
          var fieldsBackUp = [];
          for (var i = vm.positionToAdd - 1; i < vm.template.values.length; i++) {
            fieldsBackUp.push(vm.template.values[i]);
          }
          vm.template.values.splice(vm.positionToAdd - 1);
          vm.template.values.push(newItem);
          for (var i = 0; i < fieldsBackUp.length; i++) {
            vm.template.values.push(fieldsBackUp[i]);
          }
        } else {
          vm.template.values.push(newItem);
        }
        for (var i = 0; i < vm.template.values.length; i++) {
          vm.template.values[i].position = i;
        }
        vm.labelToAdd = "";
        vm.valueToAdd = "";
        vm.positionToAdd = undefined;
      } else {
        if (vm.editKey) {
          vm.closeEdit();
          return;
        }
        if (!vm.widget.data['Show Fields']) {
          vm.widget.data['Show Fields'] = [];
        }

        const firstField = vm.fieldWidget === 'custom' ? vm.fieldWidgetCustom : vm.fieldWidget;
        const value = getValueMapping(vm.fieldOptions, vm.fieldContent, vm.fieldContentCustom, vm.fieldsConcat, vm.fieldOptionsText);

        if (vm.fieldOptions === 'media') {
          vm.widget.data['Show Fields'][firstField] = { type: 'media' }
        } else if (vm.fieldOptions === 'if') {
          vm.widget.data['Show Fields'][firstField] = { type: 'if' };
          vm.widget.data['Show Fields'][firstField].filters = vm.fieldFiltersIf
          vm.widget.data['Show Fields'][firstField].true = vm.fieldOptionsTrue ? {
            type: vm.fieldOptionsTrue,
            value: getValueMapping(vm.fieldOptionsTrue, vm.fieldContentTrue, vm.fieldContentCustomTrue, vm.fieldsConcatTrue, vm.fieldOptionsTextTrue)
          } : null;
          vm.widget.data['Show Fields'][firstField].false = vm.fieldOptionsFalse ? {
            type: vm.fieldOptionsFalse,
            value: getValueMapping(vm.fieldOptionsFalse, vm.fieldContentFalse, vm.fieldContentCustomFalse, vm.fieldsConcatFalse, vm.fieldOptionsTextFalse)
          } : null;
          if (vm.widget.data['Show Fields'][firstField].true) {
            if (vm.widget.data['Show Fields'][firstField].true.type === 'media') {
              delete vm.widget.data['Show Fields'][firstField].true.value;
            }
            if (vm.widget.data['Show Fields'][firstField].true.type === '--') {
              vm.widget.data['Show Fields'][firstField].true = null;
            }
          }
          if (vm.widget.data['Show Fields'][firstField].false) {
            if (vm.widget.data['Show Fields'][firstField].false.type === 'media') {
              delete vm.widget.data['Show Fields'][firstField].false.value;
            }
            if (vm.widget.data['Show Fields'][firstField].false.type === '--') {
              vm.widget.data['Show Fields'][firstField].false = null;
            }
          }
        } else {
          vm.widget.data['Show Fields'][firstField] = { value: value, type: vm.fieldOptions }
        }
        vm.cleanFilters();
        vm.fieldWidget = null;
      }
    }

    function getValueMapping(fieldOptions, fieldContent, fieldContentCustom, fieldsConcat, fieldOptionsText) {
      if (fieldOptions === 'field') {
        return fieldContent === 'custom' ? fieldContentCustom : fieldContent
      }
      if (fieldOptions === 'concat') {
        var value = [];
        fieldsConcat.forEach(element => {
          if (typeof element === 'string') {
            value.push({ text: element });
          } else {
            value.push({ field: element.field });
          }
        });
        return value;
      }

      if (fieldOptions === 'media') {
        return false;
      }

      if (fieldOptions === 'text') {
        return fieldOptionsText;
      }
    }

    function editMapping(key) {
      vm.editKey = key;
      var firstField = vm.fieldsMapping.fields.filter(x => x.name === key);
      vm.fieldWidget = firstField.length > 0 ? key : 'custom';
      vm.fieldWidgetCustom = firstField.length > 0 ? null : key
      vm.fieldOptions = vm.widget.data['Show Fields'][key].type;
      fillEdit(vm.widget.data['Show Fields'][key], 'fieldContent', 'fieldContentCustom', 'fieldsConcat', 'fieldOptionsText');
      if (vm.widget.data['Show Fields'][key].type === 'if') {
        vm.fieldFiltersIf = vm.widget.data['Show Fields'][key].filters;
        vm.fieldOptionsTrue = vm.widget.data['Show Fields'][key].true ? vm.widget.data['Show Fields'][key].true.type : null
        if (vm.fieldOptionsTrue) {
          fillEdit(vm.widget.data['Show Fields'][key].true, 'fieldContentTrue', 'fieldContentCustomTrue', 'fieldsConcatTrue', 'fieldOptionsTextTrue');
        }
        vm.fieldOptionsFalse = vm.widget.data['Show Fields'][key].false ? vm.widget.data['Show Fields'][key].false.type : null
        if (vm.fieldOptionsFalse) {
          fillEdit(vm.widget.data['Show Fields'][key].false, 'fieldContentFalse', 'fieldContentCustomFalse', 'fieldsConcatFalse', 'fieldOptionsTextFalse');
        }
      }
    }

    function fillEdit(obj, fieldContent, fieldContentCustom, fieldsConcat, fieldOptionsText) {
      if (obj.type === 'field') {
        var secondField = vm.fieldsMapping.fields.filter(x => x.name === obj.value);
        vm[fieldContent] = secondField.length > 0 ? obj.value : 'custom';
        vm[fieldContentCustom] = secondField.length > 0 ? null : obj.value;
      }
      if (obj.type === 'concat') {
        vm[fieldsConcat] = [];
        obj.value.forEach(element => {
          vm[fieldsConcat].push(element.text ? element.text : { 'field': element.field })
        });
      }
      if (obj.type === 'media') {
        // do nothing
      }
      if (obj.type === 'text') {
        vm[fieldOptionsText] = obj.value;
      }
    }

    function closeEdit() {
      const firstField = vm.fieldWidget === 'custom' ? vm.fieldWidgetCustom : vm.fieldWidget;
      delete Object.assign(vm.widget.data['Show Fields'], { [firstField]: vm.widget.data['Show Fields'][vm.editKey] })[vm.editKey];
      vm.editKey = null;
      vm.addFilterMapping();
    }

    function isNewFilterComplete() {
      if (vm.labelToAdd) {
        return true;
      } else {
        return false;
      }
    }

    function isFilterMapingComplete() {
      const firstField = vm.fieldWidget === 'custom' ? vm.fieldWidgetCustom : vm.fieldWidget;
      if (firstField) {
        if (vm.fieldOptions === 'media') {
          return true
        }
        if (vm.fieldOptions === 'field') {
          const secondField = vm.fieldContent === 'custom' ? vm.fieldContentCustom : vm.fieldContent;
          if (secondField) {
            return true;
          }
        }
        if (vm.fieldOptions === 'concat' && firstField && vm.fieldsConcat.length > 0 || vm.fieldOptions === 'text' && firstField && vm.fieldOptionsText) {
          return true;
        }
        if (vm.fieldOptions === 'if' && vm.fieldFiltersIf.length > 0) {
          return true;
        }
      }
      return false;
    }

    function deleteMapping(key, template) {
      if (!template) {
        delete vm.widget.data['Show Fields'][key];
      } else if (template) {
        vm.template.values.splice(key.position, 1);
        for (var i = 0; i < vm.template.values.length; i++) {
          vm.template.values[i].position = i;
        }
      }
    }

    function selectChanged() {
      vm.widget.data.Section.filters = [];
      if (!(vm.widget.data.Section.section === 'Media' || vm.widget.data.Section.section === 'Users')) {
        getSelectedRef(true);
      }
    }

    $scope.keys = function (obj) {
      return obj ? Object.keys(obj) : [];
    }

    function getSelectedRef(override) {
      if (vm.widget.data && vm.widget.data.Section) {
        var section = vm.sections.find(x => x.section === vm.widget.data.Section.section);
      }
      if (section) {
        vm.selectedRef = section.fields;
        vm.cropFormatOptions = section.cropformats;
        if (override || !vm.widget.mediazones || vm.widget.mediazones.length === 0) {
          vm.widget.mediazones = section.mediaZones;
        }
      } else {
        vm.selectedRef = vm.widget.fields;
      }
      if (!vm.widget.cropformats) {
        vm.widget.cropformats = [];
      }
      if (override) {
        $rootScope.stringSection = section.id_section;
      }
    }

    function cleanFilters() {
      vm.fieldsConcat = [];
      vm.fieldsConcatTrue = [];
      vm.fieldsConcatFalse = [];
      vm.fieldWidgetCustom = null;
      vm.fieldOptions = null;
      vm.fieldOptionsTrue = null;
      vm.fieldOptionsFalse = null;
      vm.fieldContent = null;
      vm.fieldContentTrue = null;
      vm.fieldContentFalse = null;
      vm.fieldContentCustom = null;
      vm.fieldContentCustomTrue = null;
      vm.fieldContentCustomFalse = null;
      vm.fieldFiltersIf = [];
    }

    function saveDialog() {
      if (vm.restrictions && vm.restrictions.length > 0) {
        let filteredRestrictions = vm.restrictions.filter(x => x.group !== '' && x.group !== undefined);
        vm.widget.data['Mediacenter Restrictions'] = filteredRestrictions;
      }
      if (vm.widget.v1_layout) {
        vm.widget.data.Section = $rootScope.stringSection;
        var joinMediazones = [];
        if (vm.widget.mediaZones && vm.widget.mediaZones.length > 0) {
          for (var i = 0; i < vm.widget.mediazones.length; i++) {
            var thisMediazone = vm.widget.mediazones[i];
            if (thisMediazone.enabled == true) {
              for (var j = 0; j < thisMediazone.cropformats.length; j++) {
                joinMediazones.push(thisMediazone.cropformats[j].id);
              }
              vm.widget.data.default_zone = thisMediazone.id_zone;
            }
          }
        } else if (vm.widget.cropformats) {
          for (var i = 0; i < vm.widget.cropformats.length; i++) {
            if (vm.widget.data.cropformats && vm.widget.data.cropformats.indexOf(vm.widget.cropformats[i].id) == -1) {
              joinMediazones.push(vm.widget.cropformats[i].id);
            } else if (!vm.widget.data.cropformats) {
              vm.widget.data.cropformats = [];
              joinMediazones.push(vm.widget.cropformats[i].id);
            }
          }
        }
        if (!vm.widget.data.default_zone) {
          vm.widget.data.default_zone = 0;
        }
        if (joinMediazones.length > 0) {
          var backUpCrop = angular.copy(vm.widget.data.cropformats);
          if (backUpCrop.length > 0) {
            vm.widget.data.cropformats = backUpCrop + "|" + joinMediazones.join("|");
          } else {
            vm.widget.data.cropformats = joinMediazones.join("|");
          }
        }
        if (vm.widgetEditTemplate) {
          vm.widget.fields.find(x => x.type == 'template').values = vm.template.values;
        }
        var joinShowFields = [];
        if (vm.template) {
          for (var i = 0; i < vm.template.values.length; i++) {
            if (vm.template.values[i].onoff == 1) {
              if (vm.template.values[i].value) {
                joinShowFields.push(vm.template.values[i].value);
              } else {
                joinShowFields.push(vm.template.values[i].label);
              }
            } else {
              joinShowFields.push("");
            }
          }
        } else if (vm.widget.data && vm.widget.data["Show Fields"]) {
          for (const property in vm.widget.data["Show Fields"]) {
            if (vm.widget.data["Show Fields"][property].type == 'media') {
              joinShowFields.push('Media');
            } else {
              joinShowFields.push(vm.widget.data["Show Fields"][property].value);
            }
          }
        }
        if (joinShowFields.length > 0) {
          vm.widget.data["Show Fields"] = joinShowFields.join("|");
        }
      }

      function saveFields(fields) {
        if (!fields) return;
        fields.forEach(function (field) {
          if (field.type === 'tags') {
            if (!vm.widget.data) vm.widget.data = {};
            vm.widget.data[field.title] = angular.copy(vm.mediahubTagsSelected[field.title]);
          }
          if (field.type === 'mediahub galleries') {
            if (!vm.widget.data) vm.widget.data = {};
            var selectedId = vm.widget.data[field.title];
            
            if (field.title === 'Main Gallery') {
              if (selectedId === 0) {
                vm.widget.data['Main Gallery Name'] = 'Root';
              } else if (selectedId) {
                var selectedGallery = vm.mediahubGalleries.find(function (g) { return g.id === selectedId; });
                if (selectedGallery) {
                  vm.widget.data['Main Gallery Name'] = selectedGallery.name;
                }
              } else {
                vm.widget.data['Main Gallery Name'] = null;
              }
            }
            
            if (selectedId === null || selectedId === undefined || selectedId === '') {
              vm.widget.data[field.title] = null;
            }
          }
          if (field.type === 'teams-layout') {
            vm.updateTeamsLayout(field.title);
          }
          if (field.fields) {
            saveFields(field.fields);
          }
        });
      }

      saveFields(vm.widget.fields);

      if (vm.editjsonmodel) {
        try {
          widgets[vm.index] = JSON.parse(document.getElementById("text-area-json-edit").value);
          $mdDialog.hide();
        } catch (err) {
          const alert = $mdDialog.alert()
            .multiple(true)
            .title($translate.instant('SITEMAP.INVALID_JSON'))
            .textContent($translate.instant('SITEMAP.INVALID_JSON_DESC'))
            .ok($translate.instant('SITEMAP.CLOSE'));
          $mdDialog
            .show(alert)
        }
      } else {
        widgets[vm.index] = vm.widget;
        $mdDialog.hide();
      }
      delete $rootScope.stringSection;
    }

    function closeDialog() {
      widgets[vm.index] = vm.copyWidget;
      delete $rootScope.stringSection;
      $mdDialog.hide();
    }

    /**
     * Tell mediahubService which Iconik audience to ask for, so the galleries offered here are the
     * ones our own key can see. Same precedence as the media dialog: the account's own assignment
     * (users_settings.iconikGroup, set from Accounts) wins, with the tenant-wide default in
     * qiu_config.iconikGroup as the fallback for accounts nobody has assigned yet.
     *
     * Resolves either way — a failure here just leaves the fallback in place, and the feed still
     * loads (with whatever audience we could establish) rather than the dropdown coming back empty.
     */
    function resolveIconikGroup(tenantDefault, siteId) {
      mediahubService.setIconikGroupId(tenantDefault);   // apply the fallback right away
      if (!siteId) return $q.when();

      return $http.get(COMMON.BASE_API + '/domain/' + siteId + '/profile/getSettings')
        .then(function (res) {
          var rows = res.data || [];
          var row = rows.filter(function (r) { return r && r.id_domain; })[0] || rows[0];
          var settings = row && row.settings_json;
          if (angular.isString(settings)) settings = angular.fromJson(settings);
          if (settings && settings.iconikGroup) {
            mediahubService.setIconikGroupId(settings.iconikGroup);
          }
        })
        .catch(function () { /* keep the tenant default */ });
    }

    function loadMediahubData(loadGalleries, loadCropformats) {
      if (loadGalleries) vm.isLoadingGalleries = true;
      if (loadCropformats) vm.isLoadingCropformats = true;

      sessionService.loadDomainResourceSettings(site).then(function (response) {
        if (response && response.public) {
          var publicConfig = response.public;
          if (typeof publicConfig === 'string') {
            try {
              publicConfig = JSON.parse(publicConfig);
            } catch (e) { }
          }
          // Iconik mode: if the domain has an iconikUrl, galleries come from the Iconik
          // collections feed instead of the mediahub API. Cropformats still use mediahub (if any).
          if (publicConfig.iconikUrl && loadGalleries) {
            var iconikUrl = publicConfig.iconikUrl.replace(/\/$/, '');
            // Ask Iconik as our own audience (X-Group-Id), not anonymously. Without it the feed is
            // answered with the PUBLIC key, which on theoceanrace sees 2 collections out of ~700 —
            // so Main/Latest Gallery could only be pointed at what a logged-out visitor may see.
            // Resolved exactly like the media dialog does (account assignment first, tenant default
            // as fallback), so the tree offered is whatever the account is assigned to in Accounts.
            resolveIconikGroup(publicConfig.iconikGroup, site).then(function () {
              return $http.get(iconikUrl + '/en/mediacentre/image-library/feed.json', {
                headers: mediahubService.iconikHeaders()
              });
            }).then(function (res) {
              var gals = (res.data && res.data.galleries) ? res.data.galleries : [];
              var mapped = gals.map(function (g) {
                return { id: g.id, name: g.name || g.title || g.id, parentId: g.parent || null };
              });
              vm.mediahubGalleries = _formatGalleriesTree(mapped);
              vm.isLoadingGalleries = false;
            }).catch(function () {
              vm.mediahubError = true;
              vm.isLoadingGalleries = false;
            });
            loadGalleries = false; // handled by Iconik; don't reload from mediahub below
          }

          if (publicConfig.mediahubUrl) {
            var apiUrl = publicConfig.mediahubUrl;
            if (!apiUrl.endsWith('/')) {
              apiUrl += '/';
            }
            var mediahubTenant = publicConfig.mediahubTenant || 'demo1';
            var mediahubS3 = publicConfig.mediahubS3 || '';
            mediahubService.setApiUrl(apiUrl, mediahubTenant, mediahubS3);
            var mediahubApiKey = response.mediahub && response.mediahub['x-api-key'];
            mediahubService.setApiKey(mediahubApiKey);
            var reqConfig = { headers: { 'X-Tenant': mediahubTenant } };
            if (mediahubApiKey) {
              reqConfig.headers['x-api-key'] = mediahubApiKey;
            }

            // GALLERIES
            if (loadGalleries) {
              $http.get(apiUrl + 'galleries?resultsPerPage=1500', reqConfig).then(function (res) {
                if (res.data && res.data.success && res.data.data) {
                  vm.mediahubGalleries = _formatGalleriesTree(res.data.data);
                } else {
                  vm.mediahubError = true;
                }
                vm.isLoadingGalleries = false;
              }).catch(function () {
                vm.mediahubError = true;
                vm.isLoadingGalleries = false;
              });
            }

            // CROPFORMATS
            if (loadCropformats) {
              $http.get(apiUrl + 'formats?resultsPerPage=100', reqConfig).then(function (res) {
                if (res.data && res.data.success && res.data.data) {
                  vm.mediahubCropformats = res.data.data;
                } else {
                  vm.mediahubCropformatsError = true;
                }
                vm.isLoadingCropformats = false;
              }).catch(function () {
                vm.mediahubCropformatsError = true;
                vm.isLoadingCropformats = false;
              });
            }

          } else {
            if (loadGalleries) { vm.mediahubError = true; vm.isLoadingGalleries = false; }
            if (loadCropformats) { vm.mediahubCropformatsError = true; vm.isLoadingCropformats = false; }
          }
        } else {
          if (loadGalleries) { vm.mediahubError = true; vm.isLoadingGalleries = false; }
          if (loadCropformats) { vm.mediahubCropformatsError = true; vm.isLoadingCropformats = false; }
        }
      }).catch(function () {
        if (loadGalleries) { vm.mediahubError = true; vm.isLoadingGalleries = false; }
        if (loadCropformats) { vm.mediahubCropformatsError = true; vm.isLoadingCropformats = false; }
      });
    }

    function loadTags() {
      vm.isLoadingTags = true;
      tagsService.get({
        siteID: site,
        perPage: 200,
        verify: 1,
        page: 1
      }).then(function (res) {
        if (res && res.data) {
          vm.mediahubTags = res.data;
        } else {
          vm.mediahubTagsError = true;
        }
        vm.isLoadingTags = false;
      }).catch(function () {
        vm.mediahubTagsError = true;
        vm.isLoadingTags = false;
      });
    }

    function queryTags(query, selectedTags) {
      var results = query ? vm.mediahubTags.filter(createFilterFor(query)) : (vm.mediahubTags || []);

      if (selectedTags && selectedTags.length > 0) {
        var selectedTagNames = selectedTags.map(function (t) {
          var name = (typeof t === 'string') ? t : (t.tag_name || t.name || '');
          return angular.lowercase(name);
        });
        results = results.filter(function (tag) {
          return selectedTagNames.indexOf(angular.lowercase(tag.tag_name || '')) === -1;
        });
      }

      return results;
    }

    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(tag) {
        return (angular.lowercase(tag.tag_name).indexOf(lowercaseQuery) !== -1);
      };
    }

    function _formatGalleriesTree(galleries) {
      if (!galleries || !galleries.length) return [];

      var map = {};
      var roots = [];

      // Initialize map
      for (var i = 0; i < galleries.length; i++) {
        galleries[i].children = [];
        galleries[i].isMediahub = true;
        map[galleries[i].id] = galleries[i];
      }

      // Build tree structure
      for (var i = 0; i < galleries.length; i++) {
        var node = galleries[i];
        if (node.parentId !== null && map[node.parentId]) {
          map[node.parentId].children.push(node);
        } else {
          roots.push(node);
        }
      }

      // Flatten with depth prefixes
      var flatTree = [];
      function recurse(nodes, depth) {
        for (var i = 0; i < nodes.length; i++) {
          nodes[i].depth = depth;
          flatTree.push(nodes[i]);
          if (nodes[i].children && nodes[i].children.length > 0) {
            recurse(nodes[i].children, depth + 1);
          }
        }
      }
      recurse(roots, 0);
      return flatTree;
    }
  }
})();

(function () {
    'use strict';
  
    angular.module('app.sitemap')
      .controller('editLayoutDialogController', editLayoutDialogController);
  
    /** @ngInject */
    function editLayoutDialogController($scope, $rootScope, $translate, $mdDialog, $filter, site, layout) {
  
      var vm = this;
      $scope.global = $rootScope
      vm.site = site;
      vm.layout = layout;
      vm.copyLayout = angular.copy(layout);

      vm.closeDialog = closeDialog;
      vm.saveDialog = saveDialog;
  
      init();
  
      function init() {
      }

      function closeDialog() {
        $mdDialog.hide();
      }

      function saveDialog() {
        $mdDialog.hide(vm.copyLayout);
      }
    }
  })();
  
(function () {
    'use strict';

    angular
        .module('app.social', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {

        $stateProvider
            .state('app.site_overview.social', {
                abstract: true,
                url: '/social',
                onEnter: function ($stateParams) {


                },
                data: {
                    displayName: '{{section}}'
                },
                resolve: {
                    section: function ($stateParams) {
                        return $stateParams.section
                    },
                },


            })
            .state('app.site_overview.social.posts', {
                url: '/posts',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/social/social-posts/social-posts.html',
                        controller: 'SocialPostsController as vm'
                    }
                },
                onEnter: function () {
                },
                data: {
                    displayName: 'List {{section}}'
                },
                resolve: {
                    // Cards: function (msApi)
                    // {
                    //     return msApi.resolve('cards@get');
                    // }
                    section: function ($stateParams) {
                        return $stateParams.section
                    }
                },
            })
            .state('app.site_overview.social.accounts', {
                url: '/accounts',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/social/social-accounts/social-accounts.html',
                        controller: 'SocialAccountsController as vm'
                    }
                },
                onEnter: function () {
                },
                data: {
                    displayName: 'List {{section}}'
                },
                resolve: {
                    // Cards: function (msApi)
                    // {
                    //     return msApi.resolve('cards@get');
                    // }
                    section: function ($stateParams) {
                        return $stateParams.section
                    }
                },
            })

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/social');

    }
})();



(function () {
  'use strict';

  angular.module('app.social').controller('SocialAccountsController', SocialAccountsController);

  /** @ngInject */
  function SocialAccountsController($scope, $rootScope, $mdDialog, $mdMedia, requestContext, $timeout, $translate, sharedFunctionsForms) {

    var vm = this;
    $scope.isLoading = true;
    vm.loadingThreads = true;
    vm.scrollEl = angular.element('#thread-list')[0];
    vm.enterfirst = true;

    vm.basicForm = {};
    vm.searchTabText;
    vm.selectedTab = null;

    vm.currentThread = null;
    vm.selectedThreads = [];
    vm.basicForm = {};


    // Methods
    vm.init = init;


    vm.isSelected = isSelected;
    vm.toggleSelectThread = toggleSelectThread;
    vm.toggleSelectThreads = toggleSelectThreads;



    vm.addSocialNetworkPage = addSocialNetworkPage;

    vm.openMenu = openMenu;


    //////////

    init();

    /**
     * Initialize
     */
    function init() {
      var siteID = requestContext.getParam("siteId");
      var section = 'forms';

      $scope.siteID = siteID;
      $scope.section = section;

      $rootScope.global.titleToolbar = '<i class="icon s20 icon-folder-account mr-15" ng-if="node.icon"></i> ' + $translate.instant('SOCIAL');

    }


    // Watch screen size to change view modes
    $scope.$watch(function () {
      return $mdMedia('lt-sm');
    }, function (current, old) {
      if (angular.equals(current, old)) {
        return;
      }

      if (current) {
        vm.currentView = 'nosplit';
      }
    });

    $scope.$watch(function () {
      return $mdMedia('max-width: 960px');
    }, function (big) {

      if (big) {
        vm.currentView = 'nosplit';
      }

    });

    $scope.$watch(function () {
      return $mdMedia('min-width: 960px');
    }, function (small) {

      if (small) {
        vm.currentView = 'split';
      }

    });

    $scope.$watch(function () {
      return $mdMedia('gt-sm');
    }, function (current, old) {
      if (angular.equals(current, old)) {
        return;
      }

      if (current) {
        if (vm.defaultView === 'split') {
          vm.currentView = 'split';
        }
      }
    });

    $scope.$on('$includeContentLoaded', function (event, target) {
      $timeout(function () {
        vm.loadingView = false;
      }, 1000);
    });

    $scope.$on('pagination:loadStart', function (event) {
      // $anchorScroll();

      // Store the current scrollPos
      // vm.scrollPos = vm.scrollEl.scrollTop();

      // Scroll to the top
      // vm.scrollEl.scrollTop(0);
      if (!vm.enterfirst) {
        var elem = angular.element(document.getElementById('thread-list'));
        elem.scrollTopAnimated(0, 10);
      }

      // angular.element("#thread-list").scrollTop=0;
      vm.enterfirst = false;
      $scope.isLoading = true;
    });

    $scope.$on('pagination:loadPage', function (event) {
      $scope.isLoading = false;
      vm.dataAlreadyLoaded = true;
    });


    function addSocialNetworkPage(ev) {
      $mdDialog.show({
        controller: 'SocialDialogController',
        controllerAs: 'vm',
        locals: {
        },
        templateUrl: 'app/core/directives/ms-social-widget-share/social-dialog/social-dialog.html',
        targetEvent: ev,
        multiple: true,
        clickOutsideToClose: false
      }).then(function (response) {
        if (response) {
          $rootScope.pagination_resetquery();
        }
      });
    }

    function isSelected(thread) {
      return sharedFunctionsForms.isSelected(vm.selectedThreads, thread);
    }

    function toggleSelectThread(thread, event) {
      vm.selectedThreads = sharedFunctionsForms.toggleSelectThread(vm.selectedThreads, thread, event);
    }


    function toggleSelectThreads() {
      vm.selectedThreads = sharedFunctionsForms.toggleSelectThreads(vm.selectedThreads, vm.threads);
    }

    var originatorEv;

    function openMenu($mdMenu, ev) {
      originatorEv = ev;
      $mdMenu.open(ev);
    }


  }

})();

(function () {
    'use strict';

    angular
        .module('app.social')
        .service('socialAccountsService', socialAccountsService);

    /** @ngInject */
    // I provide access to the session store.
    function socialAccountsService($q, $resource, settingsDomainService, sessionService, COMMON, $window) {

        function get(options) {
            if (!angular.isArray(options.groupIds) || options.groupIds.length === 0) {
                return getSocial(options);
            } else {
                return getSocialAccountsInGroup(options);
            }
        }

        function getSocial(options) {
            var deferred = $q.defer();
            var filters = [];

            _.forEach(options, function (value, key, list) {
                if (_.isObject(list[key])) {
                    _.forEach(list[key], function (filter, keyFilter, listFilter) {
                        if (!_.isEmpty(filter.selected)) {
                            filters.push({
                                field: filter.field,
                                name: filter.name,
                                values: filter.selected
                            });
                        }
                    });
                }
            });

            resourceSocialAccounts.get({
                domain: options.siteID,
                page: options.page,
                search: options.searchStringFilter,
                paginate: options.paginate,
                sortField: options.sortField,
                sortDir: options.sortDir,
                filters: JSON.stringify(filters),
                resultsPerPage: options.resultsPerPage
            },
                function (response) {
                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);

                },
                function (e) {
                    console.error(e)
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getOptions(options) {
            var deferred = $q.defer();

            // Return the promise.
            return (deferred.promise);
        }

        function getSocialProviders(options) {

            var deferred = $q.defer();

            var opts = {
                domain: options.siteID
            };

            resourceSocialProviders.get(
                opts,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    deferred.reject();
                }
            );

            return (deferred.promise);
        }

        function getSocialAccountsInGroup(options) {

            var deferred = $q.defer();

            var opts = {
                domain: options.siteID,
                'id_group[]': options.groupIds,
                sortField: options.sortField,
                sortDir: options.sortDir,
                resultsPerPage: options.resultsPerPage,
                page: options.page,
                search: options.searchStringFilter
            };
            /*
            if (options.ingroupStatus && options.ingroupStatus != "0") {
                opts.ingroupStatus = parseInt(options.ingroupStatus);
            }
            */

            resourceSocialAccountsInGroup.get(
                opts,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    deferred.reject();
                }
            );

            return (deferred.promise);
        };



        function getSocialAccountsGroups(options) {
            var deferred = $q.defer();

            resourceSocialAccountsGroups.get({
                domain: options.siteID
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getSocialAccountsGroupsNested(options) {
            var deferred = $q.defer();


            resourceSocialAccountsGroupsNested.get({
                domain: options.siteID,
                sortDir: options.sortDir || 'ASC',
                sortField: options.sortField || 'name'
            },
                function (response) {
                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);

                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function createSocialAccountsGroup(options) {
            var deferred = $q.defer();
            resourceSocialAccountsGroups.post({
                domain: options.siteID,
                parent: options.parentGroupId,
                name: options.groupName
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);

        }

        function editSocialAccountsGroup(options) {
            var deferred = $q.defer();
            resourceSocialAccountsGroups.update({
                domain: options.siteID,
                parent: options.parentGroupId,
                name: options.groupName,
                id: options.groupId
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);

        }

        function deleteSocialAccountsGroup(options) {
            var deferred = $q.defer();
            resourceSocialAccountsGroups.delete({
                domain: options.siteID,
                id: options.groupId
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    deferred.reject(e);
                }
            );
            return (deferred.promise);
        }

        function massInsertIntoGroups(options) {
            var deferred = $q.defer();
            resourceSocialAccountsInGroupsMassInsert.post({
                domain: options.siteID
            }, JSON.stringify(options.data),
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function removeFromGroup(options) {
            var deferred = $q.defer();
            resourceSocialAccountsInGroup.delete({
                domain: options.siteID,
                id: options.id_group,
                'id_social_account[]': options.ids
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function addToGroup(options) {
            var deferred = $q.defer();
            resourceSocialAccountsInGroup.post({
                domain: options.siteID,
                id: options.id_group
            }, {
                id: options.id_group,
                id_social_account: options.ids
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }


        var resourceSocialAccounts = $resource(COMMON.BASE_API + "/domain/:domain/socialAccounts", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });

        var resourceSocialProviders = $resource(COMMON.BASE_API + "/domain/:domain/social/providers", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: true
                }
            });

        var resourceSocialAccountsInGroup = $resource(COMMON.BASE_API + "/domain/:domain/socialAccountsInGroup/:id", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false
            },
            delete: {
                method: "DELETE",
                isArray: true
            },
            update: {
                method: "PUT",
                isArray: true
            },
            post: {
                method: "POST",
                isArray: true
            }
        });

        var resourceSocialAccountsGroups = $resource(COMMON.BASE_API + "/domain/:domain/socialAccountsGroups/:id", {
            // No default data.
            domain: '@domain',
            id: '@id'
        }, {
            get: {
                method: "GET",
                isArray: false
            },
            post: {
                method: "POST"
            },
            update: {
                method: "PUT"
            },
            delete: {
                method: "DELETE",
                isArray: true
            }
        });

        var resourceSocialAccountsGroupsNested = $resource(COMMON.BASE_API + "/domain/:domain/socialAccountsGroupsNested", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false,
                transformResponse: function(data, headers){
                    var response = {}
                    response.data = JSON.parse(data);
                    response.qiuRestrictions = JSON.parse(headers('qiu-restrictions'));
                    return response;
                }
            }
        });

        var resourceSocialAccountsInGroupsMassInsert = $resource(
            COMMON.BASE_API + "/domain/:domain/socialAccountsInGroups/massInsert", {
                // No default data.

            }, {
                post: {
                    method: "POST",
                    //isArray: true
                }
            }
        );

        return ({
            get: get,
            getSocial: getSocial,
            getFilters: getOptions,
            getSocialProviders: getSocialProviders,
            getSocialAccountsGroups: getSocialAccountsGroups,
            getSocialAccountsGroupsNested: getSocialAccountsGroupsNested,
            getSocialAccountsInGroup: getSocialAccountsInGroup,
            createSocialAccountsGroup: createSocialAccountsGroup,
            editSocialAccountsGroup: editSocialAccountsGroup,
            deleteSocialAccountsGroup: deleteSocialAccountsGroup,
            massInsertIntoGroups: massInsertIntoGroups,
            addToGroup: addToGroup,
            removeFromGroup: removeFromGroup
        });

    }

})();
(function () {
  'use strict';

  angular.module('app.social').controller('SocialAccountsController', SocialAccountsController);

  /** @ngInject */
  function SocialAccountsController($scope, $rootScope, $mdDialog, $mdMedia, requestContext, $timeout, $translate,
    sharedFunctionsForms, socialAccountsService, $mdToast, msUtils) {

    var vm = this;
    $scope.isLoading = true;
    vm.loadingThreads = true;
    vm.scrollEl = angular.element('#thread-list')[0];
    vm.enterfirst = true;

    vm.basicForm = {};
    vm.searchTabText;
    vm.selectedTab = null;

    vm.currentThread = null;
    vm.selectedThreads = [];
    vm.basicForm = {};

    vm.isOpenSidenavGroups = true;
    vm.groups = false;
    vm.qiuRestrictions = false;
    vm.selectedGroup = false;

    vm.showQiuGroupsSidenav = true;

    vm.sortGroupsField = 'name';
    vm.sortGroupsDir = 'ASC';
    vm.sortGroupsBy = {
      "USERS.NAME": "name",
      "USERS.UPDATED_AT": "updated_at",
      "USERS.ID": "id_group",
      "USERS.SORT": "sort"
    };

    // Methods
    vm.init = init;

    vm.isSelected = isSelected;
    vm.toggleSelectThread = toggleSelectThread;
    vm.toggleSelectThreads = toggleSelectThreads;
    vm.addSocialNetworkPage = addSocialNetworkPage;
    vm.openMenu = openMenu;

    vm.toggleQiuGroupsSidenav = toggleQiuGroupsSidenav;
    vm.getSocialAccounts = getSocialAccounts;
    vm.createSocialAccountsGroup = createSocialAccountsGroup;
    vm.editSocialAccountsGroup = editSocialAccountsGroup;
    vm.deleteSocialAccountsGroup = deleteSocialAccountsGroup;
    vm.sortSocialAccountsGroups = sortSocialAccountsGroups;
    vm.massInsertIntoGroups = massInsertIntoGroups;
    vm.removeFromGroup = removeFromGroup;

    //////////

    init();

    /**
     * Initialize
     */
    function init() {
      var siteID = requestContext.getParam("siteId");
      var section = 'forms';

      $scope.siteID = siteID;
      $scope.section = section;

      $rootScope.global.titleToolbar = '<i class="icon s20 icon-folder-account mr-15" ng-if="node.icon"></i> ' + $translate.instant('SOCIAL');
      getSocialAccountsGroups();
    }

    function getSocialAccountsGroups() {
      var currentlySelectedGroup = angular.copy(vm.selectedGroup);
      var options = {
        siteID: $scope.siteID,
        sortField: vm.sortGroupsField,
        sortDir: vm.sortGroupsDir
      }
      socialAccountsService.getSocialAccountsGroupsNested(options).then(function(response) {
        if (currentlySelectedGroup) {
            var newSelectedGroup = msUtils.getGroupByIdNested(response.data, currentlySelectedGroup.id_group);
            if (newSelectedGroup) {
                newSelectedGroup.is_selected_group = true;
            }
        }
        vm.groups = response.data;
        vm.qiuRestrictions = response.qiuRestrictions;
      });
    }

    function sortSocialAccountsGroups(field, dir) {
      vm.sortGroupsField = field;
      vm.sortGroupsDir = dir;
      getSocialAccountsGroups();
    }

    // Watch screen size to change view modes
    $scope.$watch(function () {
      return $mdMedia('lt-sm');
    }, function (current, old) {
      if (angular.equals(current, old)) {
        return;
      }

      if (current) {
        vm.currentView = 'nosplit';
      }
    });

    $scope.$watch(function () {
      return $mdMedia('max-width: 960px');
    }, function (big) {

      if (big) {
        vm.currentView = 'nosplit';
      }

    });

    $scope.$watch(function () {
      return $mdMedia('min-width: 960px');
    }, function (small) {

      if (small) {
        vm.currentView = 'split';
      }

    });

    $scope.$watch(function () {
      return $mdMedia('gt-sm');
    }, function (current, old) {
      if (angular.equals(current, old)) {
        return;
      }

      if (current) {
        if (vm.defaultView === 'split') {
          vm.currentView = 'split';
        }
      }
    });

    $scope.$on('$includeContentLoaded', function (event, target) {
      $timeout(function () {
        vm.loadingView = false;
      }, 1000);
    });

    $scope.$on('pagination:loadStart', function (event) {
      // $anchorScroll();

      // Store the current scrollPos
      // vm.scrollPos = vm.scrollEl.scrollTop();

      // Scroll to the top
      // vm.scrollEl.scrollTop(0);
      if (!vm.enterfirst) {
        var elem = angular.element(document.getElementById('thread-list'));
        elem.scrollTopAnimated(0, 10);
      }

      // angular.element("#thread-list").scrollTop=0;
      vm.enterfirst = false;
      $scope.isLoading = true;
    });

    $scope.$on('pagination:loadPage', function (event) {
      $scope.isLoading = false;
      vm.dataAlreadyLoaded = true;
    });

    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */
    function toggleQiuGroupsSidenav(sidenavId) {
      vm.showQiuGroupsSidenav = !vm.showQiuGroupsSidenav;
    }

    function getSocialAccounts(groupIds) {
      $rootScope.pagination_groupIds = groupIds;
      $scope.isLoading = true;
      var options = {
        siteID: $scope.siteID,
        sortDir: $rootScope.sortDir,
        sortField: $rootScope.sortField,
        page: 1,
        resultsPerPage: $rootScope.perPage,
        searchStringFilter: '',
        groupIds: groupIds
      };
      socialAccountsService.get(options).then(function (response) {
        vm.threads = response.data;
        $rootScope.pagination_totalItems = response.total;
        $rootScope.pagination_total_pages = response.last_page;
        if ($rootScope.pagination_page != response.current_page) {
          $rootScope.pagination_page = response.current_page;
        }
        vm.selectedThreads = [];
        $scope.isLoading = false;
      });
    }

    function createSocialAccountsGroup(groupName, parentGroupId) {
      var options = {
        siteID: $scope.siteID,
        groupName: groupName,
        parentGroupId: parentGroupId
      };
      socialAccountsService.createSocialAccountsGroup(options).then(function(response){
        getSocialAccountsGroups()
      })
    }

    function editSocialAccountsGroup(group, groupName, parentGroupId) {
      var options = {
        siteID: $scope.siteID,
        groupId: group.id_group,
        groupName: groupName,
        parentGroupId: parentGroupId
      };
      socialAccountsService.editSocialAccountsGroup(options).then(function(response){
        getSocialAccountsGroups()
      })
    }

    function deleteSocialAccountsGroup(group) {
      var options = {
        siteID: $scope.siteID,
        groupId: group.id_group
      };
      socialAccountsService.deleteSocialAccountsGroup(options).then(function(response){
        getSocialAccountsGroups()
      })
    }

    function addSocialNetworkPage(ev) {

      let selGroup = false;
      if (vm.selectedGroup) {
        selGroup = vm.selectedGroup;
      } else {
        // Force root group assignment if root group is the only one available.
        if (vm.groups.length === 1 && !vm.groups[0].hasOwnProperty('children')) {
          selGroup = vm.groups[0];
        }
      }

      $mdDialog.show({
        controller: 'SocialDialogController',
        controllerAs: 'vm',
        locals: {
          selectedGroup: selGroup,
          qiuRestrictedRootGroup: vm.groups[0].is_qiu_restricted_root ? vm.groups[0] : null
        },
        templateUrl: 'app/core/directives/ms-social-widget-share/social-dialog/social-dialog.html',
        targetEvent: ev,
        multiple: true,
        clickOutsideToClose: false
      }).then(function (response) {
        if (response) {
          $rootScope.pagination_resetquery();
        }
      });
    }

    function massInsertIntoGroups(itemIds, groups){

      var options = {
          siteID: $scope.siteID,
          data: {
              id_social_accounts: itemIds,
              groups: groups
          }
      };
      socialAccountsService.massInsertIntoGroups(options)
          .then(function (response) {
              vm.reload = true;
              if (itemIds.length == 1) {
                  var message = $translate.instant('SOCIAL.ADDTOGROUPS_SINGULAR');
              } else {
                  var message = itemIds.length + ' ' + $translate.instant('SOCIAL.ADDTOGROUPS_PLURAL');
              }
              vm.loading = false;
              $mdToast.show({
                  template: '<md-toast id="language-message"><span class="md-toast-text" flex>' + message + '</span><md-button ng-click="closeToast()">X</md-button></md-toast>',
                  hideDelay: 7000,
                  position: 'top right',
                  parent: '#main'
              });
          });
    }

    function removeFromGroup(idGroup, itemIds) {
      var options = {
          siteID: $scope.siteID,
          ids: itemIds,
          id_group: idGroup
      };
      socialAccountsService.removeFromGroup(options)
          .then(function (response) {
              vm.loading = false;
              if (itemIds.length == 1) {
                  var message = $translate.instant('SOCIAL.REMOVEFROMGROUP_SINGULAR');
              } else {
                  var message = itemIds.length + ' ' + $translate.instant('SOCIAL.REMOVEFROMGROUP_PLURAL');
              }
              $mdToast.show({
                  template: '<md-toast id="language-message"><span class="md-toast-text" flex>' + message + '</span><md-button ng-click="closeToast()">X</md-button></md-toast>',
                  hideDelay: 7000,
                  position: 'top right',
                  parent: '#main'
              });
              vm.selectedThreads = [];
              $rootScope.pagination_resetquery();
      })
    }


    function isSelected(thread) {
      return sharedFunctionsForms.isSelected(vm.selectedThreads, thread);
    }

    function toggleSelectThread(thread, event) {
      vm.selectedThreads = sharedFunctionsForms.toggleSelectThread(vm.selectedThreads, thread, event);
    }


    function toggleSelectThreads() {
      vm.selectedThreads = sharedFunctionsForms.toggleSelectThreads(vm.selectedThreads, vm.threads);
    }

    var originatorEv;

    function openMenu($mdMenu, ev) {
      originatorEv = ev;
      $mdMenu.open(ev);
    }


  }

})();

(function () {
    'use strict';

    angular
        .module('app.social')
        .service('socialPostsService', socialPostsService);

    /** @ngInject */
    // I provide access to the session store.
    function socialPostsService($q, $resource, settingsDomainService, sessionService, COMMON, $window) {

        function getSocial(options) {
            var deferred = $q.defer();
            var filters = [];

            _.forEach(options, function (value, key, list) {
                if (_.isObject(list[key])) {
                    _.forEach(list[key], function (filter, keyFilter, listFilter) {
                        if (!_.isEmpty(filter.selected)) {
                            filters.push({
                                field: filter.field,
                                name: filter.name,
                                values: filter.selected
                            });
                        }

                    });

                }
            });


            resourceSocialPosts.get({
                domain: options.siteID,
                page: options.page,
                search: options.searchStringFilter,
                paginate: options.paginate,
                sortField: options.sortField,
                sortDir: options.sortDir,
                filters: JSON.stringify(filters),
                resultsPerPage: 100
            },
                function (response) {
                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);

                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getOptions(options) {
            var deferred = $q.defer();

            // Return the promise.
            return (deferred.promise);
        }





        var resourceSocialPosts = $resource(COMMON.BASE_API + "/domain/:domain/social/posts?withAccount=True&withUser=True&withMedia=True", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false
            }
        });


        return ({
            get: getSocial,
            getFilters: getOptions
        });

    }

})();
(function () {
  'use strict';

  angular.module('app.social').controller('SocialPostsController', SocialPostsController);

  /** @ngInject */
  function SocialPostsController($scope, socialPostsService, $rootScope, $mdDialog, matchCenterService, $mdMedia, requestContext, $timeout, $translate, sharedFunctionsForms) {

    var vm = this;
    $scope.isLoading = true;
    vm.loadingThreads = true;
    vm.scrollEl = angular.element('#thread-list')[0];
    vm.enterfirst = true;

    vm.basicForm = {};
    vm.searchTabText;
    vm.selectedTab = null;

    vm.currentThread = null;
    vm.selectedThreads = [];
    vm.basicForm = {};


    // Methods
    vm.init = init;


    vm.isSelected = isSelected;
    vm.toggleSelectThread = toggleSelectThread;
    vm.toggleSelectThreads = toggleSelectThreads;



    vm.openMenu = openMenu;
    vm.deletePost = deletePost;


    //////////

    init();

    /**
     * Initialize
     */
    function init() {
      var siteID = requestContext.getParam("siteId");
      var section = 'forms';

      $scope.siteID = siteID;
      $scope.section = section;

      $rootScope.global.titleToolbar = '<i class="icon s20 icon-folder-account mr-15" ng-if="node.icon"></i> ' + $translate.instant('SOCIAL POSTS');

      vm.interval = setInterval(() => {
        if (vm.threads.find(x => x.status == 'queued' || x.status == 'processing')) {
          var opt = {
            page: $rootScope.pagination_page,
            resultsPerPage: $rootScope.perPage,
            siteID: siteID,
            sortDir: "DESC"
          }
          socialPostsService.get(opt).then(res => {
            // vm.threads = [];
            for (let i = 0; i < vm.threads.length; i++) {
              vm.threads[i].status = res.data.find(x => x.id_social_post === vm.threads[i].id_social_post).status
            }
          })
        }
      }, 10000);
    }

    $scope.$on('$destroy', function () {
      clearInterval(vm.interval);
    });

    function deletePost(post) {
      matchCenterService.deletePostsSocial({ "siteID": $scope.siteID, id: post.id_social_post }).then(function (response) {
        vm.threads = [];
        $rootScope.pagination_resetquery();
      });
    }

    // Watch screen size to change view modes
    $scope.$watch(function () {
      return $mdMedia('lt-sm');
    }, function (current, old) {
      if (angular.equals(current, old)) {
        return;
      }

      if (current) {
        vm.currentView = 'nosplit';
      }
    });

    $scope.$watch(function () {
      return $mdMedia('max-width: 960px');
    }, function (big) {

      if (big) {
        vm.currentView = 'nosplit';
      }

    });

    $scope.$watch(function () {
      return $mdMedia('min-width: 960px');
    }, function (small) {

      if (small) {
        vm.currentView = 'split';
      }

    });

    $scope.$watch(function () {
      return $mdMedia('gt-sm');
    }, function (current, old) {
      if (angular.equals(current, old)) {
        return;
      }

      if (current) {
        if (vm.defaultView === 'split') {
          vm.currentView = 'split';
        }
      }
    });

    $scope.$on('$includeContentLoaded', function (event, target) {
      $timeout(function () {
        vm.loadingView = false;
      }, 1000);
    });

    $scope.$on('pagination:loadStart', function (event) {
      // $anchorScroll();

      // Store the current scrollPos
      // vm.scrollPos = vm.scrollEl.scrollTop();

      // Scroll to the top
      // vm.scrollEl.scrollTop(0);
      if (!vm.enterfirst) {
        var elem = angular.element(document.getElementById('thread-list'));
        elem.scrollTopAnimated(0, 10);
      }

      // angular.element("#thread-list").scrollTop=0;
      vm.enterfirst = false;
      $scope.isLoading = true;
    });

    $scope.$on('pagination:loadPage', function (event) {
      $scope.isLoading = false;
      vm.dataAlreadyLoaded = true;
    });

    function isSelected(thread) {
      return sharedFunctionsForms.isSelected(vm.selectedThreads, thread);
    }

    function toggleSelectThread(thread, event) {
      vm.selectedThreads = sharedFunctionsForms.toggleSelectThread(vm.selectedThreads, thread, event);
    }


    function toggleSelectThreads() {
      vm.selectedThreads = sharedFunctionsForms.toggleSelectThreads(vm.selectedThreads, vm.threads);
    }

    var originatorEv;

    function openMenu($mdMenu, ev) {
      originatorEv = ev;
      $mdMenu.open(ev);
    }


  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .factory('CardFilters', CardFiltersService);

    /** @ngInject */
    function CardFiltersService()
    {
        var service = {
            name   : '',
            labels : [],
            members: [],
            clear  : clear,
            isOn   : isOn
        };

        /**
         * Clear
         */
        function clear()
        {
            service.name = '';
            service.labels = [];
            service.members = [];
        }

        /**
         * Is on
         *
         * @returns {boolean}
         */
        function isOn()
        {
            return (service.name === '' && service.labels.length === 0 && service.members.length === 0 ) ? false : true;
        }

        return service;
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .factory('DialogService', DialogService);

    /** @ngInject */
    function DialogService($mdDialog, $document)
    {
        var service = {
            openCardDialog: openCardDialog
        };

        //////////

        /**
         * Open card dialog
         *
         * @param ev
         * @param cardId
         */
        function openCardDialog(ev, cardId)
        {
            $mdDialog.show({
                templateUrl        : 'app/main/apps/scrumboard/dialogs/card/card-dialog.html',
                controller         : 'ScrumboardCardDialogController',
                controllerAs       : 'vm',
                parent             : $document.find('#scrumboard'),
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true,
                locals             : {
                    cardId: cardId
                }
            });
        }

        return service;
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .factory('BoardService', BoardService);

    /** @ngInject */
    function BoardService($q, msApi)
    {
        var service = {
            data        : {},
            addNewBoard : addNewBoard,
            getBoardData: getBoardData
        };

        /**
         * Get board data from the server
         *
         * @param boardId
         * @returns {*}
         */
        function getBoardData(boardId)
        {
            // Create a new deferred object
            var deferred = $q.defer();

            msApi.request('scrumboard.board@get', {id: boardId},

                // SUCCESS
                function (response)
                {
                    // Attach the data
                    service.data = response.data;

                    // Resolve the promise
                    deferred.resolve(response);
                },

                // ERROR
                function (response)
                {
                    // Reject the promise
                    deferred.reject(response);
                }
            );

            return deferred.promise;
        }

        /**
         * Create an empty board object and set it.
         *
         * For the demonstration purposes, we are creating the
         * empty object in the javascript which you wouldn't do
         * it in real life. Rather, you would make an API call
         * to your server to generate an empty object that fills
         * some of the areas for you like an ID, labels, members
         * or the default board settings.
         *
         * Then you would grab the response that comes from
         * the API call and attach it to the service.data object.
         */
        function addNewBoard()
        {
            // Create a new deferred object
            var deferred = $q.defer();

            // Here you would make an API call to your server...
            _generateEmptyScrumboardObject().then(
                // SUCCESS
                function (response)
                {
                    // Attach the data
                    service.data = response.data;

                    // Resolve the response
                    deferred.resolve(response);
                },
                // ERROR
                function (response)
                {
                    // Reject the response
                    deferred.reject(response);
                }
            );

            return deferred.promise;
        }

        /**
         * Dummy function for generating an empty
         * scrumboard object for demonstration
         * purposes
         *
         * @private
         * returns {$promise}
         */
        function _generateEmptyScrumboardObject()
        {
            // Create a new deferred object
            var deferred = $q.defer();

            // Fake id generator
            var id = parseInt(new Date().valueOf(), 16);

            // Prepare an empty scrumboard object
            var emptyObject = {
                data: {
                    name    : 'Untitled Board',
                    uri     : 'untitled-board',
                    id      : id,
                    settings: {
                        color          : '',
                        subscribed     : false,
                        cardCoverImages: true
                    },
                    lists   : [],
                    cards   : [],
                    members : [
                        {
                            id    : '56027c1930450d8bf7b10758',
                            name  : 'Alice Freeman',
                            avatar: 'assets/images/avatars/alice.jpg'
                        },
                        {
                            id    : '26027s1930450d8bf7b10828',
                            name  : 'Danielle Obrien',
                            avatar: 'assets/images/avatars/danielle.jpg'
                        },
                        {
                            id    : '76027g1930450d8bf7b10958',
                            name  : 'James Lewis',
                            avatar: 'assets/images/avatars/james.jpg'
                        },
                        {
                            id    : '36027j1930450d8bf7b10158',
                            name  : 'Vincent Munoz',
                            avatar: 'assets/images/avatars/vincent.jpg'
                        }
                    ],
                    labels  : [
                        {
                            id   : '26022e4129ad3a5sc28b36cd',
                            name : 'High Priority',
                            color: 'red'
                        },
                        {
                            id   : '56027e4119ad3a5dc28b36cd',
                            name : 'Design',
                            color: 'orange'
                        },
                        {
                            id   : '5640635e19ad3a5dc21416b2',
                            name : 'App',
                            color: 'blue'
                        },
                        {
                            id   : '6540635g19ad3s5dc31412b2',
                            name : 'Feature',
                            color: 'green'
                        }
                    ]
                }
            };

            // Resolve the promise
            deferred.resolve(emptyObject);

            return deferred.promise;
        }

        return service;
    }
})();
(function () {
    'use strict';

    angular.module('app.runtag')
        .controller('RuntagSupportController', RuntagSupportController);

    /** @ngInject */

    function RuntagSupportController($scope, $filter, RuntagService, requestContext){

        var vm = this;

    }
})();
(function () {
    'use strict';

    angular
        .module('app.users')
        .service('RuntagSalesService', RuntagSalesService);

    /** @ngInject */
    // I provide access to the session store.
    function RuntagSalesService($rootScope, $q, $resource, $stateParams, COMMON ) {

    }
})();
(function () {
    'use strict';

    angular.module('app.runtag')
        .filter('keys', function () {
            return function (input) {
                if (!angular.isObject(input)) {
                    return [];
                }
                return Object.keys(input);
            };
        })
        .controller('RuntagSalesV2Controller', RuntagSalesV2Controller);

    /** @ngInject */

    function RuntagSalesV2Controller($scope, $filter, $location, RuntagService, RuntagEventService, requestContext, sessionService, contentService, $mdToast){

        var vm = this;

        vm.clients = [];
        vm.selectedClient = undefined;
        vm.clientSearchText = "";

        vm.events = [];
        vm.loadedEventPeriods = {}; // periodos ya traídos (ver loadEventsForPeriod)
        vm.loadingEvents = false;
        vm.filteredEvents = [];
        vm.filteredClients = [];
        vm.filteredPaymentEvents = [];
        vm.selectedEvent = undefined;

        vm.payments = [];
        vm.paymentPeriods = {};
        vm.tableArray = [];

        vm.orders = [];
        vm.moreOrders = undefined;

        vm.loadingOrders = true;
        vm.loadingPayments = true;

        vm.sectionOptions = {};
        vm.paymentSelectedStatus = 2;
        vm.paymentSelectedOrder = 'date';
        vm.paymentSelectedPaid = 0;
        vm.isAdmin = false;
        vm.salesPerCurrency = undefined;
        vm.runnerSales = undefined;
        vm.loadMoreRunners = undefined;
        vm.totalFee = undefined;
        vm.eventsSales = [];
        vm.searchUsersString = "";
        vm.inUserSearch = false;
        vm.requiredRevisionRunner = undefined;
        vm.revisionNote = "";
        vm.runnerSortField = 'created_at';
        vm.runnerSortDir = 'DESC';

        vm.isCommercial = $location.path().includes('commercial');
        vm.paymentPeriods = {};
        vm.tableArray = [];
        vm.payments = [];
        vm.morePayments = undefined;

        vm.totals = {
            payment_breakdown: {
                sales_international: null,
                payment_due_usd: null,
                sales_local: null,
                total_sales_usd: null,
                commercial_commision_payment_due_usd: null
            },
            orders: {
                items_total: null,
                price: null,
                usd: null,
                total: null
            }
        };

        vm.years = {};
        vm.yearsLoaded = false;
        vm.calendarOpen = false;

        vm.formatDate = formatDate;
        vm.getOrders = getOrders;
        vm.calcPayment = calcPayment;
        vm.openModalRevision = openModalRevision;
        vm.closeModalRevision = closeModalRevision;
        vm.saveModalRevision = saveModalRevision;
        vm.toggleRunnerSort = toggleRunnerSort;

        init();

        function init(){
            var siteID = requestContext.getParam("siteId");
            var section = 'runtag';
            $scope.siteID = siteID;
            $scope.section = section;

            sessionService.loadDomainResourceSettings($scope.siteID).then(function (response){
              if(response.public){
                  var publicConfig = angular.fromJson(response.public);
                  sessionService.authenticate(siteID).then(function(response){
                    if(publicConfig.adminAccounts && publicConfig.adminAccounts.indexOf(response.account.email) != -1){
                      vm.isAdmin = true;
                    }else{
                      vm.isAdmin = false;
                    }
                  });
              }
            });
            
            // Initialization of date filter for V2 calendar
            const now = new Date();
            vm.selectedYear = now.getFullYear();
            if (!vm.years[vm.selectedYear]) {
                vm.years[vm.selectedYear] = Array(12).fill(null).map((_, index) => ({
                    name: new Date(0, index).toLocaleString('en-US', {month: 'long'}),
                    value: index
                }));
            }
            vm.selectedMonth = vm.years[vm.selectedYear][now.getMonth()];

            getClients();
            getEvents();
            if (vm.isCommercial) {
                getOptions('payments_breakdown');
            }
        }

        function getOptions(section) {
            RuntagService.getSectionFilters({
                domain: $scope.siteID,
                section: section
            }).then(function (response) {
                vm.sectionOptions[section] = response.reference_sections;
                
                // Ensure unique subsections to prevent md-select crashes
                if (vm.sectionOptions[section] && vm.sectionOptions[section].subsection) {
                    vm.sectionOptions[section].subsection = vm.sectionOptions[section].subsection.filter((sub, index, self) =>
                        index === self.findIndex((t) => t.id_subsec == sub.id_subsec)
                    );
                }

                if (vm.isCommercial) {
                    getPaymentBreakdown();
                }
            });
        }

        function calcPayment(payment){
            let totalPhotos = payment.total_photos;
            let pricePerPhoto = parseFloat(payment.prices_per_photo_usd);
            let priceFee = parseFloat(payment.prices_fee_usd);
            let pricePerPhotos = totalPhotos * pricePerPhoto;
            let pricePlusFee = (pricePerPhotos + priceFee).toFixed(2);
            if(pricePlusFee === payment.payment_due_usd){
                return true;
            }else{
                return false;
            }
        }

        function getClients(){
            var options = {
                domain:  $scope.siteID,
                section: 'clients',
                filters:[
                    {
                        field: 'onoff',
                        values: [1]
                    }
                ],
                resultsPerPage: 900
            }
            RuntagService.getSection(options).then((resp) => {
                // Ensure unique clients by id_clients (loose comparison to catch string/number mix)
                vm.clients = resp.data.filter((client, index, self) =>
                    index === self.findIndex((t) => String(t.id_clients) === String(client.id_clients))
                );
            });
        }

        /**
         * Calendario + eventos de la pantalla de ventas.
         *
         * ANTES se bajaban TODOS los eventos (`content/events?resultsPerPage=999`) solo para sacar de ahí
         * los años/meses con datos y llenar el desplegable. Sale carísimo: ese endpoint, por CADA fila que
         * devuelve, lanza dos consultas más (miniaturas y galerías) e hidrata sus modelos — con ~770 eventos
         * son ~1.500 consultas en una sola petición, y es lo que reventaba la memoria de qiu-api
         * (Allowed memory size of 268435456 bytes exhausted) además de hacer eterna la carga.
         *
         * AHORA va en dos pasos:
         *  1. El calendario solo necesita FECHAS → se piden agregadas (`groupBy: 'date'`). qiu-api resuelve
         *     esa rama ANTES de paginar y sin tocar medias: una consulta y unos pocos KB.
         *  2. Los eventos (desplegable y nombre en las tablas) se piden por AÑO a `stats/perEvent`, que no
         *     tiene ese N+1. Se acota al año porque ese endpoint calcula de paso el nº de corredores y de
         *     compras de cada evento: con todos son ~25 s de consultas; con un año, ~2,7 s. Se cachea.
         */
        function getEvents(){
            RuntagService.getSection({
                domain:         $scope.siteID,
                section:        'events',
                resultSumField: 'id_events',
                groupBy:        'date',
                sumPerGroup:    true
            }).then((resp) => {
                (resp.sums || []).forEach(group => {
                    if (!group || !group.date) { return; }
                    const eventDate = new Date(group.date);
                    const year = eventDate.getFullYear();
                    if (isNaN(year)) { return; }
                    ensureYear(year);
                    const month = vm.years[year].find(x => x.value === eventDate.getMonth());
                    if (month && !month.available) {
                        month.available = true;
                    }
                });

                const currentDate = new Date();
                const currentYear = currentDate.getFullYear();
                const currentMonth = currentDate.getMonth();
                ensureYear(currentYear);

                vm.selectedYear = currentYear;
                vm.selectedMonth = vm.years[vm.selectedYear][currentMonth];
                let previousMonth = vm.selectedMonth? vm.selectedMonth.value - 1 : null;
                let previousYear = vm.selectedYear;

                if (previousMonth < 0) {
                    previousMonth = 11;
                    previousYear = vm.selectedYear - 1;
                }

                vm.previousMonth = vm.years[previousYear] && vm.years[previousYear][previousMonth]
                    ? vm.years[previousYear][previousMonth]
                    : null;

                vm.yearsLoaded = true;
                loadEventsForPeriod(vm.selectedYear, vm.selectedMonth && vm.selectedMonth.value);
            });
        }

        function ensureYear(year) {
            if (!vm.years[year]) {
                vm.years[year] = Array(12).fill(null).map((_, index) => ({
                    name: new Date(0, index).toLocaleString('en-US', { month: 'long' }),
                    value: index
                }));
            }
        }

        /**
         * Eventos del periodo seleccionado (año + mes), acumulados en vm.events — de ahí comen el desplegable
         * y searchEventName. Se piden a stats/perEvent, que no tiene el N+1 de miniaturas de content/events.
         * Se acota al MES y no al año: el año son ~250 eventos y esa respuesta tarda decenas de segundos.
         * Se cachea por periodo y lo ya cargado no se descarta, así que moverse por meses va sumando.
         * Las fechas van explícitas porque el servicio manda `from`/`to` vacíos si no se le pasan y el filtro
         * de qiu-api los invocaría sin argumento (ArgumentCountError → 500).
         */
        function loadEventsForPeriod(year, monthValue) {
            year = parseInt(year, 10);
            if (!year) { return; }
            const month = (monthValue === undefined || monthValue === null) ? null : parseInt(monthValue, 10);
            const key = month === null ? String(year) : year + '-' + month;
            if (vm.loadedEventPeriods[key]) { return; }
            vm.loadedEventPeriods[key] = true;
            vm.loadingEvents = true;

            const desde = month === null ? new Date(year, 0, 1) : new Date(year, month, 1);
            const hasta = month === null ? new Date(year, 11, 31) : new Date(year, month + 1, 0);

            RuntagEventService.getEventsStats({
                domain: $scope.siteID,
                from: $filter('date')(desde, 'yyyy-MM-dd 00:00:00'),
                to: $filter('date')(hasta, 'yyyy-MM-dd 23:59:59'),
                resultsPerPage: 999,
                sortDir: 'desc'
            }).then((response) => {
                const rows = (response && response.data) || [];
                const seen = {};
                vm.events.forEach(e => { seen[String(e.id_events)] = true; });
                rows.forEach(e => {
                    if (seen[String(e.id_events)]) { return; }
                    seen[String(e.id_events)] = true;
                    // stats/perEvent devuelve la fecha como event_date; el resto de la vista espera `date`.
                    e.date = e.date || e.event_date;
                    vm.events.push(e);
                });
                vm.loadingEvents = false;
                vm.filterClientsAndEvents();
            }).catch(() => {
                vm.loadedEventPeriods[key] = false; // que se pueda reintentar
                vm.loadingEvents = false;
            });
        }

        vm.getLastAvailableDate = function() {
            const yearKeys = Object.keys(vm.years).map(year => parseInt(year, 10));
            const lastYear = Math.max(...yearKeys);
            vm.selectedYear = lastYear;
            const months = vm.years[vm.selectedYear];
            if (months && months.length > 0) {
                const availableMonths = months.filter(month => month.available === true);
                if (availableMonths.length > 0) {
                    vm.selectedMonth = availableMonths[availableMonths.length - 1]
                } else {
                    vm.selectedMonth = null;
                }
            } else {
                vm.selectedMonth = null;
            }
        };

        vm.filterClientsAndEvents = function(variable){
            if(vm.clients.length === 1){
                vm.selectedClient = vm.clients[0].id_clients;
            }
            if(variable){
                vm[variable] = undefined;
            }
            vm.filteredClients = vm.clients;
            if(vm.selectedClient){
                vm.filteredEvents = vm.events.filter(x => x.id_client === vm.selectedClient);
            }else{
                vm.filteredEvents = vm.events;
            }
            if(vm.selectedClient && vm.selectedEvent){
                const ev = vm.events.find(x => x.id_events === vm.selectedEvent);
                if(ev && ev.id_client != vm.selectedClient){
                    vm.selectedEvent = undefined;
                }
            }
            if (vm.isCommercial) {
                getPaymentBreakdown(true);
            } else {
                getOrders();
            }
        }

        function getClientDateRangeUTC(year, month0Based, timeZone) {
            const DateTime = luxon.DateTime;

            const from = DateTime.fromObject(
                { year, month: month0Based + 1, day: 1, hour: 0, minute: 0, second: 0 },
                { zone: timeZone }
            );

            const to = from.endOf('month');

            return {
                from: from.toUTC().toISO({ suppressMilliseconds: true }),
                to: to.toUTC().toISO({ suppressMilliseconds: true })
            };
        }

        function getRange() {
            const year = vm.selectedYear ? parseInt(vm.selectedYear) : new Date().getFullYear();
            const month = vm.selectedMonth ? vm.selectedMonth.value : new Date().getMonth();
            let from, to;

            if (vm.selectedClient) {
                const client = vm.clients.find(x => x.id_clients === vm.selectedClient);
                if (client && client.timezone) {
                    ({ from, to } = getClientDateRangeUTC(year, month, client.timezone));
                }
            }

            if (!from || !to) {
                from = new Date(Date.UTC(year, month, 1)).toISOString().split(".")[0] + "Z";
                to = new Date(Date.UTC(year, month + 1, 0, 23, 59, 59)).toISOString().split(".")[0] + "Z";
            }

            return { from, to };
        }

        function getRunnerSales() {
            vm.loadingOrders = true;
            const range = getRange();

            const options = {
                domain: $scope.siteID,
                from: range.from,
                to: range.to,
                event_id: vm.selectedEvent ? vm.selectedEvent : null,
                client_id: vm.selectedClient ? vm.selectedClient : null,
                resultsPerPage: 500,
                sortField: vm.runnerSortField,
                sortDir: vm.runnerSortDir
            };

            return RuntagService.getSales(options).then(respSales => {
                vm.runnerSales = respSales.data;
                vm.loadMoreRunners = {
                    total: respSales.total,
                    current: respSales.to,
                    current_page: respSales.current_page,
                    last_page: respSales.last_page
                };
                vm.loadingOrders = false;
                return respSales;
            });
        }

        function getOrders() {
            vm.loadingOrders = true;
            const range = getRange();

            const optionsCurrent = {
                domain: $scope.siteID,
                from: range.from,
                to: range.to,
                event_id: vm.selectedEvent ? vm.selectedEvent : null,
                client_id: vm.selectedClient ? vm.selectedClient : null,
                per: 'currency'
            };

            const optionsPerEvent = {
                domain: $scope.siteID,
                from: range.from,
                to: range.to,
                event_id: vm.selectedEvent ? vm.selectedEvent : null,
                client_id: vm.selectedClient ? vm.selectedClient : null,
                per: 'ev'
            };

            Promise.all([
                getRunnerSales(),
                RuntagService.getSales(optionsCurrent),
                RuntagService.getSales(optionsPerEvent)
            ]).then(([respSales, respCurrency, respEvents]) => {
                vm.eventsSales = respEvents.sort((a, b) => b.orders - a.orders);
                vm.salesPerCurrency = respCurrency.sales;
                
                if (vm.selectedClient) {
                    const cl = vm.clients.find(x => x.id_clients === vm.selectedClient);
                    getFee(cl);
                } else if (vm.selectedEvent) {
                    const ev = vm.events.find(x => x.id_events === vm.selectedEvent);
                    const cl = vm.clients.find(x => x.id_clients === ev.id_client);
                    getFee(cl);
                } else {
                    vm.totalFee = undefined;
                }
                $scope.$apply();
            }).catch(error => {
                console.error(error);
                vm.loadingOrders = false;
            });
        }

        function getPaymentBreakdown(reset) {
            vm.loadingPayments = true;
            if (reset) {
                vm.morePayments = undefined;
            }

            var filters = [];
            if (vm.selectedEvent) {
                filters.push({
                    field: 'id_event',
                    values: [vm.selectedEvent]
                });
            }
            if (vm.selectedClient) {
                filters.push({
                    field: 'id_client',
                    values: [vm.selectedClient]
                });
            }
            if (vm.paymentSelectedStatus) {
                filters.push({
                    field: 'id_subsec',
                    values: [vm.paymentSelectedStatus]
                });
            }
            if (vm.paymentSelectedPaid != null && vm.paymentSelectedPaid != undefined) {
                filters.push({
                    field: 'commercial_paid',
                    values: [vm.paymentSelectedPaid]
                });
            }

            // Apply date range from V2 calendar
            const range = getRange();
            filters.push({
                field: 'date_from',
                operator: '>=',
                values: [range.from]
            });
            filters.push({
                field: 'date_to',
                operator: '<=',
                values: [range.to]
            });

            var options = {
                domain: $scope.siteID,
                section: 'payments_breakdown',
                filters: filters,
                resultsPerPage: 20
            };

            if (vm.morePayments) {
                options.page = vm.morePayments.nextPage;
            } else {
                vm.payments = [];
            }

            RuntagService.getSection(options).then((resp) => {
                if (vm.morePayments) {
                    vm.payments = vm.payments.concat(resp.data);
                } else {
                    vm.payments = resp.data;
                }
                updatePaymentsPeriods(vm.payments);

                if (resp.current_page < resp.last_page) {
                    vm.morePayments = {
                        nextPage: resp.current_page + 1
                    }
                } else {
                    vm.morePayments = undefined;
                }
                vm.loadingPayments = false;
                getCommercialTotals(filters);
            });
        }

        function getCommercialTotals(filters) {
            // Commercial total commission payment due
            RuntagService.getSection({
                domain: $scope.siteID,
                section: 'payments_breakdown',
                resultSumField: 'commercial_commision_payment_due_usd',
                filters: filters
            }).then((resp) => {
                vm.totals.payment_breakdown.commercial_commision_payment_due_usd = resp.sum;
            });
            
            // Total sales for the period in USD
            RuntagService.getSection({
                domain: $scope.siteID,
                section: 'payments_breakdown',
                resultSumField: 'total_sales_usd',
                filters: filters
            }).then((resp) => {
                vm.totals.payment_breakdown.total_sales_usd = resp.sum;
            });
        }

        function updatePaymentsPeriods(paymentArray) {
            let payments = paymentArray.sort((a, b) => new Date(a.date_from) + new Date(b.date_to));
            if (vm.paymentSelectedStatus) {
                payments = payments.filter(x => x.id_subsec === vm.paymentSelectedStatus);
            }
            vm.paymentPeriods = {};
            vm.tableArray = [];
            payments.forEach((pay) => {
                var field = undefined;
                switch (vm.paymentSelectedOrder) {
                    case 'date':
                        field = getPeriod(pay.date_from, pay.date_to);
                        break;
                    case 'event':
                        let event = vm.events.find(x => x.id_events === pay.id_event);
                        field = event? `${event.event_name} (${formatDate(event.date, 'dd MMM yyyy')})` : `Event ${pay.id_event}`;
                        break;
                    case 'status':
                        let status = vm.sectionOptions.payments_breakdown.subsection.find(x => x.id_subsec === pay.id_subsec);
                        field = status.subsec;
                        break;
                }
                if (!vm.paymentPeriods[field]) {
                    vm.paymentPeriods[field] = [];
                }
                vm.paymentPeriods[field].push(pay);
            });
            for (let key in vm.paymentPeriods) {
                vm.tableArray.push({
                    type: 'key',
                    value: key
                });
                vm.paymentPeriods[key].forEach((item) => {
                    vm.tableArray.push({
                        type: 'object',
                        value: item
                    });
                });
            }
        }

        function getPeriod(from, to) {
            var dateFrom = formatDate(from, 'dd/MM');
            var dateTo = formatDate(to, 'dd/MM');
            return `${dateFrom}-${dateTo}`;
        }

        vm.getLengthOfObject = function (obj) {
            return Object.keys(obj).length;
        }

        vm.searchEventName = function (id) {
            let event = vm.events.find(x => x.id_events == id);
            return event ? event.event_name : id;
        }

        vm.searchClientName = function (id) {
            let client = vm.clients.find(x => x.id_clients == id);
            return client ? client.client_name : id;
        }

        vm.getSubTotal = function (item) {
            let runtagPay = item.value.payment_due_usd;
            let serviceCost = item.value.commercial_cost_total;
            return (runtagPay - serviceCost).toFixed(2);
        }

        vm.checkPays = function (pay, type) {
            if (pay[type]) {
                return 'done';
            } else {
                var today = new Date();
                var payDate = new Date(pay.date_to);
                var timeDiff = today - payDate;
                var daysDiff = timeDiff / (1000 * 60 * 60 * 24);
                if (daysDiff > 30) {
                    return 'exceed';
                } else {
                    return 'waiting';
                }
            }
        }

        vm.getPaymentBreakdown = getPaymentBreakdown;
        vm.updatePaymentsPeriods = updatePaymentsPeriods;

        vm.searchUsers = function(){
            if(vm.searchUsersString != null && vm.searchUsersString != undefined && vm.searchUsersString != ""){
                vm.loadingOrders = true;
        
                const year = parseInt(vm.selectedYear);
                const month = vm.selectedMonth.value;

                const from = new Date(Date.UTC(year, month, 1)).toISOString().split(".")[0] + "Z";
                const to = new Date(Date.UTC(year, month + 1, 0, 23, 59, 59)).toISOString().split(".")[0] + "Z";

                const options = {
                    domain: $scope.siteID,
                    from: from,
                    to: to,
                    event_id: vm.selectedEvent ? vm.selectedEvent : null,
                    client_id: vm.selectedClient ? vm.selectedClient : null,
                    resultsPerPage: 500,
                    search: vm.searchUsersString,
                    sortField: vm.runnerSortField,
                    sortDir: vm.runnerSortDir
                }

                RuntagService.getSales(options).then(resp => {
                    console.log('resp', resp);
                    if(resp.data && resp.data.length > 0){
                        vm.loadMoreRunners = {
                            total: resp.total,
                            current: resp.to,
                            current_page: resp.current_page,
                            last_page: resp.last_page,
                            search: vm.searchUsersString
                        }
                        vm.runnerSales = resp.data;
                        vm.inUserSearch = true;
                        vm.loadingOrders = false;
                    }else{
                        vm.loadingOrders = false;
                        $mdToast.show({
                            template: '<md-toast layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-close" class="icon"></md-icon><span class="md-toast-text" flex>No results for ' + vm.searchUsersString + '</span></div></md-toast>',
                            hideDelay: 5000,
                            position: 'top',
                            parent: '#content-container'
                        });
                    }
                });
            }
        }

        vm.resetUserSearch = function(){
            vm.searchUsersString = "";
            vm.inUserSearch = false;
            getRunnerSales().then(() => {
                $scope.$apply();
            });
        }

        vm.getMoreRunners = function(){

            const year = parseInt(vm.selectedYear);
            const month = vm.selectedMonth.value;

            const from = new Date(Date.UTC(year, month, 1)).toISOString().split(".")[0] + "Z";
            const to = new Date(Date.UTC(year, month + 1, 0, 23, 59, 59)).toISOString().split(".")[0] + "Z";

            const page = vm.loadMoreRunners.current_page? vm.loadMoreRunners.current_page + 1 : 0;

            const options = {
                domain: $scope.siteID,
                from: from,
                to: to,
                event_id: vm.selectedEvent ? vm.selectedEvent : null,
                client_id: vm.selectedClient ? vm.selectedClient : null,
                page: page,
                resultsPerPage: 500,
                search: vm.loadMoreRunners.search,
                sortField: vm.runnerSortField,
                sortDir: vm.runnerSortDir
            }

            RuntagService.getSales(options).then(response => {
                vm.runnerSales = vm.runnerSales.concat(response.data);
                vm.loadMoreRunners = {
                    total: response.total,
                    current: response.to,
                    current_page: response.current_page,
                    last_page: response.last_page,
                    search: vm.loadMoreRunners.search
                }
            });
        }

        vm.getEventsCurrencies = function(){
            let currencies = [];
            vm.eventsSales.forEach(ev => {
                Object.keys(ev).forEach(key => {
                    if (key.startsWith('sales_amount_') && key !== 'sales_amount_total_usd' && ev[key] > 0) {
                        const currency = key.replace('sales_amount_', '');
                        if (!currencies.includes(currency)) {
                            currencies.push(currency);
                        }
                    }
                });
            });
            return currencies;
        }

        vm.getEventsTotals = function(field){
            let total = 0;
            vm.eventsSales.forEach(ev => {
                total = total + parseFloat(ev[field]);
            });
            return total;
        }

        function getFee(client){
            if(client && client.commission && vm.salesPerCurrency){
                const commissionPercentage = parseFloat(client.commission);
                const amount = parseFloat(vm.salesPerCurrency.total.amount);
                const fee = (commissionPercentage / 100) * amount;
                vm.totalFee = Math.round(fee * 100) / 100;
            }
        }

        vm.toggleCalendar = function () {
            vm.calendarOpen = !vm.calendarOpen;
        };

        vm.handleYearChange = function () {
            const year = vm.selectedYear;
            const availableMonths = vm.years[year];
            vm.selectedMonth = availableMonths[0];
            
            let previousMonth = vm.selectedMonth.value - 1;
            let previousYear = vm.selectedYear;
            if (previousMonth < 0) {
                previousMonth = 11;
                previousYear = vm.selectedYear - 1;
            }
            vm.previousMonth = vm.years[previousYear] && vm.years[previousYear][previousMonth]
                ? vm.years[previousYear][previousMonth]
                : null;
        };

        vm.selectYear = function(year) {
            vm.selectedYear = year;
            // Los eventos van por periodo: al cambiar de año se piden los del mes ya seleccionado.
            loadEventsForPeriod(year, vm.selectedMonth && vm.selectedMonth.value);
        }

        vm.selectMonth = function (month) {
            vm.selectedMonth = month;

            let previousMonth = vm.selectedMonth.value - 1;
            let previousYear = vm.selectedYear;
            if (previousMonth < 0) {
                previousMonth = 11;
                previousYear = vm.selectedYear - 1;
            }
            vm.previousMonth = vm.years[previousYear] && vm.years[previousYear][previousMonth]
                ? vm.years[previousYear][previousMonth]
                : null;

            vm.calendarOpen = false;
            loadEventsForPeriod(vm.selectedYear, vm.selectedMonth && vm.selectedMonth.value);
            vm.filterClientsAndEvents();
        };

        function toggleRunnerSort(field) {
            if (vm.runnerSortField === field) {
                vm.runnerSortDir = vm.runnerSortDir === 'ASC' ? 'DESC' : 'ASC';
            } else {
                vm.runnerSortField = field;
                vm.runnerSortDir = 'DESC';
            }
            getRunnerSales().then(() => {
                $scope.$apply();
            });
        }

        function formatDate(date, format) {
            let dateObject = new Date(date);

            if (vm.selectedClient) {
                const client = vm.clients.find(x => x.id_clients === vm.selectedClient);
                if (client && client.timezone) {
                    // Convertimos la fecha original a la hora local del cliente
                    const localeString = dateObject.toLocaleString("en-US", { timeZone: client.timezone });
                    const localDate = new Date(localeString);

                    // Convertimos esa hora local a UTC para que AngularJS la formatee correctamente
                    const offsetMs = localDate.getTimezoneOffset() * 60000;
                    dateObject = new Date(localDate.getTime() - offsetMs);
                }
            }

            return $filter('date')(dateObject, format);
        }


        function saveModalRevision(){
            const order = {
                revision_comment: vm.revisionNote,
                requires_revision: 1,
                id: vm.requiredRevisionRunner.id_orders
            }
            const options = {
                item: order,
                id: vm.requiredRevisionRunner.id_orders,
                siteID: $scope.siteID
            };
            RuntagEventService.updateOrder(options).then(response => {
                if(response.result === 'update'){
                    vm.requiredRevisionRunner.revision_comment = vm.revisionNote;
                    vm.requiredRevisionRunner.requires_revision = 1;
                }
                vm.requiredRevisionRunner = undefined;
            });
        }

        function openModalRevision(runner){
            vm.requiredRevisionRunner = runner;
            vm.revisionNote = runner.revision_comment;
        }

        function closeModalRevision(del){
            if(del){
                const order = {
                    revision_comment: "",
                    requires_revision: 0,
                    id: vm.requiredRevisionRunner.id_orders
                }
                const options = {
                    item: order,
                    id: vm.requiredRevisionRunner.id_orders,
                    siteID: $scope.siteID
                };
                RuntagEventService.updateOrder(options).then(response => {
                    if(response.result === 'update'){
                        vm.requiredRevisionRunner.revision_comment = "";
                        vm.requiredRevisionRunner.requires_revision = 0;
                    }
                    vm.requiredRevisionRunner = undefined;
                });
            }else{
                vm.requiredRevisionRunner = undefined;
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.runtag')
        .factory('RuntagRunnerService', RuntagRunnerService);

    /**
     * Perfiles de corredor SIN endpoints nuevos de qiu-api: el panel obtiene un token del
     * usuario (users/getGenericToken, ya desplegado) y llama a las ACTIONS del dashboard web
     * (qiupreview api/dashboard-web) con Authorization: Bearer — myphotos / addDorsalProfile /
     * addFaceProfile / renameProfile / deleteProfile / setProfileItems / getImagesByNumber /
     * searchPhotosByFaceId. user_params se edita en directo vía users/:id (también existente).
     */
    /** @ngInject */
    function RuntagRunnerService($resource, $http, COMMON) {

        // ── qiu-api (endpoints existentes) ──
        var resourceUsersSearch = $resource(COMMON.BASE_API + '/domain/:domain/users', {
            domain: '@domain'
        }, {
            get: { method: 'GET' }
        });

        var resourceUser = $resource(COMMON.BASE_API + '/domain/:domain/users/:id', {
            domain: '@domain',
            id: '@id'
        }, {
            get:    { method: 'GET' },
            update: { method: 'PUT' }
        });

        var resourceGenericToken = $resource(COMMON.BASE_API + '/domain/:domain/users/getGenericToken/:id', {
            domain: '@domain',
            id: '@id'
        }, {
            get: { method: 'GET' }
        });

        // ── Órdenes (section_orders) vía content genérico de qiu-api ──
        // getOrders (lista) NO devuelve la columna files (no está en el _ref), así que para
        // leer type/dorsal/items hay que pedir cada orden por id (getContentID hace SELECT s.*).
        var resourceOrders = $resource(COMMON.BASE_API + '/domain/:domain/content/orders', {
            domain: '@domain'
        }, {
            get: { method: 'GET' }
        });

        var resourceOrderById = $resource(COMMON.BASE_API + '/domain/:domain/content/orders/:id', {
            domain: '@domain',
            id: '@id'
        }, {
            get: { method: 'GET' }
        });

        // Borrado real: content/{section}/action/delete con {ids:[...]} (deleteContentID es un stub).
        var resourceOrdersAction = $resource(COMMON.BASE_API + '/domain/:domain/content/orders/action/:type', {
            domain: '@domain',
            type: '@type'
        }, {
            run: { method: 'PUT' }
        });

        // Crear orden: content/orders/new (putContentNew). Escribe los campos edit_editable del _ref
        // (incluida la columna files, expuesta como escribible en id_ref=42).
        var resourceOrderNew = $resource(COMMON.BASE_API + '/domain/:domain/content/orders/new', {
            domain: '@domain'
        }, {
            create: { method: 'PUT' }
        });

        var service = {
            searchUsers: searchUsers,
            getUser: getUser,
            updateUserParams: updateUserParams,
            getGenericToken: getGenericToken,
            webAction: webAction,
            getUserOrders: getUserOrders,
            getOrderById: getOrderById,
            deleteOrders: deleteOrders,
            createOrder: createOrder
        };
        return service;

        /** mode 'text' → filtro search (email/nombre); mode 'dorsal' → filtro currentNumber. */
        function searchUsers(domain, mode, term) {
            var params = { domain: domain, resultsPerPage: 20, paginate: 20, page: 1 };
            if (mode === 'dorsal') {
                params.currentNumber = term;
            } else {
                params.search = term;
            }
            return resourceUsersSearch.get(params).$promise;
        }

        function getUser(domain, id) {
            return resourceUser.get({ domain: domain, id: id }).$promise;
        }

        /**
         * Edición EN DIRECTO de users.user_params. El backend guarda la columna (longtext) TAL CUAL y NO
         * serializa objetos (mandar un objeto da 401 "Object of class stdClass could not be converted to
         * string"), así que se envía SIEMPRE ya serializado — igual que saveUser (payload.user_params =
         * JSON.stringify(...)). Aceptamos objeto o string por comodidad de los callers.
         */
        function updateUserParams(domain, id, userParams) {
            var body = (typeof userParams === 'string') ? userParams : JSON.stringify(userParams);
            return resourceUser.update({ domain: domain, id: id }, { user_params: body }).$promise;
        }

        /** Token JWT del usuario (sub = id_user): el que aceptan las actions del dashboard web. */
        function getGenericToken(domain, id) {
            return resourceGenericToken.get({ domain: domain, id: id }).$promise
                .then(function (res) { return res && res.token; });
        }

        /**
         * POST a las actions del dashboard web COMO el usuario (Bearer).
         * actionsUrl: p.ej. https://runtagtest.qiupreview.com/es/api/dashboard-web/850_test-fotografix
         */
        function webAction(actionsUrl, token, payload) {
            return $http.post(actionsUrl, payload, {
                headers: { Authorization: 'Bearer ' + token }
            }).then(function (res) { return res.data; });
        }

        /** Lista de órdenes del usuario (sin files). filters → user_id [+ id_event]. */
        function getUserOrders(domain, userId, eventId) {
            var filters = [{ field: 'user_id', name: 'User id', values: [userId] }];
            if (eventId) {
                filters.push({ field: 'id_event', name: 'ID Event', values: [eventId] });
            }
            return resourceOrders.get({ domain: domain, filters: JSON.stringify(filters) }).$promise
                .then(function (res) {
                    return (res && res.result && res.result.data) || (res && res.data) || [];
                });
        }

        /** Orden completa por id (incluye la columna files → type/dorsal/items). */
        function getOrderById(domain, id) {
            return resourceOrderById.get({ domain: domain, id: id }).$promise
                .then(function (res) { return (res && res.result) || res; });
        }

        /** Borrado real de órdenes por id (content/orders/action/delete). */
        function deleteOrders(domain, ids) {
            return resourceOrdersAction.run({ domain: domain, type: 'delete' }, { ids: ids }).$promise;
        }

        /** Crea una orden (content/orders/new). item = columnas editables (id_subsec, user_id, files…). */
        function createOrder(domain, item) {
            return resourceOrderNew.create({ domain: domain }, { item: item }).$promise;
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.runtag')
        .controller('RuntagOrganizerController', RuntagOrganizerController);

    /** @ngInject */

    function RuntagOrganizerController($scope, $q, $filter, $location, RuntagService, RuntagEventService, usersService, requestContext, sessionService) {

        var vm = this;

        vm.clients = [];
        vm.selectedClient = undefined;
        vm.clientSearchText = "";

        var EVENTS_PAGE_SIZE = 150; // ver getEvents: content/events cuesta 2 consultas por fila devuelta
        vm.events = [];
        vm.filteredEvents = [];
        vm.selectedEvent = undefined;

        vm.payments = [];
        vm.paymentPeriods = {};
        vm.tableArray = [];

        vm.orders = [];
        vm.moreOrders = undefined;

        vm.loadingOrders = true;
        vm.loadingPayments = true;

        vm.sectionOptions = {};
        vm.paymentSelectedStatus = 2;
        vm.paymentSelectedOrder = 'date';
        vm.paymentSelectedPaid = 0;
        vm.showCommissions = false;

        vm.newPaymentBreakdown = false;
        vm.isAdmin = false;

        vm.createdPaymentBreakdown = {
            date_from: null,
            date_to: null,
            first_settlement: false,
            id_client: null
        }

        vm.totals = {
            payment_breakdown: {
                sales_international: null,
                payment_due_usd: null,
                sales_local: null,
                total_sales_usd: null,
                organizer_commision_payment_due_usd: null
            },
            orders: {
                items_total: null,
                price: null,
                usd: null,
                total: null
            }
        };

        vm.searchEventName = searchEventName;
        vm.searchClientName = searchClientName;
        vm.searchFieldInArray = searchFieldInArray;
        vm.reFilter = reFilter;
        vm.formatDate = formatDate;
        vm.autocompleteSearch = autocompleteSearch;
        vm.checkPays = checkPays;
        vm.getOrders = getOrders;
        vm.getPaymentBreakdown = getPaymentBreakdown;
        vm.calcPayment = calcPayment;
        vm.updatePaymentsPeriods = updatePaymentsPeriods;
        vm.getLengthOfObject = getLengthOfObject;
        vm.getSubTotal = getSubTotal;
        vm.resetCreatedPaymentBreakdown = resetCreatedPaymentBreakdown;
        vm.saveCreatedPaymentBreakdown = saveCreatedPaymentBreakdown;
        vm.createPaymentsTotals = createPaymentsTotals;

        init();

        function init() {
            var siteID = requestContext.getParam("siteId");
            var section = 'runtag';
            $scope.siteID = siteID;
            $scope.section = section;

            sessionService.loadDomainResourceSettings($scope.siteID).then(function (response) {
                if (response.public) {
                    var publicConfig = angular.fromJson(response.public);
                    sessionService.authenticate(siteID).then(function (response) {
                        if (publicConfig.adminAccounts && publicConfig.adminAccounts.indexOf(response.account.email) != -1) {
                            vm.isAdmin = true;
                        } else {
                            vm.isAdmin = false;
                        }
                    });
                }
            });
            getEvents().then(function () {
                getOrders();
                getOrganizer();
                getClients();
                getPaymentBreakdown();
                getOptions('payments_breakdown');
            });
        }

        function resetCreatedPaymentBreakdown() {

            vm.createdPaymentBreakdown = {
                date_from: null,
                date_to: null,
                first_settlement: false,
                id_client: null
            }

            vm.newPaymentBreakdown = false;
        }

        function saveCreatedPaymentBreakdown() {
            let pay = vm.createdPaymentBreakdown;
            if (!pay.id_client || !pay.date_from || !pay.date_to) {
                return;
            }
            RuntagService.createPaymentBreakdown({
                domain: $scope.siteID,
                date_from: paymentFormatDate(pay.date_from, 'YYYY-MM-DD'),
                date_to: paymentFormatDate(pay.date_to, 'YYYY-MM-DD'),
                id_client: pay.id_client,
                force_first_settlement: pay.first_settlement
            }).then(response => {
                console.log('response', response);
            });
        }

        function paymentFormatDate(date) {
            const year = date.getFullYear();
            const month = date.getMonth() + 1;
            const day = date.getDate();
            const monthFormatted = month < 10 ? '0' + month : month;
            const dayFormatted = day < 10 ? '0' + day : day;

            return `${year}-${monthFormatted}-${dayFormatted}`;
        }

        function getLengthOfObject(obj) {
            return Object.keys(obj).length;
        }

        function getOptions(section) {
            RuntagService.getSectionFilters({
                domain: $scope.siteID,
                section: section
            }).then(function (response) {
                vm.sectionOptions[section] = response.reference_sections;
            });
        }

        function calcPayment(payment) {
            let totalPhotos = payment.total_photos;
            let pricePerPhoto = parseFloat(payment.prices_per_photo_usd);
            let priceFee = parseFloat(payment.prices_fee_usd);
            let pricePerPhotos = totalPhotos * pricePerPhoto;
            let pricePlusFee = (pricePerPhotos + priceFee).toFixed(2);
            if (pricePlusFee === payment.payment_due_usd) {
                return true;
            } else {
                return false;
            }
        }

        function getTotals() {
            vm.loadingTotals = true;
            var filters = [];
            let paths = $location.path().split('/');
            let location = paths[paths.length - 1];
            vm.totalRunners = 0;
            vm.totalPhotos = 0;
            vm.recognizedPhotos = 0;
            vm.averagePhotos = 0;

            if (vm.selectedEvent) {
                filters.push({
                    field: 'id_event',
                    values: [vm.selectedEvent.id_events]
                });
                usersService.getUsersByGroups({
                    siteID: $scope.siteID,
                    groupIds: vm.selectedEvent.id_user_group
                }).then(resp => {
                    vm.totalRunners = resp.result.total;
                    if (vm.selectedEvent.api_url && !vm.selectedEvent.presale) {
                        RuntagEventService.getTotalsPablo({ apiUrl: vm.selectedEvent.api_url }).then(response => {
                            vm.totalPhotos = response.totalPhotos;
                            vm.recognizedPhotos = response.totalRecognizedPhotos;
                            vm.averagePhotos = response.totalPhotos / vm.totalRunners;
                            vm.loadingTotals = false;
                        });
                    } else {
                        vm.loadingTotals = false;
                    }
                });
                const lastLoginFromDate = new Date(vm.selectedEvent.date.replace(" ", "T"));
                lastLoginFromDate.setDate(lastLoginFromDate.getDate() - 1); // Subtract one day
                lastLoginFromDate.setHours(0, 0, 0, 0); // Set time to 00:00:00
                usersService.getUsersByGroups({
                    siteID: $scope.siteID,
                    groupIds: vm.selectedEvent.id_user_group,
                    lastLoginNotNull: true,
                    lastActivityFrom: $filter('date')(lastLoginFromDate, 'yyyy-MM-dd 00:00:00')
                }).then(function (response) {
                    vm.totalAccess = response.result.total;
                });
            }
            if (vm.selectedClient) {
                filters.push({
                    field: 'id_client',
                    values: [vm.selectedClient.id_clients]
                });
            }

            if (vm.paymentSelectedStatus) {
                filters.push({
                    field: 'id_subsec',
                    values: [vm.paymentSelectedStatus]
                });
            }

            if (vm.paymentSelectedPaid != null && vm.paymentSelectedPaid != undefined) {
                let field = undefined;
                switch (location) {
                    case 'commercial':
                        field = 'commercial_paid';
                        break;
                    case 'sales':
                        field = 'paid';
                        break;
                    case 'organizer':
                        field = 'organizer_paid';
                        break;
                }
                filters.push({
                    field: field,
                    values: [vm.paymentSelectedPaid]
                });
            }

            RuntagService.getSection({
                domain: $scope.siteID,
                section: 'payments_breakdown',
                resultSumField: 'payment_due_usd',
                filters: filters
            }).then((resp) => {
                vm.totals.payment_breakdown.payment_due_usd = resp.sum;
            });

            RuntagService.getSection({
                domain: $scope.siteID,
                section: 'payments_breakdown',
                resultSumField: 'total_sales_usd',
                filters: filters
            }).then((resp) => {
                vm.totals.payment_breakdown.total_sales_usd = resp.sum;
            });

            RuntagService.getSection({
                domain: $scope.siteID,
                section: 'payments_breakdown',
                resultSumField: 'sales_international',
                filters: filters
            }).then((resp) => {
                vm.totals.payment_breakdown.sales_international = resp.sum;
            });

            RuntagService.getSection({
                domain: $scope.siteID,
                section: 'payments_breakdown',
                resultSumField: 'sales_local',
                filters: filters
            }).then((resp) => {
                vm.totals.payment_breakdown.sales_local = resp.sum;
            });

            RuntagService.getSection({
                domain: $scope.siteID,
                section: 'orders',
                resultSumField: 'usd',
                filters: filters
            }).then((resp) => {
                vm.totals.orders.usd = resp.sum;
            });

            RuntagService.getSection({
                domain: $scope.siteID,
                section: 'payments_breakdown',
                resultSumField: 'organizer_commision_payment_due_usd',
                filters: filters
            }).then((resp) => {
                vm.totals.payment_breakdown.organizer_commision_payment_due_usd = resp.sum;
            });

            RuntagService.getSection({
                domain: $scope.siteID,
                section: 'payments_breakdown',
                filters: filters,
                resultSumField: 'sales_local',
                groupBy: 'currency_local',
                sumPerGroup: true
            }).then((resp) => {
                if (resp.sums && resp.sums.length === 1) {
                    vm.totals.payment_breakdown.sales_local = resp.sums[0];
                } else {
                    vm.totals.payment_breakdown.sales_local = [];
                }
            });

            RuntagService.getSection({
                domain: $scope.siteID,
                section: 'orders',
                filters: filters,
                resultSumField: 'price',
                groupBy: 'currency_code',
                sumPerGroup: true
            }).then((resp) => {
                vm.totalOrdersByCurrency = resp.sums;
            });
        }

        function reFilter(variable) {
            if (variable) {
                vm[variable] = undefined;
            }
            if (vm.selectedClient) {
                vm.filteredEvents = vm.events.filter(x => x.id_client == vm.selectedClient.id_clients);
                if (vm.selectedEvent) {
                    vm.events.push(vm.selectedEvent);
                }
            } else {
                vm.filteredEvents = vm.events;
            }
            getOrders(true);
            getPaymentBreakdown(true);
        }

        function createPaymentsTotals(withCurrency, currency) {
            if (!vm.selectedEvent) {
                return;
            }
            let ret = '';
            if (vm.totalOrdersByCurrency) {
                if (currency) {
                    let sum = vm.totalOrdersByCurrency.find(x => x.currency_code === currency);
                    if (sum) {
                        let fixedSum = Number(sum.sum).toLocaleString('en-US', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        });
                        ret = `${ret} ${fixedSum} ${withCurrency ? order.currency_code : ''}`;
                    }
                } else {
                    vm.totalOrdersByCurrency.forEach((order, index) => {
                        let fixedSum = Number(order.sum).toLocaleString('en-US', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        });
                        if (index != 0) {
                            ret = `${ret} | `;
                        }
                        ret = `${ret} ${fixedSum} ${withCurrency ? order.currency_code : ''}`;
                    });
                }
            }
            return ret;
        }

        function getOrganizer() {
            RuntagService.getSection({
                domain: $scope.siteID,
                section: 'organizer'
            }).then(resp => {
                vm.showCommissions = resp.data[0].show_organizer_commission;
            });
        }

        function getClients() {
            var options = {
                domain: $scope.siteID,
                section: 'clients',
                filters: [
                    {
                        field: 'onoff',
                        values: [1]
                    }
                ],
                resultsPerPage: 900
            }
            RuntagService.getSection(options).then((resp) => {
                vm.clients = resp.data;
            });
        }

        /**
         * Eventos del desplegable. Se piden POR PÁGINAS y no los ~770 de golpe: `content/events` lanza dos
         * consultas más por cada fila que devuelve (miniaturas y galerías) e hidrata sus modelos, y pedir 999
         * de una vez es lo que reventaba la memoria de qiu-api (Allowed memory size ... exhausted). Troceado,
         * cada petición es pequeña y la vista arranca con la primera página mientras llegan las demás.
         *
         * Aquí NO sirve stats/perEvent como en Sales: esta vista pinta `local_currency` e
         * `international_currency` del evento y ese endpoint no devuelve esas columnas.
         */
        function getEvents() {
            var deferred = $q.defer();
            vm.events = [];
            vm.filteredEvents = [];
            fetchEventsPage(1, deferred);
            return (deferred.promise);
        }

        function fetchEventsPage(page, deferred) {
            RuntagService.getSection({
                domain: $scope.siteID,
                section: 'events',
                resultsPerPage: EVENTS_PAGE_SIZE,
                page: page
            }).then((resp) => {
                vm.events = vm.events.concat(resp.data || []);
                vm.filteredEvents = vm.selectedClient
                    ? vm.events.filter(x => x.id_client == vm.selectedClient.id_clients)
                    : vm.events;
                if (page === 1) {
                    deferred.resolve(true); // la vista arranca con la primera página
                }
                if (resp.current_page < resp.last_page) {
                    fetchEventsPage(resp.current_page + 1, deferred);
                }
            }).catch(() => {
                if (page === 1) { deferred.resolve(true); }
            });
        }

        function getPaymentBreakdown(reset) {
            vm.loadingPayments = true;
            let paths = $location.path().split('/');
            let location = paths[paths.length - 1];
            if (reset) {
                vm.morePayments = undefined;
            }
            var filters = [];
            if (vm.selectedEvent) {
                filters.push({
                    field: 'id_event',
                    values: [vm.selectedEvent.id_events]
                });
            }
            if (vm.selectedClient) {
                filters.push({
                    field: 'id_client',
                    values: [vm.selectedClient.id_clients]
                });
            }
            if (vm.paymentSelectedStatus) {
                filters.push({
                    field: 'id_subsec',
                    values: [vm.paymentSelectedStatus]
                });
            }
            if (vm.paymentSelectedPaid != null && vm.paymentSelectedPaid != undefined) {
                let field = undefined;
                switch (location) {
                    case 'commercial':
                        field = 'commercial_paid';
                        break;
                    case 'sales':
                        field = 'paid';
                        break;
                    case 'organizer':
                        field = 'organizer_paid';
                        break;
                }
                filters.push({
                    field: field,
                    values: [vm.paymentSelectedPaid]
                });
            }
            var options = {
                domain: $scope.siteID,
                section: 'payments_breakdown',
                filters: filters,
                resultsPerPage: 20
            };
            if (vm.morePayments) {
                options.page = vm.morePayments.nextPage;
            } else {
                vm.payments = [];
            }
            RuntagService.getSection(options).then((resp) => {
                if (vm.morePayments) {
                    vm.payments = vm.payments.concat(resp.data);
                    updatePaymentsPeriods(vm.payments);
                } else {
                    vm.payments = resp.data;
                    updatePaymentsPeriods(vm.payments);
                }
                if (resp.current_page < resp.last_page) {
                    vm.morePayments = {
                        nextPage: resp.current_page + 1
                    }
                } else {
                    vm.morePayments = undefined;
                }
                vm.loadingPayments = false;
            });
        }

        function updatePaymentsPeriods(paymentArray) {
            let payments = paymentArray.sort((a, b) => new Date(a.date_from) + new Date(b.date_to));
            if (vm.paymentSelectedStatus) {
                payments = payments.filter(x => x.id_subsec === vm.paymentSelectedStatus);
            }
            vm.paymentPeriods = {};
            vm.tableArray = [];
            payments.forEach((pay) => {
                var field = undefined;
                switch (vm.paymentSelectedOrder) {
                    case 'date':
                        field = getPeriod(pay.date_from, pay.date_to);
                        break;
                    case 'event':
                        // Los eventos llegan por páginas: el de esta liquidación puede no estar aún en la
                        // lista. Sin la guarda, agrupar por evento reventaba con un TypeError.
                        let event = vm.events.find(x => x.id_events === pay.id_event);
                        field = event ? event.event_name : ('Event ' + pay.id_event);
                        break;
                    case 'status':
                        let status = vm.sectionOptions.payments_breakdown.subsection.find(x => x.id_subsec === pay.id_subsec);
                        field = status.subsec;
                        break;
                }
                if (!vm.paymentPeriods[field]) {
                    vm.paymentPeriods[field] = [];
                }
                vm.paymentPeriods[field].push(pay);
            });
            for (let key in vm.paymentPeriods) {
                vm.tableArray.push({
                    type: 'key',
                    value: key
                });
                vm.paymentPeriods[key].forEach((item) => {
                    vm.tableArray.push({
                        type: 'object',
                        value: item
                    });
                });
            }
            getTotals();
        }

        function getPeriod(from, to) {
            var dateFrom = formatDate(from, 'dd/MM');
            var dateTo = formatDate(to, 'dd/MM');
            return `${dateFrom}-${dateTo}`;
        }

        function getOrders(reset) {
            vm.loadingOrders = true;
            if (reset) {
                vm.moreOrders = undefined;
            }

            var filters = [
                {
                    field: 'id_subsec',
                    values: [2]
                }
            ];
            if (vm.selectedEvent) {
                filters.push({
                    field: 'id_event',
                    values: [vm.selectedEvent.id_events]
                });
            }
            // Sin evento elegido NO se manda filtro de id_event. Antes se enumeraban los ~770 ids uno a uno
            // (un IN gigante en la consulta) para decir "todos": es equivalente a no filtrar, y no es lo que
            // protege los datos — qiu-api añade por su cuenta las restricciones del usuario aunque el cliente
            // no las mande (QueryFilters::filters → addMissingFilters).
            if (vm.selectedClient) {
                filters.push({
                    field: 'id_client',
                    values: [vm.selectedClient.id_clients]
                });
            }
            var options = {
                domain: $scope.siteID,
                section: 'orders',
                filters: filters,
                resultsPerPage: 100
            };

            if (vm.moreOrders) {
                options.page = vm.moreOrders.nextPage;
            } else {
                vm.orders = [];
            }
            RuntagService.getSection(options).then((resp) => {
                if (vm.moreOrders) {
                    vm.orders = vm.orders.concat(resp.data);
                } else {
                    vm.orders = resp.data;
                    vm.totals.orders.total = resp.total;
                }
                if (resp.current_page < resp.last_page) {
                    vm.moreOrders = {
                        nextPage: resp.current_page + 1
                    }
                } else {
                    vm.moreOrders = undefined;
                }
                vm.loadingOrders = false;
            });
        }

        function searchEventName(id) {
            let name = undefined;
            let event = vm.events.find(x => x.id_events == id);
            if (event) {
                name = event.event_name;
            }
            return name;
        }

        function searchClientName(id) {
            let name = undefined;
            let client = vm.clients.find(x => x.id_clients == id);
            if (client) {
                name = client.client_name;
            }
            return name;
        }

        function searchFieldInArray(id, array, field, fieldToReturn) {
            let ret = undefined;
            let objRet = vm[array].find(x => x[field] === id);
            if (objRet) {
                ret = objRet[fieldToReturn];
            }
            return ret;
        }

        function formatDate(date, format) {
            var dateObject = new Date(date);
            return $filter('date')(dateObject, format);
        }

        function autocompleteSearch(query, stringArray, field) {
            var results = query ? vm[stringArray].filter(x => x[field].toLowerCase().indexOf(query.toLowerCase()) != -1) : vm[stringArray];
            return results;
        }

        function checkPays(pay, type) {
            if (pay[type]) {
                return 'done';
            } else {
                var today = new Date();
                var payDate = new Date(pay.date_to);
                var timeDiff = today - payDate;
                var daysDiff = timeDiff / (1000 * 60 * 60 * 24);
                if (daysDiff > 30) {
                    return 'exceed';
                } else {
                    return 'waiting';
                }
            }
        }

        function getSubTotal(item) {
            let runtagPay = item.value.payment_due_usd;
            let serviceCost = item.value.commercial_cost_total;
            return (runtagPay - serviceCost).toFixed(2);
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.users')
        .service('RuntagEventService', RuntagEventService);

    /** @ngInject */
    // I provide access to the session store.
    function RuntagEventService($rootScope, $q, $resource, $log, $stateParams, COMMON, mediaService) {

        function getUsersGroups(options) {
            var deferred = $q.defer();
            var params = {
                domain: options.siteID,
                groupType: options.groupType
            }
            if (options.withGroupType) {
                params.withGroupType = true;
            }
            params.sortDir = options.sortDir || 'ASC';
            params.sortField = options.sortField || 'name';
            resourceGroupsNested.get(params,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    $log.error("ERROR =========================================!!!!!!")
                    $log.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);

        }

        var resourceGroupsNested = $resource(
            COMMON.BASE_API + "/domain/:domain/usersGroupsNested", {
            // No default data.
        }, {
            get: {
                method: "GET",
                isArray: false,
                transformResponse: function (data, headers) {
                    var response = {}
                    response.data = JSON.parse(data);
                    response.qiuRestrictions = JSON.parse(headers('qiu-restrictions'));
                    return response;
                }
            }
        });

        function getDownloads(options) {
            var deferred = $q.defer();

            resourceGetDownloads.get(options,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    $log.error("ERROR =========================================!!!!!!")
                    $log.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function getDownloadsStatsPerPhotographer(options) {
            var deferred = $q.defer();

            resourceGetDownloadsStatsPerPhotographer.get(options,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    $log.error("ERROR =========================================!!!!!!")
                    $log.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function getAvailableDownloads(options) {
            var deferred = $q.defer();

            var params = {
                domain: options.siteID,
                filters: JSON.stringify(options.filters)
            }

            resourceGetAvailableAssigns.get(params,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    $log.error("ERROR =========================================!!!!!!")
                    $log.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        var resourceGetAvailableAssigns = $resource(
            COMMON.BASE_API + "/domain/:domain/content/user_assigns", {
            domain: '@domain',
            id: '@id',
        }, {
            get: {
                method: "GET"
            }
        }
        )

        function getOrders(options) {
            var deferred = $q.defer();

            var params = {
                domain: options.siteID,
                filters: JSON.stringify(options.filters),
                resultSumField: options.resultSumField,
                resultCount: options.resultCount
            }

            // Listado paginado y buscable (detalle de pedidos). Solo se envían si vienen: los usos
            // que ya existían (sumas y conteos) siguen llamando igual que antes.
            if (options.search) { params.search = options.search; }
            if (options.page) { params.page = options.page; }
            if (options.resultsPerPage) { params.resultsPerPage = options.resultsPerPage; }
            if (options.sortField) { params.sortField = options.sortField; }
            if (options.sortDir) { params.sortDir = options.sortDir; }

            resourceGetOrders.get(params,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    $log.error("ERROR =========================================!!!!!!")
                    $log.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        var resourceGetDownloads = $resource(
            COMMON.BASE_API + "/domain/:domain/content/user_downloads", {
            domain: '@domain'
        }, {
            get: {
                method: "GET",
            }
        }
        )

        var resourceGetDownloadsStatsPerPhotographer = $resource(
            COMMON.BASE_API + "/domain/:domain/event/:id_event/downloads/statsPerPhotographer", {
            domain: '@domain',
            id_event: '@id_event'
        }, {
            get: {
                method: "GET",
                isArray: true
            }
        }
        )

        function getUserZipDownloads(options) {
            var deferred = $q.defer();
            var params = {
                domain: options.domain,
                filters: JSON.stringify(options.filters)
            }

            resourceGetUserZipDownloads.get(params,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    $log.error("ERROR GETTING USER ZIP DOWNLOADS", e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        var resourceGetUserZipDownloads = $resource(
            COMMON.BASE_API + "/domain/:domain/content/user_zip_downloads", {
            domain: '@domain'
        }, {
            get: {
                method: "GET",
            }
        }
        )

        var resourceGetOrders = $resource(
            COMMON.BASE_API + "/domain/:domain/content/orders", {
            domain: '@domain',
            id: '@id',
        }, {
            get: {
                method: "GET"
            }
        }
        )

        function createOrder(options) {
            var deferred = $q.defer();
            var item = {
                "item": options.item
            }
            resourceNewOrder.put({
                domain: options.siteID
            }, item,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    $log.error("ERROR =========================================!!!!!!")
                    $log.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        var resourceNewOrder = $resource(
            COMMON.BASE_API + "/domain/:domain/content/orders/new", {
            //No default data.
        }, {
            put: {
                method: "PUT"
            }
        }
        );

        function deleteLocation(options) {
            var deferred = $q.defer();
            resourceDeleteLocation.delete({
                domain: options.domain,
                id_event: options.id_event,
                location: options.location
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    $log.error(e);
                    $log.error("ERROR =========================================!!!!!!");
                    deferred.reject();
                }
            );
            return deferred.promise;
        }

        var resourceDeleteLocation = $resource(
            COMMON.BASE_API + "/domain/:domain/event/:id_event/location/:location", {
            domain: '@domain',
            id_event: '@id_event',
            location: '@location'
        }, {
            delete: {
                method: "DELETE"
            }
        }
        )

        function postLambdaLocation(options) {
            var deferred = $q.defer();
            resourcePostLambdaLocation.post({
                domain: options.domain,
                id_event: options.id_event,
                name: options.name,
                reference_name: options.reference_name
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    $log.error(e);
                    $log.error("ERROR =========================================!!!!!!");
                    deferred.reject();
                }
            );
            return deferred.promise;
        }


        var resourcePostLambdaLocation = $resource(
            COMMON.BASE_API + "/domain/:domain/event/:id_event/location", {
            domain: '@domain',
            id_event: '@id_event'
        }, {
            post: {
                method: "POST"
            }
        }
        );

        function deletePhotographer(options) {
            var deferred = $q.defer();
            resourceDeletePhotographer.delete({
                domain: options.domain,
                id_event: options.id_event,
                id_photographer: options.id_photographer
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    $log.error(e);
                    $log.error("ERROR =========================================!!!!!!");
                    deferred.reject();
                }
            );
            return deferred.promise;
        }

        var resourceDeletePhotographer = $resource(
            COMMON.BASE_API + "/domain/:domain/event/:id_event/photographer/:id_photographer", {
            domain: '@domain',
            id_event: '@id_event',
            id_photographer: '@id_photographer'
        }, {
            delete: {
                method: "DELETE"
            }
        }
        );

        function putLambdaPhotographer(options) {
            var deferred = $q.defer();
            resourcePutLambdaPhotographer.put({
                domain: options.domain,
                id_event: options.id_event,
                id_photographer: options.id_photographer
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    $log.error(e);
                    $log.error("ERROR =========================================!!!!!!");
                    deferred.reject();
                }
            );
            return deferred.promise;
        }

        var resourcePutLambdaPhotographer = $resource(
            COMMON.BASE_API + "/domain/:domain/event/:id_event/photographer/:id_photographer", {
            domain: '@domain',
            id_event: '@id_event',
            id_photographer: '@id_photographer'
        }, {
            put: {
                method: "PUT"
            }
        }
        );

        function postLambdaEvent(options) {
            var deferred = $q.defer();
            resourcePostLambdaEvent.post({
                domain: options.domain,
                id_event: options.id_event
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    $log.error(e);
                    $log.error("ERROR =========================================!!!!!!");
                    deferred.reject();
                }
            );
            return deferred.promise;
        }

        var resourcePostLambdaEvent = $resource(
            COMMON.BASE_API + "/domain/:domain/event/:id_event/assets", {
            domain: '@domain',
            id_event: '@id_event'
        }, {
            post: {
                method: "POST"
            }
        }
        );

        function createItem(options) {
            var deferred = $q.defer();
            var item = {
                "item": options.item
            }
            resourceNewItem.put({
                domain: options.siteID,
                section: options.section
            }, item,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    $log.error("ERROR =========================================!!!!!!")
                    $log.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        var resourceNewItem = $resource(
            COMMON.BASE_API + "/domain/:domain/content/:section/new", {
            //No default data.
        }, {
            put: {
                method: "PUT"
            }
        }
        );

        function updateOrder(options) {
            var deferred = $q.defer();
            var item = {
                "item": options.item
            }
            resourceUpdateOrder.update({
                domain: options.siteID,
                id: options.id
            }, item,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    $log.error("ERROR =========================================!!!!!!")
                    $log.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        var resourceUpdateOrder = $resource(
            COMMON.BASE_API + "/domain/:domain/content/orders/:id", {
            //No default data.
        }, {
            update: {
                method: "PUT"
            }
        }
        );

        function updateItem(options) {
            var deferred = $q.defer();
            var item = {
                "item": options.item
            }
            resourceUpdateItem.update({
                domain: options.siteID,
                id: options.id,
                section: options.section,
                keepOldMedia: options.keepOldMedia
            }, item,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    $log.error("ERROR =========================================!!!!!!")
                    $log.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function deleteItem(options) {
            var deferred = $q.defer();
            resourceDeleteItem.delete({
                domain: options.siteID,
                id: options.id,
                section: options.section
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    $log.error("ERROR =========================================!!!!!!")
                    $log.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        var resourceDeleteItem = $resource(
            COMMON.BASE_API + "/domain/:domain/content/:section/:id", {
            //No default data.
        }, {
            delete: {
                method: "DELETE"
            }
        }
        );

        var resourceUpdateItem = $resource(
            COMMON.BASE_API + "/domain/:domain/content/:section/:id", {
            //No default data.
        }, {
            update: {
                method: "PUT"
            }
        }
        );

        function getMedias(options) {
            var deferred = $q.defer();
            var params = {
                domain: options.siteID,
                id_user: options.id_user,
                id_event: options.id_event,
                withMedia: options.withMedia,
                resultsPerPage: options.resultsPerPage,
                groupBy: options.groupBy,
                page: options.page,
                sortDir: options.sortDir,
                sortField: options.sortField
            }
            resourceGetMediaTagged.get(params,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    $log.error("ERROR =========================================!!!!!!")
                    $log.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function getPresignedLambda(options) {
            var deferred = $q.defer();

            // V2: la lambda /v2/presignedUrl está ROTA (declara un path param 'prefix'
            // requerido que no existe en la ruta -> API Gateway devuelve 400 siempre).
            // En vez de la lambda pedimos el presigned a qiu-api (getS3UploadPreSignedUrl),
            // que firma un PutObject al contenedor de subida por defecto del tenant runtag
            // = bucket 'runtag', que es EXACTAMENTE el que luego leen add_profile y
            // crop_face_profile (getObject sobre RUNTAG_BUCKET='runtag'). Mapeamos su
            // respuesta {url, id_media} al contrato {uploadUrl, objectKey} que espera el modal.
            // V3+ sigue usando la lambda (su ruta /v3/{prefix}/presignedUrl funciona).
            if (options.version && options.version.toLowerCase() === 'v2') {
                mediaService.getS3UploadPreSignedUrl({
                    siteID: options.siteID,
                    fileName: options.mediaName
                }).then(function (resp) {
                    var uploadUrl = (resp && resp.url) ? resp.url : ((resp && resp.data) ? resp.data : null);
                    // objectKey = la key del PUT dentro del bucket. La sacamos del path de la
                    // URL firmada (S3): virtual-hosted (bucket.s3.../key) -> key = path;
                    // path-style (s3.../bucket/key) -> quitamos el primer segmento (bucket).
                    var objectKey = '';
                    try {
                        var u = new URL(uploadUrl);
                        objectKey = u.pathname.replace(/^\/+/, '');
                        if (/^s3[.-]/.test(u.hostname) && objectKey.indexOf('/') > -1) {
                            objectKey = objectKey.substring(objectKey.indexOf('/') + 1);
                        }
                    } catch (e) {
                        objectKey = '';
                    }
                    if (!uploadUrl || !objectKey) {
                        $log.error("ERROR presigned V2 (qiu-api): respuesta inesperada");
                        $log.error(resp);
                        deferred.reject();
                        return;
                    }
                    deferred.resolve({ uploadUrl: uploadUrl, objectKey: objectKey });
                }, function (e) {
                    $log.error("ERROR presigned V2 (qiu-api) =========================================!!!!!!")
                    $log.error(e)
                    deferred.reject();
                });
                return (deferred.promise);
            }

            // V3+: el prefix ya viene en apiUrl -> {base}/v3/{prefix}/presignedUrl (lambda OK)
            $resource(`${options.apiUrl}/presignedUrl?path=${options.mediaName}`, {
                //No default data
            }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            }).get(
                {},
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    $log.error("ERROR =========================================!!!!!!")
                    $log.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function getAllRestoreFiles(options) {
            if (!options) {
                options = {};
            }
            var deferred = $q.defer();

            // ---------- V2 CALL ----------
            var v2Promise = $resource(
                'https://j3dxbw7aff.execute-api.us-east-1.amazonaws.com/prd/v2/allEvents/restoreFiles',
                {},
                {
                    get: {
                        method: 'GET',
                        isArray: false
                    }
                }
            ).get({}).$promise;

            // ---------- V3 CALL ----------
            var v3Params = {};
            if (options.client_id) v3Params.client_id = options.client_id;
            if (options.event_id) v3Params.event_id = options.event_id;

            var v3Promise = $resource(
                'https://gpftm9ods6.execute-api.us-east-1.amazonaws.com/runtagv3/v3/allEvents/restoreFiles',
                {},
                {
                    get: {
                        method: 'GET',
                        isArray: false
                    }
                }
            ).get(v3Params).$promise;

            // ---------- MERGE ----------
            $q.all({
                v2: v2Promise,
                v3: v3Promise
            }).then(
                function (responses) {
                    deferred.resolve({
                        v2: responses.v2,
                        v3: responses.v3
                    });
                },
                function (error) {
                    $log.error('Error fetching restore files', error);
                    deferred.reject(error);
                }
            );

            return deferred.promise;
        }

        function getMediaIdPablo(options) {
            switch (options.version) {
                case 'v2':
                    var mediaId = options.mediaId;
                    break;
                case 'v3':
                    var mediaId = options.mediaId;
                    break;
                default:
                    var mediaId = options.media_id;
                    break;
            }
            var deferred = $q.defer();
            $resource(options.apiUrl + "/mediaFiles/" + mediaId, {
                //No default data
            }, {
                get: {
                    method: "GET",
                    isArray: true
                }
            }).get({
                pagingKey: options.pagingKey
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    $log.error("ERROR =========================================!!!!!!")
                    $log.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        // Recorte de caras en la lambda: POST del array [{createdAt, faces:[{face_id, bbox}]}] a
        // {apiUrl}/crop_media_faces → devuelve [{faces:[{face_id, mediaFile}]}] con la URL del crop.
        function cropMediaFacesPablo(options) {
            var deferred = $q.defer();
            $resource(options.apiUrl + "/crop_media_faces", {}, {
                post: { method: "POST", isArray: true }
            }).post({}, options.media,
                function (response) { deferred.resolve(response); },
                function (e) { $log.error(e); deferred.reject(); }
            );
            return (deferred.promise);
        }

        function getMediasPablo(options) {
            var deferred = $q.defer();
            $resource(options.apiUrl + "/mediaFiles", {
                //No default data
            }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            }).get({
                limit: options.limit,
                sort: options.sort,
                pagingKey: options.pagingKey,
                photographer: options.photographer,
                location: options.location,
                hasDetectedFaces: options.hasDetectedFaces
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    $log.error("ERROR =========================================!!!!!!")
                    $log.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function callToArchive(options) {
            var deferred = $q.defer();

            // Validate input
            if (!options ||
                !options.apiUrl ||
                !options.user_id ||
                !options.media_file ||
                !options.created_at ||
                !options.client_id ||
                !options.event_id ||
                !options.event_name) {

                $log.error("Some field missing", options);
                deferred.reject("Missing required fields");
                return deferred.promise;
            }

            var endpoint = options.apiUrl + '/restore_file';

            var payload = {
                user_id: options.user_id,
                media_file: options.media_file,
                created_at: options.created_at,
                template_id: options.template_id,
                client_id: options.client_id,
                event_id: options.event_id,
                event_name: options.event_name
            };

            var api = $resource(endpoint, {}, {
                put: {
                    method: "PUT"
                }
            });

            // params {}, body payload {}  => sends JSON body
            api.put(
                {},
                payload,
                function success(response) {
                    deferred.resolve(response);
                },
                function error(e) {
                    $log.error("ERROR =========================================!!!!!!");
                    $log.error(e);
                    deferred.reject(e);
                }
            );

            return deferred.promise;
        }

        function getArchiveFiles(options) {
            options = options || {};
            if (!options.apiUrl) {
                return $q.reject(new Error('Missing apiUrl'));
            }

            return $resource(options.apiUrl + "/restoreFiles", {}, {
                get: { method: "GET", isArray: false }
            }).get({
                pagingKey: options.pagingKey
            }).$promise;
        }

        function getStorageTierBulk(options) {
            options = options || {};
            if (!options.apiUrl) {
                return $q.reject(new Error('Missing apiUrl'));
            }

            return $resource(options.apiUrl + "/storageTierBulk", {}, {
                post: { method: "POST", isArray: true }
            }).post(options.items).$promise;
        }

        function getTotalsPablo(options) {
            var deferred = $q.defer();
            $resource(options.apiUrl + "/totals", {
                //No data
            }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            }).get({},
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.warn(`Error al obtener los totales del evento`);
                    $log.error(e);
                    deferred.reject(e);
                }
            );
            return (deferred.promise);
        }

        function getRunnerTotals(options) {
            var deferred = $q.defer();
            $resource(options.apiUrl + "/runnerTotals", {
                //No data
            }, {
                post: {
                    method: "POST",
                    isArray: false
                }
            }).post({
                runner_numbers: options.runner_numbers
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    $log.error("ERROR =========================================!!!!!!")
                    $log.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function removeUnmatchedNumber(options) {
            var deferred = $q.defer();
            $resource(options.apiUrl + "/remove_unmatched_number", {
                //No data
            }, {
                put: {
                    method: "PUT",
                    isarray: false
                }
            }).put({
                invalidNumber: options.invalidNumber,
                mediaFile: options.mediaFile,
                createdAt: options.createdAt
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    $log.error("ERROR =========================================!!!!!!")
                    $log.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function addUserBulk(options) {
            var deferred = $q.defer();
            $resource(options.apiUrl + "/face/runner_number_bulk", {
                //NO data
            }, {
                put: {
                    method: "PUT",
                    isArray: false
                }
            }).put(options.medias,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    $log.error("ERROR =========================================!!!!!!")
                    $log.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function searchByAvatarPablo(options) {
            switch (options.version) {
                case 'v2':
                    var runnerNumber = options.runnerNumber;
                    break;
                default:
                    var runnerNumber = options.runner_number;
                    break;
            }
            var deferred = $q.defer();
            $resource(options.apiUrl + "/find_profile_related_faces/" + runnerNumber, {
                //No data
            }, {
                get: {
                    method: "GET",
                    isArray: true
                }
            }).get(
                {

                },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    $log.error("ERROR =========================================!!!!!!")
                    $log.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function postEventWatermark(options) {
            var deferred = $q.defer();
            $resource(options.apiUrl + "/config/crops", {
                //No data
            }, {
                post: {
                    method: "POST",
                    isArray: false
                }
            }).post(
                {
                    cropFormats: options.config
                },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    $log.error("ERROR =========================================!!!!!!")
                    $log.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function postEventRegex(options) {
            var deferred = $q.defer();
            $resource(options.apiUrl + "/config/regex", {
                //No data
            }, {
                post: {
                    method: "POST",
                    isArray: false
                }
            }).post(
                {
                    regexConfig: options.config
                },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    $log.error("ERROR =========================================!!!!!!")
                    $log.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function searchByFacePablo(options) {
            switch (options.version) {
                case 'v3':
                case 'v2':
                    var faceId = options.faceId;
                    break;
                default:
                    var faceId = options.face_id;
                    break;
            }
            var deferred = $q.defer();
            $resource(options.apiUrl + "/find_related_faces/" + faceId, {
                //No data
            }, {
                get: {
                    method: "GET",
                    isArray: true
                }
            }).get(
                {

                },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    $log.error("ERROR =========================================!!!!!!")
                    $log.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function getUserMediasPablo(options) {
            var deferred = $q.defer();
            $resource(options.apiUrl + "/mediaFiles/runner/" + encodeURIComponent(options.number), {
                //No data
            }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            }).get(
                {
                    number: options.number,
                    limit: options.limit,
                    sort: options.sort,
                    pagingKey: options.pagingKey
                },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    $log.error("ERROR =========================================!!!!!!")
                    $log.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }
        function restoreRunnerFiles(options) {
            var deferred = $q.defer();
            $resource(options.apiUrl + "/restore_runner_files", {}, {
                post: {
                    method: "POST",
                    isArray: false
                }
            }).post(options.params,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    $log.error("ERROR =========================================!!!!!!")
                    $log.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }
        function changeFacePablo(options) {
            var deferred = $q.defer();
            switch (options.version) {
                case 'v3':
                    var params = {
                        faceId: options.faceId,
                        runnerNumber: options.runnerNumber,
                        mediaFile: options.mediaFile,
                        createdAt: options.createdAt,
                        sort: options.sort,
                        limit: options.limit,
                        editedBy: 'admin'
                    }
                    break;
                case 'v2':
                    var params = {
                        faceId: options.faceId,
                        runnerNumber: options.runnerNumber,
                        mediaFile: options.mediaFile,
                        createdAt: options.createdAt,
                        sort: options.sort,
                        limit: options.limit,
                        editedBy: 'admin'
                    }
                    break;
                default:
                    var params = {
                        face_id: options.face_id,
                        runner_number: options.runner_number,
                        media_file: options.media_file,
                        created_at: options.created_at,
                        sort: options.sort,
                        limit: options.limit,
                        edited_by: 'admin'
                    }
                    break;
            }
            $resource(options.apiUrl + "/face/runner_number", {
                // No data
            }, {
                put: {
                    method: "PUT",
                    isArray: false
                }
            }).put(params, function (response) {
                deferred.resolve(response);
            },
                function (e) {
                    $log.error("ERROR =========================================!!!!!!")
                    $log.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function notMePablo(options) {
            var deferred = $q.defer();
            switch (options.version) {
                case 'v3':
                    var params = {
                        faceId: options.faceId,
                        mediaFile: options.mediaFile,
                        createdAt: options.createdAt,
                        runnerNumber: options.runnerNumber
                    }
                    break;
                case 'v2':
                    var params = {
                        faceId: options.faceId,
                        mediaFile: options.mediaFile,
                        createdAt: options.createdAt,
                        runnerNumber: options.runnerNumber
                    }
                    break;
                default:
                    var params = {
                        face_id: options.face_id,
                        media_file: options.media_file,
                        created_at: options.created_at,
                        runner_number: options.runner_number
                    }
                    break;
            }
            $resource(options.apiUrl + "/face/it_is_not_me", {
                //No data
            }, {
                put: {
                    method: "PUT",
                    isArray: false
                }
            }).put(params, function (response) {
                deferred.resolve(response);
            },
                function (e) {
                    $log.error("ERROR =========================================!!!!!!")
                    $log.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        /**
        * Reprocess request parameters.
        *
        * @param {Object} params
        * @param {'ai_failed'|'crop_failed'|'metadata_error'|'repeated'|'unknown_failure'} params.status
        *        Status filter used to select which items will be reprocessed.
        *
        * @param {'reprocess_image_by_status'|'reprocess_image_by_id'|'reprocess_regex'} params.reprocessType
        *        Reprocessing strategy to be applied on the backend.
        */
        function reprocessRequests(options) {
            var deferred = $q.defer();
            var params = {
                reprocessType: options.reprocessType
            };
            $resource(options.apiUrl + "/reprocessRequest", {

            }, {
                post: {
                    method: "POST",
                    isArray: false
                }
            }).post(params, function (resp) {
                deferred.resolve(resp);
            },
                function (e) {
                    $log.error("ERROR =========================================!!!!!!")
                    $log.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function downloadLambda(options) {
            var deferred = $q.defer();
            resourceDownloadLambda.get({
                domain: options.domain,
                'fileUrl[]': options['fileUrl[]']
            },
                function (response) {
                    deferred.resolve(response);
                },
                {
                    function(e) {
                        $log.error("ERROR =========================================!!!!!!")
                        $log.error(e)
                        deferred.reject();
                    }
                }
            );
            return (deferred.promise);
        }

        var resourceDownloadLambda = $resource(
            COMMON.BASE_API + "/domain/:domain/media/getS3DownloadPreSignedUrl", {
            //No default data
        }, {
            get: {
                method: "GET",
                isArray: true
            }
        }
        )

        var resourceGetMediaTagged = $resource(
            COMMON.BASE_API + "/domain/:domain/usersFaces", {
            domain: '@domain',
            id: '@id',
        }, {
            get: {
                method: "GET",
                isArray: false
            }
        }
        )



        function getPaymentMethods(options) {
            var deferred = $q.defer();
            var params = {
                domain: options.siteID
            }
            resourceGetPaymentMethods.get(params,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    $log.error("ERROR =========================================!!!!!!")
                    $log.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function getProducts(options) {
            var deferred = $q.defer();

            var params = {
                domain: options.siteID,
                filters: JSON.stringify(options.filters),
                resultsPerPage: options.resultsPerPage
            }

            resourceGetProducts.get(params,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    $log.error("ERROR =========================================!!!!!!")
                    $log.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function getUsers(options) {
            var deferred = $q.defer();
            var params = {
                domain: options.siteID,
                filters: JSON.stringify(options.filters),
                resultsPerPage: options.resultsPerPage
            }
            if (options.userIds) {
                params['id_user[]'] = options.userIds;
            }
            resourceGetUsers.get(params,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    $log.error("ERROR =========================================!!!!!!")
                    $log.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        var resourceGetUsers = $resource(COMMON.BASE_API + "/domain/:domain/users", {

        }, {
            get: {
                method: "GET",
                isArray: false
            }
        })

        function getContent(options) {
            var deferred = $q.defer();
            var params = {
                domain: options.siteID,
                filters: options.filters ? JSON.stringify(options.filters) : undefined,
                content: options.content,
                resultsPerPage: options.resultsPerPage,
                resultCount: options.resultCount,
                resultSumField: options.resultSumField,
                groupBy: options.groupBy,
                customGroupBy: options.customGroupBy ? JSON.stringify(options.customGroupBy) : undefined
            }
            resourceGetContent.get(params,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    $log.error("ERROR =========================================!!!!!!")
                    $log.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        var resourceGetContent = $resource(
            COMMON.BASE_API + "/domain/:domain/content/:content", {
            //No default data
        },
            {
                method: "GET",
                isArray: false
            }
        )

        var resourceGetProducts = $resource(
            COMMON.BASE_API + "/domain/:domain/content/products", {
            get: {
                method: "GET",
                isArray: true
            }
        }
        )

        var resourceGetPaymentMethods = $resource(
            COMMON.BASE_API + "/domain/:domain/content/payment_methods", {
            get: {
                method: "GET",
                isArray: true
            }
        }
        )

        function getCountries(options) {
            var deferred = $q.defer();
            resourceGetCountries.get({
                resultsPerPage: options.paginate,
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    $log.error(e)
                    $log.error("ERROR =========================================!!!!!!")
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        var resourceGetCountries = $resource(
            COMMON.BASE_API + "/location/countries", {
            //No default data.
        }, {
            get: {
                method: "GET"
            }
        }
        );

        function saveUser(options) {
            var deferred = $q.defer();
            resource_user_byID.update({
                domain: options.site,
                id: options.id,
                verify: options.item.verify
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    $log.error(e)
                    $log.error("ERROR =========================================!!!!!!")
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        var resource_user_byID = $resource(
            COMMON.BASE_API + "/domain/:domain/users/:id", {
            domain: '@domain',
            id: '@id',
        }, {
            update: {
                method: "PUT",
            }
        }
        );

        function deleteFaceID(options) {
            var deferred = $q.defer();
            resource_delete_faceID.delete({
                domain: options.domain,
                id_event: options.id_event,
                id_media: options.id_media,
                id_user: options.id_user
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    $log.error(e)
                    $log.error("ERROR =========================================!!!!!!")
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        var resource_delete_faceID = $resource(
            COMMON.BASE_API + "/domain/:domain/userFace/:faceID", {
            //No default data
        }, {
            delete: {
                method: "DELETE",
            }
        }
        )

        function updateMedia(options) {
            var deferred = $q.defer();
            resource_update_media.update({
                domain: options.domain,
                mediaID: options.mediaID
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    $log.error(e)
                    $log.error("ERROR =========================================!!!!!!")
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        var resource_update_media = $resource(
            COMMON.BASE_API + "/domain/:domain/media/:mediaID", {
            domain: '@domain',
            mediaID: '@mediaID'
        }, {
            update: {
                method: "PUT",
            }
        }
        )

        function getMediaWithTags(options) {
            var deferred = $q.defer();
            resource_get_media.get({
                domain: options.domain,
                withTags: options.withTags,
                withGalleries: options.withGalleries,
                hasIgnoredPersons: options.hasIgnoredPersons,
                resultsPerPage: options.resultsPerPage,
                sortField: options.sortField,
                sortDir: options.sortDir,
                withCropStatus: options.withCropStatus,
                withAiRecognition: options.withAiRecognition,
                dateFrom: options.dateFrom,
                withFilters: JSON.stringify(options.filters),
                page: options.page,
                media_type: options.media_type,
                hasRejected: options.hasRejected
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    $log.error(e)
                    $log.error("ERROR =========================================!!!!!!")
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        var resource_get_media = $resource(
            COMMON.BASE_API + "/domain/:domain/media", {
            //No default data
        }, {
            get: {
                method: "GET",
            }
        }
        )

        function postNewUsersFaces(options) {
            var deferred = $q.defer();
            resource_put_usersFaces.post({
                domain: options.domain,
                id_media: options.id_media,
                id_user: options.id_user,
                id_event: options.id_event
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    $log.error(e)
                    $log.error("ERROR =========================================!!!!!!")
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        var resource_put_usersFaces = $resource(
            COMMON.BASE_API + "/domain/:domain/usersFaces", {
            domain: '@domain'
        }, {
            post: {
                method: "POST",
            }
        }
        )

        function getMediaDetectedText(options) {
            var deferred = $q.defer();
            resource_detected_text.post({
                domain: options.domain,
                no_id_media: options.no_id_media,
                withTags: options.withTags,
                withCropStatus: options.withCropstatus,
                withGalleries: options.withGalleries,
                withAiRecognition: options.withAiRecognition,
                resultsPerPage: options.resultsPerPage,
                dateFrom: options.dateFrom,
                page: options.page,
                detected_texts: options.detected_texts
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    $log.error(e)
                    $log.error("ERROR =========================================!!!!!!")
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        var resource_detected_text = $resource(
            COMMON.BASE_API + "/domain/:domain/media/detectedText", {
            domain: '@domain'
        }, {
            post: {
                method: "POST",
                isArray: true
            }
        }
        )

        function getFileDownloads(options) {
            var deferred = $q.defer();

            resource_get_fileDownloads.get({
                domain: options.domain,
                filename: options.filename,
                event_id: options.event_id,
                event_group_id: options.event_group_id,
                file_created_at: options.file_created_at
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    $log.error(e);
                    $log.error("ERROR =========================================!!!!!!");
                    deferred.reject();
                });

            return deferred.promise;
        }

        var resource_get_fileDownloads = $resource(
            COMMON.BASE_API + "/domain/:domain/file_downloads", {
            domain: '@domain',
            filename: '@filename',
            event_id: '@event_id',
            event_group_id: '@event_group_id',
            file_created_at: '@file_created_at'
        }, {
            get: {
                method: "GET",
                isArray: true
            }
        }
        );

        function getEventsStats(options) {
            var deferred = $q.defer();
            var params = {
                domain: options.domain,
                from: options.from || '',
                to: options.to || '',
                resultsPerPage: options.resultsPerPage || 10,
                page: options.page,
                event_state_id: options.event_state_id,
                event_name: options.event_name || undefined,
                client_id: options.client_id,
                sortDir: options.sortDir,
                sortField: 'event_date'
            };

            resource_get_eventStats.get(params,
                function (response) {
                    deferred.resolve(response);
                },
                function (error) {
                    $log.error("ERROR =========================================!!!!!!");
                    $log.error(error);
                    deferred.reject(error);
                }
            );

            return deferred.promise;
        }

        // Async ZIP generation on the event lambda: same endpoint the runner's website uses
        // (qiupreview bulkDownloadZip → imagePackRequest). Resolves { uuid, status, ... }.
        function requestImagePack(options) {
            return $resource(options.apiUrl.replace(/\/+$/, '') + "/imagePackRequest", {}, {
                post: { method: "POST", isArray: false }
            }).post({
                created_at_list: options.createdAtList,
                userId: options.userId || '',
                runnerNumber: options.runnerNumber || ''
            }).$promise;
        }

        // Status of an image pack: { status: REQUESTED|PROCESSING|COMPLETED|FAILED|ERROR, outputUrl, ... }.
        function getImagePackStatus(options) {
            return $resource(options.apiUrl.replace(/\/+$/, '') + "/imagePackRequest/:uuid", { uuid: '@uuid' }, {
                get: { method: "GET", isArray: false }
            }).get({ uuid: options.uuid }).$promise;
        }

        var resource_get_eventStats = $resource(
            COMMON.BASE_API + "/domain/:domain/stats/perEvent", {
            domain: '@domain',
            from: '@from',
            to: '@to',
            resultsPerPage: '@resultsPerPage',
            page: '@page',
            event_state_id: '@event_state_id',
            event_name: '@event_name'
        }, {
            get: {
                method: "GET",
                isArray: false
            }
        }
        );

        function getEventsOptions(options) {
            var deferred = $q.defer();
            var params = {
                domain: options.domain,
            };

            resource_get_eventsOptions.get(params,
                function (response) {
                    deferred.resolve(response);
                },
                function (error) {
                    $log.error("ERROR =========================================!!!!!!");
                    $log.error(error);
                    deferred.reject(error);
                }
            );

            return deferred.promise;
        }

        var resource_get_eventsOptions = $resource(
            COMMON.BASE_API + "/domain/:domain/content/events/options", {
            domain: '@domain',
        }, {
            get: {
                method: "GET",
                isArray: false
            }
        }
        );

        return ({
            getUsersGroups: getUsersGroups,
            getOrders: getOrders,
            getAvailableDownloads: getAvailableDownloads,
            getDownloads: getDownloads,
            getMedias: getMedias,
            getMediasPablo: getMediasPablo,
            getArchiveFiles: getArchiveFiles,
            callToArchive: callToArchive,
            getAllRestoreFiles: getAllRestoreFiles,
            getMediaIdPablo: getMediaIdPablo,
            cropMediaFacesPablo: cropMediaFacesPablo,
            searchByFacePablo: searchByFacePablo,
            postEventWatermark: postEventWatermark,
            postEventRegex: postEventRegex,
            searchByAvatarPablo: searchByAvatarPablo,
            getUserMediasPablo: getUserMediasPablo,
            getTotalsPablo: getTotalsPablo,
            getRunnerTotals: getRunnerTotals,
            removeUnmatchedNumber: removeUnmatchedNumber,
            addUserBulk: addUserBulk,
            downloadLambda: downloadLambda,
            getPresignedLambda: getPresignedLambda,
            changeFacePablo: changeFacePablo,
            notMePablo: notMePablo,
            getPaymentMethods: getPaymentMethods,
            getProducts: getProducts,
            getContent: getContent,
            getUsers: getUsers,
            createOrder: createOrder,
            getCountries: getCountries,
            saveUser: saveUser,
            updateMedia: updateMedia,
            updateOrder: updateOrder,
            deleteFaceID: deleteFaceID,
            getMediaWithTags: getMediaWithTags,
            postNewUsersFaces: postNewUsersFaces,
            getMediaDetectedText: getMediaDetectedText,
            getFileDownloads: getFileDownloads,
            getEventsStats: getEventsStats,
            getEventsOptions: getEventsOptions,
            getArchiveFiles: getArchiveFiles,
            getAllRestoreFiles: getAllRestoreFiles,
            getStorageTierBulk: getStorageTierBulk,
            postLambdaLocation: postLambdaLocation,
            putLambdaPhotographer: putLambdaPhotographer,
            postLambdaEvent: postLambdaEvent,
            createItem: createItem,
            updateItem: updateItem,
            deleteItem: deleteItem,
            deletePhotographer: deletePhotographer,
            deleteLocation: deleteLocation,
            deleteLocation: deleteLocation,
            reprocessRequests: reprocessRequests,
            requestImagePack: requestImagePack,
            getImagePackStatus: getImagePackStatus,
            restoreRunnerFiles: restoreRunnerFiles,
            getUserZipDownloads: getUserZipDownloads,
            getDownloadsStatsPerPhotographer: getDownloadsStatsPerPhotographer
        });

    }
})();
(function () {
    'use strict';

    angular.module('app.runtag')
        .controller('RuntagEventControllerV2', RuntagEventControllerV2);

    /** @ngInject */
    function RuntagEventControllerV2($scope, $rootScope, $document, $mdDialog, $window, $mdMedia, $mdToast,
        $mdSidenav, $state, msApi, requestContext, $timeout,
        RuntagEventService, sharedFunctionsMailing, msUtils,
        $translate, sessionService, RuntagService, usersService, contentService,
        mediaService, transformUsers, $stateParams, $filter, $q, $log, $location, $http,
        RuntagRunnerService) {

        var vm = this;

        //Functions
        vm.filterUsers = filterUsers;
        vm.setFilter = setFilter;
        vm.selectEvent = selectEvent;
        vm.selectUser = selectUser;
        vm.selectUserFromEventList = selectUserFromEventList;
        vm.resetSearchByFace = resetSearchByFace;
        vm.searchByAvatar = searchByAvatar;
        vm.openImageDialog = openImageDialog;
        vm.openShoppingDialog = openShoppingDialog;
        vm.changeTemplate = changeTemplate;
        vm.loadRunnerProfiles = loadRunnerProfiles;
        vm.selectRunnerProfile = selectRunnerProfile;
        vm.renameRunnerProfile = renameRunnerProfile;
        vm.deleteRunnerProfile = deleteRunnerProfile;
        vm.addRunnerProfileByDorsal = addRunnerProfileByDorsal;
        vm.addRunnerProfileByFace = addRunnerProfileByFace;
        vm.reset = reset;
        vm.init = init;
        vm.getCleanUsersGroup = getCleanUsersGroup;
        vm.infoUserView = infoUserView;
        vm.cancelEditUser = cancelEditUser;
        vm.saveUser = saveUser;
        vm.downloadImage = downloadImage;
        vm.downloadProfilePhotos = downloadProfilePhotos;
        vm.toggleRemoved = toggleRemoved;
        vm.showMoreRemoved = showMoreRemoved;
        vm.cancel = cancel;
        vm.setProfileImage = setProfileImage;
        vm.changeMediaTemplate = changeMediaTemplate;
        vm.uploadAllProfilePhotos = uploadAllProfilePhotos;
        vm.showAllMedia = showAllMedia;
        vm.changeSort = changeSort;
        vm.changeLimit = changeLimit;
        vm.showAllUnrecognized = showAllUnrecognized;
        vm.getUnrecognizedPhotos = getUnrecognizedPhotos;
        vm.loadMoreMedia = loadMoreMedia;
        vm.restoreRunnerFiles = restoreRunnerFiles;
        vm.hasArchivedPhotos = hasArchivedPhotos;
        vm.nextPage = nextPage;
        vm.prevPage = prevPage;
        vm.getBackAllMedia = getBackAllMedia;
        vm.filterByMediaId = filterByMediaId;
        vm.openSearchFaceModal = openSearchFaceModal;
        vm.filterPhotographers = filterPhotographers;
        vm.closePrebuyPanel = closePrebuyPanel;
        vm.openPrebuyPanel = openPrebuyPanel;
        vm.translate = instantTranslate;
        vm.validateEmail = validateEmail;
        vm.addChips = addChips;
        vm.createPrebuys = createPrebuys;
        vm.clearSearchTerm = clearSearchTerm;
        vm.filterEvents = filterEvents;
        vm.findTotalCurrency = findTotalCurrency;
        vm.sumFields = sumFields;
        vm.getUserNumber = getUserNumber;
        vm.getUserProfiles = getUserProfiles;
        vm.getUsers = getUsers;
        vm.formatDate = formatDate;
        vm.scrollTo = scrollTo;
        vm.findTotalUSDproduct = findTotalUSDproduct;
        vm.cancelExcelPrebuyEmails = cancelExcelPrebuyEmails;
        vm.openImportDialog = openImportDialog;
        vm.selectMediaItem = selectMediaItem;
        vm.deleteSelectedMedias = deleteSelectedMedias;
        vm.initAssignBulk = initAssignBulk;
        vm.assignSearchResultToProfile = assignSearchResultToProfile;
        vm.assignSelectedSearchToProfile = assignSelectedSearchToProfile;
        vm.searchAssignSaving = {};
        vm.searchAssignBulkSaving = false;
        vm.closeAssignBulk = closeAssignBulk;
        vm.returnToSearch = returnToSearch;
        vm.searchAssignUser = searchAssignUser;
        vm.userBulk = userBulk;
        vm.deleteChip = deleteChip;
        vm.getEventsStats = getEventsStats;
        vm.changeSubsec = changeSubsec;
        vm.editEvent = editEvent;
        vm.checkUserOrders = checkUserOrders;
        vm.getAvailableDividerPhotographers = getAvailableDividerPhotographers;
        vm.openSettings = openSettings;
        vm.deselectGroup = deselectGroup;
        vm.onArchiveRestoreClick = onArchiveRestoreClick;
        vm.isAllSearchedItemsSelected = isAllSearchedItemsSelected;
        vm.toggleSelectAllSearchedItems = toggleSelectAllSearchedItems;
        vm.setPhotographersTableMode = setPhotographersTableMode;
        vm.setSalesTableMode = setSalesTableMode;
        vm.loadOrderDetail = loadOrderDetail;
        vm.onOrderDetailSearch = onOrderDetailSearch;
        vm.setOrderDetailStatus = setOrderDetailStatus;
        vm.orderDetailStatusLabel = orderDetailStatusLabel;
        vm.orderDetailStatusClass = orderDetailStatusClass;
        vm.editOrderFromList = editOrderFromList;
        vm.visibleOrderRows = visibleOrderRows;
        vm.toggleOrderRelated = toggleOrderRelated;
        vm.goToUserFromOrder = goToUserFromOrder;
        vm.reprocessPhotos = reprocessPhotos;
        vm.filterUserMedia = filterUserMedia;
        vm.clearMediaSearch = clearMediaSearch;
        vm.resetMediaPagination = resetMediaPagination;
        vm.getOrderIcon = getOrderIcon;
        vm.getOrderStatusColor = getOrderStatusColor;
        vm.getOrderStatusName = getOrderStatusName;
        //Functions

        vm.typeOfSearch = "users";
        vm.view = "app/main/apps/runtag/event/views/templates/events-template-v2.html"
        vm.isFiltered = false;
        vm.selectedUser = undefined;
        vm.filteredUserTemplate = "info"; //media, shopping, messages
        vm.userShoppings = [];
        vm.failedTransactions = 0;
        vm.shoppingOrders = [];       // vista enriquecida de compras (eventos de carrito): cobertura por perfil/fotos
        vm.shoppingFailedCount = 0;
        vm.paymentMethods = [];
        vm.products = [];
        vm.cartSales = null;          // desglose de ventas por producto de referencia (solo eventos de carrito)
        vm.loadingCartSales = false;
        vm.countries = [];
        vm.currentTab = 'preview';
        vm.reloadDialog = false;
        vm.selectedEvent = undefined;
        vm.addUserBulk = false;
        vm.usersToAdd = [];

        vm.tags = sessionService.site_operative.tags;
        var totalsPromises = {};
        vm.selectedLanguage = sessionService.getLanguage();

        vm.sort = 'desc';

        vm.limitMenu = [12, 20, 60, 100, 200, 250];
        var _savedLimit = parseInt(localStorage.getItem('runtag_limitPerPage'), 10);
        vm.limitPerPage = (vm.limitMenu.indexOf(_savedLimit) !== -1) ? _savedLimit : 20;

        $scope.$watch(function () { return vm.limitPerPage; }, function (newVal) {
            if (newVal && vm.limitMenu.indexOf(newVal) !== -1) {
                localStorage.setItem('runtag_limitPerPage', newVal);
            }
        });

        vm.addPrebuys = false;
        vm.loadingPrebuys = false;
        vm.prebuyEmails = [];
        vm.excelPrebuyEmails = [];
        vm.prebuyProducts = [];
        vm.prebuySelectedProduct = undefined;
        vm.creatingOrders = false;
        vm.searchTerm = '';
        vm.currentClient = undefined;

        vm.customLocale = {
            'GROUP_SEP': '.'
        };

        vm.loadingProducts = false;

        vm.usersArray = [];
        vm.usersOrders = [];
        vm.moreUsersParams = undefined;
        vm.loadinMoreUsers = false;

        vm.shortCutEvents = [];
        vm.eventsGroup = [];

        vm.loadingExcel = false;

        vm.actualLocation = undefined;

        vm.clients = [];

        vm.selectedMedias = [];

        vm.usersOrder = 'firstname';
        vm.usersSort = 'ASC';
        vm.eventsSortDir = 'DESC';

        vm.generatingZip = false;

        vm.uniqueClients = [];
        vm.eventsStatesMap = [];
        vm.archiveItems = [];
        vm.rawArchiveItems = [];
        vm.archivePagingKey = null;
        vm.selectedState = 'all';
        vm.eventsQuerySearch = undefined;
        vm.selectedClientId = "all";

        vm.isAdmin = sessionService.user && sessionService.user.is_admin;


        vm.availableDownloads = undefined;
        vm.mediaSearch = '';

        vm.activePhotographersTableMode = 'photographers';
        // Vista activa de la tabla de ventas: agregado por producto ('sales') o listado de
        // pedidos ('orders'). El listado se pide la primera vez que se abre su pestaña.
        vm.activeSalesTableMode = 'sales';
        vm.orderDetail = {
            rows: [],
            loading: false,
            loadingMore: false,
            total: 0,
            hasMore: false,
            search: '',
            status: 'all',
            page: 1,
            requestId: 0,
            searchTimer: null,
            // Id de la compra cuyos perfiles se están trayendo antes de abrir el diálogo (solo carrito).
            loadingProfilesFor: null,
            // Id de la compra desde la que se está abriendo la ficha del corredor.
            openingUser: null
        };
        vm.mediaPagination = {
            history: [null],
            currentIndex: 0,
            hasNext: false
        };

        init();

        function init() {

            sessionService.loadDomainResourceSettings($scope.siteID).then(function (response) {
                if (response.public) {
                    var publicConfig = angular.fromJson(response.public);
                    sessionService.authenticate(siteID).then(function (response) {
                        if (publicConfig.adminAccounts && publicConfig.adminAccounts.indexOf(response.account.email) != -1) {
                            vm.isAdmin = true;
                            // Only load global archive if no event is selected via hash
                            if (!$location.hash()) {
                                getAllRestoreFiles();
                            }
                        } else {
                            vm.isAdmin = false;
                        }
                    });
                }
            });

            vm.isLoadingGroups = true;
            vm.totalRunners = 0;
            vm.totalAccess = 0;
            vm.totalPhotos = 0;
            vm.averagePhotos = 0;
            vm.recognizedPhotos = 0;
            vm.totalOrders = 0;
            vm.totalOrdersUSD = 0;
            vm.totalOrdersUSDbyProduct = [];
            vm.manualUSDbyProduct = {};   // USD manual por producto (se resta de cada fila de producto)
            vm.totalManualUSD = 0;        // USD de la fila "Manual"
            vm.eventFirstCrop = "";

            var siteID = requestContext.getParam("siteId");

            var section = 'users';

            $scope.siteID = siteID;
            vm.siteID = siteID;
            $scope.section = section;

            vm.filteredUsers = [];

            getClients();
            getCleanUsersGroup();
            getPaymentMethods();
            getCountries();
            getEventsOptions();
            var eventIdFromHash = $location.hash();

            if (eventIdFromHash) {

                RuntagService.getSection({
                    domain: $scope.siteID,
                    section: 'events',
                    filters: [
                        {
                            field: 'id_events',
                            values: [eventIdFromHash]
                        }
                    ]
                }).then(response => {
                    if (angular.isArray(response.data) && response.data.length) {
                        selectEvent(response.data[0]);
                    }
                });
            }

        }

        function setPhotographersTableMode(mode) {
            vm.activePhotographersTableMode = mode;
        }

        // ---------- DETALLE DE PEDIDOS ----------
        // Listado individual de las compras del evento, lo más reciente primero, con buscador por
        // pedido / cliente / email / dorsal. Es una herramienta de soporte: cuando un corredor
        // pregunta por su compra, hay que poder encontrarla sin salir del evento.
        // La tabla de SALES de al lado es un agregado por producto; esto es lo contrario.
        function setSalesTableMode(mode) {
            vm.activeSalesTableMode = mode;
            if (mode === 'orders' && !vm.orderDetail.rows.length && !vm.orderDetail.loading) {
                loadOrderDetail(false);
            }
        }

        // Estados de subsection_orders: 1 generado, 2 PAGADO, 3 rechazado, 4 cancelado,
        // 5 pendiente, 6 bloqueado. El 7 (recolectado) queda FUERA a propósito: son perfiles que
        // el corredor recolectó, a precio 0, y no son compras.
        var ORDER_DETAIL_STATUSES = {
            all: [1, 2, 3, 4, 5, 6],
            paid: [2],
            pending: [1, 5],
            failed: [3, 4]
        };

        function setOrderDetailStatus(status) {
            if (vm.orderDetail.status === status) { return; }
            vm.orderDetail.status = status;
            loadOrderDetail(false);
        }

        // El buscador escribe letra a letra: se espera a que pare para no lanzar una petición por tecla.
        function onOrderDetailSearch() {
            if (vm.orderDetail.searchTimer) { $timeout.cancel(vm.orderDetail.searchTimer); }
            vm.orderDetail.searchTimer = $timeout(function () {
                vm.orderDetail.searchTimer = null;
                loadOrderDetail(false);
            }, 350);
        }

        function loadOrderDetail(append) {
            if (!vm.selectedGroup || !vm.selectedGroup.id_events) { return; }

            if (append) {
                if (vm.orderDetail.loadingMore || !vm.orderDetail.hasMore) { return; }
                vm.orderDetail.page++;
                vm.orderDetail.loadingMore = true;
            } else {
                vm.orderDetail.page = 1;
                vm.orderDetail.loading = true;
                vm.orderDetail.rows = [];
                vm.orderDetail.hasMore = false;
            }

            // Si mientras llega una respuesta se cambia la búsqueda, la anterior se descarta.
            var peticion = ++vm.orderDetail.requestId;
            var estados = ORDER_DETAIL_STATUSES[vm.orderDetail.status] || ORDER_DETAIL_STATUSES.all;

            return RuntagEventService.getOrders({
                siteID: $scope.siteID,
                filters: [
                    { field: 'id_event', name: 'Event', values: [vm.selectedGroup.id_events] },
                    { field: 'id_subsec', name: 'Status', values: estados }
                ],
                search: vm.orderDetail.search,
                page: vm.orderDetail.page,
                resultsPerPage: 20,
                // id_orders es autoincremental: ordenar por él descendente da "las últimas que
                // entraron" sin depender de created_at, que en los pedidos heredados falta a veces.
                sortField: 'id_orders',
                sortDir: 'desc'
            }).then(function (response) {
                if (peticion !== vm.orderDetail.requestId) { return; }
                var cuerpo = (response && response.result) ? response.result : response;
                var filas = (cuerpo && cuerpo.data) ? cuerpo.data : [];
                filas.forEach(decorateOrderDetailRow);

                vm.orderDetail.rows = append ? vm.orderDetail.rows.concat(filas) : filas;
                vm.orderDetail.total = (cuerpo && cuerpo.total) ? cuerpo.total : filas.length;
                vm.orderDetail.hasMore = (cuerpo && cuerpo.current_page && cuerpo.last_page)
                    ? cuerpo.current_page < cuerpo.last_page
                    : false;
                vm.orderDetail.loading = false;
                vm.orderDetail.loadingMore = false;
            }).catch(function () {
                if (peticion !== vm.orderDetail.requestId) { return; }
                // Si falló al pedir más, la página anterior se queda como la última buena.
                if (append) { vm.orderDetail.page--; }
                vm.orderDetail.loading = false;
                vm.orderDetail.loadingMore = false;
            });
        }

        // Se resuelve una vez por fila lo que hay que mirar en el JSON, y no en cada digest.
        function decorateOrderDetailRow(order) {
            if (!order) { return; }
            var files = null;
            if (order.files && angular.isString(order.files)) {
                try { files = angular.fromJson(order.files); } catch (e) { files = null; }
            } else if (order.files && angular.isObject(order.files)) {
                files = order.files;
            }
            order._createdAt = order.created_at
                ? new Date(String(order.created_at).replace(' ', 'T'))
                : null;
            order._dorsal = orderDetailDorsal(order, files);
            order._productName = orderDetailProduct(order, files);
            order._items = orderDetailItems(order, files, order._productName);
            order._paymentName = orderDetailPayment(order);
        }

        /**
         * Dorsal del pedido. No vive en un solo sitio:
         *  - user_number: lo rellena el flujo clásico, no el carrito.
         *  - files.dorsal: compras heredadas y perfiles asignados.
         *  - files.runners[].dorsal: carrito de perfil completo (puede haber varios en un pedido).
         * Una compra de fotos sueltas puede no llevar dorsal: entonces no se inventa.
         */
        function orderDetailDorsal(order, files) {
            if (order.user_number) { return String(order.user_number); }
            if (!files) { return ''; }
            if (files.dorsal) { return String(files.dorsal); }
            var dorsales = [];
            (angular.isArray(files.runners) ? files.runners : []).forEach(function (runner) {
                if (runner && runner.dorsal) { dorsales.push(String(runner.dorsal)); }
            });
            return dorsales.length ? dorsales.join(' · ') : '';
        }

        function orderDetailProduct(order, files) {
            var encontrado = null;
            if (order.id_product) {
                for (var i = 0; i < vm.products.length; i++) {
                    if (vm.products[i].id == order.id_product) { encontrado = vm.products[i].product; break; }
                }
            }
            if (encontrado) { return encontrado; }
            // Sin producto de catálogo (p. ej. pagos manuales), el tipo de compra ya dice bastante.
            if (files && files.type === 'profile_cart') { return $translate.instant('RUNTAG.ORDER_WHOLE_PROFILE'); }
            if (files && files.type === 'mixed_cart') { return $translate.instant('RUNTAG.ORDER_CART'); }
            return '—';
        }

        function orderDetailItems(order, files, productName) {
            var total = parseInt(order.items_total, 10);
            if (total > 0) {
                var texto = total === 1
                    ? $translate.instant('RUNTAG.ORDER_ONE_PHOTO')
                    : $translate.instant('RUNTAG.ORDER_N_PHOTOS', { count: total });
                // El producto del catálogo ya suele decir "1 FOTO" en su propio nombre (con HTML
                // dentro): repetirlo debajo sobra. Se compara sin etiquetas y sin mayúsculas.
                var nombreLimpio = String(productName || '').replace(/<[^>]*>/g, ' ').toLowerCase();
                if (nombreLimpio.indexOf(texto.toLowerCase()) !== -1) { return ''; }
                return texto;
            }
            var runners = (files && angular.isArray(files.runners)) ? files.runners : [];
            // items_total null en un runner del carrito = "todas las fotos" de ese dorsal.
            for (var i = 0; i < runners.length; i++) {
                if (runners[i] && runners[i].items_total === null) {
                    return $translate.instant('RUNTAG.ORDER_ALL_PHOTOS');
                }
            }
            return '';
        }

        function orderDetailPayment(order) {
            if (!order.id_payment_method) { return '—'; }
            for (var i = 0; i < vm.paymentMethods.length; i++) {
                if (vm.paymentMethods[i].id == order.id_payment_method) { return vm.paymentMethods[i].name; }
            }
            return '—';
        }

        // Referencia estable para cuando no hay que pintar filas: devolver un array nuevo en cada
        // digest metería a AngularJS en un bucle infinito.
        var SIN_ORDENES = [];

        /**
         * Filas a pintar. Va por función porque el ng-repeat de la tabla lleva ng-repeat-start (para
         * poder añadir las filas desplegadas debajo de cada compra) y ahí un ng-if solo afectaría a la
         * primera fila del grupo, no al grupo entero.
         */
        function visibleOrderRows() {
            if (vm.activeSalesTableMode !== 'orders' || vm.orderDetail.loading) { return SIN_ORDENES; }
            return vm.orderDetail.rows;
        }

        /**
         * Desplegar una compra para ver todas las de ese corredor EN ESTE EVENTO, de más reciente a
         * más antigua. Se piden al abrir (no antes) y se quedan cacheadas en la propia fila.
         */
        function toggleOrderRelated(order) {
            if (!order) { return; }
            order._expanded = !order._expanded;
            if (!order._expanded || order._related || order._relatedLoading) { return; }
            if (!order.user_id) { order._related = []; return; }

            order._relatedLoading = true;
            RuntagEventService.getOrders({
                siteID: $scope.siteID,
                filters: [
                    { field: 'user_id', name: 'User id', values: [order.user_id] },
                    { field: 'id_event', name: 'Event', values: [vm.selectedGroup.id_events] },
                    { field: 'id_subsec', name: 'Status', values: ORDER_DETAIL_STATUSES.all }
                ],
                resultsPerPage: 100,
                sortField: 'created_at',
                sortDir: 'desc'
            }).then(function (response) {
                var cuerpo = (response && response.result) ? response.result : response;
                var filas = (cuerpo && cuerpo.data) ? cuerpo.data : [];
                filas.forEach(function (o) {
                    decorateOrderDetailRow(o);
                    o._parentOrderId = order.id_orders;
                    // La propia compra desde la que se desplegó se marca, para no confundirla.
                    o._isCurrent = String(o.id_orders) === String(order.id_orders);
                });
                order._related = filas;
                order._relatedLoading = false;
            }).catch(function () {
                order._related = [];
                order._relatedLoading = false;
            });
        }

        /**
         * Ir a la ficha del corredor desde una compra. El listado solo trae su id, así que hay que
         * traerse el usuario completo: selectUser necesita sus user_params (dorsal, perfiles…).
         * Se reutiliza selectUserFromEventList, que es lo que hace la tabla de corredores.
         */
        function goToUserFromOrder(order) {
            if (!order || !order.user_id) { return; }
            vm.orderDetail.openingUser = order.id_orders;
            RuntagRunnerService.getUser($scope.siteID, order.user_id).then(function (res) {
                var usuario = (res && res.result) ? res.result : res;
                vm.orderDetail.openingUser = null;
                if (!usuario || !(usuario.id_user || usuario.id)) { return; }
                selectUserFromEventList(usuario);
            }).catch(function () {
                vm.orderDetail.openingUser = null;
                // Si no se pudo traer la ficha, al menos se deja el buscador de corredores preparado
                // con su email para que se pueda abrir a mano.
                vm.querySearch = order.user_email;
                filterUsers();
            });
        }

        /**
         * Editar una compra directamente desde el listado, sin entrar a la ficha del corredor.
         * Reutiliza EL MISMO diálogo que se abre desde sus compras (addTransactionsController), para no
         * duplicar la lógica de edición; la única diferencia es que al cerrar se recarga este listado en
         * vez de saltar a la ficha del usuario.
         */
        function editOrderFromList(ev, order) {
            if (!order || !order.id_orders) { return; }
            // El listado trae el nombre ya compuesto (columna user_name) y el diálogo lo pinta como
            // firstname + lastname. Al editar, el diálogo NO reescribe los campos de usuario de la orden
            // (solo estado, precio, producto y files), así que basta con esto.
            var usuario = {
                id_user: order.user_id,
                email: order.user_email,
                firstname: order.user_name || '',
                lastname: ''
            };

            if (!vm.cartEnabled) {
                openOrderDialog(ev, usuario, order, null);
                return;
            }

            // En eventos de carrito el diálogo ofrece asignar la compra a un perfil del corredor, y
            // vm.runnerProfiles solo está cargado si se entró a su ficha: hay que traer los suyos.
            vm.orderDetail.loadingProfilesFor = order.id_orders;
            fetchProfilesForUser(usuario).then(function (profiles) {
                vm.orderDetail.loadingProfilesFor = null;
                openOrderDialog(ev, usuario, order, profiles || []);
            }).catch(function () {
                vm.orderDetail.loadingProfilesFor = null;
                openOrderDialog(ev, usuario, order, []);
            });
        }

        function openOrderDialog(ev, usuario, order, profiles) {
            $mdDialog.show({
                controller: 'addTransactionsController',
                controllerAs: 'vm',
                locals: {
                    siteID: $scope.siteID,
                    user: usuario,
                    event: vm.selectedGroup,
                    client: vm.currentClient,
                    order: order,
                    paymentMethods: vm.paymentMethods,
                    cartEnabled: vm.cartEnabled,
                    profiles: profiles !== null ? profiles : vm.runnerProfiles,
                    ensureProfilePhotos: function (profile) { return loadRunnerProfilePhotos(profile); },
                    profileLabel: function (profile) { return runnerProfileLabel(profile); }
                },
                templateUrl: 'app/main/apps/runtag/event/dialogs/shopping/add-transaction.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                multiple: true,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            }).then(function () {
                // Al guardar, el diálogo pide cambiar a la vista de compras del usuario; como aquí no se
                // entra a su ficha, se descarta esa petición (si no, saltaría la próxima vez que se abra
                // un corredor) y se recarga el listado para ver la compra ya editada.
                delete ($rootScope.changeView);
                // Si la compra editada era una del desplegable, se vuelve a abrir el de su fila: al
                // recargar, las filas son objetos nuevos y el despliegue se perdería.
                var reabrir = order._parentOrderId || null;
                var recarga = loadOrderDetail(false);
                if (reabrir && recarga && recarga.then) {
                    recarga.then(function () {
                        var fila = (vm.orderDetail.rows || []).filter(function (r) {
                            return String(r.id_orders) === String(reabrir);
                        })[0];
                        if (fila) { toggleOrderRelated(fila); }
                    });
                }
            }, function () {
                // Cancelado (o cerrado pulsando fuera): no se recarga nada.
                delete ($rootScope.changeView);
            });
        }

        function orderDetailStatusLabel(order) {
            switch (parseInt(order && order.id_subsec, 10)) {
                case 2: return $translate.instant('RUNTAG.ORDER_STATUS_PAID');
                case 1: return $translate.instant('RUNTAG.ORDER_STATUS_GENERATED');
                case 5: return $translate.instant('RUNTAG.ORDER_STATUS_PENDING');
                case 3: return $translate.instant('RUNTAG.ORDER_STATUS_REJECTED');
                case 4: return $translate.instant('RUNTAG.ORDER_STATUS_CANCELLED');
                case 6: return $translate.instant('RUNTAG.ORDER_STATUS_BLOCKED');
                default: return '—';
            }
        }

        function orderDetailStatusClass(order) {
            switch (parseInt(order && order.id_subsec, 10)) {
                case 2: return 'paid';
                case 1:
                case 5: return 'pending';
                case 3:
                case 4: return 'failed';
                default: return 'other';
            }
        }

        // ---------- HELPER: Group by user and fetch contacts ----------
        function groupArchiveItemsAndFetchContacts(allItems) {
            // ---------- 1) Explode per userId ----------
            var exploded = [];
            allItems.forEach(function (item) {
                var userIds = (item && angular.isArray(item.userIds)) ? item.userIds : [];

                // Ensure distinct per item (avoid duplicates inside userIds)
                var uniqueUserIds = Array.from(new Set(userIds));

                uniqueUserIds.forEach(function (userId) {
                    // Skip empty-ish ids
                    if (userId === undefined || userId === null || userId === '') return;

                    exploded.push({
                        userId: String(userId), // normalize as string for consistent keys
                        item: item
                    });
                });
            });

            // ---------- 2) Group by userId ----------
            var byUserId = {}; // { [userId]: { userId, items: [] } }

            exploded.forEach(function (row) {
                if (!byUserId[row.userId]) {
                    byUserId[row.userId] = { userId: row.userId, items: [] };
                }
                byUserId[row.userId].items.push(row.item);
            });

            var grouped = Object.keys(byUserId).map(function (k) { return byUserId[k]; });

            // Optional: sort by number of requests desc
            grouped.sort(function (a, b) { return (b.items.length || 0) - (a.items.length || 0); });

            // ---------- 3) Fetch user contacts in one batch ----------
            // Collect unique userIds across all groups
            var allUserIds = Object.keys(byUserId); // already unique

            if (!allUserIds.length) {
                // Nothing to enrich
                return $q.resolve(grouped);
            }

            // Note: usersService.getUsers expects options.userIds and uses 'id_user[]'
            return usersService.getUsers({
                siteID: $scope.siteID,
                page: 1,
                paginate: false,
                userIds: allUserIds,
                withFilters: {},
                resultsPerPage: allUserIds.length
            }).then(function (usersResp) {
                // Depending on your API, users list may be in usersResp.result or usersResp.result.data
                var usersList = [];
                if (usersResp && usersResp.result) {
                    // Common patterns: array directly OR { data: [] }
                    if (angular.isArray(usersResp.result)) usersList = usersResp.result;
                    else if (usersResp.result.data && angular.isArray(usersResp.result.data)) usersList = usersResp.result.data;
                }
                // Index users by id for O(1) lookup
                // Adjust key field if your API uses a different one (id_user, id, userId, etc.)
                var usersById = {};
                usersList.forEach(function (u) {
                    var id = (u && (u.id_user || u.id || u.userId)) ? String(u.id_user || u.id || u.userId) : null;
                    if (id) usersById[id] = u;
                });

                grouped.forEach(function (g) {
                    // Attach contact info to each grouped record
                    g.contact = usersById[String(g.userId)] || null;

                    var byStatus = {};

                    g.items.forEach(function (item) {
                        var status = item.status || 'UNKNOWN';

                        if (!byStatus[status]) {
                            byStatus[status] = [];
                        }
                        byStatus[status].push(item);
                    });

                    // attach grouped structure
                    g.itemsByStatus = byStatus;
                });

                return grouped;
            });
        }

        function getAllRestoreFiles() {
            return RuntagEventService.getAllRestoreFiles().then(function (resp) {

                // ---------- 1) Safe reads ----------
                var v2Items = (resp && resp.v2 && resp.v2.processRequests && angular.isArray(resp.v2.processRequests) && resp.v2.processRequests.length)
                    ? resp.v2.processRequests
                    : [];

                var v3Items = (resp && resp.v3 && resp.v3.data && angular.isArray(resp.v3.data) && resp.v3.data.length)
                    ? resp.v3.data
                    : [];

                // ---------- 2) Merge ----------
                v2Items = v2Items.map(function (it) { return angular.extend({}, it, { __source: 'v2' }); });
                v3Items = v3Items.map(function (it) { return angular.extend({}, it, { __source: 'v3' }); });

                var allItems = [].concat(v2Items, v3Items);

                return groupArchiveItemsAndFetchContacts(allItems);



            }).then(function (groupedEnriched) {
                // Safety check: don't overwrite if an event was selected in the meantime
                if (vm.selectedGroup) {
                    $log.warn('getAllRestoreFiles finished but an event is already selected. Ignoring global results.');
                    return;
                }
                vm.archiveItems = groupedEnriched;
                $log.warn('vm.archiveItems (global)', vm.archiveItems);
            });
        }

        function reprocessPhotos(status) {
            if (!status) return;
            vm.openReprocessModal(status);
        }

        vm.openReprocessModal = function (status) {
            $mdDialog.show({
                controller: 'reprocessModalController',
                controllerAs: 'vm',
                locals: {
                    status: status
                },
                templateUrl: 'app/main/apps/runtag/event/dialogs/reprocess/reprocess-modal.html',
                parent: angular.element($document.body),
                clickOutsideToClose: true,
                multiple: true,
                onShowing: function (scope, element) {
                    element.addClass('reprocess-modal');
                },
                fullscreen: true
            }).then(function (result) {
                if (result) {
                    RuntagEventService.reprocessRequests(
                        {
                            apiUrl: vm.apiUrl,
                            reprocessType: status
                        }
                    ).then(resp => {
                        $mdToast.show({
                            template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-600-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex translate="RUNTAG.REPROCESS_STARTED">Las fotos han comenzado a reprocesarse</span></div></md-toast>',
                            hideDelay: 5000,
                            position: 'top',
                            parent: '#content-container'
                        });
                        $log.warn('resp', resp);
                    })
                }
            }, function () {
                $log.warn('Modal cancelado');
            });
        }

        vm.sortByRequestedAtDesc = function (it) {
            // Return negative to sort desc using orderBy:'fn':true (reverse)
            // In AngularJS orderBy accepts a function; we'll just return date value.
            return new Date(it.requestedAt || it.createdAt || 0).getTime();
        };

        function onArchiveRestoreClick(ev, mediaItem) {
            // Stop parent click handlers (e.g. open detail)
            if (ev && ev.stopPropagation) ev.stopPropagation();

            // Only allow restoring when item is actually archived
            if (!mediaItem || mediaItem.archiveStatus !== "ARCHIVED") return;

            // Basic validation
            if (!mediaItem.mediaId || !mediaItem.createdAt) {
                $log.error('Invalid mediaItem', mediaItem);
                showToast('RUNTAG.RESTORE_INVALID_ITEM', 'error');
                return;
            }

            // createdAt can be "2026-01-15T23:49:38.479Z_xxx"
            const isoDate = mediaItem.createdAt.split('_')[0];
            const timestamp = new Date(isoDate).getTime();

            if (isNaN(timestamp)) {
                $log.error('Invalid createdAt date', mediaItem.createdAt);
                showToast('RUNTAG.RESTORE_INVALID_DATE', 'error');
                return;
            }

            // mediaId must include extension
            const lastDot = mediaItem.mediaId.lastIndexOf('.');
            if (lastDot === -1) {
                $log.error('Invalid mediaId (no extension)', mediaItem.mediaId);
                showToast('RUNTAG.RESTORE_INVALID_MEDIAID', 'error');
                return;
            }

            // Keep previous status so we can rollback on error
            const previousStatus = mediaItem.archiveStatus;

            // Switch UI to loading state
            mediaItem.archiveStatus = "LOADING";

            const name = mediaItem.mediaId.substring(0, lastDot);
            const ext = mediaItem.mediaId.substring(lastDot + 1);

            const user = sessionService.user;
            const options = {
                apiUrl: vm.apiUrl,
                media_file: `${name}_${timestamp}.${ext}`,
                user_id: user.id_user,
                created_at: mediaItem.createdAt,
                template_id: vm.currentClient.id_template,
                client_id: vm.currentClient.id_clients,
                event_id: vm.selectedGroup.id_events,
                event_name: vm.selectedGroup.event_name
            };
            return RuntagEventService.callToArchive(options)
                .then(function (resp) {
                    // Success path: set to PENDING and notify
                    mediaItem.archiveStatus = "PENDING";

                    // If you have translate keys, use them; otherwise replace with a literal
                    showToast('RUNTAG.RESTORE_REQUESTED_OK', 'success');

                    return resp;
                })
                .catch(function (err) {
                    // Rollback UI state on error
                    mediaItem.archiveStatus = previousStatus;

                    // Try to extract the most useful error information
                    const status = (err && (err.status || err.statusCode)) || null;
                    const code =
                        (err && err.data && (err.data.code || err.data.errorCode)) ||
                        (err && err.code) ||
                        null;

                    $log.error('Restore from archive failed', err);

                    // Pick message by status/code (adjust mapping to your API)
                    if (status === 409 || code === 'ALREADY_REQUESTED') {
                        // Conflict: request already exists / already pending
                        showToast('RUNTAG.RESTORE_ALREADY_PENDING', 'warn');
                    } else if (status === 404 || code === 'NOT_FOUND') {
                        showToast('RUNTAG.RESTORE_NOT_FOUND', 'error');
                    } else if (status === 401 || status === 403) {
                        showToast('RUNTAG.RESTORE_NOT_AUTHORIZED', 'error');
                    } else {
                        showToast('RUNTAG.RESTORE_GENERIC_ERROR', 'error');
                    }

                    // Re-throw if callers upstream rely on rejection
                    return $q.reject(err);
                });

            // -------------------------
            // Helpers
            // -------------------------
            function showToast(messageKeyOrText, level) {
                const text = $translate ? $translate.instant(messageKeyOrText) : messageKeyOrText;

                $mdToast.show(
                    $mdToast.simple()
                        .textContent(text)
                        .position('top center')
                        .toastClass('toast-' + (level || 'info'))
                        .hideDelay(5000)
                );
            }
        }

        function getEventArchiveItems(loadMore) {
            if (!loadMore) {
                vm.archiveItems = [];
                vm.rawArchiveItems = [];
                vm.archivePagingKey = null;
            }

            vm.isLoadingArchiveItems = true;

            RuntagEventService.getArchiveFiles({
                apiUrl: vm.apiUrl,
                pagingKey: vm.archivePagingKey
            }).then(function (resp) {
                var newItems = [];
                if (resp && angular.isArray(resp.processRequests) && resp.processRequests.length) {
                    newItems = newItems.concat(resp.processRequests);
                }
                if (resp && angular.isArray(resp.data) && resp.data.length) {
                    newItems = newItems.concat(resp.data);
                }

                vm.rawArchiveItems = vm.rawArchiveItems.concat(newItems);
                vm.archivePagingKey = resp && resp.pagingKey ? String(resp.pagingKey) : null;

                return groupArchiveItemsAndFetchContacts(vm.rawArchiveItems);
            }).then(function (groupedEnriched) {
                vm.archiveItems = groupedEnriched;
            }).catch(function (e) {
                $log.error('Error loading archive items', e);
            }).finally(function () {
                vm.isLoadingArchiveItems = false;
            });
        }

        function deselectGroup() {
            $location.hash(null);
            vm.selectedGroup = undefined;

            // If admin, restore global archive items view
            if (vm.isAdmin) {
                getAllRestoreFiles();
            }

            if (vm.eventsGroup) {
                vm.eventsGroup.forEach(ev => {
                    if (!ev.totalPhotos) {
                        setTotalPhotos(ev);
                    }
                });
            }
        }

        function openSettings(ev) {
            const eventNumbers = (vm.selectedUser?.user_params?.events_data || [])
                .filter(x => x.event_group_id === vm.selectedGroup.id_user_group);
            $mdDialog.show({
                controller: 'EventNumbersDialogController',
                controllerAs: 'dlg',
                bindToController: true,
                templateUrl: 'app/main/apps/runtag/event/dialogs/event-numbers/event-numbers-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                escapeToClose: true,
                locals: {
                    eventNumbers,
                    userId: vm.selectedUser.id,
                    groupId: vm.selectedGroup.id_user_group
                },
                onShowing: function (scope, element) {
                    element.addClass('event-numbers-dialog-wrapper');
                }
            }).then(function (updatedList) {
                if (!updatedList) return; //dialog closed without payload

                var groupId = vm.selectedGroup.id_user_group;

                //current list for this group (from user_params)
                var currentRaw = (vm.selectedUser?.user_params?.events_data || [])
                    .filter(x => x.event_group_id === groupId);

                //normalize current and next for equality check
                var currentNorm = normalizeEventList(currentRaw);
                var nextNorm = normalizeEventList(updatedList);

                //if nothing changed, bail out
                if (sameEventList(currentNorm, nextNorm)) return;

                //ensure structures exist
                vm.selectedUser.user_params = vm.selectedUser.user_params || {};
                vm.selectedUser.user_params.events_data = vm.selectedUser.user_params.events_data || [];

                //drop every record for this group
                vm.selectedUser.user_params.events_data = vm.selectedUser.user_params.events_data
                    .filter(x => x.event_group_id !== groupId);

                //push the new list for this group
                Array.prototype.push.apply(
                    vm.selectedUser.user_params.events_data,
                    nextNorm.map(i => ({
                        event_group_id: groupId,
                        number: i.number,
                        label: i.label
                    }))
                );
                vm.userCopy = angular.copy(vm.selectedUser);
                //persist user changes
                saveUser();
            }).catch(function () { /* ignored */ });
        }

        function normalizeEventList(list) {
            return (list || [])
                .filter(i => !i._delete) // ignore items flagged for deletion from dialog
                .map(i => ({
                    // English: compare only the meaningful fields; trim and coerce
                    number: String(i.number || '').trim().toUpperCase(),
                    label: String(i.label || '').trim(),
                }))
                .sort((a, b) => a.number.localeCompare(b.number) || a.label.localeCompare(b.label));
        }

        function sameEventList(a, b) {
            if (a.length !== b.length) return false;
            for (var i = 0; i < a.length; i++) {
                if (a[i].number !== b[i].number || a[i].label !== b[i].label) return false;
            }
            return true;
        }

        function deleteChip(chip, mediaItem) {
            switch (chip.type) {
                case 'unmatchedNumber':
                    removeUnmatchedNumber(chip, mediaItem);
                    break;
                default:
                    itsNotMe(chip, mediaItem);
                    break;
            }
        }

        function removeUnmatchedNumber(tag, mediaItem) {
            var options = {
                apiUrl: vm.apiUrl,
                mediaFile: mediaItem.mediaId,
                createdAt: mediaItem.createdAt
            }
            if (tag) {
                options.invalidNumber = tag.detectedText;
            } else {
                options.invalidNumber = vm.tagToEdit.detectedText;
            }
            RuntagEventService.removeUnmatchedNumber(options).then(function (response) {
                switch (vm.eventVersion) {
                    case 'v2':
                        if (response.Item) {
                            var item = constructImage(response.Item);
                        } else {
                            var item = constructImage(response);
                        }
                        break;
                    case 'v3':
                        var item = constructImage(response);
                        break;
                    default:
                        var item = constructImage(response.Item);
                        break;
                }
                vm.selectedUser.newMedia[vm.selectedUser.newMedia.findIndex(x => x.mediaId == item.mediaId)] = item;
                mediaItem = item;
                vm.selectedMedias = [];
            });
        }

        function itsNotMe(tag, mediaItem) {
            var options = {
                apiUrl: vm.apiUrl
            }
            switch (vm.eventVersion) {
                case 'v2':
                    options.version = vm.eventVersion;
                    options.mediaFile = mediaItem.mediaId;
                    options.createdAt = mediaItem.createdAt;
                    if (vm.tagToEdit) {
                        options.faceId = vm.tagToEdit.face.faceId;
                    }
                    if (tag && tag.faceId) {
                        options.faceId = tag.faceId;
                    }
                    if (tag && tag.runnerNumber) {
                        options.runnerNumber = tag.runnerNumber.detectedText;
                    }
                    break;
                case 'v3':
                    options.version = vm.eventVersion;
                    options.mediaFile = mediaItem.mediaId;
                    options.createdAt = mediaItem.createdAt;
                    if (vm.tagToEdit) {
                        options.faceId = vm.tagToEdit.face.faceId;
                    }
                    if (tag && tag.face && tag.face.faceId) {
                        options.faceId = tag.face.faceId;
                    }
                    if (tag && tag.runnerNumber) {
                        options.runnerNumber = tag.runnerNumber.detectedText;
                    }
                    break;
                default:
                    options.media_file = mediaItem.media_id;
                    options.created_at = mediaItem.created_at;
                    if (vm.tagToEdit) {
                        options.face_id = vm.tagToEdit.face_id;
                    }
                    if (tag && tag.face_id) {
                        options.face_id = tag.face_id;
                    }
                    if (tag && tag.runner_number) {
                        options.runner_number = tag.runner_number;
                    }
                    break;
            }
            RuntagEventService.notMePablo(options).then(function (response) {
                switch (vm.eventVersion) {
                    case 'v2':
                        if (response.Item) {
                            var image = constructImage(response.Item);
                        } else {
                            var image = constructImage(response);
                        }
                        var itemIndex = vm.selectedUser.newMedia.findIndex(x => x.mediaId === image.mediaId);
                        break;
                    case 'v3':
                        var image = constructImage(response);
                        var itemIndex = vm.selectedUser.newMedia.findIndex(x => x.mediaId === image.mediaId);
                        break;
                    default:
                        var image = constructImage(response.Item);
                        var itemIndex = vm.selectedUser.newMedia.findIndex(x => x.media_id === image.media_id);
                        break;
                }
                mediaItem = image;
                vm.selectedUser.newMedia[itemIndex] = image;
                if (vm.selectedUser) {
                    var index = vm.selectedUser.newMedia.indexOf(image);
                    if (index) {
                        vm.selectedUser.newMedia.splice(index);
                    }
                    vm.selectedMedias = [];
                }
            })
        }

        function selectMediaItem(media) {
            if (vm.selectedMedias.indexOf(media) != -1) {
                vm.selectedMedias.splice(vm.selectedMedias.indexOf(media), 1);
            } else {
                vm.selectedMedias.push(media);
            }
        }

        function deleteSelectedMedias() {
            let userNumber = vm.selectedUser.user_params.events_data.find(x => x.event_group_id === vm.selectedGroup.id_user_group).number;
            vm.selectedMedias.forEach(media => {
                let tag = media.tags.find(x => {
                    if (x.detectedText && x.detectedText === userNumber) {
                        return x;
                    }
                    if (x.runnerNumber && x.runnerNumber.detectedText === userNumber) {
                        return x;
                    }
                });
                deleteChip(tag, media);
            });
        }

        function initAssignBulk() {
            vm.addUserBulk = !vm.addUserBulk;
        }

        function closeAssignBulk() {
            vm.userSearchString = "";
            vm.usersToAdd = [];
            vm.addUserBulk = false;
        }

        function returnToSearch() {
            vm.userSearchString = "";
            vm.usersToAdd = [];
        }

        function searchAssignUser() {
            var options = {
                siteID: $scope.siteID,
                groupIds: vm.selectedGroup.id_user_group,
                searchStringFilter: vm.userSearchString
            };
            usersService.getUsersByGroups(options).then(function (response) {
                if (response.result.total > 0) {
                    response.result.data = response.result.data.filter(function (user) {
                        if (user.user_params) {
                            ensureParsed(user, 'user_params');
                            let event_data = user.user_params?.events_data?.find(x => x.event_group_id == vm.selectedGroup.id_user_group);
                            if (event_data) {
                                user.eventNumber = event_data.number;
                                return true;
                            } else {
                                return false;
                            }
                        } else {
                            user.eventNumber = user.current_number;
                            return true;
                        }
                    });
                    if (response.result.data.length === 0) {
                        $mdToast.show({
                            template: '<md-toast layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-close" class="icon"></md-icon><span class="md-toast-text" flex>No results for ' + vm.userSearchString + '</span></div></md-toast>',
                            hideDelay: 5000,
                            position: 'top',
                            parent: '#content-container'
                        });
                        vm.userSearchString = "";
                    } else {
                        vm.usersToAdd = response.result.data;
                        vm.checkUserOrders(vm.usersToAdd);
                        vm.userSearchString = "";
                    }
                } else {
                    $mdToast.show({
                        template: '<md-toast layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-close" class="icon"></md-icon><span class="md-toast-text" flex>No results for ' + vm.userSearchString + '</span></div></md-toast>',
                        hideDelay: 5000,
                        position: 'top',
                        parent: '#content-container'
                    });
                }
            });
        }

        /**
         * Dorsal sintético 'SD' (Sin Dorsal) para el corredor que no tiene bib legible: 'SD' + últimos 6
         * dígitos del timestamp en ms + 4 aleatorios. MISMO formato en otros dos sitios, que hay que tocar
         * en bloque si cambia: `$scope.generateUniqueDorsal()` en el front del corredor
         * (qiupreview-assets/.../customController.js) y `CustomData::generateSyntheticDorsal()` en qiupreview.
         */
        function generateSyntheticDorsal() {
            var timestampPart = String(Date.now()).slice(-6);
            var randomPart = String(Math.floor(Math.random() * 10000));
            while (randomPart.length < 4) { randomPart = '0' + randomPart; }
            return 'SD' + timestampPart + randomPart;
        }

        /** Refleja en memoria el dorsal recién escrito, para que un saveUser() posterior no lo pise. */
        function syncLocalEventNumber(userId, dorsal, extraTargets) {
            var groupId = vm.selectedGroup.id_user_group;
            [].concat(extraTargets || [], [vm.selectedUser, vm.userCopy]).forEach(function (target) {
                if (!target || String(target.id_user || target.id) !== String(userId)) { return; }
                target.eventNumber = dorsal;
                ensureParsed(target, 'user_params');
                var params = target.user_params;
                if (!angular.isObject(params) || !angular.isArray(params.events_data)) { return; }
                var entry = params.events_data.filter(function (e) {
                    return e && String(e.event_group_id) === String(groupId);
                })[0];
                if (entry) { entry.number = dorsal; }
            });
        }

        /**
         * Pregunta y, si el admin acepta, crea el dorsal SD del corredor en ESTE evento
         * (user_params.events_data[grupo].number) y lo devuelve. Resuelve a null si se cancela o falla.
         * Se relee el usuario antes de escribir (patrón de assignPhotoToProfile) para no pisar cambios
         * ajenos, y si entretanto ya tiene dorsal se respeta el que hubiera.
         */
        function askAndCreateSyntheticDorsal(user) {
            var userId = user.id_user || user.id;
            var groupId = vm.selectedGroup.id_user_group;
            var confirm = $mdDialog.confirm()
                .title($translate.instant('RUNTAG.BULK_ASSIGN_NO_DORSAL_TITLE'))
                .textContent($translate.instant('RUNTAG.BULK_ASSIGN_NO_DORSAL_TEXT'))
                .ariaLabel('SD')
                .ok($translate.instant('RUNTAG.BULK_ASSIGN_CREATE_SD'))
                .cancel($translate.instant('RUNTAG.BULK_ASSIGN_SD_CANCEL'));

            return $mdDialog.show(confirm).then(function () {
                return RuntagRunnerService.getUser($scope.siteID, userId).then(function (res) {
                    var u = (res && res.result) || res || {};
                    var params = u.user_params;
                    if (angular.isString(params)) { try { params = JSON.parse(params); } catch (e) { params = {}; } }
                    if (!angular.isObject(params)) { params = {}; }
                    if (!angular.isArray(params.events_data)) { params.events_data = []; }
                    var entry = params.events_data.filter(function (e) {
                        return e && String(e.event_group_id) === String(groupId);
                    })[0];
                    if (!entry) { entry = { event_group_id: groupId }; params.events_data.push(entry); }

                    if (entry.number && String(entry.number).trim() !== '') {
                        // Ya tenía dorsal (lo puso otra pestaña/otro admin): no se sobreescribe.
                        syncLocalEventNumber(userId, String(entry.number), [user]);
                        return String(entry.number);
                    }

                    var dorsal = generateSyntheticDorsal();
                    entry.number = dorsal;
                    return RuntagRunnerService.updateUserParams($scope.siteID, userId, params).then(function () {
                        syncLocalEventNumber(userId, dorsal, [user]);
                        $mdToast.show({
                            template: '<md-toast layout="column" layout-align="center center"><div class="md-toast-content green-600-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' +
                                $translate.instant('RUNTAG.BULK_ASSIGN_SD_CREATED', { dorsal: dorsal }) + '</span></div></md-toast>',
                            hideDelay: 4000, position: 'top', parent: '#content-container'
                        });
                        return dorsal;
                    });
                }).catch(function (error) {
                    $log.error('[userBulk] no se pudo crear el dorsal SD', error);
                    $mdToast.show({
                        template: '<md-toast layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-close" class="icon"></md-icon><span class="md-toast-text" flex>' +
                            $translate.instant('RUNTAG.BULK_ASSIGN_SD_FAILED') + '</span></div></md-toast>',
                        hideDelay: 5000, position: 'top', parent: '#content-container'
                    });
                    return null;
                });
            }, function () {
                return null; // cancelado
            });
        }

        function userBulk(user) {
            // Close modal immediately to unblock UI
            closeAssignBulk();

            if (!user) { return; }

            // Las fotos se asignan a un PERFIL, y el dorsal propio es solo uno de ellos: en eventos de
            // carrito el corredor suele tener perfiles recolectados o comprados (el suyo real incluido),
            // y es ahí donde tienen que ir. Antes solo se miraba el dorsal propio, así que a quien no lo
            // tenía se le ofrecía crear un SD aunque ya tuviera perfiles con todas sus fotos.
            vm.isBulkAssigning = true; // el fetch de perfiles tarda: que se vea que algo pasa
            fetchProfilesForUser(user).then(function (profiles) {
                vm.isBulkAssigning = false;
                // Un perfil "face:<id>" no sirve como destino: el endpoint escribe un runnerNumber.
                var targets = (profiles || []).filter(function (p) {
                    return p && p.dorsal && String(p.dorsal).indexOf('face:') !== 0;
                });

                if (targets.length === 1) { sendUserBulk(user, targets[0].dorsal); return; }
                if (targets.length > 1) { askProfileForBulk(user, targets); return; }

                // Sin ningún perfil ni dorsal: el endpoint del reconocimiento (face/runner_number_bulk)
                // escribe el dorsal en cada foto, así que un runnerNumber vacío se serializa como clave
                // AUSENTE y la lambda rechaza el lote entero con ValidationException (pasó en Adidas
                // Terrex: 53 registros, 53 excepciones). En eventos con allow_no_dorsal hay usuarios
                // legítimamente sin dorsal: en la web se resuelve creándoles un SD, y aquí lo mismo.
                askAndCreateSyntheticDorsal(user).then(function (dorsal) {
                    if (!dorsal) { return; }
                    sendUserBulk(user, dorsal);
                });
            }).catch(function () {
                vm.isBulkAssigning = false;
                // Si no se pueden leer los perfiles, se cae al comportamiento anterior (dorsal propio).
                if (user.eventNumber) { sendUserBulk(user, user.eventNumber); return; }
                askAndCreateSyntheticDorsal(user).then(function (dorsal) {
                    if (!dorsal) { return; }
                    sendUserBulk(user, dorsal);
                });
            });
        }

        /**
         * Elegir a cuál de sus perfiles van las fotos cuando el corredor tiene más de uno. Diálogo propio en
         * vez de $mdDialog.confirm con htmlContent: ngSanitize elimina <input>/<label>, así que unos radios
         * ahí dentro no llegarían a pintarse. Cada fila elige directamente.
         */
        function askProfileForBulk(user, targets) {
            $mdDialog.show({
                locals: { targets: targets },
                controller: ['$scope', '$mdDialog', 'targets', function ($scope, $mdDialog, targets) {
                    $scope.targets = targets;
                    $scope.pick = function (t) { $mdDialog.hide(t); };
                    $scope.cancel = function () { $mdDialog.cancel(); };
                }],
                template:
                    '<md-dialog class="bulk-profile-dialog" aria-label="perfil">' +
                    '  <md-dialog-content>' +
                    '    <h2 class="md-title">{{ "RUNTAG.BULK_ASSIGN_PICK_PROFILE_TITLE" | translate }}</h2>' +
                    '    <p>{{ "RUNTAG.BULK_ASSIGN_PICK_PROFILE_TEXT" | translate }}</p>' +
                    '    <div class="bulk-profile-item" ng-repeat="t in targets" ng-click="pick(t)">' +
                    '      <strong>{{ t.name || (("RUNTAG.BULK_ASSIGN_PROFILE" | translate) + " " + t.dorsal) }}</strong>' +
                    '      <span ng-if="t.name"> · {{ t.dorsal }}</span>' +
                    '      <span ng-if="t.is_primary" class="bulk-profile-own"> · {{ "RUNTAG.BULK_ASSIGN_OWN" | translate }}</span>' +
                    '    </div>' +
                    '  </md-dialog-content>' +
                    '  <md-dialog-actions>' +
                    '    <md-button ng-click="cancel()">{{ "RUNTAG.BULK_ASSIGN_SD_CANCEL" | translate }}</md-button>' +
                    '  </md-dialog-actions>' +
                    '</md-dialog>',
                parent: angular.element($document.body),
                clickOutsideToClose: true
            }).then(function (t) {
                sendUserBulk(user, t && t.dorsal);
            }, function () { /* cancelado */ });
        }

        function sendUserBulk(user, runnerNumber) {
            // Cinturón: sin dorsal el lote entero lo rechaza la lambda (ValidationException por registro).
            // Ningún camino debería llegar aquí sin él, pero es barato asegurarlo.
            if (!runnerNumber || String(runnerNumber).trim() === '') {
                vm.isBulkAssigning = false;
                $mdToast.show({
                    template: '<md-toast layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-close" class="icon"></md-icon><span class="md-toast-text" flex>' +
                        $translate.instant('RUNTAG.BULK_ASSIGN_NEEDS_DORSAL') + '</span></div></md-toast>',
                    hideDelay: 5000, position: 'top', parent: '#content-container'
                });
                return;
            }

            // Show a non-blocking overlay (bottom-right) while request runs
            vm.isBulkAssigning = true;

            // Optional: show progress if you want (x/y)
            vm.bulkAssignTotal = (vm.selectedMedias && vm.selectedMedias.length) || 0;
            vm.bulkAssignDone = 0;

            let payload = [];
            vm.selectedMedias.forEach(item => {
                payload.push({
                    mediaFile: item.mediaId,
                    createdAt: item.createdAt,
                    editedBy: 'admin',
                    runnerNumber: runnerNumber
                });
            });

            RuntagEventService.addUserBulk({
                apiUrl: vm.apiUrl,
                medias: payload
            })
                .then(function (response) {
                    if (response.succeeded && response.succeeded.length > 0) {
                        selectUser(vm.selectedUser);
                        changeTemplate(vm.cartEnabled ? 'profiles' : 'media');
                    }

                    if (response.alreadyProcessed && response.alreadyProcessed.length > 0) {
                        let message = "";
                        response.alreadyProcessed.forEach(u => {
                            message += ` The user ${u.number} already exists at ${u.mediaFile}.`;
                        });
                        $mdToast.show({
                            template: '<md-toast layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-close" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                            hideDelay: 5000,
                            position: 'top',
                            parent: '#content-container'
                        });
                    }

                    if (response.failed && response.failed.length > 0) {
                        let message = "";
                        response.failed.forEach(u => {
                            message += ` ${u.message} for ${u.number}.`;
                        });
                        $mdToast.show({
                            template: '<md-toast layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-close" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                            hideDelay: 5000,
                            position: 'top',
                            parent: '#content-container'
                        });
                    }
                })
                .catch(function (error) {
                    // Handle unexpected errors
                    $mdToast.show({
                        template: '<md-toast layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-close" class="icon"></md-icon><span class="md-toast-text" flex>Bulk assign failed. Please try again.</span></div></md-toast>',
                        hideDelay: 5000,
                        position: 'top',
                        parent: '#content-container'
                    });
                    console.error('Bulk assign error', error);
                })
                .finally(function () {
                    // Always hide overlay
                    vm.isBulkAssigning = false;
                });
        }

        function getClients() {
            RuntagService.getSection({
                domain: $scope.siteID,
                section: 'clients',
                filters: [
                    {
                        field: 'onoff',
                        values: [1]
                    }
                ],
                resultsPerPage: 900
            }).then(response => {
                vm.clients = response.data;
            });
        }

        // Clave sintética de la fila "Manual": no es un producto real, así que no tiene id_product con el
        // que cruzar el desglose USD. Se le asigna esta clave para que la plantilla siga usando el mismo
        // findTotalUSDproduct(product.id) sin cambios.
        var MANUAL_USD_KEY = '__manual__';

        function findTotalUSDproduct(id) {
            if (id === MANUAL_USD_KEY) {
                return vm.totalManualUSD || 0;
            }
            var ret = 0;
            let product = (vm.totalOrdersUSDbyProduct || []).find(x => x.id_product === id);
            if (product) {
                ret = parseFloat(product.sum) || 0;
            }
            // Los pagos manuales de ESTE producto se muestran en la fila "Manual" → se restan aquí para no
            // contarlos dos veces en la columna USD.
            var manual = (vm.manualUSDbyProduct || {})[String(id)];
            if (manual) {
                ret -= manual;
            }
            return ret;
        }

        function scrollTo(el) {
            var element = document.getElementById(el);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }

        function sumFields(array, field) {
            let sum = 0;
            if (array) {
                array.forEach(x => {
                    if (x[field]) {
                        sum = sum + x[field];
                    }
                });
            }
            return sum;
        }

        function getAvailableDividerPhotographers() {
            const availablePhotographers = vm.selectedGroup.photographers.filter(x => x.photos > 0);
            return availablePhotographers.length;
        }

        function filterEvents() {
            if (!vm.searchText) {
                vm.filteredEvents = vm.eventsGroup;
            } else {
                vm.filteredEvents = vm.eventsGroup.filter(function (event) {
                    return event.event_name.toLowerCase().includes(vm.searchText.toLowerCase());
                });
            }
        }

        function cancel() {
            $mdDialog.hide();
        }

        function instantTranslate(text) {
            return $translate.instant(text);
        }

        function openPrebuyPanel() {
            vm.loadingPrebuys = true;
            vm.paymentMethods.forEach(method => {
                if (method.id == 9) {
                    vm.prebuyProducts = method.products;
                }
            })
            if (!vm.prebuyProducts || !vm.prebuyProducts.length) {
                closePrebuyPanel();
                $mdToast.show({
                    template: '<md-toast layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-close" class="icon"></md-icon><span class="md-toast-text" flex>This event has not products for prebuy</span></div></md-toast>',
                    hideDelay: 5000,
                    position: 'top',
                    parent: '#content-container'
                });
                return;
            } else if (vm.prebuyProducts.length == 1) {
                vm.prebuySelectedProduct = vm.prebuyProducts[0];
            }
            vm.addPrebuys = true;
            vm.loadingPrebuys = false;
        }

        function createPrebuys() {
            vm.creatingOrders = true;
            var mailErrors = [];
            let jsonProduct = angular.fromJson(vm.prebuySelectedProduct);
            var emailsPrebuy = vm.prebuyEmails.concat(vm.excelPrebuyEmails);

            const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

            const processEmail = async (email, index) => {
                var newTransaction = {
                    created_at: moment().format('YYYY-MM-DD HH:mm:00'),
                    id_subsec: 2,
                    id_event: vm.selectedGroup.id,
                    id_payment_method: 9,
                    user_id: "",
                    id_product: jsonProduct.id,
                    price: jsonProduct.price,
                    tags: [],
                    user_email: "",
                    user_name: "",
                    currency_code: jsonProduct.currency_code,
                    id_client: vm.selectedGroup.id_client,
                    id_commercial: vm.selectedGroup.id_commercial,
                    id_organizer: vm.selectedGroup.id_organizer,
                    items_total: jsonProduct.items_total
                };

                var options = {
                    siteID: $scope.siteID,
                    groupIds: vm.selectedGroup.id_user_group,
                    section: $scope.section,
                    searchStringFilter: email
                };

                try {
                    let response = await usersService.getUsersByGroups(options);
                    if (response.result.data.length === 1) {
                        var user = response.result.data[0];
                        newTransaction.user_id = user.id_user;
                        newTransaction.user_email = user.email;
                        newTransaction.user_name = user.firstname + " " + user.lastname;

                        var optionsOrder = {
                            siteID: $scope.siteID,
                            item: newTransaction
                        };

                        await RuntagEventService.createOrder(optionsOrder);
                    } else {
                        mailErrors.push(email);
                    }
                } catch (err) {
                    mailErrors.push(email);
                    $log.error('Error processing email', email, err);
                }

                // Mostrar notificación al final
                if (index === emailsPrebuy.length - 1) {
                    closePrebuyPanel();
                    if (mailErrors.length > 0) {
                        var mails = mailErrors.join(', ');
                        var message = 'There are some error with these email/s: ' + mails;
                        $mdToast.show({
                            template: `
                            <md-toast layout="column" layout-align="center center">
                                <div class="md-toast-content red-500-bg">
                                    <md-icon md-font-icon="icon-close" class="icon"></md-icon>
                                    <span class="md-toast-text" flex>${message}</span>
                                </div>
                            </md-toast>
                            `,
                            hideDelay: 5000,
                            position: 'top',
                            parent: '#content-container'
                        });
                        $log.warn('mailErrors', mailErrors);
                    }
                }
            };

            // Ejecutar en serie con delay
            (async function runSerial() {
                for (let i = 0; i < emailsPrebuy.length; i++) {
                    await processEmail(emailsPrebuy[i], i);
                    //await delay(500); // espera de 500 ms entre emails
                }
            })();
        }

        function closePrebuyPanel() {
            vm.creatingOrders = false;
            vm.prebuySelectedProduct = undefined;
            vm.prebuyProducts = [];
            vm.prebuyEmails = [];
            vm.excelPrebuyEmails = [];
            vm.addPrebuys = false;
        }

        /**
         * Multiple comma separated chips to add
         */
        function addChips(chips, model) {
            if (chips && chips.indexOf(';')) {
                var chipsArray = chips.split(';');
            } else {
                var chipsArray = chips.split(',');
            }
            angular.forEach(chipsArray, function (chip) {
                model.push(chip);
            });
            return null;
        }

        /**
         * Validate emails in Chips
         */
        function validateEmail(emails) {
            let emailsArray = emails[0].split(',');
            for (var i = 0; i < emailsArray.length; i++) {
                emailsArray[i] = emailsArray[i].toLowerCase();
                var reg = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
                if (!reg.test(emailsArray[i])) {
                    this.invalidEmail = true;
                    // remove last invalid email address :)
                    emailsArray.splice(i, 1);
                }
                else {
                    this.invalidEmail = false;
                }
            }
        }

        $scope.handleFile = function () {
            var file = document.getElementById('prebuy-file-input').files[0];
            processPrebuyEmails(file);
        }

        function processPrebuyEmails(file) {
            $scope.$apply(function () {
                vm.loadingExcel = true;
            });
            const reader = new FileReader();
            reader.onload = function (e) {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const sheetName = workbook.SheetNames[0];
                const sheet = workbook.Sheets[sheetName];
                const jsonData = XLSX.utils.sheet_to_json(sheet);
                const columnEmail = jsonData.map(row => row.email);
                $scope.$apply(function () {
                    vm.excelPrebuyEmails = columnEmail;
                    vm.loadingExcel = false;
                });
            };
            reader.readAsArrayBuffer(file);
        }

        function cancelExcelPrebuyEmails() {
            vm.excelPrebuyEmails = [];
        }

        function searchByAvatar() {
            if (!vm.selectedUser.avatar) {
                $mdToast.show({
                    template: '<md-toast layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-close" class="icon"></md-icon><span class="md-toast-text" flex>User without avatar</span></div></md-toast>',
                    hideDelay: 5000,
                    position: 'top',
                    parent: '#content-container'
                });
                return;
            }
            var options = {
                apiUrl: vm.apiUrl
            }
            switch (vm.eventVersion) {
                case 'v2':
                    options.version = vm.eventVersion;
                    options.runnerNumber = vm.selectedUser.eventNumber;
                    break;
                case 'v3':
                    options.version = vm.eventVersion;
                    options.runnerNumber = vm.selectedUser.eventNumber;
                    break;
                default:
                    options.runner_number = vm.selectedUser.eventNumber;
                    break;
            }
            RuntagEventService.searchByAvatarPablo(options).then(function (response) {
                response.map(x => {
                    if (x.crops && x.crops.length) {
                        var image = constructImage(x);
                    }
                    return image;
                });
                response = response.filter(x => x.crops.length > 0);
                vm.searchedItems = response;
            });
        }

        function constructImage(item) {
            item.tags = [];
            item.ignored = [];
            var persons = item.labels?.persons;
            var unmatchedNumbers = item.labels?.unmatchedNumbers;
            switch (vm.eventVersion) {
                case 'v2':
                    var ignoredPersons = item.labels?.unknownFaces;
                    break;
                case 'v3':
                    var ignoredPersons = item.labels?.unknownFaces;
                    break;
                default:
                    var ignoredPersons = item.labels?.unknown_persons;
                    break;
            }
            if (unmatchedNumbers) {
                unmatchedNumbers.map(function (x) {
                    x.type = 'unmatchedNumber';
                    item.tags.push(x);
                    return x;
                });
            }
            if (persons) {
                for (var i = 0; i < persons.length; i++) {
                    switch (vm.eventVersion) {
                        case 'v2':
                            var repeatedPerson = item.tags.find(x => x.runnerNumber == persons[i].runnerNumber);
                            if (persons[i] != null && !repeatedPerson) {
                                persons[i].idUserFace = item.mediaId;
                                item.tags.push(persons[i]);
                            }
                            break;
                        case 'v3':
                            var repeatedPerson = item.tags.find(x => x.runnerNumber == persons[i].runnerNumber);
                            if (persons[i] != null && !repeatedPerson) {
                                persons[i].idUserFace = item.mediaId;
                                item.tags.push(persons[i]);
                            }
                            break;
                        default:
                            var repeatedPerson = item.tags.find(x => x.runner_number == persons[i].runner_number);
                            if (persons[i] != null && !repeatedPerson) {
                                persons[i].id_user_face = item.media_id;
                                item.tags.push(persons[i]);
                            }
                            break;
                    }
                }
            }
            if (ignoredPersons && ignoredPersons.length > 0) {
                for (var i = 0; i < ignoredPersons.length; i++) {
                    if (ignoredPersons[i] != null) {
                        switch (vm.eventVersion) {
                            case 'v2':
                                var person = {
                                    boundingBox: {}
                                }
                                if (ignoredPersons[i].face) {
                                    person.boundingBox = ignoredPersons[i].face.boundingBox;
                                    item.ignored.push(person);
                                }
                                break;
                            case 'v3':
                                var person = {
                                    boundingBox: {}
                                }
                                if (ignoredPersons[i].face) {
                                    person.boundingBox = ignoredPersons[i].face.boundingBox;
                                    item.ignored.push(person);
                                }
                                break;
                            default:
                                var person = {
                                    BoundingBox: {}
                                }
                                if (ignoredPersons[i] && ignoredPersons[i].label && ignoredPersons[i].label.BoundingBox) {
                                    person.BoundingBox = ignoredPersons[i].label.BoundingBox;
                                    item.ignored.push(person);
                                }
                                break;
                        }
                    }
                }
            }
            if (item.crops && item.crops.length) {
                item.preview = item.crops.find(x => x.id == 1001)?.url;
                item.urlImage = item.crops.find(x => x.id == 11015)?.url;
                const currentClient = vm.clients.find(x => x.id_clients === vm.selectedGroup.id_client);
                if (!isValidUrl(item.preview)) {
                    item.preview = currentClient.prefix_photos_url + item.preview;
                }
                if (!isValidUrl(item.urlImage)) {
                    item.urlImage = currentClient.prefix_photos_url + item.urlImage;
                }
            }
            switch (vm.eventVersion) {
                case 'v2':
                    item.createdAtTransform = transformDate(item.createdAt);
                    break;
                case 'v3':
                    item.createdAtTransform = transformDate(item.createdAt);
                    break;
                default:
                    item.createdAtTransform = transformDate(item.created_at);
                    break;
            }
            return item;
        }

        function isValidUrl(url) {
            try {
                new URL(url);
                return true;
            } catch (err) {
                return false;
            }
        }

        // Los campos JSON de las secciones (media_ids, created_at_files...) llegan
        // como string desde la API. Devuelve siempre un array.
        function parseJsonField(value) {
            if (!value) return [];
            if (angular.isArray(value)) return value;
            try {
                var parsed = JSON.parse(value);
                return angular.isArray(parsed) ? parsed : [];
            } catch (err) {
                return [];
            }
        }

        function uploadAllProfilePhotos() {
            var userTag = vm.tags.find(tag => tag.tag_name == vm.selectedUser.eventNumber);
            var medias = [];
            for (var i = 0; i < vm.selectedUser.newMedia.length; i++) {
                switch (vm.eventVersion) {
                    case 'v2':
                        medias.push(vm.selectedUser.newMedia[i].idMedia);
                        break;
                    case 'v3':
                        medias.push(vm.selectedUser.newMedia[i].idMedia);
                        break;
                    default:
                        medias.push(vm.selectedUser.newMedia[i].id_media);
                        break;
                }
            }
            var optionsGetMedias = {
                domain: $scope.siteID,
                withTags: true,
                withGalleries: true,
                filters: [
                    {
                        field: "id_media",
                        name: "ID media",
                        values: medias
                    }
                ]
            }
            RuntagEventService.getMediaWithTags(optionsGetMedias).then(function (response) {
                var mediasToUpdate = angular.copy(response.data);
                for (var i = 0; i < mediasToUpdate.length; i++) {
                    var eventTag = mediasToUpdate[i].tags.find(tag => tag.id_type == 3);
                    var mediaUserTag = mediasToUpdate[i].tags.find(tag => tag.id_tag == userTag.id_tag);
                    for (var j = 0; j < mediasToUpdate[i].galleries.length; j++) {
                        mediasToUpdate[i].galleries[j] = mediasToUpdate[i].galleries[j].id_gallery;
                    }
                    for (var j = 0; j < mediasToUpdate[i].tags.length; j++) {
                        mediasToUpdate[i].tags[j] = mediasToUpdate[i].tags[j].id_tag;
                    }
                    if (!eventTag) {
                        mediasToUpdate[i].tags.push(3);
                    }
                    if (!mediaUserTag) {
                        mediasToUpdate[i].tags.push(userTag.id_tag);
                    }
                    var optionsMediaUpdate = {
                        domain: $scope.siteID,
                        item: mediasToUpdate[i]
                    }
                    switch (vm.eventVersion) {
                        case 'v2':
                            optionsMediaUpdate.mediaID = mediasToUpdate[i].idMedia;
                            break;
                        case 'v3':
                            optionsMediaUpdate.mediaID = mediasToUpdate[i].idMedia;
                            break;
                        default:
                            optionsMediaUpdate.mediaID = mediasToUpdate[i].id_media;
                            break;
                    }
                    RuntagEventService.updateMedia(optionsMediaUpdate).then(function (response) {
                        var message = "Media con ID: " + response.id_media + " actualizado con los tags del usuario";
                        $mdToast.show({
                            template: '<md-toast id="succesfull-update" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-close" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                            hideDelay: 5000,
                            position: 'top',
                            parent: '#content-container'
                        });
                    });
                }
            });
        }

        function downloadImage(mediaItem) {
            let url = mediaItem.original;
            if (mediaItem.original) {
                url = mediaItem.original;
            } else {
                url = mediaItem.urlImage;
            }
            var options = {
                domain: $scope.siteID
            }
            if (mediaItem == 'all') {
                var collection = vm.allUserMedias || [];
                if (vm.selectedMedias && vm.selectedMedias.length > 0) {
                    collection = vm.selectedMedias;
                } else if (vm.searchedItems && vm.searchedItems.length > 0) {
                    collection = vm.searchedItems;
                }

                downloadZip(collection);
            } else {
                if (vm.eventVersion === 'v3') {
                    fetch(url)
                        .then(response => {
                            if (!response.ok) throw new Error('Error al descargar la imagen');
                            return response.blob();
                        })
                        .then(blob => {
                            const blobUrl = window.URL.createObjectURL(blob);
                            const a = document.createElement('a');
                            a.href = blobUrl;
                            // El basename de la clave S3 puede venir SIN extensión: fotos cuyo nombre de
                            // origen trae un tag tipo "roloegus.ph-2129.jpg" se guardan como
                            // "roloegus_ORIGINAL_<ts>.ph-2129" (sin .jpg) → se bajaban sin extensión de
                            // imagen. El mediaId sí conserva la extensión correcta → se prefiere cuando
                            // la trae; si no, se cae al basename de la URL (fallback seguro).
                            var urlName = url.split('/').pop().split('?')[0];
                            var fileName = urlName || 'imagen.jpg';
                            if (mediaItem.mediaId && /\.[A-Za-z0-9]{1,5}$/.test(mediaItem.mediaId)) {
                                fileName = mediaItem.mediaId;
                            }
                            a.download = fileName;
                            document.body.appendChild(a);
                            a.click();
                            document.body.removeChild(a);
                            window.URL.revokeObjectURL(blobUrl);
                        })
                        .catch(err => {
                            $log.error('Error al forzar la descarga:', err);
                        });
                } else {
                    options['fileUrl[]'] = [url];
                    downloadImagePreSignedUrl(options, mediaItem);
                }
            }
        }

        // Descarga TODAS las fotos del perfil (ZIP), como downloadImage('all') pero acotado a p.photos.
        function downloadProfilePhotos(profile) {
            if (!profile || !profile.photos || !profile.photos.length) return;
            downloadZip(profile.photos);
        }

        // "Download all" aligned with the runner's website (qiupreview bulkDownloadZip):
        // confirm with gallery total vs photos going into the ZIP, skip archived photos, request the pack
        // asynchronously on the event lambda (imagePackRequest) in parts of 500, poll each part and
        // download it when ready. Differences on purpose: the admin gets EVERY photo of the gallery (no
        // paywall filter) and the download is NOT recorded in the runner's "My ZIPs" history.
        var ZIP_PART_SIZE = 500;
        var ZIP_POLL_MS = 5000;
        var ZIP_POLL_MAX_MS = 20 * 60 * 1000;

        function downloadZip(medias) {
            if (vm.generatingZip || !medias || !medias.length) return;

            // Dedupe by created_at (unique photo id); photos without it cannot be packed.
            var seen = {};
            var unique = [];
            medias.forEach(function (m) {
                var ca = m && (m.createdAt || m.created_at);
                if (ca && !seen[ca]) {
                    seen[ca] = true;
                    unique.push(m);
                }
            });
            // Archived (Glacier) photos are not in the bucket: the website leaves them out of the ZIP too.
            var createdAts = unique
                .filter(function (m) { return m.archiveStatus !== 'ARCHIVED' && m.archiveStatus !== 'PENDING'; })
                .map(function (m) { return m.createdAt || m.created_at; });
            var archivedCount = unique.length - createdAts.length;

            if (!createdAts.length) {
                zipToast($translate.instant('RUNTAG.DOWNLOAD_ZIP.NOTHING_TO_DOWNLOAD'), 'orange');
                return;
            }

            var chunks = [];
            for (var i = 0; i < createdAts.length; i += ZIP_PART_SIZE) {
                chunks.push(createdAts.slice(i, i + ZIP_PART_SIZE));
            }

            var text = $translate.instant('RUNTAG.DOWNLOAD_ZIP.CONFIRM_TEXT', { total: unique.length, count: createdAts.length });
            if (archivedCount > 0) {
                text += ' ' + $translate.instant('RUNTAG.DOWNLOAD_ZIP.CONFIRM_ARCHIVED', { count: archivedCount });
            }
            if (chunks.length > 1) {
                text += ' ' + $translate.instant('RUNTAG.DOWNLOAD_ZIP.CONFIRM_PARTS', { parts: chunks.length });
            }
            var confirm = $mdDialog.confirm()
                .title($translate.instant('RUNTAG.DOWNLOAD_ZIP.CONFIRM_TITLE'))
                .textContent(text)
                .ariaLabel('Download all')
                .ok($translate.instant('RUNTAG.DOWNLOAD_ZIP.CONFIRM_OK'))
                .cancel($translate.instant('RUNTAG.DOWNLOAD_ZIP.CONFIRM_CANCEL'));

            $mdDialog.show(confirm).then(function () {
                runZipParts(chunks);
            }, angular.noop);
        }

        function runZipParts(chunks) {
            vm.generatingZip = true;
            vm.zipTotal = chunks.length;
            vm.zipProgress = 1;
            var failedParts = 0;

            // One part at a time: request → poll → download, then the next one. Avoids firing several
            // downloads at once (browsers block them) and hammering the lambda.
            function processPart(index) {
                if (index >= chunks.length) {
                    finish();
                    return;
                }
                vm.zipProgress = index + 1;

                return RuntagEventService.requestImagePack({
                    apiUrl: vm.apiUrl,
                    createdAtList: chunks[index]
                }).then(function (resp) {
                    var uuid = resp && (resp.uuid || (resp.response && resp.response.uuid));
                    if (!uuid) {
                        $log.warn('imagePackRequest returned no uuid', resp);
                        return $q.reject(resp);
                    }
                    return pollPart(uuid, Date.now());
                }).then(function (pack) {
                    triggerZipDownload(pack.outputUrl);
                    var missing = pack.missing || pack.missingFiles;
                    if (angular.isArray(missing) && missing.length) {
                        $log.warn('Some files were missing from the zip:', missing);
                        zipToast($translate.instant('RUNTAG.DOWNLOAD_ZIP.MISSING_FILES', { count: missing.length }), 'orange');
                    }
                }).catch(function (err) {
                    $log.error('Error generating ZIP part ' + (index + 1), err);
                    failedParts++;
                }).then(function () {
                    return processPart(index + 1);
                });
            }

            function pollPart(uuid, startedAt) {
                return $timeout(ZIP_POLL_MS).then(function () {
                    return RuntagEventService.getImagePackStatus({ apiUrl: vm.apiUrl, uuid: uuid });
                }).then(function (resp) {
                    var pack = (resp && resp.response) || resp || {};
                    if (pack.status === 'COMPLETED' && pack.outputUrl) {
                        return pack;
                    }
                    if (pack.status === 'FAILED' || pack.status === 'ERROR' || pack.status === 'COMPLETED') {
                        return $q.reject(pack);
                    }
                    if (Date.now() - startedAt > ZIP_POLL_MAX_MS) {
                        return $q.reject('timeout');
                    }
                    return pollPart(uuid, startedAt);
                });
            }

            function finish() {
                if (failedParts > 0) {
                    zipErrorToast($translate.instant('RUNTAG.DOWNLOAD_ZIP.PARTS_FAILED', { count: failedParts, total: chunks.length }));
                } else {
                    zipToast($translate.instant('RUNTAG.DOWNLOAD_ZIP.SUCCESS'), 'green');
                }
                vm.generatingZip = false;
                vm.zipTotal = null;
                vm.zipProgress = null;
            }

            processPart(0);
        }

        // Hidden iframe (as the website does): downloads the ZIP without navigating away from qiusystem.
        function triggerZipDownload(url) {
            if (typeof webkit != "undefined" && webkit.messageHandlers && typeof webkit.messageHandlers.qiuApp == "object") {
                webkit.messageHandlers.qiuApp.postMessage(angular.toJson({ type: "openExternal", url: url }));
                return;
            }
            if (typeof window["AndroidJS"] == 'object') {
                AndroidJS.downloadFile(url);
                return;
            }
            var iframe = document.createElement('iframe');
            iframe.className = 'hide';
            iframe.src = url;
            document.body.appendChild(iframe);
            $timeout(function () {
                if (iframe.parentNode) {
                    iframe.parentNode.removeChild(iframe);
                }
            }, 60000);
        }

        function zipErrorToast(msg) {
            $mdToast.show({
                template: '<md-toast layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-close" class="icon"></md-icon><span class="md-toast-text" flex>' + msg + '</span></div></md-toast>',
                hideDelay: 5000,
                position: 'top',
                parent: '#content-container'
            });
        }

        function zipToast(msg, color) {
            var bgClass = color === 'green' ? 'green-500-bg' : 'orange-500-bg';
            var icon = color === 'green' ? 'icon-check' : 'icon-alert-circle';
            $mdToast.show({
                template: '<md-toast layout="column" layout-align="center center"><div class="md-toast-content ' + bgClass + '"><md-icon md-font-icon="' + icon + '" class="icon"></md-icon><span class="md-toast-text" flex>' + msg + '</span></div></md-toast>',
                hideDelay: 4000,
                position: 'top',
                parent: '#content-container'
            });
        }

        function downloadImagePreSignedUrl(options) {
            RuntagEventService.downloadLambda(options).then(function (response) {
                angular.forEach(response, function (url, index) {
                    setTimeout(function () {
                        if (typeof webkit != "undefined" && typeof webkit.messageHandlers.qiuApp == "object") {
                            webkit.messageHandlers.qiuApp.postMessage(angular.toJson({ type: "openExternal", url: url }));
                            event.preventDefault();
                        } else if (typeof window["AndroidJS"] == 'object') {
                            AndroidJS.downloadFile(url);
                        } else {
                            $window.location.href = url;
                        }
                    }, 500 * index);
                });
            });
        }

        function getCountries() {
            var options = {
                paginate: 99999,
                resultsPerPage: 300
            };
            RuntagEventService.getCountries(options).then(function (response) {
                vm.countries = response.data;
            })
        }

        function getPaymentMethods(event) {
            var options = {
                siteID: $scope.siteID
            }
            RuntagEventService.getPaymentMethods(options).then(function (response) {
                var methods = response.result.data;
                for (var i = 0; i < methods.length; i++) {
                    var method = {
                        id: methods[i].id,
                        name: methods[i].payment_name
                    }
                    vm.paymentMethods.push(method);
                }
            });
        }

        function changeMediaTemplate(param) {
            vm.mediaTemplate = param;
            switch (param) {
                case "face":
                    if (!vm.mediaDetectedFace) {
                        vm.isLoadingDetectedFace = true;
                        var no_id_media = [];
                        if (vm.selectedUser.newMedia && vm.selectedUser.newMedia.length > 0) {
                            for (var i = 0; i < vm.selectedUser.newMedia.length; i++) {
                                no_id_media.push(vm.selectedUser.newMedia[i].id_media);
                            }

                            var selectedFaceID = false;
                            for (var i = 0; i < vm.selectedUser.newMedia.length; i++) {
                                if (!selectedFaceID) {
                                    var userMedia = vm.selectedUser.newMedia[i];
                                    var faceID = userMedia.media.ai_recognition.persons.find(person => person.id_user == vm.selectedUser.id_user || person.email_temp == vm.selectedUser.email_temp);
                                    if (faceID && faceID.face_id) {
                                        faceID = faceID.face_id;
                                        selectedFaceID = true;
                                    }
                                }
                            }
                            var optionsDetectedFace = {
                                siteID: $scope.siteID,
                                withAiRecognition: true,
                                withTags: true,
                                item: {
                                    no_id_media: no_id_media,
                                    faces: [faceID]
                                }
                            }
                            mediaService.getFacesRelated(optionsDetectedFace).then(function (response) {
                                vm.mediaDetectedFace = [];
                                for (var i = 0; i < response.length; i++) {
                                    vm.mediaDetectedFace.push(response[i].media);
                                }
                                vm.isLoadingDetectedFace = false;
                            })

                        } else {
                            vm.isLoadingDetectedFace = false;
                        }
                    }
                    break;
                case "text":
                    if (!vm.mediaDetectedText) {
                        vm.isLoadingDetectedText = true;
                        var no_id_media = [];
                        for (var i = 0; i < vm.selectedUser.newMedia.length; i++) {
                            no_id_media.push(vm.selectedUser.newMedia[i].id_media);
                        }
                        var optionsDetectedText = {
                            domain: $scope.siteID,
                            no_id_media: no_id_media,
                            withTags: true,
                            withAiRecognition: true,
                            detected_texts: [vm.selectedUser.eventNumber]
                        }
                        RuntagEventService.getMediaDetectedText(optionsDetectedText).then(function (response) {
                            vm.mediaDetectedText = response;
                            vm.isLoadingDetectedText = false;
                        });
                    }
                    break;
            }
        }


        function changeTemplate(template) {
            vm.selectedMedias = [];
            vm.filteredUserTemplate = template;
            if (template == 'info') {
                vm.currentTab = 'preview';
            }
            if (template == 'profiles') {
                loadRunnerProfiles();
            }
            // Compras: en eventos de carrito la vista muestra la cobertura (perfiles/fotos) de cada orden,
            // que sale de vm._userFullOrders (files) → asegurar su carga y reconstruir la vista.
            if (template == 'shopping' && vm.cartEnabled) {
                loadRunnerProfiles();
                buildShoppingView();
            }
        }

        // ─────────────────────────────────────────────────────────────────────────────
        // PERFILES DE CORREDOR (pestaña "Perfiles", sustituye a Media en eventos de carrito)
        //
        // Todo va contra qiu-api (esto es qiusystem, NO qiupreview):
        //  - Perfiles con fotos = órdenes assigned_profile en section_orders. getOrders NO trae
        //    la columna files, así que se piden por id (getContentID → SELECT s.*).
        //  - Dorsal propio + nombres: del registro users (user_params.events_data[grupo]).
        //  - Fotos: se resuelven contra la API de reconocimiento (cara → find_related_faces,
        //    dorsal → mediaFiles/runner), se pasan por constructImage (mismo shape que Media)
        //    y se muestran con item-media-unified.html. Se casan con los items por created_at.
        //  - Renombrar → user_params (users/:id). Borrar → content/orders/action/delete + user_params.
        // ─────────────────────────────────────────────────────────────────────────────

        var _runnerProfilesUserParams = null; // user_params vivo (objeto) para renombrar/borrar
        var _runnerProfilesGroupEntry = null; // entry events_data del grupo del evento

        function loadRunnerProfiles(force) {
            if (!vm.selectedUser || !vm.selectedUser.id_user || !vm.selectedGroup || !vm.selectedGroup.id_events) {
                return;
            }
            // Cache por usuario: no recargar salvo force.
            if (!force && vm._runnerProfilesLoadedFor === vm.selectedUser.id_user) { return; }

            vm.runnerProfiles = [];
            vm.runnerProfileIndex = 0;
            vm.runnerProfilesError = false;
            vm.runnerProfileOwnNumber = null;
            vm.runnerProfileOwnName = null;
            _runnerProfilesUserParams = null;
            _runnerProfilesGroupEntry = null;
            vm._faceSearchCache = {}; // caché find_related_faces por faceId, por usuario
            vm.runnerProfilesLoading = true;

            var userId = vm.selectedUser.id_user;
            var eventId = vm.selectedGroup.id_events;
            var groupId = vm.selectedGroup.id_user_group;

            var pUser = RuntagRunnerService.getUser($scope.siteID, userId).then(function (res) {
                var u = (res && res.result) || res || {};
                // Same label the website gives the primary profile (getAccessibleProfilesForEvent: firstname + lastname, or Runner).
                vm.runnerProfileOwnName = ((u.firstname || '') + ' ' + (u.lastname || '')).trim() || 'Runner';
                var params = u.user_params;
                if (angular.isString(params)) {
                    try { params = JSON.parse(params); } catch (e) { params = {}; }
                }
                _runnerProfilesUserParams = angular.isObject(params) ? params : {};
                var eds = angular.isArray(_runnerProfilesUserParams.events_data) ? _runnerProfilesUserParams.events_data : [];
                _runnerProfilesGroupEntry = eds.filter(function (e) { return e && e.event_group_id === groupId; })[0] || null;
                vm.runnerProfileOwnNumber = _runnerProfilesGroupEntry ? (_runnerProfilesGroupEntry.number || null) : null;
            });

            var pOrders = RuntagRunnerService.getUserOrders($scope.siteID, userId, eventId).then(function (orders) {
                var ids = (orders || [])
                    .filter(function (o) { return String(o.id_event) === String(eventId); })
                    .map(function (o) { return o.id_orders; });
                if (!ids.length) { return []; }
                return $q.all(ids.map(function (id) {
                    return RuntagRunnerService.getOrderById($scope.siteID, id).catch(function () { return null; });
                }));
            });

            $q.all([pUser, pOrders])
                .then(function (r) {
                    // Detalles completos de las órdenes (CON la columna files, que el listado no trae) →
                    // fuente para calcular qué fotos están compradas (markProfilePhotosPurchased).
                    vm._userFullOrders = (r[1] || []).filter(Boolean);
                    buildRunnerProfiles(r[1] || []);
                    buildShoppingView(); // vista "Compras" (cobertura por perfil/fotos) usa los mismos files
                    vm._runnerProfilesLoadedFor = userId;
                    // Si el admin llegó buscando un dorsal (búsqueda por perfil), se abre ESE perfil y no el
                    // primero: en un usuario con varios perfiles, abrir el primero obliga a buscarlo a mano.
                    if (vm.runnerProfiles.length) { selectRunnerProfile(matchedProfileIndex()); }
                    // Load the whole-profile (all-photos) packs up front: their photos are marked as bought in
                    // every other profile, as on the website, so they must be known before the admin opens them.
                    var packSets = computePurchaseSets();
                    (vm.runnerProfiles || []).forEach(function (p) {
                        if (packSets && packSets.allPhotosDorsals[String(p.dorsal)]) { loadRunnerProfilePhotos(p); }
                    });
                })
                .catch(function () {
                    vm.runnerProfilesError = true;
                })
                .finally(function () { vm.runnerProfilesLoading = false; });
        }

        /**
         * Índice del perfil que buscó el admin (`user.matchedProfileNumber`, puesto por filterUsers), o 0
         * si no viene de una búsqueda por dorsal o si ese perfil no está en la lista. Se compara como string
         * (los dorsales son texto: A1007, E04, SD…, así que 001 ≠ 1) pero sin distinguir mayúsculas (p1 = P1).
         *
         * Se consume UNA sola vez por usuario: las recargas posteriores (loadRunnerProfiles(true) tras asignar
         * o renombrar) siguen abriendo el primero, como antes — si no, saltarían al perfil buscado sacando al
         * admin del perfil en el que estaba trabajando.
         */
        function matchedProfileIndex() {
            var user = vm.selectedUser;
            var wanted = user && user.matchedProfileNumber;
            if (!wanted || vm._matchedProfileConsumedFor === user.id_user) { return 0; }
            vm._matchedProfileConsumedFor = user.id_user;
            for (var i = 0; i < vm.runnerProfiles.length; i++) {
                if (String(vm.runnerProfiles[i].dorsal).toLowerCase() === String(wanted).toLowerCase()) { return i; }
            }
            return 0;
        }

        // Carga la lista de perfiles de un usuario ARBITRARIO (no el seleccionado) — para el picker del
        // media dialog. Devuelve [{dorsal, name, is_face, is_primary}] = dorsal propio (user_params) +
        // dorsales de las órdenes assigned_profile. No toca vm.runnerProfiles.
        /**
         * Dorsales de los perfiles que hay dentro del `files` de una orden. Los tres tipos cuentan, no solo
         * `assigned_profile`: un perfil también se compra entero (`profile_cart` → runners[]) o aparece al
         * comprar fotos sueltas (`mixed_cart` → el dorsal de cada foto). Mirar solo assigned_profile dejaba
         * fuera perfiles reales — p.ej. el 29314 del evento 908, comprado con un profile_cart.
         */
        function dorsalsFromOrderFiles(files) {
            var f = files;
            if (angular.isString(f)) { try { f = JSON.parse(f); } catch (e) { f = null; } }
            if (!f) { return []; }
            var out = [];
            if (f.type === 'assigned_profile') {
                if (f.dorsal) { out.push(String(f.dorsal)); }
            } else if (f.type === 'profile_cart') {
                (angular.isArray(f.runners) ? f.runners : []).forEach(function (r) {
                    if (r && r.dorsal) { out.push(String(r.dorsal)); }
                });
            } else if (f.type === 'mixed_cart') {
                (angular.isArray(f.photos) ? f.photos : []).forEach(function (ph) {
                    if (ph && ph.dorsal) { out.push(String(ph.dorsal)); }
                });
            }
            return out;
        }

        function fetchProfilesForUser(user) {
            var userId = user && (user.id_user || user.id);
            var eventId = vm.selectedGroup.id_events;
            var groupId = vm.selectedGroup.id_user_group;
            var ownNumber = null, names = {};
            var pUser = RuntagRunnerService.getUser($scope.siteID, userId).then(function (res) {
                var u = (res && res.result) || res || {};
                var params = u.user_params;
                if (angular.isString(params)) { try { params = JSON.parse(params); } catch (e) { params = {}; } }
                var eds = (params && angular.isArray(params.events_data)) ? params.events_data : [];
                var entry = eds.filter(function (e) { return e && e.event_group_id === groupId; })[0] || null;
                ownNumber = entry ? (entry.number || null) : null;
                names = (entry && entry.profile_names && !angular.isArray(entry.profile_names)) ? entry.profile_names : {};
            });
            var pOrders = RuntagRunnerService.getUserOrders($scope.siteID, userId, eventId).then(function (orders) {
                var ids = (orders || [])
                    .filter(function (o) { return String(o.id_event) === String(eventId); })
                    .map(function (o) { return o.id_orders; });
                if (!ids.length) { return []; }
                return $q.all(ids.map(function (id) {
                    return RuntagRunnerService.getOrderById($scope.siteID, id).catch(function () { return null; });
                }));
            });
            return $q.all([pUser, pOrders]).then(function (r) {
                var orders = r[1] || [], out = [], seen = {};
                orders.forEach(function (o) {
                    if (!o) { return; }
                    dorsalsFromOrderFiles(o.files).forEach(function (d) {
                        if (!d || seen[d]) { return; }
                        seen[d] = true;
                        out.push({ dorsal: d, is_face: d.indexOf('face:') === 0, name: names[d] || null });
                    });
                });
                if (ownNumber && !seen[String(ownNumber)]) {
                    out.unshift({ dorsal: String(ownNumber), is_face: false, name: names[String(ownNumber)] || null, is_primary: true });
                }
                return out;
            });
        }

        // Asigna una foto a un perfil (dorsal): la mete en user_params.events_data[grupo].assignedPhotos[dorsal]
        // como {created_at, mediaId}. El mediaId permite resolver la miniatura al pintar el perfil (una foto
        // asignada suele ser de OTRO dorsal, así que no está en el reco de este → se resuelve con getMediaIdPablo,
        // ver applyProfileDiff). También la saca de unassignedPhotos si estaba. Escribe con updateUserParams
        // (qiu-api existente). El dashboard del usuario aplicará el diff más adelante (CustomData).
        function assignPhotoToProfile(user, dorsal, createdAt, mediaId) {
            var userId = user && (user.id_user || user.id);
            var groupId = vm.selectedGroup.id_user_group;
            var key = String(dorsal);
            return RuntagRunnerService.getUser($scope.siteID, userId).then(function (res) {
                var u = (res && res.result) || res || {};
                var params = u.user_params;
                if (angular.isString(params)) { try { params = JSON.parse(params); } catch (e) { params = {}; } }
                if (!angular.isObject(params)) { params = {}; }
                if (!angular.isArray(params.events_data)) { params.events_data = []; }
                var entry = params.events_data.filter(function (e) { return e && e.event_group_id === groupId; })[0];
                if (!entry) { entry = { event_group_id: groupId }; params.events_data.push(entry); }
                if (!entry.assignedPhotos || angular.isArray(entry.assignedPhotos)) { entry.assignedPhotos = {}; }
                if (!entry.unassignedPhotos || angular.isArray(entry.unassignedPhotos)) { entry.unassignedPhotos = {}; }
                var a = angular.isArray(entry.assignedPhotos[key]) ? entry.assignedPhotos[key] : [];
                // dedup por created_at (compat: elementos antiguos podían ser strings sueltos)
                var exists = a.some(function (x) { return ((typeof x === 'string') ? x : (x && x.created_at)) === createdAt; });
                if (!exists) { a.push({ created_at: createdAt, mediaId: mediaId || null }); }
                entry.assignedPhotos[key] = a;
                var un = angular.isArray(entry.unassignedPhotos[key]) ? entry.unassignedPhotos[key] : [];
                entry.unassignedPhotos[key] = un.filter(function (c) { return photoEntryCreatedAt(c) !== createdAt; });
                // params es objeto; updateUserParams lo serializa (el backend guarda user_params como string).
                return RuntagRunnerService.updateUserParams($scope.siteID, userId, params);
            });
        }

        // ── Asignar resultados de búsqueda (por cara/dorsal) a un PERFIL del usuario seleccionado (eventos carrito) ──
        function _searchMediaCA(m) { return m && (m.createdAt || m.created_at); }
        function _searchMediaId(m) { return m && (m.mediaId || m.media_id); }

        function assignSearchResultToProfile(mediaItem, profile) {
            if (!vm.selectedUser || !profile || !mediaItem) { return; }
            var createdAt = _searchMediaCA(mediaItem);
            var mediaId = _searchMediaId(mediaItem);
            if (!createdAt) { return; }
            var key = mediaId || createdAt;
            vm.searchAssignSaving[key] = true;
            assignPhotoToProfile(vm.selectedUser, profile.dorsal, createdAt, mediaId)
                .then(function () {
                    mediaItem._assignedToDorsal = profile.dorsal;
                    $mdToast.show($mdToast.simple().textContent('Foto asignada a ' + vm.runnerProfileLabel(profile)).position('top right').hideDelay(2500));
                    loadRunnerProfiles(true);
                })
                .catch(function () {
                    $mdToast.show($mdToast.simple().textContent('No se pudo asignar la foto.').position('top right').hideDelay(2500));
                })
                .finally(function () { vm.searchAssignSaving[key] = false; });
        }

        function assignSelectedSearchToProfile(profile) {
            if (!vm.selectedUser || !profile) { return; }
            var items = (vm.selectedMedias || []).filter(function (m) { return _searchMediaCA(m); });
            if (!items.length) { return; }
            vm.searchAssignBulkSaving = true;
            vm.searchAssignBulkTotal = items.length;
            vm.searchAssignBulkDone = 0;
            // SECUENCIAL a propósito: assignPhotoToProfile hace read-modify-write de user_params; en paralelo se
            // pisarían las asignaciones (last-write-wins).
            var chain = items.reduce(function (prev, m) {
                return prev.then(function () {
                    return assignPhotoToProfile(vm.selectedUser, profile.dorsal, _searchMediaCA(m), _searchMediaId(m))
                        .then(function () { m._assignedToDorsal = profile.dorsal; vm.searchAssignBulkDone++; });
                });
            }, $q.resolve());
            chain
                .then(function () {
                    $mdToast.show($mdToast.simple().textContent(items.length + ' foto(s) asignadas a ' + vm.runnerProfileLabel(profile)).position('top right').hideDelay(2800));
                    vm.selectedMedias = [];
                    loadRunnerProfiles(true);
                })
                .catch(function () {
                    $mdToast.show($mdToast.simple().textContent('Error al asignar algunas fotos.').position('top right').hideDelay(2800));
                })
                .finally(function () { vm.searchAssignBulkSaving = false; });
        }

        // Quita una foto del perfil: la saca de assignedPhotos[dorsal] Y la mete en unassignedPhotos[dorsal]
        // (por created_at). Cubre con un único handler tanto fotos del reco/orden (se ocultan vía unassigned)
        // como assignedPhotos manuales (se sacan de assigned). Persiste con updateUserParams; splice optimista.
        function unassignPhotoFromProfile(profile, mediaItem, $event) {
            if ($event) { $event.stopPropagation(); $event.preventDefault(); } // no abrir el visor
            var user = vm.selectedUser;
            var userId = user && (user.id_user || user.id);
            var groupId = vm.selectedGroup.id_user_group;
            var key = String(profile.dorsal);
            var createdAt = mediaItem.createdAt || mediaItem.created_at;
            if (!createdAt) { return; }
            var mediaId = mediaItem.mediaId || mediaItem.media_id || null;
            return RuntagRunnerService.getUser($scope.siteID, userId).then(function (res) {
                var u = (res && res.result) || res || {};
                var params = u.user_params;
                if (angular.isString(params)) { try { params = JSON.parse(params); } catch (e) { params = {}; } }
                if (!angular.isObject(params)) { params = {}; }
                if (!angular.isArray(params.events_data)) { params.events_data = []; }
                var entry = params.events_data.filter(function (e) { return e && e.event_group_id === groupId; })[0];
                if (!entry) { entry = { event_group_id: groupId }; params.events_data.push(entry); }
                if (!entry.assignedPhotos || angular.isArray(entry.assignedPhotos)) { entry.assignedPhotos = {}; }
                if (!entry.unassignedPhotos || angular.isArray(entry.unassignedPhotos)) { entry.unassignedPhotos = {}; }
                // − assignedPhotos[key] (por created_at; compat string/objeto). Si estaba, era una foto ASIGNADA
                // (de otro dorsal) → al restaurar habrá que re-añadirla a assignedPhotos (no está en el reco).
                var a = angular.isArray(entry.assignedPhotos[key]) ? entry.assignedPhotos[key] : [];
                var wasAssigned = a.some(function (x) { return photoEntryCreatedAt(x) === createdAt; });
                entry.assignedPhotos[key] = a.filter(function (x) { return photoEntryCreatedAt(x) !== createdAt; });
                // + unassignedPhotos[key] como {created_at, mediaId} (dedup por created_at; el mediaId permite
                // restaurar con miniatura una foto asignada de otro dorsal).
                var un = angular.isArray(entry.unassignedPhotos[key]) ? entry.unassignedPhotos[key] : [];
                if (!un.some(function (x) { return photoEntryCreatedAt(x) === createdAt; })) {
                    un.push({ created_at: createdAt, mediaId: mediaId });
                }
                entry.unassignedPhotos[key] = un;
                // params es objeto; updateUserParams lo serializa (el backend guarda user_params como string).
                return RuntagRunnerService.updateUserParams($scope.siteID, userId, params).then(function () {
                    profile.photos = profile.photos.filter(function (m) { return m !== mediaItem; });
                    profile.items_total = profile.photos.length;
                    mediaItem._reco = !wasAssigned; // reco = se recupera solo quitándola de unassigned
                    profile.removedPhotos = profile.removedPhotos || [];
                    profile.removedPhotos.push(mediaItem);
                    if (_runnerProfilesGroupEntry) {
                        _runnerProfilesGroupEntry.assignedPhotos = entry.assignedPhotos;
                        _runnerProfilesGroupEntry.unassignedPhotos = entry.unassignedPhotos;
                    }
                });
            });
        }
        vm.unassignPhotoFromProfile = unassignPhotoFromProfile;

        // Restaura una foto quitada: la saca de unassignedPhotos[dorsal] y, si NO es del reco (era una foto
        // asignada de otro dorsal), la vuelve a meter en assignedPhotos[dorsal] con su mediaId. Persiste; UI optimista.
        function restorePhotoToProfile(profile, item, $event) {
            if ($event) { $event.stopPropagation(); $event.preventDefault(); }
            var user = vm.selectedUser;
            var userId = user && (user.id_user || user.id);
            var groupId = vm.selectedGroup.id_user_group;
            var key = String(profile.dorsal);
            var createdAt = item.createdAt || item.created_at;
            if (!createdAt) { return; }
            var mediaId = item.mediaId || item.media_id || null;
            var inReco = !!item._reco; // si no lo sabemos, false → re-añade a assigned (inofensivo por dedup)
            return RuntagRunnerService.getUser($scope.siteID, userId).then(function (res) {
                var u = (res && res.result) || res || {};
                var params = u.user_params;
                if (angular.isString(params)) { try { params = JSON.parse(params); } catch (e) { params = {}; } }
                if (!angular.isObject(params)) { params = {}; }
                if (!angular.isArray(params.events_data)) { params.events_data = []; }
                var entry = params.events_data.filter(function (e) { return e && e.event_group_id === groupId; })[0];
                if (!entry) { entry = { event_group_id: groupId }; params.events_data.push(entry); }
                if (!entry.assignedPhotos || angular.isArray(entry.assignedPhotos)) { entry.assignedPhotos = {}; }
                if (!entry.unassignedPhotos || angular.isArray(entry.unassignedPhotos)) { entry.unassignedPhotos = {}; }
                // − unassignedPhotos[key] (por created_at; compat)
                var un = angular.isArray(entry.unassignedPhotos[key]) ? entry.unassignedPhotos[key] : [];
                entry.unassignedPhotos[key] = un.filter(function (x) { return photoEntryCreatedAt(x) !== createdAt; });
                // + assignedPhotos[key] solo si NO es del reco (una foto propia del reco reaparece sola)
                if (!inReco) {
                    var a = angular.isArray(entry.assignedPhotos[key]) ? entry.assignedPhotos[key] : [];
                    if (!a.some(function (x) { return photoEntryCreatedAt(x) === createdAt; })) {
                        a.push({ created_at: createdAt, mediaId: mediaId });
                    }
                    entry.assignedPhotos[key] = a;
                }
                return RuntagRunnerService.updateUserParams($scope.siteID, userId, params).then(function () {
                    profile.removedPhotos = (profile.removedPhotos || []).filter(function (m) { return m !== item; });
                    delete item._reco;
                    profile.photos = profile.photos || [];
                    profile.photos.push(item);
                    // La galería se pinta por lotes: la foto restaurada se añade al final, así que
                    // hay que ampliar la ventana o el admin no vería el resultado de su clic.
                    profile._photosShown = Math.max(profile._photosShown || 0, profile.photos.length);
                    profile.items_total = profile.photos.length;
                    if (_runnerProfilesGroupEntry) {
                        _runnerProfilesGroupEntry.assignedPhotos = entry.assignedPhotos;
                        _runnerProfilesGroupEntry.unassignedPhotos = entry.unassignedPhotos;
                    }
                });
            });
        }
        vm.restorePhotoToProfile = restorePhotoToProfile;

        function runnerProfileNameFor(dorsal) {
            var names = (_runnerProfilesGroupEntry && _runnerProfilesGroupEntry.profile_names) || {};
            return (names && !angular.isArray(names)) ? (names[dorsal] || null) : null;
        }

        function buildRunnerProfiles(orders) {
            var profiles = [];
            var seen = {};
            var ownNumber = vm.runnerProfileOwnNumber;

            (orders || []).forEach(function (o) {
                if (!o) { return; }
                var files = o.files;
                if (angular.isString(files)) {
                    try { files = JSON.parse(files); } catch (e) { files = null; }
                }
                if (!files) { return; }
                var type = files.type;
                if (type === 'assigned_profile') {
                    // Perfil recolectado/curado (dorsal + items).
                    var dorsal = String(files.dorsal || '');
                    if (!dorsal || seen[dorsal]) { return; }
                    seen[dorsal] = true;
                    profiles.push(makeRunnerProfile(o.id_orders, dorsal, angular.isArray(files.items) ? files.items : []));
                } else if (type === 'mixed_cart') {
                    // Compra de fotos SUELTAS: cada foto lleva su dorsal → surface un perfil por dorsal comprado
                    // (igual que la web del corredor). Antes qiusystem lo ignoraba y esos perfiles no aparecían.
                    var byDorsal = {};
                    (angular.isArray(files.photos) ? files.photos : []).forEach(function (ph) {
                        var d = String((ph && ph.dorsal) || '');
                        if (d) { (byDorsal[d] = byDorsal[d] || []).push(ph); }
                    });
                    Object.keys(byDorsal).forEach(function (d) {
                        if (seen[d]) { return; }
                        seen[d] = true;
                        profiles.push(makeRunnerProfile(o.id_orders, d, byDorsal[d]));
                    });
                } else if (type === 'profile_cart') {
                    // Pack "todas las fotos" por perfil: cada runner es un dorsal comprado.
                    (angular.isArray(files.runners) ? files.runners : []).forEach(function (r) {
                        var d = String((r && r.dorsal) || '');
                        if (!d || seen[d]) { return; }
                        seen[d] = true;
                        profiles.push(makeRunnerProfile(o.id_orders, d, []));
                    });
                }
            });

            if (ownNumber && !seen[String(ownNumber)]) {
                var own = makeRunnerProfile(null, String(ownNumber), []);
                own.no_order = true;
                profiles.unshift(own);
            } else if (!ownNumber && ownProfileFaceIds().length) {
                // Own profile WITHOUT a dorsal but WITH a registered face: the website shows it as the primary
                // profile (getAccessibleProfilesForEvent → has_own_content) and loads it by face. It keys the
                // curated diff (assigned/unassignedPhotos) by the empty dorsal, so '' is kept as the key here.
                var ownFace = makeRunnerProfile(null, '', []);
                ownFace.no_order = true;
                ownFace.face_only = true;
                ownFace.is_primary = true;
                ownFace.ownFaceIds = ownProfileFaceIds();
                ownFace.ownLoadByFace = true;
                profiles.unshift(ownFace);
            }

            // Primary siempre primero; el resto por ORDEN DE CREACIÓN (id_orders ASC) → los perfiles NUEVOS
            // se colocan al FINAL, no al principio (getUserOrders puede venir en orden inverso).
            profiles.sort(function (a, b) {
                var pa = a.is_primary ? 1 : 0, pb = b.is_primary ? 1 : 0;
                if (pa !== pb) { return pb - pa; }
                return (a.id_orders || 0) - (b.id_orders || 0);
            });
            profiles.forEach(function (p, i) { p.profileNumber = i + 1; });
            vm.runnerProfiles = profiles;
        }

        // Contador del sub-tab ajustado por el diff SIN cargar reco: items − unassigned + assigned no-en-items.
        // (El dorsal propio tiene items=[] → da la cuenta de assigned; se corrige al cargarse, es index 0.)
        function diffAdjustedCount(dorsal, items) {
            var entry = _runnerProfilesGroupEntry || {};
            var key = String(dorsal);
            var assigned = groupPhotoList(entry, 'assignedPhotos', key);
            var unassignedRaw = groupPhotoList(entry, 'unassignedPhotos', key);
            var unCA = {};
            unassignedRaw.forEach(function (x) { var c = photoEntryCreatedAt(x); if (c) { unCA[c] = true; } });
            var inItems = {}, n = 0;
            (items || []).forEach(function (it) {
                inItems[it.created_at] = true;
                if (!unCA[it.created_at]) { n++; }
            });
            assigned.forEach(function (a) {
                var ca = photoEntryCreatedAt(a);
                // Igual que applyProfileDiff: una assigned cross-source sin mediaId no se pinta → no la cuentes.
                if (ca && photoEntryMediaId(a) && !inItems[ca] && !unCA[ca]) { n++; }
            });
            return n;
        }

        // Caras usadas para el reconocimiento de un perfil: profile_faces[dorsal] (faceIds) +
        // profile_face_sources[dorsal] (mediaId de la foto de la que salió cada cara), del events_data.
        // Compat: valores pueden ser array (multi-cara) o string legacy. Se emparejan por índice.
        function buildRecognitionFaces(dorsal) {
            var entry = _runnerProfilesGroupEntry || {};
            var faces = (entry.profile_faces || {})[dorsal];
            var sources = (entry.profile_face_sources || {})[dorsal];
            if (typeof faces === 'string') { faces = faces ? [faces] : []; }
            if (!angular.isArray(faces)) { faces = []; }
            if (typeof sources === 'string') { sources = sources ? [sources] : []; }
            if (!angular.isArray(sources)) { sources = []; }
            var n = Math.max(faces.length, sources.length);
            var out = [];
            for (var i = 0; i < n; i++) {
                out.push({ faceId: faces[i] || null, sourceMediaId: sources[i] || null, preview: null, loadingThumb: false });
            }
            return out;
        }

        // Busca el boundingBox de una cara (por faceId) en la media resuelta.
        function findFaceBbox(media, faceId) {
            var lb = media && media.labels;
            if (!lb || !faceId) { return null; }
            var buckets = [lb.persons, lb.unknownFaces, lb.lowQualityFaces];
            for (var b = 0; b < buckets.length; b++) {
                var arr = buckets[b] || [];
                for (var i = 0; i < arr.length; i++) {
                    var f = arr[i] && arr[i].face;
                    if (f && (f.faceId === faceId || f.id === faceId) && f.boundingBox) { return f.boundingBox; }
                }
            }
            return null;
        }

        // Miniatura de cada cara: recorte real (endpoint crop_media_faces). Vía rápida = foto fuente +
        // match del faceId en su detección actual; si el faceId está OBSOLETO (foto reprocesada, faceIds
        // reasignados), se localiza la cara con find_related_faces (que sí mantiene el faceId en la
        // colección) y se cropea. Fallback final: foto fuente completa. Guarda rf.sourceMedia (para abrir
        // el preview al click).
        function resolveRecognitionFaceThumbs(profile) {
            (profile && profile.recognitionFaces || []).forEach(function (rf) {
                if (!rf.faceId || rf._done || rf.loadingThumb) { return; }
                rf.loadingThumb = true;
                resolveOneRecognitionFace(rf);
            });
        }

        // Último recurso: mostrar la foto completa SOLO si no se logró el recorte (así no parpadea la
        // foto original antes del crop).
        function faceThumbFallback(rf) {
            if (!rf.cropUrl && rf.sourceMedia) { rf.preview = rf.sourceMedia.preview; }
            rf.loadingThumb = false;
            rf._done = true;
        }

        function resolveOneRecognitionFace(rf) {
            if (!rf.sourceMediaId) { recognitionFaceViaRelated(rf); return; }
            RuntagEventService.getMediaIdPablo({ apiUrl: vm.apiUrl, version: vm.eventVersion, mediaId: rf.sourceMediaId, media_id: rf.sourceMediaId })
                .then(function (resp) {
                    var media = angular.isArray(resp) ? resp[0] : resp;
                    if (media) { rf.sourceMedia = constructImage(media); } // para el click; NO se pinta en el thumb
                    var bbox = media ? findFaceBbox(media, rf.faceId) : null;
                    var ca = media && (media.created_at || media.createdAt);
                    if (bbox && ca) { cropRecognitionFace(rf, ca, bbox, rf.faceId); }
                    else { recognitionFaceViaRelated(rf); } // faceId obsoleto → localizar por find_related_faces
                })
                .catch(function () { recognitionFaceViaRelated(rf); });
        }

        function recognitionFaceViaRelated(rf) {
            faceSearch(rf.faceId)
                .then(function (items) {
                    items = items || [];
                    var it = null;
                    if (rf.sourceMediaId) { it = items.filter(function (x) { return String(x.mediaId) === String(rf.sourceMediaId); })[0]; }
                    if (!it) { it = items[0]; }
                    if (!it) { faceThumbFallback(rf); return; }
                    // El recorte sale de ESTA foto (it), no del source grabado (que puede ser incorrecto):
                    // el click debe abrir la foto real de la que salió la cara.
                    rf.sourceMedia = constructImage(it);
                    rf.sourceMediaId = it.mediaId;
                    var fid = it.faceId || rf.faceId;
                    var bbox = findFaceBbox(it, fid);
                    var ca = it.createdAt || it.created_at;
                    if (bbox && ca) { cropRecognitionFace(rf, ca, bbox, fid); }
                    else { faceThumbFallback(rf); }
                })
                .catch(function () { faceThumbFallback(rf); });
        }

        function cropRecognitionFace(rf, ca, bbox, faceId) {
            var c = function (v) { v = Number(v); return isNaN(v) ? 0 : Math.max(0, Math.min(1, v)); };
            var payload = [{ createdAt: ca, faces: [{ face_id: faceId, bbox: { top: c(bbox.top), left: c(bbox.left), width: c(bbox.width), height: c(bbox.height) } }] }];
            RuntagEventService.cropMediaFacesPablo({ apiUrl: vm.apiUrl, media: payload })
                .then(function (cropResp) {
                    var arr = angular.isArray(cropResp) ? cropResp : (cropResp && cropResp.response) || [];
                    arr.forEach(function (m) {
                        (m.faces || []).forEach(function (f) {
                            if (f && f.face_id === faceId && f.mediaFile) { rf.cropUrl = f.mediaFile; }
                        });
                    });
                    if (rf.cropUrl) { rf.loadingThumb = false; rf._done = true; }
                    else { faceThumbFallback(rf); } // el crop no devolvió URL → foto completa
                })
                .catch(function () { faceThumbFallback(rf); });
        }

        function makeRunnerProfile(idOrders, dorsal, items) {
            var ds = String(dorsal == null ? '' : dorsal);
            var isFace = ds.indexOf('face:') === 0;
            // Dorsal "real" de reconocimiento (no cara/desconocido/vacío) → se muestra en el subtab.
            var dorsalNumber = (ds && !isFace && ds.indexOf('unknown_') !== 0) ? ds : null;
            var isPrimary = !!(vm.runnerProfileOwnNumber && dorsal === String(vm.runnerProfileOwnNumber));
            return {
                id_orders: idOrders,
                dorsal: dorsal,
                dorsalNumber: dorsalNumber,
                is_face: isFace,
                face_id: isFace ? ds.slice(5) : null,
                items: items,
                items_total: diffAdjustedCount(dorsal, items),
                name: runnerProfileNameFor(dorsal),
                is_primary: isPrimary,
                recognitionFaces: buildRecognitionFaces(dorsal),
                // Caras PROPIAS del usuario (user_params.events_data[grupo].profile.face_ids). Son distintas de
                // recognitionFaces (esas son las caras vinculadas a UN dorsal concreto, feature #9). Solo aplican
                // al perfil propio, y son las que la web usa para resolver sus fotos cuando load_by_face.
                ownFaceIds: isPrimary ? ownProfileFaceIds() : [],
                ownLoadByFace: isPrimary ? ownProfileLoadsByFace() : false,
                photos: null,
                loadingPhotos: false,
                photosLoaded: false
            };
        }

        // Mismas razones que MANUAL_CLAIM_REASONS del backend: una foto entra en el perfil por decisión HUMANA
        // (el admin o el propio usuario la reclamó), no por OCR automático del dorsal.
        var MANUAL_CLAIM_REASONS = ['ADMIN_CLAIM', 'ADMIN_CLAIM_WITHOUT_FACE_ID', 'USER_CLAIM', 'USER_CLAIM_WITHOUT_FACE_ID'];

        /** Predicado: ¿esta media está reclamada manualmente para ese dorsal? */
        function isManualClaimForDorsal(dorsal) {
            var d = String(dorsal == null ? '' : dorsal);
            return function (m) {
                // La razón puede venir suelta (como la manda el media service) o dentro de labels.persons[].
                var reason = m && m.reason;
                if (reason && MANUAL_CLAIM_REASONS.indexOf(String(reason)) !== -1) { return true; }
                var persons = (m && m.labels && m.labels.persons) || [];
                for (var i = 0; i < persons.length; i++) {
                    var p = persons[i] || {};
                    var num = p.runnerNumber && p.runnerNumber.detectedText;
                    if (String(num) !== d) { continue; }
                    if (MANUAL_CLAIM_REASONS.indexOf(String(p.reason)) !== -1) { return true; }
                }
                return false;
            };
        }

        /** face_ids propios del usuario en el evento (compat: face_id suelto = face_ids[0]). */
        function ownProfileFaceIds() {
            var profile = (_runnerProfilesGroupEntry || {}).profile;
            if (!profile) { return []; }
            var ids = angular.isArray(profile.face_ids) ? profile.face_ids : (profile.face_id ? [profile.face_id] : []);
            return ids.map(function (f) { return String(f || ''); }).filter(Boolean);
        }

        function ownProfileLoadsByFace() {
            var profile = (_runnerProfilesGroupEntry || {}).profile;
            return !!(profile && profile.load_by_face);
        }

        // Sin nombre propio → "Perfil N" (N = posición en la lista, 1-based).
        function runnerProfileLabel(p) {
            if (!p) { return ''; }
            if (p.name) { return p.name; }
            // The primary profile is named after the user, as on the website — not "Perfil N".
            if (p.is_primary && vm.runnerProfileOwnName) { return vm.runnerProfileOwnName; }
            return $translate.instant('RUNTAG.PROFILES.DEFAULT_LABEL', { n: p.profileNumber });
        }
        vm.runnerProfileLabel = runnerProfileLabel;

        function selectRunnerProfile(i) {
            vm.runnerProfileIndex = i;
            var p = vm.runnerProfiles[i];
            if (p) { resolveRecognitionFaceThumbs(p); loadRunnerProfilePhotos(p); }
        }

        // find_related_faces (searchByFacePablo) memoizado por faceId — lo usan la unión de fotos del
        // perfil Y la sección "Caras usadas", evitando duplicar la llamada (cara). Se limpia por usuario.
        function faceSearch(faceId) {
            if (!faceId) { return $q.when([]); }
            vm._faceSearchCache = vm._faceSearchCache || {};
            if (!vm._faceSearchCache[faceId]) {
                vm._faceSearchCache[faceId] = RuntagEventService.searchByFacePablo({ apiUrl: vm.apiUrl, version: vm.eventVersion, faceId: faceId })
                    .then(function (r) { return angular.isArray(r) ? r : ((r && r.items) || []); })
                    .catch(function () { return []; });
            }
            return vm._faceSearchCache[faceId];
        }

        function loadRunnerProfilePhotos(profile) {
            // Devuelve una promesa que resuelve con profile.photos (los llamadores de selección la ignoran;
            // el diálogo de alta de compra la usa para pintar el grid de fotos del perfil elegido).
            if (profile.photosLoaded) { return $q.when(profile.photos || []); }
            if (profile.loadingPhotos) { return profile._photosPromise || $q.when(profile.photos || []); }
            // Dorsal PROPIO sin colección (no_order): no hay orden assigned_profile → sin items, pero el
            // dorsal SÍ tiene fotos en el reconocimiento → cargarlas TODAS para que el admin las vea/edite.
            // Cualquier perfil de dorsal REAL (propio, comprado o recolectado) sin caras: el corredor ve en la
            // web TODA la galería del reconocimiento del dorsal (no solo lo comprado/recolectado). El admin debe
            // ver lo mismo. `unknown_` no es un dorsal de reconocimiento → excluido.
            var isRealDorsal = !!profile.dorsal && !esDorsalSintetico(profile.dorsal);
            // PERFIL PROPIO RESUELTO POR CARA: si el usuario eligió/subió su cara (load_by_face) y el evento usa
            // profileFaceSelection —o ni siquiera tiene dorsal—, la web NO le muestra la galería del dorsal, sino
            // la UNIÓN de su cara ∪ los claims MANUALES de su dorsal. Aquí se replica tal cual para que el admin
            // vea EXACTAMENTE lo mismo; si no, veía el reco del dorsal (que puede llevar fotos de otra persona y
            // faltarle las que solo encuentra la cara).
            // A dorsal-less own profile (face_only) is ALWAYS loaded by face, as the website's $ownFaceOnly branch.
            var ownByFace = !!profile.is_primary && !profile.is_face &&
                            (profile.ownFaceIds || []).length > 0 &&
                            (profile.face_only || (profile.ownLoadByFace && (vm.faceSelectionEnabled || !isRealDorsal)));
            var ownAllPhotos = !profile.is_face && isRealDorsal && !ownByFace;
            // Caras del perfil (face:<id> → 1; dorsal con profile_faces → varias). Con caras, la vista del
            // admin debe mostrar la MISMA UNIÓN que el corredor: galería del dorsal ∪ find_related por cada
            // cara ∪ fotos-fuente (no solo la colección assigned_profile).
            var faceIds = profile.is_face
                ? (profile.face_id ? [profile.face_id] : [])
                : ((profile.recognitionFaces || []).map(function (rf) { return rf.faceId; }).filter(Boolean));
            if (ownByFace) {
                // Las caras propias mandan en el perfil propio (dedup con las vinculadas al dorsal).
                (profile.ownFaceIds || []).forEach(function (f) {
                    if (faceIds.indexOf(f) === -1) { faceIds.push(f); }
                });
            }
            var faceSrcIds = (profile.recognitionFaces || []).map(function (rf) { return rf.sourceMediaId; }).filter(Boolean);
            var hasFaces = faceIds.length > 0;

            if (!ownAllPhotos && !hasFaces && (!profile.items || !profile.items.length)) {
                // Sin items de orden ni caras, pero aún podría haber assignedPhotos → aplicar el diff igual.
                profile.photos = [];
                applyProfileDiff(profile, {});
                profile.photosLoaded = true;
                markPurchasedMedias(); // re-mark all: a whole-profile pack marks photos in other profiles too
                return $q.when(profile.photos);
            }
            profile.loadingPhotos = true;
            profile.photosTruncated = false;   // se recalcula en esta carga; si no, arrastra el aviso anterior

            var reqs = [];
            // No dorsal (face_only own profile) → no runner gallery to fetch (mediaFiles/runner/ would be invalid).
            if (!profile.is_face && profile.dorsal) {
                reqs.push(fetchRunnerProfileMedia(profile.dorsal)
                    .then(function (res) {
                        // El dorsal tenía más fotos de las que cabe traer: la galería NO está completa
                        // y hay que decirlo (antes se recortaba en silencio).
                        profile.photosTruncated = !!(res && res.tooMany);
                        var items = (res && res.items) || [];
                        // Cargando por cara: del dorsal solo entran los claims MANUALES (admin/usuario), igual
                        // que hace la web (getMediaFilesForRunner con MANUAL_CLAIM_REASONS). El OCR automático
                        // se descarta: es justo lo que puede traer fotos de otra persona.
                        return ownByFace ? items.filter(isManualClaimForDorsal(profile.dorsal)) : items;
                    })
                    .catch(function () { return []; }));
            }
            faceIds.forEach(function (fid) { reqs.push(faceSearch(fid)); });
            // Fotos-origen de las caras: find_related las omite → se re-añaden por mediaId.
            faceSrcIds.forEach(function (mid) {
                reqs.push(RuntagEventService.getMediaIdPablo({ apiUrl: vm.apiUrl, version: vm.eventVersion, mediaId: mid, media_id: mid })
                    .then(function (r) { return angular.isArray(r) ? r : (r ? [r] : []); }).catch(function () { return []; }));
            });
            if (!reqs.length) { reqs.push($q.when([])); }

            var chain = $q.all(reqs)
                .then(function (arrays) {
                    // Unión deduplicada (por created_at, o mediaId de fallback).
                    var byKey = {};
                    (arrays || []).forEach(function (arr) {
                        (arr || []).forEach(function (m) {
                            if (!m) { return; }
                            var key = (m.created_at || m.createdAt) || (m.mediaId || m.id);
                            if (key && !byKey[key]) { byKey[key] = m; }
                        });
                    });
                    var recoItems = Object.keys(byKey).map(function (k) { return byKey[k]; });
                    var map = buildRecoMap(recoItems);
                    if (ownAllPhotos || hasFaces) {
                        // Muestra TODA la unión (como el corredor), no solo la colección.
                        profile.photos = recoItems.filter(function (m) { return m; }).map(function (m) { return constructImage(m); });
                    } else {
                        profile.photos = profile.items.map(function (it) {
                            var m = map[it.created_at];
                            if (m) { return constructImage(m); }
                            var stub = { mediaId: it.id, media_id: it.id, createdAt: it.created_at, created_at: it.created_at,
                                         preview: null, tags: [], loadingThumb: false,
                                         createdAtTransform: it.created_at ? transformDate(it.created_at) : null };
                            resolveStubThumb(stub, it.id);
                            return stub;
                        });
                    }
                    applyProfileDiff(profile, map); // − unassignedPhotos[dorsal] + assignedPhotos[dorsal]
                })
                .catch(function () {
                    profile.photos = (profile.items || []).map(function (it) {
                        return { mediaId: it.id, media_id: it.id, createdAt: it.created_at, created_at: it.created_at,
                                 preview: null, tags: [], createdAtTransform: null };
                    });
                    applyProfileDiff(profile, {}); // al menos resta unassignedPhotos
                })
                .finally(function () {
                    profile.loadingPhotos = false;
                    profile.photosLoaded = true;
                    // Primer lote visible; el resto entra con "cargar más" (ver showMorePhotos).
                    profile._photosShown = Math.min(PROFILE_PHOTOS_PAGE, (profile.photos || []).length);
                    markPurchasedMedias(); // re-mark all: a whole-profile pack marks photos in other profiles too
                });
            profile._photosPromise = chain.then(function () { return profile.photos || []; });
            return profile._photosPromise;
        }

        // Tope de fotos que se traen para pintar la galería de un perfil, y aviso en la ficha
        // al alcanzarlo. 500 = 5 peticiones como mucho: con 1500 la galería de un dorsal muy
        // fotografiado (p.ej. el 2026 del evento 918, con 1598 fotos) tardaba demasiado en
        // cargar. Subirlo vuelve a hacerla lenta; bajarlo recorta antes, pero avisando.
        var PROFILE_MEDIA_CAP = 500;

        /**
         * Fotos del dorsal para la galería del perfil → {items, tooMany} (mismo contrato que
         * fetchAllRunnerProfileMedia). Drena TODAS las páginas hasta PROFILE_MEDIA_CAP y avisa
         * si lo alcanza. Antes cortaba en 3 páginas (300 fotos) y devolvía el recorte EN
         * SILENCIO; como el orden es DESC, lo que se perdía eran las más antiguas. Esta es la
         * vista desde la que se asignan y quitan fotos, así que trabajar sobre un conjunto
         * truncado sin saberlo lleva a conclusiones falsas.
         */
        function fetchRunnerProfileMedia(number) {
            var acc = [];
            function page(key) {
                return RuntagEventService.getUserMediasPablo({
                    apiUrl: vm.apiUrl, number: number, limit: 100, sort: 'DESC', pagingKey: key || ''
                }).then(function (res) {
                    var data = (res && res.data) || (res && res.items) || [];
                    acc = acc.concat(data);
                    if (acc.length > PROFILE_MEDIA_CAP) { return { items: acc, tooMany: true }; }
                    var next = res && res.LastEvaluatedKey;
                    if (next) { return page(next); }
                    return { items: acc, tooMany: false };
                });
            }
            return page('');
        }

        // Same paging as the runner website (CustomData::getMediaFilesForRunner): limit=100, sort=DESC, following
        // LastEvaluatedKey. A single request is NOT enough: the lambda can return fewer items than `limit` and still
        // have more pages (e.g. dorsal 12638 of event 663: 179 on the first page of limit=500, 351 in total).
        var RUNNER_MEDIA_MAX_PAGES = 40;       // getMediaFilesForRunner default $maxPages
        var MANUAL_CLAIM_SCAN_MAX_PAGES = 5;   // CustomData::MANUAL_CLAIM_SCAN_MAX_PAGES
        function fetchRunnerMediaAllPages(number, maxPages) {
            var acc = [];
            var seen = {};
            function page(key, n) {
                return RuntagEventService.getUserMediasPablo({
                    apiUrl: vm.apiUrl, number: number, limit: 100, sort: 'DESC', pagingKey: key || ''
                }).then(function (res) {
                    var data = (res && res.data) || (res && res.items) || [];
                    data.forEach(function (m) {
                        var k = m && ((m.createdAt || m.created_at) || (m.mediaId || m.media_id));
                        if (k && !seen[k]) { seen[k] = true; acc.push(m); }
                    });
                    var next = res && res.LastEvaluatedKey;
                    if (next && data.length && n < maxPages) { return page(next, n + 1); }
                    return { data: acc, count: acc.length };
                });
            }
            return page('', 1);
        }

        // Índice created_at → media (cubre v2/v3 `createdAt` y v1 `created_at`).
        function buildRecoMap(recoItems) {
            var map = {};
            (recoItems || []).forEach(function (m) {
                if (!m) { return; }
                if (m.createdAt) { map[m.createdAt] = m; }
                if (m.created_at) { map[m.created_at] = m; }
            });
            return map;
        }

        // assignedPhotos/unassignedPhotos: cada elemento puede ser string (legacy) u objeto {created_at, mediaId}.
        function photoEntryCreatedAt(x) { return (typeof x === 'string') ? x : (x && x.created_at); }
        function photoEntryMediaId(x) { return (x && typeof x === 'object') ? (x.mediaId || null) : null; }
        // Origen de la entrada: 'admin' (el admin la quitó/añadió a mano) o 'faceSelection' (la generó la
        // selección de cara del propio usuario). Las legacy (string) no lo llevan → se tratan como 'admin'.
        function photoEntrySource(x) { return (x && typeof x === 'object' && x.source) ? String(x.source) : 'admin'; }
        function groupPhotoList(entry, mapName, key) {
            var m = entry && entry[mapName];
            return (m && !angular.isArray(m)) ? (m[key] || []) : [];
        }

        // Resuelve la miniatura de un stub por mediaId (async): getMediaIdPablo → constructImage → rellena
        // preview/urlImage/tags/crops/labels en sitio. Sin mediaId no hace nada.
        // Descarga cuyo fichero NO está en allUserMedias (p.ej. usuario sin dorsal propio): resolver su
        // miniatura/datos por mediaId con getMediaIdPablo y, al lograrlo, quitar el flag unassigned para
        // que la tarjeta se pinte completa (preview + fecha + acciones), como las demás.
        // Clave única de una foto: el sufijo que va tras '_' en su created_at. Se usa ese trozo porque
        // la API reserializa la parte de fecha ("...T11:52:46.000Z") y la cadena completa puede variar.
        function caKey(v) {
            if (!v) { return null; }
            return String(v).split('_').pop() || null;
        }

        // Compara dos created_at de foto por su clave única.
        function sameCreatedAt(a, b) {
            if (!a || !b) { return false; }
            if (a === b) { return true; }
            var ka = caKey(a);
            return !!ka && ka === caKey(b);
        }

        function resolveDownloadThumb(dl, mediaId, createdAt) {
            if (!mediaId) { return; }
            RuntagEventService.getMediaIdPablo({ apiUrl: vm.apiUrl, version: vm.eventVersion, mediaId: mediaId, media_id: mediaId })
                .then(function (resp) {
                    // Buscar por nombre devuelve TODAS las fotos que se llaman igual (varias personas
                    // distintas). Se elige la que coincide con el created_at de la descarga; si no aparece,
                    // no se pinta nada: es preferible quedarse sin miniatura que mostrar una foto ajena.
                    var list = angular.isArray(resp) ? resp : (resp ? [resp] : []);
                    var media = null;
                    if (createdAt) {
                        media = list.find(function (m) {
                            return m && sameCreatedAt(m.createdAt || m.created_at, createdAt);
                        }) || null;
                    } else {
                        media = list[0] || null;
                    }
                    if (!media) { return; }
                    var built = constructImage(media);
                    dl.preview = built.preview;
                    dl.urlImage = built.urlImage;
                    dl.tags = built.tags;
                    dl.crops = built.crops;
                    dl.labels = built.labels;
                    if (built.createdAtTransform) { dl.createdAtTransform = built.createdAtTransform; }
                    dl.unassignedDownload = false;
                })
                .catch(function () {});
        }

        function resolveStubThumb(stub, mediaId) {
            if (!mediaId) { stub.loadingThumb = false; return; }
            stub.loadingThumb = true;
            RuntagEventService.getMediaIdPablo({ apiUrl: vm.apiUrl, version: vm.eventVersion, mediaId: mediaId, media_id: mediaId })
                .then(function (resp) {
                    var media = angular.isArray(resp) ? resp[0] : resp;
                    if (!media) { stub.loadingThumb = false; return; }
                    var built = constructImage(media);
                    stub.preview = built.preview;
                    stub.urlImage = built.urlImage;
                    stub.tags = built.tags;
                    stub.crops = built.crops;
                    stub.labels = built.labels;
                    stub.loadingThumb = false;
                })
                .catch(function () { stub.loadingThumb = false; });
        }

        // Aplica el diff del grupo sobre profile.photos:
        //   photos = photos − unassignedPhotos[dorsal] + assignedPhotos[dorsal]
        // Las assignedPhotos suelen ser de OTRO dorsal (no están en `map`): se pinta un stub y se resuelve la
        // miniatura por mediaId con getMediaIdPablo (async, rellena preview en sitio). Clave = String(dorsal),
        // idéntica a la que escribe assignPhotoToProfile y a "face:<id>" de las caras.
        function applyProfileDiff(profile, map) {
            var entry = _runnerProfilesGroupEntry || {};
            var key = String(profile.dorsal);
            var assignedRaw = groupPhotoList(entry, 'assignedPhotos', key);
            var unassignedRaw = groupPhotoList(entry, 'unassignedPhotos', key);

            // Set de created_at quitados (compat string/objeto).
            // OJO: las entradas con source 'faceSelection' NO ocultan la foto, porque la WEB DEL CORREDOR
            // tampoco las aplica (las salta explícitamente: existen para que el admin sepa qué descartó la
            // selección de cara). Si aquí se aplicaran, el admin vería MENOS fotos que el usuario.
            // Siguen listándose abajo en "Fotos quitadas" (con su botón de restaurar), así que no se pierde nada.
            var unCA = {};
            unassignedRaw.forEach(function (x) {
                if (photoEntrySource(x) === 'faceSelection') { return; }
                var c = photoEntryCreatedAt(x);
                if (c) { unCA[c] = true; }
            });

            // − unassignedPhotos[dorsal]
            profile.photos = profile.photos.filter(function (p) { return !unCA[p.createdAt || p.created_at]; });

            // + assignedPhotos[dorsal] (que no estén ya visibles ni quitados)
            var have = {};
            profile.photos.forEach(function (p) { var c = p.createdAt || p.created_at; if (c) { have[c] = true; } });
            assignedRaw.forEach(function (a) {
                var ca = photoEntryCreatedAt(a);
                var mid = photoEntryMediaId(a);
                if (!ca || have[ca] || unCA[ca]) { return; }
                have[ca] = true;
                var m = map[ca];
                if (m) { profile.photos.push(constructImage(m)); return; }
                // cross-source sin mediaId: no se puede pintar ni abrir de forma segura → no la mostramos.
                if (!mid) { return; }
                var stub = { mediaId: mid, media_id: mid, createdAt: ca, created_at: ca, preview: null, tags: [],
                             loadingThumb: true, createdAtTransform: transformDate(ca) };
                profile.photos.push(stub);
                resolveStubThumb(stub, mid);
            });

            // + fotos SUELTAS compradas de este dorsal que no estén ya en el perfil (p.ej. compras por CARA:
            // la cara sale en una foto cuyo número NO es el del dorsal → no está en su galería). Deben verse.
            // Se respeta al admin: si él la quitó (unassignedPhotos), NO se re-añade.
            purchasedPhotosForDorsal(profile.dorsal).forEach(function (bp) {
                var ca = bp.created_at, mid = bp.id;
                if (ca && (have[ca] || unCA[ca])) { return; }
                if (!ca && !mid) { return; }
                if (ca) { have[ca] = true; }
                var m = ca ? map[ca] : null;
                if (m) { var img = constructImage(m); img.purchased = true; profile.photos.push(img); return; }
                if (!mid) { return; }
                var stub2 = { mediaId: mid, media_id: mid, createdAt: ca, created_at: ca, preview: null, tags: [],
                              loadingThumb: true, createdAtTransform: ca ? transformDate(ca) : null, purchased: true };
                profile.photos.push(stub2);
                resolveStubThumb(stub2, mid);
            });

            profile.items_total = profile.photos.length; // recalcular contador del sub-tab

            // Lista "quitadas" (bloque Restaurar). Miniatura desde el reco si es foto propia, o por mediaId si
            // era una asignada de otro dorsal. _reco marca cómo restaurar (reco → solo quitar de unassigned).
            profile.removedPhotos = [];
            profile._removedShown = 0; // se renderiza/resuelve por LOTES al desplegar (evita el pico de 68 img/llamadas)
            unassignedRaw.forEach(function (x) {
                var ca = photoEntryCreatedAt(x);
                if (!ca) { return; }
                var mid = photoEntryMediaId(x);
                var m = map[ca];
                if (m) {
                    var img = constructImage(m);
                    img._reco = true;
                    profile.removedPhotos.push(img);
                } else {
                    // Miniatura NO resuelta aún: se pide por mediaId solo cuando su lote se hace visible (showMoreRemoved).
                    profile.removedPhotos.push({ mediaId: mid, media_id: mid, createdAt: ca, created_at: ca, preview: null,
                        tags: [], loadingThumb: false, createdAtTransform: transformDate(ca), _reco: false });
                }
            });
        }

        // "Fotos quitadas": render/resolución por LOTES (no las 68 de golpe → sin pico de imágenes ni de getMediaIdPablo).
        function toggleRemoved(profile) {
            profile._showRemoved = !profile._showRemoved;
            if (profile._showRemoved && !(profile._removedShown > 0)) {
                showMoreRemoved(profile);
            }
        }

        function showMoreRemoved(profile) {
            var step = 12;
            var start = profile._removedShown || 0;
            var end = Math.min(start + step, (profile.removedPhotos || []).length);
            for (var i = start; i < end; i++) {
                var r = profile.removedPhotos[i];
                if (r && !r.preview && !r._reco && !r.loadingThumb && (r.mediaId || r.media_id)) {
                    resolveStubThumb(r, r.mediaId || r.media_id); // resuelve la miniatura solo del lote visible
                }
            }
            profile._removedShown = end;
        }

        // Galería principal del perfil: MISMO lote que "fotos quitadas". Pintaba p.photos entera
        // de una vez y con dorsales de cientos de fotos la pestaña se quedaba inutilizable: el
        // hilo principal se satura, el scroll da tirones y Chrome empieza a avisar de listeners
        // de touchstart que no puede cancelar. Aquí no hay que resolver miniaturas (ya vienen de
        // constructImage), solo limitar el DOM, así que el lote puede ser mayor que el de 12.
        var PROFILE_PHOTOS_PAGE = 60;

        function showMorePhotos(profile) {
            var total = (profile.photos || []).length;
            profile._photosShown = Math.min((profile._photosShown || 0) + PROFILE_PHOTOS_PAGE, total);
        }
        vm.showMorePhotos = showMorePhotos;

        function renameRunnerProfile(profile, $event) {
            var prompt = $mdDialog.prompt()
                .title($translate.instant('RUNTAG.PROFILES.RENAME_TITLE'))
                .textContent($translate.instant('RUNTAG.PROFILES.RENAME_TEXT', { label: runnerProfileLabel(profile) }))
                .placeholder($translate.instant('RUNTAG.PROFILES.NAME_PLACEHOLDER'))
                .initialValue(profile.name || '')
                .targetEvent($event)
                .ok($translate.instant('RUNTAG.PROFILES.SAVE'))
                .cancel($translate.instant('RUNTAG.PROFILES.CANCEL'))
                .css('runner-profile-dialog');
            $mdDialog.show(prompt).then(function (name) {
                name = (name || '').trim().slice(0, 40);
                if (!name) { return; } // vacío = no hacer nada (nunca borra el perfil ni el nombre)
                setRunnerProfileName(profile.dorsal, name)
                    .then(function () { profile.name = name; })
                    .catch(function () { $log.error('No se pudo guardar el nombre del perfil'); });
            });
        }

        function setRunnerProfileName(dorsal, name) {
            if (!_runnerProfilesUserParams) { return $q.reject(); }
            var eds = _runnerProfilesUserParams.events_data =
                (angular.isArray(_runnerProfilesUserParams.events_data) ? _runnerProfilesUserParams.events_data : []);
            var idx = -1;
            for (var i = 0; i < eds.length; i++) {
                if (eds[i] && eds[i].event_group_id === vm.selectedGroup.id_user_group) { idx = i; break; }
            }
            if (idx === -1) {
                eds.push({ event_group_id: vm.selectedGroup.id_user_group, number: vm.runnerProfileOwnNumber || '' });
                idx = eds.length - 1;
            }
            _runnerProfilesGroupEntry = eds[idx];
            if (!_runnerProfilesGroupEntry.profile_names || angular.isArray(_runnerProfilesGroupEntry.profile_names)) {
                _runnerProfilesGroupEntry.profile_names = {};
            }
            _runnerProfilesGroupEntry.profile_names[dorsal] = name;
            return RuntagRunnerService.updateUserParams($scope.siteID, vm.selectedUser.id_user, _runnerProfilesUserParams);
        }

        function deleteRunnerProfile(profile, $event) {
            var textKey = profile.is_primary ? 'RUNTAG.PROFILES.DELETE_PRIMARY_TEXT' : 'RUNTAG.PROFILES.DELETE_TEXT';
            var confirm = $mdDialog.confirm()
                .title($translate.instant('RUNTAG.PROFILES.DELETE_TITLE'))
                .textContent($translate.instant(textKey, { label: runnerProfileLabel(profile) }))
                .targetEvent($event)
                .ok($translate.instant('RUNTAG.PROFILES.DELETE'))
                .cancel($translate.instant('RUNTAG.PROFILES.CANCEL'))
                .css('runner-profile-dialog');
            $mdDialog.show(confirm).then(function () {
                var steps = [];
                if (profile.id_orders) {
                    steps.push(RuntagRunnerService.deleteOrders($scope.siteID, [profile.id_orders]));
                }
                steps.push(cleanRunnerProfileMeta(profile.dorsal, profile.is_primary));
                $q.all(steps)
                    .then(function () {
                        vm.runnerProfiles = vm.runnerProfiles.filter(function (p) { return p !== profile; });
                        vm.runnerProfiles.forEach(function (p, i) { p.profileNumber = i + 1; });
                        vm.runnerProfileIndex = 0;
                        if (vm.runnerProfiles.length) { selectRunnerProfile(0); }
                    })
                    .catch(function () { loadRunnerProfiles(true); });
            });
        }

        function cleanRunnerProfileMeta(dorsal, isPrimary) {
            if (!_runnerProfilesUserParams || !_runnerProfilesGroupEntry) { return $q.resolve(); }
            ['profile_names', 'profile_faces', 'profile_face_sources'].forEach(function (k) {
                if (_runnerProfilesGroupEntry[k] && !angular.isArray(_runnerProfilesGroupEntry[k])) {
                    delete _runnerProfilesGroupEntry[k][dorsal];
                }
            });
            if (isPrimary) {
                // Borrar el perfil principal quita también el dorsal propio del usuario en el evento.
                delete _runnerProfilesGroupEntry.number;
                vm.runnerProfileOwnNumber = null;
            }
            return RuntagRunnerService.updateUserParams($scope.siteID, vm.selectedUser.id_user, _runnerProfilesUserParams);
        }

        // ───────── crear perfil por dorsal (como el frontend: busca las fotos y crea la orden) ─────────

        function runnerProfileToast(key) {
            $mdToast.show($mdToast.simple().textContent($translate.instant(key)).position('top right').hideDelay(3500));
        }

        function addRunnerProfileByDorsal($event) {
            if (!vm.selectedUser || !vm.selectedGroup) { return; }
            var prompt = $mdDialog.prompt()
                .title($translate.instant('RUNTAG.PROFILES.ADD_TITLE'))
                .textContent($translate.instant('RUNTAG.PROFILES.ADD_TEXT'))
                .placeholder($translate.instant('RUNTAG.PROFILES.ADD_PLACEHOLDER'))
                .targetEvent($event)
                .ok($translate.instant('RUNTAG.PROFILES.ADD'))
                .cancel($translate.instant('RUNTAG.PROFILES.CANCEL'))
                .css('runner-profile-dialog');
            $mdDialog.show(prompt).then(function (dorsal) {
                dorsal = (dorsal || '').trim();
                if (!dorsal) { return; } // vacío = no hacer nada
                createRunnerProfile(dorsal, function () { return fetchAllRunnerProfileMedia(dorsal, 300); });
            });
        }

        // Por cara: reutiliza el modal de búsqueda por cara (sube la foto → detecta faceId → busca).
        function addRunnerProfileByFace($event) {
            if (!vm.selectedUser || !vm.selectedGroup) { return; }
            $mdDialog.show({
                controller: 'searchByFaceModalController',
                controllerAs: 'vm',
                locals: {
                    siteID: $scope.siteID,
                    event: vm.selectedGroup,
                    section: $scope.section,
                    apiUrl: vm.apiUrl
                },
                templateUrl: 'app/main/apps/runtag/event/dialogs/media/search-by-face-modal.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                multiple: true,
                targetEvent: $event,
                onShowing: function (scope, element) { element.addClass('new-event-modal'); },
                fullscreen: true
            }).then(function (result) {
                if (result && result.action === 'search_completed' && result.faceId) {
                    createRunnerProfile('face:' + result.faceId, function () {
                        return fetchAllFaceProfileMedia(result.faceId, 300);
                    });
                }
            });
        }

        // Crear un perfil (dorsal real o "face:<id>") trayendo sus fotos con fetchFn → {items, tooMany}.
        function createRunnerProfile(dorsalKey, fetchFn) {
            for (var i = 0; i < vm.runnerProfiles.length; i++) {
                if (String(vm.runnerProfiles[i].dorsal) === dorsalKey) {
                    runnerProfileToast('RUNTAG.PROFILES.ADD_EXISTS');
                    selectRunnerProfile(i);
                    return;
                }
            }
            vm.runnerProfilesLoading = true;
            fetchFn()
                .then(function (result) {
                    if (result.tooMany) { runnerProfileToast('RUNTAG.PROFILES.ADD_TOO_MANY'); return $q.reject('skip'); }
                    if (!result.items.length) { runnerProfileToast('RUNTAG.PROFILES.ADD_NO_PHOTOS'); return $q.reject('skip'); }
                    return RuntagRunnerService.createOrder($scope.siteID, buildAssignedProfileOrder(dorsalKey, result.items));
                })
                .then(function () {
                    runnerProfileToast('RUNTAG.PROFILES.ADD_CREATED');
                    loadRunnerProfiles(true);
                })
                .catch(function (e) {
                    if (e !== 'skip') { runnerProfileToast('RUNTAG.PROFILES.ADD_ERROR'); }
                })
                .finally(function () { vm.runnerProfilesLoading = false; });
        }

        /** Fotos de una cara (find_related_faces) → items {id, created_at}. */
        function fetchAllFaceProfileMedia(faceId, cap) {
            return RuntagEventService.searchByFacePablo({ apiUrl: vm.apiUrl, version: vm.eventVersion, faceId: faceId })
                .then(function (results) {
                    var arr = angular.isArray(results) ? results : ((results && results.data) || []);
                    var items = [];
                    arr.forEach(function (m) {
                        var createdAt = m && (m.createdAt || m.created_at);
                        if (createdAt) {
                            items.push({ id: String((m.mediaId || m.media_id) || ''), created_at: String(createdAt) });
                        }
                    });
                    return { items: items, tooMany: items.length > cap };
                });
        }

        /** Orden assigned_profile con la misma forma que crea el frontend (upsertAssignedProfileItems). */
        function buildAssignedProfileOrder(dorsal, items) {
            var u = vm.selectedUser;
            return {
                id_subsec: 2, // approved
                user_id: u.id_user,
                user_name: ((u.firstname || '') + ' ' + (u.lastname || '')).trim(),
                user_email: u.email,
                id_event: vm.selectedGroup.id_events,
                id_client: vm.selectedGroup.id_client,
                price: 0,
                items_total: items.length,
                created_at: $filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss', 'UTC'),
                files: { type: 'assigned_profile', dorsal: dorsal, items: items }
            };
        }

        /** Pagina mediaFiles/runner/{dorsal} acumulando {id, created_at}; corta si supera el tope. */
        function fetchAllRunnerProfileMedia(number, cap) {
            var items = [];
            function page(key) {
                return RuntagEventService.getUserMediasPablo({
                    apiUrl: vm.apiUrl, number: number, limit: 100, sort: 'DESC', pagingKey: key || ''
                }).then(function (res) {
                    var data = (res && res.data) || (res && res.items) || [];
                    data.forEach(function (m) {
                        var createdAt = m && (m.createdAt || m.created_at);
                        if (createdAt) {
                            items.push({ id: String((m.mediaId || m.media_id) || ''), created_at: String(createdAt) });
                        }
                    });
                    if (items.length > cap) { return { items: items, tooMany: true }; }
                    var next = res && res.LastEvaluatedKey;
                    if (next) { return page(next); }
                    return { items: items, tooMany: false };
                });
            }
            return page('');
        }

        // Un evento es "de carrito" si su event_info tiene cart.enabled (mismo criterio que el
        // dashboard web: checkAtEventInfo('cart.enabled')). event_info puede venir como string
        // JSON o como objeto (según cómo lo sirva getSection). Se calcula 1 vez al cargar el
        // evento (vm.cartEnabled) para no parsear en cada digest.
        function isCartEvent(event) {
            if (!event || !event.event_info) { return false; }
            var info = event.event_info;
            if (typeof info === 'string') {
                try { info = JSON.parse(info); } catch (e) { return false; }
            }
            return !!(info && info.cart && info.cart.enabled);
        }

        // ¿El evento usa selección de cara (profileFaceSelection)? En esos eventos la web del corredor resuelve
        // SU perfil por la cara elegida, no por el dorsal → el admin debe ver exactamente lo mismo.
        function isFaceSelectionEvent(event) {
            if (!event || !event.event_info) { return false; }
            var info = event.event_info;
            if (typeof info === 'string') {
                try { info = JSON.parse(info); } catch (e) { return false; }
            }
            return !!(info && info.profileFaceSelection && info.profileFaceSelection.enabled);
        }

        /**
         * Desglose de ventas para EVENTOS DE CARRITO. Todas las compras se registran con un MISMO producto
         * genérico, así que la tabla SALES estándar (agrupada por id_product) las mete todas en una fila.
         * Aquí reconstruimos las VENTAS POR PRODUCTO DE REFERENCIA a partir del PRECIO de cada orden:
         *   - Se piden las órdenes pagadas (id_subsec=2) agrupadas por price (getSection groupBy) → como todas
         *     las de un mismo precio valen igual, nº de órdenes = suma_del_grupo / precio.
         *   - Cada precio se descompone en los productos de referencia del evento (denominaciones):
         *       · pack "todas las fotos" (items_total vacío): precio múltiplo de su valor → N packs (varios perfiles).
         *       · resto: combinación mínima de los tramos por-foto (p.ej. 1 foto=130, 3 fotos=299) que sume el precio.
         *   - Lo que no encaja va a "otras/no clasificadas" (no se pierde del total).
         * Todo en el FRONT (usa qiu-api, ya autenticado como admin; no toca backend). El nº de unidades es una
         * aproximación (el carrito no siempre agrupa óptimo) pero el INGRESO por producto es exacto
         * (unidades × precio unitario) y el total cuadra con la tabla de arriba.
         */
        function loadCartSalesBreakdown(event, products) {
            vm.cartSales = null;
            if (!event || !vm.cartEnabled) { return; }

            // Denominaciones = productos de referencia del evento.
            var allPacks = [];   // packs "todas las fotos" (items_total vacío)
            var tiers = [];      // tramos por-foto (items_total definido)
            (products || []).forEach(function (p) {
                var price = parseFloat(p.price_total != null ? p.price_total : p.price);
                if (!(price > 0)) { return; }
                var entry = {
                    id: p.id_products,
                    label: (p.product || p.product_label || '').toString(),
                    price: price,
                    currency: p.currency_code || '',
                    inactive: (p.onoff !== undefined && p.onoff !== null) ? !parseInt(p.onoff, 10) : false
                };
                var it = p.items_total;
                if (it === null || it === undefined || it === '') {
                    allPacks.push(entry);
                } else {
                    entry.items_total = parseInt(it, 10);
                    tiers.push(entry);
                }
            });
            // Packs de "todas las fotos": puede haber VARIOS (la preventa, la preventa externa, el normal…).
            // Se prueban TODOS, de mayor a menor precio; antes se cogía solo el más barato y las ventas del
            // resto no encajaban en ningún sitio → se iban a "otras/no clasificadas" (evento 884: 198 ventas,
            // entre ellas las 128 del pack activo de 749).
            var packDenoms = allPacks.slice().sort(function (a, b) { return b.price - a.price; });
            var tierDenoms = tiers.slice().sort(function (a, b) { return b.price - a.price; });
            if (packDenoms.length === 0 && tierDenoms.length === 0) { return; }
            // Para descomponer importes que no son múltiplo exacto de un pack valen las dos cosas
            // (p.ej. pack de todas + una foto suelta).
            var comboDenoms = packDenoms.concat(tierDenoms).sort(function (a, b) { return b.price - a.price; });

            var acc = {}; // id -> {id,label,price,currency,units,revenue,usd}
            function accEntry(entry) {
                var k = String(entry.id);
                if (!acc[k]) {
                    acc[k] = {
                        id: entry.id, label: entry.label, price: entry.price, currency: entry.currency,
                        inactive: !!entry.inactive, units: 0, revenue: 0, usd: 0
                    };
                }
                return acc[k];
            }
            // TODOS los productos del evento tienen fila, aunque no hayan vendido nada: ocultar un producto
            // con 0 ventas hace pensar que no existe.
            comboDenoms.forEach(accEntry);

            function bump(entry, units, usd) {
                if (!entry || !units) { return; }
                var k = String(entry.id);
                accEntry(entry);
                acc[k].units += units;
                acc[k].revenue += units * entry.price;
                acc[k].usd += usd || 0;
            }

            vm.loadingCartSales = true;

            // Pagos MANUALES (admin) van en una línea aparte —igual que en la tabla SALES de arriba— y NO se
            // descomponen en productos; el resto (pasarela) sí. Solo se separan si podemos aislar la pasarela
            // (hay método manual Y al menos otro método): si no, todo se descompone junto (sin doble conteo).
            var manualMethod = (vm.paymentMethods || []).find(function (m) { return (m.name || '').toLowerCase() === 'manual'; });
            var manualId = manualMethod ? manualMethod.id : null;
            var nonManualIds = (vm.paymentMethods || [])
                .filter(function (m) { return m.id !== manualId; })
                .map(function (m) { return m.id; });
            var separateManual = !!manualId && nonManualIds.length > 0;

            var baseFilters = [
                { field: 'id_event', values: [event.id_events] },
                { field: 'id_subsec', values: [2] } // solo pagadas
            ];
            // Dos agregaciones por precio: importe local (nº de órdenes = suma/precio, y el ingreso) y la
            // conversión a USD ya calculada en cada orden. El USD se reparte por producto a prorrata de la
            // descomposición → el total USD cuadra con la tabla de arriba.
            function qOrders(extraFilters, sumField) {
                return RuntagService.getSection({
                    domain: $scope.siteID,
                    section: 'orders',
                    filters: baseFilters.concat(extraFilters || []),
                    resultSumField: sumField,
                    groupBy: 'price',
                    sumPerGroup: true
                });
            }
            var mainPmFilter = separateManual ? [{ field: 'id_payment_method', values: nonManualIds }] : [];
            var calls = {
                local: qOrders(mainPmFilter, 'price'),
                usd: qOrders(mainPmFilter, 'usd')
            };
            if (separateManual) {
                var manualPmFilter = [{ field: 'id_payment_method', values: [manualId] }];
                calls.manualLocal = qOrders(manualPmFilter, 'price');
                calls.manualUsd = qOrders(manualPmFilter, 'usd');
            }

            function aggregateByPrice(localSums, usdSums, onGroup) {
                var usdByPrice = {};
                (usdSums || []).forEach(function (g) { usdByPrice[String(parseFloat(g.price))] = parseFloat(g.sum) || 0; });
                (localSums || []).forEach(function (g) {
                    var price = parseFloat(g.price);
                    var localSum = parseFloat(g.sum);
                    if (isNaN(price) || isNaN(localSum) || price <= 0) { return; } // gratis/cortesía: fuera del desglose
                    var count = Math.round(localSum / price);
                    if (count <= 0) { return; }
                    onGroup(price, localSum, count, usdByPrice[String(price)] || 0);
                });
            }

            $q.all(calls).then(function (res) {
                var anomalies = { orders: 0, revenue: 0, usd: 0 };
                var totalOrders = 0, totalRevenue = 0, totalUsd = 0;

                aggregateByPrice((res.local && res.local.sums) || [], (res.usd && res.usd.sums) || [], function (price, localSum, count, usdSum) {
                    totalOrders += count;
                    totalRevenue += localSum;
                    totalUsd += usdSum;
                    // 1) pack "todas las fotos" (y múltiplos = varios perfiles en una orden). Se prueban
                    //    todos los packs del evento, del más caro al más barato: así el importe se explica
                    //    con el menor nº de packs y no se confunde con otro más barato que también divida.
                    var matchedPack = null;
                    for (var pi = 0; pi < packDenoms.length; pi++) {
                        if (Math.abs(price % packDenoms[pi].price) < 0.01) { matchedPack = packDenoms[pi]; break; }
                    }
                    if (matchedPack) {
                        bump(matchedPack, Math.round(price / matchedPack.price) * count, usdSum);
                        return;
                    }
                    // 2) combinación mínima de productos (tramos por-foto Y packs: p.ej. todas + 1 suelta).
                    //    USD a prorrata del precio.
                    var combo = decomposeAmount(price, comboDenoms);
                    if (combo) {
                        combo.forEach(function (c) {
                            bump(c.entry, c.count * count, usdSum * ((c.entry.price * c.count) / price));
                        });
                        return;
                    }
                    // 3) no encaja → anomalía (se conserva en el total)
                    anomalies.orders += count;
                    anomalies.revenue += localSum;
                    anomalies.usd += usdSum;
                });

                // Pagos manuales: línea aparte (sin descomponer), incluida en el total.
                var manual = null;
                if (separateManual) {
                    var m = { orders: 0, revenue: 0, usd: 0 };
                    aggregateByPrice((res.manualLocal && res.manualLocal.sums) || [], (res.manualUsd && res.manualUsd.sums) || [], function (price, localSum, count, usdSum) {
                        m.orders += count; m.revenue += localSum; m.usd += usdSum;
                    });
                    if (m.orders > 0) {
                        manual = m;
                        totalOrders += m.orders;
                        totalRevenue += m.revenue;
                        totalUsd += m.usd;
                    }
                }

                var rows = Object.keys(acc).map(function (k) { return acc[k]; })
                    .sort(function (a, b) { return b.revenue - a.revenue; });

                // La columna UNITS del pie suma EXACTAMENTE lo que se ve en las filas. Antes mostraba
                // totalOrders (nº de órdenes pagadas) mientras las filas contaban unidades de producto, así
                // que no cuadraba (336 frente a 381: una orden de 298 son 2 unidades de "1 FOTO"). Las filas
                // "Other" y "Manual" no se descomponen, así que ahí la cifra son órdenes.
                var totalUnits = rows.reduce(function (sum, r) { return sum + r.units; }, 0)
                    + anomalies.orders + (manual ? manual.orders : 0);
                vm.cartSales = {
                    rows: rows,
                    anomalies: anomalies,
                    manual: manual,
                    totalOrders: totalOrders, // nº de órdenes pagadas (no se pinta: el pie muestra unidades)
                    totalUnits: totalUnits,
                    totalRevenue: totalRevenue,
                    totalUsd: totalUsd,
                    currency: (rows[0] && rows[0].currency) || (comboDenoms[0] && comboDenoms[0].currency) || ''
                };
                vm.loadingCartSales = false;
            }).catch(function (err) {
                $log.error('Error building cart sales breakdown', err);
                vm.loadingCartSales = false;
                vm.cartSales = null;
            });
        }

        /**
         * Descompone un importe en la MENOR cantidad de "monedas" de las denominaciones dadas (min-coins DP).
         * denoms: [{ ..., price }]. Devuelve [{entry, count}] o null si no hay combinación exacta.
         */
        function decomposeAmount(amount, denoms) {
            amount = Math.round(amount);
            if (!denoms || denoms.length === 0 || amount <= 0 || amount > 100000) { return null; }
            var prices = denoms.map(function (d) { return Math.round(d.price); });
            var dp = new Array(amount + 1).fill(Infinity);
            var pick = new Array(amount + 1).fill(-1);
            dp[0] = 0;
            for (var a = 1; a <= amount; a++) {
                for (var i = 0; i < prices.length; i++) {
                    var p = prices[i];
                    if (p > 0 && p <= a && dp[a - p] + 1 < dp[a]) { dp[a] = dp[a - p] + 1; pick[a] = i; }
                }
            }
            if (dp[amount] === Infinity) { return null; }
            var counts = {};
            var rem = amount;
            while (rem > 0) {
                var idx = pick[rem];
                if (idx < 0) { return null; }
                counts[idx] = (counts[idx] || 0) + 1;
                rem -= prices[idx];
            }
            return Object.keys(counts).map(function (idx) { return { entry: denoms[idx], count: counts[idx] }; });
        }

        function resetSearchByFace() {
            vm.searchedItems = [];
            // Si la búsqueda se lanzó desde otra pestaña (p.ej. Perfiles), volver a ella directamente — sin recargar
            // la media (era lo que tardaba y dejaba la vista en 'media').
            var from = vm._searchFromTemplate;
            vm._searchFromTemplate = null;
            if (vm.selectedUser && from && from !== 'media') {
                changeTemplate(from);
                return;
            }
            // If in user context, just clear search results and show user's photos again
            if (!vm.selectedUser) {
                vm.view = "app/main/apps/runtag/event/views/templates/events-all-media.html";
                resetMediaPagination();
                fetchMediaPage(null);
            }
        }

        function resetMediaPagination() {
            vm.mediaPagination.history = [null];
            vm.mediaPagination.currentIndex = 0;
            vm.mediaPagination.hasNext = false;
            vm.mediaPagination.total = 0;
        }

        async function selectUser(user) {
            vm.items = [];
            vm.searchedItems = [];
            vm._runnerProfilesLoadedFor = null; // fuerza recarga de perfiles para el nuevo usuario
            vm._matchedProfileConsumedFor = null; // el perfil buscado se abre en la 1ª carga de este usuario
            vm.runnerProfiles = [];
            vm._userPaidDownloadCAs = [];
            if (!$rootScope.reloadUser) {
                changeTemplate('info');
            }
            if ($rootScope.changeView) {
                changeTemplate($rootScope.changeView);
                delete ($rootScope.changeView);
            }
            vm.mediaDetectedText = undefined;
            vm.mediaDetectedFace = undefined;
            vm.mediaTemplate = undefined;
            vm.userShoppings = [];
            vm.userDownloads = [];
            vm.userZipDownloads = [];
            vm.loadingZipDownloads = true;

            // Auto-heal corrupted user_params
            if (user._corrupted) {
                console.log('User is marked as corrupted, auto-fixing in DB...');
                vm.selectedUser = user; // Ensure it's selected first
                vm.infoUserView('edit'); // This initializes vm.userCopy correctly
                delete vm.userCopy._corrupted;
                $timeout(() => {
                    vm.saveUser();
                    delete user._corrupted;
                }, 500);
            }

            vm.selectedUser = user;

            // Llegó de una búsqueda por dorsal en un evento de CARRITO: lo que quiere ver el admin es ese
            // perfil, no la ficha. changeTemplate('profiles') dispara loadRunnerProfiles, que ya abre el
            // perfil buscado (matchedProfileIndex).
            if (vm.cartEnabled && user.matchedProfileNumber && !$rootScope.changeView) {
                changeTemplate('profiles');
            }

            var optionsOrders = {
                siteID: $scope.siteID,
                filters: [
                    {
                        field: 'user_id',
                        name: 'User id',
                        values: [user.id_user]
                    }
                ]
            };
            RuntagEventService.getOrders(optionsOrders).then(function (response) {
                vm.userShoppings = [];
                response.result.data.forEach(data => {
                    // Las órdenes "recolectadas" (perfiles añadidos, id_subsec=7) NO son compras: no se listan.
                    if (data.id_subsec == 7) { return; }
                    if (data.id_event == vm.selectedGroup.id_events) {
                        vm.userShoppings.push(data);
                    }
                });
                vm.failedTransactions = 0;
                if (vm.userShoppings.length > 0) {
                    for (var i = 0; i < vm.userShoppings.length; i++) {
                        for (var x = 0; x < vm.paymentMethods.length; x++) {
                            if (vm.userShoppings[i].id_payment_method == vm.paymentMethods[x].id) {
                                vm.userShoppings[i].name_payment_method = vm.paymentMethods[x].name;
                            }
                        }
                        vm.userShoppings[i].payment_details = JSON.parse(vm.userShoppings[i].payment_details);
                        if (vm.userShoppings[i].id_subsec == 3 || vm.userShoppings[i].id_subsec == 4) {
                            vm.failedTransactions++;
                        }
                    }
                }
                markPurchasedMedias();
            });
            resetMediaPagination();
            vm.allUserMedias = []; // Limpiar caché local
            vm.actualView = 'user';

            await fetchMediaPage(null);

            var optionsDownloads = {
                domain: $scope.siteID,
                id_user: user.id_user,
                resultsPerPage: 500,
                id_event: vm.selectedGroup.id_events
            }
            RuntagEventService.getDownloads(optionsDownloads).then(function (responseDownloads) {
                // El id único de una foto es su created_at, NO el nombre de fichero: dentro de un mismo
                // evento el nombre se repite (p.ej. DSC04865.JPG puede ser 4 fotos de personas distintas).
                // Emparejar por nombre hacía que `find` devolviese la PRIMERA coincidencia, mostrando fotos
                // AJENAS como descargadas por el usuario, y el dedup por nombre además se comía descargas
                // legítimas de fotos homónimas. Se usa file_created_at y solo se cae al nombre en descargas
                // antiguas que no lo tengan guardado.
                const downloadKey = d => d && (d.file_created_at || d.filename);
                let results = responseDownloads.result.data.filter((item, index, self) =>
                    index === self.findIndex(t => downloadKey(t) === downloadKey(item))
                );
                vm.userDownloads = [];
                // Paid downloads (free_download=0) count as bought for the purchased marking (see computePurchaseSets).
                vm._userPaidDownloadCAs = results
                    .filter(d => d && d.file_created_at && d.free_download != null && String(d.free_download) === '0')
                    .map(d => d.file_created_at);
                results.forEach(download => {
                    let media = {};
                    if (vm.allUserMedias && vm.allUserMedias.length > 0) {
                        const ca = download.file_created_at;
                        switch (vm.eventVersion) {
                            case 'v2':
                            case 'v3':
                                media = ca
                                    ? vm.allUserMedias.find(x => sameCreatedAt(x.createdAt || x.created_at, ca))
                                    : vm.allUserMedias.find(x => x.mediaId == download.filename);
                                break;
                            default:
                                media = ca
                                    ? vm.allUserMedias.find(x => sameCreatedAt(x.createdAt || x.created_at, ca))
                                    : vm.allUserMedias.find(x => x.media_id == download.filename);
                                break;
                        }
                    }
                    if (media && media.mediaId) {
                        media.downloaded = download.created_at;
                        media.id_user_downloads = download.id_user_downloads;
                        vm.userDownloads.push(media);
                    } else {
                        download.unassignedDownload = true;
                        download.mediaId = download.filename;
                        download.createdAtTransform = download.created_at ? transformDate(download.created_at) : null;
                        vm.userDownloads.push(download);
                        // Resolver preview/datos (la foto no estaba en allUserMedias). Se pasa el created_at
                        // para poder distinguirla de otras fotos con el mismo nombre.
                        resolveDownloadThumb(download, download.filename, download.file_created_at);
                    }
                });
                markPurchasedMedias();
            });

            var optionsZipDownloads = {
                domain: $scope.siteID,
                filters: [
                    {
                        field: 'id_user',
                        name: 'ID User',
                        values: [user.id_user]
                    },
                    {
                        field: 'id_event',
                        name: 'ID Event',
                        values: [vm.selectedGroup.id_events]
                    }
                ]
            };
            RuntagEventService.getUserZipDownloads(optionsZipDownloads).then(function (response) {
                vm.userZipDownloads = response.result.data;

                // Cada ZIP trae media_ids (lista de filenames, p.ej. "078A0372.jpg") y,
                // en paralelo, created_at_files (fecha de cada foto). Las fotos de un ZIP
                // pueden ser de otros fotógrafos y no estar en las fotos cargadas del
                // corredor, así que las que falten se resuelven por filename vía API.
                var resolvedMedia = {};
                (vm.allUserMedias || []).forEach(function (m) {
                    if (m.mediaId) resolvedMedia[m.mediaId] = m;
                    if (m.media_id) resolvedMedia[m.media_id] = m;
                });

                function buildZipImages() {
                    vm.userZipDownloads.forEach(function (zip) {
                        var mediaIds = parseJsonField(zip.media_ids);
                        var createdAtFiles = parseJsonField(zip.created_at_files);
                        zip.images = mediaIds.map(function (filename, index) {
                            if (resolvedMedia[filename]) {
                                return resolvedMedia[filename];
                            }
                            return {
                                mediaId: filename,
                                unassignedDownload: true,
                                fileCreatedAt: createdAtFiles[index] || null
                            };
                        });
                    });
                }

                buildZipImages();
                vm.loadingZipDownloads = false;

                // Filenames del ZIP que no están entre las fotos ya cargadas (deduplicados
                // entre todos los packs para no repetir peticiones).
                var missing = {};
                vm.userZipDownloads.forEach(function (zip) {
                    parseJsonField(zip.media_ids).forEach(function (filename) {
                        if (filename && !resolvedMedia[filename]) {
                            missing[filename] = true;
                        }
                    });
                });

                var missingFilenames = Object.keys(missing);
                if (missingFilenames.length > 0) {
                    var fetches = missingFilenames.map(function (filename) {
                        return RuntagEventService.getMediaIdPablo({
                            apiUrl: vm.apiUrl,
                            version: vm.eventVersion,
                            mediaId: filename,
                            media_id: filename
                        }).then(function (mediaResponse) {
                            var item = angular.isArray(mediaResponse) ? mediaResponse[0] : mediaResponse;
                            if (item) {
                                resolvedMedia[filename] = constructImage(item);
                            }
                        }).catch(function () {
                            // Si falla se queda con el placeholder.
                        });
                    });
                    $q.all(fetches).then(function () {
                        buildZipImages();
                    });
                }
            }).catch(function () {
                vm.loadingZipDownloads = false;
            });

            const downloadsAssignOptions = {
                siteID: $scope.siteID,
                filters: [
                    {
                        field: 'id_user',
                        name: 'ID User',
                        values: [user.id_user]
                    },
                    {
                        field: 'id_event',
                        name: 'ID Event',
                        values: [vm.selectedGroup.id_events]
                    }
                ]
            };

            RuntagEventService.getAvailableDownloads(downloadsAssignOptions).then(function (response) {
                if (response && response.result && response.result.data && response.result.data.length) {
                    vm.availableDownloads = response.result.data[0];
                } else {
                    vm.availableDownloads = {
                        id_event: vm.selectedGroup.id_events,
                        id_user: user.id_user,
                        avaliable_assign: 0
                    }
                }
            });

            if (vm.currentTab != 'preview') {
                vm.currentTab = 'preview';
            }
        }

        function restoreRunnerFiles() {
            if (!vm.selectedUser || !vm.selectedGroup) return;

            // Set UI state of visible items to LOADING
            if (vm.items && vm.items.length) {
                vm.items.forEach(function (mediaItem) {
                    if (mediaItem.archiveStatus === "ARCHIVED") {
                        mediaItem.archiveStatus = "LOADING";
                    }
                });
            }

            let params = {
                user_id: vm.selectedUser.id_user,
                runner_number: vm.selectedUser.eventNumber ? vm.selectedUser.eventNumber.toString() : "",
                runner_email: vm.selectedUser.email,
                event_id: vm.selectedGroup.id_events,
                client_id: vm.selectedGroup.id_domain,
                template_id: vm.selectedGroup.id_media_template || 1, // Fallback common in this view
                event_name: vm.selectedGroup.name || vm.eventName
            };

            let options = {
                apiUrl: vm.apiUrl,
                params: params
            };

            RuntagEventService.restoreRunnerFiles(options).then(function (response) {
                $mdToast.show({
                    template: '<md-toast id="success" layout="column" layout-align="center center"><div class="md-toast-content bg-green-500"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>El proceso de restauración ha comenzado</span></div></md-toast>',
                    hideDelay: 5000,
                    position: 'top',
                    parent: '#content-container'
                });

                // Move from LOADING to PENDING state
                if (vm.items && vm.items.length) {
                    vm.items.forEach(function (mediaItem) {
                        if (mediaItem.archiveStatus === "LOADING") {
                            mediaItem.archiveStatus = "PENDING";
                        }
                    });
                }
            }).catch(function (error) {
                $log.error('Error in restoreRunnerFiles controller:', error);
                $mdToast.show({
                    template: '<md-toast id="error" layout="column" layout-align="center center"><div class="md-toast-content bg-red-500"><md-icon md-font-icon="icon-close" class="icon"></md-icon><span class="md-toast-text" flex>Error procesando la restauración</span></div></md-toast>',
                    hideDelay: 5000,
                    position: 'top',
                    parent: '#content-container'
                });

                // Rollback from LOADING to ARCHIVED on error
                if (vm.items && vm.items.length) {
                    vm.items.forEach(function (mediaItem) {
                        if (mediaItem.archiveStatus === "LOADING") {
                            mediaItem.archiveStatus = "ARCHIVED";
                        }
                    });
                }
            });
        }

        function hasArchivedPhotos() {
            if (!vm.items || !vm.items.length) return false;
            return vm.items.some(function (mediaItem) {
                return mediaItem.archiveStatus === "ARCHIVED";
            });
        }

        function selectUserFromEventList(user) {
            vm.isLoadingGroups = true;
            let newUser = user;
            if (newUser.user_params) {
                ensureParsed(newUser, 'user_params');
                newUser.eventNumber = newUser.user_params?.events_data?.find(x => x.event_group_id == vm.selectedGroup.id_user_group)?.number;
            } else {
                newUser.eventNumber = newUser.current_number;
            }
            vm.querySearch = newUser.email;
            filterUsers();
            setTimeout(() => {
                selectUser(newUser);
                vm.isLoadingGroups = false;
            }, 1000);
        }

        function infoUserView(view) {
            vm.currentTab = view;
            if (view == 'edit') {
                vm.userCopy = angular.copy(vm.selectedUser);
            }
        }

        function getCleanUsersGroup() {
            var opts = {
                siteID: $scope.siteID,
                withGroupType: true,
            };
            RuntagEventService.getUsersGroups(opts).then(function (response) {
                var qiuRestrictions = response.qiuRestrictions;
                if (qiuRestrictions && qiuRestrictions.hasOwnProperty('advanced_settings_access')) {
                    vm.hasAdvancedSettingsAccess = qiuRestrictions.advanced_settings_access.includes(true);
                }
                var groups = response.data;
                vm.allGroups = getFlatGroups(groups, []);
                vm.CleanUsersGroups = transformUsers.formatNestedGroups(groups, qiuRestrictions, true);
                groupsByRef();
                if (angular.isArray(vm.CleanUsersGroups) &&
                    vm.CleanUsersGroups.length > 0 &&
                    vm.CleanUsersGroups[0].is_qiu_restricted_root
                ) {
                    vm.isQiuRestricted = true;
                    vm.selectedGroup = vm.CleanUsersGroups[0];
                    vm.rootGroup = vm.CleanUsersGroups[0];
                }
                vm.flatGroups = getFlatGroups(vm.CleanUsersGroups, []);
                getEventsStats();
            });

        }

        function reset() {
            vm.filteredUsers = [];
            vm.isFiltered = false;
            vm.view = "app/main/apps/runtag/event/views/templates/events-template-v2.html";
            vm.groupUsers = undefined;
            vm.selectedUser = undefined;
            vm.querySearch = "";
        }

        // La búsqueda tarda (varias llamadas encadenadas) y antes no daba ninguna señal: parecía
        // colgada. La bandera se lleva AQUÍ, en el único punto de entrada, en vez de en cada una
        // de las cinco ramas; así no puede quedarse encendida porque a una se le olvide apagarla.
        // Requisito: cada filter* devuelve su promesa (si no, esto se apaga de inmediato).
        function setFilter() {
            var enCurso;
            vm.isSearching = true;
            switch (vm.typeOfSearch) {
                case "users":
                    enCurso = filterUsers();
                    break;
                case "photographers":
                    enCurso = filterPhotographers();
                    break;
                case "media":
                    enCurso = filterByMediaId();
                    break;
                case "locations":
                    enCurso = showAllMedia(true);
                    break;
            }
            return $q.when(enCurso).finally(function () { vm.isSearching = false; });
        }

        function searchByAvatar() {
            openSearchFaceModal();
        }

        function openSearchFaceModal() {
            $mdDialog.show({
                controller: 'searchByFaceModalController',
                controllerAs: 'vm',
                locals: {
                    siteID: $scope.siteID,
                    event: vm.selectedGroup,
                    section: $scope.section,
                    apiUrl: vm.apiUrl
                },
                templateUrl: 'app/main/apps/runtag/event/dialogs/media/search-by-face-modal.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                multiple: true,
                onShowing: function (scope, element) {
                    element.addClass('new-event-modal');
                },
                fullscreen: true
            }).then(function (result) {
                if (result && result.action === 'search_completed' && result.items) {
                    vm.searchedItems = result.items;
                    // Only change view if not inside a user context
                    if (!vm.selectedUser) {
                        vm.view = "app/main/apps/runtag/event/views/templates/events-all-media.html";
                    }
                }
            }, function () {
                $log.warn('Modal cancelado');
            });
        }

        function filterByMediaId(location) {
            if (vm.querySearch) {
                var options = {
                    apiUrl: vm.apiUrl
                }
                switch (vm.eventVersion) {
                    case 'v2':
                        options.version = vm.eventVersion;
                        options.mediaId = vm.querySearch;
                        break;
                    case 'v3':
                        options.version = vm.eventVersion;
                        options.mediaId = vm.querySearch;
                        break;
                    default:
                        options.media_id = vm.querySearch;
                        break;
                }
                vm.loadingMore = true;
                return RuntagEventService.getMediaIdPablo(options).then(function (response) {
                    if (response.length > 0) {
                        vm.lastItem = false;
                        vm.fullPage = true;
                        vm.view = "app/main/apps/runtag/event/views/templates/events-search-media.html";
                        vm.items = [];
                        vm.items = response;
                        angular.forEach(vm.items, function (item) {
                            item = constructImage(item);
                        });
                        // Búsqueda por nombre = lookup directo de UNA foto (mediaFiles/{mediaId}), no un listado
                        // paginado. Hay que resetear el paginado: si no, conservaba la página/hasNext del navegado
                        // anterior, el paginador mostraba "página N" con "siguiente" activo y al pulsarlo
                        // fetchMediaPage recargaba el listado normal → el paginado se volvía loco.
                        resetMediaPagination();
                        vm.mediaPagination.total = vm.items.length;
                        vm.lastItem = false; // no hay LastEvaluatedKey en un lookup por id
                        vm.actualView = 'all';
                    } else {
                        $mdToast.show({
                            template: '<md-toast id="error" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-close" class="icon"></md-icon><span class="md-toast-text" flex>No results</span></div></md-toast>',
                            hideDelay: 5000,
                            position: 'top',
                            parent: '#content-container'
                        });
                    }
                    vm.querySearch = "";
                    vm.loadingMore = false;
                }).catch(function (error) {
                    $log.error("Error fetching media:", error);
                    vm.loadingMore = false;
                    $mdToast.show({
                        template: '<md-toast id="error" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-close" class="icon"></md-icon><span class="md-toast-text" flex>No results</span></div></md-toast>',
                        hideDelay: 5000,
                        position: 'top',
                        parent: '#content-container'
                    });
                });
            }
        }

        // A bib is always a single token without "@" (001, P1, SD…, unknown_…, face:…). Anything else
        // (an email, "first last") cannot match a profile, so the profileNumber request is skipped.
        function mayBeProfileNumber(term) {
            return !/[@\s]/.test(term);
        }

        /**
         * Merges the two lookups of the unified user search without duplicating users. Bib matches go
         * first and carry `matchedProfileNumber`: in CART events the matched profile may be a collected or
         * bought one (it lives in the order, not in events_data), so the list says which profile matched,
         * that profile opens when entering the user and the photo count uses that bib.
         *
         * Guard: an API without the profileNumber filter ignores it and returns the whole group; in that
         * case the bib lookup is discarded so it does not flood the text results.
         */
        function mergeUserSearchResults(textResponse, profileResponse, term) {
            var textUsers = (textResponse && textResponse.result && textResponse.result.data) || [];
            var profileResult = profileResponse && profileResponse.result;
            if (profileResult && vm.totalRunners > 1 && profileResult.total >= vm.totalRunners) {
                $log.warn('profileNumber filter returned the whole group; ignoring bib matches for', term);
                profileResult = null;
            }
            if (!profileResult || !profileResult.data) { return textUsers; }

            var seen = {};
            var merged = profileResult.data.map(function (user) {
                user.matchedProfileNumber = term;
                seen[user.id_user] = true;
                return user;
            });
            textUsers.forEach(function (user) {
                if (!seen[user.id_user]) { merged.push(user); }
            });
            return merged;
        }

        function filterPhotographers(photographer) {
            vm.isLoadingGroups = true;
            if (vm.querySearch || photographer) {
                vm.photographerFilter = photographer ? photographer.camera_name : vm.querySearch;
            }
            if (vm.photographerFilter) {
                resetMediaPagination();
                vm.actualView = 'photographers';
                return fetchMediaPage(null);
            } else {
                vm.isLoadingGroups = false;
            }
        }

        /**
         * Unified user search: one box for email, name and bib. The text filter (`search`: name/email
         * contains, current_number exact) always runs; when the term can be a bib, the profileNumber filter
         * (own bib in events_data, or a collected/bought profile in section_orders) runs in parallel and both
         * results are merged. An empty box goes back to the default event listing.
         */
        function filterUsers() {
            var term = String(vm.querySearch || '').trim();
            if (!term) {
                reset();
                return;
            }
            var baseOptions = {
                siteID: $scope.siteID,
                groupIds: vm.selectedGroup.id_user_group,
                section: $scope.section
            };
            var textLookup = usersService.getUsersByGroups(angular.extend({ searchStringFilter: term }, baseOptions));
            // A failing bib lookup must not hide the text matches.
            var profileLookup = mayBeProfileNumber(term)
                ? usersService.getUsersByGroups(angular.extend({ profileNumber: term }, baseOptions)).catch(function () { return null; })
                : $q.when(null);

            return $q.all([textLookup, profileLookup]).then(function (responses) {
                var users = mergeUserSearchResults(responses[0], responses[1], term);
                if (!users.length) {
                    var message = $translate.instant('RUNTAG.SEARCH_NO_RESULTS', { term: term });
                    $mdToast.show({
                        template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-close" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                        hideDelay: 5000,
                        position: 'top',
                        parent: '#content-container'
                    });
                    return;
                }
                users.forEach(user => {
                    if (user.user_params) {
                        ensureParsed(user, 'user_params');
                        user.eventNumber = user.user_params?.events_data?.find(x => x.event_group_id == vm.selectedGroup.id_user_group)?.number;
                    } else {
                        user.eventNumber = user.current_number;
                    }
                });
                vm.view = "app/main/apps/runtag/event/views/list/events-list.html";
                vm.isFiltered = true;
                vm.filteredUsers = users;
                vm.querySearch = "";
                vm.selectedUser = undefined;
                if (vm.selectedEvent && vm.selectedEvent.version != 'v2' && vm.selectedEvent.version != 'V2') {
                    const runnerNumbers = extractRunnerNumbers(users);
                    RuntagEventService.getRunnerTotals({
                        apiUrl: vm.apiUrl,
                        runner_numbers: runnerNumbers
                    }).then(resp => {
                        if (resp && resp.runners) {
                            users.forEach(u => {
                                const number = extractRunnerNumbers([u])[0];
                                u.totalPhotos = resp.runners[number] || 0;
                            });
                        }
                    });
                }
            });
        }

        function formatDate(date, format) {
            var dateObject = new Date(date);
            return $filter('date')(dateObject, format);
        }

        function getUsers(reload) {
            vm.loadingMoreUsers = true;
            usersService.getUsersByGroups({
                siteID: $scope.siteID,
                groupIds: vm.selectedGroup.id_user_group,
                section: $scope.section,
                sortField: vm.usersOrder,
                sortDir: vm.usersSort,
                page: vm.moreUsersParams && !reload ? vm.moreUsersParams.current_page + 1 : undefined,
                withSections: ['orders', 'user_downloads'],
                searchWithUserParams:
                {
                    "user_params": {
                        "event_group_id": vm.selectedGroup.id_user_group
                    }
                },
                customSectionGroupBy:
                {
                    "user_downloads": ['id_user', 'file_created_at']
                }
            }).then((response) => {
                if (vm.moreUsersParams && !reload) {
                    vm.usersArray = vm.usersArray.concat(response.result.data);
                } else {
                    vm.usersArray = response.result.data;
                }

                const runnerNumbers = extractRunnerNumbers(response.result.data);
                RuntagEventService.getRunnerTotals({
                    apiUrl: vm.apiUrl,
                    runner_numbers: runnerNumbers
                }).then(resp => {
                    if (resp && resp.runners) {
                        response.result.data.forEach(u => {
                            const number = extractRunnerNumbers([u])[0];
                            u.totalPhotos = resp.runners[number] || 0;
                        });
                    }
                });
                if (response.result.last_page != response.result.current_page) {
                    vm.moreUsersParams = {
                        total: response.result.total,
                        current_page: response.result.current_page
                    }
                } else {
                    vm.moreUsersParams = undefined;
                }
                vm.loadingMoreUsers = false;
            });
        }

        function checkUserOrders(user) {
            if (!user) return null;

            if (angular.isArray(user)) {
                user.forEach(function (u) {
                    u.orderStats = checkUserOrders(u);
                });
                return;
            }

            if (user.orderStats !== undefined) return user.orderStats;

            if (!user.orders || user.orders.length === 0) {
                user.orderStats = null;
                return null;
            }

            var counts = {};
            user.orders.forEach(function (o) {
                var id = o.id_subsec;
                // Estado 7 = recolectado (perfil asignado): no es una orden, no se muestra icono.
                if (id == 7) { return; }
                if (id) {
                    counts[id] = (counts[id] || 0) + 1;
                }
            });

            user.orderStats = Object.keys(counts).length > 0 ? counts : null;
            return user.orderStats;
        }

        /** Números (dorsales) detectados en una foto, para cruzar con packs "todas las fotos". */
        function mediaDetectedNumbers(m) {
            var out = [];
            (m.tags || []).forEach(function (t) {
                var n = (t.runnerNumber && t.runnerNumber.detectedText) ? t.runnerNumber.detectedText : t.detectedText;
                if (n) { out.push(String(n)); }
            });
            return out;
        }

        /**
         * Extrae de las compras aprobadas (vm.userShoppings, id_subsec=2) los conjuntos de "comprado".
         * Front-only, sin tocar qiu-api. Devuelve null si aún no hay órdenes cargadas.
         *   - allPhotosDorsals: dorsales con pack "todas las fotos" (profile_cart/mixed_cart, items_total=null).
         *   - boughtCreatedAts / boughtMediaIds: fotos sueltas compradas (files.photos[]/items[]).
         */
        function computePurchaseSets() {
            // OJO: la lista content/orders NO trae la columna `files`; los detalles completos (con files)
            // los descarga loadRunnerProfiles vía getOrderById y los guarda en vm._userFullOrders.
            var orders = vm._userFullOrders;
            if (!orders || !orders.length) { return null; }
            var boughtCreatedAts = {}, boughtMediaIds = {}, allPhotosDorsals = {};
            orders.forEach(function (o) {
                if (o.id_subsec != 2) { return; } // solo compras aprobadas (PAGADO)
                var f = o.files;
                if (angular.isString(f)) { try { f = JSON.parse(f); } catch (e) { f = null; } }
                if (!f) { return; }
                var type = f.type || '';
                if (type === 'assigned_profile') { return; } // recolección, no compra
                // El nombre de fichero NO identifica una foto: dentro de un mismo evento se repite
                // (DSC04504.JPG puede ser 5 fotos de personas distintas). Si se indexa por nombre
                // habiendo created_at, se marcan como compradas fotos AJENAS homónimas. Por eso el
                // nombre solo se usa como clave en compras antiguas que no guardaron el created_at.
                var addBought = function (entry) {
                    if (!entry) { return; }
                    var k = caKey(entry.created_at);
                    if (k) { boughtCreatedAts[k] = true; }
                    else if (entry.id) { boughtMediaIds[String(entry.id)] = true; }
                };
                if (type === 'profile_cart' || type === 'mixed_cart') {
                    (f.runners || []).forEach(function (r) {
                        if (r && r.dorsal != null && (r.items_total === null || r.items_total === undefined)) {
                            allPhotosDorsals[String(r.dorsal)] = true;
                        }
                    });
                    (f.photos || []).forEach(addBought);
                } else {
                    (f.items || []).forEach(addBought);
                }
            });
            // Same set the website marks as bought (CustomData::getCartPurchasedFiles → cartPurchasedFiles), which
            // is judged PER PHOTO: a photo of a whole-profile pack shows as bought in EVERY profile it appears in.
            // For each all-photos profile: its photos as the admin sees them (dorsal gallery / face union, once
            // loaded), the photos the admin added to it (assignedPhotos) and its download snapshot (profile_dl_auth).
            var entry = _runnerProfilesGroupEntry || {};
            var addCa = function (c) { var k = caKey(c); if (k) { boughtCreatedAts[k] = true; } };
            Object.keys(allPhotosDorsals).forEach(function (d) {
                groupPhotoList(entry, 'assignedPhotos', d).forEach(function (x) { addCa(photoEntryCreatedAt(x)); });
                var auth = (entry.profile_dl_auth && !angular.isArray(entry.profile_dl_auth)) ? entry.profile_dl_auth[d] : null;
                (angular.isArray(auth) ? auth : []).forEach(addCa);
            });
            (vm.runnerProfiles || []).forEach(function (p) {
                if (p && p.photosLoaded && allPhotosDorsals[String(p.dorsal)]) {
                    (p.photos || []).forEach(function (m) { addCa(m && (m.created_at || m.createdAt)); });
                }
            });
            // Photos already downloaded paying (free_download=0) also count as bought on the website.
            (vm._userPaidDownloadCAs || []).forEach(addCa);
            return { boughtCreatedAts: boughtCreatedAts, boughtMediaIds: boughtMediaIds, allPhotosDorsals: allPhotosDorsals };
        }

        // Fotos SUELTAS compradas de un dorsal (mixed_cart.photos[] + legacy sin type), como [{id, created_at}].
        // NO incluye el pack "todas las fotos" (eso es cobertura del dorsal entero, no fotos sueltas).
        function purchasedPhotosForDorsal(dorsal) {
            var out = [];
            var d = String(dorsal);
            (vm._userFullOrders || []).forEach(function (o) {
                if (!o || o.id_subsec != 2) { return; }
                var f = o.files;
                if (angular.isString(f)) { try { f = JSON.parse(f); } catch (e) { f = null; } }
                if (!f) { return; }
                var arr = (f.type === 'mixed_cart') ? f.photos : (!f.type && angular.isArray(f) ? f : null);
                (arr || []).forEach(function (p) {
                    if (p && String(p.dorsal) === d && (p.created_at || p.id)) {
                        out.push({ id: p.id || null, created_at: p.created_at || null });
                    }
                });
            });
            return out;
        }

        // ── Vista "Compras" enriquecida (solo eventos de carrito) ─────────────────────────────────
        // Descompone cada compra (orden con files de carrito) en su COBERTURA real: qué perfiles
        // (dorsales) cubre —pack "todas las fotos"— y qué fotos sueltas, con miniaturas (files.photos[].thumb).
        // Fuente: vm._userFullOrders (getOrderById trae la columna files; el listado no). Las recolecciones
        // (assigned_profile, id_subsec=7) NO son compras → se excluyen, igual que en el tab clásico.
        function shoppingProfileLabel(dorsal) {
            var d = String(dorsal == null ? '' : dorsal);
            if (!d) { return 'Sin perfil'; }
            if (d.indexOf('face:') === 0) { return 'Cara'; }
            if (d.indexOf('unknown_') === 0) { return 'Sin dorsal'; }
            var p = (vm.runnerProfiles || []).filter(function (x) { return String(x.dorsal) === d; })[0];
            if (p) { return runnerProfileLabel(p); }
            return '#' + d;
        }

        function buildShoppingView() {
            if (!vm.cartEnabled) { vm.shoppingOrders = []; vm.shoppingFailedCount = 0; return; }
            var orders = vm._userFullOrders || [];
            var out = [];
            orders.forEach(function (o) {
                if (!o) { return; }
                var f = o.files;
                if (angular.isString(f)) { try { f = JSON.parse(f); } catch (e) { f = null; } }
                var type = (f && !angular.isArray(f) && f.type) || '';
                if (type === 'assigned_profile') { return; } // recolección, no compra

                var byDorsal = {}; // dorsal -> { dorsal, label, allPhotos, thumbs:[] }
                function bucket(dorsal) {
                    var k = String(dorsal == null ? '' : dorsal);
                    if (!byDorsal[k]) {
                        // dorsalNumber: solo el dorsal "real" de reconocimiento (no cara/desconocido/vacío) → se muestra.
                        var isReal = k && k.indexOf('face:') !== 0 && k.indexOf('unknown_') !== 0;
                        var lbl = shoppingProfileLabel(k);
                        // Si el perfil no tiene nombre, la etiqueta es "#dorsal" → redundante con el chip Dorsal: usar genérico.
                        if (isReal && lbl === '#' + k) { lbl = 'Perfil'; }
                        byDorsal[k] = { dorsal: k, dorsalNumber: isReal ? k : null, label: lbl, allPhotos: false, thumbs: [] };
                    }
                    return byDorsal[k];
                }
                function pushPhoto(p) {
                    if (!p) { return; }
                    bucket(p.dorsal).thumbs.push({ id: p.id || null, created_at: p.created_at || null, thumb: p.thumb || null });
                }
                if (type === 'profile_cart' || type === 'mixed_cart') {
                    (f.runners || []).forEach(function (r) {
                        if (!r || r.dorsal == null) { return; }
                        var b = bucket(r.dorsal);
                        if (r.items_total === null || r.items_total === undefined) { b.allPhotos = true; }
                    });
                    (f.photos || []).forEach(pushPhoto);
                } else if (angular.isArray(f)) {
                    f.forEach(pushPhoto);            // legacy: array de {id, created_at, dorsal?}
                } else if (f && angular.isArray(f.items)) {
                    f.items.forEach(pushPhoto);      // legacy: {items:[...]}
                }

                var coverage = Object.keys(byDorsal).map(function (k) {
                    var b = byDorsal[k];
                    b.count = b.thumbs.length;
                    return b;
                });
                var pmName = '';
                (vm.paymentMethods || []).forEach(function (m) { if (String(m.id) === String(o.id_payment_method)) { pmName = m.name; } });
                var subsec = parseInt(o.id_subsec, 10);
                // Origen preventa: marcador presale en el files (top-level o en un runner).
                var isPresale = !!(f && !angular.isArray(f) && (f.presale === true ||
                    (angular.isArray(f.runners) && f.runners.some(function (r) { return r && r.presale === true; }))));
                // Compra SUELTA (sin asignar aún a un perfil): marcador unassigned + sin runners.
                var isPresaleUnassigned = !!(f && !angular.isArray(f) && f.unassigned === true);
                out.push({
                    id: o.id_orders || o.id,
                    id_subsec: subsec,
                    statusName: getOrderStatusName(subsec),
                    created_at: o.created_at,
                    price: o.price,
                    currency_code: o.currency_code,
                    name_payment_method: pmName,
                    coverage: coverage,
                    hasCoverage: coverage.length > 0,
                    isFailed: (subsec === 3 || subsec === 4),
                    isPresale: isPresale,
                    isPresaleUnassigned: isPresaleUnassigned,
                    raw: o
                });
            });
            out.sort(function (a, b) { return (a.id || 0) - (b.id || 0); }); // creación ASC
            vm.shoppingOrders = out;
            vm.shoppingFailedCount = out.filter(function (x) { return x.isFailed; }).length;
        }
        vm.buildShoppingView = buildShoppingView;

        /**
         * Marca .purchased en un array de fotos. Si se pasa `dorsal` (perfil) y ese dorsal tiene pack
         * "todas las fotos", TODAS se marcan. Si no, se cruzan por created_at/mediaId. `useDetected` (solo
         * la pestaña Media, sin dorsal fijo) cruza además por los números detectados en la foto.
         */
        function markPhotosPurchased(photos, dorsal, useDetected) {
            if (!photos || !photos.length) { return; }
            var sets = computePurchaseSets();
            if (!sets) { return; }
            var dorsalAll = dorsal != null && dorsal !== '' && sets.allPhotosDorsals[String(dorsal)];
            photos.forEach(function (m) {
                if (!m) { return; }
                var purchased = !!dorsalAll;
                if (!purchased) {
                    var mid = m.mediaId || m.media_id;
                    var ca = caKey(m.created_at || m.createdAt);
                    // Decide el id único; el nombre solo cuenta si la compra no guardó created_at.
                    if (ca && sets.boughtCreatedAts[ca]) { purchased = true; }
                    else if (mid && sets.boughtMediaIds[String(mid)]) { purchased = true; }
                }
                if (!purchased && useDetected) {
                    var nums = mediaDetectedNumbers(m);
                    for (var i = 0; i < nums.length; i++) {
                        if (sets.allPhotosDorsals[nums[i]]) { purchased = true; break; }
                    }
                }
                m.purchased = purchased;
            });
        }

        /** Fotos del perfil (p.photos, pestaña Perfiles): dorsal conocido → marcado fiable. */
        function markProfilePhotosPurchased(profile) {
            if (profile) { markPhotosPurchased(profile.photos, profile.dorsal, false); }
        }

        /** Fotos de la pestaña Media del usuario (vm.allUserMedias): sin dorsal fijo → cruce por detectados. */
        function markPurchasedMedias() {
            markPhotosPurchased(vm.allUserMedias, null, true);
            (vm.runnerProfiles || []).forEach(function (p) {
                if (p && p.photosLoaded) { markProfilePhotosPurchased(p); }
            });
        }

        function getOrderIcon(statusId) {
            var icons = {
                1: 'shopping_bag',      // Generado
                2: 'check_circle',     // Pagado
                3: 'hourglass_empty',  // Pendiente
                4: 'error',            // Rechazado
                5: 'block'             // Cancelado
            };
            return icons[statusId] || 'shopping_bag';
        }

        function getOrderStatusName(statusId) {
            var names = {
                1: 'Generado',
                2: 'Pagado',
                3: 'Pendiente',
                4: 'Rechazado',
                5: 'Cancelado'
            };
            return names[statusId] || 'Desconocido';
        }

        function getOrderStatusColor(statusId) {
            return 'status-order-' + statusId;
        }

        function getUserNumber(params, currentNumber) {
            var ret = undefined;
            var hasGroupEntry = false;
            if (params) {
                var jsonParams = angular.fromJson(params);
                if (jsonParams && jsonParams.events_data) {
                    var group = jsonParams.events_data.find(x => x.event_group_id == vm.selectedGroup.id_user_group);
                    if (group) {
                        hasGroupEntry = true;
                        ret = group.number;
                    }
                }
            }
            // current_number is USER-level (the last bib they had in ANY event), so it is only a fallback for
            // legacy users with no entry for this event. A user registered here without a bib (face-only
            // profile) has no dorsal, as on the website — showing current_number put another event's bib on them.
            if (!hasGroupEntry && (ret === undefined || ret === null) && currentNumber !== undefined) {
                ret = currentNumber;
            }
            return ret;
        }

        /**
         * Foto de perfil del usuario EN ESTE EVENTO (user_params.events_data[grupo].profile). No es el avatar
         * global de la cuenta (users.avatar), sino la imagen con la que el usuario identifica su cara en el
         * evento; por eso el admin no la veía en ninguna parte y parecía que sus fotos "no cuadraban".
         * Devuelve { url, isFaceCrop, faceCount } o null.
         *   - isFaceCrop: la imagen es un recorte de una cara YA detectada (el usuario la ELIGIÓ de sus fotos,
         *     URL bajo /face_crops/). Si no, subió una foto suya.
         * Sus fotos pasan a resolverse por esa cara (load_by_face), no por el dorsal.
         */
        function getUserEventProfilePhoto(user) {
            if (!user) { return null; }
            if (user._eventProfilePhotoFor === (vm.selectedGroup && vm.selectedGroup.id_user_group)) {
                return user._eventProfilePhoto;
            }
            var ret = null;
            try {
                var params = user.user_params ? angular.fromJson(user.user_params) : null;
                var eds = (params && angular.isArray(params.events_data)) ? params.events_data : [];
                var group = eds.filter(function (e) {
                    return e && e.event_group_id === (vm.selectedGroup && vm.selectedGroup.id_user_group);
                })[0];
                var profile = group && group.profile;
                var url = profile && (profile.image_url || profile.photo_url);
                if (url) {
                    // user_params guarda las barras escapadas (json_encode de PHP): "https:\/\/..."
                    url = String(url).replace(/\\\//g, '/');
                    var faces = (profile.face_ids && profile.face_ids.length)
                        ? profile.face_ids.length
                        : (profile.face_id ? 1 : 0);
                    ret = {
                        url: url,
                        isFaceCrop: url.indexOf('/face_crops/') !== -1,
                        faceCount: faces
                    };
                }
            } catch (e) { ret = null; }
            user._eventProfilePhoto = ret;
            user._eventProfilePhotoFor = vm.selectedGroup && vm.selectedGroup.id_user_group;
            return ret;
        }
        vm.getUserEventProfilePhoto = getUserEventProfilePhoto;

        /**
         * Caras propias del usuario SELECCIONADO con las que la web resuelve SU galería, o [] si la web se la
         * resuelve por dorsal. Réplica de la condición del backend (dashboardMyPhotosV2): hay face_ids +
         * load_by_face Y el evento usa profileFaceSelection (o el usuario no tiene dorsal). Solo entonces la
         * web sustituye la galería del dorsal por la unión de la cara.
         */
        // Dorsales que NO identifican a nadie en las fotos: el corredor se reconoce solo por su CARA.
        //   unknown_<hex>  el que se inventaba antes para quien buscaba por cara sin dorsal
        //   face:<id>      perfil que ES una cara, sin galeria de dorsal
        //   SD<10 digitos> sintetico que genera la web cuando ninguna foto suya lleva bib legible
        //                  (CustomData.php: "SD" + 6 del timestamp + 4 aleatorios)
        function esDorsalSintetico(numero) {
            var n = String(numero || '');
            return n.indexOf('unknown_') === 0 || n.indexOf('face:') === 0 || /^SD[0-9]{10}$/.test(n);
        }

        function selectedUserOwnFaceIds() {
            var user = vm.selectedUser;
            if (!user) { return []; }
            try {
                var params = user.user_params ? angular.fromJson(user.user_params) : null;
                var eds = (params && angular.isArray(params.events_data)) ? params.events_data : [];
                var group = eds.filter(function (e) {
                    return e && e.event_group_id === (vm.selectedGroup && vm.selectedGroup.id_user_group);
                })[0];
                var profile = group && group.profile;
                if (!profile || !profile.load_by_face) { return []; }
                // Con dorsal REAL y sin la feature, las fotos van por dorsal. Pero si el dorsal es
                // sintetico no hay ninguna foto etiquetada con el (comprobado en el evento 920:
                // mediaFiles/runner/SD4508059373 devuelve 0 y la cara devuelve 45), asi que la
                // pestana se quedaba VACIA mientras el corredor si veia sus fotos en la web.
                if (!vm.faceSelectionEnabled && group.number && !esDorsalSintetico(group.number)) { return []; }
                var ids = angular.isArray(profile.face_ids)
                    ? profile.face_ids
                    : (profile.face_id ? [profile.face_id] : []);
                return ids.map(function (f) { return String(f || ''); }).filter(Boolean);
            } catch (e) { return []; }
        }

        // Perfiles (dorsales) del usuario en el evento — para la columna NUMBER en eventos de CARRITO. Se derivan
        // de user_params (number ∪ profile_names ∪ profile_faces ∪ assignedPhotos ∪ unassignedPhotos); usa el nombre
        // si el perfil está renombrado. Memoizado en el propio user para no re-parsear en cada digest de la tabla.
        function getUserProfiles(user) {
            if (!user) { return []; }
            if (user._profilesCache) { return user._profilesCache; }
            var params = user.user_params;
            if (angular.isString(params)) { try { params = angular.fromJson(params); } catch (e) { params = null; } }
            var group = (params && angular.isArray(params.events_data))
                ? params.events_data.find(function (x) { return x && x.event_group_id === vm.selectedGroup.id_user_group; })
                : null;
            var res = [];
            if (group) {
                var dorsals = {};
                if (group.number) { dorsals[String(group.number)] = true; }
                ['profile_names', 'profile_faces', 'assignedPhotos', 'unassignedPhotos'].forEach(function (k) {
                    if (group[k] && angular.isObject(group[k])) {
                        Object.keys(group[k]).forEach(function (d) { if (d) { dorsals[String(d)] = true; } });
                    }
                });
                var names = (group.profile_names && angular.isObject(group.profile_names)) ? group.profile_names : {};
                res = Object.keys(dorsals).map(function (d) {
                    return (names[d] && String(names[d]).trim()) ? String(names[d]) : d;
                });
            }
            user._profilesCache = res;
            return res;
        }

        function selectEvent(e) {
            resetMediaPagination();

            if (vm.addPrebuys) {
                return;
            }

            vm.isLoadingTotalRunners = true;
            vm.totalRunners = 0;
            vm.isLoadingTotalAccess = true;
            vm.totalAccess = 0;
            vm.isLoadingAveragePhotos = true;
            vm.averagePhotos = 0;
            vm.isLoadingTotalOrders = true;
            vm.isLoadingCurrencys = true;
            vm.loadingProducts = true;
            vm.totalOrders = 0;
            vm.totalOrdersUSD = 0;
            vm.totalOrdersUSDbyProduct = [];
            vm.manualUSDbyProduct = {};   // USD manual por producto (se resta de cada fila de producto)
            vm.totalManualUSD = 0;        // USD de la fila "Manual"
            vm.archiveItems = [];
            vm.products = [];
            vm.cartSales = null;
            vm.recognizedRunners = 0;
            vm.isLoadingTotalPhotos = true;
            vm.totalPhotos = 0;
            vm.isLoadingRecognizedPhotos = true;
            vm.isLoadingDownloads = true;
            vm.recognizedPhotos = 0;
            vm.notRecognizedPhotos = 0;
            vm.moreUsersParams = undefined;
            vm.eventVersion = undefined;
            vm.eventName = "";
            setEventState(e);

            let eventId = null;
            if (e.id_events) {
                eventId = e.id_events;
                $location.hash(String(e.id_events));
            } else {
                eventId = e.event_id;
                $location.hash(String(e.event_id));
            }

            RuntagService.getSection({
                domain: $scope.siteID,
                section: 'events',
                filters: [
                    {
                        field: 'id_events',
                        values: [eventId]
                    }
                ]
            }).then(response => {
                let event = response.data[0];
                $rootScope.global.titleToolbar = `<span class="material-symbols-outlined">directions_run</span> Runtag > ${$translate.instant('RUNTAG.EVENTS')} > ${event.event_name}`;
                if (event.version) {
                    vm.eventVersion = event.version.toLowerCase();
                }
                event.locations = angular.fromJson(event.locations);
                if (event.photographers) {
                    if (angular.isString(event.photographers)) {
                        event.photographers = angular.fromJson(event.photographers);
                    }
                    if (!angular.isArray(event.photographers)) event.photographers = [];
                    event.photographers.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
                } else {
                    event.photographers = [];
                }
                vm.eventName = event.event_name
                vm.apiUrl = event.api_url;
                vm.isOriginal = parseInt(event.is_original, 10) === 1 ? 1 : 0; // siempre se manda en storageTierBulk
                const eventStartDateTimeStr = event.date;
                const lastLoginFromDate = new Date(event.date.replace(" ", "T")); // Subtract one day
                lastLoginFromDate.setDate(lastLoginFromDate.getDate() - 1); // Set time to 00:00:00
                lastLoginFromDate.setHours(0, 0, 0, 0);
                const eventId = event.id_events;
                const idSubSecOrdersPaid = 2;
                vm.selectedGroup = event;
                // Al cambiar de evento, el detalle de pedidos vuelve a cero: si no, se quedarían a la
                // vista las compras del evento anterior hasta que alguien abriera la pestaña.
                vm.activeSalesTableMode = 'sales';
                vm.orderDetail.rows = [];
                vm.orderDetail.total = 0;
                vm.orderDetail.hasMore = false;
                vm.orderDetail.search = '';
                vm.orderDetail.status = 'all';
                vm.orderDetail.page = 1;
                vm.orderDetail.requestId++;
                vm.cartEnabled = isCartEvent(event); // en eventos de carrito, Perfiles sustituye a Media
                vm.faceSelectionEnabled = isFaceSelectionEvent(event); // el perfil propio se resuelve por CARA
                setEventState(event);
                getUsers();
                if (event.id_subsec == 6) {
                    getEventArchiveItems();
                }

                vm.currentClient = vm.clients.find(x => x.id_clients === vm.selectedGroup.id_client);

                vm.paymentMethods.forEach(method => {
                    method.products = [];
                });

                usersService.getUsersByGroups({
                    siteID: $scope.siteID,
                    groupIds: event.id_user_group,
                }).then(function (response) {
                    vm.totalRunners = response.result.total;
                    vm.isLoadingTotalRunners = false;

                    RuntagEventService.getMedias({
                        siteID: $scope.siteID,
                        groupBy: "id_user",
                        id_event: eventId
                    }).then(function (response) {
                        vm.recognizedRunners = response.total;
                    });

                    usersService.getUsersByGroups({
                        siteID: $scope.siteID,
                        groupIds: event.id_user_group,
                        lastLoginNotNull: true,
                        resultsPerPage: 1,
                        lastActivityFrom: $filter('date')(lastLoginFromDate, 'yyyy-MM-dd 00:00:00')
                    }).then(function (response) {
                        vm.totalAccess = response.result.total;
                        vm.isLoadingTotalAccess = false;
                    });
                    RuntagService.getSection({
                        filters: [
                            {
                                field: 'id_event',
                                values: [vm.selectedGroup.id_events]
                            },
                            {
                                field: 'id_subsec',
                                values: [2]
                            }
                        ],
                        domain: $scope.siteID,
                        section: 'orders',
                        resultSumField: 'price',
                        groupBy: 'currency_code',
                        sumPerGroup: true
                    }).then((resp) => {
                        vm.totalOrdersByCurrency = resp.sums; // los importes 0 no alteran las sumas
                        vm.isLoadingCurrencys = false;
                    });
                    // El contador de ORDERS NO cuenta las órdenes de importe 0: son asignaciones de perfil
                    // hechas por el admin (sin producto ni método de pago), no ventas, y descuadraban con el
                    // desglose de abajo (evento 884: 339 contra 336). `price` no es filtrable en el _ref, así
                    // que en vez de filtrar se agrupa por precio y se cuentan solo los grupos con importe > 0
                    // (nº de órdenes = suma/precio, igual que en loadCartSalesBreakdown).
                    RuntagService.getSection({
                        filters: [
                            {
                                field: 'id_event',
                                values: [vm.selectedGroup.id_events]
                            },
                            {
                                field: 'id_subsec',
                                values: [2]
                            }
                        ],
                        domain: $scope.siteID,
                        section: 'orders',
                        resultSumField: 'price',
                        groupBy: 'price',
                        sumPerGroup: true
                    }).then((resp) => {
                        var paidOrders = 0;
                        (resp.sums || []).forEach(function (g) {
                            var price = parseFloat(g.price);
                            var sum = parseFloat(g.sum);
                            if (!(price > 0) || isNaN(sum)) { return; }
                            paidOrders += Math.round(sum / price);
                        });
                        vm.totalOrders = paidOrders;
                        vm.isLoadingTotalOrders = false;
                    });
                    // CONVERSIÓN A USD (es la cifra por la que se factura al cliente).
                    // El total sale de TODAS las órdenes pagadas (sin filtrar método) y no cambia. Lo que sí
                    // se separa es el desglose: los pagos MANUALES tienen su propia fila en la tabla, así que
                    // se restan del producto al que pertenecen. Antes no se restaban y, además, la fila Manual
                    // se creaba sin `id` → findTotalUSDproduct(undefined) devolvía 0 y parecía que las compras
                    // manuales no se contaban (su importe estaba escondido dentro de las filas de producto).
                    var manualMethodUsd = (vm.paymentMethods || []).find(function (m) {
                        return (m.name || '').toLowerCase() === 'manual';
                    });
                    function qUsdByProduct(extraFilters) {
                        return RuntagService.getSection({
                            filters: [
                                { field: 'id_event', values: [vm.selectedGroup.id_events] },
                                { field: 'id_subsec', values: [2] }
                            ].concat(extraFilters || []),
                            domain: $scope.siteID,
                            section: 'orders',
                            resultSumField: 'usd',
                            groupBy: 'id_product',
                            sumPerGroup: true
                        });
                    }
                    var usdCalls = { all: qUsdByProduct() };
                    if (manualMethodUsd) {
                        usdCalls.manual = qUsdByProduct([
                            { field: 'id_payment_method', values: [manualMethodUsd.id] }
                        ]);
                    }
                    $q.all(usdCalls).then(function (resUsd) {
                        var allSums = (resUsd.all && resUsd.all.sums) || [];
                        var manualSums = (resUsd.manual && resUsd.manual.sums) || [];
                        // Total: intacto (incluye manuales y cualquier orden sin método asignado).
                        vm.totalOrdersUSD = allSums.reduce(function (t, o) { return t + (parseFloat(o.sum) || 0); }, 0);
                        vm.totalOrdersUSDbyProduct = allSums;
                        var manualByProduct = {};
                        var manualTotal = 0;
                        manualSums.forEach(function (o) {
                            var v = parseFloat(o.sum) || 0;
                            manualByProduct[String(o.id_product)] = v;
                            manualTotal += v;
                        });
                        vm.manualUSDbyProduct = manualByProduct;
                        vm.totalManualUSD = manualTotal;
                    });
                    RuntagEventService.getProducts({
                        siteID: $scope.siteID,
                        resultsPerPage: 500,
                        filters: [
                            {
                                field: 'id_event',
                                values: [event.id_events]
                            }
                        ]
                    }).then(function (response) {
                        var products = response.result.data || [];
                        var productsLength = 0;

                        // Eventos de carrito: todas las compras se registran con un mismo producto (el genérico),
                        // así que la tabla SALES de arriba las agrupa mal. Debajo montamos el desglose real por
                        // producto de referencia, reconstruido desde el PRECIO de cada orden (ver más abajo).
                        if (vm.cartEnabled) {
                            loadCartSalesBreakdown(event, products);
                        }

                        if (products.length === 0) {
                            vm.loadingProducts = false;
                        }

                        angular.forEach(products, function (product) {
                            var method = vm.paymentMethods.find(x => x.id == product.id_payment_method);
                            var optionsProduct = {
                                siteID: $scope.siteID,
                                filters: [
                                    {
                                        field: 'id_subsec',
                                        values: [idSubSecOrdersPaid]
                                    },
                                    {
                                        field: 'id_event',
                                        values: [event.id_events]
                                    },
                                    {
                                        // 'id_payment_methods' (plural) NO existe en el _ref de orders, así que el
                                        // filtro se ignoraba en silencio: cada fila de producto sumaba TAMBIÉN las
                                        // órdenes manuales, que además se contaban otra vez en la fila "Manual".
                                        field: 'id_payment_method',
                                        values: [method.id]
                                    },
                                    {
                                        field: 'id_product',
                                        values: [product.id]
                                    }
                                ],
                                resultSumField: 'price'
                            }
                            RuntagEventService.getOrders(optionsProduct).then(function (response) {
                                method.products.push(
                                    {
                                        product: product.product,
                                        product_label: product.product_label,
                                        id: product.id,
                                        price: product.price_total,
                                        currency_code: product.currency_code,
                                        totalPrice: response.sum.toFixed(2).toString() + " " + product.currency_code,
                                        onoff: product.onoff,
                                        items_total: product.items_total,
                                        id_payment_method: product.id_payment_method
                                    }
                                )
                                delete optionsProduct.resultSumField;
                                optionsProduct.resultCount = true;
                                RuntagEventService.getOrders(optionsProduct).then(function (response) {
                                    var x = method.products.find(y => y.id == product.id);
                                    if (x) {
                                        x.totalOrders = response.count;
                                    }
                                    productsLength++;
                                    if (productsLength == products.length) {
                                        vm.paymentMethods.forEach((method) => {
                                            if (method.products.length > 0) {
                                                method.products.forEach((product) => {
                                                    if (vm.products.indexOf(product) === -1) {
                                                        vm.products.push(product);
                                                    }
                                                });
                                            }
                                        });
                                        vm.loadingProducts = false;
                                    }
                                });
                            });
                        });
                    }).catch(function (error) {
                        $log.error('Error fetching products', error);
                        vm.loadingProducts = false;
                    });
                    var manualMethod = vm.paymentMethods.find(x => x.name.toLowerCase() == 'manual');
                    var optionsManualOrders = {
                        siteID: $scope.siteID,
                        filters: [
                            {
                                field: 'id_subsec',
                                values: [idSubSecOrdersPaid]
                            },
                            {
                                field: 'id_event',
                                values: [event.id_events]
                            },
                            {
                                field: 'id_payment_method',
                                values: [manualMethod.id]
                            }
                        ],
                        resultSumField: 'price'
                    }
                    RuntagEventService.getOrders(optionsManualOrders).then(function (response) {
                        manualMethod.products = [];
                        manualMethod.products.push(
                            {
                                product: 'Manual',
                                // Sin `id` la columna USD de esta fila resolvía a 0 (findTotalUSDproduct(undefined)).
                                id: MANUAL_USD_KEY,
                                totalPrice: response.sum.toFixed(2).toString()
                            }
                        )
                        delete optionsManualOrders.resultSumField;
                        optionsManualOrders.resultCount = true;
                        RuntagEventService.getOrders(optionsManualOrders).then(function (response) {
                            manualMethod.products[0].totalOrders = response.count;
                        });
                    });
                    // El total por moneda (totalOrdersByCurrency) no contempla los
                    // pagos manuales, así que los sumamos aparte por moneda para
                    // incorporarlos en findTotalCurrency.
                    vm.manualOrdersByCurrency = [];
                    RuntagService.getSection({
                        filters: [
                            { field: 'id_event', values: [event.id_events] },
                            { field: 'id_subsec', values: [idSubSecOrdersPaid] },
                            { field: 'id_payment_method', values: [manualMethod.id] }
                        ],
                        domain: $scope.siteID,
                        section: 'orders',
                        resultSumField: 'price',
                        groupBy: 'currency_code',
                        sumPerGroup: true
                    }).then((resp) => {
                        vm.manualOrdersByCurrency = resp.sums || [];
                    });
                    var lastUpdated = new Date(event.dashboard_last_updated);
                    var newUpdated = new Date(lastUpdated.setMinutes(lastUpdated.getMinutes() + event.dashboard_minutes_update));
                    var today = new Date();
                    if (!event.dashboard_minutes_update || newUpdated < today || !event.dashboard_recognized_photos || !event.dashboard_total_photos || !event.dashboard_unrecognized_photos) {
                        fetchEventTotals(event).then(function (response) {
                            switch (vm.eventVersion) {
                                case 'v2':
                                    var tPhotos = response.totalPhotos || response.total_photos || 0;
                                    var tRecPhotos = response.totalRecognizedPhotos || response.total_recognized_photos || 0;
                                    var tUnrPhotos = response.totalUnrecognizedPhotos || response.total_unrecognized_photos || 0;

                                    applyTotals(
                                        tPhotos,
                                        vm.totalRunners > 0 ? (tPhotos / vm.totalRunners) : 0,
                                        tRecPhotos,
                                        tUnrPhotos
                                    );
                                    break;

                                case 'v3':
                                    var pProcessed = response.statuses ? (response.statuses.processed || 0) : 0;
                                    var tRecPhotosV3 = response.totalRecognizedPhotos || response.total_recognized_photos || 0;
                                    var tUnrPhotosV3 = response.totalUnrecognizedPhotos || response.total_unrecognized_photos || 0;
                                    var tPhotosV3 = response.totalPhotos || response.total_photos || 0;

                                    var aiPending = response.ai_pending || 0;
                                    var cropFailed = response.statuses ? (response.statuses.crop_failed || 0) : 0;
                                    var metaError = response.statuses ? (response.statuses.metadata_error || 0) : 0;
                                    var repeated = response.statuses ? (response.statuses.repeated || 0) : 0;
                                    var unknownFail = response.statuses ? (response.statuses.unknown_failure || 0) : 0;
                                    var aiFailed = response.statuses ? (response.statuses.ai_failed || 0) : 0;

                                    applyTotals(
                                        pProcessed,
                                        vm.totalRunners > 0 ? (pProcessed / vm.totalRunners) : 0,
                                        tRecPhotosV3,
                                        tUnrPhotosV3,
                                        tPhotosV3,
                                        aiPending,
                                        cropFailed,
                                        metaError,
                                        repeated,
                                        unknownFail,
                                        aiFailed
                                    );
                                    break;

                                default:
                                    var tPhotosDef = response.total_photos || response.totalPhotos || 0;
                                    var tRecPhotosDef = response.total_recognized_photos || response.totalRecognizedPhotos || 0;
                                    var tUnrPhotosDef = response.total_unrecognized_photos || response.totalUnrecognizedPhotos || 0;

                                    applyTotals(
                                        tPhotosDef,
                                        vm.totalRunners > 0 ? (tPhotosDef / vm.totalRunners) : 0,
                                        tRecPhotosDef,
                                        tUnrPhotosDef
                                    );
                                    break;
                            }
                            vm.isLoadingTotalPhotos = false;
                            vm.isLoadingAveragePhotos = false;
                            vm.isLoadingRecognizedPhotos = false;
                            event.dashboard_last_updated = today.getFullYear() + '-' + (today.getMonth() + 1 < 10 ? '0' + (today.getMonth() + 1) : (today.getMonth() + 1)) + '-' + (today.getDate() < 10 ? '0' + today.getDate() : today.getDate()) + ' ' + (today.getHours() < 10 ? '0' + today.getHours() : today.getHours()) + ':' + (today.getMinutes() < 10 ? '0' + today.getMinutes() : today.getMinutes()) + ':' + (today.getSeconds() < 10 ? '0' + today.getSeconds() : today.getSeconds());
                            if (event.locations && response.locations) {
                                angular.forEach(event.locations, function (location) {
                                    var dbLocation = response.locations.find(x => x.name.toLowerCase() == location.reference_name.toLowerCase());
                                    if (dbLocation) {
                                        location.photos = dbLocation.total;
                                    } else {
                                        location.photos = 0;
                                    }
                                });
                            }
                            if (response.photographers && response.photographers.length > 0) {
                                // 1. Rebuild photographers list based on Lambda response (Source of Truth)
                                // Filter: Only photographers with 2 or more photos
                                var newPhotographers = response.photographers.filter(function (lp) {
                                    return (lp.total || 0) >= 2;
                                }).map(function (lp) {
                                    var cameraName = lp.name || '';

                                    // Preserve existing human-readable name if available
                                    var existing = (event.photographers || []).find(function (p) {
                                        return p.camera_name && p.camera_name.toLowerCase() === cameraName.toLowerCase();
                                    });

                                    var pObj = {
                                        name: existing ? (existing.name || cameraName) : cameraName,
                                        camera_name: cameraName,
                                        photos: 0,
                                        uploadedPhotos: 0,
                                        processedPhotos: 0,
                                        downloads: 0,
                                        downloadsUnique: 0,
                                        recognizedPhotos: 0,
                                        unrecognizedPhotos: 0,
                                        repeatedPhotos: 0,
                                        aiPending: 0,
                                        aiFailed: 0,
                                        wrongFiles: 0,
                                        metadataError: 0,
                                        cropError: 0,
                                        downloadRatio: 0
                                    };

                                    pObj.uploadedPhotos = lp.total || 0;
                                    pObj.recognizedPhotos = lp.totalRecognizedPhotos || 0;
                                    pObj.unrecognizedPhotos = lp.totalUnrecognizedPhotos || 0;

                                    if (lp.statuses) {
                                        pObj.processedPhotos = lp.statuses.processed || 0;
                                        pObj.photos = lp.statuses.processed || 0; // Legacy mapping
                                        pObj.repeatedPhotos = lp.statuses.repeated || 0;
                                        pObj.aiPending = lp.statuses.ai_pending || lp.statuses.aiPending || 0;
                                        pObj.aiFailed = lp.statuses.ai_failed || lp.statuses.aiFailed || 0;
                                        pObj.wrongFiles = lp.statuses.unknown_failure || lp.statuses.unknownFailure || 0;
                                        pObj.metadataError = lp.statuses.metadata_error || lp.statuses.metadataError || 0;
                                        pObj.cropError = lp.statuses.crop_failed || lp.statuses.cropError || 0;
                                    } else {
                                        pObj.photos = lp.total || 0;
                                    }
                                    return pObj;
                                });

                                RuntagEventService.getDownloadsStatsPerPhotographer({
                                    domain: 'runtag',
                                    id_event: eventId
                                }).then(function (response) {
                                    if (response && angular.isArray(response)) {
                                        newPhotographers.forEach(function (photographer) {
                                            var stats = response.find(function (s) {
                                                return s.photographer === photographer.camera_name;
                                            });

                                            if (stats) {
                                                photographer.downloads = (stats.total_downloads_per_user || 0) + (stats.total_downloads_zips_per_user || 0);
                                                photographer.downloadsUnique = stats.total_user_downloads || 0;

                                                if (photographer.photos > 0) {
                                                    photographer.downloadRatio = (photographer.downloadsUnique / photographer.photos) * 100;
                                                } else {
                                                    photographer.downloadRatio = 0;
                                                }
                                                photographer.downloadRatio = Math.round(photographer.downloadRatio * 10) / 10;
                                            }
                                        });
                                    }
                                    newPhotographers.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
                                    event.photographers = newPhotographers;
                                    vm.isLoadingDownloads = false;
                                    saveEventDashboard(event);
                                });

                                // 2. Individual calls for each photographer (Reverted from batching as requested)
                                // var photographerPromises = newPhotographers.map(function (photographer) {
                                //     var cameraName = photographer.camera_name;
                                //     var baseFilters = [
                                //         { field: 'id_event', values: [event.id_events] },
                                //         { field: 'photographer', values: [cameraName] }
                                //     ];

                                //     var pUniquePairs = RuntagEventService.getContent({
                                //         siteID: $scope.siteID,
                                //         content: 'user_downloads',
                                //         filters: baseFilters,
                                //         customGroupBy: ['id_user', 'file_created_at'],
                                //         resultCount: true
                                //     });

                                //     var pUniqueUsers = RuntagEventService.getContent({
                                //         siteID: $scope.siteID,
                                //         content: 'user_downloads',
                                //         filters: baseFilters,
                                //         groupBy: 'id_user',
                                //         resultCount: true
                                //     });

                                //     return $q.all([pUniquePairs, pUniqueUsers]).then(function (results) {
                                //         var pairs = results[0].count || 0;
                                //         var users = results[1].count || 0;

                                //         photographer.downloads = pairs;
                                //         photographer.downloadsUnique = users;

                                //         if (photographer.photos > 0) {
                                //             photographer.downloadRatio = (photographer.downloadsUnique / photographer.photos) * 100;
                                //         } else {
                                //             photographer.downloadRatio = 0;
                                //         }
                                //         photographer.downloadRatio = Math.round(photographer.downloadRatio * 10) / 10;
                                //     }).catch(function (err) {
                                //         $log.error('Error fetching data for photographer ' + cameraName, err);
                                //     });
                                // });

                                // $q.all(photographerPromises).then(function () {
                                //     newPhotographers.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
                                //     event.photographers = newPhotographers;
                                //     vm.isLoadingDownloads = false;
                                //     saveEventDashboard(event);
                                // });
                            } else {
                                event.photographers = [];
                                vm.isLoadingDownloads = false;
                                saveEventDashboard(event);
                            }

                            function saveEventDashboard(event) {
                                var newEvent = {
                                    dashboard_recognized_photos: event.dashboard_recognized_photos,
                                    dashboard_total_photos: event.dashboard_total_photos,
                                    dashboard_unrecognized_photos: event.dashboard_unrecognized_photos,
                                    dashboard_last_updated: event.dashboard_last_updated,
                                    locations: event.locations,
                                    photographers: event.photographers,
                                    id: event.id
                                };

                                var optionsSaveItem = {
                                    site: $scope.siteID,
                                    id: event.id,
                                    section: 'events',
                                    item: newEvent,
                                    keepOldMedia: true
                                };

                                contentService.saveItem(optionsSaveItem).then(function (response) {
                                    $log.warn('Event saved with updated photographers!');
                                });
                            }
                        })
                            .catch(function (error) {
                                vm.totalPhotos = 0;
                                vm.isLoadingTotalPhotos = false;
                                vm.averagePhotos = 0;
                                vm.isLoadingAveragePhotos = false;
                                vm.recognizedPhotos = 0;
                                vm.isLoadingRecognizedPhotos = false;
                                vm.notRecognizedPhotos = 0;
                                event.dashboard_recognized_photos = 0;
                                event.dashboard_total_photos = 0;
                                event.dashboard_unrecognized_photos = 0;
                                vm.isLoadingDownloads = false;
                            });
                    } else {
                        vm.totalPhotos = event.dashboard_total_photos;
                        vm.isLoadingTotalPhotos = false;
                        vm.averagePhotos = event.dashboard_total_photos / vm.totalRunners;
                        vm.isLoadingAveragePhotos = false;
                        vm.recognizedPhotos = event.dashboard_recognized_photos;
                        vm.isLoadingRecognizedPhotos = false;
                        vm.notRecognizedPhotos = event.dashboard_unrecognized_photos;
                    }
                }).catch(function (error) {
                    $log.error('Error fetching event details', error);
                    vm.loadingProducts = false;
                    vm.isLoadingTotalRunners = false;
                    vm.isLoadingTotalAccess = false;
                    vm.isLoadingTotalOrders = false;
                    vm.isLoadingCurrencys = false;
                    vm.isLoadingTotalPhotos = false;
                    vm.isLoadingAveragePhotos = false;
                    vm.isLoadingRecognizedPhotos = false;
                    vm.isLoadingDownloads = false;
                });
            });
        }

        function applyTotals(totalPhotos, avg, rec, unrec, uploadedPhotos, ai_pending, crop_failed, metadata_error, repeated, unknown_failure, ai_failed) {
            $scope.$applyAsync(function () {
                vm.totalPhotos = nonNegative(totalPhotos, 0);
                vm.averagePhotos = nonNegative(avg, 0);
                vm.recognizedPhotos = nonNegative(rec, 0);
                vm.notRecognizedPhotos = nonNegative(unrec, null);

                vm.uploadedPhotos = nonNegative(uploadedPhotos, null);
                vm.ai_pending = nonNegative(ai_pending, null);
                vm.crop_failed = nonNegative(crop_failed, null);
                vm.metadata_error = nonNegative(metadata_error, null);
                vm.repeated = nonNegative(repeated, null);
                vm.unknown_failure = nonNegative(unknown_failure, null);
                vm.ai_failed = nonNegative(ai_failed, null);

                vm.isLoadingTotalPhotos = false;
                vm.isLoadingAveragePhotos = false;
                vm.isLoadingRecognizedPhotos = false;
            });
        }

        function nonNegative(value, fallback = 0) {
            if (value === null || angular.isUndefined(value)) return fallback;
            var n = Number(value);
            if (isNaN(n) || n < 0) return fallback;
            return n;
        }

        function ensureParsed(obj, field) {
            if (!obj || !obj[field] || typeof obj[field] !== 'string') return !!obj._corrupted;

            try {
                let parsed = angular.fromJson(obj[field]);
                if (parsed !== obj[field]) {
                    if (typeof parsed === 'string') {
                        // It was double encoded!
                        obj._corrupted = true;
                        obj[field] = parsed;
                        return ensureParsed(obj, field);
                    } else {
                        // Normal single encoded JSON
                        obj[field] = parsed;
                    }
                }
            } catch (e) { }
            return !!obj._corrupted;
        }

        function extractRunnerNumbers(users) {
            return users.map(u => {
                // Búsqueda por perfil: el dorsal buscado puede ser un perfil RECOLECTADO/comprado (está en la
                // orden, no en events_data) → es ese el que tiene las fotos, no el dorsal propio del usuario.
                if (u.matchedProfileNumber) { return u.matchedProfileNumber; }
                if (u.user_params) {
                    ensureParsed(u, 'user_params');
                    const eventData = u.user_params?.events_data?.find(x => x.event_group_id == vm.selectedGroup.id_user_group);
                    if (eventData && eventData.number) {
                        return eventData.number;
                    }
                }
                return u.current_number || u.id_user;
            });
        }

        vm.openNewEventModal = function () {
            $mdDialog.show({
                controller: 'newEventModalController',
                controllerAs: 'vm',
                locals: {
                    siteID: $scope.siteID,
                    event: vm.selectedGroup,
                    clients: vm.clients,
                    paymentMethods: vm.paymentMethods,
                    selectedEvent: undefined,
                    products: undefined,
                    apiUrl: vm.apiUrl
                },
                templateUrl: 'app/main/apps/runtag/event/dialogs/event/new-event-modal.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                multiple: true,
                onShowing: function (scope, element) {
                    element.addClass('new-event-modal');
                },
                fullscreen: true
            }).then(function (result) {
                $log.warn('Modal cerrado con:', result);
            }, function () {
                $log.warn('Modal cancelado');
            });
        }

        function getEventsStats(reload) {
            if (vm.isLoadingMoreEvents) return;
            vm.isLoadingMoreEvents = true;

            var today = new Date();

            today.setFullYear(today.getFullYear() + 1);

            var options = {
                domain: $scope.siteID,
                from: '2014-12-02 07:00:00',
                to: formatDate(today, 'yyyy-MM-dd HH:mm:ss'),
                page: vm.moreEventsParams && !reload ? vm.moreEventsParams.current_page + 1 : 1,
                resultsPerPage: 10,
                event_state_id: vm.selectedState && vm.selectedState !== 'all' ? vm.selectedState : undefined,
                event_name: vm.eventsQuerySearch || undefined,
                client_id: vm.selectedClientId !== 'all' ? vm.selectedClientId : undefined,
                sortDir: vm.eventsSortDir || 'DESC',
            };

            RuntagEventService.getEventsStats(options).then(function (response) {
                var hashId = $location.hash();
                response.data.forEach(ev => {
                    // If there's a hash (pre-selected event), only fetch totals for that one in the list
                    // The dashboard call will handle the actual data load
                    if (!hashId || String(ev.id_events) === String(hashId)) {
                        setTotalPhotos(ev);
                    }
                    checkThumbnail(ev);
                    setEventState(ev);
                });
                if (vm.moreEventsParams && !reload) {
                    vm.eventsGroup = vm.eventsGroup.concat(response.data);
                } else {
                    vm.eventsGroup = response.data;
                    vm.isLoadingGroups = false;
                }

                if (response.last_page !== response.current_page) {
                    vm.moreEventsParams = {
                        total: response.total,
                        current_page: response.current_page
                    };
                } else {
                    vm.moreEventsParams = undefined;
                }
            }).catch(function (error) {
                $log.error("Error fetching events:", error);
            }).finally(function () {
                vm.isLoadingMoreEvents = false;
            });
        }

        $scope.$watch(() => sessionService.getLanguage(), function (newLang, oldLang) {
            if (newLang !== oldLang) {
                vm.selectedLanguage = newLang;

                vm.updateEventStates();

            }
        });

        function fetchEventTotals(event) {
            var apiUrl = event.api_url || event.event_api_url;
            if (!apiUrl) return $q.reject('No API URL');

            if (totalsPromises[apiUrl]) {
                return totalsPromises[apiUrl];
            }

            totalsPromises[apiUrl] = RuntagEventService.getTotalsPablo({ apiUrl: apiUrl })
                .then(function (response) {
                    delete totalsPromises[apiUrl];
                    return response;
                })
                .catch(function (error) {
                    delete totalsPromises[apiUrl];
                    return $q.reject(error);
                });

            return totalsPromises[apiUrl];
        }

        function setTotalPhotos(event) {
            if (event.api_url || event.event_api_url) {
                return fetchEventTotals(event)
                    .then(response => {
                        if (response.statuses && angular.isDefined(response.statuses.processed)) {
                            event.totalPhotos = String(response.statuses.processed);
                        } else if (angular.isDefined(response.totalPhotos)) {
                            event.totalPhotos = String(response.totalPhotos);
                        } else if (angular.isDefined(response.total_photos)) {
                            event.totalPhotos = String(response.total_photos);
                        } else {
                            event.totalPhotos = 'No hay datos';
                        }
                    })
                    .catch(() => {
                        event.totalPhotos = 'No hay datos';
                    });
            } else {
                event.totalPhotos = 'No hay datos';
            }
        }

        function checkThumbnail(event) {
            if (event.event_thumbnail) {
                return checkImage(event.event_thumbnail)
                    .then(() => event.imageError = false)
                    .catch(() => event.imageError = true);
            } else {
                event.imageError = true;
            }
        }

        function setEventState(event) {
            let stateId = undefined;
            if (event.id_subsec) {
                stateId = parseInt(event.id_subsec);
            } else if (event.event_state) {
                stateId = vm.stateNameToIdMap ? vm.stateNameToIdMap[event.event_state] : undefined;
            }

            if (stateId && vm.eventsStatesMap && vm.eventsStatesMap[stateId]) {
                const stateInfo = vm.eventsStatesMap[stateId];
                const translation = stateInfo.translations[vm.selectedLanguage] || stateInfo.subsec;

                event.event_state_name = translation;
                event.event_state_color = stateInfo.color;

                // Only update global header variables if this is the selected event
                if (vm.selectedGroup && (event.id_events === vm.selectedGroup.id_events || event.id === vm.selectedGroup.id)) {
                    vm.eventStateName = translation;
                    vm.eventStateColor = stateInfo.color;
                }
            } else {
                event.event_state_name = "Undefined state";
                event.event_state_color = "#CCCCCC";

                if (vm.selectedGroup && (event.id_events === vm.selectedGroup.id_events || event.id === vm.selectedGroup.id)) {
                    vm.eventStateName = "Undefined state";
                    vm.eventStateColor = "#CCCCCC";
                }
            }
        }

        vm.updateEventStates = function () {
            vm.eventsGroup.forEach(event => {
                setEventState(event);
            });
        };

        function getEventsOptions() {
            var options = { domain: $scope.siteID };
            RuntagEventService.getEventsOptions(options).then(function (response) {
                vm.eventsStatesMap = {};
                vm.stateNameToIdMap = {};

                vm.eventsStates = response.reference_sections.subsection.map(state => {
                    vm.eventsStatesMap[state.id_subsec] = {
                        subsec: state.subsec,
                        color: state.color,
                        translations: {
                            en: state.en,
                            es: state.es,
                            fr: state.fr
                        }
                    };

                    vm.stateNameToIdMap[state.subsec] = state.id_subsec;

                    return {
                        id_subsec: state.id_subsec,
                        subsec: state.subsec,
                        color: state.color,
                        translations: {
                            en: state.en,
                            es: state.es,
                            fr: state.fr
                        }
                    };
                });

                if (vm.selectedGroup) {
                    setEventState(vm.selectedGroup);
                }

                if (vm.eventsGroup && vm.eventsGroup.length > 0) {
                    vm.updateEventStates();
                }
            }).catch(function (error) {
                $log.error("Error en getEventsOptions:", error);
            });
        }

        function checkImage(url) {
            return new Promise((resolve, reject) => {
                const img = new Image();
                img.onload = () => resolve();
                img.onerror = () => reject();
                img.src = url;
            });
        }

        vm.resetFilters = function () {
            vm.eventsQuerySearch = '';
            vm.eventsSortDir = 'DESC';
            vm.selectedClientId = 'all';
            vm.selectedState = 'all';

            vm.getEventsStats(true);
        };

        function clearSearchTerm() {
            $scope.searchTerm = '';
        }

        function groupsByRef() {
            var options = { siteID: $scope.siteID };
            usersService.getRef(options).then(function (ref) {
                var found = ref.find(x => x.category === 'show_groups');
                if (found) {
                    vm.CleanUsersGroups = cleanByType(vm.CleanUsersGroups, JSON.parse(found.field_name));
                }
            })
        }

        function getFlatGroups(nestedGroups, groups) {
            angular.forEach(nestedGroups, function (group) {
                groups.push(group);
                if (group.children) {
                    getFlatGroups(group.children, groups)
                }
            });
            return groups;
        }

        function setProfileImage(mediaItem) {
            // Foto con forma de reconocimiento (Pablo: crops/labels, SIN media.cropstatus) → el avatar desde
            // cropstatus solo aplica a la forma clásica (MySQL). Evita el TypeError (p.ej. en la pestaña Perfiles).
            if (!mediaItem || !mediaItem.media || !mediaItem.media.cropstatus) {
                $log.error('setProfileImage: media.cropstatus ausente; foto no compatible con "usar como avatar".');
                return;
            }
            vm.userCopy = angular.copy(vm.selectedUser);
            var avatar = mediaItem.media.cropstatus.filter(crop => crop.id_cropformats === 1001)[0];
            var selectedContainer = sessionService.getContainerByID(avatar.id_container);
            vm.userCopy.avatar = {
                url: ""
            }
            if (selectedContainer && selectedContainer.use_grid === 1) {
                vm.userCopy.avatar.url = selectedContainer.view_url + avatar.grid + '/' + avatar.fileName;
            } else {
                vm.userCopy.avatar.url = selectedContainer.view_url + avatar.fileName;
            }
            saveUser();
        }

        async function saveUser() {
            // Ensure we are working with an object before manipulation
            ensureParsed(vm.userCopy, 'user_params');

            if (vm.selectedUser.eventNumber != vm.userCopy.eventNumber) {
                let eventData = vm.userCopy.user_params?.events_data?.find(x => x.event_group_id == vm.selectedGroup.id_user_group);
                if (eventData) {
                    eventData.number = vm.userCopy.eventNumber;
                }
            }

            const media = vm.selectedUser.newMedia;
            delete vm.userCopy.newMedia;

            // REMOVED manual JSON.stringify to prevent double encoding. 
            // The service layer ($resource) will handle object serialization.

            try {
                if (vm.availableDownloads.id) {
                    await RuntagEventService.updateItem({
                        siteID: $scope.siteID,
                        section: 'user_assigns',
                        id: vm.availableDownloads.id,
                        item: vm.availableDownloads
                    });
                } else {
                    await RuntagEventService.createItem({
                        siteID: $scope.siteID,
                        section: 'user_assigns',
                        item: vm.availableDownloads
                    });
                }
            } catch (err) {
                $log.warn('[user_assigns upsert] fallo, continúo con saveUser()', err);
            }

            const payload = {
                id_user: vm.userCopy.id_user,
                firstname: vm.userCopy.firstname,
                lastname: vm.userCopy.lastname,
                user_params: JSON.stringify(vm.userCopy.user_params),
                password: vm.userCopy.password
            };

            const options = {
                site: $scope.siteID,
                id: vm.userCopy.id_user,
                item: payload
            };

            try {
                const response = await RuntagEventService.saveUser(options);
                const user = response;
                if (user.user_params) {
                    ensureParsed(user, 'user_params');
                    let event_data = user.user_params?.events_data?.find(x => x.event_group_id == vm.selectedGroup.id_user_group);
                    if (event_data) {
                        user.eventNumber = event_data.number;
                    }
                } else {
                    user.eventNumber = user.current_number;
                }
                vm.selectedUser = user;
                vm.selectedUser.newMedia = media;
                vm.selectUser(user);
                return response;
            } catch (err) {
                $log.error('[saveUser] error al guardar usuario', err);
                throw err;
            }
        }

        function cancelEditUser() {
            vm.userCopy = angular.copy(vm.selectedUser);
            vm.currentTab = 'preview';
        }

        //Dialog add transaction

        function openShoppingDialog(ev, user, order) {
            $mdDialog.show({
                controller: 'addTransactionsController',
                controllerAs: 'vm',
                locals: {
                    siteID: $scope.siteID,
                    user: user,
                    event: vm.selectedGroup,
                    client: vm.currentClient,
                    order: order,
                    paymentMethods: vm.paymentMethods,
                    // Eventos de carrito: alta de compra asignada a un perfil (dorsal) y, opcionalmente, a fotos
                    // concretas. El diálogo construye el files (profile_cart/mixed_cart) que autoriza descargas.
                    cartEnabled: vm.cartEnabled,
                    profiles: vm.runnerProfiles,
                    ensureProfilePhotos: function (profile) { return loadRunnerProfilePhotos(profile); },
                    profileLabel: function (profile) { return runnerProfileLabel(profile); }
                },
                templateUrl: 'app/main/apps/runtag/event/dialogs/shopping/add-transaction.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                multiple: true,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
            }).then(res => {
                selectUser(user);
                // Recargar los detalles con files → la vista Compras (y Perfiles) reflejan la nueva orden.
                if (vm.cartEnabled) { loadRunnerProfiles(true); }
            });
        }

        //Dialog media

        function openImageDialog(ev, imageSelected, images) {
            finishOpenImageDialog(ev, imageSelected, images);
            return;
        }

        function finishOpenImageDialog(ev, imageSelected, images) {
            var locals = {
                siteID: $scope.siteID,
                imagesToShow: images,
                selectedUser: vm.selectedUser,
                images: images,
                event: vm.selectedGroup.id_user_group,
                idEvent: vm.selectedGroup.id_events,
                apiUrl: vm.apiUrl,
                eventVersion: vm.eventVersion,
                client: vm.clients.find(x => x.id_clients === vm.selectedGroup.id_client),
                isAdmin: vm.isAdmin,
                // Eventos de carrito: al asignar una foto a un usuario, elegir a qué perfil (dorsal propio o
                // añadido). El diálogo usa estos helpers del controlador del evento (que ya tiene el servicio).
                cartEnabled: vm.cartEnabled,
                fetchProfilesForUser: fetchProfilesForUser,
                assignPhotoToProfile: assignPhotoToProfile
            }

            // El nombre de fichero (mediaId) NO es único: una búsqueda por nombre puede devolver varias fotos
            // distintas con el mismo mediaId. El id único es createdAt → lo pasamos para que el diálogo abra y
            // navegue por la foto correcta (si no, abría/paginaba siempre la primera coincidencia por nombre).
            locals.imageSelectedCreatedAt = imageSelected.createdAt || imageSelected.created_at || null;
            switch (vm.eventVersion) {
                case 'v2':
                    locals.imageSelected = imageSelected.mediaId;
                    var templateUrl = 'app/main/apps/runtag/event/dialogs/media/media-dialog-v2.html';
                    break;
                case 'v3':
                    locals.imageSelected = imageSelected.mediaId;
                    var templateUrl = 'app/main/apps/runtag/event/dialogs/media/media-dialog-v2.html';
                    break;
                default:
                    locals.imageSelected = imageSelected.media_id;
                    var templateUrl = 'app/main/apps/runtag/event/dialogs/media/media-dialog.html';
                    break;
            }
            $mdDialog.show({
                controller: 'mediaDialogControllerV2',
                controllerAs: 'vm',
                locals: locals,
                templateUrl: templateUrl,
                parent: angular.element(document.body),
                targetEvent: ev,
                multiple: true,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
            }).then(res => {
                if (res.action == 'searchByFaceId') {
                    // Recordar la pestaña de origen (p.ej. 'profiles') para volver a ella al resetear la búsqueda.
                    vm._searchFromTemplate = vm.filteredUserTemplate;
                    vm.searchedItems = res.data;
                    // Perfiles del usuario listos para el menú "asignar a perfil" de los resultados (solo carrito).
                    if (vm.cartEnabled && vm.selectedUser) { loadRunnerProfiles(); }
                    // Mostrar los resultados: la búsqueda puede lanzarse desde la pestaña Perfiles, pero quien pinta
                    // searchedItems es la vista 'media' → cambiamos a ella para que se vean.
                    changeTemplate('media');
                }
                if (!vm.selectedUser) {
                    if (res.action != 'searchByFaceId') {
                        vm.items = res.data;
                    }
                }
                if ($rootScope.reloadUser) {
                    selectUser(vm.selectedUser);
                    changeTemplate(vm.filteredUserTemplate);
                    $rootScope.reloadUser = false;
                } else {
                    delete $rootScope.reloadUser;
                }
            });
        }

        function changeSort() {
            resetMediaPagination();

            if (vm.actualView === 'user' && vm.allUserMedias && vm.allUserMedias.length > 0) {
                vm.allUserMedias.sort(function (a, b) {
                    var dateA = new Date(a.createdAt || a.created_at);
                    var dateB = new Date(b.createdAt || b.created_at);
                    return vm.sort === 'asc' ? dateA - dateB : dateB - dateA;
                });
            }

            switch (vm.actualView) {
                case 'all':
                    showAllMedia(vm.actualLocation ? vm.actualLocation : null);
                    break;
                case 'photographers':
                    filterPhotographers();
                    break;
                case 'unknown':
                    showAllUnrecognized();
                    break;
                case 'user':
                    if (vm.selectedUser) {
                        fetchMediaPage(null);
                    }
                    break;
            }
        }

        function changeLimit() {
            if (vm.limitPerPage && vm.limitMenu.indexOf(vm.limitPerPage) !== -1) {
                localStorage.setItem('runtag_limitPerPage', vm.limitPerPage);
            }
            resetMediaPagination();
            switch (vm.actualView) {
                case 'all':
                    showAllMedia(vm.actualLocation ? vm.actualLocation : null);
                    break;
                case 'photographers':
                    filterPhotographers();
                    break;
                case 'unknown':
                    showAllUnrecognized();
                    break;
                case 'user':
                    if (vm.selectedUser) {
                        vm.mediaPagination.history = [null];
                        vm.mediaPagination.currentIndex = 0;
                        fetchMediaPage(null);
                    }
                    break;
            }
        }

        function showAllMedia(location) {
            if (!vm.selectedGroup) {
                $mdToast.show({
                    template: '<md-toast id="error" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-close" class="icon"></md-icon><span class="md-toast-text" flex>First of all, you need to select an event</span></div></md-toast>',
                    hideDelay: 5000,
                    position: 'top',
                    parent: '#content-container'
                });
                return;
            }

            resetMediaPagination();
            vm.actualLocation = location ? location : undefined;
            vm.actualView = 'all';
            return fetchMediaPage(null);
        }

        function transformDate(date) {
            var dateToReturn = date;
            dateToReturn = dateToReturn.split("_")[0];
            return dateToReturn;
        }

        function showAllUnrecognized() {
            getUnrecognizedPhotos();
        }

        function getUnrecognizedPhotos(photographer) {
            if (!vm.selectedGroup) {
                $mdToast.show({
                    template: '<md-toast id="error" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-close" class="icon"></md-icon><span class="md-toast-text" flex>First of all, you need to select an event</span></div></md-toast>',
                    hideDelay: 5000,
                    position: 'top',
                    parent: '#content-container'
                });
                return;
            }

            resetMediaPagination();
            vm.photographerFilter = photographer ? photographer.camera_name : undefined;
            vm.actualView = 'unknown';
            fetchMediaPage(null);
        }

        function fetchMediaPage(pagingKey) {
            vm.loadingMore = true;
            vm.fullPage = true;

            // REUTILIZACIÓN DE DATOS LOCALES PARA VISTA USUARIO
            if (vm.actualView === 'user' && vm.allUserMedias && vm.allUserMedias.length > 0) {
                let filteredList = vm.allUserMedias;
                if (vm.mediaSearch) {
                    const search = vm.mediaSearch.toLowerCase();
                    filteredList = vm.allUserMedias.filter(function (item) {
                        const mediaId = (item.mediaId || item.id_media || "").toString().toLowerCase();
                        const filename = (item.filename || item.fileName || "").toString().toLowerCase();
                        const tags = (item.tags || []).join(" ").toLowerCase();
                        return mediaId.includes(search) || filename.includes(search) || tags.includes(search);
                    });
                }

                vm.mediaPagination.total = filteredList.length;

                var start = vm.mediaPagination.currentIndex * vm.limitPerPage;
                var end = start + vm.limitPerPage;
                vm.items = filteredList.slice(start, end);
                vm.mediaPagination.hasNext = filteredList.length > end;
                vm.loadingMore = false;

                // Trigger bulk storage tier check for archived events in local pagination
                if (vm.selectedGroup && vm.selectedGroup.id_subsec === 6 && vm.items.length > 0) {
                    let listToVerify = vm.items;
                    if (vm.actualView === 'user' && vm.allUserMedias && vm.allUserMedias.length > 0) {
                        listToVerify = vm.allUserMedias;
                    }

                    // Only set LOADING for items that don't have a status yet
                    const itemsToQuery = listToVerify.filter(m => !m.storageStatus);

                    if (itemsToQuery.length > 0) {
                        itemsToQuery.forEach(m => m.archiveStatus = 'LOADING');

                        RuntagEventService.getStorageTierBulk({
                            apiUrl: vm.apiUrl,
                            items: {
                                created_at_list: itemsToQuery.map(m => m.createdAt || m.created_at),
                                is_original: vm.isOriginal
                            }
                        }).then(tierResponse => {
                            if (angular.isArray(tierResponse)) {
                                tierResponse.forEach(tierInfo => {
                                    const media = itemsToQuery.find(m => (m.createdAt || m.created_at) === tierInfo.created_at);
                                    if (media) {
                                        media.storageClass = tierInfo.storage_class;
                                        media.storageStatus = tierInfo.status;

                                        if (tierInfo.status === 'archived') {
                                            media.archiveStatus = 'ARCHIVED';
                                        } else if (tierInfo.status === 'pending' || tierInfo.status === 'restoring') {
                                            media.archiveStatus = 'PENDING';
                                        } else if (tierInfo.status === 'restored') {
                                            media.archiveStatus = 'RESTORED';
                                        } else {
                                            media.archiveStatus = 'UNARCHIVED';
                                        }
                                    }
                                });
                            }
                        });
                    }
                } else {
                    angular.forEach(vm.items, function (item) {
                        item.archiveStatus = 'UNARCHIVE';
                    });
                }
                return;
            }

            vm.items = [];
            vm.loadingMore = true;
            var options = {
                apiUrl: vm.apiUrl,
                sort: vm.sort,
                limit: vm.actualView === 'user' ? 500 : vm.limitPerPage,
                pagingKey: pagingKey
            };

            var fetchPromise;

            if (vm.actualView === 'all' && vm.actualLocation) {
                vm.view = "app/main/apps/runtag/event/views/templates/events-all-media.html";
                options.location = vm.actualLocation.reference_name;
                fetchPromise = RuntagEventService.getMediasPablo(options);
            } else if (vm.actualView === 'all') {
                vm.view = "app/main/apps/runtag/event/views/templates/events-all-media.html";
                fetchPromise = RuntagEventService.getMediasPablo(options);
            } else if (vm.actualView === 'unknown') {
                vm.view = "app/main/apps/runtag/event/views/templates/events-all-media.html";
                options.hasDetectedFaces = false;
                if (vm.photographerFilter) {
                    options.photographer = vm.photographerFilter;
                }
                fetchPromise = RuntagEventService.getMediasPablo(options);
            } else if (vm.actualView === 'photographers') {
                vm.view = "app/main/apps/runtag/event/views/templates/events-search-media.html";
                options.photographer = vm.photographerFilter;
                fetchPromise = RuntagEventService.getMediasPablo(options);
            } else if (vm.actualView === 'user') {
                options.number = vm.selectedUser.eventNumber;
                options.limit = 500;
                // Si el usuario resolvió su perfil por CARA (eligió/subió su cara), la web NO le muestra la
                // galería del dorsal sino la unión de esa cara. Aquí se hace lo mismo para que el admin vea
                // EXACTAMENTE lo que ve el corredor; si no, veía el reco del dorsal (que puede llevar fotos de
                // otra persona y faltarle las que solo encuentra la cara).
                var ownFaces = selectedUserOwnFaceIds();
                if (ownFaces.length) {
                    fetchPromise = $q.all(ownFaces.map(function (fid) {
                        return RuntagEventService.searchByFacePablo({
                            apiUrl: vm.apiUrl, version: vm.eventVersion, faceId: fid
                        }).then(function (r) {
                            return angular.isArray(r) ? r : ((r && r.items) || (r && r.data) || []);
                        }).catch(function () { return []; });
                    })).then(function (arrays) {
                        // Unión de las caras ∪ claims MANUALES del dorsal (el OCR automático se descarta:
                        // es el que asocia fotos de otros). Dedup por created_at, que es el id único.
                        return fetchRunnerMediaAllPages(options.number, MANUAL_CLAIM_SCAN_MAX_PAGES)
                            .catch(function () { return { data: [] }; })
                            .then(function (recoResp) {
                                var manual = ((recoResp && recoResp.data) || [])
                                    .filter(isManualClaimForDorsal(options.number));
                                var byKey = {};
                                arrays.concat([manual]).forEach(function (arr) {
                                    (arr || []).forEach(function (m) {
                                        if (!m) { return; }
                                        var k = (m.createdAt || m.created_at) || (m.mediaId || m.id);
                                        if (k && !byKey[k]) { byKey[k] = m; }
                                    });
                                });
                                var merged = Object.keys(byKey).map(function (k) { return byKey[k]; });
                                return { data: merged, count: merged.length };
                            });
                    });
                } else {
                    fetchPromise = fetchRunnerMediaAllPages(options.number, RUNNER_MEDIA_MAX_PAGES);
                }
            }


            return fetchPromise.then(function (response) {
                if (response.data && response.data.length > 0) {
                    var processedData = response.data.map(function (item) {
                        return constructImage(item);
                    });

                    if (vm.actualView === 'user') {
                        // Guardar todo para paginación y orden local
                        vm.allUserMedias = processedData;

                        // Ordenamiento LOCAL por defecto (fecha descendente)
                        vm.allUserMedias.sort(function (a, b) {
                            return new Date(b.createdAt || b.created_at) - new Date(a.createdAt || a.created_at);
                        });

                        vm.mediaPagination.total = response.count || response.total || vm.allUserMedias.length;
                        if (vm.selectedUser) { vm.selectedUser.imagesCount = response.count || response.total || vm.allUserMedias.length; }

                        // Slicing para la primera página
                        var start = vm.mediaPagination.currentIndex * vm.limitPerPage;
                        var end = start + vm.limitPerPage;
                        vm.items = vm.allUserMedias.slice(start, end);
                        vm.selectedUser.newMedia = vm.items;
                        vm.mediaPagination.hasNext = vm.allUserMedias.length > end;
                    } else {
                        vm.items = processedData;
                        vm.lastItem = response.LastEvaluatedKey;
                        vm.mediaPagination.hasNext = !!response.LastEvaluatedKey;
                    }

                    // Trigger bulk storage tier check for archived events
                    if (vm.selectedGroup && vm.selectedGroup.id_subsec === 6 && vm.items.length > 0) {
                        let listToVerify = vm.items;
                        if (vm.actualView === 'user' && vm.allUserMedias && vm.allUserMedias.length > 0) {
                            listToVerify = vm.allUserMedias;
                        }

                        // Only set LOADING for items that don't have a status yet
                        const itemsToQuery = listToVerify.filter(m => !m.storageStatus);

                        if (itemsToQuery.length > 0) {
                            itemsToQuery.forEach(m => m.archiveStatus = 'LOADING');

                            RuntagEventService.getStorageTierBulk({
                                apiUrl: vm.apiUrl,
                                items: {
                                    created_at_list: itemsToQuery.map(m => m.createdAt || m.created_at),
                                    is_original: vm.isOriginal
                                }
                            }).then(tierResponse => {
                                if (angular.isArray(tierResponse)) {
                                    tierResponse.forEach(tierInfo => {
                                        const media = itemsToQuery.find(m => (m.createdAt || m.created_at) === tierInfo.created_at);
                                        if (media) {
                                            media.storageClass = tierInfo.storage_class;
                                            media.storageStatus = tierInfo.status;

                                            // Map status to archiveStatus for UI
                                            if (tierInfo.status === 'archived') {
                                                media.archiveStatus = 'ARCHIVED';
                                            } else if (tierInfo.status === 'pending' || tierInfo.status === 'restoring') {
                                                media.archiveStatus = 'PENDING';
                                            } else if (tierInfo.status === 'restored') {
                                                media.archiveStatus = 'RESTORED';
                                            } else {
                                                media.archiveStatus = 'UNARCHIVED';
                                            }
                                        }
                                    });
                                }
                            });
                        }
                    }
                }
                vm.loadingMore = false;
                vm.isLoadingGroups = false;
            }).catch(function (error) {
                $log.error("Error loading media page:", error);
                vm.loadingMore = false;
                vm.isLoadingGroups = false;
            });
        }

        function nextPage() {
            if (!vm.mediaPagination.hasNext || vm.loadingMore) return;
            vm.mediaPagination.currentIndex++;
            vm.mediaPagination.history[vm.mediaPagination.currentIndex] = vm.lastItem;
            fetchMediaPage(vm.lastItem);
        }

        function prevPage() {
            if (vm.mediaPagination.currentIndex === 0 || vm.loadingMore) return;
            vm.mediaPagination.currentIndex--;
            fetchMediaPage(vm.mediaPagination.history[vm.mediaPagination.currentIndex]);
        }

        function loadMoreMedia() {
            // Deprecated in favor of pagination
            vm.nextPage();
        }

        function filterUserMedia() {
            resetMediaPagination();
            fetchMediaPage(null);
        }

        function clearMediaSearch() {
            vm.mediaSearch = '';
            vm.filterUserMedia();
        }

        function getBackAllMedia() {
            vm.resetSearchByFace();
            vm.photographerFilter = undefined;
            vm.actualView = undefined;
            vm.querySearch = "";
            vm.isFiltered = false;
            vm.isLoadingGroups = false;
            vm.fullPage = false;
            vm.view = "app/main/apps/runtag/event/views/templates/events-template-v2.html";
            vm.items = [];
            vm.lastItem = "";
        }

        function findTotalCurrency(currency) {
            var ret = 0;
            if (vm.totalOrdersByCurrency) {
                var total = vm.totalOrdersByCurrency.find(x => x.currency_code == currency);
                if (total) {
                    ret = parseFloat(total.sum) || 0;
                }
            }
            // OJO: los pagos manuales NO se suman aquí. totalOrdersByCurrency se calcula SIN filtrar por
            // método de pago, así que ya los incluye; sumarlos otra vez (como se hacía) inflaba el total en
            // moneda local por el importe manual del evento. vm.manualOrdersByCurrency se mantiene porque
            // sirve para mostrar el desglose manual, no para el total.
            return ret;
        }

        function openImportDialog(ev) {
            vm.selectedGroup.id_group = vm.selectedGroup.id_user_group;
            $mdDialog.show({
                controller: 'ImportDialogController',
                controllerAs: 'vm',
                locals: {
                    siteID: $scope.siteID,
                    rootGroup: vm.isQiuRestricted ? vm.rootGroup : null,
                    selectedGroup: vm.selectedGroup ? vm.selectedGroup : vm.selectedGroupsAcc ? vm.selectedGroupsAcc[0] : null
                },
                templateUrl: 'app/main/apps/runtag/event/dialogs/import/import-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            })
                .then(function (result) {
                    if (result && result.update) {
                        selectEvent(vm.selectedGroup);
                    }
                });
        }

        function changeSubsec(event, $event) {
            $event.stopPropagation();
            const selectedSubsec = vm.eventsStates.find(x => x.subsec === event.event_state).id_subsec;
            $mdDialog.show({
                controller: 'changeSubsecEventController',
                controllerAs: 'vm',
                locals: {
                    selectedSubsec: selectedSubsec,
                    eventsSubsecs: vm.eventsStates,
                    selectedLanguage: vm.selectedLanguage
                },
                templateUrl: 'app/main/apps/runtag/event/dialogs/event/change-subsec-event.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                multiple: true,
                fullscreen: true
            }).then(function (result) {
                if (result.selected) {
                    const newSubsec = result.selected;
                    const oldSubsec = selectedSubsec;
                    if (newSubsec != oldSubsec) {
                        const updateEvent = {
                            id: event.event_id,
                            id_subsec: newSubsec
                        }
                        const options = {
                            item: updateEvent,
                            siteID: $scope.siteID,
                            id: event.event_id,
                            section: 'events',
                            keepOldMedia: true
                        }
                        RuntagEventService.updateItem(options).then(response => {
                            if (response.result === 'update') {
                                const newStatus = vm.eventsStates.find(x => x.id_subsec === newSubsec);
                                let updateEvent = vm.eventsGroup.find(x => x.event_id === event.event_id);
                                updateEvent.event_state = newStatus.subsec;
                                event.event_state_name = newStatus.translations[vm.selectedLanguage] || newStatus.subsec;
                                event.event_state_color = newStatus.color;
                            }
                        });
                    }
                }
            });
        }

        function editEvent() {
            $mdDialog.show({
                controller: 'newEventModalController',
                controllerAs: 'vm',
                locals: {
                    siteID: $scope.siteID,
                    event: vm.selectedGroup,
                    clients: vm.clients,
                    paymentMethods: vm.paymentMethods,
                    selectedEvent: vm.selectedGroup,
                    products: vm.products,
                    apiUrl: vm.apiUrl
                },
                templateUrl: 'app/main/apps/runtag/event/dialogs/event/new-event-modal.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                multiple: true,
                onShowing: function (scope, element) {
                    element.addClass('new-event-modal');
                },
                fullscreen: true
            }).then(function (result) {
                $log.warn('Modal cerrado con:', result);
            }, function () {
                $log.warn('Modal cancelado');
            });
        }

        function isAllSearchedItemsSelected() {
            if (!vm.searchedItems || !vm.searchedItems.length) return false;
            return vm.searchedItems.every(item => vm.selectedMedias.includes(item));
        }

        function toggleSelectAllSearchedItems() {
            if (isAllSearchedItemsSelected()) {
                // Deselect all searched items
                vm.searchedItems.forEach(item => {
                    const idx = vm.selectedMedias.indexOf(item);
                    if (idx > -1) {
                        vm.selectedMedias.splice(idx, 1);
                    }
                });
            } else {
                // Select all searched items
                vm.searchedItems.forEach(item => {
                    if (!vm.selectedMedias.includes(item)) {
                        vm.selectedMedias.push(item);
                    }
                });
            }
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.users')
        .factory("transformMedia", transformMedia);



    /** @ngInject */
    function transformMedia() {

        var service = {
            formatNestedGalleries: formatNestedGalleries,
            preAssignQiuRestrictedRoot: preAssignQiuRestrictedRoot,
            assignLightboxOwners: assignLightboxOwners
        };

        function getTotalCount(parent) {
            var sum = parent.total_media_count;
            if (parent.children){
                for (var i = 0; i < parent.children.length; i++) {
                    const element = parent.children[i];
                    sum += element.total_media_count
                    if (element.children) {
                        for (let j = 0; j < element.children.length; j++) {
                            const child = element.children[j];
                            sum += getTotalCount(child)
                        }
                    }
                }
            }
            return sum;
        }

        function formatNestedGalleries(galleries, qiuRestrictions, isRootCycle) {
            if (galleries) {
                for (var i = 0; i < galleries.length; i++) {
                    var gallery = galleries[i];
                    gallery.id = gallery.id_gallery;
                    gallery.label = gallery.name;
                    gallery.element_total_count = getTotalCount(gallery);
                    gallery.is_qiu_restricted = isGalleryQiuRestricted(gallery.id_gallery, qiuRestrictions);
                    gallery.is_qiu_restricted_root = isRootCycle && gallery.is_qiu_restricted;
                    if (gallery.children) {
                        formatNestedGalleries(gallery.children, qiuRestrictions, false);
                    }
                }
            } else {
                return [];
            }
            return galleries;
        }

        function isGalleryQiuRestricted(galleryId, qiuRestrictions) {
            return (qiuRestrictions
                    && (
                            (qiuRestrictions.hasOwnProperty('id_gallery') &&
                                Object.values(qiuRestrictions.id_gallery).indexOf(galleryId) > -1)
                        ||
                            (qiuRestrictions.hasOwnProperty('galleries_sub') &&
                                Object.values(qiuRestrictions.galleries_sub).indexOf(galleryId) > -1)
                        )
                    )
        }

        function preAssignQiuRestrictedRoot(galleries) {
          if (angular.isArray(galleries) &&
              galleries.length > 0 &&
                galleries[0].is_qiu_restricted_root
          ) {
            galleries[0].assigned_gallery = true;
          }
        }

        function assignLightboxOwners(galleries, owners) {
            if (angular.isArray(galleries) &&
              galleries.length > 0
            ) {
                for (var i = 0; i < galleries.length; i++) {
                    if (galleries[i].raw_settings &&
                        galleries[i].raw_settings.hasOwnProperty('lightbox') &&
                        galleries[i].raw_settings.lightbox.hasOwnProperty('owner')
                    ) {
                        galleries[i].owner = owners.find(function(owner) {
                            return owner.id_user == galleries[i].raw_settings.lightbox.owner
                        })
                    }
                    if (galleries[i].children){
                        assignLightboxOwners(galleries[i].children, owners)
                    }
                }
            }
        }

        return service;
    }


})();

(function () {
    'use strict';

    angular
        .module('app.mediahub')
        .service('mediahubTagsService', mediahubTagsService);

    /** @ngInject */
    function mediahubTagsService($http, $q, mediahubService) {

        var service = {
            getTags  : getTags,
            getTag   : getTag,
            createTag: createTag,
            updateTag: updateTag,
            deleteTag: deleteTag
        };

        return service;

        // ─── helpers ─────────────────────────────────────────────────────────
        // The shared mediahub headers: X-Tenant AND the x-api-key. Without the key the strict
        // API Gateways (americascup, demo1...) answer 403 with no CORS headers.
        function headers() {
            return angular.extend(mediahubService.mhHeaders(), {
                'Content-Type': 'application/json'
            });
        }

        function baseUrl() {
            return mediahubService.getApiUrl() + 'tags';
        }

        // ─── GET /tags ────────────────────────────────────────────────────────
        function getTags(tagType) {
            var params = tagType ? { tagType: tagType } : {};
            return $http.get(baseUrl(), { headers: headers(), params: params })
                .then(function (res) {
                    return (res.data && res.data.data && res.data.data.tags)
                        ? res.data.data.tags : [];
                });
        }

        // ─── GET /tags/{tagName} ──────────────────────────────────────────────
        function getTag(tagName) {
            return $http.get(baseUrl() + '/' + encodeURIComponent(tagName), { headers: headers() })
                .then(function (res) { return res.data && res.data.data ? res.data.data : res.data; });
        }

        // ─── POST /tags ───────────────────────────────────────────────────────
        function createTag(tag) {
            return $http.post(baseUrl(), tag, { headers: headers() })
                .then(function (res) { return res.data; });
        }

        // ─── PUT /tags/{tagName} ──────────────────────────────────────────────
        function updateTag(tagName, tag) {
            return $http.put(baseUrl() + '/' + encodeURIComponent(tagName), tag, { headers: headers() })
                .then(function (res) { return res.data; });
        }

        // ─── DELETE /tags/{tagName} ───────────────────────────────────────────
        function deleteTag(tagName) {
            return $http.delete(baseUrl() + '/' + encodeURIComponent(tagName), { headers: headers() })
                .then(function (res) { return res.data; });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.mediahub')
        .controller('MediahubTagsController', MediahubTagsController);

    /** @ngInject */
    function MediahubTagsController(mediahubTagsService, mediahubService, sessionService,
                                    $stateParams, $mdToast, $mdDialog, $log, $q, $translate) {
        var vm = this;

        // ─── views ────────────────────────────────────────────────────────────
        vm.currentView = 'split';
        vm.views = {
            split: 'app/main/apps/mediahub/tags/views/list/split-view.html'
        };

        // ─── data ─────────────────────────────────────────────────────────────
        // GET /tags has no pagination: it answers every tag of the tenant at once (americascup:
        // ~5,000 tags, ~470 KB, ~1 s). The request is not the slow part — rendering 5,000 rows
        // and re-filtering them on every digest was. So the list is loaded ONCE and filtered,
        // sorted and paged here; only the current page reaches the DOM.
        vm.allTags          = [];   // every tag, sorted by name ascending
        vm.visibleTags      = [];   // the current page
        vm.filteredCount    = 0;
        vm.page             = 1;
        vm.pageSize         = 50;

        vm.selectedContent  = null;
        vm.currentThread_Edit = null;
        vm.isNewThread      = false;
        vm.editInline       = false;
        vm.isLoading        = true;
        vm.loadingReadPane  = false;
        vm.selectedThreads  = [];
        vm.basicForm        = {};

        // ─── filter / search ──────────────────────────────────────────────────
        // Types to FILTER by come from the data (object, text, face, phase...): the tenants carry
        // many more than the API accepts on write. Types to WRITE are the API enum (TAG_TYPES in
        // tags.handler.ts); anything else answers 400.
        vm.tagTypes          = [];  // [{ type, count }]
        vm.editableTagTypes  = ['category', 'people', 'sponsors', 'team'];
        vm.filterType   = null;
        vm.filterVerify = null;
        vm.searchQuery  = '';
        vm.sortDir      = 'ASC';

        // ─── methods ──────────────────────────────────────────────────────────
        vm.loadTags            = loadTags;
        vm.setTypeFilter       = setTypeFilter;
        vm.search              = search;
        vm.setSortDir          = setSortDir;
        vm.prevPage            = prevPage;
        vm.nextPage            = nextPage;
        vm.pageFrom            = pageFrom;
        vm.pageTo              = pageTo;
        vm.editTypeOptions     = editTypeOptions;
        vm.goToPage            = goToPage;
        vm.pageNumbers         = pageNumbers;
        vm.resetFilters        = resetFilters;
        vm.pages               = [1];

        vm.openThread          = openThread;
        vm.closeThread         = closeThread;
        vm.newThread           = newThread;
        vm.viewEditInline      = viewEditInline;
        vm.closeThreadEdit     = closeThreadEdit;
        vm.saveItem            = saveItem;
        vm.deleteTag           = deleteTag;
        vm.toggleVerify        = toggleVerify;

        vm.isChecked           = isChecked;
        vm.isSelected          = isSelected;
        vm.toggleSelectThread  = toggleSelectThread;
        vm.toggleSelectThreads = toggleSelectThreads;
        vm.massDelete          = massDelete;

        vm.setVerifyFilter     = setVerifyFilter;
        vm.viewPreview         = viewPreview;

        init();

        // ─── init ─────────────────────────────────────────────────────────────
        /** Corporate x-api-key from qiu_config.mediahub (object or JSON string). */
        function mediahubApiKey(response) {
            var mh = response && response.mediahub;
            if (typeof mh === 'string') {
                try { mh = angular.fromJson(mh); } catch (e) { mh = null; }
            }
            return (mh && mh['x-api-key']) || '';
        }

        function init() {
            // Always initialize the mediahub API URL from domain config,
            // regardless of whether we navigated from the mediahub page or loaded directly.
            sessionService.loadDomainResourceSettings($stateParams.siteId)
                .then(function (response) {
                    if (response && response.public) {
                        var cfg = angular.fromJson(response.public);
                        if (cfg.mediahubUrl) {
                            mediahubService.setApiUrl(
                                cfg.mediahubUrl,
                                cfg.mediahubTenant || 'demo1',
                                cfg.mediahubS3 || ''
                            );
                            mediahubService.setApiKey(mediahubApiKey(response));
                            mediahubService.setVertexUrl(cfg.vertexUrl || '');
                            vm.hasVertex = !!cfg.vertexUrl;
                            loadTags();
                        } else {
                            vm.isLoading = false;
                            showToast('MH_TAGS.NO_MEDIAHUB_URL');
                        }
                    } else {
                        vm.isLoading = false;
                    }
                })
                .catch(function (err) {
                    $log.error('Error loading domain settings', err);
                    vm.isLoading = false;
                    showToast('MH_TAGS.ERROR_CONFIG');
                });
        }

        /** Always every type: the API's `tagType` filter only knows its 4-value enum. */
        function loadTags() {
            vm.isLoading = true;
            mediahubTagsService.getTags(null)
                .then(function (data) {
                    vm.allTags = sortByName(Array.isArray(data) ? data : []);
                    rebuildTypes();
                    // A reload keeps the tag being read in sync with what the API now says.
                    if (vm.selectedContent && !vm.isNewThread) {
                        vm.selectedContent = findTag(vm.selectedContent.tagName) || null;
                    }
                    refresh(true);
                })
                .catch(function (err) {
                    $log.error('Error loading tags', err);
                    showToast('MH_TAGS.ERROR_LOADING');
                })
                .finally(function () {
                    vm.isLoading = false;
                });
        }

        // ─── list: filter, sort, page ─────────────────────────────────────────
        var collator = (window.Intl && Intl.Collator) ? new Intl.Collator(undefined, { sensitivity: 'base', numeric: true }) : null;

        function compareNames(a, b) {
            var x = a.tagName || '', y = b.tagName || '';
            return collator ? collator.compare(x, y) : x.toLowerCase().localeCompare(y.toLowerCase());
        }

        function sortByName(list) {
            return list.slice().sort(compareNames);
        }

        function findTag(name) {
            for (var i = 0; i < vm.allTags.length; i++) {
                if (vm.allTags[i].tagName === name) return vm.allTags[i];
            }
            return null;
        }

        function rebuildTypes() {
            var counts = {};
            vm.allTags.forEach(function (t) {
                var type = t.tagType || '';
                counts[type] = (counts[type] || 0) + 1;
            });
            vm.tagTypes = Object.keys(counts).filter(Boolean).sort().map(function (type) {
                return { type: type, count: counts[type] };
            });
            if (vm.filterType && !counts[vm.filterType]) {
                vm.filterType = null;
            }
        }

        /**
         * Recomputes the filtered list and the visible page. Called on every change of data or
         * filters — never from the template, so a digest costs 50 rows and not 5,000.
         * @param {boolean} keepPage stay on the current page (clamped) instead of going to 1
         */
        function refresh(keepPage) {
            var q = (vm.searchQuery || '').toLowerCase();
            var verify = vm.filterVerify === null || vm.filterVerify === undefined || vm.filterVerify === ''
                ? null : (vm.filterVerify === 'true' || vm.filterVerify === true);

            var list = vm.allTags.filter(function (t) {
                if (vm.filterType && t.tagType !== vm.filterType) return false;
                if (verify !== null && !!t.verify !== verify) return false;
                if (q) {
                    return (t.tagName   && t.tagName.toLowerCase().indexOf(q)   >= 0) ||
                           (t.parentTag && t.parentTag.toLowerCase().indexOf(q) >= 0);
                }
                return true;
            });
            if (vm.sortDir === 'DESC') {
                list.reverse();
            }

            vm.filteredCount = list.length;
            var pages = Math.max(1, Math.ceil(list.length / vm.pageSize));
            vm.page = keepPage ? Math.min(Math.max(1, vm.page), pages) : 1;
            if (vm.totalPages !== pages || vm.pages.length !== pages) {
                // Cached array: the page select repeats over it on every digest.
                vm.pages = [];
                for (var p = 1; p <= pages; p++) vm.pages.push(p);
            }
            vm.totalPages = pages;
            var start = (vm.page - 1) * vm.pageSize;
            vm.visibleTags = list.slice(start, start + vm.pageSize);
            vm._filtered = list;
        }

        function pageFrom() {
            return vm.filteredCount ? (vm.page - 1) * vm.pageSize + 1 : 0;
        }

        function pageTo() {
            return Math.min(vm.page * vm.pageSize, vm.filteredCount);
        }

        function pageNumbers() {
            return vm.pages;
        }

        function goToPage(n) {
            vm.page = Number(n) || 1;
            refresh(true);
            scrollListTop();
        }

        /** A new page starts at its first row, not where the previous one was left scrolled. */
        function scrollListTop() {
            var list = document.getElementById('mh-tags-list-data');
            if (list) list.scrollTop = 0;
        }

        function resetFilters() {
            vm.filterType = null;
            vm.filterVerify = null;
            vm.searchQuery = '';
            refresh(false);
        }

        function prevPage() {
            if (vm.page > 1) {
                vm.page--;
                refresh(true);
                scrollListTop();
            }
        }

        function nextPage() {
            if (vm.page < vm.totalPages) {
                vm.page++;
                refresh(true);
                scrollListTop();
            }
        }

        function setTypeFilter(type) {
            vm.filterType = type || null;
            refresh(false);
        }

        function setVerifyFilter(val) {
            vm.filterVerify = val || null;
            refresh(false);
        }

        function viewPreview() {
            vm.editInline = false;
            vm.currentThread_Edit = null;
        }

        function search(query) {
            vm.searchQuery = query || '';
            refresh(false);
        }

        function setSortDir(dir) {
            vm.sortDir = dir;
            refresh(false);
        }

        /**
         * Type options for the edit form: the writable enum, plus the tag's own type when it is
         * outside it (e.g. `object`) so the select still shows what the tag is. That type cannot
         * be chosen again once changed away from — the API would reject it.
         */
        function editTypeOptions() {
            var current = vm.currentThread_Edit && vm.currentThread_Edit._originalType;
            var options = vm.editableTagTypes.slice();
            if (current && options.indexOf(current) === -1) {
                options.unshift(current);
            }
            return options;
        }

        // ─── thread open / close ──────────────────────────────────────────────
        function openThread(tag) {
            vm.selectedContent  = tag;
            vm.editInline       = false;
            vm.currentThread_Edit = null;
            vm.isNewThread      = false;
            loadTagUsage(tag);
        }

        // ─── usage (TRIAL: from Vertex; remove if it does not work out) ───────
        // `vm.tagUsage`: null = no Vertex on this tenant; { loading } while asking;
        // { total, items } or { error } once answered.
        vm.tagUsage = null;
        var usageRequest = 0;

        function loadTagUsage(tag) {
            if (!vm.hasVertex || !tag || !tag.tagName) {
                vm.tagUsage = null;
                return;
            }
            var requestId = ++usageRequest;
            vm.tagUsage = { loading: true, tagName: tag.tagName };
            mediahubService.getTagUsageFromVertex(tag.tagName, 6)
                .then(function (usage) {
                    if (requestId !== usageRequest) return;   // a newer tag was opened meanwhile
                    vm.tagUsage = usage ? angular.extend({ tagName: tag.tagName }, usage) : null;
                })
                .catch(function (err) {
                    if (requestId !== usageRequest) return;
                    $log.warn('Tag usage from Vertex failed', err);
                    vm.tagUsage = { error: true, tagName: tag.tagName };
                });
        }

        function closeThread() {
            vm.selectedContent    = null;
            vm.editInline         = false;
            vm.currentThread_Edit = null;
            vm.isNewThread        = false;
        }

        function newThread() {
            vm.selectedContent = {};         // truthy so read panel opens
            vm.isNewThread     = true;
            vm.editInline      = true;
            vm.currentThread_Edit = {
                tagName        : '',
                tagType        : 'category',
                verify         : false,
                faceExternalId : '',
                parentTag      : ''
            };
        }

        function viewEditInline() {
            vm.editInline = true;
            vm.currentThread_Edit = angular.copy(vm.selectedContent);
            // ensure all camelCase fields present
            vm.currentThread_Edit.tagName        = vm.currentThread_Edit.tagName        || '';
            vm.currentThread_Edit.tagType        = vm.currentThread_Edit.tagType        || '';
            vm.currentThread_Edit.parentTag      = vm.currentThread_Edit.parentTag      || '';
            vm.currentThread_Edit.faceExternalId = vm.currentThread_Edit.faceExternalId || '';
            vm.currentThread_Edit.verify         = !!vm.currentThread_Edit.verify;
            vm.currentThread_Edit._originalType  = vm.currentThread_Edit.tagType;
        }

        function closeThreadEdit() {
            vm.editInline = false;
            vm.currentThread_Edit = null;
            if (vm.isNewThread) {
                closeThread();
            }
        }

        // ─── save ─────────────────────────────────────────────────────────────
        /**
         * Sends only what the API accepts. Updates carry the fields the form edits — never the
         * whole tag: a PUT echoing a `tagType` outside the enum (object, text, face...) answers
         * 400, which is what broke saving most of americascup's tags.
         */
        function saveItem(tag) {
            if (!tag || !tag.tagName) { return; }
            var isNew = vm.isNewThread;
            var payload;

            if (isNew) {
                // POST /tags is a PutItem with no condition: a name that already exists is
                // silently OVERWRITTEN (type, verification and face id lost). Refuse it here and
                // open the existing tag instead.
                var existing = findTag(tag.tagName.trim());
                if (existing) {
                    showToast('MH_TAGS.ALREADY_EXISTS', { name: existing.tagName });
                    vm.editInline = false;
                    vm.currentThread_Edit = null;
                    vm.isNewThread = false;
                    openThread(existing);
                    return;
                }
                payload = {
                    tagName : tag.tagName.trim(),
                    tagType : vm.editableTagTypes.indexOf(tag.tagType) >= 0 ? tag.tagType : 'category',
                    verify  : !!tag.verify
                };
                if (tag.parentTag) payload.parentTag = tag.parentTag;
                if (payload.tagType === 'people' && tag.faceExternalId) payload.faceExternalId = tag.faceExternalId;
            } else {
                payload = {
                    verify    : !!tag.verify,
                    parentTag : tag.parentTag || null     // empty = clear (task-222)
                };
                if (tag.tagType !== tag._originalType && vm.editableTagTypes.indexOf(tag.tagType) >= 0) {
                    payload.tagType = tag.tagType;
                }
                if (tag.tagType === 'people') {
                    payload.faceExternalId = tag.faceExternalId || null;
                }
            }

            var EXISTS = 'tag-already-exists';
            var promise = isNew
                // The local list may be stale (someone else created it meanwhile): ask the API
                // right before writing. 404 = free to create.
                ? mediahubTagsService.getTag(payload.tagName).then(function (found) {
                    if (found && found.tagName) {
                        return $q.reject({ reason: EXISTS, tag: found });
                    }
                    return mediahubTagsService.createTag(payload);
                }, function (err) {
                    return err && err.status === 404 ? mediahubTagsService.createTag(payload) : $q.reject(err);
                })
                : mediahubTagsService.updateTag(tag.tagName, payload);

            promise
                .then(function (res) {
                    showToast(isNew ? 'MH_TAGS.CREATED_TAG' : 'MH_TAGS.UPDATED');
                    var saved = (res && res.data && res.data.tagName) ? res.data : null;
                    // Patched in place: reloading ~470 KB after every edit is what made the
                    // screen feel slow. The refresh button still reloads from the API.
                    var target = isNew ? null : findTag(tag.tagName);
                    if (target) {
                        angular.extend(target, saved || payload);
                        if (!saved && payload.parentTag === null) delete target.parentTag;
                    } else {
                        target = saved || angular.extend({ createdAt: new Date().toISOString() }, payload);
                        vm.allTags = sortByName(vm.allTags.concat([target]));
                    }
                    rebuildTypes();
                    refresh(true);
                    vm.editInline = false;
                    vm.currentThread_Edit = null;
                    vm.isNewThread = false;
                    vm.selectedContent = target;
                })
                .catch(function (err) {
                    if (err && err.reason === EXISTS) {
                        showToast('MH_TAGS.ALREADY_EXISTS', { name: err.tag.tagName });
                        var known = findTag(err.tag.tagName);
                        if (!known) {
                            known = err.tag;
                            vm.allTags = sortByName(vm.allTags.concat([known]));
                            rebuildTypes();
                            refresh(true);
                        }
                        vm.editInline = false;
                        vm.currentThread_Edit = null;
                        vm.isNewThread = false;
                        openThread(known);
                        return;
                    }
                    $log.error('Error saving tag', err);
                    showToast(apiMessage(err) || 'MH_TAGS.ERROR_SAVING');
                });
        }

        function removeFromList(names) {
            var gone = {};
            names.forEach(function (n) { gone[n] = true; });
            vm.allTags = vm.allTags.filter(function (t) { return !gone[t.tagName]; });
            vm.selectedThreads = vm.selectedThreads.filter(function (t) { return !gone[t.tagName]; });
            rebuildTypes();
            refresh(true);
        }

        // ─── delete ───────────────────────────────────────────────────────────
        function deleteTag(tag, $event) {
            var confirm = $mdDialog.confirm()
                .title($translate.instant('MH_TAGS.DELETE_ONE_TITLE', { name: tag.tagName }))
                .textContent($translate.instant('MH_TAGS.DELETE_CANNOT_UNDO'))
                .targetEvent($event)
                .ok($translate.instant('MH_TAGS.DELETE'))
                .cancel($translate.instant('MH_TAGS.CANCEL'));

            $mdDialog.show(confirm).then(function () {
                mediahubTagsService.deleteTag(tag.tagName)
                    .then(function () {
                        showToast('MH_TAGS.DELETED');
                        closeThread();
                        removeFromList([tag.tagName]);
                    })
                    .catch(function (err) {
                        $log.error('Error deleting tag', err);
                        showToast(apiMessage(err) || 'MH_TAGS.ERROR_DELETING');
                    });
            });
        }

        // ─── toggle verify inline (from list row) ─────────────────────────────
        function toggleVerify($event, thread) {
            $event.stopPropagation();
            var next = !thread.verify;
            // Only `verify`: see saveItem for why the whole tag must not be echoed back.
            mediahubTagsService.updateTag(thread.tagName, { verify: next })
                .then(function () {
                    thread.verify = next;
                    if (vm.selectedContent && vm.selectedContent.tagName === thread.tagName) {
                        vm.selectedContent.verify = next;
                    }
                    // Under a verify filter the row no longer belongs to the page.
                    if (vm.filterVerify) refresh(true);
                })
                .catch(function (err) {
                    $log.error('Error updating verify', err);
                    showToast(apiMessage(err) || 'MH_TAGS.ERROR_SAVING');
                });
        }

        // ─── selection (checkboxes) ───────────────────────────────────────────
        function isChecked(tag) {
            return isSelected(tag);
        }

        function isSelected(tag) {
            return vm.selectedThreads.some(function (t) {
                return t.tagName === tag.tagName;
            });
        }

        function toggleSelectThread(tag, $event) {
            if ($event) { $event.stopPropagation(); }
            var idx = vm.selectedThreads.findIndex(function (t) {
                return t.tagName === tag.tagName;
            });
            if (idx >= 0) {
                vm.selectedThreads.splice(idx, 1);
            } else {
                vm.selectedThreads.push(tag);
            }
        }

        /** Select all = the current PAGE, not the thousands behind the filter. */
        function toggleSelectThreads() {
            if (vm.selectedThreads.length > 0) {
                vm.selectedThreads = [];
            } else {
                vm.selectedThreads = vm.visibleTags.slice();
            }
        }

        function massDelete($event) {
            if (!vm.selectedThreads.length) { return; }
            var confirm = $mdDialog.confirm()
                .title($translate.instant('MH_TAGS.DELETE_MANY_TITLE', { count: vm.selectedThreads.length }))
                .textContent($translate.instant('MH_TAGS.DELETE_CANNOT_UNDO'))
                .targetEvent($event)
                .ok($translate.instant('MH_TAGS.DELETE'))
                .cancel($translate.instant('MH_TAGS.CANCEL'));

            $mdDialog.show(confirm).then(function () {
                var names = vm.selectedThreads.map(function (t) { return t.tagName; });
                var deleted = [];
                // $q (not Promise) so the list updates inside a digest. Each delete settles on its
                // own: what did go is removed from the list even when another one failed.
                $q.all(names.map(function (name) {
                    return mediahubTagsService.deleteTag(name)
                        .then(function () { deleted.push(name); })
                        .catch(function (err) { $log.error('Error deleting tag ' + name, err); });
                })).then(function () {
                    if (vm.selectedContent && deleted.indexOf(vm.selectedContent.tagName) >= 0) {
                        closeThread();
                    }
                    removeFromList(deleted);
                    showToast(deleted.length === names.length ? 'MH_TAGS.DELETED_MANY' : 'MH_TAGS.ERROR_DELETING',
                        { count: deleted.length });
                });
            });
        }

        // ─── helpers ──────────────────────────────────────────────────────────
        function apiMessage(err) {
            return err && err.data && (err.data.message || (err.data.error && err.data.error.message)) || '';
        }

        /** `key` is a translation key; an API error message is shown as it comes. */
        function showToast(key, values) {
            var text = /^MH_TAGS\./.test(key) ? $translate.instant(key, values) : key;
            $mdToast.show(
                $mdToast.simple()
                    .textContent(text)
                    .position('bottom right')
                    .hideDelay(3000)
            );
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.mediahub')
        .service('mediahubFacesService', mediahubFacesService);

    /** @ngInject */
    function mediahubFacesService($http, $q, mediahubService) {

        return {
            getFaces           : getFaces,
            identifyFace       : identifyFace,
            confirmRetroactive : confirmRetroactive
        };

        // The shared mediahub headers: X-Tenant AND the x-api-key. Without the key the strict
        // API Gateways (americascup, demo1...) answer 403 with no CORS headers.
        function headers() {
            return angular.extend(mediahubService.mhHeaders(), {
                'Content-Type': 'application/json'
            });
        }

        function baseUrl() {
            return mediahubService.getApiUrl();
        }

        /**
         * Fetches unknown faces and enriches each group with the photo URLs
         * from the media endpoint.
         * Returns an array of photo-groups:
         *   { mediaId, thumbnailUrl, previewUrl, fileName, title, faces: [...] }
         */
        function getFaces(status) {
            var params = status ? { status: status } : {};

            return $http.get(baseUrl() + 'unknown-faces', { headers: headers(), params: params })
                .then(function (res) {
                    var faces = (res.data && res.data.data && res.data.data.faces)
                        ? res.data.data.faces : [];

                    // Group faces by mediaId
                    var groups = {};
                    faces.forEach(function (face) {
                        var id = face.mediaId;
                        if (!groups[id]) {
                            groups[id] = { mediaId: id, faces: [] };
                        }
                        groups[id].faces.push(face);
                    });

                    // Fetch media info for each unique mediaId
                    var uniqueIds = Object.keys(groups);
                    var promises = uniqueIds.map(function (id) {
                        return $http.get(baseUrl() + 'media/' + id, { headers: headers() })
                            .then(function (r) {
                                var m = (r.data && r.data.data) ? r.data.data : {};
                                groups[id].thumbnailUrl = m.thumbnailUrl || '';
                                groups[id].previewUrl   = m.previewUrl   || '';
                                groups[id].fileName     = m.fileName     || '';
                                groups[id].title        = m.title        || '';
                            })
                            .catch(function () { /* skip if media not found */ });
                    });

                    return $q.all(promises).then(function () {
                        return uniqueIds.map(function (id) { return groups[id]; });
                    });
                });
        }
        /**
         * POST /unknown-faces/{unknownId}/identify
         * Body: { tagName, tagType }
         * Returns: { retroactiveMatchCount, retroactiveMatches[] }
         * — creates/verifies the tag, indexes in Rekognition, tags current photo
         */
        function identifyFace(unknownId, tagName, tagType) {
            var url  = baseUrl() + 'unknown-faces/' + encodeURIComponent(unknownId) + '/identify';
            var body = { tagName: tagName, tagType: tagType || 'people' };
            return $http.post(url, body, { headers: headers() })
                .then(function (res) {
                    return (res.data && res.data.data) ? res.data.data : res.data;
                });
        }

        /**
         * POST /unknown-faces/{unknownId}/identify/retroactive
         * Body: { tagName, retroactiveMatches: [{ unknownId, mediaId }, ...] }
         * — marks each unknown_face as identified, tags each media file
         */
        function confirmRetroactive(unknownId, tagName, retroactiveMatches) {
            var url  = baseUrl() + 'unknown-faces/' + encodeURIComponent(unknownId) + '/identify/retroactive';
            var body = { tagName: tagName, retroactiveMatches: retroactiveMatches };
            return $http.post(url, body, { headers: headers() })
                .then(function (res) {
                    return (res.data && res.data.data) ? res.data.data : res.data;
                });
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.mediahub')
        .controller('MediahubFacesController', MediahubFacesController);

    /** @ngInject */
    function MediahubFacesController(mediahubFacesService, mediahubService, sessionService,
                                     $stateParams, $mdDialog, $mdToast, $log) {
        var vm = this;

        vm.photos    = [];
        vm.isLoading = true;
        vm.total     = 0;

        vm.loadFaces      = loadFaces;
        vm.openAssignDialog = openAssignDialog;
        vm.boxStyle       = boxStyle;

        init();

        // ─── init ─────────────────────────────────────────────────────────────
        /** Corporate x-api-key from qiu_config.mediahub (object or JSON string). */
        function mediahubApiKey(response) {
            var mh = response && response.mediahub;
            if (typeof mh === 'string') {
                try { mh = angular.fromJson(mh); } catch (e) { mh = null; }
            }
            return (mh && mh['x-api-key']) || '';
        }

        function init() {
            sessionService.loadDomainResourceSettings($stateParams.siteId)
                .then(function (response) {
                    if (response && response.public) {
                        var cfg = angular.fromJson(response.public);
                        if (cfg.mediahubUrl) {
                            mediahubService.setApiUrl(
                                cfg.mediahubUrl,
                                cfg.mediahubTenant || 'demo1',
                                cfg.mediahubS3 || ''
                            );
                            mediahubService.setApiKey(mediahubApiKey(response));
                            loadFaces();
                        } else {
                            vm.isLoading = false;
                        }
                    } else {
                        vm.isLoading = false;
                    }
                })
                .catch(function (err) {
                    $log.error('Error loading domain settings', err);
                    vm.isLoading = false;
                });
        }

        function loadFaces() {
            vm.isLoading = true;
            mediahubFacesService.getFaces()
                .then(function (photos) {
                    vm.photos = photos || [];
                    vm.total  = vm.photos.reduce(function (sum, p) {
                        return sum + (p.faces ? p.faces.length : 0);
                    }, 0);
                })
                .catch(function (err) {
                    $log.error('Error loading faces', err);
                })
                .finally(function () {
                    vm.isLoading = false;
                });
        }

        // ─── bounding box style (used in grid + dialog) ───────────────────────
        function boxStyle(bb, active, identified) {
            var color = identified ? '#4caf50' : '#ff4444';
            var colorFaded = identified ? 'rgba(76,175,80,0.5)' : 'rgba(255,68,68,0.5)';
            return {
                position : 'absolute',
                left     : (bb.left   * 100) + '%',
                top      : (bb.top    * 100) + '%',
                width    : (bb.width  * 100) + '%',
                height   : (bb.height * 100) + '%',
                border   : active ? ('2px solid ' + color) : ('2px solid ' + colorFaded),
                'box-shadow'    : active ? '0 0 0 1px rgba(0,0,0,0.5)' : 'none',
                cursor          : identified ? 'default' : 'pointer',
                'pointer-events': 'all',
                transition      : 'border 0.15s'
            };
        }

        // ─── dialog ───────────────────────────────────────────────────────────
        function openAssignDialog(photo, face, $event) {
            $mdDialog.show({
                templateUrl    : 'app/main/apps/mediahub/faces/face-assign-dialog.html',
                targetEvent    : $event,
                clickOutsideToClose: true,
                controller     : DialogController,
                controllerAs   : 'dialog'
            }).then(function (result) {
                if (result) {
                    // Update the face locally so the label changes to the name
                    face.identifiedAs = result.tagName;
                    face.status       = 'identified';
                    // Recalculate totals
                    vm.total = vm.photos.reduce(function (sum, p) {
                        return sum + p.faces.filter(function (f) { return f.status !== 'identified'; }).length;
                    }, 0);
                }
            });

            /** @ngInject */
            function DialogController($mdDialog, $q, mediahubTagsService, mediahubFacesService) {
                var dvm = this;

                dvm.photo              = photo;
                dvm.face               = face;
                dvm.name               = '';
                dvm.selectedTag        = null;
                dvm.tagType            = 'people';
                dvm.saving             = false;
                dvm.step               = 'identify';   // 'identify' | 'retroactive'
                dvm.assignedName       = '';
                dvm.retroactiveMatches = [];

                var allTags = null;

                dvm.save               = save;
                dvm.cancel             = cancel;
                dvm.searchTags         = searchTags;
                dvm.applyRetroactive   = applyRetroactive;
                dvm.skipRetroactive    = skipRetroactive;

                // Style for each box in the dialog: highlight selected, dim others
                dvm.dimStyle = function (bb, isActive) {
                    var base = {
                        position : 'absolute',
                        left     : (bb.left   * 100) + '%',
                        top      : (bb.top    * 100) + '%',
                        width    : (bb.width  * 100) + '%',
                        height   : (bb.height * 100) + '%',
                        'pointer-events': 'none'
                    };
                    if (isActive) {
                        base.border     = '3px solid #ff4444';
                        base['box-shadow'] = '0 0 0 2000px rgba(0,0,0,0.45)';
                        base['z-index'] = 2;
                    } else {
                        base.border     = '2px solid rgba(255,68,68,0.4)';
                        base['z-index'] = 1;
                    }
                    return base;
                };

                // Crop the face for the 72×72 preview using pixel-based background-position.
                // previewUrl is always 1200×800.
                dvm.cropStyle = function () {
                    var bb          = face.boundingBox;
                    var imgW        = 1200, imgH = 800;
                    var containerSz = 72;

                    var faceLeft = bb.left  * imgW;
                    var faceTop  = bb.top   * imgH;
                    var faceW    = bb.width  * imgW;
                    var faceH    = bb.height * imgH;

                    // Scale so the face fills (covers) the 72×72 box
                    var scale = Math.max(containerSz / faceW, containerSz / faceH);

                    var bgW  = Math.round(imgW * scale);
                    var bgH  = Math.round(imgH * scale);
                    var bgX  = Math.round(-faceLeft * scale);
                    var bgY  = Math.round(-faceTop  * scale);

                    return {
                        'background-image'   : 'url(' + photo.previewUrl + ')',
                        'background-size'    : bgW + 'px ' + bgH + 'px',
                        'background-position': bgX + 'px ' + bgY + 'px',
                        'background-repeat'  : 'no-repeat'
                    };
                };

                // ── autocomplete search ──────────────────────────────────────
                function searchTags(query) {
                    if (!query || query.length < 1) { return []; }
                    var q = query.toLowerCase();

                    // Load tags once, then filter client-side
                    var promise = allTags
                        ? $q.resolve(allTags)
                        : mediahubTagsService.getTags(null).then(function (tags) {
                            allTags = tags || [];
                            return allTags;
                        });

                    return promise.then(function (tags) {
                        // Prioritise people, then others
                        return tags.filter(function (t) {
                            return t.tagName && t.tagName.toLowerCase().indexOf(q) >= 0;
                        }).sort(function (a, b) {
                            // people first
                            if (a.tagType === 'people' && b.tagType !== 'people') { return -1; }
                            if (b.tagType === 'people' && a.tagType !== 'people') { return  1; }
                            return a.tagName.localeCompare(b.tagName);
                        });
                    });
                }

                // ── STEP 1: identify ─────────────────────────────────────────
                function save() {
                    if (!dvm.name || dvm.name.length < 2) { return; }
                    dvm.saving = true;

                    var tagName = dvm.selectedTag ? dvm.selectedTag.tagName : dvm.name;
                    var tagType = dvm.selectedTag ? dvm.selectedTag.tagType : dvm.tagType;

                    $log.debug('[faces] identify → unknownId:', face.unknownId, '| tagName:', tagName, '| tagType:', tagType);

                    // POST /unknown-faces/{id}/identify
                    // Backend handles: create/verify tag, index in Rekognition, tag current photo
                    mediahubFacesService.identifyFace(face.unknownId, tagName, tagType)
                        .then(function (result) {
                            dvm.saving       = false;
                            dvm.assignedName = tagName;

                            var matches = (result && result.retroactiveMatches) ? result.retroactiveMatches : [];

                            if (matches.length > 0) {
                                // Go to step 2
                                dvm.retroactiveMatches = matches;
                                dvm.step = 'retroactive';
                            } else {
                                // No other matches — done
                                _done('Face identified as "' + tagName + '"');
                            }
                        })
                        .catch(function (err) {
                            $log.error('Error identifying face — status:', err && err.status, '— body:', err && err.data);
                            dvm.saving = false;

                            // HTTP 500 often means the Lambda processed correctly but crashed on
                            // the response — close the dialog and reload so the user sees the result.
                            if (err && err.status === 500) {
                                $mdToast.show(
                                    $mdToast.simple()
                                        .textContent('Face identified (backend warning — refreshing)')
                                        .position('bottom right').hideDelay(4000)
                                );
                                $mdDialog.hide({ tagName: tagName, unknownId: face.unknownId, retroactiveApplied: 0 });
                                return;
                            }

                            var errMsg = 'Error identifying face';
                            if (err && err.data && err.data.message) {
                                errMsg += ': ' + err.data.message;
                            } else if (err && err.data && err.data.error) {
                                errMsg += ': ' + err.data.error;
                            } else if (err && err.status) {
                                errMsg += ' (HTTP ' + err.status + ')';
                            }
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent(errMsg)
                                    .position('bottom right').hideDelay(6000)
                            );
                        });
                }

                // ── STEP 2: apply retroactive tags ───────────────────────────
                function applyRetroactive() {
                    dvm.saving = true;
                    mediahubFacesService.confirmRetroactive(
                        face.unknownId,
                        dvm.assignedName,
                        dvm.retroactiveMatches
                    )
                        .then(function () {
                            dvm.saving = false;
                            _done(
                                '"' + dvm.assignedName + '" tagged in ' +
                                dvm.retroactiveMatches.length + ' more photo(s)'
                            );
                        })
                        .catch(function (err) {
                            $log.error('Error applying retroactive', err);
                            dvm.saving = false;
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent('Error applying retroactive tags')
                                    .position('bottom right').hideDelay(3000)
                            );
                        });
                }

                function skipRetroactive() {
                    _done('Face identified as "' + dvm.assignedName + '"');
                }

                function _done(toastMsg) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(toastMsg)
                            .position('bottom right')
                            .hideDelay(4000)
                    );
                    $mdDialog.hide({
                        tagName            : dvm.assignedName,
                        unknownId          : face.unknownId,
                        retroactiveApplied : dvm.retroactiveMatches.length
                    });
                }

                function cancel() {
                    $mdDialog.cancel();
                }
            }
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.users')
        .factory("transformMedia", transformMedia);



    /** @ngInject */
    function transformMedia() {

        var service = {
            formatNestedGalleries: formatNestedGalleries,
            preAssignQiuRestrictedRoot: preAssignQiuRestrictedRoot,
            assignLightboxOwners: assignLightboxOwners
        };

        function getTotalCount(parent) {
            var sum = parent.total_media_count;
            if (parent.children){
                for (var i = 0; i < parent.children.length; i++) {
                    const element = parent.children[i];
                    sum += element.total_media_count
                    if (element.children) {
                        for (let j = 0; j < element.children.length; j++) {
                            const child = element.children[j];
                            sum += getTotalCount(child)
                        }
                    }
                }
            }
            return sum;
        }

        function formatNestedGalleries(galleries, qiuRestrictions, isRootCycle) {
            if (galleries) {
                for (var i = 0; i < galleries.length; i++) {
                    var gallery = galleries[i];
                    gallery.id = gallery.id_gallery;
                    gallery.label = gallery.name;
                    gallery.element_total_count = getTotalCount(gallery);
                    gallery.is_qiu_restricted = isGalleryQiuRestricted(gallery.id_gallery, qiuRestrictions);
                    gallery.is_qiu_restricted_root = isRootCycle && gallery.is_qiu_restricted;
                    if (gallery.children) {
                        formatNestedGalleries(gallery.children, qiuRestrictions, false);
                    }
                }
            } else {
                return [];
            }
            return galleries;
        }

        function isGalleryQiuRestricted(galleryId, qiuRestrictions) {
            return (qiuRestrictions
                    && (
                            (qiuRestrictions.hasOwnProperty('id_gallery') &&
                                Object.values(qiuRestrictions.id_gallery).indexOf(galleryId) > -1)
                        ||
                            (qiuRestrictions.hasOwnProperty('galleries_sub') &&
                                Object.values(qiuRestrictions.galleries_sub).indexOf(galleryId) > -1)
                        )
                    )
        }

        function preAssignQiuRestrictedRoot(galleries) {
          if (angular.isArray(galleries) &&
              galleries.length > 0 &&
                galleries[0].is_qiu_restricted_root
          ) {
            galleries[0].assigned_gallery = true;
          }
        }

        function assignLightboxOwners(galleries, owners) {
            if (angular.isArray(galleries) &&
              galleries.length > 0
            ) {
                for (var i = 0; i < galleries.length; i++) {
                    if (galleries[i].raw_settings &&
                        galleries[i].raw_settings.hasOwnProperty('lightbox') &&
                        galleries[i].raw_settings.lightbox.hasOwnProperty('owner')
                    ) {
                        galleries[i].owner = owners.find(function(owner) {
                            return owner.id_user == galleries[i].raw_settings.lightbox.owner
                        })
                    }
                    if (galleries[i].children){
                        assignLightboxOwners(galleries[i].children, owners)
                    }
                }
            }
        }

        return service;
    }


})();

(function () {
    'use strict';

    angular
        .module('app.match-center')
        .service('utilMatchCenterService', UtilMatchCenterService);

    /** @ngInject */
    // I provide access to the session store.
    function UtilMatchCenterService($rootScope, $mdToast, $q, $resource, userService, settingsDomainService, contentService, COMMON, $window) {



        function getFile(options, isArray) {
            var deferred = $q.defer();

            var resource = isArray ? resourceFileArray : resourceFile
            resource.get({
                sport: options.sport,
                file: options.file
            },
                function (responseResult) {
                    deferred.resolve(JSON.parse(angular.toJson(responseResult)));
                },
                function (e) {
                    showError(e)
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }


        function getSport(id_subsec) {
            switch (id_subsec) {
                case 1:
                    return 'football'
                case 2:
                    return 'sailing'
                case 3:
                    return 'cars'
                case 4:
                    return 'tennis'
                case 4:
                    return 'paddle'
                default:
                    break;
            }
        }


        var resourceFile = $resource("/assets/sports-data/:sport/:file", {
            // No default data
        }, {
                get: {
                    method: "GET"
                }
            });
        var resourceFileArray = $resource("/assets/sports-data/:sport/:file", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: true
                }
            });



        function showError(e) {
            $mdToast.show({
                template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content bg-red">' + e.message + '</div></md-toast>',
                hideDelay: 7000,
                position: 'top right',
                parent: '#content'
            });
        }



        return ({
            getSport: getSport,
            getFile: getFile
        });

    }

})();


(function () {
    'use strict';

    angular
        .module('app.match-center')
        .factory("transformMatchTennis", transformMatchTennis);



    /** @ngInject */
    function transformMatchTennis($filter, sessionService) {
        var vm = this;

        var service = {
            getResultTennis: getResultTennis,
            getResultDataTennis: getResultDataTennis
        };
        function getResultTennis(competitionSeason, matches) {
            var teams = [];
            teams = competitionSeason.teams.filter(x => !x.hidestandings).map(team => {
                return { id_teams: team.id_teams, team_name: team.team_name, constructor: team.color, total: 0, races: [] }
            });
            var matchesCompleted = 0;
            for (var i = 0; i < matches.length; i++) {
                const match = matches[i];
                for (let j = 0; j < match.results_data.teams.length; j++) {
                    const team = match.results_data.teams[j];
                    const index = teams.findIndex((_team) => _team.id_teams == team.id_teams)
                    if (index >= 0) {
                        teams[index].total = teams[index].total + team.points + team.extra;
                        teams[index].races.push({ race: match.match_name, date: match.date, id: match.id, id_matches: match.id_matches, points: team.points, extra: team.extra });
                    } else {
                        teams.push({ id_teams: team.id_teams, team_name: team.team_name, constructor: team.color, total: team.points + team.extra, races: [{ race: match.match_name, date: match.date, id: match.id, id_matches: match.id_matches, points: team.points, extra: team.extra }] });
                    }
                }
                for (let z = 0; z < teams.length; z++) {
                    const team = teams[z];
                    if (team.races.length < (matchesCompleted)) {
                        team.races.push({ race: match.match_name, date: match.date, id: match.id, id_matches: match.id_matches, points: '-' });
                    }
                }
            }
            teams = $filter('orderBy')(teams, 'total', competitionSeason.result_sort === 'ASC' ? false : true);
            for (let i = 0; i < teams.length; i++) {
                const element = teams[i];
                element.races = $filter('orderBy')(element.races, ['date', 'id']);
            }
            teams = teams.filter(x => {
                return !competitionSeason.teams.find(y => y.id_teams == x.id_teams).hidestandings
            })
            console.log(teams)
            return teams;
        }

        function getResultDataTennis(match, competitionSeason, ref, teamsReferenceSections) {
            var result = {};
            result.teams = [];
            if (match.teams_data) {
                for (var i = 0; i < match.teams_data.length; i++) {
                    const team = match.teams_data[i];
                    var team_result = toTeamRef(team, i, ref, teamsReferenceSections);
                    result.teams.push(team_result)
                    result.teams[i].points = team_result.points ? parseInt(team_result.points) : 0;
                    result.teams[i].extra = team_result.extra ? parseInt(team_result.extra) : 0;
                }
            }
            return result;
        }


        function getReferenceSectionData(key, property, value, teamsReferenceSections) {
            switch (property) {
                case 'id_subsec':
                    var fieldReturn = 'subsec';
                    break;
                case 'id_cat':
                    var fieldReturn = 'cat';
                    break;
                case 'id_subcat':
                    var fieldReturn = 'subcat';
                    break;
                default:
                    var fieldReturn = 'cat';
            }

            if (!angular.isUndefined(teamsReferenceSections[key])) {
                for (var i = 0, len = teamsReferenceSections[key].length; i < len; i++) {
                    if (teamsReferenceSections[key][i][property] === value) return teamsReferenceSections[key][i][fieldReturn];
                }
            }
            return "--";

        }

        function toTeamRef(team, i, ref, teamsReferenceSections) {
            var result = {}
            for (var i = 0; i < ref.length; i++) {
                const element = ref[i];
                if (element.in_json_object == 1) {
                    if (element.type == 'thumbnail') {
                        result[element.titleId] = team.Thumbnail && team.Thumbnail.length > 0 ? setItemMedia(team.Thumbnail[0], element) : team[element.titleId];
                    } else if (element.type == 'id_subsec') {
                        result[element.titleId] = getReferenceSectionData('subsection', element.type, team[element.titleId], teamsReferenceSections)
                    } else if (element.type == 'id_cat') {
                        result[element.titleId] = getReferenceSectionData('cat', element.type, team[element.titleId], teamsReferenceSections)
                    } else if (element.type == 'id_subcat') {
                        result[element.titleId] = getReferenceSectionData('subcat', element.type, team[element.titleId], teamsReferenceSections)
                    } else {
                        result[element.titleId] = team[element.titleId];
                    }
                }
            }
            result.points = parseInt(team.points);
            result.extra = parseInt(team.extra);
            result.id_teams = team.id_teams;
            result.team_name = team.team_name;
            return result;
        }

        function setItemMedia(attachment, refField) {
            var opts = {};
            opts.file = false;
            opts.thumbnail = false;
            var cropFormatId = (!refField || refField.id_cropformats === null) ? sessionService.getMediaThumbnailCropformatId() : refField.id_cropformats;
            if (cropFormatId == 0 || attachment.filename.includes(".gif") || attachment.filename.includes(".svg")) {
                var containerOriginal = sessionService.getContainerByID(attachment.cdnContainer);
                return containerOriginal.view_url + 'original/m' + attachment.id_media + '_' + attachment.filename;
            }
            if (angular.isObject(attachment) && angular.isObject(attachment.cropstatus) && attachment.cropstatus.length > 0) {
                var cropstatus = _.find(attachment.cropstatus, function (c) {
                    if (c.id_cropformats == cropFormatId) {
                        return true;
                    }
                });
                if (!angular.isUndefined(cropstatus)) {
                    var container = sessionService.getContainerByID(cropstatus.id_container);
                    return container.view_url + cropstatus.fileName;
                } else {
                    return '';
                }
            } else if (attachment.id_media) {
                var options = {
                    id_media: [attachment.id_media],
                };

                CommonMediaService.getUrl(options)
                    .then(function (response) {
                        if (response.length > 0) {
                            var cropstatus = _.find(response, {
                                'id_cropformats': cropFormatId
                            });
                            return cropstatus.url;
                        } else {
                            // Original showed
                            var containerOriginal = sessionService.getContainerByID(attachment.cdnContainer);
                            if (!angular.isUndefined(containerOriginal)) {
                                return containerOriginal.view_url + 'original/m' + attachment.id_media + '_' + attachment.filename;
                            }
                        }
                    });
            }
        }


        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.match-center')
        .factory("transformMatchSailingFlota", transformMatchSailingFlota);



    /** @ngInject */
    function transformMatchSailingFlota($filter, sessionService) {
        var vm = this;

        var service = {
            getResultsSailingFlota: getResultsSailingFlota,
            getResultDataSailingFlota: getResultDataSailingFlota
        };
        function getResultsSailingFlota(competitionSeason, matches) {
            var teams = [];
            teams = competitionSeason.teams.filter(x => !x.hidestandings).map(team => {
                if (angular.isUndefined(team.media)) {
                  team.media = '';
                }
                return { code: team.code, id_teams: team.id_teams, name: team.team_name, points: 0, pj: 0, pg: 0, pe: 0, pp: 0,total: 0, media: team.media, races: [] }
            });
            var matchesCompleted = 0;
            for (var i = 0; i < matches.length; i++) {
                const match = matches[i];
                if ((match.status == "5" || (competitionSeason.live_results && match.status == "4")) && match.results_data && match.results_data.teams) {
                    matchesCompleted++;
                    for (let j = 0; j < match.results_data.teams.length; j++) {
                        const team = match.results_data.teams[j];
                        const index = teams.findIndex((_team) => _team.id_teams == team.id_teams);
                        const status = match.teams_data.find(x => x.id_teams == team.id_teams).status;
                        if (index >= 0) {
                            teams[index].total = teams[index].total + team.points + team.extra;
                            teams[index].races.push({ race: match.match_name, date: match.date, id: match.id, id_matches: match.id_matches, points: team.points, extra: team.extra, status: status});
                        } else {
                            teams.push({ id_teams: team.id_teams, team_name: team.team_name, total: team.points + team.extra, races: [{ race: match.match_name, date: match.date, id: match.id, id_matches: match.id_matches, points: team.points, extra: team.extra, status:status}] });
                        }
                    }
                }
                for (let z = 0; z < teams.length; z++) {
                    const team = teams[z];
                    if (team.races.length < (matchesCompleted)) {
                        team.races.push({ race: match.match_name, date: match.date, id: match.id, id_matches: match.id_matches, points: '-' });
                    }
                }
            }
            teams = $filter('orderBy')(teams, 'total', competitionSeason.result_sort === 'ASC' ? false : true);
            for (let i = 0; i < teams.length; i++) {
                const element = teams[i];
                element.races = $filter('orderBy')(element.races, ['date', 'id']);
            }
            teams = teams.filter(x => {
              if (angular.isUndefined(competitionSeason.teams.find(y => y.id_teams == x.id_teams))) {
                return false;
              }
              return !competitionSeason.teams.find(y => y.id_teams == x.id_teams).hidestandings
            })
            return teams;
        }

        function getResultDataSailingFlota(match, competitionSeason, ref, teamsReferenceSections) {
            var result = {};
            result.teams = [];
            if (match.teams_data) {
                for (var i = 0; i < match.teams_data.length; i++) {
                    const team = match.teams_data[i];
                    var team_result = toTeamRef(team, i, ref, teamsReferenceSections);
                    result.teams.push(team_result)
                    result.teams[i].points = team_result.points ? parseFloat(team_result.points) : 0;
                    result.teams[i].extra = team_result.extra ? parseFloat(team_result.extra) : 0;
                }
            }
            return result;
        }

        function getReferenceSectionData(key, property, value, teamsReferenceSections) {
            switch (property) {
                case 'id_subsec':
                    var fieldReturn = 'subsec';
                    break;
                case 'id_cat':
                    var fieldReturn = 'cat';
                    break;
                case 'id_subcat':
                    var fieldReturn = 'subcat';
                    break;
                default:
                    var fieldReturn = 'cat';
            }

            if (!angular.isUndefined(teamsReferenceSections[key])) {
                for (var i = 0, len = teamsReferenceSections[key].length; i < len; i++) {
                    if (teamsReferenceSections[key][i][property] === value) return teamsReferenceSections[key][i][fieldReturn];
                }
            }
            return "--";

        }

        function toTeamRef(team, i, ref, teamsReferenceSections) {
            var result = {}
            for (var i = 0; i < ref.length; i++) {
                const element = ref[i];
                if (element.in_json_object == 1) {
                    if (element.type == 'thumbnail') {
                        result[element.titleId] = team.Thumbnail && team.Thumbnail.length > 0 ? setItemMedia(team.Thumbnail[0], element) : team[element.titleId];
                    } else if (element.type == 'id_subsec') {
                        result[element.titleId] = getReferenceSectionData('subsection', element.type, team[element.titleId], teamsReferenceSections)
                    } else if (element.type == 'id_cat') {
                        result[element.titleId] = getReferenceSectionData('cat', element.type, team[element.titleId], teamsReferenceSections)
                    } else if (element.type == 'id_subcat') {
                        result[element.titleId] = getReferenceSectionData('subcat', element.type, team[element.titleId], teamsReferenceSections)
                    } else {
                        result[element.titleId] = team[element.titleId];
                    }
                }
            }
            result.points = parseFloat(team.points);
            result.extra = parseFloat(team.extra);
            result.id_teams = team.id_teams;
            result.team_name = team.team_name;
            return result;
        }

        function setItemMedia(attachment, refField) {
            var opts = {};
            opts.file = false;
            opts.thumbnail = false;
            var cropFormatId = (!refField || refField.id_cropformats === null) ? sessionService.getMediaThumbnailCropformatId() : refField.id_cropformats;
            if (cropFormatId == 0 || attachment.filename.includes(".gif") || attachment.filename.includes(".svg")) {
                var containerOriginal = sessionService.getContainerByID(attachment.cdnContainer);
                return containerOriginal.view_url + 'original/m' + attachment.id_media + '_' + attachment.filename;
            }
            if (angular.isObject(attachment) && angular.isObject(attachment.cropstatus) && attachment.cropstatus.length > 0) {
                var cropstatus = _.find(attachment.cropstatus, function (c) {
                    if (c.id_cropformats == cropFormatId) {
                        return true;
                    }
                });
                if (!angular.isUndefined(cropstatus)) {
                    var container = sessionService.getContainerByID(cropstatus.id_container);
                    return container.view_url + cropstatus.fileName;
                } else {
                    return '';
                }
            } else if (attachment.id_media) {
                var options = {
                    id_media: [attachment.id_media],
                };

                CommonMediaService.getUrl(options)
                    .then(function (response) {
                        if (response.length > 0) {
                            var cropstatus = _.find(response, {
                                'id_cropformats': cropFormatId
                            });
                            return cropstatus.url;
                        } else {
                            // Original showed
                            var containerOriginal = sessionService.getContainerByID(attachment.cdnContainer);
                            if (!angular.isUndefined(containerOriginal)) {
                                return containerOriginal.view_url + 'original/m' + attachment.id_media + '_' + attachment.filename;
                            }
                        }
                    });
            }
        }


        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.match-center')
        .factory("transformMatchSailingRegata", transformMatchSailingRegata);



    /** @ngInject */
    function transformMatchSailingRegata($filter, sessionService) {
        var vm = this;

        var service = {
            getResultsRegata: getResultsRegata,
            getResultDataRegata: getResultDataRegata
        };
        function getResultsRegata(competitionSeason, matches) {
            var teams = [];
            teams = competitionSeason.teams.filter(x => !x.hidestandings).map(team => {
                return {code: team.code, id_teams: team.id_teams, name: team.team_name, points: 0, pj: 0, pg: 0, pe: 0, pp: 0 }
            });
            for (var i = 0; i < matches.length; i++) {
                const match = matches[i];
                if ((match.status == "5" || (competitionSeason.live_results && match.status == "4")) && match.results_data && match.results_data.teams) {
                    const team1 = match.results_data.teams[0];
                    const team2 = match.results_data.teams[1];
                    teams = saveTeamResult(teams, team1, team2);
                    teams = saveTeamResult(teams, team2, team1);
                }
            }
            teams = $filter('orderBy')(teams, 'points', competitionSeason.result_sort === 'ASC' ? false : true);
            teams = teams.filter(x => {
                return !competitionSeason.teams.find(y => y.id_teams == x.id_teams).hidestandings
            })
            return teams;
        }

        function saveTeamResult(teams, team, oponent) {
            var teamFound = _.find(teams, function (_team) { return _team.id_teams == team.id_teams })

            if (team.points == 1) {
                if (teamFound) {
                    teamFound.points += team.points;
                    teamFound.pj += 1;
                    teamFound.pg += 1;
                } else {
                    teams.push({ id_teams: team.id_teams, name: team.team_name, points: 1, pj: 1, pg: 1, pe: 0, pp: 0 });
                }
            } else {
                if (teamFound) {
                    teamFound.points += team.points;
                    teamFound.pj += 1;
                    teamFound.pp += 1;
                } else {
                    teams.push({ id_teams: team.id_teams, name: team.team_name, points: team.points, pj: 1, pg: 0, pe: 0, pp: 1 });
                }
            }
            return teams;

        }

        function getResultDataRegata(match, final_types, ref, teamsReferenceSections) {
            var result = {};
            result.teams = [];
            if (match.teams_data) {
                for (var i = 0; i < match.teams_data.length; i++) {
                    const team = match.teams_data[i];
                    var team_result = toTeamRef(team, i, ref, teamsReferenceSections);
                    team_result.points = team.points;
                    result.teams.push(team_result)
                    result.teams[i].points = team_result.points ? parseFloat(team_result.points) : 0;
                    result.teams[i].extra = team_result.extra ? parseFloat(team_result.extra) : 0;
                }
            }
            return result;
        }

        function getReferenceSectionData(key, property, value, teamsReferenceSections) {
            switch (property) {
                case 'id_subsec':
                    var fieldReturn = 'subsec';
                    break;
                case 'id_cat':
                    var fieldReturn = 'cat';
                    break;
                case 'id_subcat':
                    var fieldReturn = 'subcat';
                    break;
                default:
                    var fieldReturn = 'cat';
            }

            if (!angular.isUndefined(teamsReferenceSections[key])) {
                for (var i = 0, len = teamsReferenceSections[key].length; i < len; i++) {
                    if (teamsReferenceSections[key][i][property] === value) return teamsReferenceSections[key][i][fieldReturn];
                }
            }
            return "--";

        }

        function toTeamRef(team, i, ref, teamsReferenceSections) {
            var result = {}
            for (var i = 0; i < ref.length; i++) {
                const element = ref[i];
                if (element.in_json_object == 1) {
                    if (element.type == 'thumbnail') {
                        result[element.titleId] = team.Thumbnail && team.Thumbnail.length > 0 ? setItemMedia(team.Thumbnail[0], element) : team[element.titleId];
                    } else if (element.type == 'id_subsec') {
                        result[element.titleId] = getReferenceSectionData('subsection', element.type, team[element.titleId], teamsReferenceSections)
                    } else if (element.type == 'id_cat') {
                        result[element.titleId] = getReferenceSectionData('cat', element.type, team[element.titleId], teamsReferenceSections)
                    } else if (element.type == 'id_subcat') {
                        result[element.titleId] = getReferenceSectionData('subcat', element.type, team[element.titleId], teamsReferenceSections)
                    } else {
                        result[element.titleId] = team[element.titleId];
                    }
                }
            }
            result.score = parseFloat(team.score);
            result.points = 0;
            result.id_teams = team.id_teams;
            result.team_name = team.team_name;
            result.place = i + 1;
            return result;
        }

        function setItemMedia(attachment, refField) {
            var opts = {};
            opts.file = false;
            opts.thumbnail = false;
            var cropFormatId = (!refField || refField.id_cropformats === null) ? sessionService.getMediaThumbnailCropformatId() : refField.id_cropformats;
            if (cropFormatId == 0 || attachment.filename.includes(".gif") || attachment.filename.includes(".svg")) {
                var containerOriginal = sessionService.getContainerByID(attachment.cdnContainer);
                return containerOriginal.view_url + 'original/m' + attachment.id_media + '_' + attachment.filename;
            }
            if (angular.isObject(attachment) && angular.isObject(attachment.cropstatus) && attachment.cropstatus.length > 0) {
                var cropstatus = _.find(attachment.cropstatus, function (c) {
                    if (c.id_cropformats == cropFormatId) {
                        return true;
                    }
                });
                if (!angular.isUndefined(cropstatus)) {
                    var container = sessionService.getContainerByID(cropstatus.id_container);
                    return container.view_url + cropstatus.fileName;
                } else {
                    return '';
                }
            } else if (attachment.id_media) {
                var options = {
                    id_media: [attachment.id_media],
                };

                CommonMediaService.getUrl(options)
                    .then(function (response) {
                        if (response.length > 0) {
                            var cropstatus = _.find(response, {
                                'id_cropformats': cropFormatId
                            });
                            return cropstatus.url;
                        } else {
                            // Original showed
                            var containerOriginal = sessionService.getContainerByID(attachment.cdnContainer);
                            if (!angular.isUndefined(containerOriginal)) {
                                return containerOriginal.view_url + 'original/m' + attachment.id_media + '_' + attachment.filename;
                            }
                        }
                    });
            }
        }

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.match-center')
        .factory("transformMatchFootball", transformMatchFootball);



    /** @ngInject */
    function transformMatchFootball($filter, sessionService, CommonMediaService) {
        var vm = this;

        var service = {
            getResultsFootball: getResultsFootball,
            getResultDataFootball: getResultDataFootball
        };
        function getResultsFootball(competitionSeason, matches) {
            var teams = [];
            teams = competitionSeason.teams.filter(x => !x.hidestandings).map(team => {
                return { id_teams: team.id_teams, name: team.team_name, pt: 0, pj: 0, pg: 0, pe: 0, pp: 0, gf: 0, gc: 0 }
            });
            for (var i = 0; i < matches.length; i++) {
                const match = matches[i];
                if ((match.status == "5" || (competitionSeason.live_results && match.status == "4")) && match.results_data && match.results_data.teams) {
                    const team1 = match.results_data.teams[0];
                    const team2 = match.results_data.teams[1];
                    teams = saveTeamResult(teams, team1, team2);
                    teams = saveTeamResult(teams, team2, team1);
                }
            }
            teams = $filter('orderBy')(teams, 'pt', competitionSeason.result_sort === 'ASC' ? false : true);
            if(competitionSeason.teams.length > 0){
                teams = teams.filter(x => {
                    return !competitionSeason.teams.find(y => y.id_teams == x.id_teams)
                })
            }
            return teams;
        }

        function saveTeamResult(teams, team, oponent) {
            var teamFound = _.find(teams, function (_team) { return _team.id_teams == team.id_teams })

            if (team.points == 3) {
                if (teamFound) {
                    teamFound.pt += team.points;
                    teamFound.pj += 1;
                    teamFound.pg += 1;
                    teamFound.gf += team.score;
                    teamFound.gc += oponent.score;
                } else {
                    teams.push({ id_teams: team.id_teams, name: team.team_name, pt: team.points, pj: 1, pg: 1, pe: 0, pp: 0, gf: team.score, gc: oponent.score });
                }
            } else if (team.points == 1) {
                if (teamFound) {
                    teamFound.pt += team.points;
                    teamFound.pj += 1;
                    teamFound.pe += 1;
                    teamFound.gf += team.score;
                    teamFound.gc += oponent.score;
                } else {
                    teams.push({ id_teams: team.id_teams, name: team.team_name, pt: team.points, pj: 1, pg: 0, pe: 1, pp: 0, gf: team.score, gc: oponent.score });
                }
            } else {
                if (teamFound) {
                    teamFound.pt += team.points;
                    teamFound.pj += 1;
                    teamFound.pp += 1;
                    teamFound.gf += team.score;
                    teamFound.gc += oponent.score;
                } else {
                    teams.push({ id_teams: team.id_teams, name: team.team_name, pt: team.points, pj: 1, pg: 0, pe: 0, pp: 1, gf: team.score, gc: oponent.score });
                }
            }
            return teams;

        }

        function getResultDataFootball(match, final_types, ref, teamsReferenceSections) {
            var result = {};
            result.final_type = _.find(final_types, { 'id': match.results_data.final_type });
            result.teams = [];
            var winner;
            var tie = false;
            if (match.teams_data) {
                for (var i = 0; i < match.teams_data.length; i++) {
                    const team = match.teams_data[i];
                    var team_result = toTeamRef(team, i, ref, teamsReferenceSections);
                    result.teams.push(team_result)
                    if (!winner) {
                        winner = team_result;
                    } else if (winner && (winner.score < team_result.score || winner.penalties < team_result.penalties)) {
                        winner = team_result;
                    } else if (winner && (winner.score == team_result.score && winner.penalties == team_result.penalties)) {
                        tie = true;
                    }
                }
                if (tie) {
                    for (var i = 0; i < result.teams.length; i++) {
                        result.teams[i].points = 1;
                    }
                } else {
                    for (var i = 0; i < result.teams.length; i++) {
                        const team = result.teams[i];
                        if (team.id_teams == winner.id_teams) {
                            team.points = 3;
                        } else {
                            team.points = 0;
                        }
                    }
                }
            }
            return result;
        }

        function getReferenceSectionData(key, property, value, teamsReferenceSections) {
            switch (property) {
                case 'id_subsec':
                    var fieldReturn = 'subsec';
                    break;
                case 'id_cat':
                    var fieldReturn = 'cat';
                    break;
                case 'id_subcat':
                    var fieldReturn = 'subcat';
                    break;
                default:
                    var fieldReturn = 'cat';
            }

            if (!angular.isUndefined(teamsReferenceSections[key])) {
                for (var i = 0, len = teamsReferenceSections[key].length; i < len; i++) {
                    if (teamsReferenceSections[key][i][property] === value) return teamsReferenceSections[key][i][fieldReturn];
                }
            }
            return "--";

        }

        function toTeamRef(team, i, ref, teamsReferenceSections) {
            console.log(team);
            console.log(ref);
            var result = {}
            for (var i = 0; i < ref.length; i++) {
                const element = ref[i];
                if (element.in_json_object == 1) {
                    if (element.type == 'thumbnail') {
                        result[element.titleId] = team.Thumbnail && team.Thumbnail.length > 0 ? setItemMedia(team.Thumbnail[0], element) : team[element.titleId];
                    } else if (element.type == 'id_subsec') {
                        result[element.titleId] = getReferenceSectionData('subsection', element.type, team[element.titleId], teamsReferenceSections)
                    } else if (element.type == 'id_cat') {
                        result[element.titleId] = getReferenceSectionData('cat', element.type, team[element.titleId], teamsReferenceSections)
                    } else if (element.type == 'id_subcat') {
                        result[element.titleId] = getReferenceSectionData('subcat', element.type, team[element.titleId], teamsReferenceSections)
                    } else {
                        result[element.titleId] = team[element.titleId];
                    }
                }
            }
            result.score = parseInt(team.score);
            result.points = 0;
            result.id_teams = team.id_teams;
            result.team_name = team.team_name;
            result.place = i + 1;
            result.penalties = team.penalties;
            return result;
        }

        function setItemMedia(attachment, refField) {
            var opts = {};
            opts.file = false;
            opts.thumbnail = false;
            var cropFormatId = (!refField || refField.id_cropformats === null) ? sessionService.getMediaThumbnailCropformatId() : refField.id_cropformats;
            if (cropFormatId == 0 || attachment.filename.includes(".gif") || attachment.filename.includes(".svg")) {
                var containerOriginal = sessionService.getContainerByID(attachment.cdnContainer);
                return containerOriginal.view_url + 'original/m' + attachment.id_media + '_' + attachment.filename;
            }
            if (angular.isObject(attachment) && angular.isObject(attachment.cropstatus) && attachment.cropstatus.length > 0) {
                var cropstatus = _.find(attachment.cropstatus, function (c) {
                    if (c.id_cropformats == cropFormatId) {
                        return true;
                    }
                });
                if (!angular.isUndefined(cropstatus)) {
                    var container = sessionService.getContainerByID(cropstatus.id_container);
                    return container.view_url + cropstatus.fileName;
                } else {
                    return '';
                }
            } else if (attachment.id_media) {
                var options = {
                    id_media: [attachment.id_media],
                };

                CommonMediaService.getUrl(options)
                    .then(function (response) {
                        if (response.length > 0) {
                            var cropstatus = _.find(response, {
                                'id_cropformats': cropFormatId
                            });
                            return cropstatus.url;
                        } else {
                            // Original showed
                            var containerOriginal = sessionService.getContainerByID(attachment.cdnContainer);
                            if (!angular.isUndefined(containerOriginal)) {
                                return containerOriginal.view_url + 'original/m' + attachment.id_media + '_' + attachment.filename;
                            }
                        }
                    });
            }
        }

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.match-center')
        .factory("transformMatchCenter", transformMatchCenter);



    /** @ngInject */
    function transformMatchCenter(sessionService, transformMatchSailingRegata, CommonMediaService, transformMatchFootball, transformMatchCars, transformMatchTennis, transformMatchSailingFlota) {
        var vm = this;
        vm.dateFormat = sessionService.site_operative.dateFormat;
        vm.dateTimeFormat = sessionService.site_operative.dateTimeFormat;

        var service = {
            competitionSeasonToDTO: competitionSeasonToDTO,
            DTOtoCompetitionSeason: DTOtoCompetitionSeason,
            DTOstoMatches: DTOstoMatches,
            setItemMedia: setItemMedia,
            changePosition: changePosition,
            applyExceptions: applyExceptions,
            DTOtoMatch: DTOtoMatch,
            MatchToDTO: MatchToDTO
        };



        function competitionSeasonToDTO(competitionSeason, matches, sport) {
            competitionSeason.results = getResults(competitionSeason, matches, sport)
            competitionSeason.results = angular.toJson(competitionSeason.results);
            competitionSeason.result_exceptions = angular.toJson(competitionSeason.result_exceptions);
            competitionSeason.teams_section_data = angular.toJson(competitionSeason.teams_section_data);
            competitionSeason.teams = angular.toJson(competitionSeason.teams);
            competitionSeason.venues = angular.toJson(competitionSeason.venues);
            competitionSeason.tags = [];
            competitionSeason.Thumbnail = [];
            competitionSeason.id = competitionSeason.id_competition_season;
            delete competitionSeason.children;
            delete competitionSeason.competition;
            return competitionSeason;
        }

        function getIds(array, key) {
            var k = 'id';
            if (key) {
                k = key;
            }
            var result = [];
            for (var i = 0; i < array.length; i++) {
                result.push(array[i][k])
            }
            return result;
        }
        function getKey(sport) {
            let key;
            switch (sport) {
                case 'football':
                    key = 'pt'
                    break;
                case 'sailing':
                    key = 'total'
                    break;
                // Sin este caso key llegaba undefined en coches, y applyExceptions comparaba
                // results[a][undefined] == results[b][undefined], que siempre es cierto: las
                // excepciones se aplicaban aunque los puntos NO empataran (Turpeinen con 91
                // puntos acababa por delante de Bakkerud con 158).
                case 'cars':
                    key = 'points'
                    break;
                default:
                    break;
            }
            return key;
        }

        function DTOtoCompetitionSeason(competitionSeason, sport) {
            let key = getKey(sport);
            if (competitionSeason.teams) {
                competitionSeason.teams = JSON.parse(competitionSeason.teams);
            } else {
                competitionSeason.teams = []
            }
            if (competitionSeason.venues) {
                competitionSeason.venues = JSON.parse(competitionSeason.venues);
            } else {
                competitionSeason.venues = [];
            }
            if (competitionSeason.result_exceptions) {
                competitionSeason.result_exceptions = JSON.parse(competitionSeason.result_exceptions);
            } else {
                competitionSeason.result_exceptions = [];
            }
            if (competitionSeason.results) {
                competitionSeason.results = JSON.parse(competitionSeason.results);
                competitionSeason.results = competitionSeason.results.sort((a, b) => {
                    if (competitionSeason.result_sort == 'ASC') {
                        return a[key] > b[key] ? 1 : (a[key] < b[key] ? -1 : 0)
                    } else {
                        return a[key] > b[key] ? -1 : (a[key] < b[key] ? 1 : 0)
                    }
                });
            } else {
                competitionSeason.results = [];
            }
            if (competitionSeason.teams_section_data) {
                competitionSeason.teams_section_data = JSON.parse(competitionSeason.teams_section_data);
            } else {
                competitionSeason.teams_section_data = {
                    sectionTeams: 'teams',
                    sectionTeamsId: 'id_teams',
                    sectionTeamsName: 'team_name'
                };
            }
            return competitionSeason;

        }

        function DTOstoMatches(matches) {
            for (var i = 0; i < matches.length; i++) {
                matches[i] = DTOtoMatch(matches[i])
            }
            return matches;
        }


        function applyExceptions(results, exceptions, key) {
            if (exceptions.length > 0) {
                for (let i = 0; i < exceptions.length; i++) {
                    const exception = exceptions[i];
                    const team1index = results.findIndex(x => x.id_teams == exception.teams[0]);
                    const team2index = results.findIndex(x => x.id_teams == exception.teams[1]);
                    if (team2index >= 0 && team1index >= 0) {
                        const currentAboveTeamIndex = team1index < team2index ? team1index : team2index;
                        const currentBelowTeamIndex = team1index < team2index ? team2index : team1index;
                        if (results[team1index][key] == results[team2index][key]
                            && exception.team_above != results[currentAboveTeamIndex].id_teams) {
                            changePosition(currentBelowTeamIndex, currentAboveTeamIndex, results);
                            const name = results[currentAboveTeamIndex].name ? results[currentAboveTeamIndex].name : results[currentAboveTeamIndex].team_name;
                        }
                    }
                }
            }
            return results;
        }

        function DTOtoMatch(match) {
            if (match.jury_data) {
                match.jury_data = JSON.parse(match.jury_data);
            } else {
                match.jury_data = [];
            }
            if (match.teams_data) {
                match.teams_data = JSON.parse(match.teams_data);
            } else {
                match.teams_data = [];
            }
            if (match.venue_data) {
                match.venue_data = JSON.parse(match.venue_data);
            } else {
                match.venue_data = [];
            }
            if (match.results_data) {
                match.results_data = JSON.parse(match.results_data);
            } else {
                match.results_data = {};
            }
            if (match.date == '0000-00-00 00:00:00') {
                match.date = null;
            }
            if (match.teams_data && match.teams_data.length > 0) {
                var currentDate = new Date("1/1/00").getTime();
                for (var i = 0; i < match.teams_data.length; i++) {
                    if (match.teams_data[i].start_time) {
                        match.teams_data[i].start_time = new Date(currentDate + moment.duration(match.teams_data[i].start_time).as('milliseconds'));
                        // match.teams_data[i].start_time = moment.utc(moment.duration(match.teams_data[i].start_time).as('milliseconds')).toDate();
                    }
                    if (match.teams_data[i].end_time) {
                        match.teams_data[i].end_time = new Date(currentDate + moment.duration(match.teams_data[i].end_time).as('milliseconds'));
                        // match.teams_data[i].end_time = moment.utc(moment.duration(match.teams_data[i].end_time).as('milliseconds')).toDate();
                    }
                    if (match.teams_data[i].elapsed_time) {
//                      match.teams_data[i].elapsed_time = moment.utc(moment.duration(match.teams_data[i].elapsed_time).as('milliseconds')).toDate();
                    }
                    // delta is stored and displayed as a free-text string (no Date conversion needed)
                }
            }
            return match;
        }
        function MatchToDTO(match, competitionSeason, final_types, ref, teamsReferenceSections) {
            if (!match.results_data) {
                match.results_data = {};
            }
            match.results_data = getResultData(match, competitionSeason, final_types, ref, teamsReferenceSections)
            match.results_data = angular.toJson(match.results_data);
            match.jury_data = angular.toJson(match.jury_data);
            if (match.teams_data && match.teams_data.length > 0) {
                for (var i = 0; i < match.teams_data.length; i++) {
                    match.teams_data[i].start_time = match.teams_data[i].start_time ? moment(match.teams_data[i].start_time).format('HH:mm:ss') : null;
                    match.teams_data[i].end_time = match.teams_data[i].end_time ? moment(match.teams_data[i].end_time).format('HH:mm:ss') : null;
                    /*
                    if (!match.teams_data[i].elapsed_time) {
                      match.teams_data[i].elapsed_time = null
                    } else if (match.teams_data[i].elapsed_time != 'DNF') {
                      match.teams_data[i].elapsed_time = match.teams_data[i].elapsed_time ? moment('2021-01-01 ' + match.teams_data[i].elapsed_time).format('HH:mm:ss.SSS') : null;
                    }
                     */
                    match.teams_data[i].delta = match.teams_data[i].delta || null;
                    match.teams_data[i].position = i + 1;
                }
            }
            match.teams_data = angular.toJson(match.teams_data);
            var found = _.find(competitionSeason.venues, function (x) {
                return x.id_venues == match.id_venue
            })
            match.venue_data = angular.toJson(found);
            if (match.date == null) {
                match.date = '0000-00-00 00:00:00';
            }
            return match;

        }

        function setItemMedia(attachment, refField) {
            var opts = {};
            opts.file = false;
            opts.thumbnail = false;
            var cropFormatId = (!refField || refField.id_cropformats === null) ? sessionService.getMediaThumbnailCropformatId() : refField.id_cropformats;
            if (cropFormatId == 0 || attachment.filename.includes(".gif") || attachment.filename.includes(".svg")) {
                var containerOriginal = sessionService.getContainerByID(attachment.cdnContainer);
                return containerOriginal.view_url + 'original/m' + attachment.id_media + '_' + attachment.filename;
            }
            if (angular.isObject(attachment) && angular.isObject(attachment.cropstatus) && attachment.cropstatus.length > 0) {
                var cropstatus = _.find(attachment.cropstatus, function (c) {
                    if (c.id_cropformats == cropFormatId) {
                        return true;
                    }
                });
                if (!angular.isUndefined(cropstatus)) {
                    var container = sessionService.getContainerByID(cropstatus.id_container);
                    return container.view_url + cropstatus.fileName;
                } else {
                    return '';
                }
            } else if (attachment.id_media) {
                var options = {
                    id_media: [attachment.id_media],
                };

                CommonMediaService.getUrl(options)
                    .then(function (response) {
                        if (response.length > 0) {
                            var cropstatus = _.find(response, {
                                'id_cropformats': cropFormatId
                            });
                            return cropstatus.url;
                        } else {
                            // Original showed
                            var containerOriginal = sessionService.getContainerByID(attachment.cdnContainer);
                            if (!angular.isUndefined(containerOriginal)) {
                                return containerOriginal.view_url + 'original/m' + attachment.id_media + '_' + attachment.filename;
                            }
                        }
                    });
            }
        }

        function getResults(competitionSeason, matches, sport) {
            let key = getKey(sport);

            var result;
            switch (competitionSeason.competition.id_subsec) {
                case 1:
                    result = transformMatchFootball.getResultsFootball(competitionSeason, matches);
                    break;
                case 2:
                    if (competitionSeason.match_type == 2) {
                        result = transformMatchSailingFlota.getResultsSailingFlota(competitionSeason, matches);
                    } else {
                        result = transformMatchSailingRegata.getResultsRegata(competitionSeason, matches);
                    }
                    break;
                case 3:
                    result = transformMatchCars.getResultCars(competitionSeason, matches);
                    break;
                case 4:
                    result = transformMatchTennis.getResultTennis(competitionSeason, matches);
                    break;

                default:
                    return;
            }
            if (!result) return;
//            if (competitionSeason.competition.id_subsec != 3) {
                result = applyExceptions(result, competitionSeason.result_exceptions, key);
//            }
            for (let i = 0; i < result.length; i++) {
                const element = result[i];
                element.position = i + 1;
            }
            return result;


        }
        function getResultData(match, competitionSeason, final_types, ref, teamsReferenceSections) {
            var result;
            switch (competitionSeason.competition.id_subsec) {
                case 1:
                    result = transformMatchFootball.getResultDataFootball(match, final_types, ref, teamsReferenceSections);
                    break;
                case 2:
                    if (competitionSeason.match_type == 2) {
                        result = transformMatchSailingFlota.getResultDataSailingFlota(match, competitionSeason, ref, teamsReferenceSections);
                    } else {
                        result = transformMatchSailingRegata.getResultDataRegata(match, competitionSeason, ref, teamsReferenceSections);
                    }
                    break;
                case 3:
                    result = transformMatchCars.getResultDataCars(match, competitionSeason, ref, teamsReferenceSections);
                    break;
                case 4:
                    result = transformMatchTennis.getResultDataTennis(match, competitionSeason, ref, teamsReferenceSections);
                    break;

                default:
                    break;
            }
            return result;
        }

        function changePosition(newIndex, oldIndex, array) {
            if (oldIndex < newIndex) {
                for (var i = oldIndex; i < newIndex; i++) {
                    var temp = array[i + 1];
                    array[i + 1] = array[i];
                    array[i] = temp;
                }
            }
            if (newIndex < oldIndex) {
                for (var i = oldIndex; i > newIndex; i--) {
                    var temp = array[i - 1];
                    array[i - 1] = array[i];
                    array[i] = temp;
                }
            }
            return array;
        }


        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.match-center')
        .factory("transformMatchCars", transformMatchCars);



    /** @ngInject */
    function transformMatchCars($filter, sessionService) {
        var vm = this;

        var service = {
            getResultCars: getResultCars,
            getResultsGrouped: getResultsGrouped,
            getResultDataCars: getResultDataCars
        };

        function getResultCars(competitionSeason, matches) {
            // La clasificacion se RECONSTRUYE entera en cada guardado a partir de la
            // plantilla de pilotos y de los partidos. Hay dos datos que no salen de ahi
            // y que por tanto se perderian si no se conservan a mano:
            //   - events      : el desglose de puntos por carrera (lo escribe el importador)
            //   - penalties   : la penalizacion de puntos de la temporada
            //   - reprimands  : las amonestaciones (no restan puntos, son disciplinarias)
            // Se indexan por id_teams desde lo que ya habia guardado.
            var previo = {};
            angular.forEach(competitionSeason.results || [], function (fila) {
                if (fila && angular.isDefined(fila.id_teams)) {
                    previo[fila.id_teams] = fila;
                }
            });

            var teams = [];
            teams = competitionSeason.teams.filter(x => !x.hidestandings).map(team => {
                return angular.merge(team, { name: team.team_name, points: 0, total: 0, races_participated: 0, races_won: 0, races_podium: 0, elapsed_time: 0 })
            });
            for (var i = 0; i < matches.length; i++) {
                const match = matches[i];
                if ((match.status == "5" && match.onoff || (competitionSeason.live_results && match.status == "4")) && match.results_data && match.results_data.teams) {
                    teams = saveTeamsResult(teams, match);
                }
            }

            // Puntos NETOS = lo sumado en las carreras + la penalizacion (que es negativa).
            // Se aplica ANTES de ordenar, para que una sancion mueva al piloto de posicion.
            angular.forEach(teams, function (team) {
                var anterior = previo[team.id_teams] || {};
                if (anterior.events) {
                    team.events = anterior.events;
                }
                // -abs(): la penalizacion solo puede restar. Normalizando aqui da igual
                // con que signo llegue lo guardado (hay filas metidas a mano en la BD).
                team.penalties = aPenalizacion(anterior.penalties);
                team.reprimands = Math.abs(aNumero(anterior.reprimands));
                team.points = team.points + team.penalties;
                team.total = team.points;
            });

            // El signo va DENTRO del criterio, no en el flag de invertir. Con el flag,
            // orderBy multiplica tambien el desempate por indice (angular.js:22595) y los
            // empatados salian en orden INVERSO al de la plantilla, barajando la tabla
            // entera en cada guardado. Con el criterio firmado el desempate queda estable.
            var criterio = competitionSeason.result_sort === 'ASC' ? 'points' : '-points';
            teams = $filter('orderBy')(teams, criterio);
            teams = teams.filter(x => {
                return !competitionSeason.teams.find(y => y.id_teams == x.id_teams).hidestandings
            })
            return teams;
        }

        // Las sanciones llegan del input como texto (o vacias). Sin esto, '' o '-30'
        // contaminarian la suma de puntos con concatenaciones o NaN.
        function aPenalizacion(valor) {
            var n = Math.abs(aNumero(valor));
            return n === 0 ? 0 : -n;
        }

        function aNumero(valor) {
            var n = parseInt(valor, 10);
            return isNaN(n) ? 0 : n;
        }

        function saveTeamsResult(teams, match) {
            angular.forEach(teams, function (teamFound) {
                angular.forEach(match.results_data.teams, function (team, index) {
                    if (team.id_teams == teamFound.id_teams) {
                        const matchPosition = index;
                        teamFound.points += team.points;
                        teamFound.total += team.points;
                        teamFound.races_participated += 1;
                        if (matchPosition < 3) {
                            teamFound.races_podium += 1;
                        }
                        if (matchPosition === 0) {
                            teamFound.races_won += 1;
                        }
                        if (team.elapsed_time) {
                            if (team.elapsed_time == 'DNF' || teamFound.elapsed_time == 'DNF') {
                                teamFound.elapsed_time = 'DNF';
                            } else {
                                var exp = team.elapsed_time.split(':');
                                if (exp.length == 2) {
                                    team.elapsed_time = '00:' + team.elapsed_time;
                                }
                                if (teamFound.elapsed_time) {
                                    var expFound = teamFound.elapsed_time.split(':');
                                    if (expFound.length == 2) {
                                        teamFound.elapsed_time = '00:' + teamFound.elapsed_time;
                                    }
                                }
                                var d = moment.duration(teamFound.elapsed_time).add(moment.duration(team.elapsed_time))
                                teamFound.elapsed_time = moment.utc(d.as('milliseconds')).format("HH:mm:ss.SSS")
                                if (teamFound.elapsed_time && teamFound.elapsed_time.substring(0, 3) == '00:') {
                                    teamFound.elapsed_time = teamFound.elapsed_time.substring(3);
                                }
                            }
                        }
                    }
                })
            })
            return teams;
        }

        function getResultDataCars(match, competitionSeason, ref, teamsReferenceSections) {
            var result = {};
            result.teams = [];
            if (match.teams_data) {
                for (var i = 0; i < match.teams_data.length; i++) {
                    const team = match.teams_data[i];
                    var team_result = toTeamRef(team, i, ref, teamsReferenceSections);
                    result.teams.push(team_result)
                    result.teams[i].points = team_result.points ? parseInt(team_result.points) : 0;
                    result.teams[i].elapsed_time = team.elapsed_time;// ? moment(team.elapsed_time).format('HH:mm:ss') : 0;
                    result.teams[i].extra = team_result.extra ? parseInt(team_result.extra) : 0;
                }
            }
            if (match.results_data) {
                result.final_type = match.results_data.final_type;
                result.result_type = match.results_data.result_type;
            }
            return result;
        }

        function getResultsGrouped(results) {
            let resultsGrouped;
            resultsGrouped = _.groupBy(results, (m) => {
                return m.constructor;
            });
            resultsGrouped = Object.values(resultsGrouped).map(x => {
                const result = { constructor: '', races: [], total: 0 };
                for (let i = 0; i < x.length; i++) {
                    const element = x[i];
                    result.constructor = element.constructor;
                    for (let j = 0; j < element.races.length; j++) {
                        const raceElement = element.races[j];
                        const foundIndex = result.races.findIndex(x => x.race == raceElement.race);
                        if (foundIndex >= 0) {
                            result.races[foundIndex].points += raceElement.points;
                        } else {
                            result.races.push(angular.copy(raceElement))
                        }
                    }
                    result.total += element.total;
                }
                return result;
            });
            return resultsGrouped;
        }

        function getReferenceSectionData(key, property, value, teamsReferenceSections) {
            switch (property) {
                case 'id_subsec':
                    var fieldReturn = 'subsec';
                    break;
                case 'id_cat':
                    var fieldReturn = 'cat';
                    break;
                case 'id_subcat':
                    var fieldReturn = 'subcat';
                    break;
                default:
                    var fieldReturn = 'cat';
            }

            if (!angular.isUndefined(teamsReferenceSections[key])) {
                for (var i = 0, len = teamsReferenceSections[key].length; i < len; i++) {
                    if (teamsReferenceSections[key][i][property] === value) return teamsReferenceSections[key][i][fieldReturn];
                }
            }
            return "--";

        }

        function toTeamRef(team, i, ref, teamsReferenceSections) {
            var result = {}
            for (var i = 0; i < ref.length; i++) {
                const element = ref[i];
                if (element.in_json_object == 1) {
                    if (element.type == 'thumbnail') {
                        result[element.titleId] = team.Thumbnail && team.Thumbnail.length > 0 ? setItemMedia(team.Thumbnail[0], element) : team[element.titleId];
                    } else if (element.type == 'id_subsec') {
                        result[element.titleId] = getReferenceSectionData('subsection', element.type, team[element.titleId], teamsReferenceSections)
                    } else if (element.type == 'id_cat') {
                        result[element.titleId] = getReferenceSectionData('cat', element.type, team[element.titleId], teamsReferenceSections)
                    } else if (element.type == 'id_subcat') {
                        result[element.titleId] = getReferenceSectionData('subcat', element.type, team[element.titleId], teamsReferenceSections)
                    } else if (element.type == 'zone') {
                        if (angular.isArray(team.Thumbnail) && team.Thumbnail.length) {
                            const zone = team.Thumbnail.find(x => x.id_zone === element.id_zone);
                            result[element.titleId] = team.Thumbnail && team.Thumbnail.length > 0 ? setItemMedia(zone, element) : team[element.titleId];
                        }
                    } else {
                        result[element.titleId] = team[element.titleId];
                    }
                }
            }
            result.points = parseInt(team.points);
            result.extra = parseInt(team.extra);
            result.id_teams = team.id_teams;
            result.team_name = team.team_name;
            return result;
        }

        function setItemMedia(attachment, refField) {
            if (!attachment) return;
            var opts = {};
            opts.file = false;
            opts.thumbnail = false;
            var cropFormatId = (!refField || refField.id_cropformats === null) ? sessionService.getMediaThumbnailCropformatId() : refField.id_cropformats;
            if (cropFormatId == 0 || attachment.filename.includes(".gif") || attachment.filename.includes(".svg")) {
                var containerOriginal = sessionService.getContainerByID(attachment.cdnContainer);
                return containerOriginal.view_url + 'original/m' + attachment.id_media + '_' + attachment.filename;
            }
            if (angular.isObject(attachment) && angular.isObject(attachment.cropstatus) && attachment.cropstatus.length > 0) {
                var cropstatus = _.find(attachment.cropstatus, function (c) {
                    if (c.id_cropformats == cropFormatId) {
                        return true;
                    }
                });
                if (!angular.isUndefined(cropstatus)) {
                    var container = sessionService.getContainerByID(cropstatus.id_container);
                    return container.view_url + cropstatus.fileName;
                } else {
                    return '';
                }
            } else if (attachment.id_media) {
                var options = {
                    id_media: [attachment.id_media],
                };

                CommonMediaService.getUrl(options)
                    .then(function (response) {
                        if (response.length > 0) {
                            var cropstatus = _.find(response, {
                                'id_cropformats': cropFormatId
                            });
                            return cropstatus.url;
                        } else {
                            // Original showed
                            var containerOriginal = sessionService.getContainerByID(attachment.cdnContainer);
                            if (!angular.isUndefined(containerOriginal)) {
                                return containerOriginal.view_url + 'original/m' + attachment.id_media + '_' + attachment.filename;
                            }
                        }
                    });
            }
        }


        return service;
    }
})();

// Generated by CoffeeScript 1.8.0
(function () {
  var MODULE_NAME, SLIDER_TAG, angularize, contain, events, gap, halfWidth, hide, module, offset, offsetLeft, pixelize, qualifiedDirectiveDefinition, roundStep, show, sliderDirective, width;

  MODULE_NAME = 'ui.slider';

  SLIDER_TAG = 'slider';

  angularize = function (element) {
    return angular.element(element);
  };

  pixelize = function (position) {
    return "" + position + "px";
  };

  hide = function (element) {
    return element.css({
      opacity: 0
    });
  };

  show = function (element) {
    return element.css({
      opacity: 1
    });
  };

  offset = function (element, position) {
    return element.css({
      left: position
    });
  };

  halfWidth = function (element) {
    return element[0].offsetWidth / 2;
  };

  offsetLeft = function (element) {
    return element[0].offsetLeft;
  };

  width = function (element) {
    return element[0].offsetWidth;
  };

  gap = function (element1, element2) {
    return offsetLeft(element2) - offsetLeft(element1) - width(element1);
  };

  contain = function (value) {
    if (isNaN(value)) {
      return value;
    }
    return Math.min(Math.max(0, value), 100);
  };

  roundStep = function (value, precision, step, floor) {
    var decimals, remainder, roundedValue, steppedValue;
    if (floor == null) {
      floor = 0;
    }
    if (step == null) {
      step = 1 / Math.pow(10, precision);
    }
    remainder = (value - floor) % step;
    steppedValue = remainder > (step / 2) ? value + step - remainder : value - remainder;
    decimals = Math.pow(10, precision);
    roundedValue = steppedValue * decimals / decimals;
    return parseFloat(roundedValue.toFixed(precision));
  };

  events = {
    mouse: {
      start: 'mousedown',
      move: 'mousemove',
      end: 'mouseup'
    },
    touch: {
      start: 'touchstart',
      move: 'touchmove',
      end: 'touchend'
    }
  };

  sliderDirective = function ($timeout) {
    return {
      restrict: 'E',
      scope: {
        floor: '@',
        ceiling: '@',
        values: '=?',
        ngModelTags: '=?',
        showHandles: '=?',
        step: '@',
        highlight: '@',
        precision: '@',
        buffer: '@',
        dragstop: '@',
        ngModel: '=?',
        ngModelLow: '=?',
        ngModelHigh: '=?',
        onEmitGoTo: '&',
        change: '&'
      },
      template: '<div class="bar" ><div ng-style="{\'opacity\' : showHandles ? 1 : 0}" class="selection"></div></div>\n<div title="{{tag.title}}" ng-if="tags" ng-repeat="tag in tags track by $index" ng-click="goto(tag)" ng-class="{\'mark\' : !tag.extra}" class="tag-clip-data"></div>\n<div ng-style="{\'opacity\' : showHandles ? 1 : 0}" class="handle low"></div><div ng-style="{\'opacity\' : showHandles ? 1 : 0}"  class="handle high"></div>\n<div class="bubble limit low">{{ values.length ? values[floor || 0] : floor }}</div>\n<div class="bubble limit high">{{ values.length ? values[ceiling || values.length - 1] : ceiling }}</div>\n<div class="bubble value low">{{ values.length ? values[local.ngModelLow || local.ngModel || 0] : local.ngModelLow || local.ngModel || 0 }}</div>\n<div class="bubble value high">{{ values.length ? values[local.ngModelHigh] : local.ngModelHigh }}</div>',
      controller: ['$scope', function ($scope) {
        $scope.goto = function (tag) {
          $scope.onEmitGoTo(tag)
        }
      }],
      compile: function (element, attributes) {
        var high, low, range, watchables;
        range = (attributes.ngModel == null) && (attributes.ngModelLow != null) && (attributes.ngModelHigh != null);
        low = range ? 'ngModelLow' : 'ngModel';
        high = 'ngModelHigh';
        watchables = ['floor', 'ceiling', 'values', low];
        if (range) {
          watchables.push(high);
        }
        return {
          post: function (scope, element, attributes) {
            var bar, barWidth, bound, ceilBub, dimensions, e, flrBub, handleHalfWidth, highBub, lowBub, maxOffset, maxPtr, maxValue, minOffset, minPtr, minValue, ngDocument, offsetRange, selection, updateDOM, upper, valueRange, w, _i, _j, _len, _len1, _ref, _ref1;
            _ref = (function () {
              var _i, _len, _ref, _results;
              _ref = element.children();
              _results = [];
              for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                e = _ref[_i];
                _results.push(angularize(e));
              }
              return _results;
            })(), bar = _ref[0], minPtr = _ref[1], maxPtr = _ref[2], flrBub = _ref[3], ceilBub = _ref[4], lowBub = _ref[5], highBub = _ref[6];
            selection = angularize(bar.children()[0]);
            if (!range) {
              _ref1 = [maxPtr, highBub];
              for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
                upper = _ref1[_i];
                upper.remove();
              }
              if (!attributes.highlight) {
                selection.remove();
              }
            }
            scope.local = {};
            scope.local[low] = scope[low];
            scope.local[high] = scope[high];
            bound = false;
            ngDocument = angularize(document);
            handleHalfWidth = barWidth = minOffset = maxOffset = minValue = maxValue = valueRange = offsetRange = void 0;
            dimensions = function () {
              var value, _j, _len1, _ref2;
              if (scope.step == null) {
                scope.step = 1;
              }
              if (scope.floor == null) {
                scope.floor = 0;
              }
              if (scope.precision == null) {
                scope.precision = 0;
              }
              if (!range) {
                scope.ngModelLow = scope.ngModel;
              }
              if (scope.ngModelTags) {
                scope.tags = scope.ngModelTags;
              }
              if ((_ref2 = scope.values) != null ? _ref2.length : void 0) {
                if (scope.ceiling == null) {
                  scope.ceiling = scope.values.length - 1;
                }
              }
              scope.local[low] = scope[low];
              scope.local[high] = scope[high];
              for (_j = 0, _len1 = watchables.length; _j < _len1; _j++) {
                value = watchables[_j];
                if (typeof value === 'number') {
                  scope[value] = roundStep(parseFloat(scope[value]), parseInt(scope.precision), parseFloat(scope.step), parseFloat(scope.floor));
                }
              }
              handleHalfWidth = halfWidth(minPtr);
              barWidth = width(bar);
              minOffset = 0;
              maxOffset = barWidth - width(minPtr);
              minValue = parseFloat(scope.floor);
              maxValue = parseFloat(scope.ceiling);
              valueRange = maxValue - minValue;
              return offsetRange = maxOffset - minOffset;
            };
            updateDOM = function () {
              var bind, percentOffset, percentValue, pixelsToOffset, setBindings, setPointers;
              dimensions();
              percentOffset = function (offset) {
                return contain(((offset - minOffset) / offsetRange) * 100);
              };
              percentValue = function (value) {
                return contain(((value - minValue) / valueRange) * 100);
              };
              pixelsToOffset = function (percent) {
                return pixelize(percent * offsetRange / 100);
              };
              setPointers = function () {
                var newHighValue, newLowValue;
                offset(ceilBub, pixelize(barWidth - width(ceilBub)));
                newLowValue = percentValue(scope.local[low]);
                if (scope.tags) {
                  for (let i = 0; i < scope.tags.length; i++) {
                    const tag = scope.tags[i];
                    var startsplited = tag.start.split(':');
                    tagvaluestart = percentValue((parseInt(startsplited[0]) * 60 * 60) + (parseInt(startsplited[1]) * 60) + parseInt(startsplited[2]));
                    offset($($('.tag-clip-data')[i]), pixelsToOffset(tagvaluestart));
                  }
                }
                offset(minPtr, pixelsToOffset(newLowValue));
                offset(lowBub, pixelize(offsetLeft(minPtr) - (halfWidth(lowBub)) + handleHalfWidth));
                offset(selection, pixelize(offsetLeft(minPtr) + handleHalfWidth));
                switch (true) {
                  case range:
                    newHighValue = percentValue(scope.local[high]);
                    offset(maxPtr, pixelsToOffset(newHighValue));
                    offset(highBub, pixelize(offsetLeft(maxPtr) - (halfWidth(highBub)) + handleHalfWidth));
                    return selection.css({
                      width: pixelsToOffset(newHighValue - newLowValue)
                    });
                  case attributes.highlight === 'right':
                    return selection.css({
                      width: pixelsToOffset(110 - newLowValue)
                    });
                  case attributes.highlight === 'left':
                    selection.css({
                      width: pixelsToOffset(newLowValue)
                    });
                    return offset(selection, 0);
                }
              };
              bind = function (handle, bubble, ref, events) {
                var changed, currentRef, onEnd, onMove, onStart;
                currentRef = ref;
                changed = false;
                onEnd = function () {
                  bubble.removeClass('active');
                  handle.removeClass('active');
                  ngDocument.unbind(events.move);
                  ngDocument.unbind(events.end);
                  if (scope.dragstop) {
                    scope[high] = scope.local[high];
                    scope[low] = scope.local[low];
                  }
                  currentRef = ref;
                  scope.$apply();
                  if (changed) {
                    return scope.$eval(scope.change);
                  }
                };
                onMove = function (event) {
                  var eventX, newOffset, newPercent, newValue, _ref2, _ref3, _ref4;
                  eventX = event.clientX || ((_ref2 = event.touches) != null ? _ref2[0].clientX : void 0) || ((_ref3 = event.originalEvent) != null ? (_ref4 = _ref3.changedTouches) != null ? _ref4[0].clientX : void 0 : void 0) || 0;
                  newOffset = eventX - element[0].getBoundingClientRect().left - handleHalfWidth;
                  newOffset = Math.max(Math.min(newOffset, maxOffset), minOffset);
                  newPercent = percentOffset(newOffset);
                  newValue = minValue + (valueRange * newPercent / 100.0);
                  if (range) {
                    switch (currentRef) {
                      case low:
                        if (newValue > scope.local[high]) {
                          currentRef = high;
                          minPtr.removeClass('active');
                          lowBub.removeClass('active');
                          maxPtr.addClass('active');
                          highBub.addClass('active');
                          setPointers();
                        } else if (scope.buffer > 0) {
                          newValue = Math.min(newValue, scope.local[high] - scope.buffer);
                        }
                        break;
                      case high:
                        if (newValue < scope.local[low]) {
                          currentRef = low;
                          maxPtr.removeClass('active');
                          highBub.removeClass('active');
                          minPtr.addClass('active');
                          lowBub.addClass('active');
                          setPointers();
                        } else if (scope.buffer > 0) {
                          newValue = Math.max(newValue, parseInt(scope.local[low]) + parseInt(scope.buffer));
                        }
                    }
                  }
                  newValue = roundStep(newValue, parseInt(scope.precision), parseFloat(scope.step), parseFloat(scope.floor));
                  changed = scope.dragstop && changed || scope.local[currentRef] !== newValue;
                  scope.local[currentRef] = newValue;
                  scope.$apply();
                  setPointers();
                  if (!scope.dragstop) {
                    scope[currentRef] = newValue;
                    if (changed) {
                      return scope.$eval(scope.change);
                    }
                  }
                };
                onStart = function (event) {
                  dimensions();
                  bubble.addClass('active');
                  handle.addClass('active');
                  setPointers();
                  event.stopPropagation();
                  event.preventDefault();
                  ngDocument.bind(events.move, onMove);
                  return ngDocument.bind(events.end, onEnd);
                };
                return handle.bind(events.start, onStart);
              };
              setBindings = function () {
                var method, _j, _len1, _ref2;
                _ref2 = ['touch', 'mouse'];
                for (_j = 0, _len1 = _ref2.length; _j < _len1; _j++) {
                  method = _ref2[_j];
                  bind(minPtr, lowBub, low, events[method]);
                  bind(maxPtr, highBub, high, events[method]);
                }
                return bound = true;
              };
              if (!bound) {
                setBindings();
              }
              return setPointers();
            };
            $timeout(updateDOM);
            for (_j = 0, _len1 = watchables.length; _j < _len1; _j++) {
              w = watchables[_j];
              scope.$watch(w, updateDOM, true);
            }
            scope.$watch('tags', function () {
              setTimeout(() => {
                updateDOM();
              }, 200);
            }, true);
            return window.addEventListener('resize', updateDOM);
          }
        };
      }
    };
  };

  qualifiedDirectiveDefinition = ['$timeout', sliderDirective];

  module = function (window, angular) {
    return angular.module(MODULE_NAME, []).directive(SLIDER_TAG, qualifiedDirectiveDefinition);
  };

  module(window, window.angular);

}).call(this);


(function () {
  'use strict';

  angular.module('app.match-center')
    .directive('player', ['$rootScope', '$mdDialog', playerController]);

  function playerController($rootScope, $mdDialog) {
    'use strict';
    return {
      restrict: 'E',
      scope: {
        tags: '=',
        url: '=',
        onEmitCreate: '&',
        onEmitCreateApi: '&',
        onEmitCreateMark: '&'
      },
      link: function (scope, element, attrs) {
        // scope.url = attrs.url;
        // scope.tags = attrs.tags;
        var offset = 30;
        scope.zoom = false;
        var mediaElementPlayer;
        setTimeout(() => {

          var player = new MediaElementPlayer('vp-m3u8', {
            startVolume: 1,
            alwaysShowControls: true,
            features: ['playpause', 'current', 'progress', 'tracks', 'volume', 'fullscreen'],
            success: (mediaElement, domObject) => {
              var interval = 0;
              scope.start = 0;
              mediaElementPlayer = mediaElement;
              mediaElement.play();
              mediaElement.addEventListener('loadedmetadata', (e) => {
                scope.$apply(() => {
                  scope.end = mediaElement.getDuration();
                  scope.current = scope.start;
                  scope.currentPercent = scope.start;
                  scope.duration = scope.end;
                });
              });
              mediaElement.addEventListener('progress', (e) => {
                scope.$apply(() => {
                  scope.duration = mediaElement.getDuration();
                  if (!scope.touched) {
                    scope.end = scope.duration;
                  }
                });
              });
              mediaElement.addEventListener('timeupdate', (e) => {
                scope.$apply(() => {
                  scope.current = mediaElement.getCurrentTime();
                  scope.currentPercent = (scope.current / (scope.end - scope.start)) * 100;
                  if (scope.current < scope.start) {
                    scope.current = scope.start;
                  }
                  if (scope.current > scope.end && scope.playingclip) {
                    if (mediaElement.paused === false) {
                      mediaElement.pause();
                      scope.playingclip = false;
                    }
                  }
                });
              }, false);



              scope.onTrimChange = function () {
                scope.touched = true;
                scope.playingclip = false;
                mediaElement.pause();
              };

              scope.$watch('start', function (num) {
                if (num !== undefined && !scope.clickIn) {
                  if (interval) {
                    window.clearInterval(interval);
                  }
                  interval = window.setTimeout(function () {
                    console.log(scope.start, 'start')
                    mediaElement.setCurrentTime(scope.start);
                  }, 300);
                }
              });

              scope.$watch('end', function (num) {
                if (scope.touched && !scope.clickIn) {
                  if (num !== undefined) {
                    if (interval) {
                      window.clearInterval(interval);
                    }
                    interval = window.setTimeout(function () {
                      console.log(scope.end, 'end')
                      mediaElement.setCurrentTime(scope.end);
                    }, 300);
                  }
                }
              });
              scope.$watch('startZoom', function (num) {
                if (num !== undefined) {
                  scope.start = scope.originalStart - offset + num;
                }
              });

              scope.$watch('endZoom', function (num) {
                if (num !== undefined) {
                  scope.end = scope.start + scope.endZoom - scope.startZoom;
                }
              });
            }
          });
          $rootScope.$on('EDIT_CLIP_WINDOW', function (event, data) {
            mediaElementPlayer.setVolume(data.volume)
          });
        });

        scope.$watch('tags', function (tags) {
          console.log('change tags1', tags);
        });

        scope.onCreateClip = function () {
          if (scope.startInput != undefined && scope.endInput != undefined) {
            scope.start = parseInt(scope.startInput.split(':')[0]) * 60 * 60 + parseInt(scope.startInput.split(':')[1]) * 60 + parseInt(scope.startInput.split(':')[2]);
            scope.end = parseInt(scope.endInput.split(':')[0]) * 60 * 60 + parseInt(scope.endInput.split(':')[1]) * 60 + parseInt(scope.endInput.split(':')[2]);
          }
          scope.onEmitCreate({ start: parseInt(scope.start), end: parseInt(scope.end) })
          mediaElementPlayer.pause()
        };
        scope.onCreateClipApi = function (title, edit, create) {
          if (scope.startInput != undefined && scope.endInput != undefined) {
            if (create) {
              scope.onEmitCreateApi({ title: title, edit: edit, start: scope.startInput, end: scope.endInput })
            } else {
              scope.onEmitCreateMark({ title: title, edit: edit, start: scope.startInput, end: scope.endInput })
            }
            scope.start = parseInt(scope.startInput.split(':')[0]) * 60 * 60 + parseInt(scope.startInput.split(':')[1]) * 60 + parseInt(scope.startInput.split(':')[2]);
            scope.end = parseInt(scope.endInput.split(':')[0]) * 60 * 60 + parseInt(scope.endInput.split(':')[1]) * 60 + parseInt(scope.endInput.split(':')[2]);
          } else {
            var formatstart = new Date(parseInt(scope.start) * 1000).toISOString().substr(11, 8);
            var formatend = new Date(parseInt(scope.end) * 1000).toISOString().substr(11, 8);
            if (create) {
              scope.onEmitCreateApi({ title: title, edit: edit, start: formatstart, end: formatend })
            } else {
              scope.onEmitCreateMark({ title: title, edit: edit, start: formatstart, end: formatend })
            }
            mediaElementPlayer.pause()
          }
        };
        scope.onTitleWindow = function (ev, create) {

          $mdDialog.show({
            controller: 'TitleClipDialogController',
            controllerAs: 'vm',
            locals: {
              create: create
            },
            templateUrl: 'app/main/apps/match-center/dialogs/titleclip/titleclip-dialog.html',
            targetEvent: ev,
            multiple: true,
            clickOutsideToClose: false
          }).then(function (response) {
            if (response) {
              scope.onCreateClipApi(response.title, response.edit, create)
            }
          });
        }
        scope.getFormatTime = function (seconds) {
          if (seconds) {
            return new Date(parseInt(seconds) * 1000).toISOString().substr(11, 8);
          } else {
            return '';
          }
        }
        scope.goto = function (seconds) {
          scope.clickedIn = false;
          scope.clickedOut = false;
          mediaElementPlayer.setCurrentTime(mediaElementPlayer.getCurrentTime() - seconds);
          scope.start = mediaElementPlayer.getCurrentTime();
          scope.end = mediaElementPlayer.getCurrentTime() + seconds;
          scope.startInput = new Date(parseInt(scope.start) * 1000).toISOString().substr(11, 8)
          scope.endInput = new Date(parseInt(scope.end) * 1000).toISOString().substr(11, 8)
          scope.touched = true;
        }
        scope.gototag = function (start, end) {
          var startsplited = start.split(':');
          var endsplited = end.split(':');
          var startSeconds = (parseInt(startsplited[0]) * 60 * 60) + (parseInt(startsplited[1]) * 60) + parseInt(startsplited[2]);
          var endSeconds = (parseInt(endsplited[0]) * 60 * 60) + (parseInt(endsplited[1]) * 60) + parseInt(endsplited[2]);
          mediaElementPlayer.setCurrentTime(startSeconds);
          scope.start = startSeconds;
          scope.end = endSeconds;
          scope.startInput = new Date(parseInt(scope.start) * 1000).toISOString().substr(11, 8)
          scope.endInput = new Date(parseInt(scope.end) * 1000).toISOString().substr(11, 8)
          scope.touched = true;
          scope.clickedIn = true;
          scope.clickedOut = true;
        }
        scope.revto = function (seconds) {
          mediaElementPlayer.setCurrentTime(mediaElementPlayer.getCurrentTime() - seconds);
          mediaElementPlayer.play();

        }
        scope.revclickIn = function (seconds) {
          scope.start = scope.start - seconds;
          scope.startInput = new Date(parseInt(scope.start) * 1000).toISOString().substr(11, 8)
        }
        scope.forwardclickIn = function (seconds) {
          scope.start = scope.start + seconds;
          scope.startInput = new Date(parseInt(scope.start) * 1000).toISOString().substr(11, 8)
        }
        scope.revclickOut = function (seconds) {
          scope.end = scope.end - seconds;
          scope.endInput = new Date(parseInt(scope.end) * 1000).toISOString().substr(11, 8)
        }
        scope.forwardclickOut = function (seconds) {
          scope.end = scope.end + seconds;
          scope.endInput = new Date(parseInt(scope.end) * 1000).toISOString().substr(11, 8)
        }
        scope.isDisabledCreate = function () {
          const duration = scope.end - scope.start;
          return duration > 300;
        }
        scope.clickIn = function () {
          scope.end = mediaElementPlayer.getDuration();
          scope.start = mediaElementPlayer.getCurrentTime();
          scope.startInput = new Date(parseInt(scope.start) * 1000).toISOString().substr(11, 8)
          scope.clickedIn = true;
        }
        scope.clickOut = function () {
          scope.end = mediaElementPlayer.getCurrentTime();
          scope.endInput = new Date(parseInt(scope.end) * 1000).toISOString().substr(11, 8)
          scope.clickedOut = true;
          scope.touched = true;
        }
        scope.playClip = function () {
          scope.playingclip = true;
          mediaElementPlayer.setCurrentTime(scope.start);
          mediaElementPlayer.play();
        }
        scope.toggleZoom = function () {
          if (!scope.zoom) {
            scope.originalStart = scope.start;
            scope.originalEnd = scope.end;
            scope.startZoom = offset;
            scope.endZoom = scope.end - scope.start + offset;
          }
          scope.zoom = !scope.zoom;
        }
        scope.getDuration = function () {
          return scope.originalEnd - scope.originalStart + offset * 2;
        }
        scope.gotoLive = function () {
          mediaElementPlayer.setCurrentTime(mediaElementPlayer.getDuration());
          scope.touched = true;
          // scope.start = 0;
          // scope.end = mediaElementPlayer.getDuration();
          // delete scope.startInput;
          // delete scope.endInput;
        }
        scope.$on('$destroy', function () {
          mediaElementPlayer.remove();
          var videos = document.getElementsByTagName('video');
          for (var i = 0, total = videos.length; i < total; i++) {
            videos[i].parentNode.removeChild(videos[i]);
          }
        });
      },
      template: '<div class="wide relative" ng-class="{\'zoom\' : zoom}">' +
        '<video width="640" height="360" style="width:100%;height:100%;"  id="vp-m3u8" className="video-player mejs-ted" autoPlay preload="none"><source type="application/x-mpegURL" src="{{url}}"></video>' +
        '<div id="magnify-rail"  ng-class="{\'zoom\' : zoom}" class="mejs__time-rail"><span class="mejs__time-total mejs__time-slider" role="slider" tabindex="0" aria-label="Time Slider" aria-valuemin="0" aria-valuemax="5316.9780000000255" aria-valuenow="1501" aria-valuetext="25:01"><span class="mejs__time-buffering" style="display: none;"></span><span class="mejs__time-loaded" style="transform: scaleX(0.30725);"></span><span class="mejs__time-current" style="transform: scaleX(0.281837);"></span><span class="mejs__time-hovered no-hover" pos="135.75" style="left: 135px; transform: scaleX(0);"></span><span class="mejs__time-handle" style="transform: translateX(135px);"><span class="mejs__time-handle-content"></span></span><span class="mejs__time-float" style="display: none; left: 135.75px;"><span class="mejs__time-float-current">25:06</span><span class="mejs__time-float-corner"></span></span></span></div>' +
        '</div>' +
        '<div class="controls-custom p-10" layout="row" layout-align="end center" >' +
        ' <button class="white-fg md-button green-A700-bg  md-raised md-small layout-row layout-align-center-space-between" ng-click="revto(60)" ><md-icon  md-font-icon="icon-backup-restore" class="white-fg"></md-icon><span class="ml-5">1\'</span></button>' +
        ' <button class="white-fg md-button green-A700-bg  md-raised md-small layout-row layout-align-center-space-between" ng-click="revto(10)" ><md-icon  md-font-icon="icon-backup-restore" class="white-fg"></md-icon><span class="ml-5">10\'\'</span></button>' +
        ' <button class="md-button md-warn md-raised md-small mr-0" ng-click="gotoLive()"><strong class="font-size-20">Live</strong></button>' +
        '</div>' +
        '<div  layout="row" class="mb-20"  >' +
        '<span class="font-size-14" style="width:15%;" layout="row" layout-align="center center">{{start != undefined ? getFormatTime(start) : ""}}</span>' +
        '<div class="width-percent-100">' +
        '<slider ng-style="{\'height\' : zoom ? \'40px\' : \'0\', \'opacity\' : zoom ? \'1\' : \'0\'}" hide-pointer-labels="true"  floor="0" ceiling="{{ getDuration() }}" step="1" precision="10" show-handles="clickedIn" ng-model-low="startZoom" ng-model-high="endZoom" change="onTrimChange()"></slider>' +
        '<slider on-emit-go-to="gototag(start,end)" style="margin-top: -17px;" ng-style="{\'height\' : zoom ? \'0\' : \'40px\', \'opacity\' : zoom ? \'0\' : \'1\'}" show-handles="clickedIn" ng-model-tags="tags" hide-pointer-labels="true" floor="0" ceiling="{{ duration }}" step="1" precision="10" ng-model-low="start" ng-model-high="end" change="onTrimChange()"></slider>' +
        '</div>' +
        '<span class="font-size-14"  style="width:15%;" layout="row" layout-align="center center">{{end != undefined ? getFormatTime(end) : ""}}</span>' +
        '</div>' +
        '<div ng-if="trimToggle" layout="row" layout-align="space-between stretch" flex class=" ph-10 trim-container">' +
        '<div  layout="row" layout-align="start center" flex="50" flex-gt-md="33" class="in-combo">' +
        '<button ng-if="clickedIn" ng-click="revclickIn(1)" class="w-50 pl-0 pr-10 m-0 md-button md-accent layout-row layout-align-center-space-between ng-scope"><md-icon  md-font-icon="icon-backup-restore" class="s18"></md-icon><span>1\'\'</span></button>' +
        '<button class="md-button light-blue-800-bg md-raised md-small white-fg mh-0" ng-click="clickIn()" ><strong>IN</strong></button>' +
        '<button ng-if="clickedIn" ng-click="forwardclickIn(1)" class="w-50 pl-10 pr-0 m-0 md-button md-accent layout-row layout-align-center-space-between ng-scope"><span>1\'\'</span><md-icon style="transform: scaleX(-1);"  md-font-icon="icon-backup-restore" class="s18"></md-icon></button>' +
        '<md-input-container class="input-container">' +
        '<input pattern="[0-9]{2}:[0-9]{2}:[0-9]{2}" type="text" ng-model="startInput" placeholder="Inicio (hh:mm:ss)" />' +
        '</md-input-container>' +
        '</div>' +
        '<div ng-if="touched || clickedOut" layout="row" layout-align="center center" flex="100" flex-gt-md="33" class="trim-player" >' +
        '<button class="md-button md-accent  md-small m-0" ng-click="playClip()"><md-icon class="m-0 pointer" md-font-icon="icon-play"><span></span></md-icon></button>' +
        '<span class="font-size-14 mh-10">{{getFormatTime(end - start)}}</span>' +
        '<button class="md-button md-accent  md-small m-0" ng-click="toggleZoom()" ng-if="!zoom"><md-icon  class="m-0 pointer" md-font-icon="icon-magnify-plus"></md-icon></button>' +
        '<button class="md-button md-warn  md-small m-0" ng-click="toggleZoom()" ng-if="zoom"><md-icon  class="m-0 pointer" md-font-icon="icon-magnify-minus"></md-icon></button>' +
        '</div>' +
        '<div ng-if="clickedIn"  layout="row" layout-align="end center" flex="50" flex-gt-md="33" class="out-combo">' +
        '<md-input-container class="input-container">' +
        '<input pattern="[0-9]{2}:[0-9]{2}:[0-9]{2}" type="text" ng-model="endInput" placeholder="Fin (hh:mm:ss)" class="text-right"/>' +
        '</md-input-container>' +
        '<button ng-if="clickedOut" ng-click="revclickOut(1)"  class="w-50 pl-0 pr-10 m-0 md-button md-accent layout-row layout-align-center-space-between ng-scope"><md-icon  md-font-icon="icon-backup-restore" class="s18"></md-icon><span>1\'\'</span></button>' +
        '<button class="md-button light-blue-800-bg md-raised md-small white-fg mh-0" ng-click="clickOut()" ><strong>OUT</span></strong>' +
        '<button ng-if="clickedOut" ng-click="forwardclickOut(1)"  class="w-50 pr-0 pl-10 m-0 md-button md-accent layout-row layout-align-center-space-between ng-scope"><span>1\'\'</span><md-icon style="transform: scaleX(-1);"  md-font-icon="icon-backup-restore" class="s18"></md-icon></button>' +
        '</div>' +
        '</div>' +
        '<div layout="row" layout-align="space-between center" class="pv-5 mt-10"  >' +
        '<div layout="row" layout-align="start center"  >' +
        '<button  class="md-button md-accent md-raised md-small " ng-click="trimToggle = !trimToggle;" layout="row" layout-align="center space-between"><md-icon  md-font-icon="icon-code-braces" class="mr-5 white-fg s18"></md-icon><strong class="font-size-12">Trim</strong></button>' +
        '</div>' +
        '<div layout="row" layout-align="end center"  >' +
        '<md-button ng-disabled="isDisabledCreate()"  hide show-gt-sm type="submit" ng-click="onTitleWindow($event,false)" class="md-raised orange-bg white-fg md-button"  layout="row" layout-align="center space-between"><md-icon  md-font-icon="icon-square-inc" class="mr-5 white-fg s18"></md-icon><strong class="font-size-12" translate="MATCH_CENTER.CREATE_MARK"></strong></md-button>' +
        '<md-button ng-disabled="isDisabledCreate()"  hide show-gt-sm type="submit" ng-click="onTitleWindow($event,true)" class="md-raised md-warn md-button"  layout="row" layout-align="center space-between"><md-icon  md-font-icon="icon-movie" class="mr-5 white-fg s18"></md-icon><strong class="font-size-12" translate="MATCH_CENTER.CREATE_CLIP"></strong></md-button>' +
        '</div>' +
        '</div>'
    };
  }

})();


(function () {
    'use strict';

    angular
        .module('app.maps', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {

        $stateProvider.state('app.site_overview.maps', {
            abstract: true,
            url: '/maps'
        });

        // Tab "Maps" -> tabs.action = 'list'
        $stateProvider.state('app.site_overview.maps.list', {
            url: '/list',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/maps/maps.html',
                    controller: 'MapsController as vm'
                }
            },
            bodyClass: 'maps'
        });

        $translatePartialLoaderProvider.addPart('app/main/apps/maps');
    }
})();

(function () {
    'use strict';

    angular
        .module('app.maps')
        .controller('MapsStyleEditorController', MapsStyleEditorController);

    /**
     * Editor de estilos de OpenFreeMap (MapLibre) en un modal:
     *  - Biblioteca reutilizable (lista + nuevo + guardar + borrar) via mapsStyleService.
     *  - Editor por capas: cada capa con color + visibilidad, agrupadas.
     *  - Preview EN VIVO: los cambios se aplican al mapa al instante con
     *    setPaintProperty / setLayoutProperty (sin recargar el estilo).
     * Un estilo se guarda como { base, overrides }.
     *
     * @ngInject
     */
    function MapsStyleEditorController($scope, $q, $timeout, $translate, $mdDialog,
                                       $mdToast, mapboxLoader, mapsStyleService,
                                       siteId, mapView, mapFeatures) {
        var dlg = this;
        var maplibre = null;    // objeto GL (MapLibre)
        var previewMap = null;  // mapa de preview

        // Orden "friendly" de los grupos de capas
        var GROUP_ORDER = ['background', 'land', 'water', 'roads', 'buildings', 'labels', 'raster', 'other'];

        dlg.siteId = siteId;
        dlg.styles = [];        // biblioteca
        dlg.current = null;     // estilo en edicion {id,title,base,overrides}
        dlg.groups = [];        // grupos presentes (ordenados)
        dlg.byGroup = {};       // grupo -> [capas]
        dlg.bases = [
            {id: 'https://tiles.openfreemap.org/styles/liberty',  name: 'MAPS.OFM_LIBERTY'},
            {id: 'https://tiles.openfreemap.org/styles/bright',   name: 'MAPS.OFM_BRIGHT'},
            {id: 'https://tiles.openfreemap.org/styles/positron', name: 'MAPS.OFM_POSITRON'}
        ];
        dlg.groupLabels = {
            background: 'MAPS.STYLE_GROUP_BACKGROUND', land: 'MAPS.STYLE_GROUP_LAND',
            water: 'MAPS.STYLE_GROUP_WATER', roads: 'MAPS.STYLE_GROUP_ROADS',
            buildings: 'MAPS.STYLE_GROUP_BUILDINGS', labels: 'MAPS.STYLE_GROUP_LABELS',
            raster: 'MAPS.STYLE_GROUP_RASTER', other: 'MAPS.STYLE_GROUP_OTHER'
        };
        dlg.loading = true;
        dlg.saving = false;

        dlg.newStyle = newStyle;
        dlg.selectStyle = selectStyle;
        dlg.setBase = setBase;
        dlg.onColor = onColor;
        dlg.onVisibility = onVisibility;
        dlg.save = save;
        dlg.remove = remove;
        dlg.close = close;

        init();

        function init() {
            // Cargar MapLibre + la biblioteca en paralelo (la biblioteca puede fallar
            // si el endpoint aun no sirve la seccion: no bloquea el editor/preview).
            $q.all([
                mapboxLoader.load(),
                mapsStyleService.getStyles(siteId).then(function (l) { return l; }, function () { return []; })
            ]).then(function (res) {
                maplibre = res[0];
                dlg.styles = res[1] || [];
                dlg.loading = false;
                newStyle();      // arranca con un estilo nuevo
                createPreview();
            }, function () {
                dlg.loading = false;
            });
        }

        // ---- Biblioteca ----

        function newStyle() {
            dlg.current = mapsStyleService.newStyle(
                $translate.instant('MAPS.STYLE_NEW_NAME'), mapsStyleService.DEFAULT_BASE);
            applyCurrent();
        }

        function selectStyle(s) {
            dlg.current = {
                id: s.id,
                title: s.title,
                base: s.base || mapsStyleService.DEFAULT_BASE,
                overrides: angular.copy(s.overrides || {})
            };
            applyCurrent();
        }

        function setBase(base) {
            dlg.current.base = base;
            applyCurrent();
        }

        function save() {
            if (!dlg.current.title) {
                toast($translate.instant('MAPS.STYLE_NAME_REQUIRED'));
                return;
            }
            dlg.saving = true;
            mapsStyleService.saveStyle(dlg.siteId, dlg.current).then(function (res) {
                dlg.saving = false;
                dlg.current.id = res.id || dlg.current.id;
                refreshLibrary();
                toast($translate.instant('MAPS.STYLE_SAVED'));
            }, function () {
                dlg.saving = false;
                toast($translate.instant('MAPS.STYLE_SAVE_ERROR'));
            });
        }

        function remove() {
            if (!dlg.current.id) {
                newStyle();
                return;
            }
            mapsStyleService.deleteStyle(dlg.siteId, dlg.current.id).then(function () {
                refreshLibrary();
                newStyle();
            });
        }

        function refreshLibrary() {
            mapsStyleService.getStyles(dlg.siteId).then(function (list) {
                dlg.styles = list;
            }, angular.noop);
        }

        // ---- Preview + capas ----

        // Crea el mapa de preview. Reintenta si el contenedor del modal aun no esta
        // en el DOM (md-dialog anima al entrar). Los overrides se aplican en style.load.
        function createPreview(attempt) {
            attempt = attempt || 0;
            $timeout(function () {
                if (!maplibre || previewMap) {
                    return;
                }
                var el = document.getElementById('maps-style-preview');
                if (!el) {
                    if (attempt < 15) { createPreview(attempt + 1); }
                    return;
                }
                var v = mapView || {};
                previewMap = new maplibre.Map({
                    container: el,
                    style: dlg.current.base,
                    center: v.center || [2.1734, 41.3851],
                    zoom: angular.isNumber(v.zoom) ? v.zoom : 11,
                    pitch: angular.isNumber(v.pitch) ? v.pitch : 0,
                    bearing: angular.isNumber(v.bearing) ? v.bearing : 0
                });
                previewMap.addControl(new maplibre.NavigationControl({visualizePitch: true}), 'top-right');
                // Al cargar un estilo (inicial o setStyle): re-pintamos las zonas/volumenes
                // del mapa y re-aplicamos overrides (setStyle borra fuentes/capas propias).
                previewMap.on('style.load', onPreviewStyleLoad);
            }, 120);
        }

        // Carga las capas del base (via $http, INDEPENDIENTE del mapa: el panel se
        // puebla aunque el preview tarde/falle) y cambia el estilo base del preview.
        function applyCurrent() {
            if (!dlg.current) { return; }
            mapsStyleService.loadStyle(dlg.current.base).then(function (baseJson) {
                var list = mapsStyleService.describeLayers(baseJson);
                var ov = dlg.current.overrides || {};
                list.forEach(function (l) {
                    var o = ov[l.id];
                    if (o) {
                        if (o.color) { l.color = o.color; }
                        if (o.visibility) { l.visibility = o.visibility; }
                    }
                    l.visible = l.visibility !== 'none';
                });
                dlg.allLayers = list;
                dlg.byGroup = groupBy(list);
                dlg.groups = GROUP_ORDER.filter(function (g) { return dlg.byGroup[g]; });
                // El mapa carga el base PLANO; los overrides se aplican en style.load.
                if (previewMap) {
                    previewMap.setStyle(dlg.current.base, {diff: false});
                }
            }, angular.noop);
        }

        // Tras cargar un estilo: re-pintar zonas/volumenes + re-aplicar overrides.
        function onPreviewStyleLoad() {
            addFeatureLayers();
            applyOverridesToMap();
        }

        // Re-aplica todos los overrides al preview (tras cargar un estilo).
        function applyOverridesToMap() {
            if (!previewMap || !dlg.allLayers || !dlg.current) { return; }
            var ov = dlg.current.overrides || {};
            dlg.allLayers.forEach(function (l) {
                if (ov[l.id]) { applyToMap(l, ov[l.id]); }
            });
        }

        // Pinta las zonas/volumenes 3D del mapa real en el preview (mismas capas que
        // el editor: relleno, contorno y extrusion 3D). setStyle las borra -> re-add.
        function addFeatureLayers() {
            if (!previewMap || !mapFeatures) { return; }
            var polys = ((mapFeatures.features) || []).filter(function (f) {
                // MultiPolygon incluido: una zona de varias formas se pinta igual en el
                // preview que en el editor, o el estilo se juzgaria sobre un mapa a medias.
                return f.geometry
                    && (f.geometry.type === 'Polygon' || f.geometry.type === 'MultiPolygon');
            });
            if (!polys.length) { return; }
            var fc = {
                type: 'FeatureCollection',
                features: polys.map(function (f) {
                    return {
                        type: 'Feature', id: f.id, geometry: f.geometry,
                        properties: {
                            color: (f.properties && f.properties.color) || '#2F6FE6',
                            height: (f.properties && f.properties.height) || 0
                        }
                    };
                })
            };
            if (previewMap.getSource('preview-zones')) {
                previewMap.getSource('preview-zones').setData(fc);
                return;
            }
            previewMap.addSource('preview-zones', {type: 'geojson', data: fc});
            previewMap.addLayer({
                id: 'preview-zones-fill', type: 'fill', source: 'preview-zones',
                paint: {'fill-color': ['get', 'color'], 'fill-opacity': 0.35}
            });
            previewMap.addLayer({
                id: 'preview-zones-line', type: 'line', source: 'preview-zones',
                paint: {'line-color': ['get', 'color'], 'line-width': 2}
            });
            previewMap.addLayer({
                id: 'preview-zones-3d', type: 'fill-extrusion', source: 'preview-zones',
                filter: ['>', ['get', 'height'], 0],
                paint: {
                    'fill-extrusion-color': ['get', 'color'],
                    'fill-extrusion-height': ['get', 'height'],
                    'fill-extrusion-base': 0,
                    'fill-extrusion-opacity': 0.9
                }
            });
        }

        function groupBy(list) {
            var by = {};
            list.forEach(function (l) {
                (by[l.group] = by[l.group] || []).push(l);
            });
            return by;
        }

        function onColor(layer) {
            if (!layer.color) { return; }
            setOverride(layer.id, 'color', layer.color);
            if (previewMap && layer.colorProp) {
                try { previewMap.setPaintProperty(layer.id, layer.colorProp, layer.color); } catch (e) {}
            }
        }

        function onVisibility(layer) {
            var vis = layer.visible ? 'visible' : 'none';
            layer.visibility = vis;
            setOverride(layer.id, 'visibility', vis);
            if (previewMap) {
                try { previewMap.setLayoutProperty(layer.id, 'visibility', vis); } catch (e) {}
            }
        }

        function setOverride(id, key, value) {
            dlg.current.overrides[id] = dlg.current.overrides[id] || {};
            dlg.current.overrides[id][key] = value;
        }

        function applyToMap(layer, o) {
            if (!previewMap) { return; }
            try {
                if (o.color && layer.colorProp) {
                    previewMap.setPaintProperty(layer.id, layer.colorProp, o.color);
                }
                if (o.visibility) {
                    previewMap.setLayoutProperty(layer.id, 'visibility', o.visibility);
                }
            } catch (e) {}
        }

        function close() {
            if (previewMap) {
                try { previewMap.remove(); } catch (e) {}
                previewMap = null;
            }
            $mdDialog.hide({styles: dlg.styles});
        }

        function toast(message) {
            $mdToast.show($mdToast.simple().textContent(message).position('top right').hideDelay(3000));
        }

        $scope.$on('$destroy', function () {
            if (previewMap) {
                try { previewMap.remove(); } catch (e) {}
                previewMap = null;
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.mailing')
        .factory("transformMailing", transformMailing);



    /** @ngInject */
    function transformMailing(mediaService, $filter, $translate, $mdDialog) {

        var service = {
            getUpdateItem: getUpdateItem,
            formatStructure: formatStructure,
            formatNestedGroups: formatNestedGroups,
            contentToDTO: contentToDTO,
            DTOsToTemplates: DTOsToTemplates,
            DTOToTemplate: DTOToTemplate,
            DTOsToContents: DTOsToContents,
            DTOToContent: DTOToContent,
            formatDuplicateTemplate: formatDuplicateTemplate,
            createNewEmptyTemplate: createNewEmptyTemplate,
            createNewEmptyCommunication: createNewEmptyCommunication,
            formatDuplicateCommunication: formatDuplicateCommunication,
            formatDuplicateContent: formatDuplicateContent,
            getMediaImage: getMediaImage,
            getImageById: getImageById,
            initImages: initImages,
            getGroupsFromLabels: getGroupsFromLabels,
            validateTemplateFields: validateTemplateFields,
            validateCommunicationFields: validateCommunicationFields
            //initGroups: initGroups

        };

        //function initGroups(content){}

        function initImages(content, siteID) {
            for (var i = 0; i < content.structure_data_json.length; i++) {
                if (content.structure_data_json[i].type === 'media') {
                    if (angular.isArray(content.structure_data_json[i].defaultValue)) {
                        for (var k = 0; k < content.structure_data_json[i].defaultValue.length; k++) {
                            getImageById(content.structure_data_json[i], content.structure_data_json[i].defaultValue[k], siteID);
                        }
                    }

                }
            }
        }

        function DTOToContent(content) {

            content.structure_data_json = JSON.parse(content.structure_data_json);
            content.users_groups_json = JSON.parse(content.users_groups_json);
            for (var i = 0; i < content.structure_data_json.length; i++) {
                if (content.structure_data_json[i].type === 'media') {
                    content.structure_data_json[i].mediaValue = [];
                    if (typeof (content.structure_data_json[i].value) === 'string') {
                        content.structure_data_json[i].defaultValue = JSON.parse(content.structure_data_json[i].value);
                        delete content.structure_data_json[i].value;
                    }
                }
            }

            return content;
        }

        function getImageById(array, id, siteID) {
            var options = {
                domain: siteID,
                id_media: id
            };
            mediaService.getImageByID(options)
                .then(function (response) {
                    array.mediaValue.push(response.data[0]);
                    delete array.Thumbnail;

                });
        }

        function DTOsToContents(contents) {
            for (var i = 0; i < contents.length; i++) {
                var content = contents[i];
                content = DTOToContent(content);
            }
            return contents;
        }

        function createNewEmptyTemplate() {
            var newTemplate = {
                id_mailing_domain: 1,
                from_email: '',
                from_name: '',
                lang: null,
                rawHtmlOnly: true,
                structure_data_json: [],
                default_users_groups_json: [],
                structure_mjml: {
                    header: {},
                    footer: {}
                },
                test_emails_json: [],
                subscription_group: ''
            }
            return newTemplate;
        }

        function createNewEmptyCommunication() {
            var newTemplate = {
                id_mailing_domain: 1,
                name: '',
                from_email: '',
                from_name: '',
                subject: '',
                structure_mjml: {},
                to_emails_json: []
            }
            return newTemplate;
        }

        function formatDuplicateCommunication(content) {
            var contentToCopy = angular.copy(content);
            var newContent = {
                id_mailing_communications: '',
                id_mailing_domain: contentToCopy.id_mailing_domain,
                name: contentToCopy.name + ' Copy',
                from_email: contentToCopy.from_email,
                from_name: contentToCopy.from_name,
                subject: contentToCopy.subject,
                structure_mjml: angular.fromJson(contentToCopy.structure_mjml),
                to_emails_json: angular.fromJson(contentToCopy.to_emails_json)
            }
            return newContent;
        }

        function formatDuplicateContent(content) {
            var contentToCopy = angular.copy(content);
            var newContent = {
                id_mailing_content: '',
                subject: contentToCopy.subject + ' Copy',
                id_mailing_template: contentToCopy.id_mailing_template,
                structure_mjml: angular.fromJson(contentToCopy.structure_mjml),
                test_emails_json: angular.fromJson(contentToCopy.test_emails_json)
            }
            return newContent;
        }

        function formatDuplicateTemplate(templateToCopy) {
            var newTemplate = createNewEmptyTemplate();
            newTemplate.id_mailing_domain = templateToCopy.id_mailing_domain;
            newTemplate.name = templateToCopy.name + ' Copy';
            newTemplate.from_email = templateToCopy.from_email;
            newTemplate.from_name = templateToCopy.from_name;
            newTemplate.lang = templateToCopy.lang;
            newTemplate.id = 'new';
            newTemplate.structure_mjml = angular.copy(JSON.parse(templateToCopy.structure_mjml));
            newTemplate.subscription_group = templateToCopy.subscription_group;
            return newTemplate;
        }

        function DTOToTemplate(template) {
            template.structure_data_json = JSON.parse(template.structure_json);
            delete template.structure_json;
            template.id_mailing_template = template.id_mailing_templates;
            delete template.id_mailing_templates;
            template.default_users_groups_json = JSON.parse(template.default_users_groups_json);
            return template;
        }

        function DTOsToTemplates(templates) {
            for (var i = 0; i < templates.length; i++) {
                var template = templates[i];
                template = DTOToTemplate(template);
            }
            return templates;
        }

        function contentToDTO(content) {
            var fields = angular.copy(content.structure_data_json);
            if (content.default_users_groups_json) {
                content.users_groups_json = content.default_users_groups_json;
                delete content.default_users_groups_json;
            } else {
                content.users_groups_json = content.users_groups_json;
            }
            content.structure_data_json = [];

            for (var i = 0; i < fields.length; i++) {
                if (fields[i].type !== 'media_header' && fields[i].type !== 'media_footer') {
                    var object = {
                        id: fields[i].id,
                        type: fields[i].type
                    };

                    if (fields[i].allowMultipleSelections) {
                        object['values'] = [];
                    } else {
                        if (fields[i].defaultValue) {
                            object['value'] = fields[i].defaultValue;
                        } else {
                            object['value'] = 'No default value';
                        }
                    }
                    if (fields[i].availableCssClasses) {
                        object['availableCssClasses'] = [];
                        for (var k = 0; k < fields[i].availableCssClasses.length; k++) {
                            object['availableCssClasses'].push(fields[i].availableCssClasses[k]);
                        }
                    }

                    if (fields[i].type === 'media') {
                        object.value = JSON.stringify(object.value);
                    }


                    if (fields[i].groups) {
                        var d = new Date();
                        var n = d.getTime();
                        for (var k = 0; k < fields[i].groups.length; k++) {
                            var group = {};
                            group.id = object.id;
                            group.type = object.type;
                            group.items = [];
                            for (var j = 0; j < fields[i].groups[k].length; j++) {

                                var subGroup = fields[i].groups[k][j];
                                if (!subGroup.id.match(/[_]/i)) {
                                    subGroup.id = subGroup.id + '_' + (n + k);
                                }
                                delete subGroup.multiLine;
                                delete subGroup.label;
                                if (subGroup.type === 'checkbox') {
                                    if (subGroup.checked === true || subGroup.checked === false) {
                                        subGroup.value = angular.copy(subGroup.checked);
                                        delete subGroup.checked;
                                    } else {
                                        subGroup.value = false;
                                    }
                                }
                                else {
                                    var value = angular.copy(subGroup.defaultValue);
                                    if (value) {
                                        subGroup.value = value;
                                    } else {
                                        subGroup.value = 'No default value';
                                    }
                                }
                                delete subGroup.defaultValue;
                                group.items.push(subGroup);
                            }
                            content.structure_data_json.push(group);
                        }
                    } else {
                        if (!fields[i].items) {
                            content.structure_data_json.push(object);
                        }
                    }
                }
            }

            if (!content.users_groups_json) {
                content.users_groups_json = [];
            }
            return content;
        }

        //templatetodto???
        function getUpdateItem(item) {
            item.rawHtmlOnly = JSON.parse(item.rawHtmlOnly);
            item.default_users_groups_json = item.default_users_groups_json;
            item.structure_json = formatStructure(item.structure_data_json);
            delete item.structure_data_json;
            return item;
        }

        function formatNestedGroups(groups) {
            if (groups) {
              angular.forEach(groups, function(g) {
                g.children = $filter('filter')(groups, {parent: g.id_group}, true);
              })
            } else {
                return [];
            }
            return groups;
        }

        function formatStructure(array) {
            for (var i = 0; i < array.length; i++) {
                var element = array[i];

                if (element.type !== 'datePicker') {
                    delete element.backendFormat;
                    delete element.frontendFormat;
                }
                if (element.type !== 'textBox') {
                    delete element.multiLine;
                    delete element.availableCssClasses;
                }
                if (element.type == 'textBox') {
                    element.availableCssClasses = [];
                }
                if (element.type !== 'group') {
                    delete element.items;
                }
                if (element.type == 'datePicker') {
                    delete element.defaultValue;
                    element.frontendFormat = "dddd, mmmm dS, yyyy, h:MM:ss TT";
                    element.backendFormat = "Y-m-d H:i:s";
                }

                if (element.type == 'group') {
                    if (element.items) {
                        formatStructure(element.items);
                    }
                }
                if (element.temporary) {
                    array.splice(i, 1);
                    i--;
                }
                delete element.temporary;
                delete element.editing;
            }
            return array;
        }

        function getMediaImage(template, siteId) {
            template.header_thumbnails = [];
            template.footer_thumbnails = [];

            for (var i = 0; i < template.structure_data_json.length; i++) {
                if (template.structure_data_json[i].type === 'media_header') {
                    for (var k = 0; k < template.structure_data_json[i].id_media.length; k++) {
                        template.header_thumbnails.push({ id_media: template.structure_data_json[i].id_media[k] })
                    }
                } else if (template.structure_data_json[i].type === 'media_footer') {
                    for (var k = 0; k < template.structure_data_json[i].id_media.length; k++) {
                        template.footer_thumbnails.push({ id_media: template.structure_data_json[i].id_media[k] })
                    }
                }
            }

            getImageResources(template, siteId);
        }

        function getImageResources(template, siteId) {
            for (var i = 0; i < template.footer_thumbnails.length; i++) {
                getMediaImageById(template.footer_thumbnails, i, siteId)
            }
            for (var j = 0; j < template.header_thumbnails.length; j++) {
                getMediaImageById(template.header_thumbnails, j, siteId)
            }
        }

        function getMediaImageById(arrayImages, position, siteId) {
            var arrayOptions = {
                domain: siteId,
                id_media: arrayImages[position].id_media //TODO
            };
            mediaService.getImageByID(arrayOptions)
                .then(function (response) {
                    arrayImages[position] = response.data[0];
                });
        }

        function getGroupsFromLabels(array) {
            var ids = [];
            for (var i = 0; i < array.length; i++) {
                ids.push(array[i].id);
            }
            return ids;
        }

        function validateTemplateFields(item) {
          item.default_users_groups_json = angular.fromJson(item.default_users_groups_json) ? angular.fromJson(item.default_users_groups_json) : [];
          item.test_emails_json = angular.fromJson(item.test_emails_json) ? angular.fromJson(item.test_emails_json) : [];
          try {
            item.structure_mjml = angular.fromJson(item.structure_mjml);
          } catch (e) {
            item.structure_mjml = {};
            if(item.structure_mjml_temp){
                var message = $translate.instant('MAILING.MJML_PROBLEM');
                var confirm = $mdDialog.confirm()
                  .title(message)
                  .ariaLabel('Change email')
                  .ok('ACCEPT')
                  .cancel('CANCEL');
                $mdDialog.show(confirm).then(function () {
                  item.structure_mjml = angular.fromJson(item.structure_mjml_temp);
                });
            }
          }
          item.from_email_nodomain = '';
          var fromEmailExp = item.from_email.split('@');
          if (fromEmailExp.length == 2) {
            item.from_email_nodomain = fromEmailExp[0];
          }
          item.structure_mjml = angular.fromJson(item.structure_mjml) ? angular.fromJson(item.structure_mjml) : [];
          return item;
        }

        function validateCommunicationFields(item) {
          item.to_emails_json = angular.fromJson(item.to_emails_json) ? angular.fromJson(item.to_emails_json) : [];
          item.structure_mjml = angular.fromJson(item.structure_mjml) ? angular.fromJson(item.structure_mjml) : [];
          return item;
        }

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('app.mailing')
        .factory("sharedFunctionsMailing", sharedFunctionsMailing);


    function sharedFunctionsMailing(transformMailing) {

        var service = {
            selectThreads: selectThreads,
            deselectThreads: deselectThreads,
            toggleSelectThreads: toggleSelectThreads,
            toggleSelectThread: toggleSelectThread,
            isSelected: isSelected,
            updateChildren: updateChildren,
            updateUsersGroups: updateUsersGroups,
            initChildrenUsers: initChildrenUsers,
            initUsersGroup: initUsersGroup,
            getLabels: getLabels,
            getLabelsChildren: getLabelsChildren,
            safeFromJson: safeFromJson

        };

        /**
         * Parsea JSON sin lanzar. Un valor corrupto en un campo secundario (p. ej.
         * test_emails_json truncado en BD) no debe abortar la carga del content y
         * dejar el editor de diseño en blanco: devolvemos el valor por defecto.
         *
         * @param value        valor a parsear (string JSON u objeto ya parseado)
         * @param defaultValue valor a devolver si el parseo falla o queda vacío
         * @param fieldName    opcional, solo para trazar en consola qué campo falló
         */
        function safeFromJson(value, defaultValue, fieldName) {
            try {
                var parsed = angular.fromJson(value);
                return (parsed === null || angular.isUndefined(parsed)) ? defaultValue : parsed;
            } catch (e) {
                console.warn('[mailing] JSON inválido en "' + (fieldName || '?') + '", se usa el valor por defecto.', e.message);
                return defaultValue;
            }
        }

        function getLabels(usersGroups) {
            if (usersGroups) {
                var labelsArray = [];
                for (var i = 0; i < usersGroups.length; i++) {
                    if (usersGroups[i].selected === true) {
                        labelsArray.push({ label: usersGroups[i].label, id: usersGroups[i].id_group });
                    }
                    if (usersGroups[i].children) {
                        for (var k = 0; k < usersGroups[i].children.length; k++) {
                            getLabelsChildren(labelsArray, usersGroups[i].children[k]);
                        }
                    }
                }
                return labelsArray;
            }
        }

        function getLabelsChildren(labelsArray, child) {
            if (child.selected === true) {
                labelsArray.push({ label: child.label, id: child.id_group });
            }
            if (child.children) {
                for (var i = 0; i < child.children.length; i++) {
                    getLabelsChildren(labelsArray, child.children[i]);
                }
            }
        }


        function initChildrenUsers(arrayId, child) {
            for (var i = 0; i < arrayId.length; i++) {
                if (child.id_group === arrayId[i]) {
                    child.selected = true;
                    arrayId.splice(i, 1);
                }

                if (child.children && arrayId) {
                    for (var k = 0; k < child.children.length; k++) {
                        initChildrenUsers(arrayId, child.children[k]);
                    }
                }
            }
        }

        function initUsersGroup(usersGroups, arrayId) {
            if (usersGroups && arrayId) {
                usersGroups = transformMailing.formatNestedGroups(usersGroups);
                for (var i = 0; i < arrayId.length; i++) {
                    for (var k = 0; k < usersGroups.length; k++) {
                        if (usersGroups[k].id_group === arrayId[i]) {
                            usersGroups[k].selected = true;
                            arrayId.splice(i, 1);
                        }
                        if (usersGroups[k].children && arrayId) {
                            for (var c = 0; c < usersGroups[k].children.length; c++) {
                                initChildrenUsers(arrayId, usersGroups[k].children[c]);
                            }
                        }
                    }
                }
                return usersGroups;
            }
        }

        function updateChildren(array, child) {
            if (child.selected === true) {
                array.push(child.id_group);
            }
            if (child.children) {
                for (var i = 0; i < child.children.length; i++) {
                    updateChildren(array, child.children[i]);
                }
            }
        }

        function updateUsersGroups(usersGroups, node) {
            var arrayIds = [];
            for (var i = 0; i < usersGroups.length; i++) {
                if (usersGroups[i].selected === true) {
                    arrayIds.push(usersGroups[i].id_group);
                }
                if (usersGroups[i].children) {
                    for (var k = 0; k < usersGroups[i].children.length; k++) {
                        updateChildren(arrayIds, usersGroups[i].children[k]);
                    }
                }
            }
            return arrayIds;
        }


        function isSelected(threads, thread) {
            return threads.indexOf(thread) > -1;
        }

        function toggleSelectThread(threads, thread, event) {
            if (event) {
                event.stopPropagation();
            }

            if (threads.indexOf(thread) > -1) {
                threads.splice(threads.indexOf(thread), 1);
            } else {
                threads.push(thread);
            }

            return threads;
        }

        function toggleSelectThreads(selectedThreads, threads) {
            if (selectedThreads.length > 0) {
                selectedThreads = deselectThreads();
            } else {
                selectedThreads = selectThreads(threads, threads);
            }
            return selectedThreads;
        }

        function selectThreads(selectedThreads, contents, key, value) {
            // Make sure the current selection is cleared
            // before trying to select new threads
            selectedThreads = [];

            for (var i = 0; i < contents.length; i++) {
                if (angular.isUndefined(key) && angular.isUndefined(value)) {
                    selectedThreads.push(contents[i]);
                    continue;
                }

                if (angular.isDefined(key) && angular.isDefined(value) && contents[i][key] === value) {
                    selectedThreads.push(contents[i]);
                }
            }

            return selectedThreads;
        }

        function deselectThreads() {
            return [];
        }



        return service;
    }
})();
(function() {
    'use strict';

    angular
        .module('app.mailing')
        .factory("fieldsTemplateMailing", fieldsTemplateMailing);



    /** @ngInject */
    function fieldsTemplateMailing() {

        var service = {
            addNewStructureField: addNewStructureField,
            saveFieldStructure: saveFieldStructure,
            cancelEditFieldStructure: cancelEditFieldStructure,
            removeFieldStructure: removeFieldStructure,
            editFieldStructure: editFieldStructure,
            closeOthers: closeOthers
        };

        function addNewStructureField(array) {
            var d = new Date();
            var n = d.getTime();
            array.push({ type: "", id: n.toString(), label: "", temporary: true, editing: true });
        }

        function saveFieldStructure(index, array) {
            array[index].temporary = false;
            array[index].editing = false;
        }

        function cancelEditFieldStructure(index, array, copyStructure) {
            console.log(array);
            if (array[index].temporary) {
                array.splice(index, 1);
            } else {
                array[index] = copyStructure; //vm.copyStructure;
                array[index].editing = false;
            }
        }

        function removeFieldStructure(index, array, noexistchangues) {
            if (noexistchangues !== null)
                noexistchangues = false;
            array.splice(index, 1);
        }

        function editFieldStructure(index, array, copyStructure) {
            closeOthers();
            copyStructure = array[index];
            array[index].editing = true;
        }

        function closeOthers(array) {
            if (array) {
                for (var i = 0; i < array.length; i++) {
                    if (array[i].temporary) {
                        array.splice(i, 1);
                        i--;
                    } else {
                        saveFieldStructure(i, array);
                    }
                }
            }
        }

        return service;
    }
})();
(function() {
    'use strict';

    angular
        .module('app.mailing')
        .factory("contentFunctionsMailing", contentFunctionsMailing);


    function contentFunctionsMailing() {

        var service = {
            createOptionsContent: createOptionsContent,
            structureHasBody: structureHasBody

        };

        // ¿La estructura de un email tiene cuerpo (contenido real)?
        // Se usa como red de seguridad anti-vaciado: si al guardar un content
        // existente el cuerpo saliente está vacío, es que algo (típicamente un
        // desajuste con el template editado) lo dejó sin contenido; en ese caso
        // NO debe persistirse el vaciado. Ante la duda (JSON no parseable pero no
        // vacío) devolvemos true para no bloquear guardados legítimos.
        function structureHasBody(structure) {
            var s = structure;
            if (s === null || s === undefined) { return false; }
            if (typeof s === 'string') {
                var str = s.trim();
                if (!str || str === '{}' || str === '[]' || str === 'null') { return false; }
                try { s = JSON.parse(str); } catch (e) { return true; }
            }
            if (!s || typeof s !== 'object') { return false; }
            var len = function (x) { return (x && x.length) ? x.length : 0; };
            if (len(s.elements)) { return true; }
            if (len(s.rows)) { return true; }                 // canvas v3 (content-plus)
            if (typeof s.html === 'string' && s.html.trim().length > 20) { return true; }
            if (s.header && len(s.header.elements)) { return true; }
            if (s.footer && len(s.footer.elements)) { return true; }
            return false;
        }



        function createOptionsContent(currentContent, isUpdateContent, $scope, contentDuplicate) {
            var method;
            var newContent;
            if (contentDuplicate) {
                newContent = contentDuplicate;
                isUpdateContent = false;
            } else {
                newContent = currentContent;
            }
            var options = {
                site: $scope.siteID,
                section: $scope.section,
                id: '',
                item: newContent
            };
            if (isUpdateContent) {
                method = 'update';
            } else {
                method = 'new';
            }
            return { options: options, method: method };
        }

        return service;
    }
})();


(function () {
    'use strict';

    angular.module('app.users')
        .controller('pushNotificationsController', pushNotificationsController);

    /** @ngInject */
    function pushNotificationsController($scope, $rootScope, $document, $mdDialog, $mdMedia, $mdToast, 
                                    $mdSidenav, $state, msApi, requestContext, $timeout, 
                                    sharedFunctionsMailing, msUtils, $translate, sessionService, $stateParams) {
        
        var vm = this;
        
        //Functions
        vm.openContent = openContent;
        //Functions
        //Vars
        $scope.section = requestContext.getParam('section');
        $scope.siteID = requestContext.getParam('siteId');
        vm.contents = [];
        vm.defaultView = 'split';
        vm.currentView = 'split';
        vm.views = {
            nosplit: 'app/main/apps/mailing/views/content/list/nosplit-view.html',
            split: 'app/main/apps/mailing/views/content/list/split-view.html',
            grid: 'app/main/apps/mailing/views/content/grid/grid-view.html'
          };
        //Vars
        init();
        
        function init(){
            $rootScope.global.titleToolbar = '<i class="icon s20 icon-telegram mr-15" ng-if="node.icon"></i><span class="hide show-gt-xs">MAILING</span><i class="mr-5 ml-5 icon s18 icon-chevron-right hide show-gt-xs"></i> ';
            $scope.page = 1;
            // if ($state.params.id) {
            //   vm.openContent($state.params.id);
            // }
            sessionService.loadDomainResourceSettings($scope.siteID).then(function (response){
                if(response.public){
                    console.log('response.public', response.public);
                }
              });
        }

        function openContent(ID){
            console.log('ID', ID);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.forms', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {

        $stateProvider
            .state('app.site_overview.forms', {
                abstract: true,
                url: '/forms',
                onEnter: function ($stateParams) {


                },
                data: {
                    displayName: '{{section}}'
                },
                resolve: {
                    section: function ($stateParams) {
                        return $stateParams.section
                    },
                },


            })
            .state('app.site_overview.forms.list', {
                url: '',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/forms/forms.html',
                        controller: 'FormsController as vm'
                    }
                },
                onEnter: function () {
                },
                data: {
                    displayName: 'List {{section}}'
                },
                resolve: {
                    // Cards: function (msApi)
                    // {
                    //     return msApi.resolve('cards@get');
                    // }
                    section: function ($stateParams) {
                        return $stateParams.section
                    }
                },
            })
            .state('app.site_overview.forms.list.thread', {
                url: '/:id',
                bodyClass: 'forms'
            })

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/forms');

    }
})();

(function () {
    'use strict';

    angular
        .module('app.forms')
        .factory("transformForms", transformForms);



    /** @ngInject */
    function transformForms(mediaService) {

        var service = {
            getImageById: getImageById,
            userToDTO: userToDTO,
            DtoToUser: DtoToUser,
            formatNestedGroups: formatNestedGroups,
            initUsersGroup: initUsersGroup,
            getLabels: getLabels,
            getGroupsFromLabels: getGroupsFromLabels
        };

        function DtoToUser(user, siteID) {
            if (user.avatar)
                getImageById(user, siteID);
            var groups = [];
            for (var i = 0; i < user.groups.length; i++) {
                groups.push(user.groups[i].id_group);
            }
            user.groups = groups;
        }

        function userToDTO(user) {
            if (user.id_user !== '' && user.id_user !== undefined) {
                user.created_at = JSON.stringify(user.created_at);
                user.last_login = JSON.stringify(user.last_login);
                if (user.avatar)
                    user.avatar = user.avatar.id_media;
                return user;
            } else {
                if (user.avatar !== undefined) {
                    user.avatar = user.avatar.id_media;
                } else {
                    delete user.avatar;
                }
                return user;
            }
        }

        function getImageById(user, siteID) {
            var options = {
                domain: siteID,
                id_media: user.avatar
            };
            mediaService.getImageByID(options)
                .then(function (response) {
                    user.avatar = response.data[0];
                    console.log(user);
                });
        }

        function formatNestedGroups(groups) {
            if (groups) {
                for (var i = 0; i < groups.length; i++) {
                    var elementParent = groups[i];
                    elementParent.label = elementParent.name
                    if (elementParent.children) {
                        for (var j = 0; j < elementParent.children.length; j++) {
                            var elementChild = elementParent.children[j];
                            elementChild.label = elementChild.name;
                            if (elementChild.children) {
                                for (var k = 0; k < elementChild.children.length; k++) {
                                    var elementSecondChild = elementChild.children[k];
                                    elementSecondChild.label = elementSecondChild.name;
                                }
                            }
                        }
                    }
                }
            } else {
                return [];
            }
            return groups;
        }

        function initUsersGroup(usersGroups, arrayId) {
            if (usersGroups && arrayId) {
                usersGroups = formatNestedGroups(usersGroups);
                for (var i = 0; i < arrayId.length; i++) {
                    for (var k = 0; k < usersGroups.length; k++) {
                        if (usersGroups[k].id_group === arrayId[i]) {
                            usersGroups[k].selected = true;
                            arrayId.splice(i, 1);
                        }
                        if (usersGroups[k].children && arrayId) {
                            for (var c = 0; c < usersGroups[k].children.length; c++) {
                                initChildrenUsers(arrayId, usersGroups[k].children[c]);
                            }
                        }
                    }
                }
                return usersGroups;
            }
        }

        function initChildrenUsers(arrayId, child) {
            for (var i = 0; i < arrayId.length; i++) {
                if (child.id_group === arrayId[i]) {
                    child.selected = true;
                    arrayId.splice(i, 1);
                }

                if (child.children && arrayId) {
                    for (var k = 0; k < child.children.length; k++) {
                        initChildrenUsers(arrayId, child.children[k]);
                    }
                }
            }
        }

        function getLabels(usersGroups) {
            if (usersGroups) {
                var labelsArray = [];
                for (var i = 0; i < usersGroups.length; i++) {
                    if (usersGroups[i].selected === true) {
                        labelsArray.push({ label: usersGroups[i].label, id: usersGroups[i].id_group });
                    }
                    if (usersGroups[i].children) {
                        for (var k = 0; k < usersGroups[i].children.length; k++) {
                            getLabelsChildren(labelsArray, usersGroups[i].children[k]);
                        }
                    }
                }
                return labelsArray;
            }
        }

        function getLabelsChildren(labelsArray, child) {
            if (child.selected === true) {
                labelsArray.push({ label: child.label, id: child.id_group });
            }
            if (child.children) {
                for (var i = 0; i < child.children.length; i++) {
                    getLabelsChildren(labelsArray, child.children[i]);
                }
            }
        }

        function getGroupsFromLabels(array) {
            var ids = [];
            for (var i = 0; i < array.length; i++) {
                ids.push(array[i].id);
            }
            return ids;
        }

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('app.forms')
        .factory("sharedFunctionsForms", sharedFunctionsForms);


    function sharedFunctionsForms() {

        var service = {
            selectThreads: selectThreads,
            deselectThreads: deselectThreads,
            toggleSelectThreads: toggleSelectThreads,
            toggleSelectThread: toggleSelectThread,
            isSelected: isSelected,
            updateChildren: updateChildren,
            updateUsersGroups: updateUsersGroups,
            initChildrenUsers: initChildrenUsers,
            initUsersGroup: initUsersGroup,
            getLabels: getLabels,
            getLabelsChildren: getLabelsChildren

        };

        function getLabels(usersGroups) {
            if (usersGroups) {
                var labelsArray = [];
                for (var i = 0; i < usersGroups.length; i++) {
                    if (usersGroups[i].selected === true) {
                        labelsArray.push({ label: usersGroups[i].label, id: usersGroups[i].id_group });
                    }
                    if (usersGroups[i].children) {
                        for (var k = 0; k < usersGroups[i].children.length; k++) {
                            getLabelsChildren(labelsArray, usersGroups[i].children[k]);
                        }
                    }
                }
                return labelsArray;
            }
        }

        function getLabelsChildren(labelsArray, child) {
            if (child.selected === true) {
                labelsArray.push({ label: child.label, id: child.id_group });
            }
            if (child.children) {
                for (var i = 0; i < child.children.length; i++) {
                    getLabelsChildren(labelsArray, child.children[i]);
                }
            }
        }


        function initChildrenUsers(arrayId, child) {
            for (var i = 0; i < arrayId.length; i++) {
                if (child.id_group === arrayId[i]) {
                    child.selected = true;
                    arrayId.splice(i, 1);
                }

                if (child.children && arrayId) {
                    for (var k = 0; k < child.children.length; k++) {
                        initChildrenUsers(arrayId, child.children[k]);
                    }
                }
            }
        }

        function initUsersGroup(usersGroups, arrayId) {
            // if (usersGroups && arrayId) {
            //     usersGroups = transformMailing.formatNestedGroups(usersGroups);
            //     for (var i = 0; i < arrayId.length; i++) {
            //         for (var k = 0; k < usersGroups.length; k++) {
            //             if (usersGroups[k].id_group === arrayId[i]) {
            //                 usersGroups[k].selected = true;
            //                 arrayId.splice(i, 1);
            //             }
            //             if (usersGroups[k].children && arrayId) {
            //                 for (var c = 0; c < usersGroups[k].children.length; c++) {
            //                     initChildrenUsers(arrayId, usersGroups[k].children[c]);
            //                 }
            //             }
            //         }
            //     }
            //     return usersGroups;
            // }
        }

        function updateChildren(array, child) {
            if (child.selected === true) {
                array.push(child.id_group);
            }
            if (child.children) {
                for (var i = 0; i < child.children.length; i++) {
                    updateChildren(array, child.children[i]);
                }
            }
        }

        function updateUsersGroups(usersGroups, node) {
            var arrayIds = [];
            for (var i = 0; i < usersGroups.length; i++) {
                if (usersGroups[i].selected === true) {
                    arrayIds.push(usersGroups[i].id_group);
                }
                if (usersGroups[i].children) {
                    for (var k = 0; k < usersGroups[i].children.length; k++) {
                        updateChildren(arrayIds, usersGroups[i].children[k]);
                    }
                }
            }
            return arrayIds;
        }


        function isSelected(threads, thread) {
            return threads.indexOf(thread) > -1;
        }

        function toggleSelectThread(threads, thread, event) {
            if (event) {
                event.stopPropagation();
            }

            if (threads.indexOf(thread) > -1) {
                threads.splice(threads.indexOf(thread), 1);
            } else {
                threads.push(thread);
            }

            return threads;
        }

        function toggleSelectThreads(selectedThreads, threads) {
            if (selectedThreads.length > 0) {
                selectedThreads = deselectThreads();
            } else {
                selectedThreads = selectThreads(threads, threads);
            }
            return selectedThreads;
        }

        function selectThreads(selectedThreads, contents, key, value) {
            // Make sure the current selection is cleared
            // before trying to select new threads
            selectedThreads = [];

            for (var i = 0; i < contents.length; i++) {
                if (angular.isUndefined(key) && angular.isUndefined(value)) {
                    selectedThreads.push(contents[i]);
                    continue;
                }

                if (angular.isDefined(key) && angular.isDefined(value) && contents[i][key] === value) {
                    selectedThreads.push(contents[i]);
                }
            }

            return selectedThreads;
        }

        function deselectThreads() {
            return [];
        }



        return service;
    }
})();
(function () {
    'use strict';

    angular
        .module('app.forms')
        .factory("fieldsTemplateForms", fieldsTemplateForms);



    /** @ngInject */
    function fieldsTemplateForms(contentService) {
        var allCountries;
        var service = {
            addNewStructureField: addNewStructureField,
            saveFieldStructure: saveFieldStructure,
            toDTOStructureField: toDTOStructureField,
            tostructureFieldFromDTO: tostructureFieldFromDTO,
            cancelEditFieldStructure: cancelEditFieldStructure,
            removeFieldStructure: removeFieldStructure,
            formatUserGroups: formatUserGroups,
            findAndCheck: findAndCheck,
            editFieldStructure: editFieldStructure,
            closeOthers: closeOthers
        };
        getCountries();
        var timeOptions = []
        for (var i = 0; i < 23; i++) {
            var hour;
            if (i > 9) {
                hour = i;
            } else {
                hour = '0' + i;
            }
            timeOptions.push({ value: hour + ':00', name: hour + ':00' });
            timeOptions.push({ value: hour + ':05', name: hour + ':05' });
            timeOptions.push({ value: hour + ':10', name: hour + ':10' });
            timeOptions.push({ value: hour + ':15', name: hour + ':15' });
            timeOptions.push({ value: hour + ':20', name: hour + ':20' });
            timeOptions.push({ value: hour + ':25', name: hour + ':25' });
            timeOptions.push({ value: hour + ':30', name: hour + ':30' });
            timeOptions.push({ value: hour + ':35', name: hour + ':35' });
            timeOptions.push({ value: hour + ':40', name: hour + ':40' });
            timeOptions.push({ value: hour + ':45', name: hour + ':45' });
            timeOptions.push({ value: hour + ':50', name: hour + ':50' });
            timeOptions.push({ value: hour + ':55', name: hour + ':55' });
        }


        function getCountries() {
            if (angular.isUndefined(allCountries)) {
                allCountries = [];
                var options = {
                    paginate: 99999,
                };
                contentService.getCountries(options).then(function (response) {
                    if (response.total) {
                        angular.forEach(response.data, function (item) {
                            var resultData = {
                                value: item.id_country,
                                name: item.country
                            };
                            allCountries.push(resultData);
                        })
                    }
                })
            }

        }

        function addNewStructureField(array) {
            array.push({
                className: "",
                key: "",
                name: "",
                type: "",
                templateOptions: {
                    label: "",
                    tooltip: "",
                    type: null,
                    disabled: false,
                    errorField: "",
                    placeholder: "",
                    required: false,
                    value: false,
                    options: [],
                    refreshURL: '',
                    datepickerOptions: {},
                    showWeeks: false,
                },
                temporary: true,
                editing: true
            });
        }

        function saveFieldStructure(index, array) {
            array[index].temporary = false;
            array[index].editing = false;
        }

        function toDTOStructureField(array) {
            if (array) {
                for (var i = 0; i < array.length; i++) {
                    if (array[i].type === 'separator') {
                        array[i].name = array[i].className;
                        delete array[i].key;
                        delete array[i].validation;
                        delete array[i].validators;
                    } else {
                        array[i].key = array[i].className;
                        delete array[i].name;
                    }
                    if (array[i].type !== 'checkbox') {
                        delete array[i].templateOptions.value;
                    }
                    if (array[i].type == 'country') {
                        array[i].templateOptions.type = 'country';
                        array[i].templateOptions.options = allCountries; // countries
                        array[i].type = 'select';
                    }
                    if (array[i].type == 'input' && array[i].templateOptions.type == 'email') {
                        array[i].templateOptions.main_field = 1;
                    }
                    if (array[i].type == 'time') {
                        array[i].templateOptions.type = 'time';
                        array[i].templateOptions.options = timeOptions;
                        array[i].type = 'select';
                    }
                    if (array[i].type !== 'datepicker') {
                        delete array[i].templateOptions.datepickerOptions;
                        delete array[i].templateOptions.showWeeks;
                    }
                    if (array[i].type !== 'multiCheckbox' && array[i].type !== 'input') {
                        delete array[i].templateOptions.type;
                    }
                    if (array[i].type !== 'multiCheckbox' || array[i].templateOptions.type == 'default') {
                        delete array[i].templateOptions.groupType;
                        delete array[i].templateOptions.status;
                    }
                    if (array[i].type == 'multiCheckbox' && array[i].templateOptions.type == 'users_group') {
                        array[i].key = 'group_' + array[i].key;
                    }
                    if (array[i].type !== 'datepicker' && array[i].type !== 'select' && array[i].type !== 'select-search' && array[i].type !== 'single-suggest' && array[i].type !== 'multiCheckbox' && array[i].type !== 'radio' && array[i].type !== 'dropzone') {
                        delete array[i].templateOptions.options;
                    }
                    if (array[i].type !== 'single-suggest') {
                        delete array[i].templateOptions.funcQ;
                        delete array[i].templateOptions.funcHttp;
                        delete array[i].templateOptions.refreshURL;
                        delete array[i].templateOptions.refresh;
                        delete array[i].templateOptions.refreshDelay;
                        delete array[i].templateOptions.minimumInputLength;
                    } else {
                        array[i].templateOptions.refresh = "|| var promise; if (!param2) { promise = param1.funcQ.when({data: {results: []}}); } else { var params = {txt: param2, sensor: false}; var endpoint = " + array[i].templateOptions.refreshURL + "; promise = param1.funcHttp.get(endpoint, {params: params}); } return promise.then(function (response) { if (response.data.results.length == 1) { } param3.templateOptions.options = response.data.results; });"
                    }

                    delete array[i].editing;
                    delete array[i].temporary;
                }
            }
            return array;
        }

        function tostructureFieldFromDTO(array) {
            if (array) {
                for (var i = 0; i < array.length; i++) {
                    if (array[i].templateOptions.type == 'country') {
                        array[i].type = 'country';
                    }
                    if (array[i].templateOptions.type == 'time') {
                        array[i].type = 'time';
                    }
                }
            }
            return array;
        }

        function cancelEditFieldStructure(index, array, copyStructure) {
            if (array[index].temporary) {
                array.splice(index, 1);
            } else {
                array[index] = copyStructure; //var copyStructure;
                array[index].editing = false;
            }
        }

        function removeFieldStructure(index, array, noexistchangues) {
            if (noexistchangues !== null)
                noexistchangues = false;
            array.splice(index, 1);
        }

        function editFieldStructure(index, array, copyStructure) {
            closeOthers();
            copyStructure = array[index];
            array[index].editing = true;
        }
        function formatUserGroups(userGroups) {
            var result = [];
            for (var i = 0; i < userGroups.length; i++) {
                const element = userGroups[i];
                result = result.concat(getElementsUserGroup(element));
            }
            return result;
        }


        function getElementsUserGroup(userGroup) {
            var result = [];
            var hasChildBoolean = (userGroup.children && userGroup.children.length > 0) ? true : false
            if (userGroup.checked) {
              var resultObj = {
                value: userGroup.id_group.toString(),
                name: userGroup.name,
                disabled: userGroup.allow_users == 1 ? false : true,
                hasChild: hasChildBoolean ? 1 : 0
              }
              if (userGroup.parent) {
                resultObj.parent = userGroup.parent.toString();
              }
              result.push(resultObj);
            }
            if (hasChildBoolean) {
                for (var i = 0; i < userGroup.children.length; i++) {
                    const element = userGroup.children[i];
                    result = result.concat(getElementsUserGroup(element));
                }

            }
            return result;
        }

        function findAndCheck(array, arraySelected) {

            for (var i = 0; i < array.length; i++) {
                const element = array[i];
                if (arraySelected.indexOf(element.id_group) > -1) {
                    element.checked = true
                }
                if (element.children) {
                    array.children = findAndCheck(element.children, arraySelected);
                }
            }
            return array;
        }

        function closeOthers(array) {
            if (array) {
                for (var i = 0; i < array.length; i++) {
                    if (array[i].temporary) {
                        array.splice(i, 1);
                        i--;
                    } else {
                        saveFieldStructure(i, array);
                    }
                }
            }
        }

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.content')
        .directive('shareCardEditor', shareCardEditor);

    /**
     * Editor visual de un diseno de share-card. Se inyecta DENTRO del panel de
     * edicion generico (tab-edit.html) para la seccion share_card_designs,
     * sustituyendo los campos crudos y conservando el chrome de qiu (lista,
     * toolbar, GUARDAR/CANCELAR).
     *
     * Escribe sobre el MISMO objeto del registro (vm.currentThread_Edit) por las
     * claves = titleId del _ref (title/style/color/logo/background/is_default/
     * onoff/sort), asi el SAVE generico lo persiste por la content API. Los inputs
     * con ng-model ensucian vm.basicForm solos (estan en el DOM del form); para los
     * controles de click marcamos el form dirty a mano (require ^form) para habilitar
     * el boton SAVE. El preview replica el render de Mueva_OgCard (qiupreview).
     *
     * @ngInject
     */
    function shareCardEditor($mdDialog, sessionService, $http) {
        return {
            restrict: 'E',
            require: '?^form',
            scope: { record: '=', titleText: '&?' },
            templateUrl: 'app/main/apps/content/share-designs/share-card-editor.html',
            link: function (scope, element, attrs, formCtrl) {

                // readonly: solo preview (vista de lectura), sin controles ni mutar el registro
                scope.readonly = ('readonly' in attrs);
                // hide-name: oculta lo que solo aplica a la BIBLIOTECA de disenos (nombre del
                // diseno, activo, usar por defecto). Lo usa el editor embebido en el sitemap,
                // que reutiliza esta misma directiva sobre los campos SEO de esa pagina.
                scope.hideName = ('hideName' in attrs);
                // texto del titulo en el preview: el que pase el host (p.ej. el titulo de la
                // pagina en sitemap) o, si no, el nombre del diseno.
                scope.previewTitle = function () {
                    var t = scope.titleText ? scope.titleText() : '';
                    return t || (scope.record && scope.record.title) || '';
                };

                scope.palette = ['#3b7cb7', '#0049f9', '#e4032e', '#0d0f14', '#16a34a', '#7b3fe4', '#f5a623'];

                // Tipografía: fuentes .ttf del tenant, servidas por qiupreview (/card-fonts).
                // GLOBAL del domain: en la práctica la card usa la font del diseño DEFAULT.
                scope.cardFonts = [{ family: 'Verdana', url: '' }];

                // ---- carga de las fuentes en el navegador (FontFace) ----
                // Los .ttf del tenant mandan Access-Control-Allow-Origin:* -> se pueden cargar
                // cross-origin. Se precargan TODAS para poder pintar cada opcion del selector con
                // su propia tipografia; la elegida alimenta ademas el titulo del preview.
                var _urlFam = {};   // url -> family ya cargada y disponible en document.fonts
                var _tried  = {};   // url -> intento ya lanzado (no repetir)

                function ensureFont(f) {
                    if (!f || !f.url) { return; }
                    if (_tried[f.url]) { return; }
                    _tried[f.url] = true;
                    if (!window.FontFace || !document.fonts) { return; }
                    // familia unica en el documento: evita chocar con fuentes del propio qiusystem
                    var fam = 'qiucard-' + (f.family || 'font').replace(/[^a-z0-9]+/gi, '-');
                    try {
                        new FontFace(fam, 'url("' + f.url + '")').load().then(function (loaded) {
                            document.fonts.add(loaded);
                            _urlFam[f.url] = fam;
                            scope.$applyAsync();
                        }, function () { /* fuente no cargable: se queda con la del sistema */ });
                    } catch (e) { /* noop */ }
                }
                function loadAllFonts() {
                    for (var i = 0; i < scope.cardFonts.length; i++) { ensureFont(scope.cardFonts[i]); }
                }
                function familyStack(url) {
                    if (!url) { return 'Verdana, Geneva, sans-serif'; }
                    return _urlFam[url] ? ('"' + _urlFam[url] + '", Verdana, Arial, sans-serif') : '';
                }

                // estilo de cada opcion del selector: se ve como es cada tipografia
                scope.fontStyle = function (f) {
                    var st = familyStack(f && f.url);
                    return st ? { 'font-family': st } : {};
                };
                // titulo del preview con la fuente elegida
                scope.titleStyle = function () {
                    var st = familyStack(scope.record && scope.record.font);
                    return st ? { 'font-family': st } : {};
                };
                scope.$watch('record.font', function (u) {
                    if (!u || _urlFam[u]) { return; }
                    for (var i = 0; i < scope.cardFonts.length; i++) {
                        if (scope.cardFonts[i].url === u) { ensureFont(scope.cardFonts[i]); return; }
                    }
                });
                loadAllFonts();

                if (!scope.readonly) {
                    var pd = sessionService && sessionService.site_operative && sessionService.site_operative.previewDomain;
                    if (pd) {
                        var base = (/^https?:\/\//.test(pd) ? pd : 'https://' + pd).replace(/\/+$/, '');
                        // skipAuthorization: satellizer inyecta "Authorization: Bearer" en todo $http;
                        // esa cabecera fuerza un preflight CORS cross-origin que el endpoint público
                        // /card-fonts no necesita (y rompía la carga -> solo salía Verdana).
                        $http.get(base + '/card-fonts', { skipAuthorization: true }).then(function (r) {
                            if (r.data && angular.isArray(r.data.fonts) && r.data.fonts.length) {
                                scope.cardFonts = r.data.fonts;
                                loadAllFonts();   // precargar todas -> el selector las muestra con su tipografia
                            }
                        }, function () { /* fallback: solo Verdana */ });
                    }
                }

                // defaults al abrir un registro nuevo/vacio (sin ensuciar el form). Solo en edicion.
                function applyDefaults(rec) {
                    if (!rec) { return; }
                    if (rec.style !== 'fill' && rec.style !== 'image' && rec.style !== 'glow') { rec.style = 'glow'; }
                    if (!/^#?[0-9a-fA-F]{6}$/.test(rec.color || '')) { rec.color = scope.palette[1]; }
                    else if (rec.color.charAt(0) !== '#') { rec.color = '#' + rec.color; }
                    if (rec.onoff !== 0 && rec.onoff !== '0' && rec.onoff !== 1 && rec.onoff !== '1') { rec.onoff = 1; }
                    var vis = { show_logo: 1, show_title: 1, show_description: 0 };
                    angular.forEach(vis, function (def, k) {
                        if (rec[k] !== 0 && rec[k] !== '0' && rec[k] !== 1 && rec[k] !== '1') { rec[k] = def; }
                    });
                }
                if (!scope.readonly) {
                    scope.$watch('record', function (rec) { applyDefaults(rec); });
                }

                // visibilidad de cada pieza en el preview. Por defecto: logo y titulo si,
                // descripcion no (mismo criterio que qiupreview y que la BD).
                scope.show = function (k) {
                    var v = scope.record ? scope.record[k] : undefined;
                    if (v === 1 || v === '1' || v === true) { return true; }
                    if (v === 0 || v === '0' || v === false) { return false; }
                    return k !== 'show_description';
                };

                function markDirty() { if (formCtrl) { formCtrl.$setDirty(); } }
                scope.markDirty = markDirty;

                scope.setStyle = function (s) { scope.record.style = s; markDirty(); };
                scope.setColor = function (c) { scope.record.color = c; markDirty(); };

                // ---- media picker (logo / fondo) ----
                // Logo: original (pequeño, conserva transparencia).
                scope.selectLogo = function (ev) {
                    openMedia(ev).then(function (r) { var u = mediaUrl(r, false); if (u) { scope.record.logo = u; markDirty(); } });
                };
                // Fondo: preferimos un CROP ligero ~16:9 (la card es 1200x630) en vez del original.
                // Evita bajar imágenes pesadas (un original de MB / GIF de 21MB no pinta y satura).
                scope.selectBackground = function (ev) {
                    openMedia(ev).then(function (r) {
                        var u = mediaUrl(r, true);
                        if (u) { scope.record.background = u; scope.record.style = 'image'; markDirty(); }
                    });
                };
                scope.clearLogo       = function () { scope.record.logo = ''; markDirty(); };
                scope.clearBackground = function () { scope.record.background = ''; markDirty(); };

                function openMedia(ev) {
                    return $mdDialog.show({
                        controller: 'MediaDialogController', controllerAs: 'vm',
                        locals: {
                            autoUpload: '', currentThread: { Thumbnail: [] }, section: '', mediazone: false,
                            isTiny: false, maxAttach: 1,
                            // solo vista 1 (rejilla de media), como el open canónico del módulo de contenido.
                            // Habilitar la vista 2 rompía el scroll de la galería en este contexto.
                            showViews: { 1: true, 2: false, 3: false, 4: false, 5: false, upload: false, import: false }
                        },
                        templateUrl: 'app/main/dialogs/media/media-dialog.html',
                        targetEvent: ev, clickOutsideToClose: true, multiple: true
                    });
                    // devuelve la RESPUESTA cruda; la extracción (con/sin crop) la hace el que llama
                }
                // Extrae la URL de la media elegida. Si wantCrop y hay un crop ~16:9 ligero,
                // se usa ese (mismo patrón que qiu-field mapMediaProperties para el original).
                function mediaUrl(response, wantCrop) {
                    if (!response || !response.Thumbnail || !response.Thumbnail.length) { return ''; }
                    var m = response.Thumbnail[0];
                    if (wantCrop) {
                        var crop = bestCrop(m);
                        if (crop) { return crop; }
                    }
                    if (m.imageUrlOriginal) { return m.imageUrlOriginal; }
                    if (m.cdnContainer && m.id_media && m.filename) {
                        var c = sessionService.getContainerByID(m.cdnContainer);
                        if (c && c.view_url) { return c.view_url + 'original/m' + m.id_media + '_' + m.filename; }
                    }
                    return m.view_url || m.filename_abs || '';
                }

                // Elige un crop ya generado, ligero y ~16:9 (la card es 1200x630) de cdn_cropstatus.
                // El fileName codifica las dimensiones (..._800x450_...). Devuelve URL o ''.
                // Solo png/jpg (GD-safe; evita webp/mp4). Ancho 600–2000 (ni diminuto ni pesado).
                function bestCrop(m) {
                    var list = m && m.cropstatus;
                    if (!angular.isArray(list) || !list.length) { return ''; }
                    var TARGET = 1200 / 630; // ~1.9
                    var best = null, bestScore = -Infinity;
                    list.forEach(function (cs) {
                        var fn = cs && cs.fileName;
                        if (!fn) { return; }
                        if (cs.isCropped === 0 || cs.isCropped === '0' || cs.isCropped === false) { return; }
                        var ext = ('' + fn).split('.').pop().toLowerCase();
                        if (ext !== 'png' && ext !== 'jpg' && ext !== 'jpeg') { return; }
                        var mm = /_(\d+)x(\d+)/.exec(fn);
                        if (!mm) { return; }
                        var w = +mm[1], h = +mm[2];
                        if (!w || !h || w < 600 || w > 2000) { return; }
                        // cercanía de aspecto (peso alto) + preferencia de ancho ~1200
                        var score = 2 - (Math.abs((w / h) - TARGET) * 2 + Math.abs(w - 1200) / 1200);
                        if (score > bestScore) { bestScore = score; best = cs; }
                    });
                    if (!best) { return ''; }
                    if (best.urlImage) { return best.urlImage; }
                    var c = best.id_container ? sessionService.getContainerByID(best.id_container) : null;
                    return (c && c.view_url) ? (c.view_url + best.fileName) : '';
                }

                // ---- preview (replica Mueva_OgCard) ----
                function hexRgb(h) {
                    h = ('' + h).replace('#', '');
                    if (h.length === 3) { h = h.replace(/./g, '$&$&'); }
                    return [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16)];
                }
                function rgb(a) { return 'rgb(' + a[0] + ',' + a[1] + ',' + a[2] + ')'; }
                function mul(a, f) { return [Math.round(a[0] * f), Math.round(a[1] * f), Math.round(a[2] * f)]; }
                function lum(a) {
                    var c = a.map(function (v) { v /= 255; return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); });
                    return 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
                }
                function color() { var c = (scope.record && scope.record.color) || scope.palette[1]; return /^#[0-9a-fA-F]{6}$/.test(c) ? c : '#0049f9'; }
                function style() { return scope.record ? scope.record.style : 'glow'; }

                scope.previewStyle = function () {
                    var st = style(), c = color(), r = hexRgb(c);
                    if (st === 'image' && scope.record.background) {
                        return { 'background-image': 'url("' + scope.record.background + '")', 'background-size': 'cover', 'background-position': 'center', 'color': '#fff' };
                    }
                    if (st === 'fill') {
                        var tl = lum(r) < 0.42;
                        return { 'background': 'linear-gradient(150deg,' + c + ',' + rgb(mul(r, 0.72)) + ')', 'color': tl ? '#fff' : '#0e1116' };
                    }
                    var top = rgb([Math.min(255, Math.round(20 + r[0] * 0.24)), Math.min(255, Math.round(24 + r[1] * 0.24)), Math.min(255, Math.round(32 + r[2] * 0.24))]);
                    var bot = rgb([Math.round(r[0] * 0.06) + 6, Math.round(r[1] * 0.06) + 7, Math.round(r[2] * 0.06) + 11]);
                    return { 'background': 'linear-gradient(180deg,' + top + ',' + bot + ')', 'color': '#fff' };
                };
                scope.glowStyle = function () {
                    var st = style(), c = color();
                    if (st === 'image') { return { 'background': 'transparent' }; }
                    if (st === 'fill') { return { 'background': lum(hexRgb(c)) < 0.42 ? 'rgba(255,255,255,.2)' : 'rgba(0,0,0,.15)' }; }
                    return { 'background': c };
                };
                scope.barStyle = function () {
                    var st = style(), c = color();
                    if (st === 'fill') { return { 'background': lum(hexRgb(c)) < 0.42 ? 'rgba(255,255,255,.85)' : 'rgba(0,0,0,.6)' }; }
                    return { 'background': c };
                };
                scope.overlayStyle = function () {
                    return style() === 'image'
                        ? { 'background': 'linear-gradient(90deg,rgba(0,0,0,.72),rgba(0,0,0,.12) 60%,rgba(0,0,0,0))', 'opacity': 1 }
                        : { 'opacity': 0 };
                };
            }
        };
    }
})();

(function() {
  'use strict';

  angular
    .module('app.forms')
    .controller('ValidationsController', ValidationsController);

  /** @ngInject */
  function ValidationsController($mdDialog, $translate, Index, Field, Fields, $scope) {
    var vm = this;
    vm.field = Field;
    vm.copyField = angular.copy(Field);
    vm.saveDialog = saveDialog;
    vm.closeDialog = closeDialog;
    vm.addValidation = addValidation;
    vm.addValidator = addValidator;
    vm.removeValidation = removeValidation;
    vm.removeValidator = removeValidator;

    vm.validationObject = {
      type: '',
      data: ''
    };
    vm.validatorObject = {
      type: '',
      data: ''
    };

    vm.translate = function(text) {
      return $translate.instant(text);
    }


    function addValidation(validation) {
      if (angular.isUndefined(vm.field.validation) || angular.isUndefined(vm.field.validation.messages))
      {
        vm.field.validation = {
          messages: {}
        }
      }

      vm.field.validation.messages[validation.type] = '|| return \'' + validation.data + '\'';
      delete validation.$$hashKey
      vm.validationObject = {
        type: '',
        data: ''
      };
    }

    function removeValidation(key) {
      if (!angular.isUndefined(vm.field.validation.messages[key]))
      {
        delete(vm.field.validation.messages[key])
      }
      if (Object.keys(vm.field.validation.messages).length == 0) {
        delete(vm.field.validation);
      }
    }

    function addValidator(validator) {
      if (angular.isUndefined(vm.field.validators))
      {
        vm.field.validators = {}
      }
      vm.field.validators[validator.type] = '||' + validator.data;
      delete validator.$$hashKey
      if (validator.type == 'passwordStrength') {
        vm.field.templateOptions.funcPStrength  = '__passwordStrength';
      } else if (validator.type == 'slugCheck') {
        vm.field.templateOptions.funcSlugCheck  = '__slugCheck';
      }
      vm.validatorObject = {
        type: '',
        data: ''
      };
    }
    function removeValidator(key) {
      if (!angular.isUndefined(vm.field.validators[key]))
      {
        delete(vm.field.validators[key])
      }
      if (Object.keys(vm.field.validators).length == 0) {
        delete(vm.field.validators);
      }
      if (key == 'passwordStrength') {
        delete(vm.field.templateOptions.funcPStrength)
      }
      if (key == 'slugCheck') {
        delete(vm.field.templateOptions.funcSlugCheck)
      }
    }

    function saveDialog() {
      if (!angular.isUndefined(vm.field.validation) && !angular.isUndefined(vm.field.validation.messages) && Object.keys(vm.field.validation.messages).length == 0)
      {
        delete(vm.field.validation);
      }
      if (!angular.isUndefined(vm.field.validators) && Object.keys(vm.field.validators).length == 0)
      {
        delete(vm.field.validators);
      }
      Fields[Index] = vm.field;
      $mdDialog.hide();
    }


    function closeDialog() {
      Fields[Index] = vm.copyField;
      $mdDialog.hide();
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.forms')
        .directive('qiuOnCheckToggleAssignedGroup', ToggleAssignedGroup)
        .controller('UserGroupsOptionsController', UserGroupsOptionsController);

    /** @ngInject */
    function UserGroupsOptionsController($mdDialog, $translate, $scope, siteID, groupType, status, optionsSelected, formsService, fieldsTemplateForms) {
        var vm = this;
        vm.loadingUserGroups = true;
        vm.groupTypeId = groupType;
        vm.optionsSelected = optionsSelected;
        vm.groupTypeStatus = status;
        vm.siteID = siteID;
        vm.saveDialog = saveDialog;
        vm.closeDialog = closeDialog;
        vm.loadUserGroups = loadUserGroups;
        vm.getUserGroupTypes = getUserGroupTypes;
        vm.addElement = addElement;
        vm.bag = [{
            label: 'Glasses',
            value: 'glasses',
            children: [{
                label: 'Top Hat',
                value: 'top_hat'
            }, {
                label: 'Curly Mustache',
                value: 'mustachio'
            }]
        }];
        vm.getUserGroupTypes();



        vm.translate = function (text) {
            return $translate.instant(text);
        }

        function loadUserGroups(type, index) {
            var options = {
                site: siteID,
                type: type
            };
            vm.loadingUserGroups = true;

            formsService.getUserGroupsByType(options).then(function (response) {
                vm.loadingUserGroups = false;
                vm.options = formatTree(response);
                if (vm.optionsSelected) {
                    var arrayIds = []
                    for (var i = 0; i < vm.optionsSelected.length; i++) {
                        arrayIds.push(vm.optionsSelected[i].id);
                    }
                    vm.options = fieldsTemplateForms.findAndCheck(vm.options, arrayIds);
                }
                for (var i = 0; i < vm.userGroupTypes.length; i++) {
                    if (vm.userGroupTypes[i].id_group_type == type) {
                        vm.groupType = vm.userGroupTypes[i];
                    }
                }
            });

        }

        function addElement(value) {
            console.log(value)
        }

        function formatTree(array) {
            for (var i = 0; i < array.length; i++) {
                array[i].label = array[i].name;
                array[i].value = array[i].id_group;
                if (array[i].children) {
                    array[i].children = formatTree(array[i].children);
                }
            }
            return array;
        }

        function getUserGroupTypes() {
            var options = {
                site: vm.siteID
            };

            formsService.getUserGroupTypes(options).then(function (response) {
                vm.userGroupTypes = response;
                if (vm.groupTypeId) {
                    vm.loadUserGroups(vm.groupTypeId);
                }else{
                    vm.loadingUserGroups = false;
                }
            });
        }


        function saveDialog() {
            vm.optionsSelected = fieldsTemplateForms.formatUserGroups(vm.options);
            $mdDialog.hide({
                optionsSelected: vm.optionsSelected,
                groupType: vm.groupTypeId,
                status: vm.groupTypeStatus
            });
        }

        function closeDialog() {
            $mdDialog.hide();
        }
    }

    function ToggleAssignedGroup() {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                $(element).on('click', function (e) {
                    if (!scope.node.checked) {
                        scope.node.checked = true;
                    } else {
                        scope.node.checked = !scope.node.checked;
                    }
                });
            }
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('app.forms')
        .controller('OptionsController', OptionsController);

    /** @ngInject */
    function OptionsController($mdDialog, $translate, Index, Field, Fields, Title, ArrayName, $scope) {
        var vm = this;
        vm.field = Field;
        vm.arrayName = ArrayName;
        vm.title = Title;
        vm.copyField = angular.copy(Field);
        vm.saveDialog = saveDialog;
        vm.closeDialog = closeDialog;
        vm.addOption = addOption;

        vm.option = {
            value: '',
            name: ''
        };

        vm.translate = function (text) {
            return $translate.instant(text);
        }

        function addOption(option) {
            vm.field.templateOptions[vm.arrayName].push(option);
            vm.option = {
                value: '',
                name: ''
            };
        }

        function saveDialog() {
            Fields[Index] = vm.field;
            $mdDialog.hide();
        }

        function closeDialog() {
            Fields[Index] = vm.copyField;
            $mdDialog.hide();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.forms')
        .controller('DropzoneOptionsController', DropzoneOptionsController);

    /** @ngInject */
    function DropzoneOptionsController($mdDialog, $translate, $scope, siteID, groupType, status, optionsSelected, $mdToast) {
        var vm = this;
        vm.groupTypeId = groupType;
        if (!optionsSelected) {
          var message = $translate.instant('FORMS.DROPZONE_OPTIONS_ERROR_RECOVER_DEFAULT');
          $mdToast.show({
            template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
            hideDelay: 3000,
            position: 'top',
            parent: '#dropzone-dialog'
          });

          optionsSelected = {
            url: '/',
            maxFilesize: 5,
            method: 'PUT',
            paramName: '',
            maxThumbnailFilesize: 5,
            autoProcessQueue: false,
            maxFiles: 1,
            acceptedFiles: '.doc,.docx,.pdf',
            uploadMultiple: false,
            thumbnailMethod: 'contain',
            thumbnailWidth: 300,
            thumbnailHeight: 300,
            previewTemplate: "<div class=\"dz-preview dz-file-preview dz-processing dz-success dz-complete\"><div class=\"dz-image\"><img data-dz-thumbnail /></div><div class=\"dz-details\"><div class=\"dz-filename\"><span data-dz-name></span></div><div class=\"dz-size\"><span data-dz-size></span></div><button data-dz-remove class=\"btn btn-danger delete\"><i class=\"ion-md-close\" aria-hidden=\"true\"></i></button></div><div class=\"dz-progress\"><span class=\"dz-upload\" data-dz-uploadprogress></span></div><div class=\"dz-error-message\"><span data-dz-errormessage></span></div></div>",
            dictFileTooBig: "The file is bigger than the maximum allowed ({{maxFilesize}}MB)",
            dictInvalidFileType: "This file type is not allowed. Please upload DOC or PDF."
          };
        }
        vm.optionsSelected = optionsSelected;
        vm.groupTypeStatus = status;
        vm.siteID = siteID;
        vm.saveDialog = saveDialog;
        vm.closeDialog = closeDialog;
        vm.title = $translate.instant('FORMS.DROPZONE_OPTIONS');
        vm.bag = [{
            label: 'Glasses',
            value: 'glasses',
            children: [{
                label: 'Top Hat',
                value: 'top_hat'
            }, {
                label: 'Curly Mustache',
                value: 'mustachio'
            }]
        }];


        vm.translate = function (text) {
            return $translate.instant(text);
        }

        function saveDialog() {
            $mdDialog.hide({
                optionsSelected: vm.optionsSelected,
                groupType: vm.groupTypeId,
                status: vm.groupTypeStatus
            });
        }

        function closeDialog() {
            $mdDialog.hide();
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.accounts')
        .factory("transformAccounts", transformAccounts);



    /** @ngInject */
    function transformAccounts(mediaService) {

        var service = {
            getImageById: getImageById,
            userToDTO: userToDTO,
            DtoToUser: DtoToUser,
            formatNestedGroups: formatNestedGroups,
            initUsersGroup: initUsersGroup,
            getLabels: getLabels,
            getGroupsFromLabels: getGroupsFromLabels
        };

        function DtoToUser(user, siteID) {
            if (user.avatar)
                getImageById(user, siteID);
            var groups = [];
            for (var i = 0; i < user.groups.length; i++) {
                groups.push(user.groups[i].id_group);
            }
            user.groups = groups;
        }

        function userToDTO(user) {
            if (user.id_user !== '' && user.id_user !== undefined) {
                user.created_at = JSON.stringify(user.created_at);
                user.last_login = JSON.stringify(user.last_login);
                if (user.avatar)
                    user.avatar = user.avatar.id_media;
                return user;
            } else {
                if (user.avatar !== undefined) {
                    user.avatar = user.avatar.id_media;
                } else {
                    delete user.avatar;
                }
                return user;
            }
        }

        function getImageById(user, siteID) {
            var options = {
                domain: siteID,
                id_media: user.avatar
            };
            mediaService.getImageByID(options)
                .then(function (response) {
                    user.avatar = response.data[0];
                    console.log(user);
                });
        }

        function formatNestedGroups(groups, qiuRestrictions, isRootCycle, parentLabel) {
            if (groups) {
                for (var i = 0; i < groups.length; i++) {
                    var group = groups[i];
                    // 'name' is used as display name on group tree, while 'label' is used for group SEARCH only.
                    // To keep showing children of search result, we concatenate parent group(s) names with current group name into label.
                    group.label = parentLabel ?  parentLabel + '_' + group.name : group.name;
                    if (elementParent.children) {
                        formatNestedGroups(elementParent.children, qiuRestrictions, false, group.label);
                    }
                }
                return groups;
            }
            return [];
        }
/*
        function formatNestedGroups(groups) {
            if (groups) {
                for (var i = 0; i < groups.length; i++) {
                    var elementParent = groups[i];
                    elementParent.label = elementParent.name
                    if (elementParent.children) {
                        for (var j = 0; j < elementParent.children.length; j++) {
                            var elementChild = elementParent.children[j];
                            elementChild.label = elementChild.name;
                            if (elementChild.children) {
                                for (var k = 0; k < elementChild.children.length; k++) {
                                    var elementSecondChild = elementChild.children[k];
                                    elementSecondChild.label = elementSecondChild.name;
                                }
                            }
                        }
                    }
                }
            } else {
                return [];
            }
            return groups;
        }
*/
        function initUsersGroup(usersGroups, arrayId) {
            if (usersGroups && arrayId) {
                usersGroups = formatNestedGroups(usersGroups);
                for (var i = 0; i < arrayId.length; i++) {
                    for (var k = 0; k < usersGroups.length; k++) {
                        if (usersGroups[k].id_group === arrayId[i]) {
                            usersGroups[k].selected = true;
                            arrayId.splice(i, 1);
                        }
                        if (usersGroups[k].children && arrayId) {
                            for (var c = 0; c < usersGroups[k].children.length; c++) {
                                initChildrenUsers(arrayId, usersGroups[k].children[c]);
                            }
                        }
                    }
                }
                return usersGroups;
            }
        }

        function initChildrenUsers(arrayId, child) {
            for (var i = 0; i < arrayId.length; i++) {
                if (child.id_group === arrayId[i]) {
                    child.selected = true;
                    arrayId.splice(i, 1);
                }

                if (child.children && arrayId) {
                    for (var k = 0; k < child.children.length; k++) {
                        initChildrenUsers(arrayId, child.children[k]);
                    }
                }
            }
        }

        function getLabels(usersGroups) {
            if (usersGroups) {
                var labelsArray = [];
                for (var i = 0; i < usersGroups.length; i++) {
                    if (usersGroups[i].selected === true) {
                        labelsArray.push({ label: usersGroups[i].label, id: usersGroups[i].id_group });
                    }
                    if (usersGroups[i].children) {
                        for (var k = 0; k < usersGroups[i].children.length; k++) {
                            getLabelsChildren(labelsArray, usersGroups[i].children[k]);
                        }
                    }
                }
                return labelsArray;
            }
        }

        function getLabelsChildren(labelsArray, child) {
            if (child.selected === true) {
                labelsArray.push({ label: child.label, id: child.id_group });
            }
            if (child.children) {
                for (var i = 0; i < child.children.length; i++) {
                    getLabelsChildren(labelsArray, child.children[i]);
                }
            }
        }

        function getGroupsFromLabels(array) {
            var ids = [];
            for (var i = 0; i < array.length; i++) {
                ids.push(array[i].id);
            }
            return ids;
        }

        return service;
    }
})();

angular.module('app.accounts').filter('groupTabs', ['$parse', function ($parse) {
        return function (list, group_by) {

            var filtered = [];

            if (!group_by) {
                filtered = list;
            } else {
                angular.forEach(list, function (item) {
                    if (item.name.indexOf(group_by) != -1) {
                        filtered.push(item);
                    }

                });
            }

            return filtered;
        };
    }]);
(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngMdIcons',
                'ngResource',
                'ngSanitize',
                'ui.slider',
                'ivh.treeview',
                'ngMaterial',
                // 'angular-chartist',
                // 'chart.js',
                'datatables',
                // 'gridshore.c3js.chart',
                // 'nvd3',
                'pascalprecht.translate',
                'timer',
                'ui.router',
                // 'uiGmapgoogle-maps',
                'ngMap',
                'textAngular',
                'ui.tinymce',
                // 'ui.sortable',
                'ng-sortable',
                'xeditable',
                'moment-picker',
                'ngMaterialDatePicker',
                // 'moment-timezone',
                'angularMoment',
                'mdPickers',
                'mdColorPickerCustom',
                'ap.fotorama',
                'underscore',
                'angular.filter',
                'duScroll',
                'angular-bind-html-compile',
                'treasure-overlay-spinner',
                'ngFileUpload',
                'lfNgMdFileInput',
                'colorpicker.module',
                'nvd3',
                'dndLists',
                angularDragula(angular)
            ]);
})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('treeItem', treeItem)
        .controller('treeItemController', treeItemController);

    /** @ngInject */
    function treeItem() {
        return {
            restrict: 'E',
            transclude: true,
            replace: true,
            scope: {
                selectedid: '=selectedid',
                selectedIds: '=selectedIds',
                iscombo: '=iscombo',
                item: '=item',
                parent: '=parent',
                expandedids: '=expandedids',
                onSelect: '&',
                onExpand: '&',
                onCollapse: '&',
                onEdit: '&'
            },
            templateUrl: "app/core/directives/qiu-tree/tree-item/tree-item.html",
            compile: function (tElement) {
                // Add class
                tElement.addClass('tree-item');
            },
            controller: 'treeItemController as vm',
            link: function (scope, $element, attrs) {



            }
        };

    }
    function treeItemController($scope) {
        var vm = this;
        vm.$onInit = function () {
            vm.item = $scope.item;
            vm.iscombo = $scope.iscombo;
            vm.parent = $scope.parent;
            vm.selectedid = $scope.selectedid;
            vm.expandedids = $scope.expandedids;
            vm.selectedIds = $scope.selectedIds || Object.create(null);
            if (vm.expandedids) {
                vm.expanded = vm.expandedids.indexOf(vm.item.id) >= 0;
            }
        }
        vm.select = select;
        vm.edit = edit;
        vm.expand = expand;
        vm.collapse = collapse;

        // Keep an eye on changes
        $scope.$watch('item', function (newVal, oldVal) {
            vm.item = newVal;
        });
        $scope.$watch('selectedid', function (newVal, oldVal) {
            vm.selectedid = newVal;
        });
        $scope.$watch('expandedids', function (newVal, oldVal) {
            vm.expandedids = newVal;
            vm.expanded = angular.isArray(newVal) && newVal.indexOf(vm.item.id) >= 0;
        });
        $scope.$watch('parent', function (newVal, oldVal) {
            vm.parent = newVal;
        });
        $scope.$watch('selectedIds', function (newVal) {
            vm.selectedIds = newVal || Object.create(null);
        });

        function edit(item, parent) {
            $scope.onEdit({ item: item, parent: parent })
        }
        function select(item) {
            $scope.onSelect({ item: item });
        }

        function expand(item) {
            if (item.id == vm.item.id) {
                vm.expanded = true;
            }
            $scope.onExpand({ item: item });
        }
        function collapse(item) {
            if (item.id == vm.item.id) {
                vm.expanded = false;
            }
            $scope.onCollapse({ item: item });
        }

        // If combo mode is enabled, clicking the row toggles selection without closing the menu.
        vm.onRowClick = function (item, $event) {
            if (vm.iscombo) {
                // Prevent checkbox double-trigger and menu interactions.
                if ($event) $event.stopPropagation();
                vm.select(item); // calls on-select from parent (qiu-tree -> vm.select(item))
                return;
            }

            // Non-combo mode keeps original behavior.
            vm.select(item);
        };
        
        // Checkbox click should only toggle and must not bubble to row/menu.
        vm.toggleFromCheckbox = function (item, $event) {
            if ($event) $event.stopPropagation();
            vm.select(item); // same as row click toggle
        };
    }
})();



(function () {
    'use strict';

    angular
        .module('app.match-center')
        .constant('_', window._)
        .controller('SocialDialogController', SocialDialogController);

    /** @ngInject */
    function SocialDialogController($mdDialog, COMMON, requestContext, $window, sessionService, matchCenterService,
        socialAccountsService, selectedGroup, qiuRestrictedRootGroup, CANARY_ROUTING) {
        var vm = this;

        vm.closeDialog = closeDialog;
        vm.login = login;
        vm.isSelected = isSelected;
        vm.toggleSelected = toggleSelected;
        vm.savePages = savePages;
        vm.connectXPublic = connectXPublic;
        vm.connectXAccount = connectXAccount;
        vm.connectYoutubePublic = connectYoutubePublic;
        vm.connectGoogleAccount = connectGoogleAccount;
        vm.backToProviders = backToProviders;
        vm.xMode = false;
        vm.ytMode = false;
        vm.socialProviders = [];
        vm.selectedGroup = selectedGroup;
        vm.qiuRestrictedRootGroup = qiuRestrictedRootGroup; // May be null.
        vm.siteID = requestContext.getParam("siteId");

        getSocialAccounts();

        function getSocialAccounts() {
            var options = {
                "siteID": vm.siteID
            }
            socialAccountsService.getSocialProviders(options).then(function(response) {
                vm.socialProviders = response;
            });
        }

        // Providers whose account is created server side from a System User token,
        // with no OAuth popup and no postMessage round trip.
        var BUSINESS_PROVIDERS = ['FacebookBusiness'];

        // Providers that return a list of pages to pick from after connecting.
        var PAGE_PICKER_PROVIDERS = ['facebook', 'facebookbusiness'];

        function login(event, tag) {
            // X gets a two-option sub-view instead of an immediate popup: follow a
            // public @handle (default, no OAuth) or connect your own account (advanced).
            if (tag === 'X') {
                vm.xMode = true;
                vm.xHandle = '';
                vm.xError = null;
                vm.xLoading = false;
                return;
            }

            // Same two-option shape for YouTube. The provider button is still labelled
            // Google (that is what tenants have in their socialProviders config), but
            // the default path follows a public channel with the app API key and never
            // opens an OAuth popup. Signing in is only needed to PUBLISH to a channel.
            if (tag === 'Google') {
                vm.ytMode = true;
                vm.ytHandle = '';
                vm.ytError = null;
                vm.ytLoading = false;
                return;
            }

            if (BUSINESS_PROVIDERS.indexOf(tag) !== -1) {
                matchCenterService.connectFacebookBusiness({
                    siteID: vm.siteID
                }).then(onAccountConnected);
                return;
            }

            openOAuthPopup(tag);
        }

        function openOAuthPopup(tag) {
            // The popup is opened with $window.open, which bypasses the $http
            // interceptors - including the canary reroute. Left as COMMON.BASE_API it
            // lands on old prod, whose code may not know this provider at all, and the
            // popup dies with "Invalid provider: X". Mirror the interceptor's rule.
            // (Its LEGACY_PROD_TENANTS check keys off a /domain/<tenant>/ segment, which
            // this URL does not have, so only the local-backend exemption applies.)
            var base = CANARY_ROUTING.LOCAL_API_PATTERN.test(COMMON.BASE_API)
                ? COMMON.BASE_API
                : CANARY_ROUTING.CANARY_BASE_API;

            $window.open(base + "/social/" + sessionService.site_operative.public_key + '/auth/' + tag, tag + ' login', 'right=10,top=150');
            window.addEventListener("message", listenerLogin);
        }
        function listenerLogin(message) {
            console.log(message.data)
            if (message.data.provider) {
                var options = {
                    "siteID": vm.siteID,
                    item: {
                        token: message.data.token
                    }
                }
                matchCenterService.finishSocial(options).then(onAccountConnected)
                $window.removeEventListener("message", listenerLogin)
            }
        }
        // Shared by both paths: the popup flow and the business flow differ only in
        // how the account row is obtained, not in what happens afterwards.
        function onAccountConnected(res) {
            if (vm.selectedGroup) {
                var groups = [vm.selectedGroup];
                if (qiuRestrictedRootGroup && qiuRestrictedRootGroup.id_group !== vm.selectedGroup.id_group) {
                    groups.push(qiuRestrictedRootGroup);
                }
                var options = {
                    siteID: vm.siteID,
                    data: {
                        id_social_accounts: [res.id_social_account],
                        groups: groups
                    }
                };
                socialAccountsService.massInsertIntoGroups(options);
            }
            if (PAGE_PICKER_PROVIDERS.indexOf(res.provider) !== -1) {
                vm.social_account = res;
                var options = {
                    siteID: vm.siteID,
                    id_account: res.id_social_account
                }
                matchCenterService.getTokensSocialPages(options).then(res => {
                    vm.pages = res;
                    vm.pagesSelected = [];
                })
            } else {
                $mdDialog.hide(true);
            }
        }

        function isSelected(page) {
            return vm.pagesSelected.indexOf(page) >= 0;
        }
        function toggleSelected(page) {
            if (isSelected(page)) {
                vm.pagesSelected.splice(vm.pagesSelected.indexOf(page), 1);
            } else {
                vm.pagesSelected.push(page);
            }
        }
        function closeDialog() {
            $mdDialog.hide();
        }

        // X approach A: create a read-only account from a public @handle (no OAuth).
        function connectXPublic() {
            var handle = (vm.xHandle || '').trim().replace(/^@+/, '');
            if (!handle) {
                vm.xError = 'Please enter an X @handle.';
                return;
            }
            vm.xError = null;
            vm.xLoading = true;
            matchCenterService.connectX({
                siteID: vm.siteID,
                item: { handle: handle }
            }).then(function (res) {
                vm.xLoading = false;
                vm.xMode = false;
                onAccountConnected(res);
            }, function (e) {
                vm.xLoading = false;
                vm.xError = (e && e.data && (e.data.detail || e.data.message || e.data.error)) || 'Could not add that X account.';
            });
        }

        // X approach B (advanced): connect your own account through the OAuth popup.
        function connectXAccount(event) {
            openOAuthPopup('X');
        }

        // YouTube default: follow a public channel by @handle or URL (no OAuth).
        function connectYoutubePublic() {
            var handle = (vm.ytHandle || '').trim();
            if (!handle) {
                vm.ytError = 'Please enter a YouTube @handle or channel URL.';
                return;
            }
            vm.ytError = null;
            vm.ytLoading = true;
            matchCenterService.connectYoutube({
                siteID: vm.siteID,
                item: { handle: handle }
            }).then(function (res) {
                vm.ytLoading = false;
                vm.ytMode = false;
                onAccountConnected(res);
            }, function (e) {
                vm.ytLoading = false;
                vm.ytError = (e && e.data && (e.data.detail || e.data.message || e.data.error)) || 'Could not add that YouTube channel.';
            });
        }

        // YouTube advanced: connect the channel's Google account through the OAuth
        // popup. Unchanged behaviour - this is the only path that can publish videos.
        function connectGoogleAccount(event) {
            openOAuthPopup('Google');
        }

        function backToProviders() {
            vm.xMode = false;
            vm.xHandle = '';
            vm.xError = null;
            vm.ytMode = false;
            vm.ytHandle = '';
            vm.ytError = null;
        }

        function savePages() {
            vm.pagesSelected
            var options = {
                "siteID": vm.siteID,
                "item": {
                    "id_social_account": vm.social_account.id_social_account,
                    "pages": vm.pagesSelected.map(x => x.id),
                    "available_to_all": vm.availableToAll ? 1 : 0
                }
            }
            matchCenterService.finishPage(options).then(res => {
                if (vm.selectedGroup && angular.isArray(res)) {
                    var groups = [vm.selectedGroup];
                    if (qiuRestrictedRootGroup && qiuRestrictedRootGroup.id_group !== vm.selectedGroup.id_group) {
                        groups.push(qiuRestrictedRootGroup);
                    }
                    var options = {
                        siteID: vm.siteID,
                        data: {
                            id_social_accounts: res.map(x => x.id_social_account),
                            groups: groups
                        }
                    };
                    socialAccountsService.massInsertIntoGroups(options).then(function(res) {
                        $mdDialog.hide(true);
                    }, function(error) {
                        console.log('Error inserting social accounts', error);
                        $mdDialog.hide(true);
                    });
                } else {
                    $mdDialog.hide(true);
                }
            })
        }

    }
})();


(function (angular) {
  'use strict';

  angular.module('app.core')
    .directive('textareaView', TextareaView);

  /*@ngInject*/
  function TextareaView($timeout) {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/core/directives/form/textarea-item/textarea-view.html',
      scope: {
        formItem: '=',
        form: '='
      },
      controller: TextareaViewCtrl,
      controllerAs: 'TextareaView',
      bindToController: true,
      link: linker
    };

    function linker(scope, elem, attrs, ctrl) {

      //this timeout is placed here in order to make sure that the creator directive of this view is finished its work
      $timeout(function() {
        ctrl.init();
      }, 50);
    }

    return directive;
  }

  /*@ngInject*/
  function TextareaViewCtrl(Utils) {
    this.Utils = Utils;
  }

  TextareaViewCtrl.prototype.init = function () {

    this.Utils.extend(this.formItem, {
      config: {}
    });
  };


})(angular);

(function (angular) {
  'use strict';

  angular.module('app.core')
    .directive('textareaItem', textareaItem);

  function textareaItem() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/core/directives/form/textarea-item/textarea-item.html',
      scope: {
        item: '='
      },
      controller: TextareaItemCtrl,
      controllerAs: 'Textarea',
      bindToController: true
    };

    return directive;
  }

  /*@ngInject*/
  function TextareaItemCtrl(Utils, $element) {
    this.Element = $element;

    Utils.extend(this.item, {
      config: {}
    });
  }

})(angular);

(function (angular) {
    'use strict';

  angular.module('app.core')
      .directive('matrixView', MatrixView);

    /*@ngInject*/
    function MatrixView($timeout) {
      var directive = {
        restrict: 'E',
        templateUrl: 'app/core/directives/form/matrix-item/matrix-view.html',
        scope: {
          formItem: '=',
          isPreview: '&',
          form: '='
        },
        controller: MatrixViewCtrl,
        controllerAs: 'MatrixView',
        bindToController: true,
        link: linker
      };

      function linker(scope, elem, attrs, ctrl) {

        //this timeout is placed here in order to make sure that the creator directive of this view is finished its work
        $timeout(function () {
          ctrl.init();
        }, 50);
      }

      return directive;
    }

    /*@ngInject*/
    function MatrixViewCtrl($scope, Utils) {
      this.Scope = $scope;
      this.Utils = Utils;
      this.isValid = true;
    }

    MatrixViewCtrl.prototype.init = function () {
      this.Utils.extend(this.formItem, {
        config: {
          rows: [],
          columns: []
        }
      });

      this._updateValidity();
      if (this.isPreview()) {
        this._enableWatchers();
      }
    };

    MatrixViewCtrl.prototype._updateValidity = function () {
      var valid = true;
      if (this.formItem.config.required) {
        for (var i = 0; i < this.formItem.config.rows.length; i++) {
          if (!this.formItem.config.rows[i].hasOwnProperty('selected')) {
            valid = false;
            break;
          }
        }
      }

      this.isValid = valid;
      this.form.$setValidity('required', this.isValid);
    };

    MatrixViewCtrl.prototype._enableWatchers = function () {
      this.Scope.$watchGroup(['MatrixView.formItem.config.required',
                         'MatrixView.formItem.config.rows.length'], function (newVal) {
        if (newVal !== undefined) {
          this._updateValidity();
        }
      }.bind(this));
    };

  })
(angular);

(function (angular) {
  'use strict';

  angular.module('app.core')
    .directive('matrixItem', matrixItem);

  function matrixItem() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/core/directives/form/matrix-item/matrix-item.html',
      scope: {
        item: '='
      },
      controller: MatrixItemCtrl,
      controllerAs: 'Matrix',
      bindToController: true
    };

    return directive;
  }

  /*@ngInject*/
  function MatrixItemCtrl(Utils, $document) {
    this.RowContainer = angular.element($document[0].querySelector('.rowContainer'));
    this.ColumnContainer = angular.element($document[0].querySelector('.columnContainer'));

    Utils.extend(this.item, {
      config: {
        rows: [{
          value: ''
        }],
        columns: [{
          value: ''
        }]
      }
    });
  }

  MatrixItemCtrl.prototype.deleteRow = function(index) {
    this.item.config.rows.splice(index, 1);
  };

  MatrixItemCtrl.prototype.addRow = function() {
    this.item.config.rows.push({
      value: ''
    });

    setTimeout(function() {
      var options = this.RowContainer.find('input');
      var addedOption = options[options.length - 1];
      addedOption.focus();
    }.bind(this), 0);
  };

  MatrixItemCtrl.prototype.deleteColumn = function(index) {
    this.item.config.columns.splice(index, 1);
  };

  MatrixItemCtrl.prototype.addColumn = function() {
    this.item.config.columns.push({
      value: ''
    });

    setTimeout(function() {
      var options = this.ColumnContainer.find('input');
      var addedOption = options[options.length - 1];
      addedOption.focus();
    }.bind(this), 0);
  };

})(angular);

(function (angular) {
  'use strict';

  angular.module('app.core')
    .directive('radioButtonView', RadioButtonView);

  /*@ngInject*/
  function RadioButtonView($timeout) {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/core/directives/form/radio-button-item/radio-button-view.html',
      scope: {
        formItem: '=',
        isPreview: '&',
        form: '='
      },
      controller: RadioButtonViewCtrl,
      controllerAs: 'RadioButtonView',
      bindToController: true,
      link: linker
    };

    function linker(scope, elem, attrs, ctrl) {

      //this timeout is placed here in order to make sure that the creator directive of this view is finished its work
      $timeout(function() {
        ctrl.init();
      }, 50);
    }

    return directive;
  }

  /*@ngInject*/
  function RadioButtonViewCtrl(Utils) {
    this.Utils = Utils;
  }

  RadioButtonViewCtrl.prototype.init = function () {

    this.Utils.extend(this.formItem, {
      config: {},
      options: []
    });
  };


})(angular);

(function (angular) {
  'use strict';

  angular.module('app.core')
    .directive('radioButtonItem', RadioButton);

  function RadioButton() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/core/directives/form/radio-button-item/radio-button-item.html',
      scope: {
        item: '='
      },
      controller: RadioButtonCtrl,
      controllerAs: 'RadioButton',
      bindToController: true
    };

    return directive;
  }

  /*@ngInject*/
  function RadioButtonCtrl(Utils, $element) {
    this.Element = $element;
    Utils.extend(this.item, {
      config: {},
      options: [{
        value: ''
      }]
    });
  }

  RadioButtonCtrl.prototype.deleteOption = function (index) {
    this.item.options.splice(index, 1);
  };

  RadioButtonCtrl.prototype.addOption = function () {
    this.item.options.push({
      value: ''
    });

    setTimeout(function() {
      var options = this.Element.find('input');
      var addedOption = options[options.length - 1];
      addedOption.focus();
    }.bind(this), 0);
  };

})(angular);

(function (angular) {
  'use strict';

  angular.module('app.core')
    .directive('formView', FormView);

  function FormView() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/core/directives/form/form-view/form-view.html',
      scope: {
        form: '='
      },
      controller: FormViewCtrl,
      controllerAs: 'FormView',
      bindToController: true,
      link: linker
    };

    function linker(scope, elem, attrs, ctrl) {
      ctrl.init();
    }

    return directive;
  }

  /*@ngInject*/
  function FormViewCtrl($scope) {
    this.Scope = $scope;
  }

  FormViewCtrl.prototype.init = function () {
  };

})(angular);

(function (angular) {
  'use strict';

  angular.module('app.core')
    .directive('inputView', InputView);

  /*@ngInject*/
  function InputView($timeout) {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/core/directives/form/input-item/input-view.html',
      scope: {
        formItem: '=',
        form: '='
      },
      controller: InputViewCtrl,
      controllerAs: 'InputView',
      bindToController: true,
      link: linker
    };

    function linker(scope, elem, attrs, ctrl) {

      //this timeout is placed here in order to make sure that the creator directive of this view is finished its work
      $timeout(function() {
        ctrl.init();
      }, 50);
    }

    return directive;
  }

  /*@ngInject*/
  function InputViewCtrl(Utils) {
    this.Utils = Utils;
  }

  InputViewCtrl.prototype.init = function () {

    this.Utils.extend(this.formItem, {
      config: {}
    });
  };


})(angular);

(function (angular) {
  'use strict';

  angular.module('app.core')
    .directive('inputItem', InputItem);

  function InputItem() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/core/directives/form/input-item/input-item.html',
      scope: {
        item: '='
      },
      controller: InputItem,
      controllerAs: 'Input',
      bindToController: true
    };

    return directive;
  }

  /*@ngInject*/
  function InputItemCtrl(Utils, $element) {
    this.Element = $element;

    Utils.extend(this.item, {
      config: {
        type: 'text'
      }
    });
  }

})(angular);

(function (angular) {
  'use strict';

  angular.module('app.core')
    .directive('formItemsContainer', FormItemsContainer);

  /** @ngInject */
  function FormItemsContainer() {
    var directive = {
      restrict: 'E',
      scope: {
        form: '='
      },
      controller: FormItemsContainerCtrl,
      controllerAs: 'container',
      bindToController: true,
      templateUrl: 'app/core/directives/form/form-items-container/form-items-container.html'
    };

    return directive;
  }

  var vm;

  /*@ngInject*/
  function FormItemsContainerCtrl() {
    vm = this;
  }

  FormItemsContainerCtrl.prototype.delete = function(item, index) {
    vm.form.items.splice(index, 1);
  };

  FormItemsContainerCtrl.prototype.up = function(item, index) {
    if(index !== 0) {
      var prevItem = vm.form.items[index - 1];
      vm.form.items[index] = prevItem;
      vm.form.items[index - 1] = item;
    }
  };

  FormItemsContainerCtrl.prototype.down = function(item, index) {
    if(index !== vm.form.items.length - 1) {
      var nextItem = vm.form.items[index + 1];
      vm.form.items[index] = nextItem;
      vm.form.items[index + 1] = item;
    }
  };

})(angular);

(function (angular) {
  'use strict';

  angular.module('app.core')
    .directive('formItem', FormItem);

  /** @ngInject */
  function FormItem($compile) {
    var directive = {
      restrict: 'E',
      link: linker,
      scope: {
        item: '=',
        onDelete: '&',
        onUp: '&',
        onDown: '&',
        index: '&'
      },
      controller: FormItemCtrl,
      controllerAs: 'FormItem',
      bindToController: true
    };

    function linker(scope, elem, attrs, ctrl) {
      var template = ctrl._getItemTemplate(attrs.type);
      var el = $compile(template)(scope);
      elem.append(el);

      ctrl.init();
    }

    return directive;
  }

  /*@ngInject*/
  function FormItemCtrl($attrs, Utils) {
    this.Attrs = $attrs;
    this.Utils = Utils;
    this.templates = {
      input: '<input-item item="FormItem.item"></input-item>',
      chooseFromList: '<bet-form-choose-from-list item="FormItem.item"></bet-form-choose-from-list>',
      multipleChoices: '<radio-button-item item="FormItem.item"></radio-button-item>',
      matrix: '<matrix-item item="FormItem.item"></matrix-item>',
      checkboxes: '<checkboxes-item item="FormItem.item"></checkboxes-item>',
      textarea: '<textarea-item item="FormItem.item"></textarea-item>'
    };
  }

  FormItemCtrl.prototype.init = function () {
    this.Utils.extend(this.item, {
      type: this.Attrs.type,
      props: {
        title: '',
        helpText: ''
      },
      config: {
        required: false
      }
    });
  };

  FormItemCtrl.prototype.deleteClicked = function() {
    this.onDelete({item: this.item, index: this.index()});
  };

  FormItemCtrl.prototype._getItemTemplate = function (type) {
    var prefix = '' +
      '<div class="form-item-container">' +
        '<div class="form-item-actions">' +
          '<md-button class="md-button" ng-if="FormItem.Attrs.onDelete" ng-click="FormItem.deleteClicked()"> ' +
            '<i class="material-icons small">delete</i>' +
          '</md-button>' +
          '<md-button class="md-button" ng-if="FormItem.Attrs.onUp" ng-click="FormItem.onUp({item: FormItem.item, index: FormItem.index()})"> ' +
            '<i class="material-icons small">arrow_drop_up</i>' +
          '</md-button>' +
          '<md-button class="md-button" ng-if="FormItem.Attrs.onDown" ng-click="FormItem.onDown({item: FormItem.item, index: FormItem.index()})"> ' +
            '<i class="material-icons small">arrow_drop_down</i>' +
          '</md-button>' +
        '</div>' +
        '<md-input-container>' +
          '<label>Field Title</label>' +
          '<input ng-model="FormItem.item.props.title"/>' +
        '</md-input-container>' +
        '<md-input-container>' +
          '<label>Help Text</label>' +
          '<input ng-model="FormItem.item.props.helpText" />' +
        '</md-input-container>';

    var suffix = '' +
      '<md-input-container>' +
        '<md-checkbox ng-model="FormItem.item.config.required">Required field</md-checkbox>' +
      '</md-input-container>' +
    '</div>';

    return prefix + this.templates[type] + suffix;
  };

})(angular);

(function (angular) {
  'use strict';

  angular.module('app.core')
    .directive('checkboxesView', CheckboxesView);

  /*@ngInject*/
  function CheckboxesView($timeout) {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/core/directives/form/checkboxes-item/checkboxes-view.html',
      scope: {
        formItem: '=',
        isPreview: '&',
        form: '='
      },
      controller: CheckboxesViewCtrl,
      controllerAs: 'CheckboxesView',
      bindToController: true,
      link: linker
    };

    function linker(scope, elem, attrs, ctrl) {

      //this timeout is placed here in order to make sure that the creator directive of this view is finished its work
      $timeout(function() {
        ctrl.init();
      }, 50);
    }

    return directive;
  }

  /*@ngInject*/
  function CheckboxesViewCtrl($scope, Utils) {
    this.Scope = $scope;
    this.Utils = Utils;
  }

  CheckboxesViewCtrl.prototype.init = function () {
    this.Utils.extend(this.formItem, {
      config: {},
      options: []
    });

    this.selectedOptions = this._getSelectedOptions();
    this.disableOptions = false;

    this.isValid = true;
    this._updateView();
    this._updateValidity();
    if (this.isPreview()) {
      this._enableWatchers();
    }
  };

  CheckboxesViewCtrl.prototype.toggleSelectedOption = function () {
    this.selectedOptions = this._getSelectedOptions();
    this._updateView();
    this._updateValidity();
  };

  CheckboxesViewCtrl.prototype._getSelectedOptions = function () {
    return this.formItem.options.filter(function (option) {
      return option.selected;
    });
  };

  CheckboxesViewCtrl.prototype._updateView = function () {
    if (!this.formItem.config.maxSelections) {
      this.disableOptions = false;
    } else if (this.selectedOptions.length === this.formItem.config.maxSelections) {
      this.disableOptions = true;
    } else {
      this.disableOptions = false;
    }
  };

  CheckboxesViewCtrl.prototype._updateValidity = function () {
    if (this.formItem.config.required) {
      this.isValid = this.selectedOptions.length > 0;
    } else {
      this.isValid = true;
    }

    this.form.$setValidity('minSelections', this.isValid);
  };

  CheckboxesViewCtrl.prototype._enableWatchers = function () {
    this.Scope.$watch('CheckboxesView.formItem.config.required', function (newVal) {
      if (newVal !== undefined) {
        this._updateView();
        this._updateValidity();
      }
    }.bind(this));
  };

})(angular);

(function (angular) {
  'use strict';

  angular.module('app.core')
    .directive('checkboxesItem', CheckboxesItem);

  function CheckboxesItem() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/core/directives/form/checkboxes-item/checkboxes-item.html',
      scope: {
        item: '='
      },
      controller: CheckboxesItemCtrl,
      controllerAs: 'Checkboxes',
      bindToController: true
    };

    return directive;
  }

  /*@ngInject*/
  function CheckboxesItemCtrl(Utils, $element) {
    this.Element = $element;

    Utils.extend(this.item, {
      config: {
        maxSelections: null
      },
      options: [{
        value: '',
        selected: false
      }]
    });
  }

  CheckboxesItemCtrl.prototype.deleteOption = function (index) {
    this.item.options.splice(index, 1);
  };

  CheckboxesItemCtrl.prototype.addOption = function () {
    this.item.options.push({
      value: '',
      selected: false
    });

    setTimeout(function() {
      var options = this.Element.find('input');
      var addedOption = options[options.length - 1];
      addedOption.focus();
    }.bind(this), 0);
  };

})(angular);

(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();




(function () {
    'use strict';

    angular
        .module('app.toolbar')
        .directive('compareTo', compareTo)
        .controller('ChangePassDialogcontroller', ChangePassDialogcontroller);

    /** @ngInject */
    function ChangePassDialogcontroller($mdDialog, user, $mdToast, $translate, accountsService) {
        var vm = this;

        vm.closeDialog = closeDialog;
        vm.containsNumber = containsNumber;
        vm.containUpperCaseAndLowerCase = containUpperCaseAndLowerCase;
        vm.save = save;
        vm.user = user;


        function containsNumber() {
            return vm.password && vm.password.match(/\d+/g);
        }
        function containUpperCaseAndLowerCase() {
            return vm.password && vm.password.match(/[a-z]/) && vm.password.match(/[A-Z]/);
        }
        function closeDialog() {
            $mdDialog.hide();
        }

        function save() {
            var options = {
                site: vm.user.domain_active.domain_name,
                id: vm.user.id_user,
                item: {
                    "id_user": vm.user.id_user,
                    "email": vm.user.email,
                    "password": vm.password
                }
            };


            accountsService.updateUserPass(options).then(function (response) {
                $mdDialog.hide();
                var message = $translate.instant('ACCOUNTS.SAVED');
                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                    hideDelay: 5000,
                    position: 'top',
                    parent: '#content-container'
                });
            })
        }

    }
})();



function compareTo() {

    return {
        require: "ngModel",
        scope: {
            compareTolValue: "=compareTo"
        },
        link: function (scope, element, attributes, ngModel) {

            ngModel.$validators.compareTo = function (modelValue) {

                return modelValue == scope.compareTolValue;
            };

            scope.$watch("compareTolValue", function () {
                ngModel.$validate();
            });
        }
    };
}

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/quick-panel');

        // Api
        msApiProvider.register('quickPanel.activities', ['app/data/quick-panel/activities.json']);
        msApiProvider.register('quickPanel.contacts', ['app/data/quick-panel/contacts.json']);
        msApiProvider.register('quickPanel.events', ['app/data/quick-panel/events.json']);
        msApiProvider.register('quickPanel.notes', ['app/data/quick-panel/notes.json']);
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('DomainTabController', DomainTabController);

    /** @ngInject */
    function DomainTabController(msApi, $timeout, $rootScope, $scope, sessionService, $mdSidenav, $state)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        msApi.request('quickPanel.contacts@get', {},
            // Success
            function (response)
            {
                vm.contacts = response.data;
            }
        );

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;
        vm.setDomain = setDomain;




        //////////

        // Set active Domain
        function setDomain(domain) 
        {
            console.log('domain', domain);
            $scope.loadingScreen = true;

            $rootScope.$broadcast('msSplashScreen::add');
            $mdSidenav("quick-panel").toggle();

            sessionService.setActiveDomain(domain).then(
                function() {
                    setOperativeDomain();
                    $rootScope.$emit('site:loadStartDomain', domain);
                    sessionService.setModuleSection(domain).then(function() {
                        setModules()
                    })
                    console.log("remove")


                    console.info("TO site: ", sessionService.site_operative.subdomain)
                    // $state.go('site_overview.dashboard', {
                    $state.go('app.dashboards', {
                        siteId: domain.subdomain,
                        bar: 1
                    });
                },
                function() {
                    $rootScope.$emit('site:loadFinished', domain);

                    toastr.error("error", "response.status");
                    // Couldn't login for some reason - kick the user back to the login page.
                    // window.location.href = "./";

                }
            );
        };

        function setOperativeDomain() 
        {
            $scope.site_operative = sessionService.site_operative;
            $scope.modulecontent = sessionService.modulecontent;
        }

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        msApi.request('quickPanel.contacts@get', {},
            // Success
            function (response)
            {
                vm.contacts = response.data;
            }
        );

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_logout', {
            url      : '/pages/auth/logout',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_logout': {
                    // templateUrl: 'app/main/pages/auth/logout/logout.html',
                    controller : 'LogoutController as vm'
                }
            },
            bodyClass: 'logout'
        });

        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/pages/auth/logout');

        // Navigation
        // msNavigationServiceProvider.saveItem('pages.auth.logout', {
        //     title : 'Logout',
        //     state : 'app.pages_auth_logout',
        //     weight: 2
        // });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.pages')
        .controller('LogoutController', LogoutController);

    /** @ngInject */
    function LogoutController($auth, $location, $scope, $rootScope, $translate, sessionService) {

        if (!$auth.isAuthenticated()) {
            return;
        }
        $auth.logout()
            .then(function () {
                sessionService.cleanAllStorage();
                $translate.use($translate.preferredLanguage())
                $rootScope.user = '';
                // toastr.info('You have been logged out');

                $location.path('/login');
            });

        //////////
    }
})();

(function() {
  'use strict';

  angular
    .module('app.core')
    .controller('HtmlPreviewController', HtmlPreviewController);


  /** @ngInject */
  function HtmlPreviewController($scope, currentHtml, $mdDialog) {

    var vm = this;
    vm.html = currentHtml;
    vm.width = 640;
    vm.mobilePreview = false;
    vm.currentType = 'desktop';
    vm.typeWidth = {
      desktop: 640,
      mobile: 320
    };


    // METHODS
    vm.closeDialog = closeDialog;
    vm.setWidth = setWidth;

    function closeDialog() {
      $mdDialog.hide();
    }

    function setWidth(viewType) {
      if (!angular.isUndefined(vm.typeWidth[viewType])) {
        vm.currentType = viewType;
        vm.width = vm.typeWidth[vm.currentType];
      }
    }

  }

})();


(function() {
    'use strict';
  
    angular
      .module('app.core')
      .controller('WebBuilderController', WebBuilderController);
  
  
    /** @ngInject */
    function WebBuilderController($scope, $sce, msUtils, dragulaService, $mdDialog, $mdToast, currentWeb, $timeout, sessionService, contentService, requestContext, section, templates, $translate,
    ) {
  
      var vm = this;
      var siteID = requestContext.getParam("siteId");
      $scope.siteID = siteID;
      $scope.section = section;
      vm.closeDialog = closeDialog;
      vm.getTemplate = getTemplate;

      vm.currentWeb = currentWeb;
      vm.editWeb = angular.copy(currentWeb);
      console.log('vm.editWeb', vm.editWeb);
      vm.templates = templates;
      console.log('templates', templates);

      function closeDialog() {
        if(hasChanges()){
          var messageConfirm = msUtils.translate('GLOBAL.ARE_YOU_SURE_LOST_CHANGES');
          var confirm = $mdDialog.confirm()
          .title(messageConfirm)
          .ariaLabel('Lost changes')
          .ok(msUtils.translate('GLOBAL.OK'))
          .cancel(msUtils.translate('GLOBAL.CANCEL'))
          .multiple(true)
          ;
          $mdDialog.show(confirm).then(function () {
            $mdDialog.hide();
          });
        }else{
          $mdDialog.hide();
        }
      }
      /**
       * Check if web has changed, to enable or disable save button
       * @returns {boolean}
       */
      function hasChanges() {
        return !angular.equals(vm.currentWeb, vm.editWeb)
      };
     
      /**
      * Generate template by ID
      *
      * @param type
      * @returns {string}
      */
      function getTemplate(ID) {
        var template = vm.templates.find(x => x.value.id == ID).template[0];
        console.log('template', template);
        var html = "<" + template.tag + " class='" + template.class + "'>";
        if(template.children && template.children.length){
          template.children.forEach(element => {
            let value = element.value.slice(element.value.indexOf("."));
            html = html.concat("<" + element.tag + ">{{element" + value +"}}</" + element.tag + ">");
          });
        }
        html = html.concat("</" + template.tag + ">");
        console.log('html', html);
        return html;
      };
    }
  
  })();
  
(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('mdInput', [
      '$timeout',
      function ($timeout) {
        return {
          restrict: 'A',
          // scope: {
          //     ngModel: '='
          // },
          controller: function ($scope, $element) {
            var $elem = $($element);
            $scope.updateInput = function () {
              // clear wrapper classes
              $elem.closest('.md-input-wrapper').removeClass('md-input-wrapper-danger md-input-wrapper-success md-input-wrapper-disabled');

              if ($elem.hasClass('md-input-danger')) {
                $elem.closest('.md-input-wrapper').addClass('md-input-wrapper-danger');
              }
              if ($elem.hasClass('md-input-success')) {
                $elem.closest('.md-input-wrapper').addClass('md-input-wrapper-success');
              }
              if ($elem.prop('disabled')) {
                $elem.closest('.md-input-wrapper').addClass('md-input-wrapper-disabled');
              }
              if ($elem.hasClass('label-fixed')) {
                $elem.closest('.md-input-wrapper').addClass('md-input-filled');
              }
              if ($elem.val() !== '') {
                $elem.closest('.md-input-wrapper').addClass('md-input-filled');
              }
            };
          },
          link: function (scope, elem, attrs) {

            var $elem = $(elem);

            $timeout(function () {
              if (!$elem.hasClass('md-input-processed')) {

                if ($elem.prev('label').length) {
                  $elem.prev('label').addBack().wrapAll('<div class="md-input-wrapper"/>');
                } else {
                  $elem.wrap('<div class="md-input-wrapper"/>');
                }
                $elem
                  .addClass('md-input-processed')
                  .closest('.md-input-wrapper')
                  .append('<span class="md-input-bar"/>');
              }

              scope.updateInput();

            }, 100);

            scope.$watch(function () {
              return $elem.attr('class');
            },
              function (newValue, oldValue) {
                if (newValue != oldValue) {
                  scope.updateInput();
                }
              }
            );

            scope.$watch(function () {
              return $elem.val();
            },
              function (newValue, oldValue) {
                if (!$elem.is(':focus') && (newValue != oldValue)) {
                  scope.updateInput();
                }
              }
            );

            $elem
              .on('focus', function () {
                $elem.closest('.md-input-wrapper').addClass('md-input-focus');
              })
              .on('blur', function () {
                $timeout(function () {
                  $elem.closest('.md-input-wrapper').removeClass('md-input-focus');
                  if ($elem.val() === '') {
                    $elem.closest('.md-input-wrapper').removeClass('md-input-filled');
                  } else {
                    $elem.closest('.md-input-wrapper').addClass('md-input-filled');
                  }
                }, 100);
              });
          }
        };
      }
    ])
    /**
     * Custom directive to upload images
     * @example: <input type="file" input-file-upload />
     */
    .directive('inputFileUploadSingle', [
      'sessionService',
      '$document',
      '$mdDialog',
      '$timeout',
      function (sessionService, $document, $mdDialog, $timeout) {
        return {
          restrict: 'E',
          replace: true,
          scope: {
            element: '=',
            model: '=',
            key: '=',
            onUpdate: '&'
          },
          template: `
                    <div>
                        <div class="upload">
                            <div class="upload-image">
                              <md-button ng-click="showMediaDialog($event)" class="md-accent md-raised" translate="GLOBAL.BROWSE_UPLOAD"  aria-label="Browse"></md-button>
                            </div>
                        </div>
                        <div class="current-image" >
                            <img ng-src="{{model.url}}" alt="" />
                            <span ng-if="model.id_media != 0">ID: #{{model.id_media}}</span>
                        </div>
                    </div>
                `,
          link: (scope, elem, attrs) => {

            scope.selectedCrop = !angular.isUndefined(sessionService.site_operative.mailingDefaultCropformat) ? sessionService.site_operative.mailingDefaultCropformat : 'original';
            if (!angular.isUndefined(scope.element.mediaCropformats)) {
              console.log('mediaCropformat', scope.element['mediaCropformats'].cropformat);
              scope.selectedCrop = scope.element['mediaCropformats'].cropformat;
            }
            var currentThumbnail = [
              scope.model
            ]
            if (scope.element[scope.key].id_media == 0) {
              currentThumbnail = []
            }

            scope.showMediaDialog = function (ev) {
              $mdDialog.show({
                controller: 'MediaDialogController',
                controllerAs: 'vm',
                locals: {
                  currentThread: {
                    Thumbnail: currentThumbnail
                  },
                  section: '',
                  mediazone: {
                    id_zone: null,
                    zone_name: null
                  },
                  isTiny: false,
                  maxAttach: 1,
                  showViews: {
                    1: true,
                    2: true,
                    3: true,
                    4: true,
                    5: true,
                    upload: true,
                    import: true
                  },
                  autoUpload: ''
                },
                templateUrl: 'app/main/dialogs/media/media-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                multiple: true
              }).then(function (item) {
                if (item.Thumbnail.length > 0) {
                  if (!angular.equals(item.Thumbnail[0], scope.model)) {
                    var media = item.Thumbnail[0];

                    // Alias cropStatus for MediaHub items
                    if (angular.isUndefined(media.cropstatus) && angular.isDefined(media.cropStatus)) {
                      media.cropstatus = media.cropStatus;
                    }

                    // Alias id for MediaHub items
                    if (angular.isUndefined(media.id_media) && angular.isDefined(media.id)) {
                      media.id_media = media.id;
                    }

                    var containerOriginal = sessionService.getContainerByID(media.cdnContainer);
                    if (angular.isObject(media) && (angular.isObject(media.cropstatus) || !angular.isUndefined(media.url) || !angular.isUndefined(media.imageUrl))) {
                      scope.model = {
                        id_media: media.id_media,
                        fields: {
                          filename: media.filename || "",
                          photographer: media.photographer || "",
                          owner: media.owner || "",
                          caption: media.caption || "",
                          title: media.title || ""
                        },
                        id_zone: null,
                        zone_name: null,
                        url: '',
                        cropformat: 'original',
                        cropformats: {}
                      }

                      // Set original URL
                      if (media.isMediahub) {
                        scope.model.cropformats['original'] = media.imageUrlOriginal || media.imageUrl || media.url || '';
                        scope.model.isMediahub = true;
                      } else if (containerOriginal && containerOriginal.view_url) {
                        scope.model.cropformats['original'] = containerOriginal.view_url + 'original/m' + media.id_media + '_' + media.filename;
                      } else {
                        scope.model.cropformats['original'] = media.url || '';
                      }

                      if (media.cropstatus) {
                        angular.forEach(media.cropstatus, function (cropFormat) {
                          var container = sessionService.getContainerByID(cropFormat.id_container);
                          if (container && container.view_url) {
                            scope.model.cropformats[cropFormat.id_cropformats] = container.view_url + cropFormat.fileName;
                            if (cropFormat.id_cropformats == sessionService.getMediaFullCropformatId()) {
                              scope.model.cropformat = cropFormat.id_cropformats.toString();
                              scope.model.url = scope.model.cropformats[cropFormat.id_cropformats];
                            }
                          }
                        });
                      }

                      $timeout(function () {
                        if (!angular.isUndefined(scope.model.cropformats[scope.selectedCrop])) {
                          scope.model.cropformat = scope.selectedCrop;
                          scope.model.url = scope.model.cropformats[scope.selectedCrop];
                        } else {
                          scope.model.cropformat = 'original';
                          scope.model.url = scope.model.cropformats['original'];
                        }
                        scope.onUpdate();
                      })
                    }

                  }
                }
              });
            }

          }
        };
      }
    ])
    .directive('cropformatSelect', [
      'sessionService',
      '$document',
      '$mdDialog',
      '$timeout',
      function (sessionService, $document, $mdDialog, $timeout) {
        return {
          restrict: 'E',
          replace: true,
          scope: {
            element: '=',
            model: '=',
            onUpdate: '&'
          },
          template: `
                    <div>
                      <select class="md-input select-cropformat" ng-model="model.cropformat">
                        <option ng-repeat="(key, link) in model.cropformats" ng-value="key">{{getCropFormatData(key)}}</option>
                      </select>
                    </div>
                `,
          link: (scope, elem, attrs) => {
            scope.$watch(function () {
              return scope.model.cropformat;
            }, function (newValue) {
              scope.model.cropformat = newValue;
              scope.model.url = scope.model.cropformats[newValue];
              $timeout(function () {
                scope.onUpdate();
              })
            });

            scope.getCropFormatData = function (crop) {
              var cropData = sessionService.getCropformatByID(crop)
              if (cropData) {
                return cropData.name + ' (' + cropData.width + 'x' + cropData.height + ')';
              } else {
                return crop;
              }
            }
          }
        };
      }
    ])
    .directive('cropformatSelect2', [
      'sessionService',
      '$document',
      '$mdDialog',
      '$timeout',
      function (sessionService, $document, $mdDialog, $timeout) {
        return {
          restrict: 'E',
          replace: true,
          scope: {
            element: '=',
            model: '=',
            onUpdate: '&'
          },
          template: `
                    <div>
                      <select class="md-input select-cropformat" ng-model="model.cropformat">
                        <option ng-repeat="(key, val) in model.cropformats" ng-value="key">{{val}}</option>
                      </select>
                    </div>
                `,
          link: (scope, elem, attrs) => {
            if (!angular.isUndefined(sessionService.site_operative.mailingDefaultCropformat) && sessionService.site_operative.mailingDefaultCropformat) {
              scope.defaultCropformat = sessionService.site_operative.mailingDefaultCropformat;
            } else {
              scope.defaultCropformat = 'original';
            }
            angular.forEach(sessionService.site_operative.cropformats, function (cropData) {
              if (cropData.mailing) {
                scope.model.cropformats[cropData.id_cropformats] = cropData.name + ' (' + cropData.width + 'x' + cropData.height + ')'
              }
            });
            if (!scope.model.cropformat) {
              scope.model.cropformat = angular.copy(scope.defaultCropformat).toString();
            }
            scope.$watch(function () {
              return scope.model.cropformat;
            }, function (newValue) {
              angular.forEach(scope.element, function (e, key) {
                if (key.search('imageSingle') > -1) {
                  if (!angular.isUndefined(e.cropformats[newValue])) {
                    e.cropformat = newValue;
                    e.url = e.cropformats[newValue];
                  } else {
                    e.cropformat = scope.defaultCropformat;
                    e.url = e.cropformats[scope.defaultCropformat];
                  }
                }
              })
            });
          }
        };
      }
    ])
    .directive('imageWithLink', [
      'sessionService',
      function (sessionService) {
        return {
          restrict: 'A',
          transclude: true,
          scope: {
            link: '=',
            linkMedia: '='
          },
          link: function (scope, elem, attrs) {
            scope.$watch(function () {
              return scope.link.type;
            }, function (newValue) {
              if (newValue !== 'none') {
                if ($(elem).parent().is("a")) {
                  $(elem).unwrap('a');
                }
                var linkUrl = '';

                if (scope.link.type == 'link' || scope.link.type == 'email') {
                  if (scope.link.type == 'email') {
                    linkUrl = 'mailto:' + scope.link.link;
                  }
                  else {
                    linkUrl = scope.link.link;
                  }
                }
                else if (scope.link.type == 'mediacenter' && angular.isUndefined(sessionService.site_operative.mediacenterUrl)) {
                  linkUrl = sessionService.site_operative.mediacenterUrl + '#id=' + scope.linkMedia.id_media;
                }
                else if (scope.link.type == 'original') {
                  linkUrl = scope.linkMedia.cropformats.original;
                }

                $(elem).wrap($('<a/>', {
                  href: linkUrl,
                  target: '_blank'
                }).on('click', function (e) {
                  e.preventDefault();
                }));
              } else {
                if ($(elem).parent().is("a")) {
                  $(elem).unwrap('a');
                }
              }
            });

            scope.$watch(function () {
              return scope.link.link;
            }, function (newValue) {
              $(elem).closest('a').attr('href', scope.link.type == 'link' ? newValue : 'mailto:' + newValue);
            });

          }
        };
      }
    ])
    .directive('colorInput', function () {
      return {
        restrict: 'E',
        replace: true,
        template: `
                <div>
                    <div class="current-color" ng-style="{ backgroundColor: model }"></div>
                    <input ng-model="model" colorpicker colorpicker-position="top" type="text" />
                </div>
            `,
        scope: {
          model: '='
        },
        link(scope, elem, attrs) {
          $(elem).on('click', '.current-color', () => $(elem).find('input:text').click());
          $(elem).find('input:text').on('focus', () => {
            $(elem).addClass('focussed')
          }).on('focusout', () => {
            $(elem).removeClass('focussed')
          });
        }
      }
    })
    .directive('mobilePreview', ['$timeout', function ($timeout) {
      return {
        restrict: 'E',
        replace: true,
        scope: {
          email: '=',
          class: '='
        },
        template: `
                <iframe width="320" ng-class="class"></iframe>
            `,
        link(scope, iframe, attrs) {
          scope.insertHtml = function (html) {
            iframe[0].contentWindow.document.open();
            iframe[0].contentWindow.document.write(html);
            iframe[0].contentWindow.document.close();
          }

          $timeout(function () {
            scope.$watch(function () {
              return scope.email.html
            }, scope.insertHtml)
          })

        }
      }
    }])
    .directive('desktopPreview', ['$timeout', function ($timeout) {
      return {
        restrict: 'E',
        replace: true,
        scope: {
          html: '=',
          width: '=',
          class: '='
        },
        template: `
                <iframe ng-class="class"></iframe>
            `,
        link(scope, iframe, attrs) {
          scope.insertHtml = function (html) {
            iframe[0].contentWindow.document.open();
            iframe[0].contentWindow.document.write(html);
            iframe[0].contentWindow.document.close();
          }

          scope.setWidth = function (width) {
            iframe[0].width = width;
          }

          $timeout(function () {
            scope.$watch(function () {
              return scope.html
            }, scope.insertHtml)

            scope.$watch(function () {
              return scope.width
            }, scope.setWidth)
          })

        }
      }
    }])

})(angular);

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('templateBuilderUtils', templateBuilderUtils);

  /** @ngInject */
  function templateBuilderUtils($window, $sce, $http, $rootScope, $translate, templateBuilderConfig, $resource, sessionService, $mdToast, $filter) {

    var service = {
      /**
       * Convert string from snake to camel
       * @param str
       * @returns {*}
       */
      snakeToCamel: function (str) {
        if (typeof str !== 'string') {
          return str;
        }
        return str.replace(/_([a-z])/gi, function (m, w) {
          return "" + w.toUpperCase();
        });
      },
      /**
       * Convert camel to snake
       * @param str
       * @returns {*}
       */
      camelToSnake: function (str) {
        if (typeof str !== 'string') {
          return str;
        }
        return str.replace(/([A-Z])/g, function (m, w) {
          return "_" + w.toLowerCase();
        });
      },
      /**
       * Generate random id
       * @param prefix
       * @returns {string}
       */
      uid: function (prefix) {
        return (prefix || 'id') + (new Date().getTime()) + "RAND" + (Math.ceil(Math.random() * 100000));
      },
      /**
       * https://gist.github.com/aaronmccall/9751450
       * @param list
       * @param props
       * @returns {*}
       */
      findWhere: function (list, props) {
        var idx = 0;
        var len = list.length;
        var match = false;
        var item, item_k, item_v, prop_k, prop_val;
        for (; idx < len; idx++) {
          item = list[idx];
          for (prop_k in props) {
            // If props doesn't own the property, skip it.
            if (!props.hasOwnProperty(prop_k)) {
              continue;
            }
            // If item doesn't have the property, no match;
            if (!item.hasOwnProperty(prop_k)) {
              match = false;
              break;
            }
            if (props[prop_k] === item[prop_k]) {
              // We have a match…so far.
              match = true;
            } else {
              // No match.
              match = false;
              // Don't compare more properties.
              break;
            }
          }
          // We've iterated all of props' properties, and we still match!
          // Return that item!
          if (match) {
            return item;
          }
        }
        // No matches
        return null;
      },
      /**
       * @param email
       * @returns {string|*|Object|string|string}
       */
      createEmail: function (email, currentContent) {
        if (email.header) {
          var fullEmail = email.header.elements;
          fullEmail = fullEmail.concat(email.elements);
        } else {
          var fullEmail = email.elements;
        }
        if (email.footer) {
          fullEmail = fullEmail.concat(email.footer.elements);
        }
        email = email || {}; // I know, is ugly, but is supported in es5
        let compileMjmlObject = {
          tagName: 'mjml',
          children: [{
            tagName: 'mj-head',
            children: [
              {
                tagName: 'mj-title',
                content: ''
              },
              {
                tagName: 'mj-style',
                attributes: {},
                content: `a {
                            color: rgb(3,155,229);
                          }
                          sup {
                            line-height: normal;
                          }
                          h1,h2,h3,h4,h5 {
                            line-height:1;
                          }
                @media all and (max-width: 480px) {
                    .img-td img,
                    .img-td td{
                      width: 100% !important
                    }
          .mj-column-per-10,
          .mj-column-per-20,
          .mj-column-per-30,
          .mj-column-per-40,
          .mj-column-per-50,
          .mj-column-per-60,
          .mj-column-per-70,
          .mj-column-per-80,
          .mj-column-per-90 {
					    width: 100% !important;
					    max-width: 100% !important;
					}
          .image-text-container {
            padding-left:20px !important;
            padding-right:20px !important;
          }
          .image-text-container.left,
          .image-text-container.right {
            padding-top:20px !important;

          }

                }`
              }
            ]
          },
          {
            tagName: 'mj-body',
            attributes: {},
            children: [{
              tagName: 'mj-container',
              attributes: {
                'background-color': email.emailSettings.options.backgroundColor
              },
              children: [{
                tagName: 'mj-wrapper',
                attributes: {
                  'padding-top': email.emailSettings.options.paddingTop,
                  'padding-right': email.emailSettings.options.paddingRight,
                  'padding-bottom': email.emailSettings.options.paddingBottom,
                  'padding-left': email.emailSettings.options.paddingLeft,
                },
                children: fullEmail.map(element => {
                  switch (element.type) {
                    case 'title':
                      var returnData = {
                        tagName: 'mj-section',
                        attributes: {
                          'full-width': 'full-width',
                          'background-color': element.options.backgroundColor,
                          'padding': `${element.options.padding[0]} ${element.options.padding[1]} ${element.options.padding[2]} ${element.options.padding[3]}`
                        },
                        children: [{
                          tagName: 'mj-column',
                          attributes: {
                            'width': '100%'
                          },
                          children: []
                        }]
                      }
                      if (element.options.title) {
                        returnData.children[0].children.push({
                          tagName: 'mj-text',
                          attributes: {
                            'color': element.options.color ? element.options.color : '#000000',
                            'align': element.options.align,
                            'padding': 0,
                            'font-family': element.options.font.family,
                            'line-height': 0
                          },
                          content: `<h1 style="font-weight: ${element.options.font.weight};font-size: 28px;line-height: 1.3;margin: 0;">${element.options.title}</h1>`
                        })
                      }

                      if (element.options.subTitle) {
                        var mTop = element.options.title ? '30px' : '0px';
                        returnData.children[0].children.push({
                          tagName: 'mj-text',
                          attributes: {
                            'color': element.options.color ? element.options.color : '#000000',
                            'align': element.options.align,
                            'padding': 0,
                            'font-family': element.options.font.family
                          },
                          content: `<h4 style="font-weight: ${element.options.font.weight};margin-bottom: 0;margin-top: ${mTop};font-size: 18px;line-height:1.3;">${element.options.subTitle}</h4>`
                        })
                      }
                      return returnData
                    case 'button':
                      return {
                        tagName: 'mj-section',
                        attributes: {
                          'full-width': 'full-width',
                          'background-color': element.options.backgroundColor,
                          'padding': 0
                        },
                        children: [{
                          tagName: 'mj-column',
                          attributes: {
                            'width': '100%'
                          },
                          children: [{
                            tagName: 'mj-button',
                            attributes: {
                              'align': element.options.align,
                              'border': `${element.options.border.size}px ${element.options.border.style} ${element.options.border.color}`,
                              'border-radius': `${element.options.border.radius}px`,
                              'background-color': element.options.buttonBackgroundColor,
                              'font-family': `${element.options.font.family}`,
                              'color': element.options.font.color,
                              'font-size': `${element.options.font.size}px`,
                              'font-weight': element.options.font.weight,
                              'width': Boolean(element.options.fullWidth) ? '100%' : 'auto',
                              'padding': `${element.options.margin[0]} ${element.options.margin[1]} ${element.options.margin[2]} ${element.options.margin[3]}`,
                              'inner-padding': `${element.options.padding[0]} ${element.options.padding[1]} ${element.options.padding[2]} ${element.options.padding[3]}`,
                              'href': element.options.url
                            },
                            content: element.options.buttonText
                          }]
                        }]
                      }
                    case 'text':
                      if (element.options.text === null || !angular.isDefined(element.options.text)) {
                        element.options.text = '';
                      }
                      return {
                        tagName: 'mj-section',
                        attributes: {
                          'full-width': 'full-width',
                          'background-color': element.options.backgroundColor,
                          'padding': `${element.options.padding[0]} ${element.options.padding[1]} ${element.options.padding[2]} ${element.options.padding[3]}`
                        },
                        children: [{
                          tagName: 'mj-column',
                          children: [{
                            tagName: 'mj-text',
                            attributes: {
                              'font-size': '14px',
                              'color': element.options.color ? element.options.color : '#000000',
                              'line-height': '1.4',
                              'padding': 0,
                              'font-family': element.options.font.family
                            },
                            content: element.options.text
                          }]
                        }]
                      }
                    case 'divider':
                      return {
                        tagName: 'mj-section',
                        attributes: {
                          'full-width': 'full-width',
                          'padding': 0
                        },
                        children: [{
                          tagName: 'mj-column',
                          children: [{
                            tagName: 'mj-divider',
                            attributes: {
                              'padding': `${element.options.padding[0]} ${element.options.padding[1]} ${element.options.padding[2]} ${element.options.padding[3]}`,
                              'container-background-color': element.options.backgroundColor,
                              'border-width': `${element.options.border.size}px`,
                              'border-style': `${element.options.border.style}`,
                              'border-color': `${element.options.border.color}`
                            }
                          }]
                        }]
                      }
                    case 'header':
                      var returnData = {
                        tagName: 'mj-section',
                        attributes: {
                          'full-width': 'full-width',
                          'background-color': element.options.backgroundColor,
                          'padding': `${element.options.padding[0]} ${element.options.padding[1]} ${element.options.padding[2]} ${element.options.padding[3]}`
                        },
                        children: [{
                          tagName: 'mj-column',
                          children: [{
                            tagName: 'mj-image',
                            attributes: {
                              'align': element.options.align,
                              'src': element.options.imageSingle1.url,
                              'alt': element.options.imageSingle1.fields.title ? element.options.imageSingle1.fields.title : element.options.imageSingle1.fields.filename,
                              'width': element.options.width,
                              'padding': 0,
                              'css-class': 'img-td',
                              'href': null
                            }
                          }]
                        }]
                      }
                      for (var i = 1; i <= 1; i++) {
                        var linkUrl = '';
                        var linkText = '';
                        var mediaCaption = '';
                        if (!angular.isUndefined(element.options.linkTo) && element.options.linkTo.type != 'none') {
                          if (element.options.linkTo.type == 'link' || element.options.linkTo.type == 'email') {
                            if (element.options.linkTo.type == 'email') {
                              linkUrl = 'mailto:' + element.options.linkTo.link;
                            } else {
                              linkUrl = element.options.linkTo.link;
                            }
                          } else if (element.options.linkTo.type == 'mediacenter') {
                            linkUrl = sessionService.site_operative.mediacenterUrl + '#id=' + element.options['imageSingle' + i].id_media;
                          } else if (element.options.linkTo.type == 'original') {
                            linkUrl = element.options['imageSingle' + i].cropformats.original;
                          }

                        }
                        if (linkUrl) {
                          returnData.children[(i - 1)].children[0].attributes.href = linkUrl;
                        }
                      }

                      return returnData;
                    case 'footerImage':
                      var returnData = {
                        tagName: 'mj-section',
                        attributes: {
                          'full-width': 'full-width',
                          'background-color': element.options.backgroundColor,
                          'padding': `${element.options.padding[0]} ${element.options.padding[1]} ${element.options.padding[2]} ${element.options.padding[3]}`
                        },
                        children: [{
                          tagName: 'mj-column',
                          children: [{
                            tagName: 'mj-image',
                            attributes: {
                              'align': element.options.align,
                              'src': element.options.imageSingle1.url,
                              'alt': element.options.imageSingle1.fields.title ? element.options.imageSingle1.fields.title : element.options.imageSingle1.fields.filename,
                              'width': element.options.width,
                              'padding': 0,
                              'css-class': 'img-td',
                              'href': null
                            }
                          }]
                        }]
                      }
                      for (var i = 1; i <= 1; i++) {
                        var linkUrl = '';
                        var linkText = '';
                        var mediaCaption = '';
                        if (!angular.isUndefined(element.options.linkTo) && element.options.linkTo.type != 'none') {
                          if (element.options.linkTo.type == 'link' || element.options.linkTo.type == 'email') {
                            if (element.options.linkTo.type == 'email') {
                              linkUrl = 'mailto:' + element.options.linkTo.link;
                            } else {
                              linkUrl = element.options.linkTo.link;
                            }
                          } else if (element.options.linkTo.type == 'mediacenter') {
                            linkUrl = sessionService.site_operative.mediacenterUrl + '#id=' + element.options['imageSingle' + i].id_media;
                          } else if (element.options.linkTo.type == 'original') {
                            linkUrl = element.options['imageSingle' + i].cropformats.original;
                          }

                        }
                        if (linkUrl) {
                          returnData.children[(i - 1)].children[0].attributes.href = linkUrl;
                        }
                      }

                      return returnData;
                    case 'footerLegal':
                      var textAlign = '';
                      if (!angular.isUndefined(element.options.align)) {
                        textAlign = element.options.align;
                      } else {
                        textAlign = 'left';
                      }
                      return {
                        tagName: 'mj-section',
                        attributes: {
                          'full-width': 'full-width',
                          'background-color': element.options.backgroundColor,
                          'padding': `${element.options.padding[0]} ${element.options.padding[1]} ${element.options.padding[2]} ${element.options.padding[3]}`
                        },
                        children: [{
                          tagName: 'mj-column',
                          attributes: {
                            'width': '100%'
                          },
                          children: [
                            {
                              tagName: 'mj-text',
                              attributes: {
                                'font-size': element.options.font.size ? `${element.options.font.size}px` : '13px',
                                'color': element.options.font.color ? element.options.font.color : '#777777',
                                'line-height': '20px',
                                'padding': 0,
                                'font-family': element.options.font.family,
                                'align': textAlign
                              },
                              content: element.options.textAddress && element.options.textAddress != null ? element.options.textAddress : ''
                            },
                            {
                              tagName: 'mj-text',
                              attributes: {
                                'font-size': element.options.font.size ? `${element.options.font.size}px` : '13px',
                                'color': element.options.font.color ? element.options.font.color : '#777777',
                                'line-height': '20px',
                                'padding': 0,
                                'font-family': element.options.font.family,
                                'align': textAlign
                              },
                              content: element.options.textIntended && element.options.textIntended != null ? element.options.textIntended : ''
                            },
                            {
                              tagName: 'mj-text',
                              attributes: {
                                'font-weight': element.options.font.weight ? element.options.font.weight : 'normal',
                                'font-size': element.options.font.size ? `${element.options.font.size}px` : '13px',
                                'color': element.options.font.color ? element.options.font.color : '#777777',
                                'line-height': '20px',
                                'padding': 0,
                                'font-family': element.options.font.family,
                                'align': textAlign
                              },
                              content: element.options.textUnsubscribe && element.options.textUnsubscribe != null ?
                                `<a href="${sessionService.site_operative.mailingUnsubscriptionUrl}#%%USER_TOKEN%%" 
                                      color="${element.options.font.color ? element.options.font.color : '#777777'}" 
                                      style="color: ${element.options.font.color ? element.options.font.color : '#777777'};text-decoration:none;">
                                    ${element.options.textUnsubscribe}
                                  </a>` : "" + element.options.textUnsubscribe && element.options.textManage && element.options.textUnsubscribe != null && element.options.textManage != null ?
                                  `${(element.options.textManage && element.options.textManage != null) ? '<span> / </span>' : ''}
                                  <a  href="${sessionService.site_operative.mailingManageSubscriptionsUrl}#%%USER_TOKEN%%" 
                                      color="${element.options.font.color ? element.options.font.color : '#777777'}" 
                                      style="color: ${element.options.font.color ? element.options.font.color : '#777777'};text-decoration:none;">
                                    ${element.options.textManage}
                                  </a>` : ""
                            }]
                        },
                        ]

                      }
                    case 'image':
                      var fontWeight = '';
                      var fontFamily = '';
                      if (!angular.isUndefined(element.options.font)) {

                        if (!angular.isUndefined(element.options.font.weight)) {
                          fontWeight = element.options.font.weight;
                        } else {
                          fontWeight = 'normal';
                        }

                        if (!angular.isUndefined(element.options.font.family)) {
                          fontFamily = element.options.font.family;
                        } else {
                          fontFamily = 'Arial, Helvetica, sans-serif';
                        }
                      } else {
                        fontWeight = 'normal';
                        fontFamily = 'Arial, Helvetica, sans-serif';
                      }
                      var returnData = {
                        tagName: 'mj-section',
                        attributes: {
                          'full-width': 'full-width',
                          'background-color': element.options.backgroundColor,
                          'padding': `${element.options.padding[0]} ${element.options.padding[1]} ${element.options.padding[2]} ${element.options.padding[3]}`
                        },
                        children: [{
                          tagName: 'mj-column',
                          children: [{
                            tagName: 'mj-image',
                            attributes: {
                              'align': element.options.align,
                              'src': element.options.imageSingle1.url,
                              'alt': element.options.imageSingle1.fields.title ? element.options.imageSingle1.fields.title : element.options.imageSingle1.fields.filename,
                              'width': element.options.width,
                              'padding': 0,
                              'css-class': 'img-td',
                              'href': null
                            }
                          }]
                        }]
                      };
                      for (var i = 1; i <= 1; i++) {
                        var linkUrl = '';
                        var mediaCaption = '';
                        if (!angular.isUndefined(element.options.linkTo) && element.options.linkTo.type != 'none') {
                          if (element.options.linkTo.type == 'link' || element.options.linkTo.type == 'email') {
                            if (element.options.linkTo.type == 'email') {
                              linkUrl = 'mailto:' + element.options.linkTo.link;
                            } else {
                              linkUrl = element.options.linkTo.link;
                            }
                          } else if (element.options.linkTo.type == 'mediacenter') {
                            linkUrl = sessionService.site_operative.mediacenterUrl + '#id=' + element.options['imageSingle' + i].id_media;
                          } else if (element.options.linkTo.type == 'original') {
                            linkUrl = element.options['imageSingle' + i].cropformats.original;
                          }

                        }
                        var preFix = '';
                        var sufFix = '';
                        if (element.options.mediaCaption.prefix) {
                          preFix = element.options.mediaCaption.prefix + ' ';
                        } else {
                          preFix = '';
                        }
                        if (element.options.mediaCaption.suffix) {
                          sufFix = ' ' + element.options.mediaCaption.suffix;
                        } else {
                          sufFix = '';
                        }
                        if (!angular.isUndefined(element.options.mediaCaption) && element.options.mediaCaption.type != 'none') {
                          if (element.options.mediaCaption.type == 'custom') {

                            mediaCaption = (preFix ? preFix : "") + (element.options.mediaCaption['custom_' + i] ? element.options.mediaCaption['custom_' + i] : "") + (sufFix ? sufFix : "");

                          } else if (element.options.mediaCaption.type == 'caption_photographer') {

                            mediaCaption = element.options['imageSingle' + i].fields['photographer'] || element.options['imageSingle' + i].fields['caption'] ? (element.options['imageSingle' + i].fields['caption'] ? element.options['imageSingle' + i].fields['caption'] : "") + '<br>' + (preFix ? preFix : "") + (element.options['imageSingle' + i].fields['photographer'] ? element.options['imageSingle' + i].fields['photographer'] : "") + (sufFix ? sufFix : "") : "";

                          } else if (element.options.mediaCaption.type == 'caption_owner') {

                            mediaCaption = element.options['imageSingle' + i].fields['owner'] || element.options['imageSingle' + i].fields['caption'] ? (element.options['imageSingle' + i].fields['caption'] ? element.options['imageSingle' + i].fields['caption'] : "") + '<br>' + (preFix ? preFix : "") + (element.options['imageSingle' + i].fields['owner'] ? element.options['imageSingle' + i].fields['owner'] : "") + (sufFix ? sufFix : "") : "";

                          } else if (element.options.mediaCaption.type == 'title_photographer') {

                            mediaCaption = element.options['imageSingle' + i].fields['photographer'] || element.options['imageSingle' + i].fields['title'] ? (element.options['imageSingle' + i].fields['title'] ? element.options['imageSingle' + i].fields['title'] : "") + '<br>' + (preFix ? preFix : "") + (element.options['imageSingle' + i].fields['photographer'] ? element.options['imageSingle' + i].fields['photographer'] : "") + (sufFix ? sufFix : "") : "";

                          } else if (element.options.mediaCaption.type == 'photographer') {

                            mediaCaption = element.options['imageSingle' + i].fields['photographer'] ? (preFix ? preFix : "") + element.options['imageSingle' + i].fields['photographer'] + (sufFix ? sufFix : "") : "";

                          } else {

                            mediaCaption = element.options['imageSingle' + i].fields[element.options.mediaCaption.type] ? (preFix ? preFix : "") + element.options['imageSingle' + i].fields[element.options.mediaCaption.type] + (sufFix ? sufFix : "") : "";

                          }
                        }
                        if (linkUrl) {
                          returnData.children[(i - 1)].children[0].attributes.href = linkUrl;
                          if (element.options.linkTo.text) {
                            returnData.children[(i - 1)].children.push({
                              tagName: 'mj-button',
                              attributes: {
                                'align': element.options.align,
                                'background-color': 'transparent',
                                'border': '0px solid #FFFFFF',
                                'border-radius': '0px',
                                'color': element.options.color != '#888888' ? element.options.color : '#039be5',
                                'font-family': fontFamily,
                                'font-size': '13px',
                                'font-weight': fontWeight,
                                'inner-padding': element.options.paddingDownload ? `${element.options.paddingDownload[0]} ${element.options.paddingDownload[1]} ${element.options.paddingDownload[2]} ${element.options.paddingDownload[3]}` : '10px 10px 5px',
                                'padding': '0 0 0 0',
                                'width': 'auto',
                                'href': linkUrl
                              },
                              content: element.options.linkTo.text
                            });
                          }
                        }
                        if (mediaCaption) {
                          returnData.children[(i - 1)].children.push({
                            tagName: 'mj-text',
                            attributes: {
                              'align': element.options.align,
                              'font-size': '13px',
                              'color': element.options.color ? element.options.color : '#000000',
                              'line-height': '20px',
                              'padding': element.options.paddingCaption ? `${element.options.paddingCaption[0]} ${element.options.paddingCaption[1]} ${element.options.paddingCaption[2]} ${element.options.paddingCaption[3]}` : '5px 10px',
                              'font-family': fontFamily,
                              'font-weight': fontWeight
                            },
                            content: `${mediaCaption}`
                          });
                        }
                      }
                      return returnData;
                    case 'imageTextRight':

                      if (element.options.text === null || !angular.isDefined(element.options.text)) {
                        element.options.text = '';
                      }
                      if (angular.isUndefined(element.options.padding1)) {
                        element.options.padding1 = ["0px", "0px", "0px", "20px"]
                      }
                      var bgColor1 = '';
                      if (!angular.isUndefined(element.options.backgroundColor1)) {
                        bgColor1 = 'background-color: ' + element.options.backgroundColor1 + ';';
                      }
                      var fontWeight = '';
                      var fontFamily = '';
                      if (!angular.isUndefined(element.options.font)) {

                        if (!angular.isUndefined(element.options.font.weight)) {
                          fontWeight = element.options.font.weight;
                        } else {
                          fontWeight = 'normal';
                        }

                        if (!angular.isUndefined(element.options.font.family)) {
                          fontFamily = element.options.font.family;
                        } else {
                          fontFamily = 'Arial, Helvetica, sans-serif';
                        }
                      } else {
                        fontWeight = 'normal';
                        fontFamily = 'Arial, Helvetica, sans-serif';
                      }
                      var textAlign = '';
                      if (!angular.isUndefined(element.options.align)) {
                        textAlign = element.options.align;
                      } else {
                        textAlign = 'left';
                      }

                      var returnData = {
                        tagName: 'mj-section',
                        attributes: {
                          'full-width': 'full-width',
                          'background-color': element.options.backgroundColor,
                          'padding': `${element.options.padding[0]} ${element.options.padding[1]} ${element.options.padding[2]} ${element.options.padding[3]}`,
                          'css-class': 'img-td'
                        },
                        children: [{
                          tagName: 'mj-group',
                          attributes: {
                            'background-color': element.options.backgroundColor1,
                            'css-class': ' text-right'
                          },
                          children: [{
                            tagName: 'mj-column',

                            children: [{
                              tagName: 'mj-image',
                              attributes: {
                                'align': textAlign ? textAlign : 'left',
                                'src': element.options.imageSingle1.url,
                                'alt': element.options.imageSingle1.fields.title ? element.options.imageSingle1.fields.title : element.options.imageSingle1.fields.filename,
                                'padding': 0,
                                'width': element.options.width,
                                'href': null
                              }
                            }]
                          },
                          {
                            tagName: 'mj-column',
                            children: [{
                              tagName: 'mj-text',
                              attributes: {
                                'align': textAlign ? textAlign : 'left',
                                'font-size': '13px',
                                'color': element.options.color ? element.options.color : '#000000',
                                'line-height': '20px',
                                'padding': '0 ',
                                'font-family': fontFamily,
                                // 'font-family': element.options.font.family
                              },
                              content: '<div class="image-text-container right" style="padding:' + `${element.options.padding1[0]} ${element.options.padding1[1]} ${element.options.padding1[2]} ${element.options.padding1[3]}` + '">' + element.options.text + '</div>'
                            }]
                          }
                          ]
                        }]
                      }
                      for (var i = 1; i <= 1; i++) {
                        var linkUrl = '';
                        var mediaCaption = '';
                        if (!angular.isUndefined(element.options.linkTo) && element.options.linkTo.type != 'none') {
                          if (element.options.linkTo.type == 'link' || element.options.linkTo.type == 'email') {
                            if (element.options.linkTo.type == 'email') {
                              linkUrl = 'mailto:' + element.options.linkTo.link;
                            } else {
                              linkUrl = element.options.linkTo.link;
                            }
                          } else if (element.options.linkTo.type == 'mediacenter') {
                            linkUrl = sessionService.site_operative.mediacenterUrl + '#id=' + element.options['imageSingle' + i].id_media;
                          } else if (element.options.linkTo.type == 'original') {
                            linkUrl = element.options['imageSingle' + i].cropformats.original;
                          }

                        }
                        var preFix = '';
                        var sufFix = '';
                        if (element.options.mediaCaption.prefix) {
                          preFix = element.options.mediaCaption.prefix + ' ';
                        } else {
                          preFix = '';
                        }
                        if (element.options.mediaCaption.suffix) {
                          sufFix = ' ' + element.options.mediaCaption.suffix;
                        } else {
                          sufFix = '';
                        }
                        if (!angular.isUndefined(element.options.mediaCaption) && element.options.mediaCaption.type != 'none') {
                          if (element.options.mediaCaption.type == 'custom') {

                            mediaCaption = (preFix ? preFix : "") + (element.options.mediaCaption['custom_' + i] ? element.options.mediaCaption['custom_' + i] : "") + (sufFix ? sufFix : "");

                          } else if (element.options.mediaCaption.type == 'caption_photographer') {

                            mediaCaption = element.options['imageSingle' + i].fields['photographer'] || element.options['imageSingle' + i].fields['caption'] ? (element.options['imageSingle' + i].fields['caption'] ? element.options['imageSingle' + i].fields['caption'] : "") + '<br>' + (preFix ? preFix : "") + (element.options['imageSingle' + i].fields['photographer'] ? element.options['imageSingle' + i].fields['photographer'] : "") + (sufFix ? sufFix : "") : "";

                          } else if (element.options.mediaCaption.type == 'caption_owner') {

                            mediaCaption = element.options['imageSingle' + i].fields['owner'] || element.options['imageSingle' + i].fields['caption'] ? (element.options['imageSingle' + i].fields['caption'] ? element.options['imageSingle' + i].fields['caption'] : "") + '<br>' + (preFix ? preFix : "") + (element.options['imageSingle' + i].fields['owner'] ? element.options['imageSingle' + i].fields['owner'] : "") + (sufFix ? sufFix : "") : "";

                          } else if (element.options.mediaCaption.type == 'title_photographer') {

                            mediaCaption = element.options['imageSingle' + i].fields['photographer'] || element.options['imageSingle' + i].fields['title'] ? (element.options['imageSingle' + i].fields['title'] ? element.options['imageSingle' + i].fields['title'] : "") + '<br>' + (preFix ? preFix : "") + (element.options['imageSingle' + i].fields['photographer'] ? element.options['imageSingle' + i].fields['photographer'] : "") + (sufFix ? sufFix : "") : "";

                          } else if (element.options.mediaCaption.type == 'photographer') {

                            mediaCaption = element.options['imageSingle' + i].fields['photographer'] ? (preFix ? preFix : "") + element.options['imageSingle' + i].fields['photographer'] + (sufFix ? sufFix : "") : "";

                          } else {

                            mediaCaption = element.options['imageSingle' + i].fields[element.options.mediaCaption.type] ? (preFix ? preFix : "") + element.options['imageSingle' + i].fields[element.options.mediaCaption.type] + (sufFix ? sufFix : "") : "";

                          }
                        }
                        if (linkUrl) {
                          returnData.children[(i - 1)].children[0].children[0].attributes.href = linkUrl;
                          if (element.options.linkTo.text) {
                            returnData.children[(i - 1)].children[0].children.push({
                              tagName: 'mj-button',
                              attributes: {
                                'align': textAlign ? textAlign : 'left',
                                'background-color': 'transparent',
                                'border': '0px solid #FFFFFF',
                                'border-radius': '0px',
                                'color': element.options.color != '#888888' ? element.options.color : '#039be5',
                                'font-family': fontFamily,
                                'font-size': '13px',
                                'font-weight': fontWeight,
                                'inner-padding': element.options.paddingDownload ? `${element.options.paddingDownload[0]} ${element.options.paddingDownload[1]} ${element.options.paddingDownload[2]} ${element.options.paddingDownload[3]}` : '5px 0px 0px 0px',
                                'padding': '0 0 0 0',
                                'width': 'auto',
                                'href': linkUrl
                              },
                              content: element.options.linkTo.text
                            });
                          }
                        }
                        if (mediaCaption) {
                          returnData.children[(i - 1)].children[0].children.push({
                            tagName: 'mj-text',
                            attributes: {
                              'align': textAlign ? textAlign : 'left',
                              'font-size': '12px',
                              'color': element.options.color ? element.options.color : '#888888',
                              'line-height': '20px',
                              'padding': element.options.paddingCaption ? `${element.options.paddingCaption[0]} ${element.options.paddingCaption[1]} ${element.options.paddingCaption[2]} ${element.options.paddingCaption[3]}` : '5px 0px 0px 0px',
                              'font-family': fontFamily,
                              'font-weight': fontWeight
                            },
                            content: `${mediaCaption}`
                          });
                        }
                      }
                      return returnData;
                    case 'imageTextLeft':
                      if (element.options.text === null || !angular.isDefined(element.options.text)) {
                        element.options.text = '';
                      }
                      if (angular.isUndefined(element.options.padding1)) {
                        element.options.padding1 = ["0px", "20px", "0px", "0px"]
                      }
                      var bgColor1 = '';
                      if (!angular.isUndefined(element.options.backgroundColor1)) {
                        bgColor1 = 'background-color: ' + element.options.backgroundColor1 + ';';
                      }
                      var fontWeight = '';
                      var fontFamily = '';
                      if (!angular.isUndefined(element.options.font)) {

                        if (!angular.isUndefined(element.options.font.weight)) {
                          fontWeight = element.options.font.weight;
                        } else {
                          fontWeight = 'normal';
                        }

                        if (!angular.isUndefined(element.options.font.family)) {
                          fontFamily = element.options.font.family;
                        } else {
                          fontFamily = 'Arial, Helvetica, sans-serif';
                        }
                      } else {
                        fontWeight = 'normal';
                        fontFamily = 'Arial, Helvetica, sans-serif';
                      }
                      var textAlign = '';
                      if (!angular.isUndefined(element.options.align)) {
                        textAlign = element.options.align;
                      } else {
                        textAlign = 'right';
                      }
                      var returnData = {
                        tagName: 'mj-section',
                        attributes: {
                          'full-width': 'full-width',
                          'background-color': element.options.backgroundColor,
                          'padding': `${element.options.padding[0]} ${element.options.padding[1]} ${element.options.padding[2]} ${element.options.padding[3]}`,
                          'css-class': 'img-td'
                        },
                        children: [{
                          tagName: 'mj-group',
                          attributes: {
                            'background-color': element.options.backgroundColor1,
                            'css-class': ' text-left',
                            'direction': 'rtl'
                          },
                          children: [{
                            tagName: 'mj-column',
                            children: [{
                              tagName: 'mj-image',
                              attributes: {
                                'align': 'left',
                                'src': element.options.imageSingle1.url,
                                'alt': element.options.imageSingle1.fields.title ? element.options.imageSingle1.fields.title : element.options.imageSingle1.fields.filename,
                                'padding': 0,
                                'width': element.options.width,
                                'href': null
                              }
                            }]
                          },
                          {
                            tagName: 'mj-column',
                            children: [{
                              tagName: 'mj-text',
                              attributes: {
                                'align': (!angular.isUndefined(element.options.align)) ? element.options.align : 'left',
                                'font-size': '13px',
                                'color': element.options.color ? element.options.color : '#000000',
                                'line-height': '20px',
                                'padding': '0 ',
                                'font-family': fontFamily
                                // 'font-family': element.options.font.family
                              },
                              content: '<div class="image-text-container left" style="padding:' + `${element.options.padding1[0]} ${element.options.padding1[1]} ${element.options.padding1[2]} ${element.options.padding1[3]}` + '">' + element.options.text + '</div>'
                            }]
                          }
                          ]
                        }]
                      }
                      for (var i = 1; i <= 1; i++) {
                        var linkUrl = '';
                        var mediaCaption = '';
                        if (!angular.isUndefined(element.options.linkTo) && element.options.linkTo.type != 'none') {
                          if (element.options.linkTo.type == 'link' || element.options.linkTo.type == 'email') {
                            if (element.options.linkTo.type == 'email') {
                              linkUrl = 'mailto:' + element.options.linkTo.link;
                            } else {
                              linkUrl = element.options.linkTo.link;
                            }
                          } else if (element.options.linkTo.type == 'mediacenter') {
                            linkUrl = sessionService.site_operative.mediacenterUrl + '#id=' + element.options['imageSingle' + i].id_media;
                          } else if (element.options.linkTo.type == 'original') {
                            linkUrl = element.options['imageSingle' + i].cropformats.original;
                          }

                        }
                        var preFix = '';
                        var sufFix = '';
                        if (element.options.mediaCaption.prefix) {
                          preFix = element.options.mediaCaption.prefix + ' ';
                        } else {
                          preFix = '';
                        }
                        if (element.options.mediaCaption.suffix) {
                          sufFix = ' ' + element.options.mediaCaption.suffix;
                        } else {
                          sufFix = '';
                        }
                        if (!angular.isUndefined(element.options.mediaCaption) && element.options.mediaCaption.type != 'none') {
                          if (element.options.mediaCaption.type == 'custom') {

                            mediaCaption = (preFix ? preFix : "") + (element.options.mediaCaption['custom_' + i] ? element.options.mediaCaption['custom_' + i] : "") + (sufFix ? sufFix : "");

                          } else if (element.options.mediaCaption.type == 'caption_photographer') {

                            mediaCaption = element.options['imageSingle' + i].fields['photographer'] || element.options['imageSingle' + i].fields['caption'] ? (element.options['imageSingle' + i].fields['caption'] ? element.options['imageSingle' + i].fields['caption'] : "") + '<br>' + (preFix ? preFix : "") + (element.options['imageSingle' + i].fields['photographer'] ? element.options['imageSingle' + i].fields['photographer'] : "") + (sufFix ? sufFix : "") : "";

                          } else if (element.options.mediaCaption.type == 'caption_owner') {

                            mediaCaption = element.options['imageSingle' + i].fields['owner'] || element.options['imageSingle' + i].fields['caption'] ? (element.options['imageSingle' + i].fields['caption'] ? element.options['imageSingle' + i].fields['caption'] : "") + '<br>' + (preFix ? preFix : "") + (element.options['imageSingle' + i].fields['owner'] ? element.options['imageSingle' + i].fields['owner'] : "") + (sufFix ? sufFix : "") : "";

                          } else if (element.options.mediaCaption.type == 'title_photographer') {

                            mediaCaption = element.options['imageSingle' + i].fields['photographer'] || element.options['imageSingle' + i].fields['title'] ? (element.options['imageSingle' + i].fields['title'] ? element.options['imageSingle' + i].fields['title'] : "") + '<br>' + (preFix ? preFix : "") + (element.options['imageSingle' + i].fields['photographer'] ? element.options['imageSingle' + i].fields['photographer'] : "") + (sufFix ? sufFix : "") : "";

                          } else if (element.options.mediaCaption.type == 'photographer') {

                            mediaCaption = element.options['imageSingle' + i].fields['photographer'] ? (preFix ? preFix : "") + element.options['imageSingle' + i].fields['photographer'] + (sufFix ? sufFix : "") : "";

                          } else {

                            mediaCaption = element.options['imageSingle' + i].fields[element.options.mediaCaption.type] ? (preFix ? preFix : "") + element.options['imageSingle' + i].fields[element.options.mediaCaption.type] + (sufFix ? sufFix : "") : "";

                          }
                        }
                        if (linkUrl) {
                          // El enlace debe ir en el mj-image (columna 0), no en el mj-text
                          // (columna 1): mj-text no admite href y rompe la compilación MJML.
                          // Alineado con imageTextRight. La imagen está en children[0]
                          // aunque el rtl la muestre a la derecha.
                          returnData.children[(i - 1)].children[0].children[0].attributes.href = linkUrl;
                          if (element.options.linkTo.text) {
                            returnData.children[(i - 1)].children[0].children.push({
                              tagName: 'mj-button',
                              attributes: {
                                'align': textAlign ? textAlign : 'right',
                                'background-color': 'transparent',
                                'border': '0px solid #FFFFFF',
                                'border-radius': '0px',
                                'color': element.options.color != '#888888' ? element.options.color : '#039be5',
                                'font-family': fontFamily,
                                'font-size': '13px',
                                'font-weight': fontWeight,
                                'inner-padding': element.options.paddingDownload ? `${element.options.paddingDownload[0]} ${element.options.paddingDownload[1]} ${element.options.paddingDownload[2]} ${element.options.paddingDownload[3]}` : '5px 0px 0px 0px',
                                'padding': '0 0 0 0',
                                'width': 'auto',
                                'href': linkUrl
                              },
                              content: element.options.linkTo.text
                            });
                          }
                        }
                        if (mediaCaption) {
                          // Caption bajo la imagen (columna 0), como en imageTextRight.
                          returnData.children[(i - 1)].children[0].children.push({
                            tagName: 'mj-text',
                            attributes: {
                              'align': textAlign ? textAlign : 'right',
                              'font-size': '12px',
                              'color': element.options.color ? element.options.color : '#888888',
                              'line-height': '20px',
                              'padding': element.options.paddingCaption ? `${element.options.paddingCaption[0]} ${element.options.paddingCaption[1]} ${element.options.paddingCaption[2]} ${element.options.paddingCaption[3]}` : '5px 0px 0px 0px',
                              'font-family': fontFamily,
                              'font-weight': fontWeight
                            },
                            content: `${mediaCaption}`
                          });
                        }
                      }
                      return returnData;
                    case 'imageText2x2':
                      if (element.options.text1 === null || !angular.isDefined(element.options.text1)) {
                        element.options.text1 = '';
                      }

                      if (element.options.text2 === null || !angular.isDefined(element.options.text2)) {
                        element.options.text2 = '';
                      }
                      if (angular.isUndefined(element.options.padding1)) {
                        element.options.padding1 = ["15px", "0px", "0px", "0px"]
                      }
                      if (angular.isUndefined(element.options.padding2)) {
                        element.options.padding2 = ["15px", "0px", "0px", "0px"]
                      }
                      var bgColor1 = '';
                      if (!angular.isUndefined(element.options.backgroundColor1)) {
                        bgColor1 = 'background-color: ' + element.options.backgroundColor1 + ';';
                      }
                      var bgColor2 = '';
                      if (!angular.isUndefined(element.options.backgroundColor2)) {
                        bgColor2 = 'background-color: ' + element.options.backgroundColor2 + ';';
                      }

                      var fontWeight = '';
                      var fontFamily = '';
                      if (!angular.isUndefined(element.options.font)) {

                        if (!angular.isUndefined(element.options.font.weight)) {
                          fontWeight = element.options.font.weight;
                        } else {
                          fontWeight = 'normal';
                        }

                        if (!angular.isUndefined(element.options.font.family)) {
                          fontFamily = element.options.font.family;
                        } else {
                          fontFamily = 'Arial, Helvetica, sans-serif';
                        }
                      } else {
                        fontWeight = 'normal';
                        fontFamily = 'Arial, Helvetica, sans-serif';
                      }
                      var textAlign = '';
                      if (!angular.isUndefined(element.options.align)) {
                        textAlign = element.options.align;
                      } else {
                        textAlign = 'left';
                      }
                      var returnData = {
                        tagName: 'mj-section',
                        attributes: {
                          'full-width': 'full-width',
                          'background-color': element.options.backgroundColor,
                          'padding': `${element.options.padding[0]} ${element.options.padding[1]} ${element.options.padding[2]} ${element.options.padding[3]}`,
                          'css-class': 'img-td'
                        },
                        children: [{
                          tagName: 'mj-column',
                          attributes: {
                            'padding': '0 0 20px 0',
                          },
                          children: [{
                            tagName: 'mj-image',
                            attributes: {
                              'src': element.options.imageSingle1.url,
                              'alt': element.options.altTag1,
                              'padding': '0 10px 0 10px',
                              'width': element.options.width1,
                              'href': null
                            }
                          },
                          {
                            tagName: 'mj-text',
                            attributes: {
                              'align': textAlign ? textAlign : 'left',
                              'font-size': '13px',
                              'color': element.options.color ? element.options.color : '#000000',
                              'line-height': '20px',
                              'padding': '0 10px',
                              'font-family': fontFamily,
                              // 'font-family': element.options.font.family
                            },
                            content: '<div style="' + `${bgColor1}` + ' padding:' + `${element.options.padding1[0]} ${element.options.padding1[1]} ${element.options.padding1[2]} ${element.options.padding1[3]}` + '">' + element.options.text1 + '</div>'
                          }
                          ]
                        },
                        {
                          tagName: 'mj-column',
                          attributes: {
                            'padding': '0 0 20px 0',
                          },
                          children: [{
                            tagName: 'mj-image',
                            attributes: {
                              'src': element.options.imageSingle2.url,
                              'alt': element.options.altTag2,
                              'padding': '0 10px 0 10px',
                              'width': element.options.width2,
                              'href': null
                            }
                          },
                          {
                            tagName: 'mj-text',
                            attributes: {
                              'align': textAlign ? textAlign : 'left',
                              'font-size': '13px',
                              'color': element.options.color ? element.options.color : '#000000',
                              'line-height': '20px',
                              'padding': '0 10px',
                              'font-family': fontFamily,
                              // 'font-family': element.options.font.family
                            },
                            content: '<div style="' + `${bgColor2}` + ' padding:' + `${element.options.padding2[0]} ${element.options.padding2[1]} ${element.options.padding2[2]} ${element.options.padding2[3]}` + '">' + element.options.text2 + '</div>'
                          }
                          ]
                        }
                        ]
                      }
                      for (var i = 1; i <= 2; i++) {
                        var linkUrl = '';
                        var linkText = '';
                        var mediaCaption = '';
                        if (!angular.isUndefined(element.options.linkTo) && element.options.linkTo.type != 'none') {
                          if (element.options.linkTo.type == 'link' || element.options.linkTo.type == 'email') {
                            if (element.options.linkTo.type == 'email') {
                              linkUrl = 'mailto:' + element.options.linkTo.link;
                            } else {
                              linkUrl = element.options.linkTo.link;
                            }
                          } else if (element.options.linkTo.type == 'mediacenter') {
                            linkUrl = sessionService.site_operative.mediacenterUrl + '#id=' + element.options['imageSingle' + i].id_media;
                          } else if (element.options.linkTo.type == 'original') {
                            linkUrl = element.options['imageSingle' + i].cropformats.original;
                          } else if (element.options.linkTo.type == 'individual-link') {
                            if (!angular.isUndefined(element.options['imageSingle' + i].customLink)) {
                              linkUrl = element.options['imageSingle' + i].customLink;
                            } else {
                              linkUrl = element.options['imageSingle' + i].cropformats.original;
                            }
                          }

                        }
                        var preFix = '';
                        var sufFix = '';
                        if (element.options.mediaCaption.prefix) {
                          preFix = element.options.mediaCaption.prefix + ' ';
                        } else {
                          preFix = '';
                        }
                        if (element.options.mediaCaption.suffix) {
                          sufFix = ' ' + element.options.mediaCaption.suffix;
                        } else {
                          sufFix = '';
                        }
                        if (!angular.isUndefined(element.options.mediaCaption) && element.options.mediaCaption.type != 'none') {
                          if (element.options.mediaCaption.type == 'custom') {

                            mediaCaption = (preFix ? preFix : "") + (element.options.mediaCaption['custom_' + i] ? element.options.mediaCaption['custom_' + i] : "") + (sufFix ? sufFix : "");

                          } else if (element.options.mediaCaption.type == 'caption_photographer') {

                            mediaCaption = element.options['imageSingle' + i].fields['photographer'] || element.options['imageSingle' + i].fields['caption'] ? (element.options['imageSingle' + i].fields['caption'] ? element.options['imageSingle' + i].fields['caption'] : "") + '<br>' + (preFix ? preFix : "") + (element.options['imageSingle' + i].fields['photographer'] ? element.options['imageSingle' + i].fields['photographer'] : "") + (sufFix ? sufFix : "") : "";

                          } else if (element.options.mediaCaption.type == 'caption_owner') {

                            mediaCaption = element.options['imageSingle' + i].fields['owner'] || element.options['imageSingle' + i].fields['caption'] ? (element.options['imageSingle' + i].fields['caption'] ? element.options['imageSingle' + i].fields['caption'] : "") + '<br>' + (preFix ? preFix : "") + (element.options['imageSingle' + i].fields['owner'] ? element.options['imageSingle' + i].fields['owner'] : "") + (sufFix ? sufFix : "") : "";

                          } else if (element.options.mediaCaption.type == 'title_photographer') {

                            mediaCaption = element.options['imageSingle' + i].fields['photographer'] || element.options['imageSingle' + i].fields['title'] ? (element.options['imageSingle' + i].fields['title'] ? element.options['imageSingle' + i].fields['title'] : "") + '<br>' + (preFix ? preFix : "") + (element.options['imageSingle' + i].fields['photographer'] ? element.options['imageSingle' + i].fields['photographer'] : "") + (sufFix ? sufFix : "") : "";

                          } else if (element.options.mediaCaption.type == 'photographer') {

                            mediaCaption = element.options['imageSingle' + i].fields['photographer'] ? (preFix ? preFix : "") + element.options['imageSingle' + i].fields['photographer'] + (sufFix ? sufFix : "") : "";

                          } else {

                            mediaCaption = element.options['imageSingle' + i].fields[element.options.mediaCaption.type] ? (preFix ? preFix : "") + element.options['imageSingle' + i].fields[element.options.mediaCaption.type] + (sufFix ? sufFix : "") : "";

                          }
                        }
                        if (linkUrl) {
                          returnData.children[(i - 1)].children[0].attributes.href = linkUrl;
                          if (element.options.linkTo.text) {
                            var idx = (returnData.children[(i - 1)].children.length - 1);
                            var lastChild = angular.copy(returnData.children[(i - 1)].children[idx]);
                            returnData.children[(i - 1)].children.splice(idx, 1);
                            returnData.children[(i - 1)].children.push({
                              tagName: 'mj-button',
                              attributes: {
                                'align': textAlign ? textAlign : 'left',
                                'background-color': 'transparent',
                                'border': '0px solid #FFFFFF',
                                'border-radius': '0px',
                                'color': element.options.color != '#888888' ? element.options.color : '#039be5',
                                'font-family': fontFamily,
                                'font-size': '13px',
                                'font-weight': fontWeight,
                                'inner-padding': element.options.paddingDownload ? `${element.options.paddingDownload[0]} ${element.options.paddingDownload[1]} ${element.options.paddingDownload[2]} ${element.options.paddingDownload[3]}` : '5px 10px 0px 10px',
                                'padding': '0 0 0 0',
                                'width': 'auto',
                                'href': linkUrl
                              },
                              content: element.options.linkTo.text
                            });
                            returnData.children[(i - 1)].children.push(lastChild);
                          }
                        }
                        if (mediaCaption) {
                          var idx = (returnData.children[(i - 1)].children.length - 1);
                          var lastChild = angular.copy(returnData.children[(i - 1)].children[idx]);
                          returnData.children[(i - 1)].children.splice(idx, 1);
                          returnData.children[(i - 1)].children.push({
                            tagName: 'mj-text',
                            attributes: {
                              'align': textAlign ? textAlign : 'left',
                              'font-size': '12px',
                              'color': element.options.color ? element.options.color : '#888888',
                              'line-height': '20px',
                              'padding': element.options.paddingCaption ? `${element.options.paddingCaption[0]} ${element.options.paddingCaption[1]} ${element.options.paddingCaption[2]} ${element.options.paddingCaption[3]}` : '5px 10px 0px 10px',
                              'font-family': fontFamily,
                              'font-weight': fontWeight,
                            },
                            content: `${mediaCaption}`
                          });
                          returnData.children[(i - 1)].children.push(lastChild);
                        }
                      }


                      return returnData;
                    case 'imageText3x2':
                      if (element.options.text1 === null || !angular.isDefined(element.options.text1)) {
                        element.options.text1 = '';
                      }

                      if (element.options.text2 === null || !angular.isDefined(element.options.text2)) {
                        element.options.text2 = '';
                      }

                      if (element.options.text3 === null || !angular.isDefined(element.options.text3)) {
                        element.options.text3 = '';
                      }
                      if (angular.isUndefined(element.options.padding1)) {
                        element.options.padding1 = ["10px", "0px", "0px", "0px"]
                      }
                      if (angular.isUndefined(element.options.padding2)) {
                        element.options.padding2 = ["10px", "0px", "0px", "0px"]
                      }
                      if (angular.isUndefined(element.options.padding3)) {
                        element.options.padding3 = ["10px", "0px", "0px", "0px"]
                      }
                      var bgColor1 = '';
                      if (!angular.isUndefined(element.options.backgroundColor1)) {
                        bgColor1 = 'background-color: ' + element.options.backgroundColor1 + ';';
                      }
                      var bgColor2 = '';
                      if (!angular.isUndefined(element.options.backgroundColor2)) {
                        bgColor2 = 'background-color: ' + element.options.backgroundColor2 + ';';
                      }
                      var bgColor3 = '';
                      if (!angular.isUndefined(element.options.backgroundColor3)) {
                        bgColor3 = 'background-color: ' + element.options.backgroundColor3 + ';';
                      }

                      var fontWeight = '';
                      var fontFamily = '';
                      if (!angular.isUndefined(element.options.font)) {

                        if (!angular.isUndefined(element.options.font.weight)) {
                          fontWeight = element.options.font.weight;
                        } else {
                          fontWeight = 'normal';
                        }

                        if (!angular.isUndefined(element.options.font.family)) {
                          fontFamily = element.options.font.family;
                        } else {
                          fontFamily = 'Arial, Helvetica, sans-serif';
                        }
                      } else {
                        fontWeight = 'normal';
                        fontFamily = 'Arial, Helvetica, sans-serif';
                      }
                      var textAlign = '';
                      if (!angular.isUndefined(element.options.align)) {
                        textAlign = element.options.align;
                      } else {
                        textAlign = 'left';
                      }
                      var returnData = {
                        tagName: 'mj-section',
                        attributes: {
                          'full-width': 'full-width',
                          'background-color': element.options.backgroundColor,
                          'padding': `${element.options.padding[0]} ${element.options.padding[1]} ${element.options.padding[2]} ${element.options.padding[3]}`,
                          'css-class': 'img-td'
                        },
                        children: [{
                          tagName: 'mj-column',
                          attributes: {
                            'padding': '0 0 20px 0',
                          },
                          children: [{
                            tagName: 'mj-image',
                            attributes: {
                              'src': element.options.imageSingle1.url,
                              'alt': element.options.altTag1,
                              'padding': '0 10px 0 10px',
                              'width': element.options.width1,
                              'href': null
                            }
                          },
                          {
                            tagName: 'mj-text',
                            attributes: {
                              'align': textAlign ? textAlign : 'left',
                              'font-size': '13px',
                              'color': element.options.color ? element.options.color : '#000000',
                              'line-height': '20px',
                              'padding': '0 10px',
                              'font-family': fontFamily,
                              // 'font-family': element.options.font.family
                            },
                            content: '<div style="' + `${bgColor1}` + ' padding:' + `${element.options.padding1[0]} ${element.options.padding1[1]} ${element.options.padding1[2]} ${element.options.padding1[3]}` + '">' + element.options.text1 + '</div>'
                          }
                          ]
                        },
                        {
                          tagName: 'mj-column',
                          attributes: {
                            'padding': '0 0 20px 0',
                          },
                          children: [{
                            tagName: 'mj-image',
                            attributes: {
                              'src': element.options.imageSingle2.url,
                              'alt': element.options.altTag2,
                              'padding': '0 10px 0 10px',
                              'width': element.options.width2,
                              'href': null
                            }
                          },
                          {
                            tagName: 'mj-text',
                            attributes: {
                              'align': textAlign ? textAlign : 'left',
                              'font-size': '13px',
                              'color': element.options.color ? element.options.color : '#000000',
                              'line-height': '20px',
                              'padding': '0 10px',
                              'font-family': fontFamily,
                              // 'font-family': element.options.font.family
                            },
                            content: '<div style="' + `${bgColor2}` + ' padding:' + `${element.options.padding2[0]} ${element.options.padding2[1]} ${element.options.padding2[2]} ${element.options.padding2[3]}` + '">' + element.options.text2 + '</div>'
                          },
                          ]
                        },
                        {
                          tagName: 'mj-column',
                          attributes: {
                            'padding': '0 0 20px 0',
                          },
                          children: [{
                            tagName: 'mj-image',
                            attributes: {
                              'src': element.options.imageSingle3.url,
                              'alt': element.options.altTag3,
                              'padding': '0 10px 0 10px',
                              'width': element.options.width3,
                              'href': null
                            }
                          },
                          {
                            tagName: 'mj-text',
                            attributes: {
                              'align': textAlign ? textAlign : 'left',
                              'font-size': '13px',
                              'color': element.options.color ? element.options.color : '#000000',
                              'line-height': '20px',
                              'padding': '0 10px',
                              'font-family': fontFamily,
                              // 'font-family': element.options.font.family
                            },
                            content: '<div style="' + `${bgColor3}` + ' padding:' + `${element.options.padding3[0]} ${element.options.padding3[1]} ${element.options.padding3[2]} ${element.options.padding3[3]}` + '">' + element.options.text3 + '</div>'
                          },
                          ]
                        }
                        ]
                      }
                      for (var i = 1; i <= 3; i++) {
                        var linkUrl = '';
                        var linkText = '';
                        var mediaCaption = '';
                        if (!angular.isUndefined(element.options.linkTo) && element.options.linkTo.type != 'none') {
                          if (element.options.linkTo.type == 'link' || element.options.linkTo.type == 'email') {
                            if (element.options.linkTo.type == 'email') {
                              linkUrl = 'mailto:' + element.options.linkTo.link;
                            } else {
                              linkUrl = element.options.linkTo.link;
                            }
                          } else if (element.options.linkTo.type == 'mediacenter') {
                            linkUrl = sessionService.site_operative.mediacenterUrl + '#id=' + element.options['imageSingle' + i].id_media;
                          } else if (element.options.linkTo.type == 'original') {
                            linkUrl = element.options['imageSingle' + i].cropformats.original;
                          } else if (element.options.linkTo.type == 'individual-link') {
                            if (!angular.isUndefined(element.options['imageSingle' + i].customLink)) {
                              linkUrl = element.options['imageSingle' + i].customLink;
                            } else {
                              linkUrl = element.options['imageSingle' + i].cropformats.original;
                            }
                          }

                        }
                        var preFix = '';
                        var sufFix = '';
                        if (element.options.mediaCaption.prefix) {
                          preFix = element.options.mediaCaption.prefix + ' ';
                        } else {
                          preFix = '';
                        }
                        if (element.options.mediaCaption.suffix) {
                          sufFix = ' ' + element.options.mediaCaption.suffix;
                        } else {
                          sufFix = '';
                        }
                        if (!angular.isUndefined(element.options.mediaCaption) && element.options.mediaCaption.type != 'none') {
                          if (element.options.mediaCaption.type == 'custom') {

                            mediaCaption = (preFix ? preFix : "") + (element.options.mediaCaption['custom_' + i] ? element.options.mediaCaption['custom_' + i] : "") + (sufFix ? sufFix : "");

                          } else if (element.options.mediaCaption.type == 'caption_photographer') {

                            mediaCaption = element.options['imageSingle' + i].fields['photographer'] || element.options['imageSingle' + i].fields['caption'] ? (element.options['imageSingle' + i].fields['caption'] ? element.options['imageSingle' + i].fields['caption'] : "") + '<br>' + (preFix ? preFix : "") + (element.options['imageSingle' + i].fields['photographer'] ? element.options['imageSingle' + i].fields['photographer'] : "") + (sufFix ? sufFix : "") : "";

                          } else if (element.options.mediaCaption.type == 'caption_owner') {

                            mediaCaption = element.options['imageSingle' + i].fields['owner'] || element.options['imageSingle' + i].fields['caption'] ? (element.options['imageSingle' + i].fields['caption'] ? element.options['imageSingle' + i].fields['caption'] : "") + '<br>' + (preFix ? preFix : "") + (element.options['imageSingle' + i].fields['owner'] ? element.options['imageSingle' + i].fields['owner'] : "") + (sufFix ? sufFix : "") : "";

                          } else if (element.options.mediaCaption.type == 'title_photographer') {

                            mediaCaption = element.options['imageSingle' + i].fields['photographer'] || element.options['imageSingle' + i].fields['title'] ? (element.options['imageSingle' + i].fields['title'] ? element.options['imageSingle' + i].fields['title'] : "") + '<br>' + (preFix ? preFix : "") + (element.options['imageSingle' + i].fields['photographer'] ? element.options['imageSingle' + i].fields['photographer'] : "") + (sufFix ? sufFix : "") : "";

                          } else if (element.options.mediaCaption.type == 'photographer') {

                            mediaCaption = element.options['imageSingle' + i].fields['photographer'] ? (preFix ? preFix : "") + element.options['imageSingle' + i].fields['photographer'] + (sufFix ? sufFix : "") : "";

                          } else {

                            mediaCaption = element.options['imageSingle' + i].fields[element.options.mediaCaption.type] ? (preFix ? preFix : "") + element.options['imageSingle' + i].fields[element.options.mediaCaption.type] + (sufFix ? sufFix : "") : "";

                          }
                        }
                        if (linkUrl) {
                          returnData.children[(i - 1)].children[0].attributes.href = linkUrl;
                          if (element.options.linkTo.text) {
                            var idx = (returnData.children[(i - 1)].children.length - 1);
                            var lastChild = angular.copy(returnData.children[(i - 1)].children[idx]);
                            returnData.children[(i - 1)].children.splice(idx, 1);
                            returnData.children[(i - 1)].children.push({
                              tagName: 'mj-button',
                              attributes: {
                                'align': textAlign ? textAlign : 'left',
                                'background-color': 'transparent',
                                'border': '0px solid #FFFFFF',
                                'border-radius': '0px',
                                'color': element.options.color != '#888888' ? element.options.color : '#039be5',
                                'font-family': fontFamily,
                                'font-size': '13px',
                                'font-weight': fontWeight,
                                'inner-padding': element.options.paddingDownload ? `${element.options.paddingDownload[0]} ${element.options.paddingDownload[1]} ${element.options.paddingDownload[2]} ${element.options.paddingDownload[3]}` : '5px 10px 0px 10px',
                                'padding': '0 0 0 0',
                                'width': 'auto',
                                'href': linkUrl
                              },
                              content: element.options.linkTo.text
                            });
                            returnData.children[(i - 1)].children.push(lastChild);
                          }
                        }
                        if (mediaCaption) {
                          var idx = (returnData.children[(i - 1)].children.length - 1);
                          var lastChild = angular.copy(returnData.children[(i - 1)].children[idx]);
                          returnData.children[(i - 1)].children.splice(idx, 1);
                          returnData.children[(i - 1)].children.push({
                            tagName: 'mj-text',
                            attributes: {
                              'align': textAlign ? textAlign : 'left',
                              'font-size': '12px',
                              'color': element.options.color ? element.options.color : '#888888',
                              'line-height': '20px',
                              'padding': element.options.paddingCaption ? `${element.options.paddingCaption[0]} ${element.options.paddingCaption[1]} ${element.options.paddingCaption[2]} ${element.options.paddingCaption[3]}` : '5px 10px 0px 10px',
                              'font-family': fontFamily,
                              'font-weight': fontWeight,
                            },
                            content: `${mediaCaption}`
                          });
                          returnData.children[(i - 1)].children.push(lastChild);
                        }
                      }
                      return returnData;
                    case 'text2x2':
                      if (element.options.text1 === null || !angular.isDefined(element.options.text1)) {
                        element.options.text1 = '';
                      }

                      if (element.options.text2 === null || !angular.isDefined(element.options.text2)) {
                        element.options.text2 = '';
                      }
                      if (angular.isUndefined(element.options.padding1)) {
                        element.options.padding1 = ["15px", "0px", "0px", "0px"]
                      }
                      if (angular.isUndefined(element.options.padding2)) {
                        element.options.padding2 = ["15px", "0px", "0px", "0px"]
                      }
                      var bgColor1 = '';
                      if (!angular.isUndefined(element.options.backgroundColor1)) {
                        bgColor1 = 'background-color: ' + element.options.backgroundColor1 + ';';
                      }
                      var bgColor2 = '';
                      if (!angular.isUndefined(element.options.backgroundColor2)) {
                        bgColor2 = 'background-color: ' + element.options.backgroundColor2 + ';';
                      }

                      var fontWeight = '';
                      var fontFamily = '';
                      if (!angular.isUndefined(element.options.font)) {

                        if (!angular.isUndefined(element.options.font.weight)) {
                          fontWeight = element.options.font.weight;
                        } else {
                          fontWeight = 'normal';
                        }

                        if (!angular.isUndefined(element.options.font.family)) {
                          fontFamily = element.options.font.family;
                        } else {
                          fontFamily = 'Arial, Helvetica, sans-serif';
                        }
                      } else {
                        fontWeight = 'normal';
                        fontFamily = 'Arial, Helvetica, sans-serif';
                      }
                      var textAlign = '';
                      if (!angular.isUndefined(element.options.align)) {
                        textAlign = element.options.align;
                      } else {
                        textAlign = 'left';
                      }
                      var returnData = {
                        tagName: 'mj-section',
                        attributes: {
                          'full-width': 'full-width',
                          'background-color': element.options.backgroundColor,
                          'padding': `${element.options.padding[0]} ${element.options.padding[1]} ${element.options.padding[2]} ${element.options.padding[3]}`,
                          'css-class': 'img-td'
                        },
                        children: [{
                          tagName: 'mj-column',
                          attributes: {
                            'padding': '0 0 20px 0',
                          },
                          children: [{
                            tagName: 'mj-text',
                            attributes: {
                              'align': textAlign ? textAlign : 'left',
                              'font-size': '13px',
                              'color': element.options.color ? element.options.color : '#000000',
                              'line-height': '20px',
                              'padding': '0 10px',
                              'font-family': fontFamily,
                              // 'font-family': element.options.font.family
                            },
                            content: '<div style="' + `${bgColor1}` + ' padding:' + `${element.options.padding1[0]} ${element.options.padding1[1]} ${element.options.padding1[2]} ${element.options.padding1[3]}` + '">' + element.options.text1 + '</div>'
                          }
                          ]
                        },
                        {
                          tagName: 'mj-column',
                          attributes: {
                            'padding': '0 0 20px 0',
                          },
                          children: [{
                            tagName: 'mj-text',
                            attributes: {
                              'align': textAlign ? textAlign : 'left',
                              'font-size': '13px',
                              'color': element.options.color ? element.options.color : '#000000',
                              'line-height': '20px',
                              'padding': '0 10px',
                              'font-family': fontFamily,
                              // 'font-family': element.options.font.family
                            },
                            content: '<div style="' + `${bgColor2}` + ' padding:' + `${element.options.padding2[0]} ${element.options.padding2[1]} ${element.options.padding2[2]} ${element.options.padding2[3]}` + '">' + element.options.text2 + '</div>'
                          }
                          ]
                        }
                        ]
                      }


                      return returnData;
                    case 'text3x2':
                      if (element.options.text1 === null || !angular.isDefined(element.options.text1)) {
                        element.options.text1 = '';
                      }

                      if (element.options.text2 === null || !angular.isDefined(element.options.text2)) {
                        element.options.text2 = '';
                      }

                      if (element.options.text3 === null || !angular.isDefined(element.options.text3)) {
                        element.options.text3 = '';
                      }
                      if (angular.isUndefined(element.options.padding1)) {
                        element.options.padding1 = ["10px", "0px", "0px", "0px"]
                      }
                      if (angular.isUndefined(element.options.padding2)) {
                        element.options.padding2 = ["10px", "0px", "0px", "0px"]
                      }
                      if (angular.isUndefined(element.options.padding3)) {
                        element.options.padding3 = ["10px", "0px", "0px", "0px"]
                      }
                      var bgColor1 = '';
                      if (!angular.isUndefined(element.options.backgroundColor1)) {
                        bgColor1 = 'background-color: ' + element.options.backgroundColor1 + ';';
                      }
                      var bgColor2 = '';
                      if (!angular.isUndefined(element.options.backgroundColor2)) {
                        bgColor2 = 'background-color: ' + element.options.backgroundColor2 + ';';
                      }
                      var bgColor3 = '';
                      if (!angular.isUndefined(element.options.backgroundColor3)) {
                        bgColor3 = 'background-color: ' + element.options.backgroundColor3 + ';';
                      }

                      var fontWeight = '';
                      var fontFamily = '';
                      if (!angular.isUndefined(element.options.font)) {

                        if (!angular.isUndefined(element.options.font.weight)) {
                          fontWeight = element.options.font.weight;
                        } else {
                          fontWeight = 'normal';
                        }

                        if (!angular.isUndefined(element.options.font.family)) {
                          fontFamily = element.options.font.family;
                        } else {
                          fontFamily = 'Arial, Helvetica, sans-serif';
                        }
                      } else {
                        fontWeight = 'normal';
                        fontFamily = 'Arial, Helvetica, sans-serif';
                      }
                      var textAlign = '';
                      if (!angular.isUndefined(element.options.align)) {
                        textAlign = element.options.align;
                      } else {
                        textAlign = 'left';
                      }
                      var returnData = {
                        tagName: 'mj-section',
                        attributes: {
                          'full-width': 'full-width',
                          'background-color': element.options.backgroundColor,
                          'padding': `${element.options.padding[0]} ${element.options.padding[1]} ${element.options.padding[2]} ${element.options.padding[3]}`,
                          'css-class': 'img-td'
                        },
                        children: [{
                          tagName: 'mj-column',
                          attributes: {
                            'padding': '0 0 20px 0',
                          },
                          children: [{
                            tagName: 'mj-text',
                            attributes: {
                              'align': textAlign ? textAlign : 'left',
                              'font-size': '13px',
                              'color': element.options.color ? element.options.color : '#000000',
                              'line-height': '20px',
                              'padding': '0 10px',
                              'font-family': fontFamily,
                              // 'font-family': element.options.font.family
                            },
                            content: '<div style="' + `${bgColor1}` + ' padding:' + `${element.options.padding1[0]} ${element.options.padding1[1]} ${element.options.padding1[2]} ${element.options.padding1[3]}` + '">' + element.options.text1 + '</div>'
                          }
                          ]
                        },
                        {
                          tagName: 'mj-column',
                          attributes: {
                            'padding': '0 0 20px 0',
                          },
                          children: [{
                            tagName: 'mj-text',
                            attributes: {
                              'align': textAlign ? textAlign : 'left',
                              'font-size': '13px',
                              'color': element.options.color ? element.options.color : '#000000',
                              'line-height': '20px',
                              'padding': '0 10px',
                              'font-family': fontFamily,
                              // 'font-family': element.options.font.family
                            },
                            content: '<div style="' + `${bgColor2}` + ' padding:' + `${element.options.padding2[0]} ${element.options.padding2[1]} ${element.options.padding2[2]} ${element.options.padding2[3]}` + '">' + element.options.text2 + '</div>'
                          }
                          ]
                        },
                        {
                          tagName: 'mj-column',
                          attributes: {
                            'padding': '0 0 20px 0',
                          },
                          children: [{
                            tagName: 'mj-text',
                            attributes: {
                              'align': textAlign ? textAlign : 'left',
                              'font-size': '13px',
                              'color': element.options.color ? element.options.color : '#000000',
                              'line-height': '20px',
                              'padding': '0 10px',
                              'font-family': fontFamily,
                              // 'font-family': element.options.font.family
                            },
                            content: '<div style="' + `${bgColor3}` + ' padding:' + `${element.options.padding3[0]} ${element.options.padding3[1]} ${element.options.padding3[2]} ${element.options.padding3[3]}` + '">' + element.options.text3 + '</div>'
                          }
                          ]
                        }
                        ]
                      }
                      return returnData;
                    case 'social':
                      let links = '';
                      Object.keys(element.options.links).forEach(key => {
                        if (element.options.links[key].active) {
                          if (!angular.isUndefined(element.options.links[key].imageSingle)) {
                            links += `<a href="${element.options.links[key].link}" target="_blank" style="border: none;text-decoration: none;">
                                                                  <img border="0" src="${element.options.links[key].imageSingle.url}" width="${element.options.size}" style="width:${element.options.size}px" alt="">
                                                               </a>`
                          } else {
                            links += `<a href="${element.options.links[key].link}" target="_blank" style="border: none;text-decoration: none;">
                                                                  <img border="0" src="${templateBuilderConfig.assetsPath}/social/${key}.png" width="${element.options.size}" style="width:${element.options.size}px" alt="">
                                                               </a>`
                          }
                        }
                      })

                      return {
                        tagName: 'mj-section',
                        attributes: {
                          'full-width': 'full-width',
                          'background-color': element.options.backgroundColor,
                          'padding': `${element.options.padding[0]} ${element.options.padding[1]} ${element.options.padding[2]} ${element.options.padding[3]}`
                        },
                        children: [{
                          tagName: 'mj-column',
                          attributes: {
                            'width': '100%'
                          },
                          children: [{
                            tagName: 'mj-text',
                            attributes: {
                              'color': element.options.color ? element.options.color : '#000000',
                              'align': element.options.align,
                              'padding': 0,
                              'font-family': 'Arial, sans-serif',
                              'line-height': 0
                            },
                            content: links
                          }]
                        }]
                      }
                    case 'imagesX2':
                      var fontWeight = '';
                      var fontFamily = '';
                      if (!angular.isUndefined(element.options.font)) {

                        if (!angular.isUndefined(element.options.font.weight)) {
                          fontWeight = element.options.font.weight;
                        } else {
                          fontWeight = 'normal';
                        }

                        if (!angular.isUndefined(element.options.font.family)) {
                          fontFamily = element.options.font.family;
                        } else {
                          fontFamily = 'Arial, Helvetica, sans-serif';
                        }
                      } else {
                        fontWeight = 'normal';
                        fontFamily = 'Arial, Helvetica, sans-serif';
                      }
                      var textAlign = '';
                      if (!angular.isUndefined(element.options.align)) {
                        textAlign = element.options.align;
                      } else {
                        textAlign = 'left';
                      }
                      var returnData = {
                        tagName: 'mj-section',
                        attributes: {
                          'full-width': 'full-width',
                          'background-color': element.options.backgroundColor,
                          'padding': `${element.options.padding[0]} ${element.options.padding[1]} ${element.options.padding[2]} ${element.options.padding[3]}`,
                          'css-class': 'img-td'
                        },
                        children: [{
                          tagName: 'mj-column',
                          attributes: {
                            'padding': '0 0 20px 0',
                          },
                          children: [{
                            tagName: 'mj-image',
                            attributes: {
                              'src': element.options.imageSingle1.url,
                              'alt': element.options.imageSingle1.fields.title ? element.options.imageSingle1.fields.title : element.options.imageSingle1.fields.filename,
                              'padding': '0 10px 0px 10px',
                              'width': 1000,
                              'href': null
                            }
                          }]
                        },
                        {
                          tagName: 'mj-column',
                          attributes: {
                            'padding': '0 0 20px 0',
                          },
                          children: [{
                            tagName: 'mj-image',
                            attributes: {
                              'src': element.options.imageSingle2.url,
                              'alt': element.options.imageSingle2.fields.title ? element.options.imageSingle2.fields.title : element.options.imageSingle2.fields.filename,
                              'padding': '0 10px 0px 10px',
                              'width': 1000,
                              'href': null
                            }
                          }]
                        }
                        ]
                      }
                      for (var i = 1; i <= 2; i++) {
                        var linkUrl = '';
                        var linkText = '';
                        var mediaCaption = '';
                        if (!angular.isUndefined(element.options.linkTo) && element.options.linkTo.type != 'none') {
                          if (element.options.linkTo.type == 'link' || element.options.linkTo.type == 'email') {
                            if (element.options.linkTo.type == 'email') {
                              linkUrl = 'mailto:' + element.options.linkTo.link;
                            } else {
                              linkUrl = element.options.linkTo.link;
                            }
                          } else if (element.options.linkTo.type == 'mediacenter') {
                            linkUrl = sessionService.site_operative.mediacenterUrl + '#id=' + element.options['imageSingle' + i].id_media;
                          } else if (element.options.linkTo.type == 'original') {
                            linkUrl = element.options['imageSingle' + i].cropformats.original;
                          } else if (element.options.linkTo.type == 'individual-link') {
                            if (!angular.isUndefined(element.options['imageSingle' + i].customLink)) {
                              linkUrl = element.options['imageSingle' + i].customLink;
                            } else {
                              linkUrl = element.options['imageSingle' + i].cropformats.original;
                            }
                          }
                        }
                        var preFix = '';
                        var sufFix = '';
                        if (element.options.mediaCaption.prefix) {
                          preFix = element.options.mediaCaption.prefix + ' ';
                        } else {
                          preFix = '';
                        }
                        if (element.options.mediaCaption.suffix) {
                          sufFix = ' ' + element.options.mediaCaption.suffix;
                        } else {
                          sufFix = '';
                        }
                        if (!angular.isUndefined(element.options.mediaCaption) && element.options.mediaCaption.type != 'none') {
                          if (element.options.mediaCaption.type == 'custom') {

                            mediaCaption = (preFix ? preFix : "") + (element.options.mediaCaption['custom_' + i] ? element.options.mediaCaption['custom_' + i] : "") + (sufFix ? sufFix : "");

                          } else if (element.options.mediaCaption.type == 'caption_photographer') {

                            mediaCaption = element.options['imageSingle' + i].fields['photographer'] || element.options['imageSingle' + i].fields['caption'] ? (element.options['imageSingle' + i].fields['caption'] ? element.options['imageSingle' + i].fields['caption'] : "") + '<br>' + (preFix ? preFix : "") + (element.options['imageSingle' + i].fields['photographer'] ? element.options['imageSingle' + i].fields['photographer'] : "") + (sufFix ? sufFix : "") : "";

                          } else if (element.options.mediaCaption.type == 'caption_owner') {

                            mediaCaption = element.options['imageSingle' + i].fields['owner'] || element.options['imageSingle' + i].fields['caption'] ? (element.options['imageSingle' + i].fields['caption'] ? element.options['imageSingle' + i].fields['caption'] : "") + '<br>' + (preFix ? preFix : "") + (element.options['imageSingle' + i].fields['owner'] ? element.options['imageSingle' + i].fields['owner'] : "") + (sufFix ? sufFix : "") : "";

                          } else if (element.options.mediaCaption.type == 'title_photographer') {

                            mediaCaption = element.options['imageSingle' + i].fields['photographer'] || element.options['imageSingle' + i].fields['title'] ? (element.options['imageSingle' + i].fields['title'] ? element.options['imageSingle' + i].fields['title'] : "") + '<br>' + (preFix ? preFix : "") + (element.options['imageSingle' + i].fields['photographer'] ? element.options['imageSingle' + i].fields['photographer'] : "") + (sufFix ? sufFix : "") : "";

                          } else if (element.options.mediaCaption.type == 'photographer') {

                            mediaCaption = element.options['imageSingle' + i].fields['photographer'] ? (preFix ? preFix : "") + element.options['imageSingle' + i].fields['photographer'] + (sufFix ? sufFix : "") : "";

                          } else {

                            mediaCaption = element.options['imageSingle' + i].fields[element.options.mediaCaption.type] ? (preFix ? preFix : "") + element.options['imageSingle' + i].fields[element.options.mediaCaption.type] + (sufFix ? sufFix : "") : "";

                          }
                        }
                        if (linkUrl) {
                          returnData.children[(i - 1)].children[0].attributes.href = linkUrl;
                          if (element.options.linkTo.text) {
                            returnData.children[(i - 1)].children.push({
                              tagName: 'mj-button',
                              attributes: {
                                'align': textAlign,
                                'background-color': 'transparent',
                                'border': '0px solid #FFFFFF',
                                'border-radius': '0px',
                                'color': element.options.color != '#888888' ? element.options.color : '#039be5',
                                'font-family': fontFamily,
                                'font-size': '13px',
                                'font-weight': fontWeight,
                                'inner-padding': element.options.paddingDownload ? `${element.options.paddingDownload[0]} ${element.options.paddingDownload[1]} ${element.options.paddingDownload[2]} ${element.options.paddingDownload[3]}` : '5px 10px 0px 10px',
                                'padding': '0 0 0 0',
                                'width': 'auto',
                                'href': linkUrl
                              },
                              content: element.options.linkTo.text
                            });
                          }
                        }
                        if (mediaCaption) {
                          returnData.children[(i - 1)].children.push({
                            tagName: 'mj-text',
                            attributes: {
                              'align': textAlign,
                              'font-size': '13px',
                              'color': element.options.color ? element.options.color : '#888888',
                              'line-height': '20px',
                              'padding': element.options.paddingCaption ? `${element.options.paddingCaption[0]} ${element.options.paddingCaption[1]} ${element.options.paddingCaption[2]} ${element.options.paddingCaption[3]}` : '5px 10px 0px 10px',
                              'font-family': fontFamily,
                              'font-weight': fontWeight
                            },
                            content: `${mediaCaption}`
                          });
                        }
                      }
                      return returnData;
                    case 'imagesX3':
                      var fontWeight = '';
                      var fontFamily = '';
                      if (!angular.isUndefined(element.options.font)) {

                        if (!angular.isUndefined(element.options.font.weight)) {
                          fontWeight = element.options.font.weight;
                        } else {
                          fontWeight = 'normal';
                        }

                        if (!angular.isUndefined(element.options.font.family)) {
                          fontFamily = element.options.font.family;
                        } else {
                          fontFamily = 'Arial, Helvetica, sans-serif';
                        }
                      } else {
                        fontWeight = 'normal';
                        fontFamily = 'Arial, Helvetica, sans-serif';
                      }
                      var textAlign = '';
                      if (!angular.isUndefined(element.options.align)) {
                        textAlign = element.options.align;
                      } else {
                        textAlign = 'left';
                      }
                      var returnData = {
                        tagName: 'mj-section',
                        attributes: {
                          'full-width': 'full-width',
                          'background-color': element.options.backgroundColor,
                          'padding': `${element.options.padding[0]} ${element.options.padding[1]} ${element.options.padding[2]} ${element.options.padding[3]}`,
                          'css-class': 'img-td'
                        },
                        children: [{
                          tagName: 'mj-column',
                          attributes: {
                            'padding': '0 0 20px 0',
                          },
                          children: [{
                            tagName: 'mj-image',
                            attributes: {
                              'src': element.options.imageSingle1.url,
                              'alt': element.options.imageSingle1.fields.title ? element.options.imageSingle1.fields.title : element.options.imageSingle1.fields.filename,
                              'padding': '0 10px 0px 10px',
                              'width': 1000,
                              'href': null
                            }
                          }]
                        },
                        {
                          tagName: 'mj-column',
                          attributes: {
                            'padding': '0 0 20px 0',
                          },
                          children: [{
                            tagName: 'mj-image',
                            attributes: {
                              'src': element.options.imageSingle2.url,
                              'alt': element.options.imageSingle2.fields.title ? element.options.imageSingle2.fields.title : element.options.imageSingle2.fields.filename,
                              'padding': '0 10px 0px 10px',
                              'width': 1000,
                              'href': null
                            }
                          }]
                        },
                        {
                          tagName: 'mj-column',
                          attributes: {
                            'padding': '0 0 20px 0',
                          },
                          children: [{
                            tagName: 'mj-image',
                            attributes: {
                              'src': element.options.imageSingle3.url,
                              'alt': element.options.imageSingle3.fields.title ? element.options.imageSingle3.fields.title : element.options.imageSingle3.fields.filename,
                              'padding': '0 10px 0px 10px',
                              'width': 1000,
                              'href': null
                            }
                          }]
                        }
                        ]
                      }

                      for (var i = 1; i <= 3; i++) {
                        var linkUrl = '';
                        var linkText = '';
                        var mediaCaption = '';
                        if (!angular.isUndefined(element.options.linkTo) && element.options.linkTo.type != 'none') {
                          if (element.options.linkTo.type == 'link' || element.options.linkTo.type == 'email') {
                            if (element.options.linkTo.type == 'email') {
                              linkUrl = 'mailto:' + element.options.linkTo.link;
                            } else {
                              linkUrl = element.options.linkTo.link;
                            }
                          } else if (element.options.linkTo.type == 'mediacenter') {
                            linkUrl = sessionService.site_operative.mediacenterUrl + '#id=' + element.options['imageSingle' + i].id_media;
                          } else if (element.options.linkTo.type == 'original') {
                            linkUrl = element.options['imageSingle' + i].cropformats.original;
                          } else if (element.options.linkTo.type == 'individual-link') {
                            if (!angular.isUndefined(element.options['imageSingle' + i].customLink)) {
                              linkUrl = element.options['imageSingle' + i].customLink;
                            } else {
                              linkUrl = element.options['imageSingle' + i].cropformats.original;
                            }
                          }
                        }
                        var preFix = '';
                        var sufFix = '';
                        if (element.options.mediaCaption.prefix) {
                          preFix = element.options.mediaCaption.prefix + ' ';
                        } else {
                          preFix = '';
                        }
                        if (element.options.mediaCaption.suffix) {
                          sufFix = ' ' + element.options.mediaCaption.suffix;
                        } else {
                          sufFix = '';
                        }
                        if (!angular.isUndefined(element.options.mediaCaption) && element.options.mediaCaption.type != 'none') {
                          if (element.options.mediaCaption.type == 'custom') {

                            mediaCaption = (preFix ? preFix : "") + (element.options.mediaCaption['custom_' + i] ? element.options.mediaCaption['custom_' + i] : "") + (sufFix ? sufFix : "");

                          } else if (element.options.mediaCaption.type == 'caption_photographer') {

                            mediaCaption = element.options['imageSingle' + i].fields['photographer'] || element.options['imageSingle' + i].fields['caption'] ? (element.options['imageSingle' + i].fields['caption'] ? element.options['imageSingle' + i].fields['caption'] : "") + '<br>' + (preFix ? preFix : "") + (element.options['imageSingle' + i].fields['photographer'] ? element.options['imageSingle' + i].fields['photographer'] : "") + (sufFix ? sufFix : "") : "";

                          } else if (element.options.mediaCaption.type == 'caption_owner') {

                            mediaCaption = element.options['imageSingle' + i].fields['owner'] || element.options['imageSingle' + i].fields['caption'] ? (element.options['imageSingle' + i].fields['caption'] ? element.options['imageSingle' + i].fields['caption'] : "") + '<br>' + (preFix ? preFix : "") + (element.options['imageSingle' + i].fields['owner'] ? element.options['imageSingle' + i].fields['owner'] : "") + (sufFix ? sufFix : "") : "";

                          } else if (element.options.mediaCaption.type == 'title_photographer') {

                            mediaCaption = element.options['imageSingle' + i].fields['photographer'] || element.options['imageSingle' + i].fields['title'] ? (element.options['imageSingle' + i].fields['title'] ? element.options['imageSingle' + i].fields['title'] : "") + '<br>' + (preFix ? preFix : "") + (element.options['imageSingle' + i].fields['photographer'] ? element.options['imageSingle' + i].fields['photographer'] : "") + (sufFix ? sufFix : "") : "";

                          } else if (element.options.mediaCaption.type == 'photographer') {

                            mediaCaption = element.options['imageSingle' + i].fields['photographer'] ? (preFix ? preFix : "") + element.options['imageSingle' + i].fields['photographer'] + (sufFix ? sufFix : "") : "";

                          } else {

                            mediaCaption = element.options['imageSingle' + i].fields[element.options.mediaCaption.type] ? (preFix ? preFix : "") + element.options['imageSingle' + i].fields[element.options.mediaCaption.type] + (sufFix ? sufFix : "") : "";

                          }
                        }
                        if (linkUrl) {
                          returnData.children[(i - 1)].children[0].attributes.href = linkUrl;
                          if (element.options.linkTo.text) {
                            returnData.children[(i - 1)].children.push({
                              tagName: 'mj-button',
                              attributes: {
                                'align': textAlign,
                                'background-color': 'transparent',
                                'border': '0px solid #FFFFFF',
                                'border-radius': '0px',
                                'color': element.options.color != '#888888' ? element.options.color : '#039be5',
                                'font-family': fontFamily,
                                'font-size': '13px',
                                'font-weight': fontWeight,
                                'inner-padding': element.options.paddingDownload ? `${element.options.paddingDownload[0]} ${element.options.paddingDownload[1]} ${element.options.paddingDownload[2]} ${element.options.paddingDownload[3]}` : '5px 10px 0px 10px',
                                'padding': '0 0 0 0',
                                'width': 'auto',
                                'href': linkUrl
                              },
                              content: element.options.linkTo.text
                            });
                          }
                        }
                        if (mediaCaption) {
                          returnData.children[(i - 1)].children.push({
                            tagName: 'mj-text',
                            attributes: {
                              'align': textAlign,
                              'font-size': '13px',
                              'color': element.options.color ? element.options.color : '#888888',
                              'line-height': '20px',
                              'padding': element.options.paddingCaption ? `${element.options.paddingCaption[0]} ${element.options.paddingCaption[1]} ${element.options.paddingCaption[2]} ${element.options.paddingCaption[3]}` : '5px 10px 0px 10px',
                              'font-family': fontFamily,
                              'font-weight': fontWeight
                            },
                            content: `${mediaCaption}`
                          });
                        }
                      }

                      return returnData;
                    case 'imagesX4':
                      var fontWeight = '';
                      var fontFamily = '';
                      if (!angular.isUndefined(element.options.font)) {

                        if (!angular.isUndefined(element.options.font.weight)) {
                          fontWeight = element.options.font.weight;
                        } else {
                          fontWeight = 'normal';
                        }

                        if (!angular.isUndefined(element.options.font.family)) {
                          fontFamily = element.options.font.family;
                        } else {
                          fontFamily = 'Arial, Helvetica, sans-serif';
                        }
                      } else {
                        fontWeight = 'normal';
                        fontFamily = 'Arial, Helvetica, sans-serif';
                      }
                      var textAlign = '';
                      if (!angular.isUndefined(element.options.align)) {
                        textAlign = element.options.align;
                      } else {
                        textAlign = 'left';
                      }
                      var returnData = {
                        tagName: 'mj-section',
                        attributes: {
                          'full-width': 'full-width',
                          'background-color': element.options.backgroundColor,
                          'padding': `${element.options.padding[0]} ${element.options.padding[1]} ${element.options.padding[2]} ${element.options.padding[3]}`,
                          'css-class': 'img-td'
                        },
                        children: [{
                          tagName: 'mj-column',
                          attributes: {
                            'padding': '0 0 20px 0',
                          },
                          children: [{
                            tagName: 'mj-image',
                            attributes: {
                              'src': element.options.imageSingle1.url,
                              'alt': element.options.imageSingle1.fields.title ? element.options.imageSingle1.fields.title : element.options.imageSingle1.fields.filename,
                              'padding': '0 10px 0px 10px',
                              'width': 1000,
                              'href': null
                            }
                          }]
                        },
                        {
                          tagName: 'mj-column',
                          attributes: {
                            'padding': '0 0 20px 0',
                          },
                          children: [{
                            tagName: 'mj-image',
                            attributes: {
                              'src': element.options.imageSingle2.url,
                              'alt': element.options.imageSingle2.fields.title ? element.options.imageSingle2.fields.title : element.options.imageSingle2.fields.filename,
                              'padding': '0 10px 0px 10px',
                              'width': 1000,
                              'href': null
                            }
                          }]
                        },
                        {
                          tagName: 'mj-column',
                          attributes: {
                            'padding': '0 0 20px 0',
                          },
                          children: [{
                            tagName: 'mj-image',
                            attributes: {
                              'src': element.options.imageSingle3.url,
                              'alt': element.options.imageSingle3.fields.title ? element.options.imageSingle3.fields.title : element.options.imageSingle3.fields.filename,
                              'padding': '0 10px 0px 10px',
                              'width': 1000,
                              'href': null
                            }
                          }]
                        },
                        {
                          tagName: 'mj-column',
                          attributes: {
                            'padding': '0 0 20px 0',
                          },
                          children: [{
                            tagName: 'mj-image',
                            attributes: {
                              'src': element.options.imageSingle4.url,
                              'alt': element.options.imageSingle4.fields.title ? element.options.imageSingle4.fields.title : element.options.imageSingle4.fields.filename,
                              'padding': '0 10px 0px 10px',
                              'width': 1000,
                              'href': null
                            }
                          }]
                        }
                        ]
                      }

                      for (var i = 1; i <= 4; i++) {
                        var linkUrl = '';
                        var linkText = '';
                        var mediaCaption = '';
                        if (!angular.isUndefined(element.options.linkTo) && element.options.linkTo.type != 'none') {
                          if (element.options.linkTo.type == 'link' || element.options.linkTo.type == 'email') {
                            if (element.options.linkTo.type == 'email') {
                              linkUrl = 'mailto:' + element.options.linkTo.link;
                            } else {
                              linkUrl = element.options.linkTo.link;
                            }
                          } else if (element.options.linkTo.type == 'mediacenter') {
                            linkUrl = sessionService.site_operative.mediacenterUrl + '#id=' + element.options['imageSingle' + i].id_media;
                          } else if (element.options.linkTo.type == 'original') {
                            linkUrl = element.options['imageSingle' + i].cropformats.original;
                          } else if (element.options.linkTo.type == 'individual-link') {
                            if (!angular.isUndefined(element.options['imageSingle' + i].customLink)) {
                              linkUrl = element.options['imageSingle' + i].customLink;
                            } else {
                              linkUrl = element.options['imageSingle' + i].cropformats.original;
                            }
                          }

                        }
                        var preFix = '';
                        var sufFix = '';
                        if (element.options.mediaCaption.prefix) {
                          preFix = element.options.mediaCaption.prefix + ' ';
                        } else {
                          preFix = '';
                        }
                        if (element.options.mediaCaption.suffix) {
                          sufFix = ' ' + element.options.mediaCaption.suffix;
                        } else {
                          sufFix = '';
                        }
                        if (!angular.isUndefined(element.options.mediaCaption) && element.options.mediaCaption.type != 'none') {
                          if (element.options.mediaCaption.type == 'custom') {

                            mediaCaption = (preFix ? preFix : "") + (element.options.mediaCaption['custom_' + i] ? element.options.mediaCaption['custom_' + i] : "") + (sufFix ? sufFix : "");

                          } else if (element.options.mediaCaption.type == 'caption_photographer') {

                            mediaCaption = element.options['imageSingle' + i].fields['photographer'] || element.options['imageSingle' + i].fields['caption'] ? (element.options['imageSingle' + i].fields['caption'] ? element.options['imageSingle' + i].fields['caption'] : "") + '<br>' + (preFix ? preFix : "") + (element.options['imageSingle' + i].fields['photographer'] ? element.options['imageSingle' + i].fields['photographer'] : "") + (sufFix ? sufFix : "") : "";

                          } else if (element.options.mediaCaption.type == 'caption_owner') {

                            mediaCaption = element.options['imageSingle' + i].fields['owner'] || element.options['imageSingle' + i].fields['caption'] ? (element.options['imageSingle' + i].fields['caption'] ? element.options['imageSingle' + i].fields['caption'] : "") + '<br>' + (preFix ? preFix : "") + (element.options['imageSingle' + i].fields['owner'] ? element.options['imageSingle' + i].fields['owner'] : "") + (sufFix ? sufFix : "") : "";

                          } else if (element.options.mediaCaption.type == 'title_photographer') {

                            mediaCaption = element.options['imageSingle' + i].fields['photographer'] || element.options['imageSingle' + i].fields['title'] ? (element.options['imageSingle' + i].fields['title'] ? element.options['imageSingle' + i].fields['title'] : "") + '<br>' + (preFix ? preFix : "") + (element.options['imageSingle' + i].fields['photographer'] ? element.options['imageSingle' + i].fields['photographer'] : "") + (sufFix ? sufFix : "") : "";

                          } else if (element.options.mediaCaption.type == 'photographer') {

                            mediaCaption = element.options['imageSingle' + i].fields['photographer'] ? (preFix ? preFix : "") + element.options['imageSingle' + i].fields['photographer'] + (sufFix ? sufFix : "") : "";

                          } else {

                            mediaCaption = element.options['imageSingle' + i].fields[element.options.mediaCaption.type] ? (preFix ? preFix : "") + element.options['imageSingle' + i].fields[element.options.mediaCaption.type] + (sufFix ? sufFix : "") : "";

                          }
                        }
                        if (linkUrl) {
                          returnData.children[(i - 1)].children[0].attributes.href = linkUrl;
                          if (element.options.linkTo.text) {
                            returnData.children[(i - 1)].children.push({
                              tagName: 'mj-button',
                              attributes: {
                                'align': textAlign,
                                'background-color': 'transparent',
                                'border': '0px solid #FFFFFF',
                                'border-radius': '0px',
                                'color': element.options.color != '#888888' ? element.options.color : '#039be5',
                                'font-family': fontFamily,
                                'font-size': '13px',
                                'font-weight': fontWeight,
                                'inner-padding': element.options.paddingDownload ? `${element.options.paddingDownload[0]} ${element.options.paddingDownload[1]} ${element.options.paddingDownload[2]} ${element.options.paddingDownload[3]}` : '5px 10px 0px 10px',
                                'padding': '0 0 0 0',
                                'width': 'auto',
                                'href': linkUrl
                              },
                              content: element.options.linkTo.text
                            });
                          }
                        }
                        if (mediaCaption) {
                          returnData.children[(i - 1)].children.push({
                            tagName: 'mj-text',
                            attributes: {
                              'align': textAlign,
                              'font-size': '13px',
                              'color': element.options.color ? element.options.color : '#888888',
                              'line-height': '20px',
                              'padding': element.options.paddingCaption ? `${element.options.paddingCaption[0]} ${element.options.paddingCaption[1]} ${element.options.paddingCaption[2]} ${element.options.paddingCaption[3]}` : '5px 10px 0px 10px',
                              'font-family': fontFamily,
                              'font-weight': fontWeight
                            },
                            content: `${mediaCaption}`
                          });
                        }
                      }

                      return returnData;
                    case 'imagesX5':
                      var fontWeight = '';
                      var fontFamily = '';
                      if (!angular.isUndefined(element.options.font)) {

                        if (!angular.isUndefined(element.options.font.weight)) {
                          fontWeight = element.options.font.weight;
                        } else {
                          fontWeight = 'normal';
                        }

                        if (!angular.isUndefined(element.options.font.family)) {
                          fontFamily = element.options.font.family;
                        } else {
                          fontFamily = 'Arial, Helvetica, sans-serif';
                        }
                      } else {
                        fontWeight = 'normal';
                        fontFamily = 'Arial, Helvetica, sans-serif';
                      }
                      var textAlign = '';
                      if (!angular.isUndefined(element.options.align)) {
                        textAlign = element.options.align;
                      } else {
                        textAlign = 'left';
                      }
                      var returnData = {
                        tagName: 'mj-section',
                        attributes: {
                          'full-width': 'full-width',
                          'background-color': element.options.backgroundColor,
                          'padding': `${element.options.padding[0]} ${element.options.padding[1]} ${element.options.padding[2]} ${element.options.padding[3]}`,
                          'css-class': 'img-td'
                        },
                        children: [{
                          tagName: 'mj-column',
                          attributes: {
                            'padding': '0 0 20px 0',
                          },
                          children: [{
                            tagName: 'mj-image',
                            attributes: {
                              'src': element.options.imageSingle1.url,
                              'alt': element.options.imageSingle1.fields.title ? element.options.imageSingle1.fields.title : element.options.imageSingle1.fields.filename,
                              'padding': '0 10px 0px 10px',
                              'width': 1000,
                              'href': null
                            }
                          }]
                        },
                        {
                          tagName: 'mj-column',
                          attributes: {
                            'padding': '0 0 20px 0',
                          },
                          children: [{
                            tagName: 'mj-image',
                            attributes: {
                              'src': element.options.imageSingle2.url,
                              'alt': element.options.imageSingle2.fields.title ? element.options.imageSingle2.fields.title : element.options.imageSingle2.fields.filename,
                              'padding': '0 10px 0px 10px',
                              'width': 1000,
                              'href': null
                            }
                          }]
                        },
                        {
                          tagName: 'mj-column',
                          attributes: {
                            'padding': '0 0 20px 0',
                          },
                          children: [{
                            tagName: 'mj-image',
                            attributes: {
                              'src': element.options.imageSingle3.url,
                              'alt': element.options.imageSingle3.fields.title ? element.options.imageSingle3.fields.title : element.options.imageSingle3.fields.filename,
                              'padding': '0 10px 0px 10px',
                              'width': 1000,
                              'href': null
                            }
                          }]
                        },
                        {
                          tagName: 'mj-column',
                          attributes: {
                            'padding': '0 0 20px 0',
                          },
                          children: [{
                            tagName: 'mj-image',
                            attributes: {
                              'src': element.options.imageSingle4.url,
                              'alt': element.options.imageSingle4.fields.title ? element.options.imageSingle4.fields.title : element.options.imageSingle4.fields.filename,
                              'padding': '0 10px 0px 10px',
                              'width': 1000,
                              'href': null
                            }
                          }]
                        },
                        {
                          tagName: 'mj-column',
                          children: [{
                            tagName: 'mj-image',
                            attributes: {
                              'src': element.options.imageSingle5.url,
                              'alt': element.options.imageSingle5.fields.title ? element.options.imageSingle5.fields.title : element.options.imageSingle5.fields.filename,
                              'padding': '0 10px 0px 10px',
                              'width': 1000,
                              'href': null
                            }
                          }]
                        }
                        ]
                      }

                      for (var i = 1; i <= 5; i++) {
                        var linkUrl = '';
                        var linkText = '';
                        var mediaCaption = '';
                        if (!angular.isUndefined(element.options.linkTo) && element.options.linkTo.type != 'none') {
                          if (element.options.linkTo.type == 'link' || element.options.linkTo.type == 'email') {
                            if (element.options.linkTo.type == 'email') {
                              linkUrl = 'mailto:' + element.options.linkTo.link;
                            } else {
                              linkUrl = element.options.linkTo.link;
                            }
                          } else if (element.options.linkTo.type == 'mediacenter') {
                            linkUrl = sessionService.site_operative.mediacenterUrl + '#id=' + element.options['imageSingle' + i].id_media;
                          } else if (element.options.linkTo.type == 'original') {
                            linkUrl = element.options['imageSingle' + i].cropformats.original;
                          } else if (element.options.linkTo.type == 'individual-link') {
                            if (!angular.isUndefined(element.options['imageSingle' + i].customLink)) {
                              linkUrl = element.options['imageSingle' + i].customLink;
                            } else {
                              linkUrl = element.options['imageSingle' + i].cropformats.original;
                            }
                          }
                        }
                        var preFix = '';
                        var sufFix = '';
                        if (element.options.mediaCaption.prefix) {
                          preFix = element.options.mediaCaption.prefix + ' ';
                        } else {
                          preFix = '';
                        }
                        if (element.options.mediaCaption.suffix) {
                          sufFix = ' ' + element.options.mediaCaption.suffix;
                        } else {
                          sufFix = '';
                        }
                        if (!angular.isUndefined(element.options.mediaCaption) && element.options.mediaCaption.type != 'none') {
                          if (element.options.mediaCaption.type == 'custom') {

                            mediaCaption = (preFix ? preFix : "") + (element.options.mediaCaption['custom_' + i] ? element.options.mediaCaption['custom_' + i] : "") + (sufFix ? sufFix : "");

                          } else if (element.options.mediaCaption.type == 'caption_photographer') {

                            mediaCaption = element.options['imageSingle' + i].fields['photographer'] || element.options['imageSingle' + i].fields['caption'] ? (element.options['imageSingle' + i].fields['caption'] ? element.options['imageSingle' + i].fields['caption'] : "") + '<br>' + (preFix ? preFix : "") + (element.options['imageSingle' + i].fields['photographer'] ? element.options['imageSingle' + i].fields['photographer'] : "") + (sufFix ? sufFix : "") : "";

                          } else if (element.options.mediaCaption.type == 'caption_owner') {

                            mediaCaption = element.options['imageSingle' + i].fields['owner'] || element.options['imageSingle' + i].fields['caption'] ? (element.options['imageSingle' + i].fields['caption'] ? element.options['imageSingle' + i].fields['caption'] : "") + '<br>' + (preFix ? preFix : "") + (element.options['imageSingle' + i].fields['owner'] ? element.options['imageSingle' + i].fields['owner'] : "") + (sufFix ? sufFix : "") : "";

                          } else if (element.options.mediaCaption.type == 'title_photographer') {

                            mediaCaption = element.options['imageSingle' + i].fields['photographer'] || element.options['imageSingle' + i].fields['title'] ? (element.options['imageSingle' + i].fields['title'] ? element.options['imageSingle' + i].fields['title'] : "") + '<br>' + (preFix ? preFix : "") + (element.options['imageSingle' + i].fields['photographer'] ? element.options['imageSingle' + i].fields['photographer'] : "") + (sufFix ? sufFix : "") : "";

                          } else if (element.options.mediaCaption.type == 'photographer') {

                            mediaCaption = element.options['imageSingle' + i].fields['photographer'] ? (preFix ? preFix : "") + element.options['imageSingle' + i].fields['photographer'] + (sufFix ? sufFix : "") : "";

                          } else {

                            mediaCaption = element.options['imageSingle' + i].fields[element.options.mediaCaption.type] ? (preFix ? preFix : "") + element.options['imageSingle' + i].fields[element.options.mediaCaption.type] + (sufFix ? sufFix : "") : "";

                          }
                        }
                        if (linkUrl) {
                          returnData.children[(i - 1)].children[0].attributes.href = linkUrl;
                          if (element.options.linkTo.text) {
                            returnData.children[(i - 1)].children.push({
                              tagName: 'mj-button',
                              attributes: {
                                'align': textAlign,
                                'background-color': 'transparent',
                                'border': '0px solid #FFFFFF',
                                'border-radius': '0px',
                                'color': element.options.color != '#888888' ? element.options.color : '#039be5',
                                'font-family': fontFamily,
                                'font-size': '13px',
                                'font-weight': fontWeight,
                                'inner-padding': element.options.paddingDownload ? `${element.options.paddingDownload[0]} ${element.options.paddingDownload[1]} ${element.options.paddingDownload[2]} ${element.options.paddingDownload[3]}` : '5px 10px 0px 10px',
                                'padding': '0 0 0 0',
                                'width': 'auto',
                                'href': linkUrl
                              },
                              content: element.options.linkTo.text
                            });
                          }
                        }
                        if (mediaCaption) {
                          returnData.children[(i - 1)].children.push({
                            tagName: 'mj-text',
                            attributes: {
                              'align': textAlign,
                              'font-size': '13px',
                              'color': element.options.color ? element.options.color : '#888888',
                              'line-height': '20px',
                              'padding': element.options.paddingCaption ? `${element.options.paddingCaption[0]} ${element.options.paddingCaption[1]} ${element.options.paddingCaption[2]} ${element.options.paddingCaption[3]}` : '5px 10px 0px 10px',
                              'font-family': fontFamily,
                              'font-weight': fontWeight
                            },
                            content: `${mediaCaption}`
                          });
                        }
                      }

                      return returnData;
                    case 'code':
                      var returnData = {
                        tagName: 'mj-section',
                        attributes: {
                          'background-color': element.options.backgroundColor,
                          'padding': `${element.options.padding[0]} ${element.options.padding[1]} ${element.options.padding[2]} ${element.options.padding[3]}`
                        },
                        children: [{
                          tagName: 'mj-raw',
                          content: element.options.code
                        }]

                      }
                      return returnData
                    case 'previewInBrowser':
                      return {
                        tagName: 'mj-section',
                        attributes: {
                          'full-width': 'full-width',
                          'background-color': element.options.backgroundColor,
                          'padding': `${element.options.padding[0]} ${element.options.padding[1]} ${element.options.padding[2]} ${element.options.padding[3]}`
                        },
                        children: [{
                          tagName: 'mj-column',
                          attributes: {
                            'width': '100%'
                          },
                          children: [
                            {
                              tagName: 'mj-text',
                              attributes: {
                                'align': element.options.align,
                                'font-size': element.options.font.size ? `${element.options.font.size}px` : '13px',
                                'color': element.options.font.color ? element.options.font.color : '#777777',
                                'line-height': '20px',
                                'padding': 0,
                                'font-family': element.options.font.family,
                                'font-weight': element.options.font.weight
                              },
                              content: `${element.options.textPreview ? element.options.textPreview : ''} <a href="${sessionService.site_operative.mailingViewInBrowser}#${currentContent.unique_id}_${currentContent.subject ? currentContent.subject.toString().normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/\s+/g, '-').replace(/&/g, '-and-').replace(/[^\w\-]+/g, '').replace(/\-\-+/g, '-').replace(/^-+/, '').replace(/-+$/, '') : ''}" color="${element.options.font.color ? element.options.font.color : '#777777'}" style="color: ${element.options.font.color ? element.options.font.color : '#777777'}">${element.options.clickHere}</a>`
                            }]
                        },
                        ]

                      }

                    default:
                      return false;
                  }
                })
              }]
            }]
          }
          ]
        }
        if (sessionService.site_operative.mailingFonts) {
          var addFonts = []
          angular.forEach(fullEmail, function (el) {
            if (!angular.isUndefined(el.options.font) && !angular.isUndefined(el.options.font.family)) {
              var newFonts = $filter('filter')(sessionService.site_operative.mailingFonts, { name: el.options.font.family }, true);
              if (newFonts.length > 0 && addFonts.indexOf(el.options.font.family) == -1) {
                addFonts.push(newFonts[0]);
              }
            }
          })
          angular.forEach(addFonts, function (font) {
            compileMjmlObject.children[0].children.push({
              tagName: 'mj-font',
              attributes: {
                name: font.name,
                href: font.href
              }
            });
          })
        }
        return new Promise(function (succesFn, rejectFn) {
          if (!templateBuilderConfig.mjmlCompileAdress && (!templateBuilderConfig.mjmlPublicKey || !templateBuilderConfig.mjmlApplicationId)) {
            return rejectFn('You did\'nt include compile address for MJML or MJML API keys!');
          }
          if (templateBuilderConfig.mjmlPublicKey && templateBuilderConfig.mjmlApplicationId) {
            return $.ajax({
              url: 'https://api.mjml.io/v1/render',
              method: 'POST',
              data: JSON.stringify({ mjml: JSON.stringify(compileMjmlObject) }),
              datatype: 'json',
              processData: false,
              beforeSend(req) {
                req.setRequestHeader('Authorization', `Basic ${btoa(`${templateBuilderConfig.mjmlApplicationId}:${templateBuilderConfig.mjmlPublicKey}`)}`)
              },
              success(data) {
                return succesFn(data)
              }
            })
          }

          return $http.post(templateBuilderConfig.mjmlCompileAdress, {
            mjml: compileMjmlObject
          }).then(succesFn)
            .catch(rejectFn);
        });
      },
      /**
       * Notify
       * @param msg
       * @param callback
       * @returns {{log: utils.log, success: utils.success, error: utils.error}}
       */
      notify: function (msg, callback) {
        return {
          log: function () {
            //            return alertify.log(msg, callback);
          },
          success: function () {
            $mdToast.show({
              template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + msg + '</span></div></md-toast>',
              hideDelay: 5000,
              position: 'top',
              parent: '#content-container'
            });
          },
          error: function () {
            $mdToast.show({
              template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-alert" class="icon"></md-icon><span class="md-toast-text" flex>' + msg + '</span></div></md-toast>',
              hideDelay: 5000,
              position: 'top',
              parent: '#content-container'
            });
          }
        };
      },
      /**
       * Confirm dialog
       * @param msg
       * @param succesFn
       * @param cancelFn
       * @param okBtn
       * @param cancelBtn
       * @returns {IAlertify}
       */
      confirm: function (msg, succesFn, cancelFn, okBtn, cancelBtn) {
        return alertify
          .okBtn(okBtn)
          .cancelBtn(cancelBtn)
          .confirm(msg, succesFn, cancelFn);
      },
      /**
       * Alert dialog
       * @param msg
       * @returns {IAlertify}
       */
      alert: function (msg) {
        return alertify
          .okBtn("Accept")
          .alert(msg);
      },
      /**
       * Prompt dialog
       * @param defaultvalue
       * @param promptMessage
       * @param successFn
       * @param cancelFn
       * @returns {IAlertify}
       */
      prompt: function (defaultvalue, promptMessage, successFn, cancelFn) {
        return alertify
          .defaultValue(defaultvalue)
          .prompt(promptMessage, successFn, cancelFn);
      },
      /**
       * Validate email before save and import
       * @param emailToValidate
       * @returns {boolean}
       */
      validateEmail: function (emailToValidate) {
        return angular.isObject(emailToValidate) &&
          // emailToValidate.hasOwnProperty('name') &&
          angular.isArray(emailToValidate.elements) &&
          angular.isString(emailToValidate.html) &&
          angular.isObject(emailToValidate.emailSettings) &&
          emailToValidate.emailSettings.type == 'emailSettings' &&
          angular.isObject(emailToValidate.emailSettings.options);
      },
      /**
       * Track events with Google Analytics
       * @param category
       * @param event
       * @param name
       * @returns {*}
       */
      trackEvent: function (category, event, name) {
        if (templateBuilderConfig.trackEvents && window.ga) {
          return window.ga('send', 'event', category, event, name);
        } else if (templateBuilderConfig.trackEvents && !window.ga) {
          return console.info('To track events, add Google UA in config.json file!');
        }
      },
      removeLineBreaks: function (html) {
        return html.replace(/\n\s*\n/gi, '\n');
      }

    };

    var resourceApi = $resource(
      templateBuilderConfig.mjmlCompileAdress, {}, {
      post: {
        method: "POST"
      }
    }
    );


    return service;

    //////////

  }
}());

(function() {
  'use strict';

  angular
    .module('app.core')
    .filter('arrToPadding', function () {
      return function (val) {
        if (!val) {
          return '';
        }
        var str = '';
        val.forEach(function (p) {
          if (p) {
            str += p + " ";
          } else {
            str += 0 + " ";
          }
        });
        return str;
      };
    })
    .filter('hexToRgb', function () {
      return function (hex, opacity) {
        var h = hex.replace('#', '');
        h = h.match(new RegExp('(.{' + h.length / 3 + '})', 'g'));

        for (var i = 0; i < h.length; i++)
          h[i] = parseInt(h[i].length == 1 ? h[i] + h[i] : h[i], 16);

        if (typeof opacity != 'undefined') {
          opacity = opacity / 100;
          h.push(opacity);
        }
        return 'rgba(' + h.join(',') + ')';
      };
    })
    .filter('translateCamelCase', ['templateBuilderUtils', 'msUtils', function (templateBuilderUtils, msUtils) {
      return function (key_to_translate, additional_data) {
        if (typeof key_to_translate !== 'string') return key_to_translate;
        var snake_key = templateBuilderUtils.camelToSnake(key_to_translate);
        var translated = msUtils.translate(snake_key, additional_data);
        return translated === snake_key ? key_to_translate : translated;
      };
    }])
    .filter('rawHtml', ['$sce', function ($sce) {
      var div = document.createElement('div');
      return function (html, decode) {
        if (decode) {
          div.innerHTML = html;
          return $sce.trustAsHtml(div.textContent);
        }
        return $sce.trustAsHtml(html);
      };
    }])

})();

(function() {
  'use strict';

  angular
    .module('app.core')
    .controller('TemplateBuilderController', TemplateBuilderController);


  /** @ngInject */
  function TemplateBuilderController($scope, $rootScope, templateBuilderUtils, $sce, templateBuilderConfig, msUtils, dragulaService, disabledElements, $mdDialog, $mdToast, currentEmail, currentContent, emailName, $timeout, sessionService, mailingService, backendService, requestContext, section, $translate, split, mailingToContent,
//     $rootScope, $document, $mdDialog, $mdMenu, $mdMedia, $mdToast, $mdSidenav, $state, requestContext, $timeout, mailingService, transformMailing, fieldsTemplateMailing, msUtils, $anchorScroll, sessionService, tinyMceService, $window, mediaService, sharedFunctionsMailing, dragulaService, templateBuilderConfig
  ) {

    var vm = this;
    $scope.global = $rootScope;
    var siteID = requestContext.getParam("siteId");
    $scope.siteID = siteID;
    $scope.section = section;

    vm.currentThread_edit = angular.copy(currentEmail);
    $scope.defaultTemplate = {
      name: emailName,
      elements: [],
      html: '',
      emailSettings: {
        options: templateBuilderConfig.defaults.emailOptions,
        type: 'emailSettings'
      }
    };
    vm.viewPreview = false;

    if(mailingToContent){
      vm.mailingToContent = mailingToContent;
      vm.zonesInSections = [];
      backendService.getSections({
        siteID: $scope.siteID
      }).then(function(response){
        let sections = [];
        angular.forEach(vm.mailingToContent, function(section){
          let sectionToPush = response.data.find(x => x.section == section.name);
          sectionToPush.name = section.label;
          sections.push(sectionToPush);
        });
        angular.forEach(sections, function(section) {
          backendService.getSectionRef({domain: $scope.siteID, section: section.section}).then(function(response){
            let zones = [];
            angular.forEach(response, function(ref){
              if(ref.type == 'zone'){
                zones.push(ref);
              }
            });
            let sectionZones = {
              section: section.name,
              id_section: section.id_section,
              zones: zones
            }
            vm.zonesInSections.push(sectionZones);
            console.log('vm.zonesInSections', vm.zonesInSections);
          });
        });
      });
    }else{
      vm.mailingToContent = [];
    }

    // Defensa: el diseño puede llegar sin parsear (string JSON) si la carga del
    // content falló antes de tiempo. Antes se caía al template vacío y el editor
    // se abría en blanco sin avisar; aquí lo recuperamos.
    if (angular.isString(currentEmail)) {
      try {
        currentEmail = angular.fromJson(currentEmail);
      } catch (e) {
        console.error('[template-builder] structure_mjml no es JSON válido:', e.message);
        currentEmail = {};
      }
    }
    if (!currentEmail || !angular.isObject(currentEmail)) {
      currentEmail = {};
    }

    if (!angular.isUndefined(currentEmail.elements)) {
      vm.Email = angular.copy(currentEmail);
      for(var i=0; i<vm.Email.elements.length; i++){
        var el = vm.Email.elements[i];
        // Un tipo de bloque no registrado (o un elemento sin options) no debe
        // romper el builder entero: lo dejamos tal cual y seguimos.
        if (!el || !templateBuilderConfig.blocks[el.type]) {
          console.warn('[template-builder] tipo de elemento desconocido, se omite:', el && el.type);
          continue;
        }
        if (!el.options) {
          el.options = {};
        }
        var defaultOptions = templateBuilderConfig.blocks[el.type].defaultOptions;
        for(var k in defaultOptions){
          if(!el.options.hasOwnProperty(k)){
            el.options[k] = defaultOptions[k];
          }
          if(k == 'exportMedia' && angular.isArray(el.options[k])){
            el.options[k] = {};
          }
          if(typeof defaultOptions[k] == 'object'){
            for(var k2 in defaultOptions[k]){
              if(k2.indexOf('Options') != -1){
                el.options[k][k2] = defaultOptions[k][k2];
              }
            }
          }
        }
      }
      vm.cloneEmail = JSON.parse(JSON.stringify(currentEmail));
    } else {
      vm.Email = $scope.defaultTemplate;
      vm.cloneEmail = JSON.parse(JSON.stringify($scope.defaultTemplate));
    }
    $scope.$evalAsync(function() {
      vm.currentElement = vm.Email.emailSettings;
    })

    if (sessionService.site_operative.mailingFonts) {
      angular.forEach(sessionService.site_operative.mailingFonts, function(font) {
        if (templateBuilderConfig.blocks.title.defaultOptions.font.familyOptions.indexOf(font.name) == -1) {
          templateBuilderConfig.blocks.title.defaultOptions.font.familyOptions.push(font.name);
        }
      });
    }

    vm.elements = Object.keys(templateBuilderConfig.blocks).map(function(key) {
      return templateBuilderConfig.blocks[key].element
    }).sort(function(elem, elem2) {
      return templateBuilderConfig.blocks[elem.type].sort - templateBuilderConfig.blocks[elem2.type].sort
    }).filter(function(elem) {
      return disabledElements.indexOf(elem.type) === -1
    })

    vm.splitContent = split;

    // METHODS
    vm.closeDialog = closeDialog;
    vm.saveTemplate = saveTemplate;
    vm.getVariable  = getVariable;
    vm.addSocialNetwork = addSocialNetwork;
    vm.getTemplate  = getTemplate;
    vm.removeElement = removeElement;
    vm.cloneElement = cloneElement;
    vm.editElement = editElement;
    vm.elementChanged = elementChanged;
    vm.hasChanges = hasChanges;
    vm.saveEmailTemplate = saveEmailTemplate;
    vm.updateEmailTemplate = updateEmailTemplate;
    vm.exportEmailAsJson = exportEmailAsJson;
    vm.openExportContainer = openExportContainer;
    vm.downloadHtml = downloadHtml;
    vm.importEmail = importEmail;
    vm.previewEmail = previewEmail;
    vm.deleteAllElements = deleteAllElements;
    vm.toggleView = toggleView;
    vm.addWebSection = addWebSection;
    vm.deleteWebSection = deleteWebSection;
    vm.selectMedia = selectMedia;
    vm.changeTitlePosition = changeTitlePosition;
    
    let intervalBackup;
    backupInterval();
    // $mdDialog destroys this scope however the dialog closes, but setInterval
    // is not tied to it: a dialog dismissed with Esc or a backdrop click (both
    // skip closeDialog) kept backing up every five minutes for the life of the
    // tab, from whichever module the user had moved on to.
    $scope.$on('$destroy', stopBackup);
    function backupInterval() {
      if(!intervalBackup){
        intervalBackup = setInterval(saveBackup, 300000);
      }
    }

    function stopBackup() {
      clearInterval(intervalBackup);
      intervalBackup = null; // backupInterval() tests the handle, not the timer
    }
    
    // Normaliza test_emails_json (puede venir como array o como string JSON)
    // a un array, que es lo que espera el validador de la API.
    function _asEmailArray(v) {
      if (angular.isArray(v)) { return v; }
      if (typeof v === 'string') {
        try { var p = angular.fromJson(v); return angular.isArray(p) ? p : []; }
        catch (e) { return []; }
      }
      return [];
    }

    function saveBackup() {
      var item = {};
      var options = {
        site: $scope.siteID,
        section: $scope.section,
        item: item
      }
      // Workaround anti-vaciado: la API fuerza test_emails_json en cada update
      // (json_encode del valor recibido); si el autosave no lo manda, lo pone a
      // null y se pierden los usuarios de test. Reenviamos el valor actual.
      item.test_emails_json = _asEmailArray(currentContent.test_emails_json);
      switch(section){
        case 'content':
          options.id = currentContent.id_mailing_content;
          item.id_mailing_template = currentContent.mailing_template.id_mailing_templates;
          item.subject = currentContent.subject;
        break;
        case 'templates':
          options.id = currentContent.id;
          item.id_mailing_template = currentContent.id_mailing_templates;
        break;
      }
      // Backups go to structure_mjml_temp, which only mailing_content and
      // mailing_templates have. Communications, massive messages and records
      // not saved yet have no id here: $resource would drop :id and PUT to the
      // collection route, which answers 405 and pops an alert. Nothing to do.
      if (!options.id) {
        return;
      }
      var backupEmail = angular.copy(vm.Email);
      templateBuilderUtils.createEmail(backupEmail, currentContent).then(function(response){
        if (response.data.output.errors.length)
        {
          return templateBuilderUtils.notify(response.data.output.errors.map(function(err) {
            return err.message
          }).join('<br>')).error()
        }else{
          vm.backupEmail = backupEmail;
          item.structure_mjml_temp = backupEmail;
          mailingService.saveItem(options).then(function (response){
            var message = $translate.instant('MAILING.BACKUP.SAVED');
            $mdToast.show({
              template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
              hideDelay: 5000,
              position: 'top',
              parent: '#content-container'
            });
          })
        }
      }, function(err) {
        mailingService.convertLog({
          site: $scope.siteID,
          email: vm.Email,
          response: err
        })

        var errMessage = err.data.detail;
        if (err.data.detail == "Cannot read property 'trim' of null") {
            errMessage = msUtils.translate('MAILING.CHECK_EMPTY_FIELDS')
        }
        vm.isSaving= false;
        return templateBuilderUtils.notify(errMessage).error()
      })
    }

    function changeTitlePosition(option){
      if(!vm.currentThread_edit.id_cat){
        vm.currentThread_edit.id_cat = option.id_cat;
        vm.elementHeaderWeb.active_layout = option.layout_align;
        vm.elementHeaderWeb.options = {
          title_position: option.layout_align,
          title_align: 'left',
          color: '#FFFFFF',
          padding: ['0px', '0px', '0px', '0px']
        }
      }else{
        if(option.id_cat == vm.currentThread_edit.id_cat){
          vm.currentThread_edit.id_cat = null;
          vm.elementHeaderWeb.active_layout = null;
          vm.elementHeaderWeb.options = {
            title_position: null
          };
        }else{
          vm.currentThread_edit.id_cat = option.id_cat;
          vm.elementHeaderWeb.active_layout = option.layout_align;
          vm.elementHeaderWeb.options.title_position = option.layout_align;
        }
      }
    }

    function selectMedia(ev, element) {
      var item = { Thumbnail: [] };
      $mdDialog.show({
          controller: 'MediaDialogController',
          controllerAs: 'vm',
          locals: {
              autoUpload: '',
              currentThread: item,
              section: '',
              mediazone: false,
              isTiny: false,
              maxAttach: 1,
              showViews: {
                  1: true,
                  2: false,
                  3: false,
                  4: false,
                  5: false,
                  upload: false,
                  import: false
              }
          },
          templateUrl: 'app/main/dialogs/media/media-dialog.html',
          targetEvent: ev,
          clickOutsideToClose: true,
          multiple: true
      }).then(function (response) {
          if (response.Thumbnail && angular.isArray(response.Thumbnail) && response.Thumbnail.length > 0) {
              element.media = response.Thumbnail;
          }
      });
  }

    function deleteWebSection(index){
      var messageConfirm = msUtils.translate('GLOBAL.SURE_DELETE_ELEMENT');
      var confirm = $mdDialog.confirm()
        .title(messageConfirm)
        .ariaLabel('Delete item')
        .ok(msUtils.translate('GLOBAL.OK'))
        .cancel(msUtils.translate('GLOBAL.CANCEL'))
        .multiple(true)
      ;
      var message = msUtils.translate('GLOBAL.ELEMENT_DELETED');
      $mdDialog.show(confirm).then(function () {
        vm.currentWeb.splice(index, 1);
        $mdToast.show({
          template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
          hideDelay: 5000,
          position: 'top',
          parent: '#content-container'
        });
      });
    }

    function addWebSection(index, ID) {
      var element = vm.webElements.find(x => x.value.id == ID);
      element = {
        Thumbnail: [],
        media: [],
        subtitle: 'This is the subtitle',
        template: element.value,
        text: 'This is the text',
        options: element.options
      }
      vm.currentWeb.splice(index - 1, 0, element);
      $scope.$apply();
    }

    function closeDialog() {
      // Don't stop the backup timer here: Cancel on the confirm below keeps the
      // editor open. The $destroy handler stops it once the dialog really closes.
      if (hasChanges()) {
        var messageConfirm = msUtils.translate('GLOBAL.ARE_YOU_SURE_LOST_CHANGES');
        var confirm = $mdDialog.confirm()
          .title(messageConfirm)
          .ariaLabel('Lost changes')
          .ok(msUtils.translate('GLOBAL.OK'))
          .cancel(msUtils.translate('GLOBAL.CANCEL'))
          .multiple(true)
        ;
        $mdDialog.show(confirm).then(function () {
          $mdDialog.hide();
        });
      } else
      {
        $mdDialog.hide();
      }
    }

    function showNewCaseDialog(event, newElements) {
      var parent = angular.element(document.body);
      $mdDialog.show({
        controller: 'addCaseTextDialog',
        controllerAs: 'vm',
        locals: {
          elements: newElements
        },
        templateUrl: 'app/main/apps/content/dialogs/add-case-text-dialog/add-case-text-dialog.controller.html',
        parent: parent,
        targetEvent: event,
        clickOutsideToClose: true,
        multiple: true
      }).then(function () {

      });
    }
    
    function saveTemplate() {
      // stopBackup, not a bare clearInterval: the handle must go back to null or
      // backupInterval() below would think the timer is still running.
      stopBackup();
      vm.isSaving = true;
      templateBuilderUtils.createEmail(vm.Email, currentContent).then(function(res) {
        if (res.data.output.errors.length)
        {
          // The save did not happen and the editor stays open: backups back on.
          backupInterval();
          vm.isSaving = false;
          return templateBuilderUtils.notify(res.data.output.errors.map(function(err) {
            return err.message
          }).join('<br>')).error()
        }
        else
        {
          vm.Email.html = res.data.output.html;
          console.log('vm.Email', vm.Email);
          switch(section){
            case 'content':
              var mailObj = {
                email: vm.Email,
                backup: vm.backupEmail
              }
              $mdDialog.hide(mailObj);
            break;
            case 'massive-messages':
              var mailObj = {
                email: vm.Email,
                backup: vm.backupEmail
              }
              $mdDialog.hide(mailObj);
            break;
            default:
              $mdDialog.hide(vm.Email);
            break;
          }
        }
        vm.isSaving = false;
      }, function(err) {
        mailingService.convertLog({
          site: $scope.siteID,
          email: vm.Email,
          response: err
        })

        var errMessage = err.data.detail;
        if (err.data.detail == "Cannot read property 'trim' of null") {
            errMessage = msUtils.translate('MAILING.CHECK_EMPTY_FIELDS')
        }
        vm.isSaving= false;
        backupInterval(); // editor still open after a failed save
        return templateBuilderUtils.notify(errMessage).error()
      })
    }

    /**
     * Check variables from HTML
     */
    function getVariable(prop) {
      return templateBuilderConfig[prop]
    }

    /**
     * Default language
     * @type {string}
     */
    vm.currentLanguage = 'en';

    /**
     * Tinymce options
     * @type {{inline: boolean, skin: string, theme: string, plugins: string[], toolbar: string, fontsize_formats: string}}
     */
    vm.tinymceOptions = {
      inline: true,
      skin: 'lightgray',
      theme: 'modern',
      convert_urls: false,
      plugins: ["advlist autolink lists link image charmap", "searchreplace visualblocks code", "insertdatetime media table contextmenu paste", 'textcolor colorpicker textpattern'],
      toolbar: "undo redo | bold italic fontsizeselect forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist | link",
      fontsize_formats: '8pt 9pt 10pt 11pt 12pt 13pt 14pt 15pt 16pt 18pt 20pt 22pt 24pt 28pt 36pt 42pt 48pt'
    };

    vm.tinymceWebOptions = {
      inline: true,
      menubar: false,
      statusbar: false,
      toolbar: false
    }

    /**
     * Include Mailchimo Merge tags in Tinymce if is enabled
     */
    if (templateBuilderConfig.includeMailchimpMergeTags)
    {
      vm.tinymceOptions = angular.extend(vm.tinymceOptions, {
        setup: function(editor) {
          editor.addButton('mailchimpMergeTags', {
            type: 'menubutton',
            text: 'Merge Tags',
            icon: false,
            menu: ['*|FNAME|*', '*|LNAME|*', '*|EMAIL|*', '*|LIST:NAME|*', '*|LIST:COMPANY|*', '*|LIST:SUBSCRIBERS|*', '*|USER:COMPANY|*', '*|USER:ADDRESS|*', '*|USER:PHONE|*', '*|MC:DATE|*', '*|CURRENT_YEAR|*', '*|UNSUB|*', '*|UPDATE_PROFILE|*'].map(function(tag) {
              return {
                text: tag,
                onclick: function() {
                  editor.insertContent(tag);
                }
              }
            })
          });
        }
      });
    }

    function addSocialNetwork(links, selectedNetwork) {
      if (selectedNetwork)
      {
        links[selectedNetwork].active = true
      }
    }

    /**
     * Get template by type
     *
     * @param type
     * @returns {string}
     */
    function getTemplate(type, element) {
      if(type){
        return 'app/main/plugins/template-builder/fields/' + type + '.html';
      }else{
        var url = 'app/main/plugins/template-builder/web-fields/';
        switch(element.template.id){
          case 1:
            url = url + 'full-width-text-centered' +'.html';
          break;
          case 2:
            url = url + 'right-text-left-image' +'.html';
          break;
          case 3:
            url = url + 'right-image-left-text' +'.html';
          break;
          case 4:
            url = url + 'full-width-black-background' +'.html';
          break;
          case 5:
            url = url + 'image-only' +'.html';
          break;
        }
        return url;
      }
    };

    /**
     * Remove block element by id
     * @param id
     */
    function removeElement(id, location) {
      var messageConfirm = msUtils.translate('GLOBAL.SURE_DELETE_ELEMENT');

      var confirm = $mdDialog.confirm()
        .title(messageConfirm)
        .ariaLabel('Delete item')
        .ok(msUtils.translate('GLOBAL.OK'))
        .cancel(msUtils.translate('GLOBAL.CANCEL'))
        .multiple(true)
      ;
      var message = msUtils.translate('GLOBAL.ELEMENT_DELETED');
      $mdDialog.show(confirm).then(function () {
        switch (location){
          case 'header':
            var el = templateBuilderUtils.findWhere(vm.Email.header.elements, {
              id: id
            });
            vm.Email.header.elements.splice(vm.Email.header.elements.indexOf(el), 1);
          break;
          case 'content':
            var el = templateBuilderUtils.findWhere(vm.Email.elements, {
              id: id
            });
            vm.Email.elements.splice(vm.Email.elements.indexOf(el), 1);
          break;
          case 'footer':
            var el = templateBuilderUtils.findWhere(vm.Email.footer.elements, {
              id: id
            });
            vm.Email.footer.elements.splice(vm.Email.footer.elements.indexOf(el), 1);
          break;  
        }
        vm.currentElement = vm.Email.emailSettings;
        $mdToast.show({
          template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
          hideDelay: 5000,
          position: 'top',
          parent: '#content-container'
        });
      });
    };

    /**
     * Clone block element by id
     * @param id
     */
    function cloneElement(id, location) {
      switch(location){
        case 'header':
          var container = vm.Email.header.elements;
        break;
        case 'content':
          var container = vm.Email.elements;
        break;
        case 'footer':
          var container = vm.Email.footer.elements;
        break;
      }
      var el = templateBuilderUtils.findWhere(container, {
        id: id
      });
      var newEl = JSON.parse(JSON.stringify(el));
      newEl.id = templateBuilderUtils.uid();
      container.splice(container.indexOf(el) + 1, 0, newEl);
      // vm.changeHtml()
    };

    /**
     * Edit block element by id
     * @param id
     */
    function editElement(id, element, location) {
        if (!id)
      {
        return vm.currentElement = vm.Email.emailSettings
      }
      if (vm.preview)
      {
        return;
      }
      switch(location){
        case 'header':
          var container = vm.Email.header.elements;
        break;
        case 'content':
          var container = vm.Email.elements;
        break;
        case 'footer':
          var container = vm.Email.footer.elements;
        break;
      }
      vm.currentElement = id != 'emailSettings' ? templateBuilderUtils.findWhere(container, {
        id: id
      }) : vm.Email[id];
      console.log('vm.currentElement', vm.currentElement);
      $timeout(function() {
        $('.template-builder-settings').scrollTop(0)
        if (vm.currentElement && vm.currentElement.type && ['text','text2x2','text3x2'].includes(vm.currentElement.type)) {
          updateTinyMceFloatPanelPosition(vm.currentElement)
        }
      });
    };

    function elementChanged(element) {
      if (element && element.type && ['text','text2x2','text3x2'].includes(element.type)) {
        updateTinyMceFloatPanelPosition(element)
      }
    }

    /*
     * Keep the active TinyMce float panel displayed on element's top, or at dialog's buttom if element's top is too far up.
     * Fixes an issue where the panel of long text elements disappears at some point while scrolling down the view.
     */
    function updateTinyMceFloatPanelPosition(element) {

      var el = $('#'+element.id); // Text element
      if (!el) return;

      var dialogToolbar = el.closest('md-dialog').find('md-toolbar:first-child');
      var activePanel = $('.mce-floatpanel').filter(function() { return $(this).css("display") != "none" }).first();

      if (dialogToolbar.length === 0 || activePanel.length === 0) return;

      // Calc float panel target position on top of text element
      var activePanelTargetPositionOnTopOfElement = Math.round(el.offset().top) - activePanel.height();

      // Calc bottom position of dialog toolbar
      var toolbarBottom = Math.round(dialogToolbar.offset().top) + dialogToolbar.outerHeight();
      $timeout(function(){
      // Stick the panel to the dialog toolbar bottom once the elements top disappeared beyond the toolbar on down scroll
      activePanel[0].style.setProperty('top', Math.max(activePanelTargetPositionOnTopOfElement, toolbarBottom)+'px', 'important');
      })
    }

    /**
     * Check if email has changed, to enable or disable save button
     * @returns {boolean}
     */
    function hasChanges() {
      return !angular.equals(vm.Email, vm.cloneEmail)
    };

    /**
     * Save email example
     */
    function saveEmailTemplate() {
      templateBuilderUtils.createEmail(vm.Email, currentContent).then(function(res) {
        if (res.data.output.errors.length)
        {
          return templateBuilderUtils.notify(res.data.output.errors.map(function(err) {
            return err.message
          }).join('<br>')).error()
        }
        else
        {
          vm.Email.html = res.data.output.html;
          // vm.Email = is what you need to save
          vm.cloneEmail = JSON.parse(JSON.stringify(vm.Email));
          $scope.$evalAsync(function() {
            vm.currentElement = vm.Email.emailSettings
          })
        }
      }, function(err) {
        return templateBuilderUtils.notify(err).error()
      })
    };

    function updateEmailTemplate() {
      templateBuilderUtils.createEmail(vm.Email, currentContent).then(function(res) {
        if (res.data.output.errors.length)
        {
          return templateBuilderUtils.notify(res.data.output.errors.map(function(err) {
            return err.message
          }).join('<br>')).error()
        }
        else
        {
          vm.Email.html = res.data.output.html;
          vm.cloneEmail = JSON.parse(JSON.stringify(vm.Email));
        }
      }, function(err) {
        return templateBuilderUtils.notify(err).error()
      })
    };

    /**
     * Open export container
     * @returns {*}
     */
    function openExportContainer() {
      if (!vm.Email.elements.length)
      {
        return templateBuilderUtils.notify(msUtils.translate('nothing_to_export')).log();
      }
      vm.exportAsHtml = false;
      vm.currentElement = 'export';
      // vm.changeHtml();
    };

    /**
     * Export email as JSON
     * @returns {*|{trigger, _default}}
     */
    function exportEmailAsJson() {
      var a = document.createElement('a');
      a.target = '_blank';
      a.href = 'data:attachment/json;base64,' + window.btoa(unescape(encodeURIComponent(JSON.stringify(vm.Email))));
      a.download = templateBuilderUtils.uid('export') + '.json';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    };

    /**
     * Download Email as HTML
     */
    function downloadHtml() {
      var a = document.createElement('a');
      a.target = '_blank';
      a.href = 'data:attachment/html;base64,' + window.btoa(unescape(encodeURIComponent(vm.Email.html)));
      a.download = templateBuilderUtils.uid('export') + '.html';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    };

    /**
     * Import email
     * @returns {*}
     */
    function importEmail() {
      var file = $('<input />', {
        type: 'file',
        name: 'import-file'
      }).on('change', function() {
        var importedFile = new FileReader();
        importedFile.onload = function() {
          var importedData = JSON.parse(importedFile.result);
          if (templateBuilderUtils.validateEmail(importedData))
          {
            $scope.$evalAsync(function() {
              vm.currentElement = undefined;
              vm.Email = importedData;
              vm.cloneEmail = JSON.parse(JSON.stringify(importedData));
            });
            templateBuilderUtils.notify(msUtils.translate('email_has_been_imported', {
              lastModified: new Date(fileToImport.lastModified).toLocaleString()
            })).success()
          }
          else
          {
            templateBuilderUtils.notify(msUtils.translate('imported_data_isnt_valid')).error()
          }
        };
        var fileToImport = this.files[0];
        if (fileToImport.name.slice(-4) !== 'json')
        {
          return templateBuilderUtils.notify(msUtils.translate('invalid_format_file')).log()
        }
        importedFile.readAsText(fileToImport)
      });

      if (!vm.Email.elements.length)
      {
        return file.click();
      }

      return templateBuilderUtils.confirm(msUtils.translate('before_import'), function() {
        return file.click()
      }, function() {
        return templateBuilderUtils.notify(msUtils.translate('import_canceled')).log()
      }, msUtils.translate('accept'), msUtils.translate('deny'))
    };

    /**
     * Activate preview Email
     * @returns {*}
     */
    function previewEmail() {
      if (!vm.Email.elements.length)
      {
        return templateBuilderUtils.notify(msUtils.translate('nothing_to_preview')).log();
      }
      vm.preview = true;
      vm.currentElement = undefined;
    };

    /**
     * Delete all elements from builder
     * @returns {*}
     */
    function deleteAllElements() {

      var messageConfirm = msUtils.translate('before_delete_all_elements');

      var confirm = $mdDialog.confirm()
        .title(messageConfirm)
        .ariaLabel('Delete items')
        .ok(msUtils.translate('GLOBAL.OK'))
        .cancel(msUtils.translate('GLOBAL.CANCEL'))
        .multiple(true)
      ;
      var message = msUtils.translate('GLOBAL.ELEMENTS_DELETED');
      $mdDialog.show(confirm).then(function () {
        vm.mobilePreview = false;
        vm.Email = $scope.defaultTemplate;
        vm.Email.elements = [];
        vm.Email.name = '';
        vm.Email.html = '';
        vm.Email.emailSettings.options = templateBuilderConfig.defaults.emailOptions;
        vm.Email.emailSettings.type ='emailSettings';

      });

    };

    function toggleView(viewType) {
      if (!viewType) {
        vm.viewPreview = false;
      } else
      {
        vm.isLoading = true;
        templateBuilderUtils.createEmail(vm.Email, currentContent).then(function(res) {
          if (res.data.output.errors.length)
          {
            return templateBuilderUtils.notify(res.data.output.errors.map(function(err) {
              return err.message
            }).join('<br>')).error()
          }
          else
          {
            vm.Email.html = res.data.output.html;
            // vm.Email = is what you need to save
            vm.cloneEmail = JSON.parse(JSON.stringify(vm.Email));
            $scope.$evalAsync(function() {
              vm.currentElement = vm.Email.emailSettings
            })
            vm.isLoading = false;
            vm.viewPreview = viewType;
          }
        }, function(err) {
          mailingService.convertLog({
            site: $scope.siteID,
            email: vm.Email,
            response: err
          })

          return templateBuilderUtils.notify(err).error()
        })
      }
    }


    /**
     * Show and hide tinymce on preview
     */
    $scope.$watch('preview', function(newV) {
      tinymce.editors.forEach(function(editor) {
        return editor[newV ? 'hide' : 'show']();
      })
    })

    /**
     * Dragula configuration for builder elements
     */
    dragulaService.options($scope, 'element', {
      isContainer: function(el) {
        
        return el.classList.contains('header-container') || el.classList.contains('email-container') || el.classList.contains('footer-container');
      },
      copy: true,
      copySortSource: false,
      removeOnSpill: true,
      moves: function(el, source, handle, sibling) {
        return !$(source).hasClass('header-container') || !$(source).hasClass('email-container') || !$(source).hasClass('footer-container');
      },
      invalid: function(el, handle) {
        return false; // don't prevent any drags from initiating by default
      }
    });

    /**
     * Dragula configuration for builder
     */
    dragulaService.options($scope, 'element-html', {
      copy: false,
      copySortSource: false,
      moves: function(el, source, handle, sibling) {
        return $(handle).hasClass('move');
      },
      invalid: function(el, handle) {
        return false; // don't prevent any drags from initiating by default
      }
    });

    /**
     * Drag and drop events for elements
     */
    $scope.$on('element-html.cancel', function(event, el, target, source) {
      let mailContainer = el[0].parentElement.parentElement;
      for(const child of mailContainer.children){
        $(child).removeClass('div-disabled');
      }
    });
    
    $scope.$on('element.drop', function(event, el, target, source, sibling) {
      console.log('el', el);
      var elementType = $(el).data('type');
      var index = $(sibling).index();
      if(elementType.indexOf('multipleText') != -1){
        var IDelement = elementType.slice(elementType.indexOf('multipleText') + 12, elementType.length);
        addWebSection(index, IDelement);
      }else{
        var element = $.extend(true, {}, {
          type: elementType,
          options: templateBuilderConfig.blocks[elementType].defaultOptions
        });
        element.id = templateBuilderUtils.uid();
          
          if(target[0].classList.contains('header-container')){
            if(!vm.Email.header){
              vm.Email.header = {
                elements: []
              };
            }
            index == -1 ? vm.Email.header.elements.push(element) : vm.Email.header.elements.splice(index - 1, 0, element);
          }else if(target[0].classList.contains('email-container')){
            index == -1 ? vm.Email.elements.push(element) : vm.Email.elements.splice(index - 1, 0, element);
          }else if(target[0].classList.contains('footer-container')){
            if(!vm.Email.footer){
              vm.Email.footer = {
                elements: []
              };
            }
            index == -1 ? vm.Email.footer.elements.push(element) : vm.Email.footer.elements.splice(index - 1, 0, element);
          }
          //$('.email-container li').remove();
          // vm.currentElement = undefined;
          vm.saveEmailTemplate();
      }
      $scope.$apply();
    });

    /**
     * Drag and drop events for elements inside the builder
     */

     var eventFlag = true;
     var scrollFlag = true;

     $scope.$on('element-html.drag', function(event, el, source){
      let mailContainer = el[0].parentElement.parentElement;
      for(const child of mailContainer.children){
        $(child).addClass('div-disabled');
      }
      $(el[0].parentElement).removeClass('div-disabled');
        var id = $(el).attr('id');
        var canvas = document.getElementById(id).parentElement;
        var scrollDiv = canvas.parentElement;
      if(eventFlag == true){
        canvas.addEventListener('mousemove',scrollerFunction);
        eventFlag = false;
      }
      
      function scrollerFunction(evt){
        var mousePosY = evt.clientY;
        var scrollQuantity = scrollDiv.clientHeight/10;
        if(mousePosY < scrollQuantity * 3 && scrollFlag == true){
          scrollDiv.scrollTop = scrollDiv.scrollTop - 10;
        }
        if(mousePosY > scrollQuantity * 9 && scrollFlag == true){
          scrollDiv.scrollTop = scrollDiv.scrollTop + 10;
        }
      }
     });
     
    $scope.$on('element-html.drop', function(event, el, target, source, sibling) {
      let mailContainer = el[0].parentElement.parentElement;
      for(const child of mailContainer.children){
        $(child).removeClass('div-disabled');
      }
      var index = $(sibling).index();
      var id = $(el).attr('id');
      if (index == -1)
      {
        index = vm.Email.elements.length - 1;
      }
      else
      {
        index--;
      }
      var element = templateBuilderUtils.findWhere(vm.Email.elements, {
        id: id
      });
      var oldIndex = vm.Email.elements.indexOf(element);
      if (index >= vm.Email.elements.length)
      {
        var k = index - vm.Email.elements.length;
        while ((k--) + 1)
        {
          vm.Email.elements.push(undefined);
        }
      }
      vm.Email.elements.splice(index, 0, vm.Email.elements.splice(oldIndex, 1)[0]);
      vm.saveEmailTemplate();
    $scope.$apply();
      // vm.currentElement = undefined;
      scrollFlag = false;
      return false;
    });

    $scope.sanitizeMe = function(text) {
      return $sce.trustAsHtml(text)
    };
  }

})();

(function () {
    'use strict';

    /**
     * Main module of the Qiu
     */
    angular
        .module('Qiu', [
            //
            'satellizer',
            'ngConstants',
            'SafeApply',

            // Core
            'app.core',

            // Navigation
            'app.navigation',

            // Navigation
            // 'app.authentication',
            'app.public',

            // Toolbar
            'app.toolbar',

            // Quick panel
            'app.domain-panel',

            // Quick panel
            // 'app.quick-panel',

            // Apps
            'app.dashboards',
            // 'app.calendar',
            'app.content',
            'app.forms',
            'app.match-center',
            'app.social',
            'app.store',
            'app.media',
            'app.mediahub',
            'app.dialog.media-dialog',
            'app.sitemap',
            // 'app.mail',
            // 'app.file-manager',
            // 'app.scrumboard',
            // 'app.gantt-chart',
            'app.backend',
            'app.ai',

            // Pages
            'app.pages',
            'app.tags',
            'app.users',
            'app.projects',
            'app.mailing',
            'app.accounts',
            'app.module-template',
            'app.maps',
            'app.runtag'
            // Components
            // 'app.components'

        ]);
})();
(function () {
  'use strict';

  const defaultFontFamily = [
    'inherit',
    'Georgia, serif',
    '\'Palatino Linotype\', \'Book Antiqua\', Palatino, serif',
    '\'Times New Roman\', Times, serif',
    'Arial, Helvetica, sans-serif',
    '\'Arial Black\', Gadget, sans-serif',
    '\'Comic Sans MS\', cursive, sans-serif',
    'Impact, Charcoal, sans-serif',
    '\'Lucida Sans Unicode\', \'Lucida Grande\', sans-serif',
    'Tahoma, Geneva, sans-serif',
    '\'Trebuchet MS\', Helvetica, sans-serif',
    'Verdana, Geneva, sans-serif',
    '\'Courier New\', Courier, monospace',
    '\'Lucida Console\', Monaco, monospace'
  ];

  angular
    .module('Qiu')
    .constant('templateBuilderConfig', {
      assetsPath: 'https://new.qiusystem.com/assets/images/template-builder',
      layoutsPath: '/builder/layouts', // Path of layouts
      defaultLayout: 'modern', // modern or material
      defaultSkin: 'light', // light or dark
      urlToUploadImage: '//uploads.im/api',
      tinymceBaseUrl: '/bower_components/tinymce',
      translateTemplateUrl: 'i18n/{part}/{lang}.json',
      mjmlPublicKey: '',
      mjmlApplicationId: '',
      mjmlCompileAdress: 'https://ffc9g9yfhc.execute-api.us-east-1.amazonaws.com/prod/convert', // You can leave it empty if you have mjmlPublicKey and mjmlApplicationId completed from above
      buildFolder: "_dist", // Default distribution folder
      builderTitle: "Angular email builder", // Default builder Title
      builderDescription: "", // Default builder meta description
      UA: "", // Your Google Analytics ID
      exportHtml: true,
      importHtml: true,
      deleteAllBlocks: true,
      trackEvents: false,
      includeMailchimpMergeTags: false,
      defaults: {
        newEmailName: '',
        emailOptions: {
          paddingTop: "15px",
          paddingRight: "10px",
          paddingBottom: "15px",
          paddingLeft: "10px",
          backgroundColor: "#c0c0c0"
        }
      },
      disableBlocks: [],
      blocks: {
        'title': {
          type: 'title',
          sort: 3,
          element: {
            type: 'title',
            icon: 'icon-format-text',
            primary_head: 'builder_el_title',
            second_head: 'builder_el_title_comment'
          },
          defaultOptions: {
            title: 'Enter your title here',
            subTitle: 'Subtitle',
            align: 'center',
            padding: ["30px", "30px", "30px", "30px"],
            backgroundColor: '#fff',
            font: {
              weight: 'normal',
              weightOptions: ['bold', 'bolder', 'lighter', 'inherit', 'initial', 'normal', 100, 200, 300, 400, 500, 600, 700, 800, 900],
              family: 'Arial, Helvetica, sans-serif',
              familyOptions: defaultFontFamily
            },
            color: '#444444',
            exportable: true
          }
        },
        'button': {
          type: 'button',
          sort: 8,
          element: {
            type: 'button',
            icon: 'icon-cursor-pointer',
            primary_head: 'builder_el_button',
            second_head: 'builder_el_button_comment'
          },
          defaultOptions: {
            buttonText: 'Click me',
            url: '#',
            align: 'center',
            padding: ['12px', '20px', '12px', '20px'],
            margin: ['15px', '30px', '15px', '30px'],
            backgroundColor: '#ffffff',
            border: {
              size: 1,
              radius: 3,
              color: '#3498DB',
              style: 'solid',
              styleOptions: ['dotted', 'solid', 'dashed']
            },
            font: {
              size: 15,
              color: '#ffffff',
              weight: 'normal',
              weightOptions: ['bold', 'bolder', 'lighter', 'inherit', 'initial', 'normal', 100, 200, 300, 400, 500, 600, 700, 800, 900],
              family: 'Arial, Helvetica, sans-serif',
              familyOptions: defaultFontFamily
            },
            buttonBackgroundColor: '#3498DB',
            fullWidth: false,
            exportable: true
          }
        },
        'text': {
          type: 'text',
          sort: 4,
          element: {
            type: 'text',
            icon: 'icon-view-headline',
            primary_head: 'builder_el_text',
            second_head: 'builder_el_text_comment'
          },
          defaultOptions: {
            padding: ['10px', '30px', '10px', '30px'],
            backgroundColor: '#ffffff',
            color: '#000000',
            font: {
              family: 'Arial, Helvetica, sans-serif',
              familyOptions: defaultFontFamily
            },
            text: '<p>Lorem ipsum dolor sit amet, consectetur adipisci elit, sed eiusmod tempor incidunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur. Quis aute iure reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint obcaecat cupiditat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. </p>',
            exportable: true
          }
        },
        'social': {
          type: 'social',
          sort: 15,
          element: {
            type: 'social',
            icon: 'icon-thumb-up-outline',
            primary_head: 'social_icons',
            second_head: 'social_icons_comment'
          },
          defaultOptions: {
            align: 'center',
            padding: ['10px', '30px', '10px', '30px'],
            backgroundColor: '#eeeeee',
            size: 32,
            links: {
              facebook: {
                link: 'https://www.facebook.com/',
                active: true,
                imageSingle: {
                  id_media: 0,
                  id_zone: null,
                  fields: {
                    filename: '',
                    photographer: '',
                    owner: '',
                    caption: '',
                    title: ''
                  },
                  url: 'https://new.qiusystem.com/assets/images/template-builder/social/facebook.png',
                  cropformat: 'original',
                  cropformats: {
                    original: 'https://new.qiusystem.com/assets/images/template-builder/social/facebook.png'
                  }
                },
              },
              twitter: {
                link: 'https://twitter.com/',
                active: true,
                imageSingle: {
                  id_media: 0,
                  id_zone: null,
                  fields: {
                    filename: '',
                    photographer: '',
                    owner: '',
                    caption: '',
                    title: ''
                  },
                  url: 'https://new.qiusystem.com/assets/images/template-builder/social/twitter.png',
                  cropformat: 'original',
                  cropformats: {
                    original: 'https://new.qiusystem.com/assets/images/template-builder/social/twitter.png'
                  }
                }
              },
              instagram: {
                link: 'https://www.instagram.com/',
                active: true,
                imageSingle: {
                  id_media: 0,
                  id_zone: null,
                  fields: {
                    filename: '',
                    photographer: '',
                    owner: '',
                    caption: '',
                    title: ''
                  },
                  url: 'https://new.qiusystem.com/assets/images/template-builder/social/instagram.png',
                  cropformat: 'original',
                  cropformats: {
                    original: 'https://new.qiusystem.com/assets/images/template-builder/social/instagram.png'
                  }
                }
              },
              linkedin: {
                link: '',
                active: false,
                imageSingle: {
                  id_media: 0,
                  id_zone: null,
                  fields: {
                    filename: '',
                    photographer: '',
                    owner: '',
                    caption: '',
                    title: ''
                  },
                  url: 'https://new.qiusystem.com/assets/images/template-builder/social/linkedin.png',
                  cropformat: 'original',
                  cropformats: {
                    original: 'https://new.qiusystem.com/assets/images/template-builder/social/linkedin.png'
                  }
                }
              },
              youtube: {
                link: 'https://www.youtube.com/',
                active: true,
                imageSingle: {
                  id_media: 0,
                  id_zone: null,
                  fields: {
                    filename: '',
                    photographer: '',
                    owner: '',
                    caption: '',
                    title: ''
                  },
                  url: 'https://new.qiusystem.com/assets/images/template-builder/social/youtube.png',
                  cropformat: 'original',
                  cropformats: {
                    original: 'https://new.qiusystem.com/assets/images/template-builder/social/youtube.png'
                  }
                }
              },
              vimeo: {
                link: 'https://www.vimeo.com/',
                active: true,
                imageSingle: {
                  id_media: 0,
                  id_zone: null,
                  fields: {
                    filename: '',
                    photographer: '',
                    owner: '',
                    caption: '',
                    title: ''
                  },
                  url: 'https://new.qiusystem.com/assets/images/template-builder/social/vimeo.png',
                  cropformat: 'original',
                  cropformats: {
                    original: 'https://new.qiusystem.com/assets/images/template-builder/social/vimeo.png'
                  }
                }
              },
              tiktok: {
                link: 'https://www.tiktok.com/',
                active: true,
                imageSingle: {
                  id_media: 0,
                  id_zone: null,
                  fields: {
                    filename: '',
                    photographer: '',
                    owner: '',
                    caption: '',
                    title: ''
                  },
                  url: 'https://new.qiusystem.com/assets/images/template-builder/social/tiktok.png',
                  cropformat: 'original',
                  cropformats: {
                    original: 'https://new.qiusystem.com/assets/images/template-builder/social/tiktok.png'
                  }
                }
              }
            },
            exportable: true
          }
        },
        'divider': {
          type: 'divider',
          sort: 9,
          element: {
            type: 'divider',
            icon: 'icon-minus',
            primary_head: 'builder_el_divider',
            second_head: 'builder_el_divider_comment'
          },
          defaultOptions: {
            padding: ['15px', '30px', '15px', '30px'],
            backgroundColor: '#ffffff',
            border: {
              size: 1,
              style: 'solid',
              styleOptions: ['solid', 'dashed', 'dotted'],
              color: '#DADFE1'
            },
            exportable: true
          }
        },
        'header': {
          type: 'header',
          sort: 1,
          element: {
            type: 'header',
            icon: 'icon-header',
            primary_head: 'builder_el_header',
            second_head: 'builder_el_header_comment',
            totalMedia: 1
          },
          defaultOptions: {
            align: 'center',
            padding: ["0", "0", "0", "0"],
            backgroundColor: '#ffffff',
            imageSingle1: {
              id_media: 0,
              id_zone: null,
              fields: {
                filename: '',
                photographer: '',
                owner: '',
                caption: '',
                title: ''
              },
              url: 'https://new.qiusystem.com/assets/images/template-builder/header.jpg',
              cropformat: 'original',
              cropformats: {
                original: 'https://new.qiusystem.com/assets/images/template-builder/header.jpg',
                1001: 'https://new.qiusystem.com/assets/images/template-builder/header.jpg',
                1002: 'https://new.qiusystem.com/assets/images/template-builder/header.jpg',
              }
            },
            mediaCropformats: {
              cropformat: '',
              cropformats: {
                original: 'Original'
              }
            },
            linkTo: {
              type: 'none',
              typeOptions: ['none', 'link', 'original', 'mediacenter', 'email'],
              link: '',
              text: 'Download'
            },
            width: '600',
            exportable: true,
            exportMedia: {}
          }
        },
        'footerImage': {
          type: 'footerImage',
          sort: 2,
          element: {
            type: 'footerImage',
            icon: 'icon-footer',
            primary_head: 'builder_el_image_footer',
            second_head: 'builder_el_footer_image_comment'
          },
          defaultOptions: {
            align: 'center',
            padding: ["0", "0", "0", "0"],
            backgroundColor: '#ffffff',
            imageSingle1: {
              id_media: 0,
              id_zone: null,
              fields: {
                filename: '',
                photographer: '',
                owner: '',
                caption: '',
                title: ''
              },
              url: 'https://new.qiusystem.com/assets/images/template-builder/footer.jpg',
              cropformat: 'original',
              cropformats: {
                original: 'https://new.qiusystem.com/assets/images/template-builder/footer.jpg',
                1001: 'https://new.qiusystem.com/assets/images/template-builder/footer.jpg',
                1002: 'https://new.qiusystem.com/assets/images/template-builder/footer.jpg',
              }
            },
            mediaCropformats: {
              cropformat: '',
              cropformats: {
                original: 'Original'
              }
            },
            linkTo: {
              type: 'none',
              typeOptions: ['none', 'link', 'original', 'mediacenter', 'email'],
              link: '',
              text: 'Download'
            },
            width: '600',
            exportable: true,
            exportMedia: {}
          }
        },
        'footerLegal': {
          type: 'footerLegal',
          sort: 7,
          element: {
            type: 'footerLegal',
            icon: 'icon-legal-footer',
            primary_head: 'builder_el_legal_footer',
            second_head: 'builder_el_legal_footer_comment'
          },
          defaultOptions: {
            align: 'left',
            padding: ['10px', '30px', '10px', '30px'],
            backgroundColor: '#ffffff',
            font: {
              size: 13,
              color: '#777777',
              weight: 'normal',
              weightOptions: ['bold', 'bolder', 'lighter', 'inherit', 'initial', 'normal', 100, 200, 300, 400, 500, 600, 700, 800, 900],
              family: 'Arial, Helvetica, sans-serif',
              familyOptions: defaultFontFamily
            },
            textAddress: '<p>Company name. Addess 1234, 1234 City - State - Country</p>',
            textIntended: '<p>This message was intended for: %%USER_EMAIL%%</p>',
            textUnsubscribe: 'UNSUBSCRIBE',
            textManage: 'MANAGE SUBSCRIPTIONS',
            exportable: true
          }
        },
        'image': {
          type: 'image',
          sort: 10,
          element: {
            type: 'image',
            icon: 'icon-picture',
            primary_head: 'builder_el_image',
            second_head: 'builder_el_image_comment'
          },
          defaultOptions: {
            align: 'center',
            padding: ["15px", "0", "15px", "0"],
            backgroundColor: '#ffffff',
            width: '600',
            color: "#888888",
            mediaCropformats: {
              cropformat: '',
              cropformats: {
                original: 'Original'
              }
            },
            mediaCaption: {
              type: 'none',
              typeOptions: ['none', 'caption', 'photographer', 'title', 'caption_photographer', 'title_photographer','caption_owner', 'custom', 'owner'],
              custom: '',
              prefix: '',
              suffix: ''
            },
            linkTo: {
              type: 'none',
              typeOptions: ['none', 'link', 'original', 'mediacenter', 'email'],
              link: '',
              text: 'Download'
            },
            paddingDownload: ["10px", "10px", "10px", "10px"],
            paddingCaption: ["10px", "10px", "10px", "10px"],
            font: {
              weight: 'normal',
              weightOptions: ['bold', 'bolder', 'lighter', 'inherit', 'initial', 'normal', 100, 200, 300, 400, 500, 600, 700, 800, 900],
              family: 'Arial, Helvetica, sans-serif',
              familyOptions: defaultFontFamily
            },
            imageSingle1: {
              id_media: 0,
              id_zone: null,
              fields: {
                filename: '',
                photographer: '',
                owner: '',
                caption: '',
                title: ''
              },
              url: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
              cropformat: 'original',
              cropformats: {
                original: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
                1001: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
                1002: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
              }
            },
            exportable: true,
            exportMedia: {}
          }
        },
        'imageTextRight': {
          type: 'imageTextRight',
          sort: 11,
          element: {
            type: 'imageTextRight',
            icon: 'icon-img-left',
            primary_head: 'builder_el_image_text_right',
            second_head: 'builder_el_image_text_right_comment'
          },
          defaultOptions: {
            align: 'left',
            padding: ["15px", "30px", "15px", "30px"],
            backgroundColor: '#ffffff',
            font: {
              weight: 'normal',
              weightOptions: ['bold', 'bolder', 'lighter', 'inherit', 'initial', 'normal', 100, 200, 300, 400, 500, 600, 700, 800, 900],
              family: 'Arial, Helvetica, sans-serif',
              familyOptions: defaultFontFamily
            },
            color: "#000000",
            mediaCropformats: {
              cropformat: '',
              cropformats: {
                original: 'Original'
              }
            },
            imageSingle1: {
              id_media: 0,
              id_zone: null,
              fields: {
                filename: '',
                photographer: '',
                owner: '',
                caption: '',
                title: ''
              },
              url: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
              cropformat: 'original',
              cropformats: {
                original: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
                1001: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
                1002: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
              }
            },
            mediaCaption: {
              type: 'none',
              typeOptions: ['none', 'caption', 'photographer', 'title', 'caption_photographer', 'title_photographer','caption_owner', 'custom', 'owner'],
              custom: '',
              prefix: '',
              suffix: ''
            },
            linkTo: {
              type: 'none',
              typeOptions: ['none', 'link', 'original', 'mediacenter', 'email'],
              link: '',
              text: 'Download'
            },
            paddingDownload: ["5px", "10px", "0px", "0px"],
            paddingCaption: ["5px", "10px", "10px", "0px"],
            width: '340',
            text: '<p style="line-height: 20px;margin:0">Lorem ipsum dolor sit amet, consectetur adipisci elit, sed eiusmod tempor incidunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam.</p>',
            padding1: ["0px", "0px", "0px", "20px"],
            backgroundColor1: 'transparent',
            exportable: true,
            exportMedia: {}
          }
        },
        'imageTextLeft': {
          type: 'imageTextLeft',
          sort: 12,
          element: {
            type: 'imageTextLeft',
            icon: 'icon-img-right',
            primary_head: 'builder_el_image_text_left',
            second_head: 'builder_el_image_text_left_comment'
          },
          defaultOptions: {
            align: 'right',
            padding: ["15px", "30px", "15px", "30px"],
            backgroundColor: '#ffffff',
            font: {
              weight: 'normal',
              weightOptions: ['bold', 'bolder', 'lighter', 'inherit', 'initial', 'normal', 100, 200, 300, 400, 500, 600, 700, 800, 900],
              family: 'Arial, Helvetica, sans-serif',
              familyOptions: defaultFontFamily
            },
            color: "#000000",
            mediaCropformats: {
              cropformat: '',
              cropformats: {
                original: 'Original'
              }
            },
            imageSingle1: {
              id_media: 0,
              id_zone: null,
              fields: {
                filename: '',
                photographer: '',
                owner: '',
                caption: '',
                title: ''
              },
              url: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
              cropformat: 'original',
              cropformats: {
                original: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
                1001: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
                1002: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
              }
            },
            mediaCaption: {
              type: 'none',
              typeOptions: ['none', 'caption', 'photographer', 'title', 'caption_photographer', 'title_photographer','caption_owner', 'custom', 'owner'],
              custom: '',
              prefix: '',
              suffix: ''
            },
            linkTo: {
              type: 'none',
              typeOptions: ['none', 'link', 'original', 'mediacenter', 'email'],
              link: '',
              text: 'Download'
            },
            paddingDownload: ["5px", "0px", "0px", "10px"],
            paddingCaption: ["5px", "0px", "10px", "10px"],
            width: '340',
            text: '<p style="line-height: 20px;margin:0">Lorem ipsum dolor sit amet, consectetur adipisci elit, sed eiusmod tempor incidunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam.</p>',
            padding1: ["0px", "20px", "0px", "0px"],
            backgroundColor1: 'transparent',
            exportable: true,
            exportMedia: {}
          }
        },
        'imageText2x2': {
          type: 'imageText2x2',
          sort:13,
          element: {
            type: 'imageText2x2',
            icon: 'icon-2-columns',
            primary_head: 'builder_el_image_text_2x2',
            second_head: 'builder_el_image_text_2x2_comment'
          },
          defaultOptions: {
            align: 'left',
            padding: ["15px", "20px", "15px", "20px"],
            backgroundColor: '#ffffff',
            font: {
              weight: 'normal',
              weightOptions: ['bold', 'bolder', 'lighter', 'inherit', 'initial', 'normal', 100, 200, 300, 400, 500, 600, 700, 800, 900],
              family: 'Arial, Helvetica, sans-serif',
              familyOptions: defaultFontFamily
            },
            color: "#000000",
            mediaCropformats: {
              cropformat: '',
              cropformats: {
                original: 'Original'
              }
            },

            mediaCaption: {
              type: 'none',
              typeOptions: ['none', 'caption', 'photographer', 'title', 'caption_photographer', 'title_photographer','caption_owner', 'custom', 'owner'],
              custom: '',
              prefix: '',
              suffix: ''
            },
            linkTo: {
              type: 'none',
              typeOptions: ['none', 'link', 'original', 'mediacenter', 'email', 'individual-link'],
              link: '',
              text: 'Download'
            },
            paddingDownload: ["5px", "10px", "0px", "10px"],
            paddingCaption: ["5px", "10px", "0px", "10px"],
            imageSingle1: {
              id_media: 0,
              id_zone: null,
              fields: {
                filename: '',
                photographer: '',
                owner: '',
                caption: '',
                title: ''
              },
              url: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
              cropformat: 'original',
              cropformats: {
                original: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
                1001: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
                1002: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
              }
            },
            imageSingle2: {
              id_media: 0,
              id_zone: null,
              fields: {
                filename: '',
                photographer: '',
                owner: '',
                caption: '',
                title: ''
              },
              url: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
              cropformat: 'original',
              cropformats: {
                original: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
                1001: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
                1002: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
              }
            },
            text1: '<p style="line-height: 20px;margin:0">Lorem ipsum dolor sit amet, consectetur adipisci elit, sed eiusmod tempor incidunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur. Quis aute iure reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint obcaecat cupiditat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. </p>',
            text2: '<p style="line-height: 20px;margin:0">Lorem ipsum dolor sit amet, consectetur adipisci elit, sed eiusmod tempor incidunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur. Quis aute iure reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint obcaecat cupiditat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. </p>',
            padding1: ["15px", "0px", "0px", "0px"],
            backgroundColor1: 'transparent',
            padding2: ["15px", "0px", "0px", "0px"],
            backgroundColor2: 'transparent',
            exportable: true,
            exportMedia: {}
          }
        },
        'imageText3x2': {
          type: 'imageText3x2',
          sort: 14,
          element: {
            type: 'imageText3x2',
            icon: 'icon-3-columns',
            primary_head: 'builder_el_image_text_3x2',
            second_head: 'builder_el_image_text_3x2_comment'
          },
          defaultOptions: {
            align: 'left',
            padding: ["15px", "20px", "15px", "20px"],
            backgroundColor: '#ffffff',
            font: {
              weight: 'normal',
              weightOptions: ['bold', 'bolder', 'lighter', 'inherit', 'initial', 'normal', 100, 200, 300, 400, 500, 600, 700, 800, 900],
              family: 'Arial, Helvetica, sans-serif',
              familyOptions: defaultFontFamily
            },
            color: "#000000",
            mediaCropformats: {
              cropformat: '',
              cropformats: {
                original: 'Original'
              }
            },
            mediaCaption: {
              type: 'none',
              typeOptions: ['none', 'caption', 'photographer', 'title', 'caption_photographer', 'title_photographer','caption_owner', 'custom', 'owner'],
              custom: '',
              prefix: '',
              suffix: ''
            },
            linkTo: {
              type: 'none',
              typeOptions: ['none', 'link', 'original', 'mediacenter', 'email', 'individual-link'],
              link: '',
              text: 'Download'
            },
            paddingDownload: ["5px", "10px", "0px", "10px"],
            paddingCaption: ["5px", "10px", "0px", "10px"],
            imageSingle1: {
              id_media: 0,
              id_zone: null,
              fields: {
                filename: '',
                photographer: '',
                owner: '',
                caption: '',
                title: ''
              },
              url: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
              cropformat: 'original',
              cropformats: {
                original: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
                1001: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
                1002: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
              }
            },
            imageSingle2: {
              id_media: 0,
              id_zone: null,
              fields: {
                filename: '',
                photographer: '',
                owner: '',
                caption: '',
                title: ''
              },
              url: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
              cropformat: 'original',
              cropformats: {
                original: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
                1001: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
                1002: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
              }
            },
            imageSingle3: {
              id_media: 0,
              id_zone: null,
              fields: {
                filename: '',
                photographer: '',
                owner: '',
                caption: '',
                title: ''
              },
              url: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
              cropformat: 'original',
              cropformats: {
                original: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
                1001: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
                1002: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
              }
            },
            text1: '<p style="line-height: 20px;margin:0">Lorem ipsum dolor sit amet, consectetur adipisci elit, sed eiusmod tempor incidunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur. Quis aute iure reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint obcaecat cupiditat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. </p>',
            text2: '<p style="line-height: 20px;margin:0">Lorem ipsum dolor sit amet, consectetur adipisci elit, sed eiusmod tempor incidunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur. Quis aute iure reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint obcaecat cupiditat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. </p>',
            text3: '<p style="line-height: 20px;margin:0">Lorem ipsum dolor sit amet, consectetur adipisci elit, sed eiusmod tempor incidunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur. Quis aute iure reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint obcaecat cupiditat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. </p>',
            padding1: ["15px", "0px", "0px", "0px"],
            backgroundColor1: 'transparent',
            padding2: ["15px", "0px", "0px", "0px"],
            backgroundColor2: 'transparent',
            padding3: ["15px", "0px", "0px", "0px"],
            backgroundColor3: 'transparent',
            exportable: true,
            exportMedia: {}
          }
        },
        'text2x2': {
          type: 'text2x2',
          sort: 5,
          element: {
            type: 'text2x2',
            icon: 'icon-2-columns-text',
            primary_head: 'builder_el_text_2x2',
            second_head: 'builder_el_text_2x2_comment'
          },
          defaultOptions: {
            align: 'left',
            padding: ["15px", "20px", "15px", "20px"],
            backgroundColor: '#ffffff',
            font: {
              weight: 'normal',
              weightOptions: ['bold', 'bolder', 'lighter', 'inherit', 'initial', 'normal', 100, 200, 300, 400, 500, 600, 700, 800, 900],
              family: 'Arial, Helvetica, sans-serif',
              familyOptions: defaultFontFamily
            },
            color: "#000000",
            text1: '<p style="line-height: 20px;margin:0">Lorem ipsum dolor sit amet, consectetur adipisci elit, sed eiusmod tempor incidunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur. Quis aute iure reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint obcaecat cupiditat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. </p>',
            text2: '<p style="line-height: 20px;margin:0">Lorem ipsum dolor sit amet, consectetur adipisci elit, sed eiusmod tempor incidunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur. Quis aute iure reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint obcaecat cupiditat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. </p>',
            padding1: ["0px", "0px", "0px", "0px"],
            backgroundColor1: 'transparent',
            padding2: ["0px", "0px", "0px", "0px"],
            backgroundColor2: 'transparent',
            exportable: true
          }
        },
        'text3x2': {
          type: 'text3x2',
          sort: 6,
          element: {
            type: 'text3x2',
            icon: 'icon-3-columns-text',
            primary_head: 'builder_el_text_3x2',
            second_head: 'builder_el_text_3x2_comment'
          },
          defaultOptions: {
            align: 'left',
            padding: ["15px", "20px", "15px", "20px"],
            backgroundColor: '#ffffff',
            font: {
              weight: 'normal',
              weightOptions: ['bold', 'bolder', 'lighter', 'inherit', 'initial', 'normal', 100, 200, 300, 400, 500, 600, 700, 800, 900],
              family: 'Arial, Helvetica, sans-serif',
              familyOptions: defaultFontFamily
            },
            color: "#000000",
            text1: '<p style="line-height: 20px;margin:0">Lorem ipsum dolor sit amet, consectetur adipisci elit, sed eiusmod tempor incidunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur. Quis aute iure reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint obcaecat cupiditat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. </p>',
            text2: '<p style="line-height: 20px;margin:0">Lorem ipsum dolor sit amet, consectetur adipisci elit, sed eiusmod tempor incidunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur. Quis aute iure reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint obcaecat cupiditat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. </p>',
            text3: '<p style="line-height: 20px;margin:0">Lorem ipsum dolor sit amet, consectetur adipisci elit, sed eiusmod tempor incidunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur. Quis aute iure reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint obcaecat cupiditat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. </p>',
            padding1: ["15px", "0px", "0px", "0px"],
            backgroundColor1: 'transparent',
            padding2: ["15px", "0px", "0px", "0px"],
            backgroundColor2: 'transparent',
            padding3: ["15px", "0px", "0px", "0px"],
            backgroundColor3: 'transparent',
            exportable: true
          }
        },
        'imagesX2': {
          type: 'imagesX2',
          sort: 16,
          element: {
            type: 'imagesX2',
            icon: 'icon-2-img',
            primary_head: 'builder_el_images_x2',
            second_head: 'builder_el_images_x2_comment'
          },
          defaultOptions: {
            align: 'left',
            padding: ["15px", "20px", "15px", "20px"],
            backgroundColor: '#ffffff',
            font: {
              weight: 'normal',
              weightOptions: ['bold', 'bolder', 'lighter', 'inherit', 'initial', 'normal', 100, 200, 300, 400, 500, 600, 700, 800, 900],
              family: 'Arial, Helvetica, sans-serif',
              familyOptions: defaultFontFamily
            },
            color: "#888888",
            mediaCropformats: {
              cropformat: '',
              cropformats: {
                original: 'Original'
              }
            },

            mediaCaption: {
              type: 'none',
              typeOptions: ['none', 'caption', 'photographer', 'title', 'caption_photographer', 'title_photographer','caption_owner', 'custom', 'owner'],
              custom: '',
              prefix: '',
              suffix: ''
            },
            linkTo: {
              type: 'none',
              typeOptions: ['none', 'link', 'original', 'mediacenter', 'email', 'individual-link'],
              link: '',
              text: 'Download'
            },
            paddingDownload: ["5px", "10px", "0px", "10px"],
            paddingCaption: ["5px", "10px", "0px", "10px"],
            imageSingle1: {
              id_media: 0,
              id_zone: null,
              fields: {
                filename: '',
                photographer: '',
                owner: '',
                caption: '',
                title: ''
              },
              url: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
              cropformat: 'original',
              cropformats: {
                original: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
                1001: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
                1002: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
              },
              customLink: ''
            },
            imageSingle2: {
              id_media: 0,
              id_zone: null,
              fields: {
                filename: '',
                photographer: '',
                owner: '',
                caption: '',
                title: ''
              },
              url: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
              cropformat: 'original',
              cropformats: {
                original: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
                1001: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
                1002: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
              },
              customLink: ''
            },
            exportable: true,
            exportMedia: {}
          }
        },
        'imagesX3': {
          type: 'imagesX3',
          sort: 17,
          element: {
            type: 'imagesX3',
            icon: 'icon-3-img',
            primary_head: 'builder_el_images_x3',
            second_head: 'builder_el_images_x3_comment'
          },
          defaultOptions: {
            align: 'left',
            padding: ["15px", "20px", "15px", "20px"],
            backgroundColor: '#ffffff',
            font: {
              weight: 'normal',
              weightOptions: ['bold', 'bolder', 'lighter', 'inherit', 'initial', 'normal', 100, 200, 300, 400, 500, 600, 700, 800, 900],
              family: 'Arial, Helvetica, sans-serif',
              familyOptions: defaultFontFamily
            },
            color: "#888888",
            mediaCropformats: {
              cropformat: '',
              cropformats: {
                original: 'Original'
              }
            },
            mediaCaption: {
              type: 'none',
              typeOptions: ['none', 'caption', 'photographer', 'title', 'caption_photographer', 'title_photographer','caption_owner', 'custom', 'owner'],
              custom: '',
              prefix: '',
              suffix: ''
            },
            linkTo: {
              type: 'none',
              typeOptions: ['none', 'link', 'original', 'mediacenter', 'email', 'individual-link'],
              link: '',
              text: 'Download'
            },
            paddingDownload: ["5px", "10px", "0px", "10px"],
            paddingCaption: ["5px", "10px", "0px", "10px"],
            imageSingle1: {
              id_media: 0,
              id_zone: null,
              fields: {
                filename: '',
                photographer: '',
                owner: '',
                caption: '',
                title: ''
              },
              url: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
              cropformat: 'original',
              cropformats: {
                original: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
                1001: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
                1002: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
              }
            },
            imageSingle2: {
              id_media: 0,
              id_zone: null,
              fields: {
                filename: '',
                photographer: '',
                owner: '',
                caption: '',
                title: ''
              },
              url: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
              cropformat: 'original',
              cropformats: {
                original: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
                1001: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
                1002: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
              }
            },
            imageSingle3: {
              id_media: 0,
              id_zone: null,
              fields: {
                filename: '',
                photographer: '',
                owner: '',
                caption: '',
                title: ''
              },
              url: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
              cropformat: 'original',
              cropformats: {
                original: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
                1001: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
                1002: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
              }
            },
            exportable: true,
            exportMedia: {}
          }
        },
        'imagesX4': {
          type: 'imagesX4',
          sort: 18,
          element: {
            type: 'imagesX4',
            icon: 'icon-4-img',
            primary_head: 'builder_el_images_x4',
            second_head: 'builder_el_images_x4_comment'
          },
          defaultOptions: {
            align: 'left',
            padding: ["15px", "20px", "15px", "20px"],
            backgroundColor: '#ffffff',
            font: {
              weight: 'normal',
              weightOptions: ['bold', 'bolder', 'lighter', 'inherit', 'initial', 'normal', 100, 200, 300, 400, 500, 600, 700, 800, 900],
              family: 'Arial, Helvetica, sans-serif',
              familyOptions: defaultFontFamily
            },
            color: "#888888",
            mediaCropformats: {
              cropformat: '',
              cropformats: {
                original: 'Original'
              }
            },
            mediaCaption: {
              type: 'none',
              typeOptions: ['none', 'caption', 'photographer', 'title', 'caption_photographer', 'title_photographer','caption_owner', 'custom', 'owner'],
              custom: '',
              prefix: '',
              suffix: ''
            },
            linkTo: {
              type: 'none',
              typeOptions: ['none', 'link', 'original', 'mediacenter', 'email', 'individual-link'],
              link: '',
              text: 'Download'
            },
            paddingDownload: ["5px", "10px", "0px", "10px"],
            paddingCaption: ["5px", "10px", "0px", "10px"],
            imageSingle1: {
              id_media: 0,
              id_zone: null,
              fields: {
                filename: '',
                photographer: '',
                owner: '',
                caption: '',
                title: ''
              },
              url: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
              cropformat: 'original',
              cropformats: {
                original: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
                1001: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
                1002: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
              }
            },
            imageSingle2: {
              id_media: 0,
              id_zone: null,
              fields: {
                filename: '',
                photographer: '',
                owner: '',
                caption: '',
                title: ''
              },
              url: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
              cropformat: 'original',
              cropformats: {
                original: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
                1001: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
                1002: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
              }
            },
            imageSingle3: {
              id_media: 0,
              id_zone: null,
              fields: {
                filename: '',
                photographer: '',
                owner: '',
                caption: '',
                title: ''
              },
              url: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
              cropformat: 'original',
              cropformats: {
                original: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
                1001: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
                1002: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
              }
            },
            imageSingle4: {
              id_media: 0,
              id_zone: null,
              fields: {
                filename: '',
                photographer: '',
                owner: '',
                caption: '',
                title: ''
              },
              url: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
              cropformat: 'original',
              cropformats: {
                original: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
                1001: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
                1002: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
              }
            },
            exportable: true,
            exportMedia: {}
          }
        },
        'imagesX5': {
          type: 'imagesX5',
          sort: 19,
          element: {
            type: 'imagesX5',
            icon: 'icon-5-img',
            primary_head: 'builder_el_images_x5',
            second_head: 'builder_el_images_x5_comment'
          },
          defaultOptions: {
            align: 'left',
            padding: ["15px", "20px", "15px", "20px"],
            backgroundColor: '#ffffff',
            font: {
              weight: 'normal',
              weightOptions: ['bold', 'bolder', 'lighter', 'inherit', 'initial', 'normal', 100, 200, 300, 400, 500, 600, 700, 800, 900],
              family: 'Arial, Helvetica, sans-serif',
              familyOptions: defaultFontFamily
            },
            color: "#888888",
            mediaCropformats: {
              cropformat: '',
              cropformats: {
                original: 'Original'
              }
            },
            mediaCaption: {
              type: 'none',
              typeOptions: ['none', 'caption', 'photographer', 'title', 'caption_photographer', 'title_photographer','caption_owner', 'custom', 'owner'],
              custom: '',
              prefix: '',
              suffix: ''
            },
            linkTo: {
              type: 'none',
              typeOptions: ['none', 'link', 'original', 'mediacenter', 'email', 'individual-link'],
              link: '',
              text: 'Download'
            },
            paddingDownload: ["5px", "10px", "0px", "10px"],
            paddingCaption: ["5px", "10px", "0px", "10px"],
            imageSingle1: {
              id_media: 0,
              id_zone: null,
              fields: {
                filename: '',
                photographer: '',
                owner: '',
                caption: '',
                title: ''
              },
              url: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
              cropformat: 'original',
              cropformats: {
                original: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
                1001: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
                1002: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
              }
            },
            imageSingle2: {
              id_media: 0,
              id_zone: null,
              fields: {
                filename: '',
                photographer: '',
                owner: '',
                caption: '',
                title: ''
              },
              url: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
              cropformat: 'original',
              cropformats: {
                original: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
                1001: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
                1002: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
              }
            },
            imageSingle3: {
              id_media: 0,
              id_zone: null,
              fields: {
                filename: '',
                photographer: '',
                owner: '',
                caption: '',
                title: ''
              },
              url: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
              cropformat: 'original',
              cropformats: {
                original: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
                1001: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
                1002: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
              }
            },
            imageSingle4: {
              id_media: 0,
              id_zone: null,
              fields: {
                filename: '',
                photographer: '',
                owner: '',
                caption: '',
                title: ''
              },
              url: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
              cropformat: 'original',
              cropformats: {
                original: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
                1001: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
                1002: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
              }
            },
            imageSingle5: {
              id_media: 0,
              id_zone: null,
              fields: {
                filename: '',
                photographer: '',
                owner: '',
                caption: '',
                title: ''
              },
              url: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
              cropformat: 'original',
              cropformats: {
                original: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
                1001: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
                1002: 'https://new.qiusystem.com/assets/images/template-builder/340x145.jpg',
              },
            },
            exportable: true,
            exportMedia: {}
          }
        },

        'code': {
          type: 'code',
          sort: 20,
          element: {
            size: 13,
            type: 'code',
            icon: 'icon-code-tags',
            primary_head: 'builder_el_code',
            second_head: 'builder_el_code_comment'
          },
          defaultOptions: {
            padding: ["10px", "30px", "10px", "30px"],
            backgroundColor: '#ffffff',
            code: '<p style="display: block;font-size: 14px;color: #4d4d4d;font-family:Helvetica Neue, Helvetica, arial, lucida grande, sans-serif;text-align:left;">Paste your code here</p>',
            exportable: true
          }
        },
        'previewInBrowser': {
          type: 'previewInBrowser',
          sort:21,
          element: {
            type: 'previewInBrowser',
            icon: 'icon-legal-footer',
            primary_head: 'builder_el_preview_browser',
            second_head: 'builder_el_preview_browser_comment'
          },
          defaultOptions: {
            align: 'right',
            padding: ['5px', '5px', '5px', '5px'],
            backgroundColor: '#ffffff',
            font: {
              size: 13,
              color: '#777777',
              weight: 'normal',
              weightOptions: ['bold', 'bolder', 'lighter', 'inherit', 'initial', 'normal', 100, 200, 300, 400, 500, 600, 700, 800, 900],
              family: 'Arial, Helvetica, sans-serif',
              familyOptions: defaultFontFamily
            },
            textPreview: 'If you have problems viewing this message, ',
            clickHere: 'click here',
            exportable: true
          }
        }
      }
    })

})();

(function () {
	'use strict';

	angular
		.module('app.media')
		.controller('SelectMediaToJoinDialogController', SelectMediaToJoinDialogController)
		;

	/** @ngInject */
	function SelectMediaToJoinDialogController(
		$mdDialog,
		$document,
		mediaService,
		requestContext,
		$scope,
		msUtils,
		$translate,
		media_type,
		alreadySelected,
		sessionService,
		$q,
		$mdSidenav
	) {
		var vm = this;
		vm.defaultPage = 1;
		vm.defaultPerPage = 50;
		vm.PerPage = 50;
		vm.searchStringFilter = '';
		vm.searchQuery = '';
		vm.modelSearch = '';
		vm.pagination_search = pagination_search;

		vm.selectedContacts = [];


		vm.firstLoad = true;
		vm.alreadySelected = alreadySelected;
		vm.media_type = media_type;
		vm.showSearchAndPaginator = true;
		vm.searchTagText = '';
		vm.tags = sessionService.site_operative.tags;
		vm.currentTags = [];
		vm.selectedTag = null;
		vm.image = {};


		vm.closeDialog = closeDialog;

		vm.nextPage = nextPage;
		vm.prevPage = prevPage;
		vm.morePages = morePages;
		vm.gotoPage = gotoPage;
		vm.firstPage = firstPage;
		vm.attachMedia = attachMedia;
		vm.alreadySelectedbyZone = alreadySelectedbyZone;
		vm.toggleSelectContact = toggleSelectContact;


		vm.exists = msUtils.exists;
		vm.existInArray = msUtils.existInArray;

		vm.labelQuerySearch = labelQuerySearch;

		vm.isNumber = angular.isNumber;

		vm.translate = function (text) {
			return $translate.instant(text);
		}

		function alreadySelectedbyZone(array, item) {
			var ret = false;
			for (var i = 0, len = array.length; i < len; i++) {
				if (array[i] === item) {
					ret = true;
				}
			}
			return ret;
		}

		function toggleSelectContact(photo, event) {
			if (event) {
				event.stopPropagation();
			}
			if (vm.selectedContacts.indexOf(photo) > -1) {
				vm.selectedContacts.splice(vm.selectedContacts.indexOf(photo), 1);
			} else {
				vm.selectedContacts.push(photo);
			}
		}

		var siteID = requestContext.getParam("siteId");
		var section = requestContext.getParam("section");
		init();
		/**
		 * Initialize
		 */
		function init() {

			vm.loading = true;
			var options = {
				section: section,
				media_type: vm.media_type,
				page: vm.defaultPage,
				perPage: vm.defaultPerPage
			};
			//
			getData(options);

		}


		function pagination_search(searchString) {

			vm.loading = true;
			scrollToTopOfDialog();
			var options = {
				section: section,
				media_type: vm.media_type,
				page: vm.defaultPage,
				perPage: vm.defaultPerPage,
				searchString: searchString,
				gallery_type: vm.media_type
			};
			if (vm.media_type) {
				options.mediaTypeFilter = {
					'media_type': {
						selected: [vm.media_type],
						field: 'media_type',
						name: 'media_type'
					}
				}
			};

			getData(options);
		}



		function getData(options) {

			vm.loading = true;
			scrollToTopOfDialog();

			var arrayOptions = {
				siteID: siteID,
				page: options.page,
				resultsPerPage: options.perPage,
				media_type: options.media_type,
				search: vm.modelSearch,
				withCropStatus: true,
				withMediaChildren: true,
				sortField: 'date_uploaded',

			};

			if (vm.modelSearch && !_.isEmpty(vm.modelSearch)) {
				arrayOptions['searchStringFilter'] = vm.modelSearch;
				// console.log("arrayOptions ", arrayOptions)
			}

			mediaService.get(arrayOptions)
				.then(function (response) {
					// console.log("response ", response)
					vm.totalItems = response.total;
					vm.from = response.from;
					vm.to = response.to;
					vm.currentPage = response.current_page;
					vm.lastPage = response.last_page;
					vm.maxSize = 500;
					vm.bigTotalItems = 175;
					vm.items = response.data.filter(x => {
						return !vm.alreadySelected.find(y => y.id_media == x.id_media) && (!x.embed || !x.embed.startsWith("yt|"));
					});

					$('.md-button')
						.removeClass('active');
					$('[type=' + options.media_type + ']')
						.addClass('active');

					vm.loading = false;
					vm.firstLoad = false;
				})
		}


		function closeDialog() {
			$mdDialog.hide();
		}

		function nextPage() {

			var options = {
				page: vm.currentPage + 1,
				perPage: vm.PerPage,
				media_type: vm.media_type,
				searchString: vm.modelSearch
			};
			//
			getData(options);

		}

		function prevPage() {
			var options = {
				page: vm.currentPage - 1,
				perPage: vm.PerPage,
				media_type: vm.media_type,
				searchString: vm.modelSearch
			};
			//
			getData(options);
		}

		function morePages() {
			if (vm.currentPage < vm.lastPage) return true;
			return false;
		}

		function firstPage() {
			if (vm.currentPage == 1) return true;
			return false;
		}

		function gotoPage(i) {

			var options = {
				page: i,
				perPage: vm.PerPage,
				media_type: vm.media_type,
				searchString: vm.modelSearch
			};
			//
			getData(options);
		}



		function attachMedia() {
			$mdDialog.hide(vm.selectedContacts)
		}



		/**
		 * Add label chips
		 *
		 * @param query
		 * @returns {filterFn}
		 */
		function labelQuerySearch(query) {
			var ret = [];
			if (query) {
				var filteredContent = angular.copy(vm.tags.filter(vm.createFilterFor(query)));
				if (filteredContent.length > 0) {
					ret.push({
						id_tag: 0,
						tag_name: "",
						order: 1
					});
				}
				angular.forEach(filteredContent, function (val) {
					ret.push(val);
				})
			}
			return ret;
		}



		/**
		 * Scroll Media Dialog Content to the top
		 * @param speed
		 */
		function scrollToTopOfDialog() {
			//$timeout(function () {
			var dialogContent = $document.find('md-dialog-content').filter(function () {
				return angular.element(this).hasClass('mediadialog-content');
			});
			if (!angular.isUndefined(dialogContent[0])) {
				dialogContent.animate({
					scrollTop: 0
				}, 1);
			}
			//}, 1000);

		}

	}

})();

(function() {
    'use strict';

    angular
        .module('app.users')
        .directive('qiuDialogsOnChangeSetInGroupStatus', SetInGroupStatus)
        .directive('qiuDialogsOnCheckToggleAssignedGroup', ToggleAssignedGroup)
        .controller('UsersGroupController', UsersGroupController);


    /** @ngInject */
    function UsersGroupController(
        $scope,
        $mdDialog,
        usersGroups,
        usersService,
        sharedFunctionsMailing,
        $translate,
        $mdToast
    ) {

        var vm = this;

        vm.viewUsersGroup = 'app/main/dialogs/users-group/tree-view.html';

        vm.usersGroups = usersGroups;
        vm.loading = false;

        vm.closeDialog = closeDialog;
        vm.save = save;

        init();

        function init() {
            vm.loading = true;
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        function save() {
            vm.loading = true;
            var groups = getSelectedGroups(vm.usersGroups, []);
            $mdDialog.hide(groups);
        }

        function getSelectedGroups(groups, result) {

          angular.forEach(groups, function(group) {

            if(angular.isDefined(group.assigned_group) && group.assigned_group == true) {
              result.push(group);
            }
            if (typeof group.children !== 'undefined' && group.children.length >0) {
              getSelectedGroups(group.children, result);
            }
          });
          return result;
        }
    }

    function SetInGroupStatus() {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                scope.$watch(attrs.ngModel, function (v) {
                    if (angular.isDefined(v)) {
                        scope.node.id_ingroup_status = v;
                    }
                });
            }
        };
    }
    function ToggleAssignedGroup() {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                $(element).on('click', function (e) {
                    scope.node.assigned_group = !scope.node.assigned_group;
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.content')
        .constant('_', window._)
        .controller('SelectContentDialogController', SelectContentDialogController);

    /** @ngInject */
    function SelectContentDialogController($document, $mdDialog, msUtils, contentService, $translate, $mdToast, transformMatchCenter, idKey, showName, valueName, ref, contentSection, title, data,
        index, pos, isEditMode, label, matchCenterService, usersService, siteId, section, cropFormat, defaultFilters, tabType, dialogName, usersGroups, usersPermissions, team, rawSettings) {
        var vm = this;
        vm.siteId = siteId;
        vm.section = section;
        vm.contentSection = contentSection;
        vm.data = data;
        vm.idKey = idKey;
        vm.cropFormat = cropFormat;
        vm.ref = ref;
        vm.tabType = tabType;
        vm.showName = showName;
        vm.valueName = valueName;
        vm.dialogName = dialogName;
        vm.label = label;
        vm.rawSettings = rawSettings;
        vm.item = {};

        vm.select = select;
        vm.isSelected = isSelected;
        vm.title = title;
        vm.defaultFilters = defaultFilters;
        vm.selected = [];
        vm.copyData = angular.copy(data);
        vm.loadingReadPane = false;
        vm.usersGroups = usersGroups;
        vm.currentThreadEdit = team;
        vm.usersPermissions = usersPermissions;
        vm.validateEmail = validateEmail;
        vm.addChips = addChips;
        
        vm.index = index;
        vm.pos = pos;
        vm.isEditMode = isEditMode;
        
        vm.saveDialog = saveDialog;
        vm.closeDialog = closeDialog;
        vm.getContentSection = getContentSection;
        vm.mediaDialog = mediaDialog;
        vm.countries = [];
        vm.isSvg = isSvg;

        init();

        function isSvg(item) {
            var filename = item.filename || item.fileName || (item.Thumbnail && item.Thumbnail[0] ? item.Thumbnail[0].filename : '');
            return filename.toLowerCase().endsWith('.svg');
        }

        function init() {
            switch (vm.tabType) {
                case 'json-from-raw':
                    vm.item = (vm.isEditMode) ? angular.copy(vm.data[vm.index]) : {};
                    break;
                case 'simple-json':
                    if(vm.label == 'users_permissions'){
                        vm.item = vm.currentThreadEdit.users_permissions.map(x => {
                            return x[vm.showName];
                        });
                    }
                    break;
                case 'json-construct':
                    vm.data.forEach((x, index) => {
                        if(!x.id){
                            x.id = index + 1;
                        }
                    });
                    vm.item = (vm.isEditMode) ? angular.copy(vm.data[vm.index]) : {};
                    vm.rawSettings.fields.forEach(field => {
                        switch(field.type){
                            case 'country':
                                getCountries();
                                break;
                            case 'id':
                                vm.item[field.label] = vm.currentThreadEdit[`id_${vm.section}`]
                                break;
                        }
                    });
                    break;
                default:
                    vm.getContentSection();
                    break;
            }
            if(vm.label == 'users_groups_permissions'){
                findUsersGroupsSelected();
            }
        }

        function mediaDialog(ev, field){
            $mdDialog.show({
                controller: 'MediaDialogController',
                controllerAs: 'vm',
                locals: {
                    currentThread: {
                        thumbnail: []
                    },
                  section: vm.section,
                  mediazone: {
                    id_zone: null,
                    zone_name: null
                  },
                  isTiny: false,
                  maxAttach: 1,
                  showViews: {
                    1: true,
                    2: true,
                    3: true,
                    4: true,
                    5: true,
                    upload: false,
                    import: false
                  }
                },
                templateUrl: 'app/main/dialogs/media/media-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                multiple: true,
                autoUpload: ''
              }).then(function(item){
                vm.item[field.label] = item[0];
            });
        }

        function getCountries(){
            contentService.getCountries({paginate: 999}).then(resp => {
                vm.countries = resp.data;
            });
        }

        /**
         * Multiple comma separated chips to add
         */
        function addChips(chips, model) {
            if(chips && chips.indexOf(';')){
                var chipsArray = chips.split(';');
            }else{
                var chipsArray = chips.split(',');
            }
            angular.forEach(chipsArray, function (chip) {
              model.push(chip);
            });
            return null;
          };

          /**
           * Validate emails in Chips
           */
          function validateEmail(emails) {
            for (var i = 0; i < emails.length; i++) {
                emails[i] = emails[i].toLowerCase();
                var reg = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
                if (!reg.test(emails[i])) {
                  this.invalidEmail = true;
                  // remove last invalid email address :)
                  emails.splice(i, 1);
                }
                else {
                  this.invalidEmail = false;
                }
            }
        };
        
        function findUsersGroupsSelected(){
            var selectedGroups = vm.currentThreadEdit.users_groups_permissions;
            for(var i=0; i<selectedGroups.length; i++){
                for(var j=0; j<vm.usersGroups.length; j++){
                    if(!vm.usersGroups[j].add || vm.usersGroups[j].add == false){
                        if(vm.usersGroups[j].id_group == selectedGroups[i].id_group){
                            vm.usersGroups[j].add = true;
                        }else{
                            vm.usersGroups[j].add = false;
                        }
                    }
                    if(vm.usersGroups[j].children && vm.usersGroups[j].children.length){
                        for(var k=0; k<vm.usersGroups[j].children.length; k++){
                            findChildrensUsersGroupsSelected(vm.usersGroups[j].children[k], selectedGroups[i].id_group);
                        }
                    }
                }
            }
        }
        
        function findChildrensUsersGroupsSelected(child, IDGroup){
            if(child.id_group == IDGroup){
                child.add = true;
            }else{
                child.add = false;
            }
            if(child.children && child.children.length){
                for(var i=0; i<child.children.length; i++){
                    findChildrensUsersGroupsSelected(child.children[i], IDGroup);
                }
            }
        }

        function select(item) {
            if (isSelected(item)) {
                vm.selected = _.filter(vm.selected, function (x) {
                    return x[vm.idKey] != item[vm.idKey]
                })
            } else {
                vm.selected.push(angular.copy(item));
            }
        }

        function isSelected(item) {
            var result = _.find(vm.selected, function (x) {
                return x[vm.idKey] == item[vm.idKey]
            }) != undefined;
            return result;
        }

        function getContentSection(search) {
            vm.loadingReadPane = true;
            var options = {
                site: vm.siteId,
                search: search
            };
            if (vm.defaultFilters) {
              options.filters = vm.defaultFilters;
            }
            matchCenterService.getContentSection(options, vm.contentSection).then(function (response) {
                vm.dataSection = angular.copy(response.result.data);
                vm.ref = angular.copy(response.ref);
                if (vm.data) {
                    vm.dataSection = _.filter(vm.dataSection, function (item) {
                        return _.filter(vm.data, function (_item) {
                            if(_item != null){
                                return _item[vm.idKey] == item[vm.idKey];
                            }
                        }).length == 0;
                    });
                }
                vm.loadingReadPane = false;
            });
        }
        
        function searchChildrensToAdd(child) {
            var currentAtGroup = vm.currentThreadEdit.users_groups_permissions.find(x => x.id_group == child.id_group);
            if(child.add == true && !currentAtGroup){
                vm.data.push({
                    id_group: child.id_group,
                    name: child.name
                });
            }
            if(child.children && child.children.length){
                for(var i=0; i<child.children.length; i++){
                    searchChildrensToAdd(child.children[i]);
                }
            }
            delete child.add;
        }


        function saveDialog() {
            if(vm.label == 'users_groups_permissions'){
                vm.data = [];
                for(var i=0; i<vm.usersGroups.length; i++){
                    if(vm.usersGroups[i].add == true){
                        vm.data.push({
                            id_group: vm.usersGroups[i].id_group,
                            name: vm.usersGroups[i].name,
                            id_group_type: vm.usersGroups[i].id_group_type
                        });
                    }
                    if(vm.usersGroups[i].children && vm.usersGroups[i].children.length){
                        for(var j=0; j<vm.usersGroups[i].children.length; j++){
                            searchChildrensToAdd(vm.usersGroups[i].children[j]);
                        }
                    }
                    delete vm.usersGroups[i].add;
                }
                $mdDialog.hide(vm.data);
            }else if(vm.label == 'users_permissions'){
                vm.data = [];
                var emailsSearch = [];
                angular.forEach(vm.item, function(item){
                    let emailObject = vm.currentThreadEdit.users_permissions.find(x => x.email == item);
                    if(emailObject){
                        vm.data.push(emailObject);
                    }else{
                        emailsSearch.push(item);
                    }
                });
                if(emailsSearch.length){
                    var options = {
                        siteID: vm.siteId,
                        resultsPerPage: emailsSearch.length,
                        withFilters:[
                            {
                                "field": "email",
                                "values": emailsSearch
                            }
                        ]
                    }
                    usersService.getUsers(options).then(function(response){
                        if(response.result.data && response.result.data.length){
                            angular.forEach(response.result.data, function(res){
                                vm.data.push(
                                    {
                                        id: res.id_user,
                                        email: res.email
                                    }
                                )
                            });
                        }
                        var emailErrors = [];
                        angular.forEach(emailsSearch, (email)=> {
                            var e = vm.data.find(x => x.email == email);
                            if(!e){
                                emailErrors.push(email);
                            }
                        });
                        if(emailErrors.length){
                            var mails = "";
                            angular.forEach(emailErrors, function(mail, index){
                                if(index == 0){
                                    mails = mail;
                                }else{
                                    mails = mails + ", " + mail;
                                }
                            });
                            var message = 'There are some error with these email/s: ' + mails;
                            $mdToast.show({
                                template: `
                                <md-toast layout="column" layout-align="center center">
                                    <div class="md-toast-content red-500-bg">
                                        <md-icon md-font-icon="icon-close" class="icon"></md-icon>
                                        <span class="md-toast-text" flex>
                                        `+
                                        message
                                        +`
                                        </span>
                                    </div>
                                </md-toast>
                                `,
                                hideDelay: 5000,
                                position: 'top',
                                parent: '#content-container'
                            });
                        }
                        $mdDialog.hide(vm.data);
                    });
                }else{
                    $mdDialog.hide(vm.data);
                }
            }else{
                switch (vm.tabType) {
                    case 'json-from-raw':
                        if (vm.isEditMode) {
                            vm.data[vm.index] = vm.item;
                        } else {
                            if(vm.pos){
                                switch(vm.pos){
                                    case 'start':
                                        vm.data.unshift(vm.item);
                                        break;
                                    case 'end':
                                        vm.data.push(vm.item);
                                        break;
                                }
                            }else{
                                vm.data.push(vm.item);
                            }
                        }
                        break;
                    case 'json-construct':
                        vm.rawSettings.fields.forEach(field => {
                            if(field.type === 'media'){
                                if(vm.item[field.label] && typeof vm.item[field.label] != 'string'){
                                    let mediaURL = msUtils.setItemMedia(vm.item[field.label], {id_cropformats: field.cropformat});
                                    vm.item[field.label] = mediaURL;
                                }
                            }
                        });
                        let lastItem = vm.data.find(x => x.id === vm.item.id);
                        if(lastItem){
                            vm.data[vm.index] = vm.item;
                        }else{
                            vm.item.id = vm.data.length + 1;
                            vm.data.push(vm.item);
                        }
                        break;
                    default:
                        if (!vm.data) {
                            vm.data = [];
                        }
                        for (var i = 0; i < vm.selected.length; i++) {
                            vm.data.push(msUtils.toSectionRef(vm.selected[i], vm.ref));
                        }
                        break;
                }
                $mdDialog.hide(vm.data);
            }
        }

        function closeDialog() {
            data = vm.copyData;
            $mdDialog.hide();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('app.users')
        .controller('SegmentUsersGroupsController', SegmentUsersGroupsController)
        .directive('qiuSegmentUsersOnClickSelectTargetGroup', ['usersService', SelectSegmentTargetGroup]);

    /** @ngInject */
    function SegmentUsersGroupsController(
        $scope,
        $element,
        $rootScope,
        $mdDialog,
        requestContext,
        $translate,
        $mdToast,
        usersGroups,
        usersService,
        usersGroupsTypes,
        booleanOperations,
        showGroupsTypes,
        defaultGroupTypeId,
        subscriptionGroupId,
        subscriptionGroupName,
        newGroupShow
    ) {

        var vm = this;

        var siteID = requestContext.getParam("siteId");

        // Data
        vm.loading = false;
        vm.currentThread = {};
        vm.usersGroups = usersGroups;
        vm.usersGroupsTypes = usersGroupsTypes; 
        vm.booleanOperations = booleanOperations; // array [{'operation': 'intersect', name: 'Intersect'}, {operation: 'add', name: 'Add'}]
        vm.defaultGroupTypeId = defaultGroupTypeId; // int | bool
        vm.showGroupsTypes = showGroupsTypes; // bool - Show group type selector?
        vm.newGroupShow = newGroupShow; // bool - Show 'new Group' checkbox?
        vm.subscriptionGroupId = subscriptionGroupId; // int | false
        vm.subscriptionGroupName = subscriptionGroupName;
        vm.currentThread.groupTypeId = 1; // Default type "Group"
        vm.selectedGroups = [{}];
        vm.unnestedGroups = [];

        // Methods
        vm.closeDialog = closeDialog;
        vm.save = save;
        vm.addGroup = addGroup;
        vm.deleteGroup = deleteGroup;
        vm.deleteTargetGroup = deleteTargetGroup;



        init();

        function init() {
            vm.currentThread.booleanOperation = 'add';

            if (vm.defaultGroupTypeId) {
                vm.currentThread.groupTypeId = vm.defaultGroupTypeId;
            }
            if (vm.newGroupShow) {
                vm.currentThread.showGroup = false; // uncheck by default
            }
            vm.unnestedGroups = getUnnestedGroups(usersGroups, []);
        }
        
        function addGroup() {
            vm.selectedGroups.push({});
        }

        function closeDialog() {
            $mdDialog.hide(false);
        }

        $scope.$on('selectSegmentTargetGroup', function (event, targetGroup) {
            vm.currentThread.targetGroupId = targetGroup.id_group;
            vm.currentThread.targetGroupName = targetGroup.name;
            vm.currentThread.groupName = '';
        });

        function save() {
            vm.loading = true;
            var groups = getSelectedGroupIds(vm.selectedGroups, []);
            var minNumberOfRequiredSegmentGroups = (vm.subscriptionGroupId) ? 1 : 2; 

            if (groups.length < minNumberOfRequiredSegmentGroups) {
                var alert = $mdDialog.alert()
                    .title($translate.instant('GROUP.TOO_FEW_GROUPS_DIALOG.TITLE'))
                    .textContent($translate.instant('GROUP.TOO_FEW_GROUPS_DIALOG.CONTENT'))
                    .ariaLabel($translate.instant('GROUP.TOO_FEW_GROUPS_DIALOG.LABEL'))
                    .ok($translate.instant('GROUP.OK'))
                    .multiple(true);
                return $mdDialog.show(alert).then(function(){
                    vm.loading = false;
                });
            }

            if ((!vm.currentThread.targetGroupId) && (!vm.currentThread.groupName || vm.currentThread.groupName == '')) {
                // We need one of both: The id of a selected target group, or a name for a new target group.
                return;
            }
            if (!vm.currentThread.booleanOperation || vm.currentThread.booleanOperation == '') {
                return;
            }
            if (vm.subscriptionGroupId) { // e.g. in Mailing Content

                var data = {};
                data.subscription_group = vm.subscriptionGroupId;
                data.segment_groups = groups;

                if (vm.currentThread.groupName && vm.currentThread.groupName != '') {
                    var newGroup = {};
                    newGroup.name = vm.currentThread.groupName;
                    newGroup.parent = vm.subscriptionGroupId;
                    if (vm.currentThread.groupTypeId) {
                        newGroup.id_group_type = vm.currentThread.groupTypeId;
                    }
                    data.newGroup = newGroup;
                }
                if (vm.currentThread.targetGroupId) {
                    data.targetGroupId = vm.currentThread.targetGroupId;
                }

                data.boolean_operation = vm.currentThread.booleanOperation;

                var options = {
                    siteID: siteID,
                    data: data
                };

                usersService.segmentSubscriptionGroup(options).then(function(response) {
                    var targetGroup = {
                        id_group: response.id_group,
                        name: response.name
                    };
                    $mdDialog.hide(targetGroup);
                })

            } else { // e.g. in Users Groups

                var data = {};


                if (vm.currentThread.groupName && vm.currentThread.groupName != '') {
                    var newGroup = {};
                    newGroup.name = vm.currentThread.groupName;
                    newGroup.parent = null;
                    if (vm.currentThread.groupTypeId) {
                        newGroup.id_group_type = vm.currentThread.groupTypeId;
                    }
                    data.newGroup = newGroup;
                }

                if (vm.currentThread.targetGroupId) {
                    data.targetGroupId = vm.currentThread.targetGroupId;
                }

                if (vm.currentThread.booleanOperation == 'except') {
                    data.sourceGroupId = groups.shift();
                    data.exceptGroups = groups;
                }
                else if (vm.currentThread.booleanOperation == 'filter') {
                    data.sourceGroupId = groups.shift();
                    data.filterGroups = groups;
                } else {
                    data.groups = groups;
                }

                var options = {
                    siteID: siteID,
                    booleanOperation: vm.currentThread.booleanOperation,
                    data: data
                };

                usersService.insertUsersInGroupsBoolean(options).then(function(response) {
                    var targetGroup = {
                        id_group: response.id_group,
                        name: response.name
                    };
                    $mdDialog.hide(targetGroup);
                })
            }
        }

        function getSelectedGroupIds(groups, result) {

          angular.forEach(groups, function(group) {
            result.push(group.id_group);
          });

          return result;
        }

        function getUnnestedGroups(groups, result) {
            angular.forEach(groups, function (group) {
                if (group.id_group) {
                    result.push(group);
                    if (typeof group.children !== 'undefined' && group.children.length > 0) {
                        getUnnestedGroups(group.children, result);
                    }
                }
            });
            return result;
        }

        function deleteGroup(index) {
            for (var i = vm.selectedGroups.length - 1; i >= 0; i--) {
                if (index == i) {
                    vm.selectedGroups.splice(i, 1);
                }
            }
        }

        function deleteTargetGroup() {
            vm.currentThread.targetGroupId = null;
            vm.currentThread.targetGroupName = null;
        }
    }

    function SelectSegmentTargetGroup(usersService) {
        function unselectAllGroups() {
            var elemList = document.querySelectorAll('.select-segment-target-group-row');
            elemList.forEach(function (elem) {
                elem.classList.remove('selected');
            });
        }

        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                $(element).on('click', function (e) {
                    var groupNode = false;
                    if (element.parent().hasClass('selected')) {
                        unselectAllGroups();
                    } else {
                        unselectAllGroups();
                        element.parent().addClass('selected');
                        groupNode = scope.node;
                    }
                    usersService.triggerSelectSegmentTargetGroup(groupNode);
                });
            }
        };
    }
})();
(function () {
	'use strict';

	angular
		.module('app.media')
		.controller('MediaShowDialogController', MediaShowController);

	/** @ngInject */
	function MediaShowController($mdDialog, sessionService, Images, ImageSelected, $document, Tags, cropFormats, MediaFull, CommonMediaService, $sce,
		$timeout, mediaService, requestContext, $scope) {
		var vm = this;
		vm.views = {
			fotorama: 'app/main/dialogs/media-show/views/fotorama-view.html',
			editmedia: 'app/main/dialogs/media-show/views/edit-media-view.html',
		};
		vm.viewsWithTags = {
			fotorama: 'app/main/dialogs/media-show/views/fotorama-view-with-tags.html',
		};
		vm.defaultView = 'fotorama';
		vm.currentView = 'fotorama';


		// Data
		vm.title = 'View Media';
		vm.images = [];
		vm.dataImages = [];
		vm.siteID = requestContext.getParam("siteId");
		vm.tags = sessionService.site_operative.tags;

		// Methods
		vm.closeDialog = closeDialog;
		vm.changeView = changeView;
		vm.initMejPlayer = initMejPlayer;
		vm.toggleSubstitles = toggleSubstitles;
		vm.edit = edit;
		vm.labelQuerySearch = labelQuerySearch;
		vm.createFilterFor = createFilterFor;
		vm.newTag = newTag;
		vm.removeTag = removeTag;
		vm.selectedItemChange = selectedItemChange;
		vm.showTagsEdit = Tags === true;


		vm.trustSrc = function(src) {
			return $sce.trustAsResourceUrl(src);
		}

		if (!_.isArray(Images) && (Images.media_type == 2)) {
			vm.isUniqueVideo = true;
			vm.isM3u8 = Images.media_type == 2 && Images.embed && Images.embed.endsWith('.m3u8');
			if (Images.meta_analyses && Images.meta_analyses.aws_transcription && Images.meta_analyses.aws_transcription.status == "COMPLETED") {
				vm.isSubtitlesAvailable = true;
				var vtt = awsTranscribeToVtt(Images.meta_analyses.aws_transcription);
				console.log(vtt);
				setTimeout(() => {
					var blob = new Blob([vtt], { type: 'text/plain' });
					var track = document.getElementById("track-subtitles");
					track.kind = "captions";
					track.label = "English";
					track.srclang = "en";
					var objectURL = URL.createObjectURL(blob);
					track.src = objectURL;
					track.addEventListener("load", function () {
						this.mode = "showing";
						document.getElementById('mp4-player').textTracks[0].mode = "showing"; // thanks Firefox
					});
				}, 200);
			}

			// vm.isM3u8
		}

		// //////////


		/**
		 * Close dialog
		 */
		function closeDialog() {
			var $fotoramaDiv = $('#fotorama').fotorama();
			var fotorama = $fotoramaDiv.data('fotorama');
			if (fotorama) {
				fotorama.destroy();
			}
			$mdDialog.hide();
		}

		init();

		function init() {

			vm.loaded = false;
			vm.dataFotorama = [];
			vm.tagsToShow = [];
			var cropstatus;
			var urlImage;
			var cropContainer;
			var selected;
			var fit = (cropFormats) ? 'scaledown' : 'contain';

			vm.fotoramaoptions = {
				width: '100%',
				height: '80%',
				captions: true,
				loop: true,
				keyboard: true,
				allowfullscreen: true,
				autoplay: false,
				nav: 'thumbs',
				ratio: 16 / 9,
				fit: fit,
			};

			if (Tags === true) {
				$timeout(function (){
					var fotorama = angular.element('.fotorama');
					fotorama.on('fotorama:showend', function (e, fotorama, extra) {
						var index = fotorama.activeFrame.i;
						vm.currentItem = Images[index-1];
						loadMediaTagsToEdit();
						$scope.$apply();
					});
					vm.currentItem = ImageSelected;
					loadMediaTagsToEdit();
				}, 1000)
			}

			if(angular.isArray(Tags)){
				for(var i=0; i<Tags.length; i++){
					if(Tags[i].id_tag !== 1){
						vm.tagsToShow.push(Tags[i].tag_name);
					}
				}
			}

			if (!cropFormats) {
				if (!_.isArray(Images)) {
					var ImagesArray = [];
					ImagesArray.push(Images);
					Images = ImagesArray;
				}


				for (var i = 0; i < Images.length; i++) {

					var attachment = Images[i];
					var attachmentContainer = sessionService.getContainerByID(Images[i].id_container);
					if (typeof attachment == 'object') {
						var imagesCrops = [];

						for (var iCrop = 0; iCrop < Images[i].cropstatus.length; iCrop++) {
							var imageCrop = Images[i].cropstatus[iCrop];
							imagesCrops.push(Images[i].cropstatus[iCrop]);
						}
						if (ImageSelected) {
							selected = (Images[i].id_media === ImageSelected.id_media) ? true : false;
						} else {
							selected = false;
						}

						if (Images[i].media_type !== 1) {
							// continue;
						}

						// .container.view_url}}{{image.cropstatus[0].fileName

						if (attachment.media_type == 1) {

							if (MediaFull) {

/*
								cropstatus = _.find(Images[i].cropstatus, {
									'id_cropformats': sessionService.getMediaFullCropformatId()
								});
*/


								if (cropstatus) {
									cropContainer = sessionService.getContainerByID(cropstatus.id_container);
									urlImage = cropContainer.view_url + cropstatus.fileName;
								} else {
									urlImage = attachment.imageUrlOriginal;
								}
								if (urlImage === undefined) {
									// if original not provided, use cropstatus
									var cropstat = _.find(Images[i].cropstatus, {
										'id_cropformats': sessionService.getMediaFullCropformatId()
									});
									cropContainer = sessionService.getContainerByID(cropstat.id_container);
									urlImage = cropContainer.view_url + cropstat.fileName;
								}
								vm.dataFotorama.push({
									imageUrl: urlImage,
									thumb: urlImage,
									dataCaption: '#' + attachment.id_media + ' | ' + urlImage,
									html: '<div>123</div>',
									selected: selected
								});
							} else {
								cropstatus = _.find(attachment.cropstatus, {
									'id_cropformats': sessionService.getMediaFullCropformatId()
								});
								if (!cropstatus) {
									urlImage = attachmentContainer.view_url + 'original/m' + attachment.id_media + '_' + attachment.filename;
								} else {
									cropContainer = sessionService.getContainerByID(cropstatus.id_container);
									urlImage = cropContainer.view_url + cropstatus.fileName;
								}
								vm.dataFotorama.push({
									imageUrl: urlImage,
									thumb: urlImage,
									dataCaption: '#' + attachment.id_media + ' | ' + urlImage,
									html: '<div>123</div>',
									selected: selected
								});
							}
						}

						if (attachment.media_type == 2) {
							var videoUrl = '';
							var imageUrl = attachment.embed_thumb;
							if (!attachment.embed) {
								videoUrl = attachmentContainer.view_url + 'videos/m' + attachment.id_media + '_' + attachment.filename;
							} else {
								if (attachment.embed.indexOf('yt|') !== -1) {
									var YT_VideoSource = attachment.embed.split('yt|')[1];
									videoUrl = 'https://www.youtube.com/embed/' + YT_VideoSource;
								} else if (attachment.embed.indexOf('vimeo|') !== -1) {
									var Vimeo_VideoSource = attachment.embed.split('vimeo|')[1];
									videoUrl = 'https://player.vimeo.com/video/' + Vimeo_VideoSource;
								} else if (attachment.embed.indexOf('fb|') !== -1) {
									var embed_url = angular.element(attachment.embed_url);
									videoUrl = embed_url.attr('src');
								} else if (attachment.embed.indexOf('zc|') !== -1) {
									videoUrl = attachment.embed.split('zc|')[1];
								} else if (attachment.embed.indexOf('x|') !== -1) {
									videoUrl = attachment.embed.split('x|')[1];
								}
							}
							if (attachment.thumb) {
								/*
												var cropFormatId = sessionService.getMediaThumbnailCropformatId();
												var options = {
												  id_media: [attachment.thumb]
												};
												CommonMediaService.getUrl(options)
												  .then(function (response) {
													if (response.length > 0) {
													  var cropstatus = _.find(response, function (c) {
														if (c.id_cropformats == cropFormatId) {
														  return true;
														}
													  });
													  imageUrl = cropstatus.url;
													  vm.loaded = true;
													}
												  })
								*/
							}

							vm.dataFotorama.push({
								imageUrl: imageUrl,
								thumb: imageUrl,
								full: imageUrl, // Separate image for the fullscreen mode.
								video: videoUrl, // Youtube, Vimeo or custom iframe URL
								id: 'one', // Custom anchor is used with the hash:true option.
								dataCaption: '#' + attachment.id_media + ' | ' + attachment.filename ? attachment.filename : '',
								html: '<div></div>',
								// html: $('selector'), // ...or '<div>123</div>'. Custom HTML inside the frame.
								fit: 'cover', // Override the global fit option.
								any: 'Any data relative to the frame you want to store',
								selected: selected
							});
						}
						if (attachment.media_type == 3) {
							vm.isAudio = true;
							var mediaContainer = sessionService.getContainerByID(attachment.cdnContainer);
							vm.audioUrl = mediaContainer.view_url + 'audios/m' + attachment.id_media + '_' + attachment.filename;
							console.log(vm.audioUrl)

						}
					} else {
						vm.dataFotorama.push({
							imageUrl: attachment,
							thumb: attachment,
							dataCaption: attachment,
							html: '<div></div>',
							selected: false
						});
					}
				}

			} else {

				var selectedContainer = sessionService.getContainerByID(ImageSelected.id_container);
				for (var i = 0; i < Images.length; i++) {
					cropContainer = sessionService.getContainerByID(Images[i].id_container);

					selected = (Images[i].id_cropformats === ImageSelected.id_cropformats && cropContainer.id_container === selectedContainer.id_container) ? true : false;

					if (cropContainer.use_grid === 1) {
						urlImage = cropContainer.view_url + Images[i].grid + '/' + Images[i].fileName;
					} else {
						urlImage = cropContainer.view_url + Images[i].fileName;
					}
					vm.dataFotorama.push({
						imageUrl: urlImage,
						thumb: urlImage,
						dataCaption: '#' + Images[i].id_cropformats + ' | ' + urlImage,
						html: '<div></div>',
						selected: selected
					});
				}
			}
		}

		function loadMediaTagsToEdit() {
			loadMediaWithTags(vm.currentItem).then(response => {
				if(response) {
					vm.currentItem.tags = response.tags;
					vm.currentItem.galleries = response.galleries;
					vm.currentItem.meta_analyses = response.meta_analyses;
					vm.currentItem.ai_recognition = response.ai_recognition;
				}
			})
		}

		function loadMediaWithTags(media) {
			if(media){
				var options = {
					siteID: vm.siteID,
					withTags: true,
					withCropstatus: true,
					idMedia: media.id_media,
					withGalleries: true
				};
				return mediaService.get(options).then(function(response){
					return response.data[0];
				});
			}else{
				return false;
			}
		}

	/**
		 * Add label chips
		 *
		 * @param query
		 * @returns {filterFn}
		 */
		function labelQuerySearch(query) {
			var ret = [];
			if (query) {
				var filteredContent = angular.copy(vm.tags.filter(vm.createFilterFor(query)));
				if (filteredContent.length > 0) {
					ret.push({
						id_tag: 0,
						tag_name: "",
						order: 1
					});
				}
				angular.forEach(filteredContent, function (val) {
					ret.push(val);
				})
			}
			return ret;
		}

		/**
		 * Filter for chips
		 *
		 * @param query
		 * @returns {filterFn}
		 */
		function createFilterFor(query) {
			var lowercaseQuery = angular.lowercase(query);
			return function filterFn(item) {
				if (angular.isUndefined(item.tag_name)) {
				  return false;
				}
				if (!item.tag_name) {
				  return false;
				}
				if (!angular.lowercase(item.tag_name.toString()).indexOf) {
				  return false;
				}
				return angular.lowercase(item.tag_name.toString()).indexOf(lowercaseQuery) >= 0;
			};
		}

		function newTag(tagName) {

			if (vm.newTagDisabled) {
				return false;
			}
			vm.newTagDisabled = true;

			var newTag = {
				id_tag: '',
				tag_name: tagName
			};
			var options = {
				site: $scope.siteID,
				item: newTag
			};
			tagsService.saveItem(options).then(function (response) {
				newTag.id_tag = response.id_tag;
				vm.image.tags.push(newTag);
				vm.searchTagText = '';
				vm.newTagDisabled = false;
			})
		}
/*
		function removeTag(media, tag) {
			console.log('removeTag',vm.currentItem.tags);
			console.log('removeTag',media.tags);return;
			saveMedia(media)
				.finally(function(){
					vm.searchTagText = '';
					vm.selectedTag = null;
				})
		}
*/
		function removeTag(media, tag, event) {
			event.stopImmediatePropagation(); // prevent mdChipRemove directive from removing a chip too.
			for (var i = media.tags.length-1; i >= 0; i--) {
				if (media.tags[i].id_tag === tag.id_tag) {
					media.tags.splice(i, 1);
				}
			}
			saveMedia(media)
				.finally(function(){
					vm.searchTagText = '';
					vm.selectedTag = null;
				})
		}

		function selectedItemChange() {
			saveMedia(vm.currentItem)
				.finally(function(){
					vm.searchTagText = '';
					vm.selectedTag = null;
				})
		}

		function saveMedia(mediaOrig) {
			var media = angular.copy(mediaOrig)
			media.tags = media.tags.map(t => t.id_tag);
			media.galleries = media.galleries.map(g => g.id_gallery)
			var options = {
				site: vm.siteID,
				id: media.id_media,
				item: media
			};
			return mediaService.saveMedia(options);
		}

		function initMejPlayer() {
			setTimeout(() => {
				var player = new MediaElementPlayer('vp-m3u8', {
					startVolume: 1,
					alwaysShowControls: true,
					features: ['playpause', 'current', 'progress', 'tracks', 'volume', 'fullscreen'],
					success: (mediaElement, domObject) => {
						mediaElement.play();
					}
				});
			}, 200);
		}
		function changeView(view) {
			if (vm.views[view]) {
				vm.loadingView = true;
				vm.showSearchAndPaginator = false;
				vm.defaultView = view;
				vm.currentView = view;
			}
		}
		function toggleSubstitles() {
			vm.showSubtitles = !vm.showSubtitles;
		}


		function edit() {
			var $fotoramaDiv = angular.element("#fotorama1");
		}



		"use strict";

		function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

		function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

		function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

		function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

		function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

		function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

		function createMaxCharacterPerLineRule() {
			var characterPerLine = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 40;
			return function (element, newElement) {
				return element.content.length + 1 + newElement.content.length < characterPerLine;
			};
		}

		function createMaxTimeRule() {
			var maxTimeInMs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;
			return function (element, newElement) {
				return newElement.from - element.to < maxTimeInMs;
			};
		}

		function createMaxLinesRule() {
			var maxLines = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;
			return function (element, newElement) {
				return element.lines < maxLines;
			};
		} // similar to moment.duration but without having to pull in the entire moment library


		function duration(ms) {
			var millisecondsPerHour = 1000 * 3600;
			var millisecondsPerMinute = 1000 * 60;

			var _hours = Math.floor(ms / millisecondsPerHour);

			ms -= _hours * millisecondsPerHour;

			var _minutes = Math.floor(ms / millisecondsPerMinute);

			ms -= _minutes * millisecondsPerMinute;

			var _seconds = Math.floor(ms / 1000);

			ms -= _seconds * 1000;
			return {
				hours: function hours() {
					return _hours;
				},
				minutes: function minutes() {
					return _minutes;
				},
				seconds: function seconds() {
					return _seconds;
				},
				milliseconds: function milliseconds() {
					return ms;
				}
			};
		}

		function createTimeStamp(ms) {
			var dur = duration(ms);
			return "".concat(dur.hours() > 9 ? dur.hours() : '0' + dur.hours(), ":").concat(dur.minutes() > 9 ? dur.minutes() : '0' + dur.minutes(), ":").concat(dur.seconds() > 9 ? dur.seconds() : '0' + dur.seconds(), ".").concat(dur.milliseconds() > 99 ? dur.milliseconds() : dur.milliseconds() > 9 ? '0' + dur.milliseconds() : '00' + dur.milliseconds());
		}

		function awsTranscribeToVtt(event) {
			var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
				_ref$characterPerLine = _ref.characterPerLine,
				characterPerLine = _ref$characterPerLine === void 0 ? 40 : _ref$characterPerLine,
				_ref$maxLines = _ref.maxLines,
				maxLines = _ref$maxLines === void 0 ? 2 : _ref$maxLines,
				_ref$maxTimeInMs = _ref.maxTimeInMs,
				maxTimeInMs = _ref$maxTimeInMs === void 0 ? 1000 : _ref$maxTimeInMs;

			var wordsToLineMergeRules = [createMaxCharacterPerLineRule(characterPerLine), createMaxTimeRule(maxTimeInMs)];
			var multilineMergeRules = [createMaxLinesRule(maxLines), createMaxTimeRule(maxTimeInMs)];
			return 'WEBVTT\n\n' + event.results.items.map(function (e) {
				return {
					content: e.alternatives[0].content,
					from: Math.floor(parseFloat(e.start_time) * 1000),
					to: Math.floor(parseFloat(e.end_time) * 1000),
					characterCount: e.alternatives[0].content ? e.alternatives[0].content.length : 0,
					type: e.type,
					// pronunciation | punctuation
					lines: 1
				};
			}).reduce(function (acc, cur) {
				if (acc.length === 0) return [cur];
				var last = acc[acc.length - 1];

				if (cur.type === 'pronunciation') {
					var shouldMerge = wordsToLineMergeRules.reduce(function (shouldMerge, rule) {
						return shouldMerge ? rule(last, cur) : false;
					}, true);

					if (shouldMerge) {
						acc[acc.length - 1] = Object.assign({}, last, {
							content: "".concat(last.content, " ").concat(cur.content),
							to: cur.to,
							characterCount: last.characterCount + 1 + cur.characterCount
						});
						return acc;
					}

					return [].concat(_toConsumableArray(acc), [cur]);
				} //cur.type === 'punctuation'
				else {
					acc[acc.length - 1] = Object.assign({}, last, {
						content: "".concat(last.content).concat(cur.content),
						characterCount: last.characterCount + cur.characterCount
					});
					return acc;
				}
			}, []).reduce(function (acc, cur) {
				if (acc.length === 0) return [cur];
				var last = acc[acc.length - 1];
				var shouldMerge = multilineMergeRules.reduce(function (shouldMerge, rule) {
					return shouldMerge ? rule(last, cur) : false;
				}, true);

				if (shouldMerge) {
					acc[acc.length - 1] = Object.assign({}, last, {
						content: "".concat(last.content, "\n").concat(cur.content),
						to: cur.to,
						characterCount: last.characterCount + cur.characterCount,
						lines: ++last.lines
					});
					return acc;
				}

				return [].concat(_toConsumableArray(acc), [cur]);
			}, []).reduce(function (acc, cur, idx) {
				return [].concat(_toConsumableArray(acc), ["".concat(idx + 1, "\n") + "".concat(createTimeStamp(cur.from), " --> ").concat(createTimeStamp(cur.to), "\n") + "".concat(cur.content, "\n\n")]);
			}, []).join('');
		}

	}
})();



(function() {
    'use strict';

    angular
        .module('app.content')
        .controller('RssImportDialogController', RssImportDialogController);


    /** @ngInject */
    function RssImportDialogController(
        $scope,
        $rootScope,
        $mdDialog,
        requestContext,
        $translate,
        $mdToast,
        contentService,
        sessionService,
        rss,
        section,
        importSection,
        $q
    ) {

        var vm = this;
        var siteID = requestContext.getParam("siteId");

        // Data
        vm.loading = false;
        vm.importSection = importSection;
        vm.currentThread = {};
        vm.rssUrl = rss.url;
        vm.absoluteUrl = !angular.isUndefined(rss.absolute_url) ? rss.absolute_url : '';
        vm.isJsonFile = false;
        vm.mediaSource = rss.name;
        vm.forceHttps = (rss.force_https && rss.force_https === 1) ? true : false;
        vm.channel = false;
        vm.items = [];
        vm.selectedThreads = [];
        vm.selectedLanguage = false;
        vm.selectedStatus = 0;
        vm.subsecs = [];
        vm.selectedSubsec = false;
        vm.isHomeFeed = false;
        vm.descriptionAsText = false;
        vm.rssSearch = "";

        // Methods
        vm.closeDialog = closeDialog;
        vm.save = save;
        vm.isSelected = isSelected;
        vm.toggleSelectThread = toggleSelectThread;
        vm.deselectThreads = deselectThreads;
        vm.toggleSelectThreads = toggleSelectThreads;
        vm.selectThreads = selectThreads;
        vm.siteLanguages = siteLanguages;
        vm.getSubsecs = getSubsecs;
        vm.isJson = isJson;

        init();

        function init() {
            vm.loading = true;

            vm.isJsonFile = vm.isJson()
            var options = {
                site: siteID,
                section: section,
                data: {
                    url: vm.rssUrl
                }
            };
            if (vm.isJsonFile) {
              contentService.readJson(options)
                .then(function (response) {
                  vm.items = response;
                  vm.loading = false;
                });
            } else {
              contentService.parseXmlToJson(options)
                .then(function (response) {
                  if (response.channel) {
                    vm.channel = response.channel;
                    vm.items = vm.channel.item;
                  }
                  vm.loading = false;
                });
            }
        }

        function closeDialog() {
            $mdDialog.hide(false);
        }

        function save() {
            vm.loading = true;

            var promiseList = [];

            angular.forEach(vm.selectedThreads, function (item) {

              if (vm.isJsonFile) {
                var data = {
                  "Thumbnail": [],
                  "tags": [],
                  "title": item.title,
                  "short_text": "",
                  "text": "",
                  "date": item.date,
                  "onoff": vm.selectedStatus,
                  "is_external_source": rss.import_as_external_source,
                  "link": vm.absoluteUrl + item.url,
                  "media_source": vm.mediaSource,
                  "home_feed": vm.isHomeFeed ? 1 : 0
                }
                if (vm.descriptionAsText) {
                  data.text = item.short_text;
                } else {
                  data.short_text = item.short_text;
                }
                if (!angular.isUndefined(item.media) && item.media) {
                  var imageUrl = item.media;
                  if (vm.forceHttps) {
                    imageUrl = imageUrl.replace('http:', 'https:');
                  }
                  data['external_image'] = imageUrl;
                }
              } else {
                var data = {
                  "Thumbnail": [],
                  "tags": [],
                  "title": item.title,
                  "short_text": "",
                  "text": "",
                  "date": moment.utc(item.pubDate, 'ddd, DD MMM YYYY HH:mm:ss ZZ').format('YYYY-MM-DD HH:mm:ss'),
                  "onoff": vm.selectedStatus,
                  "is_external_source": 1,
                  "link": item.link,
                  "media_source": vm.mediaSource,
                  "home_feed": vm.isHomeFeed ? 1 : 0
                }
                if (vm.descriptionAsText) {
                  data.text = item.short_text;
                } else {
                  data.short_text = item.short_text;
                }
                if (!angular.isUndefined(item.enclosure) && item.enclosure['@attributes'].url) {
                  var imageUrl = item.enclosure['@attributes'].url;
                  if (vm.forceHttps) {
                    imageUrl = imageUrl.replace('http:', 'https:');
                  }
                  data['external_image'] = imageUrl;
                } else if (!angular.isUndefined(item.thumbnail) && item.thumbnail['@attributes'].url) {
                  var imageUrl = item.thumbnail['@attributes'].url.replace('/s72-c/', '/');
                  if (vm.forceHttps) {
                    imageUrl = imageUrl.replace('http:', 'https:');
                  }
                  data['external_image'] = imageUrl;
                }
              }
              if (vm.selectedLanguage !== false) {
                data['lang'] = parseInt(vm.selectedLanguage);
              }
              if (vm.selectedSubsec !== false) {
                data['id_subsec'] = parseInt(vm.selectedSubsec);
              }
              if (item.guid) {
                data['id_external_source'] = item.guid;
              }

              var options = {
                site: siteID,
                section: vm.importSection,
                id: 'new',
                item: data
              };
              promiseList.push(contentService.saveItem(options));
            });

            $q.all(promiseList).then(function (response) {

                vm.loading = false;
                var message = (vm.selectedThreads.length > 1) ? $translate.instant('CONTENT.RSS_IMPORTED_PLURAL') : $translate.instant('CONTENT.RSS_IMPORTED_SINGULAR');

                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                    hideDelay: 5000,
                    position: 'top',
                    parent: '#content-container'
                });
                $mdDialog.hide(true);
            }).catch(function (error) {
                var message = "Import error!";
                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                    hideDelay: 5000,
                    position: 'top',
                    parent: '#content-container'
                });
                vm.loading = false;
            });

        }

        /**
         * Return selected status of the thread
         *
         * @param thread
         * @returns {boolean}
         */
        function isSelected(thread) {
          return vm.selectedThreads.indexOf(thread) > -1;
        }

        /**
         * Toggle selected status of the thread
         *
         * @param thread
         * @param event
         */
        function toggleSelectThread(thread, event) {
          if (event) {
            event.stopPropagation();
          }

          if (vm.selectedThreads.indexOf(thread) > -1) {
            vm.selectedThreads.splice(vm.selectedThreads.indexOf(thread), 1);
          } else {
            vm.selectedThreads.push(thread);
          }
        }

        /**
         * Deselect threads
         */
        function deselectThreads() {
          vm.selectedThreads = [];
        }

        /**
         * Toggle select threads
         */
        function toggleSelectThreads() {
          if (vm.selectedThreads.length > 0) {
            vm.deselectThreads();
          } else {
            vm.selectThreads();
          }
        }

        /**
         * Select threads. If key/value pair given,
         * threads will be tested against them.
         *
         * @param [key]
         * @param [value]
         */
        function selectThreads(key, value) {
          // Make sure the current selection is cleared
          // before trying to select new threads
          vm.selectedThreads = [];

          for (var i = 0; i < vm.items.length; i++) {
            if (angular.isUndefined(key) && angular.isUndefined(value)) {
              vm.selectedThreads.push(vm.items[i]);
              continue;
            }

            if (angular.isDefined(key) && angular.isDefined(value) && vm.items[i][key] === value) {
              vm.selectedThreads.push(vm.items[i]);
            }
          }
        }

        function getSubsecs() {
            var options = {
                site: siteID,
                section: vm.importSection
            }
            contentService.getFilters(options).then(function(response){
                if (response.filters.id_subsec.values) {
                    vm.subsecs = response.filters.id_subsec.values;
                }
            });
        }

        function siteLanguages() {
            return sessionService.getSiteLanguages();
        }

        function isJson() {
          console.log(vm.rssUrl);
          var ext = vm.rssUrl.split('.').pop();
          if (ext == 'json') {
            return true;
          }
          return false;
        }
    }

})();

(function () {
	'use strict';

	angular
		.module('app.media')
		.controller('MediaItemMetadataDialogController', MediaItemMetadataDialogController);

	/** @ngInject */
	function MediaItemMetadataDialogController($mdDialog, ImageSelected, $document, mediaService, requestContext, $mdToast, $scope, $translate, $log, $sce, sessionService, moment) {
		var vm = this;
console.log(ImageSelected);
		vm.views = {
			// fotorama: 'app/main/dialogs/media-show/views/fotorama-view.html',
			editmedia: 'app/main/dialogs/media-item-metadata/views/media-item-metadata-view-form.html',
		};
		vm.defaultView = 'editmedia';
		vm.currentView = 'editmedia';

		// Data
		vm.title = 'View Media';
		vm.image = null;
		vm.dataImages = [];

		vm.dateFormat = sessionService.site_operative.dateFormat;
		vm.dateTimeFormat = sessionService.site_operative.dateTimeFormat;
		vm.showDate = showDate;

		// Methods
		vm.closeDialog = closeDialog;
		vm.changeView = changeView;
		vm.saveImageFocus = saveImageFocus;
		vm.ctrlFn = updateMediaFocal;
		vm.updateDatePicker = updateDatePicker;
		vm.searchTagText = null;
		vm.selectedTag = null;
		vm.createFilterFor = createFilterFor;
		vm.selectedItemChange = selectedItemChange;
		vm.labelQuerySearch = labelQuerySearch;
		vm.translate = function(text) {
			return $translate.instant(text);
		}
		vm.newTag = newTag;
		vm.tags = sessionService.site_operative.tags;


		// //////////
		init();

		function showDate(value) {
			if (angular.isObject(value)) {
				return value.dateShow;
			} else if (value == '0000-00-00 00:00:00') {
				return '-';
			} else {
				return moment.utc(value).tz(sessionService.site_operative.timezone).format(vm.dateTimeFormat);
			}
		}

		/**
		 * Close dialog
		 */
		function closeDialog()
		{
			$mdDialog.hide(false);
		}


		function init()
		{
			vm.image = angular.copy(ImageSelected);
			$log.info(vm.image)
			// vm.image.owner	= $sce.trustAsHtml(vm.image.owner);

			var utcDate = moment.utc(value);
			var siteDate = moment.utc(value).tz(sessionService.site_operative.timezone);

			var value = vm.image.file_date;
			if (value == '0000-00-00 00:00:00') {
				value = moment().format("YYYY-MM-DD");
			}
			vm.image.file_date = {};
			vm.image.file_date['value'] = value;
			vm.image.file_date['date'] = new Date(siteDate.format());
			vm.image.file_date['dateShow'] = siteDate.format(vm.dateTimeFormat);
			vm.image.file_date['utcShow'] = utcDate.format(vm.dateTimeFormat);
			vm.image.file_date['utcDate'] = utcDate;

			value = vm.image.date_uploaded;
			if (value == '0000-00-00 00:00:00') {
				value = moment().format("YYYY-MM-DD");
			}
			vm.image.date_uploaded = {};
			vm.image.date_uploaded['value'] = value;
			vm.image.date_uploaded['date'] = new Date(siteDate.format());
			vm.image.date_uploaded['dateShow'] = siteDate.format(vm.dateTimeFormat);
			vm.image.date_uploaded['utcShow'] = utcDate.format(vm.dateTimeFormat);
			vm.image.date_uploaded['utcDate'] = utcDate;

			vm.image.imageUrl = ImageSelected.container.view_url + 'original/m' + ImageSelected.id_media + '_' + ImageSelected.filename;

			vm.image.tags = [];
			angular.forEach(ImageSelected.tags, function(tag){
				vm.image.tags.push(tag);
			});
			vm.image.galleries = [];
			angular.forEach(ImageSelected.galleries, function(gallery){
				vm.image.galleries.push(gallery.id_gallery);
			});

			$scope.siteID  = requestContext.getParam("siteId");
			$scope.section  = requestContext.getParam("section");
		}


		function updateDatePicker (field) {
			console.log(field)
			var value = moment.utc(vm.image[field].date).format('YYYY-MM-DD HH:mm:00');

			var utcDate = moment.utc(value);

			var siteDate = moment.utc(value).tz(sessionService.site_operative.timezone);

			vm.image[field] = {};
			vm.image[field]['value'] = value;
			vm.image[field]['date'] = new Date(siteDate.format());
			vm.image[field]['dateShow'] = siteDate.format(vm.dateTimeFormat);
			vm.image[field]['utcShow'] = utcDate.format(vm.dateTimeFormat);
			vm.image[field]['utcDate'] = utcDate;

		};

		function updateMediaFocal(x,y)
		{
			vm.image.imageCenterRatioX = x;
			vm.image.imageCenterRatioY = y;
		}

		function saveImageFocus()
		{
			var tagIds = [];
			angular.forEach(vm.image.tags, function(tag){
				tagIds.push(tag.id_tag);
			});

			var imageToSave = {
				'tags': tagIds,
				'galleries': vm.image.galleries,
				'title': vm.image.title,
				'owner': vm.image.owner,
				'filename': vm.image.filename,
				'photographer': vm.image.photographer,
				'size': vm.image.size,
				'caption': vm.image.caption,
				'city': vm.image.city,
				'country': vm.image.country,
				'date_uploaded': vm.image.date_uploaded.value,
				'duration': vm.image.duration,
				'embed': vm.image.embed,
				'embed_thumb': vm.image.embed_thumb,
				'embed_url': vm.image.embed_url,
				'extra': vm.image.extra,
				'fileSizeKb': vm.image.fileSizeKb,
				'file_date': vm.image.file_date.value,
				'geoLat': vm.image.geoLat,
				'geoLon': vm.image.geoLon,
				'geotag': vm.image.geotag,
				'imageCenterRatioX': vm.image.imageCenterRatioX,
				'imageCenterRatioY': vm.image.imageCenterRatioY,
				'rating': vm.image.rating,
				'uses': vm.image.uses,
			};

			var options = {
				site: $scope.siteID,
				id: vm.image.id_media,
				item: imageToSave
			};

			mediaService.saveMedia(options).then(function(response) {

				vm.image=angular.copy(response);
				var message = $translate.instant('CONTENT.MEDIA_ITEM_METADATA_UPDATED');

				$mdToast.show({
					template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
					hideDelay: 5000,
					position: 'top',
					parent: '#content-container'
				});

				$mdDialog.hide(vm.image);

			});
		}

		function changeView(view)
		{
			if (vm.views[view]) {
				vm.loadingView = true;
								vm.showSearchAndPaginator	= false;
				vm.defaultView = view;
				vm.currentView = view;
			}
		}

		function selectedItemChange() {
			vm.searchTagText = '';
			vm.selectedTag = null;
		}


		/**
		 * Add label chips
		 *
		 * @param query
		 * @returns {filterFn}
		 */
		function labelQuerySearch(query) {
          var ret = [];
          if (query) {
            var filteredContent = angular.copy(vm.tags.filter(vm.createFilterFor(query)));
            if (filteredContent.length > 0) {
              ret.push({
                id_tag: 0,
                tag_name: "",
                order: 1
              });
            }
            angular.forEach(filteredContent, function(val) {
              ret.push(val);
            })
          }
          return ret;
        }
		

		/**
		 * Filter for chips
		 *
		 * @param query
		 * @returns {filterFn}
		 */
		function createFilterFor(query) {
			var lowercaseQuery = angular.lowercase(query);
			return function filterFn(item) {
				if (angular.isUndefined(item.tag_name))
				{
					return false;
				}
				if (!item.tag_name)
				{
					return false;
				}
				if (!angular.lowercase(item.tag_name.toString()).indexOf)
				{
					return false;
				}
				return angular.lowercase(item.tag_name.toString()).indexOf(lowercaseQuery) >= 0;
			};
		}

		function newTag(tagName) {
			var newTag = {
				id_tag: '',
				tag_name: tagName
			};
			vm.tags.push(newTag);
			vm.image.tags.push(newTag);
			vm.searchTagText = '';
		}


	}
})();

(function () {
	'use strict';

	angular
		.module('app.media')
		.controller('MediaFocalPointDialogController', MediaFocalPointDialogController);

	/** @ngInject */
	function MediaFocalPointDialogController($mdDialog, ImageSelected, $document, mediaService, requestContext, $mdToast, $scope, $translate, sessionService) {
		var vm = this;

		vm.views = {
			// fotorama: 'app/main/dialogs/media-show/views/fotorama-view.html',
			editmedia: 'app/main/dialogs/media-focal-point/views/edit-media-view.html',
		};
		vm.defaultView = 'editmedia';
		vm.currentView = 'editmedia';

		// Data
		vm.title = 'View Media';
		vm.image = null;
		vm.dataImages = [];

		// Methods
		vm.closeDialog = closeDialog;
		vm.changeView = changeView;
		vm.saveImageFocus = saveImageFocus;
		vm.ctrlFn = updateMediaFocal;

		// //////////
		init();

		/**
		 * Close dialog
		 */
		function closeDialog()
		{
			$mdDialog.hide(vm.image);
		}


		function init()
		{
			vm.image = angular.copy(ImageSelected);
      		vm.container = sessionService.getContainerByID(ImageSelected.cdnContainer);
			vm.image.imageUrl = vm.container.view_url + 'original/m' + ImageSelected.id_media + '_' + ImageSelected.filename;

			vm.image.tags = [];
			angular.forEach(ImageSelected.tags, function(tag){
				vm.image.tags.push(tag.id_tag);
			});
			vm.image.galleries = [];
			angular.forEach(ImageSelected.galleries, function(gallery){
				vm.image.galleries.push(gallery.id_gallery);
			});

			$scope.siteID  = requestContext.getParam("siteId");
			$scope.section  = requestContext.getParam("section");
		}

		function updateMediaFocal(x,y)
		{
			vm.image.imageCenterRatioX = x;
			vm.image.imageCenterRatioY = y;
    }

		function saveImageFocus()
		{
			var imageToSave = {
				'imageCenterRatioX': vm.image.imageCenterRatioX,
				'imageCenterRatioY': vm.image.imageCenterRatioY,
				'tags': vm.image.tags,
				'galleries': vm.image.galleries,
			};

			var options = {
				site: $scope.siteID,
				id: vm.image.id_media,
				item: imageToSave
			};

			mediaService.saveMedia(options).then(function(response) {

				vm.image=angular.copy(response);
				var message = $translate.instant('CONTENT.FOCAL_POINT_UPDATED');

				$mdToast.show({
					template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
					hideDelay: 5000,
					position: 'top',
					parent: '#content-container'
				});

				vm.closeDialog(vm.image);
				
			});
		}

		function changeView(view)
		{
			if (vm.views[view]) {
				vm.loadingView = true;
								vm.showSearchAndPaginator	= false;
				vm.defaultView = view;
				vm.currentView = view;
			}
		}

	}
})();

(function () {
	'use strict';

	angular
		.module('app.media')
		.controller('JoinClipsDialogController', JoinClipsDialogController);

	/** @ngInject */
	function JoinClipsDialogController($scope, sessionService, dragulaService, requestContext, matchCenterService,
		$mdDialog, $document, selectedClips) {
		var vm = this;

		// Data
		vm.selectedClips = selectedClips;


		vm.closeDialog = closeDialog;
		vm.saveDialog = saveDialog;

		vm.isSelected = isSelected;
		vm.toggleSelectThread = toggleSelectThread;
		vm.openSelectMediaDialog = openSelectMediaDialog;

		dragulaService.options($scope, 'attachment', {
			copy: false,
			copySortSource: false,
			removeOnSpill: false,
			direction: 'horizontal',
			moves: function (el, source, handle, sibling) {
				return handle.classList.contains('drag');
			},
		})
		$scope.$on('zone.drop', (e, el) => {
			updateWidgetContainers();
			// updateContainers();
		});


		function openSelectMediaDialog(ev) {
			$mdDialog.show({
				controller: 'SelectMediaToJoinDialogController',
				controllerAs: 'vm',
				locals: {
					alreadySelected: vm.selectedClips,
					media_type: 2
				},
				templateUrl: 'app/main/dialogs/select-media-to-join/select-media-to-join-dialog.controller.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				multiple: true,
				clickOutsideToClose: true
			}).then(function (res) {
				if (res) {
					vm.selectedClips = vm.selectedClips.concat(res)
				}
			});
		}

		function isSelected(CLIP) {
			return vm.selectedClips.indexOf(CLIP) > -1;
		}
		function toggleSelectThread(CLIP, event) {
			if (event) {
				event.stopPropagation();
			}

			if (vm.selectedClips.indexOf(CLIP) > -1) {
				vm.selectedClips.splice(vm.selectedClips.indexOf(CLIP), 1);
			} else {
				vm.selectedClips.push(CLIP);
			}
		}
		vm.translate = function (text) {
			return $translate.instant(text);
		}
		function closeDialog() {
			$mdDialog.hide();
		}
		function saveDialog() {
			var siteID = requestContext.getParam("siteId");
			vm.loading = true;
			var options = {
				siteID: siteID,
				item: {
					"id_zone": null,
					"media_files": vm.selectedClips.map((x, index) => {
						var cropContainerLeft = sessionService.getContainerByID(x.cdnContainer);
						return {
							"url": "s3://" + cropContainerLeft.sourceBucket + "/videos/m" + x.id_media + '_' + x.filename,
							"sort": index
						}
					})
				}
			}

			matchCenterService.joinClips(options).then(function (response) {
				console.log(response);
				vm.loading = false;
				$mdDialog.hide();
			})
		}

	}
})();

(function ()
{
    'use strict';

    angular
        .module('app.dialog.media-dialog', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        // // Translation
        $translatePartialLoaderProvider.addPart('app/main/dialogs/media');

        // // Api
        // msApiProvider.register('quickPanel.activities', ['app/data/quick-panel/activities.json']);
        // msApiProvider.register('quickPanel.contacts', ['app/data/quick-panel/contacts.json']);
        // msApiProvider.register('quickPanel.events', ['app/data/quick-panel/events.json']);
        // msApiProvider.register('quickPanel.notes', ['app/data/quick-panel/notes.json']);
    }
})();

(function () {
    'use strict';

    angular
        .module('app.dialog.media-dialog')
        .service("mediaDialogService", MediaDialogService);

    /** @ngInject */
    function MediaDialogService($rootScope, $resource, $http, mediahubService, COMMON) {

        // importFromMediaHub uses $http directly (below) because it needs a dynamic x-api-key header.

        // importFromIconik uses $http directly (below) because it needs a dynamic X-Group-Id header.

        function unnestGalleries(node, galleries, includeSubgalleries) {
            galleries.push(node);
            if (includeSubgalleries && typeof node.children !== 'undefined' && node.children.length > 0) {
                angular.forEach(node.children, function (data) {
                    unnestGroups(data, galleries, includeSubgalleries);
                });
            }
            return galleries;
        }

        function triggerMediaDialogMediaByGalleries(galleryNode, includeSubgalleries) {
            var galleries = false;
            if (galleryNode) {
                var node = angular.fromJson(galleryNode);
                galleries = unnestGalleries(node, [], includeSubgalleries);
            }
            $rootScope.$broadcast('loadMediaDialogMediaByGalleries', galleries);
        }

        function importFromMediaHub(domain, idMedia) {
            // Send the mediahub x-api-key (and X-Tenant) so qiu-api can resolve the asset against
            // the same mediahub API the user is browsing with — mirrors the Iconik X-Group-Id flow.
            // (qiu-api must forward the header to the mediahub API for it to take effect.)
            // Uses $http rather than the $resource action because the header is dynamic (per tenant).
            var url = COMMON.BASE_API + "/domain/" + domain + "/media/importFromMediaHub";
            return $http.post(url, {
                id_media: idMedia
            }, {
                headers: mediahubService.mhHeaders()
            }).then(function (res) {
                return res.data;
            });
        }

        function importFromIconik(domain, idMedia) {
            // Send the caller's audience as X-Group-Id so qiu-api resolves the asset against the
            // same Iconik key the user is browsing with. Without it the import resolves with the
            // public key and 403s on anything that key can't see (e.g. staff-only assets).
            // (qiu-api must forward this header to the media proxy for it to take effect.)
            //
            // Uses $http rather than the $resource action because the header is dynamic (per user).
            // Send both id keys: the deployed endpoint reads 'id' while the integration message
            // documented 'id_media'. Covering both avoids "Missing iconik id".
            var url = COMMON.BASE_API + "/domain/" + domain + "/media/importFromIconik";
            return $http.post(url, {
                id: idMedia,
                id_media: idMedia
            }, {
                headers: mediahubService.iconikHeaders()
            }).then(function (res) {
                return res.data;
            });
        }

        // Return the public API.
        return ({
            triggerMediaDialogMediaByGalleries: triggerMediaDialogMediaByGalleries,
            importFromMediaHub: importFromMediaHub,
            importFromIconik: importFromIconik
        });
    }
})();
(function () {
  'use strict';

  angular
    .module('app.dialog.media-dialog')
    .directive('qiuMediaDialogOnClickLoadMediaByGalleries', ['mediaDialogService', LoadMediaDialogMediaByGalleries])
    .controller('MediaDialogController', MediaDialogController)
    ;

  /** @ngInject */
  function MediaDialogController(
    $mdDialog,
    $document,
    currentThread,
    mediaService,
    uploadService,
    requestContext,
    $anchorScroll,
    $timeout,
    $scope,
    $sce,
    Upload,
    mediazone,
    section,
    maxAttach,
    msUtils,
    showViews,
    autoUpload,
    COMMON,
    isTiny,
    $log,
    transformMedia,
    $translate,
    sessionService,
    tagsService,
    $q,
    $mdSidenav,
    $rootScope,
    mediahubService,
    mediaDialogService,
    $http
  ) {
    var vm = this;

    // Data
    vm.currentThread = currentThread;

    vm.mediazone = mediazone;
    vm.defaultPage = 1;
    vm.defaultPerPage = 50;
    vm.PerPage = 50;
    vm.searchStringFilter = '';
    vm.searchQuery = '';
    vm.modelSearch = '';
    vm.pagination_search = pagination_search;
    vm.pageTokens = {};
    vm.authToken = null;

    vm.maxAttach = !angular.isUndefined(maxAttach) ? maxAttach : 99999;

    vm.isTiny = isTiny;

    vm.views = {
      1: 'app/main/dialogs/media/views/photos-view.html',
      2: 'app/main/dialogs/media/views/videos-view.html',
      3: 'app/main/dialogs/media/views/files-view.html',
      4: 'app/main/dialogs/media/views/audios-view.html',
      5: 'app/main/dialogs/media/views/galleries-view.html',
      upload: 'app/main/dialogs/media/views/upload-view.html',
      import: 'app/main/dialogs/media/views/import-view.html',
    };


    angular.forEach(vm.views, function (value, key) {
      if (!showViews.hasOwnProperty(key) || showViews[key] !== true) {
        delete vm.views[key];
      }
    });

    vm.defaultView = 1;
    vm.currentView = 1;

    vm.viewsTiny = {
      1: 'app/main/dialogs/media/views/tiny-attached.html',
      properties: 'app/main/dialogs/media/views/tiny-properties.html',
      upload: 'app/main/dialogs/media/views/upload-view.html',
    };
    vm.defaultViewTiny = 1;
    vm.currentViewTiny = 1;

    vm.selectedSource = 'qiusystem';
    vm.firstLoad = true;
    vm.media_type = 1;
    vm.showSearchAndPaginator = true;
    vm.import_field = '';
    vm.import_disabled = '';
    vm.importedFiles = [];
    vm.importPreview = false;
    vm.imported = false;
    vm.importing = false;
    vm.selectedContacts = [];
    vm.selectedGalleries = [];
    vm.files = [];
    vm.uploadFiles = [];
    vm.uploadedFiles = [];
    vm.tinyProperties = {
      mediaType: '',
      mediaSort: '',
      mediaData: {},
      align: '',
      size: ''
    };
    vm.tinyOptions = {
      size: [
        { value: 25, text: '25%' },
        { value: 50, text: '50%' },
        { value: 75, text: '75%' },
        { value: 100, text: '100%' }
      ],
      align: [
        { value: 'left', text: 'left' },
        { value: 'center', text: 'center' },
        { value: 'right', text: 'right' }
      ]
    }
    vm.searchTagText = '';
    vm.tags = sessionService.site_operative.tags;
    vm.currentTags = [];
    vm.selectedTag = null;
    vm.image = {};
    vm.newTagDisabled = false;
    vm.isAutoUpload = false;

    vm.fields = {
      geoLat: null,
      geoLon: null,
      title: null,
      photographer: null,
      owner: null,
      caption: null,
      city: null,
      country: null,
      uses: null,
      extras: null,
      rating: null,
    };

    // Methods
    vm.closeDialog = closeDialog;
    vm.changeView = changeView;
    vm.changeViewTiny = changeViewTiny;
    vm.changeViewGallery = changeViewGallery;
    vm.onSourceChange = onSourceChange;
    vm.getAuthToken = getAuthToken;

    vm.nextPage = nextPage;
    vm.prevPage = prevPage;
    vm.morePages = morePages;
    vm.gotoPage = gotoPage;
    vm.firstPage = firstPage;
    vm.upload = upload;
    vm.attachMedia = attachMedia;
    vm.attachMediaTiny = attachMediaTiny;
    vm.selectMediaTiny = selectMediaTiny;
    vm.selectedMediaTiny = '';

    vm.exists = msUtils.exists;
    vm.alreadySelectedbyZone = alreadySelectedbyZone;
    vm.existInArray = msUtils.existInArray;
    vm.toggleSelectContact = toggleSelectContact;
    vm.toggleSelectOne = toggleSelectOne;

    vm.selectedItemChange = selectedItemChange;
    vm.labelQuerySearch = labelQuerySearch;
    vm.createFilterFor = createFilterFor;
    vm.newTag = newTag;
    vm.getpos = getpos;
    vm.placeMarker = placeMarker;
    vm.searchLatLon = searchLatLon;
    vm.toggleMediaDialogSidenav = toggleMediaDialogSidenav;

    vm.importConfirm = importConfirm;

    vm.isNumber = angular.isNumber;

    vm.translate = function (text) {
      return $translate.instant(text);
    }

    if (isTiny) {
      vm.section = section;
      initTiny();
    } else {
      var siteID = requestContext.getParam("siteId");
      var section = requestContext.getParam("section");
      init();
    }

    if (autoUpload && autoUpload.length > 0) {
      this.changeView('upload');
      vm.files = autoUpload;
      vm.isAutoUpload = false;

    }


    /**
     * Tell the service which Iconik audience to ask for. The account's own assignment
     * (users_settings.iconikGroup, set from Accounts) wins; the tenant-wide default in
     * qiu_config.iconikGroup is the fallback for accounts nobody has assigned yet.
     */
    function applyIconikGroup(tenantDefault, siteId) {
      mediahubService.setIconikGroupId(tenantDefault);   // apply the fallback right away
      if (!siteId) return;
      $http.get(COMMON.BASE_API + '/domain/' + siteId + '/profile/getSettings')
        .then(function (res) {
          var rows = res.data || [];
          var row = rows.filter(function (r) { return r && r.id_domain; })[0] || rows[0];
          var settings = row && row.settings_json;
          if (angular.isString(settings)) settings = angular.fromJson(settings);
          if (settings && settings.iconikGroup) {
            mediahubService.setIconikGroupId(settings.iconikGroup);
          }
        })
        .catch(function () { /* keep the tenant default */ });
    }

    /**
     * Initialize
     */
    function init() {
      vm.loading = true;

      // Check MediaHub settings
      var currentSiteId = siteID || $rootScope.siteID;
      sessionService.loadDomainResourceSettings(currentSiteId).then(function (response) {
        if (response && response.public) {
          var publicConfig = angular.fromJson(response.public);
          if (publicConfig.mediahubUrl) {
            vm.mediahubUrl = publicConfig.mediahubUrl;
            var mediahubTenant = publicConfig.mediahubTenant || 'demo1';
            mediahubService.setApiUrl(vm.mediahubUrl, mediahubTenant);
            mediahubService.setApiKey(response.mediahub && response.mediahub['x-api-key']);
            if (publicConfig.vertexUrl) {
              vm.vertexUrl = publicConfig.vertexUrl;
              mediahubService.setVertexUrl(vm.vertexUrl);
              vm.getAuthToken().catch(function () {}); // auth mediahub/vertex opcional; evita unhandled rejection
            }
          }
          if (publicConfig.iconikUrl) {
            vm.iconikUrl = publicConfig.iconikUrl;
            mediahubService.setIconikUrl(vm.iconikUrl);
            applyIconikGroup(publicConfig.iconikGroup, currentSiteId);
          }
        }
      });

      if (vm.currentThread.Thumbnail) {
        for (var i = 0; i < vm.currentThread.Thumbnail.length; i++) {
          vm.selectedContacts.push(vm.currentThread.Thumbnail[i]);
          if (angular.isDefined(vm.currentThread.Thumbnail[i].gallery_type)) {
            vm.selectedGalleries.push(vm.currentThread.Thumbnail[i]);
          }
        }
      }
      changeView(vm.defaultView);
    }

    /**
     * Initialize Tinymce
     */
    function initTiny() {
      vm.currentViewTiny = vm.defaultViewTiny;
      vm.showSearchAndPaginator = false;
      vm.loading = true;
      vm.tinyProperties.mediaSort = '';
      vm.tinyProperties.mediaType = '';
      vm.tinyProperties.align = '';
      vm.tinyProperties.size = '';

      // Check MediaHub settings
      var currentSiteId = (typeof siteID !== 'undefined' ? siteID : null) || $rootScope.siteID;
      sessionService.loadDomainResourceSettings(currentSiteId).then(function (response) {
        if (response && response.public) {
          var publicConfig = angular.fromJson(response.public);
          if (publicConfig.mediahubUrl) {
            vm.mediahubUrl = publicConfig.mediahubUrl;
            vm.selectedSource = 'qiusystem'; // Default source
            var mediahubTenant = publicConfig.mediahubTenant || 'demo1';
            mediahubService.setApiUrl(vm.mediahubUrl, mediahubTenant);
            mediahubService.setApiKey(response.mediahub && response.mediahub['x-api-key']);
            if (publicConfig.vertexUrl) {
              vm.vertexUrl = publicConfig.vertexUrl;
              mediahubService.setVertexUrl(vm.vertexUrl);
              vm.getAuthToken().catch(function () {}); // auth mediahub/vertex opcional; evita unhandled rejection
            }
          }
          if (publicConfig.iconikUrl) {
            vm.iconikUrl = publicConfig.iconikUrl;
            mediahubService.setIconikUrl(vm.iconikUrl);
            applyIconikGroup(publicConfig.iconikGroup, currentSiteId);
          }
        }
      });

      for (var i = 0; i < vm.currentThread.length; i++) {
        if (vm.mediazone) {
          if (vm.currentThread[i].id_zone == 1) {
            vm.selectedContacts.push(vm.currentThread[i]);
          }
        } else {
          vm.selectedContacts.push(vm.currentThread[i]);
        }
      }
      if (vm.section.mediaSort) {
        var currentItem = '';
        currentItem = vm.selectedContacts.find(x => x.id_media == vm.section.mediaSort);
        if (currentItem) {
          vm.selectedMediaTiny = currentItem;
          vm.tinyProperties.mediaSort = vm.section.mediaSort;
          vm.tinyProperties.mediaType = currentItem.media_type;
          vm.tinyProperties.align = vm.section.mediaAlign;
          vm.tinyProperties.size = vm.section.mediaSize;
          vm.changeViewTiny('properties');
        }
      }
      vm.loading = false;
    }

    $scope.$on('loadMediaDialogMediaByGalleries', function (event, galleries) {
      if (galleries) {
        loadMediaByGalleries(galleries);
      } else {
        unselectGalleries();
      }
    })

    function unselectGalleries() {
      vm.selectedGallery = false;
      vm.selectedContent = false;
      $rootScope.pagination_galleryIds = false;
      $rootScope.sortField = "date_uploaded"; // reset to default
      $rootScope.sortDir = "DESC"; // reset to default
      var elemList = document.querySelectorAll('.gallery-row');
      elemList.forEach(function (elem) {
        elem.classList.remove('selected');
      });
      var options = {
        section: section,
        media_type: vm.media_type,
        page: vm.defaultPage,
        perPage: vm.defaultPerPage
      };
      getData(options);
    }

    function deselectFiles() {
      vm.files = [];
    }

    function pagination_search(searchString) {
      vm.loading = true;
      vm.pageTokens = {}; // Reset tokens on new search
      scrollToTopOfDialog();
      if (vm.selectedGallery) {
        loadMediaByGalleries([vm.selectedGallery]);
      } else {
        var options = {
          section: section,
          media_type: vm.media_type,
          page: vm.defaultPage,
          perPage: vm.defaultPerPage,
          searchString: searchString,
          gallery_type: vm.media_type
        };
        if (vm.media_type) {
          options.mediaTypeFilter = {
            'media_type': {
              selected: [vm.media_type],
              field: 'media_type',
              name: 'media_type'
            }
          }
        };
        getData(options);
      }
    }

    function getMediaGalleries(mediaType) {
      if (isExternalSource()) {
        return loadExternalGalleries();
      }

      if (sessionService.site_operative.mediaGalleriesDefaultSort) {
        vm.sortFieldGalleries = sessionService.site_operative.mediaGalleriesDefaultSort.field;
        if (!angular.isUndefined(sessionService.site_operative.mediaGalleriesDefaultSort.dir)) {
          vm.sortDirGalleries = sessionService.site_operative.mediaGalleriesDefaultSort.dir;
        }
      } else {
        vm.sortFieldGalleries = "sort";
        vm.sortDirGalleries = "ASC"
      }

      var options = {
        siteID: siteID,
        sortField: vm.sortFieldGalleries,
        sortDir: vm.sortDirGalleries
      };
      if (angular.isNumber(mediaType)) {
        options['gallery_type'] = [mediaType, 0];
      }
      mediaService.getNestedMediaGalleries(options)
        .then(function (response) {
          var qiuRestrictions = response.qiuRestrictions;
          var galleries = response.data;
          var nestedGalleries = transformMedia.formatNestedGalleries(galleries, qiuRestrictions, true);
          vm.CleanMediaGalleries = angular.copy(nestedGalleries);
          transformMedia.preAssignQiuRestrictedRoot(vm.CleanMediaGalleries)
          if (vm.currentView == 5) {
            vm.items = getNestedGalleriesWithMediaAssignment(nestedGalleries, vm.selectedContacts);
          }
          vm.loading = false;
        });
    }

    function getMediahubGalleries() {
      vm.loading = true;
      mediahubService.listGalleries()
        .then(function (resp) {
          var list = (resp && resp.data) ? resp.data : (resp || []);
          vm.CleanMediaGalleries = buildMediahubGalleryTree(list);
          if (vm.currentView == 5) {
            vm.items = vm.CleanMediaGalleries;
          }
        })
        .catch(function (err) {
          $log.error('[media-dialog] Error loading mediahub galleries', err);
          vm.CleanMediaGalleries = [];
        })
        .finally(function () {
          vm.loading = false;
        });
    }

    function getIconikGalleries() {
      vm.loading = true;
      mediahubService.listGalleriesIconik()
        .then(function (list) {
          vm.CleanMediaGalleries = buildMediahubGalleryTree(list || []);
          if (vm.currentView == 5) {
            vm.items = vm.CleanMediaGalleries;
          }
        })
        .catch(function (err) {
          $log.error('[media-dialog] Error loading iconik galleries', err);
          vm.CleanMediaGalleries = [];
        })
        .finally(function () {
          vm.loading = false;
        });
    }

    // External sources (mediahub / iconik) share the browse/import flow but hit different services.
    // Hoisted declaration: init() calls changeView() during construction, before assignment-style
    // (vm.x = fn) members exist, so this must be a function declaration.
    function isExternalSource() {
      return vm.selectedSource === 'mediahub' || vm.selectedSource === 'iconik';
    }
    function loadExternalGalleries() {
      return vm.selectedSource === 'iconik' ? getIconikGalleries() : getMediahubGalleries();
    }
    function externalGet(options) {
      return vm.selectedSource === 'iconik' ? mediahubService.getIconik(options) : mediahubService.get(options);
    }

    function buildMediahubGalleryTree(list) {
      var byId = {};
      var roots = [];
      list.forEach(function (g) {
        g.id_gallery = g.id;
        g.gallery_name = g.name;
        g.gallery_type = g.galleryType || 0;
        g.children = [];
        byId[g.id] = g;
      });
      Object.keys(byId).forEach(function (id) {
        var node = byId[id];
        if (node.parentId && byId[node.parentId]) {
          byId[node.parentId].children.push(node);
        } else {
          roots.push(node);
        }
      });
      return roots;
    }

    function loadMediaByGalleries(galleries) {
      vm.loading = true;
      var galleryIds = [];
      angular.forEach(galleries, function (gallery) {
        galleryIds.push(gallery.id_gallery);
      });
      vm.selectedGallery = galleries[0];

      var mediaTypeFilter = {
        'media_type': {
          selected: [vm.media_type],
          field: 'media_type',
          name: 'media_type'
        }
      };

      if (sessionService.site_operative.mediaInGalleriesDefaultSort) {
        $rootScope.sortField = sessionService.site_operative.mediaInGalleriesDefaultSort.field;
        if (!angular.isUndefined(sessionService.site_operative.mediaInGalleriesDefaultSort.dir)) {
          $rootScope.sortDir = sessionService.site_operative.mediaInGalleriesDefaultSort.dir;
        }
      } else {
        $rootScope.sortField = "sort";
      }

      var options = {
        siteID: siteID,
        page: vm.defaultPage,
        resultsPerPage: vm.defaultPerPage,
        search: vm.modelSearch,
        withCropStatus: true,
        withMediaChildren: true,
        sortField: $rootScope.sortField,
        sortDir: $rootScope.sortDir,
        gallery_type: vm.media_type,
        galleryIds: galleryIds
      };

      if (vm.media_type) {
        options.mediaTypeFilter = {
          'media_type': {
            selected: [vm.media_type],
            field: 'media_type',
            name: 'media_type'
          }
        }
      };

      if (isExternalSource()) {
        externalGet(options).then(function (response) {
          vm.totalItems = response.total;
          vm.from = response.from;
          vm.to = response.to;
          vm.currentPage = response.current_page;
          vm.lastPage = response.last_page;
          vm.items = response.data;
          // getIconik already flags items isIconik; mediahub items get isMediahub here
          if (vm.selectedSource === 'mediahub') {
            angular.forEach(vm.items, function (item) { item.isMediahub = true; });
          }
          vm.loading = false;
        });
        return;
      }

      mediaService.getMediaInGalleries(options).then(function (response) {
        vm.totalItems = response.total;
        vm.from = response.from;
        vm.to = response.to;
        vm.currentPage = response.current_page;
        vm.lastPage = response.last_page;
        vm.maxSize = 500;
        vm.bigTotalItems = 175;
        vm.items = response.data;
        vm.loading = false;
      });
    }


    function getData(options) {

      vm.loading = true;
      scrollToTopOfDialog();

      // Este diálogo ataca el endpoint /media (sistema antiguo), que no soporta
      // los campos de orden exclusivos de mediahub (fileDate/originalFileName).
      // $rootScope.sortField es global y mediahub puede haberlo dejado con uno de
      // esos valores, así que lo saneamos al default legacy.
      var mediahubOnlySorts = ['fileDate', 'originalFileName'];
      var legacySortField = mediahubOnlySorts.indexOf($rootScope.sortField) === -1 ? $rootScope.sortField : 'date_uploaded';

      var arrayOptions = {
        siteID: siteID,
        page: options.page,
        resultsPerPage: options.perPage,
        media_type: options.media_type,
        search: vm.modelSearch,
        withCropStatus: true,
        withMediaChildren: true,
        sortField: (vm.selectedGallery && legacySortField) ? legacySortField : 'date_uploaded',
      };

      if (vm.modelSearch && !_.isEmpty(vm.modelSearch)) {
        arrayOptions['searchStringFilter'] = vm.modelSearch;
      }

      if (vm.selectedGallery) {
        arrayOptions.galleryIds = [vm.selectedGallery.id_gallery];
        if ($rootScope.sortDir) {
          arrayOptions.sortDir = $rootScope.sortDir;
        }
      }

      if (isExternalSource()) {
        delete arrayOptions.media_type;

        // Pass the token for Vertex paging if it exists
        if (vm.modelSearch && vm.pageTokens[options.page]) {
          arrayOptions.nextPageToken = vm.pageTokens[options.page];
        }

        externalGet(arrayOptions)
          .then(function (response) {
            vm.totalItems = response.total;
            vm.from = response.from;
            vm.to = response.to;
            vm.currentPage = response.current_page;
            vm.lastPage = response.last_page;
            vm.items = response.data;

            // For Vertex, store next page token
            if (response.nextPageToken) {
              vm.pageTokens[vm.currentPage + 1] = response.nextPageToken;
            }

            // getIconik already flags items isIconik; mediahub items get isMediahub here
            if (vm.selectedSource === 'mediahub') {
              angular.forEach(vm.items, function (item) { item.isMediahub = true; });
            }
            vm.loading = false;
            vm.firstLoad = false;
          });
        return;
      }

      mediaService.get(arrayOptions)
        .then(function (response) {
          vm.totalItems = response.total;
          vm.from = response.from;
          vm.to = response.to;
          vm.currentPage = response.current_page;
          vm.lastPage = response.last_page;
          vm.maxSize = 500;
          vm.bigTotalItems = 175;
          vm.items = response.data;
          vm.loading = false;
          vm.firstLoad = false;
        })
    }

    function closeDialog() {
      // delete from media_files if upload not terminated.
      if (vm.uploadFiles.length == 0 || vm.uploadedFiles.length == vm.uploadFiles.length) {
        let ret = vm.currentThread;
        if (vm.currentThread.thumbnail && vm.currentThread.thumbnail.length < 1) {
          ret = vm.selectedContacts;
        }
        $mdDialog.hide(ret);
      } else {
        $mdDialog.show({
          templateUrl: 'app/main/dialogs/media/views/confirm-upload-close.html',
          controller: function ($mdDialog) {
            var vm = this;
            vm.answer = function (answer) {
              $mdDialog.hide(answer);
            };
          },
          controllerAs: 'vm',
          multiple: true,
          clickOutsideToClose: false
        }).then(function (answer) {
          if (answer === 'stay') {
            return;
          }
          if (answer === 'abort') {
            // Abort all ongoing uploads
            angular.forEach(vm.uploadFiles, function (file) {
              if (file.upload && file.upload.abort) {
                file.upload.abort();
              }
              file.uploadStatus = 'aborted';
            });

            // Delete all files (finished or not)
            var deleteIds = vm.uploadFiles.map(function (f) {
              return f.id_media;
            }).filter(function (id) {
              return !!id;
            });
            if (deleteIds.length > 0) {
              var options = {
                site: siteID,
                id_media: deleteIds,
                force: true
              };
              mediaService.massDelete(options);
            }
            $mdDialog.hide(vm.currentThread);
          }
        });
      }
    }

    function changeView(view) {

      if (vm.views[view] || (isExternalSource() && [1, 2, 3, 4].includes(view))) {

        vm.loading = true;
        scrollToTopOfDialog();
        setActiveTab(view);

        vm.showSearchAndPaginator = false;
        vm.defaultView = view;
        vm.currentView = view;
        vm.currentViewGallery = false;
        vm.CleanMediaGalleries = [];

        vm.media_type = view;

        var options = {
          section: section,
          page: 1,
          perPage: vm.PerPage,
          media_type: vm.media_type,
        };

        switch (view) {
          case 1:
            vm.showSearchAndPaginator = true;
            if (isExternalSource()) {
              if (!vm.CleanMediaGalleries || vm.CleanMediaGalleries.length === 0) {
                loadExternalGalleries();
              }
            } else {
              getMediaGalleries(vm.media_type);
            }
            getData(options);
            break;
          case 2:
            vm.showSearchAndPaginator = true;
            if (isExternalSource()) {
              if (!vm.CleanMediaGalleries || vm.CleanMediaGalleries.length === 0) {
                loadExternalGalleries();
              }
            } else {
              getMediaGalleries(vm.media_type);
            }
            getData(options);
            break;
          case 3:
            vm.showSearchAndPaginator = true;
            if (isExternalSource()) {
              if (!vm.CleanMediaGalleries || vm.CleanMediaGalleries.length === 0) {
                loadExternalGalleries();
              }
            } else {
              getMediaGalleries(vm.media_type);
            }
            getData(options);
            break;
          case 4:
            vm.showSearchAndPaginator = true;
            if (isExternalSource()) {
              if (!vm.CleanMediaGalleries || vm.CleanMediaGalleries.length === 0) {
                loadExternalGalleries();
              }
            } else {
              getMediaGalleries(vm.media_type);
            }
            getData(options);
            break;
          case 5:
            if (isExternalSource()) {
              if (!vm.CleanMediaGalleries || vm.CleanMediaGalleries.length === 0) {
                loadExternalGalleries();
              }
            } else {
              getMediaGalleries(vm.media_type);
            }
            getData(options);
            break;
          case 'upload':
            getMediaGalleries(vm.media_type);
            $mdSidenav('media-dialog-galleries-sidenav').close();
            break;
          case 'import':
            getMediaGalleries(vm.media_type);
            $mdSidenav('media-dialog-galleries-sidenav').close();
            vm.loading = false;
            break;
        }
      }
    }

    function onSourceChange(source) {
      vm.selectedSource = source;
      vm.selectedGallery = null; // Clear gallery selection when switching sources
      vm.CleanMediaGalleries = []; // Clear galleries to force reload for the new source

      // Auto-reset view if current view is forbidden for external sources (mediahub/iconik)
      if (isExternalSource()) {
        if (vm.currentView === 5 || vm.currentView === 'upload' || vm.currentView === 'import') {
          vm.currentView = 1;
        }
      }

      changeView(vm.currentView);
    }


    function setActiveTab(view) {
      $timeout(function () {
        $('.md-button:not(.source-tab)').removeClass('active');
        $('[type=' + view + ']').addClass('active');
      })
    }

    function changeViewTiny(view) {
      if (vm.viewsTiny[view]) {
        vm.items = [];
        vm.loadingView = true;
        vm.showSearchAndPaginator = false;
        vm.defaultViewTiny = view;
        vm.currentViewTiny = view;
        vm.currentViewGallery = false;
      }
    }

    function changeViewGallery(mediaType) {
      $mdSidenav('media-dialog-galleries-sidenav').close();

      vm.loadingView = true;
      vm.loading = true;
      scrollToTopOfDialog();

      vm.items = [];

      vm.totalItems = 0;
      vm.showSearchAndPaginator = false;

      vm.currentView = 5;
      vm.currentViewGallery = mediaType;

      getMediaGalleries(mediaType);
      setActiveTab(vm.currentView)
    }


    function getNestedGalleriesWithMediaAssignment(nestedGalleries, selectedContacts) {
      angular.forEach(nestedGalleries, function (gallery) {
        gallery.assigned_gallery = false;
        selectedContacts.find(function (obj) {
          if (vm.mediazone) {
            if (angular.isDefined(obj.id_gallery) &&
              obj.id_gallery == gallery.id_gallery &&
              obj.id_zone == vm.mediazone.id_zone) {
              gallery.assigned_gallery = true;
            }
          } else {
            if (angular.isDefined(obj.id_gallery) &&
              obj.id_gallery == gallery.id_gallery) {
              gallery.assigned_gallery = true;
            }
          }
        });
        if (typeof gallery.children !== 'undefined' && gallery.children.length > 0) {
          getNestedGalleriesWithMediaAssignment(gallery.children, selectedContacts);
        }
      });
      return nestedGalleries;
    }

    $scope.$watch('vm.files', function () {

      angular.forEach(vm.files, function (f) {
        vm.uploadFiles.push(f);
      });
      $scope.formUpload = false;
      if (vm.files != null) {
        // make files array for not multiple to be able to be used in ng-repeat in the ui
        if (!angular.isArray(vm.files)) {
          $timeout(function () {
            $scope.files = vm.files = [vm.files];
          });
          return;
        }
        for (var i = 0; i < vm.files.length; i++) {
          $scope.errorMsg = null;
          (function (f) {
            vm.upload(f, true);
          })(vm.files[i]);
        }
      }
    });

    $scope.$watch('vm.import_field', function () {
      vm.importConfirm(false);
    });

    $scope.log = '';

    function upload(file) {
      if (!file.$error) {
        file.processed = false;
        var uploadOptions = {
          siteID: siteID,
          filename: file.name,
          log: $scope.log,
          type: 'media'
        }
        //				console.debug("UPLOAD______****", file)
        uploadService.upload(file, uploadOptions).then(function (resp) {
          vm.uploadedFiles.push(resp.id_media);
          $scope.log = resp.log;
          var galleriesAssignedIds = getAssignedGalleriesIds(vm.CleanMediaGalleries, []);
          if (angular.isArray(galleriesAssignedIds) && galleriesAssignedIds.length) {
            var options = {
              site: siteID,
              data: {
                id_media: [file.id_media],
                id_gallery: galleriesAssignedIds
              }
            };
            mediaService.insertIntoGallery(options).then(function (response) {
              loadAndAttachMedia(file.id_media);
            })
          } else {
            loadAndAttachMedia(file.id_media);
          }
        });
      }
    };

    function upload(file) {
      if (!file.$error) {
        file.processed = false;
        mediaService.getS3UploadPreSignedUrl({
          siteID: siteID,
          fileName: file.name
        })
          .then(function (resp) {
            file.id_media = resp.id_media;
            file.upload = Upload.http({
              url: resp.url,
              skipAuthorization: true,
              method: 'PUT',
              headers: {
                "Content-Type": file.type != '' ? file.type : 'application/octet-stream'
              },
              data: file
            });
            file.upload
              .then(function (response) {
                file.result = response.data;
                // Update media
                mediaService.finishedUploadingFileToCdn({
                  siteID: siteID,
                  idMedia: file.id_media
                }).then(function (response) {
                  file.processed = true;
                  vm.uploadedFiles.push(file);
                  // Attach media to selected gallery
                  // For qiu-restricted users with limited gallery access we need to attach media
                  // to the users root gallery before loading the media again from api,
                  // otherwise the api won't return the media due to qiu restrictions.
                  var galleriesAssignedIds = getAssignedGalleriesIds(vm.CleanMediaGalleries, []);
                  if (angular.isArray(galleriesAssignedIds) && galleriesAssignedIds.length) {
                    var options = {
                      site: siteID,
                      data: {
                        id_media: [file.id_media],
                        id_gallery: galleriesAssignedIds
                      }
                    };
                    mediaService.insertIntoGallery(options).then(function (response) {
                      loadAndAttachMedia(file.id_media);
                    })
                  } else {
                    loadAndAttachMedia(file.id_media);
                  }
                }, function (error) {
                  if (error.status > 0)
                    $scope.errorMsg = error.status + ': ' + error.data;
                  console.log(error)
                })
              }, function (error) {
                if (error.status > 0)
                  $scope.errorMsg = error.status + ': ' + error.data;
              });
            file.upload
              .progress(function (evt) {
                file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
              });
          })
      }
    };

    function loadAndAttachMedia(idMedia) {
      mediaService.get({
        siteID: siteID,
        withCropStatus: true,
        idMedia: idMedia
      })
        .then(function (response) {
          //if (response.total == 1) {
          var photo = response.data[0];
          toggleSelectContact(photo);
          //}
          if (vm.uploadedFiles.length === vm.files.length && vm.isAutoUpload) {
            attachMedia();
          }
        });
    }

    function importConfirm(confirm) {
      vm.import_disabled = false;
      vm.imported = false;
      if (!confirm) {
        vm.importPreview = false;
      }
      if (vm.import_field.length > 10) {
        vm.importing = true;
        vm.import_disabled = true;

        $timeout(function () {
          var pastedUrl = vm.import_field;
          mediaService.importFromUrl({
            siteID: siteID,
            url: pastedUrl,
            execute: confirm
          })
            .then(function (response) {
              vm.importing = false;
              response.embedCodeSafe = $sce.trustAsHtml(response.metadata.embedCode);
              response.caption = response.metadata.caption;
              response.title = response.metadata.title;
              if (response.id_media) {
                // For qiu-restricted users with limited gallery access we need to attach media
                // to the users root gallery before loading the media again from api,
                // otherwise the api won't return the media due to qiu restrictions.
                var galleriesAssignedIds = getAssignedGalleriesIds(vm.CleanMediaGalleries, []);
                if (angular.isArray(galleriesAssignedIds) && galleriesAssignedIds.length) {
                  var options = {
                    site: siteID,
                    data: {
                      id_media: [response.id_media],
                      id_gallery: galleriesAssignedIds
                    }
                  };
                  mediaService.insertIntoGallery(options).then(function (resp) {
                    vm.imported = true;
                    vm.importPreview = false;
                    mediaService.get({
                      siteID: siteID,
                      withCropStatus: true,
                      idMedia: response.id_media
                    }).then(function (response) {
                      if (response.total == 1) {
                        var photo = response.data[0];
                        vm.importedFiles.push(photo);
                        toggleSelectContact(photo);
                      }
                    });
                  })
                } else {
                  vm.imported = true;
                  vm.importPreview = false;
                  mediaService.get({
                    siteID: siteID,
                    withCropStatus: true,
                    idMedia: response.id_media
                  }).then(function (response) {
                    if (response.total == 1) {
                      var photo = response.data[0];
                      vm.importedFiles.push(photo);
                      toggleSelectContact(photo);
                    }
                  });
                }
              } else {
                vm.importPreview = response;
              }
              vm.import_disabled = false;
            });
        })
      }
    }

    function nextPage() {
      var options = {
        page: vm.currentPage + 1,
        perPage: vm.PerPage,
        media_type: vm.media_type,
        searchString: vm.modelSearch
      };
      getData(options);
    }

    function prevPage() {
      var options = {
        page: vm.currentPage - 1,
        perPage: vm.PerPage,
        media_type: vm.media_type,
        searchString: vm.modelSearch
      };
      getData(options);
    }

    function morePages() {
      if (vm.selectedSource === 'mediahub' && vm.vertexUrl && vm.modelSearch) {
        return !!vm.pageTokens[vm.currentPage + 1];
      }
      if (vm.currentPage < vm.lastPage) return true;
      return false;
    }

    function getAuthToken() {
      var deferred = $q.defer();
      var xhr = new XMLHttpRequest();
      xhr.open('GET', '/api/auth/token', true);
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            try {
              var data = JSON.parse(xhr.responseText);
              if (data && data.token) {
                vm.authToken = data.token;
                mediahubService.setVertexAuthToken(vm.authToken);
                deferred.resolve(vm.authToken);
              } else {
                deferred.reject('No token in response');
              }
            } catch (e) {
              deferred.reject(e);
            }
          } else {
            deferred.reject('Auth failed: ' + xhr.status);
          }
        }
      };
      xhr.send();
      return deferred.promise;
    }

    function firstPage() {
      if (vm.currentPage == 1) return true;
      return false;
    }

    function gotoPage(i) {
      var options = {
        page: i,
        perPage: vm.PerPage,
        media_type: vm.media_type,
        searchString: vm.modelSearch
      };
      getData(options);
    }

    function alreadySelectedbyZone(array, item) {
      var ret = false;
      var isMediahub = (vm.selectedSource === 'mediahub');
      for (var i = 0, len = array.length; i < len; i++) {
        if (vm.mediazone) {
          if (array[i]['id_media'] == item.id_media &&
            array[i]['id_zone'] == vm.mediazone.id_zone &&
            array[i]['isMediahub'] == isMediahub
          ) {
            ret = true;
          }
        } else {
          if (array[i]['id_media'] == item.id_media && array[i]['isMediahub'] == isMediahub) {
            ret = true;
          }
        }
      }
      return ret;
    }

    function toggleSelectedbyZone(item) {
      var isMediahub = (vm.selectedSource === 'mediahub');
      for (var i = 0, len = vm.selectedContacts.length; i < len; i++) {
        if (vm.mediazone) {
          if (vm.selectedContacts[i]['id_media'] == item.id_media &&
            vm.selectedContacts[i]['id_zone'] == vm.mediazone.id_zone &&
            vm.selectedContacts[i]['isMediahub'] == isMediahub
          ) {
            vm.selectedContacts.splice(i, 1);
            return;
          }
        } else {
          if (vm.selectedContacts[i]['id_media'] == item.id_media &&
            vm.selectedContacts[i]['isMediahub'] == isMediahub
          ) {
            vm.selectedContacts.splice(i, 1);
            return;
          }
        }
      }
      item.isMediahub = isMediahub; // Set flag on the item being added
      vm.selectedContacts.push(item);
      $scope.show = false
    }

    function selectMediaTiny(item) {
      var currentSort = 0;
      var mediaSort = 0;
      for (var i = 0; i < vm.currentThread.length; i++) {
        if (vm.mediazone) {
          if (vm.currentThread[i]['id_zone'] == 1 &&
            vm.currentThread[i]['media_type'] == item.media_type
          ) {
            currentSort++;
            if (item.id_media == vm.currentThread[i]['id_media']) {
              mediaSort = item.id_media;
            }
          }
        } else {
          if (vm.currentThread[i]['media_type'] == item.media_type) {
            currentSort++;
            if (item.id_media == vm.currentThread[i]['id_media']) {
              mediaSort = item.id_media;
            }
          }
        }
      }
      vm.selectedMediaTiny = item;
      vm.tinyProperties.mediaSort = mediaSort;
      vm.tinyProperties.mediaType = item.media_type;
      vm.changeViewTiny('properties');
    }

    function attachMedia() {
      vm.loading = true;

      var localItems = [];
      var externalItems = [];

      angular.forEach(vm.selectedContacts, function(item) {
        if (item.isMediahub || item.isIconik) {
          externalItems.push(item);
        } else {
          localItems.push(item);
        }
      });

      if (externalItems.length > 0) {
        var domain = siteID || $rootScope.siteID; // Use siteID from scope or rootScope
        var importPromises = externalItems.map(function (item) {
          var importPromise = item.isIconik
            ? mediaDialogService.importFromIconik(domain, item.id_media)
            : mediaDialogService.importFromMediaHub(domain, item.id_media);
          return importPromise.then(function (result) {
            // The import endpoint answers HTTP 200 even when a single item fails, marking it
            // with { error: true, message }. Treat that as a failure so it isn't silently
            // attached and the modal doesn't just close.
            if (result && result.error) {
              return { __importError: true, id_media: result.id_media || item.id_media, message: result.message };
            }
            // Reload the imported media from our system to get the full object (filename, cropstatus, etc)
            return mediaService.get({
              siteID: siteID,
              withCropStatus: true,
              idMedia: result.id_media
            }).then(function (response) {
              if (response.total == 1) {
                var fullItem = response.data[0];
                // Restore zone metadata lost during import or assign current dialog zone
                fullItem.id_zone = item.id_zone || (vm.mediazone ? vm.mediazone.id_zone : null);
                fullItem.zone_name = item.zone_name || (vm.mediazone ? vm.mediazone.zone_name : null);
                return fullItem;
              }
              return result;
            });
          }).catch(function (err) {
            // A transport/HTTP failure for this one item: keep it as a failure marker instead of
            // rejecting the whole batch, so the others still import and we can report this one.
            var msg = (err && err.data && err.data.message) || (err && err.message) || 'Request failed';
            return { __importError: true, id_media: item.id_media, message: msg };
          });
        });

        $q.all(importPromises).then(function (importedResults) {
          // Surface any per-item failures instead of closing the modal without a word.
          var failures = importedResults.filter(function (r) { return r && r.__importError; });
          if (failures.length > 0) {
            vm.loading = false;
            showImportErrors(failures);
            return; // keep the dialog open so the user can see what failed and retry
          }

          // Combine original locals with newly imported records
          var finalItems = localItems.concat(importedResults);

          // Deduplicate: If an item exists with a zone, remove its "no-zone" version
          var uniqueItems = [];
          var itemsWithZone = finalItems.filter(function (item) { return !!item.id_zone; });

          angular.forEach(finalItems, function (item) {
            if (!item.id_zone) {
              // Only keep "no-zone" if it's not already present in any zone
              var alreadyInZone = itemsWithZone.some(function (zItem) {
                return zItem.id_media == item.id_media;
              });
              if (!alreadyInZone) uniqueItems.push(item);
            } else {
              // Keep all items that have a zone (allows same media in multiple specific zones if needed)
              // but avoid exact duplicates (same media, same zone)
              var isDuplicate = uniqueItems.some(function (uItem) {
                return uItem.id_media == item.id_media && uItem.id_zone == item.id_zone;
              });
              if (!isDuplicate) uniqueItems.push(item);
            }
          });

          finishAttachment(uniqueItems);
        }).catch(function (error) {
          console.error("Error importing items:", error);
          vm.loading = false;
          var msg = (error && error.data && error.data.message) || (error && error.message) || '';
          showImportErrors(msg ? [{ message: msg }] : []);
        });
      } else {
        finishAttachment(localItems);
      }
    }

    // Shows why an import from Iconik/Mediahub failed, using the app's standard error toast
    // (msUtils.showError) so it looks like every other error in qiusystem. Keeps the dialog open.
    // The backend messages are technical (e.g. "Could not resolve iconik media <id>") but are the
    // useful detail, so they are appended to the translated heading.
    function showImportErrors(failures) {
      var lines = (failures || []).map(function (f) {
        return f.id_media ? (f.id_media + ': ' + f.message) : f.message;
      });
      var message = $translate.instant('MEDIA.IMPORT_ERROR_INTRO') + (lines.length ? ' ' + lines.join(' | ') : '');
      msUtils.showError(message);
    }

    function finishAttachment(items) {
      vm.selectedContacts = items; // Update the selected contacts with the final list

      // First, handle the upload-related logic if any local files were part of an upload process
      var continueAttach = false;
      if (vm.uploadFiles.length == 0 || vm.uploadedFiles.length == vm.uploadFiles.length) {
        continueAttach = true;
      } else {
        var messageConfirm = $translate.instant('MEDIA.UPLOADING_MEDIA_CLOSE_CONFIRM');
        var confirm = $mdDialog.confirm().multiple(true).title(messageConfirm)
          .ariaLabel('Close dialog').ok('OK').cancel('CANCEL');

        $mdDialog.show(confirm)
          .then(function () {
            var deleteIds = [];
            for (var i = 0; i < vm.uploadFiles.length; i++) {
              var isFileUploaded = vm.uploadedFiles.some(function (el) {
                return el.id_media == vm.uploadFiles[i].id_media
              });
              if (!isFileUploaded) {
                deleteIds.push(vm.uploadFiles[i].id_media);
              }
            }
            if (deleteIds.length > 0) {
              var options = {
                site: siteID,
                id_media: deleteIds,
                force: true
              };
              mediaService.massDelete(options);
            }
            continueAttach = true;
          }, function () {
          })
      }
      if (!continueAttach) {
        return false;
      }

      var mediaIDs = [];
      for (var i = 0; i < items.length; i++) {
        if (items[i].id_media) {
          mediaIDs.push(items[i].id_media);
        }
      }

      console.log('vm.fields', vm.fields);
      var fields = {};
      angular.forEach(vm.fields, function (value, key) {
        if (!_.isNull(value) && value != 0) {
          this[key] = value;
        }
      }, fields);

      var uploadedFilesIDs = [];
      if (vm.uploadedFiles.length > 0) {
        vm.uploadedFiles.forEach(element => {
          uploadedFilesIDs.push(element.id_media);
        });
        var batchOptions = {
          siteID: siteID,
          id_medias: uploadedFilesIDs
        }
        mediaService.finishedUploadingBatchToCdn(batchOptions).then(function (response) {
          console.log('response', response);
        });
      }

      var galleriesAssigned = getAssignedGalleries(vm.CleanMediaGalleries, []);

      // Initial promise
      var sequence = $q.defer();
      sequence.resolve();
      sequence = sequence.promise;

      if (galleriesAssigned.length > 0) {

        var inserts = [];
        var mismatches = {};

        angular.forEach(galleriesAssigned, function (gallery) {

          var galleryTypeId = gallery.gallery_type;
          var validMediaIds = [];

          angular.forEach(vm.uploadedFiles, function (file) {

            var fileTypeId = msUtils.getFileTypeId(file.type);
            if (galleryTypeId == 0) {
              validMediaIds.push(file.id_media);
            }
            else if (galleryTypeId != 0 && fileTypeId && galleryTypeId == fileTypeId) {
              validMediaIds.push(file.id_media);
            }
            else {
              if (!angular.isArray(mismatches[file.name])) {
                mismatches[file.name] = [];
              }
              if (gallery.gallery_type != 0) {
                mismatches[file.name].push(gallery.gallery_name + ' (' + msUtils.getGalleryTypeById(gallery.gallery_type) + ')');
              }
            }
          });
          if (validMediaIds.length > 0) {
            inserts.push({ id_gallery: [gallery.id_gallery], media_ids: validMediaIds });
          }
        });

        if (!_.isEmpty(mismatches)) {
          sequence = sequence.then(function () {
            var confirm = $mdDialog.confirm()
              .title($translate.instant('MEDIA.MISMATCH_DIALOG.TITLE'))
              .textContent($translate.instant('MEDIA.MISMATCH_DIALOG.CONTENT'))
              .ariaLabel($translate.instant('MEDIA.MISMATCH_DIALOG.LABEL'))
              .ok($translate.instant('MEDIA.MISMATCH_DIALOG.OK'))
              .cancel($translate.instant('MEDIA.MISMATCH_DIALOG.CANCEL'))
              .multiple(true);
            return $mdDialog.show(confirm);
          })
        }

        angular.forEach(inserts, function (insert) {
          sequence = sequence.then(function () {
            var options = {
              site: siteID,
              data: {
                id_media: insert.media_ids,
                id_gallery: insert.id_gallery
              }
            };
            return mediaService.insertIntoGallery(options);
          });
        });
      }
      if (!_.isEmpty(fields) || !_.isEmpty(vm.currentTags)) {
        sequence = sequence.then(function () {
          var options = {
            site: siteID,
            data: {
              id_media: mediaIDs,
              fields: fields,
              tags: vm.currentTags
              // fields: {
              //  geoLat: vm.fields.geoLat,
              //  geoLon: vm.fields.geoLon
              // }
            }
          };
          return mediaService.massUpdate(options);
        });
      }
      sequence = sequence.then(function () {
        vm.selectedGalleries = updateSelectedGalleries(vm.items, vm.selectedGalleries);
        vm.selectedContacts = removeDetachedGalleriesFromContacts(vm.selectedGalleries, vm.selectedContacts);
        vm.selectedContacts = addAttachedGalleriesToContacts(vm.selectedGalleries, vm.selectedContacts);
        vm.selectedContacts = cleanGalleryWhenMedia(vm.selectedContacts);
        angular.copy(vm.selectedContacts, vm.currentThread.Thumbnail);
        return vm.closeDialog();
      }).catch(function (error) {
        console.error("Error finishing attachment:", error);
        vm.loading = false;
      });
    }

    function attachMediaTiny() {
      $mdDialog.hide(vm.tinyProperties);
    }

    function getAssignedGalleries(galleries, result) {

      angular.forEach(galleries, function (gallery) {
        if (gallery.assigned_gallery == true && !gallery.no_files_allowed) {
          result.push(gallery);
        }
        if (typeof gallery.children !== 'undefined' && gallery.children.length > 0) {
          getAssignedGalleries(gallery.children, result);
        }
      });
      return result;
    }

    function getAssignedGalleriesIds(galleries, result) {
      angular.forEach(galleries, function (gallery) {
        if (gallery.assigned_gallery == true && !gallery.no_files_allowed) {
          result.push(gallery.id_gallery);
        }
        if (typeof gallery.children !== 'undefined' && gallery.children.length > 0) {
          getAssignedGalleriesIds(gallery.children, result);
        }
      });
      return result;
    }

    function selectedItemChange() {
      vm.searchTagText = '';
      vm.selectedTag = null;
    }

    /**
     * Add label chips
     *
     * @param query
     * @returns {filterFn}
     */
    function labelQuerySearch(query) {
      var ret = [];
      if (query) {
        var filteredContent = angular.copy(vm.tags.filter(vm.createFilterFor(query)));
        if (filteredContent.length > 0) {
          ret.push({
            id_tag: 0,
            tag_name: "",
            order: 1
          });
        }
        angular.forEach(filteredContent, function (val) {
          ret.push(val);
        })
      }
      return ret;
    }

    function newTag(tagName) {

      if (vm.newTagDisabled) {
        return false;
      }
      vm.newTagDisabled = true;

      var newTag = {
        tag_name: tagName
      };
      var options = {
        site: siteID,
        item: newTag
      };
      tagsService.saveItem(options).then(function (response) {
        newTag.id_tag = response.id_tag
        vm.tags.push(newTag);
        vm.currentTags.push(newTag);
        vm.searchTagText = '';
        vm.newTagDisabled = false;
      });
    }

    /**
     * Filter for chips
     *
     * @param query
     * @returns {filterFn}
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(item) {
        if (angular.isUndefined(item.tag_name)) {
          return false;
        }
        if (!item.tag_name) {
          return false;
        }
        if (!angular.lowercase(item.tag_name.toString()).indexOf) {
          return false;
        }
        return angular.lowercase(item.tag_name.toString()).indexOf(lowercaseQuery) >= 0;
      };
    }

    function getpos(event) {
      vm.fields.geoLat = event.latLng.lat();
      vm.fields.geoLon = event.latLng.lng();
      vm.latlng = [event.latLng.lat(), event.latLng.lng()];
    }

    function placeMarker() {
      var loc = this.getPlace()
        .geometry.location;
      vm.latlng = [loc.lat(), loc.lng()];
      vm.fields.geoLat = loc.lat();
      vm.fields.geoLon = loc.lng();
      vm.center = [loc.lat(), loc.lng()];
    }

    function searchLatLon() {
      vm.latlng = [vm.fields.geoLat, vm.fields.geoLon];
      vm.center = [vm.fields.geoLat, vm.fields.geoLon];
      vm.center = [40.74, -74.18];
    }

    function removeDetachedGalleriesFromContacts(galleries, contacts) {
      for (var i = contacts.length - 1; i >= 0; i--) {
        if (vm.mediazone && contacts[i].id_zone != vm.mediazone.id_zone) {
          continue;
        }
        if (angular.isUndefined(contacts[i].id_gallery) ||
          contacts[i].id_gallery == 0) {
          continue;
        }
        if (contacts[i].media_type) { // not a gallery!
          continue;
        }
        var remove = true;
        angular.forEach(galleries, function (gallery) {
          if (contacts[i].id_gallery == gallery.id_gallery) {
            if (vm.mediazone) {
              if (contacts[i].id_zone == gallery.id_zone) {
                remove = false;
              }
            } else {
              remove = false;
            }
          }
        });
        if (remove) {
          contacts.splice(i, 1);
        }
      }
      return contacts;
    }

    function cleanGalleryWhenMedia(contacts) {
      for (var i = 0; i < contacts.length; i++) {
        if (angular.isDefined(contacts[i].id_media) && angular.isDefined(contacts[i].id_gallery)) {
          delete contacts[i].id_gallery;
        }
      }
      return contacts;
    }

    function addAttachedGalleriesToContacts(galleries, contacts) {
      angular.forEach(galleries, function (gallery) {
        //console.log("ADDDD ", gallery)
        //console.log("contacts",contacts)
        //console.log("Mediazone", vm.mediazone)
        if (!gallery.hasOwnProperty('id_gallery')) {
          // Not a gallery.
          return;
        }
        if (vm.mediazone && angular.isDefined(gallery.id_zone) && gallery.id_zone != vm.mediazone.id_zone) {
          // Different zone.
          return;
        }
        var add = true;
        for (var i = 0; i < contacts.length; i++) {
          if (angular.isDefined(contacts[i].id_gallery) &&
            contacts[i].id_gallery == gallery.id_gallery) {
            if (vm.mediazone) {
              if (contacts[i].id_zone == gallery.id_zone) {
                add = false;
              }
            } else {
              add = false;
            }
          }
        }
        if (add) {
          contacts.push(gallery);
        }
      });
      return contacts;
    }

    function updateSelectedGalleries(galleries, result) {
      angular.forEach(galleries, function (gallery) {
        if (angular.isDefined(gallery.assigned_gallery)) {
          if (gallery.assigned_gallery == true) {
            // assign checked gallery...
            var isAssigned = result.find(function (obj) {
              if (vm.mediazone) {
                return (obj.id_gallery == gallery.id_gallery && obj.id_zone == vm.mediazone.id_zone);
              } else {
                return obj.id_gallery == gallery.id_gallery;
              }
            });
            // ... but only if not already assigned
            if (!isAssigned) {
              if (vm.mediazone) {
                gallery['id_zone'] = vm.mediazone.id_zone;
              }
              result.push(gallery);
            }
          } else {
            // unassign unchecked gallery
            if (result.length > 0) {
              for (var ii = result.length - 1; ii >= 0; ii--) {
                if (vm.mediazone) {
                  if (result[ii].id_gallery == gallery.id_gallery &&
                    result[ii].id_zone == vm.mediazone.id_zone) {
                    result.splice(ii, 1);
                  }
                } else {
                  if (result[ii].id_gallery == gallery.id_gallery) {
                    result.splice(ii, 1);
                  }
                }
              }
            }
          }
        }
        if (typeof gallery.children !== 'undefined' && gallery.children.length > 0) {
          updateSelectedGalleries(gallery.children, result);
        }
      });
      return result;
    }

    /**
     * Toggle selected status of the contact
     *
     * @param contact
     * @param event
     */
    function toggleSelectContact(photo, event) {

      if (event) {
        event.stopPropagation();
      }
      if (vm.mediazone) {
        photo.id_zone = vm.mediazone.id_zone;
        photo.zone_name = vm.mediazone.zone_name;
      } else {
        photo.id_zone = null;
        photo.zone_name = null;
      }
      toggleSelectedbyZone(photo);
    }

    function toggleSelectOne(photo, event) {
      if (event) {
        event.stopPropagation();
      }
      if (vm.mediazone) {
        photo.id_zone = vm.mediazone.id_zone;
        photo.zone_name = vm.mediazone.zone_name;
      }
      else {
        photo.id_zone = null;
        photo.zone_name = null;
      }

      photo.isMediahub = (vm.selectedSource === 'mediahub'); // Mark source
      vm.selectedContacts = []
      vm.selectedContacts.push(photo);
      vm.attachMedia();
    }

    /**
     * Scroll Media Dialog Content to the top
     * @param speed
     */
    function scrollToTopOfDialog() {
      //$timeout(function () {
      var dialogContent = $document.find('md-dialog-content').filter(function () {
        return angular.element(this).hasClass('mediadialog-content');
      });
      if (!angular.isUndefined(dialogContent[0])) {
        dialogContent.animate({
          scrollTop: 0
        }, 1);
      }
      //}, 1000);
    }

    function toggleMediaDialogSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }
  }

  function LoadMediaDialogMediaByGalleries(mediaDialogService) {

    function unselectAllGalleries() {
      var elemList = document.querySelectorAll('.gallery-row');
      elemList.forEach(function (elem) {
        elem.classList.remove('selected');
      });
    }

    return {
      restrict: 'A',
      link: function (scope, element, attrs) {

        $(element).on('click', function (e) {
          var galleryNode = false;
          if (element.parent().hasClass('selected')) {
            unselectAllGalleries();
          } else {
            unselectAllGalleries();
            element.parent().addClass('selected');
            galleryNode = scope.node;
          }

          var includeSubgalleries = $('#includeSubgalleries').attr("data-include-subgalleries") == 'true';
          mediaDialogService.triggerMediaDialogMediaByGalleries(galleryNode, includeSubgalleries);
        });
      }
    };
  }
})();



(function () {
    'use strict';

    angular.module('app.users')
        .directive('qiuUsersOnClickLoadUsersByGroups', ['usersService', LoadUsersByGroups])
        .directive('qiuUsersOnClickLoadUsersByGroupsAcc', ['usersService', LoadUsersByGroupsAcc])
        .directive('qiuUsersOnClickLoadUsersByGroupsAccSub', ['usersService', LoadUsersByGroupsAccSub])
        .directive('qiuUsersOnClickOpenGroupEditDialog', ['usersService', OpenGroupEditDialog])
        .directive('qiuUsersOnClickCloseSidenav', ['usersService', CloseSidenav])
        .directive('qiuUsersOnCheckToggleAssignedGroup', ToggleAssignedGroup)
        .directive('qiuUsersOnChangeSetInGroupStatus', SetInGroupStatus)
        .controller('UsersController', UsersController)
        .component('parentGroup', {
            bindings: {
                parent: '<'
            },
            controllerAs: 'vm',
            templateUrl: 'app/main/apps/users/views/read/parent-group.html'
        });


    /** @ngInject */
    function UsersController($scope, $rootScope, $document, $mdDialog, $mdMedia, $mdToast, $mdSidenav,
        $state, msApi, requestContext, $timeout, usersService, contentService, msUtils, settingUserService,
        $anchorScroll, $translate, mailingService, sessionService, tinyMceService, sharedFunctionsMailing,
        transformUsers, ivhTreeviewMgr, $filter, $window, $q, $stateParams, formsService, $http) {
        var vm = this;
        vm.getSettingValue = settingUserService.getSettingValue;
        vm.settingsSection = 'users-' + $stateParams.groupTypeName;
        vm.isOpenSidenavGroups = vm.getSettingValue(vm.settingsSection, 'sidenavGroupsOpen', true);
        vm.fieldOrder = vm.getSettingValue(vm.settingsSection, 'sortField', null);
        vm.groupBy = vm.getSettingValue(vm.settingsSection, 'groupByField', undefined);
        if (vm.groupBy == null) {
            vm.groupBy = undefined;
        }
        $scope.validSelection = true;
        vm.page = 1;
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg', 'red-bg', 'yellow-bg', 'light-blue-bg'];
        vm.selectedColor = vm.colors[Math.floor(Math.random() * vm.colors.length)];
        $rootScope.pagination_groupIds = false;
        $rootScope.pagination_ingroupStatus = false;
        vm.includeAllGroups = false;
        // vm.folders = Folders.data;
        // vm.labels = Labels.data;
        vm.folders = [];
        vm.labels = [];
        vm.nextPageLog = 1;
        vm.loadingThreads = true;
        vm.enterfirst = true;
        vm.users = null;
        vm.searchUserText = null;
        vm.selectedUser = null;
        vm.createFilterFor = createFilterFor;
        vm.CleanUsersGroups = undefined;
        vm.eventsGroup = undefined;
        vm.currentLabelsEdit = undefined;
        vm.userGroupTypes = undefined;
        vm.currentTab = 'preview';
        vm.countriesWithStates = undefined;
        vm.statesWithCities = undefined;
        vm.timeAgo = msUtils.timeAgo;
        vm.loginUrl = sessionService.site_operative.websiteLoginUrl;
        vm.userInvitationUrlPreview = sessionService.site_operative.userInvitationUrlPreview;
        vm.userInvitationUrlIndividual = sessionService.site_operative.userInvitationUrlIndividual;
        vm.userInvitationUrlMultiple = sessionService.site_operative.userInvitationUrlMultiple;
        vm.userCustomActions = sessionService.site_operative.userCustomActions;

        vm.scrollEl = angular.element('#thread-list')[0];

        vm.currentFilter = {
            type: $state.params.type,
            filter: $state.params.filter
        };
        vm.currentThread = null;
        vm.currentThread_Edit = null;
        vm.thumbnails_Edit = {};
        vm.selectedThreads = [];
        vm.selectedGroups = [];
        vm.selectedGroup = false;
        vm.basicForm = {};
        vm.treeSearch = '';
        vm.hideAcc = hideAcc

        vm.labelQuerySearch = labelQuerySearch;
        vm.filterActiveTypes = filterActiveTypes;
        vm.getGroupIcon = getGroupIcon;

        // vm.views = {
        // 	classic: 'app/main/apps/content/views/classic/classic-view.html',
        // 	outlook: 'app/main/apps/content/views/outlook/outlook-view.html'
        // };
        // vm.defaultView = 'outlook';
        // vm.currentView = 'outlook';

        vm.mediaZones = [];
        vm.usersGroups = undefined;
        vm.currentLabelsFilter = undefined;
        vm.ingroupStatus = [];
        vm.currentGroupTypeId = parseInt($stateParams.groupTypeId);
        vm.isAccreditations = vm.currentGroupTypeId === 6;
        if (vm.isAccreditations) {
            vm.pleaseSelectGroup = true;
        }
        $scope.isLoadingGroups = true;
        $scope.loadGroup = false;
        vm.includeSubgroups = false;
        vm.conversationMessage = {};
        vm.isQiuRestricted = false;
        vm.hasAdvancedSettingsAccess = false;

        vm.sortFieldUsersGroup = 'name';
        vm.sortDirUsersGroup = 'ASC';
        vm.orderByUsersGroup = {
          "USERS.NAME": "name",
          "USERS.UPDATED_AT": "updated_at",
          "USERS.ID": "id_group",
          "USERS.SORT": "sort"
        };

        vm.sendConversationMessage = sendConversationMessage;
        vm.deleteConversationMessage = deleteConversationMessage;

        // Methods
        vm.init = init;
        vm.$mdMedia = $mdMedia;
        vm.getInArray = msUtils.getInArray;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.toggleInGroup = msUtils.toggleInGroup;
        vm.getReferencesSections = contentService.getReferencesSections;
        vm.getExtension = msUtils.getExtension;
        vm.getExtensionIcon = msUtils.getExtensionIcon;
        vm.getValuesReferencesSections = contentService.getValuesReferencesSections;
        vm.updateModelShowGroupsAsField = updateModelShowGroupsAsField;

        vm.isShowingLabelGroup = isShowingLabelGroup;
        vm.isShowingLabelGroupTab = isShowingLabelGroupTab;
        vm.isTrueFalseChecked = isTrueFalseChecked;
        vm.toggleTrueFalseCheck = toggleTrueFalseCheck;
        vm.selectOrUnselect = selectOrUnselect;
        vm.showStatus = showStatus;

        vm.loadFolder = loadFolder;
        vm.loadLabel = loadLabel;
        vm.loadUsersByGroups = loadUsersByGroups;
        vm.isFolderActive = isFolderActive;
        vm.isLabelActive = isLabelActive;

        vm.getGroupNames = getGroupNames;

        vm.newThread = newThread;
        vm.openThread = openThread;
        vm.closeThread = closeThread;
        vm.closeThreadEdit = closeThreadEdit;
        vm.deleteThread = deleteThread;

        vm.closeUsers = closeUsers;

        vm.addToGroup = addToGroup;
        vm.removeFromGroup = removeFromGroup;
        vm.toggleSelectThread = toggleSelectThread;
        vm.toggleSelectThreads = toggleSelectThreads;
        vm.toggleSelectGroups = toggleSelectGroups;
        vm.toggleSelectGroup = toggleSelectGroup;
        vm.isSelected = isSelected;
        vm.deselectThreads = deselectThreads;
        vm.getCleanUsersGroup = getCleanUsersGroup;

        vm.isActiveGroupUser = isActiveGroupUser;

        vm.setThreadStatus = setThreadStatus;
        vm.toggleThreadStatus = toggleThreadStatus;
        vm.toggleItemStatus = toggleItemStatus;
        vm.toggleItemStatusEdit = toggleItemStatusEdit;

        vm.getLabel = getLabel;
        vm.getLabelColor = getLabelColor;
        vm.getLabelTitle = getLabelTitle;
        vm.toggleLabel = toggleLabel;
        vm.isLabelExist = isLabelExist;

        vm.getLogs = getLogs;

        vm.changeView = changeView;
        vm.viewEditInline = viewEditInline;
        vm.viewPreview = viewPreview;
        vm.saveItem = saveItem;
        vm.massActions = massActions;

        vm.composeDialog = composeDialog;
        vm.replyDialog = replyDialog;
        vm.openImageDialog = openImageDialog;
        vm.openFocalPoint = openFocalPoint;
        vm.siteLanguages = siteLanguages;
        vm.setTinyMceContent = setTinyMceContent;
        vm.getCurrentMedia = getCurrentMedia;
        vm.newUser = newUser;
        vm.getZoneCrop = getZoneCrop;

        vm.dateFormat = sessionService.site_operative.dateFormat;
        vm.dateTimeFormat = sessionService.site_operative.dateTimeFormat;
        vm.showDate = showDate;

        vm.getCountriesWithStates = getCountriesWithStates;
        vm.getCountryById = getCountryById;
        vm.getStatesByCountry = getStatesByCountry;
        vm.getCitiesByState = getCitiesByState;

        vm.duplicateUser = duplicateUser;
        vm.setSortField = setSortField;
        vm.resetSortField = resetSortField;
        vm.setSortOrder = setSortOrder;
        //vm.callback = callback;
        vm.cancelUsersGroups = cancelUsersGroups;
        vm.saveUsersGroups = saveUsersGroups;
        vm.deleteTargetFilter = deleteTargetFilter;
        vm.mediaDialog = mediaDialog;
        vm.resetFilters = resetFilters;
        vm.resetGroupby = resetGroupby;
        vm.setGroupBy = setGroupBy;
        vm.openUsersGroupsDialog = openUsersGroupsDialog;
        vm.openImportDialog = openImportDialog;
        vm.openExportDialog = openExportDialog;
        vm.openCopyMoveDialog = openCopyMoveDialog;
        vm.deleteTargetEdit = deleteTargetEdit;

        vm.loadAllUsers = loadAllUsers;
        vm.getUsersByGroups = getUsersByGroups;
        vm.unselectGroups = unselectGroups;
        vm.createGroup = createGroup;
        vm.segmentGroupDialogNew = segmentGroupDialogNew;

        vm.toggleIncludeSubgroups = toggleIncludeSubgroups;
        vm.selectedIngroupStatus = "0";
        vm.changeSelectedIngroupStatus = changeSelectedIngroupStatus;
        vm.addUsersToGroupsDialog = addUsersToGroupsDialog;
        vm.removeUsersFromGroupDialog = removeUsersFromGroupDialog;
        vm.changeInGroupStatusDialog = changeInGroupStatusDialog;


        vm.isLarge = isLarge;
        vm.isMedium = isMedium;
        vm.isSmall = isSmall;
        vm.isMini = isMini;
        vm.orderByTableListSort = orderByTableListSort;

        vm.loginToWebsite = loginToWebsite;
        vm.inviteToGroupPreview = inviteToGroupPreview;
        vm.inviteToGroupIndividual = inviteToGroupIndividual;
        vm.inviteToGroupMultiple = inviteToGroupMultiple;
        vm.customActionEvent = customActionEvent;
        vm.filterIsMainOrSecondaryTableListPosition = filterIsMainOrSecondaryTableListPosition;
        
        vm.buttonClick = buttonClick;

        vm.JSONparse = JSON.parse;
        
        vm.changeGroupPriority = changeGroupPriority;
        
        vm.formatChilds = formatChilds;

        function hideAcc() {
            vm.currentThread = false;
            vm.currentThread_Edit = false;
        }

        function showStatus(status) {
            if (vm.selectedGroupsAcc) {
                var parent = vm.acreditationsGroups.find(x => x.id_group === vm.selectedGroupsAcc[0].parent);
            }
            return vm.selectedGroupsAcc && vm.selectedGroupsAcc[0] && status.id_group_type == vm.selectedGroupsAcc[0].id_group_type || (parent && status.id_group_type == parent.id_group_type);
        }


        function orderByTableListSort(ref) {
            return parseInt(ref.table_list_sort);
        }

        function getIngroupStatusRef() {
            return vm.refcolumns.find(function (ref){
                return ref.type === 'ingroup_status';
            })
        }

        function isShowingLabelGroup(thread, status) {
            var result = false;
            if (vm.isAccreditations) {
                if (vm.selectedGroupsAcc) {
                    if (vm.selectedGroupsAcc[0].parent) {
                        var group = thread.groups.find(x => x.id_group == vm.selectedGroupsAcc[0].parent);
                    } else {
                        var group = thread.groups.find(x => x.id_group == vm.selectedGroupsAcc[0].id_group);
                    }
                    if (group) {
                        result = status.id_ingroup_status == group.users_ingroup.id_ingroup_status;
                    }
                }
            } else {
                var ingroupStatusRef = getIngroupStatusRef();
                if (vm.selectedGroup.parent &&
                    ingroupStatusRef &&
                    ingroupStatusRef.raw_settings &&
                    ingroupStatusRef.raw_settings.show_parent_ingroup_status
                ) {
                    var group = thread.groups.find(x => x.id_group == vm.selectedGroup.parent);
                } else {
                    var group = thread.groups.find(x => x.id_group == vm.selectedGroup.id_group);
                }
                if (group) {
                    result = status.id_ingroup_status == group.users_ingroup.id_ingroup_status && status.id_group_type == group.id_group_type;
                }
            }
            return result;
        }
        function isShowingLabelGroupTab(thread, status, selectedGroup) {
            if (thread && thread.groups && selectedGroup) {
                var group = thread.groups.find(x => x.id_group == selectedGroup.id_group);
                var result = group && group.id_group == selectedGroup.id_group && group.users_ingroup && status.id_ingroup_status == group.users_ingroup.id_ingroup_status
                return result;
            }
            return false;
        }
        function isCurrentGroupStatus(thread, status) {
            var result = false;
            if (vm.isAccreditations) {
                return true;
            } else {
                var ingroupStatusRef = getIngroupStatusRef();
                if (vm.selectedGroup.parent &&
                    ingroupStatusRef &&
                    ingroupStatusRef.raw_settings &&
                    ingroupStatusRef.raw_settings.show_parent_ingroup_status
                ) {
                    // Status is of parent group.
                    return false;
                }
                /*
                if (vm.isAccreditations) {
                    if (vm.selectedGroupsAcc) {
                        var group = thread.groups.find(x => x.id_group == vm.selectedGroupsAcc[0].id_group);
                        if (group) {
                            result = selectedStatus.id_ingroup_status == group.users_ingroup.id_ingroup_status;
                        }
                    }
                } else {
                */
                    var group = thread.groups.find(x => x.id_group == vm.selectedGroup.id_group);
                    if (group) {
                        result = status.id_ingroup_status == group.users_ingroup.id_ingroup_status && status.id_group_type == group.id_group_type;
                    }
                //}
            }
            return result;
        }


        vm.translate = function (text) {
            return $translate.instant(text);
        }

        function showDate(value) {
            if (angular.isObject(value)) {
                return value.dateShow;
            } else if (value == '0000-00-00 00:00:00' || !value) {
                return '-';
            } else {
                var tz = (sessionService.site_operative.timezone || moment.tz.guess() || 'UTC').toString().trim();
                return moment.utc(value).tz(tz).format(vm.dateTimeFormat || 'DD/MM/YYYY HH:mm');
            }
        }


        vm.updateDatePicker = function (fld) {
            var value = moment.utc(vm.currentThread_Edit[fld].date).format('YYYY-MM-DD HH:mm:00');

            if (value == 'Invalid date') {
                vm.currentThread_Edit[fld] = {};
                vm.currentThread_Edit[fld]['value'] = '';
                vm.currentThread_Edit[fld]['date'] = '';
                vm.currentThread_Edit[fld]['dateShow'] = '';
                vm.currentThread_Edit[fld]['utcShow'] = '';
                vm.currentThread_Edit[fld]['utcDate'] = '';
            } else {
                var tz = (sessionService.site_operative.timezone || moment.tz.guess() || 'UTC').toString().trim();
                var utcDate = moment.utc(value);
                var siteDate = moment.utc(value).tz(tz);

                vm.currentThread_Edit[fld] = {};
                vm.currentThread_Edit[fld]['value'] = value;
                vm.currentThread_Edit[fld]['date'] = new Date(siteDate.format());
                vm.currentThread_Edit[fld]['dateShow'] = siteDate.format(vm.dateTimeFormat || 'DD/MM/YYYY HH:mm');
                vm.currentThread_Edit[fld]['utcShow'] = utcDate.format(vm.dateTimeFormat || 'DD/MM/YYYY HH:mm');
                vm.currentThread_Edit[fld]['utcDate'] = utcDate;
            }
        };


        vm.mediaSortable = {
            group: 'media',
            animation: 150,
            scroll: true,
            filter: '.no-sort',
            ghostClass: "sort-drop",
            onEnd: function (evt) {
                if (typeof evt.oldIndex == 'undefined' || typeof evt.newIndex == 'undefined')
                    return;
                vm.currentThread_Edit.Thumbnail = [];
                angular.forEach(vm.thumbnails_Edit, function (thumbZone, idZone) {
                    var i = 1;
                    angular.forEach(thumbZone, function (data) {
                        if (data.id_zone != idZone) {
                            var dataOld = _.clone(data);
                            if (angular.isUndefined(vm.currentThread_Edit.ThumbnailRemove))
                                vm.currentThread_Edit.ThumbnailRemove = [];
                            vm.currentThread_Edit.ThumbnailRemove.push(dataOld);
                            data.id_zone = idZone * 1;
                        }
                        data.sort = i;
                        vm.currentThread_Edit.Thumbnail.push(data)
                        i = i + 1;
                    })
                })
                vm.basicForm.$setDirty()
            }
        };

        function setTinyMceContent(event) {
            var zoneMedia = {
                1: {},
                2: {},
                3: {},
                4: {}
            };
            var typesMax = {
                1: 0,
                2: 0,
                3: 0,
                4: 0
            };
            var currentSort = 0;
            var currentType = 0;
            for (var i = 0; i < vm.currentThread_Edit.Thumbnail.length; i++) {
                if (vm.currentThread_Edit.Thumbnail[i]['id_zone'] == 1) {
                    currentSort = vm.currentThread_Edit.Thumbnail[i]['sort'];
                    currentType = vm.currentThread_Edit.Thumbnail[i]['media_type'];
                    typesMax[currentType]++;
                    zoneMedia[currentType][typesMax[currentType]] = vm.currentThread_Edit.Thumbnail[i];
                }
            }
            return zoneMedia;
        }

        vm.tinymceOptions = tinyMceService.getOptions($scope);
        /*
                {
                    theme                  : 'modern',
                    height                 : 500,
                    remove_script_host     : false,
                    allow_script_urls      : true,
                    convert_urls           : false,
                    // external_filemanager_path:"/scripts/filemanager/",
                    // 	filemanager_title:"Responsive Filemanager" ,
                    // 	external_plugins: { "filemanager" : "/scripts/filemanager/plugin.min.js"},
                    // external_plugins: {
                    //   "myplugin": "/scripts/plugin.js"
                    // },
                    extended_valid_elements: 'script[language|type|src|async|charset]',
                    plugins                : [
                        'qiumedia media advlist autolink lists link image charmap preview hr anchor pagebreak', 'searchreplace wordcount visualblocks visualchars code fullscreen imagetools', 'nonbreaking table contextmenu directionality', 'template paste textcolor colorpicker textpattern'
                    ],
                    toolbar1               : ' insertfile undo redo | bold italic | alignleft aligncenter alignright alignjustify | forecolor backcolor | bullist numlist outdent indent | link unlink image media | code fullscreen buttonadv qiumedia',
                    toolbar2               : '',
                    content_style          : "#tinymce { font-size: 16px;line-height:1.6;font-family:'Helvetica Neue', sans-serif; }" +
                    ".align-left { text-align:left }" +
                    ".align-center { text-align:center }" +
                    ".align-right { text-align:right }" +
                    ".size-25 { width:25% }" +
                    ".size-50 { width:50% }" +
                    ".size-75 { width:75% }" +
                    ".size-100 { width:100% }",
                    image_advtab           : true,
                    menubar                : false,
                    setup                  : function (editor) {
                        editor.on('change', function (e) {
                            if (vm.basicForm)
                                vm.basicForm.$setDirty();
                        });
                        editor.on('BeforeSetcontent', function(event){
                            var zoneMedia      = {
                                1: {},
                                2: {},
                                3: {},
                                4:  {}
                            };
                            var typesMax        = {
                                1: 0,
                                2: 0,
                                3: 0,
                                4: 0
                            };
                            var currentSort     = 0;
                            var currentType     = 0;
                            for (var i = 0; i < vm.currentThread_Edit.Thumbnail.length; i++) {
                                if (vm.currentThread_Edit.Thumbnail[i]['id_zone'] == 1) {
                                    currentSort = vm.currentThread_Edit.Thumbnail[i]['sort'];
                                    currentType = vm.currentThread_Edit.Thumbnail[i]['media_type'];
                                    typesMax[currentType]++;
                                    zoneMedia[currentType][typesMax[currentType]]  = vm.currentThread_Edit.Thumbnail[i];
                                }
                            }

                            var cont	= event.content;
                            var newCont	= cont;
                            var regex = /(\[image\|([^\]]*)\])/g;
                            var validData	= {
                                left: 'align-left',
                                center: 'align-center',
                                right: 'align-right',
                                25: 'size-25',
                                50: 'size-50',
                                75: 'size-75',
                                100: 'size-100',
                            }
                            let m;

                            while ((m = regex.exec(cont)) !== null) {
                                var expCont	= '';
                                var mediaData	= {
                                    type: '',
                                    sort: '',
                                    class: ''
                                };
                                var mediaExtra	= '';
                                // This is necessary to avoid infinite loops with zero-width matches
                                if (m.index === regex.lastIndex) {
                                    regex.lastIndex++;
                                }
                                if (m[2]) {
                                    expCont	= m[2].split('|');
                                    mediaData.type	= 'image';
                                    console.log(expCont);
                                    for (var i = 0; i < expCont.length; i++) {
                                        if (i == 0) {
                                            mediaData.sort	= expCont[i];
                                        } else {
                                            mediaExtra	= expCont[i];
                                            if (!angular.isUndefined(validData[mediaExtra])) {
                                                mediaData.class	+= validData[mediaExtra] + ' ';
                                            }
                                        }
                                    }
                                    var newHtml = '<div class="qiumedia" data-qiumedia="' + m[0].substr(1,-1) + '"><img src="' + zoneMedia[1][mediaData.sort].cropstatus[0].container.view_url + zoneMedia[1][mediaData.sort].cropstatus[0].fileName + '" class="qiumedia-image ' + mediaData.class + '"></div>';
                                    newCont		= newCont.replace(m[0], newHtml);
                                    event.content = newCont;
                                }
                            }
                        });
                    }
                };
        */
        function updateDatePicker(ev) {

        }

        // Attachments
        vm.deleteAttachment = deleteAttachment;
        vm.mediaDialog = mediaDialog;
        vm.mediaDialogTiny = mediaDialogTiny;
        vm.renderTinyMedia = renderTinyMedia;

        vm.toggleSidenav = toggleSidenav;
        vm.isNumber = isNumber;
        vm.hasDateShow = hasDateShow;
        vm.updateThread = updateThread;

        //////////

        init();

        function init() {

            vm.views = {
                nosplit: 'app/main/apps/users/views/list/nosplit-view.html',
                split: 'app/main/apps/users/views/list/split-view.html',
                table: 'app/main/apps/users/views/list/table-view.html',
                grid: 'app/main/apps/users/views/grid/grid-view.html',
                // Vista v2 tipo Excel: edición inline de todas las columnas. Opt-in
                // por tenant (usersGrid.enabled en qiu_config public); ver vm.usersGridEnabled.
                spreadsheet: 'app/main/apps/users/views/list/spreadsheet-view.html'
            };
            ;

            // Flag por tenant para la vista Excel/inline (v2). Se inicializa aquí y se
            // resuelve más abajo, una vez disponible el siteID (ver loadUsersGridFlag()).
            vm.usersGridEnabled = false;
            vm.defaultView = vm.getSettingValue(vm.settingsSection, 'defaultView', "split");
            vm.currentView = vm.getSettingValue(vm.settingsSection, 'defaultView', "split");
            vm.loadingView = true;

            //vm.getCountriesWithStates();

            var siteID = requestContext.getParam("siteId");
            //            var section = requestContext.getParam("section");

            var section = 'users';

            $scope.siteID = siteID;
            $scope.section = section;

            // Flag Excel/inline (v2): ahora que siteID está disponible, leemos el
            // qiu_config public del tenant. Sin el flag, el botón de la toolbar no
            // aparece y el resto de tenants no se ven afectados.
            sessionService.loadDomainResourceSettings(siteID).then(function (response) {
                if (response && response.public) {
                    var publicConfig = angular.fromJson(response.public);
                    // Solo administradores: la rejilla edita y borra en linea, igual que
                    // la de content.
                    var esAdmin = !!(sessionService.user && sessionService.user.is_admin);
                    if (esAdmin && publicConfig.usersGrid) {
                        vm.usersGridEnabled = publicConfig.usersGrid.enabled === true;
                    }
                }
            });


            /*
            contentService.getFilters({section: section, site: siteID}).then(function (response) {
                vm.mediaZones = (response.media_zones.length == 0)
                    ? null
                    : angular.copy(response.media_zones);
            });*/

            sessionService.setActiveSection(section).then(function () {
                vm.ActiveSection = sessionService.ActiveSection;
            });

            getUserGroupTypes();
            getCleanUsersGroup();

            vm.viewSplit = true;
            vm.edit = false;
            vm.currentTab = 'preview';
            vm.selectedUsers = [];
            vm.selectedGroups = [];

            $scope.view_medialist = true;
            $scope.siteID = siteID;
            $scope.section = section;
            $rootScope.global.titleToolbar = '<i class="icon s20 icon-people mr-15" ng-if="node.icon"></i> ' + $translate.instant('USERS');
            if (vm.isAccreditations) {
                $rootScope.global.titleToolbar = '<i class="icon s20 icon-people mr-15" ng-if="node.icon"></i> ' + $translate.instant('USERS.ACCREDITATIONS');
            }

            var options = {
                site: $scope.siteID,
                section: $scope.section
            };

            // $scope.page = 1;
            // request the initial set of data
            // loadRemoteData();
            $scope.page = 1;

            if ($state.params.id) {
                vm.loadingReadPane = true;
                // for (var i = 0; i < vm.threads.length; i++) {
                // if (vm.threads[i].id === $state.params.threadId) {
                //vm.openThread(null, $state.params.id);
                // break;
                // }
                // }
            }

            usersService.getUsersInGroupStatus($scope.siteID).then(function (response) {
                vm.ingroupStatus = response;
            });

        }

        function formatChilds(childs){
            if(childs){
                let ret = {};
                const parsedChilds = JSON.parse(childs);
                Object.entries(parsedChilds).forEach(([key, value]) => {
                    let keyName = key;
                    const status = vm.ingroupStatus.find(x => x.id_ingroup_status === parseInt(key));
                    if(status){
                        keyName = status.name;
                    }
                    if(value.length > 0){
                        for(let i=0; i<value.length; i++){
                            const[firstname, lastname, birthdate] = value[i].split(' ');
                            if(!ret[keyName]){
                                ret[keyName] = [];
                            }
                            ret[keyName].push(
                                {
                                    firstname: firstname,
                                    lastname: lastname,
                                    birthdate: birthdate
                                }
                            )
                        }
                    }
                });
                return ret;
            }
            return('-');
        }

        // Watch screen size to change view modes
        $scope.$watch(function () {
            return $mdMedia('lt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                vm.currentView = 'nosplit';
            }
        });

        $scope.$watch(function () {
            return $mdMedia('max-width: 960px');
        }, function (big) {

            if (big)
                vm.currentView = 'nosplit';

        });

        $scope.$watch(function () {
            return $mdMedia('min-width: 960px');
        }, function (small) {

            if (small && vm.defaultView === 'split')
                vm.currentView = vm.defaultView;

        });

        $scope.$watch(function () {
            return $mdMedia('gt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                if (vm.defaultView === 'split') {
                    vm.currentView = 'split';
                }
            }
        });

        $scope.$on('$includeContentLoaded', function (event, target) {
            $timeout(function () {
                vm.loadingView = false;
            }, 1000);
        });

        $scope.$on('loadUsersByGroups', function (event, groups, selectedGroup) {
            vm.pleaseSelectGroup = false;
            if (groups) {
                var groupIds = [];
                angular.forEach(groups, function (group) {
                    groupIds.push(group.id_group);
                });
                vm.selectedGroup = selectedGroup;
                loadUsersByGroups(groupIds);
            } else {
                if (!vm.isQiuRestricted) {
                    unselectGroups();
                }
            }
            vm.selectedThreads = [];
        });
        $scope.$on('loadUsersByGroupsAcc', function (event, groups) {
            vm.pleaseSelectGroup = false;
            if (groups) {
                var groupIds = [];
                angular.forEach(groups, function (group) {
                    groupIds.push(group.id_group);
                });
                vm.selectedGroupsAcc = groups;
                loadUsersByGroups();
            } else {
                unselectGroups();
            }
            vm.selectedThreads = [];
        });
        $scope.$on('loadUsersByGroupsAccSub', function (event, groups) {
            vm.pleaseSelectGroup = false;
            if (groups) {
                var groupIds = [];
                angular.forEach(groups, function (group) {
                    groupIds.push(group.id_group);
                });
                vm.selectedGroupsAccSub = groups;
                loadUsersByGroups();
            } else {
                unselectGroups();
            }
            vm.selectedThreads = [];
        });


        $scope.$on('pagination:loadStart', function (event) {
            $scope.isLoading = true;
            // $anchorScroll();

            // Store the current scrollPos
            // vm.scrollPos = vm.scrollEl.scrollTop();

            // Scroll to the top
            // vm.scrollEl.scrollTop(0);
            if (!vm.enterfirst) {
                var elem = angular.element(document.getElementById('thread-list'));
                elem.scrollTopAnimated(0, 10);
            }

            // angular.element("#thread-list").scrollTop=0;
            vm.enterfirst = false;
            $scope.isLoading = true;
        });

        $scope.$on('pagination:loadPage', function (event) {
            if (vm.currentGroupTypeId > 0 && !vm.selectedGroup && !vm.isAccreditations) {
                vm.threads = [];
                vm.pleaseSelectGroup = true;
            }
            if ($state.params.id && !vm.reloadFromUser) {
                vm.openThread(null, $state.params.id);
            }
            vm.reloadFromUser = false;
            $scope.isLoading = false;
            vm.dataAlreadyLoaded = true;
        });

        $scope.$on('closeSidenav', function (ev, sidenavId) {
            $mdSidenav(sidenavId).close();
        })

        $scope.$on('openGroupDialog', function (ev, group) {
            openGroupDialog(ev, group);
        });



        function getUserGroupTypes() {
            var options = {
                site: $scope.siteID
            };
            formsService.getUserGroupTypes(options).then(function (response) {
                vm.userGroupTypes = response;
            });
        }

        function toggleIncludeSubgroups() {
            vm.includeSubgroups = !vm.includeSubgroups;
            var element = $("#treeview-group-" + vm.selectedGroup.id_group);
            usersService.triggerUsersByGroups(element.attr("data-group-node"), vm.includeSubgroups);
        }

        function unselectGroups() {
            $scope.validSelection = true;
            vm.selectedIngroupStatus = "0";
            vm.selectedGroupsAcc = false;
            vm.selectedGroupsAccSub = false;
            vm.selectedGroup = false;
            vm.selectedContent = false;
            $rootScope.pagination_groupIds = false;
            $rootScope.pagination_ingroupStatus = false;
            var elemList = document.querySelectorAll('.group-row');
            elemList.forEach(function (elem) {
                elem.classList.remove('selected');
            });
            if (vm.currentGroupTypeId == 0) {
                loadAllUsers();
            } else {
                $scope.isLoading = true;
                $timeout(function () {
                    vm.pleaseSelectGroup = true;
                    vm.threads = [];
                    $scope.isLoading = false;
                }, 1000);
            }
        }

        function loadAllUsers() {
            $scope.isLoading = true;
            var options = {
                siteID: $scope.siteID,
                section: $scope.section,
                sortDir: $rootScope.sortDir,
                sortField: $rootScope.sortField
            };
            usersService.getUsers(options).then(function (response) {
                vm.threads = response.result.data;
                $rootScope.pagination_totalItems = response.result.total;
                $rootScope.pagination_total_pages = response.result.last_page;
                $rootScope.pagination_page = response.result.current_page;
                $scope.isLoading = false;
            });
        }

        function isSelectedIngroupStatusOfSelectedGroupType(groupId) {
            var selectedGroup = vm.allGroups.find(x => x.id_group === groupId);
            var selectedIngroupStatus = vm.ingroupStatus.find(y => y.id_ingroup_status === parseInt(vm.selectedIngroupStatus));
            if (selectedGroup && selectedIngroupStatus) {
                return selectedIngroupStatus.id_group_type === selectedGroup.id_group_type;
            }
            return false;
        }

        function loadUsersByGroups(groupIds) {

            $scope.validSelection = true;
            if (vm.isAccreditations) {
                groupIds = [];
                if (vm.selectedGroupsAcc) {
                    //groupIds.push(...vm.selectedGroupsAcc.map(x => x.id_group)) // Filter parent AND subgroups.
                    groupIds.push(vm.selectedGroupsAcc[0].id_group) // Only filter parent group, NO subgroups.
                }
                if (vm.selectedGroupsAccSub) {
                    groupIds = [];
                    if (vm.selectedGroupsAcc) {
                        var result = vm.selectedGroupsAccSub[0].users_groups.filter(x => vm.selectedGroupsAcc.find(y => y.id_group === x.parent))
                        groupIds.push(...result.map(x => x.id_group))
                    } else {
                        groupIds.push(...vm.selectedGroupsAccSub[0].users_groups.map(x => x.id_group))
                    }
                }
            }

            // The active ingroup status may have been set from a previously selected group.
            // Unset it if its type does not match the type of the _now_ selected group.
            if (!angular.isArray(groupIds) || groupIds.length === 0 || !isSelectedIngroupStatusOfSelectedGroupType(groupIds[0])) {
                $rootScope.pagination_ingroupStatus = false;
                vm.selectedIngroupStatus = false;
            }

            $scope.isLoading = true;
            var options = {
                siteID: $scope.siteID,
                section: $scope.section,
                groupIds: groupIds,
                sortDir: $rootScope.sortDir,
                sortField: $rootScope.sortField,
                withRelatedCountry: true,
                withRelatedCity: true,
                withRelatedState: true,
            };
            if (vm.selectedIngroupStatus != "0") {
                options.ingroupStatus = vm.selectedIngroupStatus;
            }
            if (!groupIds || groupIds.length == 0) {
                $scope.validSelection = false;
                const message = vm.translate('USERS.NO_VALID_SELECTION');
                $scope.isLoading = false;
                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-close" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                    hideDelay: 5000,
                    position: 'top',
                    parent: '#content-container'
                });
            } else {
                if (vm.refcolumns) {
                    var hasIngroupStatusTypeRef = vm.refcolumns.find(function (ref){
                        return ref.type === 'ingroup_status';
                    })
                    if (hasIngroupStatusTypeRef) {
                        vm.includeAllGroups = true;
                        options.allGroups = vm.includeAllGroups;
                    }
                }
                usersService.getUsersByGroupsNoRef(options).then(function (response) {
                    manageResponse(response, groupIds)
                });
            }
        }

        function manageResponse(response, groupIds) {
            $rootScope.pagination_groupIds = groupIds;

            vm.threads = response.result.data;
            angular.forEach(vm.threads, function (user) {
                var selUserGroup = $filter('filter')(user.groups, { id_group: vm.selectedGroup.id_group });
                if (selUserGroup.length > 0) {
                    var idIngroupStatus = selUserGroup[0].users_ingroup.id_ingroup_status;
                    user.ingroup_status = $filter('filter')(vm.ingroupStatus, { id_ingroup_status: idIngroupStatus });
                }
                // if(user.childs && user.childs.length > 0){
                //     user.formatedChilds = formatChilds(user.childs);
                // }
            });
            $rootScope.pagination_totalItems = response.result.total;
            $rootScope.pagination_total_pages = response.result.last_page;
            $rootScope.pagination_page = response.result.current_page;
            $scope.isLoading = false;
        }

        function getCleanUsersGroup() {
            $scope.isLoadingGroups = true;
            var opts = {
                siteID: $scope.siteID,
                withGroupType: true,
                sortField: vm.sortFieldUsersGroup,
                sortDir: vm.sortDirUsersGroup
            };
            if (vm.currentGroupTypeId > 0 && !vm.isAccreditations) {
                opts.groupType = vm.currentGroupTypeId;
            }
            if (vm.refcolumns) {
                var hasIngroupStatusTypeRef = vm.refcolumns.find(function (ref){
                    return ref.type === 'ingroup_status';
                })
                if (hasIngroupStatusTypeRef) {
                    vm.includeAllGroups = true;
                    opts.allGroups = vm.includeAllGroups;
                }
            }
            return usersService.getUsersGroups(opts).then(function (response) {
                var qiuRestrictions = response.qiuRestrictions;
                if (qiuRestrictions && qiuRestrictions.hasOwnProperty('advanced_settings_access')) {
                    vm.hasAdvancedSettingsAccess = qiuRestrictions.advanced_settings_access.includes(true);
                }
                var groups = response.data;
                vm.allGroups = getFlatGroups(groups, []);
                vm.CleanUsersGroups = transformUsers.formatNestedGroups(groups, qiuRestrictions, true);
                
                if (vm.isAccreditations) {
                    groupsByRefAccreditations();
                } else {
                    groupsByRef();
                }
                if (angular.isArray(vm.CleanUsersGroups) &&
                    vm.CleanUsersGroups.length > 0 &&
                    vm.CleanUsersGroups[0].is_qiu_restricted_root
                ) {
                    vm.isQiuRestricted = true;
                    if (vm.isAccreditations) {
                        //vm.selectedGroup = vm.CleanUsersGroups[0];
                        vm.rootGroup = vm.CleanUsersGroups[0];
                    } else {
                        vm.selectedGroup = vm.CleanUsersGroups[0];
                        vm.rootGroup = vm.CleanUsersGroups[0];
                    }
                }
                vm.flatGroups = getFlatGroups(vm.CleanUsersGroups, []);
                vm.eventsGroup = getEvents(vm.CleanUsersGroups);
            });

        }
        
        function getEvents(Groups){
            var groupsToReturn = [];
            if(Groups.length > 0){
                for(var i=0; i<Groups.length; i++){
                    if(Groups[i].id_group == 41){
                        groupsToReturn = Groups[i].children;
                    }
                }
            }
            return groupsToReturn;
        }

        function groupsByRefAccreditations() {
            var options = { siteID: $scope.siteID };
            usersService.getRef(options).then(function (ref) {
                vm.groupTypes = ref.find(x => x.category === 'show_groups');
                vm.subGroupTypes = ref.find(x => x.category === 'show_groups_type');
                vm.acreditationsGroups = angular.copy(vm.CleanUsersGroups);
                const arrayGroupsTypes = JSON.parse(vm.groupTypes.field_name);
                const arraysubGroupsTypes = JSON.parse(vm.subGroupTypes.field_name);
                vm.acreditationsGroups = cleanByType(vm.acreditationsGroups, arrayGroupsTypes);

                usersService.getGroupsAccreditations(options).then(function (groups) {
                    vm.groupsAccreditations = groups;
                    var copyGroups = getFlatGroups(angular.copy(vm.groupsAccreditations[0].children), []);
                    vm.subAcreditationsGroups = [];
                    for (let i = 0; i < copyGroups.length; i++) {
                        if (arraysubGroupsTypes.find(y => y === copyGroups[i].id_group_type)) {
                            transformUsers.colorizeGroupByType(copyGroups[i], vm.userGroupTypes)
                            vm.subAcreditationsGroups.push(copyGroups[i])
                        }
                    }
                    vm.subAcreditationsGroups = vm.subAcreditationsGroups.sort(function (a, b) {
                        return (a.id - b.id);
                    });
                    $scope.isLoadingGroups = false;
                })
            })
        }

        function groupsByRef() {
            var options = { siteID: $scope.siteID };
            usersService.getRef(options).then(function (ref) {
                var found = ref.find(x => x.category === 'show_groups');
                if (found) {
                    vm.CleanUsersGroups = cleanByType(vm.CleanUsersGroups, JSON.parse(found.field_name));
                }
                $scope.isLoadingGroups = false;
            })
        }

        function addToGroup(group, groupParent) {
            var existParent = vm.selectedContent.groups ? vm.selectedContent.groups.find(x => x.id_group == groupParent.id_group) : null;
            var groups = [];
            if (!existParent) {
                var groupParentToInsert = { "id_group": groupParent.id_group, "id_ingroup_status": groupParent.default_ingroup_status };
                groups.push(groupParentToInsert)
            }
            groups.push({ "id_group": group.id_group });
            addGroup(vm.selectedContent.id_user, groups, true);
        }

        function addGroup(id_user, groups, update) {
            var options = {
                siteID: $scope.siteID,
                data: {
                    id_users: [id_user],
                    groups: groups
                }
            };
            usersService.massInsertUsersIntoGroups(options)
                .then(function (response) {
                    var options = { site: $scope.siteID, section: $scope.section, id: $state.params.id, sortDir: $rootScope.sortDir, sortField: $rootScope.sortField };
                    usersService.getUserByID(options).then(function (response) {
                        vm.selectedContent.groups = JSON.parse(angular.toJson(response)).groups;
                        vm.reloadFromUser = true;
                        if (update) {
                            $rootScope.pagination_resetquery();
                        } else {
                            getGroupsAsfield();
                        }
                    });
                }, function(error) {
                    if (error.data.detail) {
                        msUtils.showError(error.data.detail);
                    }
                });
        }
        function removeFromGroup(group, groupParent) {
            var removeParent = vm.selectedContent.groups ? (vm.selectedContent.groups.filter(x => x.parent == group.parent).length <= 1) : null;
            removeGroup(group.id_group, vm.selectedContent.id_user, true);
            if (removeParent) {
                removeGroup(groupParent.id_group, vm.selectedContent.id_user, true);
            }
        }
        function removeGroup(idgroup, iduser, update) {
            var options = {
                siteID: $scope.siteID,
                data: {
                    id_group: idgroup,
                    id_user: [iduser]
                }
            };
            usersService.removeUsersFromGroup(options).then(function (response) {
                var options = { site: $scope.siteID, section: $scope.section, id: $state.params.id, sortDir: $rootScope.sortDir, sortField: $rootScope.sortField };
                usersService.getUserByID(options).then(function (response) {
                    vm.selectedContent.groups = JSON.parse(angular.toJson(response)).groups;
                    vm.reloadFromUser = true;
                    if (update) {
                        $rootScope.pagination_resetquery();
                    } else {
                        getGroupsAsfield();
                    }
                });
            });
        }

        function isActiveGroupUser(group) {
            if (!vm.selectedContent || !vm.selectedContent.groups) return false;
            return vm.selectedContent && vm.selectedContent.groups.find(x => x.id_group === group.id_group);
        }
        function cleanByType(arrayGroups, groupTypes) {
            arrayGroups = arrayGroups.filter(x => groupTypes.find(y => y === x.id_group_type))
            for (let i = 0; i < arrayGroups.length; i++) {
                const group = arrayGroups[i];
                if (group.children) {
                    group.children = cleanByType(group.children, groupTypes);
                }
            }
            return arrayGroups;
        }
        function getByType(arrayGroups, groupTypes) {

            var result = arrayGroups.filter(x => groupTypes.find(y => y === x.id_group_type))
            for (let i = 0; i < arrayGroups.length; i++) {
                const group = arrayGroups[i];
                if (group.children) {
                    result.push(...getByType(group.children, groupTypes));
                }
            }
            return result;
        }

        function getFlatGroups(nestedGroups, groups) {
            angular.forEach(nestedGroups, function (group) {
                groups.push(group);
                if (group.children) {
                    getFlatGroups(group.children, groups)
                }
            });
            return groups;
        }

        function createGroup(ev) {
            openGroupDialog(ev, {});
        }

        function segmentGroupDialogNew($event) {
            var promiseList = [];
            promiseList.push(usersService.getUsersGroups({
                siteID: $scope.siteID,
                withGroupType: true
            })
            );
            promiseList.push(usersService.getUsersGroupsTypes({ siteID: $scope.siteID }));

            $q.all(promiseList).then(function (response) {
                var cleanUsersGroups = transformUsers.formatNestedGroups(response[0].data, response[0].qiuRestrictions, true);
                var usersGroupsTypes = response[1];
                if (vm.currentGroupTypeId > 0) {
                    usersGroupsTypes = usersGroupsTypes.filter(x => x.id_group_type == vm.currentGroupTypeId)
                }
                openSegmentGroupDialogNew(cleanUsersGroups, usersGroupsTypes);
            }).catch(function (error) {
                console.log(error);
            });
        }

        function openSegmentGroupDialogNew(cleanUsersGroups, usersGroupsTypes) {
            var groupsTree = angular.copy(cleanUsersGroups);
            var booleanOperations = [
                {
                    operation: 'add',
                    name: $translate.instant('GROUP.ACTIONS.ADD')
                },
                {
                    operation: 'intersect',
                    name: $translate.instant('GROUP.ACTIONS.INTERSECT')
                },
                {
                    operation: 'except',
                    name: $translate.instant('GROUP.ACTIONS.EXCEPT')
                },
                {
                    operation: 'difference',
                    name: $translate.instant('GROUP.ACTIONS.DIFFERENCE')
                },
                {
                    operation: 'filter',
                    name: $translate.instant('GROUP.ACTIONS.FILTER')
                }
            ];
            $mdDialog.show({
                controller: 'SegmentUsersGroupsController',
                controllerAs: 'vm',
                locals: {
                    usersGroups: cleanUsersGroups,
                    usersGroupsTypes: usersGroupsTypes,
                    booleanOperations: booleanOperations,
                    defaultGroupTypeId: false,
                    showGroupsTypes: true,
                    newGroupShow: false,
                    subscriptionGroupId: false,
                    subscriptionGroupName: ''
                },
                templateUrl: 'app/main/dialogs/segment-users-groups/segment-users-groups.html',
                parent: angular.element($document.body),
                targetEvent: 'ev',
                clickOutsideToClose: true

            }).then(function (result) {
                if (result) {
                    getCleanUsersGroup();
                }
            });
        }

        function changeInGroupStatusDialog(ev, selectedUser, selectedGroup, selectedStatus, isAccreditations) {
            if(!isCurrentGroupStatus(selectedUser, selectedStatus)) {
                return;
            }
            ev.stopPropagation();
            $mdDialog.show({
                controller: 'ChangeInGroupStatusDialogController',
                controllerAs: 'vm',
                locals: {
                    isAccreditations: isAccreditations,
                    ingroupStatus: vm.ingroupStatus,
                    selectedUser: selectedUser,
                    selectedGroup: selectedGroup,
                    selectedStatus: selectedStatus,
                    siteID: $scope.siteID
                },
                templateUrl: 'app/main/apps/users/dialogs/users/change-in-group-status.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            }).then(function (user) {
                if (user) {
                    if (isAccreditations) {
                        vm.selectedContent = user;
                        vm.reloadFromUser = true;
                        $rootScope.pagination_resetquery();
                    } else {
                        var options = {
                            site: $scope.siteID,
                            id: user.id_user,
                            item: transformUsers.userToDTO(user)
                        };
                        usersService.saveItem(options).then(function () {
                            var message = $translate.instant('USERS.INGROUP_STATUS_SAVED');
                            $mdToast.show({
                                template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                                hideDelay: 5000,
                                position: 'top',
                                parent: '#content-container'
                            });
                            vm.reloadFromUser = true;
                            $rootScope.pagination_resetquery();
                        });
                    }
                }
            });
        }

        function filterActiveTypes(groups) {
            if (typeof groups === 'string') {
                groups = JSON.parse(groups)
            }
            return function (item) {
                return groups.find(x => x == item.id_group_type && vm.selectedGroupsAcc && vm.selectedGroupsAcc[0] && vm.selectedGroupsAcc[0].id_group === item.parent);
            };
        };

        function getGroupIcon(group) {
            return getByType(angular.copy(vm.CleanUsersGroups), [group.id_group_type]).find(x => x.id_group === group.id_group).group_type.icon;;
        }

        function deleteTargetEdit(item, index) {
            for (var i = vm.currentThread_Edit.groups.length - 1; i >= 0; i--) {
                if (vm.currentThread_Edit.groups[i].id_group == item.id_group) {
                    vm.currentThread_Edit.groups.splice(i, 1);
                    vm.currentLabelsEdit.splice(index, 1);
                }
            };
            for (var i = vm.currentThread_Edit.groupIds.length - 1; i >= 0; i--) {
                if (vm.currentThread_Edit.groupIds[i] == item.id_group) {
                    vm.currentThread_Edit.groupIds.splice(i, 1);
                }
            };
            for (var i = vm.groupTypesWithCurrentLabelsEdit.length - 1; i >= 0; i--) {
                if (vm.groupTypesWithCurrentLabelsEdit[i].hasOwnProperty('labelsEdit')) {
                    for (var k = vm.groupTypesWithCurrentLabelsEdit[i].labelsEdit.length - 1; k >= 0; k--) {
                        if (vm.groupTypesWithCurrentLabelsEdit[i].labelsEdit[k].group.id_group == item.id_group) {
                            vm.groupTypesWithCurrentLabelsEdit[i].labelsEdit.splice(k, 1);
                        }
                    }
                }
            }
            vm.basicForm.$setDirty();
        }

        function getCurrentLabelsEdit() {
            var usersGroupsAux = transformUsers.initGroupsTree(angular.copy(vm.CleanUsersGroups), vm.currentThread_Edit.groups, vm.ingroupStatus);
            vm.currentLabelsEdit = transformUsers.getLabels(usersGroupsAux, []);
            vm.groupTypesWithCurrentLabelsEdit = angular.copy(vm.userGroupTypes);
            angular.forEach(vm.groupTypesWithCurrentLabelsEdit, function (groupType) {
                angular.forEach(vm.currentLabelsEdit, function (labelEdit) {
                    if (labelEdit.group.id_group_type == groupType.id_group_type) {
                        if (!groupType.hasOwnProperty('labelsEdit')) {
                            groupType['labelsEdit'] = [];
                        }
                        if (labelEdit.group.parent != null) {
                            getGroupParent(labelEdit.group);
                        }
                        groupType.labelsEdit.push(labelEdit);
                    }
                });
            });
        }
        function getGroupParent(group) {
            for (var i = vm.flatGroups.length - 1; i >= 0; i--) {
                if (vm.flatGroups[i].id_group == group.parent) {
                    group.parentGroup = angular.copy(vm.flatGroups[i]);
                    if (group.parentGroup.parent != null) {
                        getGroupParent(group.parentGroup);
                    }
                }
            }
        }
        function isLarge(field) {
            return ['firstname', 'email', 'last_login', 'created_at'].includes(field);
        }
        function isMedium(field) {
            return ['mobile', 'skype', 'ingroup_status', 'country'].includes(field);
        }
        function isSmall(field) {
            return [].includes(field);
        }
        function isMini(field) {
            return ['status', 'media', 'id_user'].includes(field);
        }

        function changeSelectedIngroupStatus() {
            // TODO reload group users filtered by ingroup status
            var groupIds = $rootScope.pagination_groupIds;
            $rootScope.pagination_ingroupStatus = vm.selectedIngroupStatus;
            loadUsersByGroups(groupIds);
        }
        
        function changeGroupPriority(ev) {
            $mdDialog.show({
                controller: 'ChangePriorityGroupDialogController',
                controllerAs: 'vm',
                locals: {
                    siteID: $scope.siteID,
                    sourceGroups: [vm.selectedGroup],
                    mailingPriorities: vm.refcolumns.find(x => x.title == 'mailing_priority').raw_settings.values,
                    selectedThreads: vm.selectedThreads
                },
                templateUrl: 'app/main/apps/users/dialogs/priority/change-priority.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            }).then(function (response) {
               if(response){
                    $scope.isLoading = true;
                    var users = response.users;
                    var count = 0;
                    for(var i=0; i<users.length; i++){
                        var user = users[i];
                        user.mailing_priority = response.priority;
                        var options = {
                            site: $scope.siteID,
                            id: user.id_user,
                            item: transformUsers.userToDTO(user)
                        }
                        usersService.saveItem(options).then(function (response){
                            count ++;
                            closeThread();
                            if(count == users.length){
                                $scope.isLoading = false;
                            }
                        }, function(error) {
                            if (error.detail && error.detail === 'The email has already been taken.') {
                                msUtils.showError($translate.instant('USERS.ERRORS.EMAIL_EXISTS'));
                            }
                        });
                    }
                }else{
                    closeThread();
                }
            });
        }

        function openCopyMoveDialog(ev, selectedAction) {
            $mdDialog.show({
                controller: 'CopyMoveToGroupDialogController',
                controllerAs: 'vm',
                locals: {
                    siteID: $scope.siteID,
                    sourceGroups: [vm.selectedGroup],
                    usersGroups: vm.CleanUsersGroups,
                    includeSubgroups: vm.includeSubgroups,
                    selectedAction: selectedAction
                },
                templateUrl: 'app/main/apps/users/dialogs/in-groups/copy-move-to-group-dialog/copy-move-to-group-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            }).then(function (reloadUserList) {
                if (reloadUserList) {
                    $rootScope.pagination_reload();
                }
            });
        }

        function addUsersToGroupsDialog(ev) {
            //var groupsTree = transformUsers.initGroupsTree(angular.copy(vm.CleanUsersGroups), [], vm.ingroupStatus);
            $mdDialog.show({
                controller: 'AddUsersToGroupsDialogController',
                controllerAs: 'vm',
                locals: {
                   
                    CleanUsersGroups: vm.CleanUsersGroups,
                    ingroupStatus: vm.ingroupStatus,
                    users: angular.copy(vm.selectedThreads),
                    siteID: $scope.siteID
                },
                templateUrl: 'app/main/apps/users/dialogs/groups/users-groups-view.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                multiple: true
            }).then(function (res) {
                if (res) {
                    getCleanUsersGroup();
                }
            });
            $scope.loadGroup = false;
       }

        function getMaxAllowedUsers() {

        }

        function openImportDialog(ev) {
            $mdDialog.show({
                controller: 'ImportDialogController',
                controllerAs: 'vm',
                locals: {
                    siteID: $scope.siteID,
                    rootGroup: vm.isQiuRestricted ? vm.rootGroup : null,
                    selectedGroup: vm.selectedGroup ? vm.selectedGroup : vm.selectedGroupsAcc ? vm.selectedGroupsAcc[0] : null
                },
                templateUrl: 'app/main/apps/users/dialogs/import/import-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            })
                .then(function (result) {
                    if (result && result.update) {
                        $rootScope.pagination_resetquery();
                    }
                });
        }

        function openExportDialog(ev) {
            var groups = vm.selectedGroup ? vm.selectedGroup : null;
            var mainGroup = null;
            if (vm.selectedGroupsAcc) {
                groups = vm.selectedGroupsAcc[0];
                if (vm.selectedGroupsAccSub) {
                    mainGroup = vm.selectedGroupsAcc[0];
                    groups = vm.selectedGroupsAccSub[0].users_groups.find(x => x.parent === vm.selectedGroupsAcc[0].id_group);
                }
            } else {
                if (vm.selectedGroupsAccSub) {
                    groups = vm.selectedGroupsAccSub[0].users_groups;
                }
            }

//            console.log(groups);
            $mdDialog.show({
                controller: 'ExportDialogController',
                controllerAs: 'vm',
                locals: {
                    siteID: $scope.siteID,
                    refcolumns: vm.refcolumns,
                    selectedGroup: groups,
                    selectedMainGroup: mainGroup,
                    selectedThreads: vm.selectedThreads.length > 0 ? vm.selectedThreads : null,
                    threads: vm.threads,
                    totalItems: $rootScope.pagination_totalItems,
                    groups: vm.CleanUsersGroups,
                    includeSubgroups: vm.includeSubgroups,
                    currentGroupTypeId: vm.currentGroupTypeId,
                    selectedIngroupStatus: vm.selectedIngroupStatus
                },
                templateUrl: 'app/main/apps/users/dialogs/export/export-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            })
                .then(function (result) {
                });
        }

        function removeUsersFromGroupDialog(ev) {

            var confirmTitle = $translate.instant('GROUP.REMOVE_CONFIRM_TITLE', { group_name: vm.selectedGroup.name });
            var confirmText = $translate.instant('GROUP.REMOVE_CONFIRM_TEXT');
            var confirm = $mdDialog.confirm()
                .title(confirmTitle)
                .textContent(confirmText)
                .ariaLabel(confirmTitle)
                .targetEvent(ev)
                .ok('OK')
                .cancel($translate.instant('CANCEL'));

            $mdDialog.show(confirm).then(function () {

                var removeUserIds = vm.selectedThreads.map(function (thread) { return thread.id_user });

                var options = {
                    siteID: $scope.siteID,
                    data: {
                        id_group: vm.selectedGroup.id_group,
                        id_user: removeUserIds
                    }
                }
                usersService.removeUsersFromGroup(options).then(function (response) {
                    var element = $("#treeview-group-" + vm.selectedGroup.id_group);
                    usersService.triggerUsersByGroups(element.attr("data-group-node"), vm.includeSubgroups);

                    if (removeUserIds.length == 1) {
                        var message = $translate.instant('GROUP.USER_REMOVED_SINGULAR');
                    } else {
                        var message = removeUserIds.length + $translate.instant('GROUP.USER_REMOVED_PLURAL');
                    }

                    $mdToast.show({
                        template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                        hideDelay: 5000,
                        position: 'top',
                        parent: '#content-container'
                    });
                });
            });

        }

        function openUsersGroupsDialog() {
            var groupsTree = transformUsers.initGroupsTree(angular.copy(vm.CleanUsersGroups), vm.currentThread_Edit.groups, vm.ingroupStatus);
            $mdDialog.show({
                controller: 'UsersGroupController',
                controllerAs: 'vm',
                locals: {
                    usersGroups: groupsTree,
                    isTiny: false
                },
                templateUrl: 'app/main/dialogs/users-group/users-group-view.html',
                parent: angular.element($document.body),
                targetEvent: 'ev',
                clickOutsideToClose: true,

            }).then(function (groupsTree) {
                if (angular.isDefined(groupsTree) && groupsTree.length > 0) {
                    if (angular.isUndefined(vm.currentThread_Edit.groups)) {
                        vm.currentThread_Edit.groups = [];
                    }
                    transformUsers.updateThreadGroups(groupsTree, vm.currentThread_Edit.groups, vm.currentThread_Edit.id_user, []);
                }
                getCurrentLabelsEdit();
                vm.basicForm.$setDirty();
            });
        }




        function setSortField(field) {
            vm.fieldOrder = field;
            settingUserService.setSetting(vm.settingsSection, 'sortField', field);
            $rootScope.pagination_setSortField(field, $rootScope.sortDir);
        }

        function setSortOrder(order) {
            $rootScope.sortDir = order;
            settingUserService.setSetting(vm.settingsSection, 'sortDir', order);
            $rootScope.pagination_setSortField(vm.fieldOrder, $rootScope.sortDir);
        }

        /**
         * Load folder
         *
         * @param name
         */
        function loadFolder(name) {
            // If we are already in the selected folder and
            // there is an open thread just close it
            if (vm.isFolderActive(name)) {
                // Close the current thread if open
                if (vm.currentThread) {
                    vm.closeThread();
                }

                return;
            }

            // Show loader
            $rootScope.loadingProgress = true;

            // Update the state without reloading the controller
            $state.go('app.users.threads', {
                type: null,
                filter: name
            }, { notify: false });

            // Build the API name
            var apiName = 'content.folder.' + name + '@get';

            // Make the call
            msApi.request(apiName).then(
                // Success
                function (response) {
                    // Load new threads
                    vm.threads = response.data;
                    // Set the current filter
                    vm.currentFilter = {
                        type: null,
                        filter: name
                    };

                    // Close the current thread if open
                    if (vm.currentThread) {
                        vm.closeThread();
                    }

                    // Hide loader
                    $rootScope.loadingProgress = false;
                });
        }

        function selectOrUnselect(item, $event) {
            // var indexInTemp = $scope.temps.indexOf(item);
            var isRightClick = $event && $event.which == 3;
            var isDoubleClick = $event && $event.type == 'dblclick';

            // if ($event && $event.target.hasAttribute('prevent')) {
            //     $scope.temps = [];
            //     return;
            // }
            // if (! item || (isRightClick && $scope.isSelected(item))) {
            //     return;
            // }
            // if ($event && $event.shiftKey && !(isRightClick) && !(isDoubleClick)) {
            //     var list = $scope.fileList;
            //     var indexInList = list.indexOf(item);
            //     var lastSelected = $scope.temps[0];
            //     var i = list.indexOf(lastSelected);
            //     var current = undefined;
            //     if (lastSelected && list.indexOf(lastSelected) < indexInList) {
            //         $scope.temps = [];
            //         while (i <= indexInList) {
            //             current = list[i];
            //             !$scope.isSelected(current) && $scope.temps.push(current);
            //             i++;
            //         }
            //         return;
            //     }
            //     if (lastSelected && list.indexOf(lastSelected) > indexInList) {
            //         $scope.temps = [];
            //         while (i >= indexInList) {
            //             current = list[i];
            //             !$scope.isSelected(current) && $scope.temps.push(current);
            //             i--;
            //         }
            //         return;
            //     }
            // }
            // if ($event && !(isRightClick) && !(isDoubleClick) && ($event.ctrlKey || $event.metaKey)) {
            //     $scope.isSelected(item) ? $scope.temps.splice(indexInTemp, 1) : $scope.temps.push(item);
            //     return;
            // }
            // $scope.temps = [item];
        };

        /**
         * Toggle checked status of the content
         *
         * @param content
         * @param event
         */
        function toggleTrueFalseCheck(field, event) {
            if (event) {
                event.stopPropagation();
            }

            if (vm.selectedContent[field]) {
                vm.selectedContent[field] = false;
            } else {
                vm.selectedContent[field] = true;
            }

            // var idx = vm.checked.indexOf(content);

            // if (idx > -1) {
            // 	vm.checked.splice(idx, 1);
            // } else {
            // 	vm.checked.push(content);
            // }
        }

        /**
         * Return checked status of the content
         *
         * @param content
         * @returns {boolean}
         */
        function isTrueFalseChecked(fieldStatus) {
            return fieldStatus ?
                true :
                false;
            // return vm.checked.indexOf(content) > -1;
        }

        /**
         * Load label
         *
         * @param name
         */
        function loadLabel(name) {
            // Update the state without reloading the controller
            $state.go('app.users.threads', {
                type: 'label',
                filter: name
            }, { notify: false });

            // If we are already in the selected folder and
            // there is an open thread just close it
            if (vm.isLabelActive(name)) {
                // Close the current thread if open
                if (vm.currentThread) {
                    vm.closeThread();
                }

                return;
            }

            // Show loader
            $rootScope.loadingProgress = true;

            // Build the API name
            var apiName = 'content.label.' + name + '@get';

            // Make the call
            msApi.request(apiName).then(
                // Success
                function (response) {
                    // Load new threads
                    vm.threads = response.data;
                    // Set the current filter
                    vm.currentFilter = {
                        type: 'label',
                        filter: name
                    };

                    // Close the current thread if open
                    if (vm.currentThread) {
                        vm.closeThread();
                    }

                    // Hide loader
                    $rootScope.loadingProgress = false;
                });
        }

        /**
         * Is the folder with the given name active?
         *
         * @param name
         * @returns {boolean}
         */
        function isFolderActive(name) {
            return (vm.currentFilter.type === null && vm.currentFilter.filter === name);
        }

        /**
         * Is the label with the given name active?
         *
         * @param name
         * @returns {boolean}
         */
        function isLabelActive(name) {
            return (vm.currentFilter.type === 'label' && vm.currentFilter.filter === name);
        }

        /**
         * Open thread
         *
         * @param thread
         */
        function openThread(thread, id) {
            cleanGroupsAsfield();
            // Set the read status on the thread
            // thread.read = true;
            if (vm.countriesWithStates == undefined) {
                vm.getCountriesWithStates();
            }
            if (angular.element(document.getElementById('thread-detail')).length) {
                var elem = angular.element(document.getElementById('thread-detail'));
                elem.scrollTopAnimated(0, 10);
            }
            // pagesShown = 1;
            if (thread) {
                vm.selectedContentID = thread.id_user;
            } else if (id) {
                vm.selectedContentID = id;
            }
            if (vm.selectedContentID != 'new') {
                vm.editInline = false;

                vm.loadingReadPane = true;

                var goToState = 'app.site_overview.users.list.thread';



                $state.go(goToState, {
                    id: vm.selectedContentID
                }, {
                    notify: false,
                    inherit: true,
                    location: true
                });

                var options = {
                    site: $scope.siteID,
                    section: $scope.section,
                    id: vm.selectedContentID,
                    sortDir: $rootScope.sortDir,
                    sortField: $rootScope.sortField
                };

                /*
                if (angular.isUndefined(vm.tags) || vm.tags === null) {
                    contentService.getTags(options).then(function (response) {
                        vm.tags = angular.copy(response.tags);
                    });
                }*/
                usersService.getUserByID(options).then(function (response) {
                    //vm.selectedContent = angular.copy(response);
                    vm.currentThread = JSON.parse(angular.toJson(response));
                    // if(vm.currentThread.childs){
                    //     vm.currentThread.formatedChilds = formatChilds(vm.currentThread.childs);
                    // }
                    transformUsers.DtoToUser(vm.currentThread, $scope.siteID);
                    vm.selectedContent = angular.copy(vm.currentThread);
                    // vm.updateThread(vm.currentThread);
                    vm.log = response.log;
                    refColumnStuff();
                    vm.nextPageLog = 1;
                    vm.getLogs(vm.currentThread.email, vm.nextPageLog);
                    vm.loadingReadPane = false;
                    vm.currentThread_Edit = angular.copy(vm.selectedContent);
                    getCurrentLabelsEdit();
                    getGroupsAsfield();
                    if (vm.currentTab == 'edit') {
                        viewEditInline();
                    }
                });
                usersService.getUsersAuditTrailByID(options).then(function (response) {
                    for (var i = 0; i < response.length; i++) {
                        response[i].dateWithoutHours = moment(response[i].date).format("MMM DD");
                        response[i].action_data = JSON.parse(response[i].action_data);
                        try {
                            response[i].action_brief = JSON.parse(response[i].action_brief);
                        } catch (e) { }
                    }
                    vm.userAuditTrailEvents = response;
                })

            };
        }

        function getGroupsAsfield() {
            var ref_group_as_field = vm.refcolumns.filter(x => x.category == 'show_groups_as_field')
            if (ref_group_as_field && ref_group_as_field.length > 0) {
                for (let i = 0; i < ref_group_as_field.length; i++) {
                    const element = ref_group_as_field[i];
                    const flatgroups = getFlatGroups(element.groups_as_field, []);;
                    element.model = vm.selectedContent.groups ? vm.selectedContent.groups.filter(x => flatgroups.find(y => y.id_group == x.id_group)).map(x => x.id_group) : [];
                    markSelected(element.model, element.groups_as_field)
                }

            }
        }
        function markSelected(selected, data) {
            for (let i = 0; i < data.length; i++) {
                data[i].selected = selected.find(x => x == data[i].id_group) != undefined;
                markSelected(selected, data[i].children)
            }
        }

        function cleanGroupsAsfield() {
            if (vm.refcolumns) {
                var ref_group_as_field = vm.refcolumns.filter(x => x.category == 'show_groups_as_field')
                if (ref_group_as_field && ref_group_as_field.length > 0) {
                    for (let i = 0; i < ref_group_as_field.length; i++) {
                        const element = ref_group_as_field[i];
                        element.model = [];
                    }
                }
            }
        }

        function getGroupNames(field) {
            if (!field.groups_as_field){
                return '';
            }
            if (Array.isArray(field.model)) {
                var groups = field.groups_as_field.filter(x => field.model.find(y => y == x.id_group))
                var result = '';
                for (let i = 0; i < groups.length; i++) {
                    result += groups[i].text;
                    if (i < (groups.length - 1)) {
                        result += ', '
                    }
                }
                return result.trim();
            } else {
                var found = field.groups_as_field.find(x => x.id_group === field.model);
                return found ? found.text.trim() : '';
            }

        }
        function getLogs(email, page) {
            vm.loadingLogsReadPane = true;
            mailingService.getLogByUser({
                site: $scope.siteID,
                email: email,
                page: page,
                resultsPerPage: 250
            }).then(function (response) {
                vm.pagination_total_log_pages = response.last_page;
                vm.pagination_log_page = response.current_page;
                if (vm.nextPageLog > 1) {
                    vm.logs = vm.logs.concat(response.data)
                } else {
                    vm.logs = response.data;
                }
                vm.loadingLogsReadPane = false;
                vm.nextPageLog++;
            });
        }

        function refColumnStuff() {
            for (var i = vm.refcolumns.length - 1; i >= 0; i--) {

                if (vm.refcolumns[i].category == 'json') {
                    var value = '';
                    if (vm.selectedContent.user_params && vm.selectedContent.user_params != 'null') {
                        if (typeof vm.selectedContent.user_params == 'string') {
                            var userParamsObj = JSON.parse(vm.selectedContent.user_params);
                        } else if (typeof vm.selectedContent.user_params == 'object') {
                            var userParamsObj = vm.selectedContent.user_params;
                        }
                        if (userParamsObj && userParamsObj.hasOwnProperty(vm.refcolumns[i].title)) {
                            value = userParamsObj[vm.refcolumns[i].title];
                        }
                    }
                    vm.selectedContent[vm.refcolumns[i].title] = value;
                }

                if (vm.refcolumns[i].type) {
                    if (vm.refcolumns[i].type.substr(0, 8) == 'datetime') {

                        var value = vm.selectedContent[vm.refcolumns[i].title];
                        if (value == '0000-00-00 00:00:00') {
                            value = moment().format("YYYY-MM-DD");
                        }

                        var utcDate = moment.utc(value);

                        var siteDate = moment.utc(value).tz(sessionService.site_operative.timezone);

                        vm.selectedContent[vm.refcolumns[i].title] = {};
                        vm.selectedContent[vm.refcolumns[i].title]['value'] = value;
                        vm.selectedContent[vm.refcolumns[i].title]['date'] = new Date(siteDate.format());
                        vm.selectedContent[vm.refcolumns[i].title]['dateShow'] = siteDate.format(vm.dateTimeFormat);
                        vm.selectedContent[vm.refcolumns[i].title]['utcShow'] = utcDate.format(vm.dateTimeFormat);
                        vm.selectedContent[vm.refcolumns[i].title]['utcDate'] = utcDate;
                    } else if (vm.refcolumns[i].type.substr(0, 4) == 'date') {
                        var format = "YYYY-MM-DD";
                        if (vm.refcolumns[i].type.split('-')[1]) {
                            format = vm.refcolumns[i].type.split('-')[1];
                        }
                        vm.selectedContent[vm.refcolumns[i].title] = moment.utc(vm.selectedContent[vm.refcolumns[i].title]).tz(sessionService.site_operative.timezone).format(format);
                    } else if (vm.refcolumns[i].type == 'state') {
                        if (vm.selectedContent.country) {
                            vm.getStatesByCountry(vm.selectedContent.country);

                        }
                    } else if (vm.refcolumns[i].type == 'files') {
                        if (vm.selectedContent.files) {
                            if (typeof vm.selectedContent.files === 'string') {
                                vm.selectedContent.files = JSON.parse(vm.selectedContent.files);
                            }
                        }
                    } else if (vm.refcolumns[i].type == 'mailing_priority'){
                        vm.mailingPriority = vm.refcolumns[i].raw_settings.values;
                    }
                }
                if (vm.refcolumns[i].category == 'show_groups_inprofile') {
                    if (typeof vm.refcolumns[i].title === 'string') {
                        vm.refcolumns[i].title = JSON.parse(vm.refcolumns[i].title)
                    }
                    vm.refcolumns[i].groups = getByType(angular.copy(vm.CleanUsersGroups), vm.refcolumns[i].title);
                }

            }
            vm.selectedContent_ref = vm.refcolumns;
            //TODO move to utils directive
            for (var i = 0; i < vm.refcolumns.length; i++) {
                var ref = vm.refcolumns[i];
                ref.preview_sort = parseInt(ref.preview_sort);
            }
            vm.selectedContent_refgrouped = _.groupBy(vm.refcolumns, function (m) {
                return m.preview_position;
            });
        }

        function deleteThread() {

            $mdDialog.show({
                controller: 'DeleteUsersDialogController',
                controllerAs: 'vm',
                locals: {
                    selectedThreads: vm.selectedThreads,
                    section: $scope.section,
                    siteID: $scope.siteID,
                },
                templateUrl: 'app/main/apps/users/dialogs/users/delete-users.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
            }).then(function (deleted) {
                if (deleted) {
                    vm.selectedContentID = '';
                    vm.closeThreadEdit();
                    vm.loadingReadPane = false;
                    vm.selectedContent = undefined;
                    vm.deselectThreads();
                    $rootScope.pagination_resetquery();
                }
            });
        }

        /**
         * New thread
         *
         */
        function newThread() {
            // En la vista Excel no existe el panel de detalle donde se pinta el alta:
            // ahi el alta es la fila borrador de la propia rejilla.
            if (vm.currentView === 'spreadsheet' && vm.gridApi) {
                vm.gridApi.startNewRow();
                return;
            }
            cleanGroupsAsfield();
            if (angular.element(document.getElementById('thread-detail')).length) {
                var elem = angular.element(document.getElementById('thread-detail'));
                elem.scrollTopAnimated(0, 10);
            }

            vm.selectedContentID = '';
            vm.editInline = false;
            vm.loadingReadPane = true;

            $state.go('app.site_overview.users.list.thread', {
                id: ''
            }, {
                notify: false,
                inherit: true,
                location: true
            });

            vm.currentThread = '';
            vm.log = [];

            vm.selectedContent = {};
            refColumnStuff();
            vm.loadingReadPane = false;
            vm.viewEditInline();

            /*
            contentService.getNew(options).then(function (response) {
                vm.selectedContent = {
                    Thumbnail: []
                };
                vm.currentThread = '';
                vm.log = [];

                for (var i = response.ref.length - 1; i >= 0; i--) {
                    if (response.ref[i].type.substr(0, 4) == 'date') {
                        var value = moment().format("YYYY-MM-DD HH:mm:00");

                        var utcDate = moment.utc(value);

                        var siteDate = moment.utc(value).tz(sessionService.site_operative.timezone);

                        vm.selectedContent[response.ref[i].title] = {};
                        vm.selectedContent[response.ref[i].title]['value'] = value;
                        vm.selectedContent[response.ref[i].title]['date'] = new Date(siteDate.format());
                        vm.selectedContent[response.ref[i].title]['dateShow'] = siteDate.format(vm.dateTimeFormat);
                        vm.selectedContent[response.ref[i].title]['utcShow'] = utcDate.format(vm.dateTimeFormat);
                        vm.selectedContent[response.ref[i].title]['utcDate'] = utcDate;
                    }
                }
                vm.selectedContent_ref = response.ref;
                vm.selectedContent_refgrouped = _.groupBy(response.ref, function (m) {
                    return m.preview_position;
                });
                ;

                vm.loadingReadPane = false;
                vm.viewEditInline();
            });*/
        }

        /**
         * Close thread Edit
         */
        function closeThreadEdit() {
            resetScroll();
            vm.editInline = false;
            vm.selectedContent = false;
            vm.currentThread_Edit = false;
            vm.currentThread_ref = false;
            vm.currentThread = false;
            if (vm.selectedContentID === '') {
                vm.closeThread();
            }
        }

        function closeUsers() {
            vm.threads = [];
            vm.selectedContent = false;
            $state.go('app.site_overview.users.groups', {
                type: vm.currentFilter.type,
                filter: vm.currentFilter.filter
            }, { notify: false });
        }

        /**
         * Close thread
         */
        function closeThread() {
            vm.currentThread = null;
            vm.selectedContent = null;
            vm.selectedContentID = null;
            vm.userAuditTrailEvents = null;
            cleanGroupsAsfield();

            // Update the state without reloading the controller
            $state.go('app.site_overview.users.list', {
                type: vm.currentFilter.type,
                filter: vm.currentFilter.filter
            }, { notify: false });
        }

        /**
         * Add label chips
         *
         * @param query
         * @returns {filterFn}
         */
        function labelQuerySearch(query) {
            return query ?
                vm.users.filter(vm.createFilterFor(query)) : [];
        }

        /**
         * Filter for chips
         *
         * @param query
         * @returns {filterFn}
         */
        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(item) {
                if (angular.isUndefined(item.user_name))
                    return false;
                if (!angular.lowercase(item.user_name).indexOf)
                    return false;
                return angular.lowercase(item.user_name).indexOf(lowercaseQuery) >= 0;
            };
        }

        function duplicateUser() {
            for (var i = 0; i < vm.selectedThreads.length; i++) {
                vm.selectedThreads[i].id_user = '';
                delete vm.selectedThreads[i].created_at;
                vm.selectedThreads[i].firstname = vm.selectedThreads[i].firstname + ' Copy';
                saveItem(vm.selectedThreads[i]);
            }
            deselectThreads();
        }

        /**
         * Return checked status of the content
         *
         * @param content
         * @returns {boolean}
         */
        function saveItem(content) {
            var newContent = angular.copy(content);
            
            if (!newContent.id_user) {
                newContent.id_user = '';
            }

            var userParamsObj = {};
            if (vm.selectedContent.user_params) {
                if(typeof vm.selectedContent.user_params != 'object'){
                    var userParamsObj = JSON.parse(vm.selectedContent.user_params);
                    if(typeof userParamsObj != 'object'){
                        var userParamsObj = JSON.parse(userParamsObj);
                    }
                }else{
                    var userParamsObj = vm.selectedContent.user_params;
                }
                if (userParamsObj == null) {
                    userParamsObj = {};
                }
                userParamsObj.usersGroups = {};
                if(newContent.groups && angular.isArray(newContent.groups) && newContent.groups.length > 0){
                    for(var i=0; i<newContent.groups.length; i++){
                        var id_group = newContent.groups[i].id_group;
                        var id_ingroup_status = newContent.groups[i].users_ingroup.id_ingroup_status;
                        userParamsObj.usersGroups[id_group] = id_ingroup_status;
                    }
                }
            }
            for (var i = vm.refcolumns.length - 1; i >= 0; i--) {
                if (vm.refcolumns[i].category == 'json') {
                    if (newContent.hasOwnProperty(vm.refcolumns[i].title)) {
                        userParamsObj[vm.refcolumns[i].title] = newContent[vm.refcolumns[i].title];
                        newContent.user_params = JSON.stringify(userParamsObj);
                        delete newContent[vm.refcolumns[i].title];
                    }
                }
            }
            let selGroup = null;
            if (vm.selectedGroup) {
                selGroup = angular.copy(vm.selectedGroup);
            }
            if (vm.isAccreditations && angular.isArray(vm.selectedGroupsAcc) && vm.selectedGroupsAcc.length > 0) {
                selGroup = angular.copy(vm.selectedGroupsAcc[0]);
            }

            // Automatically add new users to selected group.
            if (selGroup && newContent.id_user == '') {
                var selectedGroupItem = {
                    users_ingroup: {
                        id_user: content.id_user,
                        id_group: selGroup.id_group,
                        id_ingroup_status: selGroup.default_ingroup_status
                    }
                };
                if (newContent.groups && angular.isArray(newContent.groups)) {
                    var containsSelectedGroup = newContent.groups.find(function(userGroup) {
                        return userGroup.id_group == selGroup.id_group;
                    })
                    if (!containsSelectedGroup) {
                        newContent.groups.push(selectedGroupItem)
                    }
                } else {
                    newContent.groups = [selectedGroupItem];
                }
            }
            if(newContent.mailing_priority != vm.selectedContent.mailing_priority){
                var currentPriority = vm.mailingPriority.find(x => x.default == vm.selectedContent.mailing_priority);
                var newPriority = vm.mailingPriority.find(x => x.default == newContent.mailing_priority);
                if(!currentPriority && ( vm.selectedContent.mailing_priority <= newPriority.max && vm.selectedContent.mailing_priority >= newPriority.min)){
                    newContent.mailing_priority = vm.selectedContent.mailing_priority;
                }
            }
            var options = {
                site: $scope.siteID,
                id: content.id_user,
                item: transformUsers.userToDTO(newContent)
            };
            usersService.saveItem(options).then(function (response) {
                updateGrouopsAsField(response.id_user);
                if (content.id_user === '' || content.id_user === undefined) {
                    content.id_user = response.id_user;
                    deselectThreads();
                    $rootScope.pagination_resetquery();
                    vm.viewPreview();
                    vm.openThread(response);
                } else {
                    vm.viewPreview();
                    vm.openThread(response);
                }
                vm.closeThreadEdit();

                var message = $translate.instant('USERS.SAVED');
                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                    hideDelay: 5000,
                    position: 'top',
                    parent: '#content-container'
                });

                return true;
            }, function(error) {
                // Prefer the stable backend code; fall back to the legacy message for safety.
                if (error && (error.code === 'EMAIL_ALREADY_EXISTS' || error.detail === 'The email has already been taken.')) {
                    promptAttachExistingUser(newContent);
                }
            });

        }

        // ============================================================
        //  Vista Excel / edición inline (v2) — helpers de la rejilla
        // ============================================================
        // Reutiliza la misma fontanería que el edit clásico (usersService.saveItem +
        // transformUsers.userToDTO + vm.refcolumns) pero operando POR FILA, sin depender
        // de vm.selectedContent, para poder editar cualquier usuario de la tabla de un
        // vistazo sin seleccionarlo antes.
        // Columnas FIJAS propias de usuarios: "Grupos" al principio y las acciones
        // (borrar) al final, que es donde se esperan.
        vm.gridFixedColumns = [{
            label: 'GROUP.GROUP',
            width: 200,
            cellTemplate: 'app/main/apps/users/views/list/grid-groups-cell.html'
        }, {
            label: 'CONTENT.ROW_ACTIONS',
            width: 96,
            position: 'end',
            cellTemplate: 'app/core/directives/mv-grid/mv-grid-actions-cell.html'
        }];

        /**
         * Borrar un usuario desde la rejilla, con DOBLE confirmación: primero un aviso
         * que dice exactamente a quién se va a borrar, y después el diálogo de borrado
         * normal de usuarios (que es el segundo "¿seguro?" y el que ejecuta el borrado).
         * Se reutiliza ese diálogo a propósito: es la vía de borrado ya probada del
         * módulo, con su toast y su manejo de errores.
         */
        function gridDeleteRow(row, $event) {
            if ($event) { $event.stopPropagation(); }
            if (!row || !row.id_user || row.$deleting) { return; }

            var label = ((row.firstname || '') + ' ' + (row.lastname || '')).trim() ||
                        row.email || ('#' + row.id_user);

            var first = $mdDialog.confirm()
                .title($translate.instant('USERS.SURE_DELETE_SINGULAR'))
                // textContent (no htmlContent): el nombre lo escribe el usuario y no debe
                // interpretarse como HTML.
                .textContent(label)
                .ariaLabel('Delete user')
                .targetEvent($event)
                .ok($translate.instant('USERS.DELETE'))
                .cancel($translate.instant('USERS.CANCEL'));

            $mdDialog.show(first).then(function () {
                row.$deleting = true;
                return $mdDialog.show({
                    controller: 'DeleteUsersDialogController',
                    controllerAs: 'vm',
                    locals: {
                        selectedThreads: [row],
                        section: $scope.section,
                        siteID: $scope.siteID
                    },
                    templateUrl: 'app/main/apps/users/dialogs/users/delete-users.html',
                    parent: angular.element($document.body),
                    clickOutsideToClose: true
                });
            }).then(function (deleted) {
                row.$deleting = false;
                if (deleted) {
                    // Quitamos la fila de la rejilla sin recargar toda la lista.
                    var i = vm.threads.indexOf(row);
                    if (i > -1) { vm.threads.splice(i, 1); }
                }
            }, function () {
                row.$deleting = false;   // cancelado en cualquiera de los dos pasos
            });
        }
        vm.gridDeleteRow = gridDeleteRow;

        /**
         * Duplicar: abre el alta con una copia de los datos, sin crear nada todavia.
         * Se quita el email a proposito (es unico: copiarlo haria fallar el alta siempre)
         * y los grupos, que se asignan desde su modal una vez el usuario existe.
         */
        function gridDuplicateRow(row, $event) {
            if ($event) { $event.stopPropagation(); }
            if (!row || !vm.gridApi) { return; }
            var copy = angular.copy(row);
            delete copy.id_user;
            delete copy.id;
            delete copy.email;
            delete copy.groups;
            angular.forEach(Object.keys(copy), function (k) {
                if (k.charAt(0) === '$') { delete copy[k]; }
            });
            vm.gridApi.startNewRow(copy);
        }
        vm.gridDuplicateRow = gridDuplicateRow;

        // Valores por defecto de la fila nueva. Se deja el estado en "no validado" (1),
        // que es el que aplica el alta normal.
        function gridNewRowDefaults() {
            return { user_status: 1 };
        }
        vm.gridNewRowDefaults = gridNewRowDefaults;

        /**
         * Crear el usuario de la fila borrador. usersService.saveItem crea (POST) cuando
         * el id viene vacio, que es la misma via del alta normal.
         * Devuelve una promesa: si falla, la rejilla deja la fila con lo escrito para
         * poder corregir y reintentar.
         */
        function gridCreateRow(row) {
            var deferred = $q.defer();
            var item = angular.copy(row);
            // Fuera los auxiliares de la rejilla ($isNew, $d_<campo>, etc.).
            angular.forEach(Object.keys(item), function (k) {
                if (k.charAt(0) === '$') { delete item[k]; }
            });

            usersService.saveItem({
                site: $scope.siteID,
                id: '',                       // vacio = alta
                item: transformUsers.userToDTO(item)
            }).then(function (response) {
                var created = JSON.parse(angular.toJson(response));
                // La fila nueva se coloca arriba del listado, ya editable inline.
                if (created && created.id_user) {
                    vm.threads.unshift(created);
                }
                $mdToast.show({
                    template: '<md-toast id="language-message"><span class="md-toast-text" flex>' +
                              $translate.instant('USERS.SAVED') + '</span></md-toast>',
                    hideDelay: 4000, position: 'top right', parent: '#main'
                });
                deferred.resolve(created);
            }, function (error) {
                // El caso tipico: email repetido o invalido. Se avisa y se deja corregir.
                var detail = (error && error.data && error.data.detail) ||
                             (error && error.detail) || null;
                if (detail) { msUtils.showError(detail); }
                deferred.reject(error);
            });

            return deferred.promise;
        }
        vm.gridCreateRow = gridCreateRow;

        // Ancho inicial de una columna cuando users quiere uno distinto del genérico.
        // Devolver null = que decida <mv-grid> por el tipo.
        vm.gridColumnWidth = function (col) {
            return isComplexCell(col) ? 70 : null;
        };

        vm.ensureGridRow = ensureGridRow;
        vm.isComplexCell = isComplexCell;
        vm.cellKind = cellKind;
        vm.cellDisplay = cellDisplay;
        vm.avatarText = avatarText;
        vm.avatarColor = avatarColor;
        vm.gridCountries = gridCountries;
        vm.gridStatesFor = gridStatesFor;
        vm.gridCitiesFor = gridCitiesFor;
        vm.onGridGeoChange = onGridGeoChange;
        vm.onGridDateChange = onGridDateChange;

        // Cambio en un datepicker (fecha editable): serializa el Date a 'YYYY-MM-DD' en
        // row[title] (lo que se guarda) y guarda la fila. Con guard para ignorar el
        // ng-change espurio de md-datepicker al inicializar (mismo valor).
        function onGridDateChange(row, col) {
            var d = row['$d_' + col.title];
            var newVal = (d instanceof Date && !isNaN(d.getTime())) ? moment(d).format('YYYY-MM-DD') : '';
            if (String(row[col.title] == null ? '' : row[col.title]) === newVal) {
                return; // sin cambio real
            }
            row[col.title] = newVal;
            saveRow(row);
        }

        // Opciones del estado de usuario (tipo user_status). Valores canónicos y sus
        // etiquetas i18n, iguales que la vista de tabla/blacklist.
        vm.userStatusOptions = [
            { value: 0,  label: 'USERS.STATUS_NAMES.DISABLED',      dot: '#F44336' },
            { value: 1,  label: 'USERS.STATUS_NAMES.NOT_VALIDATED', dot: '#FFB300' },
            { value: 2,  label: 'USERS.STATUS_NAMES.VALIDATED',     dot: '#4CAF50' },
            { value: 99, label: 'USERS.STATUS_NAMES.BLOCKED',       dot: '#212121' }
        ];

        // ---- Desplegables dependientes country -> state -> city (cascada) ----
        // Countries: lista global (una carga). States: por país (API, cacheados por país).
        // Cities: anidadas dentro de cada state ya cargado. Se devuelven referencias
        // ESTABLES (misma array) para no romper ng-repeat en cada digest.
        var GRID_GEO_EMPTY = [];
        vm.gridStatesCache = {};      // countryId -> [ {id, code, name, cities} ]
        vm.gridStatesLoading = {};    // countryId -> true mientras carga

        function gridCountries() {
            if (angular.isUndefined(vm.countriesWithStates)) {
                getCountriesWithStates();
            }
            return vm.countriesWithStates || GRID_GEO_EMPTY;
        }

        function gridStatesFor(countryId) {
            if (!countryId) return GRID_GEO_EMPTY;
            if (vm.gridStatesCache[countryId]) return vm.gridStatesCache[countryId];
            if (!vm.gridStatesLoading[countryId]) {
                vm.gridStatesLoading[countryId] = true;
                usersService.getStatesWithCities({ paginate: 99999, resultsPerPage: 99999, id_country: countryId })
                    .then(function (response) {
                        var list = [];
                        if (response && response.total) {
                            angular.forEach(response.data, function (item) {
                                list.push({ id: item.id_state, code: item.code, name: item.state, cities: item.cities });
                            });
                        }
                        vm.gridStatesCache[countryId] = list;
                    });
            }
            return GRID_GEO_EMPTY;
        }

        function gridCitiesFor(countryId, stateId) {
            if (!countryId || !stateId) return GRID_GEO_EMPTY;
            var states = vm.gridStatesCache[countryId];
            if (!states) { gridStatesFor(countryId); return GRID_GEO_EMPTY; }
            for (var i = 0; i < states.length; i++) {
                if (states[i].id == stateId) { return states[i].cities || GRID_GEO_EMPTY; }
            }
            return GRID_GEO_EMPTY;
        }

        // Al cambiar un nivel se invalidan los inferiores (país->limpia estado+ciudad,
        // estado->limpia ciudad) y se guarda la fila.
        function onGridGeoChange(row, level) {
            // md-select dispara ng-change también al "reconciliar" el valor cuando llegan
            // sus opciones async (aunque el valor NO cambie). Si no filtramos eso, el país
            // dispararía un cambio falso al recargar y borraría state/city. Solo actuamos
            // ante un cambio REAL comparando con el valor anterior (normalizado string).
            if (!row.$geoPrev) {
                row.$geoPrev = { country: row.country, state: row.state, city: row.city };
            }
            var norm = function (v) { return (v === null || v === undefined) ? '' : String(v); };
            if (norm(row[level]) === norm(row.$geoPrev[level])) {
                return; // sin cambio real -> no tocar dependientes ni guardar
            }
            row.$geoPrev[level] = row[level];
            if (level === 'country') {
                row.state = ''; row.city = '';
                row.$geoPrev.state = ''; row.$geoPrev.city = '';
            } else if (level === 'state') {
                row.city = '';
                row.$geoPrev.city = '';
            }
            saveRow(row);
        }
        vm.saveRow = saveRow;
        vm.editComplexCell = editComplexCell;
        vm.editRowGroups = editRowGroups;

        // Abre el modal de gestión de grupos del usuario de esa fila. Al cerrarse con
        // guardado, el diálogo ya ha actualizado row.groups (por referencia).
        function editRowGroups(row, $event) {
            if ($event) { $event.stopPropagation(); }
            // Los grupos se asignan a un usuario existente: en la fila de alta no aplica.
            if (!row || !row.id_user) { return; }
            // El árbol de grupos puede no estar cargado aún: si falta, lo cargamos y
            // esperamos ANTES de abrir el diálogo (getCleanUsersGroup es asíncrono).
            var ready = angular.isUndefined(vm.CleanUsersGroups)
                ? $q.when(getCleanUsersGroup())
                : $q.when();
            ready.then(function () {
                $mdDialog.show({
                    controller: 'GridGroupsDialogController',
                    controllerAs: 'vm',
                    locals: {
                        user: row,
                        siteID: $scope.siteID,
                        CleanUsersGroups: vm.CleanUsersGroups,
                        ingroupStatus: vm.ingroupStatus
                    },
                    templateUrl: 'app/main/apps/users/dialogs/grid-groups/grid-groups.html',
                    parent: angular.element($document.body),
                    targetEvent: $event,
                    clickOutsideToClose: true
                });
            });
        }

        // Devuelve el tipo de editor de una celda como un único string, para poder
        // usar ng-switch en la plantilla (más robusto que encadenar ng-if con
        // col.type.indexOf(...), que peta si col.type viene undefined).
        function cellKind(col) {
            if (!col) return 'text';
            if (isComplexCell(col)) return 'complex';
            var t = col.type || '';
            // Avatar / imagen: se muestra como círculo con inicial (no editable).
            if (t === 'thumbnail' || t.indexOf('thumbnail') === 0 || t === 'media' || col.title === 'media') return 'avatar';
            // Campos NO editables (ID, fechas automáticas, in group status, etc.): solo
            // lectura. Se decide por edit_editable de users_ref (0 / '' = no editable).
            if (!isFieldEditable(col)) return 'readonly';
            // Geo en cascada: desplegables con buscador y dependientes (país->estado->ciudad).
            if (t === 'country') return 'country';
            if (t === 'state') return 'state';
            if (t === 'city') return 'city';
            // Estado de usuario (valores 0/1/2/99): desplegable con etiquetas.
            if (t === 'user_status') return 'userstatus';
            if (t === 'status' || t === 'onoff') return 'checkbox';
            // Fecha EDITABLE (las readonly ya salieron arriba): datepicker.
            if (t === 'date' || t === 'dateHm' || t.indexOf('datetime') === 0) return 'date';
            if (t === 'language') return 'language';
            if (col.category === 'input_related') return 'related';
            // Fechas: como texto editable (md-datepicker exige un Date real y rompía la fila).
            if (t === 'text') return 'textarea';
            if (t === 'password') return 'password';
            return 'text';
        }

        // Un campo es editable inline solo si users_ref no lo marca como no editable.
        // El ID nunca es editable. edit_editable === 0 / '' => bloqueado; NULL/1 => editable
        // (permisivo, para no bloquear campos que un tenant deje sin configurar).
        function isFieldEditable(col) {
            if (!col) return false;
            if (col.type === 'id') return false;
            var e = col.edit_editable;
            if (e === 0 || e === '0' || e === '') return false;
            return true;
        }

        // Texto a mostrar en una celda de solo lectura (ID con prefijo #, sin objetos crudos).
        function cellDisplay(row, col) {
            if (!row || !col) return '';
            var v = row[col.title];
            if (col.type === 'id') return (v || v === 0) ? '#' + v : '';
            if (v == null || typeof v === 'object') return '';
            return v;
        }

        // Inicial y color del avatar (círculo tipo vista de tabla) a partir de la fila.
        function avatarText(row) {
            if (!row) return '?';
            var s = (row.firstname || row.lastname || row.name || row.email || '').toString().trim();
            return s ? s.charAt(0).toUpperCase() : '?';
        }
        var AVATAR_PALETTE = ['#F44336', '#E91E63', '#9C27B0', '#673AB7', '#3F51B5',
                              '#2196F3', '#009688', '#4CAF50', '#FF9800', '#795548', '#607D8B'];
        function avatarColor(row) {
            var id = (row && parseInt(row.id_user, 10)) || 0;
            return AVATAR_PALETTE[id % AVATAR_PALETTE.length];
        }

        // Columnas de datos de la rejilla (todas las refcolumns salvo las estructurales
        // 'label'). El ORDEN, los anchos y su persistencia los gestiona <mv-grid>; aquí
        // solo se necesita la lista para preparar cada fila (ensureGridRow).
        function gridDataColumns() {
            if (!vm.refcolumns) return [];
            return vm.refcolumns.filter(function (c) { return c && c.type !== 'label'; });
        }

        // Un campo es "complejo" (no editable inline en una celda) si representa grupos
        // o ficheros: se edita en su propio editor, no con un input suelto.
        function isComplexCell(col) {
            if (!col) return false;
            if (col.category === 'show_groups_as_field' || col.category === 'show_groups_inprofile') return true;
            if (col.type === 'files') return true;
            return false;
        }

        // Expande una fila para la rejilla UNA sola vez: saca los campos 'json' de
        // user_params a columnas propias y envuelve los datetime/date igual que hace
        // refColumnStuff() con selectedContent, para que el binding inline funcione y
        // el guardado (saveRow) sea simétrico.
        function ensureGridRow(row) {
            if (!row || row.$gridExpanded) return;
            var cols = gridDataColumns();
            for (var i = 0; i < cols.length; i++) {
                var col = cols[i];
                if (col.category === 'json') {
                    var value = '';
                    if (row.user_params && row.user_params !== 'null') {
                        var up = row.user_params;
                        if (typeof up === 'string') {
                            try { up = JSON.parse(up); } catch (e) { up = {}; }
                        }
                        if (up && typeof up === 'object' && up.hasOwnProperty(col.title)) {
                            value = up[col.title];
                        }
                    }
                    row[col.title] = value;
                }
                if (col.type) {
                    // Fechas/fechas-hora: se dejan como STRING formateado legible (la rejilla
                    // las edita como texto). Envuelto en try/catch para que un valor raro nunca
                    // rompa el pintado de la fila.
                    if (col.type.substr(0, 8) === 'datetime' || col.type.substr(0, 4) === 'date') {
                        try {
                            var raw = row[col.title];
                            if (raw && raw !== '0000-00-00 00:00:00' && typeof raw !== 'object') {
                                var isDatetime = col.type.substr(0, 8) === 'datetime';
                                var fmt = isDatetime ? (vm.dateTimeFormat || 'YYYY-MM-DD HH:mm') : 'YYYY-MM-DD';
                                if (!isDatetime && col.type.split('-')[1]) { fmt = col.type.split('-')[1]; }
                                var m = moment.utc(raw);
                                if (m.isValid()) {
                                    var tz = sessionService.site_operative && sessionService.site_operative.timezone;
                                    row[col.title] = (tz ? m.tz(tz) : m).format(fmt);
                                }
                            }
                            // Para fechas EDITABLES (datepicker), guardamos un objeto Date
                            // aparte ($d_<title>). md-datepicker exige un Date; el string se
                            // mantiene en row[title] para el guardado.
                            if (isFieldEditable(col)) {
                                var dv = row[col.title];
                                var md = (dv && typeof dv === 'string') ? moment(dv, 'YYYY-MM-DD') : null;
                                row['$d_' + col.title] = (md && md.isValid()) ? md.toDate() : null;
                            }
                        } catch (e) { /* dejar el valor tal cual */ }
                    } else if (col.type === 'files') {
                        if (row.files && typeof row.files === 'string') {
                            try { row.files = JSON.parse(row.files); } catch (e) {}
                        }
                    }
                }
            }
            // Si la fila ya trae país, precargamos sus estados/ciudades para que los
            // desplegables muestren el NOMBRE del estado/ciudad (no solo el id).
            if (row.country) { gridStatesFor(row.country); }
            // Línea base de geo para distinguir cambios reales de la reconciliación de
            // md-select al cargar sus opciones (ver onGridGeoChange).
            row.$geoPrev = { country: row.country, state: row.state, city: row.city };
            row.$gridExpanded = true;
            // El listado general (getUsers) NO trae los grupos del usuario; los cargamos
            // aquí por fila para pintar los chips de la columna Grupos.
            ensureRowGroups(row);
        }

        // --- Carga LAZY de grupos por fila -------------------------------------------
        // getUsers (vista "todos los usuarios") no incluye los grupos de cada usuario;
        // solo la vista filtrada por grupo los trae. Como no podemos tocar qiu-api, los
        // pedimos uno a uno con getUserByID (endpoint show, que sí devuelve .groups),
        // con un tope de concurrencia para no saturar en tenants grandes. Solo se hace
        // en la rejilla (ensureGridRow) y una vez por fila.
        var gridGroupsQueue = [];
        var gridGroupsActive = 0;
        var GRID_GROUPS_CONCURRENCY = 5;

        function ensureRowGroups(row) {
            if (!row || !row.id_user) return;
            // Si ya trae grupos (p.ej. vista por grupo) o ya se están cargando, nada.
            if (angular.isDefined(row.groups) || row.$groupsLoading) return;
            row.$groupsLoading = true;
            gridGroupsQueue.push(row);
            pumpGridGroupsQueue();
        }

        function pumpGridGroupsQueue() {
            while (gridGroupsActive < GRID_GROUPS_CONCURRENCY && gridGroupsQueue.length) {
                gridGroupsActive++;
                (function (r) {
                    usersService.getUserByID({ site: $scope.siteID, id: r.id_user }).then(function (resp) {
                        var fresh = JSON.parse(angular.toJson(resp));
                        // OJO: solo mezclamos los grupos; NO pisamos el resto de campos de
                        // la fila (el usuario puede estar editándolos en la rejilla).
                        r.groups = fresh.groups || [];
                    }, function () {
                        r.groups = r.groups || [];
                    })['finally'](function () {
                        r.$groupsLoading = false;
                        gridGroupsActive--;
                        pumpGridGroupsQueue();
                    });
                })(gridGroupsQueue.shift());
            }
        }

        // Guardado por fila con debounce. Colapsa los campos 'json' de vuelta a
        // user_params (simétrico a ensureGridRow) y reutiliza usersService.saveItem.
        var gridSaveTimers = {};
        function saveRow(row) {
            if (!row || !row.id_user) return;
            if (gridSaveTimers[row.id_user]) { $timeout.cancel(gridSaveTimers[row.id_user]); }
            row.$saveError = false;
            row.$saving = true;
            gridSaveTimers[row.id_user] = $timeout(function () {
                doSaveRow(row);
            }, 600);
        }

        function doSaveRow(row) {
            var newContent = angular.copy(row);
            delete newContent.$gridExpanded;
            delete newContent.$saving;
            delete newContent.$saved;
            delete newContent.$saveError;

            var userParamsObj = {};
            if (row.user_params) {
                if (typeof row.user_params !== 'object') {
                    try { userParamsObj = JSON.parse(row.user_params); } catch (e) { userParamsObj = {}; }
                    if (typeof userParamsObj !== 'object' || userParamsObj === null) { userParamsObj = {}; }
                } else {
                    userParamsObj = angular.copy(row.user_params) || {};
                }
            }
            for (var i = vm.refcolumns.length - 1; i >= 0; i--) {
                if (vm.refcolumns[i].category === 'json') {
                    var title = vm.refcolumns[i].title;
                    if (newContent.hasOwnProperty(title)) {
                        userParamsObj[title] = newContent[title];
                        newContent.user_params = JSON.stringify(userParamsObj);
                        delete newContent[title];
                    }
                }
            }

            var options = {
                site: $scope.siteID,
                id: row.id_user,
                item: transformUsers.userToDTO(newContent)
            };
            usersService.saveItem(options).then(function (response) {
                row.$saving = false;
                row.$saved = true;
                $timeout(function () { row.$saved = false; }, 1500);
            }, function (error) {
                row.$saving = false;
                row.$saveError = true;
            });
        }

        // Campos complejos (grupos, ficheros): abre el editor completo de ESA fila
        // reutilizando el flujo probado (openThread), sin que el operador tenga que
        // seleccionar el usuario primero. El modal dedicado por celda es un pulido posterior.
        function editComplexCell(row, col, $event) {
            if ($event) { $event.stopPropagation(); }
            openThread(row);
        }

        // When a create fails because the email already belongs to an existing user (often one
        // outside the operator's visible scope), offer to attach that user to the selected group(s)
        // instead. The backend modifies no existing user data and preserves other memberships.
        function promptAttachExistingUser(newContent) {
            var attachGroups = [];
            if (newContent.groups && angular.isArray(newContent.groups)) {
                newContent.groups.forEach(function (g) {
                    var idGroup = (g.users_ingroup && g.users_ingroup.id_group) || g.id_group;
                    if (!idGroup) {
                        return;
                    }
                    var status = null;
                    if (g.users_ingroup && typeof g.users_ingroup.id_ingroup_status !== 'undefined') {
                        status = g.users_ingroup.id_ingroup_status;
                    } else if (typeof g.id_ingroup_status !== 'undefined') {
                        status = g.id_ingroup_status;
                    }
                    attachGroups.push({ id_group: idGroup, id_ingroup_status: status });
                });
            }

            // No group selected: nothing to attach to, fall back to the plain notice.
            if (attachGroups.length === 0) {
                msUtils.showError($translate.instant('USERS.ERRORS.EMAIL_EXISTS'));
                return;
            }

            var confirm = $mdDialog.confirm()
                .title($translate.instant('USERS.EXISTING_USER_ATTACH_TITLE'))
                .textContent($translate.instant('USERS.EXISTING_USER_ATTACH_BODY'))
                .ariaLabel($translate.instant('USERS.EXISTING_USER_ATTACH_TITLE'))
                .ok($translate.instant('USERS.EXISTING_USER_ATTACH_OK'))
                .cancel($translate.instant('CANCEL'));

            $mdDialog.show(confirm).then(function () {
                usersService.attachExistingUserByEmail({
                    siteID: $scope.siteID,
                    data: {
                        email: newContent.email,
                        groups: attachGroups
                    }
                }).then(function (response) {
                    deselectThreads();
                    $rootScope.pagination_resetquery();
                    vm.viewPreview();
                    vm.openThread(response);
                    vm.closeThreadEdit();

                    var message = $translate.instant('USERS.EXISTING_USER_ATTACHED');
                    $mdToast.show({
                        template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                        hideDelay: 5000,
                        position: 'top',
                        parent: '#content-container'
                    });
                }, function () {
                    msUtils.showError($translate.instant('USERS.ERRORS.EXISTING_USER_ATTACH_FAILED'));
                });
            }, function () {
                // Operator cancelled - surface the original notice so they know nothing happened.
                msUtils.showError($translate.instant('USERS.ERRORS.EMAIL_EXISTS'));
            });
        }

        function findInTree(tree, id) {
            var result = tree.find(x => x.id_group == id);
            if (!result) {
                for (let i = 0; i < tree.length; i++) {
                    result = findInTree(tree[i].children, id);
                    if (result) {
                        return result;
                    }
                }
            }
            return result;
        }

        function updateGrouopsAsField(id_user) {
            var groupsToAdd = [];
            var groupsToRemove = [];
            var ref_group_as_field = vm.currentThread_ref.filter(x => x.category == 'show_groups_as_field');
            if (ref_group_as_field && ref_group_as_field.length > 0) {
                for (let i = 0; i < ref_group_as_field.length; i++) {
                    const element = ref_group_as_field[i];
                    for (let j = 0; j < element.model.length; j++) {
                        const element2 = element.model[j];
                        var found = vm.selectedContent.groups ? vm.selectedContent.groups.find(x => x.id_group == element2) : null;
                        if (!found) {
                            var group = findInTree(element.groups_as_field, element2);
                            groupsToAdd.push({ id_group: group.id_group });
                        }
                    }
                    var groupsSelection = getFlatGroups(vm.allGroups.filter(x => element.groups_as_field.find(y => y.id_group == x.id_group)), []);
                    for (let i = 0; i < groupsSelection.length; i++) {
                        const element2 = groupsSelection[i];
                        var found = element.model.find(x => x == element2.id_group);
                        var foundInUser = vm.selectedContent.groups ? vm.selectedContent.groups.find(x => x.id_group == element2.id_group) : null;
                        if (!found && foundInUser) {
                            var group = findInTree(element.groups_as_field, element2.id_group);
                            groupsToRemove.push({ id_group: group.id_group });
                        }
                    }

                }
            }
            if (groupsToAdd.length > 0) {
                addGroup(id_user, groupsToAdd, false);
            }
            if (groupsToRemove.length > 0) {
                for (let i = 0; i < groupsToRemove.length; i++) {
                    removeGroup(groupsToRemove[i].id_group, vm.selectedContent.id_user);
                }
            }
        }

        /**
         * Return checked status of the content
         *
         * @param content
         * @returns {boolean}
         */
        function massActions(action) {

            if (vm.selectedThreads.length === 0) return false;
            var selectedIds = [];

            for (var i = 0; i < vm.selectedThreads.length; i++) {
                selectedIds.push(vm.selectedThreads[i].id);
            }
            switch (action) {
                case 'delete':
                    if (selectedIds.length == 1) {
                        var messageConfirm = $translate.instant('CONTENT.SURE_DELETED_SINGULAR');

                        var confirm = $mdDialog.confirm().title(messageConfirm).htmlContent('<b>This item will be deleted</b>.')
                            // .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' will be deleted.')
                            .ariaLabel('Delete item').targetEvent(event).ok('OK').cancel('CANCEL');
                        var message = $translate.instant('CONTENT.DELETED');
                    } else {
                        var messageConfirm = $translate.instant('CONTENT.SURE_DELETED_PLURAL');

                        var confirm = $mdDialog.confirm().title(messageConfirm).htmlContent('<b>This items will be deleted</b>.')
                            // .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' will be deleted.')
                            .ariaLabel('Delete item').targetEvent(event).ok('OK').cancel('CANCEL');
                        var message = $translate.instant('CONTENT.DELETED');
                    }
                    break;
                case 'duplicate':
                    if (selectedIds.length == 1) {
                        var confirm = $mdDialog.confirm().title(messageConfirm).htmlContent('<b>This item will be duplicated</b>.')
                            // .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' will be deleted.')
                            .ariaLabel('Duplicate item').targetEvent(event).ok('OK').cancel('CANCEL');
                        var message = $translate.instant('CONTENT.DUPLICATED');
                    } else {
                        var confirm = $mdDialog.confirm().title(messageConfirm).htmlContent('<b>This items will be duplicated</b>.')
                            // .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' will be deleted.')
                            .ariaLabel('Duplicate item').targetEvent(event).ok('OK').cancel('CANCEL');
                        var message = $translate.instant('CONTENT.DUPLICATED');
                    }
                    break;
            }


            /*
            $mdDialog.show(confirm).then(function () {

                var options = {
                    site   : $scope.siteID,
                    section: $scope.section,
                    action : action,
                    item   : selectedIds
                };

                usersService.massActions(options).then(function (response) {
                    vm.toggleSelectThreads();
                    $rootScope.pagination_resetquery();
                    vm.closeThread();
                    $mdToast.show({
                        template : '<md-toast id="language-message"><span class="md-toast-text" flex>' + message + '</span><md-button ng-click="closeToast()">X</md-button></md-toast>',
                        hideDelay: 7000,
                        position : 'top right',
                        parent   : '#main'
                    });
                });
            });*/

        }

        $scope.closeToast = function () {
            if (isDlgOpen)
                return;

            $mdToast.hide().then(function () {
                isDlgOpen = false;
            });
        };

        /**
         * Return selected status of the thread
         *
         * @param thread
         * @returns {boolean}
         */
        /*function isSelected(thread) {
            return vm.selectedThreads.indexOf(thread) > -1;
        }*/
        function isSelected(thread) {
            return sharedFunctionsMailing.isSelected(vm.selectedThreads, thread);
        }

        /**
         * Toggle selected status of the thread
         *
         * @param thread
         * @param event
         */
        /*function toggleSelectThread(thread, event) {
            if (event) {
                event.stopPropagation();
            }

            if (vm.selectedThreads.indexOf(thread) > -1) {
                vm.selectedThreads.splice(vm.selectedThreads.indexOf(thread), 1);
            } else {
                vm.selectedThreads.push(thread);
            }
        }*/
        function toggleSelectThread(thread, event) {
            vm.selectedThreads = sharedFunctionsMailing.toggleSelectThread(vm.selectedThreads, thread, event);
        }

        /**
         * Select threads. If key/value pair given,
         * threads will be tested against them.
         *
         * @param [key]
         * @param [value]
         */
        function selectThreads(key, value) {
            // Make sure the current selection is cleared
            // before trying to select new threads
            vm.selectedThreads = [];

            for (var i = 0; i < vm.threads.length; i++) {
                if (angular.isUndefined(key) && angular.isUndefined(value)) {
                    vm.selectedThreads.push(vm.threads[i]);
                    continue;
                }

                if (angular.isDefined(key) && angular.isDefined(value) && vm.threads[i][key] === value) {
                    vm.selectedThreads.push(vm.threads[i]);
                }
            }
        }

        function toggleSelectGroups() {
            //vm.selectedGroups = sharedFunctionsMailing.toggleSelectThreads(vm.selectedGroups, vm.groups);
            if (vm.selectedGroups == []) {
                ivhTreeviewMgr.selectAll(vm.CleanUsersGroups);
                vm.selectedGroups = vm.CleanUsersGroups;
            } else {
                ivhTreeviewMgr.deselectAll(vm.CleanUsersGroups);
                vm.selectedGroups = [];
            }
        }

        function toggleSelectGroup(group, event) {
            if (vm.selectedGroups) {
                vm.selectedGroups = sharedFunctionsMailing.toggleSelectThread(vm.selectedGroups, group, event);
            }
        }

        function selectGroups(key, value) {
            // Make sure the current selection is cleared
            // before trying to select new threads
            vm.selectedGroups = [];

            for (var i = 0; i < vm.threads.length; i++) {
                if (angular.isUndefined(key) && angular.isUndefined(value)) {
                    vm.selectedGroups.push(vm.threads[i]);
                    continue;
                }

                if (angular.isDefined(key) && angular.isDefined(value) && vm.threads[i][key] === value) {
                    vm.selectedGroups.push(vm.threads[i]);
                }
            }
        }

        /**
         * Deselect threads
         */
        function updateThread(itemThread) {
            for (var i = 0; i < vm.threads.length; i++) {
                if (vm.threads[i]['id_user'] == itemThread['id_user']) {
                    vm.threads[i] = itemThread;
                }
                // if (angular.isUndefined(key) && angular.isUndefined(value)) {
                // 	vm.selectedThreads.push(vm.threads[i]);
                // 	continue;
                // }

                // if (angular.isDefined(key) && angular.isDefined(value) && vm.threads[i][key] === value) {
                // 	vm.selectedThreads.push(vm.threads[i]);
                // }
            }
        }

        /**
         * Deselect threads
         */
        /*function deselectThreads() {
            vm.selectedThreads = [];
        }*/
        function deselectThreads() {
            vm.selectedThreads = sharedFunctionsMailing.deselectThreads();
        }

        /**
         * Toggle select threads
         */
        /*function toggleSelectThreads() {
            if (vm.selectedThreads.length > 0) {
                vm.deselectThreads();
            } else {
                vm.selectThreads();
            }
        }*/
        function toggleSelectThreads() {
            vm.selectedThreads = sharedFunctionsMailing.toggleSelectThreads(vm.selectedThreads, vm.threads);
        }

        function toggleSelectAllThreads() {

        }

        /**
         * Set the status on given thread, current thread or selected threads
         *
         * @param key
         * @param value
         * @param [thread]
         * @param [event]
         */
        function setThreadStatus(key, value, thread, event) {
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if (event) {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if (thread) {
                thread[key] = value;
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if (vm.currentThread) {
                vm.currentThread[key] = value;
                return;
            }

            // Otherwise do the status update on selected threads
            for (var x = 0; x < vm.selectedThreads.length; x++) {
                vm.selectedThreads[x][key] = value;
            }
        }

        /**
         * Toggle the value of the given key on given thread, current
         * thread or selected threads. Given key value must be boolean.
         *
         * @param key
         * @param thread
         * @param event
         */
        function toggleItemStatus(thread, event, key) {

            event.stopPropagation();

            var confirm = $mdDialog.confirm().title('Are you sure want to set the item?').htmlContent('<b>This item will be changed </b>.')
                // .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' will be deleted.')
                .ariaLabel('change item').targetEvent(event).ok('OK').cancel('CANCEL');

            $mdDialog.show(confirm).then(function () {

                switch (thread.status) {
                    case 0:
                        thread.status = 1;
                        break;
                    case 1:
                        thread.status = 2;
                        break;
                    case 2:
                        thread.status = 99;
                        break;
                    case 99:
                        thread.status = 0;
                        break;
                    default:
                        thread.status = 0;
                        break;
                }


                var options = {
                    site: $scope.siteID,
                    id: thread.id_user,
                    item: transformUsers.userToDTO(thread)
                };


                usersService.saveItem(options).then(function (response) {
                    // vm.viewPreview();
                    // vm.selectContent(content);
                    var message = "Saved";

                    $mdToast.show({
                        template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                        hideDelay: 5000,
                        position: 'top',
                        parent: '#content-container'
                    });

                    return true;
                });

            }, function () {
                // alert("cancel")

            });

            return;
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if (event) {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if (thread) {
                if (typeof (thread[key]) !== 'boolean') {
                    return;
                }

                thread[key] = !thread[key];
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if (vm.currentThread) {
                if (typeof (vm.currentThread[key]) !== 'boolean') {
                    return;
                }

                vm.currentThread[key] = !vm.currentThread[key];
                return;
            }

            // Otherwise do the status update on selected threads
            for (var x = 0; x < vm.selectedThreads.length; x++) {
                if (typeof (vm.selectedThreads[x][key]) !== 'boolean') {
                    continue;
                }

                vm.selectedThreads[x][key] = !vm.selectedThreads[x][key];
            }
        }

        /**
         * Toggle the value of the given key on given thread, current
         * thread or selected threads. Given key value must be boolean.
         *
         * @param key
         * @param thread
         * @param event
         */
        function toggleItemStatusEdit(fieldName) {

            event.stopPropagation();
            var thread = vm.currentThread_Edit[fieldName];
            thread = (thread === 1) ?
                0 :
                1;

            vm.currentThread_Edit[fieldName] = thread;
            vm.basicForm.$setDirty()
        }

        function deleteAttachment(attachment) {

            if (attachment.id_zone) {
                for (var i = 0; i < vm.currentThread_Edit.Thumbnail.length; i++) {
                    if (vm.currentThread_Edit.Thumbnail[i].id_media === attachment.id_media && vm.currentThread_Edit.Thumbnail[i].id_zone === attachment.id_zone) {
                        if (angular.isUndefined(vm.currentThread_Edit.ThumbnailRemove))
                            vm.currentThread_Edit.ThumbnailRemove = [];
                        vm.currentThread_Edit.ThumbnailRemove.push(vm.currentThread_Edit.Thumbnail[i]);
                        vm.currentThread_Edit.Thumbnail.splice(i, 1);
                    }
                }

                for (var i = 0; i < vm.thumbnails_Edit[attachment.id_zone].length; i++) {
                    if (vm.thumbnails_Edit[attachment.id_zone][i].id_media === attachment.id_media) {
                        vm.thumbnails_Edit[attachment.id_zone].splice(i, 1);
                    }
                }

            } else {
                if (vm.currentThread_Edit.Thumbnail[i].id_media === attachment.id_media) {
                    if (angular.isUndefined(vm.currentThread_Edit.ThumbnailRemove))
                        vm.currentThread_Edit.ThumbnailRemove = [];
                    vm.currentThread_Edit.ThumbnailRemove.push(vm.currentThread_Edit.Thumbnail[i]);
                    vm.currentThread_Edit.Thumbnail.splice(i, 1);
                }
            }
            vm.basicForm.$setDirty()

        }

        /**
         * Toggle the value of the given key on given thread, current
         * thread or selected threads. Given key value must be boolean.
         *
         * @param key
         * @param thread
         * @param event
         */
        function toggleThreadStatus(key, thread, event) {
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if (event) {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if (thread) {
                if (typeof (thread[key]) !== 'boolean') {
                    return;
                }

                thread[key] = !thread[key];
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if (vm.currentThread) {
                if (typeof (vm.currentThread[key]) !== 'boolean') {
                    return;
                }

                vm.currentThread[key] = !vm.currentThread[key];
                return;
            }

            // Otherwise do the status update on selected threads
            for (var x = 0; x < vm.selectedThreads.length; x++) {
                if (typeof (vm.selectedThreads[x][key]) !== 'boolean') {
                    continue;
                }

                vm.selectedThreads[x][key] = !vm.selectedThreads[x][key];
            }
        }

        /**
         * Get label object content
         *
         * @param id
         * @returns {*}
         */
        function getLabel(id) {
            for (var i = 0; i < vm.labels.length; i++) {
                if (vm.labels[i].id === id) {
                    return vm.labels[i];
                }
            }
        }

        /**
         * Get label color from label object
         *
         * @param id
         * @returns {*}
         */
        function getLabelColor(id) {
            return vm.getLabel(id).color;
        }

        /**
         * Get label title from label object
         *
         * @param id
         * @returns {*}
         */
        function getLabelTitle(id) {
            return vm.getLabel(id).title;
        }

        /**
         * Toggle label
         *
         * @param label
         */
        function toggleLabel(label) {
            // Toggle label on the currently open thread
            if (vm.currentThread) {
                if (vm.currentThread.labels.indexOf(label.id) > -1) {
                    vm.currentThread.labels.splice(vm.currentThread.labels.indexOf(label.id), 1);
                } else {
                    vm.currentThread.labels.push(label.id);
                }

                return;
            }

            // Toggle labels on selected threads
            // Toggle action will be determined by the first thread from the selection.
            if (vm.selectedThreads.length > 0) {
                // Decide if we are going to remove or add labels
                var removeLabels = (vm.selectedThreads[0].labels.indexOf(label.id) > -1);

                for (var i = 0; i < vm.selectedThreads.length; i++) {
                    if (!removeLabels) {
                        vm.selectedThreads[i].labels.push(label.id);
                        continue;
                    }

                    if (vm.selectedThreads[i].labels.indexOf(label.id) > -1) {
                        vm.selectedThreads[i].labels.splice(vm.selectedThreads[i].labels.indexOf(label.id), 1);
                    }
                }
            }
        }

        /**
         * Is label exist?
         *
         * @param label
         * @returns {boolean}
         */
        function isLabelExist(label) {
            if (vm.currentThread && vm.currentThread.labels) {
                return (vm.currentThread.labels.indexOf(label.id) > -1);
            }
        }

        /**
         * Change the view
         *
         * @param view
         */
        function changeView(view) {
            if (vm.views[view]) {
                settingUserService.setSetting(vm.settingsSection, 'defaultView', view)
                vm.loadingView = true;
                vm.defaultView = view;
                vm.currentView = view;
                vm.closeThread();
                vm.closeThreadEdit();

            }
        }

        function orderRefFields() {
            var header = [];
            var main = [];
            var secondary = [];

            for (var i = 0; i < vm.currentThread_ref.length; i++) {
                if (vm.currentThread_ref[i].edit_position === 'header') {
                    header.push(vm.currentThread_ref[i]);
                } else if (vm.currentThread_ref[i].edit_position === 'main') {
                    main.push(vm.currentThread_ref[i]);
                } else if (vm.currentThread_ref[i].edit_position === 'secondary') {
                    secondary.push(vm.currentThread_ref[i]);
                }
            }


            header.sort(function (a, b) {
                return (a.edit_sort - b.edit_sort);
            });

            main.sort(function (a, b) {
                return (a.edit_sort - b.edit_sort);
            });

            secondary.sort(function (a, b) {
                return (a.edit_sort - b.edit_sort);
            });

            vm.currentThread_ref = [];

            for (var i = 0; i < header.length; i++) {
                vm.currentThread_ref.push(header[i]);
            }
            for (var i = 0; i < main.length; i++) {
                vm.currentThread_ref.push(main[i]);
            }
            for (var i = 0; i < secondary.length; i++) {
                vm.currentThread_ref.push(secondary[i]);
            }
        }

        /**
         * Toggle view Edit
         */
        function viewEditInline() {
            resetScroll();
            vm.currentTab = 'edit';
            if (!vm.editInline) {
                vm.editInline = true;
                vm.currentThread_Edit = angular.copy(vm.selectedContent);
                getCurrentLabelsEdit();
                if (vm.selectedContent_ref) {
                    vm.currentThread_ref = angular.copy(vm.selectedContent_ref);
                    orderRefFields();
                }
                angular.forEach(vm.selectedContent_ref, function (refColumn) {
                    switch (refColumn.type) {
                        case 'date':
                        case 'dateHm':
                            var type = 'input';
                            break;
                        case 'single':
                            var type = 'input';
                            break;
                        default:
                            break;
                    }
                });
                if (vm.countriesWithStates == undefined) {
                    getCountriesWithStates();
                }
            }
        }

        /**
         * Toggle view Edit
         */
        function viewPreview() {
            resetScroll();
            vm.editInline = false;
            vm.currentTab = 'preview';
        }

        function resetScroll() {
            if (angular.element(document.getElementById('thread-detail')).length) {
                var elem = angular.element(document.getElementById('thread-detail'));
                elem.scrollTopAnimated(0, 10);
            }
        }

        /**
         * Open compose dialog
         *
         * @param ev
         */

        function composeDialog(ev) {
            $mdDialog.show({
                controller: 'ComposeDialogController',
                controllerAs: 'vm',
                locals: {
                    selectedContent: undefined
                },
                templateUrl: 'app/main/dialogs/compose/compose-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        }

        /**
         * Open Image dialog
         *
         * @param ev
         * @param task
         */
        function openImageDialog(ev, images, ImageSelected) {
            $mdDialog.show({
                controller: 'MediaShowDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/dialogs/media-show/media-show-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Images: images,
                    ImageSelected: ImageSelected,
                    cropFormats: false,
                    MediaFull: false,
                    Tags: false,
                    // Tasks: vm.tasks,
                    // event: ev
                }
            });
        }

        /**
         * Open Image dialog
         *
         * @param ev
         * @param task
         */
        function openFocalPoint(ev, ImageSelected) {
            $mdDialog.show({
                controller: 'MediaFocalPointDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/dialogs/media-focal-point/media-focal-point-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    ImageSelected: ImageSelected,
                }
            }).then(function (item) {
                vm.basicForm.$setDirty()
                angular.forEach(vm.mediaZones, function (mediazone) {
                    angular.forEach(vm.thumbnails_Edit[mediazone.id_zone], function (attachment) {
                        if (item.id_media === attachment.id_media) {
                            attachment.imageCenterRatioX = item.imageCenterRatioX;
                            attachment.imageCenterRatioY = item.imageCenterRatioY;
                        }
                    })
                })
            });
        }

        /**
         * Open compose dialog
         *
         * @param ev
         */


        /**
         * Open TinyMCE media selector
         *
         * @param item
         */

        function mediaDialogTiny(item) {
            $mdDialog.show({
                controller: 'MediaDialogController',
                controllerAs: 'vm',
                locals: {
                    autoUpload: '',
                    currentThread: item,
                    section: $scope.section,
                    mediazone: 1,
                    isTiny: 1,
                    maxAttach: undefined,
                    showViews: {
                        1: true,
                        2: true,
                        3: true,
                        4: true,
                        5: true,
                        upload: true,
                        import: true
                    }
                },
                templateUrl: 'app/main/dialogs/media/media-dialog-tinymce.html',
                parent: angular.element($document.body),
                clickOutsideToClose: true
            }).then(function (item) {

                /*
                                vm.currentThread_Edit = item;

                                vm.basicForm.$setDirty()
                                vm.thumbnails_Edit = {};
                                angular.forEach(vm.mediaZones, function (mz) {
                                    if (angular.isUndefined(vm.thumbnails_Edit[mz.id_zone])) {
                                        vm.thumbnails_Edit[mz.id_zone] = [];
                                    }
                                })
                                angular.forEach(vm.currentThread_Edit.Thumbnail, function (thumb) {
                                    vm.thumbnails_Edit[thumb.id_zone].push(thumb);
                                })
                */
            });
        }


        function openGroupDialog(ev, group) {

            var groupType = undefined;
            if (angular.isDefined(vm.userGroupTypes)) {
                groupType = vm.userGroupTypes.find(function(groupType) {
                    return groupType.id_group_type == group.id_group_type;
                })
            }
            $mdDialog.show({
                controller: 'EditGroupDialogController',
                controllerAs: 'vm',
                locals: {
                    group: group,
                    siteID: $scope.siteID,
                    groupType: groupType,
                    currentGroupTypeId: vm.currentGroupTypeId,
                    hasAdvancedSettingsAccess: vm.hasAdvancedSettingsAccess
                    //nestedGroups:
                },
                templateUrl: 'app/main/apps/users/dialogs/groups/edit-group.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
            }).then(function (res) {
                if (res) {
                    getCleanUsersGroup();
                }
            });
        }

        /**
         * Open reply dialog
         *
         * @param ev
         */
        function replyDialog(ev) {
            $mdDialog.show({
                controller: 'ComposeDialogController',
                controllerAs: 'vm',
                locals: {
                    selectedContent: vm.selectedContent
                },
                templateUrl: 'app/main/dialogs/compose/compose-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        }

        function setGroupBy(field) {
            $rootScope.pagination_setSortField(field);
            vm.groupBy = field;
            settingUserService.setSetting(vm.settingsSection, 'groupByField', field)
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */

        function cancelUsersGroups(sidenavId) {
            vm.usersGroups = angular.copy(vm.copyUsersGroups);
            $mdSidenav(sidenavId).toggle();
            settingUserService.setSetting(vm.settingsSection, 'sidenavGroupsOpen', false)
        }



        function saveUsersGroups(sidenavId) {
            vm.copyUsersGroups = [];
            $mdSidenav(sidenavId).toggle();
            vm.currentLabelsFilter = transformUsers.getLabels(vm.usersGroups, []);

            if (vm.currentLabelsFilter.length > 0) {
                var array = transformUsers.getGroupsFromLabels(vm.currentLabelsFilter);
                if (array.length === 1) {
                    var copy = angular.copy(array[0]);
                    array[0] = -1;
                    array.push(copy);
                }
                var options = {
                    site: $scope.siteID,
                    section: $scope.section,
                    ids: array
                };
                getUsersByGroups(options);
            } else {
                resetFilters();
            }
            vm.selectedContent = undefined;

        }

        function getUsersByGroups(options) {
            if (vm.refcolumns) {
                var hasIngroupStatusTypeRef = vm.refcolumns.find(function (ref){
                    return ref.type === 'ingroup_status';
                })
                if (hasIngroupStatusTypeRef) {
                    vm.includeAllGroups = true;
                    options.allGroups = vm.includeAllGroups;
                }
            }
            usersService.getUsersByGroupsNoRef(options).then(function (response) {
                vm.threads = response.data;
                $rootScope.pagination_totalItems = response.total;
                $rootScope.pagination_total_pages = response.last_page;
            });
        }

        function resetFilters() {
            vm.currentLabelsFilter = undefined;
            vm.usersGroups = transformUsers.formatNestedGroups(angular.copy(vm.refFilterables));
            $rootScope.pagination_resetquery();
        }

        function resetGroupby() {
            vm.groupBy = undefined;
            settingUserService.setSetting(vm.settingsSection, 'groupByField', null);
            $rootScope.pagination_setSortField(vm.fieldOrder ? vm.fieldOrder : 'id_user');
            $rootScope.pagination_resetquery();
        }

        function resetSortField() {
            vm.groupBy = undefined;
            vm.fieldOrder = undefined;
            settingUserService.setSetting(vm.settingsSection, 'sortField', null);
            settingUserService.setSetting(vm.settingsSection, 'groupByField', null);
            $rootScope.pagination_setSortField('id_user');
            $rootScope.pagination_resetquery();
        }




        function mediaDialog(ev, mediazone, item, type) {
            item.Thumbnail = [];

            $mdDialog.show({
                controller: 'MediaDialogController',
                controllerAs: 'vm',
                locals: {
                    autoUpload: '',
                    currentThread: item,
                    section: $scope.section,
                    mediazone: mediazone,
                    multipleSelection: false,
                    isTiny: false,
                    maxAttach: undefined,
                    showViews: {
                        1: true,
                        2: true,
                        3: true,
                        4: true,
                        5: true,
                        upload: true,
                        import: true
                    }
                },
                templateUrl: 'app/main/dialogs/media/media-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true

            }).then(function (item) {
                vm.currentThread_Edit.avatar = item.Thumbnail[0];
                vm.basicForm.$setDirty();
            });
        }

        function deleteTargetFilter(id, index) {

            vm.currentLabelsFilter.splice(index, 1);
            var groups = transformUsers.getGroupsFromLabels(vm.currentLabelsFilter);
            vm.usersGroups = transformUsers.initGroupsTree(angular.copy(vm.refFilterables), groups, vm.ingroupStatus);

            if (vm.currentLabelsFilter.length <= 0) {
                vm.currentLabelsFilter = undefined;
                $rootScope.pagination_resetquery();

            } else {

                var options = {
                    site: $scope.siteID,
                    section: $scope.section,
                    ids: arrayIds
                };
                getUsersByGroups(options);
                vm.selectedContent = undefined;
            }

        }

        function toggleSidenav(sidenavId) {
            if (!vm.usersGroups) {
                vm.usersGroups = transformUsers.formatNestedGroups(angular.copy(vm.refFilterables));
            }
            vm.copyUsersGroups = angular.copy(vm.usersGroups);
            $mdSidenav(sidenavId).toggle();
            settingUserService.setSetting(vm.settingsSection, 'sidenavGroupsOpen', true)
        }

        function isNumber(value) {
            return angular.isNumber(value);
        }

        function hasDateShow(value) {
            if (value != null && !angular.isUndefined(value.dateShow)) {
                return value.dateShow;
            }
            return false;
        }

        function siteLanguages() {
            return sessionService.getSiteLanguages();
        }

        function dateSelectedCallback(date, fieldName) {
            console.log(date, fieldName)
        }

        function getCurrentMedia() {
            return vm.currentThread_Edit.Thumbnail;
        }

        function getZoneCrop(field) {
            var cropId = '';
            if (!angular.isUndefined(field.id_cropformats)) {
                cropId = field.id_cropformats;
            }
            return cropId;
        }

        function newUser(userName) {
            var newUser = {
                id_user: '',
                user_name: userName
            }
            vm.users.push(newUser);
            vm.currentThread_Edit.users.push(newUser);
            vm.searchUserText = '';
        }


        $scope.$watch('vm.refcolumns', function (countryId) {
            if (vm.refcolumns) {
                var ref_group_as_field = vm.refcolumns.filter(x => x.category == 'show_groups_as_field')
                if (ref_group_as_field && ref_group_as_field.length > 0) {
                    for (let i = 0; i < ref_group_as_field.length; i++) {
                        const element = ref_group_as_field[i];
                        element.groups_as_field = [];
                        var found = vm.allGroups.find(x => x.id_group === JSON.parse(element.title)[0] && x.hasOwnProperty('children'));
                        if (found) {
                            element.groups_as_field = found.children.map(x => {
                                return {
                                    id_group: x.id_group,
                                    value: x.id_group,
                                    text: x.name,
                                    selected: false,
                                    children: getChildren(vm.allGroups, x.id_group)
                                }
                            });
                        }
                    }
                }
            }
        });

        function getChildren(groups, parent) {
            var result = [];
            result = groups.filter(y => y.parent === parent).map(x => {
                return {
                    id_group: x.id_group,
                    value: x.id_group,
                    text: x.name,
                    selected: false,
                    children: getChildren(groups, x.id_group)
                }
            });
            return result;
        }

        function updateModelShowGroupsAsField(data, field) {
            field.model = data.selectedValues;
        }

        $scope.$watch('vm.currentThread_Edit.country', function (countryId) {
            if (countryId) {
                getStatesByCountry(countryId);
            } else if (vm.currentThread_Edit) {
                vm.currentThread_Edit.state = "";
            }
        });

        $scope.$watch('vm.currentThread_Edit.state', function (stateId) {
            if (stateId) {
                getCitiesByState(stateId);
            } else if (vm.currentThread_Edit) {
                vm.currentThread_Edit.city = "";
            }
        });

        function getCountriesWithStates() {
            if (angular.isUndefined(vm.countriesWithStates)) {
                vm.countriesWithStates = [];
                var options = {
                    paginate: 99999,
                    resultsPerPage: 300
                };
                usersService.getCountriesWithStates(options).then(function (response) {

                    if (response.total) {
                        angular.forEach(response.data, function (item) {
                            var resultId = item['id_country'];
                            var resultData = {
                                id: resultId,
                                code: item['code'],
                                name: item['country']
                            };
                            vm.countriesWithStates.push(resultData);
                        })
                    }
                })
            }
        }

        function getCountryById(id) {
            var country;
            angular.forEach(vm.countriesWithStates, function (item) {
                if (item.id == id) {
                    country = item;
                }
            })
            return country;
        }


        function getStatesByCountry(countryId) {

            if (angular.isDefined(countryId)) {
                vm.statesWithCities = [];
                var options = {
                    paginate: 99999,
                    resultsPerPage: 99999,
                    id_country: countryId
                };
                usersService.getStatesWithCities(options).then(function (response) {
                    if (response.total) {
                        angular.forEach(response.data, function (item) {
                            var resultId = item['id_state'];
                            var resultData = {
                                id: resultId,
                                code: item['code'],
                                name: item['state'],
                                cities: item['cities']
                            };
                            vm.statesWithCities.push(resultData);
                            if (vm.selectedContent.state && vm.selectedContent.state == resultData.id) {
                                vm.selectedContent.related_state = resultData;
                                vm.getCitiesByState(vm.selectedContent.state);
                            }
                        })
                    }
                })
            }
        };

        function getCitiesByState(stateId) {
            if (angular.isDefined(stateId) && stateId !== '') {
                var item = ($filter('filter')(vm.statesWithCities, { id: stateId }));
                if (item && item.length > 0) {
                    vm.cities = item[0].cities;
                }
                if (vm.selectedContent.city) {
                    angular.forEach(vm.cities, function (item) {
                        if (item.id_city == vm.selectedContent.city) {
                            vm.selectedContent.related_city = item;
                        }
                    });
                }
            }
        }

        function loginToWebsite(user) {
            usersService.getUserToken({
                siteID: $scope.siteID,
                id: user.id_user
            }).then(function (response) {
                $window.open(vm.loginUrl + response.token, 'website');
            })
        }

        function inviteToGroupPreview(user, group) {
            if (angular.isArray(group) && group.length > 0) {
                group = group[0]
            }
            usersService.getUserToken({
                siteID: $scope.siteID,
                id: user.id_user,
                id_group: group.id_group
            }).then(function (response) {
                $window.open(vm.userInvitationUrlPreview + response.token, 'website');
            })
        }
        function inviteToGroupIndividual(user, group) {
            if (angular.isArray(group) && group.length > 0) {
                group = group[0]
            }
            usersService.getUserToken({
                siteID: $scope.siteID,
                id: user.id_user,
                id_group: group.id_group
            }).then(function (response) {
                $window.open(vm.userInvitationUrlIndividual + response.token, 'website');
            })
        }
        function inviteToGroupMultiple(event, group) {
            if (angular.isArray(group) && group.length > 0){
                group = group[0]
            }
            var ids = [];
            angular.forEach(vm.selectedThreads, function(user){
                ids.push(user.id_user)
            })
            usersService.getUserToken({
                siteID: $scope.siteID,
                id: 0,
                id_group: group.id_group,
                id_users: ids
            }).then(function (response) {
                $window.open(vm.userInvitationUrlMultiple + response.token, 'website');
            })
        }

        function customActionEvent(axn, event) {
          switch (axn.action) {
            case "openUrlWithTokenAndGroup":
              var group = '';
              if (!angular.isUndefined(vm.selectedGroupsAcc)) {
                group = vm.selectedGroupsAcc
              } else if (vm.selectedGroup) {
                group = vm.selectedGroup;
              }
              if (!group) {
                return;
              }
              if (angular.isArray(group) && group.length > 0) {
                group = group[0]
              }
              var ids = [];
              angular.forEach(vm.selectedThreads, function (user) {
                ids.push(user.id_user)
              })
              usersService.getUserToken({
                siteID: $scope.siteID,
                id: 0,
                id_group: group.id_group,
                id_users: ids
              }).then(function (response) {
                $window.open(axn.url + response.token, 'website');
              })
              break;
          }
          /*
           */
        }

        function sendConversationMessage(conversationKey) {

            if (angular.isUndefined(vm.conversationMessage[conversationKey]) || vm.conversationMessage[conversationKey].length < 1) {
                return;
            }

            var currentUser = sessionService.user;
            var newMessage = {
                date_created: moment.utc().format('YYYY-MM-DD HH:mm:ss'),
                message: vm.conversationMessage[conversationKey],
                username: currentUser.first_name + " " + currentUser.last_name,
                user_id: currentUser.id_user
            }
            if (angular.isUndefined(vm.selectedContent.conversations)) {
                vm.selectedContent.conversations = {};
            }
            if (angular.isUndefined(vm.selectedContent.conversations[conversationKey])) {
                vm.selectedContent.conversations[conversationKey] = [];
            }
            vm.conversationMessage[conversationKey] = '';

            var options = {
                site: $scope.siteID,
                id: vm.selectedContent.id_user,
                messages: [newMessage],
                conversation: conversationKey,
                attach: true
            };
            usersService.saveConversation(options).then(function (response) {
                vm.selectedContent.conversations[conversationKey].push(newMessage);

                var message = $translate.instant('USERS.COMMENT_SENT');
                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                    hideDelay: 5000,
                    position: 'top',
                    parent: '#content-container'
                });
                return true;
            });

        }

        function deleteConversationMessage(conversationKey, idx) {
            vm.selectedContent.conversations[conversationKey].splice(idx, 1);
            var options = {
                site: $scope.siteID,
                id: vm.selectedContent.id_user,
                messages: vm.selectedContent.conversations[conversationKey],
                conversation: conversationKey,
                attach: false
            };
            usersService.saveConversation(options).then(function (response) {
                var message = $translate.instant('USERS.COMMENT_DELETED');
                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                    hideDelay: 5000,
                    position: 'top',
                    parent: '#content-container'
                });
                return true;
            });

        }

        function filterIsMainOrSecondaryTableListPosition(item) {
            return item.table_list_position == 'main' || item.table_list_position == 'secondary';
        }

        function buttonClick(event, settings, selectedUser) {
            if (settings && (settings.url || settings.url_from_field) && settings.method && settings.params) {
                vm.isSending = true;
                var params = {};
                angular.forEach(settings.params, function(param){
                    if (selectedUser[param.field]) {
                        params[param.name] = selectedUser[param.field];
                    }
                })
                var url = false;
                if (settings.url) {
                    url = settings.url;
                }
                if (settings.url_from_field) {
                    url = selectedUser[settings.url_from_field];
                }

                if (!url) {
                    vm.isSending = false;
                    return;
                }
                var config = {
                    url: url,
                    method: settings.method,
                    params: params
                }
                if (settings.open_in_browser) {
                    $window.open(url, '_blank');
                    vm.isSending = false;
                } else {
                    $http(config).then(function(response) {
                        vm.isSending = false;
                    },
                    function(error) {
                        vm.isSending = false;
                    })
                }
            }
        }
    }


    function LoadUsersByGroups(usersService) {

        function unselectAllGroups() {
            var elemList = document.querySelectorAll('.group-row');
            elemList.forEach(function (elem) {
                elem.classList.remove('selected');
            });
        }

        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                $(element).on('click', function (e) {

                    var groupNode = false;
                    if (element.parent().hasClass('selected')) {
                        // With Qiu restriction active don't allow for unselecting groups.
                        if (scope.node.is_qiu_restricted) return;
                        unselectAllGroups();
                    } else {
                        unselectAllGroups();
                        element.parent().addClass('selected');
                        groupNode = scope.node;
                    }
                    var includeSubgroups = $('#includeSubgroups').attr("data-include-subgroups") == 'true';
                    usersService.triggerUsersByGroups(groupNode, includeSubgroups);
                });
            }
        };
    }

    function LoadUsersByGroupsAcc(usersService) {

        function unselectAllGroups() {
            var elemList = document.querySelectorAll('.group-row.acc');
            elemList.forEach(function (elem) {
                elem.classList.remove('selected');
            });
        }

        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                $(element).on('click', function (e) {
                    var groupNode = false;
                    if (element.parent().hasClass('selected')) {
                        unselectAllGroups();
                    } else {
                        unselectAllGroups();
                        element.parent().addClass('selected');
                        groupNode = scope.node;
                    }
                    usersService.triggerUsersByGroupsAcc(groupNode);
                });
            }
        };
    }

    function LoadUsersByGroupsAccSub(usersService) {

        function unselectAllGroups() {
            var elemList = document.querySelectorAll('.group-row.acc-sub');
            elemList.forEach(function (elem) {
                elem.classList.remove('selected');
            });
        }

        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                $(element).on('click', function (e) {
                    var groupNode = false;
                    if (element.parent().hasClass('selected')) {
                        unselectAllGroups();
                    } else {
                        unselectAllGroups();
                        element.parent().addClass('selected');
                        groupNode = scope.node;
                    }
                    usersService.triggerUsersByGroupsAccSub(groupNode);
                });
            }
        };
    }

    function ToggleAssignedGroup() {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                $(element).on('click', function (e) {
                    scope.node.assigned_group = !scope.node.assigned_group;
                });
            }
        };
    }

    function SetInGroupStatus() {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                scope.$watch(attrs.ngModel, function (v) {
                    if (angular.isDefined(v)) {
                        scope.node.id_ingroup_status = v;
                    }
                });
            }
        };
    }

    function OpenGroupEditDialog(usersService) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                $(element).on('click', function (e) {
                    var groupNode = scope.node;
                    usersService.triggerGroupDialog(groupNode);
                });
            }
        };
    }

    function renderTinyMedia(content) { }

    function CloseSidenav(usersService) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                $(element).on('click', function (e) {
                    usersService.triggerCloseSidenav(attrs.sidenavId);
                });
            }
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.users')
        .service('usersService', usersService);

    /** @ngInject */
    // I provide access to the session store.
    function usersService($rootScope, $q, $resource, $stateParams, settingUserService, userService, settingsDomainService, sessionService, COMMON, $window) {
        function get(options) {
            if (options.groupIds === undefined) {
                return getUsers(options);
            } else {
                return getUsersByGroups(options);
            }
        }

        function getUsers(options) {

            var deferred = $q.defer();

            var settingsSection = 'users-' + $stateParams.groupTypeName;

            var opts = {
                domain: options.siteID,
                page: options.page,
                search: options.searchStringFilter,
                paginate: options.paginate,
                sortField: settingUserService.getSettingValue(settingsSection, 'sortField', options.sortField),
                sortDir: settingUserService.getSettingValue(settingsSection, 'sortDir', options.sortDir),
                withFilters: JSON.stringify(options.withFilters),
                withRelatedCountry: true,
                withRelatedCity: true,
                withRelatedState: true,
                resultsPerPage: options.resultsPerPage || 250
            };

            if (options.userIds) {
                opts['id_user[]'] = options.userIds;
            }

            resourceUsers.get(opts,
                function (responseResult, headers) {
                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);
                    var ref = resourceUsersRef;
                    if ($stateParams.groupTypeId === "6") {
                        ref = resourceUSersAccreditationsRef;
                    }

                    ref.get({
                        domain: options.siteID,
                        page: options.page,
                        search: options.searchStringFilter,
                        paginate: options.paginate,
                        sort: options.sort,
                        withFilters: JSON.stringify(options.withFilters),
                    },
                        function (response) {
                            var promise = Promise.resolve();
                            var qiuRestrictions = JSON.parse(headers('qiu-restrictions'));
                            if (qiuRestrictions && qiuRestrictions.groups_sub) {
                                promise = promise.then(function () {
                                    options.groupIds = [Object.values(qiuRestrictions.groups_sub)[0]];
                                    var hasIngroupStatusTypeRef = response.find(function (ref) {
                                        return ref.type === 'ingroup_status';
                                    })
                                    if (hasIngroupStatusTypeRef) {
                                        options.allGroups = true;
                                    }
                                    return getUsersByGroups(options).then(function (resp) {
                                        responseResult = resp.result;
                                        return Promise.resolve();
                                    });

                                })
                            }
                            promise.then(function () {
                                // angular.copy(response, modulecontent);
                                // setActiveDomain(domain);
                                deferred.resolve({
                                    ref: response,
                                    result: responseResult,
                                    qiuRestrictions: qiuRestrictions
                                });
                            })
                        },
                        function (e) {
                            console.error("ERROR =========================================!!!!!!")
                            console.error(e)
                            deferred.reject();
                        }
                    );

                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getRef(options) {
            var deferred = $q.defer();
            var ref = resourceUsersRef;
            if ($stateParams.groupTypeId === "6") {
                ref = resourceUSersAccreditationsRef;
            }
            ref.get({
                domain: options.siteID
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }
        function getGroupsAccreditations(options) {
            var deferred = $q.defer();
            resourceGroupsAccreditations.get({
                domain: options.siteID
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function getUserByID(options) {
            var deferred = $q.defer();

            resourceUserById.get({
                domain: options.site,
                id: options.id,
                withRelatedCountry: true,
                withRelatedCity: true,
                withRelatedState: true,
                // lang: get("language")
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getUsersByGroups(options) {

            var deferred = $q.defer();
            var filters = [];

            _.forEach(options, function (value, key, list) {
                if (_.isObject(list[key])) {
                    _.forEach(list[key], function (filter, keyFilter, listFilter) {
                        if (!_.isEmpty(filter.selected)) {
                            filters.push({
                                field: filter.field,
                                name: filter.name,
                                values: filter.selected
                            });
                        }

                    });

                }
            });

            var opts = {
                domain: options.siteID,
                'id_group[]': options.groupIds,
                sortField: options.sortField,
                sortDir: options.sortDir,
                resultsPerPage: options.resultsPerPage || 250,
                page: options.page,
                search: options.searchStringFilter,
                searchWithUserParams: options.searchWithUserParams,
                'withSections[]': options.withSections,
                customSectionGroupBy: options.customSectionGroupBy
            };
            if (options.lastLoginNotNull) {
                opts.lastLoginNotNull = options.lastLoginNotNull;
            }
            if (options.lastLoginFrom) {
                opts.lastLoginFrom = options.lastLoginFrom;
            }
            if (options.lastAuditLogOrLoadInFrom) {
                opts.lastAuditLogOrLoadInFrom = options.lastAuditLogOrLoadInFrom;
            }
            if (options.lastActivityFrom) {
                opts.lastActivityFrom = options.lastActivityFrom;
            }
            if (options.currentNumber) {
                opts.currentNumber = options.currentNumber;
            }
            // profileNumber: filtra a los usuarios que tienen un PERFIL con ese dorsal en el evento
            // (events_data propio o perfil recolectado/comprado en section_orders). Lo aplica UsersFilters@profileNumber.
            if (options.profileNumber) {
                opts.profileNumber = options.profileNumber;
            }
            if (options.ingroupStatus && options.ingroupStatus != "0") {
                opts.ingroupStatus = parseInt(options.ingroupStatus);
            }
            if (options.allGroups) {
                opts.all_groups = options.allGroups
            }
            resource_user_by_users_groups.get(opts,
                function (responseResult) {
                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);
                    var ref = resourceUsersRef;
                    if ($stateParams.groupTypeId === "6") {
                        ref = resourceUSersAccreditationsRef;
                    }
                    ref.get({
                        domain: options.siteID,
                        page: options.page,
                        search: options.searchStringFilter,
                        paginate: options.paginate,
                        sort: options.sort,
                        filters: JSON.stringify(filters),
                    },
                        function (response) {
                            // angular.copy(response, modulecontent);
                            // setActiveDomain(domain);

                            deferred.resolve({
                                ref: response,
                                result: responseResult
                            });
                        },
                        function (e) {
                            console.error("ERROR =========================================!!!!!!")
                            console.error(e)
                            deferred.reject();
                        }
                    );

                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );

            return (deferred.promise);
        };
        function getUsersByGroupsCount(options) {
            var deferred = $q.defer();
            var filters = [];
            _.forEach(options, function (value, key, list) {
                if (_.isObject(list[key]) && !Array.isArray(list[key])) {
                    _.forEach(list[key], function (filter, keyFilter, listFilter) {
                        if (!_.isEmpty(filter.selected)) {
                            filters.push({
                                field: filter.field,
                                name: filter.name,
                                values: filter.selected
                            });
                        }

                    });

                }
            });

            var opts = {
                domain: options.siteID,
                'id_group[]': options.groupIds,
            };

            resource_user_by_users_groups_count.get(opts,
                function (responseResult) {
                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);
                    deferred.resolve({
                        result: responseResult
                    });
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );

            return (deferred.promise);
        };
        function getUsersByGroupsNoRef(options) {

            var deferred = $q.defer();
            var filters = [];

            _.forEach(options, function (value, key, list) {
                if (_.isObject(list[key])) {
                    _.forEach(list[key], function (filter, keyFilter, listFilter) {
                        if (!_.isEmpty(filter.selected)) {
                            filters.push({
                                field: filter.field,
                                name: filter.name,
                                values: filter.selected
                            });
                        }

                    });

                }
            });

            var opts = {
                domain: options.siteID,
                'id_group[]': options.groupIds,
                sortField: options.sortField,
                sortDir: options.sortDir,
                resultsPerPage: 250,
                page: options.page,
                search: options.searchStringFilter
            };
            if (options.ingroupStatus && options.ingroupStatus != "0") {
                opts.ingroupStatus = parseInt(options.ingroupStatus);
            }
            if (options.allGroups) {
                opts.all_groups = options.allGroups;
            }

            resource_user_by_users_groups.get(opts,
                function (responseResult) {

                    deferred.resolve({
                        result: responseResult
                    });

                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );

            return (deferred.promise);
        };


        function getUsersGroups(options) {
            var deferred = $q.defer();
            var params = {
                domain: options.siteID,
                groupType: options.groupType
            }
            if (options.withGroupType) {
                params.withGroupType = true;
            }
            params.sortDir = options.sortDir || 'ASC';
            params.sortField = options.sortField || 'name';
            resourceGroupsNested.get(params,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);

        }

        function getUsersGroupsTypes(options) {
            var deferred = $q.defer();
            resourceGroupsTypes.get({
                domain: options.siteID
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);

        }

        function getUsersInGroupStatus(siteID) {
            var deferred = $q.defer();
            resourceInGroupStatus.get({
                domain: siteID
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function getUnnestedUsersGroups(siteID) {
            var deferred = $q.defer();
            resourceGroups.get({
                domain: siteID
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);

        }


        function getUsersGroup(options) {
            var deferred = $q.defer();
            resourceGroups.get({
                domain: options.siteID,
                withoutUsers: options.withoutUsers,
                id: options.id
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    deferred.reject(e);
                }
            );
            return (deferred.promise);

        }

        function createUsersGroup(siteID, parentId, name, groupTypeId, groupStatusId, sort) {
            var deferred = $q.defer();
            resourceGroups.post({
                domain: siteID,
                parent: parentId,
                name: name,
                id_group_type: groupTypeId,
                id_group_status: groupStatusId,
                sort: sort
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    deferred.reject(e);
                }
            );
            return (deferred.promise);

        }

        function editUsersGroup(siteID, groupId, parentId, name, groupTypeId, groupStatusId, sort, rawSettings) {
            var deferred = $q.defer();
            resourceGroups.update({
                domain: siteID,
                parent: parentId,
                name: name,
                id_group_type: groupTypeId,
                id_group_status: groupStatusId,
                id: groupId,
                sort: sort,
                raw_settings: rawSettings
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    deferred.reject(e);
                }
            );
            return (deferred.promise);

        }

        function deleteUsersGroup(siteID, groupId) {
            var deferred = $q.defer();
            resourceGroups.delete({
                domain: siteID,
                id: groupId
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    deferred.reject(e);
                }
            );
            return (deferred.promise);

        }

        function massInsertUsersIntoGroups(options) {
            var deferred = $q.defer();
            resourceUsersInGroupsMassInsert.post({
                domain: options.siteID
            }, JSON.stringify(options.data),
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject(e);
                }
            );
            return (deferred.promise);
        }

        // Attach an EXISTING user (matched by email) to the given group(s). Backs the
        // "user already exists - add to this group?" flow. options.data = { email, groups: [{ id_group, id_ingroup_status }] }
        function attachExistingUserByEmail(options) {
            var deferred = $q.defer();
            resourceUserAttachExistingByEmail.post({
                domain: options.siteID
            }, JSON.stringify(options.data),
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    deferred.reject(e.data);
                }
            );
            return (deferred.promise);
        }

        function copyUsersInGroupsToGroups(options) {
            var deferred = $q.defer();
            resourceUsersInGroupsCopyToGroup.post({
                domain: options.siteID
            }, JSON.stringify(options.data),
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function moveUsersInGroupsToGroups(options) {
            var deferred = $q.defer();
            resourceUsersInGroupsMoveToGroup.post({
                domain: options.siteID
            }, JSON.stringify(options.data),
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function insertUsersInGroupsBoolean(options) {
            var deferred = $q.defer();
            resourceUsersInGroupsBoolean.post({
                domain: options.siteID,
                boolean_operation: options.booleanOperation
            }, JSON.stringify(options.data),
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function segmentSubscriptionGroup(options) {
            var deferred = $q.defer();
            resourceSegmentSubscriptionGroup.post({
                domain: options.siteID
            }, JSON.stringify(options.data),
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function removeUsersFromGroup(options) {
            var deferred = $q.defer();
            resourceUsersInGroup.delete({
                domain: options.siteID,
                id: options.data.id_group,
                id_group: options.data.id_group,
                'id_user[]': options.data.id_user
            }, JSON.stringify(options.data),
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }
        function updateUsersFromGroup(options) {
            var deferred = $q.defer();
            resourceUsersInGroup.update({
                domain: options.siteID,
                id: options.id,
                id_ingroup_status: options.id_ingroup_status,
                'id_user': options.id_user
            }, options,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }



        function getUserGroups(options) {
            var deferred = $q.defer();
            resourceUserGroups.get({
                domain: options.site,
            },
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function deleteItem(options) {
            var deferred = $q.defer();
            resource_user_byID.delete({
                domain: options.site,
                id: options.id
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function triggerUsersByGroups(groupNode, includeSubgroups) {
            var groups = false;
            var selectedGroup = false;
            if (groupNode) {
                var node = angular.fromJson(groupNode);
                groups = unnestGroups(node, [], includeSubgroups);
                selectedGroup = node;
            }
            $rootScope.$broadcast('loadUsersByGroups', groups, selectedGroup);
        }
        function triggerUsersByGroupsAcc(groupNode) {
            var groups = false;
            if (groupNode) {
                var node = angular.fromJson(groupNode);
                groups = unnestGroups(node, [], includeSubgroups);
            }
            $rootScope.$broadcast('loadUsersByGroupsAcc', groups);
        }
        function triggerUsersByGroupsAccSub(groupNode) {
            var groups = false;
            if (groupNode) {
                var node = angular.fromJson(groupNode);
                groups = unnestGroups(node, []);
            }
            $rootScope.$broadcast('loadUsersByGroupsAccSub', groups);
        }

        function triggerReloadGroups() {
            $rootScope.$broadcast('reloadGroups');
        }

        function triggerSelectParentGroup(groupNode) {
            $rootScope.$broadcast('selectParentGroup', groupNode);
        }

        function triggerCloseSidenav(sidenavId) {
            $rootScope.$broadcast('closeSidenav', sidenavId);
        }

        function triggerSelectSegmentTargetGroup(groupNode) {
            $rootScope.$broadcast('selectSegmentTargetGroup', groupNode);
        }

        function unselectAllGroups() {
            var elemList = document.querySelectorAll('.group-row');
            elemList.forEach(function (elem) {
                elem.classList.remove('selected');
            });
        }

        function unnestGroups(node, groups, includeSubgroups) {
            groups.push(node);
            if (includeSubgroups && typeof node.children !== 'undefined' && node.children.length > 0) {
                angular.forEach(node.children, function (data) {
                    unnestGroups(data, groups, includeSubgroups);
                });
            }
            return groups;
        }

        function triggerGroupDialog(group) {
            $rootScope.$broadcast('openGroupDialog', group);
        }

        function getCountriesWithStates(options) {
            var deferred = $q.defer();
            resourceCountriesWithStates.get({
                resultsPerPage: options.paginate,
            },
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function getStatesWithCities(options) {
            var deferred = $q.defer();

            resourceStatesWithCities.get({
                resultsPerPage: options.paginate,
                id_country: options.id_country
            },
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );
            // Return the promise.
            return (deferred.promise);
        }

        function saveItem(options) {
            var deferred = $q.defer();

            if (options.id !== '' && options.id !== undefined) {
                resource_user_byID.update({
                    domain: options.site,
                    id: options.id,
                    verify: options.item.verify,
                }, options.item,
                    function (response) {

                        deferred.resolve(response);
                    },
                    function (e) {
                        console.error(e)
                        console.error("Database connection error")
                        deferred.reject();
                    }
                );
            } else {
                resource_user_post_byID.save({
                    domain: options.site,
                    verify: options.item.verify
                }, options.item,
                    function (response) {

                        // angular.copy(response, modulecontent);
                        // setActiveDomain(domain);

                        deferred.resolve(response);
                    },
                    function (e) {
                        console.error(e)
                        //console.error("Database connection error")
                        deferred.reject(e.data);
                    }
                );
            }

            // Return the promise.
            return (deferred.promise);
        }

        function saveConversation(options) {
            var deferred = $q.defer();

            resource_user_conversation.update({
                domain: options.site,
                id: options.id,
            },
                {
                    messages: options.messages,
                    conversation: options.conversation,
                    attach: options.attach ? true : false
                },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );
            // Return the promise.
            return (deferred.promise);
        }

        function getTemplatesExport(options) {
            var deferred = $q.defer();

            resource_user_template_export.get({
                domain: options.siteID,
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );
            // Return the promise.
            return (deferred.promise);
        }
        function saveTemplateExport(options) {
            var deferred = $q.defer();

            resource_user_template_export.post({
                domain: options.siteID,
            },
                options.item,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );
            // Return the promise.
            return (deferred.promise);
        }

        function getUsersAuditTrailByID(options) {

            var deferred = $q.defer();
            var params = {
                domain: options.site,
                user_id: options.id
            }
            resourceAuditTrailByID.get(params,
                function (response) {
                    deferred.resolve(response.data);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function getUsersAuditTrail(options) {

            var deferred = $q.defer();
            var params = {
                domain: options.site
            }
            resourceAuditTrail.get(params,
                function (response) {
                    deferred.resolve(response.data);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }
        function getUsersBetweenDates(options) {
            var deferred = $q.defer();
            var params = {
                domain: options.siteID,
                dateFrom: options.dateFrom,
                dateTo: options.dateTo,
                resultsPerPage: options.resultsPerPage ? options.resultsPerPage : 15
            }
            resourceBetweenDates.get(params,
                function (response) {
                    deferred.resolve(response.data);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function getUserToken(options) {

            var deferred = $q.defer();
            var params = {
                domain: options.siteID,
                id: options.id
            }
            if (options.id_group) {
                params.id_group = options.id_group;
            }
            if (options.id_users) {
                params['id_users[]'] = options.id_users;
            }
            resourceGenericUserToken.get(params,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function getFileInfo(options) {
            var deferred = $q.defer();
            resourceGetFileInfo.post({
                domain: options.domain,
                token: options.token,
                options: options.options,
                // lang: get("language")
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }


        function getS3UploadPreSignedUrl(options) {
            var deferred = $q.defer();

            resource_s3_presigned_url.get({
                domain: options.siteID,
                fileName: options.fileName,
                fileSizeKb: (angular.isDefined(options.fileSizeKb)) ? options.fileSizeKb : null
                // lang: get("language")
            },
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }



        function exportUsers(options) {
            var deferred = $q.defer();
            var options = {
                domain: options.siteID,
                users: options.users,
                groups: options.groups,
                fields: options.fields,
                format: options.format,
                nestedGroups: options.nestedGroups,
                users_group_type: options.users_group_type,
                selected_users_group_id: options.selected_users_group_id,
                selected_ingroup_status_id: options.selected_ingroup_status_id
            };
            resourceExportUsers.post(options,
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);

        }


        function importUsers(options) {
            var deferred = $q.defer();
            var options = {
                domain: options.siteID,
                token: options.token,
                targetGroup: options.targetGroup,
                options: options.options,
                fieldMap: options.fieldMap,
                primaryKey: options.primaryKey,
                ignoreDuplicates: options.ignoreDuplicates,
            }
            resourceImportUsers.post(options,
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function changeGroupPriority(options) {
            var deferred = $q.defer();
            resourceChagePriority.update(options,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject(e);
                }
            );

            return (deferred.promise);
        }

        var resourceChagePriority = $resource(
            COMMON.BASE_API + "/domain/:domain/users/byGroup/:groupID", {
            domain: '@domain',
            groupID: '@groupID'
        },
            {
                update: {
                    method: "PUT",
                }
            }
        )

        var resourceGetFileInfo = $resource(
            COMMON.BASE_API + "/domain/:domain/import/users/getFileInfo", {
            domain: '@domain',
        }, {
            post: {
                method: "POST",
                isArray: false
            }
        }
        );

        var resourceImportUsers = $resource(
            COMMON.BASE_API + "/domain/:domain/import/users/import", {
            domain: '@domain',
        }, {
            post: {
                method: "POST",
                isArray: false
            }
        }
        );
        var resourceExportUsers = $resource(
            COMMON.BASE_API + "/domain/:domain/export/users/export", {
            domain: '@domain',
        }, {
            post: {
                method: "POST",
                isArray: false
            }
        }
        );
        var resource_s3_presigned_url = $resource(
            COMMON.BASE_API + "/domain/:domain/import/users/getS3UploadPreSignedUrl", {
            // No default data.
        }, {
            get: {
                method: "GET",
                isArray: false
            }
        }
        );

        var resourceGroupsNested = $resource(
            COMMON.BASE_API + "/domain/:domain/usersGroupsNested", {
            // No default data.
        }, {
            get: {
                method: "GET",
                isArray: false,
                transformResponse: function (data, headers) {
                    var response = {}
                    response.data = JSON.parse(data);
                    response.qiuRestrictions = JSON.parse(headers('qiu-restrictions'));
                    return response;
                }
            }
        }
        );
        var resourceAuditTrailByID = $resource(
            COMMON.BASE_API + "/domain/:domain/usersAuditTrail?user_id=:user_id", {
            // No default data.
        }, {
            get: {
                method: "GET",
                isArray: false
            }
        }
        );
        var resourceAuditTrail = $resource(
            COMMON.BASE_API + "/domain/:domain/usersAuditTrail?withUser", {
            // No default data.
        }, {
            get: {
                method: "GET",
                isArray: false
            }
        }
        );

        var resourceGenericUserToken = $resource(
            COMMON.BASE_API + "/domain/:domain/users/getGenericToken/:id", {
            // No default data.
        }, {
            get: {
                method: "GET",
                isArray: false
            }
        }
        );

        var resourceGroupsTypes = $resource(
            COMMON.BASE_API + "/domain/:domain/usersGroupsTypes", {
            // No default data.
        }, {
            get: {
                method: "GET",
                isArray: true
            }
        }
        );

        var resourceInGroupStatus = $resource(
            COMMON.BASE_API + "/domain/:domain/usersInGroupStatus", {
            // No default data.
        }, {
            get: {
                method: "GET",
                isArray: true
            }
        }
        );

        var resourceGroups = $resource(
            COMMON.BASE_API + "/domain/:domain/usersGroups/:id", {
            // No default data.
            domain: '@domain',
            id: '@id'
        }, {
            get: {
                method: "GET",
                isArray: false
            },
            post: {
                method: "POST"
            },
            update: {
                method: "PUT"
            },
            delete: {
                method: "DELETE",
                isArray: true
            }

        }
        );



        var resourceUsers = $resource(COMMON.BASE_API + "/domain/:domain/users", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false
            }
        });
        var resourceGroupsAccreditations = $resource(COMMON.BASE_API + "/domain/:domain/usersGroupsTypes?withChildren&groupTypes[]=6", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: true
            }
        });
        var resourceUsersRef = $resource(COMMON.BASE_API + "/domain/:domain/usersRef", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: true
            }
        });
        var resourceUSersAccreditationsRef = $resource(COMMON.BASE_API + "/domain/:domain/usersRefAccreditations", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: true
            }
        });

        var resourceUserById = $resource(COMMON.BASE_API + "/domain/:domain/users/:id", {
            // No default data
        }, {
            get: {
                method: "GET",
                // isArray: true
            }
        });

        var resourceUserGroups = $resource(
            COMMON.BASE_API + "/domain/:domain/usersGroupsNested", {
            // No default data.
        }, {
            get: {
                method: "GET",
                isArray: true
            }
        }
        );

        var resource_user_by_users_groups = $resource(
            COMMON.BASE_API + "/domain/:domain/usersInGroup", {
            // No default data.

        }, {
            get: {
                method: "GET",
                //isArray: true
            }
        }
        );

        var resource_user_by_users_groups_count = $resource(
            COMMON.BASE_API + "/domain/:domain/usersInGroup/count", {
            // No default data.

        }, {
            get: {
                method: "GET",
                //isArray: true
            }
        }
        );

        var resourceUsersInGroup = $resource(
            COMMON.BASE_API + "/domain/:domain/usersInGroup/:id", {
            // No default data.
        }, {
            delete: {
                method: "DELETE",
                isArray: true
            },
            update: {
                method: "PUT",
                isArray: true
            }
        }
        );

        var resourceUsersInGroupsMassInsert = $resource(
            COMMON.BASE_API + "/domain/:domain/usersInGroups/massInsert", {
            // No default data.

        }, {
            post: {
                method: "POST",
                //isArray: true
            }
        }
        );

        var resourceUsersInGroupsCopyToGroup = $resource(
            COMMON.BASE_API + "/domain/:domain/usersInGroups/copyToGroup", {
            // No default data.

        }, {
            post: {
                method: "POST",
                //isArray: true
            }
        }
        );

        var resourceUsersInGroupsMoveToGroup = $resource(
            COMMON.BASE_API + "/domain/:domain/usersInGroups/moveToGroup", {
            // No default data.

        }, {
            post: {
                method: "POST",
                //isArray: true
            }
        }
        );

        var resourceUsersInGroupsBoolean = $resource(
            COMMON.BASE_API + "/domain/:domain/usersInGroups/boolean/:boolean_operation", {
            // No default data.

        }, {
            post: {
                method: "POST",
                //isArray: true
            }
        }
        );

        var resourceSegmentSubscriptionGroup = $resource(
            COMMON.BASE_API + "/domain/:domain/usersInGroups/segmentSubscriptionGroup", {
            // No default data.

        }, {
            post: {
                method: "POST",
                //isArray: true
            }
        }
        );
        var resource_user_template_export = $resource(
            COMMON.BASE_API + "/domain/:domain/users/export/templates", {
            // No default data.

        }, {
            get: {
                method: "GET",
                //isArray: true
            },
            post: {
                method: "POST",
                //isArray: true
            }
        }
        );

        var resource_user_post_byID = $resource(
            COMMON.BASE_API + "/domain/:domain/users", {
            domain: '@domain',
        }, {
            save: {
                method: "POST",
            },
        }
        );

        var resourceUserAttachExistingByEmail = $resource(
            COMMON.BASE_API + "/domain/:domain/users/attachExistingByEmail", {
            domain: '@domain',
        }, {
            post: {
                method: "POST",
            },
        }
        );

        var resource_user_byID = $resource(
            COMMON.BASE_API + "/domain/:domain/users/:id", {
            domain: '@domain',
            id: '@id',
        }, {
            get: {
                method: "GET",
            },
            update: {
                method: "PUT",
            },
            delete: {
                method: "DELETE",
                isArray: true
            }
        }
        );
        var resource_user_conversation = $resource(
            COMMON.BASE_API + "/domain/:domain/usersConversations/:id", {
            domain: '@domain',
            id: '@id',
        }, {
            update: {
                method: "PUT",
            }
        }
        );
        var resourceBetweenDates = $resource(
            COMMON.BASE_API + "/domain/:domain/users?sortDir=DESC&sortField=created_at&dateFrom=:dateFrom&dateTo=:dateTo", {
            domain: '@domain',
            id: '@id',
        }, {
            get: {
                method: "GET",
            },
            update: {
                method: "PUT",
            },
            delete: {
                method: "DELETE",
                isArray: true
            }
        }
        );

        var resourceCountriesWithStates = $resource(
            COMMON.BASE_API + "/location/countries?withStates", {
            // No default data.
        }, {
            get: {
                method: "GET",
                // isArray: true
            }
        }
        );

        var resourceStatesWithCities = $resource(
            COMMON.BASE_API + "/location/states?withCities", {
            // No default data.
        }, {
            get: {
                method: "GET",
                // isArray: true
            }
        }
        );

        return ({
            get: get,
            //get: getUsers,
            //get: getUsersByGroups,
            getUserByID: getUserByID,
            getFilters: getUserGroups,
            getRef: getRef,
            saveItem: saveItem,
            deleteItem: deleteItem,
            getUsers: getUsers,
            getUsersByGroups: getUsersByGroups,
            getUsersByGroupsCount: getUsersByGroupsCount,
            getUsersByGroupsNoRef: getUsersByGroupsNoRef,
            getUsersGroups: getUsersGroups,
            getUsersGroup: getUsersGroup,
            triggerUsersByGroups: triggerUsersByGroups,
            triggerUsersByGroupsAcc: triggerUsersByGroupsAcc,
            triggerUsersByGroupsAccSub: triggerUsersByGroupsAccSub,
            triggerGroupDialog: triggerGroupDialog,
            triggerSelectSegmentTargetGroup: triggerSelectSegmentTargetGroup,
            getCountriesWithStates: getCountriesWithStates,
            getStatesWithCities: getStatesWithCities,
            getUsersBetweenDates: getUsersBetweenDates,
            getUnnestedUsersGroups: getUnnestedUsersGroups,
            saveConversation: saveConversation,
            createUsersGroup: createUsersGroup,
            editUsersGroup: editUsersGroup,
            deleteUsersGroup: deleteUsersGroup,
            updateUsersFromGroup: updateUsersFromGroup,
            triggerSelectParentGroup: triggerSelectParentGroup,
            unnestGroups: unnestGroups,
            triggerReloadGroups: triggerReloadGroups,
            triggerCloseSidenav: triggerCloseSidenav,
            massInsertUsersIntoGroups: massInsertUsersIntoGroups,
            attachExistingUserByEmail: attachExistingUserByEmail,
            copyUsersInGroupsToGroups: copyUsersInGroupsToGroups,
            moveUsersInGroupsToGroups: moveUsersInGroupsToGroups,
            insertUsersInGroupsBoolean: insertUsersInGroupsBoolean,
            segmentSubscriptionGroup: segmentSubscriptionGroup,
            removeUsersFromGroup: removeUsersFromGroup,
            getUsersGroupsTypes: getUsersGroupsTypes,
            getUsersInGroupStatus: getUsersInGroupStatus,
            getUsersAuditTrailByID: getUsersAuditTrailByID,
            getUsersAuditTrail: getUsersAuditTrail,
            getS3UploadPreSignedUrl: getS3UploadPreSignedUrl,
            getGroupsAccreditations: getGroupsAccreditations,
            saveTemplateExport: saveTemplateExport,
            getTemplatesExport: getTemplatesExport,
            getFileInfo: getFileInfo,
            importUsers: importUsers,
            exportUsers: exportUsers,
            getUserToken: getUserToken,
            changeGroupPriority: changeGroupPriority
        });

    }

})();

(function () {
    'use strict';

    angular
        .module('app.users')
        .service('usersActivityService', usersActivityService);

    /** @ngInject */
    // I provide access to the session store.
    function usersActivityService($rootScope, $q, $resource, userService, settingsDomainService, sessionService, COMMON, $window) {



        function get(options) {

            var deferred = $q.defer();
            var filters = [];

            _.forEach(options, function (value, key, list) {
                if (_.isObject(list[key])) {
                    _.forEach(list[key], function (filter, keyFilter, listFilter) {
                        if (!_.isEmpty(filter.selected)) {
                            filters.push({
                                field: filter.field,
                                name: filter.name,
                                values: filter.selected
                            });
                        }

                    });

                }
            });

            let opts = {
                domain: options.siteID,
                page: options.page,
                search: options.searchStringFilter,
                paginate: options.paginate,
                sortField: options.sortField,
                sortDir: options.sortDir,
                filters: JSON.stringify(filters),
                resultsPerPage: options.resultsPerPage ? options.resultsPerPage : 25
            };

            if (options.dateFrom && options.dateTo) {
                opts.dateFrom = options.dateFrom;
                opts.dateTo = options.dateTo;
            }
            resourceAuditTrail.get(opts,
                function (responseResult) {
                    for (var i = 0; i < responseResult.data.length; i++) {
                        responseResult.data[i].dateWithoutHours = moment(responseResult.data[i].date).format("MMM DD");
                        responseResult.data[i].action_data = JSON.parse(responseResult.data[i].action_data);
                        try {
                            responseResult.data[i].action_brief = JSON.parse(responseResult.data[i].action_brief);
                        } catch (e) { }
                    }
                    $rootScope.total_items = responseResult.total;
                    deferred.resolve(responseResult);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getOptions(options) {
            var deferred = $q.defer();

            // Return the promise.
            return (deferred.promise);
        }
 
        // var resourceAuditTrailByID = $resource(
        //     COMMON.BASE_API + "/domain/:domain/usersAuditTrail?user_id=:user_id", {
        //         // No default data.
        //     }, {
        //         get: {
        //             method: "GET",
        //             isArray: false
        //         }
        //     }
        // );
        var resourceAuditTrail = $resource(
            COMMON.BASE_API + "/domain/:domain/usersAuditTrail?withUser", {
                // No default data.
            }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            }
        );

        return ({
            get: get,
            getFilters: getOptions
        });

    }

})();



(function () {
    'use strict';

    angular.module('app.users')
        .controller('UsersActivityController', UsersActivityController);

    function UsersActivityController($scope, $rootScope, usersService, $mdDialog, $document, usersActivityService, requestContext, msUtils, $translate) {
        var vm = this;
        $scope.isLoading = true;
        vm.test = "hola"
        vm.page = 1;
        vm.loadMore = loadMore;
        vm.msScrollOptions = {
            suppressScrollX: true
        };
        vm.openImageDialog = openImageDialog;
        var siteID = requestContext.getParam("siteId");
        $scope.siteID = siteID;

        vm.translate = translate;


        vm.timeAgo = msUtils.timeAgo;

        vm.colors = ['blue-bg'];

        function translate(val) {
            return $translate.instant(val);
        }

        function openImageDialog(ev, images, ImageSelected, cropFormats, MediaFull) {
            $mdDialog.show({
                controller: 'MediaShowDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/dialogs/media-show/media-show-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                escapeToClose: false,
                locals: {
                    Images: images,
                    ImageSelected: ImageSelected,
                    cropFormats: cropFormats,
                    MediaFull: MediaFull,
                    Tags: false,
                    // Tasks: vm.tasks,
                    // event: ev
                }
            }).then(function () {
            });
        }


        function loadMore() {
            vm.page++;
            var options = {
                page: vm.page,
                siteID: $scope.siteID
            };
            $scope.isLoading = true;
            usersActivityService.get(options).then(function (response) {
                vm.userAuditTrailEvents = vm.userAuditTrailEvents.concat(response.data);
                $scope.isLoading = false;
            });
        }
        $scope.$on('pagination:loadStart', function (event) {
            $scope.isLoading = true;
        });
        $scope.$on('pagination:loadPage', function (event) {
            $scope.isLoading = false;
        });

    }


})();

(function() {
    'use strict';

    angular
        .module('app.content')
        .controller('EditContentSubSecCatsController', EditContentSubSecCatsController);

    /** @ngInject */
    function EditContentSubSecCatsController($mdDialog, $document, $anchorScroll, $timeout, $scope, 
        COMMON, $translate, contentService, siteId, section, name, type, event) {

        var vm = this;

        // Data
        vm.siteId = siteId;
        vm.section = section;
        vm.name = name;
        vm.type = type;
        vm.options = [];
        vm.event = event;
        vm.selectedOption = null;

        // Methods
        vm.editSelectedOption = editSelectedOption;
        vm.translate = instantTranslate;
        vm.closeDialog = closeDialog;
        vm.hasEdit = false;

        init();

        function init() {
            vm.loading = true;
            vm.optionsEdit = [];
            vm.options = contentService.getValuesReferencesSections(type);

            angular.forEach(vm.options, function(option){
                console.log(option);
                let newItem = {};
                switch(type) {
                    case 'subsection':
                        newItem['id'] = option.id_subsec;
                        newItem['name'] = option.subsec;
                        break;
                    case 'cat':
                        newItem['id'] = option.id_cat;
                        newItem['name'] = option.cat;
                        break;
                    case 'subcat':
                        newItem['id'] = option.id_subcat;
                        newItem['name'] = option.subcat;
                        break;
                }
                console.log(newItem);
                vm.optionsEdit.push(newItem);
            });
            vm.loading = false;
        }

        function editSelectedOption() {
            let promise;
            let opts = {
                site: vm.siteId,
                section: vm.section,
                id: vm.selectedOption.id,
                data: {}
            }
            switch (vm.type) {
                case 'subsection':
                    opts.data = {
                        'subsec': vm.selectedOption.name
                    }
                    promise = contentService.updateSubSec(opts);
                    break;
                case 'cat':
                    opts.data = {
                        'cat': vm.selectedOption.name
                    }
                    promise = contentService.updateCatSec(opts);
                    break;
                case 'subcat':
                    opts.data = {
                        'subcat': vm.selectedOption.name
                    }
                    promise = contentService.updateSubCat(opts);
                    break;
            }
            if (promise) {
                vm.loading = true;
                promise.then(function(res) {
                    vm.loading = false;
                    vm.hasEdit = true;
                });
            }
            
        }

        function closeDialog() {
            $mdDialog.hide(vm.hasEdit);
        }
        
        function instantTranslate(text)
        {
            return $translate.instant(text);
        }
    }
})();
(function () {
	'use strict';

	angular.module('app.content').controller('TagsController', TagsController);

	/** @ngInject */
	function TagsController($scope, $rootScope, $document, $mdDialog, $mdMedia, $mdToast, $mdSidenav, $state, msApi, requestContext, $timeout, tagsService, contentService,	msUtils, $anchorScroll, $translate, sessionService, tinyMceService) {
		var vm = this;

		// vm.folders = Folders.data;
		// vm.labels = Labels.data;
		vm.typeTag = [];
		vm.folders = [];
		vm.labels = [];
		vm.verifyStatus = [
			{
				status: 0,
				name: 'Unverified',
				label: 'VERIFY_0'
			},
			{
				status: 1,
				name: 'Verified',
				label: 'VERIFY_1'
			},
			{
				status: 2,
				name: 'Rejected',
				label: 'VERIFY_2'
			}
		]
		vm.saveTag = false;
		vm.loadingThreads = true;
		vm.enterfirst = true;
		vm.tags = null;
		vm.searchTagText = null;
		vm.selectedTag = null;
		vm.createFilterFor = createFilterFor;
		vm.selectedTagFilter = "0";
		vm.idFilterTag = 0;

		vm.scrollEl = angular.element('#thread-list')[0];

		vm.currentFilter = {
			type	: $state.params.type,
			filter: $state.params.filter
		};
		vm.currentThread = null;
		vm.currentThread_Edit = null;
		vm.thumbnails_Edit = {};
		vm.selectedThreads = [];
		vm.basicForm = {};
		vm.filters = {};

		vm.labelQuerySearch = labelQuerySearch;

		// vm.views = {
		// 	classic: 'app/main/apps/content/views/classic/classic-view.html',
		// 	outlook: 'app/main/apps/content/views/outlook/outlook-view.html'
		// };
		// vm.defaultView = 'outlook';
		// vm.currentView = 'outlook';

		vm.views = {
			nosplit: 'app/main/apps/tags/views/list/nosplit-view.html',
			split	: 'app/main/apps/tags/views/list/split-view.html',
			grid	 : 'app/main/apps/tags/views/grid/grid-view.html'
		};
		vm.defaultView = 'split';
		vm.currentView = 'split';
		vm.loadingView = true;

		vm.mediaZones = [];

		vm.showQiuGroupsSidenav = false;
		vm.newTagTitle = false;
		vm.selectedGroup = false;
		vm.isOpenSidenavGroups = true;
		vm.sortGroupsField = 'name';
		vm.sortGroupsDir = 'ASC';
		vm.sortGroupsBy = {
			"USERS.NAME": "name",
			"USERS.UPDATED_AT": "updated_at",
			"USERS.ID": "id_group",
			"USERS.SORT": "sort"
		};

		// Methods
		vm.init = init;
		vm.getInArray = msUtils.getInArray;
		vm.toggleInArray = msUtils.toggleInArray;
		vm.toggleInGroup = msUtils.toggleInGroup;
		vm.getReferencesSections = contentService.getReferencesSections;
		vm.getExtension = msUtils.getExtension;
		vm.getExtensionIcon = msUtils.getExtensionIcon;
		vm.getValuesReferencesSections = contentService.getValuesReferencesSections;

		vm.isTrueFalseChecked = isTrueFalseChecked;
		vm.toggleTrueFalseCheck = toggleTrueFalseCheck;
		vm.selectOrUnselect = selectOrUnselect;

		vm.loadFolder = loadFolder;
		vm.loadLabel = loadLabel;
		vm.isFolderActive = isFolderActive;
		vm.isLabelActive = isLabelActive;

		vm.newThread = newThread;
		vm.openThread = openThread;
		vm.closeThread = closeThread;
		vm.closeThreadEdit = closeThreadEdit;

		vm.isSelected = isSelected;
		vm.toggleSelectThread = toggleSelectThread;
		vm.selectThreads = selectThreads;
		vm.deselectThreads = deselectThreads;
		vm.toggleSelectThreads = toggleSelectThreads;

		vm.setThreadStatus = setThreadStatus;
		vm.toggleThreadStatus = toggleThreadStatus;
		vm.toggleItemStatus = toggleItemStatus;
		vm.toggleItemStatusEdit = toggleItemStatusEdit;
		vm.setItemStatus = setItemStatus;

		vm.getLabel = getLabel;
		vm.getLabelColor = getLabelColor;
		vm.getLabelTitle = getLabelTitle;
		vm.toggleLabel = toggleLabel;
		vm.isLabelExist = isLabelExist;

		vm.changeView = changeView;
		vm.viewEditInline = viewEditInline;
		vm.viewPreview = viewPreview;
		vm.saveItem = saveItem;
		vm.massActions = massActions;

		vm.composeDialog = composeDialog;
		vm.replyDialog = replyDialog;
		vm.openImageDialog = openImageDialog;
		vm.openFocalPoint = openFocalPoint;
		vm.siteLanguages = siteLanguages;
		vm.setTinyMceContent = setTinyMceContent;
		vm.getCurrentMedia	= getCurrentMedia;
		vm.newTag = newTag;
		vm.getZoneCrop	= getZoneCrop;

		vm.dateFormat = sessionService.site_operative.dateFormat;
		vm.dateTimeFormat = sessionService.site_operative.dateTimeFormat;
		vm.showDate = showDate;


		vm.isSelected = isSelected;
		vm.toggleSelectTag = toggleSelectTag;
		vm.selectTags = selectTags;
		vm.deselectTags = deselectTags;
		vm.toggleSelectTags = toggleSelectTags;
		vm.openTag = openTag;
		vm.selectedContentID = '';

		vm.getTags = getTags;
		vm.toggleQiuGroupsSidenav = toggleQiuGroupsSidenav;
		vm.createTagsGroups = createTagsGroups;
		vm.editTagsGroups = editTagsGroups;
		vm.deleteTagsGroups = deleteTagsGroups;
		vm.sortTagsGroups = sortTagsGroups;
		vm.massInsertIntoGroups = massInsertIntoGroups;
		vm.removeFromGroup = removeFromGroup;
		vm.showAddToGroupsButton = showAddToGroupsButton;
		vm.showRemoveFromGroupsButton = showRemoveFromGroupsButton;
		vm.unselectGroups = unselectGroups;

		vm.updateTagStatus = updateTagStatus;
		
		vm.changeSelectedFilterTag = changeSelectedFilterTag;

		vm.changeStatusFilter = changeStatusFilter;

		

		/**
		 * Toggle sidenav
		 *
		 * @param sidenavId
		 */
		function toggleQiuGroupsSidenav() {
			vm.showQiuGroupsSidenav = !vm.showQiuGroupsSidenav;
		}

		function unselectGroups() {
            vm.selectedGroup = false;
			vm.selectedContentID = false;
			vm.selectedContent = false;
            var elemList = document.querySelectorAll('.group-row');
            elemList.forEach(function (elem) {
                elem.classList.remove('selected');
            });
			getTags();
        }
		
		function changeSelectedFilterTag(){
			var groupIds = $rootScope.pagination_groupIds;
			var filter = vm.selectedTagFilter;
			var tagsTypes = vm.tagsTypes;
			if(filter != 0){
				for(var i=0; i<tagsTypes.length; i++){
					if(tagsTypes[i].name == filter){
						vm.idFilterTag = tagsTypes[i].id_type;
					}
				}	
			}else if( filter = "0"){
				vm.idFilterTag = 0;
			}
			getTags(groupIds);
		}

		function changeStatusFilter(){
			var groupIds = $rootScope.pagination_groupIds;
			if(!vm.filters){
				vm.filters = {};
			}
			if(vm.statusFilter != 'null'){
				vm.filters.verify = parseInt(vm.statusFilter);
			}else{
				delete vm.filters.verify;
			}
			getTags(groupIds);
		}

		function getTags(groupIds) {
			$rootScope.pagination_groupIds = groupIds;
			$scope.isLoading = true;
			var options = {
				siteID: $scope.siteID,
				sortDir: $rootScope.sortDir,
				sortField: $rootScope.sortField,
				page: 1,
				resultsPerPage: $rootScope.perPage,
				searchStringFilter: '',
				groupIds: groupIds,
				typeIds: vm.idFilterTag,
				verify: vm.filters.verify
			};
			tagsService.get(options).then(function (response) {
				vm.threads = response.data;
				$rootScope.pagination_totalItems = response.total;
				$rootScope.pagination_total_pages = response.last_page;
				if ($rootScope.pagination_page != response.current_page) {
					$rootScope.pagination_page = response.current_page;
				}
				vm.selectedThreads = [];
				$scope.isLoading = false;
			});
		}

		function getTagsGroups() {
			var currentlySelectedGroup = angular.copy(vm.selectedGroup);
			var options = {
				siteID: $scope.siteID,
				sortField: vm.sortGroupsField,
				sortDir: vm.sortGroupsDir
			}
			tagsService.getTagsGroupsNested(options).then(function(response) {
				if (currentlySelectedGroup) {
					var newSelectedGroup = msUtils.getGroupByIdNested(response.data, currentlySelectedGroup.id_group);
					if (newSelectedGroup) {
						newSelectedGroup.is_selected_group = true;
					}
				}
				vm.groups = response.data;
				if(vm.groups.length < 1){
					vm.toggleQiuGroupsSidenav();
				}
				vm.qiuRestrictions = response.qiuRestrictions;
				vm.showQiuGroupsSidenav = true;

			});
		}

		function getTagsTypes() {
			var options = {
				siteID: $scope.siteID
			}
			tagsService.getTagsTypes(options).then(function(response) {
				vm.tagsTypes = response
			})
		}

		function createTagsGroups(groupName, parentGroupId) {
			var options = {
				siteID: $scope.siteID,
				groupName: groupName,
				parentGroupId: parentGroupId
			};
			tagsService.createTagsGroups(options).then(function(response){
				getTagsGroups()
			})
		}

		function editTagsGroups(group, groupName, parentGroupId) {
			var options = {
				siteID: $scope.siteID,
				groupId: group.id_group,
				groupName: groupName,
				parentGroupId: parentGroupId
			};
			tagsService.editTagsGroups(options).then(function(response){
				getTagsGroups()
			})
		}

		function deleteTagsGroups(group) {
			var options = {
				siteID: $scope.siteID,
				groupId: group.id_group
			};
			tagsService.deleteTagsGroups(options).then(function(response){
				getTagsGroups()
			})
		}

		function sortTagsGroups(field, dir) {
			vm.sortGroupsField = field;
			vm.sortGroupsDir = dir;
			getTagsGroups();
		}

		function massInsertIntoGroups(itemIds, groups){
			const items = vm.selectedThreads;

			itemIds = items.map(x => { return x.id_tag })

			var options = {
				siteID: $scope.siteID,
				data: {
					id_tags: itemIds,
					groups: groups
				}
			};
			tagsService.massInsertIntoGroups(options)
				.then(function (response) {
					vm.reload = true;
					if (itemIds.length == 1) {
						var message = $translate.instant('TAGS.ADDTOGROUPS_SINGULAR');
					} else {
						var message = itemIds.length + ' ' + $translate.instant('TAGS.ADDTOGROUPS_PLURAL');
					}
					vm.loading = false;
					$mdToast.show({
						template: '<md-toast id="language-message"><span class="md-toast-text" flex>' + message + '</span><md-button ng-click="closeToast()">X</md-button></md-toast>',
						hideDelay: 7000,
						position: 'top right',
						parent: '#main'
					});
				});
		}

		function removeFromGroup(idGroup, itemIds) {
			const items = vm.selectedThreads;
			itemIds = items.map(x => { return x.id_tag })
			var options = {
				siteID: $scope.siteID,
				ids: itemIds,
				id_group: idGroup
			};
			tagsService.removeFromGroup(options)
				.then(function (response) {
					vm.loading = false;
					if (itemIds.length == 1) {
						var message = $translate.instant('TAGS.REMOVEFROMGROUP_SINGULAR');
					} else {
						var message = itemIds.length + ' ' + $translate.instant('TAGS.REMOVEFROMGROUP_PLURAL');
					}
					$mdToast.show({
						template: '<md-toast id="language-message"><span class="md-toast-text" flex>' + message + '</span><md-button ng-click="closeToast()">X</md-button></md-toast>',
						hideDelay: 7000,
						position: 'top right',
						parent: '#main'
					});
					vm.selectedThreads = [];
					$rootScope.pagination_resetquery();
			})
		}

		function showAddToGroupsButton() {
			const checked = vm.selectedThreads;
			return checked.length > 0;
		}

		function showRemoveFromGroupsButton() {
			const checked = vm.selectedThreads;
			return checked.length > 0;
		}

		vm.translate = function(text) {
			return $translate.instant(text);
		}


		function isSelected(tags) {
			return vm.selectedTags.indexOf(tags) > -1;
		}

		function toggleSelectTag(tag, event) {
			if (event) {
				event.stopPropagation();
			}
			if (vm.selectedTags.indexOf(tag) > -1) {
				vm.selectedTags.splice(vm.selectedTags.indexOf(tag), 1);
			} else {
				vm.selectedTags.push(tag);
			}
		}

		/**
		 * Select threads. If key/value pair given,
		 * threads will be tested against them.
		 *
		 * @param [key]
		 * @param [value]
		 */
		function selectTags(key, value) {
			// Make sure the current selection is cleared
			// before trying to select new threads
			vm.selectedTags = [];

			for (var i = 0; i < vm.tags.length; i++) {
				if (angular.isUndefined(key) && angular.isUndefined(value)) {
					vm.selectedTags.push(vm.tags[i]);
					continue;
				}

				if (angular.isDefined(key) && angular.isDefined(value) && vm.tags[i][key] === value) {
					vm.selectedTags.push(vm.tags[i]);
				}
			}
		}

		function deselectTags() {
			vm.selectedTags = [];
		}

		/**
		 * Toggle select threads
		 */
		function toggleSelectTags() {
			if (vm.selectedTags.length > 0) {
				vm.deselectTags();
			} else {
				vm.selectTags();
			}
		}

		function openTag(tag, id) {
			// Set the read status on the thread
			// thread.read = true;

			if (angular.element(document.getElementById('tag-detail')).length) {
				var elem = angular.element(document.getElementById('tag-detail'));
				elem.scrollTopAnimated(0, 10);
			}
			// pagesShown = 1;
			if (tag) {
				vm.selectedContentID = tag.id_tag;
			} else if (id) {
				vm.selectedContentID = id;
			}
			if (vm.selectedContentID != 'new') {
				vm.editInline = false;

				vm.loadingReadPane = true;

				$state.go('app.tags.tag', {
					id: vm.selectedContentID
				}, {
					notify	: false,
					inherit : true,
					location: true
				});

				var options = {
					site	 : $scope.siteID,
					id	: vm.selectedContentID
				};

				tagsService.getTagByID(options).then(function (response) {

					vm.selectedContent = response;
					vm.currentThread = response;
					//vm.updateThread(vm.currentThread);

					vm.loadingReadPane = false;

				});
			}
		}

		function showDate(value) {

			if (angular.isObject(value)) {
				return value.dateShow;
			} else if (value == '0000-00-00 00:00:00' || !value) {
				return '-';
			} else {
				var tz = (sessionService.site_operative.timezone || moment.tz.guess() || 'UTC').toString().trim();
				return moment.utc(value).tz(tz).format(vm.dateTimeFormat || 'DD/MM/YYYY HH:mm');
			}
		}


		vm.updateDatePicker = function (fld) {
			var value = moment.utc(vm.currentThread_Edit[fld].date).format('YYYY-MM-DD HH:mm:00');

			if (value == 'Invalid date') {
				vm.currentThread_Edit[fld] = {};
				vm.currentThread_Edit[fld]['value'] = '';
				vm.currentThread_Edit[fld]['date'] = '';
				vm.currentThread_Edit[fld]['dateShow'] = '';
				vm.currentThread_Edit[fld]['utcShow'] = '';
				vm.currentThread_Edit[fld]['utcDate'] = '';
			} else {
				var tz = (sessionService.site_operative.timezone || moment.tz.guess() || 'UTC').toString().trim();
				var utcDate = moment.utc(value);
				var siteDate = moment.utc(value).tz(tz);
				vm.currentThread_Edit[fld] = {};
				vm.currentThread_Edit[fld]['value'] = value;
				vm.currentThread_Edit[fld]['date'] = new Date(siteDate.format());
				vm.currentThread_Edit[fld]['dateShow'] = siteDate.format(vm.dateTimeFormat || 'DD/MM/YYYY HH:mm');
				vm.currentThread_Edit[fld]['utcShow'] = utcDate.format(vm.dateTimeFormat || 'DD/MM/YYYY HH:mm');
				vm.currentThread_Edit[fld]['utcDate'] = utcDate;
			}
		};


		vm.mediaSortable = {
			group	: 'media',
			animation : 150,
			scroll	: true,
			filter	: '.no-sort',
			ghostClass: "sort-drop",
			onEnd	: function (evt) {
				if (typeof evt.oldIndex == 'undefined' || typeof evt.newIndex == 'undefined')
					return;
				vm.currentThread_Edit.Thumbnail = [];
				angular.forEach(vm.thumbnails_Edit, function (thumbZone, idZone) {
					var i = 1;
					angular.forEach(thumbZone, function (data) {
						if (data.id_zone != idZone) {
							var dataOld = _.clone(data);
							if (angular.isUndefined(vm.currentThread_Edit.ThumbnailRemove))
								vm.currentThread_Edit.ThumbnailRemove = [];
							vm.currentThread_Edit.ThumbnailRemove.push(dataOld);
							data.id_zone = idZone * 1;
						}
						data.sort = i;
						vm.currentThread_Edit.Thumbnail.push(data)
						i = i + 1;
					})
				})
				vm.basicForm.$setDirty()
			}
		};

		 function setTinyMceContent(event) {
			var zoneMedia		= {
			 1: {},
			 2: {},
			 3: {},
			 4: {}
			};
			var typesMax		 = {
			 1: 0,
			 2: 0,
			 3: 0,
			 4: 0
			};
			var currentSort	= 0;
			var currentType	= 0;
			for (var i = 0; i < vm.currentThread_Edit.Thumbnail.length; i++) {
			 if (vm.currentThread_Edit.Thumbnail[i]['id_zone'] == 1) {
				currentSort = vm.currentThread_Edit.Thumbnail[i]['sort'];
				currentType = vm.currentThread_Edit.Thumbnail[i]['media_type'];
				typesMax[currentType]++;
				zoneMedia[currentType][typesMax[currentType]]	= vm.currentThread_Edit.Thumbnail[i];
			 }
			}
			return zoneMedia;
		 }

		vm.tinymceOptions = tinyMceService.getOptions($scope);
/*
		{
			theme				 : 'modern',
			height				: 500,
			remove_script_host	: false,
			allow_script_urls	 : true,
			convert_urls		 : false,
			// external_filemanager_path:"/scripts/filemanager/",
			// 	filemanager_title:"Responsive Filemanager" ,
			// 	external_plugins: { "filemanager" : "/scripts/filemanager/plugin.min.js"},
			// external_plugins: {
			//	 "myplugin": "/scripts/plugin.js"
			// },
			extended_valid_elements: 'script[language|type|src|async|charset]',
			plugins			 : [
				'qiumedia media advlist autolink lists link image charmap preview hr anchor pagebreak', 'searchreplace wordcount visualblocks visualchars code fullscreen imagetools', 'nonbreaking table contextmenu directionality', 'template paste textcolor colorpicker textpattern'
			],
			toolbar1			: ' insertfile undo redo | bold italic | alignleft aligncenter alignright alignjustify | forecolor backcolor | bullist numlist outdent indent | link unlink image media | code fullscreen buttonadv qiumedia',
			toolbar2			: '',
			content_style		: "#tinymce { font-size: 16px;line-height:1.6;font-family:'Helvetica Neue', sans-serif; }" +
			".align-left { text-align:left }" +
			".align-center { text-align:center }" +
			".align-right { text-align:right }" +
			".size-25 { width:25% }" +
			".size-50 { width:50% }" +
			".size-75 { width:75% }" +
			".size-100 { width:100% }",
			image_advtab		 : true,
			menubar			 : false,
			setup				 : function (editor) {
				editor.on('change', function (e) {
					if (vm.basicForm)
						vm.basicForm.$setDirty();
				});
			 editor.on('BeforeSetcontent', function(event){
				var zoneMedia	 = {
					1: {},
					2: {},
					3: {},
					4:	{}
				};
				var typesMax		 = {
					1: 0,
					2: 0,
					3: 0,
					4: 0
				};
				var currentSort	= 0;
				var currentType	= 0;
				for (var i = 0; i < vm.currentThread_Edit.Thumbnail.length; i++) {
					if (vm.currentThread_Edit.Thumbnail[i]['id_zone'] == 1) {
						 currentSort = vm.currentThread_Edit.Thumbnail[i]['sort'];
						 currentType = vm.currentThread_Edit.Thumbnail[i]['media_type'];
						 typesMax[currentType]++;
						 zoneMedia[currentType][typesMax[currentType]]	= vm.currentThread_Edit.Thumbnail[i];
					}
				}

			 	var cont	= event.content;
				var newCont	= cont;
				var regex = /(\[image\|([^\]]*)\])/g;
				var validData	= {
					left: 'align-left',
						center: 'align-center',
						right: 'align-right',
						25: 'size-25',
						50: 'size-50',
						75: 'size-75',
						100: 'size-100',
				}
				let m;

				while ((m = regex.exec(cont)) !== null) {
					var expCont	= '';
					var mediaData	= {
						 type: '',
						 sort: '',
						 class: ''
					};
					var mediaExtra	= '';
					// This is necessary to avoid infinite loops with zero-width matches
					if (m.index === regex.lastIndex) {
						 regex.lastIndex++;
					}
					if (m[2]) {
							expCont	= m[2].split('|');
						 mediaData.type	= 'image';
						 console.log(expCont);
						 for (var i = 0; i < expCont.length; i++) {
							if (i == 0) {
									mediaData.sort	= expCont[i];
								} else {
						 		mediaExtra	= expCont[i];
						 		if (!angular.isUndefined(validData[mediaExtra])) {
						 			mediaData.class	+= validData[mediaExtra] + ' ';
									}
								}
						 }
						 var newHtml = '<div class="qiumedia" data-qiumedia="' + m[0].substr(1,-1) + '"><img src="' + zoneMedia[1][mediaData.sort].cropstatus[0].container.view_url + zoneMedia[1][mediaData.sort].cropstatus[0].fileName + '" class="qiumedia-image ' + mediaData.class + '"></div>';
						 newCont		= newCont.replace(m[0], newHtml);
						 event.content = newCont;
					}
				}
			 });
			}
		};
*/
		function updateDatePicker(ev) {

		}

		// Attachments
		vm.deleteAttachment = deleteAttachment;
		vm.mediaDialog = mediaDialog;
		vm.mediaDialogTiny = mediaDialogTiny;
		vm.renderTinyMedia = renderTinyMedia;

		vm.toggleSidenav = toggleSidenav;
		vm.isNumber = isNumber;
		vm.updateThread = updateThread;

		//////////

		init();

		/**
		 * Initialize
		 */
		function init() {
			var siteID = requestContext.getParam("siteId");
			var section = requestContext.getParam("section");

			$scope.siteID = siteID;
			$scope.section = section;
			// $scope.section = "Tags";
			/*
			contentService.getFilters({section: section, site: siteID}).then(function (response) {
				vm.mediaZones = (response.media_zones.length == 0)
					? null
					: angular.copy(response.media_zones);
			});*/

			sessionService.setActiveSection(section).then(function () {
				vm.ActiveSection = sessionService.ActiveSection;
			});

			vm.viewSplit = true;
			vm.edit = false;
			vm.selectedTags = [];

			$scope.view_medialist = true;
			$scope.siteID = siteID;
			$scope.section = section;
			$rootScope.global.titleToolbar = '<i class="icon s20 icon-tag-multiple mr-15" ng-if="node.icon"></i> ' + $translate.instant('TAGS') ;

			var options = {
				site	 : $scope.siteID,
				section: $scope.section
			};

			/*
			if (angular.isUndefined(vm.tags) || vm.tags === null) {
				tagsService.getTags(options).then(function(response) {
					vm.tags = angular.copy(response.data);
				});
			}*/

			// $scope.page = 1;
			// request the initial set of data
			// loadRemoteData();
			$scope.page = 1;

			if ($state.params.id) {
				// for (var i = 0; i < vm.threads.length; i++) {
				// if (vm.threads[i].id === $state.params.threadId) {
				vm.openThread(null, $state.params.id);
				// break;
				// }
				// }
			}
			getTagsGroups();
			getTagsTypes();
		}

		// Watch screen size to change view modes
		$scope.$watch(function () {
			return $mdMedia('lt-sm');
		}, function (current, old) {
			if (angular.equals(current, old)) {
				return;
			}

			if (current) {
				vm.currentView = 'nosplit';
			}
		});

		$scope.$watch(function () {
				return $mdMedia('max-width: 960px');
			}, function (big) {

				if (big)
					vm.currentView = 'nosplit';

			}
		);

		$scope.$watch(function () {
				return $mdMedia('min-width: 960px');
			}, function (small) {

				if (small)
					vm.currentView = 'split';

			}
		);

		$scope.$watch(function () {
			return $mdMedia('gt-sm');
		}, function (current, old) {
			if (angular.equals(current, old)) {
				return;
			}

			if (current) {
				if (vm.defaultView === 'split') {
					vm.currentView = 'split';
				}
			}
		});

		$scope.$on('$includeContentLoaded', function (event, target) {
			$timeout(function () {
				vm.loadingView = false;
			}, 1000);
		});

		$scope.$on('pagination:loadStart', function (event) {
			// $anchorScroll();

			// Store the current scrollPos
			// vm.scrollPos = vm.scrollEl.scrollTop();

			// Scroll to the top
			// vm.scrollEl.scrollTop(0);
			if (!vm.enterfirst) {
				var elem = angular.element(document.getElementById('thread-list'));
				elem.scrollTopAnimated(0, 10);
			}

			// angular.element("#thread-list").scrollTop=0;

			vm.enterfirst = false;

			$scope.isLoading = true;
		});

		$scope.$on('pagination:loadPage', function (event) {
			$scope.isLoading = false;
			vm.dataAlreadyLoaded = true;
		});

		/**
		 * Load folder
		 *
		 * @param name
		 */
		function loadFolder(name) {
			// If we are already in the selected folder and
			// there is an open thread just close it
			if (vm.isFolderActive(name)) {
				// Close the current thread if open
				if (vm.currentThread) {
					vm.closeThread();
				}

				return;
			}

			// Show loader
			$rootScope.loadingProgress = true;

			// Update the state without reloading the controller
			$state.go('app.tags.threads', {
				type	: null,
				filter: name
			}, {notify: false});

			// Build the API name
			var apiName = 'content.folder.' + name + '@get';

			// Make the call
			msApi.request(apiName).then(
				// Success
				function (response) {
					// Load new threads
					vm.threads = response.data;
					// Set the current filter
					vm.currentFilter = {
						type	: null,
						filter: name
					};

					// Close the current thread if open
					if (vm.currentThread) {
						vm.closeThread();
					}

					// Hide loader
					$rootScope.loadingProgress = false;
				});
		}

		function selectOrUnselect(item, $event) {
			// var indexInTemp = $scope.temps.indexOf(item);
			var isRightClick = $event && $event.which == 3;
			var isDoubleClick = $event && $event.type == 'dblclick';

			// if ($event && $event.target.hasAttribute('prevent')) {
			//	$scope.temps = [];
			//	return;
			// }
			// if (! item || (isRightClick && $scope.isSelected(item))) {
			//	return;
			// }
			// if ($event && $event.shiftKey && !(isRightClick) && !(isDoubleClick)) {
			//	var list = $scope.fileList;
			//	var indexInList = list.indexOf(item);
			//	var lastSelected = $scope.temps[0];
			//	var i = list.indexOf(lastSelected);
			//	var current = undefined;
			//	if (lastSelected && list.indexOf(lastSelected) < indexInList) {
			//		$scope.temps = [];
			//		while (i <= indexInList) {
			//			 current = list[i];
			//			 !$scope.isSelected(current) && $scope.temps.push(current);
			//			 i++;
			//		}
			//		return;
			//	}
			//	if (lastSelected && list.indexOf(lastSelected) > indexInList) {
			//		$scope.temps = [];
			//		while (i >= indexInList) {
			//			 current = list[i];
			//			 !$scope.isSelected(current) && $scope.temps.push(current);
			//			 i--;
			//		}
			//		return;
			//	}
			// }
			// if ($event && !(isRightClick) && !(isDoubleClick) && ($event.ctrlKey || $event.metaKey)) {
			//	$scope.isSelected(item) ? $scope.temps.splice(indexInTemp, 1) : $scope.temps.push(item);
			//	return;
			// }
			// $scope.temps = [item];
		};

		/**
		 * Toggle checked status of the content
		 *
		 * @param content
		 * @param event
		 */
		function toggleTrueFalseCheck(field, event) {
			if (event) {
				event.stopPropagation();
			}

			if (vm.selectedContent[field]) {
				vm.selectedContent[field] = false;
			} else {
				vm.selectedContent[field] = true;
			}

			// var idx = vm.checked.indexOf(content);

			// if (idx > -1) {
			// 	vm.checked.splice(idx, 1);
			// } else {
			// 	vm.checked.push(content);
			// }
		}

		/**
		 * Return checked status of the content
		 *
		 * @param content
		 * @returns {boolean}
		 */
		function isTrueFalseChecked(fieldStatus) {
			return fieldStatus
				? true
				: false;
			// return vm.checked.indexOf(content) > -1;
		}

		/**
		 * Load label
		 *
		 * @param name
		 */
		function loadLabel(name) {
			// Update the state without reloading the controller
			$state.go('app.tags.threads', {
				type	: 'label',
				filter: name
			}, {notify: false});

			// If we are already in the selected folder and
			// there is an open thread just close it
			if (vm.isLabelActive(name)) {
				// Close the current thread if open
				if (vm.currentThread) {
					vm.closeThread();
				}

				return;
			}

			// Show loader
			$rootScope.loadingProgress = true;

			// Build the API name
			var apiName = 'content.label.' + name + '@get';

			// Make the call
			msApi.request(apiName).then(
				// Success
				function (response) {
					// Load new threads
					vm.threads = response.data;
					// Set the current filter
					vm.currentFilter = {
						type	: 'label',
						filter: name
					};

					// Close the current thread if open
					if (vm.currentThread) {
						vm.closeThread();
					}

					// Hide loader
					$rootScope.loadingProgress = false;
				});
		}

		/**
		 * Is the folder with the given name active?
		 *
		 * @param name
		 * @returns {boolean}
		 */
		function isFolderActive(name) {
			return (vm.currentFilter.type === null && vm.currentFilter.filter === name);
		}

		/**
		 * Is the label with the given name active?
		 *
		 * @param name
		 * @returns {boolean}
		 */
		function isLabelActive(name) {
			return (vm.currentFilter.type === 'label' && vm.currentFilter.filter === name);
		}

		/**
		 * Open thread
		 *
		 * @param thread
		 */
		function openThread(thread, id) {
			// Set the read status on the thread
			// thread.read = true;
			if (angular.element(document.getElementById('thread-detail')).length) {
				var elem = angular.element(document.getElementById('thread-detail'));
				elem.scrollTopAnimated(0, 10);
			}
			// pagesShown = 1;
			if (thread) {
				vm.selectedContentID = thread.id_tag;
			} else if (id) {
				vm.selectedContentID = id;
			}
			if (vm.selectedContentID != 'new') {
				vm.editInline = false;

				vm.loadingReadPane = true;

				$state.go('app.site_overview.tags.list.thread', {
					id: vm.selectedContentID
				}, {
					notify	: false,
					inherit : true,
					location: true
				});

				var options = {
					site	 : $scope.siteID,
					section: $scope.section,
					section: "Tags",
					id	: vm.selectedContentID
				};

				if (angular.isUndefined(vm.tags) || vm.tags === null) {
					contentService.getTags(options).then(function (response) {
						vm.tags = angular.copy(response.tags);
					});

				}

				tagsService.getTagByID(options).then(function (response) {
					var useTagsOptions = {
						siteID: $scope.siteID,
						id: response.id_tag
					}
					tagsService.getTagService(useTagsOptions).then(function(response2) {
							response.use = {
								media: response2.media,
								content: Object.values(response2.content || {})
									.filter(arr => Array.isArray(arr) && arr.length && typeof arr[0] === 'object')
									.flat()
							};
							vm.selectedContent = response;
							vm.currentThread = response;
							var indexT = vm.selectedContent.id_type;
							$scope.indexType = vm.selectedContent.id_type - 1;

							vm.updateThread(vm.currentThread);
							vm.log = response.log;

							/*
							for (var i = response.ref.length - 1; i >= 0; i--) {
								if (response.ref[i].type.substr(0, 4) == 'date') {

									var value = vm.selectedContent[response.ref[i].titleId];
									if (value == '0000-00-00 00:00:00') {
																		value = moment().format("YYYY-MM-DD");
																}

									var utcDate = moment.utc(value);

									var siteDate = moment.utc(value).tz(sessionService.site_operative.timezone);

									vm.selectedContent[response.ref[i].titleId] = {};
									vm.selectedContent[response.ref[i].titleId]['value'] = value;
									vm.selectedContent[response.ref[i].titleId]['date'] = new Date(siteDate.format());
									vm.selectedContent[response.ref[i].titleId]['dateShow'] = siteDate.format(vm.dateTimeFormat);
									vm.selectedContent[response.ref[i].titleId]['utcShow'] = utcDate.format(vm.dateTimeFormat);
									vm.selectedContent[response.ref[i].titleId]['utcDate'] = utcDate;
								}
							}
							vm.selectedContent_ref = response.ref;
							vm.selectedContent_refgrouped = _.groupBy(response.ref, function (m) {
								return m.preview_position;
							});*/
							;

							vm.loadingReadPane = false;
						}
					);
				});

			}
			;
		}

		/**
		 * New thread
		 *
		 */
		function newThread() {
			if (angular.element(document.getElementById('thread-detail')).length) {
				var elem = angular.element(document.getElementById('thread-detail'));
				elem.scrollTopAnimated(0, 10);
			}

			vm.selectedContentID = '';
			vm.editInline = false;
			vm.loadingReadPane = true;

			$state.go('app.site_overview.tags.list.thread', {
				id: ''
			}, {
				notify	: false,
				inherit : true,
				location: true
			});

			vm.currentThread = '';
			vm.log = [];

			vm.selectedContent = {};

			vm.loadingReadPane = false;
			vm.viewEditInline();

			/*
			contentService.getNew(options).then(function (response) {
				vm.selectedContent = {
					Thumbnail: []
				};
				vm.currentThread = '';
				vm.log = [];

				for (var i = response.ref.length - 1; i >= 0; i--) {
					if (response.ref[i].type.substr(0, 4) == 'date') {
						var value = moment().format("YYYY-MM-DD HH:mm:00");

						var utcDate = moment.utc(value);

						var siteDate = moment.utc(value).tz(sessionService.site_operative.timezone);

						vm.selectedContent[response.ref[i].titleId] = {};
						vm.selectedContent[response.ref[i].titleId]['value'] = value;
						vm.selectedContent[response.ref[i].titleId]['date'] = new Date(siteDate.format());
						vm.selectedContent[response.ref[i].titleId]['dateShow'] = siteDate.format(vm.dateTimeFormat);
						vm.selectedContent[response.ref[i].titleId]['utcShow'] = utcDate.format(vm.dateTimeFormat);
						vm.selectedContent[response.ref[i].titleId]['utcDate'] = utcDate;
					}
				}
				vm.selectedContent_ref = response.ref;
				vm.selectedContent_refgrouped = _.groupBy(response.ref, function (m) {
					return m.preview_position;
				});
				;

				vm.loadingReadPane = false;
				vm.viewEditInline();
			});*/
		}

		/**
		 * Close thread Edit
		 */
		function closeThreadEdit() {
			resetScroll();
			vm.editInline = false;
			vm.currentThread_Edit = false;
			vm.currentThread_ref = false;
		}

		/**
		 * Close thread
		 */
		function closeThread() {
			vm.currentThread = null;
			vm.selectedContent = null;
			vm.selectedContentID = null;

			// Update the state without reloading the controller
			$state.go('app.site_overview.tags.list', {
				type	: vm.currentFilter.type,
				filter: vm.currentFilter.filter
			}, {notify: false});
		}

		/**
		 * Add label chips
		 *
		 * @param query
		 * @returns {filterFn}
		 */
		function labelQuerySearch(query) {
			return query
				? vm.tags.filter(vm.createFilterFor(query))
				: [];
		}

		/**
		 * Filter for chips
		 *
		 * @param query
		 * @returns {filterFn}
		 */
		function createFilterFor(query) {
			var lowercaseQuery = angular.lowercase(query);
			return function filterFn(item) {
				if (angular.isUndefined(item.tag_name))
					return false;
				if (!angular.lowercase(item.tag_name.toString()).indexOf)
					return false;
				return angular.lowercase(item.tag_name.toString()).indexOf(lowercaseQuery) >= 0;
			};
		}

		/**
		 * Return checked status of the content
		 *
		 * @param content
		 * @returns {boolean}
		 */
		function saveItem(content) {
			vm.saveTag = true;

			var newContent = angular.copy(content);

			/*
			for (var i = vm.currentThread_ref.length - 1; i >= 0; i--) {
				if (vm.currentThread_ref[i].type.substr(0, 4) == 'date') {
					newContent[vm.currentThread_ref[i].titleId] = newContent[vm.currentThread_ref[i].titleId].value;
				} else if (vm.currentThread_ref[i].type.substr(0, 4) == 'html') {
					var newHtml	= newContent[vm.currentThread_ref[i].titleId];
					var str		= newContent[vm.currentThread_ref[i].titleId];
				var regex = /<div\b[^>]*data-qiumedia="(.*?)"[^>]*>([\s\S]*)<\/div>/g;

				var m;

				while ((m = regex.exec(str)) !== null) {
					// This is necessary to avoid infinite loops with zero-width matches
					if (m.index === regex.lastIndex) {
						 regex.lastIndex++;
					}

					if (m[0] && m[1]) {
						newHtml	= newHtml.replace(m[0], '[' + m[1] + ']');
						}

				newContent[vm.currentThread_ref[i].titleId]	= newHtml;

			 }
			}*/
			if (!content.id_tag) {
				content.id_tag = '';
			}

			var options = {
				site	 : $scope.siteID,
				id	: content.id_tag,
				section: "Tags",
				item	 : newContent
			};

			tagsService.saveItem(options).then(function (response) {
				if (content.id_tag === '') {
					if (vm.selectedGroup) {
						var groups = [vm.selectedGroup];
						if (vm.groups[0].is_qiu_restricted_root && vm.groups[0].id_group != vm.selectedGroup.id_group) {
							groups.push(vm.groups[0]);
						}
						var options = {
							siteID: $scope.siteID,
							data: {
								id_tags: [response.id_tag],
								groups: groups
							}
						};
						tagsService.massInsertIntoGroups(options).then(function(){
							$rootScope.pagination_reload();
							vm.saveTag = false;
						});
					}
					content.id_tag = response.id_tag
					$rootScope.pagination_resetquery();
					vm.viewPreview();
					vm.openThread('', response.id_tag);
				} else {
					vm.viewPreview();
					vm.openThread(content);
					vm.saveTag = false;
				}
				vm.closeThreadEdit();

				var message = $translate.instant('TAG.SAVED');
				$mdToast.show({
					template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
					hideDelay: 5000,
					position: 'top',
					parent: '#content-container'
				});
				return true;
			});

		}

		/**
		 * Executes action on selected tags
		 *
		 * @param action
		 * @returns {boolean}
		 */
		function massActions(action) {

			if (vm.selectedThreads.length === 0) return false;
			var selectedIds = [];

			for (var i = 0; i < vm.selectedThreads.length; i++) {
				selectedIds.push(vm.selectedThreads[i].id_tag);
			}
			switch (action) {
				case 'delete':
					if (selectedIds.length == 1) {
						var confirmTitle = $translate.instant('TAGS.SURE_DELETE_SINGULAR_TITLE');
						var confirmContent = $translate.instant('TAGS.SURE_DELETE_SINGULAR_CONTENT');
						var message = $translate.instant('TAGS.DELETED_SINGULAR');
					} else {
						var confirmTitle = $translate.instant('TAGS.SURE_DELETE_PLURAL_TITLE');
						var confirmContent = $translate.instant('TAGS.SURE_DELETE_PLURAL_CONTENT');
						var message = $translate.instant('TAGS.DELETED_PLURAL');
					}
					break;
				case 'duplicate':
					if (selectedIds.length == 1) {
						var confirmTitle = $translate.instant('TAGS.SURE_DUPLICATE_SINGULAR_TITLE');
						var confirmContent = $translate.instant('TAGS.SURE_DUPLICATE_SINGULAR_CONTENT');
						var message = $translate.instant('TAGS.DUPLICATED_SINGULAR');
					} else {
						var confirmTitle = $translate.instant('TAGS.SURE_DUPLICATE_PLURAL_TITLE');
						var confirmContent = $translate.instant('TAGS.SURE_DUPLICATE_PLURAL_CONTENT');
						var message = $translate.instant('TAGS.DUPLICATED_PLURAL');
					}
					break;
			}

			var confirm = $mdDialog.confirm().title(confirmTitle).htmlContent('<b>' + confirmContent + '</b>.')
							.ariaLabel(confirmContent).targetEvent(event).ok('OK').cancel('CANCEL');

			$mdDialog.show(confirm).then(function () {

				var options = {
					site	 : $scope.siteID,
					section: $scope.section,
					action : action,
					ids : selectedIds
				};

				tagsService.massActions(options).then(function (response) {
					vm.toggleSelectThreads();
					$rootScope.pagination_resetquery();
					vm.closeThread();
					$mdToast.show({
						template : '<md-toast id="language-message"><span class="md-toast-text" flex>' + message + '</span><md-button ng-click="closeToast()">X</md-button></md-toast>',
						hideDelay: 7000,
						position : 'top right',
						parent	 : '#main'
					});
				});
			});

		}

		$scope.closeToast = function () {
			if (isDlgOpen)
				return;

			$mdToast.hide().then(function () {
				isDlgOpen = false;
			});
		};

		/**
		 * Return selected status of the thread
		 *
		 * @param thread
		 * @returns {boolean}
		 */
		function isSelected(thread) {
			return vm.selectedThreads.indexOf(thread) > -1;
		}

		/**
		 * Toggle selected status of the thread
		 *
		 * @param thread
		 * @param event
		 */
		function toggleSelectThread(thread, event) {
			if (event) {
				event.stopPropagation();
			}

			if (vm.selectedThreads.indexOf(thread) > -1) {
				vm.selectedThreads.splice(vm.selectedThreads.indexOf(thread), 1);
			} else {
				vm.selectedThreads.push(thread);
			}
		}

		/**
		 * Select threads. If key/value pair given,
		 * threads will be tested against them.
		 *
		 * @param [key]
		 * @param [value]
		 */
		function selectThreads(key, value) {
			// Make sure the current selection is cleared
			// before trying to select new threads
			vm.selectedThreads = [];

			for (var i = 0; i < vm.threads.length; i++) {
				if (angular.isUndefined(key) && angular.isUndefined(value)) {
					vm.selectedThreads.push(vm.threads[i]);
					continue;
				}

				if (angular.isDefined(key) && angular.isDefined(value) && vm.threads[i][key] === value) {
					vm.selectedThreads.push(vm.threads[i]);
				}
			}
		}

		/**
		 * Deselect threads
		 */
		function updateThread(itemThread) {
			for (var i = 0; i < vm.threads.length; i++) {
				if (vm.threads[i]['id_tag'] == itemThread['id_tag']) {
					vm.threads[i] = itemThread;
				}
				// if (angular.isUndefined(key) && angular.isUndefined(value)) {
				// 	vm.selectedThreads.push(vm.threads[i]);
				// 	continue;
				// }

				// if (angular.isDefined(key) && angular.isDefined(value) && vm.threads[i][key] === value) {
				// 	vm.selectedThreads.push(vm.threads[i]);
				// }
			}
		}

		/**
		 * Deselect threads
		 */
		function deselectThreads() {
			vm.selectedThreads = [];
		}

		/**
		 * Toggle select threads
		 */
		function toggleSelectThreads() {
			if (vm.selectedThreads.length > 0) {
				vm.deselectThreads();
			} else {
				vm.selectThreads();
			}
		}

		/**
		 * Set the status on given thread, current thread or selected threads
		 *
		 * @param key
		 * @param value
		 * @param [thread]
		 * @param [event]
		 */
		function setThreadStatus(key, value, thread, event) {
			// Stop the propagation if event provided
			// This will stop unwanted actions on button clicks
			if (event) {
				event.stopPropagation();
			}

			// If the thread provided, do the changes on that
			// particular thread
			if (thread) {
				thread[key] = value;
				return;
			}

			// If the current thread is available, do the
			// changes on that one
			if (vm.currentThread) {
				vm.currentThread[key] = value;
				return;
			}

			// Otherwise do the status update on selected threads
			for (var x = 0; x < vm.selectedThreads.length; x++) {
				vm.selectedThreads[x][key] = value;
			}
		}

		/**
		 * Toggle the value of the given key on given thread, current
		 * thread or selected threads. Given key value must be boolean.
		 *
		 * @param key
		 * @param thread
		 * @param event
		 */
		function toggleItemStatus(thread, event, key) {

			event.stopPropagation();

			var confirm = $mdDialog.confirm().title('Are you sure want to set the item?').htmlContent('<b>This item will be changed </b>.')
				// .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' will be deleted.')
				.ariaLabel('change item').targetEvent(event).ok('OK').cancel('CANCEL');

			$mdDialog.show(confirm).then(function () {

				thread.onoff = (thread.onoff === 1)
					? 0
					: 1;

				vm.threads[key].onoff = thread.onoff;

				var options = {
					site	 : $scope.siteID,
					section: $scope.section,
					id	: vm.threads[key].id,
					item	 : vm.threads[key]
				};

				contentService.saveItem(options).then(function (response) {
					// vm.viewPreview();
					// vm.selectContent(content);
					var message = "Saved";

					$mdToast.show({
						template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
						hideDelay: 5000,
						position: 'top',
						parent: '#content-container'
					});

					return true;
				});

			}, function () {
				// alert("cancel")

			});

			return;
			// Stop the propagation if event provided
			// This will stop unwanted actions on button clicks
			if (event) {
				event.stopPropagation();
			}

			// If the thread provided, do the changes on that
			// particular thread
			if (thread) {
				if (typeof(thread[key]) !== 'boolean') {
					return;
				}

				thread[key] = !thread[key];
				return;
			}

			// If the current thread is available, do the
			// changes on that one
			if (vm.currentThread) {
				if (typeof(vm.currentThread[key]) !== 'boolean') {
					return;
				}

				vm.currentThread[key] = !vm.currentThread[key];
				return;
			}

			// Otherwise do the status update on selected threads
			for (var x = 0; x < vm.selectedThreads.length; x++) {
				if (typeof(vm.selectedThreads[x][key]) !== 'boolean') {
					continue;
				}

				vm.selectedThreads[x][key] = !vm.selectedThreads[x][key];
			}
		}

		/**
		 * Toggle the value of the given key on given thread, current
		 * thread or selected threads. Given key value must be boolean.
		 *
		 * @param key
		 * @param thread
		 * @param event
		 */
		function toggleItemStatusEdit(fieldName) {

			event.stopPropagation();
			var thread = vm.currentThread_Edit[fieldName];
			switch (true){
				case (thread == 1):
					thread = 2;
					break;
				case (thread == 2):
					thread = 0;
					break;
				case (thread == 0):
					thread = 1;
					break;
			}

			vm.currentThread_Edit[fieldName] = thread;
			vm.basicForm.$setDirty()
		}

		function setItemStatus(fieldName,status) {

			event.stopPropagation();
			vm.currentThread_Edit[fieldName] = status;
			vm.basicForm.$setDirty()
		}

		function deleteAttachment(attachment) {

			if (attachment.id_zone) {
				for (var i = 0; i < vm.currentThread_Edit.Thumbnail.length; i++) {
					if (vm.currentThread_Edit.Thumbnail[i].id_media === attachment.id_media && vm.currentThread_Edit.Thumbnail[i].id_zone === attachment.id_zone) {
						if (angular.isUndefined(vm.currentThread_Edit.ThumbnailRemove))
							vm.currentThread_Edit.ThumbnailRemove = [];
						vm.currentThread_Edit.ThumbnailRemove.push(vm.currentThread_Edit.Thumbnail[i]);
						vm.currentThread_Edit.Thumbnail.splice(i, 1);
					}
				}

				for (var i = 0; i < vm.thumbnails_Edit[attachment.id_zone].length; i++) {
					if (vm.thumbnails_Edit[attachment.id_zone][i].id_media === attachment.id_media) {
						vm.thumbnails_Edit[attachment.id_zone].splice(i, 1);
					}
				}

			} else {
				if (vm.currentThread_Edit.Thumbnail[i].id_media === attachment.id_media) {
					if (angular.isUndefined(vm.currentThread_Edit.ThumbnailRemove))
						vm.currentThread_Edit.ThumbnailRemove = [];
					vm.currentThread_Edit.ThumbnailRemove.push(vm.currentThread_Edit.Thumbnail[i]);
					vm.currentThread_Edit.Thumbnail.splice(i, 1);
				}
			}
			vm.basicForm.$setDirty()

		}

		/**
		 * Toggle the value of the given key on given thread, current
		 * thread or selected threads. Given key value must be boolean.
		 *
		 * @param key
		 * @param thread
		 * @param event
		 */
		function toggleThreadStatus(key, thread, event) {
			// Stop the propagation if event provided
			// This will stop unwanted actions on button clicks
			if (event) {
				event.stopPropagation();
			}

			// If the thread provided, do the changes on that
			// particular thread
			if (thread) {
				if (typeof(thread[key]) !== 'boolean') {
					return;
				}

				thread[key] = !thread[key];
				return;
			}

			// If the current thread is available, do the
			// changes on that one
			if (vm.currentThread) {
				if (typeof(vm.currentThread[key]) !== 'boolean') {
					return;
				}

				vm.currentThread[key] = !vm.currentThread[key];
				return;
			}

			// Otherwise do the status update on selected threads
			for (var x = 0; x < vm.selectedThreads.length; x++) {
				if (typeof(vm.selectedThreads[x][key]) !== 'boolean') {
					continue;
				}

				vm.selectedThreads[x][key] = !vm.selectedThreads[x][key];
			}
		}

		/**
		 * Get label object content
		 *
		 * @param id
		 * @returns {*}
		 */
		function getLabel(id) {
			for (var i = 0; i < vm.labels.length; i++) {
				if (vm.labels[i].id === id) {
					return vm.labels[i];
				}
			}
		}

		/**
		 * Get label color from label object
		 *
		 * @param id
		 * @returns {*}
		 */
		function getLabelColor(id) {
			return vm.getLabel(id).color;
		}

		/**
		 * Get label title from label object
		 *
		 * @param id
		 * @returns {*}
		 */
		function getLabelTitle(id) {
			return vm.getLabel(id).title;
		}

		/**
		 * Toggle label
		 *
		 * @param label
		 */
		function toggleLabel(label) {
			// Toggle label on the currently open thread
			if (vm.currentThread) {
				if (vm.currentThread.labels.indexOf(label.id) > -1) {
					vm.currentThread.labels.splice(vm.currentThread.labels.indexOf(label.id), 1);
				} else {
					vm.currentThread.labels.push(label.id);
				}

				return;
			}

			// Toggle labels on selected threads
			// Toggle action will be determined by the first thread from the selection.
			if (vm.selectedThreads.length > 0) {
				// Decide if we are going to remove or add labels
				var removeLabels = (vm.selectedThreads[0].labels.indexOf(label.id) > -1);

				for (var i = 0; i < vm.selectedThreads.length; i++) {
					if (!removeLabels) {
						vm.selectedThreads[i].labels.push(label.id);
						continue;
					}

					if (vm.selectedThreads[i].labels.indexOf(label.id) > -1) {
						vm.selectedThreads[i].labels.splice(vm.selectedThreads[i].labels.indexOf(label.id), 1);
					}
				}
			}
		}

		/**
		 * Is label exist?
		 *
		 * @param label
		 * @returns {boolean}
		 */
		function isLabelExist(label) {
			if (vm.currentThread && vm.currentThread.labels) {
				return (vm.currentThread.labels.indexOf(label.id) > -1);
			}
		}

		/**
		 * Change the view
		 *
		 * @param view
		 */
		function changeView(view) {
			if (vm.views[view]) {
				vm.loadingView = true;
				vm.defaultView = view;
				vm.currentView = view;
			}
		}

		/**
		 * Toggle view Edit
		 */
		function viewEditInline() {
			resetScroll();
			vm.editInline = true;
			vm.currentThread_Edit = angular.copy(vm.selectedContent);
			vm.currentThread_ref = angular.copy(vm.selectedContent_ref);

			angular.forEach(vm.selectedContent_ref, function (refColumn) {
				switch (refColumn.type) {
					case 'date':
					case 'dateHm':
						var type = 'input';
						break;
					case 'single':
						var type = 'input';
						break;
					default:
						break;
				}
			});
		}

		/**
		 * Toggle view Edit
		 */
		function viewPreview() {
			resetScroll();
			vm.editInline = false;
		}

		function resetScroll() {
			if (angular.element(document.getElementById('thread-detail')).length) {
				var elem = angular.element(document.getElementById('thread-detail'));
				elem.scrollTopAnimated(0, 10);
			}
		}

		/**
		 * Open compose dialog
		 *
		 * @param ev
		 */

		function composeDialog(ev) {
			$mdDialog.show({
				controller		: 'ComposeDialogController',
				controllerAs		: 'vm',
				locals			 : {
					selectedContent: undefined
				},
				templateUrl		 : 'app/main/dialogs/compose/compose-dialog.html',
				parent			 : angular.element($document.body),
				targetEvent		 : ev,
				clickOutsideToClose: true
			});
		}

		/**
		 * Open Image dialog
		 *
		 * @param ev
		 * @param task
		 */
		function openImageDialog(ev, images, ImageSelected) {
			$mdDialog.show({
				controller		: 'MediaShowDialogController',
				controllerAs		: 'vm',
				templateUrl		 : 'app/main/dialogs/media-show/media-show-dialog.html',
				parent			 : angular.element($document.body),
				targetEvent		 : ev,
				clickOutsideToClose: true,
				locals			 : {
					Images		: images,
					ImageSelected: ImageSelected,
					cropFormats: false,
					MediaFull: false,
					Tags: false,
					// Tasks: vm.tasks,
					// event: ev
				}
			});
		}

		/**
		 * Open Image dialog
		 *
		 * @param ev
		 * @param task
		 */
		function openFocalPoint(ev, ImageSelected) {
			$mdDialog.show({
				controller		: 'MediaFocalPointDialogController',
				controllerAs		: 'vm',
				templateUrl		 : 'app/main/dialogs/media-focal-point/media-focal-point-dialog.html',
				parent			 : angular.element($document.body),
				targetEvent		 : ev,
				clickOutsideToClose: true,
				locals			 : {
					ImageSelected: ImageSelected,
				}
			}).then(function (item) {
			 vm.basicForm.$setDirty()
			 angular.forEach(vm.mediaZones, function (mediazone) {
				angular.forEach(vm.thumbnails_Edit[mediazone.id_zone], function (attachment) {
					if(item.id_media===attachment.id_media){
						 attachment.imageCenterRatioX = item.imageCenterRatioX;
						 attachment.imageCenterRatioY = item.imageCenterRatioY;
					}
				})
			 })
			});
		}

		/**
		 * Open compose dialog
		 *
		 * @param ev
		 */

		function mediaDialog(ev, mediazone, item) {
			$mdDialog.show({
				controller		: 'MediaDialogController',
				controllerAs		: 'vm',
				locals			 : {
					currentThread: item,
					section	 : $scope.section,
					mediazone	: mediazone,
					isTiny		 : false,
					maxAttach: undefined,
					showViews: {
					1: true,
					2: true,
					3: true,
					4: true,
					5: true,
					upload: true,
					import: true
				}
				},
				templateUrl		 : 'app/main/dialogs/media/media-dialog.html',
				parent			 : angular.element($document.body),
				targetEvent		 : ev,
				clickOutsideToClose: true
			}).then(function (item) {
				vm.currentThread_Edit = item;

				vm.basicForm.$setDirty()
				vm.thumbnails_Edit = {};
				angular.forEach(vm.mediaZones, function (mz) {
					if (angular.isUndefined(vm.thumbnails_Edit[mz.id_zone])) {
						vm.thumbnails_Edit[mz.id_zone] = [];
					}
				})
				angular.forEach(vm.currentThread_Edit.Thumbnail, function (thumb) {
					vm.thumbnails_Edit[thumb.id_zone].push(thumb);
				})

			});
		}

		/**
		 * Open TinyMCE media selector
		 *
		 * @param item
		 */

		function mediaDialogTiny(item) {
			$mdDialog.show({
				controller		: 'MediaDialogController',
				controllerAs		: 'vm',
				locals			 : {
					currentThread: item,
					section	 : $scope.section,
					mediazone	: 1,
					isTiny		 : 1,
					maxAttach: undefined,
					showViews: {
					1: true,
					2: true,
					3: true,
					4: true,
					5: true,
					upload: true,
					import: true
				}
				},
				templateUrl		 : 'app/main/dialogs/media/media-dialog-tinymce.html',
				parent			 : angular.element($document.body),
				clickOutsideToClose: true
			}).then(function (item) {

/*
				vm.currentThread_Edit = item;

				vm.basicForm.$setDirty()
				vm.thumbnails_Edit = {};
				angular.forEach(vm.mediaZones, function (mz) {
					if (angular.isUndefined(vm.thumbnails_Edit[mz.id_zone])) {
						vm.thumbnails_Edit[mz.id_zone] = [];
					}
				})
				angular.forEach(vm.currentThread_Edit.Thumbnail, function (thumb) {
					vm.thumbnails_Edit[thumb.id_zone].push(thumb);
				})
*/
			});
		}

		/**
		 * Open reply dialog
		 *
		 * @param ev
		 */
		function replyDialog(ev) {
			$mdDialog.show({
				controller		: 'ComposeDialogController',
				controllerAs		: 'vm',
				locals			 : {
					selectedContent: vm.selectedContent
				},
				templateUrl		 : 'app/main/dialogs/compose/compose-dialog.html',
				parent			 : angular.element($document.body),
				targetEvent		 : ev,
				clickOutsideToClose: true
			});
		}

		/**
		 * Update Tag verification status
		 *
		 * @param ev
		 */
		function updateTagStatus(ev, item, newStatus) {
		ev.stopPropagation();
			let updatedItem = angular.copy(item);
			updatedItem.verify = newStatus;
			var options = {
				id  : updatedItem.id_tag,
				site: $scope.siteID,
				item: updatedItem
			}
			tagsService.saveItem(options).then(function(response){
				item.verify = newStatus;
				}, function(error){
				var errorMsg = $translate.instant('TAGS.SAVING_ERROR');
				$mdToast.show({
					template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg">' + errorMsg + '</div></md-toast>',
					hideDelay: 7000,
					position: 'top center',
					parent: '#content-container'
				});
				console.log('error', error)
			})
		}

		/**
		 * Toggle sidenav
		 *
		 * @param sidenavId
		 */
		function toggleSidenav(sidenavId) {
			$mdSidenav(sidenavId).toggle();
		}

		function isNumber(value) {
			return angular.isNumber(value);
		}

		function siteLanguages() {
			return sessionService.getSiteLanguages();
		}

		function dateSelectedCallback(date, fieldName) {
		}

		function getCurrentMedia() {
			return vm.currentThread_Edit.Thumbnail;
		}

		function getZoneCrop(field) {
			var cropId	= '';
			if (!angular.isUndefined(field.id_cropformats)) {
				cropId	= field.id_cropformats;
			}
			return cropId;
		}

		function newTag(tagName) {
			var newTag	= {
				id_tag: '',
				tag_name: tagName
			}
			vm.tags.push(newTag);
			vm.currentThread_Edit.tags.push(newTag);
			vm.searchTagText = '';
		}

	}

	function renderTinyMedia(content) {
	}
})();

(function () {
	'use strict';

	angular
		.module('app.content')
		.service('tagsService', tagsService);

	/** @ngInject */
	// I provide access to the session store.
	function tagsService($q, $resource, userService, settingsDomainService, sessionService, COMMON, $window) {

		function get(options) {
			if (!angular.isArray(options.groupIds) || options.groupIds.length === 0) {
				return getTags(options);
			} else {
				return getTagsInGroup(options);
			}
		}
		function getTags(options) {
			var deferred = $q.defer();
			var filters = [];

			_.forEach(options, function (value, key, list) {
				if (_.isObject(list[key])) {
					_.forEach(list[key], function (filter, keyFilter, listFilter) {
						if (!_.isEmpty(filter.selected)) {
							filters.push({
								field: filter.field,
								name: filter.name,
								values: filter.selected
							});
						}

					});

				}
			});

			var opts = {
				domain: options.siteID,
				page: options.page,
				paginate: options.paginate,
				sort: options.sort,
				filters: JSON.stringify(filters),
				resultsPerPage: options.perPage,
				verify: options.verify
			}

			if (options.searchStringFilter) {
				opts.search = options.searchStringFilter;
			}

			if (options.typeIds) {
				opts['id_type[]'] = options.typeIds;
			}
			resourceTags.get(opts,
				function (response) {
					// angular.copy(response, modulecontent);
					// setActiveDomain(domain);

					deferred.resolve(response);
				},
				function (e) {
					console.error(e)
					deferred.reject();
				}
			);

			// Return the promise.
			return (deferred.promise);
		}

		function getTagByID(options) {
			var deferred = $q.defer();

			resourceTagById.get({
					domain: options.site,
					id: options.id,
					// lang: get("language")
				},
				function (response) {

					// angular.copy(response, modulecontent);
					// setActiveDomain(domain);

					deferred.resolve(response);
				},
				function (e) {
					console.error(e)
					console.error("Database connection error")
					deferred.reject();
				}
			);

			// Return the promise.
			return (deferred.promise);
		}

		// function getFilters(options) {
		// 	var deferred = $q.defer();

		// 	resourceFilters.get({
		// 			domain: options.site,
		// 			name: 'feed',
		// 		},
		// 		function (response) {

		// 			// angular.copy(response, modulecontent);
		// 			// setActiveDomain(domain);

		// 			deferred.resolve(response);
		// 		},
		// 		function (e) {
		// 			console.error(e)
		// 			console.error("Database connection error")
		// 			deferred.reject();
		// 		}
		// 	);

		// 	// Return the promise.
		// 	return (deferred.promise);
		// }

		function saveItem(options) {
			var deferred = $q.defer();

			if (options.id) {
				resource_tag_byID.update({
						domain: options.site,
						id: options.id,
						verify: options.item.verify,
						tag_name: options.item.tag_name,
						tag_alternate: options.item.tag_alternate,
						id_type: options.item.id_type
					},
					function (response) {

						// angular.copy(response, modulecontent);
						// setActiveDomain(domain);

						deferred.resolve(response);
					},
					function (e) {
						console.error(e)
						console.error("Database connection error")
						deferred.reject();
					}
				);
			} else {
				resource_tag_post_byID.save({
						domain: options.site,
						verify: options.item.verify,
						tag_name: options.item.tag_name,
						id_type: options.item.id_type
					},
					function (response) {

						// angular.copy(response, modulecontent);
						// setActiveDomain(domain);

						deferred.resolve(response);
					},
					function (e) {
						console.error(e)
						console.error("Database connection error")
						deferred.reject();
					}
				);
			}

			// Return the promise.
			return (deferred.promise);
		}

		function massActions(options) {
			var deferred = $q.defer();
			switch (options.action) {
				case 'duplicate':
					resource_tag_massDuplicate.duplicate({
							domain: options.site,
						},{
							'tags': options.ids,
						},
						function (response) {
							deferred.resolve(response);
						},
						function (e) {
							console.error(e)
							console.error("Database connection error")
							deferred.reject();
						}
					);
					break;
				case 'delete':
					resource_tag_massDelete.delete({
							domain: options.site,
							'tags[]': options.ids,
						},
						function (response) {
							deferred.resolve(response);
						},
						function (e) {
							console.error(e)
							console.error("Database connection error")
							deferred.reject();
						}
					);
					break;
				}

			// Return the promise.
			return (deferred.promise);
		}

		function getTagsInGroup(options) {

			var deferred = $q.defer();

			var opts = {
				domain: options.siteID,
				'id_group[]': options.groupIds,
				sortField: options.sortField,
				sortDir: options.sortDir,
				resultsPerPage: options.resultsPerPage,
				page: options.page
			};
			if (options.typeIds) {
				opts['id_type[]'] = options.typeIds;
			}
			if (options.searchStringFilter) {
				opts.search = options.searchStringFilter;
			}
			if (options.sortBy) {
				opts.sortBy = options.sortBy;
			}

			resourceTagsInGroup.get(
				opts,
				function (response) {
					deferred.resolve(response);
				},
				function (e) {
					console.error(e)
					deferred.reject();
				}
			);

			return (deferred.promise);
		};


		function getTagsGroupsNested(options) {
			var deferred = $q.defer();
			resourceTagsGroupsNested.get({
				domain: options.siteID,
				sortDir: options.sortDir || 'ASC',
				sortField: options.sortField || 'name'
			},
				function (response) {
					deferred.resolve(response);
				},
				function (e) {
					console.error("Database connection error")
					console.error(e)
					deferred.reject();
				}
			);

			// Return the promise.
			return (deferred.promise);
		}

		function createTagsGroups(options) {
			var deferred = $q.defer();
			resourceTagsGroups.post({
				domain: options.siteID,
				parent: options.parentGroupId,
				name: options.groupName
			},
				function (response) {
					deferred.resolve(response);
				},
				function (e) {
					console.error("Database connection error")
					console.error(e)
					deferred.reject();
				}
			);
			return (deferred.promise);
		}

		function editTagsGroups(options) {
			var deferred = $q.defer();
			resourceTagsGroups.update({
				domain: options.siteID,
				parent: options.parentGroupId,
				name: options.groupName,
				id: options.groupId
			},
				function (response) {
					deferred.resolve(response);
				},
				function (e) {
					console.error("Database connection error")
					console.error(e)
					deferred.reject();
				}
			);
			return (deferred.promise);
		}

		function deleteTagsGroups(options) {
			var deferred = $q.defer();
			resourceTagsGroups.delete({
				domain: options.siteID,
				id: options.groupId
			},
				function (response) {
					deferred.resolve(response);
				},
				function (e) {
					deferred.reject(e);
				}
			);
			return (deferred.promise);
		}

		function massInsertIntoGroups(options) {
			var deferred = $q.defer();
			resourceTagsInGroupsMassInsert.post({
				domain: options.siteID
			}, JSON.stringify(options.data),
				function (response) {
					deferred.resolve(response);
				},
				function (e) {
					console.error("Database connection error")
					console.error(e)
					deferred.reject();
				}
			);
			return (deferred.promise);
		}

		function addToGroup(options) {
			var deferred = $q.defer();
			resourceTagsInGroup.post({
				domain: options.siteID,
				id: options.id_group
			}, {
				id: options.id_group,
				id_tag: options.ids
			},
				function (response) {
					deferred.resolve(response);
				},
				function (e) {
					console.error(e)
					deferred.reject();
				}
			);
			return (deferred.promise);
		}

		function removeFromGroup(options) {
			var deferred = $q.defer();
			resourceTagsInGroup.delete({
				domain: options.siteID,
				id: options.id_group,
				'id_tag[]': options.ids
			},
				function (response) {
					deferred.resolve(response);
				},
				function (e) {
					console.error("Database connection error")
					console.error(e)
					deferred.reject();
				}
			);
			return (deferred.promise);
		}

		function getTagsTypes(options) {
			var deferred = $q.defer();
			resourceTagsTypes.get({
				domain: options.siteID
			},
				function (response) {
					deferred.resolve(response);
				},
				function (e) {
					console.error("Database connection error")
					console.error(e)
					deferred.reject();
				}
			);

			// Return the promise.
			return (deferred.promise);
		}
		
		function getTagService(options) {
			var deferred = $q.defer();
			resourceTagsService.get({
				domain: options.siteID,
				id: options.id
			},
				function (response) {
					deferred.resolve(response);
				},
				function (e) {
					console.error("Database connection error")
					console.error(e)
					deferred.reject();
				}
			);
			return (deferred.promise);
		}
		var resourceTagsService = $resource(COMMON.BASE_API + "/domain/:domain/tagServices/:id", {
				//No default data
			}, {
				get: {
					method: "GET",
					isArray: false
				}
			}
		);


		var resourceTags = $resource(COMMON.BASE_API + "/domain/:domain/tags", {
				// No default data
			}, {
				get: {
					method: "GET",
					isArray: false
				}
			}
		);

		var resourceTagById = $resource(COMMON.BASE_API + "/domain/:domain/tags/:id", {
				// No default data
			}, {
				get: {
					method: "GET",
					// isArray: true
				}
			}
		);

		var resourceFilters = $resource(
			COMMON.BASE_API + "/domain/:domain/content/:name/options", {
				// No default data.
			}, {
				get: {
					method: "GET",
					// isArray: true
				}
			}
		);

		var resource_tag_post_byID = $resource(
			COMMON.BASE_API + "/domain/:domain/tags", {
				domain: '@domain',
			}, {
				save: {
					method: "POST",
				},
			}
		);

		var resource_tag_byID = $resource(
			COMMON.BASE_API + "/domain/:domain/tags/:id", {
				domain: '@domain',
				id: '@id',
			}, {
				get: {
					method: "GET",
				},
				update: {
					method: "PUT",
				},
				delete:{
					method: "DELETE"
				}
			}
		);

		var resource_tag_massDelete= $resource(
			COMMON.BASE_API + "/domain/:domain/tags/delete/multiple", {
				domain: '@domain',
			}, {
				delete:{
					method: "DELETE",
					isArray: true
				}
			}
		);

		var resource_tag_massDuplicate= $resource(
			COMMON.BASE_API + "/domain/:domain/tags/duplicate/multiple", {
				domain: '@domain',
			}, {
				duplicate:{
					method: "POST",
					isArray: true
				}
			}
		);


		var resourceTagsGroups = $resource(COMMON.BASE_API + "/domain/:domain/tagsGroups/:id", {
			// No default data.
			domain: '@domain',
			id: '@id'
		}, {
			get: {
				method: "GET",
				isArray: false
			},
			post: {
				method: "POST"
			},
			update: {
				method: "PUT"
			},
			delete: {
				method: "DELETE",
				isArray: true
			}
		});

		var resourceTagsGroupsNested = $resource(COMMON.BASE_API + "/domain/:domain/tagsGroupsNested", {
			// No default data
		}, {
			get: {
				method: "GET",
				isArray: false,
				transformResponse: function(data, headers){
					var response = {}
					response.data = JSON.parse(data);
					response.qiuRestrictions = JSON.parse(headers('qiu-restrictions'));
					return response;
				}
			}
		});

		var resourceTagsInGroupsMassInsert = $resource(
			COMMON.BASE_API + "/domain/:domain/tagsInGroups/massInsert", {
				// No default data.

			}, {
				post: {
					method: "POST",
					//isArray: true
				}
			}
		);

		var resourceTagsInGroup = $resource(COMMON.BASE_API + "/domain/:domain/tagsInGroup/:id", {
			// No default data
		}, {
			get: {
				method: "GET",
				isArray: false
			},
			delete: {
				method: "DELETE",
				isArray: true
			},
			update: {
				method: "PUT",
				isArray: true
			},
			post: {
				method: "POST",
				isArray: true
			}
		});

		var resourceTagsNestedInGroup = $resource(COMMON.BASE_API + "/domain/:domain/tagsInGroup/getNested", {
			// No default data
		}, {
			get: {
				method: "GET",
				isArray: true
			}
		});

		var resourceTagsTypes = $resource(COMMON.BASE_API + "/domain/:domain/tagsTypes", {
			// No default data
		}, {
			get: {
				method: "GET",
				isArray: true
			}
		});

		return ({
			get: get,
			getTagByID: getTagByID,
			// getFilters: getFilters,
			saveItem: saveItem,
			createTagsGroups: createTagsGroups,
			getTagsGroupsNested: getTagsGroupsNested,
			editTagsGroups: editTagsGroups,
			deleteTagsGroups: deleteTagsGroups,
			massInsertIntoGroups: massInsertIntoGroups,
			removeFromGroup: removeFromGroup,
			addToGroup: addToGroup,
			getTagsTypes: getTagsTypes,
			massActions: massActions,
			getTagService: getTagService
		});

	}

})();



(function () {
    'use strict';

    angular.module('app.projects')
        .directive('qiuProjectsOnClickLoadUsersByGroups', ['tasksService', LoadUsersByGroups])
        .directive('qiuProjectsOnClickOpenGroupEditDialog', ['tasksService', OpenGroupEditDialog])
        .directive('qiuProjectsOnClickCloseSidenav', ['tasksService', CloseSidenav])
        .directive('qiuProjectsOnCheckToggleAssignedGroup', ToggleAssignedGroup)
        .directive('qiuProjectsOnChangeSetInGroupStatus', SetInGroupStatus)
        .controller('TasksController', TasksController);



    /** @ngInject */
    function TasksController($scope, $rootScope, $document, $mdDialog, $mdMedia, $mdToast, $mdSidenav,
        $state, msApi, requestContext, $timeout, tasksService, contentService, msUtils,
        $anchorScroll, $translate, sessionService, tinyMceService, sharedFunctionsMailing,
        transformTasks, ivhTreeviewMgr, $filter, $window) {
        var vm = this;
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg', 'red-bg', 'yellow-bg', 'light-blue-bg'];
        vm.selectedColor = vm.colors[Math.floor(Math.random() * vm.colors.length)];
        // vm.folders = Folders.data;
        // vm.labels = Labels.data;
        vm.folders = [];
        vm.labels = [];

        vm.loadingThreads = true;
        vm.enterfirst = true;
        vm.users = null;
        vm.searchUserText = null;
        vm.selectedUser = null;
        vm.createFilterFor = createFilterFor;
        vm.groupBy = undefined;
        vm.CleanUsersGroups = undefined;
        vm.currentLabelsEdit = undefined;
        vm.currentTab = 'edit';
        vm.countriesWithStates = undefined;
        vm.statesWithCities = undefined;
        vm.timeAgo = msUtils.timeAgo;
        vm.loginUrl = sessionService.site_operative.websiteLoginUrl;

        vm.scrollEl = angular.element('#thread-list')[0];

        vm.currentFilter = {
            type: $state.params.type,
            filter: $state.params.filter
        };
        vm.currentThread = null;
        vm.currentThread_Edit = null;
        vm.thumbnails_Edit = {};
        vm.selectedThreads = [];
        vm.selectedGroups = [];
        vm.selectedGroup = false;
        vm.basicForm = {};



        vm.labelQuerySearch = labelQuerySearch;

        // vm.views = {
        // 	classic: 'app/main/apps/content/views/classic/classic-view.html',
        // 	outlook: 'app/main/apps/content/views/outlook/outlook-view.html'
        // };
        // vm.defaultView = 'outlook';
        // vm.currentView = 'outlook';

        vm.mediaZones = [];
        vm.usersGroups = undefined;
        vm.currentLabelsFilter = undefined;
        vm.ingroupStatus = [];

        // Methods
        vm.init = init;
        vm.getInArray = msUtils.getInArray;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.toggleInGroup = msUtils.toggleInGroup;
        vm.getReferencesSections = contentService.getReferencesSections;
        vm.getExtension = msUtils.getExtension;
        vm.getExtensionIcon = msUtils.getExtensionIcon;
        vm.getValuesReferencesSections = contentService.getValuesReferencesSections;

        vm.isTrueFalseChecked = isTrueFalseChecked;
        vm.toggleTrueFalseCheck = toggleTrueFalseCheck;
        vm.selectOrUnselect = selectOrUnselect;

        vm.loadFolder = loadFolder;
        vm.loadLabel = loadLabel;
        vm.loadUsersByGroups = loadUsersByGroups;
        vm.isFolderActive = isFolderActive;
        vm.isLabelActive = isLabelActive;

        vm.newThread = newThread;
        vm.openThread = openThread;
        vm.send = send;
        vm.attach = attach;
        vm.closeThread = closeThread;
        vm.closeThreadEdit = closeThreadEdit;
        vm.deleteThread = deleteThread;

        vm.closeUsers = closeUsers;

        vm.toggleSelectThread = toggleSelectThread;
        vm.toggleSelectThreads = toggleSelectThreads;
        vm.toggleSelectGroups = toggleSelectGroups;
        vm.toggleSelectGroup = toggleSelectGroup;
        vm.isSelected = isSelected;
        vm.deselectThreads = deselectThreads;

        vm.setThreadStatus = setThreadStatus;
        vm.toggleThreadStatus = toggleThreadStatus;
        vm.toggleItemStatus = toggleItemStatus;
        vm.toggleItemStatusEdit = toggleItemStatusEdit;

        vm.getLabel = getLabel;
        vm.getLabelColor = getLabelColor;
        vm.getLabelTitle = getLabelTitle;
        vm.toggleLabel = toggleLabel;
        vm.isLabelExist = isLabelExist;

        vm.changeView = changeView;
        vm.viewEditInline = viewEditInline;
        vm.viewPreview = viewPreview;
        vm.saveItem = saveItem;
        vm.massActions = massActions;

        vm.composeDialog = composeDialog;
        vm.replyDialog = replyDialog;
        vm.openImageDialog = openImageDialog;
        vm.openFocalPoint = openFocalPoint;
        vm.siteLanguages = siteLanguages;
        vm.setTinyMceContent = setTinyMceContent;
        vm.getCurrentMedia = getCurrentMedia;
        vm.newUser = newUser;
        vm.getZoneCrop = getZoneCrop;

        vm.dateFormat = sessionService.site_operative.dateFormat;
        vm.dateTimeFormat = sessionService.site_operative.dateTimeFormat;
        vm.showDate = showDate;

        vm.getCountriesWithStates = getCountriesWithStates;
        vm.getCountryById = getCountryById;
        vm.getStatesByCountry = getStatesByCountry;
        vm.getCitiesByState = getCitiesByState;

        vm.duplicateUser = duplicateUser;
        vm.setSortField = setSortField;
        vm.resetSortField = resetSortField;
        vm.setSortOrder = setSortOrder;
        //vm.callback = callback;
        vm.cancelUsersGroups = cancelUsersGroups;
        vm.saveUsersGroups = saveUsersGroups;
        vm.deleteTargetFilter = deleteTargetFilter;
        vm.mediaDialog = mediaDialog;
        vm.resetFilters = resetFilters;
        vm.resetGroupby = resetGroupby;
        vm.setGroupBy = setGroupBy;
        vm.openUsersGroupsDialog = openUsersGroupsDialog;
        vm.deleteTargetEdit = deleteTargetEdit;

        vm.loadAllUsers = loadAllUsers;
        vm.getUsersByGroups = getUsersByGroups;
        vm.unselectGroups = unselectGroups;
        vm.createGroup = createGroup;

        vm.includeSubgroups = true;
        vm.toggleIncludeSubgroups = toggleIncludeSubgroups;
        vm.addUsersToGroupsDialog = addUsersToGroupsDialog;
        vm.removeUsersFromGroupDialog = removeUsersFromGroupDialog;


        vm.isLarge = isLarge;
        vm.isMedium = isMedium;
        vm.isSmall = isSmall;
        vm.isMini = isMini;

        vm.loginToWebsite = loginToWebsite;
        vm.textMessage = '';
        vm.timeAgo = msUtils.timeAgo;
        $scope.thumbImage = []


        vm.translate = function (text) {
            return $translate.instant(text);
        }

        function showDate(value) {
            if (angular.isObject(value)) {
                return value.dateShow;
            } else if (value == '0000-00-00 00:00:00' || !value) {
                return '-';
            } else {
                var tz = (sessionService.site_operative.timezone || moment.tz.guess() || 'UTC').toString().trim();
                return moment.utc(value).tz(tz).format(vm.dateTimeFormat || 'DD/MM/YYYY HH:mm');
            }
        }


        vm.updateDatePicker = function (fld) {
            var value = moment.utc(vm.currentThread_Edit[fld].date).format('YYYY-MM-DD HH:mm:00');

            if (value == 'Invalid date') {
                vm.currentThread_Edit[fld] = {};
                vm.currentThread_Edit[fld]['value'] = '';
                vm.currentThread_Edit[fld]['date'] = '';
                vm.currentThread_Edit[fld]['dateShow'] = '';
                vm.currentThread_Edit[fld]['utcShow'] = '';
                vm.currentThread_Edit[fld]['utcDate'] = '';
            } else {
                var tz = (sessionService.site_operative.timezone || moment.tz.guess() || 'UTC').toString().trim();
                var utcDate = moment.utc(value);
                var siteDate = moment.utc(value).tz(tz);
                vm.currentThread_Edit[fld] = {};
                vm.currentThread_Edit[fld]['value'] = value;
                vm.currentThread_Edit[fld]['date'] = new Date(siteDate.format());
                vm.currentThread_Edit[fld]['dateShow'] = siteDate.format(vm.dateTimeFormat || 'DD/MM/YYYY HH:mm');
                vm.currentThread_Edit[fld]['utcShow'] = utcDate.format(vm.dateTimeFormat || 'DD/MM/YYYY HH:mm');
                vm.currentThread_Edit[fld]['utcDate'] = utcDate;
            }
        };


        vm.mediaSortable = {
            group: 'media',
            animation: 150,
            scroll: true,
            filter: '.no-sort',
            ghostClass: "sort-drop",
            onEnd: function (evt) {
                if (typeof evt.oldIndex == 'undefined' || typeof evt.newIndex == 'undefined')
                    return;
                vm.currentThread_Edit.Thumbnail = [];
                angular.forEach(vm.thumbnails_Edit, function (thumbZone, idZone) {
                    var i = 1;
                    angular.forEach(thumbZone, function (data) {
                        if (data.id_zone != idZone) {
                            var dataOld = _.clone(data);
                            if (angular.isUndefined(vm.currentThread_Edit.ThumbnailRemove))
                                vm.currentThread_Edit.ThumbnailRemove = [];
                            vm.currentThread_Edit.ThumbnailRemove.push(dataOld);
                            data.id_zone = idZone * 1;
                        }
                        data.sort = i;
                        vm.currentThread_Edit.Thumbnail.push(data)
                        i = i + 1;
                    })
                })
                vm.basicForm.$setDirty()
            }
        };

        function setTinyMceContent(event) {
            var zoneMedia = {
                1: {},
                2: {},
                3: {},
                4: {}
            };
            var typesMax = {
                1: 0,
                2: 0,
                3: 0,
                4: 0
            };
            var currentSort = 0;
            var currentType = 0;
            for (var i = 0; i < vm.currentThread_Edit.Thumbnail.length; i++) {
                if (vm.currentThread_Edit.Thumbnail[i]['id_zone'] == 1) {
                    currentSort = vm.currentThread_Edit.Thumbnail[i]['sort'];
                    currentType = vm.currentThread_Edit.Thumbnail[i]['media_type'];
                    typesMax[currentType]++;
                    zoneMedia[currentType][typesMax[currentType]] = vm.currentThread_Edit.Thumbnail[i];
                }
            }
            return zoneMedia;
        }

        vm.tinymceOptions = tinyMceService.getOptions($scope);

        function updateDatePicker(ev) {

        }

        // Attachments
        vm.deleteAttachment = deleteAttachment;
        vm.mediaDialog = mediaDialog;
        vm.mediaDialogTiny = mediaDialogTiny;
        vm.renderTinyMedia = renderTinyMedia;

        vm.toggleSidenav = toggleSidenav;
        vm.isNumber = isNumber;
        vm.hasDateShow = hasDateShow;
        vm.updateThread = updateThread;

        //////////

        init();

        function init() {

            vm.views = {
                nosplit: 'app/main/apps/tasks/views/list/nosplit-view.html',
                split: 'app/main/apps/tasks/views/list/split-view.html',
                table: 'app/main/apps/tasks/views/list/table-view.html',
                grid: 'app/main/apps/tasks/views/grid/grid-view.html'
            };
            vm.defaultView = 'split';
            vm.currentView = 'split';
            vm.loadingView = true;

            vm.getCountriesWithStates();

            var siteID = requestContext.getParam("siteId");
            //            var section = requestContext.getParam("section");

            var section = 'TASKS';

            $scope.siteID = siteID;
            $scope.section = section;




            /*
            contentService.getFilters({section: section, site: siteID}).then(function (response) {
            	vm.mediaZones = (response.media_zones.length == 0)
            		? null
            		: angular.copy(response.media_zones);
            });*/

            sessionService.setActiveSection(section).then(function () {
                vm.ActiveSection = sessionService.ActiveSection;
            });

            // getCleanUsersGroup();

            vm.viewSplit = true;
            vm.edit = false;
            vm.selectedUsers = [];
            vm.selectedGroups = [];

            $scope.view_medialist = true;
            $scope.siteID = siteID;
            $scope.section = section;
            $rootScope.global.titleToolbar = '<i class="icon s20 icon-people mr-15" ng-if="node.icon"></i> ' + $translate.instant('TASKS');

            var options = {
                site: $scope.siteID,
                section: $scope.section
            };

            // $scope.page = 1;
            // request the initial set of data
            // loadRemoteData();
            $scope.page = 1;

            if ($state.params.id) {
                vm.loadingReadPane = true;
                // for (var i = 0; i < vm.threads.length; i++) {
                // if (vm.threads[i].id === $state.params.threadId) {
                //vm.openThread(null, $state.params.id);
                // break;
                // }
                // }
            }

            tasksService.getUsersInGroupStatus($scope.siteID).then(function (response) {
                vm.ingroupStatus = response;
            });


        }

        // Watch screen size to change view modes
        $scope.$watch(function () {
            return $mdMedia('lt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                vm.currentView = 'nosplit';
            }
        });

        $scope.$watch(function () {
            return $mdMedia('max-width: 960px');
        }, function (big) {

            if (big)
                vm.currentView = 'nosplit';

        });

        $scope.$watch(function () {
            return $mdMedia('min-width: 960px');
        }, function (small) {

            if (small)
                vm.currentView = 'split';

        });

        $scope.$watch(function () {
            return $mdMedia('gt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                if (vm.defaultView === 'split') {
                    vm.currentView = 'split';
                }
            }
        });

        $scope.$on('$includeContentLoaded', function (event, target) {
            $timeout(function () {
                vm.loadingView = false;
            }, 1000);
        });

        $scope.$on('loadUsersByGroups', function (event, groups) {
            if (groups) {
                loadUsersByGroups(groups);
            } else {
                unselectGroups();
            }
            vm.selectedThreads = [];
        });

        $scope.$on('reloadGroups', function () {
            getCleanUsersGroup();
        });


        $scope.$on('pagination:loadStart', function (event) {
            // $anchorScroll();

            // Store the current scrollPos
            // vm.scrollPos = vm.scrollEl.scrollTop();

            // Scroll to the top
            // vm.scrollEl.scrollTop(0);
            if (!vm.enterfirst) {
                var elem = angular.element(document.getElementById('thread-list'));
                elem.scrollTopAnimated(0, 10);
            }

            // angular.element("#thread-list").scrollTop=0;
            vm.enterfirst = false;
            $scope.isLoading = true;
        });

        $scope.$on('pagination:loadPage', function (event) {

            if ($state.params.id) {
                vm.openThread(null, $state.params.id);
            }
            $scope.isLoading = false;
            vm.dataAlreadyLoaded = true;
        });

        $scope.$on('closeSidenav', function (ev, sidenavId) {
            $mdSidenav(sidenavId).close();
        })

        $scope.$on('openGroupDialog', function (ev, group) {
            openGroupDialog(ev, group);
        });

        function toggleIncludeSubgroups() {
            vm.includeSubgroups = !vm.includeSubgroups;
            var element = $("#treeview-group-" + vm.selectedGroup.id_group);
            tasksService.triggerUsersByGroups(element.attr("data-group-node"), vm.includeSubgroups);
        }

        function unselectGroups() {
            vm.selectedGroup = false;
            vm.selectedContent = false;
            $rootScope.pagination_groupIds = false;
            var elemList = document.querySelectorAll('.group-row');
            elemList.forEach(function (elem) {
                elem.classList.remove('selected');
            });
            loadAllUsers();
        }

        function loadAllUsers() {
            $scope.isLoading = true;
            var options = {
                siteID: $scope.siteID,
                section: $scope.section,
                sortDir: $rootScope.sortDir,
                sortField: $rootScope.sortField
            };
            tasksService.getUsers(options).then(function (response) {
                vm.threads = response.result.data;
                $rootScope.pagination_totalItems = response.result.total;
                $rootScope.pagination_total_pages = response.result.last_page;
                $rootScope.pagination_page = response.result.current_page;
                $scope.isLoading = false;
            });
        }

        function loadUsersByGroups(groups) {
            $scope.isLoading = true;
            var groupIds = [];
            angular.forEach(groups, function (group) {
                groupIds.push(group.id_group);
            });
            vm.selectedGroup = groups[0];
            var options = {
                siteID: $scope.siteID,
                section: $scope.section,
                groupIds: groupIds,
                sortDir: $rootScope.sortDir,
                sortField: $rootScope.sortField
            };
            tasksService.getUsersByGroups(options).then(function (response) {
                $rootScope.pagination_groupIds = groupIds;
                vm.threads = response.result.data;
                angular.forEach(vm.threads, function (user) {
                    var selUserGroup = $filter('filter')(user.groups, { id_group: vm.selectedGroup.id_group });
                    if (selUserGroup.length > 0) {
                        var idIngroupStatus = selUserGroup[0].users_ingroup.id_ingroup_status;
                        user.ingroup_status = $filter('filter')(vm.ingroupStatus, { id_ingroup_status: idIngroupStatus });
                    }
                });
                $rootScope.pagination_totalItems = response.result.total;
                $rootScope.pagination_total_pages = response.result.last_page;
                $rootScope.pagination_page = response.result.current_page;
                $scope.isLoading = false;
            });
        }

        function getCleanUsersGroup() {
            tasksService.getUsersGroups({
                siteID: $scope.siteID,
                withGroupType: true
            }).then(function (response) {
                var qiuRestrictions = response.qiuRestrictions;
                var groups = response.data;
                vm.CleanUsersGroups = transformTasks.formatNestedGroups(groups, qiuRestrictions, true);
            });
        }

        function createGroup(ev) {
            openGroupDialog(ev, {});
        }

        function deleteTargetEdit(item, index) {
            for (var i = vm.currentThread_Edit.groups.length - 1; i >= 0; i--) {
                if (vm.currentThread_Edit.groups[i].id_group == item.id_group) {
                    vm.currentThread_Edit.groups.splice(i, 1);
                    vm.currentLabelsEdit.splice(index, 1);
                }
            };
            for (var i = vm.currentThread_Edit.groupIds.length - 1; i >= 0; i--) {
                if (vm.currentThread_Edit.groupIds[i] == item.id_group) {
                    vm.currentThread_Edit.groupIds.splice(i, 1);
                    vm.currentLabelsEdit.splice(index, 1);
                }
            };
            vm.basicForm.$setDirty();
        }

        function getCurrentLabelsEdit() {
            var usersGroupsAux = transformTasks.initGroupsTree(angular.copy(vm.CleanUsersGroups), vm.currentThread_Edit.groups, vm.ingroupStatus);
            vm.currentLabelsEdit = transformTasks.getLabels(usersGroupsAux, []);
        }
        function isLarge(field) {
            return ['firstname', 'email', 'last_login', 'created_at'].includes(field);
        }
        function isMedium(field) {
            return ['mobile', 'skype', 'ingroup_status', 'country'].includes(field);
        }
        function isSmall(field) {
            return [].includes(field);
        }
        function isMini(field) {
            return ['status', 'media', 'id_user'].includes(field);
        }

        function addUsersToGroupsDialog(ev) {
            var groupsTree = transformTasks.initGroupsTree(angular.copy(vm.CleanUsersGroups), [], vm.ingroupStatus);

            $mdDialog.show({
                controller: 'AddUsersToGroupsDialogController',
                controllerAs: 'vm',
                locals: {
                    usersGroups: groupsTree,
                    users: angular.copy(vm.selectedThreads),
                    siteID: $scope.siteID
                },
                templateUrl: 'app/main/apps/tasks/dialogs/groups/users-groups-view.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        }

        function removeUsersFromGroupDialog(ev) {

            var confirmTitle = $translate.instant('GROUP.REMOVE_CONFIRM_TITLE', { group_name: vm.selectedGroup.name });
            var confirmText = $translate.instant('GROUP.REMOVE_CONFIRM_TEXT');
            var confirm = $mdDialog.confirm()
                .title(confirmTitle)
                .textContent(confirmText)
                .ariaLabel(confirmTitle)
                .targetEvent(ev)
                .ok('OK')
                .cancel($translate.instant('CANCEL'));

            $mdDialog.show(confirm).then(function () {

                var removeUserIds = vm.selectedThreads.map(function (thread) { return thread.id_user });

                var options = {
                    siteID: $scope.siteID,
                    data: {
                        id_group: vm.selectedGroup.id_group,
                        id_user: removeUserIds
                    }
                }
                tasksService.removeUsersFromGroup(options).then(function (response) {
                    var element = $("#treeview-group-" + vm.selectedGroup.id_group);
                    tasksService.triggerUsersByGroups(element.attr("data-group-node"), vm.includeSubgroups);

                    if (removeUserIds.length == 1) {
                        var message = $translate.instant('GROUP.USER_REMOVED_SINGULAR');
                    } else {
                        var message = removeUserIds.length + $translate.instant('GROUP.USER_REMOVED_PLURAL');
                    }

                    $mdToast.show({
                        template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                        hideDelay: 5000,
                        position: 'top',
                        parent: '#content-container'
                    });
                });
            });

        }

        function openUsersGroupsDialog() {
            var groupsTree = transformTasks.initGroupsTree(angular.copy(vm.CleanUsersGroups), vm.currentThread_Edit.groups, vm.ingroupStatus);
            $mdDialog.show({
                controller: 'UsersGroupController',
                controllerAs: 'vm',
                locals: {
                    usersGroups: groupsTree,
                    isTiny: false
                },
                templateUrl: 'app/main/dialogs/users-group/users-group-view.html',
                parent: angular.element($document.body),
                targetEvent: 'ev',
                clickOutsideToClose: true,

            }).then(function (groupsTree) {
                if (angular.isDefined(groupsTree) && groupsTree.length > 0) {
                    transformTasks.updateThreadGroups(groupsTree, vm.currentThread_Edit.groups, vm.currentThread_Edit.id_user, []);
                }
                getCurrentLabelsEdit();
                vm.basicForm.$setDirty();
            });
        }


        function setSortField(field) {
            vm.fieldOrder = field;
            $rootScope.pagination_setSortField(field, $rootScope.sortDir);
        }

        function setSortOrder(order) {
            $rootScope.sortDir = order;
            $rootScope.pagination_setSortField(vm.fieldOrder, $rootScope.sortDir);
        }

        /**
         * Load folder
         *
         * @param name
         */
        function loadFolder(name) {
            // If we are already in the selected folder and
            // there is an open thread just close it
            if (vm.isFolderActive(name)) {
                // Close the current thread if open
                if (vm.currentThread) {
                    vm.closeThread();
                }

                return;
            }

            // Show loader
            $rootScope.loadingProgress = true;

            // Update the state without reloading the controller
            $state.go('app.projects.tasks.threads', {
                type: null,
                filter: name
            }, { notify: false });

            // Build the API name
            var apiName = 'content.folder.' + name + '@get';

            // Make the call
            msApi.request(apiName).then(
                // Success
                function (response) {
                    // Load new threads
                    vm.threads = response.data;

                    // Set the current filter
                    vm.currentFilter = {
                        type: null,
                        filter: name
                    };

                    // Close the current thread if open
                    if (vm.currentThread) {
                        vm.closeThread();
                    }

                    // Hide loader
                    $rootScope.loadingProgress = false;
                });
        }

        function selectOrUnselect(item, $event) {
            // var indexInTemp = $scope.temps.indexOf(item);
            var isRightClick = $event && $event.which == 3;
            var isDoubleClick = $event && $event.type == 'dblclick';

            // if ($event && $event.target.hasAttribute('prevent')) {
            //     $scope.temps = [];
            //     return;
            // }
            // if (! item || (isRightClick && $scope.isSelected(item))) {
            //     return;
            // }
            // if ($event && $event.shiftKey && !(isRightClick) && !(isDoubleClick)) {
            //     var list = $scope.fileList;
            //     var indexInList = list.indexOf(item);
            //     var lastSelected = $scope.temps[0];
            //     var i = list.indexOf(lastSelected);
            //     var current = undefined;
            //     if (lastSelected && list.indexOf(lastSelected) < indexInList) {
            //         $scope.temps = [];
            //         while (i <= indexInList) {
            //             current = list[i];
            //             !$scope.isSelected(current) && $scope.temps.push(current);
            //             i++;
            //         }
            //         return;
            //     }
            //     if (lastSelected && list.indexOf(lastSelected) > indexInList) {
            //         $scope.temps = [];
            //         while (i >= indexInList) {
            //             current = list[i];
            //             !$scope.isSelected(current) && $scope.temps.push(current);
            //             i--;
            //         }
            //         return;
            //     }
            // }
            // if ($event && !(isRightClick) && !(isDoubleClick) && ($event.ctrlKey || $event.metaKey)) {
            //     $scope.isSelected(item) ? $scope.temps.splice(indexInTemp, 1) : $scope.temps.push(item);
            //     return;
            // }
            // $scope.temps = [item];
        };

        /**
         * Toggle checked status of the content
         *
         * @param content
         * @param event
         */
        function toggleTrueFalseCheck(field, event) {
            if (event) {
                event.stopPropagation();
            }

            if (vm.selectedContent[field]) {
                vm.selectedContent[field] = false;
            } else {
                vm.selectedContent[field] = true;
            }

            // var idx = vm.checked.indexOf(content);

            // if (idx > -1) {
            // 	vm.checked.splice(idx, 1);
            // } else {
            // 	vm.checked.push(content);
            // }
        }

        /**
         * Return checked status of the content
         *
         * @param content
         * @returns {boolean}
         */
        function isTrueFalseChecked(fieldStatus) {
            return fieldStatus ?
                true :
                false;
            // return vm.checked.indexOf(content) > -1;
        }

        /**
         * Load label
         *
         * @param name
         */
        function loadLabel(name) {
            // Update the state without reloading the controller
            $state.go('app.projects.tasks.threads', {
                type: 'label',
                filter: name
            }, { notify: false });

            // If we are already in the selected folder and
            // there is an open thread just close it
            if (vm.isLabelActive(name)) {
                // Close the current thread if open
                if (vm.currentThread) {
                    vm.closeThread();
                }

                return;
            }

            // Show loader
            $rootScope.loadingProgress = true;

            // Build the API name
            var apiName = 'content.label.' + name + '@get';

            // Make the call
            msApi.request(apiName).then(
                // Success
                function (response) {
                    // Load new threads
                    vm.threads = response.data;

                    // Set the current filter
                    vm.currentFilter = {
                        type: 'label',
                        filter: name
                    };

                    // Close the current thread if open
                    if (vm.currentThread) {
                        vm.closeThread();
                    }

                    // Hide loader
                    $rootScope.loadingProgress = false;
                });
        }

        /**
         * Is the folder with the given name active?
         *
         * @param name
         * @returns {boolean}
         */
        function isFolderActive(name) {
            return (vm.currentFilter.type === null && vm.currentFilter.filter === name);
        }

        /**
         * Is the label with the given name active?
         *
         * @param name
         * @returns {boolean}
         */
        function isLabelActive(name) {
            return (vm.currentFilter.type === 'label' && vm.currentFilter.filter === name);
        }

        /**
         * Open thread
         *
         * @param thread
         */
        function openThread(thread, id) {
            // Set the read status on the thread
            // thread.read = true;
            vm.currentTab = 'edit';
            if (angular.element(document.getElementById('thread-detail')).length) {
                var elem = angular.element(document.getElementById('thread-detail'));
                elem.scrollTopAnimated(0, 10);
            }
            // pagesShown = 1;
            if (thread) {
                vm.selectedContentID = thread.id;
            } else if (id) {
                vm.selectedContentID = id;
            }
            if (vm.selectedContentID != 'new') {
                vm.editInline = false;
                vm.loadingReadPane = true;
                var goToState = 'app.site_overview.projects.tasks.list.thread';
                $state.go(goToState, {
                    id: vm.selectedContentID
                }, {
                        notify: false,
                        inherit: true,
                        location: true
                    });

                var options = {
                    site: $scope.siteID,
                    section: $scope.section,
                    id: vm.selectedContentID,
                    sortDir: $rootScope.sortDir,
                    sortField: $rootScope.sortField
                };
                tasksService.getUserByID(options).then(function (response) {
                    vm.currentThread = JSON.parse(angular.toJson(response.result));
                    vm.selectedContent = angular.copy(vm.currentThread);
                    console.log("SELECTEDCONTENT ", vm.selectedContent)

                    tasksService.getCurrentUser(opt).then(function (res) {
                        var userTask = res.data;
                        // console.log('sessionService ', sessionService.user)
                        var aloneUser = userTask.filter((x) => { return x.id_user == vm.selectedContent.assigned_to_user })
                        vm.taskUser = aloneUser[0]
                    })

                    var now = moment(new Date())
                    var due_date = moment(vm.selectedContent.due_date)
                    var duration = moment.duration(now.diff(due_date));
                    $scope.dateTime = moment(vm.selectedContent.due_date).format('D MMM');
                    // if(duration.asSeconds() < 60) {
                    //     $scope.dateTime = `${parseInt(duration.asSeconds())} seconds ago`
                    // }
                    // if(duration.asMinutes() < 60) {
                    //     $scope.dateTime = `${parseInt(duration.asMinutes())} minutes ago`
                    // }
                    // if(duration.asHours() < 24) {
                    //     $scope.dateTime = `${parseInt(duration.asHours())} hours ago`
                    // }
                    // if(duration.asDays() <= 30) {
                    //     $scope.dateTime = `${parseInt(duration.asDays())} days ago`
                    // }
                    // if(duration.asMonths() >= 1) {
                    //     $scope.dateTime = `${parseInt(duration.asMonths())} months ago`
                    // }
                    // if(duration.asYears() >= 1) {
                    //     $scope.dateTime = `${parseInt(duration.asYears())} years ago`
                    // }

                    vm.updateThread(vm.currentThread);
                    vm.log = response.log;
                    refColumnStuff();
                    vm.loadingReadPane = false;
                });
                tasksService.getUsersAuditTrailByID(options).then(function (response) {
                    for (var i = 0; i < response.length; i++) {
                        response[i].dateWithoutHours = moment(response[i].date).format("MMM DD");
                        // response[i].action_data = JSON.parse(response[i].action_data);
                        // response[i].action_brief = JSON.parse(response[i].action_brief);
                    }
                    vm.userAuditTrailEvents = response;
                })

                var opt = {
                    site: $scope.siteID,
                    tasks: {
                        field: 'id_crm_task',
                        values: [+vm.selectedContentID]
                    }
                }
                getTasksMessages(opt)
                // tasksService.getCurrentUser(opt).then(function(res) {
                //     let userTask = res.data;
                //     // console.log('sessionService ', sessionService.user)
                //     vm.taskUser = userTask.filter((x) => { return x.id_user == vm.selectedContent.assigned_to_user })
                //     console.log('vm.taskUsers ', vm.taskUser)
                // })

            };
        }

        function getTasksMessages(opt) {
            tasksService.getTasksMessages(opt).then(function (response) {
                // var now = moment(new Date()).tz('Europe/Berlin | CET').format('YYYY-MM-DD HH:mm:ss')
                
                var now = moment(new Date())
                // var length = response.result.data;
                // for (var i = 0; i < length.length; i++) {
                //     if(length[i].date) {
                //         var allDate = moment(length[i].date).format('YYYY-MM-DD')
                //         var duration = moment.duration(now.diff(allDate))    
                //         if(duration.asHours() > 24) {
                //             var ini = duration.asHours();
                //             length[i].date = `${duration.get('days')} days ago`
                //         } else {
                //             length[i].date = `${parseInt(duration.asHours())} h ago`
                //         }
                //     }
                // }
                vm.tasksMessages = response.result;
                $scope.messageDate = '';
                console.log("Current date ", now)
                // for (var i = 0; i < vm.tasksMessages.data.length; i++) {
                //     if (vm.tasksMessages.data[i].date && vm.tasksMessages.data[i].date != null) {
                //         console.log("DB Date :: ", vm.tasksMessages.data[i].date)
                //         // var allDate = moment(vm.tasksMessages.data[i].date).format('YYYY-MM-DD')
                //         var allDate = vm.tasksMessages.data[i].date
                //         var duration = moment.duration(now.diff(allDate))
                //         console.log('duration ', duration)
                //         if (duration.asHours() > 24) {
                //             var ini = duration.asHours();
                //             $scope.messageDate = `${duration.get('days')} days ago`
                //         } else {
                //             $scope.messageDate = `${parseInt(duration.asHours())} h ago`
                //         }
                //         return;
                //     }
                // }
                console.log("vm.tasksMessages ", vm.tasksMessages)
            })
        }

        function send(value, taskId) {
            if (value == null || value == '') {
                return;
            }
            var items = {
                "item": {
                    "message": value,
                    "client_id": "1",
                    "project_id": "1",
                    "id_crm_task": taskId,
                    "user_sender_id": "2",
                    "date": moment().utc().format("YYYY-MM-DD HH:mm"),
                    "Thumbnail": $scope.thumbImage
                }
            }
            // console.log(items);
            tasksService.putMesssage(items).then(function (res) {
                var opt = {
                    site: $scope.siteID,
                    tasks: {
                        field: 'id_crm_task',
                        values: [+taskId]
                    }
                }
                getTasksMessages(opt)
            }, function (err) {
                console.log(err)
            })
            vm.textMessage = ''
        }

        function attach(ev, mediazone,item) {
            // console.log(ev, mediazone, item)
            // $scope.thumbImage = []
            item.Thumbnail = [];

            $mdDialog.show({
                controller: 'MediaDialogController',
                controllerAs: 'vm',
                locals: {
                    currentThread: item,
                    section: $scope.section,
                    mediazone: mediazone,
                    multipleSelection: false,
                    isTiny: false,
                    maxAttach: undefined,
                    showViews: {
                        1: true,
                        2: true,
                        3: true,
                        4: true,
                        5: true,
                        upload: true,
                        import: true
                    }
                },
                templateUrl: 'app/main/dialogs/media/media-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true

            }).then(function (item) {
                $scope.thumbImage = item.Thumbnail
                // console.log(item);
                // console.log('item.Thumbnail[0] ', item.Thumbnail)
                // vm.currentThread_Edit.avatar = item.Thumbnail[0];
                // vm.basicForm.$setDirty();
            });
        }

        function refColumnStuff() {
            // console.log("COLS ", vm.refcolumns)
            for (var i = vm.refcolumns.length - 1; i >= 0; i--) {
                if (vm.refcolumns[i].type) {
                    if (vm.refcolumns[i].type.substr(0, 4) == 'date') {

                        var value = vm.selectedContent[vm.refcolumns[i].title];
                        if (value == '0000-00-00 00:00:00') {
                            value = moment().format("YYYY-MM-DD");
                        }

                        var utcDate = moment.utc(value);

                        var siteDate = moment.utc(value).tz(sessionService.site_operative.timezone);

                        vm.selectedContent[vm.refcolumns[i].title] = {};
                        vm.selectedContent[vm.refcolumns[i].title]['value'] = value;
                        vm.selectedContent[vm.refcolumns[i].title]['date'] = new Date(siteDate.format());
                        vm.selectedContent[vm.refcolumns[i].title]['dateShow'] = siteDate.format(vm.dateTimeFormat);
                        vm.selectedContent[vm.refcolumns[i].title]['utcShow'] = utcDate.format(vm.dateTimeFormat);
                        vm.selectedContent[vm.refcolumns[i].title]['utcDate'] = utcDate;
                    }
                    if (vm.refcolumns[i].type == 'country') {
                        vm.selectedContent.related_country = vm.getCountryById(vm.selectedContent.country);
                    }
                    if (vm.refcolumns[i].type == 'state') {
                        if (vm.selectedContent.country) {
                            vm.getStatesByCountry(vm.selectedContent.country);

                        }
                    }
                }

            }

            // Changes here mate
            if (vm.selectedContent.due_date) {
                // var now = moment(new Date())
                // var allDate = vm.selectedContent.due_date.dateShow
                // var allDate = moment(vm.selectedContent.due_date.dateShow)
                // console.log(now, '', moment(allDate))
                // var duration = moment.duration(now.diff(allDate))    
                // if(duration.asHours() > 24) {
                //     var ini = duration.asHours();
                //     vm.selectedContent.due_date.dateShow = `${duration.get('days')} days ago`
                // } else {
                //     // console.log('duration.asHours()  ', duration.asHours() )
                //     vm.selectedContent.due_date.dateShow = `${parseInt(duration.asHours())} h ago`
                // }
            }
            vm.selectedContent_ref = vm.refcolumns;
            //TODO move to utils directive
            for (var i = 0; i < vm.refcolumns.length; i++) {
                var ref = vm.refcolumns[i];
                ref.preview_sort = parseInt(ref.preview_sort);
            }
            // console.log('new ', vm.selectedContent_ref)
            vm.selectedContent_refgrouped = _.groupBy(vm.refcolumns, function (m) {
                // console.log('topa ', m.preview_position)
                return m.preview_position;
            });
        }

        function deleteThread() {
            for (var i = 0; i < vm.selectedThreads.length; i++) {
                var options = {
                    site: $scope.siteID,
                    section: $scope.section,
                    id: vm.selectedThreads[i].id_user
                };
                tasksService.deleteItem(options).then(function (response) {
                    vm.loadingReadPane = false;
                    deselectThreads();
                    vm.selectedContent = undefined;
                    $rootScope.pagination_resetquery();
                });
            }
        }

        /**
         * New thread
         *
         */
        function newThread() {
            if (angular.element(document.getElementById('thread-detail')).length) {
                var elem = angular.element(document.getElementById('thread-detail'));
                elem.scrollTopAnimated(0, 10);
            }

            vm.selectedContentID = '';
            vm.editInline = false;
            vm.loadingReadPane = true;

            $state.go('app.site_overview.projects.tasks.list.thread', {
                id: ''
            }, {
                    notify: false,
                    inherit: true,
                    location: true
                });

            vm.currentThread = '';
            vm.log = [];

            vm.selectedContent = {};
            refColumnStuff();
            vm.loadingReadPane = false;
            vm.viewEditInline();

            /*
            contentService.getNew(options).then(function (response) {
                vm.selectedContent = {
                    Thumbnail: []
                };
                vm.currentThread = '';
                vm.log = [];
    
                for (var i = response.ref.length - 1; i >= 0; i--) {
                    if (response.ref[i].type.substr(0, 4) == 'date') {
                        var value = moment().format("YYYY-MM-DD HH:mm:00");
    
                        var utcDate = moment.utc(value);
    
                        var siteDate = moment.utc(value).tz(sessionService.site_operative.timezone);
    
                        vm.selectedContent[response.ref[i].title] = {};
                        vm.selectedContent[response.ref[i].title]['value'] = value;
                        vm.selectedContent[response.ref[i].title]['date'] = new Date(siteDate.format());
                        vm.selectedContent[response.ref[i].title]['dateShow'] = siteDate.format(vm.dateTimeFormat);
                        vm.selectedContent[response.ref[i].title]['utcShow'] = utcDate.format(vm.dateTimeFormat);
                        vm.selectedContent[response.ref[i].title]['utcDate'] = utcDate;
                    }
                }
                vm.selectedContent_ref = response.ref;
                vm.selectedContent_refgrouped = _.groupBy(response.ref, function (m) {
                    return m.preview_position;
                });
                ;
    
                vm.loadingReadPane = false;
                vm.viewEditInline();
            });*/
        }

        /**
         * Close thread Edit
         */
        function closeThreadEdit() {
            resetScroll();
            vm.editInline = false;
            vm.currentThread_Edit = false;
            vm.currentThread_ref = false;
            if (vm.selectedContentID === '') {
                vm.closeThread();
            }
        }

        function closeUsers() {
            vm.threads = [];
            vm.selectedContent = false;
            $state.go('app.site_overview.projects.tasks.groups', {
                type: vm.currentFilter.type,
                filter: vm.currentFilter.filter
            }, { notify: false });
        }

        /**
         * Close thread
         */
        function closeThread() {
            vm.currentThread = null;
            vm.selectedContent = null;
            vm.selectedContentID = null;
            vm.userAuditTrailEvents = null;


            // Update the state without reloading the controller
            $state.go('app.site_overview.projects.tasks.list', {
                type: vm.currentFilter.type,
                filter: vm.currentFilter.filter
            }, { notify: false });
        }

        /**
         * Add label chips
         *
         * @param query
         * @returns {filterFn}
         */
        function labelQuerySearch(query) {
            return query ?
                vm.users.filter(vm.createFilterFor(query)) : [];
        }

        /**
         * Filter for chips
         *
         * @param query
         * @returns {filterFn}
         */
        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(item) {
                if (angular.isUndefined(item.user_name))
                    return false;
                if (!angular.lowercase(item.user_name).indexOf)
                    return false;
                return angular.lowercase(item.user_name).indexOf(lowercaseQuery) >= 0;
            };
        }

        function duplicateUser() {
            for (var i = 0; i < vm.selectedThreads.length; i++) {
                vm.selectedThreads[i].id_user = '';
                delete vm.selectedThreads[i].created_at;
                vm.selectedThreads[i].firstname = vm.selectedThreads[i].firstname + ' Copy';
                saveItem(vm.selectedThreads[i]);
            }
            deselectThreads();
        }

        /**
         * Return checked status of the content
         *
         * @param content
         * @returns {boolean}
         */
        function saveItem(content) {

            var newContent = angular.copy(content);

            /*
            for (var i = vm.currentThread_ref.length - 1; i >= 0; i--) {
                if (vm.currentThread_ref[i].type.substr(0, 4) == 'date') {
                    newContent[vm.currentThread_ref[i].title] = newContent[vm.currentThread_ref[i].title].value;
                } else if (vm.currentThread_ref[i].type.substr(0, 4) == 'html') {
                    var newHtml	= newContent[vm.currentThread_ref[i].title];
                    var str		= newContent[vm.currentThread_ref[i].title];
                    var regex = /<div\b[^>]*data-qiumedia="(.*?)"[^>]*>([\s\S]*)<\/div>/g;
    
                    var m;
    
                    while ((m = regex.exec(str)) !== null) {
                        // This is necessary to avoid infinite loops with zero-width matches
                        if (m.index === regex.lastIndex) {
                            regex.lastIndex++;
                        }
    
                        if (m[0] && m[1]) {
                            newHtml	= newHtml.replace(m[0], '[' + m[1] + ']');
                        }
    
                    newContent[vm.currentThread_ref[i].title]	= newHtml;
    
                }
            }*/
            if (!newContent.id_user) {
                newContent.id_user = '';
            }

            var options = {
                site: $scope.siteID,
                id: content.id_user,
                item: transformTasks.userToDTO(newContent)
            };


            tasksService.saveItem(options).then(function (response) {
                if (content.id_user === '' || content.id_user === undefined) {
                    content.id_user = response.id_user;
                    deselectThreads();
                    $rootScope.pagination_resetquery();
                    vm.viewPreview();
                    vm.openThread(response);
                } else {
                    vm.viewPreview();
                    vm.openThread(response);
                }
                vm.closeThreadEdit();

                var message = $translate.instant('TAG.SAVED');
                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                    hideDelay: 5000,
                    position: 'top',
                    parent: '#content-container'
                });
                return true;
            });

        }

        /**
         * Return checked status of the content
         *
         * @param content
         * @returns {boolean}
         */
        function massActions(action) {
            if (vm.selectedThreads.length === 0) return false;
            var selectedIds = [];

            for (var i = 0; i < vm.selectedThreads.length; i++) {
                selectedIds.push(vm.selectedThreads[i].id);
            }
            switch (action) {
                case 'delete':
                    if (selectedIds.length == 1) {
                        var messageConfirm = $translate.instant('CONTENT.SURE_DELETED_SINGULAR');

                        var confirm = $mdDialog.confirm().title(messageConfirm).htmlContent('<b>This item will be deleted</b>.')
                            // .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' will be deleted.')
                            .ariaLabel('Delete item').targetEvent(event).ok('OK').cancel('CANCEL');
                        var message = $translate.instant('CONTENT.DELETED');
                    } else {
                        var messageConfirm = $translate.instant('CONTENT.SURE_DELETED_PLURAL');

                        var confirm = $mdDialog.confirm().title(messageConfirm).htmlContent('<b>This items will be deleted</b>.')
                            // .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' will be deleted.')
                            .ariaLabel('Delete item').targetEvent(event).ok('OK').cancel('CANCEL');
                        var message = $translate.instant('CONTENT.DELETED');
                    }
                    break;
                case 'duplicate':
                    if (selectedIds.length == 1) {
                        var confirm = $mdDialog.confirm().title(messageConfirm).htmlContent('<b>This item will be duplicated</b>.')
                            // .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' will be deleted.')
                            .ariaLabel('Duplicate item').targetEvent(event).ok('OK').cancel('CANCEL');
                        var message = $translate.instant('CONTENT.DUPLICATED');
                    } else {
                        var confirm = $mdDialog.confirm().title(messageConfirm).htmlContent('<b>This items will be duplicated</b>.')
                            // .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' will be deleted.')
                            .ariaLabel('Duplicate item').targetEvent(event).ok('OK').cancel('CANCEL');
                        var message = $translate.instant('CONTENT.DUPLICATED');
                    }
                    break;
            }


            /*
            $mdDialog.show(confirm).then(function () {
    
                var options = {
                    site   : $scope.siteID,
                    section: $scope.section,
                    action : action,
                    item   : selectedIds
                };
    
                tasksService.massActions(options).then(function (response) {
                    vm.toggleSelectThreads();
                    $rootScope.pagination_resetquery();
                    vm.closeThread();
                    $mdToast.show({
                        template : '<md-toast id="language-message"><span class="md-toast-text" flex>' + message + '</span><md-button ng-click="closeToast()">X</md-button></md-toast>',
                        hideDelay: 7000,
                        position : 'top right',
                        parent   : '#main'
                    });
                });
            });*/

        }

        $scope.closeToast = function () {
            if (isDlgOpen)
                return;

            $mdToast.hide().then(function () {
                isDlgOpen = false;
            });
        };

        /**
         * Return selected status of the thread
         *
         * @param thread
         * @returns {boolean}
         */
        /*function isSelected(thread) {
            return vm.selectedThreads.indexOf(thread) > -1;
        }*/
        function isSelected(thread) {
            return sharedFunctionsMailing.isSelected(vm.selectedThreads, thread);
        }

        /**
         * Toggle selected status of the thread
         *
         * @param thread
         * @param event
         */
        /*function toggleSelectThread(thread, event) {
            if (event) {
                event.stopPropagation();
            }
    
            if (vm.selectedThreads.indexOf(thread) > -1) {
                vm.selectedThreads.splice(vm.selectedThreads.indexOf(thread), 1);
            } else {
                vm.selectedThreads.push(thread);
            }
        }*/
        function toggleSelectThread(thread, event) {
            vm.selectedThreads = sharedFunctionsMailing.toggleSelectThread(vm.selectedThreads, thread, event);
        }

        /**
         * Select threads. If key/value pair given,
         * threads will be tested against them.
         *
         * @param [key]
         * @param [value]
         */
        function selectThreads(key, value) {
            // Make sure the current selection is cleared
            // before trying to select new threads
            vm.selectedThreads = [];
            for (var i = 0; i < vm.threads.length; i++) {
                if (angular.isUndefined(key) && angular.isUndefined(value)) {
                    vm.selectedThreads.push(vm.threads[i]);
                    continue;
                }

                if (angular.isDefined(key) && angular.isDefined(value) && vm.threads[i][key] === value) {
                    vm.selectedThreads.push(vm.threads[i]);
                }
            }
        }

        function toggleSelectGroups() {
            //vm.selectedGroups = sharedFunctionsMailing.toggleSelectThreads(vm.selectedGroups, vm.groups);
            if (vm.selectedGroups == []) {
                ivhTreeviewMgr.selectAll(vm.CleanUsersGroups);
                vm.selectedGroups = vm.CleanUsersGroups;
            } else {
                ivhTreeviewMgr.deselectAll(vm.CleanUsersGroups);
                vm.selectedGroups = [];
            }
        }

        function toggleSelectGroup(group, event) {
            if (vm.selectedGroups) {
                vm.selectedGroups = sharedFunctionsMailing.toggleSelectThread(vm.selectedGroups, group, event);
            }
        }

        function selectGroups(key, value) {
            // Make sure the current selection is cleared
            // before trying to select new threads
            vm.selectedGroups = [];
            for (var i = 0; i < vm.threads.length; i++) {
                if (angular.isUndefined(key) && angular.isUndefined(value)) {
                    vm.selectedGroups.push(vm.threads[i]);
                    continue;
                }

                if (angular.isDefined(key) && angular.isDefined(value) && vm.threads[i][key] === value) {
                    vm.selectedGroups.push(vm.threads[i]);
                }
            }
        }

        /**
         * Deselect threads
         */
        function updateThread(itemThread) {
            // console.log("ITEMS ", itemThread, "THREADSS ", vm.threads)
            for (var i = 0; i < vm.threads.length; i++) {
                if (vm.threads[i]['id'] == itemThread['id']) {
                    // console.log(vm.threads[i]['id_user'])
                    vm.threads[i] = itemThread;
                    // console.log("vm.threads[i] ", vm.threads[i])
                }
                // if (angular.isUndefined(key) && angular.isUndefined(value)) {
                // 	vm.selectedThreads.push(vm.threads[i]);
                // 	continue;
                // }

                // if (angular.isDefined(key) && angular.isDefined(value) && vm.threads[i][key] === value) {
                // 	vm.selectedThreads.push(vm.threads[i]);
                // }
            }
        }

        /**
         * Deselect threads
         */
        /*function deselectThreads() {
            vm.selectedThreads = [];
        }*/
        function deselectThreads() {
            vm.selectedThreads = sharedFunctionsMailing.deselectThreads();
        }

        /**
         * Toggle select threads
         */
        /*function toggleSelectThreads() {
            if (vm.selectedThreads.length > 0) {
                vm.deselectThreads();
            } else {
                vm.selectThreads();
            }
        }*/
        function toggleSelectThreads() {
            vm.selectedThreads = sharedFunctionsMailing.toggleSelectThreads(vm.selectedThreads, vm.threads);
        }

        function toggleSelectAllThreads() {

        }

        /**
         * Set the status on given thread, current thread or selected threads
         *
         * @param key
         * @param value
         * @param [thread]
         * @param [event]
         */
        function setThreadStatus(key, value, thread, event) {
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if (event) {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if (thread) {
                thread[key] = value;
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if (vm.currentThread) {
                vm.currentThread[key] = value;
                return;
            }

            // Otherwise do the status update on selected threads
            for (var x = 0; x < vm.selectedThreads.length; x++) {
                vm.selectedThreads[x][key] = value;
            }
        }

        /**
         * Toggle the value of the given key on given thread, current
         * thread or selected threads. Given key value must be boolean.
         *
         * @param key
         * @param thread
         * @param event
         */
        function toggleItemStatus(thread, event, key) {

            event.stopPropagation();

            var confirm = $mdDialog.confirm().title('Are you sure want to set the item?').htmlContent('<b>This item will be changed </b>.')
                // .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' will be deleted.')
                .ariaLabel('change item').targetEvent(event).ok('OK').cancel('CANCEL');

            $mdDialog.show(confirm).then(function () {

                thread.onoff = (thread.onoff === 1) ?
                    0 :
                    1;
                vm.threads[key].onoff = thread.onoff;

                var options = {
                    site: $scope.siteID,
                    section: $scope.section,
                    id: vm.threads[key].id,
                    item: vm.threads[key]
                };

                contentService.saveItem(options).then(function (response) {
                    // vm.viewPreview();
                    // vm.selectContent(content);
                    var message = "Saved";

                    $mdToast.show({
                        template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                        hideDelay: 5000,
                        position: 'top',
                        parent: '#content-container'
                    });

                    return true;
                });

            }, function () {
                // alert("cancel")

            });

            return;
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if (event) {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if (thread) {
                if (typeof (thread[key]) !== 'boolean') {
                    return;
                }

                thread[key] = !thread[key];
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if (vm.currentThread) {
                if (typeof (vm.currentThread[key]) !== 'boolean') {
                    return;
                }

                vm.currentThread[key] = !vm.currentThread[key];
                return;
            }

            // Otherwise do the status update on selected threads
            for (var x = 0; x < vm.selectedThreads.length; x++) {
                if (typeof (vm.selectedThreads[x][key]) !== 'boolean') {
                    continue;
                }

                vm.selectedThreads[x][key] = !vm.selectedThreads[x][key];
            }
        }

        /**
         * Toggle the value of the given key on given thread, current
         * thread or selected threads. Given key value must be boolean.
         *
         * @param key
         * @param thread
         * @param event
         */
        function toggleItemStatusEdit(fieldName) {

            event.stopPropagation();
            var thread = vm.currentThread_Edit[fieldName];
            thread = (thread === 1) ?
                0 :
                1;

            vm.currentThread_Edit[fieldName] = thread;
            vm.basicForm.$setDirty()
        }

        function deleteAttachment(attachment) {

            if (attachment.id_zone) {
                for (var i = 0; i < vm.currentThread_Edit.Thumbnail.length; i++) {
                    if (vm.currentThread_Edit.Thumbnail[i].id_media === attachment.id_media && vm.currentThread_Edit.Thumbnail[i].id_zone === attachment.id_zone) {
                        if (angular.isUndefined(vm.currentThread_Edit.ThumbnailRemove))
                            vm.currentThread_Edit.ThumbnailRemove = [];
                        vm.currentThread_Edit.ThumbnailRemove.push(vm.currentThread_Edit.Thumbnail[i]);
                        vm.currentThread_Edit.Thumbnail.splice(i, 1);
                    }
                }

                for (var i = 0; i < vm.thumbnails_Edit[attachment.id_zone].length; i++) {
                    if (vm.thumbnails_Edit[attachment.id_zone][i].id_media === attachment.id_media) {
                        vm.thumbnails_Edit[attachment.id_zone].splice(i, 1);
                    }
                }

            } else {
                if (vm.currentThread_Edit.Thumbnail[i].id_media === attachment.id_media) {
                    if (angular.isUndefined(vm.currentThread_Edit.ThumbnailRemove))
                        vm.currentThread_Edit.ThumbnailRemove = [];
                    vm.currentThread_Edit.ThumbnailRemove.push(vm.currentThread_Edit.Thumbnail[i]);
                    vm.currentThread_Edit.Thumbnail.splice(i, 1);
                }
            }
            vm.basicForm.$setDirty()

        }

        /**
         * Toggle the value of the given key on given thread, current
         * thread or selected threads. Given key value must be boolean.
         *
         * @param key
         * @param thread
         * @param event
         */
        function toggleThreadStatus(key, thread, event) {
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if (event) {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if (thread) {
                if (typeof (thread[key]) !== 'boolean') {
                    return;
                }

                thread[key] = !thread[key];
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if (vm.currentThread) {
                if (typeof (vm.currentThread[key]) !== 'boolean') {
                    return;
                }

                vm.currentThread[key] = !vm.currentThread[key];
                return;
            }

            // Otherwise do the status update on selected threads
            for (var x = 0; x < vm.selectedThreads.length; x++) {
                if (typeof (vm.selectedThreads[x][key]) !== 'boolean') {
                    continue;
                }

                vm.selectedThreads[x][key] = !vm.selectedThreads[x][key];
            }
        }

        /**
         * Get label object content
         *
         * @param id
         * @returns {*}
         */
        function getLabel(id) {
            for (var i = 0; i < vm.labels.length; i++) {
                if (vm.labels[i].id === id) {
                    return vm.labels[i];
                }
            }
        }

        /**
         * Get label color from label object
         *
         * @param id
         * @returns {*}
         */
        function getLabelColor(id) {
            return vm.getLabel(id).color;
        }

        /**
         * Get label title from label object
         *
         * @param id
         * @returns {*}
         */
        function getLabelTitle(id) {
            return vm.getLabel(id).title;
        }

        /**
         * Toggle label
         *
         * @param label
         */
        function toggleLabel(label) {
            // Toggle label on the currently open thread
            if (vm.currentThread) {
                if (vm.currentThread.labels.indexOf(label.id) > -1) {
                    vm.currentThread.labels.splice(vm.currentThread.labels.indexOf(label.id), 1);
                } else {
                    vm.currentThread.labels.push(label.id);
                }

                return;
            }

            // Toggle labels on selected threads
            // Toggle action will be determined by the first thread from the selection.
            if (vm.selectedThreads.length > 0) {
                // Decide if we are going to remove or add labels
                var removeLabels = (vm.selectedThreads[0].labels.indexOf(label.id) > -1);

                for (var i = 0; i < vm.selectedThreads.length; i++) {
                    if (!removeLabels) {
                        vm.selectedThreads[i].labels.push(label.id);
                        continue;
                    }

                    if (vm.selectedThreads[i].labels.indexOf(label.id) > -1) {
                        vm.selectedThreads[i].labels.splice(vm.selectedThreads[i].labels.indexOf(label.id), 1);
                    }
                }
            }
        }

        /**
         * Is label exist?
         *
         * @param label
         * @returns {boolean}
         */
        function isLabelExist(label) {
            if (vm.currentThread && vm.currentThread.labels) {
                return (vm.currentThread.labels.indexOf(label.id) > -1);
            }
        }

        /**
         * Change the view
         *
         * @param view
         */
        function changeView(view) {
            if (vm.views[view]) {
                vm.loadingView = true;
                vm.defaultView = view;
                vm.currentView = view;
                vm.closeThread();
                vm.closeThreadEdit();
            }
        }

        function orderRefFields() {
            var header = [];
            var main = [];
            var secondary = [];

            for (var i = 0; i < vm.currentThread_ref.length; i++) {
                if (vm.currentThread_ref[i].edit_position === 'header') {
                    header.push(vm.currentThread_ref[i]);
                } else if (vm.currentThread_ref[i].edit_position === 'main') {
                    main.push(vm.currentThread_ref[i]);
                } else if (vm.currentThread_ref[i].edit_position === 'secondary') {
                    secondary.push(vm.currentThread_ref[i]);
                }
            }


            header.sort(function (a, b) {
                return (a.edit_sort - b.edit_sort);
            });

            main.sort(function (a, b) {
                return (a.edit_sort - b.edit_sort);
            });

            secondary.sort(function (a, b) {
                return (a.edit_sort - b.edit_sort);
            });

            vm.currentThread_ref = [];

            for (var i = 0; i < header.length; i++) {
                vm.currentThread_ref.push(header[i]);
            }
            for (var i = 0; i < main.length; i++) {
                vm.currentThread_ref.push(main[i]);
            }
            for (var i = 0; i < secondary.length; i++) {
                vm.currentThread_ref.push(secondary[i]);
            }

        }

        /**
         * Toggle view Edit
         */
        function viewEditInline() {
            resetScroll();
            vm.currentTab = 'edit';
            if (!vm.editInline) {
                vm.editInline = true;
                vm.currentThread_Edit = angular.copy(vm.selectedContent);
                getCurrentLabelsEdit();
                if (vm.selectedContent_ref) {
                    vm.currentThread_ref = angular.copy(vm.selectedContent_ref);
                    orderRefFields();
                }
                angular.forEach(vm.selectedContent_ref, function (refColumn) {
                    switch (refColumn.type) {
                        case 'date':
                        case 'dateHm':
                            var type = 'input';
                            break;
                        case 'single':
                            var type = 'input';
                            break;
                        default:
                            break;
                    }
                });
                getCountriesWithStates();
            }
        }

        /**
         * Toggle view Edit
         */
        function viewPreview() {
            resetScroll();
            vm.editInline = false;
        }

        function resetScroll() {
            if (angular.element(document.getElementById('thread-detail')).length) {
                var elem = angular.element(document.getElementById('thread-detail'));
                elem.scrollTopAnimated(0, 10);
            }
        }

        /**
         * Open compose dialog
         *
         * @param ev
         */

        function composeDialog(ev) {
            $mdDialog.show({
                controller: 'ComposeDialogController',
                controllerAs: 'vm',
                locals: {
                    selectedContent: undefined
                },
                templateUrl: 'app/main/dialogs/compose/compose-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        }

        /**
         * Open Image dialog
         *
         * @param ev
         * @param task
         */
        function openImageDialog(ev, images, ImageSelected) {
            $mdDialog.show({
                controller: 'MediaShowDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/dialogs/media-show/media-show-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Images: images,
                    ImageSelected: ImageSelected,
                    cropFormats: false,
                    MediaFull: false,
                    Tags: false,
                    // Tasks: vm.tasks,
                    // event: ev
                }
            });
        }

        /**
         * Open Image dialog
         *
         * @param ev
         * @param task
         */
        function openFocalPoint(ev, ImageSelected) {
            $mdDialog.show({
                controller: 'MediaFocalPointDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/dialogs/media-focal-point/media-focal-point-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    ImageSelected: ImageSelected,
                }
            }).then(function (item) {
                vm.basicForm.$setDirty()
                angular.forEach(vm.mediaZones, function (mediazone) {
                    angular.forEach(vm.thumbnails_Edit[mediazone.id_zone], function (attachment) {
                        if (item.id_media === attachment.id_media) {
                            attachment.imageCenterRatioX = item.imageCenterRatioX;
                            attachment.imageCenterRatioY = item.imageCenterRatioY;
                        }
                    })
                })
            });
        }

        /**
         * Open compose dialog
         *
         * @param ev
         */


        /**
         * Open TinyMCE media selector
         *
         * @param item
         */

        function mediaDialogTiny(item) {
            $mdDialog.show({
                controller: 'MediaDialogController',
                controllerAs: 'vm',
                locals: {
                    currentThread: item,
                    section: $scope.section,
                    mediazone: 1,
                    isTiny: 1,
                    maxAttach: undefined,
                    showViews: {
                        1: true,
                        2: true,
                        3: true,
                        4: true,
                        5: true,
                        upload: true,
                        import: true
                    }
                },
                templateUrl: 'app/main/dialogs/media/media-dialog-tinymce.html',
                parent: angular.element($document.body),
                clickOutsideToClose: true
            }).then(function (item) {

                /*
                                vm.currentThread_Edit = item;
    
                                vm.basicForm.$setDirty()
                                vm.thumbnails_Edit = {};
                                angular.forEach(vm.mediaZones, function (mz) {
                                    if (angular.isUndefined(vm.thumbnails_Edit[mz.id_zone])) {
                                        vm.thumbnails_Edit[mz.id_zone] = [];
                                    }
                                })
                                angular.forEach(vm.currentThread_Edit.Thumbnail, function (thumb) {
                                    vm.thumbnails_Edit[thumb.id_zone].push(thumb);
                                })
                */
            });
        }


        function openGroupDialog(ev, group) {
            $mdDialog.show({
                controller: 'EditGroupDialogController',
                controllerAs: 'vm',
                locals: {
                    group: group,
                    siteID: $scope.siteID
                    //nestedGroups:
                },
                templateUrl: 'app/main/apps/tasks/dialogs/groups/edit-group.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
            });
        }

        /**
         * Open reply dialog
         *
         * @param ev
         */
        function replyDialog(ev) {
            $mdDialog.show({
                controller: 'ComposeDialogController',
                controllerAs: 'vm',
                locals: {
                    selectedContent: vm.selectedContent
                },
                templateUrl: 'app/main/dialogs/compose/compose-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        }

        function setGroupBy(field) {
            $rootScope.pagination_setSortField(field);
            vm.groupBy = field;
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */

        function cancelUsersGroups(sidenavId) {
            vm.usersGroups = angular.copy(vm.copyUsersGroups);
            $mdSidenav(sidenavId).toggle();
        }

        function saveUsersGroups(sidenavId) {
            vm.copyUsersGroups = [];
            $mdSidenav(sidenavId).toggle();
            vm.currentLabelsFilter = transformTasks.getLabels(vm.usersGroups, []);

            if (vm.currentLabelsFilter.length > 0) {
                var array = transformTasks.getGroupsFromLabels(vm.currentLabelsFilter);
                if (array.length === 1) {
                    var copy = angular.copy(array[0]);
                    array[0] = -1;
                    array.push(copy);
                }
                var options = {
                    site: $scope.siteID,
                    section: $scope.section,
                    ids: array
                };
                getUsersByGroups(options);
            } else {
                resetFilters();
            }
            vm.selectedContent = undefined;

        }

        function getUsersByGroups(options) {
            tasksService.getUsersByGroups(options).then(function (response) {
                vm.threads = response.data;
                $rootScope.pagination_totalItems = response.total;
                $rootScope.pagination_total_pages = response.last_page;
            });
        }

        function resetFilters() {
            vm.currentLabelsFilter = undefined;
            vm.usersGroups = transformTasks.formatNestedGroups(angular.copy(vm.refFilterables));
            $rootScope.pagination_resetquery();
        }

        function resetGroupby() {
            vm.groupBy = undefined;
            $rootScope.pagination_setSortField('id_user');
            $rootScope.pagination_resetquery();
        }

        function resetSortField() {
            vm.groupBy = undefined;
            vm.fieldOrder = undefined;
            $rootScope.pagination_setSortField('id_user');
            $rootScope.pagination_resetquery();
        }




        function mediaDialog(ev, mediazone, item, type) {
            console.log(ev, mediazone, item, type)
            item.Thumbnail = [];

            $mdDialog.show({
                controller: 'MediaDialogController',
                controllerAs: 'vm',
                locals: {
                    currentThread: item,
                    section: $scope.section,
                    mediazone: mediazone,
                    multipleSelection: false,
                    isTiny: false,
                    maxAttach: undefined,
                    showViews: {
                        1: true,
                        2: true,
                        3: true,
                        4: true,
                        5: true,
                        upload: true,
                        import: true
                    }
                },
                templateUrl: 'app/main/dialogs/media/media-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true

            }).then(function (item) {
                vm.currentThread_Edit.avatar = item.Thumbnail[0];
                vm.basicForm.$setDirty();
            });
        }

        function deleteTargetFilter(id, index) {

            vm.currentLabelsFilter.splice(index, 1);
            var groups = transformTasks.getGroupsFromLabels(vm.currentLabelsFilter);
            vm.usersGroups = transformTasks.initGroupsTree(angular.copy(vm.refFilterables), groups, vm.ingroupStatus);

            if (vm.currentLabelsFilter.length <= 0) {
                vm.currentLabelsFilter = undefined;
                $rootScope.pagination_resetquery();

            } else {

                var options = {
                    site: $scope.siteID,
                    section: $scope.section,
                    ids: arrayIds
                };
                getUsersByGroups(options);
                vm.selectedContent = undefined;
            }

        }

        function toggleSidenav(sidenavId) {
            if (!vm.usersGroups) {
                vm.usersGroups = transformTasks.formatNestedGroups(angular.copy(vm.refFilterables));
            }
            vm.copyUsersGroups = angular.copy(vm.usersGroups);
            $mdSidenav(sidenavId).toggle();
        }

        function isNumber(value) {
            return angular.isNumber(value);
        }

        function hasDateShow(value) {
            if (value != null && !angular.isUndefined(value.dateShow)) {
                return value.dateShow;
            }
            return false;
        }

        function siteLanguages() {
            return sessionService.getSiteLanguages();
        }

        function dateSelectedCallback(date, fieldName) {
            console.log(date, fieldName)
        }

        function getCurrentMedia() {
            return vm.currentThread_Edit.Thumbnail;
        }

        function getZoneCrop(field) {
            var cropId = '';
            if (!angular.isUndefined(field.id_cropformats)) {
                cropId = field.id_cropformats;
            }
            return cropId;
        }

        function newUser(userName) {
            var newUser = {
                id_user: '',
                user_name: userName
            }
            vm.users.push(newUser);
            vm.currentThread_Edit.users.push(newUser);
            vm.searchUserText = '';
        }


        $scope.$watch('vm.currentThread_Edit.country', function (countryId) {
            if (countryId) {
                getStatesByCountry(countryId);
            } else if (vm.currentThread_Edit) {
                vm.currentThread_Edit.state = "";
            }
        });

        $scope.$watch('vm.currentThread_Edit.state', function (stateId) {
            if (stateId) {
                getCitiesByState(stateId);
            } else if (vm.currentThread_Edit) {
                vm.currentThread_Edit.city = "";
            }
        });

        function getCountriesWithStates() {
            if (angular.isUndefined(vm.countriesWithStates)) {
                vm.countriesWithStates = [];
                var options = {
                    paginate: 99999,
                    resultsPerPage: 300
                };
                tasksService.getCountriesWithStates(options).then(function (response) {

                    if (response.total) {
                        angular.forEach(response.data, function (item) {
                            var resultId = item['id_country'];
                            var resultData = {
                                id: resultId,
                                code: item['code'],
                                name: item['country']
                            };
                            vm.countriesWithStates.push(resultData);
                        })
                    }
                })
            }
        }

        function getCountryById(id) {
            var country;
            angular.forEach(vm.countriesWithStates, function (item) {
                if (item.id == id) {
                    country = item;
                }
            })
            return country;
        }


        function getStatesByCountry(countryId) {

            if (angular.isDefined(countryId)) {
                vm.statesWithCities = [];
                var options = {
                    paginate: 99999,
                    resultsPerPage: 99999,
                    id_country: countryId
                };
                tasksService.getStatesWithCities(options).then(function (response) {
                    if (response.total) {
                        angular.forEach(response.data, function (item) {
                            var resultId = item['id_state'];
                            var resultData = {
                                id: resultId,
                                code: item['code'],
                                name: item['state'],
                                cities: item['cities']
                            };
                            vm.statesWithCities.push(resultData);
                            if (vm.selectedContent.state && vm.selectedContent.state == resultData.id) {
                                vm.selectedContent.related_state = resultData;
                                vm.getCitiesByState(vm.selectedContent.state);
                            }
                        })
                    }
                })
            }
        };

        function getCitiesByState(stateId) {
            if (angular.isDefined(stateId) && stateId !== '') {
                var item = ($filter('filter')(vm.statesWithCities, { id: stateId }));
                if (item && item.length > 0) {
                    vm.cities = item[0].cities;
                }
                if (vm.selectedContent.city) {
                    angular.forEach(vm.cities, function (item) {
                        if (item.id_city == vm.selectedContent.city) {
                            vm.selectedContent.related_city = item;
                        }
                    });
                }
            }
        }

        function loginToWebsite(user) {
            tasksService.getUserToken({
                siteID: $scope.siteID,
                id: user.id_user
            }).then(function (response) {
                $window.open(vm.loginUrl + response.token, 'website');
            })
        }

    }


    function LoadUsersByGroups(tasksService) {

        function unselectAllGroups() {
            var elemList = document.querySelectorAll('.group-row');
            elemList.forEach(function (elem) {
                elem.classList.remove('selected');
            });
        }

        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                $(element).on('click', function (e) {
                    var groupNode = false;
                    if (element.parent().hasClass('selected')) {
                        unselectAllGroups();
                    } else {
                        unselectAllGroups();
                        element.parent().addClass('selected');
                        groupNode = scope.node;
                    }
                    var includeSubgroups = $('#includeSubgroups').attr("data-include-subgroups") == 'true';
                    tasksService.triggerUsersByGroups(groupNode, includeSubgroups);
                });
            }
        };
    }

    function ToggleAssignedGroup() {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                $(element).on('click', function (e) {
                    scope.node.assigned_group = !scope.node.assigned_group;
                });
            }
        };
    }

    function SetInGroupStatus() {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                scope.$watch(attrs.ngModel, function (v) {
                    if (angular.isDefined(v)) {
                        scope.node.id_ingroup_status = v;
                    }
                });
            }
        };
    }

    function OpenGroupEditDialog(tasksService) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                $(element).on('click', function (e) {
                    var groupNode = scope.node;
                    tasksService.triggerGroupDialog(groupNode);
                });
            }
        };
    }

    function renderTinyMedia(content) { }

    function CloseSidenav(tasksService) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                $(element).on('click', function (e) {
                    tasksService.triggerCloseSidenav(attrs.sidenavId);
                });
            }
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.projects')
        .service('tasksService', tasksService);

    /** @ngInject */
    // I provide access to the session store.
    function tasksService($rootScope, $q, $resource, userService, settingsDomainService, sessionService, COMMON, $window) {
        function get(options) {
            if (options.groupIds === undefined) {
                return getUsers(options);
            } else {
                return getUsersByGroups(options);
            }
        }

        function getUsers(options) {

            var deferred = $q.defer();
            var filters = [];

            _.forEach(options, function (value, key, list) {
                if (_.isObject(list[key])) {
                    _.forEach(list[key], function (filter, keyFilter, listFilter) {
                        if (!_.isEmpty(filter.selected)) {
                            filters.push({
                                field: filter.field,
                                name: filter.name,
                                values: filter.selected
                            });
                        }

                    });

                }
            });

            resourceUsers.get({
                domain: options.siteID,
                // page: options.page,
                // search: options.searchStringFilter,
                // paginate: options.paginate,
                // sortField: options.sortField,
                // sortDir: options.sortDir,
                // filters: JSON.stringify(filters),
                // resultsPerPage: 50
            },
                function (responseResult) {
                    resourceUsersRef.get({
                        domain: options.siteID,
                        // page: options.page,
                        // search: options.searchStringFilter,
                        // paginate: options.paginate,
                        // sort: options.sort,
                        // filters: JSON.stringify(filters),
                    },
                        function (response) {
                            deferred.resolve({
                                ref: response.ref,
                                result: responseResult.result
                            });
                        },
                        function (e) {
                            console.error("ERROR =========================================!!!!!!")
                            console.error(e)
                            deferred.reject();
                        }
                    );

                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getUserByID(options) {
            var deferred = $q.defer();
            resourceUserById.get({
                domain: options.site,
                id: options.id
                // lang: get("language")
            },
                function (response) {

                    // console.log("from serve ", response)
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getTasksMessages(options) {
            
            var deferred = $q.defer();
            resourceMessage.get({
                domain: options.site,
                filters: JSON.stringify([options.tasks])
            }, function(response) {
                // console.log('Messages ', response)
                deferred.resolve(response);
            }, function(e) {
                console.error(e)
                console.error("Database connection error")
                deferred.reject();
            })
            return (deferred.promise);
        }

        function getCurrentUser(options) {
            var deferred = $q.defer()
            resourceUserForTask.get({
                domain: options.site
            }, function(response) {
                console.log("USERS ", response)
                deferred.resolve(response)
            }, function(e) {
                console.error(e)
                console.error("Database connection error")
                deferred.reject();
            })
            return (deferred.promise)
        }

        function putMesssage(items) {
            // console.log(items)
            var deferred = $q.defer()
            resourcePutMessage.update({
                domain: 'sports_temp'
            }, items, function(response) {
                console.log("PUT MESSAGE ", response)
                deferred.resolve(response)
            }, function(e) {
                console.error(e)
                console.error("Database connection error")
                deferred.reject();
            })
            return (deferred.promise)
        }

        function getUsersByGroups(options) {

            var deferred = $q.defer();
            var filters = [];

            _.forEach(options, function (value, key, list) {
                if (_.isObject(list[key])) {
                    _.forEach(list[key], function (filter, keyFilter, listFilter) {
                        if (!_.isEmpty(filter.selected)) {
                            filters.push({
                                field: filter.field,
                                name: filter.name,
                                values: filter.selected
                            });
                        }

                    });

                }
            });

            resource_user_by_users_groups.get({
                domain: options.siteID,
                'id_group[]': options.groupIds,
                sortField: options.sortField,
                sortDir: options.sortDir,
                resultsPerPage: 50,
                page: options.page

            },
                function (responseResult) {
                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    resourceUsersRef.get({
                        domain: options.siteID,
                        // page: options.page,
                        // search: options.searchStringFilter,
                        // paginate: options.paginate,
                        // sort: options.sort,
                        // filters: JSON.stringify(filters),
                    },
                        function (response) {
                            // angular.copy(response, modulecontent);
                            // setActiveDomain(domain);

                            deferred.resolve({
                                ref: response,
                                result: responseResult
                            });
                        },
                        function (e) {
                            console.error("ERROR =========================================!!!!!!")
                            console.error(e)
                            deferred.reject();
                        }
                    );

                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );

            return (deferred.promise);
        };

        function getUsersGroups(options) {
            var deferred = $q.defer();
            var params  = {
              domain: options.siteID,
              groupType: options.groupType
            }
            if (options.withGroupType) {
              params.withGroupType = true;
            }
            resourceGroupsNested.get(params,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);

        }

        function getUsersGroupsTypes(options) {
            var deferred = $q.defer();
            resourceGroupsTypes.get({
                domain: options.siteID
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);

        }

        function getUsersInGroupStatus(siteID) {
            var deferred = $q.defer();
            resourceInGroupStatus.get({
                domain: siteID
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);

        }

        function getUnnestedUsersGroups(siteID) {
            var deferred = $q.defer();
            resourceGroups.get({
                domain: siteID
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);

        }

        function createUsersGroup(siteID, parentId, name, groupTypeId) {
            var deferred = $q.defer();
            resourceGroups.post({
                domain: siteID,
                parent: parentId,
                name: name,
                id_group_type: groupTypeId
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);

        }

        function editUsersGroup(siteID, groupId, parentId, name, groupTypeId) {
            var deferred = $q.defer();
            resourceGroups.update({
                domain: siteID,
                parent: parentId,
                name: name,
                id_group_type: groupTypeId,
                id: groupId
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);

        }

        function deleteUsersGroup(siteID, groupId) {
            var deferred = $q.defer();
            resourceGroups.delete({
                domain: siteID,
                id: groupId
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);

        }

        function massInsertUsersIntoGroups(options) {
            var deferred = $q.defer();
            resourceUsersInGroupsMassInsert.post({
                    domain: options.siteID
                }, JSON.stringify(options.data),
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function removeUsersFromGroup(options) {
            var deferred = $q.defer();
            resourceUsersInGroup.delete({
                    domain: options.siteID,
                    id: options.data.id_group,
                    id_group: options.data.id_group,
                    'id_user[]': options.data.id_user
                }, JSON.stringify(options.data),
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }



        function getUserGroups(options) {
            var deferred = $q.defer();
            resourceUserGroups.get({
                domain: options.site,
            },
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function deleteItem(options) {
            var deferred = $q.defer();
            resource_user_byID.delete({
                domain: options.site,
                id: options.id
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function triggerUsersByGroups(groupNode, includeSubgroups) {
            var groups = false;
            if (groupNode) {
                var node = angular.fromJson(groupNode);
                groups = unnestGroups(node, [], includeSubgroups);
            }
            $rootScope.$broadcast('loadUsersByGroups', groups);
        }

        function triggerReloadGroups() {
            $rootScope.$broadcast('reloadGroups');
        }

        function triggerSelectParentGroup(groupNode) {
            $rootScope.$broadcast('selectParentGroup', groupNode);
        }

        function triggerCloseSidenav(sidenavId) {
            $rootScope.$broadcast('closeSidenav', sidenavId);
        }


        function unselectAllGroups(){
            var elemList = document.querySelectorAll('.group-row');
            elemList.forEach(function(elem) {
                elem.classList.remove('selected');
            });
        }

        function unnestGroups(node, groups, includeSubgroups) {
            groups.push(node);
            if (includeSubgroups && typeof node.children !== 'undefined' && node.children.length >0) {
                angular.forEach(node.children, function (data) {
                    unnestGroups(data, groups, includeSubgroups);
                });
            }
            return groups;
        }

        function triggerGroupDialog(group) {
            $rootScope.$broadcast('openGroupDialog', group);
        }

        function getCountriesWithStates(options) {
            var deferred = $q.defer();
            resourceCountriesWithStates.get({
                    resultsPerPage: options.paginate,
                },
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function getStatesWithCities(options) {
            var deferred = $q.defer();

            resourceStatesWithCities.get({
                    resultsPerPage: options.paginate,
                    id_country: options.id_country
                },
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );
            // Return the promise.
            return (deferred.promise);
        }

        function saveItem(options) {
            var deferred = $q.defer();

            if (options.id !== '' && options.id !== undefined) {
                resource_user_byID.update({
                    domain: options.site,
                    id: options.id,
                    verify: options.item.verify,
                }, options.item,
                    function (response) {

                        deferred.resolve(response);
                    },
                    function (e) {
                        console.error(e)
                        console.error("Database connection error")
                        deferred.reject();
                    }
                );
            } else {
                resource_user_post_byID.save({
                    domain: options.site,
                    verify: options.item.verify
                }, options.item,
                    function (response) {

                        // angular.copy(response, modulecontent);
                        // setActiveDomain(domain);

                        deferred.resolve(response);
                    },
                    function (e) {
                        console.error(e)
                        console.error("Database connection error")
                        deferred.reject();
                    }
                );
            }

            // Return the promise.
            return (deferred.promise);
        }

        function getUsersAuditTrailByID(options){
            
            var deferred = $q.defer();
            var params  = {
              domain: options.site,
              user_id: options.id
            }
            resourceAuditTrailByID.get(params,
                function (response) {
                    // console.log(response)
                    deferred.resolve(response.result.data);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function getUsersAuditTrail(options){
            
            var deferred = $q.defer();
            var params  = {
              domain: options.site
            }
            resourceAuditTrail.get(params,
                function (response) {
                    deferred.resolve(response.data);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function getUserToken(options){

            var deferred = $q.defer();
            var params  = {
              domain: options.siteID,
              id: options.id
            }
            resourceGenericUserToken.get(params,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        var resourceGroupsNested = $resource(
            COMMON.BASE_API + "/domain/:domain/usersGroupsNested", {
                // No default data.
            }, {
                get: {
                    method: "GET",
                    isArray: false,
                    transformResponse: function(data, headers){
                        var response = {}
                        response.data = JSON.parse(data);
                        response.qiuRestrictions = JSON.parse(headers('qiu-restrictions'));
                        return response;
                    }
                }
            }
        );
        var resourceAuditTrailByID = $resource(
            COMMON.BASE_API + "/domain/:domain/content/crm_status/:id", {
                // No default data. mine
            }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            }
        );
        var resourceAuditTrail = $resource(
            COMMON.BASE_API + "/domain/:domain/usersAuditTrail?withUser", {
                // No default data.
            }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            }
        );

        var resourceGenericUserToken = $resource(
            COMMON.BASE_API + "/domain/:domain/users/getGenericToken/:id", {
                // No default data.
            }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            }
        );

        var resourceGroupsTypes = $resource(
            COMMON.BASE_API + "/domain/:domain/usersGroupsTypes", {
                // No default data.
            }, {
                get: {
                    method: "GET",
                    isArray: true
                }
            }
        );

        var resourceInGroupStatus = $resource(
            COMMON.BASE_API + "/domain/:domain/usersInGroupStatus", {
                // No default data.
            }, {
                get: {
                    method: "GET",
                    isArray: true
                }
            }
        );

        var resourceGroups = $resource(
            COMMON.BASE_API + "/domain/:domain/content/crm_status/:id", {
                // No default data. mine
                domain: '@domain',
                id: '@id'
            }, {
                get: {
                    method: "GET",
                    isArray: false
                },
                post: {
                    method: "POST"
                },
                update: {
                    method: "PUT"
                },
                delete: {
                    method: "DELETE",
                    isArray: true
                }

            }
        );


        var resourceUsers = $resource(COMMON.BASE_API + "/domain/:domain/content/crm_tasks", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });
        var resourceUsersRef = $resource(COMMON.BASE_API + "/domain/:domain/content/crm_tasks", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });

        var resourceUserById = $resource(COMMON.BASE_API + "/domain/:domain/content/crm_tasks/:id", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    // isArray: true
                }
            });

        var resourceMessage = $resource(COMMON.BASE_API + "/domain/:domain/content/crm_messages", {

        }, {
            get: {
                method: "GET",
                // isArray: "true"
            }
        })

        var resourceUserForTask = $resource(COMMON.BASE_API + "/domain/:domain/accounts/basic", {

        }, {
            get: {
                method: "GET",
                // isArray: "true"
            }
        })

        var resourcePutMessage = $resource(COMMON.BASE_API + "/domain/:domain/content/crm_messages/new", {

        }, {
            update: {
                method: 'PUT'
            }
        })

        var resourceUserGroups = $resource(
            COMMON.BASE_API + "/domain/:domain/usersGroupsNested", {
                // No default data.
            }, {
                get: {
                    method: "GET",
                    isArray: true
                }
            }
        );

        var resource_user_by_users_groups = $resource(
            COMMON.BASE_API + "/domain/:domain/usersInGroup", {
                // No default data.

            }, {
                get: {
                    method: "GET",
                    //isArray: true
                }
            }
        );

        var resourceUsersInGroup = $resource(
            COMMON.BASE_API + "/domain/:domain/usersInGroup/:id", {
                // No default data.
            }, {
                delete: {
                    method: "DELETE",
                    isArray: true
                }
            }
        );

        var resourceUsersInGroupsMassInsert = $resource(
            COMMON.BASE_API + "/domain/:domain/usersInGroups/massInsert", {
                // No default data.

            }, {
                post: {
                    method: "POST",
                    //isArray: true
                }
            }
        );

        var resource_user_post_byID = $resource(
            COMMON.BASE_API + "/domain/:domain/crm_tasks", {
                domain: '@domain',
            }, {
                save: {
                    method: "POST",
                },
            }
        );

        var resource_user_byID = $resource(
            COMMON.BASE_API + "/domain/:domain/crm_tasks/:id", {
                domain: '@domain',
                id: '@id',
            }, {
                get: {
                    method: "GET",
                },
                update: {
                    method: "PUT",
                },
                delete: {
                    method: "DELETE",
                    isArray: true
                }
            }
        );

        var resourceCountriesWithStates   = $resource(
            COMMON.BASE_API + "/location/countries?withStates", {
                // No default data.
            }, {
                get: {
                    method: "GET",
                    // isArray: true
                }
            }
        );

        var resourceStatesWithCities   = $resource(
            COMMON.BASE_API + "/location/states?withCities", {
                // No default data.
            }, {
                get: {
                    method: "GET",
                    // isArray: true
                }
            }
        );

        return ({
            get: get,
            //get: getUsers,
            //get: getUsersByGroups,
            getUserByID: getUserByID,
            getTasksMessages: getTasksMessages,
            getCurrentUser: getCurrentUser,
            putMesssage: putMesssage,
            getFilters: getUserGroups,
            saveItem: saveItem,
            deleteItem: deleteItem,
            getUsers: getUsers,
            getUsersByGroups: getUsersByGroups,
            getUsersGroups: getUsersGroups,
            triggerUsersByGroups: triggerUsersByGroups,
            triggerGroupDialog: triggerGroupDialog,
            getCountriesWithStates: getCountriesWithStates,
            getStatesWithCities: getStatesWithCities,
            getUnnestedUsersGroups: getUnnestedUsersGroups,
            createUsersGroup: createUsersGroup,
            editUsersGroup: editUsersGroup,
            deleteUsersGroup: deleteUsersGroup,
            triggerSelectParentGroup: triggerSelectParentGroup,
            unnestGroups: unnestGroups,
            triggerReloadGroups: triggerReloadGroups,
            triggerCloseSidenav: triggerCloseSidenav,
            massInsertUsersIntoGroups: massInsertUsersIntoGroups,
            removeUsersFromGroup: removeUsersFromGroup,
            getUsersGroupsTypes: getUsersGroupsTypes,
            getUsersInGroupStatus: getUsersInGroupStatus,
            getUsersAuditTrailByID: getUsersAuditTrailByID,
            getUsersAuditTrail: getUsersAuditTrail,
            getUserToken: getUserToken
        });

    }

})();

(function () {
  'use strict';

  angular.module('app.sitemap')
    .directive('qiuSitemapOnClick', ['sitemapService', openSitemap])
    .directive('qiuSitemapOnToggleClick', ['sitemapService', toggleNode])
    .directive('qiuSitemapOnToggleClick', ['$rootScope', toggleSitemapStatus])
    .controller('SitemapController', SitemapController);


  /** @ngInject */
  function SitemapController($scope, $mdMenu, $rootScope, $document, $mdDialog, $mdMedia, $mdToast, $mdSidenav, $sce,
    $state, msApi, requestContext, $timeout, $anchorScroll, $translate, sessionService, backendService, sitemapService, $filter,
    ivhTreeviewMgr, $window, dragulaService, $q, msUtils, site, settingUserService, contentService) {
    var vm = this;
    vm.site = site;
    vm.settingsSection = 'sitemap';
    vm.availableSidenavs = true;
    vm.collapsedSidenav = false;
    vm.deviceSelected = 'desktop';
    vm.tabSelected = 0;
    vm.previewDomain = sessionService.site_operative.previewDomain;
    $rootScope.isseosection = $state.params.isseosection;
    if ($state.params.isseosection) {
      $rootScope.global.titleToolbar = '<i class="icon s20 icon-sitemap mr-15" ng-if="node.icon"></i> ' + $translate.instant('SITEMAP');
    } else {
      $rootScope.global.titleToolbar = '<i class="icon s20 icon-sitemap mr-15" ng-if="node.icon"></i> ' + $translate.instant('SEO');
    }
    vm.islite = $state.params.islite;

    // ===== Editor visual de Share Card (tab SEO) =====
    // Escribe en los campos SEO Card Style / Card Color / Card Background (contrato con qiupreview).
    vm.cardPalette = ['#3b7cb7', '#0049f9', '#e4032e', '#0d0f14', '#16a34a', '#7b3fe4', '#f5a623'];

    function ogSeoField(title) {
      if (!vm.currentSitemap || !vm.currentSitemap.seo || !vm.currentSitemap.seo.fields) { return null; }
      var fs = vm.currentSitemap.seo.fields;
      for (var i = 0; i < fs.length; i++) { if (fs[i].title === title) { return fs[i]; } }
      return null;
    }
    vm.cardGet = function (title) { var f = ogSeoField(title); return f ? (f.value || '') : ''; };
    vm.cardSet = function (title, val) { var f = ogSeoField(title); if (f) { f.value = val; } };
    vm.cardStyle = function () { var s = vm.cardGet('Card Style'); return (s === 'fill' || s === 'image') ? s : 'glow'; };
    vm.cardColor = function () { var c = vm.cardGet('Card Color'); return /^#?[0-9a-fA-F]{6}$/.test(c) ? ('#' + c.replace('#', '')) : vm.cardPalette[0]; };
    vm.cardBg = function () { return vm.cardGet('Card Background'); };
    vm.cardLogo = function () { return vm.cardGet('Card Logo'); };
    vm.cardTitlePreview = function () { return vm.cardGet('Title') || (vm.currentSitemap && vm.currentSitemap.name) || ''; };
    vm.setCardStyle = function (s) { vm.cardSet('Card Style', s); };
    vm.setCardColor = function (c) { vm.cardSet('Card Color', c); };

    // ---- Biblioteca de disenos (section_share_card_designs): elegir uno por-pagina ----
    // El id del diseno elegido se guarda en el campo SEO 'Card Design'; qiupreview (SetSeo)
    // lo resuelve al publicar y lo hornea en la HTML estatica. Sin diseno elegido -> modo
    // "Personalizado" (campos manuales de abajo). Funciona en produccion estatica.
    vm.cardDesigns = [];
    vm.cardDesignId = function () { return vm.cardGet('Card Design'); };
    vm.selectedCardDesign = function () {
      var id = vm.cardDesignId();
      if (!id) { return null; }
      for (var i = 0; i < vm.cardDesigns.length; i++) {
        if ('' + vm.cardDesigns[i].id === '' + id) { return vm.cardDesigns[i]; }
      }
      return null;
    };
    vm.pickCardDesign = function (d) { vm.cardSet('Card Design', '' + d.id); };
    // "Personalizado": sin diseno de la biblioteca, pero CON config manual propia. Sembramos un
    // estilo por defecto para que sea un estado real y persistente; si no, al no quedar ningun
    // campo con valor, seria indistinguible de "Sin card" (ambos se veian como "sin card").
    vm.pickCardCustom = function () {
      vm.cardSet('Card Design', '');
      if (!vm.hasCardConfig()) { vm.cardSet('Card Style', 'glow'); }
    };

    // ---- "Sin card propia": devolver la pagina al comportamiento por defecto del domain ----
    // OJO: no basta con vaciar 'Card Design'. Si queda un 'Card Style'/'Card Color'/... suelto,
    // qiupreview lo interpreta como card manual (hasCardCfg) y la pagina sigue con card propia.
    // Por eso limpiamos TODOS los campos de card. Se usa cardGet (valor crudo), no cardStyle(),
    // que devuelve 'glow' por defecto aunque el campo este vacio.
    var CARD_FIELDS = ['Card Design', 'Card Style', 'Card Color', 'Card Background', 'Card Logo',
                       'Card Font', 'Card Show Logo', 'Card Show Title', 'Card Show Description',
                       'Card Use First Image'];
    // los mismos + el separador: no deben salir en la lista cruda de campos SEO (se editan arriba)
    var CARD_SEO_TITLES = ['SHARE CARD'].concat(CARD_FIELDS);
    vm.hasCardConfig = function () {
      for (var i = 0; i < CARD_FIELDS.length; i++) { if (vm.cardGet(CARD_FIELDS[i])) { return true; } }
      return false;
    };
    vm.clearCard = function () {
      for (var i = 0; i < CARD_FIELDS.length; i++) { vm.cardSet(CARD_FIELDS[i], ''); }
    };

    // ---- Adaptador para REUTILIZAR <share-card-editor> (el editor del modulo content) ----
    // La directiva trabaja sobre un objeto plano (record.style, record.logo, ...); aqui esos
    // valores viven en los campos SEO del sitemap. Con getters/setters exponemos los campos
    // como si fueran propiedades, asi hay UNA sola implementacion del editor en los dos sitios.
    vm.cardRecord = {};
    (function () {
      var map = {
        style: 'Card Style', color: 'Card Color', logo: 'Card Logo', background: 'Card Background',
        font: 'Card Font', show_logo: 'Card Show Logo', show_title: 'Card Show Title',
        show_description: 'Card Show Description', use_first_image: 'Card Use First Image'
      };
      angular.forEach(map, function (seoTitle, key) {
        Object.defineProperty(vm.cardRecord, key, {
          enumerable: true,
          get: function () { return vm.cardGet(seoTitle); },
          set: function (v) { vm.cardSet(seoTitle, v); }
        });
      });
    })();
    // titulo que se ve en el preview: el de la pagina (no hay "nombre de diseno" aqui)
    vm.cardPreviewTitle = function () { return vm.cardTitlePreview(); };

    // valores efectivos para el preview: diseno elegido -> sus campos; si no -> manuales
    vm.cardEffStyle = function () { var d = vm.selectedCardDesign(); return d ? d.style : vm.cardStyle(); };
    vm.cardEffColor = function () { var d = vm.selectedCardDesign(); return d ? d.color : vm.cardColor(); };
    vm.cardEffBg    = function () { var d = vm.selectedCardDesign(); return d ? d.background : vm.cardBg(); };
    vm.cardEffLogo  = function () { var d = vm.selectedCardDesign(); return d ? d.logo : vm.cardLogo(); };

    function loadCardDesigns() {
      var siteId = requestContext.getParam('siteId');
      if (!siteId || !contentService || !contentService.get) { return; }
      contentService.get({ siteID: siteId, section: 'share_card_designs', page: 1, resultsPerPage: 100 })
        .then(function (resp) {
          var rows = [];
          if (resp && resp.result && angular.isArray(resp.result.data)) { rows = resp.result.data; }
          else if (resp && angular.isArray(resp.data)) { rows = resp.data; }
          else if (angular.isArray(resp)) { rows = resp; }
          vm.cardDesigns = rows
            .filter(function (r) { var o = r.onoff; return o !== 0 && o !== '0' && o !== false; })   // activos (tolerante)
            .map(function (r) {
              return {
                id: r.id_share_card_designs || r.id,
                title: r.title || '—',
                style: (r.style === 'fill' || r.style === 'image') ? r.style : 'glow',
                color: /^#?[0-9a-fA-F]{6}$/.test(r.color || '') ? ('#' + ('' + r.color).replace('#', '')) : '#0049f9',
                logo: r.logo || '',
                background: r.background || '',
                sort: parseInt(r.sort, 10) || 0
              };
            })
            .sort(function (a, b) { return a.sort - b.sort || a.id - b.id; });
        }, function () { vm.cardDesigns = []; });
    }
    loadCardDesigns();

    // predicado para ocultar los campos de card del listado SEO crudo (los pinta el editor visual)
    vm.notCardField = function (field) {
      return CARD_SEO_TITLES.indexOf(field.title) === -1;
    };

    function ogHexRgb(h) { h = ('' + h).replace('#', ''); if (h.length === 3) { h = h.replace(/./g, '$&$&'); } return [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16)]; }
    function ogRgb(a) { return 'rgb(' + a[0] + ',' + a[1] + ',' + a[2] + ')'; }
    function ogMul(a, f) { return [Math.round(a[0] * f), Math.round(a[1] * f), Math.round(a[2] * f)]; }
    function ogLum(a) { var c = a.map(function (v) { v /= 255; return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); }); return 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2]; }

    vm.cardPreviewStyle = function () {
      var st = vm.cardEffStyle(), c = vm.cardEffColor(), r = ogHexRgb(c);
      if (st === 'image' && vm.cardEffBg()) {
        return { 'background-image': 'url("' + vm.cardEffBg() + '")', 'background-size': 'cover', 'background-position': 'center', 'color': '#fff' };
      }
      if (st === 'fill') {
        var tl = ogLum(r) < 0.42;
        return { 'background': 'linear-gradient(150deg,' + c + ',' + ogRgb(ogMul(r, 0.72)) + ')', 'color': tl ? '#fff' : '#0e1116' };
      }
      var top = ogRgb([Math.min(255, Math.round(20 + r[0] * 0.24)), Math.min(255, Math.round(24 + r[1] * 0.24)), Math.min(255, Math.round(32 + r[2] * 0.24))]);
      var bot = ogRgb([Math.round(r[0] * 0.06) + 6, Math.round(r[1] * 0.06) + 7, Math.round(r[2] * 0.06) + 11]);
      return { 'background': 'linear-gradient(180deg,' + top + ',' + bot + ')', 'color': '#fff' };
    };
    vm.cardGlowStyle = function () {
      var st = vm.cardEffStyle(), c = vm.cardEffColor();
      if (st === 'image') { return { 'background': 'transparent' }; }
      if (st === 'fill') { return { 'background': ogLum(ogHexRgb(c)) < 0.42 ? 'rgba(255,255,255,.2)' : 'rgba(0,0,0,.15)' }; }
      return { 'background': c };
    };
    vm.cardBarStyle = function () {
      var st = vm.cardEffStyle(), c = vm.cardEffColor();
      if (st === 'fill') { return { 'background': ogLum(ogHexRgb(c)) < 0.42 ? 'rgba(255,255,255,.85)' : 'rgba(0,0,0,.6)' }; }
      return { 'background': c };
    };
    vm.cardOverlayStyle = function () {
      return vm.cardEffStyle() === 'image'
        ? { 'background': 'linear-gradient(90deg,rgba(0,0,0,.72),rgba(0,0,0,.12) 60%,rgba(0,0,0,0))', 'opacity': 1 }
        : { 'opacity': 0 };
    };

    // Selección del fondo desde la media del tenant (MediaDialog). Si el picker no da la URL,
    // el campo "Card Background" sigue siendo editable a mano en el editor.
    vm.selectCardBackground = function (ev) {
      $mdDialog.show({
        controller: 'MediaDialogController', controllerAs: 'vm',
        locals: {
          autoUpload: '', currentThread: { Thumbnail: [] }, section: '', mediazone: false, isTiny: false, maxAttach: 1,
          showViews: { 1: true, 2: false, 3: false, 4: false, 5: false, upload: false, import: false }
        },
        templateUrl: 'app/main/dialogs/media/media-dialog.html',
        targetEvent: ev, clickOutsideToClose: true, multiple: true
      }).then(function (response) {
        var url = ogMediaUrl(response);
        if (url) { vm.cardSet('Card Background', url); vm.cardSet('Card Style', 'image'); }
      });
    };

    // Selección del logo de la card (media del tenant). Si no se elige, el servidor usa el logo del sitio.
    vm.selectCardLogo = function (ev) {
      $mdDialog.show({
        controller: 'MediaDialogController', controllerAs: 'vm',
        locals: {
          autoUpload: '', currentThread: { Thumbnail: [] }, section: '', mediazone: false, isTiny: false, maxAttach: 1,
          showViews: { 1: true, 2: false, 3: false, 4: false, 5: false, upload: false, import: false }
        },
        templateUrl: 'app/main/dialogs/media/media-dialog.html',
        targetEvent: ev, clickOutsideToClose: true, multiple: true
      }).then(function (response) {
        var url = ogMediaUrl(response);
        if (url) { vm.cardSet('Card Logo', url); }
      });
    };

    // extrae la URL de imagen de la media elegida (mismo patrón que qiu-field mapMediaProperties)
    function ogMediaUrl(response) {
      if (!response || !response.Thumbnail || !response.Thumbnail.length) { return ''; }
      var m = response.Thumbnail[0];
      if (m.imageUrlOriginal) { return m.imageUrlOriginal; }
      if (m.cdnContainer && m.id_media && m.filename) {
        var c = sessionService.getContainerByID(m.cdnContainer);
        if (c && c.view_url) { return c.view_url + 'original/m' + m.id_media + '_' + m.filename; }
      }
      return m.view_url || m.filename_abs || '';
    }

    vm.widgetsTemplates = [
      // {
      //     title: "Template 1",
      //     onoff: 1
      // },
      // {
      //     title: "Template 2",
      //     onoff: 1
      // }
    ];
    vm.widgets2 = [];
    vm.showByRow = true;
    vm.rowslayout =
      vm.onlyMenu = false;
    vm.changeView = changeView;
    vm.toggleMenuItems = toggleMenuItems;
    vm.togglePathItems = togglePathItems;
    vm.toggleHtmlItems = toggleHtmlItems;
    vm.toggleJsonItems = toggleJsonItems;
    vm.toggleExternalItems = toggleExternalItems;
    vm.toggleItemStatus = toggleItemStatus;
    vm.newSitemap = newSitemap;
    vm.openSitemap = openSitemap;
    vm.checkAll = checkAll;
    vm.getChecked = getChecked;
    vm.currentSitemap = null;
    vm.closeSitemap = closeSitemap;
    vm.onLoadedIframe = onLoadedIframe;
    vm.selectDevice = selectDevice;
    vm.updateSearch = updateSearch;
    vm.saveSitemap = saveSitemap;
    vm.ctrlScope = $scope;
    vm.deleteWidget = deleteWidget;
    vm.openMenu = openMenu;
    vm.changeLayout = changeLayout;
    vm.updateNoLayout = updateNoLayout;
    vm.cleanValues = cleanValues;
    vm.editParentDialog = editParentDialog;
    vm.showSearchToggle = showSearchToggle;
    vm.basicForm = {};
    vm.seoForm = {};
    vm.init = init;
    vm.searchQuery = '';
    vm.typesSitemap = ['static', 'dynamic', 'external', 'redirect', 'header/footer'];
    vm.dynamicStructures = [
      {
        value: 1,
        structure: 'Normal (ID+Slug)'
      },
      {
        value: 2,
        structure: '/LANG/URL/%slugs'
      },
      {
        value: 3,
        structure: '/LANG/URL/%url1/%slugs'
      },
      {
        value: 4,
        structure: '/LANG/URL/%url1/%url2/%slugs'
      },
      {
        value: 5,
        structure: '/LANG/URL/%url1/%url2/%url3/%slugs'
      },
    ]
    vm.translate = function (text) {
      return $translate.instant(text);
    };
    vm.nolayout = false;
    vm.editMode = true;
    vm.msScrollOptions = {
      suppressScrollX: true
    };
    vm.addRowLayout = addRowLayout;
    vm.editWidgetDialog = editWidgetDialog;
    vm.duplicateWidget = duplicateWidget;
    vm.saveWidgetAsTemplate = saveWidgetAsTemplate;
    vm.deleteWidgetTemplate = deleteWidgetTemplate;
    vm.toggleSidenav = toggleSidenav;
    vm.closeSidenav = closeSidenav;
    vm.showSidenav = showSidenav;
    vm.deleteSitemap = deleteSitemap;
    vm.duplicateSitemap = duplicateSitemap;
    vm.duplicateSitemapWindow = duplicateSitemapWindow;
    vm.migrateAllOldWidgets = migrateAllOldWidgets;
    vm.getSubDomains = getSubDomains;
    vm.copySitemapWindow = copySitemapWindow;

    vm.showDeleteButton = showDeleteButton;
    vm.massActions = massActions;
    vm.confirmAction = confirmAction;

    vm.saveWidgetsAssocs = saveWidgetsAssocs;
    vm.closeWidgetsAssocs = closeWidgetsAssocs;

    vm.showQiuGroupsSidenav = false;
    vm.newSitemapTitle = false;
    vm.selectedGroup = false;
    vm.isOpenSidenavGroups = true;
    vm.getSitemaps = getSitemaps;

    vm.sortGroupsField = 'name';
    vm.sortGroupsDir = 'ASC';
    vm.sortGroupsBy = {
      "USERS.NAME": "name",
      "USERS.UPDATED_AT": "updated_at",
      "USERS.ID": "id_group",
      "USERS.SORT": "sort"
    };
    vm.toggleQiuGroupsSidenav = toggleQiuGroupsSidenav;
    vm.createSitemapGroup = createSitemapGroup;
    vm.editSitemapGroup = editSitemapGroup;
    vm.deleteSitemapGroup = deleteSitemapGroup;
    vm.sortSitemapGroups = sortSitemapGroups;
    vm.massInsertIntoGroups = massInsertIntoGroups;
    vm.removeFromGroup = removeFromGroup;
    vm.showAddToGroupsButton = showAddToGroupsButton;
    vm.showRemoveFromGroupsButton = showRemoveFromGroupsButton;
    vm.changeURL = changeURL;

    vm.editSitemapLayout = editSitemapLayout;

    vm.getSitemapsSubdomain = getSitemapsSubdomain;

    function getSitemapsSubdomain(subdomainId) {
      settingUserService.setSetting(vm.settingsSection, 'subdomainFilter', subdomainId);
      if (subdomainId) {
        getSitemaps('', subdomainId);
      } else {
        getSitemaps('', '', true);
      }
    }

    function editSitemapLayout(ev, layouts, index) {
      let layout = layouts[index];
      $mdDialog.show({
        controller: 'editLayoutDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/apps/sitemap/dialogs/edit-layout.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        escapeToClose: false,
        locals: {
          site: $scope.siteID,
          layout: layout
        }
      }).then(function (copyLayout) {
        if (copyLayout) {
          vm.currentSitemap.sitemap_data[index] = copyLayout;
        }
      });
    }

    /**
     * Toggle sidenav
     */
    function toggleQiuGroupsSidenav() {
      vm.showQiuGroupsSidenav = !vm.showQiuGroupsSidenav;
    }

    function changeURL() {
      const validExternalUrl = vm.currentSitemap.external_url && vm.currentSitemap.external_url.indexOf('http') === 0;
      if (validExternalUrl) {
        vm.sitemapUrl = $sce.trustAsResourceUrl(vm.currentSitemap.external_url);
      } else if (vm.currentSitemap.id_template != 0 && vm.currentSitemap.id_template != null) {
        var newPreviewDomain = vm.subDomains.find(x => x.id_template == vm.currentSitemap.id_template)?.template_name + ".qiupreview.com";
        vm.sitemapUrl = vm.currentSitemap.lang ? $sce.trustAsResourceUrl(`//${newPreviewDomain}/${vm.sitemaps.find(x => x.id_lang === vm.currentSitemap.lang).lang_name.toLowerCase()}/${vm.currentSitemap.url}`) : $sce.trustAsResourceUrl(`https://${newPreviewDomain}/${vm.currentSitemap.url}`);
      } else {
        vm.sitemapUrl = vm.currentSitemap.lang ? $sce.trustAsResourceUrl(`//${vm.previewDomain}/${vm.sitemaps.find(x => x.id_lang === vm.currentSitemap.lang).lang_name.toLowerCase()}/${vm.currentSitemap.url}`) : $sce.trustAsResourceUrl(`https://${vm.previewDomain}/${vm.currentSitemap.url}`);
      }
      if (vm.currentSitemap.extension && !validExternalUrl) {
        vm.sitemapUrl = $sce.trustAsResourceUrl(vm.sitemapUrl + `.${vm.currentSitemap.extension}`);
      }
    }

    function getSitemaps(groupIds, idTemplate) {
      $rootScope.pagination_groupIds = groupIds;
      $scope.isLoading = true;
      var options = {
        siteID: $scope.siteID,
        sortDir: $rootScope.sortDir,
        sortField: $rootScope.sortField,
        page: 1,
        resultsPerPage: $rootScope.perPage,
        searchStringFilter: '',
        groupIds: groupIds
      };
      if (idTemplate) {
        options.id_template = idTemplate;
        vm.subdomainFilter = idTemplate;
        $rootScope.subdomainFilter = idTemplate;
      } else {
        options.without_template = true;
      }
      sitemapService.get(options).then(function (response) {
        vm.sitemaps = response.data;
        $rootScope.pagination_totalItems = response.total;
        $rootScope.pagination_total_pages = response.last_page;
        if ($rootScope.pagination_page !== response.current_page) {
          $rootScope.pagination_page = response.current_page;
        }
        vm.selectedThreads = [];
        $scope.isLoading = false;

        var savedOpenedSitemapId = settingUserService.getSettingValue(vm.settingsSection, 'openedSitemapId', null);
        if (savedOpenedSitemapId) {
          loadSitemap(savedOpenedSitemapId);
          expandToNode(savedOpenedSitemapId);
        }
      });
    }

    function createSitemapGroup(groupName, parentGroupId) {
      var options = {
        siteID: $scope.siteID,
        groupName: groupName,
        parentGroupId: parentGroupId
      };
      sitemapService.createSitemapGroup(options).then(function (response) {
        getSitemapGroups();
      });
    }

    function editSitemapGroup(group, groupName, parentGroupId) {
      var options = {
        siteID: $scope.siteID,
        groupId: group.id_group,
        groupName: groupName,
        parentGroupId: parentGroupId
      };
      sitemapService.editSitemapGroup(options).then(function (response) {
        getSitemapGroups();
      });
    }

    function deleteSitemapGroup(group) {
      var options = {
        siteID: $scope.siteID,
        groupId: group.id_group
      };
      sitemapService.deleteSitemapGroup(options).then(function (response) {
        getSitemapGroups();
      });
    }

    function massInsertIntoGroups(itemIds, groups) {
      const items = getChecked();
      itemIds = items.map(x => {
        return x.id_sitemap;
      });

      var options = {
        siteID: $scope.siteID,
        data: {
          id_sitemap: itemIds,
          groups: groups
        }
      };
      sitemapService.massInsertIntoGroups(options)
        .then(function (response) {
          vm.reload = true;
          var message = itemIds.length + ' ' + $translate.instant('SITEMAP.ADDTOGROUPS_PLURAL');
          if (itemIds.length === 1) {
            message = $translate.instant('SITEMAP.ADDTOGROUPS_SINGULAR');
          }
          vm.loading = false;
          $mdToast.show({
            template: '<md-toast id="language-message"><span class="md-toast-text" flex>' + message + '</span><md-button ng-click="closeToast()">X</md-button></md-toast>',
            hideDelay: 7000,
            position: 'top right',
            parent: '#main'
          });
        });
    }

    function removeFromGroup(idGroup, itemIds) {
      const items = getChecked();
      itemIds = items.map(x => {
        return x.id_sitemap;
      });
      var options = {
        siteID: $scope.siteID,
        ids: itemIds,
        id_group: idGroup
      };
      sitemapService.removeFromGroup(options)
        .then(function (response) {
          vm.loading = false;
          var message = itemIds.length + ' ' + $translate.instant('SITEMAP.REMOVEFROMGROUP_PLURAL');
          if (itemIds.length === 1) {
            message = $translate.instant('SITEMAP.REMOVEFROMGROUP_SINGULAR');
          }
          $mdToast.show({
            template: '<md-toast id="language-message"><span class="md-toast-text" flex>' + message + '</span><md-button ng-click="closeToast()">X</md-button></md-toast>',
            hideDelay: 7000,
            position: 'top right',
            parent: '#main'
          });
          vm.selectedThreads = [];
          $rootScope.pagination_resetquery();
        });
    }

    vm.langs = Object.values(sessionService.getSiteLanguages()).map(x => {
      return {
        id: x.id_lang,
        name: x.lang_name
      };
    });

    vm.subsections = [];
    vm.categories = [];
    vm.subcategories = [];

    var sectionReferencesCache = {};

    vm.loadSectionReferences = function () {
      if (!vm.currentSitemap || !vm.currentSitemap.id_section || !vm.sections) {
        vm.subsections = [];
        vm.categories = [];
        vm.subcategories = [];
        return;
      }
      
      var selectedIds = [];
      if (Array.isArray(vm.currentSitemap.id_section)) {
        selectedIds = vm.currentSitemap.id_section;
      } else if (typeof vm.currentSitemap.id_section === 'string') {
        selectedIds = vm.currentSitemap.id_section.split(',').map(x => x.trim()).filter(Boolean);
      } else if (vm.currentSitemap.id_section) {
        selectedIds = [String(vm.currentSitemap.id_section)];
      }

      if (selectedIds.length === 0) {
        vm.subsections = [];
        vm.categories = [];
        vm.subcategories = [];
        return;
      }

      var promises = [];
      selectedIds.forEach(function (id) {
        var section = vm.sections.find(x => x.id == id);
        if (section) {
          var p;
          if (sectionReferencesCache[section.name]) {
            p = $q.resolve(sectionReferencesCache[section.name]);
          } else {
            p = contentService.get({
              siteID: $scope.siteID,
              section: section.name,
              resultsPerPage: 1
            }).then(function (response) {
              var refs = response.reference_sections || {};
              sectionReferencesCache[section.name] = refs;
              return refs;
            }).catch(function () {
              return {};
            });
          }
          promises.push(p);
        }
      });

      if (promises.length === 0) {
        vm.subsections = [];
        vm.categories = [];
        vm.subcategories = [];
        return;
      }

      $q.all(promises).then(function (results) {
        var mergedSubsections = [];
        var mergedCategories = [];
        var mergedSubcategories = [];

        results.forEach(function (ref) {
          if (ref.subsection) {
            mergedSubsections = mergedSubsections.concat(ref.subsection);
          }
          if (ref.cat) {
            mergedCategories = mergedCategories.concat(ref.cat);
          }
          if (ref.subcat) {
            mergedSubcategories = mergedSubcategories.concat(ref.subcat);
          }
        });

        vm.subsections = mergedSubsections.filter((item, index, self) =>
          self.findIndex(t => t.id_subsec === item.id_subsec) === index
        );
        vm.categories = mergedCategories.filter((item, index, self) =>
          self.findIndex(t => t.id_cat === item.id_cat) === index
        );
        vm.subcategories = mergedSubcategories.filter((item, index, self) =>
          self.findIndex(t => t.id_subcat === item.id_subcat) === index
        );
      });
    };

    function parseSitemapSection(sitemap) {
      if (!sitemap) return;
      if (sitemap.id_section) {
        if (typeof sitemap.id_section === 'string') {
          sitemap.id_section = sitemap.id_section.split(',').map(x => x.trim()).filter(Boolean);
        } else if (typeof sitemap.id_section === 'number') {
          sitemap.id_section = [String(sitemap.id_section)];
        }
      } else {
        sitemap.id_section = [];
      }

      if (sitemap.id_subsec) {
        if (typeof sitemap.id_subsec === 'string') {
          sitemap.id_subsec = sitemap.id_subsec.split(',').map(x => x.trim()).filter(Boolean);
        } else if (typeof sitemap.id_subsec === 'number') {
          sitemap.id_subsec = [String(sitemap.id_subsec)];
        }
      } else {
        sitemap.id_subsec = [];
      }
    }

    $scope.groups = [
      {
        name: 'Group A',
        items: [{ name: 'Item A', list: [1] }, { name: 'Item B', list: [] }, { name: 'Item C', list: [] }, {
          name: 'Item D',
          list: []
        }]
      },
      {
        name: 'Group B',
        items: [{ name: 'Item 1', list: [] }, { name: 'Item 2', list: [3, 4] }, { name: 'Item 3', list: [] }, {
          name: 'Item 4',
          list: []
        }]
      }
    ];

    dragulaService.options($scope, 'nested-bag', {
      direction: 'vertical',
      moves: function (el, source, handle, sibling) {
        return handle.classList.contains('dragX');
      }
    });
    dragulaService.options($scope, 'subnested-bag', {
      direction: 'vertical',
      moves: function (el, source, handle, sibling) {
        return handle.classList.contains('dragY');
      }
    });
    //////////

    init();

    function init() {

      getSubDomains();

      vm.views = {
        nosplit: 'app/main/apps/sitemap/views/list/nosplit-view.html',
        split: 'app/main/apps/sitemap/views/list/split-view.html'
      };
      vm.defaultView = 'split';
      vm.currentView = 'split';
      vm.loadingView = true;

      //vm.getCountriesWithStates();

      var siteID = requestContext.getParam("siteId");
      // var section = requestContext.getParam("section");

      var section = 'users';

      $scope.siteID = siteID;
      $scope.section = section;
      var options = {
        site: $scope.siteID,
        lang: 1,
      };
      sitemapService.getOptions(options).then(function (response) {
        response.layouts = _.uniq(response.layouts, (e) => e.id_layout);
        response.headers = _.uniq(response.headers, (e) => e.id_header);
        response.footers = _.uniq(response.footers, (e) => e.id_footer);
        response.widgets = response.widgets.map(createChildren);
        vm.widgets = $filter('orderBy')(response.widgets, 'title');
        vm.v2Widgets = angular.copy(vm.widgets);
        vm.widgetsCopy = $filter('orderBy')(response.widgets, 'title');
        vm.currentOptions = response;
      });
      getWidgetTemplates();
      if (vm.islite) {
        getSitemapGroups();
      }

      backendService.getSections({
        siteID: $scope.siteID
      }).then(function (response) {
        vm.sections = response.data.map(x => {
          return (
            {
              id: x.id_section,
              name: x.section
            }
          );
        });
        console.log('vm.sections', vm.sections);
        vm.loadSectionReferences();
      });
    }

    function getWidgetTemplates() {
      sitemapService.getTemplateWidgets({ domain: $scope.siteID }).then(function (response) {
        response.data = response.data.map(createChildren);
        vm.widgetsTemplates = $filter('orderBy')(response.data, 'title');
      });
    }

    vm.sitemapsSelected = [];
    function confirmAction(action) {
      switch (action) {
        case 'delete':
          var messageConfirm = $translate.instant('CONTENT.SURE_DELETED_SINGULAR');

          var confirm = $mdDialog.confirm().title(messageConfirm).htmlContent('<b>This item will be deleted</b>.')
            // .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' will be deleted.')
            .ariaLabel('Delete item').targetEvent(event).ok('OK').cancel('CANCEL');
          $mdDialog.show(confirm).then(function () {
            $scope.isLoading = true;
            vm.deleteSitemap(vm.currentSitemap.id_sitemap);
          });
          break;

        default:
          break;
      }

    }

    function massActions(action, ev) {
      const selected = getChecked();
      var messageConfirm = '';
      var confirm = '';
      switch (action) {
        case 'delete':
          if (selected.length === 1) {
            messageConfirm = $translate.instant('CONTENT.SURE_DELETED_SINGULAR');
            confirm = $mdDialog.confirm().title(messageConfirm).htmlContent('<b>This item will be deleted</b>.')
              // .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' will be deleted.')
              .ariaLabel('Delete item').targetEvent(event).ok('OK').cancel('CANCEL');
          } else {
            messageConfirm = $translate.instant('CONTENT.SURE_DELETED_PLURAL');
            confirm = $mdDialog.confirm().title(messageConfirm).htmlContent('<b>This items will be deleted</b>.')
              // .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' will be deleted.')
              .ariaLabel('Delete item').targetEvent(event).ok('OK').cancel('CANCEL');
          }
          break;

      }


      $mdDialog.show(confirm).then(function () {
        switch (action) {
          case 'delete':
            vm.deleteSitemap(selected.map(x => x.id_sitemap));
            break;

          default:
            break;
        }
      });
    }

    function showDeleteButton() {
      const checked = getChecked();
      return checked.length > 0;
    }

    function showAddToGroupsButton() {
      const checked = getChecked();
      return checked.length > 0;
    }

    function showRemoveFromGroupsButton() {
      const checked = getChecked();
      return checked.length > 0;
    }

    function getChecked() {
      let checked = [];
      for (let i = 0; i < vm.sitemaps.length; i++) {
        const element = vm.sitemaps[i];
        if (element.checked && element.id_sitemap) {
          checked.push(element);
        }
        checked = checked.concat(getCheckedItems(element));
      }
      checked = checked.filter(function (item, index) {
        return checked.findIndex(x => x.id_sitemap === item.id_sitemap) === index;
      });
      return checked;
    }

    function getCheckedItems(element) {
      let found = element.children ? element.children.filter(x => x.checked) : [];
      let checked = found ? found : [];
      if (element.children) {
        for (let j = 0; j < element.children.length; j++) {
          const child = element.children[j];
          if (child.checked && child.id_sitemap) {
            checked.push(child);
          }
          checked = checked.concat(getCheckedItems(child));
        }
      }
      return checked;
    }

    function createChildren(x) {
      if (!x.children) {
        x.children = [];
      } else {
        for (let i = 0; i < x.children.length; i++) {
          createChildren(x.children[i]);
        }
      }
      return x;
    }

    function updateSearch(query) {
      if (query) {
        vm.widgets = vm.widgetsCopy.filter(x => {
          var a = x.title.toLowerCase();
          var b = query.toLowerCase();
          return a.indexOf(b) >= 0;
        });
      } else {
        vm.widgets = angular.copy(vm.widgetsCopy);
      }

    }

    function initDragula() {
      initZoneDragulaOptions();
      initWidgetDragulaOptions();
    }

    function updateNoLayout() {
      if (vm.nolayout) {
        var confirm = $mdDialog.confirm().title($translate.instant('SITEMAP.WARNING_LAYOUT')).htmlContent($translate.instant('SITEMAP.WARNING_LAYOUT_2'))
          .ok('OK').cancel($translate.instant('SITEMAP.CANCEL'));
        $mdDialog.show(confirm).then(function () {
          var currentSitemapWidgets = [];
          for (var i = 0; i < vm.currentSitemap.sitemap_data.length; i++) {
            var sitemapZone = vm.currentSitemap.sitemap_data[i].zones;
            for (var j = 0; j < sitemapZone.length; j++) {
              var zoneWidgets = sitemapZone[j].widgets;
              for (var k = 0; k < zoneWidgets.length; k++) {
                currentSitemapWidgets.push(zoneWidgets[k]);
              }
            }
          }
          vm.currentSitemap.disable_layout = 1;
          vm.currentSitemap.sitemap_data = [{
            class: "",
            type_layout: "ajax-content",
            zones: [{ "is_hidden": false, widgets: currentSitemapWidgets }]
          }];
        });
      } else {
        vm.currentSitemap.disable_layout = 0;
      }
    }

    function changeLayout() {
      var confirm = $mdDialog.confirm().title($translate.instant('SITEMAP.WARNING_LAYOUT')).htmlContent($translate.instant('SITEMAP.WARNING_LAYOUT_2'))
        .ok('OK').cancel($translate.instant('SITEMAP.CANCEL'));
      $mdDialog.show(confirm).then(function () {
        vm.currentSitemap.id_layout = vm.layoutSelected;
        const selectedLayout = vm.currentOptions.layouts.find(x => x.id_layout === vm.layoutSelected);
        vm.currentSitemap.sitemap_data = [];
        if (selectedLayout && selectedLayout.structure_json) {
          for (let i = 0; i < selectedLayout.structure_json.length; i++) {
            const structure_json = selectedLayout.structure_json[i];
            vm.currentSitemap.sitemap_data.push({
              class: structure_json.class,
              type_layout: structure_json.type_layout,
              zones: []
            });
            for (let j = 0; j < selectedLayout.structure_json[0].total_zones; j++) {
              vm.currentSitemap.sitemap_data[i].zones.push({ "is_hidden": false, widgets: [] });
            }
          }
        }
      }, function () {
        vm.layoutSelected = vm.currentSitemap.id_layout;
      });
    }

    function cleanValues() {
      // delete vm.currentSitemap.url;
      delete vm.currentSitemap.extension;
      delete vm.currentSitemap.external_url;
      delete vm.currentSitemap.sub_item;
    }

    function initZoneDragulaOptions() {
      if (!dragulaService.find($scope, 'zone')) {
        dragulaService.options($scope, 'zone', {
          copy: false,
          copySortSource: false,
          removeOnSpill: false,
          direction: 'vertical',
          moves: function (el, source, handle, sibling) {
            var result = handle.classList.contains('dragZ');
            return result;
          }
        });
        $scope.$on('zone.drop', (e, el) => {
          updateWidgetContainers();
          // updateContainers();
        });
      }
    }

    function initWidgetDragulaOptions() {
      // Guard against re-registration: newSitemap()/initDragula() can run more
      // than once per scope, and dragula throws "Bag named 'widget' already
      // exists" if the bag is registered twice. Mirrors initZoneDragulaOptions().
      if (dragulaService.find($scope, 'widget')) {
        return;
      }
      dragulaService.options($scope, 'widget', {
        copySortSource: false,
        removeOnSpill: false,
        direction: 'vertical',
        moves: function (el, source, handle, sibling) {
          // Only drag if the handle has the 'drag' class
          if (!handle.classList.contains('drag')) return false;

          // With deepest-first container registration, el.parentElement === source is enough
          // to ensure we pick the most specific container.
          return el.parentElement === source;
        },
        accepts: function (el, target, source, sibling) {
          // Prevent dropping a widget into one of its own descendant containers
          // This fixes HierarchyRequestError: The new child element contains the parent.
          if (el.contains(target)) {
            return false;
          }
          // Prevent dropping items back to the sidebar
          return !target.classList.contains('copy-widgets');
        },
        copy: function (el, source) {
          var result = source.classList.contains('copy-widgets');
          return result;
        }
      });

      $scope.$on('widget.cloned', function (e, clone, original, type) {
        if (type === 'mirror') {
          var cloneEl = clone[0] || clone; // Handle both jQuery/jqLite and native elements
          // Physically remove the children from the mirror element to ensure a compact view
          var children = cloneEl.querySelector('.widget-item-children');
          if (children) {
            children.remove();
          }
          // Also hide extra UI elements in the mirror
          var extraElements = cloneEl.querySelectorAll('.tools, .sub-dot, .drag');
          for (var i = 0; i < extraElements.length; i++) {
            extraElements[i].remove();
          }

          // Force styles to ensure it looks like a single card
          cloneEl.style.maxWidth = '350px';
          cloneEl.style.height = 'auto';
          cloneEl.style.background = '#ffffff';
          cloneEl.style.border = '2px solid #448AFF';
          cloneEl.style.boxShadow = '0 10px 30px rgba(0,0,0,0.3)';
          cloneEl.style.borderRadius = '8px';
          cloneEl.style.padding = '10px';
        }
      });
      if (!vm.interval) {
        vm.interval = setInterval(() => {
          updateWidgetContainers();
        }, 1000);
      }
      $scope.$on('widget.drop', (e, el) => {
        $timeout(() => {
          updateWidgetContainers();
        }, 100);
      });
    }

    vm.initArray = initArray;

    function updateWidgetContainers() {
      if (!dragulaService.find($scope, 'widget')) {
        return;
      }
      var drake = dragulaService.find($scope, 'widget').drake;
      if (drake.dragging) {
        return;
      }

      var containers = [];
      var resultModels = [];

      // Add Sidebar Containers
      var copyWidgets = document.querySelector('.copy-widgets');
      if (copyWidgets) {
        containers.push(copyWidgets);
        if (!vm.widgets) vm.widgets = [];
        resultModels.push(vm.widgets);
      }

      var templateWidgets = document.querySelector('.template-widgets');
      if (templateWidgets) {
        containers.push(templateWidgets);
        if (!vm.widgetsTemplates) vm.widgetsTemplates = [];
        resultModels.push(vm.widgetsTemplates);
      }


      function traverseWidgets(widgets) {
        if (!widgets) return;
        widgets.forEach(function (widget) {
          // RECURSE FIRST to ensure Child-First (deepest-first) order
          if (widget.children && widget.children.length > 0) {
            traverseWidgets(widget.children);
          }
          if (widget.$$hashKey) {
            var container = document.getElementById('children-' + widget.$$hashKey);
            if (container && containers.indexOf(container) === -1) {
              containers.push(container);
              if (!widget.children) widget.children = [];
              resultModels.push(widget.children);
            }
          }
        });
      }

      // Add Main Layout Containers (Children FIRST for correct nested detection)
      if (vm.currentSitemap && vm.currentSitemap.sitemap_data) {
        vm.currentSitemap.sitemap_data.forEach(function (row, rowIndex) {
          if (row.zones && Array.isArray(row.zones)) {
            row.zones.forEach(function (zone, zoneIndex) {
              if (zone.widgets) {
                traverseWidgets(zone.widgets);
              }
              var zoneEl = document.getElementById('zone-' + rowIndex + '-' + zoneIndex);
              if (zoneEl && containers.indexOf(zoneEl) === -1) {
                containers.push(zoneEl);
                if (!zone.widgets) zone.widgets = [];
                resultModels.push(zone.widgets);
              }
            });
          }
        });
      }

      drake.containers = containers;
      drake.models = resultModels;
    }

    function initArray(array) {
      // Note: this function is called from the template with 'widgets' as argument.
      // In SitemapController, widgets are usually initialized in adaptive methods, 
      // but we ensure it's at least an empty array if undefined.
      if (!array) {
        array = [];
      }
    }

    var originatorEv;

    function openMenu($mdMenu, ev) {
      originatorEv = ev;
      $mdMenu.open(ev);
    }

    function toggleItemStatus(item) {
      item.onoff = (item.onoff === 1) ? 0 : 1;
    }

    function toggleMenuItems() {
      vm.onlyPath = false;
      vm.onlyMenu = !vm.onlyMenu;
      var options = {
        page: 1,
        resultsPerPage: 50,
        //siteID: "staging_qiu_demo_account",
        siteID: $scope.siteID,
      };
      if (vm.onlyMenu) {
        options.sortBy = "menu";
      }
      if (vm.selectedGroup) {
        options.groupIds = [vm.selectedGroup.id_group];
      }
      $scope.isLoading = true;
      sitemapService.get(options).then(res => {
        vm.sitemaps = res.data;
        $scope.isLoading = false;
      });
    }

    function togglePathItems() {
      vm.onlyMenu = false;
      vm.onlyPath = !vm.onlyPath;
      var options = {
        page: 1,
        resultsPerPage: 50,
        //siteID: "staging_qiu_demo_account",
        siteID: $scope.siteID,
      };
      if (vm.onlyPath) {
        options.sortBy = "path";
      }
      if (vm.selectedGroup) {
        options.groupIds = [vm.selectedGroup.id_group];
      }
      $scope.isLoading = true;
      sitemapService.get(options).then(res => {
        vm.sitemaps = res.data;
        $scope.isLoading = false;
      });
    }

    function toggleHtmlItems() {
      vm.onlyHtml = !vm.onlyHtml;
      if (vm.onlyHtml) {
        vm.onlyJson = false;
        vm.onlyExtenal = false;
      }
    }

    function toggleJsonItems() {
      vm.onlyJson = !vm.onlyJson;
      if (vm.onlyJson) {
        vm.onlyHtml = false;
        vm.onlyExtenal = false;
      }
    }
    function toggleExternalItems() {
      vm.onlyExtenal = !vm.onlyExtenal;
      if (vm.onlyExtenal) {
        vm.onlyHtml = false;
        vm.onlyJson = false;
      }
    }

    $scope.filterItems = function (node) {
      var result = true;
      if (vm.searchQuery !== '') {
        if (node.label && typeof node.label == 'string') {
          result = node.label.toLowerCase().indexOf(vm.searchQuery.toLowerCase()) >= 0;
        }
        if (node.url && typeof node.url == 'string' && !result) {
          result = node.url.toLowerCase().indexOf(vm.searchQuery.toLowerCase()) >= 0;
        }
      }
      // if(vm.subdomainFilter){
      //   if(!node.id_template || node.id_template != vm.subdomainFilter){
      //     result = false;
      //   }
      // }
      if (result && node.extension !== 'json' && vm.onlyJson) {
        result = false;
      }
      if (result && node.extension !== 'html' && vm.onlyHtml) {
        result = false;
      }
      return result;
    };

    // Watch screen size to change view modes
    $scope.$watch(function () {
      return $mdMedia('lt-sm');
    }, function (current, old) {
      if (angular.equals(current, old)) {
        return;
      }

      if (current) {
        vm.currentView = 'nosplit';
      }
    });

    $scope.$watch(function () {
      return $mdMedia('max-width: 960px');
    }, function (big) {

      if (big) {
        $scope.$on('widget.drag', function (event, el, target, source, sibling) {
          vm.closeSidenav('widgets-sidenav');
        });
      }
      $scope.$on('zone.drag', function (event, el, target, source, sibling) {
        vm.closeSidenav('layout-sidenav');
      });
      vm.currentView = 'nosplit';

    });

    $scope.$watch(function () {
      return $mdMedia('min-width: 960px');
    }, function (small) {

      if (small) {
        vm.currentView = 'split';
      }

    });

    $scope.$watch(function () {
      return $mdMedia('gt-sm');
    }, function (current, old) {
      if (angular.equals(current, old)) {
        return;
      }

      if (current) {
        if (vm.defaultView === 'split') {
          vm.currentView = 'split';
        }
      }
    });


    $scope.$on('pagination:loadStart', function (event) {
      $scope.isLoading = true;
    });

    $scope.$on('pagination:loadPage', function (event) {
      $scope.isLoading = false;
    });


    $scope.$on('loadSitemap', function (event, id) {
      closeSitemap();
      loadSitemap(id);
    });

    $scope.$on('toggleChecked', function (event, id, rowid) {
      const lang = vm.sitemaps.find(x => x.id_lang === id);
      if (!lang) {
        const lang = vm.sitemaps.find(x => x.id_sitemap === id);
      }
      const value = !lang.children.find(x => x.checked);
      lang.checked = value;
      lang.children = lang.children.map(x => {
        x.checked = value;
        if (x.children) {
          checkChildrens(x, value);
        }
        return x;
      });
    });

    function checkChildrens(sitemap, value) {
      sitemap.children = sitemap.children.map(x => {
        x.checked = value;
        if (x.children) {
          checkChildrens(x, value);
        }
        return x;
      })
    }

    $scope.$on('toggleStatus', function (event, sitemap) {
      sitemap.onoff = (sitemap.onoff === 1) ? 0 : 1;
      var confirm = $mdDialog.confirm().title('Are you sure want to turn off/on this sitemap?').htmlContent('<b>This item will be changed </b>.')
        // .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' will be deleted.')
        .ariaLabel('change item').ok('OK').cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        vm.saveSitemap(sitemap);
      });

    });

    function loadSitemap(id) {
      settingUserService.setSetting(vm.settingsSection, 'openedSitemapId', id);
      var options = {};
      $scope.isLoadingReadPane = true;
      $timeout();
      if (vm.islite) {
        options = {
          site: $scope.siteID,
          id: id
        };
        sitemapService.getSitemapByID(options).then(function (response) {
          parseSitemapSection(response.sitemap);
          vm.currentSitemap = response.sitemap;
          vm.loadSectionReferences();
          options = {
            site: $scope.siteID,
            domain: $scope.siteID,
            id_sitemap: id,
            withWidget: true,
            sortField: 'sort',
            sortDir: 'Asc'
          };
          sitemapService.getWidgetsAssocsNested(options).then(function (response) {
            chargeWidgets(response);
          });
        });
      } else {
        options = {
          site: $scope.siteID,
          id: id
        };
        sitemapService.getSitemapByID(options).then(function (response) {
          var sitemapZones = response.sitemap.sitemap_data;
          chargeSitemap(response.sitemap);
        });
      }
    }

    function expandToNode(id) {
      if (!vm.sitemaps) return;
      var node = findNodeById(vm.sitemaps, id);
      if (node) {
        ivhTreeviewMgr.expandTo(vm.sitemaps, node);
      }
    }

    function findNodeById(nodes, id) {
      for (var i = 0; i < nodes.length; i++) {
        if (nodes[i].id_sitemap == id) return nodes[i];
        if (nodes[i].children) {
          var found = findNodeById(nodes[i].children, id);
          if (found) return found;
        }
      }
      return null;
    }

    function saveWidgetsAssocs(widgetsAssocs) {
      updateWidgetsAssocs(widgetsAssocs);
    }

    function updateWidgetsAssocs(widgetsAssocs) {
      $scope.isLoadingReadPane = true;
      var promiseQueue = [];
      angular.forEach(widgetsAssocs, function (assocs, zoneId) {
        var parentId = null;
        for (let i = 0; i < assocs.length; i++) {
          parentId = null;
          assocs[i].sort = i + 1;
          assocs[i].id_parent = parentId;
          assocs[i].id_zone = parseInt(zoneId);
          promiseQueue.push(updateWidgetsAssoc(assocs[i]));
          if (assocs[i].children && assocs[i].children.length > 0) {
            parentId = assocs[i].id_assoc;
            for (let k = 0; k < assocs[i].children.length; k++) {
              assocs[i].children[k].sort = k + 1;
              assocs[i].children[k].id_parent = parentId;
              assocs[i].children[k].id_zone = parseInt(zoneId);
              promiseQueue.push(updateWidgetsAssoc(assocs[i].children[k]));
            }
          }
        }
      });
      $q.all(promiseQueue).then(function (responses) {

        var message = $translate.instant('SITEMAP.SAVE_SUCCESS');
        $mdToast.show({
          template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
          hideDelay: 3000,
          position: 'top right',
          parent: '#main'
        });
        $scope.isLoadingReadPane = false;
      }, function (err) {
        var message = $translate.instant('GLOBAL.ERROR') + '<br>' + err.data.detail;
        $mdToast.show({
          template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
          hideDelay: 5000,
          position: 'top',
          parent: '#content-container'
        });
        $scope.isLoadingReadPane = false;
      });
    }

    function updateWidgetsAssoc(widgetsAssoc) {
      var item = angular.copy(widgetsAssoc);
      delete item.children;
      delete item.widget;
      var options = {
        site: $scope.siteID,
        id: item.id_assoc,
        data: item
      };
      return sitemapService.updateWidgetsAssoc(options);
    }

    function closeWidgetsAssocs() {
      vm.currentSitemap = null;
      vm.currentWidgetsAssocs = null;
    }


    function getSitemapGroups() {
      var currentlySelectedGroup = angular.copy(vm.selectedGroup);
      var options = {
        siteID: $scope.siteID,
        sortField: vm.sortGroupsField,
        sortDir: vm.sortGroupsDir
      };
      sitemapService.getSitemapGroupsNested(options).then(function (response) {
        if (currentlySelectedGroup) {
          var newSelectedGroup = msUtils.getGroupByIdNested(response.data, currentlySelectedGroup.id_group);
          if (newSelectedGroup) {
            newSelectedGroup.is_selected_group = true;
          }
        }
        vm.groups = response.data;
        vm.qiuRestrictions = response.qiuRestrictions;
        vm.showQiuGroupsSidenav = true;
      });
    }

    function sortSitemapGroups(field, dir) {
      vm.sortGroupsField = field;
      vm.sortGroupsDir = dir;
      getSitemapGroups();
    }

    function chargeWidgets(widgets) {
      vm.currentWidgetsAssocs = reduceByZone(widgets, 'id_zone');
      $scope.isLoadingReadPane = false;
    }

    function reduceByZone(arr, key) {
      let group = arr.reduce((r, a) => {
        r[a[key]] = [...r[a[key]] || [], a];
        return r;
      }, {});
      return group;
    }

    function editParentDialog(ev) {
      var excludeId = vm.currentSitemap ? vm.currentSitemap.id_sitemap : null;
      var filteredSitemaps = filterSitemapsForParentSelect(vm.sitemaps, excludeId);

      $mdDialog.show({
        controller: 'selectSitemapDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/apps/sitemap/dialogs/select-sitemap-dialog/select-sitemap-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          sitemaps: filteredSitemaps
        }
      }).then(function (id) {
        if (id) {
          vm.currentSitemap.parent_sitemap = id;
          loadParentSitemap(id);
        }
      });

    }

    function filterSitemapsForParentSelect(nodes, excludeId) {
      if (!nodes) return [];
      var filtered = [];
      for (var i = 0; i < nodes.length; i++) {
        var node = nodes[i];
        if (excludeId && node.id_sitemap == excludeId) {
          continue;
        }
        var nodeCopy = angular.copy(node);
        if (nodeCopy.children) {
          nodeCopy.children = filterSitemapsForParentSelect(nodeCopy.children, excludeId);
        }
        filtered.push(nodeCopy);
      }
      return filtered;
    }

    function showSearchToggle() {
      vm.showSearch = true;
      $timeout(() => {
        document.getElementById('ms-search-bar-input').focus();
      }, 300);
    }

    function chargeSitemap(sitemap) {
      parseSitemapSection(sitemap);
      vm.currentSitemap = sitemap;
      changeURL();
      vm.loadSectionReferences();
      if (vm.currentSitemap.parent_sitemap) {
        loadParentSitemap(vm.currentSitemap.parent_sitemap);
      } else {
        vm.parentSitemap = null;
      }
      if (!vm.currentSitemap.seo) {
        vm.currentSitemap.seo = {
          "fields":
            [
              { "id": 1, "type": "text", "title": "Title", "value": "", "field_name": "title" },
              { "id": 2, "type": "text", "title": "Keywords", "value": "", "field_name": "keywords" },
              { "id": 3, "type": "text", "title": "Description", "value": "", "field_name": "description" },
              { "id": 3, "type": "text", "title": "Default image url", "value": "", "field_name": "default_image_url" },
              { "id": 4, "type": "separator", "title": "FACEBOOK OG" },
              { "id": 3, "type": "text", "title": "Type", "value": "", "field_name": "type" },
              { "id": 3, "type": "text", "title": "Site Name", "value": "", "field_name": "site_name" },
              { "id": 4, "type": "separator", "title": "ADVANCED SEO" },
              { "id": 5, "type": "text", "title": "Author", "value": "", "field_name": "author" },
              { "id": 6, "type": "text", "title": "Locality", "value": "", "field_name": "locality" },
              { "id": 7, "type": "text", "title": "Copyright", "value": "", "field_name": "copyright" },
              {
                "id": 8,
                "type": "select",
                "title": "robots",
                "value": "",
                "options": ["Default", "Other"],
                "field_name": "robots"
              },
              {
                "id": 9,
                "type": "select",
                "title": "Revisit After",
                "value": "",
                "options": ["Default", "Other"],
                "field_name": "revisit_after"
              }
            ]
        };
      } else if (typeof vm.currentSitemap.seo === 'string') {
        vm.currentSitemap.seo = JSON.parse(vm.currentSitemap.seo);
      }

      // Campos de la tarjeta de compartir (og:image). Los lee qiupreview (SetSeo.php) por el
      // título EXACTO. Backfill: se añaden si faltan, para que salgan tanto en SEO nuevos como
      // en los ya guardados. NO traducir los títulos (son la clave del contrato).
      (function () {
        var cardFields = [
          { "id": 20, "type": "separator", "title": "SHARE CARD" },
          { "id": 25, "type": "text",   "title": "Card Design",     "value": "", "field_name": "card_design" },
          { "id": 21, "type": "select", "title": "Card Style", "value": "", "options": ["", "glow", "fill", "image"], "field_name": "card_style" },
          { "id": 22, "type": "text",   "title": "Card Color",      "value": "", "field_name": "card_color" },
          { "id": 23, "type": "text",   "title": "Card Background",  "value": "", "field_name": "card_background" },
          { "id": 24, "type": "text",   "title": "Card Logo",        "value": "", "field_name": "card_logo" },
          { "id": 26, "type": "text",   "title": "Card Font",        "value": "", "field_name": "card_font" },
          { "id": 27, "type": "text",   "title": "Card Show Logo",   "value": "", "field_name": "card_show_logo" },
          { "id": 28, "type": "text",   "title": "Card Show Title",  "value": "", "field_name": "card_show_title" },
          { "id": 29, "type": "text",   "title": "Card Show Description", "value": "", "field_name": "card_show_description" },
          { "id": 30, "type": "text",   "title": "Card Use First Image",  "value": "", "field_name": "card_use_first_image" }
        ];
        if (vm.currentSitemap.seo && vm.currentSitemap.seo.fields) {
          cardFields.forEach(function (cf) {
            var exists = vm.currentSitemap.seo.fields.some(function (f) { return f.title === cf.title; });
            if (!exists) { vm.currentSitemap.seo.fields.push(cf); }
          });
        }
      })();
      // refs a los campos (para editarlos con ng-model en el editor visual)
      vm.cardBgFieldRef    = ogSeoField('Card Background');
      vm.cardColorFieldRef = ogSeoField('Card Color');
      vm.cardLogoFieldRef  = ogSeoField('Card Logo');

      vm.layoutSelected = vm.currentSitemap.id_layout;
      vm.nolayout = vm.currentSitemap.disable_layout == 1;
      if (vm.nolayout && !vm.currentSitemap.sitemap_data) {
        vm.currentSitemap.sitemap_data = [{
          class: "",
          type_layout: "ajax-content",
          zones: [{ "is_hidden": false, widgets: [] }]
        }];
      } else if (!vm.currentSitemap.sitemap_data) {
        vm.currentSitemap.sitemap_data = [];
      }

      if (vm.currentSitemap.sitemap_data) {
        if (!Array.isArray(vm.currentSitemap.sitemap_data)) {
          vm.currentSitemap.sitemap_data = Object.values(vm.currentSitemap.sitemap_data);
        }
        vm.currentSitemap.sitemap_data.forEach(row => {
          if (!row.type_layout && row.class) {
            if (row.class.indexOf('full-width') >= 0) row.type_layout = 'full-width';
            else if (row.class.indexOf('primary-related') >= 0) row.type_layout = 'primary';
            else if (row.class.indexOf('secondary') >= 0) row.type_layout = 'secondary';
            else if (row.class.indexOf('threecols') >= 0) row.type_layout = 'threecols';
            else if (row.class.indexOf('ajax-content') >= 0) row.type_layout = 'ajax-content';
          }

          // Robust initialization of zones and widgets
          var expectedZones = 0;
          switch (row.type_layout) {
            case 'full-width': expectedZones = 1; break;
            case 'primary': case 'secondary': expectedZones = 2; break;
            case 'threecols': expectedZones = 3; break;
            case 'ajax-content': expectedZones = 1; break;
          }

          if (!row.zones || !Array.isArray(row.zones)) {
            row.zones = [];
          }

          // Fill missing zones if necessary
          while (row.zones.length < expectedZones) {
            row.zones.push({ "is_hidden": false, widgets: [] });
          }

          row.zones.forEach(zone => {
            if (!zone.widgets || !Array.isArray(zone.widgets)) {
              zone.widgets = [];
            }
          });
        });
      }
      $scope.isLoadingReadPane = false;
      initDragula();
    }

    function loadParentSitemap(parentSitemapId) {
      if (!vm.sitemaps) return;
      vm.parentSitemap = findNodeById(vm.sitemaps, parentSitemapId);
    }

    function addRowLayout(type, row) {
      if (!vm.currentSitemap.sitemap_data) {
        vm.currentSitemap.sitemap_data = [];
      }
      switch (type) {
        case 'full-width':
          vm.currentSitemap.sitemap_data.push({ type_layout: type, zones: [{ "is_hidden": false, widgets: [] }] });
          break;

        case 'primary':
          vm.currentSitemap.sitemap_data.push({
            type_layout: type,
            zones: [{ "is_hidden": false, widgets: [] }, { "is_hidden": false, widgets: [] }]
          });
          break;

        case 'secondary':
          vm.currentSitemap.sitemap_data.push({
            type_layout: type,
            zones: [{ "is_hidden": false, widgets: [] }, { "is_hidden": false, widgets: [] }]
          });
          break;
        case 'threecols':
          vm.currentSitemap.sitemap_data.push({
            type_layout: type,
            zones: [{ "is_hidden": false, widgets: [] }, { "is_hidden": false, widgets: [] }, {
              "is_hidden": false,
              widgets: []
            }]
          });
          break;
        case 'duplicate':
          vm.currentSitemap.sitemap_data.push(row);
          break;
        default:
          break;
      }
    }

    function destroyDragula() {
      destroyZoneDragula();
      destroyWidgetDragula();

    }

    function destroyWidgetDragula() {
      let widgets = dragulaService.find($scope, 'widget');
      if (widgets) {
        dragulaService.destroy($scope, 'widget');
      }
    }

    function destroyZoneDragula() {
      let zones = dragulaService.find($scope, 'zone');
      if (zones) {
        dragulaService.destroy($scope, 'zone');
      }
    }

    function onLoadedIframe() {
      vm.iframeFinishLoad = true;
      $scope.$apply();
    }

    function selectDevice(device) {
      vm.deviceSelected = device;
      vm.iframeFinishLoad = false;
      document.getElementById('iframeSitemap').src = vm.sitemapUrl;
    }

    function closeSitemap() {
      if (vm.currentSitemap) {
        destroyDragula();
      }
      vm.currentSitemap = null;
    }

    function resetSitemapList(list, scroll, sitemap) {
      if (!$scope.isLoading) {
        $scope.isLoading = true;
      }
      if (Array.isArray(sitemap)) {
        sitemap = sitemap[0];
      }
      $scope.listref = list;
      $scope.scrollref = scroll;
      $scope.sitemapref = sitemap;
      var getSitemapsOptions = {
        siteID: $scope.siteID,
        sortDir: $rootScope.sortDir,
        sortField: $rootScope.sortField,
        page: 1,
        resultsPerPage: $rootScope.perPage,
        searchStringFilter: ''
      };
      if (vm.subdomainFilter) {
        getSitemapsOptions.id_template = vm.subdomainFilter;
      } else {
        getSitemapsOptions.without_template = true;
      }
      sitemapService.get(getSitemapsOptions).then(function (response) {
        vm.sitemaps = response.data;
        if (!$scope.listref && !$scope.scrollref) {
          $scope.listref = document.getElementsByClassName('treeview-sitemap')[0];
          if (sitemap.parent_sitemap) {
            var item = document.getElementById('treeview-group-' + sitemap.id_sitemap).parentElement.parentElement;
            $scope.scrollref = item.offsetTop + 64 - (document.body.clientHeight / 2);
          } else {
            $scope.scrollref = 0;
          }
        }
        setTimeout(function () {
          $scope.listref.scrollTop = $scope.scrollref;
          var item = document.getElementById('treeview-group-' + sitemap.id_sitemap).parentElement.parentElement;
          item.classList.add("selected");
          delete $scope.listref;
          delete $scope.scrollref;
        }, 500);
        $scope.isLoading = false;
      });
    }

    function saveSitemap(sitemap, updateCurrent) {
      if (sitemap.id_sitemap) {
        var list = document.getElementsByClassName('treeview-sitemap')[0];
        if (list) {
          var scroll = list.scrollTop;
        } else {
          var scroll = '';
        }
        var options = {};
        sitemap = adaptSitemap(sitemap);
        options = {
          site: $scope.siteID,
          item: sitemap
        };
        $scope.isLoadingReadPane = true;
        sitemapService.saveSitemap(options).then(function (response) {
          $scope.isLoadingReadPane = false;
          $scope.isLoading = true;
          parseSitemapSection(response);
          vm.currentSitemap = response;
          vm.loadSectionReferences();
          resetSitemapList(list, scroll, sitemap);
        }, function () {
          // Without this the read pane spinner never clears on a failed save,
          // which is how an API rejection (a 413 on an oversized sitemap_data,
          // say) shows up as the editor hanging rather than as an error.
          $scope.isLoadingReadPane = false;
        });
      } else {
        sitemap = adaptSitemap(sitemap);
        options = {
          site: $scope.siteID,
          item: sitemap
        };
        sitemapService.createSitemap(options).then(function (response) {
          $rootScope.pagination_resetquery();
          sitemap = response;
          if (updateCurrent) {
            parseSitemapSection(sitemap);
            vm.currentSitemap = sitemap;
            vm.loadSectionReferences();
          }
        });
      }
    }

    function deleteWidget(widgetsList, index) {
      widgetsList.splice(index, 1);
    }

    function adaptSitemap(sitemap) {
      var clonedSitemap = angular.copy(sitemap);
      if (clonedSitemap.sitemap_data) {
        for (let i = 0; i < clonedSitemap.sitemap_data.length; i++) {
          var result = "row " + "row-" + i + " ";
          switch (clonedSitemap.sitemap_data[i].type_layout) {
            case 'full-width':
              result += "zones-1 full-width " + (clonedSitemap.sitemap_data[i].extra_class || "");
              break;
            case 'primary':
              result += "zones-2 primary-related " + (clonedSitemap.sitemap_data[i].extra_class || "");
              break;
            case 'secondary':
              result += "zones-2 secondary " + (clonedSitemap.sitemap_data[i].extra_class || "");
              break;
            case 'threecols':
              result += "zones-3 threecols " + (clonedSitemap.sitemap_data[i].extra_class || "");
              break;
            default:
              break;
          }
          clonedSitemap.sitemap_data[i].class = result;
        }
      }
      if (!clonedSitemap.frontend_settings) {
        delete clonedSitemap.frontend_settings;
      }

      if (Array.isArray(clonedSitemap.id_section)) {
        clonedSitemap.id_section = clonedSitemap.id_section.join(',');
      }

      if (Array.isArray(clonedSitemap.id_subsec)) {
        clonedSitemap.id_subsec = clonedSitemap.id_subsec.join(',');
      }

      return clonedSitemap;
    }


    function newSitemap() {
      vm.currentSitemap = { lang: 2, sitemap_data: [], id_section: [], id_subsec: [] };
      vm.loadSectionReferences();
      vm.newSitemapTitle = true;
      initDragula();
    }


    /**
     * Change the view
     *
     * @param view
     */
    function changeView(view) {
      if (vm.views[view]) {
        vm.defaultView = view;
        vm.currentView = view;
      }
    }

    function deleteSitemap(id) {
      var options = {};
      if (Array.isArray(id)) {
        options = {
          site: $scope.siteID,
          id_sitemap: id
        };
        sitemapService.deleteMultipleSitemap(options).then(function (response) {
          vm.closeSitemap();
          $rootScope.pagination_resetquery();
          var message = $translate.instant('CONTENT.DELETED');
          $mdToast.show({
            template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
            hideDelay: 3000,
            position: 'top right',
            parent: '#main'
          });
        });
      } else {
        options = {
          site: $scope.siteID,
          id: id ? id : vm.currentSitemap.id_sitemap
        };
        sitemapService.deleteSitemap(options).then(function (response) {
          vm.closeSitemap();
          $rootScope.pagination_resetquery();
          var message = $translate.instant('CONTENT.DELETED');
          $mdToast.show({
            template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
            hideDelay: 3000,
            position: 'top right',
            parent: '#main'
          });
        });
      }
    }

    function duplicateSitemapWindow(ev, sitemaps) {
      $mdDialog.show({
        controller: 'duplicateSitemapDialog',
        controllerAs: 'vm',
        templateUrl: 'app/main/apps/sitemap/dialogs/duplicate-sitemaps-dialog/duplicate-sitemaps-dialog.controller.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          sitemaps: sitemaps ? sitemaps : [vm.currentSitemap]
        }
      }).then(function (res) {
        if (res) {
          duplicateSitemap(res);
        }
      });

    }

    function getSubDomains() {
      var domain = sessionService.site_operative.id_domain;
      var options = {
        domain: domain
      }
      sitemapService.getSubDomains(options).then(function (response) {
        vm.subDomains = response;
        var savedSubdomainFilter = settingUserService.getSettingValue(vm.settingsSection, 'subdomainFilter', null);
        if (savedSubdomainFilter) {
          vm.subdomainFilter = savedSubdomainFilter;
          $rootScope.subdomainFilter = savedSubdomainFilter;
          getSitemapsSubdomain(savedSubdomainFilter);
        } else {
          const defaultDomain = vm.subDomains.find(x => x.default_template);
          if (defaultDomain) {
            vm.subdomainFilter = defaultDomain.id_template;
            $rootScope.subdomainFilter = defaultDomain.id_template;
          }
        }
      });
    }

    function migrateAllOldWidgets() {
      var domain = vm.site;
      var sitemapId = vm.currentSitemap.id_sitemap;
      var options = {
        domain: domain,
        id: sitemapId
      }
      sitemapService.migrateAllOldWidgets(options).then(function (response) {
        closeSitemap();
      });
    }


    function copySitemapWindow(ev, sitemaps, lang) {
      if (!lang) {
        $mdDialog.show({
          controller: 'copySitemapDialog',
          controllerAs: 'vm',
          templateUrl: 'app/main/apps/sitemap/dialogs/copy-sitemaps-dialog/copy-sitemaps-dialog.controller.html',
          parent: angular.element($document.body),
          targetEvent: ev,
          clickOutsideToClose: true
        }).then(function (lang) {
          if (lang) {
            copySitemap(ev, sitemaps, lang);
          }
        });
      } else {
        copySitemap(ev, sitemaps, lang);
      }
    }

    function copySitemap(ev, sitemaps, lang) {
      var messageConfirm = '';
      var confirm = '';
      if (sitemaps.length === 1) {
        messageConfirm = $translate.instant('CONTENT.SURE_COPY_SINGULAR');
        confirm = $mdDialog.confirm().title(messageConfirm).htmlContent()
          .ariaLabel('Delete item').targetEvent(event).ok('OK').cancel('CANCEL');
      } else {
        messageConfirm = $translate.instant('CONTENT.SURE_COPY_PLURAL');
        confirm = $mdDialog.confirm().title(messageConfirm).htmlContent()
          .ariaLabel('Delete item').targetEvent(event).ok('OK').cancel('CANCEL');
      }

      $mdDialog.show(confirm).then(function () {
        sitemaps = sitemaps.map(x => {
          if (!x.id_sitemap) {
            return {};
          } else {
            return {
              "id_sitemap": x.id_sitemap,
              "lang": lang.id
            };
          }
        });
        var options = {
          site: $scope.siteID,
          item: { sitemaps: sitemaps }
        };
        sitemapService.copySitemap(options).then(function (response) {
          $rootScope.pagination_resetquery();
          var message = $translate.instant('CONTENT.COPIED');
          $mdToast.show({
            template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
            hideDelay: 3000,
            position: 'top right',
            parent: '#main'
          });
        }, function (err) {
          var message = $translate.instant('GLOBAL.ERROR') + '<br>' + err.data.detail;
          $mdToast.show({
            template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
            hideDelay: 5000,
            position: 'top',
            parent: '#content-container'
          });
        });
      });

    }

    function duplicateSitemap(data) {
      var options = {};
      if (Array.isArray(data)) {
        options = {
          site: $scope.siteID,
          item: {
            sitemaps: data
          }
        };
        sitemapService.duplicateMultipleSitemap(options).then(function (response) {
          resetSitemapList('', '', data);
          var message = $translate.instant('CONTENT.DUPLICATED');
          $mdToast.show({
            template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
            hideDelay: 3000,
            position: 'top right',
            parent: '#main'
          });
        }, function (err) {
          var message = $translate.instant('GLOBAL.ERROR') + '<br>' + err.data.detail;
          $mdToast.show({
            template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
            hideDelay: 5000,
            position: 'top',
            parent: '#content-container'
          });
        });
      } else {
        options = {
          site: $scope.siteID,
          id: data ? data : vm.currentSitemap.id_sitemap
        };
        sitemapService.duplicateSitemap(options).then(function (response) {
          $rootScope.pagination_resetquery();
          var message = $translate.instant('CONTENT.DUPLICATED');
          $mdToast.show({
            template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
            hideDelay: 3000,
            position: 'top right',
            parent: '#main'
          });
        }, function (err) {
          var message = $translate.instant('GLOBAL.ERROR') + '<br>' + err.data.detail;
          $mdToast.show({
            template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
            hideDelay: 5000,
            position: 'top',
            parent: '#content-container'
          });
        });
      }
    }

    function editWidgetDialog(ev, widgets, widget, widgetsOptions) {
      widgetsOptions = vm.widgets;
      $mdDialog.show({
        controller: 'editWidgetDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/apps/sitemap/dialogs/edit-widget.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        escapeToClose: false,
        locals: {
          site: $scope.siteID,
          widgets: widgets,
          widget: widget,
          widgetsOptions: widgetsOptions,
          v2Widgets: vm.v2Widgets
        }
      }).then(function (updatedWidget) {
        if (updatedWidget) {
          vm.saveSitemap(vm.currentSitemap);
        }
      });
    }

    function duplicateWidget(widgets, widget) {
      widgets.push(JSON.parse(angular.toJson(widget)));
      updateWidgetContainers();
    }

    function saveWidgetAsTemplate(widget) {
      var templateWidget = vm.widgets.find(x => x.id_widget == widget.id_widget);
      templateWidget = {
        id_widget: widget.id_widget,
        name: widget.title,
        title: widget.title,
        description: widget.description,
        dafault_id: widget.default_id,
        fields: templateWidget.fields,
        structure_json: widget.structure,
        v1_layout: templateWidget.v1_layout,
        config: widget.config,
        data: widget.data
      }
      var options = {
        domain: $scope.siteID,
        item: angular.toJson(templateWidget)
      };
      sitemapService.postTemplateWidget(options).then(function (response) {
        getWidgetTemplates();
      });
    }

    function deleteWidgetTemplate(id) {
      var options = {
        domain: $scope.siteID,
        id_template: id
      }
      sitemapService.deleteWidgetTemplate(options).then(function (response) {
        getWidgetTemplates();
      });
    }

    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    function closeSidenav(sidenavId) {
      $mdSidenav(sidenavId).close();
    }

    function showSidenav(sidenavId) {
      $mdSidenav(sidenavId).open();
    }


  }


  function openSitemap(sitemapService) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {

        $(element).on('click', function (e) {
          var id = attrs.rowid;
          var item = JSON.parse(attrs.item);
          if (element.parent().parent().parent().hasClass('selected')) {
            unselectAllGroups();
          } else {
            unselectAllGroups();
            element.parent().parent().parent().addClass('selected');
          }
          sitemapService.openSitemapTrigger(id);
        });
      }
    };
  }

  function toggleNode(sitemapService) {

    return {
      restrict: 'A',
      link: function (scope, element, attrs) {

        $(element).on('click', function (e) {

        });
      }
    };
  }

  function checkAll(node) {
    console.log('node', node);
  }

  function unselectAllGroups() {
    var elemList = document.querySelectorAll('.ivh-treeview-node');
    elemList.forEach(function (elem) {
      elem.classList.remove('selected');
    });
  }


  function toggleSitemapStatus($rootScope) {

    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        $(element).on('click', function (e) {
          $rootScope.$broadcast('toggleChecked', parseInt(attrs.id));

        });
      }
    };
  }


})();

(function () {
    'use strict';

    angular
        .module('app.sitemap')
        .service('sitemapService', SitemapService);

    /** @ngInject */
    // I provide access to the session store.
    function SitemapService($rootScope, $q, $resource, userService, settingsDomainService, sessionService, COMMON, $window, $state) {


        function get(options) {
            if (!options.id_template && !options.without_template) {
                return getSubDomains({ domain: sessionService.site_operative.id_domain })
                    .then(subDomains => {
                        const defaultDomain = subDomains.find(x => x.default_template);
                        if (defaultDomain) {
                            options.id_template = defaultDomain.id_template;
                        }
                        if (!angular.isArray(options.groupIds) || options.groupIds.length === 0) {
                            return getSitemaps(options);
                        } else {
                            return getSitemapsInGroup(options);
                        }
                    });
            } else {
                if (!angular.isArray(options.groupIds) || options.groupIds.length === 0) {
                    return getSitemaps(options);
                } else {
                    return getSitemapsInGroup(options);
                }
            }
        }       

        function getSitemaps(options) {
            var deferred = $q.defer();
            var filters = [];

            _.forEach(options, function (value, key, list) {
                if (_.isObject(list[key])) {
                    _.forEach(list[key], function (filter, keyFilter, listFilter) {
                        if (!_.isEmpty(filter.selected)) {
                            filters.push({
                                field: filter.field,
                                name: filter.name,
                                values: filter.selected
                            });
                        }

                    });

                }
            });

            var optionsObj = {
                domain: options.siteID,
                page: options.page,
                search: options.searchStringFilter,
                paginate: options.paginate,
                sortField: options.sortField,
                sortDir: options.sortDir,
                filters: JSON.stringify(filters),
                resultsPerPage: 50,
                id_template: options.id_template
            };
            if (options.sortBy) {
                optionsObj.sortBy = options.sortBy;
            }
            if($state.params.isseosection){
                optionsObj.in_seo = 1;
            }
            resourceSitemap.get(optionsObj,
                function (responseResult) {
                    formatSitemaps(responseResult);
                    deferred.resolve({ data: responseResult });

                },
                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getSitemapsInGroup(options) {

            var deferred = $q.defer();

            var opts = {
                domain: options.siteID,
                'id_group[]': options.groupIds,
                sortField: options.sortField,
                sortDir: options.sortDir,
                resultsPerPage: options.resultsPerPage,
                page: options.page,
                search: options.searchStringFilter
            };
            if (options.sortBy) {
                opts.sortBy = options.sortBy;
            }
            /*
            if (options.ingroupStatus && options.ingroupStatus != "0") {
                opts.ingroupStatus = parseInt(options.ingroupStatus);
            }
            */

            resourceSitemapNestedInGroup.get(
                opts,
                function (response) {
                    formatSitemaps(response);
                    deferred.resolve({data: response});
                },
                function (e) {
                    console.error(e)
                    deferred.reject();
                }
            );

            return (deferred.promise);
        };



        function openSitemapTrigger(id) {
            $rootScope.$broadcast('loadSitemap', id);
        }
        function toggleStatusTrigger(sitemap) {
            $rootScope.$broadcast('toggleStatus', sitemap);
        }

        function formatSitemaps(sitemaps) {
            for (var i = 0; i < sitemaps.length; i++) {
                sitemaps[i].label = sitemaps[i].lang_name;
                if (sitemaps[i].menu) {
                    sitemaps[i].children = sitemaps[i].menu;
                }
                if (sitemaps[i].paths) {
                    sitemaps[i].children = sitemaps[i].paths;
                }
                if (sitemaps[i].submenu) {
                    sitemaps[i].children = sitemaps[i].submenu;
                }
                if (sitemaps[i].children) {
                    formatChildren(sitemaps[i].children)
                }
            }
        }

        function formatChildren(children) {
            for (var i = 0; i < children.length; i++) {
                children[i].label = children[i].name;
                if (children[i].submenu) {
                    children[i].children = children[i].submenu;
                }
                if (children[i].children) {
                    formatChildren(children[i].children);
                }
            }
        }

        function saveSitemap(options) {
            var deferred = $q.defer();

            options.item = sitemapToDTO(options.item);

            var params = {
                domain: options.site,
                id: options.item.id_sitemap
            };

            function onSaved(sitemap) {
                sitemap = DTOtoSitemap(sitemap)
                deferred.resolve(sitemap);
            }

            // Sitemaps carry their whole sitemap_data layout tree, so the body
            // is regularly megabytes and gzip cuts it by roughly 10x. Fall back
            // to the uncompressed PUT if anything about the compressed path
            // fails, so a browser without pako or an API that predates
            // Controller::getRawRequestBody() still saves.
            var gzipBlob = null;
            try {
                gzipBlob = new Blob([pako.gzip(JSON.stringify(options.item))]);
            } catch (err) {
                console.warn("sitemap: gzip unavailable, sending uncompressed", err);
            }

            function saveUncompressed() {
                resourceSitemapById.update(params, options.item, onSaved, function (e) {
                    // Don't report this as a connection error — it is usually a
                    // status the caller needs to see. 413 in particular means
                    // the body exceeded nginx's client_max_body_size, and nginx
                    // answers with an HTML page carrying no CORS headers, so
                    // the status is all we get.
                    console.error("sitemap: save failed with status " + (e && e.status), e);
                    deferred.reject(e);
                });
            }

            if (gzipBlob === null) {
                saveUncompressed();
            } else {
                resourceSitemapById.updateGzip(params, gzipBlob, onSaved, function (e) {
                    var status = e && e.status;
                    // The retry exists for an API that doesn't inflate gzip
                    // (it answers 400, having tried to JSON-parse the binary).
                    // Retrying is pointless where the uncompressed body can
                    // only do worse — 413, since it is ~10x larger and would
                    // just re-upload megabytes to fail again — or where the
                    // body was never the problem, as with an expired token.
                    if (status === 413 || status === 401 || status === 403) {
                        console.error("sitemap: save failed with status " + status + " (not retrying uncompressed)", e);
                        deferred.reject(e);
                        return;
                    }
                    console.warn("sitemap: gzipped save failed with status " + status + ", retrying uncompressed", e);
                    saveUncompressed();
                });
            }

            // Return the promise.
            return (deferred.promise);
        }
        function deleteMultipleSitemap(options) {
            var deferred = $q.defer();

            resourceMassDelete.delete({
                domain: options.site,
                'id_sitemap[]': options.id_sitemap,
            }, function (res) {
                deferred.resolve(res);
            },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function deleteSitemap(options) {
            var deferred = $q.defer();

            resourceSitemapById.delete({
                domain: options.site,
                id: options.id
            }, function (res) {
                deferred.resolve(res);
            },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function duplicateSitemap(options) {
            var deferred = $q.defer();

            var options = {
                domain: options.site,
                id: options.id
            };
            resourceDuplicateSitemapById.post(options, {}, function (res) {
                deferred.resolve(res);
            },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function duplicateMultipleSitemap(options) {
            var deferred = $q.defer();
            resourceMassDuplicate.post(
                {
                    domain: options.site
                }, options.item, function (res) {
                    deferred.resolve(res);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function copySitemap(options) {
            var deferred = $q.defer();
            resourceMassCopy.post(
                {
                    domain: options.site
                }, options.item, function (res) {
                    deferred.resolve(res);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function createSitemap(options) {
            var deferred = $q.defer();

            options.item = sitemapToDTO(options.item);
            resourceSitemapById.post({
                domain: options.site
            }, options.item,
                function (sitemap) {
                    sitemap = DTOtoSitemap(sitemap)
                    deferred.resolve(sitemap);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }


        function getSitemapByID(options) {
            var deferred = $q.defer();

            resourceSitemapById.get({
                domain: options.site,
                id: options.id
            },
                function (response) {
                    response = ResponseToData(response);
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function getWidgetsAssocs(options) {
            var deferred = $q.defer();

            var opts = {
                domain: options.site
            };
            if (options.id) {
                opts.id_sitemap = options.id;
            }
            resourceWidgetsAssocs.get(opts,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function getWidgetsAssocsNested(options) {
            var deferred = $q.defer();
            resourceWidgetsAssocsNested.get(options,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function updateWidgetsAssoc(options) {
          var deferred = $q.defer();

          resourceWidgetsAssoc.update({
              domain: options.site,
              id: options.id
            },
            options.data,
            function (response) {
              deferred.resolve(response);
            },
            function (e) {
              console.error(e)
              console.error("Database connection error")
              deferred.reject();
            }
          );

          // Return the promise.
          return (deferred.promise);
        }
        function getOptions(options) {
            var deferred = $q.defer();

            resourceOptions.get({
                domain: options.site,
                lang: options.lang
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function getWidgets(options) {
            var deferred = $q.defer();

            resourceWidgets.get({
                domain: options.site
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function getSections(options) {
            var deferred = $q.defer();

            resourceSections.get({
                domain: options.siteID,
                mediaZones: options.mediaZones,
                cropformats: options.cropformats,
                fields: options.fields,
                sub: options.sub
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function getSection(options) {
            var deferred = $q.defer();

            resourceSection.get({
                domain: options.site,
                section: options.section
            }, options.item,
                function (sitemap) {
                    deferred.resolve(sitemap);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function getSectionRef(options) {
            var deferred = $q.defer();

            resourceSectionRef.get({
                domain: options.site,
                section: options.section
            }, options.item,
                function (sitemap) {
                    deferred.resolve(sitemap);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function getFilters(options) {
            var deferred = $q.defer();

            // Return the promise.
            return (deferred.promise);
        }

        function getSitemapGroupsNested(options) {
            var deferred = $q.defer();
            resourceSitemapGroupsNested.get({
                domain: options.siteID,
                sortDir: options.sortDir || 'ASC',
                sortField: options.sortField || 'name'
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("Database connection error")
                    console.error(e)
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }



        function createSitemapGroup(options) {
            var deferred = $q.defer();
            resourceSitemapGroups.post({
                domain: options.siteID,
                parent: options.parentGroupId,
                name: options.groupName
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("Database connection error")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function editSitemapGroup(options) {
            var deferred = $q.defer();
            resourceSitemapGroups.update({
                domain: options.siteID,
                parent: options.parentGroupId,
                name: options.groupName,
                id: options.groupId
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("Database connection error")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function deleteSitemapGroup(options) {
            var deferred = $q.defer();
            resourceSitemapGroups.delete({
                domain: options.siteID,
                id: options.groupId
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    deferred.reject(e);
                }
            );
            return (deferred.promise);
        }

        function massInsertIntoGroups(options) {
            var deferred = $q.defer();
            resourceSitemapInGroupsMassInsert.post({
                domain: options.siteID
            }, JSON.stringify(options.data),
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("Database connection error")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function removeFromGroup(options) {
            var deferred = $q.defer();
            resourceSitemapInGroup.delete({
                domain: options.siteID,
                id: options.id_group,
                'id_sitemap[]': options.ids
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("Database connection error")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function ResponseToData(response) {
            response.options.dynamic_structure = Object.values(response.options.dynamic_structure);
            response.sitemap = DTOtoSitemap(response.sitemap)
            return response;
        }

        function DTOtoSitemap(sitemap) {
            if (sitemap.url && sitemap.url.length > 0 && sitemap.extension && sitemap.extension.length > 0 && sitemap.cache_timeout && !sitemap.sub_item) {
                if (sitemap.external_url && sitemap.external_url.length > 0) {
                    sitemap.type = 'redirect';
                } else {
                    sitemap.type = 'static';
                }
            } else if (sitemap.external_url && sitemap.external_url.length > 0) {
                sitemap.type = 'external';
            } else if(sitemap.sub_item && sitemap.sub_item > 0){
                sitemap.type = 'dynamic';
            }else{
                sitemap.type = 'static';
            }
            // if (sitemap.seo) {
            //     sitemap.seo = JSON.parse(sitemap.seo);
            // }
            sitemap.isHome = sitemap.home == 1 ? true : false;
            sitemap.isMenu = sitemap.menu == 1 ? true : false;
            sitemap.isMenuSecondary = sitemap.menu_secondary == 1 ? true : false;
            sitemap.label = sitemap.name;
            return sitemap
        }
        function sitemapToDTO(sitemap) {
            switch (sitemap.type) {
                case 'static':
                    sitemap.sub_item = null;
                    sitemap.external_url = null;
                    break;
                case 'dynamic':
                    sitemap.external_url = null;
                    break;
                case 'external':
                    sitemap.extension = null;
                    sitemap.cache_timeout = null;
                    sitemap.sub_item = null;
                    break;
                case 'redirect':
                    sitemap.sub_item = null;
                    break;
                default:
                    break;
            }
            // if (sitemap.seo) {
            //     sitemap.seo = JSON.stringify(sitemap.seo);
            // }
            // delete sitemap.type;
            sitemap.menu_secondary = sitemap.isMenuSecondary ? 1 : 0;
            delete sitemap.isMenuSecondary;
            sitemap.menu = sitemap.isMenu ? 1 : 0;
            delete sitemap.isMenu;
            sitemap.home = sitemap.isHome ? 1 : 0;
            delete sitemap.isHome;
            delete sitemap.sub_item_template;
            return sitemap;
        }

        function getSubDomains(options){
            var deferred = $q.defer();

            resourceGetSubDomain.get({
                domain: options.domain
            },
                function response(response) {
                    deferred.resolve(response);
                },
                function(e) {
                    console.error(e);
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function migrateAllOldWidgets(options){
            var deferred = $q.defer();

            resourceMigrateSitemapWidgets.get({
                domain: options.domain,
                id: options.id
            },
                function response(response) {
                    deferred.resolve(response);
                },
                function(e) {
                    console.error("Something goes wrong");
                    console.error(e);
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getWidget(options){
            var deferred = $q.defer();

            resourceGetWidget.get({
                domain: options.domain,
                id: options.id
            },
                function response(response) {
                    deferred.resolve(response);
                },
                function(e){
                    console.error(e);
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function postTemplateWidget(options){
          var deferred = $q.defer();

          resourceWidgetTemplate.post({
            domain: options.domain,
          }, options.item,
            function response(response){
              deferred.resolve(response);
            },
            function(e){
              console.error(e);
              deferred.reject();
            }
          );
          return (deferred.promise);
        }

        function getTemplateWidgets(options){
          var deferred = $q.defer();

          resourceWidgetTemplate.get({
            domain: options.domain
          },
            function response(response){
              deferred.resolve(response);
            },
            function(e){
              console.error(e);
              deferred.reject();
            }
          );
          return (deferred.promise);
        }

        function deleteWidgetTemplate(options){
          var deferred = $q.defer();

          resourceWidgetTemplate.delete({
            domain: options.domain,
            id: options.id_template
          },
            function response(response){
              deferred.resolve(response);
            },
            function(e){
              console.error(e);
              deferred.reject();
            }
          );
          return (deferred.promise);
        }

        var resourceWidgetTemplate = $resource(COMMON.BASE_API + "/domain/:domain/widgetsV2Templates/:id", {
          domain: '@domain',
          id: '@id'
        }, {
          post: {
            method: "POST"
          },
          get: {
            method: "GET"
          },
          delete: {
            method: "DELETE",
            isArray: true
          }
        });

        var resourceSitemap = $resource(COMMON.BASE_API + "/domain/:domain/sitemap/getNested", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: true
            }
        });

        var resourceWidgets = $resource(COMMON.BASE_API + "/domain/:domain/widgets", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false
            }
        });


        var resourceDuplicateSitemapById = $resource(COMMON.BASE_API + "/domain/:domain/sitemap/:id/duplicate", {
            // No default data
        }, {
            post: {
                method: "POST",
                // isArray: true
            }
        });
        var resourceMassDuplicate = $resource(COMMON.BASE_API + "/domain/:domain/sitemap/massDuplicate", {
            // No default data
        }, {
            post: {
                method: "POST",
                // isArray: true
            }
        });
        var resourceMassCopy = $resource(COMMON.BASE_API + "/domain/:domain/sitemap/massCopy", {
            // No default data
        }, {
            post: {
                method: "POST",
                // isArray: true
            }
        });
        var resourceMassDelete = $resource(COMMON.BASE_API + "/domain/:domain/sitemap/massDelete", {
            // No default data
        }, {
            delete: {
                method: "DELETE",
                // isArray: true
            }
        });
        var resourceSitemapById = $resource(COMMON.BASE_API + "/domain/:domain/sitemap/:id", {
            // No default data
        }, {
            get: {
                method: "GET",
                // isArray: true
            },
            post: {
                method: "POST",
                // isArray: true
            },
            update: {
                method: "PUT",
                // isArray: true
            },
            // Same PUT, but the body is a gzipped Blob. A sitemap carries its
            // whole sitemap_data layout tree and routinely runs to megabytes,
            // most of it the same widget field schema repeated per node, so it
            // deflates by roughly an order of magnitude. Mirrors the
            // updateGzip action in content-service.js; the API inflates it in
            // Controller::getRawRequestBody(). saveSitemap() falls back to
            // plain `update` if this fails.
            updateGzip: {
                method: "PUT",
                isArray: false,
                headers: {
                    'Cache-Control': 'no-cache',
                    'Content-Encoding': 'gzip',
                    'Content-Type': 'application/json; charset=utf-8'
                }
            },
            delete: {
                method: "DELETE",
                isArray: true
            }
        });
        var resourceWidgetsAssocs = $resource(COMMON.BASE_API + "/domain/:domain/widgetsAssocs", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: true
            }
        });
        var resourceWidgetsAssocsNested = $resource(COMMON.BASE_API + "/domain/:domain/widgetsAssocsNested", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: true
            }
        });
        var resourceWidgetsAssoc = $resource(COMMON.BASE_API + "/domain/:domain/widgetsAssoc/:id", {
            // No default data
        }, {
            update: {
                method: "PUT",
                isArray: false
            }
        });
        var resourceOptions = $resource(COMMON.BASE_API + "/domain/:domain/sitemap/options", {
            // No default data
        }, {
            get: {
                method: "GET",
                // isArray: true
            }
        });
        //
        var resourceSections = $resource(COMMON.BASE_API + "/domain/:domain/content/sections", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: true
            }
        });
        var resourceSection = $resource(COMMON.BASE_API + "/domain/:domain/content/:section", {
            // No default data
        }, {
            get: {
                method: "GET",
                // isArray: true
            }
        });
        var resourceSectionRef = $resource(COMMON.BASE_API + "/domain/:domain/content/:section/refFields", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: true
            }
        });

        var resourceSitemapGroups = $resource(COMMON.BASE_API + "/domain/:domain/sitemapGroups/:id", {
            // No default data.
            domain: '@domain',
            id: '@id'
        }, {
            get: {
                method: "GET",
                isArray: false
            },
            post: {
                method: "POST"
            },
            update: {
                method: "PUT"
            },
            delete: {
                method: "DELETE",
                isArray: true
            }
        });

        var resourceSitemapGroupsNested = $resource(COMMON.BASE_API + "/domain/:domain/sitemapGroupsNested", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false,
                transformResponse: function(data, headers){
                    var response = {}
                    response.data = JSON.parse(data);
                    response.qiuRestrictions = JSON.parse(headers('qiu-restrictions'));
                    return response;
                }
            }
        });

        var resourceSitemapInGroup = $resource(COMMON.BASE_API + "/domain/:domain/sitemapInGroup/:id", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false
            },
            delete: {
                method: "DELETE",
                isArray: true
            },
            update: {
                method: "PUT",
                isArray: true
            },
            post: {
                method: "POST",
                isArray: true
            }
        });

        var resourceSitemapNestedInGroup = $resource(COMMON.BASE_API + "/domain/:domain/sitemapInGroup/getNested", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: true
            }
        });

        var resourceSitemapInGroupsMassInsert = $resource(
            COMMON.BASE_API + "/domain/:domain/sitemapInGroups/massInsert", {
                // No default data.

            }, {
                post: {
                    method: "POST",
                    //isArray: true
                }
            }
        );

        var resourceMigrateSitemapWidgets = $resource(
            COMMON.BASE_API + "/domain/:domain/sitemap/migrateSitemapWidgets/:id"
        )

        var resourceGetSubDomain = $resource(
            COMMON.BASE_API + "/domains/:domain/subDomains", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: true
            }
        });

        var resourceGetWidget = $resource(
            COMMON.BASE_API + "/domain/:domain/widgets/:id"
        )




        return ({
            get: get,
            getFilters: getFilters,
            saveSitemap: saveSitemap,
            createSitemap: createSitemap,
            deleteSitemap: deleteSitemap,
            deleteMultipleSitemap: deleteMultipleSitemap,
            duplicateSitemap: duplicateSitemap,
            duplicateMultipleSitemap: duplicateMultipleSitemap,
            copySitemap: copySitemap,
            getOptions: getOptions,
            getWidgets: getWidgets,
            getSection: getSection,
            getSectionRef: getSectionRef,
            getSections: getSections,
            openSitemapTrigger: openSitemapTrigger,
            toggleStatusTrigger: toggleStatusTrigger,
            sitemapToDTO: sitemapToDTO,
            getSitemapByID: getSitemapByID,
            getWidgetsAssocs: getWidgetsAssocs,
            getWidgetsAssocsNested: getWidgetsAssocsNested,
            getSitemapGroupsNested: getSitemapGroupsNested,
            updateWidgetsAssoc: updateWidgetsAssoc,
            createSitemapGroup: createSitemapGroup,
            editSitemapGroup: editSitemapGroup,
            deleteSitemapGroup: deleteSitemapGroup,
            massInsertIntoGroups: massInsertIntoGroups,
            removeFromGroup: removeFromGroup,
            migrateAllOldWidgets: migrateAllOldWidgets,
            getSubDomains: getSubDomains,
            getWidget: getWidget,
            postTemplateWidget: postTemplateWidget,
            getTemplateWidgets: getTemplateWidgets,
            deleteWidgetTemplate: deleteWidgetTemplate
        });

    }

})();

(function() {
    var scope = angular.element(document.querySelector('.site-sitemap')).scope();
    if (!scope) {
        console.log("Scope not found");
        return;
    }
    var vm = scope.vm;
    var dragulaService = angular.element(document.body).injector().get('dragulaService');
    var drake = dragulaService.find(scope, 'widget').drake;
    console.log("Drake containers:", drake.containers.length);
    console.log("Drake models:", drake.models.length);
    drake.containers.forEach((c, i) => {
        console.log("Container " + i + ": " + c.id + " (Children: " + c.children.length + ")");
    });
})();

(function() {
  'use strict';

  angular
    .module('app.store')
    .controller('StoreController', StoreController);

  /** @ngInject */
  function StoreController($scope, $rootScope, $document, $mdDialog, $mdMedia, $mdToast, $mdSidenav, $state, msApi, requestContext, $timeout, storeService, $translate, sessionService, $window, Dashboard, DTOptionsBuilder, msUtils, usersService) {
    var vm = this;
    var section = (requestContext.getParam("section")) ? requestContext.getParam("section") : 'orders';
    var sectionType = (requestContext.getParam("type")) ? requestContext.getParam("type") : false;
    $rootScope.pagination_storeSectionType = sectionType;

    vm.views = function(view) {
      switch(view) {
        case 'split': 
          return 'app/main/apps/store/views/'+section+'/split-view.html';
         break;
        case 'nosplit': 
          return 'app/main/apps/store/views/'+section+'/nosplit-view.html';
          break;
      }
      return false;
    };
    vm.defaultView = 'split';
    vm.currentView = 'split';

    var siteID = requestContext.getParam("siteId");
    $scope.siteID = siteID;
    vm.dateFormat = sessionService.site_operative.dateFormat;
    vm.dateTimeFormat = sessionService.site_operative.dateTimeFormat;
    vm.toggleInArray = msUtils.toggleInArray;
    vm.loginUrl = sessionService.site_operative.websiteLoginUrl;
    vm.idOrder = '';
    vm.filters = {};
    vm.initialized = false;
    vm.isLoading = true;
    vm.loadingThread = false;
    vm.enterfirst = true;
    vm.selectedThread = false;
    vm.isSelected = isSelected;
    vm.toggleSelectThread = toggleSelectThread;
    vm.selectThreads = selectThreads;
    vm.deselectThreads = deselectThreads;
    vm.toggleSelectThreads = toggleSelectThreads;
    vm.selectedThreads = [];
    vm.filterDateFrom = null;
    vm.filterDateTo = null;
    vm.filterDateField = 'delivery';
    vm.paginationActive = false;
    
    ///////////
    // Methods

    // Init
    vm.init = init();
    vm.initOrder = initOrder;
    vm.initDashboard = initDashboard;

    // Utils
    vm.getOrderStatus = getOrderStatus;
    vm.showDate = showDate;
    vm.showFromNow = showFromNow;
    vm.toggleSidenav = toggleSidenav;
    vm.translateVar = translateVar;
    vm.convertDate = convertDate;
    vm.saveShippingDate = saveShippingDate;
    vm.updateShipping = updateShipping;
    vm.updateOrderStatus = updateOrderStatus;
    vm.openOrder = openOrder;
    vm.openSubscription = openSubscription;
    vm.orderViewDetails = orderViewDetails;
    vm.orderViewInvoice = orderViewInvoice;
    vm.orderViewHistory = orderViewHistory;
    vm.subscriptionViewHistory = subscriptionViewHistory;
    vm.subscriptionViewDetails = subscriptionViewDetails;
    vm.translate = msUtils.translate;
    vm.closeThread = closeThread;
    vm.openUrl = msUtils.openUrl;

    // Paginations & search
    vm.pagination_firstPage = pagination_firstPage;
    vm.pagination_morePages = pagination_morePages;
    vm.setPageOrder = setPageOrder;
    vm.orderSearch = orderSearch;
    vm.orderSearchClear = orderSearchClear;
    vm.showOrderStatus = showOrderStatus;
    vm.setFilterDates = setFilterDates;
    vm.unsetFilterDates = unsetFilterDates;
    vm.changeView = changeView;
    vm.loginToWebsite = loginToWebsite;


    storeService.getSettings({site: siteID}).then(function(response){
      vm.storeSettings = response;
    });

    if ($state.params.id) {
      var itemId = $state.params.id;
      switch(section) {
        case 'orders':
          vm.openOrder({id_order: itemId});
          break;
        case 'subscriptions':
          vm.openSubscription({id_subscription: itemId});
          break;
      }
    }


    function orderSearch(query) {
      vm.dtOrderApi.search(query).draw();
    };

    function orderSearchClear() {
      vm.dtOrderApi.search('').draw();
    };



    $scope.$on('storeLoad', function(event, data) {

      vm.threads = [];
      vm.deselectThreads();
      vm.changeView(vm.currentView);

      $rootScope.global.titleToolbar = '<i class="icon s20 icon-store mr-15" ng-if="node.icon"></i> <span class="hide show-gt-xs">' + $translate.instant('STORE.STORE') + '</span> <i class="mr-5 ml-5 icon s18 icon-chevron-right hide show-gt-xs"></i> ' + data;

      if (data == 'dashboard')
      {
        vm.initDashboard();
      }
    })

    /**
     * Get order status
     *
     * @param id
     * @returns {*}
     */
    function getOrderStatus(id) {
      for (var i = 0; i < vm.statuses.length; i++)
      {
        if (vm.statuses[i].id === parseInt(id))
        {
          return vm.statuses[i];
        }
      }
    }

    function showFromNow(value) {
      return moment.utc(value).tz(sessionService.site_operative.timezone).fromNow();
    }

    function showDate(value, customFormat) {

      var dateTimeFormat = vm.dateTimeFormat;
      if (!customFormat)
      {
        dateTimeFormat = customFormat;
      }
      if (angular.isObject(value))
      {
        return value.dateShow;
      }
      else if (!value || value == '0000-00-00 00:00:00')
      {
        return '-';
      }
      else
      {
        return moment.utc(value).tz(sessionService.site_operative.timezone).format(customFormat);
      }
    }

    function translateVar(group, value) {
      var response = $translate.instant(group + '.' + value);
      return response;
    }

    function convertDate(dateToConvert) {
      var value = dateToConvert;
      if (value == '0000-00-00 00:00:00')
      {
        value = moment().utc().format("YYYY-MM-DD");
      }
      var siteDate = moment.utc(value).tz(sessionService.site_operative.timezone);
      return new Date(siteDate.format());

    }

    function saveShippingDate(shipping) {
      shipping.delivery_date = moment.utc(shipping.deliveryFormatted).format('YYYY-MM-DD HH:mm:00');
      storeService.updateShipping({
        siteID: siteID,
        id: shipping.id_shipping,
        item: shipping,
        paginate: 1000,
      }).then(function(response) {
        var message = $translate.instant('STORE.SHIPPING_DATE_SAVED');
        $mdToast.show({
          template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
          hideDelay: 5000,
          position: 'top',
          parent: '#content-container'
        });
        $rootScope.pagination_resetquery('');
      })

      return true;
    }

    function updateShipping(shipping) {
      shipping.delivery_date = moment.utc(shipping.deliveryFormatted).format('YYYY-MM-DD HH:mm:00');
      return true;
      storeService.updateShipping({
        siteID: siteID,
        id: shipping.id_shipping,
        item: shipping,
        paginate: 1000,
      }).then(function(response) {
        var message = $translate.instant('STORE.SHIPPING_STATUS_UPDATED');
        $mdToast.show({
          template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
          hideDelay: 5000,
          position: 'top',
          parent: '#content-container'
        });
        $rootScope.pagination_resetquery('');
      })

      return true;
    }

    function updateOrderStatus(newStatus) {
      storeService.updateOrderStatus({
        siteID: siteID,
        id: vm.order.id_order,
        status: newStatus,
        paginate: 1000,
      }).then(function(response) {
        var statusName = '';
        angular.forEach($scope.refFilterables.status.values, function(st) {
          if (st.value == newStatus)
          {
            statusName = st.name;
          }
        })
        vm.order.status.color = '';
        vm.order.status.status_name = statusName;
        vm.newStatus = '';
        var message = vm.translate('STORE.ORDER_STATUS_UPDATED');
        $mdToast.show({
          template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
          hideDelay: 5000,
          position: 'top',
          parent: '#content-container'
        });
        $rootScope.pagination_resetquery('');
      })

      return true;
    }

    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */
    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    function pagination_firstPage() {
      if (!angular.isUndefined(vm.pagination))
      {
        if (vm.pagination.page == 0)
        {
          return true;
        }
        else
        {
          return false;
        }
      }
    }

    function pagination_morePages() {
      if (!angular.isUndefined(vm.pagination))
      {
        if ((vm.pagination.page + 1) < vm.pagination.pages)
        {
          return false;
        }
        else
        {
          return true;
        }
      }
    }

    function setFilterDates() {
      var filter = {};
      filter.field = vm.filterDateField;
      if (! vm.filterDateFrom) {
        return;
      }
      if (vm.filterDateField == 'delivery') {
        filter.fromDate = msUtils.formatDate(vm.filterDateFrom) + " 00:00:00";
        if (vm.filterDateTo) {
          filter.toDate = msUtils.formatDate(vm.filterDateTo) + " 23:59:39";
        }
      }
      if (vm.filterDateField == 'create') {
        var tz = sessionService.site_operative.timezone;
        vm.filterDateFrom.setHours(0, 0, 0);
        filter.fromTs = msUtils.formatDateToUnixTS(vm.filterDateFrom, tz);
        if (vm.filterDateTo) {
          vm.filterDateTo.setHours(23, 59, 59);
          filter.toTs = msUtils.formatDateToUnixTS(vm.filterDateTo, tz);
        }
      }
      $rootScope.pagination_storeDatesFilter = filter;
      $rootScope.pagination_reload();
    }

    function unsetFilterDates() {
      $rootScope.pagination_storeDatesFilter = null;
      vm.filterDateFrom = null;
      vm.filterDateTo = null;
      $rootScope.pagination_reload();
    }

    function setPageOrder(type) {
      vm.dtOrderApi.page(type).draw('page');
    }
    
    
    /**
    * Toggle selected status of the thread
    *
    * @param thread
    * @param event
    */
    function toggleSelectThread(thread, event) {
        if (event)
        {
            event.stopPropagation();
        }
 
        if (vm.selectedThreads.indexOf(thread) > -1)
        {
            vm.selectedThreads.splice(vm.selectedThreads.indexOf(thread), 1);
        }
        else
        {
            vm.selectedThreads.push(thread);
        }
    }
 
    /**
     * Select threads. If key/value pair given,
     * threads will be tested against them.
     *
     * @param [key]
     * @param [value]
     */
    function selectThreads(key, value) {
        // Make sure the current selection is cleared
        // before trying to select new threads
        vm.selectedThreads = [];
 
        for (var i = 0; i < vm.threads.length; i++)
        {
            if (angular.isUndefined(key) && angular.isUndefined(value))
            {
                vm.selectedThreads.push(vm.threads[i]);
                continue;
            }
 
            if (angular.isDefined(key) && angular.isDefined(value) && vm.threads[i][key] === value)
            {
                vm.selectedThreads.push(vm.threads[i]);
            }
        }
    }
     
    /**
     * Return selected status of the thread
     *
     * @param thread
     * @returns {boolean}
     */
    function isSelected(thread) {
        return vm.selectedThreads.indexOf(thread) > -1;
    }   
    
    /**
     * Deselect threads
     */
    function deselectThreads() {
        vm.selectedThreads = [];
    }
  
    /**
     * Toggle select threads
     */
    function toggleSelectThreads() {
        if (vm.selectedThreads.length > 0)
        {
            vm.deselectThreads();
        }
        else
        {
            vm.selectThreads();
        }
    }
    
    // NEW FUNCTIONS
    function init() {

      if (!vm.initialized)
      {
        vm.initialized = true;
      }
    }



    function initOrder() {
      vm.isLoading = true;
      vm.currentPageOrder = vm.currentPage;
      vm.idOrder = requestContext.getParam("id");
      vm.shippingEdit = false;
      console.log('Load Order #' + vm.idOrder);
      storeService.getOrderFromId({
        siteID: siteID,
        idOrder: vm.idOrder
      }).then(function(response) {
        if (!angular.isUndefined(response.shippings))
        {
          var newShipping = []
          angular.forEach(response.shippings, function(shipping) {
            shipping.deliveryFormatted = vm.convertDate(shipping.delivery_date);
            newShipping.push(shipping);
          })
          response.shippings = newShipping;
          vm.isLoading = false;
        }
        vm.order = response;
      })
    }

    function initDashboard() {
      console.log('Load Dashboard');
      vm.dashboard = Dashboard;

      vm.widget1 = vm.dashboard.widget1;
      vm.widget2 = vm.dashboard.widget2;
      vm.widget3 = vm.dashboard.widget3;
      vm.widget4 = vm.dashboard.widget4;
      vm.widget5 = {
        title: vm.dashboard.widget5.title,
        mainChart: {
          config: {
            refreshDataOnly: true,
            deepWatchData: true
          },
          options: {
            chart: {
              type: 'multiBarChart',
              color: ['#03a9f4', '#b3e5fc'],
              height: 420,
              margin: {
                top: 8,
                right: 16,
                bottom: 32,
                left: 32
              },
              clipEdge: true,
              groupSpacing: 0.3,
              reduceXTicks: false,
              stacked: true,
              duration: 250,
              x: function(d) {
                return d.x;
              },
              y: function(d) {
                return d.y;
              },
              yAxis: {
                tickFormat: function(d) {
                  return d;
                }
              },
              legend: {
                margin: {
                  top: 8,
                  bottom: 32
                }
              },
              controls: {
                margin: {
                  top: 8,
                  bottom: 32
                }
              },
              tooltip: {
                gravity: 's',
                classes: 'gravity-s'
              }
            }
          },
          data: []
        },
        days: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
        ranges: vm.dashboard.widget5.ranges,
        currentRange: '',
        changeRange: function(range) {
          vm.widget5.currentRange = range;

          /**
           * Update main chart data by iterating through the
           * chart dataset and separately adding every single
           * dataset by hand.
           *
           * You MUST NOT swap the entire data object by doing
           * something similar to this:
           * vm.widget.mainChart.data = chartData
           *
           * It would be easier but it won't work with the
           * live updating / animated charts due to how d3
           * works.
           *
           * If you don't need animated / live updating charts,
           * you can simplify these greatly.
           */
          angular.forEach(vm.dashboard.widget5.mainChart, function(chartData, index) {
            vm.widget5.mainChart.data[index] = {
              key: chartData.key,
              values: chartData.values[range]
            };
          });
        },
        init: function() {
          // Run this function once to initialize widget

          /**
           * Update the range for the first time
           */
          vm.widget5.changeRange('TW');
        }
      };

      // Widget 6
      vm.widget6 = {
        title: vm.dashboard.widget6.title,
        mainChart: {
          config: {
            refreshDataOnly: true,
            deepWatchData: true
          },
          options: {
            chart: {
              type: 'pieChart',
              color: ['#f44336', '#9c27b0', '#03a9f4', '#e91e63'],
              height: 400,
              margin: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
              },
              donut: true,
              clipEdge: true,
              cornerRadius: 0,
              labelType: 'percent',
              padAngle: 0.02,
              x: function(d) {
                return d.label;
              },
              y: function(d) {
                return d.value;
              },
              tooltip: {
                gravity: 's',
                classes: 'gravity-s'
              }
            }
          },
          data: []
        },
        footerLeft: vm.dashboard.widget6.footerLeft,
        footerRight: vm.dashboard.widget6.footerRight,
        ranges: vm.dashboard.widget6.ranges,
        currentRange: '',
        changeRange: function(range) {
          vm.widget6.currentRange = range;

          /**
           * Update main chart data by iterating through the
           * chart dataset and separately adding every single
           * dataset by hand.
           *
           * You MUST NOT swap the entire data object by doing
           * something similar to this:
           * vm.widget.mainChart.data = chartData
           *
           * It would be easier but it won't work with the
           * live updating / animated charts due to how d3
           * works.
           *
           * If you don't need animated / live updating charts,
           * you can simplify these greatly.
           */
          angular.forEach(vm.dashboard.widget6.mainChart, function(data, index) {
            vm.widget6.mainChart.data[index] = {
              label: data.label,
              value: data.values[range]
            };
          });
        },
        init: function() {
          // Run this function once to initialize widget

          /**
           * Update the range for the first time
           */
          vm.widget6.changeRange('TW');
        }
      };

      // Widget 7
      vm.widget7 = {
        title: vm.dashboard.widget7.title,
        ranges: vm.dashboard.widget7.ranges,
        customers: vm.dashboard.widget7.customers,
        currentRange: 'T'
      };

      // Methods

      //////////

      // Initialize Widget 5
      vm.widget5.init();

      // Initialize Widget 6
      vm.widget6.init();
    }

    // Watch screen size to change view modes
    $scope.$watch(function() {
      return $mdMedia('lt-sm');
    }, function(current, old) {
      if (angular.equals(current, old))
      {
        return;
      }

      if (current)
      {
        vm.currentView = 'nosplit';
      }
    });

    $scope.$watch(function() {
        return $mdMedia('max-width: 960px');
      }, function(big) {

        if (big)
        {
          vm.currentView = 'nosplit';
        }

      }
    );

    $scope.$watch(function() {
        return $mdMedia('min-width: 960px');
      }, function(small) {

        if (small)
        {
          vm.currentView = 'split';
        }

      }
    );

    $scope.$watch(function() {
      return $mdMedia('gt-sm');
    }, function(current, old) {
      if (angular.equals(current, old))
      {
        return;
      }

      if (current)
      {
        if (vm.defaultView === 'split')
        {
          vm.currentView = 'split';
        }
      }
    });

    $scope.$on('pagination:loadStart', function(event) {
      if (!vm.enterfirst)
      {
        var elem = angular.element(document.getElementById('thread-list'));
        elem.scrollTopAnimated(0, 10);
      }
      vm.enterfirst = false;
      $scope.isLoading = true;
    });

    $scope.$on('pagination:loadPage', function(event) {
      $scope.isLoading = false;
    });

    function showOrderStatus(status) {
      return '<span class="status ' + status.color + '">' + $translate.instant('SHIPPING.' + status.status_name) + '</span>';
    }

    function openOrder(order) {
      var idOrder = order.id_order
      vm.loadingThread = true;
      vm.orderView = 'details';
      $state.go('app.site_overview.store.'+sectionType+'.detail', {
        id: idOrder
      }, {
        notify: false,
        inherit: true,
        location: true
      });
      storeService.getOrderFromId({
        siteID: siteID,
        idOrder: idOrder
      }).then(function(response) {
        if (!angular.isUndefined(response.shippings))
        {
          var newShipping = []
          angular.forEach(response.shippings, function(shipping) {
            shipping.deliveryFormatted = vm.convertDate(shipping.delivery_date);
            newShipping.push(shipping);
          })
          response.shippings = newShipping;
          vm.loadingThread = false;
        }
        vm.order = response;
      })
      vm.selectedThread = true;
      if (idOrder)
      {
          vm.selectedContentID = idOrder;
      }

    }

    function openSubscription(subscription) {
      var id = subscription.id_subscription
      vm.loadingThread = true;
      vm.subscriptionView = 'details';
      $state.go('app.site_overview.store.subscriptions.detail', {
        id: id,
        section: section
      }, {
        notify: false,
        inherit: true,
        location: true
      });
      storeService.getSubscriptionFromId({
        siteID: siteID,
        id: id
      }).then(function(response) {
        /*
        if (!angular.isUndefined(response.shippings))
        {
          var newShipping = []
          angular.forEach(response.shippings, function(shipping) {
            shipping.deliveryFormatted = vm.convertDate(shipping.delivery_date);
            newShipping.push(shipping);
          })
          response.shippings = newShipping;
          vm.loadingThread = false;
        }
        */
        vm.subscription = response;
        vm.loadingThread = false;
      })
      vm.selectedThread = true;
      if (id)
      {
          vm.selectedContentID = id;
      }

    }
    
    function closeThread() {
	    vm.selectedThread = false;
	    vm.loadingThread = false;
	    vm.order = false;
      vm.subscription = false;
    }

    function orderViewInvoice() {
      vm.orderView = 'invoice';
    }

    function orderViewDetails() {
      vm.orderView = 'details';
    }


    function subscriptionViewDetails() {
      vm.subscriptionView = 'details';
    }

    function orderViewHistory() {
      vm.loadingThread = true;
      vm.orderView = 'history';
      $scope.siteID = siteID;
      var options = {
        siteID: $scope.siteID,
        id_user: vm.order.user.id_user,
        sortField: 'id_order',
        sortDir: 'DESC'
      };

      storeService.getOrders(options).then(function(response) {
        vm.order.history = response.data;
        vm.loadingThread = false;
      })
    }

    function subscriptionViewHistory() {
      vm.loadingThread = true;
      vm.subscriptionView = 'history';
      $scope.siteID = siteID;
      var options = {
        siteID: $scope.siteID,
        id_user: vm.subscription.user.id_user,
        sortField: 'id_order',
        sortDir: 'DESC'
      };

      storeService.getOrders(options).then(function(response) {
        vm.subscription.history = response.data;
        vm.loadingThread = false;
      })
    }



    /**
     * Change the view
     *
     * @param view
     */
    function changeView(view) {
        if (vm.views(view)) {
            vm.loadingView = true;
            vm.defaultView = view;
            vm.currentView = view;
        }
    }

    function loginToWebsite(user) {
      usersService.getUserToken({
        siteID: $scope.siteID,
        id: user.id_user
      }).then(function(response) {
        $window.open(vm.loginUrl + response.token, 'website');
      })
    }

  }
})();

(function () {
    'use strict';

    angular
        .module('app.store')
        .service("storeService", store);

    /** @ngInject */
    function store($q, $resource, COMMON) {

        var api = [];

        function get(options) {

            switch (options.section) {
                case 'orders':
                    return getOrders(options);
                    break;
                case 'subscriptions':
                    return getSubscriptions(options);
                    break;
                    /*
                default:
                    var deferred = $q.defer();
                    var response = {data: []};
                    deferred.resolve(response);
                    return (deferred.promise);
                    break;
                    */
            }

        }

        function getOrders(options) {
            var deferred = $q.defer();
            var filters = [];

            _.forEach(options, function (value, key, list) {
                if (_.isObject(list[key])) {
                    _.forEach(list[key], function (filter, keyFilter, listFilter) {
                        if (!_.isEmpty(filter.selected)) {
                            filters.push({
                                field: filter.field,
                                name: filter.name,
                                values: filter.selected
                            });
                        }

                    });

                }
            });

            resourceOrders.get({
                    domain: options.siteID,
                    page: options.page,
                    sectionType: options.storeSectionType, 
                    search: options.searchStringFilter,
                    resultsPerPage: 500,
                    sortField: options.sortField,
                    sortDir: options.sortDir,
                    withFilters: JSON.stringify(filters),
                    id_user: options.id_user,
                    storeDatesFilter: JSON.stringify(options.storeDatesFilter),
                    // lang: get("language")
                },
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }


        var resourceOrders  = $resource(
            COMMON.BASE_API + "/domain/:domain/store/orders", {
                // No default data.
            }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            }
        );


        function getOrderFromId(options) {
            var deferred = $q.defer();
            var filters = [];

            _.forEach(options, function (value, key, list) {
                if (_.isObject(list[key])) {
                    _.forEach(list[key], function (filter, keyFilter, listFilter) {
                        if (!_.isEmpty(filter.selected)) {
                            filters.push({
                                field: filter.field,
                                name: filter.name,
                                values: filter.selected
                            });
                        }

                    });

                }
            });

            resourceOrderId.get({
                    domain: options.siteID,
                    id: options.idOrder,
                },
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function updateShipping(options) {
            var deferred = $q.defer();
            var filters = [];

            resourceShippingUpdate.update({
                    domain: options.siteID,
                    id: options.id,
                    item: options.item
                },
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function updateOrderStatus(options) {
            var deferred = $q.defer();
            var filters = [];

            resourceUpdateOrderStatus.update({
                    domain: options.siteID,
                    id: options.id,
                    status: options.status
                },
                function (response) {
                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function updateShippingStatus(options) {
            var deferred = $q.defer();
            var filters = [];

            resourceUpdateShippingStatus.update({
                    domain: options.siteID,
                    id: options.id,
                    status: options.status
                },
                function (response) {
                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }


        function getSubscriptions(options) {
            var deferred = $q.defer();
            var filters = [];

            _.forEach(options, function (value, key, list) {
                if (_.isObject(list[key])) {
                    _.forEach(list[key], function (filter, keyFilter, listFilter) {
                        if (!_.isEmpty(filter.selected)) {
                            filters.push({
                                field: filter.field,
                                name: filter.name,
                                values: filter.selected
                            });
                        }

                    });

                }
            });


            resourceSubscriptions.get({
                    domain: options.siteID,
                    page: options.page,
                    search: options.searchStringFilter,
                    resultsPerPage: 500,
                    withFilters: JSON.stringify(filters),
                    sortField: options.sortField,
                    sortDir: options.sortDir,
                    id_user: options.id_user,
                    storeDatesFilter: JSON.stringify(options.storeDatesFilter)
                    // lang: get("language")
                },
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }


        function getSubscriptionFromId(options) {
            var deferred = $q.defer();
            var filters = [];

            _.forEach(options, function (value, key, list) {
                if (_.isObject(list[key])) {
                    _.forEach(list[key], function (filter, keyFilter, listFilter) {
                        if (!_.isEmpty(filter.selected)) {
                            filters.push({
                                field: filter.field,
                                name: filter.name,
                                values: filter.selected
                            });
                        }

                    });

                }
            });

            resourceSubscriptions.get({
                    domain: options.siteID,
                    id: options.id,
                },
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }



        var resourceOrderId  = $resource(
            COMMON.BASE_API + "/domain/:domain/store/order/:id", {
                // No default data.
            }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            }
        );

        var resourceShippingUpdate= $resource(

            COMMON.BASE_API + "/domain/:domain/store/shipping/:id", {
                domain: '@domain',
                name: '@name',
                id: '@id',
            }, {
                update: {
                    method: "PUT",
                    isArray: false
                }
            }
        );

        var resourceUpdateOrderStatus= $resource(

            COMMON.BASE_API + "/domain/:domain/store/order/status/:id", {
                domain: '@domain',
                name: '@name',
                id: '@id',
            }, {
                update: {
                    method: "PUT",
                    isArray: false
                }
            }
        );

        var resourceUpdateShippingStatus= $resource(

            COMMON.BASE_API + "/domain/:domain/store/shipping/status/:id", {
                domain: '@domain',
                name: '@name',
                id: '@id',
            }, {
                update: {
                    method: "PUT",
                    isArray: false
                }
            }
        );

        function getOptions(options) {
            var deferred = $q.defer();


            resourceOptions.get({
                    domain: options.site,
                    section: options.section,
                    sectionType: options.sectionType
                },
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getSettings(options) {
            var deferred = $q.defer();


            resourceSettings.get({
                    domain: options.site,
                },
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        var resourceOptions = $resource(
            COMMON.BASE_API + "/domain/:domain/store/options", {
                // No default data.
                section: '@section',
            }, {
                get: {
                    method: "GET",
                    // isArray: true
                }
            }
        );

        var resourceSettings = $resource(
            COMMON.BASE_API + "/domain/:domain/store/settings", {
                // No default data.
            }, {
                get: {
                    method: "GET",
                    // isArray: true
                }
            }
        );

        var resourceSubscriptions  = $resource(
            COMMON.BASE_API + "/domain/:domain/store/subscriptions/:id", {
                id_user: '@id_user'
                // No default data.
            }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            }
        );


        // Return the public API.
        return ({
            get: get,
            getOrders: getOrders,
            getOrderFromId: getOrderFromId,
            getFilters: getOptions,
            getSettings: getSettings,
            updateShipping: updateShipping,
            updateOrderStatus: updateOrderStatus,
            getSubscriptions: getSubscriptions,
            getSubscriptionFromId: getSubscriptionFromId
        });


    }


})();

(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('ScrumboardController', ScrumboardController);

    /** @ngInject */
    function ScrumboardController($mdSidenav, BoardService, BoardList, CardFilters)
    {
        var vm = this;

        // Data
        vm.currentView = 'board';
        vm.board = BoardService.data;
        vm.boardList = BoardList.data;
        vm.boardSelectorVisible = false;

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.updateBoardUri = updateBoardUri;
        vm.clearFilters = CardFilters.clear;
        vm.filteringIsOn = CardFilters.isOn;

        ////////

        /**
         * Update Board Uri
         *
         * Once you connect your app to your server,
         * you would do this on your API server.
         */
        function updateBoardUri()
        {
            if ( vm.boardList.getById(vm.board.id) )
            {
                vm.boardList.getById(vm.board.id).name = vm.board.name;
                vm.boardList.getById(vm.board.id).uri = vm.board.uri = encodeURIComponent(vm.board.name).replace(/%20/g, '-').toLowerCase();
            }
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Array prototype
         *
         * Get by id
         *
         * @param value
         * @returns {T}
         */
        Array.prototype.getById = function (value)
        {
            return this.filter(function (x)
            {
                return x.id === value;
            })[0];
        };

    }
})();
(function () {
    'use strict';

    angular
        .module('app.users')
        .service('RuntagService', RuntagService);

    /** @ngInject */
    // I provide access to the session store.
    function RuntagService($rootScope, $q, $resource, $stateParams, COMMON ) {

        function getSales(options){
            var deferred = $q.defer();
            let resource = resourceGetSales;
            if(options.per){
                switch(options.per){
                    case 'currency':
                        resource = resourceGetSalesPerCurrency;
                        break;
                    case 'ev':
                        resource = resourceGetSalesPerEvent;
                        break;
                }
            }
            resource.get({
                domain: options.domain,
                client_id: options.client_id,
                event_id: options.event_id,
                from: options.from,
                to: options.to,
                product_type_id: options.product_type_id,
                payment_method_id: options.payment_method_id,
                requires_revision: options.requires_revision,
                resultsPerPage: options.resultsPerPage,
                page: options.page,
                search: options.search,
                sortField: options.sortField,
                sortDir: options.sortDir
            },
            function(response){
                if(response.result){
                    deferred.resolve(response.result);
                }else{
                    deferred.resolve(response);
                }
            },
            function(e){
                    console.error("¡¡¡ERROR!!!");
                    console.error(e);
                    deferred.reject();
                }
            )
            return(deferred.promise);
        }

        var resourceGetSales = $resource(
            `${COMMON.BASE_API}/domain/:domain/sales`,{
            },{
                get: {
                    method: "GET",
                    isArray: false
                }
            }
        );
        var resourceGetSalesPerEvent = $resource(
            `${COMMON.BASE_API}/domain/:domain/sales/perEvent`,{
            },{
                get: {
                    method: "GET",
                    isArray: true
                }
            }
        );
        var resourceGetSalesPerCurrency = $resource(
            `${COMMON.BASE_API}/domain/:domain/sales/perCurrency`,{
            },{
                get: {
                    method: "GET",
                    isArray: false
                }
            }
        );

        function getSection(options){
            var deferred = $q.defer();
            resourceGetSection.get({
                domain:         options.domain,
                section:        options.section,
                filters:        JSON.stringify(options.filters),
                resultsPerPage: options.resultsPerPage || 10,
                page:           options.page,
                resultSumField: options.resultSumField,
                groupBy:        options.groupBy,
                sumPerGroup:    options.sumPerGroup
            },
            function(response){
                if(response.result){
                    deferred.resolve(response.result);
                }else{
                    deferred.resolve(response);
                }
            },
            function(e) {
                    console.error("¡¡¡ERROR!!!");
                    console.error(e);
                    deferred.reject();
                }
            );
            return(deferred.promise);
        }

        var resourceGetSection = $resource(
            `${COMMON.BASE_API}/domain/:domain/content/:section`,{
            },{
                get: {
                    method: "GET",
                    isArray: false
                }
            }
        )
        
        function createPaymentBreakdown(options){
            var deferred = $q.defer();

            resourceCreatePaymentBreakdown.post({
                    domain: options.domain,
                    date_from: options.date_from,
                    date_to: options.date_to,
                    id_client: options.id_client,
                    id_event: options.id_event,
                    force_first_settlement: options.force_first_settlement
                },
                function(response){
                    deferred.resolve(response);
                },
                function(e){
                    console.error(e);
                    deferred.reject();
                }
            );

            return(deferred.promise);
        }
        
        var resourceCreatePaymentBreakdown = $resource(
            `${COMMON.BASE_API}/domain/:domain/runtag_settlement`,{
                domain: '@domain'
            },{
                post: {
                    method: "POST" 
                }
            }
        );

        function getSectionFilters(options){
            var deferred = $q.defer();

            resourceGetSectionFilters.get({
                    domain: options.domain,
                    section: options.section
                },
                function(response){
                    deferred.resolve(response);
                },
                function(e){
                    console.error(e);
                    deferred.reject();
                }
            );

            return(deferred.promise);
        }

        var resourceGetSectionFilters = $resource(
            `${COMMON.BASE_API}/domain/:domain/content/:section/options`,{
            },{
                get: {
                    method: "GET",
                    isArray: false
                }
            }
        )

        return({
            getSection: getSection,
            getSectionFilters: getSectionFilters,
            createPaymentBreakdown: createPaymentBreakdown,
            getSales: getSales
        });

    }
})();
/**
 * MODULE TEMPLATE - Boilerplate for new Qiu Modules
 * 
 * INSTRUCTIONS FOR FUTURE AI / DEVELOPERS:
 * 1. Duplicate this folder to create a new module (e.g., 'news-module').
 * 2. Find and replace all instances of 'module-template' / 'ModuleTemplate' with your new module name.
 * 3. Register the new module in src/app/index.module.js.
 * 4. This file handles the AngularJS module registration and routing (state) definitions.
 * 5. Ensure the state hierarchy (app.site_overview.*) is maintained for proper dynamic navigation.
 */
(function () {
    'use strict';

    angular
        .module('app.module-template', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // Base State
        $stateProvider.state('app.module-template', {
            url: '/module-template',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/module-template/module-template.html',
                    controller: 'ModuleTemplateController as vm'
                }
            },
            bodyClass: 'module-template'
        });

        // Site Overview Hierarchy (Dynamic Navigation)
        $stateProvider
            .state('app.site_overview.template', {
                abstract: true,
                url: '/template'
            })
            .state('app.site_overview.template.module_template', {
                url: '/list',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/module-template/module-template.html',
                        controller: 'ModuleTemplateController as vm'
                    }
                },
                bodyClass: 'module-template'
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/module-template');

        // Navigation (Example registration - uncomment to show in sidebar)
        /*
        msNavigationServiceProvider.saveItem('apps.module-template', {
            title: 'Module Template',
            icon: 'icon-tile-four',
            state: 'app.module-template',
            weight: 10
        });
        */
    }
})();

/**
 * MODULE TEMPLATE - Service
 * 
 * INSTRUCTIONS FOR FUTURE AI / DEVELOPERS:
 * 1. This factory handles all API communications for the module.
 * 2. It follows the Qiu standard service pattern (getItems, getItemById, saveItem, deleteItem).
 * 3. Use msApi.resolve() or $http for requests.
 * 4. Update the factory name and endpoints when duplicating this template.
 */
(function () {
    'use strict';

    angular
        .module('app.module-template')
        .factory('moduleTemplateService', moduleTemplateService);

    /** @ngInject */
    function moduleTemplateService($http, msApi) {
        var service = {
            getItems: getItems,
            getItemById: getItemById,
            saveItem: saveItem,
            deleteItem: deleteItem
        };

        return service;

        //////////

        function getItems() {
            // return $http.get('/api/module-template');
            // Or use msApi if registered
            // return msApi.resolve('module-template@get');
            return Promise.resolve({ data: [] });
        }

        function getItemById(id) {
            // return $http.get('/api/module-template/' + id);
            return Promise.resolve({ data: {} });
        }

        function saveItem(item) {
            if (item.id) {
                // return $http.put('/api/module-template/' + item.id, item);
            } else {
                // return $http.post('/api/module-template', item);
            }
            return Promise.resolve({ data: item });
        }

        function deleteItem(id) {
            // return $http.delete('/api/module-template/' + id);
            return Promise.resolve({ success: true });
        }
    }
})();

/**
 * MODULE TEMPLATE - Controller
 * 
 * INSTRUCTIONS FOR FUTURE AI / DEVELOPERS:
 * 1. This controller manages the View-Model (VM) for the module.
 * 2. It implements the Master-Detail (Split View) logic using vm.currentLayout.
 * 3. It handles search, pagination placeholders, and item selection.
 * 4. When duplicating, update the controller name and all service references.
 */
(function () {
    'use strict';

    angular
        .module('app.module-template')
        .controller('ModuleTemplateController', ModuleTemplateController);

    /** @ngInject */
    function ModuleTemplateController($mdSidenav, $mdDialog, moduleTemplateService) {
        var vm = this;

        // Data
        vm.currentLayout = 'nosplit';
        vm.currentCategory = 'News';
        vm.currentSection = 'NEWS';
        vm.categories = ['News', 'Top stories', 'Cases mueva', 'About us', 'Serie', 'Classes'];
        
        vm.selectedItem = null;
        
        vm.items = [
            {
                id: 1,
                date: 'this is the date',
                title: 'this is the title',
                type: 'this is the short text',
                description: 'this is the description',
                image: '',
                lang: 'en',
                active: true,
                Thumbnail: [
                    {
                        filename: 'placeholder.jpg'
                    }
                ]
            }
        ];

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.selectItem = selectItem;
        vm.filterByCategory = filterByCategory;
        vm.toggleLayout = toggleLayout;

        //////////

        /**
         * Toggle between split and nosplit layout
         */
        function toggleLayout() {
            vm.currentLayout = (vm.currentLayout === 'split') ? 'nosplit' : 'split';
        }

        /**
         * Select an item for the split view detail pane
         * @param item
         */
        function selectItem(item) {
            vm.selectedItem = item;
            if (vm.currentLayout === 'nosplit') {
                vm.currentLayout = 'split';
            }
            console.log("Selected item:", item);
        }

        /**
         * Toggle Sidenav
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Filter by category
         * @param category
         */
        function filterByCategory(category) {
            vm.currentCategory = category;
            vm.currentSection = category.toUpperCase();
        }

        /**
         * New Item Placeholder
         */
        function newItem(ev) {
            console.log("Creating new item...");
            // Trigger logic...
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('app.mediahub')
    .directive('qiuOnCheckSetBasicFormDirty', ['mediaService', SetBasicFormDirty])
    .controller('MediahubController', MediahubController);

  function SetBasicFormDirty(mediaService) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        $(element).on('click', function (e) {
          mediaService.triggerSetBasicFormDirty();
        });
      }
    };
  }

  /** @ngInject */
  function MediahubController(
    $stateParams, $state, $scope, $rootScope, $timeout,
    settingUserService, sessionService, $translate,
    mediahubService, mediaService, $log, $q, $mdSidenav, $document, $mdDialog,
    msUtils, $mdToast, $cookies, $http, $mdMedia, requestContext, $location, $window,
    tagsService, ivhTreeviewMgr, ivhTreeviewOptions
  ) {
    var vm = this;
    vm.$mdMedia = $mdMedia;
    $scope.siteID = $stateParams.siteId || $state.params.siteId || requestContext.getParam('siteId');

    // Check if we have an ID in the URL path as a fallback
    var pathParts = $location.path().split('/');
    var lastPathPart = pathParts[pathParts.length - 1];
    var idFromPath = (lastPathPart && /^\d+$/.test(lastPathPart)) ? lastPathPart : null;

    // Data
    vm.image = null;
    vm.items = [];
    vm.galleries = [];
    vm.CleanMediaGalleries = [];
    vm.CleanMediaGalleriesWithMediaAssignment = [];
    vm.selectedGallery = null;
    vm.selectedThreads = [];
    vm.loadingGalleries = false;
    vm.isLoading = true;
    vm.mediaSelected = !!($stateParams.id || $state.params.id || idFromPath);
    vm.mediaSelectedLoaded = false;
    vm.basicForm = {}; // Handles form validity if needed
    vm.authToken = null;
    vm.resultsPerPage = 50; // Default results per page
    vm.pagination = null;
    vm.searchedItems = null;
    vm.pageTokens = {}; // Cache for Vertex nextPageToken strings <!-- page-index: token-to-get-that-page -->

    // Settings / View State
    vm.media_type_name = ($stateParams.mediaType && $stateParams.mediaType.trim())
      ? $stateParams.mediaType.trim()
      : 'all';

    vm.media_type = null;
    var mt = vm.media_type_name.toLowerCase();
    if (mt === 'photos' || mt === 'photo' || mt === 'mediahub photos') {
      vm.media_type = 1;
    } else if (mt === 'videos' || mt === 'video' || mt === 'mediahub videos') {
      vm.media_type = 2;
    }

    vm.settingsSection = 'mediahub-' + vm.media_type_name;
    vm.currentView = 'split'; // 'split' or 'nosplit'
    $scope.perPagePresets = [10, 20, 50, 100];

    // View modes
    vm.views = {
      nosplit: 'app/main/apps/mediahub/views/nosplit-view.html',
      split: 'app/main/apps/mediahub/views/split-view.html'
    };

    vm.viewslist = {
      gridGoogle: 3,
      list: 2,
      grid: 1
    };

    vm.subviews = {
      1: 'app/main/apps/mediahub/views/list/subviews/photos-view.html',
      2: 'app/main/apps/mediahub/views/list/subviews/videos-view.html',
      3: 'app/main/apps/mediahub/views/list/subviews/audios-view.html',
      4: 'app/main/apps/mediahub/views/list/subviews/files-view.html',
      list: 'app/main/apps/mediahub/views/list/subviews/list-view.html',
      upload: 'app/main/apps/mediahub/views/list/subviews/upload-view.html',
      import: 'app/main/apps/mediahub/views/list/subviews/import-view.html'
    };

    // Load settings
    vm.isOpenSidenavGalleries = settingUserService.getSettingValue(vm.settingsSection, 'sidenavGalleriesOpen', true);
    vm.defaultListView = settingUserService.getSettingValue(vm.settingsSection, 'defaultView', "grid");
    vm.currentListView = vm.defaultListView;
    vm.perPage = settingUserService.getSettingValue(vm.settingsSection, 'pageSize', 50);
    $rootScope.perPage = vm.perPage;


    // Sort settings
    vm.orderByGalleries = { 'NAME': 'name' };
    vm.sortDirGalleries = 'DESC';
    vm.sortFieldGalleries = 'name';

    vm.refSortables = [
      { titleId: 'fileDate', name: 'File Date' },
      { titleId: 'originalFileName', name: 'Filename' }
    ];
    // Fields exposed as sortable during a Vertex text search. Kept empty on purpose:
    // Vertex text search runs by relevance only (the date orderBy isn't reliably
    // available across tenants). Add 'fileDate' here to re-enable date sorting once
    // the datastore schema exposes created_at as indexable everywhere.
    vm.vertexSortableFields = [];
    // Effective sort selected for the current Vertex text search ('relevance' | 'fileDate').
    vm.vertexSortField = null;
    // Set once we learn this tenant's datastore can't order by date (orderBy → HTTP 400).
    // From then on we don't offer/attempt the date sort, we search straight by relevance.
    vm.vertexOrderByUnsupported = false;

    // Stable references so ng-repeat doesn't recreate items every digest.
    var RELEVANCE_SORT = { titleId: 'relevance', name: 'Relevance' };
    var VERTEX_SORTABLES = [RELEVANCE_SORT].concat(vm.refSortables.filter(function (f) {
      return vm.vertexSortableFields.indexOf(f.titleId) !== -1;
    }));
    var VERTEX_SORTABLES_RELEVANCE_ONLY = [RELEVANCE_SORT];

    // Sort options to show for the current context: all of them while browsing;
    // while a text search is active, only what Vertex supports — "Relevance" (no
    // orderBy) plus the Vertex-sortable fields (date).
    vm.getSortables = function () {
      if (vm.vertexUrl && vm.searchQuery) {
        // If this tenant can't order by date, only relevance is available.
        return vm.vertexOrderByUnsupported ? VERTEX_SORTABLES_RELEVANCE_ONLY : VERTEX_SORTABLES;
      }
      return vm.refSortables;
    };

    // Which sort option is currently active (drives the checkmark in the menu).
    // During a Vertex text search this tracks vm.vertexSortField, not the persisted
    // browse setting (which the Vertex order may differ from, e.g. after a fallback).
    vm.isSortActive = function (sortfield) {
      var inGallery = (vm.media_type_name == 'galleries' || vm.selectedGallery);
      if (vm.vertexUrl && vm.searchQuery) {
        var active = vm.vertexSortField;
        if (!active) {
          var persisted = settingUserService.getSettingValue(vm.settingsSection, inGallery ? 'sortFieldInGallery' : 'sortField', 'fileDate');
          active = (vm.vertexSortableFields.indexOf(persisted) !== -1) ? persisted : 'relevance';
        }
        return sortfield.titleId === active;
      }
      // $rootScope.sortField is what actually went into the request, and it is not always the
      // user's saved preference: opening a gallery that carries its own order overrides it for
      // that gallery. Reading the setting here made the menu tick an order that was not the one
      // on screen. The setting stays as the fallback for before anything has been applied.
      return sortfield.titleId === ($rootScope.sortField ||
        settingUserService.getSettingValue(vm.settingsSection, inGallery ? 'sortFieldInGallery' : 'sortField', 'fileDate'));
    };

    // Whether the ASC/DESC direction toggle is meaningful. During a Vertex text search
    // it only applies to a directional (date) sort; relevance has no direction.
    vm.isSortDirEnabled = function () {
      if (vm.vertexUrl && vm.searchQuery) {
        return vm.vertexSortField === 'fileDate';
      }
      return true;
    };

    // True while a Vertex text search is active. Used to hide controls that don't apply
    // to Vertex results (filters sidenav, settings, sort direction, …).
    vm.isVertexSearch = function () {
      return !!(vm.vertexUrl && vm.searchQuery);
    };
    vm.modelSearch = '';

    // Migración de sorts antiguos a los nuevos campos. Los usuarios con un
    // sortField/sortFieldInGallery guardado de antes (id_media, date_uploaded,
    // file_date, fileName) se reescriben al nuevo valor para que no envíen un
    // campo de orden ya inexistente.
    var LEGACY_SORT_FIELD_MAP = {
      'id_media': 'fileDate',
      'date_uploaded': 'fileDate',
      'file_date': 'fileDate',
      'fileName': 'originalFileName'
    };
    function migrateLegacySortSetting(property) {
      var stored = settingUserService.getSettingValue(vm.settingsSection, property, null);
      if (stored && LEGACY_SORT_FIELD_MAP[stored]) {
        settingUserService.setSetting(vm.settingsSection, property, LEGACY_SORT_FIELD_MAP[stored]);
      }
    }
    migrateLegacySortSetting('sortField');
    migrateLegacySortSetting('sortFieldInGallery');

    // Initialize $rootScope sort parameters from settings or defaults
    $rootScope.sortDir = settingUserService.getSettingValue(vm.settingsSection, 'sortDir', 'DESC');
    $rootScope.sortField = settingUserService.getSettingValue(vm.settingsSection, 'sortField', 'fileDate');

    // Search / Tree
    vm.showTreeSearch = false;
    vm.treeSearch = null;
    vm.collapseAndExpand = {
      'MEDIA.COLLAPSE': 'collapse_all',
      'MEDIA.EXPAND': 'expand_all'
    };
    vm.collapseAndExpandFunction = collapseAndExpandFunction;
    vm.expandedids = [];

    // --- Methods ---

    vm.setNewPerPageSize = function (size) {
      vm.perPage = size;
      $rootScope.perPage = size;
      settingUserService.setSetting(vm.settingsSection, 'pageSize', size);
      $rootScope.pagination_reload && $rootScope.pagination_reload();
    };

    vm.logResize = function () { };
    vm.getCleanMediaGalleries = loadGalleries;
    vm.expandGalleries = function () { };
    vm.expandAllGalleries = expandAllGalleries;
    vm.collapseAllGalleries = collapseAllGalleries;
    vm.openUrl = msUtils.openUrl;
    vm.getExtensionIcon = msUtils.getExtensionIcon;
    vm.openImageDialog = openImageDialog;
    vm.copyLink = copyLink;
    vm.tags = sessionService.site_operative.tags;
    vm.searchTagText = null;
    vm.selectedTag = null;
    vm.newTagDisabled = false;

    // Sorting functions for toolbar
    vm.getSettingValue = settingUserService.getSettingValue;
    vm.setSortField = setSortField;
    vm.setSortDir = setSortDir;
    vm.pagination_url = 'http://';
    vm.pagination_search = pagination_search;
    vm.resetSearch = resetSearch;

    function pagination_search(query) {
      if (vm.vertexUrl && query) {
        // A Vertex text search spans the whole tenant, so leave any selected gallery
        // (without its own reload — performSearch loads the results).
        if (vm.selectedGallery) {
          vm.selectedGallery = false;
          $rootScope.pagination_galleryIds = false;
          vm.selectedThreads = [];
        }
        vm.searchQuery = true;
        vm.modelSearch = query;
        // Search straight by relevance (natural for a text query and never triggers an
        // unsupported orderBy). Date is an explicit opt-in from the sort menu.
        vm.vertexSortField = 'relevance';
        vm.performSearch(1);
        return;
      }

      vm.searchQuery = true;
      var pageWasOne = ($rootScope.pagination_page === 1);

      // Update global search state
      $rootScope.pagination_searchstring = query;
      $rootScope.pagination_searchquery = !!query;
      $rootScope.pagination_page = 1;

      $log.debug('[mediahub] Triggering search:', query);

      // Only broadcast if the page was already 1.
      // If page was NOT 1, changing it above will trigger the internal directive watcher reload automatically.
      if (pageWasOne) {
        $log.debug('[mediahub] Page was 1, manual reload broadcast required.');
        $rootScope.$broadcast('pagination:reload', {
          query: query
        });
      } else {
        $log.debug('[mediahub] Page was not 1, internal watcher will handle the reload.');
      }
    }

    // Clear the (Vertex) text-search state WITHOUT reloading. Callers that navigate
    // elsewhere (e.g. selecting a gallery) reuse this and trigger their own reload.
    function clearSearchState() {
      vm.modelSearch = '';
      vm.searchQuery = false;
      vm.searchedItems = null;
      vm.pagination = null;
      vm.pageTokens = {};
      vm.vertexSortField = null;
      $rootScope.pagination_searchstring = "";
      $rootScope.pagination_searchquery = false;
    }
    vm.clearSearchState = clearSearchState;

    function resetSearch() {
      clearSearchState();
      $rootScope.pagination_page = 1;

      // Now reset the URL. Page is already 1.
      vm.pagination_url = 'http://';

      // Trigger reload to clear search results
      $rootScope.$broadcast('pagination:reload', {
        query: ''
      });

      if ($rootScope.pagination_resetquery) {
        $rootScope.pagination_resetquery();
      }
    }

    function setSortField(field) {
      // "relevance" is a Vertex-search-only mode; never persist it as the browse sort.
      if (field === 'relevance') {
        if (vm.vertexUrl && vm.searchQuery) {
          vm.vertexSortField = 'relevance';
          vm.pageTokens = {};
          vm.performSearch(1);
        }
        return;
      }
      if (vm.media_type_name == 'galleries' || vm.selectedGallery) {
        settingUserService.setSetting(vm.settingsSection, 'sortFieldInGallery', field);
      } else {
        settingUserService.setSetting(vm.settingsSection, 'sortField', field);
      }
      $rootScope.sortField = field;
      // During a Vertex text search, re-run the search with the new sort instead of
      // falling back to the normal listing (which silently discarded the search).
      if (vm.vertexUrl && vm.searchQuery) {
        vm.vertexSortField = field;
        vm.pageTokens = {};
        vm.performSearch(1);
        return;
      }
      if ($rootScope.pagination_setSortField) {
        $rootScope.pagination_setSortField(field);
      }
    }

    function setSortDir(dir) {
      if (vm.media_type_name == 'galleries' || vm.selectedGallery) {
        settingUserService.setSetting(vm.settingsSection, 'sortDirInGallery', dir);
      } else {
        settingUserService.setSetting(vm.settingsSection, 'sortDir', dir);
      }
      $rootScope.sortDir = dir;
      // See setSortField: re-run the Vertex search with the new sort.
      if (vm.vertexUrl && vm.searchQuery) {
        vm.pageTokens = {};
        vm.performSearch(1);
        return;
      }
      if ($rootScope.pagination_setSortDir) {
        $rootScope.pagination_setSortDir(dir);
      }
    }

    // Sidenavs
    vm.cancelMediaGalleries = function () {
      settingUserService.setSetting(vm.settingsSection, 'sidenavGalleriesOpen', false);
      vm.isOpenSidenavGalleries = false;
      vm.toggleSidenav('galleries-sidenav');
    };

    vm.openGallerySidenav = function () {
      settingUserService.setSetting(vm.settingsSection, 'sidenavGalleriesOpen', true);
      vm.isOpenSidenavGalleries = true;
      vm.toggleSidenav('galleries-sidenav');
    };

    vm.toggleSidenav = function (sidenavId) {
      $mdSidenav(sidenavId).toggle().then(function () {
        $scope.showSidenav = $mdSidenav(sidenavId).isOpen();
      });
    };

    vm.closeSidenav = function () {
      $mdSidenav('galleries-sidenav').close();
    };

    // View Switching
    vm.changeListView = function (view) {
      vm.isLoading = true;
      $timeout(function () {
        if (vm.viewslist[view]) {
          settingUserService.setSetting(vm.settingsSection, 'defaultView', view);
          vm.loadingListView = true;
          vm.defaultListView = view;
          vm.currentListView = view;
        }
        vm.isLoading = false;
      }, 500);
    };

    // Selection / Detail
    vm.selectMediaFile = selectMediaFile;
    vm.closeMediaPreview = closeMediaPreview;
    vm.showCropformatsTab = showCropformatsTab;
    vm.createGallery = createGallery;
    vm.toggleSelectThread = toggleSelectThread;
    vm.toggleSelectThreads = toggleSelectThreads;
    vm.isSelected = isSelected;
    vm.deleteMediaFromGallery = deleteMediaFromGallery;
    vm.createMediaInGallery = createMediaInGallery;
    vm.AddMediaItemToGalleryDialog = AddMediaItemToGalleryDialog;
    vm.RemoveMediaItemFromGalleryDialog = RemoveMediaItemFromGalleryDialog;
    vm.deleteMediaItem = deleteMediaItem;
    vm.openUploadDialog = openUploadDialog;
    vm.openMediahubSettings = openMediahubSettings;
    vm.openGalleryDialog = openGalleryDialog;
    vm.saveImage = saveImage;
    vm.updateDatePicker = updateDatePicker;
    vm.translate = translate;
    vm.MediaItemRecropAllFormats = MediaItemRecropAllFormats;
    vm.downloadSelected = downloadSelected;
    vm.batchJobs = [];
    vm.downloadBatchJob = downloadBatchJob;
    vm.dismissBatchJob = dismissBatchJob;
    vm.labelQuerySearch = labelQuerySearch;
    vm.newTag = newTag;
    vm.selectedItemChange = selectedItemChange;
    vm.createFilterFor = createFilterFor;
    vm.getTagsTypes = getTagsTypes;
    vm.EditMultipleFieldsDialog = EditMultipleFieldsDialog;

    // Gallery Selection
    vm.handleGallerySelect = function (item) {
      // Selecting a gallery leaves any active Vertex text search so the gallery loads
      // through the normal listing (full sort menu, filters/settings back, etc.).
      if (vm.searchQuery) {
        clearSearchState();
      }
      // Keep the whole gallery node (gallery_type, is_qiu_restricted, children, …) and
      // map the name: mediahub galleries come from the API as `name`, but the selected-
      // gallery bar binds `gallery_name`.
      vm.selectedGallery = angular.extend({}, item, {
        id_gallery: item.id,
        gallery_name: item.gallery_name || item.name
      });
      vm.unselectGalleries(true); // reset other filters but keep gallery
      applyGalleryDefaultSort(item);
      // Set before requesting: requestRange reads pagination_galleryIds off $rootScope.
      $rootScope.pagination_galleryIds = [item.id];

      // On mobile, auto-hide the sidenav after selection
      if ($mdMedia('xs') || $mdMedia('sm')) {
        vm.closeSidenav();
      }

      reloadFirstPage();
    };

    /**
     * Loads page 1 of the current selection with exactly ONE request.
     *
     * Setting `pagination_page` fires the directive's own watcher, which requests on its own —
     * so doing that AND calling `pagination_reload()` produced two identical calls the first time
     * a gallery was opened (page went undefined → 1; afterwards it was already 1 and the watcher
     * stayed quiet, which is why it only showed up on the first open).
     *
     * `pagination_setSortField` is the directive's own way in: it raises the `preventFiltering`
     * guard, resets to page 1 and issues the request itself — the same pattern every sort control
     * in that directive uses. The guard is lowered again when the response lands.
     *
     * The fallback keeps the old behaviour for any consumer that lacks the newer helper.
     */
    function reloadFirstPage() {
      if ($rootScope.pagination_setSortField) {
        $rootScope.pagination_setSortField($rootScope.sortField, $rootScope.sortDir);
        return;
      }
      $rootScope.pagination_page = 1;
      if ($rootScope.pagination_reload) $rootScope.pagination_reload();
    }

    /**
     * Opens a gallery in the order it was configured with.
     *
     * The API only falls back to a gallery's stored `defaultSort` when the client sends NO sort at
     * all, and this admin always sends `sortField`/`sortDir` (from the user's saved preference).
     * So the gallery's order has to be applied here, by seeding those controls from it — otherwise
     * configuring a gallery order in the dialog would have no visible effect in the admin.
     *
     * Only on entering the gallery: once inside, any sort the user picks is theirs and stands.
     * Not written to their saved preference either — it belongs to the gallery, not to them.
     *
     * @param {object} gallery - the selected gallery node, as returned by the API
     */
    function applyGalleryDefaultSort(gallery) {
      var token = gallery && gallery.defaultSort;
      var parsed = /^(.+)_(asc|desc)$/.exec(token || '');

      if (parsed) {
        $rootScope.sortField = parsed[1];
        $rootScope.sortDir = parsed[2].toUpperCase();
        return;
      }

      // No order configured: back to the user's own preference. Without this, the previous
      // gallery's order would leak into this one and look like it had been configured too.
      $rootScope.sortField = settingUserService.getSettingValue(
        vm.settingsSection, 'sortFieldInGallery', 'fileDate');
      $rootScope.sortDir = settingUserService.getSettingValue(
        vm.settingsSection, 'sortDirInGallery', 'DESC');
    }

    vm.unselectGalleries = function (keepGallery) {
      if (!keepGallery) {
        vm.selectedGallery = false;
        $rootScope.pagination_galleryIds = false;
      }

      vm.mediaSelected = false;
      vm.image = null;
      vm.selectedThreads = [];

      // Reset sort to defaults based on current context (Global vs Gallery)
      var sortDirKey = (vm.media_type_name == 'galleries' || vm.selectedGallery) ? 'sortDirInGallery' : 'sortDir';
      var sortFieldKey = (vm.media_type_name == 'galleries' || vm.selectedGallery) ? 'sortFieldInGallery' : 'sortField';

      // Use current $rootScope value if available (user selection), otherwise load from settings
      $rootScope.sortDir = $rootScope.sortDir || settingUserService.getSettingValue(vm.settingsSection, sortDirKey, 'DESC');
      $rootScope.sortField = $rootScope.sortField || settingUserService.getSettingValue(vm.settingsSection, sortFieldKey, 'fileDate');

      if (!keepGallery) {
        // Reload all
        $rootScope.pagination_reload && $rootScope.pagination_reload();
      }
    };

    /**
     * Drag & Drop Handler
     * Assigned to $rootScope because the directive expects it there (legacy behavior)
     */
    vm.dropToGallery = function (targetGalleryId) {
      if (!vm.selectedThreads || vm.selectedThreads.length === 0) {
        return;
      }

      var sourceGalleryId = vm.selectedGallery ? vm.selectedGallery.id_gallery : null;

      // If source is the same as target, do nothing
      if (sourceGalleryId == targetGalleryId) {
        return;
      }

      if (vm.selectedGallery) {
        showCustomMoveCopyDialog(targetGalleryId, sourceGalleryId);
      } else {
        // If no source gallery (e.g. All Media), default to Copy (Add to gallery)
        copyItemsToGallery(targetGalleryId);
      }
    };

    // Override global handler for this controller's lifecycle
    var originalDropToGallery = $rootScope.dropToGallery;
    $rootScope.dropToGallery = vm.dropToGallery;

    $scope.$on('$destroy', function () {
      $rootScope.dropToGallery = originalDropToGallery;
    });

    function showMoveOrCopyDialog(targetGalleryId, sourceGalleryId) {
      var confirm = $mdDialog.confirm()
        .title($translate.instant('MEDIA.DND_CONFIRM_TITLE'))
        .textContent($translate.instant('MEDIA.DND_CONFIRM_CONTENT'))
        .ariaLabel('Move or Copy')
        .ok($translate.instant('MEDIA.MOVE'))
        .cancel($translate.instant('MEDIA.COPY'));

      $mdDialog.show(confirm).then(function () {
        // User clicked MOVE
        moveItemsToGallery(targetGalleryId, sourceGalleryId);
      }, function () {
        // User clicked COPY (or cancelled, but in this confirm implementation cancel is the second action)
        // Note: mdDialog.confirm cancel usually means "Right button". 
        // We want a way to actually cancel (do nothing).
        // A custom dialog might be better if we want [Move] [Copy] [Cancel].
        // But standard confirm only has 2 buttons.
        // Let's implement a custom dialog or use a prompt. 
        // Actually, simplest is to use show() with a custom template or controller, 
        // but for now let's assume standard behavior:
        // "OK" = Move, "Cancel" = Copy.
        // DO WE WANT TO CANCEL? Standard UI usually allows cancelling drag.
        // If user clicks outside, it cancels.
        // So we need to distinguish "Copy" from "Cancel".

        // Re-implementing with a custom dialog to allow Cancel.
        showCustomMoveCopyDialog(targetGalleryId, sourceGalleryId);
      });
    }

    function showCustomMoveCopyDialog(targetGalleryId, sourceGalleryId) {
      $mdDialog.show({
        parent: angular.element(document.body),
        template:
          '<md-dialog aria-label="Move or Copy">' +
          '  <form>' +
          '    <md-dialog-content class="md-dialog-content">' +
          '      <h2 class="md-title" translate="MEDIA.DND_CONFIRM_TITLE"></h2>' +
          '      <div class="md-dialog-content-body">' +
          '        <p translate="MEDIA.DND_CONFIRM_CONTENT"></p>' +
          '      </div>' +
          '    </md-dialog-content>' +
          '    <md-dialog-actions layout="row">' +
          '      <md-button ng-click="cancel()" translate="CANCEL"></md-button>' +
          '      <span flex></span>' +
          '      <md-button ng-click="copy()" translate="MEDIA.COPY"></md-button>' +
          '      <md-button class="md-primary" ng-click="move()" translate="MEDIA.MOVE"></md-button>' +
          '    </md-dialog-actions>' +
          '  </form>' +
          '</md-dialog>',
        controller: function ($scope, $mdDialog) {
          $scope.move = function () { $mdDialog.hide('move'); };
          $scope.copy = function () { $mdDialog.hide('copy'); };
          $scope.cancel = function () { $mdDialog.cancel(); };
        }
      }).then(function (result) {
        if (result === 'move') {
          moveItemsToGallery(targetGalleryId, sourceGalleryId);
        } else if (result === 'copy') {
          copyItemsToGallery(targetGalleryId);
        }
      });
    }

    function deleteMediaFromGallery(mediaId, galleryId) {
      if (!mediaId || !galleryId) return;

      vm.isLoading = true;
      mediahubService.deleteMedia(mediaId, galleryId)
        .then(function () {
          return mediahubService.regenerateGalleryFeed(galleryId).catch(function (err) {
            $log.warn('Ignored error regenerating gallery feed:', err);
            return $q.resolve();
          });
        })
        .then(function () {
          showToast($translate.instant('MEDIA.DELETE_SUCCESS'));
          $rootScope.pagination_reload && $rootScope.pagination_reload();
        })
        .catch(function (err) {
          $log.error('Error deleting media from gallery', err);
          showErrorToast($translate.instant('MEDIA.DELETE_ERROR'));
        })
        .finally(function () {
          vm.isLoading = false;
        });
    }

    function createMediaInGallery(mediaData, galleryId, skipReload) {
      if (!mediaData) return;

      // Ensure galleryId is set if provided
      if (galleryId) {
        mediaData.galleryId = galleryId;
      }

      vm.isLoading = true;
      return mediahubService.createMedia(mediaData)
        .then(function (newMedia) {
          if (!skipReload) {
            showToast($translate.instant('MEDIA.CREATE_SUCCESS'));
            mediahubService.regenerateGalleryFeed(galleryId).then(function () {
              $rootScope.pagination_reload && $rootScope.pagination_reload();
            });
          }
          return newMedia;
        })
        .catch(function (err) {
          $log.error('Error creating media in gallery', err);
          showErrorToast($translate.instant('MEDIA.CREATE_ERROR'));
          throw err;
        })
        .finally(function () {
          vm.isLoading = false;
        });
    }

    function copyItemsToGallery(targetGalleryId) {
      if (!vm.selectedThreads || vm.selectedThreads.length === 0) return;

      vm.isLoading = true;
      var mediaIds = vm.selectedThreads.map(function (item) {
        return item.id_media || item.id;
      });

      var sourceId = vm.selectedGallery ? (vm.selectedGallery.id_gallery || vm.selectedGallery.id) : null;
      mediahubService.assignMediaToGalleries(mediaIds, [parseInt(targetGalleryId, 10)], 'copy', sourceId)
        .then(function () {
          showToast(vm.selectedThreads.length + ' ' + $translate.instant('MEDIA.ADDTOGALLERIES_PLURAL'));
          onDropComplete();
          $rootScope.pagination_reload && $rootScope.pagination_reload();
        })
        .catch(function (err) {
          $log.error('Error copying media to gallery', err);
        })
        .finally(function () {
          vm.isLoading = false;
        });
    }

    function moveItemsToGallery(targetGalleryId, sourceGalleryId) {
      if (!vm.selectedThreads || vm.selectedThreads.length === 0) return;

      vm.isLoading = true;
      var mediaIds = vm.selectedThreads.map(function (item) {
        return item.id_media || item.id;
      });

      var sourceId = sourceGalleryId || (vm.selectedGallery ? (vm.selectedGallery.id_gallery || vm.selectedGallery.id) : null);
      mediahubService.assignMediaToGalleries(mediaIds, [parseInt(targetGalleryId, 10)], 'move', sourceId)
        .then(function () {
          showToast(vm.selectedThreads.length + ' items moved');
          onDropComplete();
          $rootScope.pagination_reload && $rootScope.pagination_reload();
        })
        .catch(function (err) {
          $log.error('Error moving media to gallery', err);
        })
        .finally(function () {
          vm.isLoading = false;
        });
    }

    /**
     * Add Media items to galleries
     *
     * @param ev
     */
    function AddMediaItemToGalleryDialog(ev) {
      var mediaGalleries = getGalleriesWithMediaAssignment(angular.copy(vm.CleanMediaGalleries), []);
      $mdDialog.show({
        controller: 'AddMediahubToGalleriesDialogController',
        controllerAs: 'vm',
        locals: {
          selectedThreads: vm.selectedThreads,
          CleanMediaGalleries: mediaGalleries,
          sourceGalleryId: vm.selectedGallery ? (vm.selectedGallery.id_gallery || vm.selectedGallery.id) : null
        },
        templateUrl: 'app/main/apps/mediahub/dialogs/add-media-galleries/add-media-galleries.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true
      })
        .then(function (reload) {
          if (reload) {
            vm.closeMediaPreview();
            vm.selectedThreads = [];
            loadGalleries();
            $rootScope.pagination_reload && $rootScope.pagination_reload();
          }
        });
    }

    /**
     * Edit Multiple Fields dialog
     *
     * @param ev
     */
    function EditMultipleFieldsDialog(ev) {
      $mdDialog.show({
        controller: 'MHEditMultipleFieldsDialogController',
        controllerAs: 'vm',
        locals: {
          selectedThreads: vm.selectedThreads,
          siteID: $scope.siteID
        },
        templateUrl: 'app/main/apps/mediahub/dialogs/edit-multiple-fields/edit-multiple-fields.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true
      })
        .then(function (reload) {
          if (reload) {
            vm.closeMediaPreview();
            vm.selectedThreads = [];
            $rootScope.pagination_reload && $rootScope.pagination_reload();
          }
        });
    }

    /**
     * Load galleries permissions from CMS section
     */
    function loadGalleriesPermissions() {
      mediahubService.getGalleriesPermissions($scope.siteID).then(function (permResponse) {
        if (permResponse && permResponse.result && permResponse.result.data) {
          vm.galleriesPermissions = permResponse.result.data.map(function (item) {
            return {
              id: item.id_galleries_permissions,
              name: item.name,
              groups: typeof item.config === 'string' ? angular.fromJson(item.config) : (item.config || [])
            };
          });
        } else {
          vm.galleriesPermissions = [];
        }
      }).catch(function (err) {
        $log.error('[mediahub] Error loading galleries permissions:', err);
      });
    }

    /**
     * Open Mediahub Settings Dialog
     *
     * @param ev
     */
    function openMediahubSettings(ev) {
      $mdDialog.show({
        controller: 'MhSettingsDialogController',
        controllerAs: 'vm',
        locals: {
          siteID: $scope.siteID,
          defaultPermissions: vm.galleriesPermissions || []
        },
        templateUrl: 'app/main/apps/mediahub/dialogs/settings/mh-settings-dialog.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true
      }).then(function (presets) {
        if (presets) {
          // Identify deleted presets
          var deletedPresets = (vm.galleriesPermissions || []).filter(function (orig) {
            return orig.id && !presets.some(function (p) { return p.id === orig.id; });
          });

          vm.galleriesPermissions = presets;
          var promises = [];

          // Delete removed presets
          angular.forEach(deletedPresets, function (deleted) {
            promises.push(mediahubService.deleteGalleriesPermissions($scope.siteID, deleted.id));
          });

          // Save/Update remaining presets
          angular.forEach(presets, function (preset) {
            var payload = {
              id: preset.id || undefined,
              name: preset.name,
              config: angular.toJson(preset.groups || [])
            };
            promises.push(mediahubService.saveGalleriesPermissions($scope.siteID, payload));
          });


          $q.all(promises).then(function (saveResults) {
            $log.debug('[mediahub] all galleries permissions saved:', saveResults);
            loadGalleriesPermissions();
          }).catch(function (err) {
            $log.error('[mediahub] Error saving galleries permissions:', err);
          });
        }
      });
    }


    /**
     * Open Mediahub-specific upload dialog (presigned S3 flow)
     */
    function openUploadDialog(ev) {
      var galleryId = vm.selectedGallery ? (vm.selectedGallery.id_gallery || vm.selectedGallery.id) : null;
      $mdDialog.show({
        controller: 'MhUploadDialogController',
        controllerAs: 'vm',
        locals: {
          galleryId: galleryId,
          siteID: $scope.siteID
        },
        templateUrl: 'app/main/apps/mediahub/dialogs/upload/mh-upload-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        multiple: true
      }).then(function (uploaded) {
        if (uploaded) {
          $rootScope.pagination_reload && $rootScope.pagination_reload();
        }
      });
    }

    /**
     * Remove selected Media items from the current gallery
     *
     * @param ev
     */
    /**
     * Los dos botones de la barra hacen cosas DISTINTAS y comparten servicio:
     * mediahubService.deleteMedia(id, galleryId) quita el media de esa galeria si se le
     * pasa galleryId, y lo borra del todo si no se le pasa.
     *
     *   - RemoveMediaItemFromGalleryDialog: quitar de la galeria seleccionada.
     *   - deleteMediaItem:                  borrado permanente, de todas las galerias.
     *
     * Antes vm.deleteMediaItem era un alias de la primera, asi que el boton de borrar
     * abria el dialogo de quitar-de-galeria y nunca llegaba a borrar nada de verdad.
     */
    function RemoveMediaItemFromGalleryDialog(ev) {
      if (!vm.selectedThreads || !vm.selectedThreads.length) return;

      var galleryId = vm.selectedGallery ? (vm.selectedGallery.id_gallery || vm.selectedGallery.id) : null;

      // Sin galeria seleccionada esto no tiene sentido. Antes caia en el borrado
      // permanente sin avisar, que es justo lo que no debe hacer este boton.
      if (!galleryId) {
        showErrorToast($translate.instant('MEDIA.SELECT_GALLERY_FIRST'));
        return;
      }

      var numItems = vm.selectedThreads.length;
      var confirm = $mdDialog.confirm()
        .title($translate.instant('MEDIA.REMOVEFROMGALLERY'))
        .textContent($translate.instant('MEDIA.REMOVE_FROM_GALLERY_CONFIRM').replace('%s', numItems))
        .ariaLabel('Remove from gallery')
        .targetEvent(ev)
        .ok($translate.instant('MEDIA.REMOVE'))
        .cancel($translate.instant('MEDIA.CANCEL'));

      $mdDialog.show(confirm).then(function () {
        ejecutarBorradoMedia(galleryId);
      }, function () { /* cancelado */ });
    }

    /**
     * Borrado PERMANENTE del media (no se pasa galleryId). Doble confirmacion, porque
     * desaparece de todas las galerias y no hay vuelta atras.
     */
    function deleteMediaItem(ev) {
      if (!vm.selectedThreads || !vm.selectedThreads.length) return;

      var numItems = vm.selectedThreads.length;

      var primera = $mdDialog.confirm()
        .title($translate.instant('MEDIA.DELETE'))
        .textContent($translate.instant('MEDIA.DELETE_PERMANENT_CONFIRM').replace('%s', numItems))
        .ariaLabel('Delete media')
        .targetEvent(ev)
        .ok($translate.instant('MEDIA.DELETE'))
        .cancel($translate.instant('MEDIA.CANCEL'));

      $mdDialog.show(primera).then(function () {
        var segunda = $mdDialog.confirm()
          .title($translate.instant('MEDIA.DELETE_PERMANENT_TITLE'))
          .textContent($translate.instant('MEDIA.DELETE_PERMANENT_WARNING'))
          .ariaLabel('Confirm permanent delete')
          .ok($translate.instant('MEDIA.DELETE'))
          .cancel($translate.instant('MEDIA.CANCEL'));
        return $mdDialog.show(segunda);
      }).then(function () {
        ejecutarBorradoMedia(null);
      }, function () { /* cancelado en cualquiera de los dos pasos */ });
    }

    /**
     * Ejecuta la operacion sobre los medias seleccionados.
     * @param {number|null} galleryId  con galeria = quitar de ella; null = borrar del todo.
     */
    function ejecutarBorradoMedia(galleryId) {
      vm.isLoading = true;

      var promises = [];
      angular.forEach(vm.selectedThreads, function (item) {
        var mediaId = item.id_media || item.id;
        promises.push(mediahubService.deleteMedia(mediaId, galleryId || undefined));
      });

      $q.all(promises).then(function () {
        // Al quitar de una galeria hay que regenerar su feed; en el borrado total se
        // regenera igualmente el de la galeria abierta, porque el item desaparece de ella.
        var galeriaARegenerar = galleryId ||
          (vm.selectedGallery ? (vm.selectedGallery.id_gallery || vm.selectedGallery.id) : null);
        if (galeriaARegenerar) {
          return mediahubService.regenerateGalleryFeed(galeriaARegenerar).catch(function (err) {
            $log.warn('Ignored error regenerating gallery feed:', err);
            return $q.resolve();
          });
        }
        return $q.resolve();
      }).then(function () {
        showToast($translate.instant('MEDIA.DELETE_SUCCESS'));
        vm.selectedThreads = [];
        if ($rootScope.pagination_reload) {
          $rootScope.pagination_reload();
        }
      }).catch(function (err) {
        $log.error('Error deleting media', err);
        showErrorToast($translate.instant('MEDIA.DELETE_ERROR'));
      }).finally(function () {
        vm.isLoading = false;
      });
    }

    function getGalleriesWithMediaAssignment(galleries, assignedGalleries) {
      angular.forEach(galleries, function (gallery) {
        gallery.assigned_gallery = false;
        if (msUtils.exists(gallery.id_gallery, assignedGalleries) && !gallery.no_files_allowed) {
          gallery.assigned_gallery = true;
        }
        if (typeof gallery.children !== 'undefined' && gallery.children.length > 0) {
          getGalleriesWithMediaAssignment(gallery.children, assignedGalleries);
        }
      });
      return galleries;
    }

    function translate(key) {
      return $translate.instant(key);
    }

    function getAssignedGalleriesIds(galleries, result) {
      angular.forEach(galleries, function (gallery) {
        if (gallery.assigned_gallery) {
          result.push(gallery.id_gallery);
        }
        if (gallery.children && gallery.children.length > 0) {
          getAssignedGalleriesIds(gallery.children, result);
        }
      });
      return result;
    }

    function updateDatePicker(field) {
      if (vm.image && vm.image[field] && vm.image[field].date) {
        vm.image[field].utcShow = vm.image[field].date.toISOString();
      }
    }

    function saveImage(mediaOrig) {
      if (!mediaOrig) return;

      // Merge typed tags into main tags array
      if (mediaOrig.tagsWithTypes) {
        mediaOrig.tags = mediaOrig.tags || [];
        angular.forEach(mediaOrig.tagsWithTypes, function (typedTags) {
          angular.forEach(typedTags, function (tag) {
            var exists = mediaOrig.tags.some(function (t) {
              return (t.id_tag && tag.id_tag && t.id_tag === tag.id_tag) || (t.tag_name === tag.tag_name);
            });
            if (!exists) {
              mediaOrig.tags.push(tag);
            }
          });
        });
      }

      vm.isLoading = true;

      var payload = {
        galleryIds: getAssignedGalleriesIds(vm.CleanMediaGalleriesWithMediaAssignment, []),
        title: mediaOrig.title,
        photographer: mediaOrig.photographer,
        credits: mediaOrig.credits,
        owner: mediaOrig.owner,
        caption: mediaOrig.caption,
        city: mediaOrig.city,
        country: mediaOrig.country,
        uses: mediaOrig.uses,
        extra: mediaOrig.extra,
        rating: mediaOrig.rating,
        geoLat: mediaOrig.geoLat,
        geoLon: mediaOrig.geoLon,
        imageCenterRatioX: mediaOrig.imageCenterRatioX,
        imageCenterRatioY: mediaOrig.imageCenterRatioY,
        fileDate: (mediaOrig.fileDate && mediaOrig.fileDate.date) ? mediaOrig.fileDate.date.toISOString() : null,
        dateUploaded: (mediaOrig.dateUploaded && mediaOrig.dateUploaded.date) ? mediaOrig.dateUploaded.date.toISOString() : null,
        tags: (mediaOrig.tags || []).map(function (t) { return t.tag_name || t; })
      };

      var id = mediaOrig.id_media || mediaOrig.id;

      return mediahubService.updateMedia(id, payload).then(function () {
        showToast($translate.instant('MEDIA.SAVE_SUCCESS') || 'Saved successfully');
        vm.isLoading = false;
        if (vm.basicForm && angular.isFunction(vm.basicForm.$setPristine)) {
          vm.basicForm.$setPristine();
        }
      }).catch(function (err) {
        $log.error('Error saving media', err);
        showErrorToast($translate.instant('MEDIA.SAVE_ERROR') || 'Error saving');
        vm.isLoading = false;
      });
    }

    /**
     * Trigger regeneration of all formats for a media item.
     * @param {number} id_media - The ID of the media item to recrop
     */
    function MediaItemRecropAllFormats(id_media) {
      if (!id_media) return;

      var messageConfirm = $translate.instant('CONTENT.MEDIA_ITEM_SURE_RECROP') || 'Are you sure you want to recrop all formats?';
      var confirm = $mdDialog.confirm()
        .title(messageConfirm)
        .ariaLabel('Recrop all formats')
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        vm.isLoading = true;

        var formatIds = [];
        if (vm.image && vm.image.cropstatus) {
          formatIds = vm.image.cropstatus.map(function (f) {
            return f.id_cropformats;
          }).filter(Boolean);
        }

        mediahubService.regenerateMediaFormats([id_media], formatIds, true)
          .then(function () {
            var message = $translate.instant('CONTENT.MEDIA_ITEM_FINISH_RECROP') || 'Media regeneration started';
            showToast(message);
          })
          .catch(function (err) {
            $log.error('[mediahub] Error regenerating media', err);
            showErrorToast('Error regenerating media');
          })
          .finally(function () {
            vm.isLoading = false;
          });
      });
    }

    /**
     * Download selected media items as a zip file.
     */
    function downloadSelected(ev) {
      if (!vm.selectedThreads || vm.selectedThreads.length === 0) return;

      var domain = $scope.siteID;
      var user = $scope.currentUser || {};
      var zipFileName = domain + '-media.zip';
      var batchBody = {
        ids: vm.selectedThreads.map(function (f) {
          return f.id_media || f.id || f.mediaId;
        }),
        zipFileName: zipFileName,
        user_id: user.id_user
      };

      var job = {
        jobId: null,
        status: 'pending',
        itemCount: batchBody.ids.length,
        processedCount: 0,
        zipFileName: zipFileName,
        downloadUrl: null
      };
      vm.batchJobs.push(job);

      mediahubService.batchDownload(batchBody)
        .then(function (data) {
          var jobData = data && data.data;
          if (!jobData || !jobData.jobId) {
            job.status = 'failed';
            showErrorToast($translate.instant('MEDIA.DOWNLOAD_ERROR_LINK') || 'Error starting batch download');
            return;
          }
          job.jobId = jobData.jobId;
          job.status = jobData.status || 'pending';
          job.itemCount = jobData.itemCount || batchBody.ids.length;
          schedulePoll(job, 0);
        })
        .catch(function (err) {
          $log.error('[mediahub] Error starting batch download', err);
          job.status = 'failed';
          showErrorToast($translate.instant('MEDIA.DOWNLOAD_ERROR') || 'Error downloading selected items');
        });
    }

    function schedulePoll(job, attempts) {
      var MAX_ATTEMPTS = 60;
      var POLL_INTERVAL = 3000;

      if (attempts >= MAX_ATTEMPTS) {
        job.status = 'failed';
        return;
      }

      $timeout(function () {
        mediahubService.pollBatchJob(job.jobId)
          .then(function (data) {
            var remote = data && data.data;
            if (!remote) {
              job.status = 'failed';
              return;
            }
            job.status = remote.status;
            job.processedCount = remote.processedCount || 0;
            job.downloadUrl = remote.downloadUrl || null;

            if (job.status === 'complete' && job.downloadUrl) {
              $window.open(job.downloadUrl, '_blank');
            } else if (job.status !== 'failed' && job.status !== 'error') {
              schedulePoll(job, attempts + 1);
            }
          })
          .catch(function (err) {
            $log.error('[mediahub] Error polling batch job', err);
            job.status = 'failed';
          });
      }, POLL_INTERVAL);
    }

    function downloadBatchJob(job) {
      if (job && job.downloadUrl) {
        $window.open(job.downloadUrl, '_blank');
      }
    }

    function dismissBatchJob(job) {
      var idx = vm.batchJobs.indexOf(job);
      if (idx !== -1) {
        vm.batchJobs.splice(idx, 1);
      }
    }

    function onDropComplete() {
      $rootScope.galleryDroppedLoading = false;
      vm.closeMediaPreview();
      // vm.deselectThreads() was missing. Using setting to empty array.
      vm.selectedThreads = [];
    }

    /*
    function showToast(message) {
      $mdToast.show({
        template: '<md-toast id="language-message" layout="column" layout-align="center center">' +
          '<div class="md-toast-content green-500-bg">' +
          '<md-icon md-font-icon="icon-check" class="icon"></md-icon>' +
          '<span class="md-toast-text" flex>' + message + '</span>' +
          '</div></md-toast>',
        hideDelay: 3000,
        position: 'top right',
        parent: '#main'
      });
    }
    */
    function showToast(message) {
      $mdToast.show({
        template: '<md-toast id="language-message" layout="column" layout-align="center center">' +
          '<div class="md-toast-content green-500-bg">' +
          '<md-icon md-font-icon="icon-check" class="icon"></md-icon>' +
          '<span class="md-toast-text" flex>' + message + '</span>' +
          '</div></md-toast>',
        hideDelay: 3000,
        position: 'top right',
        parent: '#main'
      });
    }

    function showErrorToast(message) {
      $mdToast.show({
        template: '<md-toast id="language-message" layout="column" layout-align="center center">' +
          '<div class="md-toast-content red-500-bg">' +
          '<md-icon md-font-icon="icon-alert-circle" class="icon"></md-icon>' +
          '<span class="md-toast-text" flex>' + message + '</span>' +
          '</div></md-toast>',
        hideDelay: 3000,
        position: 'top right',
        parent: '#main'
      });
    }

    // Internal Init
    init();

    function init() {

      // Fix default route
      if (!$stateParams.mediaType || !$stateParams.mediaType.trim()) {
        $state.go('app.site_overview.mediahub.type', { mediaType: 'all' }, { replace: true, notify: false });
        return;
      }

      // Toolbar title
      $rootScope.global.titleToolbar = '<i class="icon s20 icon-camera mr-15" ng-if="node.icon"></i> <span class="hide show-gt-xs">MEDIAHUB</span> <i class="mr-5 ml-5 icon s18 icon-chevron-right hide show-gt-xs"></i> ' + vm.media_type_name;

      loadGalleriesPermissions();
      getTagsTypes();

      sessionService.loadDomainResourceSettings($scope.siteID).then(function (response) {
        $log.debug('[mediahub] domain resource settings:', response);
        var mediahubConfig = {};
        if (response.mediahub) {
          mediahubConfig = typeof response.mediahub === 'string' ? angular.fromJson(response.mediahub) : response.mediahub;
        }
        vm.mediahubConfig = mediahubConfig;

        if (response.public) {
          var publicConfig = angular.fromJson(response.public);
          $log.debug('[mediahub] public config:', publicConfig);
          if (publicConfig.mediahubUrl) {
            vm.mediahubUrl = publicConfig.mediahubUrl;
            vm.vertexUrl = publicConfig.vertexUrl;
            mediahubService.setVertexUrl(vm.vertexUrl);
            vm.pagination_url = 'http://';
            var mediahubTenant = publicConfig.mediahubTenant || 'demo1';
            var mediahubS3 = publicConfig.mediahubS3 || '';
            mediahubService.setApiUrl(vm.mediahubUrl, mediahubTenant, mediahubS3);
            mediahubService.setApiKey(response.mediahub && response.mediahub['x-api-key']);
            vm.mediahubUrlMissing = false;
            vm.mediahubUrlReady = true;

            // Vertex is queried without an auth token here, see the note further down.

            // Initial Load
            loadGalleries();

            var finalId = $stateParams.id || $state.params.id || idFromPath;
            if (finalId) {
              selectMediaFile({ id: finalId });
            }
          } else {
            vm.mediahubUrlMissing = true;
            vm.mediahubUrlReady = true;
          }

          $scope.currentUser = sessionService.user;

        } else {
          vm.mediahubUrlMissing = true;
          vm.mediahubUrlReady = true;
        }
      }).catch(function (error) {
        $log.error('[mediahub] Error loading settings:', error);
        vm.mediahubUrlMissing = true;
        vm.mediahubUrlReady = true;
      });
    }

    // --- Implementation ---

    function loadGalleries() {
      vm.loadingGalleries = true;
      return mediahubService.listGalleries()
        .then(function (resp) {
          var flat = resp && resp.data ? resp.data : (resp || []);
          vm.CleanMediaGalleries = buildGalleryTree(flat);

          // Auto-select root if needed
          // if (!vm.selectedGallery && vm.CleanMediaGalleries.length > 0) {
          //   vm.selectedGallery = { id_gallery: vm.CleanMediaGalleries[0].id };
          // }
        })
        .catch(function (e) {
          $log.error('[mediahub] listGalleries failed', e);
          vm.CleanMediaGalleries = [];
        })
        .finally(function () {
          vm.loadingGalleries = false;
        });
    }

    // --- Vertex Search Pattern (Replicated from qiupreview-assets) ---

    /**
     * There is no auth token for Vertex in qiusystem.
     *
     * This was copied over from qiupreview-assets, where '/api/auth/token' is a route of
     * the site itself (ApiController::authTokenAction) that signs an RS256 JWT with the
     * site's private.pem carrying the logged in visitor and their group ids, so that
     * Vertex can scope the results to what that visitor may see.
     *
     * The admin is a static app served from another origin, so that relative url always
     * resolved against qiusystem itself and answered 404 on every mediahub load; qiu-api
     * has no equivalent endpoint, and an admin has no site groups to scope by anyway.
     * Both callers send the X-Auth-Token header only when there is a token, so the search
     * works without it. vm.authToken stays null (declared at the top of the controller):
     * if the results ever need scoping from the admin, the token has to come from a real
     * endpoint in qiu-api, not from this one.
     */

    function performXhr(method, url, data, headers) {
      var deferred = $q.defer();
      var xhr = new XMLHttpRequest();
      xhr.addEventListener("readystatechange", function () {
        if (this.readyState === 4) {
          $scope.$apply(function () {
            if (xhr.status >= 200 && xhr.status < 300) {
              try {
                var response = (typeof xhr.response === 'string') ? JSON.parse(xhr.responseText) : xhr.response;
                deferred.resolve(response);
              } catch (e) {
                console.error("Error parsing response from " + url, e);
                deferred.reject(e);
              }
            } else {
              console.error("Request failed: " + url, xhr.status, xhr.responseText);
              deferred.reject({ status: xhr.status, data: xhr.responseText });
            }
          });
        }
      });
      xhr.open(method, url);

      if (data && method === 'POST') {
        xhr.setRequestHeader("Content-Type", "application/json");
      }

      if (headers) {
        angular.forEach(headers, function (value, key) {
          xhr.setRequestHeader(key, value);
        });
      }

      if (data) {
        xhr.send(data);
      } else {
        xhr.send();
      }
      return deferred.promise;
    }

    function normalizeVertexSearchItem(item) {
      if (!item) return null;
      var title = item.title || item.caption || ('Media #' + item.id);
      var filename = item.file_name || item.title || title;
      var url = item.image_url || '';
      var thumb = item.thumbnail_url || url;

      var mTypeRaw = parseInt(item.media_type || 1);
      var mType = 'image';
      if (mTypeRaw === 2) {
        mType = 'video';
      } else if (mTypeRaw === 3) {
        mType = 'audio';
      } else if (mTypeRaw === 4) {
        mType = 'file';
      }

      return {
        id_media: item.id,
        id: item.id,
        title: title,
        caption: item.caption || '',
        date_uploaded: { date: new Date(item.available_time), utcShow: item.available_time },
        mediaType: mTypeRaw,
        media_type: mTypeRaw,
        media_type_name: mType,
        filename: filename,
        photographer: item.photographer || '',
        tags: (item.tags || []).map(function (t) { return { tag_name: t }; }),
        thumbnailUrl: thumb,
        imageUrl: url,
        imageUrlOriginal: item.preview_url || url,
        isMediahub: true,
        allCropped: (item.allCropped !== undefined) ? item.allCropped : 1,
        source: 'vertex',
        galleries: item.galleries || []
      };
    }

    vm.vertexSearch = function (query, pageSize, nextPageToken, sort) {
      if (!query || !vm.vertexUrl) return $q.resolve({ items: [] });
      pageSize = pageSize || 20;
      var url = vm.vertexUrl;

      var data = {
        "query": query || "",
        "pageSize": pageSize
      };

      // Vertex only supports ordering by created_at ("date"/"date_asc") or "relevance".
      if (sort) {
        data.sort = sort;
      }

      if (nextPageToken) {
        data.nextPageToken = nextPageToken;
      }

      var headers = {};
      if (vm.authToken) {
        headers['X-Auth-Token'] = vm.authToken;
      }

      return performXhr('POST', url, JSON.stringify(data), headers).then(function (response) {
        var items = response.results || [];
        return {
          items: items.map(normalizeVertexSearchItem).filter(Boolean),
          pagination: {
            total_items: response.totalSize || 0,
            nextPageToken: response.nextPageToken
          }
        };
      }).catch(function (err) {
        // Some tenants' datastores don't expose created_at as a sortable field, so any
        // orderBy returns HTTP 400. In that case retry once in "relevance" mode (the only
        // value that makes the backend skip orderBy) so the search still returns results.
        var text = (err && (typeof err.data === 'string' ? err.data : JSON.stringify(err.data || err.message || err))) || '';
        if (sort && sort !== 'relevance' && /orderBy/i.test(text)) {
          $log.warn("[mediahub] Vertex orderBy unsupported on this datastore; retrying in relevance mode");
          // Remember it for this tenant so we stop offering/attempting the date sort,
          // and reflect the effective order (relevance) in the sort menu.
          vm.vertexOrderByUnsupported = true;
          vm.vertexSortField = 'relevance';
          return vm.vertexSearch(query, pageSize, nextPageToken, 'relevance');
        }
        $log.error("[mediahub] Vertex search error", err);
        return { items: [] };
      });
    };

    // Map the current Vertex sort selection to what the Vertex endpoint accepts:
    // "relevance" (no orderBy), or created_at "date"/"date_asc" for the date field.
    function getVertexSort() {
      if (vm.vertexOrderByUnsupported || vm.vertexSortField === 'relevance') {
        return 'relevance';
      }
      if (vm.vertexSortField === 'fileDate') {
        var inGallery = (vm.media_type_name == 'galleries' || vm.selectedGallery);
        var dir = settingUserService.getSettingValue(vm.settingsSection, inGallery ? 'sortDirInGallery' : 'sortDir', 'DESC');
        return (String(dir).toUpperCase() === 'ASC') ? 'date_asc' : 'date';
      }
      // No explicit selection / unsupported field → relevance (never 400s).
      return 'relevance';
    }

    vm.performSearch = function (page) {
      vm.isLoading = true;
      var query = vm.modelSearch;
      var sort = getVertexSort();

      // Retrieve cached token for the requested page (Page 1 is always null)
      var currentPageToken = (page > 1) ? (vm.pageTokens[page] || null) : null;

      vm.vertexSearch(query, vm.perPage, currentPageToken, sort)
        .then(function (results) {
          vm.searchedItems = results.items;
          vm.items = results.items;

          if (results.pagination) {
            var totalItems = Number(results.pagination.total_items) || 0;
            var perPage = Number(vm.perPage) || 20;
            var totalPages = Math.max(1, Math.ceil(totalItems / perPage));

            vm.pagination = {
              totalItems: totalItems,
              totalPages: totalPages,
              page: page,
              hasNext: !!results.pagination.nextPageToken,
              hasPrev: (page > 1),
              nextPageToken: results.pagination.nextPageToken
            };

            // Cache the token for the NEXT page
            if (results.pagination.nextPageToken) {
              vm.pageTokens[page + 1] = results.pagination.nextPageToken;
            }
            
            // Update rootScope variables to sync with UI expectations
            $rootScope.pagination_totalItems = vm.pagination.totalItems;
            $rootScope.pagination_total_pages = vm.pagination.totalPages;
            $rootScope.pagination_page = page;
            $rootScope.pagination_searchquery = true;
            $rootScope.modelSearch = query;
          }
        })
        .finally(function () {
          vm.isLoading = false;
        });
    };

    // --- Pagination Overrides for Vertex ---

    $scope.pagination_gotoPage = function (page) {
      if (vm.vertexUrl && vm.searchQuery) {
        vm.performSearch(page);
      } else if ($rootScope.pagination_gotoPage) {
        $rootScope.pagination_gotoPage(page);
      }
    };

    $scope.pagination_prevPage = function () {
      if (vm.vertexUrl && vm.searchQuery) {
        if (vm.pagination && vm.pagination.page > 1) {
          vm.performSearch(vm.pagination.page - 1);
        }
      } else if ($rootScope.pagination_prevPage) {
        $rootScope.pagination_prevPage();
      }
    };

    $scope.pagination_nextPage = function () {
      if (vm.vertexUrl && vm.searchQuery) {
        if (vm.pagination && vm.pagination.hasNext) {
          vm.performSearch(vm.pagination.page + 1);
        }
      } else if ($rootScope.pagination_nextPage) {
        $rootScope.pagination_nextPage();
      }
    };

    $scope.pagination_morePages = function () {
      if (vm.vertexUrl && vm.searchQuery) {
        return vm.pagination ? !vm.pagination.hasNext : true;
      }
      return $rootScope.pagination_morePages ? $rootScope.pagination_morePages() : true;
    };

    $scope.pagination_firstPage = function () {
      if (vm.vertexUrl && vm.searchQuery) {
        return vm.pagination ? (vm.pagination.page === 1) : true;
      }
      return $rootScope.pagination_firstPage ? $rootScope.pagination_firstPage() : true;
    };

    function collectAllIds(nodes, result) {
      (nodes || []).forEach(function (node) {
        if (node.children && node.children.length > 0) {
          result.push(node.id);
          collectAllIds(node.children, result);
        }
      });
      return result;
    }

    function expandAllGalleries() {
      vm.expandedids = collectAllIds(vm.CleanMediaGalleries, []);
      vm.allGalleriesExpanded = true;
    }

    function collapseAllGalleries() {
      vm.expandedids = [];
      vm.allGalleriesExpanded = false;
    }

    function buildGalleryTree(list) {
      // Basic tree builder
      var byId = {};
      var roots = [];

      (list || []).forEach(function (g) {
        // Use the object directly to preserve 'cover', 'media', etc.
        g.id_gallery = g.id;
        g.isMediahub = true;
        g.gallery_type = g.gallery_type || 0;
        g.children = [];
        byId[g.id] = g;
      });

      Object.keys(byId).forEach(function (id) {
        var node = byId[id];
        if (node.parentId && byId[node.parentId]) {
          byId[node.parentId].children.push(node);
        } else {
          roots.push(node);
        }
      });

      // Remove empty children arrays so qiu-tree doesn't show expand icon
      Object.keys(byId).forEach(function (id) {
        if (byId[id].children && byId[id].children.length === 0) {
          delete byId[id].children;
        }
      });

      return roots;
    }

    function selectMediaFile(mediaItem) {
      vm.mediaSelected = true;
      vm.mediaSelectedLoaded = false;
      // edit-layout.html shows the spinner with this flag; without it the panel stayed
      // empty and silent while the media was being fetched.
      vm.loadingReadPane = true;
      vm.image = null;
      vm.showCropformats = false;

      if (vm.$mdMedia('xs') || vm.$mdMedia('sm')) {
        $timeout(function () {
          $mdSidenav('galleries-sidenav').close();
          vm.isOpenSidenavGalleries = false;
        }, 500);
      }

      var id = mediaItem.id_media || mediaItem.id;
      vm.ImageIDSelected = id;

      // Update URL
      $state.go('app.site_overview.mediahub.type.edit', {
        id: id,
        mediaType: vm.media_type_name
      }, { notify: false, location: true });

      // Fetch details using service
      mediahubService.getById(id)
        .then(function (item) {
          vm.image = item;

          if (vm.CleanMediaGalleries) {
            vm.CleanMediaGalleriesWithMediaAssignment = angular.copy(vm.CleanMediaGalleries);
            var rawGalleries = vm.image.galleries || [];
            var assignedIds = rawGalleries.map(function (val) {
              return parseInt(val);
            });
            function applyAssignment(galleries) {
              angular.forEach(galleries, function (g) {
                var currentId = parseInt(g.id);
                g.assigned_gallery = assignedIds.indexOf(currentId) !== -1;
                g.gallery_icon = getGalleryIcon(g);
                if (g.children) applyAssignment(g.children);
              });
            }
            applyAssignment(vm.CleanMediaGalleriesWithMediaAssignment);
            expandAssignedGalleries(vm.CleanMediaGalleriesWithMediaAssignment);
          }

          vm.mediaSelectedLoaded = true;
          vm.loadingReadPane = false;
        })
        .catch(function (err) {
          $log.error('Error loading media', err);
          vm.mediaSelectedLoaded = true;
          vm.loadingReadPane = false;
        });
    }

    /**
     * Icon of a gallery in the tree of tab-galleries, by media type and by whether it has
     * children. It used to be ten ng-if'd <md-icon> in the template, so ten watchers per
     * gallery on a tree that holds hundreds of them. An empty children array counts as a
     * branch, exactly as the ng-if did.
     */
    var GALLERY_ICONS_LEAF = [
      'icon-folder', 'icon-folder-image', 'qiu-icon-video-folder',
      'qiu-icon-audio-folder', 'qiu-icon-file-folder'
    ];
    var GALLERY_ICONS_BRANCH = [
      'icon-folder-multiple', 'icon-folder-multiple-image', 'qiu-icon-video-gallery',
      'qiu-icon-audio-gallery', 'qiu-icon-file-gallery'
    ];

    function getGalleryIcon(gallery) {
      var icons = gallery.children ? GALLERY_ICONS_BRANCH : GALLERY_ICONS_LEAF;
      return icons[gallery.gallery_type] || '';
    }

    /**
     * Opens the branches that hold a gallery of this media, and closes the rest.
     *
     * The tree of tab-galleries now builds each branch as it is opened, so a closed one
     * is not in the dom at all. Without this the tab would open showing only the roots,
     * with no sign of where the media actually is.
     *
     * @param  {Array}   galleries
     * @return {Boolean} whether this level, or anything below it, is assigned
     */
    function expandAssignedGalleries(galleries) {
      var anyAssigned = false;
      angular.forEach(galleries, function (gallery) {
        var assignedBelow = (gallery.children && gallery.children.length)
          ? expandAssignedGalleries(gallery.children)
          : false;
        gallery[ivhTreeviewOptions().expandedAttribute] = assignedBelow;
        if (gallery.assigned_gallery || assignedBelow) {
          anyAssigned = true;
        }
      });
      return anyAssigned;
    }

    /**
     * Opens the branches holding a gallery whose name matches, and closes the rest.
     * The filter of ivh-treeview only hides nodes, it never opens their parents, so a
     * match inside a closed branch would not even be built.
     *
     * @param  {Array}   galleries
     * @param  {String}  search    already lowercased
     * @return {Boolean} whether this level, or anything below it, matches
     */
    function expandMatchingGalleries(galleries, search) {
      var anyMatch = false;
      angular.forEach(galleries, function (gallery) {
        var matchBelow = (gallery.children && gallery.children.length)
          ? expandMatchingGalleries(gallery.children, search)
          : false;
        gallery[ivhTreeviewOptions().expandedAttribute] = matchBelow;
        var name = (gallery.name || '').toLowerCase();
        if (matchBelow || name.indexOf(search) !== -1) {
          anyMatch = true;
        }
      });
      return anyMatch;
    }

    $scope.$watch(function () {
      return vm.treeSearch;
    }, function (search, previousSearch) {
      if (search === previousSearch || !vm.CleanMediaGalleriesWithMediaAssignment) {
        return;
      }
      if (search) {
        expandMatchingGalleries(vm.CleanMediaGalleriesWithMediaAssignment, search.toLowerCase());
      } else {
        expandAssignedGalleries(vm.CleanMediaGalleriesWithMediaAssignment);
      }
    });

    /**
     * Collapse / expand all of the galleries tree. The menu of tab-galleries was already
     * there but neither vm.collapseAndExpand nor this function existed in mediahub, so it
     * came up empty and threw on click.
     *
     * Beware that expanding everything on a tenant with a thousand galleries does build
     * all of them, which is exactly what this tab used to do on every media selection.
     */
    function collapseAndExpandFunction() {
      var tree = vm.CleanMediaGalleriesWithMediaAssignment;
      if (!tree) {
        return;
      }
      if (vm.collapseAndExpandValue === 'expand_all') {
        ivhTreeviewMgr.expandRecursive(tree);
      } else if (vm.collapseAndExpandValue === 'collapse_all') {
        ivhTreeviewMgr.collapseRecursive(tree);
      }
    }

    // tab-cropformats.html hides its list behind this flag. It was never set in mediahub
    // (the function only existed in the media module), so the tab came up empty and the
    // md-on-select of the tab threw on every click.
    function showCropformatsTab() {
      vm.showCropformats = true;
    }

    function closeMediaPreview() {
      if (vm.currentListView == 'gridGoogle') {
        $rootScope.$broadcast('closeSidenav', 'sidenav-media');
      }
      vm.mediaSelected = false;
      vm.image = null;
      vm.ImageIDSelected = null;
      $state.go('app.site_overview.mediahub.type', { mediaType: vm.media_type_name }, { notify: false });
    }

    function toggleSelectThread(item, event) {
      if (event) {
        event.stopPropagation();
      }
      var idx = vm.selectedThreads.indexOf(item);
      if (idx > -1) {
        vm.selectedThreads.splice(idx, 1);
      } else {
        vm.selectedThreads.push(item);
      }
    }

    function toggleSelectThreads() {
      if (vm.selectedThreads.length > 0) {
        vm.selectedThreads = [];
      } else {
        vm.selectedThreads = vm.items.slice(0);
      }
    }

    function isSelected(item) {
      return vm.selectedThreads.indexOf(item) > -1;
    }

    // --- Event Listeners ---

    $scope.$on('pagination:loadStart', function () {
      vm.isLoading = true;
    });

    $scope.$on('pagination:loadPage', function () {
      // Delay slightly for smooth transition
      $timeout(function () { vm.isLoading = false; }, 500);
    });

    // Pagination data binding (qiu-pagination pushes to vm.items)
    // No explicit load needed here if qiu-pagination handles the service call

    $scope.$on('pagination:perPageChanged', function (event, size) {
      vm.perPage = size;
      if (vm.vertexUrl && vm.searchQuery) {
        vm.pageTokens = {};
        vm.performSearch(1);
      }
    });

    $scope.$on('setBasicFormDirty', function () {
      $timeout(function () {
        if (vm.basicForm && angular.isFunction(vm.basicForm.$setDirty)) {
          vm.basicForm.$setDirty();
        }
      });
    });

    function createGallery(ev) {
      var parentGallery = null;
      if (vm.selectedGallery && vm.CleanMediaGalleries) {
        parentGallery = findGallery(vm.CleanMediaGalleries, vm.selectedGallery.id_gallery);
      }

      $mdDialog.show({
        controller: 'MHEditGalleryDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/apps/mediahub/dialogs/galleries/edit-gallery.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          gallery: {},
          galleries: vm.CleanMediaGalleries,
          parentGallery: parentGallery,
          siteID: sessionService.site_operative.subdomain,
          // Decides whether the dynamic filter offers free-text words (Vertex-only in the API).
          hasVertex: !!vm.vertexUrl
        }
      }).then(function () {
        loadGalleries();
      });
    }

    function openGalleryDialog(ev, item, parent) {
      $mdDialog.show({
        controller: 'MHEditGalleryDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/apps/mediahub/dialogs/galleries/edit-gallery.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          gallery: item || {},
          galleries: vm.CleanMediaGalleries,
          parentGallery: parent || null,
          siteID: sessionService.site_operative.subdomain,
          // Decides whether the dynamic filter offers free-text words (Vertex-only in the API).
          hasVertex: !!vm.vertexUrl
        }
      }).then(function () {
        loadGalleries();
      });
    }

    function findGallery(nodes, id) {
      if (!nodes) return null;
      for (var i = 0; i < nodes.length; i++) {
        var node = nodes[i];
        if (node.id_gallery == id) {
          return node;
        }
        if (node.children && node.children.length > 0) {
          var found = findGallery(node.children, id);
          if (found) return found;
        }
      }
      return null;
    }

    function copyLink(link) {
      if (!link) return;
      var dummy = document.createElement('textarea');
      document.body.appendChild(dummy);
      dummy.value = link;
      dummy.select();
      document.execCommand('copy');
      document.body.removeChild(dummy);
      $mdToast.show({
        template: '<md-toast layout="row" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>Copied to clipboard</span></div></md-toast>',
        hideDelay: 2000,
        position: 'top',
        parent: '#content-container'
      });
    }

    function openImageDialog(ev, images, ImageSelected, cropFormats, MediaFull) {
      $mdDialog.show({
        controller: 'MediahubShowDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/apps/mediahub/dialogs/media-show/media-show-dialog-with-tags.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        escapeToClose: false,
        locals: {
          Images: images,
          ImageSelected: ImageSelected,
          cropFormats: cropFormats,
          MediaFull: MediaFull,
          Tags: true
        }
      }).then(function () {
      });
    }

    function selectedItemChange(searcher) {
      if (searcher) {
        vm[searcher] = '';
      } else {
        vm.searchTagText = '';
      }
      vm.selectedTag = null;
    }

    function labelQuerySearch(query, type) {
      var ret = [];
      if (query) {
        var filteredContent = angular.copy(vm.tags.filter(vm.createFilterFor(query)));
        if (filteredContent.length > 0) {
          ret.push({
            id_tag: 0,
            tag_name: "",
            order: 1
          });
        }
        angular.forEach(filteredContent, function (val) {
          if (!type || (type && val.id_type == type)) {
            ret.push(val);
          }
        });
      }
      return ret;
    }

    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query).normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      return function filterFn(item) {
        if (!item || angular.isUndefined(item.tag_name)) {
          return false;
        }
        var normItem;
        if (typeof item.tag_name == 'string') {
          normItem = item.tag_name.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        } else {
          normItem = item.tag_name;
        }
        if (!item.tag_name) {
          return false;
        }
        return angular.lowercase(normItem.toString()).indexOf(lowercaseQuery) >= 0;
      };
    }

    function newTag(tagName, type) {
      if (vm.newTagDisabled) {
        return false;
      }
      vm.newTagDisabled = true;

      var tagObj = {
        id_tag: '',
        tag_name: tagName,
        id_type: type && type.id_type ? type.id_type : undefined
      };
      var options = {
        site: $scope.siteID,
        item: tagObj
      };
      tagsService.saveItem(options).then(function (response) {
        tagObj.id_tag = response.id_tag;
        if (response.id_type) {
          var typeObj = vm.tagsTypes.find(t => t.id_type == response.id_type);
          if (typeObj) {
            var typename = typeObj.name;
            if (!vm.image.tagsWithTypes[typename]) {
              vm.image.tagsWithTypes[typename] = [];
            }
            vm.image.tagsWithTypes[typename].push(tagObj);
            vm[type.searcher] = "";
          }
        } else {
          if (!vm.image.tags) {
            vm.image.tags = [];
          }
          vm.image.tags.push(tagObj);
          vm.searchTagText = '';
        }
        vm.newTagDisabled = false;
      }).catch(function (err) {
        $log.error('[mediahub] Error creating tag:', err);
        vm.newTagDisabled = false;
      });
    }

    function getTagsTypes() {
      var options = {
        siteID: $scope.siteID
      };
      tagsService.getTagsTypes(options).then(function (response) {
        vm.tagsTypes = response;
        angular.forEach(vm.tagsTypes, function (type) {
          var searcher = 'searchTag' + type.name.replace(/\s/g, '');
          vm[searcher] = null;
          type.searcher = searcher;
        });
      }).catch(function (err) {
        $log.error('[mediahub] Error loading tag types:', err);
      });
    }

  }
})();

(function () {
    'use strict';

    angular
        .module('app.media')
        .service("rekognitionService", rekognitionService);

    /** @ngInject */
    // I provide access to the session store.
    function rekognitionService($q, $resource, COMMON) {

        function get(options) {
            var deferred = $q.defer();

            var opts = {
                domain: options.siteID,
                name: options.section,
                page: options.page,
                search: options.searchStringFilter,
                resultsPerPage: options.resultsPerPage,
                sort: options.sort,
                sortField: options.sortField,
                sortDir: options.sortDir
            };


            resourceMediaFaces.get(opts,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function openFace(options) {
            var deferred = $q.defer();
            resourceMediaFacesById.get(options,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }
        function getTagsRelated(options) {
            var deferred = $q.defer();
            options.resultsPerPage = 200;
            options.filter = JSON.stringify([{ "field": "tags", "name": "Tags", "values": options.id_tags }]);
            resourceMediaTagsRelated.get(options,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }
        function getTextsRelated(options) {
            var deferred = $q.defer();
            resourceMediaTextRelated.post(options, options.item,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }


        function getFilters(options) {
            var deferred = $q.defer();
            return (deferred.promise);
        }
        
        function getUserById(options){
            var deferred = $q.defer();
            resourceGetUserById.get(options, 
                function(response){
                    deferred.resolve(response);
                },
                function(e){
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }
        
        var resourceGetUserById = $resource(
            COMMON.BASE_API + '/domain/:domain/users/:id', {
            }, {
                'get': {method: "GET", isArray: false }
            }
        );


        var resourceMediaFaces = $resource(
            COMMON.BASE_API + '/domain/:domain/media?recognition[]={"faces": true}', {
            // No default data.
        }, {
            'get': { method: "GET", isArray: false },
            'post': { method: "POST", isArray: false },
            'update': { method: "PUT" },
        }
        );
        var resourceMediaFacesById = $resource(
            COMMON.BASE_API + '/domain/:domain/media?recognition[]={"faces": ":ia_id"}', {
            // No default data.
        }, {
            'get': { method: "GET", isArray: false }
        }
        );
        var resourceMediaTagsRelated = $resource(
            COMMON.BASE_API + '/domain/:domain/media?withCropStatus=true&withTags=true&withFilters=:filter', {
            // No default data.
        }, {
            'get': { method: "GET", isArray: false }
        }
        );
        var resourceMediaTextRelated = $resource(
            COMMON.BASE_API + '/domain/:domain/ai/searchText', {
            // No default data.
        }, {
            'post': { method: "POST", isArray: true }
        }
        );


        // Return the public API.
        return ({
            get: get,
            getTagsRelated: getTagsRelated,
            getTextsRelated: getTextsRelated,
            openFace: openFace,
            getFilters: getFilters,
            getUserById: getUserById

        });


    }


})();

(function () {
  'use strict';

  angular
    .module('app.media')
    .controller('RekognitionController', RekognitionController);

  /** @ngInject */
  function RekognitionController($stateParams, $mdDialog, $document, mediaService, rekognitionService, $mdMenu, $rootScope,
                                 requestContext, $anchorScroll, $timeout, $scope, $translate, $mdMedia, $mdToast, sessionService) {

    var vm = this;

    vm.selectedThreads = [];
    $scope.isLoading = true;
    vm.enterfirst = true;
    vm.isTiny = false;
    vm.openMenu = openMenu;
    vm.views = {
      1: 'app/main/apps/media/views-rekognition/grid-view.html'
    };

    vm.views = {
      nosplit: 'app/main/apps/media/views-rekognition/nosplit-view.html',
      split: 'app/main/apps/media/views-rekognition/split-view.html'
    };

    vm.viewslist = {
      list: 2,
      grid: 1
    };

    vm.defaultView = 'split';
    vm.currentView = 'split';

    vm.defaultListView = 'grid';
    vm.currentListView = 'grid';

    vm.changeListView = changeListView;
    vm.logResize = logResize;

    vm.firstLoad = true;
    vm.openImageDialog = openImageDialog;

    vm.isSelected = isSelected;
    vm.toggleSelectThread = toggleSelectThread;
    vm.selectThreads = selectThreads;
    vm.deselectThreads = deselectThreads;
    vm.toggleSelectThreads = toggleSelectThreads;
    vm.openFace = openFace;
    vm.newFace = newFace;
    vm.isCheckedMedia = isCheckedMedia;
    vm.toggleCheck = toggleCheck;
    vm.selectAll = selectAll;
    vm.selectUntagged = selectUntagged;
    vm.autoTag = autoTag;
    vm.AddmediaDialog = AddmediaDialog;

    vm.selectedText = [];
    vm.selectedRelated = [];

    vm.translate = function (text) {
      return $translate.instant(text);
    }


    var originatorEv;

    function openMenu($mdMenu, ev) {
      originatorEv = ev;
      $mdMenu.open(ev);
    }


    var siteID = requestContext.getParam("siteId");
    var section = requestContext.getParam("section");
    init();

    /**
     * Initialize
     */
    function init() {

      vm.loading = true;
      $scope.siteID = requestContext.getParam("siteId");
      $rootScope.global.titleToolbar = '<i class="icon s20 icon-camera mr-15" ng-if="node.icon"></i> <span class="hide show-gt-xs">' + $translate.instant('MEDIA.REKOGNITION') + ' </span> <i class="mr-5 ml-5 icon s18 icon-chevron-right hide show-gt-xs"></i> FACES';

    }
    /**
     * Change the view
     *
     * @param view
     */
    function changeListView(view) {
      $scope.isLoading = true;
      $timeout(function () {
        if (vm.viewslist[view]) {
          vm.loadingListView = true;
          vm.defaultListView = view;
          vm.currentListView = view;
        }

        $scope.isLoading = false;
      }, 1000);
    }


    // Watch screen size to change view modes
    $scope.$watch(function () {
      return $mdMedia('lt-sm');
    }, function (current, old) {
      if (angular.equals(current, old)) {
        return;
      }

      if (current) {
        vm.currentView = 'nosplit';
      }
    });

    $scope.$watch(function () {
      return $mdMedia('max-width: 960px');
    }, function (big) {

      if (big)
        vm.currentView = 'nosplit';

    });

    $scope.$watch(function () {
      return $mdMedia('min-width: 960px');
    }, function (small) {

      if (small)
        vm.currentView = 'split';

    });

    $scope.$watch(function () {
      return $mdMedia('gt-sm');
    }, function (current, old) {
      if (angular.equals(current, old)) {
        return;
      }

      if (current) {
        if (vm.defaultView === 'split') {
          vm.currentView = 'split';
        }
      }
    });





    $scope.$on('pagination:loadStart', function (event) {
      // $anchorScroll();

      // Store the current scrollPos
      // vm.scrollPos = vm.scrollEl.scrollTop();

      // Scroll to the top
      // vm.scrollEl.scrollTop(0);
      if (!vm.enterfirst) {
        var elem = angular.element(document.getElementById('thread-list'));
        elem.scrollTopAnimated(0, 10);
      }

      // angular.element("#thread-list").scrollTop=0;
      vm.enterfirst = false;
      $scope.isLoading = true;
    });

    $scope.$on('pagination:loadPage', function (event) {

      vm.dataAlreadyLoaded = true;
      $timeout(function () {
        $scope.isLoading = false;
      }, 1000);
    });


    /**
     * Open Image dialog
     *
     * @param ev
     * @param task
     */
    function openImageDialog(ev, images, ImageSelected, cropFormats, MediaFull) {
      $mdDialog.show({
        controller: 'MediaShowDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/dialogs/media-show/media-show-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        escapeToClose: false,
        locals: {
          Images: images,
          ImageSelected: ImageSelected,
          cropFormats: cropFormats,
          MediaFull: MediaFull,
          Tags: false,
          // Tasks: vm.tasks,
          // event: ev
        }
      }).then(function () {
      });
    }

    function openFace(item) {
      vm.selectedText = [];
      vm.selectedRelated = [];
      vm.selectedTags = [];
      vm.facesRelated = null
      vm.textsRelated = null
      vm.selectedFace = item;
      if (!vm.currentTab || (vm.currentTab == 'text' && (!vm.selectedFace.ai_recognition.texts.length > 0))) {
        vm.currentTab = 'preview';
      }
      vm.isLoadingRelated = true;
      vm.isLoadingTags = true;
      vm.isLoadingText = true;


      mediaService.get({
        siteID: $scope.siteID,
        withCropStatus: true,
        withTags: true,
        idMedia: item.id_media
      }).then(res => {
        res.data = res.data.map(mapMedia);
        vm.selectedFaceData = res.data[0];

        var optionsRelated = {
          siteID: $scope.siteID,
          withTags: true,
          item: {
            faces: [vm.selectedFaceData.ai_recognition.faces[0].id]
          }
        }
        mediaService.getFacesRelated(optionsRelated).then(res => {
          vm.facesRelated = res.map(mapMedia);
          vm.isLoadingRelated = false;
        })

        if (vm.selectedFaceData.ai_recognition.faces && vm.selectedFaceData.ai_recognition.faces.length > 0) {
          var optionsRelatedTags = {
            domain: siteID,
            withTags: true,
            id_tags: vm.selectedFaceData.ai_recognition.faces[0].tags.map(x => x.id)
          }
          rekognitionService.getTagsRelated(optionsRelatedTags).then(res => {
            vm.tagsRelated = res.data.map(mapMedia);
            vm.isLoadingTags = false;
          })
        } else {
          vm.isLoadingTags = false;
        }
        if (vm.selectedFaceData.ai_recognition.texts && vm.selectedFaceData.ai_recognition.texts.length > 0) {
          var optionsRelatedText = {
            domain: siteID,
            withTags: true,
            item: {
              "texts": [
                vm.selectedFaceData.ai_recognition.texts[0].id
              ]
            }
          }
          rekognitionService.getTextsRelated(optionsRelatedText).then(res => {
            vm.textsRelated = res.map(mapMedia);
            vm.isLoadingText = false;
          })
        } else {
          vm.isLoadingText = false;
        }
      })

    }

    function autoTag() {
      switch (vm.currentTab) {
        case 'preview':
          saveMass(vm.selectedRelated.map(x => x.id_media), vm.selectedFaceData.ai_recognition.faces[0].tags)
          break;
        case 'text':
          saveMass(vm.selectedText.map(x => x.id_media), vm.selectedFaceData.ai_recognition.texts[0].tags)
          break;
        default:
          break;
      }
    }
    function saveMass(mediaIDs, tags) {
      var options = {
        site: siteID,
        data: {
          id_media: mediaIDs,
          tags: tags.map(x => {
            return {
              id_tag: x.id,
              tag_name: x.name
            }
          })
        }
      };
      mediaService.massUpdate(options)
        .then(function (response) {
          vm.reload = true;
          var message = $translate.instant('MEDIA.ITEMS_UPDATED_PLURAL');
          $mdToast.show({
            template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + mediaIDs.length + message + '</span></div></md-toast>',
            hideDelay: 5000,
            position: 'top',
            parent: '#content-container'
          });
          vm.openFace(vm.selectedFace);
        });
    }

    function AddmediaDialog(ev, mediazone, item) {
      var mediaGalleries = vm.CleanMediaGalleries;
      if (vm.selectedGallery) {
        mediaGalleries = getGalleriesWithMediaAssignment(vm.CleanMediaGalleries, [vm.selectedGallery.id_gallery]);
      }
      $mdDialog.show({
        controller: 'AddMediaDialogController',
        controllerAs: 'vm',
        locals: {
          currentThread: vm.items,
          section: $scope.section,
          isReplace: false,
          item: false,
          mediazone: mediazone,
          CleanMediaGalleries: mediaGalleries,
          isTiny: false,
          preselectedTags: []
        },
        templateUrl: 'app/main/apps/media/dialogs/media/media-dialog.html',
        parent: angular.element($document.body),
        multiple: true,
        targetEvent: ev,
        clickOutsideToClose: true
      })
        .then(function (items) {
          //          console.debug("Item added", items)
          $rootScope.pagination_resetquery();

          // for (var i = 0; i < items.length; i++) {
          //   console.log(items[i])
          //   $scope.$safeApply(function() {
          //     vm.items.push(items)
          //   });
          // }

          // vm.currentThread_Edit = item;
          //         $log.log(item.Thumbnail, vm.currentThread_Edit.Thumbnail);
          // vm.basicForm.$setDirty()
          // vm.thumbnails_Edit = {};
          // $log.log(mediazone, item);
          //         if (vm.mediaZones) {
          //             angular.forEach(vm.mediaZones, function (mz) {
          //                 if (angular.isUndefined(vm.thumbnails_Edit[mz.id_zone])) {
          //                     vm.thumbnails_Edit[mz.id_zone] = [];
          //                 }
          //             })
          //             angular.forEach(vm.currentThread_Edit.Thumbnail, function (thumb) {
          //                 vm.thumbnails_Edit[thumb.id_zone].push(thumb);
          //             })
          //         }

        });
    }

    function selectAll(tab) {
      switch (tab) {
        case 'preview':
          vm.selectedRelated = angular.copy(vm.facesRelated);
          break;
        case 'text':
          vm.selectedText = angular.copy(vm.textsRelated);
          break;
        default:
          break;
      }
    }

    function selectUntagged(tab) {
      switch (tab) {
        case 'preview':
          vm.selectedRelated = angular.copy(vm.facesRelated).filter(x => x.tags.length == 0);
          break;
        case 'text':
          vm.selectedText = angular.copy(vm.textsRelated).filter(x => x.tags.length == 0);
          break;
        default:
          break;
      }
    }

    function isCheckedMedia(property, media) {
      return vm[property].find(x => x.id_media == media.id_media);
    }


    function toggleCheck(property, media) {
      var found = isCheckedMedia(property, media);
      if (found) {
        var index = vm[property].indexOf(found);
        vm[property].splice(index, 1)
      } else {
        vm[property].push(media);
      }
    }


    function mapMedia(media) {
      if (media.media) {
        var mediaContainer = sessionService.getContainerByID(media.media.cdnContainer);
        media.media.imageUrlOriginal = mediaContainer.view_url + 'original/m' + media.media.id_media + '_' + media.media.filename;
        media = media.media;
      } else {
        var mediaContainer = sessionService.getContainerByID(media.cdnContainer);
        media.imageUrlOriginal = mediaContainer.view_url + 'original/m' + media.id_media + '_' + media.filename;
      }
      return media;
    }


    function newFace(ev) {
      $mdDialog.show({
        controller: 'MediaTagDialogController',
        controllerAs: 'vm',
        locals: {
          section: $scope.section,
          mediazone: '',
          isTiny: false,
          maxAttach: 1,
          showViews: {
            1: true,
            2: false,
            3: false,
            4: false,
            5: false,
            upload: true,
            import: false
          }
        },
        templateUrl: 'app/main/apps/media/dialogs/media-tags-dialog/media-tags-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true
      }).then(function (data) {
        if (data) {
          $rootScope.pagination_resetquery();
        }
      });
    }

    function logResize(size) {

      if (size.width >= 1635) {
        var cols = 5;
      } else if (size.width >= 1300) {
        var cols = 4;
      } else if (size.width >= 1000) {
        var cols = 3;

      } else if (size.width >= 600) {
        var cols = 2;

      } else if (size.width >= 1) {
        var cols = 1;

      }
      $scope.$safeApply(function () {
        vm.cols = cols;
      });

    };

    /**
     * Return selected status of the thread
     *
     * @param thread
     * @returns {boolean}
     */
    function isSelected(thread) {
      return vm.selectedThreads.indexOf(thread) > -1;
    }

    /**
     * Toggle selected status of the thread
     *
     * @param thread
     * @param event
     */
    function toggleSelectThread(thread, event) {
      if (event) {
        event.stopPropagation();
      }

      if (vm.selectedThreads.indexOf(thread) > -1) {
        vm.selectedThreads.splice(vm.selectedThreads.indexOf(thread), 1);
      } else {
        vm.selectedThreads.push(thread);
      }
    }


    /**
     * Deselect threads
     */
    function deselectThreads() {
      vm.selectedThreads = [];
    }

    /**
     * Toggle select threads
     */
    function toggleSelectThreads() {
      if (vm.selectedThreads.length > 0) {
        vm.deselectThreads();
      } else {
        vm.selectThreads();
      }
    }

    /**
     * Select threads. If key/value pair given,
     * threads will be tested against them.
     *
     * @param [key]
     * @param [value]
     */
    function selectThreads(key, value) {
      // Make sure the current selection is cleared
      // before trying to select new threads
      vm.selectedThreads = [];

      for (var i = 0; i < vm.items.length; i++) {
        if (angular.isUndefined(key) && angular.isUndefined(value)) {
          vm.selectedThreads.push(vm.items[i]);
          continue;
        }

        if (angular.isDefined(key) && angular.isDefined(value) && vm.items[i][key] === value) {
          vm.selectedThreads.push(vm.items[i]);
        }
      }
    }


  }


})();

(function () {
  'use strict';

  angular
    .module('app.media')
    .directive('qiuOnClickLoadMediaByGalleries', ['mediaService', LoadMediaByGalleries])
    .directive('qiuOnClickOpenGalleryEditDialog', ['mediaService', OpenGalleryEditDialog])
    .directive('qiuOnCheckToggleAssignedGallery', ToggleAssignedGallery)
    .directive('qiuOnCheckSetBasicFormDirty', ['mediaService', SetBasicFormDirty])
    .directive('qiuOnClickCloseSidenav', ['mediaService', CloseSidenav])
    .directive('dragSelect', ['$document', function ($document) {
      return {
        restrict: 'A',
        link: function (scope, element) {
          // Ancla del recuadro en coords RELATIVAS a la grid (element[0]). Como la grid
          // se mueve como un bloque con el scroll, estas coords son invariantes al scroll
          // sin depender de detectar exactamente el contenedor scrolleable.
          let anchorGX, anchorGY, selectionBox;
          let lastClientX = 0, lastClientY = 0;
          let isDragging = false;
          let scrollContainer = null;      // para auto-scroll (null => ventana)
          let autoScrollDir = 0;
          let autoScrollRAF = null;
          let updateRAF = null;
          let scrollHandler = null;
          const EDGE = 45;                 // px desde el borde para el auto-scroll
          const SPEED = 18;                // px por frame

          // Contenedor scrolleable más cercano (incluye el propio elemento).
          function getScrollParent(node) {
            let el = node;
            while (el && el !== document.body && el !== document.documentElement) {
              const oy = window.getComputedStyle(el).overflowY;
              if ((oy === 'auto' || oy === 'scroll') && el.scrollHeight > el.clientHeight + 1) {
                return el;
              }
              el = el.parentElement;
            }
            return null;
          }

          // Bordes (viewport) del área scrolleable, para detectar cuándo auto-scrollear.
          function containerBounds() {
            if (!scrollContainer) return { top: 0, bottom: window.innerHeight };
            const r = scrollContainer.getBoundingClientRect();
            return { top: r.top, bottom: r.bottom };
          }

          function createSelectionBox(event) {
            angular.element(document.querySelectorAll('.selection-box')).remove();
            if (isDragging) return;

            event.preventDefault();
            event.stopPropagation();

            scrollContainer = getScrollParent(element[0]);
            const gr = element[0].getBoundingClientRect();
            lastClientX = event.clientX;
            lastClientY = event.clientY;
            anchorGX = event.clientX - gr.left;
            anchorGY = event.clientY - gr.top;

            selectionBox = angular.element('<div class="selection-box"></div>');
            angular.element(document.body).append(selectionBox);
            selectionBox.css({
              position: 'fixed',
              border: '1px dashed #2196F3',
              background: 'rgba(33, 150, 243, 0.2)',
              zIndex: '1000',
              pointerEvents: 'none'
            });

            document.body.style.userSelect = 'none';
            scope.shiftPressed = event.shiftKey;

            // Limpieza UNA sola vez al iniciar (salvo shift).
            if (!scope.shiftPressed) {
              scope.vm.selectedThreads = [];
              angular.element(document.querySelectorAll('.grid-element.box-selected')).removeClass('box-selected');
            }

            // Recalcular también al hacer scroll (manual O auto). Capturing en window
            // para recibir el evento de scroll de cualquier contenedor anidado.
            scrollHandler = function () { scheduleUpdate(); };
            window.addEventListener('scroll', scrollHandler, true);

            $document.on('mousemove', onMouseMove);
            $document.on('mouseup', endSelection);
            $document.on('mouseleave', endSelection);
            updateSelection();
          }

          function onMouseMove(event) {
            lastClientX = event.clientX;
            lastClientY = event.clientY;
            updateAutoScroll();
            updateSelection();
          }

          // Throttle de updateSelection para eventos de scroll frecuentes.
          function scheduleUpdate() {
            if (updateRAF) return;
            updateRAF = requestAnimationFrame(function () {
              updateRAF = null;
              updateSelection();
            });
          }

          // Recuadro visible (viewport) + selección, todo en coords relativas a la grid.
          function updateSelection() {
            if (!selectionBox || isDragging) return;
            const gr = element[0].getBoundingClientRect();

            const curGX = lastClientX - gr.left;
            const curGY = lastClientY - gr.top;
            const box = {
              top: Math.min(anchorGY, curGY),
              bottom: Math.max(anchorGY, curGY),
              left: Math.min(anchorGX, curGX),
              right: Math.max(anchorGX, curGX)
            };

            // Posición del recuadro en viewport = top/left de la grid + offset relativo.
            selectionBox.css({
              left: (gr.left + box.left) + 'px',
              top: (gr.top + box.top) + 'px',
              width: (box.right - box.left) + 'px',
              height: (box.bottom - box.top) + 'px'
            });

            selectElements(box, gr);
          }

          function selectElements(box, gr) {
            const elements = element[0].querySelectorAll('.grid-element');
            if (!scope.vm.selectedThreads) {
              scope.vm.selectedThreads = [];
            }

            // Se evalúan TODOS los items (visibles o no): sus coords relativas a la grid
            // son fijas, así que el conjunto seleccionado es el recuadro completo en una
            // sola pasada, sin depender de la velocidad del scroll.
            angular.forEach(elements, function (el) {
              const r = el.getBoundingClientRect();
              const elTop = r.top - gr.top;
              const elBottom = r.bottom - gr.top;
              const elLeft = r.left - gr.left;
              const elRight = r.right - gr.left;
              const mediaId = el.getAttribute('data-id');
              const inside =
                elTop < box.bottom &&
                elBottom > box.top &&
                elLeft < box.right &&
                elRight > box.left;

              const idx = scope.vm.selectedThreads.findIndex(item => item && item.id_media == mediaId);

              if (inside) {
                if (idx === -1) {
                  angular.element(el).addClass('box-selected');
                  const item = scope.vm.items.find(x => x.id_media == mediaId);
                  scope.vm.selectedThreads.push(item);

                  angular.element(el).attr('draggable', 'true');
                }
              } else if (!scope.shiftPressed && idx !== -1) {
                angular.element(el).removeClass('box-selected');
                scope.vm.selectedThreads.splice(idx, 1);
              }
            });
            scope.$applyAsync();
          }

          // Auto-scroll cuando el puntero llega cerca del borde del contenedor.
          function updateAutoScroll() {
            const b = containerBounds();
            if (lastClientY > b.bottom - EDGE) {
              autoScrollDir = 1;
            } else if (lastClientY < b.top + EDGE) {
              autoScrollDir = -1;
            } else {
              autoScrollDir = 0;
            }
            if (autoScrollDir !== 0 && !autoScrollRAF) {
              autoScrollRAF = requestAnimationFrame(autoScrollTick);
            }
          }

          function autoScrollTick() {
            autoScrollRAF = null;
            if (autoScrollDir === 0 || !selectionBox || isDragging) return;
            const dy = autoScrollDir * SPEED;
            if (!scrollContainer) {
              window.scrollBy(0, dy);
            } else {
              scrollContainer.scrollTop += dy;
            }
            // El listener de scroll recalcula; lo llamamos también aquí por si acaso.
            updateSelection();
            autoScrollRAF = requestAnimationFrame(autoScrollTick);
          }

          function stopAutoScroll() {
            autoScrollDir = 0;
            if (autoScrollRAF) {
              cancelAnimationFrame(autoScrollRAF);
              autoScrollRAF = null;
            }
            if (updateRAF) {
              cancelAnimationFrame(updateRAF);
              updateRAF = null;
            }
          }

          function handleDragStart(event) {
            isDragging = true;
            event.dataTransfer.setData("text", JSON.stringify(scope.vm.selectedThreads));

            if (event.dataTransfer.setDragImage) {
              let transparentPixel = document.createElement("img");
              transparentPixel.src = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";
              transparentPixel.width = 1;
              transparentPixel.height = 1;
              event.dataTransfer.setDragImage(transparentPixel, 0, 0);
            }

            if (typeof dragIndicator !== 'undefined') {
              dragIndicator.css({
                display: "block",
                zIndex: "2147483647",
              });
            }

            event.stopPropagation();
          }

          function handleDragEnd(event) {
            isDragging = false;
          }

          // Delegated dragstart for the whole grid: lets any item be dragged without a
          // prior selection. If the grabbed item is part of the current multi-selection,
          // the whole selection is dragged; otherwise only that item is.
          function onGridDragStart(event) {
            var gridEl = event.target.closest ? event.target.closest('.grid-element') : null;
            if (!gridEl) return;

            var mediaId = gridEl.getAttribute('data-id');
            var selected = scope.vm.selectedThreads || [];
            var inSelection = selected.some(function (t) {
              return t && String(t.id_media) === String(mediaId);
            });

            if (!inSelection) {
              // Drag just this item: make it the (only) selection.
              var item = (scope.vm.items || []).find(function (x) {
                return String(x.id_media) === String(mediaId);
              });
              angular.element(document.querySelectorAll('.grid-element.box-selected'))
                .removeClass('box-selected').attr('draggable', 'false');
              angular.element(gridEl).addClass('box-selected').attr('draggable', 'true');
              scope.vm.selectedThreads = item ? [item] : [];
              scope.$applyAsync();
            }

            handleDragStart(event);
          }

          function endSelection() {
            stopAutoScroll();
            if (selectionBox) {
              selectionBox.remove();
              selectionBox = null;
            }

            document.body.style.userSelect = '';

            if (scrollHandler) {
              window.removeEventListener('scroll', scrollHandler, true);
              scrollHandler = null;
            }

            $document.off('mousemove', onMouseMove);
            $document.off('mouseup', endSelection);
            $document.off('mouseleave', endSelection);
          }

          // Delegated drag listeners for the whole grid (cover every item, selected or not).
          element.on('dragstart', onGridDragStart);
          element.on('dragend', handleDragEnd);

          element.on('mousedown', function (event) {
            if (event.button !== 0 || isDragging) return;

            var grabbedEl = event.target.closest('.grid-element');
            if (grabbedEl) {
              // Make any item draggable the moment it's grabbed, so it can be dragged
              // without having to select it first (dragstart handles single vs. selection).
              grabbedEl.setAttribute('draggable', 'true');
              return;
            }

            let mouseUpFired = false;

            const mouseUpHandler = (e) => {
              mouseUpFired = true;
              $document.off('mouseup', mouseUpHandler);

              if (e.target.closest('.grid-element')) {
                return;
              }

              angular.element(document.querySelectorAll('.grid-element.box-selected')).removeClass('box-selected');
              angular.element(document.querySelectorAll('.selection-box')).remove();
              scope.vm.selectedThreads = [];
              scope.$apply();
            };

            $document.on('mouseup', mouseUpHandler);

            setTimeout(() => {
              $document.off('mouseup', mouseUpHandler);

              if (!mouseUpFired && !isDragging) {
                createSelectionBox(event);
              }
            }, 100);
          });
        }
      };
    }])
    .directive('droppable', function ($rootScope, $document) {
      return {
        restrict: 'A',
        link: function (scope, element, attrs) {
          let dragIndicator = angular.element('<div class="drag-indicator"></div>');
          angular.element(document.body).append(dragIndicator);

          element.on('dragover', function (event) {
            event.preventDefault();
            event.dataTransfer.dropEffect = "move";
            element.addClass('drag-over');
          });

          element.on('dragleave', function () {
            element.removeClass('drag-over');
          });

          element.on('drop', function (event) {
            event.preventDefault();
            element.removeClass('drag-over');
            dragIndicator.hide();

            // let data = event.dataTransfer.getData("text");
            // let items = JSON.parse(data);
            let galleryId = attrs.galleryId;

            scope.$apply(function () {
              $rootScope.dropToGallery(galleryId);
            });

            removeSelectionBox();
          });

          element.on('dragenter', function (event) {
            dragIndicator.show();
          });

          $document.on('dragover', function (event) {
            event.preventDefault();
            dragIndicator.text($rootScope.getDragLength());
            dragIndicator.css({
              top: event.pageY + 10 + 'px',
              left: event.pageX + 10 + 'px',
              display: 'block'
            });
          });

          $document.on('dragend drop', function () {
            dragIndicator.hide();
            removeSelectionBox();
          });

          function removeSelectionBox() {
            angular.element(document.querySelectorAll('.selection-box')).remove();
            document.body.style.userSelect = '';
          }

          scope.$on('$destroy', function () {
            dragIndicator.remove();
            $document.off('dragover');
            $document.off('dragend drop');
          });
        }
      };
    })
    .controller('MediaController', MediaController);


  /** @ngInject */
  function MediaController($stateParams, $mdDialog, $document, settingUserService, uploadService, mediaService, $mdMenu, requestContext, $anchorScroll,
    $timeout, $scope, $translate, $mdToast, $mdMedia, $sce, Upload, msUtils, COMMON, $log, sessionService, $state, $mdSidenav, $rootScope,
    transformMedia, tagsService, ivhTreeviewMgr, ivhTreeviewOptions, usersService, rekognitionService, $window) {

    var vm = this;
    vm.getSettingValue = settingUserService.getSettingValue;

    // Data
    vm.originalVideoCropformatId = 9999992;

    $rootScope.galleryDroppedLoading = false;

    vm.settingsSection = 'media-' + $stateParams.mediaType;
    vm.isOpenSidenavGalleries = vm.getSettingValue(vm.settingsSection, 'sidenavGalleriesOpen', true);
    vm.perPage = vm.getSettingValue(vm.settingsSection, 'pageSize', 50);
    $rootScope.perPage = vm.perPage;
    vm.showNideVar = true;
    vm.expandedids = [];

    $rootScope.pagination_galleryIds = false;
    vm.media_type = false;
    vm.media_type_name = $stateParams.mediaType;
    if (vm.media_type_name == 'galleries') {
      vm.hierarchyGalleries = [];
      vm.isRoot = true;
    }

    $rootScope.pagination_isLightbox = false;
    if (vm.media_type_name == 'lightbox') {
      vm.isLightbox = true;
      $rootScope.pagination_isLightbox = true;
    }

    angular.forEach(sessionService.site_operative.menu, function (value, key) {
      angular.forEach(value.tabs, function (tab, key) {
        if (tab.module_name == 'media' && tab.tab_name == vm.media_type_name) {
          vm.media_type = parseInt(tab.extra);
        }
      });
    });

    if (vm.media_type === false) {
      $state.go('app.dashboards');
    }
    // vm.defaultPage = 1;
    // vm.defaultPerPage = 50;
    // vm.PerPage = 50;

    vm.searchStringFilter = '';
    vm.searchQuery = '';
    vm.modelSearch = '';
    vm.treeSearch = '';
    vm.viewSortType = '';

    vm.joinClipsWindow = joinClipsWindow;
    vm.openGallery = openGallery;
    vm.handleGallerySelect = handleGallerySelect;
    vm.AddmediaDialog = AddmediaDialog;
    vm.AddMediaItemToGalleryDialog = AddMediaItemToGalleryDialog;
    vm.RemoveMediaItemFromGalleryDialog = RemoveMediaItemFromGalleryDialog;
    vm.EditMultipleFieldsDialog = EditMultipleFieldsDialog;
    vm.downloadSelected = downloadSelected;
    vm.selectMediaFile = selectMediaFile;
    vm.selectMediaFileSidenav = selectMediaFileSidenav;
    vm.openGalleryFolder = openGalleryFolder;
    vm.backToGallery = backToGallery;
    vm.rekognitionDialog = rekognitionDialog;
    vm.selectedThreads = [];
    vm.isLoading = true;
    vm.enterfirst = true;
    vm.isTiny = false;
    vm.openMenu = openMenu;
    vm.shareDialog = shareDialog;
    vm.openFace = openFace;
    vm.openGalleryDialog = openGalleryDialog;
    vm.dropToGallery = dropToGallery;
    vm.views = {
      1: 'app/main/apps/media/views/grid-view.html'
    };

    vm.views = {
      nosplit: 'app/main/apps/media/views/nosplit-view.html',
      split: 'app/main/apps/media/views/split-view.html'
    };

    vm.viewslist = {
      gridGoogle: 3,
      list: 2,
      grid: 1
    };
    vm.subviews = {
      1: 'app/main/apps/media/views/list/subviews/photos-view.html',
      2: 'app/main/apps/media/views/list/subviews/videos-view.html',
      3: 'app/main/apps/media/views/list/subviews/audios-view.html',
      4: 'app/main/apps/media/views/list/subviews/files-view.html',
      list: 'app/main/apps/media/views/list/subviews/list-view.html',
      upload: 'app/main/apps/media/views/list/subviews/upload-view.html',
      import: 'app/main/apps/media/views/list/subviews/import-view.html'
    };


    vm.defaultView = 'split';
    vm.currentView = 'split';

    vm.defaultListView = vm.getSettingValue(vm.settingsSection, 'defaultView', "grid");
    vm.currentListView = vm.getSettingValue(vm.settingsSection, 'defaultView', "grid");

    vm.changeListView = changeListView;

    vm.mediaSelected = false;

    vm.viewsTiny = {
      1: 'app/main/dialogs/media/views/tiny-attached.html',
      properties: 'app/main/dialogs/media/views/tiny-properties.html',
      upload: 'app/main/dialogs/media/views/upload-view.html'
    };
    vm.defaultViewTiny = '1';
    vm.currentViewTiny = '1';

    vm.firstLoad = true;
    vm.showSearchAndPaginator = true;
    vm.import_field = '';
    vm.import_disabled = '';
    vm.importedFiles = [];
    vm.importPreview = false;
    vm.imported = false;
    vm.importing = false;
    vm.selectedContacts = [];
    vm.files = [];
    vm.uploadedFiles = [];
    vm.tinyProperties = {
      mediaType: '',
      mediaSort: '',
      mediaData: {},
      align: '',
      size: ''
    };
    vm.CleanMediaGalleries = false;
    vm.includeSubgalleries = false;
    vm.searchTagText = null;
    vm.selectedTag = null;
    vm.newTagDisabled = false;
    vm.showCropformats = false;
    vm.nodeExpanded = [];

    vm.orderByGalleries = {
      "MEDIA.NAME": "gallery_name",
      "MEDIA.DATE": "date",
      "MEDIA.SORT": "sort"
    };

    vm.collapseAndExpand = {
      "MEDIA.COLLAPSE": "collapse_all",
      "MEDIA.EXPAND": "expand_all"
    };

    vm.mediaGalleryRestrictions = null;

    // Methods
    vm.toggleSidenav = toggleSidenav;
    vm.closeDialog = closeDialog;

    vm.setNewPerPageSize = setNewPerPageSize;
    vm.setSortField = setSortField;
    vm.setSortDir = setSortDir;
    vm.setGalleriesSortField = setGalleriesSortField;
    vm.setGalleriesSortDir = setGalleriesSortDir;

    vm.upload = upload;
    vm.attachMedia = attachMedia;
    vm.attachMediaTiny = attachMediaTiny;
    vm.selectMediaTiny = selectMediaTiny;
    vm.selectedMediaTiny = '';

    vm.openImageDialog = openImageDialog;
    vm.openFocalPoint = openFocalPoint;
    vm.saveImage = saveImage;
    vm.viewEditInline = viewEditInline;
    vm.closeMediaPreview = closeMediaPreview;

    vm.exists = msUtils.exists;
    vm.openUrl = msUtils.openUrl;
    vm.alreadySelectedbyZone = alreadySelectedbyZone;
    vm.existInArray = msUtils.existInArray;
    vm.getInArray = msUtils.getInArray;
    vm.toggleInArray = msUtils.toggleInArray;
    vm.toggleInGroup = msUtils.toggleInGroup;
    vm.getExtension = msUtils.getExtension;
    vm.getExtensionIcon = msUtils.getExtensionIcon;
    vm.removeObjectsFromArrayByProperty = msUtils.removeObjectsFromArrayByProperty;

    vm.toggleSelectContact = toggleSelectContact;
    vm.isProcessingItem = isProcessingItem;
    vm.copyLink = copyLink;
    vm.copyVideoLink = copyVideoLink;
    vm.timeAgo = msUtils.timeAgo;

    vm.isSelected = isSelected;
    vm.toggleSelectThread = toggleSelectThread;
    vm.selectThreads = selectThreads;
    vm.deselectThreads = deselectThreads;
    vm.toggleSelectThreads = toggleSelectThreads;

    vm.MediaItemRecrop = MediaItemRecrop;
    vm.MediaItemRecropSingleFormat = MediaItemRecropSingleFormat;
    vm.MediaItemRecropAllFormats = MediaItemRecropAllFormats;
    vm.logResize = logResize;
    vm.cols = 6;

    vm.dateFormat = sessionService.site_operative.dateFormat;
    vm.dateTimeFormat = sessionService.site_operative.dateTimeFormat;
    vm.showDate = showDate;
    vm.updateDatePicker = updateDatePicker;

    vm.deleteMediaItem = deleteMediaItem;
    vm.cancelMediaGalleries = cancelMediaGalleries;
    vm.openGallerySidenav = openGallerySidenav;
    vm.toggleIncludeSubgalleries = toggleIncludeSubgalleries;
    vm.unselectGalleries = unselectGalleries;
    vm.createGallery = createGallery;
    vm.changeVideoThumb = changeVideoThumb;
    vm.massRecropMedia = massRecropMedia

    vm.translate = function (text) {
      return $translate.instant(text);
    }


    vm.createFilterFor = createFilterFor;
    vm.selectedItemChange = selectedItemChange;
    vm.labelQuerySearch = labelQuerySearch;
    vm.newTag = newTag;
    vm.tags = sessionService.site_operative.tags;
    vm.showCropformatsTab = showCropformatsTab;
    vm.deleteGallery = deleteGallery;
    vm.editGallery = editGallery;
    vm.getContainerData = getContainerData;
    vm.setLastToggle = setLastToggle;
    vm.getCleanMediaGalleries = getCleanMediaGalleries;
    vm.openSelectMediaDialog = openSelectMediaDialog;
    vm.deleteMediaChild = deleteMediaChild;
    vm.collapseAndExpandFunction = collapseAndExpandFunction;
    vm.getUncroppedMedias = getUncroppedMedias;
    vm.resetUncropped = resetUncropped;

    vm.parseDotNotation = parseDotNotation;

    vm.applyFilters = applyFilters;

    vm.expandGalleries = expandGalleries;

    function dropToGallery(galleryId) {
      if (!vm.selectedThreads || vm.selectedThreads.length === 0) {
        return;
      }

      var sourceGalleryId = vm.selectedGallery ? vm.selectedGallery.id_gallery : null;

      // Same source and target → nothing to do
      if (sourceGalleryId == galleryId) {
        return;
      }

      if (vm.selectedGallery) {
        // Dropping from inside a gallery → let the user choose Move / Copy / Cancel
        showMediaMoveCopyDialog(galleryId, sourceGalleryId);
      } else {
        // All Media (no source gallery) → add to gallery (copy)
        copyMediaToGallery(galleryId);
      }
    }

    function showMediaMoveCopyDialog(targetGalleryId, sourceGalleryId) {
      $mdDialog.show({
        parent: angular.element(document.body),
        template:
          '<md-dialog aria-label="Move or Copy">' +
          '  <form>' +
          '    <md-dialog-content class="md-dialog-content">' +
          '      <h2 class="md-title" translate="MEDIA.DND_CONFIRM_TITLE"></h2>' +
          '      <div class="md-dialog-content-body">' +
          '        <p translate="MEDIA.DND_CONFIRM_CONTENT"></p>' +
          '      </div>' +
          '    </md-dialog-content>' +
          '    <md-dialog-actions layout="row">' +
          '      <md-button ng-click="cancel()" translate="MEDIA.CANCEL"></md-button>' +
          '      <span flex></span>' +
          '      <md-button ng-click="copy()" translate="MEDIA.COPY"></md-button>' +
          '      <md-button class="md-primary" ng-click="move()" translate="MEDIA.MOVE"></md-button>' +
          '    </md-dialog-actions>' +
          '  </form>' +
          '</md-dialog>',
        controller: function ($scope, $mdDialog) {
          $scope.move = function () { $mdDialog.hide('move'); };
          $scope.copy = function () { $mdDialog.hide('copy'); };
          $scope.cancel = function () { $mdDialog.cancel(); };
        }
      }).then(function (result) {
        if (result === 'move') {
          moveMediaToGallery(targetGalleryId, sourceGalleryId);
        } else if (result === 'copy') {
          copyMediaToGallery(targetGalleryId);
        }
      });
    }

    function copyMediaToGallery(galleryId) {
      var mediaIDs = vm.selectedThreads.map(function (item) { return item.id_media; });
      $rootScope.galleryDroppedLoading = true;
      var options = {
        site: $scope.siteID,
        data: {
          id_media: mediaIDs,
          id_gallery: [galleryId]
        }
      };
      mediaService.insertIntoGallery(options).then(function () {
        onDropToGalleryComplete(mediaIDs.length, 'MEDIA.ADDTOGALLERIES_PLURAL');
      }).catch(function (err) {
        console.error('Error copying media to gallery', err);
        $rootScope.galleryDroppedLoading = false;
      });
    }

    function moveMediaToGallery(targetGalleryId, sourceGalleryId) {
      var mediaIDs = vm.selectedThreads.map(function (item) { return item.id_media; });
      $rootScope.galleryDroppedLoading = true;
      var insertOptions = {
        site: $scope.siteID,
        data: {
          id_media: mediaIDs,
          id_gallery: [targetGalleryId]
        }
      };
      // Move = add to the target gallery, then remove from the source gallery.
      mediaService.insertIntoGallery(insertOptions).then(function () {
        return mediaService.removeFromGallery($scope.siteID, {
          id_gallery: sourceGalleryId,
          id_media: mediaIDs
        });
      }).then(function () {
        onDropToGalleryComplete(mediaIDs.length, 'MEDIA.MOVETOGALLERIES_PLURAL');
      }).catch(function (err) {
        console.error('Error moving media to gallery', err);
        $rootScope.galleryDroppedLoading = false;
      });
    }

    function onDropToGalleryComplete(count, messageKey) {
      var message = $translate.instant(messageKey);
      $mdToast.show({
        template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + count + message + '</span></div></md-toast>',
        hideDelay: 7000,
        position: 'top right',
        parent: '#main'
      });
      $rootScope.galleryDroppedLoading = false;
      vm.closeMediaPreview();
      vm.deselectThreads();
      $rootScope.pagination_resetquery();
      getCleanMediaGalleries();
    }

    $rootScope.dropToGallery = vm.dropToGallery;

    /**
     * Download selected media items as a zip file.
     */
    function downloadSelected(ev) {
      if (!vm.selectedThreads || vm.selectedThreads.length === 0) return;

      var mediaIds = vm.selectedThreads.map(function (item) {
        return item.id_media || item.id;
      });

      var options = {
        domain: $scope.siteID,
        mediaIds: mediaIds,
        title: 'Media_Download_' + moment().format('YYYYMMDD_HHmmss')
      };

      mediaService.downloadMediasZip(options).then(function (response) {
        if (response && response.zip_url) {
          // Open the URL to trigger download in a new tab
          $window.open(response.zip_url, '_blank');
          vm.showToast($translate.instant('MEDIA.DOWNLOAD_STARTED') || 'Download started');
        } else {
          vm.showErrorToast($translate.instant('MEDIA.DOWNLOAD_ERROR_LINK') || 'Error generating download link');
        }
      }).catch(function (err) {
        $log.error('[media] Error downloading medias', err);
        vm.showErrorToast($translate.instant('MEDIA.DOWNLOAD_ERROR') || 'Error downloading selected items');
      });
    }

    $rootScope.getDragLength = function () {
      return vm.selectedThreads.length;
    };

    function expandGalleries(arr) {
      if (vm.treeSearch.length == 0) {
        vm.expandedids = [];
        return;
      }
      if (!arr) {
        arr = vm.CleanMediaGalleries;
      }
      angular.forEach(arr, function (item) {
        vm.expandedids.push(item.id_gallery);
        if (item.children && item.children.length) {
          expandGalleries(item.children);
        }
      });
    }

    function parseDotNotation(obj, dotNotationString) {

      var parts = dotNotationString.split('.');
      for (var i = 0; i < parts.length; i++) {
        if (obj && obj.hasOwnProperty(parts[i])) {
          obj = obj[parts[i]];
        } else {
          return false;
        }
      }
      return obj;
    }

    vm.mediaSortable = {
      group: 'media',
      dataIdAttr: 'data-id',
      scroll: true,
      filter: '.no-sort',
      handle: '.sortable',
      onEnd: function (evt) {
        // vm.isLoading = true;

        var oldSort = evt.model.sort;
        var items = [];

        // Reassign sort values for affected items
        if (evt.newIndex > evt.oldIndex) {
          evt.model.sort = evt.models[evt.newIndex - 1].sort;
          for (var i = evt.newIndex - 1; i > evt.oldIndex; i--) {
            evt.models[i].sort = evt.models[i - 1].sort;
            items.push(evt.models[i]);
          }
        }
        if (evt.newIndex < evt.oldIndex) {
          evt.model.sort = evt.models[evt.newIndex + 1].sort;
          for (var i = evt.newIndex + 1; i < evt.oldIndex; i++) {
            evt.models[i].sort = evt.models[i + 1].sort;
            items.push(evt.models[i]);
          }
        }
        evt.models[evt.oldIndex].sort = oldSort;
        items.push(evt.models[evt.oldIndex]);
        items.push(evt.model);
      }
    };

    $scope.$watch(
      function () {
        return vm.selectedThreads.length;
      },
      function (newVal) {
        vm.mediaSortable.disabled = newVal != 0;
      }
    );

    function deleteGallery(ev, gallery) {
      var confirmTitle = $translate.instant('GALLERY.DELETE_CONFIRM_TITLE', { gallery_name: gallery.gallery_name });
      var confirmText = $translate.instant('GALLERY.DELETE_CONFIRM_TEXT');
      var confirm = $mdDialog.confirm()
        .title(confirmTitle)
        .textContent(confirmText)
        .ariaLabel(confirmTitle)
        .targetEvent(ev)
        .ok('OK')
        .cancel($translate.instant('CANCEL'))
        .multiple(true);

      $mdDialog.show(confirm).then(function () {
        mediaService
          .deleteMediaGallery($scope.siteID, gallery.id_gallery)
          .then(function (response) {
            mediaService.triggerReloadGalleries();
          });
      });
    }
    function editGallery(gallery) {
      mediaService.triggerGalleryDialog(gallery);
    }

    function getContainerData(id_container, field) {
      var container = sessionService.getContainerByID(id_container);
      return container[field];

    }
    function shareDialog(ev) {
      $mdDialog.show({
        controller: 'ShareDialogController',
        controllerAs: 'vm',
        locals: {
          medias: vm.selectedThreads
        },
        templateUrl: 'app/main/apps/media/dialogs/share-dialog/share-dialog.controller.html',
        targetEvent: ev,
        multiple: true,
        clickOutsideToClose: false
      }).then(function (response) {
        if (!response) {
          vm.selectedThreads = [];
        }
      });

    }
    function openFace(faceItem) {
      var options = {
        siteID: $scope.siteID,
        item: {
          faces: [faceItem.Face.FaceId]
        }
      }
      mediaService.getFacesRelated(options).then(res => {
        vm.facesRelated = res.map(image => {
          var mediaContainer = sessionService.getContainerByID(image.media.cdnContainer);
          image.media.imageUrlOriginal = mediaContainer.view_url + 'original/m' + image.media.id_media + '_' + image.media.filename;
          return image;
        })
      })
    }

    var originatorEv;

    function openMenu($mdMenu, ev) {
      originatorEv = ev;
      $mdMenu.open(ev);
    }
    function isProcessingItem(mediaItem) {
      return mediaItem.meta_analyses && typeof mediaItem.meta_analyses.rekognition_detect_text == 'undefined';
    }

    function copyLink(link) {
      var dummy = document.createElement("textarea");
      document.body.appendChild(dummy);
      dummy.value = link;
      dummy.select();
      document.execCommand("copy");
      document.body.removeChild(dummy);
      var message = $translate.instant('GLOBAL.COPIED_TO_CLIPBOARD');
      $mdToast.show({
        template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
        hideDelay: 2000,
        position: 'top',
        parent: '#content-container'
      });
    }

    function copyVideoLink(video) {
      for (var i = video.cropstatus_videos.length - 1; i >= 0; i--) {
        if (video.cropstatus_videos[i].id_cropformats == vm.originalVideoCropformatId) { // ORIGINAL
          var container = sessionService.getContainerByID(video.cropstatus_videos[i].id_container);
          var link = container.url + '/' + container.sourceBucket + '/' + container.sourceKeyPrefix + video.cropstatus_videos[i].fileName;
        }
      }
      if (link) {
        copyLink(link);
      }
    }

    vm.gallerySortable = {
      group: 'media',
      dataIdAttr: 'data-id',
      scroll: true,
      filter: '.no-sort',
      handle: '.sortable',
      disabled: vm.sortFieldGalleries != 'sort',
      onEnd: function (evt) {
        vm.isLoading = true;

        var oldSort = evt.model.sort;
        var items = [];

        // Reassign sort values for affected items
        var newSort = 1;
        if (evt.newIndex > 0) {
          var preceedingModel = evt.models[evt.newIndex - 1];
          newSort = preceedingModel.sort + 1;
        }
        evt.model.sort = newSort;
        items.push(evt.model);
        // Upcount sort for subsequent models
        for (var i = evt.newIndex + 1; i < evt.models.length; i++) {
          newSort++;
          evt.models[i].sort = newSort;
          items.push(evt.models[i]);
        }
        /*
        if (evt.newIndex > evt.oldIndex) {
          evt.model.sort = evt.models[evt.newIndex - 1].sort;
          for (var i = evt.newIndex - 1; i > evt.oldIndex; i--) {
            evt.models[i].sort = evt.models[i - 1].sort;
            items.push(evt.models[i]);
          }
        }
        if (evt.newIndex < evt.oldIndex) {
          evt.model.sort = evt.models[evt.newIndex + 1].sort;
          for (var i = evt.newIndex + 1; i < evt.oldIndex; i++) {
            evt.models[i].sort = evt.models[i + 1].sort;
            items.push(evt.models[i]);
          }
        }
        evt.models[evt.oldIndex].sort = oldSort;
        items.push(evt.models[evt.oldIndex]);
        items.push(evt.model);
        */

        var options = {
          items: items,
          fields: ['sort']
        };
        mediaService.updateSortGallery($scope.siteID, options)
          .then(function (response) {
            vm.isLoading = false;
          });
      }
    };
    //////////

    var siteID = requestContext.getParam("siteId");
    init();

    /**
     * Initialize
     */
    function init() {

      vm.loading = true;
      $scope.siteID = requestContext.getParam("siteId");
      $scope.section = requestContext.getParam("section");
      $rootScope.global.titleToolbar = '<i class="icon s20 icon-camera mr-15" ng-if="node.icon"></i> <span class="hide show-gt-xs">' + $translate.instant('MEDIA.MEDIA') + ' </span> <i class="mr-5 ml-5 icon s18 icon-chevron-right hide show-gt-xs"></i> ' + vm.media_type_name;
      // for (var i = 0; i < vm.currentThread.Thumbnail.length; i++) {
      //  vm.selectedContacts.push(vm.currentThread.Thumbnail[i]);
      // }

      if ($state.params.id) {
        vm.selectMediaFile(null, $state.params.id);
      }

      if (sessionService.site_operative.mediaGalleriesDefaultSort) {
        vm.sortFieldGalleries = sessionService.site_operative.mediaGalleriesDefaultSort.field;
        if (!angular.isUndefined(sessionService.site_operative.mediaGalleriesDefaultSort.dir)) {
          vm.sortDirGalleries = sessionService.site_operative.mediaGalleriesDefaultSort.dir;
        }
      } else {
        vm.sortFieldGalleries = "gallery_name";
        vm.sortDirGalleries = "ASC"
      }

      getCleanMediaGalleries();
      getMediaRef();
      recropUncropped();
      getTagsTypes();

      sessionService.loadDomainResourceSettings($scope.siteID).then(function (response) {
        if (response.public) {
          var publicConfig = angular.fromJson(response.public);
          sessionService.authenticate(siteID).then(function (response) {
            if (publicConfig.adminAccounts && publicConfig.adminAccounts.indexOf(response.account.email) != -1) {
              vm.isAdmin = true;
            } else {
              vm.isAdmin = false;
            }
          });
        }
      });
      mediaService.getFilters({ site: siteID }).then(function (response) {
        $scope.filtersToSelect = angular.copy(response.filters);
        var i = 0;
        for (i in $scope.filtersToSelect) {
          switch ($scope.filtersToSelect[i].field) {
            case "tags":
              $scope.filtersToSelect[i].selected = [];
              $scope.filtersToSelect[i].values = vm.tags;
              break;
            case "status":
              $scope.filtersToSelect[i].values = [
                {
                  name: "",
                  value: 0
                },
                {
                  name: angular.copy($scope.filtersToSelect[i].name),
                  value: 1
                }
              ]
              break;
            default:
              $scope.filtersToSelect[i].selected = [];
              break;
          }
        }
        // vm.mediaZones = (response.media_zones.length == 0)
        //     ? null
        //     : angular.copy(response.media_zones);
      });
    }
    function applyFilters() {
      var i = 0;
      for (i in $scope.filtersToSelect) {
        $scope.refFilterables[i].selected = angular.copy($scope.filtersToSelect[i].selected);
      }
    }
    //TODO reset uncropped filter
    function resetUncropped() {
      vm.uncroppedFilesOnly = false;
    }
    function getUncroppedMedias() {
      var path = window.location.pathname.split('/');
      var mediaTypes = [];
      switch (path[path.length - 1]) {
        case "all":
          mediaTypes.push(1);
          mediaTypes.push(2);
          break;
        case "photos":
          mediaTypes.push(1);
          break;
        case "videos":
          mediaTypes.push(2);
          break;
      }
      vm.isLoading = true;
      // vm.uncroppedFilesOnly = true;
      var options = {
        siteID: $scope.siteID,
        section: $scope.section,
        sortDir: $rootScope.sortDir,
        sortField: $rootScope.sortField,
        resultsPerPage: $rootScope.perPage,
        filters: $rootScope.filters,
        withCropStatus: false,
        isUncropped: true,
        filters: {
          media_type:
          {
            field: "media_type",
            name: "media_type",
            selected: mediaTypes
          }
        }
      };
      if (vm.media_type != 0) {
        options.media_type = vm.media_type;
      }
      mediaService.get(options).then(function (response) {
        vm.items = response.data;
        $rootScope.pagination_totalItems = response.total;
        $rootScope.pagination_total_pages = response.last_page;
        // $rootScope.pagination_page = response.current_page;
        vm.isLoading = false;
      });
    }

    function recropUncropped() {
      mediaService.getAllUncroppedMediaIds()
        .then(function (response) {
          if (angular.isArray(response) && response.length > 0) {
            var uniqueMediaIds = [];
            angular.forEach(response, function (mediaId) {
              if (!uniqueMediaIds.includes(mediaId)) {
                uniqueMediaIds.push(mediaId);
              }
            })
            var options = {
              mediaIds: uniqueMediaIds
            }
            mediaService.cropMissingFormatsMultiple(options);
          }
        })
    }

    function setLastToggle(node) {
      var id = node.id;
      var pos = vm.nodeExpanded.indexOf(id);
      if (pos == -1) {
        vm.nodeExpanded.push(id);
      } else {
        vm.nodeExpanded.splice(pos, 1);
      };
    };


    function openSelectMediaDialog(ev) {
      $mdDialog.show({
        controller: 'SelectMediaToJoinDialogController',
        controllerAs: 'vm',
        locals: {
          alreadySelected: vm.image.children,
          media_type: null
        },
        templateUrl: 'app/main/dialogs/select-media-to-join/select-media-to-join-dialog.controller.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        multiple: true,
        clickOutsideToClose: true
      }).then(function (res) {
        if (res) {
          var count = 0;
          res.forEach(element => {
            count++;
            element.parent = vm.image.id_media;
            element.tags = getTagIdsFromTags(element.tags);
            var options = {
              site: $scope.siteID,
              id: element.id_media,
              item: element
            };
            mediaService.saveMedia(options)
              .then(function (response) {
                count--;
                if (count == 0) {
                  vm.selectMediaFile(vm.image);
                }
              });

          });
        }
      });
    }
    function deleteMediaChild(element, tab) {

      element.parent = null;
      var options = {
        site: $scope.siteID,
        id: element.id_media,
        item: element
      };
      mediaService.saveMedia(options)
        .then(function (response) {
          vm.selectMediaFile(vm.image);
        });

    }

    function getMediaRef() {
      var options = {
        site: $scope.siteID,
      };
      mediaService.getMediaRef(options).then(function (response) {
        vm.mediaRef = response;
        if (angular.isArray(vm.mediaRef)) {
          vm.mediaRefMetadata = vm.mediaRef.filter(function (ref) {
            return ref.type == 'metadata';
          })
        }
      })
    }

    function getCleanMediaGalleries() {
      vm.scrolledGaleries = $('#sidenav-galleries-wrapp').scrollTop();
      vm.loadingGalleries = true;
      var options = {
        domain: $scope.siteID,
        siteID: $scope.siteID,
        sortField: vm.sortFieldGalleries,
        sortDir: vm.sortDirGalleries
      };
      if (vm.media_type_name != 'galleries') {
        if (vm.media_type == undefined) {
          options.gallery_type = 1;
        } else if (vm.media_type == 0) {
          options.gallery_type = 0;
        } else if (angular.isNumber(vm.media_type)) {
          options.gallery_type = [vm.media_type, 0];
        }
      }
      options.is_lightbox = vm.isLightbox ? true : false;
      options.withTotalMediaCount = vm.media_type_name == 'galleries';
      options.withCover = vm.media_type_name == 'galleries';
      mediaService.getNestedMediaGalleries(options)
        .then(function (response) {
          var qiuRestrictions = response.qiuRestrictions;
          vm.mediaGalleryRestrictions = angular.copy(qiuRestrictions);
          var galleries = response.data;
          vm.CleanMediaGalleries = transformMedia.formatNestedGalleries(galleries, qiuRestrictions, true);
          transformMedia.preAssignQiuRestrictedRoot(vm.CleanMediaGalleries);

          if (vm.media_type_name == 'galleries') {
            vm.selectedGalleryChildren = angular.copy(vm.CleanMediaGalleries);
            vm.isRoot = true;
            if (vm.hierarchyGalleries.length > 0) {
              updateHierarchy();
            }
          }

          if (vm.isLightbox) {
            var lightboxOwnerIds = getGalleriesOwnerIds(vm.CleanMediaGalleries, []);
            var options = {
              siteID: $scope.siteID,
              userIds: lightboxOwnerIds
            };
            usersService.getUsers(options).then(function (response) {
              var owners = response.result.data;
              transformMedia.assignLightboxOwners(vm.CleanMediaGalleries, owners);
            })
          }

          if (vm.nodeExpanded.length > 0) {
            angular.forEach(vm.nodeExpanded, function (id) {
              ivhTreeviewMgr.expand(vm.CleanMediaGalleries, id);
            });
          }
          if (vm.scrolledGaleries) {
            setTimeout(() => {
              $('#sidenav-galleries-wrapp').scrollTop(vm.scrolledGaleries)
            }, 10);
          }
          if (vm.CleanMediaGalleries[0] && vm.CleanMediaGalleries[0].is_qiu_restricted_root) {
            openGallery(vm.CleanMediaGalleries[0])
          }
          vm.isLoading = false;
          vm.loadingGalleries = false;
        });
    }

    /**
     * Collapse / expand all of the galleries tree of tab-galleries.
     *
     * It used to add and remove the 'ivh-treeview-node-collapsed' class by hand on every
     * .ivh-treeview-node of the page, which reached other trees and left the class out of
     * sync with the model. Now that the branches are built as they open, touching the css
     * would show nothing at all, so it goes through the model like <mv-tree-expander>.
     *
     * Beware that expanding everything on a tenant with a thousand galleries does build
     * all of them, which is exactly what this tab used to do on every media selection.
     */
    function collapseAndExpandFunction() {
      var tree = vm.CleanMediaGalleriesWithMediaAssignment;
      if (!tree) {
        return;
      }
      if (vm.collapseAndExpandValue === 'expand_all') {
        ivhTreeviewMgr.expandRecursive(tree);
      } else if (vm.collapseAndExpandValue === 'collapse_all') {
        ivhTreeviewMgr.collapseRecursive(tree);
      }
    }

    function setSortDir(sortDir) {
      if (vm.selectedGallery) {
        settingUserService.setSetting(vm.settingsSection, 'sortDirInGallery', sortDir);
        $rootScope.pagination_setSortField(sortDir);
      } else {
        settingUserService.setSetting(vm.settingsSection, 'sortDir', sortDir);
        $rootScope.pagination_setSortField(sortDir);
      }
    }
    function setSortField(sortField) {
      if (vm.selectedGallery) {
        settingUserService.setSetting(vm.settingsSection, 'sortFieldInGallery', sortField);
        $rootScope.pagination_setSortField(sortField);
      } else {
        settingUserService.setSetting(vm.settingsSection, 'sortField', sortField);
        $rootScope.pagination_setSortField(sortField);
      }
    }
    function setGalleriesSortDir(sortDir) {
      vm.sortDirGalleries = sortDir;
      getCleanMediaGalleries();
    }
    function setGalleriesSortField(sortField) {
      vm.sortFieldGalleries = sortField;
      getCleanMediaGalleries();
    }
    function setNewPerPageSize(size) {
      vm.perPage = size;
      $rootScope.perPage = size;
      settingUserService.setSetting(vm.settingsSection, 'pageSize', size);
      $rootScope.pagination_resetquery();
    }
    function cancelMediaGalleries() {
      settingUserService.setSetting(vm.settingsSection, 'sidenavGalleriesOpen', false)
      vm.toggleSidenav('galleries-sidenav')
    }
    function openGallerySidenav() {
      settingUserService.setSetting(vm.settingsSection, 'sidenavGalleriesOpen', true)
      vm.toggleSidenav('galleries-sidenav')
    }

    function getGalleriesOwnerIds(galleries, response) {
      for (var i = 0; i < galleries.length; i++) {
        if (galleries[i].raw_settings &&
          galleries[i].raw_settings.hasOwnProperty('lightbox') &&
          galleries[i].raw_settings.lightbox.hasOwnProperty('owner') &&
          !response.includes(galleries[i].raw_settings.lightbox.owner)
        ) {
          response.push(galleries[i].raw_settings.lightbox.owner);
        }
        if (galleries[i].children) {
          getGalleriesOwnerIds(galleries[i].children, response)
        }
      }
      return response;
    }

    function updateHierarchy() {
      var result = [];
      for (var i = 0; i < vm.hierarchyGalleries.length; i++) {
        const element = vm.hierarchyGalleries[i];
        var gallery = findGallery(vm.CleanMediaGalleries, element);
        result.push(gallery);
      }
      vm.hierarchyGalleries = result;
      var last = vm.hierarchyGalleries.splice(-1)
      openGalleryFolder(last[0]);
    }

    function findGallery(galleries, gallery) {
      var result = null;
      for (var i = 0; i < galleries.length; i++) {
        const element = galleries[i];
        if (element.id_gallery == gallery.id_gallery) {
          result = element;
          break;
        } else if (element.children) {
          result = findGallery(element.children, gallery);
          if (result != null) {
            break;
          }
        }
      }
      return result;
    }

    function logResize(size) {

      if (size.width >= 1635) {
        var cols = 5;
      } else if (size.width >= 1300) {
        var cols = 4;
      } else if (size.width >= 1000) {
        var cols = 3;

      } else if (size.width >= 600) {
        var cols = 2;

      } else if (size.width >= 1) {
        var cols = 1;

      }
      $scope.$safeApply(function () {
        vm.cols = cols;
      });

    };

    // Watch screen size to change view modes
    $scope.$watch(function () {
      return $mdMedia('lt-sm');
    }, function (current, old) {
      if (angular.equals(current, old)) {
        return;
      }

      if (current) {
        vm.currentView = 'nosplit';
      }
    });

    $scope.$watch(function () {
      return $mdMedia('max-width: 960px');
    }, function (big) {

      if (big)
        vm.currentView = 'nosplit';

    });

    $scope.$watch(function () {
      return $mdMedia('min-width: 960px');
    }, function (small) {

      if (small)
        vm.currentView = 'split';

    });

    $scope.$watch(function () {
      return $mdMedia('gt-sm');
    }, function (current, old) {
      if (angular.equals(current, old)) {
        return;
      }

      if (current) {
        if (vm.defaultView === 'split') {
          vm.currentView = 'split';
        }
      }
    });

    $scope.$on('loadMediaByGalleries', function (event, galleries) {
      if (galleries) {
        loadMediaByGalleries(galleries);
      } else {
        unselectGalleries();
      }
    });

    $scope.$on('reloadGalleries', function () {
      getCleanMediaGalleries();
    });

    $scope.$on('closeSidenav', function (ev, sidenavId) {
      $mdSidenav(sidenavId).close();
    })

    function loadMediaByGalleries(galleries) {
      vm.isLoading = true;
      vm.deselectThreads();
      var galleryIds = [];
      angular.forEach(galleries, function (gallery) {
        galleryIds.push(gallery.id_gallery);
      });
      vm.selectedGallery = galleries[0];
      $rootScope.sortField = vm.getSettingValue(vm.settingsSection, 'sortFieldInGallery', 'sort');
      $rootScope.sortDir = vm.getSettingValue(vm.settingsSection, 'sortDirInGallery', 'ASC');
      if (galleries.length == 1 && galleries[0].raw_settings) {
        $rootScope.filters = galleries[0].raw_settings.filters;
      }
      /*
      if (sessionService.site_operative.mediaInGalleriesDefaultSort) {
        $rootScope.sortField = sessionService.site_operative.mediaInGalleriesDefaultSort.field;
        if (!angular.isUndefined(sessionService.site_operative.mediaInGalleriesDefaultSort.dir)) {
          $rootScope.sortDir = sessionService.site_operative.mediaInGalleriesDefaultSort.dir;
        }
      } else {
        $rootScope.sortField = "sort";
      }
      */
      var options = {
        domain: $scope.siteID,
        siteID: $scope.siteID,
        galleryIds: galleryIds,
        sortDir: $rootScope.sortDir,
        sortField: $rootScope.sortField,
        resultsPerPage: $rootScope.perPage,
        filters: $rootScope.filters
      };
      mediaService.getMediaInGalleries(options).then(function (response) {
        $rootScope.pagination_galleryIds = galleryIds;
        vm.items = response.data;
        $rootScope.pagination_totalItems = response.total;
        $rootScope.pagination_total_pages = response.last_page;
        $rootScope.pagination_page = response.current_page;
        vm.isLoading = false;
      });
    }

    function unselectGalleries() {
      vm.selectedGallery = false;
      vm.selectedContent = false;
      vm.deselectThreads();
      $rootScope.pagination_galleryIds = false;
      $rootScope.sortDir = vm.getSettingValue(vm.settingsSection, 'sortDir', 'DESC'); // "DESC"; // reset to default
      $rootScope.sortField = vm.getSettingValue(vm.settingsSection, 'sortField', 'date_uploaded'); //"date_uploaded"; // reset to default
      settingUserService.setSetting(vm.settingsSection, 'sortField', $rootScope.sortField);
      $rootScope.pagination_setSortField($rootScope.sortField);
      var elemList = document.querySelectorAll('.gallery-row');
      elemList.forEach(function (elem) {
        elem.classList.remove('selected');
      });
      loadAllMedia();
    }

    function toggleIncludeSubgalleries() {
      vm.includeSubgalleries = !vm.includeSubgalleries;
      var element = $("#treeview-gallery-" + vm.selectedGallery.id_gallery);
      //var includeSubgalleries = $('#includeSubgalleries').attr("data-include-subgalleries") == 'true';
      mediaService.triggerMediaByGalleries(element.attr("data-gallery-node"), vm.includeSubgalleries);
    }

    function loadAllMedia() {
      vm.isLoading = true;
      var options = {
        siteID: $scope.siteID,
        section: $scope.section,
        sortDir: $rootScope.sortDir,
        sortField: $rootScope.sortField,
        resultsPerPage: $rootScope.perPage,
        filters: $rootScope.filters
      };
      if (vm.media_type != 0) {
        options.media_type = vm.media_type;
      }
      mediaService.get(options).then(function (response) {
        vm.items = response.data;
        $rootScope.pagination_totalItems = response.total;
        $rootScope.pagination_total_pages = response.last_page;
        $rootScope.pagination_page = response.current_page;
        vm.isLoading = false;
      });
    }

    $scope.filterByNumNotCurrentYears = function (item) {
      var num = parseInt(item.DetectedText);
      return !isNaN(item.DetectedText) && num < 10000 && num != 2018 && num != 2019 && num != 2020;
    };

    $scope.$on('pagination:loadStart', function (event) {
      // $anchorScroll();

      // Store the current scrollPos
      // vm.scrollPos = vm.scrollEl.scrollTop();

      // Scroll to the top
      // vm.scrollEl.scrollTop(0);
      if (!vm.enterfirst) {
        var elem = angular.element(document.getElementById('thread-list'));
        elem.scrollTopAnimated(0, 10);
      }

      // angular.element("#thread-list").scrollTop=0;
      vm.enterfirst = false;
      vm.isLoading = true;
    });

    $scope.$on('pagination:loadPage', function (event) {

      vm.dataAlreadyLoaded = true;

      $timeout(function () {
        if (vm.CleanMediaGalleries) {
          vm.isLoading = false;
        }
      }, 1000);
    });


    /**
     * Change the view
     *
     * @param view
     */
    function changeListView(view) {
      vm.isLoading = true;
      $timeout(function () {
        if (vm.viewslist[view]) {
          settingUserService.setSetting(vm.settingsSection, 'defaultView', view)
          vm.loadingListView = true;
          vm.defaultListView = view;
          vm.currentListView = view;
        }
        vm.isLoading = false;
      }, 1000);
    }

    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */
    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle().then(function () {
        if ($mdSidenav(sidenavId).isOpen()) {
          $timeout(function () {
            $scope.showSidenav = true;
          }, 500);
        } else {
          $scope.showSidenav = false;
        }
      });
    }

    /**
     * Open compose dialog
     *
     * @param ev
     */

    function AddmediaDialog(ev, mediazone, item, isReplace) {
      var mediaGalleries = vm.CleanMediaGalleries;
      if (vm.selectedGallery) {
        mediaGalleries = getGalleriesWithMediaAssignment(vm.CleanMediaGalleries, [vm.selectedGallery.id_gallery]);
      }
      $mdDialog.show({
        controller: 'AddMediaDialogController',
        controllerAs: 'vm',
        locals: {
          currentThread: vm.items,
          section: $scope.section,
          mediazone: mediazone,
          item: item,
          isReplace: isReplace,
          CleanMediaGalleries: mediaGalleries,
          isTiny: false,
          preselectedTags: []
        },
        templateUrl: 'app/main/apps/media/dialogs/media/media-dialog.html',
        parent: angular.element($document.body),
        multiple: true,
        targetEvent: ev,
        clickOutsideToClose: true
      })
        .then(function (response) {
          $rootScope.pagination_resetquery();
          if (isReplace) {
            selectMediaFile(item, item.id_media);
          }
          if (response.replaced && response.replaced.length) {
            angular.forEach(response.replaced, function (id) {
              var file = vm.items.find(x => x.id_media == id);
              if (file) {
                file.cropstatus.map(x => {
                  x.fileName = x.fileName + '?timestamp=' + new Date().getTime();
                  return x;
                });
              }
            });
          }
          if (response && response.action && response.action == 'delete') {
            var deleteIds = [];
            angular.forEach(response.items, function (item) {
              deleteIds.push(item.id_media);
            });
            var options = {
              site: $scope.siteID,
              id_media: deleteIds,
              force: true
            }
            mediaService.massDelete(options).then(function (response) {
              vm.deselectThreads();
              $rootScope.pagination_resetquery();
              getCleanMediaGalleries();
            });
          }
        });
    }

    function changeVideoThumb(ev, video) {
      var item = { Thumbnail: [] };
      $mdDialog.show({
        controller: 'MediaDialogController',
        controllerAs: 'vm',
        locals: {
          autoUpload: '',
          currentThread: item,
          section: $scope.section,
          mediazone: false,
          isTiny: false,
          maxAttach: 1,
          showViews: {
            1: true,
            2: false,
            3: false,
            4: false,
            5: false,
            upload: false,
            import: false
          }
        },
        templateUrl: 'app/main/dialogs/media/media-dialog.html',
        targetEvent: ev,
        clickOutsideToClose: true,
        multiple: true
      }).then(function (response) {
        if (angular.isArray(response.Thumbnail) && response.Thumbnail[0] && response.Thumbnail[0].id_media) {
          video.thumb = response.Thumbnail[0].id_media;
          mediaService.triggerSetBasicFormDirty();
        }
      });
    }


    /**
     * Add Media items to galleries
     *
     * @param ev
     */

    function AddMediaItemToGalleryDialog(ev) {
      var mediaGalleries = getGalleriesWithMediaAssignment(angular.copy(vm.CleanMediaGalleries), []);
      $mdDialog.show({
        controller: 'AddMediaToGalleriesDialogController',
        controllerAs: 'vm',
        locals: {
          selectedThreads: vm.selectedThreads,
          CleanMediaGalleries: mediaGalleries
        },
        templateUrl: 'app/main/apps/media/dialogs/add-media-galleries/add-media-galleries.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true
      })
        .then(function (reload) {
          if (reload) {
            vm.closeMediaPreview();
            vm.deselectThreads();
            $rootScope.pagination_resetquery();
            getCleanMediaGalleries()
          }


        });
    }

    function RemoveMediaItemFromGalleryDialog(ev) {
      var confirmTitle = $translate.instant('GALLERY.REMOVE_CONFIRM_TITLE', { gallery_name: vm.selectedGallery.gallery_name });
      var confirmText = $translate.instant('GALLERY.REMOVE_CONFIRM_TEXT');
      var confirm = $mdDialog.confirm()
        .title(confirmTitle)
        .textContent(confirmText)
        .ariaLabel(confirmTitle)
        .targetEvent(ev)
        .ok('OK')
        .cancel($translate.instant('CANCEL'));

      $mdDialog.show(confirm).then(function () {

        var removeMediaIds = vm.selectedThreads.map(function (thread) { return thread.id_media });

        var options = {
          id_gallery: vm.selectedGallery.id_gallery,
          id_media: removeMediaIds
        }
        mediaService.removeFromGallery($scope.siteID, options).then(function (response) {

          vm.selectedThreads = vm.removeObjectsFromArrayByProperty(vm.selectedThreads, 'id_media', removeMediaIds);
          var galleries = [];
          galleries.push(vm.selectedGallery);
          loadMediaByGalleries(galleries);

          var message = $translate.instant('GALLERY.MEDIA_REMOVED');
          $mdToast.show({
            template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
            hideDelay: 5000,
            position: 'top',
            parent: '#content-container'
          });
          getCleanMediaGalleries();
        });
      });
    }

    /**
     * Edit Multiple Fields dialog
     *
     * @param ev
     */

    function EditMultipleFieldsDialog(ev) {
      $mdDialog.show({
        controller: 'EditMultipleFieldsDialogController',
        controllerAs: 'vm',
        locals: {
          selectedThreads: vm.selectedThreads
        },
        templateUrl: 'app/main/apps/media/dialogs/edit-multiple-fields/edit-multiple-fields.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true
      })
        .then(function (reload) {
          if (reload) {
            vm.closeMediaPreview();
            vm.deselectThreads();
            $rootScope.pagination_resetquery();

          }
        });
    }

    function backToGallery(gallery) {
      if (gallery) {
        var index = vm.hierarchyGalleries.indexOf(gallery);
        vm.hierarchyGalleries = vm.hierarchyGalleries.slice(0, index);
        openGalleryFolder(gallery);
      } else {
        vm.selectedGalleryChildren = vm.CleanMediaGalleries;
        vm.isRoot = true;
        vm.hierarchyGalleries = [];
      }
    }

    function openGalleryFolder(gallery) {
      vm.isRoot = false;
      vm.hierarchyGalleries.push(gallery);
      vm.selectedGalleryChildren = gallery.children;
      loadMediaByGalleries([gallery]);
    }

    function selectMediaFileSidenav(mediaItem, id_media) {
      vm.loadingReadPane = true;
      vm.mediaSelectedLoaded = false;
      $mdSidenav('sidenav-media').open();
      setTimeout(() => {
        selectMediaFile(mediaItem, id_media);
      }, 400);
    }

    function selectMediaFile(mediaItem, id_media) {

      vm.facesRelated = null;

      resetScroll();

      vm.galleriesAsigned = [];
      vm.mediaSelected = true;
      vm.mediaSelectedLoaded = false;
      // vm.image=file;
      vm.editInline = false;
      vm.showCropformats = false;
      vm.loadingReadPane = true;
      vm.image = [];

      if (mediaItem) {
        vm.ImageIDSelected = mediaItem.id_media;
      } else if (id_media) {
        vm.ImageIDSelected = id_media;
      }


      $state.go('app.site_overview.media.type.edit', {
        id: vm.ImageIDSelected,
        mediaType: vm.media_type_name
      }, {
        notify: false,
        inherit: true,
        location: true
      });

      mediaService.get({
        siteID: $scope.siteID,
        withCropStatusVideos: true,
        withCropStatus: true,
        withTags: true,
        idMedia: vm.ImageIDSelected
      })
        .then(function (response) {
          for (var i = 0; i < response.data[0].cropstatus.length; i++) {
            var cropImage = response.data[0].cropstatus[i];
            var cropContainer = sessionService.getContainerByID(response.data[0].cropstatus[i].id_container);
            if (cropContainer) {
              if (cropContainer.use_grid === 1) {
                var urlImage = cropContainer.view_url + cropImage.grid + '/' + cropImage.fileName;
              } else {
                var urlImage = cropContainer.view_url + cropImage.fileName;
              }
              response.data[0].cropstatus[i].urlImage = urlImage;
            }
          }



          $scope.$safeApply(function () {
            vm.image = angular.copy(response.data[0]);
            vm.image.totalGalleries = vm.image.galleries.filter(x => x.is_lightbox == 0).length;
            if (vm.image.allCropped === 0 || vm.image.allCropped === 2 ||
              (vm.image.media_type === 2 && vm.image.cropstatus_videos.length > 0 && vm.image.allCropped === null)
            ) {
              mediaService.addUncroppedMediaID(vm.image.id_media);
              $rootScope.$on('MEDIA::IS_ALL_CROPPED::ID::' + vm.image.id_media, function (event, data) {
                vm.image.allCropped = 1;
              })
            }
            vm.image.tagsWithTypes = [];
            angular.forEach(vm.tagsTypes, function (type) {
              var tagsWithType = vm.image.tags.filter(t => t.id_type == type.id_type);
              vm.image.tagsWithTypes[type.name] = tagsWithType;
            });
            vm.image.tags = vm.image.tags.filter(t => !t.id_type);
          });

          if (!angular.isUndefined(vm.image.meta_analyses) && vm.image.meta_analyses !== null && !angular.isUndefined(vm.image.meta_analyses.rekognition_index_faces) && !angular.isUndefined(vm.image.meta_analyses.rekognition_index_faces.FaceRecords)) {
            vm.image.meta_analyses.rekognition_index_faces.loaders = [];
            for (let i = 0; i < vm.image.meta_analyses.rekognition_index_faces.FaceRecords.length; i++) {
              if (i == 0) {
                vm.image.meta_analyses.rekognition_index_faces.FaceRecords[i].show = true;
              }
              const element = vm.image.meta_analyses.rekognition_index_faces.FaceRecords[i];
              vm.image.meta_analyses.rekognition_index_faces.loaders.push(true);
              loadRelated(element, i)
            }
            // console.log(vm.image.meta_analyses.rekognition_index_faces.FaceRecords)
          }

          var value = vm.image.file_date;
          if (value == '0000-00-00 00:00:00') {
            value = moment()
              .format("YYYY-MM-DD");
          }

          var utcDate = moment.utc(value);
          var siteDate = moment.utc(value)
            .tz(sessionService.site_operative.timezone);

          $scope.$safeApply(function () {
            vm.image.file_date = {};
            vm.image.file_date['value'] = value;
            vm.image.file_date['date'] = new Date(siteDate.format());
            vm.image.file_date['dateShow'] = siteDate.format(vm.dateTimeFormat);
            vm.image.file_date['utcShow'] = utcDate.format(vm.dateTimeFormat);
            vm.image.file_date['utcDate'] = utcDate;
          });

          var value = vm.image.date_uploaded;
          if (value == '0000-00-00 00:00:00') {
            value = moment()
              .format("YYYY-MM-DD");
          }

          utcDate = moment.utc(value);
          siteDate = moment.utc(value)
            .tz(sessionService.site_operative.timezone);

          $scope.$safeApply(function () {
            vm.image.date_uploaded = {};
            vm.image.date_uploaded['value'] = value;
            vm.image.date_uploaded['date'] = new Date(siteDate.format());
            vm.image.date_uploaded['dateShow'] = siteDate.format(vm.dateTimeFormat);
            vm.image.date_uploaded['utcShow'] = utcDate.format(vm.dateTimeFormat);
            vm.image.date_uploaded['utcDate'] = utcDate;
          });

          if (vm.image.galleries) {
            for (var i = vm.image.galleries.length - 1; i >= 0; i--) {
              vm.galleriesAsigned.push(vm.image.galleries[i].id_gallery);
            }
            vm.CleanMediaGalleriesWithMediaAssignment = getGalleriesWithMediaAssignment(angular.copy(vm.CleanMediaGalleries), vm.galleriesAsigned);
            expandAssignedGalleries(vm.CleanMediaGalleriesWithMediaAssignment);
          }

          var cropstatus = _.find(vm.image.cropstatus, {
            'id_cropformats': sessionService.getMediaThumbnailCropformatId()
          });

          for (var i = vm.image.cropstatus.length - 1; i >= 0; i--) {
            var cropformat = sessionService.getCropformatByID(vm.image.cropstatus[i].id_cropformats);

            _.extend(vm.image.cropstatus[i], {
              cropformat: cropformat
            });
          }


          for (var i = vm.image.cropstatus_videos.length - 1; i >= 0; i--) {
            var container = sessionService.getContainerByID(vm.image.cropstatus_videos[i].id_container);
            var cropformat = sessionService.getCropformatByID(vm.image.cropstatus_videos[i].id_cropformats);
            if (cropformat) {
              //cropformat.url = container.url + '/' + container.targetBucket + '/' + container.targetKeyPrefix + vm.image.cropstatus_videos[i].fileName;
              cropformat.url = container.view_url + container.targetKeyPrefix + vm.image.cropstatus_videos[i].fileName;
            } else if (vm.image.cropstatus_videos[i].id_cropformats == vm.originalVideoCropformatId) { // ORIGINAL
              var size = vm.image.size;
              var sizeParts = size.split("x");
              cropformat = {
                //url: container.url + '/' + container.sourceBucket + '/' + container.sourceKeyPrefix + vm.image.cropstatus_videos[i].fileName,
                url: container.view_url + container.sourceKeyPrefix + vm.image.cropstatus_videos[i].fileName,
                width: sizeParts[0] || null,
                height: sizeParts[1] || null,
                description: 'Original'
              }
            }
            _.extend(vm.image.cropstatus_videos[i], {
              cropformat: cropformat
            });
          }


          $scope.$safeApply(function () {
            var mediaContainer = sessionService.getContainerByID(vm.image.cdnContainer);
            switch (vm.image.media_type) {
              case 1:
                vm.image.imageUrlOriginal = mediaContainer.view_url + 'original/m' + vm.image.id_media + '_' + vm.image.filename;
                if (!angular.isUndefined(cropstatus)) {
                  var cropContainer = sessionService.getContainerByID(cropstatus.id_container);
                  vm.image.imageUrl = cropContainer.view_url + cropstatus.fileName;
                }
                break;
              case 2:


                if (vm.image.embed && vm.image.embed.indexOf('yt|') !== -1) {
                  var YT_VideoSource = vm.image.embed.split('yt|')[1];
                  vm.image.imageUrlOriginal = 'https://youtu.be/' + YT_VideoSource;
                } else if (vm.image.embed && vm.image.embed.indexOf('vimeo|') !== -1) {
                  var Vimeo_VideoSource = vm.image.embed.split('vimeo|')[1];
                  vm.image.imageUrlOriginal = 'https://player.vimeo.com/video/' + Vimeo_VideoSource;
                } else if (vm.image.embed && vm.image.embed.indexOf('fb|') !== -1) {
                  var embed_url = angular.element(vm.image.embed_url);
                  vm.image.imageUrlOriginal = embed_url.attr('src');
                } else if (vm.image.embed && vm.image.embed.indexOf('zc|') !== -1) {
                  var embed_url = angular.element(vm.image.embed_url);
                  vm.image.imageUrlOriginal = vm.image.embed.split('zc|')[1];
                } else {
                  if (vm.image.embed_thumb) {
                    vm.image.imageUrlOriginal = vm.image.embed_thumb;
                  } else if (!vm.image.embed && !vm.image.embed_code && !vm.image.embed_thumb && !vm.image.embed_url) {
                    vm.image.imageUrlOriginal = mediaContainer.view_url + 'videos/m' + vm.image.id_media + '_' + vm.image.filename;
                  }
                }

                break;
              case 3:
                vm.image.imageUrlOriginal = mediaContainer.view_url + 'audios/m' + vm.image.id_media + '_' + vm.image.filename;
                break;
              case 4:
                vm.image.imageUrlOriginal = mediaContainer.view_url + 'files/m' + vm.image.id_media + '_' + vm.image.filename;

                // vm.image.imageUrl = cropstatus.container.view_url + cropstatus.fileName;
                break;
            }
          });

          vm.imageMedia_containersgrouped = _.groupBy(vm.image.cropstatus, function (m) {
            return m.id_container;
          });

          vm.loadingReadPane = false;
          vm.mediaSelectedLoaded = true;
          if (vm.image.meta_analyses && vm.image.meta_analyses.rekognition_index_faces && vm.image.meta_analyses.rekognition_index_faces.FaceRecords.length == 1) {
            openFace(vm.image.meta_analyses.rekognition_index_faces.FaceRecords[0]);
          }

        });
    }

    function rekognitionDialog(ev, media, type) {
      $mdDialog.show({
        controller: 'RekognitionDialogController',
        controllerAs: 'vm',
        locals: {
          media: media,
          type: type
        },
        templateUrl: 'app/main/apps/media/dialogs/rekognition-dialog/rekognition-dialog.controller.html',
        targetEvent: ev,
        multiple: true,
        clickOutsideToClose: false
      }).then(function (response) {
        if (!response) {
          vm.selectedThreads = [];
        }
      });
    }

    function loadRelated(faceId, index) {
      if (!vm.image.meta_analyses.rekognition_search_faces[faceId.Face.FaceId]) {
        return;
      }
      vm.image.meta_analyses.rekognition_index_faces.related = []
      var indexFaces = vm.image.meta_analyses.rekognition_search_faces[faceId.Face.FaceId].FaceMatches.map(x => x.Face.FaceId);
      if (indexFaces.length === 0) {
        return;
      }
      var options = {
        siteID: siteID,
        item: { index_faces: indexFaces }
      }
      mediaService.loadRelatedFacesInfo(options).then(function (res) {
        vm.image.meta_analyses.rekognition_index_faces.related[index] = res;
        vm.image.meta_analyses.rekognition_index_faces.loaders[index] = false;
      })
    }

    /**
     * getGalleriesWithMediaAssignment
     *
     * Adds boolean attribute 'assigned_gallery' to all nested objects in passed 'galleries' list.
     * Sets 'assigned_gallery' = true if id_gallery attribute exists in assignedGalleries list.
     * Returns nested list with new attribute.
     *
     * assigned_gallery attribute is used to activate view's checkboxes
     *
     * @param  {list} galleries List of nested objects, with children contained in 'children' attribute
     * @param  {list} assignedGalleries List of ids
     * @return {list} galleries List of nested objects, with children contained in 'children' attribute
     */
    function getGalleriesWithMediaAssignment(galleries, assignedGalleries) {
      angular.forEach(galleries, function (gallery) {
        gallery.assigned_gallery = false;
        if (vm.exists(gallery.id_gallery, assignedGalleries) && !gallery.no_files_allowed) {
          gallery.assigned_gallery = true;
        }
        gallery.gallery_icon = getGalleryIcon(gallery);
        if (typeof gallery.children !== 'undefined' && gallery.children.length > 0) {
          getGalleriesWithMediaAssignment(gallery.children, assignedGalleries);
        }
      });
      return galleries;
    }

    /**
     * Icon of a gallery in the tree of tab-galleries, by media type and by whether it has
     * children. It used to be ten ng-if'd <md-icon> in the template, so ten watchers per
     * gallery on a tree that holds hundreds of them. An empty children array counts as a
     * branch, exactly as the ng-if did.
     */
    var GALLERY_ICONS_LEAF = [
      'icon-folder', 'icon-folder-image', 'qiu-icon-video-folder',
      'qiu-icon-audio-folder', 'qiu-icon-file-folder'
    ];
    var GALLERY_ICONS_BRANCH = [
      'icon-folder-multiple', 'icon-folder-multiple-image', 'qiu-icon-video-gallery',
      'qiu-icon-audio-gallery', 'qiu-icon-file-gallery'
    ];

    function getGalleryIcon(gallery) {
      var icons = gallery.children ? GALLERY_ICONS_BRANCH : GALLERY_ICONS_LEAF;
      return icons[gallery.gallery_type] || '';
    }

    /**
     * Opens the branches that hold a gallery of this media, and closes the rest.
     *
     * The tree of tab-galleries now builds each branch as it is opened, so a closed one
     * is not in the dom at all. Without this the tab would open showing only the roots,
     * with no sign of where the media actually is.
     *
     * @param  {Array}   galleries
     * @return {Boolean} whether this level, or anything below it, is assigned
     */
    function expandAssignedGalleries(galleries) {
      var anyAssigned = false;
      angular.forEach(galleries, function (gallery) {
        var assignedBelow = (gallery.children && gallery.children.length)
          ? expandAssignedGalleries(gallery.children)
          : false;
        gallery[ivhTreeviewOptions().expandedAttribute] = assignedBelow;
        if (gallery.assigned_gallery || assignedBelow) {
          anyAssigned = true;
        }
      });
      return anyAssigned;
    }

    /**
     * Opens the branches holding a gallery whose name matches, and closes the rest.
     * The filter of ivh-treeview only hides nodes, it never opens their parents, so a
     * match inside a closed branch would not even be built.
     *
     * @param  {Array}   galleries
     * @param  {String}  search    already lowercased
     * @return {Boolean} whether this level, or anything below it, matches
     */
    function expandMatchingGalleries(galleries, search) {
      var anyMatch = false;
      angular.forEach(galleries, function (gallery) {
        var matchBelow = (gallery.children && gallery.children.length)
          ? expandMatchingGalleries(gallery.children, search)
          : false;
        gallery[ivhTreeviewOptions().expandedAttribute] = matchBelow;
        var name = (gallery.gallery_name || '').toLowerCase();
        if (matchBelow || name.indexOf(search) !== -1) {
          anyMatch = true;
        }
      });
      return anyMatch;
    }

    $scope.$watch(function () {
      return vm.treeSearch;
    }, function (search, previousSearch) {
      if (search === previousSearch || !vm.CleanMediaGalleriesWithMediaAssignment) {
        return;
      }
      if (search) {
        expandMatchingGalleries(vm.CleanMediaGalleriesWithMediaAssignment, search.toLowerCase());
      } else {
        expandAssignedGalleries(vm.CleanMediaGalleriesWithMediaAssignment);
      }
    });


    /**
     * getAssignedGalleries
     *
     * Filters objects of nested list by boolean attribute 'assigned_gallery' = true
     * Returns filtered nested list
     *
     * @param  {list} galleries List of nested objects, with children contained in 'children' attribute
     * @param  {list} result
     * @return {list}           List of ids
     */
    function getAssignedGalleriesIds(galleries, result) {
      angular.forEach(galleries, function (gallery) {
        if (gallery.assigned_gallery == true && !gallery.no_files_allowed) {
          result.push(gallery.id_gallery);
        }
        if (typeof gallery.children !== 'undefined' && gallery.children.length > 0) {
          getAssignedGalleriesIds(gallery.children, result);
        }
      });
      return result;
    }

    vm.openFacesRelatedInImageDialog = function (ev, facesRelated, ImageSelected, cropFormats, MediaFull) {
      var images = facesRelated.map(x => x.media);
      openImageDialog(ev, images, ImageSelected, cropFormats, MediaFull)
    }

    /**
     * Open Image dialog
     *
     * @param ev
     * @param task
     */
    function openImageDialog(ev, images, ImageSelected, cropFormats, MediaFull) {
      $mdDialog.show({
        controller: 'MediaShowDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/dialogs/media-show/media-show-dialog-with-tags.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        escapeToClose: false,
        locals: {
          Images: images,
          ImageSelected: ImageSelected,
          cropFormats: cropFormats,
          MediaFull: MediaFull,
          Tags: true,
          // Tasks: vm.tasks,
          // event: ev
        }
      }).then(function () {
      });
    }

    /**
     * Open Focal Point dialog
     *
     * @param ev
     * @param Image
     */
    function openFocalPoint(ev, ImageSelected) {
      $mdDialog.show({
        controller: 'MediaFocalPointDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/dialogs/media-focal-point/media-focal-point-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          ImageSelected: ImageSelected,
        }
      })
        .then(function (item) {
          vm.basicForm.$setDirty()

          vm.image.imageCenterRatioX = item.imageCenterRatioX;
          vm.image.imageCenterRatioY = item.imageCenterRatioY;
        });
    }

    function closeDialog() {
      $mdDialog.hide(vm.currentThread);
    }



    $scope.$watch('vm.files', function () {
      $scope.formUpload = false;
      if (vm.files != null) {
        // make files array for not multiple to be able to be used in ng-repeat in the ui
        if (!angular.isArray(vm.files)) {
          $timeout(function () {
            $scope.files = vm.files = [vm.files];
          });
          return;
        }
        for (var i = 0; i < vm.files.length; i++) {
          $scope.errorMsg = null;
          (function (f) {
            vm.upload(f, true);
          })(vm.files[i]);
        }
      }
    });

    $scope.$watch('vm.import_field', function () {
      vm.importConfirm(false);
    });

    $scope.$watch('vm.selectedGallery', function () {
      if (vm.selectedGallery) {
        vm.viewSortType = 'gallery';
      } else {
        vm.viewSortType = '';
      }
    });


    $scope.log = '';

    function upload(file) {
      if (!file.$error) {
        file.processed = false;
        var uploadOptions = {
          siteID: siteID,
          filename: file.name,
          log: $scope.log,
          type: 'media'
        }
        console.debug("UPLOAD______****", file)
        uploadService.upload(file, uploadOptions).then(function (resp) {
          $scope.log = resp.log;
          vm.uploadedFiles.push(resp.id_media);
          mediaService.get({
            siteID: siteID,
            withCropStatus: true,
            withTags: true,
            idMedia: file.id_media
          })
            .then(function (response) {
              if (response.total == 1) {
                var photo = response.data[0];
                toggleSelectContact(photo);
              }
            });
        });
      }
    };

    vm.importConfirm = function (confirm) {
      vm.import_disabled = false;
      vm.imported = false;
      if (!confirm) {
        vm.importPreview = false;
      }
      if (vm.import_field.length > 10) {
        vm.importing = true;
        vm.import_disabled = true;

        $timeout(function () {
          var pastedUrl = vm.import_field;
          mediaService.importFromUrl({
            siteID: siteID,
            url: pastedUrl,
            execute: confirm
          })
            .then(function (response) {
              vm.importing = false;
              response.embedCodeSafe = $sce.trustAsHtml(response.metadata.embedCode);
              if (response.id_media) {
                vm.imported = true;
                vm.importPreview = false;
                mediaService.get({
                  siteID: siteID,
                  withCropStatus: true,
                  withTags: true,
                  idMedia: response.id_media
                })
                  .then(function (response) {
                    if (response.total == 1) {
                      var photo = response.data[0];
                      vm.importedFiles.push(photo);
                      toggleSelectContact(photo);
                    }
                  });

              } else {
                vm.importPreview = response;
              }
              vm.import_disabled = false;
            });
        })
      }
    }

    function getTagIdsFromTags(tags) {
      var ids = [];
      for (var i = tags.length - 1; i >= 0; i--) {
        if (angular.isDefined(tags[i].id_tag)) {
          ids.push(tags[i].id_tag);
        }
      }
      return ids;
    }

    function saveImage() {

      if (vm.image.tagsWithTypes) {
        for (var type in vm.image.tagsWithTypes) {
          angular.forEach(vm.image.tagsWithTypes[type], function (tag) {
            vm.image.tags.push(tag);
          });
        }
      }

      delete vm.image.tagsWithTypes;

      var galleries = getAssignedGalleriesIds(vm.CleanMediaGalleriesWithMediaAssignment, []);

      var imageToSave = {
        'tags': getTagIdsFromTags(vm.image.tags),
        'title': vm.image.title,
        'owner': vm.image.owner,
        'filename': vm.image.filename,
        'photographer': vm.image.photographer,
        'credits': vm.image.credits,
        'size': vm.image.size,
        'caption': vm.image.caption,
        'city': vm.image.city,
        'country': vm.image.country,
        'date_uploaded': vm.image.date_uploaded.value,
        'duration': vm.image.duration,
        'thumb': vm.image.thumb,
        'embed': vm.image.embed,
        'embed_thumb': vm.image.embed_thumb,
        'embed_url': vm.image.embed_url,
        'extra': vm.image.extra,
        'fileSizeKb': vm.image.fileSizeKb,
        'file_date': vm.image.file_date.value,
        'geoLat': vm.image.geoLat,
        'geoLon': vm.image.geoLon,
        'geotag': vm.image.geotag,
        'imageCenterRatioX': vm.image.imageCenterRatioX,
        'imageCenterRatioY': vm.image.imageCenterRatioY,
        'rating': vm.image.rating,
        'uses': vm.image.uses,
        'galleries': galleries,
      };

      var options = {
        site: $scope.siteID,
        id: vm.image.id_media,
        item: imageToSave
      };

      mediaService.saveMedia(options)
        .then(function (response) {

          // vm.image = angular.copy(response);
          vm.image = angular.extend(vm.image, response);



          var message = $translate.instant('CONTENT.SAVED');

          $mdToast.show({
            template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
            hideDelay: 5000,
            position: 'top',
            parent: '#content-container'
          });

          $mdDialog.hide(vm.image);
          vm.selectMediaFile(vm.image);
          getCleanMediaGalleries();
        });
    }

    /**
     * Toggle view Edit
     */
    function viewEditInline() {
      resetScroll();

      vm.thumbnails_Edit = {};
      vm.editInline = true;
      vm.currentThread_Edit = angular.copy(vm.selectedContent);
      vm.currentThread_ref = angular.copy(vm.selectedContent_ref);
      if (vm.mediaZones) {
        angular.forEach(vm.mediaZones, function (mz) {
          if (angular.isUndefined(vm.thumbnails_Edit[mz.id_zone])) {
            vm.thumbnails_Edit[mz.id_zone] = [];
          }
        })
        angular.forEach(vm.currentThread_Edit.Thumbnail, function (thumb) {
          vm.thumbnails_Edit[thumb.id_zone].push(thumb);
        })
      }

      angular.forEach(vm.selectedContent_ref, function (refColumn) {
        switch (refColumn.type) {
          case 'date':
          case 'dateHm':
            var type = 'input';
            break;
          case 'single':
            var type = 'input';
            break;
          default:
            break;
        }
      });
    }

    function closeMediaPreview() {
      if (vm.currentListView == 'gridGoogle') {
        $rootScope.$broadcast('closeSidenav', 'sidenav-media');
      }
      vm.mediaSelected = false;
      vm.image = null;
      vm.editInline = false;
      vm.ImageIDSelected = null;
      $state.go('app.site_overview.media.type', { MediaType: vm.media_type_name }, { notify: false });

    }

    function resetScroll() {
      if (angular.element(document.getElementById('thread-detail'))
        .length) {
        var elem = angular.element(document.getElementById('thread-detail'));
        elem.scrollTopAnimated(0, 10);
      }
    }

    function alreadySelectedbyZone(array, item) {
      var ret = false;
      for (var i = 0, len = array.length; i < len; i++) {
        // if (vm.mediazone) {
        //             if (array[i]['id_media'] === item.id_media && array[i]['id_zone'] === mediazone.id_zone) {
        //              ret = true;
        //             }
        //         } else {
        //             if (array[i]['id_media'] === item.id_media) {
        //                 ret = true;
        //             }
        //
        // }
      }

      return ret;
    }


    function toggleSelectedbyZone(item) {
      for (var i = 0, len = vm.selectedContacts.length; i < len; i++) {
        console.info(vm.selectedContacts[i]['id_media'] + '---' + item.id_media)
        if (vm.selectedContacts[i]['id_media'] === item.id_media) {
          vm.selectedContacts.splice(i, 1);
          return;
        }
      }

      vm.selectedContacts.push(item);
      return;
    }

    function selectMediaTiny(item) {
      var currentSort = 0;
      var mediaSort = 0;
      for (var i = 0; i < vm.currentThread.length; i++) {
        if (vm.mediazone) {
          if (vm.currentThread[i]['id_zone'] == 1 && (vm.currentThread[i]['media_type'] == item.media_type)) {
            currentSort++;
            if (item.id_media == vm.currentThread[i]['id_media']) {
              mediaSort = currentSort;
            }
          }
        } else {
          currentSort++;
          if (item.id_media == vm.currentThread[i]['id_media']) {
            mediaSort = currentSort;
          }
        }
      }

      vm.selectedMediaTiny = item;
      vm.tinyProperties.mediaSort = mediaSort;
      vm.tinyProperties.mediaType = item.media_type;
      vm.changeViewTiny('properties');

    }

    function attachMedia() {
      var uploadedFilesIDs = [];
      if (vm.uploadedFiles.length > 0) {
        vm.uploadedFiles.forEach(element => {
          uploadedFilesIDs.push(element.id_media);
        });
        var batchOptions = {
          siteID: siteID,
          id_medias: uploadedFilesIDs
        }
        mediaService.finishedUploadingBatchToCdn(batchOptions).then(function (response) {
          console.log('response', response);
        });
      }

      for (var i = 0; i < vm.selectedContacts.length; i++) {

        // $scope.$safeApply(function() {

        // vm.currentThread.Thumbnail.push(vm.selectedContacts[i]);
        // });
      }
      angular.copy(vm.selectedContacts, vm.currentThread.Thumbnail)

      vm.closeDialog();
    }

    function attachMediaTiny() {
      $mdDialog.hide(vm.tinyProperties);
    }

    /**
     * Toggle selected status of the contact
     *
     * @param contact
     * @param event
     */

    function toggleSelectContact(photo, event) {
      if (event) {
        event.stopPropagation();
      }


      //         else{
      if (vm.mediazone) {
        photo.id_zone = vm.mediazone.id_zone;
        photo.zone_name = vm.mediazone.zone_name;
      } else {
        photo.id_zone = null;
        photo.zone_name = null;
      }

      toggleSelectedbyZone(photo);
      // if(vm.alreadySelectedbyZone(vm.selectedContacts, photo)){
      // vm.selectedContacts.splice(vm.selectedContacts.indexOf(photo.id_media), 1);
      //         }else{
      //          vm.selectedContacts.push(photo);
      //         }
      // }

      // if ( vm.selectedContacts.indexOf(photo.id_media) > -1 )
      // {
      //     vm.selectedContacts.splice(vm.selectedContacts.indexOf(photo.id_media), 1);
      // }
      // else
      // {
      //     vm.selectedContacts.push(photo.id_media);
      // }
    }

    /**
     * Scroll Media Dialog Content to the top
     * @param speed
     */
    function scrollToTopOfDialog() {
      $timeout(function () {
        var dialogContent = $document.find('md-dialog-content')
          .filter(function () {
            return angular.element(this)
              .hasClass('mediadialog-content');
          });

        dialogContent.animate({
          scrollTop: dialogContent[0].scrollHeight
        }, 1);
      }, 0);

    }


    /**
     * Return selected status of the thread
     *
     * @param thread
     * @returns {boolean}
     */
    function isSelected(thread) {
      return vm.selectedThreads.indexOf(thread) > -1;
    }

    /**
     * Toggle selected status of the thread
     *
     * @param thread
     * @param event
     */
    function toggleSelectThread(thread, event) {
      var shift = false;
      if (event) {
        if (event.shiftKey) {
          shift = true;
        }
        event.stopPropagation();
      }

      // Selección múltiple con Shift
      if (shift && vm.selectedThreads.length > 0) {
        var first = vm.items.indexOf(vm.selectedThreads[0]);
        var last = vm.items.indexOf(thread);
        if (first > last) {
          var temp = first;
          first = last;
          last = temp;
        }
        // Se limpia la selección y se actualizan los elementos
        vm.selectedThreads = [];
        for (var i = first; i <= last; i++) {
          vm.selectedThreads.push(vm.items[i]);
          // Buscamos el elemento DOM mediante su atributo data-id
          var el = document.querySelector('.grid-element[data-id="' + vm.items[i].id_media + '"]');
          if (el) {
            el.classList.add('box-selected');
            el.setAttribute('draggable', 'true');
          }
        }
      } else {
        // Selección individual
        var gridElement = event.target.closest('.grid-element');
        var index = vm.selectedThreads.indexOf(thread);
        if (index > -1) {
          vm.selectedThreads.splice(index, 1);
          if (gridElement) {
            gridElement.classList.remove('box-selected');
            gridElement.setAttribute('draggable', 'false');
          }
        } else {
          vm.selectedThreads.push(thread);
          if (gridElement) {
            gridElement.classList.add('box-selected');
            gridElement.setAttribute('draggable', 'true');
          }
        }
      }
    }

    /**
     * Toggle select threads
     */
    function toggleSelectThreads() {
      if (vm.selectedThreads.length > 0) {
        vm.deselectThreads();
      } else {
        vm.selectThreads();
      }
    }

    /**
     * Deselect threads
     */
    function deselectThreads() {
      vm.selectedThreads.forEach(thread => {
        const el = document.querySelector('.grid-element[data-id="' + thread.id_media + '"]');
        if (el) {
          el.classList.remove('box-selected');
          el.setAttribute('draggable', 'false');
        }
      });
      vm.selectedThreads = [];
    }

    /**
     * Select threads. If key/value pair given,
     * threads will be tested against them.
     *
     * @param [key]
     * @param [value]
     */
    function selectThreads(key, value) {
      // Make sure the current selection is cleared
      // before trying to select new threads
      vm.selectedThreads = [];

      for (var i = 0; i < vm.items.length; i++) {
        if (angular.isUndefined(key) && angular.isUndefined(value)) {

          const el = document.querySelector('.grid-element[data-id="' + vm.items[i].id_media + '"]');
          el.classList.add('box-selected');
          el.setAttribute('draggable', 'true');

          vm.selectedThreads.push(vm.items[i]);
          continue;
        }

        if (angular.isDefined(key) && angular.isDefined(value) && vm.items[i][key] === value) {

          const el = document.querySelector('.grid-element[data-id="' + vm.items[i].id_media + '"]');
          el.classList.add('box-selected');
          el.setAttribute('draggable', 'true');

          vm.selectedThreads.push(vm.items[i]);
        }
      }
    }

    /**
     * Return checked status of the content
     *
     * @param content
     * @returns {boolean}
     */
    function MediaItemRecrop(image) {

      var messageConfirm = $translate.instant('CONTENT.MEDIA_ITEM_SURE_RECROP');

      var confirm = $mdDialog.confirm()
        .title(messageConfirm)
        .htmlContent('')
        .ariaLabel('Delete item')
        .ok('OK')
        .cancel('CANCEL');
      var message = $translate.instant('CONTENT.MEDIA_ITEM_FINISH_RECROP');


      $mdDialog.show(confirm)
        .then(function () {

          var imageToSave = {
            'forceRecrop': true,
            'tags': [],
          };

          var options = {
            site: $scope.siteID,
            id: image.id_media,
            item: imageToSave
          };

          mediaService.saveMedia(options)
            .then(function (response) {
              $mdToast.show({
                template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                hideDelay: 5000,
                position: 'top',
                parent: '#content-container'
              });
            });
        });

    }

    /**
     * Return checked status of the content
     *
     * @param content
     * @returns {boolean}
     */
    function MediaItemRecropSingleFormat(id_media, id_cropformat) {

      var messageConfirm = $translate.instant('CONTENT.MEDIA_ITEM_SURE_RECROP');

      var confirm = $mdDialog.confirm()
        .title(messageConfirm)
        .htmlContent('')
        .ariaLabel('Delete item')
        .ok('OK')
        .cancel('CANCEL');
      var message = $translate.instant('CONTENT.MEDIA_ITEM_FINISH_RECROP');


      $mdDialog.show(confirm)
        .then(function () {

          var dataPost = {
            'id_media': id_media,
            'id_cropformat': id_cropformat
          };

          var options = {
            site: $scope.siteID,
            data: dataPost
          };

          mediaService.RecropSingleFormat(options)
            .then(function (response) {
              $mdToast.show({
                template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                hideDelay: 5000,
                position: 'top',
                parent: '#content-container'
              });
            });
        });

    }

    /**
     * Return checked status of the content
     *
     * @param content
     * @returns {boolean}
     */
    function MediaItemRecropAllFormats(id_media) {

      var messageConfirm = $translate.instant('CONTENT.MEDIA_ITEM_SURE_RECROP');

      var confirm = $mdDialog.confirm()
        .title(messageConfirm)
        .htmlContent('')
        .ariaLabel('Delete item')
        .ok('OK')
        .cancel('CANCEL');
      var message = $translate.instant('CONTENT.MEDIA_ITEM_FINISH_RECROP');


      $mdDialog.show(confirm)
        .then(function () {

          var dataPost = {
            'id_media': id_media
          };

          var options = {
            site: $scope.siteID,
            data: dataPost
          };

          mediaService.RecropAllFormats(options)
            .then(function (response) {
              $mdToast.show({
                template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                hideDelay: 5000,
                position: 'top',
                parent: '#content-container'
              });
            });
        });

    }

    function joinClipsWindow(ev, item) {
      $mdDialog.show({
        controller: 'JoinClipsDialogController',
        controllerAs: 'vm',
        locals: {
          selectedClips: [item]
        },
        templateUrl: 'app/main/dialogs/join/join-clip-dialog.controller.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true
      }).then(function (item) {

      });
    }


    function handleGallerySelect(item) {
      vm.openGallery(item);

      if ($mdMedia('xs') || $mdMedia('sm')) {
        vm.cancelMediaGalleries('galleries-sidenav');
      }
    }

    function openGallery(gallery) {
      var includeSubgalleries = $('#includeSubgalleries').attr("data-include-subgalleries") == 'true';
      mediaService.triggerMediaByGalleries(gallery, includeSubgalleries);
    }

    function updateDatePicker(field) {
      var value = moment.utc(vm.image[field].date)
        .format('YYYY-MM-DD HH:mm:00');

      if (value == 'Invalid date') {
        vm.image[field] = {};
        vm.image[field]['value'] = '';
        vm.image[field]['date'] = '';
        vm.image[field]['dateShow'] = '';
        vm.image[field]['utcShow'] = '';
        vm.image[field]['utcDate'] = '';
      } else {
        var tz = (sessionService.site_operative.timezone || moment.tz.guess() || 'UTC').toString().trim();
        var utcDate = moment.utc(value);
        var siteDate = moment.utc(value).tz(tz);

        vm.image[field] = {};
        vm.image[field]['value'] = value;
        vm.image[field]['date'] = new Date(siteDate.format());
        vm.image[field]['dateShow'] = siteDate.format(vm.dateTimeFormat || 'DD/MM/YYYY HH:mm');
        vm.image[field]['utcShow'] = utcDate.format(vm.dateTimeFormat || 'DD/MM/YYYY HH:mm');
        vm.image[field]['utcDate'] = utcDate;
      }
    }


    function showDate(value) {
      if (angular.isObject(value)) {
        return value.dateShow;
      } else if (value == '0000-00-00 00:00:00' || !value) {
        return '-';
      } else {
        var tz = (sessionService.site_operative.timezone || moment.tz.guess() || 'UTC').toString().trim();
        return moment.utc(value)
          .tz(tz)
          .format(vm.dateTimeFormat || 'DD/MM/YYYY HH:mm');
      }
    }



    function massRecropMedia(ev) {

      if (vm.selectedThreads.length === 0) return false;

      if (vm.selectedThreads.length > 100) {
        var message = $translate.instant('CONTENT.MAX_MASS_RECROP');
        $mdToast.show({
          template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
          hideDelay: 5000,
          position: 'top',
          parent: '#content-container'
        });
        return;
      } else {
        vm.recroppedImages = 0;
        var messageConfirm = $translate.instant('CONTENT.MASS_ITEM_SURE_RECROP');
        var imagesMessage = $translate.instant('CONTENT.RECROP_IMAGE');
        var confirm = $mdDialog.confirm()
          .title(messageConfirm + " " + vm.selectedThreads.length + " " + imagesMessage)
          .htmlContent('')
          .ariaLabel('Delete item')
          .ok('OK')
          .cancel('CANCEL');
        var message = $translate.instant('CONTENT.MEDIA_ITEMS_FINISH_RECROP');
        $mdDialog.show(confirm)
          .then(function () {
            angular.forEach(vm.selectedThreads, function (media) {
              var dataPost = {
                'id_media': media.id_media
              };
              var options = {
                site: $scope.siteID,
                data: dataPost
              }
              mediaService.RecropAllFormats(options)
                .then(function (response) {
                  vm.recroppedImages++;
                  if (vm.recroppedImages == vm.selectedThreads.length) {
                    $mdToast.show({
                      template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + ' (' + + vm.recroppedImages + ')' + '</span></div></md-toast>',
                      hideDelay: 5000,
                      position: 'top',
                      parent: '#content-container'
                    });
                  }
                });
            });
          });
      }
    }


    /**
     * Return checked status of the content
     *
     * @param content
     * @returns {boolean}
     */
    function deleteMediaItem(ev) {

      if (vm.selectedThreads.length === 0) return false;


      $mdDialog.show({
        controller: 'DeleteMediaDialogController',
        controllerAs: 'vm',
        locals: {
          selectedThreads: vm.selectedThreads,
          siteID: $scope.siteID
        },
        templateUrl: 'app/main/apps/media/dialogs/media/delete-media-dialog.html',
        parent: angular.element($document.body),
        multiple: true,
        targetEvent: ev,
        clickOutsideToClose: true
      }).then(function (deleted) {
        if (deleted) {
          vm.deselectThreads();
          $rootScope.pagination_resetquery();
          getCleanMediaGalleries();
        }
      });
      /*
              var confirm = $mdDialog
                  .confirm()
                  .title(messageConfirm)
                  .htmlContent(messageConfirmContent + messageMediaAssigned)
                  .ariaLabel('Delete item').ok('OK').cancel('CANCEL');

              $mdDialog.show(confirm)
      */
    }

    /**
     * Show success toast message
     */
    function showToast(message) {
      $mdToast.show({
        template: '<md-toast id="language-message" layout="column" layout-align="center center">' +
          '<div class="md-toast-content green-500-bg">' +
          '<md-icon md-font-icon="icon-check" class="icon"></md-icon>' +
          '<span class="md-toast-text" flex>' + message + '</span>' +
          '</div></md-toast>',
        hideDelay: 3000,
        position: 'top right',
        parent: '#main'
      });
    }

    /**
     * Show error toast message
     */
    function showErrorToast(message) {
      $mdToast.show({
        template: '<md-toast id="language-message" layout="column" layout-align="center center">' +
          '<div class="md-toast-content red-500-bg">' +
          '<md-icon md-font-icon="icon-alert-circle" class="icon"></md-icon>' +
          '<span class="md-toast-text" flex>' + message + '</span>' +
          '</div></md-toast>',
        hideDelay: 3000,
        position: 'top right',
        parent: '#main'
      });
    }

    vm.showToast = showToast;
    vm.showErrorToast = showErrorToast;

    function selectedItemChange(searcher) {
      if (searcher) {
        vm[searcher] = '';
      } else {
        vm.searchTagText = '';
      }
      vm.selectedTag = null;
    }


    /**
     * Add label chips
     *
     * @param query
     * @returns {filterFn}
     */
    function labelQuerySearch(query, type) {
      var ret = [];
      if (query) {
        var filteredContent = angular.copy(vm.tags.filter(vm.createFilterFor(query)));
        if (filteredContent.length > 0) {
          ret.push({
            id_tag: 0,
            tag_name: "",
            order: 1
          });
        }
        angular.forEach(filteredContent, function (val) {
          if (!type || (type && val.id_type == type)) {
            ret.push(val);
          }
        })
      }
      return ret;
    }

    /**
     * Filter for chips
     *
     * @param query
     * @returns {filterFn}
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query).normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      return function filterFn(item) {
        if (angular.isUndefined(item.tag_name)) {
          return false;
        } else if (typeof item.tag_name == 'string') {
          var normItem = item.tag_name.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
        } else {
          normItem = item.tag_name;
        }
        if (!item.tag_name) {
          return false;
        }
        if (!angular.lowercase(normItem.toString()).indexOf) {
          return false;
        }
        return angular.lowercase(normItem.toString()).indexOf(lowercaseQuery) >= 0;
      };
    }

    function newTag(tagName, type) {
      if (vm.newTagDisabled) {
        return false;
      }
      vm.newTagDisabled = true;

      var newTag = {
        id_tag: '',
        tag_name: tagName,
        id_type: type && type.id_type ? type.id_type : undefined
      };
      var options = {
        site: $scope.siteID,
        item: newTag
      };
      tagsService.saveItem(options).then(function (response) {
        newTag.id_tag = response.id_tag;
        if (response.id_type) {
          var typename = vm.tagsTypes.find(t => t.id_type == response.id_type).name;
          if (!vm.image.tagsWithTypes[typename]) {
            vm.image.tagsWithTypes[typename] = [];
          }
          vm.image.tagsWithTypes[typename].push(newTag);
          vm[type.searcher] = "";
        } else {
          vm.image.tags.push(newTag);
          vm.searchTagText = '';
        }
        vm.newTagDisabled = false;
      })
    }

    function getTagsTypes() {
      var options = {
        siteID: $scope.siteID
      };
      tagsService.getTagsTypes(options).then(function (response) {
        vm.tagsTypes = response;
        angular.forEach(vm.tagsTypes, function (type) {
          var searcher = 'searchTag' + type.name.replace(' ', '');
          vm[searcher] = null;
          type.searcher = searcher;
        });
      });
    }

    function showCropformatsTab() {
      vm.showCropformats = true;
    }

    function createGallery(ev) {
      if (vm.media_type_name == 'galleries' && vm.hierarchyGalleries.length > 0) {
        openGalleryDialog(ev, {}, vm.hierarchyGalleries[vm.hierarchyGalleries.length - 1]);
      } else {
        openGalleryDialog(ev, {});
      }
    }

    $scope.$on('openGalleryDialog', function (ev, gallery) {
      var parentGallery = false;
      if (vm.media_type_name == 'galleries' &&
        vm.hierarchyGalleries &&
        angular.isArray(vm.hierarchyGalleries) &&
        vm.hierarchyGalleries.length > 0
      ) {
        parentGallery = vm.hierarchyGalleries[vm.hierarchyGalleries.length - 1]
      }

      openGalleryDialog(ev, gallery, parentGallery);
    });

    $scope.$on('setBasicFormDirty', function () {
      vm.basicForm.$setDirty();
    })


    function openGalleryDialog(ev, gallery, parentGallery) {
      var hasMediacenterSettingsAccess = false;
      var hasLightboxSettingsAccess = false;
      if (vm.mediaGalleryRestrictions) {
        if (vm.mediaGalleryRestrictions.hasOwnProperty('mediacenter_settings_access') &&
          vm.mediaGalleryRestrictions.mediacenter_settings_access.includes(true)
        ) {
          hasMediacenterSettingsAccess = true;
        }
        if (vm.isLightbox &&
          vm.mediaGalleryRestrictions.hasOwnProperty('lightbox_settings_access') &&
          vm.mediaGalleryRestrictions.lightbox_settings_access.includes(true)
        ) {
          hasLightboxSettingsAccess = true;
        }
      }
      $mdDialog.show({
        controller: 'EditGalleryDialogController',
        controllerAs: 'vm',
        locals: {
          gallery: gallery,
          siteID: $scope.siteID,
          isAdmin: vm.isAdmin,
          mediaType: vm.media_type,
          galleries: vm.CleanMediaGalleries,
          parentGallery: parentGallery,
          sortFieldGalleries: vm.sortFieldGalleries,
          sortDirGalleries: vm.sortDirGalleries,
          hasMediacenterSettingsAccess: hasMediacenterSettingsAccess,
          hasLightboxSettingsAccess: hasLightboxSettingsAccess
        },
        templateUrl: 'app/main/apps/media/dialogs/galleries/edit-gallery.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        multiple: true,
        clickOutsideToClose: true,
        fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
      }).then(res => {
        // if (res) {
        //   vm.galleriesOriginal.push(res);
        //   vm.galleriesOriginal = vm.galleriesOriginal.sort(function (a, b) {
        //     return a.gallery_name - b.gallery_name;
        //   });
        //   vm.CleanMediaGalleries = transformMedia.formatNestedGalleries(vm.galleriesOriginal);
        //   console.log(vm.CleanMediaGalleries)
        // }
      });
    }


  }

  function OpenGalleryEditDialog(mediaService) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        $(element).on('click', function (e) {
          var galleryNode = scope.node;
          mediaService.triggerGalleryDialog(galleryNode);
        });
      }
    };
  }

  function LoadMediaByGalleries(mediaService) {

    function unselectAllGalleries() {
      var elemList = document.querySelectorAll('.gallery-row');
      elemList.forEach(function (elem) {
        elem.classList.remove('selected');
      });
    }

    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        $(element).on('click', function (e) {
          var galleryNode = false;
          if (element.parent().hasClass('selected')) {
            unselectAllGalleries();
          } else {
            unselectAllGalleries();
            element.parent().addClass('selected');
            galleryNode = scope.node;
          }
          var includeSubgalleries = $('#includeSubgalleries').attr("data-include-subgalleries") == 'true';
          mediaService.triggerMediaByGalleries(galleryNode, includeSubgalleries);
        });
      }
    };
  }

  function ToggleAssignedGallery() {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        $(element).on('click', function (e) {
          scope.node.assigned_gallery = !scope.node.assigned_gallery;
        });
      }
    };
  }

  function SetBasicFormDirty(mediaService) {

    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        $(element).on('click', function (e) {
          mediaService.triggerSetBasicFormDirty();
        });
      }
    };
  }

  function CloseSidenav(mediaService) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        $(element).on('click', function (e) {
          mediaService.triggerCloseSidenav(attrs.sidenavId);
        });
      }
    }
  }
})();


(function () {
    'use strict';

    angular.module('app.match-center')

        .directive('qiuMatchCenterOnClickEditDialog', ['matchCenterService', OpenEditDialog])
        .controller('MatchCenterController', MatchCenterController);



    /** @ngInject */
    function MatchCenterController($scope, $rootScope, $document, $mdDialog, $mdMedia, $mdToast, $mdSidenav,
        $state, msApi, requestContext, $timeout, matchCenterService, utilMatchCenterService, contentService, msUtils,
        $anchorScroll, $translate, $mdMenu, tinyMceService, sessionService, mediaService,
        transformMatchCenter, ivhTreeviewMgr, ivhTreeviewOptions, $filter, $window, $q, $log) {
        var vm = this;
        $rootScope.global.titleToolbar = '<i class="icon s20 icon-folder-account mr-15" ng-if="node.icon"></i> ' + $translate.instant('MATCH_CENTER.MATCH_CENTER');
        vm.isLiveCenter = false;
        $rootScope.teamsMatch1 = [];
       if ($state.current.name === 'app.site_overview.fixture.livecenter') {
            vm.isLiveCenter = true;
            $rootScope.global.titleToolbar = '<i class="icon s20 icon-people mr-15" ng-if="node.icon"></i> ' + $translate.instant('MATCH_CENTER.LIVE_CENTER');
        }
        vm.timeAgo = msUtils.timeAgo;
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg', 'red-bg', 'yellow-bg', 'light-blue-bg'];
        vm.user = sessionService.user;
        vm.init = init;
        vm.languageFilter = null;
        vm.activeTab = 'matches';
        vm.activeTabStandings = 'drivers';
        vm.languages = [
            { "value": 1, "name": "Spanish" },
            { "value": 2, "name": "English" },
            { "value": 3, "name": "French" }
        ];
        vm.downloadClip = downloadClip;
        // vm.templateSortableOLD = {
        //     group: '.template',
        //     forceFallback: true,
        //     handle: '.drag',
        //     ghostClass: 'drag-item-placeholder',
        //     fallbackClass: 'drag-item-ghost',
        //     fallbackOnBody: true,
        //     sort: true,
        //     onStart: function (evt) {
        //         vm.copyMock = angular.copy(vm.currentCompetitionSeason.results);
        //     },
        //     onEnd: function (evt) {
        //         let key;
        //         switch (vm.sport) {
        //             case 'football':
        //                 key = 'pt'
        //                 break;
        //             case 'sailing':
        //                 key = 'total'
        //                 break;
        //             default:
        //                 break;
        //         }
        //         if (
        //             typeof evt.oldIndex == 'undefined'
        //             || typeof evt.newIndex == 'undefined'
        //             || evt.newIndex == evt.oldIndex
        //             || (Math.abs(evt.newIndex - evt.oldIndex) > 1)
        //             || evt.models[evt.oldIndex][key] != evt.models[evt.newIndex][key]) 
        //         {
        //             vm.currentCompetitionSeason.results = vm.copyMock;
        //         } else {
        //             if (!vm.currentCompetitionSeason.result_exceptions) {
        //                 vm.currentCompetitionSeason.result_exceptions = [];
        //             } else {
        //                 const found = vm.currentCompetitionSeason.result_exceptions.findIndex(excepction => {
        //                     return JSON.stringify(excepction.teams) == JSON.stringify([evt.models[evt.newIndex].id_teams, evt.models[evt.oldIndex].id_teams].sort())
        //                 })
        //                 if (found >= 0) {
        //                     vm.currentCompetitionSeason.result_exceptions.splice(found, 1);
        //                 }
        //             }
        //             vm.currentCompetitionSeason.result_exceptions.push(
        //                 {
        //                     team_above: evt.oldIndex < evt.newIndex ? evt.models[evt.oldIndex].id_teams : evt.models[evt.newIndex].id_teams,
        //                     teams: [evt.models[evt.newIndex].id_teams, evt.models[evt.oldIndex].id_teams].sort()
        //                 }
        //             );
        //             vm.copyMock = transformMatchCenter.changePosition(evt.newIndex, evt.oldIndex, vm.copyMock);
        //             vm.currentCompetitionSeason.results = vm.copyMock;
        //             vm.saveCompetitionSeason(vm.currentCompetitionSeason);
        //         }
        //         return false;
        //     }
        // }

        vm.templateSortable = {
            group: '.template',
            handle: '.drag',
            animation: 150,
            ghostClass: 'sortable-ghost',
            chosenClass: 'sortable-chosen',
            forceFallback: false,
            onStart: function(evt) {
                vm.copyMock = angular.copy(vm.currentCompetitionSeason.results);
            },
            onEnd: function(evt) {
                let key;
                switch (vm.sport) {
                    case 'football':
                        key = 'pt'
                        break;
                    case 'sailing':
                        key = 'total'
                        break;
                    default:
                        break;
                }
                if (
                    typeof evt.oldIndex == 'undefined'
                    || typeof evt.newIndex == 'undefined'
                    || evt.newIndex == evt.oldIndex
                    || (Math.abs(evt.newIndex - evt.oldIndex) > 1)
                    || evt.models[evt.oldIndex][key] != evt.models[evt.newIndex][key]) 
                {
                    vm.currentCompetitionSeason.results = vm.copyMock;
                } else {
                    if (!vm.currentCompetitionSeason.result_exceptions) {
                        vm.currentCompetitionSeason.result_exceptions = [];
                    } else {
                        const found = vm.currentCompetitionSeason.result_exceptions.findIndex(excepction => {
                            return JSON.stringify(excepction.teams) == JSON.stringify([evt.models[evt.newIndex].id_teams, evt.models[evt.oldIndex].id_teams].sort())
                        })
                        if (found >= 0) {
                            vm.currentCompetitionSeason.result_exceptions.splice(found, 1);
                        }
                    }
                    vm.currentCompetitionSeason.result_exceptions.push(
                        {
                            team_above: evt.oldIndex < evt.newIndex ? evt.models[evt.oldIndex].id_teams : evt.models[evt.newIndex].id_teams,
                            teams: [evt.models[evt.newIndex].id_teams, evt.models[evt.oldIndex].id_teams].sort()
                        }
                    );
                    vm.copyMock = transformMatchCenter.changePosition(evt.newIndex, evt.oldIndex, vm.copyMock);
                    vm.currentCompetitionSeason.results = vm.copyMock;
                    vm.saveCompetitionSeason(vm.currentCompetitionSeason);
                }
                return false;
            }
          };



        vm.dataEvent = {
            timeSelected: null,
            actionSelected: null
        };
        vm.dataComment = {
            comment: null,
            langSelected: null
        };
        vm.dateFormat = sessionService.site_operative.dateFormat;
        vm.dateTimeFormat = sessionService.site_operative.dateTimeFormat;
        vm.selectTab = selectTab;
        vm.updateDatePicker = updateDatePicker;
        vm.mediaDialog = mediaDialog;
        vm.joinClipsWindow = joinClipsWindow;
        vm.openThread = openThread;
        vm.closeThread = closeThread;
        vm.getArrayOfSets = getArrayOfSets;
        vm.deleteAttachment = deleteAttachment;
        vm.downloadMediaOriginal = downloadMediaOriginal;
        vm.MediaItemRecrop = MediaItemRecrop;
        vm.openMediaItemMetadata = openMediaItemMetadata;
        vm.openFocalPoint = openFocalPoint;
        vm.createMark = createMark;
        vm.openImageDialog = openImageDialog;
        vm.toggleSidenav = toggleSidenav;
        vm.getTeamsPeople = getTeamsPeople;
        vm.getMatches = getMatches;
        vm.getMatchesStatus = getMatchesStatus;
        vm.getMatchClass = getMatchClass;
        vm.isOpenSidenav = isOpenSidenav;
        vm.openCreateDialog = openCreateDialog;
        vm.openLiveStream = openLiveStream;
        vm.createClipApi = createClipApi;
        vm.editClipApi = editClipApi;
        vm.openPreview = openPreview;
        vm.getTranslateBySport = getTranslateBySport;
        vm.openCompetitionSeason = openCompetitionSeason;
        vm.getMaxTeams = getMaxTeams;
        vm.getActionClass = getActionClass;
        vm.openTeamsDialog = openTeamsDialog;
        vm.openImportDialog = openImportDialog;
        vm.configureTabsDialog = configureTabsDialog;
        vm.openJuryDialog = openJuryDialog;
        vm.getSportFiles = getSportFiles;
        vm.cancelAddEvent = cancelAddEvent;
        vm.cancelAddComment = cancelAddComment;
        vm.setUndefindedDate = setUndefindedDate;
        vm.newMatch = newMatch;
        vm.openMatch = openMatch;
        vm.deleteMatch = deleteMatch;
        vm.saveMatch = saveMatch;
        vm.closeMatch = closeMatch;
        vm.openVenuesDialog = openVenuesDialog;
        vm.openTeamEditDialog = openTeamEditDialog;
        vm.openTeamEditStatusDialog = openTeamEditStatusDialog;
        vm.removeEvent = removeEvent;
        vm.removeComment = removeComment;
        vm.openTeamMatchDialog = openTeamMatchDialog;
        vm.getContentSection = getContentSection;
        vm.getMatchesEvents = getMatchesEvents;
        vm.getMatchesComments = getMatchesComments;
        vm.getMatchesLive = getMatchesLive;
        vm.getClips = getClips;
        vm.closeCompetitionSeason = closeCompetitionSeason;
        vm.createMatchComment = createMatchComment;
        vm.deleteTeamMatch = deleteTeamMatch;
        vm.addComment = addComment;
        vm.toggleItemStatusComment = toggleItemStatusComment;
        vm.toggleItemStatusMatch = toggleItemStatusMatch;
        vm.addEvent = addEvent;
        vm.createMatchEvent = createMatchEvent;
        vm.currentMatch = null;
        vm.matches = [];
        vm.openMenu = openMenu;
        vm.saveCompetitionSeason = saveCompetitionSeason;
        vm.recalcularSanciones = recalcularSanciones;
        vm.reordenarSanciones = reordenarSanciones;
        vm.guardarSanciones = guardarSanciones;
        vm.isSortableUpEvent = isSortableUpEvent;
        vm.isSortableDownEvent = isSortableDownEvent;
        vm.sortEvent = sortEvent;
        vm.deleteTeam = deleteTeam;
        vm.updateTeams = updateTeams;
        vm.normalizeDecimal = normalizeDecimal;
        vm.finalizePoints = finalizePoints;

        vm.sortEvents = '';
        vm.showTeams = true;
        vm.showJury = true;
        vm.showFormAddEvent = false;
        vm.showFormAddComment = false;
        $scope.isLoading = true;
        vm.loadingEventsPane = false;
        vm.loadingAddComment = false;
        vm.seeUpdate = false;
        vm.updatePeople = updatePeople;
        vm.loadMatchRequestUpdate = loadMatchRequestUpdate;
        vm.teamsMatch = [];
        vm.peopleMatch = [];
        vm.peopleFind = [];
        vm.ref1 = [];
        //        vm.siteId = siteId;
        // vm.showJury = false;
        vm.currentSettings = {};
        vm.basicForm = {};
        /*        vm.searchQuery = '';
                vm.skipLoad = false;
                vm.ref  = null;
                vm.showAll = false;
                vm.teamsup = "";
                vm.siteID = $scope.siteID;
                vm.filterTeams = {};
                vm.filterTeams[vm.sectionTeamsName] = '';
        //        vm.sectionTeams = vm.currentCompetitionSeason.teams_section_data.sectionTeams;
        //        vm.sectionTeamsId = vm.currentCompetitionSeason.teams_section_data.sectionTeamsId;
        //        vm.sectionTeamsName = vm.currentCompetitionSeason.teams_section_data.sectionTeamsName;  */
        vm.translate = function (text) {
            return $translate.instant(text);
        }

        vm.msScrollOptions = {
            suppressScrollX: true
        };

        vm.mediaZones = [];

        //////////

        /**
         * Expanded/collapsed state of the seasons tree.
         *
         * Every save calls $rootScope.pagination_resetquery(), and qiu-pagination answers
         * by replacing vm.seasons with brand new objects, so the expanded flag that
         * ivh-treeview keeps inside each node is lost and the tree comes back fully
         * expanded. The state is kept here, keyed by node, and reapplied to the new tree
         * before it is rendered.
         *
         * It is read from the tree that is being replaced instead of from the toggle
         * events, so it also covers the expand/collapse all buttons of <mv-tree-expander>,
         * which write the flag directly.
         */
        var treeExpandedState = {};
        var treeExpandedAttribute = ivhTreeviewOptions().expandedAttribute;
        var treeSearchExpanded = false;
        var treeSelectedId = null;

        // matchCenterService tags every node with its type when it builds the tree.
        function treeNodeKey(node) {
            var id = (node.type === 'season') ? node.id_season : node.id_competition_season;
            return node.type + ':' + (angular.isDefined(id) ? id : node.label);
        }

        function rememberTreeExpandedState(nodes) {
            angular.forEach(nodes || [], function (node) {
                // Undefined means the node was never rendered, so it says nothing.
                if (angular.isDefined(node[treeExpandedAttribute])) {
                    treeExpandedState[treeNodeKey(node)] = !!node[treeExpandedAttribute];
                }
                rememberTreeExpandedState(node.children);
            });
        }

        function applyTreeExpandedState(nodes) {
            angular.forEach(nodes || [], function (node) {
                var key = treeNodeKey(node);
                // A node never seen before stays expanded, as the whole tree used to be.
                node[treeExpandedAttribute] = treeExpandedState.hasOwnProperty(key)
                    ? treeExpandedState[key]
                    : true;
                applyTreeExpandedState(node.children);
            });
        }

        /**
         * Highlight of the open competition season.
         *
         * It lives in the node itself because the ivh-treeview node template is compiled
         * against an isolated scope, where vm is not reachable. It used to be a class
         * added to the dom by hand, which the reload after a save wiped out along with
         * the rest of the tree.
         */
        function selectTreeNode(competitionSeason) {
            treeSelectedId = competitionSeason ? competitionSeason.id_competition_season : null;
            applyTreeSelection(vm.seasons);
        }

        function applyTreeSelection(nodes) {
            angular.forEach(nodes || [], function (node) {
                node.is_selected_node = !!treeSelectedId
                    && node.type === 'competition_season'
                    && node.id_competition_season == treeSelectedId;
                applyTreeSelection(node.children);
            });
        }

        // vm.seasons is replaced, never mutated, so watching the reference is enough.
        // This watcher belongs to the controller scope, so it runs before the treeview
        // renders the new nodes and there is no flicker.
        $scope.$watch(function () {
            return vm.seasons;
        }, function (newSeasons, oldSeasons) {
            if (oldSeasons !== newSeasons && !treeSearchExpanded) {
                rememberTreeExpandedState(oldSeasons);
            }
            if (treeSearchExpanded) {
                ivhTreeviewMgr.expandRecursive(newSeasons);
            } else {
                applyTreeExpandedState(newSeasons);
            }
            applyTreeSelection(newSeasons);
        });

        // The filter of the tree only hides nodes, it does not open their parents, so a
        // match inside a collapsed season would be invisible. The whole tree is expanded
        // while searching and put back as the user had it once the search is cleared.
        $scope.$watch(function () {
            return vm.treeSearch;
        }, function (search, previousSearch) {
            if (search === previousSearch) {
                return;
            }
            if (search) {
                treeSearchExpanded = true;
                ivhTreeviewMgr.expandRecursive(vm.seasons);
            } else if (treeSearchExpanded) {
                treeSearchExpanded = false;
                applyTreeExpandedState(vm.seasons);
            }
        });

        init();

        function init() {
            vm.views = {
                split: 'app/main/apps/match-center/views/list/split-view.html',
                nosplit: 'app/main/apps/match-center/views/list/no-split-view.html'
            };
            vm.viewsLive = {
                split: 'app/main/apps/match-center/views/list/split-view-live.html',
                nosplit: 'app/main/apps/match-center/views/list/no-split-view-live.html'
            };
            vm.defaultView = 'split';
            vm.currentView = 'split';
            vm.loadingView = true;

            //vm.getCountriesWithStates();

            var siteID = requestContext.getParam("siteId");
            $scope.siteID = siteID;

            contentService.getFilters({ section: 'matches', site: siteID }).then(function (response) {
                vm.mediaZones = (response.media_zones.length == 0)
                    ? null
                    : angular.copy(response.media_zones);
            });

            if (!vm.isLiveCenter) {
                getTabs()
                vm.getContentSection('teams');
                vm.getContentSection('people');
                vm.getContentSection('venues');
                vm.getContentSection('phases');
                vm.getContentSection('groups');
                vm.getContentSection('serie');
                vm.getContentSection('classes');
                vm.getContentSection('matches_events_actions');
            } else {
                vm.tabs = [
                    { "id_matches_tabs": 6, "onoff": 1, "lang": null, "name": "live", "title": "MATCH_CENTER.LIVE", "template": "app/main/apps/match-center/views/list/tabs-match/tab-live.html", "sort": 1, "Thumbnail": [], "tags": [], "id": 6 },
                    { "id_matches_tabs": 7, "onoff": 1, "lang": null, "name": "live-clips", "title": "MATCH_CENTER.LIVECLIPS", "template": "app/main/apps/match-center/views/list/tabs-match/tab-live-clips.html", "sort": 2, "Thumbnail": [], "tags": [], "id": 7 },
                    { "id_matches_tabs": 8, "onoff": 1, "lang": null, "name": "social-post", "title": "MATCH_CENTER.SOCIALPOSTS", "template": "app/main/apps/match-center/views/list/tabs-match/tab-social-post.html", "sort": 2, "Thumbnail": [], "tags": [], "id": 8 }
                ];
                vm.existTabClips = true;
            }
        }

        function normalizeDecimal(team) {
            if (!team) return;
            var val = team.points;
            if (val === null || angular.isUndefined(val)) return;

            if (typeof val === 'string') {
                var normalized = val.replace(',', '.');

                var allowed = /^-?\d*\.?\d*$/.test(normalized);

                if (allowed) {
                    team.points = normalized;
                } else {
                    team.points = normalized.replace(/[^0-9.\-]/g, '');
                }
            }
        }

        function finalizePoints(team) {
            if (!team) return;
            var str = (team.points === null || angular.isUndefined(team.points)) ? '' : String(team.points);
            var n = parseFloat(str.replace(',', '.'));
            team.points = isNaN(n) ? 0 : n;
        }

        function deleteTeam(index, ev){
            let team = vm.currentCompetitionSeason.teams[index];
            let confirmTitle = $translate.instant('MATCH_CENTER.DELETE_TEAM', {team_name: team.name});
            var confirm = $mdDialog.confirm()
                            .title(confirmTitle)
                            .ariaLabel(confirmTitle)
                            .targetEvent(ev)
                            .ok('OK')
                            .cancel($translate.instant('CANCEL'));
            $mdDialog.show(confirm).then(function () {
                vm.currentCompetitionSeason.teams.splice(index, 1);
                vm.saveCompetitionSeason()
            });
        }

        function updateTeams(){
            matchCenterService.getContentSection({
                site: $scope.siteID,
                search: null,
                filters: []
            }, 'teams').then(resp => {
                let oldTeams = vm.currentCompetitionSeason.teams || [];
                let dataTeams = (resp && resp.result && Array.isArray(resp.result.data)) ? resp.result.data : [];

                // Optional debug (harmless)
                $log.info('[updateTeams] oldTeams:', oldTeams.length, 'dataTeams:', dataTeams.length);

                let newTeams = [];
                oldTeams.forEach(team => {
                    // CHANGE #1: normalize id types to avoid mismatch
                    let dataTeam = dataTeams.find(x => String(x.id_teams) === String(team.id_teams));

                    let newTeam = {};
                    Object.keys(team).forEach((key) => {
                        if (dataTeam && dataTeam[key]) {
                            if (typeof dataTeam[key] === 'string' && dataTeam[key].startsWith('[') && dataTeam[key].endsWith(']')) {
                                try{
                                    newTeam[key] = JSON.parse(dataTeam[key]);
                                }catch(error){
                                    newTeam[key] = dataTeam[key];
                                }
                            } else {
                                newTeam[key] = dataTeam[key];
                            }
                        } else {
                            newTeam[key] = team[key];
                        }

                        // CHANGE #2: guard if dataTeam is undefined
                        if (dataTeam && dataTeam.Thumbnail){
                            newTeam.Thumbnail = dataTeam.Thumbnail;
                        }
                    });

                    newTeams.push(toTeamRef(newTeam));
                });

                vm.currentCompetitionSeason.teams = newTeams;

                if (vm.matches && vm.matches.length){
                    // El listado (vm.matches) NO incluye teams_data, así que NO podemos guardar
                    // directamente esos matches: se guardarían con teams_data vacío y se borrarían
                    // todos los resultados. Cargamos cada match COMPLETO (getByID trae teams_data),
                    // fusionamos solo los campos de equipo y guardamos. Esperamos a que terminen
                    // todos los guardados antes de recargar.
                    var matchSavePromises = vm.matches.map(function (listMatch) {
                        return contentService.getByID({
                            site: $scope.siteID,
                            section: 'matches',
                            id: listMatch.id
                        }).then(function (res) {
                            var fullMatch = transformMatchCenter.DTOtoMatch(res.result);
                            if (fullMatch.teams_data){
                                fullMatch.teams_data.forEach(function (team) {
                                    var newTeam = newTeams.find(function (x) {
                                        return String(x.id_teams) === String(team.id_teams);
                                    });
                                    if (newTeam){
                                        Object.keys(team).forEach(function (key) {
                                            if (newTeam[key]){
                                                team[key] = newTeam[key];
                                            }
                                        });
                                    }
                                });
                            }
                            return saveNotOpenMatch(fullMatch);
                        });
                    });
                    $q.all(matchSavePromises).then(function () {
                        vm.getMatches(true);
                    });
                }
                vm.updatePeople();
                vm.saveCompetitionSeason(vm.currentCompetitionSeason);
            });
        }


       function toTeamRef(team) {
            var result = {};
            var hasGetRef = (typeof vm.getReferenceSectionData === 'function');

            for (var i = 0; i < vm.teamsRef.length; i++) {
                const element = vm.teamsRef[i];

                if (element.in_json_object == 1) {
                    if (element.type == 'thumbnail') {
                        if (element.id_zone) {
                        var thumb = $filter('filter')(team.Thumbnail, { id_zone: element.id_zone }, true) || [];
                        result[element.titleId] = thumb.length > 0
                            ? transformMatchCenter.setItemMedia(thumb[0], element)
                            : team[element.titleId];
                        } else {
                        result[element.titleId] = (team.Thumbnail && team.Thumbnail.length > 0)
                            ? transformMatchCenter.setItemMedia(team.Thumbnail[0], element)
                            : team[element.titleId];
                        }

                    } else if (element.type == 'id_subsec' || element.type == 'id_cat' || element.type == 'id_subcat') {
                        // --- minimal guard + try/catch ---
                        var sectionKey =
                        element.type == 'id_subsec' ? 'subsection' :
                        element.type == 'id_cat'    ? 'cat'        :
                                                        'subcat';

                        var rawId = team[element.titleId];

                        if (!hasGetRef) {
                            console.warn('[toTeamRef] getReferenceSectionData is not a function; falling back. key:', element.titleId);
                            result[element.titleId] = rawId;
                        } else if (rawId == null || rawId === '') {
                            console.warn('[toTeamRef] Missing id for reference lookup; falling back. type:', sectionKey, 'key:', element.titleId);
                            result[element.titleId] = rawId;
                        } else {
                        try {
                            // normalize id just in case (string/number)
                            var normId = (typeof rawId === 'string' && /^\d+$/.test(rawId)) ? Number(rawId) : rawId;
                            result[element.titleId] = vm.getReferenceSectionData(sectionKey, element.type, normId);
                        } catch (e) {
                            $log.error('[toTeamRef] getReferenceSectionData threw. type:', sectionKey, 'id:', rawId, 'key:', element.titleId, e);
                            result[element.titleId] = rawId; // safe fallback
                        }
                        }

                    } else if (element.type == 'json' || element.type == 'jsondata') {
                        try {
                            result[element.titleId] = angular.fromJson(team[element.titleId]);
                        } catch (e) {
                            console.warn('[toTeamRef] JSON parse failed; falling back. key:', element.titleId, e);
                            result[element.titleId] = team[element.titleId];
                        }

                    } else {
                        result[element.titleId] = team[element.titleId];
                    }
                }
            }

            if (!result.team_name) {
                result.team_name = result[vm.sectionTeamsName];
            }
            if (!result.id_teams) {
                result.id_teams = result[vm.sectionTeamsId];
            }
            return result;
        }

        function updatePeople() {
            vm.peopleFind = [];
            var options = {
                site: $scope.siteID,
                search: null,
                filters: []
            };
            matchCenterService.getContentSection(options, 'people').then(function (response) {
                vm.peopleFind = angular.copy(response.result.data);
                vm.ref1 = angular.copy(response.ref);
                //           vm.setCropFormat();
                for (var i = 0; i < vm.peopleFind.length; i++) {
                    vm.peopleMatch.push(msUtils.toSectionRef(vm.peopleFind[i], vm.ref1));
                }
            });
        }

        function getTabs() {
            contentService.get({ section: 'matches_tabs', siteID: $scope.siteID }).then(function (response) {
                vm.tabs = $filter('filter')(response.result.data, { onoff: 1 });
                vm.existTabClips = vm.tabs.find(x => {
                    return x.name === "live-clips" && x.onoff === 1
                }) ? true : false;
            });
        }
        function selectTab(tab) {
            vm.tabs = vm.tabs.map(x => {
                x.displayed = false;
                return x;
            })
            tab.displayed = true;
        }


        $scope.criteriaMatch = function (criteria) {
            return function (item) {
                return !criteria || item.name.normalize('NFD').replace(/[\u0300-\u036f]/g, "").search(new RegExp(criteria.normalize('NFD').replace(/[\u0300-\u036f]/g, ""), "i")) >= 0;
            };
        };

        $scope.localeSensitiveComparator = function (v1, v2) {
            // If we don't get strings, just compare by index
            if (v1.type !== 'string' || v2.type !== 'string') {
                return (v1.index < v2.index) ? -1 : 1;
            }

            // Compare strings alphabetically, taking locale into account
            return v1.value.localeCompare(v2.value);
        };
        var originatorEv;
        function openMenu($mdMenu, ev) {
            originatorEv = ev;
            $mdMenu.open(ev);
        }


        // Watch screen size to change view modes
        $scope.$watch(function () {
            return $mdMedia('lt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                vm.currentView = 'nosplit';
            }
        });

        $scope.$watch(function () {
            return $mdMedia('max-width: 960px');
        }, function (big) {

            if (big)
                vm.currentView = 'nosplit';

        });

        $scope.$watch(function () {
            return $mdMedia('min-width: 960px');
        }, function (small) {

            if (small)
                vm.currentView = 'split';

        });

        $scope.$watch(function () {
            return $mdMedia('gt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                if (vm.defaultView === 'split') {
                    vm.currentView = 'split';
                }
            }
        });

        function updateDatePicker() {
            var value = moment.utc(vm.currentMatch.date).format('YYYY-MM-DD HH:mm:00');
            var utcDate = moment.utc(value);
            var siteDate = moment.utc(value).tz(sessionService.site_operative.timezone);
            vm.currentMatch.dateValue = value;
            vm.currentMatch.date = new Date(siteDate.format());
            vm.currentMatch.dateShow = siteDate.format(vm.dateTimeFormat);
            vm.currentMatch.utcShow = utcDate.format(vm.dateTimeFormat);
            vm.currentMatch.utcDate = utcDate;
        }

        function setUndefindedDate() {
            if (vm.currentMatch.date == null) {
                vm.currentMatch.date = new Date();
                updateDatePicker()
            } else {
                vm.currentMatch.date = null;
            }
        }


        $scope.$on('pagination:loadStart', function (event) {
            $scope.isLoading = true;
        });

        $scope.$on('pagination:loadPage', function (event) {
            $scope.isLoading = false;
        });

        $scope.$on('openEditDialog', function (event, node) {
            vm.openCompetitionSeason(node);
        });

        function isSortableUpEvent(i) {
            const sorted = $filter('orderBy')(vm.matchEvents, ['time_category', 'time', 'sort'], vm.sortEvents)
            return ((i - 1) > 0) && sorted[i].time == sorted[i - 1].time
        }
        function isSortableDownEvent(i) {
            const sorted = $filter('orderBy')(vm.matchEvents, ['time_category', 'time', 'sort'], vm.sortEvents)
            return ((i + 1) < sorted.length) && sorted[i].time == sorted[i + 1].time
        }
        function sortEvent(dir, i) {
            const sorted = $filter('orderBy')(vm.matchEvents, ['time_category', 'time', 'sort'], vm.sortEvents)
            vm.timeSorting = sorted[i].time;
            let filtered = sorted.filter(x => x.time === sorted[i].time).map((x, i) => {
                return { id: x.id, sort: i }
            })
            filtered = filtered.map(x => {
                if (x.id == sorted[i].id) {
                    x.sort = x.sort + (1.1 * dir);
                }
                return x;
            })
            filtered = $filter('orderBy')(filtered, 'sort')
            filtered = filtered.map((x, i) => {
                return { id: x.id, sort: i }
            })
            var options = {
                site: $scope.siteID,
                data: {
                    "items": filtered
                }
            }
            matchCenterService.updateSortEvents(options).then(res => {
                vm.getMatchesEvents(vm.currentMatch.id);
                setTimeout(() => {
                    vm.timeSorting = false;
                }, 200);
            })
        }
        function closeCompetitionSeason() {
            vm.currentCompetitionSeason = null;
            selectTreeNode(null);
        }
        function addEvent(event, push) {

            if (event.actionSelected.trigger && vm.sport == 'football' && event.teamSelected) {
                var messageConfirm = msUtils.translate('MATCH_CENTER.APPLY_ACTION_ATACHED');

                var confirm = $mdDialog.confirm()
                    .title(messageConfirm)
                    .ok(msUtils.translate('GLOBAL.OK'))
                    .cancel(msUtils.translate('GLOBAL.CANCEL'))
                    .multiple(true)
                    ;
                $mdDialog.show(confirm).then(function () {
                    switch (event.actionSelected.trigger) {
                        case 'score':
                            for (var i = 0; i < vm.currentMatch.teams_data.length; i++) {
                                if (vm.currentMatch.teams_data[i].id_teams == event.teamSelected.id_teams) {
                                    vm.currentMatch.teams_data[i].score = parseInt(vm.currentMatch.teams_data[i].score, 10) + 1
                                }
                            }
                            break;
                        case 'score-in-penalties':
                            for (var i = 0; i < vm.currentMatch.teams_data.length; i++) {
                                if (vm.currentMatch.teams_data[i].id_teams == event.teamSelected.id_teams) {
                                    vm.currentMatch.teams_data[i].penalties = parseInt(vm.currentMatch.teams_data[i].penalties, 10) + 1
                                }
                            }
                            break;
                        case 'score-against':
                            for (var i = 0; i < vm.currentMatch.teams_data.length; i++) {
                                if (vm.currentMatch.teams_data[i].id_teams != event.teamSelected.id_teams) {
                                    vm.currentMatch.teams_data[i].score = parseInt(vm.currentMatch.teams_data[i].score, 10) + 1
                                }
                            }
                            break;
                        default:
                            break;
                    }
                    vm.saveMatch(false, true, event, push)
                }, function () {
                    createEvent(event, push);
                });


            } else {
                createEvent(event, push);
            }

        }

        function createEvent(event, push) {
            vm.newEvent = {
                id_match: parseInt(vm.currentMatch.id),
                time_category: event.timeSelected.category,
                time: event.timeSelected.name,
                id_action: event.actionSelected.id,
                action: event.actionSelected.action_name,
                id_team: event.teamSelected ? event.teamSelected.id_teams : null,
                name_team: event.teamSelected ? event.teamSelected.team_name : null,
                name_player: event.playerSelected ? event.playerSelected.name : null,
                id_player: event.playerSelected ? event.playerSelected.id_people : null,
                send_push: angular.isUndefined(push) ? 0 : push
            };
            vm.showFormAddEvent = false;
            vm.createMatchEvent(vm.newEvent);
        }
        function cancelAddEvent() {
            vm.showFormAddEvent = false;
            vm.cleanVars();
        }
        function cancelAddComment() {
            vm.showFormAddComment = false;
            vm.cleanVars();
        }
        vm.cleanVars = function () {
            vm.dataEvent = {
                timeSelected: null,
                actionSelected: null,
                playerSelected: null
            };
            vm.languageFilter = null;
            vm.dataComment = {
                comment: null,
                langSelected: null
            };
        }
        function toggleItemStatusComment(comment) {
            event.stopPropagation();
            vm.loadingCommentsPane = true;
            comment.onoff = (comment.onoff === 1)
                ? 0
                : 1;

            var options = {
                site: $scope.siteID,
                id: comment.id,
                item: comment,
            };
            matchCenterService.saveMatchComment(options).then(function (response) {
                vm.getMatchesComments(vm.currentMatch.id);
                var message = $translate.instant('MATCH_CENTER.SAVED');
                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                    hideDelay: 5000,
                    position: 'top',
                    parent: '#content-container'
                });

            });
        }
        function toggleItemStatusMatch(match) {
            event.stopPropagation();
            // vm.loadingCommentsPane = true;
            match.onoff = (match.onoff === 1)
                ? 0
                : 1;

            var options = {
                site: $scope.siteID,
                id: match.id,
                item: match,
            };
            var options = {
                site: $scope.siteID,
                section: 'matches',
                id: match.id,
                item: transformMatchCenter.MatchToDTO(angular.copy(match), vm.currentCompetitionSeason, vm.final_types, vm.teamsRef, vm.teamsReferenceSections)
            };
            contentService.saveItem(options).then(function (response) {
                var message = $translate.instant('MATCH_CENTER.SAVED');
                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                    hideDelay: 5000,
                    position: 'top',
                    parent: '#content-container'
                });
            });
        }
        function createMatchEvent(match_event) {

            vm.loadingEventsPane = true;
            var options = {
                site: $scope.siteID,
                id: 'new',
                item: match_event,
            };
            matchCenterService.saveMatchEvent(options).then(function (response) {
                vm.dataEvent = null;
                vm.dataEvent = {
                    timeSelected: null,
                    actionSelected: null
                }
                vm.getMatchesEvents(vm.currentMatch.id);
                var message = $translate.instant('MATCH_CENTER.SAVED');
                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                    hideDelay: 5000,
                    position: 'top',
                    parent: '#content-container'
                });

            });

        }
        function removeEvent(event) {
            var options = {
                site: $scope.siteID,
                id: event.id
            };
            vm.loadingEventsPane = true;
            matchCenterService.removeEvent(options).then(function (response) {
                vm.getMatchesEvents(vm.currentMatch.id);
            });
        }
        function removeComment(comment) {
            var options = {
                site: $scope.siteID,
                id: comment.id
            };
            vm.loadingCommentsPane = true;
            matchCenterService.removeComment(options).then(function (response) {
                vm.getMatchesComments(vm.currentMatch.id);
            });
        }

        function addComment(dataComment) {
            vm.newComment = {
                datetime: new Date(),
                author: vm.user.first_name + ' ' + vm.user.last_name,
                id_author: vm.user.id_user,
                comment: dataComment.comment,
                onoff: 1,
                time: dataComment.time.name,
                lang: dataComment.langSelected,
                id_match: parseInt(vm.currentMatch.id),
            };
            vm.showFormAddComment = false;
            vm.createMatchComment(vm.newComment);
        }
        function createMatchComment(match_comment) {
            vm.cleanVars();
            vm.loadingCommentsPane = true;
            var options = {
                site: $scope.siteID,
                id: 'new',
                item: match_comment,
            };
            matchCenterService.saveMatchComment(options).then(function (response) {
                vm.getMatchesComments(vm.currentMatch.id);
                var message = $translate.instant('MATCH_CENTER.SAVED');
                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                    hideDelay: 5000,
                    position: 'top',
                    parent: '#content-container'
                });

            });

        }

        // La penalizacion NUNCA suma: se teclea en positivo y aqui se le pone el signo.
        // Normalizar con -abs() en vez de confiar en el signo guardado deja a salvo los
        // datos metidos a mano (Gabi guardo -30 directamente en la BD).
        function aPenalizacion(valor) {
            var n = Math.abs(aEntero(valor));
            return n === 0 ? 0 : -n;
        }

        function aEntero(valor) {
            var n = parseInt(valor, 10);
            return isNaN(n) ? 0 : n;
        }

        /**
         * Los puntos guardados YA son netos (bruto + penalizacion). Para poder
         * recalcular al vuelo hace falta el bruto, y hay que deducirlo AQUI, al cargar.
         *
         * Deducirlo en el primer ng-change no vale: el primer evento al teclear una
         * penalizacion es el del signo "-", cuando ng-model ya ha puesto penalties a
         * null. Entonces se cacheaba el NETO como si fuera el bruto y a partir de ahi
         * todo salia mal (con -30 guardado, teclear -40 daba -10 y volver a -30 daba 0).
         */
        function prepararSanciones(competitionSeason) {
            var filas = (competitionSeason && competitionSeason.results) || [];
            angular.forEach(filas, function (fila) {
                fila.penalties = aPenalizacion(fila.penalties);
                fila.reprimands = Math.abs(aEntero(fila.reprimands));
                // Lo que se teclea es el valor POSITIVO; fila.penalties sigue siendo el
                // negativo que se guarda y con el que se hacen las cuentas.
                fila._penalizacion = Math.abs(fila.penalties);
                fila._puntosBrutos = aEntero(fila.points) - fila.penalties;
                fila._sancionGuardada = firmaSancion(fila);
            });
            return competitionSeason;
        }

        /**
         * Recalcula los puntos netos mientras se teclea, para ver el efecto antes de
         * guardar. No reordena: la fila que estas editando se escaparia de debajo del
         * cursor. De reordenar se encarga reordenarSanciones() al salir del campo.
         */
        function recalcularSanciones() {
            var filas = (vm.currentCompetitionSeason && vm.currentCompetitionSeason.results) || [];
            angular.forEach(filas, function (fila) {
                if (!angular.isDefined(fila._puntosBrutos)) { return; }
                fila.penalties = aPenalizacion(fila._penalizacion);
                fila.reprimands = Math.abs(aEntero(fila.reprimands));
                fila.points = fila._puntosBrutos + fila.penalties;
                fila.total = fila.points;
            });
        }

        /**
         * Reordena al salir del campo, con el mismo criterio que getResultCars() usara
         * al guardar: el signo va DENTRO del criterio para que orderBy no invierta
         * tambien el desempate por indice.
         */
        function reordenarSanciones() {
            var cs = vm.currentCompetitionSeason;
            if (!cs || !cs.results) { return; }
            recalcularSanciones();
            var criterio = cs.result_sort === 'ASC' ? 'points' : '-points';
            cs.results = $filter('orderBy')(cs.results, criterio);
            angular.forEach(cs.results, function (fila, i) { fila.position = i + 1; });
        }

        function firmaSancion(fila) {
            return aEntero(fila.penalties) + '/' + aEntero(fila.reprimands);
        }

        /**
         * El guardado reconstruye la clasificacion ENTERA desde los partidos, asi que un
         * guardado automatico solo es seguro si lo unico que cambia es la sancion.
         *
         * Devuelve la lista de diferencias inesperadas. Cubre tres escenarios reales:
         *   - vm.matches todavia vacio (se llena async tras cargar la temporada): todos
         *     los brutos saldrian a 0 y se borraria la clasificacion.
         *   - pilotos que estan en results pero ya no en la plantilla (pasa hoy en Euro
         *     RX5 con 3 pilotos que ya no existen en section_teams): desapareceria.
         *   - cualquier otra divergencia futura entre lo pintado y lo reconstruido.
         */
        function diferenciasInesperadas(cs) {
            var dto = transformMatchCenter.competitionSeasonToDTO(angular.copy(cs), vm.matches, vm.sport);
            var reconstruido;
            try { reconstruido = JSON.parse(dto.results); } catch (e) { return ['results ilegible']; }
            var porId = {};
            angular.forEach(reconstruido, function (f) { porId[f.id_teams] = f; });
            var problemas = [];
            angular.forEach(cs.results, function (fila) {
                var n = porId[fila.id_teams];
                if (!n) { problemas.push(fila.name + ': desapareceria'); return; }
                var esperado = aEntero(fila._puntosBrutos) + aEntero(fila.penalties);
                if (aEntero(n.points) !== esperado) {
                    problemas.push(fila.name + ': ' + esperado + ' -> ' + n.points);
                }
            });
            return problemas;
        }

        function avisoSancion(mensaje, claseColor) {
            $mdToast.show({
                template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content ' + claseColor + '"><span class="md-toast-text" flex>' + mensaje + '</span></div></md-toast>',
                hideDelay: claseColor === 'green-500-bg' ? 1500 : 8000,
                position: 'top',
                parent: '#content-container'
            });
        }

        /**
         * Al salir de una celda de sancion: recalcula, reordena y GUARDA, pero solo si el
         * valor ha cambiado de verdad (entrar y salir sin tocar no escribe nada) y solo si
         * la reconstruccion no toca nada mas que la sancion.
         */
        function guardarSanciones() {
            var cs = vm.currentCompetitionSeason;
            if (!cs || !cs.results) { return; }
            reordenarSanciones();

            var cambiadas = [];
            angular.forEach(cs.results, function (fila) {
                if (firmaSancion(fila) !== fila._sancionGuardada) { cambiadas.push(fila); }
            });
            if (!cambiadas.length) { return; }

            // Una escritura en vuelo cada vez; si llega otra antes, se reintenta al acabar.
            if (vm.guardandoSanciones) { vm.sancionesPendientes = true; return; }

            var problemas = diferenciasInesperadas(cs);
            if (problemas.length) {
                avisoSancion($translate.instant('CARS.SANCTION_BLOCKED') + ' (' + problemas.slice(0, 3).join('; ') + (problemas.length > 3 ? '; ...' : '') + ')', 'red-500-bg');
                return;
            }

            vm.guardandoSanciones = true;
            var opciones = {
                site: $scope.siteID,
                section: 'competition_season',
                id: cs.id_competition_season,
                item: transformMatchCenter.competitionSeasonToDTO(angular.copy(cs), vm.matches, vm.sport)
            };
            contentService.saveItem(opciones).then(function (response) {
                var competition = cs.competition;
                response.item.competition = competition;
                vm.currentCompetitionSeason = prepararSanciones(transformMatchCenter.DTOtoCompetitionSeason(response.item, vm.sport));
                vm.currentCompetitionSeason.competition = competition;
                avisoSancion($translate.instant('CARS.SANCTION_SAVED'), 'green-500-bg');
            }).finally(function () {
                vm.guardandoSanciones = false;
                if (vm.sancionesPendientes) { vm.sancionesPendientes = false; guardarSanciones(); }
            });
        }

        function saveCompetitionSeason() {
            $scope.isLoadingReadPane = true;
            var options = {
                site: $scope.siteID,
                section: 'competition_season',
                id: vm.currentCompetitionSeason.id_competition_season,
                item: transformMatchCenter.competitionSeasonToDTO(angular.copy(vm.currentCompetitionSeason), vm.matches, vm.sport)
            };
            contentService.saveItem(options).then(function (response) {
                $scope.isLoadingReadPane = false;
                $rootScope.pagination_resetquery();
                var message = $translate.instant('MATCH_CENTER.SAVED');
                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                    hideDelay: 5000,
                    position: 'top',
                    parent: '#content-container'
                });
                var competition = vm.currentCompetitionSeason.competition;
                response.item.competition = competition;
                vm.currentCompetitionSeason = prepararSanciones(transformMatchCenter.DTOtoCompetitionSeason(response.item, vm.sport));
                vm.currentCompetitionSeason.competition = competition;
                return true;
            });

        }

        function openJuryDialog(ev) {
            $mdDialog.show({
                controller: 'JuryDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/match-center/dialogs/jury/jury-dialog.html',
                preserveScope: true,
                autoWrap: true,
                multiple: true,
                locals: {
                    siteID: $scope.siteID,
                    title: 'MATCH_CENTER.JURY',
                    jury: vm.currentMatch.jury_data,
                    event: ev
                }
            }).then(function (jury) {
                if (jury) {
                    vm.currentMatch.jury_data = jury;
                }
            });
        }

        function getMatchesEvents(id) {
            var options = {
                site: $scope.siteID,
                filters: [
                    {
                        field: 'id_match',
                        name: 'id_match',
                        values: [id]
                    }
                ],
                resultsPerPage: 1000,
                sortField: 'time_category',
                sortDir: 'ASC'
            };
            matchCenterService.getEvents(options).then(function (response) {
                vm.loadingEventsPane = false;
                vm.matchEvents = response.result.data;
            });
        }

        function openLiveStream(live) {
            vm.matchLive = live;
            vm.matchLivesUrl = live.live_url;
            vm.clipsData = JSON.parse(live.clips_data);
            vm.idLiveStream = live.id_live_stream;
            vm.getClips(vm.idLiveStream);
            vm.interval = setInterval(() => {
                vm.getClips(vm.idLiveStream, true);
            }, 15000);
        }


        function getMatchesLive(id) {
            var options = {
                site: $scope.siteID,
                filters: [
                    {
                        field: 'id_match',
                        name: 'id_match',
                        values: [id]
                    }
                ]
            };
            matchCenterService.getLives(options).then(function (response) {
                vm.matchLive = response.result.data[0];
                if (angular.isUndefined(vm.matchLive)) {
                    return;
                }
                vm.matchLivesUrl = response.result.data[0].live_url;
                vm.clipsData = JSON.parse(response.result.data[0].clips_data);
                vm.idLiveStream = response.result.data[0].id_live_stream;
                vm.getClips(vm.idLiveStream);
                vm.interval = setInterval(() => {
                    vm.getClips(vm.idLiveStream, true);
                }, 15000);
            });
        }
        function getClips(id, reload) {
            var options = {
                site: $scope.siteID,
                id: id,
            };
            matchCenterService.getClips(options).then(function (response) {
                if (!reload) {
                    vm.clips = response.result.Thumbnail;
                } else {
                    vm.newResults = response.result.Thumbnail.filter(x => !vm.clips.find(y => y.id_media === x.id_media));
                    for (let i = 0; i < vm.clips.length; i++) {
                        const element = vm.clips[i];
                        element.isNew = false;
                    }
                    vm.newResults.forEach(element => {
                        element.isNew = true;
                        vm.clips.push(element);
                    });
                }
            });
        }
        function getMatchesComments(id) {
            var options = {
                site: $scope.siteID,
                filters: [
                    {
                        field: 'id_match',
                        name: 'id_match',
                        values: [id]
                    }
                ]
            };
            matchCenterService.getComments(options).then(function (response) {
                vm.loadingCommentsPane = false;
                vm.matchComments = response.result.data;
            });
        }

        function configureTabsDialog(ev) {
            $mdDialog.show({
                controller: 'SettingsTabsDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/match-center/dialogs/settings/settings-tabs-dialog.controller.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                locals: {
                    data: vm.tabs,
                    siteID: $scope.siteID,
                    event: ev
                }
            }).then(function (res) {
                if (res) {
                    getTabs();
                }
            });
        }


        function openTeamsDialog(ev) {
            if (!vm.currentCompetitionSeason.teams) {
                vm.currentCompetitionSeason.teams = [];
            }
            $mdDialog.show({
                controller: 'TeamsDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/match-center/dialogs/teams/teams-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                locals: {
                    data: vm.currentCompetitionSeason,
                    sport: vm.sport,
                    currentCompetitionSeason: vm.currentCompetitionSeason,
                    typesMatch: vm.typesMatch,
                    key: 'teams',
                    maxteams: null,
                    sectionTeams: vm.currentCompetitionSeason.teams_section_data.sectionTeams,
                    sectionTeamsId: vm.currentCompetitionSeason.teams_section_data.sectionTeamsId,
                    sectionTeamsName: vm.currentCompetitionSeason.teams_section_data.sectionTeamsName,
                    teams: null,
                    ref: null,
                    skipLoad: false,
                    siteID: $scope.siteID,
                    referenceSections: vm.teamsReferenceSections,
                    event: ev,
                    seasons: vm.seasons,
                    seeUpdate: vm.seeUpdate,
                    teamsMatch: vm.teamsMatch
                }
            }).then(function (res) {
                if (res) {
                    updatePeople();
                    if (vm.seeUpdate) {
                        for (var i = 0; i < vm.matches.length; i++) {
                            var idM = vm.matches[i].id;
                            for (var im = 0; im < $rootScope.teamsMatch1.length; im++) {
                                if ($rootScope.teamsMatch1[im].id == vm.matches[i].teams_data[0].id_teams) {
                                    vm.matches[i].teams_data[0].media = $rootScope.teamsMatch1[im].media;
                                    vm.matches[i].teams_data[0].team_name = $rootScope.teamsMatch1[im].name;
                                    vm.openMatch(event, idM);

                                }
                                if ($rootScope.teamsMatch1[im].id == vm.matches[i].teams_data[1].id_teams) {
                                    vm.matches[i].teams_data[1].media = $rootScope.teamsMatch1[im].media;
                                    vm.matches[i].teams_data[1].team_name = $rootScope.teamsMatch1[im].name;
                                    vm.openMatch(event, idM);
                                }
                            }
                        }
                    }
                    vm.saveCompetitionSeason(vm.currentCompetitionSeason);
                }
            });
        }
        function openImportDialog(ev) {
            if (!vm.currentCompetitionSeason.teams) {
                vm.currentCompetitionSeason.teams = [];
            }
            $rootScope.siteID1 = $scope.siteID;
            $mdDialog.show({
               controller: 'TeamsDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/match-center/dialogs/teams/import-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                locals: {
                    data: vm.currentCompetitionSeason,
                    sport: vm.sport,
                    currentCompetitionSeason: vm.currentCompetitionSeason,
                    typesMatch: vm.typesMatch,
                    key: 'teams',
                    maxteams: null,
                    sectionTeams: vm.currentCompetitionSeason.teams_section_data.sectionTeams,
                    sectionTeamsId: vm.currentCompetitionSeason.teams_section_data.sectionTeamsId,
                    sectionTeamsName: vm.currentCompetitionSeason.teams_section_data.sectionTeamsName,
                    teams: null,
                    ref: null,
                    skipLoad: false,
                    siteID: $scope.siteID,
                    referenceSections: vm.teamsReferenceSections,
                    event: ev,
                    seeUpdate: vm.seeUpdate,
                    seasons: vm.seasons,
                    teamsMatch: vm.teamsMatch
                }
            }).then(function (res) {
                if (res) {
                    vm.saveCompetitionSeason(vm.currentCompetitionSeason);
                }
            });
        }
        function newMatch() {
            vm.copySidenavState = $mdSidenav('tree-sidenav').isOpen();
            $mdSidenav('tree-sidenav').close();
            vm.matchEvents = [];
            vm.matchComments = [];
            vm.currentMatch = {};
            vm.currentMatch.date = new Date();
            vm.currentMatch.id_competition_season = vm.currentCompetitionSeason.id_competition_season;
            vm.currentMatch.id_competition = vm.currentCompetitionSeason.id_competition ? vm.currentCompetitionSeason.id_competition : vm.currentCompetitionSeason.id_parent;
            vm.currentMatch.id_season = vm.currentCompetitionSeason.id_season;
            vm.currentMatch.onoff = 1;
            vm.currentMatch.teams_data = [];
            vm.updateDatePicker();
        }
        function isOpenSidenav() {
            return $mdSidenav('tree-sidenav').isOpen();
        }
        function openMatch(event, id) {
            delete vm.matchComments;
            delete vm.matchEvents;
            vm.copySidenavState = $mdSidenav('tree-sidenav').isOpen();
            $mdSidenav('tree-sidenav').close();
            loadMatchRequest(id);
            if (!vm.isLiveCenter) {
                vm.getMatchesEvents(id);
                vm.getMatchesComments(id);
            }
            if (vm.tabs.find(x => x.name === "live" || x.name === "live-clips")) {
                vm.getMatchesLive(id);
            }
        }

        function closeThread() {
            vm.currentThread = null;
            vm.currentThread_Edit = false;
            vm.selectedContent = null;
            vm.selectedContentID = null;
        }
        function openThread(thread, id) {
            // Set the read status on the thread
            // thread.read = true;
            $scope.$safeApply(function () {

                vm.thumbnails_Edit = {};
                vm.editInline = false;
                vm.currentThread_Edit = null;
                vm.currentThread_ref = null;
            });


            if (angular.element(document.getElementById('thread-detail')).length) {
                var elem = angular.element(document.getElementById('thread-detail'));
                elem.scrollTopAnimated(0, 10);
            }
            // pagesShown = 1;
            if (thread) {
                vm.selectedContentID = thread.id;
            }
            else if (id) {
                vm.selectedContentID = id;
            }
            if (vm.selectedContentID != 'new') {
                vm.editInline = false;

                vm.loadingReadPane = true;
                var options = {
                    site: $scope.siteID,
                    section: 'live_stream',
                    id: vm.selectedContentID
                };

                contentService.getByID(options).then(function (response) {
                    $scope.$safeApply(function () {
                        vm.selectedContent = response.result;
                        vm.currentThread = response.result;
                        vm.log = response.log;
                    });

                    for (var i = response.ref.length - 1; i >= 0; i--) {
                        if (response.ref[i].type.substr(0, 4) == 'date') {

                            var value = vm.selectedContent[response.ref[i].titleId];
                            if (value == '0000-00-00 00:00:00') {
                                value = moment().utc().format("YYYY-MM-DD");
                            }

                            var utcDate = moment.utc(value);

                            var siteDate = moment.utc(value).tz(sessionService.site_operative.timezone);

                            vm.selectedContent[response.ref[i].titleId] = {};
                            vm.selectedContent[response.ref[i].titleId]['value'] = value;
                            vm.selectedContent[response.ref[i].titleId]['date'] = new Date(siteDate.format());
                            vm.selectedContent[response.ref[i].titleId]['dateShow'] = siteDate.format(vm.dateTimeFormat);
                            vm.selectedContent[response.ref[i].titleId]['utcShow'] = utcDate.format(vm.dateTimeFormat);
                            vm.selectedContent[response.ref[i].titleId]['utcDate'] = utcDate;
                        }
                        else if (response.ref[i].type == 'sectionmulti') {
                            try {
                                var sectionMultiData = angular.fromJson(vm.selectedContent[response.ref[i].titleId]);
                                if (!angular.isUndefined(sectionMultiData.items)) {
                                    vm.selectedContent[response.ref[i].titleId] = sectionMultiData.items;
                                } else {
                                    vm.selectedContent[response.ref[i].titleId] = [];
                                }
                            } catch (e) {
                                vm.selectedContent[response.ref[i].titleId] = [];
                            }
                        }
                        else if (response.ref[i].type == 'json' && vm.selectedContent[response.ref[i].title]) {
                            vm.selectedContent[response.ref[i].title] = JSON.parse(vm.selectedContent[response.ref[i].title])
                        }
                    }
                    vm.selectedContent_ref = response.ref;
                    vm.selectedContent_ref_tabs = _.filter(response.ref, function (x) {
                        return x.category == 'tab'
                    });
                    vm.selectedContent_ref_tabs = _.map(vm.selectedContent_ref_tabs, function (x) {
                        x.raw_settings = JSON.parse(x.raw_settings);
                        return x;
                    })
                    fetchTabsData(vm.selectedContent_ref_tabs);
                    vm.selectedContent_refgrouped = _.groupBy(response.ref, function (m) {
                        return m.preview_position;
                    });
                    vm.loadingReadPane = false;
                })
                    .then(function () {
                        contentService.getTags(options).then(function (response) {
                            if (!angular.equals(vm.tags, response.tags)) {
                                vm.tags = angular.copy(response.tags);
                                sessionService.site_operative.tags = vm.tags;
                            }
                        });
                    });
            }
        }


        function fetchTabsData(tabs) {
            for (var i = 0; i < tabs.length; i++) {
                const tab = tabs[i];
                var options = {
                    siteID: $scope.siteID,
                    per_page: 99999,
                    section: tab.raw_settings.fromSection
                };
                contentService.get(options).then(function (res) {
                    vm['tab_' + tab.raw_settings.fromSection + '_data'] = res.result.data;
                    vm['tab_' + tab.raw_settings.fromSection + '_ref'] = res.ref;
                })
                if (tab.raw_settings.fromSectionGroup) {
                    var options = {
                        siteID: $scope.siteID,
                        per_page: 99999,
                        section: tab.raw_settings.fromSectionGroup
                    };
                    contentService.get(options).then(function (res) {
                        vm['tab_' + tab.raw_settings.fromSectionGroup + '_data'] = res.result.data;
                        vm['tab_' + tab.raw_settings.fromSectionGroup + '_ref'] = res.ref;
                    })
                }
            }
        }

        function loadMatchRequest(id) {
            var options = {
                site: $scope.siteID,
                section: 'matches',
                id: id
            }
            $scope.isLoadingReadPane = true;
            contentService.getByID(options).then(function (res) {
                $scope.isLoadingReadPane = false;
                //                if(!vm.seeUpdate) {
                // Initial load of currentMatch
                vm.currentMatch = transformMatchCenter.DTOtoMatch(res.result);
                if (vm.currentMatch.date != null) {
                    vm.updateDatePicker();
                }
                //           }
                vm.thumbnails_Edit = {};
                if (vm.mediaZones) {
                    angular.forEach(vm.mediaZones, function (mz) {
                        if (angular.isUndefined(vm.thumbnails_Edit[mz.id_zone])) {
                            vm.thumbnails_Edit[mz.id_zone] = [];
                        }
                    });
                    angular.forEach(vm.currentMatch.Thumbnail, function (thumb) {
                        if (thumb.id_zone > 0) {
                            vm.thumbnails_Edit[thumb.id_zone].push(thumb);
                        }
                    });
                }
                if (vm.seeUpdate) {
                    for (var i = 0; i < vm.currentMatch.teams_data.length; i++) {
                        for (var im = 0; im < $rootScope.teamsMatch1.length; im++) {
                            if ($rootScope.teamsMatch1[im].id == vm.currentMatch.teams_data[i].id_teams) {
                                vm.currentMatch.teams_data[i].media = $rootScope.teamsMatch1[im].media;
                                vm.currentMatch.teams_data[i].team_name = $rootScope.teamsMatch1[im].name;
                            }
                        }
                        if (vm.currentMatch.teams_data[i].skipper) {
                            for (var ip = 0; ip < vm.currentMatch.teams_data[i].skipper.length; ip++) {
                                for (var im = 0; im < vm.peopleMatch.length; im++) {
                                    if (vm.peopleMatch[im].id_people == vm.currentMatch.teams_data[i].skipper[ip].id_people) {
                                        vm.currentMatch.teams_data[i].skipper[ip].media = vm.peopleMatch[im].media;
                                        vm.currentMatch.teams_data[i].skipper[ip].name = vm.peopleMatch[im].name;
                                        vm.currentMatch.teams_data[i].skipper[ip].nickname = vm.peopleMatch[im].nickname;
                                    }
                                }
                            }
                            if (vm.currentMatch.teams_data[i].onboard) {
                                for (var ip = 0; ip < vm.currentMatch.teams_data[i].onboard.length; ip++) {
                                    for (var im = 0; im < vm.peopleMatch.length; im++) {
                                        if (vm.peopleMatch[im].id_people == vm.currentMatch.teams_data[i].onboard[ip].id_people) {
                                            vm.currentMatch.teams_data[i].onboard[ip].media = vm.peopleMatch[im].media;
                                            vm.currentMatch.teams_data[i].onboard[ip].name = vm.peopleMatch[im].name;
                                            vm.currentMatch.teams_data[i].onboard[ip].nickname = vm.peopleMatch[im].nickname;
                                        }
                                    }
                                }
                            }
                            if (vm.currentMatch.teams_data[i].onshore) {
                                for (var ip = 0; ip < vm.currentMatch.teams_data[i].onshore.length; ip++) {
                                    for (var im = 0; im < vm.peopleMatch.length; im++) {
                                        if (vm.peopleMatch[im].id_people == vm.currentMatch.teams_data[i].onshore[ip].id_people) {
                                            vm.currentMatch.teams_data[i].onshore[ip].media = vm.peopleMatch[im].media;
                                            vm.currentMatch.teams_data[i].onshore[ip].name = vm.peopleMatch[im].name;
                                            vm.currentMatch.teams_data[i].onshore[ip].nickname = vm.peopleMatch[im].nickname;
                                        }
                                    }
                                }
                            }
                            if (vm.currentMatch.teams_data[i].technical_staff) {
                                for (var ip = 0; ip < vm.currentMatch.teams_data[i].technical_staff.length; ip++) {
                                    for (var im = 0; im < vm.peopleMatch.length; im++) {
                                        if (vm.peopleMatch[im].id_people == vm.currentMatch.teams_data[i].technical_staff[ip].id_people) {
                                            vm.currentMatch.teams_data[i].technical_staff[ip].media = vm.peopleMatch[im].media;
                                            vm.currentMatch.teams_data[i].technical_staff[ip].name = vm.peopleMatch[im].name;
                                            vm.currentMatch.teams_data[i].technical_staff[ip].nickname = vm.peopleMatch[im].nickname;
                                        }
                                    }
                                }
                            }
                            if (vm.currentMatch.teams_data[i].headlines) {
                                for (var ip = 0; ip < vm.currentMatch.teams_data[i].headlines.length; ip++) {
                                    for (var im = 0; im < vm.peopleMatch.length; im++) {
                                        if (vm.peopleMatch[im].id_people == vm.currentMatch.teams_data[i].headlines[ip].id_people) {
                                            vm.currentMatch.teams_data[i].headlines[ip].media = vm.peopleMatch[im].media;
                                            vm.currentMatch.teams_data[i].headlines[ip].name = vm.peopleMatch[im].name;
                                            vm.currentMatch.teams_data[i].headlines[ip].nickname = vm.peopleMatch[im].nickname;
                                        }
                                    }
                                }
                            }
                            if (vm.currentMatch.teams_data[i].alternates) {
                                for (var ip = 0; ip < vm.currentMatch.teams_data[i].alternates.length; ip++) {
                                    for (var im = 0; im < vm.peopleMatch.length; im++) {
                                        if (vm.peopleMatch[im].id_people == vm.currentMatch.teams_data[i].alternates[ip].id_people) {
                                            vm.currentMatch.teams_data[i].alternates[ip].media = vm.peopleMatch[im].media;
                                            vm.currentMatch.teams_data[i].alternates[ip].name = vm.peopleMatch[im].name;
                                            vm.currentMatch.teams_data[i].alternates[ip].nickname = vm.peopleMatch[im].nickname;
                                        }
                                    }
                                }
                            }
                            if (vm.currentMatch.teams_data[i].coaches) {
                                for (var ip = 0; ip < vm.currentMatch.teams_data[i].coaches.length; ip++) {
                                    for (var im = 0; im < vm.peopleMatch.length; im++) {
                                        if (vm.peopleMatch[im].id_people == vm.currentMatch.teams_data[i].coaches[ip].id_people) {
                                            vm.currentMatch.teams_data[i].coaches[ip].media = vm.peopleMatch[im].media;
                                            vm.currentMatch.teams_data[i].coaches[ip].name = vm.peopleMatch[im].name;
                                            vm.currentMatch.teams_data[i].coaches[ip].nickname = vm.peopleMatch[im].nickname;
                                        }
                                    }
                                }
                            }
                      }
                    }
                    vm.saveMatch(true);
                }
            });
        }

        function loadMatchRequestUpdate(id) {
            var options = {
                site: $scope.siteID,
                section: 'matches',
                id: id
            }
            //            $scope.isLoadingReadPane = true;
            contentService.getByID(options).then(function (res) {
                //                $scope.isLoadingReadPane = false;
                vm.currentMatch = res.result;
                /*               if (vm.currentMatch.date != null) {
                                   vm.updateDatePicker();
                               }
                               vm.thumbnails_Edit = {};
                               if (vm.mediaZones) {
                                   angular.forEach(vm.mediaZones, function (mz) {
                                       if (angular.isUndefined(vm.thumbnails_Edit[mz.id_zone])) {
                                           vm.thumbnails_Edit[mz.id_zone] = [];
                                       }
                                   });
                                   angular.forEach(vm.currentMatch.Thumbnail, function (thumb) {
                                       if (thumb.id_zone > 0) {
                                           vm.thumbnails_Edit[thumb.id_zone].push(thumb);
                                       }
                                   });
                               } */
            });
        }

        function mediaDialog(ev, mediazone, item) {
            $mdDialog.show({
                controller: 'MediaDialogController',
                controllerAs: 'vm',
                locals: {
                    autoUpload: '',
                    currentThread: item,
                    section: 'matches',
                    mediazone: mediazone,
                    isTiny: false,
                    maxAttach: undefined,
                    showViews: {
                        1: true,
                        2: true,
                        3: true,
                        4: true,
                        5: true,
                        upload: true,
                        import: true
                    }
                },
                templateUrl: 'app/main/dialogs/media/media-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            }).then(function (item) {
                vm.currentMatch = item;
                vm.thumbnails_Edit = {};
                if (vm.mediaZones) {
                    angular.forEach(vm.mediaZones, function (mz) {
                        if (angular.isUndefined(vm.thumbnails_Edit[mz.id_zone])) {
                            vm.thumbnails_Edit[mz.id_zone] = [];
                        }
                    });
                    angular.forEach(vm.currentMatch.Thumbnail, function (thumb) {

                        if (angular.isUndefined(vm.thumbnails_Edit[thumb.id_zone])) {
                            vm.thumbnails_Edit[thumb.id_zone] = [];
                        }
                        vm.thumbnails_Edit[thumb.id_zone].push(thumb);
                    })
                }
            });
        }

        function joinClipsWindow(ev, item) {
            $mdDialog.show({
                controller: 'JoinClipsDialogController',
                controllerAs: 'vm',
                locals: {
                    selectedClips: [item]
                },
                templateUrl: 'app/main/dialogs/join/join-clip-dialog.controller.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            }).then(function (item) {

            });
        }

        function deleteAttachment(attachment) {

            if (attachment.id_zone) {
                for (var i = 0; i < vm.currentMatch.Thumbnail.length; i++) {
                    if (vm.currentMatch.Thumbnail[i].id_zone === attachment.id_zone) {

                        if (angular.isDefined(attachment.id_media) &&
                            vm.currentMatch.Thumbnail[i].id_media === attachment.id_media) {
                        }
                        else if (attachment.id_gallery > 0 &&
                            vm.currentMatch.Thumbnail[i].id_gallery === attachment.id_gallery) {
                        }
                        else {
                            continue;
                        }
                        vm.currentMatch.Thumbnail.splice(i, 1);
                    }
                }

                for (var i = 0; i < vm.thumbnails_Edit[attachment.id_zone].length; i++) {
                    if (angular.isDefined(attachment.id_media) &&
                        vm.thumbnails_Edit[attachment.id_zone][i].id_media === attachment.id_media) {
                        vm.thumbnails_Edit[attachment.id_zone].splice(i, 1);
                    }
                    else if (attachment.id_gallery > 0 &&
                        vm.thumbnails_Edit[attachment.id_zone][i].id_gallery === attachment.id_gallery) {
                        vm.thumbnails_Edit[attachment.id_zone].splice(i, 1);
                    }
                }

            }
            else {
                for (var i = 0; i < vm.currentMatch.Thumbnail.length; i++) {
                    if (angular.isDefined(attachment.id_media) &&
                        vm.currentMatch.Thumbnail[i].id_media === attachment.id_media) {

                    } else if (attachment.id_gallery > 0 &&
                        vm.currentMatch.Thumbnail[i].id_gallery === attachment.id_gallery) {

                    } else {
                        continue;
                    }
                    vm.currentMatch.Thumbnail.splice(i, 1);
                }
            }

        }

        function downloadMediaOriginal(media) {
            switch (media.media_type) {
                case 1:
                    var url = media.container.view_url + 'original/m' + media.id_media + '_' + media.filename;

                    break;
                case 2:
                    if (media.embed_thumb) {
                        var url = media.embed_thumb;
                    }
                    else if (!media.embed && !media.embed_code && !media.embed_thumb && !media.embed_url) {
                        var url = media.container.view_url + 'videos/m' + media.id_media + '_' + media.filename;
                    }
                    break;
                case 4:
                    var url = media.container.view_url + 'files/m' + media.id_media + '_' + media.filename;

                    // vm.image.imageUrl = cropstatus.container.view_url + cropstatus.fileName;
                    break;
            }
            if (url) {
                msUtils.openUrl(url)
            }
        }

        function MediaItemRecrop(image) {

            var messageConfirm = $translate.instant('CONTENT.MEDIA_ITEM_SURE_RECROP');

            var confirm = $mdDialog.confirm().title(messageConfirm).htmlContent('')
                .ariaLabel('Delete item').ok('OK').cancel('CANCEL');
            var message = $translate.instant('CONTENT.MEDIA_ITEM_FINISH_RECROP');

            var tags = [];
            angular.forEach(image.tags, function (tag) {
                tags.push(tag.id_tag);
            });
            var galleries = [];
            angular.forEach(image.galleries, function (gallery) {
                galleries.push(gallery.id_gallery);
            });


            $mdDialog.show(confirm).then(function () {

                var imageToSave = {
                    'forceRecrop': true,
                    'tags': tags,
                    'galleries': galleries
                };

                var options = {
                    site: $scope.siteID,
                    id: image.id_media,
                    item: imageToSave
                };

                mediaService.saveMedia(options).then(function (response) {
                    $mdToast.show({
                        template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                        hideDelay: 5000,
                        position: 'top',
                        parent: '#content-container'
                    });
                });
            });

        }
        function openMediaItemMetadata(ev, ImageSelected) {
            $mdDialog.show({
                controller: 'MediaItemMetadataDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/dialogs/media-item-metadata/media-item-metadata-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    ImageSelected: ImageSelected,
                }
            }).then(function (item) {

                if (item) {
                    angular.forEach(vm.currentMatch.Thumbnail, function (media) {
                        if (item.id_media === media.id_media) {
                            angular.forEach(media, function (value, key) {
                                if (item[key]) {
                                    media[key] = item[key];
                                }
                            })
                        }
                    })
                }
            });
        }
        function openFocalPoint(ev, ImageSelected) {
            $mdDialog.show({
                controller: 'MediaFocalPointDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/dialogs/media-focal-point/media-focal-point-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    ImageSelected: ImageSelected,
                }
            }).then(function (item) {
                ImageSelected.imageCenterRatioX = item.imageCenterRatioX;
                ImageSelected.imageCenterRatioY = item.imageCenterRatioY;
                angular.forEach(vm.mediaZones, function (mediazone) {
                    angular.forEach(vm.thumbnails_Edit[mediazone.id_zone], function (attachment) {
                        if (item.id_media === attachment.id_media) {
                            attachment.imageCenterRatioX = item.imageCenterRatioX;
                            attachment.imageCenterRatioY = item.imageCenterRatioY;
                        }
                    })
                })
            });
        }
        function openImageDialog(ev, images, ImageSelected) {
            var images = angular.copy(images);

            // preview only images and video
            for (var i = images.length - 1; i >= 0; i--) {
                if (angular.isUndefined(images[i].media_type) ||
                    [1, 2].indexOf(parseInt(images[i].media_type)) < 0) {
                    images.splice(i, 1);
                }
            }

            $mdDialog.show({
                controller: 'MediaShowDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/dialogs/media-show/media-show-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Images: images,
                    ImageSelected: ImageSelected,
                    cropFormats: false,
                    MediaFull: false,
                    Tags: false,
                    // Tasks: vm.tasks,
                    // event: ev
                }
            });
        }
        function getSportFiles(id_subsec) {
            if (vm.sport) {
                utilMatchCenterService.getFile({ sport: vm.sport, file: 'categories-time.json' }).then(function (res) {
                    vm.categoriesTime = res;
                })
                utilMatchCenterService.getFile({ sport: vm.sport, file: 'tabs-team.json' }, true).then(function (res) {
                    vm.tabsTeams = res;
                })
                utilMatchCenterService.getFile({ sport: vm.sport, file: 'types-clasification.json' }, true).then(function (res) {
                    vm.typesClasification = res;
                })
                utilMatchCenterService.getFile({ sport: vm.sport, file: 'types-match.json' }, true).then(function (res) {
                    vm.typesMatch = res;
                })
                utilMatchCenterService.getFile({ sport: vm.sport, file: 'match-statuses.json' }, true).then(function (res) {
                    vm.match_statuses = res;
                })
                utilMatchCenterService.getFile({ sport: vm.sport, file: 'final-types.json' }, true).then(function (res) {
                    vm.final_types = res;
                })
                utilMatchCenterService.getFile({ sport: vm.sport, file: 'results-types.json' }, true).then(function (res) {
                    vm.result_types = res;
                })
            }
        }
        function deleteMatch(event, index) {

            var messageTitle = $translate.instant('MATCH_CENTER.SURE_DELETED_SINGULAR');
            var messageBody = $translate.instant('MATCH_CENTER.ITEM_WILL_DELETE');
            var messageOk = $translate.instant('MATCH_CENTER.DELETED_SINGULAR');

            var confirm = $mdDialog.confirm()
                        .title(messageTitle)
                        .ariaLabel(messageTitle)
                        .htmlContent(messageBody)
                        .targetEvent(event)
                        .ok($translate.instant('MATCH_CENTER.ACCEPT'))
                        .cancel($translate.instant('MATCH_CENTER.CANCEL'));
            $mdDialog.show(confirm).then(function () {            
                var options = {
                    site: $scope.siteID,
                    section: 'matches',
                    type: 'delete',
                    item: [vm.matches[index].id]
                };
                contentService.massActions(options).then(function (response) {
                    $timeout(() => {
                        vm.openCompetitionSeason(vm.currentCompetitionSeason);
                        $mdToast.show({
                            template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + messageOk + '</span></div></md-toast>',
                            hideDelay: 5000,
                            position: 'top',
                            parent: '#content-container'
                        });
                    }, 100);
                });
            });
        }

        function saveNotOpenMatch(match){
            return contentService.saveItem({ // <-- return
                site: $scope.siteID,
                section: 'matches',
                id: match.id, // no cambiamos esto
                item: transformMatchCenter.MatchToDTO(angular.copy(match), vm.currentCompetitionSeason, vm.final_types, vm.teamsRef, vm.teamsReferenceSections)
            }).then(resp => {
                $log.info(`Saved match: ${resp.item.id_matches}`);
            }).catch(err => {
                $log.error('[saveNotOpenMatch] Error:', err);
            });
        }

        function saveMatch(close, createAction, event, push) {
            if(vm.currentMatch.teams_data && vm.currentMatch.teams_data.length > 0){
                const teamsId = vm.currentMatch.teams_data.map(t => t.id_teams);
                $scope.isLoadingReadPane = true;
                contentService.get(
                    {
                        siteID: $scope.siteID,
                        section: 'teams',
                        filters: {
                            teams: {
                                field: 'id_teams',
                                name: 'teams',
                                selected: teamsId
                            }
                        }
                    }
                ).then(res => {
                    if(res && res.result && res.result.data && res.result.data.length > 0){
                        res.result.data.forEach(teamData => {
                            var team = vm.currentMatch.teams_data.find(x => x.id_teams == teamData.id_teams);
                            if (team) {
                                team.Thumbnail = teamData.Thumbnail;
                            }
                        });
                    }
                    saveMatchItem(close, createAction, event, push);
                });
            }else{
                saveMatchItem(close, createAction, event, push);
            }
        }

        function saveMatchItem(close, createAction, event, push) {
            var options = {
                site: $scope.siteID,
                section: 'matches',
                id: vm.currentMatch.id ? vm.currentMatch.id : 'new',
                item: transformMatchCenter.MatchToDTO(angular.copy(vm.currentMatch), vm.currentCompetitionSeason, vm.final_types, vm.teamsRef, vm.teamsReferenceSections)
            };
            contentService.saveItem(options).then(function (response) {
                $scope.isLoadingReadPane = false;
                var message = $translate.instant('CONTENT.SAVED');
                if (!vm.seeUpdate) {
                    $mdToast.show({
                        template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                        hideDelay: 5000,
                        position: 'top',
                        parent: '#content-container'
                    });
                }
                if (options.id == 'new') {
                    vm.currentMatch.id = response.id;
                }
                if (close) {
                    vm.closeMatch();
                }
                if (createAction) {
                    createEvent(event, push);
                }
                vm.getMatches(true);
                return true;
            });
        }

        function getTeamsPeople(selectedTeam) {
            var result = [];
            vm.currentMatch.teams_data.forEach(team => {
                if (!selectedTeam || selectedTeam.id_teams == team.id_teams) {
                    vm.tabsTeams.forEach(tab => {
                        if (team[tab.section]) {
                            team[tab.section].forEach(element => {
                                result.push(element);
                            });
                        }
                    });
                }
            });
            return result;
        }
        function closeMatch() {
            vm.matchLive = null;
            vm.matchLivesUrl = null;
            vm.currentMatch = null;
            clearInterval(vm.interval);
            if (vm.copySidenavState) {
                $mdSidenav('tree-sidenav').open();
            } else {
                $mdSidenav('tree-sidenav').close();
            }
            if (vm.seeUpdate) {
                $mdSidenav('tree-sidenav').open();
            }
        }
        function openVenuesDialog(ev) {
            if (!vm.currentCompetitionSeason.venues) {
                vm.currentCompetitionSeason.venues = [];
            }
            $mdDialog.show({
                controller: 'VenuesDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/match-center/dialogs/venues/venues-dialog.controller.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                locals: {
                    data: vm.currentCompetitionSeason,
                    settings: vm.currentSettings,
                    siteID: $scope.siteID,
                    event: ev
                }
            }).then(function (res) {
                if (res) {
                    vm.saveCompetitionSeason(vm.currentCompetitionSeason);
                }
            });
        }

        function deleteTeamMatch(index) {
            var messageConfirm = msUtils.translate('GLOBAL.ARE_YOU_SURE');

            var confirm = $mdDialog.confirm()
                .title(messageConfirm)
                .ok(msUtils.translate('GLOBAL.OK'))
                .cancel(msUtils.translate('GLOBAL.CANCEL'))
                .multiple(true)
                ;
            $mdDialog.show(confirm).then(function () {
                vm.currentMatch.teams_data.splice(index, 1)
            });
        }

        function openTeamEditDialog(ev, index) {
            $mdDialog.show({
                controller: 'TeamEditController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/match-center/dialogs/team-edit/team-edit.html',
                autoWrap: false,
                bindToController: true,
                targetEvent: ev,
                locals: {
                    siteId: $scope.siteID,
                    data: vm.currentMatch.teams_data[index],
                    id_subsec: vm.currentCompetitionSeason.competition.id_subsec,
                    event: ev
                }
            }).then(function (response) {
                if (response) {
                    vm.currentMatch.teams_data[index] = response;
                }
            });
        }
        function openTeamEditStatusDialog(ev, index) {
            $mdDialog.show({
                controller: 'TeamStatusDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/match-center/dialogs/team-status/team-status.html',
                autoWrap: false,
                bindToController: true,
                targetEvent: ev,
                locals: {
                    team: vm.currentMatch.teams_data[index],
                    event: ev
                }
            }).then(function (response) {
                if (response) {
                    vm.currentMatch.teams_data[index] = response;
                }
            });
        }
        function openTeamMatchDialog(ev, index) {
            if (!vm.currentMatch.teams_data) {
                vm.currentMatch.teams_data = [];
            }
            let maxteams;
            switch (vm.sport) {
                case 'football':
                    maxteams = vm.currentCompetitionSeason.match_type == "1" ? 2 : null;
                    break;
                case 'sailing':
                    maxteams = null;
                    break;
                case 'cars':
                    maxteams = null;
                    break;
                case 'tennis':
                    maxteams = 2;
                    break;
                case 'paddle':
                    maxteams = 2;
                    break;
                default:
                    break;
            }
            $mdDialog.show({
                controller: 'TeamsDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/match-center/dialogs/teams/teams-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                locals: {
                    data: vm.currentMatch,
                    sport: vm.sport,
                    currentCompetitionSeason: vm.currentCompetitionSeason,
                    typesMatch: vm.typesMatch,
                    key: 'teams_data',
                    maxteams: maxteams,
                    sectionTeams: vm.currentCompetitionSeason.teams_section_data.sectionTeams,
                    sectionTeamsId: vm.currentCompetitionSeason.teams_section_data.sectionTeamsId,
                    sectionTeamsName: vm.currentCompetitionSeason.teams_section_data.sectionTeamsName,
                    teams: vm.currentCompetitionSeason.teams,
                    ref: vm.teamsRef,
                    skipLoad: true,
                    siteID: $scope.siteID,
                    referenceSections: vm.teamsReferenceSections,
                    event: ev,
                    seasons: vm.seasons,
                    seeUpdate: vm.seeUpdate,
                    teamsMatch: vm.teamsMatch
                }
            }).then(function (res) {
                // if (res) {
                //     vm.saveMatch(vm.currentMatch);
                // }
            });
        }

        function getMaxTeams() {
            return vm.currentCompetitionSeason.match_type == "1" ? 2 : null;
        }


        function getActionClass(id_action) {
            const action = _.find(vm.matches_events_actions, function (action) {
                return action.id == id_action;
            })
            return action ? action.classname : '';
        }

        function getArrayOfSets() {
            const matchType = vm.typesMatch.find(x => x.id === vm.currentCompetitionSeason.match_type);
            return [...Array(matchType.num_sets).keys()];
        }

        function openCompetitionSeason(competitionSeason) {
            selectTreeNode(competitionSeason);
            delete vm.matches;
            var options = {
                site: $scope.siteID,
                id: competitionSeason.id_competition_season
            }
            $scope.isLoadingReadPane = true;
            $scope.$apply();
            matchCenterService.getCompetitionSeasonById(options).then(function (response) {
                vm.sport = utilMatchCenterService.getSport(response.competition.id_subsec);
                vm.currentCompetitionSeason = prepararSanciones(transformMatchCenter.DTOtoCompetitionSeason(response, vm.sport));
                $scope.isLoadingReadPane = false;
                vm.getMatches();
                vm.getSportFiles(vm.currentCompetitionSeason.competition.id_subsec);
            })

        }

        function getMatches(reloadResults) {
            var options = {
                siteID: $scope.siteID,
                resultsPerPage: 99999,
                section: 'matches',
                filters: [
                    {
                        field: 'id_competition_season',
                        name: 'id_competition_season',
                        selected: [vm.currentCompetitionSeason.id_competition_season]
                    }
                ]
            }
            contentService.get(options).then(function (res) {
                vm.matches = transformMatchCenter.DTOstoMatches(res.result.data);
                if (reloadResults) {
                    vm.saveCompetitionSeason(vm.currentCompetitionSeason);
                }
            })
        }

        function getMatchesStatus(match) {
            var filt = $filter('filter')(vm.match_statuses, { id: match.status.toString() }, true);
            if (filt.length == 0) {
                return 'MATCH_CENTER.STATUS_NOT_DEFINED';
            }
            return $translate.instant(filt[0].name);
        }

        function getMatchClass(match) {
            var filt = $filter('filter')(vm.match_statuses, { id: match.status.toString() }, true);
            
            if (filt.length == 0) {
                return 'STATUS_NOT_DEFINED';
            }
        
            var className = filt[0].name.split('.')[1];
            return className ? className.toLowerCase() : 'status-not-defined';
        }

        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        function getTranslateBySport(tag) {
            if (vm.sport) {
                return vm.sport.toUpperCase() + '.' + tag;
            }
            return '';
        }

        function downloadClip(url) {
            $window.open(url, '_blank');
        }

        function openPreview(ev, clip) {
            var clipurl = clip.embed.split('|')[1]
            $rootScope.$broadcast('EDIT_CLIP_WINDOW', { volume: 0 });
            $mdDialog.show({
                controller: 'PreviewClipDialogController',
                controllerAs: 'vm',
                locals: {
                    sharing: true,
                    clipUrl: clipurl,
                    idLiveStream: vm.idLiveStream,
                    siteID: $scope.siteID,
                    id_media: clip.id_media,
                    extra: null
                },
                templateUrl: 'app/main/apps/match-center/dialogs/previewclip/previewclip-dialog.html',
                targetEvent: ev,
                multiple: true,
                clickOutsideToClose: false
            }).then(function (response) {
                if (response) {
                    $mdDialog.hide()
                    $rootScope.$broadcast('EDIT_CLIP_WINDOW', { volume: 1 });
                }
            });
        }

        function createMark(start, end, title, edit, ev, extra) {
            if (!vm.clipsData) {
                vm.clipsData = [];
            }
            vm.clipsData.push({
                title: title,
                extra: extra,
                start: start,
                end: end
            })
            vm.matchLive.clips_data = vm.clipsData;
            var copy = angular.copy(vm.matchLive);
            var options = {
                site: $scope.siteID,
                id: vm.matchLive.id,
                item: copy
            }
            vm.clipsData = angular.copy(vm.clipsData);
            matchCenterService.updateLive(options).then(function (response) {
            });
        }

        function createClipApi(start, end, title, edit, ev) {
            var options = {
                siteID: $scope.siteID,
                item: {
                    "name": vm.matchLive.name,
                    "start_time": start,
                    "id_live_stream": vm.matchLive.id_live_stream,
                    "title": title,
                    "end_time": end,
                    "id_zone": 1,
                    "watermarks": []
                }
            }

            matchCenterService.createClip(options).then(function (response) {
                if (edit) {
                    $rootScope.$broadcast('EDIT_CLIP_WINDOW', { volume: 0 });
                } else {
                    var message = $translate.instant('MATCH_CENTER.CREATING_CLIP_FEEDBACK');
                    $mdToast.show({
                        template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                        hideDelay: 5000,
                        position: 'top',
                        parent: '#content-container'
                    });
                }
                if (edit) {
                    $mdDialog.show({
                        controller: 'EditClipDialogController',
                        idLiveStream: vm.matchLive.id_live_stream,
                        title: title,
                        controllerAs: 'vm',
                        locals: {
                            clip: null,
                            clipUrl: response.clipUrl, // "http://mirror.cessen.com/blender.org/peach/trailer/trailer_iphone.m4v"
                            extra: response.extra, // "http://mirror.cessen.com/blender.org/peach/trailer/trailer_iphone.m4v"
                            siteID: $scope.siteID,
                            startPoint: start,
                            name: vm.matchLive.name,
                            endPoint: end
                        },
                        templateUrl: 'app/main/apps/match-center/dialogs/editclip/editclip-dialog.html',
                        targetEvent: ev,
                        multiple: true,
                        clickOutsideToClose: false
                    }).then(function (response) {
                        if (response) {
                        }
                    });
                }
                createMark(start, end, title, edit, ev, response.extra)
            })
        }
        function editClipApi(ev, clip, extra) {
            $rootScope.$broadcast('EDIT_CLIP_WINDOW', { volume: 0 });
            $mdDialog.show({
                controller: 'EditClipDialogController',
                controllerAs: 'vm',
                locals: {
                    clip: clip,
                    idLiveStream: vm.matchLive.id_live_stream,
                    title: clip.title,
                    extra: clip.extra,
                    clipUrl: null,
                    startPoint: null,
                    siteID: $scope.siteID,
                    name: null,
                    endPoint: null
                },
                templateUrl: 'app/main/apps/match-center/dialogs/editclip/editclip-dialog.html',
                targetEvent: ev,
                multiple: true,
                clickOutsideToClose: false
            }).then(function (response) {
                if (response) {
                }
            });
        }

        function openCreateDialog(ev) {
            $mdDialog.show({
                controller: 'CreateMatchCenterDialogController',
                controllerAs: 'vm',
                locals: {
                    siteID: $scope.siteID
                },
                templateUrl: 'app/main/apps/match-center/dialogs/forms-creation/match-center-dialog.controller.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
            }).then(function (res) {
                if (res) {
                    $rootScope.pagination_resetquery();
                }
            });
        }

        function getContentSection(section) {
            var options = {
                site: $scope.siteID
            };
            matchCenterService.getContentSection(options, section).then(function (response) {
                vm[section] = angular.copy(response.result.data);
                vm[section + 'ReferenceSections'] = response.reference_sections;
                vm[section + 'Ref'] = angular.copy(response.ref);
            });
        }

        $scope.$on('$destroy', function () {
            clearInterval(vm.interval);
        });

    }
    function OpenEditDialog(matchCenterService) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                $(element).on('click', function (e) {
                    var groupNode = scope.node;
                    if (groupNode.type == 'competition_season') {
                        // The highlight is set by the controller, on the node itself, so
                        // that it survives the tree being reloaded after a save.
                        matchCenterService.triggerEditDialog(groupNode);
                    }
                });
            }
        };
    }


})();

(function () {
    'use strict';

    angular
        .module('app.match-center')
        .service('matchCenterService', MatchCenterService);

    /** @ngInject */
    // I provide access to the session store.
    function MatchCenterService($rootScope, $mdToast, $q, $resource, userService, settingsDomainService, contentService, COMMON, $window) {



        function get(options) {

            var deferred = $q.defer();
            var filters = [];

            _.forEach(options, function (value, key, list) {
                if (_.isObject(list[key])) {
                    _.forEach(list[key], function (filter, keyFilter, listFilter) {
                        if (!_.isEmpty(filter.selected)) {
                            filters.push({
                                field: filter.field,
                                name: filter.name,
                                values: filter.selected
                            });
                        }

                    });

                }
            });

            resourceSeasons.get({
                domain: options.siteID,
                filters: JSON.stringify(filters),
                search: options.searchStringFilter

            },
                function (responseResult) {
                    responseResult = formatSeasons(responseResult);
                    deferred.resolve({ data: responseResult.reverse() });

                },
                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }



        function formatSeasons(data) {
            for (var i = 0; i < data.length; i++) {
                const element = data[i];
                element.label = element.season;
                element.children = formatCompetitionsSeasons(element.competition_seasons);
                element.type = "season";
            }

            return data;
        }

        function formatCompetitionsSeasons(data) {
            for (var i = 0; i < data.length; i++) {
                const element = data[i];
                element.label = element.reference_name;
                element.children = formatCompetitionsSeasons(element.children);
                element.type = "competition_season";
            }

            return data;
        }

        function triggerEditDialog(node) {
            $rootScope.$broadcast('openEditDialog', node);
        }


        function getEvents(options) {
            var deferred = $q.defer();
            resource_matchevent.get({
                domain: options.site,
                filters: JSON.stringify(options.filters),
                resultsPerPage: options.resultsPerPage,
                sortField: options.sortField,
                sortDir: options.sortDir
            },
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    showError(e);
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getClips(options) {
            var deferred = $q.defer();
            resource_matchclips.get({
                domain: options.site,
                id: options.id,
                resultsPerPage: options.resultsPerPage,
                sortField: options.sortField,
                sortDir: options.sortDir
            },
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    showError(e);
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getComments(options) {
            var deferred = $q.defer();
            resource_matchcomment.get({
                domain: options.site,
                filters: JSON.stringify(options.filters),
            },
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    showError(e);
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function getLives(options) {
            var deferred = $q.defer();
            resource_matchlives.get({
                domain: options.site,
                filters: JSON.stringify(options.filters),
            },
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    showError(e);
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function updateLive(options) {
            var deferred = $q.defer();
            options.item = angular.copy(options.item);
            options.item.clips_data = JSON.stringify(options.item.clips_data);
            resource_matchlives_update.update({
                domain: options.site,
                id: options.id,
                item: options.item
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    showError(e);
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function updateSortEvents(options) {
            var deferred = $q.defer();
            resource_update_sort_event.update({
                domain: options.site
            }, options.data,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    showError(e);
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }


        function getFilters(options) {
            var deferred = $q.defer();

            // Return the promise.
            return (deferred.promise);
        }

        function getContentSection(options, section) {
            var deferred = $q.defer();

            var filters = [];

            _.forEach(options, function (value, key, list) {
                if (_.isObject(list[key])) {
                    _.forEach(list[key], function (filter, keyFilter, listFilter) {
                        if (!_.isEmpty(filter.selected)) {
                            filters.push({
                                field: filter.field,
                                name: filter.name,
                                values: filter.selected
                            });
                        }

                    });

                }
            });
            var resourceSelected = $resource(
                COMMON.BASE_API + "/domain/:domain/content/:section", {
                domain: '@domain',
                section: '@section',
            }, {
                get: {
                    method: "GET",
                }
            }
            );

            resourceSelected.get({
                domain: options.site,
                search: options.search,
                resultsPerPage: 500,
                filters: JSON.stringify(filters),
                section: section
            },
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e);
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getCompetitionSeasonById(options) {
            var deferred = $q.defer();

            resourceCompetitionSeasonsGetById.get({
                domain: options.site,
                id: options.id
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    showError(e);
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function shareSocial(options) {
            var deferred = $q.defer();
            resourceShareSocial.post({
                domain: options.siteID,
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    showError(e);
                    deferred.reject();
                }
            );
            // Return the promise.
            return (deferred.promise);
        }
        function finishSocial(options) {
            var deferred = $q.defer();
            resourceFinishSocial.post({
                domain: options.siteID,
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    showError(e);
                    deferred.reject();
                }
            );
            // Return the promise.
            return (deferred.promise);
        }
        function connectFacebookBusiness(options) {
            var deferred = $q.defer();
            resourceConnectFacebookBusiness.post({
                domain: options.siteID,
            }, options.item || {},
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    showError(e);
                    deferred.reject(e);
                }
            );
            // Return the promise.
            return (deferred.promise);
        }
        // Approach A: create a read-only X account from a public @handle (no OAuth).
        function connectX(options) {
            var deferred = $q.defer();
            resourceConnectX.post({
                domain: options.siteID
            }, options.item || {},
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    deferred.reject(e);
                }
            );
            return (deferred.promise);
        }

        // Follow a public YouTube channel (no OAuth): the API resolves the @handle or
        // channel URL and creates the read-only stream account.
        function connectYoutube(options) {
            var deferred = $q.defer();
            resourceConnectYoutube.post({
                domain: options.siteID
            }, options.item || {},
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    deferred.reject(e);
                }
            );
            return (deferred.promise);
        }

        function getTokensSocialPages(options) {
            var deferred = $q.defer();
            resourceGetTokensPages.get({
                id_account: options.id_account,
                domain: options.siteID,
            }, function (response) {
                deferred.resolve(response);
            },
                function (e) {
                    showError(e);
                    deferred.reject();
                }
            );
            // Return the promise.
            return (deferred.promise);
        }
        function finishPage(options) {
            var deferred = $q.defer();
            resourceGetTokens.post({
                domain: options.siteID,
            }, options.item, function (response) {
                deferred.resolve(response);
            },
                function (e) {
                    showError(e);
                    deferred.reject();
                }
            );
            // Return the promise.
            return (deferred.promise);
        }
        function getTokensSocial(options) {
            var deferred = $q.defer();
            resourceGetTokens.get({
                domain: options.siteID,
            }, function (response) {
                deferred.resolve(response);
            },
                function (e) {
                    showError(e);
                    deferred.reject();
                }
            );
            // Return the promise.
            return (deferred.promise);
        }
        function loadPostsSocial(options) {
            var deferred = $q.defer();
            var media = options.id;
            var related = JSON.stringify({ 'service': options.service, 'section': options.section });
            resource_social_post.get({
                domain: options.siteID,
                media: media,
                related: related
            }, function (response) {
                deferred.resolve(response);
            },
                function (e) {
                    showError(e);
                    deferred.reject();
                }
            );
            // Return the promise.
            return (deferred.promise);
        }
        function deletePostsSocial(options) {
            var deferred = $q.defer();
            resource_delete_social_post.delete({
                domain: options.siteID,
                id: options.id
            }, function (response) {
                deferred.resolve(response);
            },
                function (e) {
                    showError(e);
                    deferred.reject();
                }
            );
            // Return the promise.
            return (deferred.promise);
        }

        function createClip(options) {
            var deferred = $q.defer();
            resourceCreateClip.post({
                domain: options.siteID,
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    showError(e);
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function joinClips(options) {
            var deferred = $q.defer();
            resourceJoinClips.post({
                domain: options.siteID,
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    showError(e);
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }


        function saveItem(options) {
            var deferred = $q.defer();


            // resourceCompetitionSeasonsUpdateById.update({
            //     domain: options.site,
            //     item: options.item,
            //     id: options.id
            // }, options.item,
            //     function (response) {
            //         deferred.resolve(response);
            //     },
            //     function (e) {
            //         showError(e);
            //         deferred.reject();
            //     }
            // );

            // Return the promise.
            return (deferred.promise);
        }


        function saveMatchEvent(options) {
            var deferred = $q.defer();


            resource_matchevent_byID.update({
                domain: options.site,
                id: options.id,
                item: options.item
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    showError(e);
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function removeEvent(options) {
            var deferred = $q.defer();


            resource_matchevent_delete.update({
                domain: options.site,
                ids: [options.id]
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    showError(e);
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function removeComment(options) {
            var deferred = $q.defer();


            resource_matchcomment_delete.update({
                domain: options.site,
                ids: [options.id]
            },
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function saveMatchComment(options) {
            var deferred = $q.defer();


            resource_matchcomment_byID.update({
                domain: options.site,
                id: options.id,
                item: options.item
            },
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        var resource_social_post = $resource(
            COMMON.BASE_API + "/domain/:domain/social/posts?withAccount=True&withUser=True&withMedia=True&related[]=:related&media[]=:media", {
            domain: '@domain'
        }, {
            update: {
                method: "GET",
            }
        }
        );
        var resource_delete_social_post = $resource(
            COMMON.BASE_API + "/domain/:domain/social/posts/:id", {
            domain: '@domain'
        }, {
            delete: {
                method: "DELETE",
            }
        }
        );
        var resource_matchcomment_delete = $resource(
            COMMON.BASE_API + "/domain/:domain/content/matches_comments/action/delete", {
            domain: '@domain'
        }, {
            update: {
                method: "PUT",
            }
        }
        );

        var resource_matchcomment_byID = $resource(
            COMMON.BASE_API + "/domain/:domain/content/matches_comments/:id", {
            domain: '@domain',
            id: '@id',
        }, {
            get: {
                method: "GET",
            },
            update: {
                method: "PUT",
            }
        }
        );

        var resource_matchevent_delete = $resource(
            COMMON.BASE_API + "/domain/:domain/content/matches_events/action/delete", {
            domain: '@domain'
        }, {
            update: {
                method: "PUT",
            }
        }
        );
        var resource_matchevent_byID = $resource(
            COMMON.BASE_API + "/domain/:domain/content/matches_events/:id", {
            domain: '@domain',
            id: '@id',
        }, {
            get: {
                method: "GET",
            },
            update: {
                method: "PUT",
            }
        }
        );

        var resourceCompetitionSeasonsGetById = $resource(COMMON.BASE_API + "/domain/:domain/fixture/competitionSeason/:id", {
            // No default data
        }, {
            get: {
                method: "GET",
                // isArray: true
            }
        });

        var resourceCompetitionSeasonsUpdateById = $resource(COMMON.BASE_API + "/domain/:domain/content/competition_season/:id", {
            // No default data
        }, {
            update: {
                method: "PUT",
                // isArray: true
            }
        });

        var resource_matchevent = $resource(
            COMMON.BASE_API + "/domain/:domain/content/matches_events?filters=[{'field':'id_match','values':[:id_match]}]", {
            domain: '@domain'
        }, {
            get: {
                method: "GET",
            }
        }
        );
        var resource_matchlives = $resource(
            COMMON.BASE_API + "/domain/:domain/content/live_stream?filters=[{'field':'id_match','values':[:id_match]}]", {
            domain: '@domain'
        }, {
            get: {
                method: "GET",
            }
        }
        );

        var resource_update_sort_event = $resource(
            COMMON.BASE_API + "/domain/:domain/content/matches_events/updateMultiple", {
            domain: '@domain'
        }, {
            update: {
                method: "PUT",
            }
        }
        );
        var resource_matchlives_update = $resource(
            COMMON.BASE_API + "/domain/:domain/content/live_stream/:id", {
            domain: '@domain',
            id: '@id',
        }, {
            update: {
                method: "PUT",
            }
        }
        );
        var resource_matchclips = $resource(
            COMMON.BASE_API + "/domain/:domain/content/live_stream/:id", {
            domain: '@domain'
        }, {
            get: {
                method: "GET",
            }
        }
        );
        var resource_matchcomment = $resource(
            COMMON.BASE_API + "/domain/:domain/content/matches_comments?filters=[{'field':'id_match','values':[:id_match]}]", {
            domain: '@domain'
        }, {
            get: {
                method: "GET",
            }
        }
        );
        var resource_fixture_content_section = $resource(
            COMMON.BASE_API + "/domain/:domain/content/:section?search=:search&resultsPerPage=100", {
            domain: '@domain',
            section: '@section',
        }, {
            get: {
                method: "GET",
            }
        }
        );

        var resourceSeasons = $resource(COMMON.BASE_API + "/domain/:domain/fixture/seasons?sortDir=ASC&sortField=season", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: true
            }
        });
        var resourceCreateClip = $resource(COMMON.BASE_API + "/domain/:domain/media/clip", {
            // No default data
        }, {
            post: {
                method: "POST",
                isArray: false
            }
        });
        var resourceJoinClips = $resource(COMMON.BASE_API + "/domain/:domain/media/clipMediaFiles", {
            // No default data
        }, {
            post: {
                method: "POST",
                isArray: false
            }
        });
        var resourceShareSocial = $resource(COMMON.BASE_API + "/domain/:domain/social/posts", {
            // No default data
        }, {
            post: {
                method: "POST",
                isArray: false
            }
        });
        var resourceFinishSocial = $resource(COMMON.BASE_API + "/domain/:domain/social/auth/finish", {
            // No default data
        }, {
            post: {
                method: "POST",
                isArray: false
            }
        });

        // Facebook Business: no OAuth popup - the System User token lives server side,
        // so the account is created in one call instead of via postMessage.
        var resourceConnectFacebookBusiness = $resource(COMMON.BASE_API + "/domain/:domain/social/facebookBusiness/connect", {
            // No default data
        }, {
            post: {
                method: "POST",
                isArray: false
            }
        });

        var resourceConnectX = $resource(COMMON.BASE_API + "/domain/:domain/social/x/connect", {
            // No default data
        }, {
            post: {
                method: "POST",
                isArray: false
            }
        });

        var resourceConnectYoutube = $resource(COMMON.BASE_API + "/domain/:domain/social/youtube/connect", {
            // No default data
        }, {
            post: {
                method: "POST",
                isArray: false
            }
        });

        var resourceGetTokens = $resource(COMMON.BASE_API + "/domain/:domain/socialAccounts?can_post=1", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false
            },
            post: {
                method: "POST",
                isArray: true
            }
        });
        var resourceGetTokensPages = $resource(COMMON.BASE_API + "/domain/:domain/socialAccounts/:id_account/pages", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: true
            }
        });


        function showError(e) {
            $mdToast.show({
                template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content bg-red">' + e.data.detail + '</div></md-toast>',
                hideDelay: 7000,
                position: 'top right',
                parent: '#content'
            });
        }



        return ({
            get: get,
            getContentSection: getContentSection,
            createClip: createClip,
            joinClips: joinClips,
            shareSocial: shareSocial,
            saveItem: saveItem,
            getTokensSocial: getTokensSocial,
            getTokensSocialPages: getTokensSocialPages,
            loadPostsSocial: loadPostsSocial,
            deletePostsSocial: deletePostsSocial,
            finishPage: finishPage,
            updateSortEvents: updateSortEvents,
            getEvents: getEvents,
            getClips: getClips,
            getComments: getComments,
            getLives: getLives,
            saveMatchEvent: saveMatchEvent,
            updateLive: updateLive,
            finishSocial: finishSocial,
            connectFacebookBusiness: connectFacebookBusiness,
            connectX: connectX,
            connectYoutube: connectYoutube,
            saveMatchComment: saveMatchComment,
            removeEvent: removeEvent,
            removeComment: removeComment,
            getCompetitionSeasonById: getCompetitionSeasonById,
            triggerEditDialog: triggerEditDialog,
            getFilters: getFilters
        });

    }

})();


(function () {
    'use strict';

    angular
        .module('app.match-center')
        .service('matchCenterServiceLive', matchCenterServiceLive);

    /** @ngInject */
    // I provide access to the session store.
    function matchCenterServiceLive($rootScope, $mdToast, $q, $resource, userService, settingsDomainService, contentService, COMMON, $window) {



        function get(options) {

            var deferred = $q.defer();
            var filters = [];

            _.forEach(options, function (value, key, list) {
                if (_.isObject(list[key])) {
                    _.forEach(list[key], function (filter, keyFilter, listFilter) {
                        if (!_.isEmpty(filter.selected)) {
                            filters.push({
                                field: filter.field,
                                name: filter.name,
                                values: filter.selected
                            });
                        }

                    });

                }
            });

            resourceLive.get({
                domain: options.siteID,
                filters: JSON.stringify(filters),
                search: options.searchStringFilter

            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }


        function getFilters(options) {
            var deferred = $q.defer();

            // Return the promise.
            return (deferred.promise);
        }

        var resourceLive = $resource(COMMON.BASE_API + "/domain/:domain/content/live_stream", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false
            }
        });


        return ({
            get: get,
            getFilters: getFilters
        });

    }

})();


/* mvt-decoder.js — VENDORIZADO (ES5). Bundle de pbf + @mapbox/vector-tile (esbuild+babel preset-env ie11) para decodificar vector tiles de Mapbox en el navegador. Expone window.QiuMVT={PbfReader,VectorTile}. NO editar a mano. */
function _classCallCheck(a,n){if(!(a instanceof n))throw new TypeError("Cannot call a class as a function");}function _defineProperties(e,r){for(var t=0;t<r.length;t++){var o=r[t];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,_toPropertyKey(o.key),o);}}function _createClass(e,r,t){return r&&_defineProperties(e.prototype,r),t&&_defineProperties(e,t),Object.defineProperty(e,"prototype",{writable:!1}),e;}function _toPropertyKey(t){var i=_toPrimitive(t,"string");return"symbol"==_typeof(i)?i:i+"";}function _toPrimitive(t,r){if("object"!=_typeof(t)||!t)return t;var e=t[Symbol.toPrimitive];if(void 0!==e){var i=e.call(t,r||"default");if("object"!=_typeof(i))return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return("string"===r?String:Number)(t);}function _typeof(o){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(o){return typeof o;}:function(o){return o&&"function"==typeof Symbol&&o.constructor===Symbol&&o!==Symbol.prototype?"symbol":typeof o;},_typeof(o);}var window=window||{};window.QiuMVT=function(){var __defProp=Object.defineProperty;var __getOwnPropDesc=Object.getOwnPropertyDescriptor;var __getOwnPropNames=Object.getOwnPropertyNames;var __hasOwnProp=Object.prototype.hasOwnProperty;var __export=function __export(target,all){for(var name in all)__defProp(target,name,{get:all[name],enumerable:true});};var __copyProps=function __copyProps(to,from,except,desc){if(from&&_typeof(from)==="object"||typeof from==="function"){var _loop=function _loop(){var key=_getOwnPropNames2[_i2];if(!__hasOwnProp.call(to,key)&&key!==except)__defProp(to,key,{get:function get(){return from[key];},enumerable:!(desc=__getOwnPropDesc(from,key))||desc.enumerable});};for(var _i2=0,_getOwnPropNames2=__getOwnPropNames(from);_i2<_getOwnPropNames2.length;_i2++){_loop();}}return to;};var __toCommonJS=function __toCommonJS(mod){return __copyProps(__defProp({},"__esModule",{value:true}),mod);};// mvt-entry.js
var mvt_entry_exports={};__export(mvt_entry_exports,{PbfReader:function PbfReader(){return _PbfReader;},VectorTile:function VectorTile(){return _VectorTile;}});// node_modules/pbf/index.js
var SHIFT_LEFT_32=(1<<16)*(1<<16);var SHIFT_RIGHT_32=1/SHIFT_LEFT_32;var TEXT_DECODER_MIN_LENGTH=12;var utf8TextDecoder=typeof TextDecoder==="undefined"?null:new TextDecoder("utf-8");var PBF_VARINT=0;var PBF_FIXED64=1;var PBF_BYTES=2;var PBF_FIXED32=5;var _PbfReader=/*#__PURE__*/function(){/**
     * @param {Uint8Array | ArrayBuffer} buf
     */function _PbfReader(buf){_classCallCheck(this,_PbfReader);this.buf=ArrayBuffer.isView(buf)?buf:new Uint8Array(buf);this.dataView=new DataView(this.buf.buffer,this.buf.byteOffset,this.buf.byteLength);this.pos=0;this.type=0;this._valueStart=-1;this.length=this.buf.length;}/**
     * @template T
     * @param {(tag: number, result: T, pbf: PbfReader) => void} readField
     * @param {T} result
     * @param {number} [end]
     */return _createClass(_PbfReader,[{key:"readFields",value:function readFields(readField,result){var end=arguments.length>2&&arguments[2]!==undefined?arguments[2]:this.length;var field;while(field=this.nextField(end)){readField(field,result,this);}return result;}/**
     * @template T
     * @param {(tag: number, result: T, pbf: PbfReader) => void} readField
     * @param {T} result
     */},{key:"readMessage",value:function readMessage(readField,result){return this.readFields(readField,result,this.readVarint()+this.pos);}},{key:"readFixed32",value:function readFixed32(){var val=this.dataView.getUint32(this.pos,true);this.pos+=4;return val;}},{key:"readSFixed32",value:function readSFixed32(){var val=this.dataView.getInt32(this.pos,true);this.pos+=4;return val;}// 64-bit int handling is based on github.com/dpw/node-buffer-more-ints (MIT-licensed)
},{key:"readFixed64",value:function readFixed64(){var val=this.dataView.getUint32(this.pos,true)+this.dataView.getUint32(this.pos+4,true)*SHIFT_LEFT_32;this.pos+=8;return val;}},{key:"readSFixed64",value:function readSFixed64(){var val=this.dataView.getUint32(this.pos,true)+this.dataView.getInt32(this.pos+4,true)*SHIFT_LEFT_32;this.pos+=8;return val;}},{key:"readFloat",value:function readFloat(){var val=this.dataView.getFloat32(this.pos,true);this.pos+=4;return val;}},{key:"readDouble",value:function readDouble(){var val=this.dataView.getFloat64(this.pos,true);this.pos+=8;return val;}/**
     * @param {boolean} [isSigned]
     */},{key:"readVarint",value:function readVarint(isSigned){var buf=this.buf;var b0=buf[this.pos++];if(b0<128)return b0;var val=b0&127,b;b=buf[this.pos++];val|=(b&127)<<7;if(b<128)return val;b=buf[this.pos++];val|=(b&127)<<14;if(b<128)return val;b=buf[this.pos++];val|=(b&127)<<21;if(b<128)return val;b=buf[this.pos];val|=(b&15)<<28;return readVarintRemainder(val,isSigned,this);}},{key:"readSVarint",value:function readSVarint(){var num=this.readVarint();return num%2===1?(num+1)/-2:num/2;}},{key:"readBoolean",value:function readBoolean(){return Boolean(this.readVarint());}},{key:"readString",value:function readString(){var end=this.readVarint()+this.pos;var pos=this.pos;this.pos=end;if(end-pos>=TEXT_DECODER_MIN_LENGTH&&utf8TextDecoder){return utf8TextDecoder.decode(this.buf.subarray(pos,end));}return readUtf8(this.buf,pos,end);}},{key:"readBytes",value:function readBytes(){var end=this.readVarint()+this.pos,buffer=this.buf.subarray(this.pos,end);this.pos=end;return buffer;}// verbose for performance reasons; doesn't affect gzipped size
/**
     * @param {number[]} [arr]
     * @param {boolean} [isSigned]
     */},{key:"readPackedVarint",value:function readPackedVarint(){var arr=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var isSigned=arguments.length>1?arguments[1]:undefined;var end=this.readPackedEnd();while(this.pos<end)arr.push(this.readVarint(isSigned));return arr;}/** @param {number[]} [arr] */},{key:"readPackedSVarint",value:function readPackedSVarint(){var arr=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var end=this.readPackedEnd();while(this.pos<end)arr.push(this.readSVarint());return arr;}/** @param {boolean[]} [arr] */},{key:"readPackedBoolean",value:function readPackedBoolean(){var arr=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var end=this.readPackedEnd();while(this.pos<end)arr.push(this.readBoolean());return arr;}/** @param {number[]} [arr] */},{key:"readPackedFloat",value:function readPackedFloat(){var arr=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var end=this.readPackedEnd();while(this.pos<end)arr.push(this.readFloat());return arr;}/** @param {number[]} [arr] */},{key:"readPackedDouble",value:function readPackedDouble(){var arr=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var end=this.readPackedEnd();while(this.pos<end)arr.push(this.readDouble());return arr;}/** @param {number[]} [arr] */},{key:"readPackedFixed32",value:function readPackedFixed32(){var arr=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var end=this.readPackedEnd();while(this.pos<end)arr.push(this.readFixed32());return arr;}/** @param {number[]} [arr] */},{key:"readPackedSFixed32",value:function readPackedSFixed32(){var arr=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var end=this.readPackedEnd();while(this.pos<end)arr.push(this.readSFixed32());return arr;}/** @param {number[]} [arr] */},{key:"readPackedFixed64",value:function readPackedFixed64(){var arr=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var end=this.readPackedEnd();while(this.pos<end)arr.push(this.readFixed64());return arr;}/** @param {number[]} [arr] */},{key:"readPackedSFixed64",value:function readPackedSFixed64(){var arr=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var end=this.readPackedEnd();while(this.pos<end)arr.push(this.readSFixed64());return arr;}},{key:"readPackedEnd",value:function readPackedEnd(){return this.type===PBF_BYTES?this.readVarint()+this.pos:this.pos+1;}/**
     * Advance to the next field. Returns the field number, or 0 at end-of-message.
     * @param {number} [end]
     */},{key:"nextField",value:function nextField(){var end=arguments.length>0&&arguments[0]!==undefined?arguments[0]:this.length;if(this.pos===this._valueStart)this.skip(this.type);if(this.pos>=end)return 0;var tag=this.readVarint();this.type=tag&7;this._valueStart=this.pos;return tag>>>3;}/** @param {number} val */},{key:"skip",value:function skip(val){var type=val&7;if(type===PBF_VARINT)while(this.buf[this.pos++]>127){}else if(type===PBF_BYTES)this.pos=this.readVarint()+this.pos;else if(type===PBF_FIXED32)this.pos+=4;else if(type===PBF_FIXED64)this.pos+=8;else throw new Error("Unimplemented type: ".concat(type));}}]);}();function readVarintRemainder(l,s,p){var buf=p.buf;var h,b;b=buf[p.pos++];h=(b&112)>>4;if(b<128)return toNum(l,h,s);b=buf[p.pos++];h|=(b&127)<<3;if(b<128)return toNum(l,h,s);b=buf[p.pos++];h|=(b&127)<<10;if(b<128)return toNum(l,h,s);b=buf[p.pos++];h|=(b&127)<<17;if(b<128)return toNum(l,h,s);b=buf[p.pos++];h|=(b&127)<<24;if(b<128)return toNum(l,h,s);b=buf[p.pos++];h|=(b&1)<<31;if(b<128)return toNum(l,h,s);throw new Error("Expected varint not more than 10 bytes");}function toNum(low,high,isSigned){return isSigned?high*4294967296+(low>>>0):(high>>>0)*4294967296+(low>>>0);}function readUtf8(buf,pos,end){var str="";var i=pos;while(i<end){var b0=buf[i];var c=null;var bytesPerSequence=b0>239?4:b0>223?3:b0>191?2:1;if(i+bytesPerSequence>end)break;var b1=void 0,b2=void 0,b3=void 0;if(bytesPerSequence===1){if(b0<128){c=b0;}}else if(bytesPerSequence===2){b1=buf[i+1];if((b1&192)===128){c=(b0&31)<<6|b1&63;if(c<=127){c=null;}}}else if(bytesPerSequence===3){b1=buf[i+1];b2=buf[i+2];if((b1&192)===128&&(b2&192)===128){c=(b0&15)<<12|(b1&63)<<6|b2&63;if(c<=2047||c>=55296&&c<=57343){c=null;}}}else if(bytesPerSequence===4){b1=buf[i+1];b2=buf[i+2];b3=buf[i+3];if((b1&192)===128&&(b2&192)===128&&(b3&192)===128){c=(b0&15)<<18|(b1&63)<<12|(b2&63)<<6|b3&63;if(c<=65535||c>=1114112){c=null;}}}if(c===null){c=65533;bytesPerSequence=1;}else if(c>65535){c-=65536;str+=String.fromCharCode(c>>>10&1023|55296);c=56320|c&1023;}str+=String.fromCharCode(c);i+=bytesPerSequence;}return str;}// node_modules/@mapbox/point-geometry/index.js
function Point(x,y){this.x=x;this.y=y;}Point.prototype={/**
     * Clone this point, returning a new point that can be modified
     * without affecting the old one.
     * @return {Point} the clone
     */clone:function clone(){return new Point(this.x,this.y);},/**
     * Add this point's x & y coordinates to another point,
     * yielding a new point.
     * @param {Point} p the other point
     * @return {Point} output point
     */add:function add(p){return this.clone()._add(p);},/**
     * Subtract this point's x & y coordinates to from point,
     * yielding a new point.
     * @param {Point} p the other point
     * @return {Point} output point
     */sub:function sub(p){return this.clone()._sub(p);},/**
     * Multiply this point's x & y coordinates by point,
     * yielding a new point.
     * @param {Point} p the other point
     * @return {Point} output point
     */multByPoint:function multByPoint(p){return this.clone()._multByPoint(p);},/**
     * Divide this point's x & y coordinates by point,
     * yielding a new point.
     * @param {Point} p the other point
     * @return {Point} output point
     */divByPoint:function divByPoint(p){return this.clone()._divByPoint(p);},/**
     * Multiply this point's x & y coordinates by a factor,
     * yielding a new point.
     * @param {number} k factor
     * @return {Point} output point
     */mult:function mult(k){return this.clone()._mult(k);},/**
     * Divide this point's x & y coordinates by a factor,
     * yielding a new point.
     * @param {number} k factor
     * @return {Point} output point
     */div:function div(k){return this.clone()._div(k);},/**
     * Rotate this point around the 0, 0 origin by an angle a,
     * given in radians
     * @param {number} a angle to rotate around, in radians
     * @return {Point} output point
     */rotate:function rotate(a){return this.clone()._rotate(a);},/**
     * Rotate this point around p point by an angle a,
     * given in radians
     * @param {number} a angle to rotate around, in radians
     * @param {Point} p Point to rotate around
     * @return {Point} output point
     */rotateAround:function rotateAround(a,p){return this.clone()._rotateAround(a,p);},/**
     * Multiply this point by a 4x1 transformation matrix
     * @param {[number, number, number, number]} m transformation matrix
     * @return {Point} output point
     */matMult:function matMult(m){return this.clone()._matMult(m);},/**
     * Calculate this point but as a unit vector from 0, 0, meaning
     * that the distance from the resulting point to the 0, 0
     * coordinate will be equal to 1 and the angle from the resulting
     * point to the 0, 0 coordinate will be the same as before.
     * @return {Point} unit vector point
     */unit:function unit(){return this.clone()._unit();},/**
     * Compute a perpendicular point, where the new y coordinate
     * is the old x coordinate and the new x coordinate is the old y
     * coordinate multiplied by -1
     * @return {Point} perpendicular point
     */perp:function perp(){return this.clone()._perp();},/**
     * Return a version of this point with the x & y coordinates
     * rounded to integers.
     * @return {Point} rounded point
     */round:function round(){return this.clone()._round();},/**
     * Return the magnitude of this point: this is the Euclidean
     * distance from the 0, 0 coordinate to this point's x and y
     * coordinates.
     * @return {number} magnitude
     */mag:function mag(){return Math.sqrt(this.x*this.x+this.y*this.y);},/**
     * Judge whether this point is equal to another point, returning
     * true or false.
     * @param {Point} other the other point
     * @return {boolean} whether the points are equal
     */equals:function equals(other){return this.x===other.x&&this.y===other.y;},/**
     * Calculate the distance from this point to another point
     * @param {Point} p the other point
     * @return {number} distance
     */dist:function dist(p){return Math.sqrt(this.distSqr(p));},/**
     * Calculate the distance from this point to another point,
     * without the square root step. Useful if you're comparing
     * relative distances.
     * @param {Point} p the other point
     * @return {number} distance
     */distSqr:function distSqr(p){var dx=p.x-this.x,dy=p.y-this.y;return dx*dx+dy*dy;},/**
     * Get the angle from the 0, 0 coordinate to this point, in radians
     * coordinates.
     * @return {number} angle
     */angle:function angle(){return Math.atan2(this.y,this.x);},/**
     * Get the angle from this point to another point, in radians
     * @param {Point} b the other point
     * @return {number} angle
     */angleTo:function angleTo(b){return Math.atan2(this.y-b.y,this.x-b.x);},/**
     * Get the angle between this point and another point, in radians
     * @param {Point} b the other point
     * @return {number} angle
     */angleWith:function angleWith(b){return this.angleWithSep(b.x,b.y);},/**
     * Find the angle of the two vectors, solving the formula for
     * the cross product a x b = |a||b|sin(θ) for θ.
     * @param {number} x the x-coordinate
     * @param {number} y the y-coordinate
     * @return {number} the angle in radians
     */angleWithSep:function angleWithSep(x,y){return Math.atan2(this.x*y-this.y*x,this.x*x+this.y*y);},/** @param {[number, number, number, number]} m */_matMult:function _matMult(m){var x=m[0]*this.x+m[1]*this.y,y=m[2]*this.x+m[3]*this.y;this.x=x;this.y=y;return this;},/** @param {Point} p */_add:function _add(p){this.x+=p.x;this.y+=p.y;return this;},/** @param {Point} p */_sub:function _sub(p){this.x-=p.x;this.y-=p.y;return this;},/** @param {number} k */_mult:function _mult(k){this.x*=k;this.y*=k;return this;},/** @param {number} k */_div:function _div(k){this.x/=k;this.y/=k;return this;},/** @param {Point} p */_multByPoint:function _multByPoint(p){this.x*=p.x;this.y*=p.y;return this;},/** @param {Point} p */_divByPoint:function _divByPoint(p){this.x/=p.x;this.y/=p.y;return this;},_unit:function _unit(){this._div(this.mag());return this;},_perp:function _perp(){var y=this.y;this.y=this.x;this.x=-y;return this;},/** @param {number} angle */_rotate:function _rotate(angle){var cos=Math.cos(angle),sin=Math.sin(angle),x=cos*this.x-sin*this.y,y=sin*this.x+cos*this.y;this.x=x;this.y=y;return this;},/**
     * @param {number} angle
     * @param {Point} p
     */_rotateAround:function _rotateAround(angle,p){var cos=Math.cos(angle),sin=Math.sin(angle),x=p.x+cos*(this.x-p.x)-sin*(this.y-p.y),y=p.y+sin*(this.x-p.x)+cos*(this.y-p.y);this.x=x;this.y=y;return this;},_round:function _round(){this.x=Math.round(this.x);this.y=Math.round(this.y);return this;},constructor:Point};Point.convert=function(p){if(p instanceof Point){return/** @type {Point} */p;}if(Array.isArray(p)){return new Point(+p[0],+p[1]);}if(p.x!==void 0&&p.y!==void 0){return new Point(+p.x,+p.y);}throw new Error("Expected [x, y] or {x, y} point format");};// node_modules/@mapbox/vector-tile/index.js
var VectorTileFeature=/*#__PURE__*/function(){/**
     * @param {PbfReader} pbf
     * @param {number} end
     * @param {number} extent
     * @param {string[]} keys
     * @param {(number | string | boolean)[]} values
     */function VectorTileFeature(pbf,end,extent,keys,values){_classCallCheck(this,VectorTileFeature);this.properties=/* @__PURE__ */Object.create(null);this.extent=extent;this.type=0;this.id=void 0;this._pbf=pbf;this._geometry=-1;this._keys=keys;this._values=values;while(pbf.pos<end){var tag=pbf.readVarint();if(tag===8)this.id=pbf.readVarint();else if(tag===18){var tagsEnd=pbf.readVarint()+pbf.pos;while(pbf.pos<tagsEnd){var key=keys[pbf.readVarint()];var value=values[pbf.readVarint()];this.properties[key]=value;}}else if(tag===24)this.type=/** @type {0 | 1 | 2 | 3} */pbf.readVarint();else if(tag===34){this._geometry=pbf.pos;pbf.skip(tag);}else pbf.skip(tag);}}return _createClass(VectorTileFeature,[{key:"loadGeometry",value:function loadGeometry(){if(this._geometry<0)throw new Error("feature has no geometry");var pbf=this._pbf;pbf.pos=this._geometry;var end=pbf.readVarint()+pbf.pos;var lines=[];var line;var cmd=1;var length=0;var x=0;var y=0;while(pbf.pos<end){if(length<=0){var cmdLen=pbf.readVarint();cmd=cmdLen&7;length=cmdLen>>3;if(length===0)continue;}length--;if(cmd===1){x+=pbf.readSVarint();y+=pbf.readSVarint();if(line)lines.push(line);line=[new Point(x,y)];}else if(cmd===2){x+=pbf.readSVarint();y+=pbf.readSVarint();if(line)line.push(new Point(x,y));}else if(cmd===7){if(line){line.push(line[0].clone());}}else{throw new Error("unknown command ".concat(cmd));}}if(line)lines.push(line);return lines;}},{key:"bbox",value:function bbox(){if(this._geometry<0)throw new Error("feature has no geometry");var pbf=this._pbf;pbf.pos=this._geometry;var end=pbf.readVarint()+pbf.pos;var cmd=1,length=0,x=0,y=0,x1=Infinity,x2=-Infinity,y1=Infinity,y2=-Infinity;while(pbf.pos<end){if(length<=0){var cmdLen=pbf.readVarint();cmd=cmdLen&7;length=cmdLen>>3;if(length===0)continue;}length--;if(cmd===1||cmd===2){x+=pbf.readSVarint();y+=pbf.readSVarint();if(x<x1)x1=x;if(x>x2)x2=x;if(y<y1)y1=y;if(y>y2)y2=y;}else if(cmd!==7){throw new Error("unknown command ".concat(cmd));}}return[x1,y1,x2,y2];}/**
     * @param {number} x
     * @param {number} y
     * @param {number} z
     * @return {Feature}
     */},{key:"toGeoJSON",value:function toGeoJSON(x,y,z){var size=this.extent*Math.pow(2,z),x0=this.extent*x,y0=this.extent*y,vtCoords=this.loadGeometry();function projectPoint(p){return[(p.x+x0)*360/size-180,360/Math.PI*Math.atan(Math.exp((1-(p.y+y0)*2/size)*Math.PI))-90];}function projectLine(line){return line.map(projectPoint);}var geometry;if(this.type===1){var points=[];for(var _i4=0;_i4<vtCoords.length;_i4++){var line=vtCoords[_i4];points.push(line[0]);}var coordinates=projectLine(points);geometry=points.length===1?{type:"Point",coordinates:coordinates[0]}:{type:"MultiPoint",coordinates:coordinates};}else if(this.type===2){var _coordinates=vtCoords.map(projectLine);geometry=_coordinates.length===1?{type:"LineString",coordinates:_coordinates[0]}:{type:"MultiLineString",coordinates:_coordinates};}else if(this.type===3){var polygons=classifyRings(vtCoords);var _coordinates2=[];for(var _i6=0;_i6<polygons.length;_i6++){var polygon=polygons[_i6];_coordinates2.push(polygon.map(projectLine));}geometry=_coordinates2.length===1?{type:"Polygon",coordinates:_coordinates2[0]}:{type:"MultiPolygon",coordinates:_coordinates2};}else{throw new Error("unknown feature type");}var result={type:"Feature",geometry:geometry,properties:this.properties};if(this.id!=null){result.id=this.id;}return result;}}]);}();VectorTileFeature.types=["Unknown","Point","LineString","Polygon"];function classifyRings(rings){var len=rings.length;if(len<=1)return[rings];var polygons=[];var polygon,ccw;for(var i=0;i<len;i++){var area=signedArea(rings[i]);if(area===0)continue;if(ccw===void 0)ccw=area<0;if(ccw===area<0){if(polygon)polygons.push(polygon);polygon=[rings[i]];}else if(polygon){polygon.push(rings[i]);}}if(polygon)polygons.push(polygon);return polygons;}function signedArea(ring){var sum=0;for(var i=0,len=ring.length,j=len-1,p1,p2;i<len;j=i++){p1=ring[i];p2=ring[j];sum+=(p2.x-p1.x)*(p1.y+p2.y);}return sum;}var VectorTileLayer=/*#__PURE__*/function(){/**
     * @param {PbfReader} pbf
     * @param {number} [end]
     */function VectorTileLayer(pbf,end){_classCallCheck(this,VectorTileLayer);this.version=1;this.name="";this.extent=4096;this.length=0;this._pbf=pbf;this._keys=[];this._values=[];this._features=[];if(end===void 0)end=pbf.length;while(pbf.pos<end){var tag=pbf.readVarint();if(tag===10)this.name=pbf.readString();else if(tag===18){this._features.push(pbf.pos);pbf.skip(tag);}else if(tag===26)this._keys.push(pbf.readString());else if(tag===34)this._values.push(readValueMessage(pbf));else if(tag===40)this.extent=pbf.readVarint();else if(tag===120)this.version=pbf.readVarint();else pbf.skip(tag);}this.length=this._features.length;}/** return feature `i` from this layer as a `VectorTileFeature`
     * @param {number} i
     */return _createClass(VectorTileLayer,[{key:"feature",value:function feature(i){if(i<0||i>=this._features.length)throw new Error("feature index out of bounds");this._pbf.pos=this._features[i];var end=this._pbf.readVarint()+this._pbf.pos;return new VectorTileFeature(this._pbf,end,this.extent,this._keys,this._values);}}]);}();function readValueMessage(pbf){var value=null;var end=pbf.readVarint()+pbf.pos;while(pbf.pos<end){var tag=pbf.readVarint();value=tag===10?pbf.readString():tag===21?pbf.readFloat():tag===25?pbf.readDouble():tag===32?pbf.readVarint(true):tag===40?pbf.readVarint():tag===48?pbf.readSVarint():tag===56?pbf.readBoolean():(pbf.skip(tag),null);}if(value==null){throw new Error("unknown feature value");}return value;}var _VectorTile=/*#__PURE__*/_createClass(/**
     * @param {PbfReader} pbf
     * @param {number} [end]
     */function _VectorTile(pbf){var end=arguments.length>1&&arguments[1]!==undefined?arguments[1]:pbf.length;_classCallCheck(this,_VectorTile);var layers=/* @__PURE__ */Object.create(null);while(pbf.pos<end){var tag=pbf.readVarint();if(tag===26){var layer=new VectorTileLayer(pbf,pbf.readVarint()+pbf.pos);if(layer.length)layers[layer.name]=layer;}else pbf.skip(tag);}this.layers=layers;});return __toCommonJS(mvt_entry_exports);}();

(function () {
    'use strict';

    angular
        .module('app.maps')
        .controller('MapsController', MapsController);

    /** @ngInject */
    function MapsController($stateParams, $state, $mdDialog, $translate,
                            requestContext, mapsService, $mdToast) {
        var vm = this;

        vm.siteID = $stateParams.siteId || $state.params.siteId || requestContext.getParam('siteId');
        vm.maps = [];
        vm.loading = true;
        vm.query = '';

        vm.selectedMap = null;
        vm.openingMap = false;
        vm.editorFullscreen = false;

        vm.createMap = createMap;
        vm.selectMap = selectMap;
        vm.closeMap = closeMap;
        vm.onMapSaved = onMapSaved;
        vm.deleteMap = deleteMap;
        vm.featureCount = featureCount;
        vm.toggleFullscreen = toggleFullscreen;

        loadMaps();

        function loadMaps() {
            vm.loading = true;

            mapsService.getMaps(vm.siteID).then(function (maps) {
                vm.maps = maps;
                vm.loading = false;
            }, function () {
                vm.maps = [];
                vm.loading = false;
                toast($translate.instant('MAPS.LOAD_ERROR'));
            });
        }

        function featureCount(map) {
            return (map.features && map.features.features) ? map.features.features.length : 0;
        }

        function createMap() {
            // Abre el editor a la derecha con un mapa vacio en memoria (como el
            // "nuevo" de content). Se persiste con el primer "Guardar"; el editor
            // adopta el id devuelto y los siguientes guardados son updates.
            vm.selectedMap = mapsService.newMap('');
        }

        function toggleFullscreen() {
            vm.editorFullscreen = !vm.editorFullscreen;
        }

        function selectMap(map) {
            if (!map) {
                return;
            }
            // Mapa nuevo sin guardar (sin id): no hay nada que recargar.
            if (!map.id) {
                vm.selectedMap = map;
                return;
            }
            // Recargar SIEMPRE desde la BD al abrir: si un compañero edito el mapa
            // mientras tanto, vemos su version actual (no la copia vieja de la lista).
            // Usamos getMaps (la lista, endpoint probado) y cogemos el mapa por id;
            // de paso refrescamos la lista. getMap (item unico) no da el shape esperado.
            vm.selectedMap = null;
            vm.openingMap = true;
            mapsService.getMaps(vm.siteID).then(function (maps) {
                vm.openingMap = false;
                vm.maps = maps;
                var fresh = null;
                for (var i = 0; i < maps.length; i++) {
                    if (maps[i].id === map.id) { fresh = maps[i]; break; }
                }
                if (fresh) {
                    vm.selectedMap = fresh;
                } else {
                    // El mapa ya no existe (borrado por otra persona mientras tanto)
                    toast($translate.instant('MAPS.LOAD_ERROR'));
                }
            }, function () {
                vm.openingMap = false;
                // Si falla la recarga, abrimos con lo que hay en la lista.
                vm.selectedMap = map;
                toast($translate.instant('MAPS.LOAD_ERROR'));
            });
        }

        function closeMap() {
            vm.selectedMap = null;
            vm.editorFullscreen = false;
        }

        function onMapSaved() {
            // Solo refrescamos la lista (contador de elementos, mapas nuevos).
            // NO reasignamos vm.selectedMap: el editor ya tiene la copia de trabajo
            // al dia, y sustituir la referencia forzaria un re-init del mapa.
            mapsService.getMaps(vm.siteID).then(function (maps) {
                vm.maps = maps;
            });
        }

        function deleteMap(ev, map) {
            var confirm = $mdDialog.confirm()
                .title($translate.instant('MAPS.DELETE_CONFIRM_TITLE'))
                .textContent($translate.instant('MAPS.DELETE_CONFIRM_TEXT', {name: map.title}))
                .targetEvent(ev)
                .ok($translate.instant('MAPS.DELETE'))
                .cancel($translate.instant('MAPS.CANCEL'));

            $mdDialog.show(confirm).then(function () {
                mapsService.deleteMap(vm.siteID, map.id).then(function () {
                    if (vm.selectedMap && vm.selectedMap.id === map.id) {
                        vm.selectedMap = null;
                    }
                    loadMaps();
                }, function () {
                    toast($translate.instant('MAPS.DELETE_ERROR'));
                });
            });
        }

        function toast(message) {
            $mdToast.show($mdToast.simple().textContent(message).position('top right').hideDelay(3000));
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.maps')
        .factory('mapsStyleService', mapsStyleService);

    /**
     * Biblioteca de estilos de OpenFreeMap (MapLibre) + nucleo del editor por capas.
     *
     * Almacenamiento: cada estilo es una fila de la seccion `mapbox_styles`
     *   (misma mecanica de content endpoints que los mapas, sin API propia):
     *   { id, title, base, overrides, onoff, sort }
     *   base      -> URL del estilo base (liberty/bright/positron)
     *   overrides -> { <layerId>: { color?, visibility? } }  (LONGTEXT JSON)
     * Al renderizar: base + overrides = estilo final (resolve()).
     *
     * @ngInject
     */
    function mapsStyleService($resource, $q, $rootScope, COMMON) {

        var SECTION = 'mapbox_styles';
        var DEFAULT_BASE = 'https://tiles.openfreemap.org/styles/liberty';

        var resourceContent = $resource(COMMON.BASE_API + '/domain/:domain/content/:section/:id', {
            domain: '@domain', section: SECTION, id: '@id'
        }, {
            get: {method: 'GET'},
            put: {method: 'PUT'}
        });

        // El DELETE de item es un stub; el borrado real va por action/delete (como maps).
        var resourceAction = $resource(COMMON.BASE_API + '/domain/:domain/content/:section/action/:type', {
            domain: '@domain', section: SECTION, type: '@type'
        }, {
            run: {method: 'PUT'}
        });

        return {
            // Biblioteca (CRUD)
            getStyles: getStyles,
            getStyle: getStyle,
            saveStyle: saveStyle,
            deleteStyle: deleteStyle,
            newStyle: newStyle,
            // Nucleo del editor por capas
            loadStyle: loadStyle,
            describeLayers: describeLayers,
            applyOverrides: applyOverrides,
            resolve: resolve,
            colorPropFor: colorPropFor,
            DEFAULT_BASE: DEFAULT_BASE
        };

        // ---------- Biblioteca (CRUD via content endpoints) ----------

        function newStyle(title, base) {
            return {
                id: null,
                title: title || '',
                base: base || DEFAULT_BASE,
                overrides: {},
                onoff: 1,
                sort: 0
            };
        }

        function parseStyle(row) {
            return {
                id: row.id_mapbox_styles,
                title: row.title || '',
                base: row.style_base || DEFAULT_BASE,
                overrides: safeParse(row.style_overrides, {}),
                onoff: row.onoff,
                sort: row.sort
            };
        }

        function serializeStyle(style) {
            var payload = {
                title: style.title,
                sort: angular.isDefined(style.sort) ? style.sort : 0,
                onoff: angular.isDefined(style.onoff) ? style.onoff : 1,
                style_base: style.base || DEFAULT_BASE,
                style_overrides: angular.toJson(style.overrides || {})
            };
            // Al actualizar, el endpoint necesita item.id (si no, cae en insert roto)
            if (style.id) {
                payload.id = style.id;
            }
            return payload;
        }

        function getStyles(domain) {
            var deferred = $q.defer();
            resourceContent.get({domain: domain, section: SECTION}, function (response) {
                deferred.resolve(extractRows(response).map(parseStyle));
            }, deferred.reject);
            return deferred.promise;
        }

        function getStyle(domain, id) {
            var deferred = $q.defer();
            resourceContent.get({domain: domain, section: SECTION, id: id}, function (response) {
                var rows = extractRows(response);
                if (!rows.length) {
                    deferred.reject(response);
                    return;
                }
                deferred.resolve(parseStyle(rows[0]));
            }, deferred.reject);
            return deferred.promise;
        }

        function saveStyle(domain, style) {
            var deferred = $q.defer();
            var payload = {item: serializeStyle(style)};
            var id = style.id ? style.id : 'new';
            resourceContent.put({domain: domain, section: SECTION, id: id}, payload, function (response) {
                deferred.resolve({response: response, id: extractNewId(response) || style.id});
            }, deferred.reject);
            return deferred.promise;
        }

        function deleteStyle(domain, id) {
            var deferred = $q.defer();
            resourceAction.run({domain: domain, section: SECTION, type: 'delete'}, {ids: [id]},
                function (response) { deferred.resolve(response); }, deferred.reject);
            return deferred.promise;
        }

        function extractRows(response) {
            if (!response) { return []; }
            if (response.result && angular.isArray(response.result.data)) { return response.result.data; }
            if (angular.isArray(response.data)) { return response.data; }
            if (angular.isArray(response)) { return response; }
            return angular.isObject(response) && response.id_mapbox_styles ? [response] : [];
        }

        function extractNewId(response) {
            if (!response) { return null; }
            if (response.id_mapbox_styles) { return response.id_mapbox_styles; }
            if (response.result && response.result.id_mapbox_styles) { return response.result.id_mapbox_styles; }
            var rows = extractRows(response);
            return rows.length && rows[0].id_mapbox_styles ? rows[0].id_mapbox_styles : null;
        }

        function safeParse(value, fallback) {
            if (!value) { return fallback; }
            if (angular.isObject(value)) { return value; }
            try {
                var parsed = angular.fromJson(value);
                return angular.isObject(parsed) ? parsed : fallback;
            } catch (e) {
                return fallback;
            }
        }

        // ---------- Nucleo del editor por capas ----------

        function loadStyle(url) {
            if (!url) { return $q.reject('NO_URL'); }
            // fetch NATIVO (no $http): el interceptor de auth de la app anade cabeceras
            // que disparan un preflight CORS que tiles.openfreemap.org rechaza. MapLibre
            // usa fetch por eso funciona; aqui hacemos igual. $applyAsync -> digest.
            var deferred = $q.defer();
            fetch(url).then(function (r) {
                if (!r.ok) { throw new Error('HTTP ' + r.status); }
                return r.json();
            }).then(function (json) {
                $rootScope.$applyAsync(function () { deferred.resolve(json); });
            }, function (err) {
                $rootScope.$applyAsync(function () { deferred.reject(err); });
            });
            return deferred.promise;
        }

        function colorPropFor(type) {
            switch (type) {
                case 'background':     return 'background-color';
                case 'fill':           return 'fill-color';
                case 'line':           return 'line-color';
                case 'fill-extrusion': return 'fill-extrusion-color';
                case 'symbol':         return 'text-color';
                default:               return null;
            }
        }

        function groupOf(layer) {
            var sl = (layer['source-layer'] || '').toLowerCase();
            var id = (layer.id || '').toLowerCase();
            if (layer.type === 'background') { return 'background'; }
            if (layer.type === 'raster') { return 'raster'; }
            if (sl === 'water' || sl === 'waterway' || id.indexOf('water') > -1) { return 'water'; }
            if (sl === 'building' || id.indexOf('building') > -1) { return 'buildings'; }
            if (sl === 'transportation' || sl === 'transportation_name' ||
                id.indexOf('road') > -1 || id.indexOf('bridge') > -1 || id.indexOf('tunnel') > -1) { return 'roads'; }
            if (layer.type === 'symbol' || id.indexOf('label') > -1 ||
                sl.indexOf('place') > -1 || sl.indexOf('poi') > -1) { return 'labels'; }
            if (sl === 'landcover' || sl === 'landuse' || sl === 'park' ||
                id.indexOf('land') > -1 || id.indexOf('park') > -1) { return 'land'; }
            return 'other';
        }

        function describeLayers(style) {
            var layers = (style && style.layers) || [];
            return layers.map(function (l) {
                var prop = colorPropFor(l.type);
                var paint = l.paint || {};
                var raw = prop ? paint[prop] : undefined;
                var color = (typeof raw === 'string') ? raw : null;
                return {
                    id: l.id,
                    type: l.type,
                    sourceLayer: l['source-layer'] || null,
                    group: groupOf(l),
                    colorProp: prop,
                    color: color,
                    isExpression: !!(prop && raw !== undefined && typeof raw !== 'string'),
                    visibility: (l.layout && l.layout.visibility) || 'visible'
                };
            });
        }

        function applyOverrides(style, overrides) {
            var out = angular.copy(style) || {};
            var byId = overrides || {};
            (out.layers || []).forEach(function (l) {
                var ov = byId[l.id];
                if (!ov) { return; }
                if (ov.visibility) {
                    l.layout = l.layout || {};
                    l.layout.visibility = ov.visibility;
                }
                if (ov.color) {
                    var prop = colorPropFor(l.type);
                    if (prop) {
                        l.paint = l.paint || {};
                        l.paint[prop] = ov.color;
                    }
                }
            });
            return out;
        }

        function resolve(styleDef) {
            if (!styleDef || !styleDef.base) { return $q.reject('NO_BASE'); }
            return loadStyle(styleDef.base).then(function (base) {
                return applyOverrides(base, styleDef.overrides || {});
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.maps')
        .factory('mapsService', mapsService);

    /**
     * Los mapas se guardan como una seccion de contenido (section_mapbox_maps),
     * asi que reutilizamos los endpoints genericos de content en lugar de tener
     * API propia. Los dos campos JSON viajan como string: el editor es el unico
     * que los escribe y valida antes de enviar.
     *
     * @ngInject
     */
    function mapsService($resource, $q, COMMON) {

        var SECTION = 'mapbox_maps';

        var resourceContent = $resource(COMMON.BASE_API + "/domain/:domain/content/:section/:id", {
            domain: '@domain',
            section: SECTION,
            id: '@id'
        }, {
            get: {method: "GET"},
            put: {method: "PUT"}
        });

        // El DELETE de un item es un stub que no borra nada; el borrado real de
        // contenido va por la accion masiva PUT content/{section}/action/delete.
        var resourceAction = $resource(COMMON.BASE_API + "/domain/:domain/content/:section/action/:type", {
            domain: '@domain',
            section: SECTION,
            type: '@type'
        }, {
            run: {method: "PUT"}
        });

        return {
            getMaps: getMaps,
            getMap: getMap,
            saveMap: saveMap,
            deleteMap: deleteMap,
            parseMap: parseMap,
            serializeMap: serializeMap,
            newMap: newMap,
            buildObj: buildObj,
            buildObjWith: buildObjWith,
            polygonCount: polygonCount
        };

        /**
         * Mapa vacio con el mismo shape que devuelve parseMap, listo para el editor.
         */
        function newMap(title) {
            return {
                id: null,
                title: title || '',
                sort: 0,
                onoff: 1,
                view: defaultView(),
                features: emptyFeatures(),
                categories: defaultCategories()
            };
        }

        /**
         * Categorias de arranque (las de la demo de America's Cup). Editables por mapa.
         */
        function defaultCategories() {
            return [
                {id: 'village', name: 'Race Village', color: '#E5352B'},
                {id: 'ace',     name: 'ACE Facilities', color: '#12202C'},
                {id: 'marina',  name: 'Marinas & Berths', color: '#EFC84A'},
                {id: 'fanzone', name: 'Fan Zone', color: '#37B34A'},
                {id: 'race',    name: 'Race Areas', color: '#16384F'}
            ];
        }

        /**
         * Convierte una fila cruda de la seccion en el objeto que usa el editor.
         * Si el JSON guardado no parsea, devuelve valores por defecto en vez de
         * propagar la excepcion: un mapa corrupto no debe tumbar el listado.
         */
        function parseMap(row) {
            var categories = safeParse(row.map_categories, null);
            var view = safeParse(row.map_view, defaultView());
            // Mapas creados antes del selector de render: por defecto Mapbox
            if (!view.render) {
                view.render = 'mapbox';
            }
            return {
                id: row.id_mapbox_maps,
                title: row.title || '',
                sort: row.sort,
                onoff: row.onoff,
                view: view,
                features: migrateFeatures(safeParse(row.map_features, emptyFeatures())),
                // Mapas creados antes de las categorias: arrancan con las por defecto
                categories: angular.isArray(categories) ? categories : defaultCategories()
            };
        }

        // Migracion title/subtitle/description: hasta ahora `description` era el
        // subtitulo de la tarjeta. Ahora `subtitle` es ese subtitulo y `description`
        // es un campo NUEVO solo-detalle. Los elementos antiguos no tienen la clave
        // `subtitle` -> movemos su `description` a `subtitle` y dejamos description
        // vacia. Idempotente: si ya existe la clave `subtitle`, no toca nada.
        function migrateFeatures(fc) {
            var feats = (fc && fc.features) || [];
            feats.forEach(function (f) {
                var p = f && f.properties;
                if (p && typeof p.subtitle === 'undefined') {
                    p.subtitle = p.description || '';
                    p.description = '';
                }
            });
            return fc;
        }

        /**
         * Objeto del editor -> payload de la seccion.
         */
        function serializeMap(map) {
            var payload = {
                title: map.title,
                sort: angular.isDefined(map.sort) ? map.sort : 0,
                onoff: angular.isDefined(map.onoff) ? map.onoff : 1,
                map_view: angular.toJson(map.view),
                map_features: angular.toJson(map.features),
                map_categories: angular.toJson(map.categories || defaultCategories())
            };
            // Al actualizar, el endpoint de contenido necesita item.id NO vacio: si
            // falta, cae en una rama de "insert" rota (contentUpdate recibe id null).
            // El id no se escribe como columna (no es campo editable), solo enruta.
            if (map.id) {
                payload.id = map.id;
            }
            return payload;
        }

        function defaultView() {
            return {
                center: [2.1734, 41.3851],
                zoom: 14,
                pitch: 0,
                bearing: 0,
                render: 'openfreemap',
                openfreemapStyle: 'https://tiles.openfreemap.org/styles/liberty'
            };
        }

        function emptyFeatures() {
            return {type: 'FeatureCollection', features: []};
        }

        function safeParse(value, fallback) {
            if (!value) {
                return fallback;
            }
            if (angular.isObject(value)) {
                return value;
            }
            try {
                var parsed = angular.fromJson(value);
                return angular.isObject(parsed) ? parsed : fallback;
            } catch (e) {
                return fallback;
            }
        }

        /**
         * El endpoint de contenido devuelve {ref: [...], result: {data: [...], ...}}.
         * Aceptamos tambien formas mas planas por si cambia entre endpoints.
         */
        function extractRows(response) {
            if (!response) {
                return [];
            }
            if (response.result && angular.isArray(response.result.data)) {
                return response.result.data;
            }
            if (angular.isArray(response.data)) {
                return response.data;
            }
            if (angular.isArray(response)) {
                return response;
            }
            return angular.isObject(response) && response.id_mapbox_maps ? [response] : [];
        }

        function getMaps(domain) {
            var deferred = $q.defer();
            resourceContent.get({domain: domain, section: SECTION}, function (response) {
                deferred.resolve(extractRows(response).map(parseMap));
            }, deferred.reject);
            return deferred.promise;
        }

        function getMap(domain, id) {
            var deferred = $q.defer();
            resourceContent.get({domain: domain, section: SECTION, id: id}, function (response) {
                var rows = extractRows(response);
                if (!rows.length) {
                    deferred.reject(response);
                    return;
                }
                deferred.resolve(parseMap(rows[0]));
            }, deferred.reject);
            return deferred.promise;
        }

        function saveMap(domain, map) {
            var deferred = $q.defer();
            // El endpoint de contenido espera el registro dentro de "item"
            var payload = {item: serializeMap(map)};
            var id = map.id ? map.id : 'new';

            resourceContent.put({domain: domain, section: SECTION, id: id}, payload, function (response) {
                // Al crear, la respuesta trae el id nuevo; lo normalizamos para que
                // el editor pueda reabrir el mapa recien creado.
                var newId = extractNewId(response);
                deferred.resolve({response: response, id: newId || map.id});
            }, deferred.reject);

            return deferred.promise;
        }

        /**
         * El PUT de creacion devuelve el registro nuevo; buscamos su id_mapbox_maps
         * en las formas conocidas de respuesta del endpoint de contenido.
         */
        function extractNewId(response) {
            if (!response) {
                return null;
            }
            var rows = extractRows(response);
            if (rows.length && rows[0].id_mapbox_maps) {
                return rows[0].id_mapbox_maps;
            }
            if (response.id_mapbox_maps) {
                return response.id_mapbox_maps;
            }
            if (response.id) {
                return response.id;
            }
            return null;
        }

        function deleteMap(domain, id) {
            var deferred = $q.defer();
            resourceAction.run(
                {domain: domain, section: SECTION, type: 'delete'},
                {ids: [id]},
                function (response) {
                    deferred.resolve(response);
                },
                deferred.reject
            );
            return deferred.promise;
        }

        // ---- Exportar volumenes a OBJ (Wavefront) para Cinema 4D ----
        //
        // Cada zona/circulo (Polygon) se exporta como malla: se proyectan sus
        // coordenadas lng/lat a METROS locales respecto a un origen (centro de la
        // vista), y se extruye a su altura. Sistema de coordenadas de salida:
        // X=este, Y=arriba (altura), Z=sur (-norte) -> mano derecha, Y up (como C4D).
        // Se emiten caras poligonales (n-gons) que C4D importa directamente, sin
        // triangular. Los pins (Point) no son volumenes: se ignoran.

        // Numero de poligonos que se exportarian (para avisar si no hay ninguno)
        function polygonCount(map) {
            return polygonsOf(map).length;
        }

        function polygonsOf(map) {
            var features = (map && map.features && map.features.features) || [];
            return features.filter(function (f) {
                return f.geometry
                    && (f.geometry.type === 'Polygon' || f.geometry.type === 'MultiPolygon');
            });
        }

        // Anillos EXTERIORES de un elemento: uno si es un Polygon, y uno por forma si
        // es un MultiPolygon (una zona con varias manchas bajo la misma etiqueta).
        // Cada anillo se extruye por separado: en 3D son volumenes independientes.
        function outerRingsOf(geometry) {
            if (!geometry || !angular.isArray(geometry.coordinates)) {
                return [];
            }
            if (geometry.type === 'MultiPolygon') {
                return geometry.coordinates.map(function (rings) {
                    return rings[0] || [];
                });
            }
            return geometry.type === 'Polygon' ? [geometry.coordinates[0] || []] : [];
        }

        // Solo nuestras figuras
        function buildObj(map) {
            return buildObjWith(map, []);
        }

        // Nuestras figuras + geometria externa (de los vector tiles de Mapbox).
        // buildings: [{coords:[[lng,lat],...], baseH, topH, name}] -> extruidos/planos.
        // polylines: [{coords:[[lng,lat],...], name}]            -> lineas OBJ (agua no, calles si).
        // terrain (opcional): {cols, rows, west, north, dLng, dLat, elev[]} -> malla de
        //   topografia + drapeado (cada figura sube a la cota del terreno bajo ella).
        function buildObjWith(map, buildings, polylines, terrain) {
            var polys = polygonsOf(map);
            var origin = objOrigin(map, polys);
            var ctx = {
                lines: [
                    '# Mapbox map export - ' + (map && map.title || 'map'),
                    '# Origen 0,0,0 = lng ' + origin[0] + ' lat ' + origin[1],
                    '# Unidades: metros. Ejes: X=este, Y=altura, Z=sur.'
                ],
                vBase: 0,
                origin: origin,
                mLng: 111320 * Math.cos(origin[1] * Math.PI / 180),
                mLat: 110574
            };

            // Topografia: malla de terreno + funcion de cota para drapear el resto.
            var elevAt = terrain ? makeTerrainSampler(terrain) : function () { return 0; };
            if (terrain) {
                addTerrainMesh(ctx, terrain);
            }

            // Nuestras figuras (prefijo MUEVA_): base a la cota del terreno bajo ellas.
            polys.forEach(function (f, idx) {
                var h = (f.properties && Number(f.properties.height)) || 0;
                var name = 'MUEVA_' + objName((f.properties && f.properties.title) || ('shape_' + (idx + 1)), idx);
                var rings = outerRingsOf(f.geometry);
                rings.forEach(function (ring, part) {
                    // Varias formas -> un objeto OBJ por forma, sufijado, para que en
                    // Cinema 4D se puedan tratar por separado sin perder de quien son.
                    var partName = rings.length > 1 ? (name + '_p' + (part + 1)) : name;
                    var z = elevAt(ringCentroid(ring));
                    extrudeRing(ctx, ring, z, z + h, partName);
                });
            });

            // Poligonos externos (edificios extruidos, agua plana...): drapeados a la cota.
            (buildings || []).forEach(function (bd) {
                var z = elevAt(ringCentroid(bd.coords));
                extrudeRing(ctx, bd.coords, z + (bd.baseH || 0), z + (bd.topH || 0), bd.name);
            });

            // Polilineas externas (calles): siguen el terreno vertice a vertice.
            (polylines || []).forEach(function (pl) {
                addPolyline(ctx, pl.coords, pl.name, elevAt);
            });

            return ctx.lines.join('\n') + '\n';
        }

        // Interpolacion bilineal de la cota del terreno en un punto [lng,lat].
        function makeTerrainSampler(t) {
            return function (lngLat) {
                if (!lngLat) { return 0; }
                var fc = (lngLat[0] - t.west) / t.dLng;
                var fr = (t.north - lngLat[1]) / t.dLat;
                fc = Math.min(t.cols - 1, Math.max(0, fc));
                fr = Math.min(t.rows - 1, Math.max(0, fr));
                var c0 = Math.floor(fc), r0 = Math.floor(fr);
                var c1 = Math.min(c0 + 1, t.cols - 1), r1 = Math.min(r0 + 1, t.rows - 1);
                var tx = fc - c0, ty = fr - r0;
                var e00 = t.elev[r0 * t.cols + c0], e10 = t.elev[r0 * t.cols + c1];
                var e01 = t.elev[r1 * t.cols + c0], e11 = t.elev[r1 * t.cols + c1];
                var top = e00 + (e10 - e00) * tx, bot = e01 + (e11 - e01) * tx;
                return top + (bot - top) * ty;
            };
        }

        // Malla de terreno como objeto OBJ (rejilla de vertices con su cota + caras quad).
        function addTerrainMesh(ctx, t) {
            ctx.lines.push('o TERRAIN');
            var base = ctx.vBase, r, c;
            for (r = 0; r < t.rows; r++) {
                var lat = t.north - r * t.dLat;
                for (c = 0; c < t.cols; c++) {
                    var lng = t.west + c * t.dLng;
                    ctx.lines.push(objVertex([lng, lat], t.elev[r * t.cols + c], ctx.origin, ctx.mLng, ctx.mLat));
                }
            }
            function vi(rr, cc) { return base + rr * t.cols + cc + 1; }
            for (r = 0; r < t.rows - 1; r++) {
                for (c = 0; c < t.cols - 1; c++) {
                    ctx.lines.push('f ' + vi(r, c) + ' ' + vi(r + 1, c) + ' ' + vi(r + 1, c + 1) + ' ' + vi(r, c + 1));
                }
            }
            ctx.vBase += t.rows * t.cols;
        }

        // Centroide simple (media de vertices) de un anillo [lng,lat].
        function ringCentroid(ring) {
            var pts = ring || [];
            if (!pts.length) { return null; }
            var sx = 0, sy = 0;
            for (var i = 0; i < pts.length; i++) { sx += pts[i][0]; sy += pts[i][1]; }
            return [sx / pts.length, sy / pts.length];
        }

        // Anade una polilinea (lng/lat) como objeto OBJ con un elemento 'l'. Sin terreno
        // va a z=0; con terreno (elevAt) sigue la cota vertice a vertice.
        function addPolyline(ctx, coords, name, elevAt) {
            var pts = coords || [];
            if (pts.length < 2) {
                return;
            }
            ctx.lines.push('o ' + name);
            for (var i = 0; i < pts.length; i++) {
                var z = elevAt ? elevAt(pts[i]) : 0;
                ctx.lines.push(objVertex(pts[i], z, ctx.origin, ctx.mLng, ctx.mLat));
            }
            var idx = [];
            for (i = 0; i < pts.length; i++) {
                idx.push(ctx.vBase + i + 1);
            }
            ctx.lines.push('l ' + idx.join(' '));
            ctx.vBase += pts.length;
        }

        // Extruye un anillo (lng/lat) de baseH a topH y lo anade como objeto OBJ.
        // topH<=baseH -> cara plana (footprint). Emite n-gons (C4D los importa).
        function extrudeRing(ctx, rawRing, baseH, topH, name) {
            var ring = rawRing || [];
            // Quitar el punto de cierre duplicado
            if (ring.length > 1) {
                var a = ring[0], z = ring[ring.length - 1];
                if (a[0] === z[0] && a[1] === z[1]) {
                    ring = ring.slice(0, -1);
                }
            }
            if (ring.length < 3) {
                return;
            }
            // CCW en (este, norte) para un sentido de caras consistente
            if (ringSignedArea(ring) < 0) {
                ring = ring.slice().reverse();
            }
            var n = ring.length, solid = topH > baseH, i, iw, j;
            ctx.lines.push('o ' + name);
            for (i = 0; i < n; i++) {
                ctx.lines.push(objVertex(ring[i], baseH, ctx.origin, ctx.mLng, ctx.mLat));
            }
            if (solid) {
                for (i = 0; i < n; i++) {
                    ctx.lines.push(objVertex(ring[i], topH, ctx.origin, ctx.mLng, ctx.mLat));
                }
            }
            var vBase = ctx.vBase;
            var b = function (k) { return vBase + k + 1; };
            var t = function (k) { return vBase + n + k + 1; };
            if (solid) {
                var top = [], bottom = [];
                for (iw = 0; iw < n; iw++) {
                    top.push(t(iw));
                    bottom.push(b(n - 1 - iw)); // invertido -> normal hacia abajo
                }
                ctx.lines.push('f ' + top.join(' '));
                ctx.lines.push('f ' + bottom.join(' '));
                for (iw = 0; iw < n; iw++) {
                    j = (iw + 1) % n;
                    ctx.lines.push('f ' + b(iw) + ' ' + b(j) + ' ' + t(j) + ' ' + t(iw));
                }
                ctx.vBase += 2 * n;
            } else {
                var flat = [];
                for (iw = 0; iw < n; iw++) {
                    flat.push(b(iw));
                }
                ctx.lines.push('f ' + flat.join(' '));
                ctx.vBase += n;
            }
        }

        // Origen de proyeccion: centro de la vista guardada, o centroide de los datos
        function objOrigin(map, polys) {
            var c = map && map.view && map.view.center;
            if (angular.isArray(c) && c.length === 2) {
                return [c[0], c[1]];
            }
            var sx = 0, sy = 0, k = 0;
            polys.forEach(function (f) {
                outerRingsOf(f.geometry).forEach(function (ring) {
                    openRing(ring).forEach(function (p) {
                        sx += p[0]; sy += p[1]; k++;
                    });
                });
            });
            return k ? [sx / k, sy / k] : [0, 0];
        }

        function objVertex(lngLat, height, origin, mPerDegLng, mPerDegLat) {
            var x = (lngLat[0] - origin[0]) * mPerDegLng;
            var north = (lngLat[1] - origin[1]) * mPerDegLat;
            // Z = sur (-norte) para mantener mano derecha con Y arriba
            return 'v ' + objNum(x) + ' ' + objNum(height) + ' ' + objNum(-north);
        }

        // Anillo sin el punto de cierre duplicado
        function openRing(ring) {
            var pts = ring || [];
            if (pts.length > 1) {
                var a = pts[0], z = pts[pts.length - 1];
                if (a[0] === z[0] && a[1] === z[1]) {
                    pts = pts.slice(0, -1);
                }
            }
            return pts;
        }

        function ringSignedArea(ring) {
            var s = 0;
            for (var i = 0; i < ring.length; i++) {
                var a = ring[i], b = ring[(i + 1) % ring.length];
                s += (a[0] * b[1] - b[0] * a[1]);
            }
            return s / 2;
        }

        function objNum(n) {
            return (Math.round(n * 1000) / 1000).toString();
        }

        function objName(title, idx) {
            var name = String(title).replace(/[^\w.-]+/g, '_').replace(/^_+|_+$/g, '');
            return name || ('shape_' + (idx + 1));
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.maps')
        .directive('mapsEditor', mapsEditor);

    /** @ngInject */
    function mapsEditor() {
        return {
            restrict: 'E',
            scope: {
                // OJO: NO llamar este binding "map". ng-map registra una directiva
                // 'map' con restrict:'AE' que se activaria por el atributo map="..."
                // y montaria un Google Map encima (RefererNotAllowedMapError + crash).
                map: '=mapModel',
                siteId: '=',
                onSaved: '&',
                onClose: '&',
                fullscreen: '<',
                onFullscreen: '&'
            },
            templateUrl: 'app/main/apps/maps/maps-editor.html',
            controller: MapsEditorController,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    /** @ngInject */
    function MapsEditorController($scope, $element, $timeout, $q, $translate, $mdToast,
                                  $mdDialog, $http, mapboxLoader, mapsService,
                                  mapsStyleService, mediaService, sessionService, indexService) {
        var vm = this;

        var mapboxgl = null;
        var glMap = null;
        var glDraw = null;      // instancia de mapbox-gl-draw
        var MapboxDrawCtor = null;
        var markers = {};       // featureId -> mapboxgl.Marker (solo puntos)
        var featureSeq = 0;
        var ZONE_SOURCE = 'maps-zones';
        var DRAFT_SOURCE = 'maps-draft';        // lo que se esta dibujando ahora mismo
        var EDIT_SOURCE = 'maps-edit';          // figura en reforma + nodos y manejadores
        var editState = null;                   // sesion de reforma en curso
        var ZONE_3D_PREFIX = 'maps-zones-3d-';  // + bucket de opacidad (0..100 en pasos de 5)
        var extrusionHandlerIds = {};           // ids de capa 3D con handlers ya registrados
        var middleDragCleanup = null;           // quita los listeners del boton central
        var zoneTextures = {};                  // url de textura -> id de imagen en el sprite
        var zoneTextureSeq = 0;
        // Alto REAL (m) de cada objeto 3D, medido de su geometria al cargarla. Se guarda
        // aparte (no en properties) para no persistir datos derivados en map_features.
        var modelHeights = {};
        var dragZone = null;        // estado del arrastre de una zona entera
        var circleDrag = null;      // estado del dibujo de un circulo
        var freehandDrag = null;    // estado del trazo a mano alzada (curvas)
        var pendingShapeFor = null; // zona que recibira la SIGUIENTE figura dibujada
        var touchTap = null;        // estado de un "tap" tactil (crear pin/circulo en movil)
        var lastToolTouch = 0;      // ts del ultimo tap tactil (ignora el click sintetico)
        var CARD_BASE_OFFSET = 10;  // px que el cartel flota por encima del punto
        var OPENFREEMAP_DEFAULT = 'https://tiles.openfreemap.org/styles/liberty';
        // TileJSON de los vector tiles de OpenFreeMap (para el export .obj)
        var OPENFREEMAP_TILEJSON = 'https://tiles.openfreemap.org/planet';
        var currentProvider = null; // proveedor del mapa REALMENTE cargado (para detectar cambios)
        var modelSeq = 0;           // id incremental de capas de modelo 3D
        var modelLayers = {};       // featureId -> id de la capa custom del modelo
        var destroyed = false;  // el scope ya no existe: no crear nada
        var createTimer = null; // $timeout pendiente de createMap (evita doble init)
        var searchTimer = null; // debounce del geocoder
        var TRANSLATABLE_FIELDS = ['title', 'subtitle', 'description'];

        // ---- Historial (deshacer/rehacer) ----
        // Instantaneas del CONTENIDO del mapa (titulo + elementos + categorias) en
        // JSON. No entran ni el estilo ni los limites/vista: son ajustes, no dibujo,
        // y deshacerlos con Ctrl+Z al que esta colocando pins seria una sorpresa.
        var history = [];
        var historyIndex = -1;
        var historyTimer = null;      // agrupa la rafaga de cambios de un mismo gesto
        var restoringHistory = false; // los cambios de un undo no generan historial
        var historyKeysCleanup = null;
        var HISTORY_LIMIT = 60;
        var HISTORY_DEBOUNCE = 400;

        var clipboard = null;        // elemento copiado con Ctrl+C / Ctrl+X
        var lastMouseLngLat = null;  // ultimo punto del mapa bajo el raton (para pegar ahi)

        vm.status = 'idle';     // idle | loading | ready | no-token | error
        vm.tool = 'select';     // select | pin | zone | circle | freehand
        vm.selected = null;
        vm.dirty = false;
        vm.saving = false;
        // Pestana del panel de propiedades: content | languages | appearance
        vm.propsTab = 'content';

        // Centinela para "Sin categoria" en el md-select (null no es seleccionable
        // en Angular Material). vm.categoryChoice es el modelo del desplegable.
        vm.NO_CATEGORY = '__none__';
        vm.categoryChoice = vm.NO_CATEGORY;

        vm.searchQuery = '';
        vm.searchResults = [];
        vm.searching = false;

        vm.showCategories = false;

        vm.is3d = false;
        vm.editingShape = false;
        vm.addingShape = false; // la proxima figura se suma a la zona seleccionada

        vm.setTool = setTool;
        vm.editShape = editShape;
        vm.finishEditShape = finishEditShape;
        vm.addShapeToZone = addShapeToZone;
        vm.splitShapes = splitShapes;
        vm.shapeCount = shapeCount;
        vm.deleteNode = deleteNode;
        vm.toggleNodeCurve = toggleNodeCurveSelected;
        vm.hasSelectedNode = hasSelectedNode;
        vm.undo = undo;
        vm.redo = redo;
        vm.canUndo = canUndo;
        vm.canRedo = canRedo;
        vm.pickPhoto = pickPhoto;
        vm.onRadiusChanged = onRadiusChanged;
        vm.selectFeature = selectFeature;
        vm.deleteSelected = deleteSelected;
        vm.onFeatureChanged = onFeatureChanged;
        vm.save = save;
        vm.close = close;
        vm.markDirty = markDirty;
        vm.toggle3d = toggle3d;
        vm.toggleFullscreen = toggleFullscreen;
        vm.setStyle = setStyle;
        vm.openExportDialog = openExportDialog;
        vm.openStyleEditor = openStyleEditor;
        vm.openModelObject = openModelObject;
        vm.pickModelFile = pickModelFile;
        vm.reload3dObject = reload3dObject;
        vm.openImageObject = openImageObject;
        vm.pickImageForObject = pickImageForObject;
        vm.pickModelTexture = pickModelTexture;
        vm.clearModelTexture = clearModelTexture;
        vm.pickZoneTexture = pickZoneTexture;
        vm.clearZoneTexture = clearZoneTexture;
        vm.onZoneTextureScaleChanged = onZoneTextureScaleChanged;
        vm.fitImageToView = fitImageToView;
        vm.openMapSettings = openMapSettings;
        vm.onCoordsChanged = onCoordsChanged;
        vm.onOpacityChanged = onOpacityChanged;
        vm.resetOpacity = resetOpacity;
        vm.opacityLabel = opacityLabel;

        // ---- Traducciones (titulo/subtitulo/descripcion por idioma) ----
        // Los campos normales del elemento son el idioma BASE del tenant (el de menor
        // id_lang, que es el por defecto). El resto de idiomas vive en
        // properties.i18n[id_lang] = {title, subtitle, description}; si un idioma no
        // tiene texto, la web publica cae al base. Asi los mapas ya creados no cambian.
        vm.languages = [];          // idiomas traducibles (todos menos el base)
        vm.baseLanguage = null;
        vm.translationLangId = null;
        vm.aiTranslateEnabled = false;
        vm.translating = false;
        vm.translationProgress = {done: 0, total: 0};
        vm.translationField = {};   // getterSetters de los inputs (ng-model-options)
        vm.translationLangName = translationLangName;
        vm.hasTranslation = hasTranslation;
        vm.openAiTranslate = openAiTranslate;
        TRANSLATABLE_FIELDS.forEach(function (field) {
            vm.translationField[field] = function (value) {
                if (arguments.length) {
                    setTranslation(vm.selected, vm.translationLangId, field, value);
                    markDirty();
                }
                return getTranslation(vm.selected, vm.translationLangId, field);
            };
        });

        // Estilos base de OpenFreeMap (MapLibre). Se guardan en map_view.openfreemapStyle.
        var OFM_BASE_STYLES = [
            {id: 'https://tiles.openfreemap.org/styles/liberty',  name: 'MAPS.OFM_LIBERTY'},
            {id: 'https://tiles.openfreemap.org/styles/bright',   name: 'MAPS.OFM_BRIGHT'},
            {id: 'https://tiles.openfreemap.org/styles/positron', name: 'MAPS.OFM_POSITRON'}
        ];
        // Lista del selector = base + biblioteca (estilos guardados, id 'lib:<n>').
        vm.openfreemapStyles = OFM_BASE_STYLES.slice();
        var ofmLibrary = []; // estilos de la biblioteca {id, title, base, overrides}

        vm.search = search;
        vm.goToResult = goToResult;
        vm.clearSearch = clearSearch;
        // Categorias
        vm.toggleCategories = toggleCategories;
        vm.addCategory = addCategory;
        vm.removeCategory = removeCategory;
        vm.onCategoryColorChanged = onCategoryColorChanged;
        vm.setFeatureCategory = setFeatureCategory;
        vm.categoryColor = categoryColor;

        $scope.$watch(function () {
            return vm.map ? vm.map.id : null;
        }, function (id, previous) {
            if (id === previous && glMap) {
                return;
            }
            init();
        });

        // Al entrar/salir de pantalla completa cambia el tamano del contenedor:
        // Mapbox no lo detecta solo, hay que forzar resize tras el reflow.
        // Ademas marcamos el <body>: en pantalla completa el editor se dibuja con
        // z-index alto y los overlays de Material (select, dialog) se anclan al body
        // con z-index menor; la clase los eleva por encima mientras dura el fullscreen.
        $scope.$watch(function () {
            return vm.fullscreen;
        }, function (now, before) {
            setBodyFullscreen(!!now);
            if (now === before || !glMap) {
                return;
            }
            $timeout(function () {
                if (glMap) {
                    glMap.resize();
                }
            }, 60);
        });

        // Resalta la tarjeta del elemento seleccionado y sincroniza el selector de
        // categoria. md-select no permite seleccionar una md-option con valor null
        // (la trata como "sin seleccion"), asi que el desplegable usa un centinela
        // (vm.NO_CATEGORY) y aqui lo mapeamos desde la categoria real del elemento.
        $scope.$watch(function () {
            return vm.selected ? vm.selected.id : null;
        }, function (id) {
            angular.forEach(markers, function (marker, key) {
                var el = marker.getElement();
                if (el) {
                    el.classList.toggle('maps-card-selected', key === id);
                }
            });
            var cat = vm.selected && vm.selected.properties ? vm.selected.properties.category : null;
            vm.categoryChoice = (cat === null || cat === undefined) ? vm.NO_CATEGORY : cat;
        });

        registerHistoryKeys();

        $scope.$on('$destroy', function () {
            destroyed = true;
            setBodyFullscreen(false);
            if (historyKeysCleanup) {
                historyKeysCleanup();
                historyKeysCleanup = null;
            }
            if (historyTimer) {
                $timeout.cancel(historyTimer);
                historyTimer = null;
            }
            destroyMap();
        });

        function init() {
            destroyMap();
            // Aqui y no al construir el controller: en Angular 1.6 los bindings
            // (vm.siteId) aun no estan asignados en el constructor.
            if (!vm.baseLanguage) {
                loadLanguages();
            }
            vm.selected = null;
            vm.dirty = false;
            vm.tool = 'select';
            vm.editingShape = false;
            setPendingShape(null);
            // El mapa tal cual se abre es el punto al que devuelve el ultimo Ctrl+Z
            resetHistory();

            if (!vm.map || destroyed) {
                vm.status = 'idle';
                return;
            }

            // Solo usamos OpenFreeMap. Los mapas antiguos guardados como 'mapbox' se
            // migran a OpenFreeMap al abrirlos (y quedan asi al guardar).
            if (vm.map.view && vm.map.view.render !== 'openfreemap') {
                vm.map.view.render = 'openfreemap';
            }

            vm.status = 'loading';

            // Cargamos la biblioteca de estilos ANTES de crear el mapa: si el mapa usa
            // un estilo de biblioteca ('lib:<n>'), styleForProvider necesita resolverlo.
            loadOfmLibrary().then(function () {
                return mapboxLoader.load();
            }).then(function (gl) {
                if (destroyed) {
                    return;
                }
                mapboxgl = gl;
                return mapboxLoader.loadDraw();
            }).then(function (Draw) {
                if (destroyed || !mapboxgl) {
                    return;
                }
                MapboxDrawCtor = Draw;
                // El contenedor acaba de aparecer en el DOM: esperamos al siguiente ciclo
                // para que tenga alto real (si no Mapbox arranca con altura 0). Cancelamos
                // cualquier createMap ya encolado para no crear dos mapas en el contenedor.
                if (createTimer) {
                    $timeout.cancel(createTimer);
                }
                createTimer = $timeout(createMap);
            }, function () {
                vm.status = 'error';
            });
        }

        function createMap() {
            createTimer = null;
            if (destroyed || !vm.map) {
                return;
            }
            // Si ya hay un mapa vivo, lo retiramos antes de crear otro: nunca
            // deben coexistir dos canvases de Mapbox en el mismo contenedor.
            if (glMap) {
                destroyMap();
            }
            var container = $element[0].querySelector('.maps-editor-map');
            if (!container) {
                return;
            }

            var view = vm.map.view || {};
            currentProvider = 'openfreemap'; // unico motor de render

            // Limites de la vista (zoom/inclinacion/encuadre) configurables por mapa.
            var limits = readViewLimits(view);
            var mapOpts = {
                container: container,
                style: styleForProvider(view),
                center: view.center || [2.1734, 41.3851],
                zoom: angular.isNumber(view.zoom) ? view.zoom : 14,
                pitch: angular.isNumber(view.pitch) ? view.pitch : 0,
                bearing: angular.isNumber(view.bearing) ? view.bearing : 0,
                minZoom: limits.minZoom,
                maxZoom: limits.maxZoom,
                minPitch: limits.minPitch,
                maxPitch: limits.maxPitch
            };
            if (limits.maxBounds) {
                mapOpts.maxBounds = limits.maxBounds;
            }
            glMap = new mapboxgl.Map(mapOpts);

            // Abajo-izquierda: el panel de propiedades vive arriba-derecha y no debe taparlo.
            glMap.addControl(new mapboxgl.NavigationControl({visualizePitch: true}), 'bottom-left');
            applyRotationLock(limits.rotationLock);
            registerMiddleDragRotate();

            // Herramienta de dibujo (poligonos). Sin controles propios: la barra es la nuestra.
            glDraw = new MapboxDrawCtor({displayControlsDefault: false});
            glMap.addControl(glDraw);
            // draw solo se usa para DIBUJAR zonas nuevas. Reformarlas es cosa del
            // editor de nodos propio (editShape), que ademas maneja curvas.
            glMap.on('draw.create', onDrawCreate);

            glMap.on('load', function () {
                applyLightPreset(view.lightPreset);
                applyLibraryOverridesIfAny(); // overrides del estilo de biblioteca (OpenFreeMap)
                addZoneLayers();
                addDraftLayers();
                addEditLayers();
                registerZoneHandlers();
                renderFeatures();
                $scope.$applyAsync(function () {
                    vm.status = 'ready';
                    vm.is3d = glMap.getPitch() > 1;
                    // El panel de propiedades aparece con status 'ready' y cambia el
                    // ancho disponible; ademas el contenedor puede haber recibido su
                    // altura despues de crearse el mapa. Mapbox no lo detecta solo.
                    $timeout(function () {
                        if (glMap) {
                            glMap.resize();
                        }
                    });
                });
            });

            glMap.on('error', function (e) {
                // Solo es fatal durante la carga inicial. Con el mapa ya 'ready',
                // MapLibre/Mapbox emiten errores transitorios (tiles/sprites/glyphs,
                // sobre todo al cambiar de estilo) que NO deben tumbar el editor.
                if (vm.status === 'ready') {
                    if (e && e.error && window.console) {
                        window.console.warn('maps: error no fatal', e.error.message || e.error);
                    }
                    return;
                }
                $scope.$applyAsync(function () {
                    vm.status = 'error';
                });
            });

            glMap.on('click', function (e) {
                // En movil, el tap ya crea el pin (onToolTouchEnd); ignoramos el
                // click sintetico que dispara el navegador justo despues.
                if (Date.now() - lastToolTouch < 700) {
                    return;
                }
                if (vm.tool === 'pin') {
                    addPin([e.lngLat.lng, e.lngLat.lat]);
                }
            });

            // Circulo: clic-arrastra (centro -> radio). Solo raton (escritorio).
            glMap.on('mousedown', onCircleMouseDown);

            // Trazo libre (curvas): clic-arrastra siguiendo el contorno.
            glMap.on('mousedown', onFreehandDown);
            glMap.on('touchstart', onFreehandDown);

            // Tactil (movil): Mapbox no dispara mousedown/up y el click sintetico se
            // pierde si el dedo se mueve un poco. Gestionamos un "tap" propio para
            // crear pin o circulo (radio por defecto, se ajusta en el panel).
            glMap.on('touchstart', onToolTouchStart);
            glMap.on('touchmove', onToolTouchMove);
            glMap.on('touchend', onToolTouchEnd);

            // Nota: mover/zoom/inclinar ya NO marca el mapa como "sin guardar": la vista
            // inicial es explicita (boton "fijar vista inicial"), no la camara al guardar.

            // Reajustar la elevacion de los carteles de volumenes 3D al mover/zoom/inclinar
            glMap.on('move', updateCardLifts);

            // Donde esta el raton sobre el mapa: es donde cae lo que se pegue (Ctrl+V).
            glMap.on('mousemove', function (e) {
                lastMouseLngLat = [e.lngLat.lng, e.lngLat.lat];
            });
            glMap.on('mouseout', function () {
                lastMouseLngLat = null;
            });
        }

        // ---- Capas de zonas (poligonos: relleno 2D + volumen 3D) ----

        // Fuente + capas de zonas. Re-ejecutable: setStyle() borra fuentes/capas
        // (los marcadores DOM sobreviven), asi que se re-crean tras cambiar de estilo.
        function addZoneLayers() {
            if (glMap.getSource(ZONE_SOURCE)) {
                return;
            }
            glMap.addSource(ZONE_SOURCE, {type: 'geojson', data: zonesFC()});

            // Relleno plano (footprint). La opacidad viaja POR FEATURE (zonesFC resuelve
            // la propia del elemento o la del mapa). Dos capas: con textura (patron) y
            // sin ella (color), porque una figura que referencia una imagen inexistente
            // no se pinta.
            glMap.addLayer({
                id: 'maps-zones-fill',
                type: 'fill',
                source: ZONE_SOURCE,
                filter: ['!', ['has', 'pattern']],
                paint: {
                    'fill-color': ['get', 'color'],
                    'fill-opacity': ['get', 'fillOpacity']
                }
            });

            glMap.addLayer({
                id: 'maps-zones-fill-tex',
                type: 'fill',
                source: ZONE_SOURCE,
                filter: ['has', 'pattern'],
                paint: {
                    'fill-pattern': ['get', 'pattern'],
                    'fill-opacity': ['get', 'fillOpacity']
                }
            });

            // Contorno
            glMap.addLayer({
                id: 'maps-zones-line',
                type: 'line',
                source: ZONE_SOURCE,
                paint: {
                    'line-color': ['get', 'color'],
                    'line-width': 2
                }
            });

            // Volumenes 3D: una capa por cada opacidad en uso (ver extrusionBucket).
            syncExtrusionLayers();
            // El sprite se vacia al cambiar de estilo: recargar las texturas de zonas.
            zoneTextures = {};
            ensureZoneTextures();
        }

        // Crea (si faltan) las capas de extrusion necesarias: una por cada valor de
        // opacidad presente entre las zonas con altura. Cada capa se filtra por su
        // bucket y lleva su propia fill-extrusion-opacity (que no admite expresiones).
        function syncExtrusionLayers() {
            if (!glMap || !glMap.getSource(ZONE_SOURCE)) {
                return;
            }
            var defExtrusion = numOr((vm.map.view || {}).zoneExtrusionOpacity, 0.9);
            var buckets = {};
            collection().features.forEach(function (f) {
                if (isPolygonal(f) && (f.properties.height || 0) > 0) {
                    buckets[extrusionBucket(featureOpacity(f, defExtrusion))] = true;
                }
            });
            angular.forEach(buckets, function (unused, key) {
                // Por cada opacidad, dos capas: con textura (patron) y sin ella (color).
                addExtrusionLayer(ZONE_3D_PREFIX + key, Number(key), false);
                addExtrusionLayer(ZONE_3D_PREFIX + key + '-tex', Number(key), true);
            });
        }

        function addExtrusionLayer(id, bucket, textured) {
            if (glMap.getLayer(id)) {
                return;
            }
            var paint = {
                'fill-extrusion-height': ['get', 'height'],
                'fill-extrusion-base': 0,
                'fill-extrusion-opacity': bucket / 100
            };
            if (textured) {
                paint['fill-extrusion-pattern'] = ['get', 'pattern'];
            } else {
                paint['fill-extrusion-color'] = ['get', 'color'];
                // emissive-strength es de Mapbox Standard (sin esto las capas se ven
                // negras contra su luz 3D). MapLibre no lo soporta.
                if (!isOpenFreeMap()) {
                    paint['fill-extrusion-emissive-strength'] = 0.8;
                }
            }
            glMap.addLayer({
                id: id,
                type: 'fill-extrusion',
                source: ZONE_SOURCE,
                filter: ['all',
                    ['>', ['get', 'height'], 0],
                    ['==', ['get', 'opacityBucket'], bucket],
                    textured ? ['has', 'pattern'] : ['!', ['has', 'pattern']]
                ],
                paint: paint
            });
            registerExtrusionHandlers(id);
        }

        // Click/cursor sobre una capa de volumen 3D. Se registra una sola vez por id
        // (los listeners por id sobreviven a que la capa se borre y se recree).
        function registerExtrusionHandlers(layerId) {
            if (extrusionHandlerIds[layerId]) {
                return;
            }
            extrusionHandlerIds[layerId] = true;
            glMap.on('click', layerId, onZoneClick);
            glMap.on('mouseenter', layerId, setMoveCursor);
            glMap.on('mouseleave', layerId, clearCursor);
        }

        // Handlers ligados al id de capa: se registran UNA vez (persisten aunque
        // setStyle borre y recree la capa), no en addZoneLayers.
        function registerZoneHandlers() {
            // Dos capas de relleno: color plano y texturizada.
            ['maps-zones-fill', 'maps-zones-fill-tex'].forEach(function (layer) {
                glMap.on('click', layer, onZoneClick);
                glMap.on('mouseenter', layer, setMoveCursor);
                glMap.on('mouseleave', layer, clearCursor);
                // Arrastrar la zona entera (mousedown sobre el relleno)
                glMap.on('mousedown', layer, onZoneMouseDown);
            });
            // Los volumenes 3D tienen una capa por opacidad: sus handlers se registran
            // al crearlas (registerExtrusionHandlers).
        }

        // ---- Estilo del mapa y preset de luz ----

        // Unico motor de render: OpenFreeMap (MapLibre, libre, sin token).
        function renderProvider() {
            return 'openfreemap';
        }

        function isOpenFreeMap() {
            return true;
        }

        // URL del estilo del mapa. Si es un estilo de biblioteca ('lib:<n>') se usa su
        // base y los overrides se aplican en style.load (applyLibraryOverridesIfAny).
        function styleForProvider(view) {
            return resolveOfmStyleUrl(view.openfreemapStyle || OPENFREEMAP_DEFAULT);
        }

        // 'lib:<n>' -> URL base del estilo de biblioteca; si no, la propia URL.
        function resolveOfmStyleUrl(value) {
            var lib = findLibraryStyle(value);
            if (lib) {
                return lib.base || OPENFREEMAP_DEFAULT;
            }
            // 'lib:<n>' que no se pudo resolver (biblioteca no cargada) -> default seguro
            if (typeof value === 'string' && value.indexOf('lib:') === 0) {
                return OPENFREEMAP_DEFAULT;
            }
            return value || OPENFREEMAP_DEFAULT;
        }

        function findLibraryStyle(value) {
            if (typeof value !== 'string' || value.indexOf('lib:') !== 0) {
                return null;
            }
            var id = value.slice(4);
            for (var i = 0; i < ofmLibrary.length; i++) {
                if (String(ofmLibrary[i].id) === id) { return ofmLibrary[i]; }
            }
            return null;
        }

        // Aplica los overrides del estilo de biblioteca seleccionado (color + visibilidad)
        // sobre las capas ya cargadas del mapa (setPaint/LayoutProperty).
        function applyLibraryOverridesIfAny() {
            var lib = findLibraryStyle(vm.map.view && vm.map.view.openfreemapStyle);
            if (!lib || !lib.overrides || !glMap) {
                return;
            }
            angular.forEach(lib.overrides, function (o, layerId) {
                var layer = glMap.getLayer(layerId);
                if (!layer) { return; }
                try {
                    if (o.color) {
                        var prop = mapsStyleService.colorPropFor(layer.type);
                        if (prop) { glMap.setPaintProperty(layerId, prop, o.color); }
                    }
                    if (o.visibility) {
                        glMap.setLayoutProperty(layerId, 'visibility', o.visibility);
                    }
                } catch (e) {}
            });
        }

        // Carga la biblioteca de estilos y la mezcla en el selector (base + guardados).
        function loadOfmLibrary() {
            return mapsStyleService.getStyles(vm.siteId).then(function (list) {
                ofmLibrary = list || [];
                vm.openfreemapStyles = OFM_BASE_STYLES.concat(ofmLibrary.map(function (s) {
                    return {id: 'lib:' + s.id, name: s.title};
                }));
            }, angular.noop);
        }

        function setStyle(styleUrl) {
            if (!glMap || !styleUrl) {
                return;
            }
            vm.map.view = vm.map.view || {};
            vm.map.view.openfreemapStyle = styleUrl;
            // setStyle borra fuentes/capas propias: se re-crean al cargar el estilo.
            // diff:false fuerza recarga COMPLETA -> 'style.load' dispara siempre (con
            // diff, MapLibre quita nuestras capas sin recargar y no re-anadiriamos).
            glMap.setStyle(styleForProvider(vm.map.view), {diff: false});
            glMap.once('style.load', function () {
                addZoneLayers();
                addDraftLayers();
                addEditLayers();
                applyLibraryOverridesIfAny();  // overrides del estilo de biblioteca
                reAddModelLayers();            // setStyle descarto las capas 3D
            });
            markDirty();
        }

        function setMoveCursor() {
            // Con una herramienta de creacion activa la zona no se puede arrastrar:
            // el cursor no debe sugerir lo contrario.
            if (glMap && !vm.editingShape && !isCreatingTool()) {
                glMap.getCanvas().style.cursor = 'move';
            }
        }

        function clearCursor() {
            if (glMap && !dragZone) {
                // No borrar la cruz de dibujo al salir de una zona: la herramienta
                // sigue activa y el cursor debe seguir diciendo que se va a dibujar.
                applyToolCursor();
            }
        }

        // ---- Arrastrar una zona entera ----

        function onZoneMouseDown(e) {
            // Ademas de zona/circulo, tambien con el pin: al colocar un pin dentro de una
            // zona no se debe empezar a arrastrar la zona.
            if (vm.editingShape || isCreatingTool()) {
                return;
            }
            var id = e.features && e.features[0] && e.features[0].properties.id;
            var feature = findFeatureById(id);
            if (!feature) {
                return;
            }
            // Evita el paneo del mapa mientras arrastramos la zona
            e.preventDefault();
            dragZone = {feature: feature, last: e.lngLat, moved: false};
            glMap.getCanvas().style.cursor = 'grabbing';
            glMap.on('mousemove', onZoneMouseMove);
            glMap.once('mouseup', onZoneMouseUp);
        }

        function onZoneMouseMove(e) {
            if (!dragZone) {
                return;
            }
            var dx = e.lngLat.lng - dragZone.last.lng;
            var dy = e.lngLat.lat - dragZone.last.lat;
            dragZone.last = e.lngLat;
            dragZone.moved = true;
            translateFeature(dragZone.feature, dx, dy);
            refreshZones();
            if (markers[dragZone.feature.id]) {
                markers[dragZone.feature.id].setLngLat(labelLngLat(dragZone.feature));
            }
        }

        function onZoneMouseUp() {
            if (glMap) {
                glMap.off('mousemove', onZoneMouseMove);
                applyToolCursor();
            }
            var state = dragZone;
            dragZone = null;
            if (state) {
                $scope.$applyAsync(function () {
                    vm.selected = state.feature;
                    if (state.moved) {
                        markDirty();
                    }
                });
            }
        }

        // ---- Zonas de una o VARIAS formas (Polygon / MultiPolygon) ----
        //
        // Una zona puede ser un MultiPolygon: varias manchas separadas que son UN solo
        // elemento (una etiqueta, un color, una ficha). Es como se agrupan p.ej. los
        // tres modulos de un "Food Court" para no repetir el cartel tres veces.
        // Todo el editor trata las dos formas por igual gracias a estos helpers.

        function isPolygonal(feature) {
            var type = feature && feature.geometry && feature.geometry.type;
            return type === 'Polygon' || type === 'MultiPolygon';
        }

        // Formas de una geometria como lista de poligonos, y cada poligono como su
        // lista de anillos ([exterior, hueco, ...]). Polygon devuelve una; MultiPolygon,
        // las suyas. Devolver SIEMPRE lo mismo evita repetir el if en cada sitio.
        function polygonsOfGeometry(geometry) {
            if (!geometry || !angular.isArray(geometry.coordinates)) {
                return [];
            }
            if (geometry.type === 'MultiPolygon') {
                return geometry.coordinates;
            }
            return geometry.type === 'Polygon' ? [geometry.coordinates] : [];
        }

        // Numero de formas de un elemento (1 salvo multipoligono). La plantilla lo usa
        // para ofrecer "separar formas" solo cuando hay algo que separar.
        function shapeCount(feature) {
            return polygonsOfGeometry(feature && feature.geometry).length;
        }

        // Suma una forma (lista de anillos) a una zona, promocionando Polygon ->
        // MultiPolygon la primera vez. Un circulo deja de serlo al ganar una segunda
        // forma: su radio regenera TODA la geometria (onRadiusChanged) y se comeria
        // las demas partes, asi que se le quitan los datos de circulo.
        function appendPolygon(feature, rings) {
            var geometry = feature.geometry;
            if (geometry.type === 'Polygon') {
                geometry.type = 'MultiPolygon';
                geometry.coordinates = [geometry.coordinates];
            }
            geometry.coordinates.push(rings);

            var props = feature.properties || {};
            // Los nodos de curva van en paralelo a las formas: si la zona ya tenia,
            // la nueva entra como esquinas para que las dos listas sigan cuadrando (si
            // no cuadran se descartan enteras y se perderian las curvas ya hechas).
            if (props.nodes) {
                props.nodes.push(rings.map(function (ring) {
                    return openRingPoints(ring).map(function (p) {
                        return {p: [p[0], p[1]]};
                    });
                }));
            }
            if (props.shape === 'circle') {
                delete props.shape;
                delete props.center;
                delete props.radiusKm;
            }
        }

        // Mueve un elemento entero: vertices, nodos de curva y, si es un circulo, su
        // centro. Los tres tienen que viajar juntos; si los nodos se quedaran atras, al
        // volver a reformar la figura pegaria un salto a donde estaba antes.
        function translateFeature(feature, dx, dy) {
            translatePolygon(feature.geometry, dx, dy);
            var props = feature.properties || {};
            if (props.nodes) {
                translateNodes(props.nodes, dx, dy);
            }
            if (props.shape === 'circle' && props.center) {
                props.center = [props.center[0] + dx, props.center[1] + dy];
            }
        }

        function translateNodes(nodes, dx, dy) {
            nodes.forEach(function (rings) {
                rings.forEach(function (ring) {
                    ring.forEach(function (node) {
                        node.p = [node.p[0] + dx, node.p[1] + dy];
                        if (node.h1) { node.h1 = [node.h1[0] + dx, node.h1[1] + dy]; }
                        if (node.h2) { node.h2 = [node.h2[0] + dx, node.h2[1] + dy]; }
                    });
                });
            });
        }

        function translatePolygon(geometry, dx, dy) {
            if (geometry.type === 'MultiPolygon') {
                geometry.coordinates = geometry.coordinates.map(function (rings) {
                    return translateRings(rings, dx, dy);
                });
                return;
            }
            geometry.coordinates = translateRings(geometry.coordinates, dx, dy);
        }

        function translateRings(rings, dx, dy) {
            return rings.map(function (ring) {
                return ring.map(function (pt) {
                    return [pt[0] + dx, pt[1] + dy];
                });
            });
        }

        // ---- Zonas circulares (centro + radio) ----

        // Un circulo geografico es un poligono de N lados; guardamos center y
        // radiusKm en las propiedades para poder cambiar el radio despues.
        function circleRing(center, radiusKm, n) {
            n = n || 64;
            var lng = center[0], lat = center[1];
            var dLat = radiusKm / 110.574;
            var dLng = radiusKm / (111.320 * Math.cos(lat * Math.PI / 180));
            var ring = [];
            for (var i = 0; i <= n; i++) {
                var a = 2 * Math.PI * i / n;
                ring.push([lng + dLng * Math.cos(a), lat + dLat * Math.sin(a)]);
            }
            return [ring];
        }

        // Distancia aproximada en km entre dos [lng,lat] (equirectangular, basta a esta escala)
        function kmDistance(a, b) {
            var dLat = (b[1] - a[1]) * 110.574;
            var dLng = (b[0] - a[0]) * 111.320 * Math.cos(a[1] * Math.PI / 180);
            return Math.sqrt(dLat * dLat + dLng * dLng);
        }

        function onCircleMouseDown(e) {
            if (vm.tool !== 'circle') {
                return;
            }
            e.preventDefault(); // no panear mientras se dibuja
            featureSeq++;
            var firstCat = (vm.map.categories && vm.map.categories[0]) || null;
            var center = [e.lngLat.lng, e.lngLat.lat];
            var feature = {
                type: 'Feature',
                id: 'c' + featureSeq + '_' + collection().features.length,
                geometry: {type: 'Polygon', coordinates: circleRing(center, 0.05)},
                properties: {
                    kind: 'zone',
                    shape: 'circle',
                    center: center,
                    radiusKm: 0.05,
                    title: $translate.instant('MAPS.NEW_CIRCLE'),
                    category: firstCat ? firstCat.id : null,
                    color: firstCat ? firstCat.color : '#2F6FE6',
                    height: 0,
                    subtitle: '',
                    description: ''
                }
            };
            collection().features.push(feature);
            refreshZones();
            addLabel(feature);
            circleDrag = {feature: feature, center: center};
            glMap.on('mousemove', onCircleMouseMove);
            glMap.once('mouseup', onCircleMouseUp);
        }

        function onCircleMouseMove(e) {
            if (!circleDrag) {
                return;
            }
            var r = kmDistance(circleDrag.center, [e.lngLat.lng, e.lngLat.lat]);
            circleDrag.feature.properties.radiusKm = r;
            circleDrag.feature.geometry.coordinates = circleRing(circleDrag.center, r);
            refreshZones();
        }

        function onCircleMouseUp() {
            if (glMap) {
                glMap.off('mousemove', onCircleMouseMove);
            }
            var state = circleDrag;
            circleDrag = null;
            if (!state) {
                return;
            }
            // Radio minimo si apenas se arrastro
            if (state.feature.properties.radiusKm < 0.02) {
                state.feature.properties.radiusKm = 0.2;
                state.feature.geometry.coordinates = circleRing(state.center, 0.2);
                refreshZones();
            }
            $scope.$applyAsync(function () {
                vm.selected = state.feature;
                vm.tool = 'select';
                markDirty();
            });
        }

        // Crea un circulo con radio por defecto en un punto (usado por el tap tactil).
        // El usuario ajusta el radio despues con el campo "Radio (km)" del panel.
        function addCircleAt(center) {
            featureSeq++;
            var firstCat = (vm.map.categories && vm.map.categories[0]) || null;
            var feature = {
                type: 'Feature',
                id: 'c' + featureSeq + '_' + collection().features.length,
                geometry: {type: 'Polygon', coordinates: circleRing(center, 0.2)},
                properties: {
                    kind: 'zone',
                    shape: 'circle',
                    center: center,
                    radiusKm: 0.2,
                    title: $translate.instant('MAPS.NEW_CIRCLE'),
                    category: firstCat ? firstCat.id : null,
                    color: firstCat ? firstCat.color : '#2F6FE6',
                    height: 0,
                    subtitle: '',
                    description: ''
                }
            };
            collection().features.push(feature);
            refreshZones();
            addLabel(feature);
            $scope.$applyAsync(function () {
                vm.selected = feature;
                vm.tool = 'select';
                markDirty();
            });
        }

        // ---- Trazo libre: zonas con contorno curvo ----
        //
        // El dibujo por vertices (draw_polygon) solo hace rectas, asi que una plaza
        // redondeada o el borde de una dársena habia que aproximarlos a base de clics.
        // Aqui se arrastra siguiendo el contorno y el trazo se convierte en zona.
        //
        // El trazo crudo trae un punto por cada pixel movido (cientos): se simplifica
        // con Ramer-Douglas-Peucker EN PIXELES (la tolerancia asi es la misma se este
        // donde se este del mundo y al zoom que sea) para que quede una figura con
        // vertices manejables, que luego se pueda reformar como cualquier otra.
        var FREEHAND_MIN_STEP_PX = 3;    // muestreo: por debajo de esto no anotamos punto
        var FREEHAND_TOLERANCE_PX = 2.5; // simplificacion del trazo

        function onFreehandDown(e) {
            // Re-entrada: en tactil el touchstart va seguido de un mousedown sintetico
            // y entrariamos dos veces, dejando el primer trazo huerfano.
            if (vm.tool !== 'freehand' || !glMap || !e.point || freehandDrag) {
                return;
            }
            // Pellizco para zoom: no es un trazo
            if (e.points && e.points.length > 1) {
                return;
            }
            // Corta el paneo SOLO para este gesto, igual que hace el circulo. Antes se
            // apagaba glMap.dragPan y se volvia a encender al soltar: si el gesto se
            // entraba dos veces, el segundo lo veia ya apagado y no lo reactivaba nadie
            // -> el mapa se quedaba sin arrastre para el resto de la sesion.
            e.preventDefault();

            var doc = $element[0].ownerDocument;
            freehandDrag = {
                points: [{x: e.point.x, y: e.point.y, lngLat: [e.lngLat.lng, e.lngLat.lat]}],
                doc: doc
            };
            drawFreehandDraft(freehandDrag.points);

            glMap.on('mousemove', onFreehandMove);
            glMap.on('touchmove', onFreehandMove);
            // El final del gesto se escucha en el DOCUMENTO, no en el mapa: soltando
            // fuera del canvas (algo normal trazando pegado al borde) el mapa no
            // emitiria mouseup y el trazo se quedaria a medias.
            doc.addEventListener('mouseup', onFreehandUp, true);
            doc.addEventListener('touchend', onFreehandUp, true);
            doc.addEventListener('touchcancel', onFreehandUp, true);
        }

        function releaseFreehand(state) {
            if (glMap) {
                glMap.off('mousemove', onFreehandMove);
                glMap.off('touchmove', onFreehandMove);
            }
            state.doc.removeEventListener('mouseup', onFreehandUp, true);
            state.doc.removeEventListener('touchend', onFreehandUp, true);
            state.doc.removeEventListener('touchcancel', onFreehandUp, true);
            clearDraft();
        }

        function onFreehandMove(e) {
            if (!freehandDrag || !e.point) {
                return;
            }
            var last = freehandDrag.points[freehandDrag.points.length - 1];
            var dx = e.point.x - last.x;
            var dy = e.point.y - last.y;
            if (Math.sqrt(dx * dx + dy * dy) < FREEHAND_MIN_STEP_PX) {
                return;
            }
            freehandDrag.points.push({x: e.point.x, y: e.point.y, lngLat: [e.lngLat.lng, e.lngLat.lat]});
            // El trazo se pinta en la capa de borrador, que solo contiene ESTA figura.
            // Antes se metia en el modelo y se llamaba a refreshZones() en cada muestra,
            // que recorre todos los elementos del mapa, recalcula texturas y opacidades
            // y re-crea las capas 3D: con un mapa poblado, el trazo iba a tirones.
            drawFreehandDraft(freehandDrag.points);
        }

        function onFreehandUp() {
            var state = freehandDrag;
            freehandDrag = null;
            if (!state) {
                return;
            }
            releaseFreehand(state);

            // Un clic suelto (sin arrastrar) no es una figura
            var simplified = simplifyPoints(state.points, FREEHAND_TOLERANCE_PX);
            if (simplified.length < 3) {
                return;
            }

            var feature = createZoneFeature([closedRing(simplified)]);
            collection().features.push(feature);
            refreshZones();   // una sola vez, al terminar
            addLabel(feature);

            $scope.$applyAsync(function () {
                vm.selected = feature;
                vm.tool = 'select';
                applyToolCursor();
                markDirty();
            });
        }

        // ---- Capa de borrador: lo que se esta dibujando, aparte del modelo ----

        function addDraftLayers() {
            if (!glMap || glMap.getSource(DRAFT_SOURCE)) {
                return;
            }
            glMap.addSource(DRAFT_SOURCE, {type: 'geojson', data: emptyFC()});
            glMap.addLayer({
                id: 'maps-draft-fill',
                type: 'fill',
                source: DRAFT_SOURCE,
                paint: {'fill-color': '#2F6FE6', 'fill-opacity': 0.18}
            });
            glMap.addLayer({
                id: 'maps-draft-line',
                type: 'line',
                source: DRAFT_SOURCE,
                paint: {'line-color': '#2F6FE6', 'line-width': 2}
            });
        }

        function emptyFC() {
            return {type: 'FeatureCollection', features: []};
        }

        function setDraft(geometry) {
            if (!glMap || !glMap.getSource(DRAFT_SOURCE)) {
                return;
            }
            glMap.getSource(DRAFT_SOURCE).setData(geometry
                ? {type: 'FeatureCollection', features: [{type: 'Feature', properties: {}, geometry: geometry}]}
                : emptyFC());
        }

        function clearDraft() {
            setDraft(null);
        }

        // Con menos de tres puntos aun no hay poligono valido: se muestra la linea,
        // para que el trazo se vea desde el primer milimetro y no aparezca de golpe.
        function drawFreehandDraft(points) {
            var coords = points.map(function (p) { return p.lngLat; });
            if (coords.length < 2) {
                return;
            }
            setDraft(coords.length < 3
                ? {type: 'LineString', coordinates: coords}
                : {type: 'Polygon', coordinates: [coords.concat([coords[0]])]});
        }

        // El cursor dice que va a pasar al pulsar: cruz para dibujar, normal para el resto.
        function applyToolCursor() {
            if (!glMap) {
                return;
            }
            glMap.getCanvas().style.cursor = isCreatingTool() ? 'crosshair' : '';
        }

        // Anillo cerrado (primer punto repetido al final) a partir de los puntos del trazo
        function closedRing(points) {
            var ring = points.map(function (p) {
                return p.lngLat;
            });
            ring.push(ring[0].slice());
            return ring;
        }

        // Ramer-Douglas-Peucker sobre las coordenadas en PIXELES: se queda con los
        // puntos que de verdad definen la silueta y tira los intermedios que caen
        // (casi) sobre la recta que une a sus vecinos.
        function simplifyPoints(points, tolerancePx) {
            if (points.length < 3) {
                return points.slice();
            }
            var keep = new Array(points.length);
            keep[0] = true;
            keep[points.length - 1] = true;
            simplifySegment(points, 0, points.length - 1, tolerancePx, keep);
            return points.filter(function (unused, i) {
                return keep[i];
            });
        }

        function simplifySegment(points, first, last, tolerancePx, keep) {
            var maxDist = -1;
            var index = -1;
            for (var i = first + 1; i < last; i++) {
                var d = pointToSegmentPx(points[i], points[first], points[last]);
                if (d > maxDist) {
                    maxDist = d;
                    index = i;
                }
            }
            if (maxDist <= tolerancePx || index < 0) {
                return;
            }
            keep[index] = true;
            simplifySegment(points, first, index, tolerancePx, keep);
            simplifySegment(points, index, last, tolerancePx, keep);
        }

        function pointToSegmentPx(p, a, b) {
            var vx = b.x - a.x, vy = b.y - a.y;
            var wx = p.x - a.x, wy = p.y - a.y;
            var len2 = vx * vx + vy * vy;
            // Segmento degenerado (a == b): la distancia es la del punto a ese vertice
            var t = len2 ? Math.max(0, Math.min(1, (wx * vx + wy * vy) / len2)) : 0;
            var dx = wx - t * vx;
            var dy = wy - t * vy;
            return Math.sqrt(dx * dx + dy * dy);
        }

        // ---- Gestos tactiles (movil): crear pin / circulo con un "tap" ----

        function onToolTouchStart(e) {
            // pin/circle: crear · select: seleccionar el poligono bajo el dedo
            if (vm.tool !== 'pin' && vm.tool !== 'circle' && vm.tool !== 'select') {
                touchTap = null;
                return;
            }
            // Multi-touch = pellizco para zoom: no es un tap
            if (e.points && e.points.length > 1) {
                touchTap = null;
                return;
            }
            touchTap = {
                lngLat: [e.lngLat.lng, e.lngLat.lat],
                x: e.point.x,
                y: e.point.y,
                moved: false
            };
        }

        function onToolTouchMove(e) {
            if (!touchTap) {
                return;
            }
            // Si el dedo se desplaza mas que el umbral, fue un paneo, no un tap
            var p = e.point;
            if (p) {
                var dx = p.x - touchTap.x;
                var dy = p.y - touchTap.y;
                if (Math.sqrt(dx * dx + dy * dy) > 12) {
                    touchTap.moved = true;
                }
            }
        }

        function onToolTouchEnd(e) {
            if (!touchTap) {
                return;
            }
            var tap = touchTap;
            touchTap = null;
            if (tap.moved) {
                return; // fue un paneo del mapa
            }
            if (vm.tool === 'pin') {
                // Evita el click sintetico posterior (no duplicar el pin)
                if (e.preventDefault) { e.preventDefault(); }
                lastToolTouch = Date.now();
                addPin(tap.lngLat);
            } else if (vm.tool === 'circle') {
                if (e.preventDefault) { e.preventDefault(); }
                lastToolTouch = Date.now();
                addCircleAt(tap.lngLat);
            } else if (vm.tool === 'select') {
                // Seleccionar la zona/circulo bajo el dedo (el click de capa se
                // pierde en tactil si el dedo se mueve algo; el tap lo tolera).
                selectZoneAtPoint(tap.x, tap.y);
            }
        }

        // Selecciona el poligono (zona/circulo) renderizado en un punto en pixeles.
        function selectZoneAtPoint(x, y) {
            if (!glMap) {
                return;
            }
            var layers = [];
            ['maps-zones-fill', 'maps-zones-fill-tex'].forEach(function (id) {
                if (glMap.getLayer(id)) { layers.push(id); }
            });
            // Volumenes 3D: una capa por opacidad (solo las que existan ahora mismo)
            angular.forEach(extrusionHandlerIds, function (unused, id) {
                if (glMap.getLayer(id)) { layers.push(id); }
            });
            if (!layers.length) {
                return;
            }
            var hits = glMap.queryRenderedFeatures(
                [[x - 6, y - 6], [x + 6, y + 6]],
                {layers: layers}
            );
            if (hits && hits.length) {
                var feature = findFeatureById(hits[0].properties.id);
                if (feature) {
                    $scope.$applyAsync(function () {
                        vm.selected = feature;
                    });
                }
            }
        }

        // Cambiar el radio desde el campo de propiedades regenera el circulo
        function onRadiusChanged() {
            if (!vm.selected || vm.selected.properties.shape !== 'circle') {
                return;
            }
            var r = parseFloat(vm.selected.properties.radiusKm) || 0.05;
            vm.selected.geometry.coordinates = circleRing(vm.selected.properties.center, r);
            // La circunferencia se regenera entera: unos nodos de curva de un radio
            // anterior no describen ya esta figura y harian saltar la forma al reformar.
            delete vm.selected.properties.nodes;
            refreshZones();
            markDirty();
        }

        // FeatureCollection solo con los poligonos (zonas/volumenes).
        // La zona en reforma se oculta (la pinta draw mientras se edita).
        // Opacidad PROPIA del elemento (properties.opacity, 0-100). Si no tiene, se usa
        // la del mapa (config general) segun sea relleno plano o volumen 3D.
        function featureOpacity(feature, mapDefault01) {
            var o = feature && feature.properties ? feature.properties.opacity : null;
            if (o === null || o === undefined || o === '') {
                return mapDefault01;
            }
            var n = Number(o) / 100;
            if (isNaN(n)) { return mapDefault01; }
            return Math.min(1, Math.max(0, n));
        }

        // Opacidad del elemento seleccionado: al mover el slider se guarda en el propio
        // feature; si no tiene valor, hereda la opacidad general del mapa.
        function onOpacityChanged() {
            if (!vm.selected) { return; }
            if (isPolygonal(vm.selected)) {
                refreshZones();
            }
            if (is3dObject(vm.selected) && glMap) {
                glMap.triggerRepaint();
            }
            markDirty();
        }

        // Vuelve a "heredado": quita la opacidad propia y manda la general del mapa.
        function resetOpacity() {
            if (!vm.selected || !vm.selected.properties) { return; }
            delete vm.selected.properties.opacity;
            onOpacityChanged();
        }

        // Texto del slider: el % propio o "Heredada" si usa la del mapa.
        function opacityLabel() {
            var p = vm.selected && vm.selected.properties;
            var o = p ? p.opacity : null;
            if (o === null || o === undefined || o === '') {
                return $translate.instant('MAPS.OPACITY_INHERITED');
            }
            return Math.round(Number(o)) + '%';
        }

        // Aplica la opacidad propia del elemento a los materiales de un objeto 3D. Se
        // llama en cada frame pero solo toca el material cuando el valor ha cambiado.
        function applyMaterialOpacity(materials, feature) {
            if (!materials || !materials.length) { return; }
            var op = featureOpacity(feature, 1);
            for (var i = 0; i < materials.length; i++) {
                var m = materials[i];
                if (m.opacity !== op) {
                    m.opacity = op;
                    if (op < 1 && !m.transparent) {
                        m.transparent = true;
                        m.needsUpdate = true;
                    }
                }
            }
        }

        // Opacidad de un volumen 3D -> "bucket" 0..100 en pasos de 5.
        // fill-extrusion-opacity es data-constant (solo zoom): NO admite expresiones por
        // feature. Y meter el alpha en fill-extrusion-color no vale: no da transparencia,
        // multiplica el RGB y oscurece la figura hasta negro. Por eso creamos UNA CAPA
        // de extrusion por cada valor de opacidad en uso, filtrada por este bucket.
        function extrusionBucket(opacity01) {
            return Math.round(opacity01 * 20) * 5;
        }

        // Tamano de la textura de una zona, en % del natural (100 = tal cual).
        function zoneTextureScale(feature) {
            var s = feature.properties && feature.properties.textureScale;
            var n = Number(s);
            if (!s || isNaN(n) || n <= 0) { return 100; }
            return Math.min(400, Math.max(25, Math.round(n)));
        }

        // Cada combinacion imagen+tamano es una entrada distinta del sprite.
        function zoneTextureKey(url, scalePct) {
            return url + '@' + scalePct;
        }

        // Id de la textura de una zona en el sprite del mapa, SOLO si ya esta cargada
        // (si se referencia una imagen que aun no existe, la figura no se pinta).
        function zonePatternId(feature) {
            var url = feature.properties && feature.properties.textureUrl;
            if (!url || !glMap) { return null; }
            var id = zoneTextures[zoneTextureKey(url, zoneTextureScale(feature))];
            return (id && glMap.hasImage && glMap.hasImage(id)) ? id : null;
        }

        function zonesFC() {
            var v = vm.map.view || {};
            var defFill = numOr(v.zoneFillOpacity, 0.35);
            var defExtrusion = numOr(v.zoneExtrusionOpacity, 0.9);
            var feats = collection().features.filter(function (f) {
                return isPolygonal(f)
                    && !(vm.editingShape && f.id === (vm.selected && vm.selected.id));
            }).map(function (f) {
                var props = {
                    id: f.id,
                    color: f.properties.color || '#2F6FE6',
                    height: f.properties.height || 0,
                    fillOpacity: featureOpacity(f, defFill),
                    opacityBucket: extrusionBucket(featureOpacity(f, defExtrusion))
                };
                // 'pattern' solo existe si la zona tiene textura YA cargada: las capas
                // se separan con ['has','pattern'] (con textura) / ['!',...] (color).
                var pattern = zonePatternId(f);
                if (pattern) { props.pattern = pattern; }
                return {type: 'Feature', id: f.id, geometry: f.geometry, properties: props};
            });
            return {type: 'FeatureCollection', features: feats};
        }

        // Carga en el sprite del mapa las texturas de las zonas que aun no esten.
        // Al terminar cada una, repinta para que el patron entre en juego.
        function ensureZoneTextures() {
            if (!glMap) { return; }
            var wanted = {};
            collection().features.forEach(function (f) {
                if (isPolygonal(f) && f.properties.textureUrl) {
                    var scalePct = zoneTextureScale(f);
                    wanted[zoneTextureKey(f.properties.textureUrl, scalePct)] = {
                        url: f.properties.textureUrl,
                        scalePct: scalePct
                    };
                }
            });
            angular.forEach(wanted, function (info, key) {
                if (zoneTextures[key]) { return; }
                var id = 'qiu-zone-tex-' + (zoneTextureSeq++);
                zoneTextures[key] = id; // se reserva ya para no cargarla dos veces
                loadCorsImage(info.url, function (img) {
                    if (!glMap) { return; }
                    try {
                        // pixelRatio controla el tamano del patron en pantalla:
                        // tamano = pixeles de la imagen / pixelRatio. Es la unica palanca
                        // de escala que ofrece MapLibre para los patrones.
                        if (!glMap.hasImage(id)) {
                            glMap.addImage(id, img, {pixelRatio: 100 / info.scalePct});
                        }
                    } catch (e) { /* imagen no valida para el sprite */ }
                    refreshZones();
                }, function () {
                    delete zoneTextures[key]; // reintentara en el proximo refresh
                });
            });
        }

        function refreshZones() {
            if (glMap && glMap.getSource(ZONE_SOURCE)) {
                glMap.getSource(ZONE_SOURCE).setData(zonesFC());
                // Puede haber aparecido una opacidad nueva -> su capa 3D
                syncExtrusionLayers();
                // ...o una textura nueva que aun no este en el sprite
                ensureZoneTextures();
            }
        }

        // Con una herramienta de CREACION activa (pin/zona/circulo) el clic sirve para
        // crear, no para seleccionar: si no, al pinchar dentro de una zona existente se
        // seleccionaba esa zona y era imposible dibujar encima de otra.
        function isCreatingTool() {
            return vm.tool === 'pin' || vm.tool === 'zone'
                || vm.tool === 'circle' || vm.tool === 'freehand';
        }

        function onZoneClick(e) {
            if (vm.editingShape || isCreatingTool() || !e.features || !e.features.length) {
                return;
            }
            var id = e.features[0].properties.id;
            var feature = findFeatureById(id);
            if (feature) {
                $scope.$applyAsync(function () {
                    vm.selected = feature;
                });
            }
        }

        function findFeatureById(id) {
            var feats = collection().features;
            for (var i = 0; i < feats.length; i++) {
                if (feats[i].id === id) {
                    return feats[i];
                }
            }
            return null;
        }

        // mapbox-gl-draw termina un poligono: lo pasamos a NUESTRO modelo y lo
        // sacamos de draw (draw solo se usa para dibujar/editar, no para pintar).
        function onDrawCreate(e) {
            var drawn = e.features && e.features[0];
            if (!drawn) {
                return;
            }
            glDraw.delete(drawn.id);

            // "Anadir forma": la figura recien dibujada se suma a una zona existente
            // en vez de nacer como elemento aparte (ver addShapeToZone).
            var target = pendingShapeFor;
            setPendingShape(null);
            if (target && isPolygonal(target) && collection().features.indexOf(target) > -1) {
                appendPolygon(target, drawn.geometry.coordinates);
                refreshZones();
                if (markers[target.id]) {
                    markers[target.id].setLngLat(labelLngLat(target));
                }
                $scope.$applyAsync(function () {
                    vm.selected = target;
                    vm.tool = 'select';
                    markDirty();
                });
                return;
            }

            var feature = createZoneFeature(drawn.geometry.coordinates);
            collection().features.push(feature);
            refreshZones();
            addLabel(feature);

            $scope.$applyAsync(function () {
                vm.selected = feature;
                vm.tool = 'select';
                markDirty();
            });
        }

        // Zona nueva a partir de sus anillos. Comun al dibujo por vertices, al trazo
        // libre y a la separacion de un multipoligono, para que las tres salgan con
        // las mismas propiedades por defecto.
        function createZoneFeature(rings) {
            featureSeq++;
            var firstCat = (vm.map.categories && vm.map.categories[0]) || null;
            return {
                type: 'Feature',
                id: 'z' + featureSeq + '_' + collection().features.length,
                geometry: {type: 'Polygon', coordinates: rings},
                properties: {
                    kind: 'zone',
                    title: $translate.instant('MAPS.NEW_ZONE'),
                    category: firstCat ? firstCat.id : null,
                    color: firstCat ? firstCat.color : '#2F6FE6',
                    height: 0,
                    subtitle: '',
                    description: ''
                }
            };
        }

        // Quita un elemento del modelo (y su cartel/capa 3D si los tiene).
        function removeFeature(feature) {
            var features = collection().features;
            var index = features.indexOf(feature);
            if (index > -1) {
                features.splice(index, 1);
            }
            dropVisuals(feature);
        }

        // ---- Reforma de una zona: nodos y manejadores de curva ----
        //
        // Editor de trazado propio, al estilo de la pluma de Photoshop/Illustrator, en
        // lugar del direct_select de mapbox-gl-draw (que solo mueve vertices rectos).
        //
        // El modelo de edicion son NODOS: cada uno tiene su punto de anclaje y, si es
        // curvo, dos manejadores (h1 el que llega, h2 el que sale). Entre dos nodos hay
        // una bezier cubica cuyos puntos de control son A.h2 y B.h1; si ninguno de los
        // dos existe, el tramo es una recta.
        //
        // Los nodos viven en properties.nodes, pero la geometria del elemento sigue
        // siendo un poligono normal con la curva ya "planchada" en vertices. Asi la web
        // publica, el volumen 3D, las texturas y el export .obj no se enteran de nada:
        // siguen viendo un poligono corriente.
        var CURVE_STEPS = 14;      // vertices por tramo curvo al planchar
        var HIT_TOLERANCE_PX = 8;  // margen de clic sobre nodos y manejadores

        function editShape() {
            if (!vm.selected || !isPolygonal(vm.selected) || !glMap) {
                return;
            }
            editState = {
                feature: vm.selected,
                nodes: nodesOfFeature(vm.selected),
                selected: null,
                drag: null
            };
            vm.editingShape = true;

            // La zona sale de las capas normales: mientras se edita la pinta la capa de
            // borrador, que solo tiene esta figura y se repinta en O(1) por movimiento.
            refreshZones();
            if (markers[vm.selected.id]) {
                markers[vm.selected.id].getElement().style.display = 'none';
            }
            renderEditState();

            glMap.on('mousedown', onEditMouseDown);
            glMap.getCanvas().style.cursor = 'default';
        }

        // Nodos de un elemento: los guardados si siguen encajando con su geometria, y
        // si no, unos nuevos deducidos de los vertices (todos esquinas, sin curva).
        // Reconstruir es lo correcto cuando la figura se ha tocado por otra via (trazo
        // libre, separar formas, deshacer): los nodos viejos serian de otra figura.
        function nodesOfFeature(feature) {
            var polygons = polygonsOfGeometry(feature.geometry);
            var saved = feature.properties && feature.properties.nodes;
            if (matchesGeometry(saved, polygons)) {
                return angular.fromJson(angular.toJson(saved));
            }
            return polygons.map(function (rings) {
                return rings.map(function (ring) {
                    return openRingPoints(ring).map(function (p) {
                        return {p: [p[0], p[1]]};
                    });
                });
            });
        }

        // Encajan si tienen la misma cantidad de formas y de anillos por forma. No se
        // comparan vertices: el numero cambia con la curvatura, que es justo lo que
        // estos nodos describen.
        function matchesGeometry(saved, polygons) {
            if (!angular.isArray(saved) || saved.length !== polygons.length) {
                return false;
            }
            return saved.every(function (rings, i) {
                return angular.isArray(rings) && rings.length === polygons[i].length
                    && rings.every(function (nodes) {
                        return angular.isArray(nodes) && nodes.length >= 3;
                    });
            });
        }

        function openRingPoints(ring) {
            var pts = (ring || []).slice();
            if (pts.length > 1) {
                var a = pts[0], z = pts[pts.length - 1];
                if (a[0] === z[0] && a[1] === z[1]) {
                    pts.pop();
                }
            }
            return pts;
        }

        // ---- Planchado: nodos -> vertices ----

        function flattenNodes(nodes) {
            return nodes.map(function (rings) {
                return rings.map(flattenRing);
            });
        }

        function flattenRing(ring) {
            var out = [];
            for (var i = 0; i < ring.length; i++) {
                var a = ring[i];
                var b = ring[(i + 1) % ring.length];
                out.push([a.p[0], a.p[1]]);
                if (!a.h2 && !b.h1) {
                    continue;   // tramo recto: basta con sus extremos
                }
                var c1 = a.h2 || a.p;
                var c2 = b.h1 || b.p;
                for (var s = 1; s < CURVE_STEPS; s++) {
                    out.push(cubicAt(a.p, c1, c2, b.p, s / CURVE_STEPS));
                }
            }
            out.push([out[0][0], out[0][1]]);   // cerrar el anillo
            return out;
        }

        function cubicAt(p0, p1, p2, p3, t) {
            var u = 1 - t;
            var a = u * u * u, b = 3 * u * u * t, c = 3 * u * t * t, d = t * t * t;
            return [
                a * p0[0] + b * p1[0] + c * p2[0] + d * p3[0],
                a * p0[1] + b * p1[1] + c * p2[1] + d * p3[1]
            ];
        }

        // Vuelca los nodos en la geometria del elemento y repinta la capa de edicion.
        function applyNodes() {
            var feature = editState.feature;
            var flat = flattenNodes(editState.nodes);
            if (feature.geometry.type === 'MultiPolygon') {
                feature.geometry.coordinates = flat;
            } else {
                feature.geometry.coordinates = flat[0];
            }
            // Curvar un circulo lo convierte en zona normal: su radio regenera toda la
            // geometria y se llevaria por delante lo que se acabe de dibujar.
            if (feature.properties && feature.properties.shape === 'circle') {
                delete feature.properties.shape;
                delete feature.properties.center;
                delete feature.properties.radiusKm;
            }
            renderEditState();
        }

        // ---- Pintado de la figura en edicion con sus nodos y manejadores ----

        function renderEditState() {
            if (!editState || !glMap || !glMap.getSource(EDIT_SOURCE)) {
                return;
            }
            var feature = editState.feature;
            var color = (feature.properties && feature.properties.color) || '#2F6FE6';
            var features = [{
                type: 'Feature',
                properties: {role: 'shape', color: color},
                geometry: {type: 'MultiPolygon', coordinates: flattenNodes(editState.nodes)}
            }];
            var sel = editState.selected;

            editState.nodes.forEach(function (rings, poly) {
                rings.forEach(function (ring, ringIdx) {
                    ring.forEach(function (node, idx) {
                        var isSel = !!sel && sel.poly === poly && sel.ring === ringIdx && sel.idx === idx;
                        features.push(point(node.p, {
                            role: 'anchor', poly: poly, ring: ringIdx, idx: idx, selected: isSel
                        }));
                        // Los manejadores solo se ven en el nodo seleccionado: con todos
                        // a la vez la figura se vuelve ilegible.
                        if (isSel) {
                            ['h1', 'h2'].forEach(function (which) {
                                if (!node[which]) {
                                    return;
                                }
                                features.push(point(node[which], {
                                    role: 'handle', poly: poly, ring: ringIdx, idx: idx, handle: which
                                }));
                                features.push({
                                    type: 'Feature',
                                    properties: {role: 'handle-line'},
                                    geometry: {type: 'LineString', coordinates: [node.p, node[which]]}
                                });
                            });
                        }
                        // Punto medio del tramo: clic ahi para insertar un nodo nuevo
                        var next = ring[(idx + 1) % ring.length];
                        features.push(point(segmentMidpoint(node, next), {
                            role: 'mid', poly: poly, ring: ringIdx, idx: idx
                        }));
                    });
                });
            });

            glMap.getSource(EDIT_SOURCE).setData({type: 'FeatureCollection', features: features});
        }

        function point(coordinates, properties) {
            return {
                type: 'Feature',
                properties: properties,
                geometry: {type: 'Point', coordinates: [coordinates[0], coordinates[1]]}
            };
        }

        function segmentMidpoint(a, b) {
            if (!a.h2 && !b.h1) {
                return [(a.p[0] + b.p[0]) / 2, (a.p[1] + b.p[1]) / 2];
            }
            return cubicAt(a.p, a.h2 || a.p, b.h1 || b.p, b.p, 0.5);
        }

        function addEditLayers() {
            if (!glMap || glMap.getSource(EDIT_SOURCE)) {
                return;
            }
            glMap.addSource(EDIT_SOURCE, {type: 'geojson', data: emptyFC()});
            glMap.addLayer({
                id: 'maps-edit-shape',
                type: 'fill',
                source: EDIT_SOURCE,
                filter: ['==', ['get', 'role'], 'shape'],
                paint: {'fill-color': ['get', 'color'], 'fill-opacity': 0.3}
            });
            glMap.addLayer({
                id: 'maps-edit-shape-line',
                type: 'line',
                source: EDIT_SOURCE,
                filter: ['==', ['get', 'role'], 'shape'],
                paint: {'line-color': ['get', 'color'], 'line-width': 2}
            });
            glMap.addLayer({
                id: 'maps-edit-handle-line',
                type: 'line',
                source: EDIT_SOURCE,
                filter: ['==', ['get', 'role'], 'handle-line'],
                paint: {'line-color': '#7A8CA3', 'line-width': 1}
            });
            glMap.addLayer({
                id: 'maps-edit-mid',
                type: 'circle',
                source: EDIT_SOURCE,
                filter: ['==', ['get', 'role'], 'mid'],
                paint: {
                    'circle-radius': 3.5,
                    'circle-color': '#FFFFFF',
                    'circle-opacity': 0.85,
                    'circle-stroke-width': 1,
                    'circle-stroke-color': '#7A8CA3'
                }
            });
            glMap.addLayer({
                id: 'maps-edit-handle',
                type: 'circle',
                source: EDIT_SOURCE,
                filter: ['==', ['get', 'role'], 'handle'],
                paint: {
                    'circle-radius': 5,
                    'circle-color': '#2F6FE6',
                    'circle-stroke-width': 1.5,
                    'circle-stroke-color': '#FFFFFF'
                }
            });
            glMap.addLayer({
                id: 'maps-edit-anchor',
                type: 'circle',
                source: EDIT_SOURCE,
                filter: ['==', ['get', 'role'], 'anchor'],
                paint: {
                    'circle-radius': 6,
                    'circle-color': ['case', ['get', 'selected'], '#2F6FE6', '#FFFFFF'],
                    'circle-stroke-width': 2,
                    'circle-stroke-color': '#2F6FE6'
                }
            });
        }

        // ---- Raton en modo reforma ----

        function editHitAt(point2d) {
            var box = [
                [point2d.x - HIT_TOLERANCE_PX, point2d.y - HIT_TOLERANCE_PX],
                [point2d.x + HIT_TOLERANCE_PX, point2d.y + HIT_TOLERANCE_PX]
            ];
            // Por orden de prioridad: el manejador esta encima del nodo, y el punto
            // medio es el ultimo recurso (es el mas grande de agarrar por accidente).
            var layers = ['maps-edit-handle', 'maps-edit-anchor', 'maps-edit-mid'];
            for (var i = 0; i < layers.length; i++) {
                if (!glMap.getLayer(layers[i])) {
                    continue;
                }
                var hits = glMap.queryRenderedFeatures(box, {layers: [layers[i]]});
                if (hits && hits.length) {
                    return hits[0].properties;
                }
            }
            return null;
        }

        function onEditMouseDown(e) {
            if (!editState || !e.point) {
                return;
            }
            var hit = editHitAt(e.point);
            if (!hit) {
                return;   // fuera de los nodos: que el mapa se panee con normalidad
            }
            e.preventDefault();
            var ref = {poly: hit.poly, ring: hit.ring, idx: hit.idx};
            var altKey = !!(e.originalEvent && e.originalEvent.altKey);

            if (hit.role === 'mid') {
                insertNodeAt(ref);
                ref = {poly: ref.poly, ring: ref.ring, idx: ref.idx + 1};
                editState.selected = ref;
                editState.drag = {type: 'anchor', ref: ref};
            } else if (hit.role === 'handle') {
                editState.drag = {type: 'handle', ref: ref, handle: hit.handle, breakMirror: altKey};
            } else {
                // Alt+clic sobre un nodo alterna esquina <-> curva sin arrastrar nada
                if (altKey) {
                    toggleNodeCurve(ref);
                    editState.selected = ref;
                    applyNodes();
                    $scope.$applyAsync(markDirty);
                    return;
                }
                editState.selected = ref;
                editState.drag = {type: 'anchor', ref: ref};
            }

            renderEditState();
            var doc = $element[0].ownerDocument;
            editState.drag.doc = doc;
            glMap.on('mousemove', onEditMouseMove);
            doc.addEventListener('mouseup', onEditMouseUp, true);
        }

        function onEditMouseMove(e) {
            if (!editState || !editState.drag || !e.lngLat) {
                return;
            }
            var drag = editState.drag;
            var node = nodeAt(drag.ref);
            if (!node) {
                return;
            }
            var to = [e.lngLat.lng, e.lngLat.lat];

            if (drag.type === 'anchor') {
                // El nodo se lleva sus manejadores: mover el ancla no deforma la curva.
                var dx = to[0] - node.p[0];
                var dy = to[1] - node.p[1];
                node.p = to;
                if (node.h1) { node.h1 = [node.h1[0] + dx, node.h1[1] + dy]; }
                if (node.h2) { node.h2 = [node.h2[0] + dx, node.h2[1] + dy]; }
            } else {
                node[drag.handle] = to;
                // Nodo suave: el manejador opuesto sigue en linea, conservando su largo.
                // Con Alt se rompe la simetria y cada lado va por su cuenta.
                var other = drag.handle === 'h1' ? 'h2' : 'h1';
                if (!drag.breakMirror && node[other]) {
                    node[other] = mirrorHandle(node.p, to, node[other]);
                }
            }
            applyNodes();
        }

        function onEditMouseUp() {
            if (!editState || !editState.drag) {
                return;
            }
            var doc = editState.drag.doc;
            editState.drag = null;
            if (glMap) {
                glMap.off('mousemove', onEditMouseMove);
            }
            if (doc) {
                doc.removeEventListener('mouseup', onEditMouseUp, true);
            }
            $scope.$applyAsync(markDirty);
        }

        // Coloca el manejador opuesto en la direccion contraria, con su propia longitud.
        function mirrorHandle(anchor, dragged, other) {
            var vx = dragged[0] - anchor[0];
            var vy = dragged[1] - anchor[1];
            var len = Math.sqrt(vx * vx + vy * vy);
            if (!len) {
                return other;
            }
            var ox = other[0] - anchor[0];
            var oy = other[1] - anchor[1];
            var otherLen = Math.sqrt(ox * ox + oy * oy) || len;
            return [anchor[0] - vx / len * otherLen, anchor[1] - vy / len * otherLen];
        }

        function nodeAt(ref) {
            var rings = editState.nodes[ref.poly];
            var ring = rings && rings[ref.ring];
            return ring ? ring[ref.idx] : null;
        }

        // Convierte un nodo de esquina en curvo (y al reves). Los manejadores nacen
        // siguiendo la direccion entre los vecinos (Catmull-Rom), que es la curva que
        // uno espera ver al "redondear" ese punto.
        function toggleNodeCurve(ref) {
            var ring = editState.nodes[ref.poly][ref.ring];
            var node = ring[ref.idx];
            if (node.h1 || node.h2) {
                delete node.h1;
                delete node.h2;
                return;
            }
            var prev = ring[(ref.idx - 1 + ring.length) % ring.length];
            var next = ring[(ref.idx + 1) % ring.length];
            var dx = (next.p[0] - prev.p[0]) / 6;
            var dy = (next.p[1] - prev.p[1]) / 6;
            node.h1 = [node.p[0] - dx, node.p[1] - dy];
            node.h2 = [node.p[0] + dx, node.p[1] + dy];
        }

        // Parte el tramo idx -> idx+1 por la mitad SIN cambiar la forma: en un tramo
        // curvo se usa De Casteljau, que da los controles exactos de las dos mitades.
        function insertNodeAt(ref) {
            var ring = editState.nodes[ref.poly][ref.ring];
            var a = ring[ref.idx];
            var b = ring[(ref.idx + 1) % ring.length];

            if (!a.h2 && !b.h1) {
                ring.splice(ref.idx + 1, 0, {p: [(a.p[0] + b.p[0]) / 2, (a.p[1] + b.p[1]) / 2]});
                return;
            }
            var c1 = a.h2 || a.p;
            var c2 = b.h1 || b.p;
            var p01 = mid(a.p, c1), p12 = mid(c1, c2), p23 = mid(c2, b.p);
            var p012 = mid(p01, p12), p123 = mid(p12, p23);
            var center = mid(p012, p123);

            a.h2 = p01;
            b.h1 = p23;
            ring.splice(ref.idx + 1, 0, {p: center, h1: p012, h2: p123});
        }

        function mid(a, b) {
            return [(a[0] + b[0]) / 2, (a[1] + b[1]) / 2];
        }

        // Quita el nodo seleccionado (boton de la ficha). Un anillo necesita tres.
        function deleteNode() {
            if (!editState || !editState.selected) {
                return;
            }
            var ref = editState.selected;
            var ring = editState.nodes[ref.poly][ref.ring];
            if (ring.length <= 3) {
                toast($translate.instant('MAPS.NODE_MIN'));
                return;
            }
            ring.splice(ref.idx, 1);
            editState.selected = null;
            applyNodes();
            markDirty();
        }

        // Alterna esquina/curva del nodo seleccionado (equivalente al Alt+clic, para
        // quien no conozca el atajo).
        function toggleNodeCurveSelected() {
            if (!editState || !editState.selected) {
                return;
            }
            toggleNodeCurve(editState.selected);
            applyNodes();
            markDirty();
        }

        function hasSelectedNode() {
            return !!(editState && editState.selected);
        }

        function finishEditShape() {
            if (!vm.editingShape) {
                return;
            }
            var feature = editState ? editState.feature : null;
            if (feature) {
                // Los nodos se guardan con el elemento: al volver a entrar en reforma
                // las curvas siguen siendo curvas y no una ristra de vertices sueltos.
                feature.properties.nodes = editState.nodes;
            }
            closeEditShape();

            refreshZones();
            if (feature && markers[feature.id]) {
                var marker = markers[feature.id];
                marker.setLngLat(labelLngLat(feature));
                marker.setOffset(cardOffset(feature));
                marker.getElement().style.display = '';
            }
            markDirty();
        }

        // Sale del modo reforma SIN guardar los nodos. Lo usa el historial: al deshacer
        // se sustituye el contenido y lo que hubiera en edicion es de la version vieja.
        function cancelEditShape() {
            var feature = editState ? editState.feature : null;
            closeEditShape();
            if (feature && markers[feature.id]) {
                markers[feature.id].getElement().style.display = '';
            }
        }

        function closeEditShape() {
            if (editState && editState.drag && editState.drag.doc) {
                editState.drag.doc.removeEventListener('mouseup', onEditMouseUp, true);
            }
            if (glMap) {
                glMap.off('mousedown', onEditMouseDown);
                glMap.off('mousemove', onEditMouseMove);
                if (glMap.getSource(EDIT_SOURCE)) {
                    glMap.getSource(EDIT_SOURCE).setData(emptyFC());
                }
            }
            editState = null;
            vm.editingShape = false;
            applyToolCursor();
        }

        // ---- Zonas de varias formas: agrupar y separar ----

        // Arma el editor para que la SIGUIENTE figura dibujada no cree un elemento
        // nuevo, sino que se sume a la zona seleccionada (Polygon -> MultiPolygon).
        // Es la forma de tener un unico cartel para varias manchas separadas.
        function addShapeToZone() {
            if (!vm.selected || !isPolygonal(vm.selected) || !glDraw) {
                return;
            }
            if (vm.editingShape) {
                finishEditShape();
            }
            setPendingShape(vm.selected);
            vm.tool = 'zone';
            glDraw.changeMode('draw_polygon');
        }

        // Zona que recibira la proxima figura. vm.addingShape es solo su espejo para
        // la plantilla, que asi puede avisar de que se esta anadiendo a una existente
        // en vez de mostrar la ayuda normal de "dibujar zona".
        function setPendingShape(feature) {
            pendingShapeFor = feature || null;
            vm.addingShape = !!feature;
        }

        // Deshace la agrupacion: la primera forma se queda en el elemento y cada una
        // de las demas sale como zona independiente que copia sus propiedades (color,
        // altura, textura...), de modo que visualmente no cambia nada; solo pasan a
        // ser elementos con su propio cartel y su propia ficha.
        function splitShapes() {
            if (!vm.selected || shapeCount(vm.selected) < 2) {
                return;
            }
            if (vm.editingShape) {
                finishEditShape();
            }

            var source = vm.selected;
            var parts = polygonsOfGeometry(source.geometry);
            // Los nodos de curva se reparten con las formas, para que cada zona nueva
            // conserve sus curvas en vez de volver a ser un poligono de esquinas.
            var nodeParts = (source.properties && source.properties.nodes) || null;
            if (nodeParts && nodeParts.length !== parts.length) {
                nodeParts = null;
            }
            var created = [];

            source.geometry = {type: 'Polygon', coordinates: parts[0]};
            if (nodeParts) {
                source.properties.nodes = [nodeParts[0]];
            }

            parts.slice(1).forEach(function (rings, i) {
                featureSeq++;
                var copy = {
                    type: 'Feature',
                    id: 'z' + featureSeq + '_' + collection().features.length,
                    geometry: {type: 'Polygon', coordinates: rings},
                    properties: angular.copy(source.properties)
                };
                copy.properties.nodes = nodeParts ? [nodeParts[i + 1]] : null;
                if (!copy.properties.nodes) {
                    delete copy.properties.nodes;
                }
                collection().features.push(copy);
                created.push(copy);
            });

            refreshZones();
            if (markers[source.id]) {
                markers[source.id].setLngLat(labelLngLat(source));
            }
            created.forEach(addLabel);
            markDirty();
        }

        function applyLightPreset(preset) {
            if (!preset || !glMap.setConfigProperty) {
                return;
            }
            try {
                glMap.setConfigProperty('basemap', 'lightPreset', preset);
            } catch (e) {
                // Estilos no-Standard no soportan config; no es un error real
            }
        }

        function collection() {
            if (!vm.map.features || !angular.isArray(vm.map.features.features)) {
                vm.map.features = {type: 'FeatureCollection', features: []};
            }
            return vm.map.features;
        }

        // ---- Categorias (configurables por mapa) ----

        function categories() {
            if (!angular.isArray(vm.map.categories)) {
                vm.map.categories = [];
            }
            return vm.map.categories;
        }

        function toggleCategories() {
            vm.showCategories = !vm.showCategories;
        }

        function categoryColor(catId) {
            var cat = findCategory(catId);
            return cat ? cat.color : null;
        }

        function findCategory(catId) {
            var list = categories();
            for (var i = 0; i < list.length; i++) {
                if (list[i].id === catId) {
                    return list[i];
                }
            }
            return null;
        }

        function addCategory() {
            featureSeq++;
            categories().push({
                id: 'cat_' + featureSeq + '_' + categories().length,
                name: $translate.instant('MAPS.NEW_CATEGORY'),
                color: '#2F6FE6'
            });
            markDirty();
        }

        function removeCategory(cat) {
            var list = categories();
            var index = list.indexOf(cat);
            if (index > -1) {
                list.splice(index, 1);
            }
            // Los elementos que la usaban quedan con su color actual pero sin categoria
            collection().features.forEach(function (f) {
                if (f.properties && f.properties.category === cat.id) {
                    f.properties.category = null;
                }
            });
            markDirty();
        }

        // Al cambiar el color de una categoria, se recolorean sus elementos
        function onCategoryColorChanged(cat) {
            collection().features.forEach(function (f) {
                if (f.properties && f.properties.category === cat.id) {
                    f.properties.color = cat.color;
                    if (markers[f.id]) {
                        updateCardEl(markers[f.id].getElement(), f);
                    }
                }
            });
            refreshZones();
            markDirty();
        }

        // Asignar una categoria al elemento seleccionado (hereda su color).
        // Recibe el valor del md-select, que puede ser el centinela NO_CATEGORY;
        // en ese caso se guarda null y se conserva el color manual actual.
        function setFeatureCategory(choice) {
            if (!vm.selected || !vm.selected.properties) {
                return;
            }
            var catId = (choice === vm.NO_CATEGORY) ? null : choice;
            vm.selected.properties.category = catId;
            var cat = findCategory(catId);
            if (cat) {
                vm.selected.properties.color = cat.color;
            }
            onFeatureChanged();
        }

        // ---- Buscador de lugares (Mapbox Geocoding API) ----

        function search() {
            if (searchTimer) {
                $timeout.cancel(searchTimer);
            }
            var q = (vm.searchQuery || '').trim();
            if (q.length < 3) {
                vm.searchResults = [];
                return;
            }
            searchTimer = $timeout(function () {
                runSearch(q);
            }, 350);
        }

        // Geocoder: Photon (libre, sobre OSM). No usamos el de Mapbox (requeria token).
        function runSearch(q) {
            runSearchPhoton(q);
        }

        function runSearchPhoton(q) {
            vm.searching = true;
            var lang = ($translate.use() || 'es').split('-')[0];
            var params = {q: q, limit: 5};
            // Photon publico solo admite en/de/fr; para el resto, nombres locales
            if (lang === 'en' || lang === 'de' || lang === 'fr') {
                params.lang = lang;
            }
            $http.get('https://photon.komoot.io/api/', {params: params}).then(function (res) {
                vm.searching = false;
                var feats = (res.data && res.data.features) || [];
                vm.searchResults = feats.map(normalizePhoton);
            }, function () {
                vm.searching = false;
                vm.searchResults = [];
            });
        }

        // Photon -> mismo shape que usa goToResult (geometry.coordinates + properties.name/bbox)
        function normalizePhoton(f) {
            var p = f.properties || {};
            var label = [p.name || p.street, p.city, p.country].filter(Boolean).join(', ');
            var ext = p.extent; // Photon: [oeste, norte, este, sur]
            var bbox = (ext && ext.length === 4) ? [ext[0], ext[3], ext[2], ext[1]] : null;
            return {
                geometry: f.geometry,
                properties: {name: label || p.name || '', bbox: bbox}
            };
        }

        function goToResult(feature) {
            if (!glMap || !feature) {
                return;
            }
            var bbox = feature.properties && feature.properties.bbox;
            var coords = feature.geometry && feature.geometry.coordinates;
            if (bbox && bbox.length === 4) {
                glMap.fitBounds([[bbox[0], bbox[1]], [bbox[2], bbox[3]]], {padding: 40, duration: 800});
            } else if (coords) {
                glMap.flyTo({center: coords, zoom: 15, duration: 800});
            }
            vm.searchResults = [];
            if (feature.properties && feature.properties.name) {
                vm.searchQuery = feature.properties.name;
            }
        }

        function clearSearch() {
            vm.searchQuery = '';
            vm.searchResults = [];
        }

        function close() {
            // Destruimos el mapa AHORA, con el contenedor todavia en el DOM. Si
            // dejamos que lo haga el $destroy, Angular ya habra quitado el nodo y
            // el remove() de Mapbox peta al operar sobre un arbol desconectado.
            destroyMap();
            vm.onClose();
        }

        // ---- Traducciones ----

        // Idiomas del tenant (tabla languages). 'OTHER' no es un idioma real.
        function loadLanguages() {
            var langs = [];
            angular.forEach(sessionService.getSiteLanguages() || {}, function (lang) {
                if (lang && lang.lang_name && lang.lang_name.toUpperCase() !== 'OTHER') {
                    langs.push(lang);
                }
            });
            langs.sort(function (a, b) { return Number(a.id_lang) - Number(b.id_lang); });
            vm.baseLanguage = langs[0] || null;
            vm.languages = langs.slice(1);
            vm.translationLangId = vm.languages.length ? vm.languages[0].id_lang : null;

            // El boton de IA solo si el tenant tiene algun proveedor de traduccion
            if (vm.languages.length && vm.siteId) {
                sessionService.loadDomainResourceSettings(vm.siteId).then(function (settings) {
                    vm.aiTranslateEnabled = !!(settings && settings.translateServices &&
                        settings.translateServices.length);
                }, function () {
                    vm.aiTranslateEnabled = false;
                });
            }
        }

        function translationLangName() {
            for (var i = 0; i < vm.languages.length; i++) {
                if (vm.languages[i].id_lang == vm.translationLangId) {
                    return vm.languages[i].lang_name;
                }
            }
            return '';
        }

        function getTranslation(feature, langId, field) {
            var i18n = feature && feature.properties && feature.properties.i18n;
            var entry = i18n && langId !== null ? i18n[langId] : null;
            return (entry && entry[field]) || '';
        }

        // Escribe un texto traducido. Vacio = se borra la clave (y el idioma/i18n si se
        // quedan vacios), para no guardar objetos huecos en map_features.
        function setTranslation(feature, langId, field, value) {
            if (!feature || !feature.properties || langId === null || langId === undefined) {
                return;
            }
            var p = feature.properties;
            var key = String(langId);
            if (value) {
                p.i18n = p.i18n || {};
                p.i18n[key] = p.i18n[key] || {};
                p.i18n[key][field] = value;
                return;
            }
            if (p.i18n && p.i18n[key]) {
                delete p.i18n[key][field];
                if (!Object.keys(p.i18n[key]).length) {
                    delete p.i18n[key];
                }
                if (!Object.keys(p.i18n).length) {
                    delete p.i18n;
                }
            }
        }

        function hasTranslation(feature, langId) {
            return TRANSLATABLE_FIELDS.some(function (field) {
                return !!getTranslation(feature, langId, field);
            });
        }

        /**
         * Traduccion con IA, con el mismo dialogo que content (proveedor + idiomas).
         * scope 'feature': el elemento seleccionado, sobrescribe lo que haya.
         * scope 'map': todos los elementos, SOLO rellena los campos vacios para no
         * pisar lo que ya se haya corregido a mano.
         * Se traduce texto a texto con el endpoint sincrono (indexService.aiTextTranslate,
         * que ya encola las peticiones de una en una) y los textos repetidos se piden
         * una sola vez por idioma.
         */
        function openAiTranslate(scope) {
            if (vm.translating || !vm.baseLanguage) {
                return;
            }
            var feats = scope === 'feature' ? (vm.selected ? [vm.selected] : []) : collection().features;
            if (!feats.length) {
                return;
            }
            $mdDialog.show({
                controller: 'aiTranslateController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/content/dialogs/ai-translate-dialog/ai-translate-dialog.html',
                parent: angular.element($element[0].ownerDocument.body),
                clickOutsideToClose: true,
                multiple: true,
                locals: {
                    languages: vm.languages.concat([vm.baseLanguage]),
                    siteID: vm.siteId,
                    // El dialogo excluye el idioma del "registro" de origen: el base
                    threads: [{lang: vm.baseLanguage.id_lang}]
                }
            }).then(function (res) {
                if (res && res.success && res.langs && res.langs.length) {
                    runAiTranslation(feats, res.langs, res.selectedProvider, scope !== 'feature');
                }
            });
        }

        function runAiTranslation(feats, langIds, provider, onlyEmpty) {
            var jobs = [];
            langIds.forEach(function (langId) {
                var lang = findLanguage(langId);
                if (!lang) {
                    return;
                }
                feats.forEach(function (feature) {
                    TRANSLATABLE_FIELDS.forEach(function (field) {
                        var text = feature.properties && feature.properties[field];
                        if (!text || !String(text).trim()) {
                            return;
                        }
                        if (onlyEmpty && getTranslation(feature, langId, field)) {
                            return;
                        }
                        jobs.push({feature: feature, lang: lang, field: field, text: String(text)});
                    });
                });
            });
            if (!jobs.length) {
                toast($translate.instant('MAPS.AI_TRANSLATE_NOTHING'));
                return;
            }

            var cache = {}; // lang|texto -> promesa de la traduccion
            var failed = 0;
            vm.translating = true;
            vm.translationProgress = {done: 0, total: jobs.length};

            $q.all(jobs.map(function (job) {
                var key = job.lang.id_lang + '|' + job.text;
                if (!cache[key]) {
                    cache[key] = indexService.aiTextTranslate({
                        domain: vm.siteId,
                        text: job.text,
                        target_lang: job.lang.lang_name,
                        current_lang: vm.baseLanguage.lang_name,
                        translate_service: provider
                    }).then(function (response) {
                        return response && response.translation;
                    });
                }
                return cache[key].then(function (translation) {
                    if (translation) {
                        setTranslation(job.feature, job.lang.id_lang, job.field, String(translation).trim());
                    } else {
                        failed++;
                    }
                }, function () {
                    failed++;
                }).finally(function () {
                    vm.translationProgress.done++;
                });
            })).finally(function () {
                vm.translating = false;
                markDirty();
                toast($translate.instant(failed ? 'MAPS.AI_TRANSLATE_PARTIAL' : 'MAPS.AI_TRANSLATE_DONE'));
            });
        }

        function findLanguage(langId) {
            var all = vm.languages.concat(vm.baseLanguage ? [vm.baseLanguage] : []);
            for (var i = 0; i < all.length; i++) {
                if (all[i].id_lang == langId) {
                    return all[i];
                }
            }
            return null;
        }

        // Abre el diálogo de media del sistema (attachment/add-media). Al elegir
        // una foto (maxAttach:1) guarda su URL en properties.photo.
        function pickPhoto() {
            if (!vm.selected || !vm.selected.properties) {
                return;
            }
            $mdDialog.show({
                controller: 'MediaDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/dialogs/media/media-dialog.html',
                parent: angular.element($element[0].ownerDocument.body),
                clickOutsideToClose: true,
                multiple: true,
                locals: {
                    autoUpload: '',
                    currentThread: {Thumbnail: []},
                    section: '',
                    mediazone: false,
                    isTiny: false,
                    maxAttach: 1,
                    showViews: {1: true, 2: false, 3: false, 4: false, 5: false, upload: true, import: false}
                }
            }).then(function (response) {
                var thumb = response && response.Thumbnail && response.Thumbnail[0];
                var url = thumb ? mediaUrlFromItem(thumb) : '';
                if (url) {
                    vm.selected.properties.photo = url;
                    markDirty();
                }
            });
        }

        // URL a guardar de un item de media: original a buen tamano (mejor para el
        // panel de la web). Los items de mediahub/iconik ya traen URL completa.
        function mediaUrlFromItem(item) {
            if (!item) {
                return '';
            }
            if (item.imageUrl) {
                return item.imageUrl;
            }
            if (item.thumbnailUrl) {
                return item.thumbnailUrl;
            }
            var container = sessionService.getContainerByID(item.cdnContainer);
            var filename = item.filename || item.fileName;
            if (container && container.view_url && filename) {
                return container.view_url + 'original/m' + item.id_media + '_' + filename;
            }
            return mediaService.getThumbSrcFromMedia(item);
        }

        // URL del ORIGINAL subido, sin pasar por miniaturas. Es la que necesita un
        // fichero que no es imagen (.glb): no tiene imageUrl ni thumbnail.
        function mediaOriginalUrl(item) {
            if (!item) {
                return '';
            }
            var container = sessionService.getContainerByID(item.cdnContainer);
            var filename = item.filename || item.fileName;
            if (container && container.view_url && filename) {
                return container.view_url + 'original/m' + item.id_media + '_' + filename;
            }
            // Los items de mediahub/iconik ya vienen con la URL completa
            return item.imageUrl || item.thumbnailUrl || '';
        }

        function renderFeatures() {
            clearMarkers();
            // Etiqueta (tarjeta con nombre) para TODO elemento: pins, zonas y modelos
            collection().features.forEach(function (feature) {
                addLabel(feature);
                if (is3dObject(feature)) {
                    renderModel(feature);
                }
            });
        }

        function addPin(coordinates) {
            featureSeq++;
            var firstCat = (vm.map.categories && vm.map.categories[0]) || null;
            var feature = {
                type: 'Feature',
                id: 'f' + featureSeq + '_' + collection().features.length,
                geometry: {type: 'Point', coordinates: coordinates},
                properties: {
                    kind: 'pin',
                    title: $translate.instant('MAPS.NEW_PIN'),
                    category: firstCat ? firstCat.id : null,
                    color: firstCat ? firstCat.color : '#1E40AF',
                    subtitle: '',
                    description: ''
                }
            };

            collection().features.push(feature);
            addLabel(feature);

            $scope.$applyAsync(function () {
                vm.selected = feature;
                vm.tool = 'select';
                markDirty();
            });
        }

        // ---- Etiquetas (tarjeta: punto de color + nombre) para pins y zonas ----

        // Punto donde se planta el cartel: media de los vertices del anillo EXTERIOR.
        // En una zona de varias formas se promedian los de todas, para que la etiqueta
        // caiga en el conjunto y no clavada sobre una de las partes.
        function centroidOfPolygon(geometry) {
            var sx = 0, sy = 0, n = 0;
            polygonsOfGeometry(geometry).forEach(function (rings) {
                var ring = rings[0] || [];
                // Sin el punto de cierre (repetido), que si no pesa doble
                var count = ring.length;
                if (count > 1) {
                    var a = ring[0], z = ring[count - 1];
                    if (a[0] === z[0] && a[1] === z[1]) {
                        count--;
                    }
                }
                for (var i = 0; i < count; i++) {
                    sx += ring[i][0];
                    sy += ring[i][1];
                    n++;
                }
            });
            if (!n) {
                return [0, 0];
            }
            return [sx / n, sy / n];
        }

        function labelLngLat(feature) {
            return feature.geometry.type === 'Point'
                ? feature.geometry.coordinates
                : centroidOfPolygon(feature.geometry);
        }

        function buildCardEl(feature) {
            var el = $element[0].ownerDocument.createElement('div');
            el.className = 'maps-card-marker';
            el.innerHTML =
                '<div class="maps-card-box">' +
                    '<span class="maps-card-dot"></span>' +
                    '<span class="maps-card-text">' +
                        '<span class="maps-card-name"></span>' +
                        '<span class="maps-card-sub"></span>' +
                    '</span>' +
                '</div><span class="maps-card-stem"></span>';
            updateCardEl(el, feature);
            return el;
        }

        // Color, nombre y descripcion son datos por-elemento (color de categoria
        // arbitrario): se fijan por JS sobre el DOM del marker, no como estilo
        // inline en la plantilla. La sub-linea vacia se oculta via CSS (:empty).
        function updateCardEl(el, feature) {
            el.querySelector('.maps-card-dot').style.background = feature.properties.color || '#2F6FE6';
            el.querySelector('.maps-card-name').textContent = feature.properties.title || '';
            el.querySelector('.maps-card-sub').textContent = feature.properties.subtitle || '';
        }

        // Offset en pixeles del cartel: siempre por encima del punto; si es un volumen
        // 3D (altura > 0), sube ademas la altura proyectada a pantalla (~ altura_px *
        // sin(pitch)) para no tapar el edificio. Se recalcula al mover/inclinar.
        function cardOffset(feature) {
            var p = feature.properties || {};
            // Zonas: altura de extrusion. Objetos 3D: altitud + su alto REAL (medido de
            // la geometria al cargarla) para que el cartel quede por encima del objeto y
            // no clavado en su base. En ambos casos se proyecta a pantalla.
            var h;
            if (is3dObject(feature)) {
                // Una imagen tumbada no levanta nada; de pie, levanta su alto.
                var flat = isImage3d(feature) && p.orientation !== 'upright';
                var unitsTall = flat ? 0 : (modelHeights[feature.id] || 0);
                h = (Number(p.altitude) || 0) + unitsTall * (Number(p.scale) || 0);
            } else {
                h = p.height || 0;
            }
            if (!glMap || !h) {
                return [0, -CARD_BASE_OFFSET];
            }
            var lat = labelLngLat(feature)[1];
            var metersPerPixel = 78271.516 * Math.cos(lat * Math.PI / 180) / Math.pow(2, glMap.getZoom());
            var lift = (h / metersPerPixel) * Math.sin(glMap.getPitch() * Math.PI / 180);
            return [0, -(CARD_BASE_OFFSET + lift + 8)];
        }

        // Reajusta el offset de todos los carteles (los planos devuelven un valor fijo).
        function updateCardLifts() {
            angular.forEach(markers, function (marker, id) {
                var feature = findFeatureById(id);
                if (feature) {
                    marker.setOffset(cardOffset(feature));
                }
            });
        }

        function addLabel(feature) {
            var draggable = feature.geometry.type === 'Point';
            var el = buildCardEl(feature);
            var marker = new mapboxgl.Marker({element: el, anchor: 'bottom', offset: cardOffset(feature), draggable: draggable})
                .setLngLat(labelLngLat(feature))
                .addTo(glMap);

            if (draggable) {
                // Objetos 3D (modelos/imagenes): mover en vivo al arrastrar (repintar).
                if (is3dObject(feature)) {
                    marker.on('drag', function () {
                        var p = marker.getLngLat();
                        feature.geometry.coordinates = [p.lng, p.lat];
                        if (glMap) {
                            glMap.triggerRepaint();
                        }
                    });
                }
                marker.on('dragend', function () {
                    var position = marker.getLngLat();
                    feature.geometry.coordinates = [position.lng, position.lat];
                    if (is3dObject(feature) && glMap) {
                        glMap.triggerRepaint();
                    }
                    $scope.$applyAsync(function () {
                        vm.selected = feature;
                        markDirty();
                    });
                });
            }

            el.addEventListener('click', function (event) {
                event.stopPropagation();
                $scope.$applyAsync(function () {
                    vm.selected = feature;
                });
            });

            markers[feature.id] = marker;
        }

        function selectFeature(feature) {
            vm.selected = feature;
            if (glMap) {
                glMap.easeTo({center: labelLngLat(feature)});
            }
        }

        function onFeatureChanged() {
            if (vm.selected && markers[vm.selected.id]) {
                updateCardEl(markers[vm.selected.id].getElement(), vm.selected);
                // La altura (volumen 3D) puede haber cambiado -> reajustar la elevacion del cartel
                markers[vm.selected.id].setOffset(cardOffset(vm.selected));
            }
            // Zonas: color/altura se reflejan repintando la fuente
            if (isPolygonal(vm.selected)) {
                refreshZones();
            }
            // Objetos 3D: escala/altitud/rotacion se leen en el render -> repintar
            if (is3dObject(vm.selected) && glMap) {
                glMap.triggerRepaint();
            }
            markDirty();
        }

        function deleteSelected() {
            if (!vm.selected) {
                return;
            }

            // Si se estaba reformando, salimos del modo edicion sin conservar geometria
            if (vm.editingShape) {
                cancelEditShape();
            }

            removeFeature(vm.selected);
            vm.selected = null;
            refreshZones();
            markDirty();
        }

        function setTool(tool) {
            // No cambiar de herramienta mientras se reforma una zona
            if (vm.editingShape) {
                finishEditShape();
            }
            // Cambiar de herramienta cancela un "anadir forma" pendiente
            setPendingShape(null);
            var next = vm.tool === tool ? 'select' : tool;
            vm.tool = next;
            // Red de seguridad: una version anterior del trazo libre podia dejar el
            // arrastre del mapa apagado. Al cambiar de herramienta lo devolvemos, para
            // que una pestana ya abierta se recupere sin tener que recargar.
            if (glMap && glMap.dragPan && !glMap.dragPan.isEnabled()) {
                glMap.dragPan.enable();
            }
            applyToolCursor();
            if (!glDraw) {
                return;
            }
            // La herramienta "zona" pone a mapbox-gl-draw en modo dibujo de poligono.
            // El trazo libre no pasa por draw: lo gestionamos nosotros (onFreehandDown).
            if (next === 'zone') {
                glDraw.changeMode('draw_polygon');
            } else {
                glDraw.changeMode('simple_select');
            }
        }

        function markDirty() {
            $scope.$applyAsync(function () {
                vm.dirty = true;
            });
            recordHistory();
        }

        // ---- Deshacer / rehacer ----

        function docSnapshot() {
            if (!vm.map) {
                return null;
            }
            return angular.toJson({
                title: vm.map.title,
                features: collection(),
                categories: categories()
            });
        }

        function resetHistory() {
            if (historyTimer) {
                $timeout.cancel(historyTimer);
                historyTimer = null;
            }
            var snap = docSnapshot();
            history = snap === null ? [] : [snap];
            historyIndex = history.length - 1;
        }

        // Una entrada por CAMBIO, no por evento: teclear un titulo o arrastrar un
        // vertice dispara markDirty decenas de veces. Todo lo que ocurra dentro de la
        // misma rafaga (HISTORY_DEBOUNCE) acaba en una sola instantanea, que es lo que
        // el usuario entiende por "un paso atras".
        function recordHistory() {
            if (restoringHistory || !vm.map) {
                return;
            }
            if (historyTimer) {
                $timeout.cancel(historyTimer);
            }
            historyTimer = $timeout(commitHistory, HISTORY_DEBOUNCE);
        }

        function commitHistory() {
            historyTimer = null;
            if (restoringHistory || !vm.map) {
                return;
            }
            var snap = docSnapshot();
            // Cambios que no tocan el contenido (estilo, limites de vista) llegan aqui
            // con la misma instantanea: no gastan un paso de historial.
            if (snap === null || snap === history[historyIndex]) {
                return;
            }
            history = history.slice(0, historyIndex + 1);
            history.push(snap);
            if (history.length > HISTORY_LIMIT) {
                history.shift();
            }
            historyIndex = history.length - 1;
        }

        // El cambio en curso entra en el historial ANTES de deshacerlo; si no, el
        // primer Ctrl+Z tras soltar el raton se saltaria el ultimo movimiento.
        function flushHistory() {
            if (historyTimer) {
                $timeout.cancel(historyTimer);
                commitHistory();
            }
        }

        function canUndo() {
            return historyIndex > 0 || !!historyTimer;
        }

        function canRedo() {
            return historyIndex > -1 && historyIndex < history.length - 1;
        }

        function undo() {
            flushHistory();
            if (historyIndex <= 0) {
                return;
            }
            historyIndex--;
            restoreSnapshot(history[historyIndex]);
        }

        function redo() {
            flushHistory();
            if (historyIndex < 0 || historyIndex >= history.length - 1) {
                return;
            }
            historyIndex++;
            restoreSnapshot(history[historyIndex]);
        }

        // Vuelca una instantanea sobre el modelo.
        //
        // Se PARCHEA elemento a elemento en vez de sustituir la coleccion entera y
        // repintar de cero. Dos razones, y las dos se notan: (1) re-crear el cartel de
        // cada elemento es DOM por elemento, y con un mapa poblado deshacer tardaba lo
        // suyo; (2) las capas 3D se cierran sobre el objeto del feature, asi que
        // reemplazarlo obliga a destruir y recargar cada .glb — lo caro de verdad.
        // Conservando la identidad de los objetos, el 3D sigue vivo y solo se toca lo
        // que de verdad cambio.
        function restoreSnapshot(snap) {
            var doc = angular.fromJson(snap);
            if (!doc || !vm.map) {
                return;
            }
            restoringHistory = true;
            try {
                if (vm.editingShape) {
                    cancelEditShape();
                }
                setPendingShape(null);
                var selectedId = vm.selected ? vm.selected.id : null;

                vm.map.title = doc.title;
                vm.map.categories = doc.categories;

                var live = {};
                collection().features.forEach(function (f) {
                    live[f.id] = f;
                });

                var restored = (doc.features && doc.features.features) || [];
                var kept = {};
                var next = restored.map(function (snapshot) {
                    var current = live[snapshot.id];
                    if (!current) {
                        return snapshot;   // elemento que el undo devuelve a la vida
                    }
                    kept[snapshot.id] = true;
                    patchFeature(current, snapshot);
                    return current;
                });

                // Los que ya no estan en la instantanea: fuera (cartel y capa 3D incluidos)
                collection().features.forEach(function (f) {
                    if (!kept[f.id]) {
                        dropVisuals(f);
                    }
                });

                vm.map.features = {type: 'FeatureCollection', features: next};

                // Y los que vuelven necesitan cartel (y modelo, si son 3D)
                next.forEach(function (f) {
                    if (!markers[f.id] && glMap) {
                        addLabel(f);
                        if (is3dObject(f)) {
                            renderModel(f);
                        }
                    }
                });

                refreshZones();

                // La seleccion se recupera por id. El $watch de seleccion compara ids y
                // no se dispara si es el mismo, asi que el resaltado y el desplegable de
                // categoria se ponen a mano.
                vm.selected = selectedId ? findFeatureById(selectedId) : null;
                if (vm.selected && markers[vm.selected.id]) {
                    var el = markers[vm.selected.id].getElement();
                    if (el) {
                        el.classList.add('maps-card-selected');
                    }
                }
                var cat = vm.selected && vm.selected.properties ? vm.selected.properties.category : null;
                vm.categoryChoice = (cat === null || cat === undefined) ? vm.NO_CATEGORY : cat;
                vm.dirty = true;
            } finally {
                restoringHistory = false;
            }
        }

        // Copia geometria y propiedades de la instantanea sobre el objeto vivo, sin
        // cambiar su identidad, y refresca solo lo que dependa de lo que cambio.
        function patchFeature(current, snapshot) {
            var was3d = is3dObject(current);
            var oldSource = was3d ? objectSourceUrl(current) : null;

            current.geometry = snapshot.geometry;
            current.properties = snapshot.properties;

            var marker = markers[current.id];
            if (marker) {
                marker.setLngLat(labelLngLat(current));
                marker.setOffset(cardOffset(current));
                updateCardEl(marker.getElement(), current);
            }

            // La capa 3D solo se rehace si cambio el fichero que carga (o si el elemento
            // dejo de ser 3D / paso a serlo). Tamano, altura y giro los lee el render en
            // cada frame del propio feature, que es el mismo objeto: no hay que tocarla.
            var is3d = is3dObject(current);
            if (was3d && (!is3d || objectSourceUrl(current) !== oldSource)) {
                removeModelLayer(current);
            }
            if (is3d && !modelLayers[current.id] && glMap) {
                renderModel(current);
            }
        }

        // Retira lo pintado de un elemento (cartel y capa 3D) sin tocar la coleccion:
        // en el volcado del historial la lista se reconstruye entera aparte.
        function dropVisuals(feature) {
            if (markers[feature.id]) {
                markers[feature.id].remove();
                delete markers[feature.id];
            }
            if (is3dObject(feature)) {
                removeModelLayer(feature);
            }
        }

        // ---- Copiar / cortar / pegar ----

        // Portapapeles PROPIO del editor (no el del sistema): lo que se copia es un
        // elemento del mapa con todas sus propiedades, que no tiene representacion util
        // como texto, y asi tampoco pisamos lo que el usuario tuviera copiado fuera.
        function copySelected() {
            if (!vm.selected) {
                return;
            }
            clipboard = angular.fromJson(angular.toJson(vm.selected));
        }

        function cutSelected() {
            if (!vm.selected) {
                return;
            }
            copySelected();
            deleteSelected();
        }

        // Pega donde esta el raton si el puntero anda por el mapa, y si no en el centro
        // de la vista. Pegar encima del original (o siempre en el mismo sitio) obliga a
        // adivinar donde cayo la copia; junto al cursor es donde uno la espera.
        function pasteClipboard() {
            if (!clipboard || !glMap) {
                return;
            }
            var copy = angular.fromJson(angular.toJson(clipboard));
            featureSeq++;
            copy.id = 'p' + featureSeq + '_' + collection().features.length;

            var target = lastMouseLngLat || (function () {
                var c = glMap.getCenter();
                return [c.lng, c.lat];
            }());
            moveFeatureTo(copy, target);

            collection().features.push(copy);
            refreshZones();
            addLabel(copy);
            if (is3dObject(copy)) {
                renderModel(copy);
            }
            vm.selected = copy;
            markDirty();
        }

        // Coloca un elemento en un punto: los de tipo punto se mueven ahi y los
        // poligonos se desplazan en bloque, para que la copia conserve su forma.
        function moveFeatureTo(feature, lngLat) {
            if (!feature.geometry) {
                return;
            }
            if (feature.geometry.type === 'Point') {
                feature.geometry.coordinates = [lngLat[0], lngLat[1]];
                return;
            }
            if (!isPolygonal(feature)) {
                return;
            }
            var from = centroidOfPolygon(feature.geometry);
            translateFeature(feature, lngLat[0] - from[0], lngLat[1] - from[1]);
        }

        // Ctrl/Cmd+Z deshace · Ctrl+Y (o Ctrl+Shift+Z) rehace · Ctrl+C/X/V copian,
        // cortan y pegan · Supr y Retroceso borran. Se escucha en el documento porque
        // el foco suele estar en el canvas del mapa, que no es focusable. Dentro de un
        // campo de texto NO se intercepta nada: alli estos atajos son los del navegador
        // sobre lo que se esta escribiendo, y quitarselos al usuario seria peor.
        function registerHistoryKeys() {
            var doc = $element[0].ownerDocument;

            function onKeyDown(e) {
                if (destroyed || vm.status !== 'ready' || isTextTarget(e.target)) {
                    return;
                }
                var key = (e.key || '').toLowerCase();

                // Borrar no lleva modificador
                if (key === 'delete' || key === 'backspace') {
                    if (!vm.selected) {
                        return;
                    }
                    e.preventDefault();
                    $scope.$applyAsync(deleteSelected);
                    return;
                }

                if (!(e.ctrlKey || e.metaKey) || e.altKey) {
                    return;
                }
                var action = null;
                if (key === 'z' && !e.shiftKey) { action = undo; }
                else if (key === 'y' || (key === 'z' && e.shiftKey)) { action = redo; }
                else if (key === 'c') { action = copySelected; }
                else if (key === 'x') { action = cutSelected; }
                else if (key === 'v') { action = pasteClipboard; }
                if (!action) {
                    return;
                }
                e.preventDefault();
                $scope.$applyAsync(action);
            }

            doc.addEventListener('keydown', onKeyDown, true);
            historyKeysCleanup = function () {
                doc.removeEventListener('keydown', onKeyDown, true);
            };
        }

        function isTextTarget(el) {
            if (!el) {
                return false;
            }
            var tag = (el.tagName || '').toLowerCase();
            return tag === 'input' || tag === 'textarea' || tag === 'select' || !!el.isContentEditable;
        }

        // Pide al contenedor padre alternar pantalla completa. El resize del mapa
        // lo dispara el watch de vm.fullscreen (el tamano cambia tras el reflow).
        function toggleFullscreen() {
            vm.onFullscreen();
        }

        // Marca/desmarca el <body> para elevar los overlays de Material en fullscreen.
        function setBodyFullscreen(on) {
            var body = $element[0].ownerDocument.body;
            if (body) {
                body.classList.toggle('maps-editor-fs-open', on);
            }
        }

        // Abre el editor de estilos de OpenFreeMap (modal: biblioteca + editor por
        // capas + preview en vivo sobre MapLibre).
        function openStyleEditor(ev) {
            $mdDialog.show({
                controller: 'MapsStyleEditorController',
                controllerAs: 'dlg',
                templateUrl: 'app/main/apps/maps/dialogs/style-editor-dialog.html',
                parent: angular.element($element[0].ownerDocument.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                locals: {
                    siteId: vm.siteId,
                    // Vista actual (centro/zoom/inclinacion en vivo) y features para que
                    // el preview del editor de estilos sea igual que el mapa real.
                    mapView: currentView(),
                    mapFeatures: vm.map.features
                }
            }).then(afterStyleEditor, afterStyleEditor);
        }

        // Al cerrar el editor de estilos: refresca el selector con los guardados y,
        // si el mapa usa un estilo de biblioteca, lo recarga para reflejar cambios.
        function afterStyleEditor() {
            loadOfmLibrary().then(function () {
                if (glMap && isOpenFreeMap() &&
                    findLibraryStyle(vm.map.view && vm.map.view.openfreemapStyle)) {
                    glMap.setStyle(styleForProvider(vm.map.view), {diff: false});
                    glMap.once('style.load', function () {
                        addZoneLayers();
                        applyLibraryOverridesIfAny();
                        reAddModelLayers();
                    });
                }
            });
        }

        // ---- Modelos 3D (.glb via three.js) — elemento persistente y editable ----
        // Un modelo es un feature Point con kind:'model3d' en map_features. Se puede
        // mover (arrastrando su cartel), subir/bajar (altitud), escalar y rotar desde
        // el panel de propiedades. La capa lee posicion/escala/altitud/rotacion del
        // feature EN CADA frame, asi que cualquier cambio se refleja al instante.

        function isModel3d(feature) {
            return !!(feature && feature.properties && feature.properties.kind === 'model3d');
        }

        function isImage3d(feature) {
            return !!(feature && feature.properties && feature.properties.kind === 'image3d');
        }

        // Carga una imagen con CORS, obligatorio para poder usarla como textura WebGL.
        // Trampa: si el navegador ya tiene CACHEADA una respuesta SIN cabeceras CORS
        // (porque antes se pinto en un <img> normal, p.ej. la miniatura del panel), se
        // la sirve tambien a WebGL y la textura falla EN SILENCIO. Por eso, si el primer
        // intento falla, reintentamos con un parametro que fuerza una peticion nueva.
        function loadCorsImage(url, onOk, onFail) {
            var win = $element[0].ownerDocument.defaultView || window;
            function attempt(src, canRetry) {
                var img = new win.Image();
                img.crossOrigin = 'anonymous';
                img.onload = function () { onOk(img); };
                img.onerror = function () {
                    if (canRetry) {
                        attempt(url + (url.indexOf('?') > -1 ? '&' : '?') + 'qiucors=1', false);
                    } else if (onFail) {
                        onFail();
                    }
                };
                img.src = src;
            }
            attempt(url, true);
        }

        // Objetos que se pintan con una capa custom 3D (three.js): modelos .glb e imagenes.
        function is3dObject(feature) {
            return isModel3d(feature) || isImage3d(feature);
        }

        function objectSourceUrl(feature) {
            if (!feature || !feature.properties) { return null; }
            return isImage3d(feature) ? feature.properties.imageUrl : feature.properties.modelUrl;
        }

        // Abre un dialogo para pegar la URL del .glb y crea el modelo en el centro.
        // Sube un .glb propio (o elige uno ya subido) y lo coloca en el centro del mapa.
        // El media center hace de biblioteca: al abrirlo salen los modelos anteriores.
        function openModelObject() {
            if (!glMap) { return; }
            pickModelUrl().then(function (url) {
                if (!url || !glMap) { return; }
                var c = glMap.getCenter();
                addModel([c.lng, c.lat], url);
            });
        }

        // Cambia el .glb del modelo seleccionado por otro subido/elegido.
        function pickModelFile() {
            if (!isModel3d(vm.selected)) { return; }
            pickModelUrl().then(function (url) {
                if (!url) { return; }
                vm.selected.properties.modelUrl = url;
                reload3dObject();
            });
        }

        // Crea el feature persistente y lo pinta (capa 3D + cartel arrastrable).
        function addModel(coordinates, url) {
            featureSeq++;
            var feature = {
                type: 'Feature',
                id: 'm' + featureSeq + '_' + collection().features.length,
                geometry: {type: 'Point', coordinates: coordinates},
                properties: {
                    kind: 'model3d',
                    title: $translate.instant('MAPS.MODEL_NEW'),
                    modelUrl: url,
                    scale: 40,
                    altitude: 0,
                    rotation: 0,
                    category: null,
                    color: '#2F6FE6',
                    subtitle: '',
                    description: ''
                }
            };
            collection().features.push(feature);
            renderModel(feature);
            addLabel(feature);
            $scope.$applyAsync(function () {
                vm.selected = feature;
                vm.tool = 'select';
                markDirty();
            });
        }

        // Carga three.js (si hace falta) y anade la capa custom del objeto 3D
        // (modelo .glb o imagen). Sirve para model3d e image3d.
        function renderModel(feature) {
            if (!glMap || !feature || !objectSourceUrl(feature) || modelLayers[feature.id]) {
                return;
            }
            mapboxLoader.loadThree().then(function (THREE) {
                if (!glMap || modelLayers[feature.id]) {
                    return;
                }
                var layer = isImage3d(feature) ? buildImageLayer(THREE, feature) : buildModelLayer(THREE, feature);
                glMap.addLayer(layer);
                modelLayers[feature.id] = layer.id;
                glMap.triggerRepaint();
            }, function () {
                toast($translate.instant('MAPS.MODEL_ERROR'));
            });
        }

        // Cambio de URL/imagen/textura: descarta la capa vieja y la reconstruye.
        function reload3dObject() {
            if (!is3dObject(vm.selected)) {
                return;
            }
            removeModelLayer(vm.selected);
            renderModel(vm.selected);
            markDirty();
        }

        // Quita la capa 3D de un modelo (al borrarlo).
        function removeModelLayer(feature) {
            var layerId = feature && modelLayers[feature.id];
            if (layerId && glMap && glMap.getLayer(layerId)) {
                try { glMap.removeLayer(layerId); } catch (e) { /* la capa ya no existe */ }
            }
            if (feature) {
                delete modelLayers[feature.id];
                delete modelHeights[feature.id];
            }
        }

        // Reconstruye las capas 3D tras un cambio de estilo (setStyle {diff:false}
        // descarta las capas custom): olvida las refs y vuelve a anadir cada modelo.
        function reAddModelLayers() {
            modelLayers = {};
            collection().features.forEach(function (feature) {
                if (is3dObject(feature)) {
                    renderModel(feature);
                }
            });
        }

        // Capa custom de MapLibre/Mapbox que renderiza un .glb con three.js.
        // render() lee la posicion/escala/altitud/rotacion del feature EN CADA frame,
        // asi que mover/escalar/subir/rotar desde el panel se refleja al instante.
        function buildModelLayer(THREE, feature) {
            return {
                id: 'qiu-model-' + (modelSeq++),
                type: 'custom',
                renderingMode: '3d',
                onAdd: function (map, gl) {
                    this.camera = new THREE.Camera();
                    this.scene = new THREE.Scene();
                    var d1 = new THREE.DirectionalLight(0xffffff, 1); d1.position.set(0, -70, 100).normalize(); this.scene.add(d1);
                    var d2 = new THREE.DirectionalLight(0xffffff, 1); d2.position.set(0, 70, 100).normalize(); this.scene.add(d2);
                    this.scene.add(new THREE.AmbientLight(0xffffff, 0.85));
                    var self = this;
                    new THREE.GLTFLoader().load(feature.properties.modelUrl, function (gltf) {
                        // Textura opcional: envuelve los materiales del modelo con una imagen
                        // subida desde qiusystem (logos/skins). Segun el mapeado UV del .glb
                        // puede verse mejor o peor; con modelos pensados para ello va fino.
                        if (feature.properties.textureUrl) {
                            applyTextureToModel(THREE, gltf.scene, feature.properties.textureUrl);
                        }
                        // Materiales del modelo -> para aplicarle la opacidad del elemento
                        self.materials = [];
                        gltf.scene.traverse(function (node) {
                            if (node.isMesh && node.material) {
                                var ms = Array.isArray(node.material) ? node.material : [node.material];
                                ms.forEach(function (m) { self.materials.push(m); });
                            }
                        });
                        // Alto real del modelo: 1 unidad del .glb = 'scale' metros, asi que
                        // el alto en metros es (alto de su caja) x scale. Sirve para subir
                        // el cartel por encima del modelo en vez de dejarlo en la base.
                        try {
                            var box = new THREE.Box3().setFromObject(gltf.scene);
                            var unitsTall = box.max.y - box.min.y;
                            if (isFinite(unitsTall) && unitsTall > 0) {
                                modelHeights[feature.id] = unitsTall;
                                updateCardLifts();
                            }
                        } catch (e) { /* modelo sin geometria medible */ }
                        self.scene.add(gltf.scene);
                        if (glMap) { glMap.triggerRepaint(); }
                    });
                    this.renderer = new THREE.WebGLRenderer({canvas: map.getCanvas(), context: gl, antialias: true});
                    this.renderer.autoClear = false;
                },
                render: function (gl, matrix) {
                    // Transformacion en vivo desde las propiedades del feature.
                    var lngLat = feature.geometry.coordinates;
                    var altitude = Number(feature.properties.altitude) || 0;
                    var scaleMeters = Number(feature.properties.scale) || 30;
                    var heading = (Number(feature.properties.rotation) || 0) * Math.PI / 180;
                    var merc = mapboxgl.MercatorCoordinate.fromLngLat(lngLat, altitude);
                    var unit = merc.meterInMercatorCoordinateUnits() * scaleMeters;
                    // MapLibre/Mapbox (mercator) pasan la matriz como array; soportamos
                    // tambien el objeto de las versiones con globe.
                    var mat = Array.isArray(matrix) ? matrix
                        : (matrix && matrix.defaultProjectionData && matrix.defaultProjectionData.mainMatrix) || matrix;
                    var rX = new THREE.Matrix4().makeRotationAxis(new THREE.Vector3(1, 0, 0), Math.PI / 2);
                    var rY = new THREE.Matrix4().makeRotationAxis(new THREE.Vector3(0, 1, 0), heading);
                    var M = new THREE.Matrix4().fromArray(mat);
                    var L = new THREE.Matrix4()
                        .makeTranslation(merc.x, merc.y, merc.z)
                        .scale(new THREE.Vector3(unit, -unit, unit))
                        .multiply(rX).multiply(rY);
                    this.camera.projectionMatrix = M.multiply(L);
                    applyMaterialOpacity(this.materials, feature);
                    this.renderer.resetState();
                    this.renderer.render(this.scene, this.camera);
                }
            };
        }

        // Aplica una imagen como textura a TODOS los materiales de un modelo .glb.
        // La imagen se compone sobre BLANCO opaco: un PNG con transparencia (un logo)
        // dejaria agujeros y el modelo pareceria desaparecer. flipY=false porque glTF
        // usa el origen de UV arriba (si no, sale invertida).
        function applyTextureToModel(THREE, scene, url) {
            var doc = $element[0].ownerDocument;
            loadCorsImage(url, function (img) {
                var cv = doc.createElement('canvas');
                cv.width = img.naturalWidth || 1;
                cv.height = img.naturalHeight || 1;
                var g = cv.getContext('2d');
                g.fillStyle = '#FFFFFF';
                g.fillRect(0, 0, cv.width, cv.height);
                g.drawImage(img, 0, 0);
                var texture = new THREE.CanvasTexture(cv);
                if (THREE.sRGBEncoding !== undefined) { texture.encoding = THREE.sRGBEncoding; }
                texture.flipY = false;
                scene.traverse(function (node) {
                    if (node.isMesh && node.material) {
                        var mats = Array.isArray(node.material) ? node.material : [node.material];
                        mats.forEach(function (m) { m.map = texture; m.needsUpdate = true; });
                    }
                });
                if (glMap) { glMap.triggerRepaint(); }
            }, function () { /* textura no disponible: el modelo mantiene sus materiales */ });
        }

        // Capa custom que pinta una IMAGEN como plano texturizado en el mapa. Orientacion
        // 'flat' = tumbada en el suelo (grafico/plano de recinto); 'upright' = de pie
        // (cartel/valla). El ancho es properties.scale (m); el alto sale del ratio real.
        function buildImageLayer(THREE, feature) {
            return {
                id: 'qiu-image-' + (modelSeq++),
                type: 'custom',
                renderingMode: '3d',
                onAdd: function (map, gl) {
                    this.camera = new THREE.Camera();
                    this.scene = new THREE.Scene();
                    var self = this;
                    // loadCorsImage (no TextureLoader): controlamos el reintento cuando
                    // el navegador tiene cacheada una respuesta sin CORS.
                    loadCorsImage(feature.properties.imageUrl, function (img) {
                        var texture = new THREE.Texture(img);
                        texture.needsUpdate = true;
                        if (THREE.sRGBEncoding !== undefined) { texture.encoding = THREE.sRGBEncoding; }
                        var aspect = (img.naturalWidth && img.naturalHeight) ? (img.naturalWidth / img.naturalHeight) : 1;
                        var geo = new THREE.PlaneGeometry(1, 1 / aspect);
                        var matl = new THREE.MeshBasicMaterial({map: texture, transparent: true, side: THREE.DoubleSide});
                        self.materials = [matl]; // para aplicar la opacidad del elemento
                        self.scene.add(new THREE.Mesh(geo, matl));
                        // Alto en unidades (el ancho es 1): lo usa el cartel si esta de pie
                        modelHeights[feature.id] = 1 / aspect;
                        updateCardLifts();
                        if (glMap) { glMap.triggerRepaint(); }
                    });
                    this.renderer = new THREE.WebGLRenderer({canvas: map.getCanvas(), context: gl, antialias: true});
                    this.renderer.autoClear = false;
                },
                render: function (gl, matrix) {
                    var lngLat = feature.geometry.coordinates;
                    var altitude = Number(feature.properties.altitude) || 0;
                    var widthMeters = Number(feature.properties.scale) || 30;
                    var heading = (Number(feature.properties.rotation) || 0) * Math.PI / 180;
                    var upright = feature.properties.orientation === 'upright';
                    var merc = mapboxgl.MercatorCoordinate.fromLngLat(lngLat, altitude);
                    var unit = merc.meterInMercatorCoordinateUnits() * widthMeters;
                    var mat = Array.isArray(matrix) ? matrix
                        : (matrix && matrix.defaultProjectionData && matrix.defaultProjectionData.mainMatrix) || matrix;
                    var M = new THREE.Matrix4().fromArray(mat);
                    var L = new THREE.Matrix4()
                        .makeTranslation(merc.x, merc.y, merc.z)
                        .scale(new THREE.Vector3(unit, -unit, unit))
                        .multiply(new THREE.Matrix4().makeRotationAxis(new THREE.Vector3(0, 0, 1), heading));
                    // 'flat' -> el plano (XY) queda tumbado mirando arriba. 'upright' ->
                    // lo ponemos de pie girando 90deg sobre X para que sea un cartel vertical.
                    if (upright) {
                        L.multiply(new THREE.Matrix4().makeRotationAxis(new THREE.Vector3(1, 0, 0), Math.PI / 2));
                    }
                    this.camera.projectionMatrix = M.multiply(L);
                    applyMaterialOpacity(this.materials, feature);
                    this.renderer.resetState();
                    this.renderer.render(this.scene, this.camera);
                }
            };
        }

        // Crea un objeto imagen (plano texturizado) persistente y lo pinta. Antes lee el
        // tamano real de la imagen para elegir defaults con los que SE VEA: un logo o
        // rotulo (muy apaisado) se coloca DE PIE y con alto legible; una imagen tipo
        // foto se coloca tumbada en el suelo. Con 'scale' = ancho fijo, un logo 6:1
        // quedaba de apenas unos metros de alto y era practicamente invisible.
        function addImage(coordinates, imageUrl) {
            loadCorsImage(imageUrl, function (img) {
                var w = img.naturalWidth || 1, h = img.naturalHeight || 1;
                var aspect = w / h;
                var banner = aspect >= 2.5; // logo/rotulo apaisado
                createImageFeature(coordinates, imageUrl, {
                    orientation: banner ? 'upright' : 'flat',
                    scale: banner ? Math.max(20, Math.round(aspect * 16)) : 40
                });
            }, function () {
                createImageFeature(coordinates, imageUrl, {orientation: 'flat', scale: 40});
            });
        }

        function createImageFeature(coordinates, imageUrl, defaults) {
            featureSeq++;
            var feature = {
                type: 'Feature',
                id: 'i' + featureSeq + '_' + collection().features.length,
                geometry: {type: 'Point', coordinates: coordinates},
                properties: {
                    kind: 'image3d',
                    title: $translate.instant('MAPS.IMAGE_NEW'),
                    imageUrl: imageUrl,
                    scale: defaults.scale,
                    altitude: 0,
                    rotation: 0,
                    orientation: defaults.orientation,
                    category: null,
                    color: '#2F6FE6',
                    subtitle: '',
                    description: ''
                }
            };
            collection().features.push(feature);
            renderModel(feature);
            addLabel(feature);
            $scope.$applyAsync(function () {
                vm.selected = feature;
                vm.tool = 'select';
                markDirty();
            });
        }

        // Abre el selector de medias (subir/elegir imagen) y devuelve una promesa con la
        // URL del original. Reutiliza el mismo dialogo que las fotos de los pins.
        // Abre el media center (subir o elegir de la biblioteca) y devuelve el item.
        // Es el dialogo generico, que NO restringe extensiones: acepta tambien .glb.
        function openMediaDialog() {
            return $mdDialog.show({
                controller: 'MediaDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/dialogs/media/media-dialog.html',
                parent: angular.element($element[0].ownerDocument.body),
                clickOutsideToClose: true,
                multiple: true,
                locals: {
                    autoUpload: '',
                    currentThread: {Thumbnail: []},
                    section: '',
                    mediazone: false,
                    isTiny: false,
                    maxAttach: 1,
                    showViews: {1: true, 2: false, 3: false, 4: false, 5: false, upload: true, import: false}
                }
            }).then(function (response) {
                return (response && response.Thumbnail && response.Thumbnail[0]) || null;
            });
        }

        function pickMediaUrl() {
            return openMediaDialog().then(function (item) {
                return item ? mediaUrlFromItem(item) : '';
            });
        }

        // Igual, pero devuelve SIEMPRE la URL del original. Para ficheros que no son
        // imagen (un .glb) no valen imageUrl/thumbnail: no existen.
        function pickModelUrl() {
            return openMediaDialog().then(function (item) {
                return item ? mediaOriginalUrl(item) : '';
            });
        }

        // Boton de barra: sube/elige una imagen y la coloca en el centro del mapa.
        function openImageObject() {
            if (!glMap) { return; }
            pickMediaUrl().then(function (url) {
                if (!url) { return; }
                var c = glMap.getCenter();
                addImage([c.lng, c.lat], url);
            });
        }

        // Cambia la imagen del objeto imagen seleccionado.
        function pickImageForObject() {
            if (!isImage3d(vm.selected)) { return; }
            pickMediaUrl().then(function (url) {
                if (!url) { return; }
                vm.selected.properties.imageUrl = url;
                reload3dObject();
            });
        }

        // Textura de una ZONA (volumen 3D o relleno plano) creada en el editor. Se aplica
        // como patron nativo de MapLibre (se repite sobre las caras).
        function pickZoneTexture() {
            if (!vm.selected || vm.selected.properties.kind !== 'zone') { return; }
            pickMediaUrl().then(function (url) {
                if (!url) { return; }
                vm.selected.properties.textureUrl = url;
                if (!vm.selected.properties.textureScale) {
                    vm.selected.properties.textureScale = 100; // % del tamano natural
                }
                refreshZones();
                markDirty();
            });
        }

        function clearZoneTexture() {
            if (!vm.selected || vm.selected.properties.kind !== 'zone') { return; }
            vm.selected.properties.textureUrl = '';
            refreshZones();
            markDirty();
        }

        // Cambio de tamano de la textura: la nueva escala es otra entrada del sprite,
        // asi que refreshZones -> ensureZoneTextures la registra y repinta.
        function onZoneTextureScaleChanged() {
            refreshZones();
            markDirty();
        }

        // Aplica/actualiza la textura (imagen) del modelo .glb seleccionado.
        function pickModelTexture() {
            if (!isModel3d(vm.selected)) { return; }
            pickMediaUrl().then(function (url) {
                if (!url) { return; }
                vm.selected.properties.textureUrl = url;
                reload3dObject();
            });
        }

        // Quita la textura del modelo .glb seleccionado (vuelve a sus materiales).
        function clearModelTexture() {
            if (!isModel3d(vm.selected)) { return; }
            vm.selected.properties.textureUrl = '';
            reload3dObject();
        }

        // Ajusta el objeto imagen (tumbado) al encuadre actual del mapa: lo centra,
        // lo pone plano sin giro y le da el ancho aproximado del encuadre en metros.
        // Sirve para overlays de suelo tipo plano de recinto / circuito.
        function fitImageToView() {
            if (!isImage3d(vm.selected) || !glMap) { return; }
            var c = glMap.getCenter();
            var b = glMap.getBounds();
            var meters = Math.abs(b.getEast() - b.getWest()) * 111320 * Math.cos(c.lat * Math.PI / 180);
            vm.selected.geometry.coordinates = [c.lng, c.lat];
            vm.selected.properties.orientation = 'flat';
            vm.selected.properties.rotation = 0;
            vm.selected.properties.altitude = 0;
            vm.selected.properties.scale = Math.max(1, Math.round(meters));
            if (markers[vm.selected.id]) { markers[vm.selected.id].setLngLat([c.lng, c.lat]); }
            glMap.triggerRepaint();
            markDirty();
        }

        // ---- Configuracion de la vista (limites de zoom/inclinacion/encuadre) ----
        // Se guardan en map_view y se aplican tanto al editor como (via el viewer)
        // a la web publica, para acotar lo que el usuario final puede hacer.

        function numOr(value, fallback) {
            return angular.isNumber(value) ? value :
                (value === 0 || value ? Number(value) : fallback);
        }

        function clampNum(value, min, max, fallback) {
            var n = numOr(value, fallback);
            if (isNaN(n)) { n = fallback; }
            return Math.min(max, Math.max(min, n));
        }

        // Lee los limites/config del view aplicando los defaults si faltan.
        function readViewLimits(view) {
            view = view || {};
            return {
                minZoom: numOr(view.minZoom, 0),
                maxZoom: numOr(view.maxZoom, 22),
                minPitch: numOr(view.minPitch, 0),
                maxPitch: numOr(view.maxPitch, 85),
                rotationLock: !!view.rotationLock,
                maxBounds: view.maxBounds || null,
                // Opacidad de zonas (0-100 en UI; se guarda 0-1). Defaults = look actual.
                zoneFillOpacity: Math.round(numOr(view.zoneFillOpacity, 0.35) * 100),
                zoneExtrusionOpacity: Math.round(numOr(view.zoneExtrusionOpacity, 0.9) * 100),
                // Controles de interaccion del usuario final (solo se aplican en el viewer).
                scrollZoomLock: !!view.scrollZoomLock,
                dragPanLock: !!view.dragPanLock,
                hideNavControl: !!view.hideNavControl
            };
        }

        // La opacidad de zonas viaja por feature (zonesFC resuelve la propia del elemento
        // o la del mapa): cambiar la config general = repintar la fuente.
        function applyZoneOpacity() {
            refreshZones();
        }

        // Bloquea/activa la rotacion (arrastre con boton derecho y gesto tactil).
        function applyRotationLock(locked) {
            if (!glMap) { return; }
            if (locked) {
                if (glMap.dragRotate) { glMap.dragRotate.disable(); }
                if (glMap.touchZoomRotate) { glMap.touchZoomRotate.disableRotation(); }
            } else {
                if (glMap.dragRotate) { glMap.dragRotate.enable(); }
                if (glMap.touchZoomRotate) { glMap.touchZoomRotate.enableRotation(); }
            }
        }

        // Rotar/inclinar con el BOTON CENTRAL del raton. MapLibre solo mapea el boton
        // derecho (o Ctrl+izquierdo), y arrastrar con la rueda pulsada es un gesto que
        // mucha gente da por hecho, sobre todo en Windows. Se usan las MISMAS constantes
        // que la libreria (dx*0.8 grados de giro, dy*-0.5 de inclinacion) para que el
        // tacto sea identico al del boton derecho.
        function registerMiddleDragRotate() {
            var container = glMap.getCanvasContainer();
            var doc = $element[0].ownerDocument;
            var last = null;

            function onDown(e) {
                // Solo boton central, y no mientras el mapa tenga la rotacion bloqueada
                if (e.button !== 1 || (vm.map.view && vm.map.view.rotationLock)) {
                    return;
                }
                // Imprescindible en Windows: sin esto el navegador abre el autoscroll
                // (el circulito de desplazamiento) y se come el arrastre.
                e.preventDefault();
                last = {x: e.clientX, y: e.clientY};
                doc.addEventListener('mousemove', onMove, true);
                doc.addEventListener('mouseup', onUp, true);
            }

            function onMove(e) {
                if (!last || !glMap) { return; }
                e.preventDefault();
                var dx = e.clientX - last.x;
                var dy = e.clientY - last.y;
                last = {x: e.clientX, y: e.clientY};
                // setBearing/setPitch respetan los limites configurados del mapa
                glMap.setBearing(glMap.getBearing() + dx * 0.8);
                glMap.setPitch(glMap.getPitch() + dy * -0.5);
                $scope.$applyAsync(function () {
                    vm.is3d = glMap.getPitch() > 1;
                });
            }

            function onUp() {
                last = null;
                doc.removeEventListener('mousemove', onMove, true);
                doc.removeEventListener('mouseup', onUp, true);
            }

            // El click auxiliar posterior al boton central abriria pestanas/pegar segun
            // el sistema; lo cortamos sobre el mapa.
            function onAux(e) {
                if (e.button === 1) { e.preventDefault(); }
            }

            container.addEventListener('mousedown', onDown);
            container.addEventListener('auxclick', onAux);

            // Se retiran al destruir el mapa (los de doc solo viven durante el arrastre)
            middleDragCleanup = function () {
                onUp();
                container.removeEventListener('mousedown', onDown);
                container.removeEventListener('auxclick', onAux);
            };
        }

        // Guarda los limites en el view y los aplica en vivo al mapa del editor.
        function applyViewLimits(limits) {
            var v = vm.map.view = vm.map.view || {};
            var minZ = clampNum(limits.minZoom, 0, 24, 0);
            var maxZ = clampNum(limits.maxZoom, 0, 24, 22);
            if (minZ > maxZ) { minZ = maxZ; }
            var minP = clampNum(limits.minPitch, 0, 85, 0);
            var maxP = clampNum(limits.maxPitch, 0, 85, 85);
            if (minP > maxP) { minP = maxP; }

            var fill01 = clampNum(limits.zoneFillOpacity, 0, 100, 35) / 100;
            var ext01 = clampNum(limits.zoneExtrusionOpacity, 0, 100, 90) / 100;

            v.minZoom = minZ;
            v.maxZoom = maxZ;
            v.minPitch = minP;
            v.maxPitch = maxP;
            v.rotationLock = !!limits.rotationLock;
            v.maxBounds = limits.maxBounds || null;
            v.zoneFillOpacity = fill01;
            v.zoneExtrusionOpacity = ext01;
            // Controles de interaccion: solo se guardan; se aplican en el viewer publico
            // (en el editor haria imposible navegar para editar).
            v.scrollZoomLock = !!limits.scrollZoomLock;
            v.dragPanLock = !!limits.dragPanLock;
            v.hideNavControl = !!limits.hideNavControl;

            if (glMap) {
                // Orden seguro: bajar el minimo antes de subir/bajar el maximo evita
                // que setMax* lance si el nuevo maximo queda por debajo del minimo actual.
                try { glMap.setMinZoom(0); glMap.setMaxZoom(maxZ); glMap.setMinZoom(minZ); } catch (e1) {}
                try { glMap.setMinPitch(0); glMap.setMaxPitch(maxP); glMap.setMinPitch(minP); } catch (e2) {}
                try { glMap.setMaxBounds(v.maxBounds || null); } catch (e3) {}
                applyRotationLock(v.rotationLock);
                applyZoneOpacity();
            }
            markDirty();
        }

        // Abre el dialogo de configuracion del mapa. Aplica en vivo; al cancelar,
        // revierte a como estaba al abrir.
        function openMapSettings(ev) {
            var snapshot = readViewLimits(vm.map.view);
            $mdDialog.show({
                controller: MapSettingsDialogController,
                controllerAs: 'dlg',
                templateUrl: 'app/main/apps/maps/dialogs/map-settings-dialog.html',
                parent: angular.element($element[0].ownerDocument.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                locals: {
                    limits: readViewLimits(vm.map.view),
                    onChange: function (limits) { applyViewLimits(limits); },
                    captureBounds: function () {
                        return glMap ? glMap.getBounds().toArray() : null;
                    },
                    setInitialView: function () { setInitialView(); }
                }
            }).then(angular.noop, function () {
                applyViewLimits(snapshot); // cancelar -> revertir los limites/config
            });
        }

        // Abre el dialogo de exportar a OBJ (elige radio e incluir o no la ciudad).
        function openExportDialog(ev) {
            // Se puede exportar aunque no haya figuras propias: el .obj puede llevar solo
            // ciudad (Mapbox) y/o topografia (Terrarium) alrededor del centro.
            $mdDialog.show({
                controller: ExportDialogController,
                controllerAs: 'dlg',
                templateUrl: 'app/main/apps/maps/dialogs/export-obj-dialog.html',
                parent: angular.element($element[0].ownerDocument.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    build: function (opts) { return buildExport(opts); }
                }
            }).then(function (result) {
                if (result && result.obj) {
                    downloadObj(result.obj, vm.map.title);
                }
            });
        }

        // Construye el OBJ segun las opciones. Sin ciudad -> solo nuestras figuras
        // (sincrono). Con ciudad -> baja edificios + agua + calles de Mapbox y combina.
        function buildExport(opts) {
            if (!opts || (!opts.includeCity && !opts.includeTerrain)) {
                return $q.resolve(mapsService.buildObj(vm.map));
            }
            var center = (vm.map.view && vm.map.view.center) ||
                (glMap ? [glMap.getCenter().lng, glMap.getCenter().lat] : [0, 0]);
            var cityP = opts.includeCity
                ? fetchCityLayers(center, opts.radiusKm)
                : $q.resolve({buildings: [], polylines: []});
            var terrainP = opts.includeTerrain
                ? fetchTerrain(center, opts.radiusKm)
                : $q.resolve(null);
            return $q.all([cityP, terrainP]).then(function (res) {
                var layers = res[0] || {buildings: [], polylines: []};
                return mapsService.buildObjWith(vm.map, layers.buildings, layers.polylines, res[1]);
            });
        }

        // Descarga el DEM (modelo de elevacion) de AWS Terrarium — GRATIS y SIN token —
        // alrededor del centro y radio, y devuelve una rejilla de cotas (metros) para
        // que buildObjWith monte la malla de terreno y drape encima el resto.
        // Terrarium: elevacion = (R*256 + G + B/256) - 32768. PNG via canvas -> pixeles.
        function fetchTerrain(center, radiusKm) {
            var doc = $element[0].ownerDocument;
            var win = doc.defaultView || window;
            var lat0 = center[1], lng0 = center[0];
            var dLat = radiusKm / 111.0;
            var dLng = radiusKm / (111.320 * Math.cos(lat0 * Math.PI / 180));
            var west = lng0 - dLng, east = lng0 + dLng, north = lat0 + dLat, south = lat0 - dLat;
            var Z = 13;
            var N = Math.min(200, Math.max(60, Math.round(radiusKm * 40))); // resolucion de la rejilla
            var pow = Math.pow(2, Z);

            function lon2gpx(l) { return (l + 180) / 360 * pow * 256; }
            function lat2gpx(l) { var r = l * Math.PI / 180; return (1 - Math.log(Math.tan(r) + 1 / Math.cos(r)) / Math.PI) / 2 * pow * 256; }

            var tx0 = Math.floor(lon2gpx(west) / 256), tx1 = Math.floor(lon2gpx(east) / 256);
            var ty0 = Math.floor(lat2gpx(north) / 256), ty1 = Math.floor(lat2gpx(south) / 256);

            var tiles = {};
            var jobs = [];
            for (var tx = tx0; tx <= tx1; tx++) {
                for (var ty = ty0; ty <= ty1; ty++) {
                    (function (x, y) {
                        jobs.push(loadTerrariumTile(doc, win, Z, x, y).then(function (im) {
                            if (im) { tiles[x + '_' + y] = im; }
                        }, function () { /* tile fallido (CORS/red): esa zona queda a 0 */ }));
                    })(tx, ty);
                }
            }

            return $q.when(Promise.all(jobs).then(function () {
                var elev = new Array(N * N);
                for (var r = 0; r < N; r++) {
                    var lat = north - (north - south) * (r / (N - 1));
                    for (var c = 0; c < N; c++) {
                        var lng = west + (east - west) * (c / (N - 1));
                        elev[r * N + c] = sampleTerrarium(tiles, Z, lng, lat);
                    }
                }
                return {
                    cols: N, rows: N, west: west, north: north,
                    dLng: (east - west) / (N - 1), dLat: (north - south) / (N - 1),
                    elev: elev
                };
            }));
        }

        // Carga un tile Terrarium a un canvas y devuelve su ImageData (o null si CORS
        // no lo permite -> el canvas se contamina y getImageData lanza).
        function loadTerrariumTile(doc, win, z, x, y) {
            return new Promise(function (resolve) {
                var img = new win.Image();
                img.crossOrigin = 'anonymous';
                img.onload = function () {
                    try {
                        var cv = doc.createElement('canvas');
                        cv.width = 256; cv.height = 256;
                        var g = cv.getContext('2d');
                        g.drawImage(img, 0, 0);
                        resolve(g.getImageData(0, 0, 256, 256));
                    } catch (e) {
                        resolve(null); // canvas contaminado (sin CORS)
                    }
                };
                img.onerror = function () { resolve(null); };
                img.src = 'https://s3.amazonaws.com/elevation-tiles-prod/terrarium/' + z + '/' + x + '/' + y + '.png';
            });
        }

        // Cota (m) en un punto muestreando el pixel Terrarium correspondiente.
        function sampleTerrarium(tiles, Z, lng, lat) {
            var pow = Math.pow(2, Z);
            var gx = (lng + 180) / 360 * pow * 256;
            var rr = lat * Math.PI / 180;
            var gy = (1 - Math.log(Math.tan(rr) + 1 / Math.cos(rr)) / Math.PI) / 2 * pow * 256;
            var tx = Math.floor(gx / 256), ty = Math.floor(gy / 256);
            var im = tiles[tx + '_' + ty];
            if (!im) { return 0; }
            var px = Math.floor(gx) % 256, py = Math.floor(gy) % 256;
            if (px < 0) { px += 256; }
            if (py < 0) { py += 256; }
            var idx = (py * 256 + px) * 4;
            var R = im.data[idx], G = im.data[idx + 1], B = im.data[idx + 2];
            return (R * 256 + G + B / 256) - 32768;
        }

        // Plantilla de URL de los vector tiles de OpenFreeMap. Se lee del TileJSON
        // (https://tiles.openfreemap.org/planet) porque la ruta lleva la VERSION del
        // planeta y cambia con cada actualizacion: no se puede hardcodear. Cacheada.
        var ofmTilesUrl = null;
        function getOfmTilesUrl() {
            if (ofmTilesUrl) { return $q.resolve(ofmTilesUrl); }
            var deferred = $q.defer();
            // fetch nativo (no $http): el interceptor de auth anade cabeceras que
            // disparan un preflight que tiles.openfreemap.org no necesita responder.
            fetch(OPENFREEMAP_TILEJSON).then(function (r) {
                if (!r.ok) { throw new Error('HTTP ' + r.status); }
                return r.json();
            }).then(function (json) {
                ofmTilesUrl = (json.tiles && json.tiles[0]) || null;
                if (!ofmTilesUrl) { throw new Error('SIN_TILES'); }
                deferred.resolve(ofmTilesUrl);
            }, function (err) {
                deferred.reject(err);
            });
            return deferred.promise;
        }

        // Descarga de los vector tiles de OpenFreeMap (alrededor de un centro y radio
        // en km): edificios (extruidos, con su altura), agua (caras planas) y calles
        // (lineas). Esquema OpenMapTiles, libre y SIN token.
        function fetchCityLayers(center, radiusKm) {
            if (!window.QiuMVT) { return $q.reject('NO_DECODER'); }

            return getOfmTilesUrl().then(function (tpl) {
                // OpenMapTiles llega hasta z14 (Mapbox Streets daba z15).
                var Z = 14, lat0 = center[1];
                var dLat = radiusKm / 111.0;
                var dLng = radiusKm / (111.320 * Math.cos(lat0 * Math.PI / 180));
                var pow = Math.pow(2, Z);
                function lon2x(l) { return Math.floor((l + 180) / 360 * pow); }
                function lat2y(l) { var r = l * Math.PI / 180; return Math.floor((1 - Math.log(Math.tan(r) + 1 / Math.cos(r)) / Math.PI) / 2 * pow); }
                var x0 = lon2x(center[0] - dLng), x1 = lon2x(center[0] + dLng);
                var y0 = lat2y(center[1] + dLat), y1 = lat2y(center[1] - dLat);

                var tiles = [];
                for (var x = x0; x <= x1; x++) {
                    for (var y = y0; y <= y1; y++) { tiles.push({x: x, y: y}); }
                }

                var state = {
                    buildings: [], polylines: [],
                    seenB: {}, seenW: {}, seenR: {},
                    nb: 0, nw: 0, nr: 0
                };
                var jobs = tiles.map(function (tile) {
                    var url = tpl.replace('{z}', Z).replace('{x}', tile.x).replace('{y}', tile.y);
                    return fetch(url).then(function (r) {
                        return r.ok ? r.arrayBuffer() : null;
                    }).then(function (buf) {
                        if (buf) { collectTile(buf, tile, Z, state); }
                    }).catch(function () { /* tile fallido: se ignora */ });
                });

                return $q.when(Promise.all(jobs).then(function () {
                    return {buildings: state.buildings, polylines: state.polylines};
                }));
            });
        }

        function collectTile(buf, tile, Z, s) {
            var vt = new window.QiuMVT.VectorTile(new window.QiuMVT.PbfReader(new Uint8Array(buf)));
            var i, f, p, gj;

            // Edificios -> extruidos de render_min_height a render_height (esquema
            // OpenMapTiles; en Mapbox Streets eran min_height/height + extrude).
            var bl = vt.layers.building;
            for (i = 0; bl && i < bl.length; i++) {
                f = bl.feature(i); p = f.properties || {};
                if (String(p.hide_3d) === 'true') { continue; }
                var h = parseFloat(p.render_height) || 0, mh = parseFloat(p.render_min_height) || 0;
                if (h <= mh) { continue; }
                if (dupById(s.seenB, f.id)) { continue; }
                gj = f.toGeoJSON(tile.x, tile.y, Z);
                eachExtGeometry(gj.geometry, function (ring) {
                    s.buildings.push({coords: ring, baseH: mh, topH: h, name: 'MB_b' + (s.nb++)});
                });
            }

            // Agua -> caras planas a z=0
            var wl = vt.layers.water;
            for (i = 0; wl && i < wl.length; i++) {
                f = wl.feature(i);
                if (dupById(s.seenW, f.id)) { continue; }
                gj = f.toGeoJSON(tile.x, tile.y, Z);
                eachExtGeometry(gj.geometry, function (ring) {
                    s.buildings.push({coords: ring, baseH: 0, topH: 0, name: 'WATER_w' + (s.nw++)});
                });
            }

            // Calles -> lineas a z=0 ('transportation' en OpenMapTiles; 'road' en Mapbox)
            var rl = vt.layers.transportation;
            for (i = 0; rl && i < rl.length; i++) {
                f = rl.feature(i);
                if (dupById(s.seenR, f.id)) { continue; }
                gj = f.toGeoJSON(tile.x, tile.y, Z);
                eachLineGeometry(gj.geometry, function (line) {
                    s.polylines.push({coords: line, name: 'ROAD_r' + (s.nr++)});
                });
            }
        }

        // Dedup por id de feature (los que cruzan el borde de un tile aparecen 2 veces)
        function dupById(seen, id) {
            if (id == null) { return false; }
            if (seen[id]) { return true; }
            seen[id] = true;
            return false;
        }

        function eachExtGeometry(geom, cb) {
            if (!geom) { return; }
            if (geom.type === 'Polygon') { cb(geom.coordinates[0]); }
            else if (geom.type === 'MultiPolygon') {
                geom.coordinates.forEach(function (poly) { cb(poly[0]); });
            }
        }

        function eachLineGeometry(geom, cb) {
            if (!geom) { return; }
            if (geom.type === 'LineString') { cb(geom.coordinates); }
            else if (geom.type === 'MultiLineString') {
                geom.coordinates.forEach(function (line) { cb(line); });
            }
        }

        // Descarga un string OBJ como fichero .obj
        function downloadObj(obj, title) {
            var doc = $element[0].ownerDocument;
            var win = doc.defaultView || window;
            var urlApi = win.URL || win.webkitURL;
            var blob = new win.Blob([obj], {type: 'text/plain;charset=utf-8'});
            var url = urlApi.createObjectURL(blob);
            var a = doc.createElement('a');
            a.href = url;
            a.download = ((title || 'map').replace(/[^\w.-]+/g, '_') || 'map') + '.obj';
            doc.body.appendChild(a);
            a.click();
            doc.body.removeChild(a);
            $timeout(function () { urlApi.revokeObjectURL(url); }, 1000);
        }

        // Alterna vista plana (cenital) / 3D (inclinada) para apreciar los volumenes.
        // El pitch resultante se guarda con la vista del mapa.
        function toggle3d() {
            if (!glMap) {
                return;
            }
            vm.is3d = !vm.is3d;
            glMap.easeTo({
                pitch: vm.is3d ? 60 : 0,
                duration: 600
            });
            markDirty();
        }

        // Vista LIVE de la camara (para previews que deben seguir a lo que se ve, p.ej.
        // el editor de estilos). NO es la vista inicial guardada del mapa.
        function currentView() {
            var view = angular.copy(vm.map.view) || {};
            if (glMap) {
                var center = glMap.getCenter();
                view.center = [center.lng, center.lat];
                view.zoom = glMap.getZoom();
                view.pitch = glMap.getPitch();
                view.bearing = glMap.getBearing();
            }
            return view;
        }

        // Fija la vista inicial del mapa = camara actual (posicion/zoom/inclinacion/giro).
        // Es la vista a la que el viewer publico arranca y a la que vuelve el boton "inicio".
        function setInitialView() {
            if (!glMap) { return; }
            var v = vm.map.view = vm.map.view || {};
            var c = glMap.getCenter();
            v.center = [c.lng, c.lat];
            v.zoom = glMap.getZoom();
            v.pitch = glMap.getPitch();
            v.bearing = glMap.getBearing();
            markDirty();
            toast($translate.instant('MAPS.INITIAL_VIEW_SET'));
        }

        // Coloca un elemento de tipo punto (pin, modelo) por lat/lng escritos a mano.
        // Se llama al editar los campos del panel; ignora valores incompletos/invalidos.
        function onCoordsChanged() {
            var f = vm.selected;
            if (!f || !f.geometry || f.geometry.type !== 'Point') { return; }
            var lng = Number(f.geometry.coordinates[0]);
            var lat = Number(f.geometry.coordinates[1]);
            if (!isFinite(lng) || !isFinite(lat) || lat < -90 || lat > 90 || lng < -180 || lng > 180) {
                return; // valor a medio escribir o fuera de rango: no movemos aun
            }
            if (markers[f.id]) { markers[f.id].setLngLat([lng, lat]); }
            if (is3dObject(f) && glMap) { glMap.triggerRepaint(); }
            markDirty();
        }

        function save() {
            if (vm.saving) {
                return;
            }

            if (!vm.map.title || !vm.map.title.trim()) {
                toast($translate.instant('MAPS.NAME_REQUIRED'));
                return;
            }

            vm.saving = true;
            // La vista inicial es EXPLICITA (boton "fijar vista inicial"), ya no se
            // captura la camara en cada guardado. Solo la sembramos si el mapa aun no
            // tiene una (mapa nuevo), para que el viewer tenga a donde arrancar.
            var v = vm.map.view = vm.map.view || {};
            if (!v.center && glMap) {
                var c = glMap.getCenter();
                v.center = [c.lng, c.lat];
                v.zoom = glMap.getZoom();
                v.pitch = glMap.getPitch();
                v.bearing = glMap.getBearing();
            }

            mapsService.saveMap(vm.siteId, vm.map).then(function (result) {
                vm.saving = false;
                vm.dirty = false;
                // Si era un mapa nuevo, adoptamos el id devuelto para que a partir
                // de ahora los guardados sean updates y no vuelvan a crear.
                if (!vm.map.id && result && result.id) {
                    vm.map.id = result.id;
                }
                toast($translate.instant('MAPS.SAVED'));
                vm.onSaved({result: result});
            }, function () {
                vm.saving = false;
                toast($translate.instant('MAPS.SAVE_ERROR'));
            });
        }

        function clearMarkers() {
            angular.forEach(markers, function (marker) {
                try {
                    marker.remove();
                } catch (e) {
                    // el contenedor puede estar ya desconectado del DOM
                }
            });
            markers = {};
        }

        function destroyMap() {
            if (createTimer) {
                $timeout.cancel(createTimer);
                createTimer = null;
            }
            clearMarkers();
            if (middleDragCleanup) {
                middleDragCleanup();
                middleDragCleanup = null;
            }
            // Gestos a medias (trazo libre, arrastre de zona, circulo): el mapa que los
            // sostenia se va, sus handlers con el, y no deben sobrevivir al siguiente.
            // El trazo libre ademas cuelga listeners del documento: hay que soltarlos.
            if (freehandDrag) {
                releaseFreehand(freehandDrag);
                freehandDrag = null;
            }
            dragZone = null;
            circleDrag = null;
            setPendingShape(null);
            // Las capas 3D mueren con el mapa (glMap.remove()); soltamos las refs para
            // que un mapa nuevo no crea que ya existen y las vuelva a anadir.
            modelLayers = {};
            // glDraw se destruye con el mapa (glMap.remove()); solo soltamos la ref
            glDraw = null;
            if (glMap) {
                try {
                    glMap.remove();
                } catch (e) {
                    // Mapbox puede lanzar si Angular ya quito el contenedor del DOM;
                    // el mapa queda igualmente inutilizable, seguimos con glMap = null
                }
                glMap = null;
            }
        }

        function toast(message) {
            $mdToast.show($mdToast.simple().textContent(message).position('top right').hideDelay(3000));
        }
    }

    // Controlador del dialogo de exportar OBJ. `build(opts)` (inyectado como local)
    // devuelve una promesa con el string OBJ; aqui solo gestionamos la UI/spinner.
    ExportDialogController.$inject = ['$mdDialog', 'build'];
    function ExportDialogController($mdDialog, build) {
        var dlg = this;
        dlg.includeCity = true;
        dlg.includeTerrain = false;
        dlg.radiusKm = 3;
        dlg.working = false;
        dlg.error = false;

        dlg.cancel = function () {
            $mdDialog.cancel();
        };

        dlg.run = function () {
            dlg.working = true;
            dlg.error = false;
            build({includeCity: dlg.includeCity, includeTerrain: dlg.includeTerrain, radiusKm: dlg.radiusKm})
                .then(function (obj) {
                    $mdDialog.hide({obj: obj});
                })
                .catch(function () {
                    dlg.working = false;
                    dlg.error = true;
                });
        };
    }

    // Dialogo de configuracion del mapa (limites de zoom/inclinacion/encuadre y
    // bloqueo de rotacion). Aplica en vivo via onChange; `captureBounds` devuelve el
    // encuadre actual del mapa para fijarlo como limite de desplazamiento.
    MapSettingsDialogController.$inject = ['$mdDialog', 'limits', 'onChange', 'captureBounds', 'setInitialView'];
    function MapSettingsDialogController($mdDialog, limits, onChange, captureBounds, setInitialView) {
        var dlg = this;
        dlg.limits = limits;

        dlg.change = function () {
            onChange(dlg.limits);
        };

        dlg.setInitialView = function () {
            setInitialView();
        };

        dlg.hasBounds = function () {
            return !!dlg.limits.maxBounds;
        };

        dlg.setBoundsToCurrent = function () {
            dlg.limits.maxBounds = captureBounds();
            dlg.change();
        };

        dlg.clearBounds = function () {
            dlg.limits.maxBounds = null;
            dlg.change();
        };

        dlg.close = function () {
            $mdDialog.hide();
        };

        dlg.cancel = function () {
            $mdDialog.cancel();
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('app.maps')
        .factory('mapboxLoader', mapboxLoader);

    /**
     * Carga bajo demanda el motor de mapas y sus plugins. Se inyecta la primera vez
     * que se abre un mapa, no en cada carga del admin.
     *
     * Motor unico: MapLibre GL JS + OpenFreeMap (libre, SIN token ni cuenta). Ya no
     * se carga Mapbox GL ni se usa ningun servicio de Mapbox.
     *
     * @ngInject
     */
    function mapboxLoader($q, $document, $window) {

        var MAPLIBRE_VERSION = '4.7.1';
        var MAPLIBRE_JS = 'https://unpkg.com/maplibre-gl@' + MAPLIBRE_VERSION + '/dist/maplibre-gl.js';
        var MAPLIBRE_CSS = 'https://unpkg.com/maplibre-gl@' + MAPLIBRE_VERSION + '/dist/maplibre-gl.css';

        // Plugin de dibujo. El paquete se llama @mapbox/mapbox-gl-draw pero funciona
        // sobre MapLibre y no habla con ningun servicio: se sirve desde unpkg para no
        // depender de la infraestructura de Mapbox.
        var DRAW_VERSION = '1.5.0';
        var DRAW_JS = 'https://unpkg.com/@mapbox/mapbox-gl-draw@' + DRAW_VERSION + '/dist/mapbox-gl-draw.js';
        var DRAW_CSS = 'https://unpkg.com/@mapbox/mapbox-gl-draw@' + DRAW_VERSION + '/dist/mapbox-gl-draw.css';

        // three.js r136 (build GLOBAL, no ESM) + GLTFLoader para modelos 3D (.glb).
        var THREE_VERSION = '0.136.0';
        var THREE_JS = 'https://unpkg.com/three@' + THREE_VERSION + '/build/three.min.js';
        var GLTF_JS = 'https://unpkg.com/three@' + THREE_VERSION + '/examples/js/loaders/GLTFLoader.js';

        var loadingMaplibre = null;
        var loadingDraw = null;
        var loadingThree = null;

        return {
            load: load,
            loadDraw: loadDraw,
            loadThree: loadThree
        };

        /**
         * Carga el motor de render (MapLibre).
         * @returns {Promise} resuelve con window.maplibregl
         */
        function load() {
            return loadMaplibre();
        }

        function loadMaplibre() {
            if ($window.maplibregl) {
                return $q.resolve($window.maplibregl);
            }
            if (loadingMaplibre) {
                return loadingMaplibre;
            }
            injectCss(MAPLIBRE_CSS, 'data-maplibre-gl');
            loadingMaplibre = injectScript(MAPLIBRE_JS, 'maplibregl').then(null, function (err) {
                loadingMaplibre = null;
                return $q.reject(err);
            });
            return loadingMaplibre;
        }

        // Inyecta un <script> y resuelve con el global esperado (globalName).
        function injectScript(url, globalName) {
            var deferred = $q.defer();
            var script = $document[0].createElement('script');
            script.src = url;
            script.async = true;
            script.onload = function () {
                if ($window[globalName]) {
                    deferred.resolve($window[globalName]);
                } else {
                    deferred.reject('LOAD_FAILED');
                }
            };
            script.onerror = function () {
                deferred.reject('LOAD_FAILED');
            };
            $document[0].head.appendChild(script);
            return deferred.promise;
        }

        /**
         * Carga three.js (global) + GLTFLoader para renderizar modelos 3D (.glb).
         * Se carga bajo demanda (solo si el mapa usa modelos). GLTFLoader se anade
         * DESPUES de three (depende de la global THREE).
         * @returns {Promise} resuelve con window.THREE (con THREE.GLTFLoader)
         */
        function loadThree() {
            if ($window.THREE && $window.THREE.GLTFLoader) {
                return $q.resolve($window.THREE);
            }
            if (loadingThree) {
                return loadingThree;
            }
            loadingThree = injectScript(THREE_JS, 'THREE').then(function () {
                return injectScript(GLTF_JS, 'THREE'); // adjunta THREE.GLTFLoader
            }).then(function () {
                return $window.THREE;
            }, function (err) {
                loadingThree = null;
                return $q.reject(err);
            });
            return loadingThree;
        }

        /**
         * Carga mapbox-gl-draw (herramienta de dibujo de poligonos) bajo demanda.
         * Requiere que Mapbox GL ya este cargado.
         * @returns {Promise} resuelve con window.MapboxDraw
         */
        function loadDraw() {
            if ($window.MapboxDraw) {
                return $q.resolve($window.MapboxDraw);
            }
            if (loadingDraw) {
                return loadingDraw;
            }

            var deferred = $q.defer();
            loadingDraw = deferred.promise;

            injectCss(DRAW_CSS, 'data-mapbox-draw');

            var script = $document[0].createElement('script');
            script.src = DRAW_JS;
            script.async = true;
            script.onload = function () {
                if ($window.MapboxDraw) {
                    deferred.resolve($window.MapboxDraw);
                } else {
                    loadingDraw = null;
                    deferred.reject('DRAW_LOAD_FAILED');
                }
            };
            script.onerror = function () {
                loadingDraw = null;
                deferred.reject('DRAW_LOAD_FAILED');
            };
            $document[0].head.appendChild(script);

            return loadingDraw;
        }

        function injectCss(url, marker) {
            if (!url || $document[0].querySelector('link[' + marker + ']')) {
                return;
            }
            var link = $document[0].createElement('link');
            link.rel = 'stylesheet';
            link.href = url;
            link.setAttribute(marker, '1');
            $document[0].head.appendChild(link);
        }
    }
})();

(function ()
{
    'use strict';

    angular.module('app.gantt-chart')
        .controller('GanttChartController', GanttChartController);

    /** @ngInject */
    function GanttChartController($mdDialog, $document, $animate, $scope, $timeout, ganttUtils, GanttObjectModel, ganttDebounce, moment, Tasks, Timespans, $window, $mdSidenav, msApi)
    {
        var vm = this;
        var objectModel;

        // Data
        vm.live = {};
        vm.options = {
            mode                    : 'custom',
            scale                   : 'day',
            sortMode                : undefined,
            sideMode                : 'Tree',
            daily                   : true,
            maxHeight               : 300,
            width                   : true,
            zoom                    : 1,
            rowSortable             : true,
            columns                 : ['model.name', 'from', 'to'],
            treeTableColumns        : ['from', 'to'],
            columnsHeaders          : {
                'model.name': 'Name',
                'from'      : 'Start Time',
                'to'        : 'End Time'
            },
            columnsClasses          : {
                'model.name': 'gantt-column-name',
                'from'      : 'gantt-column-from',
                'to'        : 'gantt-column-to'
            },
            columnsFormatters       : {
                'from': function (from)
                {
                    return angular.isDefined(from) ? from.format('lll') : undefined;
                },
                'to'  : function (to)
                {
                    return angular.isDefined(to) ? to.format('lll') : undefined;
                }
            },
            treeHeaderContent       : '{{getHeader()}}',
            columnsHeaderContents   : {
                'model.name': '{{getHeader()}}',
                'from'      : '{{getHeader()}}',
                'to'        : '{{getHeader()}}'
            },
            autoExpand              : 'both',
            taskOutOfRange          : 'truncate',
            fromDate                : '',
            toDate                  : '',
            rowContentEnabled       : true,
            rowContent              : '{{row.model.name}}',
            taskContentEnabled      : true,
            taskContent             : '<i ng-click="scope.vm.editDialog($event, \'task\', task)" class="gantt-task-edit-button icon-pencil s12 icon"\n   aria-label="edit task">\n</i>\n<span class="gantt-task-name">\n    {{task.model.name}}\n    <md-tooltip md-direction="top" class="gantt-chart-task-tooltip">\n        <div layout="column" layout-align="center center">\n            <div class="tooltip-name">\n                {{task.model.name}}\n            </div>\n            <div class="tooltip-date">\n                <span>\n                    {{task.model.from.format(\'MMM DD, HH:mm\')}}\n                </span>\n                <span>-</span>\n                <span>\n                    {{task.model.to.format(\'MMM DD, HH:mm\')}}\n                </span>\n            </div>\n        </div>\n    </md-tooltip>\n</span>',
            allowSideResizing       : false,
            labelsEnabled           : true,
            currentDate             : 'line',
            currentDateValue        : new Date(),
            draw                    : true,
            readOnly                : false,
            groupDisplayMode        : 'group',
            filterTask              : '',
            filterRow               : '',
            timeFrames              : {
                'day'    : {
                    start  : moment('8:00', 'HH:mm'),
                    end    : moment('20:00', 'HH:mm'),
                    working: true,
                    default: true
                },
                'noon'   : {
                    start  : moment('12:00', 'HH:mm'),
                    end    : moment('13:30', 'HH:mm'),
                    working: false,
                    default: true
                },
                'weekend': {
                    working: false
                },
                'holiday': {
                    working: false,
                    color  : 'red',
                    classes: ['gantt-timeframe-holiday']
                }
            },
            dateFrames              : {
                'weekend'    : {
                    evaluator: function (date)
                    {
                        return date.isoWeekday() === 6 || date.isoWeekday() === 7;
                    },
                    targets  : ['weekend']
                },
                '11-november': {
                    evaluator: function (date)
                    {
                        return date.month() === 10 && date.date() === 11;
                    },
                    targets  : ['holiday']
                }
            },
            timeFramesWorkingMode   : 'hidden',
            timeFramesNonWorkingMode: 'visible',
            columnMagnet            : '15 minutes',
            timeFramesMagnet        : true,
            dependencies            : true,
            canDraw                 : function (event)
            {
                var isLeftMouseButton = event.button === 0 || event.button === 1;
                return vm.options.draw && !vm.options.readOnly && isLeftMouseButton;
            },
            drawTaskFactory         : function ()
            {
                return {
                    id   : ganttUtils.randomUuid(),  // Unique id of the task.
                    name : 'Drawn task', // Name shown on top of each task.
                    color: '#AA8833' // Color of the task in HEX format (Optional).
                };
            },
            api                     : function (ganttApi)
            {
                // API Object is used to control methods and events from angular-gantt.
                vm.api = ganttApi;

                vm.api.core.on.ready($scope, function ()
                {
                    // When gantt is ready, load data.
                    // `data` attribute could have been used too.
                    vm.load();

                    // DOM events
                    vm.api.directives.on.new($scope, function (directiveName, directiveScope, element)
                    {
                        /**
                         * Gantt Task
                         */
                        if ( directiveName === 'ganttTask' )
                        {
                            element.on('mousedown touchstart', function (event)
                            {
                                event.preventDefault();
                                event.stopPropagation();
                                vm.live.row = directiveScope.task.row.model;
                                if ( angular.isDefined(directiveScope.task.originalModel) )
                                {
                                    vm.live.task = directiveScope.task.originalModel;
                                }
                                else
                                {
                                    vm.live.task = directiveScope.task.model;
                                }
                                $scope.$digest();
                            });

                        }

                        /**
                         * Gantt Row
                         */
                        else if ( directiveName === 'ganttRow' )
                        {

                            element.on('click', function (event)
                            {
                                event.stopPropagation();
                            });

                            element.on('mousedown touchstart', function (event)
                            {
                                event.stopPropagation();
                                vm.live.row = directiveScope.row.model;
                                $scope.$digest();
                            });

                        }

                        /**
                         * Gantt Row Label
                         */
                        else if ( directiveName === 'ganttRowLabel' )
                        {
                            // Fix for double trigger due to gantt-sortable plugin
                            element.off('click');

                            element.on('click', function (event)
                            {
                                event.preventDefault();
                                editDialog(event, 'row', directiveScope.row);
                            });

                            element.on('mousedown touchstart', function ()
                            {
                                vm.live.row = directiveScope.row.model;
                                $scope.$digest();
                            });

                        }
                    });

                    vm.api.tasks.on.rowChange($scope, function (task)
                    {
                        vm.live.row = task.row.model;
                    });

                    objectModel = new GanttObjectModel(vm.api);
                });
            }
        };

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.search = search;
        vm.setSortMode = setSortMode;
        vm.addDialog = addDialog;
        vm.editDialog = editDialog;
        vm.canAutoWidth = canAutoWidth;
        vm.getColumnWidth = getColumnWidth;
        vm.load = load;
        vm.reload = reload;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Set Gantt Chart height at the init
            calculateHeight();

            angular.element($window).on('resize', function ()
            {
                $scope.$apply(function ()
                {
                    calculateHeight();
                });
            });
        }

        /**
         * Max Height Fix
         */
        function calculateHeight()
        {
            vm.options.maxHeight = $document.find('#chart-container').offsetHeight;
        }

        /**
         * Add New Row
         */
        function addDialog(ev)
        {
            $mdDialog.show({
                controller         : 'GanttChartAddEditDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/gantt-chart/dialogs/add-edit/add-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    dialogData: {
                        chartData : vm.data,
                        dialogType: 'add'
                    }
                }
            });
        }

        /**
         * Edit Dialog
         */
        function editDialog(ev, formView, formData)
        {
            $mdDialog.show({
                controller         : 'GanttChartAddEditDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/gantt-chart/dialogs/add-edit/edit-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    dialogData: {
                        chartData : vm.data,
                        dialogType: 'edit',
                        formView  : formView,
                        formData  : formData
                    }
                }
            });
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Search
         * @param sidenavId
         */
        function search(option, keyword)
        {
            if ( option === 'rows' )
            {
                vm.options.filterRow = keyword;
            }
            else if ( option === 'tasks' )
            {
                vm.options.filterTask = keyword;
            }
        }

        /**
         * Sort Mode
         * @param mode
         */
        function setSortMode(mode)
        {
            vm.options.sortMode = mode;

            if ( angular.isUndefined(mode) )
            {
                vm.options.rowSortable = true;
            }
            else
            {
                vm.options.rowSortable = false;
            }
        }

        /**
         * Side Mode
         */
        $scope.$watch('vm.options.sideMode', function (newValue, oldValue)
        {
            if ( newValue !== oldValue )
            {
                vm.api.side.setWidth(undefined);

                $timeout(function ()
                {
                    vm.api.columns.refresh();
                });
            }
        });

        function canAutoWidth(scale)
        {
            if ( scale.match(/.*?hour.*?/) || scale.match(/.*?minute.*?/) )
            {
                return false;
            }

            return true;
        }

        function getColumnWidth(widthEnabled, scale, zoom)
        {
            if ( !widthEnabled && vm.canAutoWidth(scale) )
            {
                return undefined;
            }

            if ( scale.match(/.*?week.*?/) )
            {
                return 150 * zoom;
            }

            if ( scale.match(/.*?month.*?/) )
            {
                return 300 * zoom;
            }

            if ( scale.match(/.*?quarter.*?/) )
            {
                return 500 * zoom;
            }

            if ( scale.match(/.*?year.*?/) )
            {
                return 800 * zoom;
            }

            return 40 * zoom;
        }

        // Reload data action
        function load()
        {
            vm.data = Tasks.data;
            vm.timespans = Timespans.data;

            // Fix for Angular-gantt-chart issue
            $animate.enabled(true);
            $animate.enabled($document.find('#gantt'), false);

        }

        /**
         * Reload Data
         */
        function reload()
        {
            msApi.resolve('ganttChart.tasks@get', function (response)
            {
                vm.data = response.data;
            });

            msApi.resolve('ganttChart.timespans@get', function (response)
            {
                vm.timespans = response.data;
            });
        }

        // Visual two way binding.
        var ganttDebounceValue = 1000;

        var listenTaskJson = ganttDebounce(function (taskJson)
        {
            if ( angular.isDefined(taskJson) )
            {
                var task = angular.fromJson(taskJson);
                objectModel.cleanTask(task);
                var model = vm.live.task;
                angular.extend(model, task);
            }
        }, ganttDebounceValue);

        $scope.$watch('vm.live.taskJson', listenTaskJson);

        var listenRowJson = ganttDebounce(function (rowJson)
        {
            if ( angular.isDefined(rowJson) )
            {
                var row = angular.fromJson(rowJson);
                objectModel.cleanRow(row);
                var tasks = row.tasks;

                delete row.tasks;
                var rowModel = vm.live.row;

                angular.extend(rowModel, row);

                var newTasks = {};
                var i, l;

                if ( angular.isDefined(tasks) )
                {
                    for ( i = 0, l = tasks.length; i < l; i++ )
                    {
                        objectModel.cleanTask(tasks[i]);
                    }

                    for ( i = 0, l = tasks.length; i < l; i++ )
                    {
                        newTasks[tasks[i].id] = tasks[i];
                    }

                    if ( angular.isUndefined(rowModel.tasks) )
                    {
                        rowModel.tasks = [];
                    }

                    for ( i = rowModel.tasks.length - 1; i >= 0; i-- )
                    {
                        var existingTask = rowModel.tasks[i];
                        var newTask = newTasks[existingTask.id];

                        if ( angular.isUndefined(newTask) )
                        {
                            rowModel.tasks.splice(i, 1);
                        }
                        else
                        {
                            objectModel.cleanTask(newTask);
                            angular.extend(existingTask, newTask);

                            delete newTasks[existingTask.id];
                        }
                    }
                }
                else
                {
                    delete rowModel.tasks;
                }

                angular.forEach(newTasks, function (newTask)
                {
                    rowModel.tasks.push(newTask);
                });
            }
        }, ganttDebounceValue);

        $scope.$watch('vm.live.rowJson', listenRowJson);

        $scope.$watchCollection('vm.live.task', function (task)
        {
            vm.live.taskJson = angular.toJson(task, true);
            vm.live.rowJson = angular.toJson(vm.live.row, true);
        });

        $scope.$watchCollection('vm.live.row', function (row)
        {
            vm.live.rowJson = angular.toJson(row, true);
            if ( angular.isDefined(row) && angular.isDefined(row.tasks) && row.tasks.indexOf(vm.live.task) < 0 )
            {
                vm.live.task = row.tasks[0];
            }
        });

        $scope.$watchCollection('vm.live.row.tasks', function ()
        {
            vm.live.rowJson = angular.toJson(vm.live.row, true);
        });
    }

})();

(function () {
  'use strict';

  $(window.document).on('contextmenu', '.list-media-item', function (e) {
    var menu = $('#context-menu');

    if (e.pageX >= window.innerWidth - menu.width()) {
      e.pageX -= menu.width();
    }
    if (e.pageY >= window.innerHeight - menu.height()) {
      e.pageY -= menu.height();
    }

    var posx = 0;
    var posy = 0;

    if (!e)
      var e = window.event;

    posx = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
    posy = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;

    menu.hide().css({
      left: e.pageX,
      top: e.pageY
      // left: posx,
      // top: posy
    }).show();

    e.preventDefault();
  });

  angular
    .module('app.mailing')
    .controller('TemplateController', TemplateController);



  /** @ngInject */
  function TemplateController($scope, $rootScope, $document, $mdDialog, $mdMenu, $mdMedia, $mdToast, $mdConstant, $mdSidenav, $state, requestContext, $timeout, mailingService, transformMailing, fieldsTemplateMailing, msUtils, $anchorScroll, $translate, sessionService, tinyMceService, $window, mediaService, sharedFunctionsMailing, section, templateBuilderConfig, $http, $filter) {
    /*
        Object.keys(templateBuilderConfig.blocks).forEach(function (key) {
          if (templateBuilderConfig.disableBlocks.indexOf(key) === -1) {
            $http.get('app/main/plugins/template-builder/fields/' + templateBuilderConfig.blocks[key].type + '.html').then(function(response) {
              $templateCache.put(templateBuilderConfig.blocks[key].type + 'Template', response.data);
            })
          }
        });
    */
    var vm = this;

    $scope.section = section;
    $scope.array = [{
      active: true,
      value: 'Copy'
    }, {
      active: true,
      value: 'Cut'
    }, {
      active: false,
      value: 'Paste'
    }];

    vm.selectedIndex = 0;
    vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg', 'red-bg', 'yellow-bg', 'light-blue-bg'];
    vm.testEmails = [];
    vm.selectedAccount = 'creapond';

    vm.mailingToContent = [];
    vm.folders = [];
    vm.labels = [];
    vm.loadingThreads = true;
    vm.enterfirst = true;
    vm.tags = null;
    vm.searchTagText = null;
    vm.selectedTag = null;
    vm.tinymceOptions = tinyMceService.getOptions($scope);
    vm.selectedIndexTab = 0;


    vm.typeFields = ['separator', 'relatedTable', 'textBox', 'media', 'htmlBox', 'colorPicker', 'checkbox', 'datePicker', 'group', 'lineSeparator', 'previewLink', 'social'];
    vm.keys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA];

    vm.scrollEl = angular.element('#thread-list')[0];

    vm.currentFilter = {
      type: $state.params.type,
      filter: $state.params.filter
    };
    vm.currentThread = null;
    vm.currentThread_Edit = null;
    vm.selectedThreads = [];
    vm.basicForm = {};
    vm.footerThumbnail = [];
    vm.nofooterThumbnail = [];
    vm.default_users_groups = [];
    vm.openTemplateView = openTemplateView;

    vm.views = {
      nosplit: 'app/main/apps/mailing/views/template/list/nosplit-view.html',
      split: 'app/main/apps/mailing/views/template/list/split-view.html',
      grid: 'app/main/apps/mailing/views/template/grid/grid-view.html'
    };
    vm.defaultView = 'split';
    vm.currentView = 'split';
    vm.loadingView = true;

    vm.defaultTemplateView = 'edit';
    vm.currentTemplateView = 'edit';

    vm.mediaZones = [];

    vm.currentFilter = {
      type: $state.params.type,
      filter: $state.params.filter
    };
    vm.currentThread = null;
    vm.currentThread_Edit = null;
    vm.selectedThreads = [];
    vm.basicForm = {};
    vm.noexistchangues = true;
    vm.fieldOrder = 'created_at';

    vm.templateSortable = {
      group: '.template',
      animation: 150,
      scroll: true,
      handle: '.drag',
      filter: '.no-sort',
      ghostClass: "sort-drop",
      onStart: function (evt) {
        vm.copyMock = angular.copy(vm.currentThread_Edit.structure_data_json);
      },
      onEnd: function (evt) {
        if (typeof evt.oldIndex == 'undefined' || typeof evt.newIndex == 'undefined') {
          return false
        }
        vm.copyMock = changePosition(evt.newIndex - 1, evt.oldIndex - 1, vm.copyMock);
        vm.currentThread_Edit.structure_data_json = vm.copyMock;
        vm.basicForm.$setDirty();
        return false;

      }
    }

    vm.mailingOptions = [];

    vm.mediaSortable = {
      group: 'media',
      animation: 150,
      scroll: true,
      filter: '.no-sort',
      handle: '.media',
      ghostClass: "sort-drop",
      onEnd: function (evt) {
        vm.basicForm.$setDirty();
      }
    };

    vm.viewGroupField = "app/main/apps/mailing/dialogs/group/group-view.html";
    vm.currentGroup;

    // Methods
    vm.siteLanguages = siteLanguages;

    vm.init = init;
    vm.getInArray = msUtils.getInArray;
    vm.toggleInArray = msUtils.toggleInArray;
    vm.toggleInGroup = msUtils.toggleInGroup;
    vm.getReferencesSections = mailingService.getReferencesSections;
    vm.getExtension = msUtils.getExtension;
    vm.getExtensionIcon = msUtils.getExtensionIcon;
    vm.getValuesReferencesSections = mailingService.getValuesReferencesSections;



    vm.newTemplate = newTemplate;
    vm.openTemplate = openTemplate;
    vm.closeThread = closeThread;
    vm.closeThreadEdit = closeThreadEdit;
    vm.deleteThread = deleteThread;
    vm.setSortField = setSortField;
    vm.setSortOrder = setSortOrder;

    vm.openUrl = openUrl;
    vm.toggleSelectThread = toggleSelectThread;
    vm.toggleSelectThreads = toggleSelectThreads;
    vm.isSelected = isSelected;
    vm.deselectThreads = deselectThreads;


    vm.changeView = changeView;
    vm.viewPreview = viewPreview;
    vm.saveItem = saveItem;



    vm.toggleSidenav = toggleSidenav;
    vm.updateThread = updateThread;


    vm.openMenu = openMenu;
    vm.editFieldStructure = editFieldStructure;
    vm.saveFieldStructure = saveFieldStructure;
    vm.cancelEditFieldStructure = cancelEditFieldStructure;
    vm.removeFieldStructure = removeFieldStructure;
    vm.addNewStructureField = addNewStructureField;
    vm.selectOrUnselect = selectOrUnselect;
    vm.openImageDialog = openImageDialog;
    vm.openFocalPoint = openFocalPoint;
    vm.openMediaItemMetadata = openMediaItemMetadata;
    vm.MediaItemRecrop = MediaItemRecrop;
    vm.deleteAttachment = deleteAttachment;
    vm.mediaDialog = mediaDialog;
    vm.groupDialog = groupDialog;
    vm.openUsersGroupsDialog = openUsersGroupsDialog;
    vm.deleteTarget = deleteTarget;
    vm.showDesignView = showDesignView;
    vm.showTemplatePlus = showTemplatePlus;

    vm.setTinyMceContent = setTinyMceContent;

    vm.callback = callback;
    vm.deleteItemArray = deleteItemArray;

    vm.editGroupField = editGroupField();
    vm.duplicateTemplate = duplicateTemplate;

    vm.translate = instantTranslate;

    vm.filterGroups = {
      groups: [],
      includeSubgroups: true
    }
    vm.toggleIncludeSubgroups = toggleIncludeSubgroups;
    vm.unselectGroups = unselectGroups;

    //////////

    init();

    /**
     * Initialize
     */
    function init() {
      var siteID = requestContext.getParam("siteId");

      vm.ActiveSection = {};
      vm.ActiveSection.edit = true;
      vm.ActiveSection.media = true;
      vm.ActiveSection.usersGroups = true;
      vm.ActiveSection.testUsers = true;
      vm.ActiveSection.advancedConfig = true;

      $scope.siteID = siteID;
      $scope.section = section;
      $rootScope.global.titleToolbar = '<i class="icon s20 icon-telegram mr-15" ng-if="node.icon"></i>MAILING<i class="mr-5 ml-5 icon s18 icon-chevron-right hide show-gt-xs"></i> <span class="hide show-gt-xs">' + section + '</span>';
      var options = {
        site: $scope.siteID,
        section: $scope.section
      };
      $scope.page = 1;

      initUsersGroups();

      initOptions();

      if ($state.params.id) {
        vm.openTemplate(null, $state.params.id);
      }

      // sessionService.loadDomainResourceSettings($scope.siteID).then(function (response){
      //   vm.splitContent = response.mailingHeaderContentSplitOption;
      // });

      vm.isAdmin = sessionService.user.is_admin;

      sessionService.loadDomainResourceSettings($scope.siteID).then(function (response){
        if(response.public){
          var publicConfig = angular.fromJson(response.public);
          if(publicConfig.mailToContent){
            vm.mailingToContent = publicConfig.mailToContent.sections;
          }
        }
        vm.splitContent = response.mailingHeaderContentSplitOption;
      });

    }

    function initMailingGroups() {
      mailingService.getMailingGroups({
        section: $scope.section,
        site: $scope.siteID
      }).then(function (response) {
        vm.filterGroups.groups = transformMailing.formatNestedGroups(response);
      });
    }

    function initUsersGroups() {
      mailingService.getUsersGroups({
        section: $scope.section,
        site: $scope.siteID,
        groupType: 2,
        withoutUsers: true,
        resultsPerPage: 1000
      }).then(function (response) {
        vm.usersGroups = transformMailing.formatNestedGroups(response);
      });
    }

    function initOptions() {
      mailingService.getOptions({
        site: $scope.siteID,
      })
        .then(function (response) {
          if (!angular.isUndefined(response.options)) {
            angular.forEach(response.options, function (val, key) {
              vm.mailingOptions[key] = val;
            })
          }
        });
    }

    function changePosition(newIndex, oldIndex, array) {
      if (oldIndex < newIndex) {
        for (var i = oldIndex; i < newIndex; i++) {
          var temp = array[i + 1];
          array[i + 1] = array[i];
          array[i] = temp;
        }
      }
      if (newIndex < oldIndex) {
        for (var i = oldIndex; i > newIndex; i--) {
          var temp = array[i - 1];
          array[i - 1] = array[i];
          array[i] = temp;
        }
      }

      vm.basicForm.$setDirty();
      return array;
    }

    // Watch screen size to change view modes
    $scope.$watch(function () {
      return $mdMedia('lt-sm');
    }, function (current, old) {
      if (angular.equals(current, old)) {
        return;
      }

      if (current) {
        vm.currentView = 'nosplit';
      }
    });

    $scope.$watch(function () {
      return $mdMedia('max-width: 960px');
    }, function (big) {

      if (big)
        vm.currentView = 'nosplit';

    });

    $scope.$watch(function () {
      return $mdMedia('min-width: 960px');
    }, function (small) {

      if (small)
        vm.currentView = 'split';

    });

    $scope.$watch(function () {
      return $mdMedia('gt-sm');
    }, function (current, old) {
      if (angular.equals(current, old)) {
        return;
      }

      if (current) {
        if (vm.defaultView === 'split') {
          vm.currentView = 'split';
        }
      }
    });

    $scope.$on('$includeContentLoaded', function (event, target) {
      $timeout(function () {
        vm.loadingView = false;
      }, 1000);
    });

    $scope.$on('pagination:loadStart', function (event) {
      // $anchorScroll();

      // Store the current scrollPos
      // vm.scrollPos = vm.scrollEl.scrollTop();

      // Scroll to the top
      // vm.scrollEl.scrollTop(0);
      if (!vm.enterfirst) {
        var elem = angular.element(document.getElementById('thread-list'));
        elem.scrollTopAnimated(0, 10);
      }

      // angular.element("#thread-list").scrollTop=0;

      vm.enterfirst = false;

      $scope.isLoading = true;
    });

    $scope.$on('pagination:loadPage', function (event) {
      $scope.isLoading = false;
      vm.dataAlreadyLoaded = true;
    });

    function setTinyMceContent(event) {
      var zoneMedia = {
        1: {},
        2: {},
        3: {},
        4: {}
      };
      var typesMax = {
        1: 0,
        2: 0,
        3: 0,
        4: 0
      };
      var currentSort = 0;
      var currentType = 0;

      return zoneMedia;
    }


    var originatorEv;

    function openMenu($mdMenu, ev) {
      originatorEv = ev;
      $mdMenu.open(ev);
    }


    /**
     * Open thread
     *
     * @param thread
     */
    function openTemplate(thread, id) {

      if (angular.element(document.getElementById('thread-detail')).length) {
        var elem = angular.element(document.getElementById('thread-detail'));
        elem.scrollTopAnimated(0, 10);
      }
      if (id != 'new') {
        if (thread) {
          vm.selectedContentID = thread.id_mailing_templates;
        } else {
          vm.selectedContentID = id;
        }

        vm.loadingReadPane = true;
        $state.go('app.site_overview.mailing.template.list.thread', {
          id: vm.selectedContentID
        }, {
          notify: false,
          inherit: true,
          location: true
        });

        var options = {
          site: $scope.siteID,
          section: $scope.section,
          id: vm.selectedContentID
        }

        mailingService.getByID(options).then(function (response) {
          response = transformMailing.validateTemplateFields(response);
          vm.currentThread_Edit = response;
          vm.selectedContent = response;
          vm.selectedContent.id = vm.selectedContentID;
          vm.loadingReadPane = false;
        }).catch(function (err) {
          var message = $translate.instant('GLOBAL.ERROR') + '<br>' + err.data.detail;
          $mdToast.show({
            template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
            hideDelay: 5000,
            position: 'top',
            parent: '#content-container'
          });
        });;
      } else {
        vm.selectedContent = thread;

        vm.selectedContent.id = 'new';
        vm.currentThread_Edit = angular.copy(thread);
        vm.loadingReadPane = false;
        vm.selectedIndexTab = 0;
      }
      vm.openTemplateView('edit');
    }

    function deleteThread() {

      for (var i = 0; i < vm.selectedThreads.length; i++) {
        var options = {
          site: $scope.siteID,
          section: $scope.section,
          id: vm.selectedThreads[i]['id_mailing_templates']
        };
        mailingService.deleteThread(options).then(function (response) {
          vm.loadingReadPane = false;
          $rootScope.pagination_resetquery();
          deselectThreads();
          vm.closeThreadEdit();
        });
      }
    }

    function setSortField(field) {
      vm.fieldOrder = field;
      $rootScope.pagination_setSortField(field, $rootScope.sortDir);
    }

    function setSortOrder(order) {
      $rootScope.sortDir = order;
      $rootScope.pagination_setSortField(vm.fieldOrde, $rootScope.sortDir);
    }


    function newTemplate() {
      if (angular.element(document.getElementById('thread-detail')).length) {
        var elem = angular.element(document.getElementById('thread-detail'));
        elem.scrollTopAnimated(0, 10);
      }

      vm.selectedContentID = '';
      vm.loadingReadPane = true;

      $state.go('app.site_overview.mailing.template.list.thread', {
        id: ''
      }, {});

      var newTemplate = transformMailing.createNewEmptyTemplate();
      vm.currentThread_Edit = newTemplate;
      vm.currentThread_Edit.structure_data_json = [];
      openTemplate(newTemplate, 'new');

    }


    function getCurrentLabels(template) {
      var usersGroupsAux = sharedFunctionsMailing.initUsersGroup(angular.copy(vm.usersGroups), angular.copy(template.default_users_groups_json));
      return sharedFunctionsMailing.getLabels(usersGroupsAux);
    }

    function closeThreadEdit() {
      resetScroll();
      vm.currentThread_Edit.structure_data_json = [];
      vm.currentThread_Edit = false;
      vm.selectedContentID = false;
      vm.templateSelected = false;
      vm.noexistchangues = true;
      vm.currentLabels = [];
      if (vm.currentView === 'split') {
        vm.selectedContent = false;
      }
      $state.go('app.site_overview.mailing.template.list', {
        id: ''
      }, {});
    }

    function editFieldStructure(index) {
      closeOthers();
      vm.copyStructure = angular.copy(vm.currentThread_Edit.structure_data_json[index]);
      vm.currentThread_Edit.structure_data_json[index].editing = true;
    }

    function closeOthers() {
      fieldsTemplateMailing.closeOthers(vm.currentThread_Edit.structure_data_json);
    }

    function saveFieldStructure(index) {
      vm.basicForm.$setDirty();
      fieldsTemplateMailing.saveFieldStructure(index, vm.currentThread_Edit.structure_data_json);
    }

    function cancelEditFieldStructure(index) {
      fieldsTemplateMailing.cancelEditFieldStructure(index, vm.currentThread_Edit.structure_data_json, vm.copyStructure);
    }

    function removeFieldStructure(index) {
      vm.basicForm.$setDirty();
      fieldsTemplateMailing.removeFieldStructure(index, vm.currentThread_Edit.structure_data_json, vm.noexistchangues);
    }

    function addNewStructureField() {
      fieldsTemplateMailing.addNewStructureField(vm.currentThread_Edit.structure_data_json);
    }

    /**
     * Close thread
     */
    function closeThread() {
      vm.editInline = false;

      vm.currentThread_Edit = false;
      vm.selectedContent = null;
      vm.selectedContentID = null;
      vm.currentThread_Edit.structure_data_json = [];
      vm.noexistchangues = true;

    }


    /**
     * Return checked status of the content
     *
     * @param content
     * @returns {boolean}
     */
    function saveItem(content) {
      if ($('#md-chips-email input') && $('#md-chips-email input')[0] && $('#md-chips-email input')[0].value) {
        $scope.addChips($('#md-chips-email input')[0].value, vm.currentThread_Edit.test_emails_json)
        $scope.validateEmail(vm.currentThread_Edit.test_emails_json);
        $('#md-chips-email input')[0].value = '';
      }
      if (content.id_mailing_domain) {
        var selectedDomain = $filter('filter')(vm.mailingOptions.domains, { 'id_mailing_domain': content.id_mailing_domain });
        if (selectedDomain.length) {
          content.from_email = content.from_email_nodomain + '@' + selectedDomain[0].domain_name;
        }
      }
      if(!content.structure_mjml_temp){
        content.structure_mjml_temp = null;
      }else if(typeof content.structure_mjml_temp != 'JSON'){
        content.structure_mjml_temp = JSON.parse(content.structure_mjml_temp);
      }

      var contentAux = angular.copy(content);

      if (contentAux.default_users_groups_json) {
        contentAux.default_users_groups_json = JSON.stringify(contentAux.default_users_groups_json);
      }
      if (contentAux.test_emails_json) {
        contentAux.test_emails_json = JSON.stringify(contentAux.test_emails_json);
      }
      if (contentAux.test_lang_json) {
        contentAux.test_lang_json = JSON.stringify(contentAux.test_lang_json);
      }
      if (contentAux.structure_data_json) {
        contentAux.structure_data_json = JSON.stringify(contentAux.structure_data_json);
      }
      if (contentAux.structure_mjml_temp) {
        contentAux.structure_mjml_temp = JSON.stringify(contentAux.structure_mjml_temp);
      }

      // var data = {
      //   'id_mailing_template': contentAux.id_mailing_template,
      //   'template_name': contentAux.template_name,
      //   'template_description': contentAux.template_description,
      //   'template_subject': contentAux.template_subject,
      //   'template_type': contentAux.template_type,
      //   'from_email': contentAux.from_email,
      //   'lang': contentAux.lang.id_lang,
      //   'default_users_groups_json': contentAux.default_users_groups_json,
      //   'test_emails': contentAux.test_emails_json,
      //   'test_lang': contentAux.test_lang_json,
      //   'structure_data_json': contentAux.structure_data_json,
      //   'structure_mjml_temp': contentAux.structure_mjml_temp
      // };

      //setMediaImage(content);
      var options = {
        site: $scope.siteID,
        section: $scope.section,
        id: content.id,
        item: content
      };
      mailingService.saveItem(options).then(function (response) {
        var message = $translate.instant('CONTENT.SAVED');
        $mdToast.show({
          template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
          hideDelay: 5000,
          position: 'top',
          parent: '#content-container'
        });
        vm.closeThreadEdit();
        $rootScope.pagination_resetquery();
        return true;
      }).catch(function (error) {
        console.log(error.message);
      });
    }

    function createMediaStructure(type, n, thumbnails) {
      var array = [];
      for (var i = 0; i < thumbnails.length; i++) {
        array.push(thumbnails[i]['id_media']);
      }
      vm.currentThread_Edit.structure_data_json.unshift({
        type: type,
        id_media: array,
        id: n.toString()
      });
    }

    function setImageToStructure(thumbnails, n, typeMedia, existMedia) {
      for (var i = 0; i < vm.currentThread_Edit.structure_data_json.length; i++) {
        if (vm.currentThread_Edit.structure_data_json[i]['type'] === typeMedia) {
          existMedia = true;
          vm.currentThread_Edit.structure_data_json[i]['id_media'] = [];
          for (var k = 0; k < thumbnails.length; k++) {
            vm.currentThread_Edit.structure_data_json[i]['id_media'].push(thumbnails[k]['id_media']);
            /*var existElement = false;
            for (var j = 0; j < vm.currentThread_Edit.structure_data_json[i]['id_media'].length; j++) {
                if (vm.currentThread_Edit.structure_data_json[i]['id_media'][j] === thumbnails[k]['id_media']) {
                    existElement = true;
                }
            }
            if (!existElement) {
                vm.currentThread_Edit.structure_data_json[i]['id_media'].push(thumbnails[k]['id_media']);
            }*/
          }
        }
      }
      return existMedia;
    }

    function formatMediaArray(thumbnails, n, typeMedia) {
      if (thumbnails) {
        var existMedia = false;
        existMedia = setImageToStructure(thumbnails, n, typeMedia, existMedia);
        if (!existMedia) {
          createMediaStructure(typeMedia, n, thumbnails);
        }
      }
    }

    function setMediaImage(content) {
      var d = new Date();
      var n = d.getTime();
      formatMediaArray(content.header_thumbnails, n++, 'media_header');
      formatMediaArray(content.footer_thumbnails, ++n, 'media_footer');
    }


    $scope.closeToast = function () {
      if (isDlgOpen)
        return;

      $mdToast.hide().then(function () {
        isDlgOpen = false;
      });
    };

    /**
     * Return selected status of the thread
     *
     * @param thread
     * @returns {boolean}
     */
    function isSelected(thread) {
      return sharedFunctionsMailing.isSelected(vm.selectedThreads, thread);
    }

    function openUrl(url) {
      $window.open(url, '_blank');
    }


    function toggleSelectThread(thread, event) {
      vm.selectedThreads = sharedFunctionsMailing.toggleSelectThread(vm.selectedThreads, thread, event);
    }


    function updateThread(itemThread) {
      if ($scope.section === 'templates') {
        for (var i = 0; i < vm.threads.length; i++) {
          if (vm.threads[i]['id_mailing_templates'] == itemThread['id_mailing_templates']) {
            vm.threads[i] = itemThread;
          }
        }
      }
    }


    function deselectThreads() {
      vm.selectedThreads = sharedFunctionsMailing.deselectThreads();
    }


    function toggleSelectThreads() {
      vm.selectedThreads = sharedFunctionsMailing.toggleSelectThreads(vm.selectedThreads, vm.threads);
    }


    function openTemplateView(view) {
      vm.loadingView = true;
      vm.defaultTemplateView = view;
      vm.currentTemplateView = view;
    }

    function changeView(view) {
      if (vm.views[view]) {
        vm.loadingView = true;
        vm.defaultView = view;
        vm.currentView = view;
      }
    }


    function viewPreview() {
      resetScroll();
      vm.editInline = false;
    }

    function resetScroll() {
      if (angular.element(document.getElementById('thread-detail')).length) {
        var elem = angular.element(document.getElementById('thread-detail'));
        elem.scrollTopAnimated(0, 10);
      }
    }

    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    function selectOrUnselect(item, $event) {
      var isRightClick = $event && $event.which == 3;
      var isDoubleClick = $event && $event.type == 'dblclick';
    };

    function openImageDialog(ev, mediazone, index) {
      $mdDialog.show({
        controller: 'MediaShowDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/dialogs/media-show/media-show-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          Images: vm.currentThread_Edit[mediazone.id_zone],
          ImageSelected: vm.currentThread_Edit[mediazone.id_zone][index],
          cropFormats: false,
          MediaFull: false,
          Tags: false
        }
      });
    }


    function duplicateTemplate() {
      for (var i = 0; i < vm.selectedThreads.length; i++) {
        var newTemplate = transformMailing.formatDuplicateTemplate(vm.selectedThreads[i]);
        var options = {
          site: $scope.siteID,
          section: $scope.section,
          item: newTemplate,
          id: 'new'
        };
        mailingService.saveItem(options).then(function (response) {
          $rootScope.pagination_resetquery();
          deselectThreads();
        });
      }
    }

    function groupDialog(structureGroup) {
      if (!structureGroup.items) {
        structureGroup.items = [];
      }
      var itemsToEdit = angular.copy(structureGroup.items);
      $mdDialog.show({
        controller: 'GroupMailingController',
        controllerAs: 'vm',
        locals: {
          items: itemsToEdit,
          modeView: 'creating',
          section: $scope.section,
          isTiny: false
        },
        templateUrl: 'app/main/apps/mailing/dialogs/group/group-mailing.html',
        parent: angular.element($document.body),
        targetEvent: 'ev',
        clickOutsideToClose: true

      }).then(function (result) {
        if (result) {
          structureGroup.items = result
        }
        vm.basicForm.$setDirty();
      });
    }

    function openUsersGroupsDialog() {
      $mdDialog.show({
        controller: 'UsersGroupController',
        controllerAs: 'vm',
        locals: {
          usersGroups: angular.copy(vm.usersGroups),
          selectedGroups: angular.copy(vm.currentThread_Edit.default_users_groups_json),
          isTiny: false
        },
        templateUrl: 'app/main/dialogs/users-group/users-group-view.html',
        parent: angular.element($document.body),
        targetEvent: 'ev',
        clickOutsideToClose: true,

      }).then(function (object) {
        if (object) {
          vm.currentThread_Edit.default_users_groups_json = sharedFunctionsMailing.updateUsersGroups(object.usersGroups);
          vm.currentLabels = object.labels;
          vm.basicForm.$setDirty();
        }
      });
    }


    function deleteTarget(id, index) { // TODO(Refactorizar)
      var index_user_group = vm.currentThread_Edit.default_users_groups_json.indexOf(id);
      if (index_user_group > -1) {
        vm.currentThread_Edit.default_users_groups_json.splice(index_user_group, 1);
      }
      vm.currentLabels.splice(index, 1);
      vm.basicForm.$setDirty();
    }


    function mediaDialog(ev, mediazone, item, type) {
      item.Thumbnail = [];

      $mdDialog.show({
        controller: 'MediaDialogController',
        controllerAs: 'vm',
        locals: {
          autoUpload: '',
          currentThread: item,
          section: $scope.section,
          mediazone: mediazone,
          multipleSelection: true,
          isTiny: false,
          maxAttach: undefined,
          showViews: {
            1: true,
            2: true,
            3: true,
            4: true,
            5: true,
            upload: true,
            import: true
          }
        },
        templateUrl: 'app/main/dialogs/media/media-mailing.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true

      }).then(function (item) {
        for (var i = 0; i < item.Thumbnail.length; i++) {
          if (!vm.currentThread_Edit[mediazone.id_zone]) {
            vm.currentThread_Edit[mediazone.id_zone] = [];
          }
          vm.currentThread_Edit[mediazone.id_zone].push(item.Thumbnail[i]);
        }
        vm.basicForm.$setDirty()
      });
    }



    function deleteAttachment(mediazone, index) {

      var current = vm.currentThread_Edit[mediazone.id_zone];
      var id = vm.currentThread_Edit[mediazone.id_zone][index]['id_media'];
      current.splice(index, 1);
      deleteImageStructure(mediazone, id);
      vm.basicForm.$setDirty();

    }

    function deleteImageStructure(mediazone, id) {
      for (var i = 0; i < vm.currentThread_Edit.structure_data_json.length; i++) {
        if (vm.currentThread_Edit.structure_data_json[i].type === 'media_header' && mediazone.id_zone === 'header_thumbnails') {
          for (var k = 0; k < vm.currentThread_Edit.structure_data_json[i].id_media.length; k++) {
            if (vm.currentThread_Edit.structure_data_json[i].id_media[k] === id) {
              vm.currentThread_Edit.structure_data_json[i].id_media.splice(k, 1);
            }
          }
        } else if (vm.currentThread_Edit.structure_data_json[i].type === 'media_footer' && mediazone.id_zone === 'footer_thumbnails') {
          for (var k = 0; k < vm.currentThread_Edit.structure_data_json[i].id_media.length; k++) {
            if (vm.currentThread_Edit.structure_data_json[i].id_media[k] === id) {
              vm.currentThread_Edit.structure_data_json[i].id_media.splice(k, 1);
            }
          }
        }

      }
    }

    function MediaItemRecrop(image, mediazone, index) {

      var messageConfirm = $translate.instant('CONTENT.MEDIA_ITEM_SURE_RECROP');

      var confirm = $mdDialog.confirm().title(messageConfirm).htmlContent('')
        .ariaLabel('Delete item').ok('OK').cancel('CANCEL');
      var message = $translate.instant('CONTENT.MEDIA_ITEM_FINISH_RECROP');


      $mdDialog.show(confirm).then(function () {

        var imageToSave = {
          'forceRecrop': true,
          'tags': [],
        };

        var options = {
          site: $scope.siteID,
          id: image.id_media,
          item: imageToSave
        };

        mediaService.saveMedia(options).then(function (response) {
          $mdToast.show({
            template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
            hideDelay: 5000,
            position: 'top',
            parent: '#content-container'
          });
        });
      });

    }

    function openMediaItemMetadata(ev, mediazone, index) {
      $mdDialog.show({
        controller: 'MediaItemMetadataDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/dialogs/media-item-metadata/media-item-metadata-mailing-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          ImageSelected: vm.currentThread_Edit[mediazone.id_zone][index],
        }
      }).then(function (item) {
        vm.basicForm.$setDirty()
      });
    }

    function openFocalPoint(ev, mediazone, index) {
      $mdDialog.show({
        controller: 'FocalPointDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/dialogs/media-focal-point/media-focal-point-mailing-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          ImageSelected: vm.currentThread_Edit[mediazone.id_zone][index],
        }
      }).then(function (item) {
        vm.basicForm.$setDirty()
        vm.currentThread_Edit[mediazone.id_zone][index].imageCenterRatioX = item.imageCenterRatioX;
        vm.currentThread_Edit[mediazone.id_zone][index].imageCenterRatioY = item.imageCenterRatioY;
      });
    }

    function callback(node, select, tree) {
      console.log(node, select, tree);
      //vm.default_users_groups = sharedFunctionsMailing.updateUsersGroups(angular.copy(vm.usersGroups), node);
      //vm.basicForm.$setDirty();
    };


    function deleteItemArray(array, item, field) {
      for (var i = 0; i < array.length; i++) {
        if (array[i] === item[field]) {
          array.splice(i, 1);
        }
      }
    }



    function editGroupField() {

    }

    function instantTranslate(text) {
      return $translate.instant(text);
    }

    function cancelMailingGroups(sidenavId) {
      vm.mailingGroups = angular.copyvm.cancelMailingGroups = cancelMailingGroups; (vm.copyMailingGroups);
      $mdSidenav(sidenavId).toggle();
    }

    function saveMailingGroups(sidenavId) {
      vm.copyMailingGroups = [];
      $mdSidenav(sidenavId).toggle();
      vm.currentLabelsFilter = transformMailing.getLabels(vm.mailingGroups);

      if (vm.currentLabelsFilter.length > 0) {
        var array = transformUsers.getGroupsFromLabels(vm.currentLabelsFilter);
        if (array.length === 1) {
          var copy = angular.copy(array[0]);
          array[0] = -1;
          array.push(copy);
        }
        var options = {
          site: $scope.siteID,
          section: 'templates',
          ids: array
        };
        getMailingByGroups(options);
      } else {
        resetFilters();
      }
      vm.selectedContent = undefined;

    }

    function getMailingByGroups(options) {
      mailingService.getMailingByGroups(options).then(function (response) {
        vm.threads = response.data;
        $rootScope.pagination_totalItems = response.total;
        $rootScope.pagination_total_pages = response.last_page;
      });
    }


    function getCleanMailingGroup() {
      //vm.CleanMailingGroups = transformMailing.formatNestedGroups(vm.refFilterables);
    }

    function toggleSelectGroups() {
      if (vm.selectedGroups == []) {
        ivhTreeviewMgr.selectAll(vm.CleanMailingGroups);
        vm.selectedGroups = vm.CleanMailingGroups;
      } else {
        ivhTreeviewMgr.deselectAll(vm.CleanMailingGroups);
        vm.selectedGroups = [];

      }
    }

    function toggleSelectGroup(group, event) {
      if (vm.selectedGroups) {
        vm.selectedGroups = sharedFunctionsMailing.toggleSelectThread(vm.selectedGroups, group, event);
      }
    }

    function selectGroups(key, value) {
      // Make sure the current selection is cleared
      // before trying to select new threads
      vm.selectedGroups = [];

      for (var i = 0; i < vm.threads.length; i++) {
        if (angular.isUndefined(key) && angular.isUndefined(value)) {
          vm.selectedGroups.push(vm.threads[i]);
          continue;
        }

        if (angular.isDefined(key) && angular.isDefined(value) && vm.threads[i][key] === value) {
          vm.selectedGroups.push(vm.threads[i]);
        }
      }
    }

    function unselectGroups() {
      vm.selectedGroup = false;
      vm.selectedContent = false;
      $rootScope.pagination_groupIds = false;
      var elemList = document.querySelectorAll('.group-row');
      elemList.forEach(function (elem) {
        elem.classList.remove('selected');
      });
      loadAllGroups();
    }

    function loadAllGroups() {
      $scope.isLoading = true;
      var options = {
        siteID: $scope.siteID,
        section: 'templates',
        sortDir: $rootScope.sortDir,
        sortField: $rootScope.sortField
      };
      mailingService.get(options).then(function (response) {
        vm.threads = response.data;
        $rootScope.pagination_totalItems = response.total;
        $rootScope.pagination_total_pages = response.last_page;
        $rootScope.pagination_page = response.current_page;
        $scope.isLoading = false;
      });
    }

    function toggleIncludeSubgroups() {
      vm.filterGroups.includeSubgroups = !vm.filterGroups.includeSubgroups;
      var element = $(".sidenav-groups #treeview-group-" + vm.selectedGroup.id_group);
      mailingService.triggerGroupsFilter(element.attr("data-group-node"), vm.filterGroups.includeSubgroups);
    }

    function loadMailingByGroups(groups) {
      $scope.isLoading = true;
      var groupIds = [];
      angular.forEach(groups, function (group) {
        groupIds.push(group.id_group);
      });
      vm.selectedGroup = groups[0];
      var options = {
        siteID: $scope.siteID,
        section: 'templates',
        groupIds: groupIds,
        sortDir: $rootScope.sortDir,
        sortField: $rootScope.sortField
      };
      mailingService.get(options).then(function (response) {
        $rootScope.pagination_groupIds = groupIds;
        vm.threads = response.data;
        $rootScope.pagination_totalItems = response.total;
        $rootScope.pagination_total_pages = response.last_page;
        $rootScope.pagination_page = response.current_page;
        $scope.isLoading = false;
      });
    }

    $scope.$on('loadGroupsFilter', function (event, groups) {
      if (groups) {
        loadMailingByGroups(groups);
      } else {
        unselectGroups();
      }
    });


    $scope.fonts = [
      {
        value: 'Arial, Helvetica, sans-serif',
        label: 'Arial',
        selected: 'true'
      },
      {
        value: 'Tahoma, Geneva, sans-serif',
        label: 'Tahoma',
        selected: 'false'
      },
      {
        value: 'Georgia, serif',
        label: 'Georgia',
        selected: 'false'
      },
      {
        value: '"Times New Roman", Times, serif',
        label: 'Times New Roman',
        selected: 'false'
      },
      {
        value: 'Impact, Charcoal, sans-serif',
        label: 'Impact',
        selected: 'false'
      },
      {
        value: '"Lucida Sans Unicode", "Lucida Grande", sans-serif',
        label: 'Lucida',
        selected: 'false'
      },
      {
        value: '"Trebuchet MS", Helvetica, sans-serif',
        label: 'Trebuchet',
        selected: 'false'
      },
      {
        value: 'Verdana, Geneva, sans-serif',
        label: 'Verdana',
        selected: 'false'
      },
      {
        value: '"Courier New", Courier, monospace',
        label: 'Courier New',
        selected: 'false'
      },
      {
        value: '"Lucida Console", Monaco, monospace',
        label: 'Lucida Console',
        selected: 'false'
      }
    ];
    $scope.selectedFont = '';
    $scope.change = function (option) {
      $scope.selectedFont = option.value;
    }

    // Opens the new React editor (content-plus) in TEMPLATE mode.
    function showTemplatePlus($event) {
      var CONTENT_PLUS_URL = (window.location.hostname === 'localhost')
        ? 'http://localhost:5173'
        : window.location.origin + '/content-plus/';

      var idTemplate = vm.currentThread_Edit && vm.currentThread_Edit.id_mailing_templates;
      if (!idTemplate) {
        $mdToast.show($mdToast.simple().textContent($translate.instant('MAILING.SAVE_TEMPLATE_FIRST') || 'Save the template first').position('top'));
        return;
      }

      $mdDialog.show({
        controller: 'MailingContentPlusEditorController',
        controllerAs: 'vm',
        templateUrl: 'app/main/apps/mailing/views/content-plus/dialogs/editor-dialog.html',
        parent: angular.element($document.body),
        targetEvent: $event,
        clickOutsideToClose: false,
        escapeToClose: true,
        multiple: true,
        locals: {
          contentPlusUrl: CONTENT_PLUS_URL,
          idContent: null,
          idTemplate: idTemplate,
          editorMode: 'template',
          contentTitle: vm.currentThread_Edit.name || '',
          siteID: $scope.siteID || $rootScope.siteID,
          currentLang: $translate.use() || 'es'
        }
      }).then(function () {
        if (idTemplate) { openTemplate(vm.currentThread_Edit, idTemplate); }
      }, function () {
        if (idTemplate) { openTemplate(vm.currentThread_Edit, idTemplate); }
      });
    }

    function showDesignView($event) {
      $mdDialog.show({
        controller: 'TemplateBuilderController',
        controllerAs: 'vm',
        locals: {
          currentContent: vm.currentThread_Edit,
          currentEmail: vm.currentThread_Edit.structure_mjml,
          emailName: vm.currentThread_Edit.name,
          disabledElements: [],
          section: section,
          split: vm.splitContent,
          mailingToContent: vm.mailingToContent
        },
        templateUrl: 'app/main/plugins/template-builder/template-builder.html',
        parent: angular.element($document.body),
        targetEvent: $event,
        clickOutsideToClose: false,
        escapeToClose: false,
        multiple: true
      }).then(function (item) {
        if (item) {
          vm.currentThread_Edit.structure_mjml = item
        }
      });
    }

    /**
     * Multiple comma separated chips to add
     */
    $scope.addChips = function (chips, model) {
      if(chips && chips.indexOf(';')){
        var chipsArray = chips.split(';');
      }else{
        var chipsArray = chips.split(',');
      }
      angular.forEach(chipsArray, function (chip) {
        model.push(chip);
      });
      return null;
    };
    /**
     * Validate emails in Chips
     */
    $scope.validateEmail = function (emails) {
      var reg = /^(([^<>()\[\]\\.,;:\s@\"]+(\.[^<>()\[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  
      this.invalidEmail = false;
  
      for (var i = 0; i < emails.length; i++) {
          emails[i] = emails[i].toLowerCase();
  
          if (!reg.test(emails[i])) {
              this.invalidEmail = true;
              emails.splice(i, 1);
              i--;
          }
      }
  };
  

    function siteLanguages() {
      return sessionService.getSiteLanguages();
  }



  }

})();

(function () {
  'use strict';

  angular
    .module('app.mailing')
    .controller('MailingTemplatePlusController', MailingTemplatePlusController);

  /** @ngInject */
  function MailingTemplatePlusController(
    $scope, $rootScope, $document, $mdDialog, $mdToast, $window,
    requestContext, mailingService, transformMailing, msUtils,
    $translate, sessionService, section
  ) {
    var vm = this;

    vm.templates = [];                 // bound to qiu-pagination collection
    vm.selectedThreads = [];
    vm.selectedTemplateID = null;
    vm.currentTemplate = null;
    vm.basicForm = {};
    vm.isSaving = false;
    vm.msScrollOptions = { suppressScrollX: true };

    // List actions
    vm.newTemplate = newTemplate;
    vm.openTemplate = openTemplate;
    vm.deleteTemplate = deleteTemplate;
    vm.duplicateTemplate = duplicateTemplate;
    vm.toggleSelectThread = toggleSelectThread;
    vm.toggleSelectThreads = toggleSelectThreads;
    vm.isSelected = isSelected;
    vm.isChecked = isChecked;
    vm.setSortField = setSortField;
    vm.setSortOrder = setSortOrder;

    // Detail panel actions
    vm.openEditor = openEditor;
    vm.closeDetail = closeDetail;
    vm.saveTemplate = saveTemplate;
    vm.openPreview = openPreview;

    // Utils
    vm.translate = function (key) { return $translate.instant(key); };

    init();

    function init() {
      var siteID = requestContext.getParam('siteId');
      $scope.siteID = siteID;
      $scope.section = 'templates';
      $rootScope.global.titleToolbar =
        '<i class="icon s20 icon-telegram mr-15"></i>' +
        '<span class="hide show-gt-xs">MAILING</span>' +
        '<i class="mr-5 ml-5 icon s18 icon-chevron-right hide show-gt-xs"></i> Template Plus';
    }

    // ── List ──────────────────────────────────────────────

    function openTemplate(tpl, $event) {
      if ($event) $event.stopPropagation();
      vm.selectedTemplateID = tpl.id_mailing_templates;
      vm.currentTemplate = null;
      vm.basicForm = {};
      mailingService.getByID({ site: $scope.siteID, id: vm.selectedTemplateID, section: 'templates' }).then(function (response) {
        vm.currentTemplate = transformMailing.validateTemplateFields
          ? transformMailing.validateTemplateFields(response)
          : response;
      });
    }

    function newTemplate($event) {
      if ($event) $event.stopPropagation();
      // Creación diferida (igual que el template tradicional): NO persistimos un
      // registro vacío en BD. Armamos un template vacío en memoria y mostramos el
      // panel de detalle; el POST real ocurre en saveTemplate con id 'new'.
      var emptyTemplate = transformMailing.createNewEmptyTemplate
        ? transformMailing.createNewEmptyTemplate()
        : { from_name: '', from_email: '', structure_data_json: [], structure_mjml: {} };
      emptyTemplate.name = '';
      vm.selectedTemplateID = 'new';
      vm.currentTemplate = emptyTemplate;
      vm.basicForm = {};
    }

    function deleteTemplate() {
      if (vm.selectedThreads.length === 0) return;
      var ids = vm.selectedThreads.map(function (t) { return t.id_mailing_templates; });
      var confirm = $mdDialog.confirm()
        .title($translate.instant('CONTENT.DELETE') || 'Eliminar')
        .textContent('¿Eliminar ' + ids.length + ' elemento(s)?')
        .ok('OK').cancel('Cancel');
      $mdDialog.show(confirm).then(function () {
        var done = 0;
        ids.forEach(function (id) {
          mailingService.deleteThread({ site: $scope.siteID, id: id, section: 'templates' }).then(function () {
            done++;
            if (done === ids.length) {
              vm.selectedThreads = [];
              vm.currentTemplate = null;
              vm.selectedTemplateID = null;
              $rootScope.pagination_resetquery();
            }
          });
        });
      });
    }

    function duplicateTemplate() {
      if (vm.selectedThreads.length === 0) return;
      vm.selectedThreads.forEach(function (item) {
        var newItem = transformMailing.formatDuplicateTemplate
          ? transformMailing.formatDuplicateTemplate(item)
          : angular.extend(angular.copy(item), { id_mailing_templates: undefined, name: (item.name || '') + ' (copia)' });
        mailingService.saveItem({ site: $scope.siteID, section: 'templates', id: 'new', item: newItem }).then(function () {
          $rootScope.pagination_resetquery();
          vm.selectedThreads = [];
        });
      });
    }

    function toggleSelectThread(item, $event) {
      $event.stopPropagation();
      var idx = vm.selectedThreads.indexOf(item);
      if (idx > -1) { vm.selectedThreads.splice(idx, 1); } else { vm.selectedThreads.push(item); }
    }

    function toggleSelectThreads() {
      vm.selectedThreads = vm.selectedThreads.length > 0 ? [] : vm.templates.slice();
    }

    function isSelected(item) { return vm.selectedThreads.indexOf(item) > -1; }
    function isChecked(item) { return vm.selectedThreads.indexOf(item) > -1; }
    function setSortField(field) { $rootScope.pagination_setSortField(field, $rootScope.sortDir); }
    function setSortOrder(dir) { $rootScope.sortDir = dir; $rootScope.pagination_setSortField($rootScope.sortField, dir); }

    // ── Detail panel ──────────────────────────────────────

    function closeDetail() {
      vm.currentTemplate = null;
      vm.selectedTemplateID = null;
      vm.basicForm = {};
    }

    function saveTemplate() {
      if (!vm.currentTemplate) return;
      if (!vm.currentTemplate.name) { _toast('MAILING.NAME_REQUIRED'); return; }
      var isNew = !vm.currentTemplate.id_mailing_templates;
      vm.isSaving = true;
      var item = angular.copy(vm.currentTemplate);
      item.id = item.id_mailing_templates;
      mailingService.saveItem({
        site: $scope.siteID,
        section: 'templates',
        id: isNew ? 'new' : vm.currentTemplate.id_mailing_templates,
        item: item
      }).then(function (response) {
        vm.isSaving = false;
        vm.basicForm.$setPristine && vm.basicForm.$setPristine();
        var newId = (response && response.id_mailing_templates) || vm.currentTemplate.id_mailing_templates;
        openTemplate({ id_mailing_templates: newId }, null);
        $rootScope.pagination_resetquery();
        _toast('MAILING.SAVED');
      }, function () {
        vm.isSaving = false;
        _toast('MAILING.ERROR');
      });
    }

    function openPreview($event) {
      if (!vm.currentTemplate || !vm.currentTemplate.structure_mjml) return;
      // Los templates no tienen unique_id ni URL pública de preview (eso es para
      // contents que se envían). Renderizamos el HTML guardado en structure_mjml.html
      // con el mismo diálogo que usa el content tradicional.
      var structure = vm.currentTemplate.structure_mjml;
      if (typeof structure === 'string') {
        try { structure = JSON.parse(structure); } catch (e) { structure = null; }
      }
      var html = structure && structure.html;
      if (!html) { _toast('MAILING.PREVIEW_NEEDS_SAVE'); return; }
      $mdDialog.show({
        controller: 'HtmlPreviewController',
        controllerAs: 'vm',
        locals: { currentHtml: html },
        templateUrl: 'app/main/plugins/html-preview/html-preview.html',
        parent: angular.element($document.body),
        targetEvent: $event,
        clickOutsideToClose: true
      });
    }

    // ── Editor dialog (React, TEMPLATE mode) ──────────────

    function openEditor($event) {
      if (!vm.currentTemplate) return;
      if (!vm.currentTemplate.id_mailing_templates) { _toast('MAILING.SAVE_BEFORE'); return; }
      var CONTENT_PLUS_URL = (window.location.hostname === 'localhost')
        ? 'http://localhost:5173'
        : window.location.origin + '/content-plus/';

      $mdDialog.show({
        controller: 'MailingContentPlusEditorController',
        controllerAs: 'vm',
        templateUrl: 'app/main/apps/mailing/views/content-plus/dialogs/editor-dialog.html',
        parent: angular.element($document.body),
        targetEvent: $event,
        clickOutsideToClose: false,
        escapeToClose: true,
        locals: {
          contentPlusUrl: CONTENT_PLUS_URL,
          idContent: null,
          idTemplate: vm.currentTemplate.id_mailing_templates,
          editorMode: 'template',
          contentTitle: vm.currentTemplate.name || '',
          siteID: $scope.siteID,
          currentLang: $translate.use() || 'es'
        }
      }).then(_reloadCurrent, _reloadCurrent);
    }

    function _reloadCurrent() {
      if (vm.selectedTemplateID) {
        openTemplate({ id_mailing_templates: vm.selectedTemplateID }, null);
      }
      $rootScope.pagination_resetquery();
    }

    function _toast(key) {
      $mdToast.show({
        template: '<md-toast layout="column" layout-align="center center"><div class="md-toast-content"><span class="md-toast-text" flex>' + $translate.instant(key) + '</span></div></md-toast>',
        hideDelay: 3000,
        position: 'top right'
      });
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.mailing')
        .service("mailingService", mailingService);

    /** @ngInject */
    // I provide access to the session store.
    function mailingService($q, $resource, $rootScope, userService, settingsDomainService, sessionService, COMMON, $window, transformMailing) {


        var reference_sections = [];


        var resource = $resource(
            COMMON.BASE_API + "/domain/:domain/mailing/:name", {
            // No default data.
        }, {
            get: {
                method: "GET",
                isArray: false
            }
        }
        );


        var resourceInGroups = $resource(
            COMMON.BASE_API + "/domain/:domain/mailing/inGroups/:name", {
            // No default data.
        }, {
            get: {
                method: "GET",
                isArray: false
            }
        }
        );
        var resourceOptions = $resource(
            COMMON.BASE_API + "/domain/:domain/mailing/templates/options", {
            // No default data.
        }, {
            get: {
                method: "GET",
                isArray: false
            }
        }
        );
        var resourceLog = $resource(
            COMMON.BASE_API + "/domain/:domain/mailing/log?page=:page&resultsPerPage=:resultsPerPage&id=:id", {
            // No default data.
        }, {
            get: {
                method: "GET",
                isArray: false
            }
        }
        );
        var resourceLogByUser = $resource(
            COMMON.BASE_API + "/domain/:domain/mailing/log?page=:page&resultsPerPage=:resultsPerPage&email=:email&withMailingContent", {
            // No default data.
        }, {
            get: {
                method: "GET",
                isArray: false
            }
        }
        );


        var resourceUsersGroups = $resource(
            COMMON.BASE_API + "/domain/:domain/usersGroups", {
            // No default data.
        }, {
            get: {
                method: "GET"
            }
        }
        );

        var resource_content_byID = $resource(
            COMMON.BASE_API + "/domain/:domain/mailing/:name/:id", {
            domain: '@domain',
            name: '@name',
            id: '@id',
        }, {
            get: {
                method: "GET",
            },
            update: {
                method: "PUT",
            },
            delete: {
                method: "DELETE"
            }
        }
        );

        var resource_content_send = $resource(
            COMMON.BASE_API + "/domain/:site/mailing/sendLive", {
            site: '@site'
        }, {
            post: {
                method: "POST",
                isArray: false
            }
        }
        );
        var resource_massive_send = $resource(
            COMMON.BASE_API + "/domain/:site/mailing/sendMassive", {
            site: '@site'
        }, {
            post: {
                method: "POST",
                isArray: false
            }
        }
        );

        var resource_massive_check = $resource(
            COMMON.BASE_API + "/domain/:site/mailing/checkMassive", {
            site: '@site'
        }, {
            post: {
                method: "POST",
                isArray: false
            }
        }
        );

        var resource_content_cancel = $resource(
            COMMON.BASE_API + "/domain/:site/mailing/cancelScheduled", {
            site: '@site'
        }, {
            post: {
                method: "POST",
                isArray: true
            }


        }
        );

        //massive
        var resource_massive_cancel = $resource(
            COMMON.BASE_API + "/domain/:site/mailing/cancelMassiveScheduled", {
            site: '@site'
        }, {
            post: {
                method: "POST",
                isArray: true
            }


        }
        );

        var resource_content_reschedule = $resource(
            COMMON.BASE_API + "/domain/:site/mailing/changeScheduled", {
            site: '@site'
        }, {
            post: {
                method: "POST",
                isArray: true
            }


        }
        );

        //massive
        var resource_massive_reschedule = $resource(
            COMMON.BASE_API + "/domain/:site/mailing/changeMassiveScheduled", {
            site: '@site'
        }, {
            post: {
                method: "POST",
                isArray: true
            }


        }
        );

        var resource_content_send_after = $resource(
            COMMON.BASE_API + "/domain/:site/mailing/sendLive", {
            site: '@site'
        }, {
            post: {
                method: "POST",
                isArray: true
            }
        }
        );
        var resource_massive_send_after = $resource(
            COMMON.BASE_API + "/domain/:site/mailing/sendMassiveAfter", {
            site: '@site'
        }, {
            post: {
                method: "POST",
                isArray: true
            }
        }
        );

        var resource_send_status = $resource(
            COMMON.BASE_API + "/domain/:site/mailing/sendStatus", {
            site: '@site'
        }, {
            post: {
                method: "POST",
                isArray: true
            }
        }
        );

        var resource_content_send_test = $resource(
            COMMON.BASE_API + "/domain/:site/mailing/sendTest", {
            site: '@site'
        }, {
            post: {
                method: "POST",
                isArray: false
            }


        }
        );

        var resource_content_new = $resource(
            COMMON.BASE_API + "/domain/:site/mailing/:section", {
            site: '@site',
            section: '@section'
        }, {
            post: {
                method: "POST",
                isArray: false
            }


        }
        );

        //massive
        var resource_massive_new = $resource(
            COMMON.BASE_API + "/domain/:site/mailing/:section", {
            site: '@site',
            section: '@section'
        }, {
            post: {
                method: "POST",
                isArray: false
            }


        }
        );

        var resource_convert_log = $resource(
            COMMON.BASE_API + "/domain/:site/mailing/convert/log", {
            site: '@site'
        }, {
            post: {
                method: "POST",
                isArray: false
            }


        }
        );

        var resource_content_save = $resource(
            COMMON.BASE_API + "/domain/:site/mailing/:section/:id", {
            site: '@site',
            section: '@section',
            id: '@id',
        }, {
            update: {
                method: "PUT",
                isArray: false
            }
        }
        );

        var resource_massive_save = $resource(
            COMMON.BASE_API + "/domain/:site/mailing/:section/:id", {
            site: '@site',
            section: '@section',
            id: '@id',
        }, {
            update: {
                method: "PUT",
                isArray: false
            }
        }
        );


        var resource_content_delete = $resource(
            COMMON.BASE_API + "/domain/:site/mailing/:section/:id" /* + options.site + "/" + options.section + "/" + options.id*/, {
            site: '@site',
            section: '@section',
            id: '@id',
        }, {
            delete: {
                method: "DELETE",
                isArray: false
            },
        }
        );

        var resource_mailing_log_export = $resource(
            COMMON.BASE_API + "/domain/:domain/export/mailing/log/export", {
            domain: '@domain',
        }, {
            post: {
                method: "POST",
                isArray: false
            }
        }
        );

        var resource_mailing_isolate_bounces = $resource(
            COMMON.BASE_API + "/domain/:domain/mailing/:section/:id/isolateBounces", {
            domain: '@domain',
            section: '@section',
            id: '@id',
        }, {
            update: {
                method: "PUT",
                isArray: false
            }
        }
        );

      var resource_preview_token = $resource(
        COMMON.BASE_API + "/domain/:domain/mailing/previewToken/:id", {
          domain: '@domain',
          id: '@id',
        }, {
          get: {
            method: "GET",
          }
        }
      );

      var resource_pdf_file = $resource(
        COMMON.BASE_API + "/domain/:domain/mailing/pdf", {
          domain: '@domain'
        }, {
          post: {
            method: "POST",
            isArray: false
          }
        }
      );

      var estado = $resource(
        COMMON.BASE_API + "/domain/:site/mailing/estado", {
        site: '@site'
    }, {
        post: {
            method: "POST",
            isArray: true
        }
    }
    );

    var resource_massive_stats = $resource(
        COMMON.BASE_API + "/domain/:site/mailing/massiveStats", {
        site: '@site'
    }, {
        post: {
            method: "POST",
            isArray: true
        }
    }
    );

        function massiveStats(options) {
            var deferred = $q.defer();
            resource_massive_stats.post({
                site: options.site,
            }, options,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e.data.message)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }


        function estado(options) {
            var deferred = $q.defer();
            resource_massive_send_after.post({
                site: options.site,
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function getContent(options) {
            var deferred = $q.defer();
            var filters = [];

            _.forEach(options, function (value, key, list) {
                if (_.isObject(list[key])) {
                    _.forEach(list[key], function (filter, keyFilter, listFilter) {
                        if (!_.isEmpty(filter.selected)) {
                            filters.push({
                                field: filter.field,
                                name: filter.name,
                                values: filter.selected
                            });
                        }

                    });

                }
            });

            var opt = {
                domain: options.siteID,
                name: options.section,
                page: options.page,
                search: options.searchStringFilter,
                paginate: options.resultsPerPage,
                resultsPerPage: options.resultsPerPage,
                sortField: options.sortField,
                sortDir: options.sortDir,
                filters: JSON.stringify(filters),
                // lang: get("language")
            }
            resource.get(opt,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getByID(options) {
            var deferred = $q.defer();

            resource_content_byID.get({
                domain: options.site,
                name: options.section,
                id: options.id,
                // lang: get("language")
            },
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);
                    deferred.resolve(response);
                },
                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }


        function saveItem(options) {
            var promise;
            if (options.id == 'new') {
                promise = newItem(options);
            } else {
                promise = updateItem(options);
            }
            return promise;
        }

        function sendContent(options) {
            var deferred = $q.defer();
            resource_content_send.post({
                site: options.site,
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function sendMassive(options) {
            var deferred = $q.defer();
            resource_massive_send.post({
                site: options.site,
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e.data.message)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function checkMassive(options) {
            var deferred = $q.defer();
            resource_massive_check.post({
                site: options.site,
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e.data.message)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function cancelScheduled(options) {
            var deferred = $q.defer();
            resource_content_cancel.post({
                site: options.site,
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        //massive cancel
        function cancelMassiveScheduled(options) {
            var deferred = $q.defer();
            resource_massive_cancel.post({
                site: options.site,
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function reScheduled(options) {
            var deferred = $q.defer();
            resource_content_reschedule.post({
                site: options.site,
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        //massive reschedule
        function massivereScheduled(options) {
            var deferred = $q.defer();
            resource_massive_reschedule.post({
                site: options.site,
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function sendContentAfter(options) {
            var deferred = $q.defer();
            resource_content_send_after.post({
                site: options.site,
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        //massive send after---------------------------------------------------
        function sendMassiveAfter(options) {
            var deferred = $q.defer();
            resource_massive_send_after.post({
                site: options.site,
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function sendStatus(options) {
            var deferred = $q.defer();
            resource_send_status.post({
                site: options.site,
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function sendTest(options) {
            var deferred = $q.defer();
            resource_content_send_test.post({
                site: options.site,
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        // Red de seguridad anti-vaciado (idéntica a contentFunctionsMailing.structureHasBody).
        // Copia local para no acoplar el servicio a otra factory.
        function _structureHasBody(structure) {
            var s = structure;
            if (s === null || s === undefined) { return false; }
            if (typeof s === 'string') {
                var str = s.trim();
                if (!str || str === '{}' || str === '[]' || str === 'null') { return false; }
                try { s = JSON.parse(str); } catch (e) { return true; }
            }
            if (!s || typeof s !== 'object') { return false; }
            var len = function (x) { return (x && x.length) ? x.length : 0; };
            if (len(s.elements)) { return true; }
            if (len(s.rows)) { return true; }
            if (typeof s.html === 'string' && s.html.trim().length > 20) { return true; }
            if (s.header && len(s.header.elements)) { return true; }
            if (s.footer && len(s.footer.elements)) { return true; }
            return false;
        }

        function saveContent(options, method) {
            var deferred = $q.defer();
            // GUARD UNIVERSAL: nunca sobrescribir un content EXISTENTE con un cuerpo
            // vacío. Si structure_mjml viene presente pero sin contenido (típico tras
            // editar el template y romperse el mapeo), rechazamos el guardado para que
            // el contenido guardado en BD quede intacto. No afecta a la creación (sin id)
            // ni a guardados que no envían structure_mjml (borradores por _temp).
            if (options.item && options.item.id_mailing_content &&
                options.item.structure_mjml !== undefined && options.item.structure_mjml !== null &&
                !_structureHasBody(options.item.structure_mjml)) {
                deferred.reject({
                    emptyBodyGuard: true,
                    data: { detail: 'Guardado bloqueado: el cuerpo del email está vacío (posible desajuste con el template). El contenido guardado NO se ha sobrescrito; recarga el email para recuperarlo.' }
                });
                return (deferred.promise);
            }
            if (!options.item.id_mailing_content) {
                resource_content_new.post({
                    site: options.site,
                    section: options.section,
                    id: ''
                }, options.item,
                    function (response) {
                        deferred.resolve(response);
                    },
                    function (e) {
                        deferred.reject(e);
                    }
                );
                return (deferred.promise);
            }
            else {
                resource_content_save.update({
                    site: options.site,
                    section: options.section,
                    id: options.item.id_mailing_content,
                }, options.item,
                    function (response) {
                        deferred.resolve(response);
                    },
                    function (e) {
                        deferred.reject(e);
                    }
                );
                return (deferred.promise);
            }

        }
        function saveMassive(options, method) {
            var deferred = $q.defer();
            if (!options.item.id_message) {
                resource_massive_new.post({
                    site: options.site,
                    section: options.section,
                    id: ''
                }, options.item,
                    function (response) {
                        deferred.resolve(response);
                    },
                    function (e) {
                        deferred.reject(e);
                    }
                );
                return (deferred.promise);
            }
            else {
                resource_massive_save.update({
                    site: options.site,
                    section: options.section,
                    id: options.item.id_message,
                }, options.item,
                    function (response) {
                        deferred.resolve(response);
                    },
                    function (e) {
                        console.log(e);
                        deferred.reject(e);
                    }
                );
                return (deferred.promise);
            }

        }

        function convertLog(options, method) {
            var deferred = $q.defer();
            resource_convert_log.post({
                site: options.site
            }, {
                email: options.email,
                response: options.response
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    deferred.reject(e);
                }
            );
            return (deferred.promise);
        }

        function deleteThread(options) {
            var deferred = $q.defer();
            resource_content_delete.delete({
                site: options.site,
                section: options.section,
                id: options.id
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function getUsersGroups(options) {

            var deferred = $q.defer();
            resourceUsersGroups.get({
                domain: options.site,
                groupType: options.groupType,
                withoutUsers: options.withoutUsers,
                resultsPerPage: !angular.isUndefined(options.resultsPerPage) ? options.resultsPerPage : 500
            },
                function (response) {
                    deferred.resolve(response.data);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);

        }
        function getLog(options) {
            var deferred = $q.defer();
            resourceLog.get({
                domain: options.site,
                id: options.id,
                page: options.page,
                resultsPerPage: options.resultsPerPage,
                search: options.search
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }
        function getLogByFilter(options) {
            var deferred = $q.defer();
            var opt = {
                domain: options.site,
                id: options.id,
                page: options.page,
                resultsPerPage: options.resultsPerPage,
                filter: options.filter,
                search: options.search,
            };

            console.log(opt.filter);

            var url = COMMON.BASE_API + "/domain/:domain/mailing/log?page=:page&resultsPerPage=:resultsPerPage&id=:id"
            if (options.filter) {
                url += '&:filter';
            } else {
                delete opt.filter;
            }
            if (options.idGroups) {
                options.idGroups.forEach(element => {
                    url += '&id_group[]=' + element;
                });
            } else {
                delete opt.id_group;
            }
            if (options.search && options.search != '') {
                url += '&search=:search'
            } else {
                delete opt.search;
            }
            let res = $resource(url, {}, { get: { method: "GET", isArray: false } });

            res.get(opt,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }
        function getLogByUser(options) {
            var deferred = $q.defer();
            resourceLogByUser.get({
                domain: options.site,
                email: options.email,
                page: options.page,
                resultsPerPage: options.resultsPerPage
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function newItem(options) {
            var deferred = $q.defer();
            resource_content_new.post({
                site: options.site,
                section: options.section,
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e);
                    alert(e.data.detail);
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function updateItem(options) {
            var deferred = $q.defer();
            resource_content_save.update({
                site: options.site,
                section: options.section,
                id: options.id,
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e);
                    alert(e.data.detail);
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function setSubsec(items) {
            angular.extend(reference_sections, items);
        }

        function getValuesReferencesSections(key) {

            return reference_sections[key];

        }

        function getReferencesSections(key, property, value) {
            switch (property) {
                case 'id_subsec':
                    var fieldReturn = 'subsec';
                    break;
                case 'id_cat':
                    var fieldReturn = 'cat';
                    break;
                case 'id_subcat':
                    var fieldReturn = 'subcat';
                    break;
                default:
                    var fieldReturn = 'cat';
            }

            if (!angular.isUndefined(reference_sections[key])) {
                for (var i = 0, len = reference_sections[key].length; i < len; i++) {
                    if (reference_sections[key][i][property] === value) return reference_sections[key][i][fieldReturn];
                }
            }
            return "--";
        }

        function triggerGroupsFilter(groupNode, includeSubgroups, allGroups) {
            var groups = false;
            if (groupNode) {
                var node = angular.fromJson(groupNode);
                groups = getGroups(node, [], includeSubgroups);
            }
            $rootScope.$broadcast('loadGroupsFilter', groups);
        }

        function getGroups(node, groups, includeSubgroups) {
            groups.push(node);
            if (includeSubgroups && typeof node.children !== 'undefined' && node.children.length > 0) {
                angular.forEach(node.children, function (data) {
                    getGroups(data, groups, includeSubgroups);
                });
            }
            return groups;
        }


        function getOptions(options) {
            var deferred = $q.defer();
            resourceOptions.get({
                domain: options.site,
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );

            return (deferred.promise);
        }

      function getPreviewToken(options) {
        var deferred = $q.defer();

        resource_preview_token.get({
            domain: options.siteID,
            id: options.id,
          },
          function (response) {

            deferred.resolve(response);
          },
          function (e) {
            deferred.reject(e);
          }
        );

        // Return the promise.
        return (deferred.promise);
      }

      function getPDFFile(options) {
        var deferred = $q.defer();

        resource_pdf_file.post({
            domain: options.siteID,
          }, {
            id: options.id
          },
          function (response) {
            deferred.resolve(response);
          },
          function (e) {
            deferred.reject(e);
          }
        );

        // Return the promise.
        return (deferred.promise);
      }


      function getFilters(options) {
            var deferred = $q.defer();
            return (deferred.promise);
        }

        function exportLogByMailingContentId(options) {
            var deferred = $q.defer();
            var options = {
                domain: options.siteID,
                idMailingContent: options.idMailingContent,
                format: options.format
            }
            resource_mailing_log_export.post(options,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function triggerSelectGroup(groupNode){
            $rootScope.$broadcast('selectGroupFilter', groupNode);
        }

        function isolateBounces(options) {
            var deferred = $q.defer();
            var opts = {
                domain: options.siteID,
                id: options.id,
                section: options.section
            }
            if (options.bounceType) {
                opts['bounceType'] = options.bounceType;
            }
            resource_mailing_isolate_bounces.update(opts,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        // Return the public API.
        return ({
            get: getContent,
            getByID: getByID,
            saveItem: saveItem,
            saveContent: saveContent,
            saveMassive: saveMassive,
            cancelScheduled: cancelScheduled,
            cancelMassiveScheduled: cancelMassiveScheduled,
            triggerSelectGroup: triggerSelectGroup,
            reScheduled: reScheduled,
            massivereScheduled: massivereScheduled,
            sendTest: sendTest,
            sendContent: sendContent,
            sendMassive: sendMassive,
            checkMassive: checkMassive,
            sendContentAfter: sendContentAfter,
            sendMassiveAfter: sendMassiveAfter,
            sendStatus: sendStatus,
            deleteThread: deleteThread,
            getUsersGroups: getUsersGroups,
            setSubsec: setSubsec,
            getReferencesSections: getReferencesSections,
            getValuesReferencesSections: getValuesReferencesSections,
            triggerGroupsFilter: triggerGroupsFilter,
            getLog: getLog,
            getLogByFilter: getLogByFilter,
            getLogByUser: getLogByUser,
            getFilters: getFilters,
            getOptions: getOptions,
            exportLogByMailingContentId: exportLogByMailingContentId,
            isolateBounces: isolateBounces,
            convertLog: convertLog,
            getPreviewToken: getPreviewToken,
            getPDFFile: getPDFFile,
            estado: estado,
            massiveStats: massiveStats

        });


    }


})();

(function () {
  'use strict';
  $(window.document).on('contextmenu', '.list-media-item', function (e) {
    var menu = $('#context-menu');

    if (e.pageX >= window.innerWidth - menu.width()) {
      e.pageX -= menu.width();
    }
    if (e.pageY >= window.innerHeight - menu.height()) {
      e.pageY -= menu.height();
    }

    var posx = 0;
    var posy = 0;

    if (!e) {
      var e = window.event;
    }

    posx = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
    posy = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;

    menu.hide().css({
      left: e.pageX,
      top: e.pageY
      // left: posx,
      // top: posy
    }).show();

    e.preventDefault();
  });

  angular
    .module('app.mailing')
    .controller('MailingMassiveMessagesController', MailingMassiveMessagesController);


  /** @ngInject */
  function MailingMassiveMessagesController(
    $scope, $rootScope, $document, $mdDialog, $mdMenu, $mdMedia, $mdToast, $mdConstant,
    $mdSidenav, $state, requestContext, $timeout, mailingService, transformMailing, msUtils, $anchorScroll,
    $translate, sessionService, tinyMceService, $window, mediaService, Upload, sharedFunctionsMailing, contentFunctionsMailing, section,
    usersService, transformUsers, $q, $filter, $templateCache, templateBuilderConfig, $http
  ) {
    /*
        Object.keys(templateBuilderConfig.blocks).forEach(function (key) {
          if (templateBuilderConfig.disableBlocks.indexOf(key) === -1) {
            $http.get('app/main/plugins/template-builder/fields/' + templateBuilderConfig.blocks[key].type + '.html').then(function(response) {
              $templateCache.put(templateBuilderConfig.blocks[key].type + 'Template', response.data);
            })
          }
        });
    */
    var vm = this;
    vm.showLoader = false;
    vm.templates = null;
    vm.channels = null;
    vm.templateSelected = false;
    vm.query = undefined;
    vm.loadTemplates = false;
    vm.isChannel = false;
    vm.isUpdateContent = false;
    vm.currentContent = undefined;
    vm.templateRelated = undefined;
    vm.selectedThreads = [];
    vm.usersGroups = undefined;
    vm.usersGroupsIds = undefined;
    vm.currentLabels = undefined;
    vm.nextPageLog = 1;
    $scope.section = section;

    $scope.array = [{
      active: true,
      value: 'Copy'
    }, {
      active: true,
      value: 'Cut'
    }, {
      active: false,
      value: 'Paste'
    }];

    vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg', 'red-bg', 'yellow-bg', 'light-blue-bg'];
    vm.testEmails = ['test@domain.com', 'other@testing.com', 'name@tester.com'];
    vm.sendExtraEmails = [];
    vm.sendGroups = ['Group 1', 'Group 2'];

    vm.selectedAccount = 'creapond';
    vm.selectedIndexTab = 0;

    vm.folders = [];
    vm.labels = [];
    vm.loadingThreads = true;
    vm.isLogsLoading = false;
    vm.enterfirst = true;
    vm.sendNow = true;
    vm.tags = null;
    vm.searchTagText = null;
    vm.selectedTag = null;
    vm.tinymceOptions = tinyMceService.getOptions($scope);
    vm.currentImages = [];

    vm.isOpenChecked = false;
    vm.isClickedChecked = false;
    vm.isBouncedChecked = false;
    vm.isRejectedChecked = false;
    vm.isComplainedChecked = false;
    vm.isSuppressedChecked = false;
    vm.isAllChecked = false;
    vm.isSending = false;
    vm.isUnsubscribedChecked = false;

    vm.activateFilter = activateFilter;
    vm.detailsTabActive = false;

    vm.typeFields = ['separator', 'relatedTable', 'textBox', 'media', 'htmlBox', 'colorPicker', 'checkbox', 'datePicker', 'group', 'lineSeparator', 'previewLink', 'social'];
    vm.keys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA];

    vm.scrollEl = angular.element('#thread-list')[0];

    vm.currentFilter = {
      type: $state.params.type,
      filter: $state.params.filter
    };
    vm.basicForm = {};
    vm.filters = {};
    vm.views = {
      nosplit: 'app/main/apps/mailing/views/massive-messages/list/nosplit-view.html',
      split: 'app/main/apps/mailing/views/massive-messages/list/split-view.html',
      grid: 'app/main/apps/mailing/views/massive-messages/grid/grid-view.html'
    };
    vm.defaultView = 'split';
    vm.currentView = 'split';
    vm.loadingView = true;
    vm.fieldOrder = 'created_at';
    vm.currentFilter = {
      type: $state.params.type,
      filter: $state.params.filter
    };

    vm.defaultContentView = 'massive-messages';
    vm.currentContentView = 'massive-messages';

    vm.defaultStatsView = 'bars';
    vm.currentStatsView = 'bars';

    vm.noexistchanges = true;
    vm.selectedContentSegmentGroups = [];
    vm.usersRef = null;

    vm.isAll = true;

    // Methods
    vm.init = init;
    vm.getInArray = msUtils.getInArray;
    vm.toggleInArray = msUtils.toggleInArray;
    vm.toggleInGroup = msUtils.toggleInGroup;
    vm.getReferencesSections = mailingService.getReferencesSections;
    vm.getExtension = msUtils.getExtension;
    vm.getExtensionIcon = msUtils.getExtensionIcon;
    vm.timeAgo = msUtils.timeAgo;
    vm.getValuesReferencesSections = mailingService.getValuesReferencesSections;
    vm.getLogs = getLogs;
    vm.getLogsByFilter = getLogsByFilter;
    vm.checkAndReload = checkAndReload;
    vm.getLogsByUser = getLogsByUser;

    vm.newContent = newContent;
    vm.newChannel = newChannel;
    vm.openTemplate = openTemplate;
    vm.closeTemplate = closeTemplate;
    vm.openTemplateList = openTemplateList;
    vm.closeTemplateList = closeTemplateList;
    vm.clearTemplateSelected = clearTemplateSelected;
    vm.disableTemplates = disableTemplates;
    vm.selectUser = selectUser;
    vm.closeUser = closeUser;
    vm.saveContent = saveContent;
    vm.openContent = openContent;
    vm.closeContent = closeContent;
    vm.deleteContent = deleteContent;
    vm.setSortField = setSortField;
    vm.setSortOrder = setSortOrder;
    vm.changeView = changeView;
    vm.viewPreview = viewPreview;
    vm.openContentView = openContentView;
    vm.openStatsView = openStatsView;
    vm.sendFull = sendFull;
    vm.sendTest = sendTest;
    vm.getDateFormat = getDateFormat;

    vm.toggleSidenav = toggleSidenav;
    vm.selectOrUnselect = selectOrUnselect;
    vm.setTinyMceContent = setTinyMceContent;

    vm.isSent = isSent;

    vm.groupDialog = groupDialog;
    vm.groupDialogNew = groupDialogNew;
    vm.usersInGroupDialog = usersInGroupDialog;
    vm.openMenu = openMenu;

    vm.initDate = initDate;

    vm.onTabSelected = onTabSelected;

    vm.openImageDialog = openImageDialog;
    vm.sendLaterDialog = sendLaterDialog;
    vm.cancelSend = cancelSend;
    vm.reSchedule = reSchedule;
    vm.deleteImage = deleteImage;
    vm.setImage = setImage;
    vm.mediaDialogSingle = mediaDialogSingle;

    vm.toggleSelectThread = toggleSelectThread;
    vm.toggleSelectThreads = toggleSelectThreads;
    vm.isSelected = isSelected;
    vm.deselectThreads = deselectThreads;
    vm.duplicateContent = duplicateContent;
    vm.openUsersGroupsDialog = openUsersGroupsDialog;
    vm.deleteTarget = deleteTarget;

    vm.getFirstTextBox = getFirstTextBox;

    vm.translate = instantTranslate;
    vm.segmentGroupDialogNew = segmentGroupDialogNew;
    vm.changeGroupSubscriptionDialog = changeGroupSubscriptionDialog;
    vm.exportMailingLogByMailingContentId = exportMailingLogByMailingContentId;

    vm.isolateBounces = isolateBounces;
    vm.changeMailingTemplate = changeMailingTemplate;
    vm.openGroupsDialog = openGroupsDialog;
    vm.mailingPreviewUrl = sessionService.site_operative.mailingPreviewUrl;
    vm.searchString = '';

    vm.filterName = 'All';

    vm.siteLanguages = siteLanguages;

    //////////

    init();

    /**
     * Initialize
     */
    function init() {
      var siteID = requestContext.getParam("siteId");
      $scope.modalShown = false;
      $scope.siteID = siteID;

      $rootScope.global.titleToolbar = '<i class="icon s20 icon-telegram mr-15" ng-if="node.icon"></i><span class="hide show-gt-xs">MAILING</span><i class="mr-5 ml-5 icon s18 icon-chevron-right hide show-gt-xs"></i> ' + section;

      $scope.page = 1;
      if ($state.params.id) {
        vm.openContent($state.params.id);
      }
      vm.isAdmin = sessionService.user.is_admin;
      sessionService.loadDomainResourceSettings($scope.siteID).then(function (response){
        vm.splitContent = response.mailingHeaderContentSplitOption;
      });

    }

    function siteLanguages() {
      return sessionService.getSiteLanguages();
  }

    /**
     * Multiple comma separated chips to add
     */
    $scope.addChips = function (chips, model) {
      if(chips && chips.indexOf(';')){
        var chipsArray = chips.split(';');
      }else{
        var chipsArray = chips.split(',');
      }
      angular.forEach(chipsArray, function (chip) {
        model.push(chip);
      });
      return null;
    };
    /**
     * Validate emails in Chips
     */
    $scope.validateEmail = function (emails) {
      for (var i = 0; i < emails.length; i++) {
        emails[i] = emails[i].toLowerCase();
        var reg = /^(([^<>()\[\]\\.,;:\s@\"]+(\.[^<>()\[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!reg.test(emails[i])) {
          this.invalidEmail = true;
          // remove last invalid email address :)
          emails.splice(i, 1);
        }
        else {
          this.invalidEmail = false;
        }
      }
    };

    // Watch screen size to change view modes
    $scope.$watch(function () {
      return $mdMedia('lt-sm');
    }, function (current, old) {
      if (angular.equals(current, old)) {
        return;
      }

      if (current) {
        vm.currentView = 'nosplit';
      }
    });

    $scope.$watch(function () {
      return $mdMedia('max-width: 960px');
    }, function (big) {

      if (big) {
        vm.currentView = 'nosplit';
        vm.chartWidth = 600;
        vm.donutSm = 100;
        vm.donutLg = 120;
      }

    });

    $scope.$watch(function () {
      return $mdMedia('min-width: 960px');
    }, function (small) {

      if (small) {
        vm.currentView = 'split';
        vm.chartWidth = 700;
        vm.chartWidthColumn = 350;
        vm.donutSm = 120;
        vm.donutLg = 150;
      }


    });
    $scope.$watch(function () {
      return $mdMedia('min-width: 1280px');
    }, function (small) {

      if (small) {
        vm.chartWidthColumn = 350;

      }


    });
    $scope.$watch(function () {
      return $mdMedia('min-width: 1441px');
    }, function (small) {

      if (small) {
        vm.chartWidthColumn = 450;

      }


    });
    $scope.$watch(function () {
      return $mdMedia('width: 1024px');
    }, function (big) {

      if (big) {
        vm.chartWidth = 500;
        vm.chartWidthColumn = 240;
      }

    });

    $scope.$watch(function () {
      return $mdMedia('max-width: 767px');
    }, function (big) {

      if (big) {
        vm.chartWidth = 350;
        vm.chartWidthColumn = 350;
        vm.donutSm = 85;
        vm.donutLg = 100;

      }

    });

    $scope.$watch(function () {
      return $mdMedia('gt-sm');
    }, function (current, old) {
      if (angular.equals(current, old)) {
        return;
      }

      if (current) {
        if (vm.defaultView === 'split') {
          vm.currentView = 'split';
        }
      }
    });


    $scope.$watch('vm.filters', function () {
      vm.loadingReadPane = false;
    }, true);

    $scope.$on('$includeContentLoaded', function (event, target) {
      $timeout(function () {
        vm.loadingView = false;
      }, 1000);
    });

    $scope.$on('pagination:loadStart', function (event) {
      // $anchorScroll();

      // Store the current scrollPos
      // vm.scrollPos = vm.scrollEl.scrollTop();

      // Scroll to the top
      // vm.scrollEl.scrollTop(0);
      if (!vm.enterfirst) {
        var elem = angular.element(document.getElementById('thread-list'));
        elem.scrollTopAnimated(0, 10);
      }

      // angular.element("#thread-list").scrollTop=0;

      vm.enterfirst = false;

      $scope.isLoading = true;
    });

    $scope.$on('pagination:loadPage', function (event) {
      $scope.isLoading = false;
      vm.dataAlreadyLoaded = true;
      $timeout(() => {
        $timeout.cancel(vm.timeout);
        vm.checkAndReload();
      }, 1000);
    });

    $scope.title = "Angularjs Bootstrap Modal Directive Example";
    $scope.showModal1 = false;
    $scope.showModal2 = false;

    $scope.hide = function (m) {
      if (m === 1) {
        $scope.showModal1 = false;
      }
      else {
        $scope.showModal2 = false;
      }
    }

    $scope.modalOneShown = function () {
      console.log('model one shown');
    }

    $scope.modalOneHide = function () {
      console.log('model one hidden');
    }

    function isPendingToSend(x) {
      return x.id_message_status == 2 || x.id_message_status == 3 || x.id_message_status == 4 || x.id_message_status == 6;
    }

    function checkAndReload() {
      if (vm.massive.filter(isPendingToSend).length > 0) {
        vm.timeout = $timeout(() => {
          var options = {
            siteID: $scope.siteID,
            section: 'massive-messages',
            page: $rootScope.pagination_current_page,
            resultsPerPage: $rootScope.perPage,
            sortDir: $rootScope.sortDir
          };
          mailingService.get(options).then(function (response) {
            vm.massive = vm.massive.map(x => {
              if (isPendingToSend(x)) {
                return response.data.find(y => y.id_message === x.id_message);
              }
              return x;
            })
            if (vm.massive.filter(isPendingToSend).length > 0) {
              vm.checkAndReload();
            }
          })
        }, 5000);
      }

    }


    function isSent(content) {
      var now = moment().utc()
      if (content.id_message_status != 5) {
        return false;
      } else {
        return true;
      }
    }

    function toggleSelectThread(thread, event) {
      vm.selectedThreads = sharedFunctionsMailing.toggleSelectThread(vm.selectedThreads, thread, event);
    }

    function isSelected(thread) {
      return sharedFunctionsMailing.isSelected(vm.selectedThreads, thread);
    }

    function resetAllFilter() {
      vm.isAll = false;
      vm.isOpenChecked = false;
      vm.isClickedChecked = false;
      vm.isBouncedChecked = false;
      vm.isRejectedChecked = false;
      vm.isComplainedChecked = false;
      vm.isSuppressedChecked = false;
      vm.isUnsubscribedChecked = false;
    };

    function search() {

    }

    function activateFilter(resetpage) {
      if (resetpage) {
        vm.nextPageLog = 1;
      }
      vm.getLogsByFilter(vm.currentContent.id_message, vm.nextPageLog, vm.filter, vm.searchString, vm.groupFiltered);
    }

    function setTinyMceContent(event) {
      var zoneMedia = {
        1: {},
        2: {},
        3: {},
        4: {}
      };
      var typesMax = {
        1: 0,
        2: 0,
        3: 0,
        4: 0
      };
      var currentSort = 0;
      var currentType = 0;

      return zoneMedia;
    }

    function onTabSelected(tab) {
      vm.tabSelected = tab;
    }

    var originatorEv;

    function openMenu($mdMenu, ev) {
      originatorEv = ev;
      $mdMenu.open(ev);
    }

    function deleteContent() {
      vm.loadingReadPane = true;
      if (vm.selectedThreads.length == 1) {
          var messageConfirm = $translate.instant('MASSIVE_MESSAGES.SURE_DELETED_SINGULAR');
          var contentConfirm = $translate.instant('MASSIVE_MESSAGES.WILL_DELETE_ITEM');
          var message = $translate.instant('MASSIVE_MESSAGES.DELETED');
      }
      else {
          var messageConfirm = $translate.instant('MASSIVE_MESSAGES.SURE_DELETED_PLURAL');
          var contentConfirm = $translate.instant('MASSIVE_MESSAGES.WILL_DELETE_ITEMS');
          var message = $translate.instant('MASSIVE_MESSAGES.DELETED');
      }
       var confirm = $mdDialog.confirm()
         .title(messageConfirm)
         .htmlContent('<b>'+ contentConfirm +'</b>.')
         .ariaLabel('Delete item')
         .ok('OK')
         .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        for (var i = 0; i < vm.selectedThreads.length; i++) {
          var options = {
            site: $scope.siteID,
            section: 'massive-messages',
            id: vm.selectedThreads[i].id_message
          };
          mailingService.deleteThread(options).then(function (response) {
            $rootScope.pagination_resetquery();
            vm.loadingReadPane = false;
            vm.clearTemplateSelected();
            sharedFunctionsMailing.toggleSelectThread(vm.selectedThreads, vm.selectedThreads[i])
            deselectThreads();
          });
      }}, function (){
        vm.loadingReadPane = false;
      })
    }


    function deselectThreads() {
      vm.selectedThreads = sharedFunctionsMailing.deselectThreads();
    }

    function newContent() {
      vm.loadingReadPane = true;
      vm.closeContent();
      vm.isChannel = false;
      vm.loadTemplates = true;

      if (angular.element(document.getElementById('thread-detail')).length) {
        var elem = angular.element(document.getElementById('thread-detail'));
        elem.scrollTopAnimated(0, 10);
      }

      $state.go('app.site_overview.mailing.massive-messages.list.templates', {
        id: vm.selectedContentID
      }, {
        notify: false,
        inherit: true,
        location: true
      });

      vm.currentContent = {
        id_message: '',
        id_message_status: 1,
        structure_mjml: {},
        template: {},
        subject: '',
        test_emails_json: {}
      }
      getTemplates();
      // console.log(!vm.isChannel && (vm.loadTemplates || vm.isUpdateContent));
      // console.log(!vm.isChannel);
      // console.log((vm.loadTemplates || vm.isUpdateContent));
      // console.log(vm.loadTemplates);
      // console.log(vm.isUpdateContent);
    }

    function newChannel() {
      vm.loadingReadPane = true;
      vm.closeContent();

      if (angular.element(document.getElementById('thread-detail')).length) {
        var elem = angular.element(document.getElementById('thread-detail'));
        elem.scrollTopAnimated(0, 10);
      }

      $state.go('app.site_overview.mailing.massive-messages.list.channel', {
        id: vm.selectedContentID
      }, {
        notify: false,
        inherit: true,
        location: true
      });

      vm.currentContent = {
        id_message: '',
        id_message_status: 1,
        structure_mjml: {},
        template: {},
        subject: '',
        test_emails_json: {}
      }
      getChannels();
      
    }
    function getChannels() {
      var options = {
        page: 1,
        resultsPerPage: 100,
        section: "channel",
        siteID: $scope.siteID,
        sortDir: "ASC"
      }

      mailingService.get(options).then(function (response) {
        // console.log(response)
        vm.channels = response.data;
        vm.loadingReadPane = false;
        vm.loadTemplates = false;
        vm.isChannel = true;
        vm.loadChannels = true;

      });
    }
    function getTemplates() {
      var options = {
        page: 1,
        resultsPerPage: 100,
        section: "templates",
        siteID: $scope.siteID,
        sortDir: "ASC"
      }

      mailingService.get(options).then(function (response) {
        vm.templates = response.data;
        vm.loadingReadPane = false;
        vm.loadTemplates = true;
        vm.isChannel = false;
        vm.loadChannels = true;

      });
    }

    function duplicateContent() {
      for (var i = 0; i < vm.selectedThreads.length; i++) {
        var options = {
          id: vm.selectedThreads[i].id_message,
          section: "massive-messages",
          site: $scope.siteID
        }
        mailingService.getByID(options).then(function (response) {
          vm.saveContent(transformMailing.formatDuplicateContent(response));
        })
      }
    }

    function openUsersGroupsDialog() {
      $mdDialog.show({
        controller: 'UsersGroupController',
        controllerAs: 'vm',
        locals: {
          usersGroups: angular.copy(vm.usersGroups),
          selectedGroups: angular.copy(vm.currentContent.users_groups_json),
          isTiny: false
        },
        templateUrl: 'app/main/dialogs/users-group/users-group-view.html',
        parent: angular.element($document.body),
        targetEvent: 'ev',
        clickOutsideToClose: true,

      }).then(function (object) {
        if (object) {
          vm.currentContent.users_groups_json = sharedFunctionsMailing.updateUsersGroups(object.usersGroups);
          vm.currentLabels = object.labels;
          vm.basicForm.$setDirty();
        }
      });
    }

    function deleteTarget(id, index) { // TODO(Refactorizar)
      var index_user_group = vm.currentContent.users_groups_json.indexOf(id);
      if (index_user_group > -1) {
        vm.currentContent.users_groups_json.splice(index_user_group, 1);
      }
      vm.currentLabels.splice(index, 1);
      vm.basicForm.$setDirty();
    }

    function getCurrentLabels() {
      var usersGroupsAux = sharedFunctionsMailing.initUsersGroup(angular.copy(vm.usersGroups), angular.copy(vm.currentContent.users_groups_json));
      vm.currentLabels = sharedFunctionsMailing.getLabels(usersGroupsAux);
    }


    function groupDialog(structure_group, index, group) {
      $mdDialog.show({
        controller: 'GroupMailingController',
        controllerAs: 'vm',
        locals: {
          items: angular.copy(group),
          modeView: 'editing',
          section: $scope.section,
          isTiny: false
        },
        templateUrl: 'app/main/apps/mailing/dialogs/group/group-mailing.html',
        parent: angular.element($document.body),
        targetEvent: 'ev',
        clickOutsideToClose: true,

      }).then(function (result) {
        if (result) {
          structure_group.groups[index] = result;
        }
        vm.basicForm.$setDirty();
      });
    }

    function groupDialogNew(structure_group, items) {
      $mdDialog.show({
        controller: 'GroupMailingController',
        controllerAs: 'vm',
        locals: {
          items: angular.copy(items),
          modeView: 'editing',
          section: $scope.section,
          isTiny: false
        },
        templateUrl: 'app/main/apps/mailing/dialogs/group/group-mailing.html',
        parent: angular.element($document.body),
        targetEvent: 'ev',
        clickOutsideToClose: true,

      }).then(function (result) {
        if (result) {
          if (!structure_group.groups) {
            structure_group.groups = [];
          }
          structure_group.groups.push(result);
        }
        vm.basicForm.$setDirty();
      });
    }

    function changeGroupSubscriptionDialog(ev) {
      $mdDialog.show({
        controller: 'SelectGroupDialogController',
        controllerAs: 'vm',
        locals: {
          siteID: $scope.siteID,
          sourceGroups: [vm.selectedGroup]
        },
        templateUrl: 'app/main/apps/mailing/dialogs/select-group-dialog/select-group-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true
      }).then(function (result) {
        if (result) {
          // console.log(result);
          // console.log(vm.currentContent);
          vm.currentContent.mailing_template.subscription_group_object = result;
          vm.currentContent.segment_group = result.id_group;
          var options = {
            siteID: $scope.siteID,
            section: $scope.section,
            groupIds: [result.id_group],
          };
          vm.loadingUsersCount = true;
          usersService.getUsersByGroupsCount(options).then(function (response2) {
            vm.loadingUsersCount = false;
            vm.currentContent.mailing_template.subscription_group_object.totalUsers = response2.result.total;
          });
        }
      });
    }


    function segmentGroupDialogNew($event) {
      var promiseList = [];
      promiseList.push(usersService.getUsersGroups({
        siteID: $scope.siteID,
        //groupType: 2, // Subscription
        withGroupType: true
      })
      );
      promiseList.push(usersService.getUsersGroupsTypes({ siteID: $scope.siteID }));

      $q.all(promiseList).then(function (response) {
        var cleanUsersGroups = response[0].data; //transformUsers.formatNestedGroups(response[0]);
        var usersGroupsTypes = response[1]; //$filter('filter')(response[1], {'id_group_type': 2}, true);
        openSegmentGroupDialogNew(cleanUsersGroups, usersGroupsTypes);
      }).catch(function (error) {
        console.log(error);
      });
    }

    function openSegmentGroupDialogNew(cleanUsersGroups, usersGroupsTypes) {
      var groupsTree = angular.copy(cleanUsersGroups);
      var booleanOperations = [
        {
          operation: 'add',
          name: $translate.instant('GROUP.ACTIONS.ANY')
        },
        {
          operation: 'intersect',
          name: $translate.instant('GROUP.ACTIONS.ALL')
        }
      ];
      $mdDialog.show({
        controller: 'SegmentUsersGroupsController',
        controllerAs: 'vm',
        locals: {
          usersGroups: cleanUsersGroups,
          usersGroupsTypes: usersGroupsTypes,
          booleanOperations: booleanOperations,
          defaultGroupTypeId: 2, //subscription
          showGroupsTypes: false,
          newGroupShow: true,
          subscriptionGroupId: vm.currentContent.mailing_template.subscription_group_object.id_group,
          subscriptionGroupName: vm.currentContent.mailing_template.subscription_group_object.name,
        },
        templateUrl: 'app/main/dialogs/segment-users-groups/segment-users-groups.html',
        parent: angular.element($document.body),
        targetEvent: 'ev',
        clickOutsideToClose: true

      }).then(function (newSegment) {
        if (newSegment) {
          vm.currentContent.segment_group = newSegment.id_group;
          var object = contentFunctionsMailing.createOptionsContent(vm.currentContent, vm.isUpdateContent, $scope, false);
          var options = object.options;
          var method = object.method;

          mailingService.saveMassive({
            site: $scope.siteID,
            section: 'massive-messages',
            id: options.item.id_message,
            item: options.item
          }, method).then(function (response) {
            var options = {
              siteID: $scope.siteID,
              section: $scope.section,
              groupIds: [newSegment.id_group],
              sortDir: $rootScope.sortDir,
              sortField: $rootScope.sortField
            };
            usersService.getUsersByGroups(options).then(function (response2) {
              newSegment.totalUsers = response2.result.total;
              vm.selectedContentSegmentGroups.push(newSegment);
            })
          });

          /*
          if (!structure_group.groups) {
            structure_group.groups = [];
          }
          structure_group.groups.push(result);
          */
        }
        vm.basicForm.$setDirty();
      });
    }

    function usersInGroupDialog(groupId, groupName) {
      if (groupId) {
        $mdDialog.show({
          controller: 'UsersInGroupMailingController',
          controllerAs: 'vm',
          locals: {
            usersRef: vm.usersRef,
            groupId: groupId,
            groupName: groupName,
            section: $scope.section,
            siteID: $scope.siteID
          },
          templateUrl: 'app/main/apps/mailing/dialogs/users-ingroup/users-ingroup-mailing.html',
          parent: angular.element($document.body),
          targetEvent: 'ev',
          clickOutsideToClose: true,

        }).then(function (result) {
          if (result) {
            structure_group.groups[index] = result;
          }
          vm.basicForm.$setDirty();
        });
      }
    }


    function openTemplate(template) {
      vm.templateSelected = true;

      var newTemplate = angular.copy(template);
      var structureMjml = newTemplate.structure_mjml;
      if (Object.keys(vm.currentContent.structure_mjml).length > 0) {
        structureMjml = angular.toJson(vm.currentContent.structure_mjml);
      }
      newTemplate.structure_mjml = structureMjml;
      vm.currentContent.structure_mjml = angular.fromJson(structureMjml);
      vm.currentContent.id_mailing_template = newTemplate.id_mailing_templates;
      vm.currentContent.mailing_template = newTemplate;
      vm.currentContent.mailing_template.test_emails_json = angular.fromJson(newTemplate.test_emails_json) || [];
      vm.openContentView('massive-messages');
      var state;
      if (vm.currentContent.id_message) {
        state = 'app.site_overview.mailing.massive-messages.list.templates.openedContent';
      }
      else {
        state = 'app.site_overview.mailing.massive-messages.list.templates.selectedTemplate';
      }

      $state.go(state, {
        id: vm.currentContent.id_message
      }, {
        notify: false,
        inherit: true,
        location: true
      });
    }

    function closeTemplate() {
      vm.tabSelected = null;
      vm.clearTemplateSelected();
      disableTemplates();
      // console.log(vm.basicForm);
      if (vm.basicForm && vm.basicForm.$setPristine) {
        vm.basicForm.$setPristine();
      }
    }
    function openTemplateList(template) {
      vm.templateSelected = true;

      var newTemplate = angular.copy(template);
      var structureMjml = newTemplate.structure_mjml;
      if (Object.keys(vm.currentContent.structure_mjml).length > 0) {
        structureMjml = angular.toJson(vm.currentContent.structure_mjml);
      }
      newTemplate.structure_mjml = structureMjml;
      vm.currentContent.structure_mjml = angular.fromJson(structureMjml);
      vm.currentContent.id_mailing_template = newTemplate.id_mailing_templates;
      vm.currentContent.mailing_template = newTemplate;
      vm.currentContent.mailing_template.test_emails_json = angular.fromJson(newTemplate.test_emails_json) || [];
      vm.openContentView('massive');
      var state;
      if (vm.currentContent.id_mailing_content) {
        state = 'app.site_overview.mailing.massive-messages.list.templates.openedContent';
      }
      else {
        state = 'app.site_overview.mailing.massive-messages.list.templates.selectedTemplate';
      }

      $state.go(state, {
        id: vm.currentContent.id_mailing_content
      }, {
        notify: false,
        inherit: true,
        location: true
      });
    }

    function closeTemplateList() {
      vm.tabSelected = null;
      vm.clearTemplateSelected();
      disableTemplates();
      if (vm.basicForm.$setPristine) {
        vm.basicForm.$setPristine();
      }
    }
    function selectUser(user) {
      vm.nextPageLogUser = 1;
      vm.selectedUser = user;
      vm.getLogsByUser(user, vm.nextPageLogUser);
    }
    function closeUser() {
      vm.selectedUser = null;
    }

    function disableTemplates() {
      vm.loadTemplates = false;
      var state;
      if (vm.currentContent && vm.currentContent.id_message) {
        vm.templateSelected = true;
        state = 'app.site_overview.mailing.massive-messages.list.templates.openedContent';
      } else {
        state = 'app.site_overview.mailing.massive-messages.list';
      }
      $state.go(state, {}, {
        notify: false,
        inherit: true,
        location: true
      });
    }

    function openContent(idContent, afterSave) {

      // console.log(idContent, afterSave);
      vm.selectedContentSegmentGroups = [];
      if (!afterSave) {
        vm.openContentView('massive-messages');
      }
      vm.loadingReadPane = true;
      vm.selectedContentID = idContent;

      var options = {
        id: idContent,
        section: "massive-messages",
        id_message: idContent,
        site: $scope.siteID
      }

      mailingService.getByID(options).then(function (response) {
        vm.loadingReadPane = false;
        vm.templateSelected = true;

        vm.currentContent = response;
        // Parseo tolerante: un JSON corrupto aquí no debe abortar la carga y dejar
        // el diseño (structure_mjml) sin parsear → editor vacío.
        vm.currentContent.users_groups_json = sharedFunctionsMailing.safeFromJson(response.users_groups_json, [], 'users_groups_json');
        vm.currentContent.test_emails_json = sharedFunctionsMailing.safeFromJson(response.test_emails_json, [], 'test_emails_json') || [];
        try {
          vm.currentContent.structure_mjml = angular.fromJson(response.structure_mjml);
        } catch (e) {
          vm.currentContent.structure_mjml = {};
        }
        //console.log("----------> "+response.mailing_template);
        try {
            vm.currentContent.mailing_template.test_emails_json = angular.fromJson(response.mailing_template.test_emails_json) || [];
          } catch (e) {
            vm.currentContent.mailing_template.test_emails_json = [];
          }

        var options = {
          id: vm.currentContent.mailing_template.subscription_group,
          siteID: $scope.siteID
        }
        usersService.getUsersGroup(options).then(function (response) {
          var options = {
            siteID: $scope.siteID,
            section: $scope.section,
            groupIds: [response.id_group],
          };
          usersService.getUsersByGroupsCount(options).then(function (response2) {
            response.totalUsers = response2.result.total;
            vm.currentContent.mailing_template.subscription_group_object = response;
          });
        });

        if (!angular.isNumber(vm.currentContent.segment_group)) {
          vm.currentContent.segment_group = vm.currentContent.mailing_template.subscription_group;
        }
        if (vm.currentContent.segment_group != vm.currentContent.mailing_template.subscription_group) {
          var options = {
            id: vm.currentContent.segment_group,
            siteID: $scope.siteID
          };
          usersService.getUsersGroup(options).then(function (response) {
            var options = {
              siteID: $scope.siteID,
              section: $scope.section,
              groupIds: [response.id_group],
              sortDir: $rootScope.sortDir,
              sortField: $rootScope.sortField
            };
            usersService.getUsersByGroups(options).then(function (response2) {
              vm.usersRef = response2.ref;
              response.totalUsers = response2.result.total;
              vm.selectedContentSegmentGroups.push(response);
            });
          });
        }

        vm.currentContent.not_delivered_count = vm.currentContent.sent_count - vm.currentContent.delivered_count;
        vm.currentContent.blacklisted_count = vm.currentContent.total_count - vm.currentContent.sent_count;
        vm.currentContent.total_count = (!vm.currentContent.total_count) ? '0' : vm.currentContent.total_count;
        vm.currentContent.sent_count = (!vm.currentContent.sent_count) ? '0' : vm.currentContent.sent_count;
        vm.currentContent.blacklisted_count = (!vm.currentContent.blacklisted_count) ? '0' : vm.currentContent.blacklisted_count;
        vm.currentContent.delivered_count = (!vm.currentContent.delivered_count) ? '0' : vm.currentContent.delivered_count;
        vm.currentContent.not_delivered_count = (!vm.currentContent.not_delivered_count) ? '0' : vm.currentContent.not_delivered_count;
        vm.currentContent.open_count = (!vm.currentContent.open_count) ? '0' : vm.currentContent.open_count;
        vm.currentContent.clicked_count = (!vm.currentContent.clicked_count) ? '0' : vm.currentContent.clicked_count;
        vm.currentContent.rejected_count = (!vm.currentContent.rejected_count) ? '0' : vm.currentContent.rejected_count;
        vm.currentContent.bounced_count = (!vm.currentContent.bounced_count) ? '0' : vm.currentContent.bounced_count;
        vm.currentContent.complained_count = (!vm.currentContent.complained_count) ? '0' : vm.currentContent.complained_count;
        vm.currentContent.suppressed_count = (!vm.currentContent.suppressed_count) ? '0' : vm.currentContent.suppressed_count;
        vm.currentContent.not_delivered_processing_count = (!vm.currentContent.not_delivered_processing_count) ? '0' : vm.currentContent.not_delivered_processing_count;

        vm.isUpdateContent = true;
        vm.statsCharts = {
          options: {
            sent: {
              chart: {
                type: 'pieChart',
                height: 370,
                x: function (d) {
                  return d.key;
                },
                y: function (d) {
                  return d.y;
                },
                valueFormat: function (n) {
                  return n;
                },
                donut: true,
                donutRatio: 0.3,
                labelsOutside: false,
                showLabels: true,
                duration: 5,
                labelThreshold: 0.01,
                labelSunbeamLayout: false,
                legendPosition: 'bottom',
                legend: {
                  margin: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                  }
                },
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              }
            },
            open: {
              chart: {
                type: 'pieChart',
                height: 200,
                donut: true,
                x: function (d) {
                  return d.key;
                },
                y: function (d) {
                  return d.y;
                },
                valueFormat: function (n) {
                  return n;
                },
                showLabels: true,
                showLegend: false,
                pie: {
                  startAngle: function (d) {
                    return d.startAngle / 2 - Math.PI / 2
                  },
                  endAngle: function (d) {
                    return d.endAngle / 2 - Math.PI / 2
                  }
                },
                duration: 500,
                legend: {
                  margin: {
                    top: 5,
                    right: 60,
                    bottom: 5,
                    left: 0
                  }
                },
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              }
            },
            click: {
              chart: {
                type: 'pieChart',
                height: 200,
                donut: true,
                x: function (d) {
                  return d.key;
                },
                y: function (d) {
                  return d.y;
                },
                valueFormat: function (n) {
                  return n;
                },
                showLabels: true,
                showLegend: false,
                donutLabelsOutside: false,
                labelsOutside: false,
                pie: {
                  startAngle: function (d) {
                    return d.startAngle / 2 - Math.PI / 2
                  },
                  endAngle: function (d) {
                    return d.endAngle / 2 - Math.PI / 2
                  }
                },
                duration: 500,
                legend: {
                  margin: {
                    top: 5,
                    right: 60,
                    bottom: 5,
                    left: 0
                  }
                },
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              }
            },
            all: {
              chart: {
                type: 'discreteBarChart',
                height: 350,
                width: vm.chartWidth,
                margin: {
                  top: 20,
                  right: 10,
                  bottom: 50,
                  left: 10
                },
                rotateLabels: -20,
                x: function (d) { return d.label; },
                y: function (d) { return Math.round(d.value + (1e-10)); },
                showValues: true,
                showYAxis: false,
                valueFormat: function (n) {
                  return n;
                },
                duration: 500,
                xAxis: {
                  tickPadding: 12
                },
                yAxis: {
                  axisLabelDistance: 0
                }
              }
            },
            all_vertical: {
              chart: {
                type: 'multiBarHorizontalChart',
                height: 400,
                width: vm.chartWidthColumn,
                margin: {
                  top: 20,
                  right: 10,
                  bottom: 50,
                  left: 80
                },
                rotateLabels: -20,
                x: function (d) { return d.label; },
                y: function (d) { return Math.round(d.value + (1e-10)); },
                showValues: true,
                showYAxis: false,
                valueFormat: function (n) {
                  return n;
                },
                duration: 500,
                xAxis: {
                  tickPadding: 12
                },
                yAxis: {
                  axisLabelDistance: 0
                },
                showControls: false
              }
            },
            donut_total: {
              chart: {
                type: 'pieChart',
                height: vm.donutLg,
                width: vm.donutLg,
                tooltip: {
                  enabled: false
                },
                growOnHover: false,
                x: function (d) {
                  return d.key;
                },
                y: function (d) {
                  return d.y;
                },
                valueFormat: function (n) {
                  return n;
                },
                title: vm.currentContent.total_count,
                titleOffset: -15,
                donut: true,
                donutRatio: 0.85,
                labelsOutside: false,
                showLabels: false,
                duration: 5,
                labelThreshold: 0.01,
                labelSunbeamLayout: false,
                showLegend: false,
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              },
              legend: {
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              }

            },
            donut_sent: {
              chart: {
                type: 'pieChart',
                height: vm.donutLg,
                width: vm.donutLg,
                tooltip: {
                  enabled: false
                },
                growOnHover: false,
                x: function (d) {
                  return d.key;
                },
                y: function (d) {
                  return d.y;
                },
                valueFormat: function (n) {
                  return n;
                },
                title: vm.currentContent.sent_count,
                titleOffset: -15,
                donut: true,
                donutRatio: 0.85,
                labelsOutside: false,
                showLabels: false,
                duration: 5,
                labelThreshold: 0.01,
                labelSunbeamLayout: false,
                showLegend: false,
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              },
              legend: {
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              }
            },
            donut_delivered: {
              chart: {
                type: 'pieChart',
                height: vm.donutLg,
                width: vm.donutLg,
                tooltip: {
                  enabled: false
                },
                growOnHover: false,
                x: function (d) {
                  return d.key;
                },
                y: function (d) {
                  return d.y;
                },
                valueFormat: function (n) {
                  return n;
                },
                title: vm.currentContent.delivered_count,
                titleOffset: -15,
                donut: true,
                donutRatio: 0.85,
                labelsOutside: false,
                showLabels: false,
                duration: 5,
                labelThreshold: 0.01,
                labelSunbeamLayout: false,
                showLegend: false,
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              },
              legend: {
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              }
            },
            donut_not_delivered: {
              chart: {
                type: 'pieChart',
                height: vm.donutLg,
                width: vm.donutLg,
                tooltip: {
                  enabled: false
                },
                growOnHover: false,
                x: function (d) {
                  return d.key;
                },
                y: function (d) {
                  return d.y;
                },
                valueFormat: function (n) {
                  return n;
                },
                title: vm.currentContent.not_delivered_count,
                titleOffset: -15,
                donut: true,
                donutRatio: 0.85,
                labelsOutside: false,
                showLabels: false,
                duration: 5,
                labelThreshold: 0.01,
                labelSunbeamLayout: false,
                showLegend: false,
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              },
              legend: {
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              }
            },
            donut_blacklisted: {
              chart: {
                type: 'pieChart',
                height: vm.donutLg,
                width: vm.donutLg,
                tooltip: {
                  enabled: false
                },
                growOnHover: false,
                x: function (d) {
                  return d.key;
                },
                y: function (d) {
                  return d.y;
                },
                valueFormat: function (n) {
                  return n;
                },
                title: vm.currentContent.blacklisted_count,
                titleOffset: -15,
                donut: true,
                donutRatio: 0.85,
                labelsOutside: false,
                showLabels: false,
                duration: 5,
                labelThreshold: 0.01,
                labelSunbeamLayout: false,
                showLegend: false,
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              },
              legend: {
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              }
            },
            donut_opened: {
              chart: {
                type: 'pieChart',
                height: vm.donutSm,
                width: vm.donutSm,
                tooltip: {
                  enabled: false
                },
                growOnHover: false,
                x: function (d) {
                  return d.key;
                },
                y: function (d) {
                  return d.y;
                },
                valueFormat: function (n) {
                  return n;
                },
                title: vm.currentContent.open_count,
                titleOffset: -15,
                donut: true,
                donutRatio: 0.85,
                labelsOutside: false,
                showLabels: false,
                duration: 5,
                labelThreshold: 0.01,
                labelSunbeamLayout: false,
                showLegend: false,
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              },
              legend: {
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              }
            },
            donut_clicked: {
              chart: {
                type: 'pieChart',
                height: vm.donutSm,
                width: vm.donutSm,
                tooltip: {
                  enabled: false
                },
                growOnHover: false,
                x: function (d) {
                  return d.key;
                },
                y: function (d) {
                  return d.y;
                },
                valueFormat: function (n) {
                  return n;
                },
                title: vm.currentContent.clicked_count,
                titleOffset: -15,
                donut: true,
                donutRatio: 0.85,
                labelsOutside: false,
                showLabels: false,
                duration: 5,
                labelThreshold: 0.01,
                labelSunbeamLayout: false,
                showLegend: false,
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              },
              legend: {
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              }
            },
            donut_rejected: {
              chart: {
                type: 'pieChart',
                height: vm.donutSm,
                width: vm.donutSm,
                tooltip: {
                  enabled: false
                },
                growOnHover: false,
                x: function (d) {
                  return d.key;
                },
                y: function (d) {
                  return d.y;
                },
                valueFormat: function (n) {
                  return n;
                },
                title: vm.currentContent.rejected_count,
                titleOffset: -15,
                donut: true,
                donutRatio: 0.85,
                labelsOutside: false,
                showLabels: false,
                duration: 5,
                labelThreshold: 0.01,
                labelSunbeamLayout: false,
                showLegend: false,
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              },
              legend: {
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              }
            },
            donut_bounced: {
              chart: {
                type: 'pieChart',
                height: vm.donutSm,
                width: vm.donutSm,
                tooltip: {
                  enabled: false
                },
                growOnHover: false,
                x: function (d) {
                  return d.key;
                },
                y: function (d) {
                  return d.y;
                },
                valueFormat: function (n) {
                  return n;
                },
                title: vm.currentContent.bounced_count,
                titleOffset: -15,
                donut: true,
                donutRatio: 0.85,
                labelsOutside: false,
                showLabels: false,
                duration: 5,
                labelThreshold: 0.01,
                labelSunbeamLayout: false,
                showLegend: false,
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              },
              legend: {
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              }
            },
            donut_complained: {
              chart: {
                type: 'pieChart',
                height: vm.donutSm,
                width: vm.donutSm,
                tooltip: {
                  enabled: false
                },
                growOnHover: false,
                x: function (d) {
                  return d.key;
                },
                y: function (d) {
                  return d.y;
                },
                valueFormat: function (n) {
                  return n;
                },
                title: vm.currentContent.complained_count,
                titleOffset: -15,
                donut: true,
                donutRatio: 0.85,
                labelsOutside: false,
                showLabels: false,
                duration: 5,
                labelThreshold: 0.01,
                labelSunbeamLayout: false,
                showLegend: false,
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              },
              legend: {
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              }
            },
            donut_suppressed: {
              chart: {
                type: 'pieChart',
                height: vm.donutSm,
                width: vm.donutSm,
                tooltip: {
                  enabled: false
                },
                growOnHover: false,
                x: function (d) {
                  return d.key;
                },
                y: function (d) {
                  return d.y;
                },
                valueFormat: function (n) {
                  return n;
                },
                title: vm.currentContent.suppressed_count,
                titleOffset: -15,
                donut: true,
                donutRatio: 0.85,
                labelsOutside: false,
                showLabels: false,
                duration: 5,
                labelThreshold: 0.01,
                labelSunbeamLayout: false,
                showLegend: false,
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              },
              legend: {
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              }
            },
            donut_not_delivered_processing: {
              chart: {
                type: 'pieChart',
                height: vm.donutSm,
                width: vm.donutSm,
                tooltip: {
                  enabled: false
                },
                growOnHover: false,
                x: function (d) {
                  return d.key;
                },
                y: function (d) {
                  return d.y;
                },
                valueFormat: function (n) {
                  return n;
                },
                title: vm.currentContent.not_delivered_processing_count,
                titleOffset: -15,
                donut: true,
                donutRatio: 0.85,
                labelsOutside: false,
                showLabels: false,
                duration: 5,
                labelThreshold: 0.01,
                labelSunbeamLayout: false,
                showLegend: false,
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              },
              legend: {
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              }
            }

          },
          data: {
            sent: [
              {
                key: "Delivered",
                y: vm.currentContent.delivered_count,
                visible: false
              },
              {
                key: "Rejected",
                y: vm.currentContent.rejected_count
              },
              {
                key: "Bounced",
                y: vm.currentContent.bounced_count
              },
              {
                key: "Complained",
                y: vm.currentContent.complained_count
              },
              {
                key: "Suppressed",
                y: vm.currentContent.suppressed_count
              },
              {
                key: "Blacklisted",
                y: vm.currentContent.blacklisted_count,
                color: "#333333"
              },
            ],
            open: [
              {
                key: "Opened",
                y: vm.currentContent.open_count
              },
              {
                key: "Not opened",
                y: vm.currentContent.delivered_count - vm.currentContent.open_count
              }
            ],
            click: [
              {
                key: "Clicked",
                y: vm.currentContent.clicked_count
              },
              {
                key: "Not clicked",
                y: vm.currentContent.open_count - vm.currentContent.clicked_count
              }
            ],
            all: [
              {
                values: [
                  {
                    "label": "Total",
                    "value": vm.currentContent.total_count
                  },
                  {
                    "label": "Sent",
                    "value": vm.currentContent.sent_count
                  },
                  {
                    "label": "Delivered",
                    "value": vm.currentContent.delivered_count
                  },
                  {
                    "label": "Open",
                    "value": vm.currentContent.open_count
                  },
                  {
                    "label": "Clicked",
                    "value": vm.currentContent.clicked_count
                  },
                  {
                    "label": "Rejected",
                    "value": vm.currentContent.rejected_count
                  },
                  {
                    "label": "Bounced",
                    "value": vm.currentContent.bounced_count
                  },
                  {
                    "label": "Complained",
                    "value": vm.currentContent.complained_count
                  },
                  {
                    "label": "Suppressed",
                    "value": vm.currentContent.suppressed_count
                  },
                  {
                    "label": "Blacklisted",
                    "value": vm.currentContent.blacklisted_count,
                    "color": "#222222"
                  }
                ]
              }
            ],
            donut_total: [
              {
                key: "",
                y: vm.currentContent.total_count,
                color: '#039be5'

              }
            ],
            donut_sent: [
              {
                key: "",
                y: vm.currentContent.sent_count,
                color: '#039be5'

              },
              {
                key: "",
                y: vm.currentContent.total_count - vm.currentContent.sent_count,
                color: "#dddddd"
              }
            ],
            donut_delivered: [
              {
                key: "",
                y: vm.currentContent.delivered_count,
                color: '#4CAF50'

              },
              {
                key: "",
                y: vm.currentContent.sent_count - vm.currentContent.delivered_count,
                color: "#dddddd"
              }
            ],
            donut_not_delivered: [
              {
                key: "",
                y: vm.currentContent.not_delivered_count,
                color: '#ff0000'

              },
              {
                key: "",
                y: vm.currentContent.delivered_count,
                color: "#dddddd"
              }
            ],
            donut_opened: [
              {
                key: "",
                y: vm.currentContent.open_count,
                color: '#4CAF50'

              },
              {
                key: "",
                y: vm.currentContent.delivered_count - vm.currentContent.open_count,
                color: "#dddddd"
              }
            ],
            donut_clicked: [
              {
                key: "",
                y: vm.currentContent.clicked_count,
                color: '#4CAF50'

              },
              {
                key: "",
                y: vm.currentContent.open_count - vm.currentContent.clicked_count,
                color: "#dddddd"
              }
            ],
            donut_rejected: [
              {
                key: "",
                y: vm.currentContent.rejected_count,
                color: '#ff0000'

              },
              {
                key: "",
                y: vm.currentContent.not_delivered_count - vm.currentContent.rejected_count,
                color: "#dddddd"
              }
            ],
            donut_bounced: [
              {
                key: "",
                y: vm.currentContent.bounced_count,
                color: '#ff0000'

              },
              {
                key: "",
                y: vm.currentContent.not_delivered_count - vm.currentContent.bounced_count,
                color: "#dddddd"
              }
            ],
            donut_complained: [
              {
                key: "",
                y: vm.currentContent.complained_count,
                color: '#ff0000'

              },
              {
                key: "",
                y: vm.currentContent.not_delivered_count - vm.currentContent.complained_count,
                color: "#dddddd"
              }
            ],
            donut_suppressed: [
              {
                key: "",
                y: vm.currentContent.suppressed_count,
                color: '#ff0000'

              },
              {
                key: "",
                y: vm.currentContent.not_delivered_count - vm.currentContent.suppressed_count,
                color: "#dddddd"
              }
            ],
            donut_not_delivered_processing: [
              {
                key: "",
                y: vm.currentContent.not_delivered_processing_count,
                color: '#ff0000'

              },
              {
                key: "",
                y: vm.currentContent.not_delivered_count - vm.currentContent.not_delivered_processing_count,
                color: "#dddddd"
              }
            ],
            donut_blacklisted: [
              {
                key: "",
                y: vm.currentContent.blacklisted_count,
                color: '#000000'

              },
              {
                key: "",
                y: vm.currentContent.total_count - vm.currentContent.blacklisted_count,
                color: "#dddddd"
              }
            ]
          }
        };
        vm.nextPageLog = 1;
        vm.nextPageLogUser = 1;
        vm.getLogs(vm.currentContent.id_message, vm.nextPageLog)
        $state.go('app.site_overview.mailing.massive-messages.list.templates.openedContent', {
          id: vm.currentContent.id_message
        }, {
          notify: false,
          inherit: true,
          location: true
        });
      }).catch(function (err) {
        console.log(err);
        var message = $translate.instant('GLOBAL.ERROR') + '<br>' + err.data.detail;
        $mdToast.show({
          template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
          hideDelay: 5000,
          position: 'top',
          parent: '#content-container'
        });
      });
    }


    function setSortField(field) {
      vm.fieldOrder = field;
      $rootScope.pagination_setSortField(field, $rootScope.sortDir);
    }

    function setSortOrder(order) {
      $rootScope.sortDir = order;
      $rootScope.pagination_setSortField(vm.fieldOrde, $rootScope.sortDir);
    }

    function getFirstTextBox(group) {
      if (group.items) {
        group = angular.copy(group.items);
      }
      var exist = false;
      for (var i = 0; i < group.length; i++) {
        var element = group[i];
        if (element.type == 'textBox') {
          if (element.defaultValue) {
            exist = element.defaultValue;
          }
          else {
            exist = element.value;
          }
        }
      }
      if (!exist) {
        exist = group[0].label;
      }
      return exist;
    }

    function fillTemplateValues(template, content) {
      // TODO Check this
      for (var i = 0; i < content.structure_data_json.length; i++) {
        for (var j = 0; j < template.structure_data_json.length; j++) {
          if (template.structure_data_json[j].id === content.structure_data_json[i].id) {
            if (template.structure_data_json[j].type !== 'media') {
              if (template.structure_data_json[j].allowMultipleSections) {
                template.structure_data_json[j].defaultValue = content.structure_data_json[i].values;
              }
              else {
                template.structure_data_json[j].defaultValue = content.structure_data_json[i].value;
              }
            }

            if (template.structure_data_json[j].type === 'group') {
              if (!template.structure_data_json[j].groups) {
                template.structure_data_json[j].groups = [];
              }
              for (var k = 0; k < content.structure_data_json[i].items.length; k++) {
                content.structure_data_json[i].items[k].defaultValue = content.structure_data_json[i].items[k].value;
                content.structure_data_json[i].items[k].label = template.structure_data_json[j].items[k].label;
                delete content.structure_data_json[i].items[k].value
                if (content.structure_data_json[i].items[k].type === 'checkbox') {
                  content.structure_data_json[i].items[k].checked = content.structure_data_json[i].items[k].defaultValue;
                }
              }
              template.structure_data_json[j].groups.push(content.structure_data_json[i].items);

            }
            else {
              template.structure_data_json[j].defaultValue = content.structure_data_json[i].value;
            }

          }

        }
      }
      return template;
    }


    function closeContent() {
      vm.isUpdateContent = false;
      vm.closeTemplate();
    }

    function getLogs(idContent, page, filter, search, groupFiltered) {
      vm.loadingReadPane = true;
      var options = {
        id_message: idContent,
        site: $scope.siteID,
        page: page,
        resultsPerPage: 250,
        filter: filter,
        search: search,
        groupFiltered: groupFiltered
      }
      mailingService.massiveStats(options).then(function (response) {
        console.log(response);
        vm.pagination_total_log_pages = response.last_page;
        vm.pagination_log_page = response.current_page;
        if (vm.nextPageLog === 1) {
          vm.logs = response;
        } else {
          response = response.filter(log => !vm.logs.some(l => l.id === log.id));
          vm.logs = vm.logs.concat(response)
        }
        vm.loadingReadPane = false;
        vm.nextPageLog++;
      
        vm.clickCount = {};

        vm.logs.forEach(function(log) {
          log.click?.L.forEach(function(click) {
            var link = click.M.link.S;
            if(!vm.clickCount[link]) {
              vm.clickCount[link] = 1;
            } else {
              vm.clickCount[link]++;
            }
          });
        });

        vm.clickCountInfo = {};
        vm.logs.forEach(function(log) {
          var email = log.destination['S'];
          if (!vm.clickCountInfo[email]) {
            vm.clickCountInfo[email] = {};
          }
          log.click?.L.forEach(function(click) {
            var link = click.M.link.S;
            if (!vm.clickCountInfo[email][link]) {
              vm.clickCountInfo[email][link] = 1;
            } else {
              vm.clickCountInfo[email][link]++;
            }
          });
        });


        vm.totalClickCount = {};
        vm.logs.forEach(function(log) {
            var email = log.destination['S'];
            if (!vm.totalClickCount[email]) {
                vm.totalClickCount[email] = 0;
            }
            log.click?.L.forEach(function(click) {
                vm.totalClickCount[email]++;
            });
        });


        vm.toggleDropdown = function(log) {
          log.showDropdown = !log.showDropdown;

          angular.forEach(vm.logs, function(item) {
            if (item !== log) {
              item.showDropdown = false;
            }
          });
        };
      });
    }


    function getLogsByFilter(idContent, page, filter, search, groupFiltered) {
      vm.loadingReadPane = true;

      var options = {
        id_message: idContent,
        site: $scope.siteID,
        page: page,
        resultsPerPage: 250,
        filter: filter,
        search: search,
        groupFiltered: groupFiltered
      }
      
      mailingService.massiveStats(options).then(function (response) {

        console.log(response);
        
        vm.pagination_total_log_pages = response.last_page;
        vm.pagination_log_page = response.current_page;
        if (vm.nextPageLog > 1) {
          vm.logs = vm.logs.concat(response)
        } else {
          vm.logs = response;
        }
        vm.loadingReadPane = false;
        vm.nextPageLog++;

      });
    }
    

    function getLogsByUser(email, page) {
      vm.loadingReadPaneUser = true;
      mailingService.getLogByUser({
        site: $scope.siteID,
        page: page,
        resultsPerPage: 250,
        email: email
      }).then(function (response) {
        vm.pagination_total_log_pages_user = response.last_page;
        vm.pagination_log_page_user = response.current_page;
        if (page > 1) {
          vm.logsUserSelected = vm.logsUserSelected.concat(response.data)
        } else {
          vm.logsUserSelected = response.data;
        }
        vm.loadingReadPaneUser = false;
        vm.nextPageLogUser++;
      });
    }

    function saveContent(content, send) {
      if ($('#md-chips-email input') && $('#md-chips-email input')[0] && $('#md-chips-email input')[0].value) {
        $scope.addChips($('#md-chips-email input')[0].value, vm.currentContent.test_emails_json)
        $scope.validateEmail(vm.currentContent.test_emails_json);
        $('#md-chips-email input')[0].value = '';
      }
      var object = contentFunctionsMailing.createOptionsContent(vm.currentContent, vm.isUpdateContent, $scope, content);
      var options = object.options;
      var method = object.method;
      mailingService.saveMassive({
        site: $scope.siteID,
        section: 'massive-messages',
        id: options.item.id_message,
        item: options.item
      }, method)
        .then(function (response) {
          var message = $translate.instant('MAILING.SAVED');
          if (response.scheduled_at) {
            message = $translate.instant('MAILING.SCHEDULE_SAVED');
          }
          if (!send) {
            $mdToast.show({
              template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
              hideDelay: 5000,
              position: 'top',
              parent: '#content-container'
            });
          } else {
            vm.sendFull(false, true);
          }
          $rootScope.pagination_resetquery();
          vm.basicForm = {};
          vm.openContent(response.id_message, true);
          deselectThreads();
        })
        .catch(function (err) {
          console.log(err);
          var message = $translate.instant('GLOBAL.ERROR') + '<br>' + err.data.detail;

          $mdToast.show({
            template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
            hideDelay: 5000,
            position: 'top',
            parent: '#content-container'
          });
        });

    }

    function toggleSelectThreads() {
      vm.selectedThreads = sharedFunctionsMailing.toggleSelectThreads(vm.selectedThreads, vm.massive);
    }

    function clearTemplateSelected() {
      vm.currentContent = undefined;
      vm.isUpdateContent = false;
      vm.templateSelected = false;
    }

    function changeView(view) {
      if (vm.views[view]) {
        vm.loadingView = true;
        vm.defaultView = view;
        vm.currentView = view;
      }
    }

    function openContentView(view) {
      vm.loadingView = true;
      vm.defaultContentView = view;
      vm.currentContentView = view;
    }

    function openStatsView(view) {
      vm.loadingView = true;
      vm.defaultStatsView = view;
      vm.currentStatsView = view;
    }

    function viewPreview() {
      resetScroll();
      vm.editInline = false;
    }

    function resetScroll() {
      if (angular.element(document.getElementById('thread-detail')).length) {
        var elem = angular.element(document.getElementById('thread-detail'));
        elem.scrollTopAnimated(0, 10);
      }
    }

    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    function selectOrUnselect(item, $event) {
      var isRightClick = $event && $event.which == 3;
      var isDoubleClick = $event && $event.type == 'dblclick';
    };


    function initDate(formItem) {
      formItem.defaultValue ? formItem.defaultValue = new Date(formItem.defaultValue) : formItem.defaultValue = new Date();
    }


    function openImageDialog(ev, index, images, img) {
      $mdDialog.show({
        controller: 'MediaShowDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/dialogs/media-show/media-show-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          Images: images,
          ImageSelected: img,
          cropFormats: false,
          MediaFull: false,
          Tags: false
        }
      });
    }

    function cancelSend() {
      mailingService.cancelMassiveScheduled({
        site: $scope.siteID,
        item: {
          id_message: vm.currentContent.id_message,
        }
      }).then(function (response) {
        vm.currentContent.scheduled_at = null;
        vm.saveContent(vm.currentContent);
      }, function (error) {
        console.log(error);
        $mdToast.show({
          template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg">' +
            $translate.instant('MAILING.CANCEL_NOT_AVAILABLE') + '</div></md-toast>',
          hideDelay: 7000,
          position: 'top',
          parent: '#login-form-wrapper'
        });
      });
    }

    function reSchedule() {
      mailingService.massivereScheduled({
        site: $scope.siteID,
        item: {
          id_message: vm.currentContent.id_message,
          scheduled_at: vm.currentContent.scheduled_at,
        }
      }).then(function (response) {
        var message = $translate.instant('MAILING.RESCHEDULED');
        $mdToast.show({
          template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
          hideDelay: 5000,
          position: 'top',
          parent: '#content-container'
        });

      }, function (error) {
        $mdToast.show({
          template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg">' +
            $translate.instant('MAILING.CANCEL_NOT_AVAILABLE') + '</div></md-toast>',
          hideDelay: 7000,
          position: 'top',
          parent: '#login-form-wrapper'
        });
      });
    }
    

    function sendLaterDialog(ev) {
      $mdDialog.show({
        controller: 'SendLaterController',
        controllerAs: 'vm',
        templateUrl: 'app/main/apps/mailing/dialogs/send-later/send-later.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          date: vm.currentContent.scheduled_at
        }
      }).then(function (data) {
        if (data) {
          if (vm.currentContent.scheduled_at && !data.date) {
            vm.cancelSend();
            console.log ('cancel');

          } else if (data.date && !vm.currentContent.scheduled_at) {
            console.log(typeof data.date);
            vm.currentContent.scheduled_at = data.date;
            console.log(moment.utc(data.date));
            vm.saveContent(vm.currentContent, true);
            console.log ('save');

          } else if (data.date && (vm.currentContent.scheduled_at != data.date)) {
            vm.currentContent.scheduled_at = data.date;
            vm.reSchedule(vm.currentContent);
            console.log ('reschedule');
          }
        }
      });
    }

    function getDateFormat(date) {
     /*var IsLocalTime = sessionService.site_operative.timezone == 'UTC' ? false : true;
      var siteDate = IsLocalTime ? moment(date.now()) : moment(date.now()).utcOffset('0').tz("UTC");
      return siteDate.format('DD/MM/YYYY HH:mm');
    }*/
      var siteDate = moment.utc(date).tz(sessionService.site_operative.timezone);
      return siteDate.format(sessionService.site_operative.dateTimeFormat);
    };

    function deleteImage(id) {
      for (var i = 0; i < vm.currentContent.structure_data_json.length; i++) {
        if (vm.currentContent.structure_data_json[i].type === 'media') {
          if (vm.currentContent.structure_data_json[i].defaultValue) {
            for (var k = 0; k < vm.currentContent.structure_data_json[i].defaultValue.length; k++) {
              if (vm.currentContent.structure_data_json[i].defaultValue[k] === id) {
                vm.currentContent.structure_data_json[i].defaultValue.splice(k, 1);
              }
            }
            for (var k = 0; k < vm.currentContent.structure_data_json[i].mediaValue.length; k++) {
              if (vm.currentContent.structure_data_json[i].mediaValue[k].id_media === id) {
                vm.currentContent.structure_data_json[i].mediaValue.splice(k, 1);
              }
            }
          }
        }
      }
      vm.basicForm.$setDirty();
    }

    function mediaDialogSingle(ev, formItem) {
      formItem.Thumbnail = [];

      $mdDialog.show({
        controller: 'MediaDialogController',
        controllerAs: 'vm',
        locals: {
          autoUpload: '',
          currentThread: formItem,
          section: $scope.section,
          mediazone: 'single',
          multipleSelection: true,
          isTiny: false,
          maxAttach: undefined,
          showViews: {
            1: true,
            2: true,
            3: true,
            4: true,
            5: true,
            upload: true,
            import: true
          }
        },
        templateUrl: 'app/main/dialogs/media/media-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true

      }).then(function (formItem) {
        if (formItem.Thumbnail[0] && formItem.Thumbnail[0].id_media) {
          for (var i = 0; i < formItem.Thumbnail.length; i++) {
            vm.setImage(formItem, formItem.Thumbnail[i].id_media);
          }
        }

      });
    }

    function setImage(formItem, id) {

      var options = {
        domain: $scope.siteID,
        id_media: id
      };
      mediaService.getImageByID(options)
        .then(function (response) {
          for (var i = 0; i < vm.currentContent.structure_data_json.length; i++) {
            if (vm.currentContent.structure_data_json[i].type === 'media' && response.data[0]) {
              if (!vm.currentContent.structure_data_json[i].mediaValue) {
                vm.currentContent.structure_data_json[i].mediaValue = [];
                vm.currentContent.structure_data_json[i].defaultValue = [];
              }
              vm.currentContent.structure_data_json[i].mediaValue.push(response.data[0]);
              vm.currentContent.structure_data_json[i].defaultValue.push(id);
              delete vm.currentContent.structure_data_json[i].Thumbnail;
            }
          }
          vm.basicForm.$setDirty();
        });
    }

    function instantTranslate(text) {
      return $translate.instant(text);
    }


    // V2
    vm.previewTemplate = previewTemplate;
    vm.openPreview = openPreview;
    vm.showEdit = showEdit;
    vm.openExternalPreview = openExternalPreview;
    vm.openExternalPDF = openExternalPDF;

    function previewTemplate($event, template) {
      var templateArray = angular.fromJson(template.structure_mjml);
      $mdDialog.show({
        controller: 'HtmlPreviewController',
        controllerAs: 'vm',
        locals: {
          currentHtml: templateArray.html
        },
        templateUrl: 'app/main/plugins/html-preview/html-preview.html',
        parent: angular.element($document.body),
        targetEvent: $event,
        clickOutsideToClose: true
      }).then(function (item) {
        console.log('closed');
      });
    }

    function openPreview($event) {
      // console.log(vm.currentContent.structure_mjml.html);
      $mdDialog.show({
        controller: 'HtmlPreviewController',
        controllerAs: 'vm',
        locals: {
          currentHtml: vm.currentContent.structure_mjml.html
        },
        templateUrl: 'app/main/plugins/html-preview/html-preview.html',
        parent: angular.element($document.body),
        targetEvent: $event,
        clickOutsideToClose: true
      });
    }

    function openExternalPreview($event) {
      var options = {
        siteID: $scope.siteID,
        id: vm.currentContent.id_message
      };
      mailingService.getPreviewToken(options).then(function (response) {
        $window.open(vm.mailingPreviewUrl + response.token, 'mailingpreview');
      })
    }

    function openExternalPDF($event) {
      var options = {
        siteID: $scope.siteID,
        id: vm.currentContent.id_message
      };
      vm.loadingReadPane = true;
      mailingService.getPDFFile(options).then(function (response) {
        if (response.url) {
          $window.open(response.url, 'mailingpdf');
          vm.loadingReadPane = false;
        } else {
          $mdToast.show({
            template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg">' + $translate.instant('MAILING.PDF_ERROR') + '</div></md-toast>',
            hideDelay: 7000,
            position: 'top',
            parent: '#login-form-wrapper'
          });
          vm.loadingReadPane = false;
        }
      })

    }

    function showEdit($event) {
      $mdDialog.show({
        controller: 'TemplateBuilderController',
        controllerAs: 'vm',
        locals: {
          currentContent: vm.currentContent,
          currentEmail: vm.currentContent.structure_mjml,
          emailName: '',
          disabledElements: [],
          section: $scope.section,
          split: vm.splitContent,
          mailingToContent: false
        },
        templateUrl: 'app/main/plugins/template-builder/template-builder.html',
        parent: angular.element($document.body),
        targetEvent: $event,
        clickOutsideToClose: true,
        escapeToClose: false,
        multiple: true
      }).then(function (item) {
        if (item) {
          vm.currentContent.structure_mjml = item.email
          vm.currentContent.structure_mjml_temp = item.backup;
          if (!vm.currentContent.sent_at) {
            vm.saveContent();
          }
        }
        vm.basicForm.$setDirty();

      });
    }

    function uploadUsersAWS(callback){
      var options = {
        id: vm.currentContent.segment_group,
        siteID: $scope.siteID
      }
      usersService.getUsersGroup(options).then(function (response) {
        var users = response.users;
        
        var users2csv = 'ChannelType,Address\r\n';
        users.forEach(user => {
          users2csv += 'EMAIL,'+user.email+'\r\n';
        });

        mediaService.getS3UploadPreSignedUrl({
          siteID: $scope.siteID,
          fileName: vm.currentContent.id_message + '.csv'
        })
          .then(function (resp) {
            console.log(resp)
            Upload.http({
              url: resp.url,
              skipAuthorization: true,
              method: 'PUT',
              headers: {
                "Content-Type": 'text/csv'
              },
              data: users2csv
            }).then(function (response) {
              console.log(response.data)
              //              console.debug("SEND_TO_CROP______****", file)
              mediaService.finishedUploadingFileToCdn({
                siteID: $scope.siteID,
                idMedia: resp.id_media
              })
              callback(resp.id_media)
                
              //              console.debug("LOAD_MEDIA_FROM_DB______****", file)
            }, function (response) {
              if (response.status > 0)
                $scope.errorMsg = response.status + ': ' + response.data;
            });

          })
      });
    }

    function DialogController($scope, $mdDialog, items) {
      $scope.items = items;
      $scope.confirmSchedule = function () {
        //$mdDialog.scheduled_at = vm.currentContent.scheduled_at;
        $mdDialog.hide(true);
      };
      $scope.closeDialog = function () {
        $mdDialog.hide();
      }
      $scope.confirm = function () {
        $mdDialog.hide(true);
      }
    }

    function sendFull(execute, scheduled) {

      if (!scheduled) {
        var message1 = $translate.instant('MAILING.YOU_ARE_ABOUT_TO_SEND') + ' '
            var message3 = $translate.instant('MAILING.EMAILS_TO') + ' ';
            var message4 = vm.currentContent.mailing_template.subscription_group_object.name + ' ';
            var message5 = $translate.instant('MAILING.JUST_TO_KNOW');
            var message6 = $translate.instant('MAILING.THIS_LIST_HAS');
            var message7 = $translate.instant('MAILING.EMAILS_BUT');
            var message8 = vm.currentContent.mailing_template.subscription_group_object.totalUsers;
            var message9 = $translate.instant('MAILING.ARE_UNSUBSCRIBED');
            var message10 = $translate.instant('MAILING.ONLY');
            $mdDialog.show({
              template:
                '<md-dialog aria-label="List dialog">' +
                '  <md-dialog-content style="max-width: 500px;" class="m-25">' +
                "  <h2 class='bold'>{{'MAILING.READY_TO_SEND' | translate}}</h2>" +
                "  <h3>" + message1 + message3 + "<span class='bold'>" + message4 + "</span></h3>" +
                "  <p class='block mt-30 mb-0 grey-200-bg  ph-10 pv-10'><strong>" + message5 + "</strong><br>" + message6 + " " + vm.currentContent.mailing_template.subscription_group_object.totalUsers + " " + message7 + " " + message8 + " " + message9 +  + " " + message10 + "</p>" +
                '  </md-dialog-content>' +
                '  <md-dialog-actions class="pv-10">' +
                '    <md-button ng-click="closeDialog()" class="md-raised md-warn ">{{"MAILING.CANCEL" | translate }}</md-button>' +
                '    <md-button type="submit" ng-click="confirm()" class="ml-0 mb-20 send-button md-accent no-shadow md-raised md-rounded md-large" aria-label="MAILING.SEND" translate="" translate-attr-aria-label="MAILING.SEND_NOW" layout="row" layout-align="start center"><span><md-icon md-font-icon="icon-telegram" role="icon" aria-hidden="true"></md-icon><span translate="MAILING.SEND_NOW"></span></span></md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
              locals: {
                items: $scope.items
              },
              controller: DialogController
            }).then(function (res) {
              if (res) {
                vm.showLoader = true;
                setTimeout(() => {
                  mailingService.sendStatus({
                    site: $scope.siteID,
                    item: {
                      id_message: vm.currentContent.id_message,
                    }
                  }).then(function (response) {
                    console.log(response)
                    
                    vm.showLoader = false;
                    var message = $translate.instant('MAILING.SEND_STATUS')
          
                    $mdToast.show({
                      template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                      hideDelay: 5000,
                      position: 'top',
                      parent: '#content-container'
                    });
                    $rootScope.pagination_resetquery();
                    vm.basicForm = {};
                    vm.isSending = false;
                    vm.openContent(vm.currentContent.id_message, true);
                    deselectThreads();        
                  
                    mailingService.sendMassive({
                    site: $scope.siteID,
                    item: {
                      id_message: vm.currentContent.id_message,
                      segment_group: vm.currentContent.segment_group,
                      execute: false,
                      domain: $scope.siteID,
                    }
                  }).then(function (response) {
                    console.log(response)
                    vm.showLoader = false;
                    var message = $translate.instant('MAILING.SENT')
                    if (vm.currentContent.scheduled_at) {
                      message = $translate.instant('MAILING.SCHEDULE_SAVED')
                    }
                    $mdToast.show({
                      template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                      hideDelay: 5000,
                      position: 'top',
                      parent: '#content-container'
                    });
                    $rootScope.pagination_resetquery();
                    vm.basicForm = {};
                    vm.isSending = false;
                    vm.openContent(vm.currentContent.id_message);
                  
                  })
                
              }, 0);
            
            }, 0);

          }
        })
      } else {
        vm.showLoader = true;
        console.log({id_message: vm.currentContent.id_message,
          segment_group: vm.currentContent.segment_group,
          execute: false,
          scheduled_at: vm.currentContent.scheduled_at,
          domain: $scope.siteID})

        mailingService.sendStatus({
          site: $scope.siteID,
          item: {
            id_message: vm.currentContent.id_message,
          }
        }).then(function (response) {
          console.log(response)
          
          vm.showLoader = false;
          var message = $translate.instant('MAILING.SEND_STATUS')

          $mdToast.show({
            template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
            hideDelay: 5000,
            position: 'top',
            parent: '#content-container'
          });
          $rootScope.pagination_resetquery();
          vm.basicForm = {};
          vm.isSending = false;
          vm.openContent(vm.currentContent.id_message, true);
          deselectThreads();

          mailingService.sendMassiveAfter({
            site: $scope.siteID,
            item: {
              id_message: vm.currentContent.id_message,
              segment_group: vm.currentContent.segment_group,
              execute: false,
              scheduled_at: vm.currentContent.scheduled_at,
              domain: $scope.siteID,
            }
          }).then(function (response) {
            console.log(response)
            var message = $translate.instant('MAILING.SENT')
            if (vm.currentContent.scheduled_at) {
              message = $translate.instant('MAILING.SCHEDULE_SAVED')
            }
            $mdToast.show({
              template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
              hideDelay: 5000,
              position: 'top',
              parent: '#content-container'
            });
            $rootScope.pagination_resetquery();
            vm.basicForm = {};
            vm.isSending = false;
            vm.openContent(vm.currentContent.id_message, true);
            deselectThreads();
          
          })
        })

       
    }
    
  }

    function sendTest() {
      var message = $translate.instant('MAILING.SEND_MESSAGE_SEND_TEST');
      var messageConfirm = $translate.instant('MAILING.SEND_MESSAGE_SURE_SEND_TEST');
      var emailsCount = (vm.currentContent && vm.currentContent.test_emails_json ? vm.currentContent.test_emails_json.length : 0) + 
                        (vm.currentContent && vm.currentContent.mailing_template && vm.currentContent.mailing_template.test_emails_json ? vm.currentContent.mailing_template.test_emails_json.length : 0);
      var confirm = $mdDialog.confirm()
        .title(message + ' ' + (emailsCount) + ' e-mail(s), ' + messageConfirm)
        .ariaLabel('Send test')
        .ok('SEND')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        mailingService.sendTest({
          site: $scope.siteID,
          item: {
            id_message: vm.currentContent.id_message,
          }
        }).then(function (response) {
          $mdToast.show({
            template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + $translate.instant('MAILING.TEST_SENT') + '</span></div></md-toast>',
            hideDelay: 5000,
            position: 'top',
            parent: '#content-container'
          });
          $rootScope.pagination_resetquery();
          vm.basicForm = {};
        })
      });

    }


    function exportMailingLogByMailingContentId(idMailingContent) {
      var options = {
        siteID: $scope.siteID,
        idMailingContent: idMailingContent,
        format: 'csv'
      }
      mailingService.exportLogByMailingContentId(options).then(function (response) {
        window.open(response.url);
        $mdDialog.hide();
      }, function (error) {
        $mdToast.show({
          template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg">' + (error.data.detail.length > 0 ? error.data.detail : error.data.title) + '</div></md-toast>',
          hideDelay: 7000,
          position: 'top',
          parent: '#login-form-wrapper'
        });
      })
    }

    function isolateBounces(idMailingContent, bounceType) {
      if (!bounceType) {
        var messageConfirm = $translate.instant('MAILING.SURE_ISOLATE_ALL_BOUNCES');
        var ariaLabel = $translate.instant('MAILING.SURE_ISOLATE_ALL_BOUNCES');
      } else if (bounceType == 'permanent') {
        var messageConfirm = $translate.instant('MAILING.SURE_ISOLATE_HARD_BOUNCES');
        var ariaLabel = $translate.instant('MAILING.SURE_ISOLATE_HARD_BOUNCES');
      }

      var confirm = $mdDialog
        .confirm()
        .title(messageConfirm)
        .ariaLabel(ariaLabel)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        var options = {
          siteID: $scope.siteID,
          id: idMailingContent,
          section: 'massive-messages'
        };

        if (bounceType != null) {
          options['bounceType'] = bounceType;
        }
        mailingService.isolateBounces(options).then(function (response) {
          $mdToast.show({
            template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + $translate.instant('MAILING.BOUNCES_ISOLATED') + '</span></div></md-toast>',
            hideDelay: 5000,
            position: 'top',
            parent: '#content-container'
          });
        }, function (error) {
          $mdToast.show({
            template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg">' + (error.data.detail.length > 0 ? error.data.detail : error.data.title) + '</div></md-toast>',
            hideDelay: 7000,
            position: 'top',
            parent: '#login-form-wrapper'
          });
        });
      });
    }

    function changeMailingTemplate() {
      vm.templateSelected = false;
      vm.loadTemplates = true;
      vm.loadChannels = false;
      getTemplates();
    }

    $scope.$on('selectGroupFilter', function (event, data) {
      if (!vm.groupFiltered) {
        vm.groupFiltered = [];
      }
      if (!vm.groupFiltered.find(x => x == data)) {
        vm.groupFiltered.push(data);
      } else {
        vm.groupFiltered = vm.groupFiltered.filter(x => x !== data);
      }
    });
    $scope.$on('$destroy', function () {
      $timeout.cancel(vm.timeout);
    });

    function openGroupsDialog() {
      usersService.getUsersGroups({
        siteID: $scope.siteID,
        withGroupType: true
      }).then(function (response) {
        var qiuRestrictions = response.qiuRestrictions;
        var groups = response.data;
        $mdDialog.show({
          controller: 'GroupsController',
          controllerAs: 'vm',
          locals: {
            groups: groups,
          },
          templateUrl: 'app/main/apps/mailing/dialogs/groups/groups-view.html',
          parent: angular.element($document.body),
          targetEvent: 'ev',
          clickOutsideToClose: true,
        }).then(function (update) {
          if (update) {
            vm.activateFilter(true);
          }
        });
      });
    }
  }
})();

(function () {
  'use strict';

  $(window.document).on('contextmenu', '.list-media-item', function (e) {
    var menu = $('#context-menu');

    if (e.pageX >= window.innerWidth - menu.width()) {
      e.pageX -= menu.width();
    }
    if (e.pageY >= window.innerHeight - menu.height()) {
      e.pageY -= menu.height();
    }

    var posx = 0;
    var posy = 0;
    
    if (!e) {
      var e = window.event;
    }

    posx = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
    posy = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;

    menu.hide().css({
      left: e.pageX,
      top: e.pageY
      // left: posx,
      // top: posy
    }).show();

    e.preventDefault();
  });

  angular
    .module('app.mailing')
    .controller('MailingContentController', MailingContentController);


  /** @ngInject */
  function MailingContentController(
    $scope, $rootScope, $document, $mdDialog, $mdMenu, $mdMedia, $mdToast, $mdConstant,
    $mdSidenav, $state, requestContext, $timeout, mailingService, transformMailing, msUtils, $anchorScroll,
    $translate, sessionService, tinyMceService, $window, mediaService, backendService, contentService, sharedFunctionsMailing, contentFunctionsMailing, section,
    usersService, transformUsers, $q, $filter, $templateCache, templateBuilderConfig, $http, $log,
    mailingToContentService
  ) {
    /*
        Object.keys(templateBuilderConfig.blocks).forEach(function (key) {
          if (templateBuilderConfig.disableBlocks.indexOf(key) === -1) {
            $http.get('app/main/plugins/template-builder/fields/' + templateBuilderConfig.blocks[key].type + '.html').then(function(response) {
              $templateCache.put(templateBuilderConfig.blocks[key].type + 'Template', response.data);
            })
          }
        });
    */
    var vm = this;
    vm.templates = null;
    vm.templateSelected = false;
    vm.query = undefined;
    vm.loadTemplates = false;
    vm.isUpdateContent = false;
    vm.currentContent = undefined;
    vm.templateRelated = undefined;
    vm.selectedThreads = [];
    vm.usersGroups = undefined;
    vm.usersGroupsIds = undefined;
    vm.currentLabels = undefined;
    vm.nextPageLog = 1;
    $scope.section = section;

    $scope.array = [{
      active: true,
      value: 'Copy'
    }, {
      active: true,
      value: 'Cut'
    }, {
      active: false,
      value: 'Paste'
    }];

    vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg', 'red-bg', 'yellow-bg', 'light-blue-bg'];
    vm.testEmails = ['test@domain.com', 'other@testing.com', 'name@tester.com'];
    vm.sendExtraEmails = [];
    vm.sendGroups = ['Group 1', 'Group 2'];

    vm.selectedAccount = 'creapond';
    vm.selectedIndexTab = 0;

    vm.folders = [];
    vm.labels = [];
    vm.loadingThreads = true;
    vm.isLogsLoading = false;
    vm.enterfirst = true;
    vm.sendNow = true;
    vm.tags = null;
    vm.searchTagText = null;
    vm.selectedTag = null;
    vm.tinymceOptions = tinyMceService.getOptions($scope);
    vm.currentImages = [];

    vm.isOpenChecked = false;
    vm.isClickedChecked = false;
    vm.isBouncedChecked = false;
    vm.isRejectedChecked = false;
    vm.isComplainedChecked = false;
    vm.isSuppressedChecked = false;
    vm.isAllChecked = false;
    vm.isSending = false;
    vm.isUnsubscribedChecked = false;

    vm.activateFilter = activateFilter;
    vm.detailsTabActive = false;

    vm.typeFields = ['separator', 'relatedTable', 'textBox', 'media', 'htmlBox', 'colorPicker', 'checkbox', 'datePicker', 'group', 'lineSeparator', 'previewLink', 'social'];
    vm.keys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA];

    vm.scrollEl = angular.element('#thread-list')[0];

    vm.currentFilter = {
      type: $state.params.type,
      filter: $state.params.filter
    };
    vm.basicForm = {};
    vm.filters = {};
    vm.views = {
      nosplit: 'app/main/apps/mailing/views/content/list/nosplit-view.html',
      split: 'app/main/apps/mailing/views/content/list/split-view.html',
      grid: 'app/main/apps/mailing/views/content/grid/grid-view.html'
    };
    vm.defaultView = 'split';
    vm.currentView = 'split';
    vm.loadingView = true;
    vm.fieldOrder = 'created_at';
    vm.currentFilter = {
      type: $state.params.type,
      filter: $state.params.filter
    };

    vm.defaultContentView = 'content';
    vm.currentContentView = 'content';

    vm.defaultStatsView = 'bars';
    vm.currentStatsView = 'bars';

    vm.noexistchanges = true;
    vm.selectedContentSegmentGroups = [];
    vm.usersRef = null;

    vm.isAll = true;

    vm.mailingToContent = [];
    // Opt-in por tenant del convert unificado (mailToContent.unified en qiu_config).
    vm.mailingToContentUnified = false;

    // Methods
    vm.init = init;
    vm.getInArray = msUtils.getInArray;
    vm.toggleInArray = msUtils.toggleInArray;
    vm.toggleInGroup = msUtils.toggleInGroup;
    vm.getReferencesSections = mailingService.getReferencesSections;
    vm.getExtension = msUtils.getExtension;
    vm.getExtensionIcon = msUtils.getExtensionIcon;
    vm.timeAgo = msUtils.timeAgo;
    vm.getValuesReferencesSections = mailingService.getValuesReferencesSections;
    vm.getLogs = getLogs;
    vm.getLogsByFilter = getLogsByFilter;
    vm.checkAndReload = checkAndReload;
    vm.getLogsByUser = getLogsByUser;

    vm.newContent = newContent;
    vm.openTemplate = openTemplate;
    vm.closeTemplate = closeTemplate;
    vm.clearTemplateSelected = clearTemplateSelected;
    vm.disableTemplates = disableTemplates;
    vm.selectUser = selectUser;
    vm.closeUser = closeUser;
    vm.saveContent = saveContent;
    vm.openContent = openContent;
    vm.closeContent = closeContent;
    vm.deleteContent = deleteContent;
    vm.setSortField = setSortField;
    vm.setSortOrder = setSortOrder;
    vm.changeView = changeView;
    vm.viewPreview = viewPreview;
    vm.openContentView = openContentView;
    vm.openStatsView = openStatsView;
    vm.sendFull = sendFull;
    vm.sendTest = sendTest;
    vm.getDateFormat = getDateFormat;

    vm.toggleSidenav = toggleSidenav;
    vm.selectOrUnselect = selectOrUnselect;
    vm.setTinyMceContent = setTinyMceContent;

    vm.isSent = isSent;

    vm.groupDialog = groupDialog;
    vm.groupDialogNew = groupDialogNew;
    vm.usersInGroupDialog = usersInGroupDialog;
    vm.openMenu = openMenu;

    vm.initDate = initDate;

    vm.onTabSelected = onTabSelected;

    vm.openImageDialog = openImageDialog;
    vm.sendLaterDialog = sendLaterDialog;
    vm.cancelSend = cancelSend;
    vm.reSchedule = reSchedule;
    vm.deleteImage = deleteImage;
    vm.setImage = setImage;
    vm.mediaDialogSingle = mediaDialogSingle;

    vm.toggleSelectThread = toggleSelectThread;
    vm.toggleSelectThreads = toggleSelectThreads;
    vm.isSelected = isSelected;
    vm.deselectThreads = deselectThreads;
    vm.duplicateContent = duplicateContent;
    vm.openUsersGroupsDialog = openUsersGroupsDialog;
    vm.deleteTarget = deleteTarget;

    vm.getFirstTextBox = getFirstTextBox;

    vm.translate = instantTranslate;
    vm.segmentGroupDialogNew = segmentGroupDialogNew;
    vm.changeGroupSubscriptionDialog = changeGroupSubscriptionDialog;
    vm.exportMailingLogByMailingContentId = exportMailingLogByMailingContentId;

    vm.isolateBounces = isolateBounces;
    vm.changeMailingTemplate = changeMailingTemplate;
    vm.openGroupsDialog = openGroupsDialog;
    vm.mailingPreviewUrl = sessionService.site_operative.mailingPreviewUrl;
    vm.searchString = '';

    vm.filterName = 'All';

    vm.templateToCases = templateToCases;
    // Convert unificado (canónico), separado del clásico.
    vm.templateToContentUnified = templateToContentUnified;

    //////////

    init();

    /**
     * Initialize
     */
    function init() {
      var siteID = requestContext.getParam("siteId");
      $scope.modalShown = false;
      $scope.siteID = siteID;

      vm.isAdmin = sessionService.user.is_admin; //vm.splitContent and vm.isAdmin need to works equal

      $rootScope.global.titleToolbar = '<i class="icon s20 icon-telegram mr-15" ng-if="node.icon"></i><span class="hide show-gt-xs">MAILING</span><i class="mr-5 ml-5 icon s18 icon-chevron-right hide show-gt-xs"></i> ' + section;

      $scope.page = 1;
      if ($state.params.id) {
        vm.openContent($state.params.id);
      }

      sessionService.loadDomainResourceSettings($scope.siteID).then(function (response){
        if(response.public){
          var publicConfig = angular.fromJson(response.public);
          if(publicConfig.mailToContent){
            vm.mailingToContent = publicConfig.mailToContent.sections;
            // El convert unificado (canónico) es opt-in por tenant: solo se muestra
            // donde se active con mailToContent.unified = true. Así el resto de
            // tenants siguen viendo únicamente el convert clásico.
            vm.mailingToContentUnified = publicConfig.mailToContent.unified === true;
          }
        }
        vm.splitContent = response.mailingHeaderContentSplitOption;
      });

    }

    /**
     * Multiple comma separated chips to add
     */

     function templateToCases() {
      backendService.getSections({
        siteID: $scope.siteID
      }).then(function(response){
        let sections = [];
        angular.forEach(vm.mailingToContent, function(section) {
          let sectionToPush = response.data.find(x => x.section == section.name);
          sectionToPush.raw_settings = section.raw_settings;
          sectionToPush.header = section.header;
          sectionToPush.footer = section.footer;
          sectionToPush.label = section.label;
          sections.push(sectionToPush);
        });
        $mdDialog.show({
          controller: 'SelectSectionMailToCases',
          controllerAs: 'vm',
          locals: {
            sections: sections
          },
          templateUrl: 'app/main/apps/mailing/dialogs/select-section/select-section.html',
          parent: angular.element($document.body),
          clickOutsideToClose: true
        }).then(function(section){
          if(section){
            vm.isSaving = true;
            let newContent = {
              "Thumbnail": [],
              "multiple_texts": []
            }
            for(let k in section.raw_settings){
              if(k == 'lang' && !vm.currentContent[section.raw_settings[k]]){
                newContent[k] = 1;
              }else{
                newContent[k] = vm.currentContent[section.raw_settings[k]];
              }
            }
            backendService.getSectionRef({
              domain: $scope.siteID,
              section: section.section
            }).then(function (response){
              let zones = response.filter(x => x.type == 'zone');
              let multipleTexts = angular.fromJson(response.find(x => x.field_name == 'multiple_texts').raw_settings);
              let mailingTemplates = multipleTexts.ref.find(x => x.name == 'mailing-templates').options;
              multipleTexts = multipleTexts.ref.find(x => x.name == 'template').options;
              let elements = [];
              if(section.header && vm.currentContent.structure_mjml.header){
                elements = elements.concat(vm.currentContent.structure_mjml.header.elements);
              }
              elements = elements.concat(vm.currentContent.structure_mjml.elements);
              if(section.footer && vm.currentContent.structure_mjml.footer){
                elements = elements.concat(vm.currentContent.structure_mjml.footer.elements);
              }
              var itemsForZones = [];
              for(let i=0; i<elements.length; i++){
                let element = elements[i];
                if(element.options.exportMedia && !angular.isArray(element.options.exportMedia)){
                  for(let option in element.options){
                    if(option.indexOf('imageSingle') != -1){
                      for(let exportMedia in element.options.exportMedia){
                        if(exportMedia == section.label){
                          for(let zoneToExport in element.options.exportMedia[exportMedia]){
                            let zone = zones.find(x => x.title == zoneToExport);
                            // element.options[option]
                            let item = {
                              id_mediaFile: element.options[option].id_media,
                              id_service: 2,
                              id_section: section.id_section,
                              id_from_section: "",
                              id_zone: zone.id_zone
                            }
                            itemsForZones.push(item);
                          }
                        }
                      }
                    }
                  }
                }
                let multipleID = mailingTemplates.find(x => x.type == element.type);
                if(multipleID && element.options.exportable){
                    if(angular.isArray(multipleID.template)){
                      var template = [];
                      if(!multipleID.width){
                        var size = (100 / multipleID.template.length).toFixed();
                      }else{
                        var size = multipleID.width;
                      }
                      for(var k=0; k<multipleID.template.length; k++){
                        let templateToPush = multipleTexts.find(x => x.value.id == multipleID.template[k]).value;
                        template.push(templateToPush);
                      }
                      for(var l=0; l<template.length; l++){
                        var contentMultipleTexts = {};
                        contentMultipleTexts.size = size;
                        contentMultipleTexts.template = template[l];
                        var values = multipleID.values[l+1];
                        for(let m=0; m<values.length; m++){
                          if(typeof values[m].from == 'object' && typeof values[m].to == 'object'){
                            contentMultipleTexts[values[m].to.name] = [{}];
                            for(var n=0; n<values[m].from.values.length; n++){
                              contentMultipleTexts[values[m].to.name][0][values[m].to.values[n]] = element.options[values[m].from.name][values[m].from.values[n]];
                            }
                            // Arrastra la caption del mail (imageSingleN.fields.caption) al media del bloque -> lo pinta el figcaption
                            if(values[m].to.name === 'media' && element.options[values[m].from.name] && element.options[values[m].from.name].fields && element.options[values[m].from.name].fields.caption){
                              contentMultipleTexts[values[m].to.name][0].caption = element.options[values[m].from.name].fields.caption;
                            }
                          }else if((!typeof values[m].from == 'object' && typeof values[m].to == 'object') || (typeof values[m].from == 'object' && !typeof values[m].to == 'object')){
                            return;
                          }else{
                            contentMultipleTexts[values[m].to] = element.options[values[m].from];
                          }
                        }
                        newContent.multiple_texts.push(contentMultipleTexts);
                      }
                    }else{
                      var contentMultipleTexts = {};
                      var values = multipleID.values;
                      if(!values){
                        values = element.options;
                        for(let key in values){
                          contentMultipleTexts[key] = element.options[key];
                        }
                      }else{
                        for(let k=0; k<values.length; k++){
                          if(typeof values[k].from == 'object' && typeof values[k].to == 'object'){
                            let key = values[k].to.name;
                            if (!(key in contentMultipleTexts)) {
                                contentMultipleTexts[key] = [{}];
                            }
                            for(var l=0; l<values[k].from.values.length; l++){
                              contentMultipleTexts[values[k].to.name][0][values[k].to.values[l]] = element.options[values[k].from.name][values[k].from.values[l]];
                            }
                            // Arrastra la caption del mail (imageSingleN.fields.caption) al media del bloque -> lo pinta el figcaption
                            if(values[k].to.name === 'media' && element.options[values[k].from.name] && element.options[values[k].from.name].fields && element.options[values[k].from.name].fields.caption){
                              contentMultipleTexts[values[k].to.name][0].caption = element.options[values[k].from.name].fields.caption;
                            }
                          }else if((!typeof values[k].from == 'object' && typeof values[k].to == 'object') || (typeof values[k].from == 'object' && !typeof values[k].to == 'object')){
                            return;
                          }else{
                            contentMultipleTexts[values[k].to] = element.options[values[k].from];
                          }
                        }
                      }
                      if(!multipleID.width){
                        var size = 100;
                      }else{
                        var size = multipleID.width;
                      }
                      var template = multipleTexts.find(x => x.value.id == multipleID.template);
                      if(template){
                        template = template.value;
                        contentMultipleTexts.size = size;
                        contentMultipleTexts.template = template;
                        newContent.multiple_texts.push(contentMultipleTexts);
                      }
                    }
                }
              }
              if(itemsForZones.length === 0 && zones.length > 0){
                for(let i=0; i<elements.length; i++){
                  let firstImageKey = Object.keys(elements[i].options).find(k => k.indexOf('imageSingle') !== -1);
                  if(firstImageKey && elements[i].options[firstImageKey] && elements[i].options[firstImageKey].id_media){
                    itemsForZones.push({
                      id_mediaFile: elements[i].options[firstImageKey].id_media,
                      id_service: 2,
                      id_section: section.id_section,
                      id_from_section: "",
                      id_zone: zones[0].id_zone
                    });
                    break;
                  }
                }
              }
              // multiple_texts se serializa tras la revisión (el editor necesita el array).
              var optionsNewContent = {
                site: $scope.siteID,
                section: section.section,
                id: "new",
                item: newContent
              }
              if(itemsForZones.length > 0){
                var id_medias = [];
                angular.forEach(itemsForZones, function(item){
                  id_medias.push(item.id_mediaFile);
                });
                var options = {
                  siteID: $scope.siteID,
                  section: $scope.section,
                  resultsPerPage: 100,
                  filtersGroup: [
                    {
                      field: "id_media",
                      name: "id_media",
                      selected: id_medias
                    }
                  ]
                };
                mediaService.get(options).then(function(response){
                  angular.forEach(itemsForZones, function(media){
                    var thumb = response.data.find(x => x.id_media == media.id_mediaFile);
                    if(thumb){
                      var newThumb = angular.copy(thumb); // <-- CLONE
                      newThumb.id_zone = media.id_zone;
                      optionsNewContent.item.Thumbnail.push(newThumb);
                    }else{
                      $log.warn(`Media with ID#${media.id_mediaFile} error. Not found`);
                    }
                  });
                  reviewAndSaveContent(optionsNewContent, section);
                });
              }else{
                reviewAndSaveContent(optionsNewContent, section);
              }
            });
          }
        });
      });
    }

    /**
     * CONVERT UNIFICADO (canónico) — independiente de templateToCases().
     *
     * No usa el bloque `mailing-templates` del _ref de la sección (config por tenant
     * con template.id propios), sino el mapeo en código `mailingToContentMap`, común a
     * todos los tenants. El multiple_texts resultante es portable: cada bloque lleva
     * su `type` canónico en vez de un id de plantilla del tenant.
     *
     * Requiere que qiupreview tenga el render dual (type canónico + legacy template.id).
     */
    function templateToContentUnified() {
      backendService.getSections({
        siteID: $scope.siteID
      }).then(function (response) {
        var sections = [];
        angular.forEach(vm.mailingToContent, function (section) {
          var sectionToPush = response.data.find(x => x.section == section.name);
          if (!sectionToPush) {
            return;
          }
          sectionToPush.raw_settings = section.raw_settings;
          sectionToPush.header = section.header;
          sectionToPush.footer = section.footer;
          sectionToPush.label = section.label;
          sections.push(sectionToPush);
        });

        $mdDialog.show({
          controller: 'SelectSectionMailToCases',
          controllerAs: 'vm',
          locals: { sections: sections },
          templateUrl: 'app/main/apps/mailing/dialogs/select-section/select-section.html',
          parent: angular.element($document.body),
          clickOutsideToClose: true
        }).then(function (section) {
          if (!section) {
            return;
          }
          vm.isSaving = true;

          // Cabecera: mismo mapeo por raw_settings que el convert clásico.
          var newContent = mailingToContentService.buildHeaderFields(vm.currentContent, section);
          newContent.Thumbnail = [];

          var elements = mailingToContentService.collectElements(vm.currentContent, section);
          // Bloques canónicos: sin depender de la config del tenant.
          newContent.multiple_texts = mailingToContentService.buildBlocks(elements);

          var optionsNewContent = {
            site: $scope.siteID,
            section: section.section,
            id: "new",
            item: newContent
          };

          // Las zonas sí siguen dependiendo del _ref de la sección (son suyas).
          backendService.getSectionRef({
            domain: $scope.siteID,
            section: section.section
          }).then(function (refResponse) {
            var zones = (refResponse || []).filter(x => x.type == 'zone');
            var zoneItems = mailingToContentService.collectZoneItems(elements, section, zones);

            if (!zoneItems.length) {
              reviewAndSaveContent(optionsNewContent, section);
              return;
            }

            var idMedias = zoneItems.map(function (item) { return item.id_mediaFile; });
            mediaService.get({
              siteID: $scope.siteID,
              section: $scope.section,
              resultsPerPage: 100,
              filtersGroup: [{ field: "id_media", name: "id_media", selected: idMedias }]
            }).then(function (mediaResponse) {
              angular.forEach(zoneItems, function (item) {
                var thumb = mediaResponse.data.find(x => x.id_media == item.id_mediaFile);
                if (!thumb) {
                  $log.warn(`Media with ID#${item.id_mediaFile} error. Not found`);
                  return;
                }
                var newThumb = angular.copy(thumb);
                newThumb.id_zone = item.id_zone;
                optionsNewContent.item.Thumbnail.push(newThumb);
              });
              reviewAndSaveContent(optionsNewContent, section);
            });
          }, function () {
            // Sin _ref no hay zonas: se puede convertir igual.
            reviewAndSaveContent(optionsNewContent, section);
          });
        });
      });
    }

    /**
     * Paso de revisión previo a crear el content: abre el editor con el resultado ya
     * mapeado (cabecera + bloques + imágenes) y solo guarda si se confirma.
     *
     * Es OPT-IN por tenant (mailToContent.unified): sin el flag se mantiene el
     * comportamiento clásico de siempre —crear el content directamente, sin modal—
     * para no cambiarle el flujo a los tenants que ya lo usan en producción.
     */
    function reviewAndSaveContent(optionsNewContent, section) {
      if (!vm.mailingToContentUnified) {
        saveConvertedContent(optionsNewContent);
        return;
      }

      // Paramos el spinner mientras se revisa; se reanuda al confirmar.
      vm.isSaving = false;

      $mdDialog.show({
        controller: 'MailingToContentReviewController',
        controllerAs: 'vm',
        locals: {
          content: optionsNewContent.item,
          section: section
        },
        templateUrl: 'app/main/apps/mailing/dialogs/review-content/review-content.html',
        parent: angular.element($document.body),
        clickOutsideToClose: false
      }).then(function (reviewedContent) {
        if (!reviewedContent) {
          return; // cancelado: no se crea nada
        }
        vm.isSaving = true;
        optionsNewContent.item = reviewedContent;
        saveConvertedContent(optionsNewContent);
      }, function () {
        // Diálogo descartado: no se crea nada.
      });
    }

    /** Crea el content. multiple_texts viaja serializado como JSON. */
    function saveConvertedContent(optionsNewContent) {
      optionsNewContent.item.multiple_texts = JSON.stringify(optionsNewContent.item.multiple_texts || []);
      contentService.saveItem(optionsNewContent).then(function (response) {
        vm.isSaving = false;
      }, function () {
        vm.isSaving = false;
      });
    }

    $scope.addChips = function (chips, model) {
      if(chips && chips.indexOf(';')){
        var chipsArray = chips.split(';');
      }else{
        var chipsArray = chips.split(',');
      }
      angular.forEach(chipsArray, function (chip) {
        model.push(chip);
      });
      return null;
    };
    /**
     * Validate emails in Chips
     */
    $scope.validateEmail = function (emails) {
      for (var i = 0; i < emails.length; i++) {
        emails[i] = emails[i].toLowerCase();
        var reg = /^(([^<>()\[\]\\.,;:\s@\"]+(\.[^<>()\[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!reg.test(emails[i])) {
          this.invalidEmail = true;
          // remove last invalid email address :)
          emails.splice(i, 1);
        }
        else {
          this.invalidEmail = false;
          vm.testEmailsChanged = true;
        }
      }
    }

    // Watch screen size to change view modes
    $scope.$watch(function () {
      return $mdMedia('lt-sm');
    }, function (current, old) {
      if (angular.equals(current, old)) {
        return;
      }

      if (current) {
        vm.currentView = 'nosplit';
      }
    });

    $scope.$watch(function () {
      return $mdMedia('max-width: 960px');
    }, function (big) {

      if (big) {
        vm.currentView = 'nosplit';
        vm.chartWidth = 600;
        vm.donutSm = 100;
        vm.donutLg = 120;
      }

    });

    $scope.$watch(function () {
      return $mdMedia('min-width: 960px');
    }, function (small) {

      if (small) {
        vm.currentView = 'split';
        vm.chartWidth = 700;
        vm.chartWidthColumn = 350;
        vm.donutSm = 120;
        vm.donutLg = 150;
      }


    });
    $scope.$watch(function () {
      return $mdMedia('min-width: 1280px');
    }, function (small) {

      if (small) {
        vm.chartWidthColumn = 350;

      }


    });
    $scope.$watch(function () {
      return $mdMedia('min-width: 1441px');
    }, function (small) {

      if (small) {
        vm.chartWidthColumn = 450;

      }


    });
    $scope.$watch(function () {
      return $mdMedia('width: 1024px');
    }, function (big) {

      if (big) {
        vm.chartWidth = 500;
        vm.chartWidthColumn = 240;
      }

    });

    $scope.$watch(function () {
      return $mdMedia('max-width: 767px');
    }, function (big) {

      if (big) {
        vm.chartWidth = 350;
        vm.chartWidthColumn = 350;
        vm.donutSm = 85;
        vm.donutLg = 100;

      }

    });

    $scope.$watch(function () {
      return $mdMedia('gt-sm');
    }, function (current, old) {
      if (angular.equals(current, old)) {
        return;
      }

      if (current) {
        if (vm.defaultView === 'split') {
          vm.currentView = 'split';
        }
      }
    });


    $scope.$watch('vm.filters', function () {
      vm.loadingReadPane = false;
    }, true);

    $scope.$on('$includeContentLoaded', function (event, target) {
      $timeout(function () {
        vm.loadingView = false;
      }, 1000);
    });

    $scope.$on('pagination:loadStart', function (event) {
      // $anchorScroll();

      // Store the current scrollPos
      // vm.scrollPos = vm.scrollEl.scrollTop();

      // Scroll to the top
      // vm.scrollEl.scrollTop(0);
      if (!vm.enterfirst) {
        var elem = angular.element(document.getElementById('thread-list'));
        elem.scrollTopAnimated(0, 10);
      }

      // angular.element("#thread-list").scrollTop=0;

      vm.enterfirst = false;

      $scope.isLoading = true;
    });

    $scope.$on('pagination:loadPage', function (event) {
      $scope.isLoading = false;
      vm.dataAlreadyLoaded = true;
      $timeout(() => {
        $timeout.cancel(vm.timeout);
        vm.checkAndReload();
      }, 1000);
    });

    $scope.title = "Angularjs Bootstrap Modal Directive Example";
    $scope.showModal1 = false;
    $scope.showModal2 = false;

    $scope.hide = function (m) {
      if (m === 1) {
        $scope.showModal1 = false;
      }
      else {
        $scope.showModal2 = false;
      }
    }

    $scope.modalOneShown = function () {
      console.log('model one shown');
    }

    $scope.modalOneHide = function () {
      console.log('model one hidden');
    }

    function isPendingToSend(x) {
      return x.id_mailing_status == 2 || x.id_mailing_status == 3 || x.id_mailing_status == 4
    }

    function checkAndReload() {
      if (vm.contents.filter(isPendingToSend).length > 0) {
        vm.timeout = $timeout(() => {
          var options = {
            siteID: $scope.siteID,
            section: 'content',
            page: $rootScope.pagination_current_page,
            resultsPerPage: $rootScope.perPage,
            sortDir: $rootScope.sortDir
          };
          mailingService.get(options).then(function (response) {
            vm.contents = vm.contents.map(x => {
              if (isPendingToSend(x)) {
                return response.data.find(y => y.id_mailing_content === x.id_mailing_content);
              }
              return x;
            })
            if (vm.contents.filter(isPendingToSend).length > 0) {
              vm.checkAndReload();
            }
          })
        }, 5000);
      }

    }


    function isSent(content) {
      var now = moment().utc()
      if (content.id_mailing_status < 5) {
        return false;
      } else {
        return true;
      }
    }

    function toggleSelectThread(thread, event) {
      vm.selectedThreads = sharedFunctionsMailing.toggleSelectThread(vm.selectedThreads, thread, event);
    }

    function isSelected(thread) {
      return sharedFunctionsMailing.isSelected(vm.selectedThreads, thread);
    }

    function resetAllFilter() {
      vm.isAll = false;
      vm.isOpenChecked = false;
      vm.isClickedChecked = false;
      vm.isBouncedChecked = false;
      vm.isRejectedChecked = false;
      vm.isComplainedChecked = false;
      vm.isSuppressedChecked = false;
      vm.isUnsubscribedChecked = false;
    };

    function search() {

    }

    function activateFilter(resetpage) {
      if (resetpage) {
        vm.nextPageLog = 1;
      }
      vm.getLogsByFilter(vm.currentContent.id_mailing_content, vm.nextPageLog, vm.filter, vm.searchString, vm.groupFiltered);
    }

    function setTinyMceContent(event) {
      var zoneMedia = {
        1: {},
        2: {},
        3: {},
        4: {}
      };
      var typesMax = {
        1: 0,
        2: 0,
        3: 0,
        4: 0
      };
      var currentSort = 0;
      var currentType = 0;

      return zoneMedia;
    }

    function onTabSelected(tab) {
      vm.tabSelected = tab;
    }

    var originatorEv;

    function openMenu($mdMenu, ev) {
      originatorEv = ev;
      $mdMenu.open(ev);
    }

    function deleteContent() {
      vm.loadingReadPane = true;
      if (vm.selectedThreads.length == 1) {
          var messageConfirm = $translate.instant('CONTENT.SURE_DELETED_SINGULAR');
          var contentConfirm = $translate.instant('CONTENT.WILL_DELETE_ITEM');
          var message = $translate.instant('CONTENT.DELETED');
      }
      else {
          var messageConfirm = $translate.instant('CONTENT.SURE_DELETED_PLURAL');
          var contentConfirm = $translate.instant('CONTENT.WILL_DELETE_ITEMS');
          var message = $translate.instant('CONTENT.DELETED');
      }
       var confirm = $mdDialog.confirm()
         .title(messageConfirm)
         .htmlContent('<b>'+ contentConfirm +'</b>.')
         .ariaLabel('Delete item')
         .ok('OK')
         .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        for (var i = 0; i < vm.selectedThreads.length; i++) {
          var options = {
            site: $scope.siteID,
            section: 'content',
            id: vm.selectedThreads[i].id_mailing_content
          };
          mailingService.deleteThread(options).then(function (response) {
            $rootScope.pagination_resetquery();
            vm.loadingReadPane = false;
            vm.clearTemplateSelected();
            sharedFunctionsMailing.toggleSelectThread(vm.selectedThreads, vm.selectedThreads[i])
            deselectThreads();
          });
      }}, function (){
        vm.loadingReadPane = false;
      })
    }


    function deselectThreads() {
      vm.selectedThreads = sharedFunctionsMailing.deselectThreads();
    }

    function newContent() {
      vm.loadingReadPane = true;
      vm.closeContent();

      if (angular.element(document.getElementById('thread-detail')).length) {
        var elem = angular.element(document.getElementById('thread-detail'));
        elem.scrollTopAnimated(0, 10);
      }

      $state.go('app.site_overview.mailing.content.list.templates', {
        id: vm.selectedContentID
      }, {
        notify: false,
        inherit: true,
        location: true
      });

      vm.currentContent = {
        id_mailing_content: '',
        id_mailing_status: 1,
        structure_mjml: {},
        template: {},
        subject: '',
        test_emails_json: {}
      }
      getTemplates();
    }


    function getTemplates() {
      var options = {
        page: 1,
        resultsPerPage: 350,
        section: "templates",
        siteID: $scope.siteID,
        sortDir: "ASC"
      }

      mailingService.get(options).then(function (response) {
        vm.templates = response.data;
        vm.loadingReadPane = false;
        vm.loadTemplates = true;
      });
    }

    function duplicateContent() {
      for (var i = 0; i < vm.selectedThreads.length; i++) {
        var options = {
          id: vm.selectedThreads[i].id_mailing_content,
          section: "content",
          site: $scope.siteID
        }
        mailingService.getByID(options).then(function (response) {
          if(!response.mailing_template){
            console.log('response', response);
            var message = $translate.instant('MAILING.NOT_MAILING_TEMPLATE_ERROR');
            $mdToast.show({
              template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
              hideDelay: 7000,
              position: 'top',
              parent: '#content-container'
            });
            return;
          }
          if(vm.selectedThreads.length > 1 || !vm.splitContent){
            vm.saveContent(transformMailing.formatDuplicateContent(response));
          }else{
            response.structure_mjml = angular.fromJson(response.structure_mjml);
            var mail = response;
            var options = {
              page: 1,
              resultsPerPage: 100,
              section: "templates",
              siteID: $scope.siteID,
              sortDir: "ASC"
            }
            mailingService.get(options).then(function (response) {
              $mdDialog.show({
                controller: 'SelectDuplicateTemplateController',
                controllerAs: 'vm',
                locals: {
                  templates: response.data,
                  currentContent: mail
                },
                templateUrl: 'app/main/apps/mailing/dialogs/select-duplicate-template/select-duplicate-template.html',
                parent: angular.element($document.body),
                clickOutsideToClose: true
              }).then(function (template) {
                if(template && template != mail.id_mailing_template){
                  let templateStructure = angular.fromJson(response.data.find(x => x.id_mailing_templates == template).structure_mjml);
                  templateStructure.elements = mail.structure_mjml.elements;
                  let newMail = {
                    id_mailing_content: '',
                    subject: mail.subject + ' COPY (#' + template + ')',
                    id_mailing_template: template,
                    structure_mjml: templateStructure,
                    test_emails_json: angular.fromJson(mail.test_emails_json)
                  }
                  vm.saveContent(newMail);
                }else if(template && template == mail.id_mailing_template){
                  var options = {
                    id: mail.id_mailing_content,
                    section: "content",
                    site: $scope.siteID
                  }
                  mailingService.getByID(options).then(function (response) {
                    vm.saveContent(transformMailing.formatDuplicateContent(response));
                  })
                }
              });
            });
          }
        });
      }
    }

    function openUsersGroupsDialog() {
      $mdDialog.show({
        controller: 'UsersGroupController',
        controllerAs: 'vm',
        locals: {
          usersGroups: angular.copy(vm.usersGroups),
          selectedGroups: angular.copy(vm.currentContent.users_groups_json),
          isTiny: false
        },
        templateUrl: 'app/main/dialogs/users-group/users-group-view.html',
        parent: angular.element($document.body),
        targetEvent: 'ev',
        clickOutsideToClose: true,

      }).then(function (object) {
        if (object) {
          vm.currentContent.users_groups_json = sharedFunctionsMailing.updateUsersGroups(object.usersGroups);
          vm.currentLabels = object.labels;
          vm.basicForm.$setDirty();
        }
      });
    }

    function deleteTarget(id, index) { // TODO(Refactorizar)
      var index_user_group = vm.currentContent.users_groups_json.indexOf(id);
      if (index_user_group > -1) {
        vm.currentContent.users_groups_json.splice(index_user_group, 1);
      }
      vm.currentLabels.splice(index, 1);
      vm.basicForm.$setDirty();
    }

    function getCurrentLabels() {
      var usersGroupsAux = sharedFunctionsMailing.initUsersGroup(angular.copy(vm.usersGroups), angular.copy(vm.currentContent.users_groups_json));
      vm.currentLabels = sharedFunctionsMailing.getLabels(usersGroupsAux);
    }


    function groupDialog(structure_group, index, group) {
      $mdDialog.show({
        controller: 'GroupMailingController',
        controllerAs: 'vm',
        locals: {
          items: angular.copy(group),
          modeView: 'editing',
          section: $scope.section,
          isTiny: false
        },
        templateUrl: 'app/main/apps/mailing/dialogs/group/group-mailing.html',
        parent: angular.element($document.body),
        targetEvent: 'ev',
        clickOutsideToClose: true,

      }).then(function (result) {
        if (result) {
          structure_group.groups[index] = result;
        }
        vm.basicForm.$setDirty();
      });
    }

    function groupDialogNew(structure_group, items) {
      $mdDialog.show({
        controller: 'GroupMailingController',
        controllerAs: 'vm',
        locals: {
          items: angular.copy(items),
          modeView: 'editing',
          section: $scope.section,
          isTiny: false
        },
        templateUrl: 'app/main/apps/mailing/dialogs/group/group-mailing.html',
        parent: angular.element($document.body),
        targetEvent: 'ev',
        clickOutsideToClose: true,

      }).then(function (result) {
        if (result) {
          if (!structure_group.groups) {
            structure_group.groups = [];
          }
          structure_group.groups.push(result);
        }
        vm.basicForm.$setDirty();
      });
    }

    function changeGroupSubscriptionDialog(ev) {
      $mdDialog.show({
        controller: 'SelectGroupDialogController',
        controllerAs: 'vm',
        locals: {
          siteID: $scope.siteID,
          sourceGroups: [vm.selectedGroup]
        },
        templateUrl: 'app/main/apps/mailing/dialogs/select-group-dialog/select-group-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true
      }).then(function (result) {
        if (result) {
          vm.currentContent.mailing_template.subscription_group_object = result;
          vm.loadingDefaultSubscriptionGroup = false;
          vm.currentContent.segment_group = result.id_group;
          var options = {
            siteID: $scope.siteID,
            section: $scope.section,
            groupIds: [result.id_group],
          };
          vm.loadingUsersCount = true;
          usersService.getUsersByGroupsCount(options).then(function (response2) {
            vm.loadingUsersCount = false;
            vm.currentContent.mailing_template.subscription_group_object.totalUsers = response2.result.total;
          });
        }else{
          vm.loadingDefaultSubscriptionGroup = false;
        }
      });
    }


    function segmentGroupDialogNew($event) {
      var promiseList = [];
      promiseList.push(usersService.getUsersGroups({
        siteID: $scope.siteID,
        //groupType: 2, // Subscription
        withGroupType: true
      })
      );
      promiseList.push(usersService.getUsersGroupsTypes({ siteID: $scope.siteID }));

      $q.all(promiseList).then(function (response) {
        var cleanUsersGroups = response[0].data; //transformUsers.formatNestedGroups(response[0]);
        var usersGroupsTypes = response[1]; //$filter('filter')(response[1], {'id_group_type': 2}, true);
        openSegmentGroupDialogNew(cleanUsersGroups, usersGroupsTypes);
      }).catch(function (error) {
        console.log(error);
      });
    }

    function openSegmentGroupDialogNew(cleanUsersGroups, usersGroupsTypes) {
      var groupsTree = angular.copy(cleanUsersGroups);
      var booleanOperations = [
        {
          operation: 'add',
          name: $translate.instant('GROUP.ACTIONS.ANY')
        },
        {
          operation: 'intersect',
          name: $translate.instant('GROUP.ACTIONS.ALL')
        }
      ];
      $mdDialog.show({
        controller: 'SegmentUsersGroupsController',
        controllerAs: 'vm',
        locals: {
          usersGroups: cleanUsersGroups,
          usersGroupsTypes: usersGroupsTypes,
          booleanOperations: booleanOperations,
          defaultGroupTypeId: 2, //subscription
          showGroupsTypes: false,
          newGroupShow: true,
          subscriptionGroupId: vm.currentContent.mailing_template.subscription_group_object.id_group,
          subscriptionGroupName: vm.currentContent.mailing_template.subscription_group_object.name,
        },
        templateUrl: 'app/main/dialogs/segment-users-groups/segment-users-groups.html',
        parent: angular.element($document.body),
        targetEvent: 'ev',
        clickOutsideToClose: true

      }).then(function (newSegment) {
        if (newSegment) {
          vm.currentContent.segment_group = newSegment.id_group;
          var object = contentFunctionsMailing.createOptionsContent(vm.currentContent, vm.isUpdateContent, $scope, false);
          var options = object.options;
          var method = object.method;
          if(options.item.hasOwnProperty('mailing_template')){
            delete options.item.mailing_template;
          }
          mailingService.saveContent({
            site: $scope.siteID,
            section: 'content',
            id: options.item.id_mailing_content,
            item: options.item
          }, method).then(function (response) {
            var options = {
              siteID: $scope.siteID,
              section: $scope.section,
              groupIds: [newSegment.id_group],
              sortDir: $rootScope.sortDir,
              sortField: $rootScope.sortField
            };
            usersService.getUsersByGroups(options).then(function (response2) {
              newSegment.totalUsers = response2.result.total;
              vm.selectedContentSegmentGroups.push(newSegment);
              vm.loadingSegmentsGroups = false;
            })
          });

          /*
          if (!structure_group.groups) {
            structure_group.groups = [];
          }
          structure_group.groups.push(result);
          */
        }
        vm.basicForm.$setDirty();
      });
    }

    function usersInGroupDialog(groupId, groupName) {
      if (groupId) {
        $mdDialog.show({
          controller: 'UsersInGroupMailingController',
          controllerAs: 'vm',
          locals: {
            usersRef: vm.usersRef,
            groupId: groupId,
            groupName: groupName,
            section: $scope.section,
            siteID: $scope.siteID
          },
          templateUrl: 'app/main/apps/mailing/dialogs/users-ingroup/users-ingroup-mailing.html',
          parent: angular.element($document.body),
          targetEvent: 'ev',
          clickOutsideToClose: true,

        }).then(function (result) {
          if (result) {
            structure_group.groups[index] = result;
          }
          vm.basicForm.$setDirty();
        });
      }
    }


    function openTemplate(template) {
      vm.templateSelected = true;

      var newTemplate = angular.copy(template);
      var structureMjml = newTemplate.structure_mjml;
      if (Object.keys(vm.currentContent.structure_mjml).length > 0) {
        structureMjml = angular.toJson(vm.currentContent.structure_mjml);
      }
      newTemplate.structure_mjml = structureMjml;
      vm.currentContent.structure_mjml = angular.fromJson(structureMjml);
      vm.currentContent.id_mailing_template = newTemplate.id_mailing_templates;
      vm.currentContent.mailing_template = newTemplate;
      vm.currentContent.mailing_template.test_emails_json = angular.fromJson(newTemplate.test_emails_json);
      vm.openContentView('content');
      var state;
      if (vm.currentContent.id_mailing_content) {
        state = 'app.site_overview.mailing.content.list.templates.openedContent';
      }
      else {
        state = 'app.site_overview.mailing.content.list.templates.selectedTemplate';
      }

      $state.go(state, {
        id: vm.currentContent.id_mailing_content
      }, {
        notify: false,
        inherit: true,
        location: true
      });
    }

    function closeTemplate() {
      vm.tabSelected = null;
      vm.clearTemplateSelected();
      disableTemplates();
      if (vm.basicForm.$setPristine) {
        vm.basicForm.$setPristine();
      }
    }
    function selectUser(user) {
      vm.nextPageLogUser = 1;
      vm.selectedUser = user;
      vm.getLogsByUser(user, vm.nextPageLogUser);
    }
    function closeUser() {
      vm.selectedUser = null;
    }

    function disableTemplates() {
      vm.loadTemplates = false;
      var state;
      if (vm.currentContent && vm.currentContent.id_mailing_content) {
        vm.templateSelected = true;
        state = 'app.site_overview.mailing.content.list.templates.openedContent';
      } else {
        state = 'app.site_overview.mailing.content.list';
      }
      $state.go(state, {}, {
        notify: false,
        inherit: true,
        location: true
      });
    }

    function openContent(idContent, afterSave) {
      vm.selectedContentSegmentGroups = [];
      if (!afterSave) {
        vm.openContentView('content');
      }
      vm.loadingReadPane = true;
      vm.selectedContentID = idContent;
      var options = {
        id: idContent,
        section: "content",
        site: $scope.siteID
      }

      mailingService.getByID(options).then(function (response) {
        vm.testEmailsChanged = false;
        vm.loadingReadPane = false;
        vm.templateSelected = true;
        vm.loadingSegmentsGroups = true;
        vm.loadingDefaultSubscriptionGroup = true;
        vm.currentContent = response;
        // Parseo tolerante: si uno de estos campos trae JSON corrupto no debe
        // abortar la carga y dejar el diseño (structure_mjml) sin parsear, que es
        // lo que hacía que el editor se abriera vacío.
        vm.currentContent.users_groups_json = sharedFunctionsMailing.safeFromJson(response.users_groups_json, [], 'users_groups_json');
        vm.currentContent.test_emails_json = sharedFunctionsMailing.safeFromJson(response.test_emails_json, [], 'test_emails_json') || [];
        try {
          vm.currentContent.structure_mjml = angular.fromJson(response.structure_mjml);
        } catch (e) {
          vm.currentContent.structure_mjml = {};
          if(response.structure_mjml_temp){
            var message = $translate.instant('MAILING.MJML_PROBLEM');
            var accept = $translate.instant('MAILING.MJML_PROBLEM_ACCEPT');
            var cancel = $translate.instant('MAILING.MJML_PROBLEM_CANCEL');
            var confirm = $mdDialog.confirm()
              .title(message)
              .ariaLabel('Change email')
              .ok(accept)
              .cancel(cancel);
              
            $mdDialog.show(confirm).then(function () {
              vm.currentContent.structure_mjml = angular.fromJson(response.structure_mjml_temp);
            });
          }
        }

        if(vm.currentContent.id_mailing_status != 5){
          try {
            vm.currentContent.mailing_template.test_emails_json = angular.fromJson(response.mailing_template.test_emails_json) || [];
          } catch (e) {
            vm.currentContent.mailing_template.test_emails_json = [];
          }
          var options = {
            id: vm.currentContent.mailing_template.subscription_group,
            withoutUsers: true,
            siteID: $scope.siteID
          }
          usersService.getUsersGroup(options).then(function (response) {
            var options = {
              siteID: $scope.siteID,
              section: $scope.section,
              groupIds: [response.id_group],
            };
            usersService.getUsersByGroupsCount(options).then(function (response2) {
              response.totalUsers = response2.result.total;
              vm.currentContent.mailing_template.subscription_group_object = response;
              vm.loadingDefaultSubscriptionGroup = false;
            });
          });
  
          if (!angular.isNumber(vm.currentContent.segment_group)) {
            vm.currentContent.segment_group = vm.currentContent.mailing_template.subscription_group;
          }
          if (vm.currentContent.segment_group != vm.currentContent.mailing_template.subscription_group) {
            var options = {
              id: vm.currentContent.segment_group,
              siteID: $scope.siteID,
              withoutUsers: true
            };
            usersService.getUsersGroup(options).then(function (response) {
              var options = {
                siteID: $scope.siteID,
                section: $scope.section,
                groupIds: [response.id_group],
                sortDir: $rootScope.sortDir,
                sortField: $rootScope.sortField
              };
              usersService.getUsersByGroups(options).then(function (response2) {
                vm.usersRef = response2.ref;
                response.totalUsers = response2.result.total;
                vm.selectedContentSegmentGroups.push(response);
                vm.loadingSegmentsGroups = false;
              });
            });
          }else{
            vm.loadingSegmentsGroups = false;
          }
        }

        vm.currentContent.not_delivered_count = vm.currentContent.sent_count - vm.currentContent.delivered_count;
        vm.currentContent.blacklisted_count = vm.currentContent.total_count - vm.currentContent.sent_count;
        vm.currentContent.total_count = (!vm.currentContent.total_count) ? '0' : vm.currentContent.total_count;
        vm.currentContent.sent_count = (!vm.currentContent.sent_count) ? '0' : vm.currentContent.sent_count;
        vm.currentContent.blacklisted_count = (!vm.currentContent.blacklisted_count) ? '0' : vm.currentContent.blacklisted_count;
        vm.currentContent.delivered_count = (!vm.currentContent.delivered_count) ? '0' : vm.currentContent.delivered_count;
        vm.currentContent.not_delivered_count = (!vm.currentContent.not_delivered_count) ? '0' : vm.currentContent.not_delivered_count;
        vm.currentContent.open_count = (!vm.currentContent.open_count) ? '0' : vm.currentContent.open_count;
        vm.currentContent.clicked_count = (!vm.currentContent.clicked_count) ? '0' : vm.currentContent.clicked_count;
        vm.currentContent.rejected_count = (!vm.currentContent.rejected_count) ? '0' : vm.currentContent.rejected_count;
        vm.currentContent.bounced_count = (!vm.currentContent.bounced_count) ? '0' : vm.currentContent.bounced_count;
        vm.currentContent.complained_count = (!vm.currentContent.complained_count) ? '0' : vm.currentContent.complained_count;
        vm.currentContent.suppressed_count = (!vm.currentContent.suppressed_count) ? '0' : vm.currentContent.suppressed_count;
        vm.currentContent.not_delivered_processing_count = (!vm.currentContent.not_delivered_processing_count) ? '0' : vm.currentContent.not_delivered_processing_count;

        vm.isUpdateContent = true;
        vm.statsCharts = {
          options: {
            sent: {
              chart: {
                type: 'pieChart',
                height: 370,
                x: function (d) {
                  return d.key;
                },
                y: function (d) {
                  return d.y;
                },
                valueFormat: function (n) {
                  return n;
                },
                donut: true,
                donutRatio: 0.3,
                labelsOutside: false,
                showLabels: true,
                duration: 5,
                labelThreshold: 0.01,
                labelSunbeamLayout: false,
                legendPosition: 'bottom',
                legend: {
                  margin: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                  }
                },
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              }
            },
            open: {
              chart: {
                type: 'pieChart',
                height: 200,
                donut: true,
                x: function (d) {
                  return d.key;
                },
                y: function (d) {
                  return d.y;
                },
                valueFormat: function (n) {
                  return n;
                },
                showLabels: true,
                showLegend: false,
                pie: {
                  startAngle: function (d) {
                    return d.startAngle / 2 - Math.PI / 2
                  },
                  endAngle: function (d) {
                    return d.endAngle / 2 - Math.PI / 2
                  }
                },
                duration: 500,
                legend: {
                  margin: {
                    top: 5,
                    right: 60,
                    bottom: 5,
                    left: 0
                  }
                },
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              }
            },
            click: {
              chart: {
                type: 'pieChart',
                height: 200,
                donut: true,
                x: function (d) {
                  return d.key;
                },
                y: function (d) {
                  return d.y;
                },
                valueFormat: function (n) {
                  return n;
                },
                showLabels: true,
                showLegend: false,
                donutLabelsOutside: false,
                labelsOutside: false,
                pie: {
                  startAngle: function (d) {
                    return d.startAngle / 2 - Math.PI / 2
                  },
                  endAngle: function (d) {
                    return d.endAngle / 2 - Math.PI / 2
                  }
                },
                duration: 500,
                legend: {
                  margin: {
                    top: 5,
                    right: 60,
                    bottom: 5,
                    left: 0
                  }
                },
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              }
            },
            all: {
              chart: {
                type: 'discreteBarChart',
                height: 350,
                width: vm.chartWidth,
                margin: {
                  top: 20,
                  right: 10,
                  bottom: 50,
                  left: 10
                },
                rotateLabels: -20,
                x: function (d) { return d.label; },
                y: function (d) { return Math.round(d.value + (1e-10)); },
                showValues: true,
                showYAxis: false,
                valueFormat: function (n) {
                  return n;
                },
                duration: 500,
                xAxis: {
                  tickPadding: 12
                },
                yAxis: {
                  axisLabelDistance: 0
                }
              }
            },
            all_vertical: {
              chart: {
                type: 'multiBarHorizontalChart',
                height: 400,
                width: vm.chartWidthColumn,
                margin: {
                  top: 20,
                  right: 10,
                  bottom: 50,
                  left: 80
                },
                rotateLabels: -20,
                x: function (d) { return d.label; },
                y: function (d) { return Math.round(d.value + (1e-10)); },
                showValues: true,
                showYAxis: false,
                valueFormat: function (n) {
                  return n;
                },
                duration: 500,
                xAxis: {
                  tickPadding: 12
                },
                yAxis: {
                  axisLabelDistance: 0
                },
                showControls: false
              }
            },
            donut_total: {
              chart: {
                type: 'pieChart',
                height: vm.donutLg,
                width: vm.donutLg,
                tooltip: {
                  enabled: false
                },
                growOnHover: false,
                x: function (d) {
                  return d.key;
                },
                y: function (d) {
                  return d.y;
                },
                valueFormat: function (n) {
                  return n;
                },
                title: vm.currentContent.total_count,
                titleOffset: -15,
                donut: true,
                donutRatio: 0.85,
                labelsOutside: false,
                showLabels: false,
                duration: 5,
                labelThreshold: 0.01,
                labelSunbeamLayout: false,
                showLegend: false,
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              },
              legend: {
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              }

            },
            donut_sent: {
              chart: {
                type: 'pieChart',
                height: vm.donutLg,
                width: vm.donutLg,
                tooltip: {
                  enabled: false
                },
                growOnHover: false,
                x: function (d) {
                  return d.key;
                },
                y: function (d) {
                  return d.y;
                },
                valueFormat: function (n) {
                  return n;
                },
                title: vm.currentContent.sent_count,
                titleOffset: -15,
                donut: true,
                donutRatio: 0.85,
                labelsOutside: false,
                showLabels: false,
                duration: 5,
                labelThreshold: 0.01,
                labelSunbeamLayout: false,
                showLegend: false,
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              },
              legend: {
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              }
            },
            donut_delivered: {
              chart: {
                type: 'pieChart',
                height: vm.donutLg,
                width: vm.donutLg,
                tooltip: {
                  enabled: false
                },
                growOnHover: false,
                x: function (d) {
                  return d.key;
                },
                y: function (d) {
                  return d.y;
                },
                valueFormat: function (n) {
                  return n;
                },
                title: vm.currentContent.delivered_count,
                titleOffset: -15,
                donut: true,
                donutRatio: 0.85,
                labelsOutside: false,
                showLabels: false,
                duration: 5,
                labelThreshold: 0.01,
                labelSunbeamLayout: false,
                showLegend: false,
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              },
              legend: {
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              }
            },
            donut_not_delivered: {
              chart: {
                type: 'pieChart',
                height: vm.donutLg,
                width: vm.donutLg,
                tooltip: {
                  enabled: false
                },
                growOnHover: false,
                x: function (d) {
                  return d.key;
                },
                y: function (d) {
                  return d.y;
                },
                valueFormat: function (n) {
                  return n;
                },
                title: vm.currentContent.not_delivered_count,
                titleOffset: -15,
                donut: true,
                donutRatio: 0.85,
                labelsOutside: false,
                showLabels: false,
                duration: 5,
                labelThreshold: 0.01,
                labelSunbeamLayout: false,
                showLegend: false,
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              },
              legend: {
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              }
            },
            donut_blacklisted: {
              chart: {
                type: 'pieChart',
                height: vm.donutLg,
                width: vm.donutLg,
                tooltip: {
                  enabled: false
                },
                growOnHover: false,
                x: function (d) {
                  return d.key;
                },
                y: function (d) {
                  return d.y;
                },
                valueFormat: function (n) {
                  return n;
                },
                title: vm.currentContent.blacklisted_count,
                titleOffset: -15,
                donut: true,
                donutRatio: 0.85,
                labelsOutside: false,
                showLabels: false,
                duration: 5,
                labelThreshold: 0.01,
                labelSunbeamLayout: false,
                showLegend: false,
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              },
              legend: {
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              }
            },
            donut_opened: {
              chart: {
                type: 'pieChart',
                height: vm.donutSm,
                width: vm.donutSm,
                tooltip: {
                  enabled: false
                },
                growOnHover: false,
                x: function (d) {
                  return d.key;
                },
                y: function (d) {
                  return d.y;
                },
                valueFormat: function (n) {
                  return n;
                },
                title: vm.currentContent.open_count,
                titleOffset: -15,
                donut: true,
                donutRatio: 0.85,
                labelsOutside: false,
                showLabels: false,
                duration: 5,
                labelThreshold: 0.01,
                labelSunbeamLayout: false,
                showLegend: false,
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              },
              legend: {
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              }
            },
            donut_clicked: {
              chart: {
                type: 'pieChart',
                height: vm.donutSm,
                width: vm.donutSm,
                tooltip: {
                  enabled: false
                },
                growOnHover: false,
                x: function (d) {
                  return d.key;
                },
                y: function (d) {
                  return d.y;
                },
                valueFormat: function (n) {
                  return n;
                },
                title: vm.currentContent.clicked_count,
                titleOffset: -15,
                donut: true,
                donutRatio: 0.85,
                labelsOutside: false,
                showLabels: false,
                duration: 5,
                labelThreshold: 0.01,
                labelSunbeamLayout: false,
                showLegend: false,
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              },
              legend: {
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              }
            },
            donut_rejected: {
              chart: {
                type: 'pieChart',
                height: vm.donutSm,
                width: vm.donutSm,
                tooltip: {
                  enabled: false
                },
                growOnHover: false,
                x: function (d) {
                  return d.key;
                },
                y: function (d) {
                  return d.y;
                },
                valueFormat: function (n) {
                  return n;
                },
                title: vm.currentContent.rejected_count,
                titleOffset: -15,
                donut: true,
                donutRatio: 0.85,
                labelsOutside: false,
                showLabels: false,
                duration: 5,
                labelThreshold: 0.01,
                labelSunbeamLayout: false,
                showLegend: false,
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              },
              legend: {
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              }
            },
            donut_bounced: {
              chart: {
                type: 'pieChart',
                height: vm.donutSm,
                width: vm.donutSm,
                tooltip: {
                  enabled: false
                },
                growOnHover: false,
                x: function (d) {
                  return d.key;
                },
                y: function (d) {
                  return d.y;
                },
                valueFormat: function (n) {
                  return n;
                },
                title: vm.currentContent.bounced_count,
                titleOffset: -15,
                donut: true,
                donutRatio: 0.85,
                labelsOutside: false,
                showLabels: false,
                duration: 5,
                labelThreshold: 0.01,
                labelSunbeamLayout: false,
                showLegend: false,
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              },
              legend: {
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              }
            },
            donut_complained: {
              chart: {
                type: 'pieChart',
                height: vm.donutSm,
                width: vm.donutSm,
                tooltip: {
                  enabled: false
                },
                growOnHover: false,
                x: function (d) {
                  return d.key;
                },
                y: function (d) {
                  return d.y;
                },
                valueFormat: function (n) {
                  return n;
                },
                title: vm.currentContent.complained_count,
                titleOffset: -15,
                donut: true,
                donutRatio: 0.85,
                labelsOutside: false,
                showLabels: false,
                duration: 5,
                labelThreshold: 0.01,
                labelSunbeamLayout: false,
                showLegend: false,
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              },
              legend: {
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              }
            },
            donut_suppressed: {
              chart: {
                type: 'pieChart',
                height: vm.donutSm,
                width: vm.donutSm,
                tooltip: {
                  enabled: false
                },
                growOnHover: false,
                x: function (d) {
                  return d.key;
                },
                y: function (d) {
                  return d.y;
                },
                valueFormat: function (n) {
                  return n;
                },
                title: vm.currentContent.suppressed_count,
                titleOffset: -15,
                donut: true,
                donutRatio: 0.85,
                labelsOutside: false,
                showLabels: false,
                duration: 5,
                labelThreshold: 0.01,
                labelSunbeamLayout: false,
                showLegend: false,
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              },
              legend: {
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              }
            },
            donut_not_delivered_processing: {
              chart: {
                type: 'pieChart',
                height: vm.donutSm,
                width: vm.donutSm,
                tooltip: {
                  enabled: false
                },
                growOnHover: false,
                x: function (d) {
                  return d.key;
                },
                y: function (d) {
                  return d.y;
                },
                valueFormat: function (n) {
                  return n;
                },
                title: vm.currentContent.not_delivered_processing_count,
                titleOffset: -15,
                donut: true,
                donutRatio: 0.85,
                labelsOutside: false,
                showLabels: false,
                duration: 5,
                labelThreshold: 0.01,
                labelSunbeamLayout: false,
                showLegend: false,
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              },
              legend: {
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                }
              }
            }

          },
          data: {
            sent: [
              {
                key: "Delivered",
                y: vm.currentContent.delivered_count,
                visible: false
              },
              {
                key: "Rejected",
                y: vm.currentContent.rejected_count
              },
              {
                key: "Bounced",
                y: vm.currentContent.bounced_count
              },
              {
                key: "Complained",
                y: vm.currentContent.complained_count
              },
              {
                key: "Suppressed",
                y: vm.currentContent.suppressed_count
              },
              {
                key: "Blacklisted",
                y: vm.currentContent.blacklisted_count,
                color: "#333333"
              },
            ],
            open: [
              {
                key: "Opened",
                y: vm.currentContent.open_count
              },
              {
                key: "Not opened",
                y: vm.currentContent.delivered_count - vm.currentContent.open_count
              }
            ],
            click: [
              {
                key: "Clicked",
                y: vm.currentContent.clicked_count
              },
              {
                key: "Not clicked",
                y: vm.currentContent.open_count - vm.currentContent.clicked_count
              }
            ],
            all: [
              {
                values: [
                  {
                    "label": "Total",
                    "value": vm.currentContent.total_count
                  },
                  {
                    "label": "Sent",
                    "value": vm.currentContent.sent_count
                  },
                  {
                    "label": "Delivered",
                    "value": vm.currentContent.delivered_count
                  },
                  {
                    "label": "Open",
                    "value": vm.currentContent.open_count
                  },
                  {
                    "label": "Clicked",
                    "value": vm.currentContent.clicked_count
                  },
                  {
                    "label": "Rejected",
                    "value": vm.currentContent.rejected_count
                  },
                  {
                    "label": "Bounced",
                    "value": vm.currentContent.bounced_count
                  },
                  {
                    "label": "Complained",
                    "value": vm.currentContent.complained_count
                  },
                  {
                    "label": "Suppressed",
                    "value": vm.currentContent.suppressed_count
                  },
                  {
                    "label": "Blacklisted",
                    "value": vm.currentContent.blacklisted_count,
                    "color": "#222222"
                  }
                ]
              }
            ],
            donut_total: [
              {
                key: "",
                y: vm.currentContent.total_count,
                color: '#039be5'

              }
            ],
            donut_sent: [
              {
                key: "",
                y: vm.currentContent.sent_count,
                color: '#039be5'

              },
              {
                key: "",
                y: vm.currentContent.total_count - vm.currentContent.sent_count,
                color: "#dddddd"
              }
            ],
            donut_delivered: [
              {
                key: "",
                y: vm.currentContent.delivered_count,
                color: '#4CAF50'

              },
              {
                key: "",
                y: vm.currentContent.sent_count - vm.currentContent.delivered_count,
                color: "#dddddd"
              }
            ],
            donut_not_delivered: [
              {
                key: "",
                y: vm.currentContent.not_delivered_count,
                color: '#ff0000'

              },
              {
                key: "",
                y: vm.currentContent.delivered_count,
                color: "#dddddd"
              }
            ],
            donut_opened: [
              {
                key: "",
                y: vm.currentContent.open_count,
                color: '#4CAF50'

              },
              {
                key: "",
                y: vm.currentContent.delivered_count - vm.currentContent.open_count,
                color: "#dddddd"
              }
            ],
            donut_clicked: [
              {
                key: "",
                y: vm.currentContent.clicked_count,
                color: '#4CAF50'

              },
              {
                key: "",
                y: vm.currentContent.open_count - vm.currentContent.clicked_count,
                color: "#dddddd"
              }
            ],
            donut_rejected: [
              {
                key: "",
                y: vm.currentContent.rejected_count,
                color: '#ff0000'

              },
              {
                key: "",
                y: vm.currentContent.not_delivered_count - vm.currentContent.rejected_count,
                color: "#dddddd"
              }
            ],
            donut_bounced: [
              {
                key: "",
                y: vm.currentContent.bounced_count,
                color: '#ff0000'

              },
              {
                key: "",
                y: vm.currentContent.not_delivered_count - vm.currentContent.bounced_count,
                color: "#dddddd"
              }
            ],
            donut_complained: [
              {
                key: "",
                y: vm.currentContent.complained_count,
                color: '#ff0000'

              },
              {
                key: "",
                y: vm.currentContent.not_delivered_count - vm.currentContent.complained_count,
                color: "#dddddd"
              }
            ],
            donut_suppressed: [
              {
                key: "",
                y: vm.currentContent.suppressed_count,
                color: '#ff0000'

              },
              {
                key: "",
                y: vm.currentContent.not_delivered_count - vm.currentContent.suppressed_count,
                color: "#dddddd"
              }
            ],
            donut_not_delivered_processing: [
              {
                key: "",
                y: vm.currentContent.not_delivered_processing_count,
                color: '#ff0000'

              },
              {
                key: "",
                y: vm.currentContent.not_delivered_count - vm.currentContent.not_delivered_processing_count,
                color: "#dddddd"
              }
            ],
            donut_blacklisted: [
              {
                key: "",
                y: vm.currentContent.blacklisted_count,
                color: '#000000'

              },
              {
                key: "",
                y: vm.currentContent.total_count - vm.currentContent.blacklisted_count,
                color: "#dddddd"
              }
            ]
          }
        };
        vm.nextPageLog = 1;
        vm.nextPageLogUser = 1;
        vm.getLogs(vm.currentContent.id_mailing_content, vm.nextPageLog)
        $state.go('app.site_overview.mailing.content.list.templates.openedContent', {
          id: vm.currentContent.id_mailing_content
        }, {
          notify: false,
          inherit: true,
          location: true
        });
      }).catch(function (err) {
        console.log('err', err);
        var message = $translate.instant('GLOBAL.ERROR') + '<br>' + err.data.detail;
        $mdToast.show({
          template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
          hideDelay: 5000,
          position: 'top',
          parent: '#content-container'
        });
      });;
    }


    function setSortField(field) {
      vm.fieldOrder = field;
      $rootScope.pagination_setSortField(field, $rootScope.sortDir);
    }

    function setSortOrder(order) {
      $rootScope.sortDir = order;
      $rootScope.pagination_setSortField(vm.fieldOrde, $rootScope.sortDir);
    }

    function getFirstTextBox(group) {
      if (group.items) {
        group = angular.copy(group.items);
      }
      var exist = false;
      for (var i = 0; i < group.length; i++) {
        var element = group[i];
        if (element.type == 'textBox') {
          if (element.defaultValue) {
            exist = element.defaultValue;
          }
          else {
            exist = element.value;
          }
        }
      }
      if (!exist) {
        exist = group[0].label;
      }
      return exist;
    }

    function fillTemplateValues(template, content) {
      // TODO Check this
      for (var i = 0; i < content.structure_data_json.length; i++) {
        for (var j = 0; j < template.structure_data_json.length; j++) {
          if (template.structure_data_json[j].id === content.structure_data_json[i].id) {
            if (template.structure_data_json[j].type !== 'media') {
              if (template.structure_data_json[j].allowMultipleSections) {
                template.structure_data_json[j].defaultValue = content.structure_data_json[i].values;
              }
              else {
                template.structure_data_json[j].defaultValue = content.structure_data_json[i].value;
              }
            }

            if (template.structure_data_json[j].type === 'group') {
              if (!template.structure_data_json[j].groups) {
                template.structure_data_json[j].groups = [];
              }
              for (var k = 0; k < content.structure_data_json[i].items.length; k++) {
                content.structure_data_json[i].items[k].defaultValue = content.structure_data_json[i].items[k].value;
                content.structure_data_json[i].items[k].label = template.structure_data_json[j].items[k].label;
                delete content.structure_data_json[i].items[k].value
                if (content.structure_data_json[i].items[k].type === 'checkbox') {
                  content.structure_data_json[i].items[k].checked = content.structure_data_json[i].items[k].defaultValue;
                }
              }
              template.structure_data_json[j].groups.push(content.structure_data_json[i].items);

            }
            else {
              template.structure_data_json[j].defaultValue = content.structure_data_json[i].value;
            }

          }

        }
      }
      return template;
    }


    function closeContent() {
      vm.isUpdateContent = false;
      vm.closeTemplate();
    }

    function getLogs(idContent, page) {
      vm.loadingReadPane = true;
      mailingService.getLog({
        site: $scope.siteID,
        id: idContent,
        page: page,
        resultsPerPage: 250
      }).then(function (response) {
        vm.pagination_total_log_pages = response.last_page;
        vm.pagination_log_page = response.current_page;
        if (vm.nextPageLog > 1) {
          vm.logs = vm.logs.concat(response.data)
        } else {
          vm.logs = response.data;
        }
        vm.loadingReadPane = false;
        vm.nextPageLog++;
      });
    }

    function getLogsByFilter(idContent, page, filter, search, groupFiltered) {
      vm.loadingReadPane = true;
      mailingService.getLogByFilter({
        site: $scope.siteID,
        id: idContent,
        page: page,
        resultsPerPage: 250,
        filter: filter,
        idGroups: vm.groupFiltered,
        search: search
      }).then(function (response) {
        vm.pagination_total_log_pages = response.last_page;
        vm.pagination_log_page = response.current_page;
        if (page > 1) {
          vm.logs = vm.logs.concat(response.data)
        } else {
          vm.logs = response.data;
        }
        vm.loadingReadPane = false;
        vm.nextPageLog++;
      });
    }
    function getLogsByUser(email, page) {
      vm.loadingReadPaneUser = true;
      mailingService.getLogByUser({
        site: $scope.siteID,
        page: page,
        resultsPerPage: 250,
        email: email
      }).then(function (response) {
        vm.pagination_total_log_pages_user = response.last_page;
        vm.pagination_log_page_user = response.current_page;
        if (page > 1) {
          vm.logsUserSelected = vm.logsUserSelected.concat(response.data)
        } else {
          vm.logsUserSelected = response.data;
        }
        vm.loadingReadPaneUser = false;
        vm.nextPageLogUser++;
      });
    }

    function saveContent(content, send) {
      if ($('#md-chips-email input') && $('#md-chips-email input')[0] && $('#md-chips-email input')[0].value) {
        $scope.addChips($('#md-chips-email input')[0].value, vm.currentContent.test_emails_json)
        $scope.validateEmail(vm.currentContent.test_emails_json);
        $('#md-chips-email input')[0].value = '';
      }
      var object = contentFunctionsMailing.createOptionsContent(vm.currentContent, vm.isUpdateContent, $scope, content);
      var options = object.options;
      var method = object.method;
      if(options.item.hasOwnProperty('mailing_template')){
        delete options.item.mailing_template;
      }
      if(!options.item.structure_mjml_temp){
        options.item.structure_mjml_temp = null;
      }else if(typeof options.item.structure_mjml_temp != "object"){
        options.item.structure_mjml_temp = JSON.parse(options.item.structure_mjml_temp);
      }
      // GUARD anti-vaciado (con aviso): si el content ya existe y su cuerpo quedó
      // vacío (típicamente por editar el template y romperse el mapeo de campos),
      // NO guardamos: evitaríamos sobrescribir el contenido bueno con uno vacío.
      // El backstop del servicio cubre además otras vías; esto da el aviso claro.
      if (options.item.id_mailing_content &&
          !contentFunctionsMailing.structureHasBody(options.item.structure_mjml)) {
        $mdDialog.show($mdDialog.alert()
          .parent(angular.element(document.body))
          .clickOutsideToClose(true)
          .title($translate.instant('MAILING.EMPTY_BODY_GUARD_TITLE'))
          .htmlContent($translate.instant('MAILING.EMPTY_BODY_GUARD_MSG'))
          .ok('OK'));
        return;
      }
      mailingService.saveContent({
        site: $scope.siteID,
        section: 'content',
        id: options.item.id_mailing_content,
        item: options.item
      }, method)
        .then(function (response) {
          var message = $translate.instant('MAILING.SAVED');
          if (response.scheduled_at) {
            message = $translate.instant('MAILING.SCHEDULE_SAVED');
          }
          if (!send) {
            $mdToast.show({
              template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
              hideDelay: 5000,
              position: 'top',
              parent: '#content-container'
            });
          } else {
            vm.sendFull(false, true);
          }
          $rootScope.pagination_resetquery();
          vm.basicForm = {};
          vm.openContent(response.id_mailing_content, true);
          deselectThreads();
          // vm.clearTemplateSelected();
          // vm.closeTemplate();
          // vm.disableTemplates();
        })
        .catch(function (err) {
          console.log('err', err);
          var message = $translate.instant('GLOBAL.ERROR') + '<br>' + err.data.detail;

          $mdToast.show({
            template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
            hideDelay: 5000,
            position: 'top',
            parent: '#content-container'
          });
        });

    }

    function toggleSelectThreads() {
      vm.selectedThreads = sharedFunctionsMailing.toggleSelectThreads(vm.selectedThreads, vm.contents);
    }

    function clearTemplateSelected() {
      vm.currentContent = undefined;
      vm.isUpdateContent = false;
      vm.templateSelected = false;
    }

    function changeView(view) {
      if (vm.views[view]) {
        vm.loadingView = true;
        vm.defaultView = view;
        vm.currentView = view;
      }
    }

    function openContentView(view) {
      vm.loadingView = true;
      vm.defaultContentView = view;
      vm.currentContentView = view;
    }

    function openStatsView(view) {
      vm.loadingView = true;
      vm.defaultStatsView = view;
      vm.currentStatsView = view;
    }

    function viewPreview() {
      resetScroll();
      vm.editInline = false;
    }

    function resetScroll() {
      if (angular.element(document.getElementById('thread-detail')).length) {
        var elem = angular.element(document.getElementById('thread-detail'));
        elem.scrollTopAnimated(0, 10);
      }
    }

    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    function selectOrUnselect(item, $event) {
      var isRightClick = $event && $event.which == 3;
      var isDoubleClick = $event && $event.type == 'dblclick';
    };


    function initDate(formItem) {
      formItem.defaultValue ? formItem.defaultValue = new Date(formItem.defaultValue) : formItem.defaultValue = new Date();
    }


    function openImageDialog(ev, index, images, img) {
      $mdDialog.show({
        controller: 'MediaShowDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/dialogs/media-show/media-show-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          Images: images,
          ImageSelected: img,
          cropFormats: false,
          MediaFull: false,
          Tags: false
        }
      });
    }

    function cancelSend() {
      mailingService.cancelScheduled({
        site: $scope.siteID,
        item: {
          id_mailing_content: vm.currentContent.id_mailing_content,
        }
      }).then(function (response) {
        vm.currentContent.scheduled_at = null;
        vm.saveContent(vm.currentContent);
      }, function (error) {
        console.log(error);
        $mdToast.show({
          template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg">' +
            $translate.instant('MAILING.CANCEL_NOT_AVAILABLE') + '</div></md-toast>',
          hideDelay: 7000,
          position: 'top',
          parent: '#login-form-wrapper'
        });
      });
    }

    function reSchedule() {
      mailingService.reScheduled({
        site: $scope.siteID,
        item: {
          id_mailing_content: vm.currentContent.id_mailing_content,
          scheduled_at: vm.currentContent.scheduled_at,
        }
      }).then(function (response) {
        //vm.saveContent(vm.currentContent);
        var message = $translate.instant('MAILING.RESCHEDULED');
        $mdToast.show({
          template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
          hideDelay: 5000,
          position: 'top',
          parent: '#content-container'
        });

      }, function (error) {
        $mdToast.show({
          template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg">' +
            $translate.instant('MAILING.CANCEL_NOT_AVAILABLE') + '</div></md-toast>',
          hideDelay: 7000,
          position: 'top',
          parent: '#login-form-wrapper'
        });
      });
    }

    function sendLaterDialog(ev) {
      $mdDialog.show({
        controller: 'SendLaterController',
        controllerAs: 'vm',
        templateUrl: 'app/main/apps/mailing/dialogs/send-later/send-later.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          date: vm.currentContent.scheduled_at
        }
      }).then(function (data) {
        if (data) {
          if (vm.currentContent.scheduled_at && !data.date) {
            vm.cancelSend();
          } else if (data.date && !vm.currentContent.scheduled_at) {
            vm.currentContent.scheduled_at = data.date;
            vm.saveContent(vm.currentContent, true);
          } else if (data.date && (vm.currentContent.scheduled_at != data.date)) {
            vm.currentContent.scheduled_at = data.date;
            vm.reSchedule(vm.currentContent);
          }
        }
      });
    }

    function getDateFormat(date) {
      var siteDate = moment.utc(date).tz(sessionService.site_operative.timezone);
      return siteDate.format(sessionService.site_operative.dateTimeFormat);
    };

    function deleteImage(id) {
      for (var i = 0; i < vm.currentContent.structure_data_json.length; i++) {
        if (vm.currentContent.structure_data_json[i].type === 'media') {
          if (vm.currentContent.structure_data_json[i].defaultValue) {
            for (var k = 0; k < vm.currentContent.structure_data_json[i].defaultValue.length; k++) {
              if (vm.currentContent.structure_data_json[i].defaultValue[k] === id) {
                vm.currentContent.structure_data_json[i].defaultValue.splice(k, 1);
              }
            }
            for (var k = 0; k < vm.currentContent.structure_data_json[i].mediaValue.length; k++) {
              if (vm.currentContent.structure_data_json[i].mediaValue[k].id_media === id) {
                vm.currentContent.structure_data_json[i].mediaValue.splice(k, 1);
              }
            }
          }
        }
      }
      vm.basicForm.$setDirty();
    }

    function mediaDialogSingle(ev, formItem) {
      formItem.Thumbnail = [];

      $mdDialog.show({
        controller: 'MediaDialogController',
        controllerAs: 'vm',
        locals: {
          autoUpload: '',
          currentThread: formItem,
          section: $scope.section,
          mediazone: 'single',
          multipleSelection: true,
          isTiny: false,
          maxAttach: undefined,
          showViews: {
            1: true,
            2: true,
            3: true,
            4: true,
            5: true,
            upload: true,
            import: true
          }
        },
        templateUrl: 'app/main/dialogs/media/media-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true

      }).then(function (formItem) {
        if (formItem.Thumbnail[0] && formItem.Thumbnail[0].id_media) {
          for (var i = 0; i < formItem.Thumbnail.length; i++) {
            vm.setImage(formItem, formItem.Thumbnail[i].id_media);
          }
        }

      });
    }

    function setImage(formItem, id) {

      var options = {
        domain: $scope.siteID,
        id_media: id
      };
      mediaService.getImageByID(options)
        .then(function (response) {
          for (var i = 0; i < vm.currentContent.structure_data_json.length; i++) {
            if (vm.currentContent.structure_data_json[i].type === 'media' && response.data[0]) {
              if (!vm.currentContent.structure_data_json[i].mediaValue) {
                vm.currentContent.structure_data_json[i].mediaValue = [];
                vm.currentContent.structure_data_json[i].defaultValue = [];
              }
              vm.currentContent.structure_data_json[i].mediaValue.push(response.data[0]);
              vm.currentContent.structure_data_json[i].defaultValue.push(id);
              delete vm.currentContent.structure_data_json[i].Thumbnail;
            }
          }
          vm.basicForm.$setDirty();
        });
    }

    function instantTranslate(text) {
      return $translate.instant(text);
    }


    // V2
    vm.previewTemplate = previewTemplate;
    vm.openPreview = openPreview;
    vm.showEdit = showEdit;
    vm.openExternalPreview = openExternalPreview;
    vm.openExternalPDF = openExternalPDF;

    function previewTemplate($event, template) {
      var templateArray = angular.fromJson(template.structure_mjml);
      $mdDialog.show({
        controller: 'HtmlPreviewController',
        controllerAs: 'vm',
        locals: {
          currentHtml: templateArray.html
        },
        templateUrl: 'app/main/plugins/html-preview/html-preview.html',
        parent: angular.element($document.body),
        targetEvent: $event,
        clickOutsideToClose: true
      }).then(function (item) {
        console.log('closed');
      });
    }

    function openPreview($event) {
      $mdDialog.show({
        controller: 'HtmlPreviewController',
        controllerAs: 'vm',
        locals: {
          currentHtml: vm.currentContent.structure_mjml.html
        },
        templateUrl: 'app/main/plugins/html-preview/html-preview.html',
        parent: angular.element($document.body),
        targetEvent: $event,
        clickOutsideToClose: true
      });
    }

    function openExternalPreview($event) {
      var options = {
        siteID: $scope.siteID,
        id: vm.currentContent.id_mailing_content
      };
      mailingService.getPreviewToken(options).then(function (response) {
        $window.open(vm.mailingPreviewUrl + response.token, 'mailingpreview');
      })
    }

    function openExternalPDF($event) {
      var options = {
        siteID: $scope.siteID,
        id: vm.currentContent.id_mailing_content
      };
      vm.loadingReadPane = true;
      mailingService.getPDFFile(options).then(function (response) {
        if (response.url) {
          $window.open(response.url, 'mailingpdf');
          vm.loadingReadPane = false;
        } else {
          $mdToast.show({
            template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg">' + $translate.instant('MAILING.PDF_ERROR') + '</div></md-toast>',
            hideDelay: 7000,
            position: 'top',
            parent: '#login-form-wrapper'
          });
          vm.loadingReadPane = false;
        }
      })

    }

    function showEdit($event) {
      $mdDialog.show({
        controller: 'TemplateBuilderController',
        controllerAs: 'vm',
        locals: {
          currentContent: vm.currentContent,
          currentEmail: vm.currentContent.structure_mjml,
          emailName: '',
          disabledElements: [],
          section: section,
          split: vm.splitContent,
          mailingToContent: vm.mailingToContent
        },
        templateUrl: 'app/main/plugins/template-builder/template-builder.html',
        parent: angular.element($document.body),
        targetEvent: $event,
        clickOutsideToClose: true,
        escapeToClose: false,
        multiple: true
      }).then(function (item) {
        if (item) {
          vm.currentContent.structure_mjml = item.email;
          vm.currentContent.structure_mjml_temp = item.backup;
          if (!vm.currentContent.sent_at) {
            vm.saveContent();
          }
        }
        // vm.basicForm.$setDirty();
      });
    }

    function sendFull(execute, scheduled) {
      if (!execute) {
        mailingService.sendContent({
          site: $scope.siteID,
          item: {
            id_mailing_content: vm.currentContent.id_mailing_content,
            segment_group: vm.currentContent.segment_group,
            execute: false
          }
        }).then(function (response) {
          if (!scheduled) {
            // var messageConfirm = $translate.instant('MAILING.SEND_MESSAGE_SURE_SEND_TO') + response.send_total + $translate.instant('MAILING.SEND_MESSAGE_USERS');

            // var confirm = $mdDialog.confirm()
            //   .title(messageConfirm)
            //   .ariaLabel('Send mailing')
            //   .ok('SEND')
            //   .cancel('CANCEL');

            // $mdDialog.show(confirm).then(function () {
            //   sendConfirm();
            // });
            var message1 = $translate.instant('MAILING.YOU_ARE_ABOUT_TO_SEND') + ' '
            var message2 = response.send_total + ' ';
            var message3 = $translate.instant('MAILING.EMAILS_TO') + ' ';
            var message4 = vm.currentContent.mailing_template.subscription_group_object.name + ' ';
            var message5 = $translate.instant('MAILING.JUST_TO_KNOW');
            var message6 = $translate.instant('MAILING.THIS_LIST_HAS');
            var message7 = $translate.instant('MAILING.EMAILS_BUT');
            var message8 = vm.currentContent.mailing_template.subscription_group_object.totalUsers - response.send_total;
            var message9 = $translate.instant('MAILING.ARE_UNSUBSCRIBED');
            var message10 = $translate.instant('MAILING.ONLY');
            $mdDialog.show({
              template:
                '<md-dialog aria-label="List dialog">' +
                '  <md-dialog-content style="max-width: 500px;" class="m-25">' +
                "  <h2 class='bold'>{{'MAILING.READY_TO_SEND' | translate}}</h2>" +
                "  <h3>" + message1 + "<span class='bold'>" + message2 + "</span>" + message3 + "<span class='bold'>" + message4 + "</span></h3>" +
                "  <p class='block mt-30 mb-0 grey-200-bg  ph-10 pv-10'><strong>" + message5 + "</strong><br>" + message6 + " " + vm.currentContent.mailing_template.subscription_group_object.totalUsers + " " + message7 + " " + message8 + " " + message9 + " " + response.send_total + " " + message10 + "</p>" +
                '  </md-dialog-content>' +
                '  <md-dialog-actions class="pv-10">' +
                '    <md-button ng-click="closeDialog()" class="md-raised md-warn ">{{"MAILING.CANCEL" | translate }}</md-button>' +
                '    <md-button type="submit" ng-click="confirm()" class="ml-0 mb-20 send-button md-accent no-shadow md-raised md-rounded md-large" aria-label="MAILING.SEND" translate="" translate-attr-aria-label="MAILING.SEND_NOW" layout="row" layout-align="start center"><span><md-icon md-font-icon="icon-telegram" role="icon" aria-hidden="true"></md-icon><span translate="MAILING.SEND_NOW"></span></span></md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
              locals: {
                items: $scope.items
              },
              controller: DialogController
            }).then(function (res) {
              if (res) {
                sendConfirm();
              }
            });
            function DialogController($scope, $mdDialog, items) {
              $scope.items = items;
              $scope.closeDialog = function () {
                $mdDialog.hide();
              }
              $scope.confirm = function () {
                $mdDialog.hide(true);
              }
            }
          } else {
            sendConfirm();
          }

        });
      }

    }

    function sendConfirm() {
      vm.isSending = true;
      mailingService.sendContentAfter({
        site: $scope.siteID,
        item: {
          id_mailing_content: vm.currentContent.id_mailing_content,
          execute: true
        }
      }).then(function (response) {
        var message = $translate.instant('MAILING.SENT')
        if (vm.currentContent.scheduled_at) {
          message = $translate.instant('MAILING.SCHEDULE_SAVED')
        }
        $mdToast.show({
          template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
          hideDelay: 5000,
          position: 'top',
          parent: '#content-container'
        });
        $rootScope.pagination_resetquery();
        vm.basicForm = {};
        vm.isSending = false;
        vm.openContent(vm.currentContent.id_mailing_content);
      });
    }

    function sendTest() {
      var message = $translate.instant('MAILING.SEND_MESSAGE_SEND_TEST');
      var messageConfirm = $translate.instant('MAILING.SEND_MESSAGE_SURE_SEND_TEST');
      var emailsCount = (vm.currentContent && vm.currentContent.test_emails_json ? vm.currentContent.test_emails_json.length : 0) + 
                        (vm.currentContent && vm.currentContent.mailing_template && vm.currentContent.mailing_template.test_emails_json ? vm.currentContent.mailing_template.test_emails_json.length : 0);
      var confirm = $mdDialog.confirm()
        .title(message + ' ' + (emailsCount) + ' e-mail(s), ' + messageConfirm)
        .ariaLabel('Send test')
        .ok('SEND')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        mailingService.sendTest({
          site: $scope.siteID,
          item: {
            id_mailing_content: vm.currentContent.id_mailing_content,
          }
        }).then(function (response) {
          $mdToast.show({
            template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + $translate.instant('MAILING.TEST_SENT') + '</span></div></md-toast>',
            hideDelay: 5000,
            position: 'top',
            parent: '#content-container'
          });
          $rootScope.pagination_resetquery();
          vm.basicForm = {};
        })
      });


    }


    function exportMailingLogByMailingContentId(idMailingContent) {
      var options = {
        siteID: $scope.siteID,
        idMailingContent: idMailingContent,
        format: 'csv'
      }
      mailingService.exportLogByMailingContentId(options).then(function (response) {
        window.open(response.url);
        $mdDialog.hide();
      }, function (error) {
        $mdToast.show({
          template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg">' + (error.data.detail.length > 0 ? error.data.detail : error.data.title) + '</div></md-toast>',
          hideDelay: 7000,
          position: 'top',
          parent: '#login-form-wrapper'
        });
      })
    }

    function isolateBounces(idMailingContent, bounceType) {
      if (!bounceType) {
        var messageConfirm = $translate.instant('MAILING.SURE_ISOLATE_ALL_BOUNCES');
        var ariaLabel = $translate.instant('MAILING.SURE_ISOLATE_ALL_BOUNCES');
      } else if (bounceType == 'permanent') {
        var messageConfirm = $translate.instant('MAILING.SURE_ISOLATE_HARD_BOUNCES');
        var ariaLabel = $translate.instant('MAILING.SURE_ISOLATE_HARD_BOUNCES');
      }

      var confirm = $mdDialog
        .confirm()
        .title(messageConfirm)
        .ariaLabel(ariaLabel)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        var options = {
          siteID: $scope.siteID,
          id: idMailingContent,
          section: 'content'
        };

        if (bounceType != null) {
          options['bounceType'] = bounceType;
        }
        mailingService.isolateBounces(options).then(function (response) {
          $mdToast.show({
            template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + $translate.instant('MAILING.BOUNCES_ISOLATED') + '</span></div></md-toast>',
            hideDelay: 5000,
            position: 'top',
            parent: '#content-container'
          });
        }, function (error) {
          $mdToast.show({
            template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg">' + (error.data.detail.length > 0 ? error.data.detail : error.data.title) + '</div></md-toast>',
            hideDelay: 7000,
            position: 'top',
            parent: '#login-form-wrapper'
          });
        });
      });
    }

    function changeMailingTemplate() {
      vm.templateSelected = false;
      vm.loadTemplates = true;
      getTemplates();
    }

    $scope.$on('selectGroupFilter', function (event, data) {
      if (!vm.groupFiltered) {
        vm.groupFiltered = [];
      }
      if (!vm.groupFiltered.find(x => x == data)) {
        vm.groupFiltered.push(data);
      } else {
        vm.groupFiltered = vm.groupFiltered.filter(x => x !== data);
      }
    });
    $scope.$on('$destroy', function () {
      $timeout.cancel(vm.timeout);
    });

    function openGroupsDialog() {
      usersService.getUsersGroups({
        siteID: $scope.siteID,
        withGroupType: true
      }).then(function (response) {
        var qiuRestrictions = response.qiuRestrictions;
        var groups = response.data;
        $mdDialog.show({
          controller: 'GroupsController',
          controllerAs: 'vm',
          locals: {
            groups: groups,
          },
          templateUrl: 'app/main/apps/mailing/dialogs/groups/groups-view.html',
          parent: angular.element($document.body),
          targetEvent: 'ev',
          clickOutsideToClose: true,
        }).then(function (update) {
          if (update) {
            vm.activateFilter(true);
          }
        });
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.mailing')
    .controller('MailingContentPlusController', MailingContentPlusController)
    .controller('MailingContentPlusEditorController', MailingContentPlusEditorController);

  /** @ngInject */
  function MailingContentPlusController(
    $scope, $rootScope, $document, $mdDialog, $mdToast, $timeout,
    requestContext, mailingService, msUtils,
    $translate, sessionService, section
  ) {
    var vm = this;

    vm.contents = [];
    vm.selectedThreads = [];
    vm.selectedContentID = null;
    vm.currentContent = null;
    vm.currentContentView = 'content';
    vm.basicForm = {};
    vm.isSaving = false;
    vm.msScrollOptions = { suppressScrollX: true };
    vm.mailingPreviewUrl = sessionService.site_operative.mailingPreviewUrl;
    vm.keys = [13, 188]; // ENTER, COMMA

    // List actions
    vm.newContent = newContent;
    vm.openContent = openContent;
    vm.deleteContent = deleteContent;
    vm.duplicateContent = duplicateContent;
    vm.toggleSelectThread = toggleSelectThread;
    vm.toggleSelectThreads = toggleSelectThreads;
    vm.isSelected = isSelected;
    vm.isChecked = isChecked;
    vm.setSortField = setSortField;
    vm.setSortOrder = setSortOrder;

    // Detail panel actions
    vm.openEditor = openEditor;
    vm.closeDetail = closeDetail;
    vm.openContentView = openContentView;
    vm.saveContent = saveContent;
    vm.openPreview = openPreview;
    vm.sendFull = sendFull;
    vm.sendTest = sendTest;
    vm.sendLaterDialog = sendLaterDialog;
    vm.changeMailingTemplate = changeMailingTemplate;
    vm.segmentGroupDialogNew = segmentGroupDialogNew;
    vm.changeGroupSubscriptionDialog = changeGroupSubscriptionDialog;
    vm.usersInGroupDialog = usersInGroupDialog;
    vm.getDateFormat = getDateFormat;

    // Utils
    vm.isSent = isSent;
    vm.timeAgo = msUtils.timeAgo;
    vm.translate = function (key) { return $translate.instant(key); };

    init();

    function init() {
      var siteID = requestContext.getParam('siteId');
      $scope.siteID = siteID;
      $rootScope.global.titleToolbar =
        '<i class="icon s20 icon-telegram mr-15"></i>' +
        '<span class="hide show-gt-xs">MAILING</span>' +
        '<i class="mr-5 ml-5 icon s18 icon-chevron-right hide show-gt-xs"></i> Content Plus';
    }

    // ── List ──────────────────────────────────────────────

    function openContent(idContent, $event) {
      if ($event) $event.stopPropagation();
      vm.selectedContentID = idContent;
      vm.currentContent = null;
      vm.currentContentView = 'content';
      vm.basicForm = {};
      vm.testEmailsChanged = false;
      mailingService.getByID({ site: $scope.siteID, id: idContent, section: 'content' }).then(function (response) {
        vm.currentContent = response;
        // md-chips necesita arrays; la API devuelve test_emails_json como string JSON.
        vm.currentContent.test_emails_json = _toArray(vm.currentContent.test_emails_json);
        if (vm.currentContent.mailing_template) {
          vm.currentContent.mailing_template.test_emails_json = _toArray(vm.currentContent.mailing_template.test_emails_json);
        }
      });
    }

    function newContent($event) {
      if ($event) $event.stopPropagation();
      // Creación como en mailing>content: no abrimos el editor directamente. Mostramos
      // el panel de detalle con un content vacío; el usuario pone asunto, elige template
      // (obligatorio: un content referencia un id_mailing_template y hereda su estructura)
      // y guarda. Solo tras guardar (unique_id) se habilita "Editar diseño".
      vm.selectedContentID = 'new';
      vm.currentContent = {
        id_mailing_content: '',
        id_mailing_status: 1,
        subject: '',
        structure_mjml: {},
        mailing_template: {},
        test_emails_json: []
      };
      vm.currentContentView = 'content';
      vm.basicForm = {};
    }

    function deleteContent() {
      if (vm.selectedThreads.length === 0) return;
      var ids = vm.selectedThreads.map(function (t) { return t.id_mailing_content; });
      var confirm = $mdDialog.confirm()
        .title('Eliminar')
        .textContent('¿Eliminar ' + ids.length + ' elemento(s)?')
        .ok('Eliminar').cancel('Cancelar');
      $mdDialog.show(confirm).then(function () {
        var promises = ids.map(function (id) {
          return mailingService.deleteThread({ site: $scope.siteID, id: id, section: 'content' });
        });
        Promise.all(promises).then(function () {
          vm.selectedThreads = [];
          vm.currentContent = null;
          vm.selectedContentID = null;
          $rootScope.pagination_resetquery();
        });
      });
    }

    function duplicateContent() {
      if (vm.selectedThreads.length === 0) return;
      mailingService.getByID({ site: $scope.siteID, id: vm.selectedThreads[0].id_mailing_content, section: 'content' }).then(function (response) {
        if (!response) return;
        var newItem = angular.copy(response);
        delete newItem.id_mailing_content;
        delete newItem.unique_id;
        delete newItem.sent_at;
        newItem.id_mailing_status = 1;
        newItem.subject = (newItem.subject || '') + ' (copia)';
        mailingService.saveContent({ site: $scope.siteID, section: 'content', id: 'new', item: newItem }).then(function () {
          $rootScope.pagination_resetquery();
        });
      });
    }

    function toggleSelectThread(item, $event) {
      $event.stopPropagation();
      var idx = vm.selectedThreads.indexOf(item);
      if (idx > -1) { vm.selectedThreads.splice(idx, 1); } else { vm.selectedThreads.push(item); }
    }

    function toggleSelectThreads() {
      vm.selectedThreads = vm.selectedThreads.length > 0 ? [] : vm.contents.slice();
    }

    function isSelected(item) { return vm.selectedThreads.indexOf(item) > -1; }
    function isChecked(item) { return vm.selectedThreads.indexOf(item) > -1; }
    function setSortField(field) { $scope.sortField = field; }
    function setSortOrder(dir) { $scope.sortDir = dir; }

    // ── Detail panel ──────────────────────────────────────

    function openContentView(view) {
      vm.currentContentView = view;
    }

    function closeDetail() {
      vm.currentContent = null;
      vm.selectedContentID = null;
      vm.basicForm = {};
    }

    // El validador de la API exige structure_mjml / structure_mjml_temp como array y
    // test_emails_json como array. La API devuelve structure_mjml como string JSON,
    // así que lo parseamos antes de guardar (y quitamos la relación mailing_template).
    function _contentSavePayload() {
      var item = angular.copy(vm.currentContent);
      if (angular.isString(item.structure_mjml)) {
        try { item.structure_mjml = angular.fromJson(item.structure_mjml); } catch (e) { item.structure_mjml = {}; }
      }
      if (angular.isString(item.structure_mjml_temp)) {
        try { item.structure_mjml_temp = angular.fromJson(item.structure_mjml_temp); } catch (e) { item.structure_mjml_temp = null; }
      }
      if (!item.structure_mjml_temp) { item.structure_mjml_temp = null; }
      item.test_emails_json = _toArray(item.test_emails_json);
      delete item.mailing_template;
      // segment_group se valida con exists (no nullable): no lo mandamos si está vacío.
      if (!item.segment_group) { delete item.segment_group; }
      return item;
    }

    function saveContent() {
      if (!vm.currentContent) return;
      if (!vm.currentContent.subject) { _toast('MAILING.SUBJECT_REQUIRED'); return; }
      if (!vm.currentContent.id_mailing_template) { _toast('MAILING.TEMPLATE_REQUIRED'); return; }
      vm.isSaving = true;
      mailingService.saveContent({
        site: $scope.siteID,
        section: 'content',
        id: vm.currentContent.id_mailing_content,
        item: _contentSavePayload()
      }).then(function (response) {
        vm.isSaving = false;
        vm.basicForm.$setPristine && vm.basicForm.$setPristine();
        openContent(response.id_mailing_content || vm.currentContent.id_mailing_content, null);
        $rootScope.pagination_resetquery();
        _toast('MAILING.SAVED');
      }, function () {
        vm.isSaving = false;
        _toast('MAILING.ERROR');
      });
    }

    function openEditor($event) {
      if (!vm.currentContent || !vm.currentContent.unique_id) return;
      var title = vm.currentContent.subject || '(sin asunto)';
      _openEditorDialog(vm.currentContent.id_mailing_content, title, $event);
    }

    function openPreview($event) {
      if (!vm.currentContent || !vm.currentContent.structure_mjml) return;
      // Renderizamos el HTML guardado en structure_mjml.html con el mismo diálogo que
      // usa el content tradicional (cliente, sin depender de unique_id ni URL pública).
      var structure = vm.currentContent.structure_mjml;
      if (typeof structure === 'string') {
        try { structure = JSON.parse(structure); } catch (e) { structure = null; }
      }
      var html = structure && structure.html;
      if (!html) { _toast('MAILING.PREVIEW_NEEDS_SAVE'); return; }
      $mdDialog.show({
        controller: 'HtmlPreviewController',
        controllerAs: 'vm',
        locals: { currentHtml: html },
        templateUrl: 'app/main/plugins/html-preview/html-preview.html',
        parent: angular.element($document.body),
        targetEvent: $event,
        clickOutsideToClose: true
      });
    }

    function sendFull(execute, scheduled) {
      mailingService.sendContent({
        site: $scope.siteID,
        item: {
          id_mailing_content: vm.currentContent.id_mailing_content,
          segment_group: vm.currentContent.segment_group,
          execute: execute !== false
        }
      }).then(function () {
        openContent(vm.currentContent.id_mailing_content, null);
      });
    }

    function sendTest() {
      if (!vm.currentContent) return;
      // Captura el email que el usuario dejó escrito sin pulsar Enter.
      var input = document.querySelector('#md-chips-email input');
      if (input && input.value) {
        $scope.addChips(input.value, vm.currentContent.test_emails_json);
        $scope.validateEmail(vm.currentContent.test_emails_json);
        input.value = '';
      }
      var emails = _toArray(vm.currentContent.test_emails_json);
      var tplEmails = vm.currentContent.mailing_template ? _toArray(vm.currentContent.mailing_template.test_emails_json) : [];
      if (!emails.length && !tplEmails.length) { _toast('MAILING.TEST_EMAILS_REQUIRED'); return; }
      // La pestaña Enviar no tiene botón de guardar: guardamos automáticamente antes
      // de enviar, porque sendTest envía a las direcciones ya persistidas del content.
      vm.isSaving = true;
      mailingService.saveContent({
        site: $scope.siteID,
        section: 'content',
        id: vm.currentContent.id_mailing_content,
        item: _contentSavePayload()
      }).then(function (response) {
        vm.basicForm.$setPristine && vm.basicForm.$setPristine();
        vm.testEmailsChanged = false;
        var id = (response && response.id_mailing_content) || vm.currentContent.id_mailing_content;
        return mailingService.sendTest({ site: $scope.siteID, item: { id_mailing_content: id } });
      }).then(function () {
        vm.isSaving = false;
        _toast('MAILING.SEND_MESSAGE_SEND_TEST');
      }, function () {
        vm.isSaving = false;
        _toast('MAILING.ERROR');
      });
    }

    function sendLaterDialog() {
      $mdDialog.show({
        controller: 'SendLaterController',
        controllerAs: 'vm',
        templateUrl: 'app/main/apps/mailing/dialogs/send-later/send-later.html',
        parent: angular.element($document.body),
        clickOutsideToClose: true,
        locals: { currentContent: vm.currentContent }
      }).then(function () {
        openContent(vm.currentContent.id_mailing_content, null);
      });
    }

    function changeMailingTemplate($event) {
      mailingService.get({
        page: 1, resultsPerPage: 350, section: 'templates',
        siteID: $scope.siteID, sortDir: 'ASC'
      }).then(function (response) {
        var templates = (response && response.data) || [];
        $mdDialog.show({
          controller: 'SelectDuplicateTemplateController',
          controllerAs: 'vm',
          templateUrl: 'app/main/apps/mailing/dialogs/select-template/select-template.html',
          parent: angular.element($document.body),
          targetEvent: $event,
          clickOutsideToClose: true,
          locals: { templates: templates, currentContent: vm.currentContent }
        }).then(function (selectedId) {
          if (!selectedId) return;
          var tpl = templates.filter(function (t) { return t.id_mailing_templates == selectedId; })[0];
          if (!tpl) return;
          tpl.test_emails_json = _toArray(tpl.test_emails_json);
          vm.currentContent.id_mailing_template = tpl.id_mailing_templates;
          vm.currentContent.mailing_template = tpl;
          // Si el content todavía no tiene diseño propio, hereda la estructura del template
          // (no la pisamos si ya hay diseño, para no perder el trabajo al solo cambiar template).
          var current = vm.currentContent.structure_mjml;
          if (angular.isString(current)) { current = angular.fromJson(current) || {}; }
          var hasStructure = current && Object.keys(current).length > 0;
          if (!hasStructure) {
            vm.currentContent.structure_mjml = angular.fromJson(tpl.structure_mjml) || {};
          }
          vm.basicForm.$setDirty && vm.basicForm.$setDirty();
        });
      });
    }

    function segmentGroupDialogNew() {
      $mdDialog.show({
        controller: 'GroupMailingController',
        controllerAs: 'vm',
        templateUrl: 'app/main/apps/mailing/dialogs/group/group-mailing.html',
        parent: angular.element($document.body),
        clickOutsideToClose: true,
        locals: { currentContent: vm.currentContent, siteID: $scope.siteID }
      }).then(function () {
        openContent(vm.currentContent.id_mailing_content, null);
      });
    }

    function changeGroupSubscriptionDialog($event) {
      $mdDialog.show({
        controller: 'GroupsMailingController',
        controllerAs: 'vm',
        templateUrl: 'app/main/apps/mailing/dialogs/groups/groups.html',
        parent: angular.element($document.body),
        targetEvent: $event,
        clickOutsideToClose: true,
        locals: { currentContent: vm.currentContent, siteID: $scope.siteID }
      }).then(function (group) {
        if (group) {
          vm.currentContent.segment_group = group.id_group;
          vm.currentContent.mailing_template.subscription_group_object = group;
        }
      });
    }

    function usersInGroupDialog(idGroup, name) {
      $mdDialog.show({
        controller: 'UsersInGroupMailingController',
        controllerAs: 'vm',
        templateUrl: 'app/main/apps/mailing/dialogs/users-ingroup/users-ingroup-mailing.html',
        parent: angular.element($document.body),
        clickOutsideToClose: true,
        locals: { idGroup: idGroup, name: name, siteID: $scope.siteID }
      });
    }

    function getDateFormat(date) {
      return date ? new Date(date).toLocaleString() : '';
    }

    function isSent(item) { return item && item.id_mailing_status >= 5; }

    function _toArray(val) {
      if (angular.isArray(val)) return val;
      if (angular.isString(val)) {
        try { var parsed = angular.fromJson(val); return angular.isArray(parsed) ? parsed : []; }
        catch (e) { return []; }
      }
      return [];
    }

    // Chips de emails de test. md-transform-chip añade el chip devuelto: devolvemos
    // el primero (para que md-chips lo inserte y limpie el input) y empujamos los
    // extras al modelo cuando se pega/escribe una lista separada por , o ;.
    $scope.addChips = function (chips, model) {
      if (!chips) return null;
      var parts = (chips.indexOf(';') > -1 ? chips.split(';') : chips.split(','))
        .map(function (s) { return (s || '').trim(); })
        .filter(function (s) { return !!s; });
      if (!parts.length) return null;
      for (var i = 1; i < parts.length; i++) { model.push(parts[i]); }
      return parts[0];
    };

    // Alta de emails de test con input propio (evita las rarezas de md-chips).
    vm.testEmailInput = '';
    vm.addTestEmail = addTestEmail;
    vm.removeTestEmail = removeTestEmail;
    vm.testEmailKeydown = testEmailKeydown;

    function addTestEmail() {
      var raw = (vm.testEmailInput || '').trim();
      if (!raw || !vm.currentContent) return;
      if (!angular.isArray(vm.currentContent.test_emails_json)) { vm.currentContent.test_emails_json = []; }
      var parts = (raw.indexOf(';') > -1 ? raw.split(';') : raw.split(','))
        .map(function (s) { return (s || '').trim(); })
        .filter(function (s) { return !!s; });
      parts.forEach(function (p) { vm.currentContent.test_emails_json.push(p); });
      $scope.validateEmail(vm.currentContent.test_emails_json); // valida y quita inválidos
      vm.testEmailInput = '';
      vm.testEmailsChanged = true;
    }

    function removeTestEmail(index) {
      if (vm.currentContent && angular.isArray(vm.currentContent.test_emails_json)) {
        vm.currentContent.test_emails_json.splice(index, 1);
        vm.testEmailsChanged = true;
      }
    }

    function testEmailKeydown($event) {
      if ($event.keyCode === 13 || $event.keyCode === 188) { // ENTER, COMMA
        $event.preventDefault();
        addTestEmail();
      }
    }

    $scope.validateEmail = function (emails) {
      var reg = /^(([^<>()\[\]\\.,;:\s@\"]+(\.[^<>()\[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      for (var i = 0; i < emails.length; i++) {
        emails[i] = emails[i].toLowerCase();
        if (!reg.test(emails[i])) {
          this.invalidEmail = true;
          emails.splice(i, 1);
        } else {
          this.invalidEmail = false;
          vm.testEmailsChanged = true;
        }
      }
    };

    function _toast(key) {
      $mdToast.show({
        template: '<md-toast layout="column" layout-align="center center"><div class="md-toast-content"><span class="md-toast-text" flex>' + $translate.instant(key) + '</span></div></md-toast>',
        hideDelay: 3000,
        position: 'top right'
      });
    }

    // ── Editor dialog ─────────────────────────────────────

    function _openEditorDialog(idContent, title, $event) {
      var CONTENT_PLUS_URL = (window.location.hostname === 'localhost')
        ? 'http://localhost:5173'
        : window.location.origin + '/content-plus/';

      $mdDialog.show({
        controller: 'MailingContentPlusEditorController',
        controllerAs: 'vm',
        templateUrl: 'app/main/apps/mailing/views/content-plus/dialogs/editor-dialog.html',
        parent: angular.element($document.body),
        targetEvent: $event,
        clickOutsideToClose: false,
        escapeToClose: true,
        locals: {
          contentPlusUrl: CONTENT_PLUS_URL,
          idContent: idContent,
          idTemplate: null,
          editorMode: 'content',
          contentTitle: title,
          siteID: $scope.siteID,
          currentLang: $translate.use() || 'es'
        }
      }).then(function () {
        if (vm.selectedContentID) { openContent(vm.selectedContentID, null); }
        $rootScope.pagination_resetquery();
      }, function () {
        if (vm.selectedContentID) { openContent(vm.selectedContentID, null); }
      });
    }
  }

  /** @ngInject */
  function MailingContentPlusEditorController(
    $scope, $mdDialog, $document, $sce, $timeout, $q, $http, $auth, sessionService, COMMON, mediahubService, mediaService,
    contentPlusUrl, idContent, idTemplate, editorMode, contentTitle, siteID, currentLang
  ) {
    var vm = this;

    vm.iframeSrc = $sce.trustAsResourceUrl(contentPlusUrl);
    vm.contentTitle = contentTitle;
    vm.close = function () { $mdDialog.hide(); };

    // Load MediaHub settings (url + tenant) so the React editor can browse the media center.
    var _mediaSettings = { mediahubUrl: '', mediahubTenant: '', vertexUrl: '' };
    var _settingsPromise = sessionService
      .loadDomainResourceSettings(siteID || $scope.siteID)
      .then(function (response) {
        if (response && response.public) {
          var publicConfig = angular.fromJson(response.public);
          _mediaSettings.mediahubUrl = publicConfig.mediahubUrl || '';
          _mediaSettings.mediahubTenant = publicConfig.mediahubTenant || 'demo1';
          _mediaSettings.vertexUrl = publicConfig.vertexUrl || '';
        }
      })
      .catch(function () { /* media browsing simply stays disabled */ });

    function _sendInit(iframe) {
      var token = $auth.getToken();
      var domain = sessionService.site_operative.subdomain || '';
      var apiBase = COMMON.BASE_API ? COMMON.BASE_API.replace('/api/v1', '') : '';
      var payload = {
        type: 'QIU_INIT',
        token: token,
        domain: domain,
        contentId: idContent,
        apiBase: apiBase,
        lang: currentLang,
        mediahubUrl: _mediaSettings.mediahubUrl,
        mediahubTenant: _mediaSettings.mediahubTenant,
        vertexUrl: _mediaSettings.vertexUrl,
        siteID: siteID || $scope.siteID,
        mode: editorMode || 'content',
        templateId: idTemplate || null,
        mailingFonts: (sessionService.site_operative && sessionService.site_operative.mailingFonts) || []
      };
      iframe.contentWindow.postMessage(payload, '*');
    }

    function _cropLabel(cfDef) {
      if (cfDef && cfDef.name) {
        return cfDef.name + (cfDef.width ? ' (' + cfDef.width + 'x' + cfDef.height + ')' : '');
      }
      return 'Formato ' + (cfDef && cfDef.id_cropformats);
    }

    // Resolve the URL of a single cropstatus entry (handles mediahub + legacy).
    function _cropUrl(cf) {
      if (!cf) { return ''; }
      if (cf.urlImage) { return cf.urlImage; }
      if (cf.container && cf.container.view_url) { return cf.container.view_url + cf.fileName; }
      var c = sessionService.getContainerByID(cf.id_container);
      if (c && c.view_url) { return c.view_url + cf.fileName; }
      return '';
    }

    // Map of generated cropformat id -> url, from a media item's cropstatus.
    function _generatedCropUrls(item) {
      var map = {};
      angular.forEach((item && item.cropstatus) || [], function (cf) {
        var u = _cropUrl(cf);
        if (u) { map[String(cf.id_cropformats)] = u; }
      });
      return map;
    }

    function _originalUrl(item) {
      if (!item) { return ''; }
      if (item.imageUrlOriginal) { return item.imageUrlOriginal; }
      if (item.imageUrl) { return item.imageUrl; }
      // Legacy: build from the original container.
      var c = sessionService.getContainerByID(item.cdnContainer);
      if (c && c.view_url && item.filename) {
        return c.view_url + 'original/m' + (item.id_media || item.id) + '_' + item.filename;
      }
      return item.url || '';
    }

    // Build the crop list: every cropformat defined for the tenant, marked
    // generated (with url) or not. The "original" is NOT included here because
    // the original URL must never be used as the final email image.
    function _buildCompleteCrops(fullItem) {
      var generated = _generatedCropUrls(fullItem);
      var defined = (sessionService.site_operative && sessionService.site_operative.cropformats) || [];
      var crops = [];
      angular.forEach(defined, function (cfDef) {
        var key = String(cfDef.id_cropformats);
        crops.push({
          key: key,
          url: generated[key] || '',
          label: _cropLabel(cfDef),
          generated: !!generated[key],
          width: cfDef.width,
          height: cfDef.height
        });
      });
      return crops;
    }

    function _mediaMeta(media) {
      var f = media.fields || {};
      return {
        filename: media.filename || f.filename || '',
        photographer: media.photographer || f.photographer || '',
        owner: media.owner || f.owner || '',
        caption: media.caption || f.caption || '',
        title: media.title || f.title || ''
      };
    }

    // Re-fetch the full media (mediahub) and post the complete crop list to the iframe.
    function _sendMediaSelection(media) {
      var mediaId = media.id_media || media.id;
      var meta = _mediaMeta(media);
      function finish(fullItem) {
        var crops = _buildCompleteCrops(fullItem);
        var fullId = sessionService.getMediaFullCropformatId && sessionService.getMediaFullCropformatId();
        var defaultUrl = '';
        // Prefer the "full" cropformat if generated.
        if (fullId) {
          for (var i = 0; i < crops.length; i++) {
            if (crops[i].key === String(fullId) && crops[i].generated) { defaultUrl = crops[i].url; break; }
          }
        }
        // Otherwise the first generated crop. NEVER the original (those URLs
        // don't work in the final email); if nothing is generated, url stays
        // empty and the editor will prompt the user to generate a crop.
        if (!defaultUrl) {
          for (var j = 0; j < crops.length; j++) {
            if (crops[j].generated && crops[j].url) { defaultUrl = crops[j].url; break; }
          }
        }
        _postToIframe({
          type: 'QIU_MEDIA_SELECTED',
          mediaId: mediaId,
          isMediahub: !!media.isMediahub,
          url: defaultUrl,
          originalUrl: _originalUrl(fullItem),
          crops: crops,
          meta: meta
        });
      }
      if (media.isMediahub && mediaId && mediahubService.getById) {
        mediahubService.getById(mediaId).then(finish).catch(function () { finish(media); });
      } else {
        finish(media);
      }
    }

    // Crops are generated asynchronously (queue worker). Poll patiently until ready,
    // with a high safety cap so we don't poll forever if the worker is down.
    var CROP_POLL_INTERVAL = 3000;   // ms
    var CROP_POLL_MAX = 100;         // ~5 min

    function _cropFailed(mediaId, formatId) {
      _postToIframe({ type: 'QIU_CROP_FAILED', mediaId: mediaId, formatId: String(formatId) });
    }
    function _cropReady(mediaId, formatId, url) {
      _postToIframe({ type: 'QIU_CROP_READY', mediaId: mediaId, formatId: String(formatId), url: url });
    }

    // Generate a single crop format. Routes to mediahub or legacy depending on the media.
    function _generateCrop(mediaId, formatId, isMediahub) {
      if (!mediaId || !formatId) { _cropFailed(mediaId, formatId); return; }
      if (isMediahub) {
        if (!mediahubService.regenerateMediaFormats) { _cropFailed(mediaId, formatId); return; }
        mediahubService.regenerateMediaFormats([mediaId], [Number(formatId)], false)
          .then(function () { _pollHubCrop(mediaId, formatId, 0); })
          .catch(function () { _cropFailed(mediaId, formatId); });
      } else {
        // Legacy media: POST media/crop/singleFormat, then poll the media's cropstatus.
        var domain = sessionService.site_operative.subdomain || siteID;
        $http.post(COMMON.BASE_API + '/domain/' + domain + '/media/crop/singleFormat', {
          id_media: Number(mediaId),
          id_cropformat: Number(formatId)
        }).then(function () {
          _pollLegacyCrop(mediaId, formatId, 0);
        }).catch(function () { _cropFailed(mediaId, formatId); });
      }
    }

    function _pollHubCrop(mediaId, formatId, attempt) {
      if (attempt > CROP_POLL_MAX) { _cropFailed(mediaId, formatId); return; }
      mediahubService.getById(mediaId).then(function (full) {
        var url = _generatedCropUrls(full)[String(formatId)];
        if (url) { _cropReady(mediaId, formatId, url); }
        else { $timeout(function () { _pollHubCrop(mediaId, formatId, attempt + 1); }, CROP_POLL_INTERVAL); }
      }).catch(function () {
        $timeout(function () { _pollHubCrop(mediaId, formatId, attempt + 1); }, CROP_POLL_INTERVAL);
      });
    }

    function _pollLegacyCrop(mediaId, formatId, attempt) {
      if (attempt > CROP_POLL_MAX) { _cropFailed(mediaId, formatId); return; }
      var domain = sessionService.site_operative.subdomain || siteID;
      // Direct call (self-contained, avoids mediaService's app-state coupling).
      $http.get(COMMON.BASE_API + '/domain/' + domain + '/media', {
        params: { id_media: mediaId, withCropStatus: true, page: 1, resultsPerPage: 1 }
      }).then(function (resp) {
        var d = resp.data;
        var list = (d && angular.isArray(d.data)) ? d.data : (angular.isArray(d) ? d : []);
        var item = list[0];
        var url = item ? _generatedCropUrls(item)[String(formatId)] : '';
        if (url) { _cropReady(mediaId, formatId, url); }
        else { $timeout(function () { _pollLegacyCrop(mediaId, formatId, attempt + 1); }, CROP_POLL_INTERVAL); }
      }).catch(function () {
        $timeout(function () { _pollLegacyCrop(mediaId, formatId, attempt + 1); }, CROP_POLL_INTERVAL);
      });
    }

    function _postToIframe(payload) {
      var iframe = document.getElementById('content-plus-iframe');
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage(payload, '*');
      }
    }

    function _putToS3(url, blob, contentType) {
      var deferred = $q.defer();
      var xhr = new XMLHttpRequest();
      xhr.open('PUT', url, true);
      xhr.setRequestHeader('Content-Type', contentType || 'application/octet-stream');
      var tenant = mediahubService.getCurrentTenant && mediahubService.getCurrentTenant();
      if (tenant) { xhr.setRequestHeader('X-Tenant', tenant); }
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
          if (xhr.status >= 200 && xhr.status < 300) { deferred.resolve(); }
          else { deferred.reject(xhr.status); }
        }
      };
      xhr.send(blob);
      return deferred.promise;
    }

    function _pollUploadedUrl(mediaId, attempt) {
      if (attempt > 20) { _postToIframe({ type: 'QIU_CROP_UPLOAD_FAILED' }); return; }
      mediahubService.getById(mediaId).then(function (full) {
        var url = (full && (full.imageUrlOriginal || full.imageUrl)) || '';
        if (url) { _postToIframe({ type: 'QIU_CROP_UPLOADED', url: url }); }
        else { $timeout(function () { _pollUploadedUrl(mediaId, attempt + 1); }, 2500); }
      }).catch(function () {
        $timeout(function () { _pollUploadedUrl(mediaId, attempt + 1); }, 2500);
      });
    }

    // Upload a cropped blob to the media center and return its hosted URL.
    function _uploadCrop(blob, filename) {
      if (!blob || !mediahubService.getPresignedUploadUrl) {
        _postToIframe({ type: 'QIU_CROP_UPLOAD_FAILED' });
        return;
      }
      var name = filename || ('crop_' + Date.now() + '.jpg');
      mediahubService.getPresignedUploadUrl(name, 'image/jpeg', [], { title: name })
        .then(function (resp) {
          var data = resp.data || resp;
          if (!data || !data.uploadUrl) { return $q.reject('no uploadUrl'); }
          return _putToS3(data.uploadUrl, blob, 'image/jpeg').then(function () { return data; });
        })
        .then(function (data) {
          var direct = data.viewUrl || data.publicUrl || data.url || data.imageUrl;
          if (direct) { _postToIframe({ type: 'QIU_CROP_UPLOADED', url: direct }); return; }
          var newId = data.id_media || data.id || (data.media && data.media.id);
          if (newId && mediahubService.getById) { _pollUploadedUrl(newId, 0); }
          else { _postToIframe({ type: 'QIU_CROP_UPLOAD_FAILED' }); }
        })
        .catch(function () { _postToIframe({ type: 'QIU_CROP_UPLOAD_FAILED' }); });
    }

    function _openMediaDialog() {
      $mdDialog.show({
        controller: 'MediaDialogController',
        controllerAs: 'vm',
        locals: {
          currentThread: { Thumbnail: [] },
          section: '',
          mediazone: { id_zone: null, zone_name: null },
          isTiny: false,
          maxAttach: 1,
          showViews: { 1: true, 2: true, 3: true, 4: true, 5: true, upload: true, import: true },
          autoUpload: ''
        },
        templateUrl: 'app/main/dialogs/media/media-dialog.html',
        parent: angular.element($document.body),
        clickOutsideToClose: true,
        multiple: true
      }).then(function (item) {
        // Stop the legacy uncropped-media polling triggered by the dialog grid.
        if (mediaService.stopUncroppedPolling) { mediaService.stopUncroppedPolling(); }
        if (item && item.Thumbnail && item.Thumbnail.length) {
          _sendMediaSelection(item.Thumbnail[0]);
        } else {
          _postToIframe({ type: 'QIU_MEDIA_CANCELLED' });
        }
      }, function () {
        if (mediaService.stopUncroppedPolling) { mediaService.stopUncroppedPolling(); }
        _postToIframe({ type: 'QIU_MEDIA_CANCELLED' });
      });
    }

    function _onWindowMessage(event) {
      if (event.data && event.data.type === 'QIU_READY') {
        var iframe = document.getElementById('content-plus-iframe');
        if (iframe) {
          // Make sure media settings are loaded before sending init.
          _settingsPromise.finally(function () { _sendInit(iframe); });
        }
      }
      if (event.data && event.data.type === 'QIU_OPEN_MEDIA') {
        _openMediaDialog();
      }
      if (event.data && event.data.type === 'QIU_GENERATE_CROP') {
        _generateCrop(event.data.mediaId, event.data.formatId, event.data.isMediahub);
      }
      if (event.data && event.data.type === 'QIU_UPLOAD_CROP') {
        _uploadCrop(event.data.blob, event.data.filename);
      }
      if (event.data && event.data.type === 'QIU_CLOSE') {
        $scope.$apply(function () { $mdDialog.hide(); });
      }
    }
    window.addEventListener('message', _onWindowMessage);

    $scope.$on('$destroy', function () {
      window.removeEventListener('message', _onWindowMessage);
      if (mediaService.stopUncroppedPolling) { mediaService.stopUncroppedPolling(); }
    });
  }

})();

(function () {
  'use strict';

  $(window.document).on('contextmenu', '.list-media-item', function (e) {
    var menu = $('#context-menu');

    if (e.pageX >= window.innerWidth - menu.width()) {
      e.pageX -= menu.width();
    }
    if (e.pageY >= window.innerHeight - menu.height()) {
      e.pageY -= menu.height();
    }

    var posx = 0;
    var posy = 0;

    if (!e)
      var e = window.event;

    posx = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
    posy = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;

    menu.hide().css({
      left: e.pageX,
      top: e.pageY
      // left: posx,
      // top: posy
    }).show();

    e.preventDefault();
  });

  angular
    .module('app.mailing')
    .controller('CommunicationsController', CommunicationsController);



  /** @ngInject */
  function CommunicationsController($scope, $rootScope, $document, $mdDialog, $mdMenu, $mdMedia, $mdToast, $mdConstant, $mdSidenav, $state, requestContext, $timeout, mailingService, transformMailing, msUtils, $anchorScroll, $translate, sessionService, tinyMceService, $window, mediaService, sharedFunctionsMailing, section) {


    var vm = this;

    $scope.section = section;

    $scope.array = [{
      active: true,
      value: 'Copy'
    }, {
      active: true,
      value: 'Cut'
    }, {
      active: false,
      value: 'Paste'
    }];


    vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg', 'red-bg', 'yellow-bg', 'light-blue-bg'];
    vm.testEmails = [];
    vm.selectedAccount = 'creapond';


    vm.folders = [];
    vm.labels = [];
    vm.loadingThreads = true;
    vm.enterfirst = true;
    vm.tags = null;
    vm.searchTagText = null;
    vm.selectedTag = null;
    vm.tinymceOptions = tinyMceService.getOptions($scope);
    vm.selectedIndexTab = 0;


    vm.typeFields = ['separator', 'relatedTable', 'textBox', 'media', 'htmlBox', 'colorPicker', 'checkbox', 'datePicker', 'group', 'lineSeparator', 'previewLink', 'social'];
    vm.keys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA];

    vm.scrollEl = angular.element('#thread-list')[0];

    vm.currentFilter = {
      type: $state.params.type,
      filter: $state.params.filter
    };
    vm.currentThread = null;
    vm.currentThread_Edit = null;
    vm.selectedThreads = [];
    vm.basicForm = {};
    vm.footerThumbnail = [];
    vm.nofooterThumbnail = [];
    vm.default_users_groups = [];


    vm.views = {
      nosplit: 'app/main/apps/mailing/views/communications/list/nosplit-view.html',
      split: 'app/main/apps/mailing/views/communications/list/split-view.html',
      grid: 'app/main/apps/mailing/views/communications/grid/grid-view.html'
    };
    vm.defaultView = 'split';
    vm.currentView = 'split';
    vm.loadingView = true;

    vm.mediaZones = [];

    vm.currentFilter = {
      type: $state.params.type,
      filter: $state.params.filter
    };
    vm.currentThread = null;
    vm.currentThread_Edit = null;
    vm.selectedThreads = [];
    vm.basicForm = {};
    vm.noexistchangues = true;
    vm.fieldOrder = 'created_at';

    vm.templateSortable = {
      group: '.template',
      animation: 150,
      scroll: true,
      handle: '.drag',
      filter: '.no-sort',
      ghostClass: "sort-drop",
      onStart: function (evt) {
        vm.copyMock = angular.copy(vm.currentThread_Edit.structure_data_json);
      },
      onEnd: function (evt) {
        if (typeof evt.oldIndex == 'undefined' || typeof evt.newIndex == 'undefined') {
          return false
        }
        vm.copyMock = changePosition(evt.newIndex - 1, evt.oldIndex - 1, vm.copyMock);
        vm.currentThread_Edit.structure_data_json = vm.copyMock;
        vm.basicForm.$setDirty();
        return false;

      }
    }

    vm.mediaSortable = {
      group: 'media',
      animation: 150,
      scroll: true,
      filter: '.no-sort',
      handle: '.media',
      ghostClass: "sort-drop",
      onEnd: function (evt) {
        vm.basicForm.$setDirty();
      }
    };

    vm.viewGroupField = "app/main/apps/mailing/dialogs/group/group-view.html";
    vm.currentGroup;


    // Methods
    vm.init = init;
    vm.getInArray = msUtils.getInArray;
    vm.toggleInArray = msUtils.toggleInArray;
    vm.toggleInGroup = msUtils.toggleInGroup;
    vm.getReferencesSections = mailingService.getReferencesSections;
    vm.getExtension = msUtils.getExtension;
    vm.getExtensionIcon = msUtils.getExtensionIcon;
    vm.getValuesReferencesSections = mailingService.getValuesReferencesSections;



    vm.newCommunication = newCommunication;
    vm.openCommunication = openCommunication;
    vm.closeThread = closeThread;
    vm.closeThreadEdit = closeThreadEdit;
    vm.deleteThread = deleteThread;
    vm.setSortField = setSortField;
    vm.setSortOrder = setSortOrder;

    vm.openUrl = openUrl;
    vm.toggleSelectThread = toggleSelectThread;
    vm.toggleSelectThreads = toggleSelectThreads;
    vm.isSelected = isSelected;
    vm.deselectThreads = deselectThreads;


    vm.changeView = changeView;
    vm.viewPreview = viewPreview;
    vm.saveItem = saveItem;



    vm.toggleSidenav = toggleSidenav;
    vm.updateThread = updateThread;


    vm.openMenu = openMenu;
    vm.selectOrUnselect = selectOrUnselect;
    vm.openImageDialog = openImageDialog;
    vm.openFocalPoint = openFocalPoint;
    vm.openMediaItemMetadata = openMediaItemMetadata;
    vm.MediaItemRecrop = MediaItemRecrop;
    vm.deleteAttachment = deleteAttachment;
    vm.mediaDialog = mediaDialog;
    vm.groupDialog = groupDialog;
    vm.openUsersGroupsDialog = openUsersGroupsDialog;
    vm.deleteTarget = deleteTarget;
    vm.showDesignView = showDesignView;

    vm.setTinyMceContent = setTinyMceContent;

    vm.callback = callback;
    vm.deleteItemArray = deleteItemArray;

    vm.editGroupField = editGroupField();
    vm.duplicateCommunication = duplicateCommunication;

    vm.translate = instantTranslate;

    vm.filterGroups = {
      groups: [],
      includeSubgroups: true
    }
    vm.toggleIncludeSubgroups = toggleIncludeSubgroups;
    vm.unselectGroups = unselectGroups;

    //////////

    init();

    /**
     * Initialize
     */
    function init() {
      var siteID = requestContext.getParam("siteId");

      vm.ActiveSection = {};
      vm.ActiveSection.edit = true;
      vm.ActiveSection.media = true;
      vm.ActiveSection.usersGroups = true;
      vm.ActiveSection.testUsers = true;
      vm.ActiveSection.advancedConfig = true;

      $scope.siteID = siteID;
      $scope.section = section;
      $rootScope.global.titleToolbar = '<i class="icon s20 icon-telegram mr-15" ng-if="node.icon"></i>MAILING<i class="mr-5 ml-5 icon s18 icon-chevron-right hide show-gt-xs"></i> <span class="hide show-gt-xs">' + section + '</span>';
      var options = {
        site: $scope.siteID,
        section: $scope.section
      };
      $scope.page = 1;

      if ($state.params.id) {
        vm.openCommunication(null, $state.params.id);
      }

      vm.isAdmin = sessionService.user.is_admin;
      
      sessionService.loadDomainResourceSettings($scope.siteID).then(function (response){
        vm.splitContent = response.mailingHeaderContentSplitOption;
      });

    }

    function initUsersGroups() {
      mailingService.getUsersGroups({
        section: $scope.section,
        site: $scope.siteID,
        groupType: 2
      }).then(function (response) {
        vm.usersGroups = transformMailing.formatNestedGroups(response);
      });
    }

    function changePosition(newIndex, oldIndex, array) {
      if (oldIndex < newIndex) {
        for (var i = oldIndex; i < newIndex; i++) {
          var temp = array[i + 1];
          array[i + 1] = array[i];
          array[i] = temp;
        }
      }
      if (newIndex < oldIndex) {
        for (var i = oldIndex; i > newIndex; i--) {
          var temp = array[i - 1];
          array[i - 1] = array[i];
          array[i] = temp;
        }
      }

      vm.basicForm.$setDirty();
      return array;
    }

    // Watch screen size to change view modes
    $scope.$watch(function () {
      return $mdMedia('lt-sm');
    }, function (current, old) {
      if (angular.equals(current, old)) {
        return;
      }

      if (current) {
        vm.currentView = 'nosplit';
      }
    });

    $scope.$watch(function () {
      return $mdMedia('max-width: 960px');
    }, function (big) {

      if (big)
        vm.currentView = 'nosplit';

    });

    $scope.$watch(function () {
      return $mdMedia('min-width: 960px');
    }, function (small) {

      if (small)
        vm.currentView = 'split';

    });

    $scope.$watch(function () {
      return $mdMedia('gt-sm');
    }, function (current, old) {
      if (angular.equals(current, old)) {
        return;
      }

      if (current) {
        if (vm.defaultView === 'split') {
          vm.currentView = 'split';
        }
      }
    });

    $scope.$on('$includeContentLoaded', function (event, target) {
      $timeout(function () {
        vm.loadingView = false;
      }, 1000);
    });

    $scope.$on('pagination:loadStart', function (event) {
      // $anchorScroll();

      // Store the current scrollPos
      // vm.scrollPos = vm.scrollEl.scrollTop();

      // Scroll to the top
      // vm.scrollEl.scrollTop(0);
      if (!vm.enterfirst) {
        var elem = angular.element(document.getElementById('thread-list'));
        elem.scrollTopAnimated(0, 10);
      }

      // angular.element("#thread-list").scrollTop=0;

      vm.enterfirst = false;

      $scope.isLoading = true;
    });

    $scope.$on('pagination:loadPage', function (event) {
      $scope.isLoading = false;
      vm.dataAlreadyLoaded = true;
    });

    function setTinyMceContent(event) {
      var zoneMedia = {
        1: {},
        2: {},
        3: {},
        4: {}
      };
      var typesMax = {
        1: 0,
        2: 0,
        3: 0,
        4: 0
      };
      var currentSort = 0;
      var currentType = 0;

      return zoneMedia;
    }


    var originatorEv;

    function openMenu($mdMenu, ev) {
      originatorEv = ev;
      $mdMenu.open(ev);
    }


    /**
     * Open thread
     *
     * @param thread
     */
    function openCommunication(thread, id) {

      if (angular.element(document.getElementById('thread-detail')).length) {
        var elem = angular.element(document.getElementById('thread-detail'));
        elem.scrollTopAnimated(0, 10);
      }
      if (id != 'new') {
        if (thread) {
          vm.selectedContentID = thread.id_mailing_communications;
        } else {
          vm.selectedContentID = id;
        }

        vm.loadingReadPane = true;
        $state.go('app.site_overview.mailing.communications.list.thread', {
          id: vm.selectedContentID
        }, {
          notify: false,
          inherit: true,
          location: true
        });

        var options = {
          site: $scope.siteID,
          section: $scope.section,
          id: vm.selectedContentID
        }

        mailingService.getByID(options).then(function (response) {
          response = transformMailing.validateCommunicationFields(response);
          vm.currentThread_Edit = response;
          vm.selectedContent = response;
          vm.selectedContent.id = vm.selectedContentID;
          vm.loadingReadPane = false;
        }).catch(function (err) {
          var message = $translate.instant('GLOBAL.ERROR') + '<br>' + err.data.detail;
          $mdToast.show({
            template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
            hideDelay: 5000,
            position: 'top',
            parent: '#content-container'
          });
        });
      } else {
        vm.selectedContent = thread;

        vm.selectedContent.id = 'new';
        vm.currentThread_Edit = angular.copy(thread);
        vm.loadingReadPane = false;
        vm.selectedIndexTab = 0;
      }
    }

    function deleteThread() {

      for (var i = 0; i < vm.selectedThreads.length; i++) {
        var options = {
          site: $scope.siteID,
          section: $scope.section,
          id: vm.selectedThreads[i]['id_mailing_communications']
        };
        mailingService.deleteThread(options).then(function (response) {
          vm.loadingReadPane = false;
          $rootScope.pagination_resetquery();
          deselectThreads();
          vm.closeThreadEdit();
        });
      }
    }

    function setSortField(field) {
      vm.fieldOrder = field;
      $rootScope.pagination_setSortField(field, $rootScope.sortDir);
    }

    function setSortOrder(order) {
      $rootScope.sortDir = order;
      $rootScope.pagination_setSortField(vm.fieldOrde, $rootScope.sortDir);
    }


    function newCommunication() {
      if (angular.element(document.getElementById('thread-detail')).length) {
        var elem = angular.element(document.getElementById('thread-detail'));
        elem.scrollTopAnimated(0, 10);
      }

      vm.selectedContentID = '';
      vm.loadingReadPane = true;

      $state.go('app.site_overview.mailing.communications.list.thread', {
        id: ''
      }, {});

      var newCommunication = transformMailing.createNewEmptyCommunication();
      vm.currentThread_Edit = newCommunication;
      vm.currentThread_Edit.structure_data_json = [];
      openCommunication(newCommunication, 'new');

    }


    function getCurrentLabels(template) {
      var usersGroupsAux = sharedFunctionsMailing.initUsersGroup(angular.copy(vm.usersGroups), angular.copy(template.default_users_groups_json));
      return sharedFunctionsMailing.getLabels(usersGroupsAux);
    }

    function closeThreadEdit() {
      resetScroll();
      vm.currentThread_Edit = false;
      vm.selectedContentID = false;
      vm.templateSelected = false;
      vm.noexistchangues = true;
      vm.currentLabels = [];
      if (vm.currentView === 'split') {
        vm.selectedContent = false;
      }
      $state.go('app.site_overview.mailing.communications.list', {
        id: ''
      }, {});
    }

    /**
     * Close thread
     */
    function closeThread() {
      vm.editInline = false;

      vm.currentThread_Edit = false;
      vm.selectedContent = null;
      vm.selectedContentID = null;
      vm.currentThread_Edit.structure_data_json = [];
      vm.noexistchangues = true;

    }


    /**
     * Return checked status of the content
     *
     * @param content
     * @returns {boolean}
     */
    function saveItem(content) {
      if ($('#md-chips-email input') && $('#md-chips-email input')[0] && $('#md-chips-email input')[0].value) {
        $scope.addChips($('#md-chips-email input')[0].value, vm.currentThread_Edit.to_emails_json)
        $scope.validateEmail(vm.currentThread_Edit.to_emails_json);
        $('#md-chips-email input')[0].value = '';
      }
      //setMediaImage(content);
      var options = {
        site: $scope.siteID,
        section: $scope.section,
        id: content.id,
        item: content
      };
      mailingService.saveItem(options).then(function (response) {
        var message = $translate.instant('CONTENT.SAVED');
        $mdToast.show({
          template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
          hideDelay: 5000,
          position: 'top',
          parent: '#content-container'
        });
        // vm.closeThreadEdit();
        return true;
      });
    }

    function createMediaStructure(type, n, thumbnails) {
      var array = [];
      for (var i = 0; i < thumbnails.length; i++) {
        array.push(thumbnails[i]['id_media']);
      }
      vm.currentThread_Edit.structure_data_json.unshift({
        type: type,
        id_media: array,
        id: n.toString()
      });
    }

    function setImageToStructure(thumbnails, n, typeMedia, existMedia) {
      for (var i = 0; i < vm.currentThread_Edit.structure_data_json.length; i++) {
        if (vm.currentThread_Edit.structure_data_json[i]['type'] === typeMedia) {
          existMedia = true;
          vm.currentThread_Edit.structure_data_json[i]['id_media'] = [];
          for (var k = 0; k < thumbnails.length; k++) {
            vm.currentThread_Edit.structure_data_json[i]['id_media'].push(thumbnails[k]['id_media']);
            /*var existElement = false;
            for (var j = 0; j < vm.currentThread_Edit.structure_data_json[i]['id_media'].length; j++) {
                if (vm.currentThread_Edit.structure_data_json[i]['id_media'][j] === thumbnails[k]['id_media']) {
                    existElement = true;
                }
            }
            if (!existElement) {
                vm.currentThread_Edit.structure_data_json[i]['id_media'].push(thumbnails[k]['id_media']);
            }*/
          }
        }
      }
      return existMedia;
    }

    function formatMediaArray(thumbnails, n, typeMedia) {
      if (thumbnails) {
        var existMedia = false;
        existMedia = setImageToStructure(thumbnails, n, typeMedia, existMedia);
        if (!existMedia) {
          createMediaStructure(typeMedia, n, thumbnails);
        }
      }
    }

    function setMediaImage(content) {
      var d = new Date();
      var n = d.getTime();
      formatMediaArray(content.header_thumbnails, n++, 'media_header');
      formatMediaArray(content.footer_thumbnails, ++n, 'media_footer');
    }


    $scope.closeToast = function () {
      if (isDlgOpen)
        return;

      $mdToast.hide().then(function () {
        isDlgOpen = false;
      });
    };

    /**
     * Return selected status of the thread
     *
     * @param thread
     * @returns {boolean}
     */
    function isSelected(thread) {
      return sharedFunctionsMailing.isSelected(vm.selectedThreads, thread);
    }

    function openUrl(url) {
      $window.open(url, '_blank');
    }


    function toggleSelectThread(thread, event) {
      vm.selectedThreads = sharedFunctionsMailing.toggleSelectThread(vm.selectedThreads, thread, event);
    }


    function updateThread(itemThread) {
      if ($scope.section === 'communications') {
        for (var i = 0; i < vm.threads.length; i++) {
          if (vm.threads[i]['id_mailing_communications'] == itemThread['id_mailing_communications']) {
            vm.threads[i] = itemThread;
          }
        }
      }
    }


    function deselectThreads() {
      vm.selectedThreads = sharedFunctionsMailing.deselectThreads();
    }


    function toggleSelectThreads() {
      vm.selectedThreads = sharedFunctionsMailing.toggleSelectThreads(vm.selectedThreads, vm.threads);
    }



    function changeView(view) {
      if (vm.views[view]) {
        vm.loadingView = true;
        vm.defaultView = view;
        vm.currentView = view;
      }
    }


    function viewPreview() {
      resetScroll();
      vm.editInline = false;
    }

    function resetScroll() {
      if (angular.element(document.getElementById('thread-detail')).length) {
        var elem = angular.element(document.getElementById('thread-detail'));
        elem.scrollTopAnimated(0, 10);
      }
    }

    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    function selectOrUnselect(item, $event) {
      var isRightClick = $event && $event.which == 3;
      var isDoubleClick = $event && $event.type == 'dblclick';
    };

    function openImageDialog(ev, mediazone, index) {
      $mdDialog.show({
        controller: 'MediaShowDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/dialogs/media-show/media-show-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          Images: vm.currentThread_Edit[mediazone.id_zone],
          ImageSelected: vm.currentThread_Edit[mediazone.id_zone][index],
          cropFormats: false,
          MediaFull: false,
          Tags: false
        }
      });
    }


    function duplicateCommunication() {
      for (var i = 0; i < vm.selectedThreads.length; i++) {
        var newCommunication = transformMailing.formatDuplicateCommunication(vm.selectedThreads[i]);
        var options = {
          site: $scope.siteID,
          section: $scope.section,
          item: newCommunication,
          id: 'new'
        };
        mailingService.saveItem(options).then(function (response) {
          $rootScope.pagination_resetquery();
          deselectThreads();
        });
      }
    }

    function groupDialog(structureGroup) {
      if (!structureGroup.items) {
        structureGroup.items = [];
      }
      var itemsToEdit = angular.copy(structureGroup.items);
      $mdDialog.show({
        controller: 'GroupMailingController',
        controllerAs: 'vm',
        locals: {
          items: itemsToEdit,
          modeView: 'creating',
          section: $scope.section,
          isTiny: false
        },
        templateUrl: 'app/main/apps/mailing/dialogs/group/group-mailing.html',
        parent: angular.element($document.body),
        targetEvent: 'ev',
        clickOutsideToClose: true

      }).then(function (result) {
        if (result) {
          structureGroup.items = result
        }
        vm.basicForm.$setDirty();
      });
    }

    function openUsersGroupsDialog() {
      $mdDialog.show({
        controller: 'UsersGroupController',
        controllerAs: 'vm',
        locals: {
          usersGroups: angular.copy(vm.usersGroups),
          selectedGroups: angular.copy(vm.currentThread_Edit.default_users_groups_json),
          isTiny: false
        },
        templateUrl: 'app/main/dialogs/users-group/users-group-view.html',
        parent: angular.element($document.body),
        targetEvent: 'ev',
        clickOutsideToClose: true,

      }).then(function (object) {
        if (object) {
          vm.currentThread_Edit.default_users_groups_json = sharedFunctionsMailing.updateUsersGroups(object.usersGroups);
          vm.currentLabels = object.labels;
          vm.basicForm.$setDirty();
        }
      });
    }


    function deleteTarget(id, index) { // TODO(Refactorizar)
      var index_user_group = vm.currentThread_Edit.default_users_groups_json.indexOf(id);
      if (index_user_group > -1) {
        vm.currentThread_Edit.default_users_groups_json.splice(index_user_group, 1);
      }
      vm.currentLabels.splice(index, 1);
      vm.basicForm.$setDirty();
    }


    function mediaDialog(ev, mediazone, item, type) {
      item.Thumbnail = [];

      $mdDialog.show({
        controller: 'MediaDialogController',
        controllerAs: 'vm',
        locals: {
          autoUpload: '',
          currentThread: item,
          section: $scope.section,
          mediazone: mediazone,
          multipleSelection: true,
          isTiny: false,
          maxAttach: undefined,
          showViews: {
            1: true,
            2: true,
            3: true,
            4: true,
            5: true,
            upload: true,
            import: true
          }
        },
        templateUrl: 'app/main/dialogs/media/media-mailing.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true

      }).then(function (item) {
        for (var i = 0; i < item.Thumbnail.length; i++) {
          if (!vm.currentThread_Edit[mediazone.id_zone]) {
            vm.currentThread_Edit[mediazone.id_zone] = [];
          }
          vm.currentThread_Edit[mediazone.id_zone].push(item.Thumbnail[i]);
        }
        vm.basicForm.$setDirty()
      });
    }



    function deleteAttachment(mediazone, index) {

      var current = vm.currentThread_Edit[mediazone.id_zone];
      var id = vm.currentThread_Edit[mediazone.id_zone][index]['id_media'];
      current.splice(index, 1);
      deleteImageStructure(mediazone, id);
      vm.basicForm.$setDirty();

    }

    function deleteImageStructure(mediazone, id) {
      for (var i = 0; i < vm.currentThread_Edit.structure_data_json.length; i++) {
        if (vm.currentThread_Edit.structure_data_json[i].type === 'media_header' && mediazone.id_zone === 'header_thumbnails') {
          for (var k = 0; k < vm.currentThread_Edit.structure_data_json[i].id_media.length; k++) {
            if (vm.currentThread_Edit.structure_data_json[i].id_media[k] === id) {
              vm.currentThread_Edit.structure_data_json[i].id_media.splice(k, 1);
            }
          }
        } else if (vm.currentThread_Edit.structure_data_json[i].type === 'media_footer' && mediazone.id_zone === 'footer_thumbnails') {
          for (var k = 0; k < vm.currentThread_Edit.structure_data_json[i].id_media.length; k++) {
            if (vm.currentThread_Edit.structure_data_json[i].id_media[k] === id) {
              vm.currentThread_Edit.structure_data_json[i].id_media.splice(k, 1);
            }
          }
        }

      }
    }

    function MediaItemRecrop(image, mediazone, index) {

      var messageConfirm = $translate.instant('CONTENT.MEDIA_ITEM_SURE_RECROP');

      var confirm = $mdDialog.confirm().title(messageConfirm).htmlContent('')
        .ariaLabel('Delete item').ok('OK').cancel('CANCEL');
      var message = $translate.instant('CONTENT.MEDIA_ITEM_FINISH_RECROP');


      $mdDialog.show(confirm).then(function () {

        var imageToSave = {
          'forceRecrop': true,
          'tags': [],
        };

        var options = {
          site: $scope.siteID,
          id: image.id_media,
          item: imageToSave
        };

        mediaService.saveMedia(options).then(function (response) {
          $mdToast.show({
            template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
            hideDelay: 5000,
            position: 'top',
            parent: '#content-container'
          });
        });
      });

    }

    function openMediaItemMetadata(ev, mediazone, index) {
      $mdDialog.show({
        controller: 'MediaItemMetadataDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/dialogs/media-item-metadata/media-item-metadata-mailing-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          ImageSelected: vm.currentThread_Edit[mediazone.id_zone][index],
        }
      }).then(function (item) {
        vm.basicForm.$setDirty()
      });
    }

    function openFocalPoint(ev, mediazone, index) {
      $mdDialog.show({
        controller: 'FocalPointDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/dialogs/media-focal-point/media-focal-point-mailing-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          ImageSelected: vm.currentThread_Edit[mediazone.id_zone][index],
        }
      }).then(function (item) {
        vm.basicForm.$setDirty()
        vm.currentThread_Edit[mediazone.id_zone][index].imageCenterRatioX = item.imageCenterRatioX;
        vm.currentThread_Edit[mediazone.id_zone][index].imageCenterRatioY = item.imageCenterRatioY;
      });
    }

    function callback(node, select, tree) {
      console.log(node, select, tree);
      //vm.default_users_groups = sharedFunctionsMailing.updateUsersGroups(angular.copy(vm.usersGroups), node);
      //vm.basicForm.$setDirty();
    };


    function deleteItemArray(array, item, field) {
      for (var i = 0; i < array.length; i++) {
        if (array[i] === item[field]) {
          array.splice(i, 1);
        }
      }
    }



    function editGroupField() {

    }

    function instantTranslate(text) {
      return $translate.instant(text);
    }

    function cancelMailingGroups(sidenavId) {
      vm.mailingGroups = angular.copyvm.cancelMailingGroups = cancelMailingGroups; (vm.copyMailingGroups);
      $mdSidenav(sidenavId).toggle();
    }

    function saveMailingGroups(sidenavId) {
      vm.copyMailingGroups = [];
      $mdSidenav(sidenavId).toggle();
      vm.currentLabelsFilter = transformMailing.getLabels(vm.mailingGroups);

      if (vm.currentLabelsFilter.length > 0) {
        var array = transformUsers.getGroupsFromLabels(vm.currentLabelsFilter);
        if (array.length === 1) {
          var copy = angular.copy(array[0]);
          array[0] = -1;
          array.push(copy);
        }
        var options = {
          site: $scope.siteID,
          section: 'communications',
          ids: array
        };
        getMailingByGroups(options);
      } else {
        resetFilters();
      }
      vm.selectedContent = undefined;

    }

    function getMailingByGroups(options) {
      mailingService.getMailingByGroups(options).then(function (response) {
        vm.threads = response.data;
        $rootScope.pagination_totalItems = response.total;
        $rootScope.pagination_total_pages = response.last_page;
      });
    }


    function getCleanMailingGroup() {
      //vm.CleanMailingGroups = transformMailing.formatNestedGroups(vm.refFilterables);
    }

    function toggleSelectGroups() {
      if (vm.selectedGroups == []) {
        ivhTreeviewMgr.selectAll(vm.CleanMailingGroups);
        vm.selectedGroups = vm.CleanMailingGroups;
      } else {
        ivhTreeviewMgr.deselectAll(vm.CleanMailingGroups);
        vm.selectedGroups = [];

      }
    }

    function toggleSelectGroup(group, event) {
      if (vm.selectedGroups) {
        vm.selectedGroups = sharedFunctionsMailing.toggleSelectThread(vm.selectedGroups, group, event);
      }
    }

    function selectGroups(key, value) {
      // Make sure the current selection is cleared
      // before trying to select new threads
      vm.selectedGroups = [];

      for (var i = 0; i < vm.threads.length; i++) {
        if (angular.isUndefined(key) && angular.isUndefined(value)) {
          vm.selectedGroups.push(vm.threads[i]);
          continue;
        }

        if (angular.isDefined(key) && angular.isDefined(value) && vm.threads[i][key] === value) {
          vm.selectedGroups.push(vm.threads[i]);
        }
      }
    }

    function unselectGroups() {
      vm.selectedGroup = false;
      vm.selectedContent = false;
      $rootScope.pagination_groupIds = false;
      var elemList = document.querySelectorAll('.group-row');
      elemList.forEach(function (elem) {
        elem.classList.remove('selected');
      });
      loadAllGroups();
    }

    function loadAllGroups() {
      $scope.isLoading = true;
      var options = {
        siteID: $scope.siteID,
        section: 'communications',
        sortDir: $rootScope.sortDir,
        sortField: $rootScope.sortField
      };
      mailingService.get(options).then(function (response) {
        vm.threads = response.data;
        $rootScope.pagination_totalItems = response.total;
        $rootScope.pagination_total_pages = response.last_page;
        $rootScope.pagination_page = response.current_page;
        $scope.isLoading = false;
      });
    }

    function toggleIncludeSubgroups() {
      vm.filterGroups.includeSubgroups = !vm.filterGroups.includeSubgroups;
      var element = $(".sidenav-groups #treeview-group-" + vm.selectedGroup.id_group);
      mailingService.triggerGroupsFilter(element.attr("data-group-node"), vm.filterGroups.includeSubgroups);
    }

    function loadMailingByGroups(groups) {
      $scope.isLoading = true;
      var groupIds = [];
      angular.forEach(groups, function (group) {
        groupIds.push(group.id_group);
      });
      vm.selectedGroup = groups[0];
      var options = {
        siteID: $scope.siteID,
        section: 'communications',
        groupIds: groupIds,
        sortDir: $rootScope.sortDir,
        sortField: $rootScope.sortField
      };
      mailingService.get(options).then(function (response) {
        $rootScope.pagination_groupIds = groupIds;
        vm.threads = response.data;
        $rootScope.pagination_totalItems = response.total;
        $rootScope.pagination_total_pages = response.last_page;
        $rootScope.pagination_page = response.current_page;
        $scope.isLoading = false;
      });
    }

    $scope.$on('loadGroupsFilter', function (event, groups) {
      if (groups) {
        loadMailingByGroups(groups);
      } else {
        unselectGroups();
      }
    });


    $scope.fonts = [
      {
        value: 'Arial, Helvetica, sans-serif',
        label: 'Arial',
        selected: 'true'
      },
      {
        value: 'Tahoma, Geneva, sans-serif',
        label: 'Tahoma',
        selected: 'false'
      },
      {
        value: 'Georgia, serif',
        label: 'Georgia',
        selected: 'false'
      },
      {
        value: '"Times New Roman", Times, serif',
        label: 'Times New Roman',
        selected: 'false'
      },
      {
        value: 'Impact, Charcoal, sans-serif',
        label: 'Impact',
        selected: 'false'
      },
      {
        value: '"Lucida Sans Unicode", "Lucida Grande", sans-serif',
        label: 'Lucida',
        selected: 'false'
      },
      {
        value: '"Trebuchet MS", Helvetica, sans-serif',
        label: 'Trebuchet',
        selected: 'false'
      },
      {
        value: 'Verdana, Geneva, sans-serif',
        label: 'Verdana',
        selected: 'false'
      },
      {
        value: '"Courier New", Courier, monospace',
        label: 'Courier New',
        selected: 'false'
      },
      {
        value: '"Lucida Console", Monaco, monospace',
        label: 'Lucida Console',
        selected: 'false'
      }
    ];
    $scope.selectedFont = '';
    $scope.change = function (option) {
      $scope.selectedFont = option.value;
    }

    function showDesignView($event) {
      $mdDialog.show({
        controller: 'TemplateBuilderController',
        controllerAs: 'vm',
        locals: {
          currentContent: vm.currentThread_Edit,
          currentEmail: vm.currentThread_Edit.structure_mjml,
          emailName: vm.currentThread_Edit.name,
          disabledElements: [],
          section: section,
          split: "",
          mailingToContent: false
        },
        templateUrl: 'app/main/plugins/template-builder/template-builder.html',
        parent: angular.element($document.body),
        targetEvent: $event,
        clickOutsideToClose: true,
        multiple: true
      }).then(function (item) {
        if(item){
          vm.currentThread_Edit.structure_mjml = item
        }
      });

    }

    /**
     * Multiple comma separated chips to add
     */
    $scope.addChips = function (chips, model) {
      if(chips && chips.indexOf(';')){
        var chipsArray = chips.split(';');
      }else{
        var chipsArray = chips.split(',');
      }
      angular.forEach(chipsArray, function (chip) {
        model.push(chip);
      });
      return null;
    };
    /**
     * Validate emails in Chips
     */
    $scope.validateEmail = function (emails) {
      for (var i = 0; i < emails.length; i++) {
        emails[i] = emails[i].toLowerCase();
        var reg = /^(([^<>()\[\]\\.,;:\s@\"]+(\.[^<>()\[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!reg.test(emails[i])) {
          this.invalidEmail = true;
          // remove last invalid email address :)
          emails.splice(i, 1);
        }
        else {
          this.invalidEmail = false;
        }
      }
    };





  }

})();

(function () {
  'use strict';

  angular
    .module('app.mailing')
    .factory('mailingToContentService', mailingToContentService);

  /** @ngInject */
  function mailingToContentService(mailingToContentMap, mailingToContentStyleKeys) {

    return {
      collectElements: collectElements,
      buildBlocks: buildBlocks,
      collectZoneItems: collectZoneItems,
      buildHeaderFields: buildHeaderFields,
      renderBlockHtml: renderBlockHtml
    };

    /**
     * HTML de un bloque canónico, replicando el marcado que genera qiupreview
     * (Application_V2_Model_CanonicalBlocks + WidgetsService), para que el CSS del
     * sitio lo estilice igual en la previsualización.
     *
     * Clases: la base del tipo + " size-<N>", que es lo que el renderer concatena
     * automáticamente cuando el bloque trae `size`.
     *
     * OJO: esto duplica el marcado que vive en qiupreview. Es temporal, para poder
     * previsualizar sin depender del backend; el plan acordado es sustituirlo por un
     * endpoint que devuelva el HTML ya renderizado y así no puedan divergir.
     */
    function renderBlockHtml(block) {
      if (!block || !block.type) {
        return '';
      }
      var size = block.size ? ' size-' + block.size : '';
      var style = inlineStyle(block.style);
      var text = block.text || '';

      switch (block.type) {
        case 'text':
          return '<div class="article-text' + size + '"' + style + '><p>' + text + '</p></div>';

        case 'title':
          return '<div class="article-title' + size + '"' + style + '>' +
            '<h3>' + (block.subtitle || '') + '</h3><p>' + text + '</p></div>';

        case 'image':
          var media = (block.media && block.media[0]) || {};
          var src = media.imageUrlOriginal || '';
          var caption = media.caption
            ? '<figcaption><span class="image-caption">' + media.caption + '</span></figcaption>'
            : '';
          return '<figure class="img' + size + '"' + style + '>' +
            (src ? '<img class="img" src="' + src + '">' : '') + caption + '</figure>';

        case 'divider':
          return '<hr class="divider' + size + '"' + style + '>';

        case 'button':
          return '<div class="article-button' + size + '"' + style + '>' +
            '<a class="button" href="' + (block.link || '#') + '">' + text + '</a></div>';

        case 'code':
          return '<div class="article-code' + size + '"' + style + '>' + text + '</div>';

        case 'legal':
          return '<div class="article-legal' + size + '"' + style + '>' + text + '</div>';

        default:
          // Tipos sin plantilla canónica (social, previewInBrowser…): marcador neutro.
          return '<div class="article-block' + size + '"' + style + '>' + text + '</div>';
      }
    }

    /** Estilo en línea del bloque, con el mismo criterio que las plantillas. */
    function inlineStyle(style) {
      if (!style) {
        return '';
      }
      var css = '';
      if (style.backgroundColor) {
        css += 'background-color:' + style.backgroundColor + ';';
      }
      if (style.color) {
        css += 'color:' + style.color + ';';
      }
      if (angular.isArray(style.padding) && style.padding.length === 4) {
        css += 'padding:' + style.padding.join(' ') + ';';
      }
      return css ? ' style="' + css + '"' : '';
    }

    /**
     * Elementos del mailing a convertir, en orden: header + cuerpo + footer.
     * header/footer solo si la sección destino los pide (igual que el convert clásico).
     */
    function collectElements(currentContent, section) {
      var elements = [];
      var mjml = currentContent && currentContent.structure_mjml;
      if (!mjml) {
        return elements;
      }
      if (section && section.header && mjml.header && mjml.header.elements) {
        elements = elements.concat(mjml.header.elements);
      }
      elements = elements.concat(mjml.elements || []);
      if (section && section.footer && mjml.footer && mjml.footer.elements) {
        elements = elements.concat(mjml.footer.elements);
      }
      return elements;
    }

    /**
     * Campos de cabecera del content (title←subject, lang, date…), mapeados por el
     * raw_settings de la sección. Idéntico al convert clásico: eso no cambia.
     */
    function buildHeaderFields(currentContent, section) {
      var fields = {};
      angular.forEach(section.raw_settings, function (source, target) {
        if (target === 'lang' && !currentContent[source]) {
          fields[target] = 1;
        } else {
          fields[target] = currentContent[source];
        }
      });
      return fields;
    }

    /**
     * Convierte los elementos del mailing en bloques CANÓNICOS.
     * Un elemento compuesto (imageTextLeft, imagesX3…) produce varios bloques
     * atómicos con su `size`.
     */
    function buildBlocks(elements) {
      var blocks = [];

      angular.forEach(elements, function (element) {
        if (!element || !element.options) {
          return;
        }
        // Solo se excluye si el mailing lo marca EXPLÍCITAMENTE como no exportable.
        // Muchos mails antiguos no traen la clave `exportable` (solo está en los
        // defaultOptions), y tratar "undefined" como falso vaciaba la conversión.
        if (element.options.exportable === false) {
          return;
        }
        var spec = mailingToContentMap[element.type];
        if (!spec) {
          return; // tipo sin equivalente (p. ej. 'none')
        }

        angular.forEach(spec.blocks, function (blockSpec) {
          var block = buildBlock(blockSpec, element);
          if (block) {
            blocks.push(block);
          }
        });
      });

      return blocks;
    }

    /** Construye un bloque canónico a partir de su spec y el elemento origen. */
    function buildBlock(blockSpec, element) {
      var options = element.options;
      var block = {
        type: blockSpec.type,
        size: blockSpec.size
      };

      // Textos: la spec indica de qué campo de options sale cada uno.
      if (blockSpec.subtitle && angular.isDefined(options[blockSpec.subtitle])) {
        block.subtitle = options[blockSpec.subtitle];
      }
      if (blockSpec.text && angular.isDefined(options[blockSpec.text])) {
        block.text = options[blockSpec.text];
      }
      if (blockSpec.link && angular.isDefined(options[blockSpec.link])) {
        block.link = options[blockSpec.link];
      }
      if (blockSpec.links && angular.isDefined(options[blockSpec.links])) {
        block.links = options[blockSpec.links];
      }

      // Imagen del bloque.
      if (blockSpec.media) {
        var media = buildMedia(options[blockSpec.media], options);
        if (!media) {
          return null; // hueco de imagen vacío: no generamos bloque
        }
        block.media = [media];
      }

      var style = buildStyle(options);
      if (!angular.equals(style, {})) {
        block.style = style;
      }

      return block;
    }

    /**
     * Normaliza un imageSingleN del mailing al media del bloque canónico.
     * La caption viaja en imageSingleN.fields.caption y el enlace en options.linkTo.
     */
    function buildMedia(source, options) {
      if (!source || (!source.id_media && !source.url)) {
        return null;
      }
      var media = {
        id_media: source.id_media,
        imageUrlOriginal: source.url
      };
      if (source.fields && source.fields.caption) {
        media.caption = source.fields.caption;
      }
      if (options.linkTo && options.linkTo.link) {
        media.link_url = options.linkTo.link;
        media.link_text = options.linkTo.text;
        media.link_type = options.linkTo.type;
      }
      return media;
    }

    /** Estilo común arrastrado tal cual desde el elemento del mailing. */
    function buildStyle(options) {
      var style = {};
      angular.forEach(mailingToContentStyleKeys, function (key) {
        if (angular.isDefined(options[key]) && options[key] !== null && options[key] !== '') {
          style[key] = options[key];
        }
      });
      return style;
    }

    /**
     * Medias que van a ZONAS de la sección (no al cuerpo), vía element.options.exportMedia.
     * Se mantiene igual que en el convert clásico para no perder esa funcionalidad.
     */
    function collectZoneItems(elements, section, zones) {
      var items = [];

      angular.forEach(elements, function (element) {
        var options = element && element.options;
        if (!options || !options.exportMedia || angular.isArray(options.exportMedia)) {
          return;
        }
        angular.forEach(options, function (value, optionKey) {
          if (optionKey.indexOf('imageSingle') === -1 || !value || !value.id_media) {
            return;
          }
          angular.forEach(options.exportMedia, function (zoneMap, exportLabel) {
            if (exportLabel !== section.label) {
              return;
            }
            angular.forEach(zoneMap, function (ignored, zoneTitle) {
              var zone = (zones || []).find(function (z) { return z.title === zoneTitle; });
              if (!zone) {
                return;
              }
              items.push({
                id_mediaFile: value.id_media,
                id_service: 2,
                id_section: section.id_section,
                id_from_section: '',
                id_zone: zone.id_zone
              });
            });
          });
        });
      });

      return items;
    }
  }
})();

(function () {
  'use strict';

  /**
   * MAPEO CANÓNICO mailing → content (unificado, válido para TODOS los tenants).
   *
   * Contexto: el convert clásico (templateToCases) traduce cada elemento del mailing
   * usando el bloque `mailing-templates` del _ref de cada sección, que apunta a
   * `template.id` PROPIOS DE CADA TENANT (en un tenant id 1 = "text", en otro
   * id 1 = "text-25"). Eso obliga a configurar cada tenant a mano y hace que el
   * multiple_texts resultante no sea portable.
   *
   * Aquí el mapeo vive en CÓDIGO, igual que los propios tipos de bloque
   * (template-builder.constants.js), que ya son comunes a todos los tenants.
   *
   * ── Contrato del bloque canónico ────────────────────────────────────────────
   *   {
   *     type:  'text' | 'title' | 'image' | 'divider' | 'button' |
   *            'social' | 'code' | 'legal' | 'previewInBrowser',
   *     size:  100 | 50 | 33 | 25,          // ancho en % de la columna
   *     subtitle?: '…',
   *     text?:     '…',
   *     media?:    [{ id_media, imageUrlOriginal, caption, link_url, link_text, link_type }],
   *     style?:    { align, padding, margin, backgroundColor, color, font, border }
   *   }
   *
   * Los tipos compuestos del mailing (imageTextLeft, imagesX3, text2x2…) se
   * "explotan" en varios bloques ATÓMICOS con su `size`. Así el renderer solo
   * necesita plantillas para el puñado de tipos atómicos, no para las 21
   * combinaciones.
   *
   * Cada entrada describe los bloques a generar. Los valores son los NOMBRES DE
   * CAMPO en element.options del mailing (no los valores).
   */

  var TEXT = function (size, textKey) {
    return { type: 'text', size: size, text: textKey };
  };
  var IMAGE = function (size, mediaKey) {
    return { type: 'image', size: size, media: mediaKey };
  };

  angular
    .module('Qiu')
    .constant('mailingToContentMap', {

      // ── Bloques simples (100% de ancho) ──────────────────────────────────
      title: { blocks: [{ type: 'title', size: 100, subtitle: 'title', text: 'subTitle' }] },
      text: { blocks: [TEXT(100, 'text')] },
      image: { blocks: [IMAGE(100, 'imageSingle1')] },
      header: { blocks: [IMAGE(100, 'imageSingle1')] },
      footerImage: { blocks: [IMAGE(100, 'imageSingle1')] },
      divider: { blocks: [{ type: 'divider', size: 100 }] },
      button: { blocks: [{ type: 'button', size: 100, text: 'buttonText', link: 'url' }] },
      social: { blocks: [{ type: 'social', size: 100, links: 'links' }] },
      code: { blocks: [{ type: 'code', size: 100, text: 'code' }] },
      previewInBrowser: { blocks: [{ type: 'previewInBrowser', size: 100, text: 'textPreview' }] },
      footerLegal: { blocks: [{ type: 'legal', size: 100, text: 'textAddress' }] },

      // ── Imagen + texto (dos columnas al 50%) ─────────────────────────────
      // El orden del array ES el orden de render.
      imageTextLeft: { blocks: [TEXT(50, 'text'), IMAGE(50, 'imageSingle1')] },
      imageTextRight: { blocks: [IMAGE(50, 'imageSingle1'), TEXT(50, 'text')] },

      // ── Rejillas de imagen + texto ───────────────────────────────────────
      imageText2x2: {
        blocks: [
          IMAGE(50, 'imageSingle1'), IMAGE(50, 'imageSingle2'),
          TEXT(50, 'text1'), TEXT(50, 'text2')
        ]
      },
      imageText3x2: {
        blocks: [
          IMAGE(33, 'imageSingle1'), IMAGE(33, 'imageSingle2'), IMAGE(33, 'imageSingle3'),
          TEXT(33, 'text1'), TEXT(33, 'text2'), TEXT(33, 'text3')
        ]
      },

      // ── Solo imágenes ────────────────────────────────────────────────────
      imagesX2: { blocks: [IMAGE(50, 'imageSingle1'), IMAGE(50, 'imageSingle2')] },
      imagesX3: {
        blocks: [IMAGE(33, 'imageSingle1'), IMAGE(33, 'imageSingle2'), IMAGE(33, 'imageSingle3')]
      },
      imagesX4: {
        blocks: [
          IMAGE(25, 'imageSingle1'), IMAGE(25, 'imageSingle2'),
          IMAGE(25, 'imageSingle3'), IMAGE(25, 'imageSingle4')
        ]
      },
      imagesX5: {
        blocks: [
          IMAGE(20, 'imageSingle1'), IMAGE(20, 'imageSingle2'), IMAGE(20, 'imageSingle3'),
          IMAGE(20, 'imageSingle4'), IMAGE(20, 'imageSingle5')
        ]
      },

      // ── Solo texto ───────────────────────────────────────────────────────
      text2x2: { blocks: [TEXT(50, 'text1'), TEXT(50, 'text2')] },
      text3x2: { blocks: [TEXT(33, 'text1'), TEXT(33, 'text2'), TEXT(33, 'text3')] }
    })

    /**
     * Claves de estilo que se arrastran tal cual desde element.options al bloque
     * canónico (bajo `style`). Son comunes a casi todos los tipos de bloque.
     */
    .constant('mailingToContentStyleKeys', [
      'align', 'padding', 'margin', 'backgroundColor', 'color', 'font', 'border'
    ]);
})();

(function ()
{
    'use strict';

    angular
        .module('app.file-manager', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.file-manager', {
            url      : '/file-manager',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/file-manager/file-manager.html',
                    controller : 'FileManagerController as vm'
                }
            },
            resolve  : {
                Documents: function (msApi)
                {
                    return msApi.resolve('fileManager.documents@get');
                }
            },
            bodyClass: 'file-manager'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/file-manager');

        // Api
        msApiProvider.register('fileManager.documents', ['app/data/file-manager/documents.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('apps.file-manager', {
            title : 'File Manager',
            icon  : 'icon-folder',
            state : 'app.file-manager',
            weight: 4
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.file-manager')
        .controller('FileManagerController', FileManagerController);

    /** @ngInject */
    function FileManagerController($mdSidenav, Documents)
    {
        var vm = this;

        // Data
        vm.accounts = {
            'creapond'    : 'johndoe@creapond.com',
            'withinpixels': 'johndoe@withinpixels.com'
        };
        vm.selectedAccount = 'creapond';
        vm.currentView = 'list';
        vm.showDetails = true;

        vm.path = Documents.data.path;
        vm.folders = Documents.data.folders;
        vm.files = Documents.data.files;
        vm.selected = vm.files[0];

        // Methods
        vm.select = select;
        vm.toggleDetails = toggleDetails;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleView = toggleView;

        //////////

        /**
         * Select an item
         *
         * @param item
         */
        function select(item)
        {
            vm.selected = item;
        }

        /**
         * Toggle details
         *
         * @param item
         */
        function toggleDetails(item)
        {
            vm.selected = item;
            toggleSidenav('details-sidenav');
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Toggle view
         */
        function toggleView()
        {
            vm.currentView = vm.currentView === 'list' ? 'grid' : 'list';
        }
    }
})();
(function () {
    'use strict';

    $(window.document).on('contextmenu', '.list-media-item', function (e) {
        var menu = $('#context-menu');

        if (e.pageX >= window.innerWidth - menu.width()) {
            e.pageX -= menu.width();
        }
        if (e.pageY >= window.innerHeight - menu.height()) {
            e.pageY -= menu.height();
        }

        var posx = 0;
        var posy = 0;

        if (!e) {
            e = window.event;
        }

        posx = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
        posy = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;

        menu.hide().css({
            left: e.pageX, top: e.pageY
            // left: posx,
            // top: posy
        }).show();

        e.preventDefault();
    });

    angular.module('app.content').controller('ContentController', ContentController);

    /** @ngInject */
    function ContentController($scope, $rootScope, $document, $mdDialog, $mdMedia,
        $mdToast, $mdSidenav, $state, msApi, requestContext, $timeout, $interval, contentService,
        msUtils, $anchorScroll, $translate, $log, sessionService, backendService, tinyMceService, $window,
        mediaService, $filter, matchCenterService, Upload, $q, indexService, $http, settingUserService) {


        var vm = this;

        vm.isAdmin = sessionService.user.is_admin;
        vm.v2editorActive = false;

        vm.contentBlocks = vm.contentBlocks || { time: Date.now(), blocks: [], version: '2.0.0' };

        vm.editorConfig = {
            placeholder: 'Escribe aquí...',
            // tools: puedes sobreescribir o añadir opciones por instancia
        };

        vm.hasProp = msUtils.hasProp;

        $scope.array = [
            {
                active: true,
                value: 'Copy'
            }, {
                active: true,
                value: 'Cut'
            }, {
                active: false,
                value: 'Paste'
            }
        ];

        // Data

        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg', 'red-bg', 'yellow-bg', 'light-blue-bg'];
        vm.selectedAccount = 'creapond';

        // vm.folders = Folders.data;
        // vm.labels = Labels.data;
        vm.folders = [];
        vm.labels = [];
        vm.translationRef = [];
        vm.loadingThreads = true;
        vm.enterfirst = true;
        vm.tags = sessionService.site_operative.tags;
        vm.searchTagText = null;
        vm.selectedTag = null;
        vm.searchContentText = {};
        vm.selectedContentText = {};
        vm.createFilterFor = createFilterFor;
        vm.createFilterForSection = createFilterForSection;
        vm.selectedItemChange = selectedItemChange;
        vm.selectedContentChange = selectedContentChange;
        vm.openSelectContentDialog = openSelectContentDialog;
        vm.getElementsSelectedByGroup = getElementsSelectedByGroup;
        vm.deleteElementInGroup = deleteElementInGroup;
        vm.openMenu = openMenu;
        vm.applyFilters = applyFilters;
        vm.resetFilters = resetFilters;
        vm.createExpandTemplate = createExpandTemplate;
        vm.getColumns = getColumns;
        vm.calcColumns = calcColumns;

        vm.scrollEl = angular.element('#thread-list')[0];

        vm.currentFilter = {
            type: $state.params.type,
            filter: $state.params.filter
        };
        vm.currentThread = null;
        vm.currentThread_Edit = null;
        vm.thumbnails_Edit = {};
        vm.selectedThreads = [];
        vm.basicForm = {};

        vm.sortableOptions = {};

        vm.labelQuerySearch = labelQuerySearch;
        vm.labelQuerySearchSection = labelQuerySearchSection;

        vm.initSectionMulti = initSectionMulti;

        vm.iconikTagsState = {};
        vm.initIconikTags = initIconikTags;
        vm.toggleIconikKey = toggleIconikKey;
        vm.toggleIconikTag = toggleIconikTag;
        vm.isIconikKeyEnabled = isIconikKeyEnabled;
        vm.isIconikTagEnabled = isIconikTagEnabled;
        vm.toggleAllIconikTags = toggleAllIconikTags;

        // vm.views = {
        // 	classic: 'app/main/apps/content/views/classic/classic-view.html',
        // 	outlook: 'app/main/apps/content/views/outlook/outlook-view.html'
        // };
        // vm.defaultView = 'outlook';
        // vm.currentView = 'outlook';

        vm.views = {
            nosplit: 'app/main/apps/content/views/list/nosplit-view.html',
            split: 'app/main/apps/content/views/list/split-view.html',
            grid: 'app/main/apps/content/views/grid/grid-view.html',
            // Vista tipo Excel: edición inline de todas las columnas de la sección.
            // Opt-in por tenant (contentGrid.enabled en qiu_config public); ver
            // vm.contentGridEnabled.
            spreadsheet: 'app/main/apps/content/views/list/spreadsheet-view.html'
        };
        vm.contentGridEnabled = false;
        vm.defaultView = 'split';
        vm.currentView = 'split';
        vm.loadingView = true;

        vm.mediaZones = [];

        // Methods
        vm.init = init;
        vm.getInArray = msUtils.getInArray;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.toggleInGroup = msUtils.toggleInGroup;
        vm.getReferencesSections = contentService.getReferencesSections;
        vm.getExtension = msUtils.getExtension;
        vm.getExtensionIcon = msUtils.getExtensionIcon;
        vm.preventDefault = msUtils.preventDefault;
        vm.getValuesReferencesSections = contentService.getValuesReferencesSections;
        vm.onSectionsSelectClose = onSectionsSelectClose;

        vm.isTrueFalseChecked = isTrueFalseChecked;
        vm.toggleTrueFalseCheck = toggleTrueFalseCheck;
        vm.selectOrUnselect = selectOrUnselect;

        vm.loadFolder = loadFolder;
        vm.loadLabel = loadLabel;
        vm.isFolderActive = isFolderActive;
        vm.isLabelActive = isLabelActive;

        vm.newThread = newThread;
        vm.openThread = openThread;
        vm.closeThread = closeThread;
        vm.closeThreadEdit = closeThreadEdit;

        vm.isSelected = isSelected;
        vm.openUrl = openUrl;
        vm.toggleSelectThread = toggleSelectThread;
        vm.selectThreads = selectThreads;
        vm.deselectThreads = deselectThreads;
        vm.toggleSelectThreads = toggleSelectThreads;

        vm.setThreadStatus = setThreadStatus;
        vm.toggleThreadStatus = toggleThreadStatus;
        vm.toggleItemStatus = toggleItemStatus;
        vm.toggleItemStatusEdit = toggleItemStatusEdit;

        vm.downloadMediaOriginal = downloadMediaOriginal;
        vm.copyMediaLink = copyMediaLink;

        vm.sendPushNotification = sendPushNotification;

        vm.getLabel = getLabel;
        vm.getLabelColor = getLabelColor;
        vm.getLabelTitle = getLabelTitle;
        vm.toggleLabel = toggleLabel;
        vm.isLabelExist = isLabelExist;

        vm.changeView = changeView;
        vm.viewEditInline = viewEditInline;
        vm.viewPreview = viewPreview;
        vm.saveItem = saveItem;
        vm.massActions = massActions;
        vm.MediaItemRecrop = MediaItemRecrop;

        vm.composeDialog = composeDialog;
        vm.replyDialog = replyDialog;
        vm.openImageDialog = openImageDialog;
        vm.rssImportDialog = rssImportDialog;
        vm.openImportDialog = openImportDialog;
        vm.openFocalPoint = openFocalPoint;
        vm.openMediaItemMetadata = openMediaItemMetadata;
        vm.siteLanguages = siteLanguages;
        vm.setTinyMceContent = setTinyMceContent;
        vm.getCurrentMedia = getCurrentMedia;
        vm.getZoneCrop = getZoneCrop;
        vm.newTag = newTag;
        vm.sectionsAssoc = {};
        vm.showAssoc = showAssoc;
        vm.getShowAssoc = getShowAssoc;
        vm.getSectionRelated = getSectionRelated;
        vm.getCountries = getCountries;
        vm.showCountry = showCountry;
        vm.getShowCountries = getShowCountries;
        vm.dateFormat = sessionService.site_operative.dateFormat;
        vm.dateTimeFormat = sessionService.site_operative.dateTimeFormat;
        vm.showDate = showDate;
        vm.processHtml = processHtml;

        vm.onFilesDrop = onFilesDrop;

        vm.getThumbSrcFromMedia = mediaService.getThumbSrcFromMedia;
        vm.isArray = angular.isArray;

        vm.translate = function (text) {
            return $translate.instant(text);
        }

        vm.timeAgo = msUtils.timeAgo;
        vm.sortableOpt = sortableOpt;
        vm.isSelectedOption = isSelectedOption;
        vm.selectMedia = selectMedia;
        vm.applyExpandChanges = applyExpandChanges;
        vm.expanded = false;
        vm.deleteMedia = deleteMedia;
        vm.showDesignView = showDesignView;

        vm.elementDragged = elementDragged;

        vm.importableRefs = [];

        vm.openAiTranslate = openAiTranslate;
        // Set in init(): true when the section has fields marked for AI translation.
        // Drives the Translate buttons in both toolbars.
        vm.aiTranslateEnabled = false;

        vm.searchShowFields = searchShowFields;

        vm.openWebEditor = openWebEditor;

        vm.translationLoading = false;

        function openWebEditor(ev) {
            $mdDialog.show({
                controller: 'WebBuilderDialogController',
                controllerAs: 'vm',
                bindToController: true,
                templateUrl: 'app/main/apps/content/dialogs/web-editor/web-editor.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                escapeToClose: true,
                locals: {
                    ref: vm.currentThread_ref,
                    content: vm.currentThread_Edit
                },
                onShowing: function (scope, element) {
                    element.addClass('web-builder-dialog-wrapper');
                }
            }).then(function (resp) {
                $log.log('resp', resp);
            });
        }

        function searchShowFields(item, showFields) {
            let ret = "";
            let showFieldsArray = showFields.split('|');
            showFieldsArray.forEach(showField => {
                if (showField.startsWith('HTML')) {
                    ret = `${ret}${showField.replace('HTML', '')}`;
                } else if (item[showField]) {
                    ret = `${ret} ${item[showField]}`;
                }
            });
            return ret;
        }

        function elementDragged(movedThread) {
            let newIndex = vm.threads.findIndex(t => t[`id_${$scope.section}`] === movedThread[`id_${$scope.section}`]);

            if ($rootScope.sortDir === 'ASC') {
                updateSortValuesAscending(newIndex);
            } else {
                updateSortValuesDescending(newIndex);
            }

            function updateSortValuesAscending(newIndex) {
                vm.threads.forEach((thread, index) => {
                    let newSortValue = index + 1;
                    if (thread.sort !== newSortValue) {
                        thread.sort = newSortValue;
                        saveItemIfNeeded(thread);
                    }
                });
            }

            function updateSortValuesDescending(newIndex) {
                vm.threads.forEach((thread, index) => {
                    let newSortValue = vm.threads.length - index;
                    if (thread.sort !== newSortValue) {
                        thread.sort = newSortValue;
                        saveItemIfNeeded(thread);
                    }
                });
            }

            function saveItemIfNeeded(thread) {
                thread.id = thread[`id_${$scope.section}`];
                contentService.saveItem({
                    site: $scope.siteID,
                    section: $scope.section,
                    id: thread[`id_${$scope.section}`],
                    item: thread
                });
            }
        }


        //CASE TEXT EXPANDED

        function showDesignView($event, tab) {
            var templates = tab.raw_settings.ref.find(x => x.name == "template").options;
            var threadCopy = angular.copy(vm.currentThread);
            $mdDialog.show({
                controller: 'WebBuilderController',
                controllerAs: 'vm',
                locals: {
                    templates: templates,
                    currentWeb: threadCopy,
                    section: $scope.section
                },
                templateUrl: 'app/main/plugins/web-builder/web-builder.html',
                parent: angular.element($document.body),
                targetEvent: $event,
                clickOutsideToClose: false,
                multiple: true
            }).then(function (item) {
                //   if (item) {
                //     vm.currentThread_Edit.structure_mjml = item
                //   }
            });
        }

        function applyExpandChanges() {
            //for saveItem function
            for (var i = 0; i < vm.selectedContent_ref_tabs.length; i++) {
                var elements = getElementsSelectedByGroup(vm.selectedContent_ref_tabs[i]);
                for (var j = 0; j < elements.length; j++) {
                    var isEqual = angular.equals(elements[j], vm.currentThread_Edit.multiple_texts[j]);
                    if (!isEqual) {
                        vm.currentThread_Edit.multiple_texts[j] = elements[j];
                    }
                }
            }
        }

        function isSelectedOption(opt, item) {
            let option = opt.hasOwnProperty('value') ? opt.value : opt;
            return angular.equals(item, option);
        }

        function deleteMedia(ev, element) {
            element.media = [];
        }

        function selectMedia(ev, element) {
            var item = { Thumbnail: [] };
            $mdDialog.show({
                controller: 'MediaDialogController',
                controllerAs: 'vm',
                locals: {
                    autoUpload: '',
                    currentThread: item,
                    section: '',
                    mediazone: false,
                    isTiny: false,
                    maxAttach: 1,
                    showViews: {
                        1: true,
                        2: false,
                        3: false,
                        4: false,
                        5: false,
                        upload: false,
                        import: false
                    }
                },
                templateUrl: 'app/main/dialogs/media/media-dialog.html',
                targetEvent: ev,
                clickOutsideToClose: true,
                multiple: true
            }).then(function (response) {
                if (response.Thumbnail && angular.isArray(response.Thumbnail) && response.Thumbnail.length > 0) {
                    element.media = response.Thumbnail;
                }
            });
        }

        //CASE TEXT EXPANDED

        function applyFilters() {
            var i = 0;
            for (i in $scope.filtersToSelect) {
                $scope.refFilterables[i].selected = angular.copy($scope.filtersToSelect[i].selected);
            }
        }

        function resetFilters() {
            var i = 0;
            for (i in $scope.filtersToSelect) {
                $scope.filtersToSelect[i].selected = [];
            }
        }

        function showDate(value) {
            if (angular.isObject(value)) {
                return value.dateShow;
            }
            else if (value == '0000-00-00 00:00:00') {
                return '-';
            }
            else {
                var tz = (sessionService.site_operative.timezone || moment.tz.guess() || 'UTC').toString().trim();
                return moment.utc(value).tz(tz).format(vm.dateTimeFormat || 'DD/MM/YYYY HH:mm');
            }
        }


        vm.updateDatePicker = function (fld) {

            var utcDate = '';
            var siteDate = '';
            var value = moment.utc(vm.currentThread_Edit[fld].date).format('YYYY-MM-DD HH:mm:00');

            if (value == 'Invalid date') {
                utcDate = 'Invalid date';
                siteDate = 'Invalid date';
                vm.currentThread_Edit[fld] = {};
                vm.currentThread_Edit[fld]['value'] = '';
                vm.currentThread_Edit[fld]['date'] = '';
                vm.currentThread_Edit[fld]['dateShow'] = '';
                vm.currentThread_Edit[fld]['utcShow'] = '';
                vm.currentThread_Edit[fld]['utcDate'] = '';
            } else {
                var tz = (sessionService.site_operative.timezone || moment.tz.guess() || 'UTC').toString().trim();
                utcDate = moment.utc(value);
                siteDate = moment.utc(value).tz(tz);
                vm.currentThread_Edit[fld] = {};
                vm.currentThread_Edit[fld]['value'] = value;
                vm.currentThread_Edit[fld]['date'] = new Date(siteDate.format());
                vm.currentThread_Edit[fld]['dateShow'] = siteDate.format(vm.dateTimeFormat || 'DD/MM/YYYY HH:mm');
                vm.currentThread_Edit[fld]['utcShow'] = utcDate.format(vm.dateTimeFormat || 'DD/MM/YYYY HH:mm');
                vm.currentThread_Edit[fld]['utcDate'] = utcDate;
            }
        };


        // Bucket key inside vm.thumbnails_Edit for medias not assigned to any zone.
        // It's a real array like the zone ones so its list can be dragged to/from,
        // and so ng-sortable's ng-repeat model matches the DOM 1:1.
        var NO_ZONE_KEY = 0;
        vm.NO_ZONE_KEY = NO_ZONE_KEY;

        /**
         * Rebuilds vm.thumbnails_Edit from vm.currentThread_Edit.Thumbnail, with one
         * bucket per configured zone plus the "no zone" bucket. Every media lands in
         * exactly one bucket, so each sortable list is backed by its own array.
         */
        function buildThumbnailsByZone() {
            var byZone = {};
            byZone[NO_ZONE_KEY] = [];
            angular.forEach(vm.mediaZones, function (mz) {
                byZone[mz.id_zone] = [];
            });
            angular.forEach(vm.currentThread_Edit.Thumbnail, function (thumb) {
                var key = thumb.id_zone > 0 ? thumb.id_zone : NO_ZONE_KEY;
                if (angular.isUndefined(byZone[key])) {
                    byZone[key] = [];
                }
                byZone[key].push(thumb);
            });
            return byZone;
        }
        vm.buildThumbnailsByZone = buildThumbnailsByZone;

        /**
         * Flattens vm.thumbnails_Edit back into vm.currentThread_Edit.Thumbnail,
         * re-stamping id_zone + sort from each bucket. The buckets are the source of
         * truth (they back the sortable lists); Thumbnail is what gets saved.
         */
        function syncThumbnailsFromZones() {
            vm.currentThread_Edit.Thumbnail = [];
            angular.forEach(vm.thumbnails_Edit, function (thumbZone, idZone) {
                // forEach yields object keys as strings; NO_ZONE_KEY (0) means "no zone".
                var zoneId = (idZone * 1) || null;
                var i = 1;
                angular.forEach(thumbZone, function (data) {
                    data.id_zone = zoneId;
                    data.sort = i;
                    vm.currentThread_Edit.Thumbnail.push(data);
                    i = i + 1;
                })
            })
        }
        vm.syncThumbnailsFromZones = syncThumbnailsFromZones;

        vm.mediaSortable = {
            group: 'media',
            animation: 150,
            scroll: true,
            filter: '.no-sort',
            handle: '.media',
            ghostClass: "sort-drop",
            // Sortable uses native HTML5 drag & drop, which also fires dragover on the
            // ngf-drop containers and lights up their file-drop highlight. Flag the body
            // while sorting so that highlight can be suppressed (the ghost is enough).
            onStart: function () {
                angular.element(document.body).addClass('media-sorting');
            },
            onEnd: function (evt) {
                angular.element(document.body).removeClass('media-sorting');

                if (typeof evt.oldIndex == 'undefined' || typeof evt.newIndex == 'undefined') {
                    return;
                }

                // ng-sortable has already moved the item between the bucket arrays
                // (each list is bound to its own array). Here we only re-stamp id_zone
                // + sort from the buckets and flatten them back into Thumbnail.
                syncThumbnailsFromZones();

                vm.basicForm.$setDirty()
            }
        };

        function setTinyMceContent(event) {
            var zoneMedia = {
                1: {},
                2: {},
                3: {},
                4: {},
                5: {}
            };
            var typesMax = {
                1: 0,
                2: 0,
                3: 0,
                4: 0,
                5: 0
            };
            var currentSort = 0;
            var currentType = 0;
            for (var i = 0; i < vm.currentThread_Edit.Thumbnail.length; i++) {
                if (vm.mediaZones) {
                    if (vm.currentThread_Edit.Thumbnail[i]['id_zone'] == 1) {
                        currentSort = vm.currentThread_Edit.Thumbnail[i]['sort'];
                        if (vm.currentThread_Edit.Thumbnail[i]['media_type']) {
                            currentType = vm.currentThread_Edit.Thumbnail[i]['media_type'];
                        } else {
                            currentType = 5; // gallery
                        }
                        typesMax[currentType]++;
                        zoneMedia[currentType][typesMax[currentType]] = vm.currentThread_Edit.Thumbnail[i];
                    }
                }
                else {
                    currentSort = vm.currentThread_Edit.Thumbnail[i]['sort'];
                    if (vm.currentThread_Edit.Thumbnail[i]['media_type']) {
                        currentType = vm.currentThread_Edit.Thumbnail[i]['media_type'];
                    } else {
                        currentType = 5; // gallery
                    }
                    typesMax[currentType]++;
                    zoneMedia[currentType][typesMax[currentType]] = vm.currentThread_Edit.Thumbnail[i];

                }
            }
            return zoneMedia;
        }

        vm.tinymceOptions = tinyMceService.getOptions($scope);
        vm.tinyLines = [];
        vm.tinyEditor = null;
        vm.tinyHover = null;

        // Lock to keep hover active while interacting with the floating button
        vm.tinyHoverLock = false;

        // Called when mouse leaves the whole editor wrapper (Angular side)
        vm.onWrapperMouseLeave = function ($event) {
            // Only clear hover when it is not locked
            if (!vm.tinyHoverLock) {
                vm.tinyHover = null;
            }
        };

        vm.onAddAbove = function (hoverInfo) {
            const editor = vm.tinyEditor;
            if (!editor || !hoverInfo || !hoverInfo.id) {
                $log.warn('No editor or hover info for addAbove');
                return;
            }

            const selector = '[data-line-id="' + hoverInfo.id + '"]';
            const node = editor.dom.select(selector)[0];

            if (!node) {
                $log.warn('Node not found for addAbove line', hoverInfo.id);
                return;
            }

            // Place cursor BEFORE the block
            editor.selection.select(node);
            editor.selection.collapse(true); // true = start of node
            editor.execCommand('mceInsertParagraph'); // generate new paragraph above
            // TODO: insert your content or open menu here
        };

        vm.onAddBelow = function (hoverInfo) {
            const editor = vm.tinyEditor;
            if (!editor || !hoverInfo || !hoverInfo.id) {
                $log.warn('No editor or hover info for addBelow');
                return;
            }

            const selector = '[data-line-id="' + hoverInfo.id + '"]';
            const node = editor.dom.select(selector)[0];

            if (!node) {
                $log.warn('Node not found for addBelow line', hoverInfo.id);
                return;
            }

            // Place cursor AFTER the block
            editor.selection.select(node);
            editor.selection.collapse(false); // false = end of node
            editor.execCommand('mceInsertParagraph'); // generate new paragraph below
            // TODO: insert your content or open menu here
        };

        // This will hold the currently open template menu
        vm.tinyMenu = null;

        /**
         * Open template selection menu at the given position.
         * @param {'above'|'below'} position
         * @param {Object} hoverInfo - vm.tinyHoverTop / vm.tinyHoverBottom
         */
        vm.openTemplateMenu = function (position, hoverInfo) {
            $log.warn('hoverInfo', hoverInfo);
            // Safety check
            if (!hoverInfo || !hoverInfo.id) {
                $log.warn('No hover info to open template menu');
                return;
            }

            // Lock hover so the menu does not disappear when moving mouse
            vm.tinyHoverLock = true;

            // Compute menu position (slightly to the right of the + button)
            var offsetX = 40;  // pixels to the right of the + button
            var offsetY = 0;   // you can tweak this if needed

            vm.tinyMenu = {
                position: position,
                hoverInfo: hoverInfo,
                top: hoverInfo.top + offsetY,
                left: hoverInfo.left + offsetX
            };
        };

        /**
         * Close template selection menu.
         */
        vm.closeTemplateMenu = function () {
            vm.tinyMenu = null;
            vm.tinyHoverLock = false;
        };

        /**
         * Insert the selected template at the requested position (above/below).
         */
        vm.applyTemplate = function (template) {
            var editor = vm.tinyEditor;
            var menu = vm.tinyMenu;

            if (!editor || !menu || !menu.hoverInfo || !menu.hoverInfo.id) {
                $log.warn('No editor or menu hover info for applyTemplate');
                return;
            }

            var selector = '[data-line-id="' + menu.hoverInfo.id + '"]';
            var node = editor.dom.select(selector)[0];

            if (!node) {
                $log.warn('Node not found for template insertion', menu.hoverInfo.id);
                return;
            }

            // Place cursor at start or end depending on position
            editor.selection.select(node);
            editor.selection.collapse(menu.position === 'above');

            // Optionally create a new paragraph
            editor.execCommand('mceInsertParagraph');

            // Insert template HTML (from vm.tinyTemplates)
            editor.insertContent(template.html);

            // Close the menu (and optionally clear hover if you like)
            vm.closeTemplateMenu();
            // vm.tinyHover = null;
            // vm.tinyHoverTop = null;
            // vm.tinyHoverBottom = null;
        };

        /*
                {
                    theme                  : 'modern',
                    height                 : 500,
                    remove_script_host     : false,
                    allow_script_urls      : true,
                    convert_urls           : false,
                    // external_filemanager_path:"/scripts/filemanager/",
                    // 	filemanager_title:"Responsive Filemanager" ,
                    // 	external_plugins: { "filemanager" : "/scripts/filemanager/plugin.min.js"},
                    // external_plugins: {
                    //   "myplugin": "/scripts/plugin.js"
                    // },
                    extended_valid_elements: 'script[language|type|src|async|charset]',
                    plugins                : [
                        'qiumedia media advlist autolink lists link image charmap preview hr anchor pagebreak', 'searchreplace wordcount visualblocks visualchars code fullscreen imagetools', 'nonbreaking table contextmenu directionality', 'template paste textcolor colorpicker textpattern'
                    ],
                    toolbar1               : ' insertfile undo redo | bold italic | alignleft aligncenter alignright alignjustify | forecolor backcolor | bullist numlist outdent indent | link unlink image media | code fullscreen buttonadv qiumedia',
                    toolbar2               : '',
                    content_style          : "#tinymce { font-size: 16px;line-height:1.6;font-family:'Helvetica Neue', sans-serif; }" +
                    ".align-left { text-align:left }" +
                    ".align-center { text-align:center }" +
                    ".align-right { text-align:right }" +
                    ".size-25 { width:25% }" +
                    ".size-50 { width:50% }" +
                    ".size-75 { width:75% }" +
                    ".size-100 { width:100% }",
                    image_advtab           : true,
                    menubar                : false,
                    setup                  : function (editor) {
                        editor.on('change', function (e) {
                            if (vm.basicForm)
                                vm.basicForm.$setDirty();
                        });
                        editor.on('BeforeSetcontent', function(event){
                            var zoneMedia      = {
                                1: {},
                                2: {},
                                3: {},
                                4:  {}
                            };
                            var typesMax        = {
                                1: 0,
                                2: 0,
                                3: 0,
                                4: 0
                            };
                            var currentSort     = 0;
                            var currentType     = 0;
                            for (var i = 0; i < vm.currentThread_Edit.Thumbnail.length; i++) {
                                if (vm.currentThread_Edit.Thumbnail[i]['id_zone'] == 1) {
                                    currentSort = vm.currentThread_Edit.Thumbnail[i]['sort'];
                                    currentType = vm.currentThread_Edit.Thumbnail[i]['media_type'];
                                    typesMax[currentType]++;
                                    zoneMedia[currentType][typesMax[currentType]]  = vm.currentThread_Edit.Thumbnail[i];
                                }
                            }

                            var cont	= event.content;
                            var newCont	= cont;
                            var regex = /(\[image\|([^\]]*)\])/g;
                            var validData	= {
                                left: 'align-left',
                                center: 'align-center',
                                right: 'align-right',
                                25: 'size-25',
                                50: 'size-50',
                                75: 'size-75',
                                100: 'size-100',
                            }
                            var m;

                            while ((m = regex.exec(cont)) !== null) {
                                var expCont	= '';
                                var mediaData	= {
                                    type: '',
                                    sort: '',
                                    class: ''
                                };
                                var mediaExtra	= '';
                                // This is necessary to avoid infinite loops with zero-width matches
                                if (m.index === regex.lastIndex) {
                                    regex.lastIndex++;
                                }
                                if (m[2]) {
                                    expCont	= m[2].split('|');
                                    mediaData.type	= 'image';
                                    console.log(expCont);
                                    for (var i = 0; i < expCont.length; i++) {
                                        if (i == 0) {
                                            mediaData.sort	= expCont[i];
                                        } else {
                                            mediaExtra	= expCont[i];
                                            if (!angular.isUndefined(validData[mediaExtra])) {
                                                mediaData.class	+= validData[mediaExtra] + ' ';
                                            }
                                        }
                                    }
                                    var newHtml = '<div class="qiumedia" data-qiumedia="' + m[0].substr(1,-1) + '"><img src="' + zoneMedia[1][mediaData.sort].cropstatus[0].container.view_url + zoneMedia[1][mediaData.sort].cropstatus[0].fileName + '" class="qiumedia-image ' + mediaData.class + '"></div>';
                                    newCont		= newCont.replace(m[0], newHtml);
                                    event.content = newCont;
                                }
                            }
                        });
                    }
                };
        */

        // Attachments
        vm.deleteAttachment = deleteAttachment;
        vm.mediaDialog = mediaDialog;
        vm.mediaDialogTiny = mediaDialogTiny;
        vm.renderTinyMedia = renderTinyMedia;

        vm.toggleSidenav = toggleSidenav;
        vm.isNumber = isNumber;
        vm.updateThread = updateThread;

        //////////

        init();

        // $interval is not tied to the scope lifecycle, so the translation poll would keep
        // firing after navigating away from this section. The jobs themselves are safe —
        // they stay unapplied server-side and are offered again on the next visit.
        $scope.$on('$destroy', function () {
            stopTranslationPolling();
        });

        /**
         * Initialize
         */
        function init() {
            var siteID = requestContext.getParam("siteId");
            var section = requestContext.getParam("section");
            var sectionName = requestContext.getParam("name") || sessionService.getVirtualTabName(section);

            backendService.getSectionRef({ domain: siteID, section: section }).then(function (response) {
                vm.translationRef = response.filter(x => x.ai_translation);
                vm.importableRefs = response.filter(x => x.importable == true);
                vm.aiTranslateEnabled = vm.translationRef.length > 0;
                // siteID/section are passed explicitly rather than read off $scope, so this
                // does not depend on where in init() the scope fields happen to be assigned.
                // Note this queries translation_jobs, so the table must exist on the tenant.
                if (vm.aiTranslateEnabled) {
                    loadTranslationsInProgress(siteID, section);
                }
            });

            contentService.getUsersGroups({ siteID: siteID, withGroupType: true }).then(function (response) {
                delete response.$promise;
                delete response.$resolved;
                vm.usersGroups = response;
            });

            contentService.getFilters({ section: section, site: siteID }).then(function (response) {
                $scope.filtersToSelect = angular.copy(response.filters);
                var i = 0;
                for (i in $scope.filtersToSelect) {
                    switch ($scope.filtersToSelect[i].field) {
                        case "tags":
                            $scope.filtersToSelect[i].selected = [];
                            $scope.filtersToSelect[i].values = vm.tags;
                            break;
                        case "status":
                            $scope.filtersToSelect[i].values = [
                                {
                                    name: "",
                                    value: 0
                                },
                                {
                                    name: angular.copy($scope.filtersToSelect[i].name),
                                    value: 1
                                }
                            ]
                            break;
                        default:
                            $scope.filtersToSelect[i].selected = [];
                            break;
                    }
                }

                vm.mediaZones = (response.media_zones.length == 0)
                    ? null
                    : angular.copy(response.media_zones);
            });

            sessionService.setActiveSection(section).then(function () {
                vm.ActiveSection = sessionService.ActiveSection;
                // Ya sabemos si la seccion usa medias: recalculamos las columnas de la
                // rejilla (puede resolverse antes o despues de que llegue el _ref).
                rebuildGridCols();
                resolveGridAccess();
                resolveInitialView();
            });

            $scope.view_medialist = true;
            $scope.siteID = siteID;
            $scope.section = section;
            $scope.sectionName = sectionName;

            // Clave de settings de la rejilla (anchos y orden de columnas): POR SECCIÓN,
            // para que cada sección recuerde su propia configuración.
            vm.gridSettingsSection = 'content-' + section;

            // Acceso a la vista Excel. Depende de DOS cosas que llegan por su lado
            // (el qiu_config del tenant y ActiveSection), asi que se guarda lo que va
            // llegando y se decide cuando estan las dos.
            sessionService.loadDomainResourceSettings(siteID).then(function (response) {
                if (response && response.public) {
                    var publicConfig = angular.fromJson(response.public);
                    vm.gridCfg = publicConfig.contentGrid || null;
                }
                vm.gridCfgCargado = true;
                resolveGridAccess();
            }, function () {
                vm.gridCfgCargado = true;
                resolveGridAccess();
            });

            $rootScope.global.titleToolbar = '<i class="icon s20 icon-web mr-15" ng-if="node.icon"></i> <span class="hide show-gt-xs">' + $translate.instant('CONTENT.CONTENT') + '</span> <i class="mr-5 ml-5 icon s18 icon-chevron-right hide show-gt-xs"></i> ' + (sectionName || section);

            vm.isPushNotification = false;
            if (section == 'push_notification') {
                vm.isPushNotification = true;
            }

            var options = {
                site: $scope.siteID,
                section: $scope.section
            };

            // $scope.page = 1;
            // request the initial set of data
            // loadRemoteData();
            $scope.page = 1;

            if ($state.params.id) {
                // for (var i = 0; i < vm.threads.length; i++) {
                // if (vm.threads[i].id === $state.params.threadId) {
                vm.openThread(null, $state.params.id);
                // break;
                // }
                // }
            }
        }

        // La vista Excel es una eleccion EXPLICITA del usuario: los watchers de tamaño de
        // pantalla de abajo no deben pisarla (si no, al cargar o al redimensionar se
        // volvia siempre a 'split' y parecia que la vista no se guardaba).
        function viewIsLockedByUser() {
            if (vm.currentView === 'spreadsheet') { return true; }
            // Una vista resuelta a proposito (eleccion del usuario o defecto de la
            // seccion) tampoco debe pisarse, salvo split/nosplit, que SI dependen del
            // tamaño de pantalla y por eso los watchers deben seguir mandando en ellas.
            return vistaResuelta && vm.currentView !== 'split' && vm.currentView !== 'nosplit';
        }

        // Watch screen size to change view modes
        $scope.$watch(function () {
            return $mdMedia('lt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current && !viewIsLockedByUser()) {
                vm.currentView = 'nosplit';
            }
        });

        $scope.$watch(function () {
            return $mdMedia('max-width: 960px');
        }, function (big) {

            if (big && !viewIsLockedByUser()) {
                vm.currentView = 'nosplit';
            }

        }
        );

        $scope.$watch(function () {
            return $mdMedia('min-width: 960px');
        }, function (small) {

            if (small && !viewIsLockedByUser()) {
                vm.currentView = 'split';
            }

        }
        );

        $scope.$watch(function () {
            return $mdMedia('gt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current && !viewIsLockedByUser()) {
                if (vm.defaultView === 'split') {
                    vm.currentView = 'split';
                }
            }
        });

        $scope.$on('$includeContentLoaded', function (event, target) {
            $timeout(function () {
                vm.loadingView = false;
            }, 1000);
        });

        $scope.$on('pagination:loadStart', function (event) {
            // $anchorScroll();

            // Store the current scrollPos
            // vm.scrollPos = vm.scrollEl.scrollTop();

            // Scroll to the top
            // vm.scrollEl.scrollTop(0);
            if (!vm.enterfirst) {
                var elem = angular.element(document.getElementById('list-content-data'));
                elem.scrollTopAnimated(0, 10);
            }

            // angular.element("#thread-list").scrollTop=0;

            vm.enterfirst = false;

            $scope.isLoading = true;
        });

        $scope.$on('pagination:loadPage', function (event) {
            $scope.isLoading = false;
            vm.dataAlreadyLoaded = true;
        });


        // /* Push Notifications */
        function sendPushNotification(notificationData) {
            let confirmTitle = $translate.instant('CONTENT.CONFIRM_SENDING_PUSH_TITLE');
            let confirmText = $translate.instant('CONTENT.CONFIRM_SENDING_PUSH_TEXT');
            let confirm = $mdDialog.confirm()
                .title(confirmTitle)
                .textContent(confirmText)
                .ariaLabel(confirmTitle)
                .ok('OK')
                .cancel($translate.instant('CANCEL'));

            $mdDialog.show(confirm).then(function () {
                vm.sendingNotification = true;
                vm.notificationParams = {
                    project_name: "",
                    project_key_file_name: "",
                    topic_name: "",
                    target: "",
                    notification_body: notificationData.text,
                    notification_image: notificationData.Thumbnail.length ? notificationData.Thumbnail[0].container.view_url : '',
                    notification_title: notificationData.title,
                    validate_only: false
                }
                contentService.get({
                    section: 'push_notification_projects',
                    siteID: $scope.siteID,
                    resultsPerPage: 999999
                }).then(function (response) {
                    var pushProjects = response.result.data.find(x => x.id == notificationData.id_push_notification_project);
                    vm.notificationParams.project_name = pushProjects.project_name;
                    vm.notificationParams.project_key_file_name = pushProjects.project_key_file_name;
                    contentService.get({
                        section: 'push_notification_topics',
                        siteID: $scope.siteID,
                        resultsPerPage: 999999
                    }).then(function (response) {
                        vm.notificationParams.topic_name = response.result.data.find(x => x.id == notificationData.id_push_notification_topic).topic_name;
                        contentService.get({
                            section: 'push_notification_targets',
                            siteID: $scope.siteID,
                            resultsPerPage: 999999
                        }).then(function (response) {
                            vm.notificationParams.target = response.result.data.find(x => x.id == notificationData.id_push_notification_target).name;
                            contentService.sendPushNotification(vm.notificationParams).then(function (response) {
                                var campaignID = response.name.split('/');
                                notificationData.campaign_id = campaignID[campaignID.length - 1];
                                saveItem(notificationData);
                                vm.sendingNotification = false;
                            });
                        });
                    });
                });
            });
        }

        function selectedItemChange() {
            vm.searchTagText = '';
            vm.selectedTag = null;
        }

        function selectedContentChange(fieldData) {
            vm.searchContentText[fieldData.titleId] = '';
            vm.selectedContent[fieldData.titleId] = null;
        }
        function selectUserGroupChildrens(tabConfig) {
            if (tabConfig.raw_settings.ref.parents && tabConfig.raw_settings.ref.parents.length) {
                var parents = tabConfig.raw_settings.ref.parents;
                var usersGroupsReturn = [];
                for (var i = 0; i < parents; i++) {
                    var group = vm.usersGroups.find(x => x.id_group == parents[i]);
                    if (group) {
                        if (group.children && group.children.length) {
                            for (var j = 0; j < group.children.length; j++) {
                                usersGroupsReturn.push(group.children[j]);
                            }
                        } else if (i == parents.length && !usersGroupsReturn.length) {
                            return vm.usersGroups;
                        }
                    }
                }
                return usersGroupsReturn;
            } else {
                return vm.usersGroups;
            }
        }
        function openSelectContentDialog(ev, tabConfig, index, pos) {
            if (!vm.selectedContent[tabConfig.title]) {
                vm.selectedContent[tabConfig.title] = [];
            }
            if (!vm.currentThread_Edit[tabConfig.title]) {
                vm.currentThread_Edit[tabConfig.title] = [];
            }

            var existingData = null;
            if (tabConfig.raw_settings.fromSectionGroupId) {
                var existingData = _.find(vm.currentThread_Edit[tabConfig.title], function (item) {
                    return item[tabConfig.raw_settings.fromSectionGroupId] == vm.selectedGroupId;
                })
            } else {
                // Use all data since tab has no fromSectionGroupId defined
                existingData = {
                    elements: vm.currentThread_Edit[tabConfig.title]
                };
            }

            switch (tabConfig.type) {
                case 'json':
                    break;
                case 'simple-json':
                    break;
                case 'json-from-section':
                    var ref = vm['tab_' + tabConfig.raw_settings.fromSection + '_ref'];
                    break;
                case 'json-from-raw':
                    var ref = vm['tab_' + $scope.section + '_ref'];
                    break;
                case 'json-construct':
                    var ref = vm['tab_' + $scope.section + '_ref'];
                    break;
            }

            $mdDialog.show({
                controller: 'SelectContentDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/dialogs/select-content/select-content-dialog.controller.html',
                preserveScope: true,
                autoWrap: true,
                multiple: true,
                locals: {
                    siteId: $scope.siteID,
                    section: $scope.section,
                    contentSection: tabConfig.raw_settings.fromSection,
                    team: vm.currentThread_Edit,
                    title: tabConfig.raw_settings.tabName,
                    idKey: tabConfig.raw_settings.fromSectionId,
                    cropFormat: !angular.isUndefined(tabConfig.raw_settings.cropFormat) ? tabConfig.raw_settings.cropFormat : 0,
                    ref: ref,
                    index: index,
                    pos: pos,
                    isEditMode: !angular.isUndefined(index),
                    tabType: tabConfig.type,
                    dialogName: tabConfig.raw_settings.dialogName || null,
                    showName: tabConfig.raw_settings.showField,
                    valueName: tabConfig.raw_settings.valueField,
                    data: existingData ? existingData.elements : null,
                    label: tabConfig.title,
                    event: ev,
                    defaultFilters: !angular.isUndefined(tabConfig.raw_settings.filters) ? tabConfig.raw_settings.filters : undefined,
                    usersGroups: tabConfig.raw_settings.action_type == 'users_group_permissions' ? selectUserGroupChildrens(tabConfig) : undefined,
                    usersPermissions: tabConfig.raw_settings.action_type == 'users_permissions' ? vm.selectedContent.users_permissions : undefined,
                    rawSettings: tabConfig.raw_settings
                }
            }).then(function (res) {
                if (res) {
                    vm.basicForm.$setDirty();
                    if (tabConfig.raw_settings.fromSectionGroup) {
                        var group = _.find(vm['tab_' + tabConfig.raw_settings.fromSectionGroup + '_data'], function (item) {
                            return item[tabConfig.raw_settings.fromSectionGroupId] == vm.selectedGroupId;
                        })
                        findAndPush(vm.currentThread_Edit, group, res, tabConfig);
                        findAndPush(vm.selectedContent, group, res, tabConfig);
                    } else {
                        vm.currentThread_Edit[tabConfig.title] = angular.copy(res);
                        vm.selectedContent[tabConfig.title] = angular.copy(res);
                    }
                }
            })
        }

        function findAndPush(dest, group, items, tabConfig) {
            var found = false;
            dest[tabConfig.title] = _.map(dest[tabConfig.title], function (item) {
                if (item[tabConfig.raw_settings.fromSectionGroupId] == group[tabConfig.raw_settings.fromSectionGroupId]) {
                    item.elements = items;
                    found = true;
                    return item;
                }
                return item
            })
            if (!found) {
                var copy = angular.copy(group);
                copy = msUtils.toSectionRef(angular.copy(group), vm['tab_' + tabConfig.raw_settings.fromSectionGroup + '_ref']);
                copy.elements = items;
                dest[tabConfig.title].push(copy)
            }
        }


        function sortableOpt(tabConfig) {
            vm.sortableOptions[tabConfig.title] = {
                group: '.item',
                animation: 150,
                scroll: true,
                handle: '.handle',
                filter: '.no-sort',
                ghostClass: "sort-drop",
                onStart: function (evt) {
                    if (vm.selectedGroupId) {
                        vm.copyMock = angular.copy(getElementsSelectedByGroup(tabConfig));
                    } else {
                        vm.copyMock = angular.copy(vm.currentThread_Edit[tabConfig.title]);
                    }
                },
                onEnd: function (evt) {
                    if (typeof evt.oldIndex == 'undefined' || typeof evt.newIndex == 'undefined') {
                        return false
                    }
                    vm.copyMock = changePosition(evt.newIndex, evt.oldIndex, vm.copyMock);
                    if (vm.selectedGroupId) {
                        vm.currentThread_Edit[tabConfig.title] = updateElementsSelectedByGroup(tabConfig, vm.currentThread_Edit, vm.copyMock)
                    } else {
                        vm.currentThread_Edit[tabConfig.title] = vm.copyMock;
                    }
                    return false;
                }
            }
        }

        function updateElementsSelectedByGroup(tabConfig, thread, updatedElements) {
            if (tabConfig.raw_settings.fromSectionGroup) {
                if (thread[tabConfig.title]) {
                    var found = _.find(thread[tabConfig.title], function (item) {
                        return item[tabConfig.raw_settings.fromSectionGroupId] == vm.selectedGroupId
                    })
                    if (found) {
                        found.elements = updatedElements;
                    }
                }
            }
            vm.basicForm.$setDirty();
            return thread[tabConfig.title];
        }

        function changePosition(newIndex, oldIndex, array) {
            if (oldIndex < newIndex) {
                for (var i = oldIndex; i < newIndex; i++) {
                    var temp = array[i + 1];
                    array[i + 1] = array[i];
                    array[i] = temp;
                }
            }
            if (newIndex < oldIndex) {
                for (var i = oldIndex; i > newIndex; i--) {
                    var temp = array[i - 1];
                    array[i - 1] = array[i];
                    array[i] = temp;
                }
            }
            vm.basicForm.$setDirty();
            return array;
        }

        function parseColumnsValue(val) {
            if (val == null) return 0;
            if (typeof val === 'number') return val;
            const m = String(val).match(/\d+/);
            return m ? parseInt(m[0], 10) : 0;
        }

        function calcColumns(index, tab) {
            const isMultipleTexts =
                tab.field_name === 'multiple_texts' || tab.titleId === 'multiple_texts';
            if (!isMultipleTexts) return false;

            const fields = getElementsSelectedByGroup(tab) || [];

            // Acumulamos columnas hasta el índice actual
            let total = 0;
            for (let i = 0; i <= index; i++) {
                const item = fields[i];
                total += parseColumnsValue(item?.columns);
            }

            // Borde rojo si llegamos exactamente a múltiplo de 12
            return total > 0 && total % 12 === 0;
        }

        function getElementsSelectedByGroup(tabConfig) {
            if (tabConfig.raw_settings.fromSectionGroup) {
                if (vm.selectedContent[tabConfig.title]) {
                    var found = _.find(vm.selectedContent[tabConfig.title], function (item) {
                        return item[tabConfig.raw_settings.fromSectionGroupId] == vm.selectedGroupId
                    })
                    if (found) {
                        return found.elements
                    } else {
                        return [];
                    }
                }
                return [];
            } else {
                return vm.selectedContent[tabConfig.title] || [];
            }
        }

        function deleteElementInGroup(index, tab, groupid) {
            let confirmTitle = $translate.instant('CONTENT.DELETE');
            let confirmText = $translate.instant('CONTENT.DELETE_ITEM_AT_ARRAY', { index: index + 1, tab_name: tab.field_name });
            let confirm = $mdDialog.confirm()
                .title(confirmTitle)
                .textContent(confirmText)
                .ariaLabel(confirmTitle)
                .ok('OK')
                .cancel($translate.instant('CANCEL'));

            $mdDialog.show(confirm).then(function () {

                if (tab.type == 'section_data') {
                    massActions('delete', [index], tab.raw_settings.fromSection)
                    return;
                }
                if (groupid) {
                    vm.selectedContent[tab.title] = angular.copy(_.map(vm.selectedContent[tab.title], function (item) {
                        if (item[tab.raw_settings.fromSectionGroupId] == groupid) {
                            item.elements.splice(index, 1);
                        }
                        return item;
                    }));
                    vm.currentThread_Edit[tab.title] = angular.copy(_.map(vm.currentThread_Edit[tab.title], function (item) {
                        if (item[tab.raw_settings.fromSectionGroupId] == groupid) {
                            item.elements.splice(index, 1);
                        }
                        return item;
                    }));
                } else {
                    vm.selectedContent[tab.title].splice(index, 1);
                    vm.currentThread_Edit[tab.title].splice(index, 1);
                }
                vm.basicForm.$setDirty();

            });
        }

        var originatorEv;

        function openMenu($mdMenu, ev) {
            originatorEv = ev;
            $mdMenu.open(ev);
        }

        /**
         * Load folder
         *
         * @param name
         */
        function loadFolder(name) {
            // If we are already in the selected folder and
            // there is an open thread just close it
            if (vm.isFolderActive(name)) {
                // Close the current thread if open
                if (vm.currentThread) {
                    vm.closeThread();
                }

                return;
            }

            // Show loader
            $rootScope.loadingProgress = true;

            // Update the state without reloading the controller
            $state.go('app.content.threads', {
                type: null,
                filter: name
            }, { notify: false });

            // Build the API name
            var apiName = 'content.folder.' + name + '@get';

            // Make the call
            msApi.request(apiName).then(
                // Success
                function (response) {
                    // Load new threads
                    vm.threads = response.data;

                    // Set the current filter
                    vm.currentFilter = {
                        type: null,
                        filter: name
                    };

                    // Close the current thread if open
                    if (vm.currentThread) {
                        vm.closeThread();
                    }

                    // Hide loader
                    $rootScope.loadingProgress = false;
                });
        }

        function selectOrUnselect(item, $event) {
            // var indexInTemp = $scope.temps.indexOf(item);
            var isRightClick = $event && $event.which == 3;
            var isDoubleClick = $event && $event.type == 'dblclick';

            // if ($event && $event.target.hasAttribute('prevent')) {
            //     $scope.temps = [];
            //     return;
            // }
            // if (! item || (isRightClick && $scope.isSelected(item))) {
            //     return;
            // }
            // if ($event && $event.shiftKey && !(isRightClick) && !(isDoubleClick)) {
            //     var list = $scope.fileList;
            //     var indexInList = list.indexOf(item);
            //     var lastSelected = $scope.temps[0];
            //     var i = list.indexOf(lastSelected);
            //     var current = undefined;
            //     if (lastSelected && list.indexOf(lastSelected) < indexInList) {
            //         $scope.temps = [];
            //         while (i <= indexInList) {
            //             current = list[i];
            //             !$scope.isSelected(current) && $scope.temps.push(current);
            //             i++;
            //         }
            //         return;
            //     }
            //     if (lastSelected && list.indexOf(lastSelected) > indexInList) {
            //         $scope.temps = [];
            //         while (i >= indexInList) {
            //             current = list[i];
            //             !$scope.isSelected(current) && $scope.temps.push(current);
            //             i--;
            //         }
            //         return;
            //     }
            // }
            // if ($event && !(isRightClick) && !(isDoubleClick) && ($event.ctrlKey || $event.metaKey)) {
            //     $scope.isSelected(item) ? $scope.temps.splice(indexInTemp, 1) : $scope.temps.push(item);
            //     return;
            // }
            // $scope.temps = [item];
        }

        /**
         * Toggle checked status of the content
         *
         * @param content
         * @param event
         */
        function toggleTrueFalseCheck(field, event) {
            if (event) {
                event.stopPropagation();
            }

            vm.selectedContent[field] = !!vm.selectedContent[field];

            // var idx = vm.checked.indexOf(content);

            // if (idx > -1) {
            // 	vm.checked.splice(idx, 1);
            // } else {
            // 	vm.checked.push(content);
            // }
        }

        /**
         * Return checked status of the content
         *
         * @param content
         * @returns {boolean}
         */
        function isTrueFalseChecked(fieldStatus) {
            return !!fieldStatus;
            // return vm.checked.indexOf(content) > -1;
        }

        /**
         * Load label
         *
         * @param name
         */
        function loadLabel(name) {
            // Update the state without reloading the controller
            $state.go('app.content.threads', {
                type: 'label',
                filter: name
            }, { notify: false });

            // If we are already in the selected folder and
            // there is an open thread just close it
            if (vm.isLabelActive(name)) {
                // Close the current thread if open
                if (vm.currentThread) {
                    vm.closeThread();
                }

                return;
            }

            // Show loader
            $rootScope.loadingProgress = true;

            // Build the API name
            var apiName = 'content.label.' + name + '@get';

            // Make the call
            msApi.request(apiName).then(
                // Success
                function (response) {
                    // Load new threads
                    vm.threads = response.data;

                    // Set the current filter
                    vm.currentFilter = {
                        type: 'label',
                        filter: name
                    };

                    // Close the current thread if open
                    if (vm.currentThread) {
                        vm.closeThread();
                    }

                    // Hide loader
                    $rootScope.loadingProgress = false;
                });
        }

        /**
         * Is the folder with the given name active?
         *
         * @param name
         * @returns {boolean}
         */
        function isFolderActive(name) {
            return (vm.currentFilter.type === null && vm.currentFilter.filter === name);
        }

        /**
         * Is the label with the given name active?
         *
         * @param name
         * @returns {boolean}
         */
        function isLabelActive(name) {
            return (vm.currentFilter.type === 'label' && vm.currentFilter.filter === name);
        }

        /**
         * Open thread
         *
         * @param thread
         */
        function openThread(thread, id) {
            // Set the read status on the thread
            // thread.read = true;
            $scope.$safeApply(function () {

                vm.thumbnails_Edit = {};
                vm.editInline = false;
                vm.currentThread_Edit = null;
                vm.currentThread_ref = null;
            });


            if (angular.element(document.getElementById('thread-detail')).length) {
                var elem = angular.element(document.getElementById('thread-detail'));
                elem.scrollTopAnimated(0, 10);
            }
            // pagesShown = 1;
            if (thread) {
                vm.selectedContentID = thread.id;
            }
            else if (id) {
                vm.selectedContentID = id;
            }
            if (vm.selectedContentID != 'new') {
                vm.editInline = false;

                vm.loadingReadPane = true;

                $state.go('app.site_overview.content.list.thread', {
                    id: vm.selectedContentID
                }, {
                    notify: false,
                    inherit: true,
                    location: true
                });

                var options = {
                    site: $scope.siteID,
                    section: $scope.section,
                    id: vm.selectedContentID
                };

                // Se devuelve la promesa para poder encadenar cuando haga falta esperar a
                // que el item este cargado (p.ej. el modal de medias de la rejilla). Los
                // demas llamadores ignoran el retorno, asi que no les afecta.
                return contentService.getByID(options).then(function (response) {
                    $scope.$safeApply(function () {
                        vm.selectedContent = response.result;
                        vm.currentThread = response.result;
                        vm.log = response.log;
                    });
                    vm.updateThread(vm.currentThread);

                    for (var i = response.ref.length - 1; i >= 0; i--) {
                        if (response.ref[i].type.substr(0, 4) == 'date') {

                            var value = vm.selectedContent[response.ref[i].titleId];
                            if (value == '0000-00-00 00:00:00') {
                                value = moment().utc().format("YYYY-MM-DD");
                            }

                            var utcDate = moment.utc(value);

                            if (utcDate.isValid()) {
                                var tz = (sessionService.site_operative.timezone || moment.tz.guess() || 'UTC').toString().trim();
                                var siteDate = moment.utc(value).tz(tz);

                                vm.selectedContent[response.ref[i].titleId] = {};
                                vm.selectedContent[response.ref[i].titleId]['value'] = value;
                                vm.selectedContent[response.ref[i].titleId]['date'] = new Date(siteDate.format());
                                vm.selectedContent[response.ref[i].titleId]['dateShow'] = siteDate.format(vm.dateTimeFormat || 'DD/MM/YYYY HH:mm');
                                vm.selectedContent[response.ref[i].titleId]['utcShow'] = utcDate.format(vm.dateTimeFormat || 'DD/MM/YYYY HH:mm');
                                vm.selectedContent[response.ref[i].titleId]['utcDate'] = utcDate;
                            }
                        }

                        else if (response.ref[i].type == 'sectionmulti') {
                            try {
                                var sectionMultiData = angular.fromJson(vm.selectedContent[response.ref[i].titleId]);
                                if (!angular.isUndefined(sectionMultiData.items)) {
                                    vm.selectedContent[response.ref[i].titleId] = sectionMultiData.items;
                                } else {
                                    vm.selectedContent[response.ref[i].titleId] = [];
                                }
                            } catch (e) {
                                vm.selectedContent[response.ref[i].titleId] = [];
                            }
                        }
                        else if ((response.ref[i].type == 'json' || response.ref[i].type == 'simple-json' || response.ref[i].type == 'json-from-section' || response.ref[i].type == 'json-from-raw' || response.ref[i].type == 'json-construct') && vm.selectedContent[response.ref[i].title]) {
                            vm.selectedContent[response.ref[i].title] = JSON.parse(vm.selectedContent[response.ref[i].title])
                        }
                    }
                    vm.selectedContent_ref = response.ref;
                    vm.selectedContent_ref_tabs = _.filter(response.ref, function (x) {
                        return x.category == 'tab'
                    });
                    vm.selectedContent_ref_tabs = _.map(vm.selectedContent_ref_tabs, function (x) {
                        x.raw_settings = JSON.parse(x.raw_settings);
                        return x;
                    });
                    fetchTabsData(vm.selectedContent_ref_tabs);
                    vm.selectedContent_refgrouped = _.groupBy(response.ref, function (m) {
                        return m.preview_position;
                    });
                    vm.loadingReadPane = false;
                })
                    .then(function () {
                        contentService.getTags(options).then(function (response) {
                            if (!angular.equals(vm.tags, response.tags)) {
                                vm.tags = angular.copy(response.tags);
                                sessionService.site_operative.tags = vm.tags;
                            }
                        });
                    });
            }
        }

        function fetchTabsData(tabs) {
            for (var i = 0; i < tabs.length; i++) {
                const tab = tabs[i];
                if (tab.type == 'json' || tab.type == 'json-from-section') {
                    var options = {
                        siteID: $scope.siteID,
                        per_page: 99999,
                        section: tab.raw_settings.fromSection
                    };
                    contentService.get(options).then(function (res) {
                        vm['tab_' + tab.raw_settings.fromSection + '_data'] = res.result.data;
                        vm['tab_' + tab.raw_settings.fromSection + '_ref'] = res.ref;
                    })
                    if (tab.raw_settings.fromSectionGroup) {
                        var options = {
                            siteID: $scope.siteID,
                            per_page: 99999,
                            section: tab.raw_settings.fromSectionGroup
                        };
                        contentService.get(options).then(function (res) {
                            vm['tab_' + tab.raw_settings.fromSectionGroup + '_data'] = res.result.data;
                            vm['tab_' + tab.raw_settings.fromSectionGroup + '_ref'] = res.ref;
                        })
                    }
                } else if (tab.type == 'json-from-raw' || tab.type == 'json-construct') {
                    vm['tab_' + $scope.section + '_data'] = vm.selectedContent[tab.field_name];
                    vm['tab_' + $scope.section + '_ref'] = tab.raw_settings.ref;
                } else if (tab.type == 'section_data') {
                    var filters = {};
                    if (tab.raw_settings.filters) {
                        filters = tab.raw_settings.filters;
                    }
                    filters.section_data = {
                        field: tab.raw_settings.fromSectionDataIdField,
                        name: tab.raw_settings.fromSectionDataIdField,
                        selected: [vm.selectedContentID]
                    }
                    var options = {
                        site: $scope.siteID,
                        filters: filters
                    };
                    matchCenterService.getContentSection(options, tab.raw_settings.fromSection).then(function (response) {
                        vm.selectedContent[tab.title] = response.result.data;
                    });
                }
            }
        }

        /**
         * New thread
         *
         */
        function newThread() {
            // En la vista Excel no existe el panel de detalle donde se pinta el alta:
            // ahi el alta es la fila borrador de la propia rejilla.
            if (vm.currentView === 'spreadsheet' && vm.gridApi) {
                vm.gridApi.startNewRow();
                return;
            }
            if (angular.element(document.getElementById('thread-detail')).length) {
                var elem = angular.element(document.getElementById('thread-detail'));
                elem.scrollTopAnimated(0, 10);
            }

            vm.selectedContentID = '';
            vm.editInline = false;
            vm.loadingReadPane = true;

            $state.go('app.site_overview.content.list.thread', {
                id: ''
            }, {
                notify: false,
                inherit: true,
                location: true
            });

            var options = {
                site: $scope.siteID,
                section: $scope.section
            };

            contentService.getNew(options).then(function (response) {
                vm.selectedContent = {
                    Thumbnail: [],
                    tags: []
                };
                vm.currentThread = '';
                vm.log = [];
                for (var i = response.ref.length - 1; i >= 0; i--) {
                    if (response.ref[i].type.substr(0, 4) == 'date') {

                        var value = moment().utc().format("YYYY-MM-DD HH:mm:00");

                        var utcDate = moment.utc(value);

                        var siteDate = moment.utc(value).tz(sessionService.site_operative.timezone);

                        vm.selectedContent[response.ref[i].titleId] = {};
                        vm.selectedContent[response.ref[i].titleId]['value'] = value;
                        vm.selectedContent[response.ref[i].titleId]['date'] = new Date(siteDate.format());
                        vm.selectedContent[response.ref[i].titleId]['dateShow'] = siteDate.format(vm.dateTimeFormat);
                        vm.selectedContent[response.ref[i].titleId]['utcShow'] = utcDate.format(vm.dateTimeFormat);
                        vm.selectedContent[response.ref[i].titleId]['utcDate'] = utcDate;
                    }
                    if (response.ref[i].type == 'status' && response.ref[i].raw_settings != '') {
                        try {
                            var rawSettings = JSON.parse(response.ref[i].raw_settings);
                            vm.selectedContent[response.ref[i].titleId] = rawSettings.defaultValue ? 1 : 0;
                        } catch (e) {
                            console.error(e.message, response.ref[i].raw_settings)
                        }
                    }
                }
                vm.selectedContent_ref = response.ref;
                vm.selectedContent_ref_tabs = _.filter(response.ref, function (x) {
                    return x.category == 'tab'
                });
                vm.selectedContent_ref_tabs = _.map(vm.selectedContent_ref_tabs, function (x) {
                    x.raw_settings = JSON.parse(x.raw_settings);
                    return x;
                });
                fetchTabsData(vm.selectedContent_ref_tabs);
                vm.selectedContent_refgrouped = _.groupBy(response.ref, function (m) {
                    return m.preview_position;
                });
                vm.loadingReadPane = false;
                vm.viewEditInline();
            });
        }

        /**
         * Close thread Edit
         */
        function closeThreadEdit() {
            resetScroll();
            vm.editInline = false;
            vm.currentThread = null;
            vm.currentThread_Edit = false;
            vm.currentThread_ref = false;
            vm.selectedContentID = null;
            if (vm.currentView === 'split') {
                vm.selectedContent = false;
            }
        }

        /**
         * Close thread
         */
        function closeThread() {
            vm.editInline = false;

            vm.currentThread = null;
            vm.currentThread_Edit = false;
            vm.selectedContent = null;
            vm.selectedContentID = null;

            // Update the state without reloading the controller
            $state.go('app.site_overview.content.list', {
                type: vm.currentFilter.type,
                filter: vm.currentFilter.filter
            }, { notify: false });
        }

        /**
         * Add label chips
         *
         * @param query
         * @returns {filterFn}
         */
        function labelQuerySearch(query) {
            var ret = [];
            if (query) {
                var filteredContent = angular.copy(vm.tags.filter(vm.createFilterFor(query)));
                if (filteredContent.length > 0) {
                    ret.push({
                        id_tag: 0,
                        tag_name: "",
                        order: 1
                    });
                }
                angular.forEach(filteredContent, function (val) {
                    ret.push(val);
                })
            }
            return ret;

        }


        /**
         * Label Query Section
         *
         * @param query
         * @returns {filterFn}
         */
        function labelQuerySearchSection(fieldData, query) {
            var keyHash = fieldData.raw_settings;
            var currentFilter = [];
            if (!angular.isUndefined(vm.sectionsAssoc[keyHash])) {
                currentFilter = vm.sectionsAssoc[keyHash];
            }

            return query
                ? currentFilter.filter(vm.createFilterForSection(query))
                : [];
        }

        /**
         * Filter for chips
         *
         * @param query
         * @returns {filterFn}
         */
        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(item) {
                if (angular.isUndefined(item.tag_name)) {
                    return false;
                }
                if (!item.tag_name) {
                    return false;
                }
                if (!angular.lowercase(item.tag_name.toString()).indexOf) {
                    return false;
                }
                return angular.lowercase(item.tag_name.toString()).indexOf(lowercaseQuery) >= 0;
            };
        }

        /**
         * Filter for chips
         *
         * @param query
         * @returns {filterFn}
         */
        function createFilterForSection(query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(item) {
                if (angular.isUndefined(item.val)) {
                    return false;
                }
                if (!item.val) {
                    return false;
                }
                if (!angular.lowercase(item.val).indexOf) {
                    return false;
                }
                return angular.lowercase(item.val).indexOf(lowercaseQuery) >= 0;
            };
        }

        function initSectionMulti(fieldsData) {
            if (!angular.isArray(vm.currentThread_Edit[fieldsData.titleId])) {
                vm.currentThread_Edit[fieldsData.titleId] = [];
            } else {
                vm.currentThread_Edit[fieldsData.titleId] = angular.fromJson(vm.currentThread_Edit[fieldsData.titleId]);
            }
            vm.searchContentText[fieldsData.titleId] = '';
            vm.selectedContent[fieldsData.titleId] = null;

            vm.getShowAssoc(fieldsData);
        }

        function initIconikTags(fieldsData) {
            var titleId = fieldsData.titleId;
            var raw = vm.currentThread_Edit[titleId];
            if (raw && typeof raw === 'string') {
                try { vm.currentThread_Edit[titleId] = JSON.parse(raw); } catch (e) { vm.currentThread_Edit[titleId] = {}; }
            } else if (!raw || typeof raw !== 'object') {
                vm.currentThread_Edit[titleId] = {};
            }

            if (vm.iconikTagsState[titleId] && vm.iconikTagsState[titleId].loaded) return;

            vm.iconikTagsState[titleId] = { loading: true, loaded: false, keys: [], error: false };

            var rawSettings = fieldsData.raw_settings;
            if (rawSettings && typeof rawSettings === 'string') {
                try { rawSettings = JSON.parse(rawSettings); } catch (e) { rawSettings = {}; }
            }
            var iconikUrl = (rawSettings && rawSettings.iconikUrl)
                ? rawSettings.iconikUrl.replace(/\/$/, '')
                : '';
            if (!iconikUrl) {
                vm.iconikTagsState[titleId] = { loading: false, loaded: false, keys: [], error: true };
                return;
            }

            $http.get(iconikUrl + '/tags/keywords?limit=500').then(function (res) {
                var items = (res.data && res.data.tags) ? res.data.tags : [];
                var grouped = {};
                items.forEach(function (item) {
                    var cat = item.category || 'Unknown';
                    if (!grouped[cat]) grouped[cat] = [];
                    grouped[cat].push(item.tag);
                });
                var keys = Object.keys(grouped).sort().map(function (cat) {
                    return { name: cat, tags: grouped[cat].sort() };
                });
                vm.iconikTagsState[titleId] = { loading: false, loaded: true, keys: keys, error: false };
            }).catch(function () {
                vm.iconikTagsState[titleId] = { loading: false, loaded: false, keys: [], error: true };
            });
        }

        function isIconikKeyEnabled(titleId, keyName) {
            var val = vm.currentThread_Edit[titleId];
            return !!(val && val.hasOwnProperty(keyName));
        }

        function toggleIconikKey(titleId, key) {
            var val = vm.currentThread_Edit[titleId];
            if (!val) val = vm.currentThread_Edit[titleId] = {};
            if (val.hasOwnProperty(key.name)) {
                delete val[key.name];
            } else {
                val[key.name] = key.tags.slice();
            }
        }

        function isIconikTagEnabled(titleId, keyName, tagName) {
            var val = vm.currentThread_Edit[titleId];
            return !!(val && angular.isArray(val[keyName]) && val[keyName].indexOf(tagName) !== -1);
        }

        function toggleAllIconikTags(titleId, key) {
            var val = vm.currentThread_Edit[titleId];
            if (!val) val = vm.currentThread_Edit[titleId] = {};
            if (angular.isArray(val[key.name]) && val[key.name].length === key.tags.length) {
                val[key.name] = [];
            } else {
                val[key.name] = key.tags.slice();
            }
        }

        function toggleIconikTag(titleId, keyName, tagName) {
            var val = vm.currentThread_Edit[titleId];
            if (!val) val = vm.currentThread_Edit[titleId] = {};
            if (!angular.isArray(val[keyName])) val[keyName] = [];
            var idx = val[keyName].indexOf(tagName);
            if (idx !== -1) {
                val[keyName].splice(idx, 1);
            } else {
                val[keyName].push(tagName);
            }
        }

        /**
         * Return checked status of the content
         *
         * @param content
         * @returns {boolean}
         */
        function saveItem(content) {
            if (content.id_cases) {
                applyExpandChanges();
            }

            vm.savingProcess = true;
            $timeout(function () {
                if (vm.preventError) {
                    vm.savingProcess = false;
                    var errorMsg = $translate.instant('CONTENT.SAVING_ERROR');
                    $mdToast.show({
                        template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg">' + errorMsg + '</div></md-toast>',
                        hideDelay: 7000,
                        position: 'top center',
                        parent: '#content-container'
                    });

                }
            }, 5000)
            vm.preventError = true;
            var newContent = angular.copy(content);
            if (vm.currentThread_ref && vm.currentThread_ref.length > 0) {
                for (var i = vm.currentThread_ref.length - 1; i >= 0; i--) {
                    if (vm.currentThread_ref[i].type.substr(0, 4) == 'date') {
                        var dateField = newContent[vm.currentThread_ref[i].titleId];
                        if (dateField && dateField.value && moment(dateField.value).isValid()) {
                            newContent[vm.currentThread_ref[i].titleId] = dateField.value;
                        } else {
                            newContent[vm.currentThread_ref[i].titleId] = moment().utc().format("YYYY-MM-DD HH:mm:00");
                        }
                    }
                    else if (vm.currentThread_ref[i].type.substr(0, 4) == 'html') {
                        var newHtml = newContent[vm.currentThread_ref[i].titleId];
                        var str = newContent[vm.currentThread_ref[i].titleId];
                        var regex = /<div\b[^>]*data-qiumedia="(.*?)"(.*?)[ˆ"]*[^>]*><\/div>/g;
                        var m;
                        try {
                            while ((m = regex.exec(str)) !== null) {
                                // This is necessary to avoid infinite loops with zero-width matches
                                if (m.index === regex.lastIndex) {
                                    regex.lastIndex++;
                                }
                                if (m[0] && m[1]) {
                                    newHtml = newHtml.replace(m[0], '[' + m[1] + ']');
                                }
                                /*
                                            // The result can be accessed through the `m`-variable.
                                            m.forEach((match, groupIndex) => {
                                                console.log(`Found match, group ${groupIndex}: ${match}`);
                                            });
                                            */
                            }
                        } catch (e) {
                            console.log('err', e);
                        }
                        if (newHtml) {
                            newHtml = newHtml.replace("'", '&#39;')
                        }
                        newContent[vm.currentThread_ref[i].titleId] = newHtml;

                    }
                    else if (vm.currentThread_ref[i].type == 'sectionmulti') {
                        var sectionmultiFilters = {};
                        angular.forEach(newContent[vm.currentThread_ref[i].titleId], function (sm) {
                            sectionmultiFilters['id' + sm.id] = true;
                        })
                        newContent[vm.currentThread_ref[i].titleId] = angular.toJson({
                            'items': newContent[vm.currentThread_ref[i].titleId],
                            'filters': sectionmultiFilters
                        });

                    }
                    else if (vm.currentThread_ref[i].type == 'iconik_tags') {
                        var val = newContent[vm.currentThread_ref[i].titleId];
                        newContent[vm.currentThread_ref[i].titleId] = (val && typeof val === 'object') ? JSON.stringify(val) : (val || null);
                    }
                    else if (vm.currentThread_ref[i].type == 'json' || vm.currentThread_ref[i].type == 'simple-json' || vm.currentThread_ref[i].type == 'json-from-section' || vm.currentThread_ref[i].type == 'json-from-raw' || vm.currentThread_ref[i].type == 'json-construct') {
                        newContent[vm.currentThread_ref[i].title] = JSON.stringify(newContent[vm.currentThread_ref[i].title])
                    }
                    else if (vm.currentThread_ref[i].type == 'section_data') {
                        var items = vm.selectedContent[vm.currentThread_ref[i].title];
                        var section = vm.currentThread_ref[i].raw_settings.fromSection;
                        // TODO: Save items changes in original section.
                        delete newContent[vm.currentThread_ref[i].title];
                    }
                }
            }
            if (!content.id) {
                content.id = 'new';
            }
            vm.preventError = false;
            var options = {
                site: $scope.siteID,
                section: $scope.section,
                id: content.id,
                item: newContent
            };
            contentService.saveItem(options).then(function (response) {
                if (content.id == 'new') {
                    content.id = response.id;
                    $rootScope.pagination_resetquery();
                    vm.viewPreview();
                    vm.openThread('', response.id);
                }
                else {
                    // vm.viewPreview();
                    vm.openThread(content);
                }
                // vm.closeThreadEdit();
                if (content.migrate_top_stories) {
                    let top_stories_ref = vm.selectedContent_ref.find(x => x.category === 'top_story_migration');
                    if (top_stories_ref) {
                        let top_stories_rawSettings = JSON.parse(top_stories_ref.raw_settings);
                        let table = top_stories_rawSettings.table;
                        let item = {};
                        top_stories_rawSettings.fields.forEach(field => {
                            if (field.fromFunction) {
                                item[field.to] = vm[field.fromFunction](content);
                            } else if (field.default) {
                                item[field.to] = field.default;
                            } else {
                                let passField = content[field.from];
                                if (field.from === 'Thumbnail' && field.options && field.options.zones) {
                                    passField = [];
                                    field.options.zones.forEach(zone => {
                                        let arrayThumbs = [];
                                        if (zone.from_id_zone) {
                                            arrayThumbs = content[field.from].filter(x => x.id_zone == zone.from_id_zone);
                                        }
                                        if (zone.to_id_zone) {
                                            arrayThumbs.map(x => x.id_zone = zone.to_id_zone);
                                        } else {
                                            arrayThumbs.map(x => x.id_zone = null);
                                        }
                                        passField = [...passField, ...arrayThumbs];
                                    });
                                }
                                item[field.to] = passField;
                            }
                        });
                        contentService.newGet(
                            {
                                domain: $scope.siteID,
                                section: table,
                                filters: [
                                    {
                                        field: `id_${$scope.section}`,
                                        values: [content.id]
                                    }
                                ]
                            }
                        ).then(resp => {
                            if (resp.data && resp.data.length > 0) {
                                item.id = resp.data[0].id;
                                saveAtOtherSection(table, item);
                            } else {
                                item.id = "new";
                                if (top_stories_rawSettings.sortBy) {
                                    contentService.newGet({
                                        domain: $scope.siteID,
                                        section: table,
                                        sortField: 'sort',
                                        sortDir: "DESC",
                                        resultsPerPage: 1
                                    }).then(resp => {
                                        let sort = 0;
                                        if (resp.data && resp.data.length) {
                                            sort = resp.data[0][top_stories_rawSettings.sortBy] + 1;
                                        }
                                        item[top_stories_rawSettings.sortBy] = sort;
                                        saveAtOtherSection(table, item);
                                    });
                                } else {
                                    saveAtOtherSection(table, item);
                                }
                            }
                        });
                    }
                }
                vm.savingProcess = false;


                var message = $translate.instant('CONTENT.SAVED');
                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                    hideDelay: 5000,
                    position: 'top',
                    parent: '#content-container'
                });
                return true;
            });
        }

        function saveAtOtherSection(table, item) {
            contentService.saveItem({
                site: $scope.siteID,
                section: table,
                id: item.id,
                item: item
            }).then(resp => {
                console.log(`Saved at ${table}`, resp);
            });
        }

        function saveToSpecificSection(thread, sectionName) {
            var options = {
                site: $scope.siteID,
                section: sectionName,
                id: thread.id || 'new',
                item: angular.copy(thread)
            };
            contentService.saveItem(options).then(function (response) {
                console.log('Thread saved to section:', sectionName, response);
            });
        }

        vm.transformDateToTopStory = function (content) {
            let date = new Date(content.date.value);
            let year = date.getUTCFullYear();
            let month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
            let day = date.getUTCDate().toString().padStart(2, '0');
            let hours = date.getUTCHours().toString().padStart(2, '0');
            let minutes = date.getUTCMinutes().toString().padStart(2, '0');
            let seconds = date.getUTCSeconds().toString().padStart(2, '0');
            let transfromedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            return transfromedDate;
        }

        vm.createLink = function (content) {
            let lang = '';
            if (content.lang) {
                switch (content.lang) {
                    case 1:
                        lang = '/en';
                        break;
                }
            }
            let url = `/${$scope.section}/${content.id}_${content.title.replace(/ /g, "-")}`;
            url = url.replace(/<[^>]*>/g, "");
            // normalize diacritics (e.g. á => a, î => i, etc.)
            url = url.normalize("NFD").replace(/\p{Diacritic}/gu, "")
            return `${lang}${url}`;
        }

        function openAiTranslate() {
            let languages = Object.values(siteLanguages());
            $mdDialog.show({
                controller: 'aiTranslateController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/content/dialogs/ai-translate-dialog/ai-translate-dialog.html',
                preserveScope: true,
                locals: {
                    languages: languages,
                    siteID: $scope.siteID,
                    threads: vm.selectedThreads
                },
                parent: angular.element($document.body),
                targetEvent: 'ev',
                clickOutsideToClose: true
            }).then(function (res) {
                if (res.success && res.langs.length > 0) {
                    vm.translationLoading = true;
                    let threads = vm.selectedThreads;
                    vm.selectedThreads = [];
                    // Only the ids are needed now — the API reads each record itself — so the
                    // per-record getByID round trips this used to make are gone.
                    translateAndSaveNewContent(threads, res.langs, res.selectedProvider);
                }
            });
        }

        /*
         * ------------------------------------------------------------------
         * AI translation (asynchronous)
         * ------------------------------------------------------------------
         * We send intent only — which records, into which languages. The API reads each
         * record, works out which of its fields are marked for AI translation, translates
         * them and creates the translated record itself.
         *
         * That means the work finishes whether or not this tab stays open, so there is
         * nothing here to recover or re-apply: we poll purely to know when to refresh the
         * list. The translated records are always NEW records — a translation can never
         * overwrite an existing one.
         */

        var TRANSLATION_POLL_INTERVAL = 5000;
        // Backstop for a job the worker never picked up at all; a job that runs and fails
        // reports status 'error' itself. Measured from the row's own age (age_seconds, from
        // the API) so it does not restart on every reload, and set above the server's own
        // worst case — 2 attempts x 900s plus a visibility gap, about 45 min.
        var TRANSLATION_MAX_AGE_SECONDS = 60 * 60;

        var translationJobPoll = null;
        var pendingTranslationJobs = {};

        vm.translationsInProgress = 0;

        // vm.translationLoading drives a FULL-SCREEN BLOCKING overlay, so it is only ever on
        // while the start request itself is in flight — a second or two. Background jobs are
        // surfaced by vm.translationsInProgress, a passive badge that blocks nothing: they can
        // run for many minutes, and the operator must be able to keep working meanwhile.
        function refreshTranslationState() {
            vm.translationsInProgress = Object.keys(pendingTranslationJobs).length;
        }

        function translateAndSaveNewContent(threads, targetLangIds, provider) {
            var sourceIds = threads.map(function (thread) {
                return thread['id_' + $scope.section];
            }).filter(function (id) { return !!id; });

            if (sourceIds.length === 0 || targetLangIds.length === 0) {
                vm.translationLoading = false;
                return;
            }


            indexService.aiTextTranslateAsync({
                domain: $scope.siteID,
                section: $scope.section,
                source_ids: sourceIds,
                target_lang_ids: targetLangIds,
                translate_service: provider
            }).then(function (jobs) {
                (jobs || []).forEach(trackTranslationJob);
                if (Object.keys(pendingTranslationJobs).length > 0) {
                    showTranslationToast('CONTENT.TRANSLATIONS_QUEUED');
                }
            }).catch(function (err) {
                console.error('Could not queue translations:', err);
                showTranslationToast('CONTENT.TRANSLATION_FAILED', true);
            }).finally(function () {
                // Release the blocking overlay as soon as the work is queued; from here on the
                // passive badge carries the state.
                vm.translationLoading = false;
                refreshTranslationState();
            });
        }

        function trackTranslationJob(job) {
            var id = job && job.id_translation_job;
            if (!id || pendingTranslationJobs[id]) {
                return;
            }
            pendingTranslationJobs[id] = true;
            refreshTranslationState();
            startTranslationPolling();
        }

        function startTranslationPolling() {
            if (translationJobPoll !== null || Object.keys(pendingTranslationJobs).length === 0) {
                return;
            }
            translationJobPoll = $interval(pollTranslationJobs, TRANSLATION_POLL_INTERVAL);
        }

        function stopTranslationPolling() {
            if (translationJobPoll !== null) {
                $interval.cancel(translationJobPoll);
                translationJobPoll = null;
            }
            refreshTranslationState();
        }

        /**
         * One batched request for every outstanding job. The rows come back light — status
         * and counters, no text — so this stays cheap however large the translated fields are.
         */
        function pollTranslationJobs() {
            var ids = Object.keys(pendingTranslationJobs);
            if (ids.length === 0) {
                stopTranslationPolling();
                return;
            }
            indexService.aiTextTranslateJobs({
                domain: $scope.siteID,
                'ids[]': ids
            }).then(function (jobs) {
                var settledOk = 0;
                var failed = [];
                (jobs || []).forEach(function (job) {
                    var outcome = translationJobOutcome(job);
                    if (outcome === null) {
                        return;
                    }
                    delete pendingTranslationJobs[job.id_translation_job];
                    if (outcome === 'done') { settledOk++; } else { failed.push(job); }
                });

                if (failed.length > 0) {
                    reportTranslationFailure(failed);
                }
                if (settledOk > 0) {
                    // The records were created by the API — pull them into the list.
                    showTranslationToast('CONTENT.TRANSLATIONS_FINISHED');
                    $rootScope.pagination_resetquery();
                }
                if (Object.keys(pendingTranslationJobs).length === 0) {
                    stopTranslationPolling();
                } else {
                    refreshTranslationState();
                }
            }).catch(function (err) {
                console.error('Translation poll failed:', err);
                // The jobs carry on server-side; the next visit picks them up again.
                stopTranslationPolling();
            });
        }

        /**
         * 'done' | 'failed' | null (still running).
         */
        function translationJobOutcome(job) {
            if (job.status === 'done') {
                return 'done';
            }
            if (job.status === 'error') {
                return 'failed';
            }
            if (job.age_seconds !== null && job.age_seconds > TRANSLATION_MAX_AGE_SECONDS) {
                return 'failed';
            }
            return null;
        }

        /**
         * @param messageKey translation key
         * @param isError    red instead of green; a failure should not look like good news
         */
        function showTranslationToast(messageKey, isError) {
            $mdToast.show(
                $mdToast.simple()
                    .textContent($translate.instant(messageKey))
                    .position('top center')
                    // Reuses the app's existing toast themes from core/scss/partials/material.scss
                    // rather than introducing another one.
                    .toastClass(isError ? 'md-error-toast-theme' : 'md-success-toast-theme')
                    .hideDelay(5000)
            );
        }

        function reportTranslationFailure(jobs) {
            jobs.forEach(function (job) {
                console.error('Translation job ' + job.id_translation_job + ' failed:', job.error);
            });
            showTranslationToast('CONTENT.TRANSLATION_FAILED', true);
        }

        /**
         * Passive status only: show what this operator already has running for this section and
         * keep the list refreshing as those land. Called once on init — it is not a poll, and it
         * asks the operator for nothing.
         */
        function loadTranslationsInProgress(siteID, section) {
            indexService.aiTextTranslateJobs({
                domain: siteID,
                pending: 1,
                section: section
            }).then(function (jobs) {
                (jobs || []).forEach(trackTranslationJob);
            }).catch(function (err) {
                console.error('Could not load translations in progress:', err);
            });
        }


        /**
         * Return checked status of the content
         *
         * @param content
         * @returns {boolean}
         */
        function massActions(action, selectedIds, section) {

            if (vm.selectedThreads.length === 0 && selectedIds.length === 0) {
                return false;
            }
            let migrateIds = [];
            if (!selectedIds) {
                selectedIds = []
                for (var i = 0; i < vm.selectedThreads.length; i++) {
                    selectedIds.push(vm.selectedThreads[i].id);
                    if (vm.selectedThreads[i].migrate_top_stories) {
                        migrateIds.push(vm.selectedThreads[i].id);
                    }
                }
            }
            switch (action) {
                case 'delete':
                    if (selectedIds.length == 1) {
                        var messageConfirm = $translate.instant('CONTENT.SURE_DELETED_SINGULAR');

                        var confirm = $mdDialog.confirm().title(messageConfirm)
                            // .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' will be deleted.')
                            .ariaLabel('Delete item').ok('OK').cancel('CANCEL');
                        var message = $translate.instant('CONTENT.DELETED');
                    }
                    else {
                        var messageConfirm = $translate.instant('CONTENT.SURE_DELETED_PLURAL');

                        var confirm = $mdDialog.confirm().title(messageConfirm)
                            // .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' will be deleted.')
                            .ariaLabel('Delete item').ok('OK').cancel('CANCEL');
                        var message = $translate.instant('CONTENT.DELETED');
                    }
                    break;
                case 'duplicate':
                    if (selectedIds.length == 1) {
                        var messageConfirm = $translate.instant('CONTENT.SURE_DUPLICATED_SINGULAR');
                        var confirm = $mdDialog.confirm().title(messageConfirm)
                            // .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' will be deleted.')
                            .ariaLabel('Duplicate item').ok('OK').cancel('CANCEL');
                        var message = $translate.instant('CONTENT.DUPLICATED');
                    }
                    else {
                        var messageConfirm = $translate.instant('CONTENT.SURE_DUPLICATED_PLURAL');
                        var confirm = $mdDialog.confirm().title(messageConfirm)
                            // .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' will be deleted.')
                            .ariaLabel('Duplicate item').ok('OK').cancel('CANCEL');
                        var message = $translate.instant('CONTENT.DUPLICATED');
                    }
                    break;
                case 'recache':
                    if (selectedIds.length == 1) {
                        var messageConfirm = $translate.instant('CONTENT.SURE_RECACHE_SINGULAR');
                        var confirm = $mdDialog.confirm().title(messageConfirm)
                            // .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' will be deleted.')
                            .ariaLabel('Recache item').ok('OK').cancel('CANCEL');
                        var message = $translate.instant('CONTENT.RECACHED');
                    }
                    else {
                        var messageConfirm = $translate.instant('CONTENT.SURE_RECACHE_PLURAL');
                        var confirm = $mdDialog.confirm().title(messageConfirm)
                            // .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' will be deleted.')
                            .ariaLabel('Recache item').ok('OK').cancel('CANCEL');
                        var message = $translate.instant('CONTENT.RECACHED');
                    }
                    break;
            }


            $mdDialog.show(confirm).then(function () {

                var options = {
                    site: $scope.siteID,
                    section: section || $scope.section,
                    type: action,
                    item: selectedIds
                };

                contentService.massActions(options).then(function (response) {
                    vm.toggleSelectThreads();
                    $rootScope.pagination_resetquery();
                    vm.closeThread();
                    $mdToast.show({
                        template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                        hideDelay: 5000,
                        position: 'top',
                        parent: '#content-container'
                    });
                });

                if (migrateIds.length > 0) {
                    let options = {
                        domain: $scope.siteID,
                        section: 'top_stories',
                        filters: [
                            {
                                field: `id_${$scope.section}`,
                                value: migrateIds
                            }
                        ]
                    }
                    contentService.newGet(options).then(resp => {
                        if (resp.data && resp.data.length > 0) {
                            let topStoriesIds = [];
                            resp.data.forEach(item => {
                                topStoriesIds.push(item.id_top_stories);
                            });
                            if (topStoriesIds.length > 0) {
                                var options = {
                                    site: $scope.siteID,
                                    section: 'top_stories',
                                    type: action,
                                    item: topStoriesIds
                                };

                                contentService.massActions(options).then(function (response) {
                                    $mdToast.show({
                                        template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                                        hideDelay: 5000,
                                        position: 'top',
                                        parent: '#content-container'
                                    });
                                });
                            }
                        }
                    });
                }


            });
        }

        /**
         * Return checked status of the content
         *
         * @param content
         * @returns {boolean}
         */
        function MediaItemRecrop(image) {

            var messageConfirm = $translate.instant('CONTENT.MEDIA_ITEM_SURE_RECROP');

            var confirm = $mdDialog.confirm().title(messageConfirm).htmlContent('')
                .ariaLabel('Delete item').ok('OK').cancel('CANCEL');
            var message = $translate.instant('CONTENT.MEDIA_ITEM_FINISH_RECROP');

            var tags = [];
            angular.forEach(image.tags, function (tag) {
                tags.push(tag.id_tag);
            });
            var galleries = [];
            angular.forEach(image.galleries, function (gallery) {
                galleries.push(gallery.id_gallery);
            });


            $mdDialog.show(confirm).then(function () {

                var imageToSave = {
                    'forceRecrop': true,
                    'tags': tags,
                    'galleries': galleries
                };

                var options = {
                    site: $scope.siteID,
                    id: image.id_media,
                    item: imageToSave
                };

                mediaService.saveMedia(options).then(function (response) {
                    $mdToast.show({
                        template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                        hideDelay: 5000,
                        position: 'top',
                        parent: '#content-container'
                    });
                });
            });

        }

        $scope.closeToast = function () {
            if (isDlgOpen) {
                return;
            }

            $mdToast.hide().then(function () {
                isDlgOpen = false;
            });
        };

        /**
         * Return selected status of the thread
         *
         * @param thread
         * @returns {boolean}
         */
        function isSelected(thread) {
            return vm.selectedThreads.indexOf(thread) > -1;
        }

        /**
         * Return selected status of the thread
         *
         * @param thread
         * @returns {boolean}
         */
        function openUrl(url) {
            $window.open(url, '_blank');
        }

        /**
         * Toggle selected status of the thread
         *
         * @param thread
         * @param event
         */
        function toggleSelectThread(thread, event) {
            if (event) {
                event.stopPropagation();
            }

            if (vm.selectedThreads.indexOf(thread) > -1) {
                vm.selectedThreads.splice(vm.selectedThreads.indexOf(thread), 1);
            }
            else {
                vm.selectedThreads.push(thread);
            }
        }

        /**
         * Select threads. If key/value pair given,
         * threads will be tested against them.
         *
         * @param [key]
         * @param [value]
         */
        function selectThreads(key, value) {
            // Make sure the current selection is cleared
            // before trying to select new threads
            vm.selectedThreads = [];

            for (var i = 0; i < vm.threads.length; i++) {
                if (angular.isUndefined(key) && angular.isUndefined(value)) {
                    vm.selectedThreads.push(vm.threads[i]);
                    continue;
                }

                if (angular.isDefined(key) && angular.isDefined(value) && vm.threads[i][key] === value) {
                    vm.selectedThreads.push(vm.threads[i]);
                }
            }
        }

        /**
         * Deselect threads
         */
        function updateThread(itemThread) {
            for (var i = 0; i < vm.threads.length; i++) {
                if (vm.threads[i]['id'] == itemThread['id']) {
                    vm.threads[i] = itemThread;
                }
                // if (angular.isUndefined(key) && angular.isUndefined(value)) {
                // 	vm.selectedThreads.push(vm.threads[i]);
                // 	continue;
                // }

                // if (angular.isDefined(key) && angular.isDefined(value) && vm.threads[i][key] === value) {
                // 	vm.selectedThreads.push(vm.threads[i]);
                // }
            }
        }

        /**
         * Deselect threads
         */
        function deselectThreads() {
            vm.selectedThreads = [];
        }

        /**
         * Toggle select threads
         */
        function toggleSelectThreads() {
            if (vm.selectedThreads.length > 0) {
                vm.deselectThreads();
            }
            else {
                vm.selectThreads();
            }
        }

        /**
         * Set the status on given thread, current thread or selected threads
         *
         * @param key
         * @param value
         * @param [thread]
         * @param [event]
         */
        function setThreadStatus(key, value, thread, event) {
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if (event) {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if (thread) {
                thread[key] = value;
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if (vm.currentThread) {
                vm.currentThread[key] = value;
                return;
            }

            // Otherwise do the status update on selected threads
            for (var x = 0; x < vm.selectedThreads.length; x++) {
                vm.selectedThreads[x][key] = value;
            }
        }

        /**
         * Toggle the value of the given key on given thread, current
         * thread or selected threads. Given key value must be boolean.
         *
         * @param key
         * @param thread
         * @param event
         */
        function toggleItemStatus(thread, event, key) {

            event.stopPropagation();

            var confirm = $mdDialog.confirm().title('Are you sure want to set the item?').htmlContent('<b>This item will be changed </b>.')
                // .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' will be deleted.')
                .ariaLabel('change item').ok('OK').cancel('CANCEL');

            $mdDialog.show(confirm).then(function () {

                thread.onoff = (thread.onoff === 1)
                    ? 0
                    : 1;

                vm.threads[key].onoff = thread.onoff;

                delete thread['date'];
                var options = {
                    site: $scope.siteID,
                    section: $scope.section,
                    id: vm.threads[key].id,
                    item: thread
                };

                contentService.saveItem(options).then(function (response) {
                    // vm.viewPreview();
                    // vm.selectContent(content);
                    var message = $translate.instant('CONTENT.SAVED');

                    $mdToast.show({
                        template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                        hideDelay: 3000,
                        position: 'top',
                        parent: '#content-container',
                        theme: "success-toast"
                    });

                    return true;
                });

            }, function () {
                // alert("cancel")

            });

            return;
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if (event) {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if (thread) {
                if (typeof (thread[key]) !== 'boolean') {
                    return;
                }

                thread[key] = !thread[key];
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if (vm.currentThread) {
                if (typeof (vm.currentThread[key]) !== 'boolean') {
                    return;
                }

                vm.currentThread[key] = !vm.currentThread[key];
                return;
            }

            // Otherwise do the status update on selected threads
            for (var x = 0; x < vm.selectedThreads.length; x++) {
                if (typeof (vm.selectedThreads[x][key]) !== 'boolean') {
                    continue;
                }

                vm.selectedThreads[x][key] = !vm.selectedThreads[x][key];
            }
        }

        /**
         * Toggle the value of the given key on given thread, current
         * thread or selected threads. Given key value must be boolean.
         *
         * @param key
         * @param thread
         * @param event
         */
        function toggleItemStatusEdit(fieldName) {

            var thread = vm.currentThread_Edit[fieldName];
            thread = (thread === 1)
                ? 0
                : 1;
            vm.currentThread_Edit[fieldName] = thread;
            vm.basicForm.$setDirty()
        }

        function deleteAttachment(attachment) {
            if (!attachment) {
                return;
            }

            // Same media/gallery, regardless of how ids are typed (string vs number).
            function isSameAttachment(candidate) {
                if (!candidate) {
                    return false;
                }
                if (angular.isDefined(attachment.id_media) && attachment.id_media !== null) {
                    return candidate.id_media == attachment.id_media;
                }
                if (attachment.id_gallery > 0) {
                    return candidate.id_gallery == attachment.id_gallery;
                }
                return false;
            }

            // The views render vm.thumbnails_Edit buckets, so the removal must happen
            // there; Thumbnail is then rebuilt from the buckets (single source of truth).
            var bucketKey = attachment.id_zone > 0 ? attachment.id_zone : NO_ZONE_KEY;
            var zoneBucket = vm.thumbnails_Edit[bucketKey];

            if (zoneBucket) {
                // Filter in place: splicing inside a for loop skips items.
                var kept = zoneBucket.filter(function (candidate) {
                    return !isSameAttachment(candidate);
                });
                zoneBucket.length = 0;
                Array.prototype.push.apply(zoneBucket, kept);
            } else {
                // Fallback: bucket not found (unexpected zone) — scan every bucket.
                angular.forEach(vm.thumbnails_Edit, function (bucket) {
                    var remaining = bucket.filter(function (candidate) {
                        return !isSameAttachment(candidate);
                    });
                    bucket.length = 0;
                    Array.prototype.push.apply(bucket, remaining);
                });
            }

            syncThumbnailsFromZones();
            vm.basicForm.$setDirty()

        }

        /**
         * Toggle the value of the given key on given thread, current
         * thread or selected threads. Given key value must be boolean.
         *
         * @param key
         * @param thread
         * @param event
         */
        function toggleThreadStatus(key, thread, event) {
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if (event) {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if (thread) {
                if (typeof (thread[key]) !== 'boolean') {
                    return;
                }

                thread[key] = !thread[key];
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if (vm.currentThread) {
                if (typeof (vm.currentThread[key]) !== 'boolean') {
                    return;
                }

                vm.currentThread[key] = !vm.currentThread[key];
                return;
            }

            // Otherwise do the status update on selected threads
            for (var x = 0; x < vm.selectedThreads.length; x++) {
                if (typeof (vm.selectedThreads[x][key]) !== 'boolean') {
                    continue;
                }

                vm.selectedThreads[x][key] = !vm.selectedThreads[x][key];
            }
        }

        function downloadMediaOriginal(media) {
            switch (media.media_type) {
                case 1:
                    var url = media.container.view_url + 'original/m' + media.id_media + '_' + media.filename;

                    break;
                case 2:
                    if (media.embed_thumb) {
                        var url = media.embed_thumb;
                    }
                    else if (!media.embed && !media.embed_code && !media.embed_thumb && !media.embed_url) {
                        var url = media.container.view_url + 'videos/m' + media.id_media + '_' + media.filename;
                    }
                    break;
                case 4:
                    var url = media.container.view_url + 'files/m' + media.id_media + '_' + media.filename;

                    // vm.image.imageUrl = cropstatus.container.view_url + cropstatus.fileName;
                    break;
            }
            if (url) {
                msUtils.openUrl(url)
            }
        }

        /**
         * Copy to the clipboard the link of the highest quality crop of a media item.
         * When the media has no generated crop (videos, files, or images still being
         * processed) the original file link is copied instead.
         *
         * @param media
         */
        function copyMediaLink(media) {
            if (!media || !media.id_media) {
                return;
            }
            // The attachment carries the thumbnail cropformats only, so the whole media
            // is requested to know every crop that has been generated for it.
            mediaService.getImageByID({
                domain: requestContext.getParam("siteId"),
                id_media: media.id_media
            }).then(function (response) {
                var fullMedia = (response && angular.isArray(response.data) && response.data.length) ? response.data[0] : media;
                copyLink(getBestCropUrl(fullMedia) || getMediaOriginalUrl(fullMedia) || getMediaOriginalUrl(media));
            }, function () {
                copyLink(getMediaOriginalUrl(media));
            });
        }

        /**
         * Url of the generated crop with the highest resolution, '' when there is none.
         *
         * @param media
         * @returns {string}
         */
        function getBestCropUrl(media) {
            if (!media || !angular.isArray(media.cropstatus)) {
                return '';
            }
            var bestCrop = null;
            var bestSize = -1;
            angular.forEach(media.cropstatus, function (crop) {
                if (!crop.isCropped || !crop.fileName) {
                    return;
                }
                var cropformat = sessionService.getCropformatByID(crop.id_cropformats);
                var width = cropformat ? (cropformat.width || 0) : 0;
                var height = cropformat ? (cropformat.height || 0) : 0;
                // A cropformat is defined by its size, so its area ranks the quality.
                // Some formats only set one side, and the longest one ranks those.
                var size = (width && height) ? (width * height) : Math.pow(Math.max(width, height), 2);
                if (!size) {
                    // Unknown format: the weight of the generated file is the only hint left.
                    size = crop.fileSizeKb || 0;
                }
                if (size > bestSize) {
                    bestSize = size;
                    bestCrop = crop;
                }
            });
            if (!bestCrop) {
                return '';
            }
            var container = sessionService.getContainerByID(bestCrop.id_container);
            return (container && container.view_url) ? container.view_url + bestCrop.fileName : '';
        }

        /**
         * Url of the original uploaded file.
         *
         * @param media
         * @returns {string}
         */
        function getMediaOriginalUrl(media) {
            if (!media) {
                return '';
            }
            if (media.media_type == 2 && media.embed_thumb) {
                return media.embed_thumb;
            }
            var container = media.container || sessionService.getContainerByID(media.cdnContainer);
            if (!container || !container.view_url || !media.filename) {
                return '';
            }
            switch (media.media_type) {
                case 1:
                    return container.view_url + 'original/m' + media.id_media + '_' + media.filename;
                case 2:
                    return container.view_url + 'videos/m' + media.id_media + '_' + media.filename;
                case 4:
                    return container.view_url + 'files/m' + media.id_media + '_' + media.filename;
            }
            return '';
        }

        /**
         * Copy a link to the clipboard and tell the user about it.
         *
         * @param link
         */
        function copyLink(link) {
            if (!link) {
                showToast($translate.instant('MEDIA.LINK_NOT_AVAILABLE'), 'red-500-bg');
                return;
            }
            // The link is only known after asking the api, and execCommand('copy') is not
            // always allowed outside of the click itself, so the async api goes first.
            if ($window.navigator.clipboard && $window.navigator.clipboard.writeText) {
                $window.navigator.clipboard.writeText(link).then(function () {
                    showToast($translate.instant('GLOBAL.COPIED_TO_CLIPBOARD'), 'green-500-bg');
                }, function () {
                    copyLinkFallback(link);
                });
                return;
            }
            copyLinkFallback(link);
        }

        /**
         * Copy through a hidden textarea, and show the link so it can be copied by hand
         * when the browser refuses to write to the clipboard.
         *
         * @param link
         */
        function copyLinkFallback(link) {
            var dummy = document.createElement('textarea');
            document.body.appendChild(dummy);
            dummy.value = link;
            dummy.select();
            var copied = document.execCommand('copy');
            document.body.removeChild(dummy);
            if (copied) {
                showToast($translate.instant('GLOBAL.COPIED_TO_CLIPBOARD'), 'green-500-bg');
                return;
            }
            $mdDialog.show(
                $mdDialog.alert()
                    .title($translate.instant('MEDIA.COPY_LINK_BEST_CROP'))
                    .textContent(link)
                    .ok('OK')
            );
        }

        function showToast(message, colorClass) {
            $mdToast.show({
                template: '<md-toast layout="column" layout-align="center center"><div class="md-toast-content ' + colorClass + '"><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                hideDelay: 2000,
                position: 'top',
                parent: '#content-container'
            });
        }

        /**
         * Get label object content
         *
         * @param id
         * @returns {*}
         */
        function getLabel(id) {
            for (var i = 0; i < vm.labels.length; i++) {
                if (vm.labels[i].id === id) {
                    return vm.labels[i];
                }
            }
        }

        /**
         * Get label color from label object
         *
         * @param id
         * @returns {*}
         */
        function getLabelColor(id) {
            return vm.getLabel(id).color;
        }

        /**
         * Get label title from label object
         *
         * @param id
         * @returns {*}
         */
        function getLabelTitle(id) {
            return vm.getLabel(id).title;
        }

        /**
         * Toggle label
         *
         * @param label
         */
        function toggleLabel(label) {
            // Toggle label on the currently open thread
            if (vm.currentThread) {
                if (vm.currentThread.labels.indexOf(label.id) > -1) {
                    vm.currentThread.labels.splice(vm.currentThread.labels.indexOf(label.id), 1);
                }
                else {
                    vm.currentThread.labels.push(label.id);
                }

                return;
            }

            // Toggle labels on selected threads
            // Toggle action will be determined by the first thread from the selection.
            if (vm.selectedThreads.length > 0) {
                // Decide if we are going to remove or add labels
                var removeLabels = (vm.selectedThreads[0].labels.indexOf(label.id) > -1);

                for (var i = 0; i < vm.selectedThreads.length; i++) {
                    if (!removeLabels) {
                        vm.selectedThreads[i].labels.push(label.id);
                        continue;
                    }

                    if (vm.selectedThreads[i].labels.indexOf(label.id) > -1) {
                        vm.selectedThreads[i].labels.splice(vm.selectedThreads[i].labels.indexOf(label.id), 1);
                    }
                }
            }
        }

        /**
         * Is label exist?
         *
         * @param label
         * @returns {boolean}
         */
        function isLabelExist(label) {
            if (vm.currentThread && vm.currentThread.labels) {
                return (vm.currentThread.labels.indexOf(label.id) > -1);
            }
        }

        /**
         * Change the view
         *
         * @param view
         */
        /**
         * Decide con que vista se abre la seccion. Se llama desde dos sitios (cuando
         * llega ActiveSection y cuando llegan los flags del tenant) porque cada dato
         * viene por su lado y el orden no esta garantizado; la primera resolucion REAL
         * gana y las siguientes no hacen nada.
         *
         * Prioridad:
         *   1. La vista que eligio el usuario en esta seccion (decision explicita suya).
         *   2. El defecto configurado en la seccion: sections.default_view.
         *   3. Si no hay nada, lo de siempre (los watchers de tamaño de pantalla).
         *
         * Solo se hace caso a valores que sean una vista REAL. Asi los valores heredados
         * que hay hoy en la columna ('table', 'gallery', que no existen en content) se
         * ignoran en vez de dejar la seccion en blanco.
         */
        var vistaResuelta = false;

        function vistaDisponible(view) {
            if (!view || !vm.views[view]) { return false; }
            // La vista Excel es opt-in por tenant.
            if (view === 'spreadsheet' && !vm.contentGridEnabled) { return false; }
            return true;
        }

        function resolveInitialView() {
            if (vistaResuelta) { return; }

            var guardada = vm.gridSettingsSection
                ? settingUserService.getSettingValue(vm.gridSettingsSection, 'view', null)
                : null;
            if (vistaDisponible(guardada)) {
                vistaResuelta = true;
                vm.defaultView = guardada;
                vm.currentView = guardada;
                return;
            }

            var porDefecto = vm.ActiveSection && vm.ActiveSection.default_view;
            if (vistaDisponible(porDefecto)) {
                vistaResuelta = true;
                vm.defaultView = porDefecto;
                vm.currentView = porDefecto;
            }
        }

        function changeView(view) {
            if (vm.views[view]) {
                vm.loadingView = true;
                vm.defaultView = view;
                vm.currentView = view;
                // Recordamos la vista elegida POR SECCION, para que al volver siga la
                // misma (antes se perdia en cada recarga).
                if (vm.gridSettingsSection) {
                    settingUserService.setSetting(vm.gridSettingsSection, 'view', view);
                }
            }
        }

        // ============================================================
        //  Vista Excel / edición inline — helpers de la rejilla (<mv-grid>)
        // ============================================================
        // El armazón (tabla, anchos, resize, reordenado, persistencia) lo pone el
        // componente compartido; aquí solo va lo propio de content: qué editor toca a
        // cada tipo de campo del _ref de la sección y cómo se guarda la fila.
        // OJO: en content la clave del dato es col.titleId (el slug de `title`), NO
        // col.title —al revés que en users.
        vm.gridCellKind = gridCellKind;
        vm.gridCellDisplay = gridCellDisplay;
        vm.gridSaveRow = gridSaveRow;
        vm.ensureGridRow = ensureGridRow;
        vm.onGridDateChange = onGridDateChange;
        vm.gridEditComplexCell = gridEditComplexCell;
        vm.gridEditMedia = gridEditMedia;
        vm.gridMediaSave = gridMediaSave;
        vm.gridMediaCancel = gridMediaCancel;
        vm.gridSubsections = gridSubsections;
        vm.gridCategories = gridCategories;
        vm.gridSubcategories = gridSubcategories;

        /** Solo los administradores ven la vista Excel (edita y borra en linea). */
        function esAdmin() {
            return !!(sessionService.user && sessionService.user.is_admin);
        }

        /**
         * ¿Se ofrece la vista Excel en esta seccion? Hacen falta dos cosas:
         *   1. ser administrador,
         *   2. que la seccion la tenga activada.
         *
         * El punto 2 lo decide la columna sections.view_spreadsheet, que se enciende
         * desde Backend content: es la fuente de verdad y no hace falta tocar el
         * qiu_config del tenant.
         *
         * Para los tenants que aun no tienen esa columna se mantiene el mecanismo
         * anterior (contentGrid.enabled + su lista opcional de secciones), para no
         * romper lo que ya estaba funcionando.
         *
         * contentGrid.accounts, si existe, sigue restringiendo dentro de los admins.
         */
        function resolveGridAccess() {
            // Se espera a tener ambos: el flag del tenant y la seccion activa.
            if (!vm.gridCfgCargado || !vm.ActiveSection) { return; }

            var cfg = vm.gridCfg;
            if (!esAdmin()) {
                vm.contentGridEnabled = false;
                resolveInitialView();
                return;
            }

            var permitida;
            if (vm.ActiveSection.hasOwnProperty('view_spreadsheet')) {
                // Manda el interruptor de Backend content. Con la columna presente NO
                // hace falta tocar el qiu_config: la seccion decide y punto.
                permitida = (vm.ActiveSection.view_spreadsheet == 1);
            } else if (cfg && cfg.enabled === true) {
                // Tenant que aun no tiene la columna: se sigue honrando el flag del
                // qiu_config y su lista opcional de secciones.
                permitida = !angular.isArray(cfg.sections) ||
                            cfg.sections.indexOf($scope.section) !== -1;
            } else {
                permitida = false;
            }
            if (!permitida) {
                vm.contentGridEnabled = false;
                resolveInitialView();
                return;
            }

            // Lista opcional de cuentas: restringe aun mas dentro de los administradores.
            // OJO con el cfg &&: un tenant que use solo el interruptor de la seccion NO
            // tiene contentGrid en su qiu_config, asi que cfg es null y esto petaba.
            if (cfg && angular.isArray(cfg.accounts) && cfg.accounts.length) {
                sessionService.authenticate($scope.siteID).then(function (auth) {
                    var email = auth && auth.account && auth.account.email;
                    vm.contentGridEnabled = !!email && cfg.accounts.indexOf(email) !== -1;
                    resolveInitialView();
                }, function () {
                    resolveInitialView();
                });
                return;
            }

            vm.contentGridEnabled = true;
            resolveInitialView();
        }

        /**
         * Columnas que se le pasan a la rejilla. NO son directamente las del _ref: hay
         * que respetar el mismo criterio que el editor, que solo muestra el apartado de
         * medias si la SECCION las tiene activadas (sections.media, vm.ActiveSection.media).
         * Si no, una seccion como schedule (media = 0) enseñaba una columna Media en la
         * rejilla que no existe en el formulario.
         *
         * Se recalcula a un array NUEVO y estable: la rejilla cachea las columnas contra
         * la referencia del array, asi que devolver uno nuevo aqui la obliga a
         * reconstruirse, y solo cuando toca.
         */
        function rebuildGridCols() {
            var cols = $scope.refcolumns || [];
            vm.gridCols = cols.filter(function (c) {
                if (!c) { return false; }
                var t = c.type || '';
                var isMedia = (t === 'thumbnail' || t.indexOf('thumbnail') === 0 || t === 'media');
                if (isMedia && !(vm.ActiveSection && vm.ActiveSection.media)) { return false; }
                return true;
            });
        }
        // refcolumns lo publica qiu-pagination cuando llega el listado, y ActiveSection
        // se resuelve por su cuenta: recalculamos con cualquiera de los dos.
        $scope.$watch('refcolumns', rebuildGridCols);

        /**
         * Tipo de editor de una celda, como un único string. Los tipos son los del _ref
         * de la sección (section_<x>_ref), distintos de los de usuarios.
         */
        function gridCellKind(col) {
            if (!col) { return 'text'; }
            var t = col.type || '';
            // Relación a otra sección (p.ej. Event -> events): desplegable con los items
            // de esa sección, resueltos por raw_settings {fromSection, showField}.
            if (t === 'section' && col.raw_settings) { return 'assoc'; }
            // Campos que NO caben en una celda suelta: se abren en el formulario
            // completo (html enriquecido, multi-relación, ficheros, tags, media).
            // Medias del item: modal propio con el editor por zonas (ver gridEditMedia).
            if (t === 'thumbnail' || t.indexOf('thumbnail') === 0 || t === 'media') {
                return 'media';
            }
            if (t === 'html' || t === 'section' || t === 'sectionmulti' ||
                t === 'files' || t === 'tags') {
                return 'complex';
            }
            if (!gridFieldEditable(col)) { return 'readonly'; }
            if (t === 'onoff' || t === 'status') { return 'checkbox'; }
            // dateHm lleva hora -> input datetime-local; date -> solo fecha.
            if (t === 'dateHm' || t.indexOf('datetime') === 0) { return 'datetime'; }
            if (t === 'date') { return 'date'; }
            if (t === 'id_subsec') { return 'subsec'; }
            if (t === 'id_cat') { return 'cat'; }
            if (t === 'id_subcat') { return 'subcat'; }
            if (t === 'language') { return 'language'; }
            if (t === 'nume') { return 'number'; }
            if (t === 'color') { return 'color'; }
            if (t === 'text') { return 'textarea'; }
            return 'text';
        }

        // El ID nunca es editable; el resto lo decide edit_editable del _ref
        // (0 / '' = bloqueado; NULL/1 = editable, permisivo para no bloquear campos que
        // una sección deje sin configurar).
        function gridFieldEditable(col) {
            if (!col) { return false; }
            if (col.type === 'id' || col.type === 'timer') { return false; }
            var e = col.edit_editable;
            if (e === 0 || e === '0' || e === '') { return false; }
            return true;
        }

        /**
         * Texto de una celda de solo lectura. Los campos RELACIONALES (idioma,
         * subsección, categoría…) guardan un id, así que hay que resolver su etiqueta:
         * si no, la celda muestra un "1" pelado que no dice nada.
         */
        function gridCellDisplay(row, col) {
            if (!row || !col) { return ''; }
            var v = row[col.titleId];
            if (col.type === 'id') { return (v || v === 0) ? '#' + v : ''; }
            if (v === null || v === undefined || v === '' || typeof v === 'object') { return ''; }

            var label = gridRelationLabel(col.type, v);
            if (label !== null) { return label; }
            return v;
        }

        /**
         * Etiqueta de un valor relacional, o null si el tipo no lo es. La comparación es
         * laxa (==) a propósito: el id puede venir como número desde la fila y como
         * cadena desde el catálogo (o al revés).
         */
        function gridRelationLabel(type, value) {
            if (type === 'language') {
                var langs = sessionService.getSiteLanguages() || {};
                var lang = langs[value];
                return lang ? (lang.lang_name || '') : '';
            }
            var map = {
                id_subsec: { key: 'subsection', id: 'id_subsec', text: 'subsec' },
                id_cat:    { key: 'cat',        id: 'id_cat',    text: 'cat' },
                id_subcat: { key: 'subcat',     id: 'id_subcat', text: 'subcat' }
            };
            var cfg = map[type];
            if (!cfg) { return null; }
            var list = contentService.getValuesReferencesSections(cfg.key) || [];
            for (var i = 0; i < list.length; i++) {
                if (list[i][cfg.id] == value) { return list[i][cfg.text] || ''; }
            }
            return '';
        }

        // Opciones de los desplegables de subsección / categoría / subcategoría. Salen
        // del mismo almacén que usa el listado (contentService), así que no hace falta
        // ninguna llamada extra.
        // Columna fija de acciones (borrar) al final de la rejilla.
        vm.gridFixedColumns = [{
            label: 'CONTENT.ROW_ACTIONS',
            width: 96,
            position: 'end',
            cellTemplate: 'app/core/directives/mv-grid/mv-grid-actions-cell.html'
        }];

        /**
         * Borrar un item desde la rejilla, con DOBLE confirmación: primero un aviso que
         * dice qué item se va a borrar, y después la confirmación propia de massActions,
         * que es la que ejecuta el borrado, refresca el listado y avisa. Se reutiliza esa
         * via a proposito: es el borrado ya probado del modulo.
         */
        function gridDeleteRow(row, $event) {
            if ($event) { $event.stopPropagation(); }
            var id = row && (row.id || row['id_' + $scope.section]);
            if (!id) { return; }

            var label = row.title || row.Title || row.name || ('#' + id);

            var first = $mdDialog.confirm()
                .title($translate.instant('CONTENT.SURE_DELETED_SINGULAR'))
                // textContent (no htmlContent): el titulo es contenido editable y no debe
                // interpretarse como HTML.
                .textContent(label)
                .ariaLabel('Delete item')
                .targetEvent($event)
                .ok($translate.instant('CONTENT.DELETE'))
                .cancel($translate.instant('CONTENT.CANCEL'));

            $mdDialog.show(first).then(function () {
                massActions('delete', [id]);
            });
        }
        vm.gridDeleteRow = gridDeleteRow;

        /**
         * Duplicar: NO crea nada todavia. Abre la fila de alta con una copia de los datos
         * para revisarlos y confirmar, que es lo que se espera de "nuevo, pero relleno".
         * Se quitan el id y los campos que no puede llevar una fila sin guardar:
         * Thumbnail/tags necesitan un item ya existente para gestionarse.
         */
        function gridDuplicateRow(row, $event) {
            if ($event) { $event.stopPropagation(); }
            if (!row || !vm.gridApi) { return; }
            var copy = angular.copy(row);
            delete copy.id;
            delete copy['id_' + $scope.section];
            delete copy.Thumbnail;
            delete copy.tags;
            angular.forEach(Object.keys(copy), function (k) {
                if (k.charAt(0) === '$') { delete copy[k]; }
            });
            vm.gridApi.startNewRow(copy);
        }
        vm.gridDuplicateRow = gridDuplicateRow;

        /**
         * Valores por defecto de la fila nueva: mismos criterios que el alta normal
         * (fechas = ahora, estados con su defaultValue del _ref), pero en el formato de
         * la rejilla (cadenas, no los objetos {value,date,...} del formulario), para que
         * el guardado sea el mismo que el de cualquier otra celda.
         */
        function gridNewRowDefaults() {
            var draft = {};
            angular.forEach($scope.refcolumns || [], function (col) {
                var t = col.type || '';
                if (t === 'dateHm' || t.indexOf('datetime') === 0) {
                    draft[col.titleId] = moment.utc().format('YYYY-MM-DD HH:mm:00');
                } else if (t === 'date') {
                    draft[col.titleId] = moment().format('YYYY-MM-DD');
                } else if (t === 'status' && col.raw_settings) {
                    try {
                        var raw = angular.isString(col.raw_settings)
                            ? JSON.parse(col.raw_settings) : col.raw_settings;
                        draft[col.titleId] = raw.defaultValue ? 1 : 0;
                    } catch (e) { /* raw_settings mal formado: se deja sin defecto */ }
                } else if (t === 'onoff') {
                    // Nace desactivado: no aparece en la web hasta que se decida.
                    draft[col.titleId] = 0;
                }
            });
            return draft;
        }
        vm.gridNewRowDefaults = gridNewRowDefaults;

        /**
         * Crear el item de la fila borrador. contentService.saveItem con id 'new' es la
         * misma via del alta normal, y devuelve el id creado.
         */
        function gridCreateRow(row) {
            var deferred = $q.defer();
            var item = angular.copy(row);
            angular.forEach(Object.keys(item), function (k) {
                if (k.charAt(0) === '$') { delete item[k]; }
            });
            item.id = 'new';

            contentService.saveItem({
                site: $scope.siteID,
                section: $scope.section,
                id: 'new',
                item: item
            }).then(function (response) {
                var newId = response && (response.id || response.id_item);
                if (newId) {
                    // Se coloca arriba del listado con su id ya puesto, editable inline.
                    var created = angular.copy(item);
                    created.id = newId;
                    created['id_' + $scope.section] = newId;
                    vm.threads.unshift(created);
                }
                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' +
                              $translate.instant('CONTENT.SAVED') + '</span></div></md-toast>',
                    hideDelay: 4000, position: 'top', parent: '#content-container'
                });
                deferred.resolve(response);
            }, function (error) {
                var detail = (error && error.data && error.data.detail) || null;
                if (detail) { msUtils.showError(detail); }
                deferred.reject(error);
            });

            return deferred.promise;
        }
        vm.gridCreateRow = gridCreateRow;

        function gridSubsections() { return contentService.getValuesReferencesSections('subsection') || []; }
        function gridCategories() { return contentService.getValuesReferencesSections('cat') || []; }
        function gridSubcategories() { return contentService.getValuesReferencesSections('subcat') || []; }

        /**
         * Prepara una fila para la rejilla UNA sola vez: los inputs nativos de fecha
         * exigen un Date real, así que guardamos uno aparte ($d_<titleId>) y dejamos el
         * string original en la fila (que es lo que se guarda).
         */
        function ensureGridRow(row) {
            if (!row || row.$gridExpanded) { return; }
            // En content las columnas del _ref las publica qiu-pagination en $scope.
            var cols = ($scope.refcolumns || []);
            for (var i = 0; i < cols.length; i++) {
                var col = cols[i];
                var t = col.type || '';
                if ((t === 'date' || t === 'dateHm' || t.indexOf('datetime') === 0) && gridFieldEditable(col)) {
                    try {
                        var raw = row[col.titleId];
                        row['$d_' + col.titleId] = (raw && typeof raw === 'string')
                            ? gridDateToPicker(raw, gridDateHasTime(col))
                            : null;
                    } catch (e) { row['$d_' + col.titleId] = null; }
                }
            }
            row.$gridExpanded = true;
        }

        // ---- Fechas y zona horaria -------------------------------------------------
        // IMPORTANTE: content guarda las fechas CON HORA en UTC y las muestra en la zona
        // del sitio (ver el tratamiento de 'date' al abrir un item y al guardarlo desde
        // el formulario). La rejilla replica ESE MISMO criterio: si no, el mismo registro
        // se vería con horas distintas en la rejilla y en el formulario, y editar en la
        // rejilla guardaría un valor desplazado.
        // Las fechas SIN hora se dejan tal cual: una fecha suelta no tiene zona horaria y
        // convertirla puede saltar de día.

        function gridDateHasTime(col) {
            var t = (col && col.type) || '';
            return t === 'dateHm' || t.indexOf('datetime') === 0;
        }

        function gridSiteTimezone() {
            var tz = sessionService.site_operative && sessionService.site_operative.timezone;
            return (tz || moment.tz.guess() || 'UTC').toString().trim();
        }

        // Valor de BD -> Date para el input.
        function gridDateToPicker(raw, withTime) {
            if (!withTime) {
                var d = moment(raw, 'YYYY-MM-DD');
                return d.isValid() ? d.toDate() : null;
            }
            var utc = moment.utc(raw);
            if (!utc.isValid()) { return null; }
            return new Date(utc.tz(gridSiteTimezone()).format());
        }

        // Date del input -> string para la BD.
        function gridPickerToDb(d, withTime) {
            if (!(d instanceof Date) || isNaN(d.getTime())) { return ''; }
            return withTime
                ? moment.utc(d).format('YYYY-MM-DD HH:mm:00')
                : moment(d).format('YYYY-MM-DD');
        }

        /**
         * Cambio en una fecha: serializa el Date al formato que espera la BD y guarda.
         * Con guard para ignorar el ng-change espurio de la inicialización.
         */
        function onGridDateChange(row, col) {
            var withTime = gridDateHasTime(col);
            var newVal = gridPickerToDb(row['$d_' + col.titleId], withTime);
            var cur = (row[col.titleId] === null || row[col.titleId] === undefined) ? '' : String(row[col.titleId]);
            // Comparamos normalizado: la BD puede traer segundos ('12:00:00') y nosotros
            // siempre escribimos ':00', pero tambien puede venir con 'T' o sin segundos.
            if (gridSameInstant(cur, newVal, withTime)) { return; }
            row[col.titleId] = newVal;
            gridSaveRow(row);
        }

        // ¿Representan el mismo momento? Evita guardados espurios por diferencias de
        // formato (con/sin segundos, 'T' en medio) al inicializar el input.
        function gridSameInstant(a, b, withTime) {
            if (a === b) { return true; }
            if (!a || !b) { return false; }
            var fmt = withTime ? 'YYYY-MM-DD HH:mm:00' : 'YYYY-MM-DD';
            var ma = withTime ? moment.utc(a) : moment(a, 'YYYY-MM-DD');
            var mb = withTime ? moment.utc(b) : moment(b, 'YYYY-MM-DD');
            if (!ma.isValid() || !mb.isValid()) { return false; }
            return ma.format(fmt) === mb.format(fmt);
        }

        /**
         * Guardado por fila con debounce. Reutiliza EXACTAMENTE la misma fontanería que
         * el reordenado por drag del listado (contentService.saveItem con la fila cruda),
         * que es la vía ya probada para persistir un item desde la lista.
         */
        var gridSaveTimers = {};
        function gridSaveRow(row) {
            if (!row) { return; }
            var id = row['id_' + $scope.section];
            if (!id) { return; }
            if (gridSaveTimers[id]) { $timeout.cancel(gridSaveTimers[id]); }
            row.$saveError = false;
            row.$saving = true;
            gridSaveTimers[id] = $timeout(function () { gridDoSaveRow(row, id); }, 600);
        }

        function gridDoSaveRow(row, id) {
            // No mandamos los auxiliares de la rejilla ($d_*, $saving…): se limpian de
            // una copia para no ensuciar la fila que se está editando en pantalla.
            var item = angular.copy(row);
            angular.forEach(Object.keys(item), function (k) {
                if (k.charAt(0) === '$') { delete item[k]; }
            });
            item.id = id;

            contentService.saveItem({
                site: $scope.siteID,
                section: $scope.section,
                id: id,
                item: item,
                keepOldMedia: true
            }).then(function () {
                row.$saving = false;
                row.$saved = true;
                $timeout(function () { row.$saved = false; }, 1500);
            }, function () {
                row.$saving = false;
                row.$saveError = true;
            });
        }

        /**
         * Modal de MEDIAS del item (campo tipo thumbnail). Reutiliza el editor de medias
         * por zonas del formulario (views/read/tab-media.html) tal cual: ver las medias
         * actuales agrupadas por zona, borrarlas, moverlas entre zonas y subir nuevas.
         *
         * Se encadenan los MISMOS puntos de entrada que usa el editor normal
         * (openThread -> viewEditInline -> saveItem) en vez de escribir carga y guardado
         * propios: la asociacion item<->media viaja dentro del guardado del item entero
         * (propiedad Thumbnail, no hay endpoint solo-medias), asi que cualquier atajo
         * aqui podria estropear el resto de campos del registro.
         */
        function gridEditMedia(row, $event) {
            if ($event) { $event.stopPropagation(); }
            // Las medias se asocian a un item existente: en la fila de alta (sin id) no
            // hay nada a lo que asociarlas.
            if (!row || !(row.id || row['id_' + $scope.section])) { return; }
            if (vm.gridMediaLoading) { return; }
            vm.gridMediaLoading = true;

            $q.when(openThread(row)).then(function () {
                // Prepara currentThread_Edit + los cubos de zonas (thumbnails_Edit),
                // exactamente igual que al pulsar "editar" en el formulario.
                viewEditInline();
                vm.gridMediaLoading = false;

                // El dialogo cuelga de un scope hijo, asi que hereda `vm` y la plantilla
                // de medias funciona sin adaptarla.
                $mdDialog.show({
                    templateUrl: 'app/main/apps/content/dialogs/grid-media/grid-media.html',
                    parent: angular.element($document.body),
                    targetEvent: $event,
                    clickOutsideToClose: false,
                    scope: $scope.$new(),
                    preserveScope: false
                })['finally'](function () {
                    vm.editInline = false;
                });
            }, function () {
                vm.gridMediaLoading = false;
            });
        }

        // Guardar del modal de medias: vuelca los cubos de zonas a Thumbnail y guarda el
        // item por la via normal del editor.
        function gridMediaSave() {
            syncThumbnailsFromZones();
            saveItem(vm.currentThread_Edit);
            $mdDialog.hide();
        }

        function gridMediaCancel() {
            // Se descartan los cambios: nada se ha persistido todavia.
            $mdDialog.cancel();
        }

        /**
         * Campos que no caben en una celda (html, multi-relación): se abre el item
         * en el editor normal.
         * OJO: openThread pinta en el panel 'thread-detail', que NO existe en la vista
         * Excel; por eso hay que cambiar antes a la vista dividida o no se veía nada.
         * Se recuerda de dónde venimos para poder volver a la rejilla al cerrar.
         */
        function gridEditComplexCell(row, col, $event) {
            if ($event) { $event.stopPropagation(); }
            vm.gridReturnView = 'spreadsheet';
            changeView('split');
            $timeout(function () { vm.openThread(row); });
        }

        // Vuelve a la rejilla desde el editor (solo si llegamos allí desde la rejilla).
        vm.gridBackToSpreadsheet = function () {
            if (vm.gridReturnView === 'spreadsheet') {
                vm.gridReturnView = null;
                changeView('spreadsheet');
            }
        };

        /**
         * Toggle view Edit
         */
        function viewEditInline() {
            resetScroll();

            vm.thumbnails_Edit = {};
            vm.editInline = true;
            vm.currentThread_Edit = angular.copy(vm.selectedContent);
            vm.currentThread_ref = angular.copy(vm.selectedContent_ref);
            vm.thumbnails_Edit = buildThumbnailsByZone();
            angular.forEach(vm.selectedContent_ref, function (refColumn) {
                switch (refColumn.type) {
                    case 'date':
                    case 'dateHm':
                        var type = 'input';
                        break;
                    case 'single':
                        var type = 'input';
                        break;
                    default:
                        break;
                }
            });
        }

        function getColumns(item) {
            if (!vm.currentThread_ref) return;

            let ret = 'Not selected';
            const templateId = item.template.id;
            if (!templateId) return ret;

            const multipleTexts = vm.currentThread_ref.find(x => x.field_name === 'multiple_texts');
            if (!multipleTexts) return ret;

            const raw_settings = multipleTexts.raw_settings;
            if (!raw_settings) return ret;

            const templates = raw_settings.ref.find(x => x.type === 'templates');
            if (!templates) return ret;

            const template = templates.options.find(x => x.value.id === templateId);
            if (!template) return ret;

            const columns = template.fields.find(x => (x.type === 'list' && x.name === 'columns'));
            if (!columns) return ret;

            const label = columns.options.find(x => x.value === item.columns);
            ret = label.name;

            return ret;
        }

        /**
         * Toggle view Edit
         */
        function viewPreview() {
            resetScroll();
            vm.editInline = false;
        }

        function resetScroll() {
            if (angular.element(document.getElementById('thread-detail')).length) {
                var elem = angular.element(document.getElementById('thread-detail'));
                elem.scrollTopAnimated(0, 10);
            }
        }

        /**
         * Open compose dialog
         *
         * @param ev
         */

        function composeDialog(ev) {
            $mdDialog.show({
                controller: 'ComposeDialogController',
                controllerAs: 'vm',
                locals: {
                    selectedContent: undefined
                },
                templateUrl: 'app/main/dialogs/compose/compose-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        }

        /**
         * Open rss import dialog
         *
         * @param ev
         */

        function rssImportDialog(ev, rss) {
            $mdDialog.show({
                controller: 'RssImportDialogController',
                controllerAs: 'vm',
                locals: {
                    rss: rss,
                    section: $scope.section,
                    importSection: 'news'
                },
                templateUrl: 'app/main/dialogs/rss-import/rss-import.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        }

        /* FELIX */
        function openImportDialog(ev) {
            $mdDialog.show({
                controller: 'ImportContentDialogController',
                controllerAs: 'vm',
                locals: {
                    siteID: $scope.siteID,
                    section: $scope.section,
                    usersGroups: vm.usersGroups,
                    rootGroup: vm.isQiuRestricted ? vm.rootGroup : null,
                    selectedGroup: vm.selectedGroup ? vm.selectedGroup : vm.selectedGroupsAcc ? vm.selectedGroupsAcc[0] : null
                },
                templateUrl: 'app/main/apps/users/dialogs/import/import-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            })
                .then(function (result) {
                    if (result && result.update) {
                        $rootScope.pagination_resetquery();
                    }
                });
        }

        function saveTrackingUpdate(item) {
            if (!item || !item.id) {
                console.error("Invalid tracking item: missing ID.");
                return Promise.reject(new Error("Missing ID in tracking item."));
            }

            return contentService.saveItem({
                site: $scope.siteID,
                section: 'projects_tracking',
                id: item.id,
                item: item
            }).then(response => {
                console.log("🟢 Tracking update saved:", response);
                return response;
            }).catch(error => {
                console.error("❌ Error saving tracking update:", error);
                return Promise.reject(error);
            });
        }


        vm.startTimer = function (thread, $event) {
            $event.stopPropagation();

            const utcDate = moment.utc().startOf('minute'); // redondeado a minuto
            const siteDate = utcDate.clone().tz(sessionService.site_operative.timezone);

            thread._timerStart = {
                utcDate: utcDate,
                display: siteDate.format("HH:mm:ss")
            };
            thread._timerRunning = true;

            // Calcular y mostrar inmediatamente desde 00:00:00
            const now = moment.utc();
            const duration = moment.duration(now.diff(thread._timerStart.utcDate));
            thread._timerDisplay = moment.utc(duration.asMilliseconds()).format("HH:mm:ss");

            // Activar contador en vivo
            thread._interval = $interval(() => {
                const now = moment.utc();
                const duration = moment.duration(now.diff(thread._timerStart.utcDate));
                thread._timerDisplay = moment.utc(duration.asMilliseconds()).format("HH:mm:ss");
            }, 1000);

            const trackingItem = {
                id_projects: thread.id_projects,
                id_staff: 7, // ← Asegúrate que esto sea el ID numérico
                task_description: thread.task_description || 'Tarea iniciada',
                from_datetime: utcDate.format("YYYY-MM-DD HH:mm:ss"),
                to_datetime: null,
                timezone: sessionService.site_operative.timezone || moment.tz.guess(),
                ip_address: '192.168.1.11',
                status: 'in_progress',
                onoff: 1
            };

            contentService.saveItem({
                site: $scope.siteID,
                section: 'projects_tracking',
                id: 'new',
                item: trackingItem
            }).then(response => {
                thread._trackingId = response.id;
                console.log(thread._trackingId);
                console.log('Timer iniciado correctamente');
            });
        };

        vm.stopTimer = function (thread, $event) {
            $event.stopPropagation();

            const trackingId = thread._trackingId || thread.id_tracking_current;

            if (!trackingId) {
                console.error("No tracking ID found. Timer cannot be stopped.");
                return;
            }

            if (!thread._timerStart || !thread._timerStart.utcDate) {
                console.warn("Timer start time not available. Using only to_datetime.");
            }

            const startDate = thread._timerStart?.utcDate;
            const endDate = moment.utc().startOf('minute');

            if (!startDate || !moment.isMoment(startDate)) {
                console.error("Invalid or missing start date.");
                return;
            }

            const trackingUpdate = {
                id: trackingId,
                id_projects_tracking: trackingId,
                id_projects: thread.id_projects,
                id_staff: 7,
                task_description: thread.task_description || 'Tarea completada',
                from_datetime: startDate.format("YYYY-MM-DD HH:mm:ss"),
                to_datetime: endDate.format("YYYY-MM-DD HH:mm:ss"),
                status: 'completed',
                onoff: 1,
                ip_address: '192.168.1.11',
                timezone: sessionService.site_operative.timezone || moment.tz.guess()
            };

            saveTrackingUpdate(trackingUpdate).then(() => {
                $interval.cancel(thread._interval);
                thread._timerRunning = false;
                thread._timerDisplay = null;

                delete thread._timerStart;
                delete thread._trackingId;
                delete thread.id_tracking_current;

                console.log("Timer successfully stopped.");
            }).catch(error => {
                console.error("Failed to stop timer due to save error:", error);
            });
        };



        /**
         * Open Image dialog
         *
         * @param ev
         * @param task
         */
        function openImageDialog(ev, images, ImageSelected) {
            var images = angular.copy(images);

            // preview only images and video
            for (var i = images.length - 1; i >= 0; i--) {
                if (angular.isUndefined(images[i].media_type) ||
                    [1, 2].indexOf(parseInt(images[i].media_type)) < 0) {
                    images.splice(i, 1);
                }
            }

            $mdDialog.show({
                controller: 'MediaShowDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/dialogs/media-show/media-show-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Images: images,
                    ImageSelected: ImageSelected,
                    cropFormats: false,
                    MediaFull: false,
                    Tags: false,
                    // Tasks: vm.tasks,
                    // event: ev
                }
            });
        }

        /**
         * Open Image dialog
         *
         * @param ev
         * @param task
         */
        function openFocalPoint(ev, ImageSelected) {
            $mdDialog.show({
                controller: 'MediaFocalPointDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/dialogs/media-focal-point/media-focal-point-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    ImageSelected: ImageSelected,
                }
            }).then(function (item) {
                vm.basicForm.$setDirty();
                ImageSelected.imageCenterRatioX = item.imageCenterRatioX;
                ImageSelected.imageCenterRatioY = item.imageCenterRatioY;
                angular.forEach(vm.mediaZones, function (mediazone) {
                    angular.forEach(vm.thumbnails_Edit[mediazone.id_zone], function (attachment) {
                        if (item.id_media === attachment.id_media) {
                            attachment.imageCenterRatioX = item.imageCenterRatioX;
                            attachment.imageCenterRatioY = item.imageCenterRatioY;
                        }
                    })
                })
            });
        }

        /**
         * Open Metadata Image
         *
         * @param ev
         * @param task
         */
        function openMediaItemMetadata(ev, ImageSelected) {
            $mdDialog.show({
                controller: 'MediaItemMetadataDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/dialogs/media-item-metadata/media-item-metadata-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    ImageSelected: ImageSelected,
                }
            }).then(function (item) {

                vm.basicForm.$setDirty();
                if (item) {
                    angular.forEach(vm.currentThread_Edit.Thumbnail, function (media) {
                        if (item.id_media === media.id_media) {
                            angular.forEach(media, function (value, key) {
                                if (item[key]) {
                                    media[key] = item[key];
                                }
                            })
                        }
                    })
                }
            });
        }

        /**
         * Open compose dialog
         *
         * @param ev
         */

        function mediaDialog(ev, mediazone, item, autoUpload) {
            $mdDialog.show({
                controller: 'MediaDialogController',
                controllerAs: 'vm',
                locals: {
                    currentThread: item,
                    section: $scope.section,
                    mediazone: mediazone,
                    isTiny: false,
                    maxAttach: undefined,
                    showViews: {
                        1: true,
                        2: true,
                        3: true,
                        4: true,
                        5: true,
                        upload: true,
                        import: true
                    },
                    autoUpload: autoUpload
                },
                templateUrl: 'app/main/dialogs/media/media-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            }).then(function (item) {
                vm.currentThread_Edit = item;
                vm.basicForm.$setDirty();
                vm.thumbnails_Edit = buildThumbnailsByZone();
            });
        }

        /**
         * Open TinyMCE media selector
         *
         * @param item
         */

        function mediaDialogTiny(item) {
            $mdDialog.show({
                controller: 'MediaDialogController',
                controllerAs: 'vm',
                locals: {
                    autoUpload: '',
                    currentThread: item,
                    section: $scope.section,
                    mediazone: 1,
                    isTiny: 1,
                    maxAttach: undefined,
                    showViews: {
                        1: true,
                        2: true,
                        3: true,
                        4: true,
                        5: true,
                        upload: true,
                        import: true
                    }
                },
                templateUrl: 'app/main/dialogs/media/media-dialog-tinymce.html',
                parent: angular.element($document.body),
                clickOutsideToClose: true
            }).then(function (item) {

                /*
                                vm.currentThread_Edit = item;

                                vm.basicForm.$setDirty()
                                vm.thumbnails_Edit = {};
                                angular.forEach(vm.mediaZones, function (mz) {
                                    if (angular.isUndefined(vm.thumbnails_Edit[mz.id_zone])) {
                                        vm.thumbnails_Edit[mz.id_zone] = [];
                                    }
                                })
                                angular.forEach(vm.currentThread_Edit.Thumbnail, function (thumb) {
                                    vm.thumbnails_Edit[thumb.id_zone].push(thumb);
                                })
                */
            });
        }

        /**
         * Open reply dialog
         *
         * @param ev
         */
        function replyDialog(ev) {
            $mdDialog.show({
                controller: 'ComposeDialogController',
                controllerAs: 'vm',
                locals: {
                    selectedContent: vm.selectedContent
                },
                templateUrl: 'app/main/dialogs/compose/compose-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            if ($scope.filtersToSelect) {
                $mdSidenav(sidenavId).toggle();
                $scope.showSidenav = true;
            } else {
                $mdSidenav(sidenavId).toggle().then(function () {
                    if ($mdSidenav(sidenavId).isOpen()) {
                        $timeout(function () {
                            $scope.showSidenav = true;
                        }, 500);
                    } else {
                        $scope.showSidenav = false;
                    }
                });
            }
        }

        function isNumber(value) {
            return angular.isNumber(value);
        }

        function siteLanguages() {
            return sessionService.getSiteLanguages();
        }

        function getCurrentMedia() {
            return vm.currentThread_Edit.Thumbnail;
        }

        function getZoneCrop(field) {
            var cropId = '';
            if (!angular.isUndefined(field.id_cropformats)) {
                cropId = field.id_cropformats;
            }
            return cropId;
        }

        function newTag(tagName) {
            var newTag = {
                id_tag: '',
                tag_name: tagName
            };
            vm.tags.push(newTag);
            vm.currentThread_Edit.tags.push(newTag);
            vm.searchTagText = '';
        }

        function getCountries() {
            if (angular.isUndefined(vm.allCountries)) {
                vm.allCountries = [];
                var options = {
                    paginate: 99999,
                };
                contentService.getCountries(options).then(function (response) {
                    if (response.total) {
                        angular.forEach(response.data, function (item) {
                            var resultId = item['id_country'];
                            var resultData = {
                                id: resultId,
                                code: item['code'],
                                name: item['country']
                            };
                            vm.allCountries.push(resultData);
                        })
                    }
                })
            }

        }

        function showCountry(itemId, fieldData) {
            var ret = '';
            if (itemId) {
                vm.getCountries();
                angular.forEach(vm.allCountries, function (c) {
                    if (c.id == itemId) {
                        ret = c.name;
                    }
                })
            }
            return ret;
        }

        function getShowCountries(fieldData) {
            var ret = '';
            vm.getCountries();
            if (!angular.isUndefined(vm.allCountries)) {
                return vm.allCountries;
            }
            else {
                return {};
            }
        }

        function getSectionRelated(rawSettings, keyHash) {
            if (angular.isUndefined(vm.sectionsAssoc[keyHash])) {
                vm.sectionsAssoc[keyHash] = [];
                var options = {
                    siteID: $scope.siteID,
                    section: rawSettings.fromSection,
                    resultsPerPage: 99999,
                    filters: rawSettings.filters
                };
                if (!angular.isUndefined(rawSettings.orderField)) {
                    var sortOrder = 'DESC';
                    if (!angular.isUndefined(rawSettings.orderSort)) {
                        sortOrder = rawSettings.orderSort;
                    }
                    if (!angular.isUndefined(rawSettings.orderField)) {
                        options.sortField = rawSettings.orderField;
                    }

                    options.sortDir = sortOrder;
                }
                contentService.get(options).then(function (response) {
                    if (response.result.total) {
                        angular.forEach(response.result.data, function (item) {
                            var resultId = item['id'];
                            var resultData = {
                                id: resultId,
                                val: item[rawSettings.showField]
                            };
                            vm.sectionsAssoc[keyHash].push(resultData);
                        })
                    }
                })
            }
        }

        function showAssoc(itemId, fieldData) {
            if (!fieldData.raw_settings) {
                return '';
            }
            else {
                var ret = '';
                var rawSettings = JSON.parse(fieldData.raw_settings);
                var keyHash = fieldData.raw_settings;
                vm.getSectionRelated(rawSettings, keyHash);
                angular.forEach(vm.sectionsAssoc[keyHash], function (secData) {
                    if (secData.id == itemId) {
                        ret = secData.val;
                    }
                });
                return ret;
            }
        }

        function getShowAssoc(fieldData) {
            if (!fieldData.raw_settings) {
                return '';
            }
            else {
                var rawSettings = JSON.parse(fieldData.raw_settings);
                var keyHash = fieldData.raw_settings;
                vm.getSectionRelated(rawSettings, keyHash);
                if (!angular.isUndefined(vm.sectionsAssoc[keyHash])) {
                    return vm.sectionsAssoc[keyHash];
                }
                else {
                    return {};
                }
            }
        }

        function getZoneMediaArray() {
            var zoneMedia = {
                1: {},
                2: {},
                3: {},
                4: {},
                5: {}
            };
            var typesMax = {
                1: 0,
                2: 0,
                3: 0,
                4: 0,
                5: 0
            };
            var currentSort = 0;
            var currentType = 0;
            if (vm.currentThread) {
                for (var i = 0; i < vm.currentThread.Thumbnail.length; i++) {
                    if (vm.mediaZones) {
                        if (vm.currentThread.Thumbnail[i]['id_zone'] == 1) {
                            currentSort = vm.currentThread.Thumbnail[i]['sort'];
                            if (vm.currentThread.Thumbnail[i]['media_type']) {
                                currentType = vm.currentThread.Thumbnail[i]['media_type'];
                            } else {
                                currentType = 5; //gallery
                            }
                            typesMax[currentType]++;
                            zoneMedia[currentType][typesMax[currentType]] = vm.currentThread.Thumbnail[i];
                        }
                    }
                    else {
                        currentSort = vm.currentThread.Thumbnail[i]['sort'];
                        if (vm.currentThread.Thumbnail[i]['media_type']) {
                            currentType = vm.currentThread.Thumbnail[i]['media_type'];
                        } else {
                            currentType = 5; //gallery
                        }
                        typesMax[currentType]++;
                        zoneMedia[currentType][typesMax[currentType]] = vm.currentThread.Thumbnail[i];

                    }
                }
            }
            return zoneMedia;
        }

        function processHtml(content) {
            var newCont = content;
            var zoneMedia = getZoneMediaArray();
            var validData = {
                left: 'align-left',
                center: 'align-center',
                right: 'align-right',
                25: 'size-25',
                50: 'size-50',
                75: 'size-75',
                100: 'size-100',
            };

            // Regex for old images
            var regex = /(\[image\|([^\]]*)\])/g;
            var m;
            while ((m = regex.exec(content)) !== null) {
                var expCont = '';
                var mediaData = {
                    type: '',
                    sort: '',
                    class: ''
                };
                var mediaExtra = '';
                // This is necessary to avoid infinite loops with zero-width matches
                if (m.index === regex.lastIndex) {
                    regex.lastIndex++;
                }
                if (m[2]) {
                    expCont = m[2].split('|');
                    mediaData.type = 'image';
                    for (var i = 0; i < expCont.length; i++) {
                        if (i == 0) {
                            mediaData.sort = expCont[i];
                        }
                        else {
                            mediaExtra = expCont[i];
                            if (!angular.isUndefined(validData[mediaExtra])) {
                                mediaData.class += validData[mediaExtra] + ' ';
                            }
                        }
                    }
                    var newHtml = '';
                    if (!angular.isUndefined(zoneMedia[1][mediaData.sort])) {
                        newHtml = '<div class="qiumedia-read qiumedia-image ' + mediaData.class + '" style="background: #efefef;"><img src="' + zoneMedia[1][mediaData.sort].cropstatus[0].container.view_url + zoneMedia[1][mediaData.sort].cropstatus[0].fileName + '" class=" width-percent-100"></div>';
                    }
                    newCont = newCont.replace(m[0], newHtml);
                }
            }

            // Regex for old videos
            var regex = /(\[video\|([^\]]*)\])/g;
            var n;
            while ((n = regex.exec(content)) !== null) {
                var newHtml = '';
                var expCont = '';
                var mediaData = {
                    type: '',
                    sort: '',
                    class: ''
                };
                var mediaExtra = '';
                // This is necessary to avoid infinite loops with zero-width matches
                if (n.index === regex.lastIndex) {
                    regex.lastIndex++;
                }
                if (n[2]) {
                    expCont = n[2].split('|');
                    mediaData.type = 'video';
                    for (var i = 0; i < expCont.length; i++) {
                        if (i == 0) {
                            mediaData.sort = expCont[i];
                        } else {
                            mediaExtra = expCont[i];
                            if (!angular.isUndefined(validData[mediaExtra])) {
                                mediaData.class += validData[mediaExtra] + ' ';
                            }
                        }
                    }
                    if (!angular.isUndefined(zoneMedia[2][mediaData.sort])) {
                        newHtml = '<div class="qiumedia-read qiumedia-video ' + mediaData.class + '"><div><img src="' + zoneMedia[2][mediaData.sort].embed_thumb + '" class=" width-percent-100"></div></div>';
                    }
                    newCont = newCont.replace(n[0], newHtml);
                }
            }


            // Regex for Images
            var regex = /(\[imageid\|([^\]]*)\])/g;
            var m;
            while ((m = regex.exec(content)) !== null) {
                var expCont = '';
                var mediaData = {
                    type: '',
                    sort: '',
                    class: ''
                };
                var mediaExtra = '';
                // This is necessary to avoid infinite loops with zero-width matches
                if (m.index === regex.lastIndex) {
                    regex.lastIndex++;
                }
                if (m[2]) {
                    expCont = m[2].split('|');
                    mediaData.type = 'image';
                    for (var i = 0; i < expCont.length; i++) {
                        if (i == 0) {
                            mediaData.sort = expCont[i];
                        }
                        else {
                            mediaExtra = expCont[i];
                            if (!angular.isUndefined(validData[mediaExtra])) {
                                mediaData.class += validData[mediaExtra] + ' ';
                            }
                        }
                    }
                    var newHtml = '';
                    const found = Object.values(zoneMedia[1]).find(x => x.id_media == mediaData.sort);
                    if (found && found.cropstatus && found.cropstatus.length) {
                        newHtml = '<div class="qiumedia-read qiumedia-image ' + mediaData.class + '" style="background: #efefef;"><img src="' + found.cropstatus[0].container.view_url + found.cropstatus[0].fileName + '" class=" width-percent-100"></div>';
                    }
                    newCont = newCont.replace(m[0], newHtml);
                }
            }

            // Regex for old videos
            var regex = /(\[videoid\|([^\]]*)\])/g;
            var n;
            while ((n = regex.exec(content)) !== null) {
                var newHtml = '';
                var expCont = '';
                var mediaData = {
                    type: '',
                    sort: '',
                    class: ''
                };
                var mediaExtra = '';
                // This is necessary to avoid infinite loops with zero-width matches
                if (n.index === regex.lastIndex) {
                    regex.lastIndex++;
                }
                if (n[2]) {
                    expCont = n[2].split('|');
                    mediaData.type = 'video';
                    for (var i = 0; i < expCont.length; i++) {
                        if (i == 0) {
                            mediaData.sort = expCont[i];
                        } else {
                            mediaExtra = expCont[i];
                            if (!angular.isUndefined(validData[mediaExtra])) {
                                mediaData.class += validData[mediaExtra] + ' ';
                            }
                        }
                    }
                    const found = Object.values(zoneMedia[2]).find(x => x.id_media == mediaData.sort)
                    if (found) {
                        newHtml = '<div class="qiumedia-read qiumedia-video ' + mediaData.class + '"><div><img src="' + found.embed_thumb + '" class=" width-percent-100"></div></div>';
                    }
                    newCont = newCont.replace(n[0], newHtml);
                }
            }
            return newCont;
        }

        function onSectionsSelectClose(ev, thread, key, name, type, oldVal) {

            switch (thread[key]) {
                case 'add':
                    addPrompt(ev, name).then(function (result) {
                        let item = {
                            'xorder': null,
                            'hide': null
                        };
                        let opts = {
                            section: $scope.section,
                            site: $scope.siteID,
                            data: item
                        };
                        let createPromise;
                        switch (type) {
                            case 'subsection':
                                opts.data['subsec'] = result;
                                createPromise = contentService.createSubSec(opts);
                                break;
                            case 'cat':
                                opts.data['cat'] = result;
                                createPromise = contentService.createCatSec(opts);
                                break;
                            case 'subcat':
                                opts.data['subcat'] = result;
                                createPromise = contentService.createSubCat(opts);
                                break;
                        }
                        createPromise.then(function (result) {
                            switch (type) {
                                case 'subsection':
                                    thread[key] = result.id_subsec;
                                    item['id_subsec'] = result.id_subsec;
                                    break;
                                case 'cat':
                                    thread[key] = result.id_cat;
                                    item['id_cat'] = result.id_cat;
                                    break;
                                case 'subcat':
                                    thread[key] = result.id_subcat;
                                    item['id_subcat'] = result.id_subcat;
                                    break;
                            }
                        })
                    }, function () {
                        thread[key] = oldVal;
                    }).finally(function () {

                    });
                    break;
                case 'manage':
                    editPrompt(ev, name, type).then(function (hasEdit) {
                        thread[key] = oldVal;
                    });
                    break;
                default:
                    break;
            }
        }

        function addPrompt(ev, name) {

            var confirm = $mdDialog.prompt()
                .title($translate.instant('CONTENT.CREATE') + ' ' + name.charAt(0).toUpperCase() + name.substr(1).toLowerCase())
                //.textContent('')
                .placeholder($translate.instant('CONTENT.NAME'))
                .ariaLabel($translate.instant('CONTENT.CREATE') + ' ' + name.charAt(0).toUpperCase() + name.substr(1).toLowerCase())
                //.initialValue('')
                .targetEvent(ev)
                .required(true)
                .ok($translate.instant('CONTENT.ADD'))
                .cancel($translate.instant('CONTENT.CANCEL'));

            return $mdDialog.show(confirm);
        }

        function editPrompt(ev, name, type) {

            return $mdDialog.show({
                controller: 'EditContentSubSecCatsController',
                controllerAs: 'vm',
                templateUrl: 'app/main/dialogs/edit-content-sub-sec-cats/edit-content-sub-sec-cats.html',
                escapeToClose: false,
                parent: angular.element($document.body),
                targetEvent: ev,
                multiple: true,
                locals: {
                    siteId: $scope.siteID,
                    section: $scope.section,
                    name: name,
                    type: type,
                    event: ev
                }
            });
        }

        function onFilesDrop(files, mediazone) {
            if (files.length === 0) {
                return;
            }

            vm.mediaDialog(null, mediazone, vm.currentThread_Edit, files);
        }

        function createExpandTemplate(ref, item) {
            let template = ref.options.find(x => x.value.id === item.template.id).template;
            let html = ``;
            template.forEach(tem => {
                html = `<${tem.tag} class=${tem.class}>` + createChildrenTemplate(tem, item) + `</${tem.tag}>`
            });
            return html;
        }

        function createChildrenTemplate(template, item) {
            let html = '';
            if (template.value) {
                let fieldPath = template.value.replace('$item.', '').split('.');
                let fieldValue = fieldPath.reduce((obj, key) => obj && obj[key] !== undefined ? obj[key] : '', item);
                html += fieldValue;
            }
            if (template.children) {
                template.children.forEach(element => {
                    html = html + `<${element.tag} class=${element.class}>` + createChildrenTemplate(element, item) + `</${element.tag}>`;
                });
            }
            return html;
        }
    }

    function renderTinyMedia(content) {
    }
})();

(function () {
    'use strict';

    $(window.document).on('contextmenu', '.list-media-item', function (e) {
        var menu = $('#context-menu');

        if (e.pageX >= window.innerWidth - menu.width()) {
            e.pageX -= menu.width();
        }
        if (e.pageY >= window.innerHeight - menu.height()) {
            e.pageY -= menu.height();
        }

        var posx = 0;
        var posy = 0;

        if (!e) {
            e = window.event;
        }

        posx = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
        posy = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;

        menu.hide().css({
            left: e.pageX, top: e.pageY
            // left: posx,
            // top: posy
        }).show();

        e.preventDefault();
    });

    angular.module('app.content').controller('ContentSocialStreamController', ContentSocialStreamController);

    /** @ngInject */
    function ContentSocialStreamController($scope, $rootScope, $document, $mdDialog, $mdMedia, $mdToast, $mdSidenav, $state, msApi, requestContext, $timeout, contentService, msUtils, $anchorScroll, $translate, sessionService, tinyMceService, $window, mediaService) {


        var vm = this;

        $scope.array = [
            {
                active: true,
                value: 'Copy'
            }, {
                active: true,
                value: 'Cut'
            }, {
                active: false,
                value: 'Paste'
            }
        ];

        // Data

        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg', 'red-bg', 'yellow-bg', 'light-blue-bg'];
        vm.selectedAccount = 'creapond';

        // vm.folders = Folders.data;
        // vm.labels = Labels.data;
        vm.folders = [];
        vm.labels = [];
        vm.loadingThreads = true;
        vm.enterfirst = true;
        vm.tags = sessionService.site_operative.tags;
        vm.searchTagText = null;
        vm.selectedTag = null;
        vm.createFilterFor = createFilterFor;
        vm.selectedItemChange = selectedItemChange;

        vm.scrollEl = angular.element('#thread-list')[0];

        vm.currentFilter = {
            type: $state.params.type,
            filter: $state.params.filter
        };
        vm.currentThread = null;
        vm.currentThread_Edit = null;
        vm.thumbnails_Edit = {};
        vm.selectedThreads = [];
        vm.basicForm = {};

        vm.labelQuerySearch = labelQuerySearch;



        vm.views = {
            nosplit: 'app/main/apps/content/views/list/nosplit-view-grid.html',
            split: 'app/main/apps/content/views/list/split-view-grid.html'
        };

        vm.subviews = {
            item: 'app/main/apps/content/views/grid/social-stream-grid-item.html',
        };


        vm.defaultView = 'nosplit';
        vm.defaultSubView = 'item';
        vm.currentView = 'nosplit';
        vm.defaultListView = 'grid';
        vm.currentListView = 'grid';
        vm.loadingView = true;

        vm.mediaZones = [];

        // Methods
        vm.init = init;
        vm.getInArray = msUtils.getInArray;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.toggleInGroup = msUtils.toggleInGroup;
        vm.getReferencesSections = contentService.getReferencesSections;
        vm.getExtension = msUtils.getExtension;
        vm.getExtensionIcon = msUtils.getExtensionIcon;
        vm.getValuesReferencesSections = contentService.getValuesReferencesSections;

        vm.isTrueFalseChecked = isTrueFalseChecked;
        vm.toggleTrueFalseCheck = toggleTrueFalseCheck;
        vm.selectOrUnselect = selectOrUnselect;

        vm.loadFolder = loadFolder;
        vm.loadLabel = loadLabel;
        vm.isFolderActive = isFolderActive;
        vm.isLabelActive = isLabelActive;

        // vm.newThread = newThread;
        vm.openThread = openThread;
        vm.closeThread = closeThread;
        vm.closeThreadEdit = closeThreadEdit;

        vm.isSelected = isSelected;
        vm.openUrl = openUrl;
        vm.toggleSelectThread = toggleSelectThread;
        vm.selectThreads = selectThreads;
        vm.deselectThreads = deselectThreads;
        vm.toggleSelectThreads = toggleSelectThreads;

        vm.setThreadStatus = setThreadStatus;
        vm.toggleThreadStatus = toggleThreadStatus;
        vm.toggleItemStatus = toggleItemStatus;
        vm.toggleItemStatusEdit = toggleItemStatusEdit;

        vm.downloadMediaOriginal = downloadMediaOriginal;

        vm.getLabel = getLabel;
        vm.getLabelColor = getLabelColor;
        vm.getLabelTitle = getLabelTitle;
        vm.toggleLabel = toggleLabel;
        vm.isLabelExist = isLabelExist;

        vm.changeView = changeView;
        vm.viewEditInline = viewEditInline;
        vm.viewPreview = viewPreview;
        vm.saveItem = saveItem;
        vm.massActions = massActions;
        vm.MediaItemRecrop = MediaItemRecrop;

        vm.composeDialog = composeDialog;
        vm.replyDialog = replyDialog;
        vm.openImageDialog = openImageDialog;
        vm.openImageDialogMedia = openImageDialogMedia;
        vm.openFocalPoint = openFocalPoint;
        vm.openMediaItemMetadata = openMediaItemMetadata;
        vm.siteLanguages = siteLanguages;
        vm.getCurrentMedia = getCurrentMedia;
        vm.getZoneCrop = getZoneCrop;
        vm.newTag = newTag;
        vm.sectionsAssoc = {};
        vm.showAssoc = showAssoc;
        vm.getShowAssoc = getShowAssoc;
        vm.getSectionRelated = getSectionRelated;
        vm.getCountries = getCountries;
        vm.showCountry = showCountry;
        vm.getShowCountries = getShowCountries;
        vm.dateFormat = sessionService.site_operative.dateFormat;
        vm.dateTimeFormat = sessionService.site_operative.dateTimeFormat;
        vm.showDate = showDate;
        vm.processHtml = processHtml;
        vm.translate = function (text) {
            return $translate.instant(text);
        }

        vm.timeAgo = msUtils.timeAgo;

        function showDate(value) {
            if (angular.isObject(value)) {
                return value.dateShow;
            } else if (value == '0000-00-00 00:00:00' || !value) {
                return '-';
            } else {
                var tz = (sessionService.site_operative.timezone || moment.tz.guess() || 'UTC').toString().trim();
                return moment.utc(value).tz(tz).format(vm.dateTimeFormat || 'DD/MM/YYYY HH:mm');
            }
        }


        vm.tinymceOptions = tinyMceService.getOptions($scope);

        // Attachments
        vm.deleteAttachment = deleteAttachment;
        vm.mediaDialog = mediaDialog;
        vm.mediaDialogTiny = mediaDialogTiny;
        vm.renderTinyMedia = renderTinyMedia;

        vm.toggleSidenav = toggleSidenav;
        vm.isNumber = isNumber;
        vm.updateThread = updateThread;
        vm.callActionToggle = callActionToggle;

        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            var siteID = requestContext.getParam("siteId");
            var section = requestContext.getParam("section");

            contentService.getFilters({ section: section, site: siteID }).then(function (response) {
                $scope.refFilterablesCustom = [
                    {
                        type: "select", name: "MAILING.SOCIAL_NETWORKS", field: "id_subsec", selected: [], values:
                            [
                                { name: "MAILING.SOCIAL_NETWORKS_FACEBOOK", value: 1 },
                                { name: "MAILING.SOCIAL_NETWORKS_TWITTER", value: 2 },
                                { name: "MAILING.SOCIAL_NETWORKS_INSTAGRAM", value: 4 }
                            ]
                    },
                    {
                        type: "select", name: "ON/OFF", field: "onoff", selected: [], values:
                            [
                                { name: "ON", value: 1 },
                                { name: "OFF", value: 0 }
                            ]
                    }
                ];
                vm.mediaZones = (response.media_zones.length == 0)
                    ? null
                    : angular.copy(response.media_zones);
            });

            sessionService.setActiveSection(section).then(function () {
                vm.ActiveSection = sessionService.ActiveSection;
            });


            $scope.$watch('refFilterablesCustom', function (newFilter, oldFilter) {

                if (newFilter !== oldFilter && !angular.isUndefined(oldFilter)) {
                    $scope.refFilterables = $scope.refFilterablesCustom;
                }
                // vm.live.rowJson = angular.toJson(vm.live.row, true);
            }, true);

            $scope.view_medialist = true;
            $scope.siteID = siteID;
            $scope.section = section;
            $rootScope.global.titleToolbar = '<i class="icon s20 icon-web mr-15" ng-if="node.icon"></i> <span class="hide show-gt-xs">' + $translate.instant('CONTENT.CONTENT') + '</span> <i class="mr-5 ml-5 icon s18 icon-chevron-right hide show-gt-xs"></i> ' + section;

            var options = {
                site: $scope.siteID,
                section: $scope.section
            };

            // $scope.page = 1;
            // request the initial set of data
            // loadRemoteData();
            $scope.page = 1;

            if ($state.params.id) {
                // for (var i = 0; i < vm.threads.length; i++) {
                // if (vm.threads[i].id === $state.params.threadId) {
                vm.openThread(null, $state.params.id);
                // break;
                // }
                // }
            }
        }

        // Watch screen size to change view modes
        $scope.$watch(function () {
            return $mdMedia('lt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                vm.currentView = 'nosplit';
            }
        });

        $scope.$watch(function () {
            return $mdMedia('max-width: 960px');
        }, function (big) {

            if (big) {
                vm.currentView = 'nosplit';
            }

        }
        );

        $scope.$watch(function () {
            return $mdMedia('min-width: 960px');
        }, function (small) {

            if (small) {
                vm.currentView = 'nosplit';
            }

        }
        );

        $scope.$watch(function () {
            return $mdMedia('gt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                if (vm.defaultView === 'nosplit') {
                    vm.currentView = 'nosplit';
                }
            }
        });

        $scope.$on('$includeContentLoaded', function (event, target) {
            $timeout(function () {
                vm.loadingView = false;
            }, 1000);
        });

        $scope.$on('pagination:loadStart', function (event) {
            // $anchorScroll();

            // Store the current scrollPos
            // vm.scrollPos = vm.scrollEl.scrollTop();

            // Scroll to the top
            // vm.scrollEl.scrollTop(0);
            if (!vm.enterfirst) {
                var elem = angular.element(document.getElementById('thread-list'));
                elem.scrollTopAnimated(0, 10);
            }

            // angular.element("#thread-list").scrollTop=0;

            vm.enterfirst = false;

            $scope.isLoading = true;
        });

        $scope.$on('pagination:loadPage', function (event) {
            $scope.isLoading = false;
            vm.dataAlreadyLoaded = true;
        });


        function callActionToggle(label, index) {
            vm.toggleInArray(label.value, $scope.refFilterablesCustom[index].selected)
        };

        function selectedItemChange() {
            vm.searchTagText = '';
            vm.selectedTag = null;
        }

        /**
         * Load folder
         *
         * @param name
         */
        function loadFolder(name) {
            // If we are already in the selected folder and
            // there is an open thread just close it
            if (vm.isFolderActive(name)) {
                // Close the current thread if open
                if (vm.currentThread) {
                    vm.closeThread();
                }

                return;
            }

            // Show loader
            $rootScope.loadingProgress = true;

            // Update the state without reloading the controller
            $state.go('app.content.threads', {
                type: null,
                filter: name
            }, { notify: false });

            // Build the API name
            var apiName = 'content.folder.' + name + '@get';

            // Make the call
            msApi.request(apiName).then(
                // Success
                function (response) {
                    // Load new threads
                    vm.threads = response.data;

                    // Set the current filter
                    vm.currentFilter = {
                        type: null,
                        filter: name
                    };

                    // Close the current thread if open
                    if (vm.currentThread) {
                        vm.closeThread();
                    }

                    // Hide loader
                    $rootScope.loadingProgress = false;
                });
        }

        function selectOrUnselect(item, $event) {
            // var indexInTemp = $scope.temps.indexOf(item);
            var isRightClick = $event && $event.which == 3;
            var isDoubleClick = $event && $event.type == 'dblclick';

            // if ($event && $event.target.hasAttribute('prevent')) {
            //     $scope.temps = [];
            //     return;
            // }
            // if (! item || (isRightClick && $scope.isSelected(item))) {
            //     return;
            // }
            // if ($event && $event.shiftKey && !(isRightClick) && !(isDoubleClick)) {
            //     var list = $scope.fileList;
            //     var indexInList = list.indexOf(item);
            //     var lastSelected = $scope.temps[0];
            //     var i = list.indexOf(lastSelected);
            //     var current = undefined;
            //     if (lastSelected && list.indexOf(lastSelected) < indexInList) {
            //         $scope.temps = [];
            //         while (i <= indexInList) {
            //             current = list[i];
            //             !$scope.isSelected(current) && $scope.temps.push(current);
            //             i++;
            //         }
            //         return;
            //     }
            //     if (lastSelected && list.indexOf(lastSelected) > indexInList) {
            //         $scope.temps = [];
            //         while (i >= indexInList) {
            //             current = list[i];
            //             !$scope.isSelected(current) && $scope.temps.push(current);
            //             i--;
            //         }
            //         return;
            //     }
            // }
            // if ($event && !(isRightClick) && !(isDoubleClick) && ($event.ctrlKey || $event.metaKey)) {
            //     $scope.isSelected(item) ? $scope.temps.splice(indexInTemp, 1) : $scope.temps.push(item);
            //     return;
            // }
            // $scope.temps = [item];
        }

        /**
         * Toggle checked status of the content
         *
         * @param content
         * @param event
         */
        function toggleTrueFalseCheck(field, event) {
            if (event) {
                event.stopPropagation();
            }

            vm.selectedContent[field] = !!vm.selectedContent[field];

            // var idx = vm.checked.indexOf(content);

            // if (idx > -1) {
            // 	vm.checked.splice(idx, 1);
            // } else {
            // 	vm.checked.push(content);
            // }
        }

        /**
         * Return checked status of the content
         *
         * @param content
         * @returns {boolean}
         */
        function isTrueFalseChecked(fieldStatus) {
            return !!fieldStatus;
            // return vm.checked.indexOf(content) > -1;
        }

        /**
         * Load label
         *
         * @param name
         */
        function loadLabel(name) {
            // Update the state without reloading the controller
            $state.go('app.content.threads', {
                type: 'label',
                filter: name
            }, { notify: false });

            // If we are already in the selected folder and
            // there is an open thread just close it
            if (vm.isLabelActive(name)) {
                // Close the current thread if open
                if (vm.currentThread) {
                    vm.closeThread();
                }

                return;
            }

            // Show loader
            $rootScope.loadingProgress = true;

            // Build the API name
            var apiName = 'content.label.' + name + '@get';

            // Make the call
            msApi.request(apiName).then(
                // Success
                function (response) {
                    // Load new threads
                    vm.threads = response.data;

                    // Set the current filter
                    vm.currentFilter = {
                        type: 'label',
                        filter: name
                    };

                    // Close the current thread if open
                    if (vm.currentThread) {
                        vm.closeThread();
                    }

                    // Hide loader
                    $rootScope.loadingProgress = false;
                });
        }

        /**
         * Is the folder with the given name active?
         *
         * @param name
         * @returns {boolean}
         */
        function isFolderActive(name) {
            return (vm.currentFilter.type === null && vm.currentFilter.filter === name);
        }

        /**
         * Is the label with the given name active?
         *
         * @param name
         * @returns {boolean}
         */
        function isLabelActive(name) {
            return (vm.currentFilter.type === 'label' && vm.currentFilter.filter === name);
        }

        /**
         * Open thread
         *
         * @param thread
         */
        function openThread(thread, id, index) {
            // Set the read status on the thread
            // thread.read = true;
            $scope.$safeApply(function () {

                vm.thumbnails_Edit = {};
                vm.editInline = false;
                vm.currentThread_Edit = null;
                vm.currentThread_ref = null;
            });


            if (angular.element(document.getElementById('thread-detail')).length) {
                var elem = angular.element(document.getElementById('thread-detail'));
                elem.scrollTopAnimated(0, 10);
            }
            // pagesShown = 1;
            if (thread) {
                vm.selectedContentID = thread.id;
            }
            else if (id) {
                vm.selectedContentID = id;
            }
            if (vm.selectedContentID != 'new') {
                vm.editInline = false;

                vm.loadingReadPane = true;

                $state.go('app.site_overview.content.list.social_stream.thread', {
                    id: vm.selectedContentID
                }, {
                        notify: false,
                        inherit: true,
                        location: true
                    });

                vm.currentView = 'split';

                var options = {
                    site: $scope.siteID,
                    section: $scope.section,
                    id: vm.selectedContentID
                };

                contentService.getByID(options).then(function (response) {
                    $scope.$safeApply(function () {
                        vm.selectedContent = response.result;
                        vm.selectedIndex = index;
                        vm.currentThread = response.result;
                        vm.log = response.log;
                    });
                    vm.updateThread(vm.currentThread);

                    for (var i = response.ref.length - 1; i >= 0; i--) {
                        if (response.ref[i].type.substr(0, 4) == 'date') {

                            var value = vm.selectedContent[response.ref[i].titleId];
                            if (value == '0000-00-00 00:00:00') {
                                value = moment().utc().format("YYYY-MM-DD");
                            }

                            var utcDate = moment.utc(value);

                            var siteDate = moment.utc(value).tz(sessionService.site_operative.timezone);

                            vm.selectedContent[response.ref[i].titleId] = {};
                            vm.selectedContent[response.ref[i].titleId]['value'] = value;
                            vm.selectedContent[response.ref[i].titleId]['date'] = new Date(siteDate.format());
                            vm.selectedContent[response.ref[i].titleId]['dateShow'] = siteDate.format(vm.dateTimeFormat);
                            vm.selectedContent[response.ref[i].titleId]['utcShow'] = utcDate.format(vm.dateTimeFormat);
                            vm.selectedContent[response.ref[i].titleId]['utcDate'] = utcDate;
                        }
                    }
                    vm.selectedContent_ref = response.ref;
                    vm.selectedContent_refgrouped = _.groupBy(response.ref, function (m) {
                        return m.preview_position;
                    });
                    vm.loadingReadPane = false;

                })
                    .then(function () {
                        contentService.getTags(options).then(function (response) {
                            vm.tags = angular.copy(response.tags);
                            sessionService.site_operative.tags = vm.tags;
                        });
                    });
            }
        }


        // function newThread() {
        //     if (angular.element(document.getElementById('thread-detail')).length) {
        //         var elem = angular.element(document.getElementById('thread-detail'));
        //         elem.scrollTopAnimated(0, 10);
        //     }

        //     vm.selectedContentID = '';
        //     vm.editInline = false;
        //     vm.loadingReadPane = true;

        //     $state.go('app.site_overview.content.list.social_stream.thread', {
        //         id: ''
        //     }, {
        //             notify: false,
        //             inherit: true,
        //             location: true
        //         });

        //     var options = {
        //         site: $scope.siteID,
        //         section: $scope.section
        //     };

        //     contentService.getNew(options).then(function (response) {
        //         vm.selectedContent = {
        //             Thumbnail: [],
        //             tags: []
        //         };
        //         vm.currentThread = '';
        //         vm.log = [];
        //         for (var i = response.ref.length - 1; i >= 0; i--) {
        //             if (response.ref[i].type.substr(0, 4) == 'date') {

        //                 var value = moment().utc().format("YYYY-MM-DD HH:mm:00");

        //                 var utcDate = moment.utc(value);

        //                 var siteDate = moment.utc(value).tz(sessionService.site_operative.timezone);

        //                 vm.selectedContent[response.ref[i].titleId] = {};
        //                 vm.selectedContent[response.ref[i].titleId]['value'] = value;
        //                 vm.selectedContent[response.ref[i].titleId]['date'] = new Date(siteDate.format());
        //                 vm.selectedContent[response.ref[i].titleId]['dateShow'] = siteDate.format(vm.dateTimeFormat);
        //                 vm.selectedContent[response.ref[i].titleId]['utcShow'] = utcDate.format(vm.dateTimeFormat);
        //                 vm.selectedContent[response.ref[i].titleId]['utcDate'] = utcDate;
        //             }
        //         }
        //         vm.selectedContent_ref = response.ref;
        //         vm.selectedContent_refgrouped = _.groupBy(response.ref, function (m) {
        //             return m.preview_position;
        //         });
        //         vm.loadingReadPane = false;
        //         vm.viewEditInline();
        //     });
        // }

        /**
         * Close thread Edit
         */
        function closeThreadEdit() {
            resetScroll();
            vm.editInline = false;
            vm.currentThread = null;
            vm.currentThread_Edit = false;
            vm.currentThread_ref = false;
            vm.selectedContentID = null;
            vm.currentView = 'nosplit';
            vm.selectedContent = false;
            vm.selectedIndex = null;
        }

        /**
         * Close thread
         */
        function closeThread() {
            vm.editInline = false;

            vm.currentThread = null;
            vm.currentThread_Edit = false;
            vm.selectedContent = null;
            vm.selectedIndex = null;
            vm.selectedContentID = null;
            vm.currentView = 'nosplit';
            // Update the state without reloading the controller
            $state.go('app.site_overview.content.list.social_stream', {
                type: vm.currentFilter.type,
                filter: vm.currentFilter.filter
            }, { notify: false });
        }

        /**
         * Add label chips
         *
         * @param query
         * @returns {filterFn}
         */
        function labelQuerySearch(query) {
            return query
                ? vm.tags.filter(vm.createFilterFor(query))
                : [];
        }

        /**
         * Filter for chips
         *
         * @param query
         * @returns {filterFn}
         */
        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(item) {
                if (angular.isUndefined(item.tag_name)) {
                    return false;
                }
                if (!item.tag_name) {
                    return false;
                }
                if (!angular.lowercase(item.tag_name).indexOf) {
                    return false;
                }
                return angular.lowercase(item.tag_name).indexOf(lowercaseQuery) >= 0;
            };
        }

        /**
         * Return checked status of the content
         *
         * @param content
         * @returns {boolean}
         */
        function saveItem(content) {

            vm.savingProcess = true;
            var newContent = angular.copy(content);
            //console.log(newContent);return;
            for (var i = vm.currentThread_ref.length - 1; i >= 0; i--) {
                if (vm.currentThread_ref[i].type.substr(0, 4) == 'date') {
                    newContent[vm.currentThread_ref[i].titleId] = newContent[vm.currentThread_ref[i].titleId].value;
                }
                else if (vm.currentThread_ref[i].type.substr(0, 4) == 'html') {
                    var newHtml = newContent[vm.currentThread_ref[i].titleId];
                    var str = newContent[vm.currentThread_ref[i].titleId];
                    var regex = /<div\b[^>]*data-qiumedia="(.*?)"(.*?)[ˆ"]*[^>]*><\/div>/g;
                    var m;
                    while ((m = regex.exec(str)) !== null) {
                        // This is necessary to avoid infinite loops with zero-width matches
                        if (m.index === regex.lastIndex) {
                            regex.lastIndex++;
                        }

                        if (m[0] && m[1]) {
                            newHtml = newHtml.replace(m[0], '[' + m[1] + ']');
                        }
                        /*
                                    // The result can be accessed through the `m`-variable.
                                    m.forEach((match, groupIndex) => {
                                        console.log(`Found match, group ${groupIndex}: ${match}`);
                                    });
                                    */
                    }
                    newContent[vm.currentThread_ref[i].titleId] = newHtml;

                }
            }
            if (!content.id) {
                content.id = 'new';
            }

            var options = {
                site: $scope.siteID,
                section: $scope.section,
                id: content.id,
                item: newContent
            };
            contentService.saveItem(options).then(function (response) {
                if (content.id == 'new') {
                    content.id = response.id;
                    $rootScope.pagination_resetquery();
                    vm.viewPreview();
                    vm.openThread('', response.id);
                }
                else {
                    // vm.viewPreview();
                    vm.openThread(content);
                }
                // vm.closeThreadEdit();

                vm.savingProcess = false;


                var message = $translate.instant('CONTENT.SAVED');
                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                    hideDelay: 5000,
                    position: 'top',
                    parent: '#content-container'
                });
                return true;
            });
        }

        /**
         * Return checked status of the content
         *
         * @param content
         * @returns {boolean}
         */
        function massActions(action) {

            if (vm.selectedThreads.length === 0) {
                return false;
            }
            var selectedIds = [];

            for (var i = 0; i < vm.selectedThreads.length; i++) {
                selectedIds.push(vm.selectedThreads[i].id);
            }
            switch (action) {
                case 'delete':
                    if (selectedIds.length == 1) {
                        var messageConfirm = $translate.instant('CONTENT.SURE_DELETED_SINGULAR');

                        var confirm = $mdDialog.confirm().title(messageConfirm)
                            // .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' will be deleted.')
                            .ariaLabel('Delete item').ok('OK').cancel('CANCEL');
                        var message = $translate.instant('CONTENT.DELETED');
                    }
                    else {
                        var messageConfirm = $translate.instant('CONTENT.SURE_DELETED_PLURAL');

                        var confirm = $mdDialog.confirm().title(messageConfirm)
                            // .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' will be deleted.')
                            .ariaLabel('Delete item').ok('OK').cancel('CANCEL');
                        var message = $translate.instant('CONTENT.DELETED');
                    }
                    break;
                case 'duplicate':
                    if (selectedIds.length == 1) {
                        var messageConfirm = $translate.instant('CONTENT.SURE_DUPLICATED_SINGULAR');
                        var confirm = $mdDialog.confirm().title(messageConfirm)
                            // .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' will be deleted.')
                            .ariaLabel('Duplicate item').ok('OK').cancel('CANCEL');
                        var message = $translate.instant('CONTENT.DUPLICATED');
                    }
                    else {
                        var messageConfirm = $translate.instant('CONTENT.SURE_DUPLICATED_PLURAL');
                        var confirm = $mdDialog.confirm().title(messageConfirm)
                            // .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' will be deleted.')
                            .ariaLabel('Duplicate item').ok('OK').cancel('CANCEL');
                        var message = $translate.instant('CONTENT.DUPLICATED');
                    }
                    break;
            }


            $mdDialog.show(confirm).then(function () {

                var options = {
                    site: $scope.siteID,
                    section: $scope.section,
                    type: action,
                    item: selectedIds
                };

                contentService.massActions(options).then(function (response) {
                    vm.toggleSelectThreads();
                    $rootScope.pagination_resetquery();
                    vm.closeThread();
                    $mdToast.show({
                        template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                        hideDelay: 5000,
                        position: 'top',
                        parent: '#content-container'
                    });
                });
            });

        }

        /**
         * Return checked status of the content
         *
         * @param content
         * @returns {boolean}
         */
        function MediaItemRecrop(image) {

            var messageConfirm = $translate.instant('CONTENT.MEDIA_ITEM_SURE_RECROP');

            var confirm = $mdDialog.confirm().title(messageConfirm).htmlContent('')
                .ariaLabel('Delete item').ok('OK').cancel('CANCEL');
            var message = $translate.instant('CONTENT.MEDIA_ITEM_FINISH_RECROP');


            $mdDialog.show(confirm).then(function () {

                var imageToSave = {
                    'forceRecrop': true,
                    'tags': []
                };

                var options = {
                    site: $scope.siteID,
                    id: image.id_media,
                    item: imageToSave
                };

                mediaService.saveMedia(options).then(function (response) {
                    $mdToast.show({
                        template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                        hideDelay: 5000,
                        position: 'top',
                        parent: '#content-container'
                    });
                });
            });

        }

        $scope.closeToast = function () {
            if (isDlgOpen) {
                return;
            }

            $mdToast.hide().then(function () {
                isDlgOpen = false;
            });
        };

        /**
         * Return selected status of the thread
         *
         * @param thread
         * @returns {boolean}
         */
        function isSelected(thread) {
            return vm.selectedThreads.indexOf(thread) > -1;
        }

        /**
         * Return selected status of the thread
         *
         * @param thread
         * @returns {boolean}
         */
        function openUrl(url) {
            $window.open(url, '_blank');
        }

        /**
         * Toggle selected status of the thread
         *
         * @param thread
         * @param event
         */
        function toggleSelectThread(thread, event) {
            if (event) {
                event.stopPropagation();
            }

            if (vm.selectedThreads.indexOf(thread) > -1) {
                vm.selectedThreads.splice(vm.selectedThreads.indexOf(thread), 1);
            }
            else {
                vm.selectedThreads.push(thread);
            }
        }

        /**
         * Select threads. If key/value pair given,
         * threads will be tested against them.
         *
         * @param [key]
         * @param [value]
         */
        function selectThreads(key, value) {
            // Make sure the current selection is cleared
            // before trying to select new threads
            vm.selectedThreads = [];

            for (var i = 0; i < vm.threads.length; i++) {
                if (angular.isUndefined(key) && angular.isUndefined(value)) {
                    vm.selectedThreads.push(vm.threads[i]);
                    continue;
                }

                if (angular.isDefined(key) && angular.isDefined(value) && vm.threads[i][key] === value) {
                    vm.selectedThreads.push(vm.threads[i]);
                }
            }
        }

        /**
         * Deselect threads
         */
        function updateThread(itemThread) {
            for (var i = 0; i < vm.threads.length; i++) {
                if (vm.threads[i]['id'] == itemThread['id']) {
                    vm.threads[i] = itemThread;
                }
                // if (angular.isUndefined(key) && angular.isUndefined(value)) {
                // 	vm.selectedThreads.push(vm.threads[i]);
                // 	continue;
                // }

                // if (angular.isDefined(key) && angular.isDefined(value) && vm.threads[i][key] === value) {
                // 	vm.selectedThreads.push(vm.threads[i]);
                // }
            }
        }

        /**
         * Deselect threads
         */
        function deselectThreads() {
            vm.selectedThreads = [];
        }

        /**
         * Toggle select threads
         */
        function toggleSelectThreads() {
            if (vm.selectedThreads.length > 0) {
                vm.deselectThreads();
            }
            else {
                vm.selectThreads();
            }
        }

        /**
         * Set the status on given thread, current thread or selected threads
         *
         * @param key
         * @param value
         * @param [thread]
         * @param [event]
         */
        function setThreadStatus(key, value, thread, event) {
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if (event) {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if (thread) {
                thread[key] = value;
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if (vm.currentThread) {
                vm.currentThread[key] = value;
                return;
            }

            // Otherwise do the status update on selected threads
            for (var x = 0; x < vm.selectedThreads.length; x++) {
                vm.selectedThreads[x][key] = value;
            }
        }

        /**
         * Toggle the value of the given key on given thread, current
         * thread or selected threads. Given key value must be boolean.
         *
         * @param key
         * @param thread
         * @param event
         */
        function toggleItemStatus(thread, event, key) {

            event.stopPropagation();

            var confirm = $mdDialog.confirm().title('Are you sure want to set the item?').htmlContent('<b>This item will be changed </b>.')
                // .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' will be deleted.')
                .ariaLabel('change item').ok('OK').cancel('CANCEL');

            $mdDialog.show(confirm).then(function () {

                thread.onoff = (thread.onoff === 1)
                    ? 0
                    : 1;

                vm.threads[key].onoff = thread.onoff;

                delete thread['date'];
                var options = {
                    site: $scope.siteID,
                    section: $scope.section,
                    id: vm.threads[key].id,
                    item: angular.copy(thread)
                };
                delete options.item.created_at;

                contentService.saveItem(options).then(function (response) {
                    // vm.viewPreview();
                    // vm.selectContent(content);
                    var message = $translate.instant('CONTENT.SAVED');

                    $mdToast.show({
                        template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                        hideDelay: 3000,
                        position: 'top',
                        parent: '#content-container',
                        theme: "success-toast"
                    });

                    return true;
                });

            }, function () {
                // alert("cancel")

            });

            return;
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if (event) {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if (thread) {
                if (typeof (thread[key]) !== 'boolean') {
                    return;
                }

                thread[key] = !thread[key];
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if (vm.currentThread) {
                if (typeof (vm.currentThread[key]) !== 'boolean') {
                    return;
                }

                vm.currentThread[key] = !vm.currentThread[key];
                return;
            }

            // Otherwise do the status update on selected threads
            for (var x = 0; x < vm.selectedThreads.length; x++) {
                if (typeof (vm.selectedThreads[x][key]) !== 'boolean') {
                    continue;
                }

                vm.selectedThreads[x][key] = !vm.selectedThreads[x][key];
            }
        }

        /**
         * Toggle the value of the given key on given thread, current
         * thread or selected threads. Given key value must be boolean.
         *
         * @param key
         * @param thread
         * @param event
         */
        function toggleItemStatusEdit(fieldName) {

            var thread = vm.currentThread_Edit[fieldName];
            thread = (thread === 1)
                ? 0
                : 1;
            vm.currentThread_Edit[fieldName] = thread;
            vm.basicForm.$setDirty()
        }

        function deleteAttachment(attachment) {

            if (attachment.id_zone) {
                for (var i = 0; i < vm.currentThread_Edit.Thumbnail.length; i++) {
                    if (vm.currentThread_Edit.Thumbnail[i].id_zone === attachment.id_zone) {

                        if (angular.isDefined(attachment.id_media) &&
                            vm.currentThread_Edit.Thumbnail[i].id_media === attachment.id_media) {
                        }
                        else if (attachment.id_gallery > 0 &&
                            vm.currentThread_Edit.Thumbnail[i].id_gallery === attachment.id_gallery) {
                        }
                        else {
                            continue;
                        }
                        vm.currentThread_Edit.Thumbnail.splice(i, 1);
                    }
                }

                for (var i = 0; i < vm.thumbnails_Edit[attachment.id_zone].length; i++) {
                    if (angular.isDefined(attachment.id_media) &&
                        vm.thumbnails_Edit[attachment.id_zone][i].id_media === attachment.id_media) {
                        vm.thumbnails_Edit[attachment.id_zone].splice(i, 1);
                    }
                    else if (attachment.id_gallery > 0 &&
                        vm.thumbnails_Edit[attachment.id_zone][i].id_gallery === attachment.id_gallery) {
                        vm.thumbnails_Edit[attachment.id_zone].splice(i, 1);
                    }
                }

            }
            else {
                for (var i = 0; i < vm.currentThread_Edit.Thumbnail.length; i++) {
                    if (angular.isDefined(attachment.id_media) &&
                        vm.currentThread_Edit.Thumbnail[i].id_media === attachment.id_media) {

                    } else if (attachment.id_gallery > 0 &&
                        vm.currentThread_Edit.Thumbnail[i].id_gallery === attachment.id_gallery) {

                    } else {
                        continue;
                    }
                    vm.currentThread_Edit.Thumbnail.splice(i, 1);
                }
            }
            vm.basicForm.$setDirty()

        }

        /**
         * Toggle the value of the given key on given thread, current
         * thread or selected threads. Given key value must be boolean.
         *
         * @param key
         * @param thread
         * @param event
         */
        function toggleThreadStatus(key, thread, event) {
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if (event) {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if (thread) {
                if (typeof (thread[key]) !== 'boolean') {
                    return;
                }

                thread[key] = !thread[key];
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if (vm.currentThread) {
                if (typeof (vm.currentThread[key]) !== 'boolean') {
                    return;
                }

                vm.currentThread[key] = !vm.currentThread[key];
                return;
            }

            // Otherwise do the status update on selected threads
            for (var x = 0; x < vm.selectedThreads.length; x++) {
                if (typeof (vm.selectedThreads[x][key]) !== 'boolean') {
                    continue;
                }

                vm.selectedThreads[x][key] = !vm.selectedThreads[x][key];
            }
        }

        function downloadMediaOriginal(media) {
            switch (media.media_type) {
                case 1:
                    var url = media.container.view_url + 'original/m' + media.id_media + '_' + media.filename;

                    break;
                case 2:
                    if (media.embed_thumb) {
                        var url = media.embed_thumb;
                    }
                    else if (!media.embed && !media.embed_code && !media.embed_thumb && !media.embed_url) {
                        var url = media.container.view_url + 'videos/m' + media.id_media + '_' + media.filename;
                    }
                    break;
                case 4:
                    var url = media.container.view_url + 'files/m' + media.id_media + '_' + media.filename;

                    // vm.image.imageUrl = cropstatus.container.view_url + cropstatus.fileName;
                    break;
            }
            if (url) {
                msUtils.openUrl(url)
            }
        }

        /**
         * Get label object content
         *
         * @param id
         * @returns {*}
         */
        function getLabel(id) {
            for (var i = 0; i < vm.labels.length; i++) {
                if (vm.labels[i].id === id) {
                    return vm.labels[i];
                }
            }
        }

        /**
         * Get label color from label object
         *
         * @param id
         * @returns {*}
         */
        function getLabelColor(id) {
            return vm.getLabel(id).color;
        }

        /**
         * Get label title from label object
         *
         * @param id
         * @returns {*}
         */
        function getLabelTitle(id) {
            return vm.getLabel(id).title;
        }

        /**
         * Toggle label
         *
         * @param label
         */
        function toggleLabel(label) {
            // Toggle label on the currently open thread
            if (vm.currentThread) {
                if (vm.currentThread.labels.indexOf(label.id) > -1) {
                    vm.currentThread.labels.splice(vm.currentThread.labels.indexOf(label.id), 1);
                }
                else {
                    vm.currentThread.labels.push(label.id);
                }

                return;
            }

            // Toggle labels on selected threads
            // Toggle action will be determined by the first thread from the selection.
            if (vm.selectedThreads.length > 0) {
                // Decide if we are going to remove or add labels
                var removeLabels = (vm.selectedThreads[0].labels.indexOf(label.id) > -1);

                for (var i = 0; i < vm.selectedThreads.length; i++) {
                    if (!removeLabels) {
                        vm.selectedThreads[i].labels.push(label.id);
                        continue;
                    }

                    if (vm.selectedThreads[i].labels.indexOf(label.id) > -1) {
                        vm.selectedThreads[i].labels.splice(vm.selectedThreads[i].labels.indexOf(label.id), 1);
                    }
                }
            }
        }

        /**
         * Is label exist?
         *
         * @param label
         * @returns {boolean}
         */
        function isLabelExist(label) {
            if (vm.currentThread && vm.currentThread.labels) {
                return (vm.currentThread.labels.indexOf(label.id) > -1);
            }
        }

        /**
         * Change the view
         *
         * @param view
         */
        function changeView(view) {
            if (vm.views[view]) {
                vm.loadingView = true;
                vm.defaultView = view;
                vm.currentView = view;
            }
        }

        /**
         * Toggle view Edit
         */
        function viewEditInline() {
            resetScroll();

            vm.thumbnails_Edit = {};
            vm.editInline = true;
            vm.currentThread_Edit = angular.copy(vm.selectedContent);
            vm.currentThread_ref = angular.copy(vm.selectedContent_ref);
            if (vm.mediaZones) {
                angular.forEach(vm.mediaZones, function (mz) {
                    if (angular.isUndefined(vm.thumbnails_Edit[mz.id_zone])) {
                        vm.thumbnails_Edit[mz.id_zone] = [];
                    }
                });
                angular.forEach(vm.currentThread_Edit.Thumbnail, function (thumb) {
                    if (thumb.id_zone > 0) {
                        vm.thumbnails_Edit[thumb.id_zone].push(thumb);
                    }
                })
            }
            angular.forEach(vm.selectedContent_ref, function (refColumn) {
                switch (refColumn.type) {
                    case 'date':
                    case 'dateHm':
                        var type = 'input';
                        break;
                    case 'single':
                        var type = 'input';
                        break;
                    default:
                        break;
                }
            });
        }

        /**
         * Toggle view Edit
         */
        function viewPreview() {
            resetScroll();
            vm.editInline = false;
        }

        function resetScroll() {
            if (angular.element(document.getElementById('thread-detail')).length) {
                var elem = angular.element(document.getElementById('thread-detail'));
                elem.scrollTopAnimated(0, 10);
            }
        }

        /**
         * Open compose dialog
         *
         * @param ev
         */

        function composeDialog(ev) {
            $mdDialog.show({
                controller: 'ComposeDialogController',
                controllerAs: 'vm',
                locals: {
                    selectedContent: undefined
                },
                templateUrl: 'app/main/dialogs/compose/compose-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        }


        /**
         * Open Image dialog media
         *
         * @param ev
         * @param task
         */
        function openImageDialogMedia(ev, ImageSelected) {
            var images = angular.copy(images);

            $mdDialog.show({
                controller: 'MediaShowDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/dialogs/media-show/media-show-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Images: [],
                    ImageSelected: ImageSelected,
                    cropFormats: false,
                    MediaFull: false
                }
            });
        }

        /**
         * Open Image dialog
         *
         * @param ev
         * @param task
         */
        function openImageDialog(ev, images, ImageSelected) {
            var images = angular.copy(images);

            // preview only images and video
            for (var i = images.length - 1; i >= 0; i--) {
                if (angular.isUndefined(images[i].media_type) ||
                    [1, 2].indexOf(parseInt(images[i].media_type)) < 0) {
                    images.splice(i, 1);
                }
            }

            $mdDialog.show({
                controller: 'MediaShowDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/dialogs/media-show/media-show-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Images: images,
                    ImageSelected: ImageSelected,
                    cropFormats: false,
                    MediaFull: false,
                    Tags: false,
                    // Tasks: vm.tasks,
                    // event: ev
                }
            });
        }

        /**
         * Open Image dialog
         *
         * @param ev
         * @param task
         */
        function openImageDialog(ev, images, ImageSelected) {
            var images = angular.copy(images);

            // preview only images and video
            for (var i = images.length - 1; i >= 0; i--) {
                if (angular.isUndefined(images[i].media_type) ||
                    [1, 2].indexOf(parseInt(images[i].media_type)) < 0) {
                    images.splice(i, 1);
                }
            }

            $mdDialog.show({
                controller: 'MediaShowDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/dialogs/media-show/media-show-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Images: images,
                    ImageSelected: ImageSelected,
                    cropFormats: false,
                    MediaFull: false,
                    Tags: false,
                    // Tasks: vm.tasks,
                    // event: ev
                }
            });
        }

        /**
         * Open Image dialog
         *
         * @param ev
         * @param task
         */
        function openFocalPoint(ev, ImageSelected) {
            $mdDialog.show({
                controller: 'MediaFocalPointDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/dialogs/media-focal-point/media-focal-point-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    ImageSelected: ImageSelected,
                }
            }).then(function (item) {
                vm.basicForm.$setDirty();
                angular.forEach(vm.mediaZones, function (mediazone) {
                    angular.forEach(vm.thumbnails_Edit[mediazone.id_zone], function (attachment) {
                        if (item.id_media === attachment.id_media) {
                            attachment.imageCenterRatioX = item.imageCenterRatioX;
                            attachment.imageCenterRatioY = item.imageCenterRatioY;
                        }
                    })
                })
            });
        }

        /**
         * Open Metadata Image
         *
         * @param ev
         * @param task
         */
        function openMediaItemMetadata(ev, ImageSelected) {
            $mdDialog.show({
                controller: 'MediaItemMetadataDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/dialogs/media-item-metadata/media-item-metadata-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    ImageSelected: ImageSelected,
                }
            }).then(function (item) {

                vm.basicForm.$setDirty();
                if (item) {
                    angular.forEach(vm.currentThread_Edit.Thumbnail, function (media) {
                        if (item.id_media === media.id_media) {
                            angular.forEach(media, function (value, key) {
                                // console.log(key)
                                if (item[key]) {
                                    media[key] = item[key];
                                    console.log("setting: " + key);

                                }
                            })
                        }
                    })
                }
            });
        }

        /**
         * Open compose dialog
         *
         * @param ev
         */

        function mediaDialog(ev, mediazone, item) {
            $mdDialog.show({
                controller: 'MediaDialogController',
                controllerAs: 'vm',
                locals: {
                    autoUpload: '',
                    currentThread: item,
                    section: $scope.section,
                    mediazone: mediazone,
                    isTiny: false,
                    maxAttach: undefined,
                    showViews: {
                        1: true,
                        2: true,
                        3: true,
                        4: true,
                        5: true,
                        upload: true,
                        import: true
                    }
                },
                templateUrl: 'app/main/dialogs/media/media-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            }).then(function (item) {
                vm.currentThread_Edit = item;
                vm.basicForm.$setDirty();
                vm.thumbnails_Edit = {};
                if (vm.mediaZones) {
                    angular.forEach(vm.mediaZones, function (mz) {
                        if (angular.isUndefined(vm.thumbnails_Edit[mz.id_zone])) {
                            vm.thumbnails_Edit[mz.id_zone] = [];
                        }
                    });
                    angular.forEach(vm.currentThread_Edit.Thumbnail, function (thumb) {

                        if (angular.isUndefined(vm.thumbnails_Edit[thumb.id_zone])) {
                            vm.thumbnails_Edit[thumb.id_zone] = [];
                        }
                        vm.thumbnails_Edit[thumb.id_zone].push(thumb);
                    })
                }
            });
        }

        /**
         * Open TinyMCE media selector
         *
         * @param item
         */

        function mediaDialogTiny(item) {
            $mdDialog.show({
                controller: 'MediaDialogController',
                controllerAs: 'vm',
                locals: {
                    autoUpload: '',
                    currentThread: item,
                    section: $scope.section,
                    mediazone: 1,
                    isTiny: 1,
                    maxAttach: undefined,
                    showViews: {
                        1: true,
                        2: true,
                        3: true,
                        4: true,
                        5: true,
                        upload: true,
                        import: true
                    }
                },
                templateUrl: 'app/main/dialogs/media/media-dialog-tinymce.html',
                parent: angular.element($document.body),
                clickOutsideToClose: true
            }).then(function (item) {

                /*
                                vm.currentThread_Edit = item;

                                vm.basicForm.$setDirty()
                                vm.thumbnails_Edit = {};
                                angular.forEach(vm.mediaZones, function (mz) {
                                    if (angular.isUndefined(vm.thumbnails_Edit[mz.id_zone])) {
                                        vm.thumbnails_Edit[mz.id_zone] = [];
                                    }
                                })
                                angular.forEach(vm.currentThread_Edit.Thumbnail, function (thumb) {
                                    vm.thumbnails_Edit[thumb.id_zone].push(thumb);
                                })
                */
            });
        }

        /**
         * Open reply dialog
         *
         * @param ev
         */
        function replyDialog(ev) {
            $mdDialog.show({
                controller: 'ComposeDialogController',
                controllerAs: 'vm',
                locals: {
                    selectedContent: vm.selectedContent
                },
                templateUrl: 'app/main/dialogs/compose/compose-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        function isNumber(value) {
            return angular.isNumber(value);
        }

        function siteLanguages() {
            return sessionService.getSiteLanguages();
        }

        function dateSelectedCallback(date, fieldName) {
            console.log(date, fieldName)
        }

        function getCurrentMedia() {
            return vm.currentThread_Edit.Thumbnail;
        }

        function getZoneCrop(field) {
            var cropId = '';
            if (!angular.isUndefined(field.id_cropformats)) {
                cropId = field.id_cropformats;
            }
            return cropId;
        }

        function newTag(tagName) {
            var newTag = {
                id_tag: '',
                tag_name: tagName
            };
            vm.tags.push(newTag);
            vm.currentThread_Edit.tags.push(newTag);
            vm.searchTagText = '';
        }

        function getCountries() {
            if (angular.isUndefined(vm.allCountries)) {
                vm.allCountries = [];
                var options = {
                    paginate: 99999,
                };
                contentService.getCountries(options).then(function (response) {
                    if (response.total) {
                        angular.forEach(response.data, function (item) {
                            var resultId = item['id_country'];
                            var resultData = {
                                id: resultId,
                                code: item['code'],
                                name: item['country']
                            };
                            vm.allCountries.push(resultData);
                        })
                    }
                })
            }

        }

        function showCountry(itemId, fieldData) {
            var ret = '';
            if (itemId) {
                vm.getCountries();
                angular.forEach(vm.allCountries, function (c) {
                    if (c.id == itemId) {
                        ret = c.name;
                    }
                })
            }
            return ret;
        }

        function getShowCountries(fieldData) {
            var ret = '';
            vm.getCountries();
            if (!angular.isUndefined(vm.allCountries)) {
                return vm.allCountries;
            }
            else {
                return {};
            }
        }

        function getSectionRelated(rawSettings, keyHash) {
            if (angular.isUndefined(vm.sectionsAssoc[keyHash])) {
                vm.sectionsAssoc[keyHash] = [];
                var options = {
                    siteID: $scope.siteID,
                    section: rawSettings.fromSection,
                    resultsPerPage: 99999,
                };
                if (!angular.isUndefined(rawSettings.orderField)) {
                    var sortOrder = 'DESC';
                    if (!angular.isUndefined(rawSettings.orderSort)) {
                        sortOrder = rawSettings.orderSort;
                    }
                    options.sort = '{"titleId":"' + rawSettings.orderField + '","order":"' + sortOrder + '"}';
                }

                contentService.get(options).then(function (response) {
                    if (response.result.total) {
                        angular.forEach(response.result.data, function (item) {
                            var resultId = item['id'];
                            var resultData = {
                                id: resultId,
                                val: item[rawSettings.showField]
                            };
                            vm.sectionsAssoc[keyHash].push(resultData);
                        })
                    }
                })
            }

        }

        function showAssoc(itemId, fieldData) {
            if (!fieldData.raw_settings) {
                return '';
            }
            else {
                var ret = '';
                var rawSettings = JSON.parse(fieldData.raw_settings);
                var keyHash = fieldData.raw_settings;
                vm.getSectionRelated(rawSettings, keyHash);
                angular.forEach(vm.sectionsAssoc[keyHash], function (secData) {
                    if (secData.id == itemId) {
                        ret = secData.val;
                    }
                });
                return ret;
            }
        }

        function getShowAssoc(fieldData) {
            if (!fieldData.raw_settings) {
                return '';
            }
            else {
                var rawSettings = JSON.parse(fieldData.raw_settings);
                var keyHash = fieldData.raw_settings;
                vm.getSectionRelated(rawSettings, keyHash);
                if (!angular.isUndefined(vm.sectionsAssoc[keyHash])) {
                    return vm.sectionsAssoc[keyHash];
                }
                else {
                    return {};
                }
            }
        }

        function getZoneMediaArray() {
            var zoneMedia = {
                1: {},
                2: {},
                3: {},
                4: {},
                5: {}
            };
            var typesMax = {
                1: 0,
                2: 0,
                3: 0,
                4: 0,
                5: 0
            };
            var currentSort = 0;
            var currentType = 0;
            if (vm.currentThread) {
                for (var i = 0; i < vm.currentThread.Thumbnail.length; i++) {
                    if (vm.mediaZones) {
                        if (vm.currentThread.Thumbnail[i]['id_zone'] == 1) {
                            currentSort = vm.currentThread.Thumbnail[i]['sort'];
                            if (vm.currentThread.Thumbnail[i]['media_type']) {
                                currentType = vm.currentThread.Thumbnail[i]['media_type'];
                            } else {
                                currentType = 5; //gallery
                            }
                            typesMax[currentType]++;
                            zoneMedia[currentType][typesMax[currentType]] = vm.currentThread.Thumbnail[i];
                        }
                    }
                    else {
                        currentSort = vm.currentThread.Thumbnail[i]['sort'];
                        if (vm.currentThread.Thumbnail[i]['media_type']) {
                            currentType = vm.currentThread.Thumbnail[i]['media_type'];
                        } else {
                            currentType = 5; //gallery
                        }
                        typesMax[currentType]++;
                        zoneMedia[currentType][typesMax[currentType]] = vm.currentThread.Thumbnail[i];

                    }
                }
            }
            return zoneMedia;
        }

        function processHtml(content) {
            var newCont = content;
            var zoneMedia = getZoneMediaArray();
            var validData = {
                left: 'align-left',
                center: 'align-center',
                right: 'align-right',
                25: 'size-25',
                50: 'size-50',
                75: 'size-75',
                100: 'size-100',
            };

            // Regex for Images
            var regex = /(\[image\|([^\]]*)\])/g;
            var m;
            while ((m = regex.exec(content)) !== null) {
                var expCont = '';
                var mediaData = {
                    type: '',
                    sort: '',
                    class: ''
                };
                var mediaExtra = '';
                // This is necessary to avoid infinite loops with zero-width matches
                if (m.index === regex.lastIndex) {
                    regex.lastIndex++;
                }
                if (m[2]) {
                    expCont = m[2].split('|');
                    mediaData.type = 'image';
                    for (var i = 0; i < expCont.length; i++) {
                        if (i == 0) {
                            mediaData.sort = expCont[i];
                        }
                        else {
                            mediaExtra = expCont[i];
                            if (!angular.isUndefined(validData[mediaExtra])) {
                                mediaData.class += validData[mediaExtra] + ' ';
                            }
                        }
                    }
                    var newHtml = '';
                    if (!angular.isUndefined(zoneMedia[1][mediaData.sort])) {
                        newHtml = '<div class="qiumedia-read" style="background: #efefef;"><img src="' + zoneMedia[1][mediaData.sort].cropstatus[0].container.view_url + zoneMedia[1][mediaData.sort].cropstatus[0].fileName + '" class="qiumedia-image ' + mediaData.class + '"></div>';
                    }
                    newCont = newCont.replace(m[0], newHtml);
                }
            }

            // Regex for Videos
            var regex = /(\[video\|([^\]]*)\])/g;
            var n;
            while ((n = regex.exec(content)) !== null) {
                var expCont = '';
                var mediaData = {
                    type: '',
                    sort: '',
                    class: ''
                };
                var mediaExtra = '';
                // This is necessary to avoid infinite loops with zero-width matches
                if (n.index === regex.lastIndex) {
                    regex.lastIndex++;
                }
                if (n[2]) {
                    expCont = n[2].split('|');
                    mediaData.type = 'video';
                    for (var i = 0; i < expCont.length; i++) {
                        if (i == 0) {
                            mediaData.sort = expCont[i];
                        }
                        else {
                            mediaExtra = expCont[i];
                            if (!angular.isUndefined(validData[mediaExtra])) {
                                mediaData.class += validData[mediaExtra] + ' ';
                            }
                        }
                    }
                    var newHtml = '<div class="qiumedia-read"><img src="' + zoneMedia[2][mediaData.sort].embed_thumb + '" class="qiumedia-video ' + mediaData.class + '"></div>';
                    newCont = newCont.replace(n[0], newHtml);
                }
            }
            return newCont;
        }

    }

    function renderTinyMedia(content) {
    }
})();

(function () {
  'use strict';

  angular
    .module('app.content')
    .service("contentService", content);

  /** @ngInject */
  // I provide access to the session store.
  function content($q, $resource, userService, settingsDomainService, sessionService, COMMON, $window) {


    var reference_sections = [];
    var media_zones = [];

    function getContent(options) {
      var deferred = $q.defer();
      var filters = [];

      _.forEach(options, function (value, key, list) {
        if (key === 'filters' && _.isArray(value)) {
          // Support direct filters array and normalize format to ensure backend compatibility
          var directFilters = _.map(value, function (f) {
            if (f.field && !f.values && f.value !== undefined) {
              return {
                field: f.field,
                name: f.name || f.field,
                operator: f.operator || "=",
                values: _.isArray(f.value) ? f.value : [f.value]
              };
            }
            return f;
          });
          filters = filters.concat(directFilters);
        } else if (_.isObject(list[key])) { 
          _.forEach(list[key], function (filter, keyFilter, listFilter) {
            if (!_.isEmpty(filter.selected)) {
              filters.push({
                field: filter.field,
                name: filter.name,
                values: filter.selected
              });
            }

          });

        }
      });

      resource.get({
          domain: options.siteID,
          name: options.section,
          page: options.page,
          search: options.searchStringFilter,
          resultsPerPage: options.resultsPerPage,
          sortField: options.sortField,
          sortDir: options.sortDir,
          filters: JSON.stringify(filters),
          // lang: get("language")
        },
        function (response) {

          // angular.copy(response, modulecontent);
          // setActiveDomain(domain);

          deferred.resolve(response);
        },
        function (e) {
          console.error(e)
          console.error("Database connection error")
          deferred.reject();
        }
      );

      // Return the promise.
      return (deferred.promise);
    }

    function getTags(options) {
      var deferred = $q.defer();


      resourceTags.get({
          domain: options.site,
          name: options.section,
        },
        function (response) {

          // angular.copy(response, modulecontent);
          // setActiveDomain(domain);

          deferred.resolve(response);
        },
        function (e) {
          console.error(e)
          console.error("Database connection error")
          deferred.reject();
        }
      );

      // Return the promise.
      return (deferred.promise);
    }

    function getFilters(options) {
      var deferred = $q.defer();

      resourceFilters.get({
          domain: options.site,
          name: options.section,
        },
        function (response) {

          // angular.copy(response, modulecontent);
          // setActiveDomain(domain);

          deferred.resolve(response);
        },
        function (e) {
          console.error(e)
          console.error("Database connection error")
          deferred.reject();
        }
      );

      // Return the promise.
      return (deferred.promise);
    }

    function getCdnStatus(siteID, cdn) {
      var deferred = $q.defer();

      resource_cdn_status.get({
          domain: siteID,
          // id: cdn.id_container,
          // lang: get("language")
        },
        function (response) {

          // angular.copy(response, modulecontent);
          // setActiveDomain(domain);

          deferred.resolve(response);
        },
        function (e) {
          console.error(e)
          console.error("Database connection error")
          deferred.reject();
        }
      );

      // Return the promise.
      return (deferred.promise);
    }

    function getByID(options) {
      var deferred = $q.defer();

      resource_content_byID.get({
          domain: options.site,
          name: options.section,
          id: options.id,
          // lang: get("language")
        },
        function (response) {

          // angular.copy(response, modulecontent);
          // setActiveDomain(domain);

          deferred.resolve(response);
        },
        function (e) {
          console.error(e)
          console.error("Database connection error")
          deferred.reject();
        }
      );

      // Return the promise.
      return (deferred.promise);
    }

    function getNew(options) {
      var deferred = $q.defer();

      resource_content_new.get({
          domain: options.site,
          name: options.section,
          // lang: get("language")
        },
        function (response) {

          // angular.copy(response, modulecontent);
          // setActiveDomain(domain);

          deferred.resolve(response);
        },
        function (e) {
          console.error(e)
          console.error("Database connection error")
          deferred.reject();
        }
      );

      // Return the promise.
      return (deferred.promise);
    }


    function saveItem(options) {
      var deferred = $q.defer();
      var itemString = JSON.stringify(options.item);
      var gzipString = pako.gzip(itemString);
      var blob = new Blob([gzipString]);
      resource_content_byID.updateGzip({
          domain: options.site,
          name: options.section,
          id: options.id,
          keepOldMedia: options.keepOldMedia
        },
        blob,
        function (response) {
          deferred.resolve(response);
        },
        function (e) {
          console.error("Database connection error 1")
          resource_content_byID.update({
            domain: options.site,
            name: options.section,
            id: options.id,
            item: options.item,
            keepOldMedia: options.keepOldMedia
          },
          function (response) {
            deferred.resolve(response);
          },
          function (e) {
            console.error(e)
            console.error("Database connection error 2")
            deferred.reject();
          })
        }
      );

      // Return the promise.
      return (deferred.promise);
    }

    function xmlToJson(options) {
      var deferred = $q.defer();

      resource_content_xmlToJson.post({
          domain: options.site,
          name: options.section,
        }, JSON.stringify(options.data),
        function (response) {
          deferred.resolve(response);
        },
        function (e) {
          console.error(e)
          console.error("Database connection error")
          deferred.reject();
        }
      );

      // Return the promise.
      return (deferred.promise);
    }

    function readJson(options) {
      var deferred = $q.defer();

      resource_content_readJson.post({
          domain: options.site,
          name: options.section,
          url: options.data.url
        },
        function (response) {
          deferred.resolve(response);
        },
        function (e) {
          console.error(e)
          console.error("Database connection error")
          deferred.reject();
        }
      );

      // Return the promise.
      return (deferred.promise);
    }

    function massActions(options) {
      var deferred = $q.defer();

      resource_content_Multiple.update({
          domain: options.site,
          name: options.section,
          type: options.type,
          ids: options.item
        },
        function (response) {

          // angular.copy(response, modulecontent);
          // setActiveDomain(domain);

          deferred.resolve(response);
        },
        function (e) {
          console.error(e)
          console.error("Database connection error")
          deferred.reject();
        }
      );

      // Return the promise.
      return (deferred.promise);
    }

    function getMediaByID(options) {
      var deferred = $q.defer();

      resource_content_media_byID.get({
          domain: options.site,
          name: options.section,
          id: options.id,
          // lang: get("language")
        },
        function (response) {

          // angular.copy(response, modulecontent);
          // setActiveDomain(domain);

          deferred.resolve(response);
        },
        function (e) {
          console.error(e)
          console.error("Database connection error")
          deferred.reject();
        }
      );

      // Return the promise.
      return (deferred.promise);
    }


    function getCountries(options) {
      var deferred = $q.defer();

      resourceCountries.get({
          resultsPerPage: options.paginate,
        },
        function (response) {

          // angular.copy(response, modulecontent);
          // setActiveDomain(domain);

          deferred.resolve(response);
        },
        function (e) {
          console.error(e)
          console.error("Database connection error")
          deferred.reject();
        }
      );

      // Return the promise.
      return (deferred.promise);
    }

    function createSubSec(options) {
      var deferred = $q.defer();

      resourceSubsection.post({
          domain: options.site,
          subsection: options.section
        },
        options.data,
        function (response) {
          reference_sections['subsection'].push(response);
          deferred.resolve(response);
        },
        function (e) {
          console.error(e)
          console.error("Database connection error")
          deferred.reject();
        }
      );

      // Return the promise.
      return (deferred.promise);
    }

    function updateSubSec(options) {
      var deferred = $q.defer();

      resourceSubsection.update({
          domain: options.site,
          subsection: options.section,
          id: options.id
        },
        options.data,
        function (response) {
          setReferenceSectionItem('subsection', 'id_subsec', response);
          deferred.resolve(response);
        },
        function (e) {
          console.error(e)
          console.error("Database connection error")
          deferred.reject();
        }
      );

      // Return the promise.
      return (deferred.promise);
    }

    function createCatSec(options) {
      var deferred = $q.defer();

      resourceCatsection.post({
          domain: options.site,
          catsection: options.section
        },
        options.data,
        function (response) {
          reference_sections['cat'].push(response);
          deferred.resolve(response);
        },
        function (e) {
          console.error(e)
          console.error("Database connection error")
          deferred.reject();
        }
      );

      // Return the promise.
      return (deferred.promise);
    }

    function updateCatSec(options) {
      var deferred = $q.defer();

      resourceCatsection.update({
          domain: options.site,
          catsection: options.section,
          id: options.id
        },
        options.data,
        function (response) {
          setReferenceSectionItem('cat', 'id_cat', response);
          deferred.resolve(response);
        },
        function (e) {
          console.error(e)
          console.error("Database connection error")
          deferred.reject();
        }
      );

      // Return the promise.
      return (deferred.promise);
    }

    function createSubCat(options) {
      var deferred = $q.defer();

      resourceSubcatsection.post({
          domain: options.site,
          subcatsection: options.section
        },
        options.data,
        function (response) {
          reference_sections['subcat'].push(response);
          deferred.resolve(response);
        },
        function (e) {
          console.error(e)
          console.error("Database connection error")
          deferred.reject();
        }
      );

      // Return the promise.
      return (deferred.promise);
    }

    function updateSubCat(options) {
      var deferred = $q.defer();

      resourceSubcatsection.update({
          domain: options.site,
          subcatsection: options.section,
          id: options.id
        },
        options.data,
        function (response) {
          setReferenceSectionItem('subcat', 'id_subcat', response);
          deferred.resolve(response);
        },
        function (e) {
          console.error(e)
          console.error("Database connection error")
          deferred.reject();
        }
      );

      // Return the promise.
      return (deferred.promise);
    }
    
    function getUsersGroups(options) {
      var deferred = $q.defer();
      var params = {
          domain: options.siteID,
          withGroupType: options.withGroupType
      }
      if (options.withGroupType) {
          params.withGroupType = true;
      }
      params.sortDir = options.sortDir || 'ASC';
      params.sortField = options.sortField || 'name';
      resourceGroupsNested.get(params,
          function (response) {
              deferred.resolve(response);
          },
          function (e) {
              console.error("ERROR =========================================!!!!!!")
              console.error(e)
              deferred.reject();
          }
      );
      return (deferred.promise);
    }

    function getFileInfo(options) {
      var deferred = $q.defer();
      resourcegetFileInfo.post({
        domain: options.domain,
        content: options.content,
        token: options.token,
        options: options.options
      },
        function (response) {
          deferred.resolve(response);
        },
        function (e) {
          console.error("ERROR =========================================!!!!!!")
          console.error(e)
          deferred.reject();
        }
      );
      return (deferred.promise);
    }

    function getS3UploadPreSignedUrl(options) {
      var deferred = $q.defer();
      resource_s3_presigned_url.get({
        domain: options.domain,
        content: options.content,
        fileName: options.fileName,
        filseSizeKb: (angular.isDefined(options.fileSizeKb)) ? options.fileSizeKb : null
      },
        function (response) {
          deferred.resolve(response);
        },
        function (e) {
          console.error("ERROR =========================================!!!!!!")
          console.error(e)
          deferred.reject();
        }
      );
      return (deferred.promise);
    }

    function importContent(options) {
      var deferred = $q.defer();
      var options = {
        domain: options.domain,
        content: options.content,
        token: options.token,
        targetGroup: options.targetGroup,
        options: options.options,
        fieldMap: options.fieldMap,
        primaryKey: options.primaryKey,
        ignoreDuplicates: options.ignoreDuplicates
      }
      resource_import_content.post(options,
        function (response) {
          deferred.resolve(response);
        },
        function (e) {
          console.error("ERROR =========================================!!!!!!")
          console.error(e)
          deferred.reject(e);
        }
      );
      return(deferred.promise);
    }

    function getUsersByGroupsCount(options) {

      var deferred = $q.defer();
      var filters = [];

      _.forEach(options, function (value, key, list) {
          if (_.isObject(list[key])) {
              _.forEach(list[key], function (filter, keyFilter, listFilter) {
                  if (!_.isEmpty(filter.selected)) {
                      filters.push({
                          field: filter.field,
                          name: filter.name,
                          values: filter.selected
                      });
                  }

              });

          }
      });

      var opts = {
          domain: options.siteID,
          'id_group[]': options.groupIds,
      };

      resource_user_by_users_groups_count.get(opts,
          function (responseResult) {
              // angular.copy(response, modulecontent);
              // setActiveDomain(domain);
              deferred.resolve({
                  result: responseResult
              });
          },
          function (e) {
              console.error("ERROR =========================================!!!!!!")
              console.error(e)
              deferred.reject();
          }
      );

      return (deferred.promise);
    };

    /* Push Notifications */
    function sendPushNotification(options) {
      var deferred = $q.defer();
      resource_push_notificaction.post(options,
        function (response) {
          deferred.resolve(response);
        },
        function (e) {
          console.error("ERROR =========================================!!!!!!")
          console.error(e)
          deferred.reject();
        }
      );
      return (deferred.promise);
    }

    function newGet(options){
      var deferred = $q.defer();
      resourceNewGet.get({
        domain:         options.domain,
        section:        options.section,
        filters:        JSON.stringify(options.filters),
        resultsPerPage: options.resultsPerPage || 10,
        page:           options.page,
        resultSumField: options.resultSumField,
        groupBy:        options.groupBy,
        sumPerGroup:    options.sumPerGroup,
        sortField:      options.sortField,
        sortDir:        options.sortDir,
        resultsPerPage: options.resultsPerPage
      },
      function(response){
        if(response.result){
          deferred.resolve(response.result);
        }else{
          deferred.resolve(response);
        }
      },
      {
        function(e){
          console.error("¡¡¡ERROR!!!");
          console.error(e);
          deferred.reject();
        }
      });
      return(deferred.promise);
    }

    var resourceNewGet = $resource(
      `${COMMON.BASE_API}/domain/:domain/content/:section`,{
        domain: '@domain',
      },{
        get: {
          method: "GET",
          isArray: false
        }
      }
    )

    var resource_push_notificaction = $resource(
      COMMON.BASE_API + "/mobile/snsTopic/publishFirebase", {
        // No default data.
      }, {
        post: {
          method: "POST",
          // isArray: true
        }
      }
    );

    var resource_user_by_users_groups_count = $resource(
      COMMON.BASE_API + "/domain/:domain/usersInGroup/count", {
      // No default data.
      }, {
          get: {
              method: "GET",
              //isArray: true
          }
      }
    );

    var resource_import_content = $resource(
      COMMON.BASE_API + "/domain/:domain/import/content/:content/import", {
        domain: '@domain',
        content: '@content'
      }, {
        post: {
          method: "POST",
          isArray: false
        }
      }
    )
    
    var resource_s3_presigned_url = $resource(
      COMMON.BASE_API + "/domain/:domain/import/content/:content/getS3UploadPreSignedUrl", {
        domain: '@domain',
        content: '@content'
      }, {
        get: {
          method: "GET",
          isArray: false
        }
      }
    )

    var resourcegetFileInfo = $resource(
      COMMON.BASE_API + "/domain/:domain/import/content/:content/getFileInfo", {
        domain: '@domain',
        content: '@content'
      }, {
        post: {
          method: "POST",
          isArray: false
        }
      }
    );
    var resourceGroupsNested = $resource(
        COMMON.BASE_API + "/domain/:domain/usersGroupsNested", {
        domain: '@domain'
        }, {
          get: {
              method: "GET",
              isArray: true
          }
    });

    var resource = $resource(
      COMMON.BASE_API + "/domain/:domain/content/:name", {
        // No default data.
      }, {
        get: {
          method: "GET",
          isArray: false
        }
      }
    );

    var resourceTags = $resource(
      COMMON.BASE_API + "/domain/:domain/content/:name/tags", {
        // No default data.
      }, {
        get: {
          method: "GET",
          // isArray: true
        }
      }
    );

    var resourceFilters = $resource(
      COMMON.BASE_API + "/domain/:domain/content/:name/options", {
        // No default data.
      }, {
        get: {
          method: "GET",
          // isArray: true
        }
      }
    );

    var resource_content_byID = $resource(
      COMMON.BASE_API + "/domain/:domain/content/:name/:id", {
        domain: '@domain',
        name: '@name',
        id: '@id',
      }, {
        get: {
          method: "GET",
        },
        update: {
          method: "PUT",
        },
        delete: {
          method: "DELETE"
        },
        updateGzip: {
          method: "PUT",
          isArray: false,
          headers : {
            'Cache-Control': 'no-cache',
            'Content-Encoding': 'gzip',
            'Content-Type': 'application/json; charset=utf-8'
          }
        }
      }
    );

    var resource_content_xmlToJson = $resource(
      COMMON.BASE_API + "/domain/:domain/content/:name/xml2json", {
        domain: '@domain',
        name: '@name'
      }, {
        post: {
          method: "POST",
        }
      }
    );

    var resource_content_readJson = $resource(
      COMMON.BASE_API + "/domain/:domain/content/:name/readJson", {
        domain: '@domain',
        name: '@name'
      }, {
        post: {
          isArray: true,
          method: "POST",
        }
      }
    );

    var resource_content_Multiple = $resource(
      COMMON.BASE_API + "/domain/:domain/content/:name/action/:type", {
        domain: '@domain',
        name: '@name',
        type: '@type',
      }, {
        update: {
          method: "PUT",
        },
        delete: {
          method: "DELETE",
          // isArray: true
        }
      }
    );

    var resource_content_new = $resource(
      COMMON.BASE_API + "/domain/:domain/content/:name/new", {
        domain: '@domain',
        name: '@name',
      }, {
        get: {
          method: "GET",
        },
      }
    );
    var resource_content_media_byID = $resource(
      COMMON.BASE_API + "/domain/:domain/content/:name/:id/media", {
        // No default data.
      }, {
        get: {
          method: "GET",
          // isArray: true
        }
      }
    );

    var resource_cdn_status = $resource(
      COMMON.BASE_API + "/domain/:domain/container/cdn/status", {
        // No default data.
      }, {
        get: {
          method: "GET",
          // isArray: true
        }
      }
    );


    var resourceCountries = $resource(
      COMMON.BASE_API + "/location/countries", {
        // No default data.
      }, {
        get: {
          method: "GET",
          // isArray: true
        }
      }
    );

    var resourceSubsection = $resource(
      COMMON.BASE_API + "/domain/:domain/content/subsection/:subsection/:id", {
        // No default data.
      }, {
        post: {
          method: "POST",
          // isArray: true
        },
        update: {
          method: "PUT"
        }
      }
    );

    var resourceCatsection = $resource(
      COMMON.BASE_API + "/domain/:domain/content/catsection/:catsection/:id", {
        // No default data.
      }, {
        post: {
          method: "POST",
          // isArray: true
        },
        update: {
          method: "PUT"
        }
      }
    );

    var resourceSubcatsection = $resource(
      COMMON.BASE_API + "/domain/:domain/content/subcatsection/:subcatsection/:id", {
        // No default data.
      }, {
        post: {
          method: "POST",
          // isArray: true
        },
        update: {
          method: "PUT"
        }
      }
    );

    function setSubsec(items) {
      angular.extend(reference_sections, items);
    }

    function setMediaZones(items) {
      angular.extend(media_zones, items);
    }

    function getMediaZones() {
      return media_zones;
    }

    function getValuesReferencesSections(key) {

      return reference_sections[key];

    }

    function setReferenceSectionItem(key, idType, item) {
      for (var i = reference_sections[key].length - 1; i >= 0; i--) {
        if (reference_sections[key][i][idType] == item[idType]) {
          reference_sections[key][i] = item;
        }
      }
    }

    function getReferencesSections(key, property, value) {
      switch (property) {
        case 'id_subsec':
          var fieldReturn = 'subsec';
          break;
        case 'id_cat':
          var fieldReturn = 'cat';
          break;
        case 'id_subcat':
          var fieldReturn = 'subcat';
          break;
        default:
          var fieldReturn = 'cat';
      }

      if (!angular.isUndefined(reference_sections[key])) {
        for (var i = 0, len = reference_sections[key].length; i < len; i++) {
          if (reference_sections[key][i][property] === value) return reference_sections[key][i][fieldReturn];
        }
      }
      return "--";
    }

    // Return the public API.
    return ({
      get: getContent,
      getByID: getByID,
      getNew: getNew,
      getMediaByID: getMediaByID,
      getCdnStatus: getCdnStatus,
      getTags: getTags,
      getFilters: getFilters,
      getUsersGroups: getUsersGroups,
      saveItem: saveItem,
      massActions: massActions,
      setSubsec: setSubsec,
      setMediaZones: setMediaZones,
      getMediaZones: getMediaZones,
      getReferencesSections: getReferencesSections,
      getValuesReferencesSections: getValuesReferencesSections,
      getCountries: getCountries,
      parseXmlToJson: xmlToJson,
      readJson: readJson,
      createSubSec: createSubSec,
      updateSubSec: updateSubSec,
      createCatSec: createCatSec,
      updateCatSec: updateCatSec,
      createSubCat: createSubCat,
      updateSubCat: updateSubCat,
      getFileInfo: getFileInfo,
      getS3UploadPreSignedUrl: getS3UploadPreSignedUrl,
      importContent: importContent,
      getUsersByGroupsCount: getUsersByGroupsCount,
      sendPushNotification: sendPushNotification,
      newGet: newGet
      // filterables: filterables,

    });


  }


})();

(function () {
    'use strict';

    angular
        .module('app.forms')
        .service('formsService', formsService);

    /** @ngInject */
    // I provide access to the session store.
    function formsService($q, $resource, settingsDomainService, sessionService, COMMON, $window) {

        function getForms(options) {
            var deferred = $q.defer();
            var filters = [];

            _.forEach(options, function (value, key, list) {
                if (_.isObject(list[key])) {
                    _.forEach(list[key], function (filter, keyFilter, listFilter) {
                        if (!_.isEmpty(filter.selected)) {
                            filters.push({
                                field: filter.field,
                                name: filter.name,
                                values: filter.selected
                            });
                        }

                    });

                }
            });


            resourceForms.get({
                domain: options.siteID,
                page: options.page,
                search: options.searchStringFilter,
                paginate: options.paginate,
                sortField: options.sortField,
                sortDir: options.sortDir,
                filters: JSON.stringify(filters),
                resultsPerPage: 100
            },
                function (response) {
                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve({
                        result: response.result
                    });

                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }


        function getFormById(options) {
            var deferred = $q.defer();

            resourceFormById.get({
                domain: options.site,
                id: options.id,
                // lang: get("language")
            },
                function (response) {

                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getOptions(options) {
            var deferred = $q.defer();


            resourceOptions.get({
                domain: options.site,
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e);
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function deleteItem(options) {
            var deferred = $q.defer();
            resource_form_byID.delete({
                domain: options.site,
                id: options.id
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );

            return (deferred.promise);
        }

        function saveItem(options) {
            var deferred = $q.defer();

            var id = options.id;
            var domain = options.site;

            resource_form_byID.update({
                domain: domain,
                id: id,
            }, options,
                function (response) {

                    deferred.resolve(response);
                },
                function (e) {
                    deferred.reject(e);
                }
            );


            // Return the promise.
            return (deferred.promise);
        }

        function massActions(options) {
            var deferred = $q.defer();

            resource_content_Multiple.update({
                domain: options.site,
                name: options.section,
                type: options.type,
                ids: options.item
            },
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }



        function getUserGroupsByType(options) {
            var deferred = $q.defer();

            resourceUserGroupByType.get({
                domain: options.site,
                type: options.type,
            },
                function (response) {
                    deferred.resolve(JSON.parse(angular.toJson(response)));
                },
                function (e) {
                    console.error(e);
                    deferred.reject();
                }
            );
            // Return the promise.
            return (deferred.promise);
        }


        function getUserGroupTypes(options) {
            var deferred = $q.defer();
            resourceUserGroupTypes.get({
                domain: options.site
            },
                function (response) {
                    deferred.resolve(JSON.parse(angular.toJson(response)));
                },
                function (e) {
                    console.error(e);
                    deferred.reject();
                }
            );
            // Return the promise.
            return (deferred.promise);
        }

        var resourceUserGroupByType = $resource(COMMON.BASE_API + "/domain/:domain/usersGroupsNested?groupType=:type", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: true
                }
            });

        var resourceUserGroupTypes = $resource(COMMON.BASE_API + "/domain/:domain/usersGroupsTypes?withUsersInGroupStatus", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: true
                }
            });

        var resourceForms = $resource(COMMON.BASE_API + "/domain/:domain/content/forms", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });

        var resourceFormById = $resource(COMMON.BASE_API + "/domain/:domain/content/forms/:id", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    // isArray: true
                }
            });

        var resourceOptions = $resource(
            COMMON.BASE_API + "/domain/:domain/content/forms/options", {
                // No default data.
            }, {
                get: {
                    method: "GET",
                }
            }
        );


        var resource_content_Multiple = $resource(
            COMMON.BASE_API + "/domain/:domain/content/:name/action/:type", {
                domain: '@domain',
                name: '@name',
                type: '@type',
            }, {
                update: {
                    method: "PUT",
                },
                delete: {
                    method: "DELETE",
                    // isArray: true
                }
            }
        );

        var resource_form_byID = $resource(
            COMMON.BASE_API + "/domain/:domain/content/forms/:id", {
                domain: '@domain',
                id: '@id',
            }, {
                get: {
                    method: "GET",
                },
                update: {
                    method: "PUT",
                },
                delete: {
                    method: "DELETE",
                    isArray: true
                }
            }
        );



        return ({
            get: getForms,
            getFormById: getFormById,
            getFilters: getOptions,
            saveItem: saveItem,
            deleteItem: deleteItem,
            getUserGroupsByType: getUserGroupsByType,
            getUserGroupTypes: getUserGroupTypes,
            massActions: massActions,
        });

    }

})();

(function() {
  'use strict';

  angular.module('app.forms').controller('FormsController', FormsController);

  /** @ngInject */
  function FormsController($scope, $rootScope, $document, $mdMenu, $mdDialog, $mdMedia, $mdToast, $mdSidenav,
                           $state, requestContext, $timeout, formsService, msUtils,
                           $translate, sessionService, sharedFunctionsForms, fieldsTemplateForms,
                           dragulaService
  ) {

    var vm = this;
    $scope.isLoading = true;
    vm.loadingThreads = true;
    vm.scrollEl = angular.element('#thread-list')[0];
    vm.enterfirst = true;
    vm.typeFields = ['textarea', 'input', 'select', 'radio', 'separator', 'multiCheckbox', 'checkbox',
      'single-suggest', 'datepicker', 'time', 'country', 'image-crop', 'dropzone'];
    vm.typesInput = ['number', 'password', 'tel', 'hidden', 'email', 'text'];
    vm.typesMulticheckbox = ['default', 'users_group'];
    vm.weekDays = [
      {
        "name": "Monday",
        "abb": "Mon",
        "order": 0,
        "value": 1
      },
      {
        "name": "Tuesday",
        "abb": "Tue",
        "order": 1,
        "value": 2
      },
      {
        "name": "Wednesday",
        "abb": "Wed",
        "order": 2,
        "value": 3
      },
      {
        "name": "Thursday",
        "abb": "Thu",
        "order": 3,
        "value": 4
      },
      {
        "name": "Friday",
        "abb": "Fri",
        "order": 4,
        "value": 5
      },
      {
        "name": "Saturday",
        "abb": "Sat",
        "order": 5,
        "value": 6
      },
      {
        "name": "Sunday",
        "abb": "Sun",
        "order": 6,
        "value": 0
      }
    ]

    vm.currentFilter = {
      type: $state.params.type,
      filter: $state.params.filter
    };

    vm.basicForm = {};
    vm.searchTabText;
    vm.selectedTab = null;

    vm.currentThread = null;
    vm.selectedThreads = [];
    vm.basicForm = {};

    vm.views = {
      split: 'app/main/apps/forms/views/list/split-view.html',
      nosplit: 'app/main/apps/forms/views/list/nosplit-view.html',
    };

    vm.defaultView = 'split';
    vm.currentView = 'split';
    vm.loadingView = true;

    // Methods
    vm.init = init;

    vm.newThread = newThread;
    vm.openThread = openThread;

    vm.closeThread = closeThread;
    vm.closeThreadEdit = closeThreadEdit;
    vm.deleteThread = deleteThread;

    vm.changeView = changeView;

    vm.isSelected = isSelected;
    vm.toggleSelectThread = toggleSelectThread;
    vm.toggleSelectThreads = toggleSelectThreads;

    vm.openMenu = openMenu;
    vm.editFieldStructure = editFieldStructure;
    vm.saveFieldStructure = saveFieldStructure;
    vm.cancelEditFieldStructure = cancelEditFieldStructure;
    vm.removeFieldStructure = removeFieldStructure;
    vm.addNewStructureField = addNewStructureField;
    vm.saveItem = saveItem;
    vm.massActions = massActions;

    vm.setTOOptions = setTOOptions;


    vm.noexistchangues = true;
    vm.loadingUserGroups = false;

    vm.openValidationsDialog = openValidationsDialog;
    vm.openOptionsDialog = openOptionsDialog;
    vm.openUserGroupDialog = openUserGroupDialog;
    vm.openDropzoneOptions = openDropzoneOptions;

    vm.setDisabledDay = setDisabledDay;

    // Attachments
    vm.toggleSidenav = toggleSidenav;
    vm.templateSortable = {
      group: '.template',
      forceFallback: true,
      handle: '.drag',
      ghostClass: 'drag-field-item-placeholder',
      fallbackClass: 'drag-field-item-ghost',
      fallbackOnBody: true,
      sort: true,
      onStart: function(evt) {
        vm.copyMock = angular.copy(vm.selectedContent.form_data.fields);
      },
      onEnd: function(evt) {
        if (typeof evt.oldIndex == 'undefined' || typeof evt.newIndex == 'undefined')
        {
          return false
        }
        vm.copyMock = changePosition(evt.newIndex - 1, evt.oldIndex - 1, vm.copyMock);
        vm.selectedContent.form_data.fields = vm.copyMock;
        vm.basicForm.$setDirty();
        return false;

      }
    }

    /**
     * Dragula configuration for builder elements
     */
    dragulaService.options($scope, 'element', {
      copy: false,
      copySortSource: false,
      removeOnSpill: true,
      direction: 'vertical',
      moves: function(el, source, handle, sibling) {
        return true;
      },
      invalid: function(el, handle) {
        return false; // don't prevent any drags from initiating by default
      }
    });

    /**
     * Drag and drop events for elements
     */
    $scope.$on('element.drop', function(event, el, target, source, sibling) {
      vm.basicForm.$setDirty();
    });

    //////////

    init();

    /**
     * Initialize
     */
    function init() {
      var siteID = requestContext.getParam("siteId");
      var section = 'forms';

      $scope.siteID = siteID;
      $scope.section = section;

      sessionService.setActiveSection(section).then(function() {
        vm.ActiveSection = sessionService.ActiveSection;
      });

      vm.viewSplit = true;

      vm.edit = false;

      vm.selectedUsers = [];

      $scope.view_medialist = true;

      $rootScope.global.titleToolbar = '<i class="icon s20 icon-folder-account mr-15" ng-if="node.icon"></i> ' + $translate.instant('FORMS');

      var options = {
        site: $scope.siteID,
        section: $scope.section
      };

      $scope.page = 1;

      if ($state.params.id)
      {
        // for (var i = 0; i < vm.threads.length; i++) {
        // if (vm.threads[i].id === $state.params.threadId) {
        vm.openThread(null, $state.params.id);
        // break;
        // }
        // }
      }


    }

    function setDisabledDay(field, value){
      if(!field.templateOptions.datepickerOptions || angular.isArray(field.templateOptions.datepickerOptions)){
        field.templateOptions.datepickerOptions = {};
        field.templateOptions.datepickerOptions.weeksDisabled = [];
      }else if(!field.templateOptions.datepickerOptions.weeksDisabled){
        field.templateOptions.datepickerOptions.weeksDisabled = [];
      }
      if(field.templateOptions.datepickerOptions.weeksDisabled.indexOf(value) != -1){
        field.templateOptions.datepickerOptions.weeksDisabled = field.templateOptions.datepickerOptions.weeksDisabled.filter(x => x != value);
      }else{
        field.templateOptions.datepickerOptions.weeksDisabled.push(value);
      }
    }

    function openValidationsDialog(ev, index) {
      $mdDialog.show({
        controller: 'ValidationsController',
        controllerAs: 'vm',
        templateUrl: 'app/main/apps/forms/dialogs/validations-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        locals: {
          Index: index,
          Field: vm.selectedContent.form_data.fields[index],
          Fields: vm.selectedContent.form_data.fields,
          event: ev
        }
      });
    }

    function openOptionsDialog(ev, index, title, arrayName) {
      $mdDialog.show({
        controller: 'OptionsController',
        controllerAs: 'vm',
        templateUrl: 'app/main/apps/forms/dialogs/options-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        locals: {
          Index: index,
          Title: title,
          ArrayName: arrayName,
          Field: vm.selectedContent.form_data.fields[index],
          Fields: vm.selectedContent.form_data.fields,
          event: ev
        }
      });
    }

    function openUserGroupDialog(ev, index, field) {
      $mdDialog.show({
        controller: 'UserGroupsOptionsController',
        controllerAs: 'vm',
        templateUrl: 'app/main/apps/forms/dialogs/usergroup-options-dialog.controller.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        locals: {
          event: ev,
          siteID: $scope.siteID,
          groupType: field.templateOptions.groupType ? field.templateOptions.groupType : null,
          status: field.templateOptions.status ? field.templateOptions.status : null,
          optionsSelected: field.templateOptions.options ? field.templateOptions.options : null
        }
      }).then(function(result) {
        if (result)
        {
          field.templateOptions.status = result.status;
          field.templateOptions.groupType = result.groupType;
          field.templateOptions.options = result.optionsSelected;
        }
      });
      ;
    }

    function openDropzoneOptions(ev, index, field) {
      $mdDialog.show({
        controller: 'DropzoneOptionsController',
        controllerAs: 'vm',
        templateUrl: 'app/main/apps/forms/dialogs/dropzone-options-dialog.controller.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        locals: {
          event: ev,
          siteID: $scope.siteID,
          groupType: field.templateOptions.groupType ? field.templateOptions.groupType : null,
          status: field.templateOptions.status ? field.templateOptions.status : null,
          optionsSelected: field.templateOptions.options ? field.templateOptions.options : null
        }
      }).then(function(result) {
        if (result)
        {
          field.templateOptions.status = result.status;
          field.templateOptions.groupType = result.groupType;
          field.templateOptions.options = result.optionsSelected;
        }
      });
      ;
    }


    function changePosition(newIndex, oldIndex, array) {
      if (oldIndex < newIndex)
      {
        for (var i = oldIndex; i < newIndex; i++)
        {
          var temp = array[i + 1];
          array[i + 1] = array[i];
          array[i] = temp;
        }
      }
      if (newIndex < oldIndex)
      {
        for (var i = oldIndex; i > newIndex; i--)
        {
          var temp = array[i - 1];
          array[i - 1] = array[i];
          array[i] = temp;
        }
      }

      vm.basicForm.$setDirty();
      return array;
    }


    // Watch screen size to change view modes
    $scope.$watch(function() {
      return $mdMedia('lt-sm');
    }, function(current, old) {
      if (angular.equals(current, old))
      {
        return;
      }

      if (current)
      {
        vm.currentView = 'nosplit';
      }
    });

    $scope.$watch(function() {
      return $mdMedia('max-width: 960px');
    }, function(big) {

      if (big)
      {
        vm.currentView = 'nosplit';
      }

    });

    $scope.$watch(function() {
      return $mdMedia('min-width: 960px');
    }, function(small) {

      if (small)
      {
        vm.currentView = 'split';
      }

    });

    $scope.$watch(function() {
      return $mdMedia('gt-sm');
    }, function(current, old) {
      if (angular.equals(current, old))
      {
        return;
      }

      if (current)
      {
        if (vm.defaultView === 'split')
        {
          vm.currentView = 'split';
        }
      }
    });

    $scope.$on('$includeContentLoaded', function(event, target) {
      $timeout(function() {
        vm.loadingView = false;
      }, 1000);
    });

    $scope.$on('pagination:loadStart', function(event) {
      // $anchorScroll();

      // Store the current scrollPos
      // vm.scrollPos = vm.scrollEl.scrollTop();

      // Scroll to the top
      // vm.scrollEl.scrollTop(0);
      if (!vm.enterfirst)
      {
        var elem = angular.element(document.getElementById('thread-list'));
        elem.scrollTopAnimated(0, 10);
      }

      // angular.element("#thread-list").scrollTop=0;
      vm.enterfirst = false;
      $scope.isLoading = true;
    });

    $scope.$on('pagination:loadPage', function(event) {
      $scope.isLoading = false;
      vm.dataAlreadyLoaded = true;
    });

    /**
     * Open thread
     *
     * @param thread
     */
    function openThread(thread, id) {
      // Set the read status on the thread
      // thread.read = true;
      vm.loadingReadPane = true;
      if (angular.element(document.getElementById('thread-detail')).length)
      {
        var elem = angular.element(document.getElementById('thread-detail'));
        elem.scrollTopAnimated(0, 10);
      }
      if (thread)
      {
        vm.selectedContentID = thread.id;
      }
      else if (id)
      {
        vm.selectedContentID = id;
      }
      if (vm.selectedContentID != 'new')
      {
        vm.editData = false;

        vm.loadingReadPane = true;

        $state.go('app.site_overview.forms.list.thread', {
          id: vm.selectedContentID
        }, {
          notify: false,
          inherit: true,
          location: true
        });

        var options = {
          site: $scope.siteID,
          section: $scope.section,
          id: vm.selectedContentID
        };

        formsService.getFormById(options).then(function(response) {
          vm.editData = false;
          vm.selectedContent = angular.copy(response.toJSON().result);
          vm.selectedContent.form_data = JSON.parse(vm.selectedContent.form_data);
          vm.selectedContent.form_data.fields = fieldsTemplateForms.tostructureFieldFromDTO(vm.selectedContent.form_data.fields)
          vm.loadingReadPane = false;
        });

      }
      ;
    }

    function massActions(action) {

      if (vm.selectedThreads.length === 0)
      {
        return false;
      }
      var selectedIds = [];

      for (var i = 0; i < vm.selectedThreads.length; i++)
      {
        selectedIds.push(vm.selectedThreads[i].id);
      }
      switch (action)
      {
        case 'delete':
          if (selectedIds.length == 1)
          {
            var messageConfirm = $translate.instant('CONTENT.SURE_DELETED_SINGULAR');

            var confirm = $mdDialog.confirm().title(messageConfirm)
            // .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' will be deleted.')
              .ariaLabel('Delete item').ok('OK').cancel('CANCEL');
            var message = $translate.instant('CONTENT.DELETED');
          }
          else
          {
            var messageConfirm = $translate.instant('CONTENT.SURE_DELETED_PLURAL');

            var confirm = $mdDialog.confirm().title(messageConfirm)
            // .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' will be deleted.')
              .ariaLabel('Delete item').ok('OK').cancel('CANCEL');
            var message = $translate.instant('CONTENT.DELETED');
          }
          break;
        case 'duplicate':
          if (selectedIds.length == 1)
          {
            var messageConfirm = $translate.instant('CONTENT.SURE_DUPLICATED_SINGULAR');
            var confirm = $mdDialog.confirm().title(messageConfirm)
            // .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' will be deleted.')
              .ariaLabel('Duplicate item').ok('OK').cancel('CANCEL');
            var message = $translate.instant('CONTENT.DUPLICATED');
          }
          else
          {
            var messageConfirm = $translate.instant('CONTENT.SURE_DUPLICATED_PLURAL');
            var confirm = $mdDialog.confirm().title(messageConfirm)
            // .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' will be deleted.')
              .ariaLabel('Duplicate item').ok('OK').cancel('CANCEL');
            var message = $translate.instant('CONTENT.DUPLICATED');
          }
          break;
      }


      $mdDialog.show(confirm).then(function() {

        var options = {
          site: $scope.siteID,
          section: $scope.section,
          type: action,
          item: selectedIds
        };

        formsService.massActions(options).then(function(response) {
          vm.toggleSelectThreads();
          $rootScope.pagination_resetquery();
          vm.closeThread();
          $mdToast.show({
            template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
            hideDelay: 5000,
            position: 'top',
            parent: '#content-container'
          });
        });
      });

    }

    function deleteThread() {
      for (var i = 0; i < vm.selectedThreads.length; i++)
      {
        var options = {
          site: $scope.siteID,
          section: $scope.section,
          id: vm.selectedThreads[i].id_user
        };
        formsService.deleteItem(options).then(function(response) {
          vm.loadingReadPane = false;
          deselectThreads();
          vm.selectedContent = undefined;
          $rootScope.pagination_resetquery();
        });
      }
    }

    /**
     * New thread
     *
     */
    function newThread() {
      if (angular.element(document.getElementById('thread-detail')).length)
      {
        var elem = angular.element(document.getElementById('thread-detail'));
        elem.scrollTopAnimated(0, 10);
      }

      vm.selectedContentID = '';
      vm.editData = false;
      vm.loadingReadPane = true;

      $state.go('app.site_overview.forms.list', {
        id: ''
      }, {
        notify: false,
        inherit: true,
        location: true
      });

      vm.currentThread = '';
      vm.log = [];

      vm.selectedContent = {
        "id_subsec": 1,
        "id_cat": 1,
        "id_subcat": 1,
        "lang": 1,
        "onoff": 1,
        "date": "",
        "title": "",
        "Thumbnail": [],
        "tags": [],
        "form_data": {
          "fields": []
        }
      }


      vm.loadingReadPane = false;


    }

    /**
     * Close thread Edit
     */
    function closeThreadEdit() {
      resetScroll();
      vm.currentThread = null;
      vm.selectedContent = null;
      vm.selectedContentID = null;
      // Update the state without reloading the controller
      $state.go('app.site_overview.forms.list', {
        type: vm.currentFilter.type,
        filter: vm.currentFilter.filter
      }, {notify: false});
    }

    function isSelected(thread) {
      return sharedFunctionsForms.isSelected(vm.selectedThreads, thread);
    }

    function toggleSelectThread(thread, event) {
      vm.selectedThreads = sharedFunctionsForms.toggleSelectThread(vm.selectedThreads, thread, event);
    }


    function toggleSelectThreads() {
      vm.selectedThreads = sharedFunctionsForms.toggleSelectThreads(vm.selectedThreads, vm.threads);
    }

    var originatorEv;

    function openMenu($mdMenu, ev) {
      originatorEv = ev;
      $mdMenu.open(ev);
    }


    function editFieldStructure(index) {
      closeOthers();
      vm.copyStructure = angular.copy(vm.selectedContent.form_data.fields[index]);
      vm.selectedContent.form_data.fields[index].editing = true;
    }

    function closeOthers() {
      fieldsTemplateForms.closeOthers(vm.selectedContent.form_data.fields);
    }

    function saveFieldStructure(index) {
      vm.basicForm.$setDirty();
      fieldsTemplateForms.saveFieldStructure(index, vm.selectedContent.form_data.fields);
    }

    function cancelEditFieldStructure(index) {
      fieldsTemplateForms.cancelEditFieldStructure(index, vm.selectedContent.form_data.fields, vm.copyStructure);
    }

    function removeFieldStructure(index) {
      vm.basicForm.$setDirty();
      fieldsTemplateForms.removeFieldStructure(index, vm.selectedContent.form_data.fields, vm.noexistchangues);
    }

    function addNewStructureField() {
      fieldsTemplateForms.addNewStructureField(vm.selectedContent.form_data.fields);
    }

    function saveItem(content) {
      vm.loadingReadPane = true;
      content.form_data.fields = fieldsTemplateForms.toDTOStructureField(content.form_data.fields);
      content.form_data = angular.toJson(content.form_data);
      if (!content.id)
      {
        content.id = 'new';
      }
      var options = {
        site: $scope.siteID,
        id: content.id,
        item: content,
        name: $scope.section
      };
      formsService.saveItem(options).then(function(response) {
        $rootScope.pagination_reload();
        var message = $translate.instant('FORMS.SAVED');
        $mdToast.show({
          template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
          hideDelay: 5000,
          position: 'top',
          parent: '#content-container'
        });
        vm.closeThread();

        return true;
      });
    }

    function setTOOptions(field) {
      if (field.type == 'dropzone') {
        field.templateOptions.options = {
          url: '/',
          maxFilesize: 5,
          method: 'PUT',
          paramName: '',
          maxThumbnailFilesize: 5,
          autoProcessQueue: false,
          maxFiles: 1,
          acceptedFiles: '.doc,.docx,.pdf',
          uploadMultiple: false,
          thumbnailMethod: 'contain',
          thumbnailWidth: 300,
          thumbnailHeight: 300,
          previewTemplate: "<div class=\"dz-preview dz-file-preview dz-processing dz-success dz-complete\"><div class=\"dz-image\"><img data-dz-thumbnail /></div><div class=\"dz-details\"><div class=\"dz-filename\"><span data-dz-name></span></div><div class=\"dz-size\"><span data-dz-size></span></div><button data-dz-remove class=\"btn btn-danger delete\"><i class=\"ion-md-close\" aria-hidden=\"true\"></i></button></div><div class=\"dz-progress\"><span class=\"dz-upload\" data-dz-uploadprogress></span></div><div class=\"dz-error-message\"><span data-dz-errormessage></span></div></div>",
          dictFileTooBig: "The file is bigger than the maximum allowed ({{maxFilesize}}MB)",
          dictInvalidFileType: "This file type is not allowed. Please upload DOC or PDF."
        }
      } else {
        field.templateOptions.options = [];
      }
    }

    /**
     * Close thread
     */
    function closeThread() {
      vm.currentThread = null;
      vm.selectedContent = null;
      vm.selectedContentID = null;

      // Update the state without reloading the controller
      $state.go('app.site_overview.forms.list', {
        type: vm.currentFilter.type,
        filter: vm.currentFilter.filter
      }, {notify: false});
      vm.loadingReadPane = false;
    }


    $scope.closeToast = function() {
      if (isDlgOpen)
      {
        return;
      }

      $mdToast.hide().then(function() {
        isDlgOpen = false;
      });
    };

    /**
     * Change the view
     *
     * @param view
     */
    function changeView(view) {
      if (vm.views[view])
      {
        vm.loadingView = true;
        vm.defaultView = view;
        vm.currentView = view;
      }
    }


    function resetScroll() {
      if (angular.element(document.getElementById('thread-detail')).length)
      {
        var elem = angular.element(document.getElementById('thread-detail'));
        elem.scrollTopAnimated(0, 10);
      }
    }


    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app.dashboards', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, msApiProvider, $translatePartialLoaderProvider)
  {
    $stateProvider.state('app.dashboards', {
      url: '/dashboard',
      views: {
        'content@app': {
          templateUrl: 'app/main/apps/dashboards/dashboard-project.html',
          controller: 'DashboardProjectController as vm'
        }
      },
      bodyClass: 'dashboard-project'
    });

    $stateProvider
      .state('app.site_overview.dashboards', {
        abstract: true,
        url: '/dashboard',
        onEnter: function ($stateParams) {

        },
        data: {
          displayName: '{{section}}'
        },
        resolve: {
          section: function ($stateParams) {
            return $stateParams.section
          },
        },
      })
      .state('app.site_overview.dashboards.show', {
        url: '',
        views: {
          'content@app': {
            templateUrl: 'app/main/apps/dashboards/dashboard.html',
            controller: 'DashboardController as vm'
          }
        },
        onEnter: function () {
          
        },
        data: {
          displayName: 'List {{section}}'
        },
        resolve: {
        },
      })

      $translatePartialLoaderProvider.addPart('app/main/apps/users');
      $translatePartialLoaderProvider.addPart('app/main/apps/dashboards');
  }

})();

(function () {
  'use strict';

  angular
    .module('app.dashboards')
    .controller('DashboardController', DashboardController);

  /** @ngInject */
  /** @ngInject */
  function DashboardController($scope, usersService, $interval, msUtils, mediaService, $document, $translate, $mdMenu, $mdDialog, requestContext, $mdSidenav, sessionService, usersActivityService, dashboardsService) {
    var vm = this;
    vm.timeSelector = 'last-week';
    vm.domainActive = sessionService.site_operative;
    var siteID = requestContext.getParam("siteId");
    $scope.siteID = siteID;
    // Data
    vm.dashboardData = null;

    vm.isLoadingActivity = true;
    vm.isLoadingUsers = true;
    vm.isLoadingDownloadsStats = true;
    vm.isLoadingVisits = true;


    // Methods
    vm.setCharData = setCharData;
    vm.toggleSidenav = toggleSidenav;
    vm.openMenu = openMenu;
    vm.openImageDialog = openImageDialog;
    vm.setFilter = setFilter;
    vm.msScrollOptions = {
      suppressScrollX: true
    };
    vm.getExtensionIcon = msUtils.getExtensionIcon;

    vm.translate = translate;
    vm.loadUsers = loadUsers;
    vm.loadActivity = loadActivity;
    vm.loadDailyStats = loadDailyStats;

    vm.timeAgo = msUtils.timeAgo;
    vm.filterDailyCount = 'default';
    vm.colors = ['blue-bg'];

    function translate(val) {
      return $translate.instant(val);
    }


    init();

    /**
     * Initialize
     */
    function init() {
      vm.options = {
        chart: {
          type: 'lineChart',
          height: 300,
          margin: {
            top: 60,
            right: 60,
            bottom: 60,
            left: 60
          },
          x: function (d) {
            return d[0];
          },
          y: function (d) {
            return d[1];
          },
          xAxis: {
            axisLabel: $translate.instant('DASHBOARD.DATE'),
            tickFormat: function (d) {
              return d3.time.format('%d/%m/%y')(new Date(d))
            }
          },

          yAxis: {
            axisLabel: $translate.instant('DASHBOARD.VISITS'),
            tickFormat: function (d) {
              return d;
            }
          }
        }
      };



      loadActivity();
      loadDownloadsRanking();
      loadUsers();
      vm.loadDailyStats();
    }

    //////////

    var originatorEv;

    function openMenu($mdMenu, ev) {
      originatorEv = ev;
      $mdMenu.open(ev);
    }
    // var nowWidgetTicker = $interval(vm.nowWidget.ticker, 1000);

    // $scope.$on('$destroy', function ()
    // {
    //     $interval.cancel(nowWidgetTicker);
    // });

    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */
    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    function openImageDialog(ev, images, ImageSelected, cropFormats, MediaFull) {
      $mdDialog.show({
        controller: 'MediaShowDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/dialogs/media-show/media-show-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        escapeToClose: false,
        locals: {
          Images: images,
          ImageSelected: ImageSelected,
          cropFormats: cropFormats,
          MediaFull: MediaFull,
          Tags: false,
          // Tasks: vm.tasks,
          // event: ev
        }
      }).then(function () {
      });
    }

    function getDatesFilter() {
      let initDate;
      let endDate;
      let date;
      switch (vm.timeSelector) {
        case 'last-week':
          date = new Date();
          initDate = moment.utc(date.setDate(date.getDate() - 7)).format('YYYY-MM-DD');;
          endDate = moment.utc(new Date().setHours(24, 0, 0, 0)).format('YYYY-MM-DD');;
          break;
        case 'last-month':
          date = new Date();
          initDate = moment.utc(date.setDate(date.getDate() - 30)).format('YYYY-MM-DD');;
          endDate = moment.utc(new Date().setHours(24, 0, 0, 0)).format('YYYY-MM-DD');;
          break;
        case 'three-months':
          date = new Date();
          initDate = moment.utc(date.setDate(date.getDate() - 90)).format('YYYY-MM-DD');;
          endDate = moment.utc(new Date().setHours(24, 0, 0, 0)).format('YYYY-MM-DD');;
          break;
        default:
          break;
      }
      return { initDate, endDate }
    }

    function loadActivity() {
      vm.isLoadingActivity = true;
      var options = {
        "page": 1,
        "resultsPerPage": 9999999,
        "siteID": $scope.siteID,
        "sortDir": "DESC"
      };
      var dates = getDatesFilter()
      if (dates.initDate) {
        options.dateFrom = dates.initDate;
        options.dateTo = dates.endDate;
      }
      usersActivityService.get(options).then(function (response) {
        vm.activity = response.data;
        vm.activityFiltered = response.data;
        vm.activityDownloads = response.data.filter(x => x.action_id === 'user-download-media-with-crop');
        vm.activityDownloads = _.groupBy(vm.activityDownloads, (m) => {
          return m.dateWithoutHours;
        });
        vm.activityDownloads = Object.values(vm.activityDownloads).map(x => {
          return {
            daily_date: x[0].date,
            downloads: x.length
          }
        })
        vm.isLoadingActivity = false;
      });
    }
    function loadUsers() {
      vm.isLoadingUsers = true;
      var dates = getDatesFilter();
      var options = {
        "siteID": $scope.siteID,
        "resultsPerPage": 9999999
      };
      if (dates.initDate) {
        options.dateFrom = dates.initDate;
        options.dateTo = dates.endDate;
      }
      if (dates.initDate) {
        usersService.getUsersBetweenDates(options).then(function (response) {
          vm.total = response.length;
          vm.usersRegistered = response.slice(0, 50);
          vm.isLoadingUsers = false;
        });
      } else {
        usersService.get(options).then(function (response) {
          vm.total = response.result.total;
          vm.usersRegistered = response.result.data.slice(0, 50);
          console.log(response)
          vm.isLoadingUsers = false;
        });
      }
    }
    function loadDownloadsRanking() {
      vm.isLoadingDownloadsStats = true;
      var options = {
        "page": 1,
        "resultsPerPage": 50,
        "siteID": $scope.siteID,
        "sortDir": "DESC",
        "sortField": "mediacenter->downloads",

      };
      mediaService.get(options).then(function (response) {
        vm.rankingDownloads = response.data.map((item) => {
          item.mediacenter = JSON.parse(item.mediacenter)
          return item;
        });
        vm.rankingDownloads = vm.rankingDownloads.filter(item => item.mediacenter && item.mediacenter.downloads > 0);
        vm.isLoadingDownloadsStats = false;
      });
    }

    function setFilter(filter) {
      vm.filter = filter;
      if (!filter) {
        vm.activityFiltered = vm.activity;
      } else {
        vm.activityFiltered = vm.activity.filter((element) => element.action_id === 'user-download-media' || element.action_id === 'user-download-media-with-crop')
      }
    }

    function loadDailyStats() {
      vm.isLoadingVisits = true;
      var dates = getDatesFilter();
      var options = {
        siteID: $scope.siteID,
        dateFrom: dates.initDate
      };
      dashboardsService.getDailyCount(options).then(function (response) {
        vm.dailyVisits = response;
        vm.setCharData('visits');
        vm.isLoadingVisits = false;
      });
    }

    function setCharData(type) {
      vm.charDataType = type;
      switch (vm.charDataType) {
        case 'visits':
          vm.data = [
            {
              key: "Visits by day",
              values: vm.dailyVisits.map(x => [new Date(x.daily_date).getTime(), x.daily_count])
            }
          ];
          break;
        case 'downloads':
          vm.data = [
            {
              key: "Downloads by day",
              values: vm.activityDownloads.map(x => [new Date(x.daily_date).getTime(), x.downloads])
            }
          ];
          break;

        default:
          break;
      }

    }
  }

})();

(function () {
    'use strict';

    angular
        .module('app.dashboards')
        .service('dashboardsService', dashboardsService);

    /** @ngInject */
    // I provide access to the session store.
    function dashboardsService($q, $resource, COMMON) {

        function getDailyCount(options) {
            var deferred = $q.defer();

            resource.get({
                    domain: options.siteID,
                    dateFrom: options.dateFrom
                },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        var resource = $resource(COMMON.BASE_API + "/domain/:domain/usersAuditTrail/dailyCount?dateFrom=:dateFrom&sortDir=asc", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: true
            }
        });
        
        return ({
            getDailyCount: getDailyCount,
        });

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.dashboards')
        .controller('DashboardProjectController', DashboardProjectController);

    /** @ngInject */
    function DashboardProjectController($scope, $interval, $mdSidenav, sessionService)
    {
        var vm = this;

        vm.domainActive=sessionService.site_operative;

        // Data
        vm.dashboardData = null;
  

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////


        // var nowWidgetTicker = $interval(vm.nowWidget.ticker, 1000);

        // $scope.$on('$destroy', function ()
        // {
        //     $interval.cancel(nowWidgetTicker);
        // });

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.ai')
        .service('aiService', aiService);

    /** @ngInject */
    // I provide access to the session store.
    function aiService($rootScope, $q, $resource, COMMON) {

        function get(options) {

            var deferred = $q.defer();

            // Return the promise.
            return (deferred.promise);
        }



        function getOptions(options) {
            var deferred = $q.defer();

            // Return the promise.
            return (deferred.promise);
        }


        return ({
            get: get,
            getFilters: getOptions
        });

    }

})();

(function () {
  'use strict';

  angular
    .module('app.ai')
    .controller('AiController', AiController);

  /** @ngInject */
  function AiController($stateParams, $mdDialog, $document, $mdMenu, requestContext, $anchorScroll,
    $timeout, $scope, $translate, $mdToast, $mdMedia, $sce, msUtils, COMMON, $log, sessionService, $state, $mdSidenav,
    $rootScope, tagsService, ivhTreeviewMgr, section, mediaService, $q, settingUserService, rekognitionService, transformMedia) {

    var vm = this;


    // Data
    vm.siteID = requestContext.getParam("siteId");
    vm.section = section;

    vm.views = {
      nosplit:  'app/main/apps/ai/views/list/nosplit-view.html',
      split:    'app/main/apps/ai/views/list/split-view.html',
      grid:     'app/main/apps/ai/views/grid/grid-view.html'
    };

    vm.tabViews = {
      'recognized_media':       'app/main/apps/ai/views/grid/tabs/recognized-media.html',
      'unrecognized_media':     'app/main/apps/ai/views/grid/tabs/unrecognized-media.html',
      'media_without_number':   'app/main/apps/ai/views/grid/tabs/media-without-number.html',
      'recognized_profiles':    'app/main/apps/ai/views/grid/tabs/recognized-profiles.html',
      'unrecognized_profiles':  'app/main/apps/ai/views/grid/tabs/unrecognized-profiles.html',
      'all_media':              'app/main/apps/ai/views/grid/tabs/all-media.html',
    }

    vm.defaultView = 'grid';
    vm.currentView = 'nosplit';

    vm.defaultListView = 'grid';
    vm.currentListView = 'grid';

    vm.currentTabView = 'recognized_profiles';

    vm.threads = [];
    vm.eventTags = [];

    $rootScope.pagination_totalItems = 0;
    $rootScope.pagination_total_pages = 0;
    $rootScope.pagination_page = 0;
    $rootScope.pagination_from = 0;
    $rootScope.pagination_to = 0;
    $rootScope.sortField = 'updated_at';

    $rootScope.perPage = 10;
    vm.perPage = 10;

    vm.loadingMediaItem = false;
    vm.isLoading = false;
    vm.editingTags = false;

    vm.tags = sessionService.site_operative.tags;

    vm.CleanMediaGalleries = [];

    // Methods
    vm.getItemsByEventTag = getItemsByEventTag;
    vm.confirmProfile = confirmProfile;
    vm.confirmMedia = confirmMedia;
    vm.confirmMediaIncorrectTag = confirmMediaIncorrectTag;
    vm.rejectProfile = rejectProfile;
    vm.labelQuerySearch = labelQuerySearch;
    vm.getSettingValue = settingUserService.getSettingValue;
    vm.AddmediaDialog = AddmediaDialog;
    vm.openImageDialog = openImageDialog;
    vm.deleteIncorrectTags = deleteIncorrectTags;

    vm.onTabSelected = onTabSelected;
    vm.openFace = openFace;
    vm.tagsSearch = tagsSearch;
    vm.filterRunnerOrNumberTag = filterRunnerOrNumberTag;
    vm.removeTag = removeTag;
    vm.selectedItemChange = selectedItemChange;
    vm.setRunnerTagsOptions = setRunnerTagsOptions;
    vm.tagUnrecognizedImagesByFaceId = tagUnrecognizedImagesByFaceId;
    vm.searchClear = searchClear;
    vm.searchClick = searchClick;
    vm.confirmDetectedUnrelated = confirmDetectedUnrelated;

    vm.translate = function (text) {
      return $translate.instant(text);
    }

    function filterRunnerOrNumberTag (tags) {
      return tags.filter(function(tag) {return (tag.id_type == vm.idTagTypeNumber || tag.id_type == vm.idTagTypeRunner)});
    }

    init();

    /**
     * Initialize
     */
    function init() {

      $rootScope.global.titleToolbar = '<i class="icon s20 icon-lightbulb mr-15" ng-if="node.icon"></i> <span class="hide show-gt-xs">' + $translate.instant('AI.AI') + ' </span> <i class="mr-5 ml-5 icon s18 icon-chevron-right hide show-gt-xs"></i> ' + $translate.instant('AI.'+vm.section.toUpperCase());
      vm.currentEventTag = vm.getSettingValue(vm.section, 'currentEventTag', null)

      let settings = {};
      if (sessionService.site_operative &&
          sessionService.site_operative.qiuModuleAiSettings &&
          sessionService.site_operative.qiuModuleAiSettings.faces_upload
      ) {
        settings = sessionService.site_operative.qiuModuleAiSettings.faces_upload;
      }

      vm.idTagTypeEvent                     = settings.id_tag_type_event || 3;
      vm.idTagTypeRunner                    = settings.id_tag_type_runner || 4;
      vm.idTagTypeNumber                    = settings.id_tag_type_number || 5;
      vm.idTagTypeIsProfile                 = settings.id_tag_type_is_profile || 6;
      vm.idTagTypeIsUnmatched               = settings.id_tag_type_is_unmatched_profile || 7;
      vm.confidenceThresholdFaceRecognition = settings.face_recognition_confidence_threshold || 90;
      vm.confidenceThresholdTextRecognition = settings.text_recognition_confidence_threshold || 90;
      vm.regexRule                          = settings.text_recognition_filter_regex || '^[0-9]{2}$'; // Only two numbers
      vm.setMediaAiRecognitionTags          = settings.set_media_ai_recognition_tags || false;

      var options = {
        typeIds: [vm.idTagTypeEvent, vm.idTagTypeNumber, vm.idTagTypeIsProfile, vm.idTagTypeIsUnmatched],
        siteID: vm.siteID,
        perPage: 9999999999,
      }
      getTags(options).then(getItems);
      getGalleries();
    }

    function tagsSearch(searchText, media) {
      // media.filteredTags used by the $chips.
      if (!media.filteredTags) {
        media.filteredTags = []
      }
      if (!media.tags) {
        media.tags = [];
      }
      return vm.tags.filter(function(tag) {
        return tag.tag_name.toString().toLowerCase().startsWith(searchText.toString().toLowerCase()) &&
        (tag.id_type == vm.idTagTypeRunner || tag.id_type == vm.idTagTypeNumber)
      })
    }

    function selectedItemChange(selectedTag, media) {
      if (!selectedTag) {
        return;
      }
      if (media.tags.some(x => x.id_tag === selectedTag.id_tag)) {
        return;
      }
      // Add selected tab.
      media.tags.push(angular.copy(selectedTag));

      // Search and add corresponding Runner tag
      if (selectedTag.id_type === vm.idTagTypeNumber) {
        var runnerTags = filterTagsByParentAndType(selectedTag.id_tag, vm.idTagTypeRunner);
        runnerTags.forEach(x => media.tags.push(x));
      }
      // Search and add corresponding Number tag
      if (selectedTag.id_type === vm.idTagTypeRunner) {
        var numberTags = vm.tags.filter(t => t.id_tag === selectedTag.id_parent && t.id_type === vm.idTagTypeNumber);
        numberTags.forEach(x => media.tags.push(x));
      }
      // Used by the $chips.
      media.filteredTags = filterRunnerOrNumberTag(media.tags);
    }

    function removeTag(media, tag) {
      for (var i = 0, len = media.tags.length; i < len; i++) {
        if (media.tags[i].id_tag === tag.id_tag) {
          media.tags.splice(i, 1);
        }
      }
    }
    
    function deleteIncorrectTags(profile, mediaItem){
      console.log(mediaItem.tags);
      for(var i=0; i<mediaItem.tags.length; i++){
        if(mediaItem.tags[i].tag_name === profile.runnerTag.tag_name || mediaItem.tags[i].tag_name === profile.numberTag.tag_name){
          console.log("remove: " + mediaItem.tags[i].tag_name);
          mediaItem.tags.splice(i, 1);
          // removeTag(mediaItem, mediaItem.tags[i]);
        }
      }
      confirmMediaIncorrectTag(mediaItem);
    }

    vm.openFacesRelatedInImageDialog = function(ev, facesRelated, ImageSelected, cropFormats, MediaFull) {
      openImageDialog(ev, true, facesRelated, ImageSelected, cropFormats, MediaFull)
    }

    function openImageDialog(ev, tags, images, ImageSelected, cropFormats, MediaFull) {
      var imagesToShow = [];
      for(var i=0; i<images.length; i++){
        if(images[i].id_cropformats == 11015){
          imagesToShow.push(images[i]);
        }
      }
      if(imagesToShow.length == 0){
        imagesToShow = images;
      }
      $mdDialog.show({
        controller: 'MediaShowDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/dialogs/media-show/media-show-dialog-with-tags.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        escapeToClose: true,
        locals: {
          Images: imagesToShow,
          ImageSelected: ImageSelected,
          cropFormats: cropFormats,
          MediaFull: MediaFull,
          Tags: tags,
          // Tasks: vm.tasks,
          // event: ev
        }
      })
    }

    function getGalleries() {
      if (sessionService.site_operative.mediaGalleriesDefaultSort) {
        vm.sortFieldGalleries = sessionService.site_operative.mediaGalleriesDefaultSort.field;
        if (!angular.isUndefined(sessionService.site_operative.mediaGalleriesDefaultSort.dir)) {
          vm.sortDirGalleries = sessionService.site_operative.mediaGalleriesDefaultSort.dir;
        }
      } else {
        vm.sortFieldGalleries = "gallery_name";
        vm.sortDirGalleries = "ASC"
      }
      var options = {
        domain: vm.siteID,
        siteID: vm.siteID,
        sortField: vm.sortFieldGalleries,
        sortDir: vm.sortDirGalleries
      };
      //options.withTotalMediaCount = true;
      //options.withCover = true;
      mediaService.getNestedMediaGalleries(options)
        .then(function (response) {
          var qiuRestrictions = response.qiuRestrictions;
          vm.mediaGalleryRestrictions = angular.copy(qiuRestrictions);
          var galleries = response.data;

          vm.CleanMediaGalleries = transformMedia.formatNestedGalleries(galleries, qiuRestrictions, true);
          transformMedia.preAssignQiuRestrictedRoot(vm.CleanMediaGalleries);
      })
    }

    function onTabSelected(view) {
      if (vm.eventTags.length > 0) {
        vm.currentTabView = view;
        $rootScope.pagination_page = 1;
        getItems();
      }
    }

    function getTags(options) {
      return tagsService.get(options)
        .then(function(response){
          if (response && response.hasOwnProperty('data')) {
            // Filter tags of type Event
            vm.eventTags = response.data.filter(function(tag){ return tag.id_type == vm.idTagTypeEvent});

            // Filter tag 'is profile'
            let tagIsProfile = response.data.find(function(tag){ return tag.id_type == vm.idTagTypeIsProfile});
            if (tagIsProfile) {
              vm.idTagIsProfile = tagIsProfile.id_tag;
            }
            // Filter tag 'is unmatched'
            let tagIsUnmatched = response.data.find(function(tag){ return tag.id_type == vm.idTagTypeIsUnmatched});
            if (tagIsUnmatched) {
              vm.idTagIsUnmatched = tagIsUnmatched.id_tag;
            }
            return Promise.resolve();
          } else {
            // TODO: Show error alert
            return Promise.reject();
          }
        }, function(error){
          // TODO: Show error alert
          return Promise.reject();
        })
    }

    function getItems() {
      if(vm.currentEventTag) {
        // If current event tag is retrieved from settings, we need to find it among the eventtags and point at the corresponding object.
        // Otherwise the event won't be preselected in the view's Event selector.
        let eventTag = vm.eventTags.find(tag => tag.id_tag == vm.currentEventTag.id_tag);
        if (eventTag) {
          vm.currentEventTag = eventTag;
          getItemsByEventTag(vm.currentEventTag);
        } else {
          // TODO: Show alert: Event is required.
        }
      } else {
        showDialogSelectEvent().then(function(response) {
          vm.currentEventTag = response;
          settingUserService.setSetting(vm.section, 'currentEventTag', vm.currentEventTag);
          getItemsByEventTag(vm.currentEventTag)
        }, function(){
          // TODO: Show alert: Event is required.
        })
      }
    }

    /**
    * Add label chips
    *
    * @param query
    * @returns {filterFn}
    */
    function labelQuerySearch(query, tagTypeIds) {
      var response = [];
      if (query) {
        response =  vm.tags.filter(createFilterFor(query))
      }
      if (tagTypeIds) {
        response = response.filter(function(tag){
          return tagTypeIds.includes(tag.id_type);
        });
      }

      return response;
    }
    /**
     * Filter for chips
     *
     * @param query
     * @returns {filterFn}
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(item) {
        if (angular.isUndefined(item.tag_name)) {
          return false;
        }
        if (!item.tag_name) {
          return false;
        }
        if (!angular.lowercase(item.tag_name.toString()).indexOf) {
          return false;
        }
        return angular.lowercase(item.tag_name.toString()).indexOf(lowercaseQuery) >= 0;
      };
    }

    vm.pagination_prevPage = function () {
      $rootScope.pagination_page--;
      getItemsByEventTag(vm.currentEventTag);
    }

    vm.pagination_nextPage = function () {
      $rootScope.pagination_page++;
      getItemsByEventTag(vm.currentEventTag);
    }

    vm.setNewPerPageSize = function(size) {
      vm.perPage = size;
      $rootScope.perPage = size;
      $rootScope.pagination_page = 1;
      getItemsByEventTag(vm.currentEventTag);
    }

    vm.getTagByIdAndType = function(idTag, idType) {
      return vm.tags.find(function(tag){return tag.id_tag == idTag && tag.id_type == idType});
    }

    function getItemsByEventTag(eventTag) {
      vm.threads = [];
      vm.isLoading = true;

      var options = {
        siteID: vm.siteID,
        sortDir: $rootScope.sortDir,
        sortField: $rootScope.sortField,
        resultsPerPage: $rootScope.perPage,
        page: $rootScope.pagination_page,
        filters: $rootScope.filters
      };
      // TODO: Temporary remove current Event from queries
      switch (vm.currentTabView) {
        case 'recognized_media':
          // options.idTagsAnd = [vm.currentEventTag.id_tag];
          options.idTagTypesAndOr = [vm.idTagTypeNumber, vm.idTagTypeRunner]
          break;
        case 'unrecognized_media':
          // options.idTagsAnd = [vm.currentEventTag.id_tag];
          options.idTagTypesAndNot = [vm.idTagTypeNumber, vm.idTagTypeRunner, vm.idTagTypeIsProfile]
          break;
        case 'recognized_profiles':
//          options.idTagsAnd = [vm.currentEventTag.id_tag, vm.idTagIsProfile];
          options.idTagsAnd = [vm.idTagIsProfile];
          options.idTagsAndNot = [vm.idTagIsUnmatched];
          //options-withAiRecognition = true;
          break;
        case 'unrecognized_profiles':
          options.idTagsAnd = [vm.currentEventTag.id_tag, vm.idTagIsProfile, vm.idTagIsUnmatched];
          break;
      }

      getMedia(options).then(function(){
         switch (vm.currentTabView) {
          case 'unrecognized_profiles':
          case 'recognized_profiles':
            getProfilesDetails();
            break;
          default:
            vm.isLoading = false;
            break;
        }
      });

      settingUserService.setSetting(vm.section, 'currentEventTag', eventTag);
    }

    function getMedia(options) {
      return mediaService.get(options).then(function(response){
        vm.threads = response.data
        $rootScope.pagination_totalItems = response.total;
        $rootScope.pagination_total_pages = response.last_page;
        $rootScope.pagination_from = response.from || 0 ;
        $rootScope.pagination_to = response.to || 0;
        $rootScope.pagination_page = response.last_page < response.current_page ? response.last_page : response.current_page;
        return Promise.resolve();
      }, function(error) {
        console.log(error)
        vm.isLoading = false;
      });
    }

    // function setFacesUploadMedia() {
    //   vm.media.recognized   = vm.threads.filter(media =>   media.tags &&   angular.isArray(media.tags) &&   media.tags.some (tag => tag.id_type == vm.idTagTypeRunner || tag.id_type == vm.idTagTypeNumber ))
    //   vm.media.unrecognized = vm.threads.filter(media => ! media.tags || ! angular.isArray(media.tags) || ! media.tags.some (tag => tag.id_type == vm.idTagTypeRunner || tag.id_type == vm.idTagTypeNumber || tag.id_type == vm.idTagTypeIsProfile))
    //   vm.media.profiles     = vm.threads.filter(media =>   media.tags &&   angular.isArray(media.tags) &&   media.tags.some (tag => tag.id_type == vm.idTagTypeIsProfile))
    //   vm.isLoading = false;
    // }

    function getProfilesDetails() {
      if (! angular.isArray(vm.threads)){
        return;
      }
      var promiseQueue = [];
      angular.forEach(vm.threads, function(media){
        promiseQueue.push(getMediaDetails(media));
      })
      $q.all(promiseQueue).then(function (responses) {
        vm.isLoading = false;
      })
    }

    /**
     * At this point we only have a reduced version of the media record.
     * Retrieve more info like meta_analyses.
     */
    function getMediaDetails(media) {
      var options = {
        siteID: vm.siteID,
        idMedia: media.id_media
      }
      return mediaService.get(options).then(function(response){
        if (response.hasOwnProperty('data') && angular.isArray(response.data) && response.data.length > 0) {
          media.meta_analyses = response.data[0].meta_analyses
          media.ai_recognition = response.data[0].ai_recognition
          media.runnerTags = null; // Used to hold final Runner tag;
          media.numberTags = null; // Used to hold final Runner tag;
          prepareMediaRecognitionFindings(media);
          assignMediaToProfilesByRecognitionFinding(media);
        }
        return Promise.resolve();
      }, function(error){
        // What to do if media details not found??
      })
    }


    /**
     * Reads faces and texts from meta_analyses as detected by AI.
     * Assigns corresponding faceId, and 'Number' and 'Runner' tags to media, if any were found.
     */
    function prepareMediaRecognitionFindings(media) {
      // Get number from meta_analyses
      media.faceId = getFaceIdDetection(media);
      let uniqueTextDetections = getUniqueTextDetections(media);
      let uniqueTextDetectionsFiltered = filterStringsByRegex(uniqueTextDetections);
      let numberTags = filterTagsByText(uniqueTextDetectionsFiltered, vm.idTagTypeNumber);
      if (numberTags.length != 1) {
        // Get number tag from tags
        if (media.tags && angular.isArray(media.tags)) {
          numberTags = media.tags.filter(t => t.id_type == vm.idTagTypeNumber);
        }
      }
      if (numberTags.length == 1) {
        media.numberTag = numberTags[0]
        let runnerTags = filterTagsByParentAndType(media.numberTag.id_tag, vm.idTagTypeRunner);
        if (runnerTags.length != 1) {
          // Get number tag from tags
          if (media.tags && angular.isArray(media.tags)) {
            runnerTags = media.tags.filter(t => t.id_type == vm.idTagTypeRunner);
          }
        }
        if (runnerTags.length == 1) {
          media.runnerTag = runnerTags[0];
        } else if (runnerTags.length > 1) {
          media.runnerTagsOptions = runnerTags;
        }
      }
    }

    function setRunnerTagsOptions(profile) {
      if (profile.numberTag) {
        profile.runnerTagsOptions = vm.tags.filter(x => x.id_parent == profile.numberTag.id_tag);
        if (profile.runnerTagsOptions.length == 1) {
          profile.runnerTag = profile.runnerTagsOptions[0];
        }
      }
    }

    function assignMediaToProfilesByRecognitionFinding(media) {
      if (media.runnerTag) {
        //vm.profiles.recognized.push(media);
        // Approve automatically!
        // confirmProfile(media);
      } else {
        //vm.profiles.unrecognized.push(media);
      }
    }

    function getFaceIdDetection(media) {
      if (
        media.hasOwnProperty('meta_analyses') &&
        media.meta_analyses != null &&
        media.meta_analyses.hasOwnProperty('rekognition_index_faces') &&
        media.meta_analyses.rekognition_index_faces.hasOwnProperty('FaceRecords') &&
        angular.isArray(media.meta_analyses.rekognition_index_faces.FaceRecords)
      ) {
        let faceRecord = media.meta_analyses.rekognition_index_faces.FaceRecords
          .find(function(faceDetection) {
            return faceDetection.Face.Confidence > vm.confidenceThresholdFaceRecognition;
          })
        if (faceRecord) {
          return faceRecord.Face.FaceId
        }
        return null;
      }
      return null;
    }

    function filterTagsByParentAndType(idParent, idType) {
      if (!idParent) return [];
      return vm.tags.filter(function(tag) {
        return tag.id_parent == idParent && tag.id_type == idType
      })
    }

    function filterTagsByText(texts, idType) {
      return vm.tags.filter(function(tag) {
        return (
          tag.tag_name != null &&
          tag.id_type == idType &&
          texts.includes(tag.tag_name.toString())
        )
      })
    }

    function getUniqueTextDetections(media) {
      if (
        media.hasOwnProperty('meta_analyses') &&
        media.meta_analyses != null &&
        media.meta_analyses.hasOwnProperty('rekognition_detect_text') &&
        media.meta_analyses.rekognition_detect_text.hasOwnProperty('TextDetectionsUnique') &&
        angular.isArray(media.meta_analyses.rekognition_detect_text.TextDetectionsUnique)
      ) {
        return media.meta_analyses.rekognition_detect_text.TextDetectionsUnique
          .filter(function(uniqueTextDetection){
            return uniqueTextDetection.Type == 'WORD' || 'LINE' && uniqueTextDetection.Confidence > vm.confidenceThresholdTextRecognition;
          })
          .map(function(uniqueTextDetection) {
            return uniqueTextDetection.DetectedText;
          })
      }
      return [];
    }

    function filterStringsByRegex(textDetections) {
      const regex = new RegExp(vm.regexRule);
      return textDetections.filter(textDetection => textDetection.match(regex));
    }

    function showDialogSelectEvent() {
      return $mdDialog.show({
        controller: 'SelectEventController',
        controllerAs: 'vm',
        templateUrl: 'app/main/apps/ai/dialogs/select-event/select-event.html',
        parent: angular.element($document.body),
        targetEvent: new MouseEvent('click'),
        multiple: true,
        clickOutsideToClose: false,
        locals: {
          events: vm.eventTags
        }
      })
    }

    function confirmProfile(profile) {
      profile.isLoading = true;
      delete profile.runnerTagsOptions;
      normalizeProfilesAiRecognition(profile);
      attachFaceToProfilesAiRecognition(profile);
      attachTextToProfilesAiRecognition(profile);
      removeUnmatchedTagFromProfile(profile);
      if (profile.runnerTag) {
        profile.title = profile.runnerTag.tag_name;
        profile.tags.push(profile.runnerTag.id_tag);
      }
      if (profile.numberTag) {
        profile.tags.push(profile.numberTag.id_tag);
      }
      if (vm.setMediaAiRecognitionTags) {
        profile.set_media_ai_recognition_tags = true;
      }
      updateMedia(profile)
        .then(function (response) {
          profile.isLoading = false;
          // TODO: Show success message
          //getItemsByEventTag(vm.currentEventTag)
          profile.confirmed = true;
        }, function(error){
          profile.isLoading = false;
          // TODO: Show error message
        });
    }
    
    function confirmMedia(media) {
      vm.isLoading = true;
      if (!media.tags || !angular.isArray(media.tags)){
        media.tags = []
      } else {
        media.tags = media.tags.map(x => x.id_tag);
      }

      if (media.runnerTag) {
        media.tags.push(media.runnerTag.id_tag);
      }
      if (media.numberTag) {
        media.tags.push(media.numberTag.id_tag);
      }

      delete media.runnerTagsOptions;

      updateMedia(media)
        .then(function (response) {
          vm.isLoading = false;
          // TODO: Show success message
          //getItemsByEventTag(vm.currentEventTag)
          media.confirmed = true;
        }, function(error){
          vm.isLoading = false;
          // TODO: Show error message
        });
    }

    function confirmMediaIncorrectTag(media) {
      media.loadingMediaItem = true;
      if (!media.tags || !angular.isArray(media.tags)){
        media.tags = []
      } else {
        media.tags = media.tags.map(x => x.id_tag);
      }

      if (media.runnerTag) {
        media.tags.push(media.runnerTag.id_tag);
      }
      if (media.numberTag) {
        media.tags.push(media.numberTag.id_tag);
      }

      delete media.runnerTagsOptions;

      updateMedia(media)
        .then(function (response) {
          media.loadingMediaItem = false;
          // TODO: Show success message
          //getItemsByEventTag(vm.currentEventTag)
          media.confirmed = true;
          var i = vm.mediaRelated.indexOf(media)
          vm.mediaRelated.splice(i, 1);
          //media.hidden = true;
        }, function(error){
          media.loadingMediaItem = false;
          // TODO: Show error message
        });
    }

    function normalizeProfilesAiRecognition(profile) {
      if (!profile.ai_recognition){
        profile.ai_recognition = {}
      }
      if (!profile.ai_recognition.hasOwnProperty('faces')){
        profile.ai_recognition.faces = []
      }
      if (!profile.ai_recognition.hasOwnProperty('texts')){
        profile.ai_recognition.texts = []
      }
    }

    function attachFaceToProfilesAiRecognition(profile) {
      if (!profile.faceId || !profile.runnerTag) {
        return;
      }
      let foundFace = profile.ai_recognition.faces.find(function(face){ return face.id == profile.faceId});
      if (foundFace) {
        return;
      }
      let face = {
        id: profile.faceId,
        tags: [{
          id: profile.runnerTag.id_tag,
          name: profile.runnerTag.tag_name
        }],
        enabled: true,
        min_match: vm.confidenceThresholdFaceRecognition
      }
      profile.ai_recognition.faces.push(face);
    }

    function attachTextToProfilesAiRecognition(profile) {

      if (!profile.numberTag) {
        return;
      }
      let foundText = profile.ai_recognition.texts.find(function(text){ return text.id == profile.numberTag.tag_name.toString()});
      if (foundText) {
        return;
      }
      let text = {
        id: profile.numberTag.tag_name.toString(),
        tags: [{
          id: profile.numberTag.id_tag,
          name: profile.numberTag.tag_name.toString()
        }],
        enabled: true,
        min_match: vm.confidenceThresholdTextRecognition
      }
      profile.ai_recognition.texts.push(text);
    }

    function updateMedia(media) {
      var options = {
        site: vm.siteID,
        id: media.id_media,
        item: media
      };
      if (media.galleries) {
        media.galleries = media.galleries.map(function(gallery) {return gallery.id_gallery})
      }
      return mediaService.saveMedia(options);
    }

    function removeUnmatchedTagFromProfile(profile) {
      profile.tags = profile.tags
        .filter(function(tag){return tag.id_type != vm.idTagTypeIsUnmatched})
        .map(function(tag){return tag.id_tag})
    }

    function rejectProfile(profile) {
      vm.editingTags = true;
    }

    function AddmediaDialog(ev, item) {
      $mdDialog.show({
        controller: 'AddMediaDialogController',
        controllerAs: 'vm',
        locals: {
          currentThread: vm.items,
          section: vm.section,
          isReplace: false,
          item: false,
          mediazone: false,
          CleanMediaGalleries: vm.CleanMediaGalleries,
          isTiny: false,
          preselectedTags: [vm.currentEventTag]
        },
        templateUrl: 'app/main/apps/media/dialogs/media/media-dialog.html',
        parent: angular.element($document.body),
        multiple: true,
        targetEvent: ev,
        clickOutsideToClose: true
      })
        .then(function (items) {
          getItemsByEventTag(vm.currentEventTag)
        });
    }


    function openFace(item) {
      vm.selectedText = [];
      vm.selectedRelated = [];
      vm.selectedTags = [];
      vm.facesRelated = null
      vm.textsRelated = null
      vm.selectedFace = item;
      vm.currentTab = 'preview';
      item = mapMedia(item)
      vm.selectedFaceData = item;
      vm.mediaRelated = []

      var relatedTagIds = [];

      if (item.ai_recognition &&
        item.ai_recognition.faces &&
        angular.isArray(item.ai_recognition.faces) &&
        item.ai_recognition.faces.length > 0 &&
        item.ai_recognition.faces[0].tags &&
        angular.isArray(item.ai_recognition.faces[0].tags) &&
        item.ai_recognition.faces[0].tags.length > 0
      ) {
        let runnerTagId = item.ai_recognition.faces[0].tags[0].id;
        relatedTagIds.push(runnerTagId);
      }

      if (item.ai_recognition &&
        item.ai_recognition.texts &&
        angular.isArray(item.ai_recognition.texts) &&
        item.ai_recognition.texts.length > 0 &&
        item.ai_recognition.texts[0].tags &&
        angular.isArray(item.ai_recognition.texts[0].tags) &&
        item.ai_recognition.texts[0].tags.length > 0
      ) {
        let numberTagId = item.ai_recognition.texts[0].tags[0].id;
        relatedTagIds.push(numberTagId);
      }

      if (relatedTagIds.lenth == 0) {
        return;
      }

      var options = {
        siteID: vm.siteID,
        //idTagsAnd: [vm.currentEventTag.id_tag],
        idTagAndOr: relatedTagIds,
        sortField: 'date_uploaded',
        sortDir: 'DESC',
        resultsPerPage: 100
      }

      mediaService.get(options).then(res => {
        console.log(res)
        if (res && res.data && res.data.length > 0) {
          vm.mediaRelated = res.data.map(mapMedia);
        }
        vm.isLoading = false;
      })
    }

    function mapMedia(media) {
      if (media.media) {
        var mediaContainer = sessionService.getContainerByID(media.media.cdnContainer);
        media.media.imageUrlOriginal = mediaContainer.view_url + 'original/m' + media.media.id_media + '_' + media.media.filename;
        media = media.media;
      } else {
        var mediaContainer = sessionService.getContainerByID(media.cdnContainer);
        media.imageUrlOriginal = mediaContainer.view_url + 'original/m' + media.id_media + '_' + media.filename;
      }
      return media;
    }


    function searchClick(query) {
      let numberTags = vm.tags.filter(t => t.id_type == vm.idTagTypeNumber && t.tag_name.toString().toLowerCase().includes(query.toLowerCase()))
      let runnerTags = vm.tags.filter(t => t.id_type == vm.idTagTypeRunner && t.tag_name.toString().toLowerCase().includes(query.toLowerCase()))

      if (numberTags.length == 0 && runnerTags.length == 0) {
        vm.threads = [];
        $rootScope.pagination_totalItems = 0;
        $rootScope.pagination_total_pages = 1;
        $rootScope.pagination_from = 1 || 0 ;
        $rootScope.pagination_to = 1 || 0;
        $rootScope.pagination_page = 1;
        return
      }

      var searchTagIds = [];

      angular.forEach(numberTags, x => {
        searchTagIds.push(x.id_tag)
      })
      angular.forEach(runnerTags, x => {
        searchTagIds.push(x.id_tag)
      })

      var options = {
        siteID: vm.siteID,
        withAiRecognition: true,
        idTagsAnd: [vm.idTagIsProfile],
        idTagsAndNot: [vm.idTagIsUnmatched],
        idTagAndOr: searchTagIds
      }

      vm.threads = [];

      mediaService.get(options).then(response => {
        if (response && response.data && response.data.length > 0) {
          if (runnerTags.length > 0) {
            let result = getMediaByAiRecognitionTags(response.data, runnerTags, 'faces');
            angular.forEach(result, x => {
              if (vm.threads.length == 0 || !vm.threads.map(t => t.id_media).includes(x.id_media)){
                 vm.threads.push(x);
               }
            })
          }
          if (numberTags.length > 0) {
            let result = getMediaByAiRecognitionTags(response.data, numberTags, 'texts');
            angular.forEach(result, x => {
              if (vm.threads.length == 0 || !vm.threads.map(t => t.id_media).includes(x.id_media)){
                 vm.threads.push(x);
               }
            })
          }

          angular.forEach(vm.threads, media => {
            var runnerTag = media.tags.find(x => x.id_type == vm.idTagTypeRunner)
            if (runnerTag) {
              media.runnerTag = runnerTag;
            }
            var numberTag = media.tags.find(x => x.id_type == vm.idTagTypeNumber)
            if (numberTag) {
              media.numberTag = numberTag;
            }
          });

          $rootScope.pagination_totalItems = vm.threads.length;
          $rootScope.pagination_total_pages = 1;
          $rootScope.pagination_from = 1 || 0 ;
          $rootScope.pagination_to = 1 || 0;
          $rootScope.pagination_page = 1;
        }
        vm.isLoading = false;
      })
    }

    function getMediaByAiRecognitionTags(media, tags, type) {
      return media.filter(m => {
        return  m.ai_recognition &&
                m.ai_recognition[type] &&
                angular.isArray(m.ai_recognition[type]) &&
                m.ai_recognition[type].length > 0 &&
                m.ai_recognition[type].filter(i => {
                  return  i.tags &&
                          angular.isArray(i.tags) &&
                          i.tags.length > 0 &&
                          i.tags.filter(t => tags.map(tag => tag.id_tag).includes(t.id)).length > 0
        }).length > 0
      })
    }

    function confirmDetectedUnrelated(profileMedia, mediaItem) {
      if (!profileMedia.runnerTag) {
        return;
      }

      mediaItem.loadingMediaItem = true;

      // mediaItem comes from searchFaces and thus without tags, etc, ...
      // so first load media with tags from api
      var options = {
        siteID: vm.siteID,
        withTags: true,
        idMedia:  mediaItem.id_media,
        withGalleries: true
      };
      mediaService.get(options).then(response => {
        if (response && response.data && angular.isArray(response.data) && response.data.length == 1){

          // mediaWithTags is used to replace mediaItem on list (with tags)
          var mediaWithTags = response.data[0];

          if (mediaWithTags.tags.includes(profileMedia.runnerTag.id_tag)) {
            console.log('Warning! Item already contains runner tag!', mediaWithTags)
            return;
          }
          // mediaAux is only used to update media on api (with tag IDs)
          var mediaAux = angular.copy(mediaWithTags)

          if (!mediaAux.tags || !angular.isArray(mediaAux.tags)){
            mediaAux.tags = []
          } else {
            mediaAux.tags = mediaAux.tags.map(x => x.id_tag);
          }
          // Add runner tag to media
          mediaAux.tags.push(profileMedia.runnerTag.id_tag);
          mediaWithTags.tags.push(profileMedia.runnerTag);

          delete mediaItem.runnerTagsOptions;
          delete mediaItem.isUndetectedRelated;

          updateMedia(mediaAux).then(function (response) {
              mediaItem.loadingMediaItem = false;
              mediaItem.confirmed = true;
              // replace media without tags, by media with tags
              var i = vm.mediaRelated.indexOf(mediaItem)
              vm.mediaRelated.splice(i, 1);
              vm.mediaRelated.splice(i, 0, mediaWithTags);
              // TODO: Show success message
            }, function(error){
              mediaItem.loadingMediaItem = false;
              // TODO: Show error message
            });
        }
      })
    }

    function tagUnrecognizedImagesByFaceId(media) {
      if (!media.faceId || media.faceId === null) {
        if (media.ai_recognition && media.ai_recognition.faces[0].id) {
          media.faceId = media.ai_recognition.faces[0].id;
        }
      }
      if (media.faceId) {
        vm.isLoadingRelated = true;
        var optionsRelated = {
          siteID: vm.siteID,
          item: {
            faces: [media.faceId]
          }
        }
        mediaService.getFacesRelated(optionsRelated)
        .then(response => {
            if (response && angular.isArray(response)) {
              // sort by Similarity desc.
              response.sort((a, b) => (a.Similarity > b.Similarity) ? 1 : -1)
              for (let key in response) {
                var relatedImage = response[key];
                var mediaContainer = sessionService.getContainerByID(relatedImage.media.cdnContainer);
                relatedImage.media.imageUrlOriginal = mediaContainer.view_url + 'original/m' + relatedImage.media.id_media + '_' + relatedImage.media.filename;
                if (relatedImage.Similarity && relatedImage.Similarity > 95 &&
                  !vm.mediaRelated.find(rel => rel.id_media == relatedImage.media.id_media)
                ) {
                  relatedImage.media.isUndetectedRelated = true;
                  relatedImage.media.loadingMediaItem = false;
                  vm.mediaRelated.unshift(relatedImage.media);
                }
              }
            }
          
        }, error => {
          
        }).finally(x => {
          vm.isLoadingRelated = false;
        })
      }
    }

    function searchClear(item){
      getItemsByEventTag(vm.currentEventTag);
    }

    // Watch screen size to change view modes
    $scope.$watch(function () {
      return $mdMedia('lt-sm');
    }, function (current, old) {
      if (angular.equals(current, old)) {
        return;
      }

      if (current) {
        vm.currentView = 'nosplit';
      }
    });

    $scope.$watch(function () {
      return $mdMedia('max-width: 960px');
    }, function (big) {

      if (big)
        vm.currentView = 'nosplit';

    });

    $scope.$watch(function () {
      return $mdMedia('min-width: 960px');
    }, function (small) {

      if (small)
        vm.currentView = 'split';

    });

    $scope.$watch(function () {
      return $mdMedia('gt-sm');
    }, function (current, old) {
      if (angular.equals(current, old)) {
        return;
      }

      if (current) {
        if (vm.defaultView === 'split') {
          vm.currentView = 'split';
        }
      }
    });
  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.calendar')
        .controller('CalendarController', CalendarController);

    /** @ngInject */
    function CalendarController($mdDialog, $document)
    {
        var vm = this;

        // Data
        var date = new Date();
        var d = date.getDate();
        var m = date.getMonth();
        var y = date.getFullYear();

        vm.events = [
            [
                {
                    id   : 1,
                    title: 'All Day Event',
                    start: new Date(y, m, 1),
                    end  : null
                },
                {
                    id   : 2,
                    title: 'Long Event',
                    start: new Date(y, m, d - 5),
                    end  : new Date(y, m, d - 2)
                },
                {
                    id   : 3,
                    title: 'Some Event',
                    start: new Date(y, m, d - 3, 16, 0),
                    end  : null
                },
                {
                    id   : 4,
                    title: 'Repeating Event',
                    start: new Date(y, m, d + 4, 16, 0),
                    end  : null
                },
                {
                    id   : 5,
                    title: 'Birthday Party',
                    start: new Date(y, m, d + 1, 19, 0),
                    end  : new Date(y, m, d + 1, 22, 30)
                },
                {
                    id   : 6,
                    title: 'All Day Event',
                    start: new Date(y, m, d + 8, 16, 0),
                    end  : null
                },
                {
                    id   : 7,
                    title: 'Long Event',
                    start: new Date(y, m, d + 12, 16, 0),
                    end  : null
                },
                {
                    id   : 8,
                    title: 'Repeating Event',
                    start: new Date(y, m, d + 14, 2, 0),
                    end  : null
                },
                {
                    id   : 9,
                    title: 'Repeating Event',
                    start: new Date(y, m, d + 14, 4, 0),
                    end  : null
                },
                {
                    id   : 10,
                    title: 'Repeating Event',
                    start: new Date(y, m, d + 14, 2, 0),
                    end  : null
                },
                {
                    id   : 11,
                    title: 'Repeating Event',
                    start: new Date(y, m, d + 14, 4, 0),
                    end  : null
                },
                {
                    id   : 12,
                    title: 'Repeating Event',
                    start: new Date(y, m, d + 14, 2, 0),
                    end  : null
                },
                {
                    id   : 13,
                    title: 'Repeating Event',
                    start: new Date(y, m, d + 14, 4, 0),
                    end  : null
                },
                {
                    id   : 14,
                    title: 'Conference',
                    start: new Date(y, m, d + 17, 4, 0),
                    end  : null
                },
                {
                    id   : 15,
                    title: 'Meeting',
                    start: new Date(y, m, d + 22, 4, 0),
                    end  : new Date(y, m, d + 24, 4, 0)
                }
            ]
        ];

        vm.calendarUiConfig = {
            calendar: {
                editable          : true,
                eventLimit        : true,
                header            : '',
                handleWindowResize: false,
                aspectRatio       : 1,
                dayNames          : ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                dayNamesShort     : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                viewRender        : function (view)
                {
                    vm.calendarView = view;
                    vm.calendar = vm.calendarView.calendar;
                    vm.currentMonthShort = vm.calendar.getDate().format('MMM');
                },
                columnFormat      : {
                    month: 'ddd',
                    week : 'ddd D',
                    day  : 'ddd M'
                },
                eventClick        : eventDetail,
                selectable        : true,
                selectHelper      : true,
                select            : select
            }
        };

        // Methods
        vm.addEvent = addEvent;
        vm.next = next;
        vm.prev = prev;

        //////////

        /**
         * Go to next on current view (week, month etc.)
         */
        function next()
        {
            vm.calendarView.calendar.next();
        }

        /**
         * Go to previous on current view (week, month etc.)
         */
        function prev()
        {
            vm.calendarView.calendar.prev();
        }

        /**
         * Show event detail
         *
         * @param calendarEvent
         * @param e
         */
        function eventDetail(calendarEvent, e)
        {
            showEventDetailDialog(calendarEvent, e);
        }

        /**
         * Add new event in between selected dates
         *
         * @param start
         * @param end
         * @param e
         */
        function select(start, end, e)
        {
            showEventFormDialog('add', false, start, end, e);
        }

        /**
         * Add event
         *
         * @param e
         */
        function addEvent(e)
        {
            var start = new Date(),
                end = new Date();

            showEventFormDialog('add', false, start, end, e);
        }

        /**
         * Show event detail dialog
         * @param calendarEvent
         * @param e
         */
        function showEventDetailDialog(calendarEvent, e)
        {
            $mdDialog.show({
                controller         : 'EventDetailDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/calendar/dialogs/event-detail/event-detail-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : e,
                clickOutsideToClose: true,
                locals             : {
                    calendarEvent      : calendarEvent,
                    showEventFormDialog: showEventFormDialog,
                    event              : e
                }
            });
        }

        /**
         * Show event add/edit form dialog
         *
         * @param type
         * @param calendarEvent
         * @param start
         * @param end
         * @param e
         */
        function showEventFormDialog(type, calendarEvent, start, end, e)
        {
            var dialogData = {
                type         : type,
                calendarEvent: calendarEvent,
                start        : start,
                end          : end
            };

            $mdDialog.show({
                controller         : 'EventFormDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/calendar/dialogs/event-form/event-form-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : e,
                clickOutsideToClose: true,
                locals             : {
                    dialogData: dialogData
                }
            }).then(function (response)
            {
                if ( response.type === 'add' )
                {
                    // Add new
                    vm.events[0].push({
                        id   : vm.events[0].length + 20,
                        title: response.calendarEvent.title,
                        start: response.calendarEvent.start,
                        end  : response.calendarEvent.end
                    });
                }
                else
                {
                    for ( var i = 0; i < vm.events[0].length; i++ )
                    {
                        // Update
                        if ( vm.events[0][i].id === response.calendarEvent.id )
                        {
                            vm.events[0][i] = {
                                title: response.calendarEvent.title,
                                start: response.calendarEvent.start,
                                end  : response.calendarEvent.end
                            };

                            break;
                        }
                    }
                }
            });
        }

    }

})();
(function () {
	'use strict';

	angular
		.module('app.backend')
		.service("backendService", backendService);

	/** @ngInject */
	// I provide access to the session store.
	function backendService($q, $resource, userService, settingsDomainService, sessionService, COMMON, $window) {


		var reference_sections = [];



		function getSections(options) {

			var deferred = $q.defer();

			var filters = [];
			_.forEach(options, function (value, key, list) {
				if (_.isObject(list[key])) {
					_.forEach(list[key], function (filter, keyFilter, listFilter) {
						if (!_.isEmpty(filter.selected)) {
							filters.push({
								field: filter.field,
								name: filter.name,
								values: filter.selected
							});
						}

					});

				}
			});


			resourceSections.get({
				domain: options.siteID,
				name: options.section,
				page: options.page,
				search: options.searchStringFilter,
				paginate: options.resultsPerPage,
				sortField: options.sortField,
				sortDir: options.sortDir,
				filters: JSON.stringify(filters),
				mediaZones: options.mediaZones,
				cropformats: options.cropformats,
				fields: options.fields,
				sub: options.sub
			},
				function (response) {
					deferred.resolve({ data: response.sections });
				},
				function (e) {
					console.error("ERROR =========================================!!!!!!")
					console.error(e)
					deferred.reject();
				}
			);

			// Return the promise.
			return (deferred.promise);
		}



		function getSection(options) {
			var deferred = $q.defer();

			resourceSection.get({
				domain: options.site,
				section: options.section,
				// id: options.id,
				// lang: get("language")
			},
				function (response) {

					// angular.copy(response, modulecontent);
					// setActiveDomain(domain);

					deferred.resolve(response);
				},
				function (e) {
					console.error(e)
					console.error("Database connection error")
					deferred.reject();
				}
			);

			// Return the promise.
			return (deferred.promise);
		}

		function getOptions(options) {
			var deferred = $q.defer();


			resourceOptions.get({
				domain: options.site,
			},
				function (response) {
					deferred.resolve(response);
				},
				function (e) {
					console.error(e);
					deferred.reject();
				}
			);

			// Return the promise.
			return (deferred.promise);
		}

		function saveSectionSettings(options) {
			var deferred = $q.defer();

			resourceSection.update({
				domain: options.site,
				section: options.section,
				data: options.data
			},
				function (response) {
					deferred.resolve(response);
				},
				function (e) {
					console.error(e)
					console.error("Database connection error")
					deferred.reject();
				}
			);

			// Return the promise.
			return (deferred.promise);
		}

		function saveSectionsRef(options) {
			var deferred = $q.defer();
			getResourceRef(options).update(options.data,
				function (response) {
					deferred.resolve(response);
				},
				function (e) {
					console.error(e)
					console.error("Database connection error")
					deferred.reject();
				}
			);
			// Return the promise.
			return (deferred.promise);
		}

		function deleteSectionRef(options) {
			var deferred = $q.defer();
			getResourceRef(options).delete({},
				function (response) {
					deferred.resolve(response);
				},
				function (e) {
					console.error(e)
					console.error("Database connection error")
					deferred.reject();
				}
			);

			return (deferred.promise);
		}

		function createSectionsRef(options) {
			var deferred = $q.defer();
			getResourceRefCreate(options).post(options.data,
				function (response) {
					deferred.resolve(response);
				},
				function (e) {
					console.error(e)
					console.error("Database connection error")
					deferred.reject();
				}
			);
			// Return the promise.
			return (deferred.promise);
		}

		function getResourceRef(options) {
			return $resource(
				COMMON.BASE_API + "/domain/" + options.domain + "/backend/content/sections/" + options.section + "/ref/" + options.id, {}, {
					update: { method: "PUT", },
					delete: { method: "DELETE", }
				})
		}
		function getResourceRefCreate(options) {
			return $resource(
				COMMON.BASE_API + "/domain/" + options.domain + "/backend/content/sections/" + options.section + "/ref", {}, {
					post: { method: "POST", }
				})
		}

		function populateRef(options) {
			var deferred = $q.defer();

			resourceSectionRef.save({
				domain: options.site,
				section: options.section
			},
				function (response) {
					deferred.resolve(response);
				},
				function (e) {
					console.error(e)
					console.error("Database connection error")
					deferred.reject();
				}
			);

			// Return the promise.
			return (deferred.promise);
		}

		function getSectionRef(options) {
			var deferred = $q.defer();

			resourceGetSectionRef.get({
				domain: options.domain,
				section: options.section
			},
				function (response) {
					deferred.resolve(response);
				},
				function (e) {
					console.error(e)
					console.error("Database connection error")
					deferred.reject();
				}
			);

			// Return the promise.
			return (deferred.promise);
		}

		function getSectionRefFields(options) {
			var deferred = $q.defer();
			resourceGetSectionRefFields.get({
				domain: options.domain,
				section: options.section
			},
				function(response){
					deferred.resolve(response);
				},
				function(e) {
					console.error(e)
					console.error("Database connection error")
					deferred.reject();
				}
			);
			return(deferred.promise);
		}

		var resourceGetSectionRefFields = $resource(
			COMMON.BASE_API + "/domain/:domain/content/:section/refFields", {

			}, {
				get: {
					method: "GET",
					isArray: true
				}
			}
		)

		var resourceSections = $resource(
			COMMON.BASE_API + "/domain/:domain/backend/content/sections", {
				// No default data.
			}, {
				get: {
					method: "GET",
					isArray: false
				}
			}
		);

		var resourceSection = $resource(
			COMMON.BASE_API + "/domain/:domain/backend/content/sections/:section", {
				domain: '@domain',
				section: '@section',
				// data: '@data',
			}, {
				get: {
					method: "GET",
					// isArray: true
				},
				update: {
					method: "PUT",
				},
			}
		);

		var resourceOptions = $resource(
			COMMON.BASE_API + "/domain/:domain/content/news/options", {
				// No default data.
			}, {
				get: {
					method: "GET",
				}
			}
		);

		var resourceGetSectionRef = $resource(
			COMMON.BASE_API + "/domain/:domain/backend/content/sections/:section/ref", {
				domain: '@domain',
				section: '@section'
			}, {
				get: {
					method: "GET",
					isArray: true
				}
			}
		)

		var resourceSectionRef = $resource(
			COMMON.BASE_API + "/site/:domain/backend/content/sections/:section/ref", {
				domain: '@domain',
				section: '@section',
				// data: '@data',
			}, {
				get: {
					method: "GET",
					// isArray: true
				},
				update: {
					method: "PUT",
				},
			}
		);

		var resourceSectionRefUpdate = $resource(
			COMMON.BASE_API + "/domain/:domain/backend/content/sections/:section/ref/:id", {
				domain: '@domain',
				section: '@section',
				id: '@id',
				// data: '@data',
			}, {
				get: {
					method: "GET",
					// isArray: true
				},
				update: {
					method: "PUT",
				},
			}
		);

		// Return the public API.
		return ({
			get: getSections,
			getSections: getSections,
			getSection: getSection,
			getFilters: getOptions,
			saveSectionsRef: saveSectionsRef,
			deleteSectionRef: deleteSectionRef,
			createSectionsRef: createSectionsRef,
			saveSectionSettings: saveSectionSettings,
			populateRef: populateRef,
			getSectionRef: getSectionRef,
			getSectionRefFields: getSectionRefFields
		});


	}


})();

(function () {
    'use strict';

    angular
        .module('app.backend')
        .controller('BackendController', BackendController);

    /** @ngInject */
    function BackendController($document, $state, $mdDialog, $mdSidenav, $mdToast, Tasks, Tags,
        backendService, requestContext, $scope, $rootScope, msUtils) {
        var vm = this;

        // Data
        $scope.isLoading = true;
        vm.tasks = [];
        vm.selectedContentID = null;
        vm.tags = Tags.data;
        vm.showSearch = false;
        // vm.tasks = [];
        // vm.tags = [];
        vm.completed = [];
        vm.colors = ['blue', 'blue-grey', 'orange', 'pink', 'purple'];
        vm.projects = {
            'creapond': 'Project Creapond',
            'withinpixels': 'Project Withinpixels'
        };
        vm.selectedFilter = {
            filter: 'Start Date',
            dueDate: 'Next 3 days'
        };
        vm.selectedProject = 'creapond';
        /**
         * Vistas que puede traer una seccion por defecto (sections.default_view).
         * El valor vacio = sin defecto: decide el usuario / el tamaño de pantalla.
         * La lista base se crea aqui (no en el callback de carga) para que las fichas se
         * pinten siempre, sin depender de cuando responda la peticion.
         */
        var VISTAS_BASE = [
            { value: '',            label: 'CONTENT.NO_DEFAULT_VIEW',  icon: 'icon-close' },
            { value: 'split',       label: 'CONTENT.SPLIT_VIEW',       icon: 'icon-view-quilt' },
            { value: 'nosplit',     label: 'CONTENT.NOSPLIT_VIEW',     icon: 'icon-view-list' },
            { value: 'grid',        label: 'CONTENT.GALLERY_VIEW',     icon: 'icon-view-module' },
            { value: 'spreadsheet', label: 'CONTENT.SPREADSHEET_VIEW', icon: 'icon-table-edit' }
        ];
        vm.defaultViewOptions = VISTAS_BASE.slice();

        /**
         * Al cargar la seccion: si lo guardado no es ninguna vista real (hay filas
         * heredadas con 'table' o 'gallery'), se añade como ficha aparte para que se vea
         * lo que hay puesto de verdad.
         */
        function buildDefaultViewOptions() {
            var opciones = VISTAS_BASE.slice();

            // NULL y '' significan lo mismo (sin defecto); se normaliza para que case con
            // la ficha vacia. Una columna recien añadida en otro tenant nace NULL.
            //
            // OJO: solo si la propiedad YA EXISTE. Si no, se estaria CREANDO un campo que
            // no es columna en ese tenant, y putSection hace un UPDATE con todo lo que
            // llegue: MySQL responde "Unknown column" y revienta el guardado entero de la
            // seccion. Paso exactamente eso en los 96 tenants sin default_view.
            if (vm.section && vm.section.section &&
                vm.section.section.hasOwnProperty('default_view') &&
                vm.section.section.default_view == null) {
                vm.section.section.default_view = '';
            }

            var actual = vm.section && vm.section.section && vm.section.section.default_view;
            var conocido = opciones.some(function (o) { return o.value === actual; });
            if (actual && !conocido) {
                opciones.push({ value: actual, label: actual, heredado: true });
            }

            vm.defaultViewOptions = opciones;
        }

        vm.tabs = [
            { name: 'Preview', field: 'preview', icon: 'icon-eye' },
            { name: 'Edit', field: 'edit', icon: 'icon-pencil' },
            { name: 'Media', field: 'media', icon: 'icon-camera' },
            { name: 'SEO', field: 'seo', icon: 'icon-magnify' },
            { name: 'Activity', field: 'activity', icon: 'icon-chart-histogram' },
            { name: 'Web preview', field: 'web_preview', icon: 'icon-web' }
        ];
        // Tasks will be filtered against these models
        vm.taskFilters = {
            search: '',
            tags: [],
            completed: '',
            deleted: false,
            important: '',
            starred: '',
            startDate: '',
            dueDate: ''
        };
        vm.taskFiltersDefaults = angular.copy(vm.taskFilters);
        vm.showAllTasks = true;

        vm.taskOrder = '';
        vm.taskOrderDescending = false;

        vm.sortableOptions = {
            handle: '.handle',
            forceFallback: true,
            ghostClass: 'backend-item-placeholder',
            fallbackClass: 'backend-item-ghost',
            fallbackOnBody: true,
            sort: true,
            // dragging started
            onStart: function (/**Event*/evt) {
                evt.oldIndex;  // element index within parent
            },

            // dragging ended
            onEnd: function (/**Event*/evt) {
                evt.oldIndex;  // element's old index within parent
                evt.newIndex;  // element's new index within parent

                console.log(typeof evt.oldIndex)
                console.log(typeof evt.newIndex)
                if (typeof evt.oldIndex == 'undefined' || typeof evt.newIndex == 'undefined') return;
                for (var i = 0; i < vm.tasks.length; i++) {
                    vm.tasks[i].sort = i + 1;
                }
            },

        };
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.gotoSectionDetail = gotoSectionDetail;
        vm.preventDefault = msUtils.preventDefault;
        vm.openTaskDialog = openTaskDialog;
        vm.toggleCompleted = toggleCompleted;
        vm.toggleSidenav = toggleSidenav;
        vm.changeView = changeView;
        vm.toggleFilter = toggleFilter;
        vm.toggleFilterWithEmpty = toggleFilterWithEmpty;
        vm.filterByStartDate = filterByStartDate;
        vm.filterByDueDate = filterByDueDate;
        vm.resetFilters = resetFilters;
        vm.toggleTagFilter = toggleTagFilter;
        vm.isTagFilterExists = isTagFilterExists;
        vm.toggleSidenav = toggleSidenav;
        vm.openThread = openThread;
        vm.closeThreadEdit = closeThreadEdit;
        vm.undoChangesSection = undoChangesSection;
        vm.saveSectionSettings = saveSectionSettings;
        vm.openFieldDialog = openFieldDialog;
        vm.searchLocal = searchLocal;


        vm.views = {
            split: 'app/main/apps/backend/views/list/split-view.html',
            nosplit: 'app/main/apps/backend/views/list/nosplit-view.html',
        };

        vm.defaultView = 'split';
        vm.currentView = 'split';


        init();


        //////////

        /**
         * Initialize the controller
         */
        function init() {
            var siteID = requestContext.getParam("siteId");
            $scope.siteID = siteID;
            angular.forEach(vm.tasks, function (task) {
                if (task.startDate) {
                    task.startDate = new Date(task.startDate);
                    task.startDateTimestamp = task.startDate.getTime();
                }

                if (task.dueDate) {
                    task.dueDate = new Date(task.dueDate);
                    task.dueDateTimestamp = task.dueDate.getTime();
                }
            });
        }

        /**
         * Open thread
         *
         * @param thread
         */
        function openThread(thread) {
            // Set the read status on the thread
            // thread.read = true;

            if (angular.element(document.getElementById('thread-detail')).length) {
                var elem = angular.element(document.getElementById('thread-detail'));
                elem.scrollTopAnimated(0, 10);
            }
            // pagesShown = 1;
            vm.selectedContentID = thread.id_section;
            vm.selectedContent = thread;
            $state.go('app.site_overview.backendcontent.thread', {
                id: vm.selectedContentID
            }, {
                    notify: false,
                    inherit: true,
                    location: true
                });

            backendService.getSection({
                section: vm.selectedContent.section,
                site: $scope.siteID
            })
                .then(function (response) {
                    vm.section = {};
                    vm.section.ref = (response.ref.length == 0) ? null : angular.copy(response.ref);
                    vm.section.reference_sections = (response.reference_sections.length == 0) ? null : angular.copy(response.reference_sections);
                    vm.section.section = (response.section.length == 0) ? null : angular.copy(response.section);
                    vm.isLoading = false;

                    buildDefaultViewOptions();
                    angular.copy(vm.section, vm.sectionBackup);
                });
        }
        function undoChangesSection(form) {
            angular.copy(vm.sectionBackup, vm.section);
        }
        function searchLocal(query) {
            console.log(query);
        }
        function saveSectionSettings(form) {

            var options = {
                section: vm.section.section.section,
                site: $scope.siteID,
                data: vm.section.section
            };

            backendService.saveSectionSettings(options)
                .then(
                    function (response) {
                        // vm.viewPreview();
                        // vm.openThread(mail);
                        var message = "Saved";

                        $mdToast.show({
                            template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                            hideDelay: 5000,
                            position: 'top',
                            parent: '#content-container'
                        });
                        form.$setPristine();
                        // refresh();
                        // init();
                        return true;
                    });

        }

		/**
		 * Open new field dialog
		 *
		 * @param ev
		 * @param task
		 */
        function openFieldDialog(ev, task) {
            $mdDialog.show({
                controller: 'TaskDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/backend/dialogs/task/task-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    section: vm.selectedContent.section,
                    Field: task,
                    Fields: vm.section.ref,
                    event: ev
                }
            });
        }

        /**
         * Close thread Edit
         */
        function closeThreadEdit() {
            vm.selectedContent = null;
            vm.selectedContentID = null;
            // Update the state without reloading the controller
            $state.go('app.site_overview.backendcontent', { notify: false });
        }

        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        $scope.$on('pagination:loadStart', function (event) {
            // $anchorScroll();

            // Store the current scrollPos
            // vm.scrollPos = vm.scrollEl.scrollTop();

            // Scroll to the top
            // vm.scrollEl.scrollTop(0);
            if (!vm.enterfirst) {
                var elem = angular.element(document.getElementById('thread-list'));
                elem.scrollTopAnimated(0, 10);
            }

            // angular.element("#thread-list").scrollTop=0;
            vm.enterfirst = false;
            $scope.isLoading = true;
        });

        $scope.$on('pagination:loadPage', function (event) {
            $scope.isLoading = false;
            vm.dataAlreadyLoaded = true;
        });


        /**
         * Go to section detail
         *
         * @param section
         */
        function gotoSectionDetail(section) {
            $state.go('app.site_overview.backendcontent.detail', { section: section });
        }

        /**
         * Open new task dialog
         *
         * @param ev
         * @param task
         */
        function openTaskDialog(ev, task) {
            $mdDialog.show({
                controller: 'TaskDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/backend/dialogs/task/task-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Task: task,
                    Tasks: vm.tasks,
                    event: ev
                }
            });
        }

        /**
 * Change the view
 *
 * @param view
 */
        function changeView(view) {
            if (vm.views[view]) {
                vm.loadingView = true;
                vm.defaultView = view;
                vm.currentView = view;
            }
        }

        /**
         * Toggle completed status of the task
         *
         * @param task
         * @param event
         */
        function toggleCompleted(task, event) {
            event.stopPropagation();
            task.completed = !task.completed;
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Toggles filter with true or false
         *
         * @param filter
         */
        function toggleFilter(filter) {
            vm.taskFilters[filter] = !vm.taskFilters[filter];

            checkFilters();
        }

        /**
         * Toggles filter with true or empty string
         * @param filter
         */
        function toggleFilterWithEmpty(filter) {
            if (vm.taskFilters[filter] === '') {
                vm.taskFilters[filter] = true;
            }
            else {
                vm.taskFilters[filter] = '';
            }

            checkFilters();
        }

        /**
         * Reset filters
         */
        function resetFilters() {
            vm.showAllTasks = true;
            vm.taskFilters = angular.copy(vm.taskFiltersDefaults);
        }

        /**
         * Check filters and mark showAllTasks
         * as true if no filters selected
         */
        function checkFilters() {
            vm.showAllTasks = !!angular.equals(vm.taskFiltersDefaults, vm.taskFilters);
        }

        /**
         * Filter by startDate
         *
         * @param item
         * @returns {boolean}
         */
        function filterByStartDate(item) {
            if (vm.taskFilters.startDate === true) {
                return item.startDate === new Date();
            }

            return true;
        }

        /**
         * Filter Due Date
         *
         * @param item
         * @returns {boolean}
         */
        function filterByDueDate(item) {
            if (vm.taskFilters.dueDate === true) {
                return !(item.dueDate === null || item.dueDate.length === 0);
            }

            return true;
        }

        /**
         * Toggles tag filter
         *
         * @param tag
         */
        function toggleTagFilter(tag) {
            var i = vm.taskFilters.tags.indexOf(tag);

            if (i > -1) {
                vm.taskFilters.tags.splice(i, 1);
            }
            else {
                vm.taskFilters.tags.push(tag);
            }

            checkFilters();
        }

        /**
         * Returns if tag exists in the tagsFilter
         *
         * @param tag
         * @returns {boolean}
         */
        function isTagFilterExists(tag) {
            return vm.taskFilters.tags.indexOf(tag) > -1;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.accounts')
        .service('activitiesService', activitiesService);

    /** @ngInject */
    // I provide access to the session store.
    function activitiesService($q, $resource, userService, settingsDomainService, sessionService, COMMON, $window) {

        function getActivities(options) {
            var deferred = $q.defer();
            var filters = [];

            _.forEach(options, function (value, key, list) {
                if (_.isObject(list[key])) {
                    _.forEach(list[key], function (filter, keyFilter, listFilter) {
                        if (!_.isEmpty(filter.selected)) {
                            filters.push({
                                field: filter.field,
                                name: filter.name,
                                values: filter.selected
                            });
                        }

                    });

                }
            });


            resourceActivities.get({
                domain: options.siteID,
                page: options.page,
                paginate: options.paginate,
                sortField: options.sortField,
                sortDir: options.sortDir,
                withFilters: JSON.stringify(filters),
                resultsPerPage: 100
            },
                function (responseResult) {
                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve({
                        result: responseResult
                    });

                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getOptions(options) {
            var deferred = $q.defer();


            resourceOptions.get({
                domain: options.site,
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e);
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        var resourceActivities = $resource(COMMON.BASE_API + "/domain/:domain/activities/list", {
            // No default data
        }, {
                get: {
                    method: "GET",
                    isArray: false
                }
            });

        var resourceOptions= $resource(
            COMMON.BASE_API + "/domain/:domain/activities/options", {
                // No default data.
            }, {
                get: {
                    method: "GET",
                }
            }
        );

        return ({
            get: getActivities,
            getFilters: getOptions,
        });

    }

})();
(function () {
    'use strict';

    angular.module('app.accounts').controller('AccountsController', AccountsController);

    /** @ngInject */
    function AccountsController($scope, $rootScope, $document, $mdDialog, $mdMedia, $mdToast, $mdSidenav,
        $state, msApi, requestContext, $timeout, accountsService, contentService, msUtils,
        $anchorScroll, $translate, sessionService, usersService, tinyMceService, sharedFunctionsMailing,
        transformAccounts, COMMON) {

        var pusherConfig = {
            auth: {
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem('satellizer_token')
                }
            },
            authEndpoint: COMMON.PUSHER_AUTH_ENDPOINT,
            broadcaster: 'pusher',
            cluster: 'mt1',
            encrypted: true
        };
        window.client = new Pusher(COMMON.PUSHER_APP_KEY, pusherConfig);

        /*
              var presence = client.subscribe('global-presence');

              presence.bind('App\\Events\\subscription_succeed', function (data) {
                console.log('subscription_succeed', data);
              })

              presence.bind('pusher:subscription_succeed', function (data) {
                console.log('subscription_succeed2', data);
              })

              presence.bind('pusher:member_added', function (data) {
                console.log('member_added', data);
              })

              presence.bind('pusher:member_removed', function (data) {
                console.log('member_removed', data);
              })
              console.log('presence', presence);
        */

        var vm = this;

        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg', 'red-bg', 'yellow-bg', 'light-blue-bg'];

        vm.folders = [];
        vm.labels = [];
        vm.loadingThreads = true;
        vm.enterfirst = true;
        vm.users = null;
        vm.permissionsUsers = null;
        vm.searchUserText = null;
        vm.selectedUser = null;
        vm.groupBy = undefined;
        vm.currentLabelsEdit = undefined;
        vm.scrollEl = angular.element('#thread-list')[0];

        vm.currentFilter = {
            type: $state.params.type,
            filter: $state.params.filter
        };

        vm.searchTabText;
        vm.selectedTab = null;

        vm.currentThread = null;
        vm.currentThread_Edit = null;
        vm.thumbnails_Edit = {};
        vm.selectedThreads = [];
        vm.basicForm = {};

        vm.getTabs = getTabs;

        vm.views = {
            split: 'app/main/apps/accounts/views/list/split-view.html',
            nosplit: 'app/main/apps/accounts/views/list/nosplit-view.html',
        };

        vm.defaultView = 'split';
        vm.currentView = 'split';
        vm.loadingView = true;

        vm.sortableOpt = sortableOpt;

        vm.sortableOptions = {};
        vm.sortableTabs = {};
        vm.mediaZones = [];
        vm.usersGroups = undefined;
        vm.currentLabelsFilter = undefined;

        // Methods
        vm.init = init;
        vm.getInArray = msUtils.getInArray;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.toggleInGroup = msUtils.toggleInGroup;
        vm.getExtension = msUtils.getExtension;
        vm.getExtensionIcon = msUtils.getExtensionIcon;

        vm.isTrueFalseChecked = isTrueFalseChecked;
        vm.toggleTrueFalseCheck = toggleTrueFalseCheck;
        vm.selectOrUnselect = selectOrUnselect;

        vm.newThread = newThread;
        vm.openThread = openThread;
        vm.closeThread = closeThread;
        vm.closeThreadEdit = closeThreadEdit;
        vm.deleteThread = deleteThread;

        vm.toggleSelectThread = toggleSelectThread;
        vm.toggleSelectThreads = toggleSelectThreads;
        vm.isSelected = isSelected;
        vm.deselectThreads = deselectThreads;

        vm.setThreadStatus = setThreadStatus;
        vm.toggleThreadStatus = toggleThreadStatus;
        vm.toggleItemStatus = toggleItemStatus;
        vm.toggleItemStatusEdit = toggleItemStatusEdit;

        vm.getLabel = getLabel;
        vm.getLabelColor = getLabelColor;
        vm.getLabelTitle = getLabelTitle;
        vm.getTabName = getTabName;
        vm.getTabIcon = getTabIcon;

        vm.toggleLabel = toggleLabel;
        vm.isLabelExist = isLabelExist;

        vm.changeView = changeView;
        vm.viewEditData = viewEditData;
        vm.viewEditTabs = viewEditTabs;
        vm.viewActivityTab = viewActivityTab;
        vm.saveItem = saveItem;
        vm.massActions = massActions;

        vm.siteLanguages = siteLanguages;
        vm.getCurrentMedia = getCurrentMedia;
        vm.newUser = newUser;
        vm.getZoneCrop = getZoneCrop;

        vm.dateFormat = sessionService.site_operative.dateFormat;
        vm.dateTimeFormat = sessionService.site_operative.dateTimeFormat;
        vm.showDate = showDate;

        vm.duplicateUser = duplicateUser;
        vm.setSortField = setSortField;
        vm.setSortOrder = setSortOrder;
        vm.callback = callback;

        vm.openTabSelect = openTabSelect;
        vm.iconikGroups = [];
        vm.iconikGroupId = null;
        vm.iconikGroupSearch = '';
        vm.iconikGroupsFiltered = [];
        vm.iconikGroupDirty = false;
        vm.filterIconikGroups = filterIconikGroups;
        vm.clearIconikGroupSearch = clearIconikGroupSearch;
        vm.markIconikGroupDirty = markIconikGroupDirty;

        // Audiences an account can be assigned to = the tenant's user groups. The Iconik adapter
        // maps each one to its own API key, so this is what decides which catalogue the editor
        // sees in the media dialog.
        function loadIconikGroups() {
            usersService.getUsersGroups({ siteID: $scope.siteID }).then(function (response) {
                var flat = [];
                (function walk(nodes, depth, ancestors) {
                    angular.forEach(nodes || [], function (g) {
                        // The list is flat because md-option cannot nest, so the tree is carried in
                        // `depth` (indentation) and `ancestors` (used by the search to keep branches
                        // whole). `name` stays clean: it is the only thing the search matches on.
                        flat.push({
                            id_group: g.id_group,
                            name: g.name,
                            depth: depth,
                            ancestors: ancestors,
                            match: false
                        });
                        walk(g.children || g.groups, depth + 1, ancestors.concat([g.id_group]));
                    });
                })(response.data || response, 0, []);
                vm.iconikGroups = flat;
                filterIconikGroups();
            }).catch(function () {
                vm.iconikGroups = [];
                vm.iconikGroupsFiltered = [];
            });
        }
        loadIconikGroups();

        /**
         * Hierarchical search over the group tree.
         *
         * A flat `filter:` was unusable here: it returned the hits stripped of their branch, so a
         * group named "Media" gave no clue about which of the several "Media" branches it belonged
         * to. Matching a group now keeps:
         *   - the group itself,
         *   - its whole subtree (searching "Mediahub" shows Mediahub *with* its children),
         *   - its ancestors, as read-only context, so the path from the root stays visible.
         */
        function filterIconikGroups() {
            var query = (vm.iconikGroupSearch || '').toLowerCase().trim();

            if (!query) {
                angular.forEach(vm.iconikGroups, function (g) { g.match = false; });
                vm.iconikGroupsFiltered = vm.iconikGroups;
                return;
            }

            var matched = {};
            var keep = {};

            angular.forEach(vm.iconikGroups, function (g) {
                g.match = g.name.toLowerCase().indexOf(query) !== -1;
                if (g.match) {
                    matched[g.id_group] = true;
                    keep[g.id_group] = true;
                    // Ancestors come along so the branch reads top-down instead of as loose names.
                    angular.forEach(g.ancestors, function (id) { keep[id] = true; });
                }
            });

            vm.iconikGroupsFiltered = vm.iconikGroups.filter(function (g) {
                if (keep[g.id_group]) return true;
                // Descendant of a match: the whole subtree of a hit is shown.
                for (var i = 0; i < g.ancestors.length; i++) {
                    if (matched[g.ancestors[i]]) return true;
                }
                return false;
            });
        }

        function clearIconikGroupSearch() {
            vm.iconikGroupSearch = '';
            filterIconikGroups();
        }

        function markIconikGroupDirty() {
            vm.iconikGroupDirty = true;
        }

        /**
         * Persist the account's Iconik audience. Part of saving the account, not a side effect of
         * touching the selector: picking a group used to fire updateSettings straight away, so the
         * change stuck even if the edit was never saved (or was cancelled).
         *
         * @param {number|string} idUser - taken from the save response, since a brand-new account
         *                                 has no id until then.
         * @returns {Promise}
         */
        function saveIconikGroup(idUser) {
            if (!idUser) return;
            return accountsService.setUserIconikGroup($scope.siteID, idUser, vm.iconikGroupId)
                .then(function () {
                    vm.iconikGroupDirty = false;
                })
                .catch(function () {
                    // The account itself did save, so this reports only the part that failed.
                    $mdToast.show($mdToast.simple().textContent($translate.instant('ACCOUNTS.ICONIK_GROUP_ERROR')).position('top right'));
                });
        }

        vm.editPermissionDialog = editPermissionDialog;
        vm.replacePermissionsDialog = replacePermissionsDialog;
        vm.clearSearchTab = clearSearchTab;
        vm.tabAdd = '';
        vm.timeAgo = msUtils.timeAgo;
        vm.tabOptions = null;

        function sortableOpt(virtualGroup) {
            vm.sortableOptions[virtualGroup.id_virtualgroup] = {
                group: virtualGroup.id_virtualgroup,
                handle: '.handle',
                forceFallback: false,
                ghostClass: 'virtualgroups-item-placeholder',
                fallbackClass: 'virtualgroups-item-ghost',
                fallbackOnBody: true,
                sort: true,
                // dragging started
                onStart: function (/**Event*/evt) {
                    evt.oldIndex;  // element index within parent
                },
                // dragging ended
                onEnd: function (/**Event*/evt) {
                    var oldIndex = evt.oldIndex + 1;
                    var newIndex = evt.newIndex + 1;
                    var currentTab = evt.model;

                    console.log('Current tab:', currentTab);

                    if (!currentTab || !currentTab.id_user_tab) {
                        console.error("currentTab or id_user_tab is undefined");
                        return;
                    }

                    var newTabs = [];
                    var newSortableTabs = [];
                    angular.forEach(vm.selectedContent.users_tabs, function (tab) {
                        if (tab.id_virtualgroup == virtualGroup.id_virtualgroup) {
                            if (tab.id_user_tab == currentTab.id_user_tab) {
                                tab.sort = newIndex;
                            } else {
                                if (oldIndex < newIndex) {
                                    if (tab.sort >= oldIndex && tab.sort <= newIndex) {
                                        tab.sort = tab.sort - 1;
                                    }
                                } else if (oldIndex > newIndex) {
                                    if (tab.sort <= oldIndex && tab.sort >= newIndex) {
                                        tab.sort = tab.sort + 1;
                                    }
                                }
                            }
                            newSortableTabs.push(tab);
                            newTabs.push(tab);
                        } else {
                            newTabs.push(tab);
                        }
                    });
                    vm.selectedContent.users_tabs = newTabs;
                    vm.basicForm.$setDirty();
                }

            }
        }

        function showDate(value) {
            if (angular.isObject(value)) {
                return value.dateShow;
            } else if (value == '0000-00-00 00:00:00' || !value) {
                return '-';
            } else {
                var tz = (sessionService.site_operative.timezone || moment.tz.guess() || 'UTC').toString().trim();
                return moment.utc(value).tz(tz).format(vm.dateTimeFormat || 'DD/MM/YYYY HH:mm');
            }
        }


        vm.updateDatePicker = function (fld) {
            var value = moment.utc(vm.currentThread_Edit[fld].date).format('YYYY-MM-DD HH:mm:00');

            if (value == 'Invalid date') {
                vm.currentThread_Edit[fld] = {};
                vm.currentThread_Edit[fld]['value'] = '';
                vm.currentThread_Edit[fld]['date'] = '';
                vm.currentThread_Edit[fld]['dateShow'] = '';
                vm.currentThread_Edit[fld]['utcShow'] = '';
                vm.currentThread_Edit[fld]['utcDate'] = '';
            } else {
                var tz = (sessionService.site_operative.timezone || moment.tz.guess() || 'UTC').toString().trim();
                var utcDate = moment.utc(value);
                var siteDate = moment.utc(value).tz(tz);
                vm.currentThread_Edit[fld] = {};
                vm.currentThread_Edit[fld]['value'] = value;
                vm.currentThread_Edit[fld]['date'] = new Date(siteDate.format());
                vm.currentThread_Edit[fld]['dateShow'] = siteDate.format(vm.dateTimeFormat || 'DD/MM/YYYY HH:mm');
                vm.currentThread_Edit[fld]['utcShow'] = utcDate.format(vm.dateTimeFormat || 'DD/MM/YYYY HH:mm');
                vm.currentThread_Edit[fld]['utcDate'] = utcDate;
            }
        };


        // Attachments
        vm.toggleSidenav = toggleSidenav;
        vm.isNumber = isNumber;
        vm.updateThread = updateThread;

        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            var siteID = requestContext.getParam("siteId");
            var section = 'accounts';

            $scope.siteID = siteID;
            $scope.section = section;

            sessionService.setActiveSection(section).then(function () {
                vm.ActiveSection = sessionService.ActiveSection;
            });

            vm.viewSplit = true;

            vm.edit = false;

            vm.selectedUsers = [];

            $scope.view_medialist = true;

            $rootScope.global.titleToolbar = '<i class="icon s20 icon-folder-account mr-15" ng-if="node.icon"></i> ' + $translate.instant('ACCOUNTS');

            var options = {
                site: $scope.siteID,
                section: $scope.section
            };

            $scope.page = 1;

            if ($state.params.id) {
                // for (var i = 0; i < vm.threads.length; i++) {
                // if (vm.threads[i].id === $state.params.threadId) {
                vm.openThread(null, $state.params.id);
                // break;
                // }
                // }
            }

            getUsersForPermissions();
        }

        // Watch screen size to change view modes
        $scope.$watch(function () {
            return $mdMedia('lt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                vm.currentView = 'nosplit';
            }
        });

        $scope.$watch(function () {
            return $mdMedia('max-width: 960px');
        }, function (big) {

            if (big)
                vm.currentView = 'nosplit';

        });

        $scope.$watch(function () {
            return $mdMedia('min-width: 960px');
        }, function (small) {

            if (small)
                vm.currentView = 'split';

        });

        $scope.$watch(function () {
            return $mdMedia('gt-sm');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }

            if (current) {
                if (vm.defaultView === 'split') {
                    vm.currentView = 'split';
                }
            }
        });

        $scope.$on('$includeContentLoaded', function (event, target) {
            $timeout(function () {
                vm.loadingView = false;
            }, 1000);
        });

        $scope.$on('pagination:loadStart', function (event) {
            // $anchorScroll();

            // Store the current scrollPos
            // vm.scrollPos = vm.scrollEl.scrollTop();

            // Scroll to the top
            // vm.scrollEl.scrollTop(0);
            if (!vm.enterfirst) {
                var elem = angular.element(document.getElementById('thread-list'));
                elem.scrollTopAnimated(0, 10);
            }

            // angular.element("#thread-list").scrollTop=0;
            vm.enterfirst = false;
            $scope.isLoading = true;
        });

        $scope.$on('pagination:loadPage', function (event) {
            $scope.isLoading = false;
            vm.dataAlreadyLoaded = true;
        });

        function setSortField(field) {
            vm.fieldOrder = field;
            $rootScope.pagination_setSortField(field, $rootScope.sortDir);
        }

        function setSortOrder(order) {
            $rootScope.sortDir = order;
            $rootScope.pagination_setSortField(vm.fieldOrde, $rootScope.sortDir);
        }

        function selectOrUnselect(item, $event) {
            var isRightClick = $event && $event.which == 3;
            var isDoubleClick = $event && $event.type == 'dblclick';
        };

        /**
         * Toggle checked status of the content
         *
         * @param content
         * @param event
         */
        function toggleTrueFalseCheck(field, event) {
            if (event) {
                event.stopPropagation();
            }

            if (vm.selectedContent[field]) {
                vm.selectedContent[field] = false;
            } else {
                vm.selectedContent[field] = true;
            }
        }

        /**
         * Return checked status of the content
         *
         * @param content
         * @returns {boolean}
         */
        function isTrueFalseChecked(fieldStatus) {
            return fieldStatus ?
                true :
                false;
        }

        /**
         * Open thread
         *
         * @param thread
         */
        function openThread(thread, id) {
            // Set the read status on the thread
            // thread.read = true;
            vm.tabOptions = null;

            if (angular.element(document.getElementById('thread-detail')).length) {
                var elem = angular.element(document.getElementById('thread-detail'));
                elem.scrollTopAnimated(0, 10);
            }
            // pagesShown = 1;
            if (thread) {
                vm.selectedContentID = thread.id_user;
            } else if (id) {
                vm.selectedContentID = id;
            }
            if (vm.selectedContentID != 'new') {
                vm.editData = false;

                vm.loadingReadPane = true;

                $state.go('app.site_overview.accounts.list.thread', {
                    id: vm.selectedContentID
                }, {
                    notify: false,
                    inherit: true,
                    location: true
                });

                var options = {
                    site: $scope.siteID,
                    section: $scope.section,
                    id: vm.selectedContentID
                };

                accountsService.getUserByID(options).then(function (response) {
                    vm.editData = false;
                    vm.selectedContent = angular.copy(response.toJSON());

                    // Iconik audience assigned to this account (users_settings.iconikGroup)
                    vm.iconikGroupId = null;
                    vm.iconikGroupDirty = false;
                    accountsService.getUserIconikGroup($scope.siteID, vm.selectedContentID)
                        .then(function (res) { vm.iconikGroupId = res.groupId; })
                        .catch(function () { vm.iconikGroupId = null; });

                    vm.sortableTabs = {};
                    angular.forEach(vm.selectedContent.users_tabs, function (tab) {
                        if (angular.isUndefined(vm.sortableTabs[tab.id_virtualgroup])) {
                            vm.sortableTabs[tab.id_virtualgroup] = [];
                        }
                        vm.sortableTabs[tab.id_virtualgroup].push(tab);
                    })
                    vm.currentThread = vm.selectedContent;
                    vm.updateThread(vm.currentThread);
                    vm.log = response.log;
                    vm.loadingReadPane = false;
                });

            }
            ;
        }

        function deleteThread() {
            for (var i = 0; i < vm.selectedThreads.length; i++) {
                var options = {
                    site: $scope.siteID,
                    section: $scope.section,
                    id: vm.selectedThreads[i].id_user
                };
                accountsService.deleteItem(options).then(function (response) {
                    vm.loadingReadPane = false;
                    deselectThreads();
                    vm.selectedContent = undefined;
                    $rootScope.pagination_resetquery();
                });
            }
        }

        /**
         * New thread
         *
         */
        function newThread() {
            if (angular.element(document.getElementById('thread-detail')).length) {
                var elem = angular.element(document.getElementById('thread-detail'));
                elem.scrollTopAnimated(0, 10);
            }

            vm.selectedContentID = '';
            vm.editData = false;
            vm.loadingReadPane = true;

            $state.go('app.site_overview.accounts.list', {
                id: ''
            }, {
                notify: false,
                inherit: true,
                location: true
            });

            vm.currentThread = '';
            vm.log = [];

            vm.selectedContent = {};

            vm.loadingReadPane = false;


        }

        /**
         * Close thread Edit
         */
        function closeThreadEdit() {
            resetScroll();
            vm.currentThread = null;
            vm.selectedContent = null;
            vm.selectedContentID = null;
            // Update the state without reloading the controller
            $state.go('app.site_overview.accounts.list', {
                type: vm.currentFilter.type,
                filter: vm.currentFilter.filter
            }, { notify: false });
        }

        /**
         * Close thread
         */
        function closeThread() {
            vm.currentThread = null;
            vm.selectedContent = null;
            vm.selectedContentID = null;

            // Update the state without reloading the controller
            $state.go('app.site_overview.accounts.list', {
                type: vm.currentFilter.type,
                filter: vm.currentFilter.filter
            }, { notify: false });
        }

        function duplicateUser() {
            for (var i = 0; i < vm.selectedThreads.length; i++) {
                vm.selectedThreads[i].id_user = '';
                delete vm.selectedThreads[i].created_at;
                vm.selectedThreads[i].firstname = vm.selectedThreads[i].firstname + ' Copy';
                saveItem(vm.selectedThreads[i]);
            }
            deselectThreads();
        }

        /**
         * Return checked status of the content
         *
         * @param account
         * @returns {boolean}
         */
        function saveItem(account) {

            var newAccountData = angular.copy(account);
            if (!newAccountData.id_user) {
                newAccountData.id_user = '';
            }

            var options = {
                site: $scope.siteID,
                id: account.id_user,
                item: newAccountData
            };


            accountsService.saveItem(options).then(function (response) {
                var promise = Promise.resolve();
                if(vm.tabOptions) {
                    promise = promise.then(function(){
                        return accountsService.replacePermission(vm.tabOptions)
                    })
                }
                if (vm.iconikGroupDirty) {
                    promise = promise.then(function(){
                        return saveIconikGroup(response.id_user || account.id_user);
                    })
                }
                promise = promise.then(function(){
                    onSaveItem(account);
                    return Promise.resolve();
                });
                promise.then(function(){
                    if (account.id_user === '' || account.id_user === undefined) {
                        account.id_user = response.id_user;
                        deselectThreads();
                        $rootScope.pagination_resetquery('');
                        vm.viewEditTabs();
                        vm.openThread(response);
                    } else {
                        vm.viewEditTabs();
                        vm.openThread(response);
                    }
                });
                return true;
            })
                .catch(function (err) {
                    if (err.data.detail == 'email_already_exists') {
                        var message = $translate.instant('ACCOUNTS.EMAIL_ALREADY_EXISTS');
                        $mdToast.show({
                            template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-close" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                            hideDelay: 5000,
                            position: 'top',
                            parent: '#content-container'
                        });

                    } else if (err.data.detail == 'email_in_other_domain') {
                        var confirm = $mdDialog.confirm()
                            .title($translate.instant('ACCOUNTS.USER_EXIST_OTHER_DOMAIN'))
                            .htmlContent($translate.instant('ACCOUNTS.USER_DATA_WILL_NOT_UPDATE'))
                            .targetEvent(event)
                            .ok($translate.instant('ACCOUNTS.OK'))
                            .cancel($translate.instant('ACCOUNTS.CANCEL'));

                        $mdDialog.show(confirm).then(function () {
                            vm.selectedContent.confirmEmail = true;
                            vm.saveItem(vm.selectedContent);
                        }, function () {
                        });

                    } else {
                        var message = err.data.detail;
                        $mdToast.show({
                            template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-close" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                            hideDelay: 5000,
                            position: 'top',
                            parent: '#content-container'
                        });

                    }
                });

        }

        function onSaveItem(account) {
          var message = $translate.instant('ACCOUNTS.SAVED');
          $mdToast.show({
            template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
            hideDelay: 5000,
            position: 'top',
            parent: '#content-container'
          });
          if (sessionService.user.id_user == account.id_user) {
            sessionService.updateMenu();
          }
        }

        /**
         * Return checked status of the content
         *
         * @param content
         * @returns {boolean}
         */
        function massActions(action) {
            if (vm.selectedThreads.length === 0) return false;
            var selectedIds = [];

            for (var i = 0; i < vm.selectedThreads.length; i++) {
                selectedIds.push(vm.selectedThreads[i].id_user);
            }

            switch (action) {
                case 'delete':
                    if (selectedIds.length == 1) {
                        var messageTitle = $translate.instant('ACCOUNTS.SURE_DELETED_SINGULAR');
                        var messageBody = $translate.instant('ACCOUNTS.ITEM_WILL_DELETE');
                        var messageOk = $translate.instant('ACCOUNTS.DELETED_SINGULAR');
                    } else {
                        var messageTitle = $translate.instant('ACCOUNTS.SURE_DELETED_PLURAL');
                        var messageBody = $translate.instant('ACCOUNTS.ITEMS_WILL_DELETE');
                        var messageOk = $translate.instant('ACCOUNTS.DELETED_PLURAL');
                    }
                    var confirm = $mdDialog.confirm()
                        .title(messageTitle)
                        .ariaLabel(messageTitle)
                        .htmlContent(messageBody)
                        .targetEvent(event)
                        .ok($translate.instant('ACCOUNTS.OK'))
                        .cancel($translate.instant('ACCOUNTS.CANCEL'));

                    $mdDialog.show(confirm).then(function () {
                        var options = {
                            site: $scope.siteID,
                            section: $scope.section,
                            ids: selectedIds,
                            type: 'delete'
                        };

                        accountsService.massActions(options).then(function (response) {
                            vm.loadingReadPane = false;
                            deselectThreads();
                            vm.selectedContent = undefined;
                            $rootScope.pagination_resetquery();
                            $mdToast.show({
                                template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + messageOk + '</span></div></md-toast>',
                                hideDelay: 5000,
                                position: 'top',
                                parent: '#content-container'
                            });

                        });

                    }, function () {
                    });

                    break;
                case 'duplicate':
                    if (selectedIds.length == 1) {
                        var confirm = $mdDialog.confirm().title(messageConfirm).htmlContent('<b>This item will be duplicated</b>.')
                            // .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' will be deleted.')
                            .ariaLabel('Duplicate item').targetEvent(event).ok('OK').cancel('CANCEL');
                        var message = $translate.instant('CONTENT.DUPLICATED');
                    } else {
                        var confirm = $mdDialog.confirm().title(messageConfirm).htmlContent('<b>This items will be duplicated</b>.')
                            // .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' will be deleted.')
                            .ariaLabel('Duplicate item').targetEvent(event).ok('OK').cancel('CANCEL');
                        var message = $translate.instant('CONTENT.DUPLICATED');
                    }
                    break;
            }

        }

        $scope.closeToast = function () {
            if (isDlgOpen)
                return;

            $mdToast.hide().then(function () {
                isDlgOpen = false;
            });
        };

        /**
         * Return selected status of the thread
         *
         * @param thread
         * @returns {boolean}
         */

        /*function isSelected(thread) {
            return vm.selectedThreads.indexOf(thread) > -1;
		}*/
        function isSelected(thread) {
            return sharedFunctionsMailing.isSelected(vm.selectedThreads, thread);
        }

        /**
         * Toggle selected status of the thread
         *
         * @param thread
         * @param event
         */

        /*function toggleSelectThread(thread, event) {
            if (event) {
                event.stopPropagation();
            }

            if (vm.selectedThreads.indexOf(thread) > -1) {
                vm.selectedThreads.splice(vm.selectedThreads.indexOf(thread), 1);
            } else {
                vm.selectedThreads.push(thread);
            }
		}*/
        function toggleSelectThread(thread, event) {
            if (event) {
                event.stopPropagation();
            }

            if (vm.selectedThreads.indexOf(thread) > -1) {
                vm.selectedThreads.splice(vm.selectedThreads.indexOf(thread), 1);
            } else {
                vm.selectedThreads.push(thread);
            }
        }

        /**
         * Select threads. If key/value pair given,
         * threads will be tested against them.
         *
         * @param [key]
         * @param [value]
         */
        function selectThreads(key, value) {
            // Make sure the current selection is cleared
            // before trying to select new threads
            vm.selectedThreads = [];
            for (var i = 0; i < vm.threads.length; i++) {
                if (angular.isUndefined(key) && angular.isUndefined(value)) {
                    vm.selectedThreads.push(vm.threads[i]);
                    continue;
                }

                if (angular.isDefined(key) && angular.isDefined(value) && vm.threads[i][key] === value) {
                    vm.selectedThreads.push(vm.threads[i]);
                }
            }
        }

        /**
         * Deselect threads
         */
        function updateThread(itemThread) {
            for (var i = 0; i < vm.threads.length; i++) {
                if (vm.threads[i]['id_user'] == itemThread['id_user']) {
                    vm.threads[i] = itemThread;
                }
                // if (angular.isUndefined(key) && angular.isUndefined(value)) {
                // 	vm.selectedThreads.push(vm.threads[i]);
                // 	continue;
                // }

                // if (angular.isDefined(key) && angular.isDefined(value) && vm.threads[i][key] === value) {
                // 	vm.selectedThreads.push(vm.threads[i]);
                // }
            }
        }

        /**
         * Deselect threads
         */

        /*function deselectThreads() {
            vm.selectedThreads = [];
		}*/
        function deselectThreads() {
            vm.selectedThreads = sharedFunctionsMailing.deselectThreads();
        }

        /**
         * Toggle select threads
         */

        /*function toggleSelectThreads() {
            if (vm.selectedThreads.length > 0) {
                vm.deselectThreads();
            } else {
                vm.selectThreads();
            }
		}*/
        function toggleSelectThreads() {
            vm.selectedThreads = sharedFunctionsMailing.toggleSelectThreads(vm.selectedThreads, vm.threads);
        }

        function toggleSelectAllThreads() {

        }

        /**
         * Set the status on given thread, current thread or selected threads
         *
         * @param key
         * @param value
         * @param [thread]
         * @param [event]
         */
        function setThreadStatus(key, value, thread, event) {
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if (event) {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if (thread) {
                thread[key] = value;
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if (vm.currentThread) {
                vm.currentThread[key] = value;
                return;
            }

            // Otherwise do the status update on selected threads
            for (var x = 0; x < vm.selectedThreads.length; x++) {
                vm.selectedThreads[x][key] = value;
            }
        }

        /**
         * Toggle the value of the given key on given thread, current
         * thread or selected threads. Given key value must be boolean.
         *
         * @param key
         * @param thread
         * @param event
         */
        function toggleItemStatus(thread, event, key) {

            event.stopPropagation();

            var confirm = $mdDialog.confirm().title('Are you sure want to set the item?').htmlContent('<b>This item will be changed </b>.')
                // .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' will be deleted.')
                .ariaLabel('change item').targetEvent(event).ok('OK').cancel('CANCEL');

            $mdDialog.show(confirm).then(function () {

                thread.active = (thread.active === 1) ?
                    0 :
                    1;

                vm.threads[key].active = thread.active;

                var options = {
                    site: $scope.siteID,
                    id: vm.threads[key].id_user,
                    item: vm.threads[key]
                };

                accountsService.saveItem(options).then(function (response) {
                    // vm.viewPreview();
                    // vm.selectContent(content);
                    var message = "Saved";

                    $mdToast.show({
                        template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                        hideDelay: 5000,
                        position: 'top',
                        parent: '#content-container'
                    });

                    return true;
                });

            }, function () {
                // alert("cancel")

            });

            return;
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if (event) {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if (thread) {
                if (typeof (thread[key]) !== 'boolean') {
                    return;
                }

                thread[key] = !thread[key];
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if (vm.currentThread) {
                if (typeof (vm.currentThread[key]) !== 'boolean') {
                    return;
                }

                vm.currentThread[key] = !vm.currentThread[key];
                return;
            }

            // Otherwise do the status update on selected threads
            for (var x = 0; x < vm.selectedThreads.length; x++) {
                if (typeof (vm.selectedThreads[x][key]) !== 'boolean') {
                    continue;
                }

                vm.selectedThreads[x][key] = !vm.selectedThreads[x][key];
            }
        }

        /**
         * Toggle the value of the given key on given thread, current
         * thread or selected threads. Given key value must be boolean.
         *
         * @param key
         * @param thread
         * @param event
         */
        function toggleItemStatusEdit(fieldName) {

            event.stopPropagation();
            var thread = vm.selectedContent[fieldName];
            thread = (thread === 1) ?
                0 :
                1;

            vm.selectedContent[fieldName] = thread;
            vm.basicForm.$setDirty()
        }

        /**
         * Toggle the value of the given key on given thread, current
         * thread or selected threads. Given key value must be boolean.
         *
         * @param key
         * @param thread
         * @param event
         */
        function toggleThreadStatus(key, thread, event) {
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if (event) {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if (thread) {
                if (typeof (thread[key]) !== 'boolean') {
                    return;
                }

                thread[key] = !thread[key];
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if (vm.currentThread) {
                if (typeof (vm.currentThread[key]) !== 'boolean') {
                    return;
                }

                vm.currentThread[key] = !vm.currentThread[key];
                return;
            }

            // Otherwise do the status update on selected threads
            for (var x = 0; x < vm.selectedThreads.length; x++) {
                if (typeof (vm.selectedThreads[x][key]) !== 'boolean') {
                    continue;
                }

                vm.selectedThreads[x][key] = !vm.selectedThreads[x][key];
            }
        }

        /**
         * Get label object content
         *
         * @param id
         * @returns {*}
         */
        function getLabel(id) {
            for (var i = 0; i < vm.labels.length; i++) {
                if (vm.labels[i].id === id) {
                    return vm.labels[i];
                }
            }
        }

        /**
         * Get label color from label object
         *
         * @param id
         * @returns {*}
         */
        function getLabelColor(id) {
            return vm.getLabel(id).color;
        }

        /**
         * Get label title from label object
         *
         * @param id
         * @returns {*}
         */
        function getLabelTitle(id) {
            return vm.getLabel(id).title;
        }

        /**
         * Toggle label
         *
         * @param label
         */
        function toggleLabel(label) {
            // Toggle label on the currently open thread
            if (vm.currentThread) {
                if (vm.currentThread.labels.indexOf(label.id) > -1) {
                    vm.currentThread.labels.splice(vm.currentThread.labels.indexOf(label.id), 1);
                } else {
                    vm.currentThread.labels.push(label.id);
                }

                return;
            }

            // Toggle labels on selected threads
            // Toggle action will be determined by the first thread from the selection.
            if (vm.selectedThreads.length > 0) {
                // Decide if we are going to remove or add labels
                var removeLabels = (vm.selectedThreads[0].labels.indexOf(label.id) > -1);

                for (var i = 0; i < vm.selectedThreads.length; i++) {
                    if (!removeLabels) {
                        vm.selectedThreads[i].labels.push(label.id);
                        continue;
                    }

                    if (vm.selectedThreads[i].labels.indexOf(label.id) > -1) {
                        vm.selectedThreads[i].labels.splice(vm.selectedThreads[i].labels.indexOf(label.id), 1);
                    }
                }
            }
        }

        /**
         * Is label exist?
         *
         * @param label
         * @returns {boolean}
         */
        function isLabelExist(label) {
            if (vm.currentThread && vm.currentThread.labels) {
                return (vm.currentThread.labels.indexOf(label.id) > -1);
            }
        }

        /**
         * Change the view
         *
         * @param view
         */
        function changeView(view) {
            if (vm.views[view]) {
                vm.loadingView = true;
                vm.defaultView = view;
                vm.currentView = view;
            }
        }

        /**
         * Toggle view Edit Data
         */
        function viewEditData() {
            resetScroll();
            vm.editData = true;
            vm.viewActivity = false;
        }

        function viewActivityTab() {
            resetScroll();
            vm.viewActivity = true;
            vm.editData = true;
        }

        /**
         * Toggle view Edit Tabs
         */
        function viewEditTabs() {
            resetScroll();
            vm.editData = false;
            vm.viewActivity = false;
        }

        function resetScroll() {
            if (angular.element(document.getElementById('thread-detail')).length) {
                var elem = angular.element(document.getElementById('thread-detail'));
                elem.scrollTopAnimated(0, 10);
            }
        }

        function callback() {

        }

        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        function isNumber(value) {
            return angular.isNumber(value);
        }

        function siteLanguages() {
            return sessionService.getSiteLanguages();
        }

        function dateSelectedCallback(date, fieldName) {
        }

        function getCurrentMedia() {
            return vm.currentThread_Edit.Thumbnail;
        }

        function getZoneCrop(field) {
            var cropId = '';
            if (!angular.isUndefined(field.id_cropformats)) {
                cropId = field.id_cropformats;
            }
            return cropId;
        }

        function newUser(userName) {
            var newUser = {
                id_user: '',
                user_name: userName
            }
            vm.users.push(newUser);
            vm.currentThread_Edit.users.push(newUser);
            vm.searchUserText = '';
        }

        function getTabName(tab) {
            var tabName = '';
            angular.forEach(vm.customData.tabs, function (tabData) {
                if (tab.id_section && (tabData.id_tab == tab.id_tab && tab.id_section == tabData.id_section)) {
                    tabName = tabData.name;
                } else if (!tab.id_section && tabData.id_tab == tab.id_tab) {
                    tabName = tabData.name;
                }
            })
            return tabName;
        }

        function getTabIcon(tab) {
            var tabIcon = '';
            angular.forEach(vm.customData.tabs, function (tabData) {
                if (tabData.id_tab == tab.id_tab) {
                    angular.forEach(vm.customData.modules, function (moduleData) {
                        if (moduleData.id_module == tabData.id_module) {
                            tabIcon = moduleData.modules[0].icon_v3;
                        }
                    })
                }
            })
            return tabIcon;
        }
        function editPermissionDialog(ev, tab) {
            $mdDialog.show({
                templateUrl: 'app/main/apps/accounts/dialogs/edit-permission/edit-permission.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                controller: 'EditPermissionController',
                controllerAs: 'vm',
                locals: {
                    tab: tab,
                }
            }).then(function (res) {
                if (res) {
                    tab = res;
                    vm.tabOptions = tab;
                }
            });
        }
        function replacePermissionsDialog(ev, account) {
            $mdDialog.show({
                templateUrl: 'app/main/apps/accounts/dialogs/copy-permission/copy-permission.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                controller: 'CopyPermissionController',
                controllerAs: 'vm',
                multiple: true,
                locals: {
                    account: account,
                    threads: vm.permissionsUsers,
                }
            }).then(function (res) {
                if (res) {
                    vm.openThread(vm.selectedContent)
                    $rootScope.pagination_resetquery();
                }
            });
        }

        function openTabSelect(ev, virtualGroup) {
            vm.getTabs(virtualGroup);
            $mdDialog.show({
                templateUrl: 'app/main/apps/accounts/dialogs/tabs-select/tabs-select.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                controller: 'TabsSelectController',
                controllerAs: 'vm',
                locals: {
                    nestedTabs: vm.customData.nestedTabs,
                    virtualGroup: virtualGroup,
                    userTabs: vm.selectedContent.users_tabs
                }
            }).then(function (newUserTabs) {
                vm.selectedContent.users_tabs = newUserTabs;
                vm.sortableTabs = {};
                angular.forEach(vm.selectedContent.users_tabs, function (tab) {
                    if (angular.isUndefined(vm.sortableTabs[tab.id_virtualgroup])) {
                        vm.sortableTabs[tab.id_virtualgroup] = [];
                    }
                    vm.sortableTabs[tab.id_virtualgroup].push(tab);
                })
                vm.basicForm.$setDirty();
            });

        }

        function clearSearchTab() {
            vm.searchTabText = '';
        }

        function getTabs(virtualGroup) {
            vm.tabAdd = []
            angular.forEach(vm.selectedContent.users_tabs, function (tab) {
                if (tab.id_virtualgroup == virtualGroup.id_virtualgroup) {
                    if (tab.id_tab == 42) {
                        vm.tabAdd.push(tab.id_tab + '|' + tab.id_section);
                    } else {
                        vm.tabAdd.push(tab.id_tab + '|' + tab.id_section);
                    }
                }
            })
            return true;
        }

        function getUsersForPermissions() {
            var usersOptions = {
                siteID: $scope.siteID,
            };
        
            accountsService.get(usersOptions).then(function(response) {
                vm.permissionsUsers = response.result.data;
            }).catch(function(error) {
                console.error("Ocurrió un error al obtener los usuarios");
            });
        }

    }

    function renderTinyMedia(content) {
    }


})();

(function () {
    'use strict';

    angular
        .module('app.accounts')
        .service('accountsService', accountsService);

    /** @ngInject */
    // I provide access to the session store.
    function accountsService($q, $resource, userService, settingsDomainService, sessionService, COMMON, $window) {

        function getUsers(options) {
            var deferred = $q.defer();
            var filters = [];

            _.forEach(options, function (value, key, list) {
                if (_.isObject(list[key])) {
                    _.forEach(list[key], function (filter, keyFilter, listFilter) {
                        if (!_.isEmpty(filter.selected)) {
                            filters.push({
                                field: filter.field,
                                name: filter.name,
                                values: filter.selected
                            });
                        }

                    });

                }
            });


            resourceUsers.get({
                domain: options.siteID,
                page: options.page,
                search: options.searchStringFilter,
                paginate: options.paginate,
                sortField: options.sortField,
                sortDir: options.sortDir,
                filters: JSON.stringify(filters),
                resultsPerPage: 100
            },
                function (responseResult) {
                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve({
                        result: responseResult
                    });

                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getUserByID(options) {
            var deferred = $q.defer();

            resourceUserById.get({
                domain: options.site,
                id: options.id,
                // lang: get("language")
            },
                function (response) {

                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getOptions(options) {
            var deferred = $q.defer();


            resourceOptions.get({
                domain: options.site,
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e);
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function deleteItem(options) {
            var deferred = $q.defer();
            resource_user_byID.delete({
                domain: options.site,
                id: options.id
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );

            return (deferred.promise);
        }

        function saveItem(options) {
            var deferred = $q.defer();

            if (options.id !== '' && options.id !== undefined) {
                resource_user_byID.update({
                    domain: options.site,
                    id: options.id,
                    verify: options.item.verify,
                }, options.item,
                    function (response) {

                        deferred.resolve(response);
                    },
                    function (e) {
                        deferred.reject(e);
                    }
                );
            } else {
                resource_user_post_byID.save({
                    domain: options.site,
                    verify: options.item.verify
                }, options.item,
                    function (response) {

                        deferred.resolve(response);
                    },
                    function (e) {
                        deferred.reject(e);
                    }
                );
            }

            // Return the promise.
            return (deferred.promise);
        }
        function updateUserPass(options) {
            var deferred = $q.defer();

            resource_user_pass.save({
                domain: options.site,
                verify: options.item.verify
            }, options.item,
                function (response) {

                    deferred.resolve(response);
                },
                function (e) {
                    deferred.reject(e);
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function copyUserTabs(options) {
            var deferred = $q.defer();

            resourceCopyPermissions.save({
                domain: options.siteID
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function replacePermission(options) {
            var deferred = $q.defer();

            resourcePermissions.save({
                domain: options.siteID
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function massActions(options) {
            var deferred = $q.defer();

            resource_content_Multiple.update({
                domain: options.site,
                type: options.type,
                ids: options.ids
            },
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        var resourceUsers = $resource(COMMON.BASE_API + "/domain/:domain/accounts/users", {
            // No default data
        }, {
            get: {
                method: "GET",
                isArray: false
            }
        });

        // Per-user settings (users_settings). Used to store which Iconik audience a qiusystem
        // account belongs to, so the media dialog can ask the Iconik adapter for that group's key.
        var resourceUserSettingsById = $resource(COMMON.BASE_API + "/domain/:domain/accounts/getSettings/:id", {
            domain: '@domain', id: '@id'
        }, { get: { method: "GET", isArray: true } });

        var resourceNewUserSettings = $resource(COMMON.BASE_API + "/domain/:domain/accounts/newSettings", {
            domain: '@domain'
        }, { save: { method: "POST" } });

        var resourceUpdateUserSettings = $resource(COMMON.BASE_API + "/domain/:domain/accounts/updateSettings", {
            domain: '@domain'
        }, { update: { method: "PUT" } });

        var resourceUserById = $resource(COMMON.BASE_API + "/domain/:domain/accounts/user/:id", {
            // No default data
        }, {
            get: {
                method: "GET",
                // isArray: true
            }
        });

        var resourceOptions = $resource(
            COMMON.BASE_API + "/domain/:domain/accounts/options", {
            // No default data.
        }, {
            get: {
                method: "GET",
            }
        }
        );

        var resourceCopyPermissions = $resource(
            COMMON.BASE_API + "/domain/:domain/accounts/copyUserTabs", {
            domain: '@domain',
        }, {
            save: {
                method: "POST",
                isArray: true
            },
        }
        );

        var resourcePermissions = $resource(
            COMMON.BASE_API + "/domain/:domain/accounts/replaceTabRestrictions", {
            domain: '@domain',
        }, {
            save: {
                method: "POST",
            },
        }
        );
        var resource_user_post_byID = $resource(
            COMMON.BASE_API + "/domain/:domain/accounts", {
            domain: '@domain',
        }, {
            save: {
                method: "POST",
            },
        }
        );
        var resource_user_pass = $resource(
            COMMON.BASE_API + "/domain/:domain/profile/update", {
            domain: '@domain',
        }, {
            save: {
                method: "PUT",
            },
        }
        );

        var resource_user_byID = $resource(
            COMMON.BASE_API + "/domain/:domain/accounts/:id", {
            domain: '@domain',
            id: '@id',
        }, {
            get: {
                method: "GET",
            },
            update: {
                method: "PUT",
            },
            delete: {
                method: "DELETE",
                isArray: true
            }
        }
        );

        var resource_content_Multiple = $resource(
            COMMON.BASE_API + "/domain/:domain/accounts/action/:type", {
            domain: '@domain',
            type: '@type',
        }, {
            update: {
                method: "PUT",
            },
            delete: {
                method: "DELETE",
                // isArray: true
            }
        }
        );


        /**
         * Read the Iconik audience assigned to a qiusystem account.
         * Returns { groupId, idUserSettings, settings } so the caller can save it back.
         */
        function getUserIconikGroup(domain, idUser) {
            return resourceUserSettingsById.get({ domain: domain, id: idUser }).$promise
                .then(function (rows) {
                    // Prefer the domain-scoped row over the global one (id_domain null).
                    var row = (rows || []).filter(function (r) { return r && r.id_domain; })[0] || (rows || [])[0];
                    var settings = {};
                    if (row && row.settings_json) {
                        settings = angular.isString(row.settings_json) ? angular.fromJson(row.settings_json) : row.settings_json;
                    }
                    return {
                        groupId: settings.iconikGroup || null,
                        idUserSettings: row ? row.id_user_settings : null,
                        settings: settings
                    };
                });
        }

        /** Assign (or clear, with null) the Iconik audience of a qiusystem account. */
        function setUserIconikGroup(domain, idUser, groupId) {
            return getUserIconikGroup(domain, idUser).then(function (current) {
                var settings = angular.extend({}, current.settings);
                if (groupId) {
                    settings.iconikGroup = parseInt(groupId, 10);
                } else {
                    delete settings.iconikGroup;
                }

                // The row may not exist yet: newSettings creates it, updateSettings edits it.
                // `settings` travels as an object, NOT as a JSON string: both endpoints validate it
                // with Laravel's `array` rule, so a string is rejected with "The settings must be
                // an array". The API is the one that serialises it into settings_json.
                if (current.idUserSettings) {
                    return resourceUpdateUserSettings.update({ domain: domain }, {
                        id_user_settings: current.idUserSettings,
                        settings: settings
                    }).$promise;
                }
                return resourceNewUserSettings.save({ domain: domain }, {
                    id_user: idUser,
                    settings: settings
                }).$promise;
            });
        }

        return ({
            get: getUsers,
            getUserIconikGroup: getUserIconikGroup,
            setUserIconikGroup: setUserIconikGroup,
            copyUserTabs: copyUserTabs,
            replacePermission: replacePermission,
            getUserByID: getUserByID,
            getFilters: getOptions,
            saveItem: saveItem,
            updateUserPass: updateUserPass,
            deleteItem: deleteItem,
            massActions: massActions,
        });

    }

})();
(function () {
	'use strict';

	angular
		.module('app.core')
		.directive('ngRightClick', ngRightClick);

	/** @ngInject */
	function ngRightClick($parse) {
		return function(scope, element, attrs) {
            var fn = $parse(attrs.ngRightClick);

            element.bind('contextmenu', function(event) {
                scope.$apply(function() {
                    event.preventDefault();
                    fn(scope, {$event: event});
                });
            });
        };
		
	}

})(angular);

(function () {
	'use strict';

	angular
		.module('app.core')
		.directive('mousepointMenu', mousepointMenu);

	/** @ngInject */
	function mousepointMenu() {

		return {
		restrict: 'A',
		require: 'mdMenu',
		link: function($scope, $element, $attrs, RightClickContextMenu){

		  var prev = { x: 0, y: 0 }
		  $scope.$mdOpenMousepointMenu = function($event){

		    RightClickContextMenu.offsets = function(){
		      var mouse = {
		        x: $event.clientX,
		        y: $event.clientY
		      }
		      var offsets = {
		        left: mouse.x - prev.x,
		        top: mouse.y - prev.y
		      }
		      prev = mouse;

		      return offsets;
		    }
		    RightClickContextMenu.open($event);
		  };
		}

		};
	}

})(angular);

(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('imgcover', imgcover);

    /** @ngInject */
    function imgcover($window) {

        return {
            replace: true,
            scope: {
                key: '=',
                src: '=',
                dataid: '=',
                errsrc: '=',
                accept: "&"
            },
            // template: "<div></div>",
            template: '<div class="container-cover" data-id="{{dataid}}" x-ng-click="click()"><img ng-src="{{src}}" err-src="{{errsrc}}" /></div>',
            restrict: 'EA',
            link: function postLink(scope, element, attrs) {
                var container = element.find('div');
                var img = element.find('img');

                scope.onResizeFunction = function() {
                    scope.__ImgHeight = img.height();
                    scope.__ImgWidth = img.width();
                    scope.__cWidth = element.width();
                    scope.__cHeight = ((element.width() * 9) / 16);

                    element.css('height', scope.__cHeight);
                    element.css('overflow', 'hidden');
                    
                    img.css('width', scope.__cWidth);
                    img.css('margin-top', (scope.__cHeight - scope.__ImgHeight) / 2);
                    img.css('margin-left', (scope.__cWidth - scope.__ImgWidth) / 2);


                };

                img.bind("load", function(e) {
                    img.unbind("load"); //Hack to ensure load is called only once
                    var w = parseInt(element.css('width'));
                    var h = parseInt(((w * 1) * 300) / 300);
                    img.css('width', w);
                    scope.onResizeFunction();
                });

                // Call to the function when the page is first loaded
                scope.onResizeFunction();

                // scope.$watch(function() {
                //      scope.onResizeFunction();
                //      scope.$apply();
                // });

                angular.element($window).bind('resize', function() {
                    scope.onResizeFunction();
                    scope.$apply();
                });
            }
        };
    }

})(angular);
(function () {
	'use strict';

	angular
		.module('app.core')
		.directive('parseUrl', parseUrl);

	/** @ngInject */
	function parseUrl() {

		var urlPattern = /(http|ftp|https):\/\/[\w-]+(\.[\w-]+)+([\w.,@?^=%&amp;:\/~+#-]*[\w@?^=%&amp;\/~+#-])?/gi;
		return {
			restrict: 'A',
			require: 'ngModel',
			replace: true,
			scope: {
				props: '=parseUrl',
				ngModel: '=ngModel'
			},
			link: function compile(scope, element, attrs, controller) {
				scope.$watch('ngModel', function (value) {
					var html = value.replace(urlPattern, '<a target="' + scope.props.target + '" href="$&">$&</a>') + " | " + scope.props.otherProp;
					element.html(html);
				});
			}
		};
	}

})(angular);
(function () {
	'use strict';

	angular
		.module('app.core')
		.directive('onSizeChanged', onSizeChanged);

	/** @ngInject */
	function onSizeChanged($window) {



		return {
			restrict: 'A',
			scope: {
				onSizeChanged: '&'
			},
			link: function (scope, $element, attr) {
				var element = $element[0];

				cacheElementSize(scope, element);
				$window.addEventListener('resize', onWindowResize);

				function cacheElementSize(scope, element) {
					scope.cachedElementWidth = element.offsetWidth;
					scope.cachedElementHeight = element.offsetHeight;
				}

				function onWindowResize(ev) {
					var isSizeChanged = scope.cachedElementWidth != element.offsetWidth || scope.cachedElementHeight != element.offsetHeight;
					if (isSizeChanged) {
						var expression = scope.onSizeChanged();
						expression({
							width: element.offsetWidth,
							height: element.offsetHeight
						});
					}
				}

				scope.$watch(function () {
					return {
						width: $element.width(),
						height: $element.height()
					};
				}, function (size) {
					var isSizeChanged = scope.cachedElementWidth != size.width || scope.cachedElementHeight != size.height;
					var expression = scope.onSizeChanged();
					if (isSizeChanged) {
						expression(size);
					}
				}, true);
			}
		}

	}

})(angular);
(function (angular) {
	'use strict';

	angular.module('app.core')
		.directive('imageonload', function () {
			return {
				restrict: 'A',
				link: function (scope, element, attrs) {
					element.on('load', function () {
						element.removeClass('spinner-hide');
						element.addClass('show spinner-show');
						element.parent()
							.find('.spinner')
							.remove();
					});

					scope.$watch('ngSrc', function () {
						element.addClass('hide spinner-hide');
						element.parent()
							.append('<div class="loading-container spinner"><i class="icon-loading"></i></div>');
					}, function (value) {
						if (!value) {
							element.attr('src', attrs.errSrc);
						}
					});

					element.bind('error', function () {
						element.attr('src', attrs.errSrc);
					});
					//element.bind('load', function() {
					//  alert('image is loaded');
					//});
				}
			};
		})
		.directive('errSrc', function () {
			return {
				link: function (scope, element, attrs) {
					element.bind('error', function () {
						element.attr('src', attrs.errSrc);
					});
				}
			}
		})

	.directive('imageonloadcontrol', function () {
		return {
			restrict: 'A',
			link: function (scope, element, attrs) {
				if (attrs.ngSrc == '') {
					element.attr('src', attrs.noSrc);
				} else {
					element.on('load', function () {});
					scope.$watch('ngSrc', function () {}, function (value) {
						console.log(value);
						if (!value) {
							element.attr('src', attrs.errSrc);
						}
					});

					element.bind('error', function () {
						element.attr('src', attrs.errSrc);
					});
				}
			}
		};
	})

	.directive('timezonedDate', function () {
        return {
            require: 'ngModel',
            restrict: 'A',
            link: function (scope, elem, attrs, ngModel) {
                var toView = function (val) {
                    var offset = moment(val).utcOffset();
//                    console.debug(offset)
                    var date = new Date(moment(val).subtract(offset, 'm'));
                    var newOffset = moment.tz.zone(attrs.timezone).offset(date);
//                    console.debug("TO VIEW::" +  new Date(moment(date).subtract(newOffset, 'm').unix() * 1000));
                    return new Date(moment(date).subtract(newOffset, 'm').unix() * 1000);
                };

                var toModel = function (val) {
                    var offset = moment(val).utcOffset();
                    var date = new Date(moment(val).add(offset, 'm'));
                    var newOffset = moment.tz.zone(attrs.timezone).offset(date);
//                    console.debug("TO MODEL::" + moment(date).add(newOffset, 'm').unix() * 1000);
                    return moment(date).add(newOffset, 'm').unix() * 1000;
                };

                ngModel.$formatters.unshift(toView);
                ngModel.$parsers.unshift(toModel);
            }
        };

    });
})(angular);
(function () {
	'use strict';

	angular
		.module('app.core')
		.directive('fotorama', fotoramaDirective);

	/** @ngInject */
	function fotoramaDirective($timeout, $q, $interpolate) {

		return {
			template: '<div class="fotorama-template"></div>',
			replace: true,
			restrict: 'E',
			scope: {
				options: '=',
				items: '='
			},
			link: function (scope, element, attrs) {
				scope.$watch('items', function () {
					if (scope.items) {
						var i = 0;
						var showIndex = 0;
						scope.items.forEach(function (item) {
							if (item.selected === true) {
								showIndex = i;
							}
							if(item.video){
								$('<a href="'+item.video+'?autoplay=1" data-caption="' + item.dataCaption + '" data-video="true"><img src="' + item.imageUrl + '" ></a>')
									.appendTo(element);
							} else {
								$('<a href="' + item.imageUrl + '" data-caption="' + item.dataCaption + '"><img src="' + item.thumb + '"></a>')
									.appendTo(element);
							}
							i++;
						});
						var $fotoramaDiv = $('.fotorama-template')
							.fotorama();

						$fotoramaDiv.data('fotorama')
							.setOptions(scope.options).show(showIndex);
					}
				});
			}
		};
	}

})(angular);
(function () {
	'use strict';

	angular
		.module('app.core')
		.directive('extensionClass', Directive);

	/** @ngInject */
	function Directive($timeout, $q, $interpolate, msUtils) {

		return {
			restrict: 'A',
			link: function postLink(scope, elem, attrs) {
				// Add class
				var mediaFile = attrs.extensionClass || null;
				if (mediaFile) {
					msUtils.getExtension(mediaFile);
					elem.addClass(msUtils.getExtension(mediaFile));
				}

			}
		};
	}

})(angular);
(function () {
	'use strict';

	angular
		.module('app.core')
		.directive('qiuIcon', Directive);

	/** @ngInject */
	function Directive($timeout, $q, $interpolate, msUtils, $compile) {

		return {
			restrict: 'E',

			scope: {
				mediafile: '=mediafile',
				type: '=type',
			},

			link: function (scope, element, attrs) {
				var mediaFile = scope.mediafile || null;
				var type = scope.type || null;
				if (mediaFile != null) {
					var fontIcon = msUtils.getExtensionIcon(mediaFile);
					var extension = msUtils.getExtension(mediaFile);
					var html = '';
					if (type == 'placeholder') {
						html = '<div style="position: absolute; z-index: 9999; left: 0; top: 0; width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;">';
						html += '<md-icon class="s24" md-font-icon="' + fontIcon + '" style="margin: 0;"></md-icon>';
						if (fontIcon === 'icon-file' && extension) {
							html += '<span style="position: absolute; font-size: 6px; font-weight: 900; text-transform: uppercase; top: 11px; color: white; text-shadow: 0px 0px 2px rgba(0,0,0,0.5); font-family: Roboto, sans-serif;">' + extension.substring(0, 3) + '</span>';
						}
						html += '</div>';
					} else {
						html = '<div style="display: flex; flex-direction: column; align-items: center; justify-content: center; position: relative; width: 100%; height: 100%; min-width: 56px; min-height: 56px;">';
						html += '<md-icon class="s56" md-font-icon="' + fontIcon + '" style="margin: 0;"></md-icon>';
						if (fontIcon === 'icon-file' && extension) {
							html += '<span style="position: absolute; font-size: 11px; font-weight: 900; text-transform: uppercase; top: 29px; color: white; text-shadow: 0px 1px 2px rgba(0,0,0,0.5); font-family: Roboto, sans-serif; letter-spacing: 0.2px;">' + extension.substring(0, 4) + '</span>';
						}
						html += '</div>';
					}
					var e = $compile(html)(scope);
					element.replaceWith(e);
				}
			}
		};
	}

})(angular);
(function () {
	'use strict';

	angular
		.module('app.core')
		.directive('elementSize', elementSize);

	/** @ngInject */
	function elementSize($parse) {
		return {
			restrict: 'A',
			scope: {
				elementSize: '&'
			},
			link: function (scope, $element, attr) {
				// var fn = $parse(attrs.elementSize);
				scope.$watch(function () {
					return {
						width: $element.width(),
						height: $element.height()
					};
				}, function (size) {
					console.log(size)
					var expression = scope.elementSize();
					expression(size);
					// fn.assign(scope, size);
				}, true);
			}
		}

	}

})(angular);
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('qiuTree', qiuTree)
        .controller('qiuTreeController', qiuTreeController);

    /** @ngInject */
    function qiuTree() {
        return {
            restrict: 'E',
            transclude: true,
            replace: true,
            scope: {
                tree: '=tree',
                iscombo: '=iscombo',
                selected: '=selected',
                search: '=search',
                flatSearch: '=?flatSearch',
                expandedids: '=expandedids',
                selectedIds: '=selectedIds',
                onEdit: '&',
                onSelect: '&'
            },
            templateUrl: "app/core/directives/qiu-tree/qiu-tree.html",
            compile: function (tElement) {
                tElement.addClass('qiu-tree');
            },
            controller: 'qiuTreeController as vm',
            link: function (scope, $element, attrs) { }
        };
    }

    /** @ngInject */
    function qiuTreeController($scope, $log) {
        var vm = this;

        vm.expand   = expand;
        vm.collapse = collapse;
        vm.select   = select;
        vm.edit     = edit;

        vm.$onInit = function () {
            vm.tree        = $scope.tree;
            vm.iscombo     = $scope.iscombo;
            vm.flatSearch  = $scope.flatSearch;
            vm.expandedids = $scope.expandedids || [];
            vm.selected    = $scope.selected;
            vm.searchResults = [];

            vm.selectedIds = $scope.selectedIds || Object.create(null);
        };

        // Watchers
        $scope.$watch('tree', function (newVal) {
            vm.tree = newVal;
            if ($scope.flatSearch && vm.search) {
                vm.searchResults = collectMatches(vm.tree, ('' + vm.search).toLowerCase(), [], []);
            } else {
                vm.treeFiltered = angular.copy(newVal);
            }
        }, true);

        $scope.$watch('selected', function (newVal) {
            vm.selected = newVal;
        });

        $scope.$watch('expandedids', function (newVal) {
            vm.expandedids = newVal || [];
        });

        $scope.$watch('search', function (newVal) {
            vm.search = newVal;
            if (!vm.search) {
                vm.searchResults = [];
                vm.treeFiltered = JSON.parse(JSON.stringify(vm.tree));
            } else if ($scope.flatSearch) {
                // Flat, breadcrumb mode: show only matching nodes, each with its path.
                vm.searchResults = collectMatches(vm.tree, ('' + vm.search).toLowerCase(), [], []);
            } else {
                vm.treeFiltered = JSON.parse(JSON.stringify(vm.tree)).filter(function (x) {
                    return matchFilter(x, vm.search);
                });
            }
        });

        // Collect every node whose name matches, flattened, each annotated with the
        // breadcrumb path of its ancestor names (excluding the node itself) and the full
        // trail including the node (shown on hover, since the crumb line is truncated).
        // The matched node is cloned without children so it renders as a single row.
        function collectMatches(nodes, search, path, out) {
            (nodes || []).forEach(function (node) {
                var name = (node.gallery_name || node.name || '').toString();
                if (name.toLowerCase().indexOf(search) >= 0) {
                    var leaf = angular.extend({}, node);
                    leaf.children = null;
                    out.push({
                        node: leaf,
                        breadcrumb: path.slice(),
                        path: path.concat(name).join(' / ')
                    });
                }
                if (node.children && node.children.length) {
                    collectMatches(node.children, search, path.concat(name), out);
                }
            });
            return out;
        }

        $scope.$watch('selectedIds', function (newVal) {
            vm.selectedIds = newVal || Object.create(null);
        });

        function matchFilter(item, search) {
            var name = (item.gallery_name || item.name || "").toString().toLowerCase();
            var searchStr = (search || "").toString().toLowerCase();
            var found = name.indexOf(searchStr) >= 0;

            if (!found && item.children) {
                item.children = item.children.filter(function (x) {
                    return matchFilter(x, search);
                });
            }
            return found || (item.children && item.children.length > 0);
        }

        function select(item) {
            $scope.onSelect({ item: item });
        }

        function edit(item, parent) {
            $scope.onEdit({ item: item, parent: parent });
        }

        /**
         * Helper to extract a stable ID for the node.
         * It supports different tree types (galleries, groups, etc.).
         */
        function getItemId(item) {
            // For media galleries
            if (item.id_gallery) {
                return item.id_gallery;
            }
            // For groups or other trees
            if (item.id_group) {
                return item.id_group;
            }
            // Fallback
            return item.id;
        }

        /**
         * Expand a single node
         */
        function expand(item) {
            var id = item && item.id;
            if (!id) {
                return;
            }

            if (!angular.isArray(vm.expandedids)) {
                vm.expandedids = [];
            }

            // Avoid duplicates
            if (vm.expandedids.indexOf(id) === -1) {
                vm.expandedids.push(id);
            }
        }

        /**
         * Collapse a single node
         */

        function collapse(item) {
            var id = item && item.id;
            if (!id || !angular.isArray(vm.expandedids)) {
                return;
            }

            var idx = vm.expandedids.indexOf(id);

            // VERY IMPORTANT: do NOT splice if idx === -1
            if (idx > -1) {
                vm.expandedids.splice(idx, 1);
            }
        }
    }
})();

(function() {

	'use strict';

	function RatingStarsDirective() {

		function link(scope, element, attrs, ctrl) {
			if (!attrs.maxRating || (parseInt(attrs.maxRating) <= 0)) {
				attrs.maxRating = '5';
			}
			scope.$watch('ctrl.maxRating', function(oldVal, newVal) {
				ctrl.initStarsArray();
			});
			scope.$watch('ctrl.rating', function(oldVal, newVal) {
				ctrl.validateStars(ctrl.rating);
			});
		}

		return {
			restrict: 'E',
			replace: true,
			templateUrl: 'app/core/directives/qiu-rating-stars/rating-stars-directive.html',
			scope: {},
			controller: 'RatingStarsController',
			controllerAs: 'ctrl',
			bindToController: {
				maxRating: '@?',
				rating: '=?',
				readOnly: '=?',
				onRating: '&',
				resetAllowed : '=?'
			},
			link: link
		};
	}

	angular.module('app.core')
	.directive('qiuRatingStars', [
		RatingStarsDirective
		]);

}());
(function() {
	'use strict';

	function RatingStarsController($attrs, $timeout, $scope) {

		var that = this;

		if (that.readOnly === undefined) {
			that.readOnly = false;
		}

		if( that.resetAllowed === undefined ){
			that.resetAllowed = true;
		}

		that.initStarsArray = function() {
			that.starsArray = that.getStarsArray();
			that.validateStars(that.rating);
		};

		that.getStarsArray = function() {
			var starsArray = [];
			for (var index = 0; index < that.maxRating; index++) {
				var starItem = {
						index: index,
						class: 'icon-star-outline'
				};
				starsArray.push(starItem);
			}
			return starsArray;
		};

		that.setRating = function(rating) {
			if (that.readOnly) {
				return;
			}
			that.rating = rating;
			that.validateStars(that.rating);
			$timeout(function() {
				that.onRating({
					rating: that.rating
				});
			});
		};

		that.setMouseOverRating = function(rating) {
			if (that.readOnly) {
				return;
			}
			that.validateStars(rating);
		};

		that.validateStars = function (rating) {

			if (!that.starsArray || that.starsArray.length === 0) {
				return;
			}

				for (var index = 0; index < that.starsArray.length; index++) {
					var starItem = that.starsArray[index];
					if (index <= (rating - 1)) {
							starItem.class = 'icon-star';
					} else {
							starItem.class = 'icon-star-outline';

					}
				}

		};

	}

	angular
	angular.module('app.core')
	.controller('RatingStarsController', [
		'$attrs', '$timeout','$scope',
		RatingStarsController
		]);

}());
(function() {

	'use strict';

    function qiuGroupsClick(ivhTreeviewMgr, $injector) {
        function unselectAllGroups(){
            var elemList = document.querySelectorAll('.sidenav-groups .group-row');
            elemList.forEach(function(elem) {
                elem.classList.remove('selected');
            });
        }

        return {
            restrict: 'AE',
            require: '^ivhTreeview',
            link: function(scope, element, attrs, ctrl) {
                element.on('click', function() {
                    ivhTreeviewMgr.select(ctrl.root(), scope.node, !scope.node.selected);
                    scope.$apply();
                    var groupNode = false;
                    if (element.parent().hasClass('selected')) {
                        unselectAllGroups();
                    } else {
                        unselectAllGroups();
                        element.parent().addClass('selected');
                        groupNode = scope.node;
                    }
                    var includeSubgroups = angular.element('.sidenav-groups #includeSubgroups').attr("data-include-subgroups") == 'true';
                    var ServiceInject = $injector.get(attrs.groupsService);
                    ServiceInject.triggerGroupsFilter(groupNode, includeSubgroups, ctrl.root())
                });

            }
        };
    }

	angular.module('app.core')
	.directive('qiuGroupsClick', [
        'ivhTreeviewMgr',
		'$injector',
        qiuGroupsClick
		]);

}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('qiuGroups', qiuGroupsDirective)
        .directive('qiuGroupsSelect', qiuGroupsSelect)
        .directive('qiuGroupsEditGroupDialog', qiuGroupsEditGroup)
        .directive('qiuGroupsAddSelectedItemsDialog', qiuGroupsAddSelectedItems)
        .directive('qiuGroupsRemoveSelectedItemsDialog', qiuGroupsRemoveSelectedItems)
        .config(config);

    /** @ngInject */
    function qiuGroupsDirective($mdSidenav, $mdDialog, requestContext, qiuGroupsUtils)
    {
        return {
            restrict: 'EA',
            scope: {
                qiuGroupsNested : '=',
                qiuGroupsSelectedGroup : '=',
                qiuGroupsQiuRestrictions : '=',
                qiuGroupsIncludeSubgroups : '=',
                qiuGroupsSortGroupsBy: '=',
                qiuGroupsSortGroupsField : '=',
                qiuGroupsSortGroupsDir : '=',
                qiuGroupsSortGroups: '&',
                qiuGroupsToggleSidenav : '&',
                qiuGroupsGetItemsInGroups: '&',
                qiuGroupsCreateGroup: '&',
                qiuGroupsEditGroup: '&',
                qiuGroupsDeleteGroup: '&',
            },
            templateUrl: 'app/core/directives/qiu-groups/qiu-groups-sidenav.html',
            controllerAs: 'vm',
            controller: function($scope)
            {
                var vm = this;

                if ($scope.qiuGroupsQiuRestrictions &&
                    (
                        $scope.qiuGroupsQiuRestrictions.hasOwnProperty('id_group') ||
                        $scope.qiuGroupsQiuRestrictions.hasOwnProperty('groups_sub' )
                    )
                ) {
                    $scope.qiuGroupsNested = qiuGroupsUtils.formatNestedGroups($scope.qiuGroupsNested, $scope.qiuGroupsQiuRestrictions, true);
                    $scope.qiuGroupsSelectedGroup = $scope.qiuGroupsNested[0];
                }

                // Data
                vm.isOpenSidenavGroups = true;
                vm.isQiuRestricted = false;
                vm.qiuGroupsNested = $scope.qiuGroupsNested;
                vm.qiuGroupsIncludeSubgroups = $scope.qiuGroupsIncludeSubgroups;
                vm.qiuGroupsSortGroupsBy = $scope.qiuGroupsSortGroupsBy;
                vm.qiuGroupsSortGroupsField = $scope.qiuGroupsSortGroupsField;
                vm.qiuGroupsSortGroupsDir = $scope.qiuGroupsSortGroupsDir;


                // Methods
                vm.toggleSidenav = toggleSidenav;
                vm.createGroup = createGroup;
                vm.sortGroups = sortGroups;

                if (angular.isArray(vm.qiuGroupsNested) &&
                    vm.qiuGroupsNested.length > 0 &&
                    vm.qiuGroupsNested[0].is_qiu_restricted_root
                ) {
                    vm.isQiuRestricted = true;
                    if (!vm.parentGroup) {
                        vm.parentGroup = vm.qiuGroupsNested[0];
                    }
                }

                $scope.$watch('qiuGroupsNested', function(newVal, oldVal) {
                    vm.qiuGroupsNested = newVal;
                });

                $scope.$on('qiuGroups:groupClick', function(ev, groups, includeSubgroups) {
                    $scope.qiuGroupsSelectedGroup = false;
                    if (groups) {
                        var groupIds = [];
                        angular.forEach(groups, function (group) {
                          groupIds.push(group.id_group);
                        });
                        $scope.qiuGroupsSelectedGroup = groups[0];
                    }
                    $scope.qiuGroupsGetItemsInGroups()(groupIds);
                })

                $scope.$on('qiuGroups:editGroup', function(ev, group, clickEvent){
                    openGroupDialog(clickEvent, group)
                })

                function toggleSidenav() {
                    $scope.qiuGroupsToggleSidenav()();
                }

                function createGroup(ev) {
                    openGroupDialog(ev, {});
                }

                function openGroupDialog(ev, group) {
                    $mdDialog.show({
                        controller: 'QiuGroupsEditGroupDialogController',
                        controllerAs: 'vm',
                        locals: {
                            group: group,
                            siteID: requestContext.getParam("siteId"),
                            nestedGroups: angular.copy(vm.qiuGroupsNested)
                        },
                        templateUrl: 'app/core/directives/qiu-groups/dialogs/edit-group/edit-group.html',
                        parent: angular.element(document.body),
                        targetEvent: ev,
                        clickOutsideToClose: true,
                        //fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
                    }).then(function(resp){
                        if (resp.action == 'delete') {
                            $scope.qiuGroupsDeleteGroup()(resp.group);
                        }
                        if (resp.action == 'edit') {
                            $scope.qiuGroupsEditGroup()(resp.group, resp.groupName, resp.groupParentId);
                        }
                        if (resp.action == 'create') {
                            $scope.qiuGroupsCreateGroup()(resp.groupName, resp.groupParentId);
                        }
                    });
                }

                function sortGroups() {
                    $scope.qiuGroupsSortGroups()(vm.qiuGroupsSortGroupsField, vm.qiuGroupsSortGroupsDir);
                }
            }
        };
    }

    function config($translatePartialLoaderProvider) {
        $translatePartialLoaderProvider.addPart('/app/core/directives/qiu-groups');
    }

    function qiuGroupsSelect(ivhTreeviewMgr, $injector, $rootScope) {

        function unselectAllGroups(){
            var elemList = document.querySelectorAll('.sidenav-qiu-groups .group-row');
            elemList.forEach(function(elem) {
                elem.classList.remove('selected');
            });
        }

        function unnestGroups(node, groups, includeSubgroups) {
            groups.push(node);
            if (includeSubgroups && typeof node.children !== 'undefined' && node.children.length >0) {
                angular.forEach(node.children, function (data) {
                    unnestGroups(data, groups, includeSubgroups);
                });
            }
            return groups;
        }

        return {
            restrict: 'AE',
            require: '^ivhTreeview',
            link: function(scope, element, attrs, ctrl) {
                element.on('click', function() {
                    ivhTreeviewMgr.select(ctrl.root(), scope.node, !scope.node.selected);
                    scope.$apply();
                    var groupNode = false;
                    var groups = false;
                    if (element.parent().hasClass('selected')) {
                        // With Qiu restriction active don't allow for unselecting groups.
                        if (scope.node.is_qiu_restricted) return;
                        unselectAllGroups();
                    } else {
                        unselectAllGroups();
                        element.parent().addClass('selected');
                        groupNode = scope.node;
                        var node = angular.fromJson(groupNode);
                        groups = unnestGroups(node, [], includeSubgroups);
                    }
                    var includeSubgroups = angular.element('#qiuGroupsIncludeSubgroups').attr("data-include-subgroups") == 'true';
                    $rootScope.$broadcast('qiuGroups:groupClick', groups, includeSubgroups);
                });
            }
        };
    }

    function qiuGroupsEditGroup(usersService, $mdDialog, requestContext, $rootScope) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                $(element).on('click', function (e) {
                    var groupNode = scope.node;
                    $rootScope.$broadcast('qiuGroups:editGroup', groupNode, e)
                });
            }
        };
    }

    /** @ngInject */
    function qiuGroupsAddSelectedItems($mdSidenav, $mdDialog, requestContext, $document)
    {
        return {
            restrict: 'EA',
            scope: {
                qiuGroupsNested : '=',
                qiuGroupsMembershipAction : '=',
                qiuGroupsMembershipSelectedItems : '=',
                qiuGroupsMembershipIdField : '=',
                qiuGroupsMembershipMassInsert : '&'
            },
            link: function ($scope, $element, $attrs) {

                var openDialog = function (ev) {

                    $mdDialog.show({
                        controller: 'AddSelectedItemsToGroupsDialogController',
                        controllerAs: 'vm',
                        locals: {
                            groups: $scope.qiuGroupsNested,
                            selectedItems: $scope.qiuGroupsMembershipSelectedItems,
                            siteID: $scope.siteID,
                            id_field: $scope.qiuGroupsMembershipIdField
                        },
                        templateUrl: 'app/core/directives/qiu-groups/dialogs/add-selected-items-to-groups/groups-view.html',
                        parent: angular.element($document.body),
                        targetEvent: ev,
                        clickOutsideToClose: true
                    }).then(function (result) {
                        if (result) {
                            $scope.qiuGroupsMembershipMassInsert()(result.itemIds, result.groups)
                        }
                    });
                }
                $element.on('click', openDialog);
           }
        };
    }

    /** @ngInject */
    function qiuGroupsRemoveSelectedItems($mdSidenav, $mdDialog, requestContext, $document, $translate)
    {
        return {
            restrict: 'EA',
            scope: {
                qiuGroupsMembershipSelectedItems : '=',
                qiuGroupsMembershipSelectedGroup : '=',
                qiuGroupsMembershipIdField : '=',
                qiuGroupsMembershipRemove : '&'
            },
            link: function ($scope, $element, $attrs) {

                var openDialog = function (ev) {

                    var confirmTitle = $translate.instant('QIU_GROUPS.REMOVE_CONFIRM_TITLE', { group_name: $scope.qiuGroupsMembershipSelectedGroup.name });
                    var confirmText = $translate.instant('QIU_GROUPS.REMOVE_CONFIRM_TEXT');
                    var confirm = $mdDialog.confirm()
                        .title(confirmTitle)
                        .textContent(confirmText)
                        .ariaLabel(confirmTitle)
                        .targetEvent(ev)
                        .ok('OK')
                        .cancel($translate.instant('CANCEL'));

                    $mdDialog.show(confirm).then(function () {
                        var removeIds = $scope.qiuGroupsMembershipSelectedItems.map(function (item) {
                            return item[$scope.qiuGroupsMembershipIdField]
                        });
                        $scope.qiuGroupsMembershipRemove()($scope.qiuGroupsMembershipSelectedGroup.id_group, removeIds)
                    })
                }
                $element.on('click', openDialog);
           }
        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.users')
        .factory("qiuGroupsUtils", qiuGroupsUtils);



    /** @ngInject */
    function qiuGroupsUtils() {

        var service = {
            formatNestedGroups: formatNestedGroups,
            preAssignQiuRestrictedRoot: preAssignQiuRestrictedRoot
        };


        function formatNestedGroups(groups, qiuRestrictions, isRootCycle, parentLabel) {
            if (groups) {
                for (var i = 0; i < groups.length; i++) {
                    var group = groups[i];
                    // 'name' is used as display name on group tree, while 'label' is used for group SEARCH only.
                    // To keep showing children of search result, we concatenate parent group(s) names with current group name into label.
                    group.label = parentLabel ?  parentLabel + '_' + group.name : group.name;
                    group.is_qiu_restricted = isGroupQiuRestricted(group.id_group, qiuRestrictions);
                    group.is_qiu_restricted_root = isRootCycle && group.is_qiu_restricted;
                    if (group.children) {
                        formatNestedGroups(group.children, qiuRestrictions, false, group.label);
                    }
                }
                return groups;
            }
            return [];
        }

        function isGroupQiuRestricted(groupId, qiuRestrictions) {
            return (qiuRestrictions
                &&
                    (qiuRestrictions.hasOwnProperty('id_group') &&
                        Object.values(qiuRestrictions.id_group).indexOf(groupId) > -1
                    ||
                    qiuRestrictions.hasOwnProperty('groups_sub') &&
                        Object.values(qiuRestrictions.groups_sub).indexOf(groupId) > -1)
            )
        }

        function preAssignQiuRestrictedRoot(groups) {
          if (angular.isArray(groups) && 
              groups.length > 0 &&
                groups[0].is_qiu_restricted_root
          ) {
            groups[0].assigned_group = true;
          }
        }

        return service;
    }


})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('qiuField', qiuFieldDirective)
        .factory('qiuFieldTemplates', qiuFieldTemplates)
        .controller('qiuFieldController', qiuFieldController)
        ;

    function qiuFieldTemplates() {
        return {
            checkbox: 'checkbox.html',
            date: 'date.html',
            list: 'list.html',
            media: 'media.html',
            number: 'integer.html',
            radio: 'radio.html',
            single: 'single.html',
            text: 'text.html',
            time: 'time.html',
            templates: 'templates.html'
        };
    };

    /** @ngInject */
    function qiuFieldDirective(qiuFieldTemplates)
    {
        return {
            restrict: 'AE',
            require: '^^form',
            scope: {
                ngModel: '=',
                field: '='
            },
            controller: 'qiuFieldController',
            controllerAs: 'vm',
            bindToController: true,
            template: '<div ng-include="templateUrl"></div>',
            link: function(scope, element, attrs, formCtrl) {
                var templateDir = 'app/core/directives/qiu-field/templates/';
                scope.templateUrl =  templateDir + qiuFieldTemplates[scope.vm.field.type];
                scope.vm.form = formCtrl;
            }
        }
    }

    function qiuFieldController(msUtils, requestContext, $scope, $filter, $mdDialog, sessionService, contentService, tinyMceService, $timeout, $q) {
        var vm = this;
        vm.hasProp = msUtils.hasProp;
        vm.setTinyMceContent = setTinyMceContent;

        vm.listCalls = vm.listCalls || {};
        vm.listCallsPromises = vm.listCallsPromises || {};

        $timeout(function(){
            init();
        })

        function init() {
            $scope.siteID = requestContext.getParam("siteId");
            switch (vm.field.type) {
                case 'media':
                    if (!angular.isArray(vm.ngModel[vm.field.name])) {
                        vm.ngModel[vm.field.name] = [undefined];
                        vm.ngModel.Thumbnail = [];
                    }
                break;
                case 'list':
                    vm.ngModel.Thumbnail = [];
                    if (vm.field.from){
                        var from = vm.field.from;
                        fetchFromList(from).then(function(options){
                        if (!$scope.$$destroyed){
                            vm.field.options = options;
                            $scope.$evalAsync();
                        }
                        }).catch(function(err){
                        console.error('Error loading list for', from, err);
                        if (!$scope.$$destroyed){
                            vm.field.options = [];
                        }
                        });
                    }
                break;
                case 'templates':
                    vm.templatesOptions = vm.field.options.sort(function(a,b){
                        return a.name.localeCompare(b.name);
                    });
                    var uniqueFrom = {};
                    vm.templatesOptions.forEach(function(t){
                        (t.fields || []).forEach(function(f){
                            if (f.type === 'list' && f.from){ uniqueFrom[f.from] = true; }
                        });
                    });
                    Object.keys(uniqueFrom).forEach(fetchFromList);
                    vm.templatesOptions.forEach(temp => {
                        temp.fields.forEach(field => {
                            switch(field.type){
                                case 'media':
                                    if (!angular.isArray(vm.ngModel[field.name])) {
                                        vm.ngModel[field.name] = [undefined];
                                    }
                                    break;
                                case 'list':
                                    if (field.from){
                                        var from = field.from;
                                        fetchFromList(from).then(function(options){
                                        if (!$scope.$$destroyed){
                                            field.options = options;
                                            $scope.$evalAsync();
                                        }
                                        }).catch(function(err){
                                        console.error('Error loading list for template field', from, err);
                                        if (!$scope.$$destroyed){
                                            field.options = [];
                                        }
                                        });
                                    }
                                break;
                            }
                        });
                    });
                    vm.ngModel.Thumbnail = [];
                    break;
                default:
                    vm.ngModel.Thumbnail = [];
                    break;
            }
        }

        vm.optKey = function(opt){
            if (!opt) return 'nil';
            
            if (vm.hasProp(opt,'value')) {
                var v = opt.value;
                if (angular.isObject(v)) {
                    return v.id || v._id || v.key || v.code || v.slug || ('v|' + JSON.stringify(v));
                }
                return 'v|' + String(v);
            }
            
            return opt.id || opt._id || opt.key || opt.code || opt.slug
                   || (opt.name ? ('n|' + opt.name + '|' + (opt.id_author || '')) 
                   : ('i|' + $scope.$id + '|' + Math.random()));
        };

        function mapOption(opt){
            if (opt && opt.Thumbnail && angular.isArray(opt.Thumbnail) && opt.Thumbnail.length > 0){
                opt.media = [];
                opt.Thumbnail.forEach(function(thumb){
                opt.media.push(mapMediaProperties(thumb));
                });
            }
            return opt;
        }

        function fetchFromList(from){
            if (!from) return $q.when([]);

            if (vm.listCalls[from]){
                return $q.when(vm.listCalls[from]);
            }
            
            if (vm.listCallsPromises[from]){
                return vm.listCallsPromises[from];
            }
            
            vm.listCallsPromises[from] = contentService.get({
                section: from,
                siteID: $scope.siteID,
                resultsPerPage: 9999
            }).then(function(resp){
                var data = (resp && resp.result && angular.isArray(resp.result.data)) ? resp.result.data : [];
                var options = data.map(mapOption);

                var seen = Object.create(null);
                options = options.filter(function(o){
                    var k = o.id || o._id || o.code || o.slug || (o.name + '|' + (o.id_author || '0'));
                    if (!k) return true;
                    if (seen[k]) return false;
                    seen[k] = 1;
                    return true;
                });

                vm.listCalls[from] = options;
                delete vm.listCallsPromises[from];
                return options;
            }).catch(function(err){
                delete vm.listCallsPromises[from];
                return $q.reject(err);
            });

            return vm.listCallsPromises[from];
        }

        vm.mediaSortable = {
            group: 'media',
            animation: 150,
            scroll: true,
            filter: '.no-sort',
            handle: '.media',
            ghostClass: "sort-drop",
            onEnd: function (evt) {

                if (typeof evt.oldIndex == 'undefined' || typeof evt.newIndex == 'undefined') {
                    return;
                }
                if (vm.mediaZones) {

                    vm.ngModel.Thumbnail = [];
                    angular.forEach(vm.thumbnails_Edit, function (thumbZone, idZone) {
                        var i = 1;
                        angular.forEach(thumbZone, function (data) {
                            if (data.id_zone != idZone) {
                                var dataOld = _.clone(data);
                                data.id_zone = idZone * 1;
                            }
                            data.sort = i;
                            vm.ngModel.Thumbnail.push(data);
                            i = i + 1;
                        })
                    })
                }
                else {
                    vm.ngModel.Thumbnail_Temp = _.clone(vm.ngModel.Thumbnail);
                    vm.ngModel.Thumbnail = [];
                    var i = 0;
                    angular.forEach(vm.ngModel.Thumbnail_Temp, function (data) {
                        data.sort = i;
                        vm.ngModel.Thumbnail.push(data);
                        i = i + 1;
                    })

                }
                vm.basicForm.$setDirty()
            }
        };

        function setTinyMceContent(event) {
            var zoneMedia = {
                1: {},
                2: {},
                3: {},
                4: {},
                5: {}
            };
            var typesMax = {
                1: 0,
                2: 0,
                3: 0,
                4: 0,
                5: 0
            };
            var currentSort = 0;
            var currentType = 0;
            for (var i = 0; i < vm.ngModel.Thumbnail.length; i++) {
                if (vm.mediaZones) {
                    if (vm.ngModel.Thumbnail[i]['id_zone'] == 1) {
                        currentSort = vm.ngModel.Thumbnail[i]['sort'];
                        if (vm.ngModel.Thumbnail[i]['media_type']) {
                            currentType = vm.ngModel.Thumbnail[i]['media_type'];
                        } else {
                            currentType = 5; // gallery
                        }
                        typesMax[currentType]++;
                        zoneMedia[currentType][typesMax[currentType]] = vm.ngModel.Thumbnail[i];
                    }
                }
                else {
                    currentSort = vm.ngModel.Thumbnail[i]['sort'];
                    if (vm.ngModel.Thumbnail[i]['media_type']) {
                        currentType = vm.ngModel.Thumbnail[i]['media_type'];
                    } else {
                        currentType = 5; // gallery
                    }
                    typesMax[currentType]++;
                    zoneMedia[currentType][typesMax[currentType]] = vm.ngModel.Thumbnail[i];

                }
            }
            return zoneMedia;
        }
        vm.tinymceOptions = tinyMceService.getOptions($scope);

        /**
         * Converts date to YYYY-MM-DD string and assigns result to model.
         */
        vm.dateToString = function(input) {
            vm.ngModel[vm.field.name] = input.toISOString().substr(0, 10);
        }

        /**
         * Converts YYYY-MM-DD string to date and returns result.
         */
        vm.stringToDate = function(input) {
            if (angular.isDate(input)) {
                return input;
            }
            if (angular.isUndefined(input) || input == '') {
                return null;
            }
            var d = Date.parse(input +"T12:00:00");
            var date = new Date(d);
            return date;
        }

        /**
         * Converts date to HH:mm string and assigns result to model.
         */
        vm.timeToString = function(input) {
            vm.ngModel[vm.field.name] = moment(input).format("HH:mm");
        }

        /**
         * Converts HH:mm string to date and returns result.
         */
        vm.stringToTime = function(input) {
            if (angular.isUndefined(input) || input == '') {
                return null;
            }
            var d = moment();
            var parts = input.split(':');
            var hours = parts[0];
            var minutes = parts[1];
            d.set('hour', hours);
            d.set('minute', minutes);
            return d.toDate();
        }

        vm.selectMedia = function (ev, fieldName) {
            var item = { Thumbnail: [] };
            $mdDialog.show({
                controller: 'MediaDialogController',
                controllerAs: 'vm',
                locals: {
                    autoUpload: '',
                    currentThread: item,
                    section: '',
                    mediazone: false,
                    isTiny: false,
                    maxAttach: 1,
                    showViews: {
                        1: true,
                        2: true,
                        3: false,
                        4: false,
                        5: false,
                        upload: false,
                        import: false
                    }
                },
                templateUrl: 'app/main/dialogs/media/media-dialog.html',
                targetEvent: ev,
                clickOutsideToClose: true,
                multiple: true
            }).then(function (response) {
                let name = vm.field.name;
                if(fieldName){
                    name = fieldName
                }
                if (response.Thumbnail && angular.isArray(response.Thumbnail) && response.Thumbnail.length > 0) {
                    var data = [];
                    angular.forEach(response.Thumbnail, function(media) {
                        if(media.embed_url){
                            data.push(media);
                        }else{
                            data.push(mapMediaProperties(media));
                        }
                    })
                    vm.ngModel[name] = data;
                }
            });
        }

        function mapMediaProperties(data) {
            var response = {};
            const mandatoryMediaProperties = [
                'filename',
                'title',
                'photographer',
                'caption',
                'owner',
                'credits',
                'fileSizeKb',
                'cropstatus',
                'cropstatus_videos',
                'imageUrlOriginal',
                'cdnContainer',
                'id_media',
                'allCropped',
                'media_type'
            ];
            angular.forEach(mandatoryMediaProperties, function(prop) {
                switch (prop) {
                    case 'cropstatus':
                        if (data.hasOwnProperty('cropstatus') && angular.isArray(data.cropstatus)) {
                            response.cropstatus = data.cropstatus.map(mapCropstatus)
                        }
                        break;
                    case 'cropstatus_videos':
                        if(data.hasOwnProperty('cropstatus_videos') && angular.isArray(data.cropstatus_videos)){
                          response.cropstatus_videos = data.cropstatus_videos.map(mapCropstatus);
                        }
                        break;
                    case 'imageUrlOriginal':
                        if (data.cdnContainer) {
                            let mediaContainer = sessionService.getContainerByID(data.cdnContainer);
                            response.imageUrlOriginal = mediaContainer.view_url + 'original/m' + data.id_media + '_' + data.filename
                        }
                        break;
                    default:
                        if (data.hasOwnProperty(prop)) {
                            response[prop] = data[prop];
                        }
                        break;
                }
            })
            return response;
        }

        /**
         * Returns object of following format:
         *
         * {
         *     id_cropformats: crop-format-id,
         *     fileName: crop-format-output-filename,
         *     urlImage: complete-url-to-cropped-image,
         *     id_container: cropped-image-container-id
         * }
         *
         * fileName and id_cropformats are required for example by media directive or to show avatar/thumb
         **/
        function mapCropstatus(status) {
            var response = {
                id_cropformats: status.id_cropformats,
                id_container: status.id_container,
                fileName: status.fileName
            };
            let mediaContainer = sessionService.getContainerByID(status.id_container);
            if (mediaContainer) {
                response.urlImage = mediaContainer.view_url + status.fileName;
            }
            return response;
        }

        vm.isSelectedOption = function(opt) {
            let option = opt.hasOwnProperty('value') ? opt.value : opt;
            return angular.equals(vm.ngModel[vm.field.name], option)
        }

        vm.selectedListOption = function(){
            let ret = false;
            if(vm.templatesOptions && vm.ngModel[vm.field.name]){
                let options = vm.templatesOptions.find(x => x.value.id === vm.ngModel[vm.field.name].id);
                ret = options;
            }
            return ret;
        }
    }
})();

(function () {
    'use strict';

    /**
     * <mv-tree-expander> — par de botones expandir / contraer todo para los arboles del
     * admin. Se hace como directiva compartida porque son varios sitios (users, media y
     * match-center/fixture) con el mismo comportamiento.
     *
     * Soporta los DOS modelos de arbol que conviven en qiusystem:
     *
     *   1) ivh-treeview — la expansion vive en cada nodo (__ivhTreeviewExpanded):
     *      <mv-tree-expander tree="vm.CleanUsersGroups"></mv-tree-expander>
     *
     *   2) qiu-tree — la expansion vive en una lista de ids aparte:
     *      <mv-tree-expander tree="vm.CleanMediaGalleries"
     *                        expanded-ids="vm.expandedids"></mv-tree-expander>
     *
     * El icono que se muestra NO se guarda en un booleano: se calcula mirando el arbol.
     * Asi acierta al entrar (si ya viene expandido, ofrece contraer) y no se desincroniza
     * cuando el usuario abre o cierra ramas a mano.
     */
    angular
        .module('app.core')
        .directive('mvTreeExpander', ['ivhTreeviewMgr', MvTreeExpander]);

    function MvTreeExpander(ivhTreeviewMgr) {
        return {
            restrict: 'E',
            scope: {
                tree: '=',
                expandedIds: '=?'
            },
            templateUrl: 'app/core/directives/mv-tree-expander/mv-tree-expander.html',
            bindToController: true,
            controllerAs: 'exp',
            controller: ['$attrs', function ($attrs) {
                var exp = this;

                // El modelo se decide por la presencia del atributo, no por su valor
                // (la lista de ids empieza vacia y eso no significa "no la uses").
                var usaIds = angular.isDefined($attrs.expandedIds);

                exp.allExpanded = allExpanded;
                exp.expandAll = expandAll;
                exp.collapseAll = collapseAll;

                /** Ids de los nodos que tienen hijos (los unicos que se pueden expandir). */
                function idsConHijos(nodes, result) {
                    angular.forEach(nodes || [], function (node) {
                        if (node && node.children && node.children.length) {
                            result.push(node.id);
                            idsConHijos(node.children, result);
                        }
                    });
                    return result;
                }

                /** ¿Queda algun nodo con hijos sin expandir? (salida temprana) */
                function algunoColapsado(nodes) {
                    var nodes2 = nodes || [];
                    for (var i = 0; i < nodes2.length; i++) {
                        var node = nodes2[i];
                        if (node && node.children && node.children.length) {
                            if (!node.__ivhTreeviewExpanded) { return true; }
                            if (algunoColapsado(node.children)) { return true; }
                        }
                    }
                    return false;
                }

                function allExpanded() {
                    if (!exp.tree || !exp.tree.length) { return false; }
                    if (usaIds) {
                        var ids = idsConHijos(exp.tree, []);
                        if (!ids.length) { return false; }   // arbol plano: nada que expandir
                        var abiertos = exp.expandedIds || [];
                        for (var i = 0; i < ids.length; i++) {
                            if (abiertos.indexOf(ids[i]) < 0) { return false; }
                        }
                        return true;
                    }
                    return !algunoColapsado(exp.tree);
                }

                function expandAll() {
                    if (!exp.tree) { return; }
                    if (usaIds) {
                        exp.expandedIds = idsConHijos(exp.tree, []);
                    } else {
                        ivhTreeviewMgr.expandRecursive(exp.tree);
                    }
                }

                function collapseAll() {
                    if (!exp.tree) { return; }
                    if (usaIds) {
                        exp.expandedIds = [];
                    } else {
                        ivhTreeviewMgr.collapseRecursive(exp.tree);
                    }
                }
            }]
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('qiuChip', qiuChip)

    /** @ngInject */
    function qiuChip() {
        return {
            restrict: 'A',
            link: function(scope, elem, attrs) {
                if (scope.$chip.hasOwnProperty('reason')) {
                    setReasonClass(scope.$chip.reason)
                }
                attrs.$observe('qiuChipReason', function (reason) {
                    setReasonClass(reason)
                });
                function setReasonClass(reason) {
                    var chipClass = 'reason-'+reason;
                    var mdChip = elem.parent().parent();
                    mdChip.addClass(chipClass);
                }

                if (scope.$chip.hasOwnProperty('runner')) {
                    setRunnerClass(scope.$chip.runner)
                }
                attrs.$observe('qiuChipRunner', function (runner) {
                    setRunnerClass(runner)
                });
                function setRunnerClass(runner) {
                    var chipClass = 'runner-'+runner;
                    var mdChip = elem.parent().parent();
                    mdChip.addClass(chipClass);
                }

                attrs.$observe('qiuChipLowSharpness', function (isLowSharpness) {
                    var mdChip = elem.parent().parent();
                    if (isLowSharpness === 'true' || isLowSharpness === true) {
                        mdChip.addClass('low-sharpness');
                    } else {
                        mdChip.removeClass('low-sharpness');
                    }
                });

            }
          };
    }
})();

(function () {
    'use strict';

    // 1 2 5 10 25 50 100 250 500 etc
    function quantizedNumber(i) {
        var adjust = [1, 2.5, 5];
        return Math.floor(Math.pow(10, Math.floor(i / 3)) * adjust[i % 3]);
    }

    // the j such that quantizedNumber(j) is closest to i
    function quantizedIndex(i) {
        if (i < 1) {
            return 0;
        }
        var group = Math.floor(Math.log(i) / Math.LN10),
            offset = i / (2.5 * Math.pow(10, group));
        if (offset >= 3) {
            group++;
            offset = 0;
        }
        return 3 * group + Math.round(Math.min(2, offset));
    }

    function quantize(i) {
        if (i === Infinity) {
            return Infinity;
        }
        return quantizedNumber(quantizedIndex(i));
    }

    // don't overwrite default response transforms
    function appendTransform(defaults, transform) {
        defaults = angular.isArray(defaults) ? defaults : [defaults];
        return (transform) ? defaults.concat(transform) : defaults;
    }

    angular
        .module('app.content')
        .directive('qiuPagination', function () {

            var defaultLinkGroupSize = 3,
                defaultClientLimit = 150,
                defaultPerPage = 50

            return {
                restrict: 'AE',
                scope: {
                    // required
                    url: '=',
                    collection: '=',
                    service: '=',

                    // optional
                    totalItems: '=?',
                    siteId: '=?',
                    columns: '=?',
                    columnsGrouped: '=?',
                    fieldsFilters: '=?',
                    menuFilters: '=?',
                    mediaZones: '=?',
                    customData: '=?',
                    fieldsSearch: '=?',
                    fieldsSort: '=?',
                    fieldsGroup: '=?',
                    groupby: '=?',
                    urlParams: '=?',
                    headers: '=?',
                    page: '=?',
                    perPage: '=?',
                    perPagePresets: '=?',
                    autoPresets: '=?',
                    clientLimit: '=?',
                    linkGroupSize: '=?',
                    reloadPage: '=?',
                    size: '=?',
                    passive: '@',
                    transformResponse: '=?',
                    // templateUrl: "app/core/directives/pagination/pagination.html"
                    // directive -> app communication only
                    numPages: '=?',
                    numItems: '=?',
                    serverLimit: '=?',
                    rangeFrom: '=?',
                    rangeTo: '=?',
                    filterByMediaType: '=?',
                    forceSection: '=?',
                    includeAllGroups: '=?'
                },
                templateUrl: function (element, attr) {
                    return attr.templateUrl || 'app/core/directives/pagination/pagination_fuse_1.html';
                    // return attr.templateUrl || 'src/paginate-anything.html';
                },
                replace: true,
                controller: ['$scope', '$rootScope', '$http', '$attrs', '$injector', 'requestContext', '$location', '_', '$mdSidenav', 'sessionService', '$log',
                    function ($scope, $rootScope, $http, $attrs, $injector, requestContext, $location, _, $mdSidenav, sessionService, $log) {
                        $scope.collection = [];
                        //                        console.log("reload pagination API ")
                        var ServiceInject = $injector.get($attrs.service);
                        $scope.menuFiltersID = $attrs.menuFilters;
                        $rootScope.sortField = $attrs.sortField ? $attrs.sortField : null;
                        $rootScope.sortDir = $attrs.sortDir ? $attrs.sortDir : null;
                        $log.debug('[paginate-api] Initialized sort params:', { field: $rootScope.sortField, dir: $rootScope.sortDir });
                        $scope.includeAllGroups = $attrs.includeAllGroups || false;

                        var filterByMediaType = $scope.filterByMediaType ? $scope.filterByMediaType : null;

                        // var siteID = $attrs.siteId;
                        var siteID = requestContext.getParam("siteId");
                        var section = requestContext.getParam("section");
                        if (!angular.isUndefined($attrs.forceSection)) {
                            section = $attrs.forceSection;
                        }

                        if (angular.isUndefined($rootScope.pagination_searchstring)) {
                            $rootScope.pagination_searchstring = "";
                        }

                        $scope.preventFiltering = false;

                        if ($location.search()
                            .page && $location.search()
                                .page > 0) {
                            $rootScope.pagination_page = $location.search().page;
                            // $scope.pagination_page = $location.search().page;
                        } else {
                            $rootScope.pagination_page = 1;
                            // $scope.pagination_page = 1;
                        }

                        $scope.isLoading = true;

                        $scope.reloadPage = false;
                        $scope.filterables = [];
                        $rootScope.pagination_searchquery = false;
                        $scope.serverLimit = Infinity; // it's not known yet
                        $scope.Math = window.Math; // Math for the template


                        if (typeof $scope.autoPresets !== 'boolean') {
                            $scope.autoPresets = true;
                        }

                        var lgs = $scope.linkGroupSize,
                            cl = $scope.clientLimit;
                        $scope.linkGroupSize = typeof lgs === 'number' ? lgs : defaultLinkGroupSize;
                        $scope.clientLimit = typeof cl === 'number' ? cl : defaultClientLimit;

                        $scope.loadedFilters = false;

                        $scope.updatePresets = function () {

                            if ($scope.autoPresets) {
                                if ($scope.passive !== 'true') {
                                    //$rootScope.perPage = defaultPerPage;
                                    $location.search('page', $rootScope.pagination_page);
                                    $location.search('perPage', $rootScope.perPage);
                                }


                                var presets = [],
                                    i;
                                for (i = Math.min(3, quantizedIndex($rootScope.perPage || defaultPerPage)); i <= quantizedIndex(Math.min($scope.clientLimit, $scope.serverLimit)); i++) {
                                    presets.push(quantizedNumber(i));
                                }
                                $rootScope.perPagePresets = presets;
                            } else {
                                $rootScope.perPagePresets = $rootScope.perPagePresets.filter(
                                    function (preset) {
                                        return preset <= $scope.serverLimit;
                                    }
                                )
                                    .concat([$scope.serverLimit]);
                            }
                        };

                        $scope.gotoPage = function (i) {
                            $scope.isLoading = true;

                            if (i < 0 || i * $rootScope.perPage >= $scope.numItems) {
                                return;
                            }
                            $rootScope.pagination_page = i;
                            $location.search('page', $rootScope.pagination_page);
                        };

                        $rootScope.pagination_setOrderBy = function (i) {
                            var Sort = new Array;
                            Sort.push(i)

                            //                            console.log(i);

                            $rootScope.sortable = i;
                            $scope.preventFiltering = true;
                            $rootScope.pagination_page = 1;
                            updateLocation();
                            requestRange({
                                from: $rootScope.pagination_page,
                                resultsPerPage: $rootScope.perPage,
                                filters: $scope.fieldsFilters,
                                query: $scope.fieldsSearch,
                                sort: $rootScope.sortable,
                                searchStringFilter: $rootScope.pagination_searchstring
                            });


                        }

                        $rootScope.pagination_reload = function () {
                            requestRange({
                                from: $rootScope.pagination_page,
                                resultsPerPage: $rootScope.perPage,
                                filters: $scope.fieldsFilters,
                                query: $scope.fieldsSearch,
                                sort: $rootScope.sortable,
                                searchStringFilter: $rootScope.pagination_searchstring
                            });
                        }

                        $rootScope.pagination_setSortField = function (field, dir) {
                            $rootScope.sortField = field ? field : $rootScope.sortField;
                            $rootScope.sortDir = dir ? dir : $rootScope.sortDir;

                            $scope.preventFiltering = true;
                            $rootScope.pagination_page = 1;
                            updateLocation();
                            requestRange({
                                from: $rootScope.pagination_page,
                                resultsPerPage: $rootScope.perPage,
                                filters: $scope.fieldsFilters,
                                query: $scope.fieldsSearch,
                                sortField: $rootScope.sortField,
                                sortDir: $rootScope.sortDir,
                                searchStringFilter: $rootScope.pagination_searchstring
                            });
                        };

                        $rootScope.pagination_setSortDir = function (dir) {
                            $rootScope.sortDir = dir ? dir : $rootScope.sortDir;

                            $scope.preventFiltering = true;
                            $rootScope.pagination_page = 1;
                            updateLocation();
                            requestRange({
                                from: $rootScope.pagination_page,
                                resultsPerPage: $rootScope.perPage,
                                filters: $scope.fieldsFilters,
                                query: $scope.fieldsSearch,
                                sortField: $rootScope.sortField,
                                sortDir: $rootScope.sortDir,
                                searchStringFilter: $rootScope.pagination_searchstring
                            });
                        };

                        $rootScope.pagination_resetOrderBy = function (i) {
                            $rootScope.sortField = null;
                            $rootScope.pagination_resetquery();
                        }

                        $rootScope.pagination_morePages = function () {
                            if ($rootScope.pagination_page == $rootScope.pagination_total_pages) return true;
                            return false;

                        };
                        $rootScope.pagination_firstPage = function () {

                            if ($rootScope.pagination_page == 1) return true;
                            return false;

                        };

                        $rootScope.pagination_search = function (query) {
                            $rootScope.pagination_searchstring = query;
                            $rootScope.pagination_searchquery = true;
                            $rootScope.pagination_page = 1;
                            updateLocation();
                            requestRange({
                                from: $rootScope.pagination_page,
                                resultsPerPage: $rootScope.perPage,
                                filters: $scope.fieldsFilters,
                                sort: $rootScope.sortField,
                                searchStringFilter: query
                            });


                        }

                        $rootScope.pagination_resetquery = function (query) {
                            $rootScope.modelSearch = '';
                            $rootScope.pagination_searchquery = false;
                            $rootScope.pagination_searchstring = "";
                            $rootScope.pagination_page = 1;
                            _.each($scope.fieldsFilters, function (value, key, list) {
                                //									console.log($scope.fieldsFilters[key])
                                $scope.fieldsFilters[key]['selected'] = new Array;
                            });
                            updateLocation();
                            requestRange({
                                from: $rootScope.pagination_page,
                                resultsPerPage: $rootScope.perPage,
                                filters: $scope.fieldsFilters,
                                sort: $rootScope.sortField,
                            });


                        }

                        $rootScope.pagination_prevPage = function () {

                            var i = $rootScope.pagination_page;
                            i--;

                            if (i <= 0) {
                                return;
                            }
                            $rootScope.pagination_page = i;
                            $scope.isLoading = true;
                            $location.search('page', $rootScope.pagination_page);
                        };

                        $rootScope.pagination_nextPage = function (add) {
                            if (add) {
                                $rootScope.add = true;
                            }
                            var i = $rootScope.pagination_page;
                            i++;

                            if (i > $rootScope.pagination_total_pages) {
                                return;
                            }
                            //                            console.log("nextPage")
                            $rootScope.pagination_page = i;
                            $scope.isLoading = true;
                            $location.search('page', $rootScope.pagination_page);
                        };

                        $rootScope.pagination_gotoPage = function (i) {
                            $scope.isLoading = true;

                            if (i < 0 || i * $rootScope.perPage >= $scope.numItems) {
                                return;
                            }
                            $rootScope.pagination_page = i;
                            $location.search('page', $rootScope.pagination_page);
                        };

                        $scope.linkGroupFirst = function () {
                            var rightDebt = Math.max(1,
                                $scope.linkGroupSize - ($scope.numPages - 1 - ($rootScope.pagination_page + 2))
                            );
                            return Math.max(1,
                                $rootScope.pagination_page - ($scope.linkGroupSize + rightDebt)
                            );
                        };

                        $scope.linkGroupLast = function () {
                            var leftDebt = Math.max(1,
                                $scope.linkGroupSize - ($rootScope.pagination_page - 2)
                            );
                            return Math.min($scope.numPages,
                                $rootScope.pagination_page + ($scope.linkGroupSize + leftDebt)
                            );
                        };

                        $scope.isFinite = function () {
                            return $scope.numPages < Infinity;
                        };

                        function updateLocation() {
                            if ($scope.passive === 'true') {
                                return;
                            }
                            //                            console.log("updateLocation")
                            $location.search('page', $rootScope.pagination_page);
                            $location.search('perPage', $rootScope.perPage);
                        }

                        function requestRange(request) {
                            $log.debug('[paginate-api] requestRange triggered! Source:', request.source || 'Standard Watcher', 'Request:', request);
                            if (!$scope.loadedFilters) {
                                // if (_.isEmpty($scope.filterables) || $scope.filterables === null) {
                                var filterOptions = {
                                    section: section,
                                    site: siteID
                                };
                                if ($rootScope.pagination_storeSectionType) {
                                    filterOptions.sectionType = $rootScope.pagination_storeSectionType;
                                }
                                if (ServiceInject.getFilters) {
                                    ServiceInject.getFilters(filterOptions)
                                        .then(function (response) {
                                            $scope.fieldsFilters = new Array;
                                            $scope.fieldsSort = new Array;
                                            $scope.fieldsGroup = new Array;
                                            $scope.customData = new Array;

                                            if (response.filters) {

                                                _.each(response.filters, function (value, key, list) {
                                                    if (value.field == 'tags') {
                                                        if (!angular.isUndefined(sessionService.site_operative.tags)) {
                                                            angular.forEach(sessionService.site_operative.tags, function (tag) {
                                                                value.values.push({
                                                                    name: tag.tag_name,
                                                                    value: tag.id_tag
                                                                })
                                                            })

                                                            var name = value.name.toLowerCase();

                                                            _.extend(value, {
                                                                selected: []
                                                            });

                                                            var fieldFilterable = new Array;

                                                            fieldFilterable['name'] = value.name.toLowerCase();
                                                            fieldFilterable['selected'] = new Array;

                                                            $scope.fieldsFilters[value.field] = (value);
                                                        }
                                                    } else {
                                                        // value.name = newValuee.name.toLowerCase();
                                                        var name = value.name.toLowerCase();
                                                        _.extend(value, {
                                                            selected: []
                                                        });

                                                        var fieldFilterable = new Array;

                                                        fieldFilterable['name'] = value.name.toLowerCase();
                                                        fieldFilterable['selected'] = new Array;

                                                        // $scope.fieldsFilters.push({ name : value });
                                                        $scope.fieldsFilters[value.field] = (value);

                                                        // $scope.filterables[value.name] = (value);

                                                        // $scope.filters[value.name] = (value);
                                                    }


                                                });
                                                $scope.filters = angular.copy(response.filters);
                                                $scope.fieldsFilters = angular.copy(response.filters);
                                                $scope.mediaZones = angular.copy(response.media_zones);
                                                $scope.customData = angular.copy(response.customData);
                                            } else {
                                                $scope.filters = angular.copy(response);
                                                $scope.fieldsFilters = angular.copy(response);
                                            }

                                            if (response.sort.length > 0) {
                                                _.each(response.sort, function (value, key, list) {
                                                    // value.name = value.name.toLowerCase();
                                                    _.extend(value, {
                                                        order: 'DESC'
                                                    });

                                                    if (value && !angular.isUndefined(value.name)) {
                                                        $scope.fieldsSort[value.name] = (value);
                                                    }

                                                    if (value && !angular.isUndefined(value.is_default) && value.is_default && !$rootScope.sortField) {
                                                        $rootScope.sortField = value.titleId;
                                                    }

                                                });
                                                $scope.fieldsSort = angular.copy(response.sort);

                                            }

                                            if (response.group) {
                                                _.each(response.sort, function (value, key, list) {
                                                    // value.name = value.name.toLowerCase();
                                                    _.extend(value, {
                                                        order: 'DESC'
                                                    });

                                                    $scope.fieldsGroup[value.name] = (value);

                                                });
                                                $scope.fieldsGroup = angular.copy(response.group);


                                            }

                                            if (!angular.isUndefined(response.reference_sections) && ServiceInject.setSubsec) {
                                                ServiceInject.setSubsec(response.reference_sections);
                                            }
                                            if ($scope.mediaZones) {
                                                if ((typeof ServiceInject.setMediaZones == 'function')) {
                                                    ServiceInject.setMediaZones($scope.mediaZones);
                                                }
                                            }

                                            $scope.loadedFilters = true;



                                        });
                                }
                            }

                            $scope.$emit('pagination:loadStart', request);
                            // $scope.numPages = 100;
                            $scope.isLoading = true;

                            var options = {
                                page: request.newPage,
                                resultsPerPage: request.resultsPerPage,
                                url: request.url || $scope.url,
                                siteID: siteID
                            };

                            // Common Options
                            if ($rootScope.sortField) options['sortField'] = $rootScope.sortField;
                            if ($rootScope.SortField) options['SortField'] = $rootScope.SortField;
                            if ($rootScope.sortDir) options['sortDir'] = $rootScope.sortDir;

                            $log.debug('[paginate-api] Request options constructed:', options);
                            if (request.searchStringFilter) options['searchStringFilter'] = request.searchStringFilter;
                            if (request.filters) options['filters'] = request.filters;

                            // Content
                            if (section) options['section'] = section;

                            // Media
                            if (filterByMediaType) options['media_type'] = filterByMediaType;

                            // Media Galleries
                            if ($rootScope.pagination_galleryIds) options['galleryIds'] = $rootScope.pagination_galleryIds;

                            if ($rootScope.pagination_isLightbox) options['isLightbox'] = $rootScope.pagination_isLightbox;

                            // User Groups
                            if ($rootScope.pagination_groupIds) options['groupIds'] = $rootScope.pagination_groupIds;
                            if ($rootScope.pagination_ingroupStatus) options['ingroupStatus'] = $rootScope.pagination_ingroupStatus;

                            // Users In Group
                            if ($scope.includeAllGroups) options['allGroups'] = $scope.includeAllGroups;

                            // Store Orders
                            if ($rootScope.pagination_storeDatesFilter) options['storeDatesFilter'] = $rootScope.pagination_storeDatesFilter;
                            if ($rootScope.pagination_storeSectionType) options['storeSectionType'] = $rootScope.pagination_storeSectionType;

                            if (siteID !== undefined) {

                                //                                console.log(options)
                                // ServiceInject.get({
                                // 		// domain: siteID,
                                // 		// name: content,
                                // 		page: request.newPage,
                                // 		section: section,
                                // 		paginate: request.paginate,
                                // 		// filters: request.filters,
                                // 		sortField: $rootScope.sortField,
                                // 		searchStringFilter: request.searchStringFilter,

                                // 		siteID: siteID
                                // 	})
                                if ($rootScope.subdomainFilter) {
                                    options.id_template = $rootScope.subdomainFilter;
                                }
                                ServiceInject.get(options)
                                    .then(

                                        function (response) {
                                            $scope.hasLoaded = true;
                                            $scope.medialist = [];
                                            if ($rootScope.add) {
                                                $scope.collection = $scope.collection.concat(response.data || response.result.data);
                                                $rootScope.add = false;
                                            } else {
                                                $scope.collection = response.data || response.result.data;
                                            }
                                            if (!angular.isUndefined(response.result)) {
                                                var data = response.result;
                                            } else if (!angular.isUndefined(response.data)) {
                                                var data = response;
                                            }

                                            $scope.columns = response.ref;

                                            if ($attrs.groupby) {
                                                $scope.columnsGrouped = _.groupBy($scope.columns, function (m) {
                                                    return m[$attrs.groupby];
                                                });

                                                // console.log('$scope.columnsGrouped', $scope.columnsGrouped);
                                            }

                                            // if(!angular.isUndefined(response.result)){
                                            // 	$scope.totalItems = response.total
                                            // }else if(!angular.isUndefined(response.result.total)){
                                            // 	$scope.totalItems = response.result.total;
                                            // }
                                            $scope.totalItems = data.total;


                                            $rootScope.pagination_totalItems = data.total;
                                            //                                            console.log(data)
                                            //                                            console.log($rootScope.pagination_totalItems)
                                            $scope.from = data.from;
                                            $rootScope.pagination_from = data.from || 0;
                                            $scope.to = data.to;
                                            $rootScope.pagination_to = data.to;
                                            $rootScope.pagination_current_page = data.current_page || 0;
                                            // $rootScope.pagination_page = response.current_page || response.result.current_page;
                                            $scope.last_page = data.last_page;
                                            $rootScope.pagination_total_pages = data.last_page;
                                            // $scope.currentPage = data.current_page;
                                            $scope.maxSize = 500;
                                            $scope.bigTotalItems = 175;
                                            $scope.isLoading = false;

                                            // $scope.numPages = Math.ceil($scope.numItems / ($rootScope.perPage || defaultPerPage));
                                            $scope.numPages = data.last_page;


                                            $scope.$emit('pagination:loadPage');
                                            $scope.preventFiltering = false;

                                            // allow the UI to catch up first
                                            // $timeout(function() {
                                            //     $scope.isLoading = false;
                                            //     $scope.isBusy = false;
                                            // });
                                            // $scope.bigCurrentPage = 1;
                                        })

                            } else {
                                // alert("no")
                                ServiceInject.get({
                                    // domain: siteID,
                                    // name: content,
                                    page: request.newPage,
                                    siteID: siteID,
                                    section: section,
                                    // filter: searchStringFilter
                                    // lang: get("language")
                                }, function (data, status, headers, config) {

                                    // var response = parseRange(headers('Content-Range'));
                                    // if(status === 204 || (response && response.total === 0)) {
                                    //   $scope.numItems = 0;
                                    //   $scope.collection = [];
                                    // } else {
                                    //   $scope.numItems = response ? response.total : data.result.data.length;
                                    $scope.collection = data.data && data.result.data || [];

                                    $scope.isLoading = false;
                                    // }

                                    // if(response) {
                                    // $scope.rangeFrom = response.from;
                                    // $scope.rangeTo   = response.to;
                                    // if(length(response) < response.total) {
                                    //   if(
                                    //     ( request.to < response.total - 1) ||
                                    //     (response.to < response.total - 1 && response.total < request.to)
                                    //   ) {
                                    //     if(!$rootScope.perPage || length(response) < $rootScope.perPage) {
                                    //       if($scope.autoPresets) {
                                    //         var idx = quantizedIndex(length(response));
                                    //         if(quantizedNumber(idx) > length(response)) {
                                    //           idx--;
                                    //         }
                                    //         $scope.serverLimit = quantizedNumber(idx);
                                    //       } else {
                                    //         $scope.serverLimit = length(response);
                                    //       }
                                    //       $rootScope.perPage = $scope.Math.min(
                                    //         $scope.serverLimit,
                                    //         $scope.clientLimit
                                    //       );
                                    //     }
                                    //   }
                                    // }
                                    // }

                                }, function (e) {
                                    // alert("Database connection error")
                                    // deferred.reject();
                                });

                            }

                            // $http({
                            //   method: 'GET',
                            //   url: 'http://v3-api.qiusystem.local/api/v1/admin/domains',
                            //   // params: $scope.urlParams,
                            //   params: {page:request.newPage},
                            //   headers: angular.extend(
                            //     {}, $scope.headers,
                            //     { 'Range-Unit': 'items', Range: [request.from, request.to].join('-') }
                            //   ),
                            //   transformResponse: appendTransform($http.defaults.transformResponse, $scope.transformResponse)
                            // }).success(function (data, status, headers, config) {
                            //   var response = parseRange(headers('Content-Range'));
                            //   if(status === 204 || (response && response.total === 0)) {
                            //     $scope.numItems = 0;
                            //     $scope.collection = [];
                            //   } else {
                            //     $scope.numItems = response ? response.total : data.result.data.length;
                            //     $scope.collection = data.result.data || [];
                            //   }

                            //   if(response) {
                            //     $scope.rangeFrom = response.from;
                            //     $scope.rangeTo   = response.to;
                            //     if(length(response) < response.total) {
                            //       if(
                            //         ( request.to < response.total - 1) ||
                            //         (response.to < response.total - 1 && response.total < request.to)
                            //       ) {
                            //         if(!$rootScope.perPage || length(response) < $rootScope.perPage) {
                            //           if($scope.autoPresets) {
                            //             var idx = quantizedIndex(length(response));
                            //             if(quantizedNumber(idx) > length(response)) {
                            //               idx--;
                            //             }
                            //             $scope.serverLimit = quantizedNumber(idx);
                            //           } else {
                            //             $scope.serverLimit = length(response);
                            //           }
                            //           $rootScope.perPage = $scope.Math.min(
                            //             $scope.serverLimit,
                            //             $scope.clientLimit
                            //           );
                            //         }
                            //       }
                            //     }
                            //   }
                            //   $scope.numPages = Math.ceil($scope.numItems / ($rootScope.perPage || defaultPerPage));
                            //   $scope.numPages = 10;

                            //   $scope.$emit('pagination:loadPage', status, config);
                            // }).error(function (data, status, headers, config) {
                            //   $scope.$emit('pagination:error', status, config);
                            // });
                            // $http({
                            //   method: 'GET',
                            //   url: $scope.url,
                            //   params: $scope.urlParams,
                            //   headers: angular.extend(
                            //     {}, $scope.headers,
                            //     { 'Range-Unit': 'items', Range: [request.from, request.to].join('-') }
                            //   ),
                            //   transformResponse: appendTransform($http.defaults.transformResponse, $scope.transformResponse)
                            // }).success(function (data, status, headers, config) {
                            //   var response = parseRange(headers('Content-Range'));
                            //   if(status === 204 || (response && response.total === 0)) {
                            //     $scope.numItems = 0;
                            //     $scope.collection = [];
                            //   } else {
                            //     $scope.numItems = response ? response.total : data.length;
                            //     $scope.collection = data || [];
                            //   }

                            //   if(response) {
                            //     $scope.rangeFrom = response.from;
                            //     $scope.rangeTo   = response.to;
                            //     if(length(response) < response.total) {
                            //       if(
                            //         ( request.to < response.total - 1) ||
                            //         (response.to < response.total - 1 && response.total < request.to)
                            //       ) {
                            //         if(!$rootScope.perPage || length(response) < $rootScope.perPage) {
                            //           if($scope.autoPresets) {
                            //             var idx = quantizedIndex(length(response));
                            //             if(quantizedNumber(idx) > length(response)) {
                            //               idx--;
                            //             }
                            //             $scope.serverLimit = quantizedNumber(idx);
                            //           } else {
                            //             $scope.serverLimit = length(response);
                            //           }
                            //           $rootScope.perPage = $scope.Math.min(
                            //             $scope.serverLimit,
                            //             $scope.clientLimit
                            //           );
                            //         }
                            //       }
                            //     }
                            //   }
                            //   $scope.numPages = Math.ceil($scope.numItems / ($rootScope.perPage || defaultPerPage));
                            //   $scope.numPages = 10;

                            //   $scope.$emit('pagination:loadPage', status, config);
                            // }).error(function (data, status, headers, config) {
                            //   $scope.$emit('pagination:error', status, config);
                            // });
                        }

                        $rootScope.pagination_page = $rootScope.pagination_page || 0;
                        $scope.size = $scope.size || 'md';
                        if ($scope.autoPresets) {
                            $scope.updatePresets();
                        }


                        // $rootScope.$watch($attrs.filters, function (newPage, oldPage) {

                        // 	alert("ok")
                        // });

                        $scope.watchers = [];
                        $scope.watchers.push($scope.$watch('fieldsFilters', function (newFilter, oldFilter) {

                            if (newFilter !== oldFilter && !angular.isUndefined(oldFilter)) {
                                $scope.preventFiltering = true;
                                $rootScope.pagination_page = 1;

                                _.each($scope.fieldsFilters, function (value, key, list) {
                                    if ($scope.fieldsFilters[key]['selected'].length > 0) {
                                        $rootScope.pagination_searchquery = true;
                                        $mdSidenav($scope.menuFiltersID)
                                            .toggle();
                                    }
                                });
                                updateLocation();
                                //                                console.log("change Filters")
                                $rootScope.filters = $scope.fieldsFilters
                                requestRange({
                                    from: $rootScope.pagination_page,
                                    resultsPerPage: $rootScope.perPage,
                                    filters: $scope.fieldsFilters
                                });
                            }
                            // vm.live.rowJson = angular.toJson(vm.live.row, true);
                        }, true));

                        $scope.watchers.push($rootScope.$watch('pagination_searchquery', function (newSearch, oldSearch) { }));
                        $scope.watchers.push($scope.$watch('fieldsSearch', function (newSearch, oldSearch) {



                            // if (newFilter !== oldFilter && !angular.isUndefined(oldFilter)) {
                            // 	$scope.preventFiltering = true;
                            // 	$rootScope.pagination_page = 1;
                            // 	updateLocation();
                            // 	requestRange({
                            // 		from: $rootScope.pagination_page,
                            // 		paginate: $rootScope.perPage,
                            // 		filters: $scope.fieldsFilters
                            // 	});
                            // }
                            // vm.live.rowJson = angular.toJson(vm.live.row, true);
                        }, true));

                        // $rootScope.$watch('sortDir', function (newSortDir, oldSort) {
                        // 	console.log(newSortDir)
                        // 	console.log(oldSort)

                        // 	if (newSortDir !== oldSort && !angular.isUndefined(oldSort)) {

                        // 		$scope.preventFiltering = true;
                        // 		$rootScope.pagination_page = 1;
                        // 		updateLocation();
                        // 		requestRange({
                        // 			from: $rootScope.pagination_page,
                        // 			resultsPerPage: $rootScope.perPage,
                        // 			filters: $scope.fieldsFilters,
                        // 			sortDir: newSortDir
                        // 		});
                        // 	}
                        // 	// vm.live.rowJson = angular.toJson(vm.live.row, true);
                        // }, true);

                        $scope.watchers.push($rootScope.$watch('pagination_page', function (newPage, oldPage) {
                            if ($scope.passive === 'true') {
                                return;
                            }
                            //                            console.log("oldPage_:" + oldPage)
                            //                            console.log("newPage_:" + newPage)
                            if (newPage !== oldPage && $scope.preventFiltering !== true) {
                                if (newPage < 0 || newPage * $rootScope.perPage >= $scope.numItems) {
                                    return;
                                }

                                var pp = $rootScope.perPage || defaultPerPage;

                                if ($scope.autoPresets) {
                                    pp = quantize(pp);
                                }
                                updateLocation();
                                //                                console.log("change pagination_page")
                                requestRange({
                                    from: newPage * pp,
                                    to: (newPage + 1) * pp - 1,
                                    newPage: newPage,
                                    paginate: $rootScope.perPage,
                                    filters: $scope.fieldsFilters,
                                    sort: $rootScope.sortField,
                                    resultsPerPage: $rootScope.perPage,
                                    searchStringFilter: $rootScope.pagination_searchstring
                                });
                            }
                        }));

                        $scope.watchers.push($rootScope.$watch('perPage', function (newPp, oldPp) {
                            if ($scope.passive === 'true') {
                                return;
                            }
                            //                            console.log(newPp)
                            if (typeof (oldPp) === 'number' && newPp !== oldPp) {
                                var first = $rootScope.pagination_page * oldPp;
                                var newPage = Math.floor(first / newPp);

                                // if($rootScope.pagination_page !== newPage) {
                                //   $rootScope.pagination_page = newPage;
                                // } else {
                                //   alert("nre")
                                //                                console.log("change perPage")
                                requestRange({
                                    from: $rootScope.pagination_page * newPp,
                                    to: ($rootScope.pagination_page + 1) * newPp - 1,
                                    resultsPerPage: newPp,
                                    newPage: 1,
                                    filters: $scope.fieldsFilters,
                                    sort: $rootScope.sortField,
                                    searchStringFilter: $rootScope.pagination_searchstring
                                });
                                // }
                            }
                        }));

                        $scope.watchers.push($scope.$watch('serverLimit', function (newLimit, oldLimit) {
                            if ($scope.passive === 'true') {
                                return;
                            }

                            if (newLimit !== oldLimit) {
                                $scope.updatePresets();
                            }
                        }));

                        $scope.watchers.push($scope.$watch('url', function (newUrl, oldUrl) {
                            if ($scope.passive === 'true') {
                                return;
                            }

                            if (newUrl !== oldUrl) {
                                if ($rootScope.pagination_page === 0) {
                                    $scope.reloadPage = true;
                                } else {
                                    $rootScope.pagination_page = 1;
                                }
                            }
                        }));

                        $scope.watchers.push($scope.$watch('urlParams', function (newParams, oldParams) {
                            if ($scope.passive === 'true') {
                                return;
                            }

                            if (!angular.equals(newParams, oldParams)) {
                                if ($rootScope.pagination_page === 0) {
                                    $scope.reloadPage = true;
                                } else {
                                    $rootScope.pagination_page = 1;
                                }
                            }
                        }, true));

                        $scope.watchers.push($scope.$watch('headers', function (newHeaders, oldHeaders) {
                            if ($scope.passive === 'true') {
                                return;
                            }

                            if (!angular.equals(newHeaders, oldHeaders)) {
                                if ($rootScope.pagination_page === 0) {
                                    $scope.reloadPage = true;
                                } else {
                                    $rootScope.pagination_page = 1;
                                }
                            }
                        }, true));

                        $scope.watchers.push($scope.$watch('reloadPage', function (newVal, oldVal) {
                            if ($scope.passive === 'true') {
                                return;
                            }

                            if (newVal === true && oldVal === false) {
                                $scope.reloadPage = false;
                                //                                console.log("change reloadPage")

                                requestRange({
                                    from: $rootScope.pagination_page * $rootScope.perPage,
                                    to: ($rootScope.pagination_page + 1) * $rootScope.perPage - 1
                                });
                            }
                        }));


                        // $scope.$watch(
                        //                function watchFoo( scope ) {
                        //                    // Return the "result" of the watch expression.
                        //                    return( $scope.filterables );
                        //                },
                        //                function handleFooChange( newValue, oldValue ) {
                        //                }
                        //            , true);

                        $scope.watchers.push($scope.$watch('transformResponse', function (newTransform, oldTransform) {
                            if ($scope.passive === 'true') {
                                return;
                            }
                            if (!newTransform || !oldTransform) {
                                return;
                            }

                            // If applying a transform to returned data, it makes sense to start at the first page if changed
                            // Unfortunately it's not really possible to compare function equality
                            // In lieu of that, for now we'll compare string representations of them.
                            if (!angular.equals(newTransform.toString(), oldTransform.toString())) {
                                if ($rootScope.pagination_page === 0) {
                                    $scope.reloadPage = true;
                                } else {
                                    $rootScope.pagination_page = 1;
                                }
                            }
                        }, true));

                        $scope.$on('pagination:reload', function (event, data) {
                            $log.debug('[paginate-api] pagination:reload event received:', data);
                            $rootScope.pagination_searchstring = data.query;
                            $rootScope.pagination_searchquery = !!data.query;
                            $rootScope.pagination_page = 1;
                            updateLocation();
                            requestRange({
                                source: 'pagination:reload event',
                                from: $rootScope.pagination_page,
                                resultsPerPage: $rootScope.perPage,
                                filters: $scope.fieldsFilters,
                                sort: $rootScope.sortField,
                                searchStringFilter: data.query,
                                url: data.url || $scope.url
                            });
                        });

                        $scope.$on('$destroy', function () {
                            for (var i = 0; i < $scope.watchers.length; ++i) {
                                if (typeof $scope.watchers[i] === 'function') {
                                    $scope.watchers[i]();
                                }
                            }
                        });

                        var pp = $rootScope.perPage || defaultPerPage;

                        if ($scope.autoPresets) {
                            pp = quantize(pp);
                        }

                        //                        console.log("initial request")

                        requestRange({
                            from: $rootScope.pagination_page * pp,
                            to: ($rootScope.pagination_page + 1) * pp - 1,
                            resultsPerPage: $rootScope.perPage,
                            newPage: $rootScope.pagination_page

                        });
                    }
                ]
            };
        })
        .

        filter('makeRange', function () {
            // http://stackoverflow.com/a/14932395/3102996
            return function (input) {
                var lowBound, highBound;
                switch (input.length) {
                    case 1:
                        lowBound = 0;
                        highBound = parseInt(input[0], 10) - 1;
                        break;
                    case 2:
                        lowBound = parseInt(input[0], 10);
                        highBound = parseInt(input[1], 10);
                        break;
                    default:
                        return input;
                }
                var result = [];
                for (var i = lowBound; i <= highBound; i++) {
                    result.push(i);
                }
                return result;
            };
        });


    function parseRange(hdr) {
        var m = hdr && hdr.match(/^(?:items )?(\d+)-(\d+)\/(\d+|\*)$/);
        if (m) {
            return {
                from: +m[1],
                to: +m[2],
                total: m[3] === '*' ? Infinity : +m[3]
            };
        } else if (hdr === '*/0') {
            return {
                total: 0
            };
        }
        return null;
    }

    function length(range) {
        return range.to - range.from + 1;
    }
}());

// angular.module('bgf.paginateAnything').run(['$templateCache', function($templateCache) {
//   'use strict';

//   $templateCache.put('src/paginate-anything.html',
//     "<div class=paginate-anything><ul class=\"pagination pagination-{{size}} links\" ng-if=\"numPages > 1\"><li ng-class=\"{disabled: page <= 0}\"><a href ng-click=gotoPage(page-1)>&laquo;</a></li><li ng-if=\"linkGroupFirst() > 0\"><a href ng-click=gotoPage(0)>1</a></li><li ng-if=\"linkGroupFirst() > 1\" class=disabled><a href>&hellip;</a></li><li ng-repeat=\"p in [linkGroupFirst(), linkGroupLast()] | makeRange\" ng-class=\"{active: p === page}\"><a href ng-click=gotoPage(p)>{{p+1}}</a></li><li ng-if=\"linkGroupLast() < numPages - 2\" class=disabled><a href>&hellip;</a></li><li ng-if=\"isFinite() && linkGroupLast() < numPages - 1\"><a href ng-click=gotoPage(numPages-1)>{{numPages}}</a></li><li ng-class=\"{disabled: page >= numPages - 1}\"><a href ng-click=gotoPage(page+1)>&raquo;</a></li></ul><div class=per-page ng-if=\"perPagePresets.length > 0 && numPages > 1\"><select ng-model=$parent.perPage ng-options=\"p for p in perPagePresets\"></select>per page</div></div>"
//   );

// }]);

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function () {
    'use strict';

    /**
     * <mv-grid> — rejilla editable tipo Excel, COMPARTIDA entre módulos (users, content…).
     *
     * Aporta todo lo genérico: armazón de tabla (colgroup + table-layout:fixed para que
     * cabecera y celdas cuadren), cabecera sticky, redimensionar y reordenar columnas
     * arrastrando, persistencia de anchos/orden en los settings del usuario, e
     * indicadores de guardado por fila.
     *
     * Lo ESPECÍFICO de cada módulo se inyecta desde fuera:
     *   - `cell-template`: URL de la plantilla que pinta el editor de cada celda. Dentro
     *     tiene disponibles `row`, `col` y `host` (el controlador del módulo), así que
     *     hace su propia cadena de ng-if sobre host.cellKind(col).
     *   - `fixed-columns`: columnas fijas propias del módulo (p.ej. "Grupos" en users),
     *     cada una {label, width, cellTemplate}.
     *
     * Ejemplo:
     *   <mv-grid rows="vm.threads" columns="vm.refcolumns" host="vm"
     *            settings-key="{{vm.settingsSection}}" sort-field="table_list_sort"
     *            cell-template="app/main/apps/users/views/list/grid-cells.html"
     *            row-init="vm.ensureGridRow(row)"></mv-grid>
     */
    angular
        .module('app.core')
        .directive('mvGrid', MvGrid)
        .directive('mvGridColResize', ['$document', MvGridColResize])
        .directive('mvGridColDrag', [MvGridColDrag]);

    function MvGrid() {
        return {
            restrict: 'E',
            templateUrl: 'app/core/directives/mv-grid/mv-grid.html',
            scope: {
                rows: '=',
                columns: '=',
                host: '=',
                loading: '=?',
                settingsKey: '@',
                sortField: '@',
                cellTemplate: '@',
                emptyText: '@',
                fixedColumns: '=?',
                columnWidth: '&?',
                rowInit: '&?',
                newRowInit: '&?',
                onNewRowSave: '&?',
                isSelected: '&?',
                onToggleSelect: '&?',
                api: '=?'
            },
            bindToController: true,
            controllerAs: 'grid',
            controller: ['$scope', '$q', 'settingUserService', MvGridController]
        };
    }

    /** @ngInject */
    function MvGridController($scope, $q, settingUserService) {
        var grid = this;

        /**
         * Con bindToController los bindings se asignan al CONTROLADOR (grid.host), no al
         * scope. Las plantillas de celda de cada módulo usan `host.` a secas (se leen
         * mucho mejor), así que lo publicamos también en el scope para que lo hereden los
         * scopes hijos que crea cada ng-include de celda.
         * Va en $onInit y no en el constructor porque en AngularJS 1.6 los bindings aún
         * NO están asignados cuando se construye el controlador.
         */
        grid.$onInit = function () {
            $scope.host = grid.host;
            // Las columnas fijas pueden ir al principio (por defecto) o al final
            // (position: 'end'), que es donde toca poner las acciones tipo borrar.
            // Se reparten UNA vez: filtrar en la plantilla crearia un array nuevo en cada
            // digest y ng-repeat se reconstruiria sin parar.
            // API hacia el modulo: permite que su boton "NUEVO" de la barra abra la fila
            // borrador de la rejilla en vez de intentar pintar el formulario (que en esta
            // vista no existe).
            grid.api = {
                startNewRow: startNewRow,
                cancelNewRow: cancelNewRow,
                isCreating: function () { return !!grid.newRow; }
            };
            var fixed = grid.fixedColumns || [];
            grid.fixedStart = fixed.filter(function (f) { return f && f.position !== 'end'; });
            grid.fixedEnd = fixed.filter(function (f) { return f && f.position === 'end'; });
        };

        // Ancho de la columna de estado de guardado (la única fija que aporta la rejilla).
        var STATUS_W = 44;

        grid.colKey = colKey;
        grid.startNewRow = startNewRow;
        grid.cancelNewRow = cancelNewRow;
        grid.saveNewRow = saveNewRow;
        grid.gridColumns = gridColumns;
        grid.totalWidth = totalWidth;
        grid.moveColumn = moveColumn;
        grid.persistWidths = persistWidths;
        grid.initRow = initRow;

        /**
         * Identidad estable de una columna. Se usa como `track by`, como clave de los
         * anchos guardados y para el reordenado.
         * OJO: `title` NO siempre es único — en algunas secciones el _ref trae dos filas
         * con el mismo title (visto en section_schedule_ref: `id_subsec` dos veces), y
         * usarlo como track by rompería el ng-repeat. Por eso mandamos id_ref si existe.
         */
        function colKey(col) {
            if (!col) { return ''; }
            return (col.id_ref !== null && col.id_ref !== undefined) ? ('r' + col.id_ref) : ('t' + col.title);
        }

        /**
         * Columnas visibles, ordenadas y con su ancho aplicado. Devuelve una referencia
         * ESTABLE (cacheada contra el array de origen) para no reconstruir la cabecera en
         * cada digest.
         */
        function gridColumns() {
            var src = grid.columns;
            if (!src) { return []; }
            if (grid._colsSrc === src && grid._cols) { return grid._cols; }

            var cols = src.filter(function (c) { return c && c.type !== 'label'; });

            // Orden: primero el personalizado del usuario (arrastrando cabeceras, guardado
            // en settings); si no hay, el campo de orden del _ref que indique el módulo
            // (table_list_sort en users, list_sort en content).
            if (grid._order === undefined) {
                grid._order = grid.settingsKey
                    ? settingUserService.getSettingValue(grid.settingsKey, 'mvGridColOrder', null)
                    : null;
            }
            var sortFieldName = grid.sortField || 'list_sort';
            var sortKey = function (c) {
                var v = parseInt(c[sortFieldName], 10);
                return isNaN(v) ? 9999 : v;
            };
            var order = (grid._order && grid._order.length) ? grid._order : null;
            cols.sort(function (a, b) {
                if (order) {
                    var ai = order.indexOf(colKey(a)); if (ai < 0) { ai = 9999; }
                    var bi = order.indexOf(colKey(b)); if (bi < 0) { bi = 9999; }
                    if (ai !== bi) { return ai - bi; }
                }
                return sortKey(a) - sortKey(b);
            });

            // Ancho: el guardado por el usuario; si no, el que decida el módulo; si no, el
            // genérico por tipo.
            var saved = (grid.settingsKey
                ? settingUserService.getSettingValue(grid.settingsKey, 'mvGridColWidths', {})
                : {}) || {};
            cols.forEach(function (c) {
                if (c.$width == null) {
                    var k = colKey(c);
                    var w = (saved[k] != null) ? parseInt(saved[k], 10) : null;
                    if (w && !isNaN(w)) {
                        c.$width = w;
                    } else {
                        var custom = grid.columnWidth ? grid.columnWidth({ col: c }) : null;
                        c.$width = (custom && !isNaN(custom)) ? custom : defaultColWidth(c);
                    }
                }
            });

            grid._cols = cols;
            grid._colsSrc = src;
            return cols;
        }

        // Ancho inicial (px) por tipo. Solo es el punto de partida: el usuario redimensiona.
        function defaultColWidth(col) {
            if (!col) { return 150; }
            var t = col.type || '';
            if (t === 'id') { return 80; }
            if (t === 'status' || t === 'onoff' || t === 'user_status') { return 80; }
            if (t === 'thumbnail' || t.indexOf('thumbnail') === 0) { return 90; }
            if (t === 'date' || t === 'dateHm' || t.indexOf('datetime') === 0) { return 160; }
            return 150;
        }

        /**
         * Ancho total explícito de la tabla = columna de estado + columnas fijas del módulo
         * + suma de las de datos. Hay que fijarlo (en vez de max-content) para que
         * table-layout:fixed respete el ancho de cada <col>.
         */
        function totalWidth() {
            var total = STATUS_W;
            angular.forEach(grid.fixedColumns, function (fc) {
                total += parseInt(fc.width, 10) || 150;
            });
            var cols = gridColumns();
            for (var i = 0; i < cols.length; i++) {
                total += parseInt(cols[i].$width, 10) || 150;
            }
            return total + 'px';
        }

        /**
         * Reordena una columna soltándola sobre otra. Arrastrando a la DERECHA se inserta
         * DESPUÉS del destino y a la izquierda ANTES, para que caiga justo donde se suelta
         * (si no, hacia la derecha se queda una posición corta).
         */
        function moveColumn(from, to) {
            if (!from || !to || from === to) { return; }
            var cols = grid._cols || gridColumns();
            var order = cols.map(colKey);
            var fi = order.indexOf(from);
            var tiOrig = order.indexOf(to);
            if (fi < 0 || tiOrig < 0) { return; }
            var draggingRight = fi < tiOrig;
            order.splice(fi, 1);
            var ti = order.indexOf(to);
            if (ti < 0) { ti = order.length; }
            order.splice(draggingRight ? ti + 1 : ti, 0, from);
            grid._order = order;
            grid._cols = null;      // invalida caché -> rebuild con el nuevo orden
            grid._colsSrc = null;
            if (grid.settingsKey) {
                settingUserService.setSetting(grid.settingsKey, 'mvGridColOrder', order);
            }
        }

        // Guarda los anchos actuales en los settings del usuario (persistidos en backend).
        function persistWidths() {
            if (!grid.settingsKey) { return; }
            var map = {};
            var cols = grid._cols || [];
            for (var i = 0; i < cols.length; i++) {
                if (cols[i].$width != null) { map[colKey(cols[i])] = cols[i].$width; }
            }
            settingUserService.setSetting(grid.settingsKey, 'mvGridColWidths', map);
        }

        // --- Fila NUEVA (borrador) -------------------------------------------------
        // Se pinta ENCIMA de la cabecera y no existe en la base de datos: no se guarda
        // nada hasta que se pulsa confirmar. Cancelar la descarta sin dejar rastro.
        // Los editores de celda son los mismos que los de una fila normal; sus guardados
        // automaticos no hacen nada porque la fila aun no tiene id (los modulos ya
        // comprueban el id antes de guardar).
        // `draft` opcional: si viene, se usa tal cual como fila nueva (asi es como
        // "duplicar" abre el alta con los datos ya rellenados). Si no, se piden los
        // valores por defecto al modulo.
        function startNewRow(draft) {
            if (grid.newRow) { return; }
            grid.newRowError = null;
            $q.when(draft || (grid.newRowInit ? grid.newRowInit() : {})).then(function (draft) {
                grid.newRow = draft || {};
                grid.newRow.$isNew = true;
                if (grid.rowInit) { grid.rowInit({ row: grid.newRow }); }
            });
        }

        function cancelNewRow() {
            grid.newRow = null;
            grid.newRowError = null;
            grid.newRowSaving = false;
        }

        function saveNewRow() {
            if (!grid.newRow || grid.newRowSaving || !grid.onNewRowSave) { return; }
            grid.newRowSaving = true;
            grid.newRowError = null;
            $q.when(grid.onNewRowSave({ row: grid.newRow })).then(function () {
                grid.newRowSaving = false;
                grid.newRow = null;
            }, function (err) {
                // Se mantiene la fila con lo escrito para poder corregir y reintentar.
                grid.newRowSaving = false;
                grid.newRowError = (err && err.message) || true;
            });
        }

        // Preparación de la fila delegada en el módulo (expandir json, formatear fechas…).
        function initRow(row) {
            if (grid.rowInit) { grid.rowInit({ row: row }); }
        }
    }

    /**
     * Redimensiona una columna arrastrando el tirador del borde derecho de su cabecera.
     * Actualiza col.$width (px), que el <colgroup> aplica a toda la columna.
     */
    function MvGridColResize($document) {
        return {
            restrict: 'A',
            scope: { colRef: '=', onResizeEnd: '&' },
            link: function (scope, element) {
                element.on('mousedown', function (ev) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    var startX = ev.pageX;
                    var th = element[0].parentElement;
                    var startW = (scope.colRef && scope.colRef.$width)
                        ? scope.colRef.$width
                        : (th ? th.offsetWidth : 150);
                    var moved = false;
                    element.addClass('resizing');
                    // Evita que el th (draggable, para reordenar) inicie un arrastre
                    // mientras se está redimensionando.
                    if (th) { th.setAttribute('draggable', 'false'); }

                    function onMove(e) {
                        moved = true;
                        var w = Math.max(48, startW + (e.pageX - startX));
                        scope.$apply(function () { scope.colRef.$width = w; });
                    }
                    function onUp() {
                        element.removeClass('resizing');
                        if (th) { th.setAttribute('draggable', 'true'); }
                        $document.off('mousemove', onMove);
                        $document.off('mouseup', onUp);
                        if (moved) { scope.$apply(function () { scope.onResizeEnd(); }); }
                    }
                    $document.on('mousemove', onMove);
                    $document.on('mouseup', onUp);
                });
            }
        };
    }

    /**
     * Reordenar columnas arrastrando la cabecera (drag HTML5 nativo). El tirador de resize
     * hace mousedown + preventDefault, así que no inicia arrastre: redimensionar y
     * reordenar no chocan. onColDrop(from, to) lo resuelve el controlador de la rejilla.
     */
    function MvGridColDrag() {
        return {
            restrict: 'A',
            scope: { colRef: '=', colKey: '=', onColDrop: '&' },
            link: function (scope, element) {
                var th = element[0];
                th.setAttribute('draggable', 'true');

                th.addEventListener('dragstart', function (e) {
                    if (!scope.colKey) { e.preventDefault(); return; }
                    e.dataTransfer.effectAllowed = 'move';
                    try { e.dataTransfer.setData('text/plain', scope.colKey); } catch (err) {}
                    th.classList.add('col-dragging');
                });
                th.addEventListener('dragend', function () {
                    th.classList.remove('col-dragging');
                });
                th.addEventListener('dragover', function (e) {
                    e.preventDefault();
                    e.dataTransfer.dropEffect = 'move';
                    th.classList.add('col-dragover');
                });
                th.addEventListener('dragleave', function () {
                    th.classList.remove('col-dragover');
                });
                th.addEventListener('drop', function (e) {
                    e.preventDefault();
                    th.classList.remove('col-dragover');
                    var from = '';
                    try { from = e.dataTransfer.getData('text/plain'); } catch (err) {}
                    var to = scope.colKey;
                    if (from && to && from !== to) {
                        scope.$apply(function () { scope.onColDrop({ from: from, to: to }); });
                    }
                });
            }
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                loadMore: '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element('#content');
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('msSocialWidgetShare', msSocialWidgetShareDirective);

    var controller = ['$scope', 'requestContext', 'mediaService', '$mdDialog', '$mdToast',
        'sessionService', '$window', 'matchCenterService', function ($scope, requestContext, mediaService, $mdDialog, $mdToast,
            sessionService, $window, matchCenterService) {

            var vm = this;
            vm.isSelected = isSelected;
            vm.toggleNetwork = toggleNetwork;
            vm.loadPages = loadPages;
            vm.addSocialNetworkPage = addSocialNetworkPage;
            vm.share = share;
            vm.publish = publish;
            vm.closeDialog = closeDialog;
            vm.siteID = requestContext.getParam("siteId");


            vm.$onInit = function () {
            }
            $scope.$watch('medias', function (newVal, oldVal) {
            });

            vm.socialPages = [];
            vm.socialPagesSelected = [];

            vm.loadPages();

            function closeDialog(){
                $scope.onclose();
            }

            function loadPages() {
                matchCenterService.getTokensSocial({ "siteID": vm.siteID }).then(function (response) {
                    vm.socialPages = response.data;
                });
            }

            function share() {
                // if ($scope.media) {
                // $scope.isLoadingPost = true;
                vm.publish();
                // } else {
                //     $scope.isLoadingPost = true;
                //     var options = {
                //         "siteID": siteID,
                //         "withCropStatus": false,
                //         "withFilters": false,
                //         "withGalleries": false,
                //         "withTags": false,
                //         "extra": vm.extra
                //     };
                //     mediaService.get(options).then(function (response) {
                //         if (response.data.length > 0) {
                //             vm.id_media = response.data[0].id_media;
                //             vm.publish();
                //         } else {
                //             $scope.timeout2 = setTimeout(() => {
                //                 share();
                //             }, 5000);
                //         }
                //     })
                // }
            }

            function publish() {
                var options = {
                    siteID: vm.siteID,
                    item: {
                        media: $scope.medias,
                        title: vm.title,
                        message: vm.message,
                        related: {
                            "service": $scope.service,
                            "media_type": "files",
                            "section": $scope.section,
                            "id": $scope.idcontent
                        }
                    }
                }
                var count = 0;
                for (let i = 0; i < vm.socialPagesSelected.length; i++) {
                    const socialPage = vm.socialPagesSelected[i];
                    count++;
                    var opt = angular.copy(options);
                    opt.item.id_social_account = socialPage.id_social_account;
                    matchCenterService.shareSocial(opt).then(function (response) {
                        count--;
                        if (count == 0) {
                            $scope.isLoadingPost = false;
                            $mdToast.show({
                                template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg"><md-icon md-font-icon="icon-check" class="icon"></md-icon><span class="md-toast-text" flex>Published Correctly!</span></div></md-toast>',
                                hideDelay: 5000,
                                position: 'top',
                                parent: '#content-container',
                                theme: "success-toast"
                            });
                            $mdDialog.hide();
                        }
                    })

                }
            }
            function isSelected(socialItem) {
                return vm.socialPagesSelected.indexOf(socialItem) >= 0;
            }
            function toggleNetwork(socialItem) {
                if (isSelected(socialItem)) {
                    vm.socialPagesSelected.splice(vm.socialPagesSelected.indexOf(socialItem), 1);
                } else {
                    vm.socialPagesSelected.push(socialItem);
                }
            }
            function addSocialNetworkPage(ev) {
                $mdDialog.show({
                    controller: 'SocialDialogController',
                    controllerAs: 'vm',
                    locals: {
                    },
                    templateUrl: 'app/core/directives/ms-social-widget-share/social-dialog/social-dialog.html',
                    targetEvent: ev,
                    multiple: true,
                    clickOutsideToClose: false
                }).then(function (response) {
                    if (response) {
                        vm.loadPages();
                    }
                });
            }
        }];

    /** @ngInject */
    function msSocialWidgetShareDirective($document) {
        return {
            restrict: 'AE',
            scope: {
                onclose: '&',
                medias: '=',
                service: '=',
                section: '=',
                idcontent: '='
            },
            templateUrl: 'app/core/directives/ms-social-widget-share/ms-social-widget-share.html',
            controller: controller,
            controllerAs: 'vm'
        };
    }
})();


(function() {
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate, $compile, $rootScope) {
        return {
            restrict: 'E',
            link: function(scope, iElement) {
                scope.$on('msSplashScreen::remove', function() {
                    // $animate.fadeOut(iElement).then(function() {
                        // De-register scope event
                        // splashScreenRemoveEvent();
                        // var newHtml = '';

                        // var elem = angular.element(document.getElementById("splash-screen"));
                        // $compile(newHtml)(scope, function(el) {
                        //     elem.html(el);
                        // });
                                                iElement.hide()

                        // Null-ify everything else
                        // scope = iElement = null;
                    });
                // });

                scope.$on('msSplashScreen::add', function(scope) {
                    // $animate.leave(iElement).then(function() {
                        // De-register scope event
                        // splashScreenAddEvent();

                        // var elem = angular.element(document.getElementById("splash-screen"));
                        
                        // var newHtml = '<div class="center"><div class="logo">    <span>Q</span></div><!-- Material Design Spinner --><div class="spinner-wrapper">    <div class="spinner">        <div class="inner">            <div class="gap"></div>            <div class="left">                <div class="half-circle"></div>            </div>            <div class="right">                <div class="half-circle"></div>            </div>        </div>    </div></div><div class="text-loader" ng-bind="loadPageMessage">Loading</div><!-- / Material Design Spinner --></div>';

                        // $compile(newHtml)(scope, function(el) {
                        //     elem.html(el);
                        // });
                        iElement.show()



                        // Null-ify everything else

                    // });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msStepper', msStepperDirective)
        .directive('msStepperStep', msStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element   : element,
                scope     : scope,
                form      : form,
                stepNumber: scope.step || (vm.steps.length + 1),
                stepTitle : scope.stepTitle
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            })
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            // Hide all steps
            for ( var i = 0; i < vm.steps.length; i++ )
            {
                vm.steps[i].element.hide();
            }

            // Show the current step
            vm.steps[vm.currentStepNumber - 1].element.show();
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            vm.setCurrentStep(vm.currentStepNumber - 1);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            vm.setCurrentStep(vm.currentStepNumber + 1);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msStepperDirective()
    {
        return {
            restrict        : 'A',
            require         : ['form', 'msStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        }
    }

    /** @ngInject */
    function msStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msStepper'],
            priority: 1000,
            scope   : {
                step        : '=?',
                stepTitle   : '=?',
                optionalStep: '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('msSocialList', msSocialListDirective);

    var controller = ['$scope', 'requestContext', 'matchCenterService', 'msUtils', function ($scope, requestContext, matchCenterService, msUtils) {

        var vm = this;
        vm.siteID = requestContext.getParam("siteId");
        vm.timeAgo = msUtils.timeAgo;
        vm.deletePost = deletePost;
        vm.loading = true;
        vm.$onInit = function () {
            loadPosts();
        }
        $scope.$watch('medias', function (newVal, oldVal) {
        });

        function loadPosts() {
            matchCenterService.loadPostsSocial({ "siteID": vm.siteID, service: $scope.service, section: $scope.section, id: $scope.idcontent }).then(function (response) {
                vm.socialPosts = response.data;
                vm.loading = false;
            });
            vm.interval = setInterval(() => {
                matchCenterService.loadPostsSocial({ "siteID": vm.siteID, service: $scope.service, section: $scope.section, id: $scope.idcontent }).then(function (response) {
                    if (vm.socialPosts.length != response.data.length) {
                        vm.loading = true;
                        vm.socialPosts = [];
                        setTimeout(() => {
                            vm.socialPosts = response.data;
                            vm.loading = false;
                        }, 200);
                    } else {
                        for (let i = 0; i < vm.socialPosts.length; i++) {
                            vm.socialPosts[i].status = response.data.find(x => x.id_social_post === vm.socialPosts[i].id_social_post).status
                        }
                    }
                })
            }, 3000);
        }


        $scope.$on('$destroy', function () {
            clearInterval(vm.interval);
        });


        function deletePost(post) {
            matchCenterService.deletePostsSocial({ "siteID": vm.siteID, id: post.id_social_post }).then(function (response) {
                loadPosts();
            });
        }



    }];

    /** @ngInject */
    function msSocialListDirective($document) {
        return {
            restrict: 'AE',
            scope: {
                medias: '=',
                service: '=',
                section: '=',
                idcontent: '=',
            },
            templateUrl: 'app/core/directives/ms-social-list/ms-social-list.html',
            controller: controller,
            controllerAs: 'vm'
        };
    }
})();


(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSearchNav', msSearchBarDirective);

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : true,
            templateUrl: 'app/core/directives/ms-search-nav/ms-search-nav.html',
            compile    : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-nav');

                return function postLink(scope, iElement)
                {
                    var expanderEl,
                        collapserEl;

                    // Initialize
                    init();

                    function init()
                    {
                        expanderEl = iElement.find('#ms-search-nav-expander');
                        collapserEl = iElement.find('#ms-search-nav-collapser');

                        expanderEl.on('click', expand);
                        collapserEl.on('click', collapse);
                    }

                    /**
                     * Expand
                     */
                    function expand()
                    {
                        iElement.addClass('expanded');

                        // Esc key event
                        $document.on('keyup', escKeyEvent);
                    }

                    /**
                     * Collapse
                     */
                    function collapse()
                    {
                        iElement.removeClass('expanded');
                    }

                    /**
                     * Escape key event
                     *
                     * @param e
                     */
                    function escKeyEvent(e)
                    {
                        if ( e.keyCode === 27 )
                        {
                            collapse();
                            $document.off('keyup', escKeyEvent);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSearchBarCustom', msSearchBarCustomDirective);

    /** @ngInject */
    function msSearchBarCustomDirective($document)
    {
        return {
            restrict   : 'E',
            scope: {
                modelSearch: '=modelSearch',
                searchClick: '=',
                searchClear: '=',
            },
            templateUrl: 'app/core/directives/ms-search-bar-custom/ms-search-bar-custom.html',
            compile    : function (tElement, attr, trans)
            {
                // Add class
                tElement.addClass('ms-search-bar-custom');

                return function postLink(scope, iElement)
                {
                    var expanderEl,
                        collapserEl;

                    // Initialize
                    init();

                    function init()
                    {
                        expanderEl = iElement.find('#ms-search-bar-expander');
                        collapserEl = iElement.find('#ms-search-bar-collapser');

                        expanderEl.on('click', expand);
                        collapserEl.on('click', collapse);
                    }

                    /**
                     * Expand
                     */
                    function expand()
                    {
                        iElement.addClass('expanded');

                        // Esc key event
                        $document.on('keyup', escKeyEvent);
                    }

                    /**
                     * Collapse
                     */
                    function collapse()
                    {
                        scope.$root.modelSearch = '';
                        iElement.removeClass('expanded');
                    }

                    /**
                     * Escape key event
                     *
                     * @param e
                     */
                    function escKeyEvent(e)
                    {
                        if ( e.keyCode === 27 )
                        {
                            collapse();
                            $document.off('keyup', escKeyEvent);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope: {
              modelSearch: '=',
             //bindAttr: '='
            },
            templateUrl: 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile    : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    var expanderEl,
                        collapserEl;

                    // Initialize
                    init();

                    function init()
                    {
                        expanderEl = iElement.find('#ms-search-bar-expander');
                        collapserEl = iElement.find('#ms-search-bar-collapser');

                        expanderEl.on('click', expand);
                        collapserEl.on('click', collapse);
                    }

                    /**
                     * Expand
                     */
                    function expand()
                    {
                        iElement.addClass('expanded');

                        // Esc key event
                        $document.on('keyup', escKeyEvent);
                    }

                    /**
                     * Collapse
                     */
                    function collapse()
                    {
                        iElement.removeClass('expanded');
                    }

                    /**
                     * Escape key event
                     *
                     * @param e
                     */
                    function escKeyEvent(e)
                    {
                        if ( e.keyCode === 27 )
                        {
                            collapse();
                            $document.off('keyup', escKeyEvent);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, QiuConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( QiuConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( QiuConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    })
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem           : saveItem,
                deleteItem         : deleteItem,
                sort               : sortByWeight,
                clearNavigation    : clearNavigation,
                setActiveItem      : setActiveItem,
                getActiveItem      : getActiveItem,
                getNavigationObject: getNavigationObject,
                setNavigationScope : setNavigationScope,
                setFolded          : setFolded,
                getFolded          : getFolded,
                setFoldedOpen      : setFoldedOpen,
                getFoldedOpen      : getFoldedOpen,
                toggleFolded       : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = [];
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                console.log('node', node);
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation object
             *
             * @param root
             * @returns {Array}
             */
            function getNavigationObject(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }
                }
                return navigation;
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigationObject($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigationObject();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();

                        // If navigation is folded open, close it
                        if ( msNavigationService.getFolded() )
                        {
                            onFoldCollapserHover();
                        }
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        // console.log($scope.node)
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';
        vm.searchNav = '';

        vm.loadTab = function(ev, item) {
            // debugger
          ev.preventDefault();
//          if (($state.current.name != item.qiuStateName) || ($rootScope.idUserTab != item.idUserTab)) {
            if (!angular.isUndefined(item.idUserTab) && item.idUserTab > 0)
            {
              $rootScope.idUserTab = item.idUserTab;
            }
            $state.go(item.qiuStateName, item.qiuStateParams);
//          }
        }
        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }


            $rootScope.$watch("global.searchnav", function (newVal, oldVal)
            {
                vm.searchNav = newVal;
            })

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            if ( !vm.collapsed ) { return true }

            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective($rootScope)
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            scope:true,
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }
                        //
                        // Todo Revisar para mejorarlo en un scope parent
                        //
                        $rootScope.$watch("global.searchnav", function (newVal, oldVal)
                        {
                            if(oldVal) {
                                MsNavigationNodeCtrl.expand();
                            }
                        })

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states everything except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPicker($mdMenu, $mdColorPalette, QiuGenerator)
    {
        return {
            require    : 'ngModel',
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function ($scope, element, attrs, ngModel)
            {
                // Material Color Palette
                $scope.palettes = $mdColorPalette;
                $scope.selectedPalette = false;
                $scope.selectedHues = false;

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                $scope.msModelType = $scope.msModelType || 'class';

                /**
                 * Initialize / Watch model changes
                 */
                $scope.$watch('ngModel', setSelectedColor);

                /**
                 * Activate Hue Selection
                 * @param palette
                 * @param hues
                 */
                $scope.activateHueSelection = function (palette, hues)
                {
                    $scope.selectedPalette = palette;
                    $scope.selectedHues = hues;
                };

                /**
                 * Select Color
                 * @type {selectColor}
                 */
                $scope.selectColor = function (palette, hue)
                {
                    // Update Selected Color
                    updateSelectedColor(palette, hue);

                    // Update Model Value
                    updateModel();

                    // Hide The picker
                    $mdMenu.hide();
                };

                $scope.removeColor = function ()
                {

                    $scope.selectedColor = {
                        palette: '',
                        hue    : '',
                        class  : ''
                    };

                    $scope.activateHueSelection(false, false);

                    updateModel();
                };

                /**
                 * Set SelectedColor by model type
                 */
                function setSelectedColor()
                {
                    if ( !ngModel.$viewValue || ngModel.$viewValue === '' )
                    {
                        return;
                    }

                    var palette, hue;

                    // If ModelType Class
                    if ( $scope.msModelType === 'class' )
                    {
                        var color = ngModel.$viewValue.split('-');
                        if ( color.length >= 5 )
                        {
                            palette = color[1] + '-' + color[2];
                            hue = color[3];
                        }
                        else
                        {
                            palette = color[1];
                            hue = color[2];
                        }
                    }
                    // If ModelType Object
                    else if ( $scope.msModelType === 'obj' )
                    {
                        palette = ngModel.$viewValue.palette;
                        hue = ngModel.$viewValue.hue || 500;
                    }

                    // Update Selected Color
                    updateSelectedColor(palette, hue);
                }


                /**
                 * Update Selected Color
                 * @param palette
                 * @param hue
                 */
                function updateSelectedColor(palette, hue)
                {
                    $scope.selectedColor = {
                        palette     : palette,
                        hue         : hue,
                        class       : 'md-' + palette + '-' + hue + '-bg',
                        bgColorValue: QiuGenerator.rgba($scope.palettes[palette][hue].value),
                        fgColorValue: QiuGenerator.rgba($scope.palettes[palette][hue].contrast)
                    };

                    // If Model object not Equals the selectedColor update it
                    // it can be happen when the model only have pallete and hue values
                    if ( $scope.msModelType === 'obj' && !angular.equals($scope.selectedColor, ngModel.$viewValue) )
                    {
                        // Update Model Value
                        updateModel();
                    }

                    $scope.activateHueSelection(palette, $scope.palettes[palette]);
                }

                /**
                 * Update Model Value by model type
                 */
                function updateModel()
                {
                    if ( $scope.msModelType === 'class' )
                    {
                        ngModel.$setViewValue($scope.selectedColor.class);
                    }
                    else if ( $scope.msModelType === 'obj' )
                    {
                        ngModel.$setViewValue($scope.selectedColor);
                    }
                }
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        }

    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                }
            }
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('draggableElement', draggableElement);



    /** @ngInject */
    function draggableElement($document) {
        return {
            link: function (scope, element, attr) {
                var startX = 0, startY = 0, x = 0, y = 0;

                element.css({
                    position: 'absolute',
                    backgroundColor: 'transparent',
                    cursor: 'pointer',
                    'z-index': '99'
                });

                element.on('mousedown', function (event) {
                    // Prevent default dragging of selected content
                    event.preventDefault();
                    startX = event.pageX - x;
                    startY = event.pageY - y;
                    $document.on('mousemove', mousemove);
                    $document.on('mouseup', mouseup);
                });

                function mousemove(event) {
                    y = event.pageY - startY;
                    x = event.pageX - startX;
                    if (x >= element.parent().width() - element.width()) {
                        x = element.parent().width() - element.width();
                    }
                    if (y >= element.parent().height() - element.height()) {
                        y = element.parent().height() - element.height();
                    }
                    if (x < 0) {
                        x = 0;
                    }
                    if (y < 0) {
                        y = 0
                    }
                    element.css({
                        top: y + 'px',
                        left: x + 'px'
                    });

                }

                function mouseup() {
                    $document.off('mousemove', mousemove);
                    $document.off('mouseup', mouseup);
                }
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('msCropformatWidget', msCropformatWidgetDirective);

    var controller = ['$scope', 'sitemapService', 'requestContext', function ($scope, sitemapService, requestContext) {

        var vm = this;
        vm.Math = window.Math;

        vm.addCropformat = addCropformat;
        vm.$onInit = function () {
        }
        // $scope.$watch('section', function (newVal, oldVal) {

        // });

        function addCropformat(widget, cropformatname, cropformatselected) {
            console.log('cropformatname', cropformatname);
            console.log('cropformatselected', cropformatselected);
            var crop = $scope.cropformatoptions.find(x => x.id_cropformats === cropformatselected);
            if (!widget.cropformats){
                widget.cropformats = [];
            }
            widget.cropformats.push(
                { name: cropformatname, id: crop.id_cropformats, width: crop.width, height: crop.height, proportional: crop.proportional }
            )
            vm.cropformatname = null;
            vm.cropformatselected = null;
        }

    }];

    /** @ngInject */
    function msCropformatWidgetDirective($document) {
        return {
            restrict: 'AE',
            scope: {
                cropformatoptions: '=',
                widget: '='
            },
            templateUrl: 'app/core/directives/ms-cropformat-widget/ms-cropformat-widget.directive.html',
            controller: controller,
            controllerAs: 'vm'
        };
    }
})();


(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('msFilterWidget', msFilterWidgetDirective);

    var controller = ['$scope', '$rootScope', 'sitemapService', 'requestContext', 'sessionService', function ($scope, $rootScope, sitemapService, requestContext, sessionService) {

        var vm = this;
        vm.siteID = requestContext.getParam("siteId");

        vm.addFilter = addFilter;
        vm.cleanFilters = cleanFilters;
        vm.isFilterComplete = isFilterComplete;
        vm.isNormalValue = isNormalValue;
        vm.isMultipleSelect = isMultipleSelect;
        vm.widgetsFilter = null;
        vm.siteLanguages = sessionService.getSiteLanguages();
        vm.$onInit = function () {
            getSectionRef();
        }
        vm.currentSection = '';
        $scope.$watch('section', function (newVal, oldVal) {
            getSectionRef();
        });
        $scope.$watch('sections', function (newVal, oldVal) {
            getSectionRef();
        });
      $scope.$watch(function(){
        return vm.widgetsFilter;
      },function(newVal,oldVal){
        if (newVal !== oldVal) {
          var fieldData = {
            sub: 'subsection',
            id: 'id_subsec',
            name: 'subsec'
          }
           if (newVal === 'id_cat') {
             fieldData = {
               sub: 'category',
               id: 'id_cat',
               name: 'cat'
             }

           }
           if (newVal === 'id_subcat') {
             fieldData = {
               sub: 'subcategory',
               id: 'id_subcat',
               name: 'subcat'
             }
           }
           vm.filterSub = [];
           angular.forEach(vm.currentSection[fieldData['sub']], function(item) {
             vm.filterSub.push({
               id: item[fieldData['id']],
               name: item[fieldData['name']]
             });
           })
        }
      },true)

        function getSectionRef() {
            if ($scope.sections){
                vm.currentSection = $scope.sections.find(x => x.section === $scope.section);
                vm.selectedRef = vm.currentSection.fields;
            }
        }


        function addFilter() {
            var filter = {
                field: vm.widgetsFilter
            }
            if (vm.widgetsFilter === 'onoff' || vm.widgetsFilter === 'lang' || vm.widgetsFilter === 'limit') {
                filter.value = vm.widgetsFilterValues;
            }
            if (vm.widgetsFilter === 'order' && vm.widgetsFilterOrderValue && vm.widgetsFilterFieldOrder) {
                filter.value = vm.widgetsFilterOrderValue;
                filter.condition = vm.widgetsFilterFieldOrder;
            }
            if (vm.widgetsFilter !== 'limit' && vm.widgetsFilter !== 'order' && vm.widgetsFilter !== 'onoff' && vm.widgetsFilter !== 'lang' && vm.widgetsFilter && vm.widgetsFilterCondition && vm.widgetsFilterValues) {
                filter.condition = vm.widgetsFilterCondition;
                filter.value = vm.widgetsFilterValues;
            }
            
            var field = filter.field;
            var condition = filter.condition;
            var value = filter.value;
            switch(field){
              case 'order':
                var stringFilter = 'order;' + condition + " " + value;
                break;
              case 'limit':
                var stringFilter = 'limitCount;' + value;
                break;
              case 'onoff':
                var stringFilter = 'onoff;' + value;
                break;
              case 'lang':
                var stringFilter = 'lang;' + value;
                break;
              default:
                if(condition == "IN" || condition == "NOT IN"){
                  var stringFilter = field + " " + condition + "(" + value + ")";
                }else if(!condition){
                  if(!value){
                    var stringFilter = field + ";";
                  }else{
                    var stringFilter = field + "?;" + value;
                  }
                }else{
                  var stringFilter = field + condition + "?;" + value;
                }
                break;
            } 
            
            $rootScope.stringSection = $rootScope.stringSection + "|" + stringFilter;
            
            $scope.onSubmit({ filter: filter });
            vm.cleanFilters();
            vm.widgetsFilter = null;
        }

        function cleanFilters() {
            vm.widgetsFilterCondition = null;
            vm.widgetsFilterFieldOrder = null;
            vm.widgetsFilterOrderValue = null;
            vm.widgetsFilterValues = null;
        }

        function isFilterComplete() {
            if (vm.widgetsFilter) {
                if ((vm.widgetsFilter === 'onoff' || vm.widgetsFilter === 'lang') && vm.widgetsFilterValues && vm.widgetsFilterValues.length > 0) {
                    return true;
                }
                if (vm.widgetsFilter === 'order' && vm.widgetsFilterOrderValue && vm.widgetsFilterFieldOrder) {
                    return true;
                }
                if (vm.widgetsFilter === 'limit' && vm.widgetsFilterValues) {
                    return true;
                }
                if (vm.widgetsFilter !== 'limit' && vm.widgetsFilter !== 'order' && vm.widgetsFilter !== 'onoff' && vm.widgetsFilter !== 'lang' && vm.widgetsFilter && vm.widgetsFilterCondition && vm.widgetsFilterValues) {
                    return true;
                }
            }
            return false;
        }
        function isNormalValue() {
          if (vm.widgetsFilter !== 'onoff' && vm.widgetsFilter !== 'lang' && vm.widgetsFilter !== 'order' && vm.widgetsFilter !== 'limit' && vm.widgetsFilter !== 'date' && vm.widgetsFilter !== 'id_subsec' && vm.widgetsFilter !== 'id_cat' && vm.widgetsFilter !== 'id_subcat') {
            return true;
          }
          return false;
        }
        function isMultipleSelect() {
          if (vm.widgetsFilterCondition === 'IN' || vm.widgetsFilterCondition === 'NOT IN') {
            return true;
          }
          return false;
        }

    }];

    /** @ngInject */
    function msFilterWidgetDirective($document) {
        return {
            restrict: 'AE',
            scope: {
                sections: '=',
                section: '=',
                onSubmit: '&'
            },
            templateUrl: 'app/core/directives/ms-filter-widget/ms-filter-widget.html',
            controller: controller,
            controllerAs: 'vm'
        };
    }
})();


(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {

        // Default configuration
        var defaultConfiguration = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }
                var offset = moment(val).utcOffset();
                var date = new Date(moment(val).add(offset, 'm'));
                return date;
            }
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            return defaultConfiguration;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require: 'ngModel',
            link   : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.unshift(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.unshift(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('msChipsFilters', msChipsFiltersDirective);

    var controller = ['$scope', '$rootScope', function ($scope, $rootScope) {

        var vm = this;
        
        vm.editStringSection = editStringSection;


        vm.$onInit = function () {
            vm.filters = $scope.filters;
        }
        $scope.$watch('filters', function (newVal, oldVal) {
            vm.filters = newVal;
        });

        function editStringSection(filter){
            var field = filter.field;
            var condition = filter.condition;
            var value = filter.value;
            switch(field){
              case 'order':
                var stringFilter = 'order;' + condition + " " + value;
                break;
              case 'limit':
                var stringFilter = 'limitCount;' + value;
                break;
              case 'onoff':
                var stringFilter = 'onoff;' + value;
                break;
              case 'lang':
                var stringFilter = 'lang;' + value;
                break;
              default:
                if(condition == "IN" || condition == "NOT IN"){
                  var stringFilter = field + " " + condition + "(" + value + ")";
                }else if(!condition){
                  if(!value){
                    var stringFilter = field + ";";
                  }else{
                    var stringFilter = field + "?;" + value;
                  }
                }else{
                  var stringFilter = field + condition + "?;" + value;
                }
                break;
            }
            var arraySection = $rootScope.stringSection.split('|');
            for(var i=0; i<arraySection.length; i++){
                if(arraySection[i] == stringFilter){
                    arraySection.splice(i, 1);
                }
            }
            $rootScope.stringSection = arraySection.join('|');
        }
    }];

    /** @ngInject */
    function msChipsFiltersDirective($document) {
        return {
            restrict: 'AE',
            scope: {
                filters: '='
            },
            templateUrl: 'app/core/directives/ms-chips-filters/ms-chips-filters.html',
            controller: controller,
            controllerAs: 'vm'
        };
    }
})();


(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function () {
	'use strict';

	angular
		.module('app.core')
		.directive('videoonload', videoonload);

	/** @ngInject */
	function videoonload($timeout, $q, $interpolate, $compile) {

		return {
			restrict: 'A',
			link: function (scope, element, attrs) {

				var wrapper = angular.element('<div class="avatar" layout="row" layout-align="center center"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>');

				element[0].addEventListener("error", function () {
					wrapper.remove();

					if(!attrs.errSrc){
						element.attr('src', 'assets/images/common/no_image_available_10.png');
					}else{
						element.attr('src', attrs.errSrc);
					}

			     });


				element[0].addEventListener("load", function () {

				    $compile(wrapper)(scope);
				    element.before(wrapper);

				});

				// scope.$watch('ngSrc', function () {
				// 	element.addClass('hide spinner-hide');
				//     $compile(wrapper)(scope);
				//     element.before(wrapper);
				   
				// }, function (value) {
				// 	if (!value) {
				// 		element.attr('src', attrs.errSrc);
				// 	}
				// });

				// element.bind('error', function () {
				// 	if(!attrs.errSrc){
				// 		element.attr('src', 'assets/images/common/no_image_available_10.png');
				// 	}else{
				// 		element.attr('src', attrs.errSrc);
				// 	}
					
				// });
			}
		};
	}
})();
(function () {
  'use strict';

  angular
    .module('app.core')
    .provider('msMediaService', msMediaServiceProvider)
    .directive('media', MediaItemDirective)
    .directive('errSrc', mediaSrcError)
    .controller('MediaItemController', MediaItemController);

  /** @ngInject */
  function msMediaServiceProvider() {
    // Inject $log service
    var $log = angular.injector(['ng'])
      .get('$log');

    // Navigation array

    var service = this;

    // Methods


    //////////

    /* ----------------- */
    /* Private Functions */
    /* ----------------- */


    /* ----------------- */
    /* Service           */
    /* ----------------- */

    this.$get = function () {
      var activeItem = null,
        navigationScope = null,
        thumbnailScope = null,
        thumbsScope = null,
        viewImage = null;

      var service = {
        setAttachmentScope: setAttachmentScope,
        setThumbnailScope: setThumbnailScope,
        getNavigationScope: getNavigationScope,
        setThumbsScope: setThumbsScope,
        getThumbsScope: getThumbsScope,
        setOpenImageMethod: setOpenImageMethod,
        callOpenImageMethod: callOpenImageMethod,
      };

      return service;

      //////////


      /**
       * Store navigation's scope for later use
       *
       * @param scope
       */
      function setAttachmentScope(scope) {
        navigationScope = scope;
      }

      /**
       * Store thumbnail's scope for later use
       *
       * @param scope
       */
      function setThumbnailScope(scope) {
        thumbnailScope = scope;
      }

      /**
       * Store navigation's scope for later use
       *
       * @param scope
       */
      function setThumbsScope(scope) {
        thumbsScope = scope;
      }

      /**
       * Store navigation's scope for later use
       *
       * @param scope
       */
      function getThumbsScope() {
        return thumbsScope;
      }

      /**
       * Store navigation's scope for later use
       *
       * @param scope
       */
      function getNavigationScope() {
        return navigationScope;
      }


      /**
       * Toggle fold on stored navigation's scope
       */
      function setOpenImageMethod(fn) {
        // alert("ok")
        viewImage = fn;
      }

      /**
       * Toggle fold on stored navigation's scope
       */
      function callOpenImageMethod(event, thumbs, attachment) {
        viewImage(event, thumbs, attachment)
      }


    };
  }

  /** @ngInject */
  function MediaItemDirective(msMediaService, $compile, sessionService, CommonMediaService, $log, $timeout,
    mediaService, requestContext, $rootScope, msUtils) {
    return {
      restrict: 'E',
      transclude: true,
      replace: true,
      scope: {
        thumbsGallery: '=',
        attachment: '=',
        thumbnail: '@',
        cropFormat: '@',
        openImage: '&',
        forceClass: '@',
        useDefault: '@',
        // vm          : '=viewModel'
      },
      // transclude : true,
      templateUrl: 'app/core/directives/media/item-media.html',
      controller: 'MediaItemController as vm',
      link: function (scope, element, attrs) {

        scope.watchAllCropped = true;
        scope.urlLabelProcessing = 'assets/images/common/label_processing.png';
        scope.urlLabelError = 'assets/images/common/label_error.png';

        /**
         * Initialize / Watch model changes
         */
        scope.$watch('attachment', setItemMedia);

        scope.$watchCollection('attachment.thumb', setItemMedia);

        if (scope.attachment && (scope.attachment.allCropped === 0 || scope.attachment.allCropped === 2 ||
          (scope.attachment.media_type === 2 && scope.attachment.cropstatus_videos && scope.attachment.cropstatus_videos.length > 0 && scope.attachment.allCropped === null))
        ) {
          // Listen to api when crop is done.
          mediaService.addUncroppedMediaID(scope.attachment.id_media);
          $rootScope.$on('MEDIA::IS_ALL_CROPPED::ID::' + scope.attachment.id_media, function (event, data) {
            scope.attachment.allCropped = 1;
            if (scope.attachment.media_type === 2) {
              // First retrieve media and replace attachment to get embed data etc.
              // Then update item media thumbs, etc.
              mediaService.getImageByID({
                domain: requestContext.getParam("siteId"),
                id_media: scope.attachment.id_media
              }).then(function (resp) {
                if (angular.isArray(resp.data) && resp.data.length > 0) {
                  scope.attachment = resp.data[0];
                  setItemMedia();
                }
              })
            } else {
              setItemMedia();
            }
          })
        }

        /**
         * Set ItemMedia by model type
         */
        function setItemMedia() {
          scope.image = false;
          scope.video = false;
          scope.audio = false;
          scope.file = false;
          scope.thumbnail = false;
          scope.urlvideo = false;
          scope.urlvideoEmbed = false;
          scope.isYoutube = false;
          scope.videoID = false;
          scope.labels = {
            processing: false,
            error: false
          }

          var embed = attrs.embed ? attrs.embed : false;

          scope.class = attrs.classImg || '';
          scope.forceClass = 'forceClass' in attrs;
          scope.useDefault = 'useDefault' in attrs;

          if (scope.attachment && (scope.attachment.filename || scope.attachment.fileName)) {
            var fname = (scope.attachment.filename || scope.attachment.fileName).toLowerCase();
            scope.isSvg = fname.endsWith('.svg');
          } else {
            scope.isSvg = false;
          }

          if (angular.isArray(scope.attachment)) {
          } else if (angular.isObject(scope.attachment)) {

            scope.thumbnail = !angular.isUndefined(attrs.thumbnail) ? attrs.thumbnail : false;
            switch (parseInt(scope.attachment.media_type)) {
              //
              // Image
              //
              case 1:
                scope.class += ' image';

                // Setting url for image thumb

                // MediaHub Item Logic
                if (scope.attachment.isMediahub || scope.attachment.isIconik) {
                  if ((scope.attachment.allCropped === 0 || scope.attachment.allCropped === 2) && !scope.isSvg) {
                    scope.labels.processing = true;
                  }

                  if (scope.attachment.thumbnailUrl) {
                    scope.url = scope.attachment.thumbnailUrl;
                  } else if (scope.attachment.imageUrl && !scope.attachment.imageUrl.toLowerCase().endsWith('.mp4')) {
                    scope.url = scope.attachment.imageUrl;
                  } else {
                    scope.url = msUtils.getMediaPlaceholder(scope.attachment);
                  }
                }
                // Legacy Media: Still cropping?
                else if (scope.attachment.allCropped != 1) {
                  //scope.url = 'assets/images/common/cropping_media.png'; // Show placehoder image
                  scope.url = scope.isSvg ? 'assets/images/common/svg_placeholder.png' : getOriginalImageUrl(); // Show original
                  if (!scope.isSvg) {
                    scope.labels.processing = true;
                  }
                }
                // Legacy Media: Finding crop format id for thumb
                else {
                  var cropFormatId = attrs.cropFormat;
                  if (angular.isUndefined(attrs.cropFormat) || attrs.cropFormat === null || !attrs.cropFormat) {
                    cropFormatId = sessionService.getMediaThumbnailCropformatId();
                    if (typeof cropFormatId === 'string') {
                      if (cropFormatId.indexOf(';')) {
                        var cropSplit = cropFormatId.split(';');
                      }
                      if (cropFormatId.indexOf(',')) {
                        var cropSplit = cropFormatId.split(',');
                      }
                      if (cropSplit.length > 1) {
                        cropFormatId = cropSplit[0];
                      }
                    }
                  }
                  // In some cases we need to use the original file as thumb
                  if (cropFormatId == 0 || cropFormatId == 'original' || scope.attachment.filename.includes(".gif") || scope.attachment.filename.includes(".svg")) {
                    scope.url = getOriginalImageUrl();
                  } else { // Use the identified crop format id
                    // Search crop format by id in media's "cropstatus" property
                    if (angular.isObject(scope.attachment) && angular.isObject(scope.attachment.cropstatus) && scope.attachment.cropstatus.length > 0) {
                      var cropstatus = _.find(scope.attachment.cropstatus, function (c) {
                        if (c.id_cropformats == cropFormatId) {
                          return true;
                        }
                      });
                      if (!angular.isUndefined(cropstatus)) {
                        if (cropstatus.isCropped) {
                          var container = sessionService.getContainerByID(cropstatus.id_container);
                          scope.url = container.view_url + cropstatus.fileName;
                        } else {
                          scope.url = getOriginalImageUrl();
                        }
                      } else {
                        scope.url = getOriginalImageUrl();
                      }
                      // Since media does not provide any crop formats, retrieve format from API
                    } else if (scope.attachment.id_media && !scope.attachment.isMediahub && !scope.attachment.isIconik) {
                      var options = {
                        id_media: [scope.attachment.id_media],
                        // id_cropformat: 1002,
                        // id_container: 2
                      };
                      CommonMediaService.getUrl(options)
                        .then(function (response) {
                          if (response.length > 0) {
                            var cropstatus = _.find(response, {
                              'id_cropformats': cropFormatId
                            });
                            scope.url = cropstatus ? cropstatus.url : '';
                          } else {
                            scope.url = getOriginalImageUrl();
                          }
                        });
                    }
                  }
                }
                scope.image = true;
                break;

              //
              // Video
              //
              case 2:
                thumbnailView(attrs);

                if (scope.attachment.isMediahub || scope.attachment.isIconik) {
                  if ((scope.attachment.allCropped === 0 || scope.attachment.allCropped === 2) && !scope.isSvg) {
                    scope.labels.processing = true;
                  }

                  if (scope.attachment.thumbnailUrl) {
                    scope.url = scope.attachment.thumbnailUrl;
                  } else {
                    scope.url = msUtils.getMediaPlaceholder(scope.attachment);
                  }
                  scope.video = true;
                } else if (scope.attachment.embed != null) {
                  var videoTypeSplit = scope.attachment.embed.split("|");
                  var videoType = videoTypeSplit[0];
                  var videoID = videoTypeSplit[1];

                  if (videoType === 'yt') {
                    scope.isYoutube = true;
                    scope.videoID = videoID;
                    if (embed) {
                      scope.urlvideoEmbed = 'https://www.youtube.com/embed/' + videoID;
                      element.removeClass('image');
                      element.addClass('videoEmbed');

                    } else {
                      if (scope.attachment.embed_thumb) {
                        scope.url = scope.attachment.embed_thumb;
                        scope.video = true;
                      }
                    }
                  } else if (videoType === 'vimeo') {
                    scope.isYoutube = false;
                    scope.videoID = videoID;
                    if (embed) {
                      scope.urlvideoEmbed = 'https://player.vimeo.com/video/' + videoID;
                      element.removeClass('image');
                      element.addClass('videoEmbed');

                    } else {
                      if (scope.attachment.embed_thumb) {
                        scope.url = scope.attachment.embed_thumb;
                        scope.video = true;
                      }
                    }

                  } else if (videoType === 'zc') {
                    // Still cropping?
                    if (scope.attachment.allCropped != 1) {
                      scope.url = 'assets/images/common/cropping_media.png';
                      scope.labels.processing = true;
                    } else {
                      scope.url = scope.attachment.embed_thumb || msUtils.getMediaPlaceholder(scope.attachment);
                      scope.video = true;
                    }
                    //scope.urlvideo = videoID;

                  } else if (videoType === 'x') {
                    scope.video = true;
                  } else {
                    if (scope.attachment.embed_thumb) {
                      scope.url = scope.attachment.embed_thumb;
                      scope.video = true;
                    }
                  }
                } else if (!scope.attachment.isMediahub && !scope.attachment.isIconik && !scope.attachment.embed && !scope.attachment.embed_code && !scope.attachment.embed_thumb && !scope.attachment.embed_url) {
                  var containerOriginal = sessionService.getContainerByID(scope.attachment.cdnContainer);
                  if (containerOriginal.view_url) {
                    scope.urlvideo = containerOriginal.view_url + 'videos/m' + scope.attachment.id_media + '_' + scope.attachment.filename;
                  } else {
                    scope.url = 'assets/images/common/cropping_media.png';
                    scope.labels.processing = true;
                  }
                }



                break;

              //
              // Audio
              //
              case 3:
                //
                thumbnailView(attrs);
                if (scope.attachment.isMediahub || scope.attachment.isIconik) {
                  if ((scope.attachment.allCropped === 0 || scope.attachment.allCropped === 2) && !scope.isSvg) {
                    scope.labels.processing = true;
                  }

                  if (scope.attachment.thumbnailUrl) {
                    scope.url = scope.attachment.thumbnailUrl;
                  } else {
                    scope.url = msUtils.getMediaPlaceholder(scope.attachment);
                  }
                }
                scope.audio = true;
                break;

              // File
              case 4:
                //
                thumbnailView(attrs);
                if (scope.attachment.isMediahub || scope.attachment.isIconik) {
                  if ((scope.attachment.allCropped === 0 || scope.attachment.allCropped === 2) && !scope.isSvg) {
                    scope.labels.processing = true;
                  }

                  if (scope.attachment.thumbnailUrl) {
                    scope.url = scope.attachment.thumbnailUrl;
                  } else {
                    scope.url = msUtils.getMediaPlaceholder(scope.attachment);
                  }
                } else {
                  scope.url = scope.attachment.thumb ? scope.attachment.filename : null;
                }
                scope.file = true;
                break;
              default:

            }

          } else {

            if (scope.useDefault) {
              scope.url = msUtils.getMediaPlaceholder(scope.attachment);
              scope.image = true;
              element.addClass('no-image');
            }
            if (!angular.isUndefined(scope.attachment) && scope.attachment !== null && scope.attachment.length) {
              scope.url = scope.attachment;
              scope.image = true;
              element.addClass('no-image');
            }
          }
          // $compile(element)(scope);
          if (angular.isUndefined(scope.attachment)) {
            return;
          }
          if (scope.attachment && scope.attachment.media_type == 2 && scope.attachment.short_preview) {
            setTimeout(() => {
              var video = $('#video-preview-' + scope.attachment.id_media)
              video.hover(hoverVideo, hideVideo);
              function hoverVideo(e) {
                video.get(0).play();
              }
              function hideVideo(e) {
                video.get(0).pause();
              }
            }, 200);
          }
        }
        function thumbnailView(attrs) {
          if (scope.attachment.allCropped != 1 && scope.attachment.media_type == 1 && !scope.isSvg) return;
          if (scope.attachment.thumb) {
            scope.loadedIcon = false;
            scope.url = null;
            if (element[0].querySelector('md-icon.s56')) {
              element[0].removeChild(element[0].querySelector('md-icon.s56'))
              //   element[0].parentNode.removeChild(element.find('md-icon.s56'))
            }
            scope.typeIcon = 'placeholder';
            var cropFormatId = attrs.cropFormat || sessionService.getMediaThumbnailCropformatId();
            if (scope.attachment.isMediahub || scope.attachment.isIconik) {
              if ((scope.attachment.allCropped === 0 || scope.attachment.allCropped === 2) && !scope.isSvg) {
                scope.labels.processing = true;
              }

              if (!scope.attachment.thumbnailUrl && !scope.attachment.imageUrl) {
                scope.url = msUtils.getMediaPlaceholder(scope.attachment);
              } else {
                scope.url = scope.attachment.thumbnailUrl || scope.attachment.imageUrl || null;
              }
              scope.loadedIcon = true;
            } else {
              var options = {
                id_media: [scope.attachment.thumb],
              };
              CommonMediaService.getUrl(options)
                .then(function (response) {
                  if (response.length > 0) {
                    var cropstatus = _.find(response, function (c) {
                      if (cropFormatId.indexOf(c.id_cropformats)) {
                        return true;
                      }
                    });
                    scope.url = cropstatus.url;
                    scope.loadedIcon = true;
                  }
                });
            }
          }
        }
        function getOriginalImageUrl() {
          if (scope.attachment && (scope.attachment.isMediahub || scope.attachment.isIconik)) {
            return scope.attachment.imageUrlOriginal || scope.attachment.imageUrl || '';
          }
          var containerOriginal = sessionService.getContainerByID(scope.attachment.cdnContainer);
          if (!angular.isUndefined(containerOriginal)) {
            return containerOriginal.view_url + 'original/m' + scope.attachment.id_media + '_' + (scope.attachment.filename || scope.attachment.fileName);
          }
          return false;
        }

        scope.$on('$destroy', function () {
          // Prevents from keep running the isAllCropped-loop after directive has been destroyed.
          scope.watchAllCropped = false;
        });
      }

    };


  }

  /** @ngInject */
  function MediaItemController($scope, msMediaService, $mdDialog, $document, CommonMediaService) {
    var vm = this;

    var attachment = msMediaService.getNavigationScope();

    vm.attachmentMedia = attachment;

    // Methods
    vm.openImageDialog = openImageDialog;

    //////////

    init();

    /**
     * Initialize
     */
    function init() {


    }

    /**
     * Open Image dialog
     *
     * @param ev
     * @param task
     */
    function openImageDialog(ev, images, ImageSelected, cropFormats, MediaFull) {
      $mdDialog.show({
        controller: 'MediaShowDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/dialogs/media-show/media-show-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        escapeToClose: false,
        locals: {
          Images: images,
          ImageSelected: ImageSelected,
          cropFormats: cropFormats,
          MediaFull: MediaFull,
          Tags: false,
          // Tasks: vm.tasks,
          // event: ev
        }
      }).then(function () {
      });
    }
  }

  function mediaSrcError($timeout) {
    return {

      link: function (scope, element, attrs) {
        if (scope.attachment && scope.attachment.allCropped != 1) {
          attrs.errSrc = 'assets/images/common/no_image_available_10.png'
        } else {
          attrs.errSrc = 'assets/images/common/cropping_media.png';
        }
        element.bind('error', function () {
          if (attrs.src != attrs.errSrc) {
            if (scope.attachment.allCropped != 1 && !scope.isSvg) {
              $timeout(function () {
                scope.labels.processing = true;
              })
            } else {
              $timeout(function () {
                scope.labels.error = true;
              })
            }
            attrs.$set('src', attrs.errSrc);
          }
        });
      }
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('imageonload', imageonload);

  /** @ngInject */
  function imageonload($timeout, $q, $interpolate, $compile) {

    return {
      restrict: 'A',
      link: function (scope, element, attrs) {

        //var wrapper = angular.element('<div class="avatar" layout="row" layout-align="center center"><md-progress-circular md-mode="indeterminate" md-diameter="30"></md-progress-circular></div>');
        var wrapper = angular.element('<div class="avatar" layout="row" layout-align="center center"></div>');

        element.on('load', function () {
//					element.removeClass('spinner-hide');
//					element.addClass('show spinner-show');
          wrapper.remove();
        });

        scope.$watch('ngSrc', function () {
//					element.addClass('hide spinner-hide');
//          $compile(wrapper)(scope);
          element.before(wrapper);

        }, function (value) {
          if (!value) {
            element.attr('src', attrs.errSrc);
          }
        });

        element.bind('error', function () {
          if (!attrs.errSrc) {
            element.attr('src', 'assets/images/common/no_image_available_10.png');
          } else {
            element.attr('src', attrs.errSrc);
          }
        });
      }
    };
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('focusPoint', focusPointDirective);

    /** @ngInject */
    function focusPointDirective($timeout, $q, $interpolate)
    {
      return {
          restrict: 'A',
          replace: true,
          scope: {
              model: '=ngModel',
              fromDirectiveFn: '=method'
          },
          template: '<div class="focus-point">' +
          '<div class="focus-area">' +
          '<span class="target" style="left: {{ x }}%; top: {{ y }}%"></span>' +
          '<img src="{{ src }}" alt="" ng-mousemove="onMouseMove($event)" ng-mousedown="onMouseDown($event)" ng-mouseup="onMouseUp($event)" draggable="false" class="source" />' +
          '</div>' +
          // '<span style="background-image: url(\'{{ src }}\'); background-position: {{ x }}% {{ y }}%" class="preview-portrait"></span>' +
          // '<span style="background-image: url(\'{{ src }}\'); background-position: {{ x }}% {{ y }}%" class="preview"></span>' +
          // '<span style="background-image: url(\'{{ src }}\'); background-position: {{ x }}% {{ y }}%" class="preview-landscape"></span>' +
          // '<span style="background-image: url(\'{{ src }}\'); background-position: {{ x }}% {{ y }}%" class="preview-wide"></span>' +
          '<div class="info">X: {{ x }}% | Y: {{ y }}%</div>' +
          '</div>',
          link: function (scope, element, attr) {
              var dragging = false;
              scope.src = attr.src;

              scope.x = parseFloat(attr.x * 100).toFixed(0);
              scope.y = parseFloat(attr.y * 100).toFixed(0);

              scope.onMouseDown = function (e) {
                  scope.update(e);
                  dragging = true;
              };

              scope.onMouseMove = function (e) {
                  if (dragging === true) {
                      scope.update(e);
                  }
              };

              scope.onMouseUp = function (e) {
                  e.preventDefault();
                  dragging = false;
              };

              scope.update = function (e) {
                  e.preventDefault();
                  var offset = scope.offset(e.target);
                  scope.x = Math.round(((e.pageX - offset.left) / e.target.clientWidth) * 100);
                  scope.y = Math.round(((e.pageY - offset.top) / e.target.clientHeight) * 100);
                  scope.updateMediaFn(scope.x / 100, scope.y / 100);

              };

              scope.updateMediaFn = function () {
                scope.fromDirectiveFn(scope.x / 100, scope.y / 100);
              };

              scope.offset = function (elm) {
                  try { return elm.offset(); } catch (e) { }
                  var body = document.documentElement || document.body;
                  return {
                      left: elm.getBoundingClientRect().left + (window.pageXOffset || body.scrollLeft),
                      top: elm.getBoundingClientRect().top + (window.pageYOffset || body.scrollTop)
                  };
              };
          }
      };
    }
})();

(function () {
	'use strict';

	angular
		.module('app.core')
		.directive('userAvatar', UserAvatarDirective)
		.factory("avatarService", avatarService);

	/** @ngInject */
	function UserAvatarDirective($timeout, $q, $interpolate, avatarService) {

		var controller = function ($scope) {
			$scope.ImageAvailable = false;
			if (angular.isUndefined($scope.User)) {
				$scope.GenericAvatar = avatarService.getAvatar($scope.User);
			} else {
				$scope.ImageAvailable = true;
			}

		};
		return {
			restrict: 'E',
			replace: 'true',
			scope: {
				User: '=user'
			},
			// template: '<div class="avatar generic-avatar">' +
			// 	'<a class="thumb spacer animated fadeIn color" style="background-color:{{GenericAvatar.Background}}"></a>' +
			// 	'<a class="name">{{GenericAvatar.Initials}}</a>' +
			// 	'<a class="img" data-ng-if="ImageAvailable" style="background-image:url({{User.Avatar}})"></a>' +
			// 	'</div>',
			template: '<div class="avatar generic-avatar" style="background-color:{{GenericAvatar.Background}}">{{GenericAvatar.Initials}}' +
				'</div>',
			controller: controller
		};
	}

    /** @ngInject */
	function avatarService() {

        var service = {
            getAvatar    : getAvatar
        };

        return service;
		
		/**
		 * Get Avatar
		 * @param  scope user
		 * @return array
		 */
		function getAvatar(user) {
			var colorCodes = {
				1: "#F29691",
				2: "#92D6C2",
				3: "#CFD696",
				4: "#FACA82",
				5: "#D7ADE0"
			};
			var i1 = "",
				i2 = "",
				nameArray = [];
			if (angular.isDefined(user.Name)) {
				i1 = angular.uppercase(user.Name.charAt(0));
				nameArray = user.Name.split(" ");
				if (nameArray.length > 2) {
					i2 = angular.uppercase(nameArray[nameArray.length - 1].charAt(0));
				} else {
					i2 = angular.uppercase(nameArray[1].charAt(0));
				}
			} else {
				if(user.first_name){
					i1 = angular.uppercase(user.first_name.charAt(0));
				}else{
					i1 = angular.uppercase(user.email.charAt(0));
				}
				if(user.last_name){
					nameArray = user.last_name.split(" ");
				
					if (nameArray.length > 2) {
						i2 = nameArray[nameArray.length - 1].charAt(0);
					} else {
						i2 = angular.uppercase(nameArray[0].charAt(0));
					}
				}
			}
			var initials = i1 + i2;
			var charCode = initials.charCodeAt(0) + initials.charCodeAt(1);
			charCode = charCode >= 130 && charCode <= 144 ? 1 : charCode >= 145 && charCode <= 158 ? 2 : charCode > 158 && charCode <= 172 ? 3 : charCode >= 173 && charCode <= 186 ? 4 : 5;
			var background = colorCodes[charCode];
			var background = user.profile_color;
			return ({
				"Initials": initials,
				"Background": background
			});
		}
	}
})();
(function() {
    'use strict';

    angular
        .module('app.core')
        .directive('mdTreeviewBox', mdTreeviewBox);

    function mdTreeviewBox(ivhTreeviewMgr) {
        return {
            restrict: 'AE',
            template: [
                '<span class="ascii-box">',
                '<span ng-show="node.selected" class="x"><md-checkbox style="min-height: 100%; line-height: 0" aria-label="checked" ng-checked="true"></md-checkbox></span>',
                '<span ng-show="node.__ivhTreeviewIndeterminate" class="y"><md-checkbox style="min-height: 100%; line-height: 0" aria-label="checked" ng-checked="false"></md-checkbox></span>',
                '<span ng-hide="node.selected || node.__ivhTreeviewIndeterminate"><md-checkbox style="min-height: 100%; line-height: 0" aria-label="checked" ng-checked="false"></md-checkbox></span>',
                '</span>',
            ].join(''),
            link: function(scope, element, attrs) {
                element.on('click', function() {
                    scope.trvw.toggleSelected(scope.node);
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('googleMediaItem', googleMediaItem)
        .controller('GoogleMediaItemController', GoogleMediaItemController);;

    /** @ngInject */
    function googleMediaItem($window, $interval, sessionService, CommonMediaService, $timeout,
        mediaService, requestContext) {
        return {
            restrict: 'E',
            transclude: true,
            replace: true,
            scope: {
                item: '=item',
                onSelect: '&'
            },
            templateUrl: "app/core/directives/google-media-item/google-media-item.html",
            controller: 'GoogleMediaItemController as vm',
            link: function (scope, $element, attrs) {

                generateItemUrl(scope, attrs);
                scope.stop = setInterval(() => {
                    calculateCaptionAndPosition(scope);
                }, 500);
                scope.$on('$destroy', function () {
                    window.clearInterval(scope.stop);
                    scope.watchAllCropped = false;
                });

                scope.watchAllCropped = true;

                scope.$watch('item.allCropped', isAllCropped)

                function isAllCropped(newVal, oldVal) {
                    if (!scope.watchAllCropped) return;
                    if (newVal != 1) {
                        // Cropping at work.
                        // Wait a moment and check again for current state.
                        $timeout(function () {
                            checkIsAllCropped(newVal);
                        }, 15000)
                    }
                    if (newVal == 1 && oldVal != newVal) {
                        // Cropping just finished.
                        // Reset media to replace cropping placeholder by thumb.
                        scope.item.allCropped = newVal;
                        generateItemUrl(scope, attrs);
                    }
                }

                function checkIsAllCropped(oldVal) {
                    if (scope.watchAllCropped &&
                        scope.item &&
                        scope.item.hasOwnProperty('id_media')
                    ) {
                        mediaService.getImageByID({
                            domain: requestContext.getParam("siteId"),
                            id_media: scope.item.id_media
                        }).then(function (resp) {
                            if (angular.isArray(resp.data) &&
                                resp.data.length > 0 &&
                                resp.data[0].hasOwnProperty('allCropped')
                            ) {
                                isAllCropped(resp.data[0].allCropped, oldVal);
                            } else {
                                console.log('Error retrieving "allCropped" status from media ' + scope.attachment.id_media)
                            }
                        })
                    }
                }

            }
        };

        function calculateCaptionAndPosition(scope) {
            var imgElement = $('.grid-google #' + scope.item.id_media);
            var width = imgElement.width();
            var contentTr;
            if (scope.lastwidth != width) {
                if (scope.item.media_type == 1 || scope.item.media_type == 3 || scope.item.media_type == 4) {
                    var classSelected = 'image-caption';
                    contentTr = templatePictureCaption(contentTr, scope);
                }
                if (scope.item.media_type == 2) {
                    var classSelected = 'caption-video';
                    var time = calculateTime(scope.item.duration);
                    contentTr = templateVideoCaption(contentTr, scope, time);
                }
                if ($('.grid-google .' + scope.item.id_media + '.' + classSelected).length == 0) {
                    contentTr.insertAfter(imgElement);
                }
                contentTr.on('click', function () {
                    scope.onSelect({ item: scope.item })
                });
                $('.grid-google .' + scope.item.id_media + '.' + classSelected).css('width', width + 'px')
                $('.grid-google .' + scope.item.id_media + '.' + classSelected).css('margin-left', '-' + (width + 5) + 'px')
                if (scope.item.media_type == 2) {
                    var video = $('.short-preview.' + scope.item.id_media)
                    video.hover(hoverVideo, hideVideo);
                    function hoverVideo(e) { video.get(0).play(); }
                    function hideVideo(e) { video.get(0).pause(); }
                }
                scope.lastwidth = width;
            }
        }

        function calculateTime(duration) {
            if (!duration) return { hours: null, minutes: null, seconds: null };
            var sec_num = parseInt(duration, 10); // don't forget the second param
            var hours = Math.floor(sec_num / 3600);
            var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
            var seconds = sec_num - (hours * 3600) - (minutes * 60);
            if (hours < 10) {
                hours = "0" + hours;
            }
            if (minutes < 10) {
                minutes = "0" + minutes;
            }
            if (seconds < 10) {
                seconds = "0" + seconds;
            }
            if (hours == '00') {
                hours = null;
            }
            if (minutes == '00') {
                minutes = null;
            }
            return { hours: hours, minutes: minutes, seconds: seconds };
        }


        function generateItemUrl(scope, attrs) {
            // [NEW] Use pre-calculated imageUrl if available (Mediahub support)
            if (scope.item.imageUrl) {
                scope.item.url = scope.item.imageUrl;
                return;
            }

            var cropFormatIdRaw = sessionService.getMediaThumbnailCropformatId();

            // Normalize to an array of IDs (as strings)
            var cropFormatIds = String(cropFormatIdRaw)
                .split(',')                       // split "1002,11004" → ["1002","11004"]
                .map(function (id) {              // trim spaces
                    return id.trim();
                })
                .filter(function (id) {           // remove empty values
                    return id.length > 0;
                });

            if (scope.item.media_type == 1) {
                var cropstatus = _.find(scope.item.cropstatus, function (c) {
                    // Ensure both sides are strings for a safe comparison
                    var currentId = String(c.id_cropformats);
                    return cropFormatIds.indexOf(currentId) !== -1;
                });

                if (scope.item.allCropped != 1 || !cropstatus) {
                    scope.item.url = 'assets/images/common/cropping_media.png';
                } else {
                    var container = sessionService.getContainerByID(cropstatus.id_container);
                    scope.item.url = container.view_url + cropstatus.fileName;
                }
            }

            if (scope.item.media_type == 2) {
                if (scope.item.allCropped != 1) {
                    scope.item.url = 'assets/images/common/cropping_media.png';
                } else {
                    if (scope.item.thumb) {
                        var cropFormatId = attrs.cropFormat || sessionService.getMediaThumbnailCropformatId();
                        var options = {
                            id_media: [scope.item.thumb],
                        };
                        CommonMediaService.getUrl(options)
                            .then(function (response) {
                                if (response.length > 0) {
                                    var cropstatus = _.find(response, function (c) {
                                        if (c.id_cropformats == cropFormatId) {
                                            return true;
                                        }
                                    });
                                    scope.item.url = cropstatus.url;
                                }
                            });
                    }
                    else if (scope.item.embed) {
                        var videoTypeSplit = scope.item.embed.split("|");
                        var videoType = videoTypeSplit[0];
                        scope.item.url = scope.item.embed_thumb;
                    }
                }
            }
            if (!scope.item.url) {
                scope.item.nomedia = true;
                var splited = scope.item.filename.split(".");
                var extension = splited[splited.length - 1];
                switch (extension) {
                    case "pdf":
                        scope.item.url = 'assets/images/common/pdf.jpg';
                        break;
                    case "json":
                        scope.item.url = 'assets/images/common/json.jpg';
                        break;
                    case "doc":
                        scope.item.url = 'assets/images/common/doc.jpg';
                        break;
                    case "docx":
                        scope.item.url = 'assets/images/common/doc.jpg';
                        break;
                    case "xls":
                        scope.item.url = 'assets/images/common/xls.jpg';
                        break;
                    case "xlsx":
                        scope.item.url = 'assets/images/common/xls.jpg';
                        break;
                    case "zip":
                        scope.item.url = 'assets/images/common/zip.jpg';
                        break;
                    case "rar":
                        scope.item.url = 'assets/images/common/zip.jpg';
                        break;
                    case "tgz":
                        scope.item.url = 'assets/images/common/zip.jpg';
                        break;
                    case "xml":
                        scope.item.url = 'assets/images/common/file.jpg';
                        break;
                    case "txt":
                        scope.item.url = 'assets/images/common/file.jpg';
                        break;
                    case "rtf":
                        scope.item.url = 'assets/images/common/file.jpg';
                        break;
                    case "ppt":
                        scope.item.url = 'assets/images/common/file.jpg';
                        break;
                    case "pptx":
                        scope.item.url = 'assets/images/common/file.jpg';
                        break;
                    case "mp3":
                        scope.item.url = 'assets/images/common/audio.jpg';
                        break;
                    case "wav":
                        scope.item.url = 'assets/images/common/audio.jpg';
                        break;
                    case "wma":
                        scope.item.url = 'assets/images/common/audio.jpg';
                        break;
                    case "indd":
                        scope.item.url = 'assets/images/common/file.jpg';
                        break;
                    default:
                        scope.item.url = 'assets/images/common/file.jpg';
                        break;
                }

            }
        }

        function templatePictureCaption(contentTr, scope) {
            contentTr = angular.element(`<span  class="image-caption ` + scope.item.id_media + `">
                                    <div class="info-caption size word-break-word" layout="row" layout-align="start left">
                                        <div class="layout-row layout-wrap">
                                            <strong class="mr-5">#` + scope.item.id_media + `</strong>
                                            <span class="word-break-all">
                                                <span >` + scope.item.date_uploaded + `</span>
                                            </span>
                                        </div>
                                        <div>
                                         <span title="` + scope.item.filename + `" class="filename">` + scope.item.filename + `</span>
                                        </div>
                                    </div>
                                </span>`);
            return contentTr;
        }

        function templateVideoCaption(contentTr, scope, time) {
            return angular.element(`<div class="caption-video ` + scope.item.id_media + `">
                                        <span class="time-caption">` + (time.hours ? time.hours + `:` : '') + (time.minutes ? time.minutes + `:` : (time.seconds ? '0' + `:` : '')) + (time.seconds ? time.seconds : '') + `</span><i class="icon s16 icon-video"></i>
                                        <div class="info-caption size word-break-word" layout="row" layout-align="start left">
                                            <div class="layout-row layout-wrap">
                                                <strong class="mr-5">#` + scope.item.id_media + `</strong>
                                                <span class="word-break-all">
                                                    <span >` + scope.item.date_uploaded + `</span>
                                                </span>
                                            </div>
                                            <div>
                                                <span title="` + scope.item.filename + `" class="filename">` + scope.item.filename + `</span>
                                            </div>
                                        </div>
                                        <video  width="100%" loop preload="metadata" muted class="short-preview ` + scope.item.id_media + `">
                                            <source  type="video/mp4" src="`+ scope.item.short_preview + `">
                                            Your browser does not support the video tag.
                                        </video>
                                    </div>`);
        }

    }
    function GoogleMediaItemController($scope) {
        var vm = this;
        vm.$onInit = function () {
            vm.item = $scope.item;
        }
    }
})();

/**
 * md-color-picker-custom - Angular-Material inspired color picker.
 * @version v0.2.6
 * @link https://github.com/brianpkelley/md-color-picker-custom
 * @license MIT
 */
;(function(angular, window, tinycolor) {

(function( window, angular, undefined ) {
'use strict';
var dateClick;

var GradientCanvas = function( type, restrictX ) {

	this.type = type;
	this.restrictX = restrictX;
	this.offset = {
		x: null,
		y: null
	};
	this.height = 255;

	this.$scope = null;
	this.$element = null;

	this.get = angular.bind(this, function( $temp_scope, $temp_element, $temp_attrs ) {
		////////////////////////////
		// Variables
		////////////////////////////

		this.$scope = $temp_scope;
		this.$element = $temp_element;


		this.canvas = this.$element.children()[0];
		this.marker = this.$element.children()[1];
		this.context = this.canvas.getContext('2d');
		this.currentColor = this.$scope.color.toRgb();
		this.currentHue = this.$scope.color.toHsv().h;
		////////////////////////////
		// Watchers, Observes, Events
		////////////////////////////

		//$scope.$watch( function() { return color.getRgb(); }, hslObserver, true );



		this.$element.on( 'mousedown', angular.bind( this, this.onMouseDown ) );
		this.$scope.$on('mdColorPickerCustom:colorSet', angular.bind( this, this.onColorSet ) );
		if ( this.extra ) {
			this.extra();
		};
		////////////////////////////
		// init
		////////////////////////////

		this.draw();
	});

	//return angular.bind( this, this.get );

};
GradientCanvas.prototype.$window = angular.element( window );

GradientCanvas.prototype.getColorByMouse = function( e ) {
	var x = e.pageX - this.offset.x;
	var y = e.pageY - this.offset.y;

	return this.getColorByPoint( x, y );
};

GradientCanvas.prototype.setMarkerCenter = function( x, y ) {
	var xOffset = -1 * this.marker.offsetWidth / 2;
	var yOffset = -1 * this.marker.offsetHeight / 2;
	if ( y === undefined ) {
		y = x + yOffset;
		y = Math.max( Math.min( this.height-1 + yOffset, y ), Math.ceil( yOffset ) );

		x = 0;
	} else {
		x = x + xOffset;
		y = y + yOffset;

		x = Math.max( Math.min( this.height + xOffset, x ), Math.ceil( xOffset ) );
		y = Math.max( Math.min( this.height + yOffset, y ), Math.ceil( yOffset ) );
	}



	angular.element(this.marker).css({'left': x + 'px' });
	angular.element(this.marker).css({'top': y + 'px'});
};

GradientCanvas.prototype.getMarkerCenter = function() {
	var returnObj = {
		x: this.marker.offsetLeft + ( Math.floor( this.marker.offsetWidth / 2 ) ),
		y: this.marker.offsetTop + ( Math.floor( this.marker.offsetHeight / 2 ) )
	};
	return returnObj;
};

GradientCanvas.prototype.getImageData = function( x, y ) {
	x = Math.max( 0, Math.min( x, this.canvas.width-1 ) );
	y = Math.max( 0, Math.min( y, this.canvas.height-1 ) );

	var imageData = this.context.getImageData( x, y, 1, 1 ).data;
	return imageData;
};

GradientCanvas.prototype.onMouseDown = function( e ) {
	// Prevent highlighting
	e.preventDefault();
	e.stopImmediatePropagation();

	this.$scope.previewUnfocus();

	this.$element.css({ 'cursor': 'none' });

	this.offset.x = this.canvas.getBoundingClientRect().left+1;
	this.offset.y = this.canvas.getBoundingClientRect().top;

	var fn = angular.bind( this, function( e ) {
		switch( this.type ) {
			case 'hue':
				var hue = this.getColorByMouse( e );
				this.$scope.$broadcast( 'mdColorPickerCustom:spectrumHueChange', {hue: hue});
				break;
			case 'alpha':
				var alpha = this.getColorByMouse( e );
				this.$scope.color.setAlpha( alpha );
				this.$scope.alpha = alpha;
				this.$scope.$apply();
				break;
			case 'spectrum':
				var color = this.getColorByMouse( e );
				this.setColor( color );
				break;
		}
	});

	this.$window.on( 'mousemove', fn );
	this.$window.one( 'mouseup', angular.bind(this, function( e ) {
		this.$window.off( 'mousemove', fn );
		this.$element.css({ 'cursor': 'crosshair' });
	}));

	// Set the color
	fn( e );
};

GradientCanvas.prototype.setColor = function( color ) {

		this.$scope.color._r = color.r;
		this.$scope.color._g = color.g;
		this.$scope.color._b = color.b;
		this.$scope.$apply();
		this.$scope.$broadcast('mdColorPickerCustom:spectrumColorChange', { color: color });
};

GradientCanvas.prototype.onColorSet = function( e, args ) {
	switch( this.type ) {
		case 'hue':
			var hsv = this.$scope.color.toHsv();
			this.setMarkerCenter( this.canvas.height - ( this.canvas.height * ( hsv.h / 360 ) ) );
			break;
		case 'alpha':
			this.currentColor = args.color.toRgb();
			this.draw();

			var alpha = args.color.getAlpha();
			var pos = this.canvas.height - ( this.canvas.height * alpha );

			this.setMarkerCenter( pos );
			break;
		case 'spectrum':
			var hsv = args.color.toHsv();
			this.currentHue = hsv.h;
			this.draw();

			var posX = this.canvas.width * hsv.s;
			var posY = this.canvas.height - ( this.canvas.height * hsv.v );

			this.setMarkerCenter( posX, posY );
			break;
	}

};

var hueLinkFn = new GradientCanvas( 'hue', true );
hueLinkFn.getColorByPoint = function( x, y ) {
	var imageData = this.getImageData( x, y );
	this.setMarkerCenter( y );

	var hsl = new tinycolor( {r: imageData[0], g: imageData[1], b: imageData[2] } );
	return hsl.toHsl().h;

};
hueLinkFn.draw = function()  {


	this.$element.css({'height': this.height + 'px'});

	this.canvas.height = this.height;
	this.canvas.width = this.height;



	// Create gradient
	var hueGrd = this.context.createLinearGradient(90, 0.000, 90, this.height);

	// Add colors
	hueGrd.addColorStop(0.01,	'rgba(255, 0, 0, 1.000)');
	hueGrd.addColorStop(0.167, 	'rgba(255, 0, 255, 1.000)');
	hueGrd.addColorStop(0.333, 	'rgba(0, 0, 255, 1.000)');
	hueGrd.addColorStop(0.500, 	'rgba(0, 255, 255, 1.000)');
	hueGrd.addColorStop(0.666, 	'rgba(0, 255, 0, 1.000)');
	hueGrd.addColorStop(0.828, 	'rgba(255, 255, 0, 1.000)');
	hueGrd.addColorStop(0.999, 	'rgba(255, 0, 0, 1.000)');

	// Fill with gradient
	this.context.fillStyle = hueGrd;
	this.context.fillRect( 0, 0, this.canvas.width, this.height );
};


var alphaLinkFn = new GradientCanvas( 'alpha', true );
alphaLinkFn.getColorByPoint = function( x, y ) {
	var imageData = this.getImageData( x, y );
	this.setMarkerCenter( y );

	return imageData[3] / 255;
};
alphaLinkFn.draw = function ()  {
	this.$element.css({'height': this.height + 'px'});

	this.canvas.height = this.height;
	this.canvas.width = this.height;

	// Create gradient
	var hueGrd = this.context.createLinearGradient(90, 0.000, 90, this.height);

	// Add colors
	hueGrd.addColorStop(0.01,	'rgba(' + this.currentColor.r + ',' + this.currentColor.g + ',' + this.currentColor.b + ', 1.000)');
	hueGrd.addColorStop(0.999,	'rgba(' + this.currentColor.r + ',' + this.currentColor.g + ',' + this.currentColor.b + ', 0.000)');

	// Fill with gradient
	this.context.fillStyle = hueGrd;
	this.context.fillRect( 0, 0, this.canvas.width, this.height );
};
alphaLinkFn.extra = function() {
	this.$scope.$on('mdColorPickerCustom:spectrumColorChange', angular.bind( this, function( e, args ) {
		this.currentColor = args.color;
		this.draw();
	}));
};


var spectrumLinkFn = new GradientCanvas( 'spectrum', false );
spectrumLinkFn.getColorByPoint = function( x, y ) {
	var imageData = this.getImageData( x, y );
 	this.setMarkerCenter(x,y);

	return {
		r: imageData[0],
		g: imageData[1],
		b: imageData[2]
	};
};
spectrumLinkFn.draw = function() {
	this.canvas.height = this.height;
	this.canvas.width = this.height;
	this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
	// White gradient

	var whiteGrd = this.context.createLinearGradient(0, 0, this.canvas.width, 0);

	whiteGrd.addColorStop(0, 'rgba(255, 255, 255, 1.000)');
	whiteGrd.addColorStop(1, 'rgba(255, 255, 255, 0.000)');

	// Black Gradient
	var blackGrd = this.context.createLinearGradient(0, 0, 0, this.canvas.height);

	blackGrd.addColorStop(0, 'rgba(0, 0, 0, 0.000)');
	blackGrd.addColorStop(1, 'rgba(0, 0, 0, 1.000)');

	// Fill with solid
	this.context.fillStyle = 'hsl( ' + this.currentHue + ', 100%, 50%)';
	this.context.fillRect( 0, 0, this.canvas.width, this.canvas.height );

	// Fill with white
	this.context.fillStyle = whiteGrd;
	this.context.fillRect( 0, 0, this.canvas.width, this.canvas.height );

	// Fill with black
	this.context.fillStyle = blackGrd;
	this.context.fillRect( 0, 0, this.canvas.width, this.canvas.height );
};
spectrumLinkFn.extra = function() {
	this.$scope.$on('mdColorPickerCustom:spectrumHueChange', angular.bind( this, function( e, args ) {
		this.currentHue = args.hue;
		this.draw();
		var markerPos = this.getMarkerCenter();
		var color = this.getColorByPoint( markerPos.x, markerPos.y );
		this.setColor( color );

	}));
};


angular.module('mdColorPickerCustom', [])
	.run(['$templateCache', function ($templateCache) {
		//icon resource should not be dependent
		//credit to materialdesignicons.com
		var shapes = {
			'clear': '<path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>',
			'gradient': '<path d="M11 9h2v2h-2zm-2 2h2v2H9zm4 0h2v2h-2zm2-2h2v2h-2zM7 9h2v2H7zm12-6H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 18H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2zm2-7h-2v2h2v2h-2v-2h-2v2h-2v-2h-2v2H9v-2H7v2H5v-2h2v-2H5V5h14v6z"/>',
			'tune': '<path d="M13 21v-2h8v-2h-8v-2h-2v6h2zM3 17v2h6v-2H3z"/><path d="M21 13v-2H11v2h10zM7 9v2H3v2h4v2h2V9H7z"/><path d="M15 9h2V7h4V5h-4V3h-2v6zM3 5v2h10V5H3z"/>',
			'view_module': '<path d="M4 11h5V5H4v6z"/><path d="M4 18h5v-6H4v6z"/><path d="M10 18h5v-6h-5v6z"/><path d="M16 18h5v-6h-5v6z"/><path d="M10 11h5V5h-5v6z"/><path d="M16 5v6h5V5h-5z"/>',
			'view_headline': '<path d="M4 15h17v-2H4v2z"/><path d="M4 19h17v-2H4v2z"/><path d="M4 11h17V9H4v2z"/><path d="M4 5v2h17V5H4z"/>',
			'history': '<path d="M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9z"/><path d="M12 8v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"/>',
			'clear_all': '<path d="M5 13h14v-2H5v2zm-2 4h14v-2H3v2zM7 7v2h14V7H7z"/>'
		};
		for (var i in shapes) {
			if (shapes.hasOwnProperty(i)) {
				$templateCache.put([i, 'svg'].join('.'),
					['<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">', shapes[i], '</svg>'].join(''));
			}
		}
	}])
	.factory('mdColorPickerCustomHistory', ['$injector', function( $injector ) {

		var history = [];
		var strHistory = [];

		var $cookies = false;
		try {
			$cookies = $injector.get('$cookies');
		} catch(e) {

		}

		if ( $cookies ) {
			var tmpHistory = $cookies.getObject( 'mdColorPickerCustomHistory' ) || [];
			for ( var i = 0; i < tmpHistory.length; i++ ) {
				history.push( tinycolor( tmpHistory[i] ) );
				strHistory.push( tmpHistory[i] );
			}
		}

		var length = 40;

		return {
			length: function() {
				if ( arguments[0] ) {
					length = arguments[0];
				} else {
					return history.length;
				}
			},
			add: function( color ) {
				for( var x = 0; x < history.length; x++ ) {
					if ( history[x].toRgbString() === color.toRgbString() ) {
						history.splice(x, 1);
						strHistory.splice(x, 1);
					}
				}

				history.unshift( color );
				strHistory.unshift( color.toRgbString() );

				if ( history.length > length ) {
					history.pop();
					strHistory.pop();
				}
				if ( $cookies ) {
					$cookies.putObject('mdColorPickerCustomHistory', strHistory );
				}
			},
			get: function() {
				return history;
			},
			reset: function() {
				history = [];
				strHistory = [];
				if ( $cookies ) {
					$cookies.putObject('mdColorPickerCustomHistory', strHistory );
				}
			}
		};
	}])
	.directive('mdColorPickerCustom', [ '$timeout', 'mdColorPickerCustomHistory', function( $timeout, colorHistory ) {

		return {
			templateUrl: "mdColorPickerCustom.tpl.html",

			// Added required controller ngModel
			require: '^ngModel',
			scope: {
				options: '=mdColorPickerCustom',

				// Input options
				type: '@',
				label: '@',
				icon: '@',
				random: '@',
				default: '@',

				// Dialog Options
				openOnInput: '@',
				hasBackdrop: '@',
				clickOutsideToClose: '@',
				skipHide: '@',
				preserveScope: '@',

				// Advanced options
				mdColorClearButton: '=?',
				mdColorPreview: '=?',

				mdColorAlphaChannel: '=?',
				mdColorSpectrum: '=?',
				mdColorSliders: '=?',
				mdColorGenericPalette: '=?',
				mdColorMaterialPalette: '=?',
				mdColorHistory: '=?',
				mdColorDefaultTab: '=?'
			},
			controller: ['$scope', '$element', '$attrs', '$mdDialog', '$mdColorPickerCustom', function( $scope, $element, $attrs, $mdDialog, $mdColorPickerCustom ) {
				var didJustClose = false;

				// Merge Options Object with scope.  Scope will take precedence much like css vs style attribute.
				if ( $scope.options !== undefined ) {
					for ( var opt in $scope.options ) {
						if ( $scope.options.hasOwnProperty( opt ) ) {
							var scopeVal = undefined;
							var scopeKey = undefined;
							if ( $scope.hasOwnProperty( opt ) ) {
								scopeKey = opt;
							} else if ( $scope.hasOwnProperty( 'mdColor' + opt.slice(0,1).toUpperCase() + opt.slice(1) ) ) {
								scopeKey = 'mdColor' + opt.slice(0,1).toUpperCase() + opt.slice(1);
							}

							if ( scopeKey && $scope[scopeKey] === undefined ) {
								$scope[scopeKey] = $scope.options[opt];
							}
						}
					}
				}

				// Get ngModelController from the current element
				var ngModel = $element.controller('ngModel');

				// Quick function for updating the local 'value' on scope
				var updateValue = function(val) {
					$scope.value = val || ngModel.$viewValue || '';
				};

				// Defaults
				// Everything is enabled by default.
				$scope.mdColorClearButton = $scope.mdColorClearButton === undefined ? true : $scope.mdColorClearButton;
				$scope.mdColorPreview = $scope.mdColorPreview === undefined ? true : $scope.mdColorPreview;

				$scope.mdColorAlphaChannel = $scope.mdColorAlphaChannel === undefined ? true : $scope.mdColorAlphaChannel;
				$scope.mdColorSpectrum = $scope.mdColorSpectrum === undefined ? true : $scope.mdColorSpectrum;
				$scope.mdColorSliders = $scope.mdColorSliders === undefined ? true : $scope.mdColorSliders;
				$scope.mdColorGenericPalette = $scope.mdColorGenericPalette === undefined ? true : $scope.mdColorGenericPalette;
				$scope.mdColorMaterialPalette = $scope.mdColorMaterialPalette === undefined ? true : $scope.mdColorMaterialPalette;
				$scope.mdColorHistory = $scope.mdColorHistory === undefined ? true : $scope.mdColorHistory;


				// Set the starting value
				updateValue();

				// Keep an eye on changes
				$scope.$watch(function() {
					return ngModel.$modelValue;
				},function(newVal) {
					updateValue(newVal);
				});

				// Watch for updates to value and set them on the model
				$scope.$watch('value',function(newVal,oldVal) {
					if (newVal !== '' && typeof newVal !== 'undefined' && newVal && newVal !== oldVal) {
						ngModel.$setViewValue(newVal);
					}
				});

				// The only other ngModel changes

				$scope.clearValue = function clearValue() {
					$scope.value = '';
				};
				
				$scope.showColorPicker = function showColorPicker($event) {
					if($scope.value.length == 0){
						$scope.value = '#';
					}					
					if ( didJustClose ) {
						return;
					}
				//	dateClick = Date.now();
				//	console.log( "CLICK OPEN", dateClick, $scope );

					$mdColorPickerCustom.show({
						value: $scope.value,
						defaultValue: $scope.default,
						random: $scope.random,
						clickOutsideToClose: $scope.clickOutsideToClose,
						hasBackdrop: $scope.hasBackdrop,
						skipHide: $scope.skipHide,
						preserveScope: $scope.preserveScope,

						mdColorAlphaChannel: $scope.mdColorAlphaChannel,
						mdColorSpectrum: $scope.mdColorSpectrum,
						mdColorSliders: $scope.mdColorSliders,
						mdColorGenericPalette: $scope.mdColorGenericPalette,
						mdColorMaterialPalette: $scope.mdColorMaterialPalette,
						mdColorHistory: $scope.mdColorHistory,
						mdColorDefaultTab: $scope.mdColorDefaultTab,

						$event: $event,

					}).then(function( color ) {
						$scope.value = color;
					});
				};
			}],
			compile: function( element, attrs ) {

				//attrs.value = attrs.value || "#ff0000";
				attrs.type = attrs.type !== undefined ? attrs.type : 0;

			}
		};
	}])
	.directive( 'mdColorPickerCustomContainer', ['$compile','$timeout','$mdColorPalette','mdColorPickerCustomHistory', function( $compile, $timeout, $mdColorPalette, colorHistory ) {
		return {
			templateUrl: 'mdColorPickerCustomContainer.tpl.html',
			scope: {
				value: '=?',
				default: '@',
				random: '@',
				ok: '=?',
				mdColorAlphaChannel: '=',
				mdColorSpectrum: '=',
				mdColorSliders: '=',
				mdColorGenericPalette: '=',
				mdColorMaterialPalette: '=',
				mdColorHistory: '=',
				mdColorDefaultTab: '='
			},
			controller: ["$scope", "$element", "$attrs", function( $scope, $element, $attrs ) {
			//	console.log( "mdColorPickerCustomContainer Controller", Date.now() - dateClick, $scope );

				function getTabIndex( tab ) {
					var index = 0;
					if ( tab && typeof( tab ) === 'string' ) {
/* DOM isn't fast enough for this

						var tabs = $element[0].querySelector('.md-color-picker-custom-colors').getElementsByTagName( 'md-tab' );
						console.log( tabs.length );
*/
						var tabName = 'mdColor' + tab.slice(0,1).toUpperCase() + tab.slice(1);
						var tabs = ['mdColorSpectrum', 'mdColorSliders', 'mdColorGenericPalette', 'mdColorMaterialPalette', 'mdColorHistory'];
						for ( var x = 0; x < tabs.length; x++ ) {
							//console.log(  tabs[x]('ng-if') );
							//if ( tabs[x].getAttribute('ng-if') == tabName ) {
							if ( tabs[x] == tabName ) {
								if ( $scope[tabName] ) {
									index = x;
									break;
								}
							}
						}
					} else if ( tab && typeof ( tab ) === 'number') {
						index = tab;
					}

					return index;
				}

				///////////////////////////////////
				// Variables
				///////////////////////////////////
				var container = angular.element( $element[0].querySelector('.md-color-picker-custom-container') );
				var resultSpan = angular.element( container[0].querySelector('.md-color-picker-custom-result') );
				var previewInput = angular.element( $element[0].querySelector('.md-color-picker-custom-preview-input') );

				var outputFn = [
					'toHexString',
					'toRgbString',
					'toHslString'
				];



				$scope.default = $scope.default ? $scope.default : $scope.random ? tinycolor.random() : 'rgb(255,255,255)';
				if ( $scope.value.search('#') >= 0 ) {
					$scope.type = 0;
				} else if ( $scope.value.search('rgb') >= 0 ) {
					$scope.type = 1;
				} else if ( $scope.value.search('hsl') >= 0 ) {
					$scope.type = 2;
				}
				$scope.color = new tinycolor($scope.value || $scope.default); // Set initial color
				$scope.alpha = $scope.color.getAlpha();
				$scope.history =  colorHistory;
				$scope.materialFamily = [];

				$scope.whichPane = getTabIndex( $scope.mdColorDefaultTab );
				$scope.inputFocus = false;

				// Colors for the palette screen
				///////////////////////////////////
				var steps = 9;
				var freq = 2*Math.PI/steps;

				$scope.palette = [
					["rgb(255, 204, 204)","rgb(255, 230, 204)","rgb(255, 255, 204)","rgb(204, 255, 204)","rgb(204, 255, 230)","rgb(204, 255, 255)","rgb(204, 230, 255)","rgb(204, 204, 255)","rgb(230, 204, 255)","rgb(255, 204, 255)"],
					["rgb(255, 153, 153)","rgb(255, 204, 153)","rgb(255, 255, 153)","rgb(153, 255, 153)","rgb(153, 255, 204)","rgb(153, 255, 255)","rgb(153, 204, 255)","rgb(153, 153, 255)","rgb(204, 153, 255)","rgb(255, 153, 255)"],
					["rgb(255, 102, 102)","rgb(255, 179, 102)","rgb(255, 255, 102)","rgb(102, 255, 102)","rgb(102, 255, 179)","rgb(102, 255, 255)","rgb(102, 179, 255)","rgb(102, 102, 255)","rgb(179, 102, 255)","rgb(255, 102, 255)"],
					["rgb(255, 51, 51)","rgb(255, 153, 51)","rgb(255, 255, 51)","rgb(51, 255, 51)","rgb(51, 255, 153)","rgb(51, 255, 255)","rgb(51, 153, 255)","rgb(51, 51, 255)","rgb(153, 51, 255)","rgb(255, 51, 255)"],
					["rgb(255, 0, 0)","rgb(255, 128, 0)","rgb(255, 255, 0)","rgb(0, 255, 0)","rgb(0, 255, 128)","rgb(0, 255, 255)","rgb(0, 128, 255)","rgb(0, 0, 255)","rgb(128, 0, 255)","rgb(255, 0, 255)"],
					["rgb(245, 0, 0)","rgb(245, 123, 0)","rgb(245, 245, 0)","rgb(0, 245, 0)","rgb(0, 245, 123)","rgb(0, 245, 245)","rgb(0, 123, 245)","rgb(0, 0, 245)","rgb(123, 0, 245)","rgb(245, 0, 245)"],
					["rgb(214, 0, 0)","rgb(214, 108, 0)","rgb(214, 214, 0)","rgb(0, 214, 0)","rgb(0, 214, 108)","rgb(0, 214, 214)","rgb(0, 108, 214)","rgb(0, 0, 214)","rgb(108, 0, 214)","rgb(214, 0, 214)"],
					["rgb(163, 0, 0)","rgb(163, 82, 0)","rgb(163, 163, 0)","rgb(0, 163, 0)","rgb(0, 163, 82)","rgb(0, 163, 163)","rgb(0, 82, 163)","rgb(0, 0, 163)","rgb(82, 0, 163)","rgb(163, 0, 163)"],
					["rgb(92, 0, 0)","rgb(92, 46, 0)","rgb(92, 92, 0)","rgb(0, 92, 0)","rgb(0, 92, 46)","rgb(0, 92, 92)","rgb(0, 46, 92)","rgb(0, 0, 92)","rgb(46, 0, 92)","rgb(92, 0, 92)"],
					["rgb(255, 255, 255)","rgb(205, 205, 205)","rgb(178, 178, 178)","rgb(153, 153, 153)","rgb(127, 127, 127)","rgb(102, 102, 102)","rgb(76, 76, 76)","rgb(51, 51, 51)","rgb(25, 25, 25)","rgb(0, 0, 0)"]
				];

				$scope.materialPalette = $mdColorPalette;

				///////////////////////////////////
				// Functions
				///////////////////////////////////
				$scope.isDark = function isDark( color ) {
					if ( angular.isArray( color ) ) {
						return tinycolor( {r: color[0], g: color[1], b: color[2] }).isDark();
					} else {
						return tinycolor( color ).isDark();
					}

				};
				$scope.previewFocus = function() {
					$scope.inputFocus = true;
					$timeout( function() {
						previewInput[0].setSelectionRange(0, previewInput[0].value.length);
					});
				};
				$scope.previewUnfocus = function() {
					$scope.inputFocus = false;
					previewInput[0].blur();
				};
				$scope.previewBlur = function() {
					$scope.inputFocus = false;
					$scope.setValue();
				};
				$scope.previewKeyDown = function( $event ) {

					if ( $event.keyCode == 13 ) {
						$scope.ok && $scope.ok();
					}
				};
				$scope.setPaletteColor = function( event ) {
					$timeout( function() {
						$scope.color = tinycolor( event.target.style.backgroundColor );
					});
				};

				$scope.setValue = function setValue() {
					// Set the value if available
					if ( $scope.color && $scope.color && outputFn[$scope.type] && $scope.color.toRgbString() !== 'rgba(0, 0, 0, 0)' ) {
						$scope.value = $scope.color[outputFn[$scope.type]]();
					}
				};

				$scope.changeValue = function changeValue() {
					$scope.color = tinycolor( $scope.value );
					$scope.$broadcast('mdColorPickerCustom:colorSet', { color: $scope.color });
				};


				///////////////////////////////////
				// Watches and Events
				///////////////////////////////////
				$scope.$watch( 'color._a', function( newValue ) {
					$scope.color.setAlpha( newValue );
				}, true);

				$scope.$watch( 'whichPane', function( newValue ) {
					// 0 - spectrum selector
					// 1 - sliders
					// 2 - palette
					$scope.$broadcast('mdColorPickerCustom:colorSet', {color: $scope.color });

				});

				$scope.$watch( 'type', function() {
					previewInput.removeClass('switch');
					$timeout(function() {
						previewInput.addClass('switch');
					});
				});

				$scope.$watchGroup(['color.toRgbString()', 'type'], function( newValue ) {
					if ( !$scope.inputFocus ) {
						$scope.setValue();
					}
				});


				///////////////////////////////////
				// INIT
				// Let all the other directives initialize
				///////////////////////////////////
			//	console.log( "mdColorPickerCustomContainer Controller PRE Timeout", Date.now() - dateClick );
				$timeout( function() {
			//		console.log( "mdColorPickerCustomContainer Controller Timeout", Date.now() - dateClick );
					$scope.$broadcast('mdColorPickerCustom:colorSet', { color: $scope.color });
					previewInput.focus();
					$scope.previewFocus();
				});
			}],
			link: function( scope, element, attrs ) {

				var tabs = element[0].getElementsByTagName( 'md-tab' );
				/*
				Replicating these structure without ng-repeats

				<div ng-repeat="row in palette track by $index" flex="15"  layout-align="space-between" layout="row"  layout-fill>
					<div ng-repeat="col in row track by $index" flex="10" style="height: 25.5px;" ng-style="{'background': col};" ng-click="setPaletteColor($event)"></div>
				</div>

				<div ng-repeat="(key, value) in materialColors">
					<div ng-style="{'background': 'rgb('+value['500'].value[0]+','+value['500'].value[1]+','+value['500'].value[2]+')', height: '75px'}" class="md-color-picker-custom-material-title" ng-class="{'dark': isDark( value['500'].value )}" ng-click="setPaletteColor($event)">
						<span>{{key}}</span>
					</div>
					<div ng-repeat="(label, color) in value track by $index" ng-style="{'background': 'rgb('+color.value[0]+','+color.value[1]+','+color.value[2]+')', height: '33px'}" class="md-color-picker-custom-with-label" ng-class="{'dark': isDark( color.value )}" ng-click="setPaletteColor($event)">
						<span>{{label}}</span>
					</div>
				</div>
				*/


				$timeout(function() {
					createDOM();
				});

				function createDOM() {
					var paletteContainer = angular.element( element[0].querySelector('.md-color-picker-custom-palette') );
					var materialContainer = angular.element( element[0].querySelector('.md-color-picker-custom-material-palette') );
					var paletteRow = angular.element('<div class="flex-15 layout-fill layout-row layout-align-space-between" layout-align="space-between" layout="row" layout-fill"></div>');
					var paletteCell = angular.element('<div class="flex-10"></div>');

					var materialTitle = angular.element('<div class="md-color-picker-custom-material-title"></div>');
					var materialRow = angular.element('<div class="md-color-picker-custom-with-label"></div>');



					angular.forEach(scope.palette, function( value, key ) {
						var row = paletteRow.clone();
						angular.forEach( value, function( color ) {
							var cell = paletteCell.clone();
							cell.css({
								height: '25.5px',
								backgroundColor: color
							});
							cell.bind('click', scope.setPaletteColor );
							row.append( cell );
						});

						paletteContainer.append( row );
					});

					angular.forEach(scope.materialPalette, function( value, key ) {
						var title = materialTitle.clone();
						title.html('<span>'+key.replace('-',' ')+'</span>');
						title.css({
							height: '75px',
							backgroundColor: 'rgb('+value['500'].value[0]+','+value['500'].value[1]+','+value['500'].value[2]+')'
						});
						if ( scope.isDark(value['500'].value) ) {
							title.addClass('dark');
						}

						materialContainer.append( title );

						angular.forEach( value, function( color, label ) {

							var row = materialRow.clone();
							row.css({
								height: '33px',
								backgroundColor: 'rgb('+color.value[0]+','+color.value[1]+','+color.value[2]+')'
							});
							if ( scope.isDark(color.value) ) {
								row.addClass('dark');
							}

							row.html('<span>'+label+'</span>');
							row.bind('click', scope.setPaletteColor );
							materialContainer.append( row );
						});


					});
				}
			}
		};
	}])

	.directive( 'mdColorPickerCustomHue', [function() {
		return {
			template: '<canvas width="100%" height="100%"></canvas><div class="md-color-picker-custom-marker"></div>',
			link: hueLinkFn.get,
			controller: function() {
			//	console.log( "mdColorPickerCustomHue Controller", Date.now() - dateClick );
			}
		};
	}])

	.directive( 'mdColorPickerCustomAlpha', [function() {
		return {
			template: '<canvas width="100%" height="100%"></canvas><div class="md-color-picker-custom-marker"></div>',
			link: alphaLinkFn.get,
			controller: function() {
			//	console.log( "mdColorPickerCustomAlpha Controller", Date.now() - dateClick );
			}
		};
	}])

	.directive( 'mdColorPickerCustomSpectrum', [function() {
		return {
			template: '<canvas width="100%" height="100%"></canvas><div class="md-color-picker-custom-marker"></div>{{hue}}',
			link: spectrumLinkFn.get,
			controller: function() {
			//	console.log( "mdColorPickerCustomSpectrum Controller", Date.now() - dateClick );
			}
		};
	}])

    .factory('$mdColorPickerCustom', ['$q', '$mdDialog', 'mdColorPickerCustomHistory', function ($q, $mdDialog, colorHistory)
    {
		var dialog;

        return {
            show: function (options)
            {
                if ( options === undefined ) {
                    options = {};
                }
				//console.log( 'DIALOG OPTIONS', options );
				// Defaults
				// Dialog Properties
                options.hasBackdrop = options.hasBackdrop === undefined ? true : options.hasBackdrop;
				options.clickOutsideToClose = options.clickOutsideToClose === undefined ? true : options.clickOutsideToClose;
				options.defaultValue = options.defaultValue === undefined ? '#FFFFFF' : options.defaultValue;
				options.focusOnOpen = options.focusOnOpen === undefined ? false : options.focusOnOpen;
				options.preserveScope = options.preserveScope === undefined ? true : options.preserveScope;
				options.skipHide = options.skipHide === undefined ? true : options.skipHide;

				// mdColorPickerCustom Properties
				options.mdColorAlphaChannel = options.mdColorAlphaChannel === undefined ? false : options.mdColorAlphaChannel;
				options.mdColorSpectrum = options.mdColorSpectrum === undefined ? true : options.mdColorSpectrum;
				options.mdColorSliders = options.mdColorSliders === undefined ? true : options.mdColorSliders;
				options.mdColorGenericPalette = options.mdColorGenericPalette === undefined ? true : options.mdColorGenericPalette;
				options.mdColorMaterialPalette = options.mdColorMaterialPalette === undefined ? true : options.mdColorMaterialPalette;
				options.mdColorHistory = options.mdColorHistory === undefined ? true : options.mdColorHistory;





                dialog = $mdDialog.show({
					templateUrl: 'mdColorPickerCustomDialog.tpl.html',
					hasBackdrop: options.hasBackdrop,
					clickOutsideToClose: options.clickOutsideToClose,

					controller: ['$scope', 'options', function( $scope, options ) {
							//console.log( "DIALOG CONTROLLER OPEN", Date.now() - dateClick );
							$scope.close = function close()
                            {
								$mdDialog.cancel();
							};
							$scope.ok = function ok()
							{
								$mdDialog.hide( $scope.value );
							};
							$scope.hide = $scope.ok;



							$scope.value = options.value;
							$scope.default = options.defaultValue;
							$scope.random = options.random;

							$scope.mdColorAlphaChannel = options.mdColorAlphaChannel;
							$scope.mdColorSpectrum = options.mdColorSpectrum;
							$scope.mdColorSliders = options.mdColorSliders;
							$scope.mdColorGenericPalette = options.mdColorGenericPalette;
							$scope.mdColorMaterialPalette = options.mdColorMaterialPalette;
							$scope.mdColorHistory = options.mdColorHistory;
							$scope.mdColorDefaultTab = options.mdColorDefaultTab;

					}],

					locals: {
						options: options,
					},
					preserveScope: options.preserveScope,
  					skipHide: options.skipHide,

					targetEvent: options.$event,
					focusOnOpen: options.focusOnOpen,
					autoWrap: false,
					onShowing: function() {
				//		console.log( "DIALOG OPEN START", Date.now() - dateClick );
					},
					onComplete: function() {
				//		console.log( "DIALOG OPEN COMPLETE", Date.now() - dateClick );
					}
                });

				dialog.then(function (value) {
                    colorHistory.add(new tinycolor(value));
                }, function () { });

                return dialog;
            },
			hide: function() {
				return dialog.hide();
			},
			cancel: function() {
				return dialog.cancel();
			}
		};
	}]);
})( window, window.angular );

angular.module("mdColorPickerCustom").run(["$templateCache", function($templateCache) {$templateCache.put("mdColorPickerCustom.tpl.html","<div class=\"md-color-picker-custom-input-container\" layout=\"row\">\n	<div class=\"md-color-picker-custom-preview md-color-picker-custom-checkered-bg\" ng-click=\"showColorPicker($event)\" ng-if=\"mdColorPreview\">\n		<div class=\"md-color-picker-custom-result\" ng-style=\"{background: value}\"></div>\n	</div>\n	<md-input-container flex>\n		<label><md-icon ng-if=\"icon\">{{icon}}</md-icon>{{label}}</label>\n		<input type=\"input\" ng-model=\"value\" class=\'md-color-picker-custom-input\'  ng-mousedown=\"(openOnInput || !mdColorPreview) && showColorPicker($event)\"/>\n	</md-input-container>\n	<md-button class=\"md-icon-button md-color-picker-custom-clear\" ng-if=\"mdColorClearButton && value\" ng-click=\"clearValue();\" aria-label=\"Clear Color\">\n		<md-icon md-svg-icon=\"clear.svg\"></md-icon>\n	</md-button>\n</div>\n");
$templateCache.put("mdColorPickerCustomContainer.tpl.html","<div class=\"md-color-picker-custom-container in\" layout=\"column\">\n	<div class=\"md-color-picker-custom-arrow\" ng-style=\"{\'border-bottom-color\': color.toRgbString() }\"></div>\n\n	<div class=\"md-color-picker-custom-preview md-color-picker-custom-checkered-bg\" ng-class=\"{\'dark\': !color.isDark() || color.getAlpha() < .45}\" flex=\"1\" layout=\"column\">\n\n		<div class=\"md-color-picker-custom-result\" ng-style=\"{\'background\': color.toRgbString()}\" flex=\"100\" layout=\"column\" layout-fill layout-align=\"center center\" ng-click=\"focusPreviewInput( $event )\">\n			<!--<span flex  layout=\"column\" layout-align=\"center center\">{{value}}</span>-->\n			<div flex  layout=\"row\" layout-align=\"center center\">\n				<input class=\"md-color-picker-custom-preview-input\" type=\"text\" ng-model=\"value\" ng-focus=\"previewFocus($event);\" ng-blur=\"previewBlur()\" ng-change=\"changeValue()\" ng-keypress=\"previewKeyDown($event)\" layout-fill />\n			</div>\n			<div class=\"md-color-picker-custom-tabs\" style=\"width: 100%\">\n				<md-tabs md-selected=\"type\" md-stretch-tabs=\"always\" md-no-bar md-no-ink md-no-pagination=\"true\" >\n					<md-tab label=\"Hex\" ng-disabled=\"color.getAlpha() !== 1\" md-ink-ripple=\"#ffffff\"></md-tab>\n					<md-tab label=\"RGB\"></md-tab>\n					<md-tab label=\"HSL\"></md-tab>\n					<!--<md-tab label=\"HSV\"></md-tab>\n					<md-tab label=\"VEC\"></md-tab>-->\n				</md-tabs>\n			</div>\n		</div>\n	</div>\n\n	<div class=\"md-color-picker-custom-tabs md-color-picker-custom-colors\">\n		<md-tabs md-stretch-tabs=\"always\" md-align-tabs=\"bottom\"  md-selected=\"whichPane\" md-no-pagination>\n			<md-tab ng-if=\"mdColorSpectrum\">\n				<md-tab-label>\n					<md-icon md-svg-icon=\"gradient.svg\"></md-icon>\n				</md-tab-label>\n				<md-tab-body>\n					<div layout=\"row\" layout-align=\"space-between\" style=\"height: 255px\">\n						<div md-color-picker-custom-spectrum></div>\n						<div md-color-picker-custom-hue ng-class=\"{\'md-color-picker-custom-wide\': !mdColorAlphaChannel}\"></div>\n						<div md-color-picker-custom-alpha class=\"md-color-picker-custom-checkered-bg\" ng-if=\"mdColorAlphaChannel\"></div>\n					</div>\n				</md-tab-body>\n			</md-tab>\n			<md-tab ng-if=\"mdColorSliders\">\n				<md-tab-label>\n					<md-icon md-svg-icon=\"tune.svg\"></md-icon>\n				</md-tab-label>\n				<md-tab-body>\n					<div layout=\"column\" flex=\"100\" layout-fill layout-align=\"space-between start center\" class=\"md-color-picker-custom-sliders\">\n						<div layout=\"row\" layout-align=\"start center\" layout-wrap flex layout-fill>\n							<div flex=\"10\" layout layout-align=\"center center\">\n								<span class=\"md-body-1\">R</span>\n							</div>\n							<md-slider flex=\"65\" min=\"0\" max=\"255\" ng-model=\"color._r\" aria-label=\"red\" class=\"red-slider\"></md-slider>\n							<span flex></span>\n							<div flex=\"20\" layout layout-align=\"center center\">\n								<input style=\"width: 100%;\" min=\"0\" max=\"255\" type=\"number\" ng-model=\"color._r\" aria-label=\"red\" aria-controls=\"red-slider\">\n							</div>\n						</div>\n						<div layout=\"row\" layout-align=\"start center\" layout-wrap flex layout-fill>\n							<div flex=\"10\" layout layout-align=\"center center\">\n								<span class=\"md-body-1\">G</span>\n							</div>\n							<md-slider flex=\"65\" min=\"0\" max=\"255\" ng-model=\"color._g\" aria-label=\"green\" class=\"green-slider\"></md-slider>\n							<span flex></span>\n							<div flex=\"20\" layout layout-align=\"center center\">\n								<input style=\"width: 100%;\" min=\"0\" max=\"255\" type=\"number\" ng-model=\"color._g\" aria-label=\"green\" aria-controls=\"green-slider\">\n							</div>\n						</div>\n						<div layout=\"row\" layout-align=\"start center\" layout-wrap flex layout-fill>\n							<div flex=\"10\" layout layout-align=\"center center\">\n								<span class=\"md-body-1\">B</span>\n							</div>\n							<md-slider flex=\"65\" min=\"0\" max=\"255\" ng-model=\"color._b\" aria-label=\"blue\" class=\"blue-slider\"></md-slider>\n							<span flex></span>\n							<div flex=\"20\" layout layout-align=\"center center\" >\n								<input style=\"width: 100%;\" min=\"0\" max=\"255\" type=\"number\" ng-model=\"color._b\" aria-label=\"blue\" aria-controls=\"blue-slider\">\n							</div>\n						</div>\n						<div layout=\"row\" layout-align=\"start center\" layout-wrap flex layout-fill ng-if=\"!mdColorAlphaChannel\">\n							<div flex=\"10\" layout layout-align=\"center center\">\n								<span class=\"md-body-1\">A</span>\n							</div>\n							<md-slider flex=\"65\" min=\"0\" max=\"1\" step=\".01\" ng-model=\"color._a\" aria-label=\"alpha\" class=\"md-primary\"></md-slider>\n							<span flex></span>\n							<div flex=\"20\" layout layout-align=\"center center\" >\n								<input style=\"width: 100%;\" min=\"0\" max=\"1\" step=\".01\" type=\"number\" ng-model=\"color._a\" aria-label=\"alpha\" aria-controls=\"alpha-slider\">\n							</div>\n						</div>\n					</div>\n				</md-tab-body>\n			</md-tab>\n			<md-tab ng-if=\"mdColorGenericPalette\">\n				<md-tab-label>\n					<md-icon md-svg-icon=\"view_module.svg\"></md-icon>\n				</md-tab-label>\n				<md-tab-body>\n					<div layout=\"column\" layout-align=\"space-between start center\" flex class=\"md-color-picker-custom-palette\">\n\n					</div>\n				</md-tab-body>\n			</md-tab>\n			<md-tab  ng-if=\"mdColorMaterialPalette\">\n				<md-tab-label>\n					<md-icon md-svg-icon=\"view_headline.svg\"></md-icon>\n				</md-tab-label>\n				<md-tab-body>\n					<div layout=\"column\" layout-fill flex class=\"md-color-picker-custom-material-palette\">\n\n					</div>\n				</md-tab-body>\n			</md-tab>\n			<md-tab ng-if=\"mdColorHistory\">\n				<md-tab-label>\n					<md-icon md-svg-icon=\"history.svg\"></md-icon>\n				</md-tab-label>\n				<md-tab-body layout=\"row\" layout-fill>\n					<div layout=\"column\" flex layout-align=\"space-between start\" layout-wrap layout-fill class=\"md-color-picker-custom-history\">\n						<div layout=\"row\" flex=\"80\" layout-align=\"space-between start start\" layout-wrap  layout-fill>\n							<div flex=\"10\" ng-repeat=\"historyColor in history.get() track by $index\">\n								<div  ng-style=\"{\'background\': historyColor.toRgbString()}\" ng-click=\"setPaletteColor($event)\"></div>\n							</div>\n						</div>\n\n\n						<md-button flex-end ng-click=\"history.reset()\" class=\"md-mini\" aria-label=\"Clear History\">\n							<md-icon md-svg-icon=\"clear_all.svg\"></md-icon>\n						</md-button>\n					</div>\n				</md-tab-body>\n			</md-tab>\n		</md-tabs>\n	</div>\n\n</div>\n");
$templateCache.put("mdColorPickerCustomDialog.tpl.html","<md-dialog class=\"md-color-picker-custom-dialog\">\n	<div md-color-picker-custom-container\n		value=\"value\"\n		default=\"{{defaultValue}}\"\n		random=\"{{random}}\"\n		ok=\"ok\"\n		md-color-alpha-channel=\"mdColorAlphaChannel\"\n		md-color-spectrum=\"mdColorSpectrum\"\n		md-color-sliders=\"mdColorSliders\"\n		md-color-generic-palette=\"mdColorGenericPalette\"\n		md-color-material-palette=\"mdColorMaterialPalette\"\n		md-color-history=\"mdColorHistory\"\n		md-color-default-tab=\"mdColorDefaultTab\"\n	></div>\n	<md-actions layout=\"row\">\n		<md-button class=\"md-mini\" ng-click=\"close()\" style=\"width: 50%;\">Cancel</md-button>\n		<md-button class=\"md-mini\" ng-click=\"ok()\" style=\"width: 50%;\">Select</md-button>\n	</md-actions>\n</md-dialog>\n");}]);
})(angular, window, tinycolor);
(function (angular) {
	'use strict';

	angular.module('app.core')
		.directive('ngEnter', function ($document) {

			return function (scope, element, attrs) {
				element.bind("keydown keypress", function (event) {
					if (event.which === 13) {
						scope.$apply(function () {
							scope.$eval(attrs.ngEnter, {
								'event': event
							});
						});

						event.preventDefault();
					}
				});
			};
		});
})(angular);
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('googleGallery', googleGallery)
        .controller('googleGalleryController', googleGalleryController);;

    /** @ngInject */
    function googleGallery() {
        return {
            restrict: 'E',
            transclude: true,
            replace: true,
            scope: {
                items: '=items',
                onSelect: '&',
            },
            templateUrl: "app/core/directives/google-gallery/google-gallery.html",
            compile: function (tElement) {
                // Add class
                tElement.addClass('google-gallery');
            },
            controller: 'googleGalleryController as vm',
            link: function (scope, $element, attrs) {



            }
        };

    }
    function googleGalleryController($scope, msUtils) {
        var vm = this;
        vm.$onInit = function () {
            formatItems($scope.items);
        }

        // Keep an eye on changes
        $scope.$watch('items', function (newVal, oldVal) {
            formatItems(newVal);
        });
        vm.selectMediaFile = selectMediaFile;

        function formatItems(items) {
            vm.items = items;
            vm.items = vm.items.map(x => {
                x.formatedDate = msUtils.timeAgo(x.date_uploaded);
                // x.formatedDate = moment(x.date_uploaded).format("MMM DD");
                return x;
            });
            vm.itemsGrouped = _.chain(vm.items)
                .groupBy("formatedDate")
                .pairs()
                .map(function (currentItem) {
                    return _.object(_.zip(["formatedDate", "medias"], currentItem));
                })
                .value();
        }

        function selectMediaFile(mediaItem) {
            $scope.onSelect({ mediaItem: mediaItem });
        }
    }
})();



(function ()
{
    'use strict';

    angular
        .module('app.domain-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // // Translation
        // $translatePartialLoaderProvider.addPart('app/quick-panel');

        // // Api
        // msApiProvider.register('quickPanel.activities', ['app/data/quick-panel/activities.json']);
        // msApiProvider.register('quickPanel.contacts', ['app/data/quick-panel/contacts.json']);
        // msApiProvider.register('quickPanel.events', ['app/data/quick-panel/events.json']);
        // msApiProvider.register('quickPanel.notes', ['app/data/quick-panel/notes.json']);
    }
})();

(function () {
	'use strict';

	angular
		.module('app.domain-panel')
		.controller('DomainSelectorTabController', DomainSelectorTabController);

	/** @ngInject */
	function DomainSelectorTabController(msApi, $timeout, $rootScope, $scope, sessionService, $mdSidenav, $state, msNavigationService) {
		var vm = this;

		// Data
		vm.chat = {};
		vm.chatActive = false;
		vm.replyMessage = '';

		vm.filters = {
                 contentFilterInput: ''
             };

		// Methods
		vm.toggleChat = toggleChat;
		vm.reply = reply;
		vm.setDomain = setDomain;
		vm.toggleSidenav = toggleSidenav;
		//////////

		// Set active Domain
		function setDomain(domain) {
			$scope.loadingScreen = true;

			vm.filters.contentFilterInput='';

			$rootScope.$broadcast('msSplashScreen::add');
			$mdSidenav("domain-panel")
				.toggle();

			sessionService.setActiveDomain(domain)
				.then(
					function () {
						setOperativeDomain();
						$rootScope.$emit('site:loadStartDomain', domain);
						sessionService.setModuleSection(domain)
							.then(function () {
								setNavigation();
								// setModules()
							})

						// $state.go('site_overview.dashboard', {
						$state.go('app.dashboards', {
							siteId: domain.subdomain,
							bar: 1
						});
					},
					function () {
						$rootScope.$emit('site:loadFinished', domain);
						toastr.error("error", "response.status");
						// Couldn't login for some reason - kick the user back to the login page.
						// window.location.href = "./";
					}
			);
		};

		function setNavigation() {
			$scope.modulecontent = sessionService.modulecontent;
		}


		function setOperativeDomain() {
			$scope.site_operative = sessionService.site_operative;
			$scope.modulecontent = sessionService.modulecontent;
		}

		function toggleChat(contact) {
			vm.chatActive = !vm.chatActive;

			if (vm.chatActive) {
				vm.replyMessage = '';
				vm.chat.contact = contact;
				scrollToBottomOfChat(0);
			}
		}

		function reply() {
			if (vm.replyMessage === '') {
				return;
			}

			if (!vm.chat.contact.dialog) {
				vm.chat.contact.dialog = [];
			}

			vm.chat.contact.dialog.push({
				who: 'user',
				message: vm.replyMessage,
				time: 'Just now'
			});

			vm.replyMessage = '';

			scrollToBottomOfChat(400);
		}

		function scrollToBottomOfChat(speed) {
			var chatDialog = angular.element('#chat-dialog');

			$timeout(function () {
				chatDialog.animate({
					scrollTop: chatDialog[0].scrollHeight
				}, speed);
			}, 0);

		}

		function toggleSidenav(sidenavId) {
			$mdSidenav(sidenavId).toggle();
		}
	}

})();



(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('with', aliasDirective);

    /** @ngInject */
    function aliasDirective() {
        return {
            restrict: 'A',
            scope: true,
            link: function(scope, element, attrs) {
                if (attrs.as) {
                    scope[attrs.as] = scope.$eval(attrs.with);
                } else {
                    angular.extend(scope, scope.$eval(attrs.with));
                }
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.public', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        $stateProvider.state('public.login', {
            url: '/login',
            resolve: {
                skipIfLoggedIn: skipIfLoggedIn
            },
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@public.login': {
                    templateUrl: 'app/main/public/login.html',
                    controller: 'LoginController as vm'
                }
            },
            bodyClass: 'login'
        });

        // State
        $stateProvider
            .state('app.sample', {
                url    : '/sample',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/sample/sample.html',
                        controller : 'SampleController as vm'
                    }
                },
                resolve: {
                    SampleData: function (msApi)
                    {
                        return msApi.resolve('sample@get');
                    }
                }
            });

        function skipIfLoggedIn($q, $auth, $location, $state) {

            var deferred = $q.defer();
            if ($auth.isAuthenticated()) {
                deferred.reject();
            } else {
                deferred.resolve();
            }
            return deferred.promise.catch(function () { $state.go('app.dashboards'); });
        }

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/public');

        // Api
        msApiProvider.register('sample', ['app/data/sample/sample.json']);

        // Navigation
        // msNavigationServiceProvider.saveItem('fuse', {
        //     title : 'SAMPLE',
        //     group : true,
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('fuse.sample', {
        //     title    : 'Sample',
        //     icon     : 'icon-tile-four',
        //     state    : 'app.sample',
        //     /*stateParams: {
        //         'param1': 'page'
        //      },*/
        //     translate: 'SAMPLE.SAMPLE_NAV',
        //     weight   : 1
        // });
    }
})();
(function() {
    'use strict';

    angular
        .module('app.public')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController($scope, $auth, $location, $mdToast, $translate, sessionService) {
        var vm = this;

        if($location.host() === 'panel.runtag.app'){
            vm.logoURL = "/assets/images/logos/runtag-logo.png";
            vm.translateSiteName = "LOGIN.INTRO_TITLER";
        }else{
            vm.logoURL = "/assets/images/logos/qiusystem-logo.png";
            vm.translateSiteName = "LOGIN.INTRO_TITLEQ";
        }

        // Data
        vm.languages = {
            en: {
                'title'      : 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code'       : 'en',
                'flag'       : 'us'
            },
            es: {
                'title'      : 'Spanish',
                'translation': 'TOOLBAR.SPANISH',
                'code'       : 'es',
                'flag'       : 'es'
            },
            fr: {
                'title'      : 'French',
                'translation': 'TOOLBAR.FRENCH',
                'code'       : 'fr',
                'flag'       : 'fr'
            }
        };

        vm.loading=false;

        // Methods
        vm.changeLanguage = changeLanguage;
        $scope.toggleLoading = toggleLoading;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {

            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[sessionService.getLanguage()];


        }

        function changeLanguage(lang){
            vm.selectedLanguage = lang;
            sessionService.changeLanguage(lang.code)
        }

        function loginSucess() {
            var message = 'Welcome again';
            $mdToast.show({
                template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content green-500-bg">' + message + '</div></md-toast>',
                hideDelay: 7000,
                position: 'top',
                parent: '#login-form-wrapper'
            });
            // toastr.success('You have successfully signed in');
            $scope.$emit('loginSucess', vm.user);
            $location.path('/');
        }

        function loginError(message) {
            // var message = response.data.error;

            $mdToast.show({
                template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg">' + message + '</div></md-toast>',
                hideDelay: 7000,
                position: 'top',
                parent: '#login-form-wrapper'
            });
        }

        // Scope
        $scope.login = function(loginForm) {

            toggleLoading();

            $auth.login(vm.form)
                .then(function() {
                    loginSucess();
                })
                .catch(function(response) {
                    toggleLoading();
                    if(response.data){
                      loginError(response.data.message);
                    }else if(response.status===-1){
                      loginError("Login error, please contact with support team");
                    }
                    loginForm.$setPristine();
                    loginForm.$setUntouched();
                    vm.form.password='';
                });
        };

        $scope.authenticate = function(provider) {

            $auth.authenticate(provider)
                .then(function() {
                    loginSucess();
                })

                .catch(function(error) {
                    if (error.error) {
                        // Popup error - invalid redirect_uri, pressed cancel button, etc.
                        loginError(error.error);
                    } else if (error.status==401) {

                        if(error.data.error){
                            loginError(error.data.error);
                        }else if(error.data.message){
                            loginError(error.data.message);
                        }

                    } else if (error.data) {
                        // HTTP response error from server
                        loginError(error.data.message, error.status);
                    } else {
                        loginError(error);
                    }

                });
        };

        function toggleLoading(){
            vm.loading=(vm.loading)?false:true;
        }


        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('QiuTheming', QiuThemingProvider);

    /** @ngInject */
    function QiuThemingProvider()
    {
        // Inject Cookies Service
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        var registeredPalettes,
            registeredThemes;

        // Methods
        this.setRegisteredPalettes = setRegisteredPalettes;
        this.setRegisteredThemes = setRegisteredThemes;

        //////////

        /**
         * Set registered palettes
         *
         * @param _registeredPalettes
         */
        function setRegisteredPalettes(_registeredPalettes)
        {
            registeredPalettes = _registeredPalettes;
        }

        /**
         * Set registered themes
         *
         * @param _registeredThemes
         */
        function setRegisteredThemes(_registeredThemes)
        {
            registeredThemes = _registeredThemes;
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getRegisteredPalettes: getRegisteredPalettes,
                getRegisteredThemes  : getRegisteredThemes,
                setActiveTheme       : setActiveTheme,
                setThemesList        : setThemesList,
                themes               : {
                    list  : {},
                    active: {
                        'name' : '',
                        'theme': {}
                    }
                }
            };

            return service;

            //////////

            /**
             * Get registered palettes
             *
             * @returns {*}
             */
            function getRegisteredPalettes()
            {
                return registeredPalettes;
            }

            /**
             * Get registered themes
             *
             * @returns {*}
             */
            function getRegisteredThemes()
            {
                return registeredThemes;
            }

            /**
             * Set active theme
             *
             * @param themeName
             */
            function setActiveTheme(themeName)
            {
                // If theme does not exist, fallback to the default theme
                if ( angular.isUndefined(service.themes.list[themeName]) )
                {
                    // If there is no theme called "default"...
                    if ( angular.isUndefined(service.themes.list.default) )
                    {
                        $log.error('You must have at least one theme named "default"');
                        return;
                    }

                    $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                    // Otherwise set theme to default theme
                    service.themes.active.name = 'default';
                    service.themes.active.theme = service.themes.list.default;
                    $cookies.put('selectedTheme', service.themes.active.name);

                    return;
                }

                service.themes.active.name = themeName;
                service.themes.active.theme = service.themes.list[themeName];
                $cookies.put('selectedTheme', themeName);
                /*
                var expiryDate = new Date();
                expiryDate.setMonth(expiryDate.getMonth() + 1);
                {
                  expires: expiryDate.toUTCString(),
                  path: '/',
                  secure: true,
                  samesite: 'strict'
                }
                */
            }

            /**
             * Set available themes list
             *
             * @param themeList
             */
            function setThemesList(themeList)
            {
                service.themes.list = themeList;
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, QiuPalettes, QiuThemes, QiuThemingProvider)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            QiuThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(QiuPalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(QiuThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });

        // Store generated PALETTES and THEMES objects from $mdThemingProvider
        // in our custom provider, so we can inject them into other areas
        QiuThemingProvider.setRegisteredPalettes($mdThemingProvider._PALETTES);
        QiuThemingProvider.setRegisteredThemes($mdThemingProvider._THEMES);
    }

})();
(function ()
{
    'use strict';

    var QiuThemes = {
        'default-qiu'  : {
            primary   : {
                name: 'Qiu-pale-blue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'red'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        },
        'default'  : {
            primary   : {
                name: 'Qiu-palette-blue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'red'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        },
        'pink': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'blue'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        },
        'teal'     : {
            primary   : {
                name: 'Qiu-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'deep-orange'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('QiuThemes', QiuThemes);
})();
(function () {
    'use strict';

    var QiuPalettes = [
        {
            name: 'Qiu-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'Qiu-palette-blue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#4e5665',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'Qiu-pale-blue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('QiuPalettes', QiuPalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('QiuGenerator', QiuGeneratorService);

    /** @ngInject */
    function QiuGeneratorService($cookies, $log, QiuTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            var registeredThemes = QiuTheming.getRegisteredThemes();
            var registeredPalettes = QiuTheming.getRegisteredPalettes();

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            QiuTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                QiuTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                QiuTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0, color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, QiuTheming)
    {
        var vm = this;

        // Data
        vm.themes = QiuTheming.themes;
        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // Set active theme
            QiuTheming.setActiveTheme(themeName);
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions()
    {
        return {
            restrict   : 'E',
            scope      : {
                panelOpen: '=?'
            },
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        backdropEl = angular.element('<div class="ms-theme-options-backdrop"></div>');

                    // Panel open status
                    scope.panelOpen = scope.panelOpen || false;

                    /**
                     * Toggle options panel
                     */
                    function toggleOptionsPanel()
                    {
                        if ( scope.panelOpen )
                        {
                            closeOptionsPanel();
                        }
                        else
                        {
                            openOptionsPanel();
                        }
                    }

                    function openOptionsPanel()
                    {
                        // Set panelOpen status
                        scope.panelOpen = true;

                        // Add open class
                        iElement.addClass('open');

                        // Append the backdrop
                        bodyEl.append(backdropEl);

                        // Register the event
                        backdropEl.on('click touch', closeOptionsPanel);
                    }

                    /**
                     * Close options panel
                     */
                    function closeOptionsPanel()
                    {
                        // Set panelOpen status
                        scope.panelOpen = false;

                        // Remove open class
                        iElement.removeClass('open');

                        // De-register the event
                        backdropEl.off('click touch', closeOptionsPanel);

                        // Remove the backdrop
                        backdropEl.remove();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsPanel = toggleOptionsPanel;
                };
            }
        };
    }
})();
(function (angular) {
  'use strict';

  angular.module('app.core')
    .service('Utils', Utils);

  function Utils() {}

  Utils.prototype.extend = function(dest, src) {
    Object.keys(src).forEach(function(key) {
      if(!dest.hasOwnProperty(key)) {
        dest[key] = src[key];
      } else if(typeof src[key] === 'object') {
        this.extend(dest[key], src[key]);
      }
    }.bind(this));

    return dest;
  };

})(angular);
(function() {
    'use strict';

    angular
        .module('app.core')
        .service("userService", Service);

    /** @ngInject */
    // I provide access to the screen store.
    function Service(
        //_
    ) {

        //publicly exposed dictionary
        var userProperties = {
            firstName: "firstName",
            initials: "initials",
            isSystemAvatar: "isSystemAvatar",
            hasSystemAvatar: "hasSystemAvatar",
            onlineStatus: "onlineStatus",
            shortName: "shortName"
        };

        //I add dynamic properties to a list of users
        function addPropsToUsers(users, propertyNames) {

            //for each user, add the passed in properties
            // _.forEach(users, function(user) {
            // 	_.forEach(propertyNames, function(property) {
            // 		switch (property) {
            // 			case userProperties.firstName:
            // 				user.firstName = getFirstName( user.name );
            // 				break;
            // 			case userProperties.initals:
            // 				user.initals = getInitials( user.name );
            // 				break;
            // 			case userProperties.isSystemAvatar:
            // 				user.isSystemAvatar = isSystemAvatar( user.avatarID );
            // 				break;
            // 			case userProperties.hasSystemAvatar:
            // 				user.hasSystemAvatar = isSystemAvatar( user.avatarID );
            // 				break;
            // 			case userProperties.onlineStatus:
            // 				user.onlineStatus = getOnlineStatus( user.avatarID );
            // 				break;
            // 			case userProperties.shortName:
            // 				user.shortName = getShortName(user.shortName);
            // 				break;
            // 			default:
            // 				break;
            // 		}
            // 	});
            // });

            return users;
        }

        // I get the first and last initials of the given name.
        function getInitials(name) {

            // If no value was passed-in, return nothing.
            if (!name) {

                return ("");

            }

            // Trim and split on white-space.
            var nameParts = name
                .replace(/^\s+|\s+$/i, "")
                .split(/\s+/i);

            // Get references to the two parts of the name that we want to use - the
            // first name and the last name (ignores any middle name tokens).
            var firstName = (nameParts.shift() || "");
            var lastName = (nameParts.pop() || "");

            return (
                firstName.slice(0, 1).toUpperCase() +
                lastName.slice(0, 1).toUpperCase()
            );

        }


        // I get the online status given the date of the last request.
        function getOnlineStatus(lastRequestAt) {

            var now = (new Date()).getTime();
            var onlineCutoff = (10 * 60 * 1000); // 10 minutes.
            var awayCutoff = (30 * 60 * 1000); // 30 minutes.

            if (lastRequestAt > (now - onlineCutoff)) {

                return ("Online");

            } else if (lastRequestAt > (now - awayCutoff)) {

                return ("Away");

            }

            return ("Offline");

        }


        // I get the first name plus the last initial, if it is available.
        function getShortName(name) {

            // If no value was passed-in, return nothing.
            if (!name) {

                return ("");

            }

            var nameParts = name.replace(/^\s+|\s+$/i, "").split(/\s+/i);
            var namePartsCount = nameParts.length;

            // If we have multiple parts, get the first part and first inital of the last one.
            if (namePartsCount > 1) {

                return (
                    nameParts[0] +
                    " " +
                    nameParts[namePartsCount - 1].slice(0, 1) +
                    ((nameParts[namePartsCount - 1].length > 1) ? "." : "")
                );

            }

            // If we only have one part, just get the first part.
            return (nameParts[0]);

        }


        function getFirstName(name) {

            // If no value was passed-in, return nothing.
            if (!name) {

                return ("");

            }

            var nameParts = name.replace(/^\s+|\s+$/i, "").split(/\s+/i);

            // If we only have one part, just get the first part.
            return (nameParts[0]);

        }


        // I determine if the given avatar is a system-generated avatar; or, one of the
        // user's choosing.
        function isSystemAvatar(avatarID) {

            // All the system-generated avatars start with a string of zeros (they are not
            // true UUID values).
            return (avatarID && avatarID.indexOf("00000000") === 0);

        }

        // Returns "Me" if the user is the current user
        function getNiceUsername(defaultUsername, userID, currentUserID) {

            return userID === currentUserID ? "me" : defaultUsername;

        }

        var ROLES = {
            ADMIN: 1,
            MANAGER: 2,
            CONTRIBUTOR: 3,
            REVIEWER: 4
        };

        // -------------------------------------------------- //
        // -------------------------------------------------- //


        // Return the public API.
        return ({
            addPropsToUsers: addPropsToUsers,
            getInitials: _.memoize(getInitials),
            // getOnlineStatus: getOnlineStatus,
            // getShortName: _.memoize( getShortName ),
            // getFirstName: _.memoize( getFirstName ),
            isSystemAvatar: _.memoize(isSystemAvatar),
            getNiceUsername: getNiceUsername,
            userProperties: userProperties,
            ROLES: ROLES
        });


    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .service("uploadService", Service);

    /** @ngInject */
    function Service($q, $resource, COMMON, mediaService, Upload, $timeout, sessionService, $http, $translate, $mdToast) {

        const chunkSize = 100 * 1024 * 1024; // 100MB Chunk size in bytes
        const vm = this;
        vm.isAdmin = sessionService.user.is_admin;

        /**
         * Main method to handle file upload
         */
        function upload(file, options) {
            const deferred = $q.defer();

            file.cancelled = false;
            file.uploadOptions = options;

            if (file.size < chunkSize) {
                // Traditional file upload
                return handleSmallFileUpload(file, options, deferred);
            } else {
                // Multipart file upload
                return handleMultipartUpload(file, options, deferred);
            }
        }

        /**
         * Stops an upload in progress: aborts the request in flight and prevents the
         * pending steps (pre-signed url, remaining chunks, complete) from running.
         */
        function cancel(file) {
            if (!file) {
                return;
            }
            file.cancelled = true;
            file.uploadStatus = "aborted";
            if (file.upload && angular.isFunction(file.upload.abort)) {
                file.upload.abort();
            }
            if (file.currentChunkXhr) {
                file.currentChunkXhr.abort();
            }
            discardCancelledMedia(file);
        }

        /**
         * Removes the media file created for an upload the user cancelled.
         * On a replace the id_media belongs to an already existing media, so it is never deleted.
         */
        function discardCancelledMedia(file) {
            const options = file.uploadOptions;
            if (!options || options.isReplace || !file.id_media) {
                return;
            }
            mediaService.massDelete({
                site: options.siteID,
                id_media: [file.id_media],
                force: true
            });
        }

        /**
         * Handles upload for small files
         */
        function handleSmallFileUpload(file, options, deferred) {
            mediaService.getS3UploadPreSignedUrl({
                id_media: options.id_media,
                siteID: options.siteID,
                fileName: options.filename,
                fileSizeKb: options.fileSizeKb
            }).then(resp => {
                if (resp.id_media) {
                    file.id_media = resp.id_media;
                }
                if (resp.token) {
                    options.token = resp.token;
                }

                if (file.cancelled) {
                    // the file was removed from the upload list while asking for the pre-signed url
                    discardCancelledMedia(file);
                    deferred.reject('Upload was cancelled');
                    return;
                }

                file.upload = Upload.http({
                    url: resp.url,
                    skipAuthorization: true,
                    method: 'PUT',
                    headers: {
                        "Content-Type": file.type || 'application/octet-stream'
                    },
                    data: file
                });

                file.upload.then(response => {
                    if (file.cancelled) {
                        deferred.reject('Upload was cancelled');
                        return;
                    }
                    file.result = response.data;
                    $timeout(() => {
                        options.log = `file: ${file.name}, Response: ${JSON.stringify(response.data)}, ID: ${file.id_media}\n${options.log}`;
                    });

                    if (file.progress === 100) {
                        file.processed = true;
                        deferred.resolve(file);
                    }
                }, error => {
                    handleError(error, file, options, deferred);
                });

                file.upload.progress(evt => {
                    file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                });
            });

            return deferred.promise;
        }

        /**
         * Handles multipart upload for large files
         */
        function handleMultipartUpload(file, options, deferred) {
            const totalChunks = Math.ceil(file.size / chunkSize);
            const parts = [];
            let id_upload;
            let id_media;
            let totalUploaded = 0; // Track total uploaded bytes
            file.uploadStatus = "in-progress"; // Possible values: "in-progress", "aborted", "completed"
            const contentType = file.type || 'application/octet-stream';

            return initiateUpload(options.siteID, file.name, file.size)
                .then(response => {
                    id_upload = response.id_upload;
                    if (response.id_media) {
                        file.id_media = response.id_media;
                        id_media = response.id_media;
                    }

                    if (file.cancelled) {
                        // the file was removed from the upload list while the upload was being initiated
                        throw new Error("Upload was aborted");
                    }

                    // Start sequentially processing chunks
                    let chain = $q.when(); // Initial empty promise to chain
                    for (let i = 0; i < totalChunks; i++) {
                        const chunk = file.slice(i * chunkSize, (i + 1) * chunkSize);
                        const partNumber = i + 1;
        
                        chain = chain
                            .then(() => {
                                if (file.uploadStatus === "aborted") {
                                    throw new Error("Upload was aborted");
                                }
                                return getPreSignedUrl(options.siteID, partNumber, id_upload, id_media);
                            })
                            .then(preSignedUrlResponse => {
                                return uploadChunkWithProgress(preSignedUrlResponse.url, chunk, partNumber, contentType)
                                    .then(uploadResponse => {
                                        parts.push({
                                            PartNumber: partNumber,
                                            ETag: uploadResponse.headers.etag
                                        });
                                    });
                            });
                    }
        
                    return chain; // Return the chain to ensure all parts are processed
                })
                .then(() => {
                    if (file.uploadStatus === "aborted") {
                        throw new Error("Upload was aborted before completion");
                    }
                    // Call completeUpload only if all parts are successfully uploaded
                    return completeUpload(options.siteID, id_upload, id_media)
                        .then(() => {
                            file.uploadStatus = "completed";
                            $timeout(() => {
                                file.processed = true;
                            });
                            deferred.resolve(file); // Resolve the promise with the file object
                        });
                })
                .catch(error => {
                    if (id_upload && id_media && file.uploadStatus !== "completed") {
                        file.uploadStatus = "aborted";
                        return abortUpload(options.siteID, id_upload, id_media).finally(() => {
                            if (file.cancelled) {
                                discardCancelledMedia(file);
                            }
                            $timeout(() => {
                                file.processed = false;
                            });
                            deferred.reject(error); // Reject the promise with the error
                        });
                    } else {
                        deferred.reject(error); // Reject the promise with the error
                        throw error;
                    }
                });
        
            /**
             * Uploads a chunk with progress tracking
             */
            function uploadChunkWithProgress(preSignedUrl, chunk, partNumber, contentType) {
                const deferred = $q.defer();
                const xhr = new XMLHttpRequest();
        
                xhr.open('PUT', preSignedUrl, true);
                xhr.setRequestHeader('Content-Type', contentType);
        
                xhr.upload.onprogress = function (event) {
                    if (event.lengthComputable) {
                        // Calculate the progress for the current chunk
                        const chunkProgress = Math.min(100, parseInt((event.loaded / event.total) * 100, 10));
                    
                        // Calculate the total progress based on already uploaded chunks + the progress of the current chunk
                        const totalBytesUploaded = totalUploaded + event.loaded;
                        const totalProgress = Math.min(100, parseInt((totalBytesUploaded / file.size) * 100, 10));
                    
                        // Update progress for the file
                        $timeout(() => {
                            file.progress = totalProgress;
                            console.log(`Chunk ${partNumber}: ${chunkProgress}% uploaded`);
                            console.log(`Total Progress: ${file.progress}%`);
                        });
                    }
                };
        
                xhr.onload = function () {
                    file.currentChunkXhr = null;
                    if (xhr.status >= 200 && xhr.status < 300) {
                        // Add the size of the current chunk to totalUploaded once the chunk is fully uploaded
                        totalUploaded += chunk.size;
                        deferred.resolve({
                            headers: parseHeaders(xhr.getAllResponseHeaders()),
                            data: xhr.responseText
                        });
                    } else {
                        deferred.reject(xhr.statusText);
                    }
                };

                xhr.onerror = function () {
                    file.currentChunkXhr = null;
                    deferred.reject(xhr.statusText);
                };

                xhr.onabort = function () {
                    file.currentChunkXhr = null;
                    deferred.reject("Upload was aborted");
                };

                // kept on the file so the chunk in flight can be aborted when the user cancels
                file.currentChunkXhr = xhr;
                xhr.send(chunk);
        
                return deferred.promise;
            }
        
            /**
             * Helper function to parse headers from XHR
             */
            function parseHeaders(headers) {
                const parsed = {};
                if (!headers) return parsed;
        
                headers.split('\n').forEach(header => {
                    const [key, value] = header.split(': ');
                    if (key && value) {
                        parsed[key.trim()] = value.trim();
                    }
                });
                return parsed;
            }
        }

        /**
         * Common error handling
         */
        function handleError(error, file, options, deferred) {
            if (file.cancelled) {
                // the user cancelled it on purpose: no error message and it must not come back to the list
                deferred.reject(error);
                return;
            }
            const message = `${$translate.instant('MEDIA.UPLOADING_MEDIA_FILE_ERROR')} ${file.name}`;
            showErrorDialog(message);

            options.uploadedFiles.push(file);
            if (error.status > 0) {
                options.errorMsg = `${error.status}: ${error.data}`;
            }

            deferred.reject(error);
        }

        /**
         * Displays an error dialog
         */
        function showErrorDialog(message) {
            $mdToast.show({
                template: `
                    <md-toast id="language-message" layout="column" layout-align="center center">
                        <div class="md-toast-content red-500-bg">
                            <md-icon md-font-icon="icon-check" class="icon"></md-icon>
                            <span class="md-toast-text" flex>${message}</span>
                        </div>
                    </md-toast>`,
                hideDelay: 5000,
                position: 'top',
                parent: '#content-container'
            });
        }

        /**
         * Auxiliary methods for multipart upload
         */
        function initiateUpload(domain, fileName, size) {
            return resourceGetS3Multipart.get({ domain: domain, fileName: fileName, fileSizeKb: size }).$promise;
        }

        function getPreSignedUrl(domain, partNumber, id_upload, id_media) {
            return resourceGetS3MultipartPreSigned.get({ domain: domain, part_number: partNumber, id_upload: id_upload, id_media: id_media }).$promise;
        }

        function completeUpload(domain, id_upload, id_media) {
            return resourcePostS3MultipartUpload.post({ domain }, { id_upload: id_upload, id_media: id_media })
                .$promise
                .then(response => {
                    console.log('Complete Upload Response:', response);
                    return { success: true }; // Devuelve algo explícito, si el servidor no devuelve nada útil
                })
                .catch(error => {
                    console.error('Error in completeUpload:', error);
                    throw error;
                });
        }

        function abortUpload(domain, id_upload, id_media) {
            return resourceAbortS3MultipartUpload.post({ domain }, { id_upload: id_upload, id_media: id_media }).$promise;
        }

        /**
         * Resources
         */
        const resourceGetS3Multipart = $resource(
            `${COMMON.BASE_API}/domain/:domain/media/multipartUpload/getS3UploadId`,
            { domain: '@domain' }, { get: { method: "GET" } }
        );

        const resourceGetS3MultipartPreSigned = $resource(
            `${COMMON.BASE_API}/domain/:domain/media/multipartUpload/getS3UploadPreSignedUrl`,
            { domain: '@domain' }, { get: { method: "GET" } }
        );

        const resourcePostS3MultipartUpload = $resource(
            `${COMMON.BASE_API}/domain/:domain/media/multipartUpload/complete`,
            { domain: '@domain' }, { post: { method: "POST", isArray: true } }
        );

        const resourceAbortS3MultipartUpload = $resource(
            `${COMMON.BASE_API}/domain/:domain/media/multipartUpload/abort`,
            { domain: '@domain' }, { post: { method: "POST" } }
        );

        // Public API
        return { upload, cancel };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .service("tinyMceService", tinyMce);

    /** @ngInject */
    // I provide access to the session store.
    function tinyMce($q, $resource, $log, userService, settingsDomainService, sessionService, COMMON, $window, $rootScope) {

        function setQiuMediaTextContent(content, event) {
            $log.log(content, event)
        }

        function getOptions($scope) {
            var domain = 'site-' + sessionService.site_operative.domain_name;
            var tinymceOptions = {
                body_class: domain,
                theme: 'modern',
                height: 500,
                remove_script_host: false,
                allow_script_urls: true,
                convert_urls: false,
                extended_valid_elements: 'script[language|type|src|async|charset]',
                paste_retain_style_properties: "color font-size",
                plugins: [
                    'paste qiumedia qiupaste media advlist autolink lists link image charmap preview hr anchor pagebreak', 'searchreplace wordcount visualblocks visualchars code fullscreen imagetools', 'nonbreaking table contextmenu', 'template textcolor colorpicker textpattern'
                ],
                toolbar1: ' insertfile undo redo | bold italic underline | alignleft aligncenter alignright alignjustify | forecolor backcolor | fontselect fontsizeselect | bullist numlist outdent indent | table | link unlink anchor | image media | code fullscreen removeformat buttonadv | qiumedia qiupaste',
                toolbar2: '',
                content_style: "#tinymce { font-size: 16px;line-height:1.6;font-family:'Helvetica Neue', sans-serif; } .qiumedia > img {background: #f9f2f2;}" +
                    ".align-left { text-align:left;float:left;margin-right:3%; }" +
                    ".align-center { text-align:center;margin:0 auto; }" +
                    ".align-right { text-align:right;float:right;margin-left:3%; }" +
                    ".size-25 { width:22% }" +
                    ".size-50 { width:47% }" +
                    ".size-75 { width:72% }" +
                    ".size-25.align-center { width:25% }" +
                    ".size-50.align-center { width:50% }" +
                    ".size-75.align-center { width:75% }" +
                    ".size-100 { width:100%;margin: 0;float: none; }" +
                    ".width-percent-100 { width:100% !important;margin: 0;float: none;}" +
                    ".mce-content-body *[contentEditable=false] { position:relative; }" +
                    ".mce-content-body *[contentEditable=false][data-mce-selected] { outline:none !important; }" +
                    ".mce-content-body *[contentEditable=false][data-mce-selected] img { outline: 2px solid #019be5;}" +
                    ".qiumedia-video:after {width: 0;height: 0;border-style: solid;border-width: 15px 0 15px 27px;border-color: transparent transparent transparent #ffffff;content: '';position: absolute;z-index: 1;left: 50%;top: 50%;margin-top: -15px;margin-left: -9px;}" +
                    ".qiumedia-video:before {content: '';position: absolute;color: #fff;background: #019be5;padding: 10px;left: 50%;width: 50px;height: 50px;margin-left: -35px;top: 50%;margin-top: -35px;border-radius: 50%;}" +
                    ".size-25.qiumedia-video:after {border-width: 10px 0 10px 20px;margin-top: -11px;margin-left: -7px;}" +
                    ".size-25.qiumedia-video:before {width: 30px;height: 30px;margin-left: -25px;margin-top: -25px;}" +
                    ".site-theoceanrace .qiumedia {float:none !important;}" +
                    ".site-theoceanrace .qiumedia.align-left { margin-right:auto; }" +
                    ".site-theoceanrace .qiumedia.align-right { margin-left:auto; }" +
                    ".site-theoceanrace .qiumedia.size-25 { width:25%;}" +
                    ".site-theoceanrace .qiumedia.size-50 { width:50%;}" +
                    ".site-theoceanrace .qiumedia.size-75 { width:75%;}",
                fontsize_formats: '8pt 9pt 10pt 11pt 12pt 13pt 14pt 15pt 16pt 18pt 20pt 22pt 24pt 28pt 36pt 42pt 48pt',
                image_advtab: true,
                menubar: true,
                setup: function (editor) {
                    var vm = $scope.vm || $scope;

                    vm.tinyEditor = editor;

                vm.tinyTemplates = [
                    {
                        label: 'Quote',
                        description: 'Grey quote with rounded corners and author',
                        // All styles inline so the block is self-contained
                        html:
                            '<figure style="' +
                                'background:#f5f5f5;' +
                                'border-radius:8px;' +
                                'padding:12px 16px;' +
                                'margin:12px 0;' +
                                'border-left:4px solid #cccccc;' +
                            '">' +
                                '<blockquote style="' +
                                    'margin:0 0 6px 0;' +
                                    'font-style:italic;' +
                                    'color:#555555;' +
                                '">' +
                                    'Write your quote here…' +
                                '</blockquote>' +
                                '<figcaption style="' +
                                    'margin:0;' +
                                    'font-weight:600;' +
                                    'font-size:0.9em;' +
                                    'color:#333333;' +
                                    'text-align:right;' +
                                '">' +
                                    'Author name' +
                                '</figcaption>' +
                            '</figure>'
                    }
                    // You can add more templates here
                ];

                    /*
                    editor.addButton('buttonadv', {
                        type: 'listbox',
                        text: 'Advanced',
                        icon: false,
                        onselect: function (e) {
                            $log.log(editor.plugins.qiupaste.showDialog();
                            $log.log(this.value());
                        },
                        values: [
                            {
                                text: 'Insert Social Embed',
                                value: 'qiupaste'
                            }, {
                                text: 'Insert Video/Image',
                                value: 'qiumedia'
                            }
                        ]
                    });
                    */
                    // This function splits <p> elements that contain <br> into multiple <p> elements
                    function normalizeParagraphsWithBr() {
                        try {
                            var body = editor.getBody();
                            if (!body) return;

                            // Get all <p> elements (live NodeList, so copy it first)
                            var paragraphs = Array.prototype.slice.call(body.querySelectorAll('p'));

                            paragraphs.forEach(function (p) {
                                // 1) If there is no <br> inside, skip
                                if (!p.querySelector('br')) {
                                    return;
                                }

                                // 2) Avoid touching paragraphs that are essentially empty
                                //    (only <br>, spaces, bogus nodes) -> those are used by TinyMCE for caret
                                var clone = p.cloneNode(true);
                                Array.prototype.slice.call(clone.querySelectorAll('br')).forEach(function (br) {
                                    br.parentNode.removeChild(br);
                                });

                                var textContent = (clone.textContent || '').replace(/\s+/g, '');
                                if (!textContent.length) {
                                    // Paragraph only has <br>/whitespace -> do not normalize it
                                    return;
                                }

                                // 3) From here, we only handle "real" paragraphs with text + <br>
                                var currentChunkNodes = [];
                                var newParagraphs = [];
                                var child = p.firstChild;

                                while (child) {
                                    var next = child.nextSibling;

                                    if (child.nodeName === 'BR') {
                                        // When we hit a <br>, we consider we finished one line
                                        if (currentChunkNodes.length > 0) {
                                            newParagraphs.push(currentChunkNodes);
                                            currentChunkNodes = [];
                                        }
                                        // Remove the <br> from the DOM
                                        p.removeChild(child);
                                    } else {
                                        currentChunkNodes.push(child);
                                    }

                                    child = next;
                                }

                                // Last chunk (after last <br>)
                                if (currentChunkNodes.length > 0) {
                                    newParagraphs.push(currentChunkNodes);
                                }

                                // If no real split, skip
                                if (newParagraphs.length <= 1) {
                                    return;
                                }

                                // Insert new <p> elements after the original <p>
                                var parent = p.parentNode;
                                var reference = p;

                                newParagraphs.forEach(function (nodes, index) {
                                    var newP;

                                    if (index === 0) {
                                        // Reuse original <p> for the first chunk
                                        newP = p;
                                    } else {
                                        newP = editor.getDoc().createElement('p');
                                        parent.insertBefore(newP, reference.nextSibling);
                                        reference = newP;
                                    }

                                    nodes.forEach(function (node) {
                                        newP.appendChild(node);
                                    });
                                });
                            });
                        } catch (err) {
                            $log.error('Error normalizing paragraphs with <br>', err);
                        }
                    }

                    function refreshLines() {
                        try {
                            var body = editor.getBody();
                            if (!body) return;

                            var blocks = body.querySelectorAll('p, h1, h2, h3, h4, h5, h6, div, li, figure');

                            var lines = [];
                            var timestamp = Date.now();
                            angular.forEach(blocks, function (node, index) {
                                var lineId = node.getAttribute('data-line-id');
                                if (!lineId) {
                                    lineId = 'line-' + index + '-' + timestamp;
                                    node.setAttribute('data-line-id', lineId);
                                }

                                var text = '';
                                if (angular.isString(node.innerText)) {
                                    text = node.innerText;
                                } else if (angular.isString(node.textContent)) {
                                    text = node.textContent;
                                }

                                lines.push({
                                    id: lineId,
                                    index: index,
                                    text: (text || '').trim()
                                });
                            });

                            $scope.$applyAsync(function () {
                                vm.tinyLines = lines;
                            });
                        } catch (err) {
                            $log.error('Error while refreshing TinyMCE lines', err);
                        }
                    }

                    function setHoverForBlock(block) {
                        if (!block) {
                            $scope.$applyAsync(function () {
                                if (!vm.tinyHoverLock) {
                                    vm.tinyHover = null;
                                    vm.tinyHoverTop = null;
                                    vm.tinyHoverBottom = null;
                                }
                            });
                            return;
                        }

                        var lineId = block.getAttribute('data-line-id');
                        if (!lineId) {
                            lineId = 'line-hover-' + Date.now();
                            block.setAttribute('data-line-id', lineId);
                        }

                        var text = '';
                        if (angular.isString(block.innerText)) {
                            text = block.innerText;
                        } else if (angular.isString(block.textContent)) {
                            text = block.textContent;
                        }

                        // 1) Rect del bloque dentro del viewport del iframe
                        //    (no usamos editor.dom.getRect, sino el DOM nativo)
                        var blockRect = block.getBoundingClientRect(); // { top, left, width, height, ... }

                        // 2) Iframe del editor en el documento principal
                        var iframe =
                            editor.iframeElement ||
                            (editor.getContentAreaContainer()
                                ? editor.getContentAreaContainer().querySelector('iframe')
                                : null);

                        if (!iframe) {
                            $scope.$applyAsync(function () {
                                vm.tinyHover = null;
                                vm.tinyHoverTop = null;
                                vm.tinyHoverBottom = null;
                            });
                            return;
                        }

                        // 3) Rect del iframe y del wrapper en el documento principal
                        var iframeRect = iframe.getBoundingClientRect();
                        var wrapper = iframe.closest('.editor-wrapper');
                        var wrapperRect = wrapper
                            ? wrapper.getBoundingClientRect()
                            : iframeRect;

                        // 4) Coordenadas absolutas en la página del bloque
                        var blockPageTop = iframeRect.top + blockRect.top;
                        var blockPageLeft = iframeRect.left + blockRect.left;

                        // 5) Coordenadas relativas al wrapper
                        var top = blockPageTop - wrapperRect.top;
                        var left = blockPageLeft - wrapperRect.left;

                        // 6) Posición de los botones a la IZQUIERDA del bloque
                        var buttonOffsetX = 25; // ancho del botón + margen
                        var leftSide = left - buttonOffsetX;

                        // Posición vertical del botón superior (inicio del <p>)
                        var topIconTop = top;

                        // Posición vertical del botón inferior (final del <p>)
                        var bottomIconTop = top + blockRect.height;

                        $scope.$applyAsync(function () {
                            vm.tinyHover = {
                                id: lineId,
                                text: (text || '').trim()
                            };

                            vm.tinyHoverTop = {
                                id: lineId,
                                text: (text || '').trim(),
                                top: topIconTop,
                                left: leftSide
                            };

                            vm.tinyHoverBottom = {
                                id: lineId,
                                text: (text || '').trim(),
                                top: bottomIconTop,
                                left: leftSide
                            };
                        });
                    }

                    // Recompute hover button positions using the current hovered line
                    function refreshHoverPositionFromCurrent() {
                        // If there is no active hover line, nothing to do
                        if (!vm.tinyHover || !vm.tinyHover.id) {
                            return;
                        }

                        var selector = '[data-line-id="' + vm.tinyHover.id + '"]';
                        var node = editor.dom.select(selector)[0];

                        if (!node) {
                            return;
                        }

                        setHoverForBlock(node);
                    }

                    editor.on('init', function () {
                        // normalizeParagraphsWithBr();
                        refreshLines();

                        // Attach scroll listener to the editor window (iframe)
                        var win = editor.getWin();
                        if (win && win.addEventListener) {
                            win.addEventListener('scroll', function () {
                                // When the user scrolls inside TinyMCE, update button positions
                                refreshHoverPositionFromCurrent();
                            });
                        }
                    });

                    editor.on('ScrollContent', function () {
                        refreshHoverPositionFromCurrent();
                    });

                    editor.on('change', function (e) {
                      if (vm.basicForm){
                        vm.basicForm.$setDirty();
                      }
                    //   normalizeParagraphsWithBr();
                      refreshLines();
                    });

                    editor.on('keyup', function (e) {
                        var key = e.key || e.keyCode;

                        if (key === 'Enter' || key === 13) {
                          refreshLines();
                        }
                    });

                    editor.on('mousemove', function (e) {
                        var target = e.target;
                        // Find closest block ancestor we consider a "line"
                        var block = editor.dom.getParent(
                            target,
                            'p,h1,h2,h3,h4,h5,h6,div,li,figure'
                        );
                        setHoverForBlock(block);
                    });

                    // editor.on('mouseleave', function () {
                    //     $scope.$applyAsync(function () {
                    //         vm.tinyHover = null;
                    //     });
                    // });

                    editor.on('BeforeSetcontent', function (event) {
                        var zoneMedia = vm.setTinyMceContent(event);
                        var cont = event.content;
                        var newCont = cont;
                        var validData = {
                            left: 'align-left',
                            center: 'align-center',
                            right: 'align-right',
                            25: 'size-25',
                            50: 'size-50',
                            75: 'size-75',
                            100: 'size-100',
                        }

                      // Regex for old images
                      var regex = /(\[image\|([^\]]*)\])/g;
                      var m;
                      while ((m = regex.exec(cont)) !== null) {
                        var expCont = '';
                        var mediaData = {
                          type: '',
                          sort: '',
                          class: ''
                        };
                        var mediaExtra = '';
                        // This is necessary to avoid infinite loops with zero-width matches
                        if (m.index === regex.lastIndex) {
                          regex.lastIndex++;
                        }
                        if (m[2]) {
                          expCont = m[2].split('|');
                          mediaData.type = 'image';
                          for (var i = 0; i < expCont.length; i++) {
                            if (i == 0) {
                              mediaData.sort = expCont[i];
                            } else {
                              mediaExtra = expCont[i];
                              if (angular.isDefined(validData[mediaExtra])) {
                                mediaData.class += validData[mediaExtra] + ' ';
                              }
                            }
                          }
                          var newHtml = '';

                          // if (angular.isDefined(zoneMedia[1][mediaData.sort])) {
                          if (angular.isDefined(zoneMedia[1][mediaData.sort])) {
                            newHtml = '<div contentEditable="false" class="' + mediaData.class + ' qiumedia-image " data-qiumedia="' + m[0].substr(1,(m[0].length-2)) + '"><img src="' + zoneMedia[1][mediaData.sort].cropstatus[0].container.view_url + zoneMedia[1][mediaData.sort].cropstatus[0].fileName + '" class=" width-percent-100"></div>';
                          }
                          newCont = newCont.replace(m[0], newHtml);
                          event.content = newCont;
                        }
                      }

                      // Regex for old videos
                      regex = /(\[video\|([^\]]*)\])/g;
                      var n;
                      while ((n = regex.exec(cont)) !== null) {
                        newHtml = '';
                        expCont = '';
                        mediaData = {
                          type: '',
                          sort: '',
                          class: ''
                        };
                        mediaExtra = '';
                        // This is necessary to avoid infinite loops with zero-width matches
                        if (n.index === regex.lastIndex) {
                          regex.lastIndex++;
                        }
                        if (n[2]) {
                          expCont = n[2].split('|');
                          mediaData.type = 'video';
                          for (i = 0; i < expCont.length; i++) {
                            if (i == 0) {
                              mediaData.sort = expCont[i];
                            } else {
                              mediaExtra = expCont[i];
                              if (angular.isDefined(validData[mediaExtra])) {
                                mediaData.class += validData[mediaExtra] + ' ';
                              }
                            }
                          }
                          if (angular.isDefined(zoneMedia[2][mediaData.sort])) {
                            newHtml = '<div contentEditable="false" class="' + mediaData.class + ' qiumedia-video " data-qiumedia="' + n[0].substr(1, (n[0].length - 2)) + '"><img src="' + zoneMedia[2][mediaData.sort].embed_thumb + '" class=" width-percent-100"></div>';
                          }
                          newCont = newCont.replace(n[0], newHtml);
                          event.content = newCont;
                        }
                      }

                      // Regex for images
                      regex = /(\[imageid\|([^\]]*)\])/g;
                        m;
                        while ((m = regex.exec(cont)) !== null) {
                            expCont = '';
                            mediaData = {
                                type: '',
                                sort: '',
                                class: ''
                            };
                            mediaExtra = '';
                            // This is necessary to avoid infinite loops with zero-width matches
                            if (m.index === regex.lastIndex) {
                                regex.lastIndex++;
                            }
                            if (m[2]) {
                                expCont = m[2].split('|');
                                mediaData.type = 'image';
                                for (i = 0; i < expCont.length; i++) {
                                    if (i == 0) {
                                        mediaData.sort = expCont[i];
                                    } else {
                                        mediaExtra = expCont[i];
                                        if (angular.isDefined(validData[mediaExtra])) {
                                            mediaData.class += validData[mediaExtra] + ' ';
                                        }
                                    }
                                }
                                newHtml = '';

                                // if (angular.isDefined(zoneMedia[1][mediaData.sort])) {
                                const found = Object.values(zoneMedia[1]).find(x => x.id_media == mediaData.sort)
                                if (found && found.cropstatus && found.cropstatus.length) {
                                    newHtml = '<div contentEditable="false" class="' + mediaData.class + ' qiumedia qiumedia-image " data-qiumedia="' + m[0].substr(1, (m[0].length - 2)) + '"><img src="' + found.cropstatus[0].container.view_url + found.cropstatus[0].fileName + '" class=" width-percent-100"></div>';
                                }
                                newCont = newCont.replace(m[0], newHtml);
                                event.content = newCont;
                            }
                        }
                      // Regex for videos
                        regex = /(\[videoid\|([^\]]*)\])/g;
                        n;
                        while ((n = regex.exec(cont)) !== null) {
                            newHtml = '';
                            expCont = '';
                            mediaData = {
                                type: '',
                                sort: '',
                                class: ''
                            };
                            mediaExtra = '';
                            // This is necessary to avoid infinite loops with zero-width matches
                            if (n.index === regex.lastIndex) {
                                regex.lastIndex++;
                            }
                            if (n[2]) {
                                expCont = n[2].split('|');
                                mediaData.type = 'video';
                                for (i = 0; i < expCont.length; i++) {
                                    if (i == 0) {
                                        mediaData.sort = expCont[i];
                                    } else {
                                        mediaExtra = expCont[i];
                                        if (angular.isDefined(validData[mediaExtra])) {
                                            mediaData.class += validData[mediaExtra] + ' ';
                                        }
                                    }
                                }
                                const found = Object.values(zoneMedia[2]).find(x => x.id_media == mediaData.sort)
                                if (found) {
                                  newHtml = '<div contentEditable="false" class="' + mediaData.class + ' qiumedia qiumedia-video " data-qiumedia="' + n[0].substr(1, (n[0].length - 2)) + '"><img src="' + found.embed_thumb + '" class=" width-percent-100"></div>';
                                }
                                newCont = newCont.replace(n[0], newHtml);
                                event.content = newCont;
                            }
                        }
                    });
                }
            };
            return tinymceOptions;
        }
        // Return the public API.
        return ({
            setQiuMediaTextContent: setQiuMediaTextContent,
            getOptions: getOptions,
        });


    }


})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .service('settingUserService', settingUserService);

    /** @ngInject */
    // I provide access to the session store.
    function settingUserService($q, $resource, $rootScope, COMMON, requestContext) {
        var vm = this;
        vm.userSettingsDomain = null;
        vm.userSettingsGlobal = null;
        vm.loadingGlobal = false;
        vm.loadingDomain = false;
        $rootScope.$on('site:loadStartDomain', function (event, data) {
            if (!vm.loadingGlobal && !vm.loadingDomain) {
                console.log("reloading settings");
                createUserSettings()
            }
        });

        function getGlobalUserSettings() {
            return vm.userSettingsGlobal;
        }
        function getDomainlUserSettings() {
            return vm.userSettingsDomain;
        }

        function setSetting(section, property, value, action) {
            if (!vm.userSettingsGlobal.settings_json[section]) {
                vm.userSettingsGlobal.settings_json[section] = {};
            }
            if (!vm.userSettingsDomain.settings_json[section]) {
                vm.userSettingsDomain.settings_json[section] = {};
            }
            if (typeof vm.userSettingsGlobal.settings_json[section][property] == 'undefined') {
                updateSetting(section, property, value, true)
            }
            if (typeof vm.userSettingsDomain.settings_json[section][property] == 'undefined' || vm.userSettingsDomain.settings_json[section][property] != value) {
                updateSetting(section, property, value, false)
            }
        }

        function updateSetting(section, property, value, noDomain) {
            var data;
            if (noDomain) {
                vm.userSettingsGlobal.settings_json[section][property] = value;
                data = vm.userSettingsGlobal;
            } else {
                vm.userSettingsDomain.settings_json[section][property] = value;
                data = vm.userSettingsDomain;
            }
            var deferred = $q.defer();
            resourceUpdateUserSettings.put({
                domain: vm.siteID
            }, {
                id_user_settings: data.id_user_settings,
                settings: data.settings_json
            }, function (response) {
                deferred.resolve(response);
            }, function (e) {
                console.error("ERROR =========================================!!!!!!");
                console.error(e);
                deferred.reject();
            });
            return (deferred.promise);
        }

        function getSettingValue(section, property, defaultValue) {
            if (vm.userSettingsDomain && typeof vm.userSettingsDomain.settings_json[section] != 'undefined' && typeof vm.userSettingsDomain.settings_json[section][property] != 'undefined') {
                return vm.userSettingsDomain.settings_json[section][property];
            }
            if (vm.userSettingsGlobal && typeof vm.userSettingsGlobal.settings_json[section] != 'undefined' && typeof vm.userSettingsGlobal.settings_json[section][property] != 'undefined') {
                return vm.userSettingsGlobal.settings_json[section][property];
            }
            return defaultValue;
        }


        function createUserSettings(siteID) {
            vm.loadingGlobal = true;
            vm.loadingDomain = true;
            if (siteID) {
                vm.siteID = siteID;
            }
            getUserSettings().then(response => {
                response = JSON.parse(angular.toJson(response))
                vm.userSettingsGlobal = response && response.find(x => x.id_domain === null);
                vm.userSettingsDomain = response && response.find(x => x.id_domain != null);
                if (!vm.userSettingsGlobal) {
                    requestNewUserSettings({
                        "noDomain": true,
                        "settings": {
                            "dateFormat": "Y-m-d H:i:s"
                        }
                    }).then(global => {
                        vm.userSettingsGlobal = JSON.parse(angular.toJson(global));
                        vm.loadingGlobal = false;
                    });
                } else {
                    vm.loadingGlobal = false;
                }
                if (!vm.userSettingsDomain) {
                    requestNewUserSettings({
                        "settings": {
                            "dateFormat": "Y-m-d H:i:s"
                        }
                    }).then(domain => {
                        vm.userSettingsDomain = JSON.parse(angular.toJson(domain));
                        vm.loadingDomain = false;
                    });
                } else {
                    vm.loadingDomain = false;
                }

            })

        }

        function requestNewUserSettings(data) {
            var deferred = $q.defer();
            resourceNewUserSettings.post({
                domain: vm.siteID
            }, data, function (response) {
                deferred.resolve(response);
            }, function (e) {
                console.error("ERROR =========================================!!!!!!");
                console.error(e);
                deferred.reject();
            });
            return (deferred.promise);
        }

        function getUserSettings(noDomain) {
            var deferred = $q.defer();
            resourceUserSettings.get({
                domain: vm.siteID
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);

        }

        var resourceUserSettings = $resource(
            COMMON.BASE_API + "/domain/:domain/profile/getSettings", {
            // No default data.
            domain: '@domain',
            id: '@id'
        }, {
            get: {
                method: "GET",
                isArray: true
            }
        }
        );
        var resourceNewUserSettings = $resource(
            COMMON.BASE_API + "/domain/:domain/profile/newSettings", {
            // No default data.
            domain: '@domain',
            id: '@id'
        }, {
            post: {
                method: "POST"
            }
        }
        );
        var resourceUpdateUserSettings = $resource(
            COMMON.BASE_API + "/domain/:domain/profile/updateSettings", {
            // No default data.
            domain: '@domain',
            id: '@id'
        }, {
            put: {
                method: "PUT"
            }
        }
        );



        // Return the public API.
        return ({
            userSettingsGlobal: vm.userSettingsGlobal,
            userSettingsDomain: vm.userSettingsDomain,
            getSettingValue: getSettingValue,
            createUserSettings: createUserSettings,
            requestNewUserSettings: requestNewUserSettings,
            setSetting: setSetting,
            updateSetting: updateSetting,
            getGlobalUserSettings: getGlobalUserSettings,
            getDomainlUserSettings: getDomainlUserSettings
        });


    }
})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .service('sessionService', sessionService);

    /** @ngInject */
    // I provide access to the session store.
    function sessionService($q, $resource, $translate, userService, settingsDomainService, settingUserService, COMMON, $window, requestContext, $rootScope, $state, $stateParams, msNavigationService, $auth, $location, $filter, $timeout) {


        // I attempt to login the current user. I return a promise that will resolve or reject
        // depending on whether or not the login request works.
        function authenticate(siteId) {

            // Create our deferred results.
            var deferred = $q.defer();

            // Make the request to the server.
            resourceAccount.get({
                // No data needs to be passed - cookies will take care of passing the authentication
                // token that has been provided by the server.
            },
                function (response) {
                    // Store the account and subscription information.
                    angular.extend(user, response.account);
                    user.domains_list = [];
                    angular.extend(user.domains_list, response.domains);
                    angular.extend(subscription, response.subscription);
                    angular.copy(response.domains, domains)



                    user.projectsUrl = response.projectsUrl;

                    // Get the initials for use throughout the application (avatars).
                    user.initials = userService.getInitials(user.name);

                    // Determine whether or not the user is currently using a system avatar.
                    user.hasSystemAvatar = userService.isSystemAvatar(user.avatarID);

                    // Information about sync connections
                    if (response && response.sync) {
                        user.isSyncEnabled = response.sync.enabled;
                        user.syncClients = response.sync.clients;
                    }

                    // Used to set Enterprise details
                    user.companyInfo = response.companyInfo;
                    user.isAccountAuthenticated = true;

                    if (siteId) {
                        user.domain_active = _.find(domains, {
                            'subdomain': siteId
                        });
                        setDefaultDomain(false, siteId)
                            .then(function () {
                                // Resolve the promise.
                                deferred.resolve(response);
                            })
                    } else if (user.default_domain) {
                        user.domain_active = _.find(domains, {
                            'id_domain': user.default_domain
                        });

                        setDefaultDomain(user.domain_active)
                            .then(function () {
                                // Resolve the promise.
                                deferred.resolve(response);
                            })
                    }



                },
                function () {
                    $auth.logout()
                        .then(function () {

                            cleanAllStorage();
                            $location.path('/login');

                            // $window.location.reload();

                        });

                    deferred.reject();

                }
            );

            // Return the promise.
            return (deferred.promise);

        }

        function cleanAllStorage() {
            Object.keys($window.sessionStorage)
                .forEach(function (k) {
                    $window.sessionStorage.removeItem(k);
                });
        }

        function createSettings(sideID, user) {
            requestNewSettings(sideID, {
                "id_user": user.id_user,
                "settings": {
                    "dateFormat": "Y-m-d H:i:s",
                    "CustomSetting": "2342dcsadasd"
                }
            }).then(res => {

            });

        }

        function requestNewSettings(sideID, data) {
            var deferred = $q.defer();
            resourceUserSettings.post({
                domain: siteID
            }, data, function (response) {
                deferred.resolve(response);
            }, function (e) {
                console.error("ERROR =========================================!!!!!!");
                console.error(e);
                deferred.reject();
            });
            return (deferred.promise);
        }

        function setDefaultDomain(domain, siteID) {
            var deferred = $q.defer();

            var domainStorage = $window.sessionStorage.getItem("domain")
            var domainStorageJson = JSON.parse(domainStorage);

            // var siteID = requestContext.getParam("siteId");


            if (siteID) {

                user.domain_active = _.find(domains, {
                    'subdomain': siteID
                });
                $window.sessionStorage.setItem("domain", JSON.stringify(user.domain_active));
                setSiteOperative(user.domain_active)
                    .then(function () {
                        deferred.resolve();
                    })
            } else {
                if (_.isEmpty(domainStorage)) {
                    // alert("is empty set:::"+ domain.subdomain)
                    $window.sessionStorage.setItem("domain", JSON.stringify(domain));
                    setSiteOperative(domain)
                        .then(function () {
                            deferred.resolve();
                        })
                } else {
                    //                    console.log(domainStorageJson.id_domain + '-' + domainStorageJson.subdomain)

                    // alert("NOT is empty set:::"+ domainStorageJson.subdomain)

                    setSiteOperative(JSON.parse(domainStorage))
                        .then(function () {
                            deferred.resolve();
                        })
                }
            }
            return (deferred.promise);

        }

        function setActiveDomain(domain) {
            var domainStorage = $window.sessionStorage.getItem("domain")
            // if(_.isEmpty(domainStorage)){
            $window.sessionStorage.setItem("domain", JSON.stringify(domain));
            // setSiteOperative(domain)
            // }
        }

        function changeLanguage(lang_code) {
            if (!lang_code) {
                var langStorage = $window.sessionStorage.getItem("LANG_CODE");
                if (langStorage) {
                    $translate.use(langStorage);
                }
            } else {
                $translate.use(lang_code);
                $window.sessionStorage.setItem("LANG_CODE", lang_code);
            }
        }

        function getLanguage(lang_code) {
            var langStorage = $window.sessionStorage.getItem("LANG_CODE");
            if (langStorage) {
                return $window.sessionStorage.getItem("LANG_CODE");
            } else {
                return $translate.preferredLanguage();
            }
        }

        // I get the data at the given key (or return the given default if the key is undefined).
        function get(key, defaultValue) {

            var localKey = getDataKey(key);

            // If the key exists, return its value.
            if (data.hasOwnProperty(localKey)) {

                return (data[localKey]);

                // If the key doesn't exist, but we have a default value, STORE it and return it.
            } else if (!angular.isUndefined(defaultValue)) {

                data[localKey] = defaultValue;

                return (defaultValue);

            }

        }

        // I get the data at the given key (or return the given default if the key is undefined).
        function getSettings() {

            return (defaultValue);

        }

        function getSiteLanguages() {
            var languagesArray = {};
            angular.forEach(site_operative.languages, function (lang) {
                languagesArray[lang.id_lang] = lang;
            })
            return languagesArray;

        }

        // Set session domain
        function setSiteOperative(domain) {
            if (!angular.isUndefined(domain)) {
                var deferred = $q.defer();
                settingUserService.createUserSettings(domain.subdomain)
                $rootScope.$emit('site:loadStartDomain', domain);
                $rootScope.$emit('msSplashScreen::add');

                domain_resource.get({
                    domain: domain.subdomain
                },
                    function (response) {
                        domain_resource_settings.get({
                            domain: domain.subdomain
                        },
                            function (responsesettings) {

                                var domainconfig = responsesettings;

                                angular.extend(site_operative, response);
                                if (site_operative.timezone) {
                                    site_operative.timezone = site_operative.timezone.toString().trim();
                                }


                                if (!angular.isUndefined(responsesettings.languages)) {
                                    angular.extend(site_operative, responsesettings);
                                }
                                angular.extend(site_operative, {
                                    dateFormat: 'DD/MM/YYYY'
                                });
                                angular.extend(site_operative, {
                                    dateTimeFormat: 'DD/MM/YYYY HH:mm'
                                });


                                setModuleSection(domain)
                                    .then(function () {
                                        getMenu(domain)
                                            .then(function (resp) {

                                                angular.extend(site_operative, resp);

                                                setMenu().then(function (resp) {
                                                    $rootScope.$emit('site:loadFinished', site_operative);
                                                    deferred.resolve(response);
                                                })



                                            })
                                            .catch(function (err) {
                                                deferred.reject();
                                            });
                                    });
                            },
                            function () {
                                deferred.reject();
                            }
                        );
                    },
                    function (err) {
                        console.log('domain_resource error', err);
                        $auth.logout()
                            .then(function () {
                                cleanAllStorage();
                                $location.path('/login');
                            });
                        deferred.reject();
                    }
                );
            }

            // Return the promise.
            return (deferred.promise);
        }


        function hasIdUserTab() {
            if ($rootScope.idUserTab) {
                return true;
            }
            return false;
        }

        function setModuleSection(domain) {
            var deferred = $q.defer();
            domain_module_resource.get({
                domain: domain.subdomain,
                resultsPerPage: 1000,
                sortField: 'section',
                sortDir: 'ASC',
                // lang: get("language")
            },
                function (response) {

                    angular.copy(response.data, modulecontent);
                    setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getMenu(domain) {
            var deferred = $q.defer();
            domain_menu.get({
                domain: domain.subdomain,
            },
                function (response) {
                    //angular.copy(response.menu, modulecontent);
                    setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function setMenu() {
            var deferred = $q.defer();
            if (typeof moment != 'undefined') {
                var tz = (site_operative.timezone || moment.tz.guess() || 'UTC').toString().trim();
                moment.tz.setDefault(tz);
            }


            msNavigationService.deleteItem('cms');
            // Set Navigation
            msNavigationService.saveItem('cms', {
                title: 'CMS',
                group: true,
                weight: 1
            });

            msNavigationService.deleteItem('mueva');
            if (user.is_admin) {
                // Set Navigation
                msNavigationService.saveItem('mueva', {
                    title: 'MUEVA',
                    group: true,
                    weight: 2
                });

                msNavigationService.saveItem('mueva.backendcontent', {
                    title: 'Backend content',
                    icon: 'icon-cog',
                    state: 'app.site_overview.backendcontent({siteId:"' + site_operative.subdomain + '"})',
                    // badge : {
                    //     content: 3,
                    //     color  : '#4CAF50'
                    // },
                    weight: 7,
                    qiuStateName: 'app.site_overview.backendcontent',
                    qiuStateParams: {
                        siteId: site_operative.subdomain
                    },
                    qiuModuleName: 'backendcontent',
                    idUserTab: 0
                });

                msNavigationService.saveItem('mueva.accounts', {
                    title: 'Accounts',
                    icon: 'icon-folder-account',
                    state: 'app.site_overview.accounts.list({siteId:"' + site_operative.subdomain + '", section:"0"})',
                    weight: 6,
                    qiuStateName: 'app.site_overview.accounts.list',
                    qiuStateParams: {
                        siteId: site_operative.subdomain,
                        section: '0'
                    },
                    qiuModuleName: 'accounts',
                    idUserTab: 0

                });

                msNavigationService.saveItem('mueva.activities', {
                    title: 'Activities',
                    icon: 'icon-run',
                    state: 'app.site_overview.accounts.activities({siteId:"' + site_operative.subdomain + '", section:"0"})',
                    weight: 6,
                    qiuStateName: 'app.site_overview.accounts.activities',
                    qiuStateParams: {
                        siteId: site_operative.subdomain,
                        section: '0'
                    },
                    qiuModuleName: 'accounts',
                    idUserTab: 0
                });

            }

            angular.forEach(site_operative.menu, function (virtualGroup) {
                var i = 1;
                angular.forEach(virtualGroup.tabs, function (tab, idx) {
                    var extraData = '';
                    var extraDataArr = {};
                    if (i == 1) {
                        msNavigationService.saveItem('cms.' + virtualGroup.name, {
                            title: virtualGroup.name,
                            icon: virtualGroup.icon,
                            weight: virtualGroup.sort
                        });
                    }
                    var moduleName = tab.module_name;
                    if ((moduleName == 'media' || moduleName == 'mediahub' || (virtualGroup.name && /media\s*hub/i.test(virtualGroup.name))) && tab.action == 'type') {
                        var mediaType = tab.tab_name;
                        var isMediahub = moduleName == 'mediahub' || (virtualGroup.name && /media\s*hub/i.test(virtualGroup.name));

                        if (isMediahub) {
                            moduleName = 'mediahub';
                            var mtLower = mediaType.toLowerCase();
                            if (mtLower == 'photos' || mtLower == 'photo') mediaType = 'Mediahub Photos';
                            if (mtLower == 'videos' || mtLower == 'video') mediaType = 'Mediahub Videos';
                        }

                        extraData = ', mediaType: \'' + mediaType + '\'';
                        extraDataArr = {
                            mediaType: mediaType
                        };
                    }

                    if (tab.extra) {
                        try {
                            var extraParams = angular.fromJson(tab.extra);
                            angular.forEach(extraParams, function (val, key) {
                                extraDataArr[key] = val;
                                extraData += ', ' + key + ': ' + val;
                            })
                        } catch (e) {
                            if (tab.extra && tab.extra.indexOf(';')) {
                                var extraParams = tab.extra.split(';');
                            } else {
                                var extraParams = tab.extra.split(',');
                            }
                            angular.forEach(extraParams, function (p) {
                                var params2 = p.split(':');
                                if (params2.length == 2) {
                                    extraDataArr[params2[0]] = params2[1].replace(/['"]+/g, '');
                                }
                            })
                            extraData += ', ' + tab.extra;
                        }
                    }

                    if (tab.module_name == 'content') {
                        if (tab.section.section === 'social_stream') {
                            msNavigationService.saveItem('cms.' + virtualGroup.name + '.' + tab.section.section, {
                                title: tab.section.name,
                                state: 'app.site_overview.' + tab.module_name + '.' + tab.action + '.' + tab.section.section + '({siteId:\'' + site_operative.subdomain + '\', section:\'' + tab.section.section + '\'})',
                                weight: tab.sort,
                                qiuStateName: 'app.site_overview.' + tab.module_name + '.' + tab.action + '.' + tab.section.section,
                                qiuStateParams: {
                                    siteId: site_operative.subdomain,
                                    section: tab.section.section
                                },
                                qiuModuleName: tab.module_name,
                                idUserTab: tab.id_user_tab
                            });
                        } else {
                            msNavigationService.saveItem('cms.' + virtualGroup.name + '.' + tab.section.section, {
                                title: tab.section.name,
                                state: 'app.site_overview.' + tab.module_name + '.' + tab.action + '({siteId:\'' + site_operative.subdomain + '\', section:\'' + tab.section.section + '\'})',
                                weight: tab.sort,
                                qiuStateName: 'app.site_overview.' + tab.module_name + '.' + tab.action,
                                qiuStateParams: {
                                    siteId: site_operative.subdomain,
                                    section: tab.section.section,
                                    name: tab.section.name
                                },
                                qiuModuleName: tab.module_name,
                                idUserTab: tab.id_user_tab
                            });
                            if (tab.section.name) {
                                setVirtualTabName(tab.section.section, tab.section.name)
                            }
                        }
                    } else {
                        var qiuStateParams = {
                            siteId: site_operative.subdomain
                        };
                        if (tab.module_name == 'users') {
                            extraDataArr.groupTypeName = tab.tab_name;
                            extraData = ', groupTypeName:"' + extraDataArr.groupTypeName + '"';
                        }
                        if (extraDataArr) {
                            angular.forEach(extraDataArr, function (val, key) {
                                qiuStateParams[key] = val;
                            })
                        }
                        msNavigationService.saveItem('cms.' + virtualGroup.name + '.' + tab.tab_name, {
                            title: tab.tab_name,
                            state: 'app.site_overview.' + moduleName + '.' + tab.action + '({siteId:\'' + site_operative.subdomain + '\'' + extraData + '})',
                            weight: tab.sort,
                            qiuStateName: 'app.site_overview.' + moduleName + '.' + tab.action,
                            qiuStateParams: qiuStateParams,
                            qiuModuleName: moduleName,
                            idUserTab: tab.id_user_tab
                        });
                    }
                    i++;

                })
            });
            deferred.resolve();
            return (deferred.promise);

        }

        function setVirtualTabName(key, name) {
            if (!site_operative.hasOwnProperty('virtualTabNames')) {
                site_operative.virtualTabNames = {};
            }
            site_operative.virtualTabNames[key] = name;
        }

        function updateMenu() {

            var domainStorage = $window.sessionStorage.getItem("domain")
            var domainStorageJson = JSON.parse(domainStorage);

            getMenu(domainStorageJson)
                .then(function (resp) {
                    angular.extend(site_operative, resp);
                    setMenu().then(function () {
                        $rootScope.$emit('site:loadFinished', site_operative);
                    });

                });
        }

        function setActiveSection(sectionName) {
            var deferred = $q.defer();

            var _ActiveSection = _.find(modulecontent, {
                'section': sectionName
            });


            angular.copy(_ActiveSection, ActiveSection);


            deferred.resolve(ActiveSection);

            // Return the promise.
            return (deferred.promise);
        }

        // I get the data key to use in the data-cache look-up. The key is decorated so as not to
        // collide with a standard JavaScript key.
        function getDataKey(key) {

            return ("session__" + key);

        }


        // I return whether or not the user has been authenticated.
        function isAuthenticated() {

            return (user.isAccountAuthenticated);

        }


        // I store the given value in the session.
        function set(key, value) {

            var localKey = getDataKey(key);

            return (data[localKey] = value);

        }

        function getMediaThumbnailCropformatId() {
            return site_operative.mediaThumbnailCropformatId;
        }

        function getMediaFullCropformatId() {
            return site_operative.mediaFullCropformatId;
        }

        function getCropformatByID(id) {
            id = id * 1;
            return _.find(site_operative.cropformats, {
                'id_cropformats': id
            });
        }

        function loadDomainResourceSettings(siteID) {
            var deferred = $q.defer();
            domain_resource_settings.get({
                domain: siteID
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    deferred.reject();
                }
            );
            // Return the promise.
            return deferred.promise;
        }

        function getContainerByID(id) {
            return _.find(site_operative.cdnContainers, {
                'id_container': id
            });
        }

        function getVirtualTabName(key) {
            return site_operative.virtualTabNames[key] || null;
        }

        // I reload the authenticated user (if information has changed).
        function update() {

            // Make the request to the server.
            resource.get({},
                function (response) {

                    angular.extend(user, response.account);
                    angular.extend(subscription, response.subscription);

                    // Update the initials and avatar status.
                    user.initials = userService.getInitials(user.name);
                    user.hasSystemAvatar = userService.isSystemAvatar(user.avatarID);

                }
            );

        }


        // -------------------------------------------------- //
        // -------------------------------------------------- //


        // Store the active Site for the authenticating user.
        var site_operative = {};
        var modulecontent = [];
        var ActiveSection = [];

        // Define the resource that will translate requests locally to server-side resources.
        var resourceAccount = $resource(
            COMMON.BASE_API + "/backend/user", {
            // No default data.
        }, {
            getUser: {
                method: "GET"
            }
        }
        );

        // Define the resource that will translate requests locally to server-side resources.
        var domain_resource = $resource(
            COMMON.BASE_API + "/domain/:domain/currentDomain", {
            // No default data.
        }, {
            getUser: {
                method: "GET"
            }
        }
        );

        // Define the resource that will translate requests locally to server-side resources.
        var domain_resource_settings = $resource(
            COMMON.BASE_API + "/domain/:domain/getDomainSettings", {
            // No default data.
        }, {
            get: {
                method: "GET",
                //					isArray: true
            }
        }
        );

        var domain_module_resource = $resource(
            COMMON.BASE_API + "/domain/:domain/content/getMenu", {
            // No default data.
        }, {
            get: {
                method: "GET",
                // isArray: true
            }
        }
        );

        var domain_menu = $resource(
            COMMON.BASE_API + "/domain/:domain/getMenu", {
            // No default data.
        }, {
            get: {
                method: "GET",
                // isArray: true
            }
        }
        );

        // Store the default authenticating user.
        var user = {
            id: 0,
            name: "",
            initials: "",
            hasSystemAvatar: true,
            email: "",
            isAccountAuthenticated: false
        };

        // Store the default subscription for the authenticating user.
        var subscription = {};



        // Store domains for the authenticating user.
        // array()
        var domains = [];

        // I store session data that the controllers can use to store some small stateful items.
        var data = {};

        // Copy the feature flags into the session.
        // var featureFlags = _.extend({}, config.featureFlags);





        // -------------------------------------------------- //
        // -------------------------------------------------- //


        // Return the public API.
        return ({
            authenticate: authenticate,
            setActiveDomain: setSiteOperative,
            setModuleSection: setModuleSection,
            getMenu: getMenu,
            updateMenu: updateMenu,
            setActiveSection: setActiveSection,
            cleanAllStorage: cleanAllStorage,
            // featureFlags: featureFlags,
            get: get,
            isAuthenticated: isAuthenticated,
            set: set,
            update: update,
            subscription: subscription,
            user: user,
            site_operative: site_operative,
            modulecontent: modulecontent,
            domains: domains,
            getSettings: getSettings,
            getSiteLanguages: getSiteLanguages,
            hasIdUserTab: hasIdUserTab,
            ActiveSection: ActiveSection,
            changeLanguage: changeLanguage,
            getLanguage: getLanguage,
            getContainerByID: getContainerByID,
            getVirtualTabName: getVirtualTabName,
            getMediaThumbnailCropformatId: getMediaThumbnailCropformatId,
            getMediaFullCropformatId: getMediaFullCropformatId,
            getCropformatByID: getCropformatByID,
            loadDomainResourceSettings: loadDomainResourceSettings
        });


    }
})();

(function() {
    'use strict';

    angular
        .module('app.core')



    .service("requestContext", RequestContext);


    // I provide access to the project store.
    /** @ngInject */
    function RequestContext(RenderContext) {

        // Store the injected properties.
        this.RenderContext = RenderContext;

        // Store the current action path.
        this._action = "";

        // Store the action as an array of parts so we can more easily examine parts of it.
        this._sections = [];

        // Store the current route param.
        this._params = {};

        // Store the previous action and route params. We'll use these to make a comparison from
        // one route change to the next.
        this._previousAction = "";
        this._previousParams = {};

        // Return this object reference.
        return (this);

    }


    // Define the instance methods.
    RequestContext.prototype = {

        // I get the current action.
        getAction: function() {

            return (this._action);

        },


        // I get the next section at the given location on the action path.
        getNextSection: function(prefix) {

            // Make sure the prefix is actually in the current action.
            if (!this.startsWith(prefix)) {

                return (null);

                // throw(
                // 	new Error( "Invalid prefix for current action: " + this._action )
                // );

            }

            // If the prefix is empty, return the first section.
            if (prefix === "") {

                return (this._sections[0]);

            }

            // Now that we know the prefix is valid, lets figure out the depth of the current path.
            var depth = prefix.split(".").length;

            // If the depth is out of bounds, meaning the current action doesn't define sections
            // to that path (they are equal), then return null.
            if (depth === this._sections.length) {

                return (null);

            }

            // Return the section.
            return (this._sections[depth]);

        },


        // I return the param with the given name, or null.
        getParam: function(name) {

            return (this._params[name] || null);

        },

        // I return the param with the given name, or null.
        getParams: function() {

            return (this._params || null);

        },


        // I return the param as an int. If the param cannot be returned as an int, the given 
        // default value is returned. If no default value is defined, the return will be zero.
        getParamAsInt: function(name, defaultValue) {

            // Try to parse the number.
            var valueAsInt = parseInt(this.getParam(name));

            // Check to see if the coersion failed. If so, return the default.
            if (isNaN(valueAsInt)) {

                return (defaultValue || 0);

            } else {

                return (valueAsInt);

            }

        },


        // I return the render context for the given action prefix and sub-set of route params.
        getRenderContext: function(requestActionLocation, paramNames) {

            // Default the requestion action.
            requestActionLocation = (requestActionLocation || "");

            // Default the param names. 
            paramNames = (paramNames || []);

            // The param names can be passed in as a single name; or, as an array of names. If a 
            // single name was provided, let's convert it to the array.
            if (!angular.isArray(paramNames)) {

                paramNames = [paramNames];

            }

            return (
                new this.RenderContext(this, requestActionLocation, paramNames)
            );

        },


        // I determine if the action has changed in this particular request context.
        hasActionChanged: function() {

            return (this._action !== this._previousAction);

        },


        // I determine if the given param has changed in this particular request context. This 
        // change comparison can be made against a specific value (paramValue); or, if only the
        // param name is defined, the comparison will be made agains the previous snapshot.
        hasParamChanged: function(paramName, paramValue) {

            // If the param value exists, then we simply want to use that to compare against the
            // current snapshot. 
            if (!angular.isUndefined(paramValue)) {

                return (!this.isParam(paramName, paramValue));

            }

            // If the param was NOT in the previous snapshot, then we'll consider it changing.
            if (!(paramName in this._previousParams) &&
                (paramName in this._params)
            ) {

                return (true);

                // If the param was in the previous snapshot, but NOT in the current, we'll consider 
                // it to be changing.
            } else if (
                (paramName in this._previousParams) &&
                !(paramName in this._params)
            ) {

                return (true);

            }

            // If we made it this far, the param existence has not change; as such, let's compare
            // their actual values.
            return (this._previousParams[paramName] !== this._params[paramName]);

        },


        // I determine if any of the given params have changed in this particular request context.
        haveParamsChanged: function(paramNames) {

            for (var i = 0, length = paramNames.length; i < length; i++) {

                if (this.hasParamChanged(paramNames[i])) {

                    // If one of the params has changed, return true - no need to continue checking
                    // the other parameters.
                    return (true);

                }

            }

            // If we made it this far then none of the params have changed.
            return (false);

        },


        // I check to see if the given param is still the given value.
        isParam: function(paramName, paramValue) {

            // When comparing, using the coersive equals since we may be comparing parsed value 
            // against non-parsed values.
            if (
                (paramName in this._params) &&
                (this._params[paramName] == paramValue)
            ) {

                return (true);

            }

            // If we made it this far then param is either a different value; or, is no longer 
            // available in the route.
            return (false);

        },


        // I set the new request context conditions.
        setContext: function(action, routeParams) {

            // Copy the current action and params into the previous snapshots.
            this._previousAction = this._action;
            this._previousParams = this._params;

            // Set the action.
            if (!_.isUndefined(action)) {
                this._action = action;


                // Split the action to determine the sections.
                this._sections = action.split(".");
            }

            // Update the params collection.
            this._params = angular.copy(routeParams);

        },


        // I determine if the current action starts with the given path.
        startsWith: function(prefix) {

            // When checking, we want to make sure we don't match partial sections for false
            // positives. So, either it matches in entirety; or, it matches with an additional
            // dot at the end.
            if (!prefix.length ||
                (this._action === prefix) ||
                (this._action.indexOf(prefix + ".") === 0)
            ) {

                return (true);

            }

            return (false);

        }

    };


})();
(function() {
    'use strict';

    angular
        .module('app.core')
        .value("RenderContext", RenderContext);


    // I provide a proxy to the render conditions that understands a given request action and set
    // of param names and can negotiate when a change needs to be processed.
    /** @ngInject */
    function RenderContext(requestContext, actionPrefix, paramNames) {

        // Store the injected properties.
        this._requestContext = requestContext;
        this._actionPrefix = actionPrefix;
        this._paramNames = paramNames;

        // Return this object reference.
        return (this);

    }


    // Define the instance methods.
    RenderContext.prototype = {

        // I return the next section after the location being watched.
        getNextSection: function() {

            return (
                this._requestContext.getNextSection(this._actionPrefix)
            );

        },


        // I check to see if the action has changed (and is local to the current location).
        isChangeLocal: function() {

            return (
                this._requestContext.startsWith(this._actionPrefix)
            );

        },


        // I determine if the last change in the request context is relevant to the action and route
        // params being observed in this render context.
        isChangeRelevant: function() {

            // If the action is not local to the action prefix, then we don't even want to bother
            // checking the params.
            if (!this._requestContext.startsWith(this._actionPrefix)) {

                return (false);

            }

            // If the action has changed, we don't need to bother checking the params.
            if (this._requestContext.hasActionChanged()) {

                return (true);

            }

            // If we made it this far, we know that the action has not changed. As such, we''ll 
            // have to make the change determination based on the observed parameters.
            return (
                this._paramNames.length &&
                this._requestContext.haveParamsChanged(this._paramNames)
            );

        }

    };

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window, $sce, $rootScope, $translate, sessionService, templateBuilderConfig, CommonMediaService, $mdToast) {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists: exists,
            existInArray: existInArray,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile: isMobile,
            toggleInArray: toggleInArray,
            toggleInGroup: toggleInGroup,
            arrayObjectIndexOf: arrayObjectIndexOf,
            toSectionRef: toSectionRef,
            setItemMedia: setItemMedia,
            getExtension: getExtension,
            getExtensionIcon: getExtensionIcon,
            getMediaPlaceholder: getMediaPlaceholder,
            getInArray: getInArray,
            deleteSearhNav: deleteSearhNav,
            openUrl: openUrl,
            hasEmptyArrays: hasEmptyArrays,
            timeAgo: timeAgo,
            formatDate: formatDate,
            formatDateToUnixTS: formatDateToUnixTS,
            removeObjectsFromArrayByProperty: removeObjectsFromArrayByProperty,
            translate: translate,
            getFileTypeId: getFileTypeId,
            getGalleryTypeById: getGalleryTypeById,
            showError: showError,
            preventDefault: preventDefault,
            getGroupByIdNested: getGroupByIdNested,
            capitalize: capitalize,
            exportToBrowser: exportToBrowser,
            hasProp: hasProp
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list) {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser() {
            // If we already tested, do not test again
            if (browserInfo) {
                return browserInfo;
            }

            var browserData = [
                {
                    string: $window.navigator.userAgent,
                    subString: 'Edge',
                    versionSearch: 'Edge',
                    identity: 'Edge'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity: 'Chrome'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity: 'OmniWeb'
                },
                {
                    string: $window.navigator.vendor,
                    subString: 'Apple',
                    versionSearch: 'Version',
                    identity: 'Safari'
                },
                {
                    prop: $window.opera,
                    identity: 'Opera'
                },
                {
                    string: $window.navigator.vendor,
                    subString: 'iCab',
                    identity: 'iCab'
                },
                {
                    string: $window.navigator.vendor,
                    subString: 'KDE',
                    identity: 'Konqueror'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity: 'Firefox'
                },
                {
                    string: $window.navigator.vendor,
                    subString: 'Camino',
                    identity: 'Camino'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity: 'Netscape'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'MSIE',
                    identity: 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'Trident/7',
                    identity: 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'Gecko',
                    identity: 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'Mozilla',
                    identity: 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string: $window.navigator.platform,
                    subString: 'Win',
                    identity: 'Windows'
                },
                {
                    string: $window.navigator.platform,
                    subString: 'Mac',
                    identity: 'Mac'
                },
                {
                    string: $window.navigator.platform,
                    subString: 'Linux',
                    identity: 'Linux'
                },
                {
                    string: $window.navigator.platform,
                    subString: 'iPhone',
                    identity: 'iPhone'
                },
                {
                    string: $window.navigator.platform,
                    subString: 'iPod',
                    identity: 'iPod'
                },
                {
                    string: $window.navigator.platform,
                    subString: 'iPad',
                    identity: 'iPad'
                },
                {
                    string: $window.navigator.platform,
                    subString: 'Android',
                    identity: 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data) {
                for (var i = 0; i < data.length; i++) {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if (dataString) {
                        if (dataString.indexOf(data[i].subString) !== -1) {
                            return data[i].identity;

                        }
                    }
                    else if (dataProp) {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString) {
                var index = dataString.indexOf(versionSearchString);

                if (index === -1) {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os: os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator() {
            var S4 = function () {
                return (((1 + Math.random()) * 0x10000) || 0)
                    .toString(16)
                    .substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Check if object has property
         * @param  {object}  o
         * @param  {string}  prop
         * @return {Boolean}
         */
        function hasProp(o, prop) {
            if (o == undefined) {
                return false;
            }
            return o.hasOwnProperty(prop);
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile() {
            return mobileDetect.mobile();
        }

        function toSectionRef(data, ref) {
            var result = {}
            for (var i = 0; i < ref.length; i++) {
                const element = ref[i];
                if (element.in_json_object == 1) {
                    if (element.type == 'thumbnail') {
                        result[element.titleId] = data.Thumbnail && data.Thumbnail.length > 0 ? setItemMedia(data.Thumbnail[0], element) : data[element.titleId];
                    } else if (element.type == 'zone') {
                        console.log('element', element);
                        console.log('data', data);
                    } else {
                        result[element.titleId] = data[element.titleId];
                    }
                }
            }
            return result;
        }

        function setItemMedia(attachment, refField) {
            var opts = {};
            opts.file = false;
            opts.thumbnail = false;
            var cropFormatId = (!refField || refField.id_cropformats === null) ? sessionService.getMediaThumbnailCropformatId() : refField.id_cropformats;
            if (cropFormatId == 0 || attachment.filename.includes(".gif") || attachment.filename.includes(".svg")) {
                var containerOriginal = sessionService.getContainerByID(attachment.cdnContainer);
                return containerOriginal.view_url + 'original/m' + attachment.id_media + '_' + attachment.filename;
            }
            if (angular.isObject(attachment) && angular.isObject(attachment.cropstatus) && attachment.cropstatus.length > 0) {
                if (typeof cropFormatId == 'string' || typeof cropFormatId == 'number') {
                    var cropformatObject = [cropFormatId];
                } else {
                    if (cropFormatId && cropFormatId.indexOf(';')) {
                        var cropformatObject = cropFormatId.split(';');
                    } else {
                        var cropformatObject = cropFormatId.split(',');
                    }
                }
                var cropstatus = _.find(attachment.cropstatus, function (c) {
                    if (c.id_cropformats == cropformatObject[0]) {
                        return true;
                    }
                });
                if (!angular.isUndefined(cropstatus)) {
                    var container = sessionService.getContainerByID(cropstatus.id_container);
                    return container.view_url + cropstatus.fileName;
                } else {
                    return '';
                }
            } else if (attachment.id_media && !attachment.isMediahub && !attachment.isIconik) {
                var options = {
                    id_media: [attachment.id_media],
                };

                CommonMediaService.getUrl(options)
                    .then(function (response) {
                        if (response.length > 0) {
                            var cropstatus = _.find(response, {
                                'id_cropformats': cropFormatId
                            });
                            if (!angular.isUndefined(cropstatus)) {
                                return cropstatus.url;
                            } else {
                                return false;
                            }
                        } else {
                            // Original showed
                            var containerOriginal = sessionService.getContainerByID(attachment.cdnContainer);
                            if (!angular.isUndefined(containerOriginal)) {
                                return containerOriginal.view_url + 'original/m' + attachment.id_media + '_' + attachment.filename;
                            }
                        }
                    });
            } else if (attachment.isMediahub || attachment.isIconik) {
                return attachment.imageUrl || '';
            }
        }


        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array, status) {
            if (_.isUndefined(array)) {
                alert("undefined")
            }

            if (status) {
                if (item == 1) {
                    array.push(item);
                } else {
                    array.splice(array.indexOf(item), 1);
                }
            } else {
                if (array.indexOf(item) === -1) {
                    array.push(item);
                } else {
                    array.splice(array.indexOf(item), 1);
                }
            }
        }


        /**
         * arrayObjectIndexOf
         *
         * @param array
         * @param searchTerm
         * @param property
         */
        function existInArray(array, key, value) {
            for (var i = 0, len = array.length; i < len; i++) {
                if (array[i][key] === value) {
                    return true;
                }
            }
            return false;
        }

        /**
         * arrayObjectIndexOf
         *
         * @param array
         * @param searchTerm
         * @param property
         */
        function arrayObjectIndexOf(array, searchTerm, property) {
            for (var i = 0, len = array.length; i < len; i++) {
                if (array[i][property] === searchTerm) {
                    return i;
                }
            }
            return -1;
        }

        /**
         * arrayObjectIndexOf
         *
         * @param array
         * @param searchTerm
         * @param property
         */
        function getExtension(filename) {
            return filename.split('.')
                .pop();
        }

        /**
         * arrayObjectIndexOf
         *
         * @param array
         * @param searchTerm
         * @param property
         */
        function getExtensionIcon(filename) {

            // Guard against items without a filename (e.g. some search results):
            // avoids "Cannot read properties of undefined (reading 'split')".
            if (!filename || typeof filename !== 'string') {
                return 'icon-file';
            }

            var found = false;
            var iconData = [
                {
                    extension: ['pdf'],
                    icon: 'icon-file-pdf-box'
                },
                {
                    extension: ['doc', 'docx'],
                    icon: 'icon-file-word-box'
                },
                {
                    extension: ['xls', 'xlsx', 'csv'],
                    icon: 'icon-file-excel-box'
                },
                {
                    extension: ['ppt', 'pptx'],
                    icon: 'icon-file-powerpoint-box'
                },
                {
                    extension: ['txt', 'rtf'],
                    icon: 'icon-file-document'
                },
                {
                    extension: ['zip', 'rar', 'tgz'],
                    icon: 'icon-zip-box'
                },
                {
                    extension: ['pdf'],
                    icon: 'icon-file-pdf-box'
                },
                {
                    extension: ['mp3', 'wav', 'wma'],
                    icon: 'icon-music-box'
                },
                {
                    extension: ['xml'],
                    icon: 'icon-file-xml'
                },
                {
                    extension: ['json'],
                    icon: 'icon-code-braces'
                },
                {
                    extension: ['png', 'jpg', 'tiff', 'gif', 'jpeg', 'bmp'],
                    icon: 'icon-file-image-box'
                },
                {
                    extension: ['mp4', 'mov', 'flv', 'avi', 'mpeg'],
                    icon: 'icon-camcorder'
                }
            ];

            var extension = filename.split('.')
                .pop();
            for (var i = 0; i < iconData.length; i++) {
                if (_.includes(iconData[i].extension, extension)) {
                    found = true;
                    return iconData[i].icon;
                }
            }
            if (!found) {
                return 'icon-file';
            }
        }

        /**
         * Returns the appropriate placeholder image path based on the item type or extension
         *
         * @param item
         * @returns {string} placeholder path
         */
        function getMediaPlaceholder(item) {
            var filename = '';
            var media_type = null;

            if (typeof item === 'string') {
                filename = item;
            } else if (item && typeof item === 'object') {
                filename = item.filename || item.fileName || (item.Thumbnail && item.Thumbnail[0] ? item.Thumbnail[0].filename : '');
                media_type = item.media_type || (item.Thumbnail && item.Thumbnail[0] ? item.Thumbnail[0].media_type : null);
            }

            var extension = filename.split('.').pop().toLowerCase();

            if (extension === 'svg') {
                return 'assets/images/common/svg_placeholder.png';
            }

            // Map extensions to placeholders
            var extensionMap = {
                'pdf': 'assets/images/common/pdf.jpg',
                'doc': 'assets/images/common/doc.jpg',
                'docx': 'assets/images/common/doc.jpg',
                'xls': 'assets/images/common/xls.jpg',
                'xlsx': 'assets/images/common/xls.jpg',
                'zip': 'assets/images/common/zip.jpg',
                'rar': 'assets/images/common/zip.jpg',
                'tgz': 'assets/images/common/zip.jpg',
                'mp3': 'assets/images/common/audio.jpg',
                'wav': 'assets/images/common/audio.jpg',
                'wma': 'assets/images/common/audio.jpg',
                'json': 'assets/images/common/json.jpg',
                'xml': 'assets/images/common/file.jpg'
            };

            if (extensionMap[extension]) {
                return extensionMap[extension];
            }

            // Fallback to media_type
            if (media_type) {
                switch (parseInt(media_type)) {
                    case 2: // Video
                        return 'assets/images/common/no_image_available_10.png';
                    case 3: // Audio
                        return 'assets/images/common/audio.jpg';
                    case 4: // File
                        return 'assets/images/common/file.jpg';
                }
            }

            return 'assets/images/common/no_image_available_10.png';
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function getInArray(key, array, value, field) {

            var result = '';
            angular.forEach(array, function (item, idx) {
                if (item[key] == value) {
                    result = $sce.trustAsHtml(item[field]);
                }
            });
            return result;
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInGroup(key, data) {
            var groupArray = [];

            angular.forEach(data, function (item, idx) {
                if (groupArray.indexOf(parseInt(item[key])) == -1) {
                    groupArray.push(parseInt(item[key]));
                }
            });
            return groupArray.sort();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param key
         * @param name
         * @param array
         */
        function toggleInGroup2(key, name, array) {
            var groupArray = [];
            angular.forEach(array, function (item, idx) {
                if (service.arrayObjectIndexOf(groupArray, parseInt(item[key]), key) == -1) {
                    groupArray.push(
                        {
                            key: parseInt(item[key]),
                            name: item[name]

                        });
                }
            });


            return groupArray;
            return groupArray.sort();
        }

        function deleteSearhNav() {

            $rootScope.global.searchnav = '';
            console.log($rootScope)
        }

        /**
         * Open Url in a new window
         *
         * @param url
         * @returns true
         */
        function openUrl(url) {
            if (url) {
                $window.open(url, '_blank');
            }
            return true;
        }

        /**
         * [hasEmptyArrays description]
         * @param  {[type]}  obj [description]
         * @return {Boolean}     [description]
         */
        function hasEmptyArrays(obj) {
            var emptyArrayMembers = _.filter(obj, function (member) {
                return _.isArray(member) && _.isEmpty(member)
            });

            return emptyArrayMembers.length > 0;
        }

        function timeAgo(momentTime) {
            var dateFormatted = moment.utc(momentTime).format();
            return moment.utc(dateFormatted).fromNow();
        }

        /**
         * formats date into valid api format 'yyyy-mm-dd'
         * @param  {object} date Date
         * @return {string}      'yyyy-mm-dd'
         */
        function formatDate(date) {
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) month = '0' + month;
            if (day.length < 2) day = '0' + day;

            return [year, month, day].join('-');
        }

        function formatDateToUnixTS(date, tz) {
            var formattedUtc = moment.tz(date, tz).utc();
            var formattedUnixTS = formattedUtc.unix();
            return formattedUnixTS;
        }


        /**
         * Removes objects from the array whose
         * 'property' value matches any of passed values
         *
         * @param  object-array array    e.g. [{color: "green"},{color: "red"},{color: "yellow"}]
         * @param  string|int   property e.g. "color"
         * @param  values-array values   e.g. ["green", "red"]
         * @return object-array          e.g. [{color: "yellow"}]
         */
        function removeObjectsFromArrayByProperty(array, property, values) {
            for (var i = array.length - 1; i >= 0; --i) {
                if (array[i].hasOwnProperty(property) &&
                    exists(array[i][property], values)) {
                    array.splice(i, 1);
                }
            }
            return array;
        }

        function translate(val) {
            return $translate.instant(val);
        }

        /**
         * Returns file type id
         * @param  {string} type, as given in file.type, eg. "video/mp4", "audio/mp3", "image/jpg", "application/pdf"
         * @return {int|false}    type id
         */
        function getFileTypeId(type) {
            if (type.startsWith("image")) {
                return 1;
            }
            else if (type.startsWith("video")) {
                return 2;
            }
            else if (type.startsWith("audio")) {
                return 3;
            }
            else if (type.startsWith("application")) {
                return 4;
            }
            else {
                return false;
            }
        }

        /**
         * Returns gallery type name
         * @param  {int} id Gallery type id
         * @return {string} Gallery type name
         */
        function getGalleryTypeById(id) {
            switch (id) {
                case 0:
                    return "All";
                    break;
                case 1:
                    return "Images";
                    break;
                case 2:
                    return "Videos";
                    break;
                case 3:
                    return "Audios";
                    break;
                case 4:
                    return "Docs";
                    break;
                default:
                    return "Unknown";
                    break;
            }
        }

        function showError(errorMsg) {
            $mdToast.show({
                template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg">' + errorMsg + '</div></md-toast>',
                hideDelay: 7000,
                position: 'top center',
                parent: '#content-container'
            });
        }

        function getGroupByIdNested(nestedGroups, id) {
            var found = null;
            for (var i = nestedGroups.length - 1; i >= 0; i--) {
                if (nestedGroups[i].id_group == id) {
                    return nestedGroups[i];
                } else {
                    if (nestedGroups[i].children) {
                        return getGroupByIdNested(nestedGroups[i].children, id)
                    }
                }
            };
            return found;
        }

        function capitalize(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }

        function exportToBrowser(exportData) {
            // Building the CSV from the Data two-dimensional array
            // Each column is separated by ";" and new line "\n" for next row
            var csvContent = '';
            exportData.forEach(function (infoArray, index) {
                var dataString = infoArray.join(';');
                csvContent += index < exportData.length ? dataString + '\n' : dataString;
            });

            // The download function takes a CSV string, the filename and mimeType as parameters
            // Scroll/look down at the bottom of this snippet to see how download is called
            var download = function (content, fileName, mimeType) {
                var a = document.createElement('a');
                mimeType = mimeType || 'application/octet-stream';

                if (navigator.msSaveBlob) { // IE10
                    navigator.msSaveBlob(new Blob([content], {
                        type: mimeType
                    }), fileName);
                } else if (URL && 'download' in a) { //html5 A[download]
                    a.href = URL.createObjectURL(new Blob([content], {
                        type: mimeType
                    }));
                    a.setAttribute('download', fileName);
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                } else {
                    location.href = 'data:application/octet-stream,' + encodeURIComponent(content); // only this mime type is supported
                }
            }
            download(csvContent, 'dowload.csv', 'text/csv;encoding:utf-8');
        }

        /**
         * Prevent default
         *
         * @param e
         */
        function preventDefault(e) {
            e.preventDefault();
            e.stopPropagation();
        }

    }
}());

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject required services
        var $log = angular.injector(['ng']).get('$log'),
            $resource = angular.injector(['ngResource']).get('$resource');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Prepare the resource object
            var resourceObj = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };

            // Assign the resource
            api[key] = $resource(resourceObj.url, resourceObj.paramDefaults, resourceObj.actions, resourceObj.options);
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($q, $log)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    apiObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    apiObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.mediahub')
        .service('mediahubService', mediahubService);

    /** @ngInject */
    function mediahubService($resource, $rootScope, $log, $q, $http, COMMON) {

        var apiUrl = '';
        var currentTenant = 'demo1';
        var s3BaseUrl = '';
        var vertexUrl = '';
        var vertexAuthToken = '';
        var apiKey = '';
        var iconikUrl = ''; // Iconik proxy base — used to browse iconik galleries/media in the admin dialog
        var iconikGroupId = ''; // Audience whose Iconik API key the adapter should use for us

        // Common headers for every mediahub-lambda request.
        // x-api-key is only sent when configured (qiu_config.mediahub).
        function mhHeaders() {
            var h = { 'X-Tenant': currentTenant };
            if (apiKey) {
                h['x-api-key'] = apiKey;
            }
            return h;
        }

        // -----------------------------
        // Resources Setup
        // -----------------------------
        var resourceListMedia, resourceListGalleries, resourceMediaById,
            resourceGalleryById, resourceGalleryFeed, resourceMediaGalleries, resourceMediaUploadUrl,
            resourceMediaRegenerate, resourceGalleryVertexReindex;

        function initResources() {
            resourceListMedia = $resource(
                `${apiUrl}media`,
                {},
                {
                    get: { method: 'GET', headers: mhHeaders() },
                    save: { method: 'POST', headers: mhHeaders() }
                }
            );

            resourceListGalleries = $resource(
                `${apiUrl}galleries`,
                {},
                {
                    get: { method: 'GET', headers: mhHeaders() },
                    save: { method: 'POST', headers: mhHeaders() }
                }
            );

            resourceMediaById = $resource(
                `${apiUrl}media/:id`,
                { id: '@id' },
                {
                    get: { method: 'GET', headers: mhHeaders() },
                    update: { method: 'PUT', headers: mhHeaders() },
                    delete: { method: 'DELETE', headers: mhHeaders() }
                }
            );

            resourceGalleryById = $resource(
                `${apiUrl}galleries/:id`,
                { id: '@id' },
                {
                    get: { method: 'GET', headers: mhHeaders() },
                    update: { method: 'PUT', headers: mhHeaders() },
                    delete: { method: 'DELETE', headers: mhHeaders() }
                }
            );

            resourceGalleryFeed = $resource(
                `${apiUrl}feeds/gallery/:id`,
                { id: '@id' },
                {
                    regenerate: { method: 'POST', headers: mhHeaders() }
                }
            );

            resourceMediaGalleries = $resource(
                `${apiUrl}media/galleries`,
                {},
                {
                    save: { method: 'POST', headers: mhHeaders() }
                }
            );

            resourceMediaUploadUrl = $resource(
                `${apiUrl}media/upload-url`,
                {},
                {
                    save: { method: 'POST', headers: mhHeaders() }
                }
            );

            resourceMediaRegenerate = $resource(
                `${apiUrl}media/regenerate-formats`,
                {},
                {
                    save: { method: 'POST', headers: mhHeaders() }
                }
            );

            resourceGalleryVertexReindex = $resource(
                `${apiUrl}galleries/:id/vertex-reindex`,
                { id: '@id' },
                {
                    reindex: { method: 'POST', headers: mhHeaders() }
                }
            );
        }

        function setApiUrl(baseUrl, tenant, s3Base) {
            if (baseUrl) {
                apiUrl = baseUrl.endsWith('/') ? baseUrl : (baseUrl + '/');
            }
            if (tenant) {
                currentTenant = tenant;
            }
            if (s3Base) {
                s3BaseUrl = s3Base.endsWith('/') ? s3Base : (s3Base + '/');
            }
            if (baseUrl || tenant || s3Base) {
                initResources();
            }
        }

        function setApiKey(key) {
            apiKey = key || '';
            initResources();
        }

        function setVertexUrl(url) {
            vertexUrl = url;
            $log.debug('[mediahubService] Vertex URL set to:', vertexUrl);
        }

        function setVertexAuthToken(token) {
            vertexAuthToken = token;
            $log.debug('[mediahubService] Vertex Auth Token updated');
        }

        // Initialize with default
        initResources();

        // -----------------------------
        // Helpers
        // -----------------------------

        var paginationCursors = {};

        function parseFormatsAny(formats) {
            if (!formats) return [];
            if (angular.isArray(formats)) return formats;
            if (angular.isObject(formats)) {
                return Object.keys(formats).map(function (k) {
                    var v = formats[k] || {};
                    v.name = v.name || k;
                    return v;
                });
            }
            if (typeof formats === 'string') {
                try {
                    var obj = JSON.parse(formats);
                    return parseFormatsAny(obj);
                } catch (e) {
                    return [];
                }
            }
            return [];
        }

        function pickBestFormatUrl(item) {
            var list = parseFormatsAny(item && item.formats);
            if (!angular.isArray(list) || !list.length) return null;

            var found = list.find(function (f) { return f.format_id == 1001 || f.name == 'format_1001'; }) ||
                list.find(function (f) { return f.format_id == 1002 || f.name == 'format_1002'; }) ||
                list.find(function (f) { return f.format_id == 1003 || f.name == 'format_1003'; });

            if (found && found.url) return found.url;
            return list[0].url || null;
        }

        function mapMediaTypeToLegacy(v) {
            if (v === 1 || v === 2 || v === 3 || v === 4) return v;

            var s = (v || '').toString().toLowerCase();
            if (s === 'image' || s === 'photo' || s === 'picture') return 1;
            if (s === 'video') return 2;
            if (s === 'audio') return 3;
            if (s === 'file' || s === 'document') return 4;

            return 0;
        }

        function ensureArray(v) {
            if (Array.isArray(v)) return v;
            if (!v) return [];

            if (typeof v === 'string') {
                var s = v.trim();
                if (!s) return [];

                if (s[0] === '[' || s[0] === '{') {
                    try {
                        var parsed = JSON.parse(s);
                        return Array.isArray(parsed) ? parsed : [];
                    } catch (e) {
                    }
                }

                return s.split(',')
                    .map(function (x) { return (x || '').trim(); })
                    .filter(Boolean)
                    .map(function (name) { return { tag_name: name }; });
            }

            return [];
        }

        function ensureObject(v) {
            return (v && typeof v === 'object' && !Array.isArray(v)) ? v : {};
        }

        function buildS3Base(bucket) {
            return bucket ? ('https://' + bucket + '.s3.us-east-1.amazonaws.com/') : null;
        }

        function normalizeMediaItem(item) {
            if (!item) return item;

            item.id_media = item.id_media || item.id;
            item.filename = item.filename || item.fileName;
            item.isMediahub = true;

            var meta = item.metadata_processed || {};

            item.photographer = meta.photographer || item.photographer;
            item.credits = meta.credit || meta.copyrightNotice || item.credit || item.credits;
            item.owner = meta.owner || item.owner;
            item.caption = meta.caption || item.caption;

            item.city = meta.city || item.city;
            item.country = meta.country || item.country;
            item.uses = meta.uses || item.uses;
            item.rating = meta.rating || item.rating;

            item.geoLat = meta.geoLat || item.geoLat;
            item.geoLon = meta.geoLon || item.geoLon;

            if (!item.size && item.width && item.height) {
                item.size = item.width + ' x ' + item.height;
            }
            item.fileSizeKb = item.fileSizeKB || item.fileSizeKb;

            function buildDateObj(dateStr) {
                if (!dateStr) return { date: null, utcShow: '' };
                var d = new Date(dateStr);
                if (isNaN(d.getTime())) return { date: null, utcShow: '' };
                return { date: d, utcShow: d.toISOString() };
            }

            item.dateUploaded = buildDateObj(item.dateUploaded || item.date_uploaded);
            item.date_uploaded = item.dateUploaded;

            item.fileDate = buildDateObj(item.fileDate || item.file_date);
            item.file_date = item.fileDate;

            var rawType = item.mediaType || item.media_type;
            item.mediaType = mapMediaTypeToLegacy(rawType);
            item.media_type = item.mediaType;

            var rawTags = meta.keywords || item.tags;
            item.tags = ensureArray(rawTags);

            if (item.tags && item.tags.length > 0 && typeof item.tags[0] === 'string') {
                item.tags = item.tags.map(function (t) {
                    return { tag_name: t };
                });
            }

            item.tagsWithTypes = ensureObject(item.tagsWithTypes);

            var s3Base = s3BaseUrl || buildS3Base(item.bucket);
            var containerViewUrl = s3Base || ('https://mediahub-' + currentTenant + '.s3.us-east-1.amazonaws.com/');

            item.imageUrlOriginal = item.imageUrlOriginal ||
                (s3Base && item.key ? (s3Base + item.key) : null) ||
                (item.imageUrl && typeof item.imageUrl === 'string' && item.imageUrl.startsWith('http') ? item.imageUrl : null) ||
                (item.s3KeyOriginal ? containerViewUrl + item.s3KeyOriginal : null);

            var formatsList = parseFormatsAny(item.formats);

            item.cropstatus = [];

            formatsList.forEach(function (f) {
                if (f && f.url) {
                    var idCrop = f.format_id;
                    if (!idCrop && f.name && f.name.startsWith('format_')) {
                        idCrop = parseInt(f.name.replace('format_', ''));
                    }

                    if (idCrop) {
                        addCrop(item, containerViewUrl, idCrop, f.url);
                    }
                }
            });

            item.cropstatus.sort(function (a, b) {
                return (a.id_cropformats || 0) - (b.id_cropformats || 0);
            });

            if (!item.cropstatus.length) {
                var relFallback = (item.media && item.media.thumb) || null;
                if (relFallback) {
                    addCrop(item, containerViewUrl, 1001, relFallback);
                }
            }

            var thumbUrl;
            if (item.mediaType == 2) {
                // Videos: use thumbnailUrl (jpg) as display image; imageUrl (mp4) is already captured as imageUrlOriginal
                thumbUrl = item.thumbnailUrl || null;
            } else {
                thumbUrl = pickBestFormatUrl(item) || item.thumbnailUrl;
            }

            if (thumbUrl) {
                if (!thumbUrl.startsWith('http')) {
                    thumbUrl = buildCdnUrl(containerViewUrl, thumbUrl);
                }
                item.imageUrl = thumbUrl;
            } else if (item.imageUrlOriginal) {
                item.imageUrl = item.imageUrlOriginal;
            } else if (item.imageUrl && typeof item.imageUrl === 'string') {
                if (!item.imageUrl.startsWith('http')) {
                    item.imageUrl = buildCdnUrl(containerViewUrl, item.imageUrl);
                }
            }

            if (item.allCropped === undefined || item.allCropped === null) {
                item.allCropped = 1;
            }
            return item;
        }

        function normalizeVertexSearchItem(item) {
            if (!item) return null;
            var title = item.title || item.caption || ('Media #' + item.id);
            var filename = item.file_name || item.title || title;
            var url = item.image_url || '';
            var thumb = item.thumbnail_url || url;

            var mTypeRaw = parseInt(item.media_type || 1);
            var mType = 'image';
            if (mTypeRaw === 2) {
                mType = 'video';
            } else if (mTypeRaw === 3) {
                mType = 'audio';
            } else if (mTypeRaw === 4) {
                mType = 'file';
            }

            return {
                id_media: item.id,
                id: item.id,
                title: title,
                caption: item.caption || '',
                date_uploaded: { date: new Date(item.available_time), utcShow: item.available_time },
                mediaType: mTypeRaw,
                media_type: mTypeRaw,
                media_type_name: mType,
                filename: filename,
                photographer: item.photographer || '',
                tags: (item.tags || []).map(function (t) { return { tag_name: t }; }),
                thumbnailUrl: thumb,
                imageUrl: url,
                imageUrlOriginal: item.preview_url || url,
                isMediahub: true,
                allCropped: (item.allCropped !== undefined) ? item.allCropped : 1,
                source: 'vertex',
                galleries: item.galleries || []
            };
        }

        function buildCdnUrl(origin, relOrKey) {
            if (!relOrKey) return null;
            var rel = relOrKey.toString();
            if (rel.startsWith('/')) rel = rel.slice(1);
            var url = origin.replace(/\/$/, '') + '/' + rel;
            return url.replace('/images/mediacentre/images/', '/mediacentre/images/');
        }

        function ensureTrailingSlash(u) {
            u = (u || '').toString();
            return u.endsWith('/') ? u : (u + '/');
        }

        function stripPrefix(path, prefix) {
            path = (path || '').toString();
            prefix = (prefix || '').toString();

            if (path.startsWith('/')) path = path.slice(1);
            if (prefix.startsWith('/')) prefix = prefix.slice(1);

            return path.startsWith(prefix) ? path.slice(prefix.length) : path;
        }

        function addCrop(item, containerViewUrl, idCrop, relUrl) {
            if (!relUrl) return;

            var rel = relUrl.toString();
            if (rel.startsWith('/')) rel = rel.slice(1);

            var fileName = rel;

            item.cropstatus.push({
                id_cropformats: idCrop,
                id_container: 2,
                isCropped: true,
                container: { view_url: ensureTrailingSlash(containerViewUrl) },
                fileName: fileName,
                urlImage: (relUrl.startsWith('http') ? relUrl : (ensureTrailingSlash(containerViewUrl) + fileName)).replace('/images/mediacentre/images/', '/mediacentre/images/')
            });
        }

        function normalizeMediaResponse(resp) {
            if (resp && resp.data && angular.isArray(resp.data)) {
                resp.data = resp.data.map(normalizeMediaItem);
            } else if (angular.isArray(resp)) {
                resp = resp.map(normalizeMediaItem);
            }
            return resp;
        }

        function normalizeGallery(item) {
            if (!item) return item;
            item.id_gallery = item.id_gallery || item.id;
            if (item.cover) {
                normalizeMediaItem(item.cover);
            }
            return item;
        }

        function listMediaWithOptions(options) {
            options = options || {};
            var params = {
                page: options.page || 1,
                resultsPerPage: options.resultsPerPage || options.perPage || 50,
                search: options.searchStringFilter || null
            };
            if (options.galleryId) {
                params.galleryId = options.galleryId;
            }
            if (options.sortField) {
                params.sortField = options.sortField;
            }
            if (options.sortDir) {
                params.sortDir = options.sortDir;
            }
            if (options.mediaType) {
                params.mediaType = options.mediaType;
            }

            if (params.page === 1) {
                paginationCursors = {};
            } else if (paginationCursors[params.page]) {
                params.cursor = paginationCursors[params.page];
            }

            return resourceListMedia.get(params).$promise;
        }

        function adaptToLegacyPagination(apiResp, options) {
            options = options || {};

            var list = (apiResp && angular.isArray(apiResp.data)) ? apiResp.data : [];
            var p = (apiResp && apiResp.pagination) ? apiResp.pagination : {};

            var total = Number(p.totalItems || p.total || apiResp.total || list.length || 0);
            var perPage = Number(p.resultsPerPage || options.resultsPerPage || p.limit || apiResp.per_page || 50);
            var page = Number(p.page || options.page || apiResp.current_page || 1);
            var lastPage = Number(p.totalPages || apiResp.last_page || Math.max(1, Math.ceil(total / perPage)));
            var totalPages = Number(p.totalPages);

            var from = total === 0 ? 0 : ((page - 1) * perPage + 1);
            var to = total === 0 ? 0 : Math.min(page * perPage, total);

            if (p.nextCursor || apiResp.nextCursor) {
                paginationCursors[page + 1] = p.nextCursor || apiResp.nextCursor;
            }

            return {
                data: list,
                total: total,
                from: from,
                to: to,
                current_page: page,
                last_page: lastPage,
                total_pages: totalPages,

                result: {
                    data: list,
                    total: total,
                    from: from,
                    to: to,
                    current_page: page,
                    last_page: lastPage,
                    total_pages: totalPages
                }
            };
        }

        // -----------------------------
        // Public API (legacy compatible)
        // -----------------------------

        function get(options) {
            options = options || {};
            $log.debug('[mediahubService] get options:', options);

            // Vertex Search Routing
            if (vertexUrl && options.searchStringFilter) {
                $log.debug('[mediahubService] Routing to Vertex POST API:', vertexUrl);

                var payload = {
                    query: options.searchStringFilter || "",
                    pageSize: options.resultsPerPage || options.perPage || 20
                };

                if (options.nextPageToken) {
                    payload.nextPageToken = options.nextPageToken;
                }

                var headers = {};
                if (vertexAuthToken) {
                    headers['X-Auth-Token'] = vertexAuthToken;
                }

                $log.debug('[mediahubService] Vertex Request Headers:', Object.keys(headers));

                // Use native XHR to bypass AngularJS interceptors (CORS issues with qiu- headers)
                return performXhr('POST', vertexUrl, JSON.stringify(payload), headers).then(function (apiResp) {
                    var results = (apiResp.results || []).map(normalizeVertexSearchItem);

                    // Adapt to legacy pagination format
                    var total = apiResp.totalSize || results.length;
                    var page = options.page || 1;
                    var perPage = payload.pageSize;
                    var lastPage = Math.ceil(total / perPage);
                    var from = (page - 1) * perPage + 1;
                    var to = Math.min(page * perPage, total);

                    return {
                        data: results,
                        total: total,
                        from: from,
                        to: to,
                        current_page: page,
                        last_page: lastPage,
                        total_pages: lastPage,
                        nextPageToken: apiResp.nextPageToken || null,
                        result: {
                            data: results,
                            total: total,
                            from: from,
                            to: to,
                            current_page: page,
                            last_page: lastPage,
                            total_pages: lastPage
                        }
                    };
                }).catch(function (err) {
                    $log.error('[mediahubService] Vertex Search Error:', err);
                    return $q.reject(err);
                });
            }

            // Fallback for explicit URL override (if still used)
            if (options.url && options.url !== 'http://' && options.url !== vertexUrl) {
                var baseUrl = options.url.endsWith('/') ? options.url : (options.url + '/');
                var resourceVertex = $resource(
                    `${baseUrl}media`,
                    {},
                    {
                        get: { method: 'GET', headers: mhHeaders() }
                    }
                );

                var vertexParams = {
                    page: options.page || 1,
                    resultsPerPage: options.resultsPerPage || options.perPage || 50,
                    search: options.searchStringFilter || null,
                    sortField: options.sortField || 'date_uploaded',
                    sortDir: options.sortDir || 'DESC'
                };

                return resourceVertex.get(vertexParams).$promise
                    .then(normalizeMediaResponse)
                    .then(function (resp) {
                        return adaptToLegacyPagination(resp, options);
                    });
            }

            // Use /api/media?galleryId=... instead of /api/feeds/gallery/:id
            if (angular.isArray(options.galleryIds) && options.galleryIds.length) {
                var gid = options.galleryIds[0];

                var params = {
                    galleryId: gid,
                    page: options.page || 1,
                    resultsPerPage: options.resultsPerPage || options.perPage || 50,
                    search: options.searchStringFilter || null
                };
                if (options.sortField) {
                    params.sortField = options.sortField;
                }
                if (options.sortDir) {
                    params.sortDir = options.sortDir;
                }
                if (options.mediaType) {
                    params.mediaType = options.mediaType;
                }

                if (params.page === 1) {
                    paginationCursors = {};
                } else if (paginationCursors[params.page]) {
                    params.cursor = paginationCursors[params.page];
                }

                return resourceListMedia.get(params).$promise
                    .then(function (resp) {
                        // Dynamic gallery on a Vertex tenant: the API handed back the filter
                        // instead of photos. Resolve it against Vertex (see queryDynamicGalleryInVertex).
                        if (resp && resp.data && !angular.isArray(resp.data) && resp.data.dynamic === true) {
                            return queryDynamicGalleryInVertex(resp.data, options, gid);
                        }
                        return adaptToLegacyPagination(normalizeMediaResponse(resp), options);
                    });
            }

            // Reset cursors on first page or search change
            if (options.page === 1) {
                paginationCursors = {};
            } else if (paginationCursors[options.page]) {
                options.cursor = paginationCursors[options.page];
            }

            // Default: /api/media
            return listMediaWithOptions(options)
                .then(normalizeMediaResponse)
                .then(function (resp) {
                    return adaptToLegacyPagination(resp, options);
                });
        }

        // ---------------------------------------------------------------------------------------
        // Dynamic galleries on Vertex tenants (API task-177)
        //
        // On a tenant indexed in Vertex, `GET /media?galleryId=` does NOT return the photos of a
        // dynamic gallery: it returns `{ dynamic: true, filters, defaultSort }` and leaves the
        // search to the client. This resolves that search against the Vertex endpoint the admin
        // already uses for text search, and answers in the same legacy page shape as a static
        // gallery, so the pagination directive never has to know.
        //
        // What the Vertex index CAN apply (vertex-ai-search: aws/index-function, structData):
        //   tags      `tags: ANY(...)` — the indexer lowercases every tag, so values are lowercased
        //   words     the same free-text path as the search box
        //   mediaType `media_type = N`
        // What it CANNOT: the index has no `file_date` and no `rating` field, so `from`, `to` and
        // `minRating` are not applied. They are reported back in `dynamic.unsupportedFilters` rather
        // than dropped silently — and a filter left with nothing Vertex can apply returns an EMPTY
        // page, never the whole tenant.
        //
        // Order: Vertex only orders by `created_at` ("date" / "date_asc") or by relevance.
        // ---------------------------------------------------------------------------------------

        // Vertex paginates with opaque tokens, the directive with page numbers. Tokens are kept per
        // gallery: key `<galleryId>|<page>` holds the token that fetches that page.
        var vertexDynamicTokens = {};

        /** A value quoted for a Vertex filter expression. */
        function vertexQuote(value) {
            return '"' + String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"';
        }

        /**
         * Translates a dynamic gallery's filters into a Vertex search request.
         * @returns {{ filter: string, query: string, unsupported: string[], canQuery: boolean }}
         */
        function buildVertexDynamicSearch(filters, mediaType) {
            filters = filters || {};
            var clauses = [];
            var unsupported = ['from', 'to', 'minRating'].filter(function (key) {
                return filters[key] !== undefined && filters[key] !== null && filters[key] !== '';
            });

            var tags = (angular.isArray(filters.tags) ? filters.tags : [])
                .map(function (t) { return String(t || '').trim().toLowerCase(); })
                .filter(Boolean);
            if (tags.length) {
                if (filters.tagsMode === 'all') {
                    // ANY() is an OR, so "every tag" is one ANY per tag joined with AND.
                    tags.forEach(function (t) { clauses.push('tags: ANY(' + vertexQuote(t) + ')'); });
                } else {
                    clauses.push('tags: ANY(' + tags.map(vertexQuote).join(', ') + ')');
                }
            }

            var words = (angular.isArray(filters.words) ? filters.words : [])
                .map(function (w) { return String(w || '').trim(); })
                .filter(Boolean);

            // Only the constraints that come from the gallery count towards "can query": the media
            // type is a view filter, and on its own it would list every photo of that type.
            var canQuery = tags.length > 0 || words.length > 0;

            if (mediaType) {
                clauses.push('media_type = ' + Number(mediaType));
            }

            return {
                filter: clauses.join(' AND '),
                query: words.join(' '),
                unsupported: unsupported,
                canQuery: canQuery
            };
        }

        /**
         * The Vertex sort for this listing. The admin always sends an explicit sort (seeded from the
         * gallery's `defaultSort` when the gallery is opened), so that wins; the gallery's own token
         * is the fallback. Anything that is not a date has no Vertex equivalent → newest first.
         */
        function vertexSortFor(options, defaultSort) {
            var field = options.sortField;
            var dir = options.sortDir;
            if (!field && defaultSort) {
                var m = /^(.+)_(asc|desc)$/.exec(defaultSort);
                if (m) { field = m[1]; dir = m[2]; }
            }
            var isDate = ['fileDate', 'dateUploaded', 'file_date', 'date_uploaded'].indexOf(field) !== -1;
            if (isDate && String(dir || '').toUpperCase() === 'ASC') {
                return 'date_asc';
            }
            return 'date';
        }

        /** A legacy page (the shape `adaptToLegacyPagination` produces) for a dynamic gallery. */
        function dynamicLegacyPage(items, total, page, perPage, dynamicInfo) {
            var lastPage = Math.max(1, Math.ceil(total / perPage));
            var from = total === 0 ? 0 : ((page - 1) * perPage + 1);
            var to = total === 0 ? 0 : Math.min(page * perPage, total);
            var result = {
                data: items, total: total, from: from, to: to,
                current_page: page, last_page: lastPage, total_pages: lastPage
            };
            return angular.extend({ result: angular.copy(result), dynamic: dynamicInfo }, result);
        }

        function postVertex(body) {
            var headers = {};
            if (vertexAuthToken) {
                headers['X-Auth-Token'] = vertexAuthToken;
            }
            return performXhr('POST', vertexUrl, JSON.stringify(body), headers).catch(function (err) {
                // Some datastores do not expose created_at as sortable and answer 400 to any
                // orderBy (same fallback the search box uses): retry once by relevance.
                var text = (err && (typeof err.data === 'string' ? err.data : JSON.stringify(err.data || ''))) || '';
                if (body.sort !== 'relevance' && /orderBy/i.test(text)) {
                    $log.warn('[mediahubService] Vertex orderBy unsupported; dynamic gallery retried by relevance');
                    return performXhr('POST', vertexUrl, JSON.stringify(angular.extend({}, body, { sort: 'relevance' })), headers);
                }
                return $q.reject(err);
            });
        }

        /**
         * How many media carry a tag, plus a few of them, from the Vertex index (~200-500 ms).
         * The tags table stores no usage counter and the mediahub API cannot filter media by
         * tag, so this is the only quick way. It counts what is INDEXED: media not yet in Vertex
         * are not counted. Resolves null on a tenant without Vertex.
         * @param {string} tagName
         * @param {number} [sample] media to return besides the count (default 6)
         * @returns {Promise<{ total: number, items: Array<{ id, title, thumbnailUrl }> }|null>}
         */
        function getTagUsageFromVertex(tagName, sample) {
            if (!vertexUrl || !tagName) {
                return $q.resolve(null);
            }
            var body = {
                query: '',
                // Tags are lowercased in the index (same as the dynamic galleries filter).
                filter: 'tags: ANY(' + vertexQuote(String(tagName).trim().toLowerCase()) + ')',
                pageSize: sample || 6,
                sort: 'date'
            };
            return postVertex(body).then(function (resp) {
                var results = (resp && resp.results) || [];
                return {
                    total: Number(resp && resp.totalSize) || results.length,
                    items: results.map(function (r) {
                        return {
                            id: r.id,
                            title: r.title || r.file_name || '',
                            thumbnailUrl: r.thumbnail_url || r.preview_url || r.image_url || ''
                        };
                    })
                };
            });
        }

        /**
         * Fetches page `page` of a dynamic gallery from Vertex.
         *
         * Vertex can only go forward from a token, so a page whose token is not known yet (jumping
         * from page 1 straight to page 4) is reached by walking from the highest page already seen.
         */
        function queryDynamicGalleryInVertex(dynamicData, options, galleryId) {
            var page = Number(options.page) || 1;
            var perPage = Number(options.resultsPerPage || options.perPage) || 50;
            var search = buildVertexDynamicSearch(dynamicData.filters, options.mediaType);
            var info = {
                source: 'vertex',
                filters: dynamicData.filters || {},
                unsupportedFilters: search.unsupported,
                blocked: false
            };

            if (search.unsupported.length) {
                $log.warn('[mediahubService] Dynamic gallery ' + galleryId + ': Vertex cannot apply ' +
                    search.unsupported.join(', ') + ' (no such field in the index)');
            }

            if (!vertexUrl || !search.canQuery) {
                // Without a Vertex endpoint, or with only filters Vertex cannot apply, the honest
                // answer is an empty page. Querying anyway would list the whole tenant.
                info.blocked = true;
                return $q.resolve(dynamicLegacyPage([], 0, page, perPage, info));
            }

            if (page === 1) {
                Object.keys(vertexDynamicTokens).forEach(function (k) {
                    if (k.indexOf(galleryId + '|') === 0) delete vertexDynamicTokens[k];
                });
            }

            var baseBody = {
                query: search.query,
                filter: search.filter,
                pageSize: perPage,
                sort: vertexSortFor(options, dynamicData.defaultSort)
            };

            function fetchPage(n) {
                var token = n > 1 ? vertexDynamicTokens[galleryId + '|' + n] : null;
                var body = token ? angular.extend({}, baseBody, { nextPageToken: token }) : baseBody;
                return postVertex(body).then(function (resp) {
                    if (resp && resp.nextPageToken) {
                        vertexDynamicTokens[galleryId + '|' + (n + 1)] = resp.nextPageToken;
                    }
                    return resp;
                });
            }

            function walkTo(target) {
                var known = 1;
                for (var n = target; n > 1; n--) {
                    if (vertexDynamicTokens[galleryId + '|' + n]) { known = n; break; }
                }
                if (known === target) return fetchPage(target);
                return fetchPage(known).then(function (resp) {
                    if (!resp || !resp.nextPageToken) return null; // fewer pages than asked for
                    return walkTo(target);
                });
            }

            return walkTo(page).then(function (resp) {
                var items = ((resp && resp.results) || []).map(normalizeVertexSearchItem).filter(Boolean);
                var total = Number(resp && resp.totalSize) || items.length;
                return dynamicLegacyPage(items, total, page, perPage, info);
            }).catch(function (err) {
                $log.error('[mediahubService] Dynamic gallery ' + galleryId + ': Vertex search failed', err);
                return $q.reject(err);
            });
        }

        function listMedia() {
            // Simple list (non paginated consumer)
            return resourceListMedia.get({ page: 1, resultsPerPage: 50 }).$promise.then(normalizeMediaResponse);
        }

        function listGalleries() {
            return resourceListGalleries.get(
                {
                    resultsPerPage: 1500
                }
            ).$promise.then(function (resp) {
                if (resp && resp.data && angular.isArray(resp.data)) {
                    resp.data.forEach(normalizeGallery);
                }
                return resp;
            });
        }

        function getById(id) {
            return resourceMediaById.get({ id: id }).$promise
                .then(function (resp) { return resp.data || resp; }) // Unwrap wrapper if present
                .then(normalizeMediaItem);
        }

        function createMedia(data) {
            return resourceListMedia.save(data).$promise
                .then(function (resp) { return resp.data || resp; })
                .then(normalizeMediaItem);
        }

        function updateMedia(id, data, mergeTags) {
            var params = { id: id };
            // Additive tag update: backend merges with existing tags instead of replacing.
            if (mergeTags) {
                params.mergeTags = true;
            }
            return resourceMediaById.update(params, data).$promise
                .then(function (resp) { return resp.data || resp; })
                .then(normalizeMediaItem);
        }

        function deleteMedia(id, galleryId) {
            var params = { id: id };
            if (galleryId) {
                params.galleryId = galleryId;
            }
            return resourceMediaById.delete(params).$promise;
        }

        function createGallery(data) {
            return resourceListGalleries.save(data).$promise;
        }

        function updateGallery(id, data) {
            return resourceGalleryById.update({ id: id }, data).$promise;
        }

        function deleteGallery(id) {
            return resourceGalleryById.delete({ id: id }).$promise;
        }

        function listMediaInGallery(galleryId, page, limit) {
            return resourceListMedia.get({
                galleryId: galleryId,
                page: page || 1,
                resultsPerPage: limit || 50
            }).$promise.then(normalizeMediaResponse);
        }

        function regenerateGalleryFeed(id) {
            return resourceGalleryFeed.regenerate({ id: id }).$promise;
        }

        function vertexReindexGallery(id) {
            return resourceGalleryVertexReindex.reindex({ id: id }).$promise;
        }

        function performXhr(method, url, data, headers) {
            var deferred = $q.defer();
            var xhr = new XMLHttpRequest();
            xhr.addEventListener("readystatechange", function () {
                if (this.readyState === 4) {
                    if (xhr.status >= 200 && xhr.status < 300) {
                        try {
                            var response = (typeof xhr.response === 'string') ? JSON.parse(xhr.responseText) : xhr.response;
                            if (typeof response === 'string' && xhr.responseText) {
                                response = JSON.parse(xhr.responseText);
                            }
                            deferred.resolve(response);
                        } catch (e) {
                            $log.error("[mediahubService] Error parsing response from " + url, e);
                            deferred.reject(e);
                        }
                    } else {
                        $log.error("[mediahubService] Request failed: " + url, xhr.status, xhr.responseText);
                        deferred.reject({ status: xhr.status, data: xhr.responseText });
                    }
                }
            });
            xhr.open(method, url);

            if (data && method === 'POST') {
                xhr.setRequestHeader("Content-Type", "application/json");
            }

            if (headers) {
                angular.forEach(headers, function (value, key) {
                    xhr.setRequestHeader(key, value);
                });
            }

            if (data) {
                xhr.send(data);
            } else {
                xhr.send();
            }
            return deferred.promise;
        }

        /**
         * Assign (copy/move) media items to galleries in a single batch call.
         * @param {number[]} mediaIds - Array of media IDs
         * @param {number[]} targetGalleryIds - Array of target gallery IDs
         * @param {string} operation - 'copy' or 'move'
         * @param {number} [sourceGalleryId] - Source gallery ID
         */
        function assignMediaToGalleries(mediaIds, targetGalleryIds, operation, sourceGalleryId) {
            var payload = {
                mediaIds: (mediaIds || []).map(function (id) { return parseInt(id, 10); }).filter(function (id) { return !isNaN(id); }),
                targetGalleryIds: (targetGalleryIds || []).map(function (id) { return parseInt(id, 10); }).filter(function (id) { return !isNaN(id); }),
                operation: operation || 'copy'
            };
            if (sourceGalleryId) {
                payload.sourceGalleryId = parseInt(sourceGalleryId, 10);
            }
            return resourceMediaGalleries.save(payload).$promise;
        }

        /**
         * Get a presigned S3 URL to upload a file directly.
         * Flow: POST /media/upload-url → PUT to S3 uploadUrl with file binary.
         * @param {string} fileName - Original file name
         * @param {string} [contentType] - MIME type (default: application/octet-stream)
         * @param {number[]} [galleryIds] - Array of gallery IDs to associate
         * @param {object} [mediaData] - Optional metadata (title, caption, tags)
         * @param {string} [folder] - Optional S3 folder prefix (e.g. "123-slug")
         * @param {string} [action] - Optional conflict resolution action ("duplicate" or "replace")
         * @param {number} [targetMediaId] - ID of the media to replace if action is "replace"
         */
        function getPresignedUploadUrl(fileName, contentType, galleryIds, mediaData, folder, action, targetMediaId) {
            var payload = {
                fileName: fileName,
                contentType: contentType || 'application/octet-stream',
                galleryIds: Array.isArray(galleryIds) ? galleryIds : (galleryIds ? [parseInt(galleryIds, 10)] : []),
                media: mediaData || {},
                duplicateAction: action || null,
                id_media: targetMediaId || null
            };
            return resourceMediaUploadUrl.save(payload).$promise;
        }

        /**
         * Regenerate formats for a list of media items.
         * @param {number[]} mediaIds - Array of media IDs
         * @param {number[]} formatIds - Array of format IDs
         * @param {boolean} reAnalyze - Whether to re-analyze the media
         */
        function regenerateMediaFormats(mediaIds, formatIds, reAnalyze) {
            var payload = {
                mediaIds: mediaIds,
                formatIds: formatIds,
                reAnalyze: !!reAnalyze
            };
            return resourceMediaRegenerate.save(payload).$promise;
        }

        function getGalleriesPermissions(domain) {
            return $http.get(COMMON.BASE_API + '/domain/' + domain + '/content/galleries_permissions')
                .then(function (response) {
                    return response.data;
                });
        }

        function saveGalleriesPermissions(domain, payload) {
            if (payload.id) {
                return $http.put(COMMON.BASE_API + '/domain/' + domain + '/content/galleries_permissions/' + payload.id, { item: payload })
                    .then(function (response) {
                        return response.data;
                    });
            } else {
                return $http.put(COMMON.BASE_API + '/domain/' + domain + '/content/galleries_permissions/new', { item: payload })
                    .then(function (response) {
                        return response.data;
                    });
            }
        }

        function deleteGalleriesPermissions(domain, id) {
            return $http.put(COMMON.BASE_API + '/domain/' + domain + '/content/galleries_permissions/action/delete', { ids: [id] })
                .then(function (response) {
                    return response.data;
                });
        }

        function batchDownload(body) {
            return $http.post(`${apiUrl}media/batch-download`, body, { headers: mhHeaders() }).then(function (response) {
                return response.data;
            });
        }

        function pollBatchJob(jobId) {
            return $http.get(`${apiUrl}media/batch-download/${jobId}`, { headers: mhHeaders() }).then(function (response) {
                return response.data;
            });
        }

        // -----------------------------
        // Iconik source (reuses the same lambda endpoints as the front widget)
        // -----------------------------
        // The Iconik adapter picks its API key from the caller's user group. qiusystem has no
        // signed token of its own yet, so it states the group in a header. Weak by design (see the
        // note in the adapter's index.js); swap for a signed token when qiu-api can issue one.
        function setIconikGroupId(groupId) {
            iconikGroupId = groupId ? String(groupId) : '';
        }

        function iconikHeaders() {
            return iconikGroupId ? { 'X-Group-Id': iconikGroupId } : {};
        }

        function setIconikUrl(url) {
            iconikUrl = url ? url.replace(/\/$/, '') : '';
        }

        function iconikAbsUrl(u) {
            if (!u) return '';
            if (/^https?:\/\//i.test(u)) return u;
            return iconikUrl + '/' + (u.charAt(0) === '/' ? u.slice(1) : u);
        }

        // Normalize an iconik lambda item to the shape the media dialog consumes.
        function normalizeIconikItem(item) {
            if (!item) return item;
            var thumb = (item.media && item.media.thumb) ? item.media.thumb : (item.thumbnail_url || item.thumbnailUrl || '');
            var view = (item.media && item.media.view) ? item.media.view : thumb;
            var mType = (item.mediaType === 'video' || item.media_type === 2 || item.object_type === 'video') ? 2 : 1;
            var name = item.title2 || item.title || item.description || ('Media ' + item.id);
            return {
                id_media: item.id,
                id: item.id,
                filename: name,
                title: item.title || item.title2 || name,
                media_type: mType,
                mediaType: mType,
                thumbnailUrl: iconikAbsUrl(thumb),
                imageUrl: iconikAbsUrl(view),
                imageUrlOriginal: iconikAbsUrl(view),
                tags: Array.isArray(item.tags) ? item.tags : [],
                isIconik: true,
                source: 'iconik'
            };
        }

        // Root iconik collections (feed.json), flattened to the gallery shape the dialog tree builds.
        function listGalleriesIconik() {
            if (!iconikUrl) return $q.resolve([]);
            return $http.get(iconikUrl + '/en/mediacentre/image-library/feed.json', { headers: iconikHeaders() }).then(function (res) {
                var galleries = (res.data && res.data.galleries) ? res.data.galleries : [];
                return galleries.map(function (g) {
                    return {
                        id_gallery: g.id,
                        id: g.id,
                        gallery_name: g.name || g.title || ('Gallery #' + g.id),
                        name: g.name || g.title || ('Gallery #' + g.id),
                        parentId: g.parent || null, // buildMediahubGalleryTree links children by parentId
                        media_count: g.total || 0,
                        cover_url: g.cover || '',
                        source: 'iconik'
                    };
                });
            });
        }

        // Media for a gallery (or free-text search when no gallery). Returns the same paginated
        // response shape as mediahubService.get(), so the dialog can route it identically.
        function getIconik(options) {
            options = options || {};
            var page = options.page || 1;
            var perPage = options.resultsPerPage || options.perPage || 50;
            var galleryId = (options.galleryIds && options.galleryIds.length) ? options.galleryIds[0] : (options.galleryId || null);

            var url;
            if (galleryId) {
                url = iconikUrl + '/en/mediacentre/image-library/gallery/' + galleryId + '?page=' + page + '&per_page=' + perPage;
            } else {
                var q = ['page=' + page, 'per_page=' + perPage];
                if (options.search) q.push('q=' + encodeURIComponent(options.search));
                url = iconikUrl + '/search?' + q.join('&');
            }

            return $http.get(url, { headers: iconikHeaders() }).then(function (res) {
                var d = res.data || {};
                var items = (d.items || []).map(normalizeIconikItem);
                var pag = d.pagination || {};
                return {
                    data: items,
                    total: pag.totalItems || pag.total || items.length,
                    current_page: pag.page || page,
                    last_page: pag.totalPages || 1,
                    from: (page - 1) * perPage + 1,
                    to: (page - 1) * perPage + items.length,
                    nextPageToken: pag.nextCursor || pag.cursor || null
                };
            });
        }

        return {
            get: get,
            listMedia: listMedia,
            listGalleries: listGalleries,
            createGallery: createGallery,
            updateGallery: updateGallery,
            deleteGallery: deleteGallery,
            listMediaInGallery: listMediaInGallery,
            getById: getById,
            createMedia: createMedia,
            updateMedia: updateMedia,
            deleteMedia: deleteMedia,
            regenerateGalleryFeed: regenerateGalleryFeed,
            vertexReindexGallery: vertexReindexGallery,
            regenerateMediaFormats: regenerateMediaFormats,
            assignMediaToGalleries: assignMediaToGalleries,
            getPresignedUploadUrl: getPresignedUploadUrl,
            getGalleriesPermissions: getGalleriesPermissions,
            saveGalleriesPermissions: saveGalleriesPermissions,
            deleteGalleriesPermissions: deleteGalleriesPermissions,
            batchDownload: batchDownload,
            pollBatchJob: pollBatchJob,
            setApiUrl: setApiUrl,
            setApiKey: setApiKey,
            setVertexUrl: setVertexUrl,
            getTagUsageFromVertex: getTagUsageFromVertex,
            setVertexAuthToken: setVertexAuthToken,
            setIconikUrl: setIconikUrl,
            setIconikGroupId: setIconikGroupId,
            iconikHeaders: iconikHeaders,
            mhHeaders: mhHeaders,
            listGalleriesIconik: listGalleriesIconik,
            getIconik: getIconik,
            getApiUrl: function () { return apiUrl; },
            getIconikUrl: function () { return iconikUrl; },
            getCurrentTenant: function () { return currentTenant; }
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('app.media')
        .service("mediaService", mediaService);

    /** @ngInject */
    // I provide access to the session store.
    function mediaService($q, $resource, userService, settingsDomainService, settingUserService, sessionService, COMMON, $window, $stateParams, $rootScope, $interval,
        requestContext) {


        var reference_sections = [];
        var uncroppedMediaIds = [];
        var checkUncroppedMediaInterval = null;


        function get(options) {
            // options.allCropped = 1;
            // if(!options.filters){
            //     options.filters = {};
            // }
            // if(!options.filters.allCropped){
            //     options.filters.allCropped = {
            //         field: 'allCropped',
            //         name: 'allCropped',
            //         selected: [1]
            //     };
            // }
            if (options.galleryIds === undefined) {
                return getMedia(options);
            } else {
                return getMediaInGalleries(options);
            }
        }

        function getMedia(options) {
            var deferred = $q.defer();
            var filters = [];
            var media_type = [];

            _.forEach(options, function (value, key, list) {
                if (_.isObject(list[key])) {
                    _.forEach(list[key], function (filter, keyFilter, listFilter) {
                        if (filter && !_.isEmpty(filter.selected)) {
                            filters.push({
                                field: filter.field,
                                name: filter.name,
                                values: filter.selected
                            });
                        }
                    });
                }
            });
            var settingsSection = 'media-' + $stateParams.mediaType;

            // Fix 2021/06/09 (to be removed again in near future):
            // Update 'sortField' setting to default value if value is 'sort', since 'sort' field is only available in media-in-gallery query.
            // Media-in-gallery now has its own setting 'sortFieldInGallery'.
            var sortField = settingUserService.getSettingValue(settingsSection, 'sortField', 'date_uploaded');
            if (sortField == 'sort') settingUserService.setSetting(settingsSection, 'sortField', 'date_uploaded');
            
            var opts = {
                domain: options.siteID,
                name: options.section,
                page: options.page,
                search: options.searchStringFilter,
                searchPlusTags: options.searchPlusTags,
                resultsPerPage: settingUserService.getSettingValue(settingsSection, 'pageSize', options.resultsPerPage),
                sort: options.sort,
                sortField: settingUserService.getSettingValue(settingsSection, 'sortField', options.sortField),
                sortDir: settingUserService.getSettingValue(settingsSection, 'sortDir', options.sortDir),
                extra: options.extra,
                withShortPreview: true,
                withCropStatusVideos: true,
                withCropStatus: true,
                withGalleries: true,
                withTags: true,
                withMediaChildren: options.withMediaChildren,
                id_media: options.idMedia,
                withChildren: options.idMedia ? true : false,
                withParentMedia: options.idMedia ? true : false,
                withFilters: JSON.stringify(filters),
                isUncropped: options.isUncropped
                // lang: get("language")
            };
            
            if (!options.media_type || options.media_type == 0) {

            } else if (angular.isArray(options.media_type)) {
                opts.media_type = JSON.stringify(options.media_type);
            } else {
                opts.media_type = options.media_type;
            }

            // Send invalid media_type 9999 to prevent from showing Lightbox media, since no lightbox gallery is selected.
            if (options.isLightbox === true) {
                opts.media_type = 9999;
                opts.is_lightbox = true;
            }

            if (options.hasOwnProperty('idTagsAnd')) {
                opts['id_tag_and[]'] = options.idTagsAnd;
            }

            if (options.hasOwnProperty('idTagAndOr')) {
                opts['id_tag_and_or[]'] = options.idTagAndOr;
            }

            if (options.hasOwnProperty('idTagTypesAndOr')) {
                opts['id_tag_type_and_or[]'] = options.idTagTypesAndOr;
            }

            if (options.hasOwnProperty('idTagTypesAndNot')) {
                opts['id_tag_type_and_not[]'] = options.idTagTypesAndNot;
            }

            if (options.hasOwnProperty('withAiRecognition')) {
                opts['withAiRecognition'] = options.withAiRecognition;
            }

            resourceMedia.get(opts,
                function (response) {
                    if (response.total == 1) {

                    }
                    response.data = mapUniqueText(response.data);

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);
                    // response.data = response.data.map(x => {
                    //     if (x.cropstatus_videos && x.cropstatus_videos.length > 0){
                    //         x.cropstatus = x.cropstatus_videos;
                    //     }
                    //     return x;
                    // })
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function getFaces(options) {
            var deferred = $q.defer();
            var filters = [];
            var media_type = [];

            _.forEach(options, function (value, key, list) {
                if (_.isObject(list[key])) {
                    _.forEach(list[key], function (filter, keyFilter, listFilter) {
                        if (!_.isEmpty(filter.selected)) {
                            filters.push({
                                field: filter.field,
                                name: filter.name,
                                values: filter.selected
                            });
                        }
                    });
                }
            });

            var opts = {
                domain: options.siteID,
                name: options.section,
                page: options.page,
                search: options.searchStringFilter,
                searchPlusTags: options.searchPlusTags,
                resultsPerPage: options.resultsPerPage,
                sort: options.sort,
                sortField: options.sortField,
                sortDir: options.sortDir,
                extra: options.extra,
                withCropStatus: true,
                withGalleries: true,
                withTags: true,
                withMediaChildren: options.withMediaChildren,
                id_media: options.idMedia,
                withFilters: JSON.stringify(filters),
                // lang: get("language")
            };

            if (!options.media_type || options.media_type == 0) {

            } else if (angular.isArray(options.media_type)) {
                opts.media_type = JSON.stringify(options.media_type);
            } else {
                opts.media_type = options.media_type;
            }


            resourceMedia.get(opts,
                function (response) {
                    if (response.total == 1) {

                    }
                    response.data = mapUniqueText(response.data);

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getTags(options) {
            var deferred = $q.defer();


            resourceTags.get({
                domain: options.site,
                name: options.section,
            },
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getMediaRef(options) {
            var deferred = $q.defer();
            resourceMediaRef.get({
                domain: options.site
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getFilters(options) {
            var deferred = $q.defer();


            resourceMediaFilters.get({
                domain: options.site,
            },
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getByID(options) {
            var deferred = $q.defer();

            resource_media.get({
                domain: options.site,
                id: options.id,
                // lang: get("language")
            },
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }


        function getContainerByID(options) {
            var deferred = $q.defer();

            resource_container_byID.get({
                domain: options.domain,
                id: options.id,
                // lang: get("language")
            },
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }


        function saveItem(options) {
            var deferred = $q.defer();


            resource_content_byID.update({
                domain: options.site,
                name: options.section,
                id: options.id,
                item: options.item
            },
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }


        function massDelete(options) {
            var deferred = $q.defer();

            resourceMediaMassDelete.delete({
                domain: options.site,
                'id_media[]': options.id_media,
                force: options.force ? 1 : 0
            },
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function saveMedia(options) {
            var deferred = $q.defer();

            resource_media.put({
                domain: options.site,
                id: options.id,
                // item: options.item
            }, JSON.stringify(options.item),
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function insertIntoGallery(options) {
            var deferred = $q.defer();

            resourceMedia_InsertIntoGallery.save({
                domain: options.site,
                // id: options.id,
                // item: options.item
            }, JSON.stringify(options.data),
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function massUpdate(options) {
            var deferred = $q.defer();

            resourceMediaMassUpdate.update({
                domain: options.site
            }, JSON.stringify(options.data),
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function RecropSingleFormat(options) {
            var deferred = $q.defer();

            resource_media_RecropSingleFormat.save({
                domain: options.site,
                // id: options.id,
                // item: options.item
            }, JSON.stringify(options.data),
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function RecropAllFormats(options) {
            var deferred = $q.defer();

            resource_media_RecropAllFormats.save({
                domain: options.site,
                // id: options.id,
                // item: options.item
            }, JSON.stringify(options.data),
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getMediaByID(options) {
            var deferred = $q.defer();

            resource_media.get({
                domain: options.site,
                id: options.id,
                // lang: get("language")
            },
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getImageByID(options) {
            var deferred = $q.defer();
            resourceMedia.get({
                domain: options.domain,
                id_media: options.id_media,
                withCropStatus: true,
                withCropStatusVideos: true,
                withContainer: true
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }
        function getImageOriginalByID(options) {
            var deferred = $q.defer();
            resourceMediaOriginal.get({
                domain: options.domain,
                'id_media[]': options.id_media
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function getMediaGalleries(options) {
            var deferred = $q.defer();

            var opts = {
                domain: options.domain,
                resultsPerPage: 250,
                sortField: options.sortField
                // withMediaFiles: true
                // lang: get("language")
            };
            if (options.gallery_type != 0) {
                opts.gallery_type = options.gallery_type;
            }

            resource_content_media_Galleries.get(opts,
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function loadRekognition(options) {
            var deferred = $q.defer();
            resourceLoadRekognition.post({
                domain: options.siteID,
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }
        function loadTranscription(options) {
            var deferred = $q.defer();
            resourceLoadTranscription.post({
                domain: options.siteID,
            }, options.item,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function getFacesRelated(options) {
            var deferred = $q.defer();
            resourceFacesById.post({
                domain: options.siteID,
                withAiRecognition: options.withAiRecognition,
                no_id_media: options.item.no_id_media
            }, options.item,
                function (response) {
                    response = mapUniqueText(response)
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);

        }
        function loadRelatedFacesInfo(options) {
            var deferred = $q.defer();
            resourceFacesRelated.post({
                domain: options.siteID,
            }, options.item,
                function (response) {
                    response = mapUniqueText(response)
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);

        }
        function mapUniqueText(data) {
            return data.map(x => {
                if (x.meta_analyses && x.meta_analyses.rekognition_detect_text) {
                    x.meta_analyses.rekognition_detect_text.TextDetectionsUnique = Array.from(new Set(x.meta_analyses.rekognition_detect_text.TextDetections.map(a => a.DetectedText)))
                        .map(DetectedText => {
                            return x.meta_analyses.rekognition_detect_text.TextDetections.find(a => a.DetectedText === DetectedText)
                        })
                }
                return x;
            })
        }
        function createMediaGallery(siteID, options) {
            var deferred = $q.defer();
            resourceGallery.post({
                domain: siteID,
            }, JSON.stringify(options),
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);

        }

        function editMediaGallery(siteID, galleryId, options) {
            var deferred = $q.defer();
            resourceGallery.update({
                domain: siteID,
                id: galleryId
            }, JSON.stringify(options),
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);

        }

        function deleteMediaGallery(siteID, galleryId) {
            var deferred = $q.defer();
            resourceGallery.delete({
                domain: siteID,
                id: galleryId
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);

        }

        function downloadMediaGalleryZip(siteID, galleryId, galleryName) {
            var deferred = $q.defer();
            resourceRequestZip.get({
                domain: siteID,
                'id_gallery[]': galleryId,
                title: galleryName
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }


        function removeFromGallery(siteID, options) {
            var deferred = $q.defer();
            resourceMedia_RemoveFromGallery.delete({
                domain: siteID,
                id_gallery: options.id_gallery,
                'id_media[]': options.id_media
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function getMediaInGalleries(options) {
            var deferred = $q.defer();

            var filters = [];
            //var media_type = [];
            _.forEach(options, function (value, key, list) {
                if (_.isObject(list[key])) {
                    _.forEach(list[key], function (filter, keyFilter, listFilter) {
                        if (filter.selected != null && !_.isEmpty(filter.selected)) {
                            filters.push({
                                field: filter.field,
                                name: filter.name,
                                values: filter.selected
                            });
                        }

                    });

                }
            });

            var settingsSection = 'media-' + $stateParams.mediaType;

            var opts = {
                domain: options.siteID,
                resultsPerPage: options.resultsPerPage,
                gallery_type: options.gallery_type,
                sortField: settingUserService.getSettingValue(settingsSection, 'sortFieldInGallery', options.sortField),
                sortDir: settingUserService.getSettingValue(settingsSection, 'sortDirInGallery', options.sortDir),
                withCropStatus: true,
                withContainer: true,
                page: options.page,
                'id_gallery[]': options.galleryIds,
                withFilters: JSON.stringify(filters),
                isUncropped: options.isUncropped
                // withMediaFiles: true
                // lang: get("language")
            }

            if (options.search) {
                opts['search'] = options.search;
            }
            if (options.searchStringFilter) {
                opts['search'] = options.searchStringFilter
            }

            resource_content_media_InGalleries.get(opts,
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function updateMediaInGallery(siteID, options) {
            var deferred = $q.defer();

            resource_content_media_InGallery.update({
                domain: siteID,
                items: options.items,
                fields: options.fields
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );
            // Return the promise.
            return (deferred.promise);
        }

        function updateSortGallery(siteID, options) {
            var deferred = $q.defer();

            resource_sort_gallery.update({
                domain: siteID,
                items: options.items,
                fields: options.fields
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    console.error("Database connection error")
                    deferred.reject();
                }
            );
            // Return the promise.
            return (deferred.promise);
        }


        function getNestedMediaGalleries(options) {
            var deferred = $q.defer();

            var opts = {
                domain: options.siteID,
            };
            if (options.gallery_type != 0) {
                opts['gallery_type[]'] = options.gallery_type;
            }
            if (options.withTotalMediaCount) {
                opts.withTotalMediaCount = true;
            }
            if (options.withCover) {
                opts.withCover = true;
            }

            if (options.sortField) {
                opts.sortField = options.sortField;
            }

            if (options.sortDir) {
                opts.sortDir = options.sortDir;
            }
            if (options.is_lightbox) {
                opts.is_lightbox = 1;
            } else {
                opts.is_lightbox = 0;
            }

            resourceMediaGalleriesNested.get(opts,
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);

        }

        function getMediaRelations(options) {
            var deferred = $q.defer();
            resource_media_relations.get({
                domain: options.siteID,
                'id_media[]': options.id_media,
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);

        }

        function triggerMediaByGalleries(galleryNode, includeSubgalleries) {
            var galleries = false;
            if (galleryNode) {
                var node = angular.fromJson(galleryNode);
                galleries = unnestGalleries(node, [], includeSubgalleries);
            }
            $rootScope.$broadcast('loadMediaByGalleries', galleries);
        }

        function triggerGalleryDialog(gallery) {
            $rootScope.$broadcast('openGalleryDialog', gallery);
        }

        function triggerReloadGalleries() {
            $rootScope.$broadcast('reloadGalleries');
        }

        function triggerSelectParentGallery(groupNode) {
            $rootScope.$broadcast('selectParentGallery', groupNode);
        }

        function triggerSetBasicFormDirty() {
            $rootScope.$broadcast('setBasicFormDirty');
        }

        function triggerCloseSidenav(sidenavId) {
            $rootScope.$broadcast('closeSidenav', sidenavId);
        }

        function unnestGalleries(node, galleries, includeSubgalleries) {
            galleries.push(node);
            if (includeSubgalleries && typeof node.children !== 'undefined' && node.children.length > 0) {
                angular.forEach(node.children, function (data) {
                    unnestGroups(data, galleries, includeSubgalleries);
                });
            }
            return galleries;
        }

        function addUncroppedMediaID(id) {
            if (uncroppedMediaIds.indexOf(id) < 0) {
                uncroppedMediaIds.push(id);
            }
            startUncroppedMediaInterval();
        }

        function startUncroppedMediaInterval() {
            if (checkUncroppedMediaInterval === null) {
                checkUncroppedMediaInterval = $interval(checkUncroppedMedia, 10000);
            }
        }

        function destroyUncroppedMediaInterval() {
            $interval.cancel(checkUncroppedMediaInterval);
            checkUncroppedMediaInterval = null;
        }

        // Stop the uncropped-media polling and clear the queue.
        // Used when a media dialog/editor closes so it doesn't keep polling forever.
        function stopUncroppedPolling() {
            uncroppedMediaIds = [];
            destroyUncroppedMediaInterval();
        }

        function checkUncroppedMedia() {
            resource_uncropped_media_ids.get({
                domain: requestContext.getParam("siteId"),
                'id_media[]': uncroppedMediaIds
            },
            function (response) {
                var uncroppedMediaIdsFromApi = response;
                for (var i = uncroppedMediaIds.length - 1; i >= 0; i--) {
                    if (uncroppedMediaIdsFromApi.indexOf(uncroppedMediaIds[i]) < 0) {
                        $rootScope.$broadcast('MEDIA::IS_ALL_CROPPED::ID::'+uncroppedMediaIds[i], {});
                        uncroppedMediaIds.splice(i, 1);
                    }
                }
                if (uncroppedMediaIds.length === 0) {
                    destroyUncroppedMediaInterval();
                }
            }, function (error) {
                destroyUncroppedMediaInterval();
            })
        }
        
        /**
         * downloadMediasZip
         *
         * @param {string} siteID    Domain name
         * @param {array}  mediaIds  List of media ids
         * @param {string} name      Used as zip prefix
         */
        function downloadMediasZip(options) {
            var deferred = $q.defer();
            resourceRequestZip.get({
                domain: options.domain,
                'id_media[]': options.mediaIds,
                title: options.title
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function getExistingMedia(options){
            var deferred = $q.defer();
            resourceExistingMedia.get({
                domain: options.domain,
                'fileNames[]': options.fileNames
            },
                function (response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e);
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function getDivisions(options){
            var deferred = $q.defer();
            resourceDivisions.get({
                domain:        options.domain,
                id_a:          options.id_a,
                id_b:          options.id_b,
                division_type: options.division_type
            },
                function(response) {
                    deferred.resolve(response);
                },
                function(e) {
                    console.error(e);
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function createNewDivision(options){
            var deferred = $q.defer();
            resourceDivisions.post({
                domain: options.domain
            }, options.item,
                function(response){
                    deferred.resolve(response);
                },
                function(e){
                    console.error(e);
                    deferred.reject();
                }
            );
            return (deferred.promise);
        }

        function updateDivision(options) {
            var deferred = $q.defer();
            resourceUpdateDivision.update({
                domain: options.domain,
                filters: JSON.stringify(options.filters)
            }, options.item,
                function(response) {
                    deferred.resolve(response);
                },
                function(e) {
                    console.log(e);
                    deferred.reject(e);
                }
            );
            return deferred.promise;
        }

        function duplicateGallery(options){
            var deferred = $q.defer();
            resourceDuplicateGallery.post({
                domain: options.domain,
                id_gallery: options.id_gallery
            }, options.item,
                function(response) {
                    deferred.resolve(response);
                },
                function(e) {
                    console.error(e);
                    deferred.reject(e);
                }
            );
            return deferred.promise;
        }

        var resourceDuplicateGallery = $resource(
            COMMON.BASE_API + "/domain/:domain/mediaGallery/:id_gallery/copy",{
                domain: '@domain',
                id_gallery: '@id_gallery'
            }, {
                'post': {
                    method: 'POST',
                    isArray: false
                }
            }
        );

        var resourceUpdateDivision = $resource(
            COMMON.BASE_API + "/domain/:domain/divisions/media_gallery_users_groups", {
                domain: '@domain'
            }, {
                'update': {
                    method: 'PUT'
                }
            }
        );

        var resourceDivisions = $resource(
            COMMON.BASE_API + "/domain/:domain/divisions", {

            }, {
                'get': {
                    method: 'GET',
                    isArray: true
                },
                'post': {
                    method: 'POST',
                    isArray: false
                }
            }
        )

        var resourceExistingMedia = $resource(
            COMMON.BASE_API + "/domain/:domain/media/existingMediaFromFileNames", {
                // No default data.
            }, {
                'get': {
                    method: "GET",
                    isArray: true
                }
            }
        )
        

        var resourceMedia = $resource(
            COMMON.BASE_API + "/domain/:domain/media", {
            // No default data.
        }, {
            'get': { method: "GET", isArray: false },
            'post': { method: "POST", isArray: false },
            'update': { method: "PUT" },
        }
        );
        var resourceMediaRef = $resource(
            COMMON.BASE_API + "/domain/:domain/mediaRef", {
            // No default data.
        }, {
            'get': { method: "GET", isArray: true }
        }
        );
        var resourceMediaOriginal = $resource(
            COMMON.BASE_API + "/domain/:domain/media/originalMedia", {
            // No default data.
        }, {
            'get': { method: "GET", isArray: true }
        }
        );

        var resourceMediaGalleriesNested = $resource(
            COMMON.BASE_API + "/domain/:domain/mediaGalleriesNested", {
            // No default data.
        }, {
            get: {
                method: "GET",
                isArray: false,
                transformResponse: function(data, headers){
                    var response = {}
                    response.data = JSON.parse(data);
                    response.qiuRestrictions = JSON.parse(headers('qiu-restrictions'));
                    return response;
                }
            }
        }
        );

        var resourceGallery = $resource(
            COMMON.BASE_API + "/domain/:domain/mediaGalleries/:id", {
            // No default data.
            //domain: '@domain',
            //id: '@id'
        }, {
            get: {
                method: "GET",
                isArray: false
            },
            post: {
                method: "POST"
            },
            update: {
                method: "PUT"
            },
            delete: {
                method: "DELETE",
                isArray: true
            }

        }
        );
        var resourceRequestZip = $resource(
            COMMON.BASE_API + "/domain/:domain/media/requestZip", {
            // No default data.
            //domain: '@domain',
            //id: '@id'
        }, {
            get: {
                method: "GET",
                isArray: false
            }
        }
        );
        var resourceLoadRekognition = $resource(
            COMMON.BASE_API + "/domain/:domain/media/recognize", {
            // No default data.
            //domain: '@domain',
            //id: '@id'
        }, {
            post: {
                method: "POST",
                isArray: true
            }

        }
        );
        var resourceLoadTranscription = $resource(
            COMMON.BASE_API + "/domain/:domain/media/transcribe", {
            // No default data.
            //domain: '@domain',
            //id: '@id'
        }, {
            post: {
                method: "POST",
                isArray: true
            }

        }
        );
        var resourceFacesById = $resource(
            COMMON.BASE_API + "/domain/:domain/ai/searchFaces", {
            // No default data.
            //domain: '@domain',
            //id: '@id'
        }, {
            post: {
                method: "POST",
                isArray: true
            }

        }
        );
        var resourceFacesRelated = $resource(
            COMMON.BASE_API + "/domain/:domain/media/faceId", {
            // No default data.
            //domain: '@domain',
            //id: '@id'
        }, {
            post: {
                method: "POST",
                isArray: true
            }

        }
        );


        var resourceMediaMassUpdate = $resource(
            COMMON.BASE_API + "/domain/:domain/media/massUpdate", {
            // No default data.
        }, {
            'update': { method: "PUT" },
        }
        );
        var resourceMediaMassDelete = $resource(
            COMMON.BASE_API + "/domain/:domain/media/massDelete", {
            // No default data.
        }, {
            'update': { method: "PUT" },
        }
        );

        var resourceMedia_InsertIntoGallery = $resource(
            COMMON.BASE_API + "/domain/:domain/media/gallery/insertIntoGallery", {
            // No default data.
        }, {
            get: {
                method: "GET",
                isArray: false
            }
        }
        );

        var resourceMedia_RemoveFromGallery = $resource(
            COMMON.BASE_API + "/domain/:domain/media/gallery/removeFromGallery", {
            // No default data.
        }, {
            delete: {
                method: "DELETE"
            }
        }
        );

        var resourceTags = $resource(
            COMMON.BASE_API + "/domain/:domain/content/:name/tags", {
            // No default data.
        }, {
            get: {
                method: "GET",
                // isArray: true
            }
        }
        );

        var resourceMediaFilters = $resource(
            COMMON.BASE_API + "/domain/:domain/media/options", {
            // No default data.
        }, {
            get: {
                method: "GET",
                // isArray: true
            }
        }
        );

        var resource_content_byID = $resource(
            COMMON.BASE_API + "/domain/:domain/content/:name/:id", {
            domain: '@domain',
            name: '@name',
            id: '@id',
        }, {
            get: {
                method: "GET",
            },
            update: {
                method: "PUT",
            },
        }
        );

        var resource_s3_presigned_url = $resource(
            COMMON.BASE_API + "/domain/:domain/media/upload/getS3UploadPreSignedUrl", {
            // No default data.
        }, {
            get: {
                method: "GET",
                isArray: false
            }
        }
        );
        var resource_s3_presigned_url_clip = $resource(
            COMMON.BASE_API + "/domain/:domain/media/clip/getS3UploadPreSignedUrl", {
            // No default data.
        }, {
            get: {
                method: "GET",
                isArray: false
            }
        }
        );

        var resource_finished_uploading_batch_to_cdn = $resource(
            COMMON.BASE_API + "/domain/:domain/media/upload/finishedUploadingBatchToCdn", {
                // No default data
            }, {
                post: {
                    method: "POST",
                    isArray: false
                }
            }
        )

        var resource_finished_uploading_file_to_cdn = $resource(
            COMMON.BASE_API + "/domain/:domain/media/upload/finishedUploadingFileToCdn", {
            // No default data.
        }, {
            get: {
                method: "GET",
                isArray: false
            },
            post: {
                method: "POST",
                isArray: false
            }
        }
        );
        var resource_finished_uploading_file_to_cdn_clip = $resource(
            COMMON.BASE_API + "/domain/:domain/media/clip/finishedUploadingFileToCdn", {
            // No default data.
        }, {
            get: {
                method: "GET",
                isArray: false
            },
            post: {
                method: "POST",
                isArray: false
            }
        }
        );

        var resource_import_from_url = $resource(
            COMMON.BASE_API + "/domain/:domain/media/importUrl", {
            domain: '@domain'
            // No default data.
        }, {
            post: {
                method: "POST",
                isArray: false
            }
        }
        );

        var resource_media = $resource(
            COMMON.BASE_API + "/domain/:domain/media/:id", {
            domain: '@domain',
            id: '@id'
            // No default data.
        }, {
            post: {
                method: "POST",
                isArray: false
            },
            put: {
                method: "PUT",
            }
        }
        );

        var resource_media_RecropSingleFormat = $resource(
            COMMON.BASE_API + "/domain/:domain/media/crop/singleFormat", {
            domain: '@domain',
            // No default data.
        }, {
            post: {
                method: "POST",
                isArray: false
            },
            put: {
                method: "PUT",
            }
        }
        );

        var resource_media_RecropAllFormats = $resource(
            COMMON.BASE_API + "/domain/:domain/media/crop/allFormats", {
            domain: '@domain',
            // No default data.
        }, {
            post: {
                method: "POST",
                isArray: false
            },
            put: {
                method: "PUT",
            }
        }
        );

        var resource_media_byID = $resource(
            COMMON.BASE_API + "/domain/:domain/media/:id", {
            domain: '@domain',
            id: '@id'
            // No default data.
        }, {
            post: {
                method: "POST",
                isArray: false
            },
            put: {
                method: "PUT",
            }
        }
        );


        var resource_content_media_Galleries = $resource(
            COMMON.BASE_API + "/domain/:domain/media/mediaGalleries", {
            // No default data.
        }, {
            get: {
                method: "GET",
                // isArray: true
            }
        }
        );

        var resource_media_relations = $resource(
            COMMON.BASE_API + "/domain/:domain/media/relations", {
            domain: '@domain'
            // No default data.
        }, {
            get: {
                method: "GET",
                // isArray: true
            }
        }
        );

        var resource_content_media_InGalleries = $resource(
            COMMON.BASE_API + "/domain/:domain/media/inGalleries", {
            // No default data.
        }, {
            get: {
                method: "GET",
                // isArray: true
            }
        }
        );

        var resource_content_media_InGallery = $resource(
            COMMON.BASE_API + "/domain/:domain/media/inGallery", {
            // No default data.
            domain: '@domain'
        }, {
            'update': { method: "PUT" }
        }
        );

        var resource_sort_gallery = $resource(
            COMMON.BASE_API + "/domain/:domain/mediaGalleries/update", {
            // No default data.
            domain: '@domain'
        }, {
            'update': { method: "PUT" }
        }
        );

        var resource_content_media_Image_ID = $resource(
            COMMON.BASE_API + "/domain/:domain/media", {
            // No default data.
        }, {
            get: {
                method: "GET",
                // isArray: true
            }
        }
        );

        var resource_content_media_byID = $resource(
            COMMON.BASE_API + "/domain/:domain/content/:name/:id/media", {
            // No default data.
        }, {
            get: {
                method: "GET",
                // isArray: true
            }
        }
        );

        var resource_cdn_status = $resource(
            COMMON.BASE_API + "/domain/:domain/container/cdn/status", {
            // No default data.
        }, {
            get: {
                method: "GET",
                // isArray: true
            }
        }
        );

        var resource_container_byID = $resource(
            COMMON.BASE_API + "/domain/:domain/media/container/:id", {
            // No default data.
        }, {
            get: {
                method: "GET",
                // isArray: true
            }
        }
        );

        var resource_uncropped_media_ids = $resource(
            COMMON.BASE_API + "/domain/:domain/media/getUncroppedMediaIds", {
            // No default data.
        }, {
            get: {
                method: "GET",
                isArray: true
            }
        }
        );

        var resource_all_uncropped_media_ids = $resource(
            COMMON.BASE_API + "/domain/:domain/media/getAllUncroppedMediaIds", {
            // No default data.
        }, {
            get: {
                method: "GET",
                isArray: true
            }
        }
        );

        var resource_crop_missing_formats_multiple = $resource(
            COMMON.BASE_API + "/domain/:domain/media/crop/missingFormatsMultiple", {
            // No default data.
        }, {
            post: {
                method: "POST",
                //isArray: true
            }
        }
        );


        function setSubsec(items) {
            angular.extend(reference_sections, items);
        }

        function getValuesReferencesSections(key) {

            return reference_sections[key];

        }


        function getS3UploadPreSignedUrl(options) {
            var deferred = $q.defer();

            resource_s3_presigned_url.get({
                domain: options.siteID,
                id_media: options.id_media,
                fileName: options.fileName,
                fileSizeKb: (angular.isDefined(options.fileSizeKb)) ? options.fileSizeKb : null
                // lang: get("language")
            },
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function getS3UploadPreSignedUrlClip(options) {
            var deferred = $q.defer();

            resource_s3_presigned_url_clip.get({
                domain: options.siteID,
                fileName: options.fileName,
                fileSizeKb: (angular.isDefined(options.fileSizeKb)) ? options.fileSizeKb : null
                // lang: get("language")
            },
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function finishedUploadingBatchToCdn(options) {
            var deferred = $q.defer();
            resource_finished_uploading_batch_to_cdn.post({
                domain: options.siteID
            },{ 
                id_medias: options.id_medias,
                fields: options.fields,
                tags: options.tags,
                id_galleries: options.id_galleries
            },
                function(response) {
                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );
            // Return the promise.
            return (deferred.promise);
        }

        function finishedUploadingFileToCdn(options) {
            var deferred = $q.defer();

            resource_finished_uploading_file_to_cdn.post({
                domain: options.siteID,
                id_media: options.idMedia,
                isReplace: options.isReplace || false
                // lang: get("language")
            },
                {},
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function finishedUploadingFileToCdnClip(options) {
            var deferred = $q.defer();

            resource_finished_uploading_file_to_cdn_clip.post({
                domain: options.siteID,
                fileName: options.filename,
                // lang: get("language")
            },
                {},
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error("ERROR =========================================!!!!!!")
                    console.error(e)
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }
        function importFromUrl(options) {
            var deferred = $q.defer();

            resource_import_from_url.post({
                domain: options.siteID,
                url: options.url,
                execute: options.execute
                // lang: get("language")
            },
                function (response) {

                    // angular.copy(response, modulecontent);
                    // setActiveDomain(domain);

                    deferred.resolve(response);
                },
                function (e) {
                    console.error(e)
                    deferred.reject();
                }
            );

            // Return the promise.
            return (deferred.promise);
        }

        function getReferencesSections(key, property, value) {
            switch (property) {
                case 'id_subsec':
                    var fieldReturn = 'subsec';
                    break;
                case 'id_cat':
                    var fieldReturn = 'cat';
                    break;
                default:
                    var fieldReturn = 'cat';
            }

            if (!angular.isUndefined(reference_sections[key])) {
                for (var i = 0, len = reference_sections[key].length; i < len; i++) {
                    if (reference_sections[key][i][property] === value) return reference_sections[key][i][fieldReturn];
                }
            }
            return "--";
        }

        function getAllUncroppedMediaIds() {
            var deferred = $q.defer();

            resource_all_uncropped_media_ids.get({
                domain: requestContext.getParam("siteId")
                },
                function (response) {
                    deferred.resolve(response);
                }, function (error) {
                    console.error(e)
                    deferred.reject();
                })
            // Return the promise.
            return (deferred.promise);
        }

        function cropMissingFormatsMultiple(options) {
            var deferred = $q.defer();

            resource_crop_missing_formats_multiple.post({
                    domain: requestContext.getParam("siteId")
                }, {
                    media: options.mediaIds
                },
                function (response) {
                    deferred.resolve(response);
                }, function (error) {
                    console.error(e)
                    deferred.reject();
                })
            // Return the promise.
            return (deferred.promise);
        }

        function getThumbSrcFromMedia(media) {
            if (media &&
                media.cropstatus &&
                angular.isArray(media.cropstatus) &&
                media.cropstatus.length > 0 &&
                media.cropstatus[0].fileName &&
                media.cropstatus[0].id_container
            ) {
                var container = sessionService.getContainerByID(media.cropstatus[0].id_container);
                if (container &&
                    container.view_url
                ){
                    
                    return container.view_url + media.cropstatus[0].fileName;
                }
            }
            if (media && (media.filename || media.fileName) && (media.filename || media.fileName).toLowerCase().endsWith('.svg')) {
                return 'assets/images/common/svg_placeholder.png';
            }
            return 'assets/images/common/no_image_available_10.png';
        }

        // Return the public API.
        return ({
            get: get,
            getByID: getByID,
            getMediaByID: getMediaByID,
            getImageByID: getImageByID,
            getImageOriginalByID: getImageOriginalByID,
            getTags: getTags,
            getFilters: getFilters,
            saveItem: saveItem,
            saveMedia: saveMedia,
            setSubsec: setSubsec,
            getReferencesSections: getReferencesSections,
            getValuesReferencesSections: getValuesReferencesSections,
            getS3UploadPreSignedUrl: getS3UploadPreSignedUrl,
            getS3UploadPreSignedUrlClip: getS3UploadPreSignedUrlClip,
            finishedUploadingFileToCdn: finishedUploadingFileToCdn,
            finishedUploadingFileToCdnClip: finishedUploadingFileToCdnClip,
            finishedUploadingBatchToCdn: finishedUploadingBatchToCdn,
            importFromUrl: importFromUrl,
            getContainerByID: getContainerByID,
            RecropSingleFormat: RecropSingleFormat,
            RecropAllFormats: RecropAllFormats,
            getMediaGalleries: getMediaGalleries,
            insertIntoGallery: insertIntoGallery,
            removeFromGallery: removeFromGallery,
            massUpdate: massUpdate,
            massDelete: massDelete,
            getNestedMediaGalleries: getNestedMediaGalleries,
            triggerMediaByGalleries: triggerMediaByGalleries,
            getMediaInGalleries: getMediaInGalleries,
            triggerGalleryDialog: triggerGalleryDialog,
            triggerSelectParentGallery: triggerSelectParentGallery,
            triggerReloadGalleries: triggerReloadGalleries,
            triggerSetBasicFormDirty: triggerSetBasicFormDirty,
            triggerCloseSidenav: triggerCloseSidenav,
            createMediaGallery: createMediaGallery,
            loadRelatedFacesInfo: loadRelatedFacesInfo,
            editMediaGallery: editMediaGallery,
            getFacesRelated: getFacesRelated,
            loadRekognition: loadRekognition,
            loadTranscription: loadTranscription,
            deleteMediaGallery: deleteMediaGallery,
            downloadMediaGalleryZip: downloadMediaGalleryZip,
            downloadMediasZip: downloadMediasZip,
            getExistingMedia: getExistingMedia,
            updateMediaInGallery: updateMediaInGallery,
            updateSortGallery: updateSortGallery,
            getMediaRelations: getMediaRelations,
            // filterables: filterables,
            addUncroppedMediaID: addUncroppedMediaID,
            stopUncroppedPolling: stopUncroppedPolling,
            getAllUncroppedMediaIds: getAllUncroppedMediaIds,
            cropMissingFormatsMultiple: cropMissingFormatsMultiple,
            getMediaRef: getMediaRef,
            getThumbSrcFromMedia: getThumbSrcFromMedia,
            getDivisions: getDivisions,
            createNewDivision: createNewDivision,
            updateDivision: updateDivision,
            duplicateGallery: duplicateGallery

        });


    }


})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .service("settingsDomainService", settingsDomainService);

    /** @ngInject */
    // I provide access to the session store.
    function settingsDomainService($q, $resource, userService, COMMON, $window) {


        function getSettingsDomain() {

            // Create our deferred results.
            var deferred = $q.defer();

            // Make the request to the server.
            resource.get({
                    // No data needs to be passed - cookies will take care of passing the authentication
                    // token that has been provided by the server.
                },
                function(response) {

                    // Store the account and subscription information.
                    // ng.extend(user, response.account);
                    // ng.extend(subscription, response.subscription);
                    // ng.extend(domains, response.domains);

                    // user.projectsUrl = response.projectsUrl;

                    // // Get the initials for use throughout the application (avatars).
                    // user.initials = userService.getInitials(user.name);

                    // // Determine whether or not the user is currently using a system avatar.
                    // user.hasSystemAvatar = userService.isSystemAvatar(user.avatarID);

                    // // Information about sync connections
                    // if (response && response.sync) {
                    //     user.isSyncEnabled = response.sync.enabled;
                    //     user.syncClients = response.sync.clients;
                    // }
                    // if (user.default_domain) {
                    //     user.domain_active = _.find(domains, {
                    //         'id_domain': user.default_domain
                    //     });
                    //     setDefaultDomain(user.domain_active)
                    // }

                    // // Used to set Enterprise details
                    // user.companyInfo = response.companyInfo;

                    // Resolve the promise.
                    deferred.resolve(response);

                },
                function() {

                    deferred.reject();

                }
            );

            // Return the promise.
            return (deferred.promise);

        }


        // -------------------------------------------------- //
        // -------------------------------------------------- //


        // Define the resource that will translate requests locally to server-side resources.
        var resource = $resource(
            COMMON.BASE_API + "/", {
                // No default data.
            }, {
                getUser: {
                    method: "GET"
                }
            }
        );

        // Store the default authenticating user.
        var user = {
            id: 0,
            name: "",
            initials: "",
            hasSystemAvatar: true,
            email: "",
            isAccountAuthenticated: false
        };

        // Store the default subscription for the authenticating user.
        var subscription = {};

        // Store the active Site for the authenticating user.
        var site_operative = {};

        // Store domains for the authenticating user. 
        // array()
        var domains = [];

        // I store session data that the controllers can use to store some small stateful items.
        var data = {};

        // Copy the feature flags into the session.
        


        // -------------------------------------------------- //
        // -------------------------------------------------- //


        // Return the public API.
        return ({
            // authenticate: authenticate,
            // setActiveDomain: setActiveDomain,
            // featureFlags: featureFlags,
            // get: get,
            // isAuthenticated: isAuthenticated,
            // set: set,
            // update: update,
            // subscription: subscription,
            // user: user,
            // site_operative: site_operative,
            // domains: domains
        });

    }
})();
( function ()
{
  'use strict';

  angular
    .module( 'app.core' )
    .service( "CommonMediaService", CommonMediaService );

  /** @ngInject */
  function CommonMediaService( $q, $resource, userService, settingsDomainService, sessionService, COMMON, $window )
  {

    /*
    * @array
    */
    function getUrl( options )
    {
      var deferred = $q.defer();

        var array= [];
        angular.forEach(options.id_media, function(media){
          array.push(media)
        });

        resource_content_getUrl.post(
          {
            domain: sessionService.site_operative.subdomain,
            id_media: array,
            id_cropformat: options.id_cropformat,
            id_container: options.id_container,
          },
          function ( response )
          {
            deferred.resolve( response );
          },
          function ( e )
          {
            console.error( e )
            console.error( "Database connection error" )
            deferred.reject();
          }
        );

      // Return the promise.
      return ( deferred.promise );
    }

    var resource_content_getUrl = $resource(
      COMMON.BASE_API + "/domain/:domain/media/url",
      {
        domain: '@domain',
      },
      {
        get:
        {
          method: "GET",
        },
				post:
        {
					method: 'POST',
          cache: false,
          isArray:true,
					headers:{'Content-Type':'application/json; charset=UTF-8'}
        },
        update:
        {
          method: "PUT",
        },
      }
    );

    // Return the public API.
    return (
    {
      getUrl: getUrl,
    });
  }

} )();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function (angular) {
	'use strict';

	angular.module('app.core')
		.directive('resizer', function ($document) {

			return function ($scope, $element, $attrs) {

				$element.on('mousedown', function (event) {
					event.preventDefault();

					$document.on('mousemove', mousemove);
					$document.on('mouseup', mouseup);
				});

				function mousemove(event) {

					if ($attrs.resizer == 'vertical') {
						// Handle vertical resizer
						var x = event.pageX;

						if ($attrs.resizerMax && x > $attrs.resizerMax) {
							x = parseInt($attrs.resizerMax);
						}

						$element.css({
							left: x + 'px'
						});

						$($attrs.resizerLeft)
							.css({
								width: x + 'px'
							});
						$($attrs.resizerRight)
							.css({
								left: (x + parseInt($attrs.resizerWidth)) + 'px'
							});

					} else {
						// Handle horizontal resizer
						var y = window.innerHeight - event.pageY;

						$element.css({
							bottom: y + 'px'
						});

						$($attrs.resizerTop)
							.css({
								bottom: (y + parseInt($attrs.resizerHeight)) + 'px'
							});
						$($attrs.resizerBottom)
							.css({
								height: y + 'px'
							});
					}
				}

				function mouseup() {
					$document.unbind('mousemove', mousemove);
					$document.unbind('mouseup', mouseup);
				}
			};
		})

})(angular);

/**
 * @author Gabriel Demichelis
 * @description use mediaelements to show a media-player elements
 * for example <div media-player config="configObj" class="video-player mejs-ted" width="700" height="500"></div>
 */

angular.module('core', []).directive('mediaPlayer', function ($compile, $rootScope) {
  return {
    restrict: 'A',
    replace: true,
    link: function postLink(scope, element, attrs) {
      scope.customClass = 'vp' + Math.round( Math.random() * (999999 - 999) + 999);
      scope.meOptions = {
        forceLive: false,
        features: ['playpause', 'current', 'progress', 'tracks', 'volume', 'fullscreen'],
        vrIsStereo: false
      }

      scope.generateVideoHtml = function(config, attrs) {
        var params = {
          class: attrs.class ? scope.customClass + ' ' + attrs.class : scope.customClass + ' video-player mejs-ted',
          width: angular.isUndefined(attrs.width) ? '700' : attrs.width,
          height: angular.isUndefined(attrs.height) ? '400' : attrs.height
        };

        var videoHtml = '<video width="' + params.width + '" height="' + params.height + '" class="' + params.class + '"';
        if (!angular.isUndefined(config.poster)) {
          videoHtml += ' poster="' + config.poster + '" ';
        }
        if (!angular.isUndefined(config.autoplay) && config.autoplay) {
          videoHtml += ' autoplay ';
        }
        if (!angular.isUndefined(config.preload)) {
          videoHtml += ' preload="' + config.preload + '" ';
        }
        angular.forEach(config.extra, function(data, key) {
          videoHtml += ' data-' + key + '="' + data + '" ';
        })
        videoHtml += '>';

        angular.forEach(config.sources, function(src) {
          videoHtml += '<source type="' + src.type + '" src="' + src.src + '"/>';
        })
        videoHtml += '</video>';
        return videoHtml;
      }

      scope.applyConfig = function(config) {
        if (!angular.isUndefined(config.isLive) && config.isLive) {
          scope.meOptions.forceLive = true;
        }
        if (!angular.isUndefined(config.enableCast) && config.enableCast) {
          scope.meOptions.features.push('chromecast');
        }
        if (!angular.isUndefined(config.isVr) && config.isVr) {
          scope.meOptions.features.push('vrview');
          scope.meOptions.vrIsStereo =  false
        }
        if (!angular.isUndefined(config.startAt) && config.startAt) {
          scope.meOptions.success = function (mediaElement, domObject) {
            mediaElement.setCurrentTime(config.startAt);
          };
        }


      }

      scope.$watch(attrs.config, function (config) {
        scope.applyConfig(config);
        element.html(scope.generateVideoHtml(config, attrs));
        $compile(element.contents())(scope);
        angular.element('.' + scope.customClass).mediaelementplayer(scope.meOptions);
      });
    }
  };
});



angular.module('app.core')
  .directive('iframeOnload', function ($document) {
    return {
      restrict: 'A',
      replace: true,
      scope: {
        callBack: '&iframeOnload'
      },
      link: function postLink(scope, element, attrs) {
        let isLoading = false;
        console.log('false')
        setTimeout(() => {
          isLoading = true;
          console.log('true')
        }, 400);
        element.on('load', function (e) {
          if (isLoading) {
            console.log('OK')
          } else {
            console.log('FALLO')
          }
          return scope.callBack();
        });
      }
    };
  });

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate)
    {
        return {
            restrict: 'EA',
            compile : function (tElement, tAttrs)
            {
                var code;
                //No attribute? code is the content
                if ( !tAttrs.code )
                {
                    code = tElement.html();
                    tElement.empty();
                }

                return function (scope, iElement, iAttrs)
                {
                    if ( iAttrs.code )
                    {
                        // Attribute? code is the evaluation
                        code = scope.$eval(iAttrs.code);
                    }
                    var shouldInterpolate = scope.$eval(iAttrs.shouldInterpolate);

                    $q.when(code).then(function (code)
                    {
                        if ( code )
                        {
                            if ( shouldInterpolate )
                            {
                                code = $interpolate(code)(scope);
                            }

                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );

                            iElement.append(contentParent);

                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function ()
                            {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent)
                    {
                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line)
                        {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);

                        lines = lines.map(function (line)
                        {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(iAttrs.language || iAttrs.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
/**
 * @author Sufiyan momin
 * @description showing image and videos(sample video, youtube video, vimeo video)
 * for example <div fotorama item="fotoArray" class="fotorama" data-allowfullscreen="true"></div> provide different options refer http://fotorama.io/customize/
 */

angular.module('core', []).directive('fotorama1', ['$timeout', '$compile', function ($timeout) {
  return {


    link: function (scope, element, attrs) {
      scope.$watch(attrs.item, function (value) {
        var val = angular.copy(value);
        if (val) {
          $timeout(function () {
            var fotoramaKey = [];
            angular.forEach(val, function (val, key) {
              var fotoObj = {};

              if (val.type == 'image') { // it is an image
                fotoObj.img = val.url;
                fotoObj.thumb = val.url;
                fotoObj.caption = val.caption;
                fotoramaKey.push(fotoObj);
              } else { // it is  video
                fotoObj.thumb = val.thumb;
                fotoObj.caption = val.caption;
                fotoObj.video = val.url;
                fotoramaKey.push(fotoObj);
              }

            });

            $(element).fotorama({
              data: fotoramaKey
            });
          });

        }
      }, true);

    }
  };
}]);


'use strict';

angular.module('ap.fotorama', [])

  .value('apFotoramaConfig', {
    //width:'100%', и проч. настройки по умолчанию
    //Имена полей в фотораме и приложении
    id: 'id',      //имя поля с id картинки
    thumb: 'thumb',   //имя поля с миниатюрой
    img: 'img',     //имя поля с изображением
    full: 'full',    //имя поля с оригиналом
    caption: 'caption', //имя с заголовком
    active: 'active',  //указатель активной фотки
    domain: '',        //'http://tamtakoe.ru/uploader/' //для кроссдоменных запросов
    //Колбеки событий
    show: null,
    showend: null,
    fullscreenenter: null,
    fullscreenexit: null,
    loadvideo: null,
    unloadvideo: null,
    stagetap: null,
    ready: null,
    error: null,
    load: null,
    stopautoplay: null,
    startautoplay: null
  })
  .directive('apFotorama', ['apFotoramaConfig', function (apFotoramaConfig) {
    return {
      require: '?ngModel',
      link: function (scope, element, attrs, ngModel) {
        var opts = {},
          collection,
          events = 'show showend fullscreenenter fullscreenexit loadvideo unloadvideo stagetap ready error load stopautoplay startautoplay'.split(' ');

        angular.extend(opts, apFotoramaConfig);

        element.bind('fotorama:showend', function (e, fotorama, extra) {
          if (collection !== undefined && typeof scope[attrs.ngModel] === 'object') {
            //Записываем активную фотку в модель
            setActive(collection.activeIndex);

            scope.$$phase || scope.$apply(); //Не всегда срабатывает в первый раз, если бы не было начального переключения на фотку
          }
        });

        //Преобразование массивов данных в массивы, эквивалентные внутреннему массиву Фоторамы
        function makeFotoramaArray(res, update) {
          var n = typeof res === 'object' ? res.length : 0,
            activeIndex;

          for (var i = 0, nn = n, arr = [], ci; i < nn; i++) {
            if (res[i].id !== undefined) {
              ci = arr.push({}) - 1;
              arr[ci].id = res[i][opts.id];
              arr[ci].thumb = res[i][opts.thumb] !== undefined ? opts.domain + res[i][opts.thumb] : res[i][opts.thumb];
              arr[ci].img = res[i][opts.img] !== undefined ? opts.domain + res[i][opts.img] : res[i][opts.thumb];
              arr[ci].full = res[i][opts.full] !== undefined ? opts.domain + res[i][opts.full] : res[i][opts.thumb];
              arr[ci].html = res[i][opts.html];
              arr[ci].caption = res[i][opts.caption];

              if (res[ci][opts.active]) activeIndex = ci;

              if (update && collection.data) collection.splice(i, 1, arr[i]);

            } else {
              n--;
            }
          }
          return {arr: arr, arrLength: n, activeIndex: activeIndex}
        }

        function setActive(index) {
          index = index === undefined && this !== undefined && this.$index !== undefined ? this.$index : index;

          for (var i = 0, n = scope[attrs.ngModel].length; i < n; i++) {
            scope[attrs.ngModel][i][opts.active] = index == i ? true : false;
          }
        }

        scope.setActive = setActive;

        scope.$watch(attrs.ngModel, function (newVal, oldVal) {

          //Если модель изменилась, синхронизируем с ней Фотораму
          if (oldVal !== newVal) {

            var oKeys = {}, nKeys = {}, i, oi, temp;

            var oArr = collection.data ? collection.data : [];
            var o = oArr.length,
              oldActiveIndex = collection.activeIndex;

            temp = makeFotoramaArray(newVal);
            var nArr = temp.arr,
              n = temp.arrLength,
              activeIndex = temp.activeIndex;

            if (o) {

              //Алгоритм преобразования массива фотографий в соответствии с моделью с минимальным количеством перестановок. http://plnkr.co/edit/clW0aVqzaisUkUo44EOL?p=preview
              for (i = 0; i < o; i++) {
                oKeys[oArr[i].id] = i;
              }
              for (i = 0; i < n; i++) {
                nKeys[nArr[i].id] = i;
              }
              for (i = 0, oi = 0; i < n; i++, oi++) {

                if (oArr[oi] === undefined) oArr[oi] = {id: null};

                if (nArr[i].id !== oArr[oi].id) {

                  //Добавление нового элемента
                  if (oKeys[nArr[i].id] === undefined) {

                    collection.splice(i, 0, nArr[i]);
                    oi--;
                    //console.log('+add')
                  }

                  //Удаление элемента
                  if (oi >= 0 && nKeys[oArr[oi].id] === undefined) {

                    if (oldActiveIndex == oi && activeIndex === undefined) activeIndex = i !== n ? i : i - 2; //меняем активную фотку, если она была удалена, на следующую/предыдущую
                    collection.splice(i, 1);
                    i--;
                    //console.log('-del')
                  }

                  //Смена позиции
                  if (i >= 0 && oKeys[nArr[i].id] !== undefined && nKeys[oArr[oi].id] !== undefined) {

                    if ((oKeys[nArr[i].id] - oKeys[oArr[oi].id]) > (nKeys[oArr[oi].id] - nKeys[nArr[i].id])) {

                      collection.splice(i, 0, nArr[i]);
                      delete nKeys[nArr[i].id];
                      oi--;
                      //console.log('add')
                    } else {

                      collection.splice(i, 1);
                      delete oKeys[oArr[oi].id];
                      i--;
                      //console.log('del')
                    }
                  }
                } else if (nArr[i].img !== oArr[oi].img) {

                  //Замена картинки
                  collection.splice(i, 1, nArr[i]);
                  //console.log('change')
                }
              }

              //Удаляем оставшиеся в конце элементы и меняем активную фотку, если она была удалена, на предыдущую
              if (o > oi) collection.splice(n, o - (oi));
              if (oldActiveIndex >= n && activeIndex === undefined) activeIndex = n - 1;

            } else if (n) {
              //Если фоток не было, то инициализируем фотораму заново и обновляем настройки, т.к. они сбрасываются
              collection.setOptions(opts).load(nArr).setOptions(scope[attrs.apFotorama]);
              //console.log('load data')
            }

            //Переключаемся на активную фотку
            if (n) activeIndex !== undefined ? collection.show(activeIndex) : collection.show(0);
          }

        }, true);

        //Смотрим изменение настроек
        scope.$watch(attrs.apFotorama, function (newVal, oldVal) {
          angular.extend(opts, apFotoramaConfig, newVal);
          collection.setOptions(opts)

          //Устанавливаем события
          //TODO: Уничтожение старых событий
          angular.forEach(events, function (event) {
            if (typeof opts[event] === 'function') {
              element.bind('fotorama:' + event, function (e, fotorama, extra) {
                opts[event](e, extra);
              });
            }
          });

          if (newVal.thumb || newVal.img || newVal.full) {
            //Обновляем фотораму, если поменялись имена картинок
            makeFotoramaArray(scope[attrs.ngModel], true);
          }
          //collection.setOptions(newVal);
        }, true);

        // Создаем фотораму
        collection = element.fotorama(opts).data('fotorama');

        //Копируем в настройки значения по умолчанию
        scope[attrs.apFotorama] = angular.extend({}, collection.options, scope[attrs.apFotorama]);
      }
    };
  }
  ]);

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toDate', toDate);

    /** @ngInject */
    function toDate(moment)
    {
        return function(input) {
            if (angular.isUndefined(input) || input == '') { 
                return new Date();
            }
            //console.log(input)
            //var parts =input.split('-');
            //var d = new Date(input +" 12:00:00");
            //var d = new Date(input +"T12:00:00Z");
            //var d = new Date(parts[0], parts[1] - 1, parts[2], '12', '00', '00'); 
            var d = moment(input +" 12:00:00", "YYYYY-MM-DD HH:mm:ss").toDate();
            //console.log(d);
            return d;
        };
    }
})();
(function () {
	'use strict';

	angular
		.module('app.core')
		.filter('filterByTags', filterByTags)
		.filter('filterSingleByTags', filterSingleByTags)
		.filter('filterGroupBy', filterGroupBy)
        .filter('filterInArray', filterInArray)
		.filter('filterNotInArray', filterNotInArray);

	/** @ngInject */
	function filterByTags() {
		return function (items, tags) {
			if (items.length === 0 || tags.length === 0) {
				return items;
			}

			var filtered = [];

			items.forEach(function (item) {
				var match = tags.every(function (tag) {
					var tagExists = false;

					item.tags.forEach(function (itemTag) {
						if (itemTag.name === tag.name) {
							tagExists = true;
							return;
						}
					});

					return tagExists;
				});

				if (match) {
					filtered.push(item);
				}
			});

			return filtered;
		};
	}

    function filterInArray($filter) {
        return function (list, arrayFilter, element) {
            if (arrayFilter) {
                return $filter("filter")(list, function (listItem) {
                    for (var i = 0; i < arrayFilter.length; i++) {
                        if (arrayFilter[i] == listItem[element])
                        // if (arrayFilter[i][element] == listItem[element])
                            return true;
                    }
                    return false;
                });
            }
        }
    }

	function filterNotInArray($filter) {
		return function (list, arrayFilter, element) {
			if (arrayFilter) {
				return $filter("filter")(list, function (listItem) {
					for (var i = 0; i < arrayFilter.length; i++) {
                        if (arrayFilter[i] == listItem[element])
						// if (arrayFilter[i][element] == listItem[element])
							return false;
					}
					return true;
				});
			}
		}
	}

	/** @ngInject */
	function filterSingleByTags() {
		return function (itemTags, tags) {
			if (itemTags.length === 0 || tags.length === 0) {
				return;
			}

			if (itemTags.length < tags.length) {
				return [];
			}

			var filtered = [];

			var match = tags.every(function (tag) {
				var tagExists = false;

				itemTags.forEach(function (itemTag) {
					if (itemTag.name === tag.name) {
						tagExists = true;
						return;
					}
				});

				return tagExists;
			});

			if (match) {
				filtered.push(itemTags);
			}

			return filtered;
		};
	}


	function filterGroupBy() {
		return function (items, group) {
			return items.filter(function (element, index, array) {
				return parseInt(element.time) == group;
			});
		}
	}

})();
(function () {
	'use strict';

	angular
		.module('app.core')
		.filter('toTrusted', toTrustedFilter)
		.filter('toTrustedResource', toTrustedResourceFilter)
		.filter('yesNo', yesNo)
		.filter('htmlToPlaintext', htmlToPlainTextFilter)
		.filter('nospace', nospaceFilter)
		.filter('capitalize', capitalizeFilter)
		.filter('humanizeDoc', humanizeDocFilter)
		.filter('mediaPlaceholder', mediaPlaceholderFilter)
		.filter('parseUrlFilter', parseUrlFilter)
		.filter('autoLinkerFilter', autoLinkerFilter)
		.filter('isEmptyObject', isEmptyObject);

	/** @ngInject */
	function toTrustedFilter($sce) {
		return function (value) {
			return $sce.trustAsHtml(value);
		};
	}

	/** @ngInject */
	function toTrustedResourceFilter($sce) {
		return function (value) {
			if (value.length > 0)
				return $sce.trustAsResourceUrl(value);
		};
	}

	function yesNo() {
		return function (input) {
			return input ? 'Yes' : 'No';
		}
	}

	/** @ngInject */
	function htmlToPlainTextFilter() {
		return function (text) {
			return String(text)
				.replace(/<[^>]+>/gm, '');
		};
	}

	/** @ngInject */
	function nospaceFilter() {
		return function (value) {
			return (!value) ? '' : value.replace(/ /g, '');
		};
	}

	/** @ngInject */
	function capitalizeFilter() {
		return function (input) {
			return (!!input) ? input.charAt(0)
				.toUpperCase() + input.substr(1)
					.toLowerCase() : '';
		}
	}

	/** @ngInject */
	function humanizeDocFilter() {
		return function (doc) {
			if (!doc) {
				return;
			}
			if (doc.type === 'directive') {
				return doc.name.replace(/([A-Z])/g, function ($1) {
					return '-' + $1.toLowerCase();
				});
			}
			return doc.label || doc.name;
		};
	}

	/** @ngInject */
	function mediaPlaceholderFilter(msUtils) {
		return function (item) {
			return msUtils.getMediaPlaceholder(item);
		};
	}

	function parseUrlFilter() {

		var urlPattern = /(http|ftp|https):\/\/[\w-]+(\.[\w-]+)+([\w.,@?^=%&amp;:\/~+#-]*[\w@?^=%&amp;\/~+#-])?/gi;

		return function (text, target, otherProp) {

			return text.replace(urlPattern, '<a target="' + target + '" href="$&">$&</a>') + " | " + otherProp;
		};
	}

	function autoLinkerFilter() {

		var autolinker = new Autolinker({
			urls: {
				schemeMatches: true,
				wwwMatches: true,
				tldMatches: true
			},
			email: true,
			phone: false,
			twitter: true,
			hashtag: false,

			stripPrefix: false,
			newWindow: true,

			truncate: {
				length: 0,
				location: 'end'
			},

			className: ''
		});

		return function (text) {
			if (typeof text === 'string') {
				return autolinker.link(text);
			}
			return '-';
		}
	}

	function isEmptyObject() {
		return function (object) {
			return angular.equals({}, object);
		}
	}

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('QiuConfig', QiuConfigProvider);

    /** @ngInject */
    function QiuConfigProvider()
    {
        // Default configuration
        var QiuConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            QiuConfiguration = angular.extend({}, QiuConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(QiuConfiguration[configName]) )
                {
                    return false;
                }

                return QiuConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                QiuConfiguration[configName] = configValue;
            }
        };
    }

})();



(function () {
    'use strict';

    angular
        .module('app.core')
        .config(function (ngMdIconServiceProvider) {
            ngMdIconServiceProvider.addShapes({
                'icon-nested-select-vbar': '<path d="M 19.5 0h1v40h-1z"/>',
                'icon-nested-select-el': '<path d="M 19.5 0h1v19.5h19.5v1h-20.5z"/>',
                'icon-nested-select-midbar': '<path d="M 19.5 0h1v19.5h19.5v1h-19.5v39h-1z"/>',
                'icon-nested-select-space': '<g/>',
            }).addViewBoxes({
                'icon-nested-select-vbar': '0 0 40 40',
                'icon-nested-select-el': '0 0 40 40',
                'icon-nested-select-midbar': '0 0 40 40',
                'icon-nested-select-space': '0 0 40 40'
            });
        })
        .component('nestedSelect', {
            bindings: {
                options: '<',
                label: '@',
                onChange: '&'
            },
            template: `
                <md-input-container ng-class="{'md-input-has-value': ($ctrl.hasValue() || $ctrl.fixedMenu), 'md-input-focused': $ctrl.hasFocus()}">
                    <label>{{$ctrl.label}}</label>
                    <nested-select-selection ng-if="$ctrl.showSelection" 
                        ng-click="$ctrl.onClickSelection()" ng-class="{'menu-open': $ctrl.showMenu, focused: $ctrl.hasFocus()}"
                        class="md-select-value" tabindex="0">
                        <span ng-bind="$ctrl.getSelectionText()" >
                        </span>
                        <span class="md-select-icon"></span>
                    </nested-select-selection>
                </md-input-container>
                <nested-select-menu ng-class="{visible: $ctrl.showMenu}" md-whiteframe="2" tabindex="-1">
                    <nested-select-header ng-if="$ctrl.placeholder" >
                        <input type="search" placeholder="{{$ctrl.placeholder}}" 
                            ng-model="$ctrl.filter" ng-change="$ctrl.onChangeFilter()" />
                        <md-button class="md-icon-button" ng-if="$ctrl.multiple && $ctrl.allowSelectAll" 
                            ng-click="$ctrl.onClickAll()">
                            <md-tooltip>Select All</md-tooltip>
                            <ng-md-icon icon="playlist_add_check" style="fill: currentColor"></ng-md-icon>
                        </md-button>
                    </nested-select-header>
                    <md-content ng-class="{filtering: $ctrl.filter.length}">
                        <nested-select-options options="$ctrl.options" collapsible="$ctrl.collapsible" multiple="$ctrl.multiple" depth="0" on-change="$ctrl.onOptionChange($event)">
                    </md-content>
                </nested-select-menu>
            `,
            controller: function nestedSelect($scope, $timeout, $element, $attrs, $mdConstant) {
                var $ctrl = this;

                // Lifecycle event handlers

                $ctrl.$onInit = function () {
                    $ctrl.filter = "";
                    $ctrl.placeholder = $attrs.placeholder;
                    $ctrl.multiple = !!$attrs.$attr.multiple;
                    $ctrl.collapsible = !!$attrs.$attr.collapsible;
                    $ctrl.showSelection = !!$attrs.$attr.showSelection;
                    $ctrl.allowSelectAll = !!$attrs.$attr.allowSelectAll;
                    $ctrl.fixedMenu = !!$attrs.$attr.fixedMenu;
                    $element.on("focusout", $ctrl.onFocusout);
                    $element.on("keyup", $ctrl.onKeyup);
                };

                $ctrl.$onChanges = function (changes) {
                    if (changes.options) {
                        $ctrl.options = angular.copy($ctrl.options);
                    } else {
                        $ctrl.options = $ctrl.options || [];
                    }
                    $ctrl.updateHighlightedOptions();
                };

                $ctrl.$postLink = function () {
                    var menu = $element.find('nested-select-menu');
                    if (menu) {
                        setTimeout(() => {
                            menu.css('width', $element[0].clientWidth + 'px');
                        }, 10);
                    }
                };

                // UI event handlers

                $ctrl.onFocusout = function (event) {
                    // Because the component includes multiple focusable
                    // elements, this handler can be triggered when the
                    // user moves from one element to another within
                    // the main container. That's not really a focusout
                    // event for the whole component, so we want to
                    // ignore those interactions.
                    if ($element[0].contains(event.relatedTarget)) {
                        return;
                    }

                    $ctrl.closeMenu();

                    // Angular doesn't automatically run a digest if
                    // the event's target is outside of the component
                    // element. This occurs, for example, if the
                    // user clicks outside the element.
                    $scope.$apply();
                };

                $ctrl.onKeyup = function (event) {
                    switch (event.keyCode) {
                        case $mdConstant.KEY_CODE.ESCAPE:
                            $ctrl.closeMenu();
                            document.activeElement.blur();
                            $scope.$apply();
                            break;
                        case $mdConstant.KEY_CODE.RIGHT_ARROW:
                        case $mdConstant.KEY_CODE.DOWN_ARROW:
                            $ctrl.navigateForward();
                            break;
                        case $mdConstant.KEY_CODE.LEFT_ARROW:
                        case $mdConstant.KEY_CODE.UP_ARROW:
                            $ctrl.navigateBackward();
                            break;
                    }
                };

                $ctrl.onClickSelection = function () {
                    $ctrl.toggleMenu();
                };

                $ctrl.onChangeFilter = function () {
                    $ctrl.updateHighlights();
                    $ctrl.updateHighlightedOptions();
                };

                $ctrl.onClickAll = function () {

                    // Don't emit change events for
                    // each change but rather keep track
                    // of all changes and emit a single event
                    // after all options have been processed.
                    var hasChanged = false;

                    // If all the visible options are already
                    // selected, this event de-selects them.
                    if ($ctrl.isSelectionComplete()) {
                        $ctrl.applyFnToOptions(function deselectOption(opt) {
                            if (!opt.suppressed && !opt.muted) {
                                $ctrl.deselectOption(opt, true);
                                hasChanged = true;
                            }
                        }, $ctrl.options, true);
                    } else {
                        $ctrl.applyFnToOptions(function selectOption(opt) {
                            if (!opt.suppressed && !opt.muted) {
                                $ctrl.selectOption(opt, true);
                                hasChanged = true;
                            }
                        }, $ctrl.options, true);
                    }

                    // If any options were updated, inform
                    // the parent controller that the 
                    // selection set has changed.
                    if (hasChanged) {
                        $ctrl.emitChange();
                    }
                };

                // Child component event handlers

                $ctrl.onOptionChange = function (event) {
                    if (!$ctrl.multiple) {
                        if (event.option.selected) {
                            $ctrl.applyFnToOptions(function (opt) {
                                if (opt !== event.option) {
                                    $ctrl.deselectOption(opt, true);
                                }
                            });
                            var selection = $element.find('nested-select-selection');
                            if (selection.length) {
                                $ctrl.setFocus(selection[0]);
                            }
                        } else {
                            $ctrl.clearFocus();
                        }
                        $ctrl.closeMenu();
                    }
                    $ctrl.emitChange();
                };

                // Emit events to parent components

                $ctrl.emitChange = function () {
                    $ctrl.onChange({ $event: { selectedValues: $ctrl.getSelectionValues() } });
                };

                // Utility functions

                $ctrl.applyFnToOptions = function (fn, opts, excludeCollapsed) {
                    var opts = opts || $ctrl.options;
                    opts.forEach(function applyFnToOption(opt) {
                        fn(opt);
                        if (opt.children && (!opt.collapsed || !excludeCollapsed)) {
                            $ctrl.applyFnToOptions(fn, opt.children, excludeCollapsed);
                        }
                    });
                };

                $ctrl.isSelectionComplete = function () {
                    var all = true;
                    $ctrl.applyFnToOptions(function checkOptionSelectedState(opt) {
                        all = all && (opt.selected || opt.suppressed || opt.muted);
                    }, $ctrl.options, true);
                    return all;
                };

                $ctrl.getSelectionText = function () {
                    var selection = [];
                    $ctrl.applyFnToOptions(function accumulateSelectedText(opt) {
                        if (opt.selected) {
                            selection.push(opt.text);
                        }
                    });
                    return selection.join(", ");
                };

                $ctrl.getSelectionValues = function () {
                    var selection = [];
                    $ctrl.applyFnToOptions(function accumulateSelectedValues(opt) {
                        if (opt.selected) {
                            selection.push(opt.value);
                        }
                    });
                    return selection;
                };

                $ctrl.hasValue = function () {
                    var hasValue = false;
                    $ctrl.applyFnToOptions(function accumulateSelectedValues(opt) {
                        if (opt.selected) {
                            hasValue = true;
                        }
                    });
                    return hasValue;
                };

                $ctrl.hasFocus = function () {
                    return $element[0].contains(document.activeElement);
                };

                $ctrl.setFocus = function (element, delay) {
                    delay = delay || 0;
                    // Because the controller is already watching for
                    // focus events on the entire component, make sure
                    // that Angular doesn't run the digest loop here.
                    // Otherwise Angular throws an already in progress
                    // error.
                    // See https://docs.angularjs.org/error/$rootScope/inprog
                    $timeout(function () {
                        element.focus();
                    }, delay, false);
                };

                $ctrl.clearFocus = function () {
                    // Because the controller is already watching for
                    // focusout events on the entire component, make sure
                    // that Angular doesn't run the digest loop here.
                    // Otherwise Angular throws an already in progress
                    // error.
                    // See https://docs.angularjs.org/error/$rootScope/inprog
                    $timeout(function () {
                        document.activeElement.blur();
                    }, 0, false);
                };

                $ctrl.getFocusableNodes = function () {
                    var nodes = Array.prototype.slice.call($element[0].querySelectorAll([
                        "nested-select-selection",
                        "input",
                        "button",
                        "md-checkbox"
                    ].join(",")));

                    var hidden = new Set($element[0].querySelectorAll([
                        ".filtering button",
                        "md-checkbox[disabled]",
                        "nested-select-options.collapsed button",
                        "nested-select-options.collapsed md-checkbox"
                    ].join(",")));

                    return nodes.filter(function (node) {
                        return !hidden.has(node);
                    });
                };

                $ctrl.getFocusedIndex = function (nodes) {
                    var curIdx = -1;
                    nodes.some(function (node, idx) {
                        if (node === document.activeElement) {
                            curIdx = idx;
                            return true;
                        }
                    });
                    return curIdx;
                };

                // Component logic

                $ctrl.toggleMenu = function () {
                    if ($ctrl.showMenu) {
                        $ctrl.closeMenu();
                    } else {
                        $ctrl.openMenu();
                    }
                };

                $ctrl.openMenu = function () {
                    $ctrl.showMenu = true;
                    var search = $element.find('input');
                    if (search.length) {
                        $ctrl.setFocus(search[0], 400);
                    }
                };

                $ctrl.closeMenu = function () {
                    $ctrl.showMenu = $ctrl.fixedMenu;
                };

                $ctrl.updateHighlights = function () {

                    var filter = $ctrl.filter;

                    if (filter) {

                        // Convert the text input from the search element
                        // into a regular expression to support features
                        // such as case-insensitivity and match highlighting.
                        // Since the ultimate result is a regular expression,
                        // also give users the ability to enter their own
                        // regular expressions directly. User-entered regular
                        // expressions start and end with a `/` and have at
                        // least one character between them.

                        if (filter.match(/^\/.+\/$/)) {

                            // Already a regular expression, so just
                            // remove the delimiters.
                            filter = filter.slice(1, -1);

                        } else {

                            // Not a regular expression, so escape any
                            // characters that a regular expression would
                            // view as control characters.
                            filter = filter.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');

                        }

                        // Add grouping parentheses around the search text
                        // so that matching text can be highlighted.
                        $ctrl.highlights = new RegExp("(" + filter + ")", "gi");

                    } else {

                        $ctrl.highlights = false;

                    }
                };

                $ctrl.applyHighlightsToOptions = function (opts) {

                    // Recurse through the options tree and update
                    // each option's status with respect to highlighting.
                    // An option is fully suppressed if it is not
                    // itself highlighted and has no children that
                    // are highlighted. If an option is not itself
                    // highlighted but has highlighted children, it
                    // is not suppressed but muted.

                    // Returns a boolean indicating whether or
                    // not any of the options at the current level
                    // are highlighted or have highlighted children.
                    return opts.reduce(function accumulateHighlights(anyHighlights, opt) {

                        // Does the current option have any highlighted children?
                        var childHighlights = opt.children && $ctrl.applyHighlightsToOptions(opt.children);

                        // Should the current option itself be highlighted?
                        var isHighlighted = $ctrl.highlights.test(opt.text);
                        // Since regex is global, be sure to reset after test()
                        $ctrl.highlights.lastIndex = 0;

                        // If highlighting is needed, do it; otherwise just
                        // use the plain text.
                        if (isHighlighted) {
                            opt.highlightedText = opt.text.replace($ctrl.highlights, "<b>$1</b>");
                        } else {
                            opt.highlightedText = opt.text;
                        }

                        // Update the option status.
                        opt.suppressed = !isHighlighted && !childHighlights;
                        opt.muted = !isHighlighted && childHighlights;

                        // Update accumulating value by logically ORing
                        // the highlight status of the current option and
                        // its children
                        return anyHighlights || isHighlighted || childHighlights;
                    }, false);
                };

                $ctrl.updateHighlightedOptions = function () {
                    if ($ctrl.highlights) {

                        // If there are highlights to apply, do so
                        $ctrl.applyHighlightsToOptions($ctrl.options);

                    } else {

                        // No highlights to apply so just reset
                        // the option status
                        $ctrl.applyFnToOptions(function (opt) {
                            opt.highlightedText = opt.text;
                            opt.suppressed = false;
                            opt.muted = false;
                        });
                    }
                };

                $ctrl.selectOption = function (opt, suppressChange) {
                    if (!opt.selected) {
                        if (!$ctrl.multiple) {
                            $ctrl.applyFnToOptions(function (opt) {
                                $ctrl.deselectOption(opt, true);
                            });
                            $ctrl.closeMenu();
                        }
                        if (!suppressChange) {
                            $ctrl.emitChange();
                        }
                        opt.selected = true;
                    }
                };

                $ctrl.deselectOption = function (opt, suppressChange) {
                    var changed = opt.selected;
                    opt.selected = false;
                    if (changed && !suppressChange) {
                        $ctrl.emitChange();
                    }
                };

                $ctrl.navigateForward = function () {
                    var nodes = $ctrl.getFocusableNodes();
                    var curIdx = $ctrl.getFocusedIndex(nodes);
                    if (curIdx !== -1 && curIdx < nodes.length - 1) {
                        $ctrl.setFocus(nodes[curIdx + 1]);
                    }
                };

                $ctrl.navigateBackward = function () {
                    var nodes = $ctrl.getFocusableNodes();
                    var curIdx = $ctrl.getFocusedIndex(nodes);
                    if (curIdx > 0) {
                        $ctrl.setFocus(nodes[curIdx - 1]);
                    }
                };
            }
        })
        .component('nestedSelectOptions', {
            bindings: {
                options: '<',
                collapsible: '<',
                multiple: '<',
                depth: '<',
                lastSibling: '<',
                onChange: '&'
            },
            template: `
                <nested-select-option ng-repeat="option in $ctrl.options">
                    <nested-select-text ng-if="!option.suppressed">
                        <nested-select-guide ng-if="$ctrl.showCollapseSpacer(option)" >
                            <ng-md-icon class="nested-select-icon" icon="icon-nested-select-space" size="40" style="fill: rgba(0,0,0,0.12)"></ng-md-icon>
                        </nested-select-guide>
                        <nested-select-guide ng-repeat="guide in $ctrl.countPrefixGuides(option) track by $index">
                            <ng-md-icon class="nested-select-icon" icon="{{$ctrl.getPrefixGuideIcon(option, $index)}}" size="40" style="fill: rgba(0,0,0,0.12)"></ng-md-icon>
                        </nested-select-guide>
                        <nested-select-guide ng-if="$ctrl.showGuide(option)" >
                            <ng-md-icon class="nested-select-icon" icon="{{$ctrl.getGuideIcon(option)}}" size="40" style="fill: rgba(0,0,0,0.12)"></ng-md-icon>
                        </nested-select-guide>
                        <md-button class="md-icon-button nested-select-collapse" ng-if="$ctrl.showCollapse(option)"
                            aria-label="collapse/expand" ng-click="$ctrl.onCollapseClick(option)" ng-class="{collapsed: option.collapsed}">
                            <ng-md-icon icon="keyboard_arrow_down" style="fill: currentColor"></ng-md-icon>
                        </md-button>
                        <md-checkbox ng-if="!option.suppressed" ng-model="option.selected" ng-disabled="option.muted" ng-change="$ctrl.onCheckboxChange(option)" aria-label="{{option.text}}">
                            <!-- <md-tooltip>{{option.text}}</md-tooltip> -->
                            <span ng-bind-html="option.highlightedText"></span>
                        </md-checkbox>
                    </nested-select-text>
                      <nested-select-options ng-if="option.children && option.children.length" options="option.children" 
                          collapsible="$ctrl.collapsible" multiple="$ctrl.multiple" depth="$ctrl.depth + 1" last-sibling="$ctrl.lastSibling + (+$last)"
                            ng-class="{collapsed: option.collapsed}" on-change="$ctrl.onChildChange($event)">
                      </nested-select-options>
                </nested-select-option>
            `,
            controller: function nestedSelectOptions($element, $attrs) {
                var $ctrl = this;
                $ctrl.$onInit = function () {
                    $ctrl.collapsed = false;
                    $ctrl.lastSibling = $ctrl.lastSibling || "";
                }
                $ctrl.$onChanges = function (changes) {
                    if (changes.options && !changes.options.isFirstChange()) {
                        $ctrl.options = angular.copy($ctrl.options);
                    }
                };

                // Utilities for adding visual guides and buttons

                // Should a spacer be added to account for collapse/expand button?			
                $ctrl.showCollapseSpacer = function (opt) {
                    return $ctrl.collapsible && $ctrl.depth;
                };

                // How many guides to insert in front of a text label?
                $ctrl.countPrefixGuides = function () {
                    // retuns an empty array with the appropriate number of 
                    // elements so that ng-repeat can iterate over it
                    return $ctrl.depth > 0 ? new Array($ctrl.depth - 1) : [];
                };

                // What icon should be used at the current guide depth?
                $ctrl.getPrefixGuideIcon = function (opt, depthIdx) {
                    if ($ctrl.multiple || $ctrl.lastSibling[depthIdx + 1] === '1') {
                        return "icon-nested-select-space";
                    } else {
                        return "icon-nested-select-vbar";
                    }
                };

                // Should a guide be added for this option?
                $ctrl.showGuide = function (opt) {
                    return !$ctrl.showCollapse(opt) && (!$ctrl.multiple && ($ctrl.depth > 0) || $ctrl.collapsible);
                };


                // What icon should be used for the current option's guide?
                $ctrl.getGuideIcon = function (opt) {
                    if ($ctrl.collapsible && (!opt.children || opt.children.length === 0) && ($ctrl.depth === 0 || $ctrl.multiple)) {
                        return "icon-nested-select-space";
                    } else if ($ctrl.options[$ctrl.options.length - 1] === opt) {
                        return "icon-nested-select-el";
                    } else {
                        return "icon-nested-select-midbar";
                    }
                };

                // Should the collapse/expand button be included?
                $ctrl.showCollapse = function (opt) {
                    return $ctrl.collapsible && opt.children && (opt.children.length > 0);
                };


                $ctrl.onCheckboxChange = function (opt) {
                    $ctrl.onChange({ $event: { option: opt } });
                };
                $ctrl.onCollapseClick = function (opt) {
                    opt.collapsed = !opt.collapsed;
                };
                $ctrl.onChildChange = function (event) {
                    $ctrl.onChange({ $event: { option: event.option } });
                };
            }
        });
})();



(function () {
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($rootScope, $mdSidenav, $mdDialog, settingUserService, $translate, $mdToast, sessionService, $window) {
        var vm = this;
        vm.userGlobalSettings = settingUserService.getGlobalUserSettings();
        vm.userDomainSettings = settingUserService.getDomainlUserSettings();
//        console.log(vm.userGlobalSettings);
//        console.log(vm.userDomainSettings);
        // Data
        $rootScope.global = {
            search: '',
            titleToolbar: ''
        };

        vm.titleToolbar = '';
        vm.bodyEl = angular.element('body');
        vm.userStatusOptions = [{
            'title': 'Online',
            'icon': 'icon-checkbox-marked-circle',
            'color': '#4CAF50'
        },
        {
            'title': 'Away',
            'icon': 'icon-clock',
            'color': '#FFC107'
        },
        {
            'title': 'Do not Disturb',
            'icon': 'icon-minus-circle',
            'color': '#F44336'
        },
        {
            'title': 'Invisible',
            'icon': 'icon-checkbox-blank-circle-outline',
            'color': '#BDBDBD'
        },
        {
            'title': 'Offline',
            'icon': 'icon-checkbox-blank-circle-outline',
            'color': '#616161'
        }
        ];
        vm.languages = {
            en: {
                'title': 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code': 'en',
                'flag': 'en'
            },
            es: {
                'title': 'Spanish',
                'translation': 'TOOLBAR.SPANISH',
                'code': 'es',
                'flag': 'es'
            },
            fr: {
                'title'      : 'French',
                'translation': 'TOOLBAR.FRENCH',
                'code'       : 'fr',
                'flag'       : 'fr'
            }
        };

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.openPassDialog = openPassDialog;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.openAiSidenav = openAiSidenav;
        vm.getSettingValue = settingUserService.getSettingValue;

        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            vm.user = sessionService.user;
            // Select the first status as a default
            vm.userStatus = vm.userStatusOptions[0];


            // Get the selected language directly from angular-translate module setting
            // vm.selectedLanguage = vm.languages[ $translate.preferredLanguage() ];
//            console.log(vm.getSettingValue('global', 'defaultLang', sessionService.getLanguage()));

            vm.selectedLanguage = vm.languages[sessionService.getLanguage()];
            $rootScope.$watch("global.titleToolbar", function (newVal, oldVal) {
                vm.titleToolbar = newVal;
            })
            $rootScope.$on('site:loadStartDomain', function (event, data) {
                vm.selectedLanguage = vm.languages[sessionService.getLanguage()];
            });
        }

        function openAiSidenav(){
            $rootScope.openedAi = !$rootScope.openedAi;
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId)
                .toggle();
        }

        function openPassDialog(ev) {
            $mdDialog.show({
                controller: 'ChangePassDialogcontroller',
                controllerAs: 'vm',
                locals: {
                    user: vm.user
                },
                templateUrl: 'app/toolbar/dialogs/change-password/change-password.html',
                targetEvent: ev,
                multiple: true,
                clickOutsideToClose: false
            }).then(function (response) {
                if (response) {
                    vm.loadPages();
                }
            });
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status) {
            vm.userStatus = status;
        }

        /**
         * Logout Function
         */
        function logout() {

            // Do logout here..
        }

        /**
         * Change Language
         */
        function changeLanguage(lang) {
            vm.selectedLanguage = lang;
            sessionService.changeLanguage(lang.code)
            settingUserService.setSetting('global', 'defaultLang', lang.code)
            //!-- Deprecated - Now is used in sessionService

            /**
             * Show temporary message if user selects a language other than English
             *
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             *
            if ( lang.code !== 'en' )
            {
                var message = 'Qiu supports translations, but currently we do not have all translations completely. If you want to help us, send us a message please.';

                $mdToast.show({
                    template : '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                    hideDelay: 7000,
                    position : 'top right',
                    parent   : '#content'
                });

                // return;
            }
            */
            // Change the language
            // $translate.use(lang.code);
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu() {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(msApi)
    {
        var vm = this;

        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };

        msApi.request('quickPanel.activities@get', {},
            // Success
            function (response)
            {
                vm.activities = response.data;
            }
        );

        msApi.request('quickPanel.events@get', {},
            // Success
            function (response)
            {
                vm.events = response.data;
            }
        );

        msApi.request('quickPanel.notes@get', {},
            // Success
            function (response)
            {
                vm.notes = response.data;
            }
        );

        // Methods

        //////////
    }

})();
(function() {
    'use strict';

    angular
        .module('Qiu')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope, sessionService, $location, $timeout, $state, $mdSidenav) {
        // Data
        var vm = this;

        function init(){

                    var lang = window.navigator.languages ? window.navigator.languages[0] : null;
                    lang = lang || window.navigator.language || window.navigator.browserLanguage || window.navigator.userLanguage;
                    if (lang.indexOf('-') !== -1)
                        lang = lang.split('-')[0];

                    if (lang.indexOf('_') !== -1)
                        lang = lang.split('_')[0];

                    sessionService.set("language", lang);

                    // analyticsService.identifyUser(sessionService.user,
                    //     sessionService.subscription);

                    //TODO: move to a service! it's probably not a good idea to rely on inheritence for roles :(
                    //Roles for enterprise

                    //company roles for Enterprise
                    $scope.user = sessionService.user;
                    $scope.domains = sessionService.domains;

                    // window.Intercom("boot", {
                    //   app_id: "mtz9br56",
                    //   name: $scope.user.displayName, // TODO: The current logged in user's full name
                    //   email: $scope.user.email, // TODO: The current logged in user's email address.
                    //   created_at: 1312182000 // TODO: The current logged in user's sign-up date as a Unix timestamp.
                    // });

                    $scope.isAdmin = ($scope.isEnterprise && $scope.user.companyMembership
                        .roleID === userService.ROLES.ADMIN);
                    $scope.isManager = ($scope.isEnterprise && $scope.user.companyMembership
                        .roleID === userService.ROLES.MANAGER);
                    $scope.isContributor = ($scope.isEnterprise && $scope.user.companyMembership
                        .roleID === userService.ROLES.CONTRIBUTOR);
                    $scope.isReviewer = ($scope.isEnterprise && $scope.user.companyMembership
                        .roleID === userService.ROLES.REVIEWER);

                    // Set scope Domain
                    setDomain()

                                        $rootScope.$broadcast('msSplashScreen::remove');

                    // can the user view all projects
                    // $scope.canViewAllProjects = canViewAllProjects();

                    // if admin or manager, redirect to dashboard
                    // if (($scope.isAdmin || $scope.isManager) &&
                    //     initiallyRequestedRoute === " /") {
                    //     $location.path("/dashboard");
                    //     return;
                    // }

                    // Try to send the user back to the page they first requested.
                    // $location.path(initiallyRequestedRoute);

                    // start polling intercom for user messages every 30 seconds
                    // intercomPoll(30 * 1000);
        }

        // Deprecated !! - Added to Resolve route dependencies
        // 
        // I try to authenticate the current session. If the user cannot be authenticated, the browser
        // is redirected to the root page where the server-side framework can route it appropriately.
        function authenticateSession() {

            $rootScope.$emit('site:loadStart', "");

            // Try to authenticate the current session.
            sessionService.authenticate().then(
                function() {


                    // if (!_.isUndefined(config.newSignupForPlan)) {

                    //     sessionService.set("showUpgradeModalForPlan", config.newSignupForPlan);

                    // }

                    // if (!_.isUndefined(config.newSignupForPlan)) {

                    //     sessionService.set("showUpgradeModalForPlan", config.newSignupForPlan);

                    // }

                    var lang = window.navigator.languages ? window.navigator.languages[0] : null;
                    lang = lang || window.navigator.language || window.navigator.browserLanguage || window.navigator.userLanguage;
                    if (lang.indexOf('-') !== -1)
                        lang = lang.split('-')[0];

                    if (lang.indexOf('_') !== -1)
                        lang = lang.split('_')[0];

                    sessionService.set("language", lang);

                    // analyticsService.identifyUser(sessionService.user,
                    //     sessionService.subscription);

                    //TODO: move to a service! it's probably not a good idea to rely on inheritence for roles :(
                    //Roles for enterprise

                    //company roles for Enterprise
                    $scope.user = sessionService.user;
                    $scope.domains = sessionService.domains;

                    // window.Intercom("boot", {
                    //   app_id: "mtz9br56",
                    //   name: $scope.user.displayName, // TODO: The current logged in user's full name
                    //   email: $scope.user.email, // TODO: The current logged in user's email address.
                    //   created_at: 1312182000 // TODO: The current logged in user's sign-up date as a Unix timestamp.
                    // });

                    $scope.isAdmin = ($scope.isEnterprise && $scope.user.companyMembership
                        .roleID === userService.ROLES.ADMIN);
                    $scope.isManager = ($scope.isEnterprise && $scope.user.companyMembership
                        .roleID === userService.ROLES.MANAGER);
                    $scope.isContributor = ($scope.isEnterprise && $scope.user.companyMembership
                        .roleID === userService.ROLES.CONTRIBUTOR);
                    $scope.isReviewer = ($scope.isEnterprise && $scope.user.companyMembership
                        .roleID === userService.ROLES.REVIEWER);

                    // Set scope Domain
                    setDomain()

                    // can the user view all projects
                    // $scope.canViewAllProjects = canViewAllProjects();

                    // if admin or manager, redirect to dashboard
                    // if (($scope.isAdmin || $scope.isManager) &&
                    //     initiallyRequestedRoute === " /") {
                    //     $location.path("/dashboard");
                    //     return;
                    // }

                    // Try to send the user back to the page they first requested.
                    // $location.path(initiallyRequestedRoute);

                    // start polling intercom for user messages every 30 seconds
                    // intercomPoll(30 * 1000);

                },
                function() {
                    $scope.$emit("site:loginRequired");
                    $rootScope.$broadcast('msSplashScreen::remove');
                    // Couldn't login for some reason - kick the user back to the login page.
                    // window.location.href = "./";

                }
            );

        }


        function setDomain() {

            $scope.site_operative = sessionService.site_operative;
            $scope.modulecontent = sessionService.modulecontent;




        }

        function setModules() {
            $scope.modulecontent = sessionService.modulecontent;

            // $state.go('site_overview', {siteId: sessionService.site_operative.subdomain, bar: 1});

        }

        // authenticateSession(); !! DEPRECATED
        init();

        //////////


        // Set active Domain
        $scope.setDomain = function(domain) {
            $scope.loadingScreen = true;

            $rootScope.$broadcast('msSplashScreen::add');

            sessionService.setActiveDomain(domain).then(
                function() {
                    setDomain();
                    $rootScope.$emit('site:loadStartDomain', domain);
                    sessionService.setModuleSection(domain).then(function() {
                        setModules()
                    })


                    // $state.go('site_overview.dashboard', {
                    $state.go('app.dashboards', {
                        siteId: domain.subdomain,
                        bar: 1
                    });
                },
                function() {
                    $rootScope.$emit('site:loadFinished', domain);

                    toastr.error("error", "response.status");
                    // Couldn't login for some reason - kick the user back to the login page.
                    // window.location.href = "./";

                }
            );


        };

        $scope.setDomain1 = function(domain) {
            $rootScope.$broadcast('msSplashScreen::add');
            $timeout(function() {
                $rootScope.$broadcast('msSplashScreen::remove');
            }, 2000);
        }

        $scope.isInAppMode = false;

        $scope.isAuthenticated = function() {
            return $auth.isAuthenticated();
        };

        $rootScope.$on('site:loginRequired', function(event) {
            $scope.loadPageMessage = "";
            $scope.isLoaded = true;
        });
        $rootScope.$on('site:loadStart', function(event) {
            $scope.isLoaded = false;
            $rootScope.loadPageMessage = "Autenticando";
        });
        $rootScope.$on('site:loadStartDomain', function(event, data) {
            $scope.isLoaded = false;
            $rootScope.loadPageMessage = "Loading site: " + data.subdomain;
        });
        $rootScope.$on('site:loadFinished', function(event) {
            
            $rootScope.$broadcast('msSplashScreen::remove');

            $timeout(function() {
                $rootScope.loadPageMessage = "";
                $scope.isLoaded = true;
            }, 0);

        });

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function(event) {
            if (event.targetScope.$id === $scope.$id) {

            }
        });

        $scope.closeToast   = function() {
            if (isDlgOpen) return;

            $mdToast
                .hide()
                .then(function() {
                    isDlgOpen = false;
                });
        };

    }


})();

(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function () {
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope, $mdSidenav, $mdMedia, $cookies, $location) {
        var vm = this;

        if($location.host() === 'panel.runtag.app'){
            vm.logoURL = "/assets/images/logos/runtag-logo.png";
            vm.siteName = "Runtag";
            vm.translateSiteName = "LOGIN.INTRO_TITLER";
          }else{
            vm.logoURL = "/assets/images/logos/qiusystem-logo.png";
            vm.siteName = "Qiu";
            vm.translateSiteName = "LOGIN.INTRO_TITLEQ";
          }

        // Data
        vm.bodyEl = angular.element('body');
        // vm.folded = true;
        if ($cookies.get('navigationFolded')) {
            vm.folded = $cookies.get('navigationFolded');
        } else {
            vm.folded = 'folded';
            $cookies.put('navigationFolded', vm.folded);
        }

        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded() {
            if (vm.folded == 'folded') {
                vm.folded = 'no';
            } else {
                vm.folded = 'folded';
            }
            $cookies.put('navigationFolded', vm.folded);
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function () {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });

        // $scope.$watch(function() { return $mdMedia('sm'); }, function(big) {
        //     vm.folded=true;
        // });

        // $scope.$watch(function() { return $mdMedia('lg'); }, function(big) {
        //     vm.folded=false;
        // });
    }

})();
( function ()
{
  'use strict';

  angular
    .module( 'app.core' )
    .run( runBlock );

  /** @ngInject */
  function runBlock( msUtils, QiuGenerator, QiuConfig, sessionService )
  {
    /**
     * Generate extra classes based on registered themes so we
     * can use same colors with non-angular-material elements
     */
    QiuGenerator.generate();

    /**
     * Disable md-ink-ripple effects on mobile
     * if 'disableMdInkRippleOnMobile' config enabled
     */
    // if ( QiuConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
    // {
    var bodyEl = angular.element( 'body' );
    bodyEl.attr( 'md-no-ink', true );
    // }

    /**
     * Put isMobile() to the html as a class
     */
    if ( msUtils.isMobile() )
    {
      angular.element( 'html' )
        .addClass( 'is-mobile' );
    }

    /**
     * Put browser information to the html as a class
     */
    var browserInfo = msUtils.detectBrowser();
    if ( browserInfo )
    {
      var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
      angular.element( 'html' )
        .addClass( htmlClass );
    }

    // Set Language
    sessionService.changeLanguage();

  }
} )();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('requestHeaderIdUserTab', requestHeaderIdUserTab, ['$rootScope', '$location'])
    .factory('missingTranslationHandler', missingTranslationHandler)
    .config(config);

  /** @ngInject */
  function config($ariaProvider, $logProvider, msScrollConfigProvider,
    //uiGmapGoogleMapApiProvider,
    $translateProvider, $provide, QiuConfigProvider, $mdDateLocaleProvider, $httpProvider) {

    // Enable debug logging
    $logProvider.debugEnabled(true);

    // toastr configuration
    toastr.options.timeOut = 3000;
    toastr.options.positionClass = 'toast-top-right';
    toastr.options.preventDuplicates = true;
    toastr.options.progressBar = true;

    // $mdDateLocaleProvider
    // $mdDateLocaleProvider.formatDate = function(date) {
    //     console.debug("DATE:::::" + date)
    //     var formatted=moment(date).format('L LTS');
    //     console.debug("FORMADATE:::::" + formatted)
    //     return formatted;
    // };


    // uiGmapgoogle-maps configuration
    // uiGmapGoogleMapApiProvider.configure({
    //        key: 'AIzaSyByByR4p9MOOk-j3hpduPBEQzd0Ml5Evcs',
    //     v        : '3.exp',
    //     libraries: 'weather,geometry,visualization,places'
    // });

    // angular-translate configuration
    $translateProvider.useLoader('$translatePartialLoader',
      {
        urlTemplate: '{part}/i18n/{lang}.json'
      });
    const langBrowser = navigator.language.split('-')[0];
    if (['es', 'fr', 'en'].indexOf(langBrowser) >= 0) {
      $translateProvider.preferredLanguage(langBrowser);
    } else {
      $translateProvider.preferredLanguage('en');
    }
    $translateProvider.useSanitizeValueStrategy('sanitize');

    $translateProvider.useMissingTranslationHandler('missingTranslationHandler');

    // Text Angular options
    $provide.decorator('taOptions', [
      '$delegate',
      function (taOptions) {
        taOptions.toolbar = [
          ['bold', 'italics', 'underline', 'ul', 'ol', 'quote']
        ];

        taOptions.classes = {
          focussed: 'focussed',
          toolbar: 'ta-toolbar',
          toolbarGroup: 'ta-group',
          toolbarButton: 'md-button',
          toolbarButtonActive: 'active',
          disabled: '',
          textEditor: 'form-control',
          htmlEditor: 'form-control'
        };

        return taOptions;
      }
    ]);

    // Text Angular tools
    $provide.decorator('taTools', [
      '$delegate',
      function (taTools) {
        taTools.bold.iconclass = 'icon-format-bold';
        taTools.italics.iconclass = 'icon-format-italic';
        taTools.underline.iconclass = 'icon-format-underline';
        taTools.ul.iconclass = 'icon-format-list-bulleted';
        taTools.ol.iconclass = 'icon-format-list-numbers';
        taTools.quote.iconclass = 'icon-format-quote';

        return taTools;
      }
    ]);

    /*eslint-disable */

    // ng-aria configuration
    $ariaProvider.config(
      {
        tabindex: false
      });

    // Qiu theme configurations
    QiuConfigProvider.config(
      {
        'disableCustomScrollbars': false,
        'disableCustomScrollbarsOnMobile': true,
        'disableMdInkRippleOnMobile': true
      });

    // msScroll configuration
    msScrollConfigProvider.config(
      {
        wheelPropagation: true
      });


    $httpProvider.interceptors.push(function ($q, $rootScope, $location) {
      return {
        request: function (config) {
          // Skip custom headers for external third-party APIs (e.g. AWS API Gateway)
          if (config.url && config.url.indexOf('amazonaws.com') !== -1) {
            return config;
          }
          if (!angular.isUndefined($rootScope.idUserTab)) {
            config.headers["Qiu-IdUsersTabs"] = $rootScope.idUserTab;
          } else {
            config.headers["Qiu-IdUsersTabs"] = 1;
          }
          if (!angular.isUndefined($rootScope.idUserTab) && config.url == "https://v3-api-staging.qiusystem.com/api/v1/domain/sports_temp/content/crm_tasks") {
            config.headers["Qiu-IdUsersTabs"] = 2933;
          }
          return config;
        }
      }
    });
    /*eslint-enable */
  }

  function requestHeaderIdUserTab($rootScope, $location) {

    return {
      request: function (config) {
        if (!angular.isUndefined($rootScope.isUserTab)) {
          $location.hash('idUserTab:' + $rootScope.isUserTab)
          config.headers["Qiu-IdUsersTabs"] = $rootScope.isUserTab;
        }
        if (!angular.isUndefined($rootScope.idUserTab) && config.url == "https://v3-api-staging.qiusystem.com/api/v1/domain/sports_temp/content/crm_tasks") {
          config.headers["Qiu-IdUsersTabs"] = 2933;
        }
        return config;
      }
    }
  }

  // If $translate can't find any translation for the translation Id then the 
  // missingTranslationHandler return only the last term of the Id instead of full Id.
  // E.g. instead of "USER.INGROUP.STATUS.SUSPENDED" returns "Suspended".
  // Returns a string with first character in upper case and the rest in lower case.
  function missingTranslationHandler() {
    return function (translationID) {
      if (typeof translationID === 'string' && translationID.indexOf('.') !== -1) {
        var parts = translationID.split(".");
        var lastPart = parts[parts.length - 1];
        return lastPart.charAt(0).toUpperCase() + lastPart.slice(1).toLowerCase()
      }
      return translationID;
    };
  };

})();

(function ()
{
    'use strict';

    angular
        .module('app.domain-panel')
        .controller('DomainPanelController', DomainPanelController);

    /** @ngInject */
    function DomainPanelController(msApi)
    {
        var vm = this;

        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };


        // Methods

        //////////
    }

})();
angular.module("ngConstants", [])

.constant("COMMON", {
	"GOOGLE_CLIENTID": "68983842535-tv1iubu08suhj18o0lb9qllngiisnei9.apps.googleusercontent.com",
	"GOOGLE_URL": "",
	"BASE_API": "https://v3-api.qiusystem.com/api/v1",
	"IPKEY": "ef96fbc7812def",
	"FBAPPID": "299636007161522",
	"STRIPE_KEY": "pk_test_DSv8XaiBKLSQjALxpYiGbK9D",
	"URL_ASSETS": "http://test.dev/assets/",
	"PUSHER_APP_KEY": "9ed850888b3a53c7b8b1",
	"PUSHER_AUTH_ENDPOINT": "https://v3-api.qiusystem.com/broadcasting/auth",
	"DEBUG": false
})

.constant("ENV", "production")

;
(function () {
    'use strict';

    angular
        .module('Qiu')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state) {
        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
            $rootScope.loadingProgress = true;
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
            $timeout(function () {
                $rootScope.loadingProgress = false;
            });
        });

        /**
         * Helper to get the module name from state name
         * Pattern: app.site_overview.MODULE or app.MODULE
         */
        function getModuleName(state) {
            if (!state || !state.name) return null;
            var parts = state.name.split('.');
            if (parts[0] === 'app') {
                if (parts[1] === 'site_overview' && parts.length > 2) {
                    return parts[2];
                }
                return parts[1] || 'app';
            }
            return parts[0];
        }

        // Clear search when switching modules
        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
            var fromModule = getModuleName(fromState);
            var toModule = getModuleName(toState);

            if (fromModule && toModule && fromModule !== toModule) {
                $rootScope.modelSearch = '';
                $rootScope.pagination_searchstring = '';
                $rootScope.pagination_searchquery = false;
                $rootScope.pagination_page = 1;
                $rootScope.pagination_galleryIds = false;
            }
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function () {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });
    }
})();

(function () {
	'use strict';

	angular
		.module('Qiu')
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider, $locationProvider, $authProvider, COMMON) {
		// Prevent erratic behavior at close Sattelizer Authenticate
		$locationProvider.html5Mode(true).hashPrefix('!');


		$urlRouterProvider.otherwise(function(){
			return '/dashboard';
		});

		/**
		 * Layout Style Switcher
		 *
		 * This code is here for demonstration purposes.
		 * If you don't need to switch between the layout
		 * styles like in the demo, you can set one manually by
		 * typing the template urls into the `State definitions`
		 * area and remove this code
		 */
		// Inject $cookies
		var $cookies;

		angular.injector(['ngCookies'])
			.invoke([
            '$cookies',
            function (_$cookies) {
					$cookies = _$cookies;
            }
        ]);

		// Get active layout
		var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

		var layouts = {
			verticalNavigation: {
				main: 'app/core/layouts/vertical-navigation.html',
				toolbar: 'app/toolbar/layouts/vertical-navigation/toolbar.html',
				navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
			},
			horizontalNavigation: {
				main: 'app/core/layouts/horizontal-navigation.html',
				toolbar: 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
				navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
			},
			contentOnly: {
				main: 'app/core/layouts/content-only.html',
				toolbar: '',
				navigation: ''
			},
			contentWithToolbar: {
				main: 'app/core/layouts/content-with-toolbar.html',
				toolbar: 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
				navigation: ''
			}
		};
		// END - Layout Style Switcher

		// State definitions
		$stateProvider
			.state('app', {
				abstract: true,
				views: {
					'main@': {
						templateUrl: layouts[layoutStyle].main,
						controller: 'MainController as vm'
					},
					'toolbar@app': {
						templateUrl: layouts[layoutStyle].toolbar,
						controller: 'ToolbarController as vm'
					},
					'navigation@app': {
						templateUrl: layouts[layoutStyle].navigation,
						controller: 'NavigationController as vm'
					},
					'quickPanel@app': {
						templateUrl: 'app/quick-panel/quick-panel.html',
						controller: 'QuickPanelController as vm'
					},
					'domainPanel@app': {
						templateUrl: 'app/domain-panel/domain-panel.html',
						controller: 'DomainPanelController as vm'
					}
				},
				resolve: {
					loginRequired: loginRequired,
					sessionAuth: function (sessionService, $rootScope, indexService, $state) {
						$rootScope.$emit('site:loadStart', "")
						return sessionService.authenticate().then(function() {
							return indexService.setIdUserTab($state)
						})
					}
				}
			});

		$stateProvider
			.state('app.site_overview', {
				url: '/domain/:siteId',
				// controller: 'siteOverviewController',
				// templateUrl: '/modules/site/overview/views/site_overview.html',
				// action: "site_overview",
				// abstract: true,

				data: {
					displayName: '{{site}}'
				},
				resolve: {
					site: function ($stateParams, $q, sessionService) {
//						console.log($stateParams.siteId)
						return $stateParams.siteId;

						// setTimeout(function() {
						//     return $stateParams.siteId}, 1000);

					},
// 					sessionAuth: function ($stateParams, sessionService, $rootScope, requestContext) {
// //						console.log($stateParams)
// 						var siteID = requestContext.getParam("siteId");

// 						$rootScope.$emit('site:loadStart', "")
// 						return sessionService.authenticate($stateParams.siteId).then(
//                 function(data, user) {
// //									console.log(data)
// //									console.log(user)
// 								});
// 					}
				},
				// templateUrl: global_itc_path + '/ra/apps/views/appOverviewHtml',
				// controller: 'appOverviewController',
				// abstract:true,
				// resolve: route.resolve(global_itc_path + '/ra/apps/controllers/appOverviewController',false)
			})

		$stateProvider
			.state('public', {
				abstract: true,
				views: {
					'main@': {
						templateUrl: layouts[layoutStyle].main,
						controller: 'MainController as vm'
					},
					'toolbar@app': {
						templateUrl: layouts[layoutStyle].toolbar,
						controller: 'ToolbarController as vm'
					},
					'navigation@app': {
						templateUrl: layouts[layoutStyle].navigation,
						controller: 'NavigationController as vm'
					},
					'quickPanel@app': {
						templateUrl: 'app/quick-panel/quick-panel.html',
						controller: 'QuickPanelController as vm'
					}
				},
				resolve: {
					loginRequired: skipIfLoggedIn
				}
			});


		//         $stateProvider..state('logout', {
		//                 url: '/logout',
		//                 template: null,
		//                 controller: 'LogoutCtrl'
		//             })



		$authProvider.httpInterceptor = true;
		$authProvider.withCredentials = true;
		$authProvider.blacklistDomains = ['execute-api.us-east-1.amazonaws.com'];
		$authProvider.tokenRoot = null;
		$authProvider.cordova = false;
		$authProvider.baseUrl = COMMON.BASE_API;
		$authProvider.loginUrl = '/auth/login';
		$authProvider.signupUrl = '/auth/signup';
		$authProvider.unlinkUrl = '/auth/unlink/';
		$authProvider.tokenName = 'token';
		$authProvider.tokenPrefix = 'satellizer';
		$authProvider.authHeader = 'Authorization';
		$authProvider.authToken = 'Bearer';
		$authProvider.storageType = 'localStorage';


		// Google
		$authProvider.google({
			url: '/auth/google',
			authorizationEndpoint: 'https://accounts.google.com/o/oauth2/auth',
			redirectUri: window.location.origin,
			requiredUrlParams: ['scope'],
			optionalUrlParams: ['display'],
			scope: ['profile', 'email'],
			scopePrefix: 'openid',
			scopeDelimiter: ' ',
			display: 'popup',
			type: '2.0',
			clientId: COMMON.GOOGLE_CLIENTID,

			popupOptions: {
				width: 452,
				height: 633
			}
		});

		// Facebook
		$authProvider.facebook({
      name: 'facebook',
      url: '/auth/facebook',
      authorizationEndpoint: 'https://www.facebook.com/v2.5/dialog/oauth',
      redirectUri: window.location.origin + '/',
      requiredUrlParams: ['display', 'scope'],
      scope: ['email'],
      scopeDelimiter: ',',
      display: 'popup',
      oauthType: '2.0',
      popupOptions: {
        width: 580,
        height: 400
      },
			clientId: COMMON.FBAPPID,
		});

		function skipIfLoggedIn($q, $auth) {
			var deferred = $q.defer();
			if ($auth.isAuthenticated()) {
				deferred.reject();
			} else {
				deferred.resolve();
			}
			return deferred.promise;
		}

		function loginRequired($q, $location, $auth) {
			var deferred = $q.defer();
			if ($auth.isAuthenticated()) {
				deferred.resolve();
			} else {
				$location.path('/login');
			}
			return deferred.promise;
		}
	}

})();

(function ()
{
    'use strict';

    angular
        .module('Qiu')
        .service('indexService', indexService)
        .controller('IndexController', IndexController)
        .filter('capitalizeFirstLetter', function() {
            return function(input) {
              return (!!input) ? input.charAt(0).toUpperCase() : '';
            }
        });

    /** @ngInject */
    // I provide access to the session store.
    function indexService(msNavigationService, $rootScope, $window, sessionService, $q, $resource, COMMON) {

        return ({
            setIdUserTab: setIdUserTab,
            sendMessageToAi: sendMessageToAi,
            aiTextTranslate: aiTextTranslate(),
            aiTextTranslateAsync: aiTextTranslateAsync,
            aiTextTranslateJobs: aiTextTranslateJobs,
            getAiModels: getAiModels
        });

        function setIdUserTab(state) {

            var deferred = $q.defer();
                    // Handle possible domain change in the request url
            var storedDomainStr = $window.sessionStorage.getItem("domain");
            if (storedDomainStr && sessionService.domains && sessionService.domains.length > 0) {
                var storedDomain = JSON.parse(storedDomainStr);
                var requestDomain = sessionService.domains.find(function(domain) {
                    return domain.domain_name == state.toParams.siteId
                });
                if (storedDomain.domain_name && requestDomain && (storedDomain.domain_name !== requestDomain.domain_name)) {
                    // Update active domain since the stored domain does NOT match the domain from the requested url.
                    sessionService.setActiveDomain(requestDomain);
                }
            }
            // Update the current request action change.
            // console.log("set context", $state.current.name)
            // console.log("set context", $stateParams)
            angular.forEach(msNavigationService.getNavigationObject(), function(navContainers) {
              if (!angular.isUndefined(navContainers.children))
              {
                angular.forEach(navContainers.children, function(tabs) {
                  if (!angular.isUndefined(tabs.children))
                  {
                    angular.forEach(tabs.children, function(item) {
                      if (item.qiuStateName == state.next.name)
                      {
                        if (item.qiuModuleName == 'content' || item.qiuModuleName == 'users' || item.qiuModuleName == 'media') {
                          var sp  = angular.copy(state.toParams);
                          if (angular.equals(item.qiuStateParams,sp)) {
                            $rootScope.idUserTab  = item.idUserTab;
                          }
                        } else {
                          $rootScope.idUserTab  = item.idUserTab;
                        }
                      } else if (!angular.isUndefined(state.toParams.id) && state.next.name.indexOf(item.qiuStateName) > -1) {
                        var sp  = angular.copy(state.toParams);
                        delete sp.id;
                        if (item.qiuModuleName != 'content' || item.qiuModuleName != 'users' || !item.qiuModuleName == 'media')
                        {
                          $rootScope.idUserTab  = item.idUserTab;
                        } else {
                          if (angular.equals(item.qiuStateParams,sp)) {
                            $rootScope.idUserTab  = item.idUserTab;
                          }
                        }
                      }
                    })
                  }
                })
              }
            });
            deferred.resolve();
            return (deferred.promise);
        }

        function sendMessageToAi(options){
          var resourcePostAiMessage = $resource(
            COMMON.BASE_API + "/domain/:domain/ai/translate",{
              domain: '@domain'
            },
            {
              post: {
                method: "POST"
              }
            }
          )
          var deferred = $q.defer();
          resourcePostAiMessage.post(options,
            function(response){
              deferred.resolve(response);
            },
            function(e){
              console.error('ERROR ==================>');
              console.error(e);
              deferred.reject(e);
            }
          );
          return (deferred.promise);
        }

        function aiTextTranslate() {

          var resourceAiTextTranslate = $resource(
            COMMON.BASE_API + "/domain/:domain/text/translate", {
              domain: '@domain'
            },
            {
              post: {
                method: "POST"
              }
            }
          );

          let queue = [];
          let isProcessing = false;
      
          function processQueue() {
              if (queue.length === 0) {
                  isProcessing = false;
                  return;
              }
              isProcessing = true;
              const { options, deferred } = queue.shift();
      
              resourceAiTextTranslate.post(options,
                  function (response) {
                      deferred.resolve(response);
                      processQueue();
                  },
                  function (e) {
                      console.error('ERROR ==================>');
                      console.error(e);
                      deferred.reject(e);
                      processQueue();
                  }
              );
          }
      
          return function (options) {
              const deferred = $q.defer();
              queue.push({ options, deferred });

              if (!isProcessing) {
                  processQueue();
              }

              return deferred.promise;
          };
      }

        /**
         * Queue translations of content records into other languages.
         *
         * Intent only: the API reads each record, translates the fields marked for AI
         * translation and creates the translated record itself. Unlike aiTextTranslate above
         * there is deliberately NO serial FIFO queue — these return immediately.
         *
         * options: {domain, section, source_ids: [], target_lang_ids: [], translate_service}
         * resolves with the created job rows
         */
        function aiTextTranslateAsync(options) {
          var resource = $resource(
            COMMON.BASE_API + "/domain/:domain/text/translate/async", {
              domain: '@domain'
            },
            {
              post: { method: "POST", isArray: true }
            }
          );
          var deferred = $q.defer();
          resource.post(options,
            function (response) { deferred.resolve(response); },
            function (e) {
              console.error('aiTextTranslateAsync failed:', e);
              deferred.reject(e);
            }
          );
          return (deferred.promise);
        }

        /**
         * Poll job state. Returns the light rows only (status/progress/context, no text),
         * so this is safe to call on an interval regardless of how large the fields are.
         *
         * options: {domain, 'ids[]': [1,2,3]}  or  {domain, pending: 1, section: 'news'}
         */
        function aiTextTranslateJobs(options) {
          var resource = $resource(
            COMMON.BASE_API + "/domain/:domain/text/translate/jobs", {
              domain: '@domain'
            },
            {
              get: { method: "GET", isArray: true }
            }
          );
          var deferred = $q.defer();
          resource.get(options,
            function (response) { deferred.resolve(response); },
            function (e) {
              console.error('aiTextTranslateJobs failed:', e);
              deferred.reject(e);
            }
          );
          return (deferred.promise);
        }

        function getAiModels(options){
          var resourceGetAiModels = $resource(
            COMMON.BASE_API + "/domain/:domain/ai/models",{
              domain: '@domain'
            },
            {
              get: {
                method: "GET",
                isArray: true
              }
            }
          )
          var deferred = $q.defer();
          resourceGetAiModels.get(options,
            function(response){
              deferred.resolve(response);
            },
            function (e){
              console.error("ERROR ================>");
              console.error(e);
              deferred.reject(e);
            }
          );
          return (deferred.promise);
        }
    }

    /** @ngInject */
    function IndexController(QiuTheming, $scope, requestContext, $state, $auth, $location, $stateParams, msNavigationService, $rootScope, $window, sessionService, indexService)
    {
        var vm = this;

        const favicon = document.getElementById('dynamic-favicon');
        if($location.host() === 'panel.runtag.app'){
          vm.logoURL = "/assets/images/logos/runtag-logo.png";
          $rootScope.pageTitle = "Runtag";
          vm.translateSiteName = "LOGIN.INTRO_TITLER";
          favicon.href = "assets/icons/runtagFavicon.png";
        }else{
          vm.logoURL = "/assets/images/logos/qiusystem-logo.png";
          $rootScope.pageTitle = "Qiu";
          vm.translateSiteName = "LOGIN.INTRO_TITLEQ";
          favicon.href = "assets/icons/favicon.png";
        }

        // Data
        vm.themes = QiuTheming.themes;
        $rootScope.aiShow = false;
        $rootScope.openedAi = false;
        vm.openAiSidenav = openAiSidenav;
        vm.aiNewMessage = "";
        vm.messages = [];
        vm.sendAiMessage = sendAiMessage;
        vm.checkEnter = checkEnter;
        $rootScope.aiModels = [];
        vm.loadingAiResponse = false;
        //////////

        // Listen for route changes so that we can trigger request-context change events.
        $scope.$on(
            "$stateChangeSuccess",
            // "$locationChangeSuccess",
            // "$routeChangeSuccess",
            function(event, currentRoute, previousRoute) {

                if(currentRoute.name === 'site_overview') {
                        $state.go('site_overview.dashboard')
                }


                $scope.currentPageName = $state.current.name;

                // If this is a redirect directive, then there's no action to be taken.
                // if (isRouteRedirect($state)) {
                    // return;
                // }

                // Check to make sure the session has been authenticated. If the session has not yet
                // been authenticated, we have to show the loading screen.
                // if (!sessionService.isAuthenticated()) {
                if (!$auth.isAuthenticated()) {
                    // An unauthenticated user can only see the loading screen.
                    if ($state.current.action !== "loading") {

                        // $state.go('login');
                        // Redirect to the loading sequence.
                        $rootScope.aiShow = false;
                        return (
                            $location.path("/login")
                        );

                    }

                    // If the user is authenticated, make sure they aren't going to the loading sequence.
                } else if ($state.current.action === "loading") {

                    // Redirect to the default page.
                    $rootScope.aiShow = false;
                    return (
                        $location.path("/")
                    );

                }else if(sessionService.user.is_admin){
                  $rootScope.aiShow = true;
                }

                // If we made it this far then the user has been authenticated and can view the
                // requested route.
/*
                // Handle possible domain change in the request url
                var storedDomainStr = $window.sessionStorage.getItem("domain");
                if (storedDomainStr && sessionService.domains && sessionService.domains.length > 0) {
                    var storedDomain = JSON.parse(storedDomainStr);
                    var requestDomain = sessionService.domains.find(function(domain) {
                        return domain.domain_name == $stateParams.siteId
                    });
                    if (storedDomain.domain_name && requestDomain && (storedDomain.domain_name !== requestDomain.domain_name)) {
                        // Update active domain since the stored domain does NOT match the domain from the requested url.
                        sessionService.setActiveDomain(requestDomain)
                    }
                }


                // Update the current request action change.
                // console.log("set context", $state.current.name)
                // console.log("set context", $stateParams)
                angular.forEach(msNavigationService.getNavigationObject(), function(navContainers) {
                  if (!angular.isUndefined(navContainers.children))
                  {
                    angular.forEach(navContainers.children, function(tabs) {
                      if (!angular.isUndefined(tabs.children))
                      {
                        angular.forEach(tabs.children, function(item) {
                          if (item.qiuStateName == $state.current.name)
                          {
                            if (item.qiuModuleName == 'content' || item.qiuModuleName == 'users') {
                              var sp  = angular.copy($stateParams);
                              if (angular.equals(item.qiuStateParams,sp)) {
                                $rootScope.idUserTab  = item.idUserTab;
                              }
                            } else {
                              $rootScope.idUserTab  = item.idUserTab;
                            }
                          } else if (!angular.isUndefined($stateParams.id) && $state.current.name.indexOf(item.qiuStateName) > -1) {
                            var sp  = angular.copy($stateParams);
                            delete sp.id;
                            if (item.qiuModuleName != 'content' || item.qiuModuleName != 'users' )
                            {
                              $rootScope.idUserTab  = item.idUserTab;
                            } else {
                              if (angular.equals(item.qiuStateParams,sp)) {
                                $rootScope.idUserTab  = item.idUserTab;
                              }
                            }
                          }
                        })
                      }
                    })
                  }
                });
*/
                requestContext.setContext($state.current.action, $stateParams);
                var siteID = $window.sessionStorage.getItem("domain");
                if(siteID){
                  let domain = JSON.parse(siteID);
                  if(domain.subdomain){
                    $scope.siteID = domain.subdomain;
                  }
                }
                if($scope.siteID){
                  indexService.getAiModels({
                    domain: $scope.siteID
                  }).then(response => {
                    delete response.$promise;
                    delete response.$resolved;
                    $rootScope.aiModels = response;
                  });
                }
                // Trigger the change in render conditions.
                $scope.$emit("requestContextChanged", requestContext);
            }
        );

        function openAiSidenav(){
          $rootScope.openedAi = !$rootScope.openedAi;
        }

        function sendAiMessage(){
          if(vm.aiNewMessage.trim() !== ''){
            vm.loadingAiResponse = true;
            indexService.sendMessageToAi({
              domain: $scope.siteID,
              body: vm.aiNewMessage,
              ai_models:[$rootScope.aiModels[0].model]
            }).then(response => {
              vm.messages.push({text: vm.aiNewMessage, sender: 'user'});
              vm.aiNewMessage = '';
              vm.messages.push({text:response.body[0].response, sender: 'ai'});
              vm.loadingAiResponse = false;
            });
          }
        }

        function checkEnter(event){
          if(event.which === 13){
            sendAiMessage();
            event.preventDefault();
          }
        }
    }
})();

(function() {
  'use strict';


  angular
    .module('Qiu');

})();

(function () {
    'use strict';

    angular
        .module('Qiu')
        // Exposed as a constant so anything that builds an API URL OUTSIDE $http routes
        // to the same backend the interceptor would have picked. The OAuth popup is the
        // case that matters: it is opened with $window.open, which no $http interceptor
        // can touch, so it silently kept hitting old prod.
        .constant('CANARY_ROUTING', {
            // Add a tenant subdomain to failover THAT ONE tenant back to old prod
            // (L5.6 / PHP 7.1). Empty list = full cutover.
            LEGACY_PROD_TENANTS: [],
            CANARY_BASE_API: 'https://canary-api.qiusystem.com/api/v1',
            // A BASE_API matching this is a developer's local backend, never canary.
            LOCAL_API_PATTERN: /localhost|127\.0\.0\.1|\.local(?::\d+)?(?:\/|$)/
        })
        .factory('httpResponse401Interceptor', httpResponse401Interceptor, ['$q', '$location', '$injector', 'COMMON'])
        .config(config);

    function httpResponse401Interceptor($q, $location, $injector, COMMON) {
        return {
            responseError: function(rejection) {
                if (rejection.status === 401 && rejection.config.url.startsWith(COMMON.BASE_API)) {
                    const auth = $injector.get('$auth');
                    const wind = $injector.get('$window');
                    /*
                    // Force logout
                    auth.logout().then(function () {
                        Object.keys(wind.sessionStorage).forEach(function (k) {
                            wind.sessionStorage.removeItem(k);
                        });
                        $location.path('/login');
                    });
                    */
                    var $mdToast = $injector.get('$mdToast');
                    var message = "Api error";
                    if (rejection && rejection.data && rejection.data.detail) {
                        message += ":<br>"+rejection.data.detail;
                    }
                    $mdToast.show({
                        template: '<md-toast id="language-message" layout="column" layout-align="center center"><div class="md-toast-content red-500-bg"><md-icon md-font-icon="icon-alert" class="icon"></md-icon><span class="md-toast-text" flex>' + message + '</span></div></md-toast>',
                        hideDelay: 10000,
                        position: 'top',
                        parent: '#content-container'
                    });
                }
                return $q.reject(rejection);
            }
        };
    }

    /** @ngInject */
    function config($httpProvider, $logProvider, $provide, COMMON, ivhTreeviewOptionsProvider, CANARY_ROUTING) {


        ivhTreeviewOptionsProvider.set({
            defaultSelectedState: false,
            validate: true,
            expandToDepth: -1,
            twistieCollapsedTpl: '<md-icon md-svg-icon="assets/angular-material-assets/img/icons/ic_chevron_right_24px.svg"></md-icon>',
            twistieExpandedTpl: '<md-icon md-svg-icon="assets/angular-material-assets/img/icons/ic_expand_more_black_24px.svg"></md-icon>',
            twistieLeafTpl: '<span style="cursor: default;">&#8192;&#8192;</span>'
        });


        var debug = COMMON.DEBUG ? COMMON.DEBUG : false;
        $logProvider.debugEnabled(debug);

        $provide.decorator('$log', function ($delegate) {
            //Original methods
            var origInfo = $delegate.info;
            var origLog = $delegate.log;

            //Override the default behavior
            $delegate.info = function () {

                if ($logProvider.debugEnabled())
                    origInfo.apply(null, arguments)
            };

            //Override the default behavior    
            $delegate.log = function () {

                if ($logProvider.debugEnabled())
                    origLog.apply(null, arguments)
            };

            return $delegate;
        });

        $provide.decorator('$state', function($delegate, $rootScope) {
            $rootScope.$on('$stateChangeStart', function(event, state, params) {
              $delegate.next = state;
              $delegate.toParams = params;
            });
            return $delegate;
          });

        // I create the interceptor for 401-unauthorized responses.
        var httpInterceptorFor401Response = function ($window, $q) {

            // The interceptor gets the request (promise object) and can bind to the callbacks.
            var interceptor = function (request) {

                var interceptedResponse = request.then(

                    function () {

                        // Pass successful request through.
                        return (request);

                    }, function (httpResponse) {

                        // If the response code is 401, then the user is not authorized to be using
                        // the application (perhaps they were kicked out or logged out from another
                        // location). In any case, redirect the user to the root page so the server
                        // has a change to deal with the authentication issue.
                        if (httpResponse.status === 401) {

                            // Put a pause on the redirect since we are in the middle of a digest and
                            // we dont' want to interrupt that.
                            $window.setTimeout(

                                function () {

                                    $window.location.href = "./";

                                }, 100);

                            // Return a promise that will not be resolved in time. This is to make
                            // sure that the calling context doesn't try to process the response AS
                            // we are redirecting.
                            return ($q.defer().promise);

                        }

                        // Pass failed request through.
                        return (request);

                    });

                // Return the intercepted promise, for the other interceptors in the chain.
                return (interceptedResponse);

            };

            // Return the interceptor.
            return (interceptor);

        };


        // I create the interceptor for tracking HTTP activity.
        // var httpInterceptorForHttpActivityTracking = function(httpActivityService) {

        //     // The interceptor gets the request (promise object) and can bind to the callbacks.
        //     var interceptor = function(request) {

        //         request.then(

        //             function(httpResponse) {

        //                 var isPostRequest = (httpResponse.config.method !== "GET");
        //                 var isBlacklisted = (httpResponse.config.data && ("X-Do-Not-Track-As-Post" in httpResponse.config.data));
        //                 var trackAsPost = (isPostRequest && !isBlacklisted);

        //                 httpActivityService.requestCompleted(trackAsPost);

        //             }, function(httpResponse) {

        //                 var isPostRequest = (httpResponse.config.method !== "GET");
        //                 var isBlacklisted = (httpResponse.config.data && ("X-Do-Not-Track-As-Post" in httpResponse.config.data));
        //                 var trackAsPost = (isPostRequest && !isBlacklisted);

        //                 httpActivityService.requestCompleted(trackAsPost);

        //             });

        //         // Return the original request - we're not modifying it at all.
        //         return (request);

        //     };

        //     // Return the interceptor.
        //     return (interceptor);

        // };


        // Post-cutover routing (2026-08-26):
        // Every tenant runs on canary (L11 / PHP 8.3 / AL2023) by default.
        // Add a tenant subdomain to LEGACY_PROD_TENANTS to failover THAT ONE
        // tenant back to old prod (L5.6 / PHP 7.1) — targeted rollback while
        // investigating a canary-only bug. Empty list = full cutover.
        // See runbook Phase F.1.
        // Single source of truth: see the CANARY_ROUTING constant above.
        var LEGACY_PROD_TENANTS = CANARY_ROUTING.LEGACY_PROD_TENANTS;
        var CANARY_BASE_API     = CANARY_ROUTING.CANARY_BASE_API;
        var LOCAL_API_PATTERN   = CANARY_ROUTING.LOCAL_API_PATTERN;

        var canaryTenantRerouteInterceptor = function () {
            return {
                request: function (config) {
                    if (!config || !config.url) return config;
                    // Local development points COMMON.BASE_API at a .local / localhost /
                    // 127.0.0.1 API. Rewriting those to canary makes it impossible to run
                    // the admin against a local backend at all, so leave them alone. Inert
                    // in production, where BASE_API is the public https host.
                    if (LOCAL_API_PATTERN.test(COMMON.BASE_API)) {
                        return config;
                    }
                    // If URL is for a legacy-prod-failover tenant, leave it pointed
                    // at COMMON.BASE_API (old prod). Everything else — tenant-scoped
                    // or not — rewrites to canary.
                    for (var i = 0; i < LEGACY_PROD_TENANTS.length; i++) {
                        if (config.url.indexOf('/domain/' + LEGACY_PROD_TENANTS[i] + '/') !== -1) {
                            return config;
                        }
                    }
                    config.url = config.url.replace(COMMON.BASE_API, CANARY_BASE_API);
                    return config;
                }
            };
        };

        // Register the http interceptor factories.
        $httpProvider.interceptors.push(
            httpInterceptorFor401Response);
        // $httpProvider.interceptors.push(
        //     httpInterceptorForHttpActivityTracking);

        $httpProvider.interceptors.push(
            httpResponse401Interceptor);

        $httpProvider.interceptors.push(
            canaryTenantRerouteInterceptor);

    }

})();
(function ()
{
    'use strict';

    angular
        .module('Qiu')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource)
    {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allow you to
         * add hardcoded parameters to your API calls that you want to sent every time you
         * make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *                   list     : $resource('http://api.example.com/blog'),
         *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
         *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
         *                       get: {
         *                            method: 'GET',
         *                            params: {
         *                                getByDate: true
         *                            }
         *                       }
         *                   })
         *       }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource service, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

        var api = {};

        // Base Url
        api.baseUrl = 'app/data/';

        /**
         * Here you can find all the definitions that the Demo Project requires
         *
         * If you wish to use this method, you can create your API definitions
         * in a similar way.
         */

        /*
         api.dashboard = {
         project  : $resource(api.baseUrl + 'dashboard/project/data.json'),
         server   : $resource(api.baseUrl + 'dashboard/server/data.json'),
         analytics: $resource(api.baseUrl + 'dashboard/analytics/data.json')
         };

         api.cards = $resource(api.baseUrl + 'cards/cards.json');

         api.fileManager = {
         documents: $resource(api.baseUrl + 'file-manager/documents.json')
         };

         api.ganttChart = {
         tasks: $resource(api.baseUrl + 'gantt-chart/tasks.json'),
         timespans : $resource(api.baseUrl + 'gantt-chart/timespans.json')
         };

         api.icons = $resource('assets/icons/selection.json');

         api.invoice = $resource(api.baseUrl + 'invoice/invoice.json');

         api.mail = {
         inbox: $resource(api.baseUrl + 'mail/inbox.json')
         };

         api.profile = {
         timeline    : $resource(api.baseUrl + 'profile/timeline.json'),
         about       : $resource(api.baseUrl + 'profile/about.json'),
         photosVideos: $resource(api.baseUrl + 'profile/photos-videos.json')
         };

         api.quickPanel = {
         activities: $resource(api.baseUrl + 'quick-panel/activities.json'),
         contacts  : $resource(api.baseUrl + 'quick-panel/contacts.json'),
         events    : $resource(api.baseUrl + 'quick-panel/events.json'),
         notes     : $resource(api.baseUrl + 'quick-panel/notes.json')
         };

         api.search = {
         classic : $resource(api.baseUrl + 'search/classic.json'),
         mails   : $resource(api.baseUrl + 'search/mails.json'),
         users   : $resource(api.baseUrl + 'search/users.json'),
         contacts: $resource(api.baseUrl + 'search/contacts.json')
         };

         api.scrumboard = {
         boardList: $resource(api.baseUrl + 'scrumboard/boardList.json'),
         board    : $resource(api.baseUrl + 'scrumboard/boards/:id.json')
         };

         api.tables = {
         employees   : $resource(api.baseUrl + 'tables/employees.json'),
         employees100: $resource(api.baseUrl + 'tables/employees100.json')
         };

         api.timeline = {
         page1: $resource(api.baseUrl + 'timeline/page-1.json'),
         page2: $resource(api.baseUrl + 'timeline/page-2.json'),
         page3: $resource(api.baseUrl + 'timeline/page-3.json')
         };

         api.todo = {
         tasks: $resource(api.baseUrl + 'todo/tasks.json'),
         tags : $resource(api.baseUrl + 'todo/tags.json')
         };
         */

        return api;
    }

})();
(function () {
	'use strict';

	angular
		.module('app.tags', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

		$stateProvider.state('app.tags', {
				url     : '/tags',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/tags/tags.html',
						controller: 'TagsController as vm'
					}
				},
				bodyClass: 'content'
			});

			$stateProvider
				.state('app.site_overview.tags', {
					abstract: true,
					url: '/tags',
					// controller: 'siteContentController',
					// views: {
					// 	'content@app': {
					// 		templateUrl: 'app/main/apps/content/content.html',
					// 		controller: 'ContentController as vm'
					// 	}
					// },
					// templateUrl: '/modules/site/content/views/site_content.html',
					onEnter: function ($stateParams) {


					},
					data: {
						displayName: '{{section}}'
					},
					resolve: {
						section: function ($stateParams) {
							return $stateParams.section
						},
					},


				})
				.state('app.site_overview.tags.list', {
					url: '',
					views: {
						'content@app': {
							templateUrl: 'app/main/apps/tags/tags.html',
							controller: 'TagsController as vm'
						}
					},
					// templateUrl: '/modules/site/content/views/site_content_list.html',
					// controller: 'siteContentListController',
					onEnter: function () {
					},
					data: {
						displayName: 'List {{section}}'
					},
					resolve: {
	                    // Cards: function (msApi)
	                    // {
	                    //     return msApi.resolve('cards@get');
	                    // }
					//     section: function ($stateParams) {
					//         return $stateParams.section
					//     }
					},
				})
				.state('app.site_overview.tags.list.thread', {
	                url      : '/:id',
	                bodyClass: 'content'
	            })
				.state('app.site_overview.tags.siteContentEdit', {
					url: '/:id/edit',
	                views: {
	                    'content@app': {
	                        templateUrl: 'app/main/apps/tags/views/edit/edit-view.html',
	                        controller: 'siteContentEditController as vm'
	                    }
	                },
					// templateUrl: '/modules/site/content/views/site_content_edit.html',
					// controller: 'siteContentEditController',
					onEnter: function () {
					},
					data: {
						displayName: '{{dataItem.result.title}}'
					},
					resolve: {
						id: function ($stateParams) {
							return $stateParams.id
						},
						dataItem: function (requestContext, $stateParams, contentService) {
							// $scope.isLoading=true;
							var siteID = $stateParams.siteId;
							var id = $stateParams.id;
							var options = {
								site: $stateParams.siteId,
								id: $stateParams.id
							};
							return contentService.getByID(options);
							// return searchService.getSearchResults($route.current.params);
						}
					},
					// abstract:true,

				});

		$translatePartialLoaderProvider.addPart('app/main/apps/tags');

	}
})();

angular.module("Qiu").run(["$templateCache", function($templateCache) {$templateCache.put("app/domain-panel/domain-panel.html","<md-content class=\"chat-tab\" ng-include=\"\'app/domain-panel/tabs/domains/domain-tab.html\'\" \nng-controller=\"DomainSelectorTabController as vm\"></md-content>");
$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs=\"always\"><md-tab><md-tab-label \ntranslate=\"QUICKPANEL.CHAT\">DOMAINS</md-tab-label><md-tab-body><md-content class=\"chat-tab scrollable\" ms-scroll \nng-include=\"\'app/quick-panel/tabs/domains/domain-tab.html\'\" ng-controller=\"DomainTabController as vm\"></md-content>\n</md-tab-body></md-tab><md-tab><md-tab-label translate=\"QUICKPANEL.TODAY\">TODAY</md-tab-label><md-tab-body><md-content \nclass=\"today-tab scrollable\" ms-scroll ng-include=\"\'app/quick-panel/tabs/today/today-tab.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab><md-tab-label translate=\"QUICKPANEL.CHAT\">CHAT</md-tab-label><md-tab-body><md-content \nclass=\"chat-tab scrollable\" ms-scroll ng-include=\"\'app/quick-panel/tabs/chat/chat-tab.html\'\" \nng-controller=\"ChatTabController as vm\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label \ntranslate=\"QUICKPANEL.ACTIVITY\">ACTIVITY</md-tab-label><md-tab-body><md-content class=\"activity-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/activity/activity-tab.html\'\"></md-content></md-tab-body></md-tab></md-tabs>\n</md-content>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-down md-background md-hue-1\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar\" ui-view=\"toolbar\"></md-toolbar><div id=\"horizontal-navigation\" class=\"md-whiteframe-1dp\" \nui-view=\"navigation\"></div><div id=\"content-container\" flex layout=\"column\"><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ui-view=\"content\" flex></md-content></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" ng-class=\"\'site-\' + site_operative.domain_name\" \nlayout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" \nmd-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex \nlayout=\"column\"><md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar>\n<md-content id=\"content\" class=\"animate-slide-up md-background md-hue-1\" ms-scroll ui-view=\"content\" flex></md-content>\n</div><md-sidenav id=\"domain-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"domain-panel\" \nms-scroll ui-view=\"domainPanel\"></md-sidenav></div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-panel\" layout=\"row\" layout-align=\"start start\"><div \nclass=\"ms-theme-options-panel-button md-primary-bg\" ng-click=\"toggleOptionsPanel()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><div class=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option\"><div \nclass=\"option-title\">Layout Style:</div><md-radio-group layout=\"column\" ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button value=\"verticalNavigation\">Vertical Navigation</md-radio-button>\n<md-radio-button value=\"horizontalNavigation\">Horizontal Navigation</md-radio-button><md-radio-button \nvalue=\"contentOnly\">Content Only</md-radio-button><md-radio-button value=\"contentWithToolbar\">Content with Toolbar\n</md-radio-button></md-radio-group></div><md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">\nLayout Mode:</div><md-radio-group layout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" \nng-change=\"vm.updateLayoutMode()\"><md-radio-button value=\"boxed\">Boxed</md-radio-button><md-radio-button value=\"wide\">\nWide</md-radio-button></md-radio-group></div><md-divider></md-divider><div class=\"theme-option\"><div \nclass=\"option-title\">Color Palette:</div><md-menu-item ng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"theme\">\n<md-button class=\"md-raised theme-button\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"themeName\"><span><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" md-font-icon=\"icon-palette\">\n</md-icon><span>{{themeName}}</span></span></md-button></md-menu-item></div></div></div>");
$templateCache.put("app/main/public/login.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><div class=\"logo\"><img \nng-src=\"{{vm.logoURL}}\"></div><div class=\"title\" translate=\"{{vm.translateSiteName}}\">Log in to your account</div><div \nflex layout-align=\"space-between center\" ng-if=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><div ng-if=\"!vm.loading\"><form name=\"loginForm\" novalidate ng-submit=\"login(loginForm)\">\n<md-input-container class=\"md-block\" md-no-float><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" \nplaceholder=\"Email\" translate translate-attr-placeholder=\"LOGIN.EMAIL\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"loginForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"LOGIN.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" \nplaceholder=\"Password\" translate translate-attr-placeholder=\"LOGIN.PASSWORD\" required><div \nng-messages=\"loginForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><div \nclass=\"remember-forgot-password\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-between center\"><md-checkbox \nclass=\"remember-me\" ng-model=\"data.cb1\" aria-label=\"Remember Me\"><span translate=\"LOGIN.REMEMBER_ME\">Remember Me</span>\n</md-checkbox></div><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" \nng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"LOGIN.LOG_IN\" \ntranslate-attr-aria-label=\"LOGIN.LOG_IN\">LOG IN</md-button></form><div class=\"separator\"><span class=\"text\" \ntranslate=\"LOGIN.OR\">OR</span></div><div layout=\"column\" layout-align=\"start center\"><div layout=\"column\" \nlayout-align=\"center center flex\"><md-button class=\"md-raised google\" ng-click=\"authenticate(\'google\')\"><div \nlayout=\"row\" layout-align=\"start center\"><img class=\"google-sign-in-icon\" \nsrc=\"/assets/images/google_signin_buttons/g-logo.png\" alt=\"Sign in with Google\"> <span class=\"google-sign-in-text\" \ntranslate=\"LOGIN.WITH_GOOGLE\">Sign in with Google</span></div></md-button></div><md-menu id=\"language-menu\" \nmd-offset=\"0 52\" md-position-mode=\"target-left target\"><md-button class=\"language-button\" ng-click=\"$mdMenu.open()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag img-flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.svg\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag img-flag\" ng-src=\"assets/images/flags/{{lang.flag}}.svg\">&nbsp; <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n</div></div></div></div></div>");
$templateCache.put("app/main/public/sample.html","<h1>{{vm.helloText}}</h1>");
$templateCache.put("app/core/directives/google-gallery/google-gallery.html","<div><div ng-repeat=\"group in vm.itemsGrouped\"><md-list-item class=\"tt md-toolbar-tools white-100-bg _md mb-5\" \nrole=\"listitem\"><h3 class=\"black-fg\">{{group.formatedDate}}</h3><div class=\"md-secondary-container\"></div>\n</md-list-item><div class=\"grid-google\"><google-media-item on-select=\"vm.selectMediaFile(mediaItem)\" item=\"mediaItem\" \nng-repeat=\"mediaItem in group.medias\"></google-media-item></div></div></div>");
$templateCache.put("app/core/directives/google-media-item/google-media-item.html","<img id=\"{{vm.item.id_media}}\" class=\"item\" ng-class=\"{\'no-media\': vm.item.nomedia}\" src=\"{{vm.item.url}}\" alt=\"\">");
$templateCache.put("app/core/directives/media/item-media.html","<div id=\"{{attachment.id_media}}-media-item\" class=\"media-attachment\"><qiu-icon type=\"typeIcon\" \nmediafile=\"attachment.filename\" class=\"mr-10\" ng-if=\"audio && (!attachment.thumb || loadedIcon)\"></qiu-icon><img \nng-if=\"!image && url && video\" class=\"{{class}} image\" ng-src=\"{{url}}\" err-src=\"1\" imageonload><div ng-if=\"audio\" \nclass=\"fotorama__video-play modified\" style=\"opacity:1\" \nng-click=\"vm.openImageDialog($event, attachment, false, false, true);$event.stopPropagation()\"></div><qiu-icon \ntype=\"typeIcon\" mediafile=\"attachment.filename\" ng-if=\"file && (!attachment.thumb || loadedIcon)\"></qiu-icon><img \nng-if=\"image\" class=\"{{class}}\" ng-src=\"{{url}}\" err-src=\"1\"><video id=\"video-preview-{{attachment.id_media}}\" \nclass=\"video-preview\" ng-if=\"attachment.short_preview\" width=\"100%\" loop preload=\"metadata\" muted><source \nng-if=\"attachment.short_preview\" type=\"video/mp4\" ng-src=\"{{attachment.short_preview | toTrustedResource}}\">\nYour browser does not support the video tag.</video><img class=\"{{class}} image\" ng-src=\"{{url}}\" err-src=\"1\" \nng-if=\"video && !url\" imageonload><div ng-if=\"urlvideo || video\" class=\"fotorama__video-play modified\" \nstyle=\"opacity:1\" ng-click=\"vm.openImageDialog($event, attachment, false, false, true); $event.stopPropagation()\">\n</div><video width=\"100%\" preload=\"metadata\" ng-if=\"urlvideo\" class=\"{{class}}\" \nposter=\"{{url ? (url | toTrustedResource) : \'\'}}\"><source type=\"video/mp4\" ng-src=\"{{urlvideo | toTrustedResource}}\" \nerr-src=\"1\">Your browser does not support the video tag.</video><iframe id=\"ytplayer\" type=\"text/html\" width=\"100%\" \nheight=\"100%\" ng-if=\"urlvideoEmbed\" ng-src=\"{{urlvideoEmbed | toTrustedResource}}\" frameborder=\"0\"></iframe><md-icon \nclass=\"s42 mr-15 ml-15\" md-font-icon=\"icon-folder-multiple-image\" role=\"img\" aria-label=\"icon-folder-multiple-image\" \nng-if=\"attachment.gallery_type\"></md-icon><div ng-if=\"labels.processing\" layout=\"row\" layout-align=\"center center\" \nrole=\"button\" class=\"media-status white-fg md-warn-bg label-processing\"><md-icon md-font-icon=\"icon-refresh\" \nrole=\"img\" aria-hidden=\"true\" class=\"thumb-list-icon\"><md-tooltip><span>{{ \'MEDIA.LABEL_PROCESSING\' | translate}}\n</span></md-tooltip></md-icon><md-icon md-font-icon=\"icon-refresh\" role=\"img\" aria-hidden=\"true\" \nclass=\"md-card-icon s24\"></md-icon><span class=\"ml-5\">{{ \'MEDIA.LABEL_PROCESSING\' | translate}}</span></div><div \nng-if=\"labels.error\" layout=\"row\" layout-align=\"center center\" role=\"button\" \nclass=\"media-status white-fg md-warn-bg label-error\"><md-icon md-font-icon=\"icon-exclamation\" role=\"img\" \naria-hidden=\"true\" class=\"thumb-list-icon\"><md-tooltip><span>{{ \'MEDIA.LABEL_ERROR\' | translate}}</span></md-tooltip>\n</md-icon><md-icon md-font-icon=\"icon-exclamation\" role=\"img\" aria-hidden=\"true\" class=\"md-card-icon s24\"></md-icon>\n<span class=\"ml-5\">{{ \'MEDIA.LABEL_ERROR\' | translate}}</span></div></div>");
$templateCache.put("app/core/directives/ms-cropformat-widget/ms-cropformat-widget.directive.html","<div layout=\"column\" layout-gt-xs=\"row\" layout-align-gt-xs=\"space-between center\" class=\"pr-10 pl-20 pb-20\"><div \nlayout=\"row\" layout-align=\"start center\" flex=\"100\" flex-gt-xs=\"90\"><md-input-container flex=\"50\" \nclass=\"md-block no-md-errors-spacer mr-10\"><label>Cropformat name</label><input ng-model=\"vm.cropformatname\" \ntype=\"text\" value=\"\"></md-input-container><md-input-container flex=\"50\" class=\"md-block\"><label>Select cropformat\n</label><md-select ng-model=\"vm.cropformatselected\"><md-option ng-repeat=\"crop in cropformatoptions\" \nng-value=\"crop.id_cropformats\">#{{crop.id_cropformats}} - {{crop.name}} <span ng-if=\"crop.description\">\n({{crop.description}})</span></md-option></md-select></md-input-container></div><md-button \nng-click=\"vm.addCropformat(widget, vm.cropformatname, vm.cropformatselected)\" class=\"add-event-button md-icon-button\">\n<md-icon md-font-icon=\"icon-plus-circle\" class=\"green-fg\" aria-label=\"ADD\"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate=\"WIDGETS.ADD_CROPFORMAT\">ADD CROPFORMAT</span></md-tooltip></md-button></div><div layout=\"row\" \nlayout-align=\"start center\" class=\"ph-20 pb-20\" dragula=\"\'crop\'\" dragula-model=\"widget.cropformats\"><div \nng-repeat=\"crop in widget.cropformats track by $index\" class=\"mr-10 p-5 border image-card\" layout=\"column\" \nlayout-align=\"start space-between\"><div layout=\"row\" layout-align=\"center center\" \nclass=\"dragC h-50 cropformat-container\" style=\"width:{{vm.Math.round((50 * crop.width) / crop.height)}}px\"></div><div \nlayout=\"row\" layout-align=\"space-between end\" class=\"pt-5 dragC\"><div layout=\"column\" class=\"font-size-12 pr-5\">\n<strong>{{crop.name}}</strong> <span>{{crop.id}}</span> <span>{{crop.width}}x{{crop.height}}</span></div><div \nlayout=\"column\" layout-align=\"end center\" class=\"font-size-12 pl-5\"><span ng-if=\"crop.proportional==1\">Prop.</span>\n</div></div><button ng-click=\"widget.cropformats.splice($index, 1)\" class=\"close-top-right border\" \nlayout-align=\"center center\" layout=\"row\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></button></div>\n</div>");
$templateCache.put("app/core/directives/ms-chips-filters/ms-chips-filters.html","<div id=\"ms-chips-filters\" class=\"pb-20\" layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><md-chips \nng-model=\"vm.filters\" readonly=\"true\" md-removable=\"false\"><md-chip-template><div \nng-if=\"$chip.field === \'onoff\' || $chip.field === \'lang\'\"><strong>{{$chip.field}}</strong><span> = </span><span \nng-repeat=\"value in $chip.value track by $index\">{{value}}<span ng-if=\"$index != $chip.value.length - 1\">,</span>\n</span> <button ng-click=\"vm.editStringSection($chip)\" md-chip-remove><md-icon md-font-icon=\"icon-close-circle\">\n</md-icon></button></div><div \nng-if=\"$chip.field != \'limit\' && $chip.field != \'onoff\' && $chip.field != \'lang\' && $chip.field != \'date\'\"><strong>\n{{$chip.field}}</strong><span> {{$chip.condition}} </span><span>{{$chip.value}}</span> <button \nng-click=\"vm.editStringSection($chip)\" md-chip-remove><md-icon md-font-icon=\"icon-close-circle\"></md-icon></button>\n</div><div ng-if=\"$chip.field == \'date\'\"><strong>{{$chip.field}}</strong><span> {{$chip.condition}} </span><span>\n{{$chip.value | amDateFormat:\'DD MMM YYYY\'}}</span> <button ng-click=\"vm.editStringSection($chip)\" md-chip-remove>\n<md-icon md-font-icon=\"icon-close-circle\"></md-icon></button></div><div ng-if=\"$chip.field == \'limit\'\"><strong>\n{{$chip.field}}</strong><span> = </span><span>{{$chip.value}}</span> <button ng-click=\"vm.editStringSection($chip)\" \nmd-chip-remove><md-icon md-font-icon=\"icon-close-circle\"></md-icon></button></div></md-chip-template></md-chips></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><md-button aria-label=\"Row Color\" md-menu-origin \nng-click=\"$mdMenu.open($event)\" ng-class=\"selectedColor.class\"><span ng-show=\"selectedColor.palette\">\n{{selectedColor.palette}} {{selectedColor.hue}} </span><span ng-show=\"!selectedColor.palette\">Select Color</span>\n</md-button><md-menu-content class=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"selectedColor.palette\">\n{{selectedColor.palette}} {{selectedColor.hue}} </span><span ng-if=\"!selectedColor.palette\">Select Color</span>\n<md-button class=\"remove-color-button md-icon-button\" ng-click=\"removeColor()\" aria-label=\"Remove Color\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-if=\"!selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in palettes\" ng-click=\"activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-if=\"selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+selectedPalette+\'-\'+hue+\'-bg\'\" \nng-repeat=\"(hue, values) in selectedHues\" ng-click=\"selectColor(selectedPalette,hue)\" layout=\"row\" \nlayout-align=\"start end\" md-ink-ripple><span class=\"label\">{{hue}} </span><i \nng-if=\"selectedPalette == selectedColor.palette && hue == selectedColor.hue\" class=\"s16 icon-check\"></i></div></div>\n</div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-icon \nid=\"ms-search-bar-expander\" md-font-icon=\"icon-magnify\" class=\"md-icon-button md-button\"><md-tooltip hide show-gt-xs>\n<span translate=\"TOOLBAR.SEARCH\">Search</span></md-tooltip></md-icon></label><md-icon id=\"ms-search-bar-reset\" \nmd-font-icon=\"icon-close-circle\" class=\"icon s24\" ng-if=\"$root.modelSearch\" ng-click=\"$root.modelSearch = null\">\n</md-icon><input id=\"ms-search-bar-input\" type=\"text\" ng-model=\"$root.modelSearch\" placeholder=\"Search\" md-autofocus \ntranslate translate-attr-placeholder=\"TOOLBAR.SEARCH\" flex ng-enter=\"$root.pagination_search($root.modelSearch)\">\n<md-button hide show-gt-xs id=\"ms-search-bar-button\" class=\"md-accent md-raised\" \nng-click=\"$root.pagination_search($root.modelSearch)\" ng-disabled=\"!$root.modelSearch\" aria-label=\"description\" \nmd-no-ink=\"true\" md-ripple-size=\"auto\">Search</md-button><md-button hide show-xs id=\"ms-search-bar-button\" \nclass=\"md-accent md-raised md-icon-button\" ng-click=\"$root.pagination_search($root.modelSearch)\" \nng-disabled=\"!$root.modelSearch\" aria-label=\"description\" md-no-ink=\"true\" md-ripple-size=\"auto\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon></md-button><md-icon id=\"ms-search-bar-collapser\" \nmd-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></div>");
$templateCache.put("app/core/directives/ms-search-bar-custom/ms-search-bar-custom.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-icon \nid=\"ms-search-bar-expander\" md-font-icon=\"icon-magnify\" class=\"md-icon-button md-button\"><md-tooltip hide show-gt-xs>\n<span translate=\"TOOLBAR.SEARCH\">Search</span></md-tooltip></md-icon></label><input id=\"ms-search-bar-input\" \ntype=\"text\" ng-model=\"$root.modelSearch\" placeholder=\"Search\" md-autofocus translate \ntranslate-attr-placeholder=\"TOOLBAR.SEARCH\" flex ng-enter=\"searchClick($root.modelSearch)\"><md-icon \nid=\"ms-search-bar-collapser\" md-font-icon=\"icon-close-circle\" class=\"icon s24\" ng-click=\"searchClear()\"></md-icon>\n<md-button hide show-gt-xs id=\"ms-search-bar-button\" class=\"md-accent md-raised\" \nng-click=\"searchClick($root.modelSearch)\" ng-disabled=\"!$root.modelSearch\" aria-label=\"description\" md-no-ink=\"true\" \nmd-ripple-size=\"auto\">Search</md-button><md-button hide show-xs id=\"ms-search-bar-button\" \nclass=\"md-accent md-raised md-icon-button\" ng-click=\"searchClick($root.modelSearch)\" ng-disabled=\"!$root.modelSearch\" \naria-label=\"description\" md-no-ink=\"true\" md-ripple-size=\"auto\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon>\n</md-button></div>");
$templateCache.put("app/core/directives/ms-search-nav/ms-search-nav.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-nav-input\" layout=\"row\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s20\"></md-icon></label><input \nid=\"ms-search-nav-input\" type=\"text\" ng-model=\"global.searchnav\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"TOOLBAR.SEARCH\" flex></div>");
$templateCache.put("app/core/directives/ms-social-list/ms-social-list.html","<div flex layout=\"column\" layout-align=\"center center\" ng-if=\"vm.loading\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"30\"></md-progress-circular></div><div \nng-if=\"!vm.loading && vm.socialPosts.length> 0\" with=\"vm.socialPosts\" as=\"socialPosts\" \nng-include=\"\'app/core/directives/ms-social-list/social-posts-template.html\'\"></div><div \nng-if=\"!vm.loading && vm.socialPosts.length == 0\" class=\"no-content\" layout=\"column\" layout-align=\"center center\"><h1>\nNo social post yet!</h1></div>");
$templateCache.put("app/core/directives/ms-social-list/social-posts-template.html","<div class=\"activities-list activity-main\"><table fill-width><tr ng-repeat=\"post in socialPosts\"><td class=\"bb\" \nstyle=\"width: 250px; padding-left: 10px\"><div layout=\"row\" layout-align=\"start center\"><div \nng-if=\"(post.user.avatar == \'\' || !post.user.avatar)\" class=\"avatar\" \nng-bind=\"post.user.first_name | capitalizeFirstLetter\" style=\"background-color:{{post.user.profile_color}}\"></div><div \nclass=\"avatar-wrapper\" ng-if=\"post.user.avatar\" attachment=\"post.user.avatar\"><img class=\"avatar\" \nng-src=\"{{post.user.avatar}}\" imageonload></div><h3 class=\"mt-0 mb-0 mr-10\"><strong \nng-bind-html=\"post.user.first_name + \' \' + post.user.last_name\"></strong><div layout=\"row\" layout-align=\"start center\">\n<md-icon class=\"m-0 mr-5\" md-font-icon=\"icon-{{post.provider}}\"></md-icon><p class=\"font-size-12 grey-500-fg\">\n{{post.account.name}}</p></div></h3></div></td><td class=\"bb\" style=\"width: 200px\"><div layout=\"column\" \nclass=\"ml-15 text-left\" layout-align=\"center start\"><p class=\"mv-5\"><strong>{{post.message_data.title}}</strong></p><p \nclass=\"mv-5\">{{post.message_data.message}}</p></div></td><td class=\"bb\" style=\"width: 75px\"><div layout=\"column\" \nlayout-align=\"center end\"><div ng-if=\"post.media[0]\" class=\"media photos\" layout=\"row\" layout-align=\"center center\">\n<media attachment=\"post.media[0]\" class-img=\"image\"></media></div></div></td><td class=\"bb\" style=\"width: 250px\"><div \nclass=\"mr-15\" layout=\"row\" layout-align=\"end center\"><span \nng-if=\"post.status !== \'queued\' && post.status !== \'processing\'\" class=\"grey-500-fg mr-15\" \nng-bind-html=\"vm.timeAgo(post.created_at)\"></span><md-progress-circular class=\"mr-10\" \nng-if=\"post.status == \'queued\' || post.status == \'processing\'\" md-mode=\"indeterminate\" md-diameter=\"25\">\n</md-progress-circular><span class=\"status {{post.status}}\" ng-bind-html=\"post.status\"></span></div></td><td \nclass=\"bb\" style=\"width: 20px\"><md-menu><md-icon class=\"pointer mr-10\" ng-click=\"$mdMenu.open($event)\" \nmd-font-icon=\"icon-dots-vertical\"></md-icon><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"vm.deletePost(post)\" aria-label=\"Refresh widget\" translate=\"MATCH_CENTER.DELETE_POST\"></md-button>\n</md-menu-item></md-menu-content></md-menu></td></tr></table></div>");
$templateCache.put("app/core/directives/ms-filter-widget/ms-filter-widget.html","<div id=\"ms-filter-widget\" layout=\"row\" layout-align=\"space-between center\" flex=\"100\" class=\"mb-0 pb-10 pl-20 pr-10\">\n<div layout=\"column\" layout-gt-xs=\"row\" layout-align=\"start center\" flex=\"90\"><md-input-container flex=\"100\" \nflex-gt-xs=\"30\" class=\"md-block\"><label translate=\"WIDGETS.NEW_FILTER\"></label><md-select \nng-change=\"vm.cleanFilters()\" ng-model=\"vm.widgetsFilter\"><md-optgroup label=\"Fields\"><md-option \nng-repeat=\"ref in vm.selectedRef\" value=\"{{ref.field}}\"><span class=\"block font-size-10 grey-400-fg\">{{ref.field}}\n</span>{{ref.title}}</md-option></md-optgroup><md-optgroup label=\"Options\"><md-option value=\"limit\">Limit</md-option>\n<md-option value=\"order\">Order by</md-option></md-optgroup></md-select></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"30\" class=\"md-block mh-10\" \nng-if=\"vm.widgetsFilter != \'limit\' && vm.widgetsFilter != \'order\' && vm.widgetsFilter != \'onoff\' && vm.widgetsFilter != \'lang\' && vm.widgetsFilter\">\n<label translate=\"WIDGETS.FILTER_CONDITION\"></label><md-select ng-model=\"vm.widgetsFilterCondition\"><md-option \nvalue=\"=\">equal to</md-option><md-option value=\">\" ng-if=\"vm.widgetsFilter == \'ID\' || vm.widgetsFilter == \'date\'\">\ngreater than</md-option><md-option value=\"<\" ng-if=\"vm.widgetsFilter == \'ID\' || vm.widgetsFilter == \'date\'\">\nsmaller than</md-option><md-option value=\">=\" ng-if=\"vm.widgetsFilter == \'ID\' || vm.widgetsFilter == \'date\'\">\nequal/greater than</md-option><md-option value=\"<=\" ng-if=\"vm.widgetsFilter == \'ID\' || vm.widgetsFilter == \'date\'\">\nequal/smaller than</md-option><md-option value=\"!=\">is not</md-option><md-option value=\"IN\">has</md-option><md-option \nvalue=\"NOT IN\">has not</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"30\" \nclass=\"md-block mh-10\" ng-if=\"vm.widgetsFilter == \'order\'\"><label translate=\"WIDGETS.FILTER_FIELD\"></label><md-select \nng-model=\"vm.widgetsFilterFieldOrder\"><md-option ng-repeat=\"ref in vm.selectedRef\" value=\"{{ref.field}}\">{{ref.title}}\n</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"30\" class=\"md-block\" \nng-if=\"vm.widgetsFilter == \'order\'\"><label translate=\"WIDGETS.FILTER_VALUE\"></label><md-select \nng-model=\"vm.widgetsFilterOrderValue\"><md-option value=\"DESC\">Descendent</md-option><md-option value=\"ASC\">Ascendent\n</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"30\" class=\"md-block\" \nng-if=\"vm.widgetsFilter == \'onoff\'\"><label translate=\"WIDGETS.FILTER_VALUE\"></label><md-select \nng-model=\"vm.widgetsFilterValues\" multiple=\"multiple\"><md-option value=\"1\">On</md-option><md-option value=\"0\">Off\n</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"30\" class=\"md-block\" \nng-if=\"vm.widgetsFilter == \'lang\'\"><label translate=\"WIDGETS.FILTER_VALUE\"></label><md-select \nng-model=\"vm.widgetsFilterValues\" multiple=\"multiple\"><md-option ng-value=\"lang.id_lang\" \nng-repeat=\"lang in vm.siteLanguages\">{{ lang.lang_name }}</md-option></md-select></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"40\" class=\"md-block no-md-errors-spacer\" \nng-if=\"vm.widgetsFilter == \'ID\' || vm.widgetsFilter == \'limit\'\"><label translate=\"WIDGETS.FILTER_VALUE\"></label><input \ntype=\"number\" value=\"\" ng-model=\"vm.widgetsFilterValues\"></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"40\" class=\"md-block no-md-errors-spacer\" \nng-if=\"vm.isMultipleSelect() && (vm.widgetsFilter == \'id_subsec\' || vm.widgetsFilter == \'id_cat\' || vm.widgetsFilter == \'id_subcat\')\">\n<label translate=\"WIDGETS.FILTER_VALUE\"></label><md-select ng-model=\"vm.widgetsFilterValues\" multiple=\"multiple\">\n<md-option ng-value=\"data.id\" ng-repeat=\"data in vm.filterSub\"><span class=\"block font-size-10 grey-400-fg\">\nID: {{data.id}}</span>{{data.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"40\" class=\"md-block no-md-errors-spacer\" \nng-if=\"!vm.isMultipleSelect() && (vm.widgetsFilter == \'id_subsec\' || vm.widgetsFilter == \'id_cat\' || vm.widgetsFilter == \'id_subcat\')\">\n<label translate=\"WIDGETS.FILTER_VALUE\"></label><md-select ng-model=\"vm.widgetsFilterValues\"><md-option \nng-value=\"data.id\" ng-repeat=\"data in vm.filterSub\"><span class=\"block font-size-10 grey-400-fg\">ID: {{data.id}}</span>\n{{data.name}}</md-option></md-select></md-input-container><mdp-date-picker flex=\"100\" flex-gt-xs=\"40\" \nclass=\"md-block no-md-errors-spacer mt-0 mb-0\" ng-if=\"vm.widgetsFilter == \'date\'\" mdp-placeholder=\"Date\" \nmdp-open-on-click=\"true\" mdp-format=\"DD/MM/YYYY\" ng-model=\"vm.widgetsFilterValues\"></mdp-date-picker>\n<md-input-container flex=\"100\" flex-gt-xs=\"40\" class=\"md-block no-md-errors-spacer\" ng-if=\"vm.isNormalValue()\"><label \ntranslate=\"WIDGETS.FILTER_VALUE\"></label><input type=\"text\" value=\"\" ng-model=\"vm.widgetsFilterValues\">\n</md-input-container></div><md-button ng-click=\"vm.addFilter()\" class=\"add-event-button md-icon-button\" \nng-if=\"vm.isFilterComplete()\"><md-icon md-font-icon=\"icon-plus-circle\" class=\"green-fg\" aria-label=\"ADD\"></md-icon>\n<md-tooltip hide show-gt-xs><span translate=\"WIDGETS.ADD_FILTER\">ADD FILTER</span></md-tooltip></md-button></div>");
$templateCache.put("app/core/directives/ms-social-widget-share/ms-social-widget-share.html","<div class=\"ph-15 social-icons mt-20\" layout=\"column\"><div layout=\"row\" class=\"layout-wrap\"><md-input-container \nng-repeat=\"socialItem in vm.socialPages\" class=\"md-block mv-5\" flex=\"100\" flex-gt-sm=\"50\"><md-checkbox \nng-click=\"vm.toggleNetwork(socialItem)\" ng-checked=\"vm.isSelected(socialItem)\" class=\"no-label\"><md-icon \nng-class=\"{\'selected\': vm.isSelected(socialItem)}\" ng-if=\"socialItem.provider == \'google\'\" md-font-icon=\"icon-youtube\">\n</md-icon><md-icon ng-class=\"{\'selected\': vm.isSelected(socialItem)}\" ng-if=\"socialItem.provider == \'linkedin\'\" \nmd-font-icon=\"icon-linkedin\"></md-icon><md-icon ng-class=\"{\'selected\': vm.isSelected(socialItem)}\" \nng-if=\"socialItem.provider == \'twitter\' || socialItem.provider == \'x\'\" aria-label=\"X\"><svg viewBox=\"0 0 24 24\" \nfill=\"currentColor\" style=\"width: .75em; height: .75em; vertical-align: middle\"><path \nd=\"M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z\"/>\n</svg></md-icon><md-icon ng-class=\"{\'selected\': vm.isSelected(socialItem)}\" ng-if=\"socialItem.provider == \'facebook\'\" \nmd-font-icon=\"icon-facebook\"></md-icon><span ng-class=\"{\'selected\': vm.isSelected(socialItem)}\">\n{{MATCH_CENTER.SHARE_IN}} {{socialItem.name}}</span></md-checkbox></md-input-container><md-input-container \nlayout=\"row\" layout-align=\"start center\" class=\"mv-5\" flex=\"100\"><md-button ng-if=\"!vm.loguedFacebook\" \nng-click=\"vm.addSocialNetworkPage($event)\" type=\"button\" class=\"ml-0 md-raised md-warn md-fab md-mini mv-10\"><md-icon \nmd-font-icon=\"icon-plus\" role=\"img\" aria-hidden=\"true\"></md-icon></md-button><span class=\"grey-900-fg\">ADD NEW ACCOUNT\n</span></md-input-container></div></div><div class=\"form-container\" fill-width flex layout=\"column\"><div fill-width \nclass=\"elements-list mv-15\" layout=\"column\" layout-align=\"start center\"><div fill-width class=\"ph-15\" flex \nlayout=\"row\" layout-align=\"start center\"><md-input-container class=\"md-block\" flex><label>\n{{ \'CONTENT.TITLE\' | translate}}</label><input ng-model=\"vm.title\"></md-input-container></div><div fill-width \nclass=\"ph-15\" flex layout=\"row\" layout-align=\"start center\"><md-input-container class=\"md-block\" flex><label>\n{{ \'MEDIA.DESCRIPTION\' | translate}}</label><textarea ng-model=\"vm.message\"></textarea></md-input-container></div>\n</div><div layout=\"row\" layout-align=\"end center\"><md-input-container><md-button type=\"button\" \nclass=\"md-raised md-warn\" ng-click=\"vm.closeDialog()\" translate=\"FORMS.CANCEL\"></md-button></md-input-container>\n<md-input-container><md-button ng-disabled=\"!vm.title || !vm.message || vm.socialNetworks.length == 0\" type=\"button\" \nclass=\"md-raised md-accent\" ng-click=\"vm.share()\" translate=\"MATCH_CENTER.SHARE\">SHARE</md-button></md-input-container>\n</div></div>");
$templateCache.put("app/core/directives/mv-grid/mv-grid-actions-cell.html","<div class=\"mvg-row-actions\"><button type=\"button\" class=\"mvg-duplicate-btn md-button md-icon-button\" \nng-disabled=\"row.$deleting\" ng-click=\"host.gridDuplicateRow(row, $event)\" \ntitle=\"{{ \'CONTENT.DUPLICATE\' | translate }}\"><md-icon md-font-icon=\"icon-content-duplicate\" class=\"s18\"></md-icon>\n</button> <button type=\"button\" class=\"mvg-delete-btn md-button md-icon-button\" ng-disabled=\"row.$deleting\" \nng-click=\"host.gridDeleteRow(row, $event)\" title=\"{{ \'CONTENT.DELETE\' | translate }}\"><md-progress-circular \nng-if=\"row.$deleting\" md-mode=\"indeterminate\" md-diameter=\"16\"></md-progress-circular><md-icon ng-if=\"!row.$deleting\" \nmd-font-icon=\"icon-delete\" class=\"s18\"></md-icon></button></div>");
$templateCache.put("app/core/directives/mv-grid/mv-grid.html","<div id=\"mvGridV2\" class=\"mv-grid\" flex layout=\"column\"><div flex layout=\"column\" layout-align=\"center center\" \nng-if=\"grid.loading\" class=\"loading-container\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\">\n</md-progress-circular></div><div class=\"mvg-scroll\" ng-if=\"!grid.loading\" flex><table class=\"mvg-table\" \nng-style=\"{\'width\': grid.totalWidth()}\"><colgroup><col class=\"mvg-col-status\"><col \nng-repeat=\"fc in grid.fixedStart track by $index\" ng-style=\"{\'width\': fc.width + \'px\'}\"><col \nng-repeat=\"col in grid.gridColumns() track by grid.colKey(col)\" ng-style=\"{\'width\': col.$width + \'px\'}\"><col \nng-repeat=\"fc in grid.fixedEnd track by $index\" ng-style=\"{\'width\': fc.width + \'px\'}\"></colgroup><thead><tr \nclass=\"mvg-new-row\" ng-if=\"grid.newRow\" ng-init=\"row = grid.newRow\" ng-class=\"{\'mvg-new-row-error\': grid.newRowError}\">\n<td class=\"mvg-status mvg-new-status\"></td><td ng-repeat=\"fc in grid.fixedStart track by $index\" \nclass=\"mvg-fixed-cell\"></td><td ng-repeat=\"col in grid.gridColumns() track by grid.colKey(col)\" class=\"mvg-cell\" \nng-init=\"q={}\" ng-include=\"grid.cellTemplate\"></td><td ng-repeat=\"fc in grid.fixedEnd track by $index\" \nclass=\"mvg-fixed-cell mvg-fixed-cell-end mvg-new-actions\"><div class=\"mvg-new-actions-wrap\"><button type=\"button\" \nclass=\"mvg-new-ok md-button md-icon-button\" ng-disabled=\"grid.newRowSaving\" ng-click=\"grid.saveNewRow()\" \ntitle=\"{{ \'CONTENT.SAVE\' | translate }}\"><md-progress-circular ng-if=\"grid.newRowSaving\" md-mode=\"indeterminate\" \nmd-diameter=\"16\"></md-progress-circular><md-icon ng-if=\"!grid.newRowSaving\" md-font-icon=\"icon-check\" class=\"s18\">\n</md-icon></button> <button type=\"button\" class=\"mvg-new-cancel md-button md-icon-button\" \nng-disabled=\"grid.newRowSaving\" ng-click=\"grid.cancelNewRow()\" title=\"{{ \'CONTENT.CANCEL\' | translate }}\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s18\"></md-icon></button></div></td></tr><tr \nng-class=\"{\'mvg-head-shifted\': grid.newRow}\"><th class=\"mvg-status\"></th><th \nng-repeat=\"fc in grid.fixedStart track by $index\" class=\"mvg-fixed-head\">{{fc.label | translate}}</th><th \nng-repeat=\"col in grid.gridColumns() track by grid.colKey(col)\" class=\"mvg-th\" title=\"{{col.field_name}}\" \nmv-grid-col-drag col-ref=\"col\" col-key=\"grid.colKey(col)\" on-col-drop=\"grid.moveColumn(from, to)\"><span \nclass=\"mvg-th-label\">{{col.field_name || col.title}}</span> <span class=\"mvg-resizer\" mv-grid-col-resize col-ref=\"col\" \non-resize-end=\"grid.persistWidths()\"></span></th><th ng-repeat=\"fc in grid.fixedEnd track by $index\" \nclass=\"mvg-fixed-head mvg-fixed-head-end\">{{fc.label | translate}}</th></tr></thead><tbody><tr \nng-repeat=\"row in grid.rows\" ng-init=\"grid.initRow(row)\" \nng-class=\"{\'row-saving\': row.$saving, \'row-saved\': row.$saved, \'row-error\': row.$saveError}\"><td class=\"mvg-status\">\n<md-checkbox ng-if=\"grid.isSelected && !row.$saving && !row.$saved && !row.$saveError\" \nclass=\"no-label mvg-select-check\" ng-checked=\"grid.isSelected({row: row})\" \nng-click=\"grid.onToggleSelect({row: row, $event: $event})\" aria-label=\"select\"></md-checkbox><md-progress-circular \nng-if=\"row.$saving\" md-mode=\"indeterminate\" md-diameter=\"16\"></md-progress-circular><md-icon ng-if=\"row.$saved\" \nmd-font-icon=\"icon-check\" class=\"green-500-fg s18\"></md-icon><md-icon ng-if=\"row.$saveError\" md-font-icon=\"icon-alert\" \nclass=\"red-500-fg s18\"></md-icon></td><td ng-repeat=\"fc in grid.fixedStart track by $index\" class=\"mvg-fixed-cell\" \nng-include=\"fc.cellTemplate\"></td><td ng-repeat=\"col in grid.gridColumns() track by grid.colKey(col)\" class=\"mvg-cell\" \nng-init=\"q={}\" ng-include=\"grid.cellTemplate\"></td><td ng-repeat=\"fc in grid.fixedEnd track by $index\" \nclass=\"mvg-fixed-cell mvg-fixed-cell-end\" ng-include=\"fc.cellTemplate\"></td></tr><tr ng-if=\"!grid.rows.length\"><td \nclass=\"mvg-empty\" colspan=\"99\">{{grid.emptyText | translate}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/core/directives/mv-tree-expander/mv-tree-expander.html","<md-icon ng-if=\"!exp.allExpanded()\" ng-click=\"exp.expandAll()\" md-font-icon=\"icon-unfold-more\" \nclass=\"m-0 grey-600-fg md-icon-button md-button md-default-theme md-font material-icons\" aria-label=\"Expand all\">\n<md-tooltip hide show-gt-xs><span translate=\"CONTENT.EXPAND_ALL\">Expand all</span></md-tooltip></md-icon><md-icon \nng-if=\"exp.allExpanded()\" ng-click=\"exp.collapseAll()\" md-font-icon=\"icon-unfold-less\" \nclass=\"m-0 grey-600-fg md-icon-button md-button md-default-theme md-font material-icons\" aria-label=\"Collapse all\">\n<md-tooltip hide show-gt-xs><span translate=\"CONTENT.COLLAPSE_ALL\">Collapse all</span></md-tooltip></md-icon>");
$templateCache.put("app/core/directives/pagination/pagination-simple.html","<md-table-pagination md-limit=\"query.limit\" md-limit-options=\"[5, 10, 15]\" md-page=\"query.page\" md-total=\"2306\" \nmd-on-paginate=\"getDesserts\" md-page-select=\"\" class=\"md-table-pagination\"><div class=\"limit-select\" \nng-if=\"$pagination.limitOptions\"><div class=\"label\">Rows per page:</div><md-select \nclass=\"md-table-select ng-pristine ng-untouched ng-valid\" ng-model=\"$pagination.limit\" \nmd-container-class=\"md-pagination-select\" ng-disabled=\"$pagination.disabled\" aria-label=\"Rows: 5\" placeholder=\"5\" \nrole=\"listbox\" aria-expanded=\"false\" aria-multiselectable=\"false\" id=\"select_4\" aria-owns=\"select_container_5\" \naria-disabled=\"false\" tabindex=\"0\" aria-invalid=\"false\"><md-select-value class=\"md-select-value\" \nid=\"select_value_label_1\"><span><div class=\"md-text\">5</div></span><span class=\"md-select-icon\" aria-hidden=\"true\">\n</span></md-select-value><div class=\"md-select-menu-container md-pagination-select\" aria-hidden=\"true\" \nid=\"select_container_5\"><md-select-menu><md-content><md-option ng-repeat=\"rows in $pagination.limitOptions\" \nng-value=\"rows\" tabindex=\"0\" class=\"md-ink-ripple\" role=\"option\" aria-selected=\"true\" id=\"select_option_7\" value=\"5\" \nselected=\"selected\"><div class=\"md-text\">5</div></md-option><md-option ng-repeat=\"rows in $pagination.limitOptions\" \nng-value=\"rows\" tabindex=\"0\" class=\"md-ink-ripple\" role=\"option\" aria-selected=\"false\" id=\"select_option_8\" value=\"10\">\n<div class=\"md-text\">10</div></md-option><md-option ng-repeat=\"rows in $pagination.limitOptions\" ng-value=\"rows\" \ntabindex=\"0\" class=\"md-ink-ripple\" role=\"option\" aria-selected=\"false\" id=\"select_option_9\" value=\"15\"><div \nclass=\"md-text\">15</div></md-option></md-content></md-select-menu></div></md-select></div><div class=\"buttons\"><div \nclass=\"label\">{{pagination_from}} – {{pagination_to}} of {{pagination_totalItems}}</div><md-button \naria-label=\"Previous\" class=\"md-icon-button arrow\" hide=\"\" ng-click=\"gotoPage(numPages-1)\" show-gt-xs=\"\" translate=\"\" \ntranslate-attr-aria-label=\"MAIL.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span \ntranslate=\"MAIL.PREVIOUS\">Previous</span></md-tooltip></md-button><md-button aria-label=\"Next\" \nclass=\"md-icon-button arrow\" hide=\"\" ng-click=\"gotoPage(numPages+1)\" show-gt-xs=\"\" translate=\"\" \ntranslate-attr-aria-label=\"MAIL.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span \ntranslate=\"MAIL.NEXT\">Next</span></md-tooltip></md-button><button class=\"md-icon-button md-button md-ink-ripple\" \ntype=\"button\" ng-click=\"pagination_prevPage()\" ng-disabled=\"pagination_firstPage()\" aria-label=\"Previous\"><md-icon \nmd-svg-icon=\"navigate-before.svg\" aria-hidden=\"true\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"100%\" \nheight=\"100%\" viewBox=\"0 0 24 24\" fit=\"\" preserveAspectRatio=\"xMidYMid meet\"><path \nd=\"M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z\"></path></svg></md-icon></button> <button \nclass=\"md-icon-button md-button md-ink-ripple\" type=\"button\" ng-click=\"$pagination.next()\" \nng-disabled=\"$pagination.disabled || !$pagination.hasNext()\" aria-label=\"Next\" aria-disabled=\"false\"><md-icon \nmd-svg-icon=\"navigate-next.svg\" aria-hidden=\"true\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"100%\" height=\"100%\" \nviewBox=\"0 0 24 24\" fit=\"\" preserveAspectRatio=\"xMidYMid meet\"><path \nd=\"M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z\"></path></svg></md-icon></button></div></md-table-pagination>");
$templateCache.put("app/core/directives/pagination/pagination.html","<div class=\"simple-pagination\"><md-button class=\"pagination-item disabled\" md-no-ink ng-href=\"#\" \naria-label=\"Go to previous page\" translate translate-attr-aria-label=\"SEARCH.GO_TO_PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button class=\"pagination-item active\" md-no-ink \naria-label=\"Go to page 1\" ng-repeat=\"p in [linkGroupFirst(), linkGroupLast()] | makeRange\" ng-click=\"gotoPage(p)\">\n<span>{{p}}</span></md-button><md-button class=\"pagination-item\" aria-label=\"Go to next page\" translate \ntranslate-attr-aria-label=\"SEARCH.GO_TO_NEXT\" ng-click=\"gotoPage(page+1)\"><md-icon md-font-icon=\"icon-chevron-right\">\n</md-icon></md-button><div class=\"row\"><div class=\"results_count\"><p>{{from}} – {{to}} de {{totalItems}}</p></div><div \nclass=\"paginate-anything\"><ul class=\"pagination pagination-{{size}} links\" ng-if=\"numPages > 1\"><li ng-show=\"page>1\"><a\n href ng-click=\"gotoPage(page-1)\"><i class=\"fa fa-caret-left\"></i></a></li><li ng-if=\"linkGroupFirst() > 1\"><a href \nng-click=\"gotoPage(1)\">1</a></li><li ng-if=\"linkGroupFirst() > 1\" class=\"disabled\"><a href>&hellip;</a></li><li \nng-repeat=\"p in [linkGroupFirst(), linkGroupLast()] | makeRange\" ng-class=\"{active: p === page}\" data=\"{{p}}\"><a href \nng-click=\"gotoPage(p)\">{{p}}</a></li><li ng-if=\"linkGroupLast() < numPages - 2\" class=\"disabled\"><a href>&hellip;</a>\n</li><li ng-if=\"isFinite() && linkGroupLast() < numPages - 1\"><a href ng-click=\"gotoPage(numPages-1)\">{{numPages}}</a>\n</li><li ng-class=\"{disabled: page >= numPages - 1}\"><a href ng-click=\"gotoPage(page+1)\"><i class=\"fa fa-caret-right\">\n</i></a></li></ul><div class=\"per-page\" ng-if=\"perPagePresets.length > 0 && numPages > 1\"><select \nng-model=\"$parent.perPage\" ng-options=\"p for p in perPagePresets\"></select>per page</div></div></div></div>");
$templateCache.put("app/core/directives/pagination/pagination_fuse.html","<div class=\"layout-row\"><div class=\"simple-pagination\" ng-show=\"numPages > 1\"><md-button class=\"pagination-item\" \nng-href=\"#\" aria-label=\"Go to previous page\" translate translate-attr-aria-label=\"SEARCH.GO_TO_PREVIOUS\" \nng-click=\"$root.pagination_gotoPage($root.pagination_page-1)\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon>\n</md-button><md-button class=\"pagination-item\" ng-class=\"{active: p === $root.pagination_page}\" \naria-label=\"Go to page {{p}}\" ng-repeat=\"p in [linkGroupFirst(), linkGroupLast()] | makeRange\" \nng-click=\"$root.pagination_gotoPage(p)\"><span>{{p}}</span></md-button><md-button class=\"pagination-item\" \nng-class=\"{disabled: $root.pagination_page >= numPages }\" \nng-click=\"$root.pagination_gotoPage($root.pagination_page+1)\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon>\n</md-button></div></div>");
$templateCache.put("app/core/directives/pagination/pagination_fuse_1.html","<div></div>");
$templateCache.put("app/core/directives/qiu-rating-stars/rating-stars-directive.html","<div class=\"qiu-rating-stars-container\" layout=\"row\"><a class=\"star-button\" \nng-mouseover=\"ctrl.setMouseOverRating($index + 1)\" ng-mouseleave=\"ctrl.setMouseOverRating(ctrl.rating)\" \nng-click=\"ctrl.setRating($index + 1)\" ng-repeat=\"item in ctrl.starsArray\"><md-icon class=\"step img amber-600-fg\" \nmd-font-icon=\"{{ item.class }}\" aria-label=\"description\"></md-icon></a><a class=\"ml-30\" ng-click=\"ctrl.setRating(0)\" \nng-if=\"!ctrl.readOnly && ctrl.resetAllowed\"><md-icon class=\"step img\" md-font-icon=\"icon-cancel\" \naria-label=\"description\"></md-icon><md-tooltip><span translate=\"CONTENT.NONE\">None</span></md-tooltip></a><input \nng-model=\"ctrl.rating\" type=\"text\" ng-hide style=\"display:none\"></div>");
$templateCache.put("app/core/directives/qiu-groups/qiu-groups-filters.html","<md-toolbar class=\"md-theme-light md-default-theme md-light-blue-bg\"><h2 class=\"md-toolbar-tools\" aria-label=\"Filters\" \nlayout=\"row\" layout-align=\"space-between center\"><span translate-attr-aria-label=\"QIU_GROUPS.FILTERS\" \ntranslate=\"QIU_GROUPS.FILTERS\">Filters</span> <button class=\"md-icon-button\" \nng-click=\"vm.cancelQiuGroups(\'filters-sidenav\')\"><md-icon md-font-icon=\"icon-close\"></md-icon></button></h2>\n</md-toolbar><md-content ms-scroll class=\"content\" flex><div class=\"navigation-simple\" layout=\"column\"></div>\n</md-content>");
$templateCache.put("app/core/directives/qiu-groups/qiu-groups-sidenav.html","<md-sidenav md-is-open=\"vm.isOpenSidenavGroups\" class=\"sidenav groups-tree sidenav sidenav-qiu-groups\" ms-scroll \nms-sidenav-helper md-no-ink><div flex layout=\"column\" layout-align=\"center center\" ng-if=\"isLoadingQiuGroups\" \nclass=\"loading-container\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div>\n<md-toolbar ng-if=\"!isLoadingQiuGroups\" class=\"md-default-theme grey-100-bg grey-600-fg pr-16 pl-16\" layout=\"row\" \nlayout-align=\"space-between center\"><div ng-if=\"!vm.showTreeSearch\" class=\"md-toolbar-tools p-0\" aria-label=\"Groups\" \nlayout=\"row\" layout-align=\"start center\"><md-icon hide show-gt-lg md-font-icon=\"icon-folder-multiple\" \nclass=\"grey-600-fg s18 mr-10 ml-0 md-default-theme md-font material-icons\" aria-hidden=\"true\"></md-icon><div \ntranslate-attr-aria-label=\"QIU_GROUPS.GROUPS\" translate=\"QIU_GROUPS.GROUPS\" class=\"grey-600-fg\" aria-label=\"GROUPS\">\nGROUPS</div></div><div ng-if=\"!vm.showTreeSearch\" layout=\"row\" layout-align=\"end center\"><div \nclass=\"divider-vertical hide show-gt-xs\" hide=\"\" show-gt-xs=\"\"></div><md-icon \nng-if=\"vm.qiuGroupsSortGroupsDir !== \'ASC\'\" ng-click=\"vm.qiuGroupsSortGroupsDir=\'ASC\'; vm.sortGroups()\" \nmd-font-icon=\"icon-sort-descending\" \nclass=\"m-0 grey-600-fg md-icon-button md-button md-default-theme md-font material-icons\" translate=\"\" \ntranslate-attr-aria-label=\"QIU_GROUPS.SORT_DIRECTION\"><md-tooltip><span translate=\"QIU_GROUPS.DESCENDING\"></span>\n</md-tooltip></md-icon><md-icon ng-if=\"vm.qiuGroupsSortGroupsDir === \'ASC\'\" \nng-click=\"vm.qiuGroupsSortGroupsDir=\'DESC\'; vm.sortGroups()\" md-font-icon=\"icon-sort-ascending\" \nclass=\"m-0 grey-600-fg md-icon-button md-button md-default-theme md-font material-icons\" translate=\"\" \ntranslate-attr-aria-label=\"QIU_GROUPS.SORT_DIRECTION\"><md-tooltip><span translate=\"QIU_GROUPS.ASCENDING\"></span>\n</md-tooltip></md-icon><md-menu><button aria-label=\"Filters\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" \nshow-gt-xs=\"\" translate=\"\" translate-attr-aria-label=\"QIU_GROUPS.FILTERS\"><md-icon \nmd-font-icon=\"m-0 grey-600-fg icon-chevron-down\"><md-tooltip><span translate=\"QIU_GROUPS.SORT_BY\">Sort</span>\n</md-tooltip></md-icon></button><md-menu-content width=\"4\"><md-menu-item \nng-repeat=\"(key, value) in vm.qiuGroupsSortGroupsBy\"><md-button aria-label=\"All\" \nng-click=\"vm.qiuGroupsSortGroupsField=value; vm.sortGroups()\"><div layout=\"row\" layout-align=\"space-between center\">\n<span>Order by {{key | translate}} </span><i class=\"icon-check s16\" ng-if=\"value == vm.qiuGroupsSortGroupsField\"></i>\n</div></md-button></md-menu-item></md-menu-content></md-menu><div class=\"divider-vertical hide show-gt-xs\" hide=\"\" \nshow-gt-xs=\"\"></div><md-icon id=\"\" md-font-icon=\"icon-plus\" ng-click=\"vm.createGroup($event)\" \nclass=\"m-0 grey-600-fg md-icon-button md-button md-default-theme md-font material-icons\" aria-hidden=\"true\">\n<md-tooltip><span translate=\"QIU_GROUPS.ADD\">Add</span></md-tooltip></md-icon><label for=\"ms-search-bar-input\"><md-icon\n ng-click=\"vm.showTreeSearch = true\" md-font-icon=\"icon-magnify\" \nclass=\"m-0 grey-600-fg md-icon-button md-button md-default-theme md-font material-icons\"><md-tooltip hide show-gt-xs>\n<span translate=\"QIU_GROUPS.SEARCH\">Search</span></md-tooltip></md-icon></label><div class=\"divider-vertical\"></div>\n<md-icon ng-click=\"vm.toggleSidenav()\" md-font-icon=\"icon-backburger\" \nclass=\"m-0 grey-600-fg md-icon md-button md-default-theme md-font material-icons md-icon-button\" aria-hidden=\"true\">\n</md-icon></div><div ng-if=\"vm.showTreeSearch\" layout=\"row\" class=\"groups-tree-search\"><div layout=\"row\" flex \nlayout-align=\"start center\"><label for=\"search-bar-input\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"grey-600-fg md-icon-button md-button\"><md-tooltip hide show-gt-xs><span translate=\"QIU_GROUPS.SEARCH\">Search\n</span></md-tooltip></md-icon></label><md-icon md-font-icon=\"icon-close-circle\" \nclass=\"grey-600-fg md-icon-button md-button\" ng-if=\"vm.treeSearch\" ng-click=\"vm.treeSearch = null\"></md-icon><input \ntype=\"text\" id=\"search-bar-input\" class=\"grey-600-fg grey-100-bg\" ng-model=\"vm.treeSearch\" placeholder=\"Search\" \nmd-autofocus translate translate-attr-placeholder=\"QIU_GROUPS.SEARCH\" flex><md-icon layout-align=\"end center\" \nng-click=\"vm.showTreeSearch = false\" md-font-icon=\"icon-close\" \nclass=\"qiu-groups-tree-search-collapser icon s24 grey-600-fg\"></md-icon></div></div></md-toolbar><md-content ms-scroll \nclass=\"content\" hide flex><div class=\"navigation-simple\" layout=\"column\"><div><div ng-if=\"vm.qiuGroupsNested\" \nivh-treeview=\"vm.qiuGroupsNested\" class=\"treeview small\" \nivh-treeview-on-cb-change=\"vm.callback(ivhNode, ivhIsSelected, ivhTree)\"><script type=\"text/ng-template\">\n<div class=\"level-card\">\r\n                            <span ivh-treeview-toggle> \r\n                                <span ivh-treeview-twistie></span>\r\n                            </span>\r\n                            <span class=\"pointer-indicator\"></span>\r\n                            <span class=\"ivh-treeview-node-label\" ivh-treeview-toggle>{{node.name}}</span>\r\n                            <md-treeview-box></md-treeview-box>\r\n                        </div>\r\n                        <div ivh-treeview-children></div>\n</script></div></div></div></md-content><md-content ms-scroll flex><div class=\"navigation-simple\" layout=\"column\"><div \nhidden id=\"qiuGroupsIncludeSubgroups\" data-include-subgroups=\"{{vm.includeSubgroups}}\"></div><div hidden \nid=\"qiuGroupsService\" data-groups-service=\"{{vm.qiuGroupsService}}\"></div><div ng-if=\"vm.qiuGroupsNested\" \nclass=\"ivh-treeview-folder small\" ivh-treeview=\"vm.qiuGroupsNested\" ivh-treeview-filter=\"vm.treeSearch\" \nivh-treeview-label-attribute=\"\'label\'\" ivh-treeview-on-cb-change=\"callback()\"><script type=\"text/ng-template\">\n<div class=\"level-card p-8 group-row\" layout=\"row\" layout-align=\"space-between stretch\" ng-class=\"{\'selected\': node.is_qiu_restricted_root || node.is_selected_group}\">\r\n\r\n                        <span ivh-treeview-twistie ivh-treeview-toggle layout=\"row\" layout-align=\"center center\"></span>\r\n                        <div flex id=\"treeview-group-{{node.id_group}}\" qiu-groups-select qiu-groups-service=\"mailingService\" data-group-node={{node}} layout=\"row\" layout-align=\"start center\">\r\n                            <div ng-if=\"node\">\r\n                                <md-icon ng-if=\"!node.children\" \r\n                                    md-font-icon=\"icon-folder\" \r\n                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                    aria-hidden=\"true\" >\r\n                                </md-icon>\r\n                                <md-icon \r\n                                    ng-if=\"node.children\" \r\n                                    md-font-icon=\"icon-folder-multiple\" \r\n                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                    aria-hidden=\"true\" >\r\n                                </md-icon>\r\n                            </div>\r\n                            <span class=\"ivh-treeview-node-label ng-binding\">{{node.name}}</span>\r\n                        </div> \r\n\r\n                        <div layout=\"row\" layout-align=\"end center\">\r\n                            <md-button qiu-groups-edit-group-dialog class=\"md-icon-button\" type=\"button\" aria-label=\"ACTIONS\">\r\n                                <md-icon md-font-icon=\"icon-pencil\" aria-hidden=\"true\"></md-icon>\r\n                            </md-button>\r\n                            <md-icon qiu-users-on-click-close-sidenav sidenav-id=\"qiu-groups-sidenav\" md-font-icon=\"icon-chevron-right\" aria-hidden=\"true\" hide-gt-sm class=\"mt-0 mb-0\"></md-icon>\r\n                        </div>\r\n\r\n                    </div>\r\n                    <div ivh-treeview-children></div>\n</script></div></div></md-content></md-sidenav>");
$templateCache.put("app/core/directives/qiu-tree/qiu-tree.html","<div><div ng-if=\"vm.flatSearch && vm.search\"><div class=\"qiu-tree-search-result\" \nng-repeat=\"result in vm.searchResults\"><md-tooltip md-direction=\"top\" md-delay=\"150\">{{result.path}}</md-tooltip><div \nclass=\"qiu-tree-breadcrumb\" ng-if=\"result.breadcrumb.length\"><span ng-repeat=\"crumb in result.breadcrumb\">{{crumb}}\n<span ng-if=\"!$last\" class=\"qiu-tree-breadcrumb-sep\">/</span></span></div><tree-item expandedids=\"expandedids\" \non-expand=\"vm.expand(item)\" on-collapse=\"vm.collapse(item)\" iscombo=\"vm.iscombo\" selectedid=\"vm.selected\" \nselected-ids=\"vm.selectedIds\" on-select=\"vm.select(item)\" on-edit=\"vm.edit(item, parent)\" item=\"result.node\">\n</tree-item></div><div class=\"qiu-tree-no-results\" ng-if=\"!vm.searchResults.length\" translate=\"MEDIA.NO_RESULTS\">\nNo results</div></div><div ng-if=\"!(vm.flatSearch && vm.search)\"><div ng-repeat=\"item in vm.treeFiltered\"><tree-item \nexpandedids=\"expandedids\" on-expand=\"vm.expand(item)\" on-collapse=\"vm.collapse(item)\" iscombo=\"vm.iscombo\" \nselectedid=\"vm.selected\" selected-ids=\"vm.selectedIds\" on-select=\"vm.select(item)\" on-edit=\"vm.edit(item, parent)\" \nitem=\"item\"></tree-item></div></div></div>");
$templateCache.put("app/domain-panel/tabs/domains/domain-tab.html","<div class=\"main animate-slide-right\" layout=\"column\"><md-toolbar \nclass=\"md-theme-light md-default-theme md-light-blue-bg\" layout=\"row\" layout-align=\"space-between center\"><h1 \nclass=\"md-toolbar-tools\" translate=\"TOOLBAR.DOMAINS\">DOMAINS</h1><md-button id=\"domain-panel-toggle\" \nclass=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'domain-panel\')\" aria-label=\"Toggle domain panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_DOMAIN_PANEL\"><md-icon md-font-icon=\"icon-close\" class=\"icon\"></md-icon>\n</md-button></md-toolbar><div class=\"layout-padding\" id=\"domain-search\"><form layout=\"row\" layout-align=\"start center\">\n<md-input-container flex-gt-sm layout=\"row\" layout-align=\"start center\"><label>Search domain</label><md-icon \nid=\"ms-search-bar-expander\" md-font-icon=\"icon-magnify\" \nclass=\"icon s24 ng-isolate-scope md-font icon-magnify material-icons md-default-theme\" aria-label=\"icon-magnify\" \nrole=\"img\"></md-icon><input name=\"name\" ng-model=\"vm.filters.contentFilterInput\" placeholder=\"Search domain\" \nmd-autofocus autocomplete=\"off\"></md-input-container></form></div><md-content flex layout-paddings ms-scroll \nid=\"chat-dialog\"><md-list class=\"domains\"><md-list-item class=\"domain\" \nng-repeat=\"domain in domains | filter: { domain_name:vm.filters.contentFilterInput}\" ng-click=\"vm.setDomain(domain)\">\n<md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s18 md-avatar-icon\" style=\"color:{{domain.color}}\"></md-icon>\n<div class=\"md-list-item-text\"><h3>{{domain.domain_name}}</h3></div></md-list-item></md-list></md-content></div>");
$templateCache.put("app/main/apps/accounts/accounts.html","<div id=\"site-accounts\" class=\"page-layout carded left-sidenav\" layout=\"row\" md-no-ink><md-sidenav \nclass=\"sidenav sidenav-users\" md-component-id=\"main-sidenav\" \nng-include=\"\'app/main/apps/accounts/sidenavs/main/main-sidenav.html\'\" ms-scroll ms-sidenav-helper md-no-ink>\n</md-sidenav><div class=\"center\" layout=\"column\" flex><div class=\"content-card\" ng-class=\"vm.currentView\" \nlayout=\"column\" flex ng-include=\"vm.views[vm.currentView]\" md-no-ink></div></div><qiu-pagination \ncollection=\"vm.threads\" url=\"\'http://\'\" service=\"accountsService\" columns=\"vm.refcolumns\" \ncolumns-grouped=\"vm.refcolumnsgrouped\" fields-filters=\"vm.refFilterables\" custom-data=\"vm.customData\" \nmenu-filters=\"main-sidenav\" media-zones=\"refMediaZones\" fields-search=\"refSearch\" fields-sort=\"refSortables\" \nstyle=\"display:none\" groupby=\"list_position\"></qiu-pagination></div>");
$templateCache.put("app/main/apps/accounts/activities.html","<div id=\"site-accounts\" class=\"page-layout carded left-sidenav\" layout=\"row\" md-no-ink><md-sidenav \nclass=\"sidenav sidenav-users\" md-component-id=\"main-sidenav\" \nng-include=\"\'app/main/apps/content/sidenavs/main/main-sidenav.html\'\" ms-scroll ms-sidenav-helper md-no-ink>\n</md-sidenav><div class=\"center\" layout=\"column\" flex><div class=\"content-card\" layout=\"column\" flex md-no-ink><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/accounts/views/activities/toolbar.html\'\"></div><div class=\"content-wrapper\" flex=\"\" \nlayout=\"row\"><div class=\"content thread-list mail-list-pane scrollable\" flex=\"\" ms-scroll=\"vm.msScrollOptions\" \nid=\"thread-list\" ng-include=\"\'app/main/apps/accounts/views/activities/list-view.html\'\"></div></div></div></div>\n<qiu-pagination collection=\"vm.threads\" url=\"\'http://\'\" service=\"activitiesService\" menu-filters=\"main-sidenav\" \nfields-filters=\"refFilterables\" fields-search=\"refSearch\" fields-sort=\"refSortables\" sort-dir=\"DESC\" \nstyle=\"display:none\"></qiu-pagination></div>");
$templateCache.put("app/main/apps/ai/ai.html","<div id=\"site-ai\" class=\"page-layout carded left-sidenav\" layout=\"row\" md-no-ink><div class=\"center\" layout=\"column\" \nflex><div class=\"content-card\" ng-class=\"vm.currentView\" layout=\"column\" flex ng-include=\"vm.views[vm.currentView]\" \nmd-no-ink></div></div><qiu-pagination collection=\"vm.threads\" url=\"\'http://\'\" client-limit=\"500\" service=\"aiService\" \ncolumns=\"vm.refcolumns\" columns-grouped=\"vm.refcolumnsgrouped\" fields-filters=\"vm.refFilterables\" \ncustom-data=\"vm.customData\" menu-filters=\"main-sidenav\" media-zones=\"refMediaZones\" fields-search=\"refSearch\" \nfields-sort=\"refSortables\" style=\"display:none\" groupby=\"list_position\"></qiu-pagination></div>");
$templateCache.put("app/main/apps/ai/faces-upload.html","<div id=\"site-match-profile\" class=\"page-layout carded left-sidenav\" layout=\"row\" md-no-ink><div class=\"center\" \nlayout=\"column\" flex><div class=\"content-card\" ng-class=\"vm.currentView\" layout=\"column\" flex \nng-include=\"vm.views[\'grid\']\" md-no-ink></div></div><qiu-pagination collection=\"vm.threads\" url=\"\'http://\'\" \nclient-limit=\"500\" service=\"aiService\" columns=\"vm.refcolumns\" columns-grouped=\"vm.refcolumnsgrouped\" \nfields-filters=\"vm.refFilterables\" custom-data=\"vm.customData\" menu-filters=\"main-sidenav\" media-zones=\"refMediaZones\" \nfields-search=\"refSearch\" fields-sort=\"refSortables\" style=\"display:none\" groupby=\"list_position\"></qiu-pagination>\n</div>");
$templateCache.put("app/main/apps/ai/match-profile.html","<div id=\"site-match-profile\" class=\"page-layout carded left-sidenav\" layout=\"row\" md-no-ink><div class=\"center\" \nlayout=\"column\" flex><div class=\"content-card\" ng-class=\"vm.currentView\" layout=\"column\" flex \nng-include=\"vm.views[\'grid\']\" md-no-ink></div></div><qiu-pagination collection=\"vm.threads\" url=\"\'http://\'\" \nservice=\"aiService\" client-limit=\"500\" columns=\"vm.refcolumns\" columns-grouped=\"vm.refcolumnsgrouped\" \nfields-filters=\"vm.refFilterables\" custom-data=\"vm.customData\" menu-filters=\"main-sidenav\" media-zones=\"refMediaZones\" \nfields-search=\"refSearch\" fields-sort=\"refSortables\" style=\"display:none\" groupby=\"list_position\"></qiu-pagination>\n</div>");
$templateCache.put("app/main/apps/backend/backend.html","<div id=\"site-backend\" class=\"page-layout carded left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-component-id=\"main-sidenav\" ng-include=\"\'app/main/apps/backend/sidenavs/main/main-sidenav.html\'\" ms-scroll \nms-sidenav-helper md-no-ink></md-sidenav><div class=\"center\" layout=\"column\" flex><div class=\"content-card\" \nng-class=\"vm.currentView\" layout=\"column\" flex ng-include=\"vm.views[vm.currentView]\" md-no-ink></div></div>\n<qiu-pagination collection=\"vm.threads\" url=\"\'http://\'\" service=\"backendService\" columns=\"refcolumns\" \ncolumns-grouped=\"refcolumnsgrouped\" fields-filters=\"refFilterables\" menu-filters=\"main-sidenav\" \nmedia-zones=\"refMediaZones\" fields-search=\"refSearch\" fields-sort=\"refSortables\" fields-group=\"refGroupables\" \nstyle=\"display:none\" groupby=\"list_position\"></qiu-pagination></div>");
$templateCache.put("app/main/apps/calendar/calendar.html","<div id=\"calendar\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"header\" \nng-class=\"vm.currentMonthShort\"><div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div \nclass=\"header-top\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span \nclass=\"logo-text\" translate=\"CALENDAR.CALENDAR\">Calendar</span></div><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" aria-label=\"Search\" translate \ntranslate-attr-aria-label=\"CALENDAR.SEARCH\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><md-tooltip><span \ntranslate=\"CALENDAR.SEARCH\">Search</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.calendar.today()\" aria-label=\"Today\" translate translate-attr-aria-label=\"CALENDAR.TODAY\"><md-icon \nmd-font-icon=\"icon-calendar-today\"></md-icon><md-tooltip><span translate=\"CALENDAR.TODAY\">Today</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'agendaDay\')\" aria-label=\"Day\" \ntranslate translate-attr-aria-label=\"CALENDAR.DAY\"><md-icon md-font-icon=\"icon-view-day\"></md-icon><md-tooltip><span \ntranslate=\"CALENDAR.DAY\">Day</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.calendar.changeView(\'agendaWeek\')\" aria-label=\"Week\" translate translate-attr-aria-label=\"CALENDAR.WEEK\">\n<md-icon md-font-icon=\"icon-view-week\"></md-icon><md-tooltip><span translate=\"CALENDAR.WEEK\">Week</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'month\')\" aria-label=\"Month\" translate \ntranslate-attr-aria-label=\"CALENDAR.MONTH\"><md-icon md-font-icon=\"icon-view-module\"></md-icon><md-tooltip><span \ntranslate=\"CALENDAR.MONTH\">Month</span></md-tooltip></md-button></div></div><div class=\"header-bottom\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-icon-button arrow\" ng-click=\"vm.calendar.prev()\" \naria-label=\"Previous\" translate translate-attr-aria-label=\"CALENDAR.PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><div class=\"title\">{{vm.calendarView.title}}</div><md-button \nclass=\"md-icon-button arrow\" ng-click=\"vm.calendar.next()\" aria-label=\"Next\" translate \ntranslate-attr-aria-label=\"CALENDAR.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div>\n<md-button class=\"add-event-button md-fab md-warn\" ng-click=\"vm.addEvent($event)\" aria-label=\"Add event\" translate \ntranslate-attr-aria-label=\"CALENDAR.ADD_EVENT\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div \nclass=\"content\"><div id=\"calendarView\" ui-calendar=\"vm.calendarUiConfig.calendar\" ng-model=\"vm.events\" calendar=\"main\">\n</div></div></div>");
$templateCache.put("app/main/apps/dashboards/dashboard-project.html","<div id=\"dashboard-project\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex ms-scroll>\n<div class=\"header\" layout=\"column\" layout-align=\"center center\"><div layout=\"row\" layout-align=\"space-between\"><div \nlayout=\"column\" layout-align=\"center center\"><img class=\"avatar mb-20\" \nng-src=\"/assets/images/logos/sites/{{site_operative.icon}}\"> <span \nclass=\"md-display-1 font-weight-300 white-fg text-center\">Welcome to {{site_operative.domain_name}}!</span></div><div \nclass=\"toolbar\" hide><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" \nhide-gt-md aria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div>\n</div></div><div class=\"content\"></div></div></div>");
$templateCache.put("app/main/apps/dashboards/dashboard.html","<div id=\"dashboard\" class=\"small-view grey-100-bg pt-20\"><div class=\"ph-15 dashboard-top\" layout=\"row\" \nlayout-align=\"space-between center\"><h2 class=\"font-size-28 mv-10\">Dashboard</h2><div layout=\"row\" \nlayout-align=\"end center\"><md-select ng-change=\"vm.loadUsers();vm.loadActivity(); vm.loadDailyStats()\" \nng-model=\"vm.timeSelector\" class=\"font-size-16\"><md-option value=\"last-week\">{{ \'DASHBOARD.LAST_WEEK\' | translate}}\n</md-option><md-option value=\"last-month\">{{ \'DASHBOARD.LAST_MONTH\' | translate}}</md-option><md-option \nvalue=\"three-months\">{{ \'DASHBOARD.THREE_MONTHS\' | translate}}</md-option></md-select></div></div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><div \nng-if=\"vm.isLoadingActivity || vm.isLoadingUsers || vm.isLoadingDownloadsStats || vm.isLoadingVisits\" \nclass=\"loading-container\" flex layout=\"column\" layout-align=\"center center\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><ms-widget id=\"registered-users\" \nflippable=\"false\" layout=\"row\" flex-xs=\"100\" flex-gt-xs=\"50\" flex-gt-lg=\"33\"><ms-widget-front class=\"ms-widget-front\">\n<div class=\"ph-20 md-accent-bg dashboard-featured-data\" layout=\"row\" layout-align=\"space-around center\"><div \nclass=\"font-size-110 line-height-100 font-weight-200\">{{vm.total}}</div><div \nclass=\"font-size-20 text-center h3 secondary-text font-weight-500\">REGISTERED<br>USERS</div></div><div \nclass=\"white-bg dashboard-list scrollable\" ms-scroll=\"vm.msScrollOptions\"><div ng-if=\"vm.usersRegistered.length> 0\" \nng-repeat=\"user in vm.usersRegistered\" class=\"dashboard-list-element ph-16 pv-10 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div><div ng-if=\"user.firstname || user.lastname\" class=\"h4\">\n{{user.firstname}} {{user.lastname}}</div><div ng-if=\"!user.firstname && !user.lastname\" class=\"h4\">--</div><div><span \nclass=\"secondary-text\">{{user.email}}</span></div></div><md-icon md-font-icon=\"icon-chevron-right\" role=\"img\" \naria-hidden=\"true\" class=\"mr-0 md-icon-button\"></md-icon></div><div ng-if=\"vm.usersRegistered.length == 0\"><h3 \nclass=\"text-center\" translate=\"DASHBOARD.NO_ITEMS_FOUND\"></h3></div></div></ms-widget-front></ms-widget><ms-widget \nid=\"top-downloads\" flippable=\"false\" layout=\"row\" flex-xs=\"100\" flex-gt-xs=\"50\" flex-gt-lg=\"33\"><ms-widget-front \nclass=\"ms-widget-front small\"><div class=\"ph-20 md-warn-bg dashboard-featured-data\" layout=\"row\" \nlayout-align=\"space-around center\"><div class=\"font-size-110 line-height-100 font-weight-200\">--</div><div \nclass=\"font-size-20 text-center h3 secondary-text font-weight-500\">TOTAL<br>DOWNLOADS</div></div><div \nclass=\"white-bg dashboard-list featured files-list scrollable\" ms-scroll=\"vm.msScrollOptions\"><div \nng-repeat=\"element in vm.rankingDownloads\" class=\"dashboard-list-element ph-16 pv-10 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><qiu-icon \nmediafile=\"element.filename\"></qiu-icon><div lyout=\"column\" layout-align=\"center start\"><div layout=\"row\" \nlayout-align=\"start center\"><span class=\"secondary-text\">ID #{{element.id_media}}</span></div><div class=\"h4\">\n{{element.filename}}</div></div></div><span class=\"downloads-times\">{{element.mediacenter.downloads}}</span></div>\n</div></ms-widget-front></ms-widget><ms-widget id=\"activity\" flippable=\"false\" layout=\"row\" flex=\"100\" flex-gt-lg=\"33\">\n<ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap=\"\"><div class=\"pv-8 h3\">Activity</div><div class=\"pv-8\" layout=\"row\" \nlayout-align=\"start center\" layout-align-sm=\"end\"><button ng-click=\"vm.setFilter(null)\" \nclass=\"ph-16 md-small md-button md-ink-ripple\" ng-class=\"{\'active\' : !vm.filter}\" type=\"button\">ALL</button> <button \nng-click=\"vm.setFilter(\'downloads\')\" class=\"ph-16 md-small md-button md-ink-ripple\" ng-class=\"{\'active\' : vm.filter}\" \ntype=\"button\">DOWNLOADS</button></div></div><div layout=\"column\" layout-align=\"stretch start\" \nms-scroll=\"vm.msScrollOptions\" class=\"scrollable h-445\"><div hide class=\"content\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"message\" translate=\"DASHBOARD.NO_ACTIVITY\"></div></div><div id=\"timeline\" \nclass=\"timeline-left ms-timeline\"><div class=\"day\" \nng-repeat=\"(key, value) in vm.activityFiltered | groupBy: \'dateWithoutHours\'\"><div class=\"date\">{{key}}</div><div \nclass=\"ms-timeline-item\" layout=\"row\" layout-align=\"space-between center\" ng-repeat=\"event in value\"><div \nclass=\"timeline-point md-accent-bg\" ng-switch=\"event.action_id\"><md-icon md-font-icon=\"icon-tumblr-reblog\" \nng-switch-when=\"load-in\"></md-icon><md-icon md-font-icon=\"icon-logout\" ng-switch-when=\"logged-out\"></md-icon><md-icon \nmd-font-icon=\"icon-folder-plus\" ng-switch-when=\"media-added-to-light-box\"></md-icon><md-icon \nmd-font-icon=\"icon-folder-remove\" ng-switch-when=\"media-removed-from-light-box\"></md-icon><md-icon \nmd-font-icon=\"icon-login\" ng-switch-when=\"succesfull-login\"></md-icon><md-icon md-font-icon=\"icon-cloud-download\" \nng-switch-when=\"user-download-media\"></md-icon><md-icon md-font-icon=\"icon-cloud-download\" \nng-switch-when=\"user-download-media-with-crop\"></md-icon></div><div class=\"timeline-detail\" flex layout=\"row\" \nlayout-align=\"start center\"><h4 class=\"name mt-0 mb-0 ml-5\" flex=\"80\" layout=\"column\" layout-align=\"center start\" \nlayout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><strong flex-gt-xs=\"50\" flex-xs=\"100\">\n{{event.user.firstname}} {{event.user.lastname}}</strong><div class=\"event\" flex-gt-xs=\"50\" flex-xs=\"100\">\n{{vm.translate(\'USERS.\'+event.action_id.toUpperCase())}} <a class=\"pointer\" \nng-click=\"vm.openImageDialog($event, event.action_brief.link, false, false, true)\" target=\"_blank\">\n{{event.action_brief.name}}</a></div></h4><div class=\"timeline-detail\" layout=\"row\" flex=\"20\" \nlayout-align=\"start center\"><div class=\"time\" ng-bind-html=\"vm.timeAgo(event.date)\"></div></div></div></div></div>\n</div></div></ms-widget-front></ms-widget><ms-widget id=\"dailyCount\" flippable=\"false\" layout=\"column\" fill-width \nflex=\"100\" class=\"ms-widget\"><ms-widget-front layout=\"column\" fill-width class=\"white-bg\"><div \nclass=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\" layout-wrap=\"\"><div class=\"pv-8 h3\">\nUser trail</div><div class=\"pv-8\" layout=\"row\" layout-align=\"start center\" layout-align-sm=\"end\"><button \nng-click=\"vm.setCharData(\'visits\')\" class=\"ph-16 md-small md-button md-ink-ripple\" \nng-class=\"{\'active\': vm.charDataType == \'visits\'}\" type=\"button\">{{ \'DASHBOARD.VISITS\' | translate}}</button> <button \nng-click=\"vm.setCharData(\'downloads\')\" class=\"ph-16 md-small md-button md-ink-ripple\" \nng-class=\"{\'active\': vm.charDataType == \'downloads\'}\" type=\"button\">{{ \'DASHBOARD.DOWNLOADS\' | translate}}</button>\n</div></div><nvd3 options=\"vm.options\" data=\"vm.data\"></nvd3></ms-widget-front></ms-widget></div></div>");
$templateCache.put("app/main/apps/content/content-social-stream.html","<div id=\"site-content-social\" class=\"page-layout carded left-sidenav\" layout=\"row\" md-no-ink><md-sidenav \nclass=\"sidenav\" md-component-id=\"main-sidenav\" \nng-include=\"\'app/main/apps/content/sidenavs/main/main-sidenav-social-stream.html\'\" ms-scroll ms-sidenav-helper \nmd-no-ink></md-sidenav><div class=\"center\" layout=\"column\" flex><div class=\"content-card\" \nng-class=\"{\'split\':vm.currentView==\'split\', \'nosplit\':vm.currentView==\'nosplit\',\'edited\':vm.currentView==\'split\'}\" \nlayout=\"column\" flex ng-include=\"vm.views[vm.currentView]\" md-no-ink></div></div><qiu-pagination \ncollection=\"vm.threads\" url=\"\'http://\'\" service=\"contentService\" columns=\"refcolumns\" \ncolumns-grouped=\"refcolumnsgrouped\" fields-filters=\"refFilterables\" menu-filters=\"main-sidenav\" \nmedia-zones=\"refMediaZones\" fields-search=\"refSearch\" fields-sort=\"refSortables\" fields-group=\"refGroupables\" \nstyle=\"display:none\" groupby=\"list_position\"></qiu-pagination></div>");
$templateCache.put("app/main/apps/content/content.html","<div id=\"site-content\" class=\"page-layout carded left-sidenav\" layout=\"row\" md-no-ink><md-sidenav class=\"sidenav\" \nmd-component-id=\"main-sidenav\" ng-include=\"\'app/main/apps/content/sidenavs/main/main-sidenav.html\'\" ms-scroll \nms-sidenav-helper md-no-ink></md-sidenav><div class=\"center\" layout=\"column\" flex><div class=\"content-card\" \nng-class=\"vm.currentView\" layout=\"column\" flex ng-include=\"vm.views[vm.currentView]\" md-no-ink></div></div>\n<qiu-pagination collection=\"vm.threads\" url=\"\'http://\'\" service=\"contentService\" columns=\"refcolumns\" \ncolumns-grouped=\"refcolumnsgrouped\" fields-filters=\"refFilterables\" menu-filters=\"main-sidenav\" \nmedia-zones=\"refMediaZones\" fields-search=\"refSearch\" fields-sort=\"refSortables\" fields-group=\"refGroupables\" \nstyle=\"display:none\" groupby=\"list_position\"></qiu-pagination></div><div class=\"processing-translations-container\" \nng-if=\"vm.translationLoading\"><div class=\"content\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\">\n</md-progress-circular><span translate=\"CONTENT.PROCESSING_TRANSLATION\"></span></div></div><div \nclass=\"translations-in-progress-badge\" ng-if=\"vm.translationsInProgress > 0\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"18\"></md-progress-circular><span>{{ vm.translationsInProgress }}&nbsp;<span \ntranslate=\"CONTENT.TRANSLATIONS_IN_PROGRESS\"></span></span></div>");
$templateCache.put("app/main/apps/content/content_.html","<div id=\"mail\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><md-sidenav \nclass=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" \nng-include=\"\'app/main/apps/content/sidenavs/main/main-sidenav.html\'\" ms-scroll ms-sidenav-helper></md-sidenav><p>\n\"siendo 2\"</p><div class=\"center\" layout=\"column\" flex><div class=\"content-card\" ng-class=\"vm.currentView\" \nlayout=\"column\" flex ng-include=\"vm.views[vm.currentView]\"></div></div><bgf-pagination collection=\"vm.inbox\" \ncolumns=\"refcolumns\" columns-grouped=\"refcolumnsgrouped\" fields-filters=\"refFilterables\" fields-sort=\"refSortables\" \ngroupby=\"list_position\" service=\"contentService\" style=\"display:none\" url=\"\'http://\'\"></bgf-pagination></div><div \nclass=\"page-layout carded left-sidenav hidden\" id=\"site-content\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-component-id=\"main-sidenav\" ms-scroll=\"\" ms-sidenav-helper=\"\" \nng-include=\"\'app/main/apps/content/sidenavs/main/main-sidenav.html\'\"></md-sidenav><div class=\"center\" flex=\"\" \nlayout=\"column\"><div class=\"content-card\" flex=\"\" layout=\"column\"><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"vm.activeMailPaneIndex === 0\"><div layout=\"row\" layout-align=\"start center\">\n<md-checkbox aria-label=\"{{vm.allChecked?\'Uncheck All\':\'Check All\'}}\" class=\"no-label\" hide=\"\" \nng-checked=\"vm.allChecked\" ng-click=\"vm.checkAll()\" show-gt-xs=\"\"></md-checkbox><md-menu hide=\"\" show-gt-xs=\"\"><button \naria-label=\"Filters\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.FILTERS\"><md-icon md-font-icon=\"icon-chevron-down\"></md-icon></button>\n<md-menu-content width=\"3\"><md-menu-item><md-button aria-label=\"All\" translate=\"CONTENT.ALL\" \ntranslate-attr-aria-label=\"CONTENT.ALL\">All</md-button></md-menu-item><md-menu-item><md-button aria-label=\"Page\" \nng-click=\"vm.checkAll()\" translate=\"CONTENT.INPAGE\" translate-attr-aria-label=\"CONTENT.INPAGE\">In this page</md-button>\n</md-menu-item></md-menu-content></md-menu><div class=\"divider-vertical\" hide=\"\" show-gt-xs=\"\"></div><div \naria-hidden=\"false\" class=\"action-buttons hide show-gt-xs layout-align-start-center layout-row\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"vm.selectedMail.length > 0 || vm.allChecked\"><md-button aria-label=\"Duplicate\" \nclass=\"md-icon-button\" hide=\"\" show-gt-sm=\"\" translate=\"\" translate-attr-aria-label=\"CONTENT.DUPLICATE\"><md-icon \nmd-font-icon=\"icon-content-duplicate\"></md-icon><md-tooltip><span translate=\"CONTENT.DUPLICATE\">Duplicate</span>\n</md-tooltip></md-button><md-button aria-label=\"Export\" class=\"md-icon-button\" hide=\"\" show-gt-sm=\"\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.EXPORT\"><md-icon md-font-icon=\"icon-export\"></md-icon><md-tooltip><span \ntranslate=\"CONTENT.EXPORT\">Export</span></md-tooltip></md-button><md-button aria-label=\"Delete\" class=\"md-icon-button\" \nhide=\"\" show-gt-sm=\"\" translate=\"\" translate-attr-aria-label=\"CONTENT.DELETE\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon><md-tooltip><span translate=\"CONTENT.DELETE\">Delete</span></md-tooltip></md-button><div \nclass=\"divider-vertical\" hide=\"\" show-gt-xs=\"\"></div></div><ms-search-bar class=\"ms-search-bar ng-isolate-scope\" \ndebounce=\"300\" on-result-click=\"vm.searchResultClick(item)\" on-search=\"vm.search(query)\"><div \nclass=\"layout-align-start-center layout-row flex\" flex=\"\" layout=\"row\" layout-align=\"start center\"><label \nfor=\"ms-search-bar-input\"><button aria-label=\"Expand Search Bar\" \nclass=\"ms-search-bar-expander md-icon-button md-button ng-scope md-ink-ripple md-default-theme\" \nng-click=\"MsSearchBar.expand()\" ng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\" ng-transclude=\"\" \ntype=\"button\"><md-icon class=\"icon s24 ng-scope md-font icon-magnify\" md-font-icon=\"icon-magnify\"></md-icon><div \nclass=\"md-ripple-container\"></div></button></label><input aria-invalid=\"false\" \nclass=\"ng-pristine ng-valid flex ng-empty ng-touched\" flex=\"\" id=\"ms-search-bar-input\" md-autofocus=\"\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\" ng-model=\"MsSearchBar.query\" \nng-model-options=\"MsSearchBar.queryOptions\" placeholder=\"Search\" type=\"text\"> <button aria-label=\"Collapse Search Bar\" \nclass=\"ms-search-bar-collapser md-icon-button md-button md-ink-ripple md-default-theme\" \nng-click=\"MsSearchBar.collapse()\" ng-transclude=\"\" type=\"button\"><md-icon aria-hidden=\"true\" \nclass=\"icon s24 ng-scope md-font icon-close material-icons md-default-theme\" md-font-icon=\"icon-close\"></md-icon><div \nclass=\"md-ripple-container\"></div></button></div></ms-search-bar><md-button aria-label=\"view type\" \nclass=\"md-icon-button\" hide=\"\" ng-click=\"vm.toggleSidenav(\'main-sidenav\')\" show-gt-xs=\"\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.ADVANCED\"><md-icon md-font-icon=\"icon-magnify-plus\"></md-icon><md-tooltip><span \ntranslate=\"CONTENT.ADVANCED\">Advanced</span></md-tooltip></md-button><div class=\"divider-vertical\" hide=\"\" \nshow-gt-xs=\"\"></div><md-button aria-label=\"ADD NEW\" \nclass=\"md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme hide-xs\" \nng-click=\"vm.openTaskDialog($event)\" ng-transclude=\"\" translate=\"CONTENT.ADD\" type=\"button\">Add new</md-button>\n<md-button aria-label=\"ADD NEW\" \nclass=\"md-fab md-mini md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme hide-gt-xs\" \nng-click=\"vm.openTaskDialog($event)\" ng-transclude=\"\" type=\"button\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n</md-button></div><div layout=\"row\" layout-align=\"start center\" translate-attr-aria-label=\"CONTENT.REFRESH\"><md-button \naria-label=\"view type\" class=\"md-icon-button\" hide=\"\" ng-click=\"vm.toggleView(\'grid\')\" show-gt-xs=\"\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.GRID_VIEW\"><md-icon md-font-icon=\"icon-view-module\"></md-icon><md-tooltip><span \ntranslate=\"CONTENT.GRID_VIEW\">Grid View</span></md-tooltip></md-button><md-button aria-label=\"view type\" \nclass=\"md-icon-button\" hide=\"\" ng-click=\"vm.toggleView(\'list\')\" show-gt-xs=\"\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.LIST_VIEW\"><md-icon md-font-icon=\"icon-view-headline\"></md-icon><md-tooltip><span \ntranslate=\"CONTENT.LIST_VIEW\">List View</span></md-tooltip></md-button><div class=\"divider-vertical\" hide=\"\" \nshow-gt-xs=\"\"></div><md-button aria-label=\"Sort Direction\" class=\"md-icon-button\" \nng-click=\"sortable.order == \'DESC\' ? sortable.order =\'ASC\' : sortable.order = \'DESC\'\" ng-disabled=\"!sortable\" \ntranslate=\"\" translate-attr-aria-label=\"TODO.SORT_DIRECTION\"><md-icon md-font-icon=\"icon-sort-ascending\" \nng-if=\"sortable.order !== \'ASC\'\"></md-icon><md-icon md-font-icon=\"icon-sort-descending\" \nng-if=\"sortable.order === \'ASC\'\"></md-icon></md-button><md-menu hide=\"\" show-gt-xs=\"\"><button aria-label=\"Filters\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" show-gt-xs=\"\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.FILTERS\"><md-icon md-font-icon=\"icon-chevron-down\"></md-icon></button>\n<md-menu-content width=\"3\"><md-menu-item ng-repeat=\"sortfield in refSortables\"><md-button aria-label=\"All\" \nng-click=\"pagination_setOrderBy(sortfield)\"><div layout=\"row\" layout-align=\"space-between center\"><span>\nOrder by {{sortfield.name}} </span><i class=\"icon-check s16\" ng-if=\"sortfield.titleId == sortable.titleId\"></i></div>\n</md-button></md-menu-item></md-menu-content></md-menu><md-menu hide-gt-xs=\"\" \nng-show=\"vm.selectedMail.length > 0 || vm.allChecked\"><md-button aria-label=\"Mail Actions\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\" translate=\"\" translate-attr-aria-label=\"CONTENT.ACTIONS\"><md-icon \nmd-font-icon=\"icon-cog\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \naria-label=\"Duplicate\" translate-attr-aria-label=\"CONTENT.DUPLICATE\"><md-icon md-font-icon=\"icon-folder-move\">\n</md-icon><span translate=\"CONTENT.DUPLICATE\">Duplicate</span></md-button></md-menu-item><md-menu-item><md-button \naria-label=\"Export\" translate-attr-aria-label=\"CONTENT.EXPORT\"><md-icon md-font-icon=\"icon-folder-move\"></md-icon><span\n translate=\"CONTENT.EXPORT\">Export</span></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Delete\" \ntranslate-aria-label=\"CONTENT.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span translate=\"CONTENT.DELETE\">\nDelete</span></md-button></md-menu-item></md-menu-content></md-menu><div class=\"divider-vertical\" hide=\"\" \nshow-gt-xs=\"\"></div><span class=\"page-info\" hide=\"\" show-gt-xs=\"\">\n{{pagination_from}} – {{pagination_to}} of {{pagination_totalItems}}</span><md-button aria-label=\"Previous\" \nclass=\"md-icon-button arrow\" hide=\"\" ng-click=\"pagination_prevPage()\" ng-disabled=\"pagination_firstPage()\" \nshow-gt-xs=\"\" translate=\"\" translate-attr-aria-label=\"CONTENT.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon><md-tooltip><span translate=\"CONTENT.PREVIOUS\">Previous</span></md-tooltip></md-button><md-button \naria-label=\"Next\" class=\"md-icon-button arrow\" hide=\"\" ng-click=\"pagination_nextPage()\" \nng-disabled=\"pagination_morePages()\" show-gt-xs=\"\" translate=\"\" translate-attr-aria-label=\"CONTENT.NEXT\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span translate=\"CONTENT.NEXT\">Next</span></md-tooltip>\n</md-button></div></div><div class=\"content-wrapper\" flex=\"\" layout=\"row\"><md-tabs class=\"mail-tabs\" flex=\"\" \nmd-dynamic-height=\"{{vm.dynamicHeight}}\" md-selected=\"vm.activeMailPaneIndex\" ng-if=\"vm.currentView === \'list\'\">\n<md-tab><md-tab-label>Mails</md-tab-label><md-tab-body><div class=\"content mail-list-pane\" ms-scroll=\"\" \nng-if=\"vm.currentView === \'list\'\" ng-include=\"\'app/main/apps/content/views/list/list-view.html\'\"></div></md-tab-body>\n</md-tab><md-tab><md-tab-label>Read Pane</md-tab-label><md-tab-body><div class=\"content mail-read-pane\" ms-scroll=\"\" \nng-include=\"\'app/main/apps/content/views/read/read-view.html\'\"></div></md-tab-body></md-tab></md-tabs><md-tabs \nclass=\"mail-tabs-grid\" flex=\"\" md-dynamic-height=\"{{vm.dynamicHeight}}\" md-selected=\"vm.activeMailPaneIndex\" \nng-if=\"vm.currentView === \'grid\'\"><md-tab><md-tab-label>Mails</md-tab-label><md-tab-body><md-content \nclass=\"content mail-list-pane-grid\" flex=\"\" ms-scroll=\"\" \nng-include=\"\'app/main/apps/content/views/grid/grid-view.html\'\"></md-content></md-tab-body></md-tab></md-tabs></div>\n</div></div></div><md-tab><md-tab-label>Read Pane</md-tab-label><md-tab-body><div class=\"content mail-read-pane\" \nms-scroll=\"\" ng-include=\"\'app/main/apps/content/views/read/read-view.html\'\"></div></md-tab-body></md-tab>");
$templateCache.put("app/main/apps/forms/forms.html","<div id=\"site-forms\" class=\"page-layout carded left-sidenav\" layout=\"row\" md-no-ink><div class=\"center\" \nlayout=\"column\" flex><div class=\"content-card\" ng-class=\"vm.currentView\" layout=\"column\" flex \nng-include=\"vm.views[vm.currentView]\" md-no-ink></div></div><qiu-pagination collection=\"vm.threads\" url=\"\'http://\'\" \nservice=\"formsService\" columns=\"refcolumns\" columns-grouped=\"refcolumnsgrouped\" fields-filters=\"refFilterables\" \nmedia-zones=\"refMediaZones\" fields-search=\"refSearch\" fields-sort=\"refSortables\" fields-group=\"refGroupables\" \ngroupby=\"list_position\"></qiu-pagination></div>");
$templateCache.put("app/main/apps/file-manager/file-manager.html","<div id=\"file-manager\" class=\"page-layout simple right-sidenav\" layout=\"row\"><md-sidenav class=\"main-sidenav\" \nmd-component-id=\"main-sidenav\" ng-include=\"\'app/main/apps/file-manager/sidenavs/main/main-sidenav.html\'\" ms-scroll \nms-sidenav-helper></md-sidenav><div class=\"center\" layout=\"column\" flex><div class=\"header md-accent-bg\"><div \nclass=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"space-between\"><md-button class=\"md-icon-button main-sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'main-sidenav\')\" aria-label=\"Toggle Main Sidenav\" translate \ntranslate-attr-aria-label=\"FILE.TOOGLE_MAIN_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"right-side\" layout=\"row\"><md-button class=\"md-icon-button\" aria-label=\"Search\" translate \ntranslate-attr-aria-label=\"FM.SEARCH\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><md-tooltip><span \ntranslate=\"FM.SEARCH\">Search</span></md-tooltip></md-button><md-button ng-if=\"vm.currentView === \'list\'\" \nclass=\"md-icon-button\" ng-click=\"vm.toggleView()\" aria-label=\"view type\" translate \ntranslate-attr-aria-label=\"FM.GRID_VIEW\"><md-icon md-font-icon=\"icon-view-module\"></md-icon><md-tooltip><span \ntranslate=\"FM.GRID_VIEW\">Grid View</span></md-tooltip></md-button><md-button ng-if=\"vm.currentView === \'grid\'\" \nclass=\"md-icon-button\" aria-label=\"view type\" ng-click=\"vm.toggleView()\" translate \ntranslate-attr-aria-label=\"FM.LIST_VIEW\"><md-icon md-font-icon=\"icon-view-headline\"></md-icon><md-tooltip><span \ntranslate=\"FM.LIST_VIEW\">List View</span></md-tooltip></md-button></div></div><div class=\"breadcrumb text-truncate\" \nlayout=\"row\" layout-align=\"start center\"><span data-ng-repeat=\"path in vm.path\">{{path}}<md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"icon separator\"></md-icon></span></div></div><md-button \nclass=\"add-file-button md-fab md-warn\" ng-click=\"vm.addFile($event)\" aria-label=\"Add file\" translate \ntranslate-attr-aria-label=\"FM.ADD_FILE\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><md-content \nclass=\"content\" flex ms-scroll><div ng-if=\"vm.currentView === \'grid\'\" \nng-include=\"\'app/main/apps/file-manager/views/grid/grid-view.html\'\"></div><div ng-if=\"vm.currentView === \'list\'\" \nng-include=\"\'app/main/apps/file-manager/views/list/list-view.html\'\"></div></md-content></div><md-sidenav \nclass=\"sidenav details-sidenav md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" \nmd-component-id=\"details-sidenav\" ng-include=\"\'app/main/apps/file-manager/sidenavs/details/details-sidenav.html\'\" \nms-scroll ms-sidenav-helper></md-sidenav></div>");
$templateCache.put("app/main/apps/gantt-chart/gantt-chart.html","<div id=\"gantt-chart\" class=\"page-layout carded fullwidth\" \nng-class=\"{\'date-filter-active\':vm.dateFilterActive, \'search-active\': vm.searchActive}\" layout=\"row\"><md-sidenav \nclass=\"sidenav settings-sidenav md-sidenav-right\" md-component-id=\"settings-sidenav\" \nng-include=\"\'app/main/apps/gantt-chart/sidenavs/settings/settings-sidenav.html\'\" ms-scroll ms-sidenav-helper>\n</md-sidenav><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" \nlayout=\"column\"><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-text\" class=\"icon\"></md-icon>\n</span><span class=\"logo-text\" translate=\"GANTT.GANTT_CHART\">Gantt Chart</span></div><div layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"vm.searchActive = !vm.searchActive\" \naria-label=\"Search\" translate translate-attr-aria-label=\"GANTT.SEARCH\"><md-icon md-font-icon=\"icon-magnify\"></md-icon>\n<md-tooltip><span translate=\"GANTT.SEARCH\">Search</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.dateFilterActive = !vm.dateFilterActive\" aria-label=\"Filter Date\" translate \ntranslate-attr-aria-label=\"GANTT.FILTER_DATE\"><md-icon md-font-icon=\"icon-calendar\"></md-icon><md-tooltip><span \ntranslate=\"GANTT.FILTER_DATE\">Filter Date</span></md-tooltip></md-button><md-button ng-click=\"vm.reload()\" \nclass=\"md-icon-button\" aria-label=\"Reload\" translate translate-attr-aria-label=\"GANTT.RELOAD\"><md-icon \nmd-font-icon=\"icon-reload\"></md-icon><md-tooltip><span translate=\"GANTT.RELOAD\">RELOAD</span></md-tooltip></md-button>\n<md-button ng-click=\"vm.toggleSidenav(\'settings-sidenav\')\" class=\"md-icon-button\" aria-label=\"Settings\" translate \ntranslate-attr-aria-label=\"GANTT.SETTINGS\"><md-icon md-font-icon=\"icon-cog\"></md-icon><md-tooltip><span \ntranslate=\"GANTT.SETTINGS\">Settings</span></md-tooltip></md-button></div></div><div class=\"bottom\" layout=\"column\" \nlayout-gt-sm=\"row\" layout-align-gt-sm=\"end center\"><div class=\"search-boxes\" flex ng-show=\"vm.searchActive\" \nlayout=\"column\" layout-gt-xs=\"row\"><div class=\"search md-whiteframe-3dp mr-8\" flex layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input flex \nng-model=\"vm.searchRowKeyword\" ng-change=\"vm.search(\'rows\', vm.searchRowKeyword)\" type=\"text\" \nplaceholder=\"Search in rows\" translate translate-attr-placeholder=\"GANTT.SEARCH_IN_ROWS\"></div><div \nclass=\"search md-whiteframe-3dp\" flex layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon s24\"></md-icon><input flex ng-model=\"vm.searchTaskKeyword\" \nng-change=\"vm.search(\'tasks\', vm.searchTaskKeyword)\" type=\"text\" placeholder=\"Search in tasks\" translate \ntranslate-attr-placeholder=\"GANTT.SEARCH_IN_TASKS\"></div></div><div class=\"date-filter-box md-whiteframe-3dp\" \nng-show=\"vm.dateFilterActive\" layout=\"column\" layout-gt-xs=\"row\" layout-align-gt-xs=\"center center\"><div layout=\"row\" \nlayout-align=\"center center\" class=\"filter from\"><span class=\"label\">From:</span><md-datepicker ms-datepicker-fix \nng-model=\"vm.options.fromDate\" md-max-date=\"vm.options.toDate\" md-placeholder=\"Enter date\"></md-datepicker></div><div \nlayout=\"row\" layout-align=\"center center\" class=\"filter to\"><span class=\"label\">To:</span><md-datepicker \nms-datepicker-fix ng-model=\"vm.options.toDate\" md-min-date=\"vm.options.fromDate\" md-placeholder=\"Enter date\">\n</md-datepicker></div></div></div></div><div class=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nng-click=\"vm.addDialog($event)\" class=\"md-icon-button add-row-button\" aria-label=\"Add\" translate \ntranslate-attr-aria-label=\"GANTT.ADD\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"zoom\" layout=\"row\" layout-align=\"end center\"><span class=\"label\">Zoom:</span>\n<div class=\"input-wrapper\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-icon-button\" \naria-label=\"minus\" ng-click=\"vm.options.zoom  = vm.options.zoom - 0.1\"><md-icon md-font-icon=\"icon-minus\"></md-icon>\n</md-button><input type=\"number\" ng-model=\"vm.options.zoom\" step=\"0.1\" min=\"0.1\" max=\"5\"><md-button \nclass=\"md-icon-button\" aria-label=\"plus\" ng-click=\"vm.options.zoom =vm.options.zoom + 0.1\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div></div><md-select class=\"simplified select-scale\" \nng-model=\"vm.options.scale\" placeholder=\"Scale\"><md-option value=\"hour\" translate=\"GANTT.HOUR\">hour</md-option>\n<md-option value=\"3 hours\" translate=\"GANTT.3_HOURS\">3 hours</md-option><md-option value=\"day\" translate=\"GANTT.DAY\">\nday</md-option><md-option value=\"week\" translate=\"GANTT.WEEK\">week</md-option><md-option value=\"2 weeks\" \ntranslate=\"GANTT.2_WEEKS\">2 weeks</md-option><md-option value=\"month\" translate=\"GANTT.MONTH\">month</md-option>\n<md-option value=\"quarter\" translate=\"GANTT.QUARTER\">quarter</md-option><md-option value=\"6 months\" \ntranslate=\"GANTT.6_MONTHS\">6 months</md-option><md-option value=\"year\" translate=\"GANTT.YEAR\">year</md-option>\n</md-select><div class=\"divider-vertical\"></div><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\" aria-label=\"Filters\" translate translate-attr-aria-label=\"MAIL.FILTERS\"><md-icon \nmd-font-icon=\"icon-sort\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \naria-label=\"disabled\" ng-click=\"vm.setSortMode(undefined)\" translate=\"GANTT.DISABLED\" \ntranslate-attr-aria-label=\"GANTT.DISABLED\">disabled</md-button></md-menu-item><md-menu-item><md-button \naria-label=\"disabled\" ng-click=\"vm.setSortMode(\'from\')\" translate=\"GANTT.FROM\" translate-attr-aria-label=\"GANTT.FROM\">\nfrom</md-button></md-menu-item><md-menu-item><md-button aria-label=\"disabled\" ng-click=\"vm.setSortMode(\'to\')\" \ntranslate=\"GANTT.TO\" translate-attr-aria-label=\"GANTT.TO\">to</md-button></md-menu-item><md-menu-item><md-button \naria-label=\"disabled\" ng-click=\"vm.setSortMode(\'model.name\')\" translate=\"GANTT.NAME\" \ntranslate-attr-aria-label=\"GANTT.NAME\">name</md-button></md-menu-item></md-menu-content></md-menu></div></div>\n<md-content id=\"chart-container\" class=\"content\" flex layout=\"column\"><div flex layout-fill id=\"gantt\" gantt \ndata=\"vm.data\" timespans=\"vm.timespans\" show-side=\"vm.options.labelsEnabled\" daily=\"vm.options.daily\" \nfilter-task=\"{\'name\': vm.options.filterTask}\" filter-row=\"{\'name\': vm.options.filterRow}\" \nsort-mode=\"vm.options.sortMode\" view-scale=\"vm.options.scale\" \ncolumn-width=\"vm.getColumnWidth(vm.options.width, vm.options.scale, vm.options.zoom)\" \nauto-expand=\"vm.options.autoExpand\" task-out-of-range=\"vm.options.taskOutOfRange\" from-date=\"vm.options.fromDate\" \nto-date=\"vm.options.toDate\" allow-side-resizing=\"vm.options.allowSideResizing\" \ntask-content=\"vm.options.taskContentEnabled ? vm.options.taskContent : undefined\" \nrow-content=\"vm.options.rowContentEnabled ? vm.options.rowContent : undefined\" current-date=\"vm.options.currentDate\" \ncurrent-date-value=\"vm.options.currentDateValue\" \nheaders=\"vm.options.width && vm.options.shortHeaders || vm.options.longHeaders\" max-height=\"vm.options.maxHeight\" \ntime-frames=\"vm.options.timeFrames\" date-frames=\"vm.options.dateFrames\" \ntime-frames-non-working-mode=\"vm.options.timeFramesNonWorkingMode\" time-frames-magnet=\"vm.options.timeFramesMagnet\" \napi=\"vm.options.api\" column-magnet=\"vm.options.columnMagnet\"><gantt-tree \nenabled=\"vm.options.sideMode === \'Tree\' || vm.options.sideMode === \'TreeTable\'\" \nheader-content=\"vm.options.treeHeaderContent\" keep-ancestor-on-filter-row=\"true\"></gantt-tree><gantt-table \nenabled=\"vm.options.sideMode === \'Table\' || vm.options.sideMode === \'TreeTable\'\" \ncolumns=\"vm.options.sideMode === \'TreeTable\' ? vm.options.treeTableColumns : vm.options.columns\" \nheaders=\"vm.options.columnsHeaders\" classes=\"vm.options.columnsClasses\" formatters=\"vm.options.columnsFormatters\" \ncontents=\"vm.options.columnsContents\" header-contents=\"vm.options.columnsHeaderContents\"></gantt-table><gantt-groups \nenabled=\"vm.options.groupDisplayMode === \'group\' || vm.options.groupDisplayMode === \'overview\' || vm.options.groupDisplayMode === \'promote\'\" \ndisplay=\"vm.options.groupDisplayMode\"></gantt-groups><gantt-bounds></gantt-bounds><gantt-progress></gantt-progress>\n<gantt-sortable></gantt-sortable><gantt-movable enabled=\"!vm.options.readOnly\"></gantt-movable><gantt-draw-task \nenabled=\"vm.options.canDraw\" move-threshold=\"2\" task-factory=\"vm.options.drawTaskFactory\"></gantt-draw-task>\n<gantt-overlap></gantt-overlap><gantt-resize-sensor></gantt-resize-sensor><gantt-dependencies></gantt-dependencies>\n</div></md-content></div></div></div>");
$templateCache.put("app/main/apps/mailing/mailing.communications.html","<div id=\"site-mailing\" class=\"page-layout carded left-sidenav\" layout=\"row\" md-no-ink><div class=\"center\" \nlayout=\"column\" flex><div class=\"content-card\" ng-class=\"vm.currentView\" ng-if=\"!vm.designView\" layout=\"column\" flex \nng-include=\"vm.views[vm.currentView]\" md-no-ink></div><div class=\"content-card nosplit\" ng-if=\"vm.designView\" \nlayout=\"column\" flex ng-include=\"\'app/main/apps/mailing/views/communications/design/nosplit-view.html\'\" md-no-ink>\n</div></div><qiu-pagination collection=\"vm.threads\" url=\"\'http://\'\" fields-filters=\"vm.refFilterables\" \nservice=\"mailingService\" force-section=\"communications\" columns=\"refcolumns\" columns-grouped=\"refcolumnsgrouped\" \nstyle=\"display:none\" sort-dir=\"ASC\" fields-search=\"refSearch\"></qiu-pagination></div>");
$templateCache.put("app/main/apps/mailing/mailing.content-plus.html","<div id=\"site-mailing-content-plus\" class=\"page-layout carded left-sidenav\" layout=\"row\" md-no-ink><md-sidenav \nclass=\"sidenav\" md-component-id=\"main-sidenav\" ng-include=\"\'app/main/apps/mailing/sidenavs/main/main-sidenav.html\'\" \nms-scroll ms-sidenav-helper md-no-ink></md-sidenav><div class=\"center\" layout=\"column\" flex><div class=\"content-card\" \nlayout=\"column\" flex ng-include=\"\'app/main/apps/mailing/views/content-plus/list/nosplit-view.html\'\" md-no-ink></div>\n</div><qiu-pagination collection=\"vm.contents\" url=\"\'http://\'\" fields-filters=\"refFilterables\" \nservice=\"mailingService\" force-section=\"content\" columns=\"refcolumns\" columns-grouped=\"refcolumnsgrouped\" \nfields-search=\"refSearch\"></qiu-pagination></div>");
$templateCache.put("app/main/apps/mailing/mailing.content.html","<div id=\"site-mailing\" class=\"page-layout carded left-sidenav\" layout=\"row\" md-no-ink><md-sidenav class=\"sidenav\" \nmd-component-id=\"main-sidenav\" ng-include=\"\'app/main/apps/mailing/sidenavs/main/main-sidenav.html\'\" ms-scroll \nms-sidenav-helper md-no-ink></md-sidenav><div class=\"center\" layout=\"column\" flex><div class=\"content-card\" \nng-class=\"vm.currentView\" layout=\"column\" flex ng-include=\"vm.views[vm.currentView]\" md-no-ink></div></div>\n<qiu-pagination collection=\"vm.contents\" url=\"\'http://\'\" fields-filters=\"refFilterables\" service=\"mailingService\" \nforce-section=\"content\" columns=\"refcolumns\" columns-grouped=\"refcolumnsgrouped\" style=\"display:none\" \nfields-search=\"refSearch\"></qiu-pagination></div>");
$templateCache.put("app/main/apps/mailing/mailing.massive-messages.html","<div id=\"site-mailing\" class=\"page-layout carded left-sidenav\" layout=\"row\" md-no-ink><md-sidenav class=\"sidenav\" \nmd-component-id=\"main-sidenav\" ng-include=\"\'app/main/apps/mailing/sidenavs/main/main-sidenav.html\'\" ms-scroll \nms-sidenav-helper md-no-ink></md-sidenav><div class=\"center\" layout=\"column\" flex><div class=\"content-card\" \nng-class=\"vm.currentView\" layout=\"column\" flex ng-include=\"vm.views[vm.currentView]\" md-no-ink></div></div>\n<qiu-pagination collection=\"vm.massive\" url=\"\'http://\'\" fields-filters=\"refFilterables\" service=\"mailingService\" \nforce-section=\"massive-messages\" columns=\"refcolumns\" columns-grouped=\"refcolumnsgrouped\" style=\"display:none\" \nfields-search=\"refSearch\"></qiu-pagination></div>");
$templateCache.put("app/main/apps/mailing/mailing.template-plus.html","<div id=\"site-mailing-template-plus\" class=\"page-layout carded left-sidenav\" layout=\"row\" md-no-ink><md-sidenav \nclass=\"sidenav\" md-component-id=\"main-sidenav\" ng-include=\"\'app/main/apps/mailing/sidenavs/main/main-sidenav.html\'\" \nms-scroll ms-sidenav-helper md-no-ink></md-sidenav><div class=\"center\" layout=\"column\" flex><div class=\"content-card\" \nlayout=\"column\" flex ng-include=\"\'app/main/apps/mailing/views/template-plus/list/nosplit-view.html\'\" md-no-ink></div>\n</div><qiu-pagination collection=\"vm.templates\" url=\"\'http://\'\" fields-filters=\"refFilterables\" \nservice=\"mailingService\" force-section=\"templates\" columns=\"refcolumns\" columns-grouped=\"refcolumnsgrouped\" \nfields-search=\"refSearch\"></qiu-pagination></div>");
$templateCache.put("app/main/apps/mailing/mailing.template.html","<div id=\"site-mailing\" class=\"page-layout carded left-sidenav\" layout=\"row\" md-no-ink><div class=\"center\" \nlayout=\"column\" flex><div class=\"content-card\" ng-class=\"vm.currentView\" ng-if=\"!vm.designView\" layout=\"column\" flex \nng-include=\"vm.views[vm.currentView]\" md-no-ink></div><div class=\"content-card nosplit\" ng-if=\"vm.designView\" \nlayout=\"column\" flex ng-include=\"\'app/main/apps/mailing/views/template/design/nosplit-view.html\'\" md-no-ink></div>\n</div><qiu-pagination collection=\"vm.threads\" url=\"\'http://\'\" fields-filters=\"vm.refFilterables\" \nservice=\"mailingService\" force-section=\"templates\" columns=\"refcolumns\" columns-grouped=\"refcolumnsgrouped\" \nstyle=\"display:none\" sort-dir=\"ASC\" fields-search=\"refSearch\"></qiu-pagination></div>");
$templateCache.put("app/main/apps/maps/maps-editor.html","<div class=\"maps-editor\" layout=\"column\" flex><div class=\"maps-editor-tools\" layout=\"column\"><div \nclass=\"maps-tools-row maps-tools-row-main\" layout=\"row\" layout-align=\"space-between center\"><input type=\"text\" \nclass=\"maps-editor-name\" flex ng-model=\"vm.map.title\" ng-change=\"vm.markDirty()\" translate \ntranslate-attr-placeholder=\"MAPS.MAP_NAME\"><div class=\"maps-tools-actions\" layout=\"row\" layout-align=\"end center\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.openExportDialog($event)\" ng-disabled=\"vm.status !== \'ready\'\" \naria-label=\"{{ \'MAPS.EXPORT_OBJ\' | translate }}\"><md-icon md-font-icon=\"icon-cube-outline\" class=\"s20\"></md-icon>\n<md-tooltip hide show-gt-xs><span translate=\"MAPS.EXPORT_OBJ\"></span></md-tooltip></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.openModelObject()\" ng-disabled=\"vm.status !== \'ready\'\" \naria-label=\"{{ \'MAPS.MODEL_ADD\' | translate }}\"><md-icon md-font-icon=\"icon-cube\" class=\"s20\"></md-icon><md-tooltip \nhide show-gt-xs><span translate=\"MAPS.MODEL_ADD\"></span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.openImageObject()\" ng-disabled=\"vm.status !== \'ready\'\" aria-label=\"{{ \'MAPS.IMAGE_ADD\' | translate }}\">\n<md-icon md-font-icon=\"icon-image\" class=\"s20\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"MAPS.IMAGE_ADD\">\n</span></md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.openMapSettings($event)\" \nng-disabled=\"vm.status !== \'ready\'\" aria-label=\"{{ \'MAPS.SETTINGS_TITLE\' | translate }}\"><md-icon \nmd-font-icon=\"icon-cog\" class=\"s20\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"MAPS.SETTINGS_TITLE\"></span>\n</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.toggleFullscreen()\" \nng-disabled=\"vm.status !== \'ready\'\" \naria-label=\"{{ (vm.fullscreen ? \'MAPS.EXIT_FULLSCREEN\' : \'MAPS.FULLSCREEN\') | translate }}\"><md-icon \nmd-font-icon=\"{{ vm.fullscreen ? \'icon-fullscreen-exit\' : \'icon-fullscreen\' }}\" class=\"s20\"></md-icon><md-tooltip hide \nshow-gt-xs><span translate=\"{{ vm.fullscreen ? \'MAPS.EXIT_FULLSCREEN\' : \'MAPS.FULLSCREEN\' }}\"></span></md-tooltip>\n</md-button><md-button class=\"md-raised md-primary\" ng-click=\"vm.save()\" \nng-disabled=\"!vm.dirty || vm.saving || vm.status !== \'ready\'\"><span ng-if=\"!vm.saving\" translate=\"MAPS.SAVE\"></span> \n<span ng-if=\"vm.saving\" translate=\"MAPS.SAVING\"></span></md-button><md-button type=\"button\" class=\"md-raised md-warn\" \nng-click=\"vm.close()\" aria-label=\"{{ \'MAPS.CANCEL\' | translate }}\" translate=\"MAPS.CANCEL\"></md-button></div></div><div\n class=\"maps-tools-row maps-tools-row-draw\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button\" \nng-click=\"vm.undo()\" ng-disabled=\"vm.status !== \'ready\' || !vm.canUndo()\" aria-label=\"{{ \'MAPS.UNDO\' | translate }}\">\n<md-icon md-font-icon=\"icon-undo\" class=\"s20\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"MAPS.UNDO\"></span>\n</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.redo()\" \nng-disabled=\"vm.status !== \'ready\' || !vm.canRedo()\" aria-label=\"{{ \'MAPS.REDO\' | translate }}\"><md-icon \nmd-font-icon=\"icon-redo\" class=\"s20\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"MAPS.REDO\"></span>\n</md-tooltip></md-button><div class=\"maps-tools-sep\"></div><md-button class=\"md-icon-button\" \nng-class=\"{\'maps-tool-active\': vm.tool === \'pin\'}\" ng-click=\"vm.setTool(\'pin\')\" ng-disabled=\"vm.status !== \'ready\'\" \naria-label=\"{{ \'MAPS.TOOL_PIN\' | translate }}\"><md-icon md-font-icon=\"icon-map-marker\" class=\"s20\"></md-icon>\n<md-tooltip hide show-gt-xs><span translate=\"MAPS.TOOL_PIN\"></span></md-tooltip></md-button><md-button \nclass=\"md-icon-button\" ng-class=\"{\'maps-tool-active\': vm.tool === \'zone\'}\" ng-click=\"vm.setTool(\'zone\')\" \nng-disabled=\"vm.status !== \'ready\'\" aria-label=\"{{ \'MAPS.TOOL_ZONE\' | translate }}\"><md-icon \nmd-font-icon=\"icon-vector-square\" class=\"s20\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"MAPS.TOOL_ZONE\">\n</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-class=\"{\'maps-tool-active\': vm.tool === \'circle\'}\" ng-click=\"vm.setTool(\'circle\')\" \nng-disabled=\"vm.status !== \'ready\'\" aria-label=\"{{ \'MAPS.TOOL_CIRCLE\' | translate }}\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"s20\"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate=\"MAPS.TOOL_CIRCLE\"></span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-class=\"{\'maps-tool-active\': vm.tool === \'freehand\'}\" ng-click=\"vm.setTool(\'freehand\')\" \nng-disabled=\"vm.status !== \'ready\'\" aria-label=\"{{ \'MAPS.TOOL_FREEHAND\' | translate }}\"><md-icon \nmd-font-icon=\"icon-drawing\" class=\"s20\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"MAPS.TOOL_FREEHAND\">\n</span></md-tooltip></md-button><md-button class=\"md-icon-button\" ng-class=\"{\'maps-tool-active\': vm.showCategories}\" \nng-click=\"vm.toggleCategories()\" ng-disabled=\"vm.status !== \'ready\'\" aria-label=\"{{ \'MAPS.CATEGORIES\' | translate }}\">\n<md-icon md-font-icon=\"icon-tag-multiple\" class=\"s20\"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate=\"MAPS.CATEGORIES\"></span></md-tooltip></md-button><md-button class=\"md-icon-button maps-3d-toggle\" \nng-class=\"{\'maps-tool-active\': vm.is3d}\" ng-click=\"vm.toggle3d()\" ng-disabled=\"vm.status !== \'ready\'\" \naria-label=\"{{ \'MAPS.TOGGLE_3D\' | translate }}\"><span class=\"maps-3d-label\">{{ vm.is3d ? \'3D\' : \'2D\' }}</span>\n<md-tooltip hide show-gt-xs><span translate=\"MAPS.TOGGLE_3D\"></span></md-tooltip></md-button><span flex></span> <span \nclass=\"maps-tool-hint\" hide show-gt-sm ng-if=\"vm.tool === \'pin\'\" translate=\"MAPS.TOOL_PIN_HINT\"></span> <span \nclass=\"maps-tool-hint\" hide show-gt-sm ng-if=\"vm.tool === \'zone\' && !vm.addingShape\" translate=\"MAPS.TOOL_ZONE_HINT\">\n</span> <span class=\"maps-tool-hint maps-tool-hint-active\" hide show-gt-sm ng-if=\"vm.addingShape\" \ntranslate=\"MAPS.ADD_SHAPE_DRAW_HINT\"></span> <span class=\"maps-tool-hint\" hide show-gt-sm ng-if=\"vm.tool === \'circle\'\" \ntranslate=\"MAPS.TOOL_CIRCLE_HINT\"></span> <span class=\"maps-tool-hint\" hide show-gt-sm ng-if=\"vm.tool === \'freehand\'\" \ntranslate=\"MAPS.TOOL_FREEHAND_HINT\"></span></div><div class=\"maps-tools-row maps-tools-row-style\" layout=\"row\" \nlayout-align=\"start center\"><md-select class=\"maps-select\" ng-model=\"vm.map.view.openfreemapStyle\" \nng-change=\"vm.setStyle(vm.map.view.openfreemapStyle)\" ng-disabled=\"vm.status !== \'ready\'\" \naria-label=\"{{ \'MAPS.STYLE\' | translate }}\" md-container-class=\"maps-select-menu\"><md-option \nng-repeat=\"s in vm.openfreemapStyles\" ng-value=\"s.id\">{{ s.name | translate }}</md-option></md-select><md-button \nclass=\"md-icon-button\" ng-click=\"vm.openStyleEditor($event)\" aria-label=\"{{ \'MAPS.STYLE_EDITOR_TITLE\' | translate }}\">\n<md-icon md-font-icon=\"icon-palette\" class=\"s20\"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate=\"MAPS.STYLE_EDITOR_TITLE\"></span></md-tooltip></md-button></div></div><div class=\"maps-editor-body\" flex \nlayout=\"row\"><div class=\"maps-editor-map\" flex></div><div class=\"maps-search-box\" ng-if=\"vm.status === \'ready\'\"><div \nclass=\"maps-search-input-wrap\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"s18\"></md-icon><input type=\"text\" ng-model=\"vm.searchQuery\" ng-change=\"vm.search()\" translate \ntranslate-attr-placeholder=\"MAPS.SEARCH_PLACE\" \nng-keydown=\"$event.keyCode === 13 && vm.searchResults.length && vm.goToResult(vm.searchResults[0])\">\n<md-progress-circular ng-if=\"vm.searching\" md-mode=\"indeterminate\" md-diameter=\"18\"></md-progress-circular><md-button \nclass=\"md-icon-button\" ng-if=\"vm.searchQuery && !vm.searching\" ng-click=\"vm.clearSearch()\" \naria-label=\"{{ \'MAPS.CLOSE\' | translate }}\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div>\n<div class=\"maps-search-results\" ng-if=\"vm.searchResults.length\"><div class=\"maps-search-result text-truncate\" \nng-repeat=\"r in vm.searchResults\" ng-click=\"vm.goToResult(r)\">{{ r.properties.full_address || r.properties.name }}\n</div></div></div><div class=\"maps-categories-box\" ng-if=\"vm.status === \'ready\' && vm.showCategories\" layout=\"column\">\n<div class=\"maps-categories-header\" layout=\"row\" layout-align=\"space-between center\"><span translate=\"MAPS.CATEGORIES\">\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.toggleCategories()\" aria-label=\"{{ \'MAPS.CLOSE\' | translate }}\">\n<md-icon md-font-icon=\"icon-close\" class=\"s18\"></md-icon></md-button></div><div class=\"maps-category-row\" layout=\"row\" \nlayout-align=\"start center\" ng-repeat=\"cat in vm.map.categories\"><input type=\"color\" class=\"maps-category-color\" \nng-model=\"cat.color\" ng-change=\"vm.onCategoryColorChanged(cat)\"> <input type=\"text\" class=\"maps-category-name\" flex \nng-model=\"cat.name\" ng-change=\"vm.markDirty()\"><md-button class=\"md-icon-button\" ng-click=\"vm.removeCategory(cat)\" \naria-label=\"{{ \'MAPS.DELETE\' | translate }}\"><md-icon md-font-icon=\"icon-delete\" class=\"s18\"></md-icon></md-button>\n</div><md-button class=\"md-primary maps-category-add\" ng-click=\"vm.addCategory()\"><md-icon md-font-icon=\"icon-plus\" \nclass=\"s18\"></md-icon><span translate=\"MAPS.ADD_CATEGORY\"></span></md-button></div><div class=\"maps-editor-overlay\" \nng-if=\"vm.status !== \'ready\'\" layout=\"column\" layout-align=\"center center\"><md-progress-circular \nng-if=\"vm.status === \'loading\'\" md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular><div \nng-if=\"vm.status === \'error\'\" class=\"maps-editor-message\"><md-icon md-font-icon=\"icon-alert\" class=\"s48\"></md-icon><div\n class=\"title\" translate=\"MAPS.MAP_ERROR_TITLE\"></div><div class=\"subtitle\" translate=\"MAPS.MAP_ERROR_TEXT\"></div>\n</div></div><div class=\"maps-editor-props\" ng-if=\"vm.status === \'ready\' && vm.selected\" layout=\"column\"><div \nng-if=\"vm.editingShape\" class=\"maps-editing-shape\" layout=\"column\"><div class=\"maps-editing-hint\" \ntranslate=\"MAPS.EDIT_SHAPE_HINT\"></div><div ng-if=\"vm.hasSelectedNode()\" layout=\"column\"><md-button \nclass=\"md-primary maps-edit-shape-btn\" ng-click=\"vm.toggleNodeCurve()\"><md-icon md-font-icon=\"icon-vector-curve\" \nclass=\"s18\"></md-icon><span translate=\"MAPS.NODE_TOGGLE_CURVE\"></span></md-button><md-button \nclass=\"md-primary maps-edit-shape-btn\" ng-click=\"vm.deleteNode()\"><md-icon md-font-icon=\"icon-delete\" class=\"s18\">\n</md-icon><span translate=\"MAPS.NODE_DELETE\"></span></md-button></div><div ng-if=\"!vm.hasSelectedNode()\" \nclass=\"maps-props-hint\" translate=\"MAPS.NODE_PICK_HINT\"></div><md-button class=\"md-raised md-primary\" \nng-click=\"vm.finishEditShape()\"><span translate=\"MAPS.DONE\"></span></md-button></div><div ng-if=\"!vm.editingShape\" \nlayout=\"column\"><div class=\"maps-props-header\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"MAPS.PROPERTIES\"></span><div layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" \nng-click=\"vm.deleteSelected()\" aria-label=\"{{ \'MAPS.DELETE\' | translate }}\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"s20\"></md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.selected = null\" \naria-label=\"{{ \'MAPS.CLOSE\' | translate }}\"><md-icon md-font-icon=\"icon-close\" class=\"s20\"></md-icon></md-button></div>\n</div><div class=\"maps-props-tabs\" layout=\"row\"><button type=\"button\" class=\"maps-props-tab\" \nng-class=\"{\'maps-props-tab-active\': vm.propsTab === \'content\'}\" ng-click=\"vm.propsTab = \'content\'\" \ntranslate=\"MAPS.PROPS_TAB_CONTENT\"></button> <button type=\"button\" class=\"maps-props-tab\" ng-if=\"vm.languages.length\" \nng-class=\"{\'maps-props-tab-active\': vm.propsTab === \'languages\'}\" ng-click=\"vm.propsTab = \'languages\'\" \ntranslate=\"MAPS.PROPS_TAB_LANGUAGES\"></button> <button type=\"button\" class=\"maps-props-tab\" \nng-class=\"{\'maps-props-tab-active\': vm.propsTab === \'appearance\'}\" ng-click=\"vm.propsTab = \'appearance\'\" \ntranslate=\"MAPS.PROPS_TAB_APPEARANCE\"></button></div><div class=\"maps-props-pane\" ng-if=\"vm.propsTab === \'content\'\" \nlayout=\"column\"><md-input-container class=\"md-block\"><label translate=\"MAPS.CATEGORY\"></label><md-select \nng-model=\"vm.categoryChoice\" ng-change=\"vm.setFeatureCategory(vm.categoryChoice)\"><md-option ng-value=\"vm.NO_CATEGORY\">\n{{ \'MAPS.NO_CATEGORY\' | translate }}</md-option><md-option ng-repeat=\"cat in vm.map.categories\" ng-value=\"cat.id\">\n{{ cat.name }}</md-option></md-select></md-input-container><div class=\"maps-props-color\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"maps-props-color-label\" translate=\"MAPS.COLOR\"></span> <input type=\"color\" \nclass=\"maps-props-color-input\" ng-model=\"vm.selected.properties.color\" ng-change=\"vm.onFeatureChanged()\"></div>\n<md-input-container class=\"md-block\"><label translate=\"MAPS.PIN_TITLE\"></label><input type=\"text\" \nng-model=\"vm.selected.properties.title\" ng-change=\"vm.onFeatureChanged()\"></md-input-container><md-input-container \nclass=\"md-block\"><label translate=\"MAPS.SUBTITLE\"></label><textarea ng-model=\"vm.selected.properties.subtitle\" \nng-change=\"vm.onFeatureChanged()\" rows=\"2\"></textarea></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"MAPS.DESCRIPTION\"></label><textarea ng-model=\"vm.selected.properties.description\" \nng-change=\"vm.onFeatureChanged()\" rows=\"3\"></textarea></md-input-container><div class=\"maps-props-hint\" \ntranslate=\"MAPS.DESCRIPTION_HINT\"></div><md-input-container class=\"md-block\"><label translate=\"MAPS.SEARCH_FIELD\">\n</label><input type=\"text\" ng-model=\"vm.selected.properties.searchField\" ng-change=\"vm.onFeatureChanged()\">\n</md-input-container><div class=\"maps-props-hint\" translate=\"MAPS.SEARCH_FIELD_HINT\"></div><div \nclass=\"maps-props-label\" translate=\"MAPS.PHOTO\"></div><div class=\"maps-photo\" ng-if=\"vm.selected.properties.photo\"><img\n class=\"maps-photo-preview\" ng-src=\"{{ vm.selected.properties.photo }}\" alt=\"{{ vm.selected.properties.title }}\">\n<md-button class=\"md-icon-button maps-photo-remove\" ng-click=\"vm.selected.properties.photo = \'\'; vm.markDirty()\" \naria-label=\"{{ \'MAPS.REMOVE_PHOTO\' | translate }}\"><md-icon md-font-icon=\"icon-close\" class=\"s18\"></md-icon>\n</md-button></div><md-button class=\"md-raised maps-pick-photo-btn\" ng-click=\"vm.pickPhoto()\"><md-icon \nmd-font-icon=\"icon-image\" class=\"s18\"></md-icon><span translate=\"MAPS.PICK_PHOTO\"></span></md-button>\n<md-input-container class=\"md-block\"><input type=\"text\" ng-model=\"vm.selected.properties.photo\" \nng-change=\"vm.markDirty()\" translate translate-attr-placeholder=\"MAPS.PHOTO_URL\"></md-input-container></div><div \nclass=\"maps-props-pane\" ng-if=\"vm.propsTab === \'languages\' && vm.languages.length\" layout=\"column\"><div \nclass=\"maps-props-translations\" ng-if=\"vm.languages.length\" layout=\"column\"><div \nclass=\"maps-props-translations-header\" layout=\"row\" layout-align=\"end center\"><span \nclass=\"maps-props-translations-base\" translate=\"MAPS.TRANSLATIONS_BASE\" \ntranslate-values=\"{lang: vm.baseLanguage.lang_name}\"></span></div><md-input-container class=\"md-block\"><label \ntranslate=\"MAPS.TRANSLATION_LANGUAGE\"></label><md-select ng-model=\"vm.translationLangId\"><md-option \nng-repeat=\"lang in vm.languages\" ng-value=\"lang.id_lang\">{{ lang.language || lang.lang_name }} <span \nclass=\"maps-translation-done\" ng-if=\"vm.hasTranslation(vm.selected, lang.id_lang)\">✓</span></md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\"><label>\n{{ \'MAPS.PIN_TITLE\' | translate }} ({{ vm.translationLangName() }})</label><input type=\"text\" \nng-model=\"vm.translationField.title\" ng-model-options=\"{getterSetter: true}\"></md-input-container><div \nclass=\"maps-props-hint\" ng-if=\"vm.selected.properties.title\">\n{{ vm.baseLanguage.lang_name }}: {{ vm.selected.properties.title }}</div><md-input-container class=\"md-block\"><label>\n{{ \'MAPS.SUBTITLE\' | translate }} ({{ vm.translationLangName() }})</label><textarea \nng-model=\"vm.translationField.subtitle\" ng-model-options=\"{getterSetter: true}\" rows=\"2\"></textarea>\n</md-input-container><div class=\"maps-props-hint\" ng-if=\"vm.selected.properties.subtitle\">\n{{ vm.baseLanguage.lang_name }}: {{ vm.selected.properties.subtitle }}</div><md-input-container class=\"md-block\">\n<label>{{ \'MAPS.DESCRIPTION\' | translate }} ({{ vm.translationLangName() }})</label><textarea \nng-model=\"vm.translationField.description\" ng-model-options=\"{getterSetter: true}\" rows=\"3\"></textarea>\n</md-input-container><div class=\"maps-props-hint\" ng-if=\"vm.selected.properties.description\">\n{{ vm.baseLanguage.lang_name }}: {{ vm.selected.properties.description }}</div><div ng-if=\"vm.aiTranslateEnabled\" \nlayout=\"column\"><md-button class=\"md-raised maps-pick-photo-btn\" ng-disabled=\"vm.translating\" \nng-click=\"vm.openAiTranslate(\'feature\')\"><md-icon md-font-icon=\"icon-content-duplicate-translate\" class=\"s18\">\n</md-icon><span translate=\"MAPS.AI_TRANSLATE_FEATURE\"></span></md-button><md-button \nclass=\"md-raised maps-pick-photo-btn\" ng-disabled=\"vm.translating\" ng-click=\"vm.openAiTranslate(\'map\')\"><md-icon \nmd-font-icon=\"icon-content-duplicate-translate\" class=\"s18\"></md-icon><span translate=\"MAPS.AI_TRANSLATE_MAP\"></span>\n</md-button><div class=\"maps-props-translating\" ng-if=\"vm.translating\" layout=\"row\" layout-align=\"start center\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"16\"></md-progress-circular><span \ntranslate=\"MAPS.AI_TRANSLATING\" \ntranslate-values=\"{done: vm.translationProgress.done, total: vm.translationProgress.total}\"></span></div><div \nclass=\"maps-props-hint\" translate=\"MAPS.AI_TRANSLATE_HINT\"></div></div></div></div><div class=\"maps-props-pane\" \nng-if=\"vm.propsTab === \'appearance\'\" layout=\"column\"><md-input-container class=\"md-block\" \nng-if=\"vm.selected.properties.shape === \'circle\'\"><label translate=\"MAPS.RADIUS\"></label><input type=\"number\" \nmin=\"0.02\" max=\"200\" step=\"any\" ng-model=\"vm.selected.properties.radiusKm\" ng-change=\"vm.onRadiusChanged()\">\n</md-input-container><md-input-container class=\"md-block\" ng-if=\"vm.selected.properties.kind === \'zone\'\"><label \ntranslate=\"MAPS.HEIGHT\"></label><input type=\"number\" min=\"0\" max=\"1000\" step=\"1\" \nng-model=\"vm.selected.properties.height\" ng-change=\"vm.onFeatureChanged()\"></md-input-container><div \nng-if=\"vm.selected.properties.kind === \'model3d\'\"><md-button class=\"md-raised maps-pick-photo-btn\" \nng-click=\"vm.pickModelFile()\"><md-icon md-font-icon=\"icon-cube\" class=\"s18\"></md-icon><span \ntranslate=\"MAPS.MODEL_PICK\"></span></md-button><md-input-container class=\"md-block\"><label translate=\"MAPS.MODEL_URL\">\n</label><input type=\"text\" ng-model=\"vm.selected.properties.modelUrl\" ng-change=\"vm.reload3dObject()\">\n</md-input-container><div class=\"maps-props-hint\" translate=\"MAPS.MODEL_URL_HINT\"></div><div class=\"maps-props-label\" \ntranslate=\"MAPS.MODEL_TEXTURE\"></div><div class=\"maps-photo\" ng-if=\"vm.selected.properties.textureUrl\"><img \nclass=\"maps-photo-preview maps-photo-preview-contain\" crossorigin=\"anonymous\" \nng-src=\"{{ vm.selected.properties.textureUrl }}\" alt=\"texture\"><md-button class=\"md-icon-button maps-photo-remove\" \nng-click=\"vm.clearModelTexture()\" aria-label=\"{{ \'MAPS.REMOVE_PHOTO\' | translate }}\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s18\"></md-icon></md-button></div><md-button class=\"md-raised maps-pick-photo-btn\" \nng-click=\"vm.pickModelTexture()\"><md-icon md-font-icon=\"icon-image\" class=\"s18\"></md-icon><span \ntranslate=\"MAPS.MODEL_TEXTURE_PICK\"></span></md-button><div class=\"maps-props-hint\" \ntranslate=\"MAPS.MODEL_TEXTURE_HINT\"></div></div><div ng-if=\"vm.selected.properties.kind === \'image3d\'\"><div \nclass=\"maps-photo\" ng-if=\"vm.selected.properties.imageUrl\"><img class=\"maps-photo-preview maps-photo-preview-contain\" \ncrossorigin=\"anonymous\" ng-src=\"{{ vm.selected.properties.imageUrl }}\" alt=\"image\"></div><md-button \nclass=\"md-raised maps-pick-photo-btn\" ng-click=\"vm.pickImageForObject()\"><md-icon md-font-icon=\"icon-image\" \nclass=\"s18\"></md-icon><span translate=\"MAPS.IMAGE_PICK\"></span></md-button><md-input-container class=\"md-block\"><label \ntranslate=\"MAPS.IMAGE_ORIENTATION\"></label><md-select ng-model=\"vm.selected.properties.orientation\" \nng-change=\"vm.onFeatureChanged()\"><md-option value=\"flat\">{{ \'MAPS.IMAGE_ORIENTATION_FLAT\' | translate }}</md-option>\n<md-option value=\"upright\">{{ \'MAPS.IMAGE_ORIENTATION_UPRIGHT\' | translate }}</md-option></md-select>\n</md-input-container><md-button class=\"md-raised\" ng-if=\"vm.selected.properties.orientation === \'flat\'\" \nng-click=\"vm.fitImageToView()\"><md-icon md-font-icon=\"icon-crop\" class=\"s18\"></md-icon><span \ntranslate=\"MAPS.IMAGE_FIT_VIEW\"></span></md-button></div><div \nng-if=\"vm.selected.properties.kind === \'model3d\' || vm.selected.properties.kind === \'image3d\'\"><md-input-container \nclass=\"md-block\"><label translate=\"MAPS.MODEL_SCALE\"></label><input type=\"number\" min=\"0.1\" max=\"100000\" step=\"any\" \nng-model=\"vm.selected.properties.scale\" ng-change=\"vm.onFeatureChanged()\"></md-input-container><md-input-container \nclass=\"md-block\"><label translate=\"MAPS.MODEL_ALTITUDE\"></label><input type=\"number\" step=\"any\" \nng-model=\"vm.selected.properties.altitude\" ng-change=\"vm.onFeatureChanged()\"></md-input-container><md-input-container \nclass=\"md-block\"><label translate=\"MAPS.MODEL_ROTATION\"></label><input type=\"number\" min=\"0\" max=\"360\" step=\"any\" \nng-model=\"vm.selected.properties.rotation\" ng-change=\"vm.onFeatureChanged()\"></md-input-container></div><div \nng-if=\"vm.selected.properties.kind === \'zone\'\"><div class=\"maps-props-label\" translate=\"MAPS.ZONE_TEXTURE\"></div><div \nclass=\"maps-photo\" ng-if=\"vm.selected.properties.textureUrl\"><img \nclass=\"maps-photo-preview maps-photo-preview-contain\" crossorigin=\"anonymous\" \nng-src=\"{{ vm.selected.properties.textureUrl }}\" alt=\"texture\"><md-button class=\"md-icon-button maps-photo-remove\" \nng-click=\"vm.clearZoneTexture()\" aria-label=\"{{ \'MAPS.REMOVE_PHOTO\' | translate }}\"><md-icon md-font-icon=\"icon-close\" \nclass=\"s18\"></md-icon></md-button></div><md-button class=\"md-raised maps-pick-photo-btn\" \nng-click=\"vm.pickZoneTexture()\"><md-icon md-font-icon=\"icon-image\" class=\"s18\"></md-icon><span \ntranslate=\"MAPS.ZONE_TEXTURE_PICK\"></span></md-button><div ng-if=\"vm.selected.properties.textureUrl\"><div \nclass=\"maps-props-label\" layout=\"row\" layout-align=\"space-between center\"><span translate=\"MAPS.ZONE_TEXTURE_SCALE\">\n</span> <span>{{ vm.selected.properties.textureScale || 100 }}%</span></div><md-slider min=\"25\" max=\"400\" step=\"5\" \nng-model=\"vm.selected.properties.textureScale\" ng-change=\"vm.onZoneTextureScaleChanged()\" \naria-label=\"{{ \'MAPS.ZONE_TEXTURE_SCALE\' | translate }}\"></md-slider></div><div class=\"maps-props-hint\" \ntranslate=\"MAPS.ZONE_TEXTURE_HINT\"></div></div><div class=\"maps-props-opacity\" \nng-if=\"vm.selected.properties.kind === \'zone\' || vm.selected.properties.kind === \'model3d\' || vm.selected.properties.kind === \'image3d\'\">\n<div class=\"maps-props-label\" layout=\"row\" layout-align=\"space-between center\"><span translate=\"MAPS.OPACITY\"></span> \n<span layout=\"row\" layout-align=\"end center\"><span>{{ vm.opacityLabel() }}</span><md-button \nclass=\"md-icon-button maps-props-opacity-reset\" \nng-if=\"vm.selected.properties.opacity !== null && vm.selected.properties.opacity !== undefined\" \nng-click=\"vm.resetOpacity()\" aria-label=\"{{ \'MAPS.OPACITY_RESET\' | translate }}\"><md-icon md-font-icon=\"icon-close\" \nclass=\"s16\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"MAPS.OPACITY_RESET\"></span></md-tooltip></md-button>\n</span></div><md-slider min=\"0\" max=\"100\" step=\"1\" ng-model=\"vm.selected.properties.opacity\" \nng-change=\"vm.onOpacityChanged()\" aria-label=\"{{ \'MAPS.OPACITY\' | translate }}\"></md-slider></div><div \nng-if=\"vm.selected.properties.kind === \'zone\'\"><md-button class=\"md-primary maps-edit-shape-btn\" \nng-if=\"vm.selected.properties.shape !== \'circle\'\" ng-click=\"vm.editShape()\"><md-icon md-font-icon=\"icon-vector-square\" \nclass=\"s18\"></md-icon><span translate=\"MAPS.EDIT_SHAPE\"></span></md-button><md-button \nclass=\"md-primary maps-edit-shape-btn\" ng-click=\"vm.addShapeToZone()\"><md-icon md-font-icon=\"icon-shape-plus\" \nclass=\"s18\"></md-icon><span translate=\"MAPS.ADD_SHAPE\"></span></md-button><md-button \nclass=\"md-primary maps-edit-shape-btn\" ng-if=\"vm.shapeCount(vm.selected) > 1\" ng-click=\"vm.splitShapes()\"><md-icon \nmd-font-icon=\"icon-ungroup\" class=\"s18\"></md-icon><span translate=\"MAPS.SPLIT_SHAPES\"></span></md-button><div \nclass=\"maps-props-hint\" ng-if=\"vm.shapeCount(vm.selected) > 1\" translate=\"MAPS.SHAPES_COUNT\" \ntranslate-values=\"{count: vm.shapeCount(vm.selected)}\"></div><div class=\"maps-props-hint\" \nng-if=\"vm.shapeCount(vm.selected) < 2\" translate=\"MAPS.ADD_SHAPE_HINT\"></div></div><div \nclass=\"maps-props-coords-fields\" ng-if=\"vm.selected.geometry.type === \'Point\'\" layout=\"row\" \nlayout-align=\"start center\"><md-input-container class=\"md-block\" flex><label translate=\"MAPS.LATITUDE\"></label><input \ntype=\"number\" step=\"any\" min=\"-90\" max=\"90\" ng-model=\"vm.selected.geometry.coordinates[1]\" \nng-change=\"vm.onCoordsChanged()\"></md-input-container><md-input-container class=\"md-block\" flex><label \ntranslate=\"MAPS.LONGITUDE\"></label><input type=\"number\" step=\"any\" min=\"-180\" max=\"180\" \nng-model=\"vm.selected.geometry.coordinates[0]\" ng-change=\"vm.onCoordsChanged()\"></md-input-container></div></div></div>\n</div></div></div>");
$templateCache.put("app/main/apps/maps/maps.html","<div id=\"site-content\" class=\"page-layout carded maps-page\" layout=\"row\" md-no-ink><div class=\"center\" layout=\"column\" \nflex><div class=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button aria-label=\"ADD NEW\" \nclass=\"md-accent green-500-bg md-raised md-button md-ink-ripple\" hide show-gt-sm ng-click=\"vm.createMap()\" \ntranslate=\"MAPS.NEW_MAP\" type=\"button\">Nuevo mapa</md-button><md-button aria-label=\"ADD NEW\" \nclass=\"md-fab md-mini md-accent green-500-bg md-raised md-ink-ripple\" hide-gt-sm ng-click=\"vm.createMap()\" \ntype=\"button\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><div class=\"divider-vertical\" hide show-gt-xs>\n</div><div class=\"maps-search\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"s20 mr-8\"></md-icon><input type=\"text\" ng-model=\"vm.query\" class=\"maps-search-input\" translate \ntranslate-attr-placeholder=\"MAPS.SEARCH\" placeholder=\"Buscar\"></div></div><div layout=\"row\" layout-align=\"end center\">\n<span class=\"maps-count\">{{ \'MAPS.COUNT\' | translate:{count: vm.maps.length} }}</span></div></div><div \nclass=\"content-wrapper\" flex layout=\"row\" ng-class=\"{\'maps-has-selection\': vm.selectedMap}\"><div \nclass=\"content thread-list mail-list-pane\" flex=\"50\" id=\"thread-list\" ms-scroll><div flex layout=\"column\" \nlayout-align=\"center center\" ng-if=\"vm.loading\" class=\"loading-container\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div class=\"mail-list-item maps-empty\" \nng-if=\"!vm.loading && vm.maps.length === 0\" layout=\"column\" layout-align=\"center center\"><md-icon \nmd-font-icon=\"icon-map-marker\" class=\"s48\"></md-icon><div class=\"title\">{{ \'MAPS.EMPTY_TITLE\' | translate }}</div><div \nclass=\"subtitle\">{{ \'MAPS.EMPTY_TEXT\' | translate }}</div></div><div class=\"mail-list-item\" \nng-repeat=\"map in vm.maps | filter:vm.query track by map.id\" \nng-class=\"{\'maps-off\': !map.onoff, \'selected\': vm.selectedMap.id === map.id}\" layout=\"row\" \nlayout-align=\"space-between center\" ng-click=\"vm.selectMap(map)\"><div layout=\"row\" layout-align=\"start center\" flex>\n<md-icon md-font-icon=\"icon-map-marker\" class=\"s24 mr-16\"></md-icon><div class=\"info\" flex><div class=\"name\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"title text-truncate\">{{ map.title }}</div></div><div \nclass=\"subtitle text-truncate\">{{ \'MAPS.FEATURES_COUNT\' | translate:{count: vm.featureCount(map)} }}</div></div></div>\n<div class=\"buttons\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button\" \nng-click=\"vm.deleteMap($event, map); $event.stopPropagation()\" aria-label=\"{{ \'MAPS.DELETE\' | translate }}\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"s20\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"MAPS.DELETE\"></span>\n</md-tooltip></md-button></div></div></div><div class=\"content thread-detail mail-read-pane maps-editor-pane\" \nflex=\"50\" id=\"thread-detail\" layout=\"column\"><div ng-if=\"!vm.selectedMap && !vm.openingMap\" layout=\"column\" \nlayout-align=\"center center\" flex class=\"maps-editor-placeholder\"><md-icon md-font-icon=\"icon-map-marker\" class=\"s48\">\n</md-icon><div class=\"title\">{{ \'MAPS.SELECT_A_MAP\' | translate }}</div></div><div ng-if=\"vm.openingMap\" \nlayout=\"column\" layout-align=\"center center\" flex class=\"loading-container\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div ng-if=\"vm.selectedMap\" \nclass=\"maps-editor-canvas\" flex layout=\"column\" ng-class=\"{\'maps-editor-fullscreen\': vm.editorFullscreen}\"><maps-editor\n map-model=\"vm.selectedMap\" site-id=\"vm.siteID\" fullscreen=\"vm.editorFullscreen\" on-fullscreen=\"vm.toggleFullscreen()\" \non-saved=\"vm.onMapSaved(result)\" on-close=\"vm.closeMap()\"></maps-editor></div></div></div></div></div></div>");
$templateCache.put("app/main/apps/match-center/match-center-live.html","<div id=\"site-match-center\" class=\"page-layout carded left-sidenav\" layout=\"row\" md-no-ink><div class=\"center\" \nng-if=\"vm.currentView == \'split\'\" ng-class=\"{\'no-split\' : vm.currentView == \'nosplit\'}\" layout=\"column\" flex><div \nclass=\"content-card\" ng-class=\"vm.currentView\" layout=\"column\" flex ng-include=\"vm.viewsLive[vm.currentView]\" \nmd-no-ink></div></div><qiu-pagination collection=\"vm.threads\" url=\"\'http://\'\" service=\"matchCenterServiceLive\" \ncolumns=\"refcolumns\" columns-grouped=\"refcolumnsgrouped\" fields-filters=\"refFilterables\" menu-filters=\"main-sidenav\" \nmedia-zones=\"refMediaZones\" fields-search=\"refSearch\" fields-sort=\"refSortables\" fields-group=\"refGroupables\" \nstyle=\"display:none\" groupby=\"list_position\"></qiu-pagination></div>");
$templateCache.put("app/main/apps/match-center/match-center.html","<div id=\"site-match-center\" class=\"page-layout carded left-sidenav\" layout=\"row\" md-no-ink><md-sidenav \nmd-is-open=\"true\" class=\"sidenav groups-tree sidenav-match-center sidenav-groups\" md-component-id=\"tree-sidenav\" \nng-include=\"\'app/main/apps/match-center/sidenavs/tree-sidenav.html\'\" ms-scroll ms-sidenav-helper md-no-ink>\n</md-sidenav><div class=\"center\" ng-if=\"vm.currentCompetitionSeason || vm.currentView == \'split\'\" \nng-class=\"{\'no-split\' : vm.currentView == \'nosplit\'}\" layout=\"column\" flex><div class=\"content-card\" \nng-class=\"vm.currentView\" layout=\"column\" flex ng-include=\"vm.views[vm.currentView]\" md-no-ink></div></div>\n<qiu-pagination collection=\"vm.seasons\" url=\"\'http://\'\" service=\"matchCenterService\" style=\"display:none\">\n</qiu-pagination></div>");
$templateCache.put("app/main/apps/media/media.html","<div id=\"site-media\" class=\"page-layout carded left-sidenav\" layout=\"row\" md-no-ink><md-sidenav class=\"sidenav\" \nmd-component-id=\"main-sidenav\" ng-include=\"\'app/main/apps/content/sidenavs/main/main-sidenav.html\'\" ms-scroll \nms-sidenav-helper md-no-ink></md-sidenav><md-sidenav id=\"sidenav-galleries-wrapp\" \nng-if=\"vm.media_type_name != \'galleries\' && vm.media_type_name != \'Image Rekognition\'\" \nmd-is-open=\"vm.isOpenSidenavGalleries\" class=\"sidenav groups-tree sidenav-users sidenav-groups\" \nmd-component-id=\"galleries-sidenav\" ng-include=\"\'app/main/apps/media/sidenavs/images/galleries-sidenav.html\'\" \nms-scroll ms-sidenav-helper md-no-ink></md-sidenav><div class=\"center\" layout=\"column\" flex><div class=\"content-card\" \nng-class=\"{\'split\':vm.currentView==\'split\', \'nosplit\':vm.currentView==\'nosplit\',\'edited\':vm.mediaSelected}\" \nlayout=\"column\" flex ng-include=\"vm.views[vm.currentView]\" md-no-ink></div></div><qiu-pagination collection=\"vm.items\" \nurl=\"\'http://\'\" service=\"mediaService\" columns=\"refcolumns\" columns-grouped=\"refcolumnsgrouped\" \nmenu-filters=\"main-sidenav\" sort-field=\"date_uploaded\" sort-dir=\"DESC\" media-zones=\"refMediaZones\" \nfields-filters=\"refFilterables\" fields-search=\"refSearch\" fields-sort=\"refSortables\" fields-group=\"refGroupables\" \ngroupby=\"list_position\" filter-by-media-type=\"vm.media_type\"></div><div class=\"processing-dropped-container\" \nng-if=\"galleryDroppedLoading\"><div class=\"content\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\">\n</md-progress-circular><span translate=\"MEDIA.DROPPED_ITEMS_GALLERY\"></span></div></div>");
$templateCache.put("app/main/apps/media/rekognition.html","<div id=\"site-rekognition\" class=\"page-layout carded left-sidenav\" layout=\"row\" md-no-ink><div class=\"center\" \nlayout=\"column\" flex><div class=\"content-card\" \nng-class=\"{\'split\':vm.currentView==\'split\', \'nosplit\':vm.currentView==\'nosplit\',\'edited\':vm.mediaSelected}\" \nlayout=\"column\" flex ng-include=\"vm.views[vm.currentView]\" md-no-ink></div></div><qiu-pagination collection=\"vm.items\" \nurl=\"\'http://\'\" service=\"rekognitionService\" columns=\"refcolumns\" columns-grouped=\"refcolumnsgrouped\" \nmenu-filters=\"main-sidenav\" sort-field=\"date_uploaded\" sort-dir=\"DESC\" media-zones=\"refMediaZones\" \nfields-filters=\"refFilterables\" fields-search=\"refSearch\" fields-sort=\"refSortables\" fields-group=\"refGroupables\" \ngroupby=\"list_position\" filter-by-media-type=\"vm.media_type\"></qiu-pagination></div>");
$templateCache.put("app/main/apps/module-template/module-template.html","<div id=\"module-template\" class=\"page-layout simple\" layout=\"row\" md-no-ink><div class=\"center\" layout=\"column\" flex>\n<div class=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"row\" layout-align=\"start center\" flex><md-checkbox class=\"no-label\" aria-label=\"Select All\"></md-checkbox>\n<div class=\"divider-vertical mx-8\"></div><md-button class=\"md-accent green-500-bg md-raised px-16\" \nng-click=\"vm.newItem($event)\"><span translate=\"MODULE_TEMPLATE.NEW\">NUEVO</span></md-button><div \nclass=\"divider-vertical mx-8\"></div><ms-search-bar flex model-search=\"vm.searchQuery\"></ms-search-bar><md-button \nclass=\"md-icon-button\" aria-label=\"Filters\"><md-icon md-font-icon=\"icon-filter\" class=\"s20\"></md-icon></md-button>\n<md-button class=\"md-icon-button\" aria-label=\"Sort\"><md-icon md-font-icon=\"icon-sort\" class=\"s20\"></md-icon>\n</md-button></div><div layout=\"row\" layout-align=\"end center\" class=\"pagination-info\"><span class=\"items-count mr-16\">\n{{vm.items.length}} registros encontrados</span><md-button class=\"md-icon-button\" ng-disabled=\"true\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><span class=\"page-count\">1 / 1</span><md-button \nclass=\"md-icon-button\" ng-disabled=\"true\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button><div \nclass=\"divider-vertical mx-8\"></div><md-button class=\"md-icon-button\" ng-click=\"vm.toggleLayout()\" \naria-label=\"Toggle Layout\"><md-icon \nmd-font-icon=\"{{vm.currentLayout === \'split\' ? \'icon-view-list\' : \'icon-view-quilt\'}}\"></md-icon><md-tooltip hide \nshow-gt-xs><span translate=\"MODULE_TEMPLATE.TOGGLE_VIEW\">Cambiar vista</span></md-tooltip></md-button></div></div><div \nclass=\"content-wrapper\" flex layout=\"row\"><div class=\"list-pane master-view\" \nflex=\"{{vm.currentLayout === \'nosplit\' ? 100 : 50}}\" flex-xs=\"100\" ms-scroll><md-list class=\"module-template-list p-0\">\n<md-list-item class=\"list-item\" ng-repeat=\"item in vm.items\" ng-click=\"vm.selectItem(item)\" \nng-class=\"{\'selected\': vm.selectedItem.id === item.id}\"><div layout=\"row\" layout-align=\"start center\" flex><md-checkbox\n class=\"no-label mr-8\" aria-label=\"Select\"></md-checkbox><img ng-src=\"assets/images/flags/{{item.lang}}.png\" \nclass=\"flag-icon mr-8\" alt=\"{{item.lang}}\" ng-if=\"item.lang\"><div class=\"avatar-wrapper mr-12\"><img \nng-src=\"{{item.image || \'assets/images/placeholder-avatar.png\'}}\" class=\"avatar-circle\"></div><div \nclass=\"item-details\" layout=\"column\" flex><div class=\"item-meta\"><span class=\"item-id\"># {{item.id}}</span> <span \nclass=\"item-date ml-8\">{{item.date}}</span></div><div class=\"item-title font-weight-600 s16\">{{item.title}}</div><div \nclass=\"item-type s12 secondary-text\">{{item.type}}</div></div><div class=\"item-status\"><md-icon \nmd-font-icon=\"{{item.active ? \'icon-checkbox-marked-circle\' : \'icon-checkbox-blank-circle-outline\'}}\" \nng-class=\"item.active ? \'status-green\' : \'status-red\'\"></md-icon></div></div><md-divider></md-divider></md-list-item>\n</md-list></div><div class=\"detail-pane detail-view\" flex=\"50\" hide-xs layout=\"column\" layout-align=\"center center\" \nng-if=\"vm.currentLayout === \'split\'\"><div class=\"empty-detail-state\" ng-if=\"!vm.selectedItem\" layout=\"column\" \nlayout-align=\"center center\"><span class=\"s24 secondary-text\" translate=\"MODULE_TEMPLATE.SELECT_ITEM\">\nSelecciona un registro para verlo en el panel</span></div><div class=\"selected-item-detail p-24\" \nng-if=\"vm.selectedItem\" flex ms-scroll><h2 class=\"md-display-1\">{{vm.selectedItem.title}}</h2><md-divider \nclass=\"my-16\"></md-divider><p>{{vm.selectedItem.description}}</p></div></div></div></div></div></div>");
$templateCache.put("app/main/apps/mediahub/mediahub.html","<div id=\"site-media\" class=\"page-layout carded left-sidenav\" layout=\"row\" md-no-ink><div \nng-if=\"vm.mediahubUrlReady && vm.mediahubUrlMissing\" class=\"mediahub-url-missing\"><md-icon \nmd-font-icon=\"icon-alert-circle\" class=\"md-warn s64\"></md-icon><div class=\"md-display-1 text-bold md-accent\" \ntranslate=\"MEDIA.MEDIAHUB_URL_MISSING\">Mediahub URL Miss</div><div class=\"md-subhead\" \ntranslate=\"MEDIA.MEDIAHUB_URL_MISSING_MESSAGE\">\nNo mediahub URL is configured for this domain setting. Please configure it to access the media.</div></div><md-sidenav \nclass=\"sidenav\" ng-if=\"vm.mediahubUrlReady && !vm.mediahubUrlMissing\" md-component-id=\"main-sidenav\" \nng-include=\"\'app/main/apps/content/sidenavs/main/main-sidenav.html\'\" ms-scroll ms-sidenav-helper md-no-ink>\n</md-sidenav><md-sidenav id=\"sidenav-galleries-wrapp\" \nng-if=\"vm.mediahubUrlReady && !vm.mediahubUrlMissing && vm.media_type_name != \'galleries\' && vm.media_type_name != \'Image Rekognition\'\" \nmd-is-open=\"vm.isOpenSidenavGalleries\" class=\"sidenav groups-tree sidenav-users sidenav-groups\" \nmd-component-id=\"galleries-sidenav\" ng-include=\"\'app/main/apps/mediahub/sidenavs/images/galleries-sidenav.html\'\" \nms-scroll ms-sidenav-helper md-no-ink></md-sidenav><div class=\"center\" layout=\"column\" flex \nng-if=\"vm.mediahubUrlReady && !vm.mediahubUrlMissing\"><div class=\"content-card\" \nng-class=\"{\'split\':vm.currentView==\'split\', \'nosplit\':vm.currentView==\'nosplit\',\'edited\':vm.mediaSelected}\" \nlayout=\"column\" flex ng-include=\"vm.views[vm.currentView]\" md-no-ink></div></div><div class=\"mh-batch-queue\" \nng-if=\"vm.batchJobs && vm.batchJobs.length\"><div class=\"mh-batch-job\" ng-repeat=\"job in vm.batchJobs\" \nng-class=\"{\'complete\': job.status === \'complete\', \'failed\': job.status === \'failed\' || job.status === \'error\'}\"><div \nclass=\"mh-batch-job-icon\"><md-progress-circular ng-if=\"job.status === \'pending\' || job.status === \'processing\'\" \nmd-mode=\"indeterminate\" md-diameter=\"20\"></md-progress-circular><md-icon ng-if=\"job.status === \'complete\'\" \nmd-font-icon=\"icon-check-circle\" class=\"green-fg\"></md-icon><md-icon \nng-if=\"job.status === \'failed\' || job.status === \'error\'\" md-font-icon=\"icon-alert-circle\" class=\"red-fg\"></md-icon>\n</div><div class=\"mh-batch-job-info\"><span class=\"mh-batch-job-name\">{{job.zipFileName}}</span> <span \nclass=\"mh-batch-job-status\" ng-if=\"job.status === \'pending\' || job.status === \'processing\'\">\nGenerating ZIP ({{job.itemCount}} files)…</span> <span class=\"mh-batch-job-status\" ng-if=\"job.status === \'complete\'\">\nReady · {{job.processedCount}} files</span> <span class=\"mh-batch-job-status\" \nng-if=\"job.status === \'failed\' || job.status === \'error\'\">Failed</span></div><md-button \nng-if=\"job.status === \'complete\'\" class=\"mh-batch-job-download md-icon-button\" ng-click=\"vm.downloadBatchJob(job)\" \naria-label=\"Download\"><md-icon md-font-icon=\"icon-download\"></md-icon></md-button><md-button \nclass=\"mh-batch-job-dismiss md-icon-button\" ng-click=\"vm.dismissBatchJob(job)\" aria-label=\"Dismiss\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></div><qiu-pagination \nng-if=\"vm.mediahubUrlReady && !vm.mediahubUrlMissing\" ng-show=\"!vm.searchQuery || !vm.vertexUrl\" \npassive=\"{{ (vm.searchQuery && vm.vertexUrl) ? \'true\' : \'false\' }}\" collection=\"vm.items\" url=\"vm.pagination_url\" \nservice=\"mediahubService\" menu-filters=\"main-sidenav\" sort-field=\"fileDate\" sort-dir=\"DESC\" \nfilter-by-media-type=\"vm.media_type\" fields-sort=\"vm.refSortables\"></qiu-pagination></div>");
$templateCache.put("app/main/apps/mediahub/mediahub.page.html","");
$templateCache.put("app/main/apps/scrumboard/scrumboard.html","<div id=\"scrumboard\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"header md-accent-bg\" \nng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\" layout=\"column\"><div class=\"header-content\" layout=\"row\" \nlayout-align=\"space-between\" layout-wrap flex><div layout=\"row\" layout-align=\"center center\" flex-order=\"1\" \nflex-order-xs=\"2\"><md-button class=\"md-accent md-raised md-hue-2 header-boards-button\" \nng-class=\"\'md-\'+vm.board.settings.color+\'-700-bg\'\" ng-click=\"vm.boardSelectorVisible = !vm.boardSelectorVisible\" \naria-label=\"boards button\" translate translate-attr-aria-label=\"SB.BOARDS_BUTTON\"><md-icon md-font-icon=\"icon-trello\" \nclass=\"icon\"></md-icon><span translate=\"SB.BOARDS\">BOARDS</span></md-button></div><div class=\"header-board-name\" \nlayout=\"row\" layout-align=\"center center\" flex-order=\"2\" flex-order-xs=\"1\" flex-xs=\"100\"><i \nng-if=\"vm.board.settings.subscribed\" class=\"board-subscribe s16 icon-eye\"></i> <span editable-text=\"vm.board.name\" \nonaftersave=\"vm.updateBoardUri()\">{{vm.board.name}}</span></div><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"space-between center\" flex-order=\"3\"><md-button ui-sref-active-eq=\"ng-hide\" class=\"md-icon-button\" \nui-sref=\"app.scrumboard.boards.board.calendar\" aria-label=\"Calendar\" translate translate-attr-aria-label=\"SB.CALENDAR\">\n<md-icon md-font-icon=\"icon-calendar\"></md-icon><md-tooltip><span translate=\"SB.CALENDAR\">Calendar</span></md-tooltip>\n</md-button><md-button ui-sref-active-eq=\"ng-hide\" class=\"md-icon-button\" ui-sref=\"app.scrumboard.boards.board\" \naria-label=\"Board\" translate translate-attr-aria-label=\"SB.BOARD\"><md-icon md-font-icon=\"icon-trello\"></md-icon>\n<md-tooltip><span translate=\"SB.BOARD\">Board</span></md-tooltip></md-button><md-button ng-if=\"vm.filteringIsOn()\" \nclass=\"md-icon-button\" ng-click=\"vm.clearFilters()\" aria-label=\"Clear Filters\" translate \ntranslate-attr-aria-label=\"SB.CLEAR_FILTERS\"><md-icon md-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip \nsb.clear_filters>Clear Filters</md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'filters-sidenav\')\" aria-label=\"Filter Cards\" translate \ntranslate-attr-aria-label=\"SB.FILTER_CARDS\"><md-icon md-font-icon=\"icon-filter-variant\"></md-icon><md-tooltip><span \ntranslate=\"SB.FILTER_CARDS\">Filter Cards</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'settings-sidenav\')\" aria-label=\"Settings\" translate \ntranslate-attr-aria-label=\"SB.SETTINGS\"><md-icon md-font-icon=\"icon-cog\"></md-icon><md-tooltip><span \ntranslate=\"SB.SETTINGS\">Settings</span></md-tooltip></md-button></div></div></div><div \nng-show=\"vm.boardSelectorVisible\" id=\"board-selector\" \nclass=\"md-accent-bg animate-slide-down board-list md-whiteframe-3dp\" ng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"board-list-item\" ng-repeat=\"board in vm.boardList\" \nui-sref=\"app.scrumboard.boards.board({id:board.id, uri:board.uri})\" layout=\"column\" \nlayout-align=\"space-between center\"><div class=\"board-icon\"><i class=\"icon-trello s64\"></i></div><div flex \nclass=\"board-name\">{{board.name}}</div><div class=\"board-options\"><i class=\"icon-dots-horizontal\"></i></div><div \nng-if=\"board.id === vm.board.id\" class=\"selected-icon green-bg\"><i class=\"icon-check s24\"></i></div></div><div \nclass=\"board-list-item add-new-board\" ui-sref=\"app.scrumboard.boards.addBoard\" ui-sref-active=\"hidden\" layout=\"column\" \nlayout-align=\"space-between center\"><div class=\"board-icon\"><i class=\"icon-trello s64\"></i></div><div flex \nclass=\"board-name\" translate=\"SB.ADD_NEW_BOARD\">Add New Board</div></div></div><md-backdrop \nclass=\"board-selector-backdrop md-dialog-backdrop md-opaque\" ng-show=\"vm.boardSelectorVisible\" \nng-click=\"vm.boardSelectorVisible = false\" aria-hidden=\"true\"></md-backdrop><md-content class=\"content\" flex \nlayout=\"column\" ui-view=\"scrumboardContent\"></md-content><md-sidenav class=\"settings-sidenav md-sidenav-right\" \nmd-component-id=\"settings-sidenav\" ng-include=\"\'app/main/apps/scrumboard/sidenavs/settings/settings-sidenav.html\'\" \nng-controller=\"SettingsSidenavController as vm\" ms-sidenav-helper></md-sidenav><md-sidenav \nclass=\"filters-sidenav md-sidenav-right\" md-component-id=\"filters-sidenav\" \nng-include=\"\'app/main/apps/scrumboard/sidenavs/filters/filters-sidenav.html\'\" \nng-controller=\"FiltersSidenavController as vm\" ms-sidenav-helper></md-sidenav></div>");
$templateCache.put("app/main/apps/sitemap/sitemap.html","<div id=\"site-sitemap\" class=\"page-layout carded left-sidenav\" layout=\"row\" md-no-ink><md-sidenav \nng-if=\"vm.currentSitemap && vm.availableSidenavs\" md-is-open=\"false\" class=\"sidenav widgets-list sidenav-widgets\" \nmd-component-id=\"widgets-sidenav\" ng-include=\"\'app/main/apps/sitemap/sidenavs/widgets-sidenav.html\'\" ms-scroll \nms-sidenav-helper md-no-ink></md-sidenav><md-sidenav ng-if=\"vm.currentSitemap && vm.availableSidenavs\" \nmd-is-open=\"false\" class=\"sidenav layout-list sidenav-layout\" md-component-id=\"layout-sidenav\" \nng-include=\"\'app/main/apps/sitemap/sidenavs/layout-sidenav.html\'\" ms-scroll ms-sidenav-helper md-no-ink></md-sidenav>\n<div class=\"center\" layout=\"column\" flex><div class=\"content-card\" ng-class=\"vm.currentView\" layout=\"column\" flex \nng-include=\"vm.views[vm.currentView]\" md-no-ink></div></div><qiu-pagination collection=\"vm.sitemaps\" url=\"\'http://\'\" \nservice=\"sitemapService\" style=\"display:none\"></qiu-pagination></div>");
$templateCache.put("app/main/apps/sitemap/sitemap.lite.html","<div id=\"site-sitemap\" class=\"page-layout carded left-sidenav\" layout=\"row\" md-no-ink><qiu-groups ng-if=\"vm.groups\" \nclass=\"qiu-groups\" layout=\"column\" ng-show=\"vm.showQiuGroupsSidenav\" qiu-groups-nested=\"vm.groups\" \nqiu-groups-sort-groups-by=\"vm.sortGroupsBy\" qiu-groups-sort-groups-field=\"vm.sortGroupsField\" \nqiu-groups-sort-groups-dir=\"vm.sortGroupsDir\" qiu-groups-sort-groups=\"vm.sortSitemapGroups\" \nqiu-groups-selected-group=\"vm.selectedGroup\" qiu-groups-qiu-restrictions=\"vm.qiuRestrictions\" \nqiu-groups-toggle-sidenav=\"vm.toggleQiuGroupsSidenav\" qiu-groups-get-items-in-groups=\"vm.getSitemaps\" \nqiu-groups-include-subgroups=\"vm.includeSubgroups\" qiu-groups-create-group=\"vm.createSitemapGroup\" \nqiu-groups-edit-group=\"vm.editSitemapGroup\" qiu-groups-delete-group=\"vm.deleteSitemapGroup\"></qiu-groups><div \nclass=\"center\" layout=\"column\" flex><div class=\"content-card\" ng-class=\"vm.currentView\" layout=\"column\" flex \nng-include=\"vm.views[vm.currentView]\" md-no-ink></div></div><qiu-pagination collection=\"vm.sitemaps\" url=\"\'http://\'\" \nservice=\"sitemapService\" style=\"display:none\"></qiu-pagination></div>");
$templateCache.put("app/main/apps/store/orders.html","<div id=\"site-store\" class=\"page-layout carded left-sidenav\" layout=\"row\" md-no-ink><md-sidenav \nclass=\"sidenav sidenav-users\" md-component-id=\"main-sidenav\" \nng-include=\"\'app/main/apps/store/sidenavs/main/main-sidenav.html\'\" ms-scroll ms-sidenav-helper md-no-ink></md-sidenav>\n<div class=\"center\" layout=\"column\" flex><div class=\"content-card\" ng-class=\"vm.currentView\" layout=\"column\" flex \nng-include=\"vm.views(vm.currentView)\" md-no-ink></div></div><qiu-pagination collection=\"vm.threads\" url=\"\'http://\'\" \nservice=\"storeService\" menu-filters=\"main-sidenav\" fields-filters=\"refFilterables\" fields-search=\"refSearch\" \nfields-sort=\"refSortables\" sort-dir=\"DESC\"></qiu-pagination></div>");
$templateCache.put("app/main/fields/list/category.html","<span class=\"title grey-500-fg\" ng-bind=\"field.field_name\"></span> <span class=\"detail text-truncate\" \nng-bind=\"vm.getReferencesSections(\'cat\', field.type, thread.{{field.titleId}})\"></span>");
$templateCache.put("app/main/fields/list/country.html","<span class=\"title grey-500-fg\" ng-bind=\"field.field_name\"></span> <span \nng-bind=\"vm.showCountry(thread[field.titleId], field)\"></span>");
$templateCache.put("app/main/fields/list/language.html","<img class=\"img-flag ng-scope\" alt=\"{{vm.siteLanguages(thread[field.titleId])[lang_name]}}\" \nng-src=\"assets/images/flags/{{vm.siteLanguages()[thread[field.titleId]].flag_code|lowercase}}.svg\">");
$templateCache.put("app/main/fields/list/onoff.html","<button ng-if=\"thread.onoff===1\" class=\"md-icon-button\" ng-click=\"vm.toggleItemStatus(thread, $event, parentIndex)\">\n<md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\"></md-icon></button> <button \nng-if=\"thread.onoff!==1\" class=\"md-icon-button\" ng-click=\"vm.toggleItemStatus(thread, $event, parentIndex)\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\"></md-icon></button>");
$templateCache.put("app/main/fields/list/secondary-default.html","<span class=\"title grey-500-fg\" ng-bind=\"field.field_name\"></span> <span class=\"detail\" \nng-bind=\"thread.{{field.titleId}}\" ng-if=\"field.type != \'status\'\"></span> <span class=\"detail\" \nng-bind-html=\"thread[field.titleId]|yesNo\" ng-if=\"field.type == \'status\'\"></span>");
$templateCache.put("app/main/fields/list/section.html","<span class=\"title grey-500-fg\" ng-bind=\"field.field_name\"></span> <span \nng-bind=\"vm.showAssoc(thread[field.titleId], field)\"></span>");
$templateCache.put("app/main/fields/list/subcategory.html","<span class=\"title grey-500-fg\" ng-bind=\"field.field_name\"></span> <span class=\"detail text-truncate\" \nng-bind=\"vm.getReferencesSections(\'subcat\', field.type, thread.{{field.titleId}})\"></span>");
$templateCache.put("app/main/fields/list/subsection.html","<span class=\"title grey-500-fg\" ng-bind=\"field.field_name\"></span> <span class=\"detail text-truncate\" \nng-bind=\"vm.getReferencesSections(\'subsection\', field.type, thread.{{field.titleId}})\"></span>");
$templateCache.put("app/main/fields/list/thumbnail.html","<media attachment=\"listImage\" thumbnail=\"1\" crop-format=\"{{field.id_cropformats}}\" class-img=\"avatar\" force-class \nalt=\"{{listImage.filename}}\" ng-repeat=\"listImage in thread.Thumbnail | filter: {\'id_zone\':field.id_zone} | limitTo:1\" \nng-if=\"field.id_zone\"></media><media attachment=\"listImage\" thumbnail=\"1\" crop-format=\"{{field.id_cropformats}}\" \nclass-img=\"avatar\" force-class alt=\"{{listImage.filename}}\" ng-repeat=\"listImage in thread.Thumbnail | limitTo:1\" \nng-if=\"!field.id_zone\"></media><media class-img=\"avatar\" force-class use-default ng-if=\"thread.Thumbnail.length===0\">\n</media>");
$templateCache.put("app/main/fields/list/thumbnail_square.html","<media attachment=\"listImage\" thumbnail=\"1\" crop-format=\"{{field.id_cropformats}}\" class-img=\"avatar square\" \nforce-class alt=\"{{listImage.filename}}\" \nng-repeat=\"listImage in thread.Thumbnail | filter: {\'id_zone\':field.id_zone} | limitTo:1\" ng-if=\"field.id_zone\">\n</media><media attachment=\"listImage\" thumbnail=\"1\" crop-format=\"{{field.id_cropformats}}\" class-img=\"avatar square\" \nforce-class alt=\"{{listImage.filename}}\" ng-repeat=\"listImage in thread.Thumbnail | limitTo:1\" ng-if=\"!field.id_zone\">\n</media><media class-img=\"avatar\" force-class use-default ng-if=\"thread.Thumbnail.length===0\"></media>");
$templateCache.put("app/main/fields/list/timer.html","<md-button ng-if=\"!thread._timerRunning\" class=\"md-accent green-500-bg md-raised\" \nng-click=\"vm.startTimer(thread, $event)\">Start</md-button><md-button ng-if=\"thread._timerRunning\" \nclass=\"md-warn red-500-bg md-raised\" ng-click=\"vm.stopTimer(thread, $event)\">Stop</md-button><span \nng-if=\"thread._timerRunning\" class=\"timer-display\">{{ thread._timerDisplay }} </span>");
$templateCache.put("app/main/dialogs/edit-content-sub-sec-cats/edit-content-sub-sec-cats.html","<md-dialog class=\"\" aria-label=\"Manage\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\"><div class=\"md-button\" type=\"1\" layout=\"row\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-pencil\" class=\"s18 mr-5 ml-0\"></md-icon><span \ntranslate=\"CONTENT.EDIT_SUB_SEC_CATS.TITLE\" translate-values=\"{ type: vm.name }\"></span></div></div><div layout=\"row\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate \ntranslate-aria-label=\"CONTENT.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></div>\n</md-toolbar><md-dialog-content id=\"site-mailing\" ms-scroll flex class=\"content-card\" ng-class=\"\"><div flex \nlayout=\"column\" layout-align=\"center center\" ng-if=\"vm.loading\" class=\"loading-container\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"30\"></md-progress-circular></div><form name=\"editContentSubSecCatForm\" \nng-style=\"{\'opacity\' : vm.loading ? 0.2 : 1}\" class=\"p-10\"><md-input-container class=\"md-block\" flex><label \nng-bind=\"vm.name\"></label><md-select ng-model=\"vm.selectedOption\"><md-option ng-value=\"opt\" \nng-repeat=\"opt in vm.optionsEdit\">{{opt.name}}</md-option></md-select><div class=\"md-errors-spacer\"></div>\n</md-input-container><div ng-if=\"vm.selectedOption\" layout=\"row\" flex><md-input-container class=\"md-block\" flex><label \ntranslate=\"CONTENT.EDIT_SUB_SEC_CATS.OPTION_NAME\"></label><input type=\"text\" ng-model=\"vm.selectedOption.name\" \nng-required=\"true\" name=\"name\"><div class=\"md-errors-spacer\"></div><div \nng-messages=\"editContentSubSecCatForm.name.$error\"><div ng-message=\"required\" \ntranslate=\"CONTENT.EDIT_SUB_SEC_CATS.NAME_REQUIRED\"></div></div></md-input-container><div layout=\"row\" \nlayout-align=\"end center\" flex><md-button \nng-disabled=\"editContentSubSecCatForm.$pristine || editContentSubSecCatForm.$invalid || vm.loading\" \nclass=\"md-primary md-raised\" ng-click=\"vm.editSelectedOption()\" translate=\"CONTENT.EDIT_SUB_SEC_CATS.SAVE\"></md-button>\n</div></div></form></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"end center\" flex><md-button ng-click=\"vm.closeDialog()\" \nclass=\"send-button md-accent md-raised\">CLOSE</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/tasks/tasks.html","<div id=\"site-tasks\" class=\"page-layout carded left-sidenav\" layout=\"row\" md-no-ink><md-sidenav \nclass=\"sidenav groups-tree sidenav-users sidenav-groups\" md-component-id=\"groups-sidenav\" \nng-include=\"\'app/main/apps/tasks/sidenavs/groups-sidenav.html\'\" ms-scroll ms-sidenav-helper md-no-ink></md-sidenav>\n<md-sidenav class=\"sidenav sidenav-users\" md-component-id=\"filters-sidenav\" \nng-include=\"\'app/main/apps/tasks/sidenavs/filters-sidenav.html\'\" ms-scroll ms-sidenav-helper md-no-ink></md-sidenav>\n<div class=\"center\" layout=\"column\" flex><div class=\"content-card\" ng-class=\"vm.currentView\" layout=\"column\" flex \nng-include=\"vm.views[vm.currentView]\" md-no-ink></div></div><qiu-pagination collection=\"vm.threads\" url=\"\'http://\'\" \nservice=\"tasksService\" columns=\"vm.refcolumns\" columns-grouped=\"vm.refcolumnsgrouped\" \nfields-filters=\"vm.refFilterables\" menu-filters=\"main-sidenav\" media-zones=\"refMediaZones\" fields-search=\"refSearch\" \nfields-sort=\"refSortables\" sort-field=\"id_user\" style=\"display:none\" groupby=\"list_position\"></qiu-pagination></div>");
$templateCache.put("app/main/apps/tags/tags.html","<div id=\"site-tags\" class=\"page-layout carded left-sidenav\" layout=\"row\" md-no-ink><qiu-groups \nng-if=\"vm.groups.length > 0\" class=\"qiu-groups\" layout=\"column\" ng-show=\"vm.showQiuGroupsSidenav\" \nqiu-groups-nested=\"vm.groups\" qiu-groups-sort-groups-by=\"vm.sortGroupsBy\" \nqiu-groups-sort-groups-field=\"vm.sortGroupsField\" qiu-groups-sort-groups-dir=\"vm.sortGroupsDir\" \nqiu-groups-sort-groups=\"vm.sortTagsGroups\" qiu-groups-selected-group=\"vm.selectedGroup\" \nqiu-groups-qiu-restrictions=\"vm.qiuRestrictions\" qiu-groups-toggle-sidenav=\"vm.toggleQiuGroupsSidenav\" \nqiu-groups-get-items-in-groups=\"vm.getTags\" qiu-groups-include-subgroups=\"vm.includeSubgroups\" \nqiu-groups-create-group=\"vm.createTagsGroups\" qiu-groups-edit-group=\"vm.editTagsGroups\" \nqiu-groups-delete-group=\"vm.deleteTagsGroups\"></qiu-groups><md-sidenav class=\"sidenav\" md-component-id=\"main-sidenav\" \nng-include=\"\'app/main/apps/content/sidenavs/main/main-sidenav.html\'\" ms-scroll ms-sidenav-helper md-no-ink>\n</md-sidenav><div class=\"center\" layout=\"column\" flex><div class=\"content-card\" ng-class=\"vm.currentView\" \nlayout=\"column\" flex ng-include=\"vm.views[vm.currentView]\" md-no-ink></div></div><qiu-pagination \ncollection=\"vm.threads\" url=\"\'http://\'\" service=\"tagsService\" columns=\"refcolumns\" columns-grouped=\"refcolumnsgrouped\" \nfields-filters=\"refFilterables\" menu-filters=\"main-sidenav\" media-zones=\"refMediaZones\" fields-search=\"refSearch\" \nfields-sort=\"refSortables\" style=\"display:none\" groupby=\"list_position\"></qiu-pagination></div><div class=\"saving-tag\" \nng-if=\"vm.saveTag\"><div class=\"content\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\">\n</md-progress-circular><span translate=\"TAGS.SAVING_TAG\"></span></div></div>");
$templateCache.put("app/main/apps/users/users-activity.html","<div id=\"site-users-activity\" class=\"page-layout carded left-sidenav\" layout=\"row\" md-no-ink><div flex layout=\"column\" \nlayout-align=\"center center\" ng-if=\"isLoading\" class=\"loading-container\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"50\"></md-progress-circular></div><div layout=\"column\" flex><div id=\"users-activity\" class=\"content-card\" \nng-class=\"vm.currentView\" layout=\"column\" flex \nng-include=\"\'app/main/apps/users/views/list/nosplit-view-activity.html\'\" md-no-ink></div></div><qiu-pagination \ncollection=\"vm.userAuditTrailEvents\" url=\"\'http://\'\" service=\"usersActivityService\" columns=\"vm.refcolumns\" \ncolumns-grouped=\"vm.refcolumnsgrouped\" fields-filters=\"vm.refFilterables\" media-zones=\"refMediaZones\" \nfields-search=\"refSearch\" fields-sort=\"refSortables\" style=\"display:none\"></qiu-pagination></div>");
$templateCache.put("app/main/apps/users/users.html","<div id=\"site-users\" class=\"page-layout carded left-sidenav\" layout=\"row\" md-no-ink><md-sidenav \nng-if=\"!vm.isAccreditations\" md-is-open=\"vm.isOpenSidenavGroups\" \nclass=\"sidenav groups-tree sidenav-users sidenav-groups\" md-component-id=\"groups-sidenav\" \nng-include=\"\'app/main/apps/users/sidenavs/groups-sidenav.html\'\" ms-scroll ms-sidenav-helper md-no-ink></md-sidenav>\n<md-sidenav ng-if=\"vm.isAccreditations\" md-is-open=\"vm.isOpenSidenavGroups\" \nclass=\"sidenav groups-tree sidenav-users sidenav-groups\" md-component-id=\"groups-sidenav\" \nng-include=\"\'app/main/apps/users/sidenavs/groups-accreditations-sidenav.html\'\" ms-scroll ms-sidenav-helper md-no-ink>\n</md-sidenav><md-sidenav class=\"sidenav sidenav-users\" md-component-id=\"filters-sidenav\" \nng-include=\"\'app/main/apps/users/sidenavs/filters-sidenav.html\'\" ms-scroll ms-sidenav-helper md-no-ink></md-sidenav>\n<div class=\"center\" layout=\"column\" flex><div class=\"content-card\" ng-class=\"vm.currentView\" layout=\"column\" flex \nng-include=\"vm.views[vm.currentView]\" md-no-ink></div></div><qiu-pagination collection=\"vm.threads\" url=\"\'http://\'\" \nservice=\"usersService\" columns=\"vm.refcolumns\" columns-grouped=\"vm.refcolumnsgrouped\" \nfields-filters=\"vm.refFilterables\" menu-filters=\"main-sidenav\" media-zones=\"refMediaZones\" fields-search=\"refSearch\" \nfields-sort=\"refSortables\" sort-field=\"id_user\" style=\"display:none\" groupby=\"list_position\" \ninclude-all-groups=\"vm.includeAllGroups\"></qiu-pagination></div>");
$templateCache.put("app/main/dialogs/join/join-clip-dialog.controller.html","<md-dialog class=\"joinclip-dialog\" aria-label=\"New Task\"><form style=\"height: 100%\" name=\"taskForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between\"><h1 class=\"title\">{{\'MATCH_CENTER.JOIN_CLIP\' | translate}}</h1><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div flex layout=\"column\" \nlayout-align=\"center center\" ng-show=\"vm.loading\" class=\"loading-container\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><md-list-item ng-show=\"!vm.loading\" \nclass=\"list-media-item attachment-edit\"><div class=\"attachments\"><div class=\"field\"><div dragula=\"\'attachment\'\" \ndragula-model=\"vm.selectedClips\" class=\"attachment-list md-list-item-text\" layout=\"row\" layout-wrap=\"\" \nlayout-align=\"start start\"><div class=\"attachment\" layout=\"column\" \nng-repeat=\"clip in vm.selectedClips | orderBy:\'-id_media\' track by $index\"><div><div class=\"ms-card\" flex \nmd-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"ms-card-content-wrapper\"><div class=\"template-9\"><div \nclass=\"media\" flex layout=\"row\" layout-align=\"center center\"><media attachment=\"clip\" class-img=\"image\" \nng-click=\"vm.openImageDialog($event, clip, false, false, true)\"></media></div><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div fill-width class=\"size block mr-5\" layout=\"row\" layout-align=\"start center\" \nng-if=\"clip.media_type\"><strong class=\"mr-5\">#{{clip.id_media}}</strong> <span class=\"grey-500-fg word-break-all\">\n{{clip.title ? clip.title : clip.filename}}</span><md-icon style=\"float: right\" class=\"drag icon-equal\" \naria-label=\"DRAG\"></md-icon></div></div></div></div></div></div></div></div></div></div></md-list-item><div \nng-show=\"!vm.loading\" flex layout=\"row\" layout-align=\"end center\" class=\"mr-25 mb-25\"><md-button \nclass=\"add-event-button no-sort md-fab md-warn\" ng-click=\"vm.openSelectMediaDialog($event)\" aria-label=\"Add\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-=\"end\">\n<md-input-container flex layout=\"row\" layout-align=\"end center\" class=\"m-0\"><md-button type=\"button\" \nclass=\"md-raised md-warn\" ng-click=\"vm.closeDialog()\" translate=\"FORMS.CANCEL\">Cancel</md-button><md-button \ntype=\"submit\" class=\"send-button md-accent md-raised\" ng-click=\"vm.saveDialog()\" translate=\"FORMS.SAVE\">SAVE\n</md-button></md-input-container></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/dialogs/media/media-dialog-tinymce.html","<md-dialog class=\"attachment-dialog add-media\" aria-label=\"New Message\"><form class=\"md-inline-form\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nhide show-gt-xs><a class=\"md-button\" type=\"1\" layout=\"row\" layout-align=\"center center\" \nng-click=\"vm.changeViewTiny(\'1\')\"><md-icon md-font-icon=\"icon-file-image-box\" class=\"s18 mr-5 ml-0\"></md-icon><span>\nAttached Media</span></a></div><div layout=\"row\" hide-gt-xs show-xs><md-menu><md-button aria-label=\"Filters\" \nng-click=\"$mdMenu.open($event)\" translate=\"\" translate-attr-aria-label=\"CONTENT.FILTERS\"><span layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-file-image-box\" class=\"s18 mr-5 ml-0\"></md-icon><span \nclass=\"ml-5\">Images</span> <i class=\"icon-chevron-down s20 ml-5\"></i></span></md-button><md-menu-content width=\"3\">\n<md-menu-item><md-button type=\"photos\" ng-click=\"vm.changeViewTiny(\'1\')\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div><md-icon md-font-icon=\"icon-file-image-box\" class=\"s18\"></md-icon><span>Images\n</span></div><i class=\"icon-check s16\" ng-if=\"sortfield.titleId == sortable.titleId\"></i></div></md-button>\n</md-menu-item></md-menu-content></md-menu></div><div layout=\"row\"><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate translate-aria-label=\"CONTENT.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></div></md-toolbar><div flex \nng-include=\"\'app/main/dialogs/media/views/templates/toolbar-search.html\'\"></div><md-dialog-content \nclass=\"mediadialog-content scrollable\" flex=\"100\" ms-scroll><treasure-overlay-spinner active=\"vm.loading\"><div \nlayout=\"column\" flex><md-content flex class=\"content-card\" ng-class=\"vm.currentViewTiny\" \nng-include=\"vm.viewsTiny[vm.currentViewTiny]\" md-no-ink></md-content></div></treasure-overlay-spinner>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\" ng-if=\"!vm.loading\"><div \nlayout=\"row\" layout-align=\"start center\"></div><div layout=\"row\" layout-align=\"end right\"><md-button \nng-click=\"vm.attachMediaTiny()\" class=\"send-button md-accent md-raised\" aria-label=\"Send\" translate=\"CONTENT.ADD_FILE\" \ntranslate-attr-aria-label=\"CONTENT.ADD_FILE\">ADD</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/dialogs/media/media-dialog.html","<md-dialog class=\"attachment-dialog add-media\" aria-label=\"New Message\"><form class=\"md-inline-form\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nhide show-gt-md><a class=\"md-button\" type=\"1\" layout=\"row\" layout-align=\"center center\" ng-click=\"vm.changeView(1)\" \nng-if=\"vm.views[1]\"><md-icon md-font-icon=\"icon-file-image-box\" class=\"s18 mr-5 ml-0\"></md-icon><span \ntranslate=\"MEDIA.IMAGES\"></span> </a><a class=\"md-button\" type=\"2\" layout=\"row\" layout-align=\"center center\" \nng-click=\"vm.changeView(2)\" ng-if=\"vm.views[2]\"><md-icon md-font-icon=\"icon-video\" class=\"s18 mr-5 ml-0\"></md-icon>\n<span translate=\"MEDIA.VIDEOS\"></span> </a><a class=\"md-button\" type=\"3\" layout=\"row\" layout-align=\"center center\" \nng-click=\"vm.changeView(3)\" ng-if=\"vm.views[3]\"><md-icon md-font-icon=\"icon-volume\" class=\"s18 mr-5 ml-0\"></md-icon>\n<span translate=\"MEDIA.AUDIO\"></span> </a><a class=\"md-button\" type=\"4\" layout=\"row\" layout-align=\"center center\" \nng-click=\"vm.changeView(4)\" ng-if=\"vm.views[4]\"><md-icon md-font-icon=\"icon-file\" class=\"s18 mr-5 ml-0\"></md-icon><span\n translate=\"MEDIA.FILES\"></span></a><div layout=\"row\" ng-if=\"vm.views[5] && vm.selectedSource === \'qiusystem\'\">\n<md-menu><md-button type=\"5\" aria-label=\"Filters\" ng-click=\"$mdMenu.open($event)\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.FILTERS\"><span layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-folder-multiple-image\" class=\"s18 mr-5 ml-0\"></md-icon><span class=\"ml-5\">Galleries</span> <i \nclass=\"icon-chevron-down s20 ml-5\"></i></span></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \ntype=\"photos\" ng-click=\"vm.changeViewGallery(1)\" aria-label=\"Photos\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div><md-icon md-font-icon=\"icon-file-image-box\" class=\"s18\"></md-icon><span \ntranslate=\"MEDIA.IMAGES\"></span></div><i class=\"icon-check s16\" ng-if=\"vm.currentViewGallery===1\"></i></div>\n</md-button></md-menu-item><md-menu-item><md-button type=\"videos\" ng-click=\"vm.changeViewGallery(2)\" \naria-label=\"Videos\"><div layout=\"row\" layout-align=\"space-between center\"><div><md-icon md-font-icon=\"icon-video\" \nclass=\"ss18\"></md-icon><span translate=\"MEDIA.VIDEOS\"></span></div><i class=\"icon-check s16\" \nng-if=\"vm.currentViewGallery===2\"></i></div></md-button></md-menu-item><md-menu-item><md-button type=\"audios\" \nng-click=\"vm.changeViewGallery(3)\" aria-label=\"Audios\"><div layout=\"row\" layout-align=\"space-between center\"><div>\n<md-icon md-font-icon=\"icon-volume\" class=\"s18\"></md-icon><span translate=\"MEDIA.AUDIO\"></span></div><i \nclass=\"icon-check s16\" ng-if=\"vm.currentViewGallery===3\"></i></div></md-button></md-menu-item><md-menu-item><md-button \ntype=\"files\" ng-click=\"vm.changeViewGallery(4)\" aria-label=\"Files\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div><md-icon md-font-icon=\"icon-file\" class=\"s18\"></md-icon><span \ntranslate=\"MEDIA.FILES\"></span></div><i class=\"icon-check s16\" ng-if=\"vm.currentViewGallery===4\"></i></div></md-button>\n</md-menu-item><md-menu-item><md-button type=\"files\" ng-click=\"vm.changeViewGallery(0)\" aria-label=\"Files\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div><md-icon md-font-icon=\"icon-file\" class=\"s18\"></md-icon><span \ntranslate=\"MEDIA.ALL\"></span></div><i class=\"icon-check s16\" ng-if=\"vm.currentViewGallery===0\"></i></div></md-button>\n</md-menu-item></md-menu-content></md-menu></div><a class=\"md-button\" type=\"upload\" layout=\"row\" \nlayout-align=\"center center\" ng-click=\"vm.changeView(\'upload\')\" \nng-if=\"vm.views.upload && vm.selectedSource === \'qiusystem\'\"><md-icon md-font-icon=\"icon-import\" class=\"s18 mr-5 ml-0\">\n</md-icon><span translate=\"MEDIA.UPLOAD\"></span> </a><a class=\"md-button\" type=\"import\" layout=\"row\" \nlayout-align=\"center center\" ng-click=\"vm.changeView(\'import\')\" \nng-if=\"vm.views.import && vm.selectedSource === \'qiusystem\'\"><md-icon md-font-icon=\"icon-import\" class=\"s18 mr-5 ml-0\">\n</md-icon><span translate=\"MEDIA.IMPORT_URL\"></span></a></div><div layout=\"row\" hide-gt-md show-md><md-menu><md-button \naria-label=\"Filters\" ng-click=\"$mdMenu.open($event)\" translate=\"\" translate-attr-aria-label=\"CONTENT.FILTERS\"><span \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-file-image-box\" ng-if=\"vm.currentView===\'1\'\" \nclass=\"s18 mr-5 ml-0\"></md-icon><md-icon md-font-icon=\"icon-video\" ng-if=\"vm.currentView===\'2\'\" class=\"s18 mr-5 ml-0\">\n</md-icon><md-icon md-font-icon=\"icon-volume\" ng-if=\"vm.currentView===\'3\'\" class=\"s18 mr-5 ml-0\"></md-icon><md-icon \nmd-font-icon=\"icon-file\" ng-if=\"vm.currentView===\'4\'\" class=\"s18 mr-5 ml-0\"></md-icon><md-icon \nmd-font-icon=\"icon-folder-multiple-image\" ng-if=\"vm.currentView===5\" class=\"s18 mr-5 ml-0\"></md-icon><md-icon \nmd-font-icon=\"icon-import\" ng-if=\"vm.currentView===\'upload\' || vm.currentView===\'import\'\" class=\"s18 mr-5 ml-0\">\n</md-icon><span class=\"ml-5\" ng-if=\"vm.currentView===\'1\'\">Images</span> <span class=\"ml-5\" \nng-if=\"vm.currentView===\'2\'\">Videos</span> <span class=\"ml-5\" ng-if=\"vm.currentView===\'3\'\">Audio</span> <span \nclass=\"ml-5\" ng-if=\"vm.currentView===\'4\'\">Files</span> <span class=\"ml-5\" ng-if=\"vm.currentView===5\">Galleries</span> \n<span class=\"ml-5\" ng-if=\"vm.currentView===\'upload\'\">Upload</span> <span class=\"ml-5\" \nng-if=\"vm.currentView===\'import\'\">Web Address (URL)</span> <i class=\"icon-chevron-down s20 ml-5\"></i></span>\n</md-button><md-menu-content width=\"3\"><md-menu-item><md-button type=\"photos\" ng-click=\"vm.changeView(1)\" \naria-label=\"Photos\"><div layout=\"row\" layout-align=\"space-between center\"><div><md-icon \nmd-font-icon=\"icon-file-image-box\" class=\"s18\"></md-icon><span translate=\"MEDIA.IMAGES\"></span></div><i \nclass=\"icon-check s16\" ng-if=\"vm.currentView===\'1\'\"></i></div></md-button></md-menu-item><md-menu-item><md-button \ntype=\"videos\" ng-click=\"vm.changeView(2)\" aria-label=\"Videos\"><div layout=\"row\" layout-align=\"space-between center\">\n<div><md-icon md-font-icon=\"icon-video\" class=\"ss18\"></md-icon><span translate=\"MEDIA.VIDEOS\"></span></div><i \nclass=\"icon-check s16\" ng-if=\"vm.currentView===\'2\'\"></i></div></md-button></md-menu-item><md-menu-item><md-button \ntype=\"audios\" ng-click=\"vm.changeView(3)\" aria-label=\"Audios\"><div layout=\"row\" layout-align=\"space-between center\">\n<div><md-icon md-font-icon=\"icon-volume\" class=\"s18\"></md-icon><span translate=\"MEDIA.AUDIO\"></span></div><i \nclass=\"icon-check s16\" ng-if=\"vm.currentView===\'3\'\"></i></div></md-button></md-menu-item><md-menu-item><md-button \ntype=\"files\" ng-click=\"vm.changeView(4)\" aria-label=\"Files\"><div layout=\"row\" layout-align=\"space-between center\"><div>\n<md-icon md-font-icon=\"icon-file\" class=\"s18\"></md-icon><span translate=\"MEDIA.FILES\"></span></div><i \nclass=\"icon-check s16\" ng-if=\"vm.currentView===\'4\'\"></i></div></md-button></md-menu-item><md-menu-item \nng-if=\"vm.selectedSource === \'qiusystem\'\"><md-menu><md-button aria-label=\"Filters\" ng-click=\"$mdMenu.open($event)\" \ntranslate=\"\" translate-attr-aria-label=\"CONTENT.FILTERS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-folder-multiple-image\" class=\"s18 mr-5 ml-0\">\n</md-icon><span class=\"ml-5\">Galleries</span></div><i class=\"icon-chevron-right s16 ml-5\"></i></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button type=\"photos\" ng-click=\"vm.changeViewGallery(\'1\')\" \naria-label=\"Photos\"><div layout=\"row\" layout-align=\"space-between center\"><div><md-icon \nmd-font-icon=\"icon-file-image-box\" class=\"s18\"></md-icon><span translate=\"MEDIA.IMAGES\"></span></div><i \nclass=\"icon-check s16\" ng-if=\"vm.currentViewGallery===\'1\'\"></i></div></md-button></md-menu-item><md-menu-item>\n<md-button type=\"videos\" ng-click=\"vm.changeViewGallery(\'2\')\" aria-label=\"Videos\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div><md-icon md-font-icon=\"icon-video\" class=\"ss18\"></md-icon><span \ntranslate=\"MEDIA.VIDEOS\"></span></div><i class=\"icon-check s16\" ng-if=\"vm.currentViewGallery===\'2\'\"></i></div>\n</md-button></md-menu-item><md-menu-item><md-button type=\"audios\" ng-click=\"vm.changeViewGallery(\'3\')\" \naria-label=\"Audios\"><div layout=\"row\" layout-align=\"space-between center\"><div><md-icon md-font-icon=\"icon-volume\" \nclass=\"s18\"></md-icon><span translate=\"MEDIA.AUDIO\"></span></div><i class=\"icon-check s16\" \nng-if=\"vm.currentViewGallery===\'3\'\"></i></div></md-button></md-menu-item><md-menu-item><md-button type=\"files\" \nng-click=\"vm.changeViewGallery(\'4\')\" aria-label=\"Files\"><div layout=\"row\" layout-align=\"space-between center\"><div>\n<md-icon md-font-icon=\"icon-file\" class=\"s18\"></md-icon><span translate=\"MEDIA.FILES\"></span></div><i \nclass=\"icon-check s16\" ng-if=\"vm.currentViewGallery===\'4\'\"></i></div></md-button></md-menu-item><md-menu-item>\n<md-button type=\"files\" ng-click=\"vm.changeViewGallery(\'0\')\" aria-label=\"Files\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div><md-icon md-font-icon=\"icon-file\" class=\"s18\"></md-icon><span \ntranslate=\"MEDIA.ALL\"></span></div><i class=\"icon-check s16\" ng-if=\"vm.currentViewGallery===\'0\'\"></i></div></md-button>\n</md-menu-item></md-menu-content></md-menu></md-menu-item><md-menu-item ng-if=\"vm.selectedSource === \'qiusystem\'\">\n<md-button type=\"upload\" ng-click=\"vm.changeView(\'upload\')\" aria-label=\"Upload\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div><md-icon md-font-icon=\"icon-import\" class=\"s18\"></md-icon><span \ntranslate=\"MEDIA.UPLOAD\"></span></div><i class=\"icon-check s16\" ng-if=\"vm.currentView===\'upload\'\"></i></div>\n</md-button></md-menu-item><md-menu-item ng-if=\"vm.selectedSource === \'qiusystem\'\"><md-button type=\"import\" \nng-click=\"vm.changeView(\'import\')\" aria-label=\"Import\"><div layout=\"row\" layout-align=\"space-between center\"><div>\n<md-icon md-font-icon=\"icon-import\" class=\"s18\"></md-icon><span translate=\"MEDIA.IMPORT_URL\"></span></div><i \nclass=\"icon-check s16\" ng-if=\"vm.currentView===\'import\'\"></i></div></md-button></md-menu-item></md-menu-content>\n</md-menu></div><div layout=\"row\" layout-align=\"end center\"><div class=\"source-selector-pill\" layout=\"row\" \nng-if=\"vm.mediahubUrl || vm.iconikUrl\"><md-button class=\"source-tab\" \nng-class=\"{\'active\': vm.selectedSource === \'qiusystem\'}\" ng-click=\"vm.onSourceChange(\'qiusystem\')\"><md-icon \nmd-font-icon=\"icon-server\" class=\"s18 mr-5 ml-0\"></md-icon><span>QiuSystem</span></md-button><md-button \nclass=\"source-tab\" ng-if=\"vm.mediahubUrl\" ng-class=\"{\'active\': vm.selectedSource === \'mediahub\'}\" \nng-click=\"vm.onSourceChange(\'mediahub\')\"><md-icon md-font-icon=\"icon-cloud-outline\" class=\"s18 mr-5 ml-0\"></md-icon>\n<span>MediaHub</span></md-button><md-button class=\"source-tab\" ng-if=\"vm.iconikUrl\" \nng-class=\"{\'active\': vm.selectedSource === \'iconik\'}\" ng-click=\"vm.onSourceChange(\'iconik\')\"><md-icon \nmd-font-icon=\"icon-image-multiple\" class=\"s18 mr-5 ml-0\"></md-icon><span>Iconik</span></md-button></div><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate \ntranslate-aria-label=\"CONTENT.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></div>\n</md-toolbar><md-content class=\"full-height\"><div layout=\"row\" class=\"full-height left-sidenav carded page-layout\">\n<md-sidenav ng-show=\"!vm.firstLoad\" md-is-open=\"false\" class=\"sidenav groups-tree sidenav-media-dialog\" \nmd-component-id=\"media-dialog-galleries-sidenav\" ms-scroll ms-sidenav-helper md-no-ink md-disable-backdrop \nng-include=\"\'app/main/dialogs/media/views/sidenav.html\'\"></md-sidenav><div layout=\"column\" flex class=\"center\" \nmd-no-ink><div ng-include=\"\'app/main/dialogs/media/views/templates/toolbar-search.html\'\" \nng-show=\"!vm.firstLoad && vm.isNumber(vm.currentView) && vm.currentView != 5\"></div><div \nng-include=\"\'app/main/dialogs/media/views/templates/toolbar-search-gallery.html\'\" \nng-show=\"!vm.firstLoad && vm.currentView == 5\"></div><md-dialog-content layout=\"column\" ms-scroll=\"vm.msScrollOptions\" \nflex=\"100\" class=\"mediadialog-content scrollable\"><div flex layout=\"column\" layout-align=\"center center\" \nng-show=\"vm.loading || vm.firstLoad\" class=\"loading-container\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"50\"></md-progress-circular></div><div ng-include=\"vm.views[vm.currentView]\" \nng-hide=\"vm.isNumber(vm.currentView) && vm.items.length == 0\" ng-style=\"{\'opacity\' : vm.loading ? 0.2 : 1}\" \nng-class=\"{\'full-height\': vm.currentView == \'upload\'}\"></div><div \nng-if=\"vm.isNumber(vm.currentView) && vm.items.length == 0 && !vm.loading && !vm.firstLoad\" layout=\"row\" \nlayout-align=\"center center\" class=\"content-wrapper full-height\" flex=\"100\"><div class=\"message\" \ntranslate=\"MEDIA_DIALOG.NO_ITEMS_AVAILABLE\"></div></div></md-dialog-content></div></div></md-content><md-dialog-actions\n layout=\"row\" layout-align=\"end center\" ng-style=\"{\'opacity\' : vm.loading ? 0.2 : 1}\" \nng-if=\" (vm.items.length > 0 || vm.files.length > 0)\"><div layout=\"row\" layout-align=\"start center\" \nng-if=\"!vm.totalItems\" hide show-gt-xs><span>&nbsp;</span></div><div layout=\"row\" layout-align=\"start center\" hide \nshow-gt-xs ng-if=\"vm.totalItems > 0 && vm.showSearchAndPaginator\"><span class=\"page-info\" \nng-if=\"vm.showSearchAndPaginator && vm.selectedSource !== \'mediahub\'\">{{vm.totalItems | number}} </span>&nbsp;<span \ntranslate=\"CONTENT.ITEMS_FOUND\" ng-if=\"vm.selectedSource !== \'mediahub\'\"></span><md-button aria-label=\"Previous\" \nclass=\"md-icon-button arrow\" ng-if=\"vm.showSearchAndPaginator\" ng-click=\"vm.prevPage()\" ng-disabled=\"vm.firstPage()\" \ntranslate=\"\" translate-attr-aria-label=\"CONTENT.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon>\n<md-tooltip md-direction=\"top\"><span translate=\"CONTENT.PREVIOUS\"></span></md-tooltip></md-button><div \nng-if=\"vm.selectedSource !== \'mediahub\'\"><md-select ng-model=\"vm.currentPage\" \nplaceholder=\"{{vm.currentPage | number}}\" class=\"toolbar-item\"><md-option \nng-repeat=\"n in [].constructor(vm.lastPage) track by $index\" value=\"{{$index +1}}\" ng-click=\"vm.gotoPage($index+1)\">\n{{$index+1}}</md-option></md-select><md-tooltip md-direction=\"top\"><span translate=\"CONTENT.SELECT_PAGE\"></span>\n</md-tooltip></div><div ng-if=\"vm.selectedSource === \'mediahub\'\"><span class=\"page-info\">{{vm.currentPage | number}}\n</span></div><span class=\"page-info\" hide=\"\" show-gt-xs=\"\" ng-if=\"vm.selectedSource !== \'mediahub\'\">\n/ {{vm.lastPage | number}}</span><md-button aria-label=\"Next\" class=\"md-icon-button arrow\" \nng-if=\"vm.showSearchAndPaginator\" ng-click=\"vm.nextPage()\" ng-disabled=\"!vm.morePages()\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip \nmd-direction=\"top\"><span translate=\"CONTENT.NEXT\"></span></md-tooltip></md-button></div><div layout=\"row\" \nlayout-align=\"end center\"><md-button ng-if=\"vm.currentView == \'upload\'\" \nng-disabled=\"(vm.files.length == 0 || vm.uploadedFiles.length < vm.files.length)\" ng-click=\"vm.changeView(1)\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Done\" translate=\"MEDIA_DIALOG.DONE\"></md-button></div><md-button \nng-disabled=\"vm.loading || (vm.currentView == \'upload\' && (vm.files.length == 0 || vm.files.length > vm.uploadedFiles.length))\" \nng-click=\"vm.attachMedia()\" class=\"send-button md-accent md-raised\" aria-label=\"Send\" translate=\"MEDIA.ATTACH\" \ntranslate-attr-aria-label=\"MEDIA.ATTACH\" \nng-hide=\"vm.currentView == \'import\' && (vm.importedFiles.length < 1 || vm.importPreview)\"></md-button><md-button \nng-if=\"show\" class=\"send-button md-accent md-raised\" aria-label=\"Send\" translate=\"MEDIA_DIALOG.UPLOADING\"></md-button>\n<div layout=\"row\" layout-align=\"end center\" ng-if=\"vm.importPreview\" hide show-gt-xs><md-button \nclass=\"send-button md-accent md-raised\" ng-disabled=\"vm.loading\" ng-click=\"vm.importConfirm(1)\" \ntranslate=\"CONTENT.IMPORT\">Import</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/dialogs/media-focal-point/media-focal-point-dialog.html","<md-dialog class=\"focal-point-dialog\" aria-label=\"New Task\"><md-toolbar class=\"md-accent md-hue-2 md-default-theme\">\n<div class=\"md-toolbar-tools\"><div layout=\"row\"><a class=\"md-button\" type=\"1\" layout=\"row\" \nlayout-align=\"center center\" ng-click=\"vm.changeView(\'fotorama\')\"><md-icon md-font-icon=\"icon-file-image-box\" \nclass=\"s18 mr-5 ml-0\"></md-icon><span translate=\"CONTENT.SET_FOCAL_POINT\">Set Focal Point</span></a></div><span flex>\n</span><div layout=\"row\"><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" \ntranlate translate-aria-label=\"CONTENT.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</div></md-toolbar><md-dialog-content class=\"mediadialog-content\" layout-fill ms-scroll><md-content flex \nclass=\"content-card\" ng-class=\"vm.currentView\" ng-include=\"vm.views[vm.currentView]\" md-no-ink></md-content>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"end center\"><md-button ng-click=\"vm.saveImageFocus()\" class=\"send-button md-accent md-raised\" \naria-label=\"Save\" translate=\"CONTENT.SAVE\" translate-attr-aria-label=\"CONTENT.SAVE\">SAVE</md-button></div>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/dialogs/media-show/media-show-dialog-with-tags.html","<md-dialog class=\"large attachment-dialog\" aria-label=\"New Task\"><md-toolbar \nclass=\"md-accent md-hue-2 md-default-theme\"><div class=\"md-toolbar-tools\"><div layout=\"row\"><a class=\"md-button\" \ntype=\"1\" layout=\"row\" layout-align=\"center center\" ng-click=\"vm.changeView(\'fotorama\')\"><md-icon \nmd-font-icon=\"icon-file-image-box\" class=\"s18 mr-5 ml-0\"></md-icon><span translate=\"CONTENT.PREVIEW\">Preview Media\n</span></a></div><span flex></span><div layout=\"row\"><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" tranlate translate-aria-label=\"CONTENT.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></div></md-toolbar><md-dialog-content \nclass=\"mediadialog-content {{vm.isAudio ? \'audio\' : \'\'}}\" layout-fill><div ng-if=\"!vm.isAudio\" style=\"height: 100%\">\n<md-content ng-if=\"!vm.isUniqueVideo\" flex class=\"content-card\" ng-class=\"vm.currentView\" \nng-include=\"vm.viewsWithTags[vm.currentView]\" md-no-ink></md-content><iframe class=\"video-iframe\" \nng-if=\"vm.isUniqueVideo && !vm.isM3u8\" ng-src=\"{{vm.trustSrc(vm.dataFotorama[0].video)}}\" frameborder=\"0\" \nallowfullscreen></iframe><video ng-init=\"vm.initMejPlayer()\" ng-if=\"vm.isUniqueVideo && vm.isM3u8\" autoplay \nwidth=\"100%\" height=\"100%\" style=\"width:100%;height:100%\" id=\"vp-m3u8\" classname=\"video-player mejs-ted\" \npreload=\"none\"><source type=\"application/x-mpegURL\" ng-src=\"{{vm.dataFotorama[0].video}}\"></video></div><audio \nstyle=\"width: calc(60%);margin: 50px 20%\" ng-if=\"vm.isAudio\" preload=\"none\" autoplay controls><source \nsrc=\"{{vm.audioUrl}}\" type=\"audio/mp3\">Your browser does not support the audio element.</audio></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/dialogs/media-show/media-show-dialog.html","<md-dialog class=\"large attachment-dialog\" aria-label=\"New Task\"><md-toolbar \nclass=\"md-accent md-hue-2 md-default-theme\"><div class=\"md-toolbar-tools\"><div layout=\"row\"><a class=\"md-button\" \ntype=\"1\" layout=\"row\" layout-align=\"center center\" ng-click=\"vm.changeView(\'fotorama\')\"><md-icon \nmd-font-icon=\"icon-file-image-box\" class=\"s18 mr-5 ml-0\"></md-icon><span translate=\"CONTENT.PREVIEW\">Preview Media\n</span></a></div><span flex></span><div layout=\"row\"><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" tranlate translate-aria-label=\"CONTENT.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></div></md-toolbar><md-dialog-content \nclass=\"mediadialog-content {{vm.isAudio ? \'audio\' : \'\'}}\" layout-fill><div ng-if=\"!vm.isAudio\" style=\"height: 100%\">\n<md-content ng-if=\"!vm.isUniqueVideo\" flex class=\"content-card\" ng-class=\"vm.currentView\" \nng-include=\"vm.views[vm.currentView]\" md-no-ink></md-content><iframe class=\"video-iframe\" \nng-if=\"vm.isUniqueVideo && !vm.isM3u8\" ng-src=\"{{vm.trustSrc(vm.dataFotorama[0].video)}}\" frameborder=\"0\" \nallowfullscreen></iframe><video ng-init=\"vm.initMejPlayer()\" ng-if=\"vm.isUniqueVideo && vm.isM3u8\" autoplay \nwidth=\"100%\" height=\"100%\" style=\"width:100%;height:100%\" id=\"vp-m3u8\" classname=\"video-player mejs-ted\" \npreload=\"none\"><source type=\"application/x-mpegURL\" ng-src=\"{{vm.dataFotorama[0].video}}\"></video></div><audio \nstyle=\"width: calc(60%);margin: 50px 20%\" ng-if=\"vm.isAudio\" preload=\"none\" autoplay controls><source \nsrc=\"{{vm.audioUrl}}\" type=\"audio/mp3\">Your browser does not support the audio element.</audio></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/dialogs/media-item-metadata/media-item-metadata-dialog.html","<md-dialog class=\"media-item-metadata-dialog attachment-dialog\" aria-label=\"New Task\"><md-toolbar \nclass=\"md-accent md-hue-2 md-default-theme\"><div class=\"md-toolbar-tools\"><div layout=\"row\"><a class=\"md-button\" \ntype=\"1\" layout=\"row\" layout-align=\"center center\" ng-click=\"vm.changeView(\'fotorama\')\"><md-icon \nmd-font-icon=\"icon-file-image-box\" class=\"s18 mr-5 ml-0\"></md-icon><span translate=\"CONTENT.MEDIA_ITEM_EDIT_METADATA\">\nEdit Metadata</span></a></div><span flex></span><div layout=\"row\"><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate translate-aria-label=\"CONTENT.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></div></md-toolbar><md-dialog-content \nms-scroll=\"vm.msScrollOptions\" ng-include=\"vm.views[vm.currentView]\"></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"end center\"><md-button \nng-click=\"vm.saveImageFocus()\" class=\"send-button md-accent md-raised\" aria-label=\"Save\" translate=\"CONTENT.SAVE\" \ntranslate-attr-aria-label=\"CONTENT.SAVE\">SAVE</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/dialogs/mediahub-show/mediahub-show-dialog-with-tags.html","");
$templateCache.put("app/main/dialogs/segment-users-groups/segment-users-groups.html","<md-dialog class=\"small attachment-dialog segment-dialog\" aria-label=\"Segment\"><md-toolbar class=\"md-accent\" \nlayout=\"row\" layout-align=\"space-between\"><h1 class=\"mr-0 flex-100 title ng-binding\" layout=\"row\" \nlayout-align=\"start center\" style=\"line-height: 1\"><md-icon md-font-icon=\"icon-account-multiple-plus\" \nclass=\"mr-10 ml-0 md-font\" role=\"img\" aria-label=\"icon-account-multiple-plus\"></md-icon><span \nng-if=\"vm.subscriptionGroupName != \'\'\">Segment for \'{{vm.subscriptionGroupName}}\'</span> <span \nng-if=\"vm.subscriptionGroupName == \'\'\" class=\"title\" translate=\"GROUP.CREATE_SEGMENT\"></span></h1><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" \ntranslate-aria-label=\"CONTENT.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-toolbar><div \nclass=\"form-wrapper\"><form name=\"vm.basicForm\" class=\"md-inline-form ph-5\"><md-dialog-content flex=\"100\" class=\"\"><div \nclass=\"content-wrapper\" ms-scroll flex=\"100\" layout=\"row\"><div class=\"\" flex=\"100\" layout=\"column\"><div \nclass=\"min-height mv-5\" flex=\"100\" layout=\"row\" layout-align=\"center center\"><md-input-container \nclass=\"md-block on-off\" layout=\"row\" flex><label translate=\"GROUP.TARGET_GROUP\"></label><md-menu><button \nclass=\"mr-0 width-percent-100 pb-5 pt-5 button-select\" ng-click=\"$mdMenu.open($event)\" aria-label=\"group-menu\" \nlayout=\"row\" layout-align=\"space-between center\"><span ng-if=\"vm.currentThread.targetGroupId\" class=\"font-size-14\">\n{{vm.currentThread.targetGroupName}}</span> <span ng-if=\"!vm.currentThread.targetGroupId\" class=\"font-size-14\" \ntranslate=\"GROUP.SELECT_TARGET_GROUP\"></span><md-icon md-font-icon=\"icon-menu-down\" class=\"grey-600-fg ml-10 mr-0\" \naria-hidden=\"true\"></md-icon></button><md-menu-content class=\"md-block groups-tree\"><div \nclass=\"level-card p-8 group-row ng-scope\" layout=\"row\"><label for=\"search-bar-input\"><md-icon ng-show=\"!vm.treeSearch\" \nmd-font-icon=\"icon-magnify\" class=\"grey-600-fg md-icon-button md-button\"><md-tooltip hide show-gt-xs><span \ntranslate=\"TOOLBAR.SEARCH\">Search</span></md-tooltip></md-icon><md-icon ng-show=\"vm.treeSearch\" \nmd-font-icon=\"icon-close-circle\" class=\"grey-600-fg md-icon-button md-button\" ng-click=\"vm.treeSearch = null\">\n</md-icon></label><input type=\"text\" id=\"search-bar-input\" class=\"grey-600-fg grey-100-bg\" ng-model=\"vm.treeSearch\" \nplaceholder=\"Search\" md-autofocus translate translate-attr-placeholder=\"TOOLBAR.SEARCH\" flex></div><div \nng-click=\"$mdCloseMenu($event)\" ng-if=\"vm.usersGroups\" ivh-treeview=\"vm.usersGroups\" \nivh-treeview-filter=\"vm.treeSearch\" class=\"ivh-treeview-folder small\" ivh-treeview-label-attribute=\"\'label\'\"><script \ntype=\"text/ng-template\">\n<div\r\n                                            class=\"level-card p-8 group-row select-segment-target-group-row\"\r\n                                            layout=\"row\"\r\n                                            layout-align=\"space-between stretch\">\r\n                                            <span ivh-treeview-twistie ivh-treeview-toggle layout=\"row\" layout-align=\"center center\"></span>\r\n                                            <div\r\n                                                qiu-segment-users-on-click-select-target-group\r\n                                                flex\r\n                                                id=\"treeview-group-{{node.id_group}}\"\r\n                                                data-group-node={{node}}\r\n                                                layout=\"row\"\r\n                                                layout-align=\"start center\">\r\n                                                <div ng-if=\"node.group_type.icon\">\r\n                                                    <md-icon ng-if=\"node.group_type.icon\"\r\n                                                        class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                                        md-font-icon=\"{{node.group_type.icon}}\"\r\n                                                        aria-hidden=\"true\" >\r\n                                                    </md-icon>\r\n                                                </div>\r\n                                                <div ng-if=\"!node.group_type.icon\">\r\n                                                  <md-icon ng-if=\"!node.children && node.id_group_type == 1\"\r\n                                                      class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                                      md-font-icon=\"icon-folder\"\r\n                                                      aria-hidden=\"true\" >\r\n                                                  </md-icon>\r\n                                                  <md-icon\r\n                                                      ng-if=\"node.children && node.id_group_type == 1\"\r\n                                                      class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                                      md-font-icon=\"icon-folder-multiple\"\r\n                                                      aria-hidden=\"true\" >\r\n                                                  </md-icon> \r\n                                                  <md-icon ng-if=\"!node.children && node.id_group_type == 2\"\r\n                                                      class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                                      md-font-icon=\"qiu-icon-file-usermailing\"\r\n                                                      aria-hidden=\"true\" >\r\n                                                  </md-icon>\r\n                                                  <md-icon\r\n                                                      ng-if=\"node.children && node.id_group_type == 2\"\r\n                                                      class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                                      md-svg-src=\"/assets/icons/svg/icon-folder-mail-multiple.svg\"\r\n                                                      aria-hidden=\"true\" > \r\n                                                  </md-icon>\r\n                                                  <md-icon ng-if=\"!node.children && node.id_group_type == 3\"\r\n                                                      class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                                      md-font-icon=\"qiu-icon-file-usermediacenter\"\r\n                                                      aria-hidden=\"true\" >\r\n                                                  </md-icon>\r\n                                                  <md-icon\r\n                                                      ng-if=\"node.children && node.id_group_type == 3\"\r\n                                                      class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                                      md-svg-src=\"/assets/icons/svg/icon-folder-play-multiple.svg\"\r\n                                                      aria-hidden=\"true\" >\r\n                                                  </md-icon>\r\n                                                  <md-icon ng-if=\"!node.children && node.id_group_type == 4\"\r\n                                                      class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                                      md-font-icon=\"qiu-icon-file-usersegment\"\r\n                                                      aria-hidden=\"true\" >\r\n                                                  </md-icon>\r\n                                                  <md-icon\r\n                                                      ng-if=\"node.children && node.id_group_type == 4\"\r\n                                                      class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                                      md-svg-src=\"/assets/icons/svg/icon-folder-share-multiple.svg\"\r\n                                                      aria-hidden=\"true\" >\r\n                                                  </md-icon>\r\n                                                  <md-icon ng-if=\"!node.children && node.id_group_type == 5\"\r\n                                                      class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                                      md-font-icon=\"qiu-icon-file-userstore\"\r\n                                                      aria-hidden=\"true\" >\r\n                                                  </md-icon>\r\n                                                  <md-icon\r\n                                                      ng-if=\"node.children && node.id_group_type == 5\"\r\n                                                      class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                                      md-svg-src=\"/assets/icons/svg/icon-folder-shop-multiple.svg\"\r\n                                                      aria-hidden=\"true\" >\r\n                                                  </md-icon>\r\n                                                  <md-icon ng-if=\"!node.children && node.id_group_type == 6\"\r\n                                                      class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                                      md-font-icon=\"qiu-icon-file-useracreditation\"\r\n                                                      aria-hidden=\"true\" >\r\n                                                  </md-icon>\r\n                                                  <md-icon\r\n                                                      ng-if=\"node.children && node.id_group_type == 6\"\r\n                                                      class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                                      md-svg-src=\"/assets/icons/svg/icon-folder-board-multiple.svg\"\r\n                                                      aria-hidden=\"true\" >\r\n                                                  </md-icon>\r\n                                                  <md-icon ng-if=\"!node.children && node.id_group_type == 7\"\r\n                                                      class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                                      md-svg-src=\"/assets/icons/svg/icon-folder-chat.svg\"\r\n                                                      aria-hidden=\"true\" >\r\n                                                  </md-icon>\r\n                                                  <md-icon\r\n                                                      ng-if=\"node.children && node.id_group_type == 7\"\r\n                                                      class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                                      md-svg-src=\"/assets/icons/svg/icon-folder-chat-multiple.svg\"\r\n                                                      aria-hidden=\"true\" >\r\n                                                  </md-icon>\r\n                                                  <md-icon ng-if=\"!node.children && node.id_group_type == 8\"\r\n                                                      class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                                      md-font-icon=\"icon-folder-remove\"\r\n                                                      aria-hidden=\"true\" >\r\n                                                  </md-icon>\r\n                                                  <md-icon\r\n                                                      ng-if=\"node.children && node.id_group_type == 8\"\r\n                                                      class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                                      md-font-icon=\"icon-folder-multiple\"\r\n                                                      aria-hidden=\"true\" >\r\n                                                  </md-icon>\r\n                                                </div>\r\n                                                <span class=\"ivh-treeview-node-label ng-binding\">{{node.name}}</span>\r\n                                            </div>\r\n                                          </div>\r\n                                        <div ivh-treeview-children></div>\n</script></div></md-menu-content></md-menu></md-input-container><md-icon md-font-icon=\"icon-close s20\" \nng-click=\"vm.deleteTargetGroup()\" class=\"ml-10\"><md-tooltip hide show-gt-xs><span translate=\"GROUP.DELETE\">\nDelete target group</span></md-tooltip></md-icon></div><md-input-container class=\"mb-0\" \nng-if=\"!vm.currentThread.targetGroupId\"><label translate=\"GROUP.SEGMENT_NAME\"></label><input type=\"text\" required \nname=\"group_name\" ng-disabled=\"\" ng-model=\"vm.currentThread.groupName\" translate-attr-placeholder=\"GROUP.NAME\"><div \nng-messages=\"vm.basicForm.group_name.$error\" role=\"alert\"><div ng-message=\"required\"><div \ntranslate=\"GROUP.NAME_REQUIRED\"></div></div></div></md-input-container><md-input-container \nng-if=\"vm.newGroupShow && !vm.currentThread.targetGroupId\" class=\"m-0\"><md-checkbox \nng-model=\"vm.currentThread.showGroup\" aria-label=\"{{vm.currentThread.showGroup ? \'Deselect\' : \'Select\'}}\" class=\"ml-5\">\n<span translate=\"GROUP.SHOW_IN_LIST\"></span></md-checkbox></md-input-container><md-input-container class=\"m-0\" \nng-if=\"vm.showGroupsTypes && !vm.currentThread.targetGroupId\"><label translate=\"GROUP.TYPE\"></label><md-select \nng-model=\"vm.currentThread.groupTypeId\" translate-attr-placeholder=\"GROUP.TYPE\"><md-option \nng-repeat=\"type in vm.usersGroupsTypes\" ng-bind=\"type.name\" ng-value=\"type.id_group_type\" \nng-selected=\"type.id_group_type == vm.currentThread.groupTypeId\"></md-option></md-select><div class=\"md-errors-spacer\">\n</div></md-input-container><div class=\"min-height\" flex=\"100\" layout=\"row\" layout-align=\"start center\"><span \ntranslate=\"GROUP.USERS_MATCH\"></span><md-select required aria-label=\"Operation\" \nng-model=\"vm.currentThread.booleanOperation\" translate-attr-placeholder=\"GROUP.ACTION\" class=\"mh-10\"><md-option \nng-repeat=\"operation in vm.booleanOperations\" ng-bind=\"operation.name\" ng-value=\"operation.operation\" \nng-selected=\"operation.operation == vm.currentThread.booleanOperation\" translate-attr-aria-label=\"GROUP.ACTION\">\n</md-option></md-select><span translate=\"GROUP.OF_FOLLOWING_GROUPS\"></span></div><div class=\"min-height mv-5\" \nflex=\"100\" layout=\"row\" layout-align=\"center center\" ng-repeat=\"selGroup in vm.selectedGroups\"><span \nng-if=\"$index > 0 && vm.currentThread.action == \'add\'\">OR</span> <span \nng-if=\"$index > 0 && vm.currentThread.action == \'intersect\'\">AND</span><md-input-container layout=\"row\" \nclass=\"md-block m-0\" flex><label translate=\"GROUP.GROUP\"></label><md-select required name=\"group\" \nng-model=\"vm.selectedGroups[$index]\" translate-attr-placeholder=\"GROUP\"><md-select-header class=\"select-header-search\">\n<input autofocus ng-model=\"searchGroup\" type=\"search\" onkeydown=\"event.stopPropagation()\" placeholder=\"Search...\" \nclass=\"demo-header-searchbox md-text\"></md-select-header><md-option \nng-repeat=\"group in vm.unnestedGroups | filter: searchGroup\" ng-bind=\"group.name\" ng-value=\"group\" \nng-selected=\"group.id_group == selGroup.id_group\"></md-option></md-select><div ng-messages=\"vm.basicForm.group.$error\" \nrole=\"alert\"><div ng-message=\"required\"><div translate=\"GROUP.GROUP_REQUIRED\"></div></div></div></md-input-container>\n<md-icon md-font-icon=\"icon-close s20\" ng-click=\"vm.deleteGroup($index)\" class=\"ml-10\"><md-tooltip hide show-gt-xs>\n<span translate=\"GROUP.DELETE\">Delete group</span></md-tooltip></md-icon></div><div flex=\"100\" layout=\"row\" \nlayout-margin><md-button ng-click=\"vm.addGroup()\" class=\"ml-0 green-500-bg no-shadow md-accent md-fab\" \naria-label=\"MAILING.SEGMENT\" translate=\"\" translate-attr-aria-label=\"MAILING.SEGMENT\" layout=\"row\" \nlayout-align=\"center center\" type=\"button\"><md-icon md-font-icon=\"icon-plus\" role=\"img\" class=\"ml-10\"></md-icon>\n<md-tooltip hide show-gt-xs><span translate=\"GROUP.ACTIONS.ADD\">Add group</span></md-tooltip></md-button></div></div>\n</div></md-dialog-content></form></div><md-dialog-actions layout=\"row\" layout-align=\"end center\"><div layout=\"row\" \nlayout-align=\"end center\"><md-button ng-disabled=\"vm.basicForm.$invalid || vm.basicForm.$pristine || vm.loading\" \nng-click=\"vm.save()\" class=\"send-button md-accent md-raised\" aria-label=\"Send\" translate=\"GROUP.CREATE\" \ntranslate-attr-aria-label=\"USERS.GROUPS.CREATE\"></md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/dialogs/rss-import/rss-import.html","<md-dialog class=\"attachment-dialog add-media carded left-sidenav\" id=\"site-media\" aria-label=\"RSS Import\"><md-toolbar \nclass=\"md-accent\"><div layout-align=\"space-between center\" class=\"md-toolbar-tools\"><div layout=\"row\" \nlayout-align=\"start center\"><a class=\"md-button grey-A100-fg layout-align-start-center layout-row\" type=\"import\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-rss-box\" class=\"s18 mr-5 ml-0 md-font\" role=\"img\" \naria-label=\"icon-rss-box\"></md-icon><span class=\"title\">RSS Import ({{vm.importSection}})</span></a></div><div \nlayout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-aria-label=\"CONTENT.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></div></md-toolbar><div ng-if=\"vm.showRssSearch\" layout=\"row\" class=\"rss-search\"><div \nlayout=\"row\" flex layout-align=\"start center\"><label for=\"search-bar-input\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"grey-600-fg md-icon-button md-button\"><md-tooltip hide show-gt-xs><span translate=\"TOOLBAR.SEARCH\">Search</span>\n</md-tooltip></md-icon></label><md-icon md-font-icon=\"icon-close-circle\" class=\"grey-600-fg md-icon-button md-button\" \nng-if=\"vm.rssSearch\" ng-click=\"vm.rssSearch = \'\'\"></md-icon><input type=\"text\" id=\"search-bar-input\" \nclass=\"grey-600-fg grey-100-bg rss-search-input\" ng-model=\"vm.rssSearch\" placeholder=\"Search\" md-autofocus translate \ntranslate-attr-placeholder=\"TOOLBAR.SEARCH\" flex><md-icon layout-align=\"end center\" \nng-click=\"vm.showRssSearch = false\" md-font-icon=\"icon-close\" class=\"rss-search-collapser icon s24 grey-600-fg\">\n</md-icon></div></div><div ng-show=\"!vm.loading && !vm.showRssSearch\" class=\"toolbar\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-label\" \naria-label=\"{{vm.selectedThreads.length > 0 ? \'Deselect All\' : \'Select All\'}}\" \nng-checked=\"vm.selectedThreads.length > 0\" ng-click=\"vm.toggleSelectThreads()\"></md-checkbox><div \nclass=\"divider-vertical\"></div><div layout=\"column\" layout-margin layout-align=\"center center\"><md-select \nng-model=\"vm.selectedLanguage\" placeholder=\"Language\"><md-option ng-repeat=\"opt in vm.siteLanguages()\" \nvalue=\"{{opt.id_lang}}\">{{opt.lang_name}}</md-option></md-select><div class=\"md-errors-spacer\"></div></div><div \nng-init=\"vm.getSubsecs()\" ng-if=\"vm.subsecs\" layout-margin layout=\"column\" layout-align=\"center center\"><md-select \nng-model=\"vm.selectedSubsec\" placeholder=\"Subsection\"><md-option ng-repeat=\"opt in vm.subsecs\" value=\"{{opt.value}}\">\n{{opt.name}}</md-option></md-select><div class=\"md-errors-spacer\"></div></div><div layout=\"column\" \nlayout-align=\"center center\"><button ng-if=\"vm.selectedStatus ===1\" class=\"md-icon-button md-button\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\" ng-click=\"vm.selectedStatus = 0\"></md-icon></button>\n <button ng-if=\"vm.selectedStatus ===0\" class=\"md-icon-button md-button\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\" ng-click=\"vm.selectedStatus = 1\"></md-icon>\n</button></div><div layout=\"column\" layout-margin layout-align=\"center center\"><md-checkbox aria-label=\"Home feed\" \nng-model=\"vm.isHomeFeed\">Home feed</md-checkbox></div><div layout=\"column\" layout-margin layout-align=\"center center\">\n<md-checkbox aria-label=\"Description as Text\" ng-model=\"vm.descriptionAsText\">Description as Text</md-checkbox></div>\n</div><div layout=\"row\"><label for=\"search-bar-input\"><md-icon ng-click=\"vm.showRssSearch = true\" \nmd-font-icon=\"icon-magnify\" class=\"m-0 grey-600-fg md-icon-button md-button md-default-theme md-font material-icons\">\n<md-tooltip hide show-gt-xs><span translate=\"TOOLBAR.SEARCH\">Search</span></md-tooltip></md-icon></label></div></div>\n<md-dialog-content flex=\"100\" class=\"content\"><div class=\"content-wrapper\" flex=\"100\" layout=\"row\"><div \nclass=\"content\" flex=\"100\" layout=\"column\"><div flex layout=\"column\" layout-align=\"center center\" ng-show=\"vm.loading\" \nclass=\"loading-container\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div>\n<form ng-show=\"!vm.loading\" name=\"vm.basicForm\" class=\"md-inline-form form-wrapper\"><div id=\"list-content-data\" \nclass=\"list-content-data\" ng-style=\"{\'opacity\' : vm.isLoading ? 0.2 : 1}\" ms-scroll=\"vm.msScrollOptions\" \nng-class=\"{\'group-filter\': vm.selectedGallery,\'other-filter\':$root.pagination_searchquery==true}\" class=\"scrollable\" \nng-if=\"vm.items.length > 0\"><div class=\"mail-list-pane\"><div class=\"mail-list-item\" \nng-repeat=\"mediaItem in vm.items | filter: {title: vm.rssSearch}\" ng-if=\"vm.isJsonFile\"><div layout=\"row\" \nlayout-align=\"start center\"><md-checkbox ng-checked=\"vm.isSelected(mediaItem)\" \nng-click=\"vm.toggleSelectThread(mediaItem, $event)\" aria-label=\"{{vm.isSelected(mediaItem) ? \'Deselect\' : \'Select\'}}\" \nclass=\"mb-0\"></md-checkbox><div class=\"media photos\" layout=\"row\" layout-align=\"center center\" ng-if=\"mediaItem.media\">\n<img class=\"image\" ng-src=\"{{mediaItem.media}}\" imageonload></div><div class=\"info\" flex layout=\"column\"><div \nclass=\"subject text-truncate grey-500-fg\" layout=\"row\" layout-align=\"start center\"><span>\nDate published: {{mediaItem.date}}</span></div><div class=\"name\" layout=\"row\" layout-align=\"start center\"><span \nng-bind=\"mediaItem.title\" ng-if=\"mediaItem.title\"></span></div><div class=\"details\" ng-if=\"mediaItem.url\"><span \nclass=\"title grey-500-fg\">Link</span> <span class=\"detail\"><a target=\"_blank\" href=\"{{mediaItem.url}}\">\n{{mediaItem.url}}</a></span></div></div><div class=\"subject buttons text-truncate grey-500-fg\" layout=\"row\" \nlayout-align=\"start center\"><span>#{{mediaItem.id}}</span></div></div></div><div class=\"mail-list-item\" \nng-repeat=\"mediaItem in vm.items | filter: {title: vm.rssSearch}\" ng-if=\"!vm.isJsonFile\"><div layout=\"row\" \nlayout-align=\"start center\"><md-checkbox ng-checked=\"vm.isSelected(mediaItem)\" \nng-click=\"vm.toggleSelectThread(mediaItem, $event)\" aria-label=\"{{vm.isSelected(mediaItem) ? \'Deselect\' : \'Select\'}}\" \nclass=\"mb-0\"></md-checkbox><div class=\"media photos\" layout=\"row\" layout-align=\"center center\" \nng-if=\"mediaItem.enclosure\"><img class=\"image\" ng-src=\"{{mediaItem.enclosure[\'@attributes\'].url}}\" imageonload></div>\n<div class=\"media photos\" layout=\"row\" layout-align=\"center center\" ng-if=\"mediaItem.thumbnail\"><img class=\"image\" \nng-src=\"{{mediaItem.thumbnail[\'@attributes\'].url}}\" imageonload></div><div class=\"info\" flex layout=\"column\"><div \nclass=\"subject text-truncate grey-500-fg\" layout=\"row\" layout-align=\"start center\"><span>\nDate published: {{mediaItem.pubDate}}</span></div><div class=\"name\" layout=\"row\" layout-align=\"start center\"><span \nng-bind=\"mediaItem.filename\" ng-if=\"mediaItem.filename\"></span> <span ng-bind=\"mediaItem.title\" \nng-if=\"mediaItem.title && !mediaItem.filename\"></span></div><div class=\"details\" \nng-if=\"mediaItem.filename && mediaItem.title\"><span class=\"title grey-500-fg\">Title</span> <span class=\"detail\">\n{{mediaItem.title}}</span></div><div class=\"details\" ng-if=\"mediaItem.link\"><span class=\"title grey-500-fg\">Link</span>\n <span class=\"detail\"><a target=\"_blank\" href=\"{{mediaItem.link}}\">{{mediaItem.link}}</a></span></div></div><div \nclass=\"subject buttons text-truncate grey-500-fg\" layout=\"row\" layout-align=\"start center\"><span>#{{mediaItem.guid}}\n</span></div></div></div></div></div></form></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"end center\"><div layout=\"row\" layout-align=\"end center\"><md-button \nng-disabled=\"vm.selectedThreads.length == 0 || vm.loading\" ng-click=\"vm.save()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Send\" translate=\"CONTENT.IMPORT\" \ntranslate-attr-aria-label=\"CONTENT.IMPORT\"></md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/plugins/html-preview/html-preview.html","<md-dialog class=\"html-preview-dialog\" aria-label=\"Preview\" flex=\"95\"><form class=\"md-inline-form\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\"><a \nclass=\"md-button\" type=\"1\" layout=\"row\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-web\" \nclass=\"s18 mr-5 ml-0\"></md-icon><span translate=\"GLOBAL.PREVIEW\"></span></a></div><div layout=\"row\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" \ntranslate-aria-label=\"CONTENT.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></div>\n</md-toolbar><md-dialog-content flex=\"100\" class=\"content-card\"><div id=\"html-preview\" flex=\"\"><div \nclass=\"html-preview-content\" flex=\"100\"><div position-relative class=\"preview\"><div class=\"builder\" ms-scroll><div \nid=\"device-selector\" layout=\"row\" layout-align=\"center center\" class=\"pt-30 pb-30 h-100\"><md-button \naria-label=\"DESKTOP VIEW\" ng-click=\"vm.setWidth(\'desktop\')\" class=\"md-icon-button\" type=\"button\"><md-icon \nmd-font-icon=\"icon-desktop-mac\" class=\"s24\" ng-class=\"{\'opacity-5\': (vm.currentType == \'mobile\')}\"></md-icon>\n<md-tooltip hide show-gt-xs><span translate=\"MAILING.DESKTOP_VIEW\"></span></md-tooltip></md-button><div \nclass=\"divider-vertical\"></div><md-button aria-label=\"MOBILE VIEW\" ng-click=\"vm.setWidth(\'mobile\')\" \nclass=\"md-icon-button\" type=\"button\"><md-icon md-font-icon=\"icon-cellphone\" \nng-class=\"{\'opacity-5\': (vm.currentType != \'mobile\')}\" class=\"s24\"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate=\"MAILING.MOBILE_VIEW\"></span></md-tooltip></md-button></div><desktop-preview html=\"vm.html\" width=\"vm.width\">\n</desktop-preview></div></div></div></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/plugins/template-builder/template-builder.html","<md-dialog class=\"template-builder-dialog\" aria-label=\"Design Template\" flex=\"95\"><form class=\"md-inline-form\">\n<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\"><a class=\"md-button\" type=\"1\" layout=\"row\" layout-align=\"center center\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"s18 mr-5 ml-0\"></md-icon><span translate=\"MAILING.TEMPLATE_DESIGN\"></span></a></div>\n<div layout=\"row\"><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate \ntranslate-aria-label=\"CONTENT.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></div>\n</md-toolbar><md-dialog-content flex=\"100\" class=\"content-card\"><div id=\"email-builder\" flex=\"\"><div \nclass=\"email-builder-content\" flex=\"100\"><div class=\"md-card\" ng-class=\"{preview: vm.preview}\"><div \nclass=\"md-card-content elements-list\"><h2 ng-if=\"vm.webEdit\">Web sections</h2><ul ng-if=\"vm.webEdit\" \ndragula=\"\'element\'\"><li ng-repeat=\"element in vm.webElements\" data-type=\"{{\'multipleText\' + element.value.id}}\"><div \nclass=\"element-container\"><i class=\"material-icons {{element.value.icon}}\"></i><span \nng-bind=\"element.name | translate\"></span></div></li></ul><h2 ng-if=\"vm.webEdit\">Web elements</h2><ul \ndragula=\"\'element\'\"><li ng-repeat=\"element in vm.elements\" data-type=\"{{element.type}}\"><div class=\"element-container\">\n<i class=\"material-icons {{element.icon}}\"></i><span ng-bind=\"element.primary_head | translate\"></span></div></li></ul>\n<button ng-if=\"!vm.webEdit\" class=\"md-button md-btn md-raised md-accent\" \nng-disabled=\"vm.currentElement.type == \'emailSettings\'\" ng-click=\"vm.editElement(\'emailSettings\')\"><md-icon \nmd-font-icon=\"icon-cog\"></md-icon><span translate=\"email_settings\"></span></button> <button ng-if=\"!vm.webEdit\" \nclass=\"md-button md-btn md-raised md-warn\" ng-disabled=\"vm.Email.elements.length == 0\" \nng-click=\"vm.deleteAllElements()\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span translate=\"delete_all_elements\">\n</span></button></div></div><div position-relative ng-class=\"{preview: vm.preview, configured: !vm.preview}\"><div \nclass=\"builder\" ms-scroll><div id=\"device-selector\" layout=\"row\" layout-align=\"center center\" \nclass=\"pt-30 pb-30 h-100\"><md-button aria-label=\"DESKTOP VIEW\" ng-click=\"vm.toggleView(\'\')\" class=\"md-icon-button\" \ntype=\"button\"><md-icon md-font-icon=\"icon-pencil\" class=\"s24\" ng-class=\"{\'opacity-5\': vm.viewPreview}\"></md-icon>\n<md-tooltip hide show-gt-xs><span translate=\"MAILING.EDIT\"></span></md-tooltip></md-button><div \nclass=\"divider-vertical\"></div><md-button aria-label=\"DESKTOP VIEW\" ng-click=\"vm.toggleView(\'desktop\')\" \nclass=\"md-icon-button\" type=\"button\"><md-icon md-font-icon=\"icon-desktop-mac\" class=\"s24\" \nng-class=\"{\'opacity-5\': (vm.viewPreview != \'desktop\')}\"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate=\"MAILING.DESKTOP_VIEW\"></span></md-tooltip></md-button><div class=\"divider-vertical\"></div><md-button \naria-label=\"MOBILE VIEW\" ng-click=\"vm.toggleView(\'mobile\')\" class=\"md-icon-button\" type=\"button\"><md-icon \nmd-font-icon=\"icon-cellphone\" ng-class=\"{\'opacity-5\': (vm.viewPreview != \'mobile\')}\" class=\"s24\"></md-icon><md-tooltip \nhide show-gt-xs><span translate=\"MAILING.MOBILE_VIEW\"></span></md-tooltip></md-button></div><div class=\"email-loading\" \nng-if=\"vm.isLoading\"><div flex layout=\"column\" layout-align=\"center center\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div></div><desktop-preview \nhtml=\"vm.Email.html\" class=\"desktop-preview\" width=\"600\" ng-if=\"vm.viewPreview == \'desktop\' && !vm.isLoading\">\n</desktop-preview><mobile-preview email=\"vm.Email\" class=\"mobile-preview\" \nng-if=\"vm.viewPreview == \'mobile\' && !vm.isLoading\"></mobile-preview><div \nng-if=\"!vm.viewPreview && !vm.isLoading && !vm.webEdit\" class=\"full-email-container elements-container\" \nng-style=\"vm.Email.emailSettings.options\"><div class=\"header-container elements-container\" \nng-if=\"vm.splitContent && !vm.viewPreview && !vm.isLoading && !vm.webEdit\" \nng-class=\"{empty: !vm.Email.header.elements.length}\" \ndata-empty-template=\"{{\'drag_and_drop_elements_here\' | translate}}\" dragula=\"\'element-html\'\"><div \nclass=\"builder-element\" ng-class=\"{selected: vm.currentElement.id === element.id}\" \nng-repeat=\"element in vm.Email.header.elements track by element.id\" id=\"{{ element.id }}\"><ng-include \nsrc=\"vm.getTemplate(element.type, \'\')\" ng-click=\"vm.editElement(element.id,\'\', \'header\')\"></ng-include><div \nclass=\"icons-actions\"><i title=\"{{\'move_element\' | translate}}\" class=\"actions move material-icons\">drag_handle</i> <i \nclass=\"actions clone material-icons\" title=\"{{\'clone_element\' | translate}}\" \nng-click=\"vm.cloneElement(element.id, \'header\')\">content_copy</i><br><i class=\"actions delete material-icons\" \ntitle=\"{{\'delete_element\' | translate}}\" ng-click=\"vm.removeElement(element.id, \'header\')\">delete</i></div></div></div>\n<span ng-if=\"vm.splitContent && !vm.viewPreview && !vm.isLoading && !vm.webEdit\" class=\"container-name\">Header</span>\n<div ng-if=\"vm.splitContent && !vm.viewPreview && !vm.isLoading && !vm.webEdit\" class=\"container-divider\"></div><span \nng-if=\"vm.splitContent && !vm.viewPreview && !vm.isLoading && !vm.webEdit\" class=\"container-name\">Content</span><div \nclass=\"email-container elements-container\" ng-if=\"!vm.viewPreview && !vm.isLoading && !vm.webEdit\" \nng-class=\"{empty: !vm.Email.elements.length}\" data-empty-template=\"{{\'drag_and_drop_elements_here\' | translate}}\" \ndragula=\"\'element-html\'\"><div class=\"builder-element\" ng-class=\"{selected: vm.currentElement.id === element.id}\" \nng-repeat=\"element in vm.Email.elements track by element.id\" id=\"{{ element.id }}\"><ng-include \nsrc=\"vm.getTemplate(element.type, \'\')\" ng-click=\"vm.editElement(element.id,\'\', \'content\')\"></ng-include><div \nclass=\"icons-actions\"><i title=\"{{\'move_element\' | translate}}\" class=\"actions move material-icons\">drag_handle</i> <i \nclass=\"actions clone material-icons\" title=\"{{\'clone_element\' | translate}}\" \nng-click=\"vm.cloneElement(element.id, \'content\')\">content_copy</i><br><i class=\"actions delete material-icons\" \ntitle=\"{{\'delete_element\' | translate}}\" ng-click=\"vm.removeElement(element.id, \'content\')\">delete</i></div></div>\n</div><span ng-if=\"vm.splitContent && !vm.viewPreview && !vm.isLoading && !vm.webEdit\" class=\"container-name\">Content\n</span><div ng-if=\"vm.splitContent && !vm.viewPreview && !vm.isLoading && !vm.webEdit\" class=\"container-divider\"></div>\n<span ng-if=\"vm.splitContent && !vm.viewPreview && !vm.isLoading && !vm.webEdit\" class=\"container-name\">Footer</span>\n<div class=\"footer-container elements-container\" \nng-if=\"vm.splitContent && !vm.viewPreview && !vm.isLoading && !vm.webEdit\" \nng-class=\"{empty: !vm.Email.footer.elements.length}\" \ndata-empty-template=\"{{\'drag_and_drop_elements_here\' | translate}}\" dragula=\"\'element-html\'\"><div \nclass=\"builder-element\" ng-class=\"{selected: vm.currentElement.id === element.id}\" \nng-repeat=\"element in vm.Email.footer.elements track by element.id\" id=\"{{ element.id }}\"><ng-include \nsrc=\"vm.getTemplate(element.type, \'\')\" ng-click=\"vm.editElement(element.id,\'\', \'footer\')\"></ng-include><div \nclass=\"icons-actions\"><i title=\"{{\'move_element\' | translate}}\" class=\"actions move material-icons\">drag_handle</i> <i \nclass=\"actions clone material-icons\" title=\"{{\'clone_element\' | translate}}\" \nng-click=\"vm.cloneElement(element.id, \'footer\')\">content_copy</i><br><i class=\"actions delete material-icons\" \ntitle=\"{{\'delete_element\' | translate}}\" ng-click=\"vm.removeElement(element.id, \'footer\')\">delete</i></div></div></div>\n</div><div class=\"web-container article-view-header\" ng-if=\"!vm.viewPreview && !vm.isLoading && vm.webEdit\"><div \nng-click=\"vm.editElement(\'\', vm.elementHeaderWeb)\" class=\"builder-element article-view-header\"><media class=\"img-100\" \nattachment=\"vm.elementHeaderWeb.media\"></media><div ng-if=\"vm.elementHeaderWeb.active_layout\" \nstyle=\"padding:{{vm.elementHeaderWeb.options.padding | arrToPadding}}\" \nlayout-align=\"{{vm.elementHeaderWeb.active_layout}}\" class=\"title-container\"><h1 \nstyle=\"color: {{ vm.elementHeaderWeb.options.color }}; text-align: {{ vm.elementHeaderWeb.options.title_align}}\" \nui-tinymce=\"vm.tinymceWebOptions\" ng-model=\"vm.elementHeaderWeb.title\"></h1></div></div></div><div \nclass=\"web-container email-container article-view-body\" ng-if=\"!vm.viewPreview && !vm.isLoading && vm.webEdit\" \nng-class=\"{empty: !vm.currentWeb.length}\" data-empty-template=\"{{\'drag_and_drop_elements_here\' | translate}}\" \ndragula=\"\'element-html\'\"><div class=\"builder-element\" ng-repeat=\"element in vm.currentWeb track by $index\" \nposition=\"{{$index}}\"><ng-include ng-click=\"vm.editElement(\'\', element, $index)\" \nsrc=\"vm.getTemplate(element.type, element)\"></ng-include><div class=\"icons-actions\"><i \nng-if=\"vm.currentWeb.length > 1\" title=\"{{\'move_element\' | translate}}\" class=\"actions move material-icons\">drag_handle\n</i><i class=\"actions delete material-icons\" title=\"{{\'delete_element\' | translate}}\" \nng-click=\"vm.deleteWebSection($index)\">delete</i></div></div></div></div></div><div \nclass=\"md-card template-builder-settings\" ng-class=\"{empty: vm.preview }\"><div class=\"md-card-content\" \nng-hide=\"vm.viewPreview == \'desktop\' || vm.viewPreview == \'mobile\'\"><form action=\"#\" onsubmit=\"return false\"><div \nng-repeat=\"(key, option) in vm.currentElement.options\" ng-if=\"vm.currentElement.type != \'emailSettings\'\" \nclass=\"email-builder-element-edit-field\"><div \nng-if=\"key.search(\'mediaCaption\') > -1 || key.search(\'downloadOptions\') > -1\" class=\"block-properties\" \nng-class=\"{\'active\':toggleCap}\"><h3 class=\"mb-0\" layout=\"row\" layout-align=\"space-between center\" \nng-click=\"toggleCap = !toggleCap\" ng-class=\"{\'md-accent-fg\':toggleCap}\">{{key | translate}}<md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"m-0 s24\" ng-class=\"{\'icon-chevron-up\':toggleCap}\"></md-icon></h3><div \nclass=\"mt-20\" ng-if=\"toggleCap\"><div class=\"form-row text-inputs media-caption\"><div><label class=\"md-label\">\n{{ \'image_prefix\' | translate }}</label><input id=\"{{key}}_prefix\" type=\"text\" autofocus class=\"md-input\" \nng-model=\"vm.currentElement.options.mediaCaption.prefix\"></div></div><br><div class=\"form-row text-inputs\"><select \nclass=\"md-input\" id=\"{{key}}\" ng-model=\"vm.currentElement.options[key][\'type\']\"><option \nng-repeat=\"option in vm.currentElement.options[key][\'typeOptions\']\" ng-value=\"option\">{{option | translate}}</option>\n</select></div><div \nng-if=\"vm.currentElement.options[key][\'type\'] !== \'none\' && (vm.currentElement.options[key][\'type\'] === \'custom\' || vm.currentElement.options[key][\'type\'] === \'link\')\" \nclass=\"form-row text-inputs media-caption\"><div ng-repeat=\"(key2, optionx) in vm.currentElement.options\" \nng-if=\"key2.substring(0, 11) == \'imageSingle\'\"><label class=\"md-label\">\n{{ \'image_caption\' | translate }} {{key2.substring(11)}}</label><input id=\"{{key}}_custom\" required type=\"text\" \nautofocus class=\"md-input\" ng-model=\"vm.currentElement.options[key][\'custom_\' + key2.substring(11)]\"></div></div><br>\n<div class=\"form-row text-inputs media-caption\"><div><label class=\"md-label\">{{ \'image_suffix\' | translate }}</label>\n<input id=\"{{key}}_suffix\" type=\"text\" autofocus class=\"md-input\" \nng-model=\"vm.currentElement.options.mediaCaption.suffix\"></div></div></div></div><div \nng-if=\"key.search(\'mediaCropformats\') > -1\" class=\"block-properties\" ng-class=\"{\'active\':toggleCrop}\"><h3 class=\"mb-0\" \nlayout=\"row\" layout-align=\"space-between center\" ng-click=\"toggleCrop = !toggleCrop\" \nng-class=\"{\'md-accent-fg\':toggleCrop}\">{{key | translate}}<md-icon md-font-icon=\"icon-chevron-down\" class=\"m-0 s24\" \nng-class=\"{\'icon-chevron-up\':toggleCrop}\"></md-icon></h3><div class=\"mt-20 form-row text-inputs\" ng-if=\"toggleCrop\">\n<cropformat-select2 class=\"upload-image-container\" model=\"vm.currentElement.options[key]\" \nelement=\"vm.currentElement.options\" on-update=\"vm.updateEmailTemplate()\"></cropformat-select2></div></div><div \nng-if=\"key.substring(0, 11) == \'imageSingle\'\" class=\"block-properties\"><div class=\"form-row text-inputs\">\n<input-file-upload-single class=\"upload-image-container\" model=\"vm.currentElement.options[key]\" \nelement=\"vm.currentElement.options\" key=\"key\" on-update=\"vm.updateEmailTemplate()\"></input-file-upload-single></div>\n<div class=\"form-row text-inputs link-to\" ng-if=\"vm.currentElement.options.linkTo.type == \'individual-link\'\"><i \nclass=\"material-icons\">insert_link</i> <input id=\"{{key + \'customLink\'}}\" type=\"url\" class=\"md-input\" \nng-model=\"vm.currentElement.options[key].customLink\"></div></div><div ng-if=\"key.substring(0, 11) == \'mediaSingle\'\" \nclass=\"block-properties\"><div class=\"form-row text-inputs\"><input-file-upload-single class=\"upload-image-container\" \nmodel=\"vm.currentElement.options[key]\" element=\"vm.currentElement.options\" key=\"key\" \non-update=\"vm.updateEmailTemplate()\"></input-file-upload-single></div><div class=\"form-row text-inputs\">\n<cropformat-select class=\"upload-image-container\" model=\"vm.currentElement.options[key]\" \nelement=\"vm.currentElement.options\" on-update=\"vm.updateEmailTemplate()\"></cropformat-select></div></div><div \nclass=\"block-properties\" ng-if=\"key.substring(0, 5) == \'width\'\" ng-class=\"{\'active\':toggleWidth}\"><h3 class=\"mb-0\" \nlayout=\"row\" layout-align=\"space-between center\" ng-click=\"toggleWidth = !toggleWidth\" \nng-class=\"{\'md-accent-fg\':toggleWidth}\">{{ \'builder_el_o_width\' | translate }} {{ \'builder_el_image\' | translate }}\n<md-icon md-font-icon=\"icon-chevron-down\" class=\"m-0 s24\" ng-class=\"{\'icon-chevron-up\':toggleWidth}\"></md-icon></h3>\n<div class=\"form-row text-inputs mt-20\" ng-if=\"toggleWidth\"><input id=\"builder_el_o_width\" type=\"text\" \nclass=\"md-input\" ng-model=\"vm.currentElement.options[key]\"></div></div><div class=\"block-properties\" \nng-if=\"[\'title\', \'subTitle\', \'textUnsubscribe\', \'textManage\', \'textPreview\', \'clickHere\'].indexOf(key) > -1 || key.search(\'altTag\') > -1 || key == \'buttonText\'\">\n<div class=\"form-row text-inputs\"><label for=\"{{key}}\" class=\"md-label\">{{ key | translate }}</label><input \nid=\"{{key}}\" type=\"text\" class=\"md-input\" ng-model=\"vm.currentElement.options[key]\"></div></div><div \nclass=\"block-properties\" ng-if=\"[\'code\'].indexOf(key) > -1\"><div class=\"form-row text-inputs\"><label for=\"{{key}}\" \nclass=\"md-label\">{{ key | translate }}</label><textarea id=\"{{key}}\" type=\"text\" class=\"md-input\" \nng-model=\"vm.currentElement.options[key]\"></textarea></div></div><div class=\"block-properties\" ng-if=\"key == \'links\'\" \nng-class=\"{\'active\':toggleSocial}\"><h3 class=\"mb-0\" layout=\"row\" layout-align=\"space-between center\" \nng-click=\"toggleSocial = !toggleSocial\" ng-class=\"{\'md-accent-fg\':toggleSocial}\">{{\'social_links\' | translate}}<md-icon\n md-font-icon=\"icon-chevron-down\" class=\"m-0 s24\" ng-class=\"{\'icon-chevron-up\':toggleSocial}\"></md-icon></h3><div \nclass=\"mt-20\" ng-if=\"toggleSocial\"><div class=\"form-row color-inputs mb-20\"><select class=\"md-input\" id=\"network\" \nng-change=\"vm.addSocialNetwork(vm.currentElement.options.links, vm.selectedNetwork)\" ng-model=\"vm.selectedNetwork\">\n<option value=\"\" disabled=\"disabled\">Select network from list</option><option \nng-repeat=\"(key, link) in vm.currentElement.options.links\" ng-if=\"!link.active\" ng-value=\"key\">{{key | translate}}\n</option></select></div><hr><div class=\"form-row range-inputs mv-20\"><label for=\"border-size\">{{\'size\' | translate}}\n</label><input type=\"range\" min=\"24\" max=\"64\" id=\"icons-width\" ng-model=\"vm.currentElement.options.size\"> <span>\n{{vm.currentElement.options.size}}px</span></div><hr><div class=\"form-row text-inputs mv-20\" \nng-repeat=\"(key, link) in vm.currentElement.options.links\" ng-if=\"link.active\"><label for=\"{{key}}\">{{key | translate}}\n</label><div class=\"social-links\"><i class=\"material-icons\">insert_link</i> <input type=\"text\" id=\"{{key}}\" \nng-value=\"link.link\" ng-model=\"link.link\"></div><a href=\"#\" onclick=\"return false\" ng-click=\"link.active = false\">\nDelete</a><div ng-if=\"link.imageSingle\" class=\"block-properties\"><div class=\"form-row text-inputs\">\n<input-file-upload-single class=\"upload-image-container\" model=\"link.imageSingle\" element=\"link\" key=\"\'imageSingle\'\" \non-update=\"vm.updateEmailTemplate()\"></input-file-upload-single></div></div><hr ng-if=\"!$last\"></div></div></div><div \nclass=\"block-properties\" ng-if=\"key == \'url\'\"><div class=\"form-row text-inputs\"><label for=\"builder_el_o_url\" \ntranslate=\"builder_el_o_url\"></label><input id=\"builder_el_o_url\" type=\"url\" class=\"md-input\" \nng-model=\"vm.currentElement.options[key]\"></div></div><div class=\"block-properties\" ng-if=\"key == \'title_position\'\" \nng-class=\"{\'active\': toggleTitlePosition}\"><h3 class=\"mb-0\" layout=\"row\" layout-align=\"space-between center\" \nng-click=\"toggleTitlePosition = !toggleTitlePosition\" ng-class=\"{\'md-accent-fg\':toggleTitlePosition}\">Title position\n<md-icon md-font-icon=\"icon-chevron-down\" class=\"m-0 s24\" ng-class=\"{\'icon-chevron-up\':toggleTitlePosition}\"></md-icon>\n</h3><div class=\"mt-20\" ng-if=\"toggleTitlePosition\"><div class=\"md-btn-group title-position-container\"><button \nng-repeat=\"option in vm.currentThread_edit.id_cat_options\" type=\"button\" class=\"md-btn-custom md-btn-sm md-btn\" \nng-class=\"{\'active\': option.layout_align ==  vm.elementHeaderWeb.active_layout}\" \nng-click=\"vm.changeTitlePosition(option)\" data=\"{{option.cat}}\">{{option.cat}}</button></div></div></div><div \nclass=\"block-properties\" ng-if=\"key == \'title_align\'\" ng-class=\"{\'active\':toggleTitleAlign}\"><h3 class=\"mb-0\" \nlayout=\"row\" layout-align=\"space-between center\" ng-click=\"toggleTitleAlign = !toggleTitleAlign\" \nng-class=\"{\'md-accent-fg\':toggleTitleAlign}\">Title alignment<md-icon md-font-icon=\"icon-chevron-down\" class=\"m-0 s24\" \nng-class=\"{\'icon-chevron-up\':toggleTitleAlign}\"></md-icon></h3><div class=\"form-row mt-20\" ng-if=\"toggleTitleAlign\">\n<div class=\"md-btn-group md-btn-group-justify\"><button type=\"button\" class=\"md-btn-custom md-btn-sm md-btn\" \nng-class=\"{\'active\': option == \'left\'}\" ng-click=\"vm.currentElement.options[key] = \'left\'\" translate=\"left\"></button> \n<button type=\"button\" class=\"md-btn-custom md-btn-sm md-btn\" ng-class=\"{\'active\': option == \'center\'}\" \nng-click=\"vm.currentElement.options[key] = \'center\'\" translate=\"center\"></button> <button type=\"button\" \nclass=\"md-btn-custom md-btn-sm md-btn\" ng-class=\"{\'active\': option == \'right\'}\" \nng-click=\"vm.currentElement.options[key] = \'right\'\" translate=\"right\"></button></div></div></div><div \nclass=\"block-properties\" ng-if=\"key == \'align\'\" ng-class=\"{\'active\':toggleAlign}\"><h3 class=\"mb-0\" layout=\"row\" \nlayout-align=\"space-between center\" ng-click=\"toggleAlign = !toggleAlign\" ng-class=\"{\'md-accent-fg\':toggleAlign}\">\nText alignment<md-icon md-font-icon=\"icon-chevron-down\" class=\"m-0 s24\" ng-class=\"{\'icon-chevron-up\':toggleAlign}\">\n</md-icon></h3><div class=\"form-row mt-20\" ng-if=\"toggleAlign\"><div class=\"md-btn-group md-btn-group-justify\"><button \ntype=\"button\" class=\"md-btn-custom md-btn-sm md-btn\" ng-class=\"{\'active\': option == \'left\'}\" \nng-click=\"vm.currentElement.options[key] = \'left\'\" translate=\"left\"></button> <button type=\"button\" \nclass=\"md-btn-custom md-btn-sm md-btn\" ng-class=\"{\'active\': option == \'center\'}\" \nng-click=\"vm.currentElement.options[key] = \'center\'\" translate=\"center\"></button> <button type=\"button\" \nclass=\"md-btn-custom md-btn-sm md-btn\" ng-class=\"{\'active\': option == \'right\'}\" \nng-click=\"vm.currentElement.options[key] = \'right\'\" translate=\"right\"></button></div></div></div><div \nng-if=\"key.search(\'padding\') > -1 || key == \'margin\'\" class=\"block-properties\" ng-class=\"{\'active\':togglePadding}\"><h3 \nclass=\"mb-0\" layout=\"row\" layout-align=\"space-between center\" ng-click=\"togglePadding = !togglePadding\" \nng-class=\"{\'md-accent-fg\':togglePadding}\">{{key | translate}}<md-icon md-font-icon=\"icon-chevron-down\" class=\"m-0 s24\" \nng-class=\"{\'icon-chevron-up\':togglePadding}\"></md-icon></h3><div class=\"mt-20\" ng-if=\"togglePadding\"><div \nclass=\"form-row padding-inputs mv-20\"><div class=\"mr-5\"><label for=\"builder_el_o_top\" translate=\"builder_el_o_top\">\n</label><input id=\"builder_el_o_top\" type=\"text\" class=\"md-input\" ng-model=\"vm.currentElement.options[key][0]\"></div>\n<div class=\"mr-5\"><label for=\"builder_el_o_right\" translate=\"builder_el_o_right\"></label><input \nid=\"builder_el_o_right\" type=\"text\" class=\"md-input\" ng-model=\"vm.currentElement.options[key][1]\"></div></div><div \nclass=\"form-row padding-inputs mv-20\"><div class=\"mr-5\"><label for=\"builder_el_o_bottom\" \ntranslate=\"builder_el_o_bottom\"></label><input id=\"builder_el_o_bottom\" type=\"text\" class=\"md-input\" \nng-model=\"vm.currentElement.options[key][2]\"></div><div class=\"mr-5\"><label for=\"builder_el_o_left\" \ntranslate=\"builder_el_o_left\"></label><input id=\"builder_el_o_left\" type=\"text\" class=\"md-input\" \nng-model=\"vm.currentElement.options[key][3]\"></div></div></div></div><div class=\"block-properties\" \nng-if=\"key.search(\'backgroundColor\') > -1 || key == \'color\' || key == \'buttonBackgroundColor\'\" \nng-class=\"{\'active\':toggleColor}\"><div class=\"form-row text-inputs\"><div layout=\"row\" \nlayout-align=\"space-between center\" ng-click=\"toggleColor = !toggleColor\"><h3 class=\"mb-0\" for=\"{{key}}\" \nng-if=\"key.search(\'backgroundColor\') > -1\" ng-class=\"{\'md-accent-fg\':toggleColor}\">{{ key | translateCamelCase }}</h3>\n<h3 class=\"mb-0\" for=\"{{key}}\" ng-if=\"key == \'color\'\" ng-class=\"{\'md-accent-fg\':toggleColor}\">\n{{ \'builder_el_o_text_color\' | translateCamelCase }}</h3><h3 class=\"mb-0\" for=\"{{key}}\" ng-if=\"key == \'title_color\'\" \nng-class=\"{\'md-accent-fg\':toggleColor}\">Title color</h3><h3 class=\"mb-0\" for=\"{{key}}\" \nng-if=\"key == \'buttonBackgroundColor\'\" ng-class=\"{\'md-accent-fg\':toggleColor}\">\n{{ \'builder_el_o_button_bg_color\' | translateCamelCase }}</h3><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"m-0 s24\" ng-class=\"{\'icon-chevron-up\':toggleColor}\"></md-icon></div><div class=\"color-inputs mt-20\" \nng-if=\"toggleColor\"><span>HEX #</span><color-input class=\"color-input-container\" \nmodel=\"vm.currentElement.options[key]\"></color-input></div></div></div><div class=\"block-properties\" \nng-if=\"key == \'title_color\'\" ng-class=\"{\'active\':toggleTitleColor}\"><div class=\"form-row text-inputs\"><h3 class=\"mb-0\" \nlayout=\"row\" layout-align=\"space-between center\" ng-click=\"toggleTitleColor = !toggleTitleColor\" \nng-class=\"{\'md-accent-fg\':toggleTitleColor}\">Title color<md-icon md-font-icon=\"icon-chevron-down\" class=\"m-0 s24\" \nng-class=\"{\'icon-chevron-up\':toggleTitleColor}\"></md-icon></h3><div class=\"color-inputs mt-20\" \nng-if=\"toggleTitleColor\"><span>HEX #</span><color-input class=\"color-input-container\" \nmodel=\"vm.currentElement.options[key]\"></color-input></div></div></div><div ng-if=\"key == \'border\'\" \nclass=\"block-properties\" ng-class=\"{\'active\':toggleLine}\"><h3 class=\"mb-0\" layout=\"row\" \nlayout-align=\"space-between center\" ng-click=\"toggleLine = !toggleLine\" ng-class=\"{\'md-accent-fg\':toggleLine}\">\n{{\'border\' | translate}}<md-icon md-font-icon=\"icon-chevron-down\" class=\"m-0 s24\" \nng-class=\"{\'icon-chevron-up\':toggleLine}\"></md-icon></h3><div class=\"mt-20\" ng-if=\"toggleLine\"><div \nclass=\"form-row range-inputs mv-20\"><label for=\"border-size\">{{\'size\' | translate}}</label><input type=\"range\" min=\"0\" \nmax=\"20\" id=\"border-size\" ng-model=\"vm.currentElement.options[key][\'size\']\"> <span>\n{{vm.currentElement.options[key][\'size\']}}px</span></div><div class=\"form-row color-inputs mv-20\"><label \nfor=\"border-style\">{{\'style\' | translate}}</label><select class=\"md-input\" id=\"border-style\" \nng-model=\"vm.currentElement.options[key][\'style\']\"><option \nng-repeat=\"option in vm.currentElement.options[key][\'styleOptions\']\" ng-value=\"option\">{{option | translate}}</option>\n</select></div><div class=\"form-row text-inputs mv-20\"><label for=\"border-color\">{{\'color\' | translate}}</label><div \nclass=\"color-inputs\"><span>HEX #</span><color-input class=\"color-input-container\" \nmodel=\"vm.currentElement.options[key][\'color\']\"></color-input></div></div><div class=\"form-row range-inputs mv-20\" \nng-if=\"vm.currentElement.options[key][\'radius\'] !== \'undefined\'\"><label for=\"border-radius\">{{\'radius\' | translate}}\n</label><input type=\"range\" min=\"0\" max=\"50\" id=\"border-radius\" ng-model=\"vm.currentElement.options[key][\'radius\']\"> \n<span class=\"md-color-gray\">{{currentElement.options[key][\'radius\']}}%</span></div></div></div><div \nclass=\"block-properties\" ng-if=\"key == \'fullWidth\'\"><div class=\"form-row checkbox-inputs\"><input id=\"checkbox-1\" \ntype=\"checkbox\" ng-model=\"vm.currentElement.options[key]\"><label id=\"checkbox-1-custom\" for=\"checkbox-1\" \naria-checked=\"false\" role=\"checkbox\" tabindex=\"0\"></label><label id=\"yes\" role=\"label\" for=\"checkbox-1\">\n{{\'fullWidth\' | translate}}</label></div></div><div ng-if=\"key.search(\'linkTo\') > -1\" class=\"block-properties\" \nng-class=\"{\'active\':toggleLink}\"><h3 class=\"mb-0\" layout=\"row\" layout-align=\"space-between center\" \nng-click=\"toggleLink = !toggleLink\" ng-class=\"{\'md-accent-fg\':toggleLink}\">{{key | translate}}<md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"m-0 s24\" ng-class=\"{\'icon-chevron-up\':toggleLink}\"></md-icon></h3><div \nclass=\"mt-20\" ng-if=\"toggleLink\"><div class=\"form-row text-inputs linkto-text mv-20\"><input id=\"{{key}}_text\" required \ntype=\"text\" autofocus class=\"md-input\" ng-model=\"vm.currentElement.options[key][\'text\']\"></div><div \nclass=\"form-row text-inputs mv-20\"><select class=\"md-input\" id=\"link-to\" \nng-model=\"vm.currentElement.options[key][\'type\']\"><option \nng-repeat=\"option in vm.currentElement.options[key][\'typeOptions\']\" ng-value=\"option\">{{option | translate}}</option>\n</select></div><div \nng-if=\"vm.currentElement.options[key][\'type\'] !== \'none\' && vm.currentElement.options[key][\'type\'] === \'link\'\" \nclass=\"form-row text-inputs link-to mv-20\"><i class=\"material-icons\">insert_link</i> <input id=\"link\" required \ntype=\"url\" autofocus class=\"md-input\" ng-model=\"vm.currentElement.options[key][\'link\']\"></div><div \nng-if=\"vm.currentElement.options[key][\'type\'] !== \'none\' && vm.currentElement.options[key][\'type\'] === \'email\'\" \nclass=\"form-row text-inputs link-to mv-20\"><i class=\"material-icons\">email</i> <input id=\"link\" required type=\"email\" \nautofocus class=\"md-input\" ng-model=\"vm.currentElement.options[key][\'link\']\"></div></div></div><div \nng-if=\"key == \'font\'\" class=\"block-properties\" ng-class=\"{\'active\':toggleFont}\"><h3 class=\"mb-0\" layout=\"row\" \nlayout-align=\"space-between center\" ng-click=\"toggleFont = !toggleFont\" ng-class=\"{\'md-accent-fg\':toggleFont}\">\n{{\'font\' | translate}}<md-icon md-font-icon=\"icon-chevron-down\" class=\"m-0 s24\" \nng-class=\"{\'icon-chevron-up\':toggleFont}\"></md-icon></h3><div class=\"mt-20\" ng-if=\"toggleFont\"><div \nclass=\"form-row range-inputs mv-20\" ng-if=\"vm.currentElement.options[key][\'size\']\"><label for=\"font-size\">\n{{\'size\' | translate}}</label><input type=\"range\" min=\"10\" max=\"40\" id=\"font-size\" \nng-model=\"vm.currentElement.options[key][\'size\']\"> <span>{{currentElement.options[key][\'size\']}}px</span></div><div \nclass=\"form-row text-inputs mv-20\" ng-if=\"vm.currentElement.options[key][\'color\']\"><label for=\"font-color\">\n{{\'color\' | translate}}</label><div class=\"color-inputs\"><span>HEX #</span><color-input class=\"color-input-container\" \nmodel=\"vm.currentElement.options[key][\'color\']\"></color-input></div></div><div class=\"form-row text-inputs mv-20\" \nng-if=\"vm.currentElement.options[key][\'weight\']\" layout=\"column\"><label for=\"font-weight\">{{\'weight\' | translate}}\n</label><select class=\"md-input\" id=\"font-weight\" ng-model=\"vm.currentElement.options[key][\'weight\']\"><option \nng-repeat=\"option in vm.currentElement.options[key][\'weightOptions\']\" ng-value=\"option\">{{option | translate}}</option>\n</select></div><div class=\"form-row text-inputs mv-20\" ng-if=\"vm.currentElement.options[key][\'title_family\']\"><label \nfor=\"font-title_family\">Title family</label><select class=\"md-input\" id=\"font-title_family\" \nng-model=\"vm.currentElement.options[key][\'title_family\']\"><option ng-style=\"{fontFamily: option}\" \nng-repeat=\"option in vm.currentElement.options[key][\'familyOptions\']\" ng-value=\"option\">{{option | translate}}</option>\n</select></div><div class=\"form-row text-inputs mv-20\" ng-if=\"vm.currentElement.options[key][\'family\']\"><label \nfor=\"font-family\">{{\'family\' | translate}}</label><select class=\"md-input\" id=\"font-family\" \nng-model=\"vm.currentElement.options[key][\'family\']\"><option ng-style=\"{fontFamily: option}\" \nng-repeat=\"option in vm.currentElement.options[key][\'familyOptions\']\" ng-value=\"option\">{{option | translate}}</option>\n</select></div></div></div><div class=\"block-properties web-upload-image\" ng-if=\"key == \'media\'\"><div class=\"upload\">\n<div class=\"upload-image\"><md-button ng-click=\"vm.selectMedia($event, vm.currentElement)\" class=\"md-accent md-raised\" \ntranslate=\"GLOBAL.BROWSE_UPLOAD\" aria-label=\"Browse\"></md-button></div></div><div class=\"current-image\"><media \nattachment=\"vm.currentElement.media[0]\" class=\"img-100\"></media><span ng-if=\"vm.currentElement.media[0].id_media != 0\">\nID: #{{vm.currentElement.media[0].id_media}}</span></div></div><div class=\"block-properties\" \nng-if=\"key == \'exportable\' && vm.mailingToContent.length > 0\"><div class=\"form-row checkbox-inputs\"><input \nid=\"checkbox-2\" type=\"checkbox\" ng-model=\"vm.currentElement.options[key]\"><label id=\"checkbox-2-custom\" \nfor=\"checkbox-2\" aria-checked=\"false\" role=\"checkbox\" tabindex=\"0\"></label><label id=\"yes\" role=\"label\" \nfor=\"checkbox-2\">{{\'exportable\' | translate}}</label></div></div><div \nng-if=\"key == \'exportMedia\' && vm.zonesInSections.length > 0\" class=\"block-properties\" \nng-class=\"{\'active\':toggleCrop}\"><h3 class=\"mb-0\" layout=\"row\" layout-align=\"space-between center\" \nng-click=\"toggleCrop = !toggleCrop\" ng-class=\"{\'md-accent-fg\':toggleCrop}\">Web media zones<md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"m-0 s24\" ng-class=\"{\'icon-chevron-up\':toggleCrop}\"></md-icon></h3><div \nclass=\"mt-20 form-row text-inputs\" ng-if=\"toggleCrop\"><div ng-repeat=\"option in vm.zonesInSections\"><label>\n{{option.section}}</label><div ng-repeat=\"zone in option.zones\" class=\"form-row checkbox-inputs\"><input \nid=\"checkbox-{{zone.title}}\" type=\"checkbox\" \nng-model=\"vm.currentElement.options[key][option.section][zone.title].onoff\"><label id=\"checkbox-{{zone.title}}-custom\" \nfor=\"checkbox-{{zone.title}}\" aria-checked=\"false\" role=\"checkbox\" tabindex=\"0\"></label><label id=\"yes\" role=\"label\" \nfor=\"checkbox-{{zone.title}}\">{{zone.title}}</label></div></div></div></div></div><div \nng-if=\"(vm.currentElement.type == \'emailSettings\' && !vm.webEdit) || !vm.currentElement\" \nclass=\"email-builder-element-edit-field\"><h3 class=\"block-properties\">General settings</h3><div \nclass=\"block-properties\"><div class=\"form-row padding-inputs\"><div class=\"mr-5\"><label for=\"emailSettingsPaddingTop\" \ntranslate=\"builder_el_o_top\"></label><input id=\"emailSettingsPaddingTop\" class=\"md-input\" type=\"text\" \nng-model=\"vm.currentElement.options.paddingTop\"></div><div><label for=\"emailSettingsPaddingRight\" \ntranslate=\"builder_el_o_right\"></label><input id=\"emailSettingsPaddingRight\" class=\"md-input\" type=\"text\" \nng-model=\"vm.currentElement.options.paddingRight\"></div></div><div class=\"form-row padding-inputs\"><div class=\"mr-5\">\n<label for=\"emailSettingsPaddingBottom\" translate=\"builder_el_o_bottom\"></label><input id=\"emailSettingsPaddingBottom\" \ntype=\"text\" class=\"md-input\" ng-model=\"vm.currentElement.options.paddingBottom\"></div><div><label \nfor=\"emailSettingsPaddingLeft\" translate=\"builder_el_o_left\"></label><input id=\"emailSettingsPaddingLeft\" type=\"text\" \nclass=\"md-input\" ng-model=\"vm.currentElement.options.paddingLeft\"></div></div></div><div class=\"block-properties\"><div \nclass=\"form-row text-inputs\"><label for=\"emailSettingsBackground\">{{ \'background_color\' | translate }}</label><div \nclass=\"color-inputs\"><span>HEX #</span><color-input class=\"color-input-container\" \nmodel=\"vm.currentElement.options.backgroundColor\"></color-input></div></div></div></div></form></div></div></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button ng-if=\"!vm.webEdit\" ng-click=\"vm.downloadHtml()\" \nclass=\"send-button md-accent md-raised\">DOWNLOAD HTML</md-button><md-button ng-if=\"!vm.webEdit\" \nng-click=\"vm.exportEmailAsJson()\" class=\"send-button md-accent md-raised\">EXPORT</md-button></div><div layout=\"row\" \nlayout-align=\"end center\"><md-button ng-click=\"vm.saveTemplate()\" \nclass=\"cancel-button md-accent green-500-bg md-raised\" aria-label=\"Save\"><span translate=\"MAILING.APPLY\" \nng-if=\"!vm.isSaving\">APPLY</span><div flex layout=\"column\" layout-align=\"center center\" ng-if=\"vm.isSaving\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"25\"></md-progress-circular></div></md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/dialogs/select-content/select-content-dialog.controller.html","<md-dialog ng-style=\"{\'width\' : vm.usersGroups ? \'40vh\' : \'\'}\" class=\"select-content\" aria-label=\"New Task\"><form \nname=\"taskForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between\"><h1 class=\"title\">{{vm.dialogName || \'CONTENT.PEOPLE\' | translate}}</h1>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content ng-if=\"vm.usersGroups\" ms-scroll>\n<div id=\"list-group-users\" ivh-treeview=\"vm.usersGroups\" ivh-treeview-filter=\"\" ivh-treeview-label-attribute=\"\'label\'\" \nclass=\"ivh-treeview-folder small\" ivh-treeview-on-cb-change=\"callback()\"><script type=\"text/ng-template\">\n<div class=\"level-card p-8 group-row\" layout=\"row\" layout-align=\"space-between stretch\" ng-class=\"{\'selected\': node.is_qiu_restricted_root}\">\r\n                        <span ivh-treeview-twistie ivh-treeview-toggle layout=\"row\" layout-align=\"center center\"></span>\r\n                        <div flex id=\"treeview-group-{{node.id_group}}\" data-group-node={{node}} layout=\"row\" layout-align=\"start center\">\r\n                            <div ng-if=\"node.group_type.icon\">\r\n                                <md-icon ng-if=\"node.group_type.icon\"\r\n                                    class=\"s24 mr-10 mt-0 ml-0 mb-0\"\r\n                                    md-font-icon=\"{{node.group_type.icon}}\"\r\n                                    aria-hidden=\"true\" >\r\n                                </md-icon>\r\n                            </div>\r\n                            <div ng-if=\"!node.group_type.icon\">\r\n                                <md-icon ng-if=\"!node.children && node.id_group_type == 1\"\r\n                                    md-font-icon=\"icon-folder\"\r\n                                    class=\"s24 mr-10 mt-0 ml-0 mb-0\"\r\n                                    aria-hidden=\"true\" >\r\n                                </md-icon>\r\n                                <md-icon\r\n                                    ng-if=\"node.children && node.id_group_type == 1\"\r\n                                    md-font-icon=\"icon-folder-multiple\"\r\n                                    class=\"s24 mr-10 mt-0 ml-0 mb-0\"\r\n                                    aria-hidden=\"true\" >\r\n                                </md-icon>\r\n                                <md-icon ng-if=\"!node.children && node.id_group_type == 2\"\r\n                                    md-font-icon=\"qiu-icon-file-usermailing\"\r\n                                    class=\"s24 mr-10 mt-0 ml-0 mb-0\"\r\n                                    aria-hidden=\"true\" >\r\n                                </md-icon>\r\n                                <md-icon\r\n                                    ng-if=\"node.children && node.id_group_type == 2\"\r\n                                    class=\"s24 mr-10 mt-0 ml-0 mb-0\"\r\n                                    md-svg-src=\"/assets/icons/svg/icon-folder-mail-multiple.svg\"\r\n                                    aria-hidden=\"true\" >\r\n                                </md-icon>\r\n                                <md-icon ng-if=\"!node.children && node.id_group_type == 3\"\r\n                                    class=\"s24 mr-10 mt-0 ml-0 mb-0\"\r\n                                    md-font-icon=\"qiu-icon-file-usermediacenter\"\r\n                                    aria-hidden=\"true\" >\r\n                                </md-icon>\r\n                                <md-icon\r\n                                    ng-if=\"node.children && node.id_group_type == 3\"\r\n                                    class=\"s24 mr-10 mt-0 ml-0 mb-0\"\r\n                                    md-svg-src=\"/assets/icons/svg/icon-folder-play-multiple.svg\"\r\n                                    aria-hidden=\"true\" >\r\n                                </md-icon>\r\n                                <md-icon ng-if=\"!node.children && node.id_group_type == 4\"\r\n                                    class=\"s24 mr-10 mt-0 ml-0 mb-0\"\r\n                                    md-font-icon=\"qiu-icon-file-usersegment\"\r\n                                    aria-hidden=\"true\" >\r\n                                </md-icon>\r\n                                <md-icon\r\n                                    ng-if=\"node.children && node.id_group_type == 4\"\r\n                                    class=\"s24 mr-10 mt-0 ml-0 mb-0\"\r\n                                    md-svg-src=\"/assets/icons/svg/icon-folder-share-multiple.svg\"\r\n                                    aria-hidden=\"true\" >\r\n                                </md-icon>\r\n                                <md-icon ng-if=\"!node.children && node.id_group_type == 5\"\r\n                                    class=\"s24 mr-10 mt-0 ml-0 mb-0\"\r\n                                    md-font-icon=\"qiu-icon-file-userstore\"\r\n                                    aria-hidden=\"true\" >\r\n                                </md-icon>\r\n                                <md-icon\r\n                                    ng-if=\"node.children && node.id_group_type == 5\"\r\n                                    class=\"s24 mr-10 mt-0 ml-0 mb-0\"\r\n                                    md-svg-src=\"/assets/icons/svg/icon-folder-shop-multiple.svg\"\r\n                                    aria-hidden=\"true\" >\r\n                                </md-icon>\r\n                                <md-icon ng-if=\"!node.children && node.id_group_type == 6\"\r\n                                    class=\"s24 mr-10 mt-0 ml-0 mb-0\"\r\n                                    md-font-icon=\"qiu-icon-file-useracreditation\"\r\n                                    aria-hidden=\"true\" >\r\n                                </md-icon>\r\n                                <md-icon\r\n                                    ng-if=\"node.children && node.id_group_type == 6\"\r\n                                    class=\"s24 mr-10 mt-0 ml-0 mb-0\"\r\n                                    md-svg-src=\"/assets/icons/svg/icon-folder-board-multiple.svg\"\r\n                                    aria-hidden=\"true\" >\r\n                                </md-icon>\r\n                                <md-icon ng-if=\"!node.children && node.id_group_type == 7\"\r\n                                    class=\"s24 mr-10 mt-0 ml-0 mb-0\"\r\n                                    md-svg-src=\"/assets/icons/svg/icon-folder-chat.svg\"\r\n                                    aria-hidden=\"true\" >\r\n                                </md-icon>\r\n                                <md-icon\r\n                                    ng-if=\"node.children && node.id_group_type == 7\"\r\n                                    class=\"s24 mr-10 mt-0 ml-0 mb-0\"\r\n                                    md-svg-src=\"/assets/icons/svg/icon-folder-chat-multiple.svg\"\r\n                                    aria-hidden=\"true\" >\r\n                                </md-icon>\r\n                                <md-icon ng-if=\"!node.children && node.id_group_type == 8\"\r\n                                    class=\"s24 mr-10 mt-0 ml-0 mb-0\"\r\n                                    md-font-icon=\"icon-folder-remove\"\r\n                                    aria-hidden=\"true\" >\r\n                                </md-icon>\r\n                                <md-icon\r\n                                    ng-if=\"node.children && node.id_group_type == 8\"\r\n                                    class=\"s24 mr-10 mt-0 ml-0 mb-0\"\r\n                                    md-font-icon=\"icon-folder-multiple\"\r\n                                    aria-hidden=\"true\" >\r\n                                </md-icon>\r\n                            </div>\r\n                          \r\n                            <span class=\"ivh-treeview-node-label ng-binding\">{{node.name}}</span>\r\n                        </div>\r\n    \r\n                        <div layout=\"row\" layout-align=\"end center\">\r\n                            <md-checkbox ng-model=\"node.add\" class=\"md-icon-button\" aria-label=\"ACTIONS\"></md-checkbox>\r\n                        </div>\r\n    \r\n                    </div>\r\n                    <div ivh-treeview-children></div>\n</script></div></md-dialog-content><md-dialog-content ng-if=\"!vm.usersGroups\" ms-scroll><div ng-switch=\"vm.tabType\">\n<div ng-switch-when=\"json|json-from-section\" ng-switch-when-separator=\"|\"><div flex layout=\"column\" \nlayout-align=\"center center\" ng-if=\"vm.loadingReadPane\" class=\"loading-container\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div layout=\"row\" class=\"search-bar pr-10\">\n<md-icon style=\"margin-top: 10px\" ng-click=\"vm.getContentSection(vm.searchQuery)\" md-font-icon=\"icon-magnify\" \nclass=\"md-icon-button md-button\"><md-tooltip hide show-gt-xs><span translate=\"TOOLBAR.SEARCH\">Search</span>\n</md-tooltip></md-icon><input id=\"ms-search-bar-input\" type=\"text\" ng-model=\"vm.searchQuery\" placeholder=\"Search\" \nmd-autofocus translate translate-attr-placeholder=\"TOOLBAR.SEARCH\" flex \nng-enter=\"vm.getContentSection(vm.searchQuery)\"></div><div class=\"list-item\" \nng-repeat=\"item in vm.dataSection track by $index\" md-no-ink ng-cloak><div layout=\"row\" layout-align=\"start center\">\n<md-checkbox ng-checked=\"vm.isSelected(item)\" ng-click=\"vm.select(item)\" class=\"no-label\"></md-checkbox><media \nng-if=\"item.Thumbnail && item.Thumbnail.length > 0\" attachment=\"item.Thumbnail[0]\" thumbnail=\"true\" class=\"avatar\" \ncrop-format=\"{{vm.cropFormat}}\"></media><img ng-if=\"item.media\" class=\"avatar\" ng-src=\"{{item.media}}\" alt=\"\"> <img \nng-if=\"!item.media && (!item.Thumbnail || item.Thumbnail.length == 0)\" class=\"avatar\" \nng-src=\"{{item | mediaPlaceholder}}\" imageonload> <span class=\"grey-500-fg\">#{{item[vm.idKey]}}</span> <span \nclass=\"ml-25\">{{item[vm.showName]}}</span></div></div></div><div ng-switch-when=\"json-from-raw\" layout=\"column\" \nclass=\"p-20\"><qiu-field field=\"field\" ng-model=\"vm.item\" ng-repeat=\"field in vm.ref\"></div><div id=\"email-inputs\" \nng-switch-when=\"simple-json\"><div flex layout=\"column\" layout-align=\"center center\" ng-if=\"vm.loadingReadPane\" \nclass=\"loading-container\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div>\n<md-input-container ng-if=\"!vm.loadingReadPane\" class=\"md-block mb-0 chips\"><md-chips id=\"md-chips-email\" \nng-model=\"vm.item\" readonly=\"false\" md-removable=\"true\" placeholder=\"{{vm.translate(\'MAILING.ADD_EMAILS\')}}\" \ndelete-button-label=\"{{vm.translate(\'MAILING.REMOVE_EMAILS\')}}\" \ndelete-hint=\"{{vm.translate(\'MAILING.DELETE_REMOVE_EMAILS\')}}\" \nsecondary-placeholder=\" {{vm.translate(\'MAILING.ADD_EMAILS\')}}\" md-enable-chip-edit=\"true\" md-separator-keys=\"vm.keys\" \nng-enter=\"vm.validateEmail(vm.item)\" md-transform-chip=\"vm.addChips($chip,vm.item)\" ng-required=\"true\" \nclass=\"close-chip\"><button md-chip-remove class=\"md-primary\"><md-icon md-font-icon=\"icon-close\"></md-icon></button>\n</md-chips></md-input-container><md-input-container class=\"md-block mt-0\"><p class=\"grey-500-fg\" \nstyle=\"word-break: break-word\" translate=\"MAILING.TO_EMAILS_COMMENT\"></p></md-input-container></div><div \nid=\"json-construct-container\" ng-switch-when=\"json-construct\" layout=\"column\" class=\"p-20\"><div class=\"field\" \nng-repeat=\"field in vm.rawSettings.fields\" ng-if=\"field.type != \'id\'\"><div ng-if=\"field.type === \'string\'\">\n<md-input-container><label>{{field.show_label | capitalize}}</label><input type=\"text\" ng-model=\"vm.item[field.label]\">\n</md-input-container></div><div ng-if=\"field.type === \'textarea\'\"><md-input-container><label>\n{{field.show_label | capitalize}}</label><textarea ng-model=\"vm.item[field.label]\" rows=\"5\"></textarea>\n</md-input-container></div><div ng-if=\"field.type === \'country\'\"><md-input-container><label>\n{{field.show_label | capitalize}}</label><md-select ng-model=\"vm.item[field.label]\"><md-option \nng-value=\"country.id_country\" ng-repeat=\"country in vm.countries\">{{ country.country }}({{country.code}})</md-option>\n</md-select></md-input-container></div><div ng-if=\"field.type === \'media\'\"><label>{{field.show_label | capitalize}}\n</label><div class=\"attachment\" layout=\"column\"><div><div class=\"ms-card\" flex><div class=\"ms-card-content-wrapper\">\n<div class=\"template-9\"><div ng-click=\"vm.mediaDialog($event, field)\" class=\"media\" flex layout=\"row\" \nlayout-align=\"center center\"><media attachment=\"vm.item[field.label]\" class-img=\"image\"></media></div><div \nclass=\"header\" layout=\"row\" layout-align=\"space-between center\"><span class=\"grey-500-fg\"><span \nclass=\"word-breaka-all\"></span> <span class=\"word-breaka-all\"></span></span></div></div></div></div></div></div></div>\n</div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-=\"end\"><md-input-container flex \nlayout=\"row\" layout-align=\"end center\"><md-button ng-if=\"!vm.isEditMode\" type=\"submit\" \nclass=\"send-button md-accent md-raised\" ng-click=\"vm.saveDialog()\" translate=\"FORMS.ADD\">ADD</md-button><md-button \nng-if=\"vm.isEditMode\" type=\"submit\" class=\"send-button md-accent md-raised\" ng-click=\"vm.saveDialog()\" \ntranslate=\"FORMS.SAVE\">SAVE</md-button><md-button type=\"button\" class=\"md-raised md-warn\" ng-click=\"vm.closeDialog()\" \ntranslate=\"FORMS.CANCEL\">Cancel</md-button></md-input-container></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/dialogs/users-group/tree-view.html","<md-toolbar class=\"md-default-theme grey-100-bg grey-600-fg\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\"><label for=\"search-bar-input\"><md-icon layout=\"row\" ng-if=\"!vm.treeSearch\" md-font-icon=\"icon-magnify\" \nclass=\"grey-600-fg md-icon-button md-button\"><md-tooltip hide show-gt-xs><span translate=\"TOOLBAR.SEARCH\">Search</span>\n</md-tooltip></md-icon><md-icon layout-align=\"end center\" md-font-icon=\"icon-close-circle\" \nclass=\"grey-600-fg md-icon-button md-button\" ng-if=\"vm.treeSearch\" ng-click=\"vm.treeSearch= null\"></md-icon></label>\n<input type=\"text\" id=\"search-bar-input\" class=\"grey-600-fg grey-100-bg\" ng-model=\"vm.treeSearch\" placeholder=\"Search\" \nmd-autofocus translate translate-attr-placeholder=\"TOOLBAR.SEARCH\" flex></div></md-toolbar><div \nng-init=\"vm.treeIsLoaded = true\" ng-if=\"vm.usersGroups\" ivh-treeview=\"vm.usersGroups\" \nivh-treeview-filter=\"vm.treeSearch\" class=\"treeview\" \nivh-treeview-on-cb-change=\"vm.callback(ivhNode, ivhIsSelected, ivhTree)\"><script type=\"text/ng-template\">\n<div class=\"level-card p-8 group-row\" layout=\"row\" layout-align=\"space-between stretch\">\r\n            <span ivh-treeview-twistie ivh-treeview-toggle layout=\"row\" layout-align=\"center center\" class=\"mr-8\"></span>\r\n            <div flex id=\"treeview-group-{{node.id_group}}\" qiu-on-click-load-users-by-groups data-group-node={{node}} layout=\"row\" layout-align=\"start center\">\r\n                <div ng-if=\"node.group_type.icon\">\r\n                    <md-icon ng-if=\"node.icon\"\r\n                        class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                        md-font-icon=\"{{node.icon}}\"\r\n                        aria-hidden=\"true\" >\r\n                    </md-icon>\r\n                </div>\r\n                <div ng-if=\"!node.group_type.icon\">\r\n                    <md-icon ng-if=\"!node.children && node.id_group_type == 1\"\r\n                        class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                        md-font-icon=\"icon-folder\"\r\n                        aria-hidden=\"true\" >\r\n                    </md-icon>\r\n                    <md-icon\r\n                        ng-if=\"node.children && node.id_group_type == 1\"\r\n                        class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                        md-font-icon=\"icon-folder-multiple\"\r\n                        aria-hidden=\"true\" >\r\n                    </md-icon>\r\n                    <md-icon ng-if=\"!node.children && node.id_group_type == 2\"\r\n                        class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                        md-font-icon=\"qiu-icon-file-usermailing\"\r\n                        aria-hidden=\"true\" >\r\n                    </md-icon>\r\n                    <md-icon\r\n                        ng-if=\"node.children && node.id_group_type == 2\"\r\n                        class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                        md-svg-src=\"/assets/icons/svg/icon-folder-mail-multiple.svg\"\r\n                        aria-hidden=\"true\" >\r\n                    </md-icon>\r\n                    <md-icon ng-if=\"!node.children && node.id_group_type == 3\"\r\n                        class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                        md-font-icon=\"qiu-icon-file-usermediacenter\"\r\n                        aria-hidden=\"true\" >\r\n                    </md-icon>\r\n                    <md-icon\r\n                        ng-if=\"node.children && node.id_group_type == 3\"\r\n                        class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                        md-svg-src=\"/assets/icons/svg/icon-folder-play-multiple.svg\"\r\n                        aria-hidden=\"true\" >\r\n                    </md-icon>\r\n                    <md-icon ng-if=\"!node.children && node.id_group_type == 4\"\r\n                        class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                        md-font-icon=\"qiu-icon-file-usersegment\"\r\n                        aria-hidden=\"true\" >\r\n                    </md-icon>\r\n                    <md-icon\r\n                        ng-if=\"node.children && node.id_group_type == 4\"\r\n                        class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                        md-svg-src=\"/assets/icons/svg/icon-folder-share-multiple.svg\"\r\n                        aria-hidden=\"true\" >\r\n                    </md-icon>\r\n                    <md-icon ng-if=\"!node.children && node.id_group_type == 5\"\r\n                        class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                        md-font-icon=\"qiu-icon-file-userstore\"\r\n                        aria-hidden=\"true\" >\r\n                    </md-icon>\r\n                    <md-icon\r\n                        ng-if=\"node.children && node.id_group_type == 5\"\r\n                        class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                        md-svg-src=\"/assets/icons/svg/icon-folder-shop-multiple.svg\"\r\n                        aria-hidden=\"true\" >\r\n                    </md-icon>\r\n                    <md-icon ng-if=\"!node.children && node.id_group_type == 6\"\r\n                        class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                        md-font-icon=\"qiu-icon-file-useracreditation\"\r\n                        aria-hidden=\"true\" >\r\n                    </md-icon>\r\n                    <md-icon\r\n                        ng-if=\"node.children && node.id_group_type == 6\"\r\n                        class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                        md-svg-src=\"/assets/icons/svg/icon-folder-board-multiple.svg\"\r\n                        aria-hidden=\"true\" >\r\n                    </md-icon>\r\n                    <md-icon ng-if=\"!node.children && node.id_group_type == 7\"\r\n                        class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                        md-svg-src=\"/assets/icons/svg/icon-folder-chat.svg\"\r\n                        aria-hidden=\"true\" >\r\n                    </md-icon>\r\n                    <md-icon\r\n                        ng-if=\"node.children && node.id_group_type == 7\"\r\n                        class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                        md-svg-src=\"/assets/icons/svg/icon-folder-chat-multiple.svg\"\r\n                        aria-hidden=\"true\" >\r\n                    </md-icon>\r\n                    <md-icon ng-if=\"!node.children && node.id_group_type == 8\"\r\n                        class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                        md-font-icon=\"icon-folder-remove\"\r\n                        aria-hidden=\"true\" >\r\n                    </md-icon>\r\n                    <md-icon\r\n                        ng-if=\"node.children && node.id_group_type == 8\"\r\n                        class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                        md-font-icon=\"icon-folder-multiple\"\r\n                        aria-hidden=\"true\" >\r\n                    </md-icon>\r\n                </div>\r\n\r\n                <span class=\"ivh-treeview-node-label\" ivh-treeview-toggle>{{node.name}}</span>\r\n            </div>\r\n            <div layout=\"row\" layout-align=\"end center\" class=\"ml-10\">\r\n                <md-select ng-if=\"node.ingroup_status && node.ingroup_status.length > 0\"\r\n                    qiu-dialogs-on-change-set-in-group-status\r\n                    ng-model=\"idIngroupStatus\"\r\n                    placeholder=\"Select a status\"\r\n                    class=\"mr-10 mv-0\"\r\n                    hide show-gt-xs>\r\n                    <md-option  ng-if=\"node.id_group_type < 200\"\r\n                        ng-value=\"status.id_ingroup_status\"\r\n                        ng-selected=\"status.id_ingroup_status == node.id_ingroup_status\"\r\n                        ng-repeat=\"status in node.ingroup_status\"\r\n                        translate=\"USERS.INGROUP.STATUS.{{status.name | uppercase}}\" />\r\n                    <md-option   ng-if=\"node.id_group_type >= 200\"\r\n                        ng-value=\"status.id_ingroup_status\"\r\n                        ng-selected=\"status.id_ingroup_status == node.id_ingroup_status\"\r\n                        ng-repeat=\"status in node.ingroup_status\"\r\n                       >{{status.name}}</md-option>\r\n                </md-select>\r\n                <!-- <md-select\r\n                    qiu-dialogs-on-change-set-in-group-status\r\n                    ng-model=\"idIngroupStatus\"\r\n                    placeholder=\"Status\"\r\n                    class=\"mr-10 mv-0\"\r\n                    hide-gt-xs>\r\n                    <md-option\r\n                        ng-value=\"status.id_ingroup_status\"\r\n                        ng-selected=\"status.id_ingroup_status == node.id_ingroup_status\"\r\n                        ng-repeat=\"status in node.ingroup_status\"\r\n                        translate=\"USERS.INGROUP.STATUS.{{status.name | uppercase}}\" />\r\n                </md-select> -->\r\n                <md-checkbox\r\n                    aria-label=\"assign group\"\r\n                    ng-checked=\"node.assigned_group == true\"\r\n                    qiu-dialogs-on-check-toggle-assigned-group\r\n                    class=\"ml-5 mb-0\" />\r\n            </div>\r\n        </div>\r\n        <div ivh-treeview-children />\n</script></div>");
$templateCache.put("app/main/dialogs/users-group/users-group-view.html","<md-dialog class=\"add-users-togroup\" aria-label=\"New Message\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><h1 class=\"title\" \ntranslate=\"USERS.ADD_REMOVE_GROUPS\"></h1><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nid=\"site-mailing\" ms-scroll flex class=\"content-card\" ng-include=\"vm.viewUsersGroup\"></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><md-input-container flex layout=\"row\" \nlayout-align=\"end center\" class=\"m-0\"><md-button type=\"button\" class=\"md-raised md-warn\" ng-click=\"vm.closeDialog()\" \ntranslate=\"GROUP.CANCEL\"></md-button><md-button ng-click=\"vm.save()\" type=\"submit\" \nclass=\"send-button md-accent md-raised\" ng-click=\"vm.save()\" translate=\"USERS.SAVE\"></md-button></md-input-container>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/plugins/web-builder/web-builder.html","<md-dialog class=\"template-builder-dialog\" aria-label=\"Design Template\" flex=\"95\"><form class=\"md-inline-form\">\n<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\"><a class=\"md-button\" type=\"1\" layout=\"row\" layout-align=\"center center\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"s18 mr-5 ml-0\"></md-icon><span translate=\"MAILING.TEMPLATE_DESIGN\"></span></a></div>\n<div layout=\"row\"><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate \ntranslate-aria-label=\"CONTENT.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></div>\n</md-toolbar><md-dialog-content flex=\"100\" class=\"content-card\"><div id=\"web-builder\" flex=\"\"><div \nclass=\"web-builder-content\" flex=\"100\"><div class=\"md-card\" ng-class=\"{preview: vm.preview}\"><div \nclass=\"md-card-content elements-list\"><ul dragula=\"\'element\'\"><li ng-repeat=\"element in vm.templates\" \ndata-type=\"{{element.name}}\"><div class=\"element-container\"><span ng-bind=\"element.name | translate\"></span></div></li>\n</ul><button class=\"md-button md-btn md-raised md-accent\" ng-disabled=\"vm.currentElement.type == \'webSettings\'\" \nng-click=\"vm.editElement(\'webSettings\')\"><md-icon md-font-icon=\"icon-cog\"></md-icon><span translate=\"web_settings\">\n</span></button> <button class=\"md-button md-btn md-raised md-warn\" ng-disabled=\"vm.web.elements.length == 0\" \nng-click=\"vm.deleteAllElements()\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span translate=\"delete_all_elements\">\n</span></button></div></div><div position-relative ng-class=\"{preview: vm.preview, configured: !vm.preview}\"><div \nclass=\"builder\" ms-scroll><div id=\"device-selector\" layout=\"row\" layout-align=\"center center\" \nclass=\"pt-30 pb-30 h-100\"><md-button aria-label=\"DESKTOP VIEW\" ng-click=\"vm.toggleView(\'\')\" class=\"md-icon-button\" \ntype=\"button\"><md-icon md-font-icon=\"icon-pencil\" class=\"s24\" ng-class=\"{\'opacity-5\': vm.viewPreview}\"></md-icon>\n<md-tooltip hide show-gt-xs><span translate=\"MAILING.EDIT\"></span></md-tooltip></md-button><div \nclass=\"divider-vertical\"></div><md-button aria-label=\"DESKTOP VIEW\" ng-click=\"vm.toggleView(\'desktop\')\" \nclass=\"md-icon-button\" type=\"button\"><md-icon md-font-icon=\"icon-desktop-mac\" class=\"s24\" \nng-class=\"{\'opacity-5\': (vm.viewPreview != \'desktop\')}\"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate=\"MAILING.DESKTOP_VIEW\"></span></md-tooltip></md-button><div class=\"divider-vertical\"></div><md-button \naria-label=\"MOBILE VIEW\" ng-click=\"vm.toggleView(\'mobile\')\" class=\"md-icon-button\" type=\"button\"><md-icon \nmd-font-icon=\"icon-cellphone\" ng-class=\"{\'opacity-5\': (vm.viewPreview != \'mobile\')}\" class=\"s24\"></md-icon><md-tooltip \nhide show-gt-xs><span translate=\"MAILING.MOBILE_VIEW\"></span></md-tooltip></md-button></div><div class=\"web-loading\" \nng-if=\"vm.isLoading\"><div flex layout=\"column\" layout-align=\"center center\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div></div><desktop-preview \nhtml=\"vm.web.html\" class=\"desktop-preview\" width=\"600\" ng-if=\"vm.viewPreview == \'desktop\' && !vm.isLoading\">\n</desktop-preview><mobile-preview web=\"vm.web\" class=\"mobile-preview\" \nng-if=\"vm.viewPreview == \'mobile\' && !vm.isLoading\"></mobile-preview><div ng-if=\"!vm.viewPreview && !vm.isLoading\" \nclass=\"full-web-container elements-container\" ng-style=\"vm.web.webSettings.options\"><div class=\"web-container\" \nng-if=\"!vm.viewPreview && !vm.isLoading\" ng-class=\"{empty: !vm.editWeb.multiple_texts.length}\" \ndata-empty-template=\"{{\'drag_and_drop_elements_here\' | translate}}\" dragula=\"\'element-html\'\"><div \nclass=\"builder-element\" ng-class=\"{selected: vm.currentElement.id === element.id}\" \nng-repeat=\"element in vm.editWeb.multiple_texts track by $index\" id=\"{{ element.id }}\" \nstyle=\"width: {{element.size}}%\"><div ng-bind-html=\"vm.getTemplate(element.template.id)\"></div><div \nclass=\"icons-actions\"><i title=\"{{\'move_element\' | translate}}\" class=\"actions move material-icons\">drag_handle</i> <i \nclass=\"actions clone material-icons\" title=\"{{\'clone_element\' | translate}}\" \nng-click=\"vm.cloneElement(element.id, \'content\')\">content_copy</i><br><i class=\"actions delete material-icons\" \ntitle=\"{{\'delete_element\' | translate}}\" ng-click=\"vm.removeElement(element.id, \'content\')\">delete</i></div></div>\n</div></div></div></div><div class=\"md-card template-builder-settings\" ng-class=\"{empty: vm.preview }\"><div \nclass=\"md-card-content\" ng-hide=\"vm.viewPreview == \'desktop\' || vm.viewPreview == \'mobile\'\"><form action=\"#\" \nonsubmit=\"return false\"><div ng-repeat=\"(key, option) in vm.currentElement.options\" \nng-if=\"vm.currentElement.type != \'webSettings\'\" class=\"web-builder-element-edit-field\"><div \nng-if=\"key.search(\'mediaCaption\') > -1 || key.search(\'downloadOptions\') > -1\" class=\"block-properties\" \nng-class=\"{\'active\':toggleCap}\"><h3 class=\"mb-0\" layout=\"row\" layout-align=\"space-between center\" \nng-click=\"toggleCap = !toggleCap\" ng-class=\"{\'md-accent-fg\':toggleCap}\">{{key | translate}}<md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"m-0 s24\" ng-class=\"{\'icon-chevron-up\':toggleCap}\"></md-icon></h3><div \nclass=\"mt-20\" ng-if=\"toggleCap\"><div class=\"form-row text-inputs media-caption\"><div><label class=\"md-label\">\n{{ \'image_prefix\' | translate }}</label><input id=\"{{key}}_prefix\" type=\"text\" autofocus class=\"md-input\" \nng-model=\"vm.currentElement.options.mediaCaption.prefix\"></div></div><br><div class=\"form-row text-inputs\"><select \nclass=\"md-input\" id=\"{{key}}\" ng-model=\"vm.currentElement.options[key][\'type\']\"><option \nng-repeat=\"option in vm.currentElement.options[key][\'typeOptions\']\" ng-value=\"option\">{{option | translate}}</option>\n</select></div><div \nng-if=\"vm.currentElement.options[key][\'type\'] !== \'none\' && (vm.currentElement.options[key][\'type\'] === \'custom\' || vm.currentElement.options[key][\'type\'] === \'link\')\" \nclass=\"form-row text-inputs media-caption\"><div ng-repeat=\"(key2, optionx) in vm.currentElement.options\" \nng-if=\"key2.substring(0, 11) == \'imageSingle\'\"><label class=\"md-label\">\n{{ \'image_caption\' | translate }} {{key2.substring(11)}}</label><input id=\"{{key}}_custom\" required type=\"text\" \nautofocus class=\"md-input\" ng-model=\"vm.currentElement.options[key][\'custom_\' + key2.substring(11)]\"></div></div><br>\n<div class=\"form-row text-inputs media-caption\"><div><label class=\"md-label\">{{ \'image_suffix\' | translate }}</label>\n<input id=\"{{key}}_suffix\" type=\"text\" autofocus class=\"md-input\" \nng-model=\"vm.currentElement.options.mediaCaption.suffix\"></div></div></div></div><div \nng-if=\"key.search(\'mediaCropformats\') > -1\" class=\"block-properties\" ng-class=\"{\'active\':toggleCrop}\"><h3 class=\"mb-0\" \nlayout=\"row\" layout-align=\"space-between center\" ng-click=\"toggleCrop = !toggleCrop\" \nng-class=\"{\'md-accent-fg\':toggleCrop}\">{{key | translate}}<md-icon md-font-icon=\"icon-chevron-down\" class=\"m-0 s24\" \nng-class=\"{\'icon-chevron-up\':toggleCrop}\"></md-icon></h3><div class=\"mt-20 form-row text-inputs\" ng-if=\"toggleCrop\">\n<cropformat-select2 class=\"upload-image-container\" model=\"vm.currentElement.options[key]\" \nelement=\"vm.currentElement.options\" on-update=\"vm.updatewebTemplate()\"></cropformat-select2></div></div><div \nng-if=\"key.substring(0, 11) == \'imageSingle\'\" class=\"block-properties\"><div class=\"form-row text-inputs\">\n<input-file-upload-single class=\"upload-image-container\" model=\"vm.currentElement.options[key]\" \nelement=\"vm.currentElement.options\" key=\"key\" on-update=\"vm.updatewebTemplate()\"></input-file-upload-single></div><div \nclass=\"form-row text-inputs link-to\" ng-if=\"vm.currentElement.options.linkTo.type == \'individual-link\'\"><i \nclass=\"material-icons\">insert_link</i> <input id=\"{{key + \'customLink\'}}\" type=\"url\" class=\"md-input\" \nng-model=\"vm.currentElement.options[key].customLink\"></div></div><div ng-if=\"key.substring(0, 11) == \'mediaSingle\'\" \nclass=\"block-properties\"><div class=\"form-row text-inputs\"><input-file-upload-single class=\"upload-image-container\" \nmodel=\"vm.currentElement.options[key]\" element=\"vm.currentElement.options\" key=\"key\" \non-update=\"vm.updatewebTemplate()\"></input-file-upload-single></div><div class=\"form-row text-inputs\">\n<cropformat-select class=\"upload-image-container\" model=\"vm.currentElement.options[key]\" \nelement=\"vm.currentElement.options\" on-update=\"vm.updatewebTemplate()\"></cropformat-select></div></div><div \nclass=\"block-properties\" ng-if=\"key.substring(0, 5) == \'width\'\" ng-class=\"{\'active\':toggleWidth}\"><h3 class=\"mb-0\" \nlayout=\"row\" layout-align=\"space-between center\" ng-click=\"toggleWidth = !toggleWidth\" \nng-class=\"{\'md-accent-fg\':toggleWidth}\">{{ \'builder_el_o_width\' | translate }} {{ \'builder_el_image\' | translate }}\n<md-icon md-font-icon=\"icon-chevron-down\" class=\"m-0 s24\" ng-class=\"{\'icon-chevron-up\':toggleWidth}\"></md-icon></h3>\n<div class=\"form-row text-inputs mt-20\" ng-if=\"toggleWidth\"><input id=\"builder_el_o_width\" type=\"text\" \nclass=\"md-input\" ng-model=\"vm.currentElement.options[key]\"></div></div><div class=\"block-properties\" \nng-if=\"[\'title\', \'subTitle\', \'textUnsubscribe\', \'textManage\', \'textPreview\', \'clickHere\'].indexOf(key) > -1 || key.search(\'altTag\') > -1 || key == \'buttonText\'\">\n<div class=\"form-row text-inputs\"><label for=\"{{key}}\" class=\"md-label\">{{ key | translate }}</label><input \nid=\"{{key}}\" type=\"text\" class=\"md-input\" ng-model=\"vm.currentElement.options[key]\"></div></div><div \nclass=\"block-properties\" ng-if=\"[\'code\'].indexOf(key) > -1\"><div class=\"form-row text-inputs\"><label for=\"{{key}}\" \nclass=\"md-label\">{{ key | translate }}</label><textarea id=\"{{key}}\" type=\"text\" class=\"md-input\" \nng-model=\"vm.currentElement.options[key]\"></textarea></div></div><div class=\"block-properties\" ng-if=\"key == \'links\'\" \nng-class=\"{\'active\':toggleSocial}\"><h3 class=\"mb-0\" layout=\"row\" layout-align=\"space-between center\" \nng-click=\"toggleSocial = !toggleSocial\" ng-class=\"{\'md-accent-fg\':toggleSocial}\">{{\'social_links\' | translate}}<md-icon\n md-font-icon=\"icon-chevron-down\" class=\"m-0 s24\" ng-class=\"{\'icon-chevron-up\':toggleSocial}\"></md-icon></h3><div \nclass=\"mt-20\" ng-if=\"toggleSocial\"><div class=\"form-row color-inputs mb-20\"><select class=\"md-input\" id=\"network\" \nng-change=\"vm.addSocialNetwork(vm.currentElement.options.links, vm.selectedNetwork)\" ng-model=\"vm.selectedNetwork\">\n<option value=\"\" disabled=\"disabled\">Select network from list</option><option \nng-repeat=\"(key, link) in vm.currentElement.options.links\" ng-if=\"!link.active\" ng-value=\"key\">{{key | translate}}\n</option></select></div><hr><div class=\"form-row range-inputs mv-20\"><label for=\"border-size\">{{\'size\' | translate}}\n</label><input type=\"range\" min=\"24\" max=\"64\" id=\"icons-width\" ng-model=\"vm.currentElement.options.size\"> <span>\n{{vm.currentElement.options.size}}px</span></div><hr><div class=\"form-row text-inputs mv-20\" \nng-repeat=\"(key, link) in vm.currentElement.options.links\" ng-if=\"link.active\"><label for=\"{{key}}\">{{key | translate}}\n</label><div class=\"social-links\"><i class=\"material-icons\">insert_link</i> <input type=\"text\" id=\"{{key}}\" \nng-value=\"link.link\" ng-model=\"link.link\"></div><a href=\"#\" onclick=\"return false\" ng-click=\"link.active = false\">\nDelete</a><div ng-if=\"link.imageSingle\" class=\"block-properties\"><div class=\"form-row text-inputs\">\n<input-file-upload-single class=\"upload-image-container\" model=\"link.imageSingle\" element=\"link\" key=\"\'imageSingle\'\" \non-update=\"vm.updatewebTemplate()\"></input-file-upload-single></div></div><hr ng-if=\"!$last\"></div></div></div><div \nclass=\"block-properties\" ng-if=\"key == \'url\'\"><div class=\"form-row text-inputs\"><label for=\"builder_el_o_url\" \ntranslate=\"builder_el_o_url\"></label><input id=\"builder_el_o_url\" type=\"url\" class=\"md-input\" \nng-model=\"vm.currentElement.options[key]\"></div></div><div class=\"block-properties\" ng-if=\"key == \'title_position\'\" \nng-class=\"{\'active\': toggleTitlePosition}\"><h3 class=\"mb-0\" layout=\"row\" layout-align=\"space-between center\" \nng-click=\"toggleTitlePosition = !toggleTitlePosition\" ng-class=\"{\'md-accent-fg\':toggleTitlePosition}\">Title position\n<md-icon md-font-icon=\"icon-chevron-down\" class=\"m-0 s24\" ng-class=\"{\'icon-chevron-up\':toggleTitlePosition}\"></md-icon>\n</h3><div class=\"mt-20\" ng-if=\"toggleTitlePosition\"><div class=\"md-btn-group title-position-container\"><button \nng-repeat=\"option in vm.currentThread_edit.id_cat_options\" type=\"button\" class=\"md-btn-custom md-btn-sm md-btn\" \nng-class=\"{\'active\': option.layout_align ==  vm.elementHeaderWeb.active_layout}\" \nng-click=\"vm.changeTitlePosition(option)\" data=\"{{option.cat}}\">{{option.cat}}</button></div></div></div><div \nclass=\"block-properties\" ng-if=\"key == \'title_align\'\" ng-class=\"{\'active\':toggleTitleAlign}\"><h3 class=\"mb-0\" \nlayout=\"row\" layout-align=\"space-between center\" ng-click=\"toggleTitleAlign = !toggleTitleAlign\" \nng-class=\"{\'md-accent-fg\':toggleTitleAlign}\">Title alignment<md-icon md-font-icon=\"icon-chevron-down\" class=\"m-0 s24\" \nng-class=\"{\'icon-chevron-up\':toggleTitleAlign}\"></md-icon></h3><div class=\"form-row mt-20\" ng-if=\"toggleTitleAlign\">\n<div class=\"md-btn-group md-btn-group-justify\"><button type=\"button\" class=\"md-btn-custom md-btn-sm md-btn\" \nng-class=\"{\'active\': option == \'left\'}\" ng-click=\"vm.currentElement.options[key] = \'left\'\" translate=\"left\"></button> \n<button type=\"button\" class=\"md-btn-custom md-btn-sm md-btn\" ng-class=\"{\'active\': option == \'center\'}\" \nng-click=\"vm.currentElement.options[key] = \'center\'\" translate=\"center\"></button> <button type=\"button\" \nclass=\"md-btn-custom md-btn-sm md-btn\" ng-class=\"{\'active\': option == \'right\'}\" \nng-click=\"vm.currentElement.options[key] = \'right\'\" translate=\"right\"></button></div></div></div><div \nclass=\"block-properties\" ng-if=\"key == \'align\'\" ng-class=\"{\'active\':toggleAlign}\"><h3 class=\"mb-0\" layout=\"row\" \nlayout-align=\"space-between center\" ng-click=\"toggleAlign = !toggleAlign\" ng-class=\"{\'md-accent-fg\':toggleAlign}\">\nText alignment<md-icon md-font-icon=\"icon-chevron-down\" class=\"m-0 s24\" ng-class=\"{\'icon-chevron-up\':toggleAlign}\">\n</md-icon></h3><div class=\"form-row mt-20\" ng-if=\"toggleAlign\"><div class=\"md-btn-group md-btn-group-justify\"><button \ntype=\"button\" class=\"md-btn-custom md-btn-sm md-btn\" ng-class=\"{\'active\': option == \'left\'}\" \nng-click=\"vm.currentElement.options[key] = \'left\'\" translate=\"left\"></button> <button type=\"button\" \nclass=\"md-btn-custom md-btn-sm md-btn\" ng-class=\"{\'active\': option == \'center\'}\" \nng-click=\"vm.currentElement.options[key] = \'center\'\" translate=\"center\"></button> <button type=\"button\" \nclass=\"md-btn-custom md-btn-sm md-btn\" ng-class=\"{\'active\': option == \'right\'}\" \nng-click=\"vm.currentElement.options[key] = \'right\'\" translate=\"right\"></button></div></div></div><div \nng-if=\"key.search(\'padding\') > -1 || key == \'margin\'\" class=\"block-properties\" ng-class=\"{\'active\':togglePadding}\"><h3 \nclass=\"mb-0\" layout=\"row\" layout-align=\"space-between center\" ng-click=\"togglePadding = !togglePadding\" \nng-class=\"{\'md-accent-fg\':togglePadding}\">{{key | translate}}<md-icon md-font-icon=\"icon-chevron-down\" class=\"m-0 s24\" \nng-class=\"{\'icon-chevron-up\':togglePadding}\"></md-icon></h3><div class=\"mt-20\" ng-if=\"togglePadding\"><div \nclass=\"form-row padding-inputs mv-20\"><div class=\"mr-5\"><label for=\"builder_el_o_top\" translate=\"builder_el_o_top\">\n</label><input id=\"builder_el_o_top\" type=\"text\" class=\"md-input\" ng-model=\"vm.currentElement.options[key][0]\"></div>\n<div class=\"mr-5\"><label for=\"builder_el_o_right\" translate=\"builder_el_o_right\"></label><input \nid=\"builder_el_o_right\" type=\"text\" class=\"md-input\" ng-model=\"vm.currentElement.options[key][1]\"></div></div><div \nclass=\"form-row padding-inputs mv-20\"><div class=\"mr-5\"><label for=\"builder_el_o_bottom\" \ntranslate=\"builder_el_o_bottom\"></label><input id=\"builder_el_o_bottom\" type=\"text\" class=\"md-input\" \nng-model=\"vm.currentElement.options[key][2]\"></div><div class=\"mr-5\"><label for=\"builder_el_o_left\" \ntranslate=\"builder_el_o_left\"></label><input id=\"builder_el_o_left\" type=\"text\" class=\"md-input\" \nng-model=\"vm.currentElement.options[key][3]\"></div></div></div></div><div class=\"block-properties\" \nng-if=\"key.search(\'backgroundColor\') > -1 || key == \'color\' || key == \'buttonBackgroundColor\'\" \nng-class=\"{\'active\':toggleColor}\"><div class=\"form-row text-inputs\"><div layout=\"row\" \nlayout-align=\"space-between center\" ng-click=\"toggleColor = !toggleColor\"><h3 class=\"mb-0\" for=\"{{key}}\" \nng-if=\"key.search(\'backgroundColor\') > -1\" ng-class=\"{\'md-accent-fg\':toggleColor}\">{{ key | translateCamelCase }}</h3>\n<h3 class=\"mb-0\" for=\"{{key}}\" ng-if=\"key == \'color\'\" ng-class=\"{\'md-accent-fg\':toggleColor}\">\n{{ \'builder_el_o_text_color\' | translateCamelCase }}</h3><h3 class=\"mb-0\" for=\"{{key}}\" ng-if=\"key == \'title_color\'\" \nng-class=\"{\'md-accent-fg\':toggleColor}\">Title color</h3><h3 class=\"mb-0\" for=\"{{key}}\" \nng-if=\"key == \'buttonBackgroundColor\'\" ng-class=\"{\'md-accent-fg\':toggleColor}\">\n{{ \'builder_el_o_button_bg_color\' | translateCamelCase }}</h3><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"m-0 s24\" ng-class=\"{\'icon-chevron-up\':toggleColor}\"></md-icon></div><div class=\"color-inputs mt-20\" \nng-if=\"toggleColor\"><span>HEX #</span><color-input class=\"color-input-container\" \nmodel=\"vm.currentElement.options[key]\"></color-input></div></div></div><div class=\"block-properties\" \nng-if=\"key == \'title_color\'\" ng-class=\"{\'active\':toggleTitleColor}\"><div class=\"form-row text-inputs\"><h3 class=\"mb-0\" \nlayout=\"row\" layout-align=\"space-between center\" ng-click=\"toggleTitleColor = !toggleTitleColor\" \nng-class=\"{\'md-accent-fg\':toggleTitleColor}\">Title color<md-icon md-font-icon=\"icon-chevron-down\" class=\"m-0 s24\" \nng-class=\"{\'icon-chevron-up\':toggleTitleColor}\"></md-icon></h3><div class=\"color-inputs mt-20\" \nng-if=\"toggleTitleColor\"><span>HEX #</span><color-input class=\"color-input-container\" \nmodel=\"vm.currentElement.options[key]\"></color-input></div></div></div><div ng-if=\"key == \'border\'\" \nclass=\"block-properties\" ng-class=\"{\'active\':toggleLine}\"><h3 class=\"mb-0\" layout=\"row\" \nlayout-align=\"space-between center\" ng-click=\"toggleLine = !toggleLine\" ng-class=\"{\'md-accent-fg\':toggleLine}\">\n{{\'border\' | translate}}<md-icon md-font-icon=\"icon-chevron-down\" class=\"m-0 s24\" \nng-class=\"{\'icon-chevron-up\':toggleLine}\"></md-icon></h3><div class=\"mt-20\" ng-if=\"toggleLine\"><div \nclass=\"form-row range-inputs mv-20\"><label for=\"border-size\">{{\'size\' | translate}}</label><input type=\"range\" min=\"0\" \nmax=\"20\" id=\"border-size\" ng-model=\"vm.currentElement.options[key][\'size\']\"> <span>\n{{vm.currentElement.options[key][\'size\']}}px</span></div><div class=\"form-row color-inputs mv-20\"><label \nfor=\"border-style\">{{\'style\' | translate}}</label><select class=\"md-input\" id=\"border-style\" \nng-model=\"vm.currentElement.options[key][\'style\']\"><option \nng-repeat=\"option in vm.currentElement.options[key][\'styleOptions\']\" ng-value=\"option\">{{option | translate}}</option>\n</select></div><div class=\"form-row text-inputs mv-20\"><label for=\"border-color\">{{\'color\' | translate}}</label><div \nclass=\"color-inputs\"><span>HEX #</span><color-input class=\"color-input-container\" \nmodel=\"vm.currentElement.options[key][\'color\']\"></color-input></div></div><div class=\"form-row range-inputs mv-20\" \nng-if=\"vm.currentElement.options[key][\'radius\'] !== \'undefined\'\"><label for=\"border-radius\">{{\'radius\' | translate}}\n</label><input type=\"range\" min=\"0\" max=\"50\" id=\"border-radius\" ng-model=\"vm.currentElement.options[key][\'radius\']\"> \n<span class=\"md-color-gray\">{{currentElement.options[key][\'radius\']}}%</span></div></div></div><div \nclass=\"block-properties\" ng-if=\"key == \'fullWidth\'\"><div class=\"form-row checkbox-inputs\"><input id=\"checkbox-1\" \ntype=\"checkbox\" ng-model=\"vm.currentElement.options[key]\"><label id=\"checkbox-1-custom\" for=\"checkbox-1\" \naria-checked=\"false\" role=\"checkbox\" tabindex=\"0\"></label><label id=\"yes\" role=\"label\" for=\"checkbox-1\">\n{{\'fullWidth\' | translate}}</label></div></div><div ng-if=\"key.search(\'linkTo\') > -1\" class=\"block-properties\" \nng-class=\"{\'active\':toggleLink}\"><h3 class=\"mb-0\" layout=\"row\" layout-align=\"space-between center\" \nng-click=\"toggleLink = !toggleLink\" ng-class=\"{\'md-accent-fg\':toggleLink}\">{{key | translate}}<md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"m-0 s24\" ng-class=\"{\'icon-chevron-up\':toggleLink}\"></md-icon></h3><div \nclass=\"mt-20\" ng-if=\"toggleLink\"><div class=\"form-row text-inputs linkto-text mv-20\"><input id=\"{{key}}_text\" required \ntype=\"text\" autofocus class=\"md-input\" ng-model=\"vm.currentElement.options[key][\'text\']\"></div><div \nclass=\"form-row text-inputs mv-20\"><select class=\"md-input\" id=\"link-to\" \nng-model=\"vm.currentElement.options[key][\'type\']\"><option \nng-repeat=\"option in vm.currentElement.options[key][\'typeOptions\']\" ng-value=\"option\">{{option | translate}}</option>\n</select></div><div \nng-if=\"vm.currentElement.options[key][\'type\'] !== \'none\' && vm.currentElement.options[key][\'type\'] === \'link\'\" \nclass=\"form-row text-inputs link-to mv-20\"><i class=\"material-icons\">insert_link</i> <input id=\"link\" required \ntype=\"url\" autofocus class=\"md-input\" ng-model=\"vm.currentElement.options[key][\'link\']\"></div><div \nng-if=\"vm.currentElement.options[key][\'type\'] !== \'none\' && vm.currentElement.options[key][\'type\'] === \'web\'\" \nclass=\"form-row text-inputs link-to mv-20\"><i class=\"material-icons\">web</i> <input id=\"link\" required type=\"web\" \nautofocus class=\"md-input\" ng-model=\"vm.currentElement.options[key][\'link\']\"></div></div></div><div \nng-if=\"key == \'font\'\" class=\"block-properties\" ng-class=\"{\'active\':toggleFont}\"><h3 class=\"mb-0\" layout=\"row\" \nlayout-align=\"space-between center\" ng-click=\"toggleFont = !toggleFont\" ng-class=\"{\'md-accent-fg\':toggleFont}\">\n{{\'font\' | translate}}<md-icon md-font-icon=\"icon-chevron-down\" class=\"m-0 s24\" \nng-class=\"{\'icon-chevron-up\':toggleFont}\"></md-icon></h3><div class=\"mt-20\" ng-if=\"toggleFont\"><div \nclass=\"form-row range-inputs mv-20\" ng-if=\"vm.currentElement.options[key][\'size\']\"><label for=\"font-size\">\n{{\'size\' | translate}}</label><input type=\"range\" min=\"10\" max=\"40\" id=\"font-size\" \nng-model=\"vm.currentElement.options[key][\'size\']\"> <span>{{currentElement.options[key][\'size\']}}px</span></div><div \nclass=\"form-row text-inputs mv-20\" ng-if=\"vm.currentElement.options[key][\'color\']\"><label for=\"font-color\">\n{{\'color\' | translate}}</label><div class=\"color-inputs\"><span>HEX #</span><color-input class=\"color-input-container\" \nmodel=\"vm.currentElement.options[key][\'color\']\"></color-input></div></div><div class=\"form-row text-inputs mv-20\" \nng-if=\"vm.currentElement.options[key][\'weight\']\" layout=\"column\"><label for=\"font-weight\">{{\'weight\' | translate}}\n</label><select class=\"md-input\" id=\"font-weight\" ng-model=\"vm.currentElement.options[key][\'weight\']\"><option \nng-repeat=\"option in vm.currentElement.options[key][\'weightOptions\']\" ng-value=\"option\">{{option | translate}}</option>\n</select></div><div class=\"form-row text-inputs mv-20\" ng-if=\"vm.currentElement.options[key][\'title_family\']\"><label \nfor=\"font-title_family\">Title family</label><select class=\"md-input\" id=\"font-title_family\" \nng-model=\"vm.currentElement.options[key][\'title_family\']\"><option ng-style=\"{fontFamily: option}\" \nng-repeat=\"option in vm.currentElement.options[key][\'familyOptions\']\" ng-value=\"option\">{{option | translate}}</option>\n</select></div><div class=\"form-row text-inputs mv-20\" ng-if=\"vm.currentElement.options[key][\'family\']\"><label \nfor=\"font-family\">{{\'family\' | translate}}</label><select class=\"md-input\" id=\"font-family\" \nng-model=\"vm.currentElement.options[key][\'family\']\"><option ng-style=\"{fontFamily: option}\" \nng-repeat=\"option in vm.currentElement.options[key][\'familyOptions\']\" ng-value=\"option\">{{option | translate}}</option>\n</select></div></div></div><div class=\"block-properties web-upload-image\" ng-if=\"key == \'media\'\"><div class=\"upload\">\n<div class=\"upload-image\"><md-button ng-click=\"vm.selectMedia($event, vm.currentElement)\" class=\"md-accent md-raised\" \ntranslate=\"GLOBAL.BROWSE_UPLOAD\" aria-label=\"Browse\"></md-button></div></div><div class=\"current-image\"><media \nattachment=\"vm.currentElement.media[0]\" class=\"img-100\"></media><span ng-if=\"vm.currentElement.media[0].id_media != 0\">\nID: #{{vm.currentElement.media[0].id_media}}</span></div></div></div><div \nng-if=\"vm.currentElement.type == \'webSettings\' || !vm.currentElement\" class=\"web-builder-element-edit-field\"><h3 \nclass=\"block-properties\">General settings</h3><div class=\"block-properties\"><div class=\"form-row padding-inputs\"><div \nclass=\"mr-5\"><label for=\"webSettingsPaddingTop\" translate=\"builder_el_o_top\"></label><input id=\"webSettingsPaddingTop\" \nclass=\"md-input\" type=\"text\" ng-model=\"vm.currentElement.options.paddingTop\"></div><div><label \nfor=\"webSettingsPaddingRight\" translate=\"builder_el_o_right\"></label><input id=\"webSettingsPaddingRight\" \nclass=\"md-input\" type=\"text\" ng-model=\"vm.currentElement.options.paddingRight\"></div></div><div \nclass=\"form-row padding-inputs\"><div class=\"mr-5\"><label for=\"webSettingsPaddingBottom\" \ntranslate=\"builder_el_o_bottom\"></label><input id=\"webSettingsPaddingBottom\" type=\"text\" class=\"md-input\" \nng-model=\"vm.currentElement.options.paddingBottom\"></div><div><label for=\"webSettingsPaddingLeft\" \ntranslate=\"builder_el_o_left\"></label><input id=\"webSettingsPaddingLeft\" type=\"text\" class=\"md-input\" \nng-model=\"vm.currentElement.options.paddingLeft\"></div></div></div><div class=\"block-properties\"><div \nclass=\"form-row text-inputs\"><label for=\"webSettingsBackground\">{{ \'background_color\' | translate }}</label><div \nclass=\"color-inputs\"><span>HEX #</span><color-input class=\"color-input-container\" \nmodel=\"vm.currentElement.options.backgroundColor\"></color-input></div></div></div></div></form></div></div></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button ng-click=\"vm.downloadHtml()\" class=\"send-button md-accent md-raised\">\nDOWNLOAD HTML</md-button><md-button ng-click=\"vm.exportwebAsJson()\" class=\"send-button md-accent md-raised\">EXPORT\n</md-button></div><div layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.saveTemplate()\" \nclass=\"cancel-button md-accent green-500-bg md-raised\" aria-label=\"Save\"><span translate=\"MAILING.APPLY\" \nng-if=\"!vm.isSaving\">APPLY</span><div flex layout=\"column\" layout-align=\"center center\" ng-if=\"vm.isSaving\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"25\"></md-progress-circular></div></md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/dialogs/select-media-to-join/select-media-to-join-dialog.controller.html","<md-dialog class=\"attachment-dialog selectmediatojoin add-media\" aria-label=\"New Message\"><form class=\"md-inline-form\">\n<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"pl-5\" layout=\"row\"><h2 translate=\"MEDIA.VIDEOS\">Videos</h2></div><div layout=\"row\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate \ntranslate-aria-label=\"CONTENT.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></div>\n</md-toolbar><md-content class=\"full-height\"><div layout=\"row\" class=\"full-height left-sidenav carded page-layout\"><div\n layout=\"column\" flex class=\"center\" md-no-ink><div ng-show=\"!vm.firstLoad\"><md-toolbar \nng-if=\"vm.showSearchAndPaginator\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<ms-search-bar-none flex class=\"expanded ms-search-bar\" debounce=\"300\" model-search=\"vm.searchStringFilter\" \non-search=\"vm.searchMedia()\" layout=\"row\" layout-align=\"start center\"><div flex layout=\"row\" \nlayout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-icon id=\"ms-search-bar-expander\" \nmd-font-icon=\"icon-magnify\" class=\"md-icon-button md-button search\"><md-tooltip><span translate=\"TOOLBAR.SEARCH\">\n</span></md-tooltip></md-icon></label><md-button ng-click=\"vm.modelSearch= \'\';vm.pagination_search(vm.modelSearch)\" \naria-label=\"view type\" class=\"md-icon-button\" translate=\"\" translate-attr-aria-label=\"CONTENT.FILTERS\" \nclass=\"md-icon-button\" id=\"ms-filters-cleaner\" ng-if=\"vm.modelSearch != \'\'\"><md-icon md-font-icon=\"icon-close-circle\">\n</md-icon><md-tooltip><span translate=\"TOOLBAR.RESET_SEARCH\"></span></md-tooltip></md-button><input \nid=\"ms-search-bar-input\" type=\"text\" ng-model=\"vm.modelSearch\" placeholder=\"Search\" md-autofocus translate \ntranslate-attr-placeholder=\"TOOLBAR.SEARCH\" flex ng-enter=\"vm.pagination_search(vm.modelSearch)\"><md-icon \nid=\"ms-search-bar-collapser\" md-font-icon=\"icon-close-circle\" class=\"icon s24\"></md-icon><md-button hide show-gt-xs \nid=\"ms-search-bar-button\" class=\"md-accent md-raised search\" ng-click=\"vm.pagination_search(vm.modelSearch)\" \naria-label=\"description\" md-no-ink=\"true\" md-ripple-size=\"auto\" translate=\"TOOLBAR.SEARCH\"></md-button><md-button hide \nshow-xs id=\"ms-search-bar-button\" class=\"md-accent md-raised md-icon-button search\" \nng-click=\"vm.pagination_search(vm.modelSearch)\" ng-disabled=\"!vm.modelSearch\" aria-label=\"description\" \nmd-no-ink=\"true\" md-ripple-size=\"auto\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>\n</ms-search-bar-none></div></md-toolbar></div><md-dialog-content layout=\"column\" ms-scroll=\"vm.msScrollOptions\" \nflex=\"100\" class=\"mediadialog-content scrollable\"><div flex layout=\"column\" layout-align=\"center center\" \nng-show=\"vm.loading || vm.firstLoad\" class=\"loading-container\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"50\"></md-progress-circular></div><div ng-include=\"\'app/main/dialogs/media/views/videos-view.html\'\" \nng-hide=\"vm.items.length == 0\" ng-style=\"{\'opacity\' : vm.loading ? 0.2 : 1}\"></div><div \nng-if=\"vm.items.length == 0 && !vm.loading && !vm.firstLoad\" layout=\"row\" layout-align=\"center center\" \nclass=\"content-wrapper full-height\" flex=\"100\"><div class=\"message\" translate=\"MEDIA_DIALOG.NO_ITEMS_AVAILABLE\"></div>\n</div></md-dialog-content></div></div></md-content><md-dialog-actions layout=\"row\" layout-align=\"end center\" \nng-style=\"{\'opacity\' : vm.loading ? 0.2 : 1}\" ng-if=\"(vm.items.length> 0)\"><div layout=\"row\" \nlayout-align=\"start center\" ng-if=\"!vm.totalItems\" hide show-gt-xs><span>&nbsp;</span></div><div layout=\"row\" \nlayout-align=\"start center\" ng-if=\"vm.totalItems> 0\" hide show-gt-xs ng-if=\"vm.showSearchAndPaginator\"><span \nclass=\"page-info\" ng-if=\"vm.showSearchAndPaginator\">{{vm.totalItems | number}} </span>&nbsp;<span \ntranslate=\"CONTENT.ITEMS_FOUND\"></span><md-button aria-label=\"Previous\" class=\"md-icon-button arrow\" \nng-if=\"vm.showSearchAndPaginator\" ng-click=\"vm.prevPage()\" ng-disabled=\"vm.firstPage()\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip \nmd-direction=\"top\"><span translate=\"CONTENT.PREVIOUS\"></span></md-tooltip></md-button><div><md-select \nng-model=\"pagination_page\" placeholder=\"{{vm.currentPage | number}}\" class=\"toolbar-item\"><md-option \nng-repeat=\"n in [].constructor(vm.lastPage) track by $index\" value=\"{{$index +1}}\" ng-click=\"vm.gotoPage($index+1)\">\n{{$index+1}}</md-option></md-select><md-tooltip md-direction=\"top\"><span translate=\"CONTENT.SELECT_PAGE\"></span>\n</md-tooltip></div><span class=\"page-info\" hide=\"\" show-gt-xs=\"\">/ {{vm.lastPage | number}}</span><md-button \naria-label=\"Next\" class=\"md-icon-button arrow\" ng-if=\"vm.showSearchAndPaginator\" ng-click=\"vm.nextPage()\" \nng-disabled=\"!vm.morePages()\" translate=\"\" translate-attr-aria-label=\"CONTENT.NEXT\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip md-direction=\"top\"><span translate=\"CONTENT.NEXT\"></span>\n</md-tooltip></md-button></div><div layout=\"row\" layout-align=\"end center\"><md-button \nng-disabled=\"vm.currentView == \'upload\'\" ng-click=\"vm.attachMedia()\" class=\"send-button md-accent md-raised\" \naria-label=\"Send\" translate=\"MEDIA.ATTACH\" translate-attr-aria-label=\"MEDIA.ATTACH\"></md-button><md-button \nng-if=\"show\" class=\"send-button md-accent md-raised\" aria-label=\"Send\" translate=\"MEDIA_DIALOG.UPLOADING\"></md-button>\n</div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/sidenavs/groups/groups-generic-sidenav.html","<md-toolbar class=\"md-default-theme grey-100-bg grey-600-fg pr-16 pl-16\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"md-toolbar-tools p-0\" aria-label=\"Groups\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-folder-multiple\" \nclass=\"grey-600-fg s18 mr-10 ml-0 md-default-theme md-font material-icons\" aria-hidden=\"true\"></md-icon><div \ntranslate-attr-aria-label=\"USERS.GROUPS\" translate=\"USERS.GROUPS\" class=\"grey-600-fg\" aria-label=\"GROUPS\">GROUPS</div>\n</div><div layout=\"row\" layout-align=\"end center\"><ms-search-bar debounce=\"300\" model-search=\"\" on-result-click=\"\" \non-search=\"\" layout=\"row\" layout-align=\"start center\"></ms-search-bar><div class=\"divider-vertical\"></div><md-icon \nng-click=\"vm.toggleSidenav(\'groups-sidenav\')\" md-font-icon=\"icon-backburger\" \nclass=\"m-0 grey-600-fg md-icon md-button md-default-theme md-font material-icons md-icon-button\" aria-hidden=\"true\">\n</md-icon></div></md-toolbar><md-content ms-scroll class=\"content\" hide flex><div class=\"navigation-simple\" \nlayout=\"column\"><div><div ng-if=\"vm.filterGroups.groups\" ivh-treeview=\"vm.filterGroups.groups\" class=\"treeview small\" \nivh-treeview-on-cb-change=\"vm.callback(ivhNode, ivhIsSelected, ivhTree)\"><script type=\"text/ng-template\">\n<div class=\"level-card\">\r\n                        <span ivh-treeview-toggle> \r\n                            <span ivh-treeview-twistie></span>\r\n                        </span> <span class=\"pointer-indicator\"></span>\r\n                        <span class=\"ivh-treeview-node-label\" ivh-treeview-toggle>{{trvw.label(node)}}</span>\r\n                        <md-treeview-box></md-treeview-box>\r\n                    </div>\r\n                    <div ivh-treeview-children></div>\n</script></div></div></div></md-content><md-content ms-scroll flex><div class=\"navigation-simple\" layout=\"column\"><div \nhidden id=\"includeSubgroups\" data-include-subgroups=\"{{vm.filterGroups.includeSubgroups}}\"></div><div \nng-if=\"vm.filterGroups.groups\" ivh-treeview=\"vm.filterGroups.groups\" class=\"ivh-treeview-folder small\" \nivh-treeview-on-cb-change=\"vm.callback(ivhNode, ivhIsSelected, ivhTree)\"><script type=\"text/ng-template\">\n<div class=\"level-card p-8 group-row\" layout=\"row\" layout-align=\"space-between stretch\">\r\n                    <span ivh-treeview-twistie ivh-treeview-toggle layout=\"row\" layout-align=\"center center\"></span>\r\n                    <div flex id=\"treeview-group-{{node.id_group}}\" qiu-groups-click groups-service=\"mailingService\" data-group-node={{node}} layout=\"row\" layout-align=\"start center\">\r\n                        <div ng-if=\"node.group_type.icon\">\r\n                            <md-icon ng-if=\"node.group_type.icon\" \r\n                                md-font-icon=\"{{node.group_type.icon}}\" \r\n                                class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                        </div>\r\n                        <div ng-if=\"!node.group_type.icon\">\r\n                            <md-icon ng-if=\"!node.children && node.id_group_type == 1\" \r\n                                md-font-icon=\"icon-folder\" \r\n                                class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon \r\n                                ng-if=\"node.children && node.id_group_type == 1\" \r\n                                md-font-icon=\"icon-folder-multiple\" \r\n                                class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                                aria-hidden=\"true\" >\r\n                            </md-icon> \r\n                            <md-icon ng-if=\"!node.children && node.id_group_type == 2\" \r\n                                md-font-icon=\"qiu-icon-file-usermailing\" \r\n                                class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon \r\n                                ng-if=\"node.children && node.id_group_type == 2\" \r\n                                md-svg-src=\"/assets/icons/svg/icon-folder-mail-multiple.svg\"\r\n                                class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon ng-if=\"!node.children && node.id_group_type == 3\" \r\n                                md-font-icon=\"qiu-icon-file-usermediacenter\" \r\n                                class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon \r\n                                ng-if=\"node.children && node.id_group_type == 3\" \r\n                                md-svg-src=\"/assets/icons/svg/icon-folder-play-multiple.svg\"\r\n                                class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon ng-if=\"!node.children && node.id_group_type == 4\" \r\n                                md-font-icon=\"qiu-icon-file-usersegment\" \r\n                                class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon \r\n                                ng-if=\"node.children && node.id_group_type == 4\" \r\n                                md-svg-src=\"/assets/icons/svg/icon-folder-share-multiple.svg\"\r\n                                class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon ng-if=\"!node.children && node.id_group_type == 5\" \r\n                                md-font-icon=\"qiu-icon-file-userstore\" \r\n                                class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon \r\n                                ng-if=\"node.children && node.id_group_type == 5\" \r\n                                md-svg-src=\"/assets/icons/svg/icon-folder-shop-multiple.svg\"\r\n                                class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon ng-if=\"!node.children && node.id_group_type == 6\" \r\n                                md-font-icon=\"qiu-icon-file-useracreditation\" \r\n                                class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon \r\n                                ng-if=\"node.children && node.id_group_type == 6\" \r\n                                md-svg-src=\"/assets/icons/svg/icon-folder-board-multiple.svg\"\r\n                                class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon ng-if=\"!node.children && node.id_group_type == 7\" \r\n                                md-svg-src=\"/assets/icons/svg/icon-folder-chat.svg\"\r\n                                class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon \r\n                                ng-if=\"node.children && node.id_group_type == 7\" \r\n                                md-svg-src=\"/assets/icons/svg/icon-folder-chat-multiple.svg\"\r\n                                class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon ng-if=\"!node.children && node.id_group_type == 8\" \r\n                                md-font-icon=\"icon-folder-remove\" \r\n                                class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon \r\n                                ng-if=\"node.children && node.id_group_type == 8\" \r\n                                md-font-icon=\"icon-folder-multiple\" \r\n                                class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                                aria-hidden=\"true\" >\r\n                            </md-icon> \r\n                        </div>\r\n                        <span class=\"ivh-treeview-node-label ng-binding\">{{node.name}}</span>\r\n                    </div>\r\n                    <div layout=\"row\" layout-align=\"end center\">\r\n                        <md-button qiu-on-click-open-gallery-edit-dialog class=\"md-icon-button\" type=\"button\" aria-label=\"ACTIONS\">\r\n                            <md-icon md-font-icon=\"icon-pencil\" aria-hidden=\"true\"></md-icon>\r\n                        </md-button>\r\n                         <md-icon md-font-icon=\"icon-chevron-right\" aria-hidden=\"true\" hide-gt-sm class=\"mt-0 mb-0\"></md-icon>\r\n                    </div>\r\n                </div>\r\n                <div ivh-treeview-children></div>\n</script></div></div></md-content>");
$templateCache.put("app/main/public/logout/logout.html","<div id=\"login-v2\" layout=\"row\" layout-align=\"start\"><div id=\"login-v2-intro\" flex hide show-gt-sm><div \nclass=\"logo md-accent-bg\"><span>Q</span></div><div class=\"title\" translate=\"LOGIN_V2.INTRO_TITLE\">\nWelcome to the New QiuSystem!</div><div class=\"description\" translate=\"LOGIN_V2.INTRO_DESCRIPTION\">\nLorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ullamcorper nisl erat, vel convallis elit fermentum pellentesque. Sed mollis velit facilisis facilisis viverra.\n</div></div><div id=\"login-v2-form-wrapper\" class=\"flex-scrollable md-whiteframe-8dp\" ms-scroll><div \nid=\"login-v2-form\"><div class=\"logo md-accent-bg\" hide-gt-sm><span>Q</span></div><div class=\"title\" \ntranslate=\"LOGIN_V2.TITLE\">Log in to your account</div><div class=\"description\" translate=\"LOGIN_V2.DESCRIPTION\">\nSed mollis velit facilisis facilisis viverra</div><form name=\"loginForm\" novalidate ng-submit=\"login()\">\n<md-input-container class=\"md-block\" md-no-float><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" \nplaceholder=\"Email\" translate translate-attr-placeholder=\"LOGIN_V2.EMAIL\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"loginForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN_V2.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"LOGIN_V2.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" \nng-model=\"vm.form.password\" placeholder=\"Password\" translate translate-attr-placeholder=\"LOGIN_V2.PASSWORD\" required>\n<div ng-messages=\"loginForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN_V2.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><div \nclass=\"remember-forgot-password\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-between center\"><md-checkbox \nclass=\"remember-me\" ng-model=\"data.cb1\" aria-label=\"Remember Me\"><span translate=\"LOGIN_V2.REMEMBER_ME\">Remember Me\n</span></md-checkbox><a ui-sref=\"app.pages_auth_forgot-password\" class=\"forgot-password md-accent-color\" \ntranslate=\"LOGIN_V2.FORGOT_PASSWORD\">Forgot Password?</a></div><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" \ntranslate=\"LOGIN_V2.LOG_IN\" translate-attr-aria-label=\"LOGIN_V2.LOG_IN\">LOG IN</md-button></form><div \nclass=\"separator\"><span class=\"text\" translate=\"LOGIN_V2.OR\">OR</span></div><div layout=\"column\" \nlayout-align=\"start center\"><md-button class=\"md-raised google\"><div layout=\"row\" layout-align=\"center center\"><span>\n<md-icon md-font-icon=\"icon-google-plus\" class=\"s16\"></md-icon><span translate=\"LOGIN_V2.WITH_GOOGLE\">\nLog in with Google</span></span></div></md-button></div></div></div></div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/quick-panel/tabs/domains/domain-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-input-container \nclass=\"md-block\" flex-gt-sm><label>Name</label><input name=\"name\" ng-model=\"filters.contentFilterInput\"><div \nclass=\"hint\" ng-if=\"showHints\">Tell us what we should call you!</div><div ng-messages=\"userForm.name.$error\" \nng-if=\"!showHints\"><div ng-message=\"required\">Name is required.</div><div ng-message=\"md-maxlength\">\nThe name has to be less than 30 characters long.</div></div></md-input-container><md-subheader class=\"md-no-sticky\">\n<span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item class=\"contact md-3-line\" \nng-repeat=\"domain in domains | filter:filters.contentFilterInput\" ng-click=\"vm.setDomain(domain)\"><img \nng-src=\"/assets/images/logos/sites/{{domain.icon}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div \nclass=\"status {{contact.status}}\"></div><div ng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">\n{{contact.unread}}</div><div class=\"md-list-item-text\"><h3>{{domain.domain_name}}</h3><p class=\"last-message\">\n{{contact.lastMessage}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item \nclass=\"contact\" ng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div \nclass=\"md-list-item-text\"><h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Call\" translate translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id=\"chat-dialog\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img \nng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img\n ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex><div \nclass=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content>\n<form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea \nng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex ng-model=\"vm.replyMessage\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\">\n</textarea><md-button class=\"md-fab\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\"></md-icon></md-button></form>\n</div>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item \nclass=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" \nng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Call\" translate translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id=\"chat-dialog\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img \nng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img\n ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex><div \nclass=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content>\n<form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea \nng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex ng-model=\"vm.replyMessage\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\">\n</textarea><md-button class=\"md-fab\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\"></md-icon></md-button></form>\n</div>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span>\n</md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img \nng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" \nng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" \nng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span\n translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" \nng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" \nmd-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp_\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><a class=\"logo-image\" ng-href=\"/\"><img ng-src=\"{{vm.logoURL}}\">\n</a><span class=\"logo-text\">{{vm.siteName}}</span></div><md-icon class=\"fold-toggle s18\" \nmd-font-icon=\"icon-backburger\" hide show-gt-sm ng-click=\"vm.toggleMsNavigationFolded()\"></md-icon><md-icon \nclass=\"fold-toggle s18\" md-font-icon=\"icon-close\" hide-gt-sm ng-click=\"vm.toggleSidenav(\'navigation\')\"></md-icon>\n</md-toolbar><ms-search-nav></ms-search-nav><ms-navigation class=\"scrollable\" folded=\"vm.folded == \'folded\'\" \nms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\" layout=\"column\" layout-align=\"start start\"><div class=\"secondary-text\">\n<div>{{vm.date | date:\'EEEE\'}}</div><div layout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> \n<span class=\"md-subhead\">th</span> <span>{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list>\n<md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.EVENTS\">Events</span>\n</md-subheader><md-list-item class=\"md-2-line\" ng-repeat=\"event in vm.events\" ng-click=\"dummyFunction()\"><div \nclass=\"md-list-item-text\"><h3>{{event.title}}</h3><p>{{event.detail}}</p></div></md-list-item></md-list><md-divider>\n</md-divider><md-list><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.NOTES\">Notes</span></md-subheader>\n<md-list-item class=\"md-2-line\" ng-repeat=\"note in vm.notes\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\">\n<h3>{{note.title}}</h3><p>{{note.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list>\n<md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings</span></md-subheader>\n<md-list-item><h3 translate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3><md-switch class=\"md-secondary\" \nng-model=\"vm.settings.notify\" aria-label=\"Notifications\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch></md-list-item><md-list-item><h3 \ntranslate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.cloud\" \naria-label=\"Cloud Sync\" translate translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\"></md-switch></md-list-item>\n<md-list-item><h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3><md-switch class=\"md-secondary md-warn\" \nng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch></md-list-item></md-list>");
$templateCache.put("app/toolbar/dialogs/change-password/change-password.html","<md-dialog class=\"change-password\"><form style=\"height: 100%\" name=\"taskForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between\"><h1 \nclass=\"title\">{{\'TOOLBAR.CHANGE_PASS\' | translate}}</h1><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"p-15\"><form name=\"passwordForm\"><md-input-container style=\"min-width: 300px\" \nclass=\"md-block\" flex-gt-sm><label>Password</label><input ng-change=\"passwordForm.$setDirty()\" type=\"password\" \nname=\"password\" ng-model=\"vm.password\" required><div ng-messages=\"passwordForm.password.$error\" role=\"alert\" \nclass=\"form-errors first-name-error\"><div ng-if=\"passwordForm.$dirty && !vm.password\">Password is required.</div></div>\n</md-input-container><md-input-container style=\"min-width: 300px\" class=\"md-block\" flex-gt-sm><label>Confirm Password\n</label><input ng-change=\"passwordForm.$setDirty()\" type=\"password\" name=\"confirm_password\" \nng-model=\"vm.confirm_password\" required compare-to=\"vm.password\"><div \nng-messages=\"passwordForm.confirm_password.$error\" role=\"alert\" class=\"form-errors first-name-error\"><div \nng-if=\"vm.password != vm.confirm_password\">Must not match</div><div ng-if=\"vm.password && vm.password.length <6\">\nMinimun 6 characters</div><div ng-if=\"vm.password && !vm.containsNumber()\">At least one numeric character</div><div \nng-if=\"vm.password && !vm.containUpperCaseAndLowerCase()\">Uppercase and Lowercase characters</div></div>\n</md-input-container></form></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div flex layout=\"row\" layout-align=\"end center\"><md-button type=\"button\" \nclass=\"md-raised md-warn\" ng-click=\"vm.closeDialog()\" translate=\"FORMS.CANCEL\">Cancel</md-button><md-button \nng-disabled=\"vm.password != vm.confirm_password || vm.password.length <6 || !vm.containsNumber() || !vm.containUpperCaseAndLowerCase()\" \nng-click=\"vm.save()\" class=\"send-button md-accent md-raised\" aria-label=\"save\" translate=\"ACCOUNTS.SAVE\" \ntranslate-attr-aria-label=\"ACCOUNTS.SAVE\">SAVE</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">Q</span> <span class=\"logo-text\">Qiu</span></div>\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\"></md-progress-circular></div><div layout=\"row\" layout-align=\"start center\"><ms-search-bar>\n</ms-search-bar><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdMenu.open()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-xs>\nJohn Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdMenu.open()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdMenu.open()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag img-flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.svg\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag img-flag\" ng-src=\"assets/images/flags/{{lang.flag}}.svg\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><h1 class=\"md-toolbar-tools\" ng-if=\"vm.titleToolbar\" \nng-bind-html=\"vm.titleToolbar\"></h1><div layout-padding ng-if=\"$root.loadingProgress\"><md-progress-circular \nid=\"toolbar-progress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"34\"></md-progress-circular></div></div>\n<div layout=\"row\" layout-align=\"start center\"><div ng-if=\"aiShow\" class=\"toolbar-separator\"></div><div \nid=\"ai-container\" ng-if=\"aiShow\" ng-click=\"vm.openAiSidenav()\"><span></span></div><div class=\"toolbar-separator\"></div>\n<md-button id=\"domain-panel-toggle\" ng-if=\"domains.length>1\" class=\"user-button\" \nng-click=\"vm.toggleSidenav(\'domain-panel\')\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><span hide show-gt-xs class=\"username\">{{site_operative.domain_name}}\n</span><div style=\"background-color:{{site_operative.color}}\" hide-gt-xs class=\"username avatar\">\n{{site_operative.domain_name | capitalizeFirstLetter}}</div></md-button><md-button id=\"domain-panel-toggle\" \nmd-ink-ripple=\"false\" ng-if=\"domains.length==0\" class=\"md-no-focus\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><span class=\"username\">{{site_operative.domain_name}}</span>\n</md-button><div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\">\n<md-button class=\"user-button\" ng-click=\"$mdMenu.open()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" ng-src=\"{{vm.user.avatar}}\" ng-if=\"vm.user.avatar\">\n<md-icon md-font-icon=\"icon-account-circle\" class=\"icon s40\" ng-if=\"!vm.user.avatar\"></md-icon></div><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div></md-button><md-menu-content width=\"3\" \nclass=\"user-content\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><button>\n{{vm.user.first_name}} {{vm.user.last_name}}</button></div></md-menu-item><md-menu-item \nng-click=\"vm.openPassDialog($event)\" class=\"md-indent\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-lock\" class=\"icon\"></md-icon><button>{{ \'TOOLBAR.CHANGE_PASS\' | translate}}</button></div>\n</md-menu-item><md-menu-item class=\"md-indent\"><div layout=\"row\" layout-align=\"start center\" class=\"pr-5\"><md-menu \nid=\"user-status-menu\" flex><div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><img class=\"icon flag img-flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.svg\"> <button ng-click=\"$mdMenu.open()\" class=\"status\" \nng-class=\"vm.userStatus.class\"><span translate=\"{{vm.selectedLanguage.translation}}\">{{vm.selectedLanguage.title}}\n</span></button></div><md-icon md-font-icon=\"icon-chevron-right\" class=\"icon s20 mr-0\"></md-icon></div><md-menu-content\n width=\"3\" class=\"user-content\"><md-menu-item class=\"md-indent\" ng-repeat=\"(iso, lang) in vm.languages\" \nng-click=\"vm.changeLanguage(lang)\"><div layout=\"row\" layout-align=\"start center\"><img class=\"flag img-flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.svg\"> <button aria-label=\"{{lang.title}}\"><span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></button></div></md-menu-item></md-menu-content></md-menu></div>\n</md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_auth_logout\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><button>Logout</button></div>\n</md-menu-item></md-menu-content></md-menu></md-menu-bar></div></div>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">Q</span> <span class=\"logo-text\">Qiu</span></div>\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\"></md-progress-circular></div><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"toolbar-separator\"></div><ms-search-bar></ms-search-bar><div class=\"toolbar-separator\"></div><md-menu-bar \nid=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdMenu.open()\" \naria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-xs>\nJohn Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdMenu.open()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" \nmd-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdMenu.open()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag img-flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.svg\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag img-flag\" ng-src=\"assets/images/flags/{{lang.flag}}.svg\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/core/directives/form/form-items-container/form-items-container.html","<div><form-item ng-repeat=\"item in container.form.items track by $index\" type=\"{{item.type}}\" item=\"item\" \nindex=\"$index\" on-delete=\"container.delete(item, index)\" on-up=\"container.up(item, index)\" \non-down=\"container.down(item, index)\"></form-item></div>");
$templateCache.put("app/core/directives/form/form-view/form-view.html","<div class=\"formItem\" ng-repeat=\"formItem in FormView.form.items track by $index\" ng-switch=\"formItem.type\" \nlayout=\"column\"><ng-form name=\"formItemForm\"><div><div class=\"formItem-title\">{{formItem.props.title}}</div><div \nclass=\"formItem-help-text\">{{formItem.props.helpText}}</div><checkboxes-view form-item=\"formItem\" is-preview=\"true\" \nform=\"formItemForm\" ng-switch-when=\"checkboxes\"></checkboxes-view><radio-button-view form-item=\"formItem\" \nis-preview=\"true\" form=\"formItemForm\" ng-switch-when=\"multipleChoices\"></radio-button-view><input-view \nform-item=\"formItem\" form=\"formItemForm\" ng-switch-when=\"input\"></input-view><textarea-view form-item=\"formItem\" \nform=\"formItemForm\" ng-switch-when=\"textarea\"></textarea-view><matrix-view form-item=\"formItem\" is-preview=\"true\" \nform=\"formItemForm\" ng-switch-when=\"matrix\"></matrix-view></div></ng-form></div>");
$templateCache.put("app/core/directives/form/checkboxes-item/checkboxes-item.html","<div class=\"sortable-container\" layout=\"column\" sv-root sv-part=\"Checkboxes.item.options\"><md-input-container><label>\nMax Selections</label><input type=\"number\" ng-model=\"Checkboxes.item.config.maxSelections\"></md-input-container>\n<md-switch ng-model=\"Checkboxes.item.config.direction\" ng-true-value=\"\'horizontal\'\" ng-false-value=\"\'vertical\'\">\nLayout direction ({{Checkboxes.item.config.direction == \'horizontal\' ? \'Horizontal\' : \'Vertical\'}})</md-switch><div \nclass=\"option-item\" layout=\"row\" ng-repeat=\"option in Checkboxes.item.options track by $index\" sv-element><md-button \nclass=\"md-button handle\" md-no-ink aria-label=\"reorder option item\" sv-handle><i class=\"material-icons\">reorder</i>\n</md-button><md-input-container><label>Option {{$index + 1}}</label><input ng-model=\"option.value\">\n</md-input-container><md-button class=\"md-button\" ng-click=\"Checkboxes.deleteOption($index)\"><i class=\"material-icons\">\ndelete</i></md-button></div><div layout=\"row\" layout-align=\"start\"><md-button class=\"md-primary add-option-button\" \nng-click=\"Checkboxes.addOption()\">Add Option</md-button></div></div>");
$templateCache.put("app/core/directives/form/checkboxes-item/checkboxes-view.html","<md-input-container><div layout=\"{{CheckboxesView.formItem.config.direction == \'horizontal\' ? \'column\' : \'row\'}}\">\n<md-checkbox ng-repeat=\"option in CheckboxesView.formItem.options track by $index\" ng-model=\"option.selected\" \nng-change=\"CheckboxesView.toggleSelectedOption(option)\" \nng-disabled=\"CheckboxesView.disableOptions && !option.selected\" aria-label=\"...\">{{option.value}}</md-checkbox></div>\n<div ng-messages=\"CheckboxesView.form.$error\"><div ng-message=\"minSelections\">\nMust select {{CheckboxesView.formItem.maxSelections || 1}} items</div></div></md-input-container>");
$templateCache.put("app/core/directives/form/input-item/input-item.html","<md-input-container class=\"input-container\"><label>Placeholder</label><input type=\"text\" \nng-model=\"Input.item.config.placeholder\"></md-input-container><md-input-container><label>Type</label><md-select \nng-model=\"Input.item.config.type\"><md-option value=\"text\">Text</md-option><md-option value=\"number\">Number</md-option>\n</md-select></md-input-container>");
$templateCache.put("app/core/directives/form/input-item/input-view.html","<md-input-container flex><input ng-model=\"InputView.formItem.value\" type=\"{{InputView.formItem.config.type}}\" \nplaceholder=\"{{InputView.formItem.config.placeholder}}\" ng-required=\"InputView.formItem.config.required\"><div \nng-messages=\"InputView.form.$error\" role=\"alert\"><div ng-message=\"required\"><span>This field is required</span></div>\n</div></md-input-container>");
$templateCache.put("app/core/directives/form/matrix-item/matrix-item.html","<div class=\"sortable-container columnContainer\" layout=\"column\" sv-root sv-part=\"Matrix.item.config.columns\"><div \nclass=\"option-item\" layout=\"row\" ng-repeat=\"column in Matrix.item.config.columns track by $index\" sv-element><md-button\n class=\"md-button handle\" md-no-ink aria-label=\"reorder option item\" sv-handle><i class=\"material-icons\">reorder</i>\n</md-button><md-input-container class=\"input-container\"><label>Column {{$index + 1}}</label><input \nng-model=\"column.value\"></md-input-container><md-button class=\"md-button\" md-no-ink aria-label=\"delete column item\" \nng-click=\"Matrix.deleteColumn($index)\"><i class=\"material-icons\">delete</i><md-tooltip md-autohide=\"true\">Delete\n</md-tooltip></md-button></div><div layout=\"row\" layout-align=\"start\"><md-button class=\"md-primary add-option-button\" \nmd-no-ink aria-label=\"add option item\" ng-click=\"Matrix.addColumn()\">Add Column</md-button></div></div><div \nclass=\"sortable-container rowContainer\" layout=\"column\" sv-root sv-part=\"Matrix.item.config.rows\"><div \nclass=\"option-item\" layout=\"row\" ng-repeat=\"row in Matrix.item.config.rows track by $index\" sv-element><md-button \nclass=\"md-button handle\" md-no-ink aria-label=\"reorder row item\" sv-handle><i class=\"material-icons\">reorder</i>\n</md-button><md-input-container class=\"input-container\"><label>Row {{$index + 1}}</label><input ng-model=\"row.value\">\n</md-input-container><md-button class=\"md-button\" md-no-ink aria-label=\"delete row item\" \nng-click=\"Matrix.deleteRow($index)\"><i class=\"material-icons\">delete</i><md-tooltip md-autohide=\"true\">Delete\n</md-tooltip></md-button></div><div layout=\"row\" layout-align=\"start\"><md-button class=\"md-primary add-option-button\" \nmd-no-ink aria-label=\"add row item\" ng-click=\"Matrix.addRow()\">Add row</md-button></div></div>");
$templateCache.put("app/core/directives/form/matrix-item/matrix-view.html","<md-input-container class=\"matrix-container\" layout=\"column\"><div class=\"matrix\"><div class=\"matrix-row\" flex \nlayout=\"row\"><span class=\"matrix-cell\" flex=\"20\"></span> <span class=\"matrix-cell matrix-cell-header\" flex \nng-repeat=\"column in MatrixView.formItem.config.columns track by $index\">{{column.value}}</span></div><div \nclass=\"matrix-row\" ng-repeat=\"row in MatrixView.formItem.config.rows track by $index\" layout=\"row\"><span \nclass=\"matrix-cell\" flex=\"20\" layout=\"column\" layout-align=\"center\">{{row.value}}</span><md-radio-group \nng-model=\"row.selected\" ng-change=\"MatrixView._updateValidity()\" flex layout=\"row\"><span \nclass=\"matrix-cell radio-button-cell\" flex ng-repeat=\"column in MatrixView.formItem.config.columns track by $index\">\n<md-radio-button value=\"{{column.value}}\" aria-label=\"...\"></md-radio-button></span></md-radio-group></div></div><div \nng-messages=\"MatrixView.form.$error\"><div ng-message=\"required\">This is required</div></div></md-input-container>");
$templateCache.put("app/core/directives/form/radio-button-item/radio-button-item.html","<div class=\"sortable-container\" layout=\"column\" sv-root sv-part=\"RadioButton.item.options\"><md-switch \nng-model=\"RadioButton.item.config.direction\" ng-true-value=\"\'horizontal\'\" ng-false-value=\"\'vertical\'\">\nLayout direction ({{RadioButton.item.config.direction == \'horizontal\' ? \'Horizontal\' : \'Vertical\'}})</md-switch><div \nclass=\"option-item\" layout=\"row\" ng-repeat=\"option in RadioButton.item.options track by $index\" sv-element><md-button \nclass=\"md-button handle\" md-no-ink aria-label=\"reorder option item\" sv-handle><i class=\"material-icons\">reorder</i>\n</md-button><md-input-container><label>Option {{$index + 1}}</label><input ng-model=\"option.value\">\n</md-input-container><md-button class=\"md-button\" ng-click=\"RadioButton.deleteOption($index)\"><i \nclass=\"material-icons\">delete</i></md-button></div><div layout=\"row\" layout-align=\"start\"><md-button \nclass=\"md-primary add-option-button\" ng-click=\"RadioButton.addOption()\">Add Option</md-button></div></div>");
$templateCache.put("app/core/directives/form/radio-button-item/radio-button-view.html","<md-input-container><md-radio-group name=\"formItemInput\" ng-required=\"RadioButtonView.formItem.config.required\" \nng-model=\"RadioButtonView.formItem.value\" \nlayout=\"{{RadioButtonView.formItem.config.direction == \'horizontal\' ? \'column\' : \'row\'}}\" required><md-radio-button \nng-repeat=\"option in RadioButtonView.formItem.options track by $index\" value=\"{{option.value}}\" aria-label=\"...\">\n{{option.value}}</md-radio-button></md-radio-group><div ng-messages=\"RadioButtonView.form.$error\"><div \nng-message=\"required\">This field is required</div></div></md-input-container>");
$templateCache.put("app/core/directives/form/textarea-item/textarea-item.html","<md-input-container class=\"input-container\"><label>Placeholder</label><input type=\"text\" \nng-model=\"Textarea.item.config.placeholder\"></md-input-container>");
$templateCache.put("app/core/directives/form/textarea-item/textarea-view.html","<md-input-container><textarea ng-model=\"TextareaView.formItem.value\" \nplaceholder=\"{{TextareaView.formItem.config.placeholder}}\" ng-required=\"TextareaView.formItem.config.required\">\n</textarea><div ng-messages=\"TextareaView.form.$error\"><div ng-message=\"required\">This field is required</div></div>\n</md-input-container>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\r\n\r\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\r\n             ng-class=\"{\'active md-accent-bg\': vm.isActive}\">\r\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\r\n        </div>\r\n\r\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\r\n           ng-class=\"{\'active md-accent-bg\': vm.isActive}\"\r\n           ng-if=\"node.uisref && node.title\">\r\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\r\n        </a>\r\n\r\n    </div>\r\n\r\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\r\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\r\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\r\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\r\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\r\n\r\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\r\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title|capitalize}}</span>\r\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\r\n        </div>\r\n\r\n        <a class=\"ms-navigation-button\" ui-sref-active=\"active md-accent-bg\" ui-sref=\"{{node.uisref}}\"\r\n           ng-click=\"vm.loadTab($event, node)\"\r\n           ng-if=\"node.uisref && node.title\">\r\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title|capitalize}}</span>\r\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\r\n        </a>\r\n\r\n    </div>\r\n\r\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\r\n        <li ng-repeat=\"node in node.children | filter: vm.searchNav\" ms-navigation-node=\"node\"\r\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\r\n            ng-include=\"\'navigation-nested.html\'\"></li>\r\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-social-widget-share/social-dialog/social-dialog.html","<md-dialog class=\"social-dialog\"><form style=\"height: 100%\" name=\"taskForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between\"><h1 \nng-if=\"!vm.pages && !vm.xMode && !vm.ytMode\" class=\"title\">{{\'MATCH_CENTER.SOCIAL_DIALOG\' | translate}}</h1><h1 \nng-if=\"vm.xMode\" class=\"title\">Add an X account</h1><h1 ng-if=\"vm.ytMode\" class=\"title\">Add a YouTube channel</h1><h1 \nng-if=\"vm.pages\" class=\"title\">Pages to add</h1><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><div class=\"p-20\" ng-if=\"!vm.pages && !vm.xMode && !vm.ytMode\"><div class=\"p-5 text-center\"><md-button \nng-if=\"vm.socialProviders.includes(\'Facebook\')\" style=\"background-color: #4266b2\" \nng-click=\"vm.login($event, \'Facebook\')\" type=\"button\" class=\"social-button md-raised md-fab md-accent m-10\"><md-icon \nclass=\"pointer\" md-font-icon=\"icon-facebook\" aria-label=\"Close dialog\"></md-icon></md-button><md-button \nng-if=\"vm.socialProviders.includes(\'FacebookBusiness\')\" style=\"background-color: #0866ff\" \nng-click=\"vm.login($event, \'FacebookBusiness\')\" type=\"button\" class=\"social-button md-raised md-fab md-accent m-10\" \naria-label=\"Connect a Facebook page via the business portfolio\"><md-icon class=\"pointer\" \nmd-font-icon=\"icon-facebook-box\" aria-label=\"Facebook Business\"></md-icon></md-button><md-button \nng-if=\"vm.socialProviders.includes(\'Twitter\')\" style=\"background-color: #1ea1f2\" \nng-click=\"vm.login($event, \'Twitter\')\" type=\"button\" class=\"social-button md-raised md-accent md-fab m-10\"><md-icon \nclass=\"pointer\" md-font-icon=\"icon-twitter\" aria-label=\"Close dialog\"></md-icon></md-button><md-button \nng-if=\"vm.socialProviders.includes(\'X\')\" style=\"background-color: #000\" ng-click=\"vm.login($event, \'X\')\" type=\"button\" \nclass=\"social-button md-raised md-accent md-fab m-10\" aria-label=\"Add an X account\"><md-icon class=\"pointer\" \naria-label=\"X\"><svg viewBox=\"0 0 24 24\" fill=\"currentColor\" \nstyle=\"width: .75em; height: .75em; vertical-align: middle\"><path \nd=\"M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z\"/>\n</svg></md-icon></md-button><md-button ng-if=\"vm.socialProviders.includes(\'Google\')\" style=\"background-color: #f00\" \nng-click=\"vm.login($event, \'Google\')\" type=\"button\" class=\"social-button md-raised md-accent md-fab m-10\"><md-icon \nclass=\"pointer\" md-font-icon=\"icon-youtube\" aria-label=\"Close dialog\"></md-icon></md-button><md-button \nng-if=\"vm.socialProviders.includes(\'LinkedIn\')\" style=\"background-color: #0a77b5\" \nng-click=\"vm.login($event, \'LinkedIn\')\" type=\"button\" class=\"social-button md-raised md-fab md-accent m-10\"><md-icon \nclass=\"pointer\" md-font-icon=\"icon-linkedin\" aria-label=\"Close dialog\"></md-icon></md-button></div></div><div \nclass=\"p-20\" ng-if=\"vm.xMode\"><div class=\"mb-20\"><p class=\"mb-5\"><b>Follow a public X account</b></p>\n<md-input-container class=\"md-block\"><label>X @handle</label><input ng-model=\"vm.xHandle\" \nng-keyup=\"$event.keyCode == 13 && vm.connectXPublic()\" placeholder=\"e.g. americascup\" aria-label=\"X handle\">\n</md-input-container><div ng-if=\"vm.xError\" style=\"color:#d9534f\" class=\"mb-10\" ng-bind=\"vm.xError\"></div><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-accent md-raised\" \nng-disabled=\"vm.xLoading || !vm.xHandle\" ng-click=\"vm.connectXPublic()\"><span ng-if=\"!vm.xLoading\">Follow</span> <span \nng-if=\"vm.xLoading\">Adding&hellip;</span></md-button><md-button class=\"md-warn\" ng-click=\"vm.backToProviders()\">Back\n</md-button></div></div><div class=\"border-top pt-15\"><p class=\"mb-5\" style=\"opacity:.6; font-size:12px\">\nAdvanced: sign in with X to verify ownership of your own account (needed later for posting or protected posts). Reading a public timeline does not require this.\n</p><md-button class=\"md-raised\" style=\"background-color:#000; color:#fff\" ng-click=\"vm.connectXAccount($event)\">\nConnect your account (advanced)</md-button></div></div><div class=\"p-20\" ng-if=\"vm.ytMode\"><div class=\"mb-20\"><p \nclass=\"mb-5\"><b>Follow a public YouTube channel</b></p><md-input-container class=\"md-block\"><label>\nYouTube @handle or channel URL</label><input ng-model=\"vm.ytHandle\" \nng-keyup=\"$event.keyCode == 13 && vm.connectYoutubePublic()\" placeholder=\"e.g. @emiratesteamnz\" \naria-label=\"YouTube channel\"></md-input-container><div ng-if=\"vm.ytError\" style=\"color:#d9534f\" class=\"mb-10\" \nng-bind=\"vm.ytError\"></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-accent md-raised\" \nng-disabled=\"vm.ytLoading || !vm.ytHandle\" ng-click=\"vm.connectYoutubePublic()\"><span ng-if=\"!vm.ytLoading\">Follow\n</span> <span ng-if=\"vm.ytLoading\">Adding&hellip;</span></md-button><md-button class=\"md-warn\" \nng-click=\"vm.backToProviders()\">Back</md-button></div></div><div class=\"border-top pt-15\"><p class=\"mb-5\" \nstyle=\"opacity:.6; font-size:12px\">\nAdvanced: sign in with Google to connect a channel you own. Only needed to publish videos to that channel &mdash; importing a public channel\'s videos does not require this.\n</p><md-button class=\"md-raised\" style=\"background-color:#f00; color:#fff\" ng-click=\"vm.connectGoogleAccount($event)\">\nConnect your Google account (advanced)</md-button></div></div><div ng-if=\"vm.pages\" class=\"list-item\" \nng-repeat=\"page in vm.pages track by $index\" md-no-ink ng-cloak><div class=\"pv-15 ph-25 border-bottom\" layout=\"row\" \nlayout-align=\"start center\"><md-checkbox ng-checked=\"vm.isSelected(page)\" ng-click=\"vm.toggleSelected(page)\" \nclass=\"no-label\"></md-checkbox><span class=\"ml-25\"><md-icon ng-if=\"page.instagram\" class=\"pointer mr-5\" \nmd-font-icon=\"icon-instagram\" aria-label=\"Close dialog\"></md-icon><md-icon ng-if=\"!page.instagram\" \nclass=\"pointer mr-5\" md-font-icon=\"icon-facebook\" aria-label=\"Close dialog\"></md-icon>{{page.name}}</span></div></div>\n</md-dialog-content><md-dialog-actions ng-if=\"vm.pages\" layout=\"row\" layout-align=\"space-between center\"><div flex \nlayout=\"row\" layout-align=\"start center\"><md-checkbox ng-model=\"vm.availableToAll\" class=\"no-label\">Available to all\n</md-checkbox></div><div flex layout=\"row\" layout-align=\"end center\"><md-button type=\"button\" \nclass=\"md-raised md-warn\" ng-click=\"vm.closeDialog()\" translate=\"FORMS.CANCEL\">Cancel</md-button><md-button \nng-disabled=\"vm.pagesSelected.length == 0\" ng-click=\"vm.savePages()\" class=\"send-button md-accent md-raised\" \naria-label=\"save\" translate=\"ACCOUNTS.SAVE\" translate-attr-aria-label=\"ACCOUNTS.SAVE\">SAVE</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/core/directives/qiu-field/templates/checkbox.html","<md-input-container flex><md-checkbox ng-disabled=\"vm.field.readonly\" ng-if=\"vm.ngModel\" class=\"no-label\" \naria-label=\"vm.field.label\" ng-model=\"vm.ngModel[vm.field.name]\" tabindex=\"0\">{{vm.field.label}}</md-checkbox>\n</md-input-container>");
$templateCache.put("app/core/directives/qiu-field/templates/date.html","<div flex class=\"date-container date\"><mdp-date-picker ng-init=\"model = vm.stringToDate(vm.ngModel[vm.field.name])\" \nng-required=\"vm.field.required ? true : false\" mdp-format-show=\"{{vm.field.format ? vm.field.format : \'MM-DD-YYYY\'}}\" \nmdp-format=\"MM-DD-YYYY\" mdp-placeholder=\"{{vm.field.label}}\" mdp-open-on-click=\"false\" ng-model=\"model\" \nname=\"{{vm.field.name}}\" ng-change=\"vm.dateToString(model)\" mdp-disabled=\"vm.field.readonly\"><div \nng-messages=\"vm.form[vm.field.name].$error\"><div ng-message=\"required\" \nng-if=\"vm.field.required && !vm.ngModel[vm.field.name]\">Date is required</div><div ng-message=\"format\">\nFormat must be {{vm.field.format ? vm.field.format : \'MM-DD-YYYY\'}}</div></div></mdp-date-picker></div>");
$templateCache.put("app/core/directives/qiu-field/templates/integer.html","<md-input-container flex class=\"md-block\"><label>{{vm.field.label}}</label><input ng-if=\"vm.ngModel\" \nng-disabled=\"vm.field.readonly\" type=\"number\" min=\"0\" name=\"{{vm.field.name}}\" ng-pattern=\"/^[0-9][0-9]*$/\" \nng-model=\"vm.ngModel[vm.field.name]\" ng-required=\"vm.field.required ? true : false\"><div \nng-messages=\"vm.form[vm.field.name].$error\" md-auto-hide=\"false\"><div ng-message=\"pattern\">\nOnly unsigned integers allowed</div><div ng-message=\"required\" ng-if=\"vm.field.required && !vm.ngModel[vm.field.name]\">\nValue is required</div></div></md-input-container>");
$templateCache.put("app/core/directives/qiu-field/templates/list.html","<md-input-container flex ng-if=\"vm.ngModel && vm.field && vm.field.options\" class=\"md-block\"><label>{{vm.field.label}}\n</label><md-select name=\"{{vm.field.name}}\" ng-model=\"vm.ngModel[vm.field.name]\" \nng-required=\"vm.field.required ? true : false\" aria-label=\"vm.field.label\" ng-disabled=\"vm.field.readonly\" \ntabindex=\"0\"><md-option ng-repeat=\"opt in vm.field.options\" ng-value=\"vm.hasProp(opt,\'value\') ? opt.value : opt\" \nng-selected=\"vm.isSelectedOption(opt)\">{{vm.hasProp(opt,\'name\') ? opt.name : opt}}</md-option></md-select><div \nng-messages=\"vm.form[vm.field.name].$error\" md-auto-hide=\"false\" class=\"md-errors-spacer\"><div ng-message=\"required\" \nng-if=\"vm.field.required && !vm.ngModel[vm.field.name]\">Value is required</div></div></md-input-container>");
$templateCache.put("app/core/directives/qiu-field/templates/media.html","<md-input-container flex class=\"md-block\"><media ng-repeat=\"media in vm.ngModel[vm.field.name]\" attachment=\"media\" \nclass-img=\"image\" ng-click=\"vm.selectMedia($event)\"></media></md-input-container>");
$templateCache.put("app/core/directives/qiu-field/templates/radio.html","<md-input-container flex class=\"radio-button md-input-has-value\"><label>{{vm.field.label}}</label><md-radio-group \nname=\"{{vm.field.name}}\" ng-required=\"vm.field.required ? true : false\" ng-disabled=\"vm.field.readonly\" \nng-model=\"vm.ngModel[vm.field.name]\"><md-radio-button class=\"mr-15\" ng-repeat=\"opt in vm.field.options\" \nng-value=\"vm.hasProp(opt, \'key\') ? opt.key : opt\" aria-label=\"vm.field.name\">\n{{(vm.hasProp(opt, \'value\')) ? opt.value : opt}}</md-radio-button></md-radio-group><div \nng-messages=\"vm.form[vm.field.name].$error\" md-auto-hide=\"false\"><div ng-message=\"required\" \nng-if=\"vm.field.required && !vm.ngModel[vm.field.name]\">Value is required</div></div></md-input-container>");
$templateCache.put("app/core/directives/qiu-field/templates/single.html","<md-input-container flex class=\"md-block\"><label for=\"{{vm.field.name}}\">{{vm.field.label}}</label><input type=\"text\" \nclass=\"single-template\" ng-if=\"vm.ngModel\" ng-disabled=\"vm.field.readonly\" ng-model=\"vm.ngModel[vm.field.name]\" \nng-required=\"vm.field.required ? true : false\" name=\"{{vm.field.name}}\"><div \nng-messages=\"vm.form[vm.field.name].$error\" md-auto-hide=\"false\"><div ng-message=\"required\" \nng-if=\"vm.field.required && !vm.ngModel[vm.field.name]\">Value is required</div></div></md-input-container>");
$templateCache.put("app/core/directives/qiu-field/templates/templates.html","<md-input-container flex ng-if=\"vm.ngModel && vm.field && vm.field.options\" class=\"md-block\"><label>{{vm.field.label}}\n</label><md-select name=\"{{vm.field.name}}\" ng-model=\"vm.ngModel[vm.field.name]\" \nng-required=\"vm.field.required ? true : false\" aria-label=\"vm.field.label\" ng-disabled=\"vm.field.readonly\" \ntabindex=\"0\"><md-option ng-repeat=\"opt in vm.field.options track by vm.optKey(opt)\" \nng-value=\"vm.hasProp(opt,\'value\') ? opt.value : opt\" ng-selected=\"vm.isSelectedOption(opt)\">\n{{vm.hasProp(opt,\'name\') ? opt.name : opt}}</md-option></md-select><div ng-messages=\"vm.form[vm.field.name].$error\" \nmd-auto-hide=\"false\" class=\"md-errors-spacer\"><div ng-message=\"required\" \nng-if=\"vm.field.required && !vm.ngModel[vm.field.name]\">Value is required</div></div><div class=\"mt-30\"><div \nng-if=\"vm.selectedListOption()\" ng-repeat=\"field in vm.selectedListOption().fields\"><ng-container \nng-switch=\"field.type\"><div ng-switch-when=\"single\"><md-input-container flex class=\"md-block\"><label \nfor=\"{{field.name}}\">{{field.label}}</label><input type=\"text\" class=\"single-template\" ng-if=\"vm.ngModel\" \nng-disabled=\"field.readonly\" ng-model=\"vm.ngModel[field.name]\" ng-required=\"field.required ? true : false\" \nname=\"{{field.name}}\"><div ng-messages=\"vm.form[field.name].$error\" md-auto-hide=\"false\"><div ng-message=\"required\" \nng-if=\"field.required && !vm.ngModel[field.name]\">Value is required</div></div></md-input-container></div><div \nng-switch-when=\"text\"><md-input-container flex class=\"md-block\"><label for=\"{{field.name}}\">{{field.label}}</label>\n<textarea ui-tinymce=\"vm.tinymceOptions\" ng-model=\"vm.ngModel[field.name]\" aria-label=\"{{fields.titleId}}\" \nplaceholder=\"{{fields.field_name}}\" ng-required=\"field.required ? true : false\" md-no-autogrow=\"false\" \nclass=\"text-template\" ng-if=\"vm.ngModel\" ng-disabled=\"field.readonly\" columns=\"1\" name=\"{{field.name}}\"></textarea><div\n ng-messages=\"vm.form[field.name].$error\" md-auto-hide=\"false\"><div ng-message=\"required\" \nng-if=\"field.required && !vm.ngModel[field.name]\">Value is required</div></div></md-input-container></div><div \nclass=\"mt-15 mb-15\" ng-switch-when=\"media\"><md-input-container flex class=\"md-block\"><label for=\"{{field.name}}\">\n{{field.label}}</label><media ng-repeat=\"media in vm.ngModel[field.name]\" attachment=\"media\" class-img=\"image\" \nclass=\"w-500\" ng-click=\"vm.selectMedia($event, field.name)\"></media></md-input-container></div><div \nng-switch-when=\"list\"><md-input-container flex ng-if=\"vm.ngModel && field && field.options\" class=\"md-block\"><label>\n{{ field.label }}</label><md-select name=\"{{ field.name }}\" ng-model=\"vm.ngModel[field.name]\" \nng-required=\"field.required ? true : false\" aria-label=\"{{ field.label }}\" ng-disabled=\"field.readonly\" tabindex=\"0\">\n<md-option ng-repeat=\"opt in field.options track by vm.optKey(opt)\" \nng-value=\"vm.hasProp(opt,\'value\') ? opt.value : opt\">{{ vm.hasProp(opt,\'name\') ? opt.name : opt }}</md-option>\n</md-select><div ng-messages=\"vm.form[field.name].$error\" md-auto-hide=\"false\" class=\"md-errors-spacer\"><div \nng-message=\"required\" ng-if=\"field.required && !vm.ngModel[field.name]\">Value is required</div></div>\n</md-input-container></div><div ng-switch-default><span>Error {{field.label}}</span></div></ng-container></div></div>\n</md-input-container>");
$templateCache.put("app/core/directives/qiu-field/templates/text.html","<md-input-container flex class=\"md-block\"><label for=\"{{vm.field.name}}\">{{vm.field.label}}</label><textarea \nui-tinymce=\"vm.tinymceOptions\" ng-model=\"vm.ngModel[vm.field.name]\" aria-label=\"{{fields.titleId}}\" \nplaceholder=\"{{fields.field_name}}\" ng-required=\"vm.field.required ? true : false\" md-no-autogrow=\"false\" \nclass=\"text-template\" ng-if=\"vm.ngModel\" ng-disabled=\"vm.field.readonly\" columns=\"1\" name=\"{{vm.field.name}}\">\n</textarea><div ng-messages=\"vm.form[vm.field.name].$error\" md-auto-hide=\"false\"><div ng-message=\"required\" \nng-if=\"vm.field.required && !vm.ngModel[vm.field.name]\">Value is required</div></div></md-input-container>");
$templateCache.put("app/core/directives/qiu-field/templates/time.html","<div flex class=\"date-container date\"><mdp-time-picker ng-init=\"model = vm.stringToTime(vm.ngModel[vm.field.name])\" \nng-required=\"vm.field.required ? true : false\" mdp-format-show=\"{{vm.field.format ? vm.field.format : \'HH:mm\'}}\" \nmdp-format=\"HH:mm\" mdp-placeholder=\"{{vm.field.label}}\" mdp-open-on-click=\"false\" ng-model=\"model\" \nname=\"{{vm.field.name}}\" ng-change=\"vm.timeToString(model)\" mdp-disabled=\"vm.field.readonly\"><div \nng-messages=\"vm.form[vm.field.name].$error\"><div ng-message=\"required\" \nng-if=\"vm.field.required && !vm.ngModel[vm.field.name]\">Date is required</div><div ng-message=\"format\">\nFormat must be {{vm.field.format ? vm.field.format : \'hh:mm\'}}</div></div></mdp-time-picker></div>");
$templateCache.put("app/core/directives/qiu-tree/tree-item/tree-item.html","<div class=\"gallery-row\"><div layout=\"column\"><div ng-if=\"item.id_gallery\" \nmd-prevent-menu-close=\"md-prevent-menu-close\" ng-click=\"vm.select(vm.item);\" class=\"level-card\" \nng-class=\"{\'selected\' : vm.selectedid == vm.item.id_gallery}\" layout=\"row\" layout-align=\"start center\" droppable \ndata-gallery-id=\"{{item.id_gallery}}\"><md-icon md-prevent-menu-close=\"md-prevent-menu-close\" \nng-click=\"vm.expand(vm.item); $event.stopPropagation();\" ng-if=\"vm.item.children && !vm.expanded\" \nmd-svg-icon=\"assets/angular-material-assets/img/icons/ic_chevron_right_24px.svg\" class=\"md-default-theme arrow\" \nrole=\"img\" aria-label=\"assets/angular-material-assets/img/icons/ic_chevron_right_24px.svg\"><svg version=\"1.1\" \nxmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"100%\" \nheight=\"100%\" viewBox=\"0 0 24 24\" enable-background=\"new 0 0 24 24\" xml:space=\"preserve\" fit=\"\" \npreserveAspectRatio=\"xMidYMid meet\" focusable=\"false\"><g id=\"Header\"><g><rect x=\"-618\" y=\"-1336\" fill=\"none\" \nwidth=\"1400\" height=\"3600\"></rect></g></g><g id=\"Label\"></g><g id=\"Icon\"><g><polygon \npoints=\"10,6 8.6,7.4 13.2,12 8.6,16.6 10,18 16,12\"></polygon><rect fill=\"none\" width=\"24\" height=\"24\"></rect></g></g><g\n id=\"Grid\" display=\"none\"><g display=\"inline\"></g></g></svg></md-icon><md-icon \nmd-prevent-menu-close=\"md-prevent-menu-close\" ng-click=\"vm.collapse(vm.item); $event.stopPropagation();\" \nng-if=\"vm.item.children && vm.expanded\" \nmd-svg-icon=\"assets/angular-material-assets/img/icons/ic_expand_more_black_24px.svg\" class=\"md-default-theme arrow\" \nrole=\"img\" aria-label=\"assets/angular-material-assets/img/icons/ic_expand_more_black_24px.svg\"><svg fill=\"#757575\" \nheight=\"100%\" viewBox=\"0 0 24 24\" width=\"100%\" xmlns=\"http://www.w3.org/2000/svg\" fit=\"\" \npreserveAspectRatio=\"xMidYMid meet\" focusable=\"false\"><path d=\"M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z\"></path>\n<path d=\"M0 0h24v24H0z\" fill=\"none\"></path></svg></md-icon><md-icon \nng-if=\"!vm.item.children && vm.item.gallery_type == 0\" md-font-icon=\"icon-folder\" class=\"s24 mr-10 mt-0 ml-0 mb-0\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"!vm.item.children && vm.item.gallery_type == 1\" \nmd-font-icon=\"icon-folder-image\" class=\"s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"!vm.item.children && vm.item.gallery_type == 2\" md-font-icon=\"qiu-icon-video-folder\" \nclass=\"s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"!vm.item.children && vm.item.gallery_type == 3\" md-font-icon=\"qiu-icon-audio-folder\" \nclass=\"s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"!vm.item.children && vm.item.gallery_type == 4\" md-font-icon=\"qiu-icon-file-folder\" \nclass=\"s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"vm.item.children && vm.item.gallery_type == 0\" md-font-icon=\"icon-folder-multiple\" \nclass=\"s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"vm.item.children && vm.item.gallery_type == 1\" md-font-icon=\"icon-folder-multiple-image\" \nclass=\"s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"vm.item.children && vm.item.gallery_type == 2\" md-font-icon=\"qiu-icon-video-gallery\" \nclass=\"s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"vm.item.children && vm.item.gallery_type == 3\" md-font-icon=\"qiu-icon-audio-gallery\" \nclass=\"s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"vm.item.children && vm.item.gallery_type == 4\" md-font-icon=\"qiu-icon-file-gallery\" \nclass=\"s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><div class=\"group-status green-bg\" \nng-if=\"vm.item.status === 1 || (vm.item.isMediahub && vm.item.onoff === 1)\" role=\"button\" aria-label=\"group-status\">\n</div><span class=\"ivh-treeview-node-label ng-binding\">{{ vm.item.gallery_name? vm.item.gallery_name: vm.item.name }}\n</span><md-icon ng-if=\"!iscombo\" ng-click=\"vm.edit(vm.item, vm.parent); $event.stopPropagation();\" \nmd-font-icon=\"icon-pencil\" aria-hidden=\"true\" class=\"ng-scope md-default-theme md-font material-icons icon-pencil\" \nrole=\"img\"></md-icon><span ng-if=\"vm.item.is_lightbox\" class=\"lightbox-item\">{{vm.item.owner.email}}</span></div><div \nng-if=\"item.id_group\" md-prevent-menu-close=\"md-prevent-menu-close\" ng-click=\"vm.onRowClick(vm.item, $event);\" \nclass=\"level-card\" \nng-class=\"{\r\n               \'selected\': iscombo ? !!vm.selectedIds[vm.item.id_group] : (vm.selectedid == vm.item.id_group)\r\n             }\" \nlayout=\"row\" layout-align=\"start center\"><md-checkbox ng-if=\"iscombo\" md-prevent-menu-close=\"md-prevent-menu-close\" \nng-checked=\"!!vm.selectedIds[vm.item.id_group]\" ng-click=\"vm.toggleFromCheckbox(vm.item, $event)\" \naria-label=\"Select group\"></md-checkbox><div ng-if=\"item.group_type.icon\"><md-icon ng-if=\"item.group_type.icon\" \nclass=\"{{item.color}}-fg s24 mr-10 mt-0 ml-0 mb-0\" md-font-icon=\"{{item.group_type.icon}}\" aria-hidden=\"true\">\n</md-icon></div><div ng-if=\"!item.group_type.icon\"><md-icon ng-if=\"!item.children && item.id_group_type == 1\" \nmd-font-icon=\"icon-folder\" class=\"{{item.color}}-fg s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"item.children && item.id_group_type == 1\" md-font-icon=\"icon-folder-multiple\" \nclass=\"{{item.color}}-fg s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"!item.children && item.id_group_type == 2\" md-font-icon=\"qiu-icon-file-usermailing\" \nclass=\"{{item.color}}-fg s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"item.children && item.id_group_type == 2\" class=\"{{item.color}}-fg s24 mr-10 mt-0 ml-0 mb-0\" \nmd-svg-src=\"/assets/icons/svg/icon-folder-mail-multiple.svg\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"!item.children && item.id_group_type == 3\" class=\"{{item.color}}-fg s24 mr-10 mt-0 ml-0 mb-0\" \nmd-font-icon=\"qiu-icon-file-usermediacenter\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"item.children && item.id_group_type == 3\" class=\"{{item.color}}-fg s24 mr-10 mt-0 ml-0 mb-0\" \nmd-svg-src=\"/assets/icons/svg/icon-folder-play-multiple.svg\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"!item.children && item.id_group_type == 4\" class=\"{{item.color}}-fg s24 mr-10 mt-0 ml-0 mb-0\" \nmd-font-icon=\"qiu-icon-file-usersegment\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"item.children && item.id_group_type == 4\" class=\"{{item.color}}-fg s24 mr-10 mt-0 ml-0 mb-0\" \nmd-svg-src=\"/assets/icons/svg/icon-folder-share-multiple.svg\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"!item.children && item.id_group_type == 5\" class=\"{{item.color}}-fg s24 mr-10 mt-0 ml-0 mb-0\" \nmd-font-icon=\"qiu-icon-file-userstore\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"item.children && item.id_group_type == 5\" class=\"{{item.color}}-fg s24 mr-10 mt-0 ml-0 mb-0\" \nmd-svg-src=\"/assets/icons/svg/icon-folder-shop-multiple.svg\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"!item.children && item.id_group_type == 6\" class=\"{{item.color}}-fg s24 mr-10 mt-0 ml-0 mb-0\" \nmd-font-icon=\"qiu-icon-file-useracreditation\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"item.children && item.id_group_type == 6\" class=\"{{item.color}}-fg s24 mr-10 mt-0 ml-0 mb-0\" \nmd-svg-src=\"/assets/icons/svg/icon-folder-board-multiple.svg\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"!item.children && item.id_group_type == 7\" class=\"{{item.color}}-fg s24 mr-10 mt-0 ml-0 mb-0\" \nmd-svg-src=\"/assets/icons/svg/icon-folder-chat.svg\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"item.children && item.id_group_type == 7\" class=\"{{item.color}}-fg s24 mr-10 mt-0 ml-0 mb-0\" \nmd-svg-src=\"/assets/icons/svg/icon-folder-chat-multiple.svg\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"!item.children && item.id_group_type == 8\" class=\"{{item.color}}-fg s24 mr-10 mt-0 ml-0 mb-0\" \nmd-font-icon=\"icon-folder-remove\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"item.children && item.id_group_type == 8\" class=\"{{item.color}}-fg s24 mr-10 mt-0 ml-0 mb-0\" \nmd-font-icon=\"icon-folder-multiple\" aria-hidden=\"true\"></md-icon></div><span \nclass=\"ivh-treeview-node-label ng-binding\">{{vm.item.name}}</span></div><div class=\"children\" ng-if=\"vm.expanded\">\n<tree-item selectedid=\"vm.selectedid\" on-expand=\"vm.expand(item)\" on-collapse=\"vm.collapse(item)\" \nexpandedids=\"vm.expandedids\" iscombo=\"iscombo\" parent=\"vm.item\" on-select=\"vm.select(item )\" \non-edit=\"vm.edit(item, parent)\" ng-repeat=\"child in vm.item.children\" item=\"child\"></tree-item></div></div></div>");
$templateCache.put("app/main/apps/ai/views/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><ms-search-bar hide debounce=\"300\" \nmodel-search=\"$root.pagination_searchquery\" on-result-click=\"vm.searchResultClick(item)\" on-search=\"vm.search(query)\" \nlayout=\"row\" layout-align=\"start center\"></ms-search-bar><ms-search-bar-custom \nng-if=\"vm.currentTabView == \'recognized_profiles\'\" flex class=\"ms-search-bar\" debounce=\"300\" \nmodel-search=\"vm.searchString\" search-click=\"vm.searchClick\" search-clear=\"vm.searchClear\" layout=\"row\" \nlayout-align=\"start center\"></ms-search-bar-custom><md-button ng-disabled=\"!vm.currentEventTag\" aria-label=\"ADD NEW\" \nclass=\"md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme mr-30\" \nng-click=\"vm.AddmediaDialog()\" translate=\"AI.ADD\" type=\"button\"><span translate=\"AI.ADD\">Add new</span></md-button><div\n ng-if=\"vm.currentEventTag && vm.eventTags\"><md-select ng-model=\"vm.currentEventTag\" placeholder=\"Select Event\" \nclass=\"toolbar-item\" ng-change=\"vm.getItemsByEventTag(vm.currentEventTag)\"><md-option \nng-repeat=\"eventTag in vm.eventTags | orderBy: \'tag_name\'\" ng-value=\"eventTag\">{{eventTag.tag_name}}</md-option>\n</md-select><md-tooltip><span translate=\"CONTENT.SELECT_PAGE\">Select page</span></md-tooltip></div></div><div \nlayout=\"row\" layout-align=\"start center\"><span class=\"page-info\" hide show-gt-xs=\"\">\n{{pagination_from}} - {{pagination_to}} of {{pagination_totalItems}} total items.</span><md-button \naria-label=\"Previous\" class=\"md-icon-button arrow\" ng-click=\"vm.pagination_prevPage()\" \nng-disabled=\"pagination_firstPage()\" translate=\"\" translate-attr-aria-label=\"CONTENT.PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span translate=\"CONTENT.PREVIOUS\">Previous</span></md-tooltip>\n</md-button><div class=\"page-selector\" hide show-gt-xs><md-select style=\"margin: 0; padding: 0\" \nng-model=\"pagination_page\" placeholder=\"Page\" class=\"toolbar-item\"><md-option \nng-repeat=\"n in [].constructor(pagination_total_pages) track by $index\" value=\"{{$index +1}}\" \nng-click=\"pagination_gotoPage($index+1)\">{{$index+1}}</md-option></md-select><md-tooltip><span \ntranslate=\"CONTENT.SELECT_PAGE\">Select page</span></md-tooltip></div><span class=\"page-info ml-10\" hide=\"\" \nshow-gt-xs=\"\">/ <span class=\"ml-5\">{{pagination_total_pages | number}}</span></span><md-button aria-label=\"Next\" \nclass=\"md-icon-button arrow\" ng-click=\"vm.pagination_nextPage()\" ng-disabled=\"pagination_morePages()\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span \ntranslate=\"CONTENT.NEXT\">Next</span></md-tooltip></md-button><div class=\"divider-vertical\"></div><div \nclass=\"limit-select mr-10 ml-10 qiu-pagination\" ng-if=\"!isLoading\"><md-select class=\"md-table-select\" \nng-change=\"vm.setNewPerPageSize(vm.perPage)\" ng-model=\"vm.perPage\" md-container-class=\"md-pagination-select\" \naria-label=\"Rows\" placeholder=\"{{ $pagination.limitOptions[0] }}\"><md-option ng-repeat=\"p in perPagePresets\" \nng-value=\"p\">{{p}} {{::option.label ? option.label : option}}</md-option></md-select><md-tooltip hide show-gt-xs><span \ntranslate=\"CONTENT.ITEMS_PER_PAGE\">Items per page</span></md-tooltip></div></div>");
$templateCache.put("app/main/apps/backend/views/edit-tabs.html","<div class=\"mail-content file-details scrollable\" ms-scroll=\"vm.msScrollOptions\"><md-list><md-list-item \nng-if=\"vm.selectedContentID\" class=\"main-item\"><div class=\"main-read\"><div class=\"avatar-container\"><div \nng-if=\"(vm.selectedContent.avatar == \'\' || !vm.selectedContent.avatar)\" class=\"avatar\" \nng-bind=\"vm.selectedContent.first_name | capitalizeFirstLetter\" \nstyle=\"background-color:{{vm.selectedContent.profile_color}}\"></div><div ng-if=\"vm.selectedContent.avatar\" \nattachment=\"vm.selectedContent.avatar\"><img class=\"avatar hide show spinner-show\" \nng-src=\"{{vm.selectedContent.avatar}}\" imageonload=\"\"></div><md-icon ng-if=\"vm.selectedContent.active ===1\" \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\"></md-icon><md-icon \nng-if=\"vm.selectedContent.active !==1\" md-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\">\n</md-icon></div></div><div class=\"main-read\"><h1 class=\"name\"><strong ng-bind-html=\"vm.selectedContent.first_name\">\n</strong> <strong ng-bind-html=\"vm.selectedContent.last_name\"></strong></h1><p><span \nclass=\"font-size-16 text-truncate\" ng-bind-html=\"vm.selectedContent.email\"></span></p><md-divider></md-divider></div>\n</md-list-item><div ng-repeat=\"virtualgroup in vm.customData.virtualgroups\" ng-init=\"vm.sortableOpt(virtualgroup)\">\n<md-list-item class=\"md-toolbar-tools grey-100-bg\"><div layout=\"row\" layout-align=\"start center\" class=\"flex-50\"><h3 \nclass=\"grey-700-fg\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon \" \nng-class=\"virtualgroup.icon\" class=\"mr-8\"></md-icon><span>{{virtualgroup.name}}</span></h3></div><div layout=\"row\" \nlayout-align=\"end center\" class=\"flex-50\"><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"ACCOUNTS.ADDTABS\" ng-click=\"vm.openTabSelect($event, virtualgroup)\"><md-icon \nmd-font-icon=\"icon-cog\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"ACCOUNTS.ADD_REMOVE\">Add/remove sections\n</span></md-tooltip></md-button></div><md-divider></md-divider></md-list-item><div class=\"virtualgroups-items\" \nng-sortable=\"vm.sortableOptions[virtualgroup.id_virtualgroup]\"><md-list-item flex=\"100\" class=\"virtualgroups-item\" \nlayout=\"row\" layout-align=\"start center\" \nng-repeat=\"tab in vm.sortableTabs[virtualgroup.id_virtualgroup] | orderBy: \'sort\'\"><div class=\"handle ml-8 mr-8\" \nng-click=\"vm.preventDefault($event)\"><md-icon md-font-icon=\"icon-drag-vertical\" class=\"icon\"></md-icon></div><div \nclass=\"text-truncate\" flex=\"100\"><div class=\"field\"><md-icon md-font-icon=\"icon\" ng-class=\"vm.getTabIcon(tab)\" \nclass=\"mr-5 grey-600-fg\"></md-icon><span ng-bind-html=\"vm.getTabName(tab)\" class=\"grey-800-fg\"></span></div></div>\n<md-divider></md-divider></md-list-item></div></div></md-list></div>");
$templateCache.put("app/main/apps/content/backend/sections.html","<h1>List</h1>");
$templateCache.put("app/main/apps/content/share-designs/share-card-editor.html","<div class=\"share-card-editor\"><div class=\"sce-prev\" ng-style=\"previewStyle()\"><span class=\"sce-glow\" \nng-style=\"glowStyle()\"></span> <span class=\"sce-ov\" ng-style=\"overlayStyle()\"></span> <img class=\"sce-logoimg\" \nng-if=\"show(\'show_logo\') && record.logo\" ng-src=\"{{ record.logo }}\" alt=\"\"> <span class=\"sce-logo\" \nng-if=\"show(\'show_logo\') && !record.logo\">LOGO</span> <span class=\"sce-title\" ng-if=\"show(\'show_title\')\" \nng-style=\"titleStyle()\">{{ previewTitle() || (\'CONTENT.CARD_TITLE_PH\' | translate) }}</span> <span class=\"sce-desc\" \nng-if=\"show(\'show_description\')\" ng-style=\"titleStyle()\" translate=\"CONTENT.CARD_DESC_PH\"></span> <span \nclass=\"sce-bar\" ng-style=\"barStyle()\"></span></div><div ng-if=\"!readonly\"><div class=\"sce-row\" ng-if=\"!hideName\"><label\n class=\"sce-lab\" translate=\"CONTENT.CARD_NAME\"></label><input class=\"sce-input\" type=\"text\" ng-model=\"record.title\" \nng-change=\"markDirty()\" placeholder=\"{{ \'CONTENT.CARD_NAME_PH\' | translate }}\"></div><div class=\"sce-row\"><label \nclass=\"sce-lab\" translate=\"CONTENT.CARD_STYLE\"></label><div class=\"sce-seg\"><button type=\"button\" \nng-class=\"{\'sce-on\': record.style==\'glow\'}\" ng-click=\"setStyle(\'glow\')\" translate=\"CONTENT.CARD_STYLE_DARK\"></button> \n<button type=\"button\" ng-class=\"{\'sce-on\': record.style==\'fill\'}\" ng-click=\"setStyle(\'fill\')\" \ntranslate=\"CONTENT.CARD_STYLE_COLOR\"></button> <button type=\"button\" ng-class=\"{\'sce-on\': record.style==\'image\'}\" \nng-click=\"setStyle(\'image\')\" translate=\"CONTENT.CARD_STYLE_IMAGE\"></button></div></div><div class=\"sce-row\"><label \nclass=\"sce-lab\">{{ (record.style==\'image\' ? \'CONTENT.CARD_BAR_COLOR\' : \'CONTENT.CARD_COLOR\') | translate }}</label><div\n class=\"sce-sw\"><button type=\"button\" class=\"sce-swatch\" ng-repeat=\"c in palette\" ng-style=\"{background:c}\" \nng-class=\"{\'sce-selc\': record.color==c}\" ng-click=\"setColor(c)\"></button> <input class=\"sce-color\" type=\"color\" \nng-model=\"record.color\" ng-change=\"markDirty()\" title=\"{{ \'CONTENT.CARD_CUSTOM_COLOR\' | translate }}\"> <input \nclass=\"sce-hex\" type=\"text\" ng-model=\"record.color\" ng-change=\"markDirty()\" placeholder=\"#RRGGBB\" maxlength=\"7\"></div>\n</div><div class=\"sce-row sce-media-row\"><div class=\"sce-media-item\"><label class=\"sce-lab\" \ntranslate=\"CONTENT.CARD_LOGO\"></label><div class=\"sce-tile\" ng-class=\"{\'sce-tile-set\': record.logo}\" \nng-click=\"selectLogo($event)\" title=\"{{ \'CONTENT.CARD_PICK_LOGO\' | translate }}\"><img ng-if=\"record.logo\" \nng-src=\"{{ record.logo }}\" alt=\"\"><md-icon ng-if=\"!record.logo\" md-font-icon=\"icon-image\" class=\"s32\"></md-icon><button\n type=\"button\" class=\"sce-tile-x\" ng-if=\"record.logo\" ng-click=\"clearLogo(); $event.stopPropagation();\" \naria-label=\"{{ \'CONTENT.CARD_CLEAR\' | translate }}\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></button>\n</div></div><div class=\"sce-media-item\"><label class=\"sce-lab\" translate=\"CONTENT.CARD_BG_LABEL\"></label><div \nclass=\"sce-tile sce-tile-cover\" ng-class=\"{\'sce-tile-set\': record.background}\" ng-click=\"selectBackground($event)\" \ntitle=\"{{ \'CONTENT.CARD_PICK_IMAGE\' | translate }}\"><img ng-if=\"record.background\" ng-src=\"{{ record.background }}\" \nalt=\"\"><md-icon ng-if=\"!record.background\" md-font-icon=\"icon-image\" class=\"s32\"></md-icon><button type=\"button\" \nclass=\"sce-tile-x\" ng-if=\"record.background\" ng-click=\"clearBackground(); $event.stopPropagation();\" \naria-label=\"{{ \'CONTENT.CARD_CLEAR\' | translate }}\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></button>\n</div></div></div><div class=\"sce-row sce-row-select\"><md-input-container class=\"md-block sce-select\"><label \ntranslate=\"CONTENT.CARD_FONT\"></label><md-select ng-model=\"record.font\" ng-change=\"markDirty()\"><md-option \nng-repeat=\"f in cardFonts\" ng-value=\"f.url\" ng-style=\"fontStyle(f)\">{{ f.family }}</md-option></md-select>\n</md-input-container></div><div class=\"sce-row\"><label class=\"sce-lab\" translate=\"CONTENT.CARD_SHOW\"></label><div \nclass=\"sce-flags\"><md-switch class=\"md-primary\" ng-model=\"record.show_logo\" ng-change=\"markDirty()\" ng-true-value=\"1\" \nng-false-value=\"0\">{{ \'CONTENT.CARD_SHOW_LOGO\' | translate }}</md-switch><md-switch class=\"md-primary\" \nng-model=\"record.show_title\" ng-change=\"markDirty()\" ng-true-value=\"1\" ng-false-value=\"0\">\n{{ \'CONTENT.CARD_SHOW_TITLE\' | translate }}</md-switch><md-switch class=\"md-primary\" \nng-model=\"record.show_description\" ng-change=\"markDirty()\" ng-true-value=\"1\" ng-false-value=\"0\">\n{{ \'CONTENT.CARD_SHOW_DESC\' | translate }}</md-switch></div><p class=\"sce-hint\" translate=\"CONTENT.CARD_SHOW_HINT\"></p>\n</div><div class=\"sce-row sce-flags\"><md-switch class=\"md-primary\" ng-model=\"record.use_first_image\" \nng-change=\"markDirty()\" ng-true-value=\"1\" ng-false-value=\"0\">{{ \'CONTENT.CARD_USE_FIRST_IMAGE\' | translate }}\n</md-switch></div><p class=\"sce-hint\" translate=\"CONTENT.CARD_USE_FIRST_IMAGE_HINT\"></p><div class=\"sce-row sce-flags\" \nng-if=\"!hideName\"><md-switch class=\"md-primary\" ng-model=\"record.onoff\" ng-change=\"markDirty()\" ng-true-value=\"1\" \nng-false-value=\"0\">{{ \'CONTENT.CARD_ACTIVE\' | translate }}</md-switch><md-switch class=\"md-primary\" \nng-model=\"record.is_default\" ng-change=\"markDirty()\" ng-true-value=\"1\" ng-false-value=\"0\">\n{{ \'CONTENT.CARD_USE_DEFAULT\' | translate }}</md-switch></div></div></div>");
$templateCache.put("app/main/apps/forms/dialogs/dropzone-options-dialog.controller.html","<md-dialog class=\"dropzone-dialog\" id=\"dropzone-dialog\" aria-label=\"New Task\"><form name=\"taskForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between\"><h1 class=\"title\" translate=\"{{vm.title}}\"></h1><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout=\"column\" layout-align=\"start\" class=\"p-15\"><md-input-container \nclass=\"md-block\" flex><label translate=\"FORMS.MAX_FILESIZE_MB\"></label><input \nng-model=\"vm.optionsSelected.maxFilesize\" columns=\"1\" rows=\"1\"></md-input-container><md-input-container \nclass=\"md-block\" flex><label translate=\"FORMS.DROPZONE_ACCEPTED_FILES\"></label><input \nng-model=\"vm.optionsSelected.acceptedFiles\" columns=\"1\" rows=\"1\"></md-input-container><md-input-container \nclass=\"md-block\" flex><label translate=\"FORMS.PREVIEW_TEMPLATE\"></label><textarea \nng-model=\"vm.optionsSelected.previewTemplate\"></textarea></md-input-container><md-input-container class=\"md-block\" \nflex><label translate=\"FORMS.DROPZONE_ERROR_TOO_BIG\"></label><textarea ng-model=\"vm.optionsSelected.dictFileTooBig\">\n</textarea></md-input-container><md-input-container class=\"md-block\" flex><label \ntranslate=\"FORMS.DROPZONE_ERROR_FILETYPE\"></label><textarea ng-model=\"vm.optionsSelected.dictInvalidFileType\">\n</textarea></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-=\"end\">\n<md-input-container flex layout=\"row\" layout-align=\"end center\"><md-button type=\"submit\" \nclass=\"send-button md-accent md-raised\" ng-click=\"vm.saveDialog()\" translate=\"FORMS.SAVE\">SAVE</md-button><md-button \ntype=\"button\" class=\"md-raised md-warn\" ng-click=\"vm.closeDialog()\" translate=\"FORMS.CANCEL\">Cancel</md-button>\n</md-input-container></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/forms/dialogs/options-dialog.html","<md-dialog class=\"options-dialog\" aria-label=\"New Task\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between\"><h1 \nclass=\"title\" translate=\"{{vm.title}}\"></h1><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><div class=\"content\"><md-input-container ng-if=\"vm.arrayName == \'datepickerOptions\'\" class=\"md-block\">\n<md-checkbox ng-model=\"vm.field.templateOptions.showWeeks\"></md-checkbox><span translate=\"FORMS.SHOW_WEEKS\"></span>\n</md-input-container><div layout=\"row\" layout-align=\"start\"><md-input-container flex=\"50\" flex-sm=\"100\" \nclass=\"md-block\"><label translate=\"FORMS.VALUE\"></label><input ng-model=\"vm.option.value\" type=\"text\">\n</md-input-container><md-input-container flex=\"50\" flex-sm=\"100\" class=\"md-block\"><label translate=\"FORMS.NAME\">\n</label><input ng-model=\"vm.option.name\" type=\"text\"></md-input-container><md-input-container flex=\"10\" flex-sm=\"100\" \nclass=\"md-block\"><md-button ng-disabled=\"!vm.option.value || !vm.option.name\" translate=\"FORMS.ADD\" \nng-class=\"{\'green-500-bg\': vm.option.value && vm.option.name}\" \nclass=\"md-accent md-raised md-button md-ink-ripple md-default-theme md-button show-gt-sm hide\" \nng-click=\"vm.addOption(vm.option)\"></md-button></md-input-container></div><table class=\"row-border hover simple\" \nms-responsive-table><thead><tr><th class=\"large\"><label translate=\"FORMS.VALUE\"></label></th><th class=\"large\"><label \ntranslate=\"FORMS.NAME\"></label></th><th class=\"mini\"></th></tr></thead><tbody><tr \nng-repeat=\"option in  vm.field.templateOptions[vm.arrayName]\"><td class=\"large\"><span>{{ option.value }}</span></td><td\n class=\"large\"><span>{{ option.name }}</span></td><td class=\"mini trash\"><md-icon \nng-click=\"vm.field.templateOptions[vm.arrayName].splice($index, 1)\" md-font-icon=\"icon-delete\"></md-icon><md-tooltip>\n<span translate=\"FORMS.DELETE\">Delete</span></md-tooltip></td></tr></tbody></table><div \nng-if=\"vm.field.templateOptions[vm.arrayName].length == 0\" class=\"no-items-message\" translate=\"FORMS.NO_ITEMS_OPTIONS\">\n</div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-=\"end\"><md-input-container flex layout=\"row\" \nlayout-align=\"end center\"><md-button type=\"submit\" class=\"send-button md-accent md-raised\" ng-click=\"vm.saveDialog()\" \ntranslate=\"FORMS.SAVE\">SAVE</md-button><md-button type=\"button\" class=\"md-raised md-warn\" ng-click=\"vm.closeDialog()\" \ntranslate=\"FORMS.CANCEL\">Cancel</md-button></md-input-container></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/forms/dialogs/usergroup-options-dialog.controller.html","<md-dialog class=\"usergroups-dialog\" aria-label=\"New Task\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between\"><h1 \nclass=\"title\" translate=\"{{vm.title}}\"></h1><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><div flex layout=\"column\" layout-align=\"center center\" ng-show=\"vm.loadingUserGroups\" \nclass=\"loading-container\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div>\n<div ng-show=\"!vm.loadingUserGroups\" layout=\"row\" layout-align=\"start\" class=\"p-15\"><md-input-container flex=\"50\" \nflex-sm=\"100\" class=\"md-block\"><label translate=\"FORMS.GROUP_TYPE\"></label><md-select \nng-change=\"vm.loadUserGroups(vm.groupTypeId, $index);   vm.groupTypeStatus = null;\" ng-model=\"vm.groupTypeId\">\n<md-option ng-repeat=\"type in vm.userGroupTypes\" ng-value=\"type.id_group_type\">{{type.name}}</md-option></md-select>\n</md-input-container><md-input-container ng-if=\"vm.groupTypeId\" flex=\"50\" flex-sm=\"100\" class=\"md-block\"><label \ntranslate=\"FORMS.STATUS\"></label><md-select ng-model=\"vm.groupTypeStatus\"><md-option \nng-repeat=\"type in vm.groupType.users_in_group_status\" ng-value=\"type.id_ingroup_status\">{{type.name}}</md-option>\n</md-select></md-input-container></div><p ng-if=\"!vm.loadingUserGroups && !vm.groupTypeId\" class=\"grey-700-fg ml-25\" \ntranslate=\"FORMS.HELP_USERS_GROUPS\"></p><p ng-if=\"!vm.loadingUserGroups && vm.groupTypeId && vm.options.length == 0\" \nclass=\"grey-700-fg ml-25\" translate=\"FORMS.NO_USERS_GROUPS\"></p><div ivh-treeview=\"vm.options\" class=\"treeview\"><script\n type=\"text/ng-template\">\n<div class=\"node\" title=\"{{trvw.label(node)}}\">\r\n                          <span ivh-treeview-toggle>\r\n                            <span ivh-treeview-twistie></span>\r\n                          </span>\r\n                          <md-checkbox\r\n                          aria-label=\"assign group\"\r\n                          ng-checked=\"node.checked == true\"\r\n                          qiu-on-check-toggle-assigned-group\r\n                          class=\"ml-5 mb-0\" />\r\n                         <span class=\"ivh-treeview-node-label\" ivh-treeview-toggle>\r\n                           {{trvw.label(node)}}\r\n                         </span>\r\n                         <div ivh-treeview-children></div>\r\n                       </div>\n</script></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-=\"end\"><md-input-container flex layout=\"row\" \nlayout-align=\"end center\"><md-button type=\"submit\" class=\"send-button md-accent md-raised\" ng-click=\"vm.saveDialog()\" \ntranslate=\"FORMS.SAVE\">SAVE</md-button><md-button type=\"button\" class=\"md-raised md-warn\" ng-click=\"vm.closeDialog()\" \ntranslate=\"FORMS.CANCEL\">Cancel</md-button></md-input-container></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/forms/dialogs/validations-dialog.html","<md-dialog class=\"validations-dialog\" aria-label=\"New Task\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between\"><h1 \nclass=\"title\" translate=\"FORMS.VALIDATIONS\"></h1><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon\n md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><md-tabs ms-scroll=\"vm.msScrollOptions\" class=\"scrollable\"><md-tab><md-tab-label>\n{{ vm.translate(\'FORMS.VALIDATIONS\')}}</md-tab-label><md-tab-body><div class=\"content\"><div layout=\"row\" \nlayout-align=\"start\"><md-input-container class=\"md-block\" flex=\"30\"><label translate=\"FORMS.MESSAGE_TYPE\"></label>\n<md-select ng-model=\"vm.validationObject.type\"><md-option ng-value=\"\'required\'\" translate=\"FORMS.REQUIRED\"></md-option>\n<md-option ng-value=\"\'passwordStrength\'\" translate=\"FORMS.PASSWORD_STRENGTH\"></md-option><md-option \nng-value=\"\'telVerify\'\" translate=\"FORMS.TEL_VERIFY\"></md-option><md-option ng-value=\"\'customVerify\'\" \ntranslate=\"FORMS.CUSTOM_VERIFY\"></md-option></md-select></md-input-container><md-input-container flex=\"55\" \nflex-sm=\"100\" class=\"md-block\"><textarea ng-model=\"vm.validationObject.data\" columns=\"1\" rows=\"1\"></textarea>\n</md-input-container><md-input-container flex=\"15\" flex-sm=\"100\" class=\"md-block\"><md-button \nng-disabled=\"!vm.validationObject.type && !vm.validationObject.data\" translate=\"FORMS.ADD\" \nng-class=\"{\'green-500-bg\': vm.validationObject.data || vm.validationObject.type}\" \nclass=\"md-accent md-raised md-button md-ink-ripple md-default-theme md-button show-gt-sm hide\" \nng-click=\"vm.addValidation(vm.validationObject)\"></md-button></md-input-container></div><table \nclass=\"row-border hover simple\" ms-responsive-table><thead><tr><th class=\"large\"><label translate=\"FORMS.VALIDATION\">\n</label></th><th class=\"mini\"></th><th class=\"mini\"></th></tr></thead><tbody><tr \nng-repeat=\"(key,message) in vm.field.validation.messages\"><td class=\"large\"><span>{{ key }}</span></td><td \nclass=\"large\"><span>{{ message.substring(2, message.length)}}</span></td><td class=\"mini trash\"><md-icon \nng-click=\"vm.removeValidation(key)\" md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"FORMS.DELETE\">\nDelete</span></md-tooltip></td></tr></tbody></table><div \nng-if=\"!vm.field.validation || vm.field.validation.messages.length == 0\" class=\"no-items-message\" \ntranslate=\"FORMS.NO_ITEMS_VALIDATIONS\"></div></div></md-tab-body></md-tab><md-tab><md-tab-label>\n{{ vm.translate(\'FORMS.VALIDATORS\')}}</md-tab-label><md-tab-body><div class=\"content\"><div layout=\"row\" \nlayout-align=\"start\"><md-input-container class=\"md-block\" flex=\"30\"><label translate=\"FORMS.MESSAGE_TYPE\"></label>\n<md-select ng-model=\"vm.validatorObject.type\"><md-option ng-value=\"\'passwordStrength\'\" \ntranslate=\"FORMS.PASSWORD_STRENGTH\"></md-option><md-option ng-value=\"\'slugCheck\'\" translate=\"FORMS.SLUG_CHECK\">\n</md-option><md-option ng-value=\"\'customVerify\'\" translate=\"FORMS.CUSTOM_VERIFY\"></md-option></md-select>\n</md-input-container><md-input-container flex=\"55\" flex-sm=\"100\" class=\"md-block\"><textarea \nng-model=\"vm.validatorObject.data\" columns=\"1\" rows=\"1\"></textarea></md-input-container><md-input-container flex=\"15\" \nflex-sm=\"100\" class=\"md-block\"><md-button ng-disabled=\"!vm.validatorObject.type && !vm.validatorObject.data\" \ntranslate=\"FORMS.ADD\" ng-class=\"{\'green-500-bg\': vm.validatorObject.data || vm.validatorObject.type}\" \nclass=\"md-accent md-raised md-button md-ink-ripple md-default-theme md-button show-gt-sm hide\" \nng-click=\"vm.addValidator(vm.validatorObject)\"></md-button></md-input-container></div>{{vm.field.validators | json}}\n<table class=\"row-border hover simple\" ms-responsive-table><thead><tr><th><label translate=\"FORMS.VALIDATORS\"></label>\n</th><th></th><th></th></tr></thead><tbody><tr ng-repeat=\"(key,message) in vm.field.validators\"><td class=\"large\">\n<span>{{ key }}</span></td><td class=\"large\"><span>{{ message.substring(2, message.length)}}</span></td><td \nclass=\"mini trash\"><md-icon ng-click=\"vm.removeValidator(key)\" md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span \ntranslate=\"FORMS.DELETE\">Delete</span></md-tooltip></td></tr></tbody></table><div ng-if=\"!vm.field.validators\" \nclass=\"no-items-message\" translate=\"FORMS.NO_ITEMS_VALIDATORS\"></div></div></md-tab-body></md-tab></md-tabs>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-=\"end\"><md-input-container flex layout=\"row\" \nlayout-align=\"end center\"><md-button type=\"submit\" class=\"send-button md-accent md-raised\" ng-click=\"vm.saveDialog()\" \ntranslate=\"FORMS.SAVE\">SAVE</md-button><md-button type=\"button\" class=\"md-raised md-warn\" ng-click=\"vm.closeDialog()\" \ntranslate=\"FORMS.CANCEL\">Cancel</md-button></md-input-container></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/mailing/pushNotifications/mailing.push_notifications.html","<div id=\"site-mailing\" class=\"page-layout carded left-sidenav\" layout=\"row\" md-no-ink><md-sidenav class=\"sidenav\" \nmd-component-id=\"main-sidenav\" ng-include=\"\'app/main/apps/mailing/sidenavs/main/main-sidenav.html\'\" ms-scroll \nms-sidenav-helper md-no-ink></md-sidenav><div class=\"center\" layout=\"column\" flex><div class=\"content-card\" \nng-class=\"vm.currentView\" layout=\"column\" flex ng-include=\"vm.views[vm.currentView]\" md-no-ink></div></div>\n<qiu-pagination collection=\"vm.contents\" url=\"\'http://\'\" fields-filters=\"refFilterables\" service=\"mailingService\" \nforce-section=\"content\" columns=\"refcolumns\" columns-grouped=\"refcolumnsgrouped\" style=\"display:none\" \nfields-search=\"refSearch\"></qiu-pagination></div>");
$templateCache.put("app/main/apps/maps/dialogs/export-obj-dialog.html","<md-dialog class=\"maps-export-dialog\" aria-label=\"{{ \'MAPS.EXPORT_OBJ\' | translate }}\"><md-dialog-content \nclass=\"md-dialog-content\"><h2 class=\"md-title\" translate=\"MAPS.EXPORT_TITLE\"></h2><p class=\"maps-export-desc\" \ntranslate=\"MAPS.EXPORT_DESC\"></p><md-checkbox ng-model=\"dlg.includeCity\" ng-disabled=\"dlg.working\" class=\"md-primary\">\n<span translate=\"MAPS.EXPORT_INCLUDE_CITY\"></span></md-checkbox><md-checkbox ng-model=\"dlg.includeTerrain\" \nng-disabled=\"dlg.working\" class=\"md-primary\"><span translate=\"MAPS.EXPORT_INCLUDE_TERRAIN\"></span></md-checkbox><p \nclass=\"maps-export-hint\" ng-if=\"dlg.includeTerrain\" translate=\"MAPS.EXPORT_TERRAIN_HINT\"></p><div \nng-if=\"dlg.includeCity || dlg.includeTerrain\" layout=\"column\" class=\"maps-export-radius\"><label \nclass=\"maps-export-radius-label\">{{ \'MAPS.EXPORT_RADIUS\' | translate }}: <strong>{{ dlg.radiusKm }} km</strong></label>\n<md-slider min=\"1\" max=\"5\" step=\"1\" ng-model=\"dlg.radiusKm\" ng-disabled=\"dlg.working\" aria-label=\"radius\"></md-slider>\n<p class=\"maps-export-hint\" ng-if=\"dlg.includeCity\" translate=\"MAPS.EXPORT_CITY_HINT\"></p></div><div \nng-if=\"dlg.working\" layout=\"row\" layout-align=\"start center\" class=\"maps-export-working\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"24\"></md-progress-circular><span translate=\"MAPS.EXPORT_WORKING\"></span></div><p \nng-if=\"dlg.error\" class=\"maps-export-error\" translate=\"MAPS.EXPORT_ERROR\"></p></md-dialog-content><md-dialog-actions>\n<md-button ng-click=\"dlg.cancel()\" ng-disabled=\"dlg.working\" translate=\"MAPS.CANCEL\"></md-button><md-button \nclass=\"md-primary md-raised\" ng-click=\"dlg.run()\" ng-disabled=\"dlg.working\" translate=\"MAPS.EXPORT_DO\"></md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/maps/dialogs/map-settings-dialog.html","<md-dialog class=\"maps-settings-dialog\" aria-label=\"{{ \'MAPS.SETTINGS_TITLE\' | translate }}\"><md-dialog-content \nclass=\"md-dialog-content\"><h2 class=\"md-title\" translate=\"MAPS.SETTINGS_TITLE\"></h2><p class=\"maps-settings-desc\" \ntranslate=\"MAPS.SETTINGS_DESC\"></p><div class=\"maps-settings-group\"><div class=\"maps-settings-group-title\" \ntranslate=\"MAPS.SETTINGS_ZOOM\"></div><label class=\"maps-settings-label\">{{ \'MAPS.ZOOM_MIN\' | translate }}: <strong>\n{{ dlg.limits.minZoom }}</strong></label><md-slider min=\"0\" max=\"24\" step=\"1\" ng-model=\"dlg.limits.minZoom\" \nng-change=\"dlg.change()\" aria-label=\"min zoom\"></md-slider><label class=\"maps-settings-label\">\n{{ \'MAPS.ZOOM_MAX\' | translate }}: <strong>{{ dlg.limits.maxZoom }}</strong></label><md-slider min=\"0\" max=\"24\" \nstep=\"1\" ng-model=\"dlg.limits.maxZoom\" ng-change=\"dlg.change()\" aria-label=\"max zoom\"></md-slider></div><div \nclass=\"maps-settings-group\"><div class=\"maps-settings-group-title\" translate=\"MAPS.SETTINGS_PITCH\"></div><label \nclass=\"maps-settings-label\">{{ \'MAPS.PITCH_MIN\' | translate }}: <strong>{{ dlg.limits.minPitch }}°</strong></label>\n<md-slider min=\"0\" max=\"85\" step=\"1\" ng-model=\"dlg.limits.minPitch\" ng-change=\"dlg.change()\" aria-label=\"min pitch\">\n</md-slider><label class=\"maps-settings-label\">{{ \'MAPS.PITCH_MAX\' | translate }}: <strong>{{ dlg.limits.maxPitch }}°\n</strong></label><md-slider min=\"0\" max=\"85\" step=\"1\" ng-model=\"dlg.limits.maxPitch\" ng-change=\"dlg.change()\" \naria-label=\"max pitch\"></md-slider></div><div class=\"maps-settings-group\"><div class=\"maps-settings-group-title\" \ntranslate=\"MAPS.SETTINGS_ZONE_OPACITY\"></div><label class=\"maps-settings-label\">\n{{ \'MAPS.ZONE_FILL_OPACITY\' | translate }}: <strong>{{ dlg.limits.zoneFillOpacity }}%</strong></label><md-slider \nmin=\"0\" max=\"100\" step=\"1\" ng-model=\"dlg.limits.zoneFillOpacity\" ng-change=\"dlg.change()\" \naria-label=\"zone fill opacity\"></md-slider><label class=\"maps-settings-label\">\n{{ \'MAPS.ZONE_EXTRUSION_OPACITY\' | translate }}: <strong>{{ dlg.limits.zoneExtrusionOpacity }}%</strong></label>\n<md-slider min=\"0\" max=\"100\" step=\"1\" ng-model=\"dlg.limits.zoneExtrusionOpacity\" ng-change=\"dlg.change()\" \naria-label=\"zone extrusion opacity\"></md-slider></div><div class=\"maps-settings-group\"><div \nclass=\"maps-settings-group-title\" translate=\"MAPS.SETTINGS_INTERACTION\"></div><md-switch \nng-model=\"dlg.limits.rotationLock\" ng-change=\"dlg.change()\" class=\"md-primary\"><span translate=\"MAPS.ROTATION_LOCK\">\n</span></md-switch><md-switch ng-model=\"dlg.limits.scrollZoomLock\" ng-change=\"dlg.change()\" class=\"md-primary\"><span \ntranslate=\"MAPS.SCROLL_ZOOM_LOCK\"></span></md-switch><md-switch ng-model=\"dlg.limits.dragPanLock\" \nng-change=\"dlg.change()\" class=\"md-primary\"><span translate=\"MAPS.DRAG_PAN_LOCK\"></span></md-switch><md-switch \nng-model=\"dlg.limits.hideNavControl\" ng-change=\"dlg.change()\" class=\"md-primary\"><span \ntranslate=\"MAPS.HIDE_NAV_CONTROL\"></span></md-switch></div><div class=\"maps-settings-group\"><div \nclass=\"maps-settings-group-title\" translate=\"MAPS.SETTINGS_INITIAL_VIEW\"></div><p class=\"maps-settings-hint\" \ntranslate=\"MAPS.SETTINGS_INITIAL_VIEW_HINT\"></p><md-button class=\"md-raised\" ng-click=\"dlg.setInitialView()\"><md-icon \nmd-font-icon=\"icon-map-marker\" class=\"s18\"></md-icon><span translate=\"MAPS.INITIAL_VIEW_SET_BTN\"></span></md-button>\n</div><div class=\"maps-settings-group\"><div class=\"maps-settings-group-title\" translate=\"MAPS.SETTINGS_BOUNDS\"></div><p\n class=\"maps-settings-hint\" translate=\"MAPS.SETTINGS_BOUNDS_HINT\"></p><div layout=\"row\" layout-align=\"start center\" \nlayout-wrap><md-button class=\"md-raised\" ng-click=\"dlg.setBoundsToCurrent()\"><md-icon md-font-icon=\"icon-crop\" \nclass=\"s18\"></md-icon><span translate=\"MAPS.BOUNDS_SET\"></span></md-button><md-button ng-click=\"dlg.clearBounds()\" \nng-disabled=\"!dlg.hasBounds()\" translate=\"MAPS.BOUNDS_CLEAR\"></md-button></div><div class=\"maps-settings-bounds-state\" \ntranslate=\"{{ dlg.hasBounds() ? \'MAPS.BOUNDS_ACTIVE\' : \'MAPS.BOUNDS_NONE\' }}\"></div></div></md-dialog-content>\n<md-dialog-actions><md-button ng-click=\"dlg.cancel()\" translate=\"MAPS.CANCEL\"></md-button><md-button \nclass=\"md-primary md-raised\" ng-click=\"dlg.close()\" translate=\"MAPS.DONE\"></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/maps/dialogs/style-editor-dialog.html","<md-dialog class=\"maps-style-dialog\" aria-label=\"{{ \'MAPS.STYLE_EDITOR_TITLE\' | translate }}\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"MAPS.STYLE_EDITOR_TITLE\"></h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"dlg.close()\" aria-label=\"{{ \'MAPS.CLOSE\' | translate }}\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"maps-style-body\" \nlayout=\"row\"><div class=\"maps-style-library\" layout=\"column\"><div class=\"maps-style-library-header\" \ntranslate=\"MAPS.STYLE_LIBRARY\"></div><md-button class=\"md-raised md-primary maps-style-new\" ng-click=\"dlg.newStyle()\">\n<md-icon md-font-icon=\"icon-plus\" class=\"s18\"></md-icon><span translate=\"MAPS.STYLE_NEW\"></span></md-button><div \nclass=\"maps-style-list\" flex><div class=\"maps-style-item\" ng-repeat=\"s in dlg.styles\" \nng-class=\"{\'selected\': dlg.current.id === s.id}\" ng-click=\"dlg.selectStyle(s)\"><md-icon md-font-icon=\"icon-palette\" \nclass=\"s18\"></md-icon><span class=\"maps-style-item-name text-truncate\">{{ s.title }}</span></div><div \nclass=\"maps-style-empty\" ng-if=\"!dlg.styles.length\" translate=\"MAPS.STYLE_LIBRARY_EMPTY\"></div></div></div><div \nclass=\"maps-style-center\" layout=\"column\" flex><div class=\"maps-style-props\" layout=\"row\" layout-align=\"start center\">\n<md-input-container class=\"md-block maps-style-name\" flex><label translate=\"MAPS.STYLE_NAME\"></label><input \ntype=\"text\" ng-model=\"dlg.current.title\"></md-input-container><md-input-container class=\"maps-style-base\"><label \ntranslate=\"MAPS.STYLE_BASE\"></label><md-select ng-model=\"dlg.current.base\" ng-change=\"dlg.setBase(dlg.current.base)\">\n<md-option ng-repeat=\"b in dlg.bases\" ng-value=\"b.id\">{{ b.name | translate }}</md-option></md-select>\n</md-input-container></div><div id=\"maps-style-preview\" class=\"maps-style-preview\" flex></div></div><div \nclass=\"maps-style-layers\" layout=\"column\"><div class=\"maps-style-layers-header\" translate=\"MAPS.STYLE_LAYERS\"></div>\n<div class=\"maps-style-layers-list\" flex><div class=\"maps-style-group\" ng-repeat=\"g in dlg.groups\"><div \nclass=\"maps-style-group-title\">{{ dlg.groupLabels[g] | translate }}</div><div class=\"maps-style-layer\" \nng-repeat=\"layer in dlg.byGroup[g]\" layout=\"row\" layout-align=\"start center\"><input type=\"color\" \nclass=\"maps-style-color\" ng-model=\"layer.color\" ng-change=\"dlg.onColor(layer)\" ng-disabled=\"!layer.colorProp\" \ntitle=\"{{ layer.isExpression ? (\'MAPS.STYLE_EXPRESSION_HINT\' | translate) : \'\' }}\"> <span \nclass=\"maps-style-layer-name text-truncate\" flex>{{ layer.id }}</span><md-switch class=\"maps-style-vis md-primary\" \nng-model=\"layer.visible\" ng-change=\"dlg.onVisibility(layer)\" aria-label=\"{{ \'MAPS.STYLE_VISIBLE\' | translate }}\">\n</md-switch></div></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button class=\"md-warn\" \nng-click=\"dlg.remove()\" ng-if=\"dlg.current.id\" translate=\"MAPS.DELETE\"></md-button><span flex></span><md-button \nng-click=\"dlg.close()\" translate=\"MAPS.CLOSE\"></md-button><md-button class=\"md-raised md-primary\" \nng-click=\"dlg.save()\" ng-disabled=\"dlg.saving\"><span ng-if=\"!dlg.saving\" translate=\"MAPS.SAVE\"></span> <span \nng-if=\"dlg.saving\" translate=\"MAPS.SAVING\"></span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/match-center/sidenavs/tree-sidenav.html","<md-toolbar class=\"md-default-theme grey-100-bg grey-600-fg pr-16 pl-16\" layout=\"row\" \nlayout-align=\"space-between center\"><div ng-if=\"!vm.showTreeSearch\" class=\"md-toolbar-tools p-0\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-folder-multiple\" \nclass=\"grey-600-fg s18 mr-10 ml-0 md-default-theme md-font material-icons\" aria-hidden=\"true\"></md-icon><div \ntranslate-attr-aria-label=\"MATCH_CENTER.SEASONS\" translate=\"MATCH_CENTER.SEASONS\" class=\"grey-600-fg\">SEASONS</div>\n</div><div ng-if=\"!vm.showTreeSearch\" layout=\"row\" layout-align=\"end center\"><mv-tree-expander tree=\"vm.seasons\">\n</mv-tree-expander><md-icon id=\"\" md-font-icon=\"icon-plus\" ng-click=\"vm.openCreateDialog($event)\" \nclass=\"m-0 grey-600-fg md-icon-button md-button md-default-theme md-font material-icons\" aria-hidden=\"true\">\n<md-tooltip><span translate=\"CONTENT.ADD\">Add</span></md-tooltip></md-icon><div ng-if=\"vm.currentView !== \'nosplit\'\" \nclass=\"divider-vertical\"></div><md-icon ng-if=\"vm.currentView !== \'nosplit\'\" \nng-click=\"vm.toggleSidenav(\'tree-sidenav\')\" md-font-icon=\"icon-backburger\" \nclass=\"m-0 grey-600-fg md-icon md-button md-default-theme md-font material-icons md-icon-button\" aria-hidden=\"true\">\n</md-icon></div><div ng-if=\"vm.showTreeSearch\" layout=\"row\" class=\"users-groups-tree-search\"><div layout=\"row\" flex \nlayout-align=\"start center\"><label for=\"search-bar-input\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"grey-600-fg md-icon-button md-button\"><md-tooltip hide show-gt-xs><span translate=\"TOOLBAR.SEARCH\">Search</span>\n</md-tooltip></md-icon></label><md-icon md-font-icon=\"icon-close-circle\" class=\"grey-600-fg md-icon-button md-button\" \nng-if=\"vm.treeSearch\" ng-click=\"vm.treeSearch = null\"></md-icon><input type=\"text\" id=\"search-bar-input\" \nclass=\"grey-600-fg grey-100-bg\" ng-model=\"vm.treeSearch\" placeholder=\"Search\" md-autofocus translate \ntranslate-attr-placeholder=\"TOOLBAR.SEARCH\" flex><md-icon layout-align=\"end center\" \nng-click=\"vm.showTreeSearch = false\" md-font-icon=\"icon-close\" \nclass=\"users-groups-tree-search-collapser icon s24 grey-600-fg\"></md-icon></div></div></md-toolbar><div flex \nlayout=\"column\" layout-align=\"center center\" ng-if=\"isLoading\" class=\"loading-container\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><md-content ms-scroll flex><div \nclass=\"navigation-simple\" layout=\"column\"><div ng-if=\"vm.seasons\" ivh-treeview=\"vm.seasons\" \nivh-treeview-expand-to-depth=\"0\" ivh-treeview-filter=\"vm.treeSearch\" ivh-treeview-label-attribute=\"\'label\'\" \nclass=\"ivh-treeview-folder small\"><script type=\"text/ng-template\">\n<div class=\"level-card p-8 group-row\" ng-class=\"{\'selected\': node.is_selected_node}\" layout=\"row\" layout-align=\"space-between stretch\">\r\n                    <span ivh-treeview-twistie ivh-treeview-toggle layout=\"row\" layout-align=\"center center\"></span>\r\n                    <div flex id=\"treeview-group-{{node.id_competition_season}}\" qiu-match-center-on-click-edit-dialog data-group-node={{node}} layout=\"row\" layout-align=\"start center\">\r\n                        <span class=\"ivh-treeview-node-label ng-binding\">{{trvw.label(node)}}</span>\r\n                    </div> \r\n\r\n                    <div layout=\"row\" layout-align=\"end center\">\r\n                        <!-- <md-button qiu-match-center-on-click-edit-dialog class=\"md-icon-button\" type=\"button\" aria-label=\"ACTIONS\">\r\n                            <md-icon md-font-icon=\"icon-pencil\" aria-hidden=\"true\"></md-icon>\r\n                        </md-button> -->\r\n                        <md-icon qiu-users-on-click-close-sidenav sidenav-id=\"tree-sidenav\" md-font-icon=\"icon-chevron-right\" aria-hidden=\"true\" hide-gt-sm class=\"mt-0 mb-0\"></md-icon>\r\n                    </div>\r\n\r\n                </div>\r\n                <div ivh-treeview-children></div>\n</script></div></div></md-content>");
$templateCache.put("app/main/apps/media/views-rekognition/edit-view.html","<div><md-input-container class=\"md-block\"><label>Tag name</label><input type=\"text\"></md-input-container></div>");
$templateCache.put("app/main/apps/media/views-rekognition/list-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-if=\"isLoading\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div class=\"no-threads\" \nng-if=\"!isLoading && vm.items.length === 0\" ng-hide=\"isLoading\">There are no items!</div><div id=\"list-content-data\" \nng-style=\"{\'opacity\' : isLoading ? 0.2 : 1}\" ms-scroll=\"vm.msScrollOptions\" \nng-class=\"{\'group-filter\': vm.selectedGroup,\'other-filter\':sortField}\" class=\"scrollable\" ng-if=\"vm.items.length> 0\">\n<div class=\"mail-list-item\" ng-click=\"vm.openFace(item)\" ng-repeat=\"item in vm.items\" md-no-ink \nng-init=\"parentIndex= $index\" \nng-class=\"{\'starred\': item.starred, \'selected\': vm.selectedFace.id_media === item.id_media, \'checked\':\r\n    vm.isChecked(item)}\">\n<div layout=\"row\" layout-align=\"start center\"><div class=\"info\" flex layout=\"column\"><div layout=\"row\" \nlayout-align=\"start center\"><media class=\"avatar\" attachment=\"item\" thumbnail=\"true\"></media><div class=\"name ph-15\" \nlayout=\"row\" layout-align=\"start center\"><span>{{item.title}}</span></div></div></div><div layout=\"column\" \nlayout-align=\"space-between end\"></div></div></div><div class=\"toolbar\" layout=\"row\" layout-align=\"end center\"><div \nlayout=\"row\" layout-align=\"center center\" ng-style=\"{\'display\' : isLoading ? \'none\' : \'block\'}\"><span \nclass=\"page-info\">{{pagination_totalItems}} items found.</span><md-button aria-label=\"Previous\" \nclass=\"md-icon-button arrow\" ng-click=\"pagination_prevPage()\" ng-disabled=\"pagination_firstPage()\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span \ntranslate=\"CONTENT.PREVIOUS\">Previous</span></md-tooltip></md-button><span class=\"page-info\">\n{{pagination_page}} / {{pagination_total_pages}}</span><md-button aria-label=\"Next\" class=\"md-icon-button arrow\" \nng-click=\"pagination_nextPage()\" ng-disabled=\"pagination_morePages() || pagination_total_pages === pagination_page\" \ntranslate=\"\" translate-attr-aria-label=\"CONTENT.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip>\n<span translate=\"CONTENT.NEXT\">Next</span></md-tooltip></md-button></div></div></div>");
$templateCache.put("app/main/apps/media/views-rekognition/media-card.html","<div class=\"template-9\" layout=\"column\" layout-align=\"space-between stretch\"><div class=\"media\" flex layout=\"row\" \nlayout-align=\"center center\"><media attachment=\"mediaItem\" class-img=\"image\"></media></div><div class=\"header p-16\" \nflex><div layout=\"row\" layout-align=\"space-between center\" flex><md-checkbox ng-if=\"selectedArrayProperty\" \nclass=\"no-label\" aria-label=\"\" ng-checked=\"vm.isCheckedMedia(selectedArrayProperty, mediaItem)\" \nng-click=\"vm.toggleCheck(selectedArrayProperty, mediaItem, $event); $event.stopPropagation();\"></md-checkbox><div \nng-if=\"mediaItem != \'Image Rekognition\'\" class=\"ml-25 size block\" layout=\"row\" layout-align=\"start left\"><strong \nclass=\"mr-5\">#{{mediaItem.id_media}}</strong> <span class=\"grey-500-fg\"><span ng-if=\"mediaItem.filename\" \nclass=\"filename\">{{mediaItem.filename}}</span></span></div><div ng-if=\"mediaItem == \'Image Rekognition\'\" \nclass=\"size block\" layout=\"row\" layout-align=\"start left\"><strong ng-if=\"!vm.isProcessingItem(mediaItem)\"><span \nng-repeat=\"text in mediaItem.meta_analyses.rekognition_detect_text.TextDetectionsUnique | filter: filterByNumNotCurrentYears track by $index\">\n{{text.DetectedText}}<span ng-if=\"!$last\">,</span></span> </strong><strong style=\"color: red; font-weight: bold\" \nng-if=\"vm.isProcessingItem(mediaItem)\">PROCESANDO</strong></div></div></div></div>");
$templateCache.put("app/main/apps/media/views-rekognition/nosplit-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/media/views-rekognition/toolbar.html\'\" ng-hide=\"vm.mediaSelected\"></div><div \nclass=\"content-wrapper\" flex=\"\" layout=\"row\"><div class=\"content thread-detail mail-read-pane\" flex=\"\" \nid=\"thread-detail\" ms-scroll=\"vm.msScrollOptions\" ng-if=\"vm.mediaSelected\" \nng-include=\"\'app/main/apps/media/views-rekognition/read-view.html\'\"></div><div \nclass=\"content thread-list mail-list-pane\" flex=\"\" id=\"thread-list\" ng-if=\"!vm.mediaSelected\" \nng-include=\"\'app/main/apps/media/views-rekognition/list-view.html\'\" on-size-changed=\"vm.logResize\"></div></div>");
$templateCache.put("app/main/apps/media/views-rekognition/preview-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-if=\"vm.isLoadingRelated\" class=\"loading-container mt-60\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nng-if=\"vm.facesRelated && !vm.isLoadingRelated\" fill-width layout=\"column\"><div \nstyle=\"overflow: auto;max-height: calc(100vh - 375px)\" class=\"grid-view\" flex md-cols=\"2\"><div \nng-click=\"vm.openImageDialog($event, mediaItem,mediaItem, false, true)\" ng-repeat=\"mediaItem in vm.facesRelated\" \ndata-id=\"{{mediaItem.id_media}}\" class=\"ms-card grid-element sortable\"><div class=\"ms-card-content-wrapper\"><div \nwith=\"\'selectedRelated\'\" as=\"selectedArrayProperty\" class=\"ms-card-content-wrapper\" \nng-include=\"\'app/main/apps/media/views-rekognition/media-card.html\'\"></div></div></div></div></div>");
$templateCache.put("app/main/apps/media/views-rekognition/read-view.html","<div ng-if=\"vm.selectedFace\"><div layout=\"row\"><div \nng-click=\"vm.openImageDialog($event,vm.selectedFaceData,vm.selectedFaceData, false, true)\" \nclass=\"pointer avatar text-left m-15\" style=\"height: 150px;width: 150px\"><img style=\"height: 100%; width: 100%\" \nng-src=\"{{vm.selectedFaceData.imageUrlOriginal}}\" alt=\"\"></div><h2 style=\"line-height: 150px\">\n{{vm.selectedFaceData.title}}</h2></div><div class=\"toolbar grey-100-bg colored-bg\" layout=\"row\" \nlayout-align=\"space-between center\" scroll=\"\"><div layout=\"row\" layout-align=\"start center\"><md-button \naria-label=\"Preview\" class=\"md-icon-button\" ng-class=\"{\'md-accent\':vm.currentTab == \'preview\'}\" \nng-click=\"vm.currentTab= \'preview\'\" translate=\"\" translate-attr-aria-label=\"CONTENT.PREVIEW\"><md-icon \nmd-font-icon=\"icon-eye\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"MEDIA.PREVIEW_TAB\">Preview</span>\n</md-tooltip></md-button><div class=\"divider-vertical\" hide=\"\" show-gt-sm=\"\"></div><md-button \nng-if=\"vm.selectedFace.ai_recognition.texts.length> 0\" aria-label=\"text\" class=\"md-icon-button\" \nng-class=\"{\'md-accent\':vm.currentTab == \'text\'}\" ng-click=\"vm.currentTab= \'text\'\" translate=\"\" \ntranslate-attr-aria-label=\"MEDIA.TEXT\"><md-icon md-font-icon=\"icon-format-color\"></md-icon><md-tooltip hide show-gt-xs>\n<span translate=\"MEDIA.TEXT_TAB\">Text</span></md-tooltip></md-button><div class=\"divider-vertical\" hide=\"\" \nshow-gt-sm=\"\"></div><md-button aria-label=\"TAGS\" class=\"md-icon-button\" \nng-class=\"{\'md-accent\':vm.currentTab == \'tags\'}\" ng-click=\"vm.currentTab= \'tags\'\" translate=\"\" \ntranslate-attr-aria-label=\"MEDIA.PREVIEW\"><md-icon md-font-icon=\"icon-tag\"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate=\"MEDIA.TAGS_TAB\">TAGS</span></md-tooltip></md-button></div><div \nng-if=\"vm.currentTab == \'preview\' || vm.currentTab == \'text\'\" layout=\"row\" layout-align=\"end center\" flex><md-button \nng-if=\"(vm.currentTab == \'preview\' && vm.selectedRelated.length>0)\r\n                || (vm.currentTab == \'text\' && vm.selectedText.length>0) \" \nclass=\"md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme\" ng-click=\"vm.autoTag()\" \ntype=\"button\">AUTO TAG</md-button><md-menu style=\"line-height: 45px\"><button class=\"md-icon-button\" aria-label=\"More\" \ntranslate translate-attr-aria-label=\"TODO.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\" \nng-click=\"$mdMenu.open($event)\"></md-icon></button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.selectAll(vm.currentTab)\" translate-attr-aria-label=\"MEDIA.SELECT_ALL\"><span translate=\"MEDIA.SELECT_ALL\">\n</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.selectUntagged(vm.currentTab)\" \ntranslate-attr-aria-label=\"MEDIA.SELECT_UNTAGED\"><span translate=\"MEDIA.SELECT_UNTAGED\"></span></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div><div class=\"faces-content\"><div \nng-if=\"vm.currentTab == \'preview\'\" ng-include=\"\'app/main/apps/media/views-rekognition/preview-view.html\'\"></div><div \nng-if=\"vm.currentTab == \'text\'\" ng-include=\"\'app/main/apps/media/views-rekognition/text-view.html\'\"></div><div \nng-if=\"vm.currentTab == \'tags\'\" ng-include=\"\'app/main/apps/media/views-rekognition/tags-view.html\'\"></div><div \nclass=\"ph-25\" ng-if=\"vm.currentTab == \'edit\'\" ng-include=\"\'app/main/apps/media/views-rekognition/edit-view.html\'\">\n</div></div></div>");
$templateCache.put("app/main/apps/media/views-rekognition/split-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/media/views-rekognition/toolbar.html\'\"></div><div class=\"content-wrapper\" flex=\"\" \nlayout=\"row\"><div class=\"content thread-list mail-list-pane\" flex=\"25\" id=\"thread-list\" \nng-include=\"\'app/main/apps/media/views-rekognition/list-view.html\'\"></div><div \nclass=\"content thread-detail mail-read-pane\" flex=\"75\" id=\"thread-detail\" layout=\"column\" \nng-include=\"\'app/main/apps/media/views-rekognition/read-view.html\'\"></div></div>");
$templateCache.put("app/main/apps/media/views-rekognition/tags-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-if=\"vm.isLoadingTags\" class=\"loading-container mt-60\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nng-if=\"vm.tagsRelated && !vm.isLoadingTags\" fill-width layout=\"column\"><div \nstyle=\"overflow: auto;max-height: calc(100vh - 375px)\" class=\"grid-view\" flex md-cols=\"2\"><div \nng-click=\"vm.openImageDialog($event, mediaItem,mediaItem, false, true)\" ng-repeat=\"mediaItem in vm.tagsRelated\" \ndata-id=\"{{mediaItem.id_media}}\" class=\"ms-card grid-element sortable\"><div class=\"ms-card-content-wrapper\"><div \nwith=\"\'selectedTags\'\" as=\"selectedArrayProperty\" class=\"ms-card-content-wrapper\" \nng-include=\"\'app/main/apps/media/views-rekognition/media-card.html\'\"></div></div></div></div></div>");
$templateCache.put("app/main/apps/media/views-rekognition/text-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-if=\"vm.isLoadingText\" class=\"loading-container mt-60\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nng-if=\"vm.textsRelated && !vm.isLoadingText\" fill-width layout=\"column\"><div \nstyle=\"overflow: auto;max-height: calc(100vh - 375px)\" class=\"grid-view\" flex md-cols=\"2\"><div \nng-click=\"vm.openImageDialog($event, mediaItem,mediaItem, false, true)\" ng-repeat=\"mediaItem in vm.textsRelated\" \ndata-id=\"{{mediaItem.id_media}}\" class=\"ms-card grid-element sortable\"><div with=\"\'selectedText\'\" \nas=\"selectedArrayProperty\" class=\"ms-card-content-wrapper\" \nng-include=\"\'app/main/apps/media/views-rekognition/media-card.html\'\"></div></div></div></div>");
$templateCache.put("app/main/apps/media/views-rekognition/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><md-button aria-label=\"ADD_NEW_FACE\" \nclass=\"md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme\" hide show-gt-sm \nng-click=\"vm.newFace($event)\" translate=\"MEDIA.ADD_NEW_FACE\" type=\"button\">ADD_NEW_FACE</md-button><div \nclass=\"divider-vertical\" hide=\"\" show-gt-xs=\"\"></div><md-button ng-if=\"vm.media_type_name != \'galleries\'\" \naria-label=\"ADD NEW\" class=\"md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme\" hide \nshow-gt-sm ng-click=\"vm.AddmediaDialog()\" translate=\"UPLOAD\" type=\"button\">Upload</md-button><div \nclass=\"divider-vertical\" hide=\"\" show-gt-xs=\"\"></div><ms-search-bar debounce=\"300\" \nmodel-search=\"$root.pagination_searchquery\" on-result-click=\"vm.searchResultClick(item)\" on-search=\"vm.search(query)\" \nlayout=\"row\" layout-align=\"start center\"></ms-search-bar></div><div layout=\"row\" layout-align=\"start center\" \ntranslate-attr-aria-label=\"CONTENT.REFRESH\" class=\"qiu-pagination\" ng-hide=\"isLoading\"><span class=\"page-info\" hide=\"\" \nshow-gt-xs=\"\">{{pagination_totalItems | number}} items found.</span><md-button aria-label=\"Previous\" \nclass=\"md-icon-button arrow\" hide=\"\" ng-click=\"pagination_prevPage()\" ng-disabled=\"pagination_firstPage()\" \nshow-gt-xs=\"\" translate=\"\" translate-attr-aria-label=\"CONTENT.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.PREVIOUS\">Previous</span></md-tooltip></md-button><div \nhide show-gt-xs><md-select ng-model=\"pagination_page\" placeholder=\"Page\" class=\"toolbar-item\"><md-option \nng-repeat=\"n in [].constructor(pagination_total_pages) track by $index\" value=\"{{$index +1}}\" \nng-click=\"pagination_gotoPage($index+1)\">{{$index+1}}</md-option></md-select><md-tooltip><span \ntranslate=\"CONTENT.SELECT_PAGE\">Select page</span></md-tooltip></div><span class=\"page-info ml-10\" hide=\"\" \nshow-gt-xs=\"\">/ <span class=\"ml-5\">{{pagination_total_pages | number}}</span></span><md-button aria-label=\"Next\" \nclass=\"md-icon-button arrow\" hide=\"\" ng-click=\"pagination_nextPage()\" ng-disabled=\"pagination_morePages()\" \nshow-gt-xs=\"\" translate=\"\" translate-attr-aria-label=\"CONTENT.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\">\n</md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.NEXT\">Next</span></md-tooltip></md-button><div \nclass=\"divider-vertical\" hide hide show-gt-sm></div><div class=\"limit-select mr-10 ml-10\" ng-if=\"!isLoading\" hide \nshow-gt-sm><md-select class=\"md-table-select\" ng-model=\"$root.perPage\" md-container-class=\"md-pagination-select\" \naria-label=\"Rows\" placeholder=\"{{ $pagination.limitOptions[0] }}\"><md-option ng-repeat=\"p in perPagePresets\" \nng-value=\"p\">{{p}} {{::option.label ? option.label : option}}</md-option></md-select><md-tooltip hide show-gt-xs><span \ntranslate=\"CONTENT.ITEMS_PER_PAGE\">Items per page</span></md-tooltip></div><div class=\"divider-vertical\" hide hide \nshow-gt-sm></div><md-button aria-label=\"Refresh\" class=\"md-icon-button\" hide=\"\" show-gt-xs=\"\" \nng-click=\"pagination_reload()\" translate=\"\" translate-attr-aria-label=\"MEDIA.REFRESH\" show-gt-xs><md-icon \nmd-font-icon=\"icon-refresh\" show-gt-xs></md-icon></md-button><md-menu-bar class=\"pr-0 pl-0\" hide-gt-xs><md-menu \nclass=\"settings-menu\"><md-button aria-label=\"Settings\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" \ntranslate=\"\" translate-attr-aria-label=\"CONTENT.SETTINGS\"><md-icon md-font-icon=\"icon-cog\"></md-icon></md-button>\n<md-menu-content><md-menu-item><md-button ng-click=\"vm.deleteMediaItem($event)\" aria-label=\"Delete\" \nng-disabled=\"vm.selectedThreads.length == 0\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span \ntranslate=\"CONTENT.DELETE\">Delete</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"pagination_reload()\" aria-label=\"REFRESH\"><md-icon md-font-icon=\"icon-refresh\"></md-icon><span \ntranslate=\"MEDIA.REFRESH\">REFRESH</span></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div>");
$templateCache.put("app/main/apps/media/views/edit-layout.html","<div flex layout=\"column\" layout-align=\"center center\" ng-if=\"vm.loadingReadPane\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nng-show=\"!vm.loadingReadPane\"><div class=\"toolbar grey-100-bg colored-bg\" layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"vm.mediaSelected\" scroll=\"\"><div layout=\"row\" layout-align=\"start center\">\n<md-button aria-label=\"Info\" class=\"md-icon-button\" ng-click=\"vm.closeMediaPreview()\" \nng-if=\"vm.mediaSelected && vm.currentView==\'nosplit\'\" translate=\"\" translate-attr-aria-label=\"CONTENT.BACK\"><md-icon \nmd-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button></div><div layout=\"row\" layout-align=\"end center\" \nng-if=\"vm.mediaSelected\"><md-button type=\"submit\" ng-click=\"vm.saveImage(vm.image)\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"vm.basicForm.$invalid || vm.basicForm.$pristine\" \naria-label=\"SAVE\" translate=\"CONTENT.SAVE\" translate-attr-aria-label=\"CONTENT.SAVE\">SAVE</md-button><md-button \ntype=\"button\" ng-click=\"vm.closeMediaPreview()\" class=\"md-raised md-warn\" aria-label=\"Cancel\">Cancel</md-button></div>\n</div><md-content ng-style=\"{\'height\' : vm.currentListView == \'gridGoogle\' ? \'calc(100vh - 129px)\' : auto}\" \nng-if=\"vm.mediaSelectedLoaded\" ng-include=\"\'app/main/apps/media/views/edit-media.html\'\" class=\"scrollable\">\n</md-content></div>");
$templateCache.put("app/main/apps/media/views/edit-media.html","<div id=\"content-edit\" class=\"page-layout simple fullwidth mail-content content-edit\" layout=\"column\"><md-tabs><md-tab \nmd-on-select=\"vm.tabSelected=\'Rekognition\'\" ng-if=\"vm.media_type_name != \'Image Rekognition\'\" label=\"Edit\"><div \nlayout=\"row\" ng-include=\"\'app/main/apps/media/views/tabs/tab-edit.html\'\"></div></md-tab><md-tab \nmd-on-select=\"vm.tabSelected=\'Rekognition1\'; vm.showCropformatsTab()\" \nng-if=\"vm.media_type_name != \'Image Rekognition\' && (vm.image.media_type == 1 || (vm.image.media_type == 2 && vm.image.embed.indexOf(\'zc|\') !== -1))\" \nlabel=\"Cropformats ({{vm.image.media_type == 1 ? vm.image.cropstatus.length : vm.image.cropstatus_videos.length}})\">\n<div ng-include=\"\'app/main/apps/media/views/tabs/tab-cropformats.html\'\"></div></md-tab><md-tab \nmd-on-select=\"vm.tabSelected=\'Rekognition2\'\" ng-if=\"vm.media_type_name != \'Image Rekognition\'\" \nlabel=\"{{vm.translate(\'GALLERIES\')}} ({{vm.image.totalGalleries}})\"><div layout=\"row\" \nng-include=\"\'app/main/apps/media/views/tabs/tab-galleries.html\'\"></div></md-tab><md-tab \nmd-on-select=\"vm.tabSelected=\'AI\'\" label=\"{{vm.translate(\'AI\')}}\" \nng-if=\"vm.image.meta_analyses != null && vm.media_type_name != \'Image Rekognition\'\"><div layout=\"row\" \nng-include=\"\'app/main/apps/media/views/tabs/tab-ai.html\'\"></div></md-tab><md-tab \nmd-on-select=\"vm.tabSelected=\'AI_RECOGNITION\'\" label=\"{{vm.translate(\'MEDIA.AI_RECOGNITION\')}}\" \nng-if=\"vm.image.ai_recognition != null\"><div ng-if=\"vm.media_type_name == \'Image Rekognition\'\" \nclass=\"frame-marks size block p-0-i relative\" layout=\"row\" layout-align=\"start left\"><img \nng-src=\"{{vm.image.imageUrlOriginal}}\" alt=\"\"> <span ng-repeat=\"person in vm.image.ai_recognition.ignored_persons\">\n<span class=\"label-mark\" \nstyle=\"border: 1px solid red; opacity: 1; top: {{person.detected_person.BoundingBox.Top*100}}%; left: {{person.detected_person.BoundingBox.Left*100}}%; width: {{person.detected_person.BoundingBox.Width*100}}%; height: {{person.detected_person.BoundingBox.Height*100}}%\">\n<span style=\"color: red; font-size: 18px\">ignored</span> </span></span><span \nng-repeat=\"person in vm.image.ai_recognition.persons\"><span title=\"{{person.id_user}}\" class=\"label-mark\" \nstyle=\"border: 2px solid green; opacity: 1; top: {{person.label.BoundingBox.Top*100}}%; left: {{person.label.BoundingBox.Left*100}}%; width: {{person.label.BoundingBox.Width*100}}%; height: {{person.label.BoundingBox.Height*100}}%\">\n<span style=\"padding: 2px; background-color: white; color: green; font-size: 18px\"># {{person.id_user}}</span></span>\n</span></div><div layout=\"column\" class=\"grid-view\" md-cols=\"2\" md-row-height=\"250\" md-gutter=\"12px\" \nmd-guttet-gt-sm=\"8px\"><div ng-repeat=\"person in vm.image.ai_recognition.persons\" class=\"grid-element sortable\" \ndata-id=\"{{person.id_user}}\"><div layout=\"column\" layout-align=\"space-between left\" flex><span><strong>\n#{{person.id_user}}</strong></span> <span><strong>Dorsal:</strong>{{person.number}}</span> <span><strong>Similarity:\n</strong>{{person.similarity | number}} %</span> <span><strong>Confidence:</strong>\n{{person.label.Confidence | number}} %</span> <span><strong>Face_id:</strong>{{person.face_id}}</span></div></div>\n</div></md-tab><md-tab md-on-select=\"vm.tabSelected=\'RELATED_PICTURES\'\" \nlabel=\"{{vm.translate(\'MEDIA.RELATED_PICTURES\')}}\" ng-if=\"vm.image.meta_analyses != null\"><div \nng-if=\"vm.media_type_name == \'Image Rekognition\'\" class=\"frame-marks size block p-0-i relative\" layout=\"row\" \nlayout-align=\"start left\"><img ng-src=\"{{vm.image.imageUrlOriginal}}\" alt=\"\"> <span \nng-repeat=\"labelItem in vm.image.meta_analyses.rekognition_detect_labels.Labels\" ng-if=\"labelItem.Name == \'Person\'\">\n<span title=\"{{labelItem.Name}}\" ng-click=\"vm.openLabel(labelItem)\" class=\"label-mark\" \nstyle=\"top: {{labelInstance.BoundingBox.Top*100}}%; left: {{labelInstance.BoundingBox.Left*100}}%; width: {{labelInstance.BoundingBox.Width*100}}%; height: {{labelInstance.BoundingBox.Height*100}}%\" \nng-repeat=\"labelInstance in labelItem.Instances\"></span> </span><span ng-click=\"vm.openFace(faceItem)\" \nclass=\"face-mark\" \nstyle=\"top: {{faceItem.Face.BoundingBox.Top*100}}%; left: {{faceItem.Face.BoundingBox.Left*100}}%; width: {{faceItem.Face.BoundingBox.Width*100}}%; height: {{faceItem.Face.BoundingBox.Height*100}}%\" \nng-repeat=\"faceItem in vm.image.meta_analyses.rekognition_index_faces.FaceRecords\"></span> <span \ntitle=\"{{textItem.DetectedText}}\" ng-click=\"vm.openText(textItem)\" \nng-class=\"{\'text-mark\': true, \'text-mark-line\': textItem.Type == \'LINE\', \'text-mark-word\': textItem.Type == \'WORD\'}\" \nstyle=\"top: {{textItem.Geometry.BoundingBox.Top*100}}%; left: {{textItem.Geometry.BoundingBox.Left*100}}%; width: {{textItem.Geometry.BoundingBox.Width*100}}%; height: {{textItem.Geometry.BoundingBox.Height*100}}%\" \nng-repeat=\"textItem in vm.image.meta_analyses.rekognition_detect_text.TextDetections\"></span></div><div \nclass=\"size block m-15 p-0-i\" layout=\"row\" layout-align=\"start left\"><strong ng-if=\"!vm.isProcessingItem(vm.image)\">\n<span \nng-repeat=\"text in vm.image.meta_analyses.rekognition_detect_text.TextDetectionsUnique | filter: filterByNumNotCurrentYears track by $index\">\n{{text.DetectedText}}<span ng-if=\"!$last\">,</span></span> </strong><strong style=\"color: red; font-weight: bold\" \nng-if=\"vm.isProcessingItem(vm.image)\" translate=\"MEDIA.PROCESSING\">PROCESANDO</strong></div><div layout=\"row\" \nng-include=\"\'app/main/apps/media/views/tabs/tab-related.html\'\"></div></md-tab><md-tab \nmd-on-select=\"vm.tabSelected=\'SOCIAL_POST\'\" label=\"{{vm.translate(\'MEDIA.SOCIAL_POST\')}}\"><ms-social-list \nng-if=\"vm.tabSelected == \'SOCIAL_POST\'\" fill-width service=\"\'media\'\" section=\"\'all\'\" idcontent=\"vm.image.id_media\">\n</ms-social-list></md-tab><md-tab md-on-select=\"vm.tabSelected=\'MEDIA_CHILDS\'\" \nlabel=\"{{vm.translate(\'MEDIA.MEDIA_CHILDS\')}}\"><div style=\"max-height: 100%;overflow: auto;padding-bottom: 50px\"><div \nng-if=\"vm.image.children && vm.image.children.length> 0\" class=\"grid-view\" style=\"padding-bottom: 0px\"><div \nng-repeat=\"child in vm.image.children\" class=\"grid-element\" data-id=\"{{child.id_media}}\"><div \nclass=\"ms-card-content-wrapper\" with=\"\'children\'\" as=\"selectedTab\" \nng-include=\"\'app/main/apps/media/views/list/subviews/media-children.html\'\"></div></div></div><div \nng-if=\"!vm.image.children || vm.image.children.length ==0\"><div class=\"content\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"message font-size-20 mt-20\" translate=\"MEDIA.NO_CHILDS\"></div></div></div>\n<md-button class=\"add-event-button md-fab md-warn\" ng-click=\"vm.openSelectMediaDialog($event)\" aria-label=\"Add\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></md-tab><md-tab \nmd-on-select=\"vm.tabSelected=\'MEDIA_PARENT\'\" label=\"{{vm.translate(\'MEDIA.MEDIA_PARENT\')}}\"><div \nng-if=\"vm.image.parent_media\" class=\"grid-view\"><div ng-repeat=\"child in [vm.image.parent_media]\" class=\"grid-element\" \ndata-id=\"{{child.id_media}}\"><div class=\"ms-card-content-wrapper\" with=\"\'parent\'\" as=\"selectedTab\" \nng-include=\"\'app/main/apps/media/views/list/subviews/media-children.html\'\"></div></div></div><div \nng-if=\"!vm.image.parent_media\"><div class=\"content\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"message font-size-20 mt-20\" translate=\"MEDIA.NO_PARENT\"></div></div></div></md-tab></md-tabs></div>");
$templateCache.put("app/main/apps/media/views/galleries-toolbar.html","<div layout=\"row\" layout-align=\"start center\"><md-button ng-if=\"vm.media_type_name == \'galleries\'\" \naria-label=\"ADD NEW\" class=\"md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme\" hide \nshow-gt-sm ng-click=\"vm.createGallery($event)\" translate=\"MEDIA.ADD_GALLERY\" type=\"button\">Add gallery</md-button>\n<md-button ng-disabled=\"vm.selectedGallery && vm.selectedGallery.no_files_allowed == true\" aria-label=\"ADD NEW\" \nclass=\"md-fab md-mini md-accent green-500-bg md-raised md-ink-ripple md-default-theme\" hide-gt-sm \nng-click=\"vm.AddmediaDialog()\" type=\"button\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><div \nclass=\"divider-vertical\" hide=\"\" show-gt-xs=\"\"></div><md-icon ng-if=\"vm.sortDirGalleries !== \'ASC\'\" \nng-click=\"vm.setGalleriesSortDir(\'ASC\')\" md-font-icon=\"icon-sort-descending\" \nclass=\"m-0 grey-600-fg md-icon-button md-button md-default-theme md-font material-icons\" translate=\"\" \ntranslate-attr-aria-label=\"TODO.SORT_DIRECTION\"></md-icon><md-icon ng-if=\"vm.sortDirGalleries === \'ASC\'\" \nng-click=\"vm.setGalleriesSortDir(\'DESC\')\" md-font-icon=\"icon-sort-ascending\" \nclass=\"m-0 grey-600-fg md-icon-button md-button md-default-theme md-font material-icons\" translate=\"\" \ntranslate-attr-aria-label=\"TODO.SORT_DIRECTION\"></md-icon><md-menu ng-if=\"vm.media_type_name == \'galleries\'\"><button \naria-label=\"Filters\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.FILTERS\"><md-icon md-font-icon=\"m-0 grey-600-fg icon-chevron-down\"><md-tooltip><span\n translate=\"CONTENT.ORDER_BY\">Order</span></md-tooltip></md-icon></button><md-menu-content width=\"4\"><md-menu-item \nng-repeat=\"(key, value) in vm.orderByGalleries\"><md-button aria-label=\"All\" ng-click=\"vm.setGalleriesSortField(value)\">\n<div layout=\"row\" layout-align=\"space-between center\"><span>Order by {{key | translate}} </span><i \nclass=\"icon-check s16\" ng-if=\"value == vm.sortFieldGalleries\"></i></div></md-button></md-menu-item></md-menu-content>\n</md-menu><md-menu hide=\"\" show-gt-xs=\"\" ng-if=\"refGroupables.length>0\"><button aria-label=\"Filters\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" show-gt-xs=\"\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.FILTERS\"><md-icon md-font-icon=\"icon-chevron-down\"></md-icon></button>\n<md-menu-content width=\"4\"><md-menu-item ng-repeat=\"sortfield in refGroupables\"><md-button aria-label=\"All\" \nng-click=\"pagination_setOrderBy(sortfield)\"><div layout=\"row\" layout-align=\"space-between center\"><span>\nGroup by {{sortfield.name}} </span><i class=\"icon-check s16\" ng-if=\"sortfield.titleId == sortable.titleId\"></i></div>\n</md-button></md-menu-item><md-menu-item ng-if=\"groupable\"><md-button aria-label=\"Remove group\" \nng-click=\"pagination_resetOrderBy()\"><md-icon md-font-icon=\"icon-close \"></md-icon><span>Remove order</span>\n</md-button></md-menu-item></md-menu-content></md-menu></div>");
$templateCache.put("app/main/apps/media/views/list-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/media/views/toolbar.html\'\"></div><div class=\"content-wrapper\" flex=\"\" layout=\"row\"><div \nclass=\"content thread-list mail-list-pane\" flex=\"50\" id=\"thread-list\" \nng-include=\"\'app/main/apps/media/views/list/list-view.html\'\" on-size-changed=\"vm.logResize\" \nng-style=\"!vm.mediaSelected && {\'max-width\': \'100%\'} || {\'max-width\': \'50%\'}\"></div><div \nclass=\"content thread-detail mail-read-pane\" flex=\"50\" id=\"thread-detail\" layout=\"column\" \nng-include=\"\'app/main/apps/media/views/edit-layout.html\'\" ng-if=\"vm.mediaSelected\"></div></div>");
$templateCache.put("app/main/apps/media/views/nosplit-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/media/views/toolbar.html\'\" ng-hide=\"vm.mediaSelected\" \nng-if=\"vm.media_type_name != \'galleries\'\"></div><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/media/views/galleries-toolbar.html\'\" ng-hide=\"vm.mediaSelected\" \nng-if=\"vm.media_type_name == \'galleries\'\"></div><div class=\"content-wrapper\" flex=\"\" layout=\"row\"><div \nclass=\"content thread-detail mail-read-pane\" flex=\"\" id=\"thread-detail\" ms-scroll=\"vm.msScrollOptions\" \nng-if=\"vm.mediaSelected\" ng-include=\"\'app/main/apps/media/views/edit-layout.html\'\"></div><div \nclass=\"content thread-list mail-list-pane\" flex=\"\" id=\"thread-list\" \nng-if=\"!vm.mediaSelected && vm.media_type_name != \'galleries\'\" \nng-include=\"\'app/main/apps/media/views/list/items-view.html\'\" on-size-changed=\"vm.logResize\"></div><div \nclass=\"content thread-list mail-list-pane\" flex=\"\" id=\"thread-list\" \nng-if=\"!vm.mediaSelected && vm.media_type_name == \'galleries\'\" \nng-include=\"\'app/main/apps/media/views/list/galleries-view.html\'\" on-size-changed=\"vm.logResize\"></div></div>");
$templateCache.put("app/main/apps/media/views/photos-view.html","<div class=\"content-wrapper\" flex layout=\"row\"><div class=\"mail-tabs-grid\" flex \nmd-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"media mail-list-pane-grid\" flex><div \nng-repeat=\"photo in vm.items\" class=\"ms-card\" flex ng-click=\"vm.selectMediaFile(photo)\"><div \nclass=\"ms-card-content-wrapper\"><div class=\"template-9\"><div class=\"media\" flex layout=\"row\" \nlayout-align=\"center center\"><img ng-src=\"{{photo.cropstatus[0].container.view_url}}{{photo.cropstatus[0].fileName}}\" \nclass=\"image\"></div><div class=\"header p-16\" flex><div layout=\"row\" layout-align=\"space-between center\" flex><div \nclass=\"size block\" layout=\"row\" layout-align=\"start left\"><strong class=\"mr-5\">#{{photo.id_media}}</strong> <span \nclass=\"grey-500-fg\"><span ng-if=\"photo.filename\">{{photo.filename}}</span></span></div><md-checkbox \nng-checked=\"vm.isSelected(photo)\" ng-click=\"vm.toggleSelectThread(photo, $event)\" \naria-label=\"{{vm.isSelected(photo) ? \'Deselect\' : \'Select\'}}\" class=\"ml-5\"></md-checkbox></div><md-tooltip \nmd-direction=\"top\" hide show-gt-xs ng-if=\"photo.filename\"><span>{{photo.filename}}</span></md-tooltip></div></div>\n</div></div></div></div></div>");
$templateCache.put("app/main/apps/media/views/preview.html","<div flex layout=\"column\" layout-align=\"center center\" ng-if=\"vm.loadingReadPane\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"30\"></md-progress-circular></div><div \nng-show=\"!vm.loadingReadPane\"><div class=\"mail-content\" layout=\"column\" layout-align=\"center center\" \nng-if=\"!vm.mediaSelected\"><div class=\"content\" layout=\"column\" layout-align=\"top center\"><div class=\"message\">\nPlease select an item to show in this panel</div></div></div><div class=\"toolbar grey-100-bg colored-bg\" layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"vm.mediaSelected\" scroll=\"\"><div layout=\"row\" layout-align=\"start center\">\n<md-button class=\"md-icon-button close-thread\" aria-label=\"Back\" ng-click=\"vm.closeThread()\" \nng-if=\"vm.currentThread && vm.currentView==\'nosplit\'\" translate translate-attr-aria-label=\"CONTENT.BACK\"><md-icon \nmd-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><div class=\"divider-vertical\" hide=\"\" \nng-if=\"vm.activeMailPaneIndex === 1\" show-gt-sm=\"\"></div><md-button aria-label=\"Info\" class=\"md-icon-button\" \nng-click=\"vm.closeMediaPreview()\" ng-if=\"vm.mediaSelected\" translate=\"\" translate-attr-aria-label=\"CONTENT.CLOSE\">\n<md-icon md-font-icon=\"icon-close\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.CLOSE\">Close</span>\n</md-tooltip></md-button><div class=\"divider-vertical\" hide=\"\" show-gt-sm=\"\" ng-if=\"vm.selectedContent.id\"></div>\n<md-button aria-label=\"Edit\" class=\"md-icon-button\" ng-click=\"vm.viewEditInline()\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.EDIT\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip hide show-gt-xs>\n<span translate=\"CONTENT.EDIT\">Edit</span></md-tooltip></md-button><div class=\"divider-vertical\" hide=\"\" show-gt-sm=\"\" \nng-if=\"vm.selectedContent.urlpreview && vm.selectedContent.urlpreview.length > 10\"></div><md-button \naria-label=\"Preview\" class=\"md-icon-button\" \nng-if=\"vm.selectedContent.urlpreview && vm.selectedContent.urlpreview.length > 10\" \nng-click=\"vm.openUrl(vm.selectedContent.urlpreview)\" translate=\"\" translate-attr-aria-label=\"CONTENT.PREVIEW\"><md-icon \nmd-font-icon=\"icon-eye\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.PREVIEW\">Preview</span>\n</md-tooltip></md-button><div class=\"divider-vertical\" hide=\"\" show-gt-sm=\"\" ng-if=\"vm.ActiveSection.web_preview\">\n</div><md-button aria-label=\"Spam\" class=\"md-icon-button\" ng-click=\"\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.LIVE\" ng-if=\"vm.ActiveSection.web_preview\"><md-icon md-font-icon=\"icon-web\">\n</md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.LIVE\">Live Preview</span></md-tooltip></md-button>\n<md-menu hide=\"\"><md-button aria-label=\"Mail Actions\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" \ntranslate=\"\" translate-attr-aria-label=\"CONTENT.ACTIONS\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"3\"><md-menu-item><md-button aria-label=\"Archive\" \ntranslate-attr-aria-label=\"CONTENT.ARCHIVE\"><md-icon md-font-icon=\"icon-archive\"></md-icon><span \ntranslate=\"CONTENT.ARCHIVE\">Archive</span></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Spam\" \ntranslate-attr-aria-label=\"CONTENT.SPAM\"><md-icon md-font-icon=\"icon-alert-octagon\"></md-icon><span \ntranslate=\"CONTENT.SPAM\">Spam</span></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Delete\" \ntranslate-aria-label=\"CONTENT.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span translate=\"CONTENT.DELETE\">\nDelete</span></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Move To\" \ntranslate-attr-aria-label=\"CONTENT.MOVE_TO\"><md-icon md-font-icon=\"icon-folder-move\"></md-icon><span \ntranslate=\"CONTENT.MOVE_TO\">Move To</span></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Labels\" \ntranslate-attr-aria-label=\"CONTENT.LABELS\"><md-icon md-font-icon=\"icon-label\"></md-icon><span \ntranslate=\"CONTENT.LABELS\">Labels</span></md-button></md-menu-item></md-menu-content></md-menu></div><div layout=\"row\" \nlayout-align=\"end center\" ng-if=\"vm.mediaSelected\"><md-button type=\"submit\" ng-click=\"vm.saveImage(vm.image)\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"vm.basicForm.$invalid || vm.basicForm.$pristine\" \naria-label=\"SAVE\" translate=\"CONTENT.SAVE\" translate-attr-aria-label=\"CONTENT.SAVE\">SAVE</md-button><md-button \ntype=\"button\" ng-click=\"vm.closeThreadEdit()\" class=\"md-raised md-warn\" aria-label=\"Cancel\">Cancel</md-button></div>\n</div><md-content flex=\"\" ng-show=\"vm.mediaSelected && !vm.editInline\"><div \nclass=\"mail-content file-details scrollable\" ms-scroll=\"vm.msScrollOptions\"><div layout=\"row\" layout-xs=\"column\"><div \nflex-gt-sm=\"50\" flex=\"100\" class=\"white-box sections\"><div class=\"section\"><md-input-container class=\"md-block\" flexss>\n<img ng-src=\"{{vm.image.imageUrl}}\" src=\"{{vm.image.imageUrl}}\" alt=\"\"><div class=\"md-errors-spacer\"></div>\n</md-input-container></div></div><div flex-gt-sm=\"50\" flex=\"50\" class=\"white-box sections\"><div class=\"section\">\n<md-input-container class=\"md-block\" flexss><label translate=\"CONTENT.ID\">ID</label><input \nng-model=\"vm.image.id_media\" type=\"text\" readonly=\"readonly\"></md-input-container><md-input-container class=\"md-block\" \nflex><label translate=\"CONTENT.FILENAME\">Filename</label><input ng-model=\"vm.image.filename\" type=\"text\" \nreadonly=\"readonly\"></md-input-container></div></div></div><div layout=\"column\" layout-xs=\"column\"><div \nflex-gt-sm=\"66\" flex=\"100\" class=\"white-box sections\"><md-list><md-list-item class=\"md-toolbar-tools grey-100-bg\"><h5 \nclass=\"grey-700-fg\" translate=\"CONTENT.LATESTACTIVITY\">Publishing Settings<md-divider></md-divider></h5></md-list-item>\n</md-list><div class=\"section\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"section-title\">Main Info</span></div><md-input-container class=\"md-block\"><label translate=\"CONTENT.TITLE\">Title\n</label><textarea ng-model=\"vm.image.title\" columns=\"1\" rows=\"1\"></textarea></md-input-container><md-input-container \nclass=\"md-block\"><label translate=\"CONTENT.PHOTOGRAPHER\">Photographer</label><input ng-model=\"vm.image.photographer\" \ntype=\"text\"></md-input-container><md-input-container class=\"md-block\"><label translate=\"CONTENT.CREDITS\">Credits\n</label><input ng-model=\"vm.image.credits\" type=\"text\"></md-input-container><md-input-container class=\"md-block\"><label\n translate=\"CONTENT.OWNER\">Owner</label><input ng-model=\"vm.image.owner\" type=\"text\"></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"CONTENT.CAPTION\">Caption</label><textarea \nng-model=\"vm.image.caption\" columns=\"1\" rows=\"1\"></textarea></md-input-container><md-input-container class=\"md-block\">\n<label translate=\"CONTENT.CITY\">City</label><input ng-model=\"vm.image.city\" type=\"text\"></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"CONTENT.COUNTRY\">Country</label><input \nng-model=\"vm.image.country\" type=\"text\"></md-input-container><div ng-if=\"!vm.allFields\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent\" ng-click=\"vm.allFields = true\" \ntranslate=\"CONTENT.SHOW_ALL_FIELDS\">Show All Fields</md-button></div></div><div ng-if=\"vm.allFields\"><div \nclass=\"date-time-picker section\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"section-title\">File date</span></div><div layout=\"row\" layout-gt-sm=\"row\"><div flex class=\"date-container\">\n<mdp-date-picker mdp-placeholder=\"Date\" mdp-format=\"{{vm.dateFormat}}\" mdp-open-on-click=\"true\" \nng-model=\"vm.image.file_date.date\" ng-change=\"vm.updateDatePicker(\'file_date\')\"></mdp-date-picker></div><div flex \nclass=\"date-container\"><mdp-time-picker mdp-placeholder=\"Time\" mdp-auto-switch=\"true\" mdp-open-on-click=\"true\" \nng-model=\"vm.image.file_date.date\" ng-change=\"vm.updateDatePicker(\'file_date\')\"></mdp-time-picker></div><div flex \nclass=\"date-container\"><md-input-container class=\"md-block\"><label>UTC Date</label><input type=\"text\" \nng-model=\"vm.image.file_date.utcShow\" disabled=\"disabled\"></md-input-container></div></div></div><div \nclass=\"date-time-picker section\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"section-title\">Date uploaded</span></div><div layout=\"row\" layout-gt-sm=\"row\"><div flex class=\"date-container\">\n<mdp-date-picker mdp-placeholder=\"Date\" mdp-format=\"{{vm.dateFormat}}\" mdp-open-on-click=\"true\" \nng-model=\"vm.image.date_uploaded.date\" ng-change=\"vm.updateDatePicker(\'date_uploaded\')\"></mdp-date-picker></div><div \nflex class=\"date-container\"><mdp-time-picker mdp-placeholder=\"Time\" mdp-auto-switch=\"true\" mdp-open-on-click=\"true\" \nng-model=\"vm.image.date_uploaded.date\" ng-change=\"vm.updateDatePicker(\'date_uploaded\')\"></mdp-time-picker></div><div \nflex class=\"date-container\"><md-input-container class=\"md-block\"><label>UTC Date</label><input type=\"text\" \nng-model=\"vm.image.date_uploaded.utcShow\" disabled=\"disabled\"></md-input-container></div></div></div><div \nclass=\"geoloc section\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"section-title\" translate=\"CONTENT.GEOLOCALIZATION\">Geolocation</span></div><div layout=\"row\" layout-gt-sm=\"row\">\n<md-input-container class=\"md-block\" flex><label translate=\"CONTENT.GEOLAT\">ID</label><input \nng-model=\"vm.image.geoLat\" type=\"text\"></md-input-container><md-input-container class=\"md-block\" flex><label \ntranslate=\"CONTENT.GEOLON\">ID</label><input ng-model=\"vm.image.geoLon\" type=\"text\"></md-input-container></div></div>\n<md-input-container class=\"md-block\"><label translate=\"CONTENT.USE\">Use</label><input ng-model=\"vm.image.uses\" \ntype=\"text\"></md-input-container><md-input-container class=\"md-block\" ng-hide=\"vm.image.media_type == 2\"><label \ntranslate=\"CONTENT.EXTRAS\">Extras</label><input ng-model=\"vm.image.extra\" type=\"text\"></md-input-container><div \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-accent\" ng-click=\"vm.allFields = false\" \ntranslate=\"CONTENT.FEWER_FIELDS\">Fewer Fields</md-button></div></div></div></div></div></md-content><md-content \nng-show=\"vm.mediaSelected && vm.editInline\" ng-include=\"\'app/main/apps/media/views/edit-media.html\'\" \nclass=\"scrollable\"></md-content></div>");
$templateCache.put("app/main/apps/media/views/split-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/media/views/toolbar.html\'\" ng-if=\"vm.media_type_name != \'galleries\'\"></div><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/media/views/galleries-toolbar.html\'\" ng-if=\"vm.media_type_name == \'galleries\'\"></div><div \nclass=\"content-wrapper\" flex=\"\" layout=\"row\"><div class=\"content thread-list mail-list-pane\" flex=\"50\" \nid=\"thread-list\" ng-if=\"vm.media_type_name != \'galleries\'\" \nng-include=\"\'app/main/apps/media/views/list/items-view.html\'\" on-size-changed=\"vm.logResize\" \nng-style=\"(!vm.mediaSelected || vm.currentListView == \'gridGoogle\') && {\'max-width\': \'100%\'} || {\'max-width\': \'50%\'}\">\n</div><div class=\"content thread-list mail-list-pane\" flex=\"50\" id=\"thread-list\" \nng-if=\"vm.media_type_name == \'galleries\'\" ng-include=\"\'app/main/apps/media/views/list/galleries-view.html\'\" \non-size-changed=\"vm.logResize\" \nng-style=\"(!vm.mediaSelected || vm.currentListView == \'gridGoogle\') && {\'max-width\': \'100%\'} || {\'max-width\': \'50%\'}\">\n</div><div class=\"content thread-detail mail-read-pane\" flex=\"50\" id=\"thread-detail\" layout=\"column\" \nng-include=\"\'app/main/apps/media/views/edit-layout.html\'\" \nng-if=\"vm.mediaSelected && vm.currentListView !== \'gridGoogle\'\"></div><md-sidenav \nng-if=\"vm.currentListView == \'gridGoogle\'\" class=\"sidenav-media md-sidenav-right sidenav\" \nmd-component-id=\"sidenav-media\" ng-include=\"\'app/main/apps/media/views/edit-layout.html\'\" ms-scroll ms-sidenav-helper \nmd-no-ink></md-sidenav></div>");
$templateCache.put("app/main/apps/media/views/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-label\" \naria-label=\"{{vm.selectedThreads.length > 0 ? \'Deselect All\' : \'Select All\'}}\" \nng-checked=\"vm.selectedThreads.length > 0\" ng-click=\"vm.toggleSelectThreads()\"></md-checkbox><div \nclass=\"divider-vertical\" hide=\"\" show-gt-xs=\"\"></div><md-button \nng-disabled=\"vm.selectedGallery && vm.selectedGallery.no_files_allowed == true\" aria-label=\"ADD NEW\" \nclass=\"md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme\" hide show-gt-sm \nng-click=\"vm.AddmediaDialog()\" translate=\"CONTENT.ADD\" type=\"button\">Add new</md-button><md-button \nng-disabled=\"vm.selectedGallery && vm.selectedGallery.no_files_allowed == true\" aria-label=\"ADD NEW\" \nclass=\"md-fab md-mini md-accent green-500-bg md-raised md-ink-ripple md-default-theme\" hide-gt-sm \nng-click=\"vm.AddmediaDialog()\" type=\"button\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><div \nng-if=\"vm.media_type_name != \'galleries\' && vm.media_type_name != \'Image Rekognition\'\" class=\"divider-vertical\" \nhide=\"\" show-gt-xs=\"\"></div><div layout=\"row\" layout-align=\"start center\" class=\"groups-trigger\"><button \naria-label=\"view group\" class=\"md-button md-icon-button\" \nng-if=\"vm.media_type_name != \'galleries\' && vm.media_type_name != \'Image Rekognition\'\" \nng-click=\"vm.openGallerySidenav()\" translate translate-attr-aria-label=\"CONTENT.FILTERS\"><md-icon \nng-class=\"{\'icon-folder-multiple-image\':vm.media_type == 1, \'qiu-icon-video-gallery\':vm.media_type == 2,\'qiu-icon-audio-gallery\':vm.media_type == 3, \'qiu-icon-file-gallery\':vm.media_type == 4, \'icon-folder-multiple\':vm.media_type != 1 && vm.media_type != 2 && vm.media_type != 3 && vm.media_type != 4 }\">\n</md-icon><md-tooltip hide show-gt-xs><span translate=\"GALLERY.VIEW_GALLERIES\">View Galleries</span></md-tooltip>\n</button></div><div class=\"divider-vertical\" hide=\"\" show-gt-xs=\"\"></div><ms-search-bar debounce=\"300\" \nmodel-search=\"$root.pagination_searchquery\" on-result-click=\"vm.searchResultClick(item)\" on-search=\"vm.search(query)\" \nlayout=\"row\" layout-align=\"start center\"></ms-search-bar><md-button aria-label=\"view type\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'main-sidenav\')\" translate=\"\" translate-attr-aria-label=\"CONTENT.FILTERS\"><md-icon \nmd-font-icon=\"icon-filter\"></md-icon><md-tooltip><span translate=\"CONTENT.FILTERS\">Filters</span></md-tooltip>\n</md-button><div class=\"divider-vertical\" hide=\"\" show-gt-xs=\"\"></div><md-button \nng-if=\"vm.getSettingValue(vm.settingsSection, (vm.media_type_name == \'galleries\' || vm.selectedGallery) ? \'sortDirInGallery\' : \'sortDir\', sortDir) !== \'ASC\'\" \naria-label=\"Sort Direction\" class=\"md-icon-button\" ng-click=\"vm.setSortDir(\'ASC\')\" ng-disabled=\"!sortField\" \ntranslate=\"\" translate-attr-aria-label=\"TODO.SORT_DIRECTION\"><md-icon md-font-icon=\"icon-sort-descending\"></md-icon>\n</md-button><md-button \nng-if=\"vm.getSettingValue(vm.settingsSection, (vm.media_type_name == \'galleries\' || vm.selectedGallery) ? \'sortDirInGallery\' : \'sortDir\', sortDir) === \'ASC\'\" \naria-label=\"Sort Direction\" class=\"md-icon-button\" ng-click=\"vm.setSortDir(\'DESC\')\" ng-disabled=\"!sortField\" \ntranslate=\"\" translate-attr-aria-label=\"TODO.SORT_DIRECTION\"><md-icon md-font-icon=\"icon-sort-ascending\"></md-icon>\n</md-button><md-menu><button aria-label=\"Filters\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" show-gt-xs=\"\" \ntranslate=\"\" translate-attr-aria-label=\"CONTENT.FILTERS\"><md-icon md-font-icon=\"icon-chevron-down\"><md-tooltip><span \ntranslate=\"CONTENT.ORDER_BY\">Order</span></md-tooltip></md-icon></button><md-menu-content width=\"4\"><md-menu-item \nng-repeat=\"sortfield in refSortables\" ng-if=\"!sortfield.showOnly || (sortfield.showOnly == vm.viewSortType)\"><md-button\n aria-label=\"All\" ng-click=\"vm.setSortField(sortfield.titleId)\"><div layout=\"row\" layout-align=\"space-between center\">\n<span>Order by {{sortfield.name}} </span><i class=\"icon-check s16\" \nng-if=\"sortfield.titleId == vm.getSettingValue(vm.settingsSection, (vm.media_type_name == \'galleries\' || vm.selectedGallery) ? \'sortFieldInGallery\' : \'sortField\', \'date_uploaded\') \">\n</i></div></md-button></md-menu-item><md-menu-item ng-if=\"sortable\"><md-button aria-label=\"Remove sort\" \nng-click=\"pagination_resetOrderBy()\"><md-icon md-font-icon=\"icon-close \"></md-icon><span>Remove order</span>\n</md-button></md-menu-item></md-menu-content></md-menu><md-button class=\"md-accent green-500-bg md-raised md-button\" \nng-click=\"vm.getUncroppedMedias()\"><md-label>UNCROPPED</md-label></md-button><div aria-hidden=\"false\" \nclass=\"action-buttons\" layout=\"row\" layout-align=\"start center\" ng-show=\"vm.selectedThreads.length > 0\" hide \nshow-gt-xs><div class=\"divider-vertical\" hide=\"\" show-gt-xs=\"\"></div><md-button aria-label=\"Export\" \nng-click=\"vm.AddMediaItemToGalleryDialog()\" class=\"md-icon-button\" hide=\"\" show-gt-sm=\"\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.EXPORT\"><md-icon md-font-icon=\"icon-folder-upload\"></md-icon><md-tooltip><span \ntranslate=\"MEDIA.ADDTOGALLERIES\">Add to Galleries</span></md-tooltip></md-button><md-button aria-label=\"Remove\" \nng-click=\"vm.RemoveMediaItemFromGalleryDialog()\" class=\"md-icon-button\" hide=\"\" show-gt-sm=\"\" translate=\"\" \ntranslate-attr-aria-label=\"MEDIA.REMOVEFROMGALLERY\" ng-if=\"vm.selectedGallery\"><md-icon \nmd-font-icon=\"icon-folder-remove\"></md-icon><md-tooltip><span translate=\"MEDIA.REMOVEFROMGALLERY\">Remove from Gallery\n</span></md-tooltip></md-button><md-button aria-label=\"Export\" ng-click=\"vm.EditMultipleFieldsDialog()\" \nclass=\"md-icon-button\" hide=\"\" show-gt-sm=\"\" translate=\"\" translate-attr-aria-label=\"CONTENT.EXPORT\" \nng-if=\"vm.selectedThreads.length > 1 \"><md-icon md-font-icon=\"icon-tooltip-edit\"></md-icon><md-tooltip><span \ntranslate=\"MEDIA.EDITMULTIPLEFIELDS\">Edit Multiple Fields</span></md-tooltip></md-button><md-button \nng-click=\"vm.deleteMediaItem($event)\" aria-label=\"Delete\" class=\"md-icon-button\" hide=\"\" show-gt-sm=\"\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span \ntranslate=\"CONTENT.DELETE\">Delete</span></md-tooltip></md-button><md-button ng-click=\"vm.downloadSelected($event)\" \naria-label=\"Download\" class=\"md-icon-button\" hide=\"\" show-gt-sm=\"\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.DOWNLOAD\"><md-icon md-font-icon=\"icon-download\"></md-icon><md-tooltip><span \ntranslate=\"CONTENT.DOWNLOAD\">Download</span></md-tooltip></md-button><md-button ng-click=\"vm.shareDialog($event)\" \naria-label=\"Delete\" class=\"md-icon-button\" hide=\"\" show-gt-sm=\"\" translate=\"\" translate-attr-aria-label=\"MEDIA.SHARE\">\n<md-icon md-font-icon=\"icon-share\"></md-icon><md-tooltip><span translate=\"MEDIA.SHARE\">SHARE</span></md-tooltip>\n</md-button><md-button ng-click=\"vm.massRecropMedia($event)\" aria-label=\"Recrop\" class=\"md-icon-button\" hide=\"\" \nshow-gt-sm=\"\" translate=\"\" translate-attr-aria-label=\"MEDIA.RECROP\"><md-icon md-font-icon=\"icon-crop\"></md-icon>\n<md-tooltip><span translate=\"MEDIA.RECROP\">RECROP</span></md-tooltip></md-button><div class=\"divider-vertical\" hide=\"\" \nshow-gt-xs=\"\"></div><span ng-if=\"vm.selectedThreads.length > 0\" class=\"page-info ml-10\" hide=\"\" show-gt-xs=\"\">\n{{vm.selectedThreads.length | number}} items selected.</span></div></div><div layout=\"row\" layout-align=\"start center\" \ntranslate-attr-aria-label=\"CONTENT.REFRESH\" class=\"qiu-pagination\" \nng-hide=\"isLoading || (vm.media_type_name == \'galleries\' && vm.isRoot && !$root.pagination_searchquery)\"><span \nclass=\"page-info\" hide=\"\" show-gt-xs=\"\">{{pagination_totalItems | number}} items found.</span><md-button \naria-label=\"Previous\" class=\"md-icon-button arrow\" hide=\"\" ng-click=\"pagination_prevPage()\" \nng-disabled=\"pagination_firstPage()\" show-gt-xs=\"\" translate=\"\" translate-attr-aria-label=\"CONTENT.PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.PREVIOUS\">Previous\n</span></md-tooltip></md-button><div hide show-gt-xs><md-select ng-model=\"pagination_page\" placeholder=\"Page\" \nclass=\"toolbar-item\"><md-option ng-repeat=\"n in [].constructor(pagination_total_pages) track by $index\" \nvalue=\"{{$index +1}}\" ng-click=\"pagination_gotoPage($index+1)\">{{$index+1}}</md-option></md-select><md-tooltip><span \ntranslate=\"CONTENT.SELECT_PAGE\">Select page</span></md-tooltip></div><span class=\"page-info ml-10\" hide=\"\" \nshow-gt-xs=\"\">/ <span class=\"ml-5\">{{pagination_total_pages | number}}</span></span><md-button aria-label=\"Next\" \nclass=\"md-icon-button arrow\" hide=\"\" ng-click=\"pagination_nextPage()\" ng-disabled=\"pagination_morePages()\" \nshow-gt-xs=\"\" translate=\"\" translate-attr-aria-label=\"CONTENT.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\">\n</md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.NEXT\">Next</span></md-tooltip></md-button><div \nclass=\"divider-vertical\" hide hide show-gt-sm></div><div class=\"limit-select mr-10 ml-10\" ng-if=\"!isLoading\" hide \nshow-gt-sm><md-select class=\"md-table-select\" ng-change=\"vm.setNewPerPageSize(vm.perPage)\" ng-model=\"vm.perPage\" \nmd-container-class=\"md-pagination-select\" aria-label=\"Rows\" placeholder=\"{{ $pagination.limitOptions[0] }}\"><md-option \nng-repeat=\"p in perPagePresets\" ng-value=\"p\">{{p}} {{::option.label ? option.label : option}}</md-option></md-select>\n<md-tooltip hide show-gt-xs><span translate=\"CONTENT.ITEMS_PER_PAGE\">Items per page</span></md-tooltip></div><div \nclass=\"divider-vertical\" hide hide show-gt-sm></div><md-button aria-label=\"Refresh\" class=\"md-icon-button\" hide=\"\" \nshow-gt-xs=\"\" ng-click=\"pagination_reload()\" translate=\"\" translate-attr-aria-label=\"MEDIA.REFRESH\" show-gt-xs><md-icon\n md-font-icon=\"icon-refresh\" show-gt-xs></md-icon></md-button><div class=\"divider-vertical\" hide hide show-gt-sm></div>\n<md-menu-bar class=\"pr-0 pl-0\"><md-menu class=\"settings-menu\"><md-button aria-label=\"Settings\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\" translate=\"\" translate-attr-aria-label=\"CONTENT.SETTINGS\"><md-icon \nng-class=\"{\'icon-tile-four\':vm.currentListView == \'grid\', \'icon-view-list\':vm.currentListView == \'list\', \'icon-grid\':vm.currentListView == \'gridGoogle\'}\">\n</md-icon></md-button><md-menu-content><md-menu-item ng-if=\"vm.currentListView !== \'grid\'\"><md-button \nng-click=\"vm.changeListView(\'grid\')\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-tile-four\"></md-icon><span translate=\"MEDIA.THUMBNAILS_VIEW\">List view</span></div></md-button>\n</md-menu-item><md-menu-item ng-if=\"vm.currentListView !== \'list\'\"><md-button ng-click=\"vm.changeListView(\'list\')\"><div\n layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-view-list\"></md-icon><span \ntranslate=\"MEDIA.LIST_VIEW\">List view</span></div></md-button></md-menu-item><md-menu-item \nng-if=\"vm.currentListView !== \'gridGoogle\'\"><md-button ng-click=\"vm.changeListView(\'gridGoogle\')\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-grid\"></md-icon><span translate=\"MEDIA.GRID_VIEW\">Grid view\n</span></div></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><md-menu-bar class=\"pr-0 pl-0\" \nhide-gt-xs><md-menu class=\"settings-menu\"><md-button aria-label=\"Settings\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\" translate=\"\" translate-attr-aria-label=\"CONTENT.SETTINGS\"><md-icon \nmd-font-icon=\"icon-cog\"></md-icon></md-button><md-menu-content><md-menu-item ng-if=\"vm.currentListView !== \'grid\'\">\n<md-button ng-click=\"vm.changeListView(\'grid\')\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-tile-four\"></md-icon><span translate=\"MEDIA.THUMBNAILS_VIEW\">List view</span></div></md-button>\n</md-menu-item><md-menu-item ng-if=\"vm.currentListView !== \'list\'\"><md-button ng-click=\"vm.changeListView(\'list\')\"><div\n layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-view-list\"></md-icon><span \ntranslate=\"MEDIA.LIST_VIEW\">List view</span></div></md-button></md-menu-item><md-menu-item \nng-if=\"vm.currentListView !== \'gridGoogle\'\"><md-button ng-click=\"vm.changeListView(\'gridGoogle\')\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-grid\"></md-icon><span translate=\"MEDIA.GRID_VIEW\">Grid view\n</span></div></md-button></md-menu-item><md-menu-item><md-menu><md-button aria-label=\"Filters\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-sort\"></md-icon><span translate=\"CONTENT.ORDER_BY\">Order by\n</span></md-button><md-menu-content><md-menu-item ng-repeat=\"sortfield in refSortables\"><md-button aria-label=\"All\" \nng-click=\"vm.setSortField(sortfield.titleId)\"><div layout=\"row\" layout-align=\"space-between center\"><span>\n{{sortfield.name}}</span> <i class=\"icon-check s16\" ng-if=\"sortfield.titleId == sortField\"></i></div></md-button>\n</md-menu-item><md-menu-item ng-repeat=\"field in vm.refcolumns\" ng-if=\"field.sortable === 1\"><md-button \nng-click=\"vm.setSortField(field.title)\"><div layout=\"row\" layout-align=\"space-between center\"><span>\n{{field.field_name}}</span> <i class=\"icon-check s16\" ng-if=\"vm.fieldOrder === field.field_name\"></i></div></md-button>\n</md-menu-item></md-menu-content></md-menu></md-menu-item><md-menu-item><md-button ng-click=\"vm.setSortDir(\'ASC\')\" \nng-disabled=\"!sortField\"><div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-sort-ascending\"></md-icon><span \ntranslate=\"CONTENT.DIRECTION_A_Z\">Order A-Z</span></div><i class=\"icon-check s16\" ng-if=\"sortDir === \'ASC\'\"></i></div>\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.setSortDir(\'DESC\')\" ng-disabled=\"!sortField\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-sort-descending\"></md-icon><span translate=\"CONTENT.DIRECTION_Z_A\">Order Z-A</span></div><i \nclass=\"icon-check s16\" ng-if=\"sortDir === \'DESC\'\"></i></div></md-button></md-menu-item><md-menu-item><md-button \naria-label=\"Export\" ng-click=\"vm.AddMediaItemToGalleryDialog()\" ng-disabled=\"vm.selectedThreads.length == 0\"><md-icon \nmd-font-icon=\"icon-folder-upload\"></md-icon><span translate=\"MEDIA.ADDTOGALLERIES\">Add to Galleries</span></md-button>\n</md-menu-item><md-menu-item ng-if=\"vm.selectedGallery\"><md-button aria-label=\"Export\" \nng-click=\"vm.RemoveMediaItemFromGalleryDialog()\" ng-disabled=\"vm.selectedThreads.length == 0\"><md-icon \nmd-font-icon=\"icon-folder-remove\"></md-icon><span translate=\"MEDIA.REMOVEFROMGALLERY\">Remove from Gallery</span>\n</md-button></md-menu-item><md-menu-item><md-button aria-label=\"Export\" ng-click=\"vm.EditMultipleFieldsDialog()\" \nng-disabled=\"vm.selectedThreads.length == 0\"><md-icon md-font-icon=\"icon-tooltip-edit\"></md-icon><span \ntranslate=\"MEDIA.EDITMULTIPLEFIELDS\">Edit Multiple Fields</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.downloadSelected($event)\" aria-label=\"Download\" ng-disabled=\"vm.selectedThreads.length == 0\"><md-icon \nmd-font-icon=\"icon-download\"></md-icon><span translate=\"CONTENT.DOWNLOAD\">Download</span></md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.deleteMediaItem($event)\" aria-label=\"Delete\" \nng-disabled=\"vm.selectedThreads.length == 0\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span \ntranslate=\"CONTENT.DELETE\">Delete</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"pagination_reload()\" aria-label=\"REFRESH\"><md-icon md-font-icon=\"icon-refresh\"></md-icon><span \ntranslate=\"MEDIA.REFRESH\">REFRESH</span></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div>");
$templateCache.put("app/main/apps/mediahub/faces/face-assign-dialog.html","<md-dialog id=\"face-assign-dialog\" aria-label=\"Assign face\" style=\"max-width: 520px; width: 100%; max-height: 90vh\">\n<md-toolbar><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"icon-account-question\" class=\"mr-8\" \nng-if=\"dialog.step === \'identify\'\"></md-icon><md-icon md-font-icon=\"icon-check-circle\" class=\"mr-8 green-fg\" \nng-if=\"dialog.step === \'retroactive\'\"></md-icon><h2 ng-if=\"dialog.step === \'identify\'\">Identify face</h2><h2 \nng-if=\"dialog.step === \'retroactive\'\">More photos found</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"dialog.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content style=\"padding: 0; overflow-y: auto\"><div ng-if=\"dialog.step === \'identify\'\"><div \nclass=\"face-dialog-photo-wrap\" style=\"position: relative; background: #111; line-height: 0\"><img \nng-src=\"{{dialog.photo.previewUrl}}\" style=\"width: 100%; display: block\"><div ng-repeat=\"f in dialog.photo.faces\" \nng-style=\"dialog.dimStyle(f.boundingBox, f.unknownId === dialog.face.unknownId)\" class=\"face-dialog-box\"></div></div>\n<div layout=\"row\" layout-align=\"start center\" class=\"p-16 pb-0\"><div class=\"face-crop-preview mr-16\" \nng-style=\"dialog.cropStyle()\" \nstyle=\"width: 72px; height: 72px; border-radius: 4px; flex-shrink: 0; border: 2px solid #ff4444\"></div><div flex \nlayout=\"column\"><span class=\"grey-500-fg font-size-12\">Confidence: {{dialog.face.confidence | number:1}}% </span><span \nclass=\"grey-400-fg font-size-11 mt-4\">ID: {{dialog.face.unknownId}}</span></div></div><div class=\"p-16\"><form \nname=\"dialog.form\" novalidate><md-autocomplete class=\"md-block\" md-selected-item=\"dialog.selectedTag\" \nmd-search-text=\"dialog.name\" md-items=\"tag in dialog.searchTags(dialog.name)\" md-item-text=\"tag.tagName\" \nmd-min-length=\"1\" md-no-cache=\"true\" md-autofocus=\"true\" placeholder=\"e.g. Ben Ainslie\" md-floating-label=\"Name / Tag\" \nrequired><md-item-template><span layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-account\" \nclass=\"s16 mr-8 grey-500-fg\"></md-icon><span md-highlight-text=\"dialog.name\" md-highlight-flags=\"^i\">{{tag.tagName}}\n</span> <span class=\"ml-8 font-size-11 grey-400-fg\">({{tag.tagType}})</span></span></md-item-template><md-not-found>\n<span layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-plus\" class=\"s16 mr-8 green-fg\"></md-icon>\n<span>Create new tag: <strong>\"{{dialog.name}}\"</strong></span></span></md-not-found></md-autocomplete>\n<md-input-container class=\"md-block\" flex ng-if=\"!dialog.selectedTag\"><label>Tag type</label><md-select \nng-model=\"dialog.tagType\"><md-option value=\"people\">people</md-option><md-option value=\"sponsors\">sponsors</md-option>\n<md-option value=\"team\">team</md-option><md-option value=\"general\">general</md-option></md-select></md-input-container>\n<div class=\"mt-8 font-size-12\" ng-if=\"dialog.name.length > 1\"><span ng-if=\"dialog.selectedTag\" class=\"green-fg\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-check-circle\" class=\"s14 mr-4\"></md-icon>\nAssign to existing tag <strong class=\"ml-4\">\"{{dialog.selectedTag.tagName}}\"</strong> </span><span \nng-if=\"!dialog.selectedTag\" class=\"orange-fg\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-plus-circle\" class=\"s14 mr-4\"></md-icon>Create new verified tag <strong class=\"ml-4\">\n\"{{dialog.name}}\"</strong></span></div></form></div></div><div ng-if=\"dialog.step === \'retroactive\'\" class=\"p-24\" \nlayout=\"column\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-check-circle\" class=\"s64 green-fg mb-16\">\n</md-icon><div class=\"font-size-18 mb-8 text-center\">Face identified as <strong>\"{{dialog.assignedName}}\"</strong>\n</div><div class=\"font-size-14 grey-600-fg text-center mb-24\">Rekognition found <strong \nclass=\"accent-fg font-size-20 ml-4 mr-4\">{{dialog.retroactiveMatches.length}}</strong> other photo(s) with this person.\n</div><div class=\"retroactive-box md-whiteframe-1dp p-16 mb-16\" \nstyle=\"width: 100%; border-radius: 4px; background: #f9f9f9\"><div class=\"font-size-13 grey-700-fg mb-8\"><md-icon \nmd-font-icon=\"icon-tag-multiple\" class=\"s16 mr-4\"></md-icon>Apply <strong>\"{{dialog.assignedName}}\"</strong>\n tag to those photos too?</div><div class=\"font-size-12 grey-500-fg\">\nThis will tag {{dialog.retroactiveMatches.length}} photo(s) and mark those faces as identified — they will be removed from the unknown faces list.\n</div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><span \nng-if=\"dialog.step === \'identify\'\"><md-button ng-click=\"dialog.cancel()\" class=\"md-raised\" ng-disabled=\"dialog.saving\">\nCancel</md-button><md-button ng-click=\"dialog.save()\" class=\"md-raised md-accent\" \nng-disabled=\"!dialog.name || dialog.name.length < 2 || dialog.saving\"><span ng-if=\"!dialog.saving\">Assign</span> <span \nng-if=\"dialog.saving\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"18\" class=\"md-accent\">\n</md-progress-circular></span></md-button></span><span ng-if=\"dialog.step === \'retroactive\'\"><md-button \nng-click=\"dialog.skipRetroactive()\" class=\"md-raised\" ng-disabled=\"dialog.saving\">Skip</md-button><md-button \nng-click=\"dialog.applyRetroactive()\" class=\"md-raised md-accent\" ng-disabled=\"dialog.saving\"><span \nng-if=\"!dialog.saving\">Yes, tag {{dialog.retroactiveMatches.length}} photo(s) </span><span ng-if=\"dialog.saving\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"18\" class=\"md-accent\"></md-progress-circular></span>\n</md-button></span></md-dialog-actions></md-dialog><style>\n#face-assign-dialog .face-dialog-box { pointer-events: none; }</style>");
$templateCache.put("app/main/apps/mediahub/faces/faces.html","<div id=\"mediahub-faces\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button aria-label=\"Refresh\" \nclass=\"md-icon-button\" ng-click=\"vm.loadFaces()\"><md-icon md-font-icon=\"icon-refresh\"></md-icon><md-tooltip><span>\nRefresh</span></md-tooltip></md-button></div><div layout=\"row\" layout-align=\"end center\"><span class=\"page-info\" \nng-if=\"!vm.isLoading\">{{vm.total}} unknown face(s) in {{vm.photos.length}} photo(s)</span></div></div><div flex \nlayout=\"row\" layout-align=\"center center\" ng-if=\"vm.isLoading\" style=\"min-height: 300px\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"60\"></md-progress-circular></div><div flex layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!vm.isLoading && vm.photos.length === 0\" style=\"min-height: 300px\"><div \nclass=\"grey-500-fg font-size-20\">No unknown faces found.</div></div><div class=\"faces-grid\" layout=\"row\" layout-wrap \nng-if=\"!vm.isLoading && vm.photos.length > 0\"><div class=\"face-photo-card\" ng-repeat=\"photo in vm.photos\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-sm=\"33\" flex-gt-md=\"25\" layout=\"column\"><md-card class=\"m-8\"><div class=\"face-photo-wrapper\" \nstyle=\"position: relative; overflow: hidden; background: #111; cursor: default\"><img ng-src=\"{{photo.previewUrl}}\" \nalt=\"{{photo.title}}\" style=\"width: 100%; display: block\" loading=\"lazy\"><div ng-repeat=\"face in photo.faces\" \nng-style=\"vm.boxStyle(face.boundingBox, false, face.status === \'identified\')\" class=\"face-bounding-box\" \nng-class=\"{\'face-identified\': face.status === \'identified\'}\" \nng-click=\"face.status !== \'identified\' && vm.openAssignDialog(photo, face, $event)\"><div class=\"face-bb-label\" \nng-class=\"{\'face-bb-label--identified\': face.status === \'identified\'}\" \nng-click=\"face.status !== \'identified\' && (vm.openAssignDialog(photo, face, $event), $event.stopPropagation())\">\n{{face.identifiedAs || \'?\'}}</div><md-tooltip md-direction=\"top\" ng-if=\"face.status !== \'identified\'\">\nClick to identify this face</md-tooltip><md-tooltip md-direction=\"top\" ng-if=\"face.status === \'identified\'\">\n{{face.identifiedAs}}</md-tooltip></div></div><md-card-content class=\"p-8\"><div \nclass=\"font-size-12 grey-600-fg text-truncate\" ng-if=\"photo.fileName\">{{photo.fileName}}</div><div class=\"mt-4\" \nlayout=\"row\" layout-align=\"start center\" ng-if=\"photo.faces | filter:{status:\'!identified\'} | property:\'length\'\">\n<md-icon md-font-icon=\"icon-account-question\" class=\"s14 mr-4 orange-fg\"></md-icon><span \nclass=\"font-size-11 orange-fg\">{{(photo.faces | filter:{status:\'!identified\'}).length}} unknown face(s)</span></div>\n</md-card-content><md-list class=\"p-0\" style=\"border-top: 1px solid #eee\"><md-list-item class=\"face-detail-item\" \nng-repeat=\"face in photo.faces\" ng-class=\"{\'face-item-identified\': face.status === \'identified\'}\" \nng-click=\"face.status !== \'identified\' && vm.openAssignDialog(photo, face, $event)\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex><div layout=\"row\" layout-align=\"start center\"><md-icon \nng-if=\"face.status === \'identified\'\" md-font-icon=\"icon-account-check\" class=\"s16 mr-8 green-fg\"></md-icon><md-icon \nng-if=\"face.status !== \'identified\'\" md-font-icon=\"icon-account-question\" class=\"s16 mr-8 orange-fg\"></md-icon><span \nclass=\"font-size-11\" ng-class=\"face.status === \'identified\' ? \'green-fg\' : \'grey-600-fg\'\">\n{{face.identifiedAs || \'Unknown #\' + ($index + 1)}}</span></div><span class=\"font-size-10 grey-400-fg\">\n{{face.confidence | number:1}}%</span></div><md-icon ng-if=\"face.status !== \'identified\'\" \nmd-font-icon=\"icon-chevron-right\" class=\"s16 grey-400-fg\" md-menu-align-target></md-icon></md-list-item></md-list>\n</md-card></div></div></div><style>\n#mediahub-faces .toolbar {\r\n        padding: 0 8px;\r\n        min-height: 56px;\r\n        border-bottom: 1px solid rgba(0,0,0,.12);\r\n    }\r\n\r\n    #mediahub-faces .page-info {\r\n        font-size: 12px;\r\n        color: rgba(0,0,0,.54);\r\n        padding-right: 8px;\r\n    }\r\n\r\n    #mediahub-faces .faces-grid {\r\n        padding: 8px;\r\n    }\r\n\r\n    #mediahub-faces .face-bounding-box {\r\n        cursor: pointer;\r\n        transition: border-color 0.15s, box-shadow 0.15s;\r\n    }\r\n\r\n    #mediahub-faces .face-bounding-box:hover {\r\n        border-color: #ff0000 !important;\r\n        box-shadow: 0 0 0 1px rgba(0,0,0,0.6) !important;\r\n    }\r\n\r\n    #mediahub-faces .face-bb-label {\r\n        position: absolute;\r\n        top: -20px;\r\n        left: -2px;\r\n        background: #ff4444;\r\n        color: #fff;\r\n        font-size: 11px;\r\n        font-weight: bold;\r\n        padding: 1px 6px;\r\n        line-height: 18px;\r\n        cursor: pointer;\r\n        border-radius: 2px 2px 0 0;\r\n        user-select: none;\r\n    }\r\n\r\n    #mediahub-faces .face-bb-label:hover {\r\n        background: #cc0000;\r\n    }\r\n\r\n    #mediahub-faces .face-bb-label--identified {\r\n        background: #4caf50;\r\n        cursor: default;\r\n        max-width: 120px;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n        white-space: nowrap;\r\n    }\r\n\r\n    #mediahub-faces .face-bb-label--identified:hover {\r\n        background: #4caf50;\r\n    }\r\n\r\n    #mediahub-faces .face-item-identified {\r\n        opacity: 0.7;\r\n        cursor: default !important;\r\n    }\r\n\r\n    #mediahub-faces .face-detail-item {\r\n        min-height: 36px !important;\r\n        height: 36px;\r\n        padding: 0 12px;\r\n        cursor: pointer;\r\n    }\r\n\r\n    #mediahub-faces .face-detail-item:hover {\r\n        background: rgba(0,0,0,.04);\r\n    }\n</style>");
$templateCache.put("app/main/apps/runtag/commercial/commercial.html","<div layout=\"column\" flex=\"100\" id=\"site-content\" class=\"page-layout carded left-sidenav users-in-events\"><div \nid=\"rs-main-container\" class=\"center\" layout-align=\"space-between center\" flex=\"100\" style=\"overflow-y: scroll\"><div \nflex=\"100\" style=\"height: 100%\" \nng-include=\"\'app/main/apps/runtag/commercial/views/templates/commercial-template-v2.html\'\"></div></div></div>");
$templateCache.put("app/main/apps/mediahub/views/edit-layout.html","<div flex layout=\"column\" layout-align=\"center center\" ng-if=\"vm.loadingReadPane\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nng-show=\"!vm.loadingReadPane\"><div class=\"toolbar grey-100-bg colored-bg\" layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"vm.mediaSelected\" scroll=\"\"><div layout=\"row\" layout-align=\"start center\">\n<md-button aria-label=\"Info\" class=\"md-icon-button\" ng-click=\"vm.closeMediaPreview()\" \nng-if=\"vm.mediaSelected && (vm.currentView==\'nosplit\' || !vm.$mdMedia(\'gt-sm\'))\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><span \nclass=\"grey-600-fg font-size-14 font-weight-500 ml-8\" ng-if=\"vm.image && vm.image.id_media\">ID: {{vm.image.id_media}}\n</span></div><div layout=\"row\" layout-align=\"end center\" ng-if=\"vm.mediaSelected\"><md-button type=\"submit\" \nng-click=\"vm.saveImage(vm.image)\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.basicForm.$invalid || vm.basicForm.$pristine\" aria-label=\"SAVE\" translate=\"CONTENT.SAVE\" \ntranslate-attr-aria-label=\"CONTENT.SAVE\">SAVE</md-button><md-button type=\"button\" ng-click=\"vm.closeMediaPreview()\" \nclass=\"md-raised md-warn\" aria-label=\"Cancel\">Cancel</md-button></div></div><md-content \nng-style=\"{\'height\' : vm.currentListView == \'gridGoogle\' ? \'calc(100vh - 129px)\' : auto}\" \nng-if=\"vm.mediaSelectedLoaded\" ng-include=\"\'app/main/apps/mediahub/views/edit-media.html\'\" class=\"scrollable\">\n</md-content></div>");
$templateCache.put("app/main/apps/mediahub/views/edit-media.html","<div id=\"content-edit\" class=\"page-layout simple fullwidth mail-content content-edit\" layout=\"column\"><md-tabs><md-tab \nmd-on-select=\"vm.tabSelected=\'Rekognition\'\" ng-if=\"vm.media_type_name != \'Image Rekognition\'\" label=\"Edit\"><div \nlayout=\"row\" ng-include=\"\'app/main/apps/mediahub/views/tabs/tab-edit.html\'\"></div></md-tab><md-tab \nmd-on-select=\"vm.tabSelected=\'Rekognition1\'; vm.showCropformatsTab()\" \nng-if=\"vm.media_type_name != \'Image Rekognition\' && (vm.image.media_type == 1 || (vm.image.media_type == 2 && vm.image.embed.indexOf(\'zc|\') !== -1))\" \nlabel=\"Cropformats{{(vm.image.media_type == 1 ? vm.image.cropstatus.length : vm.image.cropstatus_videos.length) > 0 ? \' (\' + (vm.image.media_type == 1 ? vm.image.cropstatus.length : vm.image.cropstatus_videos.length) + \')\' : \'\'}}\">\n<div ng-include=\"\'app/main/apps/mediahub/views/tabs/tab-cropformats.html\'\"></div></md-tab><md-tab \nmd-on-select=\"vm.tabSelected=\'Rekognition2\'\" ng-if=\"vm.media_type_name != \'Image Rekognition\'\" \nlabel=\"{{vm.translate(\'MEDIA.GALLERIES\')}}{{((vm.image.galleries || vm.currentItem.galleries).length || 0) > 0 ? \' (\' + ((vm.image.galleries || vm.currentItem.galleries).length || 0) + \')\' : \'\'}}\">\n<div layout=\"row\" ng-include=\"\'app/main/apps/mediahub/views/tabs/tab-galleries.html\'\"></div></md-tab><md-tab \nmd-on-select=\"vm.tabSelected=\'AI\'\" label=\"{{vm.translate(\'AI\')}}\" \nng-if=\"vm.image.meta_analyses != null && vm.media_type_name != \'Image Rekognition\'\"><div layout=\"row\" \nng-include=\"\'app/main/apps/mediahub/views/tabs/tab-ai.html\'\"></div></md-tab><md-tab \nmd-on-select=\"vm.tabSelected=\'AI_RECOGNITION\'\" label=\"{{vm.translate(\'MEDIA.AI_RECOGNITION\')}}\" \nng-if=\"vm.image.ai_recognition != null\"><div ng-if=\"vm.media_type_name == \'Image Rekognition\'\" \nclass=\"frame-marks size block p-0-i relative\" layout=\"row\" layout-align=\"start left\"><img \nng-src=\"{{vm.image.imageUrlOriginal}}\" alt=\"\"> <span ng-repeat=\"person in vm.image.ai_recognition.ignored_persons\">\n<span class=\"label-mark\" \nstyle=\"border: 1px solid red; opacity: 1; top: {{person.detected_person.BoundingBox.Top*100}}%; left: {{person.detected_person.BoundingBox.Left*100}}%; width: {{person.detected_person.BoundingBox.Width*100}}%; height: {{person.detected_person.BoundingBox.Height*100}}%\">\n<span style=\"color: red; font-size: 18px\">ignored</span> </span></span><span \nng-repeat=\"person in vm.image.ai_recognition.persons\"><span title=\"{{person.id_user}}\" class=\"label-mark\" \nstyle=\"border: 2px solid green; opacity: 1; top: {{person.label.BoundingBox.Top*100}}%; left: {{person.label.BoundingBox.Left*100}}%; width: {{person.label.BoundingBox.Width*100}}%; height: {{person.label.BoundingBox.Height*100}}%\">\n<span style=\"padding: 2px; background-color: white; color: green; font-size: 18px\"># {{person.id_user}}</span></span>\n</span></div><div layout=\"column\" class=\"grid-view\" md-cols=\"2\" md-row-height=\"250\" md-gutter=\"12px\" \nmd-guttet-gt-sm=\"8px\"><div ng-repeat=\"person in vm.image.ai_recognition.persons\" class=\"grid-element sortable\" \ndata-id=\"{{person.id_user}}\"><div layout=\"column\" layout-align=\"space-between left\" flex><span><strong>\n#{{person.id_user}}</strong></span> <span><strong>Dorsal:</strong>{{person.number}}</span> <span><strong>Similarity:\n</strong>{{person.similarity | number}} %</span> <span><strong>Confidence:</strong>\n{{person.label.Confidence | number}} %</span> <span><strong>Face_id:</strong>{{person.face_id}}</span></div></div>\n</div></md-tab><md-tab md-on-select=\"vm.tabSelected=\'RELATED_PICTURES\'\" \nlabel=\"{{vm.translate(\'MEDIA.RELATED_PICTURES\')}}\" ng-if=\"vm.image.meta_analyses != null\"><div \nng-if=\"vm.media_type_name == \'Image Rekognition\'\" class=\"frame-marks size block p-0-i relative\" layout=\"row\" \nlayout-align=\"start left\"><img ng-src=\"{{vm.image.imageUrlOriginal}}\" alt=\"\"> <span \nng-repeat=\"labelItem in vm.image.meta_analyses.rekognition_detect_labels.Labels\" ng-if=\"labelItem.Name == \'Person\'\">\n<span title=\"{{labelItem.Name}}\" ng-click=\"vm.openLabel(labelItem)\" class=\"label-mark\" \nstyle=\"top: {{labelInstance.BoundingBox.Top*100}}%; left: {{labelInstance.BoundingBox.Left*100}}%; width: {{labelInstance.BoundingBox.Width*100}}%; height: {{labelInstance.BoundingBox.Height*100}}%\" \nng-repeat=\"labelInstance in labelItem.Instances\"></span> </span><span ng-click=\"vm.openFace(faceItem)\" \nclass=\"face-mark\" \nstyle=\"top: {{faceItem.Face.BoundingBox.Top*100}}%; left: {{faceItem.Face.BoundingBox.Left*100}}%; width: {{faceItem.Face.BoundingBox.Width*100}}%; height: {{faceItem.Face.BoundingBox.Height*100}}%\" \nng-repeat=\"faceItem in vm.image.meta_analyses.rekognition_index_faces.FaceRecords\"></span> <span \ntitle=\"{{textItem.DetectedText}}\" ng-click=\"vm.openText(textItem)\" \nng-class=\"{\'text-mark\': true, \'text-mark-line\': textItem.Type == \'LINE\', \'text-mark-word\': textItem.Type == \'WORD\'}\" \nstyle=\"top: {{textItem.Geometry.BoundingBox.Top*100}}%; left: {{textItem.Geometry.BoundingBox.Left*100}}%; width: {{textItem.Geometry.BoundingBox.Width*100}}%; height: {{textItem.Geometry.BoundingBox.Height*100}}%\" \nng-repeat=\"textItem in vm.image.meta_analyses.rekognition_detect_text.TextDetections\"></span></div><div \nclass=\"size block m-15 p-0-i\" layout=\"row\" layout-align=\"start left\"><strong ng-if=\"!vm.isProcessingItem(vm.image)\">\n<span \nng-repeat=\"text in vm.image.meta_analyses.rekognition_detect_text.TextDetectionsUnique | filter: filterByNumNotCurrentYears track by $index\">\n{{text.DetectedText}}<span ng-if=\"!$last\">,</span></span> </strong><strong style=\"color: red; font-weight: bold\" \nng-if=\"vm.isProcessingItem(vm.image)\" translate=\"MEDIA.PROCESSING\">PROCESANDO</strong></div><div layout=\"row\" \nng-include=\"\'app/main/apps/mediahub/views/tabs/tab-related.html\'\"></div></md-tab></md-tabs></div>");
$templateCache.put("app/main/apps/mediahub/views/galleries-toolbar.html","<div layout=\"row\" layout-align=\"start center\"><md-button ng-if=\"vm.media_type_name == \'galleries\'\" \naria-label=\"ADD NEW\" class=\"md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme\" hide \nshow-gt-sm ng-click=\"vm.createGallery($event)\" translate=\"MEDIA.ADD_GALLERY\" type=\"button\">Add gallery</md-button>\n<md-button ng-disabled=\"vm.selectedGallery && vm.selectedGallery.no_files_allowed == true\" aria-label=\"ADD NEW\" \nclass=\"md-fab md-mini md-accent green-500-bg md-raised md-ink-ripple md-default-theme\" hide-gt-sm \nng-click=\"vm.AddmediaDialog()\" type=\"button\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><div \nclass=\"divider-vertical\" hide=\"\" show-gt-xs=\"\"></div><md-icon ng-if=\"vm.sortDirGalleries !== \'ASC\'\" \nng-click=\"vm.setGalleriesSortDir(\'ASC\')\" md-font-icon=\"icon-sort-descending\" \nclass=\"m-0 grey-600-fg md-icon-button md-button md-default-theme md-font material-icons\" translate=\"\" \ntranslate-attr-aria-label=\"TODO.SORT_DIRECTION\"></md-icon><md-icon ng-if=\"vm.sortDirGalleries === \'ASC\'\" \nng-click=\"vm.setGalleriesSortDir(\'DESC\')\" md-font-icon=\"icon-sort-ascending\" \nclass=\"m-0 grey-600-fg md-icon-button md-button md-default-theme md-font material-icons\" translate=\"\" \ntranslate-attr-aria-label=\"TODO.SORT_DIRECTION\"></md-icon><md-menu ng-if=\"vm.media_type_name == \'galleries\'\"><button \naria-label=\"Filters\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.FILTERS\"><md-icon md-font-icon=\"m-0 grey-600-fg icon-chevron-down\"><md-tooltip><span\n translate=\"CONTENT.ORDER_BY\">Order</span></md-tooltip></md-icon></button><md-menu-content width=\"4\"><md-menu-item \nng-repeat=\"(key, value) in vm.orderByGalleries\"><md-button aria-label=\"All\" ng-click=\"vm.setGalleriesSortField(value)\">\n<div layout=\"row\" layout-align=\"space-between center\"><span>Order by {{key | translate}} </span><i \nclass=\"icon-check s16\" ng-if=\"value == vm.sortFieldGalleries\"></i></div></md-button></md-menu-item></md-menu-content>\n</md-menu><md-menu hide=\"\" show-gt-xs=\"\" ng-if=\"refGroupables.length>0\"><button aria-label=\"Filters\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" show-gt-xs=\"\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.FILTERS\"><md-icon md-font-icon=\"icon-chevron-down\"></md-icon></button>\n<md-menu-content width=\"4\"><md-menu-item ng-repeat=\"sortfield in refGroupables\"><md-button aria-label=\"All\" \nng-click=\"pagination_setOrderBy(sortfield)\"><div layout=\"row\" layout-align=\"space-between center\"><span>\nGroup by {{sortfield.name}} </span><i class=\"icon-check s16\" ng-if=\"sortfield.titleId == sortable.titleId\"></i></div>\n</md-button></md-menu-item><md-menu-item ng-if=\"groupable\"><md-button aria-label=\"Remove group\" \nng-click=\"pagination_resetOrderBy()\"><md-icon md-font-icon=\"icon-close \"></md-icon><span>Remove order</span>\n</md-button></md-menu-item></md-menu-content></md-menu></div>");
$templateCache.put("app/main/apps/mediahub/views/list-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/mediahub/views/toolbar.html\'\"></div><div class=\"content-wrapper\" flex=\"\" layout=\"row\"><div \nclass=\"content thread-list mail-list-pane\" flex=\"50\" id=\"thread-list\" \nng-include=\"\'app/main/apps/mediahub/views/list/list-view.html\'\" on-size-changed=\"vm.logResize\" \nng-style=\"!vm.mediaSelected && {\'max-width\': \'100%\'} || {\'max-width\': \'50%\'}\"></div><div \nclass=\"content thread-detail mail-read-pane\" flex=\"50\" id=\"thread-detail\" layout=\"column\" \nng-include=\"\'app/main/apps/mediahub/views/edit-layout.html\'\" ng-if=\"vm.mediaSelected\"></div></div>");
$templateCache.put("app/main/apps/mediahub/views/nosplit-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/mediahub/views/toolbar.html\'\" ng-hide=\"vm.mediaSelected\" \nng-if=\"vm.media_type_name != \'galleries\'\"></div><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/mediahub/views/galleries-toolbar.html\'\" ng-hide=\"vm.mediaSelected\" \nng-if=\"vm.media_type_name == \'galleries\'\"></div><div class=\"content-wrapper\" flex=\"\" layout=\"row\"><div \nclass=\"content thread-detail mail-read-pane\" flex=\"\" id=\"thread-detail\" ms-scroll=\"vm.msScrollOptions\" \nng-if=\"vm.mediaSelected\" ng-include=\"\'app/main/apps/mediahub/views/edit-layout.html\'\"></div><div \nclass=\"content thread-list mail-list-pane\" flex=\"\" id=\"thread-list\" \nng-if=\"!vm.mediaSelected && vm.media_type_name != \'galleries\'\" \nng-include=\"\'app/main/apps/mediahub/views/list/items-view.html\'\" on-size-changed=\"vm.logResize\"></div><div \nclass=\"content thread-list mail-list-pane\" flex=\"\" id=\"thread-list\" \nng-if=\"!vm.mediaSelected && vm.media_type_name == \'galleries\'\" \nng-include=\"\'app/main/apps/mediahub/views/list/galleries-view.html\'\" on-size-changed=\"vm.logResize\"></div></div>");
$templateCache.put("app/main/apps/mediahub/views/photos-view.html","<div class=\"content-wrapper\" flex layout=\"row\"><span>\n{{photo.cropstatus[0].container.view_url}}{{photo.cropstatus[0].fileName}}</span><div class=\"mail-tabs-grid\" flex \nmd-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"media mail-list-pane-grid\" flex><div \nng-repeat=\"photo in vm.items\" class=\"ms-card\" flex ng-click=\"vm.selectMediaFile(photo)\"><div \nclass=\"ms-card-content-wrapper\"><div class=\"template-9\"><div class=\"media\" flex layout=\"row\" \nlayout-align=\"center center\"><img ng-src=\"{{photo.cropstatus[0].container.view_url}}{{photo.cropstatus[0].fileName}}\" \nclass=\"image\"></div><div class=\"header p-16\" flex><div layout=\"row\" layout-align=\"space-between center\" flex><div \nclass=\"size block\" layout=\"row\" layout-align=\"start left\"><strong class=\"mr-5\">#{{photo.id_media}}</strong> <span \nclass=\"grey-500-fg\"><span ng-if=\"photo.filename\">{{photo.filename}}</span></span></div><md-checkbox \nng-checked=\"vm.isSelected(photo)\" ng-click=\"vm.toggleSelectThread(photo, $event)\" \naria-label=\"{{vm.isSelected(photo) ? \'Deselect\' : \'Select\'}}\" class=\"ml-5\"></md-checkbox></div><md-tooltip \nmd-direction=\"top\" hide show-gt-xs ng-if=\"photo.filename\"><span>{{photo.filename}}</span></md-tooltip></div></div>\n</div></div></div></div></div>");
$templateCache.put("app/main/apps/mediahub/views/preview.html","<div flex layout=\"column\" layout-align=\"center center\" ng-if=\"vm.loadingReadPane\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"30\"></md-progress-circular></div><div \nng-show=\"!vm.loadingReadPane\"><div class=\"mail-content\" layout=\"column\" layout-align=\"center center\" \nng-if=\"!vm.mediaSelected\"><div class=\"content\" layout=\"column\" layout-align=\"top center\"><div class=\"message\">\nPlease select an item to show in this panel</div></div></div><div class=\"toolbar grey-100-bg colored-bg\" layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"vm.mediaSelected\" scroll=\"\"><div layout=\"row\" layout-align=\"start center\">\n<md-button class=\"md-icon-button close-thread\" aria-label=\"Back\" ng-click=\"vm.closeThread()\" \nng-if=\"vm.currentThread && vm.currentView==\'nosplit\'\" translate translate-attr-aria-label=\"CONTENT.BACK\"><md-icon \nmd-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><div class=\"divider-vertical\" hide=\"\" \nng-if=\"vm.activeMailPaneIndex === 1\" show-gt-sm=\"\"></div><md-button aria-label=\"Info\" class=\"md-icon-button\" \nng-click=\"vm.closeMediaPreview()\" ng-if=\"vm.mediaSelected\" translate=\"\" translate-attr-aria-label=\"CONTENT.CLOSE\">\n<md-icon md-font-icon=\"icon-close\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.CLOSE\">Close</span>\n</md-tooltip></md-button><div class=\"divider-vertical\" hide=\"\" show-gt-sm=\"\" ng-if=\"vm.selectedContent.id\"></div>\n<md-button aria-label=\"Edit\" class=\"md-icon-button\" ng-click=\"vm.viewEditInline()\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.EDIT\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip hide show-gt-xs>\n<span translate=\"CONTENT.EDIT\">Edit</span></md-tooltip></md-button><div class=\"divider-vertical\" hide=\"\" show-gt-sm=\"\" \nng-if=\"vm.selectedContent.urlpreview && vm.selectedContent.urlpreview.length > 10\"></div><md-button \naria-label=\"Preview\" class=\"md-icon-button\" \nng-if=\"vm.selectedContent.urlpreview && vm.selectedContent.urlpreview.length > 10\" \nng-click=\"vm.openUrl(vm.selectedContent.urlpreview)\" translate=\"\" translate-attr-aria-label=\"CONTENT.PREVIEW\"><md-icon \nmd-font-icon=\"icon-eye\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.PREVIEW\">Preview</span>\n</md-tooltip></md-button><div class=\"divider-vertical\" hide=\"\" show-gt-sm=\"\" ng-if=\"vm.ActiveSection.web_preview\">\n</div><md-button aria-label=\"Spam\" class=\"md-icon-button\" ng-click=\"\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.LIVE\" ng-if=\"vm.ActiveSection.web_preview\"><md-icon md-font-icon=\"icon-web\">\n</md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.LIVE\">Live Preview</span></md-tooltip></md-button>\n<md-menu hide=\"\"><md-button aria-label=\"Mail Actions\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" \ntranslate=\"\" translate-attr-aria-label=\"CONTENT.ACTIONS\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"3\"><md-menu-item><md-button aria-label=\"Archive\" \ntranslate-attr-aria-label=\"CONTENT.ARCHIVE\"><md-icon md-font-icon=\"icon-archive\"></md-icon><span \ntranslate=\"CONTENT.ARCHIVE\">Archive</span></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Spam\" \ntranslate-attr-aria-label=\"CONTENT.SPAM\"><md-icon md-font-icon=\"icon-alert-octagon\"></md-icon><span \ntranslate=\"CONTENT.SPAM\">Spam</span></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Delete\" \ntranslate-aria-label=\"CONTENT.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span translate=\"CONTENT.DELETE\">\nDelete</span></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Move To\" \ntranslate-attr-aria-label=\"CONTENT.MOVE_TO\"><md-icon md-font-icon=\"icon-folder-move\"></md-icon><span \ntranslate=\"CONTENT.MOVE_TO\">Move To</span></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Labels\" \ntranslate-attr-aria-label=\"CONTENT.LABELS\"><md-icon md-font-icon=\"icon-label\"></md-icon><span \ntranslate=\"CONTENT.LABELS\">Labels</span></md-button></md-menu-item></md-menu-content></md-menu></div><div layout=\"row\" \nlayout-align=\"end center\" ng-if=\"vm.mediaSelected\"><md-button type=\"submit\" ng-click=\"vm.saveImage(vm.image)\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"vm.basicForm.$invalid || vm.basicForm.$pristine\" \naria-label=\"SAVE\" translate=\"CONTENT.SAVE\" translate-attr-aria-label=\"CONTENT.SAVE\">SAVE</md-button><md-button \ntype=\"button\" ng-click=\"vm.closeThreadEdit()\" class=\"md-raised md-warn\" aria-label=\"Cancel\">Cancel</md-button></div>\n</div><md-content flex=\"\" ng-show=\"vm.mediaSelected && !vm.editInline\"><div \nclass=\"mail-content file-details scrollable\" ms-scroll=\"vm.msScrollOptions\"><div layout=\"row\" layout-xs=\"column\"><div \nflex-gt-sm=\"50\" flex=\"100\" class=\"white-box sections\"><div class=\"section\"><md-input-container class=\"md-block\" flexss>\n<img ng-src=\"{{vm.image.imageUrl}}\" src=\"{{vm.image.imageUrl}}\" alt=\"\"><div class=\"md-errors-spacer\"></div>\n</md-input-container></div></div><div flex-gt-sm=\"50\" flex=\"50\" class=\"white-box sections\"><div class=\"section\">\n<md-input-container class=\"md-block\" flexss><label translate=\"CONTENT.ID\">ID</label><input \nng-model=\"vm.image.id_media\" type=\"text\" readonly=\"readonly\"></md-input-container><md-input-container class=\"md-block\" \nflex><label translate=\"CONTENT.FILENAME\">Filename</label><input ng-model=\"vm.image.filename\" type=\"text\" \nreadonly=\"readonly\"></md-input-container></div></div></div><div layout=\"column\" layout-xs=\"column\"><div \nflex-gt-sm=\"66\" flex=\"100\" class=\"white-box sections\"><md-list><md-list-item class=\"md-toolbar-tools grey-100-bg\"><h5 \nclass=\"grey-700-fg\" translate=\"CONTENT.LATESTACTIVITY\">Publishing Settings<md-divider></md-divider></h5></md-list-item>\n</md-list><div class=\"section\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"section-title\">Main Info</span></div><md-input-container class=\"md-block\"><label translate=\"CONTENT.TITLE\">Title\n</label><textarea ng-model=\"vm.image.title\" columns=\"1\" rows=\"1\"></textarea></md-input-container><md-input-container \nclass=\"md-block\"><label translate=\"CONTENT.PHOTOGRAPHER\">Photographer</label><input ng-model=\"vm.image.photographer\" \ntype=\"text\"></md-input-container><md-input-container class=\"md-block\"><label translate=\"CONTENT.CREDITS\">Credits\n</label><input ng-model=\"vm.image.credits\" type=\"text\"></md-input-container><md-input-container class=\"md-block\"><label\n translate=\"CONTENT.OWNER\">Owner</label><input ng-model=\"vm.image.owner\" type=\"text\"></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"CONTENT.CAPTION\">Caption</label><textarea \nng-model=\"vm.image.caption\" columns=\"1\" rows=\"1\"></textarea></md-input-container><md-input-container class=\"md-block\">\n<label translate=\"CONTENT.CITY\">City</label><input ng-model=\"vm.image.city\" type=\"text\"></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"CONTENT.COUNTRY\">Country</label><input \nng-model=\"vm.image.country\" type=\"text\"></md-input-container><div ng-if=\"!vm.allFields\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent\" ng-click=\"vm.allFields = true\" \ntranslate=\"CONTENT.SHOW_ALL_FIELDS\">Show All Fields</md-button></div></div><div ng-if=\"vm.allFields\"><div \nclass=\"date-time-picker section\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"section-title\">File date</span></div><div layout=\"row\" layout-gt-sm=\"row\"><div flex class=\"date-container\">\n<mdp-date-picker mdp-placeholder=\"Date\" mdp-format=\"{{vm.dateFormat}}\" mdp-open-on-click=\"true\" \nng-model=\"vm.image.file_date.date\" ng-change=\"vm.updateDatePicker(\'file_date\')\"></mdp-date-picker></div><div flex \nclass=\"date-container\"><mdp-time-picker mdp-placeholder=\"Time\" mdp-auto-switch=\"true\" mdp-open-on-click=\"true\" \nng-model=\"vm.image.file_date.date\" ng-change=\"vm.updateDatePicker(\'file_date\')\"></mdp-time-picker></div><div flex \nclass=\"date-container\"><md-input-container class=\"md-block\"><label>UTC Date</label><input type=\"text\" \nng-model=\"vm.image.file_date.utcShow\" disabled=\"disabled\"></md-input-container></div></div></div><div \nclass=\"date-time-picker section\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"section-title\">Date uploaded</span></div><div layout=\"row\" layout-gt-sm=\"row\"><div flex class=\"date-container\">\n<mdp-date-picker mdp-placeholder=\"Date\" mdp-format=\"{{vm.dateFormat}}\" mdp-open-on-click=\"true\" \nng-model=\"vm.image.date_uploaded.date\" ng-change=\"vm.updateDatePicker(\'date_uploaded\')\"></mdp-date-picker></div><div \nflex class=\"date-container\"><mdp-time-picker mdp-placeholder=\"Time\" mdp-auto-switch=\"true\" mdp-open-on-click=\"true\" \nng-model=\"vm.image.date_uploaded.date\" ng-change=\"vm.updateDatePicker(\'date_uploaded\')\"></mdp-time-picker></div><div \nflex class=\"date-container\"><md-input-container class=\"md-block\"><label>UTC Date</label><input type=\"text\" \nng-model=\"vm.image.date_uploaded.utcShow\" disabled=\"disabled\"></md-input-container></div></div></div><div \nclass=\"geoloc section\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"section-title\" translate=\"CONTENT.GEOLOCALIZATION\">Geolocation</span></div><div layout=\"row\" layout-gt-sm=\"row\">\n<md-input-container class=\"md-block\" flex><label translate=\"CONTENT.GEOLAT\">ID</label><input \nng-model=\"vm.image.geoLat\" type=\"text\"></md-input-container><md-input-container class=\"md-block\" flex><label \ntranslate=\"CONTENT.GEOLON\">ID</label><input ng-model=\"vm.image.geoLon\" type=\"text\"></md-input-container></div></div>\n<md-input-container class=\"md-block\"><label translate=\"CONTENT.USE\">Use</label><input ng-model=\"vm.image.uses\" \ntype=\"text\"></md-input-container><md-input-container class=\"md-block\" ng-hide=\"vm.image.media_type == 2\"><label \ntranslate=\"CONTENT.EXTRAS\">Extras</label><input ng-model=\"vm.image.extra\" type=\"text\"></md-input-container><div \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-accent\" ng-click=\"vm.allFields = false\" \ntranslate=\"CONTENT.FEWER_FIELDS\">Fewer Fields</md-button></div></div></div></div></div></md-content><md-content \nng-show=\"vm.mediaSelected && vm.editInline\" ng-include=\"\'app/main/apps/mediahub/views/edit-media.html\'\" \nclass=\"scrollable\"></md-content></div>");
$templateCache.put("app/main/apps/mediahub/views/split-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/mediahub/views/toolbar.html\'\" ng-if=\"vm.media_type_name != \'galleries\'\"></div><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/mediahub/views/galleries-toolbar.html\'\" ng-if=\"vm.media_type_name == \'galleries\'\"></div><div\n class=\"content-wrapper\" flex=\"\" layout=\"row\"><div class=\"content thread-list mail-list-pane\" flex=\"50\" flex-xs=\"100\" \nflex-sm=\"100\" id=\"thread-list\" \nng-if=\"vm.media_type_name != \'galleries\' && (!vm.mediaSelected || vm.$mdMedia(\'gt-sm\'))\" \nng-include=\"\'app/main/apps/mediahub/views/list/items-view.html\'\" on-size-changed=\"vm.logResize\" \nng-style=\"(!vm.mediaSelected || vm.currentListView == \'gridGoogle\') && {\'max-width\': \'100%\'} || {\'max-width\': \'50%\'}\">\n</div><div class=\"content thread-list mail-list-pane\" flex=\"50\" flex-xs=\"100\" flex-sm=\"100\" id=\"thread-list\" \nng-if=\"vm.media_type_name == \'galleries\' && (!vm.mediaSelected || vm.$mdMedia(\'gt-sm\'))\" \nng-include=\"\'app/main/apps/mediahub/views/list/galleries-view.html\'\" on-size-changed=\"vm.logResize\" \nng-style=\"(!vm.mediaSelected || vm.currentListView == \'gridGoogle\') && {\'max-width\': \'100%\'} || {\'max-width\': \'50%\'}\">\n</div><div class=\"content thread-detail mail-read-pane\" flex=\"50\" flex-xs=\"100\" flex-sm=\"100\" id=\"thread-detail\" \nlayout=\"column\" ng-include=\"\'app/main/apps/mediahub/views/edit-layout.html\'\" \nng-if=\"vm.mediaSelected && vm.currentListView !== \'gridGoogle\'\" \nng-style=\"!vm.$mdMedia(\'gt-sm\') && {\'max-width\': \'100%\'}\"></div><md-sidenav ng-if=\"vm.currentListView == \'gridGoogle\'\" \nclass=\"sidenav-media md-sidenav-right sidenav\" md-component-id=\"sidenav-media\" \nng-include=\"\'app/main/apps/mediahub/views/edit-layout.html\'\" ms-scroll ms-sidenav-helper md-no-ink></md-sidenav></div>");
$templateCache.put("app/main/apps/mediahub/views/toolbar.html","<div id=\"mh-toolbar\" layout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-label\" \naria-label=\"{{vm.selectedThreads.length > 0 ? \'Deselect All\' : \'Select All\'}}\" \nng-checked=\"vm.selectedThreads.length > 0\" ng-click=\"vm.toggleSelectThreads()\"></md-checkbox><div \nclass=\"divider-vertical\"></div><md-button \nng-disabled=\"vm.selectedGallery && vm.selectedGallery.no_files_allowed == true\" aria-label=\"ADD NEW\" \nclass=\"md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme\" \nng-click=\"vm.openUploadDialog($event)\" translate=\"CONTENT.ADD\" type=\"button\">Add new</md-button><md-button \nng-disabled=\"vm.selectedGallery && vm.selectedGallery.no_files_allowed == true\" aria-label=\"ADD NEW\" \nclass=\"md-fab md-mini md-accent green-500-bg md-raised md-ink-ripple md-default-theme\" ng-hide=\"true\" \nng-click=\"vm.openUploadDialog($event)\" type=\"button\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><div \nng-if=\"vm.media_type_name != \'galleries\' && vm.media_type_name != \'Image Rekognition\'\" class=\"divider-vertical\"></div>\n<div layout=\"row\" layout-align=\"start center\" class=\"groups-trigger\"><button aria-label=\"view group\" \nclass=\"md-button md-icon-button\" \nng-if=\"vm.media_type_name != \'galleries\' && vm.media_type_name != \'Image Rekognition\'\" \nng-click=\"vm.openGallerySidenav()\" translate translate-attr-aria-label=\"CONTENT.FILTERS\"><md-icon \nng-class=\"{\'icon-folder-multiple-image\':vm.media_type == 1, \'qiu-icon-video-gallery\':vm.media_type == 2,\'qiu-icon-audio-gallery\':vm.media_type == 3, \'qiu-icon-file-gallery\':vm.media_type == 4, \'icon-folder-multiple\':vm.media_type != 1 && vm.media_type != 2 && vm.media_type != 3 && vm.media_type != 4 }\">\n</md-icon><md-tooltip><span translate=\"GALLERY.VIEW_GALLERIES\">View Galleries</span></md-tooltip></button></div><div \nclass=\"divider-vertical\"></div><mh-search-bar debounce=\"300\" model-search=\"vm.modelSearch\" \non-result-click=\"vm.searchResultClick(item)\" on-search=\"vm.pagination_search(query)\" layout=\"row\" \nlayout-align=\"start center\"></mh-search-bar><md-button aria-label=\"view type\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'main-sidenav\')\" translate=\"\" translate-attr-aria-label=\"CONTENT.FILTERS\" \nng-hide=\"vm.isVertexSearch()\"><md-icon md-font-icon=\"icon-filter\"></md-icon><md-tooltip><span \ntranslate=\"CONTENT.FILTERS\">Filters</span></md-tooltip></md-button><div class=\"divider-vertical\"></div><md-button \nng-if=\"vm.isSortDirEnabled() && sortDir !== \'ASC\'\" aria-label=\"Sort Direction\" class=\"md-icon-button\" \nng-click=\"vm.setSortDir(\'ASC\')\" ng-disabled=\"!sortField\" translate=\"\" translate-attr-aria-label=\"TODO.SORT_DIRECTION\">\n<md-icon md-font-icon=\"icon-sort-descending\"></md-icon></md-button><md-button \nng-if=\"vm.isSortDirEnabled() && sortDir === \'ASC\'\" aria-label=\"Sort Direction\" class=\"md-icon-button\" \nng-click=\"vm.setSortDir(\'DESC\')\" ng-disabled=\"!sortField\" translate=\"\" translate-attr-aria-label=\"TODO.SORT_DIRECTION\">\n<md-icon md-font-icon=\"icon-sort-ascending\"></md-icon></md-button><md-menu><button aria-label=\"Filters\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" translate=\"\" translate-attr-aria-label=\"CONTENT.FILTERS\">\n<md-icon md-font-icon=\"icon-chevron-down\"><md-tooltip><span translate=\"CONTENT.ORDER_BY\">Order</span></md-tooltip>\n</md-icon></button><md-menu-content width=\"4\"><md-menu-item \nng-repeat=\"sortfield in vm.getSortables() track by sortfield.titleId\" \nng-if=\"!sortfield.showOnly || (sortfield.showOnly == vm.viewSortType)\"><md-button aria-label=\"All\" \nng-click=\"vm.setSortField(sortfield.titleId)\"><div layout=\"row\" layout-align=\"space-between center\"><span>\nOrder by {{sortfield.name}} </span><i class=\"icon-check s16\" ng-if=\"vm.isSortActive(sortfield)\"></i></div></md-button>\n</md-menu-item><md-menu-item ng-if=\"sortable\"><md-button aria-label=\"Remove sort\" ng-click=\"pagination_resetOrderBy()\">\n<md-icon md-font-icon=\"icon-close \"></md-icon><span>Remove order</span></md-button></md-menu-item></md-menu-content>\n</md-menu><div aria-hidden=\"false\" class=\"action-buttons\" layout=\"row\" layout-align=\"start center\" \nng-show=\"vm.selectedThreads.length > 0\"><div class=\"divider-vertical\"></div><md-button aria-label=\"Export\" \nng-click=\"vm.AddMediaItemToGalleryDialog()\" class=\"md-icon-button\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.EXPORT\"><md-icon md-font-icon=\"icon-folder-upload\"></md-icon><md-tooltip><span \ntranslate=\"MEDIA.ADDTOGALLERIES\">Add to Galleries</span></md-tooltip></md-button><md-button aria-label=\"Remove\" \nng-click=\"vm.RemoveMediaItemFromGalleryDialog()\" class=\"md-icon-button\" translate=\"\" \ntranslate-attr-aria-label=\"MEDIA.REMOVEFROMGALLERY\" ng-if=\"vm.selectedGallery\"><md-icon \nmd-font-icon=\"icon-folder-remove\"></md-icon><md-tooltip><span translate=\"MEDIA.REMOVEFROMGALLERY\">Remove from Gallery\n</span></md-tooltip></md-button><md-button aria-label=\"Export\" ng-click=\"vm.EditMultipleFieldsDialog()\" \nclass=\"md-icon-button\" translate=\"\" translate-attr-aria-label=\"CONTENT.EXPORT\" ng-if=\"vm.selectedThreads.length > 1 \">\n<md-icon md-font-icon=\"icon-tooltip-edit\"></md-icon><md-tooltip><span translate=\"MEDIA.EDITMULTIPLEFIELDS\">\nEdit Multiple Fields</span></md-tooltip></md-button><md-button ng-click=\"vm.deleteMediaItem($event)\" \naria-label=\"Delete\" class=\"md-icon-button\" translate=\"\" translate-attr-aria-label=\"CONTENT.DELETE\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"CONTENT.DELETE\">Delete</span></md-tooltip>\n</md-button><md-button ng-click=\"vm.downloadSelected($event)\" aria-label=\"Download\" class=\"md-icon-button\" \ntranslate=\"\" translate-attr-aria-label=\"CONTENT.DOWNLOAD\"><md-icon md-font-icon=\"icon-download\"></md-icon><md-tooltip>\n<span translate=\"CONTENT.DOWNLOAD\">Download</span></md-tooltip></md-button><md-button \nng-click=\"vm.shareDialog($event)\" aria-label=\"Delete\" class=\"md-icon-button\" translate=\"\" \ntranslate-attr-aria-label=\"MEDIA.SHARE\"><md-icon md-font-icon=\"icon-share\"></md-icon><md-tooltip><span \ntranslate=\"MEDIA.SHARE\">SHARE</span></md-tooltip></md-button><md-button ng-click=\"vm.massRecropMedia($event)\" \naria-label=\"Recrop\" class=\"md-icon-button\" translate=\"\" translate-attr-aria-label=\"MEDIA.RECROP\"><md-icon \nmd-font-icon=\"icon-crop\"></md-icon><md-tooltip><span translate=\"MEDIA.RECROP\">RECROP</span></md-tooltip></md-button>\n<div class=\"divider-vertical\"></div><span ng-if=\"vm.selectedThreads.length > 0\" class=\"page-info ml-10\">\n{{vm.selectedThreads.length | number}} items selected.</span></div></div><div layout=\"row\" layout-align=\"start center\" \ntranslate-attr-aria-label=\"CONTENT.REFRESH\" class=\"qiu-pagination\" \nng-hide=\"isLoading || (vm.media_type_name == \'galleries\' && vm.isRoot && !$root.pagination_searchquery)\"><span \nclass=\"page-info\">{{pagination_totalItems | number}} items found.</span><md-button aria-label=\"Previous\" \nclass=\"md-icon-button arrow\" ng-click=\"pagination_prevPage()\" ng-disabled=\"pagination_firstPage()\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span \ntranslate=\"CONTENT.PREVIOUS\">Previous</span></md-tooltip></md-button><span class=\"page-info ml-10\">Page <span \nclass=\"ml-5\">{{pagination_page | number}} / {{pagination_total_pages | number}}</span></span><md-button \naria-label=\"Next\" class=\"md-icon-button arrow\" ng-click=\"pagination_nextPage()\" ng-disabled=\"pagination_morePages()\" \ntranslate=\"\" translate-attr-aria-label=\"CONTENT.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip>\n<span translate=\"CONTENT.NEXT\">Next</span></md-tooltip></md-button><div class=\"divider-vertical\"></div><div \nclass=\"limit-select mr-10 ml-10\" ng-if=\"!isLoading\"><md-select class=\"md-table-select\" \nng-change=\"vm.setNewPerPageSize(vm.perPage)\" ng-model=\"vm.perPage\" md-container-class=\"md-pagination-select\" \naria-label=\"Rows\" placeholder=\"{{ $pagination.limitOptions[0] }}\"><md-option ng-repeat=\"p in perPagePresets\" \nng-value=\"p\">{{p}} {{::option.label ? option.label : option}}</md-option></md-select><md-tooltip><span \ntranslate=\"CONTENT.ITEMS_PER_PAGE\">Items per page</span></md-tooltip></div><div class=\"divider-vertical\"></div>\n<md-button aria-label=\"Refresh\" class=\"md-icon-button\" ng-click=\"pagination_reload()\" translate=\"\" \ntranslate-attr-aria-label=\"MEDIA.REFRESH\"><md-icon md-font-icon=\"icon-refresh\"></md-icon></md-button><div \nclass=\"divider-vertical\"></div><md-button aria-label=\"Settings\" class=\"md-icon-button\" \nng-click=\"vm.openMediahubSettings($event)\" ng-hide=\"vm.isVertexSearch()\"><md-icon md-font-icon=\"icon-cog\"></md-icon>\n<md-tooltip><span translate=\"CONTENT.SETTINGS\">Settings</span></md-tooltip></md-button><div class=\"divider-vertical\">\n</div><md-menu-bar class=\"pr-0 pl-0\"><md-menu class=\"settings-menu\"><md-button aria-label=\"Settings\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" translate=\"\" translate-attr-aria-label=\"CONTENT.SETTINGS\">\n<md-icon \nng-class=\"{\'icon-tile-four\':vm.currentListView == \'grid\', \'icon-view-list\':vm.currentListView == \'list\', \'icon-grid\':vm.currentListView == \'gridGoogle\'}\">\n</md-icon></md-button><md-menu-content><md-menu-item ng-if=\"vm.currentListView !== \'grid\'\"><md-button \nng-click=\"vm.changeListView(\'grid\')\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-tile-four\"></md-icon><span translate=\"MEDIA.THUMBNAILS_VIEW\">List view</span></div></md-button>\n</md-menu-item><md-menu-item ng-if=\"vm.currentListView !== \'list\'\"><md-button ng-click=\"vm.changeListView(\'list\')\"><div\n layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-view-list\"></md-icon><span \ntranslate=\"MEDIA.LIST_VIEW\">List view</span></div></md-button></md-menu-item><md-menu-item \nng-if=\"vm.currentListView !== \'gridGoogle\'\"><md-button ng-click=\"vm.changeListView(\'gridGoogle\')\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-grid\"></md-icon><span translate=\"MEDIA.GRID_VIEW\">Grid view\n</span></div></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><md-menu-bar class=\"pr-0 pl-0\" \nng-hide=\"true\"><md-menu class=\"settings-menu\"><md-button aria-label=\"Settings\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\" translate=\"\" translate-attr-aria-label=\"CONTENT.SETTINGS\"><md-icon \nmd-font-icon=\"icon-cog\"></md-icon></md-button><md-menu-content><md-menu-item ng-if=\"vm.currentListView !== \'grid\'\">\n<md-button ng-click=\"vm.changeListView(\'grid\')\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-tile-four\"></md-icon><span translate=\"MEDIA.THUMBNAILS_VIEW\">List view</span></div></md-button>\n</md-menu-item><md-menu-item ng-if=\"vm.currentListView !== \'list\'\"><md-button ng-click=\"vm.changeListView(\'list\')\"><div\n layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-view-list\"></md-icon><span \ntranslate=\"MEDIA.LIST_VIEW\">List view</span></div></md-button></md-menu-item><md-menu-item \nng-if=\"vm.currentListView !== \'gridGoogle\'\"><md-button ng-click=\"vm.changeListView(\'gridGoogle\')\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-grid\"></md-icon><span translate=\"MEDIA.GRID_VIEW\">Grid view\n</span></div></md-button></md-menu-item><md-menu-item><md-menu><md-button aria-label=\"Filters\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-sort\"></md-icon><span translate=\"CONTENT.ORDER_BY\">Order by\n</span></md-button><md-menu-content><md-menu-item \nng-repeat=\"sortfield in vm.getSortables() track by sortfield.titleId\"><md-button aria-label=\"All\" \nng-click=\"vm.setSortField(sortfield.titleId)\"><div layout=\"row\" layout-align=\"space-between center\"><span>\n{{sortfield.name}}</span> <i class=\"icon-check s16\" ng-if=\"vm.isSortActive(sortfield)\"></i></div></md-button>\n</md-menu-item><md-menu-item ng-repeat=\"field in vm.refcolumns\" ng-if=\"field.sortable === 1\"><md-button \nng-click=\"vm.setSortField(field.title)\"><div layout=\"row\" layout-align=\"space-between center\"><span>\n{{field.field_name}}</span> <i class=\"icon-check s16\" ng-if=\"vm.fieldOrder === field.field_name\"></i></div></md-button>\n</md-menu-item></md-menu-content></md-menu></md-menu-item><md-menu-item ng-if=\"vm.isSortDirEnabled()\"><md-button \nng-click=\"vm.setSortDir(\'ASC\')\" ng-disabled=\"!sortField\"><div layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-sort-ascending\"></md-icon><span \ntranslate=\"CONTENT.DIRECTION_A_Z\">Order A-Z</span></div><i class=\"icon-check s16\" ng-if=\"sortDir === \'ASC\'\"></i></div>\n</md-button></md-menu-item><md-menu-item ng-if=\"vm.isSortDirEnabled()\"><md-button ng-click=\"vm.setSortDir(\'DESC\')\" \nng-disabled=\"!sortField\"><div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-sort-descending\"></md-icon><span \ntranslate=\"CONTENT.DIRECTION_Z_A\">Order Z-A</span></div><i class=\"icon-check s16\" ng-if=\"sortDir === \'DESC\'\"></i></div>\n</md-button></md-menu-item><md-menu-item><md-button aria-label=\"Export\" ng-click=\"vm.AddMediaItemToGalleryDialog()\" \nng-disabled=\"vm.selectedThreads.length == 0\"><md-icon md-font-icon=\"icon-folder-upload\"></md-icon><span \ntranslate=\"MEDIA.ADDTOGALLERIES\">Add to Galleries</span></md-button></md-menu-item><md-menu-item \nng-if=\"vm.selectedGallery\"><md-button aria-label=\"Export\" ng-click=\"vm.RemoveMediaItemFromGalleryDialog()\" \nng-disabled=\"vm.selectedThreads.length == 0\"><md-icon md-font-icon=\"icon-folder-remove\"></md-icon><span \ntranslate=\"MEDIA.REMOVEFROMGALLERY\">Remove from Gallery</span></md-button></md-menu-item><md-menu-item><md-button \naria-label=\"Export\" ng-click=\"vm.EditMultipleFieldsDialog()\" ng-disabled=\"vm.selectedThreads.length == 0\"><md-icon \nmd-font-icon=\"icon-tooltip-edit\"></md-icon><span translate=\"MEDIA.EDITMULTIPLEFIELDS\">Edit Multiple Fields</span>\n</md-button></md-menu-item><md-menu-item><md-button aria-label=\"Share\" ng-click=\"vm.shareDialog($event)\" \nng-disabled=\"vm.selectedThreads.length == 0\"><md-icon md-font-icon=\"icon-share\"></md-icon><span \ntranslate=\"MEDIA.SHARE\">Share</span></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Recrop\" \nng-click=\"vm.massRecropMedia($event)\" ng-disabled=\"vm.selectedThreads.length == 0\"><md-icon md-font-icon=\"icon-crop\">\n</md-icon><span translate=\"MEDIA.RECROP\">Recrop</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.downloadSelected($event)\" aria-label=\"Download\" ng-disabled=\"vm.selectedThreads.length == 0\"><md-icon \nmd-font-icon=\"icon-download\"></md-icon><span translate=\"CONTENT.DOWNLOAD\">Download</span></md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.deleteMediaItem($event)\" aria-label=\"Delete\" \nng-disabled=\"vm.selectedThreads.length == 0\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span \ntranslate=\"CONTENT.DELETE\">Delete</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"pagination_reload()\" aria-label=\"REFRESH\"><md-icon md-font-icon=\"icon-refresh\"></md-icon><span \ntranslate=\"MEDIA.REFRESH\">REFRESH</span></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div>");
$templateCache.put("app/main/apps/mediahub/tags/tags.html","<div id=\"mediahub-tags\" class=\"page-layout carded left-sidenav\" layout=\"row\" md-no-ink><div class=\"center\" \nlayout=\"column\" flex><div class=\"content-card\" ng-class=\"vm.currentView\" layout=\"column\" flex \nng-include=\"vm.views[vm.currentView]\" md-no-ink></div></div></div>");
$templateCache.put("app/main/apps/runtag/event/event_v2.html","<div layout=\"column\" flex=\"100\" id=\"site-content\" class=\"page-layout carded left-sidenav users-in-events\"><div \nng-if=\"!vm.fullPage || vm.isFiltered\" ng-include=\"\'app/main/apps/runtag/event/views/sidenavs/events-sidenav.html\'\" \nclass=\"top-nav\"></div><div id=\"re-main-container\" class=\"center\" layout-align=\"space-between center\" flex=\"100\" \nstyle=\"overflow-y: scroll\"><div ng-if=\"isLoadingGroups\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\">\n</md-progress-circular></div><div ng-include=\"vm.view\" ng-if=\"!isLoadingGroups\" flex=\"100\" style=\"height: 100%\"></div>\n</div><div class=\"bulk-assign-overlay\" ng-if=\"vm.isBulkAssigning\" aria-live=\"polite\"><div class=\"bulk-assign-card\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"22\"></md-progress-circular><div class=\"bulk-assign-text\">\n<div class=\"title\">Assigning images…</div></div></div></div><div class=\"bulk-assign-overlay\" ng-if=\"vm.generatingZip\" \naria-live=\"polite\"><div class=\"bulk-assign-card\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"22\">\n</md-progress-circular><div class=\"bulk-assign-text\"><div class=\"title\" ng-if=\"!vm.zipTotal || vm.zipTotal <= 1\" \ntranslate=\"RUNTAG.DOWNLOAD_ZIP.GENERATING\">Generating Zip...</div><div class=\"title\" ng-if=\"vm.zipTotal > 1\" \ntranslate=\"RUNTAG.DOWNLOAD_ZIP.GENERATING_PART\" translate-values=\"{ progress: vm.zipProgress, total: vm.zipTotal }\">\nGenerating Zip {{vm.zipProgress}} of {{vm.zipTotal}}...</div></div></div></div></div>");
$templateCache.put("app/main/apps/runtag/organizer/organizer.html","<div layout=\"column\" flex=\"100\" id=\"site-content\" class=\"page-layout carded left-sidenav users-in-events\"><div \nid=\"rs-main-container\" class=\"center\" layout-align=\"space-between center\" flex=\"100\" style=\"overflow-y: scroll\"><div \nflex=\"100\" style=\"height: 100%\" ng-include=\"\'app/main/apps/runtag/organizer/views/templates/organizer-template.html\'\">\n</div></div></div>");
$templateCache.put("app/main/apps/runtag/support/support.html","<h1>Runtag support works!</h1>");
$templateCache.put("app/main/apps/runtag/sales/sales-v2.html","<div layout=\"column\" flex=\"100\" id=\"site-content\" class=\"page-layout carded left-sidenav users-in-events\"><div \nid=\"rs-main-container\" class=\"center\" layout-align=\"space-between center\" flex=\"100\" style=\"overflow-y: scroll\"><div \nflex=\"100\" style=\"height: 100%\" ng-include=\"\'app/main/apps/runtag/sales/views/templates/sales-template-v2.html\'\"></div>\n</div></div>");
$templateCache.put("app/main/apps/sitemap/dialogs/edit-layout.html","<md-dialog class=\"edit-widget\" aria-label=\"EDIT\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between\"><h1 class=\"mr-0 flex-100 title\" style=\"line-height: 1\" layout=\"column\" \nlayout-align=\"center start\"><span>{{vm.copyLayout.label ? vm.copyLayout.label : vm.copyLayout.type_layout}}</span></h1>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div \nclass=\"form-wrapper pt-20 ph-0\"><form class=\"md-inline-form\"><md-input-container flex=\"100\" \nclass=\"md-block mb-0 mh-20\"><label translate=\"WIDGETS.REF_NAME\"></label><input ng-model=\"vm.copyLayout.label\" \ntype=\"text\" value=\"\"></md-input-container><md-input-container flex=\"100\" class=\"md-block mb-0 mh-20\"><label>Classes\n</label><input ng-model=\"vm.copyLayout.extra_class\" type=\"text\" value=\"\"></md-input-container></form></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"send-button md-raised md-accent\" translate=\"SITEMAP.APPLY\" \naria-label=\"APPLY\" ng-click=\"vm.saveDialog()\"></md-button><md-button class=\"send-button md-raised md-warn\" \ntranslate=\"SITEMAP.CANCEL\" aria-label=\"CANCEL\" ng-click=\"vm.closeDialog()\"></md-button></div></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/apps/sitemap/dialogs/edit-template.html","<div class=\"md-warm pv-10 ph-20\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-alert-circle\" \nclass=\"red-fg ml-0 mr-10\"></md-icon><strong translate=\"WIDGETS.JSON_ALERT_MESSAGE\" class=\"red-fg\"></strong></div><div \nflex=\"100\" class=\"md-block mb-0 mh-20 border-left border\"><div layout=\"row\" layout-align=\"start center\" flex=\"100\" \nclass=\"pl-20\"><span class=\"font-size-16\" flex=\"20\"><div layout=\"row\"><md-input-container class=\"md-block mb-0 mh-0\">\n<input type=\"text\" placeholder=\"Label\" value=\"\" ng-model=\"vm.labelToAdd\"></md-input-container></div></span><md-icon \nmd-font-icon=\"icon-chevron-right\" aria-label=\"ARROW\" flex=\"10\" class=\"text-center\"></md-icon><span \nclass=\"font-size-16\" flex=\"20\"><div layout=\"row\"><md-input-container class=\"md-block mb-0 mh-0\"><input type=\"text\" \nplaceholder=\"value\" value=\"\" ng-model=\"vm.valueToAdd\"></md-input-container></div></span><md-icon \nmd-font-icon=\"icon-chevron-right\" aria-label=\"ARROW\" flex=\"10\" class=\"text-center\"></md-icon><span \nclass=\"font-size-16\" flex=\"20\"><div layout=\"row\"><md-input-container class=\"md-block mb-0 mh-0\"><input type=\"number\" \nplaceholder=\"position\" value=\"\" ng-model=\"vm.positionToAdd\"></md-input-container></div></span><md-button flex=\"10\" \nng-click=\"vm.addFilterMapping(\'true\')\" class=\"add-event-button md-icon-button\"><span ng-if=\"vm.isNewFilterComplete()\">\n<md-icon md-font-icon=\"icon-plus-circle\" class=\"green-fg\" aria-label=\"ADD\"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate=\"WIDGETS.ADD_FIELD_MAPPING\">ADD FILTER</span></md-tooltip></span></md-button></div><div \nng-repeat=\"key in vm.template.values\" layout=\"row\" layout-align=\"space-between center\" flex=\"100\" \nclass=\"mb-0 pv-5 pr-10 pl-20 h-50 border-top\"><div layout=\"row\" layout-align=\"start center\" flex=\"85\"><span \nng-if=\"!key.editing\" class=\"grey-700-fg font-size-16\" flex=\"30\">{{key.label}}</span> <span ng-if=\"key.editing\" \nclass=\"font-size-16\" flex=\"30\"><div layout=\"row\"><md-input-container class=\"md-block mb-0 mh-0\"><input type=\"text\" \nvalue=\"\" ng-model=\"key.label\"></md-input-container></div></span><md-icon md-font-icon=\"icon-chevron-right\" \naria-label=\"ARROW\" flex=\"10\" class=\"text-center\"></md-icon><span ng-if=\"!key.editing\" class=\"grey-700-fg font-size-16\" \nflex=\"60\">{{key.value}}</span> <span ng-if=\"key.editing\" class=\"font-size-16\" flex=\"60\"><div layout=\"row\">\n<md-input-container class=\"md-block mb-0 mh-0\"><input type=\"text\" value=\"\" ng-model=\"key.value\"></md-input-container>\n</div></span></div><div layout=\"row\" layout-align=\"end center\"><md-button ng-if=\"!key.editing\" \nng-click=\"key.editing= true;\" class=\"w-20 add-event-button md-icon-button\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"s20\" aria-label=\"EDIT\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"WIDGETS.EDIT_MAPPING\">EDIT MAPPING\n</span></md-tooltip></md-button><md-button ng-if=\"key.editing\" ng-click=\"key.editing= false;\" \nclass=\"w-20 add-event-button md-icon-button\"><md-icon md-font-icon=\"icon-content-save\" class=\"s20\" aria-label=\"SAVE\">\n</md-icon><md-tooltip hide show-gt-xs><span translate=\"WIDGETS.SAVE_MAPPING\">SAVE MAPPING</span></md-tooltip>\n</md-button><md-button ng-click=\"vm.deleteMapping(key, true)\" class=\"add-event-button md-icon-button\"><md-icon \nmd-font-icon=\"icon-minus-circle\" class=\"red-fg\" aria-label=\"AREMOVEDD\"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate=\"WIDGETS.REMOVE_FIELD_MAPPING\">REMOVE MAPPING</span></md-tooltip></md-button></div></div></div>");
$templateCache.put("app/main/apps/sitemap/dialogs/edit-widget.html","<md-dialog class=\"edit-widget\" aria-label=\"EDIT\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between\"><h1 class=\"mr-0 flex-100 title\" style=\"line-height: 1\" layout=\"column\" \nlayout-align=\"center start\"><span>{{vm.widget.data.reference_name ? vm.widget.data.reference_name : vm.widget.title}}\n</span></h1><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div \nclass=\"form-wrapper pt-20 ph-0\" ng-if=\"!vm.widgetEditJson && !vm.widgetEditTemplate\"><form class=\"md-inline-form\">\n<md-input-container flex=\"100\" class=\"md-block mb-0 mh-20\"><label translate=\"WIDGETS.REF_NAME\"></label><input \nng-model=\"vm.widget.data.reference_name\" type=\"text\" value=\"\"></md-input-container><div \nng-if=\"vm.showSourceAndFiltersTab\" ng-include=\"\'app/main/apps/sitemap/dialogs/tab-source-filters.html\'\"></div><div \nng-if=\"vm.fieldsMapping\" ng-include=\"\'app/main/apps/sitemap/dialogs/tab-fields-mapping.html\'\"></div><div \nng-include=\"\'app/main/apps/sitemap/dialogs/tab-widget-options.html\'\"></div><div ng-if=\"vm.mediacenterRestrictions\" \nng-include=\"\'app/main/apps/sitemap/dialogs/tab-mediacenter-restrictions.html\'\"></div><div \nng-if=\"vm.isMediaVisible() && vm.widget.data.Section.section\" \nng-include=\"\'app/main/apps/sitemap/dialogs/tab-media-options.html\'\"></div><div \nng-include=\"\'app/main/apps/sitemap/dialogs/tab-extra-options.html\'\"></div></form></div><div \nclass=\"form-wrapper pt-20 ph-0 json-editor\" ng-if=\"vm.widgetEditJson\"><div class=\"md-warm pv-10 ph-20\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-alert-circle\" class=\"red-fg ml-0 mr-10\"></md-icon><strong \ntranslate=\"WIDGETS.JSON_ALERT_MESSAGE\" class=\"red-fg\"></strong></div><md-input-container flex=\"100\" \nclass=\"md-block mb-0 mh-20\"><label translate=\"WIDGETS.JSON\"></label><textarea ng-keyup=\"vm.setValid()\" \nid=\"text-area-json-edit\">{{vm.editjsonmodel | json}}</textarea></md-input-container></div><div \nclass=\"form-wrapper pt-20 ph-0 json-editor\" ng-if=\"vm.widgetEditTemplate\" \nng-include=\"\'app/main/apps/sitemap/dialogs/edit-template.html\'\"></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nng-if=\"vm.widgetEditJson == false && vm.widgetEditTemplate == false\" \nclass=\"send-button md-raised green-500-bg md-accent\" translate=\"WIDGETS.EDIT_JSON\" aria-label=\"EDIT JSON\" \nng-click=\"vm.showEditJson()\" translate=\"WIDGETS.EDIT_JSON\"></md-button><md-button \nng-if=\"vm.widgetEditTemplate == false && vm.widgetEditJson == false\" \nclass=\"send-button md-raised green-500-bg md-accent\" translate=\"WIDGETS.EDIT_TEMPLATE\" aria-label=\"EDIT TEMPLATE\" \nng-click=\"vm.showEditTemplate()\" translate=\"WIDGETS.EDIT_TEMPLATE\"></md-button><md-button \nng-if=\"vm.widgetEditJson == true || vm.widgetEditTemplate == true\" \nclass=\"send-button md-raised green-500-bg md-accent\" aria-label=\"NORMAL_EDIT\" ng-click=\"vm.showEdit()\" \ntranslate=\"WIDGETS.BACK\"></md-button></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"send-button md-raised md-accent\" translate=\"SITEMAP.APPLY\" aria-label=\"APPLY\" \nng-disabled=\"vm.widgetEditJson && !vm.valid\" ng-click=\"vm.saveDialog()\"></md-button><md-button \nclass=\"send-button md-raised md-warn\" translate=\"SITEMAP.CANCEL\" aria-label=\"CANCEL\" ng-click=\"vm.closeDialog()\">\n</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/sitemap/dialogs/editing-key.html","<md-input-container class=\"md-block mb-0 mh-0\"><label translate=\"WIDGETS.FIELDS_OPTIONS\"></label><md-select \nng-model=\"vm.widget.data[\'Show Fields\'][key].type\"><md-option value=\"--\">--</md-option><md-option value=\"text\">Text\n</md-option><md-option value=\"field\">Fields</md-option><md-option ng-if=\"vm.fieldsMapping.fields\" value=\"concat\">Concat\n</md-option><md-option value=\"media\">Media</md-option></md-select></md-input-container><div flex=\"90\" layout=\"column\">\n<md-input-container class=\"md-block mb-0 mh-0\" ng-if=\"vm.widget.data[\'Show Fields\'][key].type == \'field\'\"><label \ntranslate=\"WIDGETS.FIELDS_IN_CONTENT\"></label><md-select ng-model=\"vm.widget.data[\'Show Fields\'][key].value\"><md-option\n ng-repeat=\"ref in vm.selectedRef\" value=\"{{ref.field}}\"><span class=\"block font-size-10 grey-400-fg\">{{ref.field}}\n</span>{{ref.title}}</md-option></md-select></md-input-container><md-input-container class=\"md-block mb-0 mh-0\" \nng-if=\"vm.widget.data[\'Show Fields\'][key].type == \'text\'\"><label translate=\"WIDGETS.TEXT\"></label><input type=\"text\" \nvalue=\"\" ng-model=\"vm.widget.data[\'Show Fields\'][key].value\"></md-input-container><div layout=\"row\" \nlayout-align=\"space-between start\" ng-if=\"vm.widget.data[\'Show Fields\'][key].type == \'concat\'\" \nclass=\"concat-options pb-50 p-relative\"><md-chips ng-model=\"vm.widget.data[\'Show Fields\'][key].value\" \nmd-enable-chip-edit=\"true\" md-removable=\"true\" readonly=\"false\" placeholder=\"Add text...\" \nclass=\"mt-15 ml-0 mr-10 concat-chips\"><button md-chip-remove><md-icon md-font-icon=\"icon-close-circle\" class=\"s16\">\n</md-icon></button></md-chips><div class=\"concat-or\">or</div><md-menu class=\"md-block mb-0 ml-10 mt-15 mr-0\" flex=\"50\">\n<md-button ng-click=\"$mdMenu.open($event)\" aria-label=\"Open sample menu\" class=\"m-0\">Content fields<md-icon \nmd-font-icon=\"icon-menu-down\" class=\"s20\"></md-icon></md-button><md-menu-content><md-menu-item \nng-repeat=\"field in vm.fieldsMapping.fields\"><md-button \nng-click=\"vm.concatField(vm.widget.data[\'Show Fields\'][key].value, field.name)\">{{field.name}}</md-button>\n</md-menu-item></md-menu-content></md-menu></div></div>");
$templateCache.put("app/main/apps/sitemap/dialogs/tab-extra-options.html","<h3 ng-click=\"extraOptions= !extraOptions\" class=\"mt-5 pv-10 mt-0 ph-20 mb-0 mh-20\" layout=\"row\" \nlayout-align=\"space-between center\" \nng-class=\"{\'grey-200-bg grey-800-fg\' : !extraOptions,\'md-accent-bg white-fg\' : extraOptions}\"><strong \ntranslate=\"WIDGETS.EXTRA_OPTIONS\">Extra options</strong> <button><md-icon class=\"md-font-icon\" \nng-class=\"{\'icon-chevron-down\' : !extraOptions,\'icon-chevron-up\' : extraOptions}\"></md-icon></button></h3><div \nclass=\"pt-10 mh-20 mb-10 border-bottom border-right border-left\" id=\"extra-options\" \nng-class=\"{\'hide\' : !extraOptions,\'show\' : extraOptions}\"><div layout=\"row\" layout-align=\"space-between center\">\n<md-input-container flex=\"80\" class=\"md-block mb-0 mh-20\"><label>ID</label><input ng-model=\"vm.widget.config.id\" \ntype=\"text\" value=\"\"></md-input-container><md-input-container flex=\"20\" class=\"md-block mb-0 mh-20\"><label>Tag</label>\n<input ng-model=\"vm.widget.config.tag\" type=\"text\" value=\"\"></md-input-container></div><md-input-container flex=\"100\" \nclass=\"md-block mb-0 mh-20\"><label>Classes</label><input ng-model=\"vm.widget.config.class\" type=\"text\" value=\"\">\n</md-input-container><md-input-container flex=\"100\" class=\"md-block mb-0 mh-20\"><label>Extra params</label><textarea \nng-model=\"vm.widget.config.extra_params\"></textarea></md-input-container></div>");
$templateCache.put("app/main/apps/sitemap/dialogs/tab-fields-mapping.html","<h3 ng-click=\"widgetFieldsMapping= !widgetFieldsMapping\" class=\"mt-5 pv-10 mt-0 ph-20 mb-0 mh-20\" layout=\"row\" \nlayout-align=\"space-between center\" \nng-class=\"{\'grey-200-bg grey-800-fg\' : !widgetFieldsMapping,\'md-accent-bg white-fg\' : widgetFieldsMapping}\"><strong \ntranslate=\"WIDGETS.FILEDS_MAPPING\">Fields Mapping</strong> <button><md-icon class=\"md-font-icon\" \nng-class=\"{\'icon-chevron-down\' : !widgetFieldsMapping,\'icon-chevron-up\' : widgetFieldsMapping}\"></md-icon></button>\n</h3><div class=\"pt-0 mh-20 mb-10 border-right border-left border-bottom\" id=\"widget-fields-mapping\" \nng-class=\"{\'hide\' : !widgetFieldsMapping,\'show\' : widgetFieldsMapping}\"><div ng-if=\"!vm.template\" layout=\"row\" \nlayout-align=\"space-between center\" flex=\"100\" class=\"pt-20 pb-20 pr-10 pl-20\"><div layout=\"column\" flex=\"85\"><div \nlayout=\"row\" layout-align=\"start start\" class=\"mb-10\" flex=\"100\"><div flex=\"90\" layout=\"column\"><md-input-container \nflex class=\"md-block mb-0 mr-0\"><label translate=\"WIDGETS.FIELDS_IN_WIDGET\"></label><md-select \nng-change=\"vm.cleanFilters()\" ng-model=\"vm.fieldWidget\"><md-option value=\"--\">--</md-option><md-option value=\"custom\">\nCustom field</md-option><md-option ng-repeat=\"field in vm.fieldsMapping.fields | orderBy: \'name\'\" \nvalue=\"{{field.name}}\">{{field.name}}</md-option></md-select></md-input-container><md-input-container \nng-if=\"vm.fieldWidget == \'custom\'\" class=\"md-block mb-0 mr-0\"><label>Field</label><input \nng-model=\"vm.fieldWidgetCustom\" type=\"text\" value=\"\"></md-input-container></div><md-icon \nmd-font-icon=\"icon-chevron-right\" aria-label=\"ARROW\" flex=\"10\" class=\"text-center mt-24\"></md-icon><md-input-container \nclass=\"md-block mb-0 mh-0\"><label translate=\"WIDGETS.FIELDS_OPTIONS\"></label><md-select ng-model=\"vm.fieldOptions\">\n<md-option value=\"--\">--</md-option><md-option value=\"text\">Text</md-option><md-option value=\"field\">Fields</md-option>\n<md-option ng-if=\"vm.fieldsMapping.fields\" value=\"concat\">Concat</md-option><md-option ng-if=\"!vm.widget.v1_layout\" \nvalue=\"if\">IF</md-option><md-option value=\"media\">Media</md-option></md-select></md-input-container><div flex=\"90\" \nlayout=\"column\"><md-input-container class=\"md-block mb-0 mh-0\" ng-if=\"vm.fieldOptions == \'field\'\"><label \ntranslate=\"WIDGETS.FIELDS_IN_CONTENT\"></label><md-select ng-model=\"vm.fieldContent\"><md-option \nng-repeat=\"ref in vm.selectedRef | orderBy: \'title\'\" value=\"{{ref.field}}\"><span \nclass=\"block font-size-10 grey-400-fg\">{{ref.field}}</span>{{ref.title}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block mb-0 mh-0\" ng-if=\"vm.fieldOptions == \'text\'\"><label translate=\"WIDGETS.TEXT\">\n</label><input type=\"text\" value=\"\" ng-model=\"vm.fieldOptionsText\"></md-input-container><div layout=\"row\" \nlayout-align=\"space-between start\" ng-if=\"vm.fieldOptions == \'concat\'\" class=\"concat-options pb-50 p-relative\">\n<md-chips ng-model=\"vm.fieldsConcat\" md-enable-chip-edit=\"true\" md-removable=\"true\" readonly=\"false\" \nplaceholder=\"Add text...\" class=\"mt-15 ml-0 mr-10 concat-chips\"><button md-chip-remove><md-icon \nmd-font-icon=\"icon-close-circle\" class=\"s16\"></md-icon></button></md-chips><div class=\"concat-or\">or</div><md-menu \nclass=\"md-block mb-0 ml-10 mt-15 mr-0\" flex=\"50\"><md-button ng-click=\"$mdMenu.open($event)\" \naria-label=\"Open sample menu\" class=\"m-0\">Content fields<md-icon md-font-icon=\"icon-menu-down\" class=\"s20\"></md-icon>\n</md-button><md-menu-content><md-menu-item ng-repeat=\"field in vm.fieldsMapping.fields | orderBy: \'name\'\"><md-button \nng-click=\"vm.concatField(vm.fieldsConcat, field.name)\">{{field.name}}</md-button></md-menu-item></md-menu-content>\n</md-menu></div></div></div><div style=\"padding: 5px 5px; padding-bottom: 20px; border: 1px solid rgba(0, 0, 0, 0.12)\" \nlayout=\"column\" layout-align=\"space-between start\" ng-if=\"vm.fieldOptions == \'if\'\" flex=\"100\"><ms-filter-widget \non-submit=\"vm.fieldFiltersIf.push(filter)\" sections=\"vm.sections\" section=\"vm.widget.data.Section.section\">\n</ms-filter-widget><ms-chips-filters ng-if=\"vm.fieldFiltersIf.length> 0\" filters=\"vm.fieldFiltersIf\">\n</ms-chips-filters></div><div layout=\"column\" ng-if=\"vm.fieldOptions == \'if\' && vm.fieldFiltersIf.length> 0\" \nflex=\"100\"><div class=\"mb-10\" layout=\"row\" layout-align=\"space-between start\" flex=\"100\"><h3 class=\"m-0\" \nstyle=\"line-height: 70px\">TRUE</h3><md-icon md-font-icon=\"icon-chevron-right\" aria-label=\"ARROW\" flex=\"10\" \nclass=\"text-center mt-24\"></md-icon><md-input-container class=\"md-block mb-0 mh-0\"><label \ntranslate=\"WIDGETS.FIELDS_OPTIONS\"></label><md-select ng-model=\"vm.fieldOptionsTrue\"><md-option value=\"--\">--\n</md-option><md-option value=\"text\">Text</md-option><md-option value=\"field\">Fields</md-option><md-option \nvalue=\"concat\">Concat</md-option><md-option value=\"media\">Media</md-option></md-select></md-input-container><div \nflex=\"90\" layout=\"column\"><md-input-container class=\"md-block mb-0 mh-0\" ng-if=\"vm.fieldOptionsTrue == \'field\'\"><label \ntranslate=\"WIDGETS.FIELDS_IN_CONTENT\"></label><md-select ng-model=\"vm.fieldContentTrue\"><md-option value=\"--\">--\n</md-option><md-option value=\"custom\">Custom field</md-option><md-option \nng-repeat=\"field in vm.fieldsMapping.fields | orderBy: \'name\'\" value=\"{{field.name}}\">{{field.name}}</md-option>\n</md-select></md-input-container><md-input-container ng-if=\"vm.fieldContentTrue == \'custom\'\" \nclass=\"md-block mb-0 mr-0\"><label>Field</label><input ng-model=\"vm.fieldContentCustomTrue\" type=\"text\" value=\"\">\n</md-input-container><md-input-container class=\"md-block mb-0 mh-0\" ng-if=\"vm.fieldOptionsTrue == \'text\'\"><label \ntranslate=\"WIDGETS.TEXT\"></label><input type=\"text\" value=\"\" ng-model=\"vm.fieldOptionsTextTrue\"></md-input-container>\n<div layout=\"row\" layout-align=\"space-between start\" ng-if=\"vm.fieldOptionsTrue == \'concat\'\" \nclass=\"concat-options pb-50 p-relative\"><md-chips ng-model=\"vm.fieldsConcatTrue\" md-enable-chip-edit=\"true\" \nmd-removable=\"true\" readonly=\"false\" placeholder=\"Add text...\" class=\"mt-15 ml-0 mr-10 concat-chips\"><button \nmd-chip-remove><md-icon md-font-icon=\"icon-close-circle\" class=\"s16\"></md-icon></button></md-chips><div \nclass=\"concat-or\">or</div><md-menu class=\"md-block mb-0 ml-10 mt-15 mr-0\" flex=\"50\"><md-button \nng-click=\"$mdMenu.open($event)\" aria-label=\"Open sample menu\" class=\"m-0\">Content fields<md-icon \nmd-font-icon=\"icon-menu-down\" class=\"s20\"></md-icon></md-button><md-menu-content><md-menu-item \nng-repeat=\"field in vm.fieldsMapping.fields  | orderBy: \'name\'\"><md-button \nng-click=\"vm.concatField(vm.fieldsConcatTrue, field.name)\">{{field.name}}</md-button></md-menu-item></md-menu-content>\n</md-menu></div></div></div><div class=\"mb-10\" layout=\"row\" layout-align=\"space-between start\" flex=\"100\"><h3 \nclass=\"m-0\" style=\"line-height: 70px\">FALSE</h3><md-icon md-font-icon=\"icon-chevron-right\" aria-label=\"ARROW\" \nflex=\"10\" class=\"text-center mt-24\"></md-icon><md-input-container class=\"md-block mb-0 mh-0\"><label \ntranslate=\"WIDGETS.FIELDS_OPTIONS\"></label><md-select ng-model=\"vm.fieldOptionsFalse\"><md-option value=\"--\">--\n</md-option><md-option value=\"text\">Text</md-option><md-option value=\"field\">Fields</md-option><md-option \nvalue=\"concat\">Concat</md-option><md-option value=\"media\">Media</md-option></md-select></md-input-container><div \nflex=\"90\" layout=\"column\"><md-input-container class=\"md-block mb-0 mh-0\" ng-if=\"vm.fieldOptionsFalse == \'field\'\"><label\n translate=\"WIDGETS.FIELDS_IN_CONTENT\"></label><md-select ng-model=\"vm.fieldContentFalse\"><md-option value=\"--\">--\n</md-option><md-option value=\"custom\">Custom field</md-option><md-option \nng-repeat=\"field in vm.fieldsMapping.fields  | orderBy: \'name\'\" value=\"{{field.name}}\">{{field.name}}</md-option>\n</md-select></md-input-container><md-input-container ng-if=\"vm.fieldContentFalse == \'custom\'\" \nclass=\"md-block mb-0 mr-0\"><label>Field</label><input ng-model=\"vm.fieldContentCustomFalse\" type=\"text\" value=\"\">\n</md-input-container><md-input-container class=\"md-block mb-0 mh-0\" ng-if=\"vm.fieldOptionsFalse == \'text\'\"><label \ntranslate=\"WIDGETS.TEXT\"></label><input type=\"text\" value=\"\" ng-model=\"vm.fieldOptionsTextFalse\"></md-input-container>\n<div layout=\"row\" layout-align=\"space-between start\" ng-if=\"vm.fieldOptionsFalse == \'concat\'\" \nclass=\"concat-options pb-50 p-relative\"><md-chips ng-model=\"vm.fieldsConcatFalse\" md-enable-chip-edit=\"true\" \nmd-removable=\"true\" readonly=\"false\" placeholder=\"Add text...\" class=\"mt-15 ml-0 mr-10 concat-chips\"><button \nmd-chip-remove><md-icon md-font-icon=\"icon-close-circle\" class=\"s16\"></md-icon></button></md-chips><div \nclass=\"concat-or\">or</div><md-menu class=\"md-block mb-0 ml-10 mt-15 mr-0\" flex=\"50\"><md-button \nng-click=\"$mdMenu.open($event)\" aria-label=\"Open sample menu\" class=\"m-0\">Content fields<md-icon \nmd-font-icon=\"icon-menu-down\" class=\"s20\"></md-icon></md-button><md-menu-content><md-menu-item \nng-repeat=\"field in vm.fieldsMapping.fields  | orderBy: \'name\'\"><md-button \nng-click=\"vm.concatField(vm.fieldsConcatFalse, field.name)\">{{field.name}}</md-button></md-menu-item></md-menu-content>\n</md-menu></div></div></div></div></div><md-button ng-if=\"vm.isFilterMapingComplete()\" \nng-click=\"vm.addFilterMapping()\" class=\"add-event-button md-icon-button\"><md-icon md-font-icon=\"icon-plus-circle\" \nclass=\"green-fg\" aria-label=\"ADD\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"WIDGETS.ADD_FIELD_MAPPING\">\nADD FILTER</span></md-tooltip></md-button></div><div ng-if=\"vm.template\" ng-repeat=\"key in vm.template.values\" \nlayout=\"row\" layout-align=\"space-between center\" flex=\"100\" class=\"mb-0 pv-5 pr-10 pl-20 border-top\" \nstyle=\"min-height: 50px; align-items: flex-start; padding-top: 12px; padding-bottom: 12px\"><div layout=\"row\" \nlayout-align=\"start start\" flex=\"85\" style=\"min-width: 0; flex-wrap: wrap\"><span class=\"grey-700-fg font-size-16\" \nflex=\"30\" style=\"min-width: 0; word-break: break-word\">{{key.label}}</span><md-icon md-font-icon=\"icon-chevron-right\" \naria-label=\"ARROW\" flex=\"10\" class=\"text-center\" style=\"margin-top: 2px\"></md-icon><span ng-if=\"!key.editing\" \nclass=\"grey-700-fg font-size-16\" flex=\"60\" style=\"min-width: 0; word-break: break-word; white-space: pre-wrap\">\n{{key.value}}</span> <span ng-if=\"key.editing\" class=\"font-size-16\" flex=\"60\"><div layout=\"row\"><md-input-container \nclass=\"md-block mb-0 mh-0\"><input type=\"text\" value=\"\" ng-model=\"key.value\"></md-input-container></div></span></div>\n<div layout=\"row\" layout-align=\"end center\"><md-button ng-if=\"!key.editing\" ng-click=\"key.editing= true;\" \nclass=\"w-20 add-event-button md-icon-button\"><md-icon md-font-icon=\"icon-pencil\" class=\"s20\" aria-label=\"EDIT\">\n</md-icon><md-tooltip hide show-gt-xs><span translate=\"WIDGETS.EDIT_MAPPING\">EDIT MAPPING</span></md-tooltip>\n</md-button><md-button ng-if=\"key.editing\" ng-click=\"key.editing= false;\" class=\"w-20 add-event-button md-icon-button\">\n<md-icon md-font-icon=\"icon-content-save\" class=\"s20\" aria-label=\"SAVE\"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate=\"WIDGETS.SAVE_MAPPING\">SAVE MAPPING</span></md-tooltip></md-button><button ng-if=\"key.onoff===1\" \nng-click=\"key.onoff = 0\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" \nclass=\"on green-fg s24\"></md-icon></button> <button ng-if=\"key.onoff!==1 || !key.onoff\" ng-click=\"key.onoff = 1\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\"></md-icon>\n</button></div></div><div ng-if=\"!vm.template\" \nng-repeat=\"key in keys(vm.widget.data[\'Show Fields\']) | orderBy:\'toString()\'\" layout=\"row\" \nlayout-align=\"space-between center\" flex=\"100\" class=\"mb-0 pv-5 pr-10 pl-20 border-top\"><div layout=\"row\" \nlayout-align=\"start center\" flex=\"85\"><span class=\"grey-700-fg font-size-16\" flex=\"30\">{{key}}</span><md-icon \nmd-font-icon=\"icon-chevron-right\" aria-label=\"ARROW\" flex=\"10\" class=\"text-center\"></md-icon><span flex=\"60\" \nng-if=\"!vm.widget.data[\'Show Fields\'][key].editing\"><span \nng-if=\"vm.widget.data[\'Show Fields\'][key].type == \'field\' || vm.widget.data[\'Show Fields\'][key].type == \'text\'\" \nclass=\"font-size-16\" flex=\"60\">{{vm.widget.data[\'Show Fields\'][key].value}}</span> <span \nng-if=\"vm.widget.data[\'Show Fields\'][key].type == \'concat\'\" class=\"grey-700-fg font-size-16\" flex=\"60\"><span \nng-repeat=\"field in vm.widget.data[\'Show Fields\'][key].value\">{{field.text ? field.text: field.field}}</span> </span>\n<span ng-if=\"vm.widget.data[\'Show Fields\'][key].type == \'media\'\" class=\"font-size-16\" flex=\"60\">Media</span> <span \nng-if=\"vm.widget.data[\'Show Fields\'][key].type == \'if\'\" class=\"font-size-16\" flex=\"60\">IF</span> </span><span \nng-if=\"vm.widget.data[\'Show Fields\'][key].editing\" class=\"font-size-16\" flex=\"60\"><div layout=\"row\" \nng-include=\"\'app/main/apps/sitemap/dialogs/editing-key.html\'\"></div></span></div><div layout=\"row\" \nlayout-align=\"end center\"><md-button \nng-if=\"!vm.widget.data[\'Show Fields\'][key].editing && vm.widget.data[\'Show Fields\'][key].type == \'if\'\" \nng-click=\"vm.editMapping(key)\" class=\"w-20 add-event-button md-icon-button\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"s20\" aria-label=\"EDIT\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"WIDGETS.EDIT_MAPPING\">EDIT MAPPING\n</span></md-tooltip></md-button><md-button \nng-if=\"!vm.widget.data[\'Show Fields\'][key].editing && vm.widget.data[\'Show Fields\'][key].type != \'if\'\" \nng-click=\"vm.widget.data[\'Show Fields\'][key].editing= true;\" class=\"w-20 add-event-button md-icon-button\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"s20\" aria-label=\"EDIT\"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate=\"WIDGETS.EDIT_MAPPING\">EDIT MAPPING</span></md-tooltip></md-button><md-button \nng-if=\"vm.widget.data[\'Show Fields\'][key].editing && vm.widget.data[\'Show Fields\'][key].type != \'if\'\" \nng-click=\"vm.widget.data[\'Show Fields\'][key].editing= false;\" class=\"w-20 add-event-button md-icon-button\"><md-icon \nmd-font-icon=\"icon-content-save\" class=\"s20\" aria-label=\"SAVE\"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate=\"WIDGETS.SAVE_MAPPING\">SAVE MAPPING</span></md-tooltip></md-button><md-button \nng-click=\"vm.deleteMapping(key)\" class=\"add-event-button md-icon-button\"><md-icon md-font-icon=\"icon-minus-circle\" \nclass=\"red-fg\" aria-label=\"AREMOVEDD\"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate=\"WIDGETS.REMOVE_FIELD_MAPPING\">REMOVE MAPPING</span></md-tooltip></md-button></div></div></div>");
$templateCache.put("app/main/apps/sitemap/dialogs/tab-media-options.html","<h3 ng-click=\"mediaOptions= !mediaOptions\" class=\"mt-5 pv-10 mt-0 ph-20 mb-0 mh-20\" layout=\"row\" \nlayout-align=\"space-between center\" \nng-class=\"{\'grey-200-bg grey-800-fg\' : !mediaOptions,\'md-accent-bg white-fg\' : mediaOptions}\"><strong \ntranslate=\"WIDGETS.MEDIA_OPTIONS\">Media options</strong> <button><md-icon class=\"md-font-icon\" \nng-class=\"{\'icon-chevron-down\' : !mediaOptions,\'icon-chevron-up\' : mediaOptions}\"></md-icon></button></h3><div \nclass=\"mh-20 mb-10 border-right border-left\" id=\"media-options\" \nng-class=\"{\'hide\' : !mediaOptions,\'show\' : mediaOptions}\"><div ng-if=\"vm.widget.mediazones.length ==0\" \nclass=\"media-zone no-zone border-bottom pv-10\"><ms-cropformat-widget cropformatoptions=\"vm.cropFormatOptions\" \nwidget=\"vm.widget\"></ms-cropformat-widget></div><div ng-if=\"vm.widget.mediazones.length > 0\" \nng-repeat=\"mediazone in vm.widget.mediazones | orderBy: \'id_zone\'\" class=\"media-zone border-bottom\"><h3 \nclass=\"grey-100-bg ph-20 mt-0 mb-0 pv-10\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\">\n<strong>Title</strong> <strong>{{mediazone.title}}</strong> <strong ng-if=\"!mediazone.title\">null</strong></div><div \nlayout=\"column\"><strong>Description</strong> <strong>{{mediazone.description}}</strong> <strong \nng-if=\"!mediazone.description\">null</strong></div><md-switch aria-label=\"On Off\" ng-model=\"mediazone.enabled\">\n</md-switch></h3><div class=\"pt-30\" ng-if=\"mediazone.enabled\" flex=\"100\"><md-input-container flex=\"100\" \nclass=\"md-block mb-0 mh-20 mt-0\"><label>Zone name</label><input ng-model=\"mediazone.title\" type=\"text\" \nvalue=\"article-images\"></md-input-container></div><ms-cropformat-widget ng-if=\"mediazone.enabled\" \ncropformatoptions=\"vm.cropFormatOptions\" widget=\"mediazone\"></ms-cropformat-widget></div></div>");
$templateCache.put("app/main/apps/sitemap/dialogs/tab-mediacenter-restrictions.html","<h3 ng-click=\"mediacenterRestrictions= !mediacenterRestrictions\" class=\"mt-5 pv-10 mt-0 ph-20 mb-0 mh-20\" layout=\"row\" \nlayout-align=\"space-between center\" \nng-class=\"{\'grey-200-bg grey-800-fg\' : !mediacenterRestrictions,\'md-accent-bg white-fg\' : mediacenterRestrictions}\">\n<strong translate=\"WIDGETS.MEDIACENTER_RESTRICTIONS\">Fields Mapping</strong> <button><md-icon class=\"md-font-icon\" \nng-class=\"{\'icon-chevron-down\' : !mediacenterRestrictions,\'icon-chevron-up\' : mediacenterRestrictions}\"></md-icon>\n</button></h3><div class=\"pt-0 mh-20 mb-10 border-right border-left border-bottom\" \nid=\"widget-mediacenter-restrictions\" ng-class=\"{\'hide\' : !mediacenterRestrictions,\'show\' : mediacenterRestrictions}\">\n<div layout=\"column\" layout-align=\"space-between center\" flex=\"100\" class=\"pt-20 pb-20 pr-10 pl-20\"><div \nclass=\"restriction-container\" ng-repeat=\"res in vm.restrictions track by $index\"><div \nclass=\"config-restriction-container\"><md-input-container><label translate=\"WIDGETS.SELECT_RESTRICTION_GROUP\"></label>\n<md-select ng-model=\"res.group\"><md-option value=\"\">--</md-option><md-option ng-repeat=\"group in vm.restrictionGroups\" \nvalue=\"{{group.id_group}}\">{{group.name}}</md-option></md-select></md-input-container><md-input-container \nng-if=\"res.group\"><label translate=\"WIDGETS.SELECT_RESTRICTION_STATUS\"></label><md-select ng-model=\"res.status\">\n<md-option value=\"\">--</md-option><md-option ng-repeat=\"status in vm.filteredRestrictionStatus(res.group)\" \nvalue=\"{{status.id_ingroup_status}}\">{{status.name}}</md-option></md-select></md-input-container><md-button \nng-click=\"vm.restrictions.splice($index, 1)\"><md-icon md-font-icon=\"icon-minus-circle\" class=\"red-fg\" \naria-label=\"AREMOVEDD\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"WIDGETS.REMOVE_RESTRICTION\">\nREMOVE RESTRICTION</span></md-tooltip></md-button></div><div ng-if=\"res.group\"><md-input-container \nng-repeat=\"crop in vm.restrictionCrops\"><md-checkbox aria-label=\"Checkbox option\" ng-click=\"vm.updateCrops(crop, res)\" \nng-checked=\"res.cropformats.indexOf(crop.id_cropformats) !== -1\">(#{{crop.id_cropformats}}) {{crop.name}}</md-checkbox>\n</md-input-container></div></div><md-button ng-click=\"vm.restrictions.push({\'cropformats\': []})\" \nclass=\"add-event-button md-icon-button\"><md-icon md-font-icon=\"icon-plus-circle\" class=\"green-fg\" aria-label=\"ADD\">\n</md-icon><md-tooltip hide show-gt-xs><span translate=\"WIDGETS.ADD_RESTRICTION\">ADD RESTRICTION</span></md-tooltip>\n</md-button></div></div>");
$templateCache.put("app/main/apps/sitemap/dialogs/tab-source-filters.html","<h3 ng-click=\"sourceFilters= !sourceFilters\" class=\"pv-10 mt-0 ph-20 mb-0 mh-20\" layout=\"row\" \nlayout-align=\"space-between center\" \nng-class=\"{\'grey-200-bg grey-800-fg\' : !sourceFilters,\'md-accent-bg white-fg\' : sourceFilters}\"><strong \ntranslate=\"WIDGETS.SOURCE_FILTERS\">Source & Filters</strong> <button><md-icon class=\"md-font-icon\" \nng-class=\"{\'icon-chevron-down\' : !sourceFilters,\'icon-chevron-up\' : sourceFilters}\"></md-icon></button></h3><div \nclass=\"pt-30 pb-20 mh-20 mb-10 border-right border-left border-bottom\" id=\"source-filters\" \nng-class=\"{\'hide\' : !sourceFilters,\'show\' : sourceFilters}\"><div layout=\"column\" layout-gt-xs=\"row\" class=\"ph-20\">\n<md-input-container flex=\"100\" class=\"md-block mt-0 mr-5\"><label translate=\"WIDGETS.SOURCE\"></label><md-select \nng-change=\"vm.selectChanged()\" ng-model=\"vm.widget.data.Section.section\" md-on-close=\"search= \'\'\" \nmd-container-class=\"md-select-mini md-select-search\"><md-select-header class=\"select-header-search\"><input autofocus \nng-model=\"search\" type=\"search\" onkeydown=\"event.stopPropagation()\" placeholder=\"Search...\" \nclass=\"demo-header-searchbox md-text\"></md-select-header><md-optgroup \nng-repeat=\"category in vm.optionsSection.categories\" label=\"{{category.name}}\"><md-option ng-value=\"option.section\" \nng-repeat=\"option in vm.optionsSection.options | filter: {category: category.value, name: searchTime, section: search }\">\n{{option.section}}</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"row\" class=\"ph-20\">\n<ms-filter-widget on-submit=\"vm.pushFilter(filter)\" sections=\"vm.sections\" section=\"vm.widget.data.Section.section\" \nng-if=\"vm.widget.data.Section.section\"></ms-filter-widget></div><ms-chips-filters class=\"pb-20\" \nfilters=\"vm.widget.data.Section.filters\"></ms-chips-filters><div layout=\"row\" layout-align=\"space-between center\" \nflex=\"100\" class=\"mb-0 pv-5 pr-10 pl-20 h-50 border-top\"><div layout=\"row\" layout-align=\"start center\" flex=\"85\"><span \nng-if=\"!vm.sectionEdit\" class=\"grey-700-fg font-size-16\" flex=\"100\">{{global.stringSection}}</span> <span \nng-if=\"vm.sectionEdit\" class=\"font-size-16\" flex=\"100\"><div layout=\"row\"><md-input-container \nclass=\"md-block mb-0 mh-0\" style=\"min-width: 100%\"><input type=\"text\" value=\"\" ng-model=\"global.stringSection\">\n</md-input-container></div></span></div><div layout=\"row\" layout-align=\"end center\"><md-button ng-if=\"!vm.sectionEdit\" \nng-click=\"vm.sectionEdit= true;\" class=\"w-20 add-event-button md-icon-button\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"s20\" aria-label=\"EDIT\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"WIDGETS.EDIT_MAPPING\">EDIT MAPPING\n</span></md-tooltip></md-button><md-button ng-if=\"vm.sectionEdit\" \nng-click=\"vm.sectionEdit= false; vm.constructWidget(\'true\')\" class=\"w-20 add-event-button md-icon-button\"><md-icon \nmd-font-icon=\"icon-content-save\" class=\"s20\" aria-label=\"SAVE\"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate=\"WIDGETS.SAVE_MAPPING\">SAVE MAPPING</span></md-tooltip></md-button></div></div></div>");
$templateCache.put("app/main/apps/sitemap/dialogs/tab-widget-options.html","<h3 ng-click=\"widgetOptions= !widgetOptions\" class=\"mt-5 pv-10 mt-0 ph-20 mb-0 mh-20\" layout=\"row\" \nlayout-align=\"space-between center\" \nng-class=\"{\'grey-200-bg grey-800-fg\' : !widgetOptions,\'md-accent-bg white-fg\' : widgetOptions}\"><strong \ntranslate=\"WIDGETS.WIDGET_OPTIONS\">Widget options</strong> <button><md-icon class=\"md-font-icon\" \nng-class=\"{\'icon-chevron-down\' : !widgetOptions,\'icon-chevron-up\' : widgetOptions}\"></md-icon></button></h3><div \nlayout=\"row\" layout-wrap=\"\" class=\"pt-10 pb-10 mh-20 mb-10 border-right border-left border-bottom\" id=\"widget-options\" \nng-class=\"{\'hide\' : !widgetOptions,\'show\' : widgetOptions}\"><div ng-repeat=\"field in vm.widget.fields\" \nng-class=\"{\r\n            \'flex-100\': true, \r\n             \'mb-18\': field.type === \'switch\',\r\n             \'mb-20\': field.type === \'tags\',\r\n             \'flex-gt-sm-100\': field.type === \'tags\', \r\n             \'flex-gt-sm-50\': field.type === \'single\' || field.type === \'switch\' || field.type === \'mediahub galleries\' || field.type === \'mediahub cropformats\',\r\n             \'flex-gt-xs-50\': field.type === \'checkbox\' || field.type === \'switch\',\r\n             \'flex-gt-sm-33\': field.type === \'checkbox\'\r\n         }\" \nclass=\"ph-20\" ng-style=\"field.type === \'checkbox\' ? {\'order\': 99} : {}\"><md-input-container \nng-if=\"field.type === \'single\'\" class=\"md-block\"><label>{{field.title}}</label><input \nng-model=\"vm.widget.data[field.title]\" type=\"text\" value=\"\"></md-input-container><md-input-container \nng-if=\"field.type === \'checkbox\'\" class=\"md-block m-0\"><md-checkbox ng-model=\"vm.widget.data[field.title]\" \naria-label=\"Checkbox option\">{{field.title}}</md-checkbox></md-input-container><div ng-if=\"field.type === \'switch\'\" \nng-init=\"vm.widget.data[field.title] = vm.widget.data[field.title] || field.values[0]\"><label class=\"switch-label\">\n{{field.title}}</label><div class=\"switch-container\"><button ng-repeat=\"val in field.values\" type=\"button\" \nclass=\"switch-btn\" ng-class=\"{\'switch-btn--active\': vm.widget.data[field.title] === val}\" \nng-click=\"vm.widget.data[field.title] = val\">{{val}}</button></div></div><div \nng-if=\"field.type === \'mediahub galleries\'\" layout=\"row\" layout-align=\"start center\"><md-input-container \nclass=\"md-block m-0\" flex \nng-init=\"vm.widget.data[field.title] = vm.widget.data[field.title] !== undefined ? vm.widget.data[field.title] : null\">\n<label>{{field.title}}</label><md-select ng-model=\"vm.widget.data[field.title]\" \nmd-on-close=\"vm.searchTermGalleries = \'\'\" md-container-class=\"md-select-mini md-select-search\"><md-select-header \nclass=\"select-header-search\"><input autofocus ng-model=\"vm.searchTermGalleries\" type=\"search\" \nonkeydown=\"event.stopPropagation()\" placeholder=\"Search galleries...\" class=\"demo-header-searchbox md-text\">\n</md-select-header><md-option ng-value=\"0\" style=\"padding-left: 16px\"><md-icon md-font-icon=\"icon-folder\" class=\"s16\" \nstyle=\"margin-right: 8px; color: #737373\"></md-icon><span>Root</span></md-option><md-option \nng-repeat=\"gallery in vm.mediahubGalleries | filter: {name: vm.searchTermGalleries}\" ng-value=\"gallery.id\" \nng-style=\"{\'padding-left\': (gallery.depth * 20 + 16) + \'px\'}\"><md-icon md-font-icon=\"icon-folder\" class=\"s16\" \nstyle=\"margin-right: 8px; color: #737373\"></md-icon><span>{{gallery.name}}</span></md-option></md-select><div \nng-if=\"vm.isLoadingGalleries\" style=\"font-size: 11px; margin-top: 5px; color: gray\" \ntranslate=\"WIDGETS.LOADING_GALLERIES\">Loading galleries...</div><div ng-if=\"vm.mediahubError\" \nstyle=\"font-size: 11px; margin-top: 5px; color: red\" translate=\"WIDGETS.ERROR_LOADING_GALLERIES\">\nError loading galleries.</div></md-input-container><md-button class=\"md-icon-button md-warn\" \nng-click=\"vm.clearMediahubGallery(field.title)\" \nng-if=\"vm.widget.data[field.title] !== null && vm.widget.data[field.title] !== undefined\" aria-label=\"Clear selection\">\n<md-icon md-font-icon=\"icon-close\"></md-icon><md-tooltip>Clear {{field.title}}</md-tooltip></md-button></div>\n<md-input-container ng-if=\"field.type === \'mediahub cropformats\'\" class=\"md-block\"><label>{{field.title}}</label>\n<md-select ng-model=\"vm.widget.data[field.title]\"><md-option ng-repeat=\"cropformat in vm.mediahubCropformats\" \nng-value=\"cropformat.id\"><span>#{{cropformat.id}} {{cropformat.width}}x{{cropformat.height}}</span></md-option>\n</md-select><div ng-if=\"vm.isLoadingCropformats\" style=\"font-size: 11px; margin-top: 5px; color: gray\" \ntranslate=\"WIDGETS.LOADING_CROPFORMATS\">Loading crop formats...</div><div ng-if=\"vm.mediahubCropformatsError\" \nstyle=\"font-size: 11px; margin-top: 5px; color: red\" translate=\"WIDGETS.ERROR_LOADING_CROPFORMATS\">\nError loading crop formats.</div></md-input-container><div ng-if=\"field.type === \'teams-layout\'\" class=\"mb-20\"><label \nclass=\"md-caption grey-600-fg\" style=\"display: block; margin-bottom: 8px\">{{field.title}}</label><div \nclass=\"teams-layout-container\" \nstyle=\"min-height: 40px; border: 1px solid #e0e0e0; border-radius: 4px; padding: 10px; background: #fafafa\"><div \ndragula=\'\"teams-layout-widget-bag\"\' dragula-model=\"vm.teamsLayoutChips[field.title]\" style=\"min-height: 20px\"><div \nng-repeat=\"chip in vm.teamsLayoutChips[field.title] track by chip._id\" class=\"teams-layout-item-wrapper mb-5\"><div \nng-if=\"vm.isField(chip)\" class=\"teams-layout-chip\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-drag-vertical\" class=\"s16 drag-handle cursor-move\" \nstyle=\"margin-right: 4px; color: #999; outline: none\"></md-icon><span class=\"chip-text\">{{chip.value}}</span><md-icon \nmd-font-icon=\"icon-close\" class=\"s14 ml-5 cursor-pointer\" ng-click=\"vm.removeTeamChip(field.title, $index)\" \nstyle=\"outline: none\"></md-icon></div><div ng-if=\"vm.isGroup(chip)\" class=\"teams-layout-group p-10 border mb-5\" \nstyle=\"background: #fff; border-style: dashed; border-color: #ccc; border-radius: 4px\"><div layout=\"row\" \nlayout-align=\"start center\" class=\"mb-10\"><md-icon md-font-icon=\"icon-drag-vertical\" \nclass=\"s16 drag-handle cursor-move\" style=\"margin-right: 4px; color: #999; outline: none\"></md-icon><strong \nclass=\"font-size-12 mr-10\" style=\"color: #666\">GROUP</strong><md-input-container class=\"md-block m-0 mr-10\" flex>\n<label>Class</label><input ng-model=\"chip.class\" ng-change=\"vm.updateTeamsLayout(field.title)\"></md-input-container>\n<md-input-container class=\"md-block m-0 mr-10\" flex><label>ID</label><input ng-model=\"chip.id\" \nng-change=\"vm.updateTeamsLayout(field.title)\"></md-input-container><md-icon md-font-icon=\"icon-close\" \nclass=\"s14 cursor-pointer\" ng-click=\"vm.removeTeamChip(field.title, $index)\" style=\"outline: none\"></md-icon></div><div\n class=\"teams-layout-subcontainer\" dragula=\'\"teams-layout-widget-bag\"\' dragula-model=\"chip.fields\" \nstyle=\"min-height: 30px; border: 1px solid #eee; padding: 5px; background: #f9f9f9; border-radius: 4px\"><div \nng-repeat=\"subchip in chip.fields track by subchip._id\" class=\"teams-layout-chip\" layout=\"row\" \nlayout-align=\"start center\" style=\"display: inline-flex\"><md-icon md-font-icon=\"icon-drag-vertical\" \nclass=\"s16 drag-handle cursor-move\" style=\"margin-right: 4px; color: #999; outline: none\"></md-icon><span \nclass=\"chip-text\">{{subchip.value}}</span><md-icon md-font-icon=\"icon-close\" class=\"s14 ml-5 cursor-pointer\" \nng-click=\"vm.removeSubChip(field.title, $parent.$index, $index)\" style=\"outline: none\"></md-icon></div><div \nng-if=\"chip.fields.length === 0\" class=\"grey-400-fg font-size-10 text-center\" style=\"padding: 5px\">Drag fields here\n</div></div></div></div></div><div \nng-if=\"!vm.teamsLayoutChips[field.title] || vm.teamsLayoutChips[field.title].length === 0\" \nclass=\"grey-400-fg font-size-12\" style=\"padding: 8px\">No fields or groups added yet.</div></div><div layout=\"row\" \nlayout-align=\"start center\" class=\"mt-10\"><md-autocomplete flex md-selected-item=\"selectedItem\" \nmd-search-text=\"vm.teamsSearchText[field.title]\" \nmd-selected-item-change=\"vm.addTeamChip(field.title, selectedItem); selectedItem = null; vm.teamsSearchText[field.title] = \'\'\" \nng-keydown=\"vm.handleEnterKey($event, field.title)\" \nmd-items=\"item in [\'position\', \'team_logo\', \'logo\', \'media\', \'name\', \'team_name\', \'code\', \'team_code\', \'points\', \'time\', \'elapsed_time\', \'score\', \'status\', \'drivers\', \'media_drivers\', \'country\', \'driver_country\', \'competitor_country\', \'driver_number\'] | filter:vm.teamsSearchText[field.title]\" \nmd-item-text=\"item\" md-min-length=\"0\" placeholder=\"Add field...\"><md-item-template><span \nmd-highlight-text=\"vm.teamsSearchText[field.title]\">{{item}}</span></md-item-template></md-autocomplete><md-button \nclass=\"md-icon-button md-accent ml-10 m-0\" ng-click=\"vm.addGroup(field.title)\" title=\"Add Group\"><md-icon \nmd-font-icon=\"icon-plus-box\"></md-icon></md-button></div><div class=\"font-size-10 grey-500-fg mt-5\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s14 mr-5\"></md-icon>\nDrag handles to reorder. Use the (+) button to add a wrapper group.</div></div><div ng-if=\"field.type === \'tags\'\">\n<md-input-container class=\"md-block mb-10 mh-0\"><label>{{field.title}}</label><input style=\"display:none\">\n</md-input-container><div ng-repeat=\"block in vm.mediahubTagsSelected[field.title] track by $index\" \nclass=\"mb-20 p-15 md-whiteframe-1dp\" style=\"background:#fdfdfd; position:relative; border-radius: 4px\"><md-button \nclass=\"md-icon-button\" \nstyle=\"position:absolute; top:4px; right:4px; margin:0; width: 32px; height: 32px; padding: 4px\" \nng-click=\"vm.removeTagBlock(field.title, $index)\" aria-label=\"Remove Tag Block\"><md-icon md-font-icon=\"icon-close\" \nclass=\"s16\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\" flex=\"100\"><md-input-container \nclass=\"md-block mb-0 mt-0\" flex=\"100\"><label>Group Label</label><input ng-model=\"block.label\"></md-input-container>\n</div><md-chips ng-model=\"block.tags\" md-transform-chip=\"vm.cloneTag($chip)\" md-enable-chip-edit=\"false\" \nmd-removable=\"true\" placeholder=\"Add a tag\" secondary-placeholder=\"+Tag\" class=\"m-0 mt-5\"><md-autocomplete \nmd-selected-item=\"block.selectedTagItem\" md-search-text=\"block.searchTagText\" \nmd-items=\"item in vm.queryTags(block.searchTagText, block.tags)\" md-item-text=\"item.tag_name\" md-no-cache=\"true\" \nplaceholder=\"Search for a tag...\"><span md-highlight-text=\"block.searchTagText\">{{item.tag_name}}</span>\n</md-autocomplete><md-chip-template><div layout=\"row\" layout-align=\"start center\" \nstyle=\"cursor: pointer; outline: none\" ng-click=\"$chip.exclude = !$chip.exclude\"><md-icon \nmd-font-icon=\"{{$chip.exclude ? \'icon-minus-circle\' : \'icon-check-circle\'}}\" \nng-class=\"$chip.exclude ? \'red-fg\' : \'green-fg\'\" class=\"s16 mr-5\" \nstyle=\"margin-top: 0; margin-bottom: 0; outline: none\"></md-icon><span>{{$chip.tag_name || $chip.name || $chip}}</span>\n</div></md-chip-template></md-chips><div class=\"font-size-10 grey-500-fg mt-5\" style=\"line-height:1\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s14 mr-5\"></md-icon>\nClick the icon inside the tag to toggle Include/Exclude logic.</div></div><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-button md-accent m-0 p-0 pl-10 pr-10\" \nng-click=\"vm.addTagBlock(field.title)\" style=\"min-width: auto; height: 36px; line-height: 36px; border-radius: 4px\">\n<md-icon md-font-icon=\"icon-plus-circle\" class=\"s20\"></md-icon><span>Add Tag Group</span></md-button><div \nng-if=\"vm.isLoadingTags\" class=\"ml-15\" style=\"font-size: 11px; color: gray\" translate=\"WIDGETS.LOADING_TAGS\">\nLoading tags...</div><div ng-if=\"vm.mediahubTagsError\" class=\"ml-15\" style=\"font-size: 11px; color: red\" \ntranslate=\"WIDGETS.ERROR_LOADING_TAGS\">Error loading tags.</div></div></div></div></div><style>\n.teams-layout-chip {\r\n        background: #e0e0e0;\r\n        border-radius: 16px;\r\n        padding: 0 8px 0 4px;\r\n        margin: 4px;\r\n        height: 32px;\r\n        font-size: 13px;\r\n        color: rgba(0,0,0,0.87);\r\n        user-select: none;\r\n    }\r\n    .teams-layout-chip .chip-text {\r\n        padding: 0 4px;\r\n    }\r\n    .teams-layout-chip .drag-handle {\r\n        cursor: grab;\r\n    }\r\n    .teams-layout-chip.gu-mirror {\r\n        box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);\r\n        cursor: grabbing !important;\r\n        position: fixed !important;\r\n        margin: 0 !important;\r\n        z-index: 9999 !important;\r\n        opacity: 0.8;\r\n    }\r\n    md-autocomplete input {\r\n        padding-left: 12px !important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/sitemap/importer/importer.html","<div id=\"sitemap-importer\" class=\"page-layout simple\" layout=\"column\" md-no-ink><div class=\"importer-toolbar\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"toolbar-badge\"><md-icon md-font-icon=\"icon-import\" class=\"s20\"></md-icon></div><div><div class=\"toolbar-title\" \ntranslate=\"SITEMAP.IMPORTER.TITLE\">Importar desde Figma</div><div class=\"toolbar-subtitle\" \ntranslate=\"SITEMAP.IMPORTER.SUBTITLE\"></div></div></div><md-button class=\"md-icon-button\" ng-click=\"vm.reset()\" \nng-disabled=\"!vm.plan && !vm.error\" aria-label=\"Reset\"><md-icon md-font-icon=\"icon-refresh\"></md-icon><md-tooltip>\n{{\'SITEMAP.IMPORTER.RESET\' | translate}}</md-tooltip></md-button></div><md-progress-linear \nclass=\"md-accent importer-progress\" md-mode=\"indeterminate\" ng-show=\"vm.loading\"></md-progress-linear><div \nclass=\"importer-scroll\" flex ms-scroll><div class=\"importer-column\"><ol class=\"importer-steps\"><li \nng-class=\"{\'active\': vm.step() === 1, \'done\': vm.step() > 1}\"><span class=\"step-dot\"><md-icon \nmd-font-icon=\"icon-check\" ng-if=\"vm.step() > 1\"></md-icon><span ng-if=\"vm.step() <= 1\">1</span></span> <span \nclass=\"step-label\" translate=\"SITEMAP.IMPORTER.STEP_SOURCE\"></span></li><li \nng-class=\"{\'active\': vm.step() === 2, \'done\': vm.step() > 2}\"><span class=\"step-dot\"><md-icon \nmd-font-icon=\"icon-check\" ng-if=\"vm.step() > 2\"></md-icon><span ng-if=\"vm.step() <= 2\">2</span></span> <span \nclass=\"step-label\" translate=\"SITEMAP.IMPORTER.STEP_REVIEW\"></span></li><li \nng-class=\"{\'active\': vm.step() === 3, \'done\': vm.step() === 3}\"><span class=\"step-dot\"><md-icon \nmd-font-icon=\"icon-check\" ng-if=\"vm.step() === 3\"></md-icon><span ng-if=\"vm.step() < 3\">3</span></span> <span \nclass=\"step-label\" translate=\"SITEMAP.IMPORTER.STEP_IMPORT\"></span></li></ol><section class=\"importer-card\"><header \nclass=\"card-header\"><h2 translate=\"SITEMAP.IMPORTER.SOURCE_TITLE\">Diseño de Figma</h2><p \ntranslate=\"SITEMAP.IMPORTER.INTRO\"></p></header><form name=\"vm.importerForm\" ng-submit=\"vm.simulate()\" novalidate>\n<md-input-container class=\"md-block md-icon-float figma-url\"><label translate=\"SITEMAP.IMPORTER.FIGMA_URL\">\nEnlace del frame de Figma</label><md-icon md-font-icon=\"icon-link-variant\"></md-icon><input name=\"figma_url\" \nng-model=\"vm.form.figma_url\" required ng-pattern=\"/figma\\.com\\/(design|file|proto)\\/[A-Za-z0-9]+.*node-id=/\"><div \nclass=\"hint\" ng-if=\"!vm.importerForm.figma_url.$touched || vm.importerForm.figma_url.$valid\" \ntranslate=\"SITEMAP.IMPORTER.FIGMA_URL_HINT\"></div><div ng-messages=\"vm.importerForm.figma_url.$error\" \nng-if=\"vm.importerForm.figma_url.$touched\"><div ng-message=\"required\" translate=\"SITEMAP.IMPORTER.REQUIRED\"></div><div \nng-message=\"pattern\" translate=\"SITEMAP.IMPORTER.FIGMA_URL_INVALID\"></div></div></md-input-container>\n<md-input-container class=\"md-block template-field\"><label translate=\"SITEMAP.IMPORTER.TEMPLATE\">Plantilla</label>\n<md-select ng-model=\"vm.form.id_template\" aria-label=\"Template\"><md-option ng-repeat=\"t in vm.templates\" \nng-value=\"t.id_template\">{{t.template_name}}</md-option></md-select></md-input-container></form></section><section \nclass=\"importer-card page-card\"><header class=\"card-header\"><h2 translate=\"SITEMAP.IMPORTER.PAGE_TITLE\">Página</h2><p>\n<span translate=\"SITEMAP.IMPORTER.PAGE_INTRO\"></span> <span ng-if=\"vm.lookFrom\">\n{{\'SITEMAP.IMPORTER.PAGE_DEFAULTS_FROM\' | translate:{url: vm.lookFrom} }}</span></p></header><div class=\"page-head\" \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"25\" class=\"md-block mh-5\"><label \ntranslate=\"SITEMAP.LANG\"></label><md-select ng-model=\"vm.currentSitemap.lang\" aria-label=\"Lang\"><md-option \nng-value=\"0\">ROOT</md-option><md-option ng-repeat=\"lang in vm.langs\" ng-value=\"lang.id\">{{lang.name}}</md-option>\n</md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"45\" class=\"md-block mh-5\"><label \ntranslate=\"SITEMAP.NAME\"></label><input type=\"text\" ng-model=\"vm.currentSitemap.name\" maxlength=\"100\"><div \nclass=\"hint\" translate=\"SITEMAP.IMPORTER.PAGE_NAME_HINT\"></div></md-input-container><div flex \nclass=\"page-url-preview mh-5\"><div class=\"url-label\" translate=\"SITEMAP.IMPORTER.PAGE_ADDRESS\"></div><div \nclass=\"url-value\">{{vm.templateHost()}}{{vm.currentSitemap.url || \'…\'}}</div><div class=\"hint\" \ntranslate=\"SITEMAP.IMPORTER.PAGE_URL_HINT\"></div></div></div><div class=\"sitemap-basic-tab\" \nng-include=\"\'app/main/apps/sitemap/views/edit/tabs/tab-basic.html\'\"></div><div class=\"card-actions\" layout=\"row\" \nlayout-align=\"start center\" layout-wrap><md-button class=\"md-raised md-accent\" ng-click=\"vm.simulate()\" \nng-disabled=\"vm.importerForm.$invalid || vm.loading\"><md-icon md-font-icon=\"icon-eye\" class=\"s18\"></md-icon><span \ntranslate=\"SITEMAP.IMPORTER.SIMULATE\">Simular</span></md-button><md-switch ng-model=\"vm.form.refresh\" \nclass=\"md-accent\" aria-label=\"Refresh\"><span translate=\"SITEMAP.IMPORTER.REFRESH\">Volver a descargar de Figma</span>\n</md-switch></div></section><div class=\"importer-banner error\" ng-if=\"vm.error\" layout=\"row\" \nlayout-align=\"start start\"><md-icon md-font-icon=\"icon-alert-circle\" class=\"s24\"></md-icon><div flex><strong \ntranslate=\"SITEMAP.IMPORTER.ERROR_TITLE\">No se ha podido completar</strong><div>{{vm.error}}</div></div></div><section \nclass=\"importer-card\" ng-if=\"vm.plan\"><header class=\"card-header plan-header\" layout=\"row\" \nlayout-align=\"space-between start\" layout-wrap><div flex><h2>{{vm.plan.source.name}}</h2><p>\nframe {{vm.plan.source.frame}} <span ng-if=\"vm.plan.source.figma.fetched_at\">\n· {{\'SITEMAP.IMPORTER.DOWNLOADED\' | translate}} {{vm.plan.source.figma.fetched_at | date:\'HH:mm\'}}</span> <span \nng-if=\"vm.plan.source.figma.cached\">({{\'SITEMAP.IMPORTER.FROM_CACHE\' | translate}})</span></p></div><span \nclass=\"status-pill\" ng-class=\"vm.plan.ready ? \'ready\' : \'pending\'\"><md-icon \nmd-font-icon=\"{{vm.plan.ready ? \'icon-check-circle\' : \'icon-alert-circle\'}}\" class=\"s16\"></md-icon>\n{{(vm.plan.ready ? \'SITEMAP.IMPORTER.READY\' : \'SITEMAP.IMPORTER.NOT_READY\') | translate}}</span></header><div \nclass=\"importer-banner outcome\" ng-if=\"vm.preview\" layout=\"row\" layout-align=\"start start\"><md-icon \nmd-font-icon=\"{{vm.preview.action === \'created\' ? \'icon-file-document\' : \'icon-sync\'}}\" class=\"s20\"></md-icon><div \nflex><strong ng-if=\"vm.preview.action === \'created\'\">\n{{\'SITEMAP.IMPORTER.WILL_CREATE\' | translate:{url: vm.preview.page_url || \'…\'} }}</strong> <strong \nng-if=\"vm.preview.action === \'updated\'\">{{\'SITEMAP.IMPORTER.WILL_UPDATE\' | translate:{url: vm.preview.page_url} }}\n</strong><div ng-if=\"vm.preview.report.look_from\">\n{{\'SITEMAP.IMPORTER.LOOK_FROM\' | translate:{url: vm.preview.report.look_from} }}</div></div></div><div \nclass=\"importer-banner stale\" ng-if=\"vm.formDirty()\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-information\" class=\"s20\"></md-icon><span flex translate=\"SITEMAP.IMPORTER.STALE\"></span><md-button \nclass=\"md-accent\" ng-click=\"vm.simulate()\" ng-disabled=\"vm.loading\" translate=\"SITEMAP.IMPORTER.SIMULATE\"></md-button>\n</div><div class=\"summary\"><div class=\"stat\"><span class=\"stat-value\">{{vm.summary.widgets}}</span><span \nclass=\"stat-label\" translate=\"SITEMAP.IMPORTER.SUMMARY_WIDGETS\"></span></div><div class=\"stat muted\"><span \nclass=\"stat-value\">{{vm.summary.statics}}</span><span class=\"stat-label\" translate=\"SITEMAP.IMPORTER.SUMMARY_STATIC\">\n</span></div><div class=\"stat\" ng-class=\"{\'amber\': vm.summary.questions}\"><span class=\"stat-value\">\n{{vm.summary.questions}}</span><span class=\"stat-label\" translate=\"SITEMAP.IMPORTER.SUMMARY_QUESTIONS\"></span></div>\n<div class=\"stat\" ng-class=\"{\'red\': vm.summary.errors}\"><span class=\"stat-value\">{{vm.summary.errors}}</span><span \nclass=\"stat-label\" translate=\"SITEMAP.IMPORTER.SUMMARY_ERRORS\"></span></div><div class=\"stat\" \nng-class=\"{\'amber\': vm.summary.warnings}\"><span class=\"stat-value\">{{vm.summary.warnings}}</span><span \nclass=\"stat-label\" translate=\"SITEMAP.IMPORTER.SUMMARY_WARNINGS\"></span></div></div><div class=\"plan-group\" \nng-if=\"vm.plan.questions.length\"><h3><md-icon md-font-icon=\"icon-help-circle\" class=\"s18\"></md-icon><span \ntranslate=\"SITEMAP.IMPORTER.QUESTIONS\"></span></h3><p class=\"group-hint\" translate=\"SITEMAP.IMPORTER.QUESTIONS_HINT\">\n</p><div class=\"question\" ng-repeat=\"q in vm.plan.questions track by q.id\"><div class=\"question-text\">{{q.question}}\n</div><md-input-container class=\"md-block\" ng-if=\"q.options\"><md-select ng-model=\"vm.answers[q.id]\" \naria-label=\"{{q.id}}\"><md-option ng-value=\"\'\'\"><em translate=\"SITEMAP.IMPORTER.NONE\">Ninguno</em></md-option><md-option\n ng-repeat=\"o in q.options\" ng-value=\"o\">{{o}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\" ng-if=\"!q.options\"><input ng-model=\"vm.answers[q.id]\" aria-label=\"{{q.id}}\" \nplaceholder=\"{{\'SITEMAP.IMPORTER.EMPTY_IS_NONE\' | translate}}\"></md-input-container><div class=\"question-id\">{{q.id}}\n</div></div><md-button class=\"md-raised md-accent\" ng-click=\"vm.simulate()\" ng-disabled=\"vm.loading\"><span \ntranslate=\"SITEMAP.IMPORTER.ANSWER\">Responder y volver a simular</span></md-button></div><div class=\"plan-group\" \nng-if=\"vm.plan.errors.length\"><h3 class=\"red-fg\"><md-icon md-font-icon=\"icon-close-circle\" class=\"s18 red-fg\">\n</md-icon><span translate=\"SITEMAP.IMPORTER.ERRORS\"></span></h3><ul class=\"message-list error\"><li \nng-repeat=\"x in vm.plan.errors track by $index\">{{x}}</li></ul></div><div class=\"view-switch\" layout=\"row\" \nlayout-align=\"start center\" layout-wrap><div class=\"segmented\"><button type=\"button\" \nng-class=\"{\'active\': vm.view === \'preview\'}\" ng-click=\"vm.view = \'preview\'\" ng-disabled=\"!vm.preview\"><md-icon \nmd-font-icon=\"icon-eye\" class=\"s16\"></md-icon><span translate=\"SITEMAP.IMPORTER.PREVIEW\"></span></button> <button \ntype=\"button\" ng-class=\"{\'active\': vm.view === \'structure\'}\" ng-click=\"vm.view = \'structure\'\"><md-icon \nmd-font-icon=\"icon-view-agenda\" class=\"s16\"></md-icon><span translate=\"SITEMAP.IMPORTER.BLOCKS\"></span></button></div>\n<span flex></span><div class=\"preview-tools\" ng-show=\"vm.view === \'preview\' && vm.preview\" layout=\"row\" \nlayout-align=\"end center\"><button type=\"button\" class=\"tool\" ng-class=\"{\'active\': vm.device === \'desktop\'}\" \nng-click=\"vm.device = \'desktop\'\" aria-label=\"Desktop\"><md-icon md-font-icon=\"icon-laptop\" class=\"s18\"></md-icon>\n</button> <button type=\"button\" class=\"tool\" ng-class=\"{\'active\': vm.device === \'tablet\'}\" \nng-click=\"vm.device = \'tablet\'\" aria-label=\"Tablet\"><md-icon md-font-icon=\"icon-tablet-ipad\" class=\"s18\"></md-icon>\n</button> <button type=\"button\" class=\"tool\" ng-class=\"{\'active\': vm.device === \'phone\'}\" \nng-click=\"vm.device = \'phone\'\" aria-label=\"Phone\"><md-icon md-font-icon=\"icon-cellphone-iphone\" class=\"s18\"></md-icon>\n</button> <span class=\"tool-divider\"></span> <button type=\"button\" class=\"tool\" ng-click=\"vm.loadPreview()\" \naria-label=\"Reload\"><md-icon md-font-icon=\"icon-refresh\" class=\"s18\"></md-icon><md-tooltip>\n{{\'SITEMAP.IMPORTER.PREVIEW_RELOAD\' | translate}}</md-tooltip></button> <button type=\"button\" class=\"tool\" \nng-click=\"vm.openPreviewTab()\" aria-label=\"Open\"><md-icon md-font-icon=\"icon-open-in-new\" class=\"s18\"></md-icon>\n<md-tooltip>{{\'SITEMAP.IMPORTER.PREVIEW_OPEN\' | translate}}</md-tooltip></button></div></div><div \nclass=\"plan-group preview-group\" ng-show=\"vm.view === \'preview\'\"><div class=\"importer-banner stale\" \nng-if=\"vm.previewError\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-information\" class=\"s20\">\n</md-icon><span flex>{{\'SITEMAP.IMPORTER.PREVIEW_UNAVAILABLE\' | translate}} {{vm.previewError}}</span></div><div \nclass=\"browser\" ng-if=\"vm.preview\" ng-class=\"\'device-\' + vm.device\"><div class=\"browser-bar\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"dots\"><i></i><i></i><i></i></span> <span class=\"address\" flex>\n{{vm.templateHost()}}{{vm.preview.page_url || vm.form.url || \'…\'}}</span> <span class=\"draft-chip\" \ntranslate=\"SITEMAP.IMPORTER.PREVIEW_BADGE\"></span></div><div class=\"browser-body\"><iframe name=\"figma-import-preview\" \ntitle=\"Preview\" frameborder=\"0\"></iframe><div class=\"browser-loading\" ng-show=\"vm.previewLoading\" layout=\"column\" \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"36\"></md-progress-circular>\n</div></div></div><p class=\"preview-note\"><md-icon md-font-icon=\"icon-information\" class=\"s16\"></md-icon><span \nng-if=\"vm.summary.statics\">{{\'SITEMAP.IMPORTER.PREVIEW_STATIC_NOTE\' | translate:{n: vm.summary.statics} }}</span> <span\n ng-if=\"vm.preview.action === \'updated\'\" translate=\"SITEMAP.IMPORTER.PREVIEW_UPDATE_NOTE\"></span> <span \nng-if=\"vm.preview\">{{\'SITEMAP.IMPORTER.PREVIEW_EXPIRES\' | translate}} {{vm.preview.expires_at | date:\'HH:mm\'}}.</span>\n</p></div><div class=\"plan-group\" ng-show=\"vm.view === \'structure\'\"><h3><md-icon md-font-icon=\"icon-view-agenda\" \nclass=\"s18\"></md-icon><span translate=\"SITEMAP.IMPORTER.BLOCKS\"></span></h3><ol class=\"page-outline\"><li \nng-repeat=\"b in vm.plan.blocks track by $index\" ng-class=\"vm.isStatic(b) ? \'is-static\' : \'is-widget\'\"><span \nclass=\"outline-index\">{{$index + 1}}</span><div class=\"outline-card\" ng-if=\"vm.isStatic(b)\"><div class=\"outline-head\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"outline-icon\"><md-icon md-font-icon=\"icon-code-tags\" class=\"s18\">\n</md-icon></span><div flex><div class=\"outline-title\" translate=\"SITEMAP.IMPORTER.STATIC\">Bloque estático</div><div \nclass=\"outline-sub\">{{vm.staticNames(b)}}</div></div><span class=\"chip muted\" translate=\"SITEMAP.IMPORTER.PENDING\">\nPendiente</span></div></div><div class=\"outline-card\" ng-if=\"!vm.isStatic(b)\"><div class=\"outline-head\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"outline-icon\"><md-icon md-font-icon=\"icon-view-module\" class=\"s18\"></md-icon>\n</span><div flex><div class=\"outline-title\">{{b.label || b.instance.title}}</div><div class=\"outline-sub\">{{b.layout}}\n<span ng-if=\"b.figma_node\"> · Figma {{b.figma_node}}</span></div></div><span class=\"chip accent\" ng-if=\"b.instance\">\nwidget {{b.instance.id_widget}}</span> <span class=\"chip red\" ng-if=\"!b.instance\" \ntranslate=\"SITEMAP.IMPORTER.UNRESOLVED\"></span></div><dl class=\"outline-data\" \nng-if=\"b.keyRows.length || (b.showMore && b.moreRows.length)\"><div class=\"data-row\" \nng-repeat=\"row in b.keyRows track by row.k\"><dt>{{row.k}}</dt><dd><code>{{row.v}}</code></dd></div><div \nclass=\"data-row\" ng-repeat=\"row in b.moreRows track by row.k\" ng-if=\"b.showMore\"><dt>{{row.k}}</dt><dd><code>{{row.v}}\n</code></dd></div></dl><button type=\"button\" class=\"link-button\" ng-if=\"b.moreRows.length\" \nng-click=\"b.showMore = !b.showMore\"><md-icon md-font-icon=\"{{b.showMore ? \'icon-chevron-up\' : \'icon-chevron-down\'}}\" \nclass=\"s16\"></md-icon>\n{{(b.showMore ? \'SITEMAP.IMPORTER.HIDE_OPTIONS\' : \'SITEMAP.IMPORTER.SHOW_OPTIONS\') | translate:{n: b.moreRows.length} }}\n</button><div class=\"outline-children\" ng-if=\"b.instance.children.length\"><div class=\"child\" \nng-repeat=\"c in b.instance.children track by $index\"><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16\"></md-icon>\nwidget {{c.id_widget}} · {{c.title}}</div></div></div></li></ol></div><div class=\"plan-group foldable\" \nng-if=\"vm.plan.warnings.length\"><button type=\"button\" class=\"fold-head\" \nng-click=\"vm.open.warnings = !vm.open.warnings\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s18 amber-fg\"></md-icon><span flex translate=\"SITEMAP.IMPORTER.WARNINGS\"></span> <span\n class=\"chip amber\">{{vm.plan.warnings.length}}</span><md-icon \nmd-font-icon=\"{{vm.open.warnings ? \'icon-chevron-up\' : \'icon-chevron-down\'}}\" class=\"s18\"></md-icon></button><ul \nclass=\"message-list warning\" ng-if=\"vm.open.warnings\"><li ng-repeat=\"x in vm.plan.warnings track by $index\">{{x}}</li>\n</ul></div><div class=\"plan-group foldable\" ng-if=\"vm.plan.checks.length\"><button type=\"button\" class=\"fold-head\" \nng-click=\"vm.open.checks = !vm.open.checks\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-check-circle\" class=\"s18 green-fg\"></md-icon><span flex translate=\"SITEMAP.IMPORTER.CHECKS\"></span> \n<span class=\"chip green\">{{vm.plan.checks.length}}</span><md-icon \nmd-font-icon=\"{{vm.open.checks ? \'icon-chevron-up\' : \'icon-chevron-down\'}}\" class=\"s18\"></md-icon></button><ul \nclass=\"message-list check\" ng-if=\"vm.open.checks\"><li ng-repeat=\"x in vm.plan.checks track by $index\">{{x}}</li></ul>\n</div></section><section class=\"importer-card result-card\" ng-if=\"vm.applied\"><div layout=\"row\" \nlayout-align=\"start center\" layout-wrap><div class=\"result-icon\"><md-icon md-font-icon=\"icon-check\" class=\"s32\">\n</md-icon></div><div flex><h2>\n{{(vm.applied.action === \'created\' ? \'SITEMAP.IMPORTER.CREATED\' : \'SITEMAP.IMPORTER.UPDATED\') | translate}}</h2><p>\n/{{vm.applied.url}} · sitemap {{vm.applied.id_sitemap}}</p></div></div><div class=\"result-stats\"><span \nclass=\"chip green\">{{\'SITEMAP.IMPORTER.WRITTEN\' | translate}}: {{vm.applied.written.length}}</span> <span class=\"chip\" \nng-if=\"vm.applied.kept_cms.length\">{{\'SITEMAP.IMPORTER.KEPT_CMS\' | translate}}: {{vm.applied.kept_cms.length}}</span> \n<span class=\"chip\" ng-if=\"vm.applied.removed.length\">\n{{\'SITEMAP.IMPORTER.REMOVED\' | translate}}: {{vm.applied.removed.length}}</span> <span class=\"chip muted\" \nng-if=\"vm.applied.skipped_static\">{{\'SITEMAP.IMPORTER.SKIPPED_STATIC\' | translate}}: {{vm.applied.skipped_static}}\n</span> <span class=\"chip amber\" ng-repeat=\"c in vm.applied.conflicts track by $index\">\n{{\'SITEMAP.IMPORTER.CONFLICT\' | translate}}: {{c.title}}</span></div><p class=\"result-hint\" \nng-if=\"vm.applied.action === \'created\'\" translate=\"SITEMAP.IMPORTER.DRAFT_HINT\"></p><div class=\"card-actions\" \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised md-accent\" ng-click=\"vm.openSitemap()\"><md-icon \nmd-font-icon=\"icon-sitemap\" class=\"s18\"></md-icon><span translate=\"SITEMAP.IMPORTER.OPEN\">Abrir en Sitemap</span>\n</md-button><md-button ng-click=\"vm.reset()\" translate=\"SITEMAP.IMPORTER.NEW_IMPORT\">Nueva importación</md-button>\n</div></section></div></div><div class=\"importer-actionbar\" ng-if=\"vm.plan && !vm.applied\" layout=\"row\" \nlayout-align=\"center center\"><div class=\"importer-column\" layout=\"row\" layout-align=\"start center\" layout-wrap><span \nclass=\"actionbar-hint\" flex ng-if=\"!vm.plan.ready\" translate=\"SITEMAP.IMPORTER.IMPORT_DISABLED\"></span> <span \nclass=\"actionbar-hint\" flex ng-if=\"vm.plan.ready && vm.formDirty()\" translate=\"SITEMAP.IMPORTER.STALE\"></span> <span \nclass=\"actionbar-hint ok\" flex ng-if=\"vm.plan.ready && !vm.formDirty()\" translate=\"SITEMAP.IMPORTER.READY_HINT\"></span>\n<md-switch ng-model=\"vm.form.force\" class=\"md-warn\" aria-label=\"Force\"><span translate=\"SITEMAP.IMPORTER.FORCE\">\nSobrescribir lo editado en el CMS</span></md-switch><md-button class=\"md-raised import-button\" \nng-click=\"vm.importPage()\" ng-disabled=\"!vm.plan.ready || vm.formDirty() || vm.loading\"><md-icon \nmd-font-icon=\"icon-import\" class=\"s18\"></md-icon><span translate=\"SITEMAP.IMPORTER.IMPORT\">Importar</span></md-button>\n</div></div></div>");
$templateCache.put("app/main/apps/sitemap/sidenavs/layout-sidenav.html","<md-toolbar class=\"md-accent-bg\"><h1 class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">Layouts \n<button class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'layout-sidenav\')\"><md-icon md-font-icon=\"icon-backburger\">\n</md-icon></button></h1></md-toolbar><div layout=\"column\" class=\"pb-5 grey-100-bg\"><div \nng-click=\"vm.addRowLayout(\'full-width\')\" layout=\"row\" layout-align=\"space-between center\" flex=\"100\" \nclass=\"pl-5 pr-5 zone-row\"><div class=\"zone-content\" flex=\"100\" layout=\"row\" layout-align=\"space-between stretch\"><div \nclass=\"zone white-bg mh-5 mv-10 ph-10 pv-20\" layout=\"column\" layout-align=\"center start\" flex=\"100\"><div \nclass=\"grey-600-fg zone-name\" layout=\"row\" layout-align=\"space-between center\"><span>FULL WIDTH</span></div></div>\n</div><div class=\"tools\" layout=\"column\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-plus-circle\" \nclass=\"green-500-fg m-5\"></md-icon></div></div><div ng-click=\"vm.addRowLayout(\'primary\')\" layout=\"row\" \nlayout-align=\"space-between center\" flex=\"100\" class=\"pl-5 pr-5 zone-row\"><div class=\"zone-content\" flex=\"100\" \nlayout=\"column\" layout-gt-xs=\"row\" layout-align=\"space-between stretch\"><div \nclass=\"zone white-bg mh-5 mv-10 ph-10 pv-20\" layout=\"column\" layout-align=\"center start\" flex=\"100\" flex-gt-xs=\"66\">\n<div class=\"grey-600-fg zone-name\" layout=\"row\" layout-align=\"space-between center\"><span>PRIMARY CONTENT</span></div>\n</div><div class=\"zone white-bg mh-5 mv-10 ph-10 pv-20\" layout=\"column\" layout-align=\"center start\" flex=\"100\" \nflex-gt-xs=\"33\"><div class=\"grey-600-fg zone-name\" layout=\"row\" layout-align=\"space-between center\"><span>\nRELATED CONTENT</span></div></div></div><div class=\"tools\" layout=\"column\" layout-align=\"center center\"><md-icon \nmd-font-icon=\"icon-plus-circle\" class=\"green-500-fg m-5\"></md-icon></div></div><div \nng-click=\"vm.addRowLayout(\'secondary\')\" layout=\"row\" layout-align=\"space-between center\" flex=\"100\" \nclass=\"pl-5 pr-5 zone-row\"><div class=\"zone-content\" flex=\"100\" layout=\"column\" layout-gt-xs=\"row\" \nlayout-align=\"space-between stretch\"><div class=\"zone white-bg mh-5 mv-10 ph-10 pv-20\" layout=\"column\" \nlayout-align=\"center start\" flex=\"100\" flex-gt-xs=\"50\"><div class=\"grey-600-fg zone-name\" layout=\"row\" \nlayout-align=\"space-between center\"><span>SECONDARY CONTENT</span></div></div><div \nclass=\"zone white-bg mh-5 mv-10 ph-10 pv-20\" layout=\"column\" layout-align=\"center start\" flex=\"100\" flex-gt-xs=\"50\">\n<div class=\"grey-600-fg zone-name\" layout=\"row\" layout-align=\"space-between center\"><span>SECONDARY CONTENT</span>\n</div></div></div><div class=\"tools\" layout=\"column\" layout-align=\"center center\"><md-icon \nmd-font-icon=\"icon-plus-circle\" class=\"green-500-fg m-5\"></md-icon></div></div><div \nng-click=\"vm.addRowLayout(\'threecols\')\" layout=\"row\" layout-align=\"space-between center\" flex=\"100\" \nclass=\"pl-5 pr-5 zone-row\"><div class=\"zone-content\" flex=\"100\" layout=\"column\" layout-gt-xs=\"row\" \nlayout-align=\"space-between stretch\"><div class=\"zone white-bg mh-5 mv-10 ph-10 pv-20\" layout=\"column\" \nlayout-align=\"center start\" flex=\"100\" flex-gt-xs=\"33\"><div class=\"grey-600-fg zone-name\" layout=\"row\" \nlayout-align=\"space-between center\"><span>3 COLUMNS</span></div></div><div \nclass=\"zone white-bg mh-5 mv-10 ph-10 pv-20\" layout=\"column\" layout-align=\"center start\" flex=\"100\" flex-gt-xs=\"33\">\n<div class=\"grey-600-fg zone-name\" layout=\"row\" layout-align=\"space-between center\"><span>3 COLUMNS</span></div></div>\n<div class=\"zone white-bg mh-5 mv-10 ph-10 pv-20\" layout=\"column\" layout-align=\"center start\" flex=\"100\" \nflex-gt-xs=\"33\"><div class=\"grey-600-fg zone-name\" layout=\"row\" layout-align=\"space-between center\"><span>3 COLUMNS\n</span></div></div></div><div class=\"tools\" layout=\"column\" layout-align=\"center center\"><md-icon \nmd-font-icon=\"icon-plus-circle\" class=\"green-500-fg m-5\"></md-icon></div></div></div>");
$templateCache.put("app/main/apps/sitemap/sidenavs/widgets-sidenav.html","<md-toolbar class=\"md-accent-bg\"><h1 class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">Widgets \n<button class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'widgets-sidenav\')\"><md-icon md-font-icon=\"icon-backburger\">\n</md-icon></button></h1></md-toolbar><md-content ms-scroll class=\"content-wrapper\" flex><md-tabs md-dynamic-height \nflex><md-tab label=\"{{ vm.translate(\'WIDGETS.WIDGETS\')}}\"><div style=\"background: #fafafa\" layout=\"row\" flex=\"100\" \nclass=\"search-bar bb\"><md-icon id=\"ms-search-bar-expander\" md-font-icon=\"icon-magnify\" \nclass=\"md-icon-button md-button\"><md-tooltip hide show-gt-xs><span translate=\"TOOLBAR.SEARCH\">Search</span>\n</md-tooltip></md-icon><input ng-change=\"vm.updateSearch(vm.searchQueryWidget)\" style=\"background: #fafafa\" \nid=\"ms-search-bar-input\" type=\"text\" ng-model=\"vm.searchQueryWidget\" placeholder=\"Search\" md-autofocus translate \ntranslate-attr-placeholder=\"TOOLBAR.SEARCH\" flex><md-icon id=\"ms-search-bar-collapser\" \nng-click=\"vm.searchQueryWidget= \'\'; vm.updateSearch(null)\" md-font-icon=\"icon-close\" class=\"icon s24 pointer mr-15\">\n</md-icon></div><div class=\"widgets-container dragula-container copy-widgets\" layout=\"column\" flex dragula=\"\'widget\'\" \ndragula-model=\"vm.widgets\" dragula-scope=\"$parent\"><div id=\"idWidget-{{widget.id_widget}}\" data-widget=\"{{widget}}\" \nng-repeat=\"widget in vm.widgets\" class=\"widget-item p-10 off\" layout=\"column\" layout-align=\"center stretch\" flex=\"100\">\n<div layout=\"row\" layout-align=\"space-between center\" flex=\"100\" \nng-include=\"\'app/main/apps/sitemap/views/edit/tabs/layout-sections/widget-content.html\'\"></div></div></div></md-tab>\n<md-tab label=\"{{ vm.translate(\'WIDGETS.TEMPLATES\')}}\"><div \nclass=\"widgets-container dragula-container template-widgets copy-widgets\" dragula=\"\'widget\'\" \ndragula-model=\"vm.widgetsTemplates\" layout=\"column\" flex><div ng-repeat=\"widget in vm.widgetsTemplates\" \ndata-widget=\"{{widget}}\" class=\"widget-item p-10 off\" layout=\"row\" layout-align=\"center stretch\" flex=\"100\"><div \nlayout=\"row\" layout-align=\"space-between center\" flex=\"100\" \nng-include=\"\'app/main/apps/sitemap/views/edit/tabs/layout-sections/widget-content.html\'\"></div><md-icon \nclass=\"pointer mh-15\" ng-if=\"widget.id_template\" ng-click=\"vm.deleteWidgetTemplate(widget.id_template)\" \nmd-font-icon=\"icon-delete\"><md-tooltip><span translate=\"CONTENT.DELETE\"></span></md-tooltip></md-icon></div></div>\n</md-tab></md-tabs></md-content>");
$templateCache.put("app/main/apps/social/social-accounts/social-accounts.html","<div id=\"site-social\" class=\"page-layout carded left-sidenav\" layout=\"row\" md-no-ink><qiu-groups ng-if=\"vm.groups\" \nclass=\"qiu-groups\" layout=\"column\" ng-show=\"vm.showQiuGroupsSidenav\" qiu-groups-nested=\"vm.groups\" \nqiu-groups-sort-groups-by=\"vm.sortGroupsBy\" qiu-groups-sort-groups-field=\"vm.sortGroupsField\" \nqiu-groups-sort-groups-dir=\"vm.sortGroupsDir\" qiu-groups-sort-groups=\"vm.sortSocialAccountsGroups\" \nqiu-groups-selected-group=\"vm.selectedGroup\" qiu-groups-qiu-restrictions=\"vm.qiuRestrictions\" \nqiu-groups-toggle-sidenav=\"vm.toggleQiuGroupsSidenav\" qiu-groups-get-items-in-groups=\"vm.getSocialAccounts\" \nqiu-groups-include-subgroups=\"vm.includeSubgroups\" qiu-groups-create-group=\"vm.createSocialAccountsGroup\" \nqiu-groups-edit-group=\"vm.editSocialAccountsGroup\" qiu-groups-delete-group=\"vm.deleteSocialAccountsGroup\"></qiu-groups>\n<div class=\"center\" layout=\"column\" flex><div class=\"content-card nosplit\" layout=\"column\" flex \nng-include=\"\'app/main/apps/social/social-accounts/views/list/nosplit-view.html\'\" md-no-ink></div></div><qiu-pagination \ncollection=\"vm.threads\" url=\"\'http://\'\" service=\"socialAccountsService\" columns=\"vm.refcolumns\" \ncolumns-grouped=\"vm.refcolumnsgrouped\" fields-filters=\"vm.refFilterables\" media-zones=\"refMediaZones\" \nfields-search=\"refSearch\" fields-sort=\"refSortables\" style=\"display:none\"></qiu-pagination></div>");
$templateCache.put("app/main/apps/social/social-posts/social-posts.html","<div id=\"site-social\" class=\"page-layout carded left-sidenav\" layout=\"row\" md-no-ink><div class=\"center\" \nlayout=\"column\" flex><div class=\"content-card nosplit\" layout=\"column\" flex \nng-include=\"\'app/main/apps/social/social-posts/views/list/nosplit-view.html\'\" md-no-ink></div></div><qiu-pagination \ncollection=\"vm.threads\" url=\"\'http://\'\" service=\"socialPostsService\" columns=\"vm.refcolumns\" \ncolumns-grouped=\"vm.refcolumnsgrouped\" fields-filters=\"vm.refFilterables\" media-zones=\"refMediaZones\" \nfields-search=\"refSearch\" fields-sort=\"refSortables\" style=\"display:none\"></qiu-pagination></div>");
$templateCache.put("app/main/apps/tasks/sidenavs/filters-sidenav.html","<md-toolbar class=\"md-theme-light md-default-theme md-light-blue-bg\"><h2 class=\"md-toolbar-tools\" aria-label=\"Filters\" \nlayout=\"row\" layout-align=\"space-between center\"><span translate-attr-aria-label=\"USERS.FILTERS\" \ntranslate=\"USERS.FILTERS\">Filters</span> <button class=\"md-icon-button\" \nng-click=\"vm.cancelUsersGroups(\'filters-sidenav\')\"><md-icon md-font-icon=\"icon-close\"></md-icon></button></h2>\n</md-toolbar><md-content ms-scroll class=\"content\" flex><div class=\"navigation-simple\" layout=\"column\"></div>\n</md-content>");
$templateCache.put("app/main/apps/tasks/sidenavs/groups-sidenav.html","<md-toolbar class=\"md-default-theme grey-100-bg grey-600-fg pr-16 pl-16\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"md-toolbar-tools p-0\" aria-label=\"Groups\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-folder-multiple\" \nclass=\"grey-600-fg s18 mr-10 ml-0 md-default-theme md-font material-icons\" aria-hidden=\"true\"></md-icon><div \ntranslate-attr-aria-label=\"USERS.GROUPS\" translate=\"USERS.GROUPS\" class=\"grey-600-fg\" aria-label=\"GROUPS\">GROUPS</div>\n</div><div layout=\"row\" layout-align=\"end center\"><md-icon id=\"\" md-font-icon=\"icon-plus\" \nng-click=\"vm.createGroup($event)\" \nclass=\"m-0 grey-600-fg md-icon-button md-button md-default-theme md-font material-icons\" aria-hidden=\"true\">\n<md-tooltip><span translate=\"CONTENT.ADD\">Add</span></md-tooltip></md-icon><ms-search-bar debounce=\"300\" \nmodel-search=\"\" on-result-click=\"\" on-search=\"\" layout=\"row\" layout-align=\"start center\"></ms-search-bar><div \nclass=\"divider-vertical\"></div><md-icon ng-click=\"vm.cancelUsersGroups(\'groups-sidenav\')\" \nmd-font-icon=\"icon-backburger\" \nclass=\"m-0 grey-600-fg md-icon md-button md-default-theme md-font material-icons md-icon-button\" aria-hidden=\"true\">\n</md-icon></div></md-toolbar><md-content ms-scroll class=\"content\" hide flex><div class=\"navigation-simple\" \nlayout=\"column\"><div><div ng-if=\"vm.usersGroups\" ivh-treeview=\"vm.usersGroups\" class=\"treeview small\" \nivh-treeview-on-cb-change=\"vm.callback(ivhNode, ivhIsSelected, ivhTree)\"><script type=\"text/ng-template\">\n<div class=\"level-card\">\r\n                        <span ivh-treeview-toggle> \r\n                            <span ivh-treeview-twistie></span>\r\n                        </span>\r\n                        <span class=\"pointer-indicator\"></span>\r\n                        <span class=\"ivh-treeview-node-label\" ivh-treeview-toggle>{{trvw.label(node)}}</span>\r\n                        <md-treeview-box></md-treeview-box>\r\n                    </div>\r\n                    <div ivh-treeview-children></div>\n</script></div></div></div></md-content><md-content ms-scroll flex><div class=\"navigation-simple\" layout=\"column\"><div \nhidden id=\"includeSubgroups\" data-include-subgroups=\"{{vm.includeSubgroups}}\"></div><div ng-if=\"vm.CleanUsersGroups\" \nivh-treeview=\"vm.CleanUsersGroups\" ivh-treeview-filter=\"$root.modelSearch\" ivh-treeview-label-attribute=\"\'name\'\" \nclass=\"ivh-treeview-folder small\" ivh-treeview-on-cb-change=\"callback()\"><script type=\"text/ng-template\">\n<div class=\"level-card p-8 group-row\" layout=\"row\" layout-align=\"space-between stretch\">\r\n                    <span ivh-treeview-twistie ivh-treeview-toggle layout=\"row\" layout-align=\"center center\"></span>\r\n                    <div flex id=\"treeview-group-{{node.id_group}}\" qiu-on-click-load-users-by-groups data-group-node={{node}} layout=\"row\" layout-align=\"start center\">\r\n                        <md-icon ng-if =\"!node.children && node.id_group_type == 1\" \r\n                            md-font-icon=\"icon-folder\" \r\n                            class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon ng-if =\"!node.children && node.id_group_type == 2\" \r\n                            md-font-icon=\"qiu-icon-file-usermailing\" \r\n                            class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon \r\n                            ng-if =\"node.children && node.id_group_type == 2\" \r\n                            md-svg-src=\"/assets/icons/svg/icon-folder-mail-multiple.svg\"\r\n                            class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon ng-if =\"!node.children && node.id_group_type == 3\" \r\n                            md-font-icon=\"qiu-icon-file-usermediacenter\" \r\n                            class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon \r\n                            ng-if =\"node.children && node.id_group_type == 3\" \r\n                            md-svg-src=\"/assets/icons/svg/icon-folder-play-multiple.svg\"\r\n                            class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon ng-if =\"!node.children && node.id_group_type == 4\" \r\n                            md-font-icon=\"qiu-icon-file-usersegment\" \r\n                            class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon \r\n                            ng-if =\"node.children && node.id_group_type == 4\" \r\n                            md-svg-src=\"/assets/icons/svg/icon-folder-share-multiple.svg\"\r\n                            class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon ng-if =\"!node.children && node.id_group_type == 5\" \r\n                            md-font-icon=\"qiu-icon-file-userstore\" \r\n                            class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon \r\n                            ng-if =\"node.children && node.id_group_type == 5\" \r\n                            md-svg-src=\"/assets/icons/svg/icon-folder-shop-multiple.svg\"\r\n                            class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon ng-if =\"!node.children && node.id_group_type == 6\" \r\n                            md-font-icon=\"qiu-icon-file-useracreditation\" \r\n                            class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon \r\n                            ng-if =\"node.children && node.id_group_type == 6\" \r\n                            md-svg-src=\"/assets/icons/svg/icon-folder-board-multiple.svg\"\r\n                            class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon ng-if =\"!node.children && node.id_group_type == 7\" \r\n                            md-svg-src=\"/assets/icons/svg/icon-folder-chat.svg\"\r\n                            class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon \r\n                            ng-if =\"node.children && node.id_group_type == 7\" \r\n                            md-svg-src=\"/assets/icons/svg/icon-folder-chat-multiple.svg\"\r\n                            class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon ng-if =\"!node.children && node.id_group_type == 8\" \r\n                            md-font-icon=\"icon-folder-remove\" \r\n                            class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon \r\n                            ng-if =\"node.children && node.id_group_type == 8\" \r\n                            md-font-icon=\"icon-folder-multiple\" \r\n                            class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                            aria-hidden=\"true\" >\r\n                        </md-icon> \r\n                        <md-icon \r\n                            ng-if =\"node.children && node.id_group_type == 1\" \r\n                            md-font-icon=\"icon-folder-multiple\" \r\n                            class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        \r\n                        <span class=\"ivh-treeview-node-label ng-binding\">{{trvw.label(node)}}</span>\r\n\r\n                    </div> \r\n\r\n                    <div layout=\"row\" layout-align=\"end center\">\r\n                        <md-button qiu-on-click-open-group-edit-dialog class=\"md-icon-button\" type=\"button\" aria-label=\"ACTIONS\">\r\n                            <md-icon md-font-icon=\"icon-pencil\" aria-hidden=\"true\"></md-icon>\r\n                        </md-button>\r\n                        <md-icon qiu-on-click-close-sidenav sidenav-id=\"groups-sidenav\" md-font-icon=\"icon-chevron-right\" aria-hidden=\"true\" hide-gt-sm class=\"mt-0 mb-0\"></md-icon>\r\n                    </div>\r\n\r\n                </div>\r\n                <div ivh-treeview-children></div>\n</script></div></div></md-content>");
$templateCache.put("app/main/apps/users/analytics/analytics.html","<div id=\"site-users\" class=\"page-layout carded left-sidenav\" layout=\"row\" md-no-ink><div class=\"center\" \nlayout=\"column\" flex><div class=\"content-card\" ng-class=\"vm.currentView\" layout=\"column\" flex \nng-include=\"vm.views[vm.currentView]\" md-no-ink></div></div></div>");
$templateCache.put("app/main/apps/users/sidenavs/events-horizontal-nav.html","<div flex layout=\"column\" layout-align=\"center center\" ng-if=\"isLoadingGroups\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><md-content \nng-if=\"!isLoadingGroups\"><div><ul layout=\"row\"><li ng-repeat=\"group in vm.eventsGroup\"><h2>{{group.name}}</h2></li>\n</ul></div></md-content><md-content ng-if=\"!isLoadingGroups\" ms-scroll flex><div class=\"navigation-simple\" \nlayout=\"column\"><div hidden id=\"includeSubgroups\" data-include-subgroups=\"{{vm.includeSubgroups}}\"></div><div \nng-if=\"vm.CleanUsersGroups\" ivh-treeview=\"vm.eventsGroup\" ivh-treeview-filter=\"vm.treeSearch\" \nivh-treeview-label-attribute=\"\'label\'\" class=\"ivh-treeview-folder small\" ivh-treeview-on-cb-change=\"callback()\"><script\n type=\"text/ng-template\">\n<div class=\"level-card p-8 group-row\" layout=\"row\" layout-align=\"space-between stretch\" ng-class=\"{\'selected\': node.is_qiu_restricted_root}\">\r\n                    <span ivh-treeview-twistie ivh-treeview-toggle layout=\"row\" layout-align=\"center center\"></span>\r\n                    <div flex id=\"treeview-group-{{node.id_group}}\" qiu-users-on-click-load-users-by-groups data-group-node={{node}} layout=\"row\" layout-align=\"start center\">\r\n                        <span class=\"ivh-treeview-node-label ng-binding\">{{node.name}}</span>\r\n                    </div>\r\n\r\n                    <div layout=\"row\" layout-align=\"end center\">\r\n                        <md-button qiu-users-on-click-open-group-edit-dialog class=\"md-icon-button\" type=\"button\" aria-label=\"ACTIONS\">\r\n                            <md-icon md-font-icon=\"icon-pencil\" aria-hidden=\"true\"></md-icon>\r\n                        </md-button>\r\n                        <md-icon qiu-users-on-click-close-sidenav sidenav-id=\"groups-sidenav\" md-font-icon=\"icon-chevron-right\" aria-hidden=\"true\" hide-gt-sm class=\"mt-0 mb-0\"></md-icon>\r\n                    </div>\r\n\r\n                </div>\r\n                <div ivh-treeview-children></div>\n</script></div></div></md-content>");
$templateCache.put("app/main/apps/users/sidenavs/filters-sidenav.html","<md-toolbar class=\"md-theme-light md-default-theme md-light-blue-bg\"><h2 class=\"md-toolbar-tools\" aria-label=\"Filters\" \nlayout=\"row\" layout-align=\"space-between center\"><span translate-attr-aria-label=\"USERS.FILTERS\" \ntranslate=\"USERS.FILTERS\">Filters</span> <button class=\"md-icon-button\" \nng-click=\"vm.cancelUsersGroups(\'filters-sidenav\')\"><md-icon md-font-icon=\"icon-close\"></md-icon></button></h2>\n</md-toolbar><md-content ms-scroll class=\"content\" flex><div class=\"navigation-simple\" layout=\"column\"></div>\n</md-content>");
$templateCache.put("app/main/apps/users/sidenavs/groups-accreditations-sidenav.html","<div flex layout=\"column\" layout-align=\"center center\" ng-if=\"isLoadingGroups\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><md-toolbar \nng-if=\"!isLoadingGroups\" class=\"md-default-theme grey-100-bg grey-600-fg pr-16 pl-16\" layout=\"row\" \nlayout-align=\"space-between center\"><div ng-if=\"!vm.showTreeSearch\" class=\"md-toolbar-tools p-0\" aria-label=\"Groups\" \nlayout=\"row\" layout-align=\"start center\"><md-icon hide show-gt-lg md-font-icon=\"icon-folder-multiple\" \nclass=\"grey-600-fg s18 mr-10 ml-0 md-default-theme md-font material-icons\" aria-hidden=\"true\"></md-icon><div \nclass=\"grey-600-fg\" aria-label=\"GROUPS\">{{vm.groupTypes.title}}</div></div><div ng-if=\"!vm.showTreeSearch\" \nlayout=\"row\" layout-align=\"end center\"><md-icon id=\"\" md-font-icon=\"icon-plus\" ng-click=\"vm.createGroup($event)\" \nclass=\"m-0 grey-600-fg md-icon-button md-button md-default-theme md-font material-icons\" aria-hidden=\"true\">\n<md-tooltip><span translate=\"CONTENT.ADD\">Add</span></md-tooltip></md-icon><div class=\"divider-vertical\"></div><md-icon\n ng-click=\"vm.cancelUsersGroups(\'groups-sidenav\')\" md-font-icon=\"icon-backburger\" \nclass=\"m-0 grey-600-fg md-icon md-button md-default-theme md-font material-icons md-icon-button\" aria-hidden=\"true\">\n</md-icon></div><div ng-if=\"vm.showTreeSearch\" layout=\"row\" class=\"users-groups-tree-search\"><div layout=\"row\" flex \nlayout-align=\"start center\"><label for=\"search-bar-input\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"grey-600-fg md-icon-button md-button\"><md-tooltip hide show-gt-xs><span translate=\"TOOLBAR.SEARCH\">Search</span>\n</md-tooltip></md-icon></label><md-icon md-font-icon=\"icon-close-circle\" class=\"grey-600-fg md-icon-button md-button\" \nng-if=\"vm.treeSearch\" ng-click=\"vm.treeSearch= null\"></md-icon><input type=\"text\" id=\"search-bar-input\" \nclass=\"grey-600-fg grey-100-bg\" ng-model=\"vm.treeSearch\" placeholder=\"Search\" md-autofocus translate \ntranslate-attr-placeholder=\"TOOLBAR.SEARCH\" flex><md-icon layout-align=\"end center\" \nng-click=\"vm.showTreeSearch= false\" md-font-icon=\"icon-close\" \nclass=\"users-groups-tree-search-collapser icon s24 grey-600-fg\"></md-icon></div></div></md-toolbar><md-content \nng-if=\"!isLoadingGroups\" ms-scroll flex><div class=\"navigation-simple\" layout=\"column\"><div hidden \nid=\"includeSubgroups\" data-include-subgroups=\"{{vm.includeSubgroups}}\"></div><div ng-if=\"vm.acreditationsGroups\" \nivh-treeview-expand-to-depth=\"0\" ivh-treeview=\"vm.acreditationsGroups\" ivh-treeview-filter=\"vm.treeSearch\" \nivh-treeview-label-attribute=\"\'label\'\" class=\"ivh-treeview-folder small\" ivh-treeview-on-cb-change=\"callback()\"><script\n type=\"text/ng-template\">\n<div class=\"level-card p-8 group-row acc\" layout=\"row\" layout-align=\"space-between stretch\">\r\n                    <span ivh-treeview-twistie ivh-treeview-toggle layout=\"row\" layout-align=\"center center\"></span>\r\n                    <div flex id=\"treeview-group-{{node.id_group}}\" qiu-users-on-click-load-users-by-groups-acc data-group-node={{node}} layout=\"row\" layout-align=\"start center\">\r\n                        <div ng-if=\"node.group_type.icon\">\r\n                            <md-icon ng-if=\"node.group_type.icon\"\r\n                                class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                md-font-icon=\"{{node.group_type.icon}}\"\r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                        </div>\r\n                        <div ng-if=\"!node.group_type.icon\">\r\n                            <md-icon ng-if=\"!node.children && node.id_group_type == 1\"\r\n                                class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                md-font-icon=\"icon-folder\"\r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon\r\n                                ng-if=\"node.children && node.id_group_type == 1\"\r\n                                class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                md-font-icon=\"icon-folder-multiple\"\r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon ng-if=\"!node.children && node.id_group_type == 2\"\r\n                                class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                md-font-icon=\"qiu-icon-file-usermailing\"\r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon\r\n                                ng-if=\"node.children && node.id_group_type == 2\"\r\n                                class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                md-svg-src=\"/assets/icons/svg/icon-folder-mail-multiple.svg\"\r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon ng-if=\"!node.children && node.id_group_type == 3\"\r\n                                class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                md-font-icon=\"qiu-icon-file-usermediacenter\"\r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon\r\n                                ng-if=\"node.children && node.id_group_type == 3\"\r\n                                class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                md-svg-src=\"/assets/icons/svg/icon-folder-play-multiple.svg\"\r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon ng-if=\"!node.children && node.id_group_type == 4\"\r\n                                class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                md-font-icon=\"qiu-icon-file-usersegment\"\r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon\r\n                                ng-if=\"node.children && node.id_group_type == 4\"\r\n                                class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                md-svg-src=\"/assets/icons/svg/icon-folder-share-multiple.svg\"\r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon ng-if=\"!node.children && node.id_group_type == 5\"\r\n                                class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                md-font-icon=\"qiu-icon-file-userstore\"\r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon\r\n                                ng-if=\"node.children && node.id_group_type == 5\"\r\n                                class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                md-svg-src=\"/assets/icons/svg/icon-folder-shop-multiple.svg\"\r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon ng-if=\"!node.children && node.id_group_type == 6\"\r\n                                class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                md-font-icon=\"qiu-icon-file-useracreditation\"\r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon\r\n                                ng-if=\"node.children && node.id_group_type == 6\"\r\n                                class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                md-svg-src=\"/assets/icons/svg/icon-folder-board-multiple.svg\"\r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon ng-if=\"!node.children && node.id_group_type == 7\"\r\n                                class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                md-svg-src=\"/assets/icons/svg/icon-folder-chat.svg\"\r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon\r\n                                ng-if=\"node.children && node.id_group_type == 7\"\r\n                                class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                md-svg-src=\"/assets/icons/svg/icon-folder-chat-multiple.svg\"\r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon ng-if=\"!node.children && node.id_group_type == 8\"\r\n                                class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                md-font-icon=\"icon-folder-remove\"\r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon\r\n                                ng-if=\"node.children && node.id_group_type == 8\"\r\n                                class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                md-font-icon=\"icon-folder-multiple\"\r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                        </div>\r\n                       \r\n                        <span class=\"ivh-treeview-node-label ng-binding\">{{node.name}}</span>\r\n\r\n                    </div>\r\n\r\n                    <div layout=\"row\" layout-align=\"end center\">\r\n                        <md-button qiu-users-on-click-open-group-edit-dialog class=\"md-icon-button\" type=\"button\" aria-label=\"ACTIONS\">\r\n                            <md-icon md-font-icon=\"icon-pencil\" aria-hidden=\"true\"></md-icon>\r\n                        </md-button>\r\n                        <md-icon qiu-users-on-click-close-sidenav sidenav-id=\"groups-sidenav\" md-font-icon=\"icon-chevron-right\" aria-hidden=\"true\" hide-gt-sm class=\"mt-0 mb-0\"></md-icon>\r\n                    </div>\r\n\r\n                </div>\r\n                <div ivh-treeview-children></div>\n</script></div></div></md-content><md-toolbar ng-if=\"!isLoadingGroups\" \nclass=\"md-default-theme grey-100-bg grey-600-fg pr-16 pl-16\" layout=\"row\" layout-align=\"space-between center\"><div \nng-if=\"!vm.showTreeSearch\" class=\"md-toolbar-tools p-0\" aria-label=\"Groups\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-label\" class=\"grey-600-fg s18 mr-10 ml-0 md-default-theme md-font material-icons\" \naria-hidden=\"true\"></md-icon><div class=\"grey-600-fg\" aria-label=\"GROUPS\">{{vm.subGroupTypes.title}}</div></div><div \nng-if=\"!vm.showTreeSearch\" layout=\"row\" layout-align=\"end center\"><md-icon id=\"\" md-font-icon=\"icon-plus\" \nng-click=\"vm.createGroup($event)\" \nclass=\"m-0 grey-600-fg md-icon-button md-button md-default-theme md-font material-icons\" aria-hidden=\"true\">\n<md-tooltip><span translate=\"CONTENT.ADD\">Add</span></md-tooltip></md-icon></div></md-toolbar><md-content \nng-if=\"!isLoadingGroups\" ms-scroll flex><div class=\"navigation-simple\" layout=\"column\"><div hidden \nid=\"includeSubgroups\" data-include-subgroups=\"{{vm.includeSubgroups}}\"></div><div ng-if=\"vm.subAcreditationsGroups\" \nivh-treeview-expand-to-depth=\"0\" ivh-treeview=\"vm.subAcreditationsGroups\" ivh-treeview-filter=\"vm.treeSearch\" \nivh-treeview-label-attribute=\"\'label\'\" class=\"ivh-treeview-folder small\" ivh-treeview-on-cb-change=\"callback()\"><script\n type=\"text/ng-template\">\n<div class=\"level-card p-8 group-row acc-sub\" layout=\"row\" layout-align=\"space-between stretch\">\r\n                        <span ivh-treeview-twistie ivh-treeview-toggle layout=\"row\" layout-align=\"center center\"></span>\r\n                        <div flex id=\"treeview-group-{{node.id_group}}\" qiu-users-on-click-load-users-by-groups-acc-sub data-group-node={{node}} layout=\"row\" layout-align=\"start center\">\r\n                            <div ng-if=\"node.icon\">\r\n                                <md-icon ng-if=\"node.icon\"\r\n                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                    md-font-icon=\"{{node.icon}}\"\r\n                                    aria-hidden=\"true\" >\r\n                                </md-icon>\r\n                            </div>\r\n                            <div ng-if=\"!node.group_type.icon\">\r\n                                <md-icon ng-if=\"!node.children && node.id_group_type == 1\"\r\n                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                    md-font-icon=\"icon-folder\"\r\n                                    aria-hidden=\"true\" >\r\n                                </md-icon>\r\n                                <md-icon\r\n                                    ng-if=\"node.children && node.id_group_type == 1\"\r\n                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                    md-font-icon=\"icon-folder-multiple\"\r\n                                    aria-hidden=\"true\" >\r\n                                </md-icon>\r\n                                <md-icon ng-if=\"!node.children && node.id_group_type == 2\"\r\n                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                    md-font-icon=\"qiu-icon-file-usermailing\"\r\n                                    aria-hidden=\"true\" >\r\n                                </md-icon>\r\n                                <md-icon\r\n                                    ng-if=\"node.children && node.id_group_type == 2\"\r\n                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                    md-svg-src=\"/assets/icons/svg/icon-folder-mail-multiple.svg\"\r\n                                    aria-hidden=\"true\" >\r\n                                </md-icon>\r\n                                <md-icon ng-if=\"!node.children && node.id_group_type == 3\"\r\n                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                    md-font-icon=\"qiu-icon-file-usermediacenter\"\r\n                                    aria-hidden=\"true\" >\r\n                                </md-icon>\r\n                                <md-icon\r\n                                    ng-if=\"node.children && node.id_group_type == 3\"\r\n                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                    md-svg-src=\"/assets/icons/svg/icon-folder-play-multiple.svg\"\r\n                                    aria-hidden=\"true\" >\r\n                                </md-icon>\r\n                                <md-icon ng-if=\"!node.children && node.id_group_type == 4\"\r\n                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                    md-font-icon=\"qiu-icon-file-usersegment\"\r\n                                    aria-hidden=\"true\" >\r\n                                </md-icon>\r\n                                <md-icon\r\n                                    ng-if=\"node.children && node.id_group_type == 4\"\r\n                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                    md-svg-src=\"/assets/icons/svg/icon-folder-share-multiple.svg\"\r\n                                    aria-hidden=\"true\" >\r\n                                </md-icon>\r\n                                <md-icon ng-if=\"!node.children && node.id_group_type == 5\"\r\n                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                    md-font-icon=\"qiu-icon-file-userstore\"\r\n                                    aria-hidden=\"true\" >\r\n                                </md-icon>\r\n                                <md-icon\r\n                                    ng-if=\"node.children && node.id_group_type == 5\"\r\n                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                    md-svg-src=\"/assets/icons/svg/icon-folder-shop-multiple.svg\"\r\n                                    aria-hidden=\"true\" >\r\n                                </md-icon>\r\n                                <md-icon ng-if=\"!node.children && node.id_group_type == 6\"\r\n                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                    md-font-icon=\"qiu-icon-file-useracreditation\"\r\n                                    aria-hidden=\"true\" >\r\n                                </md-icon>\r\n                                <md-icon\r\n                                    ng-if=\"node.children && node.id_group_type == 6\"\r\n                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                    md-svg-src=\"/assets/icons/svg/icon-folder-board-multiple.svg\"\r\n                                    aria-hidden=\"true\" >\r\n                                </md-icon>\r\n                                <md-icon ng-if=\"!node.children && node.id_group_type == 7\"\r\n                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                    md-svg-src=\"/assets/icons/svg/icon-folder-chat.svg\"\r\n                                    aria-hidden=\"true\" >\r\n                                </md-icon>\r\n                                <md-icon\r\n                                    ng-if=\"node.children && node.id_group_type == 7\"\r\n                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                    md-svg-src=\"/assets/icons/svg/icon-folder-chat-multiple.svg\"\r\n                                    aria-hidden=\"true\" >\r\n                                </md-icon>\r\n                                <md-icon ng-if=\"!node.children && node.id_group_type == 8\"\r\n                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                    md-font-icon=\"icon-folder-remove\"\r\n                                    aria-hidden=\"true\" >\r\n                                </md-icon>\r\n                                <md-icon\r\n                                    ng-if=\"node.children && node.id_group_type == 8\"\r\n                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                    md-font-icon=\"icon-folder-multiple\"\r\n                                    aria-hidden=\"true\" >\r\n                                </md-icon>\r\n                            </div>\r\n                           \r\n                            <span class=\"ivh-treeview-node-label ng-binding\">{{node.name}}</span>\r\n   \r\n                        </div>\r\n   \r\n                        <div layout=\"row\" layout-align=\"end center\">\r\n                            <md-button qiu-users-on-click-open-group-edit-dialog class=\"md-icon-button\" type=\"button\" aria-label=\"ACTIONS\">\r\n                                <md-icon md-font-icon=\"icon-pencil\" aria-hidden=\"true\"></md-icon>\r\n                            </md-button>\r\n                            <md-icon qiu-users-on-click-close-sidenav sidenav-id=\"groups-sidenav\" md-font-icon=\"icon-chevron-right\" aria-hidden=\"true\" hide-gt-sm class=\"mt-0 mb-0\"></md-icon>\r\n                        </div>\r\n   \r\n                    </div>\r\n                    <div ivh-treeview-children></div>\n</script></div></div></md-content>");
$templateCache.put("app/main/apps/users/sidenavs/groups-sidenav.html","<div flex layout=\"column\" layout-align=\"center center\" ng-if=\"isLoadingGroups\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><md-toolbar \nng-if=\"!isLoadingGroups\" class=\"md-default-theme grey-100-bg grey-600-fg pr-16 pl-16\" layout=\"row\" \nlayout-align=\"space-between center\"><div ng-if=\"!vm.showTreeSearch\" class=\"md-toolbar-tools p-0\" aria-label=\"Groups\" \nlayout=\"row\" layout-align=\"start center\"><md-icon hide show-gt-lg md-font-icon=\"icon-folder-multiple\" \nclass=\"grey-600-fg s18 mr-10 ml-0 md-default-theme md-font material-icons\" aria-hidden=\"true\"></md-icon><div \ntranslate-attr-aria-label=\"USERS.GROUPS\" translate=\"USERS.GROUPS\" class=\"grey-600-fg\" aria-label=\"GROUPS\">GROUPS</div>\n</div><div ng-if=\"!vm.showTreeSearch\" layout=\"row\" layout-align=\"end center\"><div \nclass=\"divider-vertical hide show-gt-xs\" hide=\"\" show-gt-xs=\"\"></div><md-icon ng-if=\"vm.sortDirUsersGroup !== \'ASC\'\" \nng-click=\"vm.sortDirUsersGroup=\'ASC\'; vm.getCleanUsersGroup()\" md-font-icon=\"icon-sort-descending\" \nclass=\"m-0 grey-600-fg md-icon-button md-button md-default-theme md-font material-icons\" translate=\"\" \ntranslate-attr-aria-label=\"TODO.SORT_DIRECTION\"></md-icon><md-icon ng-if=\"vm.sortDirUsersGroup === \'ASC\'\" \nng-click=\"vm.sortDirUsersGroup=\'DESC\'; vm.getCleanUsersGroup()\" md-font-icon=\"icon-sort-ascending\" \nclass=\"m-0 grey-600-fg md-icon-button md-button md-default-theme md-font material-icons\" translate=\"\" \ntranslate-attr-aria-label=\"TODO.SORT_DIRECTION\"></md-icon><md-menu><button aria-label=\"Filters\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\" show-gt-xs=\"\" translate=\"\" translate-attr-aria-label=\"CONTENT.FILTERS\"><md-icon \nmd-font-icon=\"m-0 grey-600-fg icon-chevron-down\"><md-tooltip><span translate=\"CONTENT.ORDER_BY\">Order</span>\n</md-tooltip></md-icon></button><md-menu-content width=\"4\"><md-menu-item \nng-repeat=\"(key, value) in vm.orderByUsersGroup\"><md-button aria-label=\"All\" \nng-click=\"vm.sortFieldUsersGroup=value; vm.getCleanUsersGroup()\"><div layout=\"row\" layout-align=\"space-between center\">\n<span>Order by {{key | translate}} </span><i class=\"icon-check s16\" ng-if=\"value == vm.sortFieldUsersGroup\"></i></div>\n</md-button></md-menu-item></md-menu-content></md-menu><div class=\"divider-vertical hide show-gt-xs\" hide=\"\" \nshow-gt-xs=\"\"></div><mv-tree-expander tree=\"vm.CleanUsersGroups\"></mv-tree-expander><md-icon id=\"\" \nmd-font-icon=\"icon-plus\" ng-click=\"vm.createGroup($event)\" \nclass=\"m-0 grey-600-fg md-icon-button md-button md-default-theme md-font material-icons\" aria-hidden=\"true\">\n<md-tooltip><span translate=\"CONTENT.ADD\">Add</span></md-tooltip></md-icon><md-icon \nmd-font-icon=\"icon-account-multiple-plus\" ng-click=\"vm.segmentGroupDialogNew()\" \nclass=\"m-0 grey-600-fg md-icon-button md-button md-default-theme md-font material-icons\" aria-hidden=\"true\">\n<md-tooltip><span translate=\"MAILING.SEGMENT\"></span></md-tooltip></md-icon><label for=\"ms-search-bar-input\"><md-icon \nng-click=\"vm.showTreeSearch = true\" md-font-icon=\"icon-magnify\" \nclass=\"m-0 grey-600-fg md-icon-button md-button md-default-theme md-font material-icons\"><md-tooltip hide show-gt-xs>\n<span translate=\"TOOLBAR.SEARCH\">Search</span></md-tooltip></md-icon></label><div class=\"divider-vertical\"></div>\n<md-icon ng-click=\"vm.cancelUsersGroups(\'groups-sidenav\')\" md-font-icon=\"icon-backburger\" \nclass=\"m-0 grey-600-fg md-icon md-button md-default-theme md-font material-icons md-icon-button\" aria-hidden=\"true\">\n</md-icon></div><div ng-if=\"vm.showTreeSearch\" layout=\"row\" class=\"users-groups-tree-search\"><div layout=\"row\" flex \nlayout-align=\"start center\"><label for=\"search-bar-input\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"grey-600-fg md-icon-button md-button\"><md-tooltip hide show-gt-xs><span translate=\"TOOLBAR.SEARCH\">Search</span>\n</md-tooltip></md-icon></label><md-icon md-font-icon=\"icon-close-circle\" class=\"grey-600-fg md-icon-button md-button\" \nng-if=\"vm.treeSearch\" ng-click=\"vm.treeSearch = null\"></md-icon><input type=\"text\" id=\"search-bar-input\" \nclass=\"grey-600-fg grey-100-bg\" ng-model=\"vm.treeSearch\" placeholder=\"Search\" md-autofocus translate \ntranslate-attr-placeholder=\"TOOLBAR.SEARCH\" flex><md-icon layout-align=\"end center\" \nng-click=\"vm.showTreeSearch = false\" md-font-icon=\"icon-close\" \nclass=\"users-groups-tree-search-collapser icon s24 grey-600-fg\"></md-icon></div></div></md-toolbar><md-content \nng-if=\"!isLoadingGroups\" ms-scroll class=\"content\" hide flex><div class=\"navigation-simple\" layout=\"column\"><div><div \nng-if=\"vm.usersGroups\" ivh-treeview=\"vm.usersGroups\" class=\"treeview small\" \nivh-treeview-on-cb-change=\"vm.callback(ivhNode, ivhIsSelected, ivhTree)\"><script type=\"text/ng-template\">\n<div class=\"level-card\">\r\n                        <span ivh-treeview-toggle>\r\n                            <span ivh-treeview-twistie></span>\r\n                        </span>\r\n                        <span class=\"pointer-indicator\"></span>\r\n                        <span class=\"ivh-treeview-node-label\" ivh-treeview-toggle>{{node.name}}</span>\r\n                        <md-treeview-box></md-treeview-box>\r\n                    </div>\r\n                    <div ivh-treeview-children></div>\n</script></div></div></div></md-content><md-content ng-if=\"!isLoadingGroups\" ms-scroll flex><div \nclass=\"navigation-simple\" layout=\"column\"><div hidden id=\"includeSubgroups\" \ndata-include-subgroups=\"{{vm.includeSubgroups}}\"></div><div ng-if=\"vm.CleanUsersGroups\" \nivh-treeview=\"vm.CleanUsersGroups\" ivh-treeview-filter=\"vm.treeSearch\" ivh-treeview-label-attribute=\"\'label\'\" \nclass=\"ivh-treeview-folder small\" ivh-treeview-on-cb-change=\"callback()\"><script type=\"text/ng-template\">\n<div class=\"level-card p-8 group-row\" layout=\"row\" layout-align=\"space-between stretch\" ng-class=\"{\'selected\': node.is_qiu_restricted_root}\">\r\n                    <span ivh-treeview-twistie ivh-treeview-toggle layout=\"row\" layout-align=\"center center\"></span>\r\n                    <div flex id=\"treeview-group-{{node.id_group}}\" qiu-users-on-click-load-users-by-groups data-group-node={{node}} layout=\"row\" layout-align=\"start center\">\r\n                        <div ng-if=\"node.group_type.icon\">\r\n                            <md-icon ng-if=\"node.group_type.icon\"\r\n                                class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                md-font-icon=\"{{node.group_type.icon}}\"\r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                        </div>\r\n                        <div ng-if=\"!node.group_type.icon\">\r\n                            <md-icon ng-if=\"!node.children && node.id_group_type == 1\"\r\n                                md-font-icon=\"icon-folder\"\r\n                                class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon\r\n                                ng-if=\"node.children && node.id_group_type == 1\"\r\n                                md-font-icon=\"icon-folder-multiple\"\r\n                                class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon ng-if=\"!node.children && node.id_group_type == 2\"\r\n                                md-font-icon=\"qiu-icon-file-usermailing\"\r\n                                class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon\r\n                                ng-if=\"node.children && node.id_group_type == 2\"\r\n                                class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                md-svg-src=\"/assets/icons/svg/icon-folder-mail-multiple.svg\"\r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon ng-if=\"!node.children && node.id_group_type == 3\"\r\n                                class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                md-font-icon=\"qiu-icon-file-usermediacenter\"\r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon\r\n                                ng-if=\"node.children && node.id_group_type == 3\"\r\n                                class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                md-svg-src=\"/assets/icons/svg/icon-folder-play-multiple.svg\"\r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon ng-if=\"!node.children && node.id_group_type == 4\"\r\n                                class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                md-font-icon=\"qiu-icon-file-usersegment\"\r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon\r\n                                ng-if=\"node.children && node.id_group_type == 4\"\r\n                                class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                md-svg-src=\"/assets/icons/svg/icon-folder-share-multiple.svg\"\r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon ng-if=\"!node.children && node.id_group_type == 5\"\r\n                                class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                md-font-icon=\"qiu-icon-file-userstore\"\r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon\r\n                                ng-if=\"node.children && node.id_group_type == 5\"\r\n                                class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                md-svg-src=\"/assets/icons/svg/icon-folder-shop-multiple.svg\"\r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon ng-if=\"!node.children && node.id_group_type == 6\"\r\n                                class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                md-font-icon=\"qiu-icon-file-useracreditation\"\r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon\r\n                                ng-if=\"node.children && node.id_group_type == 6\"\r\n                                class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                md-svg-src=\"/assets/icons/svg/icon-folder-board-multiple.svg\"\r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon ng-if=\"!node.children && node.id_group_type == 7\"\r\n                                class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                md-svg-src=\"/assets/icons/svg/icon-folder-chat.svg\"\r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon\r\n                                ng-if=\"node.children && node.id_group_type == 7\"\r\n                                class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                md-svg-src=\"/assets/icons/svg/icon-folder-chat-multiple.svg\"\r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon ng-if=\"!node.children && node.id_group_type == 8\"\r\n                                class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                md-font-icon=\"icon-folder-remove\"\r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon\r\n                                ng-if=\"node.children && node.id_group_type == 8\"\r\n                                class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                md-font-icon=\"icon-folder-multiple\"\r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                        </div>\r\n                      \r\n                        <span class=\"ivh-treeview-node-label ng-binding\">{{node.name}}</span>\r\n                    </div>\r\n\r\n                    <div layout=\"row\" layout-align=\"end center\">\r\n                        <md-button qiu-users-on-click-open-group-edit-dialog class=\"md-icon-button\" type=\"button\" aria-label=\"ACTIONS\">\r\n                            <md-icon md-font-icon=\"icon-pencil\" aria-hidden=\"true\"></md-icon>\r\n                        </md-button>\r\n                        <md-icon qiu-users-on-click-close-sidenav sidenav-id=\"groups-sidenav\" md-font-icon=\"icon-chevron-right\" aria-hidden=\"true\" hide-gt-sm class=\"mt-0 mb-0\"></md-icon>\r\n                    </div>\r\n\r\n                </div>\r\n                <div ivh-treeview-children></div>\n</script></div></div></md-content>");
$templateCache.put("app/main/apps/users/users-blacklist/users-blacklist.html","<div id=\"site-users\" class=\"page-layout carded left-sidenav\" layout=\"row\" md-no-ink><div class=\"center\" \nlayout=\"column\" flex><div class=\"content-card\" ng-class=\"vm.currentView\" layout=\"column\" flex \nng-include=\"vm.views[vm.currentView]\" md-no-ink></div></div><qiu-pagination collection=\"vm.threads\" url=\"\'http://\'\" \nservice=\"usersBlacklistService\" columns=\"vm.refcolumns\" columns-grouped=\"vm.refcolumnsgrouped\" \nfields-filters=\"vm.refFilterables\" menu-filters=\"main-sidenav\" media-zones=\"refMediaZones\" fields-search=\"refSearch\" \nfields-sort=\"refSortables\" sort-field=\"id_user\" style=\"display:none\" groupby=\"list_position\"></qiu-pagination></div>");
$templateCache.put("app/main/apps/users/users-temporary/users-temporary.html","<div id=\"site-users\" class=\"site-users-temporary page-layout carded left-sidenav\" layout=\"row\" md-no-ink><div \nclass=\"center\" layout=\"column\" flex><div class=\"content-card\" ng-class=\"vm.currentView\" layout=\"column\" flex \nng-include=\"vm.views[vm.currentView]\" md-no-ink></div></div><qiu-pagination collection=\"vm.threads\" url=\"\'http://\'\" \nservice=\"usersTemporaryService\" columns=\"vm.refcolumns\" columns-grouped=\"vm.refcolumnsgrouped\" \nsort-field=\"id_user_temp\" style=\"display:none\" groupby=\"list_position\"></qiu-pagination></div>");
$templateCache.put("app/main/dialogs/media/views/audios-view.html","<div class=\"content-wrapper full-height\" flex=\"\" layout=\"row\"><div class=\"mail-tabs-grid\" flex \nmd-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"content mail-list-pane-grid\" flex ms-scroll><div \nng-repeat=\"item in vm.items\" class=\"ms-card\" flex><div class=\"ms-card-content-wrapper\"><div class=\"template-9\"><div \nclass=\"media\" flex layout=\"row\" layout-align=\"center center\"><div flex layout=\"column\" layout-align=\"center center\" \nclass=\"media\"><media attachment=\"item\" class=\"\"></media><br><span class=\"grey-500-fg\" layout=\"column\" \nlayout-align=\"center center\"><span ng-if=\"item.title\"><strong>{{item.title}}</strong></span> <span \nng-if=\"item.filename\">{{item.filename}}</span></span></div></div><div class=\"header p-16\" flex><div layout=\"row\" \nlayout-align=\"space-between center\" flex><div class=\"size block\" layout=\"row\" layout-align=\"start left\"><strong \nclass=\"mr-5 mb-5 block\">#{{item.id_media}}</strong> <span class=\"grey-500-fg\"><span ng-if=\"item.date_uploaded\"><span \ntranslate=\"MEDIA_DIALOG.DATE_UPLOADED\"></span>: {{item.date_uploaded}}</span></span></div><md-checkbox \nng-checked=\"vm.alreadySelectedbyZone(vm.selectedContacts, item)\" ng-click=\"vm.toggleSelectContact(item, $event)\" \naria-label=\"{{vm.alreadySelectedbyZone(vm.selectedContacts, item) ? \'Deselect\' : \'Select\'}}\" ng-if=\"vm.maxAttach > 1\" \nclass=\"ml-5\"></md-checkbox><md-button ng-click=\"vm.toggleSelectOne(item, $event)\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Attach\" ng-if=\"vm.maxAttach == 1\" translate=\"MEDIA.SELECT\" \ntranslate-attr-aria-label=\"MEDIA.SELECT\"></md-button></div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/dialogs/media/views/confirm-upload-close.html","<md-dialog aria-label=\"Confirm upload close\" class=\"confirm-upload-close-dialog\"><md-toolbar \nstyle=\"background-color: rgba(0, 0, 0, 0.03); color: rgba(0,0,0,0.87)\"><div class=\"md-toolbar-tools\"><h2 flex \ntranslate=\"MEDIA.UPLOADING_MEDIA_DIALOG_TITLE\">Subida de archivos</h2><md-button class=\"md-icon-button\" \nng-click=\"vm.answer(\'stay\')\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\" \nstyle=\"color: rgba(0,0,0,0.54)\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div \nclass=\"md-dialog-content\"><p style=\"font-size: 16px; margin: 16px 0\" translate=\"MEDIA.UPLOADING_MEDIA_CONFIRM_TEXT\">\nMedia are still uploading, what do you wish to do?</p></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"end center\" style=\"padding: 16px\"><md-button ng-click=\"vm.answer(\'abort\')\" class=\"md-warn\" \nstyle=\"margin-right: 8px\" translate=\"MEDIA.CANCEL_UPLOAD\">CANCEL UPLOAD</md-button><span flex></span><md-button \nng-click=\"vm.answer(\'stay\')\" class=\"md-raised md-primary\" translate=\"MEDIA.FINISH_UPLOAD\">FINISH THE UPLOAD</md-button>\n</md-dialog-actions></md-dialog><style>\n.confirm-upload-close-dialog {\n        width: 600px !important;\n        max-width: 90%;\n    }</style>");
$templateCache.put("app/main/dialogs/media/views/files-view.html","<div class=\"content-wrapper full-height\" flex=\"\" layout=\"row\"><div class=\"mail-tabs-grid\" flex=\"\"><div \nclass=\"content mail-list-pane-grid\" flex=\"\" ms-scroll=\"\"><div ng-repeat=\"item in vm.items\" class=\"ms-card\" flex><div \nclass=\"ms-card-content-wrapper\"><div class=\"template-9\"><div class=\"media\" flex layout=\"row\" \nlayout-align=\"center center\"><div flex layout=\"column\" layout-align=\"center center\" class=\"media\"><media \nattachment=\"item\" class=\"\"></media><br><span class=\"grey-500-fg\" layout=\"column\" layout-align=\"center center\"><span \nng-if=\"item.title\"><strong>{{item.title}}</strong></span> <span ng-if=\"item.filename\">{{item.filename}}</span></span>\n</div></div><div class=\"header p-16\" flex><div layout=\"row\" layout-align=\"space-between center\" flex><div \nclass=\"size block\" layout=\"row\" layout-align=\"start left\"><strong class=\"mr-5\">#{{item.id_media}}</strong></div>\n<md-checkbox ng-checked=\"vm.alreadySelectedbyZone(vm.selectedContacts, item)\" \nng-click=\"vm.toggleSelectContact(item, $event)\" \naria-label=\"{{vm.alreadySelectedbyZone(vm.selectedContacts, item) ? \'Deselect\' : \'Select\'}}\" ng-if=\"vm.maxAttach > 1\" \nclass=\"ml-5\"></md-checkbox><md-button ng-click=\"vm.toggleSelectOne(item, $event)\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Attach\" ng-if=\"vm.maxAttach == 1\" translate=\"MEDIA.SELECT\" \ntranslate-attr-aria-label=\"MEDIA.SELECT\"></md-button></div></div></div></div></div></div></div></div><div \nlayout=\"column\" layout-align=\"center center\"></div>");
$templateCache.put("app/main/dialogs/media/views/galleries-view.html","<md-content ms-scroll class=\"content full-height\" flex ng-if=\"!vm.loading\"><div class=\"sections\"><div \nclass=\"section navigation-simple groups-tree p-20 white-bg\" layout=\"column\"><div \nclass=\"section-header layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-file-image-box\" ng-if=\"vm.currentViewGallery===\'1\'\" class=\"s20 mr-5 ml-0\"></md-icon><md-icon \nmd-font-icon=\"icon-video\" ng-if=\"vm.currentViewGallery===\'2\'\" class=\"s20 mr-5 ml-0\"></md-icon><md-icon \nmd-font-icon=\"icon-volume\" ng-if=\"vm.currentViewGallery===\'3\'\" class=\"s20 mr-5 ml-0\"></md-icon><md-icon \nmd-font-icon=\"icon-file\" ng-if=\"vm.currentViewGallery===\'4\'\" class=\"s20 mr-5 ml-0\"></md-icon><span \nclass=\"ml-5 grey-600-fg\" ng-if=\"vm.currentViewGallery===\'1\'\"><strong>IMAGES</strong></span> <span \nclass=\"ml-5 grey-600-fg\" ng-if=\"vm.currentViewGallery===\'2\'\"><strong>VIDEOS</strong></span> <span \nclass=\"ml-5 grey-600-fg\" ng-if=\"vm.currentViewGallery===\'3\'\"><strong>AUDIO</strong></span> <span \nclass=\"ml-5 grey-600-fg\" ng-if=\"vm.currentViewGallery===\'4\'\"><strong>FILES</strong></span></div><div ng-if=\"vm.items\" \nivh-treeview=\"vm.items\" ivh-treeview-filter=\"vm.modelFilter\" ivh-treeview-label-attribute=\"\'gallery_name\'\" \nclass=\"ivh-treeview-folder small\"><script type=\"text/ng-template\">\n<div class=\"level-card p-8 gallery-row\" layout=\"row\" layout-align=\"space-between center\">\r\n                        <span ivh-treeview-twistie ivh-treeview-toggle layout=\"row\" layout-align=\"center center\"></span>\r\n                        <div flex layout=\"row\" layout-align=\"start center\">\r\n                            <md-icon\r\n                                ng-if=\"!node.children && node.gallery_type == 0\"\r\n                                md-font-icon=\"icon-folder\"\r\n                                class=\"s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon\r\n                                ng-if=\"!node.children && node.gallery_type == 1\"\r\n                                md-font-icon=\"icon-folder-image\"\r\n                                class=\"s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon\r\n                                ng-if=\"!node.children && node.gallery_type == 2\"\r\n                                md-font-icon=\"qiu-icon-video-folder\"\r\n                                class=\"s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon\r\n                                ng-if=\"!node.children && node.gallery_type == 3\"\r\n                                md-font-icon=\"qiu-icon-audio-folder\"\r\n                                class=\"s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon\r\n                                ng-if=\"!node.children && node.gallery_type == 4\"\r\n                                md-font-icon=\"qiu-icon-file-folder\"\r\n                                class=\"s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon\r\n                                ng-if=\"node.children && node.gallery_type == 0\"\r\n                                md-font-icon=\"icon-folder-multiple\"\r\n                                class=\"s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon\r\n                                ng-if=\"node.children && node.gallery_type == 1\"\r\n                                md-font-icon=\"icon-folder-multiple-image\"\r\n                                class=\"s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon\r\n                                ng-if=\"node.children && node.gallery_type == 2\"\r\n                                md-font-icon=\"qiu-icon-video-gallery\"\r\n                                class=\"s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon\r\n                                ng-if=\"node.children && node.gallery_type == 3\"\r\n                                md-font-icon=\"qiu-icon-audio-gallery\"\r\n                                class=\"s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon\r\n                                ng-if=\"node.children && node.gallery_type == 4\"\r\n                                md-font-icon=\"qiu-icon-file-gallery\"\r\n                                class=\"s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <div class=\"group-status green-bg\" ng-if=\"node.status ===1\" role=\"button\" aria-label=\"group-status\"></div>\r\n                            <span class=\"ivh-treeview-node-label ng-binding\">{{node.gallery_name}}</span>\r\n\r\n                        </div>\r\n                        <div layout=\"row\" layout-align=\"end center\">\r\n                            <md-checkbox\r\n                                ng-disabled=\"node.is_qiu_restricted_root\"\r\n                                ng-checked=\"node.assigned_gallery\"\r\n                                aria-label=\"{{node.assigned_gallery ? \'Deselect\' : \'Select\'}}\"\r\n                                class=\"ml-5 mb-0\"\r\n                                ng-click=\"node.assigned_gallery = !node.assigned_gallery\"\r\n                            ></md-checkbox>\r\n                        <!--\r\n                          <md-button ng-click=\"vm.toggleSelectOne(photo, $event)\" class=\"send-button md-accent md-raised\" aria-label=\"Attach\"\r\n                                     ng-if=\"node.maxAttach == 1\"\r\n                                     translate=\"MEDIA.SELECT\"\r\n                                     translate-attr-aria-label=\"MEDIA.SELECT\">\r\n                          </md-button>\r\n                        -->\r\n                        </div>\r\n                    </div>\r\n                    <div ivh-treeview-children></div>\n</script></div></div></div></md-content>");
$templateCache.put("app/main/dialogs/media/views/import-view.html","<div class=\"content-wrapper full-height\" flex layout=\"column\"><div class=\"content\"><div class=\"drop-box\">\n<md-input-container class=\"md-block\"><label translate=\"MEDIA.PASTE_URL_HERE\"></label><input type=\"text\" \nname=\"import_field\" ng-model=\"vm.import_field\" placeholder=\"{{vm.translate(\'MEDIA.PASTE_URL_HERE\')}}\" \nng-disabled=\"vm.import_disabled\"></md-input-container><div ng-if=\"vm.imported\" class=\"alert-message success-message\" \ntranslate=\"MEDIA.SUCCESSIMPORT\"></div></div><treasure-overlay-spinner active=\"vm.importing\"><div layout=\"row\" \nlayout-align=\"center start\" ng-if=\"vm.importPreview\" class=\"white-box sections\"><div flex-gt-sm=\"50\" flex=\"100\"><div \nclass=\"section\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><span class=\"section-title\" \ntranslate=\"MEDIA.PREVIEW_VIEW\"></span></div><div class=\"media\" flex layout=\"row\" layout-align=\"center center\" \nng-bind-html=\"vm.importPreview.embedCodeSafe\"></div></div><div class=\"section\" ng-if=\"vm.importPreview.title\"><div \nclass=\"section-header\" layout=\"row\" layout-align=\"start center\"><span class=\"section-title\" translate=\"MEDIA.TITLE\">\n</span></div><div><span class=\"grey-500-fg\">{{vm.importPreview.title}}</span></div></div><div class=\"section\" \nng-if=\"vm.importPreview.caption\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"section-title\" translate=\"MEDIA.DESCRIPTION\"></span></div><div><span class=\"grey-500-fg\">\n{{vm.importPreview.caption}}</span></div></div><md-button hide class=\"send-button md-accent md-raised\" \nng-click=\"vm.importConfirm(1)\" translate=\"CONTENT.IMPORT\">Import</md-button></div></div><div \nng-repeat=\"f in vm.importedFiles\" class=\"ms-card\" flex><div class=\"ms-card-content-wrapper\"><div class=\"template-9\">\n<div class=\"media\" flex layout=\"row\" layout-align=\"center center\"><img ng-src=\"{{f.embed_thumb}}\" class=\"image\"></div>\n<div class=\"header p-16\" flex><div layout=\"row\" layout-align=\"space-between center\" flex><div class=\"size block\" \nlayout=\"row\" layout-align=\"start left\"><strong class=\"mr-5\">#{{f.id_media}}</strong> <span class=\"grey-500-fg\"><span \nng-if=\"f.filename\">{{f.filename}}</span> <span ng-if=\"f.title\">{{f.title}}</span></span></div><md-checkbox \nng-checked=\"vm.alreadySelectedbyZone(vm.selectedContacts, f)\" ng-click=\"vm.toggleSelectContact(f, $event)\" \naria-label=\"{{vm.alreadySelectedbyZone(vm.selectedContacts, f) ? \'Deselect\' : \'Select\'}}\"></md-checkbox></div></div>\n</div></div></div></treasure-overlay-spinner></div></div>");
$templateCache.put("app/main/dialogs/media/views/photos-view.html","<div class=\"content-wrapper full-height\" flex layout=\"row\"><div class=\"mail-tabs-grid\" flex \nmd-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"content mail-list-pane-grid\" flex><div \nng-repeat=\"photo in vm.items\" class=\"ms-card\" flex><div class=\"ms-card-content-wrapper\"><div class=\"template-9\"><div \nclass=\"media\" flex layout=\"row\" layout-align=\"center center\"><media attachment=\"photo\" class=\"\"></media></div><div \nclass=\"header p-16\" flex><div layout=\"row\" layout-align=\"space-between start\" flex><div class=\"size block pr-10\" \nlayout=\"row\" layout-align=\"start left\" flex><strong class=\"block mb-5\">#{{photo.id_media}}</strong> <span \nclass=\"grey-500-fg\"><span ng-if=\"photo.filename\" class=\"word-break-all\">{{photo.filename}}</span></span></div>\n<md-checkbox ng-checked=\"vm.alreadySelectedbyZone(vm.selectedContacts, photo)\" \nng-click=\"vm.toggleSelectContact(photo, $event)\" \naria-label=\"{{vm.alreadySelectedbyZone(vm.selectedContacts, photo) ? \'Deselect\' : \'Select\'}}\" ng-if=\"vm.maxAttach > 1\" \nclass=\"ml-5\"></md-checkbox><md-button ng-click=\"vm.toggleSelectOne(photo, $event)\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Attach\" ng-if=\"vm.maxAttach == 1\" translate=\"MEDIA.SELECT\" \ntranslate-attr-aria-label=\"MEDIA.SELECT\"></md-button></div><md-tooltip md-direction=\"top\" hide show-gt-xs \nng-if=\"photo.filename\"><span>{{photo.filename}}</span></md-tooltip></div></div></div></div></div></div></div>");
$templateCache.put("app/main/dialogs/media/views/set-tags.html","<div class=\"content-wrapper\" flex=\"\" layout-gt-sm=\"row\" layout=\"column\"><div flex-gt-sm=\"60\" flex=\"100\" \nclass=\"white-box sections\"><div class=\"tags\" ng-repeat=\"tagsTabSetting in vm.tagsTabSettings\" \nng-if=\"tagsTabSetting.field_type != \'hidden\'\"><md-input-container class=\"md-block\" \nng-if=\"tagsTabSetting.field_type == \'autocomplete\'\"><label translate=\"GLOBAL.SEARCH_FOR_TAG\">Tags</label><md-chips \nclass=\"label-chips close-chip\" ng-model=\"vm.currentTags\" md-autocomplete-snap md-require-match=\"true\"><md-autocomplete \nmd-min-length=\"1\" md-selected-item=\"vm.selectedTag\" md-selected-item-change=\"vm.selectedItemChange()\" \nmd-search-text=\"vm.searchTagText\" \nmd-items=\"tag in vm.labelQuerySearch(vm.searchTagText, tagsTabSetting.tags_types) | orderBy:\'-order\'\" \nmd-item-text=\"tag.tag_name\" md-no-cache=\"true\" placeholder=\"{{vm.translate(\'GLOBAL.SEARCH_FOR_TAG\')}}\" \nng-model-options=\"{debounce: 500}\" md-dropdown-items=\"10\"><div layout=\"row\" layout-align=\"space-between center\" \nflex=\"100\" class=\"tag-not-found-bg border-bottom\"><span ng-if=\"!tag.tag_name\">{{vm.searchTagText}}</span> <span \nmd-highlight-text=\"vm.searchTagText\" ng-if=\"tag.tag_name\">{{tag.tag_name}}</span><md-buttton ng-if=\"!tag.tag_name\" \nng-click=\"vm.newTag(vm.searchTagText)\" class=\"md-accent green-500-bg white-fg md-button m-0\"><span \ntranslate=\"CONTENT.TAGADD\"></span></md-buttton></div><md-not-found><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"100\" class=\"tag-not-found-bg\"><span>{{vm.searchTagText}}</span><md-buttton \nng-click=\"vm.newTag(vm.searchTagText)\" class=\"md-accent green-500-bg white-fg md-button m-0\"><span \ntranslate=\"CONTENT.TAGADD\"></span></md-buttton></div></md-not-found></md-autocomplete><md-chip-template><div \nclass=\"md-chip-content\"><span ng-if=\"$chip.color\" class=\"color\" ng-style=\"{\'background-color\':$chip.color}\"></span> \n<span>{{$chip.tag_name}} #{{$chip.id_tag}}</span></div></md-chip-template><button md-chip-remove class=\"md-primary\" \nlayout=\"row\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-close\"></md-icon></button></md-chips>\n</md-input-container><md-input-container class=\"md-block\" ng-if=\"tagsTabSetting.field_type == \'radio\'\"><p>\n{{vm.checkboxGroupTitleByTagTypes(tagsTabSetting.tags_types)}}</p><md-radio-group name=\"tags\" ng-model=\"tag\" \nng-change=\"vm.radioChanged(tag, tagsTabSetting.tags_types)\" layout=\"column\"><md-radio-button \nng-repeat=\"tag in vm.radioOptionsFilter(vm.tags, tagsTabSetting.tags_types)\" ng-value=\"[tag]\" \naria-label=\"tag.tag_name\">{{tag.tag_name}}</md-radio-button></md-radio-group></md-input-container><md-input-container \nclass=\"md-block\" ng-if=\"tagsTabSetting.field_type == \'checkbox\' && vm.tagsTypes\"><p>\n{{vm.checkboxGroupTitleByTagTypes(tagsTabSetting.tags_types)}}</p><md-checkbox layout=\"row\" \nng-repeat=\"tag in vm.checkboxesFilter(vm.tags, tagsTabSetting.tags_types)\" ng-checked=\"vm.isCurrentTag(tag)\" \nng-click=\"vm.updateCurrentTags(tag, $event)\" class=\"ml-5\">{{tag.tag_name}}</md-checkbox></md-input-container></div>\n</div></div>");
$templateCache.put("app/main/dialogs/media/views/sidenav.html","<md-toolbar class=\"md-default-theme grey-100-bg grey-600-fg pr-16 pl-16\" layout=\"row\" \nlayout-align=\"space-between center\"><div ng-if=\"!vm.showTreeSearch\" class=\"md-toolbar-tools p-0\" \naria-label=\"Galleries\" layout=\"row\" layout-align=\"start center\"><div translate-attr-aria-label=\"MEDIA.GALLERIES\" \ntranslate=\"MEDIA.GALLERIES\" class=\"grey-600-fg\" aria-label=\"GALLERIES\">GALLERIES</div></div><div \nng-if=\"!vm.showTreeSearch\" layout=\"row\" layout-align=\"end center\"><label for=\"ms-search-bar-input\"><md-icon \nng-click=\"vm.showTreeSearch = true\" md-font-icon=\"icon-magnify\" \nclass=\"m-0 grey-600-fg md-icon-button md-button md-default-theme md-font material-icons search\"><md-tooltip hide \nshow-gt-xs><span translate=\"TOOLBAR.SEARCH\">Search</span></md-tooltip></md-icon></label><div \nclass=\"divider-vertical hide show-gt-xs\" hide=\"\" show-gt-xs=\"\"></div><md-icon \nng-click=\"vm.toggleMediaDialogSidenav(\'media-dialog-galleries-sidenav\')\" md-font-icon=\"icon-backburger\" \nclass=\"m-0 grey-600-fg md-icon md-button md-default-theme md-font material-icons md-icon-button icon-backburger search\" \naria-hidden=\"true\"></md-icon></div><div ng-if=\"vm.showTreeSearch\" layout=\"row\" class=\"media-gallery-tree-search\"><div \nlayout=\"row\" flex layout-align=\"start center\"><label for=\"search-bar-input\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"grey-600-fg md-icon-button md-button search\"><md-tooltip hide show-gt-xs><span translate=\"TOOLBAR.SEARCH\">Search\n</span></md-tooltip></md-icon></label><md-icon md-font-icon=\"icon-close-circle\" \nclass=\"grey-600-fg md-icon-button md-button search\" ng-if=\"vm.treeSearch\" ng-click=\"vm.treeSearch = null\"></md-icon>\n<input type=\"text\" id=\"search-bar-input\" class=\"grey-600-fg grey-100-bg\" ng-model=\"vm.treeSearch\" placeholder=\"Search\" \nmd-autofocus translate translate-attr-placeholder=\"TOOLBAR.SEARCH\" flex><md-icon layout-align=\"end center\" \nng-click=\"vm.showTreeSearch = false\" md-font-icon=\"icon-close\" \nclass=\"media-gallery-tree-search-collapser icon s24 grey-600-fg search\"></md-icon></div></div></md-toolbar><md-content \nms-scroll class=\"\" flex><div class=\"navigation-simple\" layout=\"column\"><div hidden id=\"includeSubgalleries\" \ndata-include-subgalleries=\"{{vm.includeSubgalleries}}\"></div><div ng-if=\"vm.CleanMediaGalleries\" \nivh-treeview=\"vm.CleanMediaGalleries\" ivh-treeview-filter=\"vm.treeSearch\" \nivh-treeview-label-attribute=\"\'gallery_name\'\" class=\"ivh-treeview-folder small\" ivh-treeview-on-cb-change=\"callback()\">\n<script type=\"text/ng-template\">\n<div class=\"level-card p-8 gallery-row\" layout=\"row\" layout-align=\"space-between stretch\">\r\n                    <span ivh-treeview-twistie ivh-treeview-toggle layout=\"row\" layout-align=\"center center\"></span>\r\n                    <div flex id=\"treeview-gallery-{{node.id_gallery}}\" qiu-media-dialog-on-click-load-media-by-galleries data-gallery-node={{node}} layout=\"row\" layout-align=\"start center\">\r\n                        <md-icon\r\n                            ng-if=\"!node.children && node.gallery_type == 0\"\r\n                            md-font-icon=\"icon-folder\"\r\n                            class=\"s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon\r\n                            ng-if=\"!node.children && node.gallery_type == 1\"\r\n                            md-font-icon=\"icon-folder-image\"\r\n                            class=\"s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon\r\n                            ng-if=\"!node.children && node.gallery_type == 2\"\r\n                            md-font-icon=\"qiu-icon-video-folder\"\r\n                            class=\"s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon\r\n                            ng-if=\"!node.children && node.gallery_type == 3\"\r\n                            md-font-icon=\"qiu-icon-audio-folder\"\r\n                            class=\"s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon\r\n                            ng-if=\"!node.children && node.gallery_type == 4\" \r\n                            md-font-icon=\"qiu-icon-file-folder\"\r\n                            class=\"s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon\r\n                            ng-if=\"node.children && node.gallery_type == 0\"\r\n                            md-font-icon=\"icon-folder-multiple\"\r\n                            class=\"s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon\r\n                            ng-if=\"node.children && node.gallery_type == 1\"\r\n                            md-font-icon=\"icon-folder-multiple-image\"\r\n                            class=\"s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon\r\n                            ng-if=\"node.children && node.gallery_type == 2\"\r\n                            md-font-icon=\"qiu-icon-video-gallery\"\r\n                            class=\"s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon\r\n                            ng-if=\"node.children && node.gallery_type == 3\"\r\n                            md-font-icon=\"qiu-icon-audio-gallery\"\r\n                            class=\"s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon\r\n                            ng-if=\"node.children && node.gallery_type == 4\"\r\n                            md-font-icon=\"qiu-icon-file-gallery\"\r\n                            class=\"s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <div class=\"group-status green-bg\" ng-if=\"node.status ===1\" role=\"button\" aria-label=\"group-status\"></div>\r\n                        <span class=\"ivh-treeview-node-label ng-binding\">{{node.gallery_name}}</span>\r\n                        \r\n\r\n                    </div>\r\n                    <div layout=\"row\" layout-align=\"end center\">\r\n                        <!--\r\n                        <md-button qiu-on-click-open-gallery-edit-dialog class=\"md-icon-button\" type=\"button\" aria-label=\"ACTIONS\">\r\n                            <md-icon md-font-icon=\"icon-pencil\" aria-hidden=\"true\"></md-icon>\r\n                        </md-button>\r\n                        -->\r\n                        <md-icon qiu-on-click-close-sidenav sidenav-id=\"galleries-sidenav\" md-font-icon=\"icon-chevron-right\" aria-hidden=\"true\" hide-gt-sm class=\"mt-0 mb-0\"></md-icon>\r\n                    </div>\r\n                </div>\r\n                <div ivh-treeview-children></div>\n</script></div></div></md-content>");
$templateCache.put("app/main/dialogs/media/views/template-grid.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"space-between center\" flex><div \nlayout=\"column\" layout-align=\"start center\"><md-checkbox class=\"no-label\" ng-checked=\"vm.isChecked(mail)\" \nng-click=\"vm.toggleCheck(mail, $event)\" aria-label=\"{{vm.isChecked(mail)? \'Uncheck\':\'check\'}}\"></md-checkbox><div \nng-if=\"refcolumnsgrouped.main\"><div class=\"subject text-truncate\"><span \nng-repeat=\"field in refcolumnsgrouped.header | orderBy: \'list-sort\'\" ng-bind=\"thread.{{field.titleId}}\"></span></div>\n</div></div><div layout=\"column\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-attachment\" \nclass=\"has-attachment s24\" ng-if=\"thread.Thumbnail.length>0\"></md-icon><button ng-if=\"thread.onoff===1\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\"></md-icon></button> \n<button ng-if=\"thread.onoff!==1\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-blank-circle-outline\" \nclass=\"off red-fg s24\"></md-icon></button></div></div><div class=\"media\" flex layout=\"row\" \nlayout-align=\"center center\"><img class=\"image\" ng-src=\"{{card.Thumbnail[0].crop_status[0].urlformed}}\" \nalt=\"{{card.media.image.alt}}\" imageonloadcontrol></div><div class=\"header p-16\" layout=\"row\" layout-align=\"start\"><div\n class=\"info\"><div ng-if=\"refcolumnsgrouped.main\"><div class=\"name text-truncate\" layout=\"row\" \nlayout-align=\"start center\"><span ng-repeat=\"field in refcolumnsgrouped.main\"><span ng-bind=\"thread.{{field.titleId}}\">\n</span>&nbsp;</span></div></div><div ng-repeat=\"field in refcolumnsgrouped.secondary | orderBy:\'list_sort\'\"><div \nng-if=\"(field.type!==\'date\' && field.type!==\'dateHm\') && field.primary!==1\" class=\"details\" layout=\"row\" \nlayout-align=\"start start\"><div layout=\"column\"><span class=\"title\" ng-bind=\"field.title\"></span></div><div \nlayout=\"column\" class=\"text-truncate\"><span class=\"detail\" ng-bind=\"thread.{{field.titleId}}\"></span></div></div></div>\n</div></div></div>");
$templateCache.put("app/main/dialogs/media/views/tiny-attached.html","<div class=\"content-wrapper\" flex layout=\"row\"><div class=\"mail-tabs-grid\" flex \nmd-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"content mail-list-pane-grid\" flex><div \nng-repeat=\"item in vm.selectedContacts\" class=\"ms-card\" flex><div class=\"ms-card-content-wrapper\" \nng-if=\"item.media_type == 1\"><div class=\"template-9\"><div class=\"media\" flex layout=\"row\" layout-align=\"center center\">\n<media attachment=\"item\" class=\"\"></media></div><div class=\"header p-16\" flex><div layout=\"row\" \nlayout-align=\"space-between center\" flex><div class=\"size block\" layout=\"row\" layout-align=\"start left\" flex><strong \nclass=\"mb-5 block\">#{{item.id_media}}</strong> <span class=\"grey-500-fg\"><span ng-if=\"item.filename\" \nclass=\"word-break-all\">{{item.filename}}</span></span></div><button ng-click=\"vm.selectMediaTiny(item)\" \nclass=\"send-button md-fab md-mini md-accent md-raised md-button\" aria-label=\"Select\"><md-icon \nmd-font-icon=\"icon-check\" aria-hidden=\"true\"></md-icon><md-tooltip md-direction=\"top\" hide show-gt-xs><span \ntranslate=\"CONTENT.SELECT\">SELECT</span></md-tooltip></button></div></div></div></div><div \nclass=\"ms-card-content-wrapper\" ng-if=\"item.media_type == 2\"><div class=\"template-9\"><div class=\"media\" flex \nlayout=\"row\" layout-align=\"center center\"><img ng-src=\"{{item.embed_thumb}}\" class=\"image\"><div \nclass=\"fotorama__video-play\" style=\"opacity:1\" role=\"button\"></div></div><div class=\"header p-16\" flex><div \nlayout=\"row\" layout-align=\"space-between center\" flex><div class=\"size block\" layout=\"row\" layout-align=\"start left\" \nflex><strong class=\"mb-5 block\">#{{item.id_media}}</strong> <span class=\"grey-500-fg\"><span ng-if=\"item.filename\" \nclass=\"word-break-all\">{{item.filename}}</span> <span ng-if=\"item.title\" class=\"word-break-all\">{{item.title}}</span>\n</span></div><button ng-click=\"vm.selectMediaTiny(item)\" \nclass=\"send-button md-fab md-mini md-accent md-raised md-button\" aria-label=\"Select\"><md-icon \nmd-font-icon=\"icon-check\" aria-hidden=\"true\"></md-icon><md-tooltip md-direction=\"top\" hide show-gt-xs><span \ntranslate=\"CONTENT.SELECT\">SELECT</span></md-tooltip></button></div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/dialogs/media/views/tiny-properties.html","<div class=\"ontent-wrapper\" flex=\"\" layout=\"column\"><div class=\"content\"><div class=\"ms-card\" flex><div \nclass=\"ms-card-content-wrapper\"><div class=\"template-9\"><div class=\"media\" flex layout=\"row\" \nlayout-align=\"center center\" ng-if=\"vm.selectedMediaTiny.media_type == 1\"><media attachment=\"vm.selectedMediaTiny\" \nclass=\"\"></media></div><div class=\"media\" flex layout=\"row\" layout-align=\"center center\" \nng-if=\"vm.selectedMediaTiny.media_type == 2\"><img ng-src=\"{{vm.selectedMediaTiny.embed_thumb}}\" class=\"image\"><div \nclass=\"fotorama__video-play\" style=\"opacity:1\" role=\"button\"></div></div><div class=\"header p-16\" flex><div \nlayout=\"row\" layout-align=\"space-between center\" flex><div class=\"size block\" layout=\"row\" layout-align=\"start left\" \nflex><strong class=\"mb-5 block\">#{{vm.selectedMediaTiny.id_media}}</strong> <span class=\"grey-500-fg\" \nng-if=\"vm.selectedMediaTiny.title && !vm.selectedMediaTiny.filename\"><span class=\"word-break-all\">\n{{vm.selectedMediaTiny.title}}</span> </span><span class=\"grey-500-fg\" \nng-if=\"vm.selectedMediaTiny.filename && !vm.selectedMediaTiny.title\"><span class=\"word-break-all\">\n{{vm.selectedMediaTiny.filename}}</span></span></div></div></div></div></div></div><div class=\"sections white-box\"><div\n class=\"section\"><md-input-container class=\"md-block\" flex><label translate=\"CONTENT.ALIGN\" \ntranslate-attr-aria-label=\"CONTENT.ALIGN\">Align:</label><md-select ng-model=\"vm.tinyProperties.align\" \nplaceholder=\"Align\"><md-option value=\"\">---</md-option><md-option ng-repeat=\"opt in vm.tinyOptions.align\" \nvalue=\"{{opt.value}}\">{{opt.text}}</md-option></md-select><div class=\"md-errors-spacer\"></div></md-input-container>\n<md-input-container class=\"md-block\" flex><label translate=\"CONTENT.SIZE\" translate-attr-aria-label=\"CONTENT.SIZE\">\nSize:</label><md-select ng-model=\"vm.tinyProperties.size\" placeholder=\"Size\"><md-option value=\"\">---</md-option>\n<md-option ng-repeat=\"opt in vm.tinyOptions.size\" value=\"{{opt.value}}\">{{opt.text}}</md-option></md-select><div \nclass=\"md-errors-spacer\"></div></md-input-container></div></div></div></div>");
$templateCache.put("app/main/dialogs/media/views/upload-view.html","<div class=\"content-wrapper full-height\" layout=\"row\" layout-gt-sm=\"column\"><div class=\"content full-height\" \nstyle=\"width: 100%\"><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"center start\" class=\"full-height\"><div \nlayout=\"row\" layout-gt-sm=\"column\" flex-gt-sm=\"50\" flex=\"100\" class=\"m-8 full-width\"><div ngf-drop ngf-select \nng-model=\"vm.files\" class=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"!vm.isReplace\" \nngf-allow-dir=\"!vm.isReplace\" accept=\"{{vm.allowedFilesPattern}}\" ngf-pattern=\"vm.allowedFilesPattern\"><div \nlayout=\"column\"><div flex translate=\"MEDIA.DROP_HERE\" hide show-gt-sm></div><div flex translate=\"MEDIA.DROP_OR\" hide \nshow-gt-sm></div><div flex><md-button class=\"send-button md-accent md-raised\" aria-label=\"Select files\" \ntranslate=\"MEDIA.SELECT_FILES\"></md-button></div></div></div><div class=\"uploading-list\"><div \nng-if=\"vm.uploadFiles.length <= 5\"><div ng-repeat=\"f in vm.uploadFiles\" class=\"ms-card upload-view\" flex \nng-class=\"{\'opacity-6\':f.progress <100 || !f.progress || !f.processed}\"><div class=\"ms-card-content-wrapper\"><div \nclass=\"template-9\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" layout=\"column\" layout-align=\"start stretch\">\n<div class=\"media upload\" layout=\"row\" layout-align=\"center center\" ng-if=\"vm.uploadFiles.length < 15\"><img \nstyle=\"z-index: 1; position: absolute\" ng-if=\"!f.$error && f && !vm.isImage(f)\" src=\"assets/images/common/file.jpg\" \nclass=\"image\"> <img style=\"z-index: 2\" ngf-src=\"!f.$error && f\" class=\"image\"><video style=\"z-index: 3\" \nng-if=\"vm.isVideo(f)\" controls ngf-src=\"!f.$error && f\" class=\"video\"></video></div><div layout=\"column\" \nlayout-align=\"center center\" layout-align-gt-xs=\"center start\" flex><div class=\"header p-16\" \nstyle=\"margin-top: auto;margin-bottom: auto\"><div layout=\"row\" layout-align=\"space-between center\" flex><div \nclass=\"size\" layout=\"row\" layout-align=\"start left\"><strong class=\"mr-5\" ng-if=\"f.id\">#{{f.id}}</strong> <strong \nclass=\"grey-500-fg word-break-all\" ng-if=\"f.name\">{{f.name}}</strong></div></div><span class=\"grey-500-fg\" \nng-if=\"f.$error || f.$errorParam\"><span class=\"word-break-all\">{{f.$error}} / {{f.$errorParam}}</span></span></div>\n</div><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"green-fg s32 mh-20\" role=\"img\" \naria-label=\"icon-checkbox-marked-circle\" ng-show=\"f.progress == 100 && f.processed\"></md-icon><md-button \nclass=\"md-icon-button delete\" ng-click=\"vm.deleteFromUpload(f)\" aria-label=\"Delete media\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button><div style=\"z-index: 4\" flex layout=\"column\" \nlayout-align=\"center center\" class=\"loading-container\" ng-show=\"f.progress <100 || !f.progress || !f.processed\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div></div><md-progress-linear \nclass=\"md-accent\" md-mode=\"determinate\" value=\"{{(f.progress && f.progress> 5) ? f.progress : 5}}\" \nng-show=\"f.progress <100 || !f.progress || !f.processed\"></md-progress-linear></div></div></div><div \nng-if=\"vm.uploadFiles.length > 5\"><div class=\"large-upload-list\"><p class=\"uploading-items-text\">\nUploading {{vm.uploadFiles.length}} files</p><div ng-show=\"!vm.showLargeUploadList\" \nng-repeat=\"f in vm.uploadFiles | limitTo : 5\" class=\"ms-card upload-view\" flex \nng-class=\"{\'opacity-6\':f.progress <100 || !f.progress || !f.processed}\"><div class=\"ms-card-content-wrapper\"><div \nclass=\"template-9\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" layout=\"column\" layout-align=\"start stretch\">\n<div class=\"media upload\" layout=\"row\" layout-align=\"center center\" ng-if=\"vm.uploadFiles.length < 15\"><img \nstyle=\"z-index: 1; position: absolute\" ng-if=\"!f.$error && f && !vm.isImage(f)\" src=\"assets/images/common/file.jpg\" \nclass=\"image\"> <img style=\"z-index: 2\" ngf-src=\"!f.$error && f\" class=\"image\"><video style=\"z-index: 3\" \nng-if=\"vm.isVideo(f)\" controls ngf-src=\"!f.$error && f\" class=\"video\"></video><div style=\"z-index: 4\" flex \nlayout=\"column\" layout-align=\"center center\" class=\"loading-container\" \nng-show=\"f.progress <100 || !f.progress || !f.processed\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"50\"></md-progress-circular></div></div><div layout=\"column\" layout-align=\"center center\" \nlayout-align-gt-xs=\"center start\" flex><div class=\"header p-16\" style=\"margin-top: auto;margin-bottom: auto\"><div \nlayout=\"row\" layout-align=\"space-between center\" flex><div class=\"size\" layout=\"row\" layout-align=\"start left\"><strong \nclass=\"mr-5\" ng-if=\"f.id\">#{{f.id}}</strong> <strong class=\"grey-500-fg word-break-all\" ng-if=\"f.name\">{{f.name}}\n</strong></div></div><span class=\"grey-500-fg\" ng-if=\"f.$error || f.$errorParam\"><span class=\"word-break-all\">\n{{f.$error}} / {{f.$errorParam}}</span></span></div></div><md-icon md-font-icon=\"icon-checkbox-marked-circle\" \nclass=\"green-fg s32 mh-20\" role=\"img\" aria-label=\"icon-checkbox-marked-circle\" \nng-show=\"f.progress == 100 && f.processed\"></md-icon><md-icon md-font-icon=\"icon-timer-sand\" class=\"grey-fg s32 mh-20\" \nrole=\"img\" aria-label=\"icon-timer-sand\" ng-show=\"f.progress <100 || !f.progress || !f.processed\"></md-icon><md-button \nclass=\"md-icon-button delete\" ng-click=\"vm.deleteFromUpload(f)\" aria-label=\"Delete media\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><md-progress-linear class=\"md-accent\" md-mode=\"determinate\" \nvalue=\"{{(f.progress && f.progress> 5) ? f.progress : 5}}\" ng-show=\"!f.progress || f.progress <100\">\n</md-progress-linear></div></div><md-button ng-show=\"!vm.showLargeUploadList\" ng-click=\"vm.loadLargeUploadList()\" \nclass=\"look-files md-accent md-raised\" translate=\"MEDIA.EXPAND_UPLOAD_LIST\"></md-button><div \nng-show=\"vm.showLargeUploadList\" ng-repeat=\"f in vm.uploadFiles\" class=\"ms-card upload-view\" flex \nng-class=\"{\'opacity-6\':f.progress <100 || !f.progress || !f.processed}\"><div class=\"ms-card-content-wrapper\"><div \nclass=\"template-9\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" layout=\"column\" layout-align=\"start stretch\">\n<div class=\"media upload\" layout=\"row\" layout-align=\"center center\" ng-if=\"vm.uploadFiles.length < 15\"><img \nstyle=\"z-index: 1; position: absolute\" ng-if=\"!f.$error && f && !vm.isImage(f)\" src=\"assets/images/common/file.jpg\" \nclass=\"image\"> <img style=\"z-index: 2\" ngf-src=\"!f.$error && f\" class=\"image\"><video style=\"z-index: 3\" \nng-if=\"vm.isVideo(f)\" controls ngf-src=\"!f.$error && f\" class=\"video\"></video><div style=\"z-index: 4\" flex \nlayout=\"column\" layout-align=\"center center\" class=\"loading-container\" \nng-show=\"f.progress <100 || !f.progress || !f.processed\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"50\"></md-progress-circular></div></div><div layout=\"column\" layout-align=\"center center\" \nlayout-align-gt-xs=\"center start\" flex><div class=\"header p-16\" style=\"margin-top: auto;margin-bottom: auto\"><div \nlayout=\"row\" layout-align=\"space-between center\" flex><div class=\"size\" layout=\"row\" layout-align=\"start left\"><strong \nclass=\"mr-5\" ng-if=\"f.id\">#{{f.id}}</strong> <strong class=\"grey-500-fg word-break-all\" ng-if=\"f.name\">{{f.name}}\n</strong></div></div><span class=\"grey-500-fg\" ng-if=\"f.$error || f.$errorParam\"><span class=\"word-break-all\">\n{{f.$error}} / {{f.$errorParam}}</span></span></div></div><md-icon md-font-icon=\"icon-checkbox-marked-circle\" \nclass=\"green-fg s32 mh-20\" role=\"img\" aria-label=\"icon-checkbox-marked-circle\" \nng-show=\"f.progress == 100 && f.processed\"></md-icon><md-icon md-font-icon=\"icon-timer-sand\" class=\"grey-fg s32 mh-20\" \nrole=\"img\" aria-label=\"icon-timer-sand\" ng-show=\"f.progress <100 || !f.progress || !f.processed\"></md-icon><md-button \nclass=\"md-icon-button delete\" ng-click=\"vm.deleteFromUpload(f)\" aria-label=\"Delete media\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><md-progress-linear class=\"md-accent\" md-mode=\"determinate\" \nvalue=\"{{(f.progress && f.progress> 5) ? f.progress : 5}}\" ng-show=\"!f.progress || f.progress <100\">\n</md-progress-linear></div></div><md-button ng-show=\"vm.showLargeUploadList\" ng-click=\"vm.loadLargeUploadList()\" \nclass=\"look-files md-accent md-raised\" translate=\"MEDIA.UNEXPAND_UPLOAD_LIST\"></md-button></div></div></div></div><div \nng-if=\"!vm.isReplace\" layout-gt-sm=\"column\" flex-gt-sm=\"50\" flex=\"100\" class=\"p-0 m-8 full-width media-folders\" \nlayout-padding><div class=\"white-box\"><md-tabs md-dynamic-height md-border-bottom><md-tab \nlabel=\"{{vm.translate(\'MEDIA.ADDTOGALLERIES\')}}\"><div \nng-include=\"\'app/main/apps/media/dialogs/add-media-galleries/views/add-media-galleries.html\'\"></div></md-tab><md-tab \nng-if=\"vm.tagsTabSettings\" label=\"{{vm.translate(\'MEDIA.TAGS\')}}\"><div \nng-include=\"\'app/main/dialogs/media/views/set-tags.html\'\"></div></md-tab><md-tab \nlabel=\"{{vm.translate(\'MEDIA.EDITMULTIPLEFIELDS\')}}\"><div \nng-include=\"\'app/main/apps/media/dialogs/edit-multiple-fields/views/set-geolocation.html\'\"></div></md-tab></md-tabs>\n</div></div></div></div></div>");
$templateCache.put("app/main/dialogs/media/views/videos-view.html","<div class=\"content-wrapper full-height\" flex layout=\"row\"><div class=\"mail-tabs-grid\" flex><div \nclass=\"content mail-list-pane-grid\" flex><div ng-repeat=\"item in vm.items\" class=\"ms-card\" flex><div \nclass=\"ms-card-content-wrapper\"><div class=\"template-9\"><div class=\"media\" flex layout=\"row\" \nlayout-align=\"center center\"><media attachment=\"item\" thumbnail=\"true\" class=\"\"></media></div><div class=\"header p-16\" \nflex><div layout=\"row\" layout-align=\"space-between start\" flex><div class=\"size block pr-10\" layout=\"row\" \nlayout-align=\"start left\" flex><strong class=\"block mb-5\">#{{item.id_media}} <span ng-if=\"item.duration\" class=\"ml-5\">\n<md-icon md-font-icon=\"icon-clock\" class=\"s16 text-right md-accent\" aria-hidden=\"true\"></md-icon>\n{{(item.duration*1000) | amDateFormat:\'mm:ss\'}} </span></strong><span class=\"grey-500-fg\"><span ng-if=\"item.filename\" \nclass=\"word-break-all\">{{item.filename}}</span> <span ng-if=\"item.title\" class=\"word-break-all\">{{item.title}}</span>\n</span></div><md-checkbox ng-checked=\"vm.alreadySelectedbyZone(vm.selectedContacts, item)\" \nng-click=\"vm.toggleSelectContact(item, $event)\" ng-if=\"vm.maxAttach > 1\" \naria-label=\"{{vm.alreadySelectedbyZone(vm.selectedContacts, item) ? \'Deselect\' : \'Select\'}}\"></md-checkbox><md-button \nng-click=\"vm.toggleSelectOne(item, $event)\" class=\"send-button md-accent md-raised\" aria-label=\"Attach\" \nng-if=\"vm.maxAttach == 1\" translate=\"MEDIA.SELECT\" translate-attr-aria-label=\"MEDIA.SELECT\"></md-button></div>\n<md-tooltip md-direction=\"top\" hide show-gt-xs ng-if=\"item.title && !item.filename\"><span>{{item.title}}</span>\n</md-tooltip><md-tooltip md-direction=\"top\" hide show-gt-xs ng-if=\"item.filename && !item.title\"><span>\n{{item.filename}}</span></md-tooltip></div></div></div></div></div></div></div>");
$templateCache.put("app/main/dialogs/media-focal-point/views/edit-media-view.html","<img ng-src=\"{{vm.image.imageUrl}}\" src=\"{{vm.image.imageUrl}}\" alt=\"\" focus-point x=\"{{vm.image.imageCenterRatioX}}\" \ny=\"{{vm.image.imageCenterRatioY}}\" data-method=\"vm.ctrlFn\">");
$templateCache.put("app/main/dialogs/media-show/views/fotorama-view-with-tags.html","<div class=\"content-wrapper\" flex layout=\"row\"><div class=\"mail-tabs-grid\" flex \nmd-dynamic-height=\"{{vm.dynamicHeight}}\"><div id=\"tags-to-show\"><p ng-repeat=\"tag in vm.tagsToShow\">{{tag}}</p></div>\n<div id=\"tags-to-edit\" ng-if=\"vm.showTagsEdit\"><div flex=\"100\" class=\"tags\"><md-input-container \nclass=\"md-block tags-to-edit-container\"><label translate=\"GLOBAL.SEARCH_FOR_TAG\">Tags</label><md-chips \nclass=\"label-chips close-chip\" ng-model=\"vm.currentItem.tags\" md-autocomplete-snap md-require-match=\"true\">\n<md-autocomplete md-min-length=\"1\" md-selected-item=\"vm.selectedTag\" md-selected-item-change=\"vm.selectedItemChange()\" \nmd-search-text=\"vm.searchTagText\" md-items=\"tag in vm.labelQuerySearch(vm.searchTagText) | orderBy:\'-order\'\" \nmd-item-text=\"tag.tag_name\" md-no-cache=\"true\" placeholder=\"{{vm.translate(\'GLOBAL.SEARCH_FOR_TAG\')}}\" \nng-model-options=\"{debounce: 500}\" md-dropdown-items=\"10\"><div layout=\"row\" layout-align=\"space-between center\" \nflex=\"100\" class=\"tag-not-found-bg border-bottom\"><span ng-if=\"!tag.tag_name\">{{vm.searchTagText}}</span> <span \nmd-highlight-text=\"vm.searchTagText\" ng-if=\"tag.tag_name\">{{tag.tag_name}}</span></div></md-autocomplete>\n<md-chip-template><div class=\"md-chip-content\"><span ng-if=\"$chip.color\" class=\"color\" \nng-style=\"{\'background-color\':$chip.color}\"></span> <span>{{$chip.tag_name}} #{{$chip.id_tag}}</span></div>\n</md-chip-template><button md-chip-remove class=\"md-primary\" layout=\"row\" layout-align=\"center center\" \nng-click=\"vm.removeTag(vm.currentItem, $chip, $event)\"><md-icon md-font-icon=\"icon-close\"></md-icon></button>\n</md-chips></md-input-container></div></div><fotorama options=\"vm.fotoramaoptions\" items=\"vm.dataFotorama\" \nid=\"fotorama\" class=\"fotorama\"></fotorama></div></div>");
$templateCache.put("app/main/dialogs/media-show/views/fotorama-view.html","<div class=\"content-wrapper\" flex layout=\"row\"><div class=\"mail-tabs-grid\" flex \nmd-dynamic-height=\"{{vm.dynamicHeight}}\"><fotorama options=\"vm.fotoramaoptions\" items=\"vm.dataFotorama\" id=\"fotorama\">\n</fotorama></div></div>");
$templateCache.put("app/main/dialogs/media-item-metadata/views/media-item-metadata-view-form.html","<div class=\"content-wrapper\"><div class=\"content\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div \nflex-gt-xs=\"33\" flex-sm=\"100\" flex=\"100\" class=\"white-box sections\"><div class=\"section\" layout=\"column\" \nlayout-sm=\"row\"><div flex-gt-sm=\"100\" flex=\"50\"><md-input-container class=\"mt-0 md-block\" flex><img \nng-src=\"{{vm.image.imageUrl}}\" src=\"{{vm.image.imageUrl}}\" alt=\"\"><div class=\"md-errors-spacer\"></div>\n</md-input-container></div><div flex-gt-sm=\"100\" flex=\"50\"><md-input-container class=\"md-block\" flex><label \ntranslate=\"CONTENT.ID\">ID</label><input ng-model=\"vm.image.id_media\" type=\"text\" readonly=\"readonly\">\n</md-input-container><md-input-container class=\"md-block\" flex><label translate=\"CONTENT.FILENAME\">Filename</label>\n<textarea ng-model=\"vm.image.filename\" readonly=\"readonly\" columns=\"1\" rows=\"1\"></textarea></md-input-container>\n<md-input-container class=\"md-block\" flex ng-if=\"vm.image.size\"><label translate=\"MEDIA.DIMENSIONS\">Dimensions</label>\n<input ng-model=\"vm.image.size\" type=\"text\" readonly=\"readonly\"></md-input-container><md-input-container \nclass=\"md-block\" flex ng-if=\"vm.image.filesizekb\"><label translate=\"MEDIA.SIZE_KB\">File Size (Kb)</label><textarea \nng-model=\"vm.image.filesizekb\" readonly=\"readonly\" columns=\"1\" rows=\"1\"></textarea></md-input-container></div></div>\n</div><div flex-gt-xs=\"66\" flex-sm=\"100\" flex=\"100\" class=\"white-box sections\"><div class=\"section\"><div \nclass=\"section-header\" layout=\"row\" layout-align=\"start center\"><span class=\"section-title\">Main Info</span></div>\n<md-input-container class=\"md-block\"><label translate=\"CONTENT.TITLE\">Title</label><textarea ng-model=\"vm.image.title\" \ncolumns=\"1\" rows=\"1\"></textarea></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"CONTENT.PHOTOGRAPHER\">Photographer</label><input ng-model=\"vm.image.photographer\" type=\"text\">\n</md-input-container><md-input-container class=\"md-block\"><label translate=\"CONTENT.OWNER\">Owner</label><input \nng-model=\"vm.image.owner\" type=\"text\"></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"CONTENT.CAPTION\">Caption</label><textarea ng-model=\"vm.image.caption\" columns=\"1\" rows=\"1\"></textarea>\n</md-input-container><md-input-container class=\"md-block\"><label translate=\"CONTENT.CITY\">City</label><input \nng-model=\"vm.image.city\" type=\"text\"></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"CONTENT.COUNTRY\">Country</label><input ng-model=\"vm.image.country\" type=\"text\"></md-input-container><div \nclass=\"tags section\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><span class=\"section-title\" \ntranslate=\"GLOBAL.TAGS\"></span></div><md-input-container class=\"md-block\"><label translate=\"GLOBAL.SEARCH_FOR_TAG\">Tags\n</label><md-chips class=\"label-chips\" ng-model=\"vm.image.tags\" md-autocomplete-snap md-require-match=\"true\">\n<md-autocomplete md-min-length=\"3\" md-selected-item=\"vm.selectedTag\" md-selected-item-change=\"vm.selectedItemChange()\" \nmd-search-text=\"vm.searchTagText\" md-items=\"tag in vm.labelQuerySearch(vm.searchTagText) | orderBy:\'-order\'\" \nmd-item-text=\"tag.tag_name\" md-no-cache=\"true\" placeholder=\"{{vm.translate(\'GLOBAL.SEARCH_FOR_TAG\')}}\" \nng-model-options=\"{debounce: 500}\" class=\"md-input\" md-dropdown-items=\"10\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"100\" class=\"tag-not-found-bg border-bottom\"><span ng-if=\"!tag.tag_name\">\n{{vm.searchTagText}}</span> <span md-highlight-text=\"vm.searchTagText\" ng-if=\"tag.tag_name\">{{tag.tag_name}}</span>\n<md-buttton ng-if=\"!tag.tag_name\" ng-click=\"vm.newTag(vm.searchTagText)\" \nclass=\"md-accent green-500-bg white-fg md-button m-0\"><span translate=\"CONTENT.TAGADD\"></span></md-buttton></div>\n<md-not-found><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\" class=\"tag-not-found-bg\"><span>\n{{vm.searchTagText}}</span><md-buttton ng-click=\"vm.newTag(vm.searchTagText)\" \nclass=\"md-accent green-500-bg white-fg md-button m-0\"><span translate=\"CONTENT.TAGADD\"></span></md-buttton></div>\n</md-not-found></md-autocomplete><md-chip-template><div class=\"md-chip-content\"><span ng-if=\"$chip.color\" \nclass=\"color\" ng-style=\"{\'background-color\':$chip.color}\"></span> <span>{{$chip.tag_name}} #{{$chip.id_tag}}</span>\n</div></md-chip-template><button md-chip-remove class=\"md-primary md-chip-remove\" layout=\"row\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-close\" class=\"s18\"></md-icon></button></md-chips>\n</md-input-container></div><div ng-if=\"!vm.allFields\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-accent\" ng-click=\"vm.allFields = true\" translate=\"CONTENT.SHOW_ALL_FIELDS\">Show All Fields</md-button></div>\n</div><div ng-if=\"vm.allFields\"><div class=\"date-time-picker section\"><div class=\"section-header\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"section-title\">File date</span></div><div layout=\"row\" layout-gt-sm=\"row\"><div\n flex class=\"date-container\"><mdp-date-picker mdp-placeholder=\"Date\" mdp-format=\"{{vm.dateFormat}}\" \nmdp-open-on-click=\"true\" ng-model=\"vm.image.file_date.date\" ng-change=\"vm.updateDatePicker(\'file_date\')\">\n</mdp-date-picker></div><div flex class=\"date-container\"><mdp-time-picker mdp-placeholder=\"Time\" \nmdp-auto-switch=\"true\" mdp-open-on-click=\"true\" ng-model=\"vm.image.file_date.date\" \nng-change=\"vm.updateDatePicker(\'file_date\')\"></mdp-time-picker></div><div flex class=\"date-container\">\n<md-input-container class=\"md-block\"><label>UTC Date</label><input type=\"text\" ng-model=\"vm.image.file_date.utcShow\" \ndisabled=\"disabled\"></md-input-container></div></div></div><div class=\"date-time-picker section\"><div \nclass=\"section-header\" layout=\"row\" layout-align=\"start center\"><span class=\"section-title\">Date uploaded</span></div>\n<div layout=\"row\" layout-gt-sm=\"row\"><div flex class=\"date-container\"><mdp-date-picker mdp-placeholder=\"Date\" \nmdp-format=\"{{vm.dateFormat}}\" mdp-open-on-click=\"true\" ng-model=\"vm.image.date_uploaded.date\" \nng-change=\"vm.updateDatePicker(\'date_uploaded\')\"></mdp-date-picker></div><div flex class=\"date-container\">\n<mdp-time-picker mdp-placeholder=\"Time\" mdp-auto-switch=\"true\" mdp-open-on-click=\"true\" \nng-model=\"vm.image.date_uploaded.date\" ng-change=\"vm.updateDatePicker(\'date_uploaded\')\"></mdp-time-picker></div><div \nflex class=\"date-container\"><md-input-container class=\"md-block\"><label>UTC Date</label><input type=\"text\" \nng-model=\"vm.image.date_uploaded.utcShow\" disabled=\"disabled\"></md-input-container></div></div></div><div \nclass=\"geoloc section\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"section-title\" translate=\"CONTENT.GEOLOCALIZATION\">Geolocation</span></div><div layout=\"row\" layout-gt-sm=\"row\">\n<md-input-container class=\"md-block\" flex><label translate=\"CONTENT.GEOLAT\">ID</label><input \nng-model=\"vm.image.geoLat\" type=\"text\"></md-input-container><md-input-container class=\"md-block\" flex><label \ntranslate=\"CONTENT.GEOLON\">ID</label><input ng-model=\"vm.image.geoLon\" type=\"text\"></md-input-container></div></div>\n<md-input-container class=\"md-block\"><label translate=\"CONTENT.USE\">Use</label><input ng-model=\"vm.image.uses\" \ntype=\"text\"></md-input-container><md-input-container class=\"md-block\" ng-hide=\"vm.image.media_type == 2\"><label \ntranslate=\"CONTENT.EXTRAS\">Extras</label><input ng-model=\"vm.image.extra\" type=\"text\"></md-input-container><div \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-accent\" ng-click=\"vm.allFields = false\" \ntranslate=\"CONTENT.FEWER_FIELDS\">Fewer Fields</md-button></div></div></div></div></div></div>");
$templateCache.put("app/main/plugins/template-builder/fields/button.html","<table class=\"main\" width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" border=\"0\" bgcolor=\"#FFFFFF\" align=\"center\" \nstyle=\"display: table; background-color: {{element.options.backgroundColor}}\" data-type=\"button\"><tbody><tr><td \nclass=\"buttons-full-width\"><table cellspacing=\"0\" cellpadding=\"0\" border=\"0\" align=\"center\" width=\"100%\" \nstyle=\"text-align: {{ element.options.align }}\"><tbody><tr><td \nstyle=\"padding: {{element.options.margin | arrToPadding}}\"><a \nstyle=\"background-color: {{element.options.buttonBackgroundColor}};color: {{element.options.font.color}};font-family: {{element.options.font.family}};font-size: {{element.options.font.size}}px;line-height:19px;display: {{element.options.fullWidth ? \'block\' : \'inline-block\'}};border-radius: {{element.options.border.radius}}px;border: {{element.options.border.size}}px  {{element.options.border.style}}  {{element.options.border.color}};text-align: center;text-decoration: none;font-weight:  {{element.options.font.weight}};margin: 0; width: auto; padding: {{element.options.padding | arrToPadding}}\" \nclass=\"button-1\" href=\"{{ element.options.url }}\" data-default=\"1\">{{ element.options.buttonText }}</a>\n<!--[if mso]>             </center>           </v:roundrect>         <![endif]--></td></tr></tbody></table></td></tr>\n</tbody></table>");
$templateCache.put("app/main/plugins/template-builder/fields/code.html","<table class=\"main\" width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" border=\"0\" \nstyle=\"display: table; background-color: {{element.options.backgroundColor}}\" align=\"center\" data-type=\"code\"><tbody>\n<tr><td data-block-id=\"background\" ng-bind-html=\"sanitizeMe(element.options.code)\" \nstyle=\"padding:{{element.options.padding | arrToPadding}}\"></td></tr></tbody></table>");
$templateCache.put("app/main/plugins/template-builder/fields/divider.html","<table class=\"main\" width=\"100%\" \nstyle=\"border: 0; display: table; background-color: {{element.options.backgroundColor}}\" cellspacing=\"0\" \ncellpadding=\"0\" border=\"0\" align=\"center\" data-type=\"divider\"><tbody><tr><td class=\"divider-simple\" \nstyle=\"padding: {{ element.options.padding | arrToPadding  }}\"><table width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" \nborder=\"0\" \nstyle=\"border-top: {{element.options.border.size}}px {{element.options.border.style}} {{element.options.border.color}}\">\n<tbody><tr><td width=\"100%\"></td></tr></tbody></table></td></tr></tbody></table>");
$templateCache.put("app/main/plugins/template-builder/fields/footerImage.html","<table width=\"100%\" class=\"main\" cellspacing=\"0\" cellpadding=\"0\" border=\"0\" align=\"center\" \nstyle=\"display: table; background-color: {{element.options.backgroundColor}}\" data-type=\"image\"><tbody><tr><td \nalign=\"{{ element.options.align }}\" style=\"padding: {{ element.options.padding | arrToPadding  }}\" class=\"image\"><img \nimage-with-link link=\"element.options.linkTo\" link-media=\"element.options.imageSingle1\" border=\"0\" \nng-src=\"{{ element.options.imageSingle1.url }}\" width=\"{{ element.options.width }}\" \nstyle=\"max-width: 100%;display: block;margin: 0 auto\"></td></tr></tbody></table>");
$templateCache.put("app/main/plugins/template-builder/fields/footerLegal.html","<table class=\"main\" width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" border=\"0\" \nstyle=\"display: table; background-color: {{element.options.backgroundColor}}\" align=\"center\" data-type=\"text-block\">\n<tbody><tr><td class=\"block-text\" data-block-id=\"background\" data-clonable=\"true\" \nstyle=\"padding:{{element.options.padding | arrToPadding}}; font-size: {{element.options.font.size}}px; color: #000000; line-height: 20px;font-family: {{element.options.font.family}}\">\n<table class=\"main\" width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" border=\"0\" style=\"display: table\"><tbody><tr><td \nalign=\"{{ element.options.align ? element.options.align : \'left\' }}\" style=\"color: {{element.options.font.color}}\" \nui-tinymce=\"vm.tinymceOptions\" ng-model=\"element.options.textAddress\"></td></tr><tr><td \nalign=\"{{ element.options.align ? element.options.align : \'left\' }}\" style=\"color: {{element.options.font.color}}\" \nui-tinymce=\"vm.tinymceOptions\" ng-model=\"element.options.textIntended\"></td></tr></tbody></table><table class=\"main\" \nwidth=\"100%\" cellspacing=\"0\" cellpadding=\"0\" border=\"0\" style=\"display: table\"><tbody><tr><td \nalign=\"{{ element.options.align ? element.options.align : \'left\' }}\" style=\"color: {{element.options.font.color}}\"><a \nhref=\"{{global.unsubscribeLink}}\" ng-bind-html=\"element.options.textUnsubscribe\" \nstyle=\"color: {{element.options.font.color}};font-weight: {{element.options.font.weight ? element.options.font.weight : \'normal\'}};text-decoration:none\">\n</a><span ng-if=\"element.options.textUnsubscribe && element.options.textManage\"> / </span><a \nhref=\"{{global.manageSubscriptionsLink}}\" ng-bind-html=\"element.options.textManage\" \nstyle=\"color: {{element.options.font.color}};font-weight: {{element.options.font.weight ? element.options.font.weight : \'normal\'}};text-decoration:none\">\n</a></td></tr></tbody></table></td></tr></tbody></table>");
$templateCache.put("app/main/plugins/template-builder/fields/header.html","<table width=\"100%\" class=\"main\" cellspacing=\"0\" cellpadding=\"0\" border=\"0\" align=\"center\" \nstyle=\"display: table; background-color: {{element.options.backgroundColor}}\" data-type=\"image\"><tbody><tr><td \nalign=\"{{ element.options.align }}\" style=\"padding: {{ element.options.padding | arrToPadding  }}\" class=\"image\"><img \nimage-with-link link=\"element.options.linkTo\" link-media=\"element.options.imageSingle1\" border=\"0\" \nng-src=\"{{ element.options.imageSingle1.url }}\" width=\"{{ element.options.width }}\" \nstyle=\"max-width: 100%; display: block;margin: 0 auto\"></td></tr></tbody></table>");
$templateCache.put("app/main/plugins/template-builder/fields/image.html","<table width=\"100%\" class=\"main\" cellspacing=\"0\" cellpadding=\"0\" border=\"0\" align=\"center\" \nstyle=\"display: table; background-color: {{element.options.backgroundColor}}\" data-type=\"image\"><tbody><tr><td \nalign=\"{{ element.options.align }}\" \nstyle=\"padding: {{ element.options.padding | arrToPadding  }};text-align:{{ element.options.align }};line-height: 0;font-family: {{element.options.font.family ? element.options.font.family : \'Arial, Helvetica, sans-serif\'}};font-weight: {{element.options.font.weight ? element.options.font.weight : \'normal\'}}\" \nclass=\"image\"><img image-with-link link=\"element.options.linkTo\" link-media=\"element.options.imageSingle1\" border=\"0\" \nng-src=\"{{ element.options.imageSingle1.url }}\" width=\"{{ element.options.width }}\" \nstyle=\"max-width: 100%;display: inline-block;vertical-align:middle\"> <a \nhref=\"#id={{element.options.imageSingle1.id_media}}\" \nng-if=\"element.options.linkTo.text && element.options.linkTo && element.options.linkTo.type != \'none\'\" \nstyle=\"color: {{element.options.color && element.options.color != \'#888888\' ? element.options.color : \'rgb(3,155,229)\'}};padding:{{ element.options.paddingDownload ? element.options.paddingDownload : [\'10px\',\'10px\',\'5px\',\'10px\'] | arrToPadding  }};font-size: 13px;display:block;line-height: 1.4;text-decoration:none\">\n{{element.options.linkTo.text}}</a><figcaption \nng-if=\"element.options.mediaCaption.type != \'none\' && element.options.mediaCaption.type != \'custom\' && element.options.mediaCaption.type != \'link\' && element.options.mediaCaption.type != \'title_photographer\' && element.options.mediaCaption.type != \'caption_photographer\' && element.options.mediaCaption.type != \'caption_owner\'\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 13px;color: {{element.options.color}};line-height: 1.4\">\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle1.fields[element.options.mediaCaption.type] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'caption_photographer\'\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 13px;color: {{element.options.color}};line-height: 1.4\">\n{{ element.options.imageSingle1.fields[\'caption\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle1.fields[\'photographer\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'caption_owner\'\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 13px;color: {{element.options.color}};line-height: 1.4\">\n{{ element.options.imageSingle1.fields[\'caption\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle1.fields[\'owner\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'title_photographer\'\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 13px;color: {{element.options.color}};line-height: 1.4\">\n{{ element.options.imageSingle1.fields[\'title\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle1.fields[\'photographer\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption \nng-if=\"element.options.mediaCaption.type != \'none\' && (element.options.mediaCaption.type == \'custom\' || element.options.mediaCaption.type == \'link\')\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 13px;color: {{element.options.color}};line-height: 1.4\">\n{{ element.options.mediaCaption.prefix }} {{ element.options.mediaCaption.custom_1 }} {{ element.options.mediaCaption.suffix }}\n</figcaption></td></tr></tbody></table>");
$templateCache.put("app/main/plugins/template-builder/fields/imagesX2.html","<table width=\"100%\" class=\"main\" cellspacing=\"0\" cellpadding=\"0\" border=\"0\" \nbgcolor=\"{{element.options.backgroundColor}}\" align=\"center\" data-type=\"imagesX2\"><tbody><tr><td \nalign=\"{{ element.options.align ? element.options.align : \'left\' }}\" valign=\"top\" width=\"100%\" \nstyle=\"font-family: {{element.options.font.family ? element.options.font.family : \'Arial, Helvetica, sans-serif\'}};font-weight: {{element.options.font.weight ? element.options.font.weight : \'normal\'}}\">\n<div style=\"display: flex; padding: {{ element.options.padding | arrToPadding }}\"><div \nstyle=\"width: 50%;padding-bottom: 20px\"><img image-with-link link=\"element.options.linkTo\" \nlink-media=\"element.options.imageSingle1\" border=\"0\" ng-src=\"{{ element.options.imageSingle1.url }}\" width=\"250\" \nstyle=\"padding:0 10px 0px 10px;max-width: 100%;width:100%;display: block;margin: 0 auto\"> <a \nhref=\"#id={{element.options.imageSingle1.id_media}}\" \nng-if=\"element.options.linkTo.text && element.options.linkTo && element.options.linkTo.type != \'none\'\" \nstyle=\"color: {{element.options.color && element.options.color != \'#888888\' ? element.options.color : \'rgb(3,155,229)\'}};padding:{{ element.options.paddingDownload ? element.options.paddingDownload : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 13px;display:block;text-decoration:none\">\n{{element.options.linkTo.text}}</a><figcaption \nng-if=\"element.options.mediaCaption.type != \'none\' &&element.options.mediaCaption.type != \'custom\' && element.options.mediaCaption.type != \'link\' && element.options.mediaCaption.type != \'title_photographer\' && element.options.mediaCaption.type != \'caption_photographer\' && element.options.mediaCaption.type != \'caption_owner\'\" \nstyle=\"padding:{{ element.options.paddingCaption ? element.options.paddingCaption : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}}\">\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle1.fields[element.options.mediaCaption.type] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'caption_photographer\'\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle1.fields[\'caption\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle1.fields[\'photographer\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'caption_owner\'\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle1.fields[\'caption\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle1.fields[\'owner\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'title_photographer\'\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle1.fields[\'title\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle1.fields[\'photographer\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption \nng-if=\"element.options.mediaCaption.type != \'none\' && (element.options.mediaCaption.type == \'custom\' || element.options.mediaCaption.type == \'link\')\" \nstyle=\"padding:{{ element.options.paddingCaption ? element.options.paddingCaption : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}}\">\n{{ element.options.mediaCaption.prefix }} {{ element.options.mediaCaption.custom_1 }} {{ element.options.mediaCaption.suffix }}\n</figcaption></div><div style=\"width: 50%;padding-bottom: 20px\"><img image-with-link link=\"element.options.linkTo\" \nlink-media=\"element.options.imageSingle2\" border=\"0\" ng-src=\"{{ element.options.imageSingle2.url }}\" width=\"250\" \nstyle=\"padding:0 10px 0px 10px;max-width: 100%;width:100%;display: block;margin: 0 auto\"> <a \nhref=\"#id={{element.options.imageSingle2.id_media}}\" \nng-if=\"element.options.linkTo.text && element.options.linkTo && element.options.linkTo.type != \'none\'\" \nstyle=\"color: {{element.options.color && element.options.color != \'#888888\' ? element.options.color : \'rgb(3,155,229)\'}};padding:{{ element.options.paddingDownload ? element.options.paddingDownload : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 13px;display:block;text-decoration:none\">\n{{element.options.linkTo.text}}</a><figcaption \nng-if=\"element.options.mediaCaption.type != \'none\' && element.options.mediaCaption.type != \'custom\' && element.options.mediaCaption.type != \'link\' && element.options.mediaCaption.type != \'title_photographer\' && element.options.mediaCaption.type != \'caption_photographer\' && element.options.mediaCaption.type != \'caption_owner\'\" \nstyle=\"padding:{{ element.options.paddingCaption ? element.options.paddingCaption : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}}\">\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle2.fields[element.options.mediaCaption.type] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'caption_photographer\'\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle2.fields[\'caption\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle2.fields[\'photographer\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'caption_owner\'\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle2.fields[\'caption\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle2.fields[\'owner\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'title_photographer\'\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle2.fields[\'title\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle2.fields[\'photographer\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption \nng-if=\"element.options.mediaCaption.type != \'none\' && (element.options.mediaCaption.type == \'custom\' || element.options.mediaCaption.type == \'link\')\" \nstyle=\"padding:{{ element.options.paddingCaption ? element.options.paddingCaption : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#8888888\'}}\">\n{{ element.options.mediaCaption.prefix }} {{ element.options.mediaCaption.custom_2 }} {{ element.options.mediaCaption.suffix }}\n</figcaption></div></div></td></tr></tbody></table>");
$templateCache.put("app/main/plugins/template-builder/fields/imagesX3.html","<table width=\"100%\" class=\"main\" cellspacing=\"0\" cellpadding=\"0\" border=\"0\" \nbgcolor=\"{{element.options.backgroundColor}}\" align=\"center\" data-type=\"imagesX3\"><tbody><tr><td \nalign=\"{{ element.options.align ? element.options.align : \'left\' }}\" valign=\"top\" width=\"100%\" \nstyle=\"font-family: {{element.options.font.family ? element.options.font.family : \'Arial, Helvetica, sans-serif\'}};font-weight: {{element.options.font.weight ? element.options.font.weight : \'normal\'}}\">\n<div style=\"display: flex; padding: {{ element.options.padding | arrToPadding }}\"><div \nstyle=\"width: 33.3333%;padding-bottom: 20px\"><img image-with-link link=\"element.options.linkTo\" \nlink-media=\"element.options.imageSingle1\" border=\"0\" ng-src=\"{{ element.options.imageSingle1.url }}\" width=\"180\" \nstyle=\"max-width: 100%;width:100%; padding:0 10px 0 10px;display: block;margin: 0 auto\"> <a \nhref=\"#id={{element.options.imageSingle1.id_media}}\" \nng-if=\"element.options.linkTo.text && element.options.linkTo && element.options.linkTo.type != \'none\'\" \nstyle=\"color: {{element.options.color && element.options.color != \'#888888\' ? element.options.color : \'rgb(3,155,229)\'}};padding:{{ element.options.paddingDownload ? element.options.paddingDownload : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;display:block;text-decoration:none\">\n{{element.options.linkTo.text}}</a><figcaption \nng-if=\"element.options.mediaCaption.type != \'none\' && element.options.mediaCaption.type != \'custom\' && element.options.mediaCaption.type != \'link\' && element.options.mediaCaption.type != \'title_photographer\' && element.options.mediaCaption.type != \'caption_photographer\' && element.options.mediaCaption.type != \'caption_owner\'\" \nstyle=\"padding:{{ element.options.paddingCaption ? element.options.paddingCaption : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}}\">\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle1.fields[element.options.mediaCaption.type] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'caption_photographer\'\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle1.fields[\'caption\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle1.fields[\'photographer\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'caption_owner\'\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle1.fields[\'caption\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle1.fields[\'owner\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'title_photographer\'\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle1.fields[\'title\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle1.fields[\'photographer\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption \nng-if=\"element.options.mediaCaption.type != \'none\' && (element.options.mediaCaption.type == \'custom\' || element.options.mediaCaption.type == \'link\')\" \nstyle=\"padding:{{ element.options.paddingCaption ? element.options.paddingCaption : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}}\">\n{{ element.options.mediaCaption.prefix }} {{ element.options.mediaCaption.custom_1 }} {{ element.options.mediaCaption.suffix }}\n</figcaption></div><div style=\"width: 33.3333%;padding-bottom: 20px\"><img image-with-link \nlink=\"element.options.linkTo\" link-media=\"element.options.imageSingle2\" border=\"0\" \nng-src=\"{{ element.options.imageSingle2.url }}\" width=\"180\" \nstyle=\"max-width: 100%;width:100%; padding:0 10px 0 10px;display: block;margin: 0 auto\"> <a \nhref=\"#id={{element.options.imageSingle2.id_media}}\" \nng-if=\"element.options.linkTo.text && element.options.linkTo && element.options.linkTo.type != \'none\'\" \nstyle=\"color: {{element.options.color && element.options.color != \'#888888\' ? element.options.color : \'rgb(3,155,229)\'}};padding:{{ element.options.paddingDownload ? element.options.paddingDownload : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;display:block;text-decoration:none\">\n{{element.options.linkTo.text}}</a><figcaption \nng-if=\"element.options.mediaCaption.type != \'none\' && element.options.mediaCaption.type != \'custom\' && element.options.mediaCaption.type != \'link\' && element.options.mediaCaption.type != \'title_photographer\' && element.options.mediaCaption.type != \'caption_photographer\' && element.options.mediaCaption.type != \'caption_owner\'\" \nstyle=\"padding:{{ element.options.paddingCaption ? element.options.paddingCaption : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}}\">\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle2.fields[element.options.mediaCaption.type] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'caption_photographer\'\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle2.fields[\'caption\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle2.fields[\'photographer\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'caption_owner\'\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle2.fields[\'caption\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle2.fields[\'owner\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'title_photographer\'\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle2.fields[\'title\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle2.fields[\'photographer\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption \nng-if=\"element.options.mediaCaption.type != \'none\' && (element.options.mediaCaption.type == \'custom\' || element.options.mediaCaption.type == \'link\')\" \nstyle=\"padding:{{ element.options.paddingCaption ? element.options.paddingCaption : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}}\">\n{{ element.options.mediaCaption.prefix }} {{ element.options.mediaCaption.custom_2 }} {{ element.options.mediaCaption.suffix }}\n</figcaption></div><div style=\"width: 33.3333%;padding-bottom: 20px\"><img image-with-link \nlink=\"element.options.linkTo\" link-media=\"element.options.imageSingle3\" border=\"0\" \nng-src=\"{{ element.options.imageSingle3.url }}\" width=\"180\" \nstyle=\"max-width: 100%;width:100%; padding:0 10px 0 10px;display: block;margin: 0 auto\"> <a \nhref=\"#id={{element.options.imageSingle3.id_media}}\" \nng-if=\"element.options.linkTo.text && element.options.linkTo && element.options.linkTo.type != \'none\'\" \nstyle=\"color: {{element.options.color && element.options.color != \'#888888\' ? element.options.color : \'rgb(3,155,229)\'}};padding:{{ element.options.paddingDownload ? element.options.paddingDownload : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;display:block;text-decoration:none\">\n{{element.options.linkTo.text}}</a><figcaption \nng-if=\"element.options.mediaCaption.type != \'none\' && element.options.mediaCaption.type != \'custom\' && element.options.mediaCaption.type != \'link\' && element.options.mediaCaption.type != \'title_photographer\' && element.options.mediaCaption.type != \'caption_photographer\' && element.options.mediaCaption.type != \'caption_owner\'\" \nstyle=\"padding:{{ element.options.paddingCaption ? element.options.paddingCaption : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}}\">\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle3.fields[element.options.mediaCaption.type] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'caption_photographer\'\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle3.fields[\'caption\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle3.fields[\'photographer\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'caption_owner\'\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle3.fields[\'caption\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle3.fields[\'owner\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'title_photographer\'\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle3.fields[\'title\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle3.fields[\'photographer\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption \nng-if=\"element.options.mediaCaption.type != \'none\' && (element.options.mediaCaption.type == \'custom\' || element.options.mediaCaption.type == \'link\')\" \nstyle=\"padding:{{ element.options.paddingCaption ? element.options.paddingCaption : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}}\">\n{{ element.options.mediaCaption.prefix }} {{ element.options.mediaCaption.custom_3 }} {{ element.options.mediaCaption.suffix }}\n</figcaption></div></div></td></tr></tbody></table>");
$templateCache.put("app/main/plugins/template-builder/fields/imagesX4.html","<table width=\"100%\" class=\"main\" cellspacing=\"0\" cellpadding=\"0\" border=\"0\" \nbgcolor=\"{{element.options.backgroundColor}}\" align=\"center\" data-type=\"imagesX4\"><tbody><tr><td \nalign=\"{{ element.options.align ? element.options.align : \'left\' }}\" valign=\"top\" width=\"100%\" \nstyle=\"font-family: {{element.options.font.family ? element.options.font.family : \'Arial, Helvetica, sans-serif\'}};font-weight: {{element.options.font.weight ? element.options.font.weight : \'normal\'}}\">\n<div style=\"display: flex; padding: {{ element.options.padding | arrToPadding }}\"><div \nstyle=\"width: 25%;padding-bottom: 20px\"><img image-with-link link=\"element.options.linkTo\" \nlink-media=\"element.options.imageSingle1\" border=\"0\" ng-src=\"{{ element.options.imageSingle1.url }}\" width=\"180\" \nstyle=\"max-width: 100%;width:100%; padding:0 10px 0 10px;display: block;margin: 0 auto\"> <a \nhref=\"#id={{element.options.imageSingle1.id_media}}\" \nng-if=\"element.options.linkTo.text && element.options.linkTo && element.options.linkTo.type != \'none\'\" \nstyle=\"color: {{element.options.color && element.options.color != \'#888888\' ? element.options.color : \'rgb(3,155,229)\'}};padding:{{ element.options.paddingDownload ? element.options.paddingDownload : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;display:block;text-decoration:none\">\n{{element.options.linkTo.text}}</a><figcaption \nng-if=\"element.options.mediaCaption.type != \'none\' && element.options.mediaCaption.type != \'custom\' && element.options.mediaCaption.type != \'link\' && element.options.mediaCaption.type != \'title_photographer\' && element.options.mediaCaption.type != \'caption_photographer\' && element.options.mediaCaption.type != \'caption_owner\'\" \nstyle=\"padding:{{ element.options.paddingCaption ? element.options.paddingCaption : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}}\">\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle1.fields[element.options.mediaCaption.type] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'caption_photographer\'\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle1.fields[\'caption\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle1.fields[\'photographer\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'caption_owner\'\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle1.fields[\'caption\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle1.fields[\'owner\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'title_photographer\'\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle1.fields[\'title\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle1.fields[\'photographer\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption \nng-if=\"element.options.mediaCaption.type != \'none\' && (element.options.mediaCaption.type == \'custom\' || element.options.mediaCaption.type == \'link\')\" \nstyle=\"padding:{{ element.options.paddingCaption ? element.options.paddingCaption : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}}\">\n{{ element.options.mediaCaption.prefix }} {{ element.options.mediaCaption.custom_1 }} {{ element.options.mediaCaption.suffix }}\n</figcaption></div><div style=\"width: 25%;padding-bottom: 20px\"><img image-with-link link=\"element.options.linkTo\" \nlink-media=\"element.options.imageSingle2\" border=\"0\" ng-src=\"{{ element.options.imageSingle2.url }}\" width=\"180\" \nstyle=\"max-width: 100%;width:100%; padding:0 10px 0 10px;display: block;margin: 0 auto\"> <a \nhref=\"#id={{element.options.imageSingle2.id_media}}\" \nng-if=\"element.options.linkTo.text && element.options.linkTo && element.options.linkTo.type != \'none\'\" \nstyle=\"color: {{element.options.color && element.options.color != \'#888888\' ? element.options.color : \'rgb(3,155,229)\'}};padding:{{ element.options.paddingDownload ? element.options.paddingDownload : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;display:block;text-decoration:none\">\n{{element.options.linkTo.text}}</a><figcaption \nng-if=\"element.options.mediaCaption.type != \'none\' && element.options.mediaCaption.type != \'custom\' && element.options.mediaCaption.type != \'link\' && element.options.mediaCaption.type != \'title_photographer\' && element.options.mediaCaption.type != \'caption_photographer\' && element.options.mediaCaption.type != \'caption_owner\'\" \nstyle=\"padding:{{ element.options.paddingCaption ? element.options.paddingCaption : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}}\">\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle2.fields[element.options.mediaCaption.type] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'caption_photographer\'\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle2.fields[\'caption\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle2.fields[\'photographer\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'caption_owner\'\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle2.fields[\'caption\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle2.fields[\'owner\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'title_photographer\'\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle2.fields[\'title\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle2.fields[\'photographer\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption \nng-if=\"element.options.mediaCaption.type != \'none\' && (element.options.mediaCaption.type == \'custom\' || element.options.mediaCaption.type == \'link\')\" \nstyle=\"padding:{{ element.options.paddingCaption ? element.options.paddingCaption : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}}\">\n{{ element.options.mediaCaption.prefix }} {{ element.options.mediaCaption.custom_2 }} {{ element.options.mediaCaption.suffix }}\n</figcaption></div><div style=\"width: 25%;padding-bottom: 20px\"><img image-with-link link=\"element.options.linkTo\" \nlink-media=\"element.options.imageSingle3\" border=\"0\" ng-src=\"{{ element.options.imageSingle3.url }}\" width=\"180\" \nstyle=\"max-width: 100%;width:100%; padding:0 10px 0 10px;display: block;margin: 0 auto\"> <a \nhref=\"#id={{element.options.imageSingle3.id_media}}\" \nng-if=\"element.options.linkTo.text && element.options.linkTo && element.options.linkTo.type != \'none\'\" \nstyle=\"color: {{element.options.color && element.options.color != \'#888888\' ? element.options.color : \'rgb(3,155,229)\'}};padding:{{ element.options.paddingDownload ? element.options.paddingDownload : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;display:block;text-decoration:none\">\n{{element.options.linkTo.text}}</a><figcaption \nng-if=\"element.options.mediaCaption.type != \'none\' && element.options.mediaCaption.type != \'custom\' && element.options.mediaCaption.type != \'link\' && element.options.mediaCaption.type != \'title_photographer\' && element.options.mediaCaption.type != \'caption_photographer\' && element.options.mediaCaption.type != \'caption_owner\'\" \nstyle=\"padding:{{ element.options.paddingCaption ? element.options.paddingCaption : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}}\">\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle3.fields[element.options.mediaCaption.type] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'caption_photographer\'\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle3.fields[\'caption\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle3.fields[\'photographer\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'caption_owner\'\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle3.fields[\'caption\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle3.fields[\'owner\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'title_photographer\'\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle3.fields[\'title\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle3.fields[\'photographer\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption \nng-if=\"element.options.mediaCaption.type != \'none\' && (element.options.mediaCaption.type == \'custom\' || element.options.mediaCaption.type == \'link\')\" \nstyle=\"padding:{{ element.options.paddingCaption ? element.options.paddingCaption : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}}\">\n{{ element.options.mediaCaption.prefix }} {{ element.options.mediaCaption.custom_3 }} {{ element.options.mediaCaption.suffix }}\n</figcaption></div><div style=\"width: 25%;padding-bottom: 20px\"><img image-with-link link=\"element.options.linkTo\" \nlink-media=\"element.options.imageSingle4\" border=\"0\" ng-src=\"{{ element.options.imageSingle4.url }}\" width=\"180\" \nstyle=\"max-width: 100%;width:100%; padding:0 10px 0 10px;display: block;margin: 0 auto\"> <a \nhref=\"#id={{element.options.imageSingle4.id_media}}\" \nng-if=\"element.options.linkTo.text && element.options.linkTo && element.options.linkTo.type != \'none\'\" \nstyle=\"color: {{element.options.color && element.options.color != \'#888888\' ? element.options.color : \'rgb(3,155,229)\'}};padding:{{ element.options.paddingDownload ? element.options.paddingDownload : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;display:block;text-decoration:none\">\n{{element.options.linkTo.text}}</a><figcaption \nng-if=\"element.options.mediaCaption.type != \'none\' && element.options.mediaCaption.type != \'custom\' && element.options.mediaCaption.type != \'link\' && element.options.mediaCaption.type != \'title_photographer\' && element.options.mediaCaption.type != \'caption_photographer\' && element.options.mediaCaption.type != \'caption_owner\'\" \nstyle=\"padding:{{ element.options.paddingCaption ? element.options.paddingCaption : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}}\">\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle4.fields[element.options.mediaCaption.type] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'caption_photographer\'\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle4.fields[\'caption\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle4.fields[\'photographer\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'caption_owner\'\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle4.fields[\'caption\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle4.fields[\'owner\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'title_photographer\'\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle4.fields[\'title\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle4.fields[\'photographer\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption \nng-if=\"element.options.mediaCaption.type != \'none\' && (element.options.mediaCaption.type == \'custom\' || element.options.mediaCaption.type == \'link\')\" \nstyle=\"padding:{{ element.options.paddingCaption ? element.options.paddingCaption : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}}\">\n{{ element.options.mediaCaption.prefix }} {{ element.options.mediaCaption.custom_4 }} {{ element.options.mediaCaption.suffix }}\n</figcaption></div></div></td></tr></tbody></table>");
$templateCache.put("app/main/plugins/template-builder/fields/imagesX5.html","<table width=\"100%\" class=\"main\" cellspacing=\"0\" cellpadding=\"0\" border=\"0\" \nbgcolor=\"{{element.options.backgroundColor}}\" align=\"center\" data-type=\"imagesX5\"><tbody><tr><td \nalign=\"{{ element.options.align ? element.options.align : \'left\' }}\" valign=\"top\" width=\"100%\" \nstyle=\"font-family: {{element.options.font.family ? element.options.font.family : \'Arial, Helvetica, sans-serif\'}};font-weight: {{element.options.font.weight ? element.options.font.weight : \'normal\'}}\">\n<div style=\"display: flex; padding: {{ element.options.padding | arrToPadding }}\"><div \nstyle=\"width: 20%;padding-bottom: 20px\"><img image-with-link link=\"element.options.linkTo\" \nlink-media=\"element.options.imageSingle1\" border=\"0\" ng-src=\"{{ element.options.imageSingle1.url }}\" width=\"180\" \nstyle=\"max-width: 100%;width:100%; padding:0 10px 0 10px;display: block;margin: 0 auto\"> <a \nhref=\"#id={{element.options.imageSingle1.id_media}}\" \nng-if=\"element.options.linkTo.text && element.options.linkTo && element.options.linkTo.type != \'none\'\" \nstyle=\"color: {{element.options.color && element.options.color != \'#888888\' ? element.options.color : \'rgb(3,155,229)\'}};padding:{{ element.options.paddingDownload ? element.options.paddingDownload : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;display:block;text-decoration:none\">\n{{element.options.linkTo.text}}</a><figcaption \nng-if=\"element.options.mediaCaption.type != \'none\' && element.options.mediaCaption.type != \'custom\' && element.options.mediaCaption.type != \'link\' && element.options.mediaCaption.type != \'title_photographer\' && element.options.mediaCaption.type != \'caption_photographer\' && element.options.mediaCaption.type != \'caption_owner\'\" \nstyle=\"padding:{{ element.options.paddingCaption ? element.options.paddingCaption : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}}\">\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle1.fields[element.options.mediaCaption.type] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'caption_photographer\'\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle1.fields[\'caption\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle1.fields[\'photographer\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'caption_owner\'\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle1.fields[\'caption\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle1.fields[\'owner\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'title_photographer\'\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle1.fields[\'title\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle1.fields[\'photographer\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption \nng-if=\"element.options.mediaCaption.type != \'none\' && (element.options.mediaCaption.type == \'custom\' || element.options.mediaCaption.type == \'link\')\" \nstyle=\"padding:{{ element.options.paddingCaption ? element.options.paddingCaption : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}}\">\n{{ element.options.mediaCaption.prefix }} {{ element.options.mediaCaption.custom_1 }} {{ element.options.mediaCaption.suffix }}\n</figcaption></div><div style=\"width: 20%;padding-bottom: 20px\"><img image-with-link link=\"element.options.linkTo\" \nlink-media=\"element.options.imageSingle2\" border=\"0\" ng-src=\"{{ element.options.imageSingle2.url }}\" width=\"180\" \nstyle=\"max-width: 100%;width:100%; padding:0 10px 0 10px;display: block;margin: 0 auto\"> <a \nhref=\"#id={{element.options.imageSingle2.id_media}}\" \nng-if=\"element.options.linkTo.text && element.options.linkTo && element.options.linkTo.type != \'none\'\" \nstyle=\"color: {{element.options.color && element.options.color != \'#888888\' ? element.options.color : \'rgb(3,155,229)\'}};padding:{{ element.options.paddingDownload ? element.options.paddingDownload : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;display:block;text-decoration:none\">\n{{element.options.linkTo.text}}</a><figcaption \nng-if=\"element.options.mediaCaption.type != \'none\' && element.options.mediaCaption.type != \'custom\' && element.options.mediaCaption.type != \'link\' && element.options.mediaCaption.type != \'title_photographer\' && element.options.mediaCaption.type != \'caption_photographer\' && element.options.mediaCaption.type != \'caption_owner\'\" \nstyle=\"padding:{{ element.options.paddingCaption ? element.options.paddingCaption : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}}\">\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle2.fields[element.options.mediaCaption.type] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'caption_photographer\'\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle2.fields[\'caption\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle2.fields[\'photographer\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'caption_owner\'\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle2.fields[\'caption\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle2.fields[\'owner\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'title_photographer\'\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle2.fields[\'title\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle2.fields[\'photographer\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption \nng-if=\"element.options.mediaCaption.type != \'none\' && (element.options.mediaCaption.type == \'custom\' || element.options.mediaCaption.type == \'link\')\" \nstyle=\"padding:{{ element.options.paddingCaption ? element.options.paddingCaption : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}}\">\n{{ element.options.mediaCaption.prefix }} {{ element.options.mediaCaption.custom_2 }} {{ element.options.mediaCaption.suffix }}\n</figcaption></div><div style=\"width: 20%;padding-bottom: 20px\"><img image-with-link link=\"element.options.linkTo\" \nlink-media=\"element.options.imageSingle3\" border=\"0\" ng-src=\"{{ element.options.imageSingle3.url }}\" width=\"180\" \nstyle=\"max-width: 100%;width:100%; padding:0 10px 0 10px;display: block;margin: 0 auto\"> <a \nhref=\"#id={{element.options.imageSingle3.id_media}}\" \nng-if=\"element.options.linkTo.text && element.options.linkTo && element.options.linkTo.type != \'none\'\" \nstyle=\"color: {{element.options.color && element.options.color != \'#888888\' ? element.options.color : \'rgb(3,155,229)\'}};padding:{{ element.options.paddingDownload ? element.options.paddingDownload : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;display:block;text-decoration:none\">\n{{element.options.linkTo.text}}</a><figcaption \nng-if=\"element.options.mediaCaption.type != \'none\' && element.options.mediaCaption.type != \'custom\' && element.options.mediaCaption.type != \'link\' && element.options.mediaCaption.type != \'title_photographer\' && element.options.mediaCaption.type != \'caption_photographer\' && element.options.mediaCaption.type != \'caption_owner\'\" \nstyle=\"padding:{{ element.options.paddingCaption ? element.options.paddingCaption : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}}\">\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle3.fields[element.options.mediaCaption.type] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'caption_photographer\'\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle3.fields[\'caption\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle3.fields[\'photographer\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'caption_owner\'\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle3.fields[\'caption\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle3.fields[\'owner\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'title_photographer\'\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle3.fields[\'title\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle3.fields[\'photographer\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption \nng-if=\"element.options.mediaCaption.type != \'none\' && (element.options.mediaCaption.type == \'custom\' || element.options.mediaCaption.type == \'link\')\" \nstyle=\"padding:{{ element.options.paddingCaption ? element.options.paddingCaption : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}}\">\n{{ element.options.mediaCaption.prefix }} {{ element.options.mediaCaption.custom_3 }} {{ element.options.mediaCaption.suffix }}\n</figcaption></div><div style=\"width: 20%;padding-bottom: 20px\"><img image-with-link link=\"element.options.linkTo\" \nlink-media=\"element.options.imageSingle4\" border=\"0\" ng-src=\"{{ element.options.imageSingle4.url }}\" width=\"180\" \nstyle=\"max-width: 100%;width:100%; padding:0 10px 0 10px;display: block;margin: 0 auto\"> <a \nhref=\"#id={{element.options.imageSingle4.id_media}}\" \nng-if=\"element.options.linkTo.text && element.options.linkTo && element.options.linkTo.type != \'none\'\" \nstyle=\"color: {{element.options.color && element.options.color != \'#888888\' ? element.options.color : \'rgb(3,155,229)\'}};padding:{{ element.options.paddingDownload ? element.options.paddingDownload : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;display:block;text-decoration:none\">\n{{element.options.linkTo.text}}</a><figcaption \nng-if=\"element.options.mediaCaption.type != \'none\' && element.options.mediaCaption.type != \'custom\' && element.options.mediaCaption.type != \'link\' && element.options.mediaCaption.type != \'title_photographer\' && element.options.mediaCaption.type != \'caption_photographer\' && element.options.mediaCaption.type != \'caption_owner\'\" \nstyle=\"padding:{{ element.options.paddingCaption ? element.options.paddingCaption : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}}\">\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle4.fields[element.options.mediaCaption.type] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'caption_photographer\'\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle4.fields[\'caption\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle4.fields[\'photographer\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'caption_owner\'\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle4.fields[\'caption\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle4.fields[\'owner\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'title_photographer\'\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle4.fields[\'title\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle4.fields[\'photographer\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption \nng-if=\"element.options.mediaCaption.type != \'none\' && (element.options.mediaCaption.type == \'custom\' || element.options.mediaCaption.type == \'link\')\" \nstyle=\"padding:{{ element.options.paddingCaption ? element.options.paddingCaption : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}}\">\n{{ element.options.mediaCaption.prefix }} {{ element.options.mediaCaption.custom_4 }} {{ element.options.mediaCaption.suffix }}\n</figcaption></div><div style=\"width: 20%;padding-bottom: 20px\"><img image-with-link link=\"element.options.linkTo\" \nlink-media=\"element.options.imageSingle5\" border=\"0\" ng-src=\"{{ element.options.imageSingle5.url }}\" width=\"180\" \nstyle=\"max-width: 100%;width:100%; padding:0 10px 0 10px;display: block;margin: 0 auto\"> <a \nhref=\"#id={{element.options.imageSingle5.id_media}}\" \nng-if=\"element.options.linkTo.text && element.options.linkTo && element.options.linkTo.type != \'none\'\" \nstyle=\"color: {{element.options.color && element.options.color != \'#888888\' ? element.options.color : \'rgb(3,155,229)\'}};padding:{{ element.options.paddingDownload ? element.options.paddingDownload : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;display:block;text-decoration:none\">\n{{element.options.linkTo.text}}</a><figcaption \nng-if=\"element.options.mediaCaption.type != \'none\' && element.options.mediaCaption.type != \'custom\' && element.options.mediaCaption.type != \'link\' && element.options.mediaCaption.type != \'title_photographer\' && element.options.mediaCaption.type != \'caption_photographer\' && element.options.mediaCaption.type != \'caption_owner\'\" \nstyle=\"padding:{{ element.options.paddingCaption ? element.options.paddingCaption : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}}\">\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle5.fields[element.options.mediaCaption.type] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'caption_photographer\'\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle5.fields[\'caption\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle5.fields[\'photographer\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'caption_owner\'\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle5.fields[\'caption\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle5.fields[\'owner\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'title_photographer\'\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle5.fields[\'title\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle5.fields[\'photographer\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption \nng-if=\"element.options.mediaCaption.type != \'none\' && (element.options.mediaCaption.type == \'custom\' || element.options.mediaCaption.type == \'link\')\" \nstyle=\"padding:{{ element.options.paddingCaption ? element.options.paddingCaption : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}}\">\n{{ element.options.mediaCaption.prefix }} {{ element.options.mediaCaption.custom_5 }} {{ element.options.mediaCaption.suffix }}\n</figcaption></div></div></td></tr></tbody></table>");
$templateCache.put("app/main/plugins/template-builder/fields/imageText2x2.html","<table width=\"100%\" class=\"main\" cellspacing=\"0\" cellpadding=\"0\" border=\"0\" \nbgcolor=\"{{element.options.backgroundColor}}\" align=\"center\" data-type=\"imageText2x2\"><tbody><tr><td \nalign=\"{{ element.options.align ? element.options.align : \'left\' }}\" valign=\"top\" width=\"100%\" \nstyle=\"font-family: {{element.options.font.family ? element.options.font.family : \'Arial, Helvetica, sans-serif\'}}\">\n<div style=\"display: flex; padding: {{ element.options.padding | arrToPadding }}\"><div \nstyle=\"width: 50%;padding-bottom: 20px\"><img image-with-link link=\"element.options.linkTo\" \nlink-media=\"element.options.imageSingle1\" border=\"0\" ng-src=\"{{ element.options.imageSingle1.url }}\" width=\"250\" \nstyle=\"padding:0 10px 0 10px;max-width: 100%;width:100%;display: block;margin: 0 auto\"> <a \nhref=\"#id={{element.options.imageSingle1.id_media}}\" \nng-if=\"element.options.linkTo.text && element.options.linkTo && element.options.linkTo.type != \'none\'\" \nstyle=\"font-weight: {{element.options.font.weight ? element.options.font.weight : \'normal\'}};padding:{{ element.options.paddingDownload ? element.options.paddingDownload : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 13px;display:block;text-decoration:none\">\n{{element.options.linkTo.text}}</a><figcaption \nng-if=\"element.options.mediaCaption.type != \'none\' && element.options.mediaCaption.type != \'custom\' && element.options.mediaCaption.type != \'link\' && element.options.mediaCaption.type != \'title_photographer\' && element.options.mediaCaption.type != \'caption_photographer\' && element.options.mediaCaption.type != \'caption_owner\'\" \nstyle=\"font-weight: {{element.options.font.weight ? element.options.font.weight : \'normal\'}};padding:{{ element.options.paddingCaption ? element.options.paddingCaption : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}}\">\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle1.fields[element.options.mediaCaption.type] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'caption_photographer\'\" \nstyle=\"font-weight: {{element.options.font.weight ? element.options.font.weight : \'normal\'}};padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle1.fields[\'caption\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle1.fields[\'photographer\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'caption_owner\'\" \nstyle=\"font-weight: {{element.options.font.weight ? element.options.font.weight : \'normal\'}};padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle1.fields[\'caption\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle1.fields[\'owner\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'title_photographer\'\" \nstyle=\"font-weight: {{element.options.font.weight ? element.options.font.weight : \'normal\'}};padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle1.fields[\'title\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle1.fields[\'photographer\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption \nng-if=\"element.options.mediaCaption.type != \'none\' && (element.options.mediaCaption.type == \'custom\' || element.options.mediaCaption.type == \'link\')\" \nstyle=\"font-weight: {{element.options.font.weight ? element.options.font.weight : \'normal\'}};padding:{{ element.options.paddingCaption ? element.options.paddingCaption : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}}\">\n{{ element.options.mediaCaption.prefix }} {{ element.options.mediaCaption.custom_1 }} {{ element.options.mediaCaption.suffix }}\n</figcaption><div \nstyle=\"font-family: {{element.options.font.family ? element.options.font.family : \'Arial, Helvetica, sans-serif\'}}; font-size: 13px; color: {{element.options.color ? element.options.color : \'#000000\'}}; padding:0 10px;line-height: 20px\">\n<div \nstyle=\"padding: {{ element.options.padding1 | arrToPadding }}; background-color:{{ element.options.backgroundColor1 }}\">\n<div ui-tinymce=\"vm.tinymceOptions\" ng-model=\"element.options.text1\"></div></div></div></div><div \nstyle=\"width: 50%;padding-bottom: 20px\"><img image-with-link link=\"element.options.linkTo\" \nlink-media=\"element.options.imageSingle2\" border=\"0\" ng-src=\"{{ element.options.imageSingle2.url }}\" width=\"250\" \nstyle=\"padding:0 10px 0 10px;max-width: 100%;width:100%;display: block;margin: 0 auto\"> <a \nhref=\"#id={{element.options.imageSingle2.id_media}}\" \nng-if=\"element.options.linkTo.text && element.options.linkTo && element.options.linkTo.type != \'none\'\" \nstyle=\"font-weight: {{element.options.font.weight ? element.options.font.weight : \'normal\'}};padding:{{ element.options.paddingDownload ? element.options.paddingDownload : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 13px;display:block;text-decoration:none\">\n{{element.options.linkTo.text}}</a><figcaption \nng-if=\"element.options.mediaCaption.type != \'none\' && element.options.mediaCaption.type != \'custom\' && element.options.mediaCaption.type != \'link\' && element.options.mediaCaption.type != \'title_photographer\' && element.options.mediaCaption.type != \'caption_photographer\' && element.options.mediaCaption.type != \'caption_owner\'\" \nstyle=\"font-weight: {{element.options.font.weight ? element.options.font.weight : \'normal\'}};padding:{{ element.options.paddingCaption ? element.options.paddingCaption : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}}\">\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle2.fields[element.options.mediaCaption.type] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'caption_photographer\'\" \nstyle=\"font-weight: {{element.options.font.weight ? element.options.font.weight : \'normal\'}};padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle2.fields[\'caption\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle2.fields[\'photographer\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'caption_owner\'\" \nstyle=\"font-weight: {{element.options.font.weight ? element.options.font.weight : \'normal\'}};padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle2.fields[\'caption\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle2.fields[\'owner\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'title_photographer\'\" \nstyle=\"font-weight: {{element.options.font.weight ? element.options.font.weight : \'normal\'}};padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle2.fields[\'title\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle2.fields[\'photographer\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption \nng-if=\"element.options.mediaCaption.type != \'none\' && (element.options.mediaCaption.type == \'custom\' || element.options.mediaCaption.type == \'link\')\" \nstyle=\"font-weight: {{element.options.font.weight ? element.options.font.weight : \'normal\'}};padding:{{ element.options.paddingCaption ? element.options.paddingCaption : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}}\">\n{{ element.options.mediaCaption.prefix }} {{ element.options.mediaCaption.custom_2 }} {{ element.options.mediaCaption.suffix }}\n</figcaption><div \nstyle=\"font-family: {{element.options.font.family ? element.options.font.family : \'Arial, Helvetica, sans-serif\'}}; font-size: 13px; color: {{element.options.color ? element.options.color : \'#000000\'}}; padding:0 10px;line-height: 20px\">\n<div \nstyle=\"padding: {{ element.options.padding2 | arrToPadding }};background-color:{{ element.options.backgroundColor2 }}\">\n<div ui-tinymce=\"vm.tinymceOptions\" ng-model=\"element.options.text2\"></div></div></div></div></div></td></tr></tbody>\n</table>");
$templateCache.put("app/main/plugins/template-builder/fields/imageText3x2.html","<table width=\"100%\" class=\"main\" cellspacing=\"0\" cellpadding=\"0\" border=\"0\" \nbgcolor=\"{{element.options.backgroundColor}}\" align=\"center\" data-type=\"imageText3x2\"><tbody><tr><td \nalign=\"{{ element.options.align ? element.options.align : \'left\' }}\" valign=\"top\" width=\"100%\" \nstyle=\"font-family: {{element.options.font.family ? element.options.font.family : \'Arial, Helvetica, sans-serif\'}}\">\n<div style=\"display: flex; padding: {{ element.options.padding | arrToPadding }}\"><div \nstyle=\"width: 33.3333%;padding-bottom: 20px\"><img image-with-link link=\"element.options.linkTo\" \nlink-media=\"element.options.imageSingle1\" border=\"0\" ng-src=\"{{ element.options.imageSingle1.url }}\" width=\"180\" \nstyle=\"max-width: 100%;width:100%; padding:0 10px 0 10px;display: block;margin: 0 auto\"> <a \nhref=\"#id={{element.options.imageSingle1.id_media}}\" \nng-if=\"element.options.linkTo.text && element.options.linkTo && element.options.linkTo.type != \'none\'\" \nstyle=\"font-weight: {{element.options.font.weight ? element.options.font.weight : \'normal\'}};padding:{{ element.options.paddingDownload ? element.options.paddingDownload : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;display:block;text-decoration:none\">\n{{element.options.linkTo.text}}</a><figcaption \nng-if=\"element.options.mediaCaption.type != \'none\' && element.options.mediaCaption.type != \'custom\' && element.options.mediaCaption.type != \'link\' && element.options.mediaCaption.type != \'title_photographer\' && element.options.mediaCaption.type != \'caption_photographer\' && element.options.mediaCaption.type != \'caption_owner\'\" \nstyle=\"font-weight: {{element.options.font.weight ? element.options.font.weight : \'normal\'}};padding:{{ element.options.paddingCaption ? element.options.paddingCaption : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}}\">\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle1.fields[element.options.mediaCaption.type] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'caption_photographer\'\" \nstyle=\"font-weight: {{element.options.font.weight ? element.options.font.weight : \'normal\'}};padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle1.fields[\'caption\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle1.fields[\'photographer\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'caption_owner\'\" \nstyle=\"font-weight: {{element.options.font.weight ? element.options.font.weight : \'normal\'}};padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle1.fields[\'caption\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle1.fields[\'owner\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'title_photographer\'\" \nstyle=\"font-weight: {{element.options.font.weight ? element.options.font.weight : \'normal\'}};padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle1.fields[\'title\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle1.fields[\'photographer\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption \nng-if=\"element.options.mediaCaption.type != \'none\' && (element.options.mediaCaption.type == \'custom\' || element.options.mediaCaption.type == \'link\')\" \nstyle=\"font-weight: {{element.options.font.weight ? element.options.font.weight : \'normal\'}};padding:{{ element.options.paddingCaption ? element.options.paddingCaption : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}}\">\n{{ element.options.mediaCaption.prefix }} {{ element.options.mediaCaption.custom_1 }} {{ element.options.mediaCaption.suffix }}\n</figcaption><div \nstyle=\"font-family: {{element.options.font.family ? element.options.font.family : \'Arial, Helvetica, sans-serif\'}}; font-size: 13px; color: {{element.options.color ? element.options.color : \'#000000\'}}; padding:0 10px;line-height: 20px\">\n<div \nstyle=\"padding: {{ element.options.padding1 | arrToPadding }}; background-color:{{ element.options.backgroundColor1 }}\">\n<div ui-tinymce=\"vm.tinymceOptions\" ng-model=\"element.options.text1\"></div></div></div></div><div \nstyle=\"width: 33.3333%;padding-bottom: 20px\"><img image-with-link link=\"element.options.linkTo\" \nlink-media=\"element.options.imageSingle2\" border=\"0\" ng-src=\"{{ element.options.imageSingle2.url }}\" width=\"180\" \nstyle=\"max-width: 100%;width:100%; padding:0 10px 0 10px;display: block;margin: 0 auto\"> <a \nhref=\"#id={{element.options.imageSingle2.id_media}}\" \nng-if=\"element.options.linkTo.text && element.options.linkTo && element.options.linkTo.type != \'none\'\" \nstyle=\"font-weight: {{element.options.font.weight ? element.options.font.weight : \'normal\'}};padding:{{ element.options.paddingDownload ? element.options.paddingDownload : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;display:block;text-decoration:none\">\n{{element.options.linkTo.text}}</a><figcaption \nng-if=\"element.options.mediaCaption.type != \'none\' && element.options.mediaCaption.type != \'custom\' && element.options.mediaCaption.type != \'link\' && element.options.mediaCaption.type != \'title_photographer\' && element.options.mediaCaption.type != \'caption_photographer\' && element.options.mediaCaption.type != \'caption_owner\'\" \nstyle=\"font-weight: {{element.options.font.weight ? element.options.font.weight : \'normal\'}};padding:{{ element.options.paddingCaption ? element.options.paddingCaption : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}}\">\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle2.fields[element.options.mediaCaption.type] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'caption_photographer\'\" \nstyle=\"font-weight: {{element.options.font.weight ? element.options.font.weight : \'normal\'}};padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle2.fields[\'caption\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle2.fields[\'photographer\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'caption_owner\'\" \nstyle=\"font-weight: {{element.options.font.weight ? element.options.font.weight : \'normal\'}};padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle2.fields[\'caption\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle2.fields[\'owner\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'title_photographer\'\" \nstyle=\"font-weight: {{element.options.font.weight ? element.options.font.weight : \'normal\'}};padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle2.fields[\'title\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle2.fields[\'photographer\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption \nng-if=\"element.options.mediaCaption.type != \'none\' && (element.options.mediaCaption.type == \'custom\' || element.options.mediaCaption.type == \'link\')\" \nstyle=\"font-weight: {{element.options.font.weight ? element.options.font.weight : \'normal\'}};padding:{{ element.options.paddingCaption ? element.options.paddingCaption : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}}\">\n{{ element.options.mediaCaption.prefix }} {{ element.options.mediaCaption.custom_2 }} {{ element.options.mediaCaption.suffix }}\n</figcaption><div \nstyle=\"font-family: {{element.options.font.family ? element.options.font.family : \'Arial, Helvetica, sans-serif\'}}; font-size: 13px; color: {{element.options.color ? element.options.color : \'#000000\'}}; padding:0 10px;line-height: 20px\">\n<div \nstyle=\"padding: {{ element.options.padding2 | arrToPadding }};background-color:{{ element.options.backgroundColor2 }}\">\n<div ui-tinymce=\"vm.tinymceOptions\" ng-model=\"element.options.text2\"></div></div></div></div><div \nstyle=\"width: 33.3333%;padding-bottom: 20px\"><img image-with-link link=\"element.options.linkTo\" \nlink-media=\"element.options.imageSingle3\" border=\"0\" ng-src=\"{{ element.options.imageSingle3.url }}\" width=\"180\" \nstyle=\"max-width: 100%;width:100%; padding:0 10px 0 10px;display: block;margin: 0 auto\"> <a \nhref=\"#id={{element.options.imageSingle3.id_media}}\" \nng-if=\"element.options.linkTo.text && element.options.linkTo && element.options.linkTo.type != \'none\'\" \nstyle=\"font-weight: {{element.options.font.weight ? element.options.font.weight : \'normal\'}};padding:{{ element.options.paddingDownload ? element.options.paddingDownload : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;display:block;text-decoration:none\">\n{{element.options.linkTo.text}}</a><figcaption \nng-if=\"element.options.mediaCaption.type != \'none\' && element.options.mediaCaption.type != \'custom\' && element.options.mediaCaption.type != \'link\' && element.options.mediaCaption.type != \'title_photographer\' && element.options.mediaCaption.type != \'caption_photographer\' && element.options.mediaCaption.type != \'caption_owner\'\" \nstyle=\"font-weight: {{element.options.font.weight ? element.options.font.weight : \'normal\'}};padding:{{ element.options.paddingCaption ? element.options.paddingCaption : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}}\">\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle3.fields[element.options.mediaCaption.type] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'caption_photographer\'\" \nstyle=\"font-weight: {{element.options.font.weight ? element.options.font.weight : \'normal\'}};padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle3.fields[\'caption\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle3.fields[\'photographer\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'caption_owner\'\" \nstyle=\"font-weight: {{element.options.font.weight ? element.options.font.weight : \'normal\'}};padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle3.fields[\'caption\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle3.fields[\'owner\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'title_photographer\'\" \nstyle=\"font-weight: {{element.options.font.weight ? element.options.font.weight : \'normal\'}};padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle3.fields[\'title\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle3.fields[\'photographer\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption \nng-if=\"element.options.mediaCaption.type != \'none\' && (element.options.mediaCaption.type == \'custom\' || element.options.mediaCaption.type == \'link\')\" \nstyle=\"font-weight: {{element.options.font.weight ? element.options.font.weight : \'normal\'}};padding:{{ element.options.paddingCaption ? element.options.paddingCaption : [\'5px\',\'10px\',\'0px\',\'10px\'] | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}}\">\n{{ element.options.mediaCaption.prefix }} {{ element.options.mediaCaption.custom_3 }} {{ element.options.mediaCaption.suffix }}\n</figcaption><div \nstyle=\"font-family: {{element.options.font.family ? element.options.font.family : \'Arial, Helvetica, sans-serif\'}}; font-size: 13px; color: {{element.options.color ? element.options.color : \'#000000\'}}; padding:0 10px;line-height: 20px\">\n<div \nstyle=\"padding: {{ element.options.padding3 | arrToPadding }};background-color:{{ element.options.backgroundColor3 }}\">\n<div ui-tinymce=\"vm.tinymceOptions\" ng-model=\"element.options.text3\"></div></div></div></div></div></td></tr></tbody>\n</table>");
$templateCache.put("app/main/plugins/template-builder/fields/imageTextLeft.html","<table class=\"main\" width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" border=\"0\" \nbgcolor=\"{{element.options.backgroundColor}}\" align=\"center\"><tbody><tr \nstyle=\"padding: {{ element.options.padding | arrToPadding }}; display: table-cell; font-family: {{element.options.font.family ? element.options.font.family : \'Arial, Helvetica, sans-serif\'}}; font-size: 13px; color: {{element.options.color ? element.options.color : \'#000000\'}}; line-height: 20px\">\n<td width=\"300\" valign=\"top\" align=\"{{ element.options.align ? element.options.align : \'left\' }}\" \nstyle=\"padding: {{ element.options.padding1 | arrToPadding }}; background-color:{{ element.options.backgroundColor1 }};font-family: {{element.options.font.family ? element.options.font.family : \'Arial, Helvetica, sans-serif\'}}\">\n<div ui-tinymce=\"vm.tinymceOptions\" ng-model=\"element.options.text\"></div></td><td width=\"300\" \nalign=\"{{ element.options.align ? element.options.align : \'right\' }}\" valign=\"top\" \nstyle=\"background-color:{{ element.options.backgroundColor1 }};font-family: {{element.options.font.family ? element.options.font.family : \'Arial, Helvetica, sans-serif\'}};font-weight: {{element.options.font.weight ? element.options.font.weight : \'normal\'}}\">\n<img image-with-link link=\"element.options.linkTo\" link-media=\"element.options.imageSingle1\" border=\"0\" \nng-src=\"{{ element.options.imageSingle1.url }}\" width=\"{{ element.options.width }}\" \nstyle=\"max-width: 100%;display: block;margin: 0 auto\"> <a href=\"#id={{element.options.imageSingle1.id_media}}\" \nng-if=\"element.options.linkTo.text && element.options.linkTo && element.options.linkTo.type != \'none\'\" \nstyle=\"padding:{{ element.options.paddingDownload ? element.options.paddingDownload : [\'5px\',\'0px\',\'0px\',\'0px\'] | arrToPadding  }};font-size: 13px;display:block;text-decoration:none\">\n{{element.options.linkTo.text}}</a><figcaption \nng-if=\"element.options.mediaCaption.type != \'none\' && element.options.mediaCaption.type != \'custom\' && element.options.mediaCaption.type != \'link\' && element.options.mediaCaption.type != \'title_photographer\' && element.options.mediaCaption.type != \'caption_photographer\' && element.options.mediaCaption.type != \'caption_owner\'\" \nstyle=\"padding:{{ element.options.paddingCaption ? element.options.paddingCaption : [\'5px\',\'0px\',\'0px\',\'0px\'] | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}}\">\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle1.fields[element.options.mediaCaption.type] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'caption_photographer\'\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 13px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle1.fields[\'caption\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle1.fields[\'photographer\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'caption_owner\'\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 13px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle1.fields[\'caption\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle1.fields[\'owner\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'title_photographer\'\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 13px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle1.fields[\'title\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle1.fields[\'photographer\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption \nng-if=\"element.options.mediaCaption.type != \'none\' && (element.options.mediaCaption.type == \'custom\' || element.options.mediaCaption.type == \'link\')\" \nstyle=\"padding:{{ element.options.paddingCaption ? element.options.paddingCaption : [\'5px\',\'0px\',\'0px\',\'0px\'] | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}}\">\n{{ element.options.mediaCaption.prefix }} {{ element.options.mediaCaption.custom_1 }} {{ element.options.mediaCaption.suffix }}\n</figcaption></td></tr></tbody></table>");
$templateCache.put("app/main/plugins/template-builder/fields/imageTextRight.html","<table class=\"main\" width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" border=\"0\" \nbgcolor=\"{{element.options.backgroundColor}}\" align=\"center\"><tbody><tr \nstyle=\"padding: {{ element.options.padding | arrToPadding }}; display: table-cell; font-family: {{element.options.font.family ? element.options.font.family : \'Arial, Helvetica, sans-serif\'}}; font-size: 13px; color: {{element.options.color ? element.options.color : \'#000000\'}}; line-height: 20px\">\n<td width=\"300\" align=\"{{ element.options.align ? element.options.align : \'left\' }}\" valign=\"top\" \nstyle=\"background-color:{{ element.options.backgroundColor1 }};font-family: {{element.options.font.family ? element.options.font.family : \'Arial, Helvetica, sans-serif\'}};font-weight: {{element.options.font.weight ? element.options.font.weight : \'normal\'}}\">\n<img image-with-link link=\"element.options.linkTo\" link-media=\"element.options.imageSingle1\" border=\"0\" \nng-src=\"{{ element.options.imageSingle1.url }}\" width=\"{{ element.options.width }}\" \nstyle=\"max-width: 100%; display: block;margin: 0 auto\"> <a href=\"#id={{element.options.imageSingle1.id_media}}\" \nng-if=\"element.options.linkTo.text && element.options.linkTo && element.options.linkTo.type != \'none\'\" \nstyle=\"padding:{{ element.options.paddingDownload ? element.options.paddingDownload : [\'5px\',\'0px\',\'0px\',\'0px\'] | arrToPadding  }};font-size: 13px;display:block;text-decoration:none\">\n{{element.options.linkTo.text}}</a><figcaption \nng-if=\"element.options.mediaCaption.type != \'none\' && element.options.mediaCaption.type != \'custom\' && element.options.mediaCaption.type != \'link\' && element.options.mediaCaption.type != \'title_photographer\' && element.options.mediaCaption.type != \'caption_photographer\' && element.options.mediaCaption.type != \'caption_owner\'\" \nstyle=\"padding:{{ element.options.paddingCaption ? element.options.paddingCaption : [\'5px\',\'0px\',\'0px\',\'0px\'] | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}}\">\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle1.fields[element.options.mediaCaption.type] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'caption_photographer\'\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 13px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle1.fields[\'caption\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle1.fields[\'photographer\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'caption_photographer\'\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 13px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle1.fields[\'caption\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle1.fields[\'owner\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption ng-if=\"element.options.mediaCaption.type == \'title_photographer\'\" \nstyle=\"padding:{{ element.options.paddingCaption | arrToPadding  }};font-size: 13px;color: {{element.options.color ? element.options.color : \'#888888\'}};line-height: 1.4\">\n{{ element.options.imageSingle1.fields[\'title\'] }}<br>\n{{ element.options.mediaCaption.prefix }} {{ element.options.imageSingle1.fields[\'photographer\'] }} {{ element.options.mediaCaption.suffix }}\n</figcaption><figcaption \nng-if=\"element.options.mediaCaption.type != \'none\' && (element.options.mediaCaption.type == \'custom\' || element.options.mediaCaption.type == \'link\')\" \nstyle=\"padding:{{ element.options.paddingCaption ? element.options.paddingCaption : [\'5px\',\'0px\',\'0px\',\'0px\'] | arrToPadding  }};font-size: 12px;color: {{element.options.color ? element.options.color : \'#888888\'}}\">\n{{ element.options.mediaCaption.prefix }} {{ element.options.mediaCaption.custom_1 }} {{ element.options.mediaCaption.suffix }}\n</figcaption></td><td width=\"300\" valign=\"top\" align=\"{{ element.options.align ? element.options.align : \'left\' }}\" \nstyle=\"padding: {{ element.options.padding1 | arrToPadding }}; background-color:{{ element.options.backgroundColor1 }};font-family: {{element.options.font.family ? element.options.font.family : \'Arial, Helvetica, sans-serif\'}}\">\n<div ui-tinymce=\"vm.tinymceOptions\" ng-model=\"element.options.text\"></div></td></tr></tbody></table>");
$templateCache.put("app/main/plugins/template-builder/fields/previewInBrowser.html","<table class=\"main\" width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" border=\"0\" \nstyle=\"display: table; background-color: {{element.options.backgroundColor}}\" align=\"center\" data-type=\"text-block\">\n<tbody><tr><td class=\"block-text\" data-block-id=\"background\" data-clonable=\"true\" align=\"left\" \nstyle=\"padding:{{element.options.padding | arrToPadding}}; font-size: {{element.options.font.size}}px; color: #000000; line-height: 20px;font-family: {{element.options.font.family}};font-weight:{{element.options.font.weight}}\">\n<table class=\"main\" width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" border=\"0\" style=\"display: table\"><tbody><tr><td \nstyle=\"color: {{element.options.font.color}}\" align=\"{{  element.options.align  }}\"><span>\n{{element.options.textPreview}} <a href=\"{{global.previewLink}}\" ng-bind-html=\"element.options.clickHere\" \nstyle=\"color: {{element.options.font.color}};text-decoration:underline\"></a></span></td></tr></tbody></table></td></tr>\n</tbody></table>");
$templateCache.put("app/main/plugins/template-builder/fields/social.html","<table class=\"main\" align=\"center\" width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" border=\"0\" \nng-style=\"{backgroundColor: element.options.backgroundColor}\" style=\"display: table\" data-type=\"social-links\"><tbody>\n<tr><td class=\"social\" align=\"{{element.options.align}}\" \nstyle=\"padding: {{ element.options.padding | arrToPadding  }}\"><a href=\"{{element.options.links.facebook.link}}\" \ntarget=\"_blank\" style=\"border: none;text-decoration: none\" class=\"facebook\"><img border=\"0\" \nng-if=\"element.options.links.facebook.active && element.options.links.facebook.imageSingle\" \nng-src=\"{{ element.options.links.facebook.imageSingle.url }}\" width=\"{{element.options.size}}\"> <img border=\"0\" \nng-if=\"element.options.links.facebook.active && !element.options.links.facebook.imageSingle\" \nsrc=\"https://new.qiusystem.com/assets/images/template-builder/social/facebook.png\" width=\"{{element.options.size}}\"> \n</a><a href=\"{{element.options.links.twitter.link}}\" target=\"_blank\" style=\"border: none;text-decoration: none\" \nclass=\"twitter\"><img border=\"0\" \nng-if=\"element.options.links.twitter.active && element.options.links.twitter.imageSingle\" \nng-src=\"{{ element.options.links.twitter.imageSingle.url }}\" width=\"{{element.options.size}}\"> <img border=\"0\" \nng-if=\"element.options.links.twitter.active && !element.options.links.twitter.imageSingle\" \nsrc=\"https://new.qiusystem.com/assets/images/template-builder/social/twitter.png\" width=\"{{element.options.size}}\"> \n</a><a href=\"{{element.options.links.instagram.link}}\" target=\"_blank\" style=\"border: none;text-decoration: none\" \nclass=\"instagram\"><img border=\"0\" \nng-if=\"element.options.links.instagram.active && element.options.links.instagram.imageSingle\" \nng-src=\"{{ element.options.links.instagram.imageSingle.url }}\" width=\"{{element.options.size}}\"> <img border=\"0\" \nng-if=\"element.options.links.instagram.active && !element.options.links.instagram.imageSingle\" \nsrc=\"https://new.qiusystem.com/assets/images/template-builder/social/instagram.png\" width=\"{{element.options.size}}\"> \n</a><a href=\"{{element.options.links.linkedin.link}}\" target=\"_blank\" style=\"border: none;text-decoration: none\" \nclass=\"linkedin\"><img border=\"0\" \nng-if=\"element.options.links.linkedin.active && element.options.links.linkedin.imageSingle\" \nng-src=\"{{ element.options.links.linkedin.imageSingle.url }}\" width=\"{{element.options.size}}\"> <img border=\"0\" \nng-if=\"element.options.links.linkedin.active && !element.options.links.linkedin.imageSingle\" \nsrc=\"https://new.qiusystem.com/assets/images/template-builder/social/linkedin.png\" width=\"{{element.options.size}}\"> \n</a><a href=\"{{element.options.links.youtube.link}}\" target=\"_blank\" style=\"border: none;text-decoration: none\" \nclass=\"youtube\"><img border=\"0\" \nng-if=\"element.options.links.youtube.active && element.options.links.youtube.imageSingle\" \nng-src=\"{{ element.options.links.youtube.imageSingle.url }}\" width=\"{{element.options.size}}\"> <img border=\"0\" \nng-if=\"element.options.links.youtube.active && !element.options.links.youtube.imageSingle\" \nsrc=\"https://new.qiusystem.com/assets/images/template-builder/social/youtube.png\" width=\"{{element.options.size}}\"> \n</a><a href=\"{{element.options.links.vimeo.link}}\" target=\"_blank\" style=\"border: none;text-decoration: none\" \nclass=\"vimeo\"><img border=\"0\" ng-if=\"element.options.links.vimeo.active && element.options.links.vimeo.imageSingle\" \nng-src=\"{{ element.options.links.vimeo.imageSingle.url }}\" width=\"{{element.options.size}}\"> <img border=\"0\" \nng-if=\"element.options.links.vimeo.active && !element.options.links.vimeo.imageSingle\" \nsrc=\"https://new.qiusystem.com/assets/images/template-builder/social/vimeo.png\" width=\"{{element.options.size}}\"> </a>\n<a href=\"{{element.options.links.tiktok.link}}\" target=\"_blank\" style=\"border: none;text-decoration: none\" \nclass=\"tiktok\"><img border=\"0\" ng-if=\"element.options.links.tiktok.active && element.options.links.tiktok.imageSingle\" \nng-src=\"{{ element.options.links.tiktok.imageSingle.url }}\" width=\"{{element.options.size}}\"> <img border=\"0\" \nng-if=\"element.options.links.tiktok.active && !element.options.links.tiktok.imageSingle\" \nsrc=\"https://new.qiusystem.com/assets/images/template-builder/social/tiktok.png\" width=\"{{element.options.size}}\"> </a>\n<a href=\"{{element.options.links.whatsapp.link}}\" target=\"_blank\" style=\"border: none;text-decoration: none\" \nclass=\"whatsapp\"><img border=\"0\" \nng-if=\"element.options.links.whatsapp.active && element.options.links.whatsapp.imageSingle\" \nng-src=\"{{ element.options.links.whatsapp.imageSingle.url }}\" width=\"{{element.options.size}}\"> <img border=\"0\" \nng-if=\"element.options.links.whatsapp.active && !element.options.links.whatsapp.imageSingle\" \nsrc=\"https://new.qiusystem.com/assets/images/template-builder/social/whatsapp.png\" width=\"{{element.options.size}}\">\n</a></td></tr></tbody></table>");
$templateCache.put("app/main/plugins/template-builder/fields/text.html","<table class=\"main\" width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" border=\"0\" \nstyle=\"display: table; background-color: {{element.options.backgroundColor}}\" align=\"center\" data-type=\"text-block\">\n<tbody><tr><td class=\"block-text\" data-block-id=\"background\" data-clonable=\"true\" align=\"left\" \nstyle=\"padding:{{element.options.padding | arrToPadding}}; font-size: 14px; color: {{element.options.color}}; line-height: 1.4;font-family: {{element.options.font.family}}\" \nui-tinymce=\"vm.tinymceOptions\" ng-model=\"element.options.text\" ng-mousedown=\"vm.elementChanged(element)\" \nng-change=\"vm.elementChanged(element)\"></td></tr></tbody></table>");
$templateCache.put("app/main/plugins/template-builder/fields/text2x2.html","<table width=\"100%\" class=\"main\" cellspacing=\"0\" cellpadding=\"0\" border=\"0\" \nbgcolor=\"{{element.options.backgroundColor}}\" align=\"center\" data-type=\"imageText2x2\"><tbody><tr><td \nalign=\"{{ element.options.align ? element.options.align : \'left\' }}\" valign=\"top\" width=\"100%\" \nstyle=\"font-family: {{element.options.font.family ? element.options.font.family : \'Arial, Helvetica, sans-serif\'}}\">\n<div style=\"display: flex; padding: {{ element.options.padding | arrToPadding }}\"><div \nstyle=\"width: 50%;padding-bottom: 20px\"><div \nstyle=\"font-family: {{element.options.font.family ? element.options.font.family : \'Arial, Helvetica, sans-serif\'}}; font-size: 13px; color: {{element.options.color ? element.options.color : \'#000000\'}}; padding:0 10px 0 10px;line-height: 20px\">\n<div \nstyle=\"padding: {{ element.options.padding1 | arrToPadding }}; background-color:{{ element.options.backgroundColor1 }}\">\n<div ui-tinymce=\"vm.tinymceOptions\" ng-model=\"element.options.text1\" ng-change=\"vm.elementChanged(element)\"></div>\n</div></div></div><div style=\"width: 50%;padding-bottom: 20px\"><div \nstyle=\"font-family: {{element.options.font.family ? element.options.font.family : \'Arial, Helvetica, sans-serif\'}}; font-size: 13px; color: {{element.options.color ? element.options.color : \'#000000\'}}; padding:0 10px 0 10px;line-height: 20px\">\n<div \nstyle=\"padding: {{ element.options.padding2 | arrToPadding }};background-color:{{ element.options.backgroundColor2 }}\">\n<div ui-tinymce=\"vm.tinymceOptions\" ng-model=\"element.options.text2\" ng-change=\"vm.elementChanged(element)\"></div>\n</div></div></div></div></td></tr></tbody></table>");
$templateCache.put("app/main/plugins/template-builder/fields/text3x2.html","<table width=\"100%\" class=\"main\" cellspacing=\"0\" cellpadding=\"0\" border=\"0\" \nbgcolor=\"{{element.options.backgroundColor}}\" align=\"center\" data-type=\"imageText3x2\"><tbody><tr><td \nalign=\"{{ element.options.align ? element.options.align : \'left\' }}\" valign=\"top\" width=\"100%\" \nstyle=\"font-family: {{element.options.font.family ? element.options.font.family : \'Arial, Helvetica, sans-serif\'}}\">\n<div style=\"display: flex; padding: {{ element.options.padding | arrToPadding }}\"><div \nstyle=\"width: 33.3333%;padding-bottom: 20px\"><div \nstyle=\"font-family: {{element.options.font.family ? element.options.font.family : \'Arial, Helvetica, sans-serif\'}}; font-size: 13px; color: {{element.options.color ? element.options.color : \'#000000\'}}; padding:0 10px 0 10px;line-height: 20px\">\n<div \nstyle=\"padding: {{ element.options.padding1 | arrToPadding }}; background-color:{{ element.options.backgroundColor1 }}\">\n<div ui-tinymce=\"vm.tinymceOptions\" ng-model=\"element.options.text1\" ng-change=\"vm.elementChanged(element)\"></div>\n</div></div></div><div style=\"width: 33.3333%;padding-bottom: 20px\"><div \nstyle=\"font-family: {{element.options.font.family ? element.options.font.family : \'Arial, Helvetica, sans-serif\'}}; font-size: 13px; color: {{element.options.color ? element.options.color : \'#000000\'}}; padding:0 10px 0 10px;line-height: 20px\">\n<div \nstyle=\"padding: {{ element.options.padding2 | arrToPadding }};background-color:{{ element.options.backgroundColor2 }}\">\n<div ui-tinymce=\"vm.tinymceOptions\" ng-model=\"element.options.text2\" ng-change=\"vm.elementChanged(element)\"></div>\n</div></div></div><div style=\"width: 33.3333%;padding-bottom: 20px\"><div \nstyle=\"font-family: {{element.options.font.family ? element.options.font.family : \'Arial, Helvetica, sans-serif\'}}; font-size: 13px; color: {{element.options.color ? element.options.color : \'#000000\'}}; padding:0 10px 0 10px;line-height: 20px\">\n<div \nstyle=\"padding: {{ element.options.padding3 | arrToPadding }};background-color:{{ element.options.backgroundColor3 }}\">\n<div ui-tinymce=\"vm.tinymceOptions\" ng-model=\"element.options.text3\" ng-change=\"vm.elementChanged(element)\"></div>\n</div></div></div></div></td></tr></tbody></table>");
$templateCache.put("app/main/plugins/template-builder/fields/title.html","<table class=\"main\" width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" border=\"0\" align=\"center\" \nstyle=\"display: table; background-color: {{ element.options.backgroundColor }}\" data-type=\"title\"><tbody><tr><td \nalign=\"{{  element.options.align  }}\" class=\"title\" \nstyle=\"padding:{{  element.options.padding | arrToPadding   }}; color: #757575\" data-block-id=\"background\"><h1 \nstyle=\"font-family: {{ element.options.font.family }};font-weight:  {{ element.options.font.weight }}; margin: 0; color: {{ element.options.color }};    font-size: 28px;line-height: 1.3\" \nng-if=\"element.options.title.length\" data-block-id=\"main-title\">{{ element.options.title }}</h1><br \nng-if=\"element.options.title.length && element.options.subTitle.length\"><h4 \nstyle=\"font-family: {{ element.options.font.family }};font-weight: {{ element.options.font.weight }}; font-size:18px; margin-bottom: 0; margin-top: 0px;color: {{ element.options.color }}\" \nng-if=\"element.options.subTitle.length\" data-block-id=\"sub-title\">{{ element.options.subTitle }}</h4></td></tr></tbody>\n</table>");
$templateCache.put("app/main/plugins/template-builder/web-fields/full-width-black-background.html","<div \nstyle=\"background-color: {{ element.options.backgroundColor }}; padding:{{  element.options.padding | arrToPadding   }}\" \nclass=\"article-text black-background\"><h2 \nstyle=\"padding: 0 20px; margin: 0; text-align: {{ element.options.title_align }}; font-family: {{ element.options.font.title_family }}; color: {{ element.options.title_color }}\" \nui-tinymce=\"vm.tinymceWebOptions\" ng-model=\"element.subtitle\"></h2><p \nstyle=\"margin: 0; padding: 0 20px; text-align: {{ element.options.align }}; font-family: {{ element.options.font.family }}; color: {{ element.options.color }}\" \nui-tinymce=\"vm.tinymceWebOptions\" ng-model=\"element.text\"></p></div>");
$templateCache.put("app/main/plugins/template-builder/web-fields/full-width-text-centered.html","<div \nstyle=\"background-color: {{ element.options.backgroundColor }}; padding:{{  element.options.padding | arrToPadding   }}\" \nclass=\"article-text\"><h2 \nstyle=\"padding: 0 20px; margin: 0; text-align: {{ element.options.title_align }}; font-family: {{ element.options.font.title_family }}; color: {{ element.options.title_color }}\" \nui-tinymce=\"vm.tinymceWebOptions\" ng-model=\"element.subtitle\"></h2><p \nstyle=\"margin: 0; padding: 0 20px; text-align: {{ element.options.align }}; font-family: {{ element.options.font.family }}; color: {{ element.options.color }}\" \nui-tinymce=\"vm.tinymceWebOptions\" ng-model=\"element.text\"></p></div>");
$templateCache.put("app/main/plugins/template-builder/web-fields/image-only.html","<media attachment=\"element.media[0]\" class=\"img-100 img-text\"></media>");
$templateCache.put("app/main/plugins/template-builder/web-fields/right-image-left-text.html","<div class=\"text-image\"><div \nstyle=\"padding:{{  element.options.padding | arrToPadding   }}; background-color: {{ element.options.backgroundColor }}\" \nclass=\"article-text size-50\"><h3 \nstyle=\"padding: 0 20px; margin: 0; text-align: {{ element.options.title_align }}; font-family: {{ element.options.font.title_family }}; color: {{ element.options.title_color }}\" \nui-tinymce=\"vm.tinymceWebOptions\" ng-model=\"element.subtitle\"></h3><div \nstyle=\"margin: 0; padding: 0 20px; text-align: {{ element.options.align }}; font-family: {{ element.options.font.family }}; color: {{ element.options.color }}\" \nui-tinymce=\"vm.tinymceWebOptions\" ng-model=\"element.text\"></div></div><media attachment=\"element.media[0]\" \nclass=\"img-right img-50 img-text\"></media></div>");
$templateCache.put("app/main/plugins/template-builder/web-fields/right-text-left-image.html","<div class=\"text-image\"><media attachment=\"element.media[0]\" class=\"img-left img-50 img-text\"></media><div \nstyle=\"padding:{{  element.options.padding | arrToPadding   }}; background-color: {{ element.options.backgroundColor }}\" \nclass=\"article-text size-50\"><h3 \nstyle=\"padding: 0 20px; margin: 0; text-align: {{ element.options.title_align }}; font-family: {{ element.options.font.title_family }}; color: {{ element.options.title_color }}\" \nui-tinymce=\"vm.tinymceWebOptions\" ng-model=\"element.subtitle\"></h3><div \nstyle=\"margin: 0; padding: 0 20px; text-align: {{ element.options.align }}; font-family: {{ element.options.font.family }}; color: {{ element.options.color }}\" \nui-tinymce=\"vm.tinymceWebOptions\" ng-model=\"element.text\"></div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps\" layout=\"row\" layout-align=\"start center\"><div class=\"step md-accent-bg\" \nlayout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{step.stepNumber}} \n</span><span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\">\n{{step.stepTitle}}</div><div class=\"subtitle\" ng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div>\n</md-button></div></div><div class=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\">\n</span></div><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/qiu-groups/dialogs/edit-group/edit-group.html","<md-dialog class=\"small compose-dialog\" aria-label=\"Edit Group\"><form class=\"md-inline-form\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><a class=\"md-button grey-A100-fg\" type=\"import\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-folder\" class=\"s18 mr-5 ml-0 md-font material-icons\" \nrole=\"img\" aria-label=\"icon-folder\"></md-icon><span class=\"title\" ng-if=\"!(vm.group | isEmptyObject)\" \ntranslate=\"QIU_GROUPS.EDIT\"></span> <span class=\"title\" ng-if=\"vm.group | isEmptyObject\" translate=\"QIU_GROUPS.CREATE\">\n</span></a></div><div layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\" translate-aria-label=\"QIU_GROUPS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></div></md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-block\"><label \ntranslate=\"QIU_GROUPS.NAME\"></label><input ng-model=\"vm.groupName\" type=\"text\" required></md-input-container>\n<md-input-container class=\"md-block on-off\"><label translate=\"QIU_GROUPS.MOVE_TO\"></label><md-menu><button \nclass=\"mr-0 width-percent-100 pb-5 pt-5 button-select\" ng-click=\"$mdMenu.open($event)\" aria-label=\"group-menu\" \nlayout=\"row\" layout-align=\"space-between center\"><span ng-if=\"vm.groupParentName\" class=\"font-size-14\">\n{{vm.groupParentName}}</span> <span ng-if=\"!vm.groupParentName\" class=\"font-size-14\">Root</span><md-icon \nmd-font-icon=\"icon-menu-down\" class=\"grey-600-fg ml-10 mr-0\" aria-hidden=\"true\"></md-icon></button><md-menu-content \nclass=\"md-block groups-tree\"><div ng-if=\"!vm.isQiuRestricted\" ng-click=\"vm.selectParentGroupRoot()\" \nclass=\"level-card p-8 group-row ng-scope\" layout=\"row\" layout-align=\"space-between stretch\"><div flex \nclass=\"layout-align-start-center layout-row flex\"><md-icon md-font-icon=\"icon-folder-multiple\" \nclass=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 ng-scope md-default-theme md-font material-icons icon-folder-multiple\" \naria-hidden=\"true\"></md-icon><span translate=\"QIU_GROUPS.ROOT\"></span></div></div><div ng-click=\"$mdCloseMenu($event)\" \nng-if=\"vm.groups\" ivh-treeview=\"vm.groups\" class=\"ivh-treeview-folder small\" ivh-treeview-label-attribute=\"\'label\'\">\n<script type=\"text/ng-template\">\n<div class=\"level-card p-8 group-row select-parent-group-row\" layout=\"row\" layout-align=\"space-between stretch\">\r\n                        <span ivh-treeview-twistie ivh-treeview-toggle layout=\"row\" layout-align=\"center center\"></span>\r\n                        <div qiu-on-click-select-parent-group flex id=\"treeview-group-{{node.id_group}}\" data-group-node={{node}} layout=\"row\" layout-align=\"start center\">\r\n                            <md-icon ng-if=\"!node.children\" \r\n                                md-font-icon=\"icon-folder\" \r\n                                class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon \r\n                                ng-if=\"node.children\" \r\n                                md-font-icon=\"icon-folder-multiple\" \r\n                                class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <span class=\"ivh-treeview-node-label ng-binding\">{{node.name}}</span>\r\n                        </div>\r\n                      </div>\r\n                    <div ivh-treeview-children></div>\n</script></div></md-menu-content></md-menu></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nng-click=\"delete(vm.group)\" class=\"md-icon-button\" aria-label=\"Delete\" ng-if=\"!(vm.group | isEmptyObject)\" \ntranslate-attr-aria-label=\"QIU_GROUPS.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip hide \nshow-gt-xs><span translate=\"QIU_GROUPS.DELETE\"></span></md-tooltip></md-button></div><div layout=\"row\" \nlayout-align=\"end center\"><md-button ng-click=\"save(vm.group)\" class=\"send-button md-accent md-raised\" \naria-label=\"Save\" translate=\"QIU_GROUPS.SAVE\" translate-attr-aria-label=\"QIU_GROUPS.SAVE\"></md-button><md-button \nng-click=\"cancel()\" class=\"send-button md-warn md-raised\" aria-label=\"Cancel\" translate=\"QIU_GROUPS.CANCEL\" \ntranslate-attr-aria-label=\"QIU_GROUPS.CANCEL\"></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/core/directives/qiu-groups/dialogs/add-selected-items-to-groups/groups-view.html","<md-dialog class=\"add-users-togroup\" aria-label=\"New Message\"><form class=\"md-inline-form\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><h1 \nclass=\"title\" translate=\"QIU_GROUPS.ADD_TO_GROUPS\"></h1><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content id=\"site-mailing\" ms-scroll flex class=\"content-card\" ng-include=\"vm.viewGroup\"></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\" ng-if=\"!vm.loading\"><md-input-container flex \nlayout=\"row\" layout-align=\"end center\" class=\"m-0\"><md-button type=\"button\" class=\"md-raised md-warn\" \nng-click=\"vm.closeDialog()\" translate=\"QIU_GROUPS.CANCEL\"></md-button><md-button \nng-disabled=\"vm.selectedFields.length == 0\" type=\"submit\" class=\"send-button md-accent md-raised\" ng-click=\"vm.save()\" \ntranslate=\"QIU_GROUPS.SAVE\"></md-button></md-input-container></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/core/directives/qiu-groups/dialogs/add-selected-items-to-groups/tree-view.html","<md-toolbar class=\"md-default-theme grey-100-bg grey-600-fg\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\"><label for=\"search-bar-input\"><md-icon ng-if=\"!vm.treeSearch\" md-font-icon=\"icon-magnify\" \nstyle=\"padding-top: 20px\" class=\"grey-600-fg md-icon-button md-button\"><md-tooltip hide show-gt-xs><span \ntranslate=\"QIU_GROUPS.SEARCH\">Search</span></md-tooltip></md-icon><md-icon layout-align=\"end center\" \nmd-font-icon=\"icon-close-circle\" class=\"grey-600-fg md-icon-button md-button\" ng-if=\"vm.treeSearch\" \nng-click=\"vm.treeSearch = null\"></md-icon></label><input type=\"text\" id=\"search-bar-input\" \nclass=\"grey-600-fg grey-100-bg\" ng-model=\"vm.treeSearch\" placeholder=\"Search\" md-autofocus translate \ntranslate-attr-placeholder=\"QIU_GROUPS.SEARCH\" flex></div></md-toolbar><div ng-if=\"vm.groups\" ivh-treeview=\"vm.groups\" \nclass=\"treeview groups\" ivh-treeview-filter=\"vm.treeSearch\" \nivh-treeview-on-cb-change=\"vm.checkGroup(ivhNode, ivhIsSelected, ivhTree)\" ivh-treeview-label-attribute=\"\'label\'\">\n<script type=\"text/ng-template\">\n<div class=\"level-card p-8 group-row select-parent-group-row\" layout=\"row\" layout-align=\"space-between stretch\">\r\n            <span ivh-treeview-twistie ivh-treeview-toggle layout=\"row\" layout-align=\"center center\"></span>\r\n            <div qiu-on-click-select-parent-group flex id=\"treeview-group-{{node.id_group}}\" data-group-node={{node}} layout=\"row\" layout-align=\"space-between center\">\r\n                <div layout=\"row\" layout-align=\"start center\" class=\"ml-10\">\r\n                <md-icon ng-if=\"!node.children\" \r\n                    md-font-icon=\"icon-folder\" \r\n                    class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                    aria-hidden=\"true\" >\r\n                </md-icon>\r\n                <md-icon \r\n                    ng-if=\"node.children\" \r\n                    md-font-icon=\"icon-folder-multiple\" \r\n                    class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                    aria-hidden=\"true\" >\r\n                </md-icon>\r\n                <span class=\"ivh-treeview-node-label ng-binding\">{{node.name}}</span>\r\n                </div>\r\n                <div layout=\"row\" layout-align=\"end center\" class=\"ml-10\">\r\n                    <md-checkbox\r\n                        aria-label=\"assign group\"\r\n                        add-selected-items-to-group-on-check-toggle-assigned-group\r\n                        class=\"ml-5 mb-0\" />\r\n                </div>\r\n            </div>\r\n          </div>\r\n        <div ivh-treeview-children></div>\n</script></div>");
$templateCache.put("app/main/apps/accounts/dialogs/copy-permission/copy-permission.html","<md-dialog class=\"medium copy-permission\" aria-label=\"New Task\"><md-toolbar \nclass=\"md-accent md-hue-2 md-default-theme\"><div class=\"md-toolbar-tools\"><div layout=\"row\"><a class=\"md-button\" \nlayout=\"row\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-view-list\" class=\"s18 mr-5 ml-0\"></md-icon><span \ntranslate=\"ACCOUNTS.REPLACE_PERMISSIONS\"></span></a></div><span flex></span><div layout=\"row\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate \ntranslate-aria-label=\"ACCOUNTS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></div>\n</md-toolbar><md-dialog-content class=\"copy-permission\" flex><div class=\"mail-list-item\" \nng-repeat=\"thread in vm.threads\" md-no-ink ng-init=\"parentIndex= $index\" ng-click=\"vm.saveRestrictions(thread)\"><div \nlayout=\"row\" layout-align=\"start center\"><div class=\"info\" flex layout=\"column\"><div><div class=\"name\" layout=\"row\" \nlayout-align=\"start center\"><div ng-if=\"(thread.avatar == \'\' || !thread.avatar)\" class=\"avatar\" \nng-bind=\"thread.first_name | capitalizeFirstLetter\" style=\"background-color:{{thread.profile_color}}\"></div><div \nclass=\"image avatar\" ng-if=\"thread.avatar\" attachment=\"thread.avatar\"><img class=\"avatar hide show spinner-show\" \nng-src=\"{{thread.avatar}}\" imageonload></div><div class=\"user-name text-truncate\"><span ng-bind=\"thread.first_name\" \nng-if=\"thread.first_name\"></span> <span ng-bind=\"thread.last_name\" ng-if=\"thread.last_name\"></span><div \nclass=\"details\" layout=\"row\" layout-align=\"start start\"><span class=\"text-truncate title\" ng-bind=\"thread.email\">\n</span></div></div></div></div></div><div layout=\"column\" layout-align=\"space-between end\"></div></div></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/accounts/views/activities/list-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-show=\"isLoading\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nclass=\"mail-list-item filter-selected\" ng-if=\"sortField\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\" flex><div class=\"info\" ng-if=\"sortField\"><div class=\"name\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-sort-ascending\" class=\"s20 mr-5 ml-0 mb-0\" \nng-if=\"sortDir === \'ASC\'\"></md-icon><md-icon md-font-icon=\"icon-sort-descending\" class=\"s20 mr-5 ml-0 mb-0\" \nng-if=\"sortDir === \'DESC\'\"></md-icon><div class=\"title text-truncate\" layout=\"row\" layout-align=\"start center\">\nOrdered by \'{{sortField}}\'</div></div></div></div><div class=\"buttons\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-close s20\" ng-click=\"pagination_resetOrderBy()\" class=\"ml-10\"><md-tooltip hide show-gt-xs>\n<span translate=\"CONTENT.REMOVE\">Remove</span></md-tooltip></md-icon></div></div><div class=\"no-threads\" \nng-if=\"!isLoading && vm.threads.length === 0\" ng-hide=\"isLoading\">There are no items!</div><div id=\"list-content-data\" \nng-style=\"{\'opacity\' : isLoading ? 0.2 : 1}\" ms-scroll=\"vm.msScrollOptions\" \nng-class=\"{\'group-filter\': vm.selectedGroup,\'other-filter\':sortField}\" class=\"scrollable\" \nng-if=\"vm.threads.length > 0\"><div ng-if=\"vm.currentLabelsFilter\" class=\"labels\"><form novalidate><div><div \nng-repeat=\"item in vm.currentLabelsFilter track by $index\" class=\"tag\" fxlayout=\"row\" fxlayoutalign=\"start center\"><div\n class=\"tag-label\">{{item.label}}<md-icon ng-click=\"vm.deleteTargetFilter(item.id, $index)\" md-font-icon=\"icon-close\" \nclass=\"s24 pointer\"></md-icon></div></div></div></form></div><div class=\"activities-list activity-main\"><table hide \nshow-gt-md><tr ng-repeat=\"log in vm.threads | filter: vm.search | filter: global.search\"><td><div layout=\"row\" \nlayout-align=\"start center\"><div ng-if=\"(log.user.avatar == \'\' || !log.user.avatar)\" class=\"avatar\" \nng-bind=\"log.user.first_name | capitalizeFirstLetter\" style=\"background-color:{{log.user.profile_color}}\"></div><div \nclass=\"avatar-wrapper\" ng-if=\"log.user.avatar\" attachment=\"log.user.avatar\"><img class=\"avatar\" \nng-src=\"{{log.user.avatar}}\" imageonload></div><h3 class=\"mt-0 mb-0 mr-10\"><strong \nng-bind-html=\"log.user.first_name + \' \' + log.user.last_name\"></strong></h3></div></td><td><div class=\"field\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"grey-500-fg\" ng-bind-html=\"vm.timeAgo(log.date)\"></span></div>\n</td><td><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"{{log.module.icon_v3}}\" \nclass=\"mr-10 ml-0 s24\"><md-tooltip hide show-gt-xs><span>{{log.module.module_name}}</span></md-tooltip></md-icon><div>\n<div class=\"field module-name\" ng-if=\"log.id_service == 2\"><span class=\"grey-800-fg\" \nng-bind-html=\"log.section.languages[0].text\"></span></div><div class=\"field module-name\" ng-if=\"log.id_service != 2\">\n<span class=\"grey-800-fg\" ng-bind-html=\"log.module.module_name\"></span></div></div></div></td><td><div class=\"field\">\n<span class=\"grey-800-fg mr-5\">ID #{{log.id_from_section}}</span></div></td><td><div class=\"field\"><span \nclass=\"grey-500-fg\" ng-bind-html=\"log.description\"></span></div></td><td><div class=\"field\" layout=\"row\" \nlayout-align=\"end center\"><span class=\"status {{log.action.action_name}}\" ng-bind-html=\"log.action.action_name\"></span>\n</div></td></tr></table><md-list hide-gt-md><md-list-item \nng-repeat=\"log in vm.threads | filter: vm.search | filter: global.search\" flex=\"100\" role=\"listitem\" \nclass=\"_md pt-10 pb-10\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><div layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"mr-8\" hide show-gt-xs><div \nng-if=\"(log.user.avatar == \'\' || !log.user.avatar)\" class=\"avatar\" \nng-bind=\"log.user.first_name | capitalizeFirstLetter\" style=\"background-color:{{log.user.profile_color}}\"></div><div \nclass=\"avatar-wrapper\" ng-if=\"log.user.avatar\" attachment=\"log.user.avatar\"><img class=\"avatar\" \nng-src=\"{{log.user.avatar}}\" imageonload></div></div><div layout-lg=\"column\" layout-align-lg=\"center start\" \nlayout-gt-lg=\"row\" layout-align-gt-lg=\"start center\" flex><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"mb-5\"><div layout=\"row\" layout-align=\"start center\"><div class=\"mr-5\" hide-gt-xs><div \nng-if=\"(log.user.avatar == \'\' || !log.user.avatar)\" class=\"avatar\" \nng-bind=\"log.user.first_name | capitalizeFirstLetter\" ms-random-class=\"vm.colors\"></div><div class=\"avatar-wrapper\" \nng-if=\"log.user.avatar\" attachment=\"thread.avatar\"><img class=\"avatar\" ng-src=\"{{log.user.avatar}}\" imageonload></div>\n</div><h3 class=\"mt-0 mb-0 mr-10\"><strong ng-bind-html=\"log.user.first_name + \' \' + log.user.last_name\"></strong></h3>\n<div class=\"field date-field\" hide show-gt-xs><span class=\"grey-500-fg\" ng-bind-html=\"vm.timeAgo(log.date)\"></span>\n</div></div><div layout=\"row\" layout-align=\"space-between center\" hide-gt-xs><div class=\"field mr-0\"><span \nclass=\"status {{log.action.action_name}}\" ng-bind-html=\"log.action.action_name\"></span></div></div></div><div \nlayout-xs=\"column\" layout-align-xs=\"center start\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><div \nlayout=\"row\" layout-align=\"start center\" class=\"mb-5 mt-5\"><div class=\"field module-name\" ng-if=\"log.id_service == 2\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"{{log.module.icon_v3}}\"><md-tooltip hide show-gt-xs>\n<span>{{log.module.module_name}}</span></md-tooltip></md-icon><span class=\"grey-800-fg\" \nng-bind-html=\"log.section.languages[0].text\"></span></div><div class=\"field module-name\" ng-if=\"log.id_service != 2\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"{{log.module.icon_v3}}\"><md-tooltip hide show-gt-xs>\n<span>{{log.module.module_name}}</span></md-tooltip></md-icon><span class=\"grey-800-fg\" \nng-bind-html=\"log.module.module_name\"></span></div><div class=\"field date-field\" hide-gt-xs><span class=\"grey-500-fg\" \nng-bind-html=\"vm.timeAgo(log.date)\"></span></div></div><div layout=\"row\" layout-align=\"start center\" class=\"mb-5 mt-5\">\n<div class=\"field\"><span class=\"grey-800-fg\">ID #{{log.id_from_section}}</span></div><div class=\"field text-truncate\">\n<span class=\"grey-500-fg text-truncate\" ng-bind-html=\"log.description\"></span></div></div></div></div></div><div \nlayout=\"row\" layout-align=\"end center\" hide show-gt-xs><div class=\"field\"><span \nclass=\"status {{log.action.action_name}}\" ng-bind-html=\"log.action.action_name\"></span></div></div></div><md-divider \nclass=\"md-default-theme\"></md-divider><div class=\"md-secondary-container\"></div></md-list-item></md-list></div><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"end center\"><div layout=\"row\" layout-align=\"center center\" \nng-style=\"{\'display\' : isLoading ? \'none\' : \'block\'}\"><span class=\"page-info\">{{pagination_totalItems}} items found.\n</span><md-button aria-label=\"Previous\" class=\"md-icon-button arrow\" ng-click=\"pagination_prevPage()\" \nng-disabled=\"pagination_firstPage()\" translate=\"\" translate-attr-aria-label=\"CONTENT.PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span translate=\"CONTENT.PREVIOUS\">Previous</span></md-tooltip>\n</md-button><span class=\"page-info\">{{pagination_page}} / {{pagination_total_pages}}</span><md-button \naria-label=\"Next\" class=\"md-icon-button arrow\" ng-click=\"pagination_nextPage()\" \nng-disabled=\"pagination_morePages() || pagination_total_pages === pagination_page\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span \ntranslate=\"CONTENT.NEXT\">Next</span></md-tooltip></md-button></div></div></div>");
$templateCache.put("app/main/apps/accounts/views/activities/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><md-button aria-label=\"Sort Direction\" class=\"md-icon-button\" \nng-click=\"vm.setSortOrder(\'ASC\')\" ng-if=\"sortDir !== \'ASC\'\" translate translate-attr-aria-label=\"TODO.SORT_DIRECTION\">\n<md-icon md-font-icon=\"icon-sort-ascending\" ng-if=\"sortDir !== \'DESC\'\"></md-icon><md-icon \nmd-font-icon=\"icon-sort-descending\" ng-if=\"sortDir === \'DESC\'\"></md-icon></md-button><md-button \naria-label=\"Sort Direction\" class=\"md-icon-button\" ng-click=\"vm.setSortOrder(\'DESC\')\" ng-if=\"sortDir === \'ASC\'\" \ntranslate translate-attr-aria-label=\"TODO.SORT_DIRECTION\"><md-icon md-font-icon=\"icon-sort-ascending\" \nng-if=\"sortDir !== \'DESC\'\"></md-icon><md-icon md-font-icon=\"icon-sort-descending\" ng-if=\"sortDir === \'DESC\'\"></md-icon>\n</md-button><div class=\"divider-vertical\" hide=\"\" show-gt-xs=\"\"></div><md-button aria-label=\"view type\" \nclass=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'main-sidenav\')\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.FILTERS\"><md-icon md-font-icon=\"icon-filter\"></md-icon><md-tooltip hide show-gt-xs>\n<span>Filters</span></md-tooltip></md-button><md-button ng-click=\"$root.pagination_resetquery()\" \naria-label=\"view type\" class=\"md-icon-button\" translate=\"\" translate-attr-aria-label=\"ACCOUNTS.RESET_SEARCH\" \nclass=\"md-icon-button\" ng-if=\"$root.pagination_searchquery==true\"><md-icon md-font-icon=\"icon-filter-remove-outline\">\n</md-icon><md-tooltip hide show-gt-xs><span translate=\"ACCOUNTS.RESET_SEARCH\"></span></md-tooltip></md-button><div \nclass=\"divider-vertical\" hide=\"\" show-gt-xs=\"\"></div></div><div layout=\"row\" layout-align=\"start center\" \ntranslate-attr-aria-label=\"ACCOUNTS.REFRESH\"><span class=\"page-info\" hide show-gt-xs>\n{{pagination_totalItems}} items found.</span><md-button aria-label=\"Previous\" class=\"md-icon-button arrow\" hide \nng-click=\"pagination_prevPage()\" ng-disabled=\"pagination_firstPage()\" show-gt-xs translate \ntranslate-attr-aria-label=\"CONTENT.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span \ntranslate=\"ACCOUNTS.PREVIOUS\">Previous</span></md-tooltip></md-button><span class=\"page-info\" hide show-gt-xs>\n{{pagination_page}} / {{pagination_total_pages}}</span><md-button aria-label=\"Next\" class=\"md-icon-button arrow\" hide \nng-click=\"pagination_nextPage()\" ng-disabled=\"pagination_morePages()\" show-gt-xs translate \ntranslate-attr-aria-label=\"CONTENT.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span \ntranslate=\"ACCOUNTS.NEXT\">Next</span></md-tooltip></md-button></div>");
$templateCache.put("app/main/apps/accounts/dialogs/edit-permission/edit-permission.html","<md-dialog class=\"medium edit-permission\" aria-label=\"New Task\"><md-toolbar \nclass=\"md-accent md-hue-2 md-default-theme\"><div class=\"md-toolbar-tools\"><div layout=\"row\"><a class=\"md-button\" \nlayout=\"row\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-view-list\" class=\"s18 mr-5 ml-0\"></md-icon><span \ntranslate=\"ACCOUNTS.EDIT_PERMISSION\"></span></a></div><span flex></span><div layout=\"row\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate \ntranslate-aria-label=\"ACCOUNTS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></div>\n</md-toolbar><md-dialog-content class=\"edit-permission\" flex><div class=\"form-wrapper pt-20 ph-0 json-editor\"><div \nclass=\"md-warm pv-10 ph-20\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-alert-circle\" \nclass=\"red-fg ml-0 mr-10\"></md-icon><strong translate=\"WIDGETS.JSON_ALERT_MESSAGE\" class=\"red-fg\"></strong></div>\n<md-input-container flex=\"100\" class=\"md-block mb-0 mh-20\"><label translate=\"WIDGETS.JSON\"></label><textarea \nng-keyup=\"vm.setValid()\" id=\"text-area-json-edit\">{{vm.permissionsJSON | json}}</textarea></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div flex layout=\"row\" \nlayout-align=\"end center\"><md-button type=\"button\" class=\"md-raised md-warn\" ng-click=\"vm.closeDialog()\" \ntranslate=\"FORMS.CANCEL\">Cancel</md-button><md-button ng-disabled=\"!vm.valid\" ng-click=\"vm.saveTab()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"save\" translate=\"ACCOUNTS.SAVE\" \ntranslate-attr-aria-label=\"ACCOUNTS.SAVE\">SAVE</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/accounts/dialogs/tabs-select/tabs-select.html","<md-dialog class=\"medium accounts-dialog attachment-dialog\" aria-label=\"New Task\"><md-toolbar \nclass=\"md-accent md-hue-2 md-default-theme\"><div class=\"md-toolbar-tools\"><div layout=\"row\"><a class=\"md-button\" \nlayout=\"row\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-view-list\" class=\"s18 mr-5 ml-0\"></md-icon><span \ntranslate=\"ACCOUNTS.SELECT_TAB\">Select tab</span></a></div><span flex></span><div layout=\"row\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate \ntranslate-aria-label=\"ACCOUNTS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></div>\n</md-toolbar><md-toolbar class=\"ng-scope _md md-default-theme _md-toolbar-transitions\"><div \nclass=\"md-toolbar-tools layout-align-space-between-center layout-row\" layout=\"row\" layout-align=\"space-between center\">\n<div></div><ms-search-bar-none flex class=\"expanded ms-search-bar\" debounce=\"300\" layout=\"row\" \nlayout-align=\"start center\"><div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\">\n<md-icon id=\"ms-search-bar-expander\" md-font-icon=\"icon-magnify\" \nclass=\"md-icon-button md-button md-default-theme md-font material-icons icon-magnify\" aria-label=\"Search\" \naria-hidden=\"true\"></md-icon></label><input id=\"ms-search-bar-input\" type=\"text\" name=\"tabSearch\" \nng-model=\"vm.tabSearch\" placeholder=\"Search\" md-autofocus translate translate-attr-placeholder=\"TOOLBAR.SEARCH\" flex \nclass=\"ng-pristine ng-valid ng-scope ng-empty md-autofocus ng-touched\" aria-invalid=\"false\"><md-icon \nid=\"ms-search-bar-collapser\" md-font-icon=\"icon-close-circle\" \nclass=\"icon s24 md-default-theme md-font material-icons icon-close-circle\" aria-hidden=\"true\"></md-icon></div>\n</ms-search-bar-none></div></md-toolbar><md-dialog-content class=\"mediadialog-content\" flex><div \nclass=\"content-wrapper\" flex layout=\"row\"><div ng-if=\"vm.nestedTabs\" class=\"treeview small\" \nivh-treeview=\"vm.nestedTabs\" ivh-treeview-filter=\"vm.tabSearch\" flex><script type=\"text/ng-template\">\n<div class=\"level-card\" layout=\"row\" layout-align=\"space-between center\">\r\n                        <div>\r\n                            <span ivh-treeview-toggle class=\"mr-5\">\r\n                                <span ivh-treeview-twistie></span>\r\n                            </span>\r\n                            <md-icon ng-if=\"node.icon\" md-font-icon=\"icon\" ng-class=\"node.icon\" class=\"mr-5\"></md-icon>\r\n                            <span class=\"ivh-treeview-node-label\" ivh-treeview-toggle>\r\n                              {{trvw.label(node)}}\r\n                            </span>\r\n                        </div>\r\n                        <md-treeview-box></md-treeview-box>\r\n                    </div>\r\n                    <div ivh-treeview-children></div>\n</script></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.saveTabs()\" class=\"send-button md-accent md-raised\" \naria-label=\"Apply\" translate=\"ACCOUNTS.APPLY\" translate-attr-aria-label=\"ACCOUNTS.APPLY\">APPLY</md-button></div>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/accounts/views/edit/edit-data.html","<div class=\"mail-content file-details scrollable\" ms-scroll=\"vm.msScrollOptions\"><div layout=\"row\"><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><div><md-input-container class=\"md-block on-off\"><button \nng-if=\"vm.selectedContent.active ===1\" class=\"md-icon-button md-button\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\" ng-click=\"vm.toggleItemStatusEdit(\'active\')\">\n</md-icon></button> <button ng-if=\"vm.selectedContent.active !==1\" class=\"md-icon-button md-button\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\" ng-click=\"vm.toggleItemStatusEdit(\'active\')\">\n</md-icon></button></md-input-container><md-input-container class=\"md-block\"><label>Firstname</label><input \ntype=\"text\" name=\"firstname\" ng-model=\"vm.selectedContent.first_name\" placeholder=\"Firstname\" autocomplete=\"false\">\n</md-input-container><md-input-container class=\"md-block\"><label>Lastname</label><input type=\"text\" name=\"lastname\" \nng-model=\"vm.selectedContent.last_name\" placeholder=\"Lastname\" autocomplete=\"false\"></md-input-container>\n<md-input-container class=\"md-block\"><label>Email</label><input type=\"email\" name=\"email\" \nng-model=\"vm.selectedContent.email\" placeholder=\"Email\" autocomplete=\"false\"></md-input-container><md-input-container \nclass=\"md-block\"><label>Password</label><input type=\"password\" name=\"password\" ng-model=\"vm.selectedContent.password\" \nplaceholder=\"Password\" autocomplete=\"false\"></md-input-container><md-input-container class=\"md-block\" \nng-if=\"vm.selectedContentID && vm.iconikGroups.length\"><label>{{ \'ACCOUNTS.ICONIK_GROUP\' | translate }}</label>\n<md-select ng-model=\"vm.iconikGroupId\" ng-change=\"vm.markIconikGroupDirty()\" md-on-close=\"vm.clearIconikGroupSearch()\" \nmd-container-class=\"iconik-group-menu\"><md-select-header class=\"select-header-search\"><input autofocus \nng-model=\"vm.iconikGroupSearch\" ng-change=\"vm.filterIconikGroups()\" type=\"search\" onkeydown=\"event.stopPropagation()\" \nplaceholder=\"{{ \'ACCOUNTS.ICONIK_GROUP_SEARCH\' | translate }}\" class=\"demo-header-searchbox md-text\">\n</md-select-header><md-option ng-value=\"null\" ng-if=\"!vm.iconikGroupSearch\">\n{{ \'ACCOUNTS.ICONIK_GROUP_NONE\' | translate }}</md-option><md-option \nng-repeat=\"g in vm.iconikGroupsFiltered track by g.id_group\" ng-value=\"g.id_group\" class=\"iconik-group-option\" \nng-class=\"[\'iconik-group-depth-\' + (g.depth > 5 ? 5 : g.depth), { \'is-match\': g.match }]\">{{ g.name }}</md-option><div \nclass=\"iconik-group-empty\" ng-if=\"vm.iconikGroupSearch && !vm.iconikGroupsFiltered.length\">\n{{ \'ACCOUNTS.ICONIK_GROUP_NO_RESULTS\' | translate }}</div></md-select></md-input-container></div></div></div></div>");
$templateCache.put("app/main/apps/accounts/views/edit/edit-new.html","<div class=\"mail-content file-details scrollable\" ms-scroll=\"vm.msScrollOptions\"><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><div><md-input-container class=\"md-block on-off\"><button \nng-if=\"vm.selectedContent.active ===1\" class=\"md-icon-button md-button\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\" ng-click=\"vm.toggleItemStatusEdit(\'active\')\">\n</md-icon></button> <button ng-if=\"vm.selectedContent.active !==1\" class=\"md-icon-button md-button\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\" ng-click=\"vm.toggleItemStatusEdit(\'active\')\">\n</md-icon></button></md-input-container><md-input-container class=\"md-block\"><label>Firstname</label><input \ntype=\"text\" name=\"firstname\" ng-model=\"vm.selectedContent.first_name\" placeholder=\"Firstname\" autocomplete=\"false\">\n</md-input-container><md-input-container class=\"md-block\"><label>Lastname</label><input type=\"text\" name=\"lastname\" \nng-model=\"vm.selectedContent.last_name\" placeholder=\"Lastname\" autocomplete=\"false\"></md-input-container>\n<md-input-container class=\"md-block\"><label>Email</label><input type=\"email\" name=\"email\" \nng-model=\"vm.selectedContent.email\" placeholder=\"Email\" autocomplete=\"false\"></md-input-container><md-input-container \nclass=\"md-block\"><label>Password</label><input type=\"password\" name=\"password\" ng-model=\"vm.selectedContent.password\" \nplaceholder=\"Password\" autocomplete=\"false\"></md-input-container></div></div><md-list><div \nng-repeat=\"virtualgroup in vm.customData.virtualgroups\"><md-list-item class=\"md-toolbar-tools grey-100-bg\"><div \nlayout=\"row\" layout-align=\"start center\" class=\"flex-50\"><h3 class=\"grey-700-fg\"><md-icon md-font-icon=\"icon s20\" \nng-class=\"virtualgroup.icon\"></md-icon>{{virtualgroup.name}}</h3></div><div layout=\"row\" layout-align=\"end center\" \nclass=\"flex-50\"><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"ACCOUNTS.ADDTABS\" ng-click=\"vm.openTabSelect($event, virtualgroup)\"><md-icon \nmd-font-icon=\"icon-cog\"></md-icon><md-tooltip><span translate=\"ACCOUNTS.ADD_REMOVE\">Add/remove sections</span>\n</md-tooltip></md-button></div></md-list-item><div class=\"virtualgroups-items\"><md-list-item flex=\"100\" \nclass=\"virtualgroups-item\" \nng-repeat=\"tab in vm.selectedContent.users_tabs | filter: {\'id_virtualgroup\': virtualgroup.id_virtualgroup}\"><div \nclass=\"handle\" ng-click=\"vm.preventDefault($event)\"><md-icon md-font-icon=\"icon-drag-vertical s20\" class=\"icon\">\n</md-icon></div><div class=\"text-truncate\" flex=\"100\"><div class=\"field\"><md-icon md-font-icon=\"icon s20\" \nng-class=\"vm.getTabIcon(tab)\"></md-icon><span ng-bind-html=\"vm.getTabName(tab)\"></span></div><md-divider></md-divider>\n</div></md-list-item></div><md-divider></md-divider></div></md-list></div>");
$templateCache.put("app/main/apps/accounts/views/edit/edit-tabs.html","<div class=\"mail-content file-details scrollable\" ms-scroll=\"vm.msScrollOptions\"><md-list><md-list-item \nng-if=\"vm.selectedContentID\" class=\"main-item\"><div class=\"main-read\"><div class=\"avatar-container\"><div \nng-if=\"(vm.selectedContent.avatar == \'\' || !vm.selectedContent.avatar)\" class=\"avatar\" \nng-bind=\"vm.selectedContent.first_name | capitalizeFirstLetter\" \nstyle=\"background-color:{{vm.selectedContent.profile_color}}\"></div><div ng-if=\"vm.selectedContent.avatar\" \nattachment=\"vm.selectedContent.avatar\"><img class=\"avatar hide show spinner-show\" \nng-src=\"{{vm.selectedContent.avatar}}\" imageonload=\"\"></div><md-icon ng-if=\"vm.selectedContent.active ===1\" \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\"></md-icon><md-icon \nng-if=\"vm.selectedContent.active !==1\" md-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\">\n</md-icon></div></div><div class=\"main-read\"><h1 class=\"name\"><strong ng-bind-html=\"vm.selectedContent.first_name\">\n</strong> <strong ng-bind-html=\"vm.selectedContent.last_name\"></strong></h1><p><span \nclass=\"font-size-16 text-truncate\" ng-bind-html=\"vm.selectedContent.email\"></span></p><md-divider></md-divider></div>\n</md-list-item><div ng-repeat=\"virtualgroup in vm.customData.virtualgroups\" ng-init=\"vm.sortableOpt(virtualgroup)\">\n<md-list-item class=\"md-toolbar-tools grey-100-bg\"><div layout=\"row\" layout-align=\"start center\" class=\"flex-50\"><h3 \nclass=\"grey-700-fg\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon\" ng-class=\"virtualgroup.icon\" \nclass=\"mr-8\"></md-icon><span>{{virtualgroup.name}}</span></h3></div><div layout=\"row\" layout-align=\"end center\" \nclass=\"flex-50\"><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"ACCOUNTS.ADDTABS\" ng-click=\"vm.openTabSelect($event, virtualgroup)\"><md-icon \nmd-font-icon=\"icon-cog\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"ACCOUNTS.ADD_REMOVE\">Add/remove sections\n</span></md-tooltip></md-button></div><md-divider></md-divider></md-list-item><div class=\"virtualgroups-items\" \nng-sortable=\"vm.sortableOptions[virtualgroup.id_virtualgroup]\"><md-list-item flex=\"100\" class=\"virtualgroups-item\" \nlayout=\"row\" layout-align=\"start center\" \nng-repeat=\"tab in vm.sortableTabs[virtualgroup.id_virtualgroup] | orderBy: \'sort\'\"><div class=\"handle ml-8 mr-8\" \nng-click=\"vm.preventDefault($event)\"><md-icon md-font-icon=\"icon-drag-vertical\" class=\"icon\"></md-icon></div><div \nclass=\"text-truncate\" flex=\"100\"><div class=\"field\"><md-icon md-font-icon=\"icon\" ng-class=\"vm.getTabIcon(tab)\" \nclass=\"mr-5 grey-600-fg\"></md-icon><span ng-bind-html=\"vm.getTabName(tab)\" class=\"grey-800-fg\"></span></div></div><div \nclass=\"edit-permission-icon\" ng-click=\"vm.editPermissionDialog($event, tab)\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"icon\"></md-icon></div><md-divider></md-divider></md-list-item></div></div></md-list></div>");
$templateCache.put("app/main/apps/accounts/views/edit/edit-view-nosplit.html","<div flex layout=\"column\" layout-align=\"center center\" ng-if=\"vm.loadingReadPane\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"30\"></md-progress-circular></div><div \nng-show=\"!vm.loadingReadPane\"><div class=\"mail-content\" layout=\"column\" layout-align=\"center center\" \nng-if=\"!vm.selectedContent\"><div class=\"content\" layout=\"column\" layout-align=\"top center\"><div class=\"message\">\nPlease select a user to show in this panel</div></div></div><div class=\"toolbar grey-100-bg colored-bg\" layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"vm.selectedContent\" scroll=\"\"><div layout=\"row\" layout-align=\"start center\">\n<md-button aria-label=\"Edit\" class=\"md-icon-button\" ng-click=\"vm.viewEditTabs()\" translate=\"\" \ntranslate-attr-aria-label=\"ACCOUNTS.EDIT_TABS\"><md-icon md-font-icon=\"icon-view-list\"></md-icon><md-tooltip><span \ntranslate=\"ACCOUNTS.EDIT_TABS\">Edit Tabs</span></md-tooltip></md-button><div class=\"divider-vertical\" hide=\"\" \nshow-gt-sm=\"\"></div><md-button aria-label=\"Edit\" class=\"md-icon-button\" ng-click=\"vm.viewEditData()\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.EDIT\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip><span \ntranslate=\"CONTENT.EDIT\">Edit</span></md-tooltip></md-button></div><div layout=\"row\" layout-align=\"end center\" \nng-if=\"vm.selectedContent\"><md-button type=\"submit\" ng-click=\"vm.saveItem(vm.selectedContent)\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"vm.basicForm.$invalid || vm.basicForm.$pristine\" \naria-label=\"SAVE\" translate=\"ACCOUNTS.SAVE\" translate-attr-aria-label=\"ACCOUNTS.SAVE\">SAVE</md-button><md-button \ntype=\"button\" ng-click=\"vm.closeThreadEdit()\" class=\"md-raised md-warn\" aria-label=\"Cancel\">Cancel</md-button></div>\n</div><form name=\"vm.basicForm\" class=\"md-inline-form\" novalidate><md-content \nng-if=\"vm.selectedContent && !vm.editData\" ng-include=\"\'app/main/apps/accounts/views/edit/edit-tabs.html\'\" \nclass=\"scrollable\"></md-content><md-content ng-if=\"vm.selectedContent && vm.editData\" \nng-include=\"\'app/main/apps/accounts/views/edit/edit-data.html\'\" class=\"scrollable\"></md-content></form></div>");
$templateCache.put("app/main/apps/accounts/views/edit/edit-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-if=\"vm.loadingReadPane\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nng-show=\"!vm.loadingReadPane\"><div class=\"mail-content\" layout=\"column\" layout-align=\"center center\" \nng-if=\"!vm.selectedContent\"><div class=\"content\" layout=\"column\" layout-align=\"top center\"><div class=\"message\">\nPlease select a user to show in this panel</div></div></div><div class=\"toolbar grey-100-bg colored-bg\" layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"vm.selectedContent\" scroll=\"\"><div layout=\"row\" layout-align=\"start center\" \nng-if=\"vm.selectedContentID\"><md-button class=\"md-icon-button close-thread\" aria-label=\"Back\" \nng-click=\"vm.closeThreadEdit()\" translate translate-attr-aria-label=\"ACCOUNTS.BACK\" \nng-if=\"vm.currentThread && vm.currentView==\'nosplit\'\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon>\n</md-button><md-button aria-label=\"Edit\" class=\"md-icon-button\" ng-click=\"vm.viewEditTabs()\" translate=\"\" \ntranslate-attr-aria-label=\"ACCOUNTS.EDIT_TABS\"><md-icon md-font-icon=\"icon-view-list\"></md-icon><md-tooltip><span \ntranslate=\"ACCOUNTS.EDIT_TABS\">Edit Tabs</span></md-tooltip></md-button><div class=\"divider-vertical\" hide=\"\" \nshow-gt-sm=\"\"></div><md-button aria-label=\"Edit\" class=\"md-icon-button\" ng-click=\"vm.viewEditData()\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.EDIT\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip><span \ntranslate=\"CONTENT.EDIT\">Edit</span></md-tooltip></md-button><div class=\"divider-vertical\" hide=\"\" show-gt-sm=\"\"></div>\n<md-button aria-label=\"Activity\" class=\"md-icon-button\" ng-click=\"vm.viewActivityTab()\" translate=\"\" \ntranslate-attr-aria-label=\"Activities\"><md-icon md-font-icon=\"icon-run\"></md-icon><md-tooltip><span \ntranslate=\"ACCOUNTS.ACTIVITY\"></span></md-tooltip></md-button><div class=\"divider-vertical\" hide=\"\" show-gt-sm=\"\">\n</div><md-button aria-label=\"PERMISSIONS\" class=\"md-icon-button\" \nng-click=\"vm.replacePermissionsDialog($event,vm.selectedContent)\" translate=\"\" translate-attr-aria-label=\"Activities\">\n<md-icon md-font-icon=\"icon-key-variant\"></md-icon><md-tooltip><span translate=\"ACCOUNTS.PERMISSIONS\"></span>\n</md-tooltip></md-button></div><div layout=\"row\" layout-align=\"end center\" ng-if=\"vm.selectedContent\" hide show-gt-sm>\n<md-button type=\"submit\" ng-click=\"vm.saveItem(vm.selectedContent)\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.basicForm.$invalid\" aria-label=\"SAVE\" translate=\"ACCOUNTS.SAVE\" \ntranslate-attr-aria-label=\"ACCOUNTS.SAVE\">SAVE</md-button><md-button type=\"button\" ng-click=\"vm.closeThreadEdit()\" \nclass=\"md-raised md-warn\" aria-label=\"Cancel\" translate=\"ACCOUNTS.CANCEL\" translate-attr-aria-label=\"ACCOUNTS.CANCEL\">\nCancel</md-button></div><div layout=\"row\" layout-align=\"end center\" ng-if=\"vm.selectedContent\" hide-gt-sm><md-button \ntype=\"submit\" ng-click=\"vm.saveItem(vm.selectedContent)\" \nclass=\"md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme\" \nng-disabled=\"vm.basicForm.$invalid || vm.basicForm.$pristine\" aria-label=\"SAVE\"><md-icon md-font-icon=\"icon-check\" \nng-hide=\"vm.savingProcess\"></md-icon><md-progress-circular md-mode=\"indeterminate\" ng-if=\"vm.savingProcess\">\n</md-progress-circular><md-tooltip hide show-gt-xs><span translate=\"ACCOUNTS.SAVE\">Save</span></md-tooltip></md-button>\n<md-button type=\"button\" ng-click=\"vm.closeThreadEdit()\" \nclass=\"md-warn md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme\" aria-label=\"Cancel\"><md-icon \nmd-font-icon=\"icon-window-close\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"ACCOUNTS.CANCEL\">Cancel</span>\n</md-tooltip></md-button></div></div><form name=\"vm.basicForm\" class=\"md-inline-form\" novalidate><md-content \nng-if=\"!vm.selectedContentID && vm.selectedContent && !vm.editData\" \nng-include=\"\'app/main/apps/accounts/views/edit/edit-new.html\'\" class=\"scrollable\"></md-content><md-content \nng-if=\"vm.selectedContentID && vm.selectedContent && !vm.editData\" \nng-include=\"\'app/main/apps/accounts/views/edit/edit-tabs.html\'\" class=\"scrollable\"></md-content><md-content \nng-if=\"vm.selectedContentID && vm.selectedContent && vm.editData && !vm.viewActivity\" \nng-include=\"\'app/main/apps/accounts/views/edit/edit-data.html\'\" class=\"scrollable\"></md-content><md-content \nng-if=\"vm.selectedContentID && vm.selectedContent && vm.editData && vm.viewActivity\" \nng-include=\"\'app/main/apps/accounts/views/edit/view-activity.html\'\" class=\"scrollable\"></md-content></form></div>");
$templateCache.put("app/main/apps/accounts/views/edit/view-activity.html","<div class=\"mail-content file-details scrollable\" ms-scroll=\"vm.msScrollOptions\"><md-list><md-list-item \nng-if=\"vm.selectedContentID\" class=\"main-item\"><div class=\"main-read\"><div class=\"avatar-container\"><div \nng-if=\"(vm.selectedContent.avatar == \'\' || !vm.selectedContent.avatar)\" class=\"avatar\" \nng-bind=\"vm.selectedContent.first_name | capitalizeFirstLetter\" \nstyle=\"background-color:{{vm.selectedContent.profile_color}}\"></div><div ng-if=\"vm.selectedContent.avatar\" \nattachment=\"vm.selectedContent.avatar\"><img class=\"avatar hide show spinner-show\" \nng-src=\"{{vm.selectedContent.avatar}}\" imageonload=\"\"></div><md-icon ng-if=\"vm.selectedContent.active ===1\" \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\"></md-icon><md-icon \nng-if=\"vm.selectedContent.active !==1\" md-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\">\n</md-icon></div></div><div class=\"main-read\"><h1 class=\"name\"><strong ng-bind-html=\"vm.selectedContent.first_name\">\n</strong> <strong ng-bind-html=\"vm.selectedContent.last_name\"></strong></h1><p><span \nclass=\"font-size-16 text-truncate\" ng-bind-html=\"vm.selectedContent.email\"></span></p></div></md-list-item><md-divider>\n</md-divider><md-list-item class=\"md-toolbar-tools grey-100-bg\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><h3 class=\"grey-700-fg\" translate=\"ACCOUNTS.ACTIVITY\"></h3></div>\n</md-list-item><md-divider></md-divider><div class=\"activities-list\"><table hide show-gt-lg><tr \nng-repeat=\"log in vm.selectedContent.log\"><td><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"{{log.module.icon_v3}}\" class=\"mr-10 ml-0 s30\"><md-tooltip hide show-gt-xs><span>{{log.module.title}}\n</span></md-tooltip></md-icon><div><div class=\"field module-name\" ng-if=\"log.id_service == 2\"><span \nclass=\"grey-800-fg\" ng-bind-html=\"log.section.languages[0].text\"></span></div><div class=\"field module-name\" \nng-if=\"log.id_service != 2\"><span class=\"grey-800-fg\" ng-bind-html=\"log.module.module_name\"></span></div></div></div>\n</td><td><div class=\"field\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"end center\"><span \nclass=\"grey-500-fg\" ng-bind-html=\"vm.timeAgo(log.date)\"></span></div></div></td><td><div class=\"field\"><span \nclass=\"grey-800-fg mr-5\">ID #{{log.id_from_section}}</span> <span class=\"grey-500-fg\" ng-bind-html=\"log.description\">\n</span></div></td><td><div class=\"field\" layout=\"row\" layout-align=\"end center\"><span \nclass=\"status {{log.action.action_name}}\" ng-bind-html=\"log.action.action_name\"></span></div></td></tr></table>\n<md-list-item hide-gt-lg ng-repeat=\"log in vm.selectedContent.log\" class=\"pl-16 pr-16\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"100\" class=\"layout-align-space-between-center layout-row\"><md-icon \nmd-font-icon=\"{{log.module.icon_v3}}\" class=\"mr-16 ml-0 s30\" hide show-gt-xs><md-tooltip hide show-gt-xs><span>\n{{log.module.module_name}}</span></md-tooltip></md-icon><div layout=\"column\" layout-align=\"center space-between \" \nclass=\"field flex\"><div layout=\"row\" layout-align-gt-xs=\"start center\" layout-align-xs=\"space-between center\" \nclass=\"mb-10\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"{{log.module.icon_v3}}\" \nclass=\"mr-5 ml-0\" hide-gt-xs><md-tooltip hide show-gt-xs><span>{{log.module.module_name}}</span></md-tooltip></md-icon>\n<div class=\"field mr-10 module-name\"><span class=\"grey-800-fg\" ng-if=\"log.id_service == 2\" \nng-bind-html=\"log.section.languages[0].text\"></span> <span class=\"grey-800-fg\" ng-if=\"log.id_service != 2\" \nng-bind-html=\"log.module.module_name\"></span></div><span class=\"grey-500-fg\" ng-bind-html=\"vm.timeAgo(log.date)\">\n</span></div><div class=\"field\" hide-gt-xs><span class=\"status {{log.action.action_name}}\" \nng-bind-html=\"log.action.action_name\"></span></div></div><div class=\"text-truncate\"><span class=\"grey-800-fg mr-5\">\nID #{{log.id_from_section}}</span> <span class=\"grey-500-fg\" ng-bind-html=\"log.description\"></span></div></div><div \nlayout=\"row\" layout-align=\"end center\" hide show-gt-xs><div class=\"field\"><span \nclass=\"status {{log.action.action_name.toUpperCase()}}\" ng-bind-html=\"log.action.action_name\"></span></div></div></div>\n<md-divider class=\"md-default-theme\"></md-divider></md-list-item></div></md-list></div>");
$templateCache.put("app/main/apps/accounts/sidenavs/main/main-sidenav.html","<md-toolbar class=\"md-theme-light md-default-theme md-light-blue-bg\"><h2 class=\"md-toolbar-tools\" aria-label=\"Filters\" \nlayout=\"row\" layout-align=\"space-between center\"><span translate-attr-aria-label=\"ACCOUNTS.FILTERS\" \ntranslate=\"ACCOUNTS.FILTERS\">Grupos</span> <button class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'main-sidenav\')\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></button></h2></md-toolbar><md-content ms-scroll class=\"content\" flex><div\n class=\"navigation-simple\" layout=\"column\">{{vm.refFilterables | json}}<div \nng-repeat=\"filterable in vm.refFilterables track by $index\">{{filterable | json}}</div></div></md-content>");
$templateCache.put("app/main/apps/ai/dialogs/select-event/select-event.html","<md-dialog class=\"select-events\" aria-label=\"New Message\"><md-toolbar class=\"md-accent md-hue-2\"><div layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title ml-16\" translate=\"AI.SELECT_EVENT\"></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content id=\"site-mailing\" ms-scroll flex class=\"content-card\"><div \nflex layout=\"row\" layout-align=\"start center\" class=\"p-15\"><md-radio-group ng-model=\"vm.currentThread\" \naria-labelledby=\"favoriteFruit\"><md-radio-button ng-repeat=\"event in vm.events | orderBy: \'tag_name\'\" ng-value=\"event\">\n{{event.tag_name}}</md-radio-button></md-radio-group></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container flex layout=\"row\" layout-align=\"end center\" class=\"m-0\">\n<md-button ng-click=\"vm.save()\" ng-disabled=\"vm.currentThread==null\" type=\"submit\" \nclass=\"send-button md-accent md-raised\" ng-click=\"vm.save()\" translate=\"AI.SELECT\"></md-button></md-input-container>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/accounts/views/grid/grid-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/users/views/list/toolbar.html\'\"></div><div class=\"content-wrapper\" flex=\"\" layout=\"row\"><div\n class=\"mail-tabs-grid\" flex=\"\" md-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"content mail-list-pane-grid\" \nflex=\"\" ms-scroll=\"\"><md-progress-circular md-mode=\"indeterminate\" ng-if=\"isLoading\"></md-progress-circular><div \nclass=\"no-threads\" ng-hide=\"isLoading\" ng-if=\"!isLoading && vm.inbox.length === 0\">There are no items!</div><ms-card \nng-model=\"mail\" ng-repeat=\"thread in vm.threads | filter: vm.search | filter: global.search\" \ntemplate=\"\'app/main/apps/users/views/grid/template-grid-1.html\'\"></ms-card></div></div></div>");
$templateCache.put("app/main/apps/accounts/views/grid/template-grid-1.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"space-between center\" flex><div \nlayout=\"column\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-attachment\" class=\"has-attachment s24\" \nng-if=\"thread.Thumbnail.length>0\"></md-icon><button ng-if=\"thread.onoff===1\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\"></md-icon></button> <button \nng-if=\"thread.onoff!==1\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-blank-circle-outline\" \nclass=\"off red-fg s24\"></md-icon></button></div><div layout=\"column\" layout-align=\"start center\"><md-checkbox \nclass=\"no-label\" ng-checked=\"vm.isChecked(mail)\" ng-click=\"vm.toggleCheck(mail, $event)\" \naria-label=\"{{vm.isChecked(mail)? \'Uncheck\':\'check\'}}\"></md-checkbox><div ng-if=\"vm.refcolumnsgrouped.main\"><div \nclass=\"subject text-truncate\"><span ng-repeat=\"field in vm.refcolumnsgrouped.header | orderBy: \'list-sort\'\" \nng-bind=\"thread.{{field.title}}\"></span></div></div></div></div><div class=\"media\" flex layout=\"row\" \nlayout-align=\"center center\">{{vm.refcolumnsgrouped | json}}<div \nng-repeat=\"field in vm.refcolumnsgrouped.left_center | orderBy:\'list_sort\'\" \nng-if=\"field.type == \'thumbnail_square\' || field.type == \'thumbnail_\'\"><img class=\"avatar square ng-scope\" \nalt=\"{{listImage.filename}}\" ng-if=\"thread.Thumbnail.length>0\" \nng-src=\"{{listImage.cropstatus[0].container.view_url}}{{listImage.cropstatus[0].fileName}}\" \nng-repeat=\"listImage in thread.Thumbnail | filter: {\'id_zone\':field.showtype} | limitTo:1\"> <img \nclass=\"avatar square ng-scope\" alt=\"No Image\" ng-if=\"(thread.Thumbnail|filter:{\'id_zone\':field.showtype}).length == 0\" \nng-src=\"assets/images/common/no_image_available_10.png\"></div><img class=\"image\" \nng-src=\"{{card.Thumbnail[0].crop_status[0].urlformed}}\" alt=\"{{card.media.image.alt}}\" imageonloadcontrol></div><div \nclass=\"header p-16\" layout=\"row\" layout-align=\"start\"><div class=\"info\" flex layout=\"column\"><div \nng-if=\"vm.refcolumnsgrouped.main\"><div class=\"name text-truncate\" layout=\"row\" layout-align=\"start center\"><span \nng-repeat=\"field in vm.refcolumnsgrouped.main\"><span ng-bind=\"thread.{{field.title}}\"></span>&nbsp;</span></div></div>\n<div><div class=\"name text-truncate\" layout=\"row\" layout-align=\"start center\"><span><span>Title</span></span></div>\n</div><div><div class=\"details\" layout=\"row\" layout-align=\"start start\"><div layout=\"column\"><span class=\"title\">label\n</span></div><div layout=\"column\" class=\"text-truncate\"><span class=\"detail\">name</span></div></div></div><div \nng-repeat=\"field in vm.refcolumnsgrouped.secondary | orderBy:\'list_sort\'\"><div \nng-if=\"(field.type!==\'date\' && field.type!==\'dateHm\') && field.primary!==1\" class=\"details\" layout=\"row\" \nlayout-align=\"start start\"><div layout=\"column\"><span class=\"title\" ng-bind=\"field.title\"></span></div><div \nlayout=\"column\" class=\"text-truncate\"><span class=\"detail\" ng-bind=\"thread.{{field.title}}\"></span></div></div></div>\n</div></div></div>");
$templateCache.put("app/main/apps/accounts/views/grid/template-grid.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s20\" ng-if=\"card.onoff===1\"></md-icon><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s20\" ng-if=\"card.onoff===0\"></md-icon><div \nclass=\"info\"><div class=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.Thumbnail[0].crop_status[0].urlformed}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.Thumbnail[0].crop_status[0]\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/main/apps/backend/dialogs/task/task-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between\"><span \nclass=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><md-input-container class=\"md-block\"><label translate=\"BACKEND.TITLE\">Title</label><input name=\"title\" \nng-model=\"vm.field.title\" required><div ng-messages=\"taskForm.title.$error\" ng-show=\"taskForm.title.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"BACKEND.ERRORS.TITLE_REQUIRED\">Title field is required</span>\n</div></div></md-input-container><md-input-container class=\"md-block\"><label translate=\"BACKEND.FIELD_NAME\">Field name\n</label><input name=\"title\" ng-model=\"vm.field.field_name\" required><div ng-messages=\"taskForm.title.$error\" \nng-show=\"taskForm.title.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"BACKEND.ERRORS.TITLE_REQUIRED\">Field name is required</span></div></div></md-input-container><div \nlayout-xs=\"column\" layout=\"row\" layout-align=\"space-between\"><div flex class=\"date-container\"><md-input-container \nlayout-fill flex><label>Select a type</label><md-select ng-model=\"vm.field.type\"><md-option \nng-repeat=\"type in vm.types\" value=\"{{type.value}}\">{{type.name}}</md-option></md-select></md-input-container></div>\n<div flex class=\"date-container\"><md-input-container layout-fill flex><label>Select a category</label><md-select \nng-model=\"vm.field.category\"><md-option ng-repeat=\"category in vm.categories\" value=\"{{category.value}}\">\n{{category.name}}</md-option></md-select></md-input-container></div></div><div><p class=\"section-title\">List</p></div>\n<div layout-xs=\"column\" layout=\"row\" layout-align=\"space-between\"><div flex class=\"date-container\"><md-input-container \nlayout-fill flex><label>Select a position</label><md-select ng-model=\"vm.field.list_position\"><md-option \nng-repeat=\"status in vm.statusesListPosition\" value=\"{{status.value}}\">{{status.name}}</md-option></md-select>\n</md-input-container></div><div flex class=\"date-container\"><md-input-container class=\"md-block\"><label \ntranslate=\"BACKEND.SORT_DIRECTION\">Sort</label><input name=\"lits_sort\" ng-model=\"vm.field.list_sort\">\n</md-input-container></div></div><div><p class=\"section-title\">Preview</p></div><div layout-xs=\"column\" layout=\"row\" \nlayout-align=\"space-between\"><div flex class=\"date-container\"><md-input-container layout-fill flex><label>\nSelect a position</label><md-select ng-model=\"vm.field.preview_position\"><md-option \nng-repeat=\"status in vm.statusesListPosition\" value=\"{{status.value}}\">{{status.name}}</md-option></md-select>\n</md-input-container></div><div flex class=\"date-container\"><md-input-container class=\"md-block\"><label \ntranslate=\"BACKEND.SORT_DIRECTION\">Sort</label><input name=\"preview_sort\" ng-model=\"vm.field.preview_sort\">\n</md-input-container></div></div><div><p class=\"section-title\">Edit</p></div><div layout-xs=\"column\" layout=\"row\" \nlayout-align=\"space-between\"><div flex class=\"date-container\"><md-input-container layout-fill flex><label>\nSelect a position</label><md-select ng-model=\"vm.field.edit_position\"><md-option \nng-repeat=\"status in vm.statusesListPosition\" value=\"{{status.value}}\">{{status.name}}</md-option></md-select>\n</md-input-container></div><div flex class=\"date-container\"><md-input-container class=\"md-block\"><label \ntranslate=\"BACKEND.SORT_DIRECTION\">Sort</label><input name=\"edit_sort\" ng-model=\"vm.field.edit_sort\">\n</md-input-container></div><div flex class=\"date-container\"><md-input-container flex><md-checkbox class=\"no-label\" \naria-label=\"Editable\" ng-model=\"vm.field.edit_editable\" ng-true-value=\"1\" ng-false-value=\"0\">Editable</md-checkbox>\n</md-input-container></div></div><div><p class=\"section-title\">Raw settings</p></div><div layout-xs=\"column\" \nlayout=\"row\" layout-align=\"space-between\"><div flex class=\"date-container\"><md-input-container layout-fill flex><label>\nSelect from section</label><md-select ng-change=\"vm.onSelectSection(vm.field.raw_settings.fromSection)\" \nng-model=\"vm.field.raw_settings.fromSection\"><md-option ng-repeat=\"section in vm.sections\" value=\"{{section.section}}\">\n{{section.section}}</md-option></md-select></md-input-container></div><div flex class=\"date-container\">\n<md-input-container ng-if=\"vm.field.raw_settings.fromSection\" layout-fill flex><label>Select field name</label>\n<md-select ng-model=\"vm.field.raw_settings.showField\"><md-option ng-repeat=\"field in vm.selectedSectionFields\" \nvalue=\"{{field.field_name}}\">{{field.field_name}}</md-option></md-select></md-input-container></div><div flex \nclass=\"date-container\"><md-input-container ng-if=\"vm.field.raw_settings.fromSection\" layout-fill flex><label>\nSelect field name</label><md-select ng-model=\"vm.field.raw_settings.orderField\"><md-option \nng-repeat=\"field in vm.selectedSectionFields\" value=\"{{field.field_name}}\">{{field.field_name}}</md-option></md-select>\n</md-input-container></div><div flex class=\"date-container\"><md-input-container \nng-if=\"vm.field.raw_settings.orderSort\" layout-fill flex><label>Select default order</label><md-select \nng-model=\"vm.field.raw_settings.orderSort\"><md-option ng-repeat=\"type in vm.typeOrder\" value=\"{{type.value}}\">\n{{type.name}}</md-option></md-select></md-input-container></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ntype=\"submit\" ng-if=\"!vm.newTask\" ng-click=\"vm.saveTask()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"taskForm.$invalid || taskForm.$pristine\" aria-label=\"SAVE\" translate=\"BACKEND.SAVE\" \ntranslate-attr-aria-label=\"BACKEND.SAVE\">SAVE</md-button><md-button type=\"submit\" ng-if=\"vm.newTask\" \nng-click=\"vm.addNewTask()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"taskForm.$invalid || taskForm.$pristine\" aria-label=\"Add Task\" translate=\"BACKEND.ADD_TASK\" \ntranslate-attr-aria-label=\"BACKEND.ADD_FIELD\">ADD FIELD</md-button></div><div layout=\"row\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.deleteTask($event)\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"BACKEND.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span \ntranslate=\"BACKEND.DELETE\">DELETE</span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/accounts/views/list/list-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-show=\"isLoading\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nclass=\"mail-list-item filter-selected\" ng-if=\"sortField\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\" flex><div class=\"info\" ng-if=\"sortField\"><div class=\"name\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-sort-ascending\" class=\"s20 mr-5 ml-0 mb-0\" \nng-if=\"sortDir === \'ASC\'\"></md-icon><md-icon md-font-icon=\"icon-sort-descending\" class=\"s20 mr-5 ml-0 mb-0\" \nng-if=\"sortDir === \'DESC\'\"></md-icon><div class=\"title text-truncate\" layout=\"row\" layout-align=\"start center\">\nOrdered by \'{{sortField}}\'</div></div></div></div><div class=\"buttons\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-close s20\" ng-click=\"pagination_resetOrderBy()\" class=\"ml-10\"><md-tooltip hide show-gt-xs>\n<span translate=\"CONTENT.REMOVE\">Remove</span></md-tooltip></md-icon></div></div><div class=\"no-threads\" \nng-if=\"!isLoading && vm.threads.length === 0\" ng-hide=\"isLoading\">There are no items!</div><div id=\"list-content-data\" \nng-style=\"{\'opacity\' : isLoading ? 0.2 : 1}\" ms-scroll=\"vm.msScrollOptions\" \nng-class=\"{\'group-filter\': vm.selectedGroup,\'other-filter\':sortField}\" class=\"scrollable\" \nng-if=\"vm.threads.length > 0\"><div ng-if=\"vm.currentLabelsFilter\" class=\"labels\"><form novalidate><div><div \nng-repeat=\"item in vm.currentLabelsFilter track by $index\" class=\"tag\" fxlayout=\"row\" fxlayoutalign=\"start center\"><div\n class=\"tag-label\">{{item.label}}<md-icon ng-click=\"vm.deleteTargetFilter(item.id, $index)\" md-font-icon=\"icon-close\" \nclass=\"s24 pointer\"></md-icon></div></div></div></form></div><div class=\"mail-list-item {{thread.status}}\" \nng-repeat=\"thread in vm.threads | filter: vm.search | filter: global.search\" md-no-ink ng-init=\"parentIndex = $index\" \nng-click=\"vm.openThread(thread)\" \nng-class=\"{\'starred\': thread.starred, \'selected\': vm.selectedContentID === thread.id_user, \'checked\': vm.isChecked(thread)}\">\n<div layout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-label\" ng-checked=\"vm.isSelected(thread)\" \nng-click=\"vm.toggleSelectThread(thread, $event)\" aria-label=\"{{vm.isSelected(thread) ? \'Deselect\' : \'Select\'}}\">\n</md-checkbox><div class=\"info\" flex layout=\"column\"><div><div class=\"name\" layout=\"row\" layout-align=\"start center\">\n<div ng-if=\"(thread.avatar == \'\' || !thread.avatar)\" class=\"avatar\" \nng-bind=\"thread.first_name | capitalizeFirstLetter\" style=\"background-color:{{thread.profile_color}}\"></div><div \nclass=\"image avatar\" ng-if=\"thread.avatar\" attachment=\"thread.avatar\"><img class=\"avatar hide show spinner-show\" \nng-src=\"{{thread.avatar}}\" imageonload></div><div class=\"user-name text-truncate\"><span ng-bind=\"thread.first_name\" \nng-if=\"thread.first_name\"></span> <span ng-bind=\"thread.last_name\" ng-if=\"thread.last_name\"></span><div \nclass=\"details\" layout=\"row\" layout-align=\"start start\"><span class=\"text-truncate title\" ng-bind=\"thread.email\">\n</span></div></div></div></div></div><div><button ng-if=\"thread.active===1\" class=\"md-icon-button md-button\" \nng-click=\"vm.toggleItemStatus(thread, $event, parentIndex)\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" \nclass=\"on green-fg s24\"></md-icon></button> <button ng-if=\"thread.active!==1\" class=\"md-icon-button md-button\" \nng-click=\"vm.toggleItemStatus(thread, $event, parentIndex)\"><md-icon md-font-icon=\"icon-checkbox-blank-circle-outline\" \nclass=\"off red-fg s24\"></md-icon></button></div><div layout=\"column\" layout-align=\"space-between end\"></div></div>\n</div><div class=\"toolbar\" layout=\"row\" layout-align=\"end center\"><div layout=\"row\" layout-align=\"center center\" \nng-style=\"{\'display\' : isLoading ? \'none\' : \'block\'}\"><span class=\"page-info\">{{pagination_totalItems}} items found.\n</span><md-button aria-label=\"Previous\" class=\"md-icon-button arrow\" ng-click=\"pagination_prevPage()\" \nng-disabled=\"pagination_firstPage()\" translate=\"\" translate-attr-aria-label=\"CONTENT.PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span translate=\"CONTENT.PREVIOUS\">Previous</span></md-tooltip>\n</md-button><span class=\"page-info\">{{pagination_page}} / {{pagination_total_pages}}</span><md-button \naria-label=\"Next\" class=\"md-icon-button arrow\" ng-click=\"pagination_nextPage()\" \nng-disabled=\"pagination_morePages() || pagination_total_pages === pagination_page\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span \ntranslate=\"CONTENT.NEXT\">Next</span></md-tooltip></md-button></div></div></div>");
$templateCache.put("app/main/apps/accounts/views/list/nosplit-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/accounts/views/list/toolbar.html\'\" ng-hide=\"vm.currentThread || vm.currentThread_Edit\">\n</div><div class=\"content-wrapper\" flex=\"\" layout=\"row\"><div class=\"content thread-list mail-list-pane\" flex=\"\" \nid=\"thread-list\" ng-if=\"!vm.selectedContent\" ng-include=\"\'app/main/apps/accounts/views/list/list-view.html\'\"></div><div\n class=\"content thread-detail mail-read-pane\" flex=\"\" id=\"thread-detail\" layout=\"column\" ng-if=\"vm.selectedContent\" \nng-include=\"\'app/main/apps/accounts/views/edit/edit-view.html\'\"></div></div>");
$templateCache.put("app/main/apps/accounts/views/list/split-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/accounts/views/list/toolbar.html\'\"></div><div class=\"content-wrapper\" flex=\"\" layout=\"row\">\n<div class=\"content thread-list mail-list-pane\" flex=\"50\" id=\"thread-list\" \nng-include=\"\'app/main/apps/accounts/views/list/list-view.html\'\"></div><div \nclass=\"content thread-detail mail-read-pane\" flex=\"50\" id=\"thread-detail\" layout=\"column\" \nng-include=\"\'app/main/apps/accounts/views/edit/edit-view.html\'\"></div></div>");
$templateCache.put("app/main/apps/accounts/views/list/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-label\" \naria-label=\"{{vm.selectedThreads.length > 0 ? \'Deselect All\' : \'Select All\'}}\" \nng-checked=\"vm.selectedThreads.length > 0\" ng-click=\"vm.toggleSelectThreads()\"></md-checkbox><div \nclass=\"divider-vertical\" hide show-gt-xs></div><md-button aria-label=\"ADD NEW\" \nclass=\"md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme\" hide show-gt-sm \nng-click=\"vm.newThread()\" translate=\"CONTENT.ADD\" type=\"button\">Add new</md-button><md-button aria-label=\"ADD NEW\" \nclass=\"md-fab md-mini md-accent green-500-bg md-raised md-ink-ripple md-default-theme\" hide-gt-sm \nng-click=\"vm.newThread()\" type=\"button\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><div \nclass=\"divider-vertical\" hide show-gt-xs></div><div aria-hidden=\"false\" \nclass=\"action-buttons hide show-gt-xs layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\" \nng-show=\"vm.selectedThreads.length > 0\"><md-button ng-click=\"vm.massActions(\'delete\')\" aria-label=\"Delete\" \nclass=\"md-icon-button\" hide show-gt-sm translate translate-attr-aria-label=\"ACCOUNTS.DELETE\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"ACCOUNTS.DELETE\">Delete</span></md-tooltip>\n</md-button><div class=\"divider-vertical\" hide show-gt-xs></div></div><ms-search-bar debounce=\"300\" \nmodel-search=\"$root.pagination_searchquery\" on-result-click=\"vm.searchResultClick(item)\" on-search=\"vm.search(query)\" \nlayout=\"row\" layout-align=\"start center\"></ms-search-bar><md-button ng-click=\"$root.pagination_resetquery()\" \naria-label=\"view type\" class=\"md-icon-button\" translate=\"\" translate-attr-aria-label=\"ACCOUNTS.RESET_SEARCH\" \nclass=\"md-icon-button\" ng-if=\"$root.pagination_searchquery==true\"><md-icon md-font-icon=\"icon-filter-remove-outline\">\n</md-icon><md-tooltip hide show-gt-xs><span translate=\"ACCOUNTS.RESET_SEARCH\"></span></md-tooltip></md-button><div \nclass=\"divider-vertical\" hide show-gt-xs></div><md-button aria-label=\"Sort Direction\" class=\"md-icon-button\" \nng-click=\"vm.setSortOrder(\'ASC\')\" ng-disabled=\"!sortField\" ng-if=\"sortDir !== \'ASC\'\" translate \ntranslate-attr-aria-label=\"TODO.SORT_DIRECTION\"><md-icon md-font-icon=\"icon-sort-ascending\" ng-if=\"sortDir !== \'ASC\'\">\n</md-icon><md-icon md-font-icon=\"icon-sort-descending\" ng-if=\"sortDir === \'ASC\'\"></md-icon></md-button><md-button \naria-label=\"Sort Direction\" class=\"md-icon-button\" ng-click=\"vm.setSortOrder(\'DESC\')\" ng-disabled=\"!sortField\" \nng-if=\"sortDir === \'ASC\'\" translate translate-attr-aria-label=\"TODO.SORT_DIRECTION\"><md-icon \nmd-font-icon=\"icon-sort-ascending\" ng-if=\"sortDir !== \'ASC\'\"></md-icon><md-icon md-font-icon=\"icon-sort-descending\" \nng-if=\"sortDir === \'ASC\'\"></md-icon></md-button></div><div layout=\"row\" layout-align=\"start center\" \ntranslate-attr-aria-label=\"ACCOUNTS.REFRESH\"><span class=\"page-info\" hide show-gt-xs>\n{{pagination_totalItems}} items found.</span><md-button aria-label=\"Previous\" class=\"md-icon-button arrow\" hide \nng-click=\"pagination_prevPage()\" ng-disabled=\"pagination_firstPage()\" show-gt-xs translate \ntranslate-attr-aria-label=\"CONTENT.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span \ntranslate=\"ACCOUNTS.PREVIOUS\">Previous</span></md-tooltip></md-button><span class=\"page-info\" hide show-gt-xs>\n{{pagination_page}} / {{pagination_total_pages}}</span><md-button aria-label=\"Next\" class=\"md-icon-button arrow\" hide \nng-click=\"pagination_nextPage()\" ng-disabled=\"pagination_morePages()\" show-gt-xs translate \ntranslate-attr-aria-label=\"CONTENT.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span \ntranslate=\"ACCOUNTS.NEXT\">Next</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.changeView(\'nosplit\')\" ng-if=\"vm.currentView !== \'nosplit\'\" hide aria-label=\"noSplit\" show-gt-sm><md-icon \nmd-font-icon=\"icon-view-list\" ng-if=\"vm.currentView !== \'nosplit\'\"></md-icon><md-icon class=\"md-accent\" \nmd-font-icon=\"icon-checkbox-marked\" ng-if=\"vm.currentView === \'nosplit\'\"></md-icon><md-tooltip><span \ntranslate=\"ACCOUNTS.NOSPLIT_VIEW\">No split</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.changeView(\'split\')\" ng-if=\"vm.currentView !== \'split\'\" hide aria-label=\"Split\" show-gt-sm><md-icon \nmd-font-icon=\"icon-view-quilt\" ng-if=\"vm.currentView !== \'split\'\"></md-icon><md-icon class=\"md-accent\" \nmd-font-icon=\"icon-checkbox-marked\" ng-if=\"vm.currentView === \'split\'\"></md-icon><md-tooltip><span \ntranslate=\"ACCOUNTS.SPLIT_VIEW\">split</span></md-tooltip></md-button><md-menu class=\"settings-menu\" hide-gt-xs \nng-show=\"vm.selectedThreads.length > 0\"><md-button aria-label=\"Settings\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\" translate translate-attr-aria-label=\"CONTENT.SETTINGS\"><md-icon \nmd-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content><md-menu-item><md-menu-item><md-button \nng-click=\"vm.massActions(\'delete\')\" aria-label=\"Delete\" translate-aria-label=\"CONTENT.DELETE\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><span translate=\"CONTENT.DELETE\">Delete </span><span translate=\"CONTENT.SELECTED\">\nSelected</span></md-button></md-menu-item></md-menu-item></md-menu-content></md-menu></div>");
$templateCache.put("app/main/apps/ai/views/grid/grid-view.html","<div class=\"content-wrapper\" flex=\"\" layout=\"row\"><div class=\"mail-tabs-grid\" flex=\"\" md-dynamic-height=\"true\"><div \nclass=\"content mail-list-pane-grid\"><md-tabs md-dynamic-height md-selected=\"vm.selectedTabIndex\" \nng-disabled=\"!vm.basicForm.$pristine\"><md-tab md-on-select=\"vm.onTabSelected(\'recognized_profiles\')\"><span \ntranslate=\"AI.PROFILES\"></span></md-tab><md-tab md-on-select=\"vm.onTabSelected(\'unrecognized_profiles\')\"><span \ntranslate=\"AI.UNRECOGNIZED_PROFILES\"></span></md-tab><md-tab md-on-select=\"vm.onTabSelected(\'recognized_media\')\"><span \ntranslate=\"AI.RECOGNIZED_MEDIA\"></span></md-tab><md-tab md-on-select=\"vm.onTabSelected(\'unrecognized_media\')\"><span \ntranslate=\"AI.UNRECOGNIZED_MEDIA\"></span></md-tab><md-tab md-on-select=\"vm.onTabSelected(\'all_media\')\"><span \ntranslate=\"AI.ALL_MEDIA\"></span></md-tab></md-tabs><md-content class=\"fullheight\" style=\"overflow:unset\"><div \nng-include=\"vm.tabViews[vm.currentTabView]\" class=\"tabs-view\"></div></md-content></div></div></div>");
$templateCache.put("app/main/apps/ai/views/list/list-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-if=\"vm.isLoading\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div class=\"no-threads\" \nng-if=\"!vm.isLoading && vm.threads.length === 0\" ng-hide=\"vm.isLoading\">There are no items!</div><div \nid=\"list-content-data\" ng-style=\"{\'opacity\' : vm.isLoading ? 0.2 : 1}\" ms-scroll=\"vm.msScrollOptions\" \nng-class=\"{\'group-filter\': vm.selectedGroup,\'other-filter\':sortField}\" ng-if=\"vm.threads.length> 0\" \nstyle=\"max-height: calc(100vh - 180px); overflow-y: scroll\"><div class=\"mail-list-item\" ng-click=\"vm.openFace(item)\" \nng-repeat=\"item in vm.threads\" md-no-ink ng-init=\"parentIndex= $index\" \nng-class=\"{\'starred\': item.starred, \'selected\': vm.selectedFace.id_media === item.id_media, \'checked\':\r\n    vm.isChecked(item)}\">\n<div layout=\"row\" layout-align=\"start center\"><div class=\"info\" flex layout=\"column\"><div layout=\"row\" \nlayout-align=\"start center\"><media class=\"avatar\" attachment=\"item\" thumbnail=\"true\"></media><div class=\"name ph-15\" \nlayout=\"row\" layout-align=\"start center\"><span>\n{{(item.runnerTag ? item.runnerTag.tag_name : \'\' ) + \' \' + (item.numberTag ? \'(\' + item.numberTag.tag_name + \')\' : \'\' ) }}\n</span></div></div></div><div layout=\"column\" layout-align=\"space-between end\"></div></div></div><div class=\"toolbar\" \nlayout=\"row\" layout-align=\"end center\"><div layout=\"row\" layout-align=\"center center\" \nng-style=\"{\'display\' : vm.isLoading ? \'none\' : \'block\'}\"><span class=\"page-info\">{{pagination_totalItems}} items found.\n</span><md-button aria-label=\"Previous\" class=\"md-icon-button arrow\" ng-click=\"vm.pagination_prevPage()\" \nng-disabled=\"pagination_firstPage()\" translate=\"\" translate-attr-aria-label=\"CONTENT.PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span translate=\"CONTENT.PREVIOUS\">Previous</span></md-tooltip>\n</md-button><span class=\"page-info\">{{pagination_page}} / {{pagination_total_pages}}</span><md-button \naria-label=\"Next\" class=\"md-icon-button arrow\" ng-click=\"vm.pagination_nextPage()\" \nng-disabled=\"pagination_morePages() || pagination_total_pages === pagination_page\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span \ntranslate=\"CONTENT.NEXT\">Next</span></md-tooltip></md-button></div></div></div>");
$templateCache.put("app/main/apps/ai/views/list/nosplit-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/ai/views/list/toolbar.html\'\" ng-hide=\"vm.currentThread || vm.currentThread_Edit\"></div><div \nclass=\"content-wrapper\" flex=\"\" layout=\"row\"><div class=\"content thread-detail mail-read-pane\" flex=\"\" \nid=\"thread-detail\" ms-scroll=\"vm.msScrollOptions\" ng-if=\"vm.currentThread || vm.currentThread_Edit\" \nng-include=\"\'app/main/apps/ai/views/read/read-view-nosplit.html\'\"></div><div \nclass=\"content thread-list mail-list-pane\" flex id=\"thread-list\" ng-if=\"!vm.currentThread && !vm.currentThread_Edit\" \nng-include=\"\'app/main/apps/ai/views/list/list-view.html\'\"></div></div>");
$templateCache.put("app/main/apps/ai/views/list/split-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/ai/views/list/toolbar.html\'\"></div><div class=\"content-wrapper\" flex=\"\" layout=\"row\"><div \nclass=\"content thread-list mail-list-pane\" flex=\"{{vm.currentThread ? \'50\' : \'100\'}}\" id=\"thread-list\" layout=\"column\" \nng-include=\"\'app/main/apps/ai/views/list/list-view.html\'\"></div><div class=\"content thread-detail mail-read-pane\" \nflex=\"{{vm.currentThread ? \'50\' : \'0\'}}\" id=\"thread-detail\" layout=\"column\" \nng-include=\"\'app/main/apps/ai/views/read/read-view.html\'\"></div></div>");
$templateCache.put("app/main/apps/calendar/dialogs/event-detail/event-detail-dialog.html","<md-dialog class=\"event-detail-dialog\" aria-label=\"New Message\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\"><span class=\"title\">{{vm.calendarEvent.title}}</span> <span flex></span><md-button \nclass=\"edit-event-button md-fab md-warn\" ng-click=\"vm.editEvent(vm.calendarEvent)\" aria-label=\"Edit event\" translate \ntranslate-attr-aria-label=\"CALENDAR.EDIT_EVENT\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div class=\"event-details\" layout=\"column\"><div class=\"event-detail-row\" \nlayout=\"row\" layout-align=\"start start\"><md-icon md-font-icon=\"icon-clock\"></md-icon><div layout=\"column\" flex><span \nclass=\"h4\">{{vm.calendarEvent.start.format(\'MMMM Do YYYY, h:mm:ss a\')}} <span ng-if=\"vm.calendarEvent.end\">-</span>\n {{vm.calendarEvent.end.format(\'MMMM Do YYYY, h:mm:ss a\')}}</span> <span class=\"secondary-text\">\n{{vm.calendarEvent.repeat || \'Does not repeat\'}}</span></div></div><div class=\"event-detail-row\" layout=\"row\" \nlayout-align=\"start start\"><md-icon md-font-icon=\"icon-bell-ring-outline\"></md-icon><div layout=\"column\" flex><span \nclass=\"h4\" translate=\"CALENDAR.30_MIN_BEFORE\">30 minutes before</span> <span class=\"h4\" \ntranslate=\"CALENDAR.15_MIN_BEFORE\">15 minutes before</span> <span class=\"h4\" translate=\"CALENDAR.30_MIN_LATER\">\n30 minutes later</span></div></div><div class=\"event-detail-row\" layout=\"row\" layout-align=\"start start\"><md-icon \nmd-font-icon=\"icon-map-marker\"></md-icon><div layout=\"column\" flex><span class=\"h4\">Istanbul, Turkey</span></div></div>\n<div class=\"event-detail-row\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-account\"></md-icon>\n<div layout=\"row\" flex><img src=\"assets/images/avatars/alice.jpg\" class=\"avatar\" alt=\"alice\"> <img \nsrc=\"assets/images/avatars/joyce.jpg\" class=\"avatar\" alt=\"joyce\"> <img src=\"assets/images/avatars/vincent.jpg\" \nclass=\"avatar\" alt=\"vincent\"></div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/ai/views/read/read-view.html","<div ng-if=\"vm.selectedFace\"><div layout=\"row\"><div layout=\"column\" flex=\"80\"><div layout=\"row\"><div \nng-click=\"vm.openImageDialog($event, false, vm.selectedFaceData.cropstatus, vm.selectedFaceData, true)\" \nclass=\"pointer avatar text-left m-15\" style=\"height: 150px;width: 150px\"><img style=\"height: 100%; width: 100%\" \nng-src=\"{{vm.selectedFaceData.imageUrlOriginal}}\" alt=\"\"></div><h2 style=\"line-height: 150px\">\n{{(vm.selectedFaceData.runnerTag ? vm.selectedFaceData.runnerTag.tag_name : \'\' ) + \' \' + (vm.selectedFaceData.numberTag ? \'(\' + vm.selectedFaceData.numberTag.tag_name + \')\' : \'\' ) }}\n</h2></div></div><div layout=\"column\" flex=\"20\" layout-align=\"center center\"><div layout=\"row\"><md-button \naria-label=\"TAG_UNRECOGNIZED_IMAGES_BY_FACE\" \nclass=\"md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme mr-30\" \nng-click=\"vm.tagUnrecognizedImagesByFaceId(vm.selectedFaceData)\" translate=\"AI.TAG_UNRECOGNIZED_IMAGES_BY_FACE\" \ntype=\"button\"><span translate=\"AI.TAG_UNRECOGNIZED_IMAGES_BY_FACE\"><md-tooltip hide show-gt-xs><span \ntranslate=\"AI.TAG_UNRECOGNIZED_IMAGES_BY_FACE\">Recognized</span></md-tooltip></span></md-button></div></div></div><div \nclass=\"toolbar grey-100-bg colored-bg\" layout=\"row\" layout-align=\"space-between center\" scroll=\"\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button aria-label=\"Preview\" ng-class=\"md-accent\" translate=\"AI.RECOGNIZED\" \ntranslate-attr-aria-label=\"AI.RECOGNIZED\"><md-tooltip hide show-gt-xs><span translate=\"AI.RECOGNIZED\">Recognized</span>\n</md-tooltip></md-button></div></div><div class=\"faces-content\"><div flex layout=\"column\" layout-align=\"center center\" \nng-if=\"vm.isLoadingRelated\" class=\"loading-container mt-60\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"50\"></md-progress-circular></div><div ng-if=\"vm.mediaRelated && !vm.isLoadingRelated\" fill-width \nlayout=\"column\"><div style=\"overflow: auto;max-height: calc(100vh - 425px)\" class=\"grid-view\" flex md-cols=\"2\"><div \nng-if=\"!mediaItem.hidden\" ng-repeat=\"mediaItem in vm.mediaRelated\" data-id=\"{{mediaItem.id_media}}\" \nclass=\"ms-card grid-element sortable\"><div class=\"ms-card-content-wrapper\" \nng-class=\"{\'detected-unrelated-border\': mediaItem.isUndetectedRelated}\"><div class=\"template-9\" layout=\"column\" \nlayout-align=\"space-between stretch\"><div \nng-click=\"vm.openFacesRelatedInImageDialog($event, vm.mediaRelated,mediaItem, false, true)\" class=\"media\" flex \nlayout=\"row\" layout-align=\"center center\"><media attachment=\"mediaItem\" class-img=\"image\"></media></div><div \nclass=\"header p-16\" flex><div layout=\"row\" layout-align=\"space-between center\" flex><div class=\"ml-25 size block\" \nlayout=\"row\" layout-align=\"start left\"><strong class=\"mr-5\">#{{mediaItem.id_media}}</strong> <span class=\"grey-500-fg\">\n<span ng-if=\"mediaItem.filename\" class=\"filename\">{{mediaItem.filename}}</span> </span><button \nclass=\"md-primary confirm-detected-unrelated\" layout=\"row\" layout-align=\"center center\" \nng-click=\"vm.confirmDetectedUnrelated(vm.selectedFaceData, mediaItem)\" ng-if=\"mediaItem.isUndetectedRelated\"><md-icon \nng-if=\"!mediaItem.loadingMediaItem\" md-font-icon=\"icon-check\"></md-icon><md-progress-circular \nng-if=\"mediaItem.loadingMediaItem\" md-mode=\"indeterminate\" md-diameter=\"25\"></md-progress-circular></button> <button \nclass=\"md-primary remove-tag\" layout=\"row\" layout-align=\"center center\" \nng-click=\"vm.deleteIncorrectTags(vm.selectedFaceData, mediaItem)\" ng-if=\"!mediaItem.isUndetectedRelated\"><md-icon \nng-if=\"!mediaItem.loadingMediaItem\" md-font-icon=\"icon-close\"></md-icon><md-progress-circular \nng-if=\"mediaItem.loadingMediaItem\" md-mode=\"indeterminate\" md-diameter=\"25\"></md-progress-circular></button></div>\n</div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/apps/backend/sidenavs/main/main-sidenav.html","<md-content class=\"content\" flex ms-scroll></md-content>");
$templateCache.put("app/main/apps/calendar/dialogs/event-form/event-form-dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container \nclass=\"md-block\"><label translate=\"CALENDAR.TITLE\">Title</label><input name=\"title\" ng-model=\"vm.calendarEvent.title\" \nrequired><div ng-messages=\"eventForm.title.$error\" ng-show=\"eventForm.title.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"CALENDAR.ERRORS.TITLE_REQUIRED\">Title field is required</span></div></div>\n</md-input-container><md-list class=\"all-day\"><md-list-item><p translate=\"CALENDAR.ALL_DAY\">All Day</p><md-switch \nclass=\"md-secondary\" ng-model=\"vm.calendarEvent.allday\" aria-label=\"All day\" translate \ntranslate-attr-aria-label=\"CALENDAR.ALL_DAY\"></md-switch></md-list-item></md-list><div layout=\"row\" class=\"date-row\">\n<md-datepicker ng-model=\"vm.calendarEvent.start\" md-placeholder=\"Start Date\"></md-datepicker><md-input-container flex \nmd-no-float><input ng-model=\"vm.calendarEvent.startTime\" placeholder=\"Start Time\" translate \ntranslate-attr-placeholder=\"CALENDAR.START_TIME\"></md-input-container></div><div layout=\"row\" class=\"date-row\">\n<md-datepicker ng-model=\"vm.calendarEvent.end\" md-placeholder=\"End Date\"></md-datepicker><md-input-container flex \nmd-no-float><input ng-model=\"vm.calendarEvent.endTime\" placeholder=\"End Time\" translate \ntranslate-attr-placeholder=\"CALENDAR.END_TIME\"></md-input-container></div><md-input-container class=\"md-block\" flex>\n<label translate=\"CALENDAR.REPEAT\">Repeat</label><input ng-model=\"vm.calendarEvent.repeat\"></md-input-container>\n<md-input-container class=\"md-block\" flex><label translate=\"CALENDAR.LOCATION\">Location</label><input \nng-model=\"vm.calendarEvent.location\"></md-input-container><div class=\"notifications\" layout=\"column\"><div \nclass=\"title\" translate=\"CALENDAR.NOTIFICATIONS\">Notifications</div><md-select ng-model=\"notification\" \nplaceholder=\"Notification\" ng-repeat=\"notification in vm.calendarEvent.notifications\"><md-option \nng-repeat=\"opt in vm.notifications\" value=\"{{opt}}\">{{opt}}</md-option></md-select><md-button \naria-label=\"+ Add Another Notification\" translate=\"CALENDAR.ADD_NOTIFICATION\" \ntranslate-attr-aria-label=\"CALENDAR.ADD_NOTIFICATION\">+ Add Another Notification</md-button></div><md-input-container \nflex class=\"md-block textarea-container\"><label translate=\"CALENDAR.NOTES\">Notes</label><textarea \nng-model=\"vm.task.notes\" md-maxlength=\"250\"></textarea></md-input-container></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><md-button ng-click=\"vm.saveEvent()\" \nclass=\"save-button md-accent md-raised\" aria-label=\"SAVE\" ng-disabled=\"eventForm.$invalid || eventForm.$pristine\" \ntranslate=\"CALENDAR.SAVE\" translate-attr-aria-label=\"CALENDAR.SAVE\">SAVE</md-button><md-button class=\"md-icon-button\" \naria-label=\"Delete\" translate translate-attr-aria-label=\"CALENDAR.DELETE\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon><md-tooltip><span translate=\"CALENDAR.DELETE\">Delete</span></md-tooltip></md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/apps/backend/views/list/list-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-show=\"isLoading\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nclass=\"mail-list-item filter-selected\" ng-if=\"sortField\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\" flex><div class=\"info\" ng-if=\"sortField\"><div class=\"name\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-sort-ascending\" class=\"s20 mr-5 ml-0 mb-0\" \nng-if=\"sortDir === \'ASC\'\"></md-icon><md-icon md-font-icon=\"icon-sort-descending\" class=\"s20 mr-5 ml-0 mb-0\" \nng-if=\"sortDir === \'DESC\'\"></md-icon><div class=\"title text-truncate\" layout=\"row\" layout-align=\"start center\"><span \ntranslate=\"CONTENT.ORDER_BY\"></span> \'{{sortField}}\'</div></div></div></div><div class=\"buttons\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-close s20\" ng-click=\"pagination_resetOrderBy()\" class=\"ml-10\">\n<md-tooltip hide show-gt-xs><span translate=\"CONTENT.REMOVE\"></span></md-tooltip></md-icon></div></div><div \nclass=\"mail-list-item filter-selected\" ng-if=\"$root.pagination_searchquery==true\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"info\" flex><div class=\"name\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-filter\" class=\"s20 mr-8 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><div class=\"title\" layout=\"row\" \nlayout-align=\"start center\"><div ng-repeat=\"filterable in refFilterables track by $index\" class=\"inline-block\"><div \nng-repeat=\"label in filterable.values | filterInArray:filterable.selected:\'value\' track by $index\" \nclass=\"mr-5 tag-list inline-block\"><span class=\"grey-50-fg\">{{label.name}}</span></div></div></div><div \nclass=\"title text-truncate pl-10\" layout=\"row\" layout-align=\"start center\" ng-if=\"$root.modelSearch\">\n{{$root.modelSearch}}</div></div></div><div class=\"buttons\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-close s20\" ng-click=\"$root.pagination_resetquery()\" class=\"ml-10\"><md-tooltip hide show-gt-xs><span \ntranslate=\"CONTENT.REMOVE_FILTERS\">Remove filters</span></md-tooltip></md-icon></div></div><div class=\"no-threads\" \nng-if=\"!isLoading && vm.threads.length === 0\" ng-hide=\"isLoading\" translate=\"CONTENT.NO_ITEMS\"></div><div \nid=\"list-content-data\" ng-style=\"{\'opacity\' : isLoading ? 0.2 : 1}\" ms-scroll=\"vm.msScrollOptions\" \nng-class=\"{\'group-filter\': vm.selectedGroup,\'other-filter\':sortField,\'x2-filter\':$root.pagination_searchquery==true}\" \nclass=\"scrollable\" ng-if=\"vm.threads.length > 0\"><div class=\"mail-list-item {{thread.status}}\" \nng-repeat=\"thread in vm.threads | filter: {section : vm.searchQuery}\" ng-init=\"parentIndex = $index\" md-no-ink \nng-cloak ng-click=\"vm.openThread(thread)\" \nng-class=\"{\'starred\': thread.starred, \'selected\': vm.selectedContentID === thread.id_section, \'checked\': vm.isChecked(thread)}\">\n<div layout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-label\" ng-checked=\"vm.isSelected(thread)\" \nng-click=\"vm.toggleSelectThread(thread, $event)\" aria-label=\"{{vm.isSelected(thread) ? \'Deselect\' : \'Select\'}}\">\n</md-checkbox><div class=\"info\" flex layout=\"column\"><div><span><span class=\"grey-500-fg\">ID #</span> <span \nclass=\"grey-500-fg\" ng-bind=\"thread.id_section\"></span></span><div class=\"name\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"user-name text-truncate\"><span ng-bind=\"thread.section\" ng-if=\"thread.section\">\n</span></div></div></div></div></div></div><div class=\"toolbar\" layout=\"row\" layout-align=\"end center\"><div \nlayout=\"row\" layout-align=\"center center\" ng-style=\"{\'display\' : isLoading ? \'none\' : \'block\'}\"><span \nclass=\"page-info\">{{pagination_totalItems}} {{vm.translate(\'CONTENT.ITEMS_FOUND\')}}</span><md-button \naria-label=\"Previous\" class=\"md-icon-button arrow\" ng-click=\"pagination_prevPage()\" \nng-disabled=\"pagination_firstPage()\" translate=\"\" translate-attr-aria-label=\"CONTENT.PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><span class=\"page-info\">\n{{pagination_page}} / {{pagination_total_pages}}</span><md-button aria-label=\"Next\" class=\"md-icon-button arrow\" \nng-click=\"pagination_nextPage()\" ng-disabled=\"pagination_morePages()\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div>\n</div>");
$templateCache.put("app/main/apps/backend/views/list/nosplit-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/backend/views/list/toolbar.html\'\" ng-hide=\"vm.currentThread || vm.currentThread_Edit\"></div>\n<div class=\"content-wrapper\" flex=\"\" layout=\"row\"><div class=\"content thread-list mail-list-pane\" flex=\"\" \nid=\"thread-list\" ng-if=\"!vm.selectedContent\" ng-include=\"\'app/main/apps/backend/views/list/list-view.html\'\"></div><div \nclass=\"content thread-detail mail-read-pane\" flex=\"\" id=\"thread-detail\" layout=\"column\" ng-if=\"vm.selectedContent\" \nng-include=\"\'app/main/apps/backend/views/read/read-view.html\'\"></div></div>");
$templateCache.put("app/main/apps/backend/views/list/split-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/backend/views/list/toolbar.html\'\"></div><div class=\"content-wrapper\" flex=\"\" layout=\"row\">\n<div class=\"content thread-list mail-list-pane\" flex=\"50\" id=\"thread-list\" \nng-include=\"\'app/main/apps/backend/views/list/list-view.html\'\"></div><div class=\"content thread-detail mail-read-pane\" \nflex=\"50\" id=\"thread-detail\" layout=\"column\" ng-include=\"\'app/main/apps/backend/views/read/read-view.html\'\"></div>\n</div>");
$templateCache.put("app/main/apps/backend/views/list/toolbar.html","<div layout=\"row\" ng-if=\"vm.showSearch\" class=\"search-bar\"><md-icon ng-click=\"vm.showSearch = true;\" \nid=\"ms-search-bar-expander\" md-font-icon=\"icon-magnify\" class=\"md-icon-button md-button\"><md-tooltip hide show-gt-xs>\n<span translate=\"TOOLBAR.SEARCH\">Search</span></md-tooltip></md-icon><input id=\"ms-search-bar-input\" type=\"text\" \nng-model=\"vm.searchQuery\" placeholder=\"Search\" md-autofocus translate translate-attr-placeholder=\"TOOLBAR.SEARCH\" flex \nng-enter=\"vm.searchLocal(vm.searchQuery)\"><md-icon id=\"ms-search-bar-collapser\" \nng-click=\"vm.showSearch = false; vm.searchQuery = \'\';\" md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></div><div \nlayout=\"row\" ng-if=\"!vm.showSearch\" layout-align=\"start center\"><md-button aria-label=\"ADD NEW\" \nclass=\"md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme\" hide show-gt-sm \nng-click=\"vm.newThread()\" translate=\"CONTENT.ADD\" type=\"button\"></md-button><md-button aria-label=\"ADD NEW\" \nclass=\"md-fab md-mini md-accent green-500-bg md-raised md-ink-ripple md-default-theme\" hide-gt-sm \nng-click=\"vm.newThread()\" type=\"button\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><div \nclass=\"divider-vertical\" hide=\"\" show-gt-xs=\"\"></div><label for=\"ms-search-bar-input\"><md-icon \nng-click=\"vm.showSearch = true;\" id=\"ms-search-bar-expander\" md-font-icon=\"icon-magnify\" \nclass=\"md-icon-button md-button\"><md-tooltip hide show-gt-xs><span translate=\"TOOLBAR.SEARCH\">Search</span>\n</md-tooltip></md-icon></label></div><div layout=\"row\" ng-if=\"!vm.showSearch\" layout-align=\"start center\" \ntranslate-attr-aria-label=\"CONTENT.REFRESH\" class=\"qiu-pagination\" ng-hide=\"isLoading\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.changeView(\'nosplit\')\" ng-if=\"vm.currentView !== \'nosplit\'\" hide show-gt-sm \naria-label=\"noSplit\"><md-icon md-font-icon=\"icon-view-list\" ng-if=\"vm.currentView !== \'nosplit\'\"></md-icon><md-icon \nclass=\"md-accent\" md-font-icon=\"icon-checkbox-marked\" ng-if=\"vm.currentView === \'nosplit\'\"></md-icon><md-tooltip hide \nshow-gt-xs><span translate=\"CONTENT.NOSPLIT_VIEW\"></span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.changeView(\'split\')\" ng-if=\"vm.currentView !== \'split\'\" hide show-gt-sm aria-label=\"Split\"><md-icon \nmd-font-icon=\"icon-view-quilt\" ng-if=\"vm.currentView !== \'split\'\"></md-icon><md-icon class=\"md-accent\" \nmd-font-icon=\"icon-checkbox-marked\" ng-if=\"vm.currentView === \'split\'\"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate=\"CONTENT.SPLIT_VIEW\"></span></md-tooltip></md-button><md-menu-bar class=\"pr-0 pl-0\" hide-gt-xs><md-menu \nclass=\"settings-menu\"><md-button aria-label=\"Settings\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" \ntranslate=\"\" translate-attr-aria-label=\"CONTENT.SETTINGS\"><md-icon md-font-icon=\"icon-cog\"></md-icon></md-button>\n<md-menu-content><md-menu-item><md-menu><md-button aria-label=\"Filters\" ng-click=\"$mdMenu.open($event)\"><md-icon \nmd-font-icon=\"icon-sort\"></md-icon><span translate=\"CONTENT.ORDER_BY\">Order by</span></md-button><md-menu-content>\n<md-menu-item ng-repeat=\"sortfield in refSortables\"><md-button aria-label=\"All\" \nng-click=\"pagination_setSortField(sortfield.titleId)\"><div layout=\"row\" layout-align=\"space-between center\"><span>\n{{sortfield.name}}</span> <i class=\"icon-check s16\" ng-if=\"sortfield.titleId == sortField\"></i></div></md-button>\n</md-menu-item><md-menu-item ng-repeat=\"field in vm.refcolumns\" ng-if=\"field.sortable === 1\"><md-button \nng-click=\"vm.setSortField(field.title)\"><div layout=\"row\" layout-align=\"space-between center\"><span>\n{{field.field_name}}</span> <i class=\"icon-check s16\" ng-if=\"vm.fieldOrder === field.field_name\"></i></div></md-button>\n</md-menu-item></md-menu-content></md-menu></md-menu-item><md-menu-item><md-button \nng-click=\"pagination_setSortField(null,\'ASC\')\" ng-disabled=\"!sortField\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-sort-ascending\"></md-icon><span translate=\"CONTENT.DIRECTION_A_Z\">Order A-Z</span></div><i \nclass=\"icon-check s16\" ng-if=\"sortDir === \'ASC\'\"></i></div></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"pagination_setSortField(null,\'DESC\')\" ng-disabled=\"!sortField\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-sort-descending\"></md-icon><span translate=\"CONTENT.DIRECTION_Z_A\">Order Z-A</span></div><i \nclass=\"icon-check s16\" ng-if=\"sortDir === \'DESC\'\"></i></div></md-button></md-menu-item><md-menu-item \nshow=\"vm.selectedMail.length > 0 || vm.allChecked\"><md-button ng-click=\"vm.massActions(\'duplicate\')\" \naria-label=\"Duplicate\" translate-attr-aria-label=\"CONTENT.DUPLICATE\" ng-disabled=\"vm.selectedThreads.length == 0\">\n<md-icon md-font-icon=\"icon-content-duplicate\"></md-icon><span translate=\"CONTENT.DUPLICATE\"></span></md-button>\n</md-menu-item><md-menu-item show=\"vm.selectedMail.length > 0 || vm.allChecked\"><md-button \nng-click=\"vm.massActions(\'delete\')\" aria-label=\"Delete\" translate-aria-label=\"CONTENT.DELETE\" \nng-disabled=\"vm.selectedThreads.length == 0\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span \ntranslate=\"CONTENT.DELETE\"></span></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div>");
$templateCache.put("app/main/apps/backend/views/section/backend_section.html","<md-content flex=\"\" ng-if=\"vm.selectedContent && !vm.editInline\"><div class=\"mail-content file-details scrollable\" \nms-scroll=\"vm.msScrollOptions\"><div id=\"backend-section\" class=\"page-layout simple tabbed\" layout=\"column\"><div \nclass=\"content\"><div class=\"order-detail-form-container customer md-background-bg md-whiteframe-1dp\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"button\" ng-click=\"vm.populateRef()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Populate Ref\" translate=\"BACKEND.POPULATE_REF_ACTION\" \ntranslate-attr-aria-label=\"BACKEND.POPULATE_REF_ACTION\"></md-button></div></div><div \nclass=\"order-detail-form-container customer md-background-bg md-whiteframe-1dp\"><div class=\"pb-16\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-cog\" class=\"m-0 mr-16\"></md-icon><div \nclass=\"h2 secondary-text\" translate=\"BACKEND.SECTION_DETAILS\">Section</div></div><md-progress-circular \nmd-mode=\"indeterminate\" ng-if=\"vm.isLoading\" flex></md-progress-circular><div class=\"customer\" ng-if=\"!vm.isLoading\">\n<form name=\"sectionForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.saveSectionSettings(sectionForm)\"><div \nclass=\"bs-grid\"><md-input-container class=\"bs-field\"><label translate=\"BACKEND.SECTION_NAME\">Section name</label><input\n type=\"text\" ng-model=\"vm.section.section.section\"></md-input-container><md-input-container class=\"bs-field\"><label \ntranslate=\"BACKEND.SUBSECTION_NAME\">Subsection name</label><input type=\"text\" ng-model=\"vm.section.section.subsec\">\n</md-input-container><md-input-container class=\"bs-field\"><label translate=\"BACKEND.CATEGORY_NAME\">Category name\n</label><input type=\"text\" ng-model=\"vm.section.section.cat\"></md-input-container><md-input-container class=\"bs-field\">\n<label translate=\"BACKEND.SUBCATEGORY_NAME\">Subcategory name</label><input type=\"text\" \nng-model=\"vm.section.section.subcat\"></md-input-container></div><div class=\"bs-block\"><div class=\"bs-block-title\" \ntranslate=\"BACKEND.TABS\">Tabs</div><div class=\"bs-help\" translate=\"BACKEND.TABS_HELP\"></div><div class=\"bs-chips\">\n<button type=\"button\" class=\"bs-chip\" ng-repeat=\"Tab in vm.tabs\" \nng-class=\"{\'is-on\': vm.section.section[Tab.field] == 1}\" \nng-click=\"vm.section.section[Tab.field] = (vm.section.section[Tab.field] == 1 ? 0 : 1); sectionForm.$setDirty()\">\n<md-icon md-font-icon=\"{{Tab.icon}}\" class=\"s18\"></md-icon><span>{{Tab.name}}</span></button></div></div><div \nclass=\"bs-block\" ng-if=\"vm.section.section.hasOwnProperty(\'view_spreadsheet\')\"><div class=\"bs-block-title\" \ntranslate=\"BACKEND.AVAILABLE_VIEWS\">Available views</div><div class=\"bs-help\" translate=\"BACKEND.AVAILABLE_VIEWS_HELP\">\n</div><div class=\"bs-chips\"><button type=\"button\" class=\"bs-chip\" \nng-class=\"{\'is-on\': vm.section.section.view_spreadsheet == 1}\" \nng-click=\"vm.section.section.view_spreadsheet = (vm.section.section.view_spreadsheet == 1 ? 0 : 1); sectionForm.$setDirty()\">\n<md-icon md-font-icon=\"icon-table-edit\" class=\"s18\"></md-icon><span translate=\"CONTENT.SPREADSHEET_VIEW\">Spreadsheet\n</span></button></div></div><div class=\"bs-block\" ng-if=\"vm.section.section.hasOwnProperty(\'default_view\')\"><div \nclass=\"bs-block-title\" translate=\"BACKEND.DEFAULT_VIEW\">Default view</div><div class=\"bs-help\" \ntranslate=\"BACKEND.DEFAULT_VIEW_HELP\"></div><div class=\"bs-chips\"><button type=\"button\" class=\"bs-chip bs-chip-view\" \nng-repeat=\"opt in vm.defaultViewOptions\" \nng-class=\"{\'is-on\': vm.section.section.default_view === opt.value, \'is-legacy\': opt.heredado}\" \nng-click=\"vm.section.section.default_view = opt.value; sectionForm.$setDirty()\"><md-icon md-font-icon=\"{{opt.icon}}\" \nclass=\"s18\" ng-if=\"opt.icon\"></md-icon><span>{{opt.label | translate}}</span> <span class=\"bs-chip-note\" \nng-if=\"opt.heredado\" translate=\"BACKEND.NO_EFFECT\"></span></button></div></div><div class=\"bs-block\" \nng-if=\"!vm.section.section.hasOwnProperty(\'default_view\')\"><div class=\"bs-block-title\" \ntranslate=\"BACKEND.DEFAULT_VIEW\">Default view</div><div class=\"bs-help\" translate=\"BACKEND.DEFAULT_VIEW_UNAVAILABLE\">\n</div></div><div class=\"bs-actions\"><md-button type=\"submit\" class=\"md-accent md-raised\" \nng-disabled=\"sectionForm.$invalid || sectionForm.$pristine\" aria-label=\"SAVE\" translate=\"BACKEND.SAVE\" \ntranslate-attr-aria-label=\"BACKEND.SAVE\"></md-button></div></form></div></div><div \nclass=\"order-detail-form-container status md-background-bg md-whiteframe-1dp\"><div class=\"pb-16\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-table-column-width\" class=\"m-0 mr-16\"></md-icon><div \nclass=\"h2 secondary-text\" translate=\"BACKEND.FIELDS\">Fields</div></div><md-progress-circular md-mode=\"indeterminate\" \nng-if=\"vm.isLoading\" flex></md-progress-circular><table class=\"compact\" ms-responsive-table ng-if=\"!vm.isLoading\">\n<thead><tr><th>Field Name</th><th>Title</th><th>Type</th><th>List position</th><th>Preview position</th><th>\nEdit position</th><th class=\"secondary-text\" layout-padding=\"0\"><div class=\"table-header\"></div></th></tr></thead>\n<tbody><tr ng-repeat=\"fieldRef in vm.section.ref\"><td><a ng-href=\"\" ng-click=\"vm.openFieldDialog($event, fieldRef)\">\n<span class=\"status\">{{fieldRef.field_name}}</span></a></td><td><a ng-href=\"\" \nng-click=\"vm.openFieldDialog($event, fieldRef)\"><span class=\"status\">{{fieldRef.title}}</span></a></td><td>\n{{fieldRef.type}}</td><td class=\"text-center\"><md-checkbox ng-disabled=\"true\" class=\"md-secondary\" \nng-checked=\"fieldRef.list_position.length\"></md-checkbox></td><td class=\"text-center\"><md-checkbox ng-disabled=\"true\" \nclass=\"md-secondary\" ng-checked=\"fieldRef.preview_position.length\"></md-checkbox></td><td class=\"text-center\">\n<md-checkbox ng-disabled=\"true\" class=\"md-secondary\" ng-checked=\"fieldRef.edit_position.length\"></md-checkbox></td><td>\n<md-button class=\"edit-button md-icon-button\" ng-click=\"vm.openFieldDialog($event, fieldRef)\" \naria-label=\"Order details\" translate translate-attr-aria-label=\"STORE.ORDER_DETAILS\"><md-icon \nmd-font-icon=\"icon-dots-horizontal\" class=\"s16\"></md-icon></md-button></td></tr></tbody></table><div \nclass=\"update-status\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised md-accent\" \nng-click=\"vm.openFieldDialog($event)\">New Field</md-button></div></div></div></div></div></md-content>");
$templateCache.put("app/main/apps/backend/views/read/read-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-if=\"vm.loadingReadPane\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nng-show=\"!vm.loadingReadPane\"><div class=\"mail-content\" layout=\"column\" layout-align=\"center center\" \nng-if=\"!vm.selectedContent\"><div class=\"content\" layout=\"column\" layout-align=\"top center\"><div class=\"message\">\nPlease select a user to show in this panel</div></div></div><div class=\"toolbar grey-100-bg colored-bg\" layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"vm.selectedContent\" scroll=\"\"><div layout=\"row\" layout-align=\"start center\" \nng-if=\"vm.selectedContentID\"></div><div layout=\"row\" layout-align=\"end center\" ng-if=\"vm.selectedContent\" hide \nshow-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.closeThreadEdit()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div><div layout=\"row\" layout-align=\"end center\" \nng-if=\"vm.selectedContent\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.closeThreadEdit()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></div><md-content \nng-if=\"vm.selectedContentID && vm.selectedContent\" \nng-include=\"\'app/main/apps/backend/views/section/backend_section.html\'\" class=\"scrollable\"></md-content></div>");
$templateCache.put("app/main/apps/content/dialogs/add-case-text-dialog/add-case-text-dialog.controller.html","<md-dialog id=\"add-case-text-dialog\" aria-label=\"Design Template\" flex=\"50\"><form class=\"md-inline-form\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\"><a \nclass=\"md-button\" type=\"1\" layout=\"row\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"s18 mr-5 ml-0\"></md-icon><span translate=\"MAILING.TEMPLATE_DESIGN\"></span></a></div><div layout=\"row\"><md-button\n class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate \ntranslate-aria-label=\"CONTENT.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></div>\n</md-toolbar><md-dialog-content flex=\"100\" class=\"content-card\"><div id=\"content-edit\" \nclass=\"page-layout simple fullwidth mail-content content-edit\" layout=\"column\"><md-tabs ms-scroll=\"vm.msScrollOptions\" \nclass=\"scrollable\"><md-tab><md-tab-label>{{ vm.translate(\'CONTENT.EDIT_TAB\')}}</md-tab-label><md-tab-body><div \nng-include=\"\'app/main/apps/content/views/read/tab-edit.html\'\"></div></md-tab-body></md-tab></md-tabs></div>\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/content/dialogs/ai-translate-dialog/ai-translate-dialog.html","<md-dialog id=\"ai-translate-dialog\" aria-label=\"Translate Template\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><h1 class=\"title\" \ntranslate=\"CONTENT.AI_TRANSLATE\"></h1><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll flex class=\"content-card\" layout=\"column\" layout-align=\"start start\"><div ng-if=\"vm.loading\" \nid=\"loader-container\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nng-if=\"!vm.loading\" id=\"content-container\"><md-input-container id=\"trans-container\" class=\"md-block\" flex><label \ntranslate=\"CONTENT.SELECT_PROVIDER\">Proveedor de traducción</label><md-select ng-model=\"vm.selectedProvider\" \nplaceholder=\"{{\'CONTENT.SELECT_PROVIDER\' | translate}}\"><md-option ng-repeat=\"t in vm.translateServices\" value=\"{{t}}\">\n{{\'CONTENT.\'+t+\'_TRANSLATE\' | translate}}</md-option></md-select></md-input-container><div class=\"language-container\" \nng-if=\"vm.selectedProvider\"><div layout=\"row\" ng-repeat=\"lang in vm.getServiceLangs(vm.selectedProvider)\"><md-checkbox \nclass=\"no-label\" ng-click=\"vm.addLang(lang.lang_name)\"></md-checkbox><img \nsrc=\"../../../../../../assets/images/flags/{{lang.flag_code.toLowerCase()}}.svg\"> <span>{{lang.lang_name}}</span></div>\n</div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><md-input-container\n flex layout=\"row\" layout-align=\"end center\" class=\"m-0\"><md-button type=\"button\" class=\"md-raised md-warn\" \nng-click=\"vm.closeDialog()\" translate=\"CONTENT.CANCEL\"></md-button><md-button \nng-disabled=\"!vm.selectedProvider || vm.selectedLanguages.length < 1\" type=\"submit\" \nclass=\"send-button md-accent md-raised\" ng-click=\"vm.save()\" translate=\"CONTENT.SAVE\"></md-button></md-input-container>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/content/dialogs/web-editor/web-editor.html","<md-dialog aria-label=\"Web Builder\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Web Builder</h2><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"Close\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content flex layout=\"row\"><div id=\"elements-container\"><div \nng-repeat=\"tpl in vm.webTemplates\"><div class=\"element-item\" wb-draggable drag-data=\"tpl\" ng-switch=\"tpl.type\"><div \nng-switch-when=\"empty\" layout=\"column\" layout-align=\"center center\"><md-icon class=\"material-icons md-accent\">\nborder_all</md-icon><span>{{ tpl.label }}</span></div><div ng-switch-when=\"image\" layout=\"column\" \nlayout-align=\"center center\"><md-icon class=\"material-icons md-accent\">image</md-icon><span>{{ tpl.label }}</span>\n</div><div ng-switch-when=\"text\" layout=\"column\" layout-align=\"center center\"><md-icon \nclass=\"material-icons md-accent\">text_fields</md-icon><span>{{ tpl.label }}</span></div><div ng-switch-default \nlayout=\"column\" layout-align=\"center center\"><md-icon class=\"material-icons md-accent\">help_outline</md-icon><span>\n{{ tpl.label || (\'Unknown: \' + tpl.type) }}</span></div></div></div></div><div id=\"web-container\"><div id=\"web-tools\" \nlayout=\"row\" layout-align=\"center center\" class=\"p-8\"><div id=\"grid-tool\" layout=\"column\" layout-align=\"center center\">\n<md-button class=\"md-icon-button\" aria-label=\"Show Grid\" ng-click=\"vm.isGridVisible = !vm.isGridVisible\" \nng-class=\"{\'md-primary\': vm.isGridVisible}\"><span class=\"material-symbols-outlined\" ng-if=\"!vm.isGridVisible\">grid_on\n</span> <span class=\"material-symbols-outlined\" ng-if=\"vm.isGridVisible\">grid_off</span><md-tooltip>Show Grid\n</md-tooltip></md-button><span>{{ vm.isGridVisible ? \'Hide Grid\' : \'Show Grid\' }}</span></div></div><div \nid=\"web-content\" \nng-attr-style=\"\r\n                    --webCols: {{vm.webTemplate.columns}}; \r\n                    --bgColor: {{vm.webTemplate.bgColor}};\r\n                \" \nwb-droppable drop-handler=\"vm.addBlock(data)\" ng-class=\"{\'grid-on\': vm.isGridVisible}\"><div class=\"web-block\" \nng-repeat=\"block in vm.webTemplate.blocks track by $index\" wb-block-draggable wb-block-index=\"$index\" \nwb-block-move=\"vm.moveBlock(from, to)\" wb-block-insert=\"vm.insertBlockAt(index, data)\" \nng-attr-style=\"\r\n                        --webCols: {{vm.webTemplate.columns}}; \r\n                        --cols: {{block.columns}}; \r\n                        --bgColor: {{block.bgColor}};\r\n                        --mTop: {{block.margin.top || 0}}px;\r\n                        --mRight: {{block.margin.right || 0}}px;\r\n                        --mBottom: {{block.margin.bottom || 0}}px;\r\n                        --mLeft: {{block.margin.left || 0}}px;\r\n                        --pTop: {{block.padding.top || 0}}px;\r\n                        --pRight: {{block.padding.right || 0}}px;\r\n                        --pBottom: {{block.padding.bottom || 0}}px;\r\n                        --pLeft: {{block.padding.left || 0}}px;\r\n                    \" \nng-switch=\"block.type\" ng-click=\"vm.selectedBlock = block\" ng-class=\"{\'selected-block\': vm.selectedBlock === block}\">\n<div ng-switch-when=\"empty\" class=\"block-empty\"><div class=\"block-toolbar\"><button type=\"button\" \nclass=\"wb-drag-handle\"><md-icon class=\"material-icons\">drag_indicator</md-icon></button></div></div><div \nng-switch-when=\"text\" class=\"block-text\"><div class=\"block-toolbar\"><button type=\"button\" class=\"wb-drag-handle\">\n<md-icon class=\"material-icons\">drag_indicator</md-icon></button></div><span>Text</span></div><div ng-switch-default \nclass=\"block-unknown\"><div class=\"block-toolbar\"><button type=\"button\" class=\"wb-drag-handle\"><md-icon \nclass=\"material-icons\">drag_indicator</md-icon></button></div><p>Unknown block: {{block.type}}</p></div></div></div>\n</div><div id=\"config-container\"><div ng-if=\"vm.selectedBlock\"><md-button class=\"md-icon-button\" \nng-click=\"vm.selectedBlock = undefined\" aria-label=\"Close\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n<div class=\"config-item\"><md-input-container class=\"md-block\"><label>Columns</label><md-select \nng-model=\"vm.selectedBlock.columns\" aria-label=\"Block columns\"><md-option \nng-repeat=\"opt in vm.webTemplateOptions.columns track by opt.value\" ng-value=\"opt.value\">{{ opt.label }}</md-option>\n</md-select></md-input-container></div><div class=\"config-item\"><label class=\"config-label\">Margin (px)</label><div \nlayout=\"row\" layout-wrap><md-input-container flex=\"25\" class=\"md-block\"><label>Top</label><input type=\"number\" \nng-model=\"vm.selectedBlock.margin.top\"></md-input-container><md-input-container flex=\"25\" class=\"md-block\"><label>Right\n</label><input type=\"number\" ng-model=\"vm.selectedBlock.margin.right\"></md-input-container><md-input-container \nflex=\"25\" class=\"md-block\"><label>Bottom</label><input type=\"number\" ng-model=\"vm.selectedBlock.margin.bottom\">\n</md-input-container><md-input-container flex=\"25\" class=\"md-block\"><label>Left</label><input type=\"number\" \nng-model=\"vm.selectedBlock.margin.left\"></md-input-container></div></div><div class=\"config-item\"><label \nclass=\"config-label\">Padding (px)</label><div layout=\"row\" layout-wrap><md-input-container flex=\"25\" class=\"md-block\">\n<label>Top</label><input type=\"number\" ng-model=\"vm.selectedBlock.padding.top\"></md-input-container><md-input-container\n flex=\"25\" class=\"md-block\"><label>Right</label><input type=\"number\" ng-model=\"vm.selectedBlock.padding.right\">\n</md-input-container><md-input-container flex=\"25\" class=\"md-block\"><label>Bottom</label><input type=\"number\" \nng-model=\"vm.selectedBlock.padding.bottom\"></md-input-container><md-input-container flex=\"25\" class=\"md-block\"><label>\nLeft</label><input type=\"number\" ng-model=\"vm.selectedBlock.padding.left\"></md-input-container></div></div><div \nclass=\"config-item\"><md-input-container class=\"md-block\"><label>Background Color</label><input type=\"color\" \nng-model=\"vm.selectedBlock.bgColor\"></md-input-container></div><div ng-repeat=\"conf in vm.selectedBlock.config\" \nng-switch=\"conf.type\" class=\"config-item\"><div ng-switch-when=\"color\"><md-input-container class=\"md-block\"><label>\n{{ conf.label || \'Color\' }}</label><input type=\"color\" ng-model=\"vm.selectedBlock[conf.value]\"></md-input-container>\n</div><div ng-switch-when=\"selector\"><md-input-container class=\"md-block\"><label>{{ conf.label || \'Option\' }}</label>\n<md-select ng-model=\"vm.selectedBlock[conf.value]\"><md-option ng-if=\"conf.webTemplateOptions\" \nng-repeat=\"opt in vm.selectedBlock.options\" ng-value=\"opt.value\">{{ opt.label }}</md-option></md-select>\n</md-input-container></div><div ng-switch-default><p>⚠️ Unknown type: {{ conf.type }}</p></div></div></div><div \nng-if=\"!vm.selectedBlock\"><h2>Web Config</h2><div ng-repeat=\"conf in vm.webConfig\" ng-switch=\"conf.type\" \nclass=\"config-item\"><div ng-switch-when=\"color\"><md-input-container class=\"md-block\"><label>{{ conf.label || \'Color\' }}\n</label><input type=\"color\" ng-model=\"vm.webTemplate[conf.value]\"></md-input-container></div><div \nng-switch-when=\"selector\"><md-input-container class=\"md-block\"><label>{{ conf.label || \'Option\' }}</label><md-select \nng-model=\"vm.webTemplate[conf.value]\"><md-option ng-repeat=\"opt in conf.options\" ng-value=\"opt.value\">{{ opt.label }}\n</md-option></md-select></md-input-container></div><div ng-switch-default><p>⚠️ Unknown type: {{ conf.type }}</p></div>\n</div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button \nng-click=\"vm.cancel()\">Cancel</md-button><md-button class=\"md-primary md-raised\" ng-click=\"vm.save()\">Save</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/content/dialogs/grid-media/grid-media.html","<md-dialog class=\"content-grid-media-dialog\" aria-label=\"Media\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><h1 class=\"title\"><span \ntranslate=\"CONTENT.MEDIA_DIALOG_TITLE\">Medias</span> <span class=\"grid-media-item\" ng-if=\"vm.currentThread_Edit\">\n— {{vm.currentThread_Edit.title || vm.currentThread_Edit.Title || (\'#\' + vm.selectedContentID)}}</span></h1><md-button \nclass=\"md-icon-button\" ng-click=\"vm.gridMediaCancel()\" aria-label=\"Close\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll flex class=\"content-card\"><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!vm.currentThread_Edit\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"50\" class=\"m-20\"></md-progress-circular></div><md-list ng-if=\"vm.currentThread_Edit\" \nng-include=\"\'app/main/apps/content/views/read/tab-media.html\'\"></md-list></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"end center\"><md-button type=\"button\" class=\"md-raised md-warn\" \nng-click=\"vm.gridMediaCancel()\" ng-disabled=\"vm.savingProcess\" translate=\"CONTENT.CANCEL\">Cancelar</md-button>\n<md-button type=\"button\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.savingProcess || !vm.currentThread_Edit\" ng-click=\"vm.gridMediaSave()\"><span ng-if=\"!vm.savingProcess\" \ntranslate=\"CONTENT.SAVE\">Guardar</span><md-progress-circular ng-if=\"vm.savingProcess\" md-mode=\"indeterminate\" \nmd-diameter=\"20\"></md-progress-circular></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/content/sidenavs/main/main-sidenav-social-stream.html","<md-toolbar class=\"md-theme-light md-default-theme md-light-blue-bg\"><h2 class=\"md-toolbar-tools\" aria-label=\"Filters\" \nlayout=\"row\" layout-align=\"space-between center\"><span translate-attr-aria-label=\"CONTENT.FILTERS\" \ntranslate=\"CONTENT.FILTERS\">Filters</span> <button class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'main-sidenav\')\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></button></h2></md-toolbar><md-content ms-scroll class=\"content\" flex><div\n class=\"navigation-simple\" layout=\"column\"><div ng-repeat=\"filterable in refFilterablesCustom track by $index\" \nng-init=\"parentIndex = $index\"><md-menu flex layout=\"row\"><md-menu-item flex><md-button aria-label=\"Label\" translate \nng-show=\"filterable.values.length>0\" translate-attr-aria-label=\"SB.LABEL\" ng-click=\"$mdMenu.open($event)\"><div \nlayout=\"row\" layout-align=\"start start\"><span class=\"title text-left\" translate=\"{{filterable.name}}\" flex></span>\n<md-icon md-font-icon=\"icon-chevron-down\"></md-icon></div></md-button></md-menu-item><md-menu-content \nclass=\"labels-menu-content\" width=\"4\"><div ms-scroll><md-menu-item class=\"label\" \nng-repeat=\"label in filterable.values | filter: vm.filterSearchText[filterable.field] track by $index\"><md-button \nclass=\"label-toggle-button p-0\" ng-class=\"\'md-\'+label.color+\'-bg\'\" ng-click=\"vm.callActionToggle(label, parentIndex)\" \naria-label=\"Toggle Label\" translate translate-attr-aria-label=\"SB.TOGGLE_LABEL\"><div layout=\"row\" \nlayout-align=\"space-between center\"><span translate=\"{{label.name}}\"></span></div></md-button></md-menu-item></div>\n<md-divider></md-divider></md-menu-content></md-menu><div ng-show=\"refFilterablesCustom[$index].selected.length>0\">\n<md-chips class=\"md-chips md-removable close-chip\"><md-chip \nng-repeat=\"label in filterable.values | filterInArray:filterable.selected:\'value\' track by $index\" \nclass=\"md-accent-bg md-chip\"><div class=\"md-chip-content\" translate=\"{{label.name}}\"></div><div \nclass=\"md-chip-remove-container\"><button class=\"md-chip-remove\" ng-click=\"vm.callActionToggle(label, parentIndex)\" \nmd-chip-remove><md-icon md-font-icon=\"icon-close\"></md-icon></button></div></md-chip></md-chips></div></div></div>\n</md-content>");
$templateCache.put("app/main/apps/content/sidenavs/main/main-sidenav.html","<md-toolbar class=\"md-theme-light md-default-theme md-light-blue-bg\"><h2 class=\"md-toolbar-tools\" aria-label=\"Filters\" \nlayout=\"row\" layout-align=\"space-between center\"><span translate-attr-aria-label=\"CONTENT.FILTERS\" \ntranslate=\"CONTENT.FILTERS\">Filters</span> <button class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'main-sidenav\')\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></button></h2></md-toolbar><md-content ms-scroll class=\"content\" flex><div\n class=\"navigation-simple\" layout=\"column\" ng-if=\"!showSidenav\"><div layout=\"row\" layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"30\"></md-progress-circular></div></div><div \nclass=\"navigation-simple\" layout=\"column\" ng-if=\"showSidenav\"><div ng-repeat=\"(key,filterable) in filtersToSelect\"><div\n ng-if=\"filterable.type == \'multiselect\'\" layout-align=\"start start\"><md-menu flex layout=\"row\"><md-menu-item flex>\n<md-button aria-label=\"Label\" translate ng-show=\"filterable.values.length>0\" translate-attr-aria-label=\"CONTENT.LABEL\" \nng-click=\"$mdMenu.open($event)\"><div layout=\"row\" layout-align=\"start start\"><span class=\"title text-left\" flex>\n{{filterable.name}}</span><md-icon md-font-icon=\"icon-chevron-down\"></md-icon></div></md-button></md-menu-item>\n<md-menu-content class=\"labels-menu-content\" width=\"4\"><md-menu-item class=\"search-bar border-bottom\" \nng-if=\"filterable.values.length>10\"><div layout=\"row\" layout-align=\"start center\" class=\"pl-10 pr-15\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"md-icon-button ml-0 mr-10\" aria-label=\"Search\" role=\"img\"></md-icon><input \nplaceholder=\"Search\" type=\"text\" flex class=\"font-size-14\" ng-model=\"vm.filterSearchText[filterable.field]\" \nng-model-options=\"{debounce: 500}\" autocomplete=\"off\" translate-attr-palceholder=\"CONTENT.SEARCH\"></div></md-menu-item>\n<div ms-scroll ng-class=\"{\'mt-48\': filterable.values.length>10}\" \nng-if=\"!vm.filterSearchText[filterable.field] || vm.filterSearchText[filterable.field].length <= 2\"><md-menu-item \nclass=\"label\"><div layout=\"row\" layout-align=\"space-between center\"><span translate=\"CONTENT.TAGS_SEARCH_3_MIN\"></span>\n</div></md-menu-item></div><div ms-scroll ng-class=\"{\'mt-48\': filterable.values.length>10}\" \nng-if=\"vm.filterSearchText[filterable.field].length > 2\"><md-menu-item class=\"label\" \nng-repeat=\"label in filterable.values | filter: vm.filterSearchText[filterable.field] track by $index\"><md-button \nclass=\"label-toggle-button p-0\" ng-class=\"\'md-\'+label.color+\'-bg\'\" \nng-click=\"vm.toggleInArray(label.id_tag, filtersToSelect[filterable.field].selected)\" aria-label=\"Toggle Label\" \ntranslate translate-attr-aria-label=\"CONTENT.TOGGLE\"><div layout=\"row\" layout-align=\"space-between center\"><span>\n{{label.tag_name}}</span></div></md-button></md-menu-item></div><md-divider></md-divider></md-menu-content></md-menu>\n<div ng-show=\"filtersToSelect[filterable.field].selected.length>0\"><md-chips class=\"md-chips md-removable close-chip\">\n<md-chip ng-repeat=\"label in filterable.values | filterInArray:filterable.selected:\'id_tag\' track by $index\" \nclass=\"md-accent-bg md-chip\"><div class=\"md-chip-content\">{{label.tag_name}}</div><div \nclass=\"md-chip-remove-container\"><button class=\"md-chip-remove\" \nng-click=\"vm.toggleInArray(label.id_tag, filtersToSelect[filterable.field].selected)\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></button></div></md-chip></md-chips></div></div><div \nng-if=\"filterable.type == \'listSelect\' || filterable.type == \'select\' || filterable.type == \'id_subsec\' || filterable.type == \'id_cat\' || filterable.type == \'id_subcat\' || filterable.type == \'section\' || filterable.type == \'onoff\' || filterable.type == \'nume\'\" \nlayout-align=\"start start\"><md-menu flex layout=\"row\"><md-menu-item flex><md-button aria-label=\"Label\" translate \nng-show=\"filterable.values.length>0\" translate-attr-aria-label=\"CONTENT.LABEL\" ng-click=\"$mdMenu.open($event)\"><div \nlayout=\"row\" layout-align=\"start start\"><span class=\"title text-left\" flex>{{filterable.name}}</span><md-icon \nmd-font-icon=\"icon-chevron-down\"></md-icon></div></md-button></md-menu-item><md-menu-content \nclass=\"labels-menu-content\" width=\"4\"><md-menu-item class=\"search-bar border-bottom\" \nng-if=\"filterable.values.length>10\"><div layout=\"row\" layout-align=\"start center\" class=\"pl-10 pr-15\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"md-icon-button ml-0 mr-10\" aria-label=\"Search\" role=\"img\"></md-icon><input \nplaceholder=\"Search\" type=\"text\" flex class=\"font-size-14\" ng-model=\"vm.filterSearchText[filterable.field]\" \nautocomplete=\"off\" translate-attr-palceholder=\"CONTENT.SEARCH\"></div></md-menu-item><div ms-scroll \nng-class=\"{\'mt-48\': filterable.values.length>10}\"><md-menu-item class=\"label\" \nng-repeat=\"label in filterable.values | filter: vm.filterSearchText[filterable.field] track by $index\"><md-button \nclass=\"label-toggle-button p-0\" ng-class=\"\'md-\'+label.color+\'-bg\'\" \nng-click=\"vm.toggleInArray(label.value, filtersToSelect[filterable.field].selected)\" aria-label=\"Toggle Label\" \ntranslate translate-attr-aria-label=\"CONTENT.TOGGLE\"><div layout=\"row\" layout-align=\"space-between center\"><span>\n{{label.name}}</span> <i ng-if=\"vm.exists(label.value, filtersToSelect[filterable.field].selected)\" \nclass=\"icon-check s16\"></i></div></md-button></md-menu-item></div><md-divider></md-divider></md-menu-content></md-menu>\n<div ng-show=\"filtersToSelect[filterable.field].selected.length>0\"><md-chips class=\"md-chips md-removable close-chip\">\n<md-chip ng-repeat=\"label in filterable.values | filterInArray:filterable.selected:\'value\' track by $index\" \nclass=\"md-accent-bg md-chip\"><div class=\"md-chip-content\">{{label.name}}</div><div class=\"md-chip-remove-container\">\n<button class=\"md-chip-remove\" ng-click=\"vm.toggleInArray(label.value, filtersToSelect[filterable.field].selected)\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></button></div></md-chip></md-chips></div></div><div class=\"pl-16 pr-16\" \nlayout=\"row\" layout-align=\"space-between center\" ng-if=\"filterable.type == \'status\'\"><span \nclass=\"title text-left font-size-14\">{{filterable.name}}</span><md-switch ng-if=\"!filterable.value\" \nng-change=\"vm.toggleInArray(1, filtersToSelect[filterable.field].selected, true)\" ng-model=\"filterable.value\" \naria-label=\"{{filterable.name}}\"></md-switch><md-switch ng-if=\"filterable.value\" \nng-change=\"vm.toggleInArray(0, filtersToSelect[filterable.field].selected, true)\" ng-model=\"filterable.value\" \naria-label=\"{{filterable.name}}\"></md-switch></div></div><div layout=\"row\" layout-align=\"end center\"><md-button \ntype=\"submit\" ng-click=\"vm.applyFilters()\" class=\"send-button md-accent md-raised\"><span aria-label=\"SAVE\" \ntranslate=\"CONTENT.SAVE\" translate-attr-aria-label=\"CONTENT.SAVE\" ng-hide=\"vm.savingProcess\">SAVE</span> <span \nng-show=\"vm.savingProcess\" translate=\"CONTENT.SAVING\"></span></md-button></div></div></md-content>");
$templateCache.put("app/main/apps/content/sidenavs/main/sidenav.html","<md-toolbar class=\"md-theme-light md-default-theme md-light-blue-bg\"><h2 class=\"md-toolbar-tools\" aria-label=\"Filters\" \nlayout=\"row\" layout-align=\"space-between center\"><span translate-attr-aria-label=\"CONTENT.FILTERS\" \ntranslate=\"CONTENT.FILTERS\">Filters</span>asdasdasd <button class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'main-sidenav\')\"><md-icon md-font-icon=\"icon-close\"></md-icon></button></h2></md-toolbar>\n<md-content ms-scroll class=\"content\" flex><div class=\"navigation-simple\" layout=\"column\"><div \nng-repeat=\"filterable in refFilterables\"><md-menu flex layout=\"row\"><md-menu-item flex><md-button aria-label=\"Label\" \ntranslate ng-show=\"filterable.values.length>0\" translate-attr-aria-label=\"SB.LABEL\" ng-click=\"$mdMenu.open($event)\">\n<div layout=\"row\" layout-align=\"start start\"><span class=\"title text-left\" flex>{{filterable.name}}</span><md-icon \nmd-font-icon=\"icon-chevron-down\"></md-icon></div></md-button></md-menu-item><md-menu-content \nclass=\"labels-menu-content\" width=\"4\"><md-menu-item class=\"search-bar border-bottom\" \nng-if=\"filterable.values.length>10\"><div layout=\"row\" layout-align=\"start center\" class=\"pl-10 pr-15\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"md-icon-button ml-0 mr-10\" aria-label=\"Search\" role=\"img\"></md-icon><input \nplaceholder=\"Search labels...\" type=\"text\" flex class=\"font-size-14\" ng-model=\"vm.filterSearchText[filterable.field]\" \nautocomplete=\"off\" translate-attr-palceholder=\"SB.SEARCH_LABELS\"></div></md-menu-item><div ms-scroll \nng-class=\"{\'mt-48\': filterable.values.length>10}\"><md-menu-item class=\"label\" \nng-repeat=\"label in filterable.values | filter: vm.filterSearchText[filterable.field]\"><md-button \nclass=\"label-toggle-button\" ng-class=\"\'md-\'+label.color+\'-bg\'\" \nng-click=\"vm.toggleInArray(label.value, refFilterables[filterable.field].selected)\" aria-label=\"Toggle Label\" \ntranslate translate-attr-aria-label=\"SB.TOGGLE_LABEL\"><div layout=\"row\" layout-align=\"space-between center\"><span>\n{{label.name}}</span> <i ng-if=\"vm.exists(label.value, refFilterables[filterable.field].selected)\" \nclass=\"icon-check s16\"></i></div></md-button></md-menu-item></div><md-divider></md-divider></md-menu-content></md-menu>\n<div ng-show=\"refFilterables[filterable.field].selected.length>0\"><md-chips class=\"md-chips md-removable close-chip\">\n<md-chip ng-repeat=\"label in filterable.values | filterInArray:filterable.selected:\'value\'\" \nclass=\"md-accent-bg md-chip\"><div class=\"md-chip-content\">{{label.name}}</div><div class=\"md-chip-remove-container\">\n<button ng-click=\"vm.toggleInArray(label.value, refFilterables[filterable.field].selected)\" md-chip-remove><md-icon \nmd-font-icon=\"icon-close\"></md-icon></button></div></md-chip></md-chips></div></div></div></md-content>");
$templateCache.put("app/main/apps/content/views/edit/edit-view.html","<div id=\"content-edit\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div class=\"header-content\" layout=\"row\" layout-align=\"space-between\" \nlayout-wrap flex><div layout=\"row\" layout-align=\"center left\" flex-order=\"1\" flex-order-xs=\"2\"><md-button \nclass=\"md-accent md-raised md-hue-2 header-boards-button\" ng-class=\"\'md-\'+vm.board.settings.color+\'-700-bg\'\" \nng-click=\"$back()\" aria-label=\"boards button\" translate translate-attr-aria-label=\"SB.BOARDS_BUTTON\"><md-icon \nmd-font-icon=\"icon-trello\" class=\"icon\"></md-icon><span translate=\"SB.BOARDS\">BOARDS</span></md-button></div></div>\n</div><div class=\"content\" layout=\"column\"><md-content layout-gt-sm=\"row\" layout-padding><div><md-input-container>\n<label>Title</label><input ng-model=\"user.title\"></md-input-container><md-input-container><label>Email</label><input \nng-model=\"user.email\" type=\"email\"></md-input-container></div></md-content><md-content layout-padding><div><form \nname=\"userForm\"><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-xs><label>Company (Disabled)\n</label><input ng-model=\"user.company\" disabled=\"disabled\"></md-input-container><md-datepicker \nng-model=\"user.submissionDate\" md-placeholder=\"Enter date\"></md-datepicker></div><div layout-gt-sm=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm><label>First name</label><input ng-model=\"user.firstName\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label>\nLong Last Name That Will Be Truncated And 3 Dots (Ellipsis) Will Appear At The End</label><input ng-model=\"theMax\">\n</md-input-container></div><md-input-container class=\"md-block\"><label>Address</label><input ng-model=\"user.address\">\n</md-input-container><md-input-container md-no-float class=\"md-block\"><input ng-model=\"user.address2\" \nplaceholder=\"Address 2\"></md-input-container><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm>\n<label>City</label><input ng-model=\"user.city\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm>\n<label>State</label><md-select ng-model=\"user.state\"><md-option ng-repeat=\"state in states\" value=\"{{state.abbrev}}\">\n{{state.abbrev}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label>\nPostal Code</label><input name=\"postalCode\" ng-model=\"user.postalCode\" placeholder=\"12345\" required \nng-pattern=\"/^[0-9]{5}$/\" md-maxlength=\"5\"><div ng-messages=\"userForm.postalCode.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\" class=\"my-message\">You must supply a postal code.</div><div \nng-message=\"pattern\" class=\"my-message\">That doesn\'t look like a valid postal code.</div><div \nng-message=\"md-maxlength\" class=\"my-message\">Don\'t use the long version silly...we don\'t need to be that specific...\n</div></div></md-input-container></div><md-input-container class=\"md-block\"><label>Biography</label><textarea \nng-model=\"user.biography\" md-maxlength=\"150\" rows=\"5\" md-select-on-focus></textarea></md-input-container></form></div>\n</md-content></div></div>");
$templateCache.put("app/main/apps/content/views/list/grid-cells.html","<span ng-if=\"host.gridCellKind(col) === \'readonly\'\" class=\"mvg-readonly\" title=\"{{host.gridCellDisplay(row, col)}}\">\n{{host.gridCellDisplay(row, col)}}</span><button ng-if=\"host.gridCellKind(col) === \'complex\'\" type=\"button\" \nclass=\"mvg-complex-btn md-button md-icon-button\" ng-click=\"host.gridEditComplexCell(row, col, $event)\" \ntitle=\"{{ \'CONTENT.EDIT\' | translate }}\"><md-icon md-font-icon=\"icon-pencil-box-outline\" class=\"s18\"></md-icon>\n</button> <button ng-if=\"host.gridCellKind(col) === \'media\'\" type=\"button\" class=\"mvg-media-btn md-button\" \nng-click=\"host.gridEditMedia(row, $event)\" title=\"{{ \'CONTENT.MEDIA_DIALOG_TITLE\' | translate }}\"><md-icon \nmd-font-icon=\"icon-image-multiple\" class=\"s18\"></md-icon><span class=\"mvg-media-count\" ng-if=\"row.Thumbnail.length\">\n{{row.Thumbnail.length}}</span> <span class=\"mvg-media-count mvg-media-empty\" ng-if=\"!row.Thumbnail.length\">—</span>\n</button><div ng-if=\"host.gridCellKind(col) === \'checkbox\'\" class=\"mvg-editor\"><button type=\"button\" \nclass=\"mvg-toggle\" ng-class=\"{\'is-on\': row[col.titleId] == 1}\" aria-label=\"{{col.field_name}}\" \nng-click=\"row[col.titleId] = (row[col.titleId] == 1 ? 0 : 1); host.gridSaveRow(row)\"><md-icon \nmd-font-icon=\"{{ row[col.titleId] == 1 ? \'icon-check\' : \'icon-close\' }}\" class=\"s16\"></md-icon></button></div><div \nng-if=\"host.gridCellKind(col) === \'date\'\" class=\"mvg-editor\"><input type=\"date\" class=\"mvg-input mvg-date-input\" \nng-model=\"row[\'$d_\' + col.titleId]\" ng-change=\"host.onGridDateChange(row, col)\" max=\"9999-12-31\"></div><div \nng-if=\"host.gridCellKind(col) === \'datetime\'\" class=\"mvg-editor\"><input type=\"datetime-local\" \nclass=\"mvg-input mvg-date-input\" ng-model=\"row[\'$d_\' + col.titleId]\" ng-change=\"host.onGridDateChange(row, col)\" \nmax=\"9999-12-31T23:59\"></div><div ng-if=\"host.gridCellKind(col) === \'assoc\'\" class=\"mvg-editor\"><md-select \nclass=\"mvg-select\" ng-model=\"row[col.titleId]\" placeholder=\"—\" md-on-close=\"q.term = \'\'\" \nng-change=\"host.gridSaveRow(row)\" aria-label=\"{{col.field_name}}\"><md-select-header class=\"mvg-select-header\"><input \nclass=\"mvg-select-search\" type=\"search\" ng-model=\"q.term\" placeholder=\"Buscar…\" ng-click=\"$event.stopPropagation()\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-option value=\"\">—</md-option><md-option \nng-repeat=\"o in host.getShowAssoc(col) | filter: {val: q.term}\" ng-value=\"o.id\">{{o.val}}</md-option></md-select></div>\n<div ng-if=\"host.gridCellKind(col) === \'subsec\'\" class=\"mvg-editor\"><md-select class=\"mvg-select\" \nng-model=\"row[col.titleId]\" placeholder=\"—\" ng-change=\"host.gridSaveRow(row)\" aria-label=\"{{col.field_name}}\">\n<md-option value=\"\">—</md-option><md-option ng-repeat=\"o in host.gridSubsections()\" ng-value=\"o.id_subsec\">{{o.subsec}}\n</md-option></md-select></div><div ng-if=\"host.gridCellKind(col) === \'cat\'\" class=\"mvg-editor\"><md-select \nclass=\"mvg-select\" ng-model=\"row[col.titleId]\" placeholder=\"—\" ng-change=\"host.gridSaveRow(row)\" \naria-label=\"{{col.field_name}}\"><md-option value=\"\">—</md-option><md-option ng-repeat=\"o in host.gridCategories()\" \nng-value=\"o.id_cat\">{{o.cat}}</md-option></md-select></div><div ng-if=\"host.gridCellKind(col) === \'subcat\'\" \nclass=\"mvg-editor\"><md-select class=\"mvg-select\" ng-model=\"row[col.titleId]\" placeholder=\"—\" \nng-change=\"host.gridSaveRow(row)\" aria-label=\"{{col.field_name}}\"><md-option value=\"\">—</md-option><md-option \nng-repeat=\"o in host.gridSubcategories()\" ng-value=\"o.id_subcat\">{{o.subcat}}</md-option></md-select></div><div \nng-if=\"host.gridCellKind(col) === \'language\'\" class=\"mvg-editor\"><md-select class=\"mvg-select\" \nng-model=\"row[col.titleId]\" ng-change=\"host.gridSaveRow(row)\" aria-label=\"{{col.field_name}}\"><md-option \nng-repeat=\"l in host.siteLanguages()\" ng-value=\"l.id_lang\">{{l.lang_name}}</md-option></md-select></div><input \nng-if=\"host.gridCellKind(col) === \'number\'\" class=\"mvg-input\" type=\"number\" ng-model=\"row[col.titleId]\" \nng-blur=\"host.gridSaveRow(row)\" placeholder=\"{{col.field_name}}\"> <input ng-if=\"host.gridCellKind(col) === \'color\'\" \nclass=\"mvg-input\" type=\"text\" ng-model=\"row[col.titleId]\" ng-blur=\"host.gridSaveRow(row)\" \nplaceholder=\"{{col.field_name}}\"><textarea ng-if=\"host.gridCellKind(col) === \'textarea\'\" class=\"mvg-textarea\" rows=\"1\" \nng-model=\"row[col.titleId]\" ng-blur=\"host.gridSaveRow(row)\"></textarea><input \nng-if=\"host.gridCellKind(col) === \'text\'\" class=\"mvg-input\" type=\"text\" ng-model=\"row[col.titleId]\" \nng-blur=\"host.gridSaveRow(row)\" placeholder=\"{{col.field_name}}\">");
$templateCache.put("app/main/apps/content/views/list/list-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-show=\"isLoading\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nclass=\"mail-list-item filter-selected\" ng-if=\"sortField\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\" flex><div class=\"info\" ng-if=\"sortField\"><div class=\"name\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-sort-ascending\" class=\"s20 mr-5 ml-0 mb-0\" \nng-if=\"sortDir === \'ASC\'\"></md-icon><md-icon md-font-icon=\"icon-sort-descending\" class=\"s20 mr-5 ml-0 mb-0\" \nng-if=\"sortDir === \'DESC\'\"></md-icon><div class=\"title text-truncate\" layout=\"row\" layout-align=\"start center\"><span \ntranslate=\"CONTENT.ORDER_BY\"></span> \'{{sortField}}\'</div></div></div></div><div class=\"buttons\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-close s20\" ng-click=\"pagination_resetOrderBy()\" class=\"ml-10\">\n<md-tooltip hide show-gt-xs><span translate=\"CONTENT.REMOVE\"></span></md-tooltip></md-icon></div></div><div \nclass=\"mail-list-item filter-selected\" ng-if=\"$root.pagination_searchquery==true\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"info\" flex><div class=\"name\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-filter\" class=\"s20 mr-8 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><div class=\"title\" layout=\"row\" \nlayout-align=\"start center\"><div ng-repeat=\"filterable in refFilterables track by $index\" class=\"inline-block\"><div \nng-repeat=\"label in filterable.values | filterInArray:filterable.selected:\'value\' track by $index\" \nclass=\"mr-5 tag-list inline-block\"><span class=\"grey-50-fg\">{{label.name}}</span></div></div></div><div \nclass=\"title text-truncate pl-10\" layout=\"row\" layout-align=\"start center\" ng-if=\"$root.modelSearch\">\n{{$root.modelSearch}}</div></div></div><div class=\"buttons\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-close s20\" ng-click=\"$root.pagination_resetquery(); vm.resetFilters()\" class=\"ml-10\"><md-tooltip \nhide show-gt-xs><span translate=\"CONTENT.REMOVE_FILTERS\">Remove filters</span></md-tooltip></md-icon></div></div><div \nclass=\"no-threads\" ng-if=\"!isLoading && vm.threads.length === 0\" ng-hide=\"isLoading\" translate=\"CONTENT.NO_ITEMS\">\n</div><div id=\"list-content-data\" ng-style=\"{\'opacity\' : isLoading ? 0.2 : 1}\" ms-scroll=\"vm.msScrollOptions\" \nng-class=\"{\'group-filter\': vm.selectedGroup,\'other-filter\':sortField,\'x2-filter\':$root.pagination_searchquery==true}\" \nclass=\"scrollable\" ng-if=\"vm.threads.length > 0\" dnd-list=\"vm.threads\"><div class=\"mail-list-item {{thread.status}}\" \nng-repeat=\"thread in vm.threads | filter: vm.search | filter: global.search\" ng-init=\"parentIndex = $index\" \nng-click=\"vm.openThread(thread)\" md-no-ink ng-cloak \nng-class=\"{\'starred\': thread.starred, \'selected\': vm.selectedContentID === thread.id, \'checked\': vm.isChecked(thread)}\" \nlayout=\"row\"><span dnd-draggable=\"thread\" dnd-effect-allowed=\"move\" dnd-moved=\"vm.threads.splice($index, 1)\" \ndnd-dragend=\"vm.elementDragged(thread)\" ng-if=\"vm.ActiveSection.drag_and_drop && sortField === \'sort\'\" \nclass=\"drag dragger icon-equal\" ng-click=\"vm.preventDefault($event)\"></span><div class=\"mail-list-item-content\" \nlayout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-label\" ng-checked=\"vm.isSelected(thread)\" \nng-click=\"vm.toggleSelectThread(thread, $event)\" aria-label=\"{{vm.isSelected(thread) ? \'Deselect\' : \'Select\'}}\">\n</md-checkbox><div ng-repeat=\"field in refcolumnsgrouped.left_center | orderBy:\'list_sort\'\"><div \nng-if=\"field.type == \'onoff\'\" ng-include=\"\'app/main/fields/list/onoff.html\'\"></div><div \nng-if=\"field.type == \'language\'\" ng-include=\"\'app/main/fields/list/language.html\'\" layout=\"row\" \nlayout-align=\"center center\"></div><div ng-if=\"field.type == \'thumbnail\'\" \nng-include=\"\'app/main/fields/list/thumbnail.html\'\"></div><div ng-if=\"field.type == \'thumbnail_square\'\" \nng-include=\"\'app/main/fields/list/thumbnail_square.html\'\"></div><md-icon md-font-icon=\"icon-alert-circle\" \nclass=\"is-important red-600-fg\" ng-if=\"field.type == \'important\' && task.important\"></md-icon><md-icon \nmd-font-icon=\"icon-attachment\" class=\"has-attachment s24\" \nng-if=\"field.type == \'attachments\' && thread.Thumbnail.length > 0\"></md-icon></div><div class=\"info\" flex \nlayout=\"column\"><div ng-if=\"refcolumnsgrouped.main\"><div class=\"subject text-truncate grey-500-fg\"><span \nng-repeat=\"field in refcolumnsgrouped.header | orderBy: \'list_sort\'\"><span ng-if=\"field.type == \'id\'\">#</span> <span \nng-if=\"field.type == \'dateHm\' || field.type == \'date\'\" ng-bind=\"vm.showDate(thread[field.titleId])\"></span> <span \nng-if=\"field.type != \'dateHm\' && field.type != \'date\' && field.type != \'section\'\" ng-bind=\"thread.{{field.titleId}}\">\n</span> <span ng-if=\"field.type == \'section\'\" ng-bind=\"vm.showAssoc(thread[field.titleId], field)\"></span></span></div>\n</div><div ng-if=\"refcolumnsgrouped.main\"><div class=\"name\" layout=\"row\" layout-align=\"start center\"><span \nng-repeat=\"field in refcolumnsgrouped.main\" ng-switch=\"\" on=\"field.type\"><span ng-switch-default=\"\" \nng-bind=\"thread.{{field.titleId}}\"></span> <span ng-switch-when=\"date\" ng-bind=\"vm.showDate(thread[field.titleId])\">\n</span> <span ng-switch-when=\"dateHm\" ng-bind=\"vm.showDate(thread[field.titleId])\"></span> <span \nng-switch-when=\"section\" ng-bind=\"vm.showAssoc(thread[field.titleId], field)\"></span></span></div></div><div \nng-repeat=\"field in refcolumnsgrouped.secondary | orderBy:\'list_sort\'\"><div \nng-if=\"(field.type!==\'id_subcat\' && field.type!==\'id_cat\' && field.type!==\'country\' && field.type!==\'id_subsec\' && field.type!==\'date\' && field.type!==\'dateHm\' && field.type!==\'section\') && field.primary!==1\" \nng-include=\"\'app/main/fields/list/secondary-default.html\'\" class=\"details text-truncate\"></div><div \nng-if=\"field.type==\'id_subsec\'\" ng-include=\"\'app/main/fields/list/subsection.html\'\" class=\"details\" layout=\"row\" \nlayout-align=\"start start\"></div><div ng-if=\"field.type==\'id_cat\'\" ng-include=\"\'app/main/fields/list/category.html\'\" \nclass=\"details\" layout=\"row\" layout-align=\"start start\"></div><div ng-if=\"field.type==\'id_subcat\'\" \nng-include=\"\'app/main/fields/list/subcategory.html\'\" class=\"details\" layout=\"row\" layout-align=\"start start\"></div><div\n ng-if=\"field.type == \'section\'\" ng-include=\"\'app/main/fields/list/section.html\'\" class=\"details\" layout=\"row\" \nlayout-align=\"start start\"></div><div ng-if=\"field.type == \'country\'\" ng-include=\"\'app/main/fields/list/country.html\'\" \nclass=\"details\" layout=\"row\" layout-align=\"start start\"></div></div></div><div class=\"buttons\" layout=\"row\" \nlayout-align=\"start center\"><div ng-repeat=\"field in refcolumnsgrouped.right_center | orderBy:\'list_sort\'\"><div \nng-if=\"field.type == \'onoff\'\" ng-include=\"\'app/main/fields/list/onoff.html\'\"></div><div \nng-if=\"field.type == \'language\'\" ng-include=\"\'app/main/fields/list/language.html\'\" layout=\"row\" \nlayout-align=\"center center\"></div><div ng-if=\"field.type == \'thumbnail\'\" \nng-include=\"\'app/main/fields/list/thumbnail.html\'\"></div><div ng-if=\"field.type == \'thumbnail_square\'\" \nng-include=\"\'app/main/fields/list/thumbnail_square.html\'\"></div><div ng-if=\"field.type == \'timer\'\" \nng-include=\"\'app/main/fields/list/timer.html\'\"></div><md-icon md-font-icon=\"icon-alert-circle\" \nclass=\"is-important red-600-fg\" ng-if=\"field.type == \'important\' && task.important\"></md-icon><md-icon \nmd-font-icon=\"icon-attachment\" class=\"has-attachment s24\" \nng-if=\"field.type == \'attachments\' && thread.Thumbnail.length > 0\"></md-icon></div></div><div layout=\"column\" \nlayout-align=\"space-between end\"></div></div></div><div class=\"toolbar\" layout=\"row\" layout-align=\"end center\"><div \nlayout=\"row\" layout-align=\"center center\" ng-style=\"{\'display\' : isLoading ? \'none\' : \'block\'}\"><span \nclass=\"page-info\">{{pagination_totalItems}} {{vm.translate(\'CONTENT.ITEMS_FOUND\')}}</span><md-button \naria-label=\"Previous\" class=\"md-icon-button arrow\" ng-click=\"pagination_prevPage()\" \nng-disabled=\"pagination_firstPage()\" translate=\"\" translate-attr-aria-label=\"CONTENT.PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><span class=\"page-info\">\n{{pagination_page}} / {{pagination_total_pages}}</span><md-button aria-label=\"Next\" class=\"md-icon-button arrow\" \nng-click=\"pagination_nextPage()\" ng-disabled=\"pagination_morePages()\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div>\n</div>");
$templateCache.put("app/main/apps/content/views/list/nosplit-view-grid.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/content/views/list/toolbar-grid.html\'\" ng-hide=\"vm.mediaSelected\"></div><div \nclass=\"content-wrapper\" flex=\"\" layout=\"row\"><div class=\"content thread-detail mail-read-pane\" flex=\"\" \nid=\"thread-detail\" ms-scroll=\"vm.msScrollOptions\" ng-if=\"vm.mediaSelected\" \nng-include=\"\'app/main/apps/media/views/edit-layout.html\'\"></div><div class=\"content thread-list mail-list-pane\" \nflex=\"\" id=\"thread-list\" ng-if=\"!vm.mediaSelected\" \nng-include=\"\'app/main/apps/content/views/grid/social-stream-grid.html\'\"></div></div>");
$templateCache.put("app/main/apps/content/views/list/nosplit-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/content/views/list/toolbar.html\'\" ng-hide=\"vm.currentThread || vm.currentThread_Edit\"></div>\n<div class=\"content-wrapper\" flex=\"\" layout=\"row\"><div class=\"content thread-detail mail-read-pane\" flex=\"\" \nid=\"thread-detail\" ms-scroll=\"vm.msScrollOptions\" ng-if=\"vm.currentThread || vm.currentThread_Edit\" \nng-include=\"\'app/main/apps/content/views/read/read-view-nosplit.html\'\"></div><div \nclass=\"content thread-list mail-list-pane\" flex id=\"thread-list\" ng-if=\"!vm.currentThread && !vm.currentThread_Edit\" \nng-include=\"\'app/main/apps/content/views/list/list-view.html\'\"></div></div>");
$templateCache.put("app/main/apps/content/views/list/split-view-grid.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/content/views/list/toolbar-grid.html\'\"></div><div class=\"content-wrapper\" flex=\"\" \nlayout=\"row\"><div class=\"content thread-list mail-list-pane\" flex=\"50\" id=\"thread-list\" ng-if=\"!vm.mediaSelected\" \nng-include=\"\'app/main/apps/content/views/grid/social-stream-grid.html\'\"></div><div \nclass=\"content thread-detail mail-read-pane\" flex=\"50\" id=\"thread-detail\" layout=\"column\" \nng-include=\"\'app/main/apps/content/views/read/read-view-social-stream.html\'\"></div></div>");
$templateCache.put("app/main/apps/content/views/list/split-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/content/views/list/toolbar.html\'\"></div><div class=\"content-wrapper\" flex=\"\" layout=\"row\">\n<div class=\"content thread-list mail-list-pane\" flex=\"50\" id=\"thread-list\" \nng-include=\"\'app/main/apps/content/views/list/list-view.html\'\"></div><div class=\"content thread-detail mail-read-pane\" \nflex=\"50\" id=\"thread-detail\" layout=\"column\" ng-include=\"\'app/main/apps/content/views/read/read-view.html\'\"></div>\n</div>");
$templateCache.put("app/main/apps/content/views/list/spreadsheet-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/content/views/list/toolbar.html\'\"></div><mv-grid flex rows=\"vm.threads\" \ncolumns=\"vm.gridCols\" host=\"vm\" loading=\"isLoading\" settings-key=\"{{vm.gridSettingsSection}}\" sort-field=\"list_sort\" \ncell-template=\"app/main/apps/content/views/list/grid-cells.html\" fixed-columns=\"vm.gridFixedColumns\" \nrow-init=\"vm.ensureGridRow(row)\" is-selected=\"vm.isSelected(row)\" \non-toggle-select=\"vm.toggleSelectThread(row, $event)\" api=\"vm.gridApi\" new-row-init=\"vm.gridNewRowDefaults()\" \non-new-row-save=\"vm.gridCreateRow(row)\" empty-text=\"CONTENT.NO_ITEMS\"></mv-grid>");
$templateCache.put("app/main/apps/content/views/list/toolbar-grid.html","<div layout=\"row\" layout-align=\"start center\"><ms-search-bar debounce=\"300\" \nmodel-search=\"$root.pagination_searchquery\" on-result-click=\"vm.searchResultClick(item)\" on-search=\"vm.search(query)\" \nlayout=\"row\" layout-align=\"start center\"></ms-search-bar><md-button aria-label=\"view type\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'main-sidenav\')\" translate=\"\" translate-attr-aria-label=\"CONTENT.FILTERS\"><md-icon \nmd-font-icon=\"icon-filter\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.FILTERS\"></span></md-tooltip>\n</md-button><div class=\"divider-vertical\" hide=\"\" show-gt-xs=\"\"></div><md-button hide show-gt-xs \naria-label=\"Sort Direction\" class=\"md-icon-button\" ng-click=\"pagination_setSortField(null,\'ASC\')\" \nng-disabled=\"!sortField\" ng-if=\"sortDir !== \'ASC\'\" translate=\"\" translate-attr-aria-label=\"TODO.SORT_DIRECTION\">\n<md-icon md-font-icon=\"icon-sort-descending\" ng-if=\"sortDir !== \'ASC\'\"></md-icon><md-icon \nmd-font-icon=\"icon-sort-ascending\" ng-if=\"sortDir === \'ASC\'\"></md-icon></md-button><md-button hide show-gt-xs \naria-label=\"Sort Direction\" class=\"md-icon-button\" ng-click=\"pagination_setSortField(null,\'DESC\')\" \nng-disabled=\"!sortField\" ng-if=\"sortDir === \'ASC\'\" translate=\"\" translate-attr-aria-label=\"TODO.SORT_DIRECTION\">\n<md-icon md-font-icon=\"icon-sort-descending\" ng-if=\"sortDir !== \'ASC\'\"></md-icon><md-icon \nmd-font-icon=\"icon-sort-ascending\" ng-if=\"sortDir === \'ASC\'\"></md-icon></md-button><md-menu hide show-gt-xs><button \naria-label=\"Filters\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" show-gt-xs=\"\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.FILTERS\"><md-icon md-font-icon=\"icon-chevron-down\"></md-icon></button>\n<md-menu-content width=\"4\"><md-menu-item ng-repeat=\"sortfield in refSortables\"><md-button aria-label=\"All\" \nng-click=\"pagination_setSortField(sortfield.titleId)\"><div layout=\"row\" layout-align=\"space-between center\"><span>\n{{vm.translate(\'CONTENT.ORDER_BY\')}} {{sortfield.name}} </span><i class=\"icon-check s16\" \nng-if=\"sortfield.titleId == sortField\"></i></div></md-button></md-menu-item><md-menu-item ng-if=\"sortable\"><md-button \naria-label=\"Remove sort\" ng-click=\"pagination_resetOrderBy()\"><md-icon md-font-icon=\"icon-close \"></md-icon><span \ntranslate=\"CONTENT.REMOVE_ORDER\"></span></md-button></md-menu-item></md-menu-content></md-menu><md-menu hide=\"\" \nshow-gt-xs=\"\" ng-if=\"refGroupables.length>0\"><button aria-label=\"Filters\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\" show-gt-xs=\"\" translate=\"\" translate-attr-aria-label=\"CONTENT.FILTERS\"><md-icon \nmd-font-icon=\"icon-chevron-down\"><md-tooltip hide show-gt-xs><span translate=\"CONTENT.GROUP_BY\"></span></md-tooltip>\n</md-icon></button><md-menu-content width=\"4\"><md-menu-item ng-repeat=\"sortfield in refGroupables\"><md-button \naria-label=\"All\" ng-click=\"pagination_setOrderBy(sortfield)\"><div layout=\"row\" layout-align=\"space-between center\">\n<span translate=\"CONTENT.GROUP_BY\"></span> <span>{{sortfield.name}}</span> <i class=\"icon-check s16\" \nng-if=\"sortfield.titleId == sortable.titleId\"></i></div></md-button></md-menu-item><md-menu-item ng-if=\"groupable\">\n<md-button aria-label=\"Remove group\" ng-click=\"pagination_resetOrderBy()\"><md-icon md-font-icon=\"icon-close \">\n</md-icon><span translate=\"CONTENT.REMOVE_GROUP_BY\"></span></md-button></md-menu-item></md-menu-content></md-menu><div \naria-hidden=\"false\" class=\"action-buttons hide show-gt-xs layout-align-start-center layout-row\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"vm.selectedThreads.length > 0\"><div class=\"divider-vertical\" hide=\"\" \nshow-gt-xs=\"\"></div><md-button ng-click=\"vm.massActions(\'duplicate\')\" aria-label=\"Duplicate\" class=\"md-icon-button\" \nhide=\"\" show-gt-xs=\"\" translate=\"\" translate-attr-aria-label=\"CONTENT.DUPLICATE\"><md-icon \nmd-font-icon=\"icon-content-duplicate\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.DUPLICATE\"></span>\n</md-tooltip></md-button><md-button ng-if=\"vm.aiTranslateEnabled\" ng-click=\"vm.openAiTranslate()\" \naria-label=\"Translate\" class=\"md-icon-button\" hide=\"\" show-gt-xs=\"\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.TRANSLATE\"><md-icon md-font-icon=\"icon-content-duplicate-translate\"></md-icon>\n<md-tooltip hide show-gt-xs><span translate=\"CONTENT.TRANSLATE\"></span></md-tooltip></md-button><md-button \nng-click=\"vm.massActions(\'delete\')\" aria-label=\"Delete\" class=\"md-icon-button\" hide=\"\" show-gt-xs=\"\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip hide show-gt-xs>\n<span translate=\"CONTENT.DELETE\"></span></md-tooltip></md-button><div class=\"divider-vertical\" hide=\"\" show-gt-xs=\"\">\n</div></div></div><div layout=\"row\" layout-align=\"start center\" translate-attr-aria-label=\"CONTENT.REFRESH\" \nclass=\"qiu-pagination\" ng-hide=\"isLoading\"><span class=\"page-info\" hide show-gt-xs>\n{{pagination_totalItems}} {{vm.translate(\'CONTENT.ITEMS_FOUND\')}}</span><md-button aria-label=\"Previous\" \nclass=\"md-icon-button arrow\" hide=\"\" ng-click=\"pagination_prevPage()\" ng-disabled=\"pagination_firstPage()\" \nshow-gt-xs=\"\" translate=\"\" translate-attr-aria-label=\"CONTENT.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.PREVIOUS\"></span></md-tooltip></md-button><div hide \nshow-gt-xs><md-select ng-model=\"pagination_page\" placeholder=\"Page\" class=\"toolbar-item\"><md-option \nng-repeat=\"n in [].constructor(pagination_total_pages) track by $index\" value=\"{{$index +1}}\" \nng-click=\"pagination_gotoPage($index+1)\">{{$index+1}}</md-option></md-select><md-tooltip><span \ntranslate=\"CONTENT.SELECT_PAGE\"></span></md-tooltip></div><span class=\"page-info ml-10\" hide show-gt-xs>/ <span \nclass=\"ml-5\">{{pagination_total_pages}}</span></span><md-button aria-label=\"Next\" class=\"md-icon-button arrow\" hide=\"\" \nng-click=\"pagination_nextPage()\" ng-disabled=\"pagination_morePages()\" show-gt-xs=\"\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip hide \nshow-gt-xs><span translate=\"CONTENT.NEXT\"></span></md-tooltip></md-button><div class=\"divider-vertical\" hide hide \nshow-gt-sm></div><md-button class=\"md-icon-button\" ng-click=\"vm.changeView(\'nosplit\')\" \nng-if=\"vm.currentView !== \'nosplit\'\" hide show-gt-sm aria-label=\"noSplit\"><md-icon md-font-icon=\"icon-view-list\" \nng-if=\"vm.currentView !== \'nosplit\'\"></md-icon><md-icon class=\"md-accent\" md-font-icon=\"icon-checkbox-marked\" \nng-if=\"vm.currentView === \'nosplit\'\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.NOSPLIT_VIEW\">\n</span></md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.changeView(\'split\')\" \nng-if=\"vm.currentView !== \'split\'\" hide show-gt-sm aria-label=\"Split\"><md-icon md-font-icon=\"icon-view-quilt\" \nng-if=\"vm.currentView !== \'split\'\"></md-icon><md-icon class=\"md-accent\" md-font-icon=\"icon-checkbox-marked\" \nng-if=\"vm.currentView === \'split\'\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.SPLIT_VIEW\"></span>\n</md-tooltip></md-button><md-menu-bar class=\"pr-0 pl-0\" hide-gt-xs><md-menu class=\"settings-menu\"><md-button \naria-label=\"Settings\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.SETTINGS\"><md-icon md-font-icon=\"icon-cog\"></md-icon></md-button><md-menu-content>\n<md-menu-item><md-menu><md-button aria-label=\"Filters\" ng-click=\"$mdMenu.open($event)\"><md-icon \nmd-font-icon=\"icon-sort\"></md-icon><span translate=\"CONTENT.ORDER_BY\">Order by</span></md-button><md-menu-content>\n<md-menu-item ng-repeat=\"sortfield in refSortables\"><md-button aria-label=\"All\" \nng-click=\"pagination_setSortField(sortfield.titleId)\"><div layout=\"row\" layout-align=\"space-between center\"><span>\n{{sortfield.name}}</span> <i class=\"icon-check s16\" ng-if=\"sortfield.titleId == sortField\"></i></div></md-button>\n</md-menu-item><md-menu-item ng-repeat=\"field in vm.refcolumns\" ng-if=\"field.sortable === 1\"><md-button \nng-click=\"vm.setSortField(field.title)\"><div layout=\"row\" layout-align=\"space-between center\"><span>\n{{field.field_name}}</span> <i class=\"icon-check s16\" ng-if=\"vm.fieldOrder === field.field_name\"></i></div></md-button>\n</md-menu-item></md-menu-content></md-menu></md-menu-item><md-menu-item><md-button \nng-click=\"pagination_setSortField(null,\'ASC\')\" ng-disabled=\"!sortField\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-sort-ascending\"></md-icon><span translate=\"CONTENT.DIRECTION_A_Z\">Order A-Z</span></div><i \nclass=\"icon-check s16\" ng-if=\"sortDir === \'ASC\'\"></i></div></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"pagination_setSortField(null,\'DESC\')\" ng-disabled=\"!sortField\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-sort-descending\"></md-icon><span translate=\"CONTENT.DIRECTION_Z_A\">Order Z-A</span></div><i \nclass=\"icon-check s16\" ng-if=\"sortDir === \'DESC\'\"></i></div></md-button></md-menu-item><md-menu-item \nshow=\"vm.selectedMail.length > 0 || vm.allChecked\"><md-button ng-click=\"vm.massActions(\'duplicate\')\" \naria-label=\"Duplicate\" translate-attr-aria-label=\"CONTENT.DUPLICATE\" ng-disabled=\"vm.selectedThreads.length == 0\">\n<md-icon md-font-icon=\"icon-content-duplicate\"></md-icon><span translate=\"CONTENT.DUPLICATE\"></span></md-button>\n</md-menu-item><md-menu-item ng-if=\"vm.aiTranslateEnabled\"><md-button ng-click=\"vm.openAiTranslate()\" \naria-label=\"Translate\" class=\"md-icon-button\" hide=\"\" show-gt-xs=\"\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.TRANSLATE\"><md-icon md-font-icon=\"icon-content-duplicate-translate\"></md-icon><span \ntranslate=\"CONTENT.TRANSLATE\"></span></md-button></md-menu-item><md-menu-item \nshow=\"vm.selectedMail.length > 0 || vm.allChecked\"><md-button ng-click=\"vm.massActions(\'delete\')\" aria-label=\"Delete\" \ntranslate-aria-label=\"CONTENT.DELETE\" ng-disabled=\"vm.selectedThreads.length == 0\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon><span translate=\"CONTENT.DELETE\"></span></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar>\n</div>");
$templateCache.put("app/main/apps/content/views/list/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-label\" \naria-label=\"{{vm.selectedThreads.length > 0 ? \'Deselect All\' : \'Select All\'}}\" \nng-checked=\"vm.selectedThreads.length > 0\" ng-click=\"vm.toggleSelectThreads()\"></md-checkbox><div \nclass=\"divider-vertical\" ng-if=\"section !== \'forms\'\" hide=\"\" show-gt-xs=\"\"></div><md-button aria-label=\"ADD NEW\" \nng-if=\"section !== \'forms\'\" class=\"md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme\" \nhide show-gt-sm ng-click=\"vm.newThread()\" translate=\"CONTENT.ADD\" type=\"button\">Add new</md-button><md-button \naria-label=\"Import\" ng-if=\"vm.importableRefs.length > 0\" ng-click=\"vm.openImportDialog()\" \nclass=\"md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme\" hide show-gt-sm ng-click=\"\" \ntranslate=\"CONTENT.IMPORT\" type=\"button\">Import</md-button><md-button aria-label=\"ADD NEW\" \nclass=\"md-fab md-mini md-accent green-500-bg md-raised md-ink-ripple md-default-theme\" hide-gt-sm \nng-click=\"vm.newThread()\" type=\"button\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><div \nclass=\"divider-vertical\" hide=\"\" show-gt-xs=\"\"></div><ms-search-bar debounce=\"300\" \nmodel-search=\"$root.pagination_searchquery\" on-result-click=\"vm.searchResultClick(item)\" on-search=\"vm.search(query)\" \nlayout=\"row\" layout-align=\"start center\"></ms-search-bar><md-button aria-label=\"view type\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'main-sidenav\')\" translate=\"\" translate-attr-aria-label=\"CONTENT.FILTERS\"><md-icon \nmd-font-icon=\"icon-filter\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.FILTERS\"></span></md-tooltip>\n</md-button><div class=\"divider-vertical\" hide=\"\" show-gt-xs=\"\"></div><md-button hide show-gt-xs \naria-label=\"Sort Direction\" class=\"md-icon-button\" ng-click=\"pagination_setSortField(null,\'ASC\')\" \nng-disabled=\"!sortField\" ng-if=\"sortDir !== \'ASC\'\" translate=\"\" translate-attr-aria-label=\"TODO.SORT_DIRECTION\">\n<md-icon md-font-icon=\"icon-sort-descending\" ng-if=\"sortDir !== \'ASC\'\"></md-icon><md-icon \nmd-font-icon=\"icon-sort-ascending\" ng-if=\"sortDir === \'ASC\'\"></md-icon></md-button><md-button hide show-gt-xs \naria-label=\"Sort Direction\" class=\"md-icon-button\" ng-click=\"pagination_setSortField(null,\'DESC\')\" \nng-disabled=\"!sortField\" ng-if=\"sortDir === \'ASC\'\" translate=\"\" translate-attr-aria-label=\"TODO.SORT_DIRECTION\">\n<md-icon md-font-icon=\"icon-sort-descending\" ng-if=\"sortDir !== \'ASC\'\"></md-icon><md-icon \nmd-font-icon=\"icon-sort-ascending\" ng-if=\"sortDir === \'ASC\'\"></md-icon></md-button><md-menu hide show-gt-xs><button \naria-label=\"Filters\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" show-gt-xs=\"\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.FILTERS\"><md-icon md-font-icon=\"icon-chevron-down\"></md-icon></button>\n<md-menu-content width=\"4\"><md-menu-item ng-repeat=\"sortfield in refSortables\"><md-button aria-label=\"All\" \nng-click=\"pagination_setSortField(sortfield.titleId)\"><div layout=\"row\" layout-align=\"space-between center\"><span>\n{{vm.translate(\'CONTENT.ORDER_BY\')}} {{sortfield.name}} </span><i class=\"icon-check s16\" \nng-if=\"sortfield.titleId == sortField\"></i></div></md-button></md-menu-item><md-menu-item ng-if=\"sortable\"><md-button \naria-label=\"Remove sort\" ng-click=\"pagination_resetOrderBy()\"><md-icon md-font-icon=\"icon-close \"></md-icon><span \ntranslate=\"CONTENT.REMOVE_ORDER\"></span></md-button></md-menu-item></md-menu-content></md-menu><md-menu hide=\"\" \nshow-gt-xs=\"\" ng-if=\"refGroupables.length>0\"><button aria-label=\"Filters\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\" show-gt-xs=\"\" translate=\"\" translate-attr-aria-label=\"CONTENT.FILTERS\"><md-icon \nmd-font-icon=\"icon-chevron-down\"><md-tooltip hide show-gt-xs><span translate=\"CONTENT.GROUP_BY\"></span></md-tooltip>\n</md-icon></button><md-menu-content width=\"4\"><md-menu-item ng-repeat=\"sortfield in refGroupables\"><md-button \naria-label=\"All\" ng-click=\"pagination_setOrderBy(sortfield)\"><div layout=\"row\" layout-align=\"space-between center\">\n<span translate=\"CONTENT.GROUP_BY\"></span> <span>{{sortfield.name}}</span> <i class=\"icon-check s16\" \nng-if=\"sortfield.titleId == sortable.titleId\"></i></div></md-button></md-menu-item><md-menu-item ng-if=\"groupable\">\n<md-button aria-label=\"Remove group\" ng-click=\"pagination_resetOrderBy()\"><md-icon md-font-icon=\"icon-close \">\n</md-icon><span translate=\"CONTENT.REMOVE_GROUP_BY\"></span></md-button></md-menu-item></md-menu-content></md-menu><div \naria-hidden=\"false\" class=\"action-buttons hide show-gt-xs layout-align-start-center layout-row\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"vm.selectedThreads.length > 0\"><div class=\"divider-vertical\" hide=\"\" \nshow-gt-xs=\"\"></div><md-button ng-if=\"vm.currentView !== \'spreadsheet\'\" ng-click=\"vm.massActions(\'duplicate\')\" \naria-label=\"Duplicate\" class=\"md-icon-button\" hide=\"\" show-gt-xs=\"\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.DUPLICATE\"><md-icon md-font-icon=\"icon-content-duplicate\"></md-icon><md-tooltip \nhide show-gt-xs><span translate=\"CONTENT.DUPLICATE\"></span></md-tooltip></md-button><md-button \nng-if=\"vm.aiTranslateEnabled && vm.currentView !== \'spreadsheet\'\" ng-click=\"vm.openAiTranslate()\" \naria-label=\"Translate\" class=\"md-icon-button\" hide=\"\" show-gt-xs=\"\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.TRANSLATE\"><md-icon md-font-icon=\"icon-content-duplicate-translate\"></md-icon>\n<md-tooltip hide show-gt-xs><span translate=\"CONTENT.TRANSLATE\"></span></md-tooltip></md-button><md-button \nng-click=\"vm.massActions(\'delete\')\" aria-label=\"Delete\" class=\"md-icon-button\" hide=\"\" show-gt-xs=\"\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip hide show-gt-xs>\n<span translate=\"CONTENT.DELETE\"></span></md-tooltip></md-button><md-button ng-click=\"vm.massActions(\'recache\')\" \naria-label=\"Recache\" class=\"md-icon-button\" hide=\"\" show-gt-xs=\"\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.RECACHE\"><md-icon md-font-icon=\"icon-refresh\"></md-icon><md-tooltip hide show-gt-xs>\n<span translate=\"CONTENT.RECACHE\"></span></md-tooltip></md-button><div class=\"divider-vertical\" hide=\"\" show-gt-xs=\"\">\n</div></div></div><div layout=\"row\" layout-align=\"start center\" translate-attr-aria-label=\"CONTENT.REFRESH\" \nclass=\"qiu-pagination\" ng-hide=\"isLoading\"><span class=\"page-info\" hide show-gt-xs>\n{{pagination_totalItems}} {{vm.translate(\'CONTENT.ITEMS_FOUND\')}}</span><md-button aria-label=\"Previous\" \nclass=\"md-icon-button arrow\" hide=\"\" ng-click=\"pagination_prevPage()\" ng-disabled=\"pagination_firstPage()\" \nshow-gt-xs=\"\" translate=\"\" translate-attr-aria-label=\"CONTENT.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.PREVIOUS\"></span></md-tooltip></md-button><div hide \nshow-gt-xs><md-select ng-model=\"pagination_page\" placeholder=\"Page\" class=\"toolbar-item\"><md-option \nng-repeat=\"n in [].constructor(pagination_total_pages) track by $index\" value=\"{{$index +1}}\" \nng-click=\"pagination_gotoPage($index+1)\">{{$index+1}}</md-option></md-select><md-tooltip><span \ntranslate=\"CONTENT.SELECT_PAGE\"></span></md-tooltip></div><span class=\"page-info ml-10\" hide show-gt-xs>/ <span \nclass=\"ml-5\">{{pagination_total_pages}}</span></span><md-button aria-label=\"Next\" class=\"md-icon-button arrow\" hide=\"\" \nng-click=\"pagination_nextPage()\" ng-disabled=\"pagination_morePages()\" show-gt-xs=\"\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip hide \nshow-gt-xs><span translate=\"CONTENT.NEXT\"></span></md-tooltip></md-button><div class=\"divider-vertical\" hide hide \nshow-gt-sm></div><md-menu md-offset=\"0 20\" hide show-gt-sm><md-button class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\" aria-label=\"View\"><md-icon md-font-icon=\"icon-view-list\" \nng-if=\"vm.currentView === \'nosplit\'\"></md-icon><md-icon md-font-icon=\"icon-view-quilt\" \nng-if=\"vm.currentView === \'split\'\"></md-icon><md-icon md-font-icon=\"icon-table-edit\" \nng-if=\"vm.currentView === \'spreadsheet\'\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.SPLIT_VIEW\">\n</span></md-tooltip></md-button><md-menu-content width=\"4\"><md-menu-item><md-button \nng-click=\"vm.changeView(\'nosplit\')\"><div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-view-list\" class=\"mr-8\"></md-icon><span \ntranslate=\"CONTENT.NOSPLIT_VIEW\"></span></div><md-icon ng-if=\"vm.currentView === \'nosplit\'\" md-font-icon=\"icon-check\" \nclass=\"md-accent\"></md-icon></div></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.changeView(\'split\')\"><div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-view-quilt\" class=\"mr-8\"></md-icon><span \ntranslate=\"CONTENT.SPLIT_VIEW\"></span></div><md-icon ng-if=\"vm.currentView === \'split\'\" md-font-icon=\"icon-check\" \nclass=\"md-accent\"></md-icon></div></md-button></md-menu-item><md-menu-item ng-if=\"vm.contentGridEnabled\"><md-button \nng-click=\"vm.changeView(\'spreadsheet\')\"><div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-table-edit\" class=\"mr-8\"></md-icon><span \ntranslate=\"CONTENT.SPREADSHEET_VIEW\"></span></div><md-icon ng-if=\"vm.currentView === \'spreadsheet\'\" \nmd-font-icon=\"icon-check\" class=\"md-accent\"></md-icon></div></md-button></md-menu-item></md-menu-content></md-menu>\n<md-menu-bar class=\"pr-0 pl-0\" hide-gt-xs><md-menu class=\"settings-menu\"><md-button aria-label=\"Settings\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" translate=\"\" translate-attr-aria-label=\"CONTENT.SETTINGS\">\n<md-icon md-font-icon=\"icon-cog\"></md-icon></md-button><md-menu-content><md-menu-item><md-menu><md-button \naria-label=\"Filters\" ng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-sort\"></md-icon><span \ntranslate=\"CONTENT.ORDER_BY\">Order by</span></md-button><md-menu-content><md-menu-item \nng-repeat=\"sortfield in refSortables\"><md-button aria-label=\"All\" \nng-click=\"pagination_setSortField(sortfield.titleId)\"><div layout=\"row\" layout-align=\"space-between center\"><span>\n{{sortfield.name}}</span> <i class=\"icon-check s16\" ng-if=\"sortfield.titleId == sortField\"></i></div></md-button>\n</md-menu-item><md-menu-item ng-repeat=\"field in vm.refcolumns\" ng-if=\"field.sortable === 1\"><md-button \nng-click=\"vm.setSortField(field.title)\"><div layout=\"row\" layout-align=\"space-between center\"><span>\n{{field.field_name}}</span> <i class=\"icon-check s16\" ng-if=\"vm.fieldOrder === field.field_name\"></i></div></md-button>\n</md-menu-item></md-menu-content></md-menu></md-menu-item><md-menu-item><md-button \nng-click=\"pagination_setSortField(null,\'ASC\')\" ng-disabled=\"!sortField\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-sort-ascending\"></md-icon><span translate=\"CONTENT.DIRECTION_A_Z\">Order A-Z</span></div><i \nclass=\"icon-check s16\" ng-if=\"sortDir === \'ASC\'\"></i></div></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"pagination_setSortField(null,\'DESC\')\" ng-disabled=\"!sortField\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-sort-descending\"></md-icon><span translate=\"CONTENT.DIRECTION_Z_A\">Order Z-A</span></div><i \nclass=\"icon-check s16\" ng-if=\"sortDir === \'DESC\'\"></i></div></md-button></md-menu-item><md-menu-item \nshow=\"vm.selectedMail.length > 0 || vm.allChecked\"><md-button ng-click=\"vm.massActions(\'duplicate\')\" \naria-label=\"Duplicate\" translate-attr-aria-label=\"CONTENT.DUPLICATE\" ng-disabled=\"vm.selectedThreads.length == 0\">\n<md-icon md-font-icon=\"icon-content-duplicate\"></md-icon><span translate=\"CONTENT.DUPLICATE\"></span></md-button>\n</md-menu-item><md-menu-item ng-if=\"vm.aiTranslateEnabled\"><md-button ng-click=\"vm.openAiTranslate()\" \naria-label=\"Translate\" class=\"md-icon-button\" hide=\"\" show-gt-xs=\"\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.TRANSLATE\"><md-icon md-font-icon=\"icon-content-duplicate-translate\"></md-icon><span \ntranslate=\"CONTENT.TRANSLATE\"></span></md-button></md-menu-item><md-menu-item \nshow=\"vm.selectedMail.length > 0 || vm.allChecked\"><md-button ng-click=\"vm.massActions(\'delete\')\" aria-label=\"Delete\" \ntranslate-aria-label=\"CONTENT.DELETE\" ng-disabled=\"vm.selectedThreads.length == 0\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon><span translate=\"CONTENT.DELETE\"></span></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar>\n</div>");
$templateCache.put("app/main/apps/content/views/grid/grid-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/content/views/list/toolbar.html\'\"></div><div class=\"content-wrapper\" flex=\"\" layout=\"row\">\n<div class=\"mail-tabs-grid\" flex=\"\" md-dynamic-height=\"20\"><div class=\"content mail-list-pane-grid\" flex=\"\" \nms-scroll=\"\"><md-progress-circular md-mode=\"indeterminate\" ng-if=\"isLoading\"></md-progress-circular><div \nclass=\"no-threads\" ng-hide=\"isLoading\" ng-if=\"!isLoading && vm.inbox.length === 0\">There are no items!</div><ms-card \nng-model=\"mail\" ng-repeat=\"thread in vm.threads | filter: vm.search | filter: global.search\" \ntemplate=\"\'app/main/apps/content/views/grid/template-grid-1.html\'\"></ms-card></div></div></div>");
$templateCache.put("app/main/apps/content/views/grid/social-stream-grid-item.html","<div class=\"ms-card-content-wrapper\"><div class=\"template-9 height-percent-100\" layout=\"column\" \nlayout-align=\"space-between stretch\" ng-click=\"vm.openThread(item,item.id, $index)\"><div class=\"media\" flex \nlayout=\"row\" layout-align=\"center center\"><img class=\"image image hide show spinner-show\" \nng-src=\"{{item.media ? item.media  : \'assets/images/common/no_image_available_10.png\'}}\" imageonload=\"\"><div \nng-if=\"item.video\" class=\"fotorama__video-play\" style=\"opacity:1\"></div></div><div class=\"content-card p-16\" flex \nlayout=\"column\" layout-align=\"space-between stretch\"><div layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><img class=\"avatar\" ng-src=\"{{item.user_image}}\"><div layout=\"column\" \nlayout-align=\"center start\"><strong class=\"text-truncate\">{{item.user_name}}</strong> <span>\n{{item.created_at.value ? item.created_at.value : item.created_at}}</span></div></div><div \nng-switch=\"vm.getReferencesSections(\'subsection\', \'id_subsec\', item.id_subsec)\"><span ng-switch-when=\"Instagram\"><i \nclass=\"fa fa-instagram\" style=\"font-size: 25px\"></i> </span><span ng-switch-when=\"Facebook\"><i class=\"fa fa-facebook\" \nstyle=\"font-size: 25px\"></i> </span><span ng-switch-when=\"Twitter|X\" ng-switch-when-separator=\"|\"><svg \nviewBox=\"0 0 24 24\" fill=\"currentColor\" style=\"width: .8em; height: .8em; font-size: 25px; vertical-align: middle\" \nrole=\"img\" aria-label=\"X\"><path \nd=\"M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z\"/>\n</svg> </span><span ng-switch-when=\"YouTube|Youtube\" ng-switch-when-separator=\"|\"><i class=\"fa fa-youtube-play\" \nstyle=\"font-size: 25px\"></i> </span><span ng-switch-when=\"TikTok|Tiktok\" ng-switch-when-separator=\"|\"><svg \nviewBox=\"0 0 24 24\" fill=\"currentColor\" style=\"width: .8em; height: .8em; font-size: 25px; vertical-align: middle\" \nrole=\"img\" aria-label=\"TikTok\"><path \nd=\"M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z\"/>\n</svg></span></div></div><div layout=\"column\" layout-align=\" center start \" class=\"mt-5\" flex><p>{{item.message}}</p>\n</div><div layout=\"row\" layout-align=\"space-between center\"><strong class=\"mr-5\">#{{item.id}}</strong><div><button \nng-if=\"item.onoff===1\" class=\"md-icon-button\" ng-click=\"vm.toggleItemStatus(item, $event, $index)\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\"></md-icon></button> <button ng-if=\"item.onoff!==1\" \nclass=\"md-icon-button\" ng-click=\"vm.toggleItemStatus(item, $event, $index)\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\"></md-icon></button></div></div></div></div>\n</div>");
$templateCache.put("app/main/apps/content/views/grid/social-stream-grid.html","<div flex layout=\"column\" layout-align=\"center center\" ng-show=\"isLoading\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div class=\"no-threads\" \nng-if=\"!isLoading && vm.threads.length === 0\" ng-hide=\"isLoading\" translate=\"CONTENT.NO_ITEMS\"></div><div \nid=\"list-content-data\" ng-style=\"{\'opacity\' : isLoading ? 0.2 : 1}\" ms-scroll=\"vm.msScrollOptions\" \nng-class=\"{\'group-filter\': vm.selectedGallery,\'other-filter\':$root.pagination_searchquery==true}\" class=\"scrollable\" \nng-if=\"vm.threads.length > 0\"><div class=\"media mail-list-pane-grid\" flex layout-padding \nng-if=\"vm.currentListView == \'grid\'\"><div class=\"grid-view\" md-cols=\"{{vm.cols}}\" md-row-height=\"250\" md-gutter=\"12px\" \nmd-gutter-gt-sm=\"8px\" ng-sortable=\"vm.mediaSortable\" ng-if=\"vm.selectedGallery\"><div \nng-repeat=\"item in vm.threads track by $index\" \nclass=\"grid-element sortable {{vm.getReferencesSections(\'subsection\', \'id_subsec\', item.id_subsec)}}\" \ndata-id=\"{{item.id}}\"><div class=\"ms-card\" flex \nng-include=\"\'app/main/apps/content/views/grid/social-stream-grid-item.html\'\"></div></div></div><div class=\"grid-view\" \nmd-cols=\"{{vm.cols}}\" md-row-height=\"250\" md-gutter=\"12px\" md-gutter-gt-sm=\"8px\" ng-if=\"!vm.selectedGallery\"><div \nng-repeat=\"item in vm.threads track by $index\" \nclass=\"grid-element sortable {{vm.getReferencesSections(\'subsection\', \'id_subsec\', item.id_subsec)}}\" \ndata-id=\"{{item.id}}\"><div class=\"ms-card\" flex \nng-include=\"\'app/main/apps/content/views/grid/social-stream-grid-item.html\'\"></div></div></div></div><div \nng-sortable=\"vm.mediaSortable\" ng-if=\"vm.selectedGallery && vm.currentListView == \'list\'\"><div \nclass=\"mail-list-item sortable\" ng-repeat=\"mediaItem in vm.items\" ng-click=\"vm.selectMediaFile(mediaItem)\" \nng-class=\"{\'starred\': thread.starred, \'selected\': vm.ImageIDSelected === mediaItem.id_media, \'checked\': vm.isChecked(thread)}\" \ndata-id=\"{{mediaItem.id_media}}\"><div ng-include=\"vm.subviews[\'list\']\"></div></div></div><div \nng-if=\"!vm.selectedGallery && vm.currentListView == \'list\'\"><div class=\"mail-list-item\" \nng-repeat=\"mediaItem in vm.items\" ng-click=\"vm.selectMediaFile(mediaItem)\" \nng-class=\"{\'starred\': thread.starred, \'selected\': vm.ImageIDSelected === mediaItem.id_media, \'checked\': vm.isChecked(thread)}\" \ndata-id=\"{{mediaItem.id_media}}\"><div ng-include=\"vm.subviews[\'list\']\"></div></div></div><md-divider></md-divider><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"end center\"><div layout=\"row\" layout-align=\"center center\" \nng-style=\"{\'display\' : isLoading ? \'none\' : \'block\'}\"><span class=\"page-info\">\n{{pagination_totalItems | number}} items found.</span><md-button aria-label=\"Previous\" class=\"md-icon-button arrow\" \nng-click=\"pagination_prevPage()\" ng-disabled=\"pagination_firstPage()\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button><span \nclass=\"page-info\">{{pagination_current_page | number}} / {{pagination_total_pages | number}}</span><md-button \naria-label=\"Next\" class=\"md-icon-button arrow\" ng-click=\"pagination_nextPage()\" ng-disabled=\"pagination_morePages()\" \ntranslate=\"\" translate-attr-aria-label=\"CONTENT.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button>\n</div></div></div>");
$templateCache.put("app/main/apps/content/views/grid/template-grid-1.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"space-between center\" flex><div \nlayout=\"column\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-attachment\" class=\"has-attachment s24\" \nng-if=\"thread.Thumbnail.length>0\"></md-icon><button ng-if=\"thread.onoff===1\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\"></md-icon></button> <button \nng-if=\"thread.onoff!==1\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-blank-circle-outline\" \nclass=\"off red-fg s24\"></md-icon></button></div><div layout=\"column\" layout-align=\"start center\"><md-checkbox \nclass=\"no-label\" ng-checked=\"vm.isChecked(mail)\" ng-click=\"vm.toggleCheck(mail, $event)\" \naria-label=\"{{vm.isChecked(mail)? \'Uncheck\':\'check\'}}\"></md-checkbox><div ng-if=\"refcolumnsgrouped.main\"><div \nclass=\"subject text-truncate\"><span ng-repeat=\"field in refcolumnsgrouped.header | orderBy: \'list-sort\'\" \nng-bind=\"thread.{{field.titleId}}\"></span></div></div></div></div><div class=\"media\" flex layout=\"row\" \nlayout-align=\"center center\">{{refcolumnsgrouped | json}}<div \nng-repeat=\"field in refcolumnsgrouped.left_center | orderBy:\'list_sort\'\" \nng-if=\"field.type == \'thumbnail_square\' || field.type == \'thumbnail_\'\"><img class=\"avatar square ng-scope\" \nalt=\"{{listImage.filename}}\" ng-if=\"thread.Thumbnail.length>0\" \nng-src=\"{{listImage.cropstatus[0].container.view_url}}{{listImage.cropstatus[0].fileName}}\" \nng-repeat=\"listImage in thread.Thumbnail | filter: {\'id_zone\':field.showtype} | limitTo:1\"> <img \nclass=\"avatar square ng-scope\" alt=\"No Image\" ng-if=\"(thread.Thumbnail|filter:{\'id_zone\':field.showtype}).length == 0\" \nng-src=\"assets/images/common/no_image_available_10.png\"></div><img class=\"image\" \nng-src=\"{{card.Thumbnail[0].crop_status[0].urlformed}}\" alt=\"{{card.media.image.alt}}\" imageonloadcontrol></div><div \nclass=\"header p-16\" layout=\"row\" layout-align=\"start\"><div class=\"info\" flex layout=\"column\"><div \nng-if=\"refcolumnsgrouped.main\"><div class=\"name text-truncate\" layout=\"row\" layout-align=\"start center\"><span \nng-repeat=\"field in refcolumnsgrouped.main\"><span ng-bind=\"thread.{{field.titleId}}\"></span>&nbsp;</span></div></div>\n<div><div class=\"name text-truncate\" layout=\"row\" layout-align=\"start center\"><span><span>Title</span></span></div>\n</div><div><div class=\"details\" layout=\"row\" layout-align=\"start start\"><div layout=\"column\"><span class=\"title\">label\n</span></div><div layout=\"column\" class=\"text-truncate\"><span class=\"detail\">name</span></div></div></div><div \nng-repeat=\"field in refcolumnsgrouped.secondary | orderBy:\'list_sort\'\"><div \nng-if=\"(field.type!==\'date\' && field.type!==\'dateHm\') && field.primary!==1\" class=\"details\" layout=\"row\" \nlayout-align=\"start start\"><div layout=\"column\"><span class=\"title\" ng-bind=\"field.title\"></span></div><div \nlayout=\"column\" class=\"text-truncate\"><span class=\"detail\" ng-bind=\"thread.{{field.titleId}}\"></span></div></div></div>\n</div></div></div>");
$templateCache.put("app/main/apps/content/views/grid/template-grid.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s20\" ng-if=\"card.onoff===1\"></md-icon><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s20\" ng-if=\"card.onoff===0\"></md-icon><div \nclass=\"info\"><div class=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.Thumbnail[0].crop_status[0].urlformed}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.Thumbnail[0].crop_status[0]\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/main/apps/content/views/outlook/outlook-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-checkbox aria-label=\"{{vm.allChecked?\'Uncheck All\':\'Check All\'}}\" class=\"no-label\" hide=\"\" \nng-checked=\"vm.allChecked\" ng-click=\"vm.checkAll()\" show-gt-xs=\"\"></md-checkbox><md-menu hide=\"\" show-gt-xs=\"\"><button \naria-label=\"Filters\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.FILTERS\"><md-icon md-font-icon=\"icon-chevron-down\"></md-icon></button>\n<md-menu-content width=\"3\"><md-menu-item><md-button aria-label=\"All\" translate=\"CONTENT.ALL\" \ntranslate-attr-aria-label=\"CONTENT.ALL\">All</md-button></md-menu-item><md-menu-item><md-button aria-label=\"Page\" \nng-click=\"vm.checkAll()\" translate=\"CONTENT.INPAGE\" translate-attr-aria-label=\"CONTENT.INPAGE\">In this page</md-button>\n</md-menu-item></md-menu-content></md-menu><div class=\"divider-vertical\" hide=\"\" show-gt-xs=\"\"></div><div \naria-hidden=\"false\" class=\"action-buttons hide show-gt-xs layout-align-start-center layout-row\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"vm.selectedMail.length > 0 || vm.allChecked\"><md-button aria-label=\"Duplicate\" \nclass=\"md-icon-button\" hide=\"\" show-gt-sm=\"\" translate=\"\" translate-attr-aria-label=\"CONTENT.DUPLICATE\"><md-icon \nmd-font-icon=\"icon-content-duplicate\"></md-icon><md-tooltip><span translate=\"CONTENT.DUPLICATE\">Duplicate</span>\n</md-tooltip></md-button><md-button aria-label=\"Export\" class=\"md-icon-button\" hide=\"\" show-gt-sm=\"\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.EXPORT\"><md-icon md-font-icon=\"icon-export\"></md-icon><md-tooltip><span \ntranslate=\"CONTENT.EXPORT\">Export</span></md-tooltip></md-button><md-button aria-label=\"Delete\" class=\"md-icon-button\" \nhide=\"\" show-gt-sm=\"\" translate=\"\" translate-attr-aria-label=\"CONTENT.DELETE\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon><md-tooltip><span translate=\"CONTENT.DELETE\">Delete</span></md-tooltip></md-button><div \nclass=\"divider-vertical\" hide=\"\" show-gt-xs=\"\"></div></div><ms-search-bar class=\"ms-search-bar ng-isolate-scope\" \ndebounce=\"300\" on-result-click=\"vm.searchResultClick(item)\" on-search=\"vm.search(query)\"><div \nclass=\"layout-align-start-center layout-row flex\" flex=\"\" layout=\"row\" layout-align=\"start center\"><label \nfor=\"ms-search-bar-input\"><button aria-label=\"Expand Search Bar\" \nclass=\"ms-search-bar-expander md-icon-button md-button ng-scope md-ink-ripple md-default-theme\" \nng-click=\"MsSearchBar.expand()\" ng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\" ng-transclude=\"\" \ntype=\"button\"><md-icon class=\"icon s24 ng-scope md-font icon-magnify\" md-font-icon=\"icon-magnify\"></md-icon><div \nclass=\"md-ripple-container\"></div></button></label><input aria-invalid=\"false\" \nclass=\"ng-pristine ng-valid flex ng-empty ng-touched\" flex=\"\" id=\"ms-search-bar-input\" md-autofocus=\"\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\" ng-model=\"MsSearchBar.query\" \nng-model-options=\"MsSearchBar.queryOptions\" placeholder=\"Search\" type=\"text\"> <button aria-label=\"Collapse Search Bar\" \nclass=\"ms-search-bar-collapser md-icon-button md-button md-ink-ripple md-default-theme\" \nng-click=\"MsSearchBar.collapse()\" ng-transclude=\"\" type=\"button\"><md-icon aria-hidden=\"true\" \nclass=\"icon s24 ng-scope md-font icon-close material-icons md-default-theme\" md-font-icon=\"icon-close\"></md-icon><div \nclass=\"md-ripple-container\"></div></button></div></ms-search-bar><md-button aria-label=\"view type\" \nclass=\"md-icon-button\" hide=\"\" ng-click=\"vm.toggleSidenav(\'main-sidenav\')\" show-gt-xs=\"\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.ADVANCED\"><md-icon md-font-icon=\"icon-magnify-plus\"></md-icon><md-tooltip><span \ntranslate=\"CONTENT.ADVANCED\">Advanced</span></md-tooltip></md-button><div class=\"divider-vertical\" hide=\"\" \nshow-gt-xs=\"\"></div><md-button aria-label=\"ADD NEW\" \nclass=\"md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme hide-xs\" \nng-click=\"vm.openTaskDialog($event)\" ng-transclude=\"\" translate=\"CONTENT.ADD\" type=\"button\">Add new</md-button>\n<md-button aria-label=\"ADD NEW\" \nclass=\"md-fab md-mini md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme hide-gt-xs\" \nng-click=\"vm.openTaskDialog($event)\" ng-transclude=\"\" type=\"button\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n</md-button></div><div layout=\"row\" layout-align=\"start center\" translate-attr-aria-label=\"CONTENT.REFRESH\"><md-button \naria-label=\"view type\" class=\"md-icon-button\" hide=\"\" ng-click=\"vm.toggleView(\'grid\')\" show-gt-xs=\"\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.GRID_VIEW\"><md-icon md-font-icon=\"icon-view-module\"></md-icon><md-tooltip><span \ntranslate=\"CONTENT.GRID_VIEW\">Grid View</span></md-tooltip></md-button><md-button aria-label=\"view type\" \nclass=\"md-icon-button\" hide=\"\" ng-click=\"vm.toggleView(\'list\')\" show-gt-xs=\"\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.LIST_VIEW\"><md-icon md-font-icon=\"icon-view-headline\"></md-icon><md-tooltip><span \ntranslate=\"CONTENT.LIST_VIEW\">List View</span></md-tooltip></md-button><div class=\"divider-vertical\" hide=\"\" \nshow-gt-xs=\"\"></div><md-button aria-label=\"Sort Direction\" class=\"md-icon-button\" \nng-click=\"sortable.order == \'DESC\' ? sortable.order =\'ASC\' : sortable.order = \'DESC\'\" ng-disabled=\"!sortable\" \ntranslate=\"\" translate-attr-aria-label=\"TODO.SORT_DIRECTION\"><md-icon md-font-icon=\"icon-sort-ascending\" \nng-if=\"sortable.order !== \'ASC\'\"></md-icon><md-icon md-font-icon=\"icon-sort-descending\" \nng-if=\"sortable.order === \'ASC\'\"></md-icon></md-button><md-menu hide=\"\" show-gt-xs=\"\"><button aria-label=\"Filters\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" show-gt-xs=\"\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.FILTERS\"><md-icon md-font-icon=\"icon-chevron-down\"></md-icon></button>\n<md-menu-content width=\"3\"><md-menu-item ng-repeat=\"sortfield in refSortables\"><md-button aria-label=\"All\" \nng-click=\"pagination_setOrderBy(sortfield)\"><div layout=\"row\" layout-align=\"space-between center\"><span>\nOrder by {{sortfield.name}} </span><i class=\"icon-check s16\" ng-if=\"sortfield.titleId == sortable.titleId\"></i></div>\n</md-button></md-menu-item></md-menu-content></md-menu><md-menu hide-gt-xs=\"\" \nng-show=\"vm.selectedMail.length > 0 || vm.allChecked\"><md-button aria-label=\"Mail Actions\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\" translate=\"\" translate-attr-aria-label=\"CONTENT.ACTIONS\"><md-icon \nmd-font-icon=\"icon-cog\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \naria-label=\"Duplicate\" translate-attr-aria-label=\"CONTENT.DUPLICATE\"><md-icon md-font-icon=\"icon-folder-move\">\n</md-icon><span translate=\"CONTENT.DUPLICATE\">Duplicate</span></md-button></md-menu-item><md-menu-item><md-button \naria-label=\"Export\" translate-attr-aria-label=\"CONTENT.EXPORT\"><md-icon md-font-icon=\"icon-folder-move\"></md-icon><span\n translate=\"CONTENT.EXPORT\">Export</span></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Delete\" \ntranslate-aria-label=\"CONTENT.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span translate=\"CONTENT.DELETE\">\nDelete</span></md-button></md-menu-item></md-menu-content></md-menu><div class=\"divider-vertical\" hide=\"\" \nshow-gt-xs=\"\"></div><span class=\"page-info\" hide=\"\" show-gt-xs=\"\">\n{{pagination_from}} – {{pagination_to}} of {{pagination_totalItems}}</span><md-button aria-label=\"Previous\" \nclass=\"md-icon-button arrow\" hide=\"\" ng-click=\"pagination_prevPage()\" ng-disabled=\"pagination_firstPage()\" \nshow-gt-xs=\"\" translate=\"\" translate-attr-aria-label=\"CONTENT.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon><md-tooltip><span translate=\"CONTENT.PREVIOUS\">Previous</span></md-tooltip></md-button><md-button \naria-label=\"Next\" class=\"md-icon-button arrow\" hide=\"\" ng-click=\"pagination_nextPage()\" \nng-disabled=\"pagination_morePages()\" show-gt-xs=\"\" translate=\"\" translate-attr-aria-label=\"CONTENT.NEXT\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span translate=\"CONTENT.NEXT\">Next</span></md-tooltip>\n</md-button></div></div><div class=\"content-wrapper\" flex=\"\" layout=\"row\"><div class=\"content thread-list\" flex=\"50\" \nms-scroll=\"\" ng-include=\"\'app/main/apps/content/views/outlook/list/list.html\'\"></div><div \nclass=\"content thread-detail\" flex=\"50\" layout=\"column\" ms-scroll=\"\" \nng-include=\"\'app/main/apps/content/views/outlook/detail/detail.html\'\"></div></div>");
$templateCache.put("app/main/apps/content/views/read/edit-preview-splitted.html","<div id=\"content-edit\" class=\"nosplited page-layout simple fullwidth mail-content content-edit\" layout=\"row\"><md-tabs \nflex=\"50\" ms-scroll=\"vm.msScrollOptions\" class=\"scrollable\"><md-tab><md-tab-label>{{ vm.translate(\'CONTENT.EDIT_TAB\')}}\n</md-tab-label><md-tab-body><div ng-include=\"\'app/main/apps/content/views/read/tab-edit.html\'\"></div></md-tab-body>\n</md-tab></md-tabs><md-tabs flex=\"50\" ms-scroll=\"vm.msScrollOptions\" class=\"scrollable\"><md-tab \nng-if=\"vm.ActiveSection.media\"><md-tab-label>{{ vm.translate(\'CONTENT.MEDIA\')}}</md-tab-label><md-tab-body><div \nng-include=\"\'app/main/apps/content/views/read/tab-media.html\'\"></div></md-tab-body></md-tab><md-tab \nng-if=\"vm.ActiveSection.seo\"><md-tab-label>{{ vm.translate(\'CONTENT.SEO\')}}</md-tab-label><md-tab-body><div \nng-include=\"\'app/main/apps/content/views/read/tab-seo.html\'\"></div></md-tab-body></md-tab><md-tab \nng-if=\"vm.ActiveSection.activity\"><md-tab-label>{{ vm.translate(\'CONTENT.LATESTACTIVITY\')}}</md-tab-label><md-tab-body>\n<div ng-include=\"\'app/main/apps/content/views/read/tab-activity.html\'\"></div></md-tab-body></md-tab></md-tabs></div>");
$templateCache.put("app/main/apps/content/views/read/edit-preview.html","<div id=\"content-edit\" class=\"page-layout simple fullwidth mail-content content-edit\" layout=\"column\"><md-tabs \nms-scroll=\"vm.msScrollOptions\" class=\"scrollable\"><md-tab><md-tab-label>{{ vm.translate(\'CONTENT.EDIT_TAB\')}}\n</md-tab-label><md-tab-body><div ng-include=\"\'app/main/apps/content/views/read/tab-edit.html\'\"></div></md-tab-body>\n</md-tab><md-tab ng-if=\"vm.ActiveSection.media\"><md-tab-label>{{ vm.translate(\'CONTENT.MEDIA\')}}</md-tab-label>\n<md-tab-body><div ng-include=\"\'app/main/apps/content/views/read/tab-media.html\'\"></div></md-tab-body></md-tab><md-tab \nng-if=\"vm.ActiveSection.seo\"><md-tab-label>{{ vm.translate(\'CONTENT.SEO\')}}</md-tab-label><md-tab-body><div \nng-include=\"\'app/main/apps/content/views/read/tab-seo.html\'\"></div></md-tab-body></md-tab><md-tab \nng-if=\"vm.ActiveSection.activity\"><md-tab-label>{{ vm.translate(\'CONTENT.LATESTACTIVITY\')}}</md-tab-label><md-tab-body>\n<div ng-include=\"\'app/main/apps/content/views/read/tab-activity.html\'\"></div></md-tab-body></md-tab><md-tab \nng-repeat=\"tab in vm.selectedContent_ref_tabs\"><md-tab-label>{{tab.raw_settings.tabName | translate}}</md-tab-label>\n<md-tab-body><span ng-if=\"tab.raw_settings.ref.length\" layout=\"row\" layout-align=\"end\" class=\"expand-nav\"><div \nng-if=\"!vm.expanded\"><md-button ng-click=\"vm.expanded=true\"><md-icon md-font-icon=\"icon-view-column\"></md-icon>\n</md-button></div><div ng-if=\"vm.expanded\"><md-button ng-click=\"vm.expanded=false\"><md-icon \nmd-font-icon=\"icon-view-list\"></md-icon></md-button></div></span><div ng-if=\"!vm.expanded\" \nng-include=\"\'app/main/apps/content/views/read/tab-grouped.html\'\"></div><div ng-if=\"vm.expanded\" \nng-include=\"\'app/main/apps/content/views/read/tab-expand.html\'\"></div></md-tab-body></md-tab></md-tabs></div>");
$templateCache.put("app/main/apps/content/views/read/item-context-menu.html","<md-menu md-offset=\"0 -5\" id=\"context-menu\"><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"ctrl.openMenu($mdMenu.open, $event)\"><md-icon md-menu-origin md-svg-icon=\"call:ring-volume\"></md-icon>\n</md-button><md-menu-content width=\"4\"><md-menu-item ng-repeat=\"item in [1, 2, 3]\"><md-button \nng-click=\"ctrl.announceClick($index)\"><span md-menu-align-target>Option</span> {{item}}</md-button></md-menu-item>\n</md-menu-content></md-menu>");
$templateCache.put("app/main/apps/content/views/read/read-view-nosplit.html","<div flex layout=\"column\" layout-align=\"center center\" ng-show=\"vm.loadingReadPane\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nng-show=\"!vm.loadingReadPane\"><div class=\"mail-content\" layout=\"column\" layout-align=\"center center\" \nng-if=\"!vm.selectedContent\"><div class=\"content\" layout=\"column\" layout-align=\"top center\"><div class=\"message\" \ntranslate=\"CONTENT.NO_ITEM_SELECTED_PANEL\"></div></div></div><div class=\"toolbar grey-100-bg colored-bg\" layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"vm.selectedContent\" scroll=\"\"><div layout=\"row\" layout-align=\"start center\">\n<md-button class=\"md-icon-button close-thread\" aria-label=\"Back\" ng-click=\"vm.closeThread()\" \nng-if=\"vm.currentThread && vm.currentView==\'nosplit\'\" translate translate-attr-aria-label=\"CONTENT.BACK\"><md-icon \nmd-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><div class=\"divider-vertical\" hide=\"\" \nng-if=\"vm.activeMailPaneIndex === 1\" show-gt-sm=\"\"></div><md-button aria-label=\"Info\" class=\"md-icon-button\" \nng-click=\"vm.viewPreview()\" ng-class=\"{\'md-accent\':vm.selectedContent && !vm.editInline}\" \nng-if=\"vm.selectedContent.id\" translate=\"\" translate-attr-aria-label=\"CONTENT.INFORMATION\"><md-icon \nmd-font-icon=\"icon-information-outline\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.INFORMATION\">\n</span></md-tooltip></md-button><div class=\"divider-vertical\" hide=\"\" show-gt-sm=\"\" ng-if=\"vm.selectedContent.id\">\n</div><md-button aria-label=\"Edit\" class=\"md-icon-button\" ng-click=\"vm.viewEditInline()\" \nng-class=\"{\'md-accent\':vm.editInline && vm.selectedContent}\" translate=\"\" translate-attr-aria-label=\"CONTENT.EDIT\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.EDIT\"></span>\n</md-tooltip></md-button><div class=\"divider-vertical\" hide=\"\" show-gt-sm=\"\" \nng-if=\"vm.selectedContent.urlpreview && vm.selectedContent.urlpreview.length > 10\"></div><md-button \naria-label=\"Preview\" class=\"md-icon-button\" \nng-if=\"vm.selectedContent.urlpreview && vm.selectedContent.urlpreview.length > 10\" \nng-click=\"vm.openUrl(vm.selectedContent.urlpreview)\" translate=\"\" translate-attr-aria-label=\"CONTENT.PREVIEW\"><md-icon \nmd-font-icon=\"icon-eye\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.PREVIEW\"></span></md-tooltip>\n</md-button><div class=\"divider-vertical\" hide=\"\" show-gt-sm=\"\" ng-if=\"vm.ActiveSection.web_preview\"></div><md-button \naria-label=\"Spam\" class=\"md-icon-button\" ng-click=\"\" translate=\"\" translate-attr-aria-label=\"CONTENT.LIVE\" \nng-if=\"vm.ActiveSection.web_preview\"><md-icon md-font-icon=\"icon-web\"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate=\"CONTENT.LIVE\"></span></md-tooltip></md-button></div><div layout=\"row\" layout-align=\"end center\" \nng-if=\"vm.currentThread_Edit\" hide show-gt-sm><md-button type=\"submit\" ng-click=\"vm.saveItem(vm.currentThread_Edit)\" \nclass=\"send-button md-accent md-raised\"><span aria-label=\"SAVE\" translate=\"CONTENT.SAVE\" \ntranslate-attr-aria-label=\"CONTENT.SAVE\" ng-hide=\"vm.savingProcess\">SAVE</span> <span ng-show=\"vm.savingProcess\" \ntranslate=\"CONTENT.SAVING\"></span></md-button><md-button type=\"button\" ng-click=\"vm.closeThreadEdit()\" \nclass=\"md-raised md-warn\" aria-label=\"Cancel\" translate=\"CONTENT.CANCEL\"></md-button></div><div layout=\"row\" \nlayout-align=\"end center\" ng-if=\"vm.currentThread_Edit\" hide-gt-sm><md-button type=\"submit\" \nng-click=\"vm.saveItem(vm.currentThread_Edit)\" class=\"send-button md-accent md-raised md-fab md-mini\" \nng-disabled=\"vm.basicForm.$invalid || vm.basicForm.$pristine\"><md-icon md-font-icon=\"icon-check\" \nng-hide=\"vm.savingProcess\"></md-icon><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"28\" \nng-if=\"vm.savingProcess\"></md-progress-circular><md-tooltip hide show-gt-xs><span translate=\"CONTENT.SAVE\">Save</span>\n</md-tooltip></md-button><md-button type=\"button\" ng-click=\"vm.closeThreadEdit()\" \nclass=\"md-raised md-warn md-fab md-mini\" aria-label=\"Cancel\"><md-icon md-font-icon=\"icon-window-close\"></md-icon>\n<md-tooltip hide show-gt-xs><span translate=\"CONTENT.CANCEL\">Cancel</span></md-tooltip></md-button></div></div>\n<md-content flex=\"\" ng-if=\"vm.selectedContent && !vm.editInline\"><div class=\"mail-content file-details scrollable\" \nms-scroll=\"vm.msScrollOptions\"><md-list><md-list-item class=\"info\" layout=\"row\" layout-align=\"start center\"><div \nlayout=\"row\" layout-align=\"start start\"><div \nng-repeat=\"field in vm.selectedContent_refgrouped.header | orderBy:\'preview_sort\' \" class=\"header-element\" \nlayout=\"row\" layout-align=\"center center\"><div><span ng-if=\"field.type==\'id\'\"><span class=\"grey-500-fg\">ID # </span>\n<span ng-bind=\"vm.selectedContent[field.titleId]\"></span> </span><span ng-if=\"field.type==\'onoff\'\"><button \nclass=\"md-icon-button\" ng-if=\"vm.selectedContent[field.titleId] === 1\"><md-icon class=\"on green-fg s24\" \nmd-font-icon=\"icon-checkbox-marked-circle\"></md-icon></button> <button class=\"md-icon-button\" \nng-if=\"vm.selectedContent[field.titleId] !== 1\"><md-icon class=\"off red-fg s24\" \nmd-font-icon=\"icon-checkbox-blank-circle-outline\"></md-icon></button> </span><span \nng-if=\"field.type==\'dateHm\' || field.type==\'date\'\"><span>{{vm.selectedContent[field.titleId].dateShow}}</span> </span>\n<span ng-if=\"field.type==\'language\'\" layout=\"row\" layout-align=\"center center\"><img class=\"img-flag ng-scope\" \nalt=\"{{vm.siteLanguages(vm.selectedContent[field.titleId])[lang_name]}}\" \nng-src=\"assets/images/flags/{{vm.siteLanguages()[vm.selectedContent[field.titleId]].flag_code|lowercase}}.svg\"> </span>\n<span ng-if=\"field.type==\'id_subsec\' && vm.selectedContent[field.titleId].length!=0\"><span class=\"grey-500-fg\">\n{{field.field_name}} </span><span \nng-bind=\"vm.getReferencesSections(\'subsection\', field.type, vm.selectedContent[field.titleId])\"></span> </span><span \nng-if=\"field.type==\'id_cat\' && vm.selectedContent[field.titleId].length!=0\"><span class=\"grey-500-fg\">\n{{field.field_name}} </span><span \nng-bind=\"vm.getReferencesSections(\'cat\', field.type, vm.selectedContent[field.titleId])\"></span> </span><span \nng-if=\"field.type==\'id_subcat\' && vm.selectedContent[field.titleId].length!=0\"><span class=\"grey-500-fg\">\n{{field.field_name}} </span><span \nng-bind=\"vm.getReferencesSections(\'subcat\', field.type, vm.selectedContent[field.titleId])\"></span> </span><span \nng-if=\"field.type == \'nume\' || field.type == \'single\'\"><span class=\"grey-500-fg\">\n{{field.field_name}}: {{vm.selectedContent[field.titleId]}}</span></span></div></div></div></md-list-item><md-list-item\n ng-repeat=\"field in vm.selectedContent_refgrouped.main | orderBy:\'preview_sort\' \"><div><h1 class=\"name\"><strong \nng-bind=\"vm.selectedContent[field.titleId]\" ng-if=\"field.type != \'section\'\"></strong> <strong \nng-bind=\"vm.showAssoc(vm.selectedContent[field.titleId], field)\" ng-if=\"field.type == \'section\'\"></strong></h1>\n<md-divider></md-divider></div></md-list-item><div \nng-repeat=\"field in vm.selectedContent_refgrouped.secondary | orderBy:\'preview_sort\' \"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg\" ng-if=\"field.type==\'label\'\"><h3 class=\"grey-700-fg\" ng-bind=\"field.field_name\">\n</h3><md-divider></md-divider></md-list-item><md-list-item flex=\"100\" ng-if=\"field.type!==\'label\'\" ng-switch=\"\" \non=\"field.type\"><div class=\"text-truncate\" ng-switch-when=\"html\"><div class=\"field\"><p \nclass=\"grey-500-fg font-size-14\" ng-bind=\"field.field_name\"></p><span class=\"font-size-16 text-truncate\" \nng-bind-html=\"vm.processHtml(vm.selectedContent[field.titleId])\"></span><br></div><md-divider></md-divider></div><div \nclass=\"text-truncate\" ng-switch-when=\"status\"><div class=\"field\"><p class=\"grey-500-fg font-size-14\" \nng-bind=\"field.field_name\"></p><span class=\"font-size-16 text-truncate {{vm.selectedContent[field.titleId]|yesNo}}\" \nng-bind-html=\"vm.selectedContent[field.titleId]|yesNo\"></span><br></div><md-divider></md-divider></div><div \nclass=\"text-truncate\" flex=\"100\" ng-switch-default=\"\"><div class=\"field\"><p class=\"grey-500-fg font-size-14\" \nng-bind=\"field.field_name\"></p><span \nng-if=\"field.category!=\'input_related\' && vm.isNumber(vm.selectedContent[field.titleId])\" \nclass=\"font-size-16 text-truncate\" ng-bind-html=\"vm.selectedContent[field.titleId]\"></span> <span \nng-if=\"field.category!=\'input_related\' && !vm.isNumber(vm.selectedContent[field.titleId])\" \nclass=\"font-size-16 text-truncate\" ng-bind-html=\"vm.selectedContent[field.titleId]| autoLinkerFilter\"></span> <span \nng-if=\"field.category==\'input_related\'\" class=\"font-size-16 text-truncate\">\n{{vm.getInArray(\'id_\'+field.config,field.values, vm.selectedContent[field.titleId], field.config)}}</span><br></div>\n<md-divider></md-divider></div><div class=\"text-truncate\" ng-switch-when=\"section\"><div class=\"field\"><p \nclass=\"grey-500-fg font-size-14\" ng-bind=\"field.field_name\"></p><span class=\"font-size-16 text-truncate\" \nng-bind=\"vm.showAssoc(vm.selectedContent[field.titleId], field)\"></span><br></div><md-divider></md-divider></div><div \nclass=\"text-truncate\" ng-switch-when=\"country\"><div class=\"field\"><p class=\"grey-500-fg font-size-14\" \nng-bind=\"field.field_name\"></p><span class=\"font-size-16 text-truncate\" \nng-bind=\"vm.showCountry(vm.selectedContent[field.titleId], field)\"></span><br></div><md-divider></md-divider></div><div\n class=\"text-truncate\" ng-switch-when=\"id_subsec\"><div class=\"field\"><p class=\"grey-500-fg font-size-14\" \nng-bind=\"field.field_name\"></p><span class=\"font-size-16 text-truncate\" \nng-bind=\"vm.getReferencesSections(\'subsection\', field.type, vm.selectedContent[field.titleId])\"></span><br></div>\n<md-divider></md-divider></div><div class=\"text-truncate\" ng-switch-when=\"id_cat\"><div class=\"field\"><p \nclass=\"grey-500-fg font-size-14\" ng-bind=\"field.field_name\"></p><span class=\"font-size-16 text-truncate\" \nng-bind=\"vm.getReferencesSections(\'cat\', field.type, vm.selectedContent[field.titleId])\"></span><br></div><md-divider>\n</md-divider></div><div class=\"text-truncate\" ng-switch-when=\"id_subcat\"><div class=\"field\"><p \nclass=\"grey-500-fg font-size-14\" ng-bind=\"field.field_name\"></p><span class=\"font-size-16 text-truncate\" \nng-bind=\"vm.getReferencesSections(\'subcat\', field.type, vm.selectedContent[field.titleId])\"></span><br></div>\n<md-divider></md-divider></div></md-list-item></div><div ng-if=\"vm.selectedContent.tags\"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg\"><h3 class=\"grey-700-fg\"><span translate=\"CONTENT.TAGS\">\n({{vm.selectedContent.tags.length}})</span></h3><md-divider></md-divider></md-list-item><md-list-item><md-chips \nname=\"tag_name\" ng-model=\"vm.selectedContent.tags\" readonly=\"true\"><md-chip-template><span>\n{{$chip.tag_name}} #{{$chip.id_tag}}</span></md-chip-template></md-chips><md-divider></md-divider></md-list-item></div>\n<div ng-if=\"vm.selectedContent.Thumbnail\"><md-list-item class=\"md-toolbar-tools grey-100-bg\"><h3 class=\"grey-700-fg\" \ntranslate=\"CONTENT.ATTACHMENTS\"><span translate=\"ATTACHMENTS\"></span> ({{vm.selectedContent.Thumbnail.length}})</h3>\n<md-divider></md-divider></md-list-item><md-list-item ng-repeat=\"mediazone in vm.mediaZones\" ng-if=\"vm.mediaZones\"><div\n class=\"attachments\"><div class=\"field\"><p class=\"grey-500-fg font-size-14\">{{ mediazone.title }}</p><div \nclass=\"attachment-list md-list-item-text\" layout=\"row\" layout-wrap=\"\" layout-align=\"start start\"><div \nclass=\"attachment\" ng-repeat=\"attachment in vm.selectedContent.Thumbnail | filter: { id_zone: mediazone.id_zone }\"><div\n ng-hide=\"attachment.gallery_type\"><div class=\"ms-card\" flex md-dynamic-height=\"{{vm.dynamicHeight}}\"><div \nclass=\"ms-card-content-wrapper\"><div class=\"template-9\"><div class=\"media media-attachment\" flex layout=\"row\" \nlayout-align=\"center center\" ng-if=\"attachment.media_type==1 || attachment.media_type==2 || attachment.media_type==3\">\n<div class=\"media document\" layout=\"row\" layout-align=\"center center\" extension-class=\"{{attachment.filename}}\" \nng-href=\"{{attachment.permalink}}\" ng-if=\"attachment.media_type==3\" target=\"_blank\" ng-hide=\"attachment.gallery_type\">\n<qiu-icon mediafile=\"attachment.filename\" class=\"mr-10\"></qiu-icon></div><div flex \nng-click=\"vm.openImageDialog($event, vm.selectedContent.Thumbnail, attachment)\"><img class=\"image\" \nng-repeat=\"crop in attachment.cropstatus | limitTo: 1\" ng-src=\"{{crop.container.view_url}}{{crop.fileName}}\" \nng-if=\"attachment.media_type==1\"> <img class=\"image\" ng-src=\"{{attachment.embed_thumb}}\" \nng-if=\"attachment.media_type==2\"><div ng-if=\"attachment.media_type==2\" class=\"fotorama__video-play\" style=\"opacity:1\">\n</div></div></div><div flex layout=\"column\" layout-align=\"center center\" class=\"media\" \nng-if=\"attachment.media_type==4\" ng-click=\"vm.openUrl(attachment.permalink)\" target=\"_blank\"><qiu-icon \nmediafile=\"attachment.filename\" classextra=\"s56\"></qiu-icon><br><span class=\"grey-500-fg\" layout=\"column\" \nlayout-align=\"center center\"><span ng-if=\"attachment.title\"><strong>{{attachment.title}}</strong> </span><span \nng-if=\"attachment.filename\">{{attachment.filename}}</span></span></div><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"size block\" layout=\"row\" layout-align=\"start center\"><strong \nclass=\"mb-5 block\">#{{attachment.id_media}}</strong> <span class=\"grey-500-fg word-break-all\" \nng-if=\"attachment.media_type==1 || attachment.media_type==2 || attachment.media_type==3\"><span \nng-if=\"attachment.filename\">{{attachment.filename}}</span><span ng-if=\"attachment.title && attachment.filename\"> | \n</span><span ng-if=\"attachment.title\" class=\"word-break-all\">{{attachment.title}}</span></span></div><md-icon \nmd-font-icon=\"icon-eye\" class=\"s16 ml-10\" href=\"#\" \nng-click=\"vm.openImageDialog($event, vm.selectedContent.Thumbnail, attachment)\" \nng-if=\"attachment.media_type==1 || attachment.media_type==2\"></md-icon><md-icon md-font-icon=\"icon-open-in-new\" \nclass=\"s16 ml-10\" href=\"#\" click=\"vm.openUrl(attachment.permalink)\" target=\"_blank\" ng-if=\"attachment.media_type==4\">\n</md-icon></div></div></div></div></div><div ng-if=\"attachment.gallery_type\"><div class=\"ms-card\" flex \nmd-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"ms-card-content-wrapper\"><div class=\"template-9\"><div flex \nlayout=\"column\" layout-align=\"center center\" class=\"media\"><md-icon class=\"s56 mr-5 ml-10\" \nmd-font-icon=\"icon-folder-multiple-image\"></md-icon><br><span class=\"grey-500-fg\" layout=\"column\" \nlayout-align=\"center center\"><span ng-if=\"attachment.gallery_name\"><strong>{{attachment.gallery_name}}</strong></span>\n</span></div><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div class=\"size block\" layout=\"row\" \nlayout-align=\"start center\"><strong class=\"mr-5\">#{{attachment.id_gallery}}</strong> <span class=\"grey-500-fg\">\n{{attachment.gallery_name}}</span></div></div></div></div></div></div></div></div></div></div><md-divider></md-divider>\n</md-list-item><md-list-item ng-repeat=\"(key, value) in vm.selectedContent.Thumbnail | groupBy: \'id_zone\'\" \nng-if=\"!vm.mediaZones\"><div class=\"attachments\"><div class=\"field\"><p class=\"grey-500-fg font-size-14\" \ntranslate=\"CONTENT.NO_ZONE\">No Zone</p><div class=\"attachment-list md-list-item-text\" layout=\"row\" layout-wrap=\"\" \nlayout-align=\"start start\"><div class=\"attachment\" ng-repeat=\"attachment in value\"><div \nng-hide=\"attachment.gallery_type\"><div class=\"ms-card\" flex md-dynamic-height=\"{{vm.dynamicHeight}}\"><div \nclass=\"ms-card-content-wrapper\"><div class=\"template-9\"><div class=\"media media-attachment\" flex layout=\"row\" \nlayout-align=\"center center\" ng-if=\"attachment.media_type==1 || attachment.media_type==2 || attachment.media_type==3\">\n<div class=\"media document\" layout=\"row\" layout-align=\"start center\" extension-class=\"{{attachment.filename}}\" \nng-href=\"{{attachment.permalink}}\" ng-if=\"attachment.media_type==3\" target=\"_blank\" ng-hide=\"attachment.gallery_type\">\n<qiu-icon mediafile=\"attachment.filename\" class=\"mr-10\"></qiu-icon></div><div flex \nng-click=\"vm.openImageDialog($event, vm.selectedContent.Thumbnail, attachment)\"><img class=\"image\" \nng-repeat=\"crop in attachment.cropstatus | limitTo: 1\" ng-src=\"{{crop.container.view_url}}{{crop.fileName}}\" \nng-if=\"attachment.media_type==1\"> <img class=\"image\" ng-src=\"{{attachment.embed_thumb}}\" \nng-if=\"attachment.media_type==2\"><div ng-if=\"attachment.media_type==2\" class=\"fotorama__video-play\" style=\"opacity:1\">\n</div></div></div><div flex layout=\"column\" layout-align=\"center center\" class=\"media\" \nng-if=\"attachment.media_type==4\"><qiu-icon mediafile=\"attachment.filename\" classextra=\"s56\"></qiu-icon><br><span \nclass=\"grey-500-fg\" layout=\"column\" layout-align=\"center center\"><span ng-if=\"attachment.title\"><strong>\n{{attachment.title}}</strong></span> <span ng-if=\"attachment.filename\">{{attachment.filename}}</span></span></div><div \nclass=\"header\" layout=\"row\" layout-align=\"space-between center\"><div class=\"size block\" layout=\"row\" \nlayout-align=\"start center\"><strong class=\"mb-5 block\">#{{attachment.id_media}}</strong> <span \nclass=\"grey-500-fg word-break-all\" \nng-if=\"attachment.media_type==1 || attachment.media_type==2 || attachment.media_type==3\"><span \nng-if=\"attachment.filename\">{{attachment.filename}}</span>| <span ng-if=\"attachment.title\" class=\"word-break-all\">\n{{attachment.title}}</span></span></div><md-icon md-font-icon=\"icon-eye\" class=\"s16 ml-10\" href=\"#\" \nng-click=\"vm.openImageDialog($event, vm.selectedContent.Thumbnail, attachment)\"></md-icon></div></div></div></div>\n</div><div ng-if=\"attachment.gallery_type\"><div class=\"ms-card\" flex md-dynamic-height=\"{{vm.dynamicHeight}}\"><div \nclass=\"ms-card-content-wrapper\"><div class=\"template-9\"><div flex layout=\"column\" layout-align=\"center center\" \nclass=\"media\"><md-icon class=\"s56 mr-5 ml-10\" md-font-icon=\"icon-folder-multiple-image\"></md-icon><br><span \nclass=\"grey-500-fg\" layout=\"column\" layout-align=\"center center\"><span ng-if=\"attachment.gallery_name\"><strong>\n{{attachment.gallery_name}}</strong></span></span></div><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"size block\" layout=\"row\" layout-align=\"start center\"><strong \nclass=\"mb-5 block\">#{{attachment.id_gallery}}</strong> <span class=\"grey-500-fg\">{{attachment.gallery_name}}</span>\n</div></div></div></div></div></div></div></div></div></div><md-divider></md-divider></md-list-item></div><md-list-item\n class=\"md-toolbar-tools grey-100-bg\"><h3 class=\"grey-700-fg\" translate=\"CONTENT.LATESTACTIVITY\"></h3><md-divider>\n</md-divider></md-list-item><div class=\"activities\"><div class=\"activity\" layout=\"row\" layout-align=\"start center\" \nng-repeat=\"activity in vm.log | limitTo: vm.paginationLimit()\"><div class=\"avatar\" \nng-bind=\"activity.user.email | capitalizeFirstLetter\" ms-random-class=\"vm.colors\">P</div><div layout=\"column\"><div>\n<span class=\"username md-accent-color\" ng-if=\"activity.user.email.length>0 && !activity.user.first_name\">\n{{activity.user.email}} </span><span class=\"username md-accent-color\" ng-if=\"activity.user.first_name.length>0\">\n{{activity.user.first_name}} {{activity.user.lastname}} </span><span class=\"message\" ng-if=\"activity.message\">\n{{activity.message}}</span></div><span class=\"time secondary-text\">{{activity.date}}</span></div></div><button \nclass=\"md-raised md-button md-default-theme md-ink-ripple\" ng-click=\"vm.showMoreItems()\" \nng-show=\"vm.hasMoreItemsToShow()\"><span translate=\"CONTENT.SHOW_MORE\"></span></button></div><div hide \nclass=\"activities activities-list activity-main\"><table hide show-gt-md><tr \nng-repeat=\"activity in vm.log | limitTo: vm.paginationLimit()\"><td><div layout=\"row\" layout-align=\"start center\"><div \nng-if=\"(activity.user.avatar == \'\' || !activity.user.avatar)\" class=\"avatar\" \nng-bind=\"activity.user.first_name | capitalizeFirstLetter\" style=\"background-color:{{activity.user.profile_color}}\">\n</div><div class=\"avatar-wrapper\" ng-if=\"activity.user.avatar\" attachment=\"activity.user.avatar\"><img class=\"avatar\" \nng-src=\"{{activity.user.avatar}}\" imageonload></div><h3 class=\"mt-0 mb-0 mr-10\"><strong \nng-bind-html=\"activity.user.first_name + \' \' + activity.user.last_name\"></strong></h3></div></td><td><div \nclass=\"field\" layout=\"row\" layout-align=\"start center\"><span class=\"grey-500-fg\" \nng-bind-html=\"vm.timeAgo(activity.date)\"></span></div></td><td><div class=\"field\" layout=\"row\" \nlayout-align=\"end center\"><span class=\"status {{activity.action.action_name}}\" \nng-bind-html=\"activity.action.action_name\"></span></div></td></tr></table></div></md-list></div></md-content>\n<md-content ng-if=\"vm.editInline && vm.selectedContent\" \nng-include=\"\'app/main/apps/content/views/read/edit-preview-splitted.html\'\" class=\"scrollable edit-mode\" hide \nshow-gt-sm></md-content><md-content ng-if=\"vm.editInline && vm.selectedContent\" \nng-include=\"\'app/main/apps/content/views/read/edit-preview.html\'\" class=\"scrollable edit-mode\" hide-gt-sm></md-content>\n</div>");
$templateCache.put("app/main/apps/content/views/read/read-view-social-stream.html","<div flex layout=\"column\" layout-align=\"center center\" ng-show=\"vm.loadingReadPane\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nng-show=\"!vm.loadingReadPane\"><div class=\"mail-content\" layout=\"column\" layout-align=\"center center\" \nng-if=\"!vm.selectedContent\"><div class=\"content\" layout=\"column\" layout-align=\"top center\"><div class=\"message\" \ntranslate=\"CONTENT.NO_ITEM_SELECTED_PANEL\"></div></div></div><div class=\"toolbar grey-100-bg colored-bg\" layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"vm.selectedContent\" scroll=\"\"><div layout=\"row\" layout-align=\"start center\">\n<div class=\"divider-vertical\" hide=\"\" ng-if=\"vm.activeMailPaneIndex === 1\" show-gt-sm=\"\"></div><md-button \naria-label=\"Info\" class=\"md-icon-button\" ng-click=\"vm.viewPreview()\" \nng-class=\"{\'md-accent\':vm.selectedContent && !vm.editInline}\" ng-if=\"vm.selectedContent.id\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.INFORMATION\"><md-icon md-font-icon=\"icon-information-outline\"></md-icon><md-tooltip \nhide show-gt-xs><span translate=\"CONTENT.INFORMATION\"></span></md-tooltip></md-button><div class=\"divider-vertical\" \nhide=\"\" show-gt-sm=\"\" ng-if=\"vm.selectedContent.id\"></div><md-button aria-label=\"Edit\" class=\"md-icon-button\" \nng-click=\"vm.viewEditInline()\" ng-class=\"{\'md-accent\':vm.editInline && vm.selectedContent}\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.EDIT\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip hide show-gt-xs>\n<span translate=\"CONTENT.EDIT\"></span></md-tooltip></md-button></div><div layout=\"row\" layout-align=\"end center\">\n<md-button class=\"md-icon-button close-thread\" aria-label=\"Back\" ng-click=\"vm.closeThread()\" \nng-if=\"vm.selectedContent\" translate translate-attr-aria-label=\"CONTENT.BACK\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></div><md-content flex=\"\" ng-if=\"vm.selectedContent && !vm.editInline\"><div \nclass=\"mail-content file-details scrollable\" ms-scroll=\"vm.msScrollOptions\"><md-list \nclass=\"{{vm.getReferencesSections(\'subsection\', \'id_subsec\', vm.selectedContent.id_subsec)}}\"><md-list-item \nclass=\"info\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"space-between center\" flex><div \nlayout=\"row\" layout-align=\"start center\"><div class=\"header-element\" layout=\"row\" layout-align=\"center center\"><div>\n<span><span>ID # </span><strong ng-bind=\"vm.selectedContent.id\"></strong></span></div></div></div><div layout=\"row\" \nlayout-align=\"end center\"><div class=\"header-element\" layout=\"row\" layout-align=\"center center\"><div><span><span>\n{{vm.selectedContent.created_at.value ? vm.selectedContent.created_at.value : vm.selectedContent.created_at}}</span>\n</span></div></div><div class=\"header-element\" \nng-switch=\"vm.getReferencesSections(\'subsection\', \'id_subsec\', vm.selectedContent.id_subsec)\" layout=\"row\" \nlayout-align=\"center center\"><span ng-switch-when=\"Instagram\"><i class=\"fa fa-instagram\" style=\"font-size: 25px\"></i> \n</span><span ng-switch-when=\"Facebook\"><i class=\"fa fa-facebook\" style=\"font-size: 25px\"></i> </span><span \nng-switch-when=\"Twitter|X\" ng-switch-when-separator=\"|\"><svg viewBox=\"0 0 24 24\" fill=\"currentColor\" \nstyle=\"width: .8em; height: .8em; font-size: 25px; vertical-align: middle\" role=\"img\" aria-label=\"X\"><path \nd=\"M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z\"/>\n</svg> </span><span ng-switch-when=\"YouTube|Youtube\" ng-switch-when-separator=\"|\"><i class=\"fa fa-youtube-play\" \nstyle=\"font-size: 25px\"></i> </span><span ng-switch-when=\"TikTok|Tiktok\" ng-switch-when-separator=\"|\"><svg \nviewBox=\"0 0 24 24\" fill=\"currentColor\" style=\"width: .8em; height: .8em; font-size: 25px; vertical-align: middle\" \nrole=\"img\" aria-label=\"TikTok\"><path \nd=\"M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z\"/>\n</svg></span></div></div></div></md-list-item><md-divider class=\"md-default-theme\"></md-divider><md-list-item \nclass=\"main-item\" role=\"listitem\"><div layout=\"row\" layout-align=\"space-between center\" class=\"width-percent-100\"><div \nlayout=\"row\" layout-align=\"center center\"><div class=\"main-read\"><div class=\"avatar-container\"><div \nng-if=\"!vm.selectedContent.user_image\" class=\"avatar\" ng-bind=\"vm.selectedContent.user_name | capitalizeFirstLetter\" \nms-random-class=\"vm.colors\"></div><img ng-if=\"vm.selectedContent.user_image\" \nng-src=\"{{vm.selectedContent.user_image}}\" class=\"avatar fix\"></div></div><div class=\"main-read\" layout=\"column\" \nlayout-align=\"center start \"><h2 class=\"name\"><strong ng-bind=\"vm.selectedContent.user_name\" \nclass=\"mr-10 ng-binding ng-scope\"></strong></h2></div></div><div class=\"header-element\" layout=\"row\" \nlayout-align=\"center center\"><div><span><button ng-click=\"vm.toggleItemStatus(selectedContent, $event, $index)\" \nclass=\"md-icon-button\" ng-if=\"vm.selectedContent.onoff === 1\"><md-icon class=\"on green-fg s24\" \nmd-font-icon=\"icon-checkbox-marked-circle\"></md-icon></button> <button \nng-click=\"vm.toggleItemStatus(selectedContent, $event, $index)\" class=\"md-icon-button\" \nng-if=\"vm.selectedContent.onoff !== 1\"><md-icon class=\"off red-fg s24\" \nmd-font-icon=\"icon-checkbox-blank-circle-outline\"></md-icon></button></span></div></div></div></md-list-item>\n<md-list-item><div flex ng-click=\"vm.openUrl( vm.selectedContent.permalink) \"><div flex layout=\"row\" \nlayout-align=\"center center\"><img class=\"image\" ng-src=\"{{vm.selectedContent.media}} \" style=\"margin: 0 auto\"><div \nng-if=\"vm.selectedContent.video\" class=\"fotorama__video-play\" style=\"opacity:1\"></div></div></div></md-list-item>\n<md-list-item ng-repeat=\"field in vm.selectedContent_refgrouped.main | orderBy: \'preview_sort\' \"><div><h1 class=\"name\">\n<span ng-bind=\"vm.selectedContent[field.titleId] \" ng-if=\"field.type !=\'section\' \"></span> <span \nng-bind=\"vm.showAssoc(vm.selectedContent[field.titleId], field) \" ng-if=\"field.type==\'section\' \"></span></h1>\n<md-divider></md-divider></div></md-list-item><md-divider></md-divider><div \nng-repeat=\"field in vm.selectedContent_refgrouped.secondary | orderBy: \'preview_sort\' \"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg\" ng-if=\"field.type==\'label\' \"><h3 class=\"grey-700-fg\" ng-bind=\"field.field_name \">\n</h3><md-divider></md-divider></md-list-item><md-list-item flex=\"100 \" ng-if=\"field.type!==\'label\' \" ng-switch=\" \" \non=\"field.type \"><div class=\"text-truncate\" ng-switch-when=\"html \"><div class=\"field\"><p \nclass=\"grey-500-fg font-size-14\" ng-bind=\"field.field_name \"></p><span class=\"font-size-16 text-truncate\" \nng-bind-html=\"vm.processHtml(vm.selectedContent[field.titleId]) \"></span><br></div><md-divider></md-divider></div><div \nclass=\"text-truncate\" ng-switch-when=\"status \"><div class=\"field\"><p class=\"grey-500-fg font-size-14\" \nng-bind=\"field.field_name \"></p><span class=\"font-size-16 text-truncate {{vm.selectedContent[field.titleId]|yesNo}}\" \nng-bind-html=\"vm.selectedContent[field.titleId]|yesNo \"></span><br></div><md-divider></md-divider></div><div \nclass=\"text-truncate\" flex=\"100 \" ng-switch-default=\" \"><div class=\"field\"><p class=\"grey-500-fg font-size-14\" \nng-bind=\"field.field_name \"></p><span \nng-if=\"field.category!=\'input_related\' && vm.isNumber(vm.selectedContent[field.titleId]) && field.type !== \'id_subsec\'\" \nclass=\"font-size-16 text-truncate\" ng-bind-html=\"vm.selectedContent[field.titleId] \"></span> <span \nng-if=\"field.category!=\'input_related\' && vm.isNumber(vm.selectedContent[field.titleId]) && field.type === \'id_subsec\'\" \nclass=\"font-size-16 text-truncate\" \nng-bind-html=\"vm.getReferencesSections(\'subsection\', \'id_subsec\', vm.selectedContent.id_subsec) \"></span> <span \nng-if=\" vm.selectedContent[field.titleId] && field.category!=\'input_related\' && !vm.isNumber(vm.selectedContent[field.titleId]) \" \nclass=\"font-size-16 text-truncate\" \nng-bind-html=\"vm.selectedContent[field.titleId]|\r\n                            autoLinkerFilter \"></span> <span \nng-if=\"!vm.selectedContent[field.titleId] \" class=\"font-size-16 text-truncate\">-</span> <span \nng-if=\"field.category==\'input_related\' \" class=\"font-size-16 text-truncate\">\n{{vm.getInArray(\'id_\'+field.config,field.values, vm.selectedContent[field.titleId], field.config)}}</span><br></div>\n<md-divider></md-divider></div><div class=\"text-truncate\" ng-switch-when=\"section \"><div class=\"field\"><p \nclass=\"grey-500-fg font-size-14\" ng-bind=\"field.field_name \"></p><span class=\"font-size-16 text-truncate\" \nng-bind=\"vm.showAssoc(vm.selectedContent[field.titleId],\r\n                            field) \"></span><br></div>\n<md-divider></md-divider></div><div class=\"text-truncate\" ng-switch-when=\"country \"><div class=\"field\"><p \nclass=\"grey-500-fg font-size-14\" ng-bind=\"field.field_name \"></p><span class=\"font-size-16 text-truncate\" \nng-bind=\"vm.showCountry(vm.selectedContent[field.titleId],\r\n                            field) \"></span><br></div>\n<md-divider></md-divider></div><div class=\"text-truncate\" ng-switch-when=\"id_subsec \"><div class=\"field\"><p \nclass=\"grey-500-fg font-size-14\" ng-bind=\"field.field_name \"></p><span class=\"font-size-16 text-truncate\" \nng-bind=\"vm.getReferencesSections(\r\n                            \'subsection\', field.type, vm.selectedContent[field.titleId]) \">\n</span><br></div><md-divider></md-divider></div><div class=\"text-truncate\" ng-switch-when=\"id_cat \"><div class=\"field\">\n<p class=\"grey-500-fg font-size-14\" ng-bind=\"field.field_name \"></p><span class=\"font-size-16 text-truncate\" \nng-bind=\"vm.getReferencesSections( \'cat\', field.type,\r\n                            vm.selectedContent[field.titleId]) \">\n</span><br></div><md-divider></md-divider></div><div class=\"text-truncate\" ng-switch-when=\"id_subcat \"><div \nclass=\"field\"><p class=\"grey-500-fg font-size-14\" ng-bind=\"field.field_name \"></p><span \nclass=\"font-size-16 text-truncate\" \nng-bind=\"vm.getReferencesSections( \'subcat\',\r\n                            field.type, vm.selectedContent[field.titleId]) \">\n</span><br></div><md-divider></md-divider></div></md-list-item></div><div ng-if=\"vm.selectedContent.Thumbnail \">\n<md-list-item class=\"md-toolbar-tools grey-100-bg\"><h3 class=\"grey-700-fg\" translate=\"CONTENT.ATTACHMENTS \"><span \ntranslate=\"ATTACHMENTS \"></span> ({{vm.selectedContent.Thumbnail.length}})</h3><md-divider></md-divider></md-list-item>\n<md-list-item ng-repeat=\"mediazone in vm.mediaZones \" ng-if=\"vm.mediaZones \"><div class=\"attachments\"><div \nclass=\"field\"><p class=\"grey-500-fg font-size-14\">{{ mediazone.title }}</p><div \nclass=\"attachment-list md-list-item-text\" layout=\"row \" layout-wrap=\"\r\n                            \" \nlayout-align=\"start start \"><div class=\"attachment\" \nng-repeat=\"attachment in vm.selectedContent.Thumbnail | filter:\r\n                            { id_zone: mediazone.id_zone } \">\n<div class=\"preview document\" layout=\"row \" layout-align=\"start center\r\n                            \" \nextension-class=\"{{attachment.filename}} \" ng-href=\"{{attachment.permalink}} \" ng-if=\"attachment.media_type==3 \" \ntarget=\"_blank \" ng-hide=\"attachment.gallery_type \"><qiu-icon mediafile=\"attachment.filename \" class=\"mr-10\">\n</qiu-icon><a class=\"grey-1000-fg font-size-16\" ng-href=\"{{attachment.permalink}}\r\n                            \" \ntarget=\"_blank \"><span ng-if=\"attachment.title \">{{attachment.title}} </span><span ng-if=\"attachment.filename \">\n{{attachment.filename}}</span></a></div><div ng-hide=\"attachment.gallery_type \"><div class=\"ms-card\" flex \nmd-dynamic-height=\"{{vm.dynamicHeight}} \"><div class=\"ms-card-content-wrapper\"><div class=\"template-9\"><div \nclass=\"media media-attachment\" flex layout=\"row\r\n                            \" layout-align=\"center center \" \nng-if=\"attachment.media_type==1 || attachment.media_type==2 \"><div flex \nng-click=\"vm.openImageDialog($event, vm.selectedContent.Thumbnail,\r\n                            attachment) \"><img \nclass=\"image\" ng-repeat=\"crop in attachment.cropstatus\r\n                            | limitTo: 1 \" \nng-src=\"{{crop.container.view_url}}{{crop.fileName}} \" ng-if=\"attachment.media_type==1 \"> <img class=\"image\" \nng-src=\"{{attachment.embed_thumb}}\r\n                            \" ng-if=\"attachment.media_type==2 \"><div \nng-if=\"attachment.media_type==2 \" class=\"fotorama__video-play\" style=\"opacity:1\"></div></div></div><div flex \nlayout=\"column \" layout-align=\"center center\r\n                            \" class=\"media\" \nng-if=\"attachment.media_type==4 \" ng-click=\"vm.openUrl(attachment.permalink) \" target=\"_blank \"><qiu-icon \nmediafile=\"attachment.filename \" classextra=\"s56 \"></qiu-icon><br><span class=\"grey-500-fg\" layout=\"column \" \nlayout-align=\"center\r\n                            center \"><span ng-if=\"attachment.title \"><strong>{{attachment.title}}\n</strong> </span><span ng-if=\"attachment.filename \">{{attachment.filename}}</span></span></div><div class=\"header\" \nlayout=\"row \" layout-align=\"space-between\r\n                            center \"><div class=\"size block\" layout=\"row\" \nlayout-align=\"start center \"><strong class=\"mr-5\">#{{attachment.id_media}}</strong> <span class=\"grey-500-fg\" \nng-if=\"attachment.media_type==1 || attachment.media_type==2 \"><span ng-if=\"attachment.filename \">\n{{attachment.filename}}</span> <span ng-if=\"attachment.title && attachment.filename \">| </span><span \nng-if=\"attachment.title \">{{attachment.title}}</span></span></div><md-icon md-font-icon=\"icon-eye \" class=\"s16 ml-10\" \nhref=\"#\r\n                            \" \nng-click=\"vm.openImageDialog($event, vm.selectedContent.Thumbnail, attachment) \" \nng-if=\"attachment.media_type==1 || attachment.media_type==2 \"></md-icon><md-icon md-font-icon=\"icon-open-in-new \" \nclass=\"s16 ml-10\" href=\"# \" click=\"vm.openUrl(attachment.permalink) \" target=\"_blank \" \nng-if=\"attachment.media_type==4 \"></md-icon></div></div></div></div></div><div ng-if=\"attachment.gallery_type \"><div \nclass=\"ms-card\" flex md-dynamic-height=\"{{vm.dynamicHeight}} \"><div class=\"ms-card-content-wrapper\"><div \nclass=\"template-9\"><div flex layout=\"column \" layout-align=\"center center\r\n                            \" class=\"media\">\n<md-icon class=\"s56 mr-5 ml-10\" md-font-icon=\"icon-folder-multiple-image \"></md-icon><br><span class=\"grey-500-fg\" \nlayout=\"column \" layout-align=\"center\r\n                            center \"><span ng-if=\"attachment.gallery_name \">\n<strong>{{attachment.gallery_name}}</strong></span></span></div><div class=\"header\" layout=\"row \" \nlayout-align=\"space-between\r\n                            center \"><div class=\"size block\" \nlayout=\"row\r\n                            \" layout-align=\"start center \"><strong class=\"mr-5\">#{{attachment.id_gallery}}\n</strong> <span class=\"grey-500-fg\">{{attachment.gallery_name}}</span></div></div></div></div></div></div></div></div>\n</div></div><md-divider></md-divider></md-list-item><md-list-item \nng-repeat=\"(key, value) in vm.selectedContent.Thumbnail | groupBy: \'id_zone\'\r\n                            \" \nng-if=\"!vm.mediaZones \"><div class=\"attachments\"><div class=\"field\"><p class=\"grey-500-fg font-size-14\" \ntranslate=\"CONTENT.NO_ZONE \">No Zone</p><div class=\"attachment-list md-list-item-text\" layout=\"row \" \nlayout-wrap=\"\r\n                            \" layout-align=\"start start \"><div class=\"attachment\" \nng-repeat=\"attachment in value \"><div class=\"preview document\" layout=\"row \" \nlayout-align=\"start center\r\n                            \" extension-class=\"{{attachment.filename}} \" \nng-href=\"{{attachment.permalink}} \" ng-if=\"attachment.media_type==3 \" target=\"_blank \" \nng-hide=\"attachment.gallery_type \"><qiu-icon mediafile=\"attachment.filename \" class=\"mr-10\"></qiu-icon><a \nclass=\"grey-1000-fg font-size-16\" ng-href=\"{{attachment.permalink}}\r\n                            \" target=\"_blank \">\n<span ng-if=\"attachment.title \">{{attachment.title}} </span><span ng-if=\"attachment.filename \">{{attachment.filename}}\n</span></a></div><div ng-hide=\"attachment.gallery_type \"><div class=\"ms-card\" flex \nmd-dynamic-height=\"{{vm.dynamicHeight}} \"><div class=\"ms-card-content-wrapper\"><div class=\"template-9\"><div \nclass=\"media media-attachment\" flex layout=\"row\r\n                            \" layout-align=\"center center \" \nng-if=\"attachment.media_type==1 || attachment.media_type==2 \"><div flex \nng-click=\"vm.openImageDialog($event, vm.selectedContent.Thumbnail,\r\n                            attachment) \"><img \nclass=\"image\" ng-repeat=\"crop in attachment.cropstatus\r\n                            | limitTo: 1 \" \nng-src=\"{{crop.container.view_url}}{{crop.fileName}} \" ng-if=\"attachment.media_type==1 \"> <img class=\"image\" \nng-src=\"{{attachment.embed_thumb}}\r\n                            \" ng-if=\"attachment.media_type==2 \"><div \nng-if=\"attachment.media_type==2 \" class=\"fotorama__video-play\" style=\"opacity:1\"></div></div></div><div flex \nlayout=\"column \" layout-align=\"center center\r\n                            \" class=\"media\" \nng-if=\"attachment.media_type==4 \"><qiu-icon mediafile=\"attachment.filename \" classextra=\"s56 \"></qiu-icon><br><span \nclass=\"grey-500-fg\" layout=\"column \" layout-align=\"center\r\n                            center \"><span \nng-if=\"attachment.title \"><strong>{{attachment.title}}</strong> </span><span ng-if=\"attachment.filename \">\n{{attachment.filename}}</span></span></div><div class=\"header\" layout=\"row \" \nlayout-align=\"space-between\r\n                            center \"><div class=\"size block\" \nlayout=\"row\r\n                            \" layout-align=\"start center \"><strong class=\"mr-5\">#{{attachment.id_media}}\n</strong> <span class=\"grey-500-fg\" \nng-if=\"attachment.media_type==1\r\n                            || attachment.media_type==2 \"><span \nng-if=\"attachment.filename \">{{attachment.filename}}</span>| <span ng-if=\"attachment.title \">{{attachment.title}}\n</span></span></div><md-icon md-font-icon=\"icon-eye \" class=\"s16 ml-10\" href=\"#\r\n                            \" \nng-click=\"vm.openImageDialog($event, vm.selectedContent.Thumbnail, attachment) \"></md-icon></div></div></div></div>\n</div><div ng-if=\"attachment.gallery_type \"><div class=\"ms-card\" flex md-dynamic-height=\"{{vm.dynamicHeight}} \"><div \nclass=\"ms-card-content-wrapper\"><div class=\"template-9\"><div flex layout=\"column \" \nlayout-align=\"center center\r\n                            \" class=\"media\"><md-icon class=\"s56 mr-5 ml-10\" \nmd-font-icon=\"icon-folder-multiple-image \"></md-icon><br><span class=\"grey-500-fg\" layout=\"column \" \nlayout-align=\"center\r\n                            center \"><span ng-if=\"attachment.gallery_name \"><strong>\n{{attachment.gallery_name}}</strong></span></span></div><div class=\"header\" layout=\"row \" \nlayout-align=\"space-between\r\n                            center \"><div class=\"size block\" \nlayout=\"row\r\n                            \" layout-align=\"start center \"><strong class=\"mr-5\">#{{attachment.id_gallery}}\n</strong> <span class=\"grey-500-fg\">{{attachment.gallery_name}}</span></div></div></div></div></div></div></div></div>\n</div></div><md-divider></md-divider></md-list-item></div><div ng-if=\"vm.selectedContent.tags \"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg\"><h3 class=\"grey-700-fg\"><span translate=\"CONTENT.TAGS \">\n({{vm.selectedContent.tags.length}})</span></h3><md-divider></md-divider></md-list-item><md-list-item><md-chips \nname=\"tag_name \" ng-model=\"vm.selectedContent.tags \" readonly=\"true \" md-removable=\"false \"><md-chip-template><span>\n{{$chip.tag_name}} #{{$chip.id_tag}}</span></md-chip-template></md-chips><md-divider></md-divider></md-list-item></div>\n<md-list-item class=\"md-toolbar-tools grey-100-bg\"><h3 class=\"grey-700-fg\" translate=\"CONTENT.LATESTACTIVITY \"></h3>\n<md-divider></md-divider></md-list-item><div class=\"activities\"><div class=\"activity\" layout=\"row \" \nlayout-align=\"start center \" \nng-repeat=\"activity in vm.log | limitTo:\r\n                            vm.paginationLimit() \"><div class=\"avatar\" \nng-bind=\"activity.user.email | capitalizeFirstLetter \" ms-random-class=\"vm.colors \">P</div><div layout=\"column \"><div>\n<span class=\"username md-accent-color\" ng-if=\"activity.user.email.length>0 && !activity.user.first_name\">\n{{activity.user.email}} </span><span class=\"username md-accent-color\" ng-if=\"activity.user.first_name.length>0\">\n{{activity.user.first_name}} {{activity.user.lastname}} </span><span class=\"message\" ng-if=\"activity.message\">\n{{activity.message}}</span></div><span class=\"time secondary-text\">{{activity.date}}</span></div></div><button \nclass=\"md-raised md-button md-default-theme md-ink-ripple\" ng-click=\"vm.showMoreItems()\" \nng-show=\"vm.hasMoreItemsToShow()\"><span translate=\"CONTENT.SHOW_MORE\"></span></button></div><div hide \nclass=\"activities activities-list activity-main\"><table hide show-gt-md><tr \nng-repeat=\"activity in vm.log | limitTo: vm.paginationLimit()\"><td><div layout=\"row\" layout-align=\"start center\"><div \nng-if=\"(activity.user.avatar == \'\' || !activity.user.avatar)\" class=\"avatar\" \nng-bind=\"activity.user.first_name | capitalizeFirstLetter\" style=\"background-color:{{activity.user.profile_color}}\">\n</div><div class=\"avatar-wrapper\" ng-if=\"activity.user.avatar\" attachment=\"activity.user.avatar\"><img class=\"avatar\" \nng-src=\"{{activity.user.avatar}}\" imageonload></div><h3 class=\"mt-0 mb-0 mr-10\"><strong \nng-bind-html=\"activity.user.first_name + \' \' + activity.user.last_name\"></strong></h3></div></td><td><div \nclass=\"field\" layout=\"row\" layout-align=\"start center\"><span class=\"grey-500-fg\" \nng-bind-html=\"vm.timeAgo(activity.date)\"></span></div></td><td><div class=\"field\" layout=\"row\" \nlayout-align=\"end center\"><span class=\"status {{activity.action.action_name}}\" \nng-bind-html=\"activity.action.action_name\"></span></div></td></tr></table></div></md-list></div></md-content>\n<md-content ng-if=\"vm.editInline && vm.selectedContent\" \nng-include=\"\'app/main/apps/content/views/read/edit-preview.html\'\" class=\"scrollable\"></md-content></div>");
$templateCache.put("app/main/apps/content/views/read/read-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-show=\"vm.loadingReadPane\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nng-show=\"!vm.loadingReadPane\"><div class=\"mail-content\" layout=\"column\" layout-align=\"center center\" \nng-if=\"!vm.selectedContent\"><div class=\"content\" layout=\"column\" layout-align=\"top center\"><div class=\"message\" \ntranslate=\"CONTENT.NO_ITEM_SELECTED_PANEL\"></div></div></div><div class=\"toolbar grey-100-bg colored-bg\" layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"vm.selectedContent\" scroll=\"\"><div layout=\"row\" layout-align=\"start center\">\n<md-button class=\"md-icon-button close-thread\" aria-label=\"Back\" ng-click=\"vm.closeThread()\" \nng-if=\"vm.currentThread && vm.currentView==\'nosplit\'\" translate translate-attr-aria-label=\"CONTENT.BACK\"><md-icon \nmd-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><div class=\"divider-vertical\" hide=\"\" \nng-if=\"vm.activeMailPaneIndex === 1\" show-gt-sm=\"\"></div><md-button aria-label=\"Info\" class=\"md-icon-button\" \nng-click=\"vm.viewPreview()\" ng-class=\"{\'md-accent\':vm.selectedContent && !vm.editInline}\" \nng-if=\"vm.selectedContent.id\" translate=\"\" translate-attr-aria-label=\"CONTENT.INFORMATION\"><md-icon \nmd-font-icon=\"icon-information-outline\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.INFORMATION\">\n</span></md-tooltip></md-button><div class=\"divider-vertical\" hide=\"\" show-gt-sm=\"\" ng-if=\"vm.selectedContent.id\">\n</div><md-button aria-label=\"Edit\" class=\"md-icon-button\" ng-click=\"vm.viewEditInline()\" \nng-class=\"{\'md-accent\':vm.editInline && vm.selectedContent}\" translate=\"\" translate-attr-aria-label=\"CONTENT.EDIT\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.EDIT\"></span>\n</md-tooltip></md-button><div class=\"divider-vertical\" hide=\"\" show-gt-sm=\"\" \nng-if=\"vm.selectedContent.urlpreview && vm.selectedContent.urlpreview.length > 10\"></div><md-button \naria-label=\"Preview\" class=\"md-icon-button\" \nng-if=\"vm.selectedContent.urlpreview && vm.selectedContent.urlpreview.length > 10\" \nng-click=\"vm.openUrl(vm.selectedContent.urlpreview)\" translate=\"\" translate-attr-aria-label=\"CONTENT.PREVIEW\"><md-icon \nmd-font-icon=\"icon-eye\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.PREVIEW\"></span></md-tooltip>\n</md-button><div class=\"divider-vertical\" hide=\"\" show-gt-sm=\"\" ng-if=\"vm.ActiveSection.web_preview\"></div><md-button \naria-label=\"Spam\" class=\"md-icon-button\" ng-click=\"\" translate=\"\" translate-attr-aria-label=\"CONTENT.LIVE\" \nng-if=\"vm.ActiveSection.web_preview\"><md-icon md-font-icon=\"icon-web\"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate=\"CONTENT.LIVE\"></span></md-tooltip></md-button><div class=\"divider-vertical\" hide=\"\" show-gt-sm=\"\" \nng-if=\"vm.ActiveSection.template==\'rss\'\"></div><md-button aria-label=\"Spam\" class=\"md-icon-button\" \nng-click=\"vm.rssImportDialog($event, vm.selectedContent)\" translate=\"\" translate-attr-aria-label=\"CONTENT.RSS_IMPORT\" \nng-if=\"vm.ActiveSection.template==\'rss\'\"><md-icon md-font-icon=\"icon-rss-box\"></md-icon><md-tooltip hide show-gt-xs>\n<span translate=\"CONTENT.RSS_IMPORT\"></span></md-tooltip></md-button></div><div layout=\"row\" layout-align=\"end center\" \nng-if=\"vm.isPushNotification && !vm.currentThread_Edit\"><md-button type=\"submit\" \nng-click=\"vm.sendPushNotification(vm.currentThread)\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.basicForm.$invalid || vm.basicForm.$pristine || vm.sendingNotification\"><span aria-label=\"SEND\" \ntranslate=\"CONTENT.SEND\" translate-attr-aria-label=\"CONTENT.SEND\" ng-hide=\"vm.savingProcess\">SEND</span> <span \nng-show=\"vm.savingProcess\" translate=\"CONTENT.SEND\"></span></md-button></div><div layout=\"row\" \nlayout-align=\"end center\" ng-if=\"vm.currentThread_Edit\"><md-button type=\"submit\" \nng-click=\"vm.saveItem(vm.currentThread_Edit)\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.basicForm.$invalid || vm.basicForm.$pristine\"><span aria-label=\"SAVE\" translate=\"CONTENT.SAVE\" \ntranslate-attr-aria-label=\"CONTENT.SAVE\" ng-hide=\"vm.savingProcess\">SAVE</span> <span ng-show=\"vm.savingProcess\" \ntranslate=\"CONTENT.SAVING\"></span></md-button><md-button type=\"button\" ng-click=\"vm.closeThreadEdit()\" \nclass=\"md-raised md-warn\" aria-label=\"Cancel\" translate=\"CONTENT.CANCEL\"></md-button></div></div><md-content flex=\"\" \nng-if=\"vm.selectedContent && !vm.editInline\"><div id=\"content-edit\" \nclass=\"page-layout simple fullwidth mail-content content-edit\" layout=\"column\"><md-tabs ms-scroll=\"vm.msScrollOptions\" \nclass=\"scrollable\"><md-tab><md-tab-label>{{ sectionName || section}}</md-tab-label><md-tab-body><div \nng-include=\"\'app/main/apps/content/views/read/tab-read.html\'\"></div></md-tab-body></md-tab><md-tab \nng-repeat=\"tab in vm.selectedContent_ref_tabs\" ng-if=\"tab.type ===\'section_data\'\"><md-tab-label>\n{{tab.raw_settings.tabName | translate}}</md-tab-label><md-tab-body><div \nng-include=\"\'app/main/apps/content/views/read/tab-read-grouped.html\'\"></div></md-tab-body></md-tab></md-tabs></div>\n</md-content><md-content ng-if=\"vm.editInline && vm.selectedContent\" \nng-include=\"\'app/main/apps/content/views/read/edit-preview.html\'\" class=\"scrollable\"></md-content></div>");
$templateCache.put("app/main/apps/content/views/read/tab-edit.html","<div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><form name=\"vm.basicForm\" class=\"md-inline-form\" novalidate>\n<share-card-editor ng-if=\"section === \'share_card_designs\'\" record=\"vm.currentThread_Edit\"></share-card-editor><div \nng-if=\"section !== \'share_card_designs\'\"><div \nng-repeat=\"fields in vm.currentThread_ref | filter: {\'edit_editable\':1, \'edit_position\': \'header\'} | orderBy:\'edit_sort\'\">\n<md-list-item class=\"md-toolbar-tools grey-100-bg\" ng-if=\"fields.type==\'label\'\"><h3 class=\"grey-700-fg\" \nng-bind=\"fields.field_name\"></h3></md-list-item><md-input-container class=\"md-block\" ng-if=\"fields.type==\'id_subsec\'\" \nflex><label ng-bind=\"fields.field_name\"></label><md-select ng-model=\"vm.currentThread_Edit[fields.type]\" \nplaceholder=\"{{vm.currentThread_Edit[fields.field_name]}}\" ng-required=\"fields.mandatory == 1\" \nng-init=\"oldVal = vm.currentThread_Edit[fields.type]\" ng-change=\"oldVal = \'{{vm.currentThread_Edit[fields.type]}}\'\" \nmd-on-close=\"vm.onSectionsSelectClose($event, vm.currentThread_Edit, fields.type, fields.field_name, \'subsection\', oldVal)\">\n<md-option value=\"\">---</md-option><md-option value=\"{{opt.id_subsec}}\" \nng-repeat=\"opt in vm.getValuesReferencesSections(\'subsection\')\">{{opt.subsec}}</md-option><md-option value=\"add\" \ntranslate=\"CONTENT.ADD_NEW\"></md-option><md-option value=\"manage\" translate=\"CONTENT.MANAGE\"></md-option></md-select>\n<div class=\"md-errors-spacer\"></div></md-input-container><md-input-container class=\"md-block\" \nng-if=\"fields.type==\'id_cat\'\" flex><label ng-bind=\"fields.field_name\"></label><md-select \nng-model=\"vm.currentThread_Edit[fields.type]\" placeholder=\"{{vm.currentThread_Edit[fields.field_name]}}\" \nng-required=\"fields.mandatory == 1\" ng-init=\"oldVal = vm.currentThread_Edit[fields.type]\" \nng-change=\"oldVal = \'{{vm.currentThread_Edit[fields.type]}}\'\" \nmd-on-close=\"vm.onSectionsSelectClose($event, vm.currentThread_Edit, fields.type, fields.field_name, \'cat\', oldVal)\">\n<md-option value=\"\">---</md-option><md-option value=\"{{opt.id_cat}}\" \nng-repeat=\"opt in vm.getValuesReferencesSections(\'cat\')\">{{opt.cat}}</md-option><md-option value=\"add\" \ntranslate=\"CONTENT.ADD_NEW\"></md-option><md-option value=\"manage\" translate=\"CONTENT.MANAGE\"></md-option></md-select>\n<div class=\"md-errors-spacer\"></div></md-input-container><md-input-container class=\"md-block\" \nng-if=\"fields.type==\'id_subcat\'\" flex><label ng-bind=\"fields.field_name\"></label><md-select \nng-model=\"vm.currentThread_Edit[fields.type]\" placeholder=\"{{vm.currentThread_Edit[fields.field_name]}}\" \nng-required=\"fields.mandatory == 1\" ng-init=\"oldVal = vm.currentThread_Edit[fields.type]\" \nng-change=\"oldVal = \'{{vm.currentThread_Edit[fields.type]}}\'\" \nmd-on-close=\"vm.onSectionsSelectClose($event, vm.currentThread_Edit, fields.type, fields.field_name, \'subcat\', oldVal)\">\n<md-option value=\"\">---</md-option><md-option value=\"{{opt.id_subcat}}\" \nng-repeat=\"opt in vm.getValuesReferencesSections(\'subcat\')\">{{opt.subcat}}</md-option><md-option value=\"add\" \ntranslate=\"CONTENT.ADD_NEW\"></md-option><md-option value=\"manage\" translate=\"CONTENT.MANAGE\"></md-option></md-select>\n<div class=\"md-errors-spacer\"></div></md-input-container><md-input-container class=\"md-block\" \nng-if=\"fields.category==\'input_related\'\" flex><label ng-bind=\"fields.field_name\"></label><md-select \nng-model=\"vm.currentThread_Edit[fields.titleId]\" placeholder=\"{{vm.currentThread_Edit[fields.field_name]}}\" \nng-required=\"fields.mandatory == 1\"><md-option value=\"\">---</md-option><md-option ng-repeat=\"opt in fields.values\" \nng-value=\"opt.id_{{fields.config}}\">{{opt[fields.config]}}</md-option></md-select><div class=\"md-errors-spacer\"></div>\n</md-input-container><md-input-container class=\"md-block\" ng-if=\"fields.type==\'text\'\" flex><label \nng-bind=\"fields.field_name\"></label><textarea ng-model=\"vm.currentThread_Edit[fields.titleId]\" columns=\"1\" rows=\"1\" \nplaceholder=\"{{fields.field_name}}\" ng-required=\"fields.mandatory == 1\"></textarea></md-input-container>\n<md-input-container class=\"md-block\" ng-if=\"fields.type==\'status\'\" flex><md-checkbox class=\"no-label\" \naria-label=\"{{fields.field_name}}\" ng-model=\"vm.currentThread_Edit[fields.titleId]\" ng-true-value=\"1\" \nng-false-value=\"0\" ng-required=\"fields.mandatory == 1\">{{fields.field_name}}</md-checkbox></md-input-container>\n<md-input-container class=\"md-block on-off\" ng-if=\"fields.type==\'onoff\'\" flex><button \nng-if=\"vm.currentThread_Edit[fields.titleId] ===1\" class=\"md-icon-button md-button\" \nng-click=\"vm.toggleItemStatusEdit(fields.titleId)\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" \nclass=\"on green-fg s24\"></md-icon></button> <button ng-if=\"vm.currentThread_Edit[fields.titleId] !==1\" \nclass=\"md-icon-button md-button\" ng-click=\"vm.toggleItemStatusEdit(fields.titleId)\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\"></md-icon></button></md-input-container>\n<md-input-container class=\"md-block\" ng-if=\"fields.type==\'language\'\" flex><label ng-bind=\"fields.field_name\"></label>\n<md-select ng-model=\"vm.currentThread_Edit[fields.titleId]\" placeholder=\"{{vm.currentThread_Edit[fields.field_name]}}\" \nng-required=\"fields.mandatory == 1\"><md-option value=\"\">---</md-option><md-option \nng-repeat=\"opt in vm.siteLanguages()\" value=\"{{opt.id_lang}}\">{{opt.lang_name}}</md-option></md-select><div \nclass=\"md-errors-spacer\"></div></md-input-container><md-input-container class=\"md-block\" \nng-if=\"fields.type==\'single\' || fields.type==\'nume\'\"><label ng-bind=\"fields.field_name\"></label><input type=\"text\" \nname=\"{{fields.title}}\" ng-model=\"vm.currentThread_Edit[fields.titleId]\" placeholder=\"{{fields.field_name}}\" \nng-required=\"fields.mandatory == 1\"></md-input-container><div layout=\"column\" layout-gt-sm=\"column\" \nclass=\"date-time-picker\" ng-if=\"fields.type==\'dateHm\' || fields.type==\'date\'\"><div flex><label flex layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"mr-20\" ng-bind=\"fields.field_name\"></span> <a \nclass=\"md-accent text-capitalized\" hide><md-icon md-font-icon=\"icon-clock\" class=\"md-accent s16 mr-5\"></md-icon>\n<strong><span translate=\"CONTENT.SET_TO_NOW\">Set to now</span></strong></a></label></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><div flex-gt-sm=\"66\" flex=\"100\" layout=\"row\"><div flex class=\"date-container date\"><mdp-date-picker \nmdp-placeholder=\"Date\" mdp-format=\"{{vm.dateFormat}}\" mdp-open-on-click=\"true\" \nng-model=\"vm.currentThread_Edit[fields.titleId].date\" ng-change=\"vm.updateDatePicker(fields.titleId)\" \nng-required=\"fields.mandatory == 1\"></mdp-date-picker></div><div flex class=\"date-container time\"><mdp-time-picker \nmdp-placeholder=\"Time\" mdp-auto-switch=\"true\" mdp-open-on-click=\"true\" \nng-model=\"vm.currentThread_Edit[fields.titleId].date\" ng-change=\"vm.updateDatePicker(fields.titleId)\" \nng-required=\"fields.mandatory == 1\"></mdp-time-picker></div></div><div flex-gt-sm=\"33\" flex=\"100\"><div flex \nclass=\"date-container utc\"><md-input-container class=\"md-block\"><label>UTC Date</label><input type=\"text\" \nng-model=\"vm.currentThread_Edit[fields.titleId].utcShow\" disabled=\"disabled\"></md-input-container></div></div></div>\n</div><md-input-container flex class=\"md-block md-input-has-value html\" ng-if=\"fields.type==\'html\'\" \nng-class=\"{\'required\':fields.mandatory == 1}\"><label ng-bind=\"fields.field_name\"></label><textarea \nui-tinymce=\"vm.tinymceOptions\" ng-model=\"vm.currentThread_Edit[fields.titleId]\" aria-label=\"{{fields.titleId}}\" \nplaceholder=\"{{fields.field_name}}\" ng-required=\"fields.mandatory == 1\"></textarea></md-input-container></div><div \nng-repeat=\"fields in vm.currentThread_ref | filter: {\'edit_editable\':1, \'edit_position\': \'!header\'} | orderBy:\'edit_sort\'\">\n<md-list-item class=\"md-toolbar-tools grey-100-bg\" ng-if=\"fields.type==\'label\'\"><h3 class=\"grey-700-fg\" \nng-bind=\"fields.field_name\"></h3></md-list-item><md-input-container class=\"md-block\" ng-if=\"fields.type==\'id_subsec\'\" \nflex><label ng-bind=\"fields.field_name\"></label><md-select ng-model=\"vm.currentThread_Edit[fields.type]\" \nplaceholder=\"{{vm.currentThread_Edit[fields.field_name]}}\" ng-required=\"fields.mandatory == 1\" \nng-init=\"oldVal = vm.currentThread_Edit[fields.type]\" ng-change=\"oldVal = \'{{vm.currentThread_Edit[fields.type]}}\'\" \nmd-on-close=\"vm.onSectionsSelectClose($event, vm.currentThread_Edit, fields.type, fields.field_name, \'subsection\', oldVal)\">\n<md-option value=\"\">---</md-option><md-option value=\"{{opt.id_subsec}}\" \nng-repeat=\"opt in vm.getValuesReferencesSections(\'subsection\')\">{{opt.subsec}}</md-option><md-option value=\"add\" \ntranslate=\"CONTENT.ADD_NEW\"></md-option><md-option value=\"manage\" translate=\"CONTENT.MANAGE\"></md-option></md-select>\n<div class=\"md-errors-spacer\"></div></md-input-container><md-input-container class=\"md-block\" \nng-if=\"fields.type==\'id_cat\'\" flex><label ng-bind=\"fields.field_name\"></label><md-select \nng-model=\"vm.currentThread_Edit[fields.type]\" placeholder=\"{{vm.currentThread_Edit[fields.field_name]}}\" \nng-required=\"fields.mandatory == 1\" ng-init=\"oldVal = vm.currentThread_Edit[fields.type]\" \nng-change=\"oldVal = \'{{vm.currentThread_Edit[fields.type]}}\'\" \nmd-on-close=\"vm.onSectionsSelectClose($event, vm.currentThread_Edit, fields.type, fields.field_name, \'cat\', oldVal)\">\n<md-option value=\"\">---</md-option><md-option value=\"{{opt.id_cat}}\" \nng-repeat=\"opt in vm.getValuesReferencesSections(\'cat\')\">{{opt.cat}}</md-option><md-option value=\"add\" \ntranslate=\"CONTENT.ADD_NEW\"></md-option><md-option value=\"manage\" translate=\"CONTENT.MANAGE\"></md-option></md-select>\n<div class=\"md-errors-spacer\"></div></md-input-container><md-input-container class=\"md-block\" \nng-if=\"fields.type==\'id_subcat\'\" flex><label ng-bind=\"fields.field_name\"></label><md-select \nng-model=\"vm.currentThread_Edit[fields.type]\" placeholder=\"{{vm.currentThread_Edit[fields.field_name]}}\" \nng-required=\"fields.mandatory == 1\" ng-init=\"oldVal = vm.currentThread_Edit[fields.type]\" \nng-change=\"oldVal = \'{{vm.currentThread_Edit[fields.type]}}\'\" \nmd-on-close=\"vm.onSectionsSelectClose($event, vm.currentThread_Edit, fields.type, fields.field_name, \'subcat\', oldVal)\">\n<md-option value=\"\">---</md-option><md-option value=\"{{opt.id_subcat}}\" \nng-repeat=\"opt in vm.getValuesReferencesSections(\'subcat\')\">{{opt.subcat}}</md-option><md-option value=\"add\" \ntranslate=\"CONTENT.ADD_NEW\"></md-option><md-option value=\"manage\" translate=\"CONTENT.MANAGE\"></md-option></md-select>\n<div class=\"md-errors-spacer\"></div></md-input-container><md-input-container class=\"md-block\" \nng-if=\"fields.category==\'input_related\'\" flex><label ng-bind=\"fields.field_name\"></label><md-select \nng-model=\"vm.currentThread_Edit[fields.titleId]\" placeholder=\"{{vm.currentThread_Edit[fields.field_name]}}\" \nng-required=\"fields.mandatory == 1\"><md-option value=\"\">---</md-option><md-option ng-repeat=\"opt in fields.values\" \nng-value=\"opt.id_{{fields.config}}\">{{opt[fields.config]}}</md-option></md-select><div class=\"md-errors-spacer\"></div>\n</md-input-container><md-input-container class=\"md-block\" ng-if=\"fields.type==\'text\'\" flex><label \nng-bind=\"fields.field_name\"></label><textarea ng-model=\"vm.currentThread_Edit[fields.titleId]\" columns=\"1\" rows=\"1\" \nplaceholder=\"{{fields.field_name}}\" ng-required=\"fields.mandatory == 1\"></textarea></md-input-container>\n<md-input-container class=\"md-block\" ng-if=\"fields.type==\'status\'\" flex><md-checkbox class=\"no-label\" \naria-label=\"{{fields.field_name}}\" ng-model=\"vm.currentThread_Edit[fields.titleId]\" ng-true-value=\"1\" \nng-false-value=\"0\" ng-required=\"fields.mandatory == 1\">{{fields.field_name}}</md-checkbox></md-input-container>\n<md-input-container class=\"md-block on-off\" ng-if=\"fields.type==\'onoff\'\" flex><button \nng-if=\"vm.currentThread_Edit[fields.titleId] ===1\" class=\"md-icon-button md-button\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\" ng-click=\"vm.toggleItemStatusEdit(fields.titleId)\">\n</md-icon></button> <button ng-if=\"vm.currentThread_Edit[fields.titleId] !==1\" class=\"md-icon-button md-button\">\n<md-icon md-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\" \nng-click=\"vm.toggleItemStatusEdit(fields.titleId)\"></md-icon></button></md-input-container><md-input-container \nclass=\"md-block\" ng-if=\"fields.type==\'language\'\" flex><label ng-bind=\"fields.field_name\"></label><md-select \nng-model=\"vm.currentThread_Edit[fields.titleId]\" placeholder=\"{{vm.currentThread_Edit[fields.field_name]}}\" \nng-required=\"fields.mandatory == 1\"><md-option value=\"\">---</md-option><md-option \nng-repeat=\"opt in vm.siteLanguages()\" value=\"{{opt.id_lang}}\">{{opt.lang_name}}</md-option></md-select><div \nclass=\"md-errors-spacer\"></div></md-input-container><md-input-container class=\"md-block\" \nng-if=\"fields.type==\'single\' || fields.type==\'nume\'\"><label ng-bind=\"fields.field_name\"></label><textarea \nng-model=\"vm.currentThread_Edit[fields.titleId]\" columns=\"1\" rows=\"1\" placeholder=\"{{fields.field_name}}\" \nng-required=\"fields.mandatory == 1\"></textarea></md-input-container><md-input-container class=\"md-block\" \nng-if=\"fields.type == \'sectionmulti\'\" ng-init=\"vm.initSectionMulti(fields)\"><label>{{fields.field_name}}</label>\n<md-chips class=\"label-chips close-chip\" ng-model=\"vm.currentThread_Edit[fields.titleId]\" md-autocomplete-snap \nmd-require-match=\"true\"><md-autocomplete md-min-length=\"1\" md-selected-item=\"vm.selectedContent[fields.titleId]\" \nmd-selected-item-change=\"vm.selectedContentChange(fields)\" md-search-text=\"vm.searchContentText[fields.titleId]\" \nmd-items=\"content in vm.labelQuerySearchSection(fields, vm.searchContentText[fields.titleId])\" \nmd-item-text=\"content.val\" md-no-cache=\"true\" placeholder=\"{{vm.translate(\'CONTENT.SEARCH_FOR_CONTENT\')}}\" \nng-model-options=\"{debounce: 500}\"><span md-highlight-text=\"vm.searchContentText[fields.titleId]\">{{content.val}}\n</span><md-not-found><span translate=\"CONTENT.CONTENTNOTFOUND\"></span></md-not-found></md-autocomplete>\n<md-chip-template><div class=\"md-chip-content\"><span ng-if=\"$chip.color\" class=\"color\" \nng-style=\"{\'background-color\':$chip.color}\"></span> <span>{{$chip.val}}</span></div></md-chip-template><button \nmd-chip-remove class=\"md-primary\" layout=\"row\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></button></md-chips></md-input-container><md-input-container class=\"md-block\" \nng-if=\"fields.type == \'section\'\"><label>{{fields.field_name}}</label><md-select \nng-model=\"vm.currentThread_Edit[fields.titleId]\" placeholder=\"{{vm.currentThread_Edit[fields.field_name]}}\" \nng-required=\"fields.mandatory == 1\"><md-option value=\"\">---</md-option><md-option \nng-repeat=\"sec in vm.getShowAssoc(fields)\" value=\"{{sec.id}}\">{{sec.val}}</md-option></md-select><div \nclass=\"md-errors-spacer\"></div></md-input-container><md-input-container class=\"md-block\" \nng-if=\"fields.type == \'country\'\"><label>{{fields.field_name}}</label><md-select \nng-model=\"vm.currentThread_Edit[fields.titleId]\" placeholder=\"{{vm.currentThread_Edit[fields.field_name]}}\" \nng-required=\"fields.mandatory == 1\"><md-option value=\"\">---</md-option><md-option \nng-repeat=\"sec in vm.getShowCountries(fields)\" value=\"{{sec.id}}\">{{sec.name}}</md-option></md-select><div \nclass=\"md-errors-spacer\"></div></md-input-container><div class=\"iconik-tags-editor\" ng-if=\"fields.type==\'iconik_tags\'\" \nng-init=\"vm.initIconikTags(fields)\"><label class=\"iconik-tags-label\">{{fields.field_name}}</label><div \nng-if=\"vm.iconikTagsState[fields.titleId].loading\" class=\"iconik-tags-status\" layout=\"row\" layout-align=\"start center\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" class=\"mr-8\"></md-progress-circular><span>Loading tags…\n</span></div><div ng-if=\"vm.iconikTagsState[fields.titleId].error\" class=\"iconik-tags-status iconik-tags-error\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-alert-circle\" class=\"s16 mr-8 red-fg\"></md-icon>\n<span>Could not load tags from iconik.</span></div><div ng-if=\"vm.iconikTagsState[fields.titleId].loaded\" layout=\"row\" \nlayout-wrap class=\"iconik-tags-grid\"><div ng-repeat=\"key in vm.iconikTagsState[fields.titleId].keys track by key.name\" \nflex=\"33\" class=\"iconik-tags-key-col\" \nng-class=\"{\'iconik-tags-key-off\': !vm.isIconikKeyEnabled(fields.titleId, key.name)}\"><md-checkbox \nng-checked=\"vm.isIconikKeyEnabled(fields.titleId, key.name)\" ng-click=\"vm.toggleIconikKey(fields.titleId, key)\" \naria-label=\"{{key.name}}\" class=\"iconik-tags-key-checkbox\"><span class=\"iconik-tags-key-name\">{{key.name}}</span>\n</md-checkbox><div ng-if=\"vm.isIconikKeyEnabled(fields.titleId, key.name)\" class=\"iconik-tags-controls\"><div \nclass=\"iconik-tags-selectall\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"iconik-tags-selected-count\">\n{{vm.currentThread_Edit[fields.titleId][key.name].length}} / {{key.tags.length}} selected </span><a \nclass=\"iconik-tags-toggle-all\" ng-click=\"vm.toggleAllIconikTags(fields.titleId, key)\">\n{{vm.currentThread_Edit[fields.titleId][key.name].length === key.tags.length ? \'Deselect all\' : \'Select all\'}}</a>\n</div><md-select multiple=\"multiple\" ng-model=\"vm.currentThread_Edit[fields.titleId][key.name]\" \nclass=\"iconik-tags-select\" md-on-close=\"vm.onIconikSelectClose(fields.titleId, key)\"><md-option \nng-repeat=\"tag in key.tags track by tag\" ng-value=\"tag\">{{tag}}</md-option></md-select></div></div></div></div><div \nlayout=\"column\" layout-gt-sm=\"column\" class=\"date-time-picker\" ng-if=\"fields.type==\'dateHm\' || fields.type==\'date\'\">\n<div flex><label flex layout=\"row\" layout-align=\"space-between center\"><span class=\"mr-20\" ng-bind=\"fields.field_name\">\n</span> <a class=\"md-accent text-capitalized\" hide><md-icon md-font-icon=\"icon-clock\" class=\"md-accent s16 mr-5\">\n</md-icon><strong><span translate=\"CONTENT.SET_TO_NOW\">Set to now</span></strong></a></label></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><div flex class=\"date-container\"><mdp-date-picker mdp-placeholder=\"Date\" \nmdp-format=\"{{vm.dateFormat}}\" mdp-open-on-click=\"true\" ng-model=\"vm.currentThread_Edit[fields.titleId].date\" \nng-change=\"vm.updateDatePicker(fields.titleId)\"></mdp-date-picker></div><div flex class=\"date-container\">\n<mdp-time-picker mdp-placeholder=\"Time\" mdp-auto-switch=\"true\" mdp-open-on-click=\"true\" \nng-model=\"vm.currentThread_Edit[fields.titleId].date\" ng-change=\"vm.updateDatePicker(fields.titleId)\">\n</mdp-time-picker></div><div flex class=\"date-container\"><md-input-container class=\"md-block\"><label>UTC Date</label>\n<input type=\"text\" ng-model=\"vm.currentThread_Edit[fields.titleId].utcShow\" disabled=\"disabled\"></md-input-container>\n</div></div></div><div class=\"editor-wrapper\" ng-if=\"fields.type == \'html\'\"><md-input-container flex \nclass=\"md-block md-input-has-value html\" ng-class=\"{\'required\':fields.mandatory == 1}\"><label \nng-bind=\"fields.field_name\"></label><textarea ui-tinymce=\"vm.tinymceOptions\" \nng-model=\"vm.currentThread_Edit[fields.titleId]\" aria-label=\"{{fields.titleId}}\" placeholder=\"{{fields.field_name}}\" \nng-required=\"fields.mandatory == 1\">\r\n                                </textarea></md-input-container><div \nclass=\"editor-hover-add-btn\" ng-if=\"vm.tinyHoverTop && vm.isAdmin && vm.v2editorActive\" \nng-style=\"{\r\n                                    top: vm.tinyHoverTop.top + \'px\',\r\n                                    left: vm.tinyHoverTop.left + \'px\'\r\n                                }\" \nng-mouseenter=\"vm.tinyHoverLock = true\" ng-mouseleave=\"vm.tinyHoverLock = false\" \nng-click=\"vm.openTemplateMenu(\'above\', vm.tinyHoverTop)\"><md-icon class=\"material-icons\">add</md-icon></div><div \nclass=\"editor-hover-add-btn\" ng-if=\"vm.tinyHoverBottom && vm.isAdmin && vm.v2editorActive\" \nng-style=\"{\r\n                                    top: vm.tinyHoverBottom.top + \'px\',\r\n                                    left: vm.tinyHoverBottom.left + \'px\'\r\n                                }\" \nng-mouseenter=\"vm.tinyHoverLock = true\" ng-mouseleave=\"vm.tinyHoverLock = false\" \nng-click=\"vm.openTemplateMenu(\'below\', vm.tinyHoverBottom)\"><md-icon class=\"material-icons\">add</md-icon></div><div \nclass=\"editor-template-menu\" ng-if=\"vm.tinyMenu && vm.isAdmin && vm.v2editorActive\" \nng-style=\"{\r\n                                    top: vm.tinyMenu.top + \'px\',\r\n                                    left: vm.tinyMenu.left + \'px\'\r\n                                }\" \nng-mouseenter=\"vm.tinyHoverLock = true\" ng-mouseleave=\"vm.tinyHoverLock = false\"><div \nclass=\"editor-template-menu-item\" ng-repeat=\"tpl in vm.tinyTemplates\" ng-click=\"vm.applyTemplate(tpl)\">{{ tpl.label }}\n</div></div></div></div><div class=\"tags\"><md-input-container class=\"md-block\"><label \ntranslate=\"CONTENT.SEARCH_FOR_TAG\">Tags</label><md-chips class=\"label-chips close-chip\" \nng-model=\"vm.currentThread_Edit.tags\" md-autocomplete-snap md-require-match=\"true\"><md-autocomplete md-min-length=\"3\" \nmd-selected-item=\"vm.selectedTag\" md-selected-item-change=\"vm.selectedItemChange()\" md-search-text=\"vm.searchTagText\" \nmd-items=\"tag in vm.labelQuerySearch(vm.searchTagText) | orderBy:\'-order\'\" md-item-text=\"tag.tag_name\" \nmd-no-cache=\"true\" placeholder=\"{{vm.translate(\'CONTENT.SEARCH_FOR_TAG\')}}\" ng-model-options=\"{debounce: 500}\" \nmd-dropdown-items=\"10\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\" \nclass=\"tag-not-found-bg border-bottom\"><span ng-if=\"!tag.tag_name\">{{vm.searchTagText}}</span> <span \nmd-highlight-text=\"vm.searchTagText\" ng-if=\"tag.tag_name\">{{tag.tag_name}} #{{tag.id_tag}}</span><md-buttton \nng-if=\"!tag.tag_name\" ng-click=\"vm.newTag(vm.searchTagText)\" class=\"md-accent green-500-bg white-fg md-button m-0\">\n<span translate=\"CONTENT.TAGADD\"></span></md-buttton></div><md-not-found><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"100\" class=\"tag-not-found-bg\"><span>{{vm.searchTagText}}</span><md-buttton \nng-click=\"vm.newTag(vm.searchTagText)\" class=\"md-accent green-500-bg white-fg md-button m-0\"><span \ntranslate=\"CONTENT.TAGADD\"></span></md-buttton></div></md-not-found></md-autocomplete><md-chip-template><div \nclass=\"md-chip-content\"><span ng-if=\"$chip.color\" class=\"color\" ng-style=\"{\'background-color\':$chip.color}\"></span> \n<span>{{$chip.tag_name}} #{{$chip.id_tag}}</span></div></md-chip-template><button md-chip-remove class=\"md-primary\" \nlayout=\"row\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-close\"></md-icon></button></md-chips>\n</md-input-container></div></div><div layout=\"row\"><md-list flex=\"100\" class=\"md-toolbar-tools grey-100-bg\" \nlayout=\"row\" layout-align=\"end center\"><div><md-button type=\"submit\" ng-if=\"vm.currentThread_Edit\" \nng-click=\"vm.saveItem(vm.currentThread_Edit)\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.basicForm.$invalid || vm.basicForm.$pristine\"><span aria-label=\"SAVE\" translate=\"CONTENT.SAVE\" \ntranslate-attr-aria-label=\"CONTENT.SAVE\" ng-hide=\"vm.savingProcess\">SAVE</span> <span ng-show=\"vm.savingProcess\">\nSaving...</span></md-button><md-button type=\"button\" ng-click=\"vm.closeThreadEdit()\" class=\"md-raised md-warn\" \naria-label=\"Cancel\" translate=\"CONTENT.CANCEL\"></md-button></div></md-list></div></form></div>");
$templateCache.put("app/main/apps/content/views/read/tab-expand.html","<div id=\"tab-expand\" class=\"form-wrapper mail-read-pane\" layout=\"column\" flex=\"100\"><div class=\"p-25\" layout=\"row\" \nflex layout-align=\"center center\"><md-button ng-if=\"tab.type !== \'section_data\'\" \nng-click=\"vm.openSelectContentDialog($event, tab, undefined, \'start\')\" class=\"add-event-button no-sort md-fab md-warn\" \naria-label=\"Add\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div ng-init=\"vm.sortableOpt(tab)\" \nclass=\"sortable md-list-item-text\" ng-sortable=\"vm.sortableOptions[tab.title]\"><div class=\"list-item item\" \nlayout=\"column\" flex ng-repeat=\"item in vm.getElementsSelectedByGroup(tab) track by $index\" md-no-ink ng-cloak><div \nlayout=\"row\" layout-align=\"end center\" class=\"delete-element\"><md-button \nng-click=\"vm.deleteElementInGroup($index, tab, vm.selectedGroupId)\" class=\"\" aria-label=\"Delete\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><md-input-container flex ng-repeat=\"ref in tab.raw_settings.ref\" \ntype=\"{{ref.type}}\"><ng-content ng-if=\"ref.type==\'list\'\"><label>{{ref.label}}</label><md-select name=\"{{ref.name}}\" \nng-model=\"item.template\" aria-label=\"{{ref.name}}\" tabindex=\"0\"><md-option ng-repeat=\"opt in ref.options\" \nng-value=\"vm.hasProp(opt,\'value\') ? opt.value : opt\" ng-selected=\"vm.isSelectedOption(opt, item.template)\">\n{{vm.hasProp(opt,\'name\') ? opt.name : opt}}</md-option></md-select></ng-content><ng-content \nng-if=\"ref.type==\'single\' && item.template.id != 5\"><label for=\"ref.name\">{{ref.label}}</label><input \nclass=\"single-template\" type=\"text\" ng-model=\"item.subtitle\" name=\"ref.name\"></ng-content><ng-content \nng-if=\"ref.type==\'text\' && item.template.id != 5\"><label for=\"ref.name\">{{ref.label}}</label><textarea \nui-tinymce=\"vm.tinymceOptions\" ng-model=\"item.text\" name=\"ref.name\"></textarea></ng-content><ng-content \nng-if=\"ref.type==\'media\' && item.template.id != 1 && item.template.id != 4\"><div class=\"attachments\" \nng-include=\"\'app/main/apps/content/views/list/subviews/photos-view.html\'\"></div><div \nng-if=\"!item.media || item.media[0] == null\"><md-button ng-click=\"vm.selectMedia($event, item)\" \nclass=\"add-event-button no-sort md-fab md-warn\" aria-label=\"Add\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n</md-button></div></ng-content><ng-content ng-if=\"ref.type===\'templates\'\"><div id=\"template_expand_view\"><span \nclass=\"template_name\">{{item.template.name}}</span><div ng-bind-html=\"vm.createExpandTemplate(ref, item)\"></div></div>\n</ng-content></md-input-container></div></div><div class=\"p-25 pb-75\" layout=\"row\" flex layout-align=\"center center\">\n<md-button ng-if=\"tab.type !== \'section_data\'\" ng-click=\"vm.openSelectContentDialog($event, tab, undefined, \'end\')\" \nclass=\"add-event-button no-sort md-fab md-warn\" aria-label=\"Add\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n</md-button></div></div>");
$templateCache.put("app/main/apps/content/views/read/tab-grouped.html","<div id=\"tab-grouped\" class=\"form-wrapper\" layout=\"column\" flex=\"100\"><md-input-container \nng-if=\"tab.raw_settings.fromSectionGroup\" class=\"ph-25\" flex><md-select \nng-init=\"vm.selectedGroupId = vm[\'tab_\' + tab.raw_settings.fromSectionGroup + \'_data\'][0][tab.raw_settings.fromSectionGroupId]\" \nng-model=\"vm.selectedGroupId\"><md-option \nng-repeat=\"option in vm[\'tab_\' + tab.raw_settings.fromSectionGroup + \'_data\'] track by $index\" \nvalue=\"{{option[tab.raw_settings.fromSectionGroupId]}}\">{{option[tab.raw_settings.showFieldGroup]}}</md-option>\n</md-select></md-input-container><div ng-if=\"tab.titleId != \'multiple_texts\'\" class=\"ph-25\" layout=\"row\" flex \nlayout-align=\"end center\"><md-button ng-if=\"tab.type !== \'section_data\'\" \nng-click=\"vm.openSelectContentDialog($event, tab)\" class=\"add-event-button no-sort md-fab md-warn\" aria-label=\"Add\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div ng-if=\"tab.titleId == \'multiple_texts\'\" \nclass=\"ph-25\" layout=\"row\" flex layout-align=\"center center\"><div flex layout=\"column\" layout-align=\"center center\">\n<md-button ng-if=\"vm.isAdmin\" ng-click=\"vm.openWebEditor($event)\" lass=\"send-button md-accent md-raised\" \naria-label=\"Web edit\">Web Editor</md-button><md-button ng-if=\"tab.type !== \'section_data\'\" \nng-click=\"vm.openSelectContentDialog($event, tab, undefined, \'start\')\" class=\"add-event-button no-sort md-fab md-warn\" \naria-label=\"Add\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div><div \nng-init=\"vm.sortableOpt(tab)\" class=\"sortable md-list-item-text\" ng-sortable=\"vm.sortableOptions[tab.title]\"><div \nclass=\"list-item item\" layout=\"row\" flex ng-repeat=\"item in vm.getElementsSelectedByGroup(tab) track by $index\" \nmd-no-ink ng-cloak ng-style=\"{\'border-bottom\': vm.calcColumns($index, tab) ? \'1px dashed red\' : \'1px solid #dcdcdc\'}\">\n<div \nng-if=\"tab.type !== \'section_data\' && tab.titleId !== \'users_groups_permissions\' && tab.titleId !== \'users_permissions\'\" \nclass=\"handle ml-8 mr-8\" ng-click=\"vm.preventDefault($event)\" layout=\"row\" layout-align=\"center center\"><md-icon \nmd-font-icon=\"icon-drag-vertical\" class=\"icon\"></md-icon></div><div ng-if=\"tab.titleId != \'multiple_texts\'\" \nlayout=\"row\" flex layout-align=\"start center\"><media ng-if=\"item.Thumbnail && item.Thumbnail.length > 0\" \nattachment=\"item.Thumbnail[0]\" thumbnail=\"true\" class=\"avatar\"></media><img \nng-if=\"item.media && tab.type === \'json-from-raw\' && vm.isArray(item.media)\" class=\"avatar\" \nng-src=\"{{vm.getThumbSrcFromMedia(item.media[0])}}\" alt=\"\" imageonload> <img \nng-if=\"item.media && tab.type !== \'json-from-raw\'\" class=\"avatar\" ng-src=\"{{item.media}}\" alt=\"\"><div \nng-if=\"!item.group_type.icon\"><md-icon ng-if=\"!item.children && item.id_group_type == 1\" \nclass=\"{{item.color}}-fg s24 mr-10 mt-0 ml-0 mb-0\" md-font-icon=\"icon-folder\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"item.children && item.id_group_type == 1\" class=\"{{item.color}}-fg s24 mr-10 mt-0 ml-0 mb-0\" \nmd-font-icon=\"icon-folder-multiple\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"!item.children && item.id_group_type == 2\" class=\"{{item.color}}-fg s24 mr-10 mt-0 ml-0 mb-0\" \nmd-font-icon=\"qiu-icon-file-usermailing\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"item.children && item.id_group_type == 2\" class=\"{{item.color}}-fg s24 mr-10 mt-0 ml-0 mb-0\" \nmd-svg-src=\"/assets/icons/svg/icon-folder-mail-multiple.svg\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"!item.children && item.id_group_type == 3\" class=\"{{item.color}}-fg s24 mr-10 mt-0 ml-0 mb-0\" \nmd-font-icon=\"qiu-icon-file-usermediacenter\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"item.children && item.id_group_type == 3\" class=\"{{item.color}}-fg s24 mr-10 mt-0 ml-0 mb-0\" \nmd-svg-src=\"/assets/icons/svg/icon-folder-play-multiple.svg\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"!item.children && item.id_group_type == 4\" class=\"{{item.color}}-fg s24 mr-10 mt-0 ml-0 mb-0\" \nmd-font-icon=\"qiu-icon-file-usersegment\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"item.children && item.id_group_type == 4\" class=\"{{item.color}}-fg s24 mr-10 mt-0 ml-0 mb-0\" \nmd-svg-src=\"/assets/icons/svg/icon-folder-share-multiple.svg\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"!item.children && item.id_group_type == 5\" class=\"{{item.color}}-fg s24 mr-10 mt-0 ml-0 mb-0\" \nmd-font-icon=\"qiu-icon-file-userstore\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"item.children && item.id_group_type == 5\" class=\"{{item.color}}-fg s24 mr-10 mt-0 ml-0 mb-0\" \nmd-svg-src=\"/assets/icons/svg/icon-folder-shop-multiple.svg\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"!item.children && item.id_group_type == 6\" class=\"{{item.color}}-fg s24 mr-10 mt-0 ml-0 mb-0\" \nmd-font-icon=\"qiu-icon-file-useracreditation\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"item.children && item.id_group_type == 6\" class=\"{{item.color}}-fg s24 mr-10 mt-0 ml-0 mb-0\" \nmd-svg-src=\"/assets/icons/svg/icon-folder-board-multiple.svg\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"!item.children && item.id_group_type == 7\" class=\"{{item.color}}-fg s24 mr-10 mt-0 ml-0 mb-0\" \nmd-svg-src=\"/assets/icons/svg/icon-folder-chat.svg\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"item.children && item.id_group_type == 7\" class=\"{{item.color}}-fg s24 mr-10 mt-0 ml-0 mb-0\" \nmd-svg-src=\"/assets/icons/svg/icon-folder-chat-multiple.svg\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"!item.children && item.id_group_type == 8\" class=\"{{item.color}}-fg s24 mr-10 mt-0 ml-0 mb-0\" \nmd-font-icon=\"icon-folder-remove\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"item.children && item.id_group_type == 8\" class=\"{{item.color}}-fg s24 mr-10 mt-0 ml-0 mb-0\" \nmd-font-icon=\"icon-folder-multiple\" aria-hidden=\"true\"></md-icon></div><span \nng-if=\"tab.title == \'users_groups_permissions\'\"><span class=\"grey-500-fg\">#{{item.id_group}}</span> <span \nclass=\"ml-25\">{{item.name}}</span> </span><span ng-if=\"tab.title == \'users_permissions\'\"><span class=\"grey-500-fg\">\n#{{item.id}}</span> <span class=\"ml-25\">{{item.email}}</span> </span><span \nng-if=\"tab.title != \'users_groups_permissions\' && tab.title != \'users_permissions\'\" layout=\"column\"><span \nclass=\"grey-500-fg\" ng-if=\"tab.raw_settings.fromSectionId && item[tab.raw_settings.fromSectionId]\">\n#{{item[tab.raw_settings.fromSectionId]}}</span> <span \nng-bind-html=\"vm.searchShowFields(item, tab.raw_settings.showField)\" class=\"ml-25\"></span> <span class=\"ml-25\">\n{{item.template.name}}</span> </span><span ng-if=\"tab.type === \'json-construct\'\"><span \nng-repeat=\"field in tab.raw_settings.fields\" ng-if=\"field.show_list\">{{item[field.label]}}</span></span></div><div \nid=\"multiple_texts_edit_container\" ng-if=\"tab.titleId == \'multiple_texts\'\" layout=\"row\" flex \nlayout-align=\"start center\"><div class=\"img-container\"><img \nng-if=\"item.media && tab.type === \'json-from-raw\' && vm.isArray(item.media) && item.media.length > 0\" class=\"avatar\" \nng-src=\"{{vm.getThumbSrcFromMedia(item.media[0])}}\" alt=\"\" imageonload></div><div class=\"title-container\" layout=\"row\" \nflex layout-align=\"space-between\"><div layout=\"column\" flex layout-align=\"center start\"><h3 \nng-if=\"item.internal_identifier\" class=\"text-bold\">{{item.internal_identifier}}</h3><h3 ng-if=\"item.title\" \nclass=\"text-semibold\">{{item.title}}</h3><h4 ng-if=\"item.subtitle\" class=\"text-semibold\">{{item.subtitle}}</h4><span \nng-if=\"item.text\" ng-bind-html=\"item.text\"></span> <span ng-if=\"item.label\">{{item.label}}</span> <a ng-if=\"item.link\" \ntarget=\"_blank\" ng-href=\"{{item.link}}\">{{item.link}}</a></div><div flex layout=\"column\" layout-align=\"center end\" \nclass=\"gap-10\"><span class=\"template_name\">{{item.template.name}}</span> <span ng-if=\"item.columns\" \nclass=\"template_name\">{{ vm.getColumns(item) }}</span></div></div></div><div layout=\"row\" layout-align=\"end center\" \nclass=\"case-menu-none\"><md-menu><md-button class=\"md-icon-button\" aria-label=\"More\" \nng-click=\"vm.openMenu($mdMenu, $event)\"><md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/more_vert.svg\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item \nng-if=\"tab.type === \'json-from-raw\' || tab.type === \'json-construct\'\"><md-button \nng-click=\"vm.openSelectContentDialog($index, tab, $index);\" aria-label=\"Edit\"><md-icon md-font-icon=\"icon-pencil\">\n</md-icon><span translate=\"GLOBAL.EDIT\"></span></md-button></md-menu-item><md-menu-item><md-button \nng-if=\"tab.type !== \'section_data\'\" ng-click=\"vm.deleteElementInGroup($index, tab, vm.selectedGroupId);\" \naria-label=\"Delete\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span translate=\"GLOBAL.DELETE\"></span></md-button>\n<md-button ng-if=\"tab.type === \'section_data\'\" \nng-click=\"vm.deleteElementInGroup(item[tab.raw_settings.fromSectionId], tab);\" aria-label=\"Delete\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><span translate=\"GLOBAL.DELETE\"></span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></div></div><div ng-if=\"tab.titleId == \'multiple_texts\'\" \nclass=\"pl-25 pr-25 pt-50 pb-50\" layout=\"row\" flex layout-align=\"center center\"><md-button \nng-if=\"tab.type !== \'section_data\'\" ng-click=\"vm.openSelectContentDialog($event, tab, undefined, \'end\')\" \nclass=\"add-event-button no-sort md-fab md-warn\" aria-label=\"Add\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n</md-button></div></div>");
$templateCache.put("app/main/apps/content/views/read/tab-media.html","<md-list-item ng-repeat=\"mediazone in vm.mediaZones\" ng-if=\"vm.mediaZones\" \nngf-drop=\"vm.onFilesDrop($files, mediazone)\" ngf-select ngf-multiple=\"true\" ngf-drag-over-class=\"\'dragover\'\" \nngf-multiple=\"false\" accept=\"{{vm.allowedFilesPattern}}\" ngf-pattern=\"vm.allowedFilesPattern\" \nclass=\"drop-box list-media-item attachment-edit\"><div class=\"attachments\"><div class=\"field\"><p \nclass=\"grey-500-fg ml-8\">{{ mediazone.title }}</p><div class=\"attachment-list sortable md-list-item-text\" \nng-sortable=\"vm.mediaSortable\"><div class=\"attachment\" layout=\"column\" \nng-repeat=\"attachment in vm.thumbnails_Edit[mediazone.id_zone]\"><div \nng-if=\"attachment.media_type==1 || attachment.media_type==2 || attachment.media_type==4 || attachment.media_type==3 \">\n<div class=\"ms-card\" flex md-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"ms-card-content-wrapper\"><div \nclass=\"template-9\"><div class=\"media\" layout=\"row\" layout-align=\"center center\" \nextension-class=\"{{attachment.filename}}\" ng-href=\"{{attachment.permalink}}\" ng-if=\"attachment.media_type==3\" \ntarget=\"_blank\"><qiu-icon mediafile=\"attachment.filename\" class=\"mr-10\"></qiu-icon></div><div class=\"media\" flex \nlayout=\"row\" layout-align=\"center center\" ng-if=\"attachment.media_type==1 || attachment.media_type==2\"><media \nattachment=\"attachment\" class-img=\"image\" \nng-click=\"vm.openImageDialog($event, vm.currentThread_Edit.Thumbnail, attachment)\"></media></div><div flex \nlayout=\"column\" layout-align=\"center center\" class=\"media\" ng-if=\"attachment.media_type==4\"><qiu-icon \nmediafile=\"attachment.filename\" classextra=\"s56\"></qiu-icon><br><span class=\"grey-500-fg\" layout=\"column\" \nlayout-align=\"center center\"><span ng-if=\"attachment.title\"><strong>{{attachment.title}}</strong></span> <span \nng-if=\"attachment.filename\">{{attachment.filename}}</span></span></div><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"size block mr-5\" layout=\"row\" layout-align=\"start center\"><strong \nclass=\"mb-5 block\">#{{attachment.id_media}}</strong> <span class=\"grey-500-fg\" \nng-if=\"attachment.media_type==1 || attachment.media_type==2 || attachment.media_type==3\"><span \nng-if=\"attachment.title && !attachment.filename\" class=\"word-break-all\">{{attachment.title}}</span> <span \nng-if=\"attachment.filename && !attachment.title\" class=\"word-break-all\">{{attachment.filename}}</span></span></div>\n<md-menu><button class=\"md-icon-button\" aria-label=\"More\" translate translate-attr-aria-label=\"TODO.MORE\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" ng-click=\"$mdMenu.open($event)\"></md-icon></button><md-menu-content width=\"3\" \nclass=\"media-options-menu\"><md-menu-item><md-button ng-if=\"attachment.media_type==1 || attachment.media_type==2\" \nng-click=\"vm.openImageDialog($event, vm.currentThread_Edit.Thumbnail, attachment)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.PREVIEW\"><md-icon md-font-icon=\"icon-eye\" class=\"ml-10\" href=\"#\" \nng-click=\"vm.openImageDialog($event, vm.selectedMail.Thumbnail, attachment)\"></md-icon><span \ntranslate=\"CONTENT.PREVIEW\">Preview</span></md-button><md-button ng-if=\"attachment.media_type==4\" \nng-click=\"vm.openUrl(attachment.permalink)\" target=\"_blank\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.PREVIEW\"><md-icon md-font-icon=\"icon-open-in-new\" class=\"ml-10\"></md-icon><span \ntranslate=\"MEDIA.OPEN\"></span></md-button></md-menu-item><md-menu-item ng-if=\"attachment.media_type==1\"><md-button \nng-click=\"vm.openFocalPoint($event, attachment)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.SET_FOCAL_POINT\"><md-icon md-font-icon=\"icon-image-filter-center-focus\" class=\"s18\">\n</md-icon><span translate=\"MEDIA.SET_FOCAL_POINT\"></span></md-button></md-menu-item><md-menu-item \nng-if=\"attachment.media_type==1\"><md-button ng-click=\"vm.openMediaItemMetadata($event, attachment)\" \naria-label=\"Toggle done\" translate-attr-aria-label=\"CONTENT.MEDIA_ITEM_EDIT_METADATA\"><md-icon \nmd-font-icon=\"icon-message-image\" class=\"s18\"></md-icon><span translate=\"MEDIA.MEDIA_ITEM_EDIT_METADATA\"></span>\n</md-button></md-menu-item><md-menu-item ng-if=\"attachment.media_type==1\"><md-button \nng-click=\"vm.MediaItemRecrop(attachment)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.MEDIA_ITEM_RECROP\"><md-icon md-font-icon=\"icon-image\" class=\"s18\"></md-icon><span \ntranslate=\"MEDIA.MEDIA_ITEM_RECROP\"></span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.downloadMediaOriginal(attachment)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.DOWNLOAD_ORIGINAL\"><md-icon md-font-icon=\"icon-image\" class=\"s18\"></md-icon><span \ntranslate=\"MEDIA.DOWNLOAD_ORIGINAL\"></span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.copyMediaLink(attachment)\" aria-label=\"Toggle done\" translate-attr-aria-label=\"MEDIA.COPY_LINK_BEST_CROP\">\n<md-icon md-font-icon=\"icon-link\" class=\"s18\"></md-icon><span translate=\"MEDIA.COPY_LINK_BEST_CROP\"></span></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.deleteAttachment(attachment)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.REMOVE\"><md-icon md-font-icon=\"icon-close\" class=\"s18\"></md-icon><span \ntranslate=\"MEDIA.REMOVE\"></span></md-button></md-menu-item></md-menu-content></md-menu></div></div></div></div></div>\n<div ng-if=\"attachment.id_gallery\"><div class=\"ms-card\" flex md-dynamic-height=\"{{vm.dynamicHeight}}\"><div \nclass=\"ms-card-content-wrapper\"><div class=\"template-9\"><div flex layout=\"column\" layout-align=\"center center\" \nclass=\"media\"><md-icon class=\"s56 mr-5 ml-10\" md-font-icon=\"icon-folder-multiple-image\"></md-icon><br><span \nclass=\"grey-500-fg\" layout=\"column\" layout-align=\"center center\"><span ng-if=\"attachment.gallery_name\"><strong>\n{{attachment.gallery_name}}</strong></span></span></div><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"size block\" layout=\"row\" layout-align=\"start center\"><strong \nclass=\"mr-5\">#{{attachment.id_gallery}}</strong> <span class=\"grey-500-fg\">{{attachment.gallery_name}}</span></div>\n<md-menu><button class=\"md-icon-button\" aria-label=\"More\" translate translate-attr-aria-label=\"TODO.MORE\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" ng-click=\"$mdMenu.open($event)\"></md-icon></button><md-menu-content width=\"3\">\n<md-menu-item><md-button ng-click=\"vm.deleteAttachment(attachment)\" aria-label=\"Delete gallery\" \ntranslate-attr-aria-label=\"CONTENT.REMOVE\"><md-icon md-font-icon=\"icon-close\" class=\"s18\"></md-icon><span \ntranslate=\"MEDIA.REMOVE\"></span></md-button></md-menu-item></md-menu-content></md-menu></div></div></div></div></div>\n</div></div><md-button class=\"add-event-button no-sort md-fab md-warn\" \nng-click=\"vm.mediaDialog($event, mediazone, vm.currentThread_Edit, [])\" aria-label=\"Add\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div></div><md-divider></md-divider></md-list-item><md-list-item \nng-right-click=\"vm.selectOrUnselect(null, $event)\" class=\"list-media-item attachment-edit\"><div class=\"attachments\">\n<div class=\"field\"><p class=\"grey-500-fg\" translate=\"CONTENT.NO_ZONE\"></p><div \nclass=\"attachment-list md-list-item-text\" layout=\"row\" layout-wrap=\"\" layout-align=\"start start\" \nng-sortable=\"vm.mediaSortable\"><div class=\"attachment\" layout=\"column\" \nng-repeat=\"attachment in vm.thumbnails_Edit[vm.NO_ZONE_KEY]\"><div \nng-if=\"attachment.media_type==1 || attachment.media_type==2 || attachment.media_type==4 || attachment.media_type==3\">\n<div class=\"ms-card\" flex md-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"ms-card-content-wrapper\"><div \nclass=\"template-9\"><div class=\"media\" flex layout=\"row\" layout-align=\"center center\" \nng-if=\"attachment.media_type==1 || attachment.media_type==2\"><media attachment=\"attachment\" class-img=\"image\" \nng-click=\"vm.openImageDialog($event, vm.currentThread_Edit.Thumbnail, attachment)\"></media></div><div class=\"media\" \nlayout=\"row\" layout-align=\"center center\" extension-class=\"{{attachment.filename}}\" ng-href=\"{{attachment.permalink}}\" \nng-if=\"attachment.media_type==3\" target=\"_blank\"><qiu-icon mediafile=\"attachment.filename\" class=\"mr-10\"></qiu-icon>\n</div><div flex layout=\"column\" layout-align=\"center center\" class=\"media\" ng-if=\"attachment.media_type==4\"><qiu-icon \nmediafile=\"attachment.filename\" classextra=\"s56\"></qiu-icon><br><span class=\"grey-500-fg\" layout=\"column\" \nlayout-align=\"center center\"><span ng-if=\"attachment.title\"><strong>{{attachment.title}}</strong></span> <span \nng-if=\"attachment.filename\">{{attachment.filename}}</span></span></div><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"size block mr-5\" layout=\"row\" layout-align=\"start center\" \nng-if=\"attachment.media_type\"><strong class=\"mb-5 block\">#{{attachment.id_media}}</strong> <span \nclass=\"grey-500-fg word-break-all\">{{attachment.filename}}</span></div><md-menu><button class=\"md-icon-button\" \naria-label=\"More\" translate translate-attr-aria-label=\"TODO.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\" \nng-click=\"$mdMenu.open($event)\"></md-icon></button><md-menu-content width=\"3\" class=\"media-options-menu\"><md-menu-item>\n<md-button ng-click=\"vm.openImageDialog($event, vm.currentThread_Edit.Thumbnail, attachment)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.PREVIEW\"><md-icon md-font-icon=\"icon-eye\" class=\"s16 ml-10\" href=\"#\" \nng-click=\"vm.openImageDialog($event, vm.selectedMail.Thumbnail, attachment)\"></md-icon><span translate=\"MEDIA.PREVIEW\">\n</span></md-button></md-menu-item><md-menu-item ng-if=\"attachment.media_type==1\"><md-button \nng-click=\"vm.openFocalPoint($event, attachment)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.SET_FOCAL_POINT\"><md-icon md-font-icon=\"icon-image-filter-center-focus\" class=\"s18\">\n</md-icon><span translate=\"MEDIA.SET_FOCAL_POINT\"></span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.openMediaItemMetadata($event, attachment)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.MEDIA_ITEM_EDIT_METADATA\"><md-icon md-font-icon=\"icon-message-image\" class=\"s18\">\n</md-icon><span translate=\"MEDIA.MEDIA_ITEM_EDIT_METADATA\"></span></md-button></md-menu-item><md-menu-item \nng-if=\"attachment.media_type==1\"><md-button ng-click=\"vm.MediaItemRecrop(attachment)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.MEDIA_ITEM_RECROP\"><md-icon md-font-icon=\"icon-image\" class=\"s18\"></md-icon><span \ntranslate=\"MEDIA.MEDIA_ITEM_RECROP\"></span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.downloadMediaOriginal(attachment)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.DOWNLOAD_ORIGINAL\"><md-icon md-font-icon=\"icon-image\" class=\"s18\"></md-icon><span \ntranslate=\"MEDIA.DOWNLOAD_ORIGINAL\"></span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.copyMediaLink(attachment)\" aria-label=\"Toggle done\" translate-attr-aria-label=\"MEDIA.COPY_LINK_BEST_CROP\">\n<md-icon md-font-icon=\"icon-link\" class=\"s18\"></md-icon><span translate=\"MEDIA.COPY_LINK_BEST_CROP\"></span></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.deleteAttachment(attachment)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.REMOVE\"><md-icon md-font-icon=\"icon-close\" class=\"s18\"></md-icon><span \ntranslate=\"MEDIA.REMOVE\"></span></md-button></md-menu-item></md-menu-content></md-menu></div></div></div></div></div>\n<div ng-if=\"attachment.id_gallery\"><div class=\"ms-card\" flex md-dynamic-height=\"{{vm.dynamicHeight}}\"><div \nclass=\"ms-card-content-wrapper\"><div class=\"template-9\"><div flex layout=\"column\" layout-align=\"center center\" \nclass=\"media\"><md-icon class=\"s56 mr-5 ml-10\" md-font-icon=\"icon-folder-multiple-image\"></md-icon><br><span \nclass=\"grey-500-fg\" layout=\"column\" layout-align=\"center center\"><span ng-if=\"attachment.gallery_name\"><strong>\n{{attachment.gallery_name}}</strong></span></span></div><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"size block mr-5\" layout=\"row\" layout-align=\"start center\"><strong \nclass=\"mr-5\">#{{attachment.id_gallery}}</strong> <span class=\"grey-500-fg\">{{attachement.gallery_name}}</span></div>\n<md-menu><button class=\"md-icon-button\" aria-label=\"More\" translate translate-attr-aria-label=\"TODO.MORE\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" ng-click=\"$mdMenu.open($event)\"></md-icon></button><md-menu-content width=\"3\">\n<md-menu-item><md-button ng-click=\"vm.deleteAttachment(attachment)\" aria-label=\"Delete gallery\" \ntranslate-attr-aria-label=\"CONTENT.REMOVE\"><md-icon md-font-icon=\"icon-close\" class=\"s18\"></md-icon><span \ntranslate=\"MEDIA.REMOVE\"></span></md-button></md-menu-item></md-menu-content></md-menu></div></div></div></div></div>\n</div></div><md-button class=\"add-event-button md-fab md-warn\" \nng-click=\"vm.mediaDialog($event, \'\', vm.currentThread_Edit)\" aria-label=\"Add\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon></md-button></div></div><md-divider></md-divider></md-list-item>");
$templateCache.put("app/main/apps/content/views/read/tab-read-grouped.html","<div id=\"tab-grouped\" class=\"form-wrapper\" layout=\"column\" flex=\"100\"><md-input-container \nng-if=\"tab.raw_settings.fromSectionGroup\" class=\"ph-25\" flex><md-select \nng-init=\"vm.selectedGroupId = vm[\'tab_\' + tab.raw_settings.fromSectionGroup + \'_data\'][0][tab.raw_settings.fromSectionGroupId]\" \nng-model=\"vm.selectedGroupId\"><md-option \nng-repeat=\"option in vm[\'tab_\' + tab.raw_settings.fromSectionGroup + \'_data\'] track by $index\" \nvalue=\"{{option[tab.raw_settings.fromSectionGroupId]}}\">{{option[tab.raw_settings.showFieldGroup]}}</md-option>\n</md-select></md-input-container><div><div ng-init=\"vm.sortableOpt(tab)\" class=\"sortable md-list-item-text\" \nng-sortable=\"vm.sortableOptions[tab.title]\"><div class=\"list-item item\" layout=\"row\" flex \nng-repeat=\"item in vm.getElementsSelectedByGroup(tab) track by $index\" md-no-ink ng-cloak><div layout=\"row\" flex \nlayout-align=\"start center\"><media ng-if=\"item.Thumbnail && item.Thumbnail.length > 0\" attachment=\"item.Thumbnail[0]\" \nthumbnail=\"true\" class=\"avatar\"></media><img ng-if=\"item.media\" class=\"avatar\" ng-src=\"{{item.media}}\" alt=\"\"> <img \nng-if=\"!item.media && (!item.Thumbnail || item.Thumbnail.length == 0)\" class=\"avatar\" \nng-src=\"assets/images/common/no_image_available_10.png\" imageonload> <span class=\"grey-500-fg\">\n#{{item[tab.raw_settings.fromSectionId]}}</span> <span class=\"ml-25\">{{item[tab.raw_settings.showField]}}</span></div>\n</div></div></div></div>");
$templateCache.put("app/main/apps/content/views/read/tab-read.html","<div class=\"file-details scrollable\" ms-scroll=\"vm.msScrollOptions\"><share-card-editor \nng-if=\"section === \'share_card_designs\'\" readonly=\"readonly\" record=\"vm.selectedContent\"></share-card-editor><md-list>\n<md-list-item class=\"info\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start start\"><div \nng-repeat=\"field in vm.selectedContent_refgrouped.header | orderBy:\'preview_sort\' \" class=\"header-element\" \nlayout=\"row\" layout-align=\"center center\"><div><span ng-if=\"field.type==\'id\'\"><span class=\"grey-500-fg\">ID # </span>\n<span ng-bind=\"vm.selectedContent[field.titleId]\"></span> </span><span ng-if=\"field.type==\'onoff\'\"><button \nclass=\"md-icon-button\" ng-if=\"vm.selectedContent[field.titleId] === 1\"><md-icon class=\"on green-fg s24\" \nmd-font-icon=\"icon-checkbox-marked-circle\"></md-icon></button> <button class=\"md-icon-button\" \nng-if=\"vm.selectedContent[field.titleId] !== 1\"><md-icon class=\"off red-fg s24\" \nmd-font-icon=\"icon-checkbox-blank-circle-outline\"></md-icon></button> </span><span \nng-if=\"field.type==\'dateHm\' || field.type==\'date\'\"><span>{{vm.selectedContent[field.titleId].dateShow}}</span> </span>\n<span ng-if=\"field.type==\'language\'\" layout=\"row\" layout-align=\"center center\"><img class=\"img-flag ng-scope\" \nalt=\"{{vm.siteLanguages(vm.selectedContent[field.titleId])[lang_name]}}\" \nng-src=\"assets/images/flags/{{vm.siteLanguages()[vm.selectedContent[field.titleId]].flag_code|lowercase}}.svg\"> </span>\n<span ng-if=\"field.type==\'id_subsec\' && vm.selectedContent[field.titleId].length!=0\"><span class=\"grey-500-fg\">\n{{field.field_name}} </span><span \nng-bind=\"vm.getReferencesSections(\'subsection\', field.type, vm.selectedContent[field.titleId])\"></span> </span><span \nng-if=\"field.type==\'id_cat\' && vm.selectedContent[field.titleId].length!=0\"><span class=\"grey-500-fg\">\n{{field.field_name}} </span><span \nng-bind=\"vm.getReferencesSections(\'cat\', field.type, vm.selectedContent[field.titleId])\"></span> </span><span \nng-if=\"field.type==\'id_subcat\' && vm.selectedContent[field.titleId].length!=0\"><span class=\"grey-500-fg\">\n{{field.field_name}} </span><span \nng-bind=\"vm.getReferencesSections(\'subcat\', field.type, vm.selectedContent[field.titleId])\"></span> </span><span \nng-if=\"field.type == \'nume\' || field.type == \'single\'\"><span class=\"grey-500-fg\">\n{{field.field_name}}: {{vm.selectedContent[field.titleId]}}</span></span></div></div></div></md-list-item><md-list-item\n ng-repeat=\"field in vm.selectedContent_refgrouped.main | orderBy:\'preview_sort\' \"><div><h1 class=\"name\"><strong \nng-bind=\"vm.selectedContent[field.titleId]\" ng-if=\"field.type != \'section\'\"></strong> <strong \nng-bind=\"vm.showAssoc(vm.selectedContent[field.titleId], field)\" ng-if=\"field.type == \'section\'\"></strong></h1>\n<md-divider></md-divider></div></md-list-item><div \nng-repeat=\"field in vm.selectedContent_refgrouped.secondary | orderBy:\'preview_sort\' \"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg\" ng-if=\"field.type==\'label\'\"><h3 class=\"grey-700-fg\" ng-bind=\"field.field_name\">\n</h3><md-divider></md-divider></md-list-item><md-list-item flex=\"100\" ng-if=\"field.type!==\'label\'\" ng-switch=\"\" \non=\"field.type\"><div class=\"text-truncate flex-100\" ng-switch-when=\"html\"><div class=\"field\"><p \nclass=\"grey-500-fg font-size-14\" ng-bind=\"field.field_name\"></p><span class=\"font-size-16 text-truncate\" \nng-bind-html=\"vm.processHtml(vm.selectedContent[field.titleId])\"></span><br></div><md-divider></md-divider></div><div \nclass=\"text-truncate\" ng-switch-when=\"status\"><div class=\"field\"><p class=\"grey-500-fg font-size-14\" \nng-bind=\"field.field_name\"></p><span class=\"font-size-16 text-truncate {{vm.selectedContent[field.titleId]|yesNo}}\" \nng-bind-html=\"vm.selectedContent[field.titleId]|yesNo\"></span><br></div><md-divider></md-divider></div><div \nclass=\"text-truncate\" flex=\"100\" ng-switch-default=\"\"><div class=\"field\"><p class=\"grey-500-fg font-size-14\" \nng-bind=\"field.field_name\"></p><span \nng-if=\"field.category!=\'input_related\' && vm.isNumber(vm.selectedContent[field.titleId])\" \nclass=\"font-size-16 text-truncate\" ng-bind-html=\"vm.selectedContent[field.titleId]\"></span> <span \nng-if=\"field.category!=\'input_related\' && !vm.isNumber(vm.selectedContent[field.titleId])\" \nclass=\"font-size-16 text-truncate\" ng-bind-html=\"vm.selectedContent[field.titleId]| autoLinkerFilter\"></span> <span \nng-if=\"field.category==\'input_related\'\" class=\"font-size-16 text-truncate\">\n{{vm.getInArray(\'id_\'+field.config,field.values, vm.selectedContent[field.titleId], field.config)}}</span><br></div>\n<md-divider></md-divider></div><div class=\"text-truncate\" ng-switch-when=\"section\"><div class=\"field\"><p \nclass=\"grey-500-fg font-size-14\" ng-bind=\"field.field_name\"></p><span class=\"font-size-16 text-truncate\" \nng-bind=\"vm.showAssoc(vm.selectedContent[field.titleId], field)\"></span><br></div><md-divider></md-divider></div><div \nclass=\"text-truncate\" ng-switch-when=\"country\"><div class=\"field\"><p class=\"grey-500-fg font-size-14\" \nng-bind=\"field.field_name\"></p><span class=\"font-size-16 text-truncate\" \nng-bind=\"vm.showCountry(vm.selectedContent[field.titleId], field)\"></span><br></div><md-divider></md-divider></div><div\n class=\"text-truncate\" ng-switch-when=\"id_subsec\"><div class=\"field\"><p class=\"grey-500-fg font-size-14\" \nng-bind=\"field.field_name\"></p><span class=\"font-size-16 text-truncate\" \nng-bind=\"vm.getReferencesSections(\'subsection\', field.type, vm.selectedContent[field.titleId])\"></span><br></div>\n<md-divider></md-divider></div><div class=\"text-truncate\" ng-switch-when=\"id_cat\"><div class=\"field\"><p \nclass=\"grey-500-fg font-size-14\" ng-bind=\"field.field_name\"></p><span class=\"font-size-16 text-truncate\" \nng-bind=\"vm.getReferencesSections(\'cat\', field.type, vm.selectedContent[field.titleId])\"></span><br></div><md-divider>\n</md-divider></div><div class=\"text-truncate\" ng-switch-when=\"id_subcat\"><div class=\"field\"><p \nclass=\"grey-500-fg font-size-14\" ng-bind=\"field.field_name\"></p><span class=\"font-size-16 text-truncate\" \nng-bind=\"vm.getReferencesSections(\'subcat\', field.type, vm.selectedContent[field.titleId])\"></span><br></div>\n<md-divider></md-divider></div></md-list-item></div><div ng-if=\"vm.selectedContent.Thumbnail\"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg\"><h3 class=\"grey-700-fg\" translate=\"CONTENT.ATTACHMENTS\"><span \ntranslate=\"ATTACHMENTS\"></span> ({{vm.selectedContent.Thumbnail.length}})</h3><md-divider></md-divider></md-list-item>\n<md-list-item ng-repeat=\"mediazone in vm.mediaZones\" ng-if=\"vm.mediaZones\"><div class=\"attachments\"><div class=\"field\">\n<p class=\"grey-500-fg font-size-14\">{{ mediazone.title }}</p><div class=\"attachment-list md-list-item-text\" \nlayout=\"row\" layout-wrap=\"\" layout-align=\"start start\"><div class=\"attachment\" \nng-repeat=\"attachment in vm.selectedContent.Thumbnail | filter: { id_zone: mediazone.id_zone }\"><div \nng-hide=\"attachment.id_gallery\"><div class=\"ms-card\" flex md-dynamic-height=\"{{vm.dynamicHeight}}\"><div \nclass=\"ms-card-content-wrapper\"><div class=\"template-9\"><div class=\"media media-attachment\" flex layout=\"row\" \nlayout-align=\"center center\" ng-if=\"attachment.media_type==1 || attachment.media_type==2 ||attachment.media_type==3\">\n<div class=\"media document\" layout=\"row\" layout-align=\"center center\" extension-class=\"{{attachment.filename}}\" \nng-href=\"{{attachment.permalink}}\" ng-if=\"attachment.media_type==3\" target=\"_blank\" ng-hide=\"attachment.gallery_type\">\n<qiu-icon mediafile=\"attachment.filename\" class=\"mr-10\"></qiu-icon></div><div flex \nng-click=\"vm.openImageDialog($event, vm.selectedContent.Thumbnail, attachment)\"><img class=\"image\" \nng-repeat=\"crop in attachment.cropstatus | limitTo: 1\" ng-src=\"{{crop.container.view_url}}{{crop.fileName}}\" \nng-if=\"attachment.media_type==1\"> <img class=\"image\" ng-src=\"{{attachment.embed_thumb}}\" \nng-if=\"attachment.media_type==2\"><div ng-if=\"attachment.media_type==2\" class=\"fotorama__video-play\" style=\"opacity:1\">\n</div></div></div><div flex layout=\"column\" layout-align=\"center center\" class=\"media\" \nng-if=\"attachment.media_type==4\" ng-click=\"vm.openUrl(attachment.permalink)\" target=\"_blank\"><qiu-icon \nmediafile=\"attachment.filename\" classextra=\"s56\"></qiu-icon><br><span class=\"grey-500-fg\" layout=\"column\" \nlayout-align=\"center center\"><span ng-if=\"attachment.title\"><strong>{{attachment.title}}</strong></span> <span \nng-if=\"attachment.filename\">{{attachment.filename}}</span></span></div><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"size block mr-5\" layout=\"row\" layout-align=\"start center\"><strong \nclass=\"mb-5 block\">#{{attachment.id_media}}</strong> <span class=\"grey-500-fg\" \nng-if=\"attachment.media_type==1 || attachment.media_type==2 || attachment.media_type==3\"><span \nng-if=\"attachment.filename\" class=\"word-break-all\">{{attachment.filename}}</span> <span \nng-if=\"attachment.title && attachment.filename\">| </span><span ng-if=\"attachment.title\" class=\"word-break-all\">\n{{attachment.title}}</span></span></div><md-icon md-font-icon=\"icon-eye\" class=\"s16 ml-10\" href=\"#\" \nng-click=\"vm.openImageDialog($event, vm.selectedContent.Thumbnail, attachment)\" \nng-if=\"attachment.media_type==1 || attachment.media_type==2\"></md-icon><md-icon md-font-icon=\"icon-open-in-new\" \nclass=\"s16 ml-10\" href=\"#\" click=\"vm.openUrl(attachment.permalink)\" target=\"_blank\" ng-if=\"attachment.media_type==4\">\n</md-icon></div></div></div></div></div><div ng-if=\"attachment.id_gallery\"><div class=\"ms-card\" flex \nmd-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"ms-card-content-wrapper\"><div class=\"template-9\"><div flex \nlayout=\"column\" layout-align=\"center center\" class=\"media\"><md-icon class=\"s56 mr-5 ml-10\" \nmd-font-icon=\"icon-folder-multiple-image\"></md-icon><br><span class=\"grey-500-fg\" layout=\"column\" \nlayout-align=\"center center\"><span ng-if=\"attachment.gallery_name\"><strong>{{attachment.gallery_name}}</strong></span>\n</span></div><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div class=\"size block mr-5\" \nlayout=\"row\" layout-align=\"start center\"><strong class=\"mb-5 block\">#{{attachment.id_gallery}}</strong> <span \nclass=\"grey-500-fg word-break-all\">{{attachment.gallery_name}}</span></div></div></div></div></div></div></div></div>\n</div></div><md-divider></md-divider></md-list-item><md-list-item \nng-repeat=\"(key, value) in vm.selectedContent.Thumbnail | groupBy: \'id_zone\'\" ng-if=\"!vm.mediaZones\"><div \nclass=\"attachments\"><div class=\"field\"><p class=\"grey-500-fg font-size-14\" translate=\"CONTENT.NO_ZONE\">No Zone</p><div \nclass=\"attachment-list md-list-item-text\" layout=\"row\" layout-wrap=\"\" layout-align=\"start start\"><div \nclass=\"attachment\" ng-repeat=\"attachment in value\"><div ng-hide=\"attachment.id_gallery\"><div class=\"ms-card\" flex \nmd-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"ms-card-content-wrapper\"><div class=\"template-9\"><div \nclass=\"media media-attachment\" flex layout=\"row\" layout-align=\"center center\" \nng-if=\"attachment.media_type==1 || attachment.media_type==2 || attachment.media_type==3\"><div class=\"preview document\" \nlayout=\"row\" layout-align=\"start center\" extension-class=\"{{attachment.filename}}\" ng-href=\"{{attachment.permalink}}\" \nng-if=\"attachment.media_type==3\" target=\"_blank\" ng-hide=\"attachment.id_gallery\"><qiu-icon \nmediafile=\"attachment.filename\" class=\"mr-10\"></qiu-icon><a class=\"grey-1000-fg font-size-16\" \nng-href=\"{{attachment.permalink}}\" target=\"_blank\"><span ng-if=\"attachment.title\">{{attachment.title}} </span><span \nng-if=\"attachment.filename\">{{attachment.filename}}</span></a></div><div flex \nng-click=\"vm.openImageDialog($event, vm.selectedContent.Thumbnail, attachment)\"><img class=\"image\" \nng-repeat=\"crop in attachment.cropstatus | limitTo: 1\" ng-src=\"{{crop.container.view_url}}{{crop.fileName}}\" \nng-if=\"attachment.media_type==1\"> <img class=\"image\" ng-src=\"{{attachment.embed_thumb}}\" \nng-if=\"attachment.media_type==2\"><div ng-if=\"attachment.media_type==2\" class=\"fotorama__video-play\" style=\"opacity:1\">\n</div></div></div><div flex layout=\"column\" layout-align=\"center center\" class=\"media\" \nng-if=\"attachment.media_type==4\"><qiu-icon mediafile=\"attachment.filename\" classextra=\"s56\"></qiu-icon><br><span \nclass=\"grey-500-fg\" layout=\"column\" layout-align=\"center center\"><span ng-if=\"attachment.title\"><strong>\n{{attachment.title}}</strong></span> <span ng-if=\"attachment.filename\">{{attachment.filename}}</span></span></div><div \nclass=\"header\" layout=\"row\" layout-align=\"space-between center\"><div class=\"size block mr-5\" layout=\"row\" \nlayout-align=\"start center\"><strong class=\"mb-5 block\">#{{attachment.id_media}}</strong> <span class=\"grey-500-fg\" \nng-if=\"attachment.media_type==1 || attachment.media_type==2\"><span ng-if=\"attachment.filename\" class=\"word-break-all\">\n{{attachment.filename}}</span> <span ng-if=\"attachment.title && attachment.filename\">| </span><span \nng-if=\"attachment.title\" class=\"word-break-all\">{{attachment.title}}</span></span></div><md-icon \nmd-font-icon=\"icon-eye\" class=\"s16 ml-10\" href=\"#\" \nng-click=\"vm.openImageDialog($event, vm.selectedContent.Thumbnail, attachment)\"></md-icon></div></div></div></div>\n</div><div ng-if=\"attachment.id_gallery\"><div class=\"ms-card\" flex md-dynamic-height=\"{{vm.dynamicHeight}}\"><div \nclass=\"ms-card-content-wrapper\"><div class=\"template-9\"><div flex layout=\"column\" layout-align=\"center center\" \nclass=\"media\"><md-icon class=\"s56 mr-5 ml-10\" md-font-icon=\"icon-folder-multiple-image\"></md-icon><br><span \nclass=\"grey-500-fg\" layout=\"column\" layout-align=\"center center\"><span ng-if=\"attachment.gallery_name\"><strong>\n{{attachment.gallery_name}}</strong></span></span></div><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"size block\" layout=\"row\" layout-align=\"start center\"><strong \nclass=\"mb-5 block\">#{{attachment.id_gallery}}</strong> <span class=\"grey-500-fg word-break-all\">\n{{attachment.gallery_name}}</span></div></div></div></div></div></div></div></div></div></div><md-divider></md-divider>\n</md-list-item></div><div ng-repeat=\"tab in vm.selectedContent_ref_tabs\"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg\"><h3 class=\"grey-700-fg\">{{tab.raw_settings.tabName | translate}}</h3><md-divider>\n</md-divider></md-list-item><md-tab-body><div ng-include=\"\'app/main/apps/content/views/read/tab-grouped.html\'\" \nclass=\"case-text-info\"></div></md-tab-body></div><div \nng-if=\"vm.selectedContent.tags && vm.selectedContent.tags.length > 0\"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg\"><h3 class=\"grey-700-fg\"><span translate=\"CONTENT.TAGS\">\n({{vm.selectedContent.tags.length}})</span></h3><md-divider></md-divider></md-list-item><md-list-item><md-chips \nname=\"tag_name\" ng-model=\"vm.selectedContent.tags\" readonly=\"true\" md-removable=\"false\"><md-chip-template><span>\n{{$chip.tag_name}} #{{$chip.id_tag}}</span></md-chip-template></md-chips><md-divider></md-divider></md-list-item></div>\n<md-list-item class=\"md-toolbar-tools grey-100-bg\"><h3 class=\"grey-700-fg\" translate=\"CONTENT.LATESTACTIVITY\"></h3>\n<md-divider></md-divider></md-list-item><div class=\"activities\"><div class=\"activity\" layout=\"row\" \nlayout-align=\"start center\" ng-repeat=\"activity in vm.log | limitTo: vm.paginationLimit()\"><div class=\"avatar\" \nng-bind=\"activity.user.email | capitalizeFirstLetter\" ms-random-class=\"vm.colors\">P</div><div layout=\"column\"><div>\n<span class=\"username md-accent-color\" ng-if=\"activity.user.email.length>0 && !activity.user.first_name\">\n{{activity.user.email}} </span><span class=\"username md-accent-color\" ng-if=\"activity.user.first_name.length>0\">\n{{activity.user.first_name}} {{activity.user.lastname}} </span><span class=\"message\" ng-if=\"activity.message\">\n{{activity.message}}</span></div><span class=\"time secondary-text\">{{activity.date}}</span></div></div><button \nclass=\"md-raised md-button md-default-theme md-ink-ripple\" ng-click=\"vm.showMoreItems()\" \nng-show=\"vm.hasMoreItemsToShow()\"><span translate=\"CONTENT.SHOW_MORE\"></span></button></div><div hide \nclass=\"activities activities-list activity-main\"><table hide show-gt-md><tr \nng-repeat=\"activity in vm.log | limitTo: vm.paginationLimit()\"><td><div layout=\"row\" layout-align=\"start center\"><div \nng-if=\"(activity.user.avatar == \'\' || !activity.user.avatar)\" class=\"avatar\" \nng-bind=\"activity.user.first_name | capitalizeFirstLetter\" style=\"background-color:{{activity.user.profile_color}}\">\n</div><div class=\"avatar-wrapper\" ng-if=\"activity.user.avatar\" attachment=\"activity.user.avatar\"><img class=\"avatar\" \nng-src=\"{{activity.user.avatar}}\" imageonload></div><h3 class=\"mt-0 mb-0 mr-10\"><strong \nng-bind-html=\"activity.user.first_name + \' \' + activity.user.last_name\"></strong></h3></div></td><td><div \nclass=\"field\" layout=\"row\" layout-align=\"start center\"><span class=\"grey-500-fg\" \nng-bind-html=\"vm.timeAgo(activity.date)\"></span></div></td><td><div class=\"field\" layout=\"row\" \nlayout-align=\"end center\"><span class=\"status {{activity.action.action_name}}\" \nng-bind-html=\"activity.action.action_name\"></span></div></td></tr></table></div></md-list></div>");
$templateCache.put("app/main/apps/forms/views/editors/editors-editing.html","<div ng-if=\"field.temporary || field.editing\" class=\"layout-wrap layout-sm-column layout-row newfield\"><div flex=\"50\">\n<md-input-container class=\"md-block\"><label translate=\"FORMS.FIELD_TYPE\"></label><md-select \nng-change=\"vm.setTOOptions(field)\" ng-model=\"field.type\"><md-option ng-repeat=\"typeField in vm.typeFields\" \nng-value=\"typeField\"><span ng-switch=\"typeField\"><md-icon md-font-icon=\"icon-format-float-left\" class=\"mr-5 s20\" \nng-switch-when=\"textarea\"></md-icon><md-icon md-font-icon=\"icon-format-text\" class=\"mr-5 s20\" ng-switch-when=\"input\">\n</md-icon><md-icon md-font-icon=\"icon-chevron-down\" class=\"mr-5 s20\" ng-switch-when=\"select\"></md-icon><md-icon \nmd-font-icon=\"icon-tag\" class=\"mr-5 s20\" ng-switch-when=\"separator\"></md-icon><md-icon \nmd-font-icon=\"icon-checkbox-marked-outline\" class=\"mr-5 s20\" ng-switch-when=\"checkbox\"></md-icon><md-icon \nmd-font-icon=\"icon-checkbox-marked-outline\" class=\"mr-5 s20\" ng-switch-when=\"multiCheckbox\"></md-icon><md-icon \nmd-font-icon=\"icon-radiobox-marked\" class=\"mr-5 s20\" ng-switch-when=\"radio\"></md-icon><md-icon \nmd-font-icon=\"icon-view-week\" class=\"mr-5 s20\" ng-switch-default></md-icon></span>{{typeField}}</md-option></md-select>\n</md-input-container></div><div ng-if=\"field.type && field.type == \'input\'\" flex=\"50\"><md-input-container \nclass=\"md-block\"><label translate=\"FORMS.FIELD_TYPE\"></label><md-select ng-model=\"field.templateOptions.type\">\n<md-option ng-repeat=\"typeInput in vm.typesInput\" ng-value=\"typeInput\"><span ng-switch=\"typeInput\"><md-icon \nmd-font-icon=\"icon-format-list-numbers\" class=\"mr-5 s20\" ng-switch-when=\"number\"></md-icon><md-icon \nmd-font-icon=\"icon-cellphone\" class=\"mr-5 s20\" ng-switch-when=\"tel\"></md-icon><md-icon md-font-icon=\"icon-file-hidden\" \nclass=\"mr-5 s20\" ng-switch-when=\"hidden\"></md-icon><md-icon md-font-icon=\"icon-email\" class=\"mr-5 s20\" \nng-switch-when=\"email\"></md-icon><md-icon md-font-icon=\"icon-format-text\" class=\"mr-5 s20\" ng-switch-when=\"text\">\n</md-icon><md-icon md-font-icon=\"icon-view-week\" class=\"mr-5 s20\" ng-switch-default></md-icon></span>{{typeInput}}\n</md-option></md-select></md-input-container></div><div ng-if=\"field.type && field.type == \'multiCheckbox\'\" flex=\"50\">\n<md-input-container class=\"md-block\"><label translate=\"FORMS.MULTICHECKBOX_TYPE\"></label><md-select \nng-change=\"field.templateOptions.options = []\" ng-model=\"field.templateOptions.type\"><md-option \nng-repeat=\"type in vm.typesMulticheckbox\" ng-value=\"type\">{{type}}</md-option></md-select></md-input-container></div>\n<div ng-if=\"field.type\" flex=\"50\"><md-input-container class=\"md-block\"><label translate=\"FORMS.LABEL\"></label><textarea\n ng-model=\"field.templateOptions.label\" columns=\"1\" rows=\"1\"></textarea></md-input-container></div><div \nng-if=\"field.type \" flex=\"50\"><md-input-container class=\"md-block\"><label translate=\"FORMS.FIELD_NAME\"></label>\n<textarea ng-model=\"field.className\" columns=\"1\" rows=\"1\"></textarea></md-input-container></div><div \nng-if=\"field.type && field.type !== \'separator\'\" flex=\"50\"><md-input-container class=\"md-block\"><label \ntranslate=\"FORMS.PLACEHOLDER\"></label><input ng-model=\"field.templateOptions.placeholder\" columns=\"1\" rows=\"1\">\n</md-input-container></div><div ng-if=\"field.type && field.type !== \'separator\'\" flex=\"50\"><md-input-container \nclass=\"md-block\"><label translate=\"FORMS.TOOLTIP\"></label><input ng-model=\"field.templateOptions.tooltip\" columns=\"1\" \nrows=\"1\"></md-input-container></div><div ng-if=\"field.type && field.type === \'single-suggest\'\" flex=\"50\">\n<md-input-container class=\"md-block\"><label translate=\"FORMS.REFRESH_URL\"></label><input \nng-model=\"field.templateOptions.refreshURL\" columns=\"1\" rows=\"1\"></md-input-container></div><div \nng-if=\"field.type && field.type === \'single-suggest\'\" flex=\"50\"><md-input-container class=\"md-block\"><label \ntranslate=\"FORMS.REFRESH_DELAY\"></label><input type=\"number\" ng-model=\"field.templateOptions.refreshDelay\" columns=\"1\" \nrows=\"1\"></md-input-container></div><div ng-if=\"field.type && field.type === \'single-suggest\'\" flex=\"50\">\n<md-input-container class=\"md-block\"><label translate=\"FORMS.MINIMUM_INPUT_LENGTH\"></label><input type=\"number\" \nng-model=\"field.templateOptions.minimumInputLength\" columns=\"1\" rows=\"1\"></md-input-container></div><div \nng-if=\"field.type && field.type !== \'separator\'\" flex=\"50\"><md-input-container class=\"md-block\"><label \ntranslate=\"FORMS.ERRORFIELD\"></label><input ng-model=\"field.templateOptions.errorField\" columns=\"1\" rows=\"1\">\n</md-input-container></div><div \nng-if=\"field.type && (field.type === \'input\' || field.type === \'single-suggest\' || (field.type === \'multiCheckbox\' ))\" \nflex=\"50\"></div><div ng-if=\"field.type && field.type !== \'separator\'\" flex=\"100\"><md-input-container class=\"md-block\">\n<md-checkbox ng-model=\"field.templateOptions.main_field\"></md-checkbox><span translate=\"FORMS.UNIQUE_FIELD\"></span>\n</md-input-container></div><div ng-if=\"field.type && field.type !== \'separator\'\" flex=\"25\"><md-input-container \nclass=\"md-block\"><md-checkbox ng-model=\"field.templateOptions.required\"></md-checkbox><span translate=\"FORMS.REQUIRED\">\n</span></md-input-container></div><div ng-if=\"field.type && field.type !== \'separator\'\" flex=\"25\"><md-input-container \nclass=\"md-block\"><md-checkbox ng-model=\"field.templateOptions.disabled\"></md-checkbox><span translate=\"FORMS.DISABLED\">\n</span></md-input-container></div><div ng-if=\"field.type && field.type === \'checkbox\' \" flex=\"25\"><md-input-container \nclass=\"md-block\"><md-checkbox ng-model=\"field.templateOptions.value\"></md-checkbox><span \ntranslate=\"FORMS.DEFAULT_VALUE\"></span></md-input-container></div><div \nng-if=\"field.type && field.type !== \'separator\'\" flex=\"100\"><md-input-container class=\"md-block\"><label \ntranslate=\"FORMS.HIDE_EXPRESSION\"></label><input type=\"text\" ng-model=\"field.hideExpression\" columns=\"1\" rows=\"1\">\n</md-input-container></div><div id=\"calendar-disabled-days\" ng-if=\"field.type && (field.type === \'datepicker\')\"><label \ntranslate=\"FORMS.DISABLE_DATES_DATEPICKER\"></label><div class=\"disabled-days-container\"><div \nng-repeat=\"day in vm.weekDays\" \nng-class=\"{selected : field.templateOptions.datepickerOptions && field.templateOptions.datepickerOptions.weeksDisabled && field.templateOptions.datepickerOptions.weeksDisabled.indexOf(day.value) != -1}\" \nclass=\"disabled-day\" ng-click=\"vm.setDisabledDay(field, day.value)\">{{day.abb}}</div></div></div><div \nng-if=\"field.type && (field.type === \'checkbox\' )\" flex=\"50\"></div><div class=\"validations-button\" \nng-if=\"field.type && field.type !== \'separator\'\" flex=\"50\"><md-button \nng-if=\"field.type && (field.type === \'radio\' || (field.type === \'multiCheckbox\' && field.templateOptions.type !== \'users_group\') || (field.type === \'select\' ))\" \ntranslate=\"FORMS.OPTIONS\" class=\"md-accent green-500-bg md-raised md-button md-ink-ripple md-default-theme md-button\" \nng-click=\"vm.openOptionsDialog($event, $index,  \'FORMS.OPTIONS\', \'options\')\"></md-button><md-button \nng-if=\"field.type === \'multiCheckbox\' && field.templateOptions.type == \'users_group\'\" translate=\"FORMS.OPTIONS\" \nclass=\"md-accent green-500-bg md-raised md-button md-ink-ripple md-default-theme md-button\" \nng-click=\"vm.openUserGroupDialog($event, $index, field)\"></md-button><md-button ng-if=\"field.type === \'dropzone\'\" \ntranslate=\"FORMS.OPTIONS\" class=\"md-accent green-500-bg md-raised md-button md-ink-ripple md-default-theme md-button\" \nng-click=\"vm.openDropzoneOptions($event, $index, field)\"></md-button><md-button \nng-if=\"field.type && (field.type === \'datepicker\')\" translate=\"FORMS.FORMATS\" \nclass=\"md-accent green-500-bg md-raised md-button md-ink-ripple md-default-theme md-button\" \nng-click=\"vm.openOptionsDialog($event, $index, \'FORMS.FORMATS\', \'datepickerOptions\')\"></md-button><md-button \ntranslate=\"FORMS.VALIDATIONS\" \nclass=\"md-accent green-500-bg md-raised md-button md-ink-ripple md-default-theme md-button\" \nng-click=\"vm.openValidationsDialog($event, $index)\"></md-button></div><div class=\"flex-100\" layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container ng-if=\"field.type == \'group\'\" class=\"without-margin-sides\">\n<md-button ng-click=\"vm.groupDialog(field)\" class=\"edit-button md-accent md-raised\" ng-disabled=\"\" aria-label=\"EDIT\" \ntranslate=\"FORMS.EDIT\" translate-attr-aria-label=\"FORMS.EDIT\"></md-button></md-input-container><md-input-container \nclass=\"md-block without-margin-sides\" flex layout=\"row\" layout-align=\"end center\"><md-button type=\"submit\" \nng-click=\"vm.saveFieldStructure($index)\" class=\"send-button md-accent md-raised\" ng-disabled=\"\" aria-label=\"SAVE\" \ntranslate=\"FORMS.SAVE\" translate-attr-aria-label=\"FORMS.SAVE\"></md-button><md-button type=\"button\" \nng-click=\"vm.cancelEditFieldStructure($index)\" class=\"md-raised md-warn\" aria-label=\"Cancel\" translate=\"FORMS.CANCEL\" \ntranslate-attr-aria-label=\"FORMS.CANCEL\"></md-button></md-input-container></div></div>");
$templateCache.put("app/main/apps/forms/views/editors/editors-view.html","<div layout=\"row\" layout-align=\"start center\" ng-if=\"(!field.temporary && !field.editing)\"><div ng-switch=\"field.type\">\n<md-icon md-font-icon=\"icon-format-float-left\" class=\"mr-30\" ng-switch-when=\"textarea\"><md-tooltip hide show-gt-xs>\n<span translate=\"textarea\">textarea</span></md-tooltip></md-icon><md-icon md-font-icon=\"icon-format-text\" \nclass=\"mr-30\" ng-switch-when=\"input\"><md-tooltip hide show-gt-xs><span translate=\"Input\">Input</span></md-tooltip>\n</md-icon><md-icon md-font-icon=\"icon-chevron-down\" class=\"mr-30\" ng-switch-when=\"select\"><md-tooltip hide show-gt-xs>\n<span translate=\"select\">select</span></md-tooltip></md-icon><md-icon md-font-icon=\"icon-radiobox-marked\" \nclass=\"mr-30\" ng-switch-when=\"radio\"><md-tooltip hide show-gt-xs><span translate=\"Radio\">Radio</span></md-tooltip>\n</md-icon><md-icon md-font-icon=\"icon-tag\" class=\"mr-30\" ng-switch-when=\"separator\"><md-tooltip hide show-gt-xs><span \ntranslate=\"separator\">separator</span></md-tooltip></md-icon><md-icon md-font-icon=\"icon-checkbox-marked-outline\" \nclass=\"mr-30\" ng-switch-when=\"multiCheckbox\"><md-tooltip hide show-gt-xs><span translate=\"multiCheckbox\">multiCheckbox\n</span></md-tooltip></md-icon><md-icon md-font-icon=\"icon-checkbox-marked-outline\" class=\"mr-30\" \nng-switch-when=\"checkbox\"><md-tooltip hide show-gt-xs><span translate=\"checkbox\">checkbox</span></md-tooltip></md-icon>\n<md-icon md-font-icon=\"icon-format-text\" class=\"mr-30\" ng-switch-when=\"image-crop\"><md-tooltip hide show-gt-xs><span \ntranslate=\"Image\">Image</span></md-tooltip></md-icon><md-icon md-font-icon=\"icon-view-week\" class=\"mr-30\" \nng-switch-default><md-tooltip hide show-gt-xs><span translate=\"checkbox\">{{field.type}}</span></md-tooltip></md-icon>\n</div><div class=\"template flex\" layout=\"row\" layout-align=\"space-between center\"><div class=\"field\" layout=\"column\">\n<div ng-switch=\"field.type\"><span class=\"font-size-16 grey-700-fg\" ng-switch-default ng-bind=\"field.className\"></span>\n</div><div class=\"content-editable\" ng-switch=\"field.type\" layout=\"column\"><span ng-switch-when=\"textBox\" \nclass=\"grey-500-fg font-size-14 mt-5\" ng-if=\"field.defaultValue\">{{field.defaultValue}}<md-tooltip hide show-gt-xs>\n<span translate=\"MAILING.DEFAULT_VALUE\">Default value</span></md-tooltip></span><span ng-switch-when=\"lineSeparator\" \nclass=\"grey-500-fg font-size-14 mt-5\" ng-if=\"field.defaultValue\">{{field.defaultValue}}</span><div \nng-switch-when=\"checkbox\" layout=\"row\" layout-align=\"start center\" class=\"mt-5\"><span \nclass=\"grey-500-fg font-size-14 mt-0 mr-5 text-truncate\" translate=\"MAILING.DEFAULT_VALUE\"></span><md-icon \nmd-font-icon=\"icon-checkbox-marked\" class=\"s18 m-0\" ng-if=\"field.templateOptions.value == 1\"></md-icon><md-icon \nmd-font-icon=\"icon-checkbox-blank\" class=\"s18 m-0\" ng-if=\"field.templateOptions.value == 0\"></md-icon><md-tooltip hide \nshow-gt-xs ng-if=\"field.templateOptions.value == 1\"><span>Checked</span></md-tooltip><md-tooltip hide show-gt-xs \nng-if=\"field.templateOptions.value == 0\"><span>Unchecked</span></md-tooltip></div></div></div><div layout=\"row\" \nlayout-align=\"end center\"><md-menu><md-button class=\"md-icon-button\" aria-label=\"More\" \nng-click=\"vm.openMenu($mdMenu, $event)\"><md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/more_vert.svg\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"vm.editFieldStructure($index)\" \naria-label=\"Edit\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><span translate=\"MAILING.EDIT\"></span></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.removeFieldStructure($index)\" aria-label=\"Delete\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-default-theme md-font material-icons icon-delete\"></md-icon>Remove</md-button>\n</md-menu-item></md-menu-content></md-menu><md-icon class=\"drag icon-equal\" aria-label=\"DRAG\"></md-icon></div></div>\n</div>");
$templateCache.put("app/main/apps/forms/views/list/list-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-show=\"isLoading\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nclass=\"mail-list-item filter-selected\" ng-if=\"sortField\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\" flex><div class=\"info\" ng-if=\"sortField\"><div class=\"name\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-sort-ascending\" class=\"s20 mr-5 ml-0 mb-0\" \nng-if=\"sortDir === \'ASC\'\"></md-icon><md-icon md-font-icon=\"icon-sort-descending\" class=\"s20 mr-5 ml-0 mb-0\" \nng-if=\"sortDir === \'DESC\'\"></md-icon><div class=\"title text-truncate\" layout=\"row\" layout-align=\"start center\">\nOrdered by \'{{sortField}}\'</div></div></div></div><div class=\"buttons\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-close s20\" ng-click=\"pagination_resetOrderBy()\" class=\"ml-10\"><md-tooltip hide show-gt-xs>\n<span translate=\"FORMS.REMOVE\">Remove</span></md-tooltip></md-icon></div></div><div class=\"no-threads\" \nng-if=\"!isLoading && vm.threads.length === 0\" ng-hide=\"isLoading\" translate=\"FORMS.NO_ITEMS\">There are no items!</div>\n<div id=\"list-content-data\" ng-style=\"{\'opacity\' : isLoading ? 0.2 : 1}\" ms-scroll=\"vm.msScrollOptions\" \nng-class=\"{\'group-filter\': vm.selectedGroup,\'other-filter\':sortField}\" class=\"scrollable\" \nng-if=\"vm.threads.length > 0\"><div ng-if=\"vm.currentLabelsFilter\" class=\"labels\"><form novalidate><div><div \nng-repeat=\"item in vm.currentLabelsFilter track by $index\" class=\"tag\" fxlayout=\"row\" fxlayoutalign=\"start center\"><div\n class=\"tag-label\">{{item.label}}<md-icon ng-click=\"vm.deleteTargetFilter(item.id, $index)\" md-font-icon=\"icon-close\" \nclass=\"s24 pointer\"></md-icon></div></div></div></form></div><div class=\"mail-list-item {{thread.status}}\" \nng-repeat=\"thread in vm.threads | filter: vm.search | filter: global.search\" md-no-ink ng-init=\"parentIndex = $index\" \nng-click=\"vm.openThread(thread)\" \nng-class=\"{\'starred\': thread.starred, \'selected\': vm.selectedContentID === thread.id, \'checked\': vm.isChecked(thread)}\">\n<div layout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-label\" ng-checked=\"vm.isSelected(thread)\" \nng-click=\"vm.toggleSelectThread(thread, $event)\" aria-label=\"{{vm.isSelected(thread) ? \'Deselect\' : \'Select\'}}\">\n</md-checkbox><div class=\"info\" flex layout=\"column\"><div><div class=\"name\" layout=\"row\" layout-align=\"start center\">\n<div class=\"user-name text-truncate\"><span ng-bind=\"thread.title\" ng-if=\"thread.title\"></span></div></div></div></div>\n<div layout=\"column\" layout-align=\"space-between end\"></div></div></div><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"end center\"><div layout=\"row\" layout-align=\"center center\" \nng-style=\"{\'display\' : isLoading ? \'none\' : \'block\'}\"><span class=\"page-info\">{{pagination_totalItems}} items found.\n</span><md-button aria-label=\"Previous\" class=\"md-icon-button arrow\" ng-click=\"pagination_prevPage()\" \nng-disabled=\"pagination_firstPage()\" translate=\"\" translate-attr-aria-label=\"FORMS.PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span translate=\"FORMS.PREVIOUS\">Previous</span></md-tooltip>\n</md-button><span class=\"page-info\">{{pagination_page}} / {{pagination_total_pages}}</span><md-button \naria-label=\"Next\" class=\"md-icon-button arrow\" ng-click=\"pagination_nextPage()\" \nng-disabled=\"pagination_morePages() || pagination_total_pages === pagination_page\" translate=\"\" \ntranslate-attr-aria-label=\"FORMS.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span \ntranslate=\"FORMS.NEXT\">Next</span></md-tooltip></md-button></div></div></div>");
$templateCache.put("app/main/apps/forms/views/list/nosplit-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/forms/views/list/toolbar.html\'\" ng-hide=\"vm.currentThread || vm.currentThread_Edit\"></div>\n<div class=\"content-wrapper\" flex=\"\" layout=\"row\"><div class=\"content thread-list mail-list-pane\" flex=\"\" \nid=\"thread-list\" ng-if=\"!vm.selectedContent\" ng-include=\"\'app/main/apps/forms/views/list/list-view.html\'\"></div><div \nclass=\"content thread-detail mail-read-pane\" flex=\"\" id=\"thread-detail\" layout=\"column\" ng-if=\"vm.selectedContent\" \nng-include=\"\'app/main/apps/forms/views/read/read-view.html\'\"></div></div>");
$templateCache.put("app/main/apps/forms/views/list/split-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/forms/views/list/toolbar.html\'\"></div><div class=\"content-wrapper\" flex=\"\" layout=\"row\"><div\n class=\"content thread-list mail-list-pane\" flex=\"50\" id=\"thread-list\" \nng-include=\"\'app/main/apps/forms/views/list/list-view.html\'\"></div><div class=\"content thread-detail mail-read-pane\" \nflex=\"50\" id=\"thread-detail\" layout=\"column\" ng-include=\"\'app/main/apps/forms/views/read/read-view.html\'\"></div></div>");
$templateCache.put("app/main/apps/forms/views/list/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-label\" \naria-label=\"{{vm.selectedThreads.length > 0 ? \'Deselect All\' : \'Select All\'}}\" \nng-checked=\"vm.selectedThreads.length > 0\" ng-click=\"vm.toggleSelectThreads()\"></md-checkbox><div \nclass=\"divider-vertical\" hide show-gt-xs></div><md-button aria-label=\"ADD NEW\" \nclass=\"md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme\" hide show-gt-sm \nng-click=\"vm.newThread()\" translate=\"FORMS.ADD_NEW\" type=\"button\">Add new</md-button><md-button aria-label=\"ADD NEW\" \nclass=\"md-fab md-mini md-accent green-500-bg md-raised md-ink-ripple md-default-theme\" hide-gt-sm \nng-click=\"vm.newThread()\" type=\"button\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><div \nclass=\"divider-vertical\" hide show-gt-xs></div><div aria-hidden=\"false\" \nclass=\"action-buttons hide show-gt-xs layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\" \nng-show=\"vm.selectedThreads.length > 0\"><md-button ng-click=\"vm.massActions(\'delete\')\" aria-label=\"Delete\" \nclass=\"md-icon-button\" hide show-gt-sm translate translate-attr-aria-label=\"FORMS.DELETE\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"FORMS.DELETE\">Delete</span></md-tooltip></md-button>\n<div class=\"divider-vertical\" hide show-gt-xs></div></div><ms-search-bar debounce=\"300\" \nmodel-search=\"$root.pagination_searchquery\" on-result-click=\"vm.searchResultClick(item)\" on-search=\"vm.search(query)\" \nlayout=\"row\" layout-align=\"start center\"></ms-search-bar><md-button ng-click=\"$root.pagination_resetquery()\" \naria-label=\"view type\" class=\"md-icon-button\" translate=\"\" translate-attr-aria-label=\"FORMS.RESET_SEARCH\" \nclass=\"md-icon-button\" ng-if=\"$root.pagination_searchquery==true\"><md-icon md-font-icon=\"icon-filter-remove-outline\">\n</md-icon><md-tooltip hide show-gt-xs><span translate=\"FORMS.RESET_SEARCH\"></span></md-tooltip></md-button><div \nclass=\"divider-vertical\" hide show-gt-xs></div><md-button aria-label=\"Sort Direction\" class=\"md-icon-button\" \nng-click=\"vm.setSortOrder(\'ASC\')\" ng-disabled=\"!sortField\" ng-if=\"sortDir !== \'ASC\'\" translate \ntranslate-attr-aria-label=\"TODO.SORT_DIRECTION\"><md-icon md-font-icon=\"icon-sort-ascending\" ng-if=\"sortDir !== \'ASC\'\">\n</md-icon><md-icon md-font-icon=\"icon-sort-descending\" ng-if=\"sortDir === \'ASC\'\"></md-icon></md-button><md-button \naria-label=\"Sort Direction\" class=\"md-icon-button\" ng-click=\"vm.setSortOrder(\'DESC\')\" ng-disabled=\"!sortField\" \nng-if=\"sortDir === \'ASC\'\" translate translate-attr-aria-label=\"TODO.SORT_DIRECTION\"><md-icon \nmd-font-icon=\"icon-sort-ascending\" ng-if=\"sortDir !== \'ASC\'\"></md-icon><md-icon md-font-icon=\"icon-sort-descending\" \nng-if=\"sortDir === \'ASC\'\"></md-icon></md-button></div><div layout=\"row\" layout-align=\"start center\" \ntranslate-attr-aria-label=\"FORMS.REFRESH\"><span class=\"page-info\" hide show-gt-xs>\n{{pagination_totalItems}} items found.</span><md-button aria-label=\"Previous\" class=\"md-icon-button arrow\" hide \nng-click=\"pagination_prevPage()\" ng-disabled=\"pagination_firstPage()\" show-gt-xs translate \ntranslate-attr-aria-label=\"FORMS.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span \ntranslate=\"FORMS.PREVIOUS\">Previous</span></md-tooltip></md-button><span class=\"page-info\" hide show-gt-xs>\n{{pagination_page}} / {{pagination_total_pages}}</span><md-button aria-label=\"Next\" class=\"md-icon-button arrow\" hide \nng-click=\"pagination_nextPage()\" ng-disabled=\"pagination_morePages()\" show-gt-xs translate \ntranslate-attr-aria-label=\"FORMS.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span \ntranslate=\"FORMS.NEXT\">Next</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.changeView(\'nosplit\')\" ng-if=\"vm.currentView !== \'nosplit\'\" hide aria-label=\"noSplit\" show-gt-sm><md-icon \nmd-font-icon=\"icon-view-list\" ng-if=\"vm.currentView !== \'nosplit\'\"></md-icon><md-icon class=\"md-accent\" \nmd-font-icon=\"icon-checkbox-marked\" ng-if=\"vm.currentView === \'nosplit\'\"></md-icon><md-tooltip><span \ntranslate=\"FORMS.NOSPLIT_VIEW\">No split</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.changeView(\'split\')\" ng-if=\"vm.currentView !== \'split\'\" hide aria-label=\"Split\" show-gt-sm><md-icon \nmd-font-icon=\"icon-view-quilt\" ng-if=\"vm.currentView !== \'split\'\"></md-icon><md-icon class=\"md-accent\" \nmd-font-icon=\"icon-checkbox-marked\" ng-if=\"vm.currentView === \'split\'\"></md-icon><md-tooltip><span \ntranslate=\"FORMS.SPLIT_VIEW\">split</span></md-tooltip></md-button><md-menu class=\"settings-menu\" hide-gt-xs \nng-show=\"vm.selectedThreads.length > 0\"><md-button aria-label=\"Settings\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\" translate translate-attr-aria-label=\"FORMS.SETTINGS\"><md-icon \nmd-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content><md-menu-item><md-menu-item><md-button \nng-click=\"vm.massActions(\'delete\')\" aria-label=\"Delete\" translate-aria-label=\"FORMS.DELETE\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><span translate=\"FORMS.DELETE\">Delete </span><span translate=\"FORMS.SELECTED\">\nSelected</span></md-button></md-menu-item></md-menu-item></md-menu-content></md-menu></div>");
$templateCache.put("app/main/apps/forms/views/read/read-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-show=\"vm.loadingReadPane\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nng-show=\"!vm.loadingReadPane\"><div class=\"mail-content\" layout=\"column\" layout-align=\"center center\" \nng-if=\"!vm.selectedContent\"><div class=\"content\" layout=\"column\" layout-align=\"top center\"><div class=\"message\" \ntranslate=\"FORMS.NO_ITEM_SELECTED_PANEL\"></div></div></div><div class=\"toolbar grey-100-bg colored-bg\" layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"vm.selectedContent\" scroll=\"\"><div layout=\"row\" layout-align=\"start center\">\n<md-button class=\"md-icon-button close-thread\" aria-label=\"Back\" ng-click=\"vm.closeThread()\" translate \ntranslate-attr-aria-label=\"FORMS.BACK\" ng-if=\"vm.currentView === \'nosplit\'\"><md-icon md-font-icon=\"icon-arrow-left\">\n</md-icon></md-button></div><div layout=\"row\" layout-align=\"end center\" ng-if=\"vm.selectedContent\" hide show-gt-sm>\n<md-button type=\"submit\" ng-click=\"vm.saveItem(vm.selectedContent)\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.basicForm.$invalid || vm.basicForm.$pristine && vm.noexistchangues\" aria-label=\"SAVE\" \ntranslate=\"FORMS.SAVE\" translate-attr-aria-label=\"FORMS.SAVE\">SAVE</md-button><md-button type=\"button\" \nng-click=\"vm.closeThreadEdit()\" class=\"md-raised md-warn\" aria-label=\"Cancel\">Cancel</md-button></div><div \nlayout=\"row\" layout-align=\"end center\" ng-if=\"vm.selectedContent\" hide-gt-sm><md-button type=\"submit\" \nng-click=\"vm.saveItem(vm.selectedContent)\" class=\"md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme\" \nng-disabled=\"vm.basicForm.$invalid || vm.basicForm.$pristine && vm.noexistchangues\" aria-label=\"SAVE\"><md-icon \nmd-font-icon=\"icon-check\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"FORMS.SAVE\">Save</span></md-tooltip>\n</md-button><md-button type=\"button\" ng-click=\"vm.closeThreadEdit()\" \nclass=\"md-warn md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme\" aria-label=\"Cancel\"><md-icon \nmd-font-icon=\"icon-window-close\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"FORMS.CANCEL\">Cancel</span>\n</md-tooltip></md-button></div></div><form name=\"vm.basicForm\" class=\"md-inline-form\" novalidate><md-content flex=\"\" \nng-if=\"vm.selectedContent && !vm.editInline\"><div class=\"mail-content file-details scrollable\" \nms-scroll=\"vm.msScrollOptions\"><md-list class=\"pb-0\"><md-list-item class=\"info\" layout=\"row\" \nlayout-align=\"start center\"><div layout=\"row\" layout-align=\"start start\"><div class=\"header-element\" layout=\"row\" \nlayout-align=\"center center\"><div><span class=\"grey-500-fg\">ID # </span><span ng-bind=\"vm.selectedContent.id\"></span>\n</div></div></div></md-list-item><md-list-item><md-input-container fill-width class=\"md-block margin-0\"><label \ntranslate=\"FORMS.TITLE\"></label><textarea ng-model=\"vm.selectedContent.title\" columns=\"1\" rows=\"1\"></textarea>\n</md-input-container></md-list-item></md-list><md-list><md-list-item \nclass=\"md-toolbar-tools grey-100-bg md-no-proxy _md\" role=\"listitem\" style=\"border-top: 1px solid gainsboro\"><h3 \nclass=\"grey-700-fg\" translate=\"FORMS.FIELDS\"></h3><md-divider></md-divider></md-list-item></md-list><md-list \ndragula=\"\'element\'\" dragula-model=\"vm.selectedContent.form_data.fields\"><md-list-item \nng-show=\"field.type !== \'media_footer\' && field.type !== \'media_header\'\" \nng-repeat=\"field in vm.selectedContent.form_data.fields track by $index\" class=\"md-block structure\" \nng-class=\"(!field.temporary && !field.editing) ? \'md-block structure\' : \'structure-edited\'\"><div layout=\"column\" \nlayout-align=\"center space-between\" flex><div ng-include=\"\'app/main/apps/forms/views/editors/editors-view.html\'\"></div>\n<div ng-include=\"\'app/main/apps/forms/views/editors/editors-editing.html\'\"></div></div><md-divider \nclass=\"md-default-theme\"></md-divider></md-list-item></md-list><md-input-container layout=\"row\" \nlayout-align=\"end center\" flex=\"\" class=\"pr-15\" ng-click=\"vm.addNewStructureField()\"><button \nclass=\"add-event-button md-fab md-warn md-button md-default-theme\" type=\"button\" aria-label=\"ADD\"><md-icon \nmd-font-icon=\"icon-plus\" role=\"img\" aria-hidden=\"true\"></md-icon></button></md-input-container></div></md-content>\n</form></div>");
$templateCache.put("app/main/apps/file-manager/sidenavs/details/details-sidenav.html","<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"vm.delete()\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"FM.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span \ntranslate=\"FM.DELETE\">Delete</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"Download\" \ntranslate translate-attr-aria-label=\"FM.DOWNLOAD\"><md-icon md-font-icon=\"icon-download\"></md-icon><md-tooltip><span \ntranslate=\"FM.DOWNLOAD\">Download</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" \ntranslate translate-attr-aria-label=\"FM.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon><md-tooltip><span \ntranslate=\"FM.MORE\">More</span></md-tooltip></md-button></div><div><div class=\"title\">{{vm.selected.name}}</div><div \nclass=\"subtitle secondary-text\"><span translate=\"FM.EDITED\">Edited</span>: {{vm.selected.modified}}</div></div></div>\n<md-content class=\"content\" flex ms-scroll><div class=\"file-details\"><div class=\"preview file-icon\" layout=\"row\" \nlayout-align=\"center center\"><i class=\"icon-{{vm.selected.type}} s48\"></i></div><md-list class=\"offline-switch\">\n<md-list-item><p translate=\"FM.AVAILABLE_OFFLINE\">Available Offline</p><md-switch class=\"md-secondary\" \nng-model=\"vm.selected.offline\" aria-label=\"Toggle offline\" translate translate-attr-aria-label=\"FM.TOOGLE_OFFLINE\">\n</md-switch></md-list-item></md-list><div class=\"title\" translate=\"FM.INFO\">Info</div><table><tr class=\"type\"><th \ntranslate=\"FM.TYPE\">Type</th><td>{{vm.selected.type}}</td></tr><tr class=\"size\"><th translate=\"FM.SIZE\">Size</th><td>\n{{vm.selected.size === \'\' ? \'-\': vm.selected.size}}</td></tr><tr class=\"location\"><th translate=\"FM.LOCATION\">Location\n</th><td>{{vm.selected.location}}</td></tr><tr class=\"owner\"><th translate=\"FM.OWNER\">Owner</th><td>\n{{vm.selected.owner}}</td></tr><tr class=\"modified\"><th translate=\"FM.MODIFIED\">Modified</th><td>\n{{vm.selected.modified}}</td></tr><tr class=\"opened\"><th translate=\"FM.OPENED\">Opened</th><td>{{vm.selected.opened}}\n</td></tr><tr class=\"created\"><th translate=\"FM.CREATED\">Created</th><td>{{vm.selected.created}}</td></tr></table>\n</div></md-content>");
$templateCache.put("app/main/apps/file-manager/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between start\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-folder\" class=\"icon s24\"></md-icon>\n</span><span class=\"logo-text\" translate=\"FM.FILE_MANAGER\">File Manager</span></div><div class=\"account\"><div \nclass=\"title\">John Doe</div><md-select class=\"account-selection simplified\" ng-model=\"vm.selectedAccount\" \nplaceholder=\"Select Account\"><md-option ng-repeat=\"(provider, address) in vm.accounts\" value=\"{{provider}}\">{{address}}\n</md-option></md-select></div></div><div class=\"content\"><div class=\"navigation-simple\" layout=\"column\"><md-button \nclass=\"item\" aria-label=\"inbox\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-folder\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.MY_FILES\">My Files</div></div>\n</md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-star\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.STARRED\">Starred</div></div>\n</md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-folder-account\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.SHARRED_WITH_ME\">\nSharred with me</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-clock\" class=\"s16\"></md-icon><div class=\"title\" \ntranslate=\"FM.RECENT\">Recent</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"s16\"></md-icon><div\n class=\"title\" translate=\"FM.OFFLINE\">Offline</div></div></md-button></div></div>");
$templateCache.put("app/main/apps/gantt-chart/dialogs/add-edit/add-dialog.html","<md-dialog class=\"gantt-chart-add-edit-dialog\" aria-label=\"Add Dialog\" ng-cloak><md-toolbar class=\"md-accent\" \nng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><h2 class=\"title\">Add</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"close dialog\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><md-tabs md-dynamic-height><md-tab><md-tab-label><span translate=\"GANTT.ADD_ROW\">Add Row</span>\n</md-tab-label><md-tab-body><div ng-include=\"\'app/main/apps/gantt-chart/dialogs/add-edit/views/row-form-view.html\'\">\n</div></md-tab-body></md-tab><md-tab><md-tab-label><span translate=\"GANTT.ADD_TASK\">Add Task</span></md-tab-label>\n<md-tab-body><div ng-include=\"\'app/main/apps/gantt-chart/dialogs/add-edit/views/task-form-view.html\'\"></div>\n</md-tab-body></md-tab></md-tabs></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/gantt-chart/dialogs/add-edit/edit-dialog.html","<md-dialog class=\"gantt-chart-add-edit-dialog\" aria-label=\"Edit Dialog\" ng-cloak><md-toolbar class=\"md-accent\" \nng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><h2 class=\"title\">Edit</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"close dialog\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll ng-if=\"vm.formView === \'row\'\" \nng-include=\"\'app/main/apps/gantt-chart/dialogs/add-edit/views/row-form-view.html\'\"></md-dialog-content>\n<md-dialog-content ms-scroll ng-if=\"vm.formView === \'task\'\" \nng-include=\"\'app/main/apps/gantt-chart/dialogs/add-edit/views/task-form-view.html\'\"></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/file-manager/views/grid/grid-view.html","<div class=\"grid-view\" layout=\"column\"><div class=\"folders\" layout=\"row\" layout-wrap><div \nclass=\"md-background-bg md-hue-1 md-whiteframe-1dp item folder\" ng-click=\"vm.select(folder)\" \nng-repeat=\"folder in vm.folders | filter:global.search\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" class=\"title\" layout-align=\"start center\"><span class=\"file-icon\"><md-icon \nmd-font-icon=\"icon-{{folder.type}}\"></md-icon></span><span class=\"name\">{{folder.name}}</span></div><div \nclass=\"show-details\" hide-gt-md><md-button class=\"md-icon-button sidenav-toggle\" aria-label=\"Details\" translate \ntranslate-attr-aria-label=\"FM.DETAILS\"><md-icon md-font-icon=\"icon-information-outline\" \nng-click=\"vm.toggleDetails(folder)\"></md-icon></md-button></div></div></div><div class=\"files\" layout=\"row\" \nlayout-wrap><div ng-click=\"vm.select(file)\" class=\"md-whiteframe-1dp item file\" \nng-repeat=\"file in vm.files | filter:global.search\" layout=\"column\"><div class=\"preview\"><img \nng-src=\"{{file.preview}}\"></div><div class=\"bottom md-background-bg md-hue-1\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" class=\"title\" layout-align=\"start center\" flex><span \nclass=\"file-icon\"><md-icon md-font-icon=\"icon-{{file.type}}\"></md-icon></span><span class=\"name\">{{file.name}}</span>\n</div><div class=\"show-details\" hide-gt-md><md-button class=\"md-icon-button sidenav-toggle\" aria-label=\"Details\" \ntranslate translate-attr-aria-label=\"FM.DETAILS\"><md-icon md-font-icon=\"icon-information-outline\" \nng-click=\"vm.toggleDetails(file)\"></md-icon></md-button></div></div></div></div></div>");
$templateCache.put("app/main/apps/file-manager/views/list/list-view.html","<table class=\"simple list-view\"><thead><tr><th></th><th translate=\"FM.NAME\">Name</th><th hide show-gt-sm \ntranslate=\"FM.TYPE\">Type</th><th hide-xs translate=\"FM.OWNER\">Owner</th><th hide-xs translate=\"FM.SIZE\">Size</th><th \nhide show-gt-md translate=\"FM.LAST_MODIFIED\">Last Modified</th><th hide-gt-md></th></tr></thead><tbody><tr \nng-repeat=\"folder in vm.folders | filter:global.search\" ng-click=\"vm.select(folder)\" \nng-class=\"{\'selected\' : vm.selected === folder}\"><td class=\"file-icon\"><md-icon md-font-icon=\"icon-{{folder.type}}\">\n</md-icon></td><td class=\"name\">{{folder.name}}</td><td class=\"type\" hide show-gt-sm>{{folder.type}}</td><td \nclass=\"owner\" hide-xs>{{folder.owner}}</td><td class=\"size\" hide-xs>{{folder.size === \'\' ? \'-\': folder.size}}</td><td \nclass=\"last-modified\" hide show-gt-md>{{folder.modified}}</td><td class=\"show-details\" hide-gt-md><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleDetails(folder)\" aria-label=\"Toggle details sidenav\"><md-icon \nmd-font-icon=\"icon-information-outline\"></md-icon></md-button></td></tr><tr \nng-repeat=\"file in vm.files | filter:global.search\" ng-click=\"vm.select(file)\" \nng-class=\"{\'selected\' : vm.selected === file}\"><td class=\"file-icon\"><md-icon md-font-icon=\"icon-{{file.type}}\">\n</md-icon></td><td class=\"name\">{{file.name}}</td><td class=\"type\" hide show-gt-sm>{{file.type}}</td><td class=\"owner\" \nhide-xs>{{file.owner}}</td><td class=\"size\" hide-xs>{{file.size === \'\' ? \'-\': file.size}}</td><td \nclass=\"last-modified\" hide show-gt-md>{{file.modified}}</td><td class=\"show-details\" hide-gt-md><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleDetails(file)\" aria-label=\"Details\" translate \ntranslate-attr-aria-label=\"FM.DETAILS\"><md-icon md-font-icon=\"icon-information-outline\"></md-icon></md-button></td>\n</tr></tbody></table>");
$templateCache.put("app/main/apps/mailing/dialogs/group/group-mailing.html","<md-dialog class=\"attachment-dialog add-media\" aria-label=\"New Message\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\"><div class=\"md-button\" \ntype=\"1\" layout=\"row\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-layers\" class=\"s18 mr-5 ml-0\"></md-icon>\n<span translate=\"MAILING.EDIT_GROUP\"></span></div></div><div layout=\"row\"><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate translate-aria-label=\"CONTENT.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></div></md-toolbar><md-dialog-content id=\"site-mailing\" \nms-scroll flex class=\"content-card\" ng-class=\"vm.currentView\" ng-include=\"vm.viewGroupField\"></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"end center\">\n<md-button ng-if=\"vm.modeView == \'creating\'\" ng-click=\"vm.save()\" class=\"send-button md-accent md-raised\">SAVE\n</md-button><md-button ng-if=\"vm.modeView == \'editing\'\" ng-click=\"vm.save()\" class=\"send-button md-accent md-raised\">\nADD</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/mailing/dialogs/group/group-view.html","<div class=\"form-wrapper md-whiteframe-1dp mr-16 ml-16 mt-16 mb-16\" flex=\"100\"><form name=\"vm.basicForm\" \nclass=\"md-inline-form\" novalidate><md-list ng-show=\"vm.modeView == \'creating\'\" ng-sortable=\"vm.templateSortable\" \nclass=\"sortable\" layout=\"column\" layout-align=\"center space-between\"><md-list-item \nng-repeat=\"formItem in vm.items track by $index\" ng-model=\"vm.items\" class=\"structure\" flex \nng-class=\"(!formItem.temporary && !formItem.editing) ? \'md-block structure\' : \'structure-edited\'\"><div layout=\"column\" \nlayout-align=\"center space-between\" flex><div ng-include=\"\'app/main/apps/mailing/views/editors/editors-view.html\'\">\n</div><div ng-include=\"\'app/main/apps/mailing/views/editors/editors-editing.html\'\"></div></div><md-divider \nclass=\"md-default-theme\"></md-divider></md-list-item></md-list><div ng-show=\"vm.modeView == \'editing\'\" \nclass=\"sortable\" ng-repeat=\"formItem in vm.items track by $index\" ng-switch=\"formItem.type\" ng-model=\"vm.items\" \nng-include=\"\'app/main/apps/mailing/views/editors/editors-fill.html\'\"></div></form><form \nng-show=\"vm.modeView == \'creating\'\" class=\"md-inline-form\" novalidate><md-list class=\"sortable\"><md-list-item \nclass=\"structure\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nng-click=\"vm.addNewStructureFieldGroup()\" class=\"add-event-button md-fab md-warn ml-0\" aria-label=\"ADD\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button><span class=\"font-size-16 grey-500-fg ml-5\" \ntranslate=\"MAILING.ADD_NEW_FIELD\"></span></div><md-divider class=\"md-default-theme\"></md-divider></md-list-item>\n</md-list></form></div>");
$templateCache.put("app/main/apps/mailing/dialogs/groups/groups-view.html","<md-dialog class=\"add-users-togroup\" aria-label=\"New Message\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><h1 class=\"title\" \ntranslate=\"MAILING.FILTER_BY_GROUPS\"></h1><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nid=\"site-mailing\" ms-scroll flex class=\"content-card\"><div ng-if=\"vm.groups\" ivh-treeview=\"vm.groups\" \nivh-treeview-expand-to-depth=\"0\" ivh-treeview-label-attribute=\"\'label\'\" class=\"ivh-treeview-folder small\"><script \ntype=\"text/ng-template\">\n<div class=\"level-card p-8 group-row select-parent-group-row\" layout=\"row\" layout-align=\"space-between stretch\">\r\n                    <span ivh-treeview-twistie ivh-treeview-toggle layout=\"row\" layout-align=\"center center\"></span>\r\n                    <div qiu-on-click-select-parent-group flex id=\"treeview-group-{{node.id_group}}\" data-group-node={{node}} layout=\"row\" layout-align=\"start center\">\r\n                        <div ng-if=\"node.group_type.icon\">\r\n                            <md-icon ng-if=\"node.group_type.icon\" \r\n                                md-font-icon=\"{{node.group_type.icon}}\" \r\n                                class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                        </div>\r\n                        <div ng-if=\"!node.group_type.icon\">\r\n                            <md-icon ng-if=\"!node.children && node.id_group_type == 1\" \r\n                                md-font-icon=\"icon-folder\" \r\n                                class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon \r\n                                ng-if=\"node.children && node.id_group_type == 1\" \r\n                                md-font-icon=\"icon-folder-multiple\" \r\n                                class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                                aria-hidden=\"true\" >\r\n                            </md-icon> \r\n                            <md-icon ng-if=\"!node.children && node.id_group_type == 2\" \r\n                                md-font-icon=\"qiu-icon-file-usermailing\" \r\n                                class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon \r\n                                ng-if=\"node.children && node.id_group_type == 2\" \r\n                                md-svg-src=\"/assets/icons/svg/icon-folder-mail-multiple.svg\"\r\n                                class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon ng-if=\"!node.children && node.id_group_type == 3\" \r\n                                md-font-icon=\"qiu-icon-file-usermediacenter\" \r\n                                class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon \r\n                                ng-if=\"node.children && node.id_group_type == 3\" \r\n                                md-svg-src=\"/assets/icons/svg/icon-folder-play-multiple.svg\"\r\n                                class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon ng-if=\"!node.children && node.id_group_type == 4\" \r\n                                md-font-icon=\"qiu-icon-file-usersegment\" \r\n                                class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon \r\n                                ng-if=\"node.children && node.id_group_type == 4\" \r\n                                md-svg-src=\"/assets/icons/svg/icon-folder-share-multiple.svg\"\r\n                                class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon ng-if=\"!node.children && node.id_group_type == 5\" \r\n                                md-font-icon=\"qiu-icon-file-userstore\" \r\n                                class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon \r\n                                ng-if=\"node.children && node.id_group_type == 5\" \r\n                                md-svg-src=\"/assets/icons/svg/icon-folder-shop-multiple.svg\"\r\n                                class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon ng-if=\"!node.children && node.id_group_type == 6\" \r\n                                md-font-icon=\"qiu-icon-file-useracreditation\" \r\n                                class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon \r\n                                ng-if=\"node.children && node.id_group_type == 6\" \r\n                                md-svg-src=\"/assets/icons/svg/icon-folder-board-multiple.svg\"\r\n                                class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon ng-if=\"!node.children && node.id_group_type == 7\" \r\n                                md-svg-src=\"/assets/icons/svg/icon-folder-chat.svg\"\r\n                                class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon \r\n                                ng-if=\"node.children && node.id_group_type == 7\" \r\n                                md-svg-src=\"/assets/icons/svg/icon-folder-chat-multiple.svg\"\r\n                                class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon ng-if=\"!node.children && node.id_group_type == 8\" \r\n                                md-font-icon=\"icon-folder-remove\" \r\n                                class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon \r\n                                ng-if=\"node.children && node.id_group_type == 8\" \r\n                                md-font-icon=\"icon-folder-multiple\" \r\n                                class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                                aria-hidden=\"true\" >\r\n                            </md-icon> \r\n                        </div>\r\n                        <span class=\"ivh-treeview-node-label ng-binding\">{{node.name}}</span>\r\n                    </div>\r\n                    <md-checkbox\r\n                          aria-label=\"assign group\"\r\n                          qiu-on-check-toggle-assigned-group\r\n                          class=\"ml-5 mb-0\" />\r\n                </div>\r\n                <div ivh-treeview-children></div>\n</script></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\">\n<md-input-container flex layout=\"row\" layout-align=\"end center\" class=\"m-0\"><md-button type=\"button\" \nclass=\"md-raised md-warn\" ng-click=\"vm.closeDialog()\" translate=\"GROUP.CANCEL\"></md-button><md-button \nng-click=\"vm.save()\" type=\"submit\" class=\"send-button md-accent md-raised\" ng-click=\"vm.save()\" translate=\"USERS.SAVE\">\n</md-button></md-input-container></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/mailing/dialogs/select-duplicate-template/select-duplicate-template.html","<md-dialog class=\"template-selector-duplicate\" style=\"width: 90%;max-width: 600px;min-width: 320px\" \naria-label=\"New Message\"><form class=\"md-inline-form\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><h1 class=\"title\" \ntranslate=\"MAILING.SELECT_TEMPLATE_TO_DUPLICATE\"></h1><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content id=\"site-mailing\" class=\"mt-15 mb-15 pl-30 pr-30\" ms-scroll flex class=\"content-card\"><md-select \nng-model=\"vm.selection\" placeholder=\"Templates\"><md-select-header><span>Templates:</span></md-select-header><md-option \nng-repeat=\"template in vm.templates\" ng-value=\"template.id_mailing_templates\">{{template.name}}</md-option></md-select>\n</md-dialog-content></form><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"end center\"><md-button ng-click=\"vm.save()\" class=\"send-button md-accent md-raised\">SAVE</md-button>\n<md-button ng-click=\"vm.closeDialog()\" class=\"send-button md-accent md-raised\">CANCEL</md-button></div>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/mailing/dialogs/review-content/review-content.html","<md-dialog class=\"mailing-review-content\" aria-label=\"Review content\"><form class=\"md-inline-form\" name=\"reviewForm\">\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<h1 class=\"title\" translate=\"MAILING.REVIEW_TITLE\"></h1><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content class=\"content-card review-content-body\" ms-scroll flex><div class=\"p-24\"><p \nclass=\"review-intro grey-600-fg\"><span translate=\"MAILING.REVIEW_INTRO\"></span> <strong ng-if=\"vm.sectionLabel\">\n{{ vm.sectionLabel }}</strong></p><div class=\"review-section\"><h3 class=\"review-section-title\" \ntranslate=\"MAILING.REVIEW_HEADER_FIELDS\"></h3><div class=\"review-empty grey-500-fg\" ng-if=\"!vm.headerFields.length\" \ntranslate=\"MAILING.REVIEW_NO_FIELDS\"></div><md-input-container class=\"md-block\" ng-repeat=\"field in vm.headerFields\">\n<label>{{ field.key }}</label><md-select ng-if=\"vm.isLanguageField(field.key) && vm.languages.length\" \nng-model=\"vm.content[field.key]\"><md-option ng-repeat=\"lang in vm.languages\" ng-value=\"lang.id_lang\">\n{{ vm.getLanguageLabel(lang) }}</md-option></md-select><input \nng-if=\"!vm.isLanguageField(field.key) || !vm.languages.length\" type=\"text\" ng-model=\"vm.content[field.key]\" \nng-readonly=\"vm.isReadOnly(field.key)\"></md-input-container></div><div class=\"review-section\"><h3 \nclass=\"review-section-title\"><span translate=\"MAILING.REVIEW_BLOCKS\"></span> <span class=\"review-count grey-500-fg\">\n({{ vm.blocks.length }})</span></h3><div class=\"review-empty grey-500-fg\" ng-if=\"!vm.blocks.length\" \ntranslate=\"MAILING.REVIEW_NO_BLOCKS\"></div><div class=\"rc-template-bar\" layout=\"row\" layout-align=\"start center\">\n<md-input-container class=\"md-block rc-template-select\"><label translate=\"MAILING.REVIEW_TEMPLATE\"></label><md-select \nng-model=\"vm.selectedTemplate\" ng-change=\"vm.onTemplateChange()\"><md-option ng-repeat=\"tpl in vm.templates\" \nng-value=\"tpl\">{{ tpl.template_name }}<span ng-if=\"tpl.default_template\"> ★</span></md-option></md-select>\n</md-input-container><span class=\"rc-template-hint grey-500-fg\" translate=\"MAILING.REVIEW_TEMPLATE_HINT\"></span></div>\n<iframe id=\"rc-preview-frame\" class=\"rc-preview-frame\"></iframe><div class=\"rc-canvas\" ng-if=\"false\" layout=\"row\" \nlayout-wrap layout-align=\"start start\" ng-sortable=\"vm.blocksSortable\"><div class=\"rc-block\" \nng-repeat=\"block in vm.blocks\" ng-class=\"[\'rc-size-\' + block.size, {\'rc-editing\': vm.isEditing($index)}]\"><div \nclass=\"rc-block-bar\" layout=\"row\" layout-align=\"space-between center\"><span class=\"rc-block-drag\" \ntitle=\"{{ \'MAILING.REVIEW_DRAG\' | translate }}\"><md-icon md-font-icon=\"icon-drag\"></md-icon><span \nclass=\"rc-block-type\">{{ vm.getBlockLabel(block, $index) }}</span> </span><span layout=\"row\" layout-align=\"end center\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.toggleEdit($index)\" aria-label=\"Edit block\"><md-icon \nmd-font-icon=\"{{ vm.isEditing($index) ? \'icon-check\' : \'icon-pencil\' }}\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.removeBlock($index)\" aria-label=\"Remove block\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"red-500-fg\"></md-icon></md-button></span></div><div class=\"rc-block-preview\" ng-if=\"!vm.isEditing($index)\" \nng-click=\"vm.toggleEdit($index)\"><div class=\"rc-title\" ng-if=\"block.type === \'title\'\"><h3 ng-if=\"block.subtitle\">\n{{ block.subtitle }}</h3><div ng-if=\"block.text\" ng-bind-html=\"vm.trustHtml(block.text)\"></div></div><div \nclass=\"rc-text\" ng-if=\"block.type === \'text\'\" ng-bind-html=\"vm.trustHtml(block.text)\"></div><figure class=\"rc-image\" \nng-if=\"block.type === \'image\'\"><img ng-if=\"vm.getMediaPreview(block.media[0])\" \nng-src=\"{{ vm.getMediaPreview(block.media[0]) }}\" alt=\"\"><figcaption ng-if=\"block.media[0].caption\">\n{{ block.media[0].caption }}</figcaption></figure><hr class=\"rc-divider\" ng-if=\"block.type === \'divider\'\"><div \nclass=\"rc-button\" ng-if=\"block.type === \'button\'\"><span>{{ block.text }}</span></div><div class=\"rc-generic\" \nng-if=\"!vm.hasVisualPreview(block)\"><md-icon md-font-icon=\"icon-puzzle\"></md-icon><span>{{ block.type }}</span><div \nclass=\"rc-generic-text\" ng-if=\"block.text\" ng-bind-html=\"vm.trustHtml(block.text)\"></div></div></div><div \nclass=\"rc-block-edit\" ng-if=\"vm.isEditing($index)\"><md-input-container class=\"md-block\" \nng-repeat=\"field in vm.getBlockFields(block)\"><label>{{ field.key }}</label><textarea ng-model=\"block[field.key]\" \nrows=\"4\" md-select-on-focus></textarea></md-input-container><div class=\"rc-edit-media\" \nng-repeat=\"media in block.media\"><img class=\"review-media-thumb\" ng-if=\"vm.getMediaPreview(media)\" \nng-src=\"{{ vm.getMediaPreview(media) }}\" alt=\"\"><md-input-container class=\"md-block\" flex><label \ntranslate=\"MAILING.REVIEW_CAPTION\"></label><textarea ng-model=\"media.caption\" rows=\"2\"></textarea></md-input-container>\n</div></div></div></div><div class=\"rc-editor-panel\" ng-if=\"vm.editingIndex >= 0 && vm.blocks[vm.editingIndex]\"><div \nclass=\"rc-editor-head\" layout=\"row\" layout-align=\"space-between center\"><span class=\"rc-editor-title\">\n{{ vm.getBlockLabel(vm.blocks[vm.editingIndex], vm.editingIndex) }}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.editingIndex = -1\" aria-label=\"Close editor\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div><md-input-container class=\"md-block\" ng-repeat=\"field in vm.getBlockFields(vm.blocks[vm.editingIndex])\"><label>\n{{ field.key }}</label><textarea ng-model=\"vm.blocks[vm.editingIndex][field.key]\" rows=\"4\" \nng-change=\"vm.refreshPreview()\" ng-model-options=\"{debounce: 400}\"></textarea></md-input-container><div \nclass=\"rc-edit-media\" ng-repeat=\"media in vm.blocks[vm.editingIndex].media\"><img class=\"review-media-thumb\" \nng-if=\"vm.getMediaPreview(media)\" ng-src=\"{{ vm.getMediaPreview(media) }}\" alt=\"\"><md-input-container class=\"md-block\" \nflex><label translate=\"MAILING.REVIEW_CAPTION\"></label><textarea ng-model=\"media.caption\" rows=\"2\" \nng-change=\"vm.refreshPreview()\" ng-model-options=\"{debounce: 400}\"></textarea></md-input-container></div></div></div>\n<div class=\"review-section\"><h3 class=\"review-section-title\"><span translate=\"MAILING.REVIEW_IMAGES\"></span> <span \nclass=\"review-count grey-500-fg\">({{ vm.thumbnails.length }})</span></h3><div class=\"review-empty grey-500-fg\" \nng-if=\"!vm.thumbnails.length\" translate=\"MAILING.REVIEW_NO_IMAGES\"></div><div class=\"review-thumb-row\" \nng-repeat=\"thumb in vm.thumbnails\" layout=\"row\" layout-align=\"start center\"><img class=\"review-media-thumb\" \nng-if=\"vm.getMediaPreview(thumb)\" ng-src=\"{{ vm.getMediaPreview(thumb) }}\" alt=\"\"><div class=\"review-thumb-info\" flex>\n<span class=\"review-thumb-name\">{{ thumb.filename || thumb.title }}</span> <span class=\"review-thumb-zone grey-500-fg\" \nng-if=\"thumb.id_zone\"><span translate=\"MAILING.REVIEW_ZONE\"></span> {{ thumb.id_zone }}</span></div><md-button \nclass=\"md-icon-button\" ng-click=\"vm.removeThumbnail($index)\" aria-label=\"Remove image\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"red-500-fg\"></md-icon><md-tooltip><span translate=\"MAILING.REVIEW_REMOVE_IMAGE\">\n</span></md-tooltip></md-button></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"end center\"><md-button ng-click=\"vm.cancel()\" class=\"send-button md-raised\" \ntranslate=\"MAILING.REVIEW_CANCEL\"></md-button><md-button ng-click=\"vm.confirm()\" \nclass=\"send-button md-accent md-raised\" translate=\"MAILING.REVIEW_CONFIRM\"></md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/apps/mailing/dialogs/select-group-dialog/select-group-dialog.html","<md-dialog class=\"copy-move-togroup\" style=\"width: 90%;max-width: 600px;min-width: 320px\" aria-label=\"New Message\">\n<form class=\"md-inline-form\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><h1 class=\"title\" translate=\"MAILING.SELECT_SUBSCRIPTION_GROUP\"></h1><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content id=\"site-mailing\" ms-scroll flex class=\"content-card\">\n<md-toolbar class=\"md-default-theme grey-100-bg grey-600-fg\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\"><label for=\"search-bar-input\"><md-icon ng-if=\"!vm.treeSearch\" md-font-icon=\"icon-magnify\" \nstyle=\"padding-top: 20px\" class=\"grey-600-fg md-icon-button md-button\"><md-tooltip hide show-gt-xs><span \ntranslate=\"TOOLBAR.SEARCH\">Search</span></md-tooltip></md-icon><md-icon layout-align=\"end center\" \nmd-font-icon=\"icon-close-circle\" class=\"grey-600-fg md-icon-button md-button\" ng-if=\"vm.treeSearch\" \nng-click=\"vm.treeSearch= null\"></md-icon></label><input type=\"text\" id=\"search-bar-input\" \nclass=\"grey-600-fg grey-100-bg\" ng-model=\"vm.treeSearch\" placeholder=\"Search\" md-autofocus translate \ntranslate-attr-placeholder=\"TOOLBAR.SEARCH\" flex></div></md-toolbar><div ng-if=\"vm.CleanUsersGroups\" \nivh-treeview=\"vm.CleanUsersGroups\" ivh-treeview-filter=\"vm.treeSearch\" ivh-treeview-label-attribute=\"\'label\'\" \nclass=\"ivh-treeview-folder small\" ivh-treeview-on-cb-change=\"callback()\"><script type=\"text/ng-template\">\n<span style=\"position: absolute;left: 5px;margin-top: 15px;\" ivh-treeview-twistie ivh-treeview-toggle layout=\"row\" layout-align=\"center center\"></span>\r\n                    <div  data-group-node={{node}} qiu-users-on-select-group class=\"level-card group-row ml-15 pointer\" layout=\"row\" layout-align=\"space-between stretch\">\r\n                        <div  flex id=\"treeview-group-{{node.id_group}}\"  layout=\"row\" layout-align=\"start center\">\r\n                            <md-icon ng-if =\"!node.children && node.id_group_type == 1\" \r\n                                md-font-icon=\"icon-folder\" \r\n                                class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon ng-if =\"!node.children && node.id_group_type == 2\" \r\n                                md-font-icon=\"qiu-icon-file-usermailing\" \r\n                                class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon \r\n                                ng-if =\"node.children && node.id_group_type == 2\" \r\n                                md-svg-src=\"/assets/icons/svg/icon-folder-mail-multiple.svg\"\r\n                                class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon ng-if =\"!node.children && node.id_group_type == 3\" \r\n                                md-font-icon=\"qiu-icon-file-usermediacenter\" \r\n                                class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon \r\n                                ng-if =\"node.children && node.id_group_type == 3\" \r\n                                md-svg-src=\"/assets/icons/svg/icon-folder-play-multiple.svg\"\r\n                                class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon ng-if =\"!node.children && node.id_group_type == 4\" \r\n                                md-font-icon=\"qiu-icon-file-usersegment\" \r\n                                class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon \r\n                                ng-if =\"node.children && node.id_group_type == 4\" \r\n                                md-svg-src=\"/assets/icons/svg/icon-folder-share-multiple.svg\"\r\n                                class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon ng-if =\"!node.children && node.id_group_type == 5\" \r\n                                md-font-icon=\"qiu-icon-file-userstore\" \r\n                                class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon \r\n                                ng-if =\"node.children && node.id_group_type == 5\" \r\n                                md-svg-src=\"/assets/icons/svg/icon-folder-shop-multiple.svg\"\r\n                                class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon ng-if =\"!node.children && node.id_group_type == 6\" \r\n                                md-font-icon=\"qiu-icon-file-useracreditation\" \r\n                                class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon \r\n                                ng-if =\"node.children && node.id_group_type == 6\" \r\n                                md-svg-src=\"/assets/icons/svg/icon-folder-board-multiple.svg\"\r\n                                class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon ng-if =\"!node.children && node.id_group_type == 7\" \r\n                                md-svg-src=\"/assets/icons/svg/icon-folder-chat.svg\"\r\n                                class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon \r\n                                ng-if =\"node.children && node.id_group_type == 7\" \r\n                                md-svg-src=\"/assets/icons/svg/icon-folder-chat-multiple.svg\"\r\n                                class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon ng-if =\"!node.children && node.id_group_type == 8\" \r\n                                md-font-icon=\"icon-folder-remove\" \r\n                                class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon \r\n                                ng-if =\"node.children && node.id_group_type == 8\" \r\n                                md-font-icon=\"icon-folder-multiple\" \r\n                                class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                                aria-hidden=\"true\" >\r\n                            </md-icon> \r\n                            <md-icon \r\n                                ng-if =\"node.children && node.id_group_type == 1\" \r\n                                md-font-icon=\"icon-folder-multiple\" \r\n                                class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            \r\n                            <span class=\"ivh-treeview-node-label ng-binding\">{{node.name}}</span>\r\n    \r\n                        </div> \r\n    \r\n                    </div>\r\n                    <div ivh-treeview-children></div>\n</script></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/mailing/dialogs/select-section/select-section.html","<md-dialog class=\"section-selector\" style=\"width: 90%;max-width: 600px;min-width: 320px\" aria-label=\"New Case Text\">\n<form class=\"md-inline-form\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><h1 class=\"title\" translate=\"MAILING.SELECT_SECTION\"></h1><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content id=\"site-mailing\" class=\"mt-15 mb-15 pl-30 pr-30\" \nms-scroll flex class=\"content-card\"><md-select ng-model=\"vm.selection\" placeholder=\"Sections\"><md-select-header><span>\nSections:</span></md-select-header><md-option ng-repeat=\"section in vm.sections\" ng-value=\"section\">{{section.label}}\n</md-option></md-select></md-dialog-content></form><md-dialog-actions layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.save()\" class=\"send-button md-accent md-raised\">\nSAVE</md-button><md-button ng-click=\"vm.closeDialog()\" class=\"send-button md-accent md-raised\">CANCEL</md-button></div>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/mailing/dialogs/select-template/select-template.html","<md-dialog class=\"template-selector\" style=\"width: 90%;max-width: 600px;min-width: 320px\" aria-label=\"Select template\">\n<form class=\"md-inline-form\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><h1 class=\"title\" translate=\"MAILING.SELECT_TEMPLATE\"></h1><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content id=\"site-mailing\" class=\"mt-15 mb-15 pl-30 pr-30\" \nms-scroll flex class=\"content-card\"><md-select ng-model=\"vm.selection\" placeholder=\"Templates\"><md-select-header><span>\nTemplates:</span></md-select-header><md-option ng-repeat=\"template in vm.templates\" \nng-value=\"template.id_mailing_templates\">{{template.name}}</md-option></md-select></md-dialog-content></form>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"end center\">\n<md-button ng-click=\"vm.save()\" class=\"send-button md-accent md-raised\" translate=\"MAILING.SELECT\">SAVE</md-button>\n<md-button ng-click=\"vm.closeDialog()\" class=\"send-button md-accent md-raised\" translate=\"MAILING.CANCEL\">CANCEL\n</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/mailing/dialogs/users-ingroup/users-ingroup-mailing.html","<md-dialog class=\"attachment-dialog medium mailing-users\" aria-label=\"Users In Group\"><md-toolbar \nclass=\"md-accent pr-5\" layout=\"row\" layout-align=\"space-between\"><h1 class=\"mr-0 flex-100 title ng-binding\" \nlayout=\"row\" layout-align=\"start center\" style=\"line-height: 1\"><md-icon md-font-icon=\"icon-people\" \nclass=\"mr-10 ml-0 md-font\" role=\"img\" aria-label=\"icon-people\"></md-icon><span>{{vm.groupName}}</span></h1><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-aria-label=\"CONTENT.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-toolbar>\n<md-dialog-content flex class=\"content-card\"><div \nstyle=\"background: white;height: 500px;min-height: 500px;max-height: 500px\" ng-include=\"vm.currentView\"></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><div layout=\"row\" \nlayout-align=\"start center\"></div><div layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.closeDialog()\" \nclass=\"send-button md-accent md-raised\">CLOSE</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/mailing/dialogs/send-later/send-later.html","<md-dialog class=\"send-later small attachment-dialog\" aria-label=\"Users In Group\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" class=\"pl-20\"><md-icon \nmd-font-icon=\"icon-calendar-clock\" role=\"icon\" aria-hidden=\"true\"></md-icon><span class=\"ml-10\" \ntranslate=\"MAILING.SCHEDULE\"></span></div><div layout=\"row\"><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-aria-label=\"CONTENT.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></div></md-toolbar><md-dialog-content flex class=\"content-card\">\n<div class=\"form-wrapper date-picker-mailing ph-20 pt-20 pb-0\" flex=\"100\"><form layout=\"column\" layout-gt-md=\"row\"><div\n flex class=\"date-container\"><mdp-date-picker mdp-placeholder=\"Date\" mdp-format=\"{{vm.dateFormat}}\" \nmdp-open-on-click=\"true\" ng-model=\"vm.schedule.date\" ng-change=\"vm.changeDatePicker()\" class=\"date-time-picker\">\n</mdp-date-picker></div><div flex class=\"date-container\"><mdp-time-picker mdp-placeholder=\"Time\" \nng-model=\"vm.schedule.date\" ng-change=\"vm.changeDatePicker()\" class=\"date-time-picker\"></mdp-time-picker></div><div \nflex class=\"date-container\"><md-input-container class=\"md-block\"><label>UTC Date</label><input type=\"text\" \nng-model=\"vm.schedule.utcShow\" disabled=\"disabled\"></md-input-container></div></form></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-button ng-click=\"vm.cancelDialog()\" translate-attr-aria-label=\"MAILING.CANCEL_SCHEDULE\" \nclass=\"send-button md-warn md-raised\"><md-icon md-font-icon=\"icon-calendar-remove\" role=\"icon\" aria-hidden=\"true\">\n</md-icon><span translate=\"MAILING.CANCEL_SCHEDULE\"></span></md-button></div><div layout=\"row\" \nlayout-align=\"end center\"><md-button ng-click=\"vm.saveDialog()\" class=\"send-button md-accent md-raised\" \ntranslate-attr-aria-label=\"MAILING.SAVE\"><span translate=\"MAILING.SAVE\"></span></md-button></div></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/apps/gantt-chart/sidenavs/settings/settings-sidenav.html","<md-toolbar class=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" \naria-label=\"Settings\"><md-icon md-font-icon=\"icon-cog\"></md-icon></md-button><h2><span>Settings</span></h2></div>\n</md-toolbar><md-content class=\"content\" layout-padding><md-list><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"GANTT.EDIT\">Edit</span></md-subheader><md-list-item><md-icon md-font-icon=\"icon-pencil\"></md-icon><p \ntranslate=\"GANTT.DRAW\">Draw</p><md-checkbox class=\"md-secondary\" ng-model=\"vm.options.draw\"></md-checkbox>\n</md-list-item><md-list-item><md-icon md-font-icon=\"icon-lock\"></md-icon><p translate=\"GANTT.READ_ONLY\">Read only</p>\n<md-checkbox class=\"md-secondary\" ng-model=\"vm.options.readOnly\"></md-checkbox></md-list-item><md-divider></md-divider>\n<md-subheader class=\"md-no-sticky\"><span translate=\"GANTT.SNAP\">Snap</span></md-subheader><md-list-item><md-icon \nmd-font-icon=\"icon-magnet\"></md-icon><p translate=\"GANTT.SNAP_AREA\">Snap area</p><md-select \nclass=\"simplified md-secondary\" ng-model=\"vm.options.columnMagnet\" placeholder=\"Snap area\"><md-option value=\"column\" \ntranslate=\"GANTT.COLUMN\">Column</md-option><md-option value=\"1 second\" translate=\"GANTT.1_SECOND\">1 second</md-option>\n<md-option value=\"1 minute\" translate=\"GANTT.1_MINUTE\">1 minute</md-option><md-option value=\"5 minutes\" \ntranslate=\"GANTT.5_MINUTES\">5 minutes</md-option><md-option value=\"15 minutes\" translate=\"GANTT.15_MINUTES\">15 minutes\n</md-option><md-option value=\"1 hour\" translate=\"GANTT.1_HOUR\">1 hour</md-option><md-option value=\"1 day\" \ntranslate=\"GANTT.1_DAY\">1 day</md-option><md-option value=\"5 days\" translate=\"GANTT.5_DAYS\">5 days</md-option>\n</md-select></md-list-item><md-list-item><md-icon md-font-icon=\"icon-view-day\"></md-icon><p translate=\"GANTT.DAILY\">\nDaily</p><md-checkbox class=\"md-secondary\" ng-model=\"vm.options.daily\"></md-checkbox></md-list-item><md-list-item>\n<md-icon md-font-icon=\"icon-lock\"></md-icon><p translate=\"GANTT.TIME_FRAMES\">Time frames</p><md-checkbox \nclass=\"md-secondary\" ng-model=\"vm.options.timeFramesMagnet\"></md-checkbox></md-list-item><md-divider></md-divider>\n<md-subheader class=\"md-no-sticky\"><span translate=\"GANTT.SIDEBAR\">Sidebar</span></md-subheader><md-list-item><md-icon \nmd-font-icon=\"icon-eye\"></md-icon><p translate=\"GANTT.SHOW_SIDEBAR\">Show Sidebar</p><md-checkbox class=\"md-secondary\" \nng-model=\"vm.options.labelsEnabled\"></md-checkbox></md-list-item><md-list-item><md-icon md-font-icon=\"icon-code-tags\">\n</md-icon><p translate=\"GANTT.RESIZABLE\">Resizable</p><md-checkbox class=\"md-secondary\" \nng-model=\"vm.options.allowSideResizing\"></md-checkbox></md-list-item><md-list-item><md-icon \nmd-font-icon=\"icon-view-headline\"></md-icon><p translate=\"GANTT.LIST_MODE\">List Mode</p><md-select \nclass=\"simplified md-secondary\" ng-model=\"vm.options.sideMode\" placeholder=\"List\"><md-option value=\"Tree\" \ntranslate=\"GANTT.TREE\">Tree</md-option><md-option value=\"Table\" translate=\"GANTT.TABLE\">Table</md-option><md-option \nvalue=\"TreeTable\" translate=\"GANTT.TREE_TABLE\">TreeTable</md-option><md-option value=\"Disabled\" \ntranslate=\"GANTT.DISABLED\">Disabled</md-option></md-select></md-list-item><md-divider></md-divider><md-subheader \nclass=\"md-no-sticky\"><span translate=\"GANTT.TIMELINE\">Timeline</span></md-subheader><md-list-item><md-icon \nmd-font-icon=\"icon-view-headline\"></md-icon><p translate=\"GANTT.GROUPS\">Groups</p><md-select \nclass=\"simplified md-secondary\" ng-model=\"vm.options.groupDisplayMode\" placeholder=\"Groups\"><md-option value=\"group\" \ntranslate=\"GANTT.GROUP\">Group</md-option><md-option value=\"overview\" translate=\"GANTT.OVERVIEW\">Overview</md-option>\n<md-option value=\"promote\" translate=\"GANTT.PROMOTE\">Promote</md-option><md-option value=\"Disabled\" \ntranslate=\"GANTT.DISABLED\">Disabled</md-option></md-select></md-list-item><md-divider></md-divider><md-list-item>\n<md-icon md-font-icon=\"icon-calendar-today\"></md-icon><p translate=\"GANTT.TODAY\">Today</p><md-select \nclass=\"simplified md-secondary\" ng-model=\"vm.options.currentDate\" placeholder=\"Today\"><md-option value=\"none\" \ntranslate=\"GANTT.NONE\">None</md-option><md-option value=\"line\" translate=\"GANTT.LINE\">Line</md-option><md-option \nvalue=\"column\" translate=\"GANTT.COLUMN\">Column</md-option></md-select></md-list-item><md-divider></md-divider>\n<md-list-item><md-icon md-font-icon=\"icon-arrow-expand\"></md-icon><p translate=\"GANTT.EXPAND\">Expand</p><md-select \nclass=\"simplified md-secondary\" ng-model=\"vm.options.autoExpand\" placeholder=\"Today\"><md-option value=\"none\" \ntranslate=\"GANTT.NONE\">None</md-option><md-option value=\"both\" translate=\"GANTT.BOTH\">Both</md-option><md-option \nvalue=\"left\" translate=\"GANTT.LEFT\">Left</md-option><md-option value=\"right\" translate=\"GANTT.RIGHT\">Right</md-option>\n</md-select></md-list-item><md-divider></md-divider><md-list-item><md-icon md-font-icon=\"icon-content-cut\"></md-icon><p\n translate=\"GANTT.OUT_OF_RANGE\">Out of range</p><md-select class=\"simplified md-secondary\" \nng-model=\"vm.options.taskOutOfRange\" placeholder=\"Out of range\"><md-option value=\"expand\" translate=\"GANTT.EXPAND\">\nEXPAND</md-option><md-option value=\"truncate\" translate=\"GANTT.TRUNCATE\">Truncate</md-option></md-select>\n</md-list-item><md-divider></md-divider></md-list></md-content>");
$templateCache.put("app/main/apps/mailing/views/editors/editors-add-media.html","<div class=\"attachments\"><div class=\"field\"><p class=\"grey-500-fg ml-8\">{{ mediazone.title }}</p><div \nclass=\"attachment-list sortable md-list-item-text\" ng-sortable=\"vm.mediaSortable\"><div class=\"attachment\" \nlayout=\"column\" ng-repeat=\"attachment in vm.currentThread_Edit[mediazone.id_zone] track by $index\"><div \nclass=\"preview document\" layout=\"row\" layout-align=\"start center\" extension-class=\"{{attachment.filename}}\" \nng-href=\"{{attachment.permalink}}\" ng-if=\"attachment.media_type==3\" target=\"_blank\"><qiu-icon \nmediafile=\"attachment.filename\" class=\"mr-10\"></qiu-icon><a class=\"grey-1000-fg font-size-16\" \nng-href=\"{{attachment.permalink}}\" target=\"_blank\"><span ng-if=\"attachment.title\">{{attachment.title}}</span> <span \nng-if=\"attachment.filename\">{{attachment.filename}}</span></a></div><div \nng-if=\"attachment.media_type==1 || attachment.media_type==2 || attachment.media_type==4\"><div class=\"ms-card\" flex \nmd-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"ms-card-content-wrapper\"><div class=\"template-9\"><div \nclass=\"media\" flex layout=\"row\" layout-align=\"center center\" \nng-if=\"attachment.media_type==1 || attachment.media_type==2\"><media attachment=\"attachment\" class=\"image\" \nng-click=\"vm.openImageDialog($event, mediazone, $index)\"></media></div><div flex layout=\"column\" \nlayout-align=\"center center\" class=\"media\" ng-if=\"attachment.media_type==4\"><qiu-icon mediafile=\"attachment.filename\" \nclassextra=\"s56\"></qiu-icon><br><span class=\"grey-500-fg\" layout=\"column\" layout-align=\"center center\"><span \nng-if=\"attachment.title\"><strong>{{attachment.title}}</strong> </span><span ng-if=\"attachment.filename\">\n{{attachment.filename}}</span></span></div><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"size block\" layout=\"row\" layout-align=\"start center\"><strong class=\"mr-5\">#{{attachment.id_media}}</strong> \n<span class=\"grey-500-fg\" ng-if=\"attachment.media_type==1 || attachment.media_type==2\">{{attachment.filename}}</span>\n</div><md-menu><button class=\"md-icon-button\" aria-label=\"More\" translate translate-attr-aria-label=\"TODO.MORE\">\n<md-icon md-font-icon=\"icon-dots-vertical\" ng-click=\"$mdMenu.open($event)\"></md-icon></button><md-menu-content \nwidth=\"3\"><md-menu-item><md-button ng-if=\"attachment.media_type==1 || attachment.media_type==2\" \nng-click=\"vm.openImageDialog($event, mediazone, $index)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.PREVIEW\"><md-icon md-font-icon=\"icon-eye\" class=\"ml-10\" href=\"#\" \nng-click=\"vm.openImageDialog($event, mediazone, $index)\"></md-icon><span translate=\"CONTENT.PREVIEW\">Preview</span>\n</md-button><md-button ng-if=\"attachment.media_type==4\" ng-click=\"vm.openUrl(attachment.permalink)\" target=\"_blank\" \naria-label=\"Toggle done\" translate-attr-aria-label=\"CONTENT.PREVIEW\"><md-icon md-font-icon=\"icon-open-in-new\" \nclass=\"ml-10\"></md-icon><span translate=\"CONTENT.OPEN\">Open</span></md-button></md-menu-item><md-menu-item \nng-if=\"attachment.media_type==1\"><md-button ng-click=\"vm.openFocalPoint($event, mediazone, $index)\" \naria-label=\"Toggle done\" translate-attr-aria-label=\"CONTENT.SET_FOCAL_POINT\"><md-icon \nmd-font-icon=\"icon-image-filter-center-focus\" class=\"s18\"></md-icon><span translate=\"CONTENT.SET_FOCAL_POINT\">\nSet Focal point</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.openMediaItemMetadata($event, mediazone, $index)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.MEDIA_ITEM_EDIT_METADATA\"><md-icon md-font-icon=\"icon-message-image\" class=\"s18\">\n</md-icon><span translate=\"CONTENT.MEDIA_ITEM_EDIT_METADATA\">Edit Metadata</span></md-button></md-menu-item>\n<md-menu-item ng-if=\"attachment.media_type==1\"><md-button ng-click=\"vm.MediaItemRecrop(attachment,mediazone, $index)\" \naria-label=\"Toggle done\" translate-attr-aria-label=\"CONTENT.MEDIA_ITEM_RECROP\"><md-icon md-font-icon=\"icon-image\" \nclass=\"s18\"></md-icon><span translate=\"CONTENT.MEDIA_ITEM_RECROP\">Recrop Image</span></md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.deleteAttachment(mediazone, $index)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.REMOVE\"><md-icon md-font-icon=\"icon-close\" class=\"s18\"></md-icon><span \ntranslate=\"CONTENT.REMOVE\">Remove</span></md-button></md-menu-item></md-menu-content></md-menu></div></div></div></div>\n</div></div></div><md-button class=\"add-event-button no-sort md-fab md-warn\" \nng-click=\"vm.mediaDialog($event, mediazone, vm.currentThread_Edit)\" aria-label=\"Add event\" translate \ntranslate-attr-aria-label=\"CALENDAR.ADD_EVENT\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div>");
$templateCache.put("app/main/apps/mailing/views/editors/editors-editing.html","<div ng-if=\"formItem.temporary || formItem.editing\" class=\"layout-wrap layout-sm-column layout-row newfield\"><div \nflex=\"50\"><md-input-container class=\"md-block\"><label translate=\"MAILING.FIELD_TYPE\"></label><md-select \nng-model=\"formItem.type\"><md-option ng-repeat=\"typeField in vm.typeFields\" ng-value=\"typeField\"><span \nng-switch=\"typeField\"><md-icon md-font-icon=\"icon-calendar-clock\" class=\"mr-5 s20\" ng-switch-when=\"datePicker\">\n</md-icon><md-icon md-font-icon=\"icon-format-text\" class=\"mr-5 s20\" ng-switch-when=\"textBox\"></md-icon><md-icon \nmd-font-icon=\"icon-format-float-left\" class=\"mr-5 s20\" ng-switch-when=\"htmlBox\"></md-icon><md-icon \nmd-font-icon=\"icon-file-image-box\" class=\"mr-5 s20\" ng-switch-when=\"media\"></md-icon><md-icon md-font-icon=\"icon-tag\" \nclass=\"mr-5 s20\" ng-switch-when=\"separator\"></md-icon><md-icon md-font-icon=\"icon-window-minimize\" class=\"mr-5 s20\" \nng-switch-when=\"lineSeparator\"></md-icon><md-icon md-font-icon=\"icon-layers\" class=\"mr-5 s20\" ng-switch-when=\"group\">\n</md-icon><md-icon md-font-icon=\"icon-checkbox-marked-outline\" class=\"mr-5 s20\" ng-switch-when=\"checkbox\"></md-icon>\n<md-icon md-font-icon=\"icon-eyedropper\" class=\"mr-5 s20\" ng-switch-when=\"colorPicker\"></md-icon><md-icon \nmd-font-icon=\"icon-repeat\" class=\"mr-5 s20\" ng-switch-when=\"relatedTable\"></md-icon><md-icon \nmd-font-icon=\"icon-link-variant\" class=\"mr-5 s20\" ng-switch-when=\"previewLink\"></md-icon><md-icon \nmd-font-icon=\"icon-thumb-up-outline\" class=\"mr-5 s20\" ng-switch-when=\"social\"></md-icon></span>{{typeField}}\n</md-option></md-select></md-input-container></div><div flex=\"50\" ng-if=\"formItem.type !== \'separator\' \">\n<md-input-container class=\"md-block\"><label translate=\"MAILING.FIELD_NAME\"></label><textarea ng-model=\"formItem.label\" \ncolumns=\"1\" rows=\"1\" placeholder=\"{{vm.translate(\'MAILING.FIELD_NAME\')}}\"></textarea></md-input-container></div><div \nng-switch=\"formItem.type\" \nng-class=\"(formItem.type === \'media\' || formItem.type === \'htmlBox\' || formItem.type === \'textBox\' || formItem.type === \'datePicker\' || formItem.type === \'lineSeparator\' || formItem.type === \'previewLink\' || formItem.type === \'social\') ? \'flex-100\' :  \'flex-50\'\">\n<md-input-container ng-switch-when=\"separator\" class=\"md-block\"><label translate=\"MAILING.LABEL\"></label><textarea \nng-model=\"formItem.label\" columns=\"1\" rows=\"1\" placeholder=\"{{vm.translate(\'MAILING.LABEL\')}}\"></textarea>\n</md-input-container><md-input-container class=\"md-block\" ng-switch-when=\"textBox\"><label \ntranslate=\"MAILING.DEFAULT_VALUE\"></label><textarea ng-model=\"formItem.defaultValue\" columns=\"1\" rows=\"1\"></textarea>\n</md-input-container><md-input-container ng-switch-when=\"checkbox\" class=\"md-block\"><md-checkbox \nng-init=\"!formItem.defaultValue ?  formItem.defaultValue = false : true\" ng-model=\"formItem.defaultValue\">\n</md-checkbox><span translate=\"MAILING.CHECKED_BY_DEFAULT\"></span></md-input-container><div \nng-switch-when=\"colorPicker\" md-color-picker-custom ng-model=\"formItem.defaultValue\" default=\"#dddddd\" \nmd-color-generic-palette=\"false\" md-color-hsl=\"false\" md-color-rgb=\"false\" md-color-history=\"false\" \nlabel=\"{{vm.translate(\'MAILING.COLOR\')}}\"></div><md-input-container flex class=\"md-block md-input-has-value\" \nng-switch-when=\"htmlBox\"><label translate=\"MAILING.DEFAULT_VALUE\"></label><textarea ui-tinymce=\"vm.tinymceOptions\" \nng-model=\"formItem.defaultValue\"></textarea></md-input-container><div ng-switch-when=\"datePicker\" layout=\"row\" \nlayout-align=\"space-between center\" flex><md-input-container class=\"md-block\" flex=\"50\"><label \ntranslate=\"MAILING.DATE_FORMAT\"></label><md-select ng-model=\"formItem.dateFormat\" \nplaceholder=\"{{vm.translate(\'MAILING.DATE_FORMAT\')}}\"><md-option value=\"dateHm\" selected=\"selected\">(31 Dic 09 22:35)\n</md-option><md-option value=\"datedma\">(31/12/09)</md-option><md-option value=\"date\">(31 Dic 09)</md-option><md-option \nvalue=\"datemda\">(12/31/09)</md-option><md-option value=\"dateMda\">(Dic 31 09)</md-option><md-option value=\"dateMdaHm\">\n(Dic 31 09 22:35)</md-option></md-select></md-input-container><div flex=\"50\" class=\"ml-20 mr-20\"><md-icon \nclass=\"icon-information s14 grey-500-fg\"></md-icon><span class=\"font-size-14 grey-500-fg\" \ntranslate=\"MAILING.CURRENT_DATE_DEFAULT\"></span></div></div><div ng-switch-when=\"media\" layout=\"column\" \nlayout-align=\"center space-between \"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\">\n<md-input-container class=\"md-block\" flex=\"50\"><label translate=\"MAILING.MEDIA_LAYOUT\"></label><md-select \nng-model=\"formItem.mediaLayout\" placeholder=\"{{vm.translate(\'MAILING.MEDIA_LAYOUT\')}}\"><md-option value=\"oneColumn\" \nselected=\"selected\">{{vm.translate(\'MAILING.MEDIA_LAYOUT_ONE_COLUMN\')}}</md-option><md-option \nvalue=\"oneColumnThumnails\">{{vm.translate(\'MAILING.MEDIA_LAYOUT_ONE_COLUMN_THUMBNAILS\')}}</md-option><md-option \nvalue=\"Thumnails\">{{vm.translate(\'MAILING.MEDIA_LAYOUT_THUMBNAILS\')}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" flex=\"50\"><label translate=\"MAILING.MEDIA_FIELDS\"></label><md-select \nng-model=\"formItem.mediaFields\" placeholder=\"{{vm.translate(\'MAILING.MEDIA_FIELDS\')}}\" multiple=\"multiple\"><md-option \nvalue=\"mediaTitle\">{{vm.translate(\'MAILING.MEDIA_FIELDS_TITLE\')}}</md-option><md-option value=\"mediaCaption\">\n{{vm.translate(\'MAILING.MEDIA_FIELDS_CAPTION\')}}</md-option><md-option value=\"mediaCopyright\">\n{{vm.translate(\'MAILING.MEDIA_FIELDS_COPYRIGHT\')}}</md-option></md-select></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"100\"><md-input-container class=\"md-block\" flex=\"50\"><label \ntranslate=\"MAILING.MEDIA_ACTION\"></label><md-select ng-model=\"formItem.mediaAction\" \nplaceholder=\"{{vm.translate(\'MAILING.MEDIA_ACTION\')}}\"><md-option value=\"actionNone\">None</md-option><md-option \nvalue=\"actionOriginal\">{{vm.translate(\'MAILING.MEDIA_BUTTON_ACTION_ORIGINAL\')}}</md-option><md-option \nvalue=\"actionCustom\">{{vm.translate(\'MAILING.MEDIA_ACTION_CUSTOM_URL\')}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" flex=\"50\"><label translate=\"MAILING.MEDIA_ACTION_BUTTON\"></label><textarea \nng-model=\"formItem.mediaActionButton\" columns=\"1\" rows=\"1\" \nplaceholder=\"{{vm.translate(\'MAILING.MEDIA_ACTION_BUTTON\')}}\"></textarea></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"100\"><md-input-container class=\"md-block\" flex=\"100\" \nng-if=\"formItem.mediaAction == \'actionCustom\'\"><label translate=\"MAILING.MEDIA_ACTION_CUSTOM_URL\"></label><textarea \nng-model=\"formItem.actionCustom\" columns=\"1\" rows=\"1\" \nplaceholder=\"{{vm.translate(\'MAILING.MEDIA_ACTION_CUSTOM_URL\')}}\"></textarea></md-input-container></div></div>\n<md-input-container class=\"md-block input-textbox\" ng-switch-when=\"textBox\" hide aria-label=\"Multiline\"><md-checkbox \nng-init=\"!formItem.multiLine ?  formItem.multiLine = false: true\" ng-model=\"formItem.multiLine\" class=\"wm\">\n</md-checkbox><span translate=\"MAILING.MULTILINE\"></span></md-input-container><div ng-switch-when=\"lineSeparator\" \nlayout=\"row\" layout-align=\"space-between center\" flex=\"100\"><div md-color-picker-custom \nng-model=\"formItem.lineSeparatorColor\" default=\"#dddddd\" md-color-generic-palette=\"false\" md-color-hsl=\"false\" \nmd-color-rgb=\"false\" md-color-history=\"false\" label=\"{{vm.translate(\'MAILING.LINE_COLOR\')}}\" flex=\"50\"></div>\n<md-input-container class=\"md-block md-input-has-value\" flex=\"50\"><label translate=\"MAILING.LINE_WIDTH\"></label><input \ntype=\"number\" min=\"1\" max=\"10\" ng-model=\"formItem.defaultValue\" columns=\"1\" rows=\"1\" value=\"1\" \nplaceholder=\"{{vm.translate(\'MAILING.LINE_WIDTH\')}}\"></md-input-container></div><md-input-container class=\"md-block\" \nng-switch-when=\"previewLink\"><label translate=\"MAILING.PREVIEW_TEXT\"></label><textarea \nng-model=\"formItem.defaultValue\" columns=\"1\" rows=\"1\"></textarea></md-input-container><div ng-switch-when=\"social\" \nlayout=\"column\" layout-align=\"center space-between \"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\">\n<md-input-container class=\"md-block\" flex=\"50\"><label translate=\"MAILING.SOCIAL_TYPE\"></label><md-select \nng-model=\"formItem.social\" placeholder=\"{{vm.translate(\'MAILING.SOCIAL_TYPE\')}}\"><md-option value=\"socialShare\">\n{{vm.translate(\'MAILING.SOCIAL_TYPE_SHARE\')}}</md-option><md-option value=\"socialLinks\">\n{{vm.translate(\'MAILING.SOCIAL_TYPE_LINK\')}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\" flex=\"50\" ng-if=\"formItem.social\"><label translate=\"MAILING.SOCIAL_NETWORKS\"></label><md-select \nng-model=\"formItem.socialNetwoks\" placeholder=\"{{vm.translate(\'MAILING.SOCIAL_NETWORKS\')}}\" multiple=\"multiple\">\n<md-option value=\"socialFacebook\">{{vm.translate(\'MAILING.SOCIAL_NETWORKS_FACEBOOK\')}}</md-option><md-option \nvalue=\"socialTwitter\">{{vm.translate(\'MAILING.SOCIAL_NETWORKS_TWITTER\')}}</md-option><md-option \nvalue=\"socialInstagram\">{{vm.translate(\'MAILING.SOCIAL_NETWORKS_INSTAGRAM\')}}</md-option><md-option \nvalue=\"socialLinkedin\">{{vm.translate(\'MAILING.SOCIAL_NETWORKS_LINKEDIN\')}}</md-option><md-option \nvalue=\"socialGooglePlus\">{{vm.translate(\'MAILING.SOCIAL_NETWORKS_GOOGLE_PLUS\')}}</md-option><md-option \nvalue=\"socialYoutube\">{{vm.translate(\'MAILING.SOCIAL_NETWORKS_YOUTUBE\')}}</md-option><md-option value=\"socialVimeo\">\n{{vm.translate(\'MAILING.SOCIAL_NETWORKS_VIMEO\')}}</md-option><md-option value=\"socialMail\" \nng-if=\"formItem.social == \'socialShare\'\">{{vm.translate(\'MAILING.SOCIAL_NETWORKS_MAIL\')}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\" \nng-if=\"formItem.social == \'socialLinks\'\"><md-input-container class=\"md-block\" flex=\"100\"><label \ntranslate=\"MAILING.SOCIAL_NETWORKS_FACEBOOK_TEXT\"></label><textarea ng-model=\"formItem.socialFacebook\" columns=\"1\" \nrows=\"1\" placeholder=\"{{vm.translate(\'MAILING.SOCIAL_NETWORKS_FACEBOOK_TEXT\')}}\"></textarea></md-input-container>\n<md-input-container class=\"md-block\" flex=\"100\"><label translate=\"MAILING.SOCIAL_NETWORKS_TWITTER_TEXT\"></label>\n<textarea ng-model=\"formItem.socialTwitter\" columns=\"1\" rows=\"1\" \nplaceholder=\"{{vm.translate(\'MAILING.SOCIAL_NETWORKS_TWITTER_TEXT\')}}\"></textarea></md-input-container>\n<md-input-container class=\"md-block\" flex=\"100\"><label translate=\"MAILING.SOCIAL_NETWORKS_INSTAGRAM_TEXT\"></label>\n<textarea ng-model=\"formItem.socialInstagram\" columns=\"1\" rows=\"1\" \nplaceholder=\"{{vm.translate(\'MAILING.SOCIAL_NETWORKS_INSTAGRAM_TEXT\')}}\"></textarea></md-input-container></div><div \nlayout=\"row\" layout-align=\"space-between center\" flex=\"100\" ng-if=\"formItem.social == \'socialLinks\'\">\n<md-input-container class=\"md-block\" flex=\"100\"><label translate=\"MAILING.SOCIAL_NETWORKS_LINKEDIN_TEXT\"></label>\n<textarea ng-model=\"formItem.socialLinkedin\" columns=\"1\" rows=\"1\" \nplaceholder=\"{{vm.translate(\'MAILING.SOCIAL_NETWORKS_LINKEDIN_TEXT\')}}\"></textarea></md-input-container>\n<md-input-container class=\"md-block\" flex=\"100\"><label translate=\"MAILING.SOCIAL_NETWORKS_GOOGLE_PLUS_TEXT\"></label>\n<textarea ng-model=\"formItem.socialGooglePlus\" columns=\"1\" rows=\"1\" \nplaceholder=\"{{vm.translate(\'MAILING.SOCIAL_NETWORKS_GOOGLE_PLUS_TEXT\')}}\"></textarea></md-input-container>\n<md-input-container class=\"md-block\" flex=\"100\"><label translate=\"MAILING.SOCIAL_NETWORKS_YOUTUBE_TEXT\"></label>\n<textarea ng-model=\"formItem.socialYoutube\" columns=\"1\" rows=\"1\" \nplaceholder=\"{{vm.translate(\'MAILING.SOCIAL_NETWORKS_YOUTUBE_TEXT\')}}\"></textarea></md-input-container>\n<md-input-container class=\"md-block\" flex=\"100\"><label translate=\"MAILING.SOCIAL_NETWORKS_VIMEO_TEXT\"></label><textarea\n ng-model=\"formItem.socialVimeo\" columns=\"1\" rows=\"1\" \nplaceholder=\"{{vm.translate(\'MAILING.SOCIAL_NETWORKS_VIMEO_TEXT\')}}\"></textarea></md-input-container></div><div \nlayout=\"row\" layout-align=\"space-between center\" flex=\"50\"><md-input-container class=\"md-block\" flex=\"50\"><label \ntranslate=\"MAILING.SOCIAL_NETWORKS_STYLE\"></label><md-select ng-model=\"formItem.socialStyle\" \nplaceholder=\"{{vm.translate(\'MAILING.SOCIAL_NETWORKS_STYLE\')}}\"><md-option value=\"black\">\n{{vm.translate(\'MAILING.SOCIAL_NETWORKS_STYLE_BLACK\')}}</md-option><md-option value=\"white\">\n{{vm.translate(\'MAILING.SOCIAL_NETWORKS_STYLE_WHITE\')}}</md-option><md-option value=\"color\" selected=\"selected\">\n{{vm.translate(\'MAILING.SOCIAL_NETWORKS_STYLE_COLOR\')}}</md-option></md-select></md-input-container></div></div></div>\n<div flex=\"100\" layout=\"column\" layout-align=\"center space-between\" class=\"field-style-options mt-10\" \nng-if=\"formItem.type != \'separator\' && formItem.type != \'checkbox\' && formItem.type != \'colorPicker\' && formItem.type\">\n<div layout=\"row\" layout-align=\"start center\" class=\"pl-20\"><div translate=\"MAILING.FORMAT_OPTIONS\" \nclass=\"mr-10 font-size-16 grey-500-fg\"></div><md-switch ng-model=\"showStyle\" ng-checked=\"\" aria-label=\"Show\">\n</md-switch></div><div ng-if=\"showStyle == true\"><div layout=\"row\" layout-align=\"start center\" \nng-if=\"formItem.type != \'htmlBox\' && formItem.type != \'group\' && formItem.type != \'relatedTable\' && formItem.type != \'lineSeparator\'\">\n<md-input-container class=\"md-block\"><label translate=\"MAILING.FORMAT_ALIGN\"></label><md-select \nng-model=\"formItem.textAlign\" placeholder=\"{{vm.translate(\'MAILING.FORMAT_ALIGN\')}}\"><md-option value=\"Left\" \nselected=\"selected\"><md-icon md-font-icon=\"icon-format-align-left\" class=\"mr-5 s20\"></md-icon><span \ntranslate=\"MAILING.FORMAT_ALIGN_LEFT\">Left</span></md-option><md-option value=\"Right\"><md-icon \nmd-font-icon=\"icon-format-align-right\" class=\"mr-5 s20\"></md-icon><span translate=\"MAILING.FORMAT_ALIGN_RIGHT\">Right\n</span></md-option><md-option value=\"Center\"><md-icon md-font-icon=\"icon-format-align-center\" class=\"mr-5 s20\">\n</md-icon><span translate=\"MAILING.FORMAT_ALIGN_CENTER\">Center</span></md-option><md-option value=\"Justify\"><md-icon \nmd-font-icon=\"icon-format-align-justify\" class=\"mr-5 s20\"></md-icon><span translate=\"MAILING.FORMAT_ALIGN_JUSTIFY\">\nJustify</span></md-option></md-select></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"MAILING.FORMAT_STYLE\"></label><md-select ng-model=\"formItem.textStyle\" \nplaceholder=\"{{vm.translate(\'MAILING.FORMAT_STYLE\')}}\"><md-option value=\"None\" selected=\"selected\"><md-icon \nmd-font-icon=\"icon-format-color\" class=\"mr-5 s20\"></md-icon><span translate=\"MAILING.FORMAT_STYLE_NORMAL\">Normal</span>\n</md-option><md-option value=\"Left\"><md-icon md-font-icon=\"icon-format-bold\" class=\"mr-5 s20\"></md-icon><span \ntranslate=\"MAILING.FORMAT_STYLE_BOLD\">Bold</span></md-option><md-option value=\"Right\"><md-icon \nmd-font-icon=\"icon-format-italic\" class=\"mr-5 s20\"></md-icon><span translate=\"MAILING.FORMAT_STYLE_ITALIC\">Italic\n</span></md-option><md-option value=\"Center\"><md-icon md-font-icon=\"icon-format-underline\" class=\"mr-5 s20\"></md-icon>\n<span translate=\"MAILING.FORMAT_STYLE_UNDERLINE\">Underline</span></md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"MAILING.FORMAT_SIZE\"></label><md-select \nng-model=\"formItem.textSize\" placeholder=\"{{vm.translate(\'MAILING.FORMAT_SIZE\')}}\"><md-option value=\"9\">9</md-option>\n<md-option value=\"10\">10</md-option><md-option value=\"12\">12</md-option><md-option value=\"14\" selected=\"selected\">14\n</md-option><md-option value=\"16\">16</md-option><md-option value=\"18\">18</md-option><md-option value=\"20\">20\n</md-option><md-option value=\"24\">24</md-option></md-select></md-input-container><md-input-container class=\"md-block\">\n<label translate=\"MAILING.FORMAT_FONT_FAMILY\"></label><md-select ng-model=\"font\" \nplaceholder=\"{{vm.translate(\'MAILING.FORMAT_FONT_FAMILY\')}}\"><md-option ng-repeat=\"font in fonts\" \nng-value=\"font.value\" ng-selected=\"{{font.selected}}\"><font face=\"{{font.value}}\">{{font.label}}</font></md-option>\n</md-select></md-input-container></div><div layout=\"row\" layout-align=\"start center\"><div md-color-picker-custom \nng-model=\"formItem.backgroundColor\" default=\"rgb(255,255,255)\" md-color-generic-palette=\"false\" md-color-hsl=\"false\" \nmd-color-rgb=\"false\" md-color-history=\"false\" label=\"{{vm.translate(\'MAILING.FORMAT_BACKGROUND_COLOR\')}}\"></div><div \nmd-color-picker-custom ng-model=\"formItem.textColor\" default=\"#000000\" md-color-generic-palette=\"false\" \nmd-color-hsl=\"false\" md-color-rgb=\"false\" md-color-history=\"false\" \nlabel=\"{{vm.translate(\'MAILING.FORMAT_TEXT_COLOR\')}}\" \nng-if=\"formItem.type != \'group\' && formItem.type != \'relatedTable\' && formItem.type != \'lineSeparator\'\"></div></div>\n<div layout=\"row\" layout-align=\"start center\"><md-input-container class=\"md-block\"><label \ntranslate=\"MAILING.FORMAT_STYLE_PADDING_TOP\"></label><textarea ng-model=\"formItem.paddingTop\" columns=\"1\" rows=\"1\" \nplaceholder=\"{{vm.translate(\'MAILING.FORMAT_STYLE_PADDING_TOP\')}}\"></textarea></md-input-container><md-input-container \nclass=\"md-block\"><label translate=\"MAILING.FORMAT_STYLE_PADDING_RIGHT\"></label><textarea \nng-model=\"formItem.paddingRight\" columns=\"1\" rows=\"1\" \nplaceholder=\"{{vm.translate(\'MAILING.FORMAT_STYLE_PADDING_RIGHT\')}}\"></textarea></md-input-container></div><div \nlayout=\"row\" layout-align=\"start center\"><md-input-container class=\"md-block\"><label \ntranslate=\"MAILING.FORMAT_STYLE_PADDING_LEFT\"></label><textarea ng-model=\"formItem.paddingLeft\" columns=\"1\" rows=\"1\" \nplaceholder=\"{{vm.translate(\'MAILING.FORMAT_STYLE_PADDING_LEFT\')}}\"></textarea></md-input-container><md-input-container\n class=\"md-block\"><label translate=\"MAILING.FORMAT_STYLE_PADDING_BOTTOM\"></label><textarea \nng-model=\"formItem.paddingBottom\" columns=\"1\" rows=\"1\" \nplaceholder=\"{{vm.translate(\'MAILING.FORMAT_STYLE_PADDING_BOTTOM\')}}\"></textarea></md-input-container></div></div>\n</div><div class=\"flex-100\" layout=\"row\" layout-align=\"space-between center\"><md-input-container \nng-if=\"formItem.type == \'group\'\" class=\"without-margin-sides\"><md-button ng-click=\"vm.groupDialog(formItem)\" \nclass=\"edit-button md-accent md-raised\" ng-disabled=\"\" aria-label=\"EDIT\" translate=\"MAILING.EDIT\" \ntranslate-attr-aria-label=\"MAILING.EDIT\"></md-button></md-input-container><md-input-container \nclass=\"md-block without-margin-sides\" flex layout=\"row\" layout-align=\"end center\"><md-button type=\"submit\" \nng-click=\"vm.saveFieldStructure($index)\" class=\"send-button md-accent md-raised\" ng-disabled=\"\" aria-label=\"SAVE\" \ntranslate=\"MAILING.SAVE\" translate-attr-aria-label=\"MAILING.SAVE\"></md-button><md-button type=\"button\" \nng-click=\"vm.cancelEditFieldStructure($index)\" class=\"md-raised md-warn\" aria-label=\"Cancel\" \ntranslate=\"MAILING.CANCEL\" translate-attr-aria-label=\"MAILING.CANCEL\"></md-button></md-input-container></div></div>");
$templateCache.put("app/main/apps/mailing/views/editors/editors-fill.html","<md-list-item ng-switch-when=\"separator\" class=\"md-toolbar-tools grey-100-bg md-no-proxy _md\" role=\"listitem\" \nstyle=\"border-top: 1px solid gainsboro\"><h3 class=\"grey-700-fg\">{{formItem.label}}</h3><md-divider \nclass=\"md-default-theme\"></md-divider><div class=\"md-secondary-container\"></div></md-list-item><md-input-container \nng-switch-when=\"textBox\" class=\"layout-wrap layout-sm-column layout-row\"><label class=\"item\" ng-bind=\"formItem.label\">\n</label><input data-ng-model=\"formItem.defaultValue\"></md-input-container><md-input-container ng-switch-when=\"htmlBox\" \nclass=\"md-block\"><label class=\"item\" ng-bind=\"formItem.label\"></label><textarea ui-tinymce=\"vm.tinymceOptions\" \nng-model=\"formItem.defaultValue\"></textarea></md-input-container><md-input-container ng-switch-when=\"colorPicker\" \nclass=\"md-block\"><h3 class=\"grey-700-fg\">{{formItem.label}}</h3><div md-color-picker-custom \nng-model=\"formItem.defaultValue\" value=\"formItem.defaultValue\"></div></md-input-container><md-input-container \nng-switch-when=\"checkbox\" class=\"md-block\"><md-checkbox ng-model=\"formItem.checked\">{{formItem.label}}</md-checkbox>\n</md-input-container><md-input-container ng-switch-when=\"relatedTable\" class=\"md-block\"><label>This is a related table\n</label></md-input-container><md-input-container ng-switch-when=\"media\" class=\"md-block\"><label>This is a media type\n</label></md-input-container><md-input-container ng-switch-when=\"datePicker\" class=\"md-block\"><mdp-date-picker \nmdp-placeholder=\"Date\" ng-model=\"vm.currentDate\" flex=\"100\"></mdp-date-picker></md-input-container><md-input-container \nng-switch-when=\"group\" class=\"md-block\"><md-button ng-click=\"vm.groupDialog(formItem)\" \nclass=\"add-event-button md-fab md-warn\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><span>\n{{vm.translate(\'MAILING.NEW\')}} {{formItem.label}}</span></md-input-container>");
$templateCache.put("app/main/apps/mailing/views/editors/editors-view.html","<div layout=\"row\" layout-align=\"start center\" ng-if=\"(!formItem.temporary && !formItem.editing)\"><div \nng-switch=\"formItem.type\"><md-icon md-font-icon=\"icon-format-text\" class=\"mr-30\" ng-switch-when=\"textBox\"><md-tooltip \nhide show-gt-xs><span translate=\"textBox\">textBox</span></md-tooltip></md-icon><md-icon \nmd-font-icon=\"icon-format-float-left\" class=\"mr-30\" ng-switch-when=\"htmlBox\"><md-tooltip hide show-gt-xs><span \ntranslate=\"htmlBox\">htmlBox</span></md-tooltip></md-icon><md-icon md-font-icon=\"icon-calendar-clock\" class=\"mr-30\" \nng-switch-when=\"datePicker\"><md-tooltip hide show-gt-xs><span translate=\"datePicker\">datePicker</span></md-tooltip>\n</md-icon><md-icon md-font-icon=\"icon-file-image-box\" class=\"mr-30\" ng-switch-when=\"media\"><md-tooltip hide show-gt-xs>\n<span translate=\"media\">media</span></md-tooltip></md-icon><md-icon md-font-icon=\"icon-tag\" class=\"mr-30\" \nng-switch-when=\"separator\"><md-tooltip hide show-gt-xs><span translate=\"separator\">separator</span></md-tooltip>\n</md-icon><md-icon md-font-icon=\"icon-window-minimize\" class=\"mr-30\" ng-switch-when=\"lineSeparator\"><md-tooltip hide \nshow-gt-xs><span translate=\"lineSeparator\">lineSeparator</span></md-tooltip></md-icon><md-icon \nmd-font-icon=\"icon-layers\" class=\"mr-30\" ng-switch-when=\"group\"><md-tooltip hide show-gt-xs><span translate=\"group\">\ngroup</span></md-tooltip></md-icon><md-icon md-font-icon=\"icon-checkbox-marked-outline\" class=\"mr-30\" \nng-switch-when=\"checkbox\"><md-tooltip hide show-gt-xs><span translate=\"checkbox\">checkbox</span></md-tooltip></md-icon>\n<md-icon md-font-icon=\"icon-eyedropper\" class=\"mr-30\" ng-switch-when=\"colorPicker\"><md-tooltip hide show-gt-xs><span \ntranslate=\"colorPicker\">colorPicker</span></md-tooltip></md-icon><md-icon md-font-icon=\"icon-repeat\" class=\"mr-30\" \nng-switch-when=\"relatedTable\"><md-tooltip hide show-gt-xs><span translate=\"relatedTable\">relatedTable</span>\n</md-tooltip></md-icon><md-icon md-font-icon=\"icon-link-variant\" class=\"mr-30\" ng-switch-when=\"previewLink\"><md-tooltip\n hide show-gt-xs><span translate=\"previewLink\">previewLink</span></md-tooltip></md-icon><md-icon \nmd-font-icon=\"icon-thumb-up-outline\" class=\"mr-30\" ng-switch-when=\"social\"><md-tooltip hide show-gt-xs><span \ntranslate=\"social\">social</span></md-tooltip></md-icon></div><div class=\"template flex\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"field\" layout=\"column\"><div ng-switch=\"formItem.type\"><span \nclass=\"font-size-16 grey-700-fg\" ng-switch-default ng-bind=\"formItem.label\"></span></div><div class=\"content-editable\" \nng-switch=\"formItem.type\" layout=\"column\"><span ng-switch-when=\"textBox\" class=\"grey-500-fg font-size-14 mt-5\" \nng-if=\"formItem.defaultValue\">{{formItem.defaultValue}}<md-tooltip hide show-gt-xs><span \ntranslate=\"MAILING.DEFAULT_VALUE\">Default value</span></md-tooltip></span><span ng-switch-when=\"lineSeparator\" \nclass=\"grey-500-fg font-size-14 mt-5\" ng-if=\"formItem.defaultValue\">{{formItem.defaultValue}}</span><div \nng-switch-when=\"checkbox\" layout=\"row\" layout-align=\"start center\" class=\"mt-5\"><span \nclass=\"grey-500-fg font-size-14 mt-0 mr-5 text-truncate\" translate=\"MAILING.DEFAULT_VALUE\"></span><md-icon \nmd-font-icon=\"icon-checkbox-marked\" class=\"s18 m-0\" ng-if=\"formItem.defaultValue == true\"></md-icon><md-icon \nmd-font-icon=\"icon-checkbox-blank\" class=\"s18 m-0\" ng-if=\"formItem.defaultValue == false\"></md-icon><md-tooltip hide \nshow-gt-xs ng-if=\"formItem.defaultValue == true\"><span>Checked</span></md-tooltip><md-tooltip hide show-gt-xs \nng-if=\"formItem.defaultValue == false\"><span>Unchecked</span></md-tooltip></div><div ng-switch-when=\"colorPicker\" \nclass=\"md-color-picker-custom mt-5\" layout=\"row\" layout-align=\"start center\"><div class=\"sample-color mr-10\" \nng-style=\"{\'background-color\': formItem.defaultValue}\"></div><span class=\"grey-500-fg font-size-14 text-truncate\">\n{{formItem.defaultValue}}</span></div><span ng-switch-when=\"htmlBox\" class=\"grey-500-fg font-size-14 mt-5\" \ntranslate=\"MAILING.VIEW_DEFAULT_IN_EDIT\"></span> <span ng-switch-when=\"datePicker\" \nclass=\"grey-500-fg font-size-14 mt-5\" translate=\"MAILING.CURRENT_DATE_DEFAULT\"></span></div></div><div layout=\"row\" \nlayout-align=\"end center\"><md-menu><md-button class=\"md-icon-button\" aria-label=\"More\" \nng-click=\"vm.openMenu($mdMenu, $event)\"><md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/more_vert.svg\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"vm.editFieldStructure($index)\" \naria-label=\"Edit\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><span translate=\"MAILING.EDIT\"></span></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.removeFieldStructure($index)\" aria-label=\"Delete\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-default-theme md-font material-icons icon-delete\"></md-icon>Remove</md-button>\n</md-menu-item></md-menu-content></md-menu><md-icon class=\"drag icon-equal\" aria-label=\"DRAG\"></md-icon></div></div>\n</div>");
$templateCache.put("app/main/apps/mailing/views/read/tab-edit.html","<div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><form name=\"vm.basicForm\" class=\"md-inline-form\" novalidate>\n<div><md-input-container class=\"md-block\" flex><label>Teamplate name</label><textarea \nng-model=\"vm.currentThread_Edit.name\" columns=\"1\" rows=\"1\"></textarea></md-input-container><md-input-container \nclass=\"md-block\" flex><label>From name</label><textarea ng-model=\"vm.currentThread_Edit.from_name\" columns=\"1\" \nrows=\"1\"></textarea></md-input-container><md-input-container class=\"md-block\" flex><label>From email</label><textarea \nng-model=\"vm.currentThread_Edit.from_email\" columns=\"1\" rows=\"1\"></textarea></md-input-container></div><div \nng-sortable=\"vm.templateSortable\" class=\"sortable\"><md-list-item class=\"md-toolbar-tools grey-100-bg md-no-proxy _md\" \nrole=\"listitem\" style=\"border-top: 1px solid gainsboro\"><h3 class=\"grey-700-fg\">Template fields</h3><md-divider>\n</md-divider></md-list-item><md-input-container ng-repeat=\"formItem in vm.structure_json track by $index\" \nng-model=\"vm.structure_json\" \nng-class=\"(!formItem.temporary && !formItem.editing) ? \'md-block structure\' : \'structure-gray\'\" flex><div \nclass=\"template\" ng-if=\"!formItem.temporary && !formItem.editing\"><div class=\"label\"><label ng-bind=\"formItem.label\">\n</label><md-button class=\"md-icon-button\"><md-icon class=\"drag\" \nmd-svg-icon=\"assets/angular-material-assets/img/icons/ic_drag_handle_black_24px.svg\"></md-icon></md-button><md-menu>\n<md-button class=\"md-icon-button\" aria-label=\"More\" ng-click=\"vm.openMenu($mdMenu, $event)\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/more_vert.svg\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button ng-click=\"vm.removeFieldStructure($index)\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"md-default-theme md-font material-icons icon-delete\"></md-icon>Remove</md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"vm.editFieldStructure($index)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>Edit</md-button>\n</md-menu-item></md-menu-content></md-menu></div><div class=\"content-editable\" ng-switch=\"formItem.type\" \nlayout=\"column\"><md-input-container ng-switch-when=\"label\" class=\"md-block\"><h3 class=\"inline\">\n{{formItem.defaultValue}}</h3></md-input-container><md-input-container ng-switch-when=\"textBox\" \nclass=\"layout-wrap layout-sm-column layout-row\"><div flex=\"50\"><md-input-container class=\"md-block\"><h3 class=\"inline\">\n{{formItem.defaultValue}}</h3></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\">\n<md-checkbox disabled=\"disabled\" ng-model=\"formItem.multiLine\" class=\"wm\">Multiline</md-checkbox></md-input-container>\n</div></md-input-container><md-input-container ng-switch-when=\"checkbox\" class=\"md-block\"><md-checkbox \ndisabled=\"disabled\" ng-model=\"formItem.checked\" class=\"wm\">Default value</md-checkbox></md-input-container><div \nng-switch-when=\"colorPicker\" class=\"md-color-picker\"><div class=\"sample-color\" \nng-style=\"{\'background-color\': formItem.defaultValue}\"></div><h3 class=\"inline\">Default color</h3></div>\n<md-input-container ng-switch-when=\"htmlBox\" class=\"md-block\"><h3 class=\"inline\">View default value in edition mode\n</h3></md-input-container><md-input-container ng-switch-when=\"datePicker\" class=\"md-block\"><label>\nSe seleccionará la fecha actual por defecto</label></md-input-container></div></div><div \nng-if=\"formItem.temporary || formItem.editing\" class=\"layout-wrap layout-sm-column layout-row newfield\"><div flex=\"50\">\n<md-input-container class=\"md-block\"><label>New field name</label><textarea ng-model=\"formItem.label\" columns=\"1\" \nrows=\"1\"></textarea></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>Field type\n</label><md-select ng-model=\"formItem.type\"><md-option><em>Select</em></md-option><md-option \nng-repeat=\"typeField in vm.typeFields\" ng-value=\"typeField\">{{typeField}}</md-option></md-select></md-input-container>\n</div><div ng-switch=\"formItem.type\" \nng-class=\"(formItem.type == \'htmlBox\' || formItem.type == \'textBox\') ? \'flex-100\' : \'flex-50\'\"><md-input-container \nng-switch-when=\"label\" class=\"md-block\"><label>Default value</label><textarea ng-model=\"formItem.defaultValue\" \ncolumns=\"1\" rows=\"1\"></textarea></md-input-container><md-input-container ng-switch-when=\"textBox\" \nclass=\"layout-wrap layout-sm-column layout-row md-block\"><label>Default value</label><textarea \nng-model=\"formItem.defaultValue\" columns=\"1\" rows=\"1\"></textarea></md-input-container><md-input-container \nng-switch-when=\"checkbox\" class=\"md-block\"><md-checkbox ng-init=\"!formItem.checked ?  formItem.checked = false\" \nng-model=\"formItem.checked\">Default value</md-checkbox></md-input-container><div ng-switch-when=\"colorPicker\" \nmd-color-picker ng-init=\"formItem.defaultValue = \'#\'\" ng-model=\"formItem.defaultValue\" value=\"formItem.defaultValue\">\n</div><md-input-container flex class=\"md-block md-input-has-value\" ng-switch-when=\"htmlBox\"><textarea \nui-tinymce=\"vm.tinymceOptions\" ng-model=\"formItem.defaultValue\"></textarea></md-input-container><md-input-container \nflex class=\"md-block md-input-has-value\" ng-switch-when=\"datePicker\"><label>Se seleccionará la fecha actual por defecto\n</label></md-input-container></div><div \nng-class=\"(formItem.type == \'htmlBox\' || formItem.type == \'textBox\') ? \'flex-100\' : \'flex-50\'\" layout=\"row\" \nclass=\"buttons\"><md-input-container class=\"md-block without-margin-sides\"><md-button type=\"submit\" \nng-click=\"vm.saveFieldStructure($index)\" class=\"send-button md-accent md-raised\" ng-disabled=\"\" aria-label=\"SAVE\" \ntranslate=\"CONTENT.SAVE\" translate-attr-aria-label=\"CONTENT.SAVE\">SAVE</md-button></md-input-container>\n<md-input-container class=\"md-block without-margin-sides\"><md-button type=\"button\" \nng-click=\"vm.cancelEditFieldStructure($index)\" class=\"md-raised md-warn\" aria-label=\"Cancel\">Cancel</md-button>\n</md-input-container></div></div></md-input-container></div></form><form class=\"md-inline-form\" novalidate><div \nclass=\"group-form\"><md-button ng-click=\"vm.addNewStructureField()\" class=\"add-event-button md-fab md-warn\" \naria-label=\"ADD\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><span>Add new field</span></div></form></div>");
$templateCache.put("app/main/apps/mailing/sidenavs/main/main-sidenav.html","<md-toolbar class=\"md-theme-light md-default-theme md-light-blue-bg\"><h2 class=\"md-toolbar-tools\" aria-label=\"Filters\" \nlayout=\"row\" layout-align=\"space-between center\"><span translate-attr-aria-label=\"CONTENT.FILTERS\" \ntranslate=\"CONTENT.FILTERS\">Filters</span> <button class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'main-sidenav\')\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></button></h2></md-toolbar><md-content ms-scroll class=\"content\" flex><div\n class=\"navigation-simple\" layout=\"column\"><div ng-repeat=\"filterable in refFilterables\"><md-menu flex layout=\"row\">\n<md-menu-item flex><md-button aria-label=\"Label\" translate ng-show=\"filterable.values.length>0\" \ntranslate-attr-aria-label=\"SB.LABEL\" ng-click=\"$mdMenu.open($event)\"><div layout=\"row\" layout-align=\"start start\"><span\n class=\"title text-left\" flex>{{filterable.name}}</span><md-icon md-font-icon=\"icon-chevron-down\"></md-icon></div>\n</md-button></md-menu-item><md-menu-content class=\"labels-menu-content\" width=\"4\"><md-menu-item \nclass=\"search-bar border-bottom\" ng-if=\"filterable.values.length>10\"><div layout=\"row\" layout-align=\"start center\" \nclass=\"pl-10 pr-15\"><md-icon md-font-icon=\"icon-magnify\" class=\"md-icon-button ml-0 mr-10\" aria-label=\"Search\" \nrole=\"img\"></md-icon><input placeholder=\"Search labels...\" type=\"text\" flex class=\"font-size-14\" \nng-model=\"vm.filterSearchText[filterable.field]\" autocomplete=\"off\" translate-attr-palceholder=\"SB.SEARCH_LABELS\">\n</div></md-menu-item><div ms-scroll ng-class=\"{\'mt-48\': filterable.values.length>10}\"><md-menu-item class=\"label\" \nng-repeat=\"label in filterable.values | filter: vm.filterSearchText[filterable.field]\"><md-button \nclass=\"label-toggle-button\" ng-class=\"\'md-\'+label.color+\'-bg\'\" \nng-click=\"vm.toggleInArray(label.value, refFilterables[filterable.field].selected)\" aria-label=\"Toggle Label\" \ntranslate translate-attr-aria-label=\"SB.TOGGLE_LABEL\"><div layout=\"row\" layout-align=\"space-between center\"><span>\n{{label.name}}</span> <i ng-if=\"vm.exists(label.value, refFilterables[filterable.field].selected)\" \nclass=\"icon-check s16\"></i></div></md-button></md-menu-item></div><md-divider></md-divider></md-menu-content></md-menu>\n<div ng-show=\"refFilterables[filterable.field].selected.length>0\"><md-chips class=\"md-chips md-removable close-chip\">\n<md-chip ng-repeat=\"label in filterable.values | filterInArray:filterable.selected:\'value\'\" \nclass=\"md-accent-bg md-chip\"><div class=\"md-chip-content\">{{label.name}}</div><div class=\"md-chip-remove-container\">\n<button class=\"md-chip-remove\" ng-click=\"vm.toggleInArray(label.value, refFilterables[filterable.field].selected)\" \nmd-chip-remove><md-icon md-font-icon=\"icon-close\"></md-icon></button></div></md-chip></md-chips></div></div></div>\n</md-content>");
$templateCache.put("app/main/apps/mailing/sidenavs/main/sidenav.html","<md-toolbar class=\"md-theme-light md-default-theme md-light-blue-bg\"><h2 class=\"md-toolbar-tools\" aria-label=\"Filters\" \nlayout=\"row\" layout-align=\"space-between center\"><span translate-attr-aria-label=\"CONTENT.FILTERS\" \ntranslate=\"CONTENT.FILTERS\">Filters</span>asdasdasd <button class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'main-sidenav\')\"><md-icon md-font-icon=\"icon-close\"></md-icon></button></h2></md-toolbar>\n<md-content ms-scroll class=\"content\" flex><div class=\"navigation-simple\" layout=\"column\"><div \nng-repeat=\"filterable in refFilterables\"><md-menu flex layout=\"row\"><md-menu-item flex><md-button aria-label=\"Label\" \ntranslate ng-show=\"filterable.values.length>0\" translate-attr-aria-label=\"SB.LABEL\" ng-click=\"$mdMenu.open($event)\">\n<div layout=\"row\" layout-align=\"start start\"><span class=\"title text-left\" flex>{{filterable.name}}</span><md-icon \nmd-font-icon=\"icon-chevron-down\"></md-icon></div></md-button></md-menu-item><md-menu-content \nclass=\"labels-menu-content\" width=\"4\"><md-menu-item class=\"search-bar border-bottom\" \nng-if=\"filterable.values.length>10\"><div layout=\"row\" layout-align=\"start center\" class=\"pl-10 pr-15\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"md-icon-button ml-0 mr-10\" aria-label=\"Search\" role=\"img\"></md-icon><input \nplaceholder=\"Search labels...\" type=\"text\" flex class=\"font-size-14\" ng-model=\"vm.filterSearchText[filterable.field]\" \nautocomplete=\"off\" translate-attr-palceholder=\"SB.SEARCH_LABELS\"></div></md-menu-item><div ms-scroll \nng-class=\"{\'mt-48\': filterable.values.length>10}\"><md-menu-item class=\"label\" \nng-repeat=\"label in filterable.values | filter: vm.filterSearchText[filterable.field]\"><md-button \nclass=\"label-toggle-button\" ng-class=\"\'md-\'+label.color+\'-bg\'\" \nng-click=\"vm.toggleInArray(label.value, refFilterables[filterable.field].selected)\" aria-label=\"Toggle Label\" \ntranslate translate-attr-aria-label=\"SB.TOGGLE_LABEL\"><div layout=\"row\" layout-align=\"space-between center\"><span>\n{{label.name}}</span> <i ng-if=\"vm.exists(label.value, refFilterables[filterable.field].selected)\" \nclass=\"icon-check s16\"></i></div></md-button></md-menu-item></div><md-divider></md-divider></md-menu-content></md-menu>\n<div ng-show=\"refFilterables[filterable.field].selected.length>0\"><md-chips class=\"md-chips md-removable close-chip\">\n<md-chip ng-repeat=\"label in filterable.values | filterInArray:filterable.selected:\'value\'\" \nclass=\"md-accent-bg md-chip\"><div class=\"md-chip-content\">{{label.name}}</div><div class=\"md-chip-remove-container\">\n<button class=\"md-chip-remove\" ng-click=\"vm.toggleInArray(label.value, refFilterables[filterable.field].selected)\" \nmd-chip-remove><md-icon md-font-icon=\"icon-close\"></md-icon></button></div></md-chip></md-chips></div></div></div>\n</md-content>");
$templateCache.put("app/main/apps/match-center/dialogs/editclip/editclip-dialog.html","<md-dialog class=\"editclip-dialog\" aria-label=\"New Task\"><form style=\"height: 100%\" name=\"taskForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between\"><h1 class=\"title\">{{\'CONTENT.EDIT\'| translate}}</h1><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div ng-if=\"vm.isUrlReady\" layout=\"column\"><div layout=\"row\" \nclass=\"player-row\"><div class=\"left-selector\"><div class=\"pointer\" ng-click=\"vm.mediaDialog($event, \'left\')\" \nlayout=\"column\"><md-button ng-if=\"!vm.leftItem\" class=\"add-event-button no-sort md-fab md-warn\" aria-label=\"Add\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><p ng-if=\"!vm.leftItem\">\n{{\'MATCH_CENTER.ADD_PRE_VIDEO\' | translate}}</p><media ng-drag=\"true\" style=\"pointer-events: none\" \nng-click=\"$event.stopPropagation(); vm.mediaDialog($event, \'left\');\" ng-if=\"vm.leftItem\" attachment=\"vm.leftItem\" \nclass-img=\"image pointer\"></media></div></div><div class=\"video-container\" layout=\"column\"><span \nng-class=\"{\'full\': overItem.type==\'image\', \'half\': overItem.type==\'text\'}\" id=\"overItem-{{$index}}\" class=\"overitem\" \nng-repeat=\"overItem in vm.overItems track by $index\" draggable-element><img style=\"{{vm.getMaxHeight()}}\" class=\"move\" \nng-src=\"{{overItem.urlImage}}\"><md-icon md-font-icon=\"icon-delete\" ng-click=\"vm.overItems.splice($index, 1)\"></md-icon>\n</span><video id=\"mp4-player\" autoplay controls><source ng-src=\"{{vm.clipUrl}}\" type=\"video/mp4\"></video></div><div \nclass=\"right-selector\"><div ng-click=\"vm.mediaDialog($event, \'right\')\" layout=\"column\" class=\"pointer\"><md-button \nng-if=\"!vm.rightItem\" class=\"add-event-button no-sort md-fab md-warn\" aria-label=\"Add\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button><p ng-if=\"!vm.rightItem\">{{\'MATCH_CENTER.ADD_POST_VIDEO\' | translate}}\n</p><media ng-drag=\"true\" style=\"pointer-events: none\" ng-if=\"vm.rightItem\" attachment=\"vm.rightItem\" \nclass-img=\"image pointer\"></media></div></div></div><div layout=\"row\" class=\"slider-row\"><div class=\"left-input\">\n<md-input-container ng-if=\"vm.leftItem && vm.leftItem.media_type == 1\" flex class=\"md-block m-0\"><label>SECONDS</label>\n<input type=\"number\"></md-input-container></div><div class=\"slider-area\"><div layout=\"row\"><span \nstyle=\"width: 100px;text-align: left\">{{vm.start != undefined ? getFormatTime(vm.start) : \"\"}}</span> <span \nstyle=\"width: 100px;text-align: right; margin-left: auto\">{{vm.end != undefined ? getFormatTime(vm.end) : \"\"}}</span>\n</div><slider style=\"width: calc(100% - 40px); margin: 0px 18px\" floor=\"0\" ceiling=\"{{vm.duration}}\" step=\"1\" \nprecision=\"10\" ng-model-low=\"vm.start\" ng-model-high=\"vm.end\" change=\"onTrimChange()\"></slider></div><div \nclass=\"right-input\"><md-input-container ng-if=\"vm.rightItem && vm.rightItem.media_type == 1\" flex class=\"md-block m-0\">\n<label>SECONDS</label><input type=\"text\"></md-input-container></div></div><div><div class=\"form-container\" flex \nlayout=\"row\"><div class=\"elements-list\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\" \nlayout-align=\"start center\"><li ng-click=\"vm.textDialog($event)\" data-type=\"title\" class=\"ng-scope\" style=\"\"><i \nclass=\"material-icons icon-format-text\"></i> <span class=\"ng-binding\">Overlay text</span></li><li \nng-click=\"vm.mediaDialog($event, \'over\')\" data-type=\"image\" class=\"ng-scope\" style=\"\"><i \nclass=\"material-icons icon-picture\"></i> <span class=\"ng-binding\">Image</span></li></div></div><div \nstyle=\"width: 300px\" layout=\"row\" layout-align=\"end center\"><md-input-container><md-button type=\"button\" \nclass=\"md-raised md-warn\" ng-click=\"vm.closeDialog()\" translate=\"FORMS.CANCEL\"></md-button></md-input-container>\n<md-input-container><md-button type=\"button\" class=\"md-raised md-accent\" ng-click=\"vm.sendEdit($event)\" \ntranslate=\"CONTENT.CREATE\"></md-button></md-input-container></div></div></div></div><div flex layout=\"column\" \nlayout-align=\"center center\" ng-if=\"!vm.isUrlReady\" class=\"loading-container\"><div class=\"text-center\"><h1 \nclass=\"bold\">{{\'MATCH_CENTER.PROCCESSING_VIDEO\' | translate}}</h1><h3>\n{{\'MATCH_CENTER.PROCCESSING_VIDEO_2\' | translate}}</h3></div><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"50\"></md-progress-circular></div><md-progress-circular \nstyle=\"position: absolute;top: calc(50% - 25px);left: calc(50% - 25px)\" ng-if=\"vm.isEditing\" md-mode=\"indeterminate\" \nmd-diameter=\"50\"></md-progress-circular></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/match-center/dialogs/forms-creation/competition.html","<div layout=\"row\"><md-input-container flex=\"30\" class=\"md-block mb-0\"><md-checkbox \nng-change=\"vm.creationObject = {}; vm.createObjects(); vm.checkSportData()\" style=\"margin: 5px 0px\" \nng-model=\"vm.isNewCompetition\">{{vm.translate(\'MATCH_CENTER.IS_NEW\')}}</md-checkbox></md-input-container>\n<md-input-container flex=\"70\" class=\"md-block mb-0\" ng-if=\"vm.isNewCompetition\"><label translate=\"MATCH_CENTER.TITLE\">\n</label><input ng-model=\"vm.creationObject.title\" type=\"text\" required></md-input-container><md-input-container \nflex=\"70\" class=\"md-block mb-0\" ng-if=\"!vm.isNewCompetition\"><label translate=\"MATCH_CENTER.COMPETITION\"></label>\n<md-select ng-change=\"vm.checkSportData()\" ng-model=\"vm.creationObject\" \nplaceholder=\"{{vm.translate(\'MATCH_CENTER.COMPETITION\')}}\"><md-option value=\"\">---</md-option><md-option \nng-repeat=\"comp in vm.competitions\" ng-value=\"comp\">{{comp.title}}</md-option></md-select></md-input-container></div>\n<md-input-container ng-if=\"vm.isNewCompetition\" class=\"md-block mt-0\"><label translate=\"MATCH_CENTER.SPORT\"></label>\n<md-select ng-change=\"vm.checkSportData()\" ng-model=\"vm.creationObject.id_subsec\" \nplaceholder=\"{{vm.translate(\'MATCH_CENTER.SPORT\')}}\"><md-option value=\"\">---</md-option><md-option \nng-repeat=\"sport in vm.sports\" value=\"{{sport.value}}\">{{vm.translate(sport.name)}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\"><label translate=\"MATCH_CENTER.SEASON\"></label><md-select \nng-model=\"vm.competition_season.season\" placeholder=\"{{vm.translate(\'MATCH_CENTER.SEASON\')}}\"><md-option value=\"\">---\n</md-option><md-option ng-repeat=\"season in vm.seasons\" ng-value=\"{{season}}\">{{season.season}}</md-option></md-select>\n</md-input-container><md-input-container \nng-if=\"!vm.competition_season.has_subcompetitions  && (vm.creationObject.id_subsec || (!vm.isNewCompetition && vm.creationObject.id))\" \nclass=\"md-block\"><label translate=\"MATCH_CENTER.TYPE_MATCH\"></label><md-select \nng-model=\"vm.competition_season.match_type\" placeholder=\"{{vm.translate(\'MATCH_CENTER.TYPE_MATCH\')}}\"><md-option \nvalue=\"\">---</md-option><md-option ng-repeat=\"comp in vm.typesMatch\" value=\"{{comp.id}}\">{{comp.name | translate}}\n</md-option></md-select></md-input-container><md-input-container \nng-if=\"vm.creationObject.id_subsec || (!vm.isNewCompetition && vm.creationObject.id)\" class=\"md-block\"><label \ntranslate=\"MATCH_CENTER.CLASIFICATION_TYPE\"></label><md-select ng-model=\"vm.competition_season.result_type\" \nplaceholder=\"Clasification type\"><md-option value=\"\">---</md-option><md-option \nng-repeat=\"comp in vm.typesClasification\" value=\"{{comp.id}}\">{{vm.translate(comp.name)}}</md-option></md-select>\n</md-input-container>");
$templateCache.put("app/main/apps/match-center/dialogs/forms-creation/match-center-dialog.controller.html","<md-dialog class=\"small compose-dialog\"><form class=\"md-inline-form\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><a class=\"md-button grey-A100-fg\" type=\"import\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-folder\" class=\"s18 mr-5 ml-0 md-font material-icons\" role=\"img\" aria-label=\"icon-folder\">\n</md-icon><span class=\"title\" translate=\"MATCH_CENTER.CREATE\"></span></a></div><div layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" \ntranslate-aria-label=\"GROUP.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></div>\n</md-toolbar><md-dialog-content ms-scroll><form name=\"vm.basicForm\" class=\"md-inline-form\" novalidate>\n<md-input-container class=\"md-block\"><label translate=\"MATCH_CENTER.TYPE\"></label><md-select \nng-model=\"vm.creationtype\" ng-change=\"vm.createObjects()\"><md-option ng-value=\"type.id\" ng-repeat=\"type in vm.types\">\n{{ vm.translate(type.name) }}</md-option></md-select></md-input-container><md-content ng-switch=\"vm.creationtype\"><div \nng-switch-when=\"1\"><ng-content ng-include=\"\'app/main/apps/match-center/dialogs/forms-creation/season.html\'\">\n</ng-content></div><div ng-switch-when=\"2\"><ng-content \nng-include=\"\'app/main/apps/match-center/dialogs/forms-creation/competition.html\'\"></ng-content></div><div \nng-switch-when=\"4\"><ng-content ng-include=\"\'app/main/apps/match-center/dialogs/forms-creation/subcompetition.html\'\">\n</ng-content></div></md-content></form></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"cancel()\" \nclass=\"send-button md-warn md-raised\" aria-label=\"Cancel\" translate=\"MATCH_CENTER.CANCEL\" \ntranslate-attr-aria-label=\"MATCH_CENTER.CANCEL\"></md-button><md-button ng-if=\"vm.creationtype ==1\" \nng-disabled=\"!vm.creationObject.season\" ng-click=\"vm.save()\" class=\"send-button md-accent md-raised\" aria-label=\"Save\" \ntranslate=\"MATCH_CENTER.SAVE\" translate-attr-aria-label=\"MATCH_CENTER.SAVE\"></md-button><md-button \nng-if=\"vm.creationtype == 2\" \nng-disabled=\"!vm.competition_season.match_type || !vm.competition_season.result_type || !vm.creationObject.id_subsec || !vm.competition_season.season\" \nng-click=\"vm.save()\" class=\"send-button md-accent md-raised\" aria-label=\"Save\" translate=\"MATCH_CENTER.SAVE\" \ntranslate-attr-aria-label=\"MATCH_CENTER.SAVE\"></md-button><md-button ng-if=\"vm.creationtype == 4\" \nng-disabled=\"(!vm.competition_season.match_type || !vm.competition_season.result_type)\" ng-click=\"vm.save()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Save\" translate=\"MATCH_CENTER.SAVE\" \ntranslate-attr-aria-label=\"MATCH_CENTER.SAVE\"></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/match-center/dialogs/forms-creation/season.html","<md-input-container class=\"md-block\"><label translate=\"MATCH_CENTER.NAME\"></label><input \nng-model=\"vm.creationObject.season\" type=\"text\" required></md-input-container>");
$templateCache.put("app/main/apps/match-center/dialogs/forms-creation/subcompetition.html","<md-input-container class=\"md-block mb-0\"><label translate=\"MATCH_CENTER.TITLE\"></label><input \nng-model=\"vm.competition_season.reference_name\" type=\"text\" required></md-input-container><md-input-container \nclass=\"md-block\"><label translate=\"MATCH_CENTER.COMPETITION_PARENT\"></label><md-select ng-model=\"vm.creationObject\" \nng-change=\"vm.checkSportData()\" placeholder=\"{{vm.translate(\'MATCH_CENTER.COMPETITION_PARENT\')}}\"><md-option value=\"\">\n---</md-option><md-option ng-repeat=\"comp in vm.competitionsSeasons\" ng-value=\"{{comp}}\">{{comp.reference_name}}\n</md-option></md-select></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"MATCH_CENTER.TYPE_MATCH\"></label><md-select ng-model=\"vm.competition_season.match_type\" \nplaceholder=\"{{vm.translate(\'MATCH_CENTER.TYPE_MATCH\')}}\"><md-option value=\"\">---</md-option><md-option \nng-repeat=\"comp in vm.typesMatch\" value=\"{{comp.id}}\">{{comp.name | translate}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\"><label>Clasification type</label><md-select \nng-model=\"vm.competition_season.result_type\" placeholder=\"Clasification type\"><md-option value=\"\">---</md-option>\n<md-option ng-repeat=\"comp in vm.typesClasification\" value=\"{{comp.id}}\">{{vm.translate(comp.name)}}</md-option>\n</md-select></md-input-container>");
$templateCache.put("app/main/apps/match-center/dialogs/jury/jury-dialog.html","<md-dialog class=\"jury\" aria-label=\"New Task\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between\"><h1 class=\"title\">\n{{ vm.translate(vm.title) }}</h1><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><div flex layout=\"column\" layout-align=\"center center\" ng-if=\"vm.loadingReadPane\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div layout=\"row\" \nclass=\"search-bar pr-10\"><md-icon style=\"margin-top: 10px\" ng-click=\"vm.getContentSection(vm.searchQuery)\" \nmd-font-icon=\"icon-magnify\" class=\"md-icon-button md-button\"><md-tooltip hide show-gt-xs><span \ntranslate=\"TOOLBAR.SEARCH\">Search</span></md-tooltip></md-icon><input id=\"ms-search-bar-input\" type=\"text\" \nng-model=\"vm.searchQuery\" placeholder=\"Search\" md-autofocus translate translate-attr-placeholder=\"TOOLBAR.SEARCH\" flex \nng-enter=\"vm.getContentSection(vm.searchQuery)\"><md-checkbox \nng-click=\"vm.showAll = !vm.showAll;vm.searchQuery = \'\'; vm.getContentSection()\" ng-checked=\"vm.showAll\">\n{{\'MATCH_CENTER.SHOW_ALL\' | translate }}</md-checkbox></div><div class=\"list-item\" \nng-repeat=\"person in vm.people  track by $index\" md-no-ink ng-cloak><div layout=\"row\" layout-align=\"start center\">\n<md-checkbox ng-checked=\"vm.isSelected(person)\" ng-click=\"vm.select(person)\" class=\"no-label\" aria-label=\"jury person\">\n</md-checkbox><media attachment=\"person.Thumbnail[0]\" thumbnail=\"true\" class=\"avatar\"></media><span class=\"ml-5\">\n{{person.name}}</span> <span class=\"grey-500-fg ml-auto\">#{{person.id}}</span></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-=\"end\"><md-input-container flex layout=\"row\" layout-align=\"end center\">\n<md-button type=\"submit\" class=\"send-button md-accent md-raised\" ng-click=\"vm.saveDialog()\" translate=\"FORMS.ADD\">ADD\n</md-button><md-button type=\"button\" class=\"md-raised md-warn\" ng-click=\"vm.closeDialog()\" translate=\"FORMS.CANCEL\">\nCancel</md-button></md-input-container></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/match-center/dialogs/people/people-dialog.html","<md-dialog class=\"people\" aria-label=\"New Task\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between\"><h1 class=\"title\">\n{{\'MATCH_CENTER.PEOPLE\' | translate}}</h1><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><div flex layout=\"column\" layout-align=\"center center\" ng-if=\"vm.loadingReadPane\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div layout=\"row\" \nclass=\"search-bar pr-10\"><md-icon style=\"margin-top: 10px\" ng-click=\"vm.getContentSection(vm.searchQuery)\" \nmd-font-icon=\"icon-magnify\" class=\"md-icon-button md-button\"><md-tooltip hide show-gt-xs><span \ntranslate=\"TOOLBAR.SEARCH\">Search</span></md-tooltip></md-icon><input id=\"ms-search-bar-input\" type=\"text\" \nng-model=\"vm.searchQuery\" placeholder=\"Search\" md-autofocus translate translate-attr-placeholder=\"TOOLBAR.SEARCH\" flex \nng-enter=\"vm.getContentSection(vm.searchQuery)\"><md-checkbox \nng-click=\"vm.showAll = !vm.showAll; vm.getContentSection(vm.searchQuery)\" ng-checked=\"vm.showAll\">\n{{\'MATCH_CENTER.SHOW_ALL\' | translate }}</md-checkbox></div><div class=\"list-item\" \nng-repeat=\"person in vm.people track by $index\" md-no-ink ng-cloak><div layout=\"row\" layout-align=\"start center\">\n<md-checkbox ng-checked=\"vm.isSelected(person)\" ng-click=\"vm.select(person)\" class=\"no-label\" aria-label=\"jury person\">\n</md-checkbox><media ng-if=\"person.Thumbnail && person.Thumbnail.length > 0\" attachment=\"person.Thumbnail[0]\" \nthumbnail=\"true\" class=\"avatar\" crop-format=\"{{vm.cropFormat}}\"></media><img ng-if=\"person.media\" class=\"avatar\" \nng-src=\"{{person.media}}\" alt=\"\"> <img ng-if=\"!person.media && (!person.Thumbnail || person.Thumbnail.length == 0)\" \nclass=\"avatar\" ng-src=\"{{person | mediaPlaceholder}}\" imageonload> <span class=\"grey-500-fg\">#{{person.id}}</span> \n<span class=\"ml-25\">{{person.name}}</span></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-=\"end\"><md-input-container flex layout=\"row\" layout-align=\"end center\"><md-button type=\"submit\" \nng-disabled=\"vm.maxPeopleValidation()\" class=\"send-button md-accent md-raised\" ng-click=\"vm.saveDialog()\" \ntranslate=\"FORMS.ADD\">ADD</md-button><md-button type=\"button\" class=\"md-raised md-warn\" ng-click=\"vm.closeDialog()\" \ntranslate=\"FORMS.CANCEL\">Cancel</md-button></md-input-container></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/match-center/dialogs/previewclip/previewclip-dialog.html","<md-dialog class=\"previewclip-dialog\" aria-label=\"New Task\"><form style=\"height: 100%\" name=\"taskForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between\"><h1 class=\"title\">{{\'MATCH_CENTER.PREVIEW\' | translate}}</h1><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div ng-if=\"vm.isUrlReady && !isLoadingPost\" \nlayout=\"row\"><div flex=\"60\" class=\"black-bg\" layout=\"row\" layout-align=\"center center\"><div layout=\"row\" \nclass=\"player-row\"><div class=\"video-container\" layout=\"column\"><video id=\"mp4-player\" autoplay controls><source \nng-src=\"{{vm.clipUrl}}\" type=\"video/mp4\"></video></div></div></div><div flex=\"40\"><ms-social-widget-share \nservice=\"\'content\'\" section=\"\'livestream\'\" idcontent=\"vm.idLiveStream\" medias=\"[vm.id_media]\"></ms-social-widget-share>\n</div></div><div flex layout=\"column\" layout-align=\"center center\" ng-if=\"!vm.isUrlReady && vm.sharing\" \nclass=\"loading-container\"><md-progress-circular class=\"m-auto\" md-mode=\"indeterminate\" md-diameter=\"50\">\n</md-progress-circular><div class=\"text-center\"><h1 class=\"bold\">{{\'MATCH_CENTER.PREPARING\' | translate}}</h1></div>\n</div><div flex layout=\"column\" layout-align=\"center center\" ng-if=\"!vm.isUrlReady && !vm.sharing\" \nclass=\"loading-container\"><md-progress-circular class=\"m-auto\" md-mode=\"indeterminate\" md-diameter=\"50\">\n</md-progress-circular><div class=\"text-center\"><h1 class=\"bold\">{{\'MATCH_CENTER.PROCCESSING_VIDEO\' | translate}}</h1>\n<h3>{{\'MATCH_CENTER.PROCCESSING_VIDEO_2\' | translate}}</h3></div></div><div flex layout=\"column\" \nlayout-align=\"center center\" ng-if=\"isLoadingPost\" class=\"loading-container\"><md-progress-circular class=\"m-auto\" \nmd-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular><div class=\"text-center\"><h1 class=\"bold\">\n{{\'MATCH_CENTER.PUBLISHING_VIDEO\' | translate}}</h1></div></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/match-center/dialogs/selectmedia/selectmedia-dialog.html","<md-dialog class=\"selectmedia attachment-dialog add-media\" aria-label=\"New Message\"><form class=\"md-inline-form\">\n<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\"><a class=\"md-button\" type=\"1\" layout=\"row\" layout-align=\"center center\" ng-click=\"vm.changeView(1)\" \nng-if=\"vm.views[1]\"><md-icon md-font-icon=\"icon-file-image-box\" class=\"s18 mr-5 ml-0\"></md-icon><span \ntranslate=\"MEDIA.IMAGES\"></span> </a><a class=\"md-button\" type=\"2\" layout=\"row\" layout-align=\"center center\" \nng-click=\"vm.changeView(2)\" ng-if=\"vm.views[2]\"><md-icon md-font-icon=\"icon-video\" class=\"s18 mr-5 ml-0\"></md-icon>\n<span translate=\"MEDIA.VIDEOS\"></span></a></div><div layout=\"row\"><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate translate-aria-label=\"CONTENT.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></div></md-toolbar><md-content class=\"full-height\"><div \nlayout=\"row\" class=\"full-height left-sidenav carded page-layout\"><div layout=\"column\" flex class=\"center\" md-no-ink>\n<div ng-include=\"\'app/main/apps/match-center/dialogs/selectmedia/toolbar-search.html\'\" \nng-show=\"!vm.firstLoad && vm.isNumber(vm.currentView) && vm.currentView != 5\"></div><div \nng-include=\"\'app/main/apps/match-center/dialogs/selectmedia/toolbar-search-gallery.html\'\" \nng-show=\"!vm.firstLoad && vm.currentView == 5\"></div><md-dialog-content layout=\"column\" ms-scroll=\"vm.msScrollOptions\" \nflex=\"100\" class=\"mediadialog-content scrollable\"><div flex layout=\"column\" layout-align=\"center center\" \nng-show=\"vm.loading || vm.firstLoad\" class=\"loading-container\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"50\"></md-progress-circular></div><div ng-include=\"vm.views[vm.currentView]\" \nng-hide=\"vm.isNumber(vm.currentView) && vm.items.length == 0\" ng-style=\"{\'opacity\' : vm.loading ? 0.2 : 1}\"></div><div \nng-if=\"vm.isNumber(vm.currentView) && vm.items.length == 0 && !vm.loading && !vm.firstLoad\" layout=\"row\" \nlayout-align=\"center center\" class=\"content-wrapper full-height\" flex=\"100\"><div class=\"message\" \ntranslate=\"MEDIA_DIALOG.NO_ITEMS_AVAILABLE\"></div></div></md-dialog-content></div></div></md-content><md-dialog-actions\n layout=\"row\" layout-align=\"end center\" ng-style=\"{\'opacity\' : vm.loading ? 0.2 : 1}\" \nng-if=\" (vm.items.length > 0 || vm.files.length > 0)\"><div layout=\"row\" layout-align=\"start center\" \nng-if=\"!vm.totalItems\" hide show-gt-xs><span>&nbsp;</span></div><div layout=\"row\" layout-align=\"start center\" \nng-if=\"vm.totalItems > 0\" hide show-gt-xs ng-if=\"vm.showSearchAndPaginator\"><span class=\"page-info\" \nng-if=\"vm.showSearchAndPaginator\">{{vm.totalItems | number}} </span>&nbsp;<span translate=\"CONTENT.ITEMS_FOUND\"></span>\n<md-button aria-label=\"Previous\" class=\"md-icon-button arrow\" ng-if=\"vm.showSearchAndPaginator\" \nng-click=\"vm.prevPage()\" ng-disabled=\"vm.firstPage()\" translate=\"\" translate-attr-aria-label=\"CONTENT.PREVIOUS\">\n<md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip md-direction=\"top\"><span translate=\"CONTENT.PREVIOUS\">\n</span></md-tooltip></md-button><div><md-select ng-model=\"pagination_page\" placeholder=\"{{vm.currentPage | number}}\" \nclass=\"toolbar-item\"><md-option ng-repeat=\"n in [].constructor(vm.lastPage) track by $index\" value=\"{{$index +1}}\" \nng-click=\"vm.gotoPage($index+1)\">{{$index+1}}</md-option></md-select><md-tooltip md-direction=\"top\"><span \ntranslate=\"CONTENT.SELECT_PAGE\"></span></md-tooltip></div><span class=\"page-info\" hide=\"\" show-gt-xs=\"\">\n/ {{vm.lastPage | number}}</span><md-button aria-label=\"Next\" class=\"md-icon-button arrow\" \nng-if=\"vm.showSearchAndPaginator\" ng-click=\"vm.nextPage()\" ng-disabled=\"!vm.morePages()\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip \nmd-direction=\"top\"><span translate=\"CONTENT.NEXT\"></span></md-tooltip></md-button></div><div layout=\"row\" \nlayout-align=\"end center\" ng-if=\"vm.maxAttach > 1\"><md-button \nng-disabled=\"vm.currentView == \'upload\' && (vm.files.length == 0 || vm.files.length > vm.uploadedFiles.length)\" \nng-click=\"vm.attachMedia()\" class=\"send-button md-accent md-raised\" aria-label=\"Send\" translate=\"MEDIA.ATTACH\" \ntranslate-attr-aria-label=\"MEDIA.ATTACH\"></md-button><md-button ng-if=\"show\" class=\"send-button md-accent md-raised\" \naria-label=\"Send\" translate=\"MEDIA_DIALOG.UPLOADING\"></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/match-center/dialogs/selectmedia/toolbar-search-gallery.html","<md-toolbar><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><ms-search-bar-none flex \nclass=\"expanded ms-search-bar\" debounce=\"300\" layout=\"row\" layout-align=\"start center\"><div flex layout=\"row\" \nlayout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-icon id=\"ms-search-bar-expander\" \nmd-font-icon=\"icon-magnify\" class=\"md-icon-button md-button search\"><md-tooltip><span translate=\"TOOLBAR.FILTER\">\n</span></md-tooltip></md-icon></label><input id=\"ms-search-bar-input\" type=\"text\" ng-model=\"vm.modelFilter\" \nplaceholder=\"Search\" md-autofocus translate translate-attr-placeholder=\"TOOLBAR.FILTER\" flex \nng-enter=\"vm.pagination_search(vm.modelSearch)\"></div></ms-search-bar-none></div></md-toolbar>");
$templateCache.put("app/main/apps/match-center/dialogs/selectmedia/toolbar-search.html","<md-toolbar ng-if=\"vm.showSearchAndPaginator\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><ms-search-bar-none flex class=\"expanded ms-search-bar\" debounce=\"300\" \nmodel-search=\"vm.searchStringFilter\" on-search=\"vm.searchMedia()\" layout=\"row\" layout-align=\"start center\"><div flex \nlayout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-icon id=\"ms-search-bar-expander\" \nmd-font-icon=\"icon-magnify\" class=\"md-icon-button md-button search\"><md-tooltip><span translate=\"TOOLBAR.SEARCH\">\n</span></md-tooltip></md-icon></label><md-button ng-click=\"vm.modelSearch = \'\';vm.pagination_search(vm.modelSearch)\" \naria-label=\"view type\" class=\"md-icon-button\" translate=\"\" translate-attr-aria-label=\"CONTENT.FILTERS\" \nclass=\"md-icon-button\" id=\"ms-filters-cleaner\" ng-if=\"vm.modelSearch != \'\'\"><md-icon md-font-icon=\"icon-close-circle\">\n</md-icon><md-tooltip><span translate=\"TOOLBAR.RESET_SEARCH\"></span></md-tooltip></md-button><input \nid=\"ms-search-bar-input\" type=\"text\" ng-model=\"vm.modelSearch\" placeholder=\"Search\" md-autofocus translate \ntranslate-attr-placeholder=\"TOOLBAR.SEARCH\" flex ng-enter=\"vm.pagination_search(vm.modelSearch)\"><md-icon \nid=\"ms-search-bar-collapser\" md-font-icon=\"icon-close-circle\" class=\"icon s24\"></md-icon><md-button hide show-gt-xs \nid=\"ms-search-bar-button\" class=\"md-accent md-raised search\" ng-click=\"vm.pagination_search(vm.modelSearch)\" \naria-label=\"description\" md-no-ink=\"true\" md-ripple-size=\"auto\" translate=\"TOOLBAR.SEARCH\"></md-button><md-button hide \nshow-xs id=\"ms-search-bar-button\" class=\"md-accent md-raised md-icon-button search\" \nng-click=\"vm.pagination_search(vm.modelSearch)\" ng-disabled=\"!vm.modelSearch\" aria-label=\"description\" \nmd-no-ink=\"true\" md-ripple-size=\"auto\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>\n</ms-search-bar-none></div></md-toolbar>");
$templateCache.put("app/main/apps/match-center/dialogs/settings/settings-tabs-dialog.controller.html","<md-dialog class=\"settings-tabs-dialog\" aria-label=\"New Task\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between\"><h1 \nclass=\"title\" translate=\"MATCH_CENTER.CONFIGURE_TABS\"></h1><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div ng-sortable=\"vm.templateSortable\"><div layout=\"row\" \nlayout-align=\"start center\" ng-if=\"!loading\" class=\"list-item template drag-item\" ng-repeat=\"tab in vm.data\" md-no-ink \nng-cloak><div layout=\"row\" layout-align=\"start center\"><md-icon class=\"drag icon-equal\" aria-label=\"DRAG\"></md-icon>\n<span class=\"ml-25\">{{tab.title | translate}}</span></div><div layout=\"row\" flex layout-align=\"end center\"><div><button\n ng-if=\"tab.onoff===1\" class=\"md-icon-button md-button\" ng-click=\"vm.toggleItemStatusTab(tab, $event)\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\"></md-icon></button> <button ng-if=\"tab.onoff!==1\" \nclass=\"md-icon-button md-button\" ng-click=\"vm.toggleItemStatusTab(tab, $event)\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\"></md-icon></button></div></div></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-=\"end\"><md-input-container flex layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"send-button md-accent md-raised\" ng-click=\"vm.saveDialog()\" \ntranslate=\"MATCH_CENTER.ACCEPT\">ACCEPT</md-button></md-input-container></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/match-center/dialogs/selecttext/selecttext-dialog.html","<md-dialog class=\"selecttext-dialog\" aria-label=\"New Task\"><form style=\"height: 100%\" name=\"taskForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between\"><h1 class=\"title\">OVERLAY TEXT</h1><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div flex layout=\"column\" layout-align=\"center center\" ng-show=\"isLoading\" \nclass=\"loading-container\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div>\n<div layout=\"column\" ng-show=\"!isLoading\" fill-width layout-align=\"center center\" class=\"ph-15\"><md-input-container \nfill-width><label>Text</label><textarea ng-model=\"vm.text\"></textarea></md-input-container><div fill-width><div \nlayout=\"column\" class=\"mb-15\"><label for=\"font-size\">Font size {{vm.fontsize}}</label><input type=\"range\" min=\"10\" \nmax=\"120\" id=\"font-size\" ng-model=\"vm.fontsize\"></div><div class=\"form-row text-inputs\"><div layout=\"row\" \nclass=\"pv-10\" style=\"border-bottom: 1px solid #e0e0e0\"><span>HEX</span><color-input \nclass=\"ml-10 color-input-container\" model=\"vm.color\"></color-input></div></div><div class=\"form-row color-inputs\">\n<md-select ng-model=\"vm.weight\"><md-option ng-repeat=\"option in vm.weightOptions\" ng-value=\"option\">\n{{option | translate}}</md-option></md-select></div><div class=\"form-row text-inputs\"><md-select \nng-model=\"vm.fontfamily\"><md-option ng-repeat=\"option in vm.fontfamilyOptions\" ng-value=\"option\">{{option | translate}}\n</md-option></md-select></div></div></div></md-dialog-content><md-dialog-actions ng-show=\"!isLoading\" layout=\"row\" \nlayout-align=\"end\"><div style=\"width: 300px\" layout=\"row\" layout-align=\"end end\"><md-input-container><md-button \ntype=\"button\" class=\"md-raised md-warn\" ng-click=\"vm.closeDialog()\" translate=\"FORMS.CANCEL\"></md-button>\n</md-input-container><md-input-container><md-button ng-disabled=\"!vm.text\" type=\"button\" class=\"md-raised md-accent\" \nng-click=\"vm.saveDialog()\">ACCEPT</md-button></md-input-container></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/match-center/dialogs/team-status/team-status.html","<md-dialog class=\"team-status\" aria-label=\"New Task\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between\"><h1 \nclass=\"title\" translate=\"MATCH_CENTER.STATUS\"></h1><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div layout=\"row\" flex><md-input-container flex class=\"mh-25\"><label \ntranslate=\"MATCH_CENTER.STATUS\"></label><md-select ng-model=\"vm.team.status.value\"><md-option value=\"\">-</md-option>\n<md-option value=\"DNF\">DNF</md-option><md-option value=\"DNS\">DNS</md-option><md-option value=\"DSQ\">DSQ</md-option>\n<md-option value=\"ARV\">ARV</md-option><md-option value=\"NYS\">NYS</md-option><md-option value=\"RAC\">RAC</md-option>\n<md-option value=\"RET\">RET</md-option><md-option value=\"SUS\">SUS</md-option><md-option value=\"STA\">STA</md-option>\n<md-option value=\"NL\">NL</md-option><md-option value=\"STM\">STM</md-option><md-option value=\"PRV\">PRV</md-option>\n<md-option value=\"RED\">RED</md-option><md-option value=\"PIT\">PIT</md-option><md-option value=\"INR\">INR</md-option>\n</md-select></md-input-container></div><div layout=\"row\" flex><md-input-container flex class=\"mh-25\"><label \ntranslate=\"MATCH_CENTER.COMMENT\"></label><textarea ng-model=\"vm.team.status.comment\"></textarea></md-input-container>\n</div></md-dialog-content><md-dialog-actions layout=\"row\" layout-=\"end\"><md-input-container flex layout=\"row\" \nlayout-align=\"end center\"><md-button type=\"submit\" class=\"send-button md-accent md-raised\" ng-click=\"vm.saveDialog()\" \ntranslate=\"MATCH_CENTER.ACCEPT\">ACCEPT</md-button><md-button type=\"button\" class=\"md-raised md-warn\" \nng-click=\"vm.closeDialog()\" translate=\"MATCH_CENTER.CANCEL\">Cancel</md-button></md-input-container></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/apps/match-center/dialogs/teams/import-dialog.html","<md-dialog class=\"teams-dialog\" aria-label=\"New Task\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between\"><h1 \nclass=\"title\" translate=\"MATCH_CENTER.TEAMS\"></h1><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><div flex \nlayout=\"column\" layout-align=\"center center\" ng-if=\"isLoading\" class=\"loading-container\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><md-dialog-content ms-scroll><md-content \nms-scroll flex><div class=\"navigation-simple\" layout=\"column\" class=\"importTeam\"><div \nng-if=\"vm.seasons && !vm.importSeason1\" ivh-treeview=\"vm.seasons\" ivh-treeview-expand-to-depth=\"-1\" \nivh-treeview-filter=\"vm.treeSearch\" ivh-treeview-label-attribute=\"\'label\'\" class=\"ivh-treeview-folder\" \nivh-treeview-on-cb-change=\"vm.importChange(ivhNode)\" ivh-treeview-use-checkboxes=\"true\"></div></div></md-content><div \nng-if=\"!loading && vm.importSeason1\" class=\"list-item\" \nng-repeat=\"team in vm.currentCompetitionSeasonI.teams track by $index\" md-no-ink ng-cloak><div layout=\"row\" \nlayout-align=\"start center\"><md-checkbox ng-if=\"!loading\" ng-checked=\"vm.isSelected(team)\" ng-click=\"vm.select(team)\" \nclass=\"no-label\"></md-checkbox><media ng-if=\"team.Thumbnail && team.Thumbnail.length > 0\" \nattachment=\"team.Thumbnail[0]\" thumbnail=\"true\" class=\"avatar1\" crop-format=\"0\"></media><img ng-if=\"team.media\" \nclass=\"avatar\" ng-src=\"{{team.media}}\" alt=\"\"> <img \nng-if=\"!team.media && (!team.Thumbnail || team.Thumbnail.length == 0)\" class=\"avatar\" \nng-src=\"assets/images/common/no_image_available_10.png\" imageonload> <span class=\"grey-500-fg\">\n#{{team[vm.sectionTeamsId]}}</span> <span class=\"ml-25\">{{team[vm.sectionTeamsName]}}</span></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-=\"end\"><span ng-if=\"vm.maxTeamsValidation()\" \ntranslate=\"MATCH_CENTER.TEAMS_EXCEDED\"></span><md-input-container flex layout=\"row\" layout-align=\"end center\">\n<md-button type=\"button\" class=\"md-raised md-warn\" ng-click=\"vm.importCloseDialog()\" translate=\"FORMS.CANCEL\">Cancel\n</md-button><md-button ng-disabled=\"vm.maxTeamsValidation()\" ng-if=\"vm.importSeason1\" \nclass=\"send-button md-accent md-raised\" ng-click=\"vm.saveDialog()\" translate=\"FORMS.ADD\">ADD</md-button>\n</md-input-container></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/match-center/dialogs/teams/teams-dialog.html","<md-dialog class=\"teams-dialog\" aria-label=\"New Task\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between\"><h1 \nclass=\"title\" translate=\"MATCH_CENTER.TEAMS\"></h1><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div flex layout=\"column\" layout-align=\"center center\" ng-if=\"loading\" \nclass=\"loading-container\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div>\n<div ng-if=\"!loading\" layout=\"row\" flex=\"100\" class=\"search-bar pr-10\"><md-icon \nstyle=\"margin-left: 10px;margin-top: 10px\" ng-click=\"vm.getTeams(vm.searchQuery)\" md-font-icon=\"icon-magnify\" \nclass=\"md-icon-button md-button\"><md-tooltip hide show-gt-xs><span translate=\"TOOLBAR.SEARCH\">Search</span>\n</md-tooltip></md-icon><input id=\"ms-search-bar-input\" type=\"text\" ng-change=\"onSearchChange(vm.searchQuery)\" \nng-model=\"vm.searchQuery\" placeholder=\"Search\" md-autofocus translate translate-attr-placeholder=\"TOOLBAR.SEARCH\" flex>\n<md-checkbox ng-model=\"checkAllTeams\" ng-click=\"vm.showAllTeams()\">{{\'MATCH_CENTER.SHOW_INACTIVE\' | translate }}\n</md-checkbox></div><div ng-if=\"!loading\" class=\"list-item\" ng-repeat=\"team in vm.teams track by $index\" md-no-ink \nng-cloak><div layout=\"row\" layout-align=\"start center\"><md-checkbox ng-checked=\"vm.isSelected(team)\" \nng-click=\"vm.select(team)\" class=\"no-label\" aria-label=\"Check\"></md-checkbox><media \nng-if=\"team.Thumbnail && team.Thumbnail.length > 0\" attachment=\"team.Thumbnail[0]\" thumbnail=\"true\" class=\"avatar\" \ncrop-format=\"0\"></media><img ng-if=\"team.media\" class=\"avatar\" ng-src=\"{{team.media}}\" alt=\"\"> <img \nng-if=\"!team.media && (!team.Thumbnail || team.Thumbnail.length == 0)\" class=\"avatar\" \nng-src=\"assets/images/common/no_image_available_10.png\" imageonload> <span class=\"ml-5\">{{team[vm.sectionTeamsName]}}\n</span> <span class=\"grey-500-fg ml-auto\">#{{team[vm.sectionTeamsId]}}</span></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-=\"end\"><md-checkbox ng-if=\"vm.skipLoad\" \nng-click=\"vm.showAll = !vm.showAll;vm.searchQuery = \'\';  vm.getTeams()\" aria-label=\"Check all\" ng-checked=\"vm.showAll\">\n{{\'MATCH_CENTER.SHOW_ALL\' | translate }}</md-checkbox><span ng-if=\"vm.maxTeamsValidation()\" \ntranslate=\"MATCH_CENTER.TEAMS_EXCEDED\"></span><md-input-container flex layout=\"row\" layout-align=\"end center\">\n<md-button type=\"button\" class=\"md-raised md-warn\" ng-click=\"vm.closeDialog()\" translate=\"FORMS.CANCEL\">Cancel\n</md-button><md-button ng-disabled=\"vm.maxTeamsValidation()\" class=\"send-button md-accent md-raised\" \nng-click=\"vm.saveDialog()\" translate=\"FORMS.ADD\">ADD</md-button></md-input-container></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/apps/match-center/dialogs/team-edit/team-edit.html","<md-dialog class=\"team-edit\" aria-label=\"New Task\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between\"><h1 class=\"title\" \nng-bind=\"vm.team.team_name\"></h1><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><div layout=\"row\" class=\"tabs\"><div class=\"tab\" ng-class=\"{\'active\' : vm.activeTab == $index}\" \nng-click=\"vm.activeTab = $index\" ng-repeat=\"tab in vm.tabs track by $index\">{{vm.translate(tab.name)}}</div></div><div \nng-if=\"vm.activeTab == $index\" class=\"tab-content\" layout=\"column\" ng-repeat=\"tab in vm.tabs track by $index\"><div \nlayout=\"row\" layout-align=\"start center\" class=\"ph-15\" ng-if=\"tab.lineuptype\"><md-input-contaimer class=\"md-block\" \nflex=\"50\"><md-select ng-model=\"vm.team.lineup_type\" ng-model-options=\"{trackBy: \'$value.id\'}\" \nplaceholder=\"{{ tab.lineuptype.name | translate}}\"><md-option ng-repeat=\"option in tab.lineuptype.options\" \nng-value=\"option\">{{option.value}}</md-option></md-select></md-input-contaimer></div><div layout=\"column\" \nng-sortable=\"vm.templateSortable\"><md-list-item layout=\"row\" class=\"template flex fix team drag-item\" \nng-repeat=\"player in vm.team[tab.section] track by $index\"><div class=\"flex\" layout=\"row\" \nlayout-align=\"space-between center\" flex=\"100\"><div layout=\"row\" layout-align=\"start center\" flex=\"75\"><div \nclass=\"media-attachment-people\" layout=\"column\" layout-align=\"start center\"><img ng-if=\"player.media\" class=\"avatar\" \nng-src=\"{{player.media}}\" imageonload> <img ng-if=\"!player.media\" class=\"avatar\" \nng-src=\"assets/images/common/no_image_available_10.png\" imageonload></div><div class=\"edit-mode ml-10 flex-xs-10\" \nlayout=\"column\" layout-align=\"start center\" flex=\"5\"><input ng-model=\"player.number\" aria-label=\"Edit Number\"></div>\n<div class=\"field\" layout=\"column\" layout-align=\"start center\"><div><span class=\"ml-25\">{{player.name}}</span></div>\n</div></div><div layout=\"row\" layout-align=\"end center\"><md-button ng-click=\" vm.team[tab.section].splice($index, 1);\" \nclass=\"md-icon-button\" aria-label=\"More\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"md-default-theme md-font material-icons icon-delete\"></md-icon></md-button><md-icon class=\"drag icon-equal\" \naria-label=\"DRAG\"></md-icon></div></div></md-list-item></div><div class=\"mt-15 mr-16 mb-50\" layout=\"row\" \nlayout-align=\"end center\"><h3 class=\"grey-700-fg\">\n{{vm.translate(\'MATCH_CENTER.MAXIMUN\')}} {{tab.max}} {{vm.translate(\'MATCH_CENTER.PEOPLE\')}}</h3><md-button \nng-disabled=\"tab.max <= vm.team[tab.section].length\" class=\"add-event-button no-sort md-fab md-warn\" \nng-click=\"vm.openDialog($event, tab, tab.section)\" aria-label=\"Add\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n</md-button></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-=\"end\"><md-input-container flex \nlayout=\"row\" layout-align=\"end center\"><md-button type=\"submit\" class=\"send-button md-accent md-raised\" \nng-click=\"vm.saveDialog()\" translate=\"MATCH_CENTER.ACCEPT\">ACCEPT</md-button><md-button type=\"button\" \nclass=\"md-raised md-warn\" ng-click=\"vm.closeDialog()\" translate=\"MATCH_CENTER.CANCEL\">Cancel</md-button>\n</md-input-container></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/match-center/dialogs/titleclip/titleclip-dialog.html","<md-dialog class=\"titleclip-dialog\" aria-label=\"New Task\"><form style=\"height: 100%\" name=\"taskForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between\"><h1 class=\"title\">{{\'CONTENT.CREATE\'| translate}}</h1><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div class=\"p-15\" flex=\"100\"><md-input-container class=\"md-block\"><label>\n{{ \'MATCH_CENTER.TITLE\' | translate}}</label><input type=\"text\" ng-model=\"vm.title\" \nplaceholder=\"{{ \'MATCH_CENTER.TITLE\' | translate}}\" md-autofocus autocomplete=\"off\"></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"end center\"><md-button type=\"button\" class=\"md-raised md-warn\" ng-click=\"vm.closeDialog()\" \ntranslate=\"MATCH_CENTER.CANCEL\">Cancel</md-button><md-button ng-click=\"vm.saveDialog()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Apply\" translate=\"MATCH_CENTER.SAVE\" \ntranslate-attr-aria-label=\"MATCH_CENTER.SAVE\"></md-button><md-button ng-if=\"vm.create\" \nng-click=\"vm.saveDialogAndEdit()\" class=\"send-button md-accent md-raised\" aria-label=\"Apply\" \ntranslate=\"MATCH_CENTER.SAVE_AND_EDIT\" translate-attr-aria-label=\"MATCH_CENTER.SAVE_AND_EDIT\"></md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/match-center/dialogs/venues/venues-dialog.controller.html","<md-dialog class=\"venues-dialog\" aria-label=\"New Task\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between\"><h1 \nclass=\"title\" translate=\"MATCH_CENTER.VENUES\"></h1><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div flex layout=\"column\" layout-align=\"center center\" ng-if=\"loading\" \nclass=\"loading-container\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div>\n<div ng-if=\"!loading\" layout=\"row\" flex=\"100\" class=\"search-bar\"><input id=\"ms-search-bar-input\" type=\"text\" \nng-model=\"vm.searchQuery\" ng-enter=\"vm.getVenues(vm.searchQuery)\" placeholder=\"Search\" md-autofocus translate \ntranslate-attr-placeholder=\"TOOLBAR.SEARCH\" flex><md-icon style=\"position: absolute; right: 15px; top:15px\" \nng-cilck=\"vm.getVenues(vm.searchQuery)\" id=\"ms-search-bar-collapser\" md-font-icon=\"icon-magnify\" \nclass=\"icon s24 pointer\"></md-icon></div><div ng-if=\"!loading\" class=\"list-item\" \nng-repeat=\"venue in vm.venues track by $index\" md-no-ink ng-cloak><div layout=\"row\" layout-align=\"start center\">\n<md-checkbox ng-checked=\"vm.isSelected(venue)\" ng-click=\"vm.select(venue)\" class=\"no-label\"></md-checkbox><media \nng-if=\"venue.Thumbnail && venue.Thumbnail.length > 0\" attachment=\"venue.Thumbnail[0]\" thumbnail=\"true\" class=\"avatar\">\n</media><img ng-if=\"venue.media\" class=\"avatar\" ng-src=\"{{venue.media}}\" alt=\"\"> <img \nng-if=\"!venue.media && (!venue.Thumbnail || venue.Thumbnail.length == 0)\" class=\"avatar\" \nng-src=\"assets/images/common/no_image_available_10.png\" imageonload> <span class=\"grey-500-fg\">#{{venue.id}}</span> \n<span class=\"ml-25\">{{venue.title}}</span></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-=\"end\"><md-input-container flex layout=\"row\" layout-align=\"end center\"><md-button type=\"button\" \nclass=\"md-raised md-warn\" ng-click=\"vm.closeDialog()\" translate=\"FORMS.CANCEL\">Cancel</md-button><md-button \ntype=\"submit\" class=\"send-button md-accent md-raised\" ng-click=\"vm.saveDialog()\" translate=\"FORMS.ADD\">ADD</md-button>\n</md-input-container></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/match-center/views/list/list-view-live.html","<div flex layout=\"column\" layout-align=\"center center\" ng-show=\"isLoading\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div class=\"no-threads\" \nng-if=\"!isLoading && vm.threads.length === 0\" ng-hide=\"isLoading\" translate=\"CONTENT.NO_ITEMS\"></div><div \nid=\"list-content-data\" ng-style=\"{\'opacity\' : isLoading ? 0.2 : 1}\" ms-scroll=\"vm.msScrollOptions\" \nng-class=\"{\'group-filter\': vm.selectedGroup,\'other-filter\':sortField,\'x2-filter\':$root.pagination_searchquery==true}\" \nclass=\"scrollable\" ng-if=\"vm.threads.length> 0\"><div class=\"mail-list-item {{thread.status}}\" \nng-repeat=\"thread in vm.threads | filter: vm.search | filter: global.search\" ng-init=\"parentIndex= $index\" md-no-ink \nng-cloak ng-click=\"vm.openThread(thread)\" \nng-class=\"{\'starred\': thread.starred, \'selected\': vm.selectedContentID === thread.id,\r\n        \'checked\': vm.isChecked(thread)}\">\n<div layout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-label\" ng-checked=\"vm.isSelected(thread)\" \nng-click=\"vm.toggleSelectThread(thread, $event)\" aria-label=\"{{vm.isSelected(thread) ? \'Deselect\' : \'Select\'}}\">\n</md-checkbox><div ng-repeat=\"field in refcolumnsgrouped.left_center | orderBy:\'list_sort\'\"><div \nng-if=\"field.type == \'onoff\'\" ng-include=\"\'app/main/fields/list/onoff.html\'\"></div><div \nng-if=\"field.type == \'language\'\" ng-include=\"\'app/main/fields/list/language.html\'\" layout=\"row\" \nlayout-align=\"center center\"></div><div ng-if=\"field.type == \'thumbnail\'\" \nng-include=\"\'app/main/fields/list/thumbnail.html\'\"></div><div ng-if=\"field.type == \'thumbnail_square\'\" \nng-include=\"\'app/main/fields/list/thumbnail_square.html\'\"></div><md-icon md-font-icon=\"icon-alert-circle\" \nclass=\"is-important red-600-fg\" ng-if=\"field.type == \'important\' && task.important\"></md-icon><md-icon \nmd-font-icon=\"icon-attachment\" class=\"has-attachment s24\" \nng-if=\"field.type == \'attachments\' && thread.Thumbnail.length> 0\"></md-icon></div><div class=\"info\" flex \nlayout=\"column\"><div ng-if=\"refcolumnsgrouped.main\"><div class=\"subject text-truncate grey-500-fg\"><span \nng-repeat=\"field in refcolumnsgrouped.header | orderBy: \'list_sort\'\"><span ng-if=\"field.type == \'id\'\">#</span> <span \nng-if=\"field.type == \'dateHm\' || field.type == \'date\'\" ng-bind=\"vm.showDate(thread[field.titleId])\"></span> <span \nng-if=\"field.type != \'dateHm\' && field.type != \'date\' && field.type != \'section\'\" ng-bind=\"thread.{{field.titleId}}\">\n</span> <span ng-if=\"field.type == \'section\'\" ng-bind=\"vm.showAssoc(thread[field.titleId], field)\"></span></span></div>\n</div><div ng-if=\"refcolumnsgrouped.main\"><div class=\"name\" layout=\"row\" layout-align=\"start center\"><span \nng-repeat=\"field in refcolumnsgrouped.main\" ng-switch=\"\" on=\"field.type\"><span ng-switch-default=\"\" \nng-bind=\"thread.{{field.titleId}}\"></span> <span ng-switch-when=\"date\" ng-bind=\"vm.showDate(thread[field.titleId])\">\n</span> <span ng-switch-when=\"dateHm\" ng-bind=\"vm.showDate(thread[field.titleId])\"></span> <span \nng-switch-when=\"section\" ng-bind=\"vm.showAssoc(thread[field.titleId], field)\"></span></span></div></div><div \nng-repeat=\"field in refcolumnsgrouped.secondary | orderBy:\'list_sort\'\"><div \nng-if=\"(field.type!==\'id_subcat\' && field.type!==\'id_cat\' && field.type!==\'country\' && field.type!==\'id_subsec\' && field.type!==\'date\' && field.type!==\'dateHm\' && field.type!==\'section\') && field.primary!==1\" \nng-include=\"\'app/main/fields/list/secondary-default.html\'\" class=\"details text-truncate\"></div><div \nng-if=\"field.type==\'id_subsec\'\" ng-include=\"\'app/main/fields/list/subsection.html\'\" class=\"details\" layout=\"row\" \nlayout-align=\"start start\"></div><div ng-if=\"field.type==\'id_cat\'\" ng-include=\"\'app/main/fields/list/category.html\'\" \nclass=\"details\" layout=\"row\" layout-align=\"start start\"></div><div ng-if=\"field.type==\'id_subcat\'\" \nng-include=\"\'app/main/fields/list/subcategory.html\'\" class=\"details\" layout=\"row\" layout-align=\"start start\"></div><div\n ng-if=\"field.type == \'section\'\" ng-include=\"\'app/main/fields/list/section.html\'\" class=\"details\" layout=\"row\" \nlayout-align=\"start start\"></div><div ng-if=\"field.type == \'country\'\" ng-include=\"\'app/main/fields/list/country.html\'\" \nclass=\"details\" layout=\"row\" layout-align=\"start start\"></div></div></div><div class=\"buttons\" layout=\"row\" \nlayout-align=\"start center\"><div ng-repeat=\"field in refcolumnsgrouped.right_center | orderBy:\'list_sort\'\"><div \nng-if=\"field.type == \'onoff\'\" ng-include=\"\'app/main/fields/list/onoff.html\'\"></div><div \nng-if=\"field.type == \'language\'\" ng-include=\"\'app/main/fields/list/language.html\'\" layout=\"row\" \nlayout-align=\"center center\"></div><div ng-if=\"field.type == \'thumbnail\'\" \nng-include=\"\'app/main/fields/list/thumbnail.html\'\"></div><div ng-if=\"field.type == \'thumbnail_square\'\" \nng-include=\"\'app/main/fields/list/thumbnail_square.html\'\"></div><md-icon md-font-icon=\"icon-alert-circle\" \nclass=\"is-important red-600-fg\" ng-if=\"field.type == \'important\' && task.important\"></md-icon><md-icon \nmd-font-icon=\"icon-attachment\" class=\"has-attachment s24\" \nng-if=\"field.type == \'attachments\' && thread.Thumbnail.length> 0\"></md-icon></div></div><div layout=\"column\" \nlayout-align=\"space-between end\"><md-button type=\"button\" ng-click=\"vm.openLiveStream(thread)\" \nclass=\"md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme\" \ntranslate=\"MATCH_CENTER.LIVE_STREAM\"></md-button></div></div></div><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"end center\"><div layout=\"row\" layout-align=\"center center\" \nng-style=\"{\'display\' : isLoading ? \'none\' : \'block\'}\"><span class=\"page-info\">\n{{pagination_totalItems}} {{vm.translate(\'CONTENT.ITEMS_FOUND\')}}</span><md-button aria-label=\"Previous\" \nclass=\"md-icon-button arrow\" ng-click=\"pagination_prevPage()\" ng-disabled=\"pagination_firstPage()\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button><span \nclass=\"page-info\">{{pagination_page}} / {{pagination_total_pages}}</span><md-button aria-label=\"Next\" \nclass=\"md-icon-button arrow\" ng-click=\"pagination_nextPage()\" ng-disabled=\"pagination_morePages()\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div>\n</div>");
$templateCache.put("app/main/apps/match-center/views/list/list-view.html","<div class=\"mail-content\" layout=\"column\" layout-align=\"center center\" \nng-if=\"!vm.currentCompetitionSeason && !isLoadingReadPane\"><div class=\"content\" layout=\"column\" \nlayout-align=\"top center\"><div class=\"message\" translate=\"MATCH_CENTER.NO_COMPETITION_SELECTED\"></div></div></div><div \nflex layout=\"column\" layout-align=\"center center\" ng-if=\"isLoadingReadPane\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nng-if=\"vm.currentCompetitionSeason\" class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/match-center/views/list/toolbar.html\'\"></div><div class=\"mail-content mt-65 tabs-list\" \nlayout=\"column\" layout-align=\"start start\" ng-if=\"vm.currentCompetitionSeason\"><div style=\"min-height: 65px\" \nlayout=\"row\" class=\"tabs\"><div class=\"tab\" ng-class=\"{\'active\' : vm.activeTab == \'matches\'}\" \nng-click=\"vm.activeTab= \'matches\'\">{{ vm.getTranslateBySport(\'MATCHES\') | translate}}</div><div class=\"tab\" \nng-class=\"{\'active\' : vm.activeTab == \'standings\'}\" \nng-if=\"vm.currentCompetitionSeason.result_type == 2 || vm.currentCompetitionSeason.result_type == 3\" \nng-click=\"vm.activeTab= \'standings\'\">{{vm.translate(\'MATCH_CENTER.STANDINGS\')}}</div><div class=\"tab\" \nng-class=\"{\'active\' : vm.activeTab == \'teams\'}\" ng-click=\"vm.activeTab= \'teams\'\">{{vm.translate(\'MATCH_CENTER.TEAMS\')}}\n</div><div class=\"tab\" ng-class=\"{\'active\' : vm.activeTab == \'venues\'}\" ng-click=\"vm.activeTab= \'venues\'\">\n{{vm.translate(\'MATCH_CENTER.VENUES\')}}</div><div class=\"tab\" ng-class=\"{\'active\' : vm.activeTab == \'settings\'}\" \nng-click=\"vm.activeTab= \'settings\'\">{{vm.translate(\'MATCH_CENTER.SETTINGS\')}}</div></div><div \nng-if=\"vm.activeTab == \'matches\'\" class=\"tab-content\"><div \nng-include=\"\'app/main/apps/match-center/views/list/tabs/tab-matches.html\'\"></div></div><div \nng-if=\"vm.activeTab == \'standings\'\" class=\"tab-content\"><div \nng-include=\"\'app/main/apps/match-center/views/list/tabs/tab-standings.html\'\"></div></div><div \nng-if=\"vm.activeTab == \'teams\'\" class=\"tab-content\"><div \nng-include=\"\'app/main/apps/match-center/views/list/tabs/tab-teams.html\'\"></div></div><div \nng-if=\"vm.activeTab == \'venues\'\" class=\"tab-content\"><div \nng-include=\"\'app/main/apps/match-center/views/list/tabs/tab-venues.html\'\"></div></div><div \nng-if=\"vm.activeTab == \'settings\'\" class=\"tab-content\"><div \nng-include=\"\'app/main/apps/match-center/views/list/tabs/tab-settings.html\'\"></div></div></div>");
$templateCache.put("app/main/apps/match-center/views/list/match-view.html","<div ng-if=\"vm.tabs\" class=\"content-wrapper\" flex=\"\" layout=\"row\"><div flex=\"100\" flex-gt-xs=\"50\" \nclass=\"content thread-list mail-list-pane\"><div \nng-repeat=\"tab in vm.tabs | filter: { onoff: 1} | orderBy: \'sort\' track by $index\" ng-if=\"$index == 0\" fill-height \nclass=\"content p0\" style=\"max-height: 100%\" ms-scroll=\"vm.msScrollOptions\" layout=\"row\" \nng-include=\"\'app/main/apps/match-center/views/list/tabs-match/tab-\'+tab.name+\'.html\'\"></div></div><div flex=\"100\" \nflex-gt-xs=\"50\" layout=\"column\" class=\"tabs-content\"><md-menu hide show-gt-xs><md-button aria-label=\"more\" \nclass=\"md-icon-button settings-tabs\" ng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"vm.configureTabsDialog($event)\" \naria-label=\"Refresh widget\" translate=\"MATCH_CENTER.CONFIGURE_TABS\"></md-button></md-menu-item></md-menu-content>\n</md-menu><md-tabs style=\"min-height: 100%\"><md-tab md-on-select=\"vm.selectTab(tab)\" \nng-repeat=\"tab in vm.tabs | filter: { onoff: 1} | orderBy: \'sort\' track by $index\" ng-if=\"$index> 0\" \nlabel=\"{{vm.translate(tab.title)}}\"><div ng-if=\"tab.displayed\" layout=\"row\" \nng-include=\"\'app/main/apps/match-center/views/list/tabs-match/tab-\'+tab.name+\'.html\'\"></div></md-tab></md-tabs></div>\n</div>");
$templateCache.put("app/main/apps/match-center/views/list/no-split-view-live.html","No split view html");
$templateCache.put("app/main/apps/match-center/views/list/no-split-view.html","<div class=\"icon-folder-sidenav\" ng-if=\"!vm.currentCompetitionSeason &&  !vm.currentMatch\"><md-icon \nng-click=\"vm.toggleSidenav(\'tree-sidenav\')\" md-font-icon=\"icon-folder-multiple\" \nclass=\"m-0 grey-600-fg md-icon md-button md-default-theme md-font material-icons md-icon-button\" aria-hidden=\"true\">\n</md-icon></div><div ng-if=\"!vm.currentMatch\" class=\"content-wrapper\" flex=\"\" layout=\"row\"><div \nclass=\"content thread-detail mail-read-pane\" flex id=\"thread-detail\" ms-scroll=\"vm.msScrollOptions\" layout=\"column\" \nng-include=\"\'app/main/apps/match-center/views/list/list-view.html\'\"></div></div><div ng-if=\"vm.currentMatch\" \nclass=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/match-center/views/list/toolbar-match.html\'\"></div><div ng-if=\"vm.currentMatch\" \nclass=\"content-wrapper\" flex=\"\" layout=\"row\"><div class=\"content thread-detail mail-read-pane\" flex id=\"thread-detail\" \nms-scroll=\"vm.msScrollOptions\" layout=\"column\" ng-include=\"\'app/main/apps/match-center/views/list/match-view.html\'\">\n</div></div>");
$templateCache.put("app/main/apps/match-center/views/list/split-view-live.html","<div ng-if=\"!vm.matchLive\" class=\"content-wrapper\" flex=\"\" layout=\"row\"><div \nclass=\"content thread-list mail-list-pane\" flex=\"50\" id=\"thread-list\" \nng-include=\"\'app/main/apps/match-center/views/list/list-view-live.html\'\"></div><div \nclass=\"content thread-detail mail-read-pane\" flex=\"50\" id=\"thread-detail\" layout=\"column\" \nng-include=\"\'app/main/apps/match-center/views/read/read-view-live.html\'\"></div></div><div ng-if=\"vm.matchLive\" \nclass=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/match-center/views/list/toolbar-match.html\'\"></div><div ng-if=\"vm.matchLive\" \nclass=\"content-wrapper\" flex=\"\" layout=\"row\"><div class=\"content thread-detail mail-read-pane\" flex id=\"thread-detail\" \nms-scroll=\"vm.msScrollOptions\" layout=\"column\" ng-include=\"\'app/main/apps/match-center/views/list/match-view.html\'\">\n</div></div>");
$templateCache.put("app/main/apps/match-center/views/list/split-view.html","<div class=\"icon-folder-sidenav\" ng-if=\"!vm.currentCompetitionSeason &&  !vm.currentMatch && !vm.isOpenSidenav()\">\n<md-icon ng-click=\"vm.toggleSidenav(\'tree-sidenav\')\" md-font-icon=\"icon-folder-multiple\" \nclass=\"m-0 grey-600-fg md-icon md-button md-default-theme md-font material-icons md-icon-button\" aria-hidden=\"true\">\n</md-icon></div><div ng-if=\"!vm.currentMatch\" class=\"content-wrapper\" flex=\"\" layout=\"row\"><div \nclass=\"content thread-detail mail-read-pane\" flex id=\"thread-detail\" ms-scroll=\"vm.msScrollOptions\" layout=\"column\" \nng-include=\"\'app/main/apps/match-center/views/list/list-view.html\'\"></div></div><div ng-if=\"vm.currentMatch\" \nclass=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/match-center/views/list/toolbar-match.html\'\"></div><div ng-if=\"vm.currentMatch\" \nclass=\"content-wrapper\" flex=\"\" layout=\"row\"><div class=\"content thread-detail mail-read-pane\" flex id=\"thread-detail\" \nms-scroll=\"vm.msScrollOptions\" layout=\"column\" ng-include=\"\'app/main/apps/match-center/views/list/match-view.html\'\">\n</div></div>");
$templateCache.put("app/main/apps/match-center/views/list/toolbar-match.html","<div flex layout=\"row\" layout-align=\"start center\"><h3 class=\"grey-700-fg ng-binding\"><span hide show-gt-sm>\n{{vm.getTranslateBySport(\'MATCH\') | translate}}</span> <span hide show-gt-sm \nng-if=\"vm.currentMatch.match_name && !vm.isLiveCenter\">: </span><span ng-bind=\"vm.currentMatch.match_name\"></span> #\n<span ng-bind=\"vm.currentMatch.id\"> </span></h3><div flex layout=\"row\" layout-align=\"end center\"><md-button \naria-label=\"CLOSE\" class=\"ml-0 md-fab md-mini md-warn md-raised md-ink-ripple md-default-theme\" hide-gt-sm \nng-click=\"vm.closeMatch()\" type=\"button\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button><md-button \naria-label=\"SAVE\" class=\"ml-0 md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme\" hide-gt-sm \nng-click=\"vm.saveMatch()\" type=\"button\" ng-disabled=\"vm.basicForm.$invalid || vm.basicForm.$pristine\"><md-icon \nmd-font-icon=\"icon-check\"></md-icon></md-button><md-button hide show-gt-sm type=\"button\" ng-click=\"vm.closeMatch()\" \nclass=\"md-raised md-warn\" aria-label=\"Cancel\" translate=\"MATCH_CENTER.CLOSE\"></md-button><md-button hide show-gt-sm \ntype=\"submit\" ng-click=\"vm.saveMatch()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.basicForm.$invalid || vm.basicForm.$pristine\" aria-label=\"SAVE\" translate=\"MATCH_CENTER.SAVE\" \ntranslate-attr-aria-label=\"MATCH_CENTER.SAVE\">SAVE</md-button><md-button hide show-gt-sm type=\"submit\" \nng-click=\"vm.saveMatch(true)\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.basicForm.$invalid || vm.basicForm.$pristine\" aria-label=\"SAVE_AND_CLOSE\" \ntranslate=\"MATCH_CENTER.SAVE_AND_CLOSE\" translate-attr-aria-label=\"MATCH_CENTER.SAVE_AND_CLOSE\">SAVE_AND_CLOSE\n</md-button></div></div>");
$templateCache.put("app/main/apps/match-center/views/list/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><md-button aria-label=\"ADD NEW\" \nclass=\"md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme\" ng-click=\"vm.newMatch()\" \ntype=\"button\">{{ vm.getTranslateBySport(\'ADD_NEW\') | translate}}</md-button><md-button aria-label=\"ADD NEW\" \nclass=\"md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme\" \nng-click=\"vm.saveCompetitionSeason()\" type=\"button\">{{ \'MATCH_CENTER.INIT_STANDINGS\' | translate}}</md-button><div \nng-if=\"vm.currentView == \'split\'\" class=\"divider-vertical\" hide=\"\" show-gt-xs=\"\"></div><div \nng-if=\"vm.currentView == \'split\'\" layout=\"row\" layout-align=\"start center\" class=\"groups-trigger\"><button \naria-label=\"view group\" class=\"md-button md-icon-button\" ng-click=\"vm.toggleSidenav(\'tree-sidenav\')\" translate \ntranslate-attr-aria-label=\"CONTENT.FILTERS\"><md-icon md-font-icon=\"icon-folder-multiple\"></md-icon><md-tooltip hide \nshow-gt-xs><span translate=\"CONTENT.VIEW_GROUPS\">View Groups</span></md-tooltip></button></div><div \nclass=\"divider-vertical\" hide=\"\" show-gt-xs=\"\"></div></div><div flex layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeCompetitionSeason()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div>");
$templateCache.put("app/main/apps/match-center/views/read/read-view-live.html","<div flex layout=\"column\" layout-align=\"center center\" ng-show=\"vm.loadingReadPane\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nng-show=\"!vm.loadingReadPane\"><div class=\"mail-content\" layout=\"column\" layout-align=\"center center\" \nng-if=\"!vm.selectedContent\"><div class=\"content\" layout=\"column\" layout-align=\"top center\"><div class=\"message\" \ntranslate=\"CONTENT.NO_ITEM_SELECTED_PANEL\"></div></div></div><div class=\"toolbar grey-100-bg colored-bg\" layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"vm.selectedContent\" scroll=\"\"><div layout=\"row\" flex \nlayout-align=\"end center\"><md-button type=\"button\" ng-click=\"vm.openLiveStream(vm.selectedContent)\" \nclass=\"md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme\" \ntranslate=\"MATCH_CENTER.OPEN_LIVE_STREAM\"></md-button><md-button type=\"button\" ng-click=\"vm.closeThread()\" \nclass=\"md-raised md-warn\" aria-label=\"Cancel\" translate=\"CONTENT.CANCEL\"></md-button></div></div><md-content flex=\"\" \nng-if=\"vm.selectedContent && !vm.editInline\"><div class=\"mail-content file-details scrollable\" \nms-scroll=\"vm.msScrollOptions\"><md-list><md-list-item class=\"info\" layout=\"row\" layout-align=\"start center\"><div \nlayout=\"row\" layout-align=\"start start\"><div \nng-repeat=\"field in vm.selectedContent_refgrouped.header | orderBy:\'preview_sort\' \" class=\"header-element\" \nlayout=\"row\" layout-align=\"center center\"><div><span ng-if=\"field.type==\'id\'\"><span class=\"grey-500-fg\">ID # </span>\n<span ng-bind=\"vm.selectedContent[field.titleId]\"></span> </span><span ng-if=\"field.type==\'onoff\'\"><button \nclass=\"md-icon-button\" ng-if=\"vm.selectedContent[field.titleId] === 1\"><md-icon class=\"on green-fg s24\" \nmd-font-icon=\"icon-checkbox-marked-circle\"></md-icon></button> <button class=\"md-icon-button\" \nng-if=\"vm.selectedContent[field.titleId] !== 1\"><md-icon class=\"off red-fg s24\" \nmd-font-icon=\"icon-checkbox-blank-circle-outline\"></md-icon></button> </span><span \nng-if=\"field.type==\'dateHm\' || field.type==\'date\'\"><span>{{vm.selectedContent[field.titleId].dateShow}}</span> </span>\n<span ng-if=\"field.type==\'language\'\" layout=\"row\" layout-align=\"center center\"><img class=\"img-flag ng-scope\" \nalt=\"{{vm.siteLanguages(vm.selectedContent[field.titleId])[lang_name]}}\" \nng-src=\"assets/images/flags/{{vm.siteLanguages()[vm.selectedContent[field.titleId]].flag_code|lowercase}}.svg\"> </span>\n<span ng-if=\"field.type==\'id_subsec\' && vm.selectedContent[field.titleId].length!=0\"><span class=\"grey-500-fg\">\n{{field.field_name}} </span><span \nng-bind=\"vm.getReferencesSections(\'subsection\', field.type, vm.selectedContent[field.titleId])\"></span> </span><span \nng-if=\"field.type==\'id_cat\' && vm.selectedContent[field.titleId].length!=0\"><span class=\"grey-500-fg\">\n{{field.field_name}} </span><span \nng-bind=\"vm.getReferencesSections(\'cat\', field.type, vm.selectedContent[field.titleId])\"></span> </span><span \nng-if=\"field.type==\'id_subcat\' && vm.selectedContent[field.titleId].length!=0\"><span class=\"grey-500-fg\">\n{{field.field_name}} </span><span \nng-bind=\"vm.getReferencesSections(\'subcat\', field.type, vm.selectedContent[field.titleId])\"></span> </span><span \nng-if=\"field.type == \'nume\' || field.type == \'single\'\"><span class=\"grey-500-fg\">\n{{field.field_name}}: {{vm.selectedContent[field.titleId]}}</span></span></div></div></div></md-list-item><md-list-item\n ng-repeat=\"field in vm.selectedContent_refgrouped.main | orderBy:\'preview_sort\' \"><div><h1 class=\"name\"><strong \nng-bind=\"vm.selectedContent[field.titleId]\" ng-if=\"field.type != \'section\'\"></strong> <strong \nng-bind=\"vm.showAssoc(vm.selectedContent[field.titleId], field)\" ng-if=\"field.type == \'section\'\"></strong></h1>\n<md-divider></md-divider></div></md-list-item><div \nng-repeat=\"field in vm.selectedContent_refgrouped.secondary | orderBy:\'preview_sort\' \"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg\" ng-if=\"field.type==\'label\'\"><h3 class=\"grey-700-fg\" ng-bind=\"field.field_name\">\n</h3><md-divider></md-divider></md-list-item><md-list-item flex=\"100\" ng-if=\"field.type!==\'label\'\" ng-switch=\"\" \non=\"field.type\"><div class=\"text-truncate flex-100\" ng-switch-when=\"html\"><div class=\"field\"><p \nclass=\"grey-500-fg font-size-14\" ng-bind=\"field.field_name\"></p><span class=\"font-size-16 text-truncate\" \nng-bind-html=\"vm.processHtml(vm.selectedContent[field.titleId])\"></span><br></div><md-divider></md-divider></div><div \nclass=\"text-truncate\" ng-switch-when=\"status\"><div class=\"field\"><p class=\"grey-500-fg font-size-14\" \nng-bind=\"field.field_name\"></p><span class=\"font-size-16 text-truncate {{vm.selectedContent[field.titleId]|yesNo}}\" \nng-bind-html=\"vm.selectedContent[field.titleId]|yesNo\"></span><br></div><md-divider></md-divider></div><div \nclass=\"text-truncate\" flex=\"100\" ng-switch-default=\"\"><div class=\"field\"><p class=\"grey-500-fg font-size-14\" \nng-bind=\"field.field_name\"></p><span \nng-if=\"field.category!=\'input_related\' && vm.isNumber(vm.selectedContent[field.titleId])\" \nclass=\"font-size-16 text-truncate\" ng-bind-html=\"vm.selectedContent[field.titleId]\"></span> <span \nng-if=\"field.category!=\'input_related\' && !vm.isNumber(vm.selectedContent[field.titleId])\" \nclass=\"font-size-16 text-truncate\" ng-bind-html=\"vm.selectedContent[field.titleId]| autoLinkerFilter\"></span> <span \nng-if=\"field.category==\'input_related\'\" class=\"font-size-16 text-truncate\">\n{{vm.getInArray(\'id_\'+field.config,field.values, vm.selectedContent[field.titleId], field.config)}}</span><br></div>\n<md-divider></md-divider></div><div class=\"text-truncate\" ng-switch-when=\"section\"><div class=\"field\"><p \nclass=\"grey-500-fg font-size-14\" ng-bind=\"field.field_name\"></p><span class=\"font-size-16 text-truncate\" \nng-bind=\"vm.showAssoc(vm.selectedContent[field.titleId], field)\"></span><br></div><md-divider></md-divider></div><div \nclass=\"text-truncate\" ng-switch-when=\"country\"><div class=\"field\"><p class=\"grey-500-fg font-size-14\" \nng-bind=\"field.field_name\"></p><span class=\"font-size-16 text-truncate\" \nng-bind=\"vm.showCountry(vm.selectedContent[field.titleId], field)\"></span><br></div><md-divider></md-divider></div><div\n class=\"text-truncate\" ng-switch-when=\"id_subsec\"><div class=\"field\"><p class=\"grey-500-fg font-size-14\" \nng-bind=\"field.field_name\"></p><span class=\"font-size-16 text-truncate\" \nng-bind=\"vm.getReferencesSections(\'subsection\', field.type, vm.selectedContent[field.titleId])\"></span><br></div>\n<md-divider></md-divider></div><div class=\"text-truncate\" ng-switch-when=\"id_cat\"><div class=\"field\"><p \nclass=\"grey-500-fg font-size-14\" ng-bind=\"field.field_name\"></p><span class=\"font-size-16 text-truncate\" \nng-bind=\"vm.getReferencesSections(\'cat\', field.type, vm.selectedContent[field.titleId])\"></span><br></div><md-divider>\n</md-divider></div><div class=\"text-truncate\" ng-switch-when=\"id_subcat\"><div class=\"field\"><p \nclass=\"grey-500-fg font-size-14\" ng-bind=\"field.field_name\"></p><span class=\"font-size-16 text-truncate\" \nng-bind=\"vm.getReferencesSections(\'subcat\', field.type, vm.selectedContent[field.titleId])\"></span><br></div>\n<md-divider></md-divider></div></md-list-item></div><div ng-if=\"vm.selectedContent.tags\"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg\"><h3 class=\"grey-700-fg\"><span translate=\"CONTENT.TAGS\">\n({{vm.selectedContent.tags.length}})</span></h3><md-divider></md-divider></md-list-item><md-list-item><md-chips \nname=\"tag_name\" ng-model=\"vm.selectedContent.tags\" readonly=\"true\" md-removable=\"false\"><md-chip-template><span>\n{{$chip.tag_name}} #{{$chip.id_tag}}</span></md-chip-template></md-chips><md-divider></md-divider></md-list-item></div>\n<div ng-if=\"vm.selectedContent.Thumbnail\"><md-list-item class=\"md-toolbar-tools grey-100-bg\"><h3 class=\"grey-700-fg\" \ntranslate=\"CONTENT.ATTACHMENTS\"><span translate=\"ATTACHMENTS\"></span> ({{vm.selectedContent.Thumbnail.length}})</h3>\n<md-divider></md-divider></md-list-item><md-list-item ng-repeat=\"mediazone in vm.mediaZones\" ng-if=\"vm.mediaZones\"><div\n class=\"attachments\"><div class=\"field\"><p class=\"grey-500-fg font-size-14\">{{ mediazone.title }}</p><div \nclass=\"attachment-list md-list-item-text\" layout=\"row\" layout-wrap=\"\" layout-align=\"start start\"><div \nclass=\"attachment\" ng-repeat=\"attachment in vm.selectedContent.Thumbnail | filter: { id_zone: mediazone.id_zone }\"><div\n class=\"preview document\" layout=\"row\" layout-align=\"start center\" extension-class=\"{{attachment.filename}}\" \nng-href=\"{{attachment.permalink}}\" ng-if=\"attachment.media_type==3\" target=\"_blank\" ng-hide=\"attachment.gallery_type\">\n<qiu-icon mediafile=\"attachment.filename\" class=\"mr-10\"></qiu-icon><a class=\"grey-1000-fg font-size-16\" \nng-href=\"{{attachment.permalink}}\" target=\"_blank\"><span ng-if=\"attachment.title\">{{attachment.title}} </span><span \nng-if=\"attachment.filename\">{{attachment.filename}}</span></a></div><div ng-hide=\"attachment.id_gallery\"><div \nclass=\"ms-card\" flex md-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"ms-card-content-wrapper\"><div \nclass=\"template-9\"><div class=\"media media-attachment\" flex layout=\"row\" layout-align=\"center center\" \nng-if=\"attachment.media_type==1 || attachment.media_type==2\"><div flex \nng-click=\"vm.openImageDialog($event, vm.selectedContent.Thumbnail, attachment)\"><img class=\"image\" \nng-repeat=\"crop in attachment.cropstatus | limitTo: 1\" ng-src=\"{{crop.container.view_url}}{{crop.fileName}}\" \nng-if=\"attachment.media_type==1\"> <img class=\"image\" ng-src=\"{{attachment.embed_thumb}}\" \nng-if=\"attachment.media_type==2\"><div ng-if=\"attachment.media_type==2\" class=\"fotorama__video-play\" style=\"opacity:1\">\n</div></div></div><div flex layout=\"column\" layout-align=\"center center\" class=\"media\" \nng-if=\"attachment.media_type==4\" ng-click=\"vm.openUrl(attachment.permalink)\" target=\"_blank\"><qiu-icon \nmediafile=\"attachment.filename\" classextra=\"s56\"></qiu-icon><br><span class=\"grey-500-fg\" layout=\"column\" \nlayout-align=\"center center\"><span ng-if=\"attachment.title\"><strong>{{attachment.title}}</strong></span> <span \nng-if=\"attachment.filename\">{{attachment.filename}}</span></span></div><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"size block mr-5\" layout=\"row\" layout-align=\"start center\"><strong \nclass=\"mb-5 block\">#{{attachment.id_media}}</strong> <span class=\"grey-500-fg\" \nng-if=\"attachment.media_type==1 || attachment.media_type==2\"><span ng-if=\"attachment.filename\" class=\"word-break-all\">\n{{attachment.filename}}</span> <span ng-if=\"attachment.title && attachment.filename\">| </span><span \nng-if=\"attachment.title\" class=\"word-break-all\">{{attachment.title}}</span></span></div><md-icon \nmd-font-icon=\"icon-eye\" class=\"s16 ml-10\" href=\"#\" \nng-click=\"vm.openImageDialog($event, vm.selectedContent.Thumbnail, attachment)\" \nng-if=\"attachment.media_type==1 || attachment.media_type==2\"></md-icon><md-icon md-font-icon=\"icon-open-in-new\" \nclass=\"s16 ml-10\" href=\"#\" click=\"vm.openUrl(attachment.permalink)\" target=\"_blank\" ng-if=\"attachment.media_type==4\">\n</md-icon></div></div></div></div></div><div ng-if=\"attachment.id_gallery\"><div class=\"ms-card\" flex \nmd-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"ms-card-content-wrapper\"><div class=\"template-9\"><div flex \nlayout=\"column\" layout-align=\"center center\" class=\"media\"><md-icon class=\"s56 mr-5 ml-10\" \nmd-font-icon=\"icon-folder-multiple-image\"></md-icon><br><span class=\"grey-500-fg\" layout=\"column\" \nlayout-align=\"center center\"><span ng-if=\"attachment.gallery_name\"><strong>{{attachment.gallery_name}}</strong></span>\n</span></div><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div class=\"size block mr-5\" \nlayout=\"row\" layout-align=\"start center\"><strong class=\"mb-5 block\">#{{attachment.id_gallery}}</strong> <span \nclass=\"grey-500-fg word-break-all\">{{attachment.gallery_name}}</span></div></div></div></div></div></div></div></div>\n</div></div><md-divider></md-divider></md-list-item><md-list-item \nng-repeat=\"(key, value) in vm.selectedContent.Thumbnail | groupBy: \'id_zone\'\" ng-if=\"!vm.mediaZones\"><div \nclass=\"attachments\"><div class=\"field\"><p class=\"grey-500-fg font-size-14\" translate=\"CONTENT.NO_ZONE\">No Zone</p><div \nclass=\"attachment-list md-list-item-text\" layout=\"row\" layout-wrap=\"\" layout-align=\"start start\"><div \nclass=\"attachment\" ng-repeat=\"attachment in value\"><div class=\"preview document\" layout=\"row\" \nlayout-align=\"start center\" extension-class=\"{{attachment.filename}}\" ng-href=\"{{attachment.permalink}}\" \nng-if=\"attachment.media_type==3\" target=\"_blank\" ng-hide=\"attachment.id_gallery\"><qiu-icon \nmediafile=\"attachment.filename\" class=\"mr-10\"></qiu-icon><a class=\"grey-1000-fg font-size-16\" \nng-href=\"{{attachment.permalink}}\" target=\"_blank\"><span ng-if=\"attachment.title\">{{attachment.title}} </span><span \nng-if=\"attachment.filename\">{{attachment.filename}}</span></a></div><div ng-hide=\"attachment.id_gallery\"><div \nclass=\"ms-card\" flex md-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"ms-card-content-wrapper\"><div \nclass=\"template-9\"><div class=\"media media-attachment\" flex layout=\"row\" layout-align=\"center center\" \nng-if=\"attachment.media_type==1 || attachment.media_type==2\"><div flex \nng-click=\"vm.openImageDialog($event, vm.selectedContent.Thumbnail, attachment)\"><img class=\"image\" \nng-repeat=\"crop in attachment.cropstatus | limitTo: 1\" ng-src=\"{{crop.container.view_url}}{{crop.fileName}}\" \nng-if=\"attachment.media_type==1\"> <img class=\"image\" ng-src=\"{{attachment.embed_thumb}}\" \nng-if=\"attachment.media_type==2\"><div ng-if=\"attachment.media_type==2\" class=\"fotorama__video-play\" style=\"opacity:1\">\n</div></div></div><div flex layout=\"column\" layout-align=\"center center\" class=\"media\" \nng-if=\"attachment.media_type==4\"><qiu-icon mediafile=\"attachment.filename\" classextra=\"s56\"></qiu-icon><br><span \nclass=\"grey-500-fg\" layout=\"column\" layout-align=\"center center\"><span ng-if=\"attachment.title\"><strong>\n{{attachment.title}}</strong></span> <span ng-if=\"attachment.filename\">{{attachment.filename}}</span></span></div><div \nclass=\"header\" layout=\"row\" layout-align=\"space-between center\"><div class=\"size block mr-5\" layout=\"row\" \nlayout-align=\"start center\"><strong class=\"mb-5 block\">#{{attachment.id_media}}</strong> <span class=\"grey-500-fg\" \nng-if=\"attachment.media_type==1 || attachment.media_type==2\"><span ng-if=\"attachment.filename\" class=\"word-break-all\">\n{{attachment.filename}}</span> <span ng-if=\"attachment.title && attachment.filename\">| </span><span \nng-if=\"attachment.title\" class=\"word-break-all\">{{attachment.title}}</span></span></div><md-icon \nmd-font-icon=\"icon-eye\" class=\"s16 ml-10\" href=\"#\" \nng-click=\"vm.openImageDialog($event, vm.selectedContent.Thumbnail, attachment)\"></md-icon></div></div></div></div>\n</div><div ng-if=\"attachment.id_gallery\"><div class=\"ms-card\" flex md-dynamic-height=\"{{vm.dynamicHeight}}\"><div \nclass=\"ms-card-content-wrapper\"><div class=\"template-9\"><div flex layout=\"column\" layout-align=\"center center\" \nclass=\"media\"><md-icon class=\"s56 mr-5 ml-10\" md-font-icon=\"icon-folder-multiple-image\"></md-icon><br><span \nclass=\"grey-500-fg\" layout=\"column\" layout-align=\"center center\"><span ng-if=\"attachment.gallery_name\"><strong>\n{{attachment.gallery_name}}</strong></span></span></div><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"size block\" layout=\"row\" layout-align=\"start center\"><strong \nclass=\"mb-5 block\">#{{attachment.id_gallery}}</strong> <span class=\"grey-500-fg word-break-all\">\n{{attachment.gallery_name}}</span></div></div></div></div></div></div></div></div></div></div><md-divider></md-divider>\n</md-list-item></div><md-list-item class=\"md-toolbar-tools grey-100-bg\"><h3 class=\"grey-700-fg\" \ntranslate=\"CONTENT.LATESTACTIVITY\"></h3><md-divider></md-divider></md-list-item><div class=\"activities\"><div \nclass=\"activity\" layout=\"row\" layout-align=\"start center\" \nng-repeat=\"activity in vm.log | limitTo: vm.paginationLimit()\"><div class=\"avatar\" \nng-bind=\"activity.user.email | capitalizeFirstLetter\" ms-random-class=\"vm.colors\">P</div><div layout=\"column\"><div>\n<span class=\"username md-accent-color\" ng-if=\"activity.user.email.length>0 && !activity.user.first_name\">\n{{activity.user.email}} </span><span class=\"username md-accent-color\" ng-if=\"activity.user.first_name.length>0\">\n{{activity.user.first_name}} {{activity.user.lastname}} </span><span class=\"message\" ng-if=\"activity.message\">\n{{activity.message}}</span></div><span class=\"time secondary-text\">{{activity.date}}</span></div></div><button \nclass=\"md-raised md-button md-default-theme md-ink-ripple\" ng-click=\"vm.showMoreItems()\" \nng-show=\"vm.hasMoreItemsToShow()\"><span translate=\"CONTENT.SHOW_MORE\"></span></button></div><div hide \nclass=\"activities activities-list activity-main\"><table hide show-gt-md><tr \nng-repeat=\"activity in vm.log | limitTo: vm.paginationLimit()\"><td><div layout=\"row\" layout-align=\"start center\"><div \nng-if=\"(activity.user.avatar == \'\' || !activity.user.avatar)\" class=\"avatar\" \nng-bind=\"activity.user.first_name | capitalizeFirstLetter\" style=\"background-color:{{activity.user.profile_color}}\">\n</div><div class=\"avatar-wrapper\" ng-if=\"activity.user.avatar\" attachment=\"activity.user.avatar\"><img class=\"avatar\" \nng-src=\"{{activity.user.avatar}}\" imageonload></div><h3 class=\"mt-0 mb-0 mr-10\"><strong \nng-bind-html=\"activity.user.first_name + \' \' + activity.user.last_name\"></strong></h3></div></td><td><div \nclass=\"field\" layout=\"row\" layout-align=\"start center\"><span class=\"grey-500-fg\" \nng-bind-html=\"vm.timeAgo(activity.date)\"></span></div></td><td><div class=\"field\" layout=\"row\" \nlayout-align=\"end center\"><span class=\"status {{activity.action.action_name}}\" \nng-bind-html=\"activity.action.action_name\"></span></div></td></tr></table></div></md-list></div></md-content></div>");
$templateCache.put("app/main/apps/media/dialogs/add-media-galleries/add-media-galleries.html","<md-dialog class=\"medium attachment-dialog\" aria-label=\"New Message\"><form class=\"md-inline-form\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\"><a \nclass=\"md-button\" type=\"upload\" layout=\"row\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-folder-upload\" \nclass=\"s18 mr-5 ml-0\"></md-icon><span>Add to gallery</span></a></div><div layout=\"row\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate \ntranslate-aria-label=\"CONTENT.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></div>\n</md-toolbar><md-dialog-content ms-scroll flex class=\"content-card\" ng-class=\"vm.currentView\" \nng-include=\"vm.views[vm.currentView]\"></md-dialog-content><md-dialog-actions layout=\"row\" flex \nlayout-align=\"space-between center\"><div layout=\"row\" flex layout-align=\"end center\"><md-button \nng-click=\"vm.saveMediaGalleries()\" class=\"send-button md-accent md-raised\" aria-label=\"Send\" \nng-disabled=\"vm.isLoading\" translate=\"CONTENT.ADD_FILE\" translate-attr-aria-label=\"CONTENT.ADD_FILE\">ADD</md-button>\n</div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/media/dialogs/edit-multiple-fields/edit-multiple-fields.html","<md-dialog class=\"large attachment-dialog\" aria-label=\"New Message\"><form class=\"md-inline-form\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\"><a \nclass=\"md-button\" type=\"import\" layout=\"row\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-tooltip-edit\" \nclass=\"s18 mr-5 ml-0\"></md-icon><span>Edit Multiple fields</span></a></div><div layout=\"row\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate \ntranslate-aria-label=\"CONTENT.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></div>\n</md-toolbar><md-dialog-content ms-scroll flex class=\"content-card\" ng-class=\"vm.currentView\" \nng-include=\"vm.views[vm.currentView]\"></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"!vm.loading\"><div layout=\"row\" layout-align=\"end center\"><md-button \nng-click=\"vm.saveMass()\" class=\"send-button md-accent md-raised\" aria-label=\"Send\" translate=\"CONTENT.SAVE\" \ntranslate-attr-aria-label=\"CONTENT.SAVE\">SAVE</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/media/dialogs/galleries/edit-gallery.html","<md-dialog id=\"edit-gallery-dialog\" class=\"small compose-dialog\" aria-label=\"Edit Gallery\"><form \nclass=\"md-inline-form\" name=\"vm.basicForm\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><a \nclass=\"md-button grey-A100-fg\" type=\"import\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-folder\" class=\"s18 mr-5 ml-0 md-font material-icons\" role=\"img\" aria-label=\"icon-folder\"></md-icon>\n<span class=\"title\" ng-if=\"!(vm.gallery | isEmptyObject) && vm.selectedView === \'edit_gallery_main\'\" \ntranslate=\"GALLERY.EDIT\"></span> <span class=\"title\" \nng-if=\"!(vm.gallery | isEmptyObject) && vm.selectedView === \'duplicate_gallery\'\" translate=\"CONTENT.DUPLICATE\"></span> \n<span class=\"title\" ng-if=\"vm.gallery | isEmptyObject\" translate=\"GALLERY.CREATE\"></span></a></div><div layout=\"row\" \nlayout-align=\"end center\"><md-button ng-if=\"vm.hasLightboxSettingsAccess\" class=\"md-icon-button\" \nng-click=\"vm.selectedView = \'edit_gallery_users_groups_lightbox\'\" \ntranslate-aria-label=\"GALLERY.OPEN_SETTINGS_LIGHTBOX\" ng-disabled=\"vm.basicForm.$invalid\"><md-icon \nmd-font-icon=\"icon-spotlight\" ng-class=\"{\'light-green-fg\': vm.selectedView == \'edit_gallery_users_groups_lightbox\'}\">\n</md-icon><md-tooltip md-autohide=\"true\"><span translate=\"GALLERY.OPEN_SETTINGS_LIGHTBOX\"></span></md-tooltip>\n</md-button><md-button ng-if=\"vm.hasMediacenterSettingsAccess || vm.isAdmin\" class=\"md-icon-button\" \nng-click=\"vm.selectedView = \'edit_gallery_users_groups_mediacenter\'\" \ntranslate-aria-label=\"GALLERY.OPEN_SETTINGS_MEDIACENTER\" ng-disabled=\"vm.basicForm.$invalid\"><md-icon \nmd-font-icon=\"icon-account-multiple\" \nng-class=\"{\'light-green-fg\': vm.selectedView == \'edit_gallery_users_groups_mediacenter\'}\"></md-icon><md-tooltip \nmd-autohide=\"true\"><span translate=\"GALLERY.OPEN_SETTINGS_MEDIACENTER\"></span></md-tooltip></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.selectedView = \'duplicate_gallery\'\" translate-aria-label=\"CONTENT.DUPLICATE\" \ntranslate-attr-aria-label=\"CONTENT.DUPLICATE\" ng-if=\"!vm.gallery.children\"><md-icon \nmd-font-icon=\"icon-content-duplicate\" ng-class=\"{\'light-green-fg\': vm.selectedView == \'duplicate_gallery\'}\"></md-icon>\n<md-tooltip md-autohide=\"true\"><span translate=\"CONTENT.DUPLICATE\"></span></md-tooltip></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.selectedView = \'edit_gallery_main\'\" \ntranslate-aria-label=\"GALLERY.OPEN_SETTINGS_MAIN\" ng-disabled=\"vm.basicForm.$invalid\"><md-icon \nmd-font-icon=\"icon-pencil\" ng-class=\"{\'light-green-fg\': vm.selectedView == \'edit_gallery_main\'}\"></md-icon><md-tooltip \nmd-autohide=\"true\"><span translate=\"GALLERY.OPEN_SETTINGS_MAIN\"></span></md-tooltip></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"Close dialog\" translate-aria-label=\"GALLERY.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"ph-0 json-editor\" ng-include=\"vm.views[vm.selectedView]\"></div></md-dialog-content><md-dialog-actions \nng-switch=\"vm.selectedView\"><div ng-switch-default layout=\"row\" flex layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button ng-click=\"delete($event, vm.gallery)\" class=\"md-icon-button\" \naria-label=\"Delete\" ng-if=\"!(vm.gallery | isEmptyObject)\" translate-attr-aria-label=\"GALLERY.DELETE\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"GALLERY.DELETE\"></span></md-tooltip>\n</md-button><md-button ng-click=\"downloadZip($event, vm.gallery)\" class=\"md-icon-button\" aria-label=\"Zip\" \nng-if=\"!(vm.gallery | isEmptyObject) && !vm.downloading\" translate-attr-aria-label=\"GALLERY.DOWNLOAD_ZIP\" \nng-disabled=\"vm.downloading\"><md-icon md-font-icon=\"icon-cloud-download\"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate=\"GALLERY.DOWNLOAD_ZIP\"></span></md-tooltip></md-button><div ng-if=\"vm.downloading\" style=\"margin-left: 10px\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\"></md-progress-circular></div></div><div layout=\"row\" \nlayout-align=\"end center\"><md-button ng-click=\"vm.cancel()\" class=\"send-button md-warn md-raised\" aria-label=\"Cancel\" \ntranslate=\"GALLERY.CANCEL\" translate-attr-aria-label=\"GALLERY.CANCEL\"></md-button><md-button \nng-click=\"save(vm.gallery)\" class=\"send-button md-accent md-raised\" aria-label=\"Save\" translate=\"GALLERY.SAVE\" \nng-disabled=\"!vm.galleryName || (vm.galleryType!=0 && !vm.galleryType) || vm.basicForm.$invalid\" \ntranslate-attr-aria-label=\"GALLERY.SAVE\"></md-button></div></div><div \nng-switch-when=\"edit_gallery_users_groups_lightbox\" flex layout=\"row\" layout-align=\"end center\"><md-button \nng-click=\"vm.cancel()\" class=\"send-button md-warn md-raised\" aria-label=\"Cancel\" translate=\"GALLERY.CANCEL\" \ntranslate-attr-aria-label=\"GALLERY.CANCEL\"></md-button><md-button ng-click=\"save(vm.gallery)\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Save\" translate=\"GALLERY.SAVE\" \nng-disabled=\"!vm.galleryName || (vm.galleryType!=0 && !vm.galleryType) || vm.basicForm.$invalid\" \ntranslate-attr-aria-label=\"GALLERY.SAVE\"></md-button></div><div ng-switch-when=\"edit_gallery_users_groups_mediacenter\" \nflex layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.cancel()\" class=\"send-button md-warn md-raised\" \naria-label=\"Cancel\" translate=\"GALLERY.CANCEL\" translate-attr-aria-label=\"GALLERY.CANCEL\"></md-button><md-button \nng-click=\"save(vm.gallery)\" class=\"send-button md-accent md-raised\" aria-label=\"Save\" translate=\"GALLERY.SAVE\" \nng-disabled=\"!vm.galleryName || (vm.galleryType!=0 && !vm.galleryType) || vm.basicForm.$invalid\" \ntranslate-attr-aria-label=\"GALLERY.SAVE\"></md-button></div><div ng-switch-when=\"edit_gallery_users_groups_tree\" flex \nlayout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.cancelGroupSelection()\" \nclass=\"send-button md-warn md-raised\" aria-label=\"Cancel\" translate=\"GALLERY.CANCEL\" \ntranslate-attr-aria-label=\"GALLERY.CANCEL\"></md-button><md-button ng-click=\"vm.applyGroupSelection()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Apply\" translate=\"GALLERY.APPLY\" \ntranslate-attr-aria-label=\"GALLERY.APPLY\"></md-button></div></md-dialog-actions></form><div class=\"blocking-overlay\" \nlayout=\"row\" layout-align=\"center center\" ng-if=\"vm.duplicatingGallery\"><div layout=\"row\" layout-align=\"center center\" \nclass=\"loading-container duplicate-gallery\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"40\">\n</md-progress-circular><span class=\"ml-15\" translate=\"GALLERY.DUPLICATING_GALLERY\"></span></div></div></md-dialog>");
$templateCache.put("app/main/apps/media/dialogs/gallery-zip-download/gallery-zip-download.html","<md-dialog id=\"edit-gallery-dialog\" class=\"small compose-dialog\" aria-label=\"Edit Gallery\" \nstyle=\"width:auto; max-width: 90%\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><a class=\"md-button grey-A100-fg\" \ntype=\"import\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-cloud-download\" \nclass=\"s18 mr-5 ml-0 md-font material-icons\" role=\"img\" aria-label=\"icon-cloud-download\"></md-icon><span class=\"title\" \ntranslate=\"GALLERY.DOWNLOAD_ZIP\"></span></a></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"Close dialog\" translate-aria-label=\"GALLERY.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"grey-600-fg\" style=\"font-size: 14px\"><span translate=\"GALLERY.DOWNLOAD_ZIP_URL\"></span><md-icon \nmd-font-icon=\"icon-open-in-new\" class=\"s14\"></md-icon>: <a href=\"{{vm.downloadZipUrl}}\" target=\"_blank\">\n{{vm.downloadZipUrl}}</a></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><div \nlayout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.cancel()\" class=\"send-button md-warn md-raised\" \naria-label=\"Cancel\" translate=\"GALLERY.CANCEL\" translate-attr-aria-label=\"GALLERY.CANCEL\"></md-button></div>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/media/dialogs/media/delete-media-dialog.html","<md-dialog class=\"delete-dialog compose-dialog\" aria-label=\"DELETE\"><md-dialog-content><div ng-if=\"vm.isLoading\" \nclass=\"loading-container\" flex layout=\"column\" layout-align=\"center center\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div ng-if=\"vm.mediaRelations\"><h2 \nng-if=\"vm.selectedThreads.length == 1\" translate=\"CONTENT.SURE_DELETED_SINGULAR\" class=\"mt-0 mb-0 pb-10\"></h2><h2 \nng-if=\"vm.selectedThreads.length > 1\" translate=\"CONTENT.SURE_DELETED_PLURAL\" class=\"mt-0 mb-0 pb-10\"></h2><p \nng-if=\"vm.selectedThreads.length == 1\" translate=\"MEDIA.SOME_USED_IN_SINGULAR\" \nclass=\"grey-700-fg font-size-16 mt-0 mb-0 pb-10\"></p><p ng-if=\"vm.selectedThreads.length > 1\" \ntranslate=\"MEDIA.SOME_USED_IN_PLURAL\" class=\"grey-700-fg font-size-16 mt-0 mb-0 pb-10\"></p><div \nclass=\"md-dialog-content-body ng-scope\"><div ng-repeat=\"media in vm.mediaRelations\" \nclass=\"border-top pt-20 mt-20 mb-0\" layout=\"row\" layout-align=\"start center\" \nng-if=\"media.content.length >0 || media.galleries.length > 0\"><media attachment=\"media\" \nclass-img=\"square w-80 image avatar\"></media><div class=\"font-size-14\"><strong>Media #{{media.id_media}}</strong><span \nng-if=\"media.title\"> - {{media.title}}</span><p class=\"mt-5 grey-600-fg mb-0\"><span \nng-repeat=\"content in media.content\" class=\"flex block\"><strong>{{content.section | capitalize}}:</strong>\n {{content.title}} (#{{content.id}})</span> <span ng-repeat=\"gallery in media.galleries\" class=\"flex block\"><strong>\n{{vm.translate(\'MEDIA.GALLERY\')}}:</strong> {{gallery.gallery_name | capitalize}}</span></p></div></div><div \nng-repeat=\"media in vm.mediaRelations\" class=\"border-top pt-20 mt-20 mb-0 opacity-5\" layout=\"row\" \nlayout-align=\"start center\" ng-if=\"media.content.length == 0 && media.galleries.length == 0\"><media attachment=\"media\" \nclass-img=\"square w-80 image avatar \"></media><div class=\"font-size-14\"><strong>Media #{{media.id_media}}</strong><span\n ng-if=\"media.title\"> - {{media.title}}</span><p class=\"mt-5 grey-500-fg mb-0\"><strong translate=\"MEDIA.NOT_USED\">\n</strong></p></div></div></div></div></md-dialog-content><md-dialog-actions><md-button class=\"send-button md-raised\" \ntranslate=\"MEDIA.CANCEL\" aria-label=\"CANCEL\" ng-click=\"vm.cancel()\"></md-button><md-button \nclass=\"send-button md-warn md-raised\" translate=\"MEDIA.DELETE\" aria-label=\"DELETE\" ng-click=\"vm.delete()\"></md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/media/dialogs/media/media-dialog-tinymce.html","<md-dialog class=\"attachment-dialog add-media\" aria-label=\"New Message\"><form class=\"md-inline-form\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nhide show-gt-xs><a class=\"md-button\" type=\"1\" layout=\"row\" layout-align=\"center center\" \nng-click=\"vm.changeViewTiny(\'1\')\"><md-icon md-font-icon=\"icon-file-image-box\" class=\"s18 mr-5 ml-0\"></md-icon><span>\nAttached Media</span></a></div><div layout=\"row\" hide-gt-xs show-xs><md-menu><md-button aria-label=\"Filters\" \nng-click=\"$mdMenu.open($event)\" translate=\"\" translate-attr-aria-label=\"CONTENT.FILTERS\"><span layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-file-image-box\" class=\"s18 mr-5 ml-0\"></md-icon><span \nclass=\"ml-5\">Images</span> <i class=\"icon-chevron-down s20 ml-5\"></i></span></md-button><md-menu-content width=\"3\">\n<md-menu-item><md-button type=\"photos\" ng-click=\"vm.changeViewTiny(\'1\')\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div><md-icon md-font-icon=\"icon-file-image-box\" class=\"s18\"></md-icon><span>Images\n</span></div><i class=\"icon-check s16\" ng-if=\"sortfield.titleId == sortable.titleId\"></i></div></md-button>\n</md-menu-item></md-menu-content></md-menu></div><div layout=\"row\"><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate translate-aria-label=\"CONTENT.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></div></md-toolbar><div flex \nng-include=\"\'app/main/dialogs/media/views/templates/toolbar-search.html\'\"></div><md-dialog-content \nclass=\"mediadialog-content scrollable\" layout-fill ms-scroll><treasure-overlay-spinner active=\"vm.loading\"><div \nlayout=\"column\" flex><md-content flex class=\"content-card\" ng-class=\"vm.currentViewTiny\" \nng-include=\"vm.viewsTiny[vm.currentViewTiny]\" md-no-ink></md-content></div></treasure-overlay-spinner>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\" ng-if=\"!vm.loading\"><div \nlayout=\"row\" layout-align=\"start center\"></div><div layout=\"row\" layout-align=\"end right\"><md-button \nng-click=\"vm.attachMediaTiny()\" class=\"send-button md-accent md-raised\" aria-label=\"Send\" translate=\"CONTENT.ADD_FILE\" \ntranslate-attr-aria-label=\"CONTENT.ADD_FILE\">ADD</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/media/dialogs/media/media-dialog.html","<md-dialog class=\"attachment-dialog add-media\" aria-label=\"New Message\"><form class=\"md-inline-form\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nhide show-gt-xs><a class=\"md-button\" type=\"upload\" layout=\"row\" layout-align=\"center center\" \nng-click=\"vm.changeView(\'upload\')\"><md-icon md-font-icon=\"icon-import\" class=\"s18 mr-5 ml-0\"></md-icon><span>Upload\n</span> </a><a class=\"md-button\" type=\"import\" layout=\"row\" layout-align=\"center center\" \nng-click=\"vm.changeView(\'import\')\"><md-icon md-font-icon=\"icon-import\" class=\"s18 mr-5 ml-0\"></md-icon><span>\nWeb Address (URL)</span></a></div><div layout=\"row\" hide-gt-xs show-xs><md-menu><md-button aria-label=\"Filters\" \nng-click=\"$mdMenu.open($event)\" translate=\"\" translate-attr-aria-label=\"CONTENT.FILTERS\"><span layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-file-image-box\" class=\"s18 mr-5 ml-0\"></md-icon><span \nclass=\"ml-5\" ng-if=\"vm.currentView===\'upload\'\">Upload</span> <span class=\"ml-5\" ng-if=\"vm.currentView===\'import\'\">\nWeb Address (URL)</span> <i class=\"icon-chevron-down s20 ml-5\"></i></span></md-button><md-menu-content width=\"3\">\n<md-menu-item><md-button type=\"upload\" ng-click=\"vm.changeView(\'upload\')\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div><md-icon md-font-icon=\"icon-import\" class=\"s18\"></md-icon><span>Upload</span>\n</div><i class=\"icon-check s16\" ng-if=\"vm.currentView===\'upload\'\"></i></div></md-button></md-menu-item><md-menu-item>\n<md-button type=\"import\" ng-click=\"vm.changeView(\'import\')\"><div layout=\"row\" layout-align=\"space-between center\"><div>\n<md-icon md-font-icon=\"icon-import\" class=\"s18\"></md-icon><span>Web Address (URL)</span></div><i \nclass=\"icon-check s16\" ng-if=\"vm.currentView===\'import\'\"></i></div></md-button></md-menu-item></md-menu-content>\n</md-menu></div><div layout=\"row\"><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" tranlate translate-aria-label=\"CONTENT.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></div></md-toolbar><div flex layout=\"column\" layout-align=\"center center\" \nng-show=\"vm.isAttaching \" class=\"loading-container\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\">\n</md-progress-circular></div><md-dialog-content ng-if=\"vm.currentView != \'upload\'\" ms-scroll=\"vm.msScrollOptions\" flex \nclass=\"scrollable content-card\" ng-class=\"vm.currentView\" ng-include=\"vm.views[vm.currentView]\" \nng-style=\"{\'opacity\' : vm.isAttaching ? 0.2 : 1}\"></md-dialog-content><md-dialog-content \nng-if=\"vm.currentView == \'upload\'\" flex class=\"content-card\" ng-class=\"vm.currentView\" \nng-include=\"vm.views[vm.currentView]\" ng-style=\"{\'opacity\' : vm.isAttaching ? 0.2 : 1}\"></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\" ng-if=\"!vm.loading\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button ng-if=\"vm.currentView == \'upload\'  && !vm.isReplace\" \nng-click=\"vm.attachMedia()\" class=\"send-button md-raised\" aria-label=\"Send\" translate=\"MEDIA.FORCE_UPLOAD\" \ntranslate-attr-aria-label=\"MEDIA.FORCE_UPLOAD\">FORCE UPLOAD</md-button></div><div layout=\"row\" \nlayout-align=\"end center\"><md-button ng-if=\"vm.currentView == \'upload\'  && !vm.isReplace\" \nng-disabled=\"vm.uploadFiles.length == 0 || vm.uploadedFiles.length != vm.uploadFiles.length || vm.isAttaching\" \nng-click=\"vm.attachMedia()\" class=\"send-button md-accent md-raised\" aria-label=\"Send\" translate=\"MEDIA.DONE\" \ntranslate-attr-aria-label=\"MEDIA.DONE\">DONE</md-button><md-button \nng-if=\"vm.currentView == \'import\'  && !vm.isReplace && !vm.importPreview\" ng-disabled=\"vm.importedFiles.length == 0\" \nng-click=\"vm.attachMedia()\" class=\"send-button md-accent md-raised\" aria-label=\"Send\" translate=\"MEDIA.DONE\" \ntranslate-attr-aria-label=\"MEDIA.DONE\">DONE</md-button><md-button \nng-if=\"vm.currentView == \'import\' && vm.importPreview\" class=\"send-button md-accent md-raised\" \nng-click=\"vm.importConfirm(1)\" aria-label=\"Import\" translate=\"MEDIA.IMPORT\" translate-attr-aria-label=\"MEDIA.IMPORT\">\nImport</md-button><md-button ng-if=\"vm.isReplace\" \nng-disabled=\"vm.uploadFiles.length == 0 || vm.uploadedFiles.length != vm.uploadFiles.length || vm.isAttaching\" \nng-click=\"vm.attachMedia()\" class=\"send-button md-accent md-raised\" aria-label=\"Send\" translate=\"MEDIA.SAVE\" \ntranslate-attr-aria-label=\"MEDIA.SAVE\">SAVE</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/media/dialogs/media/repeated-upload-files.html","<div id=\"repeated-files-dialog\"><div class=\"full-container\" layout=\"column\"><div id=\"warning-container\" layout=\"row\">\n<md-icon md-font-icon=\"icon-alert\"></md-icon><span translate=\"MEDIA.UPLOADING_REPEATED\" class=\"warning\">\nOne or more files already exist in the system. Please check and apply an action individually or to all of them.</span>\n</div><div class=\"files-container\" layout=\"row\"><div class=\"files uploadFile-container\"><span \ntranslate=\"MEDIA.UPLOADING_MEDIA\"></span><div class=\"item-container\"><div class=\"file\"><div class=\"image-container\">\n<img style=\"z-index: 1; position: absolute\" \nng-if=\"!vm.uploadFile.$error && vm.uploadFile && !vm.isImage(vm.uploadFile)\" src=\"assets/images/common/file.jpg\" \nclass=\"image\"> <img style=\"z-index: 2\" ngf-src=\"!vm.uploadFile.$error && vm.uploadFile\" class=\"image\"><video \nstyle=\"z-index: 3\" ng-if=\"vm.isVideo(vm.uploadFile)\" controls ngf-src=\"!vm.uploadFile.$error && vm.uploadFile\" \nclass=\"video\"></video></div><div class=\"info\" layout=\"column\"><span class=\"grey-500-fg word-break-all filename\">\n{{vm.uploadFile.name}}</span></div></div></div></div><div class=\"files repeatedFiles-container\"><span \ntranslate=\"MEDIA.DB_PHOTO\"></span><div class=\"item-container\" layout=\"row\"><div class=\"file\" \nng-repeat=\"file in vm.repeatedFiles | orderBy:\'id_media\'\"><div class=\"image-container\"><img ng-src=\"{{file.preview}}\">\n</div><div class=\"info\" layout=\"row\"><div class=\"string\" layout=\"column\"><strong class=\"mr-5\">#{{file.id_media}}\n</strong> <span class=\"grey-500-fg word-break-all filename\">{{file.sanitized}}</span></div><div class=\"check-repeat\" \nlayout-align=\"start center\" class=\"md-dense\" ng-if=\"vm.repeatedFiles.length > 1\"><input type=\"radio\" \nng-checked=\"vm.checkSelectedRepeated(file)\" ng-click=\"vm.changeSelectedRepeated(file)\"></div></div></div></div><div \nid=\"remember-check-container\" layout=\"row\" layout-align=\"start center\" class=\"md-dense\"><md-checkbox \nng-checked=\"vm.rememberDecission\" ng-click=\"vm.changeRememberDecission()\" id=\"check-remember-decission\" \ntranslate-attr-aria-label=\"MEDIA.REMEMBER_DECISSION\"></md-checkbox><label for=\"check-remember-decission\" \nng-click=\"vm.changeRememberDecission()\" aria-hidden=\"true\" tab-index=\"-1\" translate=\"MEDIA.REMEMBER_DECISSION\">\nRemember my decission</label></div></div></div><div class=\"tools\"><span class=\"explain-buttons\" \ntranslate=\"MEDIA.EXPLAIN_BUTTONS\"></span><md-button ng-click=\"vm.maintainBoth()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Maintain both\" translate=\"MEDIA.KEEP_ALL\" \ntranslate-attr-aria-label=\"MEDIA.KEEP_ALL\"><md-tooltip hide show-gt-xs><span translate=\"MEDIA.KEEP_ALL_DESCRIPTION\">\nThis action will keep all medias as separated files.</span></md-tooltip></md-button><md-button \nng-click=\"vm.replaceImage()\" class=\"send-button md-accent md-raised\" aria-label=\"Replace image\" \ntranslate=\"MEDIA.RELOAD_PHOTO\" translate-attr-aria-label=\"MEDIA.RELOAD_PHOTO\"><md-tooltip hide show-gt-xs><span \ntranslate=\"MEDIA.RELOAD_PHOTO_DESCRIPTION\">\nThis action will replace the old file with the one being uploaded. (In case that there are more than one repeated files, you should check the files that you want to act)\n</span></md-tooltip></md-button><md-button ng-click=\"vm.closeDialog()\" class=\"send-button md-accent md-raised\" \naria-label=\"Close\" translate=\"MEDIA.DELETE_FROM_UPLOAD\" translate-attr-aria-label=\"MEDIA.DELETE_FROM_UPLOAD\">\n<md-tooltip hide show-gt-xs><span translate=\"MEDIA.DELETE_FROM_UPLOAD_DESCRIPTION\">\nThis action will ignore the file that is being uploaded.</span></md-tooltip></md-button></div></div></div>");
$templateCache.put("app/main/apps/media/dialogs/media-tags-dialog/media-tags-dialog.html","<md-dialog class=\"attachment-dialog add-media\" aria-label=\"New Message\"><form class=\"md-inline-form\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\"><a \nclass=\"md-button\" type=\"1\" layout=\"row\" layout-align=\"center center\" ng-click=\"vm.changeView(1)\" ng-if=\"vm.views[1]\">\n<md-icon md-font-icon=\"icon-file-image-box\" class=\"s18 mr-5 ml-0\"></md-icon><span translate=\"MEDIA.IMAGES\"></span> </a>\n<a class=\"md-button\" type=\"2\" layout=\"row\" layout-align=\"center center\" ng-click=\"vm.changeView(2)\" \nng-if=\"vm.views[2]\"><md-icon md-font-icon=\"icon-video\" class=\"s18 mr-5 ml-0\"></md-icon><span translate=\"MEDIA.VIDEOS\">\n</span> </a><a class=\"md-button\" type=\"3\" layout=\"row\" layout-align=\"center center\" ng-click=\"vm.changeView(3)\" \nng-if=\"vm.views[3]\"><md-icon md-font-icon=\"icon-volume\" class=\"s18 mr-5 ml-0\"></md-icon><span translate=\"MEDIA.AUDIO\">\n</span> </a><a class=\"md-button\" type=\"4\" layout=\"row\" layout-align=\"center center\" ng-click=\"vm.changeView(4)\" \nng-if=\"vm.views[4]\"><md-icon md-font-icon=\"icon-file\" class=\"s18 mr-5 ml-0\"></md-icon><span translate=\"MEDIA.FILES\">\n</span></a><div layout=\"row\" ng-if=\"vm.views[5]\"><md-menu><md-button type=\"5\" aria-label=\"Filters\" \nng-click=\"$mdMenu.open($event)\" translate=\"\" translate-attr-aria-label=\"CONTENT.FILTERS\"><span layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-folder-multiple-image\" class=\"s18 mr-5 ml-0\"></md-icon><span \nclass=\"ml-5\">Galleries</span> <i class=\"icon-chevron-down s20 ml-5\"></i></span></md-button><md-menu-content width=\"3\">\n<md-menu-item><md-button type=\"photos\" ng-click=\"vm.changeViewGallery(1)\" aria-label=\"Photos\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div><md-icon md-font-icon=\"icon-file-image-box\" class=\"s18\"></md-icon><span \ntranslate=\"MEDIA.IMAGES\"></span></div><i class=\"icon-check s16\" ng-if=\"vm.currentViewGallery===1\"></i></div>\n</md-button></md-menu-item><md-menu-item><md-button type=\"videos\" ng-click=\"vm.changeViewGallery(2)\" \naria-label=\"Videos\"><div layout=\"row\" layout-align=\"space-between center\"><div><md-icon md-font-icon=\"icon-video\" \nclass=\"ss18\"></md-icon><span translate=\"MEDIA.VIDEOS\"></span></div><i class=\"icon-check s16\" \nng-if=\"vm.currentViewGallery===2\"></i></div></md-button></md-menu-item><md-menu-item><md-button type=\"audios\" \nng-click=\"vm.changeViewGallery(3)\" aria-label=\"Audios\"><div layout=\"row\" layout-align=\"space-between center\"><div>\n<md-icon md-font-icon=\"icon-volume\" class=\"s18\"></md-icon><span translate=\"MEDIA.AUDIO\"></span></div><i \nclass=\"icon-check s16\" ng-if=\"vm.currentViewGallery===3\"></i></div></md-button></md-menu-item><md-menu-item><md-button \ntype=\"files\" ng-click=\"vm.changeViewGallery(4)\" aria-label=\"Files\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div><md-icon md-font-icon=\"icon-file\" class=\"s18\"></md-icon><span \ntranslate=\"MEDIA.FILES\"></span></div><i class=\"icon-check s16\" ng-if=\"vm.currentViewGallery===4\"></i></div></md-button>\n</md-menu-item><md-menu-item><md-button type=\"files\" ng-click=\"vm.changeViewGallery(0)\" aria-label=\"Files\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div><md-icon md-font-icon=\"icon-file\" class=\"s18\"></md-icon><span \ntranslate=\"MEDIA.ALL\"></span></div><i class=\"icon-check s16\" ng-if=\"vm.currentViewGallery===0\"></i></div></md-button>\n</md-menu-item></md-menu-content></md-menu></div><a class=\"md-button\" type=\"upload\" layout=\"row\" \nlayout-align=\"center center\" ng-click=\"vm.changeView(\'upload\')\" ng-if=\"vm.views.upload\"><md-icon \nmd-font-icon=\"icon-import\" class=\"s18 mr-5 ml-0\"></md-icon><span translate=\"MEDIA.UPLOAD\"></span> </a><a \nclass=\"md-button\" type=\"import\" layout=\"row\" layout-align=\"center center\" ng-click=\"vm.changeView(\'import\')\" \nng-if=\"vm.views.import\"><md-icon md-font-icon=\"icon-import\" class=\"s18 mr-5 ml-0\"></md-icon><span \ntranslate=\"MEDIA.IMPORT_URL\"></span></a></div><div layout=\"row\"><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate translate-aria-label=\"CONTENT.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></div></md-toolbar><md-content style=\"background: #dedede\" \nclass=\"full-height\"><div ng-if=\"!vm.selectedMedia\" layout=\"row\" class=\"full-height left-sidenav carded page-layout\">\n<md-sidenav ng-show=\"!vm.firstLoad\" md-is-open=\"false\" class=\"sidenav groups-tree sidenav-media-dialog\" \nmd-component-id=\"media-dialog-galleries-sidenav\" ms-scroll ms-sidenav-helper md-no-ink md-disable-backdrop \nng-include=\"\'app/main/dialogs/media/views/sidenav.html\'\"></md-sidenav><div layout=\"column\" flex class=\"center\" \nmd-no-ink><div ng-include=\"\'app/main/dialogs/media/views/templates/toolbar-search.html\'\" \nng-show=\"!vm.firstLoad && vm.isNumber(vm.currentView) && vm.currentView != 5\"></div><div \nng-include=\"\'app/main/dialogs/media/views/templates/toolbar-search-gallery.html\'\" \nng-show=\"!vm.firstLoad && vm.currentView == 5\"></div><md-dialog-content layout=\"column\" ms-scroll=\"vm.msScrollOptions\" \nflex=\"100\" class=\"mediadialog-content scrollable\"><div flex layout=\"column\" layout-align=\"center center\" \nng-show=\"vm.loading || vm.firstLoad\" class=\"loading-container\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"50\"></md-progress-circular></div><div ng-include=\"vm.views[vm.currentView]\" \nng-hide=\"vm.isNumber(vm.currentView) && vm.items.length == 0\" ng-style=\"{\'opacity\' : vm.loading ? 0.2 : 1}\"></div><div \nng-if=\"vm.isNumber(vm.currentView) && vm.items.length == 0 && !vm.loading && !vm.firstLoad\" layout=\"row\" \nlayout-align=\"center center\" class=\"content-wrapper full-height\" flex=\"100\"><div class=\"message\" \ntranslate=\"MEDIA_DIALOG.NO_ITEMS_AVAILABLE\"></div></div></md-dialog-content></div></div><div flex layout=\"row\" \nng-if=\"vm.selectedMedia\"><div class=\"ms-card\"><div style=\"width: 300px\" class=\"ms-card-content-wrapper\"><div \nclass=\"template-9\"><div style=\"background: #f6f6f6\" class=\"media p-10\" flex layout=\"row\" layout-align=\"center center\">\n<media attachment=\"vm.selectedMedia\" class=\"\"></media></div><div class=\"header p-16\" flex><div layout=\"row\" \nlayout-align=\"space-between start\" flex><div class=\"size block pr-10\" layout=\"row\" layout-align=\"start left\" flex>\n<strong class=\"block mb-5\">#{{vm.selectedMedia.id_media}}</strong> <span class=\"grey-500-fg\"><span \nng-if=\"vm.selectedMedia.filename\" class=\"word-break-all\">{{vm.selectedMedia.filename}}</span></span></div></div>\n<md-tooltip md-direction=\"top\" hide show-gt-xs ng-if=\"vm.selectedMedia.filename\"><span>{{vm.selectedMedia.filename}}\n</span></md-tooltip></div></div></div></div><div class=\"form-tags\" flex><div fill-width class=\"ph-15 mb-0\" flex \nlayout=\"row\" layout-align=\"start center\"><md-input-container class=\"md-block mb-0\" flex><label>\n{{ \'MEDIA.TITLE\' | translate}}</label><input ng-model=\"vm.title\"></md-input-container></div><div fill-width \nclass=\"ph-15 mt-0\" flex layout=\"row\" layout-align=\"start center\"><md-input-container class=\"md-block mt-0\" flex><label \ntranslate=\"CONTENT.SEARCH_FOR_TAG\">Tags</label><md-chips class=\"label-chips close-chip\" ng-model=\"vm.photo_tags\" \nmd-autocomplete-snap md-require-match=\"true\"><md-autocomplete md-min-length=\"3\" md-selected-item=\"vm.selectedTag\" \nmd-selected-item-change=\"vm.selectedItemChange()\" md-search-text=\"vm.searchTagText\" \nmd-items=\"tag in vm.labelQuerySearch(vm.searchTagText) | orderBy:\'-order\'\" md-item-text=\"tag.tag_name\" \nmd-no-cache=\"true\" placeholder=\"{{vm.translate(\'CONTENT.SEARCH_FOR_TAG\')}}\" ng-model-options=\"{debounce: 500}\" \nmd-dropdown-items=\"10\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\" \nclass=\"tag-not-found-bg border-bottom\"><span ng-if=\"!tag.tag_name\">{{vm.searchTagText}}</span> <span \nmd-highlight-text=\"vm.searchTagText\" ng-if=\"tag.tag_name\">{{tag.tag_name}} #{{tag.id_tag}}</span><md-buttton \nng-if=\"!tag.tag_name\" ng-click=\"vm.newTag(vm.searchTagText)\" class=\"md-accent green-500-bg white-fg md-button m-0\">\n<span translate=\"CONTENT.TAGADD\"></span></md-buttton></div><md-not-found><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"100\" class=\"tag-not-found-bg\"><span>{{vm.searchTagText}}</span><md-buttton \nng-click=\"vm.newTag(vm.searchTagText)\" class=\"md-accent green-500-bg white-fg md-button m-0\"><span \ntranslate=\"CONTENT.TAGADD\"></span></md-buttton></div></md-not-found></md-autocomplete><md-chip-template><div \nclass=\"md-chip-content\"><span ng-if=\"$chip.color\" class=\"color\" ng-style=\"{\'background-color\':$chip.color}\"></span> \n<span>{{$chip.tag_name}} #{{$chip.id_tag}}</span></div></md-chip-template><button md-chip-remove class=\"md-primary\" \nlayout=\"row\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-close\"></md-icon></button></md-chips>\n</md-input-container></div><div fill-width class=\"ph-15\" flex layout=\"row\" layout-align=\"start center\">\n<md-input-container class=\"md-block\" flex><label>{{ \'MEDIA.MIN_MATCH\' | translate}} (%)</label><input type=\"number\" \nmin=\"70\" max=\"100\" ng-model=\"vm.min_match\"></md-input-container></div></div></div></md-content><md-dialog-actions \nlayout=\"row\" layout-align=\"end center\" ng-style=\"{\'opacity\' : vm.loading ? 0.2 : 1}\" \nng-if=\"(vm.items.length> 0 || vm.files.length > 0)\"><div layout=\"row\" flex layout-align=\"start center\" \nng-if=\"vm.selectedMedia\" hide show-gt-xs><md-button ng-click=\"vm.selectedMedia= null;\" class=\"send-button md-raised\" \naria-label=\"save\" translate=\"CONTENT.BACK\" translate-attr-aria-label=\"CONTENT.BACK\">BACK</md-button></div><div \nng-if=\"!vm.selectedMedia\" layout=\"row\" layout-align=\"start center\" ng-if=\"vm.totalItems> 0\" hide show-gt-xs \nng-if=\"vm.showSearchAndPaginator\"><span class=\"page-info\" ng-if=\"vm.showSearchAndPaginator\">{{vm.totalItems | number}} \n</span>&nbsp;<span translate=\"CONTENT.ITEMS_FOUND\"></span><md-button aria-label=\"Previous\" \nclass=\"md-icon-button arrow\" ng-if=\"vm.showSearchAndPaginator\" ng-click=\"vm.prevPage()\" ng-disabled=\"vm.firstPage()\" \ntranslate=\"\" translate-attr-aria-label=\"CONTENT.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon>\n<md-tooltip md-direction=\"top\"><span translate=\"CONTENT.PREVIOUS\"></span></md-tooltip></md-button><div><md-select \nng-model=\"pagination_page\" placeholder=\"{{vm.currentPage | number}}\" class=\"toolbar-item\"><md-option \nng-repeat=\"n in [].constructor(vm.lastPage) track by $index\" value=\"{{$index +1}}\" ng-click=\"vm.gotoPage($index+1)\">\n{{$index+1}}</md-option></md-select><md-tooltip md-direction=\"top\"><span translate=\"CONTENT.SELECT_PAGE\"></span>\n</md-tooltip></div><span class=\"page-info\" hide=\"\" show-gt-xs=\"\">/ {{vm.lastPage | number}}</span><md-button \naria-label=\"Next\" class=\"md-icon-button arrow\" ng-if=\"vm.showSearchAndPaginator\" ng-click=\"vm.nextPage()\" \nng-disabled=\"!vm.morePages()\" translate=\"\" translate-attr-aria-label=\"CONTENT.NEXT\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip md-direction=\"top\"><span translate=\"CONTENT.NEXT\"></span>\n</md-tooltip></md-button></div><div ng-if=\"vm.selectedMedia\" layout=\"row\" layout-align=\"end center\" \nng-if=\"vm.maxAttach> 1\"><md-button ng-disabled=\"!vm.title || !vm.min_match || vm.photo_tags.length == 0\" \nng-click=\"vm.saveFace()\" class=\"send-button md-accent md-raised\" aria-label=\"save\" translate=\"CONTENT.SAVE\" \ntranslate-attr-aria-label=\"CONTENT.SAVE\">SAVE</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/media/dialogs/media-tags-dialog/upload-view-tags.html","<div class=\"content-wrapper full-height\" flex=\"\"><div class=\"content\"><div flex=\"100\" layout-padding layout=\"row\"><div \nngf-drop ngf-select ng-model=\"vm.files\" class=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"false\" \nngf-allow-dir=\"true\" accept=\"image/*\" ngf-pattern=\"\'image/*\'\"><div layout=\"column\"><div flex \ntranslate=\"MEDIA.DROP_HERE\" hide show-gt-sm></div><div flex translate=\"MEDIA.DROP_OR\" hide show-gt-sm></div><div flex>\n<md-button class=\"send-button md-accent md-raised\" aria-label=\"Select files\" translate=\"MEDIA.SELECT_FILES\">\n</md-button></div></div></div><div ngf-no-file-drop translate=\"MEDIA.FILE_DRAG_DROP\"></div></div><div flex=\"100\" \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"center start\" ng-if=\"vm.files.length> 0\"><div layout-gt-sm=\"column\" \nflex=\"100\"><div ng-repeat=\"f in vm.uploadFiles\" class=\"ms-card upload-view\" flex \nng-class=\"{\'opacity-6\':f.progress <100 || !f.progress}\"><div class=\"ms-card-content-wrapper\"><div class=\"template-9\" \nlayout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" layout=\"column\" layout-align=\"start stretch\"><div \nclass=\"media upload\" layout=\"row\" layout-align=\"center center\"><img style=\"z-index: 2\" ngf-thumbnail=\"!f.$error && f\" \nclass=\"image\"><div style=\"z-index: 1\" flex layout=\"column\" layout-align=\"center center\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div></div><div layout=\"column\" \nlayout-align=\"center center\" layout-align-gt-xs=\"center start\" flex><div class=\"header p-16\" \nstyle=\"margin-top: auto;margin-bottom: auto\"><div layout=\"row\" layout-align=\"space-between center\" flex><div \nclass=\"size\" layout=\"row\" layout-align=\"start left\"><strong class=\"mr-5\" ng-if=\"f.id\">#{{f.id}}</strong> <strong \nclass=\"grey-500-fg word-break-all\" ng-if=\"f.name\">{{f.name}}</strong></div></div><span class=\"grey-500-fg\" \nng-if=\"f.$error || f.$errorParam\"><span class=\"word-break-all\">{{f.$error}} / {{f.$errorParam}}</span></span></div>\n</div><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"green-fg s32 mh-20\" role=\"img\" \naria-label=\"icon-checkbox-marked-circle\" ng-show=\"f.progress == 100 && vm.processed\"></md-icon><md-progress-circular \nclass=\"mr-50\" md-mode=\"indeterminate\" md-diameter=\"50\" ng-if=\"!vm.processed\"></md-progress-circular></div>\n<md-progress-linear class=\"md-accent\" md-mode=\"determinate\" value=\"{{f.progress && f.progress> 5 ? f.progress : 5}}\" \nng-show=\"!f.progress || f.progress <100\"></md-progress-linear></div></div></div></div></div></div>");
$templateCache.put("app/main/apps/media/dialogs/share-dialog/share-dialog.controller.html","<md-dialog class=\"share-dialog\" aria-label=\"New Task\"><form style=\"height: 100%\" name=\"taskForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between\"><h1 class=\"title\">{{\'MATCH_CENTER.SHARE\' | translate}}</h1><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\"><div class=\"p-15 black-bg\" flex=\"60\" \nlayout=\"row\" layout-align=\"center center\"><div ng-include=\"\'app/main/dialogs/media-show/views/fotorama-view.html\'\" \nclass=\"width-percent-100\"></div></div><div flex=\"40\"><ms-social-widget-share onclose=\"vm.closeDialog()\" \nservice=\"\'media\'\" section=\"\'all\'\" idcontent=\"\" medias=\"vm.mediasIds\"></ms-social-widget-share></div></div>\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/media/dialogs/rekognition-dialog/rekognition-dialog.controller.html","<md-dialog class=\"rekognition-dialog\" aria-label=\"New Task\"><form style=\"height: 100%\" name=\"taskForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between\"><h1 class=\"title\">{{(\'MEDIA.\'+vm.type) | translate}}</h1><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div flex layout=\"column\" \nlayout-align=\"center center\" ng-show=\"vm.isLoading\" class=\"loading-container\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nng-if=\"vm.type==\'TRANSCRIPTION\' && !vm.isLoading\" layout=\"row\"><md-input-container flex class=\"md-block mh-15\"><label \ntranslate=\"CONTENT.LANGUAGE\"></label><md-select ng-model=\"vm.langSelected\"><md-option ng-repeat=\"lang in vm.languages\" \nng-value=\"lang.code\">{{lang.translation | translate}}</md-option></md-select></md-input-container></div><div \nng-if=\"vm.type==\'REKOGNITION\' && !vm.isLoading\" layout=\"row\"><md-input-container flex class=\"md-block mh-15\"><label \ntranslate=\"MEDIA.TYPE_REKOGNITION\"></label><md-select ng-model=\"vm.typeRekognitionSelected\"><md-option \nng-repeat=\"type in vm.typesRekognition\" ng-value=\"type.code\">{{type.translation | translate}}</md-option></md-select>\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div\n flex layout=\"row\" layout-align=\"end center\"><md-button type=\"button\" class=\"md-raised md-warn\" \nng-click=\"vm.closeDialog()\" translate=\"FORMS.CANCEL\">Cancel</md-button><md-button \nng-disabled=\"!vm.langSelected && !vm.typeRekognitionSelected\" ng-click=\"vm.load()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"save\" translate=\"MEDIA.LOAD\">LOAD</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/media/sidenavs/images/galleries-sidenav.html","<div flex layout=\"column\" layout-align=\"center center\" ng-hide=\"!vm.loadingGalleries\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><md-toolbar \nid=\"toolbarGalleries\" class=\"md-default-theme grey-100-bg grey-600-fg pr-16 pl-16\" layout=\"row\" \nlayout-align=\"space-between center\"><div ng-if=\"!vm.showTreeSearch\" class=\"md-toolbar-tools p-0\" \naria-label=\"Galleries\" layout=\"row\" layout-align=\"start center\"><div translate-attr-aria-label=\"MEDIA.GALLERIES\" \ntranslate=\"MEDIA.GALLERIES\" class=\"grey-600-fg\" aria-label=\"GALLERIES\">GALLERIES</div></div><div \nng-if=\"!vm.showTreeSearch\" layout=\"row\" layout-align=\"end center\"><mv-tree-expander tree=\"vm.CleanMediaGalleries\" \nexpanded-ids=\"vm.expandedids\"></mv-tree-expander><md-icon id=\"\" ng-click=\"vm.createGallery($event)\" \nmd-font-icon=\"icon-plus\" class=\"m-0 grey-600-fg md-icon-button md-button md-default-theme md-font material-icons\" \naria-hidden=\"true\"><md-tooltip><span translate=\"CONTENT.ADD\">Add</span></md-tooltip></md-icon><div \nclass=\"divider-vertical hide show-gt-xs\" hide=\"\" show-gt-xs=\"\"></div><md-icon ng-if=\"vm.sortDirGalleries !== \'ASC\'\" \nng-click=\"vm.sortDirGalleries=\'ASC\'; vm.getCleanMediaGalleries()\" md-font-icon=\"icon-sort-descending\" \nclass=\"m-0 grey-600-fg md-icon-button md-button md-default-theme md-font material-icons\" translate=\"\" \ntranslate-attr-aria-label=\"TODO.SORT_DIRECTION\"></md-icon><md-icon ng-if=\"vm.sortDirGalleries === \'ASC\'\" \nng-click=\"vm.sortDirGalleries=\'DESC\'; vm.getCleanMediaGalleries()\" md-font-icon=\"icon-sort-ascending\" \nclass=\"m-0 grey-600-fg md-icon-button md-button md-default-theme md-font material-icons\" translate=\"\" \ntranslate-attr-aria-label=\"TODO.SORT_DIRECTION\"></md-icon><md-menu><button aria-label=\"Filters\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\" show-gt-xs=\"\" translate=\"\" translate-attr-aria-label=\"CONTENT.FILTERS\"><md-icon \nmd-font-icon=\"m-0 grey-600-fg icon-chevron-down\"><md-tooltip><span translate=\"CONTENT.ORDER_BY\">Order</span>\n</md-tooltip></md-icon></button><md-menu-content width=\"4\"><md-menu-item \nng-repeat=\"(key, value) in vm.orderByGalleries\"><md-button aria-label=\"All\" \nng-click=\"vm.sortFieldGalleries=value; vm.getCleanMediaGalleries()\"><div layout=\"row\" \nlayout-align=\"space-between center\"><span>Order by {{key | translate}} </span><i class=\"icon-check s16\" \nng-if=\"value == vm.sortFieldGalleries\"></i></div></md-button></md-menu-item></md-menu-content></md-menu><div \nclass=\"divider-vertical hide show-gt-xs\" hide=\"\" show-gt-xs=\"\"></div><label for=\"ms-search-bar-input\"><md-icon \nng-click=\"vm.showTreeSearch= true\" md-font-icon=\"icon-magnify\" \nclass=\"m-0 grey-600-fg md-icon-button md-button md-default-theme md-font material-icons\"><md-tooltip hide show-gt-xs>\n<span translate=\"TOOLBAR.SEARCH\">Search</span></md-tooltip></md-icon></label><div \nclass=\"divider-vertical hide show-gt-xs\" hide=\"\" show-gt-xs=\"\"></div><md-icon \nng-click=\"vm.cancelMediaGalleries(\'galleries-sidenav\')\" md-font-icon=\"icon-backburger\" \nclass=\"m-0 grey-600-fg md-icon md-button md-default-theme md-font material-icons md-icon-button icon-backburger\" \naria-hidden=\"true\"></md-icon></div><div ng-if=\"vm.showTreeSearch\" layout=\"row\" class=\"media-gallery-tree-search\"><div \nlayout=\"row\" flex layout-align=\"start center\"><label for=\"search-bar-input\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"grey-600-fg md-icon-button md-button\"><md-tooltip hide show-gt-xs><span translate=\"TOOLBAR.SEARCH\">Search</span>\n</md-tooltip></md-icon></label><md-icon md-font-icon=\"icon-close-circle\" class=\"grey-600-fg md-icon-button md-button\" \nng-if=\"vm.treeSearch\" ng-click=\"vm.treeSearch= null\"></md-icon><input type=\"text\" ng-change=\"vm.expandGalleries()\" \nid=\"search-bar-input\" class=\"grey-600-fg grey-100-bg\" ng-model=\"vm.treeSearch\" placeholder=\"Search\" md-autofocus \ntranslate translate-attr-placeholder=\"TOOLBAR.SEARCH\" flex><md-icon layout-align=\"end center\" \nng-click=\"vm.showTreeSearch = false; vm.treeSearch = null\" md-font-icon=\"icon-close\" \nclass=\"media-gallery-tree-search-collapser icon s24 grey-600-fg\"></md-icon></div></div></md-toolbar><md-content \nng-hide=\"vm.loadingGalleries\" ms-scroll class=\"\" flex><div class=\"navigation-simple\" layout=\"column\"><div hidden \nid=\"includeSubgalleries\" data-include-subgalleries=\"{{vm.includeSubgalleries}}\"></div><qiu-tree \nexpandedids=\"vm.expandedids\" selected=\"vm.selectedGallery.id_gallery\" \non-edit=\"vm.openGalleryDialog($event, item, parent)\" on-select=\"vm.handleGallerySelect(item)\" \nng-if=\"vm.CleanMediaGalleries\" search=\"vm.treeSearch\" flat-search=\"true\" tree=\"vm.CleanMediaGalleries\"></qiu-tree>\n</div></md-content>");
$templateCache.put("app/main/apps/media/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-checkbox-marked\" class=\"s24\"></md-icon>\n</span><span class=\"logo-text\" translate=\"TODO.TO_DO\">To-Do</span></div><md-select \nclass=\"project-selection simplified\" ng-model=\"vm.selectedProject\" placeholder=\"Select Project\"><md-option \nng-repeat=\"(project, title) in vm.projects\" value=\"{{project}}\">{{title}}</md-option></md-select></div><md-content \nclass=\"content\" flex ms-scroll><div class=\"add-task-button\"><md-button class=\"md-accent md-raised\" \nng-click=\"vm.openTaskDialog($event)\" aria-label=\"ADD TASK\" translate=\"TODO.ADD_TASK\" \ntranslate-attr-aria-label=\"TODO.ADD_TASK\">ADD TASK</md-button></div><div class=\"navigation-simple\" layout=\"column\">\n<md-button class=\"item\" aria-label=\"All Tasks\" translate translate-attr-aria-label=\"TODO.ALL_TASKS\" \nng-class=\"{\'selected\':vm.showAllTasks}\" ng-click=\"vm.resetFilters()\"><div layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-view-headline\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TODO.ALL_TASKS\">\nAll Tasks</span></div></md-button><div class=\"item subheader\" translate=\"TODO.FILTERS\">Filters</div><md-button \nclass=\"item\" aria-label=\"Starred\" translate translate-attr-aria-label=\"TODO.STARRED\" \nng-click=\"vm.toggleFilterWithEmpty(\'starred\')\" ng-class=\"{\'selected\':vm.taskFilters.starred}\"><md-icon \nmd-font-icon=\"icon-star\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TODO.STARRED\">Starred</span></md-button>\n<md-button class=\"item\" aria-label=\"Priority\" translate translate-attr-aria-label=\"TODO.PRIORITY\" \nng-click=\"vm.toggleFilterWithEmpty(\'important\')\" ng-class=\"{\'selected\':vm.taskFilters.important}\"><md-icon \nmd-font-icon=\"icon-alert-circle\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TODO.PRIORITY\">Priority</span>\n</md-button><md-button class=\"item\" aria-label=\"Scheduled\" translate translate-attr-aria-label=\"TODO.SCHEDULED\" \nng-click=\"vm.toggleFilterWithEmpty(\'dueDate\')\" ng-class=\"{\'selected\':vm.taskFilters.dueDate}\"><md-icon \nmd-font-icon=\"icon-clock\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TODO.SCHEDULED\">Scheduled</span>\n</md-button><md-button class=\"item\" aria-label=\"Today\" translate translate-attr-aria-label=\"TODO.TODAY\" \nng-click=\"vm.toggleFilterWithEmpty(\'startDate\')\" ng-class=\"{\'selected\':vm.taskFilters.startDate}\"><md-icon \nmd-font-icon=\"icon-calendar-today\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TODO.TODAY\">Today</span>\n</md-button><md-button class=\"item\" aria-label=\"Done\" translate translate-attr-aria-label=\"TODO.DONE\" \nng-click=\"vm.toggleFilterWithEmpty(\'completed\')\" ng-class=\"{\'selected\':vm.taskFilters.completed}\"><md-icon \nmd-font-icon=\"icon-check\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TODO.DONE\">Done</span></md-button>\n<md-button class=\"item\" aria-label=\"Deleted\" translate translate-attr-aria-label=\"TODO.DELETED\" \nng-click=\"vm.toggleFilter(\'deleted\')\" ng-class=\"{\'selected\':vm.taskFilters.deleted}\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TODO.DELETED\">Deleted</span>\n</md-button><div class=\"item subheader\" translate=\"TODO.TAGS\">Tags</div><md-button class=\"tag item\" \naria-label=\"tag {{tag.label}}\" ng-repeat=\"tag in vm.tags track by $index\" ng-click=\"vm.toggleTagFilter(tag)\"><md-icon \nmd-font-icon=\"icon-label\" class=\"s16\" ng-style=\"{\'color\' : tag.color}\"></md-icon><span class=\"title\">{{tag.label}}\n</span></md-button></div></md-content>");
$templateCache.put("app/main/apps/media/views/list/galleries-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-show=\"vm.isLoading\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nclass=\"mail-list-item md-toolbar-tools grey-100-bg filter-selected breadcrumb\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"info\" flex><div class=\"breaditem\" layout=\"row\" layout-align=\"start center\"><div\n ng-click=\"vm.backToGallery()\" class=\"text-truncate pl-15 pr-10\" layout=\"row\" layout-align=\"start center\"><md-icon \nclass=\"s16 home-icon\" md-font-icon=\"icon-home\"></md-icon>{{\'MEDIA.GALLERIES\' | translate}} <span \nng-if=\"vm.CleanMediaGalleries.length> 0\">({{vm.CleanMediaGalleries.length}})</span></div><span class=\"pr-10\" \nng-click=\"vm.backToGallery(gallery); event.stopPropagation()\" \nng-repeat=\"gallery in vm.hierarchyGalleries track by $index\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon>\n<md-icon ng-if=\"!gallery.children && gallery.gallery_type == 0\" md-font-icon=\"icon-folder\" \nclass=\"s16 mr-0 mt-0 ml-5 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"!gallery.children && gallery.gallery_type == 1\" md-font-icon=\"icon-folder-image\" \nclass=\"s16 mr-0 mt-0 ml-5 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"!gallery.children && gallery.gallery_type == 2\" md-font-icon=\"qiu-icon-video-folder\" \nclass=\"s16 mr-0 mt-0 ml-5 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"!gallery.children && gallery.gallery_type == 3\" md-font-icon=\"qiu-icon-audio-folder\" \nclass=\"s16 mr-0 mt-0 ml-5 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"!gallery.children && gallery.gallery_type == 4\" md-font-icon=\"qiu-icon-file-folder\" \nclass=\"s16 mr-0 mt-0 ml-5 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"gallery.children && gallery.gallery_type == 0\" md-font-icon=\"icon-folder-multiple\" \nclass=\"s16 mr-0 mt-0 ml-5 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"gallery.children && gallery.gallery_type == 1\" md-font-icon=\"icon-folder-multiple-image\" \nclass=\"s16 mr-0 mt-0 ml-5 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"gallery.children && gallery.gallery_type == 2\" md-font-icon=\"qiu-icon-video-gallery\" \nclass=\"s16 mr-0 mt-0 ml-5 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"gallery.children && gallery.gallery_type == 3\" md-font-icon=\"qiu-icon-audio-gallery\" \nclass=\"s16 mr-0 mt-0 ml-5 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"gallery.children && gallery.gallery_type == 4\" md-font-icon=\"qiu-icon-file-gallery\" \nclass=\"s16 mr-0 mt-0 ml-5 mb-0\" aria-hidden=\"true\"></md-icon>{{gallery.gallery_name}} <span \nng-if=\"gallery.children.length> 0\">({{gallery.children.length}})</span></span></div></div></div><div \nid=\"list-content-data\" ng-style=\"{\'opacity\' : vm.isLoading ? 0.2 : 1}\" ms-scroll=\"vm.msScrollOptions\" \nng-class=\"{\'group-filter\': vm.selectedGallery,\'other-filter\':$root.pagination_searchquery==true}\" \nclass=\"scrollable mt-64\"><div class=\"media mail-list-pane-grid pt-20 pb-30\" flex layout-padding><div \nclass=\"no-threads\" ng-if=\"vm.selectedGalleryChildren.length == 0 || !vm.selectedGalleryChildren\"><md-icon \nmd-font-icon=\"icon-folder\" class=\"grey-fg s50 mr-10 mt-0 ml-0 mb-10\" aria-hidden=\"true\" role=\"img\"></md-icon><span \nclass=\"grey-fg\" translate=\"MEDIA.NO_ITEMS_GALLERY\"></span></div><div class=\"grid-view\" \nng-sortable=\"vm.gallerySortable\" md-cols=\"{{vm.cols}}\" md-row-height=\"250\" md-gutter=\"12px\" md-gutter-gt-sm=\"8px\" \nng-hide=\"vm.selectedGalleryChildren.length == 0 || !vm.selectedGalleryChildren\"><div \nng-click=\"vm.openGalleryFolder(gallery)\" ng-repeat=\"gallery in vm.selectedGalleryChildren\" \ndata-id=\"{{gallery.id_gallery}}\" class=\"ms-card grid-element sortable pointer\"><div class=\"ms-card-content-wrapper\">\n<div class=\"template-9\" layout=\"column\" layout-align=\"space-between stretch\"><div class=\"media\" flex layout=\"row\" \nlayout-align=\"center center\"><media attachment=\"gallery.cover\" class-img=\"image\"></media></div><div \nclass=\"header p-16\" flex><div layout=\"row\" layout-align=\"space-between center\" flex><div class=\"size text-truncate\" \nlayout=\"row\" layout-align=\"start left\"><md-icon ng-if=\"!gallery.children && gallery.gallery_type == 0\" \nmd-font-icon=\"icon-folder\" class=\"s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"!gallery.children && gallery.gallery_type == 1\" md-font-icon=\"icon-folder-image\" \nclass=\"s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"!gallery.children && gallery.gallery_type == 2\" md-font-icon=\"qiu-icon-video-folder\" \nclass=\"s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"!gallery.children && gallery.gallery_type == 3\" md-font-icon=\"qiu-icon-audio-folder\" \nclass=\"s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"!gallery.children && gallery.gallery_type == 4\" md-font-icon=\"qiu-icon-file-folder\" \nclass=\"s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"gallery.children && gallery.gallery_type == 0\" md-font-icon=\"icon-folder-multiple\" \nclass=\"s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"gallery.children && gallery.gallery_type == 1\" md-font-icon=\"icon-folder-multiple-image\" \nclass=\"s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"gallery.children && gallery.gallery_type == 2\" md-font-icon=\"qiu-icon-video-gallery\" \nclass=\"s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"gallery.children && gallery.gallery_type == 3\" md-font-icon=\"qiu-icon-audio-gallery\" \nclass=\"s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"gallery.children && gallery.gallery_type == 4\" md-font-icon=\"qiu-icon-file-gallery\" \nclass=\"s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><span class=\"grey-500-fg\"><span class=\"filename\">\n{{gallery.gallery_name}}</span> <span class=\"filename\">\n({{gallery.element_total_count ? gallery.element_total_count : \'MEDIA.NO_FILES\' | translate}})</span></span></div><div \nclass=\"size text-truncate\" layout=\"row\" layout-align=\"start right\"><md-menu><md-icon \nng-click=\"vm.openMenu($mdMenu, $event); $event.stopPropagation()\" \nmd-svg-icon=\"assets/angular-material-assets/img/icons/more_vert.svg\"></md-icon><md-menu-content width=\"2\">\n<md-menu-item><md-button ng-click=\"vm.editGallery(gallery)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>Edit\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.deleteGallery($event, gallery)\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-default-theme md-font material-icons icon-delete\"></md-icon>Remove</md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></div></div></div></div><div class=\"toolbar\" \nlayout=\"row\" layout-align=\"space-between center\" ng-include=\"\'app/main/apps/media/views/toolbar.html\'\"></div><div \nng-if=\"(!vm.isRoot || $root.pagination_searchquery==true) && (vm.items.length> 0 || vm.selectedGalleryChildren)\"><div \nclass=\"mail-list-item filter-selected\" ng-if=\"$root.pagination_searchquery==true\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"info\" flex><div class=\"name\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-filter\" class=\"s20 mr-8 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><div class=\"title\" layout=\"row\" \nlayout-align=\"start center\"><div ng-repeat=\"filterable in refFilterables track by $index\" class=\"inline-block\"><div \nng-repeat=\"label in filterable.values | filterInArray:filterable.selected:\'value\' track by $index\" \nclass=\"mr-5 tag-list inline-block\"><span class=\"grey-50-fg\">{{label.name}}</span></div></div></div><div \nclass=\"title text-truncate pl-10\" layout=\"row\" layout-align=\"start center\" ng-if=\"$root.modelSearch\">\n{{$root.modelSearch}}</div></div></div><div class=\"buttons\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-close s20\" ng-click=\"$root.pagination_resetquery()\" class=\"ml-10\"><md-tooltip hide show-gt-xs><span \ntranslate=\"CONTENT.REMOVE_FILTERS\">Remove filters</span></md-tooltip></md-icon></div></div><div \nclass=\"media mail-list-pane-grid pt-20 pb-30\" flex layout-padding><div class=\"grid-view\" \nng-sortable=\"vm.mediaSortable\" md-cols=\"{{vm.cols}}\" md-row-height=\"250\" md-gutter=\"12px\" ng-if=\"sortField == \'sort\'\" \nmd-gutter-gt-sm=\"8px\"><div ng-repeat=\"mediaItem in vm.items\" ng-click=\"vm.selectMediaFile(mediaItem)\" \ndata-id=\"{{mediaItem.id_media}}\" class=\"ms-card grid-element sortable\" \nng-class=\"{\'selected\': vm.ImageIDSelected === mediaItem.id_media}\"><div class=\"ms-card-content-wrapper\"><div \nclass=\"template-9\" layout=\"column\" layout-align=\"space-between stretch\"><div class=\"media\" flex layout=\"row\" \nlayout-align=\"center center\"><media attachment=\"mediaItem\" class-img=\"image\"></media></div><div class=\"header p-16\" \nflex><div layout=\"row\" layout-align=\"space-between center\" flex><div class=\"size block\" layout=\"row\" \nlayout-align=\"start left\"><strong class=\"mr-5\">#{{mediaItem.id_media}}</strong> <span class=\"grey-500-fg\"><span \nng-if=\"mediaItem.filename\" class=\"filename\">{{mediaItem.filename}}</span></span></div><md-checkbox \nng-checked=\"vm.isSelected(mediaItem)\" ng-click=\"vm.toggleSelectThread(mediaItem, $event)\" \naria-label=\"{{vm.isSelected(mediaItem) ? \'Deselect\' : \'Select\'}}\" class=\"ml-5\"></md-checkbox></div></div></div></div>\n</div></div><div class=\"grid-view\" md-cols=\"{{vm.cols}}\" md-row-height=\"250\" md-gutter=\"12px\" \nng-if=\"sortField != \'sort\'\" md-gutter-gt-sm=\"8px\"><div ng-repeat=\"mediaItem in vm.items\" \nng-click=\"vm.selectMediaFile(mediaItem)\" data-id=\"{{mediaItem.id_media}}\" class=\"ms-card grid-element sortable\" \nng-class=\"{\'selected\': vm.ImageIDSelected === mediaItem.id_media}\"><div class=\"ms-card-content-wrapper\"><div \nclass=\"template-9\" layout=\"column\" layout-align=\"space-between stretch\"><div class=\"media\" flex layout=\"row\" \nlayout-align=\"center center\"><media attachment=\"mediaItem\" class-img=\"image\"></media></div><div class=\"header p-16\" \nflex><div layout=\"row\" layout-align=\"space-between center\" flex><div class=\"size block\" layout=\"row\" \nlayout-align=\"start left\"><strong class=\"mr-5\">#{{mediaItem.id_media}}</strong> <span class=\"grey-500-fg\"><span \nng-if=\"mediaItem.filename\" class=\"filename\">{{mediaItem.filename}}</span></span></div><div \nng-if=\"vm.media_type_name == \'Image Rekognition\'\" class=\"size block\" layout=\"row\" layout-align=\"start left\">PROCESANDO\n</div><md-checkbox ng-checked=\"vm.isSelected(mediaItem)\" ng-click=\"vm.toggleSelectThread(mediaItem, $event)\" \naria-label=\"{{vm.isSelected(mediaItem) ? \'Deselect\' : \'Select\'}}\" class=\"ml-5\"></md-checkbox></div></div></div></div>\n</div></div></div><div class=\"no-threads\" ng-if=\"vm.items.length == 0 && vm.selectedGalleryChildren\"><span \nclass=\"grey-fg\" translate=\"MEDIA.NO_ITEMS_FILES\"></span></div><md-divider \nng-if=\"!vm.isRoot && (vm.items.length> 0 || vm.selectedGalleryChildren)\"></md-divider><div \nng-if=\"!vm.isRoot && (vm.items.length> 0 || vm.selectedGalleryChildren)\" class=\"toolbar\" layout=\"row\" \nlayout-align=\"end center\"><div layout=\"row\" layout-align=\"center center\" \nng-style=\"{\'display\' : vm.isLoading ? \'none\' : \'block\'}\"><span class=\"page-info\">\n{{pagination_totalItems | number}} items found.</span><md-button aria-label=\"Previous\" class=\"md-icon-button arrow\" \nng-click=\"pagination_prevPage()\" ng-disabled=\"pagination_firstPage()\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button><span \nclass=\"page-info\">{{pagination_current_page | number}} / {{pagination_total_pages | number}}</span><md-button \naria-label=\"Next\" class=\"md-icon-button arrow\" ng-click=\"pagination_nextPage()\" ng-disabled=\"pagination_morePages()\" \ntranslate=\"\" translate-attr-aria-label=\"CONTENT.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button>\n</div></div><div class=\"no-threads\" ng-if=\"vm.items.length == 0 && !vm.selectedGalleryChildren\"><span class=\"grey-fg\" \ntranslate=\"MEDIA.NO_ITEMS\"></span></div></div></div>");
$templateCache.put("app/main/apps/media/views/list/items-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-show=\"vm.isLoading\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nclass=\"mail-list-item filter-selected\" ng-if=\"vm.selectedGallery\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"info\" flex><div class=\"name\" layout=\"row\" layout-align=\"start center\"><md-icon \nng-if=\"!vm.selectedGallery.children && vm.selectedGallery.gallery_type == 0\" md-font-icon=\"icon-folder\" \nclass=\"s20 mr-8 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"!vm.selectedGallery.children && vm.selectedGallery.gallery_type == 1\" md-font-icon=\"icon-folder-image\" \nclass=\"s20 mr-8 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"!vm.selectedGallery.children && vm.selectedGallery.gallery_type == 2\" md-font-icon=\"qiu-icon-video-folder\" \nclass=\"s20 mr-8 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"!vm.selectedGallery.children && vm.selectedGallery.gallery_type == 3\" md-font-icon=\"qiu-icon-audio-folder\" \nclass=\"s20 mr-8 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"!vm.selectedGallery.children && vm.selectedGallery.gallery_type == 4\" md-font-icon=\"qiu-icon-file-folder\" \nclass=\"s20 mr-8 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"vm.selectedGallery.children && vm.selectedGallery.gallery_type == 0\" md-font-icon=\"icon-folder-multiple\" \nclass=\"s20 mr-8 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"vm.selectedGallery.children && vm.selectedGallery.gallery_type == 1\" md-font-icon=\"icon-folder-multiple-image\" \nclass=\"s20 mr-8 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"vm.selectedGallery.children && vm.selectedGallery.gallery_type == 2\" md-font-icon=\"qiu-icon-video-gallery\" \nclass=\"s20 mr-8 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"vm.selectedGallery.children && vm.selectedGallery.gallery_type == 3\" md-font-icon=\"qiu-icon-audio-gallery\" \nclass=\"s20 mr-8 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"vm.selectedGallery.children && vm.selectedGallery.gallery_type == 4\" md-font-icon=\"qiu-icon-file-gallery\" \nclass=\"s20 mr-8 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><div class=\"title text-truncate\" layout=\"row\" \nlayout-align=\"start center\">{{vm.selectedGallery.gallery_name}} <span ng-if=\"!vm.isLoading\">\n({{pagination_totalItems | number}})</span></div></div></div><div class=\"buttons\" layout=\"row\" \nlayout-align=\"start center\"><div><md-switch hide class=\"no-label\" ng-checked=\"vm.includeSubgalleries\" \nng-click=\"vm.toggleIncludeSubgalleries($event)\" aria-label=\"{{vm.includeSubgalleries ? \'Uncheck\':\'check\'}}\">\n</md-switch><md-tooltip><span translate=\"CONTENT.INCLUDE_SUBGROUPS\">Include subgroups</span></md-tooltip></div><md-icon\n md-font-icon=\"icon-close s20\" ng-click=\"vm.unselectGalleries()\" class=\"ml-10\" \nng-if=\"!vm.selectedGallery.is_qiu_restricted\"><md-tooltip hide show-gt-xs><span translate=\"CONTENT.DESELECT_GROUP\">\nDeselect group</span></md-tooltip></md-icon></div></div><div class=\"mail-list-item filter-selected\" \nng-if=\"$root.pagination_searchquery==true\" layout=\"row\" layout-align=\"start center\"><div class=\"info\" flex><div \nclass=\"name\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-filter\" class=\"s20 mr-8 ml-0 mb-0\" \naria-hidden=\"true\"></md-icon><div class=\"title\" layout=\"row\" layout-align=\"start center\"><div \nng-repeat=\"filterable in refFilterables track by $index\" class=\"inline-block\"><div \nng-repeat=\"label in filterable.values | filterInArray:filterable.selected:\'value\' track by $index\" \nclass=\"mr-5 tag-list inline-block\"><span class=\"grey-50-fg\">{{label.name}}</span></div></div></div><div \nclass=\"title text-truncate pl-10\" layout=\"row\" layout-align=\"start center\" ng-if=\"$root.modelSearch\">\n{{$root.modelSearch}}</div></div></div><div class=\"buttons\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-close s20\" ng-click=\"$root.pagination_resetquery()\" class=\"ml-10\"><md-tooltip hide show-gt-xs><span \ntranslate=\"CONTENT.REMOVE_FILTERS\">Remove filters</span></md-tooltip></md-icon></div></div><div class=\"no-threads\" \nng-if=\"!vm.isLoading && vm.items.length === 0\" ng-hide=\"vm.isLoading\">There are no items!</div><div \nid=\"list-content-data\" ng-style=\"{\'opacity\' : vm.isLoading ? 0.2 : 1}\" ms-scroll=\"vm.msScrollOptions\" \nng-class=\"{\'group-filter\': vm.selectedGallery,\'other-filter\':$root.pagination_searchquery==true}\" class=\"scrollable\" \nng-if=\"vm.items.length > 0\"><google-gallery on-select=\"vm.selectMediaFileSidenav(mediaItem)\" \nng-if=\"vm.currentListView == \'gridGoogle\'\" items=\"vm.items\"></google-gallery><div class=\"media mail-list-pane-grid\" \nflex layout-padding ng-if=\"vm.currentListView == \'grid\'\"><div class=\"grid-view\" md-cols=\"{{vm.cols}}\" \nmd-row-height=\"250\" md-gutter=\"12px\" md-gutter-gt-sm=\"8px\" ng-sortable=\"vm.mediaSortable\" \nng-if=\"vm.selectedGallery && sortField == \'sort\'\" drag-select><div ng-repeat=\"mediaItem in vm.items\" \nclass=\"grid-element sortable\" data-id=\"{{mediaItem.id_media}}\"><div class=\"ms-card\" flex \nng-click=\"vm.selectMediaFile(mediaItem)\" \nng-class=\"{\'starred\': thread.starred, \'selected\': vm.ImageIDSelected === mediaItem.id_media, \'checked\': vm.isChecked(thread)}\" \nng-include=\"vm.subviews[mediaItem.media_type]\"></div></div></div><div class=\"grid-view\" md-cols=\"{{vm.cols}}\" \nmd-row-height=\"250\" md-gutter=\"12px\" md-gutter-gt-sm=\"8px\" ng-if=\"!vm.selectedGallery || sortField != \'sort\'\" \ndrag-select><div ng-repeat=\"mediaItem in vm.items\" class=\"grid-element sortable\" data-id=\"{{mediaItem.id_media}}\"><div \nclass=\"ms-card\" flex ng-click=\"vm.selectMediaFile(mediaItem)\" \nng-class=\"{\'starred\': thread.starred, \'selected\': vm.ImageIDSelected === mediaItem.id_media, \'checked\': vm.isChecked(thread)}\" \nng-include=\"vm.subviews[mediaItem.media_type]\"></div></div></div></div><div ng-sortable=\"vm.mediaSortable\" \nng-if=\"vm.selectedGallery && vm.currentListView == \'list\'\"><div class=\"mail-list-item sortable\" \nng-repeat=\"mediaItem in vm.items\" ng-click=\"vm.selectMediaFile(mediaItem)\" \nng-class=\"{\'starred\': thread.starred, \'selected\': vm.ImageIDSelected === mediaItem.id_media, \'checked\': vm.isChecked(thread)}\" \ndata-id=\"{{mediaItem.id_media}}\"><div ng-include=\"vm.subviews[\'list\']\"></div></div></div><div \nng-if=\"!vm.selectedGallery && vm.currentListView == \'list\'\"><div class=\"mail-list-item\" \nng-repeat=\"mediaItem in vm.items\" ng-click=\"vm.selectMediaFile(mediaItem)\" \nng-class=\"{\'starred\': thread.starred, \'selected\': vm.ImageIDSelected === mediaItem.id_media, \'checked\': vm.isChecked(thread)}\" \ndata-id=\"{{mediaItem.id_media}}\"><div ng-include=\"vm.subviews[\'list\']\"></div></div></div><md-divider></md-divider><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"end center\"><div layout=\"row\" layout-align=\"center center\" \nng-style=\"{\'display\' : vm.isLoading ? \'none\' : \'block\'}\"><span class=\"page-info\">\n{{pagination_totalItems | number}} items found.</span><md-button aria-label=\"Previous\" class=\"md-icon-button arrow\" \nng-click=\"pagination_prevPage()\" ng-disabled=\"pagination_firstPage()\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button><span \nclass=\"page-info\">{{pagination_current_page | number}} / {{pagination_total_pages | number}}</span><md-button \naria-label=\"Next\" class=\"md-icon-button arrow\" ng-click=\"pagination_nextPage()\" ng-disabled=\"pagination_morePages()\" \ntranslate=\"\" translate-attr-aria-label=\"CONTENT.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button>\n</div></div></div>");
$templateCache.put("app/main/apps/mediahub/dialogs/galleries/edit-gallery.html","<md-dialog class=\"mediahub-edit-gallery-dialog\" aria-label=\"Gallery Editor\" ng-cloak><form name=\"vm.basicForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" translate=\"{{vm.dialogTitle}}\">Gallery #{{vm.galleryId}}</span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-tabs md-dynamic-height md-border-bottom>\n<md-tab label=\"{{ \'GALLERY.OPEN_SETTINGS_MAIN\' | translate }}\"><div ng-include=\"vm.views[\'edit_gallery_main\']\"></div>\n</md-tab><md-tab label=\"{{ \'GALLERY.PERMISSIONS\' | translate }}\"><div \nng-include=\"vm.views[\'edit_gallery_permissions\']\"></div></md-tab></md-tabs></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\" class=\"p-16\"><md-button ng-if=\"vm.isEditMode\" class=\"md-icon-button\" \nng-click=\"vm.deleteGallery()\" aria-label=\"Delete gallery\"><md-icon md-font-icon=\"icon-delete\" class=\"red-fg\"></md-icon>\n</md-button><span ng-if=\"!vm.isEditMode\"></span><div layout=\"row\" layout-align=\"start center\"><md-button \nng-click=\"vm.cancel()\" class=\"md-primary\"><span translate=\"GALLERY.CANCEL\">Cancel</span></md-button><md-button \nng-click=\"vm.save()\" class=\"md-accent md-raised\" \nng-disabled=\"vm.basicForm.$invalid || vm.saving || vm.dynamicInvalid()\"><span ng-if=\"!vm.isEditMode\" \ntranslate=\"GALLERY.SAVE\">Save</span> <span ng-if=\"vm.isEditMode\" translate=\"GALLERY.UPDATE\">Update</span></md-button>\n</div></md-dialog-actions></form><div class=\"blocking-overlay\" layout=\"row\" layout-align=\"center center\" \nng-if=\"vm.bulk.active\"><div layout=\"row\" layout-align=\"center center\" class=\"bulk-progress-card\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"40\"></md-progress-circular><div class=\"ml-15\" layout=\"column\"><span><span \ntranslate=\"GALLERY.PROPAGATE_RUNNING\">Applying to the galleries inside…</span> <span class=\"bulk-count\">\n{{ vm.bulk.done + vm.bulk.failed }}/{{ vm.bulk.total }}</span> </span><span class=\"bulk-current\" \nng-if=\"vm.bulk.current\">{{ vm.bulk.current }}</span> <span class=\"bulk-failed red-fg\" ng-if=\"vm.bulk.failed\" \ntranslate=\"GALLERY.PROPAGATE_FAILED_COUNT\" translate-values=\"{ failed: vm.bulk.failed }\"></span></div></div></div>\n</md-dialog>");
$templateCache.put("app/main/apps/media/views/tabs/tab-ai.html","<div class=\"form-wrapper md-whiteframe-1dp p-0-i\" flex=\"100\"><form name=\"vm.basicFormAi\" class=\"md-inline-form\" \nnovalidate><div layout=\"column\" layout-xs=\"column\"><div ng-if=\"vm.image.meta_analyses.google_crop_hints_detection\"><div\n layout=\"row\"><md-list flex=\"100\" class=\"p-0 bb pointer\" ng-click=\"googleCropHintsDetection=!googleCropHintsDetection\">\n<md-list-item class=\"md-toolbar-tools grey-100-bg p-0-i\"><div layout=\"row\" layout-align=\"space-between center\" \nflex=\"100\"><h3 class=\"grey-700-fg ph-25\" translate=\"MEDIA.CROPPROCESS.GOOGLE_CROP_HINTS_DETECTION\"></h3><md-button \nclass=\"md-icon-button\"><md-icon ng-if=\"!googleCropHintsDetection\" md-font-icon=\"icon-chevron-right\" class=\"mh-5\">\n</md-icon><md-icon ng-if=\"googleCropHintsDetection\" md-font-icon=\"icon-chevron-down\" class=\"mh-5\"></md-icon>\n</md-button></div></md-list-item></md-list></div><div class=\"p-10\" layout=\"column\" flex=\"100\" \nng-show=\"googleCropHintsDetection\" ng-repeat=\"item in vm.image.meta_analyses.google_crop_hints_detection.cropHints\">\n<div ng-repeat=\"(key, item) in item\"><div layout=\"row\" flex=\"100\" class=\"p-10\">{{key}}: {{item}}</div></div><md-divider\n ng-if=\"!$last\"></md-divider></div></div><div ng-if=\"vm.image.meta_analyses.google_face_detection\"><div layout=\"row\">\n<md-list flex=\"100\" class=\"p-0 bb pointer\" ng-click=\"googleFaceDetection=!googleFaceDetection\"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg p-0-i\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><h3 \nclass=\"grey-700-fg ph-25\" translate=\"MEDIA.CROPPROCESS.GOOGLE_FACE_DETECTION\"></h3><md-button class=\"md-icon-button\">\n<md-icon ng-if=\"!googleFaceDetection\" md-font-icon=\"icon-chevron-right\" class=\"mh-5\"></md-icon><md-icon \nng-if=\"googleFaceDetection\" md-font-icon=\"icon-chevron-down\" class=\"mh-5\"></md-icon></md-button></div></md-list-item>\n</md-list></div><div class=\"p-10\" layout=\"column\" flex=\"100\" ng-show=\"googleFaceDetection\" \nng-repeat=\"item in vm.image.meta_analyses.google_face_detection\"><div ng-repeat=\"(key, item) in item\"><div \nlayout=\"row\" flex=\"100\" class=\"p-10\">{{key}}: {{item}}</div></div><md-divider ng-if=\"!$last\"></md-divider></div></div>\n<div ng-if=\"vm.image.meta_analyses.google_image_properties_detection\"><div layout=\"row\"><md-list flex=\"100\" \nclass=\"p-0 bb pointer\" ng-click=\"googleImagePropertiesDetection=!googleImagePropertiesDetection\"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg p-0-i\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><h3 \nclass=\"grey-700-fg ph-25\" translate=\"MEDIA.CROPPROCESS.GOOGLE_IMAGE_PROPERTIES_DETECTION\"></h3><md-button \nclass=\"md-icon-button\"><md-icon ng-if=\"!googleImagePropertiesDetection\" md-font-icon=\"icon-chevron-right\" class=\"mh-5\">\n</md-icon><md-icon ng-if=\"googleImagePropertiesDetection\" md-font-icon=\"icon-chevron-down\" class=\"mh-5\"></md-icon>\n</md-button></div></md-list-item></md-list></div><div class=\"p-10\" layout=\"column\" flex=\"100\" \nng-show=\"googleImagePropertiesDetection\" \nng-repeat=\"(key, item) in vm.image.meta_analyses.google_image_properties_detection\"><div layout=\"row\" flex=\"100\" \nclass=\"p-10\">{{key}}: {{item}}</div><md-divider ng-if=\"!$last\"></md-divider></div></div><div \nng-if=\"vm.image.meta_analyses.google_label_detection\"><div layout=\"row\"><md-list flex=\"100\" class=\"p-0 bb pointer\" \nng-click=\"googleLabelDetection=!googleLabelDetection\"><md-list-item class=\"md-toolbar-tools grey-100-bg p-0-i\"><div \nlayout=\"row\" layout-align=\"space-between center\" flex=\"100\"><h3 class=\"grey-700-fg ph-25\" \ntranslate=\"MEDIA.CROPPROCESS.GOOGLE_LABEL_DETECTION\"></h3><md-button class=\"md-icon-button\"><md-icon \nng-if=\"!googleLabelDetection\" md-font-icon=\"icon-chevron-right\" class=\"mh-5\"></md-icon><md-icon \nng-if=\"googleLabelDetection\" md-font-icon=\"icon-chevron-down\" class=\"mh-5\"></md-icon></md-button></div></md-list-item>\n</md-list></div><div class=\"p-10\" layout=\"column\" flex=\"100\" ng-show=\"googleLabelDetection\" \nng-repeat=\"item in vm.image.meta_analyses.google_label_detection\"><div ng-repeat=\"(key, item) in item\"><div \nlayout=\"row\" flex=\"100\" class=\"p-10\">{{key}}: {{item}}</div></div><md-divider ng-if=\"!$last\"></md-divider></div></div>\n<div ng-if=\"vm.image.meta_analyses.google_logo_detection\"><div layout=\"row\"><md-list flex=\"100\" class=\"p-0 bb pointer\" \nng-click=\"googleLogoDetection=!googleLogoDetection\"><md-list-item class=\"md-toolbar-tools grey-100-bg p-0-i\"><div \nlayout=\"row\" layout-align=\"space-between center\" flex=\"100\"><h3 class=\"grey-700-fg ph-25\" \ntranslate=\"MEDIA.CROPPROCESS.GOOGLE_LOGO_DETECTION\"></h3><md-button class=\"md-icon-button\"><md-icon \nng-if=\"!googleLogoDetection\" md-font-icon=\"icon-chevron-right\" class=\"mh-5\"></md-icon><md-icon \nng-if=\"googleLogoDetection\" md-font-icon=\"icon-chevron-down\" class=\"mh-5\"></md-icon></md-button></div></md-list-item>\n</md-list></div><div class=\"p-10\" layout=\"column\" flex=\"100\" ng-show=\"googleLogoDetection\" \nng-repeat=\"item in vm.image.meta_analyses.google_logo_detection\"><div ng-repeat=\"(key, item) in item\"><div \nlayout=\"row\" flex=\"100\" class=\"p-10\">{{key}}: {{item}}</div></div><md-divider ng-if=\"!$last\"></md-divider></div></div>\n<div ng-if=\"vm.image.meta_analyses.google_object_detection\"><div layout=\"row\"><md-list flex=\"100\" \nclass=\"p-0 bb pointer\" ng-click=\"googleObjectDetection=!googleObjectDetection\"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg p-0-i\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><h3 \nclass=\"grey-700-fg ph-25\" translate=\"MEDIA.CROPPROCESS.GOOGLE_OBJECT_DETECTION\"></h3><md-button class=\"md-icon-button\">\n<md-icon ng-if=\"!googleObjectDetection\" md-font-icon=\"icon-chevron-right\" class=\"mh-5\"></md-icon><md-icon \nng-if=\"googleObjectDetection\" md-font-icon=\"icon-chevron-down\" class=\"mh-5\"></md-icon></md-button></div></md-list-item>\n</md-list></div><div class=\"p-10\" layout=\"column\" flex=\"100\" ng-show=\"googleObjectDetection\" \nng-repeat=\"item in vm.image.meta_analyses.google_object_detection\"><div ng-repeat=\"(key, item) in item\"><div \nlayout=\"row\" flex=\"100\" class=\"p-10\">{{key}}: {{item}}</div></div><md-divider ng-if=\"!$last\"></md-divider></div></div>\n<div ng-if=\"vm.image.meta_analyses.google_safe_search_properties_detection\"><div layout=\"row\"><md-list flex=\"100\" \nclass=\"p-0 bb pointer\" ng-click=\"googleSaveSearchPropertiesDetection=!googleSaveSearchPropertiesDetection\">\n<md-list-item class=\"md-toolbar-tools grey-100-bg p-0-i\"><div layout=\"row\" layout-align=\"space-between center\" \nflex=\"100\"><h3 class=\"grey-700-fg ph-25\" translate=\"MEDIA.CROPPROCESS.GOOGLE_SAFE_SEARCH_PROPERTIES_DETECTION\"></h3>\n<md-button class=\"md-icon-button\"><md-icon ng-if=\"!googleSaveSearchPropertiesDetection\" \nmd-font-icon=\"icon-chevron-right\" class=\"mh-5\"></md-icon><md-icon ng-if=\"googleSaveSearchPropertiesDetection\" \nmd-font-icon=\"icon-chevron-down\" class=\"mh-5\"></md-icon></md-button></div></md-list-item></md-list></div><div \nclass=\"p-10\" layout=\"column\" flex=\"100\" ng-show=\"googleSaveSearchPropertiesDetection\" \nng-repeat=\"(key, item) in vm.image.meta_analyses.google_safe_search_properties_detection\"><div layout=\"row\" flex=\"100\" \nclass=\"p-10\">{{key}}: {{item}}</div><md-divider ng-if=\"!$last\"></md-divider></div></div><div \nng-if=\"vm.image.meta_analyses.google_text_detection\"><div layout=\"row\"><md-list flex=\"100\" class=\"p-0 bb pointer\" \nng-click=\"googleTextDetection=!googleTextDetection\"><md-list-item class=\"md-toolbar-tools grey-100-bg p-0-i\"><div \nlayout=\"row\" layout-align=\"space-between center\" flex=\"100\"><h3 class=\"grey-700-fg ph-25\" \ntranslate=\"MEDIA.CROPPROCESS.GOOGLE_TEXT_DETECTION\"></h3><md-button class=\"md-icon-button\"><md-icon \nng-if=\"!googleTextDetection\" md-font-icon=\"icon-chevron-right\" class=\"mh-5\"></md-icon><md-icon \nng-if=\"googleTextDetection\" md-font-icon=\"icon-chevron-down\" class=\"mh-5\"></md-icon></md-button></div></md-list-item>\n</md-list></div><div class=\"p-10\" layout=\"column\" flex=\"100\" ng-show=\"googleTextDetection\" \nng-repeat=\"item in vm.image.meta_analyses.google_text_detection\"><div ng-repeat=\"(key, item) in item\"><div \nlayout=\"row\" flex=\"100\" class=\"p-10\">{{key}}: {{item}}</div></div><md-divider ng-if=\"!$last\"></md-divider></div></div>\n<div ng-if=\"vm.image.meta_analyses.google_web_detection\"><div layout=\"row\"><md-list flex=\"100\" class=\"p-0 bb pointer\" \nng-click=\"googleWebDetection=!googleWebDetection\"><md-list-item class=\"md-toolbar-tools grey-100-bg p-0-i\"><div \nlayout=\"row\" layout-align=\"space-between center\" flex=\"100\"><h3 class=\"grey-700-fg ph-25\" \ntranslate=\"MEDIA.CROPPROCESS.GOOGLE_WEB_DETECTION\"></h3><md-button class=\"md-icon-button\"><md-icon \nng-if=\"!googleWebDetection\" md-font-icon=\"icon-chevron-right\" class=\"mh-5\"></md-icon><md-icon \nng-if=\"googleWebDetection\" md-font-icon=\"icon-chevron-down\" class=\"mh-5\"></md-icon></md-button></div></md-list-item>\n</md-list></div><div class=\"p-10\" layout=\"column\" flex=\"100\" ng-show=\"googleWebDetection\" \nng-repeat=\"(key, item) in vm.image.meta_analyses.google_web_detection\"><div layout=\"row\" flex=\"100\" class=\"p-10\">\n{{key}}: {{item}}</div><md-divider ng-if=\"!$last\"></md-divider></div></div><div \nng-if=\"vm.image.meta_analyses.rekognition_detect_faces\"><div layout=\"row\"><md-list flex=\"100\" class=\"p-0 bb pointer\" \nng-click=\"rekognitionDetectFaces=!rekognitionDetectFaces\"><md-list-item class=\"md-toolbar-tools grey-100-bg p-0-i\"><div\n layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><h3 class=\"grey-700-fg ph-25\" \ntranslate=\"MEDIA.CROPPROCESS.REKOGNITION_DETECT_FACES\"></h3><md-button class=\"md-icon-button\"><md-icon \nng-if=\"!rekognitionDetectFaces\" md-font-icon=\"icon-chevron-right\" class=\"mh-5\"></md-icon><md-icon \nng-if=\"rekognitionDetectFaces\" md-font-icon=\"icon-chevron-down\" class=\"mh-5\"></md-icon></md-button></div>\n</md-list-item></md-list></div><div class=\"p-10\" layout=\"column\" flex=\"100\" ng-show=\"rekognitionDetectFaces\" \nng-repeat=\"item in vm.image.meta_analyses.rekognition_detect_faces.FaceDetails\"><div ng-repeat=\"(key, item) in item\">\n<div layout=\"row\" flex=\"100\" class=\"p-10\">{{key}}: {{item}}</div></div><md-divider ng-if=\"!$last\"></md-divider></div>\n</div><div ng-if=\"vm.image.meta_analyses.rekognition_detect_labels\"><div layout=\"row\"><md-list flex=\"100\" \nclass=\"p-0 bb pointer\" ng-click=\"rekognitionDetectLabels=!rekognitionDetectLabels\"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg p-0-i\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><h3 \nclass=\"grey-700-fg ph-25\" translate=\"MEDIA.CROPPROCESS.REKOGNITION_DETECT_LABELS\"></h3><md-button \nclass=\"md-icon-button\"><md-icon ng-if=\"!rekognitionDetectLabels\" md-font-icon=\"icon-chevron-right\" class=\"mh-5\">\n</md-icon><md-icon ng-if=\"rekognitionDetectLabels\" md-font-icon=\"icon-chevron-down\" class=\"mh-5\"></md-icon></md-button>\n</div></md-list-item></md-list></div><div class=\"p-10\" layout=\"column\" flex=\"100\" ng-show=\"rekognitionDetectLabels\" \nng-repeat=\"(key, item) in vm.image.meta_analyses.rekognition_detect_labels\"><div layout=\"row\" flex=\"100\" class=\"p-10\">\n{{key}}: {{item}}</div><md-divider ng-if=\"!$last\"></md-divider></div></div><div \nng-if=\"vm.image.meta_analyses.rekognition_detect_moderation_labels\"><div layout=\"row\"><md-list flex=\"100\" \nclass=\"p-0 bb pointer\" ng-click=\"rekognitionDetectModLabels=!rekognitionDetectModLabels\"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg p-0-i\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><h3 \nclass=\"grey-700-fg ph-25\" translate=\"MEDIA.CROPPROCESS.REKOGNITION_DETECT_MOD_FACES\"></h3><md-button \nclass=\"md-icon-button\"><md-icon ng-if=\"!rekognitionDetectModLabels\" md-font-icon=\"icon-chevron-right\" class=\"mh-5\">\n</md-icon><md-icon ng-if=\"rekognitionDetectModLabels\" md-font-icon=\"icon-chevron-down\" class=\"mh-5\"></md-icon>\n</md-button></div></md-list-item></md-list></div><div class=\"p-10\" layout=\"column\" flex=\"100\" \nng-show=\"rekognitionDetectModLabels\" \nng-repeat=\"(key, item) in vm.image.meta_analyses.rekognition_detect_moderation_labels\"><div layout=\"row\" flex=\"100\" \nclass=\"p-10\">{{key}}: {{item}}</div><md-divider ng-if=\"!$last\"></md-divider></div></div><div \nng-if=\"vm.image.meta_analyses.rekognition_detect_text\"><div layout=\"row\"><md-list flex=\"100\" class=\"p-0 bb pointer\" \nng-click=\"rekognitionDetectText=!rekognitionDetectText\"><md-list-item class=\"md-toolbar-tools grey-100-bg p-0-i\"><div \nlayout=\"row\" layout-align=\"space-between center\" flex=\"100\"><h3 class=\"grey-700-fg ph-25\" \ntranslate=\"MEDIA.CROPPROCESS.REKOGNITION_DETECT_TEXT\"></h3><md-button class=\"md-icon-button\"><md-icon \nng-if=\"!rekognitionDetectText\" md-font-icon=\"icon-chevron-right\" class=\"mh-5\"></md-icon><md-icon \nng-if=\"rekognitionDetectText\" md-font-icon=\"icon-chevron-down\" class=\"mh-5\"></md-icon></md-button></div></md-list-item>\n</md-list></div><div class=\"p-10\" layout=\"column\" flex=\"100\" ng-show=\"rekognitionDetectText\" \nng-repeat=\"item in vm.image.meta_analyses.rekognition_detect_text.TextDetections\"><div ng-repeat=\"(key, item) in item\">\n<div layout=\"row\" flex=\"100\" class=\"p-10\">{{key}}: {{item}}</div></div><md-divider ng-if=\"!$last\"></md-divider></div>\n</div><div ng-if=\"vm.image.meta_analyses.rekognition_recognize_celebrities\"><div layout=\"row\"><md-list flex=\"100\" \nclass=\"p-0 bb pointer\" ng-click=\"rekognitionRecognizeCelebrities=!rekognitionRecognizeCelebrities\"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg p-0-i\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><h3 \nclass=\"grey-700-fg ph-25\" translate=\"MEDIA.CROPPROCESS.REKOGNITION_REKOGNIZE_CELEBS\"></h3><md-button \nclass=\"md-icon-button\"><md-icon ng-if=\"!rekognitionRecognizeCelebrities\" md-font-icon=\"icon-chevron-right\" \nclass=\"mh-5\"></md-icon><md-icon ng-if=\"rekognitionRecognizeCelebrities\" md-font-icon=\"icon-chevron-down\" class=\"mh-5\">\n</md-icon></md-button></div></md-list-item></md-list></div><div class=\"p-10\" layout=\"column\" flex=\"100\" \nng-show=\"rekognitionRecognizeCelebrities\" \nng-repeat=\"(key, item) in vm.image.meta_analyses.rekognition_recognize_celebrities\"><div layout=\"row\" flex=\"100\" \nclass=\"p-10\">{{key}}: {{item}}</div><md-divider ng-if=\"!$last\"></md-divider></div></div><div \nng-if=\"vm.image.meta_analyses.aws_rekognition_person_tracking\"><div layout=\"row\"><md-list flex=\"100\" \nclass=\"p-0 bb pointer\" ng-click=\"personTrackingExpanded=!personTrackingExpanded\"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg p-0-i\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><h3 \nclass=\"grey-700-fg ph-25\" translate=\"MEDIA.METAANALYSES.PERSON_TRACKING\"></h3><md-button class=\"md-icon-button\">\n<md-icon ng-if=\"!personTrackingExpanded\" md-font-icon=\"icon-chevron-right\" class=\"mh-5\"></md-icon><md-icon \nng-if=\"personTrackingExpanded\" md-font-icon=\"icon-chevron-down\" class=\"mh-5\"></md-icon></md-button></div>\n</md-list-item></md-list></div><div class=\"p-10\" layout=\"column\" flex=\"100\" ng-show=\"personTrackingExpanded\" \nng-repeat=\"item in vm.image.meta_analyses.aws_rekognition_person_tracking\"><div ng-repeat=\"(key, item) in item\"><div \nlayout=\"row\" flex=\"100\" class=\"p-10\">{{key}}: {{item}}</div></div><md-divider ng-if=\"!$last\"></md-divider></div></div>\n<div ng-if=\"vm.image.meta_analyses.aws_rekognition_celebrity_recognition\"><div layout=\"row\"><md-list flex=\"100\" \nclass=\"p-0 bb pointer\" ng-click=\"celebRecognitionExpanded=!celebRecognitionExpanded\"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg p-0-i\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><h3 \nclass=\"grey-700-fg ph-25\" translate=\"MEDIA.METAANALYSES.CELEB_RECOGNITION\"></h3><md-button class=\"md-icon-button\">\n<md-icon ng-if=\"!celebRecognitionExpanded\" md-font-icon=\"icon-chevron-right\" class=\"mh-5\"></md-icon><md-icon \nng-if=\"celebRecognitionExpanded\" md-font-icon=\"icon-chevron-down\" class=\"mh-5\"></md-icon></md-button></div>\n</md-list-item></md-list></div><div class=\"p-10\" layout=\"column\" flex=\"100\" ng-show=\"celebRecognitionExpanded\" \nng-repeat=\"item in vm.image.meta_analyses.aws_rekognition_celebrity_recognition\"><div ng-repeat=\"(key, item) in item\">\n<div layout=\"row\" flex=\"100\" class=\"p-10\">{{key}}: {{item}}</div></div><md-divider ng-if=\"!$last\"></md-divider></div>\n</div><div ng-if=\"vm.image.meta_analyses.aws_rekognition_face_detection\"><div layout=\"row\"><md-list flex=\"100\" \nclass=\"p-0 bb pointer\" ng-click=\"faceDetectionExpanded=!faceDetectionExpanded\"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg p-0-i\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><h3 \nclass=\"grey-700-fg ph-25\" translate=\"MEDIA.METAANALYSES.FACE_DETECTION\"></h3><md-button class=\"md-icon-button\"><md-icon\n ng-if=\"!faceDetectionExpanded\" md-font-icon=\"icon-chevron-right\" class=\"mh-5\"></md-icon><md-icon \nng-if=\"faceDetectionExpanded\" md-font-icon=\"icon-chevron-down\" class=\"mh-5\"></md-icon></md-button></div></md-list-item>\n</md-list></div><div class=\"p-10\" layout=\"column\" flex=\"100\" ng-show=\"faceDetectionExpanded\" \nng-repeat=\"item in vm.image.meta_analyses.aws_rekognition_face_detection\"><div ng-repeat=\"(key, item) in item\"><div \nlayout=\"row\" flex=\"100\" class=\"p-10\">{{key}}: {{item}}</div></div><md-divider ng-if=\"!$last\"></md-divider></div></div>\n<div ng-if=\"vm.image.meta_analyses.aws_rekognition_label_detection\"><div layout=\"row\"><md-list flex=\"100\" \nclass=\"p-0 bb pointer\" ng-click=\"labelDetectionExpanded=!labelDetectionExpanded\"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg p-0-i\"><div layout=\"row\" layout-align=\"space-between center\" class=\"flex-100\"><h3 \nclass=\"grey-700-fg ph-25\" translate=\"MEDIA.METAANALYSES.LABEL_DETECTION\"></h3><md-button class=\"md-icon-button\">\n<md-icon ng-if=\"!labelDetectionExpanded\" md-font-icon=\"icon-chevron-right\" class=\"mh-5\"></md-icon><md-icon \nng-if=\"labelDetectionExpanded\" md-font-icon=\"icon-chevron-down\" class=\"mh-5\"></md-icon></md-button></div>\n</md-list-item></md-list></div><div class=\"p-10\" layout=\"column\" flex=\"100\" ng-show=\"labelDetectionExpanded\" \nng-repeat=\"item in vm.image.meta_analyses.aws_rekognition_label_detection\"><div ng-repeat=\"(key, item) in item\"><div \nlayout=\"row\" flex=\"100\" class=\"p-10\">{{key}}: {{item}}</div></div><md-divider ng-if=\"!$last\"></md-divider></div></div>\n<div ng-if=\"vm.image.meta_analyses.rekognition_index_faces\"><div layout=\"row\"><md-list flex=\"100\" \nclass=\"p-0 bb pointer\" ng-click=\"rekognitionIndexFaces=!rekognitionIndexFaces\"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg p-0-i\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><h3 \nclass=\"grey-700-fg ph-25\" translate=\"MEDIA.CROPPROCESS.REKOGNITION_INDEX_FACES\"></h3><md-button class=\"md-icon-button\">\n<md-icon ng-if=\"!rekognitionIndexFaces\" md-font-icon=\"icon-chevron-right\" class=\"mh-5\"></md-icon><md-icon \nng-if=\"rekognitionIndexFaces\" md-font-icon=\"icon-chevron-down\" class=\"mh-5\"></md-icon></md-button></div></md-list-item>\n</md-list></div><div class=\"p-10\" layout=\"column\" flex=\"100\" ng-show=\"rekognitionIndexFaces\" \nng-repeat=\"item in vm.image.meta_analyses.rekognition_index_faces.FaceRecords\"><div><div layout=\"row\" flex=\"100\" \nclass=\"p-10\">{{item.Face.FaceId}}</div></div><md-divider ng-if=\"!$last\"></md-divider></div></div><div \nng-if=\"vm.image.meta_analyses.rekognition_search_faces\"><div layout=\"row\"><md-list flex=\"100\" class=\"p-0 bb pointer\" \nng-click=\"rekognitionSearchFaces=!rekognitionSearchFaces\"><md-list-item class=\"md-toolbar-tools grey-100-bg p-0-i\"><div\n layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><h3 class=\"grey-700-fg ph-25\" \ntranslate=\"MEDIA.CROPPROCESS.REKOGNITION_SEARCH_FACES\"></h3><md-button class=\"md-icon-button\"><md-icon \nng-if=\"!rekognitionSearchFaces\" md-font-icon=\"icon-chevron-right\" class=\"mh-5\"></md-icon><md-icon \nng-if=\"rekognitionSearchFaces\" md-font-icon=\"icon-chevron-down\" class=\"mh-5\"></md-icon></md-button></div>\n</md-list-item></md-list></div><div class=\"p-10\" layout=\"column\" flex=\"100\" ng-show=\"rekognitionSearchFaces\" \nng-repeat=\"(fid, item) in vm.image.meta_analyses.rekognition_search_faces\"><div><div layout=\"row\" flex=\"100\" \nclass=\"p-10\">{{fid}}:<div ng-repeat=\"face in item.FaceMatches\">{{face.Face.FaceId}} ({{face.Similarity}})</div></div>\n</div><md-divider ng-if=\"!$last\"></md-divider></div></div><div ng-if=\"vm.image.meta_analyses.aws_transcription\"><div \nlayout=\"row\"><md-list flex=\"100\" class=\"p-0 bb pointer\" ng-click=\"transcriptionExpanded=!transcriptionExpanded\">\n<md-list-item class=\"md-toolbar-tools grey-100-bg p-0-i\"><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"flex-100\"><h3 class=\"grey-700-fg ph-25\" translate=\"MEDIA.METAANALYSES.TRANSCRIPTION\"></h3><md-button \nclass=\"md-icon-button\"><md-icon ng-if=\"!transcriptionExpanded\" md-font-icon=\"icon-chevron-right\" class=\"mh-5\">\n</md-icon><md-icon ng-if=\"transcriptionExpanded\" md-font-icon=\"icon-chevron-down\" class=\"mh-5\"></md-icon></md-button>\n</div></md-list-item></md-list></div><div class=\"p-10\" layout=\"column\" flex=\"100\" ng-show=\"transcriptionExpanded\" \nng-repeat=\"(key, item) in vm.image.meta_analyses.aws_transcription\"><div layout=\"row\" flex=\"100\" class=\"p-10\" \nng-if=\"key != \'results\'\">{{key}}: {{item}}</div><div ng-if=\"key == \'results\'\" layout=\"column\"><h4>Transcription</h4>\n<div ng-repeat=\"item in item.transcripts\"><div layout=\"row\" flex=\"100\" class=\"p-10\">{{item.transcript}}</div>\n<md-divider></md-divider></div></div><md-divider ng-if=\"!$last\"></md-divider></div></div></div><br><br><div \nlayout=\"row\" ng-if=\"vm.mediaSelected\"><md-list flex=\"100\" class=\"md-toolbar-tools grey-100-bg\" layout=\"row\" \nlayout-align=\"end center\"><md-list-item><md-button type=\"submit\" ng-click=\"vm.saveImage(vm.image)\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"vm.basicForm.$invalid || vm.basicForm.$pristine\" \naria-label=\"SAVE\" translate=\"CONTENT.SAVE\" translate-attr-aria-label=\"CONTENT.SAVE\">SAVE</md-button><md-button \ntype=\"button\" ng-click=\"vm.closeMediaPreview()\" class=\"md-raised md-warn\" aria-label=\"Cancel\">Cancel</md-button>\n</md-list-item></md-list></div></form></div>");
$templateCache.put("app/main/apps/media/views/tabs/tab-cropformats.html","<div id=\"list-content-data\" ng-style=\"{\'opacity\' : isLoading ? 0.2 : 1}\" ng-if=\"vm.showCropformats\"><div \nng-if=\"vm.image.allCropped != 1\" ng-repeat=\"(key, value) in vm.image.cropstatus | groupBy: \'id_container\'\"><div \nflex-gt-sm=\"33\" flex=\"100\" class=\"white-box sections\"><md-list class=\"pt-0\"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg\"><h3 class=\"grey-700-fg\">\nProvider: {{vm.getContainerData(value[0].id_container, \'provider\')}}<br>\n{{vm.getContainerData(value[0].id_container, \'url\')}}</h3><md-divider></md-divider></md-list-item></md-list></div><h3 \nclass=\"grey-700-fg not-cropped-h3\" translate=\"MEDIA.PROCESSING\">Processing...</h3><div \nclass=\"mail-list-item {{attachment.status}}\" ng-repeat=\"attachment in value\" ng-init=\"parentIndex = $index\" md-no-ink \nng-click=\"vm.openattachment(attachment)\"><div layout=\"row\" layout-align=\"start center\"><div flex=\"3\" \nlayout-align=\"center center\" class=\"cropping-image\"><div flex layout-align=\"center center\"><md-icon \nmd-font-icon=\"icon-refresh\" role=\"img\" aria-hidden=\"true\" \nclass=\"md-card-icon s24 md-default.theme md-font material-icons icon-refresh\"></md-icon></div></div><div class=\"info\" \nflex layout=\"column\"><div><div class=\"text-truncate\" layout=\"row\" layout-align=\"start center\"><span><span \nng-if=\"attachment.cropformat.description\">{{attachment.cropformat.description}} /</span> <span \nng-if=\"attachment.cropformat.width\">w: {{attachment.cropformat.width}}px /</span> <span \nng-if=\"attachment.cropformat.height\">h: {{attachment.cropformat.height}}px </span><span \nng-if=\"attachment.cropformat.proportional===1\">/ Proportional</span></span></div></div><div><div \nclass=\"details text-truncate\"><span class=\"title grey-500-fg\" ng-bind=\"attachment.fileName\"></span></div></div></div>\n<div class=\"buttons\" layout=\"row\" layout-align=\"start center\"><div><md-menu><button class=\"md-icon-button\" \naria-label=\"More\" translate translate-attr-aria-label=\"TODO.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\" \nng-click=\"$mdMenu.open($event)\"></md-icon></button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.openImageDialog($event, vm.image.cropstatus, attachment, true)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.PREVIEW\"><md-icon md-font-icon=\"icon-eye\" class=\"s16 ml-10\" href=\"#\" \nng-click=\"vm.openImageDialog($event, vm.selectedMail.Thumbnail, attachment)\"></md-icon><span \ntranslate=\"CONTENT.PREVIEW\">Preview</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.openUrl(attachment.urlImage)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.OPEN_IN_NEW_WINDOW\"><md-icon md-font-icon=\"icon-laptop-windows\" class=\"s18\">\n</md-icon><span translate=\"CONTENT.OPEN_IN_NEW_WINDOW\">Open in new window</span></md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.MediaItemRecropSingleFormat(vm.image.id_media,attachment.id_cropformats)\" \naria-label=\"Toggle done\" translate-attr-aria-label=\"MEDIA.MEDIA_ITEM_RECROP\"><md-icon md-font-icon=\"icon-image\" \nclass=\"s18\"></md-icon><span translate=\"MEDIA.MEDIA_ITEM_RECROP\">Recrop Image</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></div><div layout=\"column\" layout-align=\"space-between end\"></div></div></div></div>\n<div ng-if=\"vm.image.allCropped == 1\" ng-repeat=\"(key, value) in vm.image.cropstatus | groupBy: \'id_container\'\"><div \nflex-gt-sm=\"33\" flex=\"100\" class=\"white-box sections\"><md-list class=\"pt-0\"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg\"><h3 class=\"grey-700-fg\">\nProvider: {{vm.getContainerData(value[0].id_container, \'provider\')}}<br>\n{{vm.getContainerData(value[0].id_container, \'url\')}}</h3><md-divider></md-divider></md-list-item></md-list></div><div \nclass=\"mail-list-item {{attachment.status}}\" ng-repeat=\"attachment in value\" ng-init=\"parentIndex = $index\" md-no-ink \nng-click=\"vm.openattachment(attachment)\"><div layout=\"row\" layout-align=\"start center\"><div flex=\"3\" \nlayout-align=\"center center\"><div flex layout-align=\"center center\"><img class=\"image crop-image\" \nng-click=\"vm.openImageDialog($event, vm.image.cropstatus, attachment, true)\" ng-src=\"{{attachment.urlImage}}\" attr=\"\">\n</div></div><div class=\"info\" flex layout=\"column\"><div><div class=\"text-truncate\" layout=\"row\" \nlayout-align=\"start center\"><span><span ng-if=\"attachment.cropformat.description\">\n{{attachment.cropformat.description}} /</span> <span ng-if=\"attachment.cropformat.width\">\nw: {{attachment.cropformat.width}}px /</span> <span ng-if=\"attachment.cropformat.height\">\nh: {{attachment.cropformat.height}}px </span><span ng-if=\"attachment.cropformat.proportional===1\">/ Proportional</span>\n</span></div></div><div><div class=\"details text-truncate\"><span class=\"title grey-500-fg\" \nng-bind=\"attachment.fileName\"></span></div></div></div><div class=\"buttons\" layout=\"row\" layout-align=\"start center\">\n<div><md-menu><button class=\"md-icon-button\" aria-label=\"More\" translate translate-attr-aria-label=\"TODO.MORE\"><md-icon\n md-font-icon=\"icon-dots-vertical\" ng-click=\"$mdMenu.open($event)\"></md-icon></button><md-menu-content width=\"3\">\n<md-menu-item><md-button ng-click=\"vm.openImageDialog($event, vm.image.cropstatus, attachment, true)\" \naria-label=\"Toggle done\" translate-attr-aria-label=\"CONTENT.PREVIEW\"><md-icon md-font-icon=\"icon-eye\" \nclass=\"s16 ml-10\" href=\"#\" ng-click=\"vm.openImageDialog($event, vm.selectedMail.Thumbnail, attachment)\"></md-icon><span\n translate=\"CONTENT.PREVIEW\">Preview</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.openUrl(attachment.urlImage)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.OPEN_IN_NEW_WINDOW\"><md-icon md-font-icon=\"icon-laptop-windows\" class=\"s18\">\n</md-icon><span translate=\"CONTENT.OPEN_IN_NEW_WINDOW\">Open in new window</span></md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.MediaItemRecropSingleFormat(vm.image.id_media,attachment.id_cropformats)\" \naria-label=\"Toggle done\" translate-attr-aria-label=\"MEDIA.MEDIA_ITEM_RECROP\"><md-icon md-font-icon=\"icon-image\" \nclass=\"s18\"></md-icon><span translate=\"MEDIA.MEDIA_ITEM_RECROP\">Recrop Image</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></div><div layout=\"column\" layout-align=\"space-between end\"></div></div></div></div>\n<div ng-if=\"vm.image.allCropped == 1\" ng-repeat=\"(key, value) in vm.image.cropstatus_videos | groupBy: \'id_container\'\">\n<div flex-gt-sm=\"33\" flex=\"100\" class=\"white-box sections\"><md-list class=\"pt-0\"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg\"><h3 class=\"grey-700-fg\">\nProvider: {{vm.getContainerData(value[0].id_container, \'provider\')}}<br>\n{{vm.getContainerData(value[0].id_container, \'url\')}}</h3><md-divider></md-divider></md-list-item></md-list></div><div \nclass=\"mail-list-item {{attachment.status}}\" ng-repeat=\"attachment in value\" ng-init=\"parentIndex = $index\" md-no-ink \nng-click=\"vm.openattachment(attachment)\"><div layout=\"row\" layout-align=\"start center\"><div flex=\"3\" \nlayout-align=\"center center\"><div flex layout-align=\"center center\"><img class=\"image crop-image\" \nng-click=\"vm.openImageDialog($event, vm.image.cropstatus, attachment, true)\" ng-src=\"{{vm.image.embed_thumb}}\" attr=\"\">\n</div></div><div class=\"info\" flex layout=\"column\"><div><div class=\"text-truncate\" layout=\"row\" \nlayout-align=\"start center\"><span><span ng-if=\"attachment.cropformat.description\">\n{{attachment.cropformat.description}} /</span> <span ng-if=\"attachment.cropformat.width\">\nw: {{attachment.cropformat.width}}px /</span> <span ng-if=\"attachment.cropformat.height\">\nh: {{attachment.cropformat.height}}px </span><span ng-if=\"attachment.cropformat.proportional===1\">/ Proportional</span>\n</span></div></div><div><div class=\"details text-truncate\"><span class=\"title grey-500-fg\" \nng-bind=\"attachment.fileName\"></span></div></div></div><div class=\"buttons\" layout=\"row\" layout-align=\"start center\">\n<div><md-menu><button class=\"md-icon-button\" aria-label=\"More\" translate translate-attr-aria-label=\"TODO.MORE\"><md-icon\n md-font-icon=\"icon-dots-vertical\" ng-click=\"$mdMenu.open($event)\"></md-icon></button><md-menu-content width=\"3\">\n<md-menu-item hide><md-button ng-click=\"vm.openImageDialog($event, [vm.image], attachment, true)\" \naria-label=\"Toggle done\" translate-attr-aria-label=\"CONTENT.PREVIEW\"><md-icon md-font-icon=\"icon-eye\" \nclass=\"s16 ml-10\" href=\"#\" ng-click=\"vm.openImageDialog($event, vm.selectedMail.Thumbnail, attachment)\"></md-icon><span\n translate=\"CONTENT.PREVIEW\">Preview</span></md-button></md-menu-item><md-menu-item ng-if=\"attachment.cropformat.url\">\n<md-button ng-click=\"vm.openUrl(attachment.cropformat.url)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.OPEN_IN_NEW_WINDOW\"><md-icon md-font-icon=\"icon-laptop-windows\" class=\"s18\">\n</md-icon><span translate=\"CONTENT.OPEN_IN_NEW_WINDOW\">Open in new window</span></md-button></md-menu-item>\n<md-menu-item hide><md-button g-click=\"vm.MediaItemRecropSingleFormat(vm.image.id_media,attachment.id_cropformats)\" \naria-label=\"Toggle done\" translate-attr-aria-label=\"MEDIA.MEDIA_ITEM_RECROP\"><md-icon md-font-icon=\"icon-image\" \nclass=\"s18\"></md-icon><span translate=\"MEDIA.MEDIA_ITEM_RECROP\">Recrop Image</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></div><div layout=\"column\" layout-align=\"space-between end\"></div></div></div></div>\n</div><md-list-item ng-repeat=\"mediazone in vm.mediaZones\" ng-if=\"vm.mediaZones\" \nclass=\"list-media-item attachment-edit\"><div class=\"attachments\"><div class=\"field\"><p class=\"grey-500-fg ml-8\">\n{{ mediazone.zone_name }}</p><div class=\"attachment-list sortable md-list-item-text\" ng-sortable=\"vm.mediaSortable\">\n<div class=\"attachment\" layout=\"column\" ng-repeat=\"attachment in vm.thumbnails_Edit[mediazone.id_zone]\"><div \nclass=\"preview document\" layout=\"row\" layout-align=\"start center\" extension-class=\"{{attachment.fileName}}\" \nng-href=\"{{attachment.permalink}}\" ng-if=\"attachment.media_type==3\" target=\"_blank\"><qiu-icon \nmediafile=\"attachment.fileName\" class=\"mr-10\"></qiu-icon><a class=\"grey-1000-fg font-size-16\" \nng-href=\"{{attachment.permalink}}\" target=\"_blank\"><span ng-if=\"attachment.title\">{{attachment.title}}</span> <span \nng-if=\"attachment.fileName\">{{attachment.fileName}}</span></a></div><div \nng-if=\"attachment.media_type==1 || attachment.media_type==2 || attachment.media_type==4\"><div class=\"ms-card\" flex \nmd-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"ms-card-content-wrapper\"><div class=\"template-9\"><div \nclass=\"media media-attachment\" flex layout=\"row\" layout-align=\"center center\" \nng-if=\"attachment.media_type==1 || attachment.media_type==2\"><img class=\"image\" \nng-click=\"vm.openImageDialog($event, vm.currentThread_Edit.Thumbnail, attachment)\" \nng-repeat=\"crop in attachment.cropstatus | limitTo: 1\" ng-src=\"{{crop.container.view_url}}{{crop.fileName}}\" \nng-if=\"attachment.media_type==1\"> <img class=\"image\" \nng-click=\"vm.openImageDialog($event, vm.currentThread_Edit.Thumbnail, attachment)\" ng-src=\"{{attachment.embed_thumb}}\" \nng-if=\"attachment.media_type==2\"><div ng-if=\"attachment.media_type==2\" \nng-click=\"vm.openImageDialog($event, vm.currentThread_Edit.Thumbnail, attachment)\" class=\"fotorama__video-play\" \nstyle=\"opacity:1\"></div></div><div flex layout=\"column\" layout-align=\"center center\" class=\"media\" \nng-if=\"attachment.media_type==4\"><qiu-icon mediafile=\"attachment.fileName\" classextra=\"s56\"></qiu-icon><br><span \nclass=\"grey-500-fg\" layout=\"column\" layout-align=\"center center\"><span ng-if=\"attachment.title\"><strong>\n{{attachment.title}}</strong></span> <span ng-if=\"attachment.fileName\">{{attachment.fileName}}</span></span></div><div \nclass=\"header\" layout=\"row\" layout-align=\"space-between center\"><div class=\"size block\" layout=\"row\" \nlayout-align=\"start center\"><strong class=\"mr-5\">#{{attachment.id_media}}</strong> <span class=\"grey-500-fg\" \nng-if=\"attachment.media_type==1 || attachment.media_type==2\">{{attachment.fileName}}</span></div><md-menu><button \nclass=\"md-icon-button\" aria-label=\"More\" translate translate-attr-aria-label=\"TODO.MORE\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" ng-click=\"$mdMenu.open($event)\"></md-icon></button><md-menu-content width=\"3\">\n<md-menu-item><md-button ng-if=\"attachment.media_type==1 || attachment.media_type==2\" \nng-click=\"vm.openImageDialog($event, vm.currentThread_Edit.Thumbnail, attachment)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.PREVIEW\"><md-icon md-font-icon=\"icon-eye\" class=\"ml-10\" href=\"#\" \nng-click=\"vm.openImageDialog($event, vm.selectedMail.Thumbnail, attachment)\"></md-icon><span \ntranslate=\"CONTENT.PREVIEW\">Preview</span></md-button><md-button ng-if=\"attachment.media_type==4\" \nng-click=\"vm.openUrl(attachment.permalink)\" target=\"_blank\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.PREVIEW\"><md-icon md-font-icon=\"icon-open-in-new\" class=\"ml-10\"></md-icon><span \ntranslate=\"CONTENT.OPEN\">Open</span></md-button></md-menu-item><md-menu-item ng-if=\"attachment.media_type==1\">\n<md-button ng-click=\"vm.openFocalPoint($event, attachment)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.SET_FOCAL_POINT\"><md-icon md-font-icon=\"icon-image-filter-center-focus\" class=\"s18\">\n</md-icon><span translate=\"CONTENT.SET_FOCAL_POINT\">Set Focal point</span></md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"vm.openMediaItemMetadata($event, attachment)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.MEDIA_ITEM_EDIT_METADATA\"><md-icon md-font-icon=\"icon-message-image\" class=\"s18\">\n</md-icon><span translate=\"CONTENT.MEDIA_ITEM_EDIT_METADATA\">Edit Metadata</span></md-button></md-menu-item>\n<md-menu-item ng-if=\"attachment.media_type==1\"><md-button ng-click=\"vm.MediaItemRecrop(attachment)\" \naria-label=\"Toggle done\" translate-attr-aria-label=\"CONTENT.MEDIA_ITEM_RECROP\"><md-icon md-font-icon=\"icon-image\" \nclass=\"s18\"></md-icon><span translate=\"CONTENT.MEDIA_ITEM_RECROP\">Recrop Image</span></md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.deleteAttachment(attachment)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.REMOVE\"><md-icon md-font-icon=\"icon-close\" class=\"s18\"></md-icon><span \ntranslate=\"CONTENT.REMOVE\">Remove</span></md-button></md-menu-item></md-menu-content></md-menu></div></div></div></div>\n</div></div></div><md-button class=\"add-event-button no-sort md-fab md-warn\" \nng-click=\"vm.mediaDialog($event, mediazone, vm.currentThread_Edit)\" aria-label=\"Add event\" translate \ntranslate-attr-aria-label=\"CALENDAR.ADD_EVENT\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div>\n<md-divider></md-divider></md-list-item><md-list-item ng-right-click=\"vm.selectOrUnselect(null, $event)\" \nclass=\"list-media-item attachment-edit\" ng-if=\"vm.mediaZones\"><div class=\"attachments\"><div class=\"field\"><div \nclass=\"attachment-list md-list-item-text\" layout=\"row\" layout-wrap=\"\" layout-align=\"start start\" \nng-sortable=\"vm.mediaSortable\"><div class=\"attachment\" layout=\"column\" ng-repeat=\"attachment in vm.image.cropstatus\">\n<div class=\"preview document\" layout=\"row\" layout-align=\"start center\" extension-class=\"{{attachment.fileName}}\" \nng-href=\"{{attachment.permalink}}\" ng-if=\"attachment.media_type==3\" target=\"_blank\"><qiu-icon \nmediafile=\"attachment.fileName\" class=\"mr-10\"></qiu-icon><a class=\"grey-1000-fg font-size-16\" \nng-href=\"{{attachment.permalink}}\" target=\"_blank\"><span ng-if=\"attachment.title\">{{attachment.title}} </span><span \nng-if=\"attachment.fileName\">{{attachment.fileName}}</span></a></div><div class=\"preview document\" layout=\"row\" \nlayout-align=\"start center\" extension-class=\"{{attachment.fileName}}\" ng-href=\"{{attachment.permalink}}\" \nng-if=\"attachment.media_type==4\" target=\"_blank\"><qiu-icon mediafile=\"attachment.fileName\"></qiu-icon><a \nclass=\"grey-1000-fg font-size-16\" ng-href=\"{{attachment.permalink}}\" target=\"_blank\"><span ng-if=\"attachment.fileName\">\n{{attachment.fileName}} </span></a><a href=\"#\" class=\"md-accent-color link\" translate=\"CONTENT.DOWNLOAD\">Download</a>\n</div><div ng-if=\"vm.image.media_type==1 || vm.image.media_type==2\"><div class=\"ms-card\" flex \nmd-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"ms-card-content-wrapper\"><div class=\"template-9\"><div \nclass=\"media media-attachment\" flex layout=\"row\" layout-align=\"center center\"><img class=\"image\" \nng-click=\"vm.openImageDialog($event, vm.currentThread_Edit.Thumbnail, attachment)\" \nng-src=\"{{attachment.container.view_url}}{{attachment.fileName}}\" ng-if=\"vm.image.media_type==1 && !attachment.grid\" \nattr=\"algo1\"> <img class=\"image\" ng-click=\"vm.openImageDialog($event, vm.currentThread_Edit.Thumbnail, attachment)\" \nng-src=\"{{attachment.container.view_url}}{{attachment.grid}}/{{attachment.fileName}}\" \nng-if=\"vm.image.media_type==1 && attachment.grid\" attr=\"algo1\"> <img class=\"image\" \nng-click=\"vm.openImageDialog($event, vm.currentThread_Edit.Thumbnail, attachment)\" \nng-src=\"{{attachment.container.view_url}}\" ng-if=\"attachment.media_type==1\" attr=\"algo\"><div \nng-if=\"attachment.media_type==2\" ng-click=\"vm.openImageDialog($event, vm.currentThread_Edit.Thumbnail, attachment)\" \nclass=\"fotorama__video-play\" style=\"opacity:1\"></div></div><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"size block\" layout=\"row\" layout-align=\"start center\"><strong \nclass=\"mr-5\">#{{attachment.id_media}}</strong> <span class=\"grey-500-fg\">{{attachment.fileName}}</span></div><md-menu>\n<button class=\"md-icon-button\" aria-label=\"More\" translate translate-attr-aria-label=\"TODO.MORE\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" ng-click=\"$mdMenu.open($event)\"></md-icon></button><md-menu-content width=\"3\">\n<md-menu-item><md-button ng-click=\"vm.openImageDialog($event, vm.image.cropstatus, attachment, true)\" \naria-label=\"Toggle done\" translate-attr-aria-label=\"CONTENT.PREVIEW\"><md-icon md-font-icon=\"icon-eye\" \nclass=\"s16 ml-10\" href=\"#\" ng-click=\"vm.openImageDialog($event, vm.selectedMail.Thumbnail, attachment)\"></md-icon><span\n translate=\"CONTENT.PREVIEW\">Preview</span></md-button></md-menu-item><md-menu-item ng-if=\"attachment.media_type==1\">\n<md-button ng-click=\"vm.openFocalPoint($event, attachment)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.SET_FOCAL_POINT\"><md-icon md-font-icon=\"icon-image-filter-center-focus\" class=\"s18\">\n</md-icon><span translate=\"CONTENT.SET_FOCAL_POINT\">Set Focal point</span></md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"vm.openMediaItemMetadata($event, attachment)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.MEDIA_ITEM_EDIT_METADATA\"><md-icon md-font-icon=\"icon-message-image\" class=\"s18\">\n</md-icon><span translate=\"CONTENT.MEDIA_ITEM_EDIT_METADATA\">Edit Metadata</span></md-button></md-menu-item>\n<md-menu-item ng-if=\"attachment.media_type==1\"><md-button ng-click=\"vm.MediaItemRecrop(attachment)\" \naria-label=\"Toggle done\" translate-attr-aria-label=\"CONTENT.MEDIA_ITEM_RECROP\"><md-icon md-font-icon=\"icon-image\" \nclass=\"s18\"></md-icon><span translate=\"CONTENT.MEDIA_ITEM_RECROP\">Recrop Image</span></md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.deleteAttachment(attachment)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.REMOVE\"><md-icon md-font-icon=\"icon-close\" class=\"s18\"></md-icon><span \ntranslate=\"CONTENT.REMOVE\">Remove</span></md-button></md-menu-item></md-menu-content></md-menu></div></div></div></div>\n</div></div></div></div></div><md-divider></md-divider></md-list-item>");
$templateCache.put("app/main/apps/media/views/tabs/tab-edit.html","<div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><form name=\"vm.basicForm\" class=\"md-inline-form\" novalidate><div\n layout=\"column\" layout-gt-md=\"row\" class=\"media-edit-top\"><div flex=\"100\" flex-gt-md=\"60\" flex-gt-lg=\"50\" \nclass=\"media-card sections\" layout-gt-md=\"row\" layout-align><div flex=\"100\"><md-input-container class=\"md-block\" \nflexss><div class=\"ms-card\" flex><div class=\"ms-card-content-wrapper\"><div class=\"template-9\" layout=\"column\" \nlayout-align=\"space-between stretch\"><div class=\"media\" \nng-class=\"{\'file\': vm.image.media_type==4,\'audio\': vm.image.media_type==3}\" flex layout=\"column\" \nlayout-align=\"center center\"><media attachment=\"vm.image\" class-img=\"image\" ng-if=\"vm.image.media_type ==1\"></media>\n<media attachment=\"vm.image\" class-img=\"image\" embed=\"true\" ng-if=\"vm.image.media_type ==2\"></media><media \nattachment=\"vm.image\" class-img=\"image\" embed=\"true\" ng-if=\"vm.image.media_type ==3\"></media><media \nattachment=\"vm.image\" class-img=\"image\" embed=\"true\" ng-if=\"vm.image.media_type ==4\"></media></div><div \nclass=\"header p-16\" flex><div layout=\"row\" layout-align=\"center center\" ng-if=\"vm.mediaSelected\"><md-button \naria-label=\"Preview\" class=\"md-icon-button\" ng-click=\"vm.openImageDialog($event, vm.image, false, false, true)\" \ntranslate=\"\" translate-attr-aria-label=\"CONTENT.PREVIEW\" ng-if=\"vm.image.media_type ==1 || vm.image.media_type ==2\">\n<md-icon md-font-icon=\"icon-eye\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.PREVIEW\">Preview</span>\n</md-tooltip></md-button><md-button aria-label=\"Preview\" class=\"md-icon-button\" \nng-click=\"vm.openUrl(vm.image.imageUrlOriginal	)\" translate=\"\" translate-attr-aria-label=\"CONTENT.OPEN_IN_NEW_WINDOW\">\n<md-icon md-font-icon=\"icon-laptop-windows\"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate=\"CONTENT.OPEN_IN_NEW_WINDOW\">Open in new window</span></md-tooltip></md-button><md-button \nng-if=\"!vm.image.embed\" aria-label=\"Preview\" class=\"md-icon-button\" ng-click=\"vm.copyLink(vm.image.imageUrlOriginal)\" \ntranslate=\"\" translate-attr-aria-label=\"CONTENT.COPY_LINK\"><md-icon md-font-icon=\"icon-content-copy\"></md-icon>\n<md-tooltip hide show-gt-xs><span translate=\"CONTENT.COPY_LINK\">Copy link</span></md-tooltip></md-button><md-button \nng-if=\"vm.image.media_type == 2 && vm.image.cropstatus_videos.length > 0\" aria-label=\"Preview\" class=\"md-icon-button\" \nng-click=\"vm.copyVideoLink(vm.image)\" translate=\"\" translate-attr-aria-label=\"CONTENT.COPY_LINK\"><md-icon \nmd-font-icon=\"icon-content-copy\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.COPY_LINK\">Copy link\n</span></md-tooltip></md-button><md-button aria-label=\"Preview\" class=\"md-icon-button\" \nng-click=\"vm.openFocalPoint($event,vm.image)\" translate=\"\" translate-attr-aria-label=\"CONTENT.SET_FOCAL_POINT\" \nng-if=\"vm.image.media_type ==1\"><md-icon md-font-icon=\"icon-image-filter-center-focus\"></md-icon><md-tooltip hide \nshow-gt-xs><span translate=\"CONTENT.SET_FOCAL_POINT\">Set Focal Point</span></md-tooltip></md-button><md-button \nng-if=\"vm.image.media_type != 1\" aria-label=\"Preview\" class=\"md-icon-button\" \nng-click=\"vm.changeVideoThumb($event, vm.image)\" translate=\"\" translate-attr-aria-label=\"CONTENT.CHANGE_THUMB\"><md-icon\n md-font-icon=\"icon-picture\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.CHANGE_THUMB\">\nOpen in new window</span></md-tooltip></md-button><md-button aria-label=\"Preview\" class=\"md-icon-button\" \nng-click=\"vm.rekognitionDialog($event, vm.image, \'TRANSCRIPTION\')\" translate=\"\" \ntranslate-attr-aria-label=\"MEDIA.TRANSCRIPTION\" ng-if=\"vm.image.media_type ==2\"><md-icon \nmd-font-icon=\"icon-format-color\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"MEDIA.TRANSCRIPTION\">\nTRANSCRIPTION</span></md-tooltip></md-button><md-button aria-label=\"Preview\" class=\"md-icon-button\" \nng-click=\"vm.rekognitionDialog($event, vm.image, \'REKOGNITION\')\" translate=\"\" \ntranslate-attr-aria-label=\"MEDIA.REKOGNITION\" ng-if=\"vm.image.media_type ==2\"><md-icon md-font-icon=\"icon-people\">\n</md-icon><md-tooltip hide show-gt-xs><span translate=\"MEDIA.REKOGNITION\">REKOGNITION</span></md-tooltip></md-button>\n<md-button aria-label=\"Preview\" class=\"md-icon-button\" ng-click=\"vm.MediaItemRecropAllFormats(vm.image.id_media)\" \ntranslate=\"\" translate-attr-aria-label=\"MEDIA.RECROP_PHOTO\" ng-if=\"vm.image.media_type ==1\"><md-icon \nmd-font-icon=\"icon-crop\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"MEDIA.RECROP_PHOTO\">Recrop photo</span>\n</md-tooltip></md-button><md-button aria-label=\"Preview\" class=\"md-icon-button\" \nng-click=\"vm.AddmediaDialog($event,null,vm.image, true)\" translate=\"\" translate-attr-aria-label=\"MEDIA.RECROP_PHOTO\">\n<md-icon md-font-icon=\"icon-box-upload\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"MEDIA.RELOAD_PHOTO\">\nReload photo</span></md-tooltip></md-button><md-menu ng-if=\"vm.image.media_type == 2\"><button class=\"md-icon-button\" \naria-label=\"More\" translate translate-attr-aria-label=\"TODO.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\" \nng-click=\"$mdMenu.open($event)\"></md-icon></button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.joinClipsWindow($event, vm.image )\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"MATCH_CENTER.JOIN_CLIP\"><md-icon md-font-icon=\"icon-view-week\" class=\"s18 ml-10\" href=\"#\">\n</md-icon><span translate=\"MATCH_CENTER.JOIN_CLIP\"></span></md-button></md-menu-item></md-menu-content></md-menu><div \nclass=\"divider-vertical\" hide=\"\" show-gt-sm=\"\" ng-if=\"vm.ActiveSection.web_preview\"></div><md-button aria-label=\"Spam\" \nclass=\"md-icon-button\" ng-click=\"\" translate=\"\" translate-attr-aria-label=\"CONTENT.LIVE\" \nng-if=\"vm.ActiveSection.web_preview\"><md-icon md-font-icon=\"icon-web\"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate=\"CONTENT.LIVE\">Live Preview</span></md-tooltip></md-button><md-menu hide=\"\"><md-button \naria-label=\"Mail Actions\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.ACTIONS\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button aria-label=\"Archive\" translate-attr-aria-label=\"CONTENT.ARCHIVE\">\n<md-icon md-font-icon=\"icon-archive\"></md-icon><span translate=\"CONTENT.ARCHIVE\">Archive</span></md-button>\n</md-menu-item><md-menu-item><md-button aria-label=\"Spam\" translate-attr-aria-label=\"CONTENT.SPAM\"><md-icon \nmd-font-icon=\"icon-alert-octagon\"></md-icon><span translate=\"CONTENT.SPAM\">Spam</span></md-button></md-menu-item>\n<md-menu-item><md-button aria-label=\"Delete\" translate-aria-label=\"CONTENT.DELETE\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon><span translate=\"CONTENT.DELETE\">Delete</span></md-button></md-menu-item><md-menu-item><md-button \naria-label=\"Move To\" translate-attr-aria-label=\"CONTENT.MOVE_TO\"><md-icon md-font-icon=\"icon-folder-move\"></md-icon>\n<span translate=\"CONTENT.MOVE_TO\">Move To</span></md-button></md-menu-item><md-menu-item><md-button \naria-label=\"Labels\" translate-attr-aria-label=\"CONTENT.LABELS\"><md-icon md-font-icon=\"icon-label\"></md-icon><span \ntranslate=\"CONTENT.LABELS\">Labels</span></md-button></md-menu-item></md-menu-content></md-menu></div></div></div></div>\n</div></md-input-container></div></div><div flex=\"100\" flex-gt-md=\"40\" flex-gt-lg=\"50\" class=\"sections\"><div class=\"\">\n<md-input-container class=\"md-block\" flexss><label translate=\"CONTENT.ID\">ID</label><h3 class=\"mt-0\"><strong>\n# {{vm.image.id_media}}</strong></h3><label translate=\"CONTENT.FILENAME\" ng-if=\"vm.image.filename\">Filename</label><h3 \nclass=\"mt-0 word-break-word\" ng-if=\"vm.image.filename\"><strong>{{vm.image.filename}}</strong></h3><label \ntranslate=\"CONTENT.TITLE\" ng-if=\"vm.image.title && !vm.image.filename\">Title</label><h3 class=\"mt-0\" \nng-if=\"vm.image.title && !vm.image.filename\"><strong>{{vm.image.title}}</strong></h3><div layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"vm.image.size || vm.image.fileSizeKb\"><div ng-if=\"vm.image.size\"><label \ntranslate=\"MEDIA.DIMENSIONS\">Dimensions</label><h3 class=\"mt-0\"><strong>{{vm.image.size}}</strong></h3></div><div \nng-if=\"vm.image.fileSizeKb\"><label translate=\"MEDIA.SIZE_KB\">Size</label><h3 class=\"mt-0\"><strong>\n{{vm.image.fileSizeKb}} Kb</strong></h3></div></div><label translate=\"MEDIA.DATE_UPLOADED\">Date uploaded</label><h3 \nclass=\"mt-0\"><strong>{{vm.image.date_uploaded.dateShow}}</strong></h3></md-input-container></div></div></div><div \nlayout=\"column\" layout-xs=\"column\"><div layout=\"row\"><md-list flex=\"100\"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg\"><h3 class=\"grey-700-fg\" translate=\"CONTENT.LATESTACTIVITY\">Publishing Settings\n</h3></md-list-item></md-list></div><div layout=\"row\"><div flex=\"100\" layout=\"row\" class=\"layout-wrap\"><div \nflex-gt-sm=\"100\" flex=\"100\"><md-input-container class=\"md-block\"><label translate=\"CONTENT.TITLE\">Title</label>\n<textarea ng-model=\"vm.image.title\" columns=\"1\" rows=\"1\" placeholder=\"{{vm.translate(\'CONTENT.TITLE\')}}\"></textarea>\n</md-input-container></div><div flex-gt-sm=\"50\" flex=\"100\"><md-input-container class=\"md-block\"><label \ntranslate=\"CONTENT.PHOTOGRAPHER\">Photographer</label><textarea ng-model=\"vm.image.photographer\" columns=\"1\" rows=\"1\" \nplaceholder=\"{{vm.translate(\'CONTENT.PHOTOGRAPHER\')}}\"></textarea></md-input-container></div><div flex-gt-sm=\"50\" \nflex=\"100\"><md-input-container class=\"md-block\"><label translate=\"CONTENT.CREDITS\">Credits</label><textarea \nng-model=\"vm.image.credits\" columns=\"1\" rows=\"1\" placeholder=\"{{vm.translate(\'CONTENT.CREDITS\')}}\"></textarea>\n</md-input-container></div><div flex-gt-sm=\"50\" flex=\"100\"><md-input-container class=\"md-block\"><label \ntranslate=\"CONTENT.OWNER\">Owner</label><textarea ng-model=\"vm.image.owner\" columns=\"1\" rows=\"1\" \nplaceholder=\"{{vm.translate(\'CONTENT.OWNER\')}}\"></textarea></md-input-container></div><div flex-gt-sm=\"100\" flex=\"100\">\n<md-input-container class=\"md-block\"><label translate=\"CONTENT.CAPTION\">Caption</label><textarea \nng-model=\"vm.image.caption\" columns=\"1\" rows=\"1\" placeholder=\"{{vm.translate(\'CONTENT.CAPTION\')}}\"></textarea>\n</md-input-container></div><div flex-gt-sm=\"50\" flex=\"100\"><md-input-container class=\"md-block\"><label \ntranslate=\"CONTENT.CITY\">City</label><input ng-model=\"vm.image.city\" type=\"text\" \nplaceholder=\"{{vm.translate(\'CONTENT.CITY\')}}\"></md-input-container></div><div flex-gt-sm=\"50\" flex=\"100\">\n<md-input-container class=\"md-block\"><label translate=\"CONTENT.COUNTRY\">Country</label><input \nng-model=\"vm.image.country\" type=\"text\" placeholder=\"{{vm.translate(\'CONTENT.COUNTRY\')}}\"></md-input-container></div>\n<div flex-gt-sm=\"50\" flex=\"100\"><md-input-container class=\"md-block\"><label translate=\"CONTENT.USE\">Use</label><input \nng-model=\"vm.image.uses\" type=\"text\" placeholder=\"{{vm.translate(\'CONTENT.USE\')}}\"></md-input-container></div><div \nflex-gt-sm=\"50\" flex=\"100\"><md-input-container class=\"md-block\" ng-hide=\"vm.image.media_type == 2\"><label \ntranslate=\"CONTENT.EXTRAS\">Extras</label><input ng-model=\"vm.image.extra\" type=\"text\" \nplaceholder=\"{{vm.translate(\'CONTENT.EXTRAS\')}}\"></md-input-container></div><div flex-gt-sm=\"50\" flex=\"100\">\n<md-input-container class=\"md-block\"><label translate=\"CONTENT.RATING\">Rating</label><qiu-rating-stars max-rating=\"5\" \nng-click=\"vm.basicForm.$pristine? vm.basicForm.$pristine = false : \'\'\" rating=\"vm.image.rating\" \nread-only=\"ctrl.readOnly\" on-rating=\"ctrl.onRating(rating)\"></qiu-rating-stars></md-input-container></div></div></div>\n<div layout=\"column\"><div layout=\"column\" layout-gt-sm=\"column\" class=\"date-time-picker\"><div flex><label>File date\n</label></div><div layout=\"column\" layout-gt-sm=\"row\"><div flex-gt-sm=\"66\" flex=\"100\" layout=\"row\"><div flex \nclass=\"date-container date\"><mdp-date-picker mdp-placeholder=\"Date\" mdp-format=\"{{vm.dateFormat}}\" \nmdp-open-on-click=\"true\" ng-model=\"vm.image.file_date.date\" ng-change=\"vm.updateDatePicker(\'file_date\')\">\n</mdp-date-picker></div><div flex class=\"date-container time\"><mdp-time-picker mdp-placeholder=\"Time\" \nmdp-auto-switch=\"true\" mdp-open-on-click=\"true\" ng-model=\"vm.image.file_date.date\" \nng-change=\"vm.updateDatePicker(\'file_date\')\"></mdp-time-picker></div></div><div flex-gt-sm=\"33\" flex=\"100\"><div flex \nclass=\"date-container utc\"><md-input-container class=\"md-block\"><label>UTC Date</label><input type=\"text\" \nng-model=\"vm.image.file_date.utcShow\" disabled=\"disabled\"></md-input-container></div></div></div></div><div \nlayout=\"column\" layout-gt-sm=\"column\" class=\"date-time-picker\"><div flex><label translate=\"MEDIA.DATE_UPLOADED\">\n</label></div><div layout=\"column\" layout-gt-sm=\"row\"><div flex-gt-sm=\"66\" flex=\"100\" layout=\"row\"><div flex \nclass=\"date-container date\"><mdp-date-picker mdp-placeholder=\"Date\" mdp-format=\"{{vm.dateFormat}}\" \nmdp-open-on-click=\"true\" ng-model=\"vm.image.date_uploaded.date\" ng-change=\"vm.updateDatePicker(\'date_uploaded\')\">\n</mdp-date-picker></div><div flex class=\"date-container time\"><mdp-time-picker mdp-placeholder=\"Time\" \nmdp-auto-switch=\"true\" mdp-open-on-click=\"true\" ng-model=\"vm.image.date_uploaded.date\" \nng-change=\"vm.updateDatePicker(\'date_uploaded\')\"></mdp-time-picker></div></div><div flex-gt-sm=\"33\" flex=\"100\"><div \nflex class=\"date-container utc\"><md-input-container class=\"md-block\"><label>UTC Date</label><input type=\"text\" \nng-model=\"vm.image.date_uploaded.utcShow\" disabled=\"disabled\"></md-input-container></div></div></div></div></div><div \nlayout=\"row\" ng-if=\"vm.mediaRefMetadata && vm.mediaRefMetadata.length > 0\"><md-list flex=\"100\"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg\"><h3 class=\"grey-700-fg\" translate=\"CONTENT.METADATA\">METADATA</h3></md-list-item>\n</md-list></div><div layout=\"row\" ng-if=\"vm.mediaRefMetadata && vm.mediaRefMetadata.length > 0\"><div flex=\"100\" \nlayout=\"row\" class=\"layout-wrap\"><div flex-gt-sm=\"50\" flex=\"100\" \nng-repeat=\"ref in vm.mediaRefMetadata | orderBy: \'edit_sort\'\" \nng-init=\"value = vm.parseDotNotation(vm.image, ref.title)\" ng-show=\"ref.media_type == 1 && value\"><md-input-container \nclass=\"md-block\"><label>{{ref.field_name}}</label><textarea disabled=\"disabled\" columns=\"1\" rows=\"1\" \nplaceholder=\"{{ref.field_name}}\">{{value}}</textarea></md-input-container></div></div></div><div layout=\"row\"><md-list \nflex=\"100\"><md-list-item class=\"md-toolbar-tools grey-100-bg\"><h3 class=\"grey-700-fg\" \ntranslate=\"CONTENT.GEOLOCALIZATION\">Geolocation</h3></md-list-item></md-list></div><div layout=\"row\"><div \nflex-gt-sm=\"50\" flex=\"100\"><md-input-container><label translate=\"CONTENT.GEOLAT\">ID</label><input \nng-model=\"vm.image.geoLat\" type=\"text\" placeholder=\"{{vm.translate(\'CONTENT.GEOLAT\')}}\"></md-input-container></div><div\n flex-gt-sm=\"50\" flex=\"100\"><md-input-container><label translate=\"CONTENT.GEOLON\">ID</label><input \nng-model=\"vm.image.geoLon\" type=\"text\" placeholder=\"{{vm.translate(\'CONTENT.GEOLON\')}}\"></md-input-container></div>\n</div><div layout=\"row\"><md-list flex=\"100\"><md-list-item class=\"md-toolbar-tools grey-100-bg\"><div layout=\"row\" \nlayout-align=\"start center\" class=\"flex-50\"><h3 class=\"grey-700-fg\" translate=\"CONTENT.FOCAL_POINT\">Focal point</h3>\n</div><div layout=\"row\" layout-align=\"end center\" class=\"flex-50\"><md-button aria-label=\"Preview\" \nclass=\"md-icon-button\" ng-click=\"vm.openFocalPoint($event,vm.image)\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.PREVIEW\" ng-if=\"vm.image.media_type ==1\"><md-icon \nmd-font-icon=\"icon-image-filter-center-focus\"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate=\"CONTENT.SET_FOCAL_POINT\">Set Focal Point</span></md-tooltip></md-button></div></md-list-item></md-list>\n</div><div layout=\"row\"><div flex-gt-sm=\"50\" flex=\"100\"><md-input-container><label \ntranslate=\"CONTENT.IMAGE_CENTER_RATIO_X\">X</label><input ng-model=\"vm.image.imageCenterRatioX\" type=\"text\" \nplaceholder=\"{{vm.translate(\'CONTENT.IMAGE_CENTER_RATIO_X\')}}\"></md-input-container></div><div flex-gt-sm=\"50\" \nflex=\"100\"><md-input-container><label translate=\"CONTENT.IMAGE_CENTER_RATIO_Y\">Y</label><input \nng-model=\"vm.image.imageCenterRatioY\" type=\"text\" placeholder=\"{{vm.translate(\'CONTENT.IMAGE_CENTER_RATIO_Y\')}}\">\n</md-input-container></div></div><div layout=\"row\"><md-list flex=\"100\"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg\"><h3 class=\"grey-700-fg\" translate=\"CONTENT.TAGS\">Tags</h3></md-list-item>\n</md-list></div><div layout=\"row\"><div flex=\"100\" class=\"tags\"><div ng-repeat=\"type in vm.tagsTypes\"><div \nclass=\"label-container\"><md-icon md-font-icon=\"{{type.icon}}\" role=\"img\" aria-hidden=\"true\" class=\"md-card-icon s24\">\n</md-icon><label>{{type.name}}</label></div><md-input-container class=\"md-block\"><md-chips \nclass=\"label-chips close-chip\" ng-model=\"vm.image.tagsWithTypes[type.name]\" md-autocomplete-snap \nmd-require-match=\"true\"><md-autocomplete md-min-length=\"3\" md-selected-item=\"vm.selectedTag\" \nmd-selected-item-change=\"vm.selectedItemChange(type.searcher)\" md-search-text=\"vm[type.searcher]\" \nmd-items=\"tag in vm.labelQuerySearch(vm[type.searcher], type.id_type) | orderBy:\'-order\'\" md-item-text=\"tag.tag_name\" \nmd-no-cache=\"true\" placeholder=\"{{vm.translate(\'GLOBAL.SEARCH_FOR_TAG\')}}\" ng-model-options=\"{debounce: 500}\" \nmd-dropdown-items=\"10\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\" \nclass=\"tag-not-found-bg border-bottom\"><span ng-if=\"!tag.tag_name\">{{vm[type.searcher]}}</span> <span \nmd-highlight-text=\"vm[type.searcher]\" ng-if=\"tag.tag_name\">{{tag.tag_name}}</span><small> (#{{tag.id_tag}})</small>\n<md-buttton ng-if=\"!tag.tag_name\" ng-click=\"vm.newTag(vm[type.searcher], type)\" \nclass=\"md-accent green-500-bg white-fg md-button m-0\"><span translate=\"CONTENT.TAGADD\"></span></md-buttton></div>\n<md-not-found><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\" class=\"tag-not-found-bg\"><span>\n{{vm[type.searcher]}}</span><md-buttton ng-click=\"vm.newTag(vm[type.searcher], type)\" \nclass=\"md-accent green-500-bg white-fg md-button m-0\"><span translate=\"CONTENT.TAGADD\"></span></md-buttton></div>\n</md-not-found></md-autocomplete><md-chip-template><div class=\"md-chip-content\"><span ng-if=\"$chip.color\" \nclass=\"color\" ng-style=\"{\'background-color\':$chip.color}\"></span> <span>{{$chip.tag_name}}</span><small>\n (#{{$chip.id_tag}})</small></div></md-chip-template><button md-chip-remove class=\"md-primary\" layout=\"row\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-close\"></md-icon></button></md-chips></md-input-container>\n</div><div class=\"label-container\"><label>All tags</label></div><md-input-container class=\"md-block\"><label \ntranslate=\"GLOBAL.SEARCH_FOR_TAG\">Tags</label><md-chips class=\"label-chips close-chip\" ng-model=\"vm.image.tags\" \nmd-autocomplete-snap md-require-match=\"true\"><md-autocomplete md-min-length=\"3\" md-selected-item=\"vm.selectedTag\" \nmd-selected-item-change=\"vm.selectedItemChange()\" md-search-text=\"vm.searchTagText\" \nmd-items=\"tag in vm.labelQuerySearch(vm.searchTagText) | orderBy:\'-order\'\" md-item-text=\"tag.tag_name\" \nmd-no-cache=\"true\" placeholder=\"{{vm.translate(\'GLOBAL.SEARCH_FOR_TAG\')}}\" ng-model-options=\"{debounce: 500}\" \nmd-dropdown-items=\"10\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\" \nclass=\"tag-not-found-bg border-bottom\"><span ng-if=\"!tag.tag_name\">{{vm.searchTagText}}</span> <span \nmd-highlight-text=\"vm.searchTagText\" ng-if=\"tag.tag_name\">{{tag.tag_name}}</span><small> (#{{tag.id_tag}})</small>\n<md-buttton ng-if=\"!tag.tag_name\" ng-click=\"vm.newTag(vm.searchTagText)\" \nclass=\"md-accent green-500-bg white-fg md-button m-0\"><span translate=\"CONTENT.TAGADD\"></span></md-buttton></div>\n<md-not-found><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\" class=\"tag-not-found-bg\"><span>\n{{vm.searchTagText}}</span><md-buttton ng-click=\"vm.newTag(vm.searchTagText)\" \nclass=\"md-accent green-500-bg white-fg md-button m-0\"><span translate=\"CONTENT.TAGADD\"></span></md-buttton></div>\n</md-not-found></md-autocomplete><md-chip-template><div class=\"md-chip-content\"><span ng-if=\"$chip.color\" \nclass=\"color\" ng-style=\"{\'background-color\':$chip.color}\"></span> <span>{{$chip.tag_name}}</span><small>\n (#{{$chip.id_tag}})</small></div></md-chip-template><button md-chip-remove class=\"md-primary\" layout=\"row\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-close\"></md-icon></button></md-chips></md-input-container>\n</div></div></div><br><br><div layout=\"row\" ng-if=\"vm.mediaSelected\"><md-list flex=\"100\" \nclass=\"md-toolbar-tools grey-100-bg\" layout=\"row\" layout-align=\"end center\"><md-list-item><md-button type=\"submit\" \nng-click=\"vm.saveImage(vm.image)\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.basicForm.$invalid || vm.basicForm.$pristine\" aria-label=\"SAVE\" translate=\"CONTENT.SAVE\" \ntranslate-attr-aria-label=\"CONTENT.SAVE\">SAVE</md-button><md-button type=\"button\" ng-click=\"vm.closeMediaPreview()\" \nclass=\"md-raised md-warn\" aria-label=\"Cancel\">Cancel</md-button></md-list-item></md-list></div></form></div>");
$templateCache.put("app/main/apps/media/views/tabs/tab-galleries.html","<md-content ms-scroll=\"vm.msScrollOptions\" class=\"\" flex><md-toolbar \nclass=\"md-default-theme grey-100-bg grey-600-fg pr-16 pl-16\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" style=\"width: 100%\"><label for=\"search-bar-input\"><md-icon ng-if=\"!vm.treeSearch\" \nmd-font-icon=\"icon-magnify\" class=\"grey-600-fg md-icon-button md-button\"><md-tooltip hide show-gt-xs><span \ntranslate=\"TOOLBAR.SEARCH\">Search</span></md-tooltip></md-icon><md-icon ng-if=\"vm.treeSearch\" \nmd-font-icon=\"icon-close-circle\" class=\"grey-600-fg md-icon-button md-button\" ng-click=\"vm.treeSearch = null\">\n</md-icon></label><input type=\"text\" id=\"search-bar-input\" class=\"grey-600-fg grey-100-bg\" ng-model=\"vm.treeSearch\" \nplaceholder=\"Search\" md-autofocus translate translate-attr-placeholder=\"TOOLBAR.SEARCH\" flex><md-menu><button \naria-label=\"Filters\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" show-gt-xs=\"\" translate=\"\" \ntranslate-attr-aria-label=\"\"><md-icon md-font-icon=\"m-0 grey-600-fg icon-chevron-down\"><md-tooltip><span \ntranslate=\"MEDIA.COLLAPSE_OR_EXPAND\">Collapse or expand</span></md-tooltip></md-icon></button><md-menu-content \nwidth=\"4\"><md-menu-item ng-repeat=\"(key, value) in vm.collapseAndExpand\"><md-button aria-label=\"All\" \nng-click=\"vm.collapseAndExpandValue=value; vm.collapseAndExpandFunction()\"><div layout=\"row\" \nlayout-align=\"space-between center\"><span>{{key | translate}}</span></div></md-button></md-menu-item></md-menu-content>\n</md-menu></div></md-toolbar><div class=\"navigation-simple groups-tree pt-20 pb-20\" layout=\"column\"><div \nng-if=\"vm.CleanMediaGalleriesWithMediaAssignment\" ivh-treeview=\"vm.CleanMediaGalleriesWithMediaAssignment\" \nivh-treeview-label-attribute=\"\'gallery_name\'\" ivh-treeview-expand-to-depth=\"0\" ivh-treeview-filter=\"vm.treeSearch\" \nclass=\"ivh-treeview-folder small\"><script type=\"text/ng-template\">\n<div class=\"level-card p-8 gallery-row\" ng-style=\"{opacity: !node.assigned_gallery ? \'.3\' : \'1\'}\" layout=\"row\" layout-align=\"space-between center\">\r\n                    <span ivh-treeview-twistie ivh-treeview-toggle layout=\"row\" layout-align=\"center center\"></span>\r\n                    <div flex layout=\"row\" layout-align=\"start center\">\r\n                        <!-- One icon resolved in the controller (node.gallery_icon), instead of\r\n                             ten ng-if\'d md-icon: those were ten watchers on every gallery of\r\n                             the tree, evaluated on each digest. -->\r\n                        <md-icon\r\n                            ng-if=\"::node.gallery_icon\"\r\n                            md-font-icon=\"{{::node.gallery_icon}}\"\r\n                            class=\"s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <div class=\"group-status green-bg\" ng-if=\"node.status ===1\" role=\"button\" aria-label=\"group-status\"></div>\r\n                        <span class=\"ivh-treeview-node-label ng-binding\">{{node.gallery_name}}</span>\r\n\r\n                    </div>\r\n                    <div layout=\"row\" layout-align=\"end center\">\r\n                        <md-checkbox\r\n                            qiu-on-check-set-basic-form-dirty\r\n                            ng-disabled=\"node.no_files_allowed\"\r\n                            qiu-on-check-selected\r\n                            ng-checked=\"node.assigned_gallery\"\r\n                            aria-label=\"{{node.assigned_gallery ? \'Deselect\' : \'Select\'}}\"\r\n                            class=\"ml-5 mb-0\"\r\n                            ng-click=\"node.assigned_gallery = !node.assigned_gallery\"\r\n                        ></md-checkbox>\r\n                    </div>\r\n                </div>\r\n                <!-- Children only while the branch is open. ivh-treeview puts the whole tree\r\n                     in the dom and merely hides the closed branches with css, which on a\r\n                     tenant with a thousand galleries meant tens of thousands of nodes alive\r\n                     on every media selection. -->\r\n                <div ivh-treeview-children ng-if=\"trvw.isExpanded(node)\"></div>\n</script></div></div></md-content>");
$templateCache.put("app/main/apps/media/views/tabs/tab-related.html","<div ng-if=\"vm.facesRelated\" fill-width layout=\"column\"><md-list class=\"p-0 bb\"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg ph-25\">{{vm.translate(\'MEDIA.RELATED_PICTURES\')}}</md-list-item></md-list><div \nclass=\"grid-view\" flex md-cols=\"2\"><div \nng-click=\"vm.openFacesRelatedInImageDialog($event, vm.facesRelated,mediaItem.media, false, true)\" \nng-repeat=\"mediaItem in vm.facesRelated\" data-id=\"{{mediaItem.media.id_media}}\" class=\"ms-card grid-element sortable\">\n<div class=\"ms-card-content-wrapper\"><div class=\"template-9\" layout=\"column\" layout-align=\"space-between stretch\"><div \nclass=\"media\" flex layout=\"row\" layout-align=\"center center\"><media attachment=\"mediaItem.media\" class-img=\"image\">\n</media></div><div class=\"header p-16\" flex><div layout=\"row\" layout-align=\"space-between center\" flex><div \nng-if=\"vm.media_type_name != \'Image Rekognition\'\" class=\"size block\" layout=\"row\" layout-align=\"start left\"><strong \nclass=\"mr-5\">#{{mediaItem.media.id_media}}</strong> <span class=\"grey-500-fg\"><span ng-if=\"mediaItem.media.filename\" \nclass=\"filename\">{{mediaItem.media.filename}}</span></span></div><div \nng-if=\"vm.media_type_name == \'Image Rekognition\'\" class=\"size block\" layout=\"row\" layout-align=\"start left\"><strong \nng-if=\"!vm.isProcessingItem(mediaItem.media)\"><span \nng-repeat=\"text in mediaItem.media.meta_analyses.rekognition_detect_text.TextDetectionsUnique | filter: filterByNumNotCurrentYears track by $index\">\n{{text.DetectedText}}<span ng-if=\"!$last\">,</span></span> </strong><strong style=\"color: red; font-weight: bold\" \nng-if=\"vm.isProcessingItem(mediaItem.media)\">PROCESANDO</strong></div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/apps/mediahub/dialogs/add-media-galleries/add-media-galleries.html","<md-dialog class=\"medium attachment-dialog\" aria-label=\"Add to Gallery\"><form class=\"md-inline-form\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\"><a \nclass=\"md-button\" layout=\"row\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-folder-upload\" \nclass=\"s18 mr-5 ml-0\"></md-icon><span translate=\"MEDIA.ADDTOGALLERIES\">Add to gallery</span></a></div><div \nlayout=\"row\"><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></div></md-toolbar><md-dialog-content ms-scroll flex \nclass=\"content-card\"><md-toolbar class=\"md-default-theme grey-100-bg grey-600-fg pr-16 pl-16\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" flex><label for=\"mediahub-gallery-search\"><md-icon \nng-if=\"!vm.treeSearch\" md-font-icon=\"icon-magnify\" class=\"grey-600-fg md-icon-button md-button search\"><md-tooltip \nhide show-gt-xs><span translate=\"TOOLBAR.SEARCH\">Search</span></md-tooltip></md-icon><md-icon \nlayout-align=\"end center\" md-font-icon=\"icon-close-circle\" class=\"grey-600-fg md-icon-button md-button\" \nng-if=\"vm.treeSearch\" ng-click=\"vm.treeSearch = null\"></md-icon></label><input type=\"text\" \nid=\"mediahub-gallery-search\" class=\"grey-600-fg grey-100-bg\" ng-model=\"vm.treeSearch\" placeholder=\"Search\" \nmd-autofocus translate translate-attr-placeholder=\"TOOLBAR.SEARCH\" flex></div></md-toolbar><md-content ms-scroll flex>\n<div flex layout=\"column\" layout-align=\"center center\" ng-show=\"vm.isLoading\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nclass=\"navigation-simple groups-tree pt-20 pb-20\" layout=\"column\" ng-style=\"{\'opacity\' : vm.isLoading ? 0.2 : 1}\"><div \nng-if=\"vm.CleanMediaGalleries\" ivh-treeview=\"vm.CleanMediaGalleries\" ivh-treeview-label-attribute=\"\'name\'\" \nivh-treeview-filter=\"vm.treeSearch\" ivh-treeview-expand-to-depth=\"0\" class=\"ivh-treeview-folder small\"><script \ntype=\"text/ng-template\">\n<div class=\"level-card p-8 gallery-row\" layout=\"row\" layout-align=\"space-between stretch\">\r\n                                <span ivh-treeview-twistie ivh-treeview-toggle layout=\"row\" layout-align=\"center center\"></span>\r\n                                <div flex layout=\"row\" layout-align=\"start center\">\r\n                                    <md-icon\r\n                                        ng-if=\"!node.children && node.gallery_type == 0\"\r\n                                        md-font-icon=\"icon-folder\"\r\n                                        class=\"s24 mr-10 mt-0 ml-0 mb-0\"\r\n                                        aria-hidden=\"true\">\r\n                                    </md-icon>\r\n                                    <md-icon\r\n                                        ng-if=\"!node.children && node.gallery_type == 1\"\r\n                                        md-font-icon=\"icon-folder-image\"\r\n                                        class=\"s24 mr-10 mt-0 ml-0 mb-0\"\r\n                                        aria-hidden=\"true\">\r\n                                    </md-icon>\r\n                                    <md-icon\r\n                                        ng-if=\"!node.children && node.gallery_type == 2\"\r\n                                        md-font-icon=\"qiu-icon-video-folder\"\r\n                                        class=\"s24 mr-10 mt-0 ml-0 mb-0\"\r\n                                        aria-hidden=\"true\">\r\n                                    </md-icon>\r\n                                    <md-icon\r\n                                        ng-if=\"!node.children && node.gallery_type == 3\"\r\n                                        md-font-icon=\"qiu-icon-audio-folder\"\r\n                                        class=\"s24 mr-10 mt-0 ml-0 mb-0\"\r\n                                        aria-hidden=\"true\">\r\n                                    </md-icon>\r\n                                    <md-icon\r\n                                        ng-if=\"!node.children && node.gallery_type == 4\"\r\n                                        md-font-icon=\"qiu-icon-file-folder\"\r\n                                        class=\"s24 mr-10 mt-0 ml-0 mb-0\"\r\n                                        aria-hidden=\"true\">\r\n                                    </md-icon>\r\n                                    <md-icon\r\n                                        ng-if=\"node.children && node.gallery_type == 0\"\r\n                                        md-font-icon=\"icon-folder-multiple\"\r\n                                        class=\"s24 mr-10 mt-0 ml-0 mb-0\"\r\n                                        aria-hidden=\"true\">\r\n                                    </md-icon>\r\n                                    <md-icon\r\n                                        ng-if=\"node.children && node.gallery_type == 1\"\r\n                                        md-font-icon=\"icon-folder-multiple-image\"\r\n                                        class=\"s24 mr-10 mt-0 ml-0 mb-0\"\r\n                                        aria-hidden=\"true\">\r\n                                    </md-icon>\r\n                                    <md-icon\r\n                                        ng-if=\"node.children && node.gallery_type == 2\"\r\n                                        md-font-icon=\"qiu-icon-video-gallery\"\r\n                                        class=\"s24 mr-10 mt-0 ml-0 mb-0\"\r\n                                        aria-hidden=\"true\">\r\n                                    </md-icon>\r\n                                    <md-icon\r\n                                        ng-if=\"node.children && node.gallery_type == 3\"\r\n                                        md-font-icon=\"qiu-icon-audio-gallery\"\r\n                                        class=\"s24 mr-10 mt-0 ml-0 mb-0\"\r\n                                        aria-hidden=\"true\">\r\n                                    </md-icon>\r\n                                    <md-icon\r\n                                        ng-if=\"node.children && node.gallery_type == 4\"\r\n                                        md-font-icon=\"qiu-icon-file-gallery\"\r\n                                        class=\"s24 mr-10 mt-0 ml-0 mb-0\"\r\n                                        aria-hidden=\"true\">\r\n                                    </md-icon>\r\n                                    <span class=\"ivh-treeview-node-label ng-binding\">{{node.name}}</span>\r\n                                </div>\r\n                                <div layout=\"row\" layout-align=\"end center\">\r\n                                    <md-checkbox\r\n                                        ng-disabled=\"node.is_qiu_restricted_root || node.no_files_allowed\"\r\n                                        ng-checked=\"node.assigned_gallery\"\r\n                                        class=\"ml-5 mb-0\"\r\n                                        aria-label=\"{{node.assigned_gallery ? \'Deselect\' : \'Select\'}}\"\r\n                                        ng-click=\"node.assigned_gallery = !node.assigned_gallery\"\r\n                                    ></md-checkbox>\r\n                                </div>\r\n                            </div>\r\n                            <div ivh-treeview-children></div>\n</script></div></div></md-content></md-dialog-content><md-dialog-actions layout=\"row\" flex layout-align=\"end center\">\n<md-button ng-click=\"vm.saveMediaGalleries()\" class=\"send-button md-accent md-raised\" aria-label=\"Add\" \nng-disabled=\"vm.isLoading\" translate=\"MEDIA.ADD\">ADD</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/mediahub/dialogs/edit-multiple-fields/edit-multiple-fields-form.html","<div layout=\"column\" layout-gt-sm=\"row\" flex><div flex=\"100\" flex-gt-sm=\"50\" layout=\"column\" class=\"pr-16\" \nng-if=\"vm.showGeoDates\"><div \nng-include=\"\'app/main/apps/mediahub/dialogs/edit-multiple-fields/views/set-geolocation.html\'\"></div><md-input-container\n class=\"md-block\"><label translate=\"MEDIA.LATITUDE\">Latitude</label><input type=\"number\" step=\"any\" \nng-model=\"vm.mediaData.geoLat\" ng-change=\"vm.updateMapFromInputs()\"></md-input-container><md-input-container \nclass=\"md-block\"><label translate=\"MEDIA.LONGITUDE\">Longitude</label><input type=\"number\" step=\"any\" \nng-model=\"vm.mediaData.geoLon\" ng-change=\"vm.updateMapFromInputs()\"></md-input-container></div><div flex=\"100\" \nng-attr-flex-gt-sm=\"{{vm.showGeoDates ? \'50\' : \'100\'}}\" layout=\"column\" ng-class=\"{\'pl-16\': vm.showGeoDates}\">\n<md-input-container class=\"md-block\" ng-if=\"vm.showTitle\"><label translate=\"MEDIA.TITLE\">Title</label><input \ntype=\"text\" ng-model=\"vm.mediaData.title\"></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"MEDIA.PHOTOGRAPHER\">Photographer</label><input type=\"text\" ng-model=\"vm.mediaData.photographer\">\n</md-input-container><md-input-container class=\"md-block\"><label translate=\"MEDIA.OWNER\">Owner</label><input \ntype=\"text\" ng-model=\"vm.mediaData.owner\"></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"MEDIA.CAPTION\">Caption</label><input type=\"text\" ng-model=\"vm.mediaData.caption\"></md-input-container><div \nlayout=\"row\" layout-align=\"start center\" ng-if=\"vm.showGeoDates\"><md-input-container class=\"md-block\" flex><label \ntranslate=\"MEDIA.FILE_DATE\">File Date</label><input type=\"datetime-local\" ng-model=\"vm.mediaData.fileDate\" \nng-change=\"vm.markModified(\'fileDate\')\"></md-input-container><md-button class=\"md-icon-button clear-field-button\" \nng-click=\"vm.clearField(\'fileDate\')\" aria-label=\"Clear File Date\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n<md-tooltip><span translate=\"CONTENT.CLEAR\">Clear</span></md-tooltip></md-button></div><div layout=\"row\" \nlayout-align=\"start center\" ng-if=\"vm.showGeoDates\"><md-input-container class=\"md-block\" flex><label \ntranslate=\"MEDIA.DATE_UPLOADED\">Date Uploaded</label><input type=\"datetime-local\" ng-model=\"vm.mediaData.dateUploaded\" \nng-change=\"vm.markModified(\'dateUploaded\')\"></md-input-container><md-button class=\"md-icon-button clear-field-button\" \nng-click=\"vm.clearField(\'dateUploaded\')\" aria-label=\"Clear Date Uploaded\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n<md-tooltip><span translate=\"CONTENT.CLEAR\">Clear</span></md-tooltip></md-button></div><div class=\"tags mt-16\"><div \nclass=\"tags-mode\" layout=\"row\" layout-align=\"start center\" ng-if=\"vm.showTagMode\"><md-radio-group \nng-model=\"vm.tagMode\" layout=\"row\" layout-align=\"start center\"><md-radio-button value=\"add\" class=\"md-primary mr-16\">\n{{ \'MEDIA.TAGS_ADD\' | translate }}</md-radio-button><md-radio-button value=\"replace\" class=\"md-primary\">\n{{ \'MEDIA.TAGS_REPLACE\' | translate }}</md-radio-button></md-radio-group></div><md-input-container class=\"md-block\">\n<label translate=\"GLOBAL.SEARCH_FOR_TAG\">Tags</label><md-chips class=\"label-chips close-chip\" \nng-model=\"vm.currentTags\" md-autocomplete-snap md-require-match=\"true\"><md-autocomplete md-min-length=\"3\" \nmd-selected-item=\"vm.selectedTag\" md-selected-item-change=\"vm.selectedItemChange()\" md-search-text=\"vm.searchTagText\" \nmd-items=\"tag in vm.labelQuerySearch(vm.searchTagText) | orderBy:\'-order\'\" md-item-text=\"tag.tag_name\" \nmd-no-cache=\"true\" placeholder=\"{{vm.translate(\'GLOBAL.SEARCH_FOR_TAG\')}}\" ng-model-options=\"{debounce: 500}\" \nmd-dropdown-items=\"10\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\" \nclass=\"tag-not-found-bg border-bottom\"><span ng-if=\"!tag.tag_name\">{{vm.searchTagText}}</span> <span \nmd-highlight-text=\"vm.searchTagText\" ng-if=\"tag.tag_name\">{{tag.tag_name}}</span><md-button ng-if=\"!tag.tag_name\" \nng-click=\"vm.newTag(vm.searchTagText)\" class=\"md-accent green-500-bg white-fg md-button m-0\"><span \ntranslate=\"CONTENT.TAGADD\"></span></md-button></div><md-not-found><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"100\" class=\"tag-not-found-bg\"><span>{{vm.searchTagText}}</span><md-button \nng-click=\"vm.newTag(vm.searchTagText)\" class=\"md-accent green-500-bg white-fg md-button m-0\"><span \ntranslate=\"CONTENT.TAGADD\"></span></md-button></div></md-not-found></md-autocomplete><md-chip-template><div \nclass=\"md-chip-content\"><span ng-if=\"$chip.color\" class=\"color\" ng-style=\"{\'background-color\':$chip.color}\"></span> \n<span>{{$chip.tag_name}} <span ng-if=\"$chip.id_tag\">#{{$chip.id_tag}}</span></span></div></md-chip-template><button \nmd-chip-remove class=\"md-primary\" layout=\"row\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></button></md-chips></md-input-container></div></div></div>");
$templateCache.put("app/main/apps/mediahub/dialogs/edit-multiple-fields/edit-multiple-fields.html","<md-dialog class=\"large attachment-dialog edit-multiple-fields-dialog\" aria-label=\"Edit Multiple Fields\"><form \nname=\"vm.editForm\" class=\"md-inline-form\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\"><a class=\"md-button\" type=\"import\" layout=\"row\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-tooltip-edit\" class=\"s18 mr-5 ml-0\"></md-icon><span>\nEdit Multiple fields</span></a></div><div layout=\"row\"><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-aria-label=\"CONTENT.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></div></md-toolbar><md-dialog-content \nclass=\"content-card mediadialog-content edit-multiple-fields-content\"><div class=\"md-dialog-content p-24\"><div \nng-include=\"\'app/main/apps/mediahub/dialogs/edit-multiple-fields/edit-multiple-fields-form.html\'\"></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\" ng-if=\"!vm.isLoading\"><md-button \nng-click=\"vm.save()\" class=\"send-button md-accent md-raised\" aria-label=\"Send\" translate=\"CONTENT.SAVE\" \ntranslate-attr-aria-label=\"CONTENT.SAVE\" ng-disabled=\"vm.isLoading\">SAVE</md-button></md-dialog-actions><div \nclass=\"loader-overlay\" ng-if=\"vm.isLoading\" layout=\"row\" layout-align=\"center center\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div></form></md-dialog>");
$templateCache.put("app/main/apps/mediahub/dialogs/media/delete-media-dialog.html","<md-dialog class=\"delete-dialog compose-dialog\" aria-label=\"DELETE\"><md-dialog-content><div ng-if=\"vm.isLoading\" \nclass=\"loading-container\" flex layout=\"column\" layout-align=\"center center\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div ng-if=\"vm.mediaRelations\"><h2 \nng-if=\"vm.selectedThreads.length == 1\" translate=\"CONTENT.SURE_DELETED_SINGULAR\" class=\"mt-0 mb-0 pb-10\"></h2><h2 \nng-if=\"vm.selectedThreads.length > 1\" translate=\"CONTENT.SURE_DELETED_PLURAL\" class=\"mt-0 mb-0 pb-10\"></h2><p \nng-if=\"vm.selectedThreads.length == 1\" translate=\"MEDIA.SOME_USED_IN_SINGULAR\" \nclass=\"grey-700-fg font-size-16 mt-0 mb-0 pb-10\"></p><p ng-if=\"vm.selectedThreads.length > 1\" \ntranslate=\"MEDIA.SOME_USED_IN_PLURAL\" class=\"grey-700-fg font-size-16 mt-0 mb-0 pb-10\"></p><div \nclass=\"md-dialog-content-body ng-scope\"><div ng-repeat=\"media in vm.mediaRelations\" \nclass=\"border-top pt-20 mt-20 mb-0\" layout=\"row\" layout-align=\"start center\" \nng-if=\"media.content.length >0 || media.galleries.length > 0\"><media attachment=\"media\" \nclass-img=\"square w-80 image avatar\"></media><div class=\"font-size-14\"><strong>Media #{{media.id_media}}</strong><span \nng-if=\"media.title\"> - {{media.title}}</span><p class=\"mt-5 grey-600-fg mb-0\"><span \nng-repeat=\"content in media.content\" class=\"flex block\"><strong>{{content.section | capitalize}}:</strong>\n {{content.title}} (#{{content.id}})</span> <span ng-repeat=\"gallery in media.galleries\" class=\"flex block\"><strong>\n{{vm.translate(\'MEDIA.GALLERY\')}}:</strong> {{gallery.gallery_name | capitalize}}</span></p></div></div><div \nng-repeat=\"media in vm.mediaRelations\" class=\"border-top pt-20 mt-20 mb-0 opacity-5\" layout=\"row\" \nlayout-align=\"start center\" ng-if=\"media.content.length == 0 && media.galleries.length == 0\"><media attachment=\"media\" \nclass-img=\"square w-80 image avatar \"></media><div class=\"font-size-14\"><strong>Media #{{media.id_media}}</strong><span\n ng-if=\"media.title\"> - {{media.title}}</span><p class=\"mt-5 grey-500-fg mb-0\"><strong translate=\"MEDIA.NOT_USED\">\n</strong></p></div></div></div></div></md-dialog-content><md-dialog-actions><md-button class=\"send-button md-raised\" \ntranslate=\"MEDIA.CANCEL\" aria-label=\"CANCEL\" ng-click=\"vm.cancel()\"></md-button><md-button \nclass=\"send-button md-warn md-raised\" translate=\"MEDIA.DELETE\" aria-label=\"DELETE\" ng-click=\"vm.delete()\"></md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/mediahub/dialogs/media/media-dialog-tinymce.html","<md-dialog class=\"attachment-dialog add-media\" aria-label=\"New Message\"><form class=\"md-inline-form\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nhide show-gt-xs><a class=\"md-button\" type=\"1\" layout=\"row\" layout-align=\"center center\" \nng-click=\"vm.changeViewTiny(\'1\')\"><md-icon md-font-icon=\"icon-file-image-box\" class=\"s18 mr-5 ml-0\"></md-icon><span>\nAttached Media</span></a></div><div layout=\"row\" hide-gt-xs show-xs><md-menu><md-button aria-label=\"Filters\" \nng-click=\"$mdMenu.open($event)\" translate=\"\" translate-attr-aria-label=\"CONTENT.FILTERS\"><span layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-file-image-box\" class=\"s18 mr-5 ml-0\"></md-icon><span \nclass=\"ml-5\">Images</span> <i class=\"icon-chevron-down s20 ml-5\"></i></span></md-button><md-menu-content width=\"3\">\n<md-menu-item><md-button type=\"photos\" ng-click=\"vm.changeViewTiny(\'1\')\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div><md-icon md-font-icon=\"icon-file-image-box\" class=\"s18\"></md-icon><span>Images\n</span></div><i class=\"icon-check s16\" ng-if=\"sortfield.titleId == sortable.titleId\"></i></div></md-button>\n</md-menu-item></md-menu-content></md-menu></div><div layout=\"row\"><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate translate-aria-label=\"CONTENT.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></div></md-toolbar><div flex \nng-include=\"\'app/main/dialogs/mediahub/views/templates/toolbar-search.html\'\"></div><md-dialog-content \nclass=\"mediadialog-content scrollable\" layout-fill ms-scroll><treasure-overlay-spinner active=\"vm.loading\"><div \nlayout=\"column\" flex><md-content flex class=\"content-card\" ng-class=\"vm.currentViewTiny\" \nng-include=\"vm.viewsTiny[vm.currentViewTiny]\" md-no-ink></md-content></div></treasure-overlay-spinner>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\" ng-if=\"!vm.loading\"><div \nlayout=\"row\" layout-align=\"start center\"></div><div layout=\"row\" layout-align=\"end right\"><md-button \nng-click=\"vm.attachMediaTiny()\" class=\"send-button md-accent md-raised\" aria-label=\"Send\" translate=\"CONTENT.ADD_FILE\" \ntranslate-attr-aria-label=\"CONTENT.ADD_FILE\">ADD</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/mediahub/dialogs/media/media-dialog.html","<md-dialog class=\"attachment-dialog add-media\" aria-label=\"New Message\"><form class=\"md-inline-form\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nhide show-gt-xs><a class=\"md-button\" type=\"upload\" layout=\"row\" layout-align=\"center center\" \nng-click=\"vm.changeView(\'upload\')\"><md-icon md-font-icon=\"icon-import\" class=\"s18 mr-5 ml-0\"></md-icon><span>Upload\n</span> </a><a class=\"md-button\" type=\"import\" layout=\"row\" layout-align=\"center center\" \nng-click=\"vm.changeView(\'import\')\"><md-icon md-font-icon=\"icon-import\" class=\"s18 mr-5 ml-0\"></md-icon><span>\nWeb Address (URL)</span></a></div><div layout=\"row\" hide-gt-xs show-xs><md-menu><md-button aria-label=\"Filters\" \nng-click=\"$mdMenu.open($event)\" translate=\"\" translate-attr-aria-label=\"CONTENT.FILTERS\"><span layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-file-image-box\" class=\"s18 mr-5 ml-0\"></md-icon><span \nclass=\"ml-5\" ng-if=\"vm.currentView===\'upload\'\">Upload</span> <span class=\"ml-5\" ng-if=\"vm.currentView===\'import\'\">\nWeb Address (URL)</span> <i class=\"icon-chevron-down s20 ml-5\"></i></span></md-button><md-menu-content width=\"3\">\n<md-menu-item><md-button type=\"upload\" ng-click=\"vm.changeView(\'upload\')\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div><md-icon md-font-icon=\"icon-import\" class=\"s18\"></md-icon><span>Upload</span>\n</div><i class=\"icon-check s16\" ng-if=\"vm.currentView===\'upload\'\"></i></div></md-button></md-menu-item><md-menu-item>\n<md-button type=\"import\" ng-click=\"vm.changeView(\'import\')\"><div layout=\"row\" layout-align=\"space-between center\"><div>\n<md-icon md-font-icon=\"icon-import\" class=\"s18\"></md-icon><span>Web Address (URL)</span></div><i \nclass=\"icon-check s16\" ng-if=\"vm.currentView===\'import\'\"></i></div></md-button></md-menu-item></md-menu-content>\n</md-menu></div><div layout=\"row\"><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" tranlate translate-aria-label=\"CONTENT.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></div></md-toolbar><div flex layout=\"column\" layout-align=\"center center\" \nng-show=\"vm.isAttaching \" class=\"loading-container\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\">\n</md-progress-circular></div><md-dialog-content ng-if=\"vm.currentView != \'upload\'\" ms-scroll=\"vm.msScrollOptions\" flex \nclass=\"scrollable content-card\" ng-class=\"vm.currentView\" ng-include=\"vm.views[vm.currentView]\" \nng-style=\"{\'opacity\' : vm.isAttaching ? 0.2 : 1}\"></md-dialog-content><md-dialog-content \nng-if=\"vm.currentView == \'upload\'\" flex class=\"content-card\" ng-class=\"vm.currentView\" \nng-include=\"vm.views[vm.currentView]\" ng-style=\"{\'opacity\' : vm.isAttaching ? 0.2 : 1}\"></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\" ng-if=\"!vm.loading\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button ng-if=\"vm.currentView == \'upload\'  && !vm.isReplace\" \nng-click=\"vm.attachMedia()\" class=\"send-button md-raised\" aria-label=\"Send\" translate=\"MEDIA.FORCE_UPLOAD\" \ntranslate-attr-aria-label=\"MEDIA.FORCE_UPLOAD\">FORCE UPLOAD</md-button></div><div layout=\"row\" \nlayout-align=\"end center\"><md-button ng-if=\"vm.currentView == \'upload\'  && !vm.isReplace\" \nng-disabled=\"vm.uploadFiles.length == 0 || vm.uploadedFiles.length != vm.uploadFiles.length || vm.isAttaching\" \nng-click=\"vm.attachMedia()\" class=\"send-button md-accent md-raised\" aria-label=\"Send\" translate=\"MEDIA.DONE\" \ntranslate-attr-aria-label=\"MEDIA.DONE\">DONE</md-button><md-button \nng-if=\"vm.currentView == \'import\'  && !vm.isReplace && !vm.importPreview\" ng-disabled=\"vm.importedFiles.length == 0\" \nng-click=\"vm.attachMedia()\" class=\"send-button md-accent md-raised\" aria-label=\"Send\" translate=\"MEDIA.DONE\" \ntranslate-attr-aria-label=\"MEDIA.DONE\">DONE</md-button><md-button \nng-if=\"vm.currentView == \'import\' && vm.importPreview\" class=\"send-button md-accent md-raised\" \nng-click=\"vm.importConfirm(1)\" aria-label=\"Import\" translate=\"MEDIA.IMPORT\" translate-attr-aria-label=\"MEDIA.IMPORT\">\nImport</md-button><md-button ng-if=\"vm.isReplace\" \nng-disabled=\"vm.uploadFiles.length == 0 || vm.uploadedFiles.length != vm.uploadFiles.length || vm.isAttaching\" \nng-click=\"vm.attachMedia()\" class=\"send-button md-accent md-raised\" aria-label=\"Send\" translate=\"MEDIA.SAVE\" \ntranslate-attr-aria-label=\"MEDIA.SAVE\">SAVE</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/mediahub/dialogs/media/mh-media-dialog.html","<md-dialog class=\"mediahub-media-dialog attachment-dialog add-media\" aria-label=\"Mediahub Media Selection\" \nstyle=\"max-height: 90vh; width: 90vw; max-width: 1200px\"><form class=\"md-inline-form\" flex layout=\"column\" \nstyle=\"height: 100%\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-camera\" \nclass=\"mr-16\"></md-icon><span class=\"md-subhead\" translate=\"MEDIA.SELECT_COVER_IMAGE\">Select Cover Image</span></div>\n<div layout=\"row\"><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></div></md-toolbar><md-content flex layout=\"row\" \nclass=\"full-height p-0\" style=\"overflow: hidden\"><md-sidenav md-is-locked-open=\"true\" \nclass=\"sidenav groups-tree white-bg border-right\" style=\"width: 280px; min-width: 280px; overflow-y: auto\"><div \nclass=\"p-16 border-bottom\"><span class=\"md-subhead font-weight-500\">Galleries</span></div><md-list \nclass=\"p-0 m-0 cursor-pointer\"><md-list-item ng-click=\"vm.selectGalleryId(null)\" \nng-class=\"{\'grey-200-bg\': vm.selectedGallery == null}\" style=\"min-height: 40px; height: 40px\"><p \nclass=\"m-0 pl-8 pt-8 pb-8 font-weight-500\">All Media</p></md-list-item></md-list><div class=\"divider\"></div><div \nclass=\"gallery-tree-container p-0\"><script type=\"text/ng-template\" id=\"mh_media_dialog_gallery_recursive.html\">\n<div class=\"cover-tree-row\" layout=\"row\" layout-align=\"start center\"\r\n                            ng-class=\"{\'blue-50-bg\': vm.selectedGallery == node.id_gallery}\">\r\n                            <!-- Chevron -->\r\n                            <md-icon ng-if=\"node.children && !node._expanded\"\r\n                                ng-click=\"node._expanded = true; $event.stopPropagation();\"\r\n                                md-font-icon=\"icon-chevron-right\" class=\"s18 grey-500-fg cover-tree-arrow\"></md-icon>\r\n                            <md-icon ng-if=\"node.children && node._expanded\"\r\n                                ng-click=\"node._expanded = false; $event.stopPropagation();\"\r\n                                md-font-icon=\"icon-chevron-down\" class=\"s18 grey-500-fg cover-tree-arrow\"></md-icon>\r\n                            <span ng-if=\"!node.children\" class=\"cover-tree-placeholder\"></span>\r\n                            <!-- Folder icon -->\r\n                            <md-icon ng-if=\"node.children\" md-font-icon=\"icon-folder-multiple\"\r\n                                class=\"mr-8 s18 grey-600-fg\" ng-click=\"vm.selectGalleryId(node.id_gallery)\"></md-icon>\r\n                            <md-icon ng-if=\"!node.children\" md-font-icon=\"icon-folder\"\r\n                                class=\"mr-8 s18 grey-600-fg\" ng-click=\"vm.selectGalleryId(node.id_gallery)\"></md-icon>\r\n                            <span class=\"text-truncate cover-tree-label\" title=\"{{node.name || node.gallery_name}}\"\r\n                                ng-click=\"vm.selectGalleryId(node.id_gallery)\">{{node.name || node.gallery_name}}</span>\r\n                        </div>\r\n                        <ul ng-if=\"node.children && node._expanded\" class=\"cover-tree-subtree\">\r\n                            <li ng-repeat=\"node in node.children\" ng-include=\"\'mh_media_dialog_gallery_recursive.html\'\"></li>\r\n                        </ul>\n</script><ul class=\"cover-tree-list\"><li ng-repeat=\"node in vm.galleries\" \nng-include=\"\'mh_media_dialog_gallery_recursive.html\'\"></li></ul></div></md-sidenav><div layout=\"column\" flex \nclass=\"bg-gray-50 full-height relative\"><md-dialog-content layout=\"column\" flex \nclass=\"mediadialog-content scrollable p-16\" style=\"overflow-y: auto\"><div flex layout=\"column\" \nlayout-align=\"center center\" ng-show=\"vm.loading && vm.items.length == 0\" class=\"loading-container p-32\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nng-hide=\"vm.items.length == 0 && !vm.loading\"><div layout=\"row\" layout-wrap><div ng-repeat=\"photo in vm.items\" \nflex=\"25\" flex-sm=\"50\" flex-xs=\"100\" class=\"p-8\"><md-card class=\"m-0 cursor-pointer cover-media-card\" \nng-click=\"vm.toggleSelectMedia(photo)\" \nng-class=\"{\'cover-media-selected\': vm.selectedMedia && vm.selectedMedia.id_media === photo.id_media}\"><div \nclass=\"media-preview-container\" style=\"height: 140px; position: relative; background: #f5f5f5\" layout=\"column\" \nlayout-align=\"center center\"><img ng-if=\"photo.imageUrl\" ng-src=\"{{photo.imageUrl}}\" \nstyle=\"width: 100%; height: 100%; object-fit: cover\"><md-icon ng-if=\"!photo.imageUrl\" md-font-icon=\"icon-image\" \nclass=\"s64 grey-400-fg\" style=\"width: 64px; height: 64px; min-height: 64px; min-width: 64px\"></md-icon></div>\n<md-card-content class=\"p-8 border-top\"><div class=\"text-truncate font-size-12 grey-700-fg\" title=\"{{photo.filename}}\">\n{{photo.filename}}</div><div class=\"text-truncate grey-400-fg font-size-11 mt-4\">#{{photo.id_media}}</div>\n</md-card-content></md-card></div></div><div layout=\"row\" layout-align=\"center center\" class=\"p-16\" \nng-if=\"vm.pagination.currentPage < vm.pagination.lastPage\"><md-button class=\"md-raised\" ng-click=\"vm.loadMore()\" \nng-disabled=\"vm.loading\"><md-progress-circular ng-if=\"vm.loading\" md-mode=\"indeterminate\" md-diameter=\"18\" \nclass=\"mr-8\"></md-progress-circular><span translate=\"MEDIA.LOAD_MORE\">Load more</span></md-button></div></div><div \nng-if=\"vm.items.length == 0 && !vm.loading\" layout=\"column\" layout-align=\"center center\" class=\"full-height p-32\" flex>\n<md-icon md-font-icon=\"icon-image-off\" class=\"s64 grey-400-fg mb-16\"></md-icon><div \nclass=\"message md-title grey-500-fg\" translate=\"MEDIA_DIALOG.NO_ITEMS_AVAILABLE\">No items available</div></div>\n</md-dialog-content></div></md-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\" \nclass=\"border-top p-16 white-bg\"><span class=\"grey-600-fg font-weight-500\">{{vm.pagination.totalItems | number}} Items\n</span><md-button ng-disabled=\"!vm.selectedMedia\" ng-click=\"vm.attachMedia()\" class=\"md-accent md-raised px-32 m-0\" \naria-label=\"Use as Cover\"><span translate=\"MEDIA.USE_AS_COVER\">Use as Cover</span></md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/apps/mediahub/dialogs/media/repeated-upload-files.html","<div id=\"repeated-files-dialog\"><div class=\"full-container\" layout=\"column\"><div id=\"warning-container\" layout=\"row\">\n<md-icon md-font-icon=\"icon-alert\"></md-icon><span translate=\"MEDIA.UPLOADING_REPEATED\" class=\"warning\">\nOne or more files already exist in the system. Please check and apply an action individually or to all of them.</span>\n</div><div class=\"files-container\" layout=\"row\"><div class=\"files uploadFile-container\"><span \ntranslate=\"MEDIA.UPLOADING_MEDIA\"></span><div class=\"item-container\"><div class=\"file\"><div class=\"image-container\">\n<img style=\"z-index: 1; position: absolute\" \nng-if=\"!vm.uploadFile.$error && vm.uploadFile && !vm.isImage(vm.uploadFile)\" src=\"assets/images/common/file.jpg\" \nclass=\"image\"> <img style=\"z-index: 2\" ngf-src=\"!vm.uploadFile.$error && vm.uploadFile\" class=\"image\"><video \nstyle=\"z-index: 3\" ng-if=\"vm.isVideo(vm.uploadFile)\" controls ngf-src=\"!vm.uploadFile.$error && vm.uploadFile\" \nclass=\"video\"></video></div><div class=\"info\" layout=\"column\"><span class=\"grey-500-fg word-break-all filename\">\n{{vm.uploadFile.name}}</span></div></div></div></div><div class=\"files repeatedFiles-container\"><span \ntranslate=\"MEDIA.DB_PHOTO\"></span><div class=\"item-container\" layout=\"row\"><div class=\"file\" \nng-repeat=\"file in vm.repeatedFiles | orderBy:\'id_media\'\"><div class=\"image-container\"><img ng-src=\"{{file.preview}}\">\n</div><div class=\"info\" layout=\"row\"><div class=\"string\" layout=\"column\"><strong class=\"mr-5\">#{{file.id_media}}\n</strong> <span class=\"grey-500-fg word-break-all filename\">{{file.sanitized}}</span></div><div class=\"check-repeat\" \nlayout-align=\"start center\" class=\"md-dense\" ng-if=\"vm.repeatedFiles.length > 1\"><input type=\"radio\" \nng-checked=\"vm.checkSelectedRepeated(file)\" ng-click=\"vm.changeSelectedRepeated(file)\"></div></div></div></div><div \nid=\"remember-check-container\" layout=\"row\" layout-align=\"start center\" class=\"md-dense\"><md-checkbox \nng-checked=\"vm.rememberDecission\" ng-click=\"vm.changeRememberDecission()\" id=\"check-remember-decission\" \ntranslate-attr-aria-label=\"MEDIA.REMEMBER_DECISSION\"></md-checkbox><label for=\"check-remember-decission\" \nng-click=\"vm.changeRememberDecission()\" aria-hidden=\"true\" tab-index=\"-1\" translate=\"MEDIA.REMEMBER_DECISSION\">\nRemember my decission</label></div></div></div><div class=\"tools\"><span class=\"explain-buttons\" \ntranslate=\"MEDIA.EXPLAIN_BUTTONS\"></span><md-button ng-click=\"vm.maintainBoth()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Maintain both\" translate=\"MEDIA.KEEP_ALL\" \ntranslate-attr-aria-label=\"MEDIA.KEEP_ALL\"><md-tooltip hide show-gt-xs><span translate=\"MEDIA.KEEP_ALL_DESCRIPTION\">\nThis action will keep all medias as separated files.</span></md-tooltip></md-button><md-button \nng-click=\"vm.replaceImage()\" class=\"send-button md-accent md-raised\" aria-label=\"Replace image\" \ntranslate=\"MEDIA.RELOAD_PHOTO\" translate-attr-aria-label=\"MEDIA.RELOAD_PHOTO\"><md-tooltip hide show-gt-xs><span \ntranslate=\"MEDIA.RELOAD_PHOTO_DESCRIPTION\">\nThis action will replace the old file with the one being uploaded. (In case that there are more than one repeated files, you should check the files that you want to act)\n</span></md-tooltip></md-button><md-button ng-click=\"vm.closeDialog()\" class=\"send-button md-accent md-raised\" \naria-label=\"Close\" translate=\"MEDIA.DELETE_FROM_UPLOAD\" translate-attr-aria-label=\"MEDIA.DELETE_FROM_UPLOAD\">\n<md-tooltip hide show-gt-xs><span translate=\"MEDIA.DELETE_FROM_UPLOAD_DESCRIPTION\">\nThis action will ignore the file that is being uploaded.</span></md-tooltip></md-button></div></div></div>");
$templateCache.put("app/main/apps/mediahub/dialogs/gallery-zip-download/gallery-zip-download.html","<md-dialog id=\"edit-gallery-dialog\" class=\"small compose-dialog\" aria-label=\"Edit Gallery\" \nstyle=\"width:auto; max-width: 90%\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><a class=\"md-button grey-A100-fg\" \ntype=\"import\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-cloud-download\" \nclass=\"s18 mr-5 ml-0 md-font material-icons\" role=\"img\" aria-label=\"icon-cloud-download\"></md-icon><span class=\"title\" \ntranslate=\"GALLERY.DOWNLOAD_ZIP\"></span></a></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"Close dialog\" translate-aria-label=\"GALLERY.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"grey-600-fg\" style=\"font-size: 14px\"><span translate=\"GALLERY.DOWNLOAD_ZIP_URL\"></span><md-icon \nmd-font-icon=\"icon-open-in-new\" class=\"s14\"></md-icon>: <a href=\"{{vm.downloadZipUrl}}\" target=\"_blank\">\n{{vm.downloadZipUrl}}</a></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><div \nlayout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.cancel()\" class=\"send-button md-warn md-raised\" \naria-label=\"Cancel\" translate=\"GALLERY.CANCEL\" translate-attr-aria-label=\"GALLERY.CANCEL\"></md-button></div>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/mediahub/dialogs/media-tags-dialog/media-tags-dialog.html","<md-dialog class=\"attachment-dialog add-media\" aria-label=\"New Message\"><form class=\"md-inline-form\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\"><a \nclass=\"md-button\" type=\"1\" layout=\"row\" layout-align=\"center center\" ng-click=\"vm.changeView(1)\" ng-if=\"vm.views[1]\">\n<md-icon md-font-icon=\"icon-file-image-box\" class=\"s18 mr-5 ml-0\"></md-icon><span translate=\"MEDIA.IMAGES\"></span> </a>\n<a class=\"md-button\" type=\"2\" layout=\"row\" layout-align=\"center center\" ng-click=\"vm.changeView(2)\" \nng-if=\"vm.views[2]\"><md-icon md-font-icon=\"icon-video\" class=\"s18 mr-5 ml-0\"></md-icon><span translate=\"MEDIA.VIDEOS\">\n</span> </a><a class=\"md-button\" type=\"3\" layout=\"row\" layout-align=\"center center\" ng-click=\"vm.changeView(3)\" \nng-if=\"vm.views[3]\"><md-icon md-font-icon=\"icon-volume\" class=\"s18 mr-5 ml-0\"></md-icon><span translate=\"MEDIA.AUDIO\">\n</span> </a><a class=\"md-button\" type=\"4\" layout=\"row\" layout-align=\"center center\" ng-click=\"vm.changeView(4)\" \nng-if=\"vm.views[4]\"><md-icon md-font-icon=\"icon-file\" class=\"s18 mr-5 ml-0\"></md-icon><span translate=\"MEDIA.FILES\">\n</span></a><div layout=\"row\" ng-if=\"vm.views[5]\"><md-menu><md-button type=\"5\" aria-label=\"Filters\" \nng-click=\"$mdMenu.open($event)\" translate=\"\" translate-attr-aria-label=\"CONTENT.FILTERS\"><span layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-folder-multiple-image\" class=\"s18 mr-5 ml-0\"></md-icon><span \nclass=\"ml-5\">Galleries</span> <i class=\"icon-chevron-down s20 ml-5\"></i></span></md-button><md-menu-content width=\"3\">\n<md-menu-item><md-button type=\"photos\" ng-click=\"vm.changeViewGallery(1)\" aria-label=\"Photos\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div><md-icon md-font-icon=\"icon-file-image-box\" class=\"s18\"></md-icon><span \ntranslate=\"MEDIA.IMAGES\"></span></div><i class=\"icon-check s16\" ng-if=\"vm.currentViewGallery===1\"></i></div>\n</md-button></md-menu-item><md-menu-item><md-button type=\"videos\" ng-click=\"vm.changeViewGallery(2)\" \naria-label=\"Videos\"><div layout=\"row\" layout-align=\"space-between center\"><div><md-icon md-font-icon=\"icon-video\" \nclass=\"ss18\"></md-icon><span translate=\"MEDIA.VIDEOS\"></span></div><i class=\"icon-check s16\" \nng-if=\"vm.currentViewGallery===2\"></i></div></md-button></md-menu-item><md-menu-item><md-button type=\"audios\" \nng-click=\"vm.changeViewGallery(3)\" aria-label=\"Audios\"><div layout=\"row\" layout-align=\"space-between center\"><div>\n<md-icon md-font-icon=\"icon-volume\" class=\"s18\"></md-icon><span translate=\"MEDIA.AUDIO\"></span></div><i \nclass=\"icon-check s16\" ng-if=\"vm.currentViewGallery===3\"></i></div></md-button></md-menu-item><md-menu-item><md-button \ntype=\"files\" ng-click=\"vm.changeViewGallery(4)\" aria-label=\"Files\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div><md-icon md-font-icon=\"icon-file\" class=\"s18\"></md-icon><span \ntranslate=\"MEDIA.FILES\"></span></div><i class=\"icon-check s16\" ng-if=\"vm.currentViewGallery===4\"></i></div></md-button>\n</md-menu-item><md-menu-item><md-button type=\"files\" ng-click=\"vm.changeViewGallery(0)\" aria-label=\"Files\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div><md-icon md-font-icon=\"icon-file\" class=\"s18\"></md-icon><span \ntranslate=\"MEDIA.ALL\"></span></div><i class=\"icon-check s16\" ng-if=\"vm.currentViewGallery===0\"></i></div></md-button>\n</md-menu-item></md-menu-content></md-menu></div><a class=\"md-button\" type=\"upload\" layout=\"row\" \nlayout-align=\"center center\" ng-click=\"vm.changeView(\'upload\')\" ng-if=\"vm.views.upload\"><md-icon \nmd-font-icon=\"icon-import\" class=\"s18 mr-5 ml-0\"></md-icon><span translate=\"MEDIA.UPLOAD\"></span> </a><a \nclass=\"md-button\" type=\"import\" layout=\"row\" layout-align=\"center center\" ng-click=\"vm.changeView(\'import\')\" \nng-if=\"vm.views.import\"><md-icon md-font-icon=\"icon-import\" class=\"s18 mr-5 ml-0\"></md-icon><span \ntranslate=\"MEDIA.IMPORT_URL\"></span></a></div><div layout=\"row\"><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate translate-aria-label=\"CONTENT.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></div></md-toolbar><md-content style=\"background: #dedede\" \nclass=\"full-height\"><div ng-if=\"!vm.selectedMedia\" layout=\"row\" class=\"full-height left-sidenav carded page-layout\">\n<md-sidenav ng-show=\"!vm.firstLoad\" md-is-open=\"false\" class=\"sidenav groups-tree sidenav-media-dialog\" \nmd-component-id=\"media-dialog-galleries-sidenav\" ms-scroll ms-sidenav-helper md-no-ink md-disable-backdrop \nng-include=\"\'app/main/dialogs/mediahub/views/sidenav.html\'\"></md-sidenav><div layout=\"column\" flex class=\"center\" \nmd-no-ink><div ng-include=\"\'app/main/dialogs/mediahub/views/templates/toolbar-search.html\'\" \nng-show=\"!vm.firstLoad && vm.isNumber(vm.currentView) && vm.currentView != 5\"></div><div \nng-include=\"\'app/main/dialogs/mediahub/views/templates/toolbar-search-gallery.html\'\" \nng-show=\"!vm.firstLoad && vm.currentView == 5\"></div><md-dialog-content layout=\"column\" ms-scroll=\"vm.msScrollOptions\" \nflex=\"100\" class=\"mediadialog-content scrollable\"><div flex layout=\"column\" layout-align=\"center center\" \nng-show=\"vm.loading || vm.firstLoad\" class=\"loading-container\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"50\"></md-progress-circular></div><div ng-include=\"vm.views[vm.currentView]\" \nng-hide=\"vm.isNumber(vm.currentView) && vm.items.length == 0\" ng-style=\"{\'opacity\' : vm.loading ? 0.2 : 1}\"></div><div \nng-if=\"vm.isNumber(vm.currentView) && vm.items.length == 0 && !vm.loading && !vm.firstLoad\" layout=\"row\" \nlayout-align=\"center center\" class=\"content-wrapper full-height\" flex=\"100\"><div class=\"message\" \ntranslate=\"MEDIA_DIALOG.NO_ITEMS_AVAILABLE\"></div></div></md-dialog-content></div></div><div flex layout=\"row\" \nng-if=\"vm.selectedMedia\"><div class=\"ms-card\"><div style=\"width: 300px\" class=\"ms-card-content-wrapper\"><div \nclass=\"template-9\"><div style=\"background: #f6f6f6\" class=\"media p-10\" flex layout=\"row\" layout-align=\"center center\">\n<media attachment=\"vm.selectedMedia\" class=\"\"></media></div><div class=\"header p-16\" flex><div layout=\"row\" \nlayout-align=\"space-between start\" flex><div class=\"size block pr-10\" layout=\"row\" layout-align=\"start left\" flex>\n<strong class=\"block mb-5\">#{{vm.selectedMedia.id_media}}</strong> <span class=\"grey-500-fg\"><span \nng-if=\"vm.selectedMedia.filename\" class=\"word-break-all\">{{vm.selectedMedia.filename}}</span></span></div></div>\n<md-tooltip md-direction=\"top\" hide show-gt-xs ng-if=\"vm.selectedMedia.filename\"><span>{{vm.selectedMedia.filename}}\n</span></md-tooltip></div></div></div></div><div class=\"form-tags\" flex><div fill-width class=\"ph-15 mb-0\" flex \nlayout=\"row\" layout-align=\"start center\"><md-input-container class=\"md-block mb-0\" flex><label>\n{{ \'MEDIA.TITLE\' | translate}}</label><input ng-model=\"vm.title\"></md-input-container></div><div fill-width \nclass=\"ph-15 mt-0\" flex layout=\"row\" layout-align=\"start center\"><md-input-container class=\"md-block mt-0\" flex><label \ntranslate=\"CONTENT.SEARCH_FOR_TAG\">Tags</label><md-chips class=\"label-chips close-chip\" ng-model=\"vm.photo_tags\" \nmd-autocomplete-snap md-require-match=\"true\"><md-autocomplete md-min-length=\"3\" md-selected-item=\"vm.selectedTag\" \nmd-selected-item-change=\"vm.selectedItemChange()\" md-search-text=\"vm.searchTagText\" \nmd-items=\"tag in vm.labelQuerySearch(vm.searchTagText) | orderBy:\'-order\'\" md-item-text=\"tag.tag_name\" \nmd-no-cache=\"true\" placeholder=\"{{vm.translate(\'CONTENT.SEARCH_FOR_TAG\')}}\" ng-model-options=\"{debounce: 500}\" \nmd-dropdown-items=\"10\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\" \nclass=\"tag-not-found-bg border-bottom\"><span ng-if=\"!tag.tag_name\">{{vm.searchTagText}}</span> <span \nmd-highlight-text=\"vm.searchTagText\" ng-if=\"tag.tag_name\">{{tag.tag_name}} #{{tag.id_tag}}</span><md-buttton \nng-if=\"!tag.tag_name\" ng-click=\"vm.newTag(vm.searchTagText)\" class=\"md-accent green-500-bg white-fg md-button m-0\">\n<span translate=\"CONTENT.TAGADD\"></span></md-buttton></div><md-not-found><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"100\" class=\"tag-not-found-bg\"><span>{{vm.searchTagText}}</span><md-buttton \nng-click=\"vm.newTag(vm.searchTagText)\" class=\"md-accent green-500-bg white-fg md-button m-0\"><span \ntranslate=\"CONTENT.TAGADD\"></span></md-buttton></div></md-not-found></md-autocomplete><md-chip-template><div \nclass=\"md-chip-content\"><span ng-if=\"$chip.color\" class=\"color\" ng-style=\"{\'background-color\':$chip.color}\"></span> \n<span>{{$chip.tag_name}} #{{$chip.id_tag}}</span></div></md-chip-template><button md-chip-remove class=\"md-primary\" \nlayout=\"row\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-close\"></md-icon></button></md-chips>\n</md-input-container></div><div fill-width class=\"ph-15\" flex layout=\"row\" layout-align=\"start center\">\n<md-input-container class=\"md-block\" flex><label>{{ \'MEDIA.MIN_MATCH\' | translate}} (%)</label><input type=\"number\" \nmin=\"70\" max=\"100\" ng-model=\"vm.min_match\"></md-input-container></div></div></div></md-content><md-dialog-actions \nlayout=\"row\" layout-align=\"end center\" ng-style=\"{\'opacity\' : vm.loading ? 0.2 : 1}\" \nng-if=\"(vm.items.length> 0 || vm.files.length > 0)\"><div layout=\"row\" flex layout-align=\"start center\" \nng-if=\"vm.selectedMedia\" hide show-gt-xs><md-button ng-click=\"vm.selectedMedia= null;\" class=\"send-button md-raised\" \naria-label=\"save\" translate=\"CONTENT.BACK\" translate-attr-aria-label=\"CONTENT.BACK\">BACK</md-button></div><div \nng-if=\"!vm.selectedMedia\" layout=\"row\" layout-align=\"start center\" ng-if=\"vm.totalItems> 0\" hide show-gt-xs \nng-if=\"vm.showSearchAndPaginator\"><span class=\"page-info\" ng-if=\"vm.showSearchAndPaginator\">{{vm.totalItems | number}} \n</span>&nbsp;<span translate=\"CONTENT.ITEMS_FOUND\"></span><md-button aria-label=\"Previous\" \nclass=\"md-icon-button arrow\" ng-if=\"vm.showSearchAndPaginator\" ng-click=\"vm.prevPage()\" ng-disabled=\"vm.firstPage()\" \ntranslate=\"\" translate-attr-aria-label=\"CONTENT.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon>\n<md-tooltip md-direction=\"top\"><span translate=\"CONTENT.PREVIOUS\"></span></md-tooltip></md-button><div><md-select \nng-model=\"pagination_page\" placeholder=\"{{vm.currentPage | number}}\" class=\"toolbar-item\"><md-option \nng-repeat=\"n in [].constructor(vm.lastPage) track by $index\" value=\"{{$index +1}}\" ng-click=\"vm.gotoPage($index+1)\">\n{{$index+1}}</md-option></md-select><md-tooltip md-direction=\"top\"><span translate=\"CONTENT.SELECT_PAGE\"></span>\n</md-tooltip></div><span class=\"page-info\" hide=\"\" show-gt-xs=\"\">/ {{vm.lastPage | number}}</span><md-button \naria-label=\"Next\" class=\"md-icon-button arrow\" ng-if=\"vm.showSearchAndPaginator\" ng-click=\"vm.nextPage()\" \nng-disabled=\"!vm.morePages()\" translate=\"\" translate-attr-aria-label=\"CONTENT.NEXT\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip md-direction=\"top\"><span translate=\"CONTENT.NEXT\"></span>\n</md-tooltip></md-button></div><div ng-if=\"vm.selectedMedia\" layout=\"row\" layout-align=\"end center\" \nng-if=\"vm.maxAttach> 1\"><md-button ng-disabled=\"!vm.title || !vm.min_match || vm.photo_tags.length == 0\" \nng-click=\"vm.saveFace()\" class=\"send-button md-accent md-raised\" aria-label=\"save\" translate=\"CONTENT.SAVE\" \ntranslate-attr-aria-label=\"CONTENT.SAVE\">SAVE</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/mediahub/dialogs/media-tags-dialog/upload-view-tags.html","<div class=\"content-wrapper full-height\" flex=\"\"><div class=\"content\"><div flex=\"100\" layout-padding layout=\"row\"><div \nngf-drop ngf-select ng-model=\"vm.files\" class=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"false\" \nngf-allow-dir=\"true\" accept=\"image/*\" ngf-pattern=\"\'image/*\'\"><div layout=\"column\"><div flex \ntranslate=\"MEDIA.DROP_HERE\" hide show-gt-sm></div><div flex translate=\"MEDIA.DROP_OR\" hide show-gt-sm></div><div flex>\n<md-button class=\"send-button md-accent md-raised\" aria-label=\"Select files\" translate=\"MEDIA.SELECT_FILES\">\n</md-button></div></div></div><div ngf-no-file-drop translate=\"MEDIA.FILE_DRAG_DROP\"></div></div><div flex=\"100\" \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"center start\" ng-if=\"vm.files.length> 0\"><div layout-gt-sm=\"column\" \nflex=\"100\"><div ng-repeat=\"f in vm.uploadFiles\" class=\"ms-card upload-view\" flex \nng-class=\"{\'opacity-6\':f.progress <100 || !f.progress}\"><div class=\"ms-card-content-wrapper\"><div class=\"template-9\" \nlayout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" layout=\"column\" layout-align=\"start stretch\"><div \nclass=\"media upload\" layout=\"row\" layout-align=\"center center\"><img style=\"z-index: 2\" ngf-thumbnail=\"!f.$error && f\" \nclass=\"image\"><div style=\"z-index: 1\" flex layout=\"column\" layout-align=\"center center\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div></div><div layout=\"column\" \nlayout-align=\"center center\" layout-align-gt-xs=\"center start\" flex><div class=\"header p-16\" \nstyle=\"margin-top: auto;margin-bottom: auto\"><div layout=\"row\" layout-align=\"space-between center\" flex><div \nclass=\"size\" layout=\"row\" layout-align=\"start left\"><strong class=\"mr-5\" ng-if=\"f.id\">#{{f.id}}</strong> <strong \nclass=\"grey-500-fg word-break-all\" ng-if=\"f.name\">{{f.name}}</strong></div></div><span class=\"grey-500-fg\" \nng-if=\"f.$error || f.$errorParam\"><span class=\"word-break-all\">{{f.$error}} / {{f.$errorParam}}</span></span></div>\n</div><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"green-fg s32 mh-20\" role=\"img\" \naria-label=\"icon-checkbox-marked-circle\" ng-show=\"f.progress == 100 && vm.processed\"></md-icon><md-progress-circular \nclass=\"mr-50\" md-mode=\"indeterminate\" md-diameter=\"50\" ng-if=\"!vm.processed\"></md-progress-circular></div>\n<md-progress-linear class=\"md-accent\" md-mode=\"determinate\" value=\"{{f.progress && f.progress> 5 ? f.progress : 5}}\" \nng-show=\"!f.progress || f.progress <100\"></md-progress-linear></div></div></div></div></div></div>");
$templateCache.put("app/main/apps/mediahub/dialogs/media-show/media-show-dialog-with-tags.html","<md-dialog class=\"large attachment-dialog\" aria-label=\"New Task\"><md-toolbar \nclass=\"md-accent md-hue-2 md-default-theme\"><div class=\"md-toolbar-tools\"><div layout=\"row\"><a class=\"md-button\" \ntype=\"1\" layout=\"row\" layout-align=\"center center\" ng-click=\"vm.changeView(\'fotorama\')\"><md-icon \nmd-font-icon=\"icon-file-image-box\" class=\"s18 mr-5 ml-0\"></md-icon><span translate=\"CONTENT.PREVIEW\">Preview Media\n</span></a></div><span flex></span><div layout=\"row\"><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" tranlate translate-aria-label=\"CONTENT.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></div></md-toolbar><md-dialog-content \nclass=\"mediadialog-content {{vm.isAudio ? \'audio\' : \'\'}}\" layout-fill><div ng-if=\"!vm.isAudio\" style=\"height: 100%\">\n<md-content ng-if=\"!vm.isUniqueVideo\" flex class=\"content-card\" ng-class=\"vm.currentView\" \nng-include=\"vm.viewsWithTags[vm.currentView]\" md-no-ink></md-content><iframe class=\"video-iframe\" \nng-if=\"vm.isUniqueVideo && !vm.isM3u8\" ng-src=\"{{vm.trustSrc(vm.dataFotorama[0].video)}}\" frameborder=\"0\" \nallowfullscreen></iframe><video ng-init=\"vm.initMejPlayer()\" ng-if=\"vm.isUniqueVideo && vm.isM3u8\" autoplay \nwidth=\"100%\" height=\"100%\" style=\"width:100%;height:100%\" id=\"vp-m3u8\" classname=\"video-player mejs-ted\" \npreload=\"none\"><source type=\"application/x-mpegURL\" ng-src=\"{{vm.dataFotorama[0].video}}\"></video></div><audio \nstyle=\"width: calc(60%);margin: 50px 20%\" ng-if=\"vm.isAudio\" preload=\"none\" autoplay controls><source \nsrc=\"{{vm.audioUrl}}\" type=\"audio/mp3\">Your browser does not support the audio element.</audio></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/apps/mediahub/dialogs/share-dialog/share-dialog.controller.html","<md-dialog class=\"share-dialog\" aria-label=\"New Task\"><form style=\"height: 100%\" name=\"taskForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between\"><h1 class=\"title\">{{\'MATCH_CENTER.SHARE\' | translate}}</h1><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\"><div class=\"p-15 black-bg\" flex=\"60\" \nlayout=\"row\" layout-align=\"center center\"><div ng-include=\"\'app/main/dialogs/media-show/views/fotorama-view.html\'\" \nclass=\"width-percent-100\"></div></div><div flex=\"40\"><ms-social-widget-share onclose=\"vm.closeDialog()\" \nservice=\"\'media\'\" section=\"\'all\'\" idcontent=\"\" medias=\"vm.mediasIds\"></ms-social-widget-share></div></div>\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/mediahub/dialogs/settings/mh-settings-dialog.html","<md-dialog class=\"mediahub-settings-dialog\" aria-label=\"Mediahub Settings\" ng-cloak><form name=\"vm.settingsForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" translate=\"CONTENT.SETTINGS\">Settings</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><md-tabs md-dynamic-height md-border-bottom><md-tab \nlabel=\"{{ \'GALLERY.PERMISSIONS\' | translate }}\"><div layout=\"row\" layout-xs=\"column\" class=\"settings-layout\" \nstyle=\"min-height: 400px\"><div flex=\"35\" flex-xs=\"100\" class=\"border-right p-16\" layout=\"column\"><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"mb-16\"><span class=\"md-subhead font-weight-600\">Permission Presets</span>\n<md-button class=\"md-icon-button md-accent\" ng-click=\"vm.addPreset()\" aria-label=\"Add Preset\"><md-icon \nmd-font-icon=\"icon-plus-circle\"></md-icon><md-tooltip>Add New Preset</md-tooltip></md-button></div><md-list \nclass=\"pt-0 preset-list\" flex ms-scroll><md-list-item ng-repeat=\"preset in vm.defaultPermissions\" \nng-click=\"vm.selectPreset(preset)\" ng-class=\"{\'selected-preset-item\': vm.selectedPreset === preset}\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex><span class=\"text-truncate\" title=\"{{preset.name}}\">\n{{preset.name || \'Unnamed Preset\'}}</span><md-button class=\"md-icon-button md-warn\" \nng-click=\"vm.deletePreset(preset, $event)\" aria-label=\"Delete Preset\"><md-icon md-font-icon=\"icon-delete\" class=\"s18\">\n</md-icon></md-button></div></md-list-item></md-list><div ng-if=\"vm.defaultPermissions.length === 0\" \nclass=\"grey-500-fg italic p-16 text-center\">No presets created yet.</div></div><div flex=\"65\" flex-xs=\"100\" \nclass=\"p-16\" layout=\"column\"><div ng-if=\"vm.selectedPreset\" layout=\"column\" flex><md-input-container \nclass=\"md-block mb-16\"><label>Preset Name</label><input ng-model=\"vm.selectedPreset.name\" required name=\"presetName\">\n<div ng-messages=\"vm.settingsForm.presetName.$error\"><div ng-message=\"required\">Name is required.</div></div>\n</md-input-container><span class=\"md-subhead font-weight-600 mb-8\">Groups for this Preset</span><div \nng-if=\"vm.loadingGroups\" layout=\"row\" layout-align=\"center center\" class=\"pv-32\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"40\"></md-progress-circular></div><div ng-if=\"!vm.loadingGroups\" \nclass=\"groups-scroll-container\" flex ms-scroll><div layout=\"row\" layout-align=\"start center\" \nclass=\"mb-16 pb-8 border-bottom\"><md-checkbox ng-checked=\"vm.isAllSelected()\" ng-click=\"vm.toggleAllGroups()\" \naria-label=\"Select All\"><span class=\"font-weight-600\">Select All</span></md-checkbox></div><div \nng-repeat=\"group in vm.mediahubGroups\" class=\"mb-8\"><md-checkbox ng-checked=\"vm.isGroupSelected(group)\" \nng-click=\"vm.toggleGroupSelection(group)\" aria-label=\"{{group.name}}\">{{group.name}}</md-checkbox></div><div \nng-if=\"vm.mediahubGroups.length === 0\" class=\"grey-500-fg italic\" translate=\"GALLERY.NO_GROUPS_AVAILABLE\">\nNo groups available.</div></div></div><div ng-if=\"!vm.selectedPreset\" class=\"grey-500-fg italic p-32 text-center\" flex \nlayout=\"row\" layout-align=\"center center\">Select a preset on the left or create a new one.</div></div></div></md-tab>\n</md-tabs></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\" class=\"p-16\"><span>\n</span><div layout=\"row\"><md-button ng-click=\"vm.cancel()\" class=\"md-primary\"><span translate=\"GALLERY.CANCEL\">Cancel\n</span></md-button><md-button ng-click=\"vm.save()\" class=\"md-accent md-raised\" \nng-disabled=\"vm.settingsForm.$invalid || vm.saving\"><span translate=\"GALLERY.SAVE\">Save</span></md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/mediahub/dialogs/upload/mh-repeated-upload-files.html","<div id=\"mh-repeated-files-dialog\"><div class=\"full-container\" layout=\"column\"><div class=\"header-container\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-alert-circle\" class=\"warn-icon s32\"></md-icon><div\n layout=\"column\"><span class=\"title-text\">File conflict detected</span> <span class=\"subtitle-text\">\nOne or more files already exist in the system. Choose how to proceed.</span></div></div><div class=\"files-container\" \nlayout=\"row\" flex><div class=\"files-column upload-column\" flex=\"33\"><span class=\"column-header\">NEW FILE</span><div \nclass=\"mh-conflict-item shadow-card\"><div class=\"item-content\" layout=\"column\"><div class=\"mh-conflict-image-inner\" \nlayout=\"row\" layout-align=\"center center\"><img ng-if=\"vm.isImage(vm.uploadFile)\" ngf-src=\"vm.uploadFile\" \nclass=\"preview-img\"><video ng-if=\"vm.isVideo(vm.uploadFile)\" ngf-src=\"vm.uploadFile\" class=\"preview-video\"></video>\n<md-icon ng-if=\"!vm.isImage(vm.uploadFile) && !vm.isVideo(vm.uploadFile)\" md-font-icon=\"icon-file-document\" \nclass=\"s128 placeholder-icon\"></md-icon></div><div class=\"info-footer\"><span class=\"file-name\">{{vm.uploadFile.name}}\n</span><div class=\"file-size\">{{(vm.uploadFile.size / 1024 / 1024 | number:2)}} MB</div></div></div></div></div><div \nclass=\"files-column existing-column\" flex=\"66\"><span class=\"column-header\">EXISTING IN SYSTEM</span><div \nclass=\"item-grid\" layout=\"row\" layout-wrap><div class=\"mh-conflict-item shadow-card m-8\" flex=\"45\" layout=\"column\"><div\n class=\"mh-conflict-image-inner\" layout=\"row\" layout-align=\"center center\"><img \nng-src=\"{{vm.repeatedFiles[0].thumbnailUrl || vm.repeatedFiles[0].preview}}\" class=\"preview-img\"></div><div \nclass=\"info-footer\" layout=\"column\"><strong class=\"item-id\">#{{vm.repeatedFiles[0].id}}</strong> <span \nclass=\"item-name\" title=\"{{vm.repeatedFiles[0].fileName}}\">{{vm.repeatedFiles[0].fileName}}</span> <span \nclass=\"item-date\">Uploaded: {{vm.repeatedFiles[0].dateUploaded | date:\'medium\'}}</span></div></div></div></div></div>\n<div class=\"actions-footer\" layout=\"row\" layout-align=\"end center\"><div class=\"remember-container\" layout=\"row\" \nlayout-align=\"start center\"><md-checkbox ng-model=\"vm.rememberDecision\" aria-label=\"Remember my decision\">\nRemember my decision for the remaining files</md-checkbox></div><md-button ng-click=\"vm.closeDialog()\" \nclass=\"md-raised action-btn\">Ignore this file</md-button><md-button ng-click=\"vm.maintainBoth()\" \nclass=\"md-raised md-accent action-btn\">Duplicate (Keep both)</md-button><md-button ng-click=\"vm.replaceImage()\" \nclass=\"md-raised md-warn action-btn\">Replace existing</md-button></div></div></div>");
$templateCache.put("app/main/apps/mediahub/dialogs/upload/mh-upload-dialog.html","<md-dialog class=\"mediahub-upload-dialog\" aria-label=\"Upload Media\"><form class=\"md-inline-form upload-dialog-form\" \nflex layout=\"column\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-cloud-upload\" class=\"mr-16\"></md-icon><span class=\"md-subhead\">Upload Media</span></div><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close\" ng-disabled=\"vm.uploading\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-content flex layout=\"row\" \nclass=\"upload-dialog-body p-0\"><div flex layout=\"column\" class=\"upload-files-panel\"><div ng-hide=\"vm.uploading\" \nclass=\"border-bottom drop-zone\"><div ngf-drop ngf-select ng-model=\"vm.files\" ngf-drag-over-class=\"\'dragover\'\" \nngf-multiple=\"true\" ngf-keep=\"true\" ngf-keep-distinct=\"true\" ngf-allow-dir=\"true\" \naccept=\"image/*,video/*,audio/*,application/pdf\" class=\"upload-dropzone\" layout=\"column\" layout-align=\"center center\">\n<md-icon md-font-icon=\"icon-cloud-upload\" class=\"s48 grey-400-fg mb-8\"></md-icon><p class=\"md-subhead grey-600-fg m-0\">\nDrop files here or click to browse</p><p class=\"grey-400-fg text-small mt-4 mb-0\">Images, video, audio or PDF</p></div>\n</div><div ng-show=\"vm.uploading\" class=\"p-16 border-bottom blue-50-bg\" layout=\"row\" layout-align=\"start center\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"24\" class=\"mr-12\"></md-progress-circular><span \nclass=\"blue-700-fg font-weight-500\">Uploading files… please wait</span></div><md-content flex \nclass=\"upload-files-scroll p-0\"><div ng-if=\"!vm.files || vm.files.length === 0\" layout=\"column\" \nlayout-align=\"center center\" flex class=\"p-32\"><md-icon md-font-icon=\"icon-image-multiple\" \nclass=\"s48 grey-300-fg mb-8\"></md-icon><span class=\"grey-400-fg\">No files selected yet</span></div><md-list \nclass=\"p-0\" ng-if=\"vm.files && vm.files.length > 0\"><md-list-item ng-repeat=\"f in vm.files\" class=\"border-bottom\"><div \nlayout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"{{vm.getIconForFile(f)}}\" class=\"s24 mr-12\" \nng-class=\"{\r\n                                            \'green-fg\':    f._status === \'done\',\r\n                                            \'red-fg\':      f._status === \'error\',\r\n                                            \'blue-fg\':     f._status === \'uploading\',\r\n                                            \'grey-500-fg\': !f._status\r\n                                         }\">\n</md-icon><div flex layout=\"column\"><span class=\"text-truncate font-weight-500\" title=\"{{f.name}}\">{{f.name}}</span> \n<span class=\"text-small grey-500-fg mt-2\">{{(f.size / 1024 / 1024 | number:2)}} MB <span ng-if=\"f._status === \'done\'\" \nclass=\"green-fg ml-8\">&#10003; Uploaded</span> <span ng-if=\"f._status === \'error\'\" class=\"red-fg ml-8\">\n&#10007; {{f._error}}</span></span><md-progress-linear ng-if=\"f._status === \'uploading\'\" md-mode=\"determinate\" \nvalue=\"{{f._progress}}\" class=\"mt-4\"></md-progress-linear></div><md-button class=\"md-icon-button\" \nng-click=\"vm.removeFile(f)\" ng-disabled=\"vm.uploading\" aria-label=\"Remove\"><md-icon md-font-icon=\"icon-close\" \nclass=\"s18 grey-500-fg\"></md-icon></md-button></div></md-list-item></md-list></md-content></div><div layout=\"column\" \nclass=\"upload-gallery-panel\"><div class=\"p-16 border-bottom\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-folder-multiple\" class=\"s18 mr-8 grey-600-fg\"></md-icon><span class=\"md-subhead font-weight-500\">\nGalleries</span></div><div flex layout=\"column\" layout-align=\"center center\" ng-show=\"vm.loadingGalleries\" \nclass=\"p-32\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"36\"></md-progress-circular></div><div \nclass=\"gallery-tree-container p-8\" ng-hide=\"vm.loadingGalleries\"><script type=\"text/ng-template\" \nid=\"mh_upload_dialog_gallery_node.html\">\n<div layout=\"row\" layout-align=\"start center\" class=\"tree-row p-4 p-l-8 p-r-8\"\r\n                             ng-class=\"{\'blue-50-bg font-weight-500\': node.assigned_gallery, \'grey-300-fg\': !node.assigned_gallery && !vm.uploading}\">\r\n                            <!-- Collapse toggle (only for nodes with children) -->\r\n                            <md-button class=\"md-icon-button gallery-collapse-btn\"\r\n                                       ng-if=\"node.children && node.children.length > 0\"\r\n                                       ng-click=\"node._collapsed = !node._collapsed\"\r\n                                       aria-label=\"{{node._collapsed ? \'Expand\' : \'Collapse\'}}\">\r\n                                <md-icon md-font-icon=\"{{node._collapsed ? \'icon-chevron-right\' : \'icon-chevron-down\'}}\" class=\"s16\"></md-icon>\r\n                            </md-button>\r\n                            <!-- Spacer for leaf nodes -->\r\n                            <span ng-if=\"!node.children || node.children.length === 0\" class=\"gallery-leaf-spacer\"></span>\r\n                            <md-icon md-font-icon=\"{{node.children && node.children.length ? \'icon-folder-multiple\' : \'icon-folder\'}}\"\r\n                                     class=\"s18 mr-8 gallery-node-icon\"\r\n                                     ng-class=\"{\'amber-fg\': node.assigned_gallery, \'grey-400-fg\': !node.assigned_gallery}\">\r\n                            </md-icon>\r\n                            <span class=\"text-truncate\" flex title=\"{{node.name}}\"\r\n                                  ng-class=\"{\'blue-700-fg\': node.assigned_gallery, \'grey-500-fg\': !node.assigned_gallery}\">\r\n                                {{node.name}}\r\n                            </span>\r\n                            <md-checkbox\r\n                                ng-disabled=\"node.no_files_allowed || vm.uploading\"\r\n                                ng-model=\"node.assigned_gallery\"\r\n                                class=\"gallery-node-checkbox\"\r\n                                aria-label=\"{{node.name}}\">\r\n                            </md-checkbox>\r\n                        </div>\r\n                        <ul ng-if=\"node.children && node.children.length > 0 && !node._collapsed\"\r\n                            class=\"gallery-tree-children\">\r\n                            <li ng-repeat=\"node in node.children\"\r\n                                ng-include=\"\'mh_upload_dialog_gallery_node.html\'\">\r\n                            </li>\r\n                        </ul>\n</script><ul class=\"gallery-tree-list\"><li ng-repeat=\"node in vm.galleries\" \nng-include=\"\'mh_upload_dialog_gallery_node.html\'\"></li></ul></div></div><div layout=\"column\" \nclass=\"upload-fields-panel\"><div class=\"p-16 border-bottom\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-tooltip-edit\" class=\"s18 mr-8 grey-600-fg\"></md-icon><span class=\"md-subhead font-weight-500\" \ntranslate=\"MEDIA.EDITMULTIPLEFIELDS\">Edit fields</span></div><md-content flex class=\"upload-multi-edit p-16\" \nng-hide=\"vm.uploading\"><div \nng-include=\"\'app/main/apps/mediahub/dialogs/edit-multiple-fields/edit-multiple-fields-form.html\'\"></div></md-content>\n</div></md-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\" class=\"border-top p-16\"><span \nclass=\"grey-500-fg text-small\">{{vm.files.length}} file(s) selected</span><md-button ng-click=\"vm.upload()\" \nclass=\"md-accent md-raised m-0\" ng-disabled=\"!vm.files.length || vm.uploading\" aria-label=\"Upload\"><md-icon \nmd-font-icon=\"icon-cloud-upload\" class=\"mr-4 s16\"></md-icon>Upload</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/mediahub/directives/mh-search-bar/mh-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-icon \nid=\"ms-search-bar-expander\" md-font-icon=\"icon-magnify\" class=\"md-icon-button md-button\"><md-tooltip hide show-gt-xs>\n<span translate=\"TOOLBAR.SEARCH\">Search</span></md-tooltip></md-icon></label><md-icon id=\"ms-search-bar-reset\" \nmd-font-icon=\"icon-close-circle\" class=\"icon s24\" ng-if=\"msb.modelSearch\" ng-click=\"msb.modelSearch = \'\'\"></md-icon>\n<input id=\"ms-search-bar-input\" type=\"text\" ng-model=\"msb.modelSearch\" placeholder=\"Search\" md-autofocus translate \ntranslate-attr-placeholder=\"TOOLBAR.SEARCH\" flex ng-enter=\"msb.doSearch()\"><md-button hide show-gt-xs \nid=\"ms-search-bar-button\" class=\"md-accent md-raised\" ng-click=\"msb.doSearch()\" ng-disabled=\"!msb.modelSearch\" \naria-label=\"Search\" md-no-ink=\"true\" md-ripple-size=\"auto\">Search</md-button><md-button hide show-xs \nid=\"ms-search-bar-button\" class=\"md-accent md-raised md-icon-button\" ng-click=\"msb.doSearch()\" \nng-disabled=\"!msb.modelSearch\" aria-label=\"Search\" md-no-ink=\"true\" md-ripple-size=\"auto\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon></md-button><md-icon id=\"ms-search-bar-collapser\" \nmd-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></div>");
$templateCache.put("app/main/apps/mediahub/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-checkbox-marked\" class=\"s24\"></md-icon>\n</span><span class=\"logo-text\" translate=\"TODO.TO_DO\">To-Do</span></div><md-select \nclass=\"project-selection simplified\" ng-model=\"vm.selectedProject\" placeholder=\"Select Project\"><md-option \nng-repeat=\"(project, title) in vm.projects\" value=\"{{project}}\">{{title}}</md-option></md-select></div><md-content \nclass=\"content\" flex ms-scroll><div class=\"add-task-button\"><md-button class=\"md-accent md-raised\" \nng-click=\"vm.openTaskDialog($event)\" aria-label=\"ADD TASK\" translate=\"TODO.ADD_TASK\" \ntranslate-attr-aria-label=\"TODO.ADD_TASK\">ADD TASK</md-button></div><div class=\"navigation-simple\" layout=\"column\">\n<md-button class=\"item\" aria-label=\"All Tasks\" translate translate-attr-aria-label=\"TODO.ALL_TASKS\" \nng-class=\"{\'selected\':vm.showAllTasks}\" ng-click=\"vm.resetFilters()\"><div layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-view-headline\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TODO.ALL_TASKS\">\nAll Tasks</span></div></md-button><div class=\"item subheader\" translate=\"TODO.FILTERS\">Filters</div><md-button \nclass=\"item\" aria-label=\"Starred\" translate translate-attr-aria-label=\"TODO.STARRED\" \nng-click=\"vm.toggleFilterWithEmpty(\'starred\')\" ng-class=\"{\'selected\':vm.taskFilters.starred}\"><md-icon \nmd-font-icon=\"icon-star\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TODO.STARRED\">Starred</span></md-button>\n<md-button class=\"item\" aria-label=\"Priority\" translate translate-attr-aria-label=\"TODO.PRIORITY\" \nng-click=\"vm.toggleFilterWithEmpty(\'important\')\" ng-class=\"{\'selected\':vm.taskFilters.important}\"><md-icon \nmd-font-icon=\"icon-alert-circle\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TODO.PRIORITY\">Priority</span>\n</md-button><md-button class=\"item\" aria-label=\"Scheduled\" translate translate-attr-aria-label=\"TODO.SCHEDULED\" \nng-click=\"vm.toggleFilterWithEmpty(\'dueDate\')\" ng-class=\"{\'selected\':vm.taskFilters.dueDate}\"><md-icon \nmd-font-icon=\"icon-clock\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TODO.SCHEDULED\">Scheduled</span>\n</md-button><md-button class=\"item\" aria-label=\"Today\" translate translate-attr-aria-label=\"TODO.TODAY\" \nng-click=\"vm.toggleFilterWithEmpty(\'startDate\')\" ng-class=\"{\'selected\':vm.taskFilters.startDate}\"><md-icon \nmd-font-icon=\"icon-calendar-today\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TODO.TODAY\">Today</span>\n</md-button><md-button class=\"item\" aria-label=\"Done\" translate translate-attr-aria-label=\"TODO.DONE\" \nng-click=\"vm.toggleFilterWithEmpty(\'completed\')\" ng-class=\"{\'selected\':vm.taskFilters.completed}\"><md-icon \nmd-font-icon=\"icon-check\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TODO.DONE\">Done</span></md-button>\n<md-button class=\"item\" aria-label=\"Deleted\" translate translate-attr-aria-label=\"TODO.DELETED\" \nng-click=\"vm.toggleFilter(\'deleted\')\" ng-class=\"{\'selected\':vm.taskFilters.deleted}\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TODO.DELETED\">Deleted</span>\n</md-button><div class=\"item subheader\" translate=\"TODO.TAGS\">Tags</div><md-button class=\"tag item\" \naria-label=\"tag {{tag.label}}\" ng-repeat=\"tag in vm.tags track by $index\" ng-click=\"vm.toggleTagFilter(tag)\"><md-icon \nmd-font-icon=\"icon-label\" class=\"s16\" ng-style=\"{\'color\' : tag.color}\"></md-icon><span class=\"title\">{{tag.label}}\n</span></md-button></div></md-content>");
$templateCache.put("app/main/apps/mediahub/views/list/galleries-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-show=\"vm.isLoading\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nclass=\"mail-list-item md-toolbar-tools grey-100-bg filter-selected breadcrumb\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"info\" flex><div class=\"breaditem\" layout=\"row\" layout-align=\"start center\"><div\n ng-click=\"vm.backToGallery()\" class=\"text-truncate pl-15 pr-10\" layout=\"row\" layout-align=\"start center\"><md-icon \nclass=\"s16 home-icon\" md-font-icon=\"icon-home\"></md-icon>{{\'MEDIA.GALLERIES\' | translate}} <span \nng-if=\"vm.CleanMediaGalleries.length> 0\">({{vm.CleanMediaGalleries.length}})</span></div><span class=\"pr-10\" \nng-click=\"vm.backToGallery(gallery); event.stopPropagation()\" \nng-repeat=\"gallery in vm.hierarchyGalleries track by $index\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon>\n<md-icon ng-if=\"!gallery.children && gallery.gallery_type == 0\" md-font-icon=\"icon-folder\" \nclass=\"s16 mr-0 mt-0 ml-5 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"!gallery.children && gallery.gallery_type == 1\" md-font-icon=\"icon-folder-image\" \nclass=\"s16 mr-0 mt-0 ml-5 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"!gallery.children && gallery.gallery_type == 2\" md-font-icon=\"qiu-icon-video-folder\" \nclass=\"s16 mr-0 mt-0 ml-5 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"!gallery.children && gallery.gallery_type == 3\" md-font-icon=\"qiu-icon-audio-folder\" \nclass=\"s16 mr-0 mt-0 ml-5 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"!gallery.children && gallery.gallery_type == 4\" md-font-icon=\"qiu-icon-file-folder\" \nclass=\"s16 mr-0 mt-0 ml-5 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"gallery.children && gallery.gallery_type == 0\" md-font-icon=\"icon-folder-multiple\" \nclass=\"s16 mr-0 mt-0 ml-5 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"gallery.children && gallery.gallery_type == 1\" md-font-icon=\"icon-folder-multiple-image\" \nclass=\"s16 mr-0 mt-0 ml-5 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"gallery.children && gallery.gallery_type == 2\" md-font-icon=\"qiu-icon-video-gallery\" \nclass=\"s16 mr-0 mt-0 ml-5 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"gallery.children && gallery.gallery_type == 3\" md-font-icon=\"qiu-icon-audio-gallery\" \nclass=\"s16 mr-0 mt-0 ml-5 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"gallery.children && gallery.gallery_type == 4\" md-font-icon=\"qiu-icon-file-gallery\" \nclass=\"s16 mr-0 mt-0 ml-5 mb-0\" aria-hidden=\"true\"></md-icon>{{gallery.gallery_name}} <span \nng-if=\"gallery.children.length> 0\">({{gallery.children.length}})</span></span></div></div></div><div \nid=\"list-content-data\" ng-style=\"{\'opacity\' : vm.isLoading ? 0.2 : 1}\" ms-scroll=\"vm.msScrollOptions\" \nng-class=\"{\'group-filter\': vm.selectedGallery,\'other-filter\':$root.pagination_searchquery==true}\" \nclass=\"scrollable mt-64\"><div class=\"media mail-list-pane-grid pt-20 pb-30\" flex layout-padding><div \nclass=\"no-threads\" ng-if=\"vm.selectedGalleryChildren.length == 0 || !vm.selectedGalleryChildren\"><md-icon \nmd-font-icon=\"icon-folder\" class=\"grey-fg s50 mr-10 mt-0 ml-0 mb-10\" aria-hidden=\"true\" role=\"img\"></md-icon><span \nclass=\"grey-fg\" translate=\"MEDIA.NO_ITEMS_GALLERY\"></span></div><div class=\"grid-view\" \nng-sortable=\"vm.gallerySortable\" md-cols=\"{{vm.cols}}\" md-row-height=\"250\" md-gutter=\"12px\" md-gutter-gt-sm=\"8px\" \nng-hide=\"vm.selectedGalleryChildren.length == 0 || !vm.selectedGalleryChildren\"><div \nng-click=\"vm.openGalleryFolder(gallery)\" ng-repeat=\"gallery in vm.selectedGalleryChildren\" \ndata-id=\"{{gallery.id_gallery}}\" class=\"ms-card grid-element sortable pointer\"><div class=\"ms-card-content-wrapper\">\n<div class=\"template-9\" layout=\"column\" layout-align=\"space-between stretch\"><div class=\"media\" flex layout=\"row\" \nlayout-align=\"center center\"><img ng-src=\"{{gallery.cover.imageUrl || gallery.imageUrl}}\" class=\"image\" \nstyle=\"max-height: 100%; max-width: 100%\"></div><div class=\"header p-16\" flex><div layout=\"row\" \nlayout-align=\"space-between center\" flex><div class=\"size text-truncate\" layout=\"row\" layout-align=\"start left\">\n<md-icon ng-if=\"!gallery.children && gallery.gallery_type == 0\" md-font-icon=\"icon-folder\" \nclass=\"s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"!gallery.children && gallery.gallery_type == 1\" md-font-icon=\"icon-folder-image\" \nclass=\"s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"!gallery.children && gallery.gallery_type == 2\" md-font-icon=\"qiu-icon-video-folder\" \nclass=\"s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"!gallery.children && gallery.gallery_type == 3\" md-font-icon=\"qiu-icon-audio-folder\" \nclass=\"s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"!gallery.children && gallery.gallery_type == 4\" md-font-icon=\"qiu-icon-file-folder\" \nclass=\"s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"gallery.children && gallery.gallery_type == 0\" md-font-icon=\"icon-folder-multiple\" \nclass=\"s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"gallery.children && gallery.gallery_type == 1\" md-font-icon=\"icon-folder-multiple-image\" \nclass=\"s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"gallery.children && gallery.gallery_type == 2\" md-font-icon=\"qiu-icon-video-gallery\" \nclass=\"s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"gallery.children && gallery.gallery_type == 3\" md-font-icon=\"qiu-icon-audio-gallery\" \nclass=\"s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"gallery.children && gallery.gallery_type == 4\" md-font-icon=\"qiu-icon-file-gallery\" \nclass=\"s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><span class=\"grey-500-fg\"><span class=\"filename\">\n{{gallery.gallery_name}}</span> <span class=\"filename\">\n({{gallery.element_total_count ? gallery.element_total_count : \'MEDIA.NO_FILES\' | translate}})</span></span></div><div \nclass=\"size text-truncate\" layout=\"row\" layout-align=\"start right\"><md-menu><md-icon \nng-click=\"vm.openMenu($mdMenu, $event); $event.stopPropagation()\" \nmd-svg-icon=\"assets/angular-material-assets/img/icons/more_vert.svg\"></md-icon><md-menu-content width=\"2\">\n<md-menu-item><md-button ng-click=\"vm.editGallery(gallery)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>Edit\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.deleteGallery($event, gallery)\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-default-theme md-font material-icons icon-delete\"></md-icon>Remove</md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></div></div></div></div><div class=\"toolbar\" \nlayout=\"row\" layout-align=\"space-between center\" ng-include=\"\'app/main/apps/mediahub/views/toolbar.html\'\"></div><div \nng-if=\"(!vm.isRoot || $root.pagination_searchquery==true) && (vm.items.length> 0 || vm.selectedGalleryChildren)\"><div \nclass=\"mail-list-item filter-selected\" ng-if=\"$root.pagination_searchquery==true\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"info\" flex><div class=\"name\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-filter\" class=\"s20 mr-8 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><div class=\"title\" layout=\"row\" \nlayout-align=\"start center\"><div ng-repeat=\"filterable in refFilterables track by $index\" class=\"inline-block\"><div \nng-repeat=\"label in filterable.values | filterInArray:filterable.selected:\'value\' track by $index\" \nclass=\"mr-5 tag-list inline-block\"><span class=\"grey-50-fg\">{{label.name}}</span></div></div></div><div \nclass=\"title text-truncate pl-10\" layout=\"row\" layout-align=\"start center\" ng-if=\"$root.modelSearch\">\n{{$root.modelSearch}}</div></div></div><div class=\"buttons\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-close s20\" ng-click=\"vm.resetSearch()\" class=\"ml-10\"><md-tooltip hide show-gt-xs><span \ntranslate=\"CONTENT.REMOVE_FILTERS\">Remove filters</span></md-tooltip></md-icon></div></div><div \nclass=\"media mail-list-pane-grid pt-20 pb-30\" flex layout-padding><div class=\"grid-view\" \nng-sortable=\"vm.mediaSortable\" md-cols=\"{{vm.cols}}\" md-row-height=\"250\" md-gutter=\"12px\" ng-if=\"sortField == \'sort\'\" \nmd-gutter-gt-sm=\"8px\"><div ng-repeat=\"mediaItem in vm.items\" ng-click=\"vm.selectMediaFile(mediaItem)\" \ndata-id=\"{{mediaItem.id_media}}\" class=\"ms-card grid-element sortable\" \nng-class=\"{\'selected\': vm.ImageIDSelected === mediaItem.id_media}\"><div class=\"ms-card-content-wrapper\"><div \nclass=\"template-9\" layout=\"column\" layout-align=\"space-between stretch\"><div class=\"media\" flex layout=\"row\" \nlayout-align=\"center center\"><img ng-src=\"{{mediaItem.imageUrl}}\" class=\"image\" \nstyle=\"max-height: 100%; max-width: 100%\"></div><div class=\"header p-16\" flex><div layout=\"row\" \nlayout-align=\"space-between center\" flex><div class=\"size block\" layout=\"row\" layout-align=\"start left\"><strong \nclass=\"mr-5\">#{{mediaItem.id_media}}</strong> <span class=\"grey-500-fg\"><span ng-if=\"mediaItem.filename\" \nclass=\"filename\">{{mediaItem.filename}}</span></span></div><md-checkbox ng-checked=\"vm.isSelected(mediaItem)\" \nng-click=\"vm.toggleSelectThread(mediaItem, $event)\" aria-label=\"{{vm.isSelected(mediaItem) ? \'Deselect\' : \'Select\'}}\" \nclass=\"ml-5\"></md-checkbox></div></div></div></div></div></div><div class=\"grid-view\" md-cols=\"{{vm.cols}}\" \nmd-row-height=\"250\" md-gutter=\"12px\" ng-if=\"sortField != \'sort\'\" md-gutter-gt-sm=\"8px\"><div \nng-repeat=\"mediaItem in vm.items\" ng-click=\"vm.selectMediaFile(mediaItem)\" data-id=\"{{mediaItem.id_media}}\" \nclass=\"ms-card grid-element sortable\" ng-class=\"{\'selected\': vm.ImageIDSelected === mediaItem.id_media}\"><div \nclass=\"ms-card-content-wrapper\"><div class=\"template-9\" layout=\"column\" layout-align=\"space-between stretch\"><div \nclass=\"media\" flex layout=\"row\" layout-align=\"center center\"><img ng-src=\"{{mediaItem.imageUrl}}\" class=\"image\" \nstyle=\"max-height: 100%; max-width: 100%\"></div><div class=\"header p-16\" flex><div layout=\"row\" \nlayout-align=\"space-between center\" flex><div class=\"size block\" layout=\"row\" layout-align=\"start left\"><strong \nclass=\"mr-5\">#{{mediaItem.id_media}}</strong> <span class=\"grey-500-fg\"><span ng-if=\"mediaItem.filename\" \nclass=\"filename\">{{mediaItem.filename}}</span></span></div><md-checkbox ng-checked=\"vm.isSelected(mediaItem)\" \nng-click=\"vm.toggleSelectThread(mediaItem, $event)\" aria-label=\"{{vm.isSelected(mediaItem) ? \'Deselect\' : \'Select\'}}\" \nclass=\"ml-5\"></md-checkbox></div></div></div></div></div></div></div><div class=\"no-threads\" \nng-if=\"vm.items.length == 0 && vm.selectedGalleryChildren\"><span class=\"grey-fg\" translate=\"MEDIA.NO_ITEMS_FILES\">\n</span></div><md-divider ng-if=\"!vm.isRoot && (vm.items.length> 0 || vm.selectedGalleryChildren)\"></md-divider><div \nng-if=\"!vm.isRoot && (vm.items.length> 0 || vm.selectedGalleryChildren)\" class=\"toolbar\" layout=\"row\" \nlayout-align=\"end center\"><div layout=\"row\" layout-align=\"center center\" \nng-style=\"{\'display\' : vm.isLoading ? \'none\' : \'block\'}\"><span class=\"page-info\">\n{{pagination_totalItems | number}} items found.</span><md-button aria-label=\"Previous\" class=\"md-icon-button arrow\" \nng-click=\"pagination_prevPage()\" ng-disabled=\"pagination_firstPage()\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button><span \nclass=\"page-info\">{{pagination_current_page | number}} / {{pagination_total_pages | number}}</span><md-button \naria-label=\"Next\" class=\"md-icon-button arrow\" ng-click=\"pagination_nextPage()\" ng-disabled=\"pagination_morePages()\" \ntranslate=\"\" translate-attr-aria-label=\"CONTENT.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button>\n</div></div><div class=\"no-threads\" ng-if=\"vm.items.length == 0 && !vm.selectedGalleryChildren\"><span class=\"grey-fg\" \ntranslate=\"MEDIA.NO_ITEMS\"></span></div></div></div>");
$templateCache.put("app/main/apps/mediahub/views/list/items-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-show=\"vm.isLoading\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nclass=\"mail-list-item filter-selected\" ng-if=\"vm.selectedGallery\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"info\" flex><div class=\"name\" layout=\"row\" layout-align=\"start center\"><md-icon \nng-if=\"!vm.selectedGallery.children && vm.selectedGallery.gallery_type == 0\" md-font-icon=\"icon-folder\" \nclass=\"s20 mr-8 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"!vm.selectedGallery.children && vm.selectedGallery.gallery_type == 1\" md-font-icon=\"icon-folder-image\" \nclass=\"s20 mr-8 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"!vm.selectedGallery.children && vm.selectedGallery.gallery_type == 2\" md-font-icon=\"qiu-icon-video-folder\" \nclass=\"s20 mr-8 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"!vm.selectedGallery.children && vm.selectedGallery.gallery_type == 3\" md-font-icon=\"qiu-icon-audio-folder\" \nclass=\"s20 mr-8 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"!vm.selectedGallery.children && vm.selectedGallery.gallery_type == 4\" md-font-icon=\"qiu-icon-file-folder\" \nclass=\"s20 mr-8 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"vm.selectedGallery.children && vm.selectedGallery.gallery_type == 0\" md-font-icon=\"icon-folder-multiple\" \nclass=\"s20 mr-8 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"vm.selectedGallery.children && vm.selectedGallery.gallery_type == 1\" md-font-icon=\"icon-folder-multiple-image\" \nclass=\"s20 mr-8 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"vm.selectedGallery.children && vm.selectedGallery.gallery_type == 2\" md-font-icon=\"qiu-icon-video-gallery\" \nclass=\"s20 mr-8 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"vm.selectedGallery.children && vm.selectedGallery.gallery_type == 3\" md-font-icon=\"qiu-icon-audio-gallery\" \nclass=\"s20 mr-8 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"vm.selectedGallery.children && vm.selectedGallery.gallery_type == 4\" md-font-icon=\"qiu-icon-file-gallery\" \nclass=\"s20 mr-8 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><div class=\"title text-truncate\" layout=\"row\" \nlayout-align=\"start center\">{{vm.selectedGallery.gallery_name}} <span ng-if=\"!vm.isLoading\">\n({{pagination_totalItems | number}})</span></div></div></div><div class=\"buttons\" layout=\"row\" \nlayout-align=\"start center\"><div><md-switch hide class=\"no-label\" ng-checked=\"vm.includeSubgalleries\" \nng-click=\"vm.toggleIncludeSubgalleries($event)\" aria-label=\"{{vm.includeSubgalleries ? \'Uncheck\':\'check\'}}\">\n</md-switch><md-tooltip><span translate=\"CONTENT.INCLUDE_SUBGROUPS\">Include subgroups</span></md-tooltip></div><md-icon\n md-font-icon=\"icon-close s20\" ng-click=\"vm.unselectGalleries()\" class=\"ml-10\" \nng-if=\"!vm.selectedGallery.is_qiu_restricted\"><md-tooltip hide show-gt-xs><span translate=\"CONTENT.DESELECT_GROUP\">\nDeselect group</span></md-tooltip></md-icon></div></div><div class=\"mail-list-item filter-selected\" \nng-if=\"$root.pagination_searchquery==true\" layout=\"row\" layout-align=\"start center\"><div class=\"info\" flex><div \nclass=\"name\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-filter\" class=\"s20 mr-8 ml-0 mb-0\" \naria-hidden=\"true\"></md-icon><div class=\"title\" layout=\"row\" layout-align=\"start center\"><div \nng-repeat=\"filterable in refFilterables track by $index\" class=\"inline-block\"><div \nng-repeat=\"label in filterable.values | filterInArray:filterable.selected:\'value\' track by $index\" \nclass=\"mr-5 tag-list inline-block\"><span class=\"grey-50-fg\">{{label.name}}</span></div></div></div><div \nclass=\"title text-truncate pl-10\" layout=\"row\" layout-align=\"start center\" ng-if=\"$root.modelSearch\">\n{{$root.modelSearch}}</div></div></div><div class=\"buttons\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-close s20\" ng-click=\"vm.resetSearch()\" class=\"ml-10\"><md-tooltip hide show-gt-xs><span \ntranslate=\"CONTENT.REMOVE_FILTERS\">Remove filters</span></md-tooltip></md-icon></div></div><div class=\"no-threads\" \nng-if=\"!vm.isLoading && vm.items.length === 0\" ng-hide=\"vm.isLoading\">There are no items!</div><div \nid=\"list-content-data\" ng-style=\"{\'opacity\' : vm.isLoading ? 0.2 : 1}\" ms-scroll=\"vm.msScrollOptions\" \nng-class=\"{\'group-filter\': vm.selectedGallery,\'other-filter\':$root.pagination_searchquery==true}\" class=\"scrollable\" \nng-if=\"vm.items.length > 0\"><google-gallery on-select=\"vm.selectMediaFileSidenav(mediaItem)\" \nng-if=\"vm.currentListView == \'gridGoogle\'\" items=\"vm.items\"></google-gallery><div class=\"media mail-list-pane-grid\" \nflex layout-padding ng-if=\"vm.currentListView == \'grid\'\" \nng-class=\"{\'grid-cols-2\': vm.mediaSelected && vm.isOpenSidenavGalleries, \'grid-cols-3\': vm.mediaSelected && !vm.isOpenSidenavGalleries, \'grid-cols-4\': !vm.mediaSelected && vm.isOpenSidenavGalleries, \'grid-cols-5\': !vm.mediaSelected && !vm.isOpenSidenavGalleries}\">\n<div class=\"grid-view\" md-cols=\"{{vm.cols}}\" md-row-height=\"250\" md-gutter=\"12px\" md-gutter-gt-sm=\"8px\" \nng-sortable=\"vm.mediaSortable\" ng-if=\"vm.selectedGallery && sortField == \'sort\'\" drag-select><div \nng-repeat=\"mediaItem in vm.items\" class=\"grid-element sortable\" data-id=\"{{mediaItem.id_media}}\"><div class=\"ms-card\" \nflex ng-click=\"vm.selectMediaFile(mediaItem)\" \nng-class=\"{\'starred\': thread.starred, \'selected\': vm.ImageIDSelected === mediaItem.id_media, \'checked\': vm.isChecked(thread)}\" \nng-include=\"vm.subviews[mediaItem.mediaType]\"></div></div></div><div class=\"grid-view\" md-cols=\"{{vm.cols}}\" \nmd-row-height=\"250\" md-gutter=\"12px\" md-gutter-gt-sm=\"8px\" ng-if=\"!vm.selectedGallery || sortField != \'sort\'\" \ndrag-select><div ng-repeat=\"mediaItem in vm.items\" class=\"grid-element sortable\" data-id=\"{{mediaItem.id_media}}\"><div \nclass=\"ms-card\" flex ng-click=\"vm.selectMediaFile(mediaItem)\" \nng-class=\"{\'starred\': thread.starred, \'selected\': vm.ImageIDSelected === mediaItem.id_media, \'checked\': vm.isChecked(thread)}\" \nng-include=\"vm.subviews[mediaItem.mediaType]\"></div></div></div></div><div ng-sortable=\"vm.mediaSortable\" \nng-if=\"vm.selectedGallery && vm.currentListView == \'list\'\"><div class=\"mail-list-item sortable\" \nng-repeat=\"mediaItem in vm.items\" ng-click=\"vm.selectMediaFile(mediaItem)\" \nng-class=\"{\'starred\': thread.starred, \'selected\': vm.ImageIDSelected === mediaItem.id_media, \'checked\': vm.isChecked(thread)}\" \ndata-id=\"{{mediaItem.id_media}}\"><div ng-include=\"vm.subviews[\'list\']\"></div></div></div><div \nng-if=\"!vm.selectedGallery && vm.currentListView == \'list\'\"><div class=\"mail-list-item\" \nng-repeat=\"mediaItem in vm.items\" ng-click=\"vm.selectMediaFile(mediaItem)\" \nng-class=\"{\'starred\': thread.starred, \'selected\': vm.ImageIDSelected === mediaItem.id_media, \'checked\': vm.isChecked(thread)}\" \ndata-id=\"{{mediaItem.id_media}}\"><div ng-include=\"vm.subviews[\'list\']\"></div></div></div><md-divider></md-divider><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"end center\"><div layout=\"row\" layout-align=\"center center\" \nng-style=\"{\'display\' : vm.isLoading ? \'none\' : \'block\'}\"><span class=\"page-info\">\n{{pagination_totalItems | number}} items found.</span><md-button aria-label=\"Previous\" class=\"md-icon-button arrow\" \nng-click=\"pagination_prevPage()\" ng-disabled=\"pagination_firstPage()\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button><span \nclass=\"page-info\">Page {{pagination_page | number}} / {{pagination_total_pages | number}}</span><md-button \naria-label=\"Next\" class=\"md-icon-button arrow\" ng-click=\"pagination_nextPage()\" ng-disabled=\"pagination_morePages()\" \ntranslate=\"\" translate-attr-aria-label=\"CONTENT.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button>\n</div></div></div>");
$templateCache.put("app/main/apps/mediahub/sidenavs/images/galleries-sidenav.html","<div flex layout=\"column\" layout-align=\"center center\" ng-hide=\"!vm.loadingGalleries\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><md-toolbar \nid=\"toolbarGalleries\" class=\"md-default-theme grey-100-bg grey-600-fg pr-16 pl-16\" layout=\"row\" \nlayout-align=\"space-between center\"><div ng-if=\"!vm.showTreeSearch\" class=\"md-toolbar-tools p-0\" \naria-label=\"Galleries\" layout=\"row\" layout-align=\"start center\"><md-icon hide-gt-sm ng-click=\"vm.closeSidenav()\" \nmd-font-icon=\"icon-backburger\" \nclass=\"m-0 mr-8 grey-600-fg md-icon-button md-button md-default-theme md-font material-icons\" aria-hidden=\"true\">\n</md-icon><div translate-attr-aria-label=\"MEDIA.GALLERIES\" translate=\"MEDIA.GALLERIES\" class=\"grey-600-fg\" \naria-label=\"GALLERIES\">GALLERIES</div></div><div ng-if=\"!vm.showTreeSearch\" layout=\"row\" layout-align=\"end center\">\n<md-icon id=\"\" ng-click=\"vm.createGallery($event)\" md-font-icon=\"icon-plus\" \nclass=\"m-0 grey-600-fg md-icon-button md-button md-default-theme md-font material-icons\" aria-hidden=\"true\">\n<md-tooltip><span translate=\"CONTENT.ADD\">Add</span></md-tooltip></md-icon><div \nclass=\"divider-vertical hide show-gt-xs\" hide=\"\" show-gt-xs=\"\"></div><md-icon ng-if=\"vm.sortDirGalleries !== \'ASC\'\" \nng-click=\"vm.sortDirGalleries=\'ASC\'; vm.getCleanMediaGalleries()\" md-font-icon=\"icon-sort-descending\" \nclass=\"m-0 grey-600-fg md-icon-button md-button md-default-theme md-font material-icons\" translate=\"\" \ntranslate-attr-aria-label=\"TODO.SORT_DIRECTION\"></md-icon><md-icon ng-if=\"vm.sortDirGalleries === \'ASC\'\" \nng-click=\"vm.sortDirGalleries=\'DESC\'; vm.getCleanMediaGalleries()\" md-font-icon=\"icon-sort-ascending\" \nclass=\"m-0 grey-600-fg md-icon-button md-button md-default-theme md-font material-icons\" translate=\"\" \ntranslate-attr-aria-label=\"TODO.SORT_DIRECTION\"></md-icon><md-menu><button aria-label=\"Filters\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\" show-gt-xs=\"\" translate=\"\" translate-attr-aria-label=\"CONTENT.FILTERS\"><md-icon \nmd-font-icon=\"m-0 grey-600-fg icon-chevron-down\"><md-tooltip><span translate=\"CONTENT.ORDER_BY\">Order</span>\n</md-tooltip></md-icon></button><md-menu-content width=\"4\"><md-menu-item \nng-repeat=\"(key, value) in vm.orderByGalleries\"><md-button aria-label=\"All\" \nng-click=\"vm.sortFieldGalleries=value; vm.getCleanMediaGalleries()\"><div layout=\"row\" \nlayout-align=\"space-between center\"><span>Order by {{key | translate}} </span><i class=\"icon-check s16\" \nng-if=\"value == vm.sortFieldGalleries\"></i></div></md-button></md-menu-item></md-menu-content></md-menu><div \nclass=\"divider-vertical hide show-gt-xs\" hide=\"\" show-gt-xs=\"\"></div><md-icon ng-if=\"!vm.allGalleriesExpanded\" \nng-click=\"vm.expandAllGalleries()\" md-font-icon=\"icon-unfold-more\" \nclass=\"m-0 grey-600-fg md-icon-button md-button md-default-theme md-font material-icons\"><md-tooltip hide show-gt-xs>\n<span>Expand all</span></md-tooltip></md-icon><md-icon ng-if=\"vm.allGalleriesExpanded\" \nng-click=\"vm.collapseAllGalleries()\" md-font-icon=\"icon-unfold-less\" \nclass=\"m-0 grey-600-fg md-icon-button md-button md-default-theme md-font material-icons\"><md-tooltip hide show-gt-xs>\n<span>Collapse all</span></md-tooltip></md-icon><div class=\"divider-vertical hide show-gt-xs\" hide=\"\" show-gt-xs=\"\">\n</div><label for=\"ms-search-bar-input\"><md-icon ng-click=\"vm.showTreeSearch= true\" md-font-icon=\"icon-magnify\" \nclass=\"m-0 grey-600-fg md-icon-button md-button md-default-theme md-font material-icons\"><md-tooltip hide show-gt-xs>\n<span translate=\"TOOLBAR.SEARCH\">Search</span></md-tooltip></md-icon></label></div><div ng-if=\"vm.showTreeSearch\" \nlayout=\"row\" class=\"media-gallery-tree-search\"><div layout=\"row\" flex layout-align=\"start center\"><label \nfor=\"search-bar-input\"><md-icon md-font-icon=\"icon-magnify\" class=\"grey-600-fg md-icon-button md-button\"><md-tooltip \nhide show-gt-xs><span translate=\"TOOLBAR.SEARCH\">Search</span></md-tooltip></md-icon></label><md-icon \nmd-font-icon=\"icon-close-circle\" class=\"grey-600-fg md-icon-button md-button\" ng-if=\"vm.treeSearch\" \nng-click=\"vm.treeSearch= null\"></md-icon><input type=\"text\" ng-change=\"vm.expandGalleries()\" id=\"search-bar-input\" \nclass=\"grey-600-fg grey-100-bg\" ng-model=\"vm.treeSearch\" placeholder=\"Search\" md-autofocus translate \ntranslate-attr-placeholder=\"TOOLBAR.SEARCH\" flex><md-icon layout-align=\"end center\" \nng-click=\"vm.showTreeSearch = false; vm.treeSearch = null\" md-font-icon=\"icon-close\" \nclass=\"media-gallery-tree-search-collapser icon s24 grey-600-fg\"></md-icon></div></div></md-toolbar><md-content \nng-hide=\"vm.loadingGalleries\" ms-scroll class=\"\" flex><div class=\"navigation-simple\" layout=\"column\"><div hidden \nid=\"includeSubgalleries\" data-include-subgalleries=\"{{vm.includeSubgalleries}}\"></div><qiu-tree \nexpandedids=\"vm.expandedids\" selected=\"vm.selectedGallery.id_gallery\" \non-edit=\"vm.openGalleryDialog($event, item, parent)\" on-select=\"vm.handleGallerySelect(item)\" \nng-if=\"vm.CleanMediaGalleries\" search=\"vm.treeSearch\" flat-search=\"true\" tree=\"vm.CleanMediaGalleries\"></qiu-tree>\n</div></md-content>");
$templateCache.put("app/main/apps/mediahub/views/tabs/tab-ai.html","<div class=\"form-wrapper md-whiteframe-1dp p-0-i\" flex=\"100\"><form name=\"vm.basicFormAi\" class=\"md-inline-form\" \nnovalidate><div layout=\"column\" layout-xs=\"column\"><div ng-if=\"vm.image.meta_analyses.google_crop_hints_detection\"><div\n layout=\"row\"><md-list flex=\"100\" class=\"p-0 bb pointer\" ng-click=\"googleCropHintsDetection=!googleCropHintsDetection\">\n<md-list-item class=\"md-toolbar-tools grey-100-bg p-0-i\"><div layout=\"row\" layout-align=\"space-between center\" \nflex=\"100\"><h3 class=\"grey-700-fg ph-25\" translate=\"MEDIA.CROPPROCESS.GOOGLE_CROP_HINTS_DETECTION\"></h3><md-button \nclass=\"md-icon-button\"><md-icon ng-if=\"!googleCropHintsDetection\" md-font-icon=\"icon-chevron-right\" class=\"mh-5\">\n</md-icon><md-icon ng-if=\"googleCropHintsDetection\" md-font-icon=\"icon-chevron-down\" class=\"mh-5\"></md-icon>\n</md-button></div></md-list-item></md-list></div><div class=\"p-10\" layout=\"column\" flex=\"100\" \nng-show=\"googleCropHintsDetection\" ng-repeat=\"item in vm.image.meta_analyses.google_crop_hints_detection.cropHints\">\n<div ng-repeat=\"(key, item) in item\"><div layout=\"row\" flex=\"100\" class=\"p-10\">{{key}}: {{item}}</div></div><md-divider\n ng-if=\"!$last\"></md-divider></div></div><div ng-if=\"vm.image.meta_analyses.google_face_detection\"><div layout=\"row\">\n<md-list flex=\"100\" class=\"p-0 bb pointer\" ng-click=\"googleFaceDetection=!googleFaceDetection\"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg p-0-i\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><h3 \nclass=\"grey-700-fg ph-25\" translate=\"MEDIA.CROPPROCESS.GOOGLE_FACE_DETECTION\"></h3><md-button class=\"md-icon-button\">\n<md-icon ng-if=\"!googleFaceDetection\" md-font-icon=\"icon-chevron-right\" class=\"mh-5\"></md-icon><md-icon \nng-if=\"googleFaceDetection\" md-font-icon=\"icon-chevron-down\" class=\"mh-5\"></md-icon></md-button></div></md-list-item>\n</md-list></div><div class=\"p-10\" layout=\"column\" flex=\"100\" ng-show=\"googleFaceDetection\" \nng-repeat=\"item in vm.image.meta_analyses.google_face_detection\"><div ng-repeat=\"(key, item) in item\"><div \nlayout=\"row\" flex=\"100\" class=\"p-10\">{{key}}: {{item}}</div></div><md-divider ng-if=\"!$last\"></md-divider></div></div>\n<div ng-if=\"vm.image.meta_analyses.google_image_properties_detection\"><div layout=\"row\"><md-list flex=\"100\" \nclass=\"p-0 bb pointer\" ng-click=\"googleImagePropertiesDetection=!googleImagePropertiesDetection\"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg p-0-i\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><h3 \nclass=\"grey-700-fg ph-25\" translate=\"MEDIA.CROPPROCESS.GOOGLE_IMAGE_PROPERTIES_DETECTION\"></h3><md-button \nclass=\"md-icon-button\"><md-icon ng-if=\"!googleImagePropertiesDetection\" md-font-icon=\"icon-chevron-right\" class=\"mh-5\">\n</md-icon><md-icon ng-if=\"googleImagePropertiesDetection\" md-font-icon=\"icon-chevron-down\" class=\"mh-5\"></md-icon>\n</md-button></div></md-list-item></md-list></div><div class=\"p-10\" layout=\"column\" flex=\"100\" \nng-show=\"googleImagePropertiesDetection\" \nng-repeat=\"(key, item) in vm.image.meta_analyses.google_image_properties_detection\"><div layout=\"row\" flex=\"100\" \nclass=\"p-10\">{{key}}: {{item}}</div><md-divider ng-if=\"!$last\"></md-divider></div></div><div \nng-if=\"vm.image.meta_analyses.google_label_detection\"><div layout=\"row\"><md-list flex=\"100\" class=\"p-0 bb pointer\" \nng-click=\"googleLabelDetection=!googleLabelDetection\"><md-list-item class=\"md-toolbar-tools grey-100-bg p-0-i\"><div \nlayout=\"row\" layout-align=\"space-between center\" flex=\"100\"><h3 class=\"grey-700-fg ph-25\" \ntranslate=\"MEDIA.CROPPROCESS.GOOGLE_LABEL_DETECTION\"></h3><md-button class=\"md-icon-button\"><md-icon \nng-if=\"!googleLabelDetection\" md-font-icon=\"icon-chevron-right\" class=\"mh-5\"></md-icon><md-icon \nng-if=\"googleLabelDetection\" md-font-icon=\"icon-chevron-down\" class=\"mh-5\"></md-icon></md-button></div></md-list-item>\n</md-list></div><div class=\"p-10\" layout=\"column\" flex=\"100\" ng-show=\"googleLabelDetection\" \nng-repeat=\"item in vm.image.meta_analyses.google_label_detection\"><div ng-repeat=\"(key, item) in item\"><div \nlayout=\"row\" flex=\"100\" class=\"p-10\">{{key}}: {{item}}</div></div><md-divider ng-if=\"!$last\"></md-divider></div></div>\n<div ng-if=\"vm.image.meta_analyses.google_logo_detection\"><div layout=\"row\"><md-list flex=\"100\" class=\"p-0 bb pointer\" \nng-click=\"googleLogoDetection=!googleLogoDetection\"><md-list-item class=\"md-toolbar-tools grey-100-bg p-0-i\"><div \nlayout=\"row\" layout-align=\"space-between center\" flex=\"100\"><h3 class=\"grey-700-fg ph-25\" \ntranslate=\"MEDIA.CROPPROCESS.GOOGLE_LOGO_DETECTION\"></h3><md-button class=\"md-icon-button\"><md-icon \nng-if=\"!googleLogoDetection\" md-font-icon=\"icon-chevron-right\" class=\"mh-5\"></md-icon><md-icon \nng-if=\"googleLogoDetection\" md-font-icon=\"icon-chevron-down\" class=\"mh-5\"></md-icon></md-button></div></md-list-item>\n</md-list></div><div class=\"p-10\" layout=\"column\" flex=\"100\" ng-show=\"googleLogoDetection\" \nng-repeat=\"item in vm.image.meta_analyses.google_logo_detection\"><div ng-repeat=\"(key, item) in item\"><div \nlayout=\"row\" flex=\"100\" class=\"p-10\">{{key}}: {{item}}</div></div><md-divider ng-if=\"!$last\"></md-divider></div></div>\n<div ng-if=\"vm.image.meta_analyses.google_object_detection\"><div layout=\"row\"><md-list flex=\"100\" \nclass=\"p-0 bb pointer\" ng-click=\"googleObjectDetection=!googleObjectDetection\"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg p-0-i\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><h3 \nclass=\"grey-700-fg ph-25\" translate=\"MEDIA.CROPPROCESS.GOOGLE_OBJECT_DETECTION\"></h3><md-button class=\"md-icon-button\">\n<md-icon ng-if=\"!googleObjectDetection\" md-font-icon=\"icon-chevron-right\" class=\"mh-5\"></md-icon><md-icon \nng-if=\"googleObjectDetection\" md-font-icon=\"icon-chevron-down\" class=\"mh-5\"></md-icon></md-button></div></md-list-item>\n</md-list></div><div class=\"p-10\" layout=\"column\" flex=\"100\" ng-show=\"googleObjectDetection\" \nng-repeat=\"item in vm.image.meta_analyses.google_object_detection\"><div ng-repeat=\"(key, item) in item\"><div \nlayout=\"row\" flex=\"100\" class=\"p-10\">{{key}}: {{item}}</div></div><md-divider ng-if=\"!$last\"></md-divider></div></div>\n<div ng-if=\"vm.image.meta_analyses.google_safe_search_properties_detection\"><div layout=\"row\"><md-list flex=\"100\" \nclass=\"p-0 bb pointer\" ng-click=\"googleSaveSearchPropertiesDetection=!googleSaveSearchPropertiesDetection\">\n<md-list-item class=\"md-toolbar-tools grey-100-bg p-0-i\"><div layout=\"row\" layout-align=\"space-between center\" \nflex=\"100\"><h3 class=\"grey-700-fg ph-25\" translate=\"MEDIA.CROPPROCESS.GOOGLE_SAFE_SEARCH_PROPERTIES_DETECTION\"></h3>\n<md-button class=\"md-icon-button\"><md-icon ng-if=\"!googleSaveSearchPropertiesDetection\" \nmd-font-icon=\"icon-chevron-right\" class=\"mh-5\"></md-icon><md-icon ng-if=\"googleSaveSearchPropertiesDetection\" \nmd-font-icon=\"icon-chevron-down\" class=\"mh-5\"></md-icon></md-button></div></md-list-item></md-list></div><div \nclass=\"p-10\" layout=\"column\" flex=\"100\" ng-show=\"googleSaveSearchPropertiesDetection\" \nng-repeat=\"(key, item) in vm.image.meta_analyses.google_safe_search_properties_detection\"><div layout=\"row\" flex=\"100\" \nclass=\"p-10\">{{key}}: {{item}}</div><md-divider ng-if=\"!$last\"></md-divider></div></div><div \nng-if=\"vm.image.meta_analyses.google_text_detection\"><div layout=\"row\"><md-list flex=\"100\" class=\"p-0 bb pointer\" \nng-click=\"googleTextDetection=!googleTextDetection\"><md-list-item class=\"md-toolbar-tools grey-100-bg p-0-i\"><div \nlayout=\"row\" layout-align=\"space-between center\" flex=\"100\"><h3 class=\"grey-700-fg ph-25\" \ntranslate=\"MEDIA.CROPPROCESS.GOOGLE_TEXT_DETECTION\"></h3><md-button class=\"md-icon-button\"><md-icon \nng-if=\"!googleTextDetection\" md-font-icon=\"icon-chevron-right\" class=\"mh-5\"></md-icon><md-icon \nng-if=\"googleTextDetection\" md-font-icon=\"icon-chevron-down\" class=\"mh-5\"></md-icon></md-button></div></md-list-item>\n</md-list></div><div class=\"p-10\" layout=\"column\" flex=\"100\" ng-show=\"googleTextDetection\" \nng-repeat=\"item in vm.image.meta_analyses.google_text_detection\"><div ng-repeat=\"(key, item) in item\"><div \nlayout=\"row\" flex=\"100\" class=\"p-10\">{{key}}: {{item}}</div></div><md-divider ng-if=\"!$last\"></md-divider></div></div>\n<div ng-if=\"vm.image.meta_analyses.google_web_detection\"><div layout=\"row\"><md-list flex=\"100\" class=\"p-0 bb pointer\" \nng-click=\"googleWebDetection=!googleWebDetection\"><md-list-item class=\"md-toolbar-tools grey-100-bg p-0-i\"><div \nlayout=\"row\" layout-align=\"space-between center\" flex=\"100\"><h3 class=\"grey-700-fg ph-25\" \ntranslate=\"MEDIA.CROPPROCESS.GOOGLE_WEB_DETECTION\"></h3><md-button class=\"md-icon-button\"><md-icon \nng-if=\"!googleWebDetection\" md-font-icon=\"icon-chevron-right\" class=\"mh-5\"></md-icon><md-icon \nng-if=\"googleWebDetection\" md-font-icon=\"icon-chevron-down\" class=\"mh-5\"></md-icon></md-button></div></md-list-item>\n</md-list></div><div class=\"p-10\" layout=\"column\" flex=\"100\" ng-show=\"googleWebDetection\" \nng-repeat=\"(key, item) in vm.image.meta_analyses.google_web_detection\"><div layout=\"row\" flex=\"100\" class=\"p-10\">\n{{key}}: {{item}}</div><md-divider ng-if=\"!$last\"></md-divider></div></div><div \nng-if=\"vm.image.meta_analyses.rekognition_detect_faces\"><div layout=\"row\"><md-list flex=\"100\" class=\"p-0 bb pointer\" \nng-click=\"rekognitionDetectFaces=!rekognitionDetectFaces\"><md-list-item class=\"md-toolbar-tools grey-100-bg p-0-i\"><div\n layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><h3 class=\"grey-700-fg ph-25\" \ntranslate=\"MEDIA.CROPPROCESS.REKOGNITION_DETECT_FACES\"></h3><md-button class=\"md-icon-button\"><md-icon \nng-if=\"!rekognitionDetectFaces\" md-font-icon=\"icon-chevron-right\" class=\"mh-5\"></md-icon><md-icon \nng-if=\"rekognitionDetectFaces\" md-font-icon=\"icon-chevron-down\" class=\"mh-5\"></md-icon></md-button></div>\n</md-list-item></md-list></div><div class=\"p-10\" layout=\"column\" flex=\"100\" ng-show=\"rekognitionDetectFaces\" \nng-repeat=\"item in vm.image.meta_analyses.rekognition_detect_faces.FaceDetails\"><div ng-repeat=\"(key, item) in item\">\n<div layout=\"row\" flex=\"100\" class=\"p-10\">{{key}}: {{item}}</div></div><md-divider ng-if=\"!$last\"></md-divider></div>\n</div><div ng-if=\"vm.image.meta_analyses.rekognition_detect_labels\"><div layout=\"row\"><md-list flex=\"100\" \nclass=\"p-0 bb pointer\" ng-click=\"rekognitionDetectLabels=!rekognitionDetectLabels\"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg p-0-i\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><h3 \nclass=\"grey-700-fg ph-25\" translate=\"MEDIA.CROPPROCESS.REKOGNITION_DETECT_LABELS\"></h3><md-button \nclass=\"md-icon-button\"><md-icon ng-if=\"!rekognitionDetectLabels\" md-font-icon=\"icon-chevron-right\" class=\"mh-5\">\n</md-icon><md-icon ng-if=\"rekognitionDetectLabels\" md-font-icon=\"icon-chevron-down\" class=\"mh-5\"></md-icon></md-button>\n</div></md-list-item></md-list></div><div class=\"p-10\" layout=\"column\" flex=\"100\" ng-show=\"rekognitionDetectLabels\" \nng-repeat=\"(key, item) in vm.image.meta_analyses.rekognition_detect_labels\"><div layout=\"row\" flex=\"100\" class=\"p-10\">\n{{key}}: {{item}}</div><md-divider ng-if=\"!$last\"></md-divider></div></div><div \nng-if=\"vm.image.meta_analyses.rekognition_detect_moderation_labels\"><div layout=\"row\"><md-list flex=\"100\" \nclass=\"p-0 bb pointer\" ng-click=\"rekognitionDetectModLabels=!rekognitionDetectModLabels\"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg p-0-i\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><h3 \nclass=\"grey-700-fg ph-25\" translate=\"MEDIA.CROPPROCESS.REKOGNITION_DETECT_MOD_FACES\"></h3><md-button \nclass=\"md-icon-button\"><md-icon ng-if=\"!rekognitionDetectModLabels\" md-font-icon=\"icon-chevron-right\" class=\"mh-5\">\n</md-icon><md-icon ng-if=\"rekognitionDetectModLabels\" md-font-icon=\"icon-chevron-down\" class=\"mh-5\"></md-icon>\n</md-button></div></md-list-item></md-list></div><div class=\"p-10\" layout=\"column\" flex=\"100\" \nng-show=\"rekognitionDetectModLabels\" \nng-repeat=\"(key, item) in vm.image.meta_analyses.rekognition_detect_moderation_labels\"><div layout=\"row\" flex=\"100\" \nclass=\"p-10\">{{key}}: {{item}}</div><md-divider ng-if=\"!$last\"></md-divider></div></div><div \nng-if=\"vm.image.meta_analyses.rekognition_detect_text\"><div layout=\"row\"><md-list flex=\"100\" class=\"p-0 bb pointer\" \nng-click=\"rekognitionDetectText=!rekognitionDetectText\"><md-list-item class=\"md-toolbar-tools grey-100-bg p-0-i\"><div \nlayout=\"row\" layout-align=\"space-between center\" flex=\"100\"><h3 class=\"grey-700-fg ph-25\" \ntranslate=\"MEDIA.CROPPROCESS.REKOGNITION_DETECT_TEXT\"></h3><md-button class=\"md-icon-button\"><md-icon \nng-if=\"!rekognitionDetectText\" md-font-icon=\"icon-chevron-right\" class=\"mh-5\"></md-icon><md-icon \nng-if=\"rekognitionDetectText\" md-font-icon=\"icon-chevron-down\" class=\"mh-5\"></md-icon></md-button></div></md-list-item>\n</md-list></div><div class=\"p-10\" layout=\"column\" flex=\"100\" ng-show=\"rekognitionDetectText\" \nng-repeat=\"item in vm.image.meta_analyses.rekognition_detect_text.TextDetections\"><div ng-repeat=\"(key, item) in item\">\n<div layout=\"row\" flex=\"100\" class=\"p-10\">{{key}}: {{item}}</div></div><md-divider ng-if=\"!$last\"></md-divider></div>\n</div><div ng-if=\"vm.image.meta_analyses.rekognition_recognize_celebrities\"><div layout=\"row\"><md-list flex=\"100\" \nclass=\"p-0 bb pointer\" ng-click=\"rekognitionRecognizeCelebrities=!rekognitionRecognizeCelebrities\"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg p-0-i\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><h3 \nclass=\"grey-700-fg ph-25\" translate=\"MEDIA.CROPPROCESS.REKOGNITION_REKOGNIZE_CELEBS\"></h3><md-button \nclass=\"md-icon-button\"><md-icon ng-if=\"!rekognitionRecognizeCelebrities\" md-font-icon=\"icon-chevron-right\" \nclass=\"mh-5\"></md-icon><md-icon ng-if=\"rekognitionRecognizeCelebrities\" md-font-icon=\"icon-chevron-down\" class=\"mh-5\">\n</md-icon></md-button></div></md-list-item></md-list></div><div class=\"p-10\" layout=\"column\" flex=\"100\" \nng-show=\"rekognitionRecognizeCelebrities\" \nng-repeat=\"(key, item) in vm.image.meta_analyses.rekognition_recognize_celebrities\"><div layout=\"row\" flex=\"100\" \nclass=\"p-10\">{{key}}: {{item}}</div><md-divider ng-if=\"!$last\"></md-divider></div></div><div \nng-if=\"vm.image.meta_analyses.aws_rekognition_person_tracking\"><div layout=\"row\"><md-list flex=\"100\" \nclass=\"p-0 bb pointer\" ng-click=\"personTrackingExpanded=!personTrackingExpanded\"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg p-0-i\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><h3 \nclass=\"grey-700-fg ph-25\" translate=\"MEDIA.METAANALYSES.PERSON_TRACKING\"></h3><md-button class=\"md-icon-button\">\n<md-icon ng-if=\"!personTrackingExpanded\" md-font-icon=\"icon-chevron-right\" class=\"mh-5\"></md-icon><md-icon \nng-if=\"personTrackingExpanded\" md-font-icon=\"icon-chevron-down\" class=\"mh-5\"></md-icon></md-button></div>\n</md-list-item></md-list></div><div class=\"p-10\" layout=\"column\" flex=\"100\" ng-show=\"personTrackingExpanded\" \nng-repeat=\"item in vm.image.meta_analyses.aws_rekognition_person_tracking\"><div ng-repeat=\"(key, item) in item\"><div \nlayout=\"row\" flex=\"100\" class=\"p-10\">{{key}}: {{item}}</div></div><md-divider ng-if=\"!$last\"></md-divider></div></div>\n<div ng-if=\"vm.image.meta_analyses.aws_rekognition_celebrity_recognition\"><div layout=\"row\"><md-list flex=\"100\" \nclass=\"p-0 bb pointer\" ng-click=\"celebRecognitionExpanded=!celebRecognitionExpanded\"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg p-0-i\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><h3 \nclass=\"grey-700-fg ph-25\" translate=\"MEDIA.METAANALYSES.CELEB_RECOGNITION\"></h3><md-button class=\"md-icon-button\">\n<md-icon ng-if=\"!celebRecognitionExpanded\" md-font-icon=\"icon-chevron-right\" class=\"mh-5\"></md-icon><md-icon \nng-if=\"celebRecognitionExpanded\" md-font-icon=\"icon-chevron-down\" class=\"mh-5\"></md-icon></md-button></div>\n</md-list-item></md-list></div><div class=\"p-10\" layout=\"column\" flex=\"100\" ng-show=\"celebRecognitionExpanded\" \nng-repeat=\"item in vm.image.meta_analyses.aws_rekognition_celebrity_recognition\"><div ng-repeat=\"(key, item) in item\">\n<div layout=\"row\" flex=\"100\" class=\"p-10\">{{key}}: {{item}}</div></div><md-divider ng-if=\"!$last\"></md-divider></div>\n</div><div ng-if=\"vm.image.meta_analyses.aws_rekognition_face_detection\"><div layout=\"row\"><md-list flex=\"100\" \nclass=\"p-0 bb pointer\" ng-click=\"faceDetectionExpanded=!faceDetectionExpanded\"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg p-0-i\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><h3 \nclass=\"grey-700-fg ph-25\" translate=\"MEDIA.METAANALYSES.FACE_DETECTION\"></h3><md-button class=\"md-icon-button\"><md-icon\n ng-if=\"!faceDetectionExpanded\" md-font-icon=\"icon-chevron-right\" class=\"mh-5\"></md-icon><md-icon \nng-if=\"faceDetectionExpanded\" md-font-icon=\"icon-chevron-down\" class=\"mh-5\"></md-icon></md-button></div></md-list-item>\n</md-list></div><div class=\"p-10\" layout=\"column\" flex=\"100\" ng-show=\"faceDetectionExpanded\" \nng-repeat=\"item in vm.image.meta_analyses.aws_rekognition_face_detection\"><div ng-repeat=\"(key, item) in item\"><div \nlayout=\"row\" flex=\"100\" class=\"p-10\">{{key}}: {{item}}</div></div><md-divider ng-if=\"!$last\"></md-divider></div></div>\n<div ng-if=\"vm.image.meta_analyses.aws_rekognition_label_detection\"><div layout=\"row\"><md-list flex=\"100\" \nclass=\"p-0 bb pointer\" ng-click=\"labelDetectionExpanded=!labelDetectionExpanded\"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg p-0-i\"><div layout=\"row\" layout-align=\"space-between center\" class=\"flex-100\"><h3 \nclass=\"grey-700-fg ph-25\" translate=\"MEDIA.METAANALYSES.LABEL_DETECTION\"></h3><md-button class=\"md-icon-button\">\n<md-icon ng-if=\"!labelDetectionExpanded\" md-font-icon=\"icon-chevron-right\" class=\"mh-5\"></md-icon><md-icon \nng-if=\"labelDetectionExpanded\" md-font-icon=\"icon-chevron-down\" class=\"mh-5\"></md-icon></md-button></div>\n</md-list-item></md-list></div><div class=\"p-10\" layout=\"column\" flex=\"100\" ng-show=\"labelDetectionExpanded\" \nng-repeat=\"item in vm.image.meta_analyses.aws_rekognition_label_detection\"><div ng-repeat=\"(key, item) in item\"><div \nlayout=\"row\" flex=\"100\" class=\"p-10\">{{key}}: {{item}}</div></div><md-divider ng-if=\"!$last\"></md-divider></div></div>\n<div ng-if=\"vm.image.meta_analyses.rekognition_index_faces\"><div layout=\"row\"><md-list flex=\"100\" \nclass=\"p-0 bb pointer\" ng-click=\"rekognitionIndexFaces=!rekognitionIndexFaces\"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg p-0-i\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><h3 \nclass=\"grey-700-fg ph-25\" translate=\"MEDIA.CROPPROCESS.REKOGNITION_INDEX_FACES\"></h3><md-button class=\"md-icon-button\">\n<md-icon ng-if=\"!rekognitionIndexFaces\" md-font-icon=\"icon-chevron-right\" class=\"mh-5\"></md-icon><md-icon \nng-if=\"rekognitionIndexFaces\" md-font-icon=\"icon-chevron-down\" class=\"mh-5\"></md-icon></md-button></div></md-list-item>\n</md-list></div><div class=\"p-10\" layout=\"column\" flex=\"100\" ng-show=\"rekognitionIndexFaces\" \nng-repeat=\"item in vm.image.meta_analyses.rekognition_index_faces.FaceRecords\"><div><div layout=\"row\" flex=\"100\" \nclass=\"p-10\">{{item.Face.FaceId}}</div></div><md-divider ng-if=\"!$last\"></md-divider></div></div><div \nng-if=\"vm.image.meta_analyses.rekognition_search_faces\"><div layout=\"row\"><md-list flex=\"100\" class=\"p-0 bb pointer\" \nng-click=\"rekognitionSearchFaces=!rekognitionSearchFaces\"><md-list-item class=\"md-toolbar-tools grey-100-bg p-0-i\"><div\n layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><h3 class=\"grey-700-fg ph-25\" \ntranslate=\"MEDIA.CROPPROCESS.REKOGNITION_SEARCH_FACES\"></h3><md-button class=\"md-icon-button\"><md-icon \nng-if=\"!rekognitionSearchFaces\" md-font-icon=\"icon-chevron-right\" class=\"mh-5\"></md-icon><md-icon \nng-if=\"rekognitionSearchFaces\" md-font-icon=\"icon-chevron-down\" class=\"mh-5\"></md-icon></md-button></div>\n</md-list-item></md-list></div><div class=\"p-10\" layout=\"column\" flex=\"100\" ng-show=\"rekognitionSearchFaces\" \nng-repeat=\"(fid, item) in vm.image.meta_analyses.rekognition_search_faces\"><div><div layout=\"row\" flex=\"100\" \nclass=\"p-10\">{{fid}}:<div ng-repeat=\"face in item.FaceMatches\">{{face.Face.FaceId}} ({{face.Similarity}})</div></div>\n</div><md-divider ng-if=\"!$last\"></md-divider></div></div><div ng-if=\"vm.image.meta_analyses.aws_transcription\"><div \nlayout=\"row\"><md-list flex=\"100\" class=\"p-0 bb pointer\" ng-click=\"transcriptionExpanded=!transcriptionExpanded\">\n<md-list-item class=\"md-toolbar-tools grey-100-bg p-0-i\"><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"flex-100\"><h3 class=\"grey-700-fg ph-25\" translate=\"MEDIA.METAANALYSES.TRANSCRIPTION\"></h3><md-button \nclass=\"md-icon-button\"><md-icon ng-if=\"!transcriptionExpanded\" md-font-icon=\"icon-chevron-right\" class=\"mh-5\">\n</md-icon><md-icon ng-if=\"transcriptionExpanded\" md-font-icon=\"icon-chevron-down\" class=\"mh-5\"></md-icon></md-button>\n</div></md-list-item></md-list></div><div class=\"p-10\" layout=\"column\" flex=\"100\" ng-show=\"transcriptionExpanded\" \nng-repeat=\"(key, item) in vm.image.meta_analyses.aws_transcription\"><div layout=\"row\" flex=\"100\" class=\"p-10\" \nng-if=\"key != \'results\'\">{{key}}: {{item}}</div><div ng-if=\"key == \'results\'\" layout=\"column\"><h4>Transcription</h4>\n<div ng-repeat=\"item in item.transcripts\"><div layout=\"row\" flex=\"100\" class=\"p-10\">{{item.transcript}}</div>\n<md-divider></md-divider></div></div><md-divider ng-if=\"!$last\"></md-divider></div></div></div><br><br><div \nlayout=\"row\" ng-if=\"vm.mediaSelected\"><md-list flex=\"100\" class=\"md-toolbar-tools grey-100-bg\" layout=\"row\" \nlayout-align=\"end center\"><md-list-item><md-button type=\"submit\" ng-click=\"vm.saveImage(vm.image)\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"vm.basicForm.$invalid || vm.basicForm.$pristine\" \naria-label=\"SAVE\" translate=\"CONTENT.SAVE\" translate-attr-aria-label=\"CONTENT.SAVE\">SAVE</md-button><md-button \ntype=\"button\" ng-click=\"vm.closeMediaPreview()\" class=\"md-raised md-warn\" aria-label=\"Cancel\">Cancel</md-button>\n</md-list-item></md-list></div></form></div>");
$templateCache.put("app/main/apps/mediahub/views/tabs/tab-cropformats.html","<div ng-if=\"vm.image.cropstatus && vm.image.cropstatus.length\"><md-list class=\"pt-0 crop-formats-list\"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg\"><h3 class=\"grey-700-fg\">Crop Formats</h3></md-list-item><md-list-item \nclass=\"md-2-line\" ng-repeat=\"fmt in vm.image.cropstatus\" ng-class=\"{\'grey-50-bg\': $odd}\" md-no-proxy layout=\"row\" \nlayout-align=\"start center\"><img ng-src=\"{{fmt.urlImage}}\" class=\"md-avatar\" \nstyle=\"border-radius: 4px; object-fit: contain; flex-shrink: 0\" alt=\"preview\"><div class=\"md-list-item-text\" \nlayout=\"column\" flex style=\"min-width: 0; overflow: hidden\"><h4 class=\"text-truncate\">Format #{{fmt.id_cropformats}}\n<span ng-if=\"fmt.cropformat\"> — {{fmt.cropformat.width}} × {{fmt.cropformat.height}}px</span></h4><p \nclass=\"grey-500-fg text-truncate\">{{fmt.fileName}}</p></div><md-menu class=\"md-secondary\" \nstyle=\"flex-shrink: 0; margin-left: auto\"><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" \naria-label=\"Format options\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-menu-item><md-button ng-click=\"vm.openImageDialog($event, vm.image.cropstatus, fmt, true)\" \naria-label=\"Preview\"><md-icon md-font-icon=\"icon-eye\" class=\"s16 mr-10\"></md-icon><span translate=\"CONTENT.PREVIEW\">\nPreview</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.openUrl(fmt.urlImage)\" \naria-label=\"Open in new window\"><md-icon md-font-icon=\"icon-open-in-new\" class=\"s16 mr-10\"></md-icon><span \ntranslate=\"CONTENT.OPEN_IN_NEW_WINDOW\">Open in new window</span></md-button></md-menu-item></md-menu-content></md-menu>\n</md-list-item></md-list></div><div id=\"list-content-data\" ng-style=\"{\'opacity\' : isLoading ? 0.2 : 1}\" \nng-if=\"vm.showCropformats\"><div ng-if=\"vm.image.allCropped != 1\" \nng-repeat=\"(key, value) in vm.image.cropstatus | groupBy: \'id_container\'\"><div flex-gt-sm=\"33\" flex=\"100\" \nclass=\"white-box sections\"><md-list class=\"pt-0\"><md-list-item class=\"md-toolbar-tools grey-100-bg\"><h3 \nclass=\"grey-700-fg\">Provider: {{vm.getContainerData(value[0].id_container, \'provider\')}}<br>\n{{vm.getContainerData(value[0].id_container, \'url\')}}</h3><md-divider></md-divider></md-list-item></md-list></div><h3 \nclass=\"grey-700-fg not-cropped-h3\" translate=\"MEDIA.PROCESSING\">Processing...</h3><div \nclass=\"mail-list-item {{attachment.status}}\" ng-repeat=\"attachment in value\" ng-init=\"parentIndex = $index\" md-no-ink \nng-click=\"vm.openattachment(attachment)\"><div layout=\"row\" layout-align=\"start center\"><div flex=\"3\" \nlayout-align=\"center center\" class=\"cropping-image\"><div flex layout-align=\"center center\"><md-icon \nmd-font-icon=\"icon-refresh\" role=\"img\" aria-hidden=\"true\" \nclass=\"md-card-icon s24 md-default.theme md-font material-icons icon-refresh\"></md-icon></div></div><div class=\"info\" \nflex layout=\"column\"><div><div class=\"text-truncate\" layout=\"row\" layout-align=\"start center\"><span><span \nng-if=\"attachment.cropformat.description\">{{attachment.cropformat.description}} /</span> <span \nng-if=\"attachment.cropformat.width\">w: {{attachment.cropformat.width}}px /</span> <span \nng-if=\"attachment.cropformat.height\">h: {{attachment.cropformat.height}}px </span><span \nng-if=\"attachment.cropformat.proportional===1\">/ Proportional</span></span></div></div><div><div \nclass=\"details text-truncate\"><span class=\"title grey-500-fg\" ng-bind=\"attachment.fileName\"></span></div></div></div>\n<div class=\"buttons\" layout=\"row\" layout-align=\"start center\"><div><md-menu><button class=\"md-icon-button\" \naria-label=\"More\" translate translate-attr-aria-label=\"TODO.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\" \nng-click=\"$mdMenu.open($event)\"></md-icon></button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.openImageDialog($event, vm.image.cropstatus, attachment, true)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.PREVIEW\"><md-icon md-font-icon=\"icon-eye\" class=\"s16 ml-10\" href=\"#\" \nng-click=\"vm.openImageDialog($event, vm.selectedMail.Thumbnail, attachment)\"></md-icon><span \ntranslate=\"CONTENT.PREVIEW\">Preview</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.openUrl(attachment.urlImage)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.OPEN_IN_NEW_WINDOW\"><md-icon md-font-icon=\"icon-laptop-windows\" class=\"s18\">\n</md-icon><span translate=\"CONTENT.OPEN_IN_NEW_WINDOW\">Open in new window</span></md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.MediaItemRecropSingleFormat(vm.image.id_media,attachment.id_cropformats)\" \naria-label=\"Toggle done\" translate-attr-aria-label=\"MEDIA.MEDIA_ITEM_RECROP\"><md-icon md-font-icon=\"icon-image\" \nclass=\"s18\"></md-icon><span translate=\"MEDIA.MEDIA_ITEM_RECROP\">Recrop Image</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></div><div layout=\"column\" layout-align=\"space-between end\"></div></div></div></div>\n<div ng-if=\"vm.image.allCropped == 1\" ng-repeat=\"(key, value) in vm.image.cropstatus | groupBy: \'id_container\'\"><div \nflex-gt-sm=\"33\" flex=\"100\" class=\"white-box sections\"><md-list class=\"pt-0\"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg\"><h3 class=\"grey-700-fg\">\nProvider: {{vm.getContainerData(value[0].id_container, \'provider\')}}<br>\n{{vm.getContainerData(value[0].id_container, \'url\')}}</h3><md-divider></md-divider></md-list-item></md-list></div><div \nclass=\"mail-list-item {{attachment.status}}\" ng-repeat=\"attachment in value\" ng-init=\"parentIndex = $index\" md-no-ink \nng-click=\"vm.openattachment(attachment)\"><div layout=\"row\" layout-align=\"start center\"><div flex=\"3\" \nlayout-align=\"center center\"><div flex layout-align=\"center center\"><img class=\"image crop-image\" \nng-click=\"vm.openImageDialog($event, vm.image.cropstatus, attachment, true)\" ng-src=\"{{attachment.urlImage}}\" attr=\"\">\n</div></div><div class=\"info\" flex layout=\"column\"><div><div class=\"text-truncate\" layout=\"row\" \nlayout-align=\"start center\"><span><span ng-if=\"attachment.cropformat.description\">\n{{attachment.cropformat.description}} /</span> <span ng-if=\"attachment.cropformat.width\">\nw: {{attachment.cropformat.width}}px /</span> <span ng-if=\"attachment.cropformat.height\">\nh: {{attachment.cropformat.height}}px </span><span ng-if=\"attachment.cropformat.proportional===1\">/ Proportional</span>\n</span></div></div><div><div class=\"details text-truncate\"><span class=\"title grey-500-fg\" \nng-bind=\"attachment.fileName\"></span></div></div></div><div class=\"buttons\" layout=\"row\" layout-align=\"start center\">\n<div><md-menu><button class=\"md-icon-button\" aria-label=\"More\" translate translate-attr-aria-label=\"TODO.MORE\"><md-icon\n md-font-icon=\"icon-dots-vertical\" ng-click=\"$mdMenu.open($event)\"></md-icon></button><md-menu-content width=\"3\">\n<md-menu-item><md-button ng-click=\"vm.openImageDialog($event, vm.image.cropstatus, attachment, true)\" \naria-label=\"Toggle done\" translate-attr-aria-label=\"CONTENT.PREVIEW\"><md-icon md-font-icon=\"icon-eye\" \nclass=\"s16 ml-10\" href=\"#\" ng-click=\"vm.openImageDialog($event, vm.selectedMail.Thumbnail, attachment)\"></md-icon><span\n translate=\"CONTENT.PREVIEW\">Preview</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.openUrl(attachment.urlImage)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.OPEN_IN_NEW_WINDOW\"><md-icon md-font-icon=\"icon-laptop-windows\" class=\"s18\">\n</md-icon><span translate=\"CONTENT.OPEN_IN_NEW_WINDOW\">Open in new window</span></md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.MediaItemRecropSingleFormat(vm.image.id_media,attachment.id_cropformats)\" \naria-label=\"Toggle done\" translate-attr-aria-label=\"MEDIA.MEDIA_ITEM_RECROP\"><md-icon md-font-icon=\"icon-image\" \nclass=\"s18\"></md-icon><span translate=\"MEDIA.MEDIA_ITEM_RECROP\">Recrop Image</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></div><div layout=\"column\" layout-align=\"space-between end\"></div></div></div></div>\n<div ng-if=\"vm.image.allCropped == 1\" ng-repeat=\"(key, value) in vm.image.cropstatus_videos | groupBy: \'id_container\'\">\n<div flex-gt-sm=\"33\" flex=\"100\" class=\"white-box sections\"><md-list class=\"pt-0\"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg\"><h3 class=\"grey-700-fg\">\nProvider: {{vm.getContainerData(value[0].id_container, \'provider\')}}<br>\n{{vm.getContainerData(value[0].id_container, \'url\')}}</h3><md-divider></md-divider></md-list-item></md-list></div><div \nclass=\"mail-list-item {{attachment.status}}\" ng-repeat=\"attachment in value\" ng-init=\"parentIndex = $index\" md-no-ink \nng-click=\"vm.openattachment(attachment)\"><div layout=\"row\" layout-align=\"start center\"><div flex=\"3\" \nlayout-align=\"center center\"><div flex layout-align=\"center center\"><img class=\"image crop-image\" \nng-click=\"vm.openImageDialog($event, vm.image.cropstatus, attachment, true)\" ng-src=\"{{vm.image.embed_thumb}}\" attr=\"\">\n</div></div><div class=\"info\" flex layout=\"column\"><div><div class=\"text-truncate\" layout=\"row\" \nlayout-align=\"start center\"><span><span ng-if=\"attachment.cropformat.description\">\n{{attachment.cropformat.description}} /</span> <span ng-if=\"attachment.cropformat.width\">\nw: {{attachment.cropformat.width}}px /</span> <span ng-if=\"attachment.cropformat.height\">\nh: {{attachment.cropformat.height}}px </span><span ng-if=\"attachment.cropformat.proportional===1\">/ Proportional</span>\n</span></div></div><div><div class=\"details text-truncate\"><span class=\"title grey-500-fg\" \nng-bind=\"attachment.fileName\"></span></div></div></div><div class=\"buttons\" layout=\"row\" layout-align=\"start center\">\n<div><md-menu><button class=\"md-icon-button\" aria-label=\"More\" translate translate-attr-aria-label=\"TODO.MORE\"><md-icon\n md-font-icon=\"icon-dots-vertical\" ng-click=\"$mdMenu.open($event)\"></md-icon></button><md-menu-content width=\"3\">\n<md-menu-item hide><md-button ng-click=\"vm.openImageDialog($event, [vm.image], attachment, true)\" \naria-label=\"Toggle done\" translate-attr-aria-label=\"CONTENT.PREVIEW\"><md-icon md-font-icon=\"icon-eye\" \nclass=\"s16 ml-10\" href=\"#\" ng-click=\"vm.openImageDialog($event, vm.selectedMail.Thumbnail, attachment)\"></md-icon><span\n translate=\"CONTENT.PREVIEW\">Preview</span></md-button></md-menu-item><md-menu-item ng-if=\"attachment.cropformat.url\">\n<md-button ng-click=\"vm.openUrl(attachment.cropformat.url)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.OPEN_IN_NEW_WINDOW\"><md-icon md-font-icon=\"icon-laptop-windows\" class=\"s18\">\n</md-icon><span translate=\"CONTENT.OPEN_IN_NEW_WINDOW\">Open in new window</span></md-button></md-menu-item>\n<md-menu-item hide><md-button g-click=\"vm.MediaItemRecropSingleFormat(vm.image.id_media,attachment.id_cropformats)\" \naria-label=\"Toggle done\" translate-attr-aria-label=\"MEDIA.MEDIA_ITEM_RECROP\"><md-icon md-font-icon=\"icon-image\" \nclass=\"s18\"></md-icon><span translate=\"MEDIA.MEDIA_ITEM_RECROP\">Recrop Image</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></div><div layout=\"column\" layout-align=\"space-between end\"></div></div></div></div>\n</div><md-list-item ng-repeat=\"mediazone in vm.mediaZones\" ng-if=\"vm.mediaZones\" \nclass=\"list-media-item attachment-edit\"><div class=\"attachments\"><div class=\"field\"><p class=\"grey-500-fg ml-8\">\n{{ mediazone.zone_name }}</p><div class=\"attachment-list sortable md-list-item-text\" ng-sortable=\"vm.mediaSortable\">\n<div class=\"attachment\" layout=\"column\" ng-repeat=\"attachment in vm.thumbnails_Edit[mediazone.id_zone]\"><div \nclass=\"preview document\" layout=\"row\" layout-align=\"start center\" extension-class=\"{{attachment.fileName}}\" \nng-href=\"{{attachment.permalink}}\" ng-if=\"attachment.media_type==3\" target=\"_blank\"><qiu-icon \nmediafile=\"attachment.fileName\" class=\"mr-10\"></qiu-icon><a class=\"grey-1000-fg font-size-16\" \nng-href=\"{{attachment.permalink}}\" target=\"_blank\"><span ng-if=\"attachment.title\">{{attachment.title}}</span> <span \nng-if=\"attachment.fileName\">{{attachment.fileName}}</span></a></div><div \nng-if=\"attachment.media_type==1 || attachment.media_type==2 || attachment.media_type==4\"><div class=\"ms-card\" flex \nmd-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"ms-card-content-wrapper\"><div class=\"template-9\"><div \nclass=\"media media-attachment\" flex layout=\"row\" layout-align=\"center center\" \nng-if=\"attachment.media_type==1 || attachment.media_type==2\"><img class=\"image\" \nng-click=\"vm.openImageDialog($event, vm.currentThread_Edit.Thumbnail, attachment)\" \nng-repeat=\"crop in attachment.cropstatus | limitTo: 1\" ng-src=\"{{crop.container.view_url}}{{crop.fileName}}\" \nng-if=\"attachment.media_type==1\"> <img class=\"image\" \nng-click=\"vm.openImageDialog($event, vm.currentThread_Edit.Thumbnail, attachment)\" ng-src=\"{{attachment.embed_thumb}}\" \nng-if=\"attachment.media_type==2\"><div ng-if=\"attachment.media_type==2\" \nng-click=\"vm.openImageDialog($event, vm.currentThread_Edit.Thumbnail, attachment)\" class=\"fotorama__video-play\" \nstyle=\"opacity:1\"></div></div><div flex layout=\"column\" layout-align=\"center center\" class=\"media\" \nng-if=\"attachment.media_type==4\"><qiu-icon mediafile=\"attachment.fileName\" classextra=\"s56\"></qiu-icon><br><span \nclass=\"grey-500-fg\" layout=\"column\" layout-align=\"center center\"><span ng-if=\"attachment.title\"><strong>\n{{attachment.title}}</strong></span> <span ng-if=\"attachment.fileName\">{{attachment.fileName}}</span></span></div><div \nclass=\"header\" layout=\"row\" layout-align=\"space-between center\"><div class=\"size block\" layout=\"row\" \nlayout-align=\"start center\"><strong class=\"mr-5\">#{{attachment.id_media}}</strong> <span class=\"grey-500-fg\" \nng-if=\"attachment.media_type==1 || attachment.media_type==2\">{{attachment.fileName}}</span></div><md-menu><button \nclass=\"md-icon-button\" aria-label=\"More\" translate translate-attr-aria-label=\"TODO.MORE\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" ng-click=\"$mdMenu.open($event)\"></md-icon></button><md-menu-content width=\"3\">\n<md-menu-item><md-button ng-if=\"attachment.media_type==1 || attachment.media_type==2\" \nng-click=\"vm.openImageDialog($event, vm.currentThread_Edit.Thumbnail, attachment)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.PREVIEW\"><md-icon md-font-icon=\"icon-eye\" class=\"ml-10\" href=\"#\" \nng-click=\"vm.openImageDialog($event, vm.selectedMail.Thumbnail, attachment)\"></md-icon><span \ntranslate=\"CONTENT.PREVIEW\">Preview</span></md-button><md-button ng-if=\"attachment.media_type==4\" \nng-click=\"vm.openUrl(attachment.permalink)\" target=\"_blank\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.PREVIEW\"><md-icon md-font-icon=\"icon-open-in-new\" class=\"ml-10\"></md-icon><span \ntranslate=\"CONTENT.OPEN\">Open</span></md-button></md-menu-item><md-menu-item ng-if=\"attachment.media_type==1\">\n<md-button ng-click=\"vm.openFocalPoint($event, attachment)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.SET_FOCAL_POINT\"><md-icon md-font-icon=\"icon-image-filter-center-focus\" class=\"s18\">\n</md-icon><span translate=\"CONTENT.SET_FOCAL_POINT\">Set Focal point</span></md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"vm.openMediaItemMetadata($event, attachment)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.MEDIA_ITEM_EDIT_METADATA\"><md-icon md-font-icon=\"icon-message-image\" class=\"s18\">\n</md-icon><span translate=\"CONTENT.MEDIA_ITEM_EDIT_METADATA\">Edit Metadata</span></md-button></md-menu-item>\n<md-menu-item ng-if=\"attachment.media_type==1\"><md-button ng-click=\"vm.MediaItemRecrop(attachment)\" \naria-label=\"Toggle done\" translate-attr-aria-label=\"CONTENT.MEDIA_ITEM_RECROP\"><md-icon md-font-icon=\"icon-image\" \nclass=\"s18\"></md-icon><span translate=\"CONTENT.MEDIA_ITEM_RECROP\">Recrop Image</span></md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.deleteAttachment(attachment)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.REMOVE\"><md-icon md-font-icon=\"icon-close\" class=\"s18\"></md-icon><span \ntranslate=\"CONTENT.REMOVE\">Remove</span></md-button></md-menu-item></md-menu-content></md-menu></div></div></div></div>\n</div></div></div><md-button class=\"add-event-button no-sort md-fab md-warn\" \nng-click=\"vm.mediaDialog($event, mediazone, vm.currentThread_Edit)\" aria-label=\"Add event\" translate \ntranslate-attr-aria-label=\"CALENDAR.ADD_EVENT\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div>\n<md-divider></md-divider></md-list-item><md-list-item ng-right-click=\"vm.selectOrUnselect(null, $event)\" \nclass=\"list-media-item attachment-edit\" ng-if=\"vm.mediaZones\"><div class=\"attachments\"><div class=\"field\"><div \nclass=\"attachment-list md-list-item-text\" layout=\"row\" layout-wrap=\"\" layout-align=\"start start\" \nng-sortable=\"vm.mediaSortable\"><div class=\"attachment\" layout=\"column\" ng-repeat=\"attachment in vm.image.cropstatus\">\n<div class=\"preview document\" layout=\"row\" layout-align=\"start center\" extension-class=\"{{attachment.fileName}}\" \nng-href=\"{{attachment.permalink}}\" ng-if=\"attachment.media_type==3\" target=\"_blank\"><qiu-icon \nmediafile=\"attachment.fileName\" class=\"mr-10\"></qiu-icon><a class=\"grey-1000-fg font-size-16\" \nng-href=\"{{attachment.permalink}}\" target=\"_blank\"><span ng-if=\"attachment.title\">{{attachment.title}} </span><span \nng-if=\"attachment.fileName\">{{attachment.fileName}}</span></a></div><div class=\"preview document\" layout=\"row\" \nlayout-align=\"start center\" extension-class=\"{{attachment.fileName}}\" ng-href=\"{{attachment.permalink}}\" \nng-if=\"attachment.media_type==4\" target=\"_blank\"><qiu-icon mediafile=\"attachment.fileName\"></qiu-icon><a \nclass=\"grey-1000-fg font-size-16\" ng-href=\"{{attachment.permalink}}\" target=\"_blank\"><span ng-if=\"attachment.fileName\">\n{{attachment.fileName}} </span></a><a href=\"#\" class=\"md-accent-color link\" translate=\"CONTENT.DOWNLOAD\">Download</a>\n</div><div ng-if=\"vm.image.media_type==1 || vm.image.media_type==2\"><div class=\"ms-card\" flex \nmd-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"ms-card-content-wrapper\"><div class=\"template-9\"><div \nclass=\"media media-attachment\" flex layout=\"row\" layout-align=\"center center\"><img class=\"image\" \nng-click=\"vm.openImageDialog($event, vm.currentThread_Edit.Thumbnail, attachment)\" \nng-src=\"{{attachment.container.view_url}}{{attachment.fileName}}\" ng-if=\"vm.image.media_type==1 && !attachment.grid\" \nattr=\"algo1\"> <img class=\"image\" ng-click=\"vm.openImageDialog($event, vm.currentThread_Edit.Thumbnail, attachment)\" \nng-src=\"{{attachment.container.view_url}}{{attachment.grid}}/{{attachment.fileName}}\" \nng-if=\"vm.image.media_type==1 && attachment.grid\" attr=\"algo1\"> <img class=\"image\" \nng-click=\"vm.openImageDialog($event, vm.currentThread_Edit.Thumbnail, attachment)\" \nng-src=\"{{attachment.container.view_url}}\" ng-if=\"attachment.media_type==1\" attr=\"algo\"><div \nng-if=\"attachment.media_type==2\" ng-click=\"vm.openImageDialog($event, vm.currentThread_Edit.Thumbnail, attachment)\" \nclass=\"fotorama__video-play\" style=\"opacity:1\"></div></div><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"size block\" layout=\"row\" layout-align=\"start center\"><strong \nclass=\"mr-5\">#{{attachment.id_media}}</strong> <span class=\"grey-500-fg\">{{attachment.fileName}}</span></div><md-menu>\n<button class=\"md-icon-button\" aria-label=\"More\" translate translate-attr-aria-label=\"TODO.MORE\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" ng-click=\"$mdMenu.open($event)\"></md-icon></button><md-menu-content width=\"3\">\n<md-menu-item><md-button ng-click=\"vm.openImageDialog($event, vm.image.cropstatus, attachment, true)\" \naria-label=\"Toggle done\" translate-attr-aria-label=\"CONTENT.PREVIEW\"><md-icon md-font-icon=\"icon-eye\" \nclass=\"s16 ml-10\" href=\"#\" ng-click=\"vm.openImageDialog($event, vm.selectedMail.Thumbnail, attachment)\"></md-icon><span\n translate=\"CONTENT.PREVIEW\">Preview</span></md-button></md-menu-item><md-menu-item ng-if=\"attachment.media_type==1\">\n<md-button ng-click=\"vm.openFocalPoint($event, attachment)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.SET_FOCAL_POINT\"><md-icon md-font-icon=\"icon-image-filter-center-focus\" class=\"s18\">\n</md-icon><span translate=\"CONTENT.SET_FOCAL_POINT\">Set Focal point</span></md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"vm.openMediaItemMetadata($event, attachment)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.MEDIA_ITEM_EDIT_METADATA\"><md-icon md-font-icon=\"icon-message-image\" class=\"s18\">\n</md-icon><span translate=\"CONTENT.MEDIA_ITEM_EDIT_METADATA\">Edit Metadata</span></md-button></md-menu-item>\n<md-menu-item ng-if=\"attachment.media_type==1\"><md-button ng-click=\"vm.MediaItemRecrop(attachment)\" \naria-label=\"Toggle done\" translate-attr-aria-label=\"CONTENT.MEDIA_ITEM_RECROP\"><md-icon md-font-icon=\"icon-image\" \nclass=\"s18\"></md-icon><span translate=\"CONTENT.MEDIA_ITEM_RECROP\">Recrop Image</span></md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.deleteAttachment(attachment)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.REMOVE\"><md-icon md-font-icon=\"icon-close\" class=\"s18\"></md-icon><span \ntranslate=\"CONTENT.REMOVE\">Remove</span></md-button></md-menu-item></md-menu-content></md-menu></div></div></div></div>\n</div></div></div></div></div><md-divider></md-divider></md-list-item>");
$templateCache.put("app/main/apps/mediahub/views/tabs/tab-edit.html","<div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><form name=\"vm.basicForm\" class=\"md-inline-form\" novalidate><div\n layout=\"column\" class=\"media-edit-top\"><div flex=\"100\" class=\"media-card sections\" layout=\"row\" \nlayout-align=\"center center\"><div style=\"width: 75%; max-width: 75%\"><md-input-container class=\"md-block\" flexss><div \nclass=\"ms-card\" flex><div class=\"ms-card-content-wrapper\"><div class=\"template-9\" layout=\"column\" \nlayout-align=\"space-between stretch\"><div class=\"media\" \nng-class=\"{\'file\': vm.image.media_type==4,\'audio\': vm.image.media_type==3}\" flex layout=\"column\" \nlayout-align=\"center center\"><img ng-src=\"{{vm.image.imageUrl}}\" class=\"image\" \nng-if=\"vm.image.media_type == 1 && vm.image.imageUrl\" style=\"max-width: 100%\"><md-icon \nng-if=\"vm.image.media_type == 1 && !vm.image.imageUrl\" \nmd-font-icon=\"{{vm.getExtensionIcon(vm.image.filename || vm.image.fileName)}}\" class=\"s72\"></md-icon><img \nng-src=\"{{vm.image.imageUrl}}\" class=\"image\" ng-if=\"vm.image.media_type == 2 && vm.image.imageUrl\" \nstyle=\"max-width: 100%\"><md-icon ng-if=\"vm.image.media_type == 2 && !vm.image.imageUrl\" \nmd-font-icon=\"{{vm.getExtensionIcon(vm.image.filename || vm.image.fileName)}}\" class=\"s72\"></md-icon><img \nng-src=\"{{vm.image.imageUrl}}\" class=\"image\" ng-if=\"vm.image.media_type == 3 && vm.image.imageUrl\" \nstyle=\"max-width: 100%\"><md-icon ng-if=\"vm.image.media_type == 3 && !vm.image.imageUrl\" \nmd-font-icon=\"{{vm.getExtensionIcon(vm.image.filename || vm.image.fileName)}}\" class=\"s72\"></md-icon><img \nng-src=\"{{vm.image.imageUrl}}\" class=\"image\" ng-if=\"vm.image.media_type == 4 && vm.image.imageUrl\" \nstyle=\"max-width: 100%\"><md-icon ng-if=\"vm.image.media_type == 4 && !vm.image.imageUrl\" \nmd-font-icon=\"{{vm.getExtensionIcon(vm.image.filename || vm.image.fileName)}}\" class=\"s72\"></md-icon></div><div \nclass=\"header p-16\" flex><div layout=\"row\" layout-align=\"center center\" ng-if=\"vm.mediaSelected\"><md-button \naria-label=\"Preview\" class=\"md-icon-button\" ng-click=\"vm.openImageDialog($event, vm.image, false, false, true)\" \ntranslate=\"\" translate-attr-aria-label=\"CONTENT.PREVIEW\" ng-if=\"vm.image.media_type ==1 || vm.image.media_type ==2\">\n<md-icon md-font-icon=\"icon-eye\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.PREVIEW\">Preview</span>\n</md-tooltip></md-button><md-button aria-label=\"Preview\" class=\"md-icon-button\" \nng-click=\"vm.openUrl(vm.image.imageUrlOriginal || vm.image.imageUrl)\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.OPEN_IN_NEW_WINDOW\"><md-icon md-font-icon=\"icon-laptop-windows\"></md-icon>\n<md-tooltip hide show-gt-xs><span translate=\"CONTENT.OPEN_IN_NEW_WINDOW\">Open in new window</span></md-tooltip>\n</md-button><md-button ng-if=\"!vm.image.embed\" aria-label=\"Preview\" class=\"md-icon-button\" \nng-click=\"vm.copyLink(vm.image.imageUrlOriginal || vm.image.imageUrl)\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.COPY_LINK\"><md-icon md-font-icon=\"icon-content-copy\"></md-icon><md-tooltip hide \nshow-gt-xs><span translate=\"CONTENT.COPY_LINK\">Copy link</span></md-tooltip></md-button><md-button \nng-if=\"vm.image.media_type == 2 && vm.image.cropstatus_videos.length > 0\" aria-label=\"Preview\" class=\"md-icon-button\" \nng-click=\"vm.copyVideoLink(vm.image)\" translate=\"\" translate-attr-aria-label=\"CONTENT.COPY_LINK\"><md-icon \nmd-font-icon=\"icon-content-copy\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.COPY_LINK\">Copy link\n</span></md-tooltip></md-button><md-button aria-label=\"Preview\" class=\"md-icon-button\" \nng-click=\"vm.openFocalPoint($event,vm.image)\" translate=\"\" translate-attr-aria-label=\"CONTENT.SET_FOCAL_POINT\" \nng-if=\"vm.image.media_type ==1\" ng-disabled=\"true\" style=\"opacity: 0.4\"><md-icon \nmd-font-icon=\"icon-image-filter-center-focus\"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate=\"CONTENT.SET_FOCAL_POINT\">Set Focal Point</span></md-tooltip></md-button><md-button \nng-if=\"vm.image.media_type != 1\" aria-label=\"Preview\" class=\"md-icon-button\" \nng-click=\"vm.changeVideoThumb($event, vm.image)\" translate=\"\" translate-attr-aria-label=\"CONTENT.CHANGE_THUMB\"><md-icon\n md-font-icon=\"icon-picture\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.CHANGE_THUMB\">\nOpen in new window</span></md-tooltip></md-button><md-button aria-label=\"Preview\" class=\"md-icon-button\" \nng-click=\"vm.MediaItemRecropAllFormats(vm.image.id_media)\" translate=\"\" translate-attr-aria-label=\"MEDIA.RECROP_PHOTO\" \nng-if=\"vm.image.media_type == 1\"><md-icon md-font-icon=\"icon-crop\"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate=\"MEDIA.RECROP_PHOTO\">Recrop photo</span></md-tooltip></md-button><md-button aria-label=\"Preview\" \nclass=\"md-icon-button\" ng-click=\"vm.AddmediaDialog($event,null,vm.image, true)\" translate=\"\" \ntranslate-attr-aria-label=\"MEDIA.RECROP_PHOTO\" ng-disabled=\"true\" style=\"opacity: 0.4\"><md-icon \nmd-font-icon=\"icon-box-upload\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"MEDIA.RELOAD_PHOTO\">Reload photo\n</span></md-tooltip></md-button><md-menu ng-if=\"vm.image.media_type == 2\"><button class=\"md-icon-button\" \naria-label=\"More\" translate translate-attr-aria-label=\"TODO.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\" \nng-click=\"$mdMenu.open($event)\"></md-icon></button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.joinClipsWindow($event, vm.image )\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"MATCH_CENTER.JOIN_CLIP\"><md-icon md-font-icon=\"icon-view-week\" class=\"s18 ml-10\" href=\"#\">\n</md-icon><span translate=\"MATCH_CENTER.JOIN_CLIP\"></span></md-button></md-menu-item></md-menu-content></md-menu><div \nclass=\"divider-vertical\" hide=\"\" show-gt-sm=\"\" ng-if=\"vm.ActiveSection.web_preview\"></div><md-button aria-label=\"Spam\" \nclass=\"md-icon-button\" ng-click=\"\" translate=\"\" translate-attr-aria-label=\"CONTENT.LIVE\" \nng-if=\"vm.ActiveSection.web_preview\"><md-icon md-font-icon=\"icon-web\"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate=\"CONTENT.LIVE\">Live Preview</span></md-tooltip></md-button><md-menu hide=\"\"><md-button \naria-label=\"Mail Actions\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.ACTIONS\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button aria-label=\"Archive\" translate-attr-aria-label=\"CONTENT.ARCHIVE\">\n<md-icon md-font-icon=\"icon-archive\"></md-icon><span translate=\"CONTENT.ARCHIVE\">Archive</span></md-button>\n</md-menu-item><md-menu-item><md-button aria-label=\"Spam\" translate-attr-aria-label=\"CONTENT.SPAM\"><md-icon \nmd-font-icon=\"icon-alert-octagon\"></md-icon><span translate=\"CONTENT.SPAM\">Spam</span></md-button></md-menu-item>\n<md-menu-item><md-button aria-label=\"Delete\" translate-aria-label=\"CONTENT.DELETE\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon><span translate=\"CONTENT.DELETE\">Delete</span></md-button></md-menu-item><md-menu-item><md-button \naria-label=\"Move To\" translate-attr-aria-label=\"CONTENT.MOVE_TO\"><md-icon md-font-icon=\"icon-folder-move\"></md-icon>\n<span translate=\"CONTENT.MOVE_TO\">Move To</span></md-button></md-menu-item><md-menu-item><md-button \naria-label=\"Labels\" translate-attr-aria-label=\"CONTENT.LABELS\"><md-icon md-font-icon=\"icon-label\"></md-icon><span \ntranslate=\"CONTENT.LABELS\">Labels</span></md-button></md-menu-item></md-menu-content></md-menu></div></div></div></div>\n</div></md-input-container></div></div><div layout=\"row\" layout-wrap layout-align=\"start center\" \nclass=\"media-meta-compact px-16 py-8 border-top\"><div class=\"mr-24\" ng-if=\"vm.image.originalFileName\"><span \nclass=\"grey-500-fg font-size-11\" translate=\"CONTENT.FILENAME\">Filename</span>&nbsp; <span \nclass=\"font-size-12 font-weight-500\">{{vm.image.originalFileName}}</span></div><div class=\"mr-24\" \nng-if=\"vm.image.size\"><span class=\"grey-500-fg font-size-11\" translate=\"MEDIA.DIMENSIONS\">Dimensions</span>&nbsp; <span\n class=\"font-size-12 font-weight-500\">{{vm.image.size}}</span></div><div class=\"mr-24\" ng-if=\"vm.image.fileSizeKb\">\n<span class=\"grey-500-fg font-size-11\" translate=\"MEDIA.SIZE_KB\">Size</span>&nbsp; <span \nclass=\"font-size-12 font-weight-500\">{{vm.image.fileSizeKb}} Kb</span></div><div \nng-if=\"vm.image.date_uploaded && vm.image.date_uploaded.dateShow\"><span class=\"grey-500-fg font-size-11\" \ntranslate=\"MEDIA.DATE_UPLOADED\">Date uploaded</span>&nbsp; <span class=\"font-size-12 font-weight-500\">\n{{vm.image.date_uploaded.dateShow}}</span></div></div></div><div layout=\"column\" layout-xs=\"column\"><div layout=\"row\">\n<md-list flex=\"100\"><md-list-item class=\"md-toolbar-tools grey-100-bg\"><h3 class=\"grey-700-fg\" \ntranslate=\"CONTENT.LATESTACTIVITY\">Publishing Settings</h3></md-list-item></md-list></div><div layout=\"row\"><div \nflex=\"100\" layout=\"row\" class=\"layout-wrap\"><div flex-gt-sm=\"100\" flex=\"100\"><md-input-container class=\"md-block\">\n<label translate=\"CONTENT.TITLE\">Title</label><textarea ng-model=\"vm.image.title\" columns=\"1\" rows=\"1\" \nplaceholder=\"{{vm.translate(\'CONTENT.TITLE\')}}\"></textarea></md-input-container></div><div flex-gt-sm=\"50\" flex=\"100\">\n<md-input-container class=\"md-block\"><label translate=\"CONTENT.PHOTOGRAPHER\">Photographer</label><textarea \nng-model=\"vm.image.photographer\" columns=\"1\" rows=\"1\" placeholder=\"{{vm.translate(\'CONTENT.PHOTOGRAPHER\')}}\">\n</textarea></md-input-container></div><div flex-gt-sm=\"50\" flex=\"100\"><md-input-container class=\"md-block\"><label \ntranslate=\"CONTENT.CREDITS\">Credits</label><textarea ng-model=\"vm.image.credits\" columns=\"1\" rows=\"1\" \nplaceholder=\"{{vm.translate(\'CONTENT.CREDITS\')}}\"></textarea></md-input-container></div><div flex-gt-sm=\"50\" \nflex=\"100\"><md-input-container class=\"md-block\"><label translate=\"CONTENT.OWNER\">Owner</label><textarea \nng-model=\"vm.image.owner\" columns=\"1\" rows=\"1\" placeholder=\"{{vm.translate(\'CONTENT.OWNER\')}}\"></textarea>\n</md-input-container></div><div flex-gt-sm=\"100\" flex=\"100\"><md-input-container class=\"md-block\"><label \ntranslate=\"CONTENT.CAPTION\">Caption</label><textarea ng-model=\"vm.image.caption\" columns=\"1\" rows=\"1\" \nplaceholder=\"{{vm.translate(\'CONTENT.CAPTION\')}}\"></textarea></md-input-container></div><div flex-gt-sm=\"50\" \nflex=\"100\"><md-input-container class=\"md-block\"><label translate=\"CONTENT.CITY\">City</label><input \nng-model=\"vm.image.city\" type=\"text\" placeholder=\"{{vm.translate(\'CONTENT.CITY\')}}\"></md-input-container></div><div \nflex-gt-sm=\"50\" flex=\"100\"><md-input-container class=\"md-block\"><label translate=\"CONTENT.COUNTRY\">Country</label>\n<input ng-model=\"vm.image.country\" type=\"text\" placeholder=\"{{vm.translate(\'CONTENT.COUNTRY\')}}\"></md-input-container>\n</div><div flex-gt-sm=\"50\" flex=\"100\"><md-input-container class=\"md-block\"><label translate=\"CONTENT.USE\">Use</label>\n<input ng-model=\"vm.image.uses\" type=\"text\" placeholder=\"{{vm.translate(\'CONTENT.USE\')}}\"></md-input-container></div>\n<div flex-gt-sm=\"50\" flex=\"100\"><md-input-container class=\"md-block\" ng-hide=\"vm.image.media_type == 2\"><label \ntranslate=\"CONTENT.EXTRAS\">Extras</label><input ng-model=\"vm.image.extra\" type=\"text\" \nplaceholder=\"{{vm.translate(\'CONTENT.EXTRAS\')}}\"></md-input-container></div><div flex-gt-sm=\"50\" flex=\"100\">\n<md-input-container class=\"md-block\"><label translate=\"CONTENT.RATING\">Rating</label><qiu-rating-stars max-rating=\"5\" \nng-click=\"vm.basicForm.$pristine? vm.basicForm.$pristine = false : \'\'\" rating=\"vm.image.rating\" \nread-only=\"ctrl.readOnly\" on-rating=\"ctrl.onRating(rating)\"></qiu-rating-stars></md-input-container></div></div></div>\n<div layout=\"column\"><div layout=\"column\" layout-gt-sm=\"column\" class=\"date-time-picker\"><div flex><label>File date\n</label></div><div layout=\"column\" layout-gt-sm=\"row\"><div flex-gt-sm=\"66\" flex=\"100\" layout=\"row\"><div flex \nclass=\"date-container date\"><mdp-date-picker mdp-placeholder=\"Date\" mdp-format=\"{{vm.dateFormat}}\" \nmdp-open-on-click=\"true\" ng-model=\"vm.image.file_date.date\" ng-change=\"vm.updateDatePicker(\'file_date\')\">\n</mdp-date-picker></div><div flex class=\"date-container time\"><mdp-time-picker mdp-placeholder=\"Time\" \nmdp-auto-switch=\"true\" mdp-open-on-click=\"true\" ng-model=\"vm.image.file_date.date\" \nng-change=\"vm.updateDatePicker(\'file_date\')\"></mdp-time-picker></div></div><div flex-gt-sm=\"33\" flex=\"100\"><div flex \nclass=\"date-container utc\"><md-input-container class=\"md-block\"><label>UTC Date</label><input type=\"text\" \nng-model=\"vm.image.file_date.utcShow\" disabled=\"disabled\"></md-input-container></div></div></div></div><div \nlayout=\"column\" layout-gt-sm=\"column\" class=\"date-time-picker\"><div flex><label translate=\"MEDIA.DATE_UPLOADED\">\n</label></div><div layout=\"column\" layout-gt-sm=\"row\"><div flex-gt-sm=\"66\" flex=\"100\" layout=\"row\"><div flex \nclass=\"date-container date\"><mdp-date-picker mdp-placeholder=\"Date\" mdp-format=\"{{vm.dateFormat}}\" \nmdp-open-on-click=\"true\" ng-model=\"vm.image.date_uploaded.date\" ng-change=\"vm.updateDatePicker(\'date_uploaded\')\">\n</mdp-date-picker></div><div flex class=\"date-container time\"><mdp-time-picker mdp-placeholder=\"Time\" \nmdp-auto-switch=\"true\" mdp-open-on-click=\"true\" ng-model=\"vm.image.date_uploaded.date\" \nng-change=\"vm.updateDatePicker(\'date_uploaded\')\"></mdp-time-picker></div></div><div flex-gt-sm=\"33\" flex=\"100\"><div \nflex class=\"date-container utc\"><md-input-container class=\"md-block\"><label>UTC Date</label><input type=\"text\" \nng-model=\"vm.image.date_uploaded.utcShow\" disabled=\"disabled\"></md-input-container></div></div></div></div></div><div \nlayout=\"row\" ng-if=\"vm.mediaRefMetadata && vm.mediaRefMetadata.length > 0\"><md-list flex=\"100\"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg\"><h3 class=\"grey-700-fg\" translate=\"CONTENT.METADATA\">METADATA</h3></md-list-item>\n</md-list></div><div layout=\"row\" ng-if=\"vm.mediaRefMetadata && vm.mediaRefMetadata.length > 0\"><div flex=\"100\" \nlayout=\"row\" class=\"layout-wrap\"><div flex-gt-sm=\"50\" flex=\"100\" \nng-repeat=\"ref in vm.mediaRefMetadata | orderBy: \'edit_sort\'\" \nng-init=\"value = vm.parseDotNotation(vm.image, ref.title)\" ng-show=\"ref.media_type == 1 && value\"><md-input-container \nclass=\"md-block\"><label>{{ref.field_name}}</label><textarea disabled=\"disabled\" columns=\"1\" rows=\"1\" \nplaceholder=\"{{ref.field_name}}\">{{value}}</textarea></md-input-container></div></div></div><div layout=\"row\"><md-list \nflex=\"100\"><md-list-item class=\"md-toolbar-tools grey-100-bg\"><h3 class=\"grey-700-fg\" \ntranslate=\"CONTENT.GEOLOCALIZATION\">Geolocation</h3></md-list-item></md-list></div><div layout=\"row\"><div \nflex-gt-sm=\"50\" flex=\"100\"><md-input-container><label translate=\"CONTENT.GEOLAT\">ID</label><input \nng-model=\"vm.image.geoLat\" type=\"text\" placeholder=\"{{vm.translate(\'CONTENT.GEOLAT\')}}\"></md-input-container></div><div\n flex-gt-sm=\"50\" flex=\"100\"><md-input-container><label translate=\"CONTENT.GEOLON\">ID</label><input \nng-model=\"vm.image.geoLon\" type=\"text\" placeholder=\"{{vm.translate(\'CONTENT.GEOLON\')}}\"></md-input-container></div>\n</div><div layout=\"row\"><md-list flex=\"100\"><md-list-item class=\"md-toolbar-tools grey-100-bg\"><div layout=\"row\" \nlayout-align=\"start center\" class=\"flex-50\"><h3 class=\"grey-700-fg\" translate=\"CONTENT.FOCAL_POINT\">Focal point</h3>\n</div><div layout=\"row\" layout-align=\"end center\" class=\"flex-50\"><md-button aria-label=\"Preview\" \nclass=\"md-icon-button\" ng-click=\"vm.openFocalPoint($event,vm.image)\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.PREVIEW\" ng-if=\"vm.image.media_type ==1\"><md-icon \nmd-font-icon=\"icon-image-filter-center-focus\"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate=\"CONTENT.SET_FOCAL_POINT\">Set Focal Point</span></md-tooltip></md-button></div></md-list-item></md-list>\n</div><div layout=\"row\"><div flex-gt-sm=\"50\" flex=\"100\"><md-input-container><label \ntranslate=\"CONTENT.IMAGE_CENTER_RATIO_X\">X</label><input ng-model=\"vm.image.imageCenterRatioX\" type=\"text\" \nplaceholder=\"{{vm.translate(\'CONTENT.IMAGE_CENTER_RATIO_X\')}}\"></md-input-container></div><div flex-gt-sm=\"50\" \nflex=\"100\"><md-input-container><label translate=\"CONTENT.IMAGE_CENTER_RATIO_Y\">Y</label><input \nng-model=\"vm.image.imageCenterRatioY\" type=\"text\" placeholder=\"{{vm.translate(\'CONTENT.IMAGE_CENTER_RATIO_Y\')}}\">\n</md-input-container></div></div><div layout=\"row\"><md-list flex=\"100\"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg\"><h3 class=\"grey-700-fg\" translate=\"CONTENT.TAGS\">Tags</h3></md-list-item>\n</md-list></div><div layout=\"row\"><div flex=\"100\" class=\"tags\"><div ng-repeat=\"type in vm.tagsTypes\"><div \nclass=\"label-container\"><md-icon md-font-icon=\"{{type.icon}}\" role=\"img\" aria-hidden=\"true\" class=\"md-card-icon s24\">\n</md-icon><label>{{type.name}}</label></div><md-input-container class=\"md-block\"><md-chips \nclass=\"label-chips close-chip\" ng-model=\"vm.image.tagsWithTypes[type.name]\" md-autocomplete-snap \nmd-require-match=\"true\"><md-autocomplete md-min-length=\"1\" md-selected-item=\"vm.selectedTag\" \nmd-selected-item-change=\"vm.selectedItemChange(type.searcher)\" md-search-text=\"vm[type.searcher]\" \nmd-items=\"tag in vm.labelQuerySearch(vm[type.searcher], type.id_type) | orderBy:\'-order\'\" md-item-text=\"tag.tag_name\" \nmd-no-cache=\"true\" placeholder=\"{{vm.translate(\'GLOBAL.SEARCH_FOR_TAG\')}}\" ng-model-options=\"{debounce: 500}\" \nmd-dropdown-items=\"10\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\" \nclass=\"tag-not-found-bg border-bottom\"><span ng-if=\"!tag.tag_name\">{{vm[type.searcher]}}</span> <span \nmd-highlight-text=\"vm[type.searcher]\" ng-if=\"tag.tag_name\">{{tag.tag_name}}</span><small> (#{{tag.id_tag}})</small>\n<md-buttton ng-if=\"!tag.tag_name\" ng-click=\"vm.newTag(vm[type.searcher], type)\" \nclass=\"md-accent green-500-bg white-fg md-button m-0\"><span translate=\"CONTENT.TAGADD\"></span></md-buttton></div>\n<md-not-found><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\" class=\"tag-not-found-bg\"><span>\n{{vm[type.searcher]}}</span><md-buttton ng-click=\"vm.newTag(vm[type.searcher], type)\" \nclass=\"md-accent green-500-bg white-fg md-button m-0\"><span translate=\"CONTENT.TAGADD\"></span></md-buttton></div>\n</md-not-found></md-autocomplete><md-chip-template><div class=\"md-chip-content\"><span ng-if=\"$chip.color\" \nclass=\"color\" ng-style=\"{\'background-color\':$chip.color}\"></span> <span>{{$chip.tag_name}}</span><small>\n (#{{$chip.id_tag}})</small></div></md-chip-template><button md-chip-remove class=\"md-primary\" layout=\"row\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-close\"></md-icon></button></md-chips></md-input-container>\n</div><div class=\"label-container\"><label>All tags</label></div><md-input-container class=\"md-block\"><label \ntranslate=\"GLOBAL.SEARCH_FOR_TAG\">Tags</label><md-chips class=\"label-chips close-chip\" ng-model=\"vm.image.tags\" \nmd-autocomplete-snap md-require-match=\"true\"><md-autocomplete md-min-length=\"1\" md-selected-item=\"vm.selectedTag\" \nmd-selected-item-change=\"vm.selectedItemChange()\" md-search-text=\"vm.searchTagText\" \nmd-items=\"tag in vm.labelQuerySearch(vm.searchTagText) | orderBy:\'-order\'\" md-item-text=\"tag.tag_name\" \nmd-no-cache=\"true\" placeholder=\"{{vm.translate(\'GLOBAL.SEARCH_FOR_TAG\')}}\" ng-model-options=\"{debounce: 500}\" \nmd-dropdown-items=\"10\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\" \nclass=\"tag-not-found-bg border-bottom\"><span ng-if=\"!tag.tag_name\">{{vm.searchTagText}}</span> <span \nmd-highlight-text=\"vm.searchTagText\" ng-if=\"tag.tag_name\">{{tag.tag_name}}</span><small> (#{{tag.id_tag}})</small>\n<md-buttton ng-if=\"!tag.tag_name\" ng-click=\"vm.newTag(vm.searchTagText)\" \nclass=\"md-accent green-500-bg white-fg md-button m-0\"><span translate=\"CONTENT.TAGADD\"></span></md-buttton></div>\n<md-not-found><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\" class=\"tag-not-found-bg\"><span>\n{{vm.searchTagText}}</span><md-buttton ng-click=\"vm.newTag(vm.searchTagText)\" \nclass=\"md-accent green-500-bg white-fg md-button m-0\"><span translate=\"CONTENT.TAGADD\"></span></md-buttton></div>\n</md-not-found></md-autocomplete><md-chip-template><div class=\"md-chip-content\"><span ng-if=\"$chip.color\" \nclass=\"color\" ng-style=\"{\'background-color\':$chip.color}\"></span> <span>{{$chip.tag_name}}</span><small>\n (#{{$chip.id_tag}})</small></div></md-chip-template><button md-chip-remove class=\"md-primary\" layout=\"row\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-close\"></md-icon></button></md-chips></md-input-container>\n</div></div></div><br><br><div layout=\"row\" ng-if=\"vm.mediaSelected\"><md-list flex=\"100\" \nclass=\"md-toolbar-tools grey-100-bg\" layout=\"row\" layout-align=\"end center\"><md-list-item><md-button type=\"submit\" \nng-click=\"vm.saveImage(vm.image)\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.basicForm.$invalid || vm.basicForm.$pristine\" aria-label=\"SAVE\" translate=\"CONTENT.SAVE\" \ntranslate-attr-aria-label=\"CONTENT.SAVE\">SAVE</md-button><md-button type=\"button\" ng-click=\"vm.closeMediaPreview()\" \nclass=\"md-raised md-warn\" aria-label=\"Cancel\">Cancel</md-button></md-list-item></md-list></div></form></div>");
$templateCache.put("app/main/apps/mediahub/views/tabs/tab-galleries.html","<md-content ms-scroll=\"vm.msScrollOptions\" class=\"\" flex><md-toolbar \nclass=\"md-default-theme grey-100-bg grey-600-fg pr-16 pl-16\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" style=\"width: 100%\"><label for=\"search-bar-input\"><md-icon ng-if=\"!vm.treeSearch\" \nmd-font-icon=\"icon-magnify\" class=\"grey-600-fg md-icon-button md-button\"><md-tooltip hide show-gt-xs><span \ntranslate=\"TOOLBAR.SEARCH\">Search</span></md-tooltip></md-icon><md-icon ng-if=\"vm.treeSearch\" \nmd-font-icon=\"icon-close-circle\" class=\"grey-600-fg md-icon-button md-button\" ng-click=\"vm.treeSearch = null\">\n</md-icon></label><input type=\"text\" id=\"search-bar-input\" class=\"grey-600-fg grey-100-bg\" ng-model=\"vm.treeSearch\" \nplaceholder=\"Search\" md-autofocus translate translate-attr-placeholder=\"TOOLBAR.SEARCH\" flex><md-menu><button \naria-label=\"Filters\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" show-gt-xs=\"\" translate=\"\" \ntranslate-attr-aria-label=\"\"><md-icon md-font-icon=\"m-0 grey-600-fg icon-chevron-down\"><md-tooltip><span \ntranslate=\"MEDIA.COLLAPSE_OR_EXPAND\">Collapse or expand</span></md-tooltip></md-icon></button><md-menu-content \nwidth=\"4\"><md-menu-item ng-repeat=\"(key, value) in vm.collapseAndExpand\"><md-button aria-label=\"All\" \nng-click=\"vm.collapseAndExpandValue=value; vm.collapseAndExpandFunction()\"><div layout=\"row\" \nlayout-align=\"space-between center\"><span>{{key | translate}}</span></div></md-button></md-menu-item></md-menu-content>\n</md-menu></div></md-toolbar><div class=\"navigation-simple groups-tree pt-20 pb-20\" layout=\"column\"><div \nng-if=\"vm.CleanMediaGalleriesWithMediaAssignment\" ivh-treeview=\"vm.CleanMediaGalleriesWithMediaAssignment\" \nivh-treeview-label-attribute=\"\'name\'\" ivh-treeview-expand-to-depth=\"0\" ivh-treeview-filter=\"vm.treeSearch\" \nclass=\"ivh-treeview-folder small\"><script type=\"text/ng-template\">\n<div class=\"level-card p-8 gallery-row\" ng-style=\"{opacity: !node.assigned_gallery ? \'.3\' : \'1\'}\" layout=\"row\" layout-align=\"space-between center\">\r\n                    <span ivh-treeview-twistie ivh-treeview-toggle layout=\"row\" layout-align=\"center center\"></span>\r\n                    <div flex layout=\"row\" layout-align=\"start center\">\r\n                        <!-- One icon resolved in the controller (node.gallery_icon), instead of\r\n                             ten ng-if\'d md-icon: those were ten watchers on every gallery of\r\n                             the tree, evaluated on each digest. -->\r\n                        <md-icon\r\n                            ng-if=\"::node.gallery_icon\"\r\n                            md-font-icon=\"{{::node.gallery_icon}}\"\r\n                            class=\"s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <div class=\"group-status green-bg\" ng-if=\"node.status ===1\" role=\"button\" aria-label=\"group-status\"></div>\r\n                        <span class=\"ivh-treeview-node-label ng-binding\">{{node.name}}</span>\r\n\r\n                    </div>\r\n                    <div layout=\"row\" layout-align=\"end center\">\r\n                        <md-checkbox\r\n                            qiu-on-check-set-basic-form-dirty\r\n                            ng-disabled=\"node.no_files_allowed\"\r\n                            qiu-on-check-selected\r\n                            ng-checked=\"node.assigned_gallery\"\r\n                            aria-label=\"{{node.assigned_gallery ? \'Deselect\' : \'Select\'}}\"\r\n                            class=\"ml-5 mb-0\"\r\n                            ng-click=\"node.assigned_gallery = !node.assigned_gallery\"\r\n                        ></md-checkbox>\r\n                    </div>\r\n                </div>\r\n                <!-- Children only while the branch is open. ivh-treeview puts the whole tree\r\n                     in the dom and merely hides the closed branches with css, which on a\r\n                     tenant with a thousand galleries meant tens of thousands of nodes alive\r\n                     on every media selection. -->\r\n                <div ivh-treeview-children ng-if=\"trvw.isExpanded(node)\"></div>\n</script></div></div></md-content>");
$templateCache.put("app/main/apps/mediahub/views/tabs/tab-related.html","<div ng-if=\"vm.facesRelated\" fill-width layout=\"column\"><md-list class=\"p-0 bb\"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg ph-25\">{{vm.translate(\'MEDIA.RELATED_PICTURES\')}}</md-list-item></md-list><div \nclass=\"grid-view\" flex md-cols=\"2\"><div \nng-click=\"vm.openFacesRelatedInImageDialog($event, vm.facesRelated,mediaItem.media, false, true)\" \nng-repeat=\"mediaItem in vm.facesRelated\" data-id=\"{{mediaItem.media.id_media}}\" class=\"ms-card grid-element sortable\">\n<div class=\"ms-card-content-wrapper\"><div class=\"template-9\" layout=\"column\" layout-align=\"space-between stretch\"><div \nclass=\"media\" flex layout=\"row\" layout-align=\"center center\"><media attachment=\"mediaItem.media\" class-img=\"image\">\n</media></div><div class=\"header p-16\" flex><div layout=\"row\" layout-align=\"space-between center\" flex><div \nng-if=\"vm.media_type_name != \'Image Rekognition\'\" class=\"size block\" layout=\"row\" layout-align=\"start left\"><strong \nclass=\"mr-5\">#{{mediaItem.media.id_media}}</strong> <span class=\"grey-500-fg\"><span ng-if=\"mediaItem.media.filename\" \nclass=\"filename\">{{mediaItem.media.filename}}</span></span></div><div \nng-if=\"vm.media_type_name == \'Image Rekognition\'\" class=\"size block\" layout=\"row\" layout-align=\"start left\"><strong \nng-if=\"!vm.isProcessingItem(mediaItem.media)\"><span \nng-repeat=\"text in mediaItem.media.meta_analyses.rekognition_detect_text.TextDetectionsUnique | filter: filterByNumNotCurrentYears track by $index\">\n{{text.DetectedText}}<span ng-if=\"!$last\">,</span></span> </strong><strong style=\"color: red; font-weight: bold\" \nng-if=\"vm.isProcessingItem(mediaItem.media)\">PROCESANDO</strong></div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/apps/scrumboard/dialogs/card/card-dialog.html","<md-dialog class=\"card-dialog\" aria-label=\"Card Dialog\" ng-cloak><md-toolbar class=\"md-accent\" \nng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><div class=\"due-date\"><div \nng-if=\"!vm.card.due\" moment-picker=\"vm.card.due\" format=\"x\" min-view=\"year\" max-view=\"hour\" start-view=\"month\">\n<md-button class=\"md-icon-button\" aria-label=\"Due date\" translate translate-attr-aria-label=\"SB.DUE_DATE\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-calendar\"></md-icon></md-button></div></div><md-menu \nng-if=\"vm.card.due\" md-offset=\"0 48\" class=\"remove-due-date\"><md-button class=\"md-icon-button\" aria-label=\"Members\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-calendar\"></md-icon></md-button><md-menu-content \nclass=\"remove-due-date-menu-content\" width=\"4\" ms-scroll><md-menu-item><md-button ng-click=\"vm.card.due = \'\'\" \naria-label=\"remove due date\" translate-attr-aria-label=\"SB.REMOVE_DUE_DATE\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon><span translate=\"SB.REMOVE_DUE_DATE\">Remove Due Date</span></md-button></md-menu-item></md-menu-content>\n</md-menu><md-menu md-offset=\"0 48\" class=\"labels\"><md-button class=\"md-icon-button\" aria-label=\"Label\" translate \ntranslate-attr-aria-label=\"SB.LABEL\" ng-click=\"vm.labelTabIndex = 0;$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-label-outline\"></md-icon></md-button><md-menu-content class=\"labels-menu-content\" width=\"4\" \nms-scroll><md-tabs md-selected=\"vm.labelTabIndex\" md-dynamic-height><md-tab><md-tab-body><md-menu-item>\n<md-input-container class=\"no-errors-spacer\" md-no-float><input placeholder=\"Search labels...\" type=\"text\" \nng-model=\"vm.labelSearchText\" autocomplete=\"off\" translate-attr-palceholder=\"SB.SEARCH_LABELS\"></md-input-container>\n</md-menu-item><md-menu-item class=\"label\" ng-repeat=\"label in vm.labels | filter: vm.filterLabel\"><md-button \nclass=\"label-toggle-button\" md-prevent-menu-close ng-class=\"\'md-\'+label.color+\'-bg\'\" \nng-click=\"vm.toggleInArray(label.id, vm.card.idLabels)\" aria-label=\"Toggle Label\" translate \ntranslate-attr-aria-label=\"SB.TOGGLE_LABEL\"><div layout=\"row\" layout-align=\"space-between center\"><span>{{label.name}}\n</span> <i ng-if=\"vm.exists(label.id, vm.card.idLabels)\" class=\"icon-check s16\"></i></div></md-button><md-button \nclass=\"md-icon-button label-edit-button\" md-prevent-menu-close \nng-click=\"vm.editLabelId = label.id; vm.labelTabIndex = 2\" aria-label=\"Edit Label\" translate \ntranslate-attr-aria-label=\"SB.EDIT_LABEL\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon></md-button>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button class=\"add-label-button\" \nmd-prevent-menu-close ng-click=\"vm.labelTabIndex = 1\"><md-icon md-font-icon=\"icon-plus-circle-outline\"></md-icon><span \ntranslate=\"SB.ADD_NEW_LABEL\">Add new label</span></md-button></md-menu-item></md-tab-body></md-tab><md-tab>\n<md-tab-body><div class=\"add-label-tab-content\"><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<md-button class=\"md-icon-button\" md-prevent-menu-close ng-click=\"vm.labelTabIndex = 0\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"SB.BACK\"><i class=\"icon-arrow-left s20\"></i></md-button><span flex \ntranslate=\"SB.CREATE_LABEL\">Create Label</span></div><div class=\"content\" layout=\"column\" layout-align=\"start stretch\">\n<form ng-submit=\"vm.addNewLabel(); vm.labelTabIndex = 0\" layout=\"column\"><md-input-container class=\"no-errors-spacer\" \nmd-no-float><input placeholder=\"Label Name\" type=\"text\" ng-model=\"vm.newLabelName\" translate \ntranslate-attr-placeholder=\"SB.LABEL_NAME\"></md-input-container><div class=\"label-color-picker\" layout=\"row\" \nlayout-wrap><label class=\"color\" ng-repeat=\"(palette, hues) in vm.palettes\" \nng-style=\"{\'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1)}\" layout=\"column\" \nlayout-align=\"center center\"><input class=\"ng-hide\" type=\"radio\" ng-model=\"vm.newLabelColor\" ng-value=\"palette\" \naria-label=\"{{palette}}\"> <i class=\"icon-check s18\" ng-if=\"vm.newLabelColor === palette\"></i></label></div><md-button \ntype=\"submit\" md-prevent-menu-close class=\"create-button md-accent md-raised\" aria-label=\"Create\" translate \ntranslate-attr-aria-label=\"SB.CREATE\"><span translate=\"SB.CREATE\">Create</span></md-button></form></div></div>\n</md-tab-body></md-tab><md-tab><md-tab-body><div class=\"edit-label-tab-content\"><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button class=\"md-icon-button\" md-prevent-menu-close \nng-click=\"vm.labelTabIndex = 0\" aria-label=\"back\" translate translate-attr-aria-label=\"SB.BACK\"><i \nclass=\"icon-arrow-left s20\"></i></md-button><span flex translate=\"SB.EDIT_LABEL\">Edit Label</span></div><div \nclass=\"content\" layout=\"column\" layout-align=\"start stretch\"><md-input-container class=\"no-errors-spacer\" md-no-float>\n<input placeholder=\"Label Name\" type=\"text\" ng-model=\"vm.board.labels.getById(vm.editLabelId).name\" translate \ntranslate-attr-placeholder=\"SB.LABEL_NAME\"></md-input-container><div class=\"label-color-picker\" layout=\"row\" \nlayout-wrap><label class=\"color\" ng-repeat=\"(palette, hues) in vm.palettes\" \nng-style=\"{\'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1)}\" layout=\"column\" \nlayout-align=\"center center\"><input class=\"ng-hide\" type=\"radio\" \nng-model=\"vm.board.labels.getById(vm.editLabelId).color\" ng-value=\"palette\" aria-label=\"{{palette}}\"> <i \nng-if=\"vm.board.labels.getById(vm.editLabelId).color === palette\" class=\"icon-check s18\"></i></label></div><div \nlayout=\"row\" layout-align=\"end center\" flex><md-button class=\"remove-button md-icon-button\" type=\"submit\" \nmd-prevent-menu-close ng-click=\"vm.removeLabel(); vm.labelTabIndex=0\" aria-label=\"remove\" translate \ntranslate-attr-aria-label=\"SB.REMOVE\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div></div></div>\n</md-tab-body></md-tab></md-tabs></md-menu-content></md-menu><md-menu md-offset=\"0 48\" class=\"members\"><md-button \nclass=\"md-icon-button\" aria-label=\"Members\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-account-multiple\"></md-icon></md-button><md-menu-content class=\"members-menu-content\" width=\"4\" \nms-scroll><md-menu-item><md-input-container class=\"no-errors-spacer\" md-no-float><input \nplaceholder=\"Search members...\" autocomplete=\"off\" type=\"text\" ng-model=\"vm.memberSearchText\" translate \ntranslate-attr-placeholder=\"SB.SEARCH_MEMBERS\"></md-input-container></md-menu-item><md-menu-item class=\"member\" \nng-repeat=\"member in vm.members  | filter: vm.filterMember\"><md-button \nng-click=\"vm.toggleInArray(member.id, vm.card.idMembers)\" md-prevent-menu-close aria-label=\"toggle member\" translate \ntranslate-attr-aria-label=\"SB.TOGGLE_MEMBER\"><div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><img alt=\"{{ member.name }}\" ng-src=\"{{ member.avatar }}\" class=\"avatar\"><p \nclass=\"member-name\">{{ member.name }}</p></div><i class=\"icon-check s16\" \nng-if=\"vm.exists(member.id, vm.card.idMembers)\"></i></div></md-button></md-menu-item></md-menu-content></md-menu>\n<md-button class=\"md-icon-button\" ng-click=\"\" aria-label=\"Attachment\" translate \ntranslate-attr-aria-label=\"SB.ATTACHMENT\"><md-icon md-font-icon=\"icon-attachment\"></md-icon></md-button><md-menu \nmd-offset=\"0 48px\" class=\"checklist\"><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" \naria-label=\"checklist\" translate translate-attr-aria-label=\"SB.CHECKLIST\"><md-icon md-menu-origin \nmd-font-icon=\"icon-checkbox-marked\"></md-icon></md-button><md-menu-content class=\"checklist-menu-content\" width=\"4\">\n<form ng-submit=\"vm.createCheckList()\" layout=\"column\" layout-align=\"start end\"><md-input-container \nclass=\"no-errors-spacer\" md-no-float><input placeholder=\"Checklist Title\" autocomplete=\"off\" type=\"text\" \nng-model=\"vm.newCheckListTitle\" translate translate-attr-placeholder=\"SB.CHECKLIST_TITLE\"></md-input-container>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Add Checklist\" translate \ntranslate-attr-aria-label=\"SB.ADD_CHECKLIST\"><span translate=\"SB.ADD_CHECKLIST\">Add Checklist</span></md-button></form>\n</md-menu-content></md-menu><md-menu md-offset=\"0 48px\" class=\"subscribe\"><md-button class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\" aria-label=\"Subscribe\" translate translate-attr-aria-label=\"SB.SUBSCRIBE\"><md-icon \nmd-menu-origin ng-if=\"vm.card.subscribed\" md-font-icon=\"icon-eye\"></md-icon><md-icon md-menu-origin \nng-if=\"!vm.card.subscribed\" md-font-icon=\"icon-eye-off\"></md-icon></md-button><md-menu-content \nclass=\"subscribe-menu-content\" width=\"4\"><md-menu-item><md-button ng-click=\"vm.card.subscribed = !vm.card.subscribed\" \naria-label=\"Subscribed\" translate translate-attr-aria-label=\"SB.SUBSCRIBED\"><span ng-if=\"!vm.card.subscribed\" \ntranslate=\"SB.SUBSCRIBE\">Subscribe</span> <span ng-if=\"vm.card.subscribed\" translate=\"SB.UNSUBSCRIBE\">Unsubscribe\n</span></md-button></md-menu-item></md-menu-content></md-menu><md-menu md-offset=\"0 48px\" class=\"options\"><md-button \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" aria-label=\"Options\" translate \ntranslate-attr-aria-label=\"SB.OPTIONS\"><md-icon md-menu-origin md-font-icon=\"icon-dots-horizontal\"></md-icon>\n</md-button><md-menu-content class=\"options-menu-content\" width=\"4\"><md-menu-item><md-button \nng-click=\"vm.removeCard()\" aria-label=\"Remove Card\" translate translate-attr-aria-label=\"SB.REMOVE_CARD\"><md-icon \nmd-font-icon=\"icon-delete\" md-menu-align-target></md-icon><span translate=\"SB.REMOVE_CARD\">Remove Card</span>\n</md-button></md-menu-item></md-menu-content></md-menu><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close Dialog\" translate translate-attr-aria-label=\"SB.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"row\" \nlayout-align=\"space-between start\"><div layout=\"column\" layout-align=\"start start\"><div class=\"card-breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><span>{{vm.board.name}}</span> <i class=\"icon-menu-right\"></i> <span>\n{{vm.getCardList().name}}</span></div><div layout=\"row\" layout-align=\"start center\"><md-icon \nng-if=\"vm.card.subscribed\" class=\"card-subscribe s18\" md-font-icon=\"icon-eye\"></md-icon><div class=\"card-name\"><span \neditable-text=\"vm.card.name\">{{vm.card.name}}</span></div></div></div><div ng-if=\"vm.card.due\" class=\"due-date\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"picker day-picker\" moment-picker=\"vm.card.due\" format=\"x\" \nmin-view=\"year\" max-view=\"month\" start-view=\"month\"><div layout=\"row\" layout-align=\"start center\"><i \nclass=\"s18 icon icon-calendar\"></i> <span>{{vm.card.due | date:\'mediumDate\'}}</span></div></div><div \nclass=\"picker hour-picker\" moment-picker=\"vm.card.due\" format=\"x\" min-view=\"day\" max-view=\"hour\" start-view=\"day\"><div \nlayout=\"row\" layout-align=\"start center\"><i class=\"s18 icon icon-clock\"></i> <span>{{vm.card.due | date:\'shortTime\'}}\n</span></div></div><div class=\"remove-due-date\" layout=\"row\" layout-align=\"center center\" ng-click=\"vm.card.due = \'\'\">\n<i class=\"s16 icon icon-close\"></i></div></div></div><div class=\"description\"><md-input-container class=\"md-block\">\n<label translate=\"SB.DESCRIPTION\">Description</label><textarea ng-model=\"vm.card.description\" columns=\"1\" \nmd-maxlength=\"150\" rows=\"5\"></textarea></md-input-container></div><div class=\"sections\"><div \nng-if=\"vm.card.idLabels[0] || vm.card.idMembers[0]\" class=\"section\" layout=\"row\"><div ng-if=\"vm.card.idLabels[0]\" flex \nclass=\"labels\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-label-outline s18\">\n</i> <span class=\"section-title\" translate=\"SB.LABELS\">Labels</span></div><div class=\"section-content\"><md-chips \nclass=\"label-chips\" ng-model=\"vm.card.idLabels\" md-autocomplete-snap md-require-match=\"true\" \nmd-transform-chip=\"$chip.id\"><md-autocomplete md-selected-item=\"vm.selectedLabel\" md-search-text=\"vm.searchLabelText\" \nmd-items=\"label in vm.labelQuerySearch(vm.searchLabelText)\" md-item-text=\"label.name\" placeholder=\"Search for a label\">\n<span md-highlight-text=\"vm.searchLabelText\">{{label.name}}</span></md-autocomplete><md-chip-template \nclass=\"label-chip\" ng-class=\"\'md-\'+vm.board.labels.getById($chip).color+\'-bg\'\"><span>\n{{vm.board.labels.getById($chip).name}}</span></md-chip-template><button md-chip-remove class=\"md-primary\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s18\"></md-icon></button></md-chips></div></div><div ng-if=\"vm.card.idMembers[0]\" flex \nclass=\"members\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><i \nclass=\"icon-account-multiple s18\"></i> <span class=\"section-title\" translate=\"SB.MEMBERS\">Members</span></div><div \nclass=\"section-content\"><md-chips class=\"member-chips\" ng-model=\"vm.card.idMembers\" md-autocomplete-snap \nmd-require-match=\"true\" md-transform-chip=\"$chip.id\"><md-autocomplete md-selected-item=\"vm.selectedMember\" \nmd-search-text=\"vm.searchText\" md-items=\"member in vm.memberQuerySearch(vm.searchText)\" md-item-text=\"member.name\" \nplaceholder=\"Search for a member\"><span md-highlight-text=\"vm.searchText\">{{member.name}}</span></md-autocomplete>\n<md-chip-template class=\"member-chip\"><img class=\"member-chip-avatar\" \nng-src=\"{{vm.board.members.getById($chip).avatar}}\"><md-tooltip>{{vm.board.members.getById($chip).name}}</md-tooltip>\n</md-chip-template><button md-chip-remove class=\"md-primary\"><md-icon md-font-icon=\"icon-close\" class=\"s18\"></md-icon>\n</button></md-chips></div></div></div><div ng-if=\"vm.card.attachments[0]\" class=\"section\"><div class=\"attachments\"><div\n class=\"section-header\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-attachment s18\"></i> <span \nclass=\"section-title\" translate=\"SB.ATTACHMENTS\">Attachments</span></div><div class=\"section-content\"><div \nclass=\"attachment\" ng-repeat=\"item in vm.card.attachments\" ng-switch=\"item.type\"><div ng-switch-when=\"image\" \nlayout=\"row\"><div class=\"attachment-preview md-whiteframe-2dp\" ng-style=\"{\'background-image\': \'url({{item.src}})\'}\">\n</div><div class=\"attachment-content\" layout=\"column\"><div layout=\"row\" layout-align=\"start center\"><span \nclass=\"attachment-name\">{{item.name}}</span> <i ng-if=\"vm.card.idAttachmentCover === item.id\" \nclass=\"icon-star yellow-700-fg attachment-is-cover s18\"></i></div><span class=\"attachment-time\">{{item.time}}</span>\n<md-menu><md-button class=\"md-raised attachment-actions-button\" ng-click=\"$mdMenu.open($event)\" \naria-label=\"attachment actions\"><span layout=\"row\" layout-align=\"center center\"><span translate=\"SB.ACTIONS\">Actions\n</span> <i class=\"icon-chevron-down s20\"></i></span></md-button><md-menu-content><md-menu-item><md-button \nng-click=\"vm.toggleCoverImage(item.id)\" aria-label=\"Toggle Cover Image\" translate \ntranslate-attr-aria-label=\"SB.TOGGLE_COVER_IMAGE\"><span ng-if=\"vm.card.idAttachmentCover !== item.id\" translate \ntranslate=\"SB.MAKE_COVER\">Make Cover</span> <span ng-if=\"vm.card.idAttachmentCover === item.id\" translate \ntranslate=\"SB.REMOVE_COVER\">Remove Cover</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.removeAttachment(item)\" aria-label=\"Remove Attachment\" translate \ntranslate-attr-aria-label=\"SB.REMOVE_ATTACHMENT\"><span translate=\"SB.REMOVE_ATTACHMENT\">Remove Attachment</span>\n</md-button></md-menu-item></md-menu-content></md-menu></div></div><div ng-switch-when=\"link\" layout=\"row\"><div \nclass=\"attachment-preview md-whiteframe-2dp\" layout=\"column\" layout-align=\"center center\"><span translate=\"SB.LINK\">\nLINK</span></div><div class=\"attachment-content\" layout=\"column\"><span class=\"attachment-url\">{{item.url}}</span> <span\n class=\"attachment-time\">{{item.time}}</span></div></div></div><md-button class=\"add-attachment-button\" \naria-label=\"add attachment\"><div layout=\"row\" layout-align=\"start center\"><i class=\"icon-plus s20\"></i> <span \ntranslate=\"SB.ADD_AN_ATTACHMENT\">Add an attachment</span></div></md-button></div></div></div><div \nng-if=\"vm.card.checklists\" class=\"section\" ng-repeat=\"checklist in vm.card.checklists\"><div class=\"checklist\"><div \nclass=\"section-header\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-checkbox-marked s18\"></i> <span flex \nclass=\"section-title\" editable-text=\"checklist.name\">{{checklist.name}}</span><md-menu \nmd-position-mode=\"target-right target\" class=\"options\"><md-button class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\" aria-label=\"options\" translate translate-attr-aria-label=\"SB.OPTIONS\"><md-icon \nmd-menu-origin md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content class=\"options-menu-content\" \nwidth=\"4\"><md-menu-item><md-button ng-click=\"vm.removeChecklist(checklist)\" aria-label=\"Remove Checklist\" translate \ntranslate-attr-aria-label=\"SB.REMOVE_CHECKLIST\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span \ntranslate=\"SB.REMOVE_CHECKLIST\">Remove Checklist</span></md-button></md-menu-item></md-menu-content></md-menu></div>\n<div class=\"section-content\"><div class=\"checklist-progress\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"checklist-progress-value\">{{checklist.checkItemsChecked}} / {{checklist.checkItems.length}}</span>\n<md-progress-linear class=\"md-accent checklist-progressbar\" md-mode=\"determinate\" \nvalue=\"{{100 * checklist.checkItemsChecked / checklist.checkItems.length}}\"></md-progress-linear></div><div \nclass=\"check-items\"><div class=\"check-item\" ng-repeat=\"checkItem in checklist.checkItems\"><md-checkbox \nng-model=\"checkItem.checked\" ng-change=\"vm.updateCheckedCount(checklist)\" aria-label=\"{{checkItem.name}}\">\n{{checkItem.name}}</md-checkbox></div></div><form name=\"newCheckItemForm\" class=\"new-check-item-form\" \nng-submit=\"vm.addCheckItem(vm[checklist.id].newCheckItem, checklist);vm[checklist.id].newCheckItem = \'\'\" layout=\"row\" \nlayout-align=\"start center\"><md-input-container class=\"no-errors-spacer\" flex><label layout=\"row\" \nlayout-align=\"center\"><i class=\"icon-plus s18\"></i> <span translate=\"SB.ADD_AN_ITEM\">Add an item</span></label><input \ntype=\"text\" autocomplete=\"off\" ng-model=\"vm[checklist.id].newCheckItem\"></md-input-container><md-button type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Add\" translate translate-attr-aria-label=\"SB.ADD\"><span translate=\"SB.ADD\">Add\n</span></md-button></form></div></div></div><div class=\"section\"><div class=\"comments\"><div class=\"section-header\" \nlayout=\"row\" layout-align=\"start center\"><i class=\"icon-comment s18\"></i> <span class=\"section-title\" \ntranslate=\"SB.COMMENTS\">Comments</span></div><div class=\"section-content\"><form name=\"cardCommentForm\" \nng-submit=\"vm.addNewComment(vm.newCommentText); vm.newCommentText =\'\'\" class=\"comment new-comment\" layout=\"column\" \nlayout-align=\"start\" no-validate><div layout=\"row\"><img class=\"comment-member-avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-input-container flex md-no-float><textarea ms-scroll \nplaceholder=\"Write a comment..\" ng-model=\"vm.newCommentText\" required translate \ntranslate-attr-placeholder=\"SB.WRITE_A_COMMENT\"></textarea></md-input-container></div><div layout=\"row\" \nlayout-align=\"end center\"><md-button type=\"submit\" class=\"md-raised md-accent\" \nng-disabled=\"cardCommentForm.$invalid || cardCommentForm.$pristine\" aria-label=\"Add\"><span translate=\"SB.ADD\">Add\n</span></md-button></div></form><div class=\"comment\" layout=\"row\" ng-repeat=\"comment in vm.card.comments\"><img \nclass=\"comment-member-avatar\" ng-src=\"{{vm.board.members.getById(comment.idMember).avatar}}\"><div layout=\"column\"><div \nclass=\"comment-member-name\">{{vm.board.members.getById(comment.idMember).name}}</div><div class=\"comment-bubble\">\n{{comment.message}}</div><div class=\"comment-time secondary-text\">{{comment.time}}</div></div></div></div></div></div>\n<div ng-if=\"vm.card.activities[0]\" class=\"section\"><div class=\"activities\"><div class=\"section-header\" layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon-format-list-bulleted s18\"></i> <span class=\"section-title\" \ntranslate=\"SB.ACTIVITY\">Activity</span></div><div class=\"section-content\"><div class=\"activity\" layout=\"row\" \nlayout-align=\"start center\" ng-repeat=\"activity in vm.card.activities\"><img class=\"activity-member-avatar\" \nng-src=\"{{vm.board.members.getById(activity.idMember).avatar}}\"><div class=\"activity-member-name\">\n{{vm.board.members.getById(activity.idMember).name}}</div><div class=\"activity-message\">{{activity.message}}</div><div \nclass=\"activity-time secondary-text\">{{activity.time}}</div></div></div></div></div></div></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/apps/scrumboard/directives/ms-sb-add-card/ms-sb-add-card.html","<div class=\"ms-sb-add-card-button\" layout=\"row\" layout-align=\"start center\" ng-hide=\"formActive\"><div><i \nclass=\"icon-plus s20\"></i></div><span translate=\"SB.ADD_A_CARD\">Add a card</span></div><div \nclass=\"ms-sb-add-card-form-wrapper\" ng-hide=\"!formActive\"><form ng-submit=\"vm.addNewCard()\" \nclass=\"ms-sb-add-card-form\" layout=\"column\"><md-input-container flex md-no-float><input placeholder=\"Card title\" \ntype=\"text\" autocomplete=\"off\" ng-model=\"vm.newCardName\" translate-attr-placeholder=\"SB.CARD_TITLE\">\n</md-input-container><div layout=\"row\" layout-align=\"space-between center\"><md-button type=\"submit\" \nclass=\"add-button md-accent md-raised\" aria-label=\"add\" translate-attr-aria-label=\"SB.ADD\"><span translate=\"SB.ADD\">Add\n</span></md-button><md-button ng-click=\"toggleForm()\" class=\"cancel-button md-icon-button\" aria-label=\"cancel\" \ntranslate-attr-aria-label=\"SB.CANCEL\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></form></div>");
$templateCache.put("app/main/apps/scrumboard/sidenavs/filters/filters-sidenav.html","<md-toolbar class=\"md-accent\" ng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><span flex \nclass=\"menu-title\" translate=\"SB.FILTER_CARDS\">Filter Cards</span><md-button ng-if=\"vm.filteringIsOn()\" \nng-click=\"vm.clearFilters()\" class=\"md-icon-button\" aria-label=\"clear filters\"><md-icon \nmd-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip><span translate=\"SB.CLEAR_FILTER\">Clear Filters</span>\n</md-tooltip></md-button></div></md-toolbar><md-content class=\"\" ms-scroll><md-list><md-subheader class=\"md-no-sticky\" \ntranslate=\"SB.FILTER_BY_CARD_NAME\">Filter by Card Name</md-subheader><md-list-item><input flex \nplaceholder=\"Type Card Name\" type=\"text\" ng-model=\"vm.cardFilters.name\" translate \ntranslate-attr-placeholder=\"SB.TYPE_CARD_NAME\"></md-list-item><md-divider></md-divider><md-subheader \nclass=\"md-no-sticky\" translate=\"SB.FILTER_BY_LABELS\">Filter by Labels</md-subheader><md-list-item class=\"label\" \nng-repeat=\"label in vm.labels\" ng-click=\"vm.toggleInArray(label.id, vm.cardFilters.labels)\"><md-icon \nmd-font-icon=\"icon-label\" ng-class=\"label.color+\'-fg\'\" class=\"label-icon\"></md-icon><p>{{label.name}}</p><i \nclass=\"icon-check s16\" ng-if=\"vm.exists(label.id, vm.cardFilters.labels)\"></i></md-list-item><md-divider></md-divider>\n<md-subheader class=\"md-no-sticky\" translate=\"SB.FILTER_BY_MEMBERS\">Filter by Members</md-subheader><md-list-item \nclass=\"member\" ng-repeat=\"member in vm.members\" ng-click=\"vm.toggleInArray(member.id, vm.cardFilters.members)\" \naria-label=\"Toggle Member\"><img alt=\"{{ member.name }}\" ng-src=\"{{ member.avatar }}\" class=\"md-avatar\"><p \nclass=\"member-name\">{{ member.name }}</p><i class=\"icon-check s16\" \nng-if=\"vm.exists(member.id, vm.cardFilters.members)\"></i></md-list-item></md-list></md-content>");
$templateCache.put("app/main/apps/scrumboard/views/boards/boards-view.html","<div id=\"boards\" class=\"md-accent-bg\" layout=\"column\" flex><div id=\"board-selector\" layout=\"column\" \nlayout-align=\"start center\" flex><h1 translate=\"SB.SCRUMBOARD_APP\">Scrumboard App</h1><div class=\"board-list\" \nlayout=\"row\" layout-align=\"center center\" layout-wrap><div class=\"board-list-item\" ng-repeat=\"board in vm.boardList\" \nui-sref=\"app.scrumboard.boards.board({id:board.id, uri:board.uri})\" layout=\"column\" layout-align=\"center center\">\n<md-icon md-font-icon=\"icon-trello\" class=\"icon s64\"></md-icon><div class=\"board-name\">{{board.name}}</div></div><div \nclass=\"board-list-item add-new-board\" layout=\"column\" layout-align=\"center center\" \nui-sref=\"app.scrumboard.boards.addBoard\"><md-icon md-font-icon=\"icon-plus-circle\" class=\"icon s64\"></md-icon><div \nclass=\"board-name\" translate=\"SB.ADD_NEW_BOARD\">Add new board</div></div></div></div></div>");
$templateCache.put("app/main/apps/scrumboard/views/calendar/calendar-view.html","<div id=\"board-calendar\" class=\"page-layout simple right-sidenav\" flex layout=\"row\" \nng-class=\"vm.board.settings.color+\'-100-bg\'\"><md-sidenav class=\"sidenav scheduled-tasks-sidenav md-sidenav-left\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"scheduled-tasks-sidenav\" \nng-include=\"\'app/main/apps/scrumboard/views/calendar/sidenavs/scheduled-tasks/scheduled-tasks-sidenav.html\'\" ms-scroll \nms-sidenav-helper></md-sidenav><div id=\"calendar\" class=\"md-whiteframe-2dp\" flex layout=\"column\" \nng-class=\"vm.currentMonthShort\"><div class=\"calendar-header\" layout=\"row\" layout-align=\"space-between center\" \nlayout-xs=\"column\"><md-button hide-gt-md class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'scheduled-tasks-sidenav\')\" \naria-label=\"Scheduled Cards Sidenav\"><md-icon md-font-icon=\"icon-calendar-clock\"></md-icon><md-tooltip><span \ntranslate=\"SB.SCHEDULED_CARDS\">Scheduled Cards</span></md-tooltip></md-button><div class=\"\" layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button arrow\" ng-click=\"vm.calendar.prev()\" \naria-label=\"Previous\" translate translate-attr-aria-label=\"SB.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon></md-button><div class=\"title\">{{vm.calendarView.title}}</div><md-button class=\"md-icon-button arrow\" \nng-click=\"vm.calendar.next()\" aria-label=\"Next\" translate translate-attr-aria-label=\"SB.NEXT\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon></md-button></div><div><md-button class=\"md-icon-button\" \nng-click=\"vm.calendar.today()\" aria-label=\"Today\" translate translate-attr-aria-label=\"SB.TODAY\"><md-icon \nmd-font-icon=\"icon-calendar-today\"></md-icon><md-tooltip><span translate=\"SB.TODAY\">Today</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'agendaDay\')\" aria-label=\"Day\" \ntranslate translate-attr-aria-label=\"SB.DAY\"><md-icon md-font-icon=\"icon-view-day\"></md-icon><md-tooltip><span \ntranslate=\"SB.DAY\">Day</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.calendar.changeView(\'agendaWeek\')\" aria-label=\"Week\" translate translate-attr-aria-label=\"SB.WEEK\">\n<md-icon md-font-icon=\"icon-view-week\"></md-icon><md-tooltip><span translate=\"SB.WEEK\">Week</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'month\')\" aria-label=\"Month\" translate \ntranslate-attr-aria-label=\"SB.MONTH\"><md-icon md-font-icon=\"icon-view-module\"></md-icon><md-tooltip><span \ntranslate=\"SB.MONTH\">Month</span></md-tooltip></md-button></div></div><div class=\"calendar-main\" ms-scroll flex \nui-calendar=\"vm.calendarUiConfig.calendar\" ng-model=\"vm.eventSources\" calendar=\"main\"></div></div></div>");
$templateCache.put("app/main/apps/scrumboard/views/board/board-view.html","<div id=\"board\" ng-class=\"vm.board.settings.color+\'-100-bg\'\" ui-sortable=\"vm.sortableListOptions\" \nng-model=\"vm.board.lists\" layout=\"row\"><div class=\"list-wrapper\" ng-repeat=\"list in vm.board.lists track by list.id\">\n<div class=\"list md-whiteframe-1dp\" layout=\"column\"><div class=\"list-header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"list-header-name\"><span editable-text=\"list.name\">{{list.name}}</span>\n</div><md-menu md-offset=\"0 48px\" class=\"options list-header-option-button\"><md-button class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\" aria-label=\"Options\" translate translate-attr-aria-label=\"SB.OPTIONS\"><md-icon \nmd-menu-origin md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content class=\"options-menu-content\" \nwidth=\"4\"><md-menu-item><md-button ng-click=\"vm.removeList($event,list)\" aria-label=\"Remove List\" translate \ntranslate-attr-aria-label=\"SB.REMOVE_LIST\"><md-icon md-font-icon=\"icon-delete\" md-menu-align-target></md-icon><span \ntranslate=\"SB.REMOVE_LIST\">Remove List</span></md-button></md-menu-item></md-menu-content></md-menu></div><div \nclass=\"list-content\" layout=\"column\"><div class=\"list-cards\" ui-sortable=\"vm.sortableCardOptions\" \nng-model=\"list.idCards\" ms-scroll><div ng-if=\"cardId\" class=\"list-card md-whiteframe-2dp\" \nng-repeat=\"cardId in list.idCards | filter: vm.cardFilter track by $index\" \nng-click=\"vm.openCardDialog($event, cardId)\"><div \nng-if=\"vm.board.settings.cardCoverImages && vm.board.cards.getById(cardId).idAttachmentCover\" class=\"list-card-cover\">\n<img \nng-src=\"{{vm.board.cards.getById(cardId).attachments.getById(vm.board.cards.getById(cardId).idAttachmentCover).src}}\">\n</div><div class=\"list-card-details\"><div class=\"list-card-sort-handle\"><md-icon md-font-icon=\"icon-cursor-move\" \nclass=\"icon s16\"></md-icon></div><div ng-if=\"vm.board.cards.getById(cardId).idLabels.length > 0\" \nclass=\"list-card-labels\" layout=\"row\" layout-wrap><span class=\"list-card-label\" \nng-class=\"\'md-\'+vm.board.labels.getById(labelId).color+\'-bg\'\" \nng-repeat=\"labelId in vm.board.cards.getById(cardId).idLabels\"><md-tooltip>{{vm.board.labels.getById(labelId).name}}\n</md-tooltip></span></div><div class=\"list-card-name\">{{vm.board.cards.getById(cardId).name}}</div><div \nng-if=\"vm.board.cards.getById(cardId).due || vm.board.cards.getById(cardId).checkItems\" class=\"list-card-badges\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"badge due-date\" \nng-class=\"{\'overdue\': vm.isOverdue(vm.board.cards.getById(cardId).due)}\" ng-if=\"vm.board.cards.getById(cardId).due\" \nlayout=\"row\" layout-align=\"start center\"><i class=\"icon-clock s16\"></i> <span>\n{{vm.board.cards.getById(cardId).due | date:\'mediumDate\'}}</span> </span><span \nng-if=\"vm.board.cards.getById(cardId).checkItems\" class=\"badge check-items\" \nng-class=\"{\'completed\': vm.board.cards.getById(cardId).checkItemsChecked === vm.board.cards.getById(cardId).checkItems}\" \nlayout=\"row\" layout-align=\"start center\"><i class=\"icon-checkbox-marked-circle s16\"></i> <span>\n{{vm.board.cards.getById(cardId).checkItemsChecked}}</span> <span>/</span> <span>\n{{vm.board.cards.getById(cardId).checkItems}}</span></span></div><div \nng-if=\"vm.board.cards.getById(cardId).idMembers.length > 0\" class=\"list-card-members\" layout=\"row\"><div \nclass=\"list-card-member\" ng-repeat=\"memberId in vm.board.cards.getById(cardId).idMembers\"><img \nclass=\"list-card-member-avatar\" ng-src=\"{{vm.board.members.getById(memberId).avatar}}\"><md-tooltip><div class=\"name\">\n{{ vm.board.members.getById(memberId).name}}</div></md-tooltip></div></div></div><div class=\"list-card-footer\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><span \nng-if=\"vm.board.cards.getById(cardId).subscribed\" class=\"list-card-footer-item\" layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon-eye s18\"></i> </span><span \nng-if=\"vm.board.cards.getById(cardId).description !== \'\'\" class=\"list-card-footer-item\" layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon-document s18\"></i></span></div><div layout=\"row\" layout-align=\"end center\">\n<span class=\"list-card-footer-item\" ng-if=\"vm.board.cards.getById(cardId).attachments\" layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon-attachment s18\"></i> <span class=\"value\">\n{{vm.board.cards.getById(cardId).attachments.length}}</span> </span><span class=\"list-card-footer-item\" \nng-if=\"vm.board.cards.getById(cardId).comments\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-comment s18\">\n</i> <span class=\"value\">{{vm.board.cards.getById(cardId).comments.length}}</span></span></div></div></div></div></div>\n<div class=\"list-footer\"><ms-sb-add-card ms-list-id=\"list.id\"></ms-sb-add-card></div></div></div><div \nclass=\"new-list-wrapper\"><div class=\"list new-list md-whiteframe-1dp\"><span editable-text=\"vm.newListName\" \ne-form=\"newListForm\" onaftersave=\"vm.addNewList()\"></span><md-button class=\"new-list-form-button\" \nng-click=\"newListForm.$show()\" ng-hide=\"newListForm.$visible\"><div layout=\"row\" layout-align=\"start center\"><i \nclass=\"icon-plus md-red-bg\"></i> <span translate=\"SB.ADD_A_LIST\">Add a list</span></div></md-button></div></div></div>");
$templateCache.put("app/main/apps/scrumboard/sidenavs/settings/settings-sidenav.html","<md-toolbar class=\"md-accent\" ng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><md-button \nng-hide=\"vm.selectedMenu === \'Settings\'\" class=\"md-icon-button\" ng-click=\"vm.selectedMenu = \'Settings\'\" \naria-label=\"back\" translate translate-attr-aria-label=\"SB.BACK\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon>\n</md-button><span flex class=\"menu-title\">{{vm.selectedMenu}}</span></div></md-toolbar><md-content \nng-show=\"vm.selectedMenu === \'Settings\'\" class=\"animate-slide-right settings\" ms-scroll ms-sidenav-helper><md-list>\n<md-list-item class=\"item\" ng-click=\"vm.selectedMenu = \'Board Color\'\"><md-icon md-font-icon=\"icon-format-color-fill\" \nclass=\"s18\"></md-icon><p class=\"title\" translate=\"SB.BOARD_COLOR\">Board Color</p></md-list-item><md-list-item \nclass=\"item\" ng-click=\"vm.board.settings.cardCoverImages = !vm.board.settings.cardCoverImages\"><md-icon \nmd-font-icon=\"icon-image-area\" class=\"s18\"></md-icon><p flex class=\"title\" translate=\"SB.CARD_COVER_IMAGES\">\nCard Cover Images</p><md-icon ng-show=\"vm.board.settings.cardCoverImages\" md-font-icon=\"icon-check\" class=\"s18\">\n</md-icon></md-list-item><md-list-item class=\"item\" \nng-click=\"vm.board.settings.subscribed = !vm.board.settings.subscribed\"><md-icon md-font-icon=\"icon-eye\" class=\"s18\">\n</md-icon><p flex class=\"title\" translate=\"SB.SUBSCRIBE\">Subscribe</p><md-icon ng-show=\"vm.board.settings.subscribed\" \nmd-font-icon=\"icon-check\" class=\"s18\"></md-icon></md-list-item><md-list-item class=\"item\"><md-icon \nmd-font-icon=\"icon-content-copy\" class=\"s18\"></md-icon><p class=\"title\" translate=\"SB.COPY_BOARD\">Copy Board</p>\n</md-list-item><md-list-item class=\"item\"><md-icon md-font-icon=\"icon-delete\" class=\"s18\"></md-icon><p class=\"title\" \ntranslate=\"SB.DELETE_BOARD\">Delete Board</p></md-list-item><md-divider></md-divider><md-list-item class=\"item\" \nng-click=\"vm.selectedMenu = \'Labels\'\" aria-label=\"inbox\"><md-icon md-font-icon=\"icon-label\" class=\"s18\"></md-icon><p \nclass=\"title\" translate=\"SB.LABELS\">Labels</p></md-list-item><md-list-item class=\"item\" \nng-click=\"vm.selectedMenu = \'Members\'\" aria-label=\"inbox\"><md-icon md-font-icon=\"icon-account-multiple\" class=\"s18\">\n</md-icon><p class=\"title\" translate=\"SB.MEMBERS\">Members</p></md-list-item></md-list></md-content><md-content \nng-show=\"vm.selectedMenu === \'Board Color\'\" class=\"animate-slide-left board-color-selection\"><div layout=\"column\" \nlayout-fill ng-include=\"\'app/main/apps/scrumboard/sidenavs/settings/menus/color/color-menu.html\'\" \nng-controller=\"ColorMenuController as vm\"></div></md-content><md-content ng-show=\"vm.selectedMenu === \'Labels\'\" \nclass=\"animate-slide-left labels\"><div layout=\"column\" layout-fill \nng-include=\"\'app/main/apps/scrumboard/sidenavs/settings/menus/labels/labels-menu.html\'\" \nng-controller=\"LabelsMenuController as vm\"></div></md-content><md-content ng-show=\"vm.selectedMenu === \'Members\'\" \nclass=\"animate-slide-left members\"><div layout=\"column\" layout-fill \nng-include=\"\'app/main/apps/scrumboard/sidenavs/settings/menus/members/members-menu.html\'\" \nng-controller=\"MembersMenuController as vm\"></div></md-content>");
$templateCache.put("app/main/apps/sitemap/dialogs/duplicate-sitemaps-dialog/duplicate-sitemaps-dialog.controller.html","<md-dialog id=\"duplicate-sitemap\" class=\"duplicate-sitemap\" aria-label=\"EDIT\"><md-toolbar class=\"md-accent md-hue-2\">\n<div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between\"><h1 class=\"mr-0 flex-100 title\" \nstyle=\"line-height: 1\" layout=\"column\" layout-align=\"center start\"><span>{{ \'SITEMAP.DUPLICATE_SITEMAP\' | translate}}\n</span></h1><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div \nng-repeat=\"sitemap in vm.sitemaps\"><div class=\"md-toolbar-tools ph-20 grey-100-bg\" layout=\"column\" \nlayout-align=\"start start\"><h3 class=\"grey-700-fg ph-20\">Title: {{sitemap.name}}</h3><h4 class=\"grey-700-fg ph-20\">\nURL: {{sitemap.url}}</h4></div><div class=\"ph-15\" flex=\"100\" layout=\"column\"><md-input-container flex=\"100\" \nflex-gt-xs=\"40\" class=\"md-block\"><label translate=\"SITEMAP.NAME\"></label><input type=\"text\" \nng-model=\"sitemap.new_name\" placeholder=\"{{vm.translate(\'SITEMAP.NAME\')}}\"></md-input-container><div layout=\"row\" \nlayout-align=\"start start\"><md-input-container flex=\"70\" class=\"md-block\"><label translate=\"SITEMAP.URL\"></label><input\n type=\"text\" ng-model=\"sitemap.new_url\" placeholder=\"{{vm.translate(\'SITEMAP.URL\')}}\"></md-input-container>\n<md-input-container flex=\"30\" class=\"md-block\"><label translate=\"SITEMAP.EXTENSION\"></label><input type=\"text\" \nng-model=\"sitemap.new_extension\" placeholder=\"{{vm.translate(\'SITEMAP.EXTENSION\')}}\"></md-input-container></div></div>\n</div></md-dialog-content><md-dialog-actions layout=\"row\" layout-=\"end\"><md-input-container flex layout=\"row\" \nlayout-align=\"end center\" class=\"pv-0\"><md-button ng-disabled=\"vm.isDisabled()\" type=\"submit\" \nclass=\"send-button md-accent md-raised\" ng-click=\"vm.saveDialog()\" translate=\"FORMS.SAVE\">SAVE</md-button><md-button \ntype=\"button\" class=\"md-raised md-warn\" ng-click=\"vm.closeDialog()\" translate=\"FORMS.CANCEL\">Cancel</md-button>\n</md-input-container></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/sitemap/dialogs/select-sitemap-dialog/select-sitemap-dialog.html","<md-dialog id=\"select-sitemap\" class=\"select-sitemap\" aria-label=\"EDIT\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between\"><h1 class=\"mr-0 flex-100 title\" \nstyle=\"line-height: 1\" layout=\"column\" layout-align=\"center start\"><span>\n{{ \'SITEMAP.SELECT_PARENT_SITEMAP\' | translate}}</span></h1><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"row\" flex=\"100\" class=\"search-bar\"><md-icon \nng-click=\"vm.showSearch= true;\" id=\"ms-search-bar-expander\" md-font-icon=\"icon-magnify\" \nclass=\"md-icon-button md-button\"><md-tooltip hide show-gt-xs><span translate=\"TOOLBAR.SEARCH\">Search</span>\n</md-tooltip></md-icon><input style=\"background: #fafafa\" id=\"ms-search-bar-input\" type=\"text\" \nng-model=\"vm.searchQuery\" placeholder=\"Search\" md-autofocus translate translate-attr-placeholder=\"TOOLBAR.SEARCH\" flex>\n<md-icon id=\"ms-search-bar-collapser\" ng-click=\"vm.searchQuery= \'\';\" md-font-icon=\"icon-close\" \nclass=\"icon s24 pointer\"></md-icon></div><div ng-if=\"vm.sitemaps\" ivh-treeview=\"vm.sitemaps\" \nivh-treeview-filter=\"filterItems\" class=\"treeview-sitemap scrollable\" ms-scroll=\"vm.msScrollOptions\"><script \ntype=\"text/ng-template\">\n<div  class=\"level-card p-8 group-row pointer\" layout=\"row\" layout-align=\"space-between stretch\">\r\n                    <span ivh-treeview-twistie ivh-treeview-toggle layout=\"row\" layout-align=\"center center\"></span>\r\n                    <div class=\"item\"  flex id=\"treeview-group-{{node.id_sitemap}}\" data-group-node={{node}} layout=\"row\" layout-align=\"start center\">\r\n                        <span class=\"item-lang\" ng-if=\"node.lang_name\" layout=\"row\" layout-align=\"start center\">\r\n                                <div  layout=\"column\" >\r\n                                    <img class=\"flag img-flag mr-10\" ng-src=\"assets/images/flags/{{node.flag_code.toLowerCase()}}.svg\">\r\n                                </div>\r\n                                <div  layout=\"column\">\r\n                                    <span class=\"title \" translate=\"{{ \'SITEMAP.\' + node.lang_name.toUpperCase() | translate}}\"></span>\r\n                                    <span >/{{node.label.toLowerCase()}}</span>\r\n                                </div>\r\n                        </span>\r\n                        <span ng-if =\"!node.lang_name\" layout=\"row\" layout-align=\"start center\" flex=\"100\" qiu-sitemap-on-select item=\"{{node}}\" rowid=\"{{node.id_sitemap}}\">\r\n                            <span  layout=\"row\" layout-align=\"start center\" flex=\"100\" class=\"mr-5\">\r\n                                    <div  layout=\"column\" layout-align=\"start\">\r\n                                        <md-icon class=\"grey-folder ml-0 mr-10\" ng-if =\"!node.external_url && node.extension !== \'json\' && (node.children && node.children.length > 0)\" \r\n                                            md-font-icon=\"icon-folder\" \r\n                                            aria-hidden=\"true\" >\r\n                                        </md-icon>\r\n                                        <md-icon class=\"grey-folder ml-0 mr-10\" ng-if =\"!node.external_url && node.extension !== \'json\' && (!node.children || node.children.length == 0)\" \r\n                                            md-font-icon=\"icon-document\" \r\n                                            aria-hidden=\"true\" >\r\n                                        </md-icon>\r\n                                        <md-icon class=\"grey-folder ml-0 mr-10\" ng-if =\"!node.external_url && node.extension == \'json\'\" \r\n                                            md-font-icon=\"icon-code-braces\" \r\n                                            aria-hidden=\"true\" >\r\n                                        </md-icon>\r\n                                        <md-icon class=\"grey-folder ml-0 mr-10\" ng-if =\"node.external_url\" \r\n                                            md-font-icon=\"icon-link-variant\" \r\n                                            aria-hidden=\"true\" >\r\n                                        </md-icon>\r\n                                    </div>\r\n                                    <div  layout=\"column\" layout-align=\"start\">\r\n                                            <span class=\"title word-break-word\">{{node.label.toUpperCase()}}</span>\r\n                                            <a ng-click=\"previewURL(location)\" class=\"grey-fg word-break-word\" ng-if =\"!node.external_url\" >{{node.url}}.{{node.extension}}</a>\r\n                                            <a href=\"{{node.external_url}}\" target=\"_blank\" class=\"grey-fg word-break-word\" ng-if =\"node.external_url\" >{{node.external_url}}</a>\r\n                                    </div>\r\n                            </span>\r\n                        </span>\r\n\r\n                    </div>\r\n                </div>\r\n                <div class=\"children\" ivh-treeview-children>  </div>\n</script></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/sitemap/dialogs/copy-sitemaps-dialog/copy-sitemaps-dialog.controller.html","<md-dialog id=\"copy-sitemap\" class=\"copy-sitemap\" aria-label=\"EDIT\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between\"><h1 class=\"mr-0 flex-100 title\" \nstyle=\"line-height: 1\" layout=\"column\" layout-align=\"center start\"><span>{{ \'SITEMAP.DUPLICATE_SITEMAP\' | translate}}\n</span></h1><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"p-15\">\n<md-input-container flex=\"100\" class=\"md-block\"><label translate=\"SITEMAP.LANG\"></label><md-select \nng-model=\"vm.langSelected\" placeholder=\"{{vm.translate(\'SITEMAP.LANG\')}}\"><md-option value=\"\">---</md-option><md-option\n ng-repeat=\"lang in vm.langs\" value=\"{{lang.id}}\">{{lang.name}}</md-option></md-select></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-=\"end\"><md-input-container flex layout=\"row\" \nlayout-align=\"end center\" class=\"pv-0\"><md-button ng-disabled=\"!vm.langSelected\" type=\"submit\" \nclass=\"send-button md-accent md-raised\" ng-click=\"vm.saveDialog()\" translate=\"FORMS.SAVE\">SAVE</md-button><md-button \ntype=\"button\" class=\"md-raised md-warn\" ng-click=\"vm.closeDialog()\" translate=\"FORMS.CANCEL\">Cancel</md-button>\n</md-input-container></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/sitemap/views/edit/edit-view-lite.html","<md-icon ng-if=\"vm.collapsedSidenav\" ng-click=\"vm.collapsedSidenav= false;\" md-font-icon=\"icon-backburger reverse\">\n</md-icon><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" style=\"padding: 8px 4px\" \nng-if=\"vm.currentSitemap\"><div flex layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button close-thread\" aria-label=\"Back\" ng-click=\"vm.closeSitemap()\" \nng-if=\"vm.currentView==\'nosplit\' && vm.currentWidgets\" translate translate-attr-aria-label=\"CONTENT.BACK\"><md-icon \nmd-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4 layout=\"row\" layout-align=\"start center\" \nclass=\"text-truncate ml-40\" flex ng-if=\"vm.currentSitemap.name\"><md-icon hide show-gt-xs \nclass=\"grey-400-fg grey-folder ml-0 mr-5\" \nng-if=\"!vm.currentSitemap.external_url && vm.currentSitemap.extension !== \'json\'\" md-font-icon=\"icon-document\" \naria-hidden=\"true\"></md-icon><md-icon hide show-gt-xs class=\"grey-400-fg grey-folder ml-0 mr-5\" \nng-if=\"!vm.currentSitemap.external_url && vm.currentSitemap.extension == \'json\'\" md-font-icon=\"icon-code-braces\" \naria-hidden=\"true\"></md-icon><md-icon hide show-gt-xs class=\"grey-400-fg grey-folder ml-0 mr-5\" \nng-if=\"vm.currentSitemap.external_url\" md-font-icon=\"icon-link-variant\" aria-hidden=\"true\"></md-icon><strong>\n{{vm.currentSitemap.external_url || vm.currentSitemap.url || vm.currentSitemap.name.toUpperCase()}}</strong> <a \nng-if=\"vm.sitemapUrl\" href=\"{{vm.sitemapUrl}}\" target=\"_blank\"><md-button \nclass=\"md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme\" \nng-disabled=\"!vm.currentSitemap.url && !vm.currentSitemap.external_url\"><md-icon md-font-icon=\"icon-launch\" \nclass=\"s24\"></md-icon><md-tooltip hide show-gt-xs>{{\'SITEMAP.OPEN_LINK\' | translate}}</md-tooltip></md-button></a></h4>\n<div layout=\"row\" layout-align=\"end center\" style=\"margin-left: auto\"><div hide show-gt-sm><md-button type=\"submit\" \nng-click=\"vm.saveWidgetsAssocs(vm.currentWidgetsAssocs, true)\" class=\"send-button md-accent md-raised\" \naria-label=\"SAVE\" translate=\"SITEMAP.SAVE\" translate-attr-aria-label=\"SITEMAP.SAVE\">SAVE</md-button><md-button \ntype=\"button\" ng-click=\"vm.closeWidgetsAssocs()\" class=\"md-raised md-warn\" aria-label=\"Cancel\" \ntranslate=\"SITEMAP.CANCEL\" translate-attr-aria-label=\"SITEMAP.CANCEL\">Cancel</md-button></div><div hide-gt-sm>\n<md-button type=\"submit\" ng-click=\"vm.saveWidgetsAssocs(vm.currentWidgetsAssocs, true)\" \nclass=\"ml-0 md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme\" aria-label=\"SAVE\"><md-icon \nmd-font-icon=\"icon-check\" ng-hide=\"vm.savingProcess\"></md-icon><md-progress-circular md-mode=\"indeterminate\" \nng-if=\"vm.savingProcess\"></md-progress-circular><md-tooltip hide show-gt-xs><span translate=\"SITEMAP.SAVE\">Save</span>\n</md-tooltip></md-button><md-button type=\"button\" ng-click=\"vm.closeWidgetsAssocs()\" \nclass=\"ml-0 md-warn md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme\" aria-label=\"Cancel\"><md-icon \nmd-font-icon=\"icon-window-close\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"SITEMAP.CANCEL\">Cancel</span>\n</md-tooltip></md-button></div></div></div></div><div class=\"mail-content\" layout=\"column\" \nlayout-align=\"center center\" ng-hide=\"isLoadingReadPane\" ng-if=\"!vm.currentWidgetsAssocs\" flex=\"100\"><div \nclass=\"content\" layout=\"column\" layout-align=\"top center\"><div class=\"message\" translate=\"SITEMAP.NO_SITEMAP_SELECTED\">\n</div></div></div><div flex layout=\"column\" layout-align=\"center center\" ng-if=\"isLoadingReadPane || vm.reloading\" \nclass=\"loading-container\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div>\n<div class=\"mail-content\" layout=\"row\" layout-align=\"start start\" ng-if=\"vm.currentWidgetsAssocs\"><form \nname=\"vm.basicForm\" class=\"md-inline-form flex\" novalidate><md-content flex=\"\"><div \nclass=\"mail-content file-details scrollable\" ms-scroll=\"vm.msScrollOptions\"><div \nng-repeat=\"(zone, zoneWidgetsAssocs) in vm.currentWidgetsAssocs \"><md-list><md-list-item \nclass=\"md-toolbar-tools grey-100-bg md-no-proxy _md\" role=\"listitem\" style=\"border-top: 1px solid gainsboro\"><h3 \nclass=\"grey-700-fg\">Zone {{zone}}</h3><md-divider></md-divider></md-list-item></md-list><md-list \ndnd-list=\"zoneWidgetsAssocs\"><div ng-repeat=\"widgetAssoc in zoneWidgetsAssocs\" ng-if=\"widgetAssoc.can_see===1\">\n<md-list-item dnd-draggable=\"widgetAssoc\" dnd-effect-allowed=\"move\" dnd-moved=\"zoneWidgetsAssocs.splice($index, 1)\" \ndnd-dragend=\"dragendCallback(event, dropEffect)\"><div layout=\"row\" layout-align=\"start space-between\" flex><div \nlayout=\"row\" layout-align=\"start center\"><md-icon class=\"drag icon-equal\" aria-label=\"DRAG\"></md-icon></div><div \nlayout=\"row\" layout-align=\"start center\" class=\"p-10\"><button \nng-if=\"widgetAssoc.can_onoff===1 && widgetAssoc.onoff===1\" class=\"md-icon-button\" ng-click=\"widgetAssoc.onoff = 0\">\n<md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\"></md-icon></button> <button \nng-if=\"widgetAssoc.can_onoff===1 && widgetAssoc.onoff!==1\" class=\"md-icon-button\" ng-click=\"widgetAssoc.onoff = 1\">\n<md-icon md-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\"></md-icon></button> <button \nng-if=\"!widgetAssoc.can_onoff && widgetAssoc.onoff===1\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"on grey-fg s24\"></md-icon></button> <button \nng-if=\"!widgetAssoc.can_onoff && widgetAssoc.onoff!==1\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"on grey-fg s24\"></md-icon></button></div><div class=\"field\" \nlayout=\"row\" layout-align=\"start center\">{{widgetAssoc.description || widgetAssoc.widget.widget_name}}</div></div>\n<md-divider class=\"md-default-theme\"></md-divider></md-list-item><div dnd-list=\"widgetAssoc.children\"><md-list-item \nng-repeat=\"widgetAssocChild in widgetAssoc.children\" ng-if=\"widgetAssocChild.can_see===1\" \ndnd-draggable=\"widgetAssocChild\" dnd-effect-allowed=\"move\" dnd-moved=\"widgetAssoc.children.splice($index, 1)\" \ndnd-dragend=\"dragendCallback(event, dropEffect)\"><div layout=\"row\" layout-align=\"start space-between\" flex \nclass=\"pl-35\"><div layout=\"row\" layout-align=\"start center\"><md-icon class=\"drag icon-equal\" aria-label=\"DRAG\">\n</md-icon></div><div layout=\"row\" layout-align=\"start center\" class=\"p-10\"><button \nng-if=\"widgetAssocChild.can_onoff===1 && widgetAssocChild.onoff===1\" class=\"md-icon-button\" \nng-click=\"widgetAssocChild.onoff = 0\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\">\n</md-icon></button> <button ng-if=\"widgetAssocChild.can_onoff===1 && widgetAssocChild.onoff!==1\" \nclass=\"md-icon-button\" ng-click=\"widgetAssocChild.onoff = 1\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\"></md-icon></button> <button \nng-if=\"!widgetAssocChild.can_onoff && widgetAssocChild.onoff===1\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"on grey-fg s24\"></md-icon></button> <button \nng-if=\"!widgetAssocChild.can_onoff && widgetAssocChild.onoff!==1\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"on grey-fg s24\"></md-icon></button></div><div class=\"field\" \nlayout=\"row\" layout-align=\"start center\">{{widgetAssocChild.widget.widget_name}}</div></div><md-divider \nclass=\"md-default-theme\"></md-divider></md-list-item></div></div></md-list></div></div></md-content></form></div>");
$templateCache.put("app/main/apps/sitemap/views/edit/edit-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" style=\"padding: 8px 4px\" \nng-if=\"vm.currentSitemap\"><div flex layout=\"row\" layout-align=\"start center\"><md-icon ng-if=\"!vm.collapsedSidenav\" \nng-click=\"vm.collapsedSidenav= true;\" md-font-icon=\"icon-backburger\"></md-icon><md-icon ng-if=\"vm.collapsedSidenav\" \nng-click=\"vm.collapsedSidenav= false;\" md-font-icon=\"icon-backburger reverse\"></md-icon><div class=\"divider-vertical\">\n</div><md-button class=\"md-icon-button close-thread\" aria-label=\"Back\" ng-click=\"vm.closeSitemap()\" \nng-if=\"vm.currentView==\'nosplit\' && vm.currentSitemap\" translate translate-attr-aria-label=\"CONTENT.BACK\"><md-icon \nmd-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4 layout=\"row\" layout-align=\"start center\" \nclass=\"text-truncate mh-10\" ng-if=\"!vm.currentSitemap.name\"><strong>NEW PAGE</strong></h4><h4 layout=\"row\" \nlayout-align=\"start center\" class=\"text-truncate mh-10\" ng-if=\"vm.currentSitemap.name\"><md-icon hide show-gt-xs \nclass=\"grey-400-fg grey-folder ml-0 mr-5\" ng-if=\"vm.currentSitemap.home == 1\" md-font-icon=\"icon-home\" \naria-hidden=\"true\"></md-icon><md-icon hide show-gt-xs class=\"grey-400-fg grey-folder ml-0 mr-5\" \nng-if=\"!vm.currentSitemap.external_url && vm.currentSitemap.extension !== \'json\' && vm.currentSitemap.home !== 1\" \nmd-font-icon=\"icon-document\" aria-hidden=\"true\"></md-icon><md-icon hide show-gt-xs \nclass=\"grey-400-fg grey-folder ml-0 mr-5\" \nng-if=\"!vm.currentSitemap.external_url && vm.currentSitemap.extension == \'json\' && vm.currentSitemap.home !== 1\" \nmd-font-icon=\"icon-code-braces\" aria-hidden=\"true\"></md-icon><md-icon hide show-gt-xs \nclass=\"grey-400-fg grey-folder ml-0 mr-5\" ng-if=\"vm.currentSitemap.external_url && vm.currentSitemap.home !== 1\" \nmd-font-icon=\"icon-link-variant\" aria-hidden=\"true\"></md-icon><strong>{{vm.currentSitemap.name.toUpperCase()}}</strong>\n</h4><div class=\"divider-vertical\" ng-if=\"vm.sitemapUrl\"></div><a ng-if=\"vm.sitemapUrl\" href=\"{{vm.sitemapUrl}}\" \ntarget=\"_blank\"><md-button class=\"md-icon-button md-accent\" \nng-disabled=\"!vm.currentSitemap.url && !vm.currentSitemap.external_url\"><md-icon md-font-icon=\"icon-launch\" \nclass=\"s24\"></md-icon><md-tooltip hide show-gt-xs>{{\'SITEMAP.OPEN_LINK\' | translate}}</md-tooltip></md-button></a><div \nlayout=\"row\" layout-align=\"end center\" style=\"margin-left: auto\"><span ng-if=\"!isseosection\" class=\"mr-10\" \nlayout=\"row\" layout-align=\"end center\"><button ng-if=\"vm.currentSitemap.onoff===1\" \nng-click=\"vm.currentSitemap.onoff = 0\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" \nclass=\"on green-fg s24\"></md-icon></button> <button ng-if=\"vm.currentSitemap.onoff!==1\" \nng-click=\"vm.currentSitemap.onoff = 1\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\"></md-icon></button></span><div hide \nshow-gt-sm><md-button type=\"submit\" ng-click=\"vm.saveSitemap(vm.currentSitemap, true)\" \nclass=\"send-button md-accent md-raised\" aria-label=\"SAVE\" translate=\"SITEMAP.SAVE\" \ntranslate-attr-aria-label=\"SITEMAP.SAVE\">SAVE</md-button><md-button type=\"button\" ng-click=\"vm.closeSitemap()\" \nclass=\"md-raised md-warn\" aria-label=\"Cancel\" translate=\"SITEMAP.CANCEL\" translate-attr-aria-label=\"SITEMAP.CANCEL\">\nCancel</md-button></div><div hide-gt-sm><md-button type=\"submit\" ng-click=\"vm.saveSitemap(vm.currentSitemap, true)\" \nclass=\"ml-0 md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme\" aria-label=\"SAVE\"><md-icon \nmd-font-icon=\"icon-check\" ng-hide=\"vm.savingProcess\"></md-icon><md-progress-circular md-mode=\"indeterminate\" \nng-if=\"vm.savingProcess\"></md-progress-circular><md-tooltip hide show-gt-xs><span translate=\"SITEMAP.SAVE\">Save</span>\n</md-tooltip></md-button><md-button type=\"button\" ng-click=\"vm.closeSitemap()\" \nclass=\"ml-0 md-warn md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme\" aria-label=\"Cancel\"><md-icon \nmd-font-icon=\"icon-window-close\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"SITEMAP.CANCEL\">Cancel</span>\n</md-tooltip></md-button></div><md-menu-bar ng-if=\"!isseosection\" class=\"pr-0 pl-0\"><md-menu class=\"settings-menu\">\n<md-button aria-label=\"Settings\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" translate=\"\" \ntranslate-attr-aria-label=\"SITEMAP.ACTIONS\"><md-icon md-font-icon=\"icon-cog\"></md-icon></md-button><md-menu-content>\n<md-menu-item ng-click=\"vm.copySitemapWindow($event, [vm.currentSitemap], lang)\" ng-repeat=\"lang in vm.langs\">\n<md-button aria-label=\"Duplicate\" translate-attr-aria-label=\"SITEMAP.COPY\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-content-copy\"></md-icon><span class=\"mr-10\" \ntranslate=\"SITEMAP.COPY\"></span> <img class=\"flag img-flag mr-10\" ng-src=\"assets/images/flags/{{lang.name}}.svg\"></div>\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.duplicateSitemapWindow($event)\" \naria-label=\"Duplicate\" translate-attr-aria-label=\"SITEMAP.DUPLICATE\"><md-icon md-font-icon=\"icon-content-duplicate\">\n</md-icon><span translate=\"SITEMAP.DUPLICATE\"></span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.migrateAllOldWidgets()\" aria-label=\"Migrate\" translate-aria-label=\"SITEMAP.MIGRATE_WIDGETS\"><md-icon \nmd-font-icon=\"icon-content-duplicate\"></md-icon><span translate=\"SITEMAP.MIGRATE_WIDGETS\"></span></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.confirmAction(\'delete\')\" aria-label=\"Delete\" \ntranslate-aria-label=\"SITEMAP.DELETE\" class=\"red-fg\"><md-icon md-font-icon=\"icon-delete\" class=\"red-fg\"></md-icon><span\n translate=\"SITEMAP.DELETE\"></span></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div></div>\n</div><div class=\"mail-content\" layout=\"column\" layout-align=\"center center\" ng-hide=\"isLoadingReadPane\" \nng-if=\"!vm.currentSitemap\" flex=\"100\"><div class=\"content\" layout=\"column\" layout-align=\"top center\"><div \nclass=\"message\" translate=\"SITEMAP.NO_SITEMAP_SELECTED\"></div></div></div><div flex layout=\"column\" \nlayout-align=\"center center\" ng-if=\"isLoadingReadPane || vm.reloading\" class=\"loading-container\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div class=\"mail-content\" layout=\"column\" \nlayout-align=\"start start\" ng-if=\"vm.currentSitemap\"><form name=\"vm.basicForm\" layout=\"column\" \nclass=\"width-percent-100 white-bg pt-20 border-bottom\"><div ng-if=\"!isseosection\" class=\"ph-15\" flex=\"100\" \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"20\" class=\"md-block mh-5\"><label \ntranslate=\"SITEMAP.SUBDOMAIN\"></label><md-select ng-change=\"vm.changeURL()\" ng-model=\"vm.currentSitemap.id_template\" \nplaceholder=\"{{vm.translate(\'SITEMAP.SUBDOMAIN\')}}\"><md-option value=\"\">---</md-option><md-option \nng-repeat=\"subdomain in vm.subDomains\" value=\"{{subdomain.id_template}}\">{{subdomain.template_name}}</md-option>\n</md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"20\" class=\"md-block mh-5\"><label \ntranslate=\"SITEMAP.LANG\"></label><md-select ng-model=\"vm.currentSitemap.lang\" \nplaceholder=\"{{vm.translate(\'SITEMAP.LANG\')}}\"><md-option value=\"\">ROOT</md-option><md-option \nng-repeat=\"lang in vm.langs\" value=\"{{lang.id}}\">{{lang.name}}</md-option></md-select></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"40\" class=\"md-block mh-5\"><label translate=\"SITEMAP.NAME\"></label><input \ntype=\"text\" ng-model=\"vm.currentSitemap.name\" placeholder=\"{{vm.translate(\'SITEMAP.NAME\')}}\"></md-input-container>\n</div><div ng-if=\"isseosection\"><span class=\"bold p-20\">URL: /{{vm.currentSitemap.url}}</span></div></form><div \nclass=\"relative width-percent-100 flex\"><md-tabs md-selected=\"vm.tabSelected\" flex class=\"width-percent-100\"><md-tab \nng-if=\"!isseosection\" label=\"{{ vm.translate(\'SITEMAP.LAYOUT\')}}\"><div ng-if=\"vm.tabSelected == 0\" \nng-include=\"\'app/main/apps/sitemap/views/edit/tabs/tab-layout.html\'\"></div></md-tab><md-tab ng-if=\"!isseosection\" \nlabel=\"{{ vm.translate(\'SITEMAP.PREVIEW\')}}\"><div ng-init=\"vm.iframeFinishLoad= false\" ng-if=\"vm.tabSelected == 1\" \nstyle=\"height: 100%\" class=\"grey-500-bg\"><div ng-if=\"!vm.iframeFinishLoad\" flex layout=\"column\" \nlayout-align=\"center center\" class=\"loading-container\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\">\n</md-progress-circular></div><iframe id=\"iframeSitemap\" iframe-onload=\"vm.onLoadedIframe()\" \nclass=\"{{vm.deviceSelected}}\" ng-if=\"vm.sitemapUrl\" src=\"{{vm.sitemapUrl}}\" frameborder=\"0\"></iframe></div></md-tab>\n<md-tab ng-if=\"!isseosection\" label=\"{{ vm.translate(\'SITEMAP.BASIC\')}}\"><div ng-if=\"vm.tabSelected == 2\" \nng-include=\"\'app/main/apps/sitemap/views/edit/tabs/tab-basic.html\'\"></div></md-tab><md-tab \nlabel=\"{{ vm.translate(\'SITEMAP.SEO\')}}\"><div ng-if=\"vm.tabSelected == 3 || isseosection\" \nng-include=\"\'app/main/apps/sitemap/views/edit/tabs/tab-seo.html\'\"></div></md-tab><md-tab ng-if=\"!isseosection\" \nlabel=\"{{ vm.translate(\'SITEMAP.WIZARD\')}}\"><div ng-if=\"vm.tabSelected == 4\" \nng-include=\"\'app/main/apps/sitemap/views/edit/tabs/tab-wizard.html\'\"></div></md-tab></md-tabs><span \nng-if=\"vm.tabSelected == 1\" class=\"responsive-icons\"><md-icon ng-click=\"vm.selectDevice(\'desktop\')\" \nng-class=\"{\'active\' : vm.deviceSelected == \'desktop\'}\" md-font-icon=\"icon-laptop\"></md-icon><md-icon \nng-click=\"vm.selectDevice(\'tablet\')\" ng-class=\"{\'active\' : vm.deviceSelected == \'tablet\'}\" \nmd-font-icon=\"icon-tablet-ipad\"></md-icon><md-icon ng-click=\"vm.selectDevice(\'phone\')\" \nng-class=\"{\'active\' : vm.deviceSelected == \'phone\'}\" md-font-icon=\"icon-cellphone-iphone\"></md-icon></span></div></div>");
$templateCache.put("app/main/apps/sitemap/views/list/list-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" style=\"padding: 8px 4px\"><div layout=\"row\" \nng-if=\"vm.showSearch\" flex=\"100\" class=\"search-bar\"><md-icon ng-click=\"vm.showSearchToggle()\" \nid=\"ms-search-bar-expander\" md-font-icon=\"icon-magnify\" class=\"md-icon-button md-button\"><md-tooltip hide show-gt-xs>\n<span translate=\"TOOLBAR.SEARCH\">Search</span></md-tooltip></md-icon><input style=\"background: #fafafa\" \nid=\"ms-search-bar-input\" type=\"text\" ng-model=\"vm.searchQuery\" placeholder=\"Search\" md-autofocus translate \ntranslate-attr-placeholder=\"TOOLBAR.SEARCH\" flex class=\"font-size-18\"><md-icon id=\"ms-search-bar-collapser\" \nng-click=\"vm.showSearch= false; vm.searchQuery= \'\';\" md-font-icon=\"icon-close\" class=\"icon s24 pointer\"></md-icon>\n</div><div flex layout=\"row\" ng-if=\"!vm.showSearch\" layout-align=\"start center\"><md-button aria-label=\"ADD NEW\" \nclass=\"md-fab md-mini md-accent green-500-bg md-raised md-ink-ripple md-default-theme\" \nng-if=\"!vm.collapsedSidenav && !isseosection\" ng-click=\"vm.newSitemap()\" type=\"button\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button><div ng-if=\"!vm.showQiuGroupsSidenav && vm.islite\" \nclass=\"divider-vertical\" hide show-gt-xs></div><div flex layout=\"row\" layout-align=\"start center\"><div \nclass=\"divider-vertical\"></div><label for=\"ms-search-bar-input\"><md-icon ng-click=\"vm.showSearchToggle()\" \nid=\"ms-search-bar-expander\" md-font-icon=\"icon-magnify\" class=\"md-icon-button md-button\"><md-tooltip hide show-gt-xs>\n<span translate=\"TOOLBAR.SEARCH\">Search</span></md-tooltip></md-icon></label><md-menu><button aria-label=\"Filters\" \nclass=\"md-icon-button md-button\" ng-click=\"$mdMenu.open($event)\" show-gt-xs=\"\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.FILTERS\"><md-icon md-font-icon=\"icon-filter\"><md-tooltip><span \ntranslate=\"SITEMAP.FILTERS\"></span></md-tooltip></md-icon></button><md-menu-content width=\"4\"><md-menu-item><md-button \nng-click=\"vm.toggleMenuItems()\" aria-label=\"Remove sort\" ng-click=\"pagination_resetOrderBy()\"><span layout=\"row\" \nlayout-align=\"space-between center\"><span><md-icon md-font-icon=\"icon-laptop\" class=\"s24\"></md-icon><span>\n{{\'SITEMAP.ONLY_ITEMS_IN_MENU\' | translate}}</span></span><md-icon md-font-icon=\"icon-check\" class=\"s20 mr-0\" \nng-if=\"vm.onlyMenu\"></md-icon></span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.togglePathItems()\" aria-label=\"Remove sort\" ng-click=\"pagination_resetOrderBy()\"><span layout=\"row\" \nlayout-align=\"space-between center\"><span><md-icon md-font-icon=\"icon-laptop\" class=\"s24\"></md-icon><span>\n{{\'SITEMAP.SORT_BY_PATH\' | translate}}</span></span><md-icon md-font-icon=\"icon-check\" class=\"s20 mr-0\" \nng-if=\"vm.onlyPath\"></md-icon></span></md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item>\n<md-button ng-click=\"vm.toggleJsonItems()\" aria-label=\"Remove sort\" ng-click=\"pagination_resetOrderBy()\"><span \nlayout=\"row\" layout-align=\"space-between center\"><span><md-icon md-font-icon=\"icon-code-braces\" class=\"s24\"></md-icon>\n<span>{{\'SITEMAP.ONLY_JSON_ITEMS\' | translate}}</span></span><md-icon md-font-icon=\"icon-check\" class=\"s20 mr-0\" \nng-if=\"vm.onlyJson\"></md-icon></span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.toggleHtmlItems()\" aria-label=\"Remove sort\" ng-click=\"pagination_resetOrderBy()\"><span layout=\"row\" \nlayout-align=\"space-between center\"><span><md-icon md-font-icon=\"icon-document\" class=\"s24\"></md-icon><span>\n{{\'SITEMAP.ONLY_HTML_ITEMS\' | translate}}</span></span><md-icon md-font-icon=\"icon-check\" class=\"s20 mr-0\" \nng-if=\"vm.onlyHtml\"></md-icon></span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.toggleExternalItems()\" aria-label=\"Remove sort\" ng-click=\"pagination_resetOrderBy()\"><span layout=\"row\" \nlayout-align=\"space-between center\"><span><md-icon md-font-icon=\"icon-link-variant\" class=\"s24\"></md-icon><span>\n{{\'SITEMAP.ONLY_EXTERNAL_ITEMS\' | translate}}</span></span><md-icon md-font-icon=\"icon-check\" class=\"s20 mr-0\" \nng-if=\"vm.onlyExternal\"></md-icon></span></md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item>\n<md-button ng-click=\"vm.showByRow= !vm.showByRow; pagination_resetOrderBy()\" aria-label=\"Remove sort\"><span \nlayout=\"row\" layout-align=\"space-between center\"><span><md-icon md-font-icon=\"icon-view-list\" class=\"mh-5\"></md-icon>\n<span>{{\'SITEMAP.SHOW_BY_ROW\' | translate}}</span></span><md-icon md-font-icon=\"icon-check\" class=\"s20 mr-0\" \nng-if=\"vm.showByRow\"></md-icon></span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.showByRow= !vm.showByRow\" aria-label=\"Remove sort\" ng-click=\"pagination_resetOrderBy()\"><span \nlayout=\"row\" layout-align=\"space-between center\"><span><md-icon md-font-icon=\"icon-view-column\" class=\"mh-5\"></md-icon>\n<span>{{\'SITEMAP.SHOW_BY_COLUMN\' | translate}}</span></span><md-icon md-font-icon=\"icon-check\" class=\"s20 mr-0\" \nng-if=\"!vm.showByRow\"></md-icon></span></md-button></md-menu-item></md-menu-content></md-menu><div \nclass=\"divider-vertical\"></div><md-input-container ng-if=\"!isseosection\" flex=\"100\" flex-gt-xs=\"25\" \nclass=\"md-block mh-5\"><label translate=\"SITEMAP.SUBDOMAIN\"></label><md-select ng-model=\"vm.subdomainFilter\" \nplaceholder=\"{{vm.translate(\'SITEMAP.SUBDOMAIN\')}}\"><md-option value=\"\" ng-click=\"vm.getSitemapsSubdomain()\">---\n</md-option><md-option ng-repeat=\"subdomain in vm.subDomains\" \nng-click=\"vm.getSitemapsSubdomain(subdomain.id_template)\" value=\"{{subdomain.id_template}}\">{{subdomain.template_name}}\n</md-option></md-select></md-input-container><md-icon class=\"pointer mh-15\" ng-if=\"vm.showDeleteButton()\" \nng-click=\"vm.massActions(\'delete\')\" md-font-icon=\"icon-delete\"><md-tooltip><span translate=\"CONTENT.DELETE\"></span>\n</md-tooltip></md-icon><md-icon class=\"pointer mh-15\" ng-if=\"vm.showDeleteButton()\" \nng-click=\"vm.duplicateSitemapWindow($event, vm.getChecked())\" md-font-icon=\"icon-content-duplicate\"><md-tooltip><span \ntranslate=\"CONTENT.DUPLICATE\"></span></md-tooltip></md-icon><md-icon class=\"pointer mh-15\" \nng-if=\"vm.showDeleteButton()\" ng-click=\"vm.copySitemapWindow($event, vm.getChecked())\" \nmd-font-icon=\"icon-content-copy\"><md-tooltip><span translate=\"SITEMAP.COPY\"></span></md-tooltip></md-icon><div \nclass=\"divider-vertical\" ng-if=\"vm.showDeleteButton()\"></div><button ng-if=\"!vm.showQiuGroupsSidenav && vm.islite\" \naria-label=\"view group\" class=\"md-button md-icon-button\" ng-click=\"vm.toggleQiuGroupsSidenav()\" translate \ntranslate-attr-aria-label=\"CONTENT.VIEW_GROUPS\"><md-icon md-font-icon=\"icon-folder-multiple\"></md-icon><md-tooltip \nhide show-gt-xs><span translate=\"CONTENT.VIEW_GROUPS\">View Groups</span></md-tooltip></button><md-button \nng-if=\"!vm.selectedGroup && vm.showAddToGroupsButton()\" qiu-groups-add-selected-items-dialog \nqiu-groups-membership-id-field=\"\'id_social_account\'\" qiu-groups-membership-selected-items=\"[]\" \nqiu-groups-nested=\"vm.groups\" qiu-groups-membership-mass-insert=\"vm.massInsertIntoGroups\" class=\"md-icon-button\" \naria-label=\"Add\" translate-attr-aria-label=\"QIU_GROUPS.ADD_TO_GROUPS\"><md-icon md-font-icon=\"icon-folder-account\">\n</md-icon><md-tooltip hide show-gt-xs><span translate=\"QIU_GROUPS.ADD_TO_GROUPS\"></span></md-tooltip></md-button>\n<md-button ng-if=\"vm.selectedGroup && vm.showRemoveFromGroupsButton() && !vm.selectedGroup.is_qiu_restricted_root\" \nqiu-groups-remove-selected-items-dialog qiu-groups-membership-id-field=\"\'id_social_account\'\" \nqiu-groups-membership-selected-items=\"vm.selectedThreads\" qiu-groups-membership-selected-group=\"vm.selectedGroup\" \nqiu-groups-membership-remove=\"vm.removeFromGroup\" class=\"md-icon-button\" aria-label=\"Remove\" \ntranslate-attr-aria-label=\"QIU_GROUPS.REMOVE_FROM_GROUP\"><md-icon md-font-icon=\"icon-folder-remove\"></md-icon>\n<md-tooltip hide show-gt-xs><span translate=\"QIU_GROUPS.REMOVE_FROM_GROUP\"></span></md-tooltip></md-button></div></div>\n</div><div flex layout=\"column\" layout-align=\"center center\" ng-if=\"isLoading\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nng-if=\"vm.sitemaps && vm.showByRow\" ivh-treeview=\"vm.sitemaps\" ivh-treeview-filter=\"filterItems\" \nclass=\"treeview-sitemap scrollable\" ms-scroll=\"vm.msScrollOptions\"><script type=\"text/ng-template\">\n<div class=\"level-card p-8 group-row pointer\" layout=\"row\" layout-align=\"space-between stretch\">\r\n        <span ivh-treeview-twistie ivh-treeview-toggle layout=\"row\" layout-align=\"center center\"></span>\r\n        <div class=\"item\"  flex id=\"treeview-group-{{node.id_sitemap}}\" layout=\"row\" layout-align=\"start center\">\r\n            <span fill-width class=\"item-lang\" ng-if=\"node.lang_name\" layout=\"row\" layout-align=\"start center\">\r\n                    <div  layout=\"column\" >\r\n                        <img class=\"flag img-flag mr-10\" ng-src=\"assets/images/flags/{{node.flag_code.toLowerCase()}}.svg\">\r\n                    </div>\r\n                    <div  layout=\"column\">\r\n                        <span class=\"title \" translate=\"{{ \'SITEMAP.\' + node.lang_name.toUpperCase() | translate}}\"></span>\r\n                        <span ng-if=\"node.label\">/{{node.label.toLowerCase()}}</span>\r\n                    </div>\r\n                    <span class=\"ml-auto\">\r\n                        <md-checkbox ng-if=\"!$root.isseosection\" ng-checked=\"node.checked\"  id=\"{{node.id_lang}}\" qiu-sitemap-on-toggle-click class=\"no-label\" aria-label=\"check\"></md-checkbox>\r\n                    </span>\r\n            </span>\r\n            <span ng-if =\"!node.lang_name\" layout=\"row\" layout-align=\"start center\" flex=\"100\" qiu-sitemap-on-click item=\"{{node.id_sitemap}}\" rowid=\"{{node.id_sitemap}}\">\r\n                <span  layout=\"row\" layout-align=\"start center\" flex=\"100\" class=\"mr-5\">\r\n                        <div  layout=\"column\" layout-align=\"start\">\r\n                            <md-icon class=\"grey-folder ml-0 mr-10\" ng-if=\"node.home == 1\"\r\n                                md-font-icon=\"icon-home\"\r\n                                aria-hidden=\"true\">\r\n                            </md-icon>\r\n                            <md-icon class=\"grey-folder ml-0 mr-10\" ng-if =\"!node.external_url && node.extension !== \'json\' && (node.children && node.children.length > 0) && node.home !== 1\"\r\n                                md-font-icon=\"icon-folder\"\r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon class=\"grey-folder ml-0 mr-10\" ng-if =\"!node.external_url && node.extension !== \'json\' && (!node.children || node.children.length == 0) && node.home !== 1\"\r\n                                md-font-icon=\"icon-document\"\r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon class=\"grey-folder ml-0 mr-10\" ng-if =\"!node.external_url && node.extension == \'json\' && node.home !== 1\"\r\n                                md-font-icon=\"icon-code-braces\"\r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                            <md-icon class=\"grey-folder ml-0 mr-10\" ng-if =\"node.external_url && node.home !== 1\"\r\n                                md-font-icon=\"icon-link-variant\"\r\n                                aria-hidden=\"true\" >\r\n                            </md-icon>\r\n                        </div>\r\n                        <div  layout=\"column\" layout-align=\"start\">\r\n                                <span class=\"title word-break-word\">{{node.display_name || node.name}}</span>\r\n                                <span class=\"word-break-word grey-fg\"><span ng-if=\"!node.external_url || node.external_url == \'##\'\">/</span>{{node.external_url || node.sub_item_template || node.url || node.label.toUpperCase()}}</span>\r\n                                <!--<a ng-click=\"previewURL(location)\" class=\"grey-fg word-break-word\" ng-if =\"!node.external_url\" >{{node.url}}<span ng-if=\"node.extension\">.{{node.extension}}</span> </a>\r\n                                <a href=\"{{node.external_url}}\" target=\"_blank\" class=\"grey-fg word-break-word\" ng-if =\"node.external_url\" >{{node.external_url}}</a>-->\r\n                        </div>\r\n                </span>\r\n                <span layout=\"row\" layout-align=\"end center\">\r\n                    <button ng-if=\"node.menu===1\" class=\"md-icon-button mr-10\">\r\n                        <md-icon md-font-icon=\"icon-laptop\" class=\"s24\"></md-icon>\r\n                    </button>\r\n                    <!-- <span class=\"mr-10\" layout=\"row\" layout-align=\"end center\">\r\n\r\n                            <button ng-if=\"node.onoff===1\" ng-click=\"node.onoff = 0\" class=\"md-icon-button \">\r\n                                <md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\"></md-icon>\r\n                            </button>\r\n                            <button ng-if=\"node.onoff!==1\" ng-click=\"node.onoff = 1\" class=\"md-icon-button \">\r\n                                <md-icon md-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\"></md-icon>\r\n                            </button>\r\n\r\n                    </span> -->\r\n                    <span>\r\n                        <md-checkbox ng-if=\"!$root.isseosection\" ng-checked=\"node.checked\" ng-click=\"node.checked = !node.checked;  $event.stopPropagation()\" aria-label=\"check\" class=\"no-label\"></md-checkbox>\r\n                    </span>\r\n                </span>\r\n            </span>\r\n\r\n        </div>\r\n    </div>\r\n    <div class=\"children\" ivh-treeview-children>  </div>\n</script></div><div ng-if=\"vm.sitemaps && !vm.showByRow\" class=\"bycolumn\" flex=\"\" layout=\"row\"><div flex=\"50\" \nng-repeat=\"sitemap in vm.sitemaps\"><div ivh-treeview=\"sitemap\" ivh-treeview-filter=\"filterItems\" \nclass=\"treeview-sitemap\"><script type=\"text/ng-template\">\n<div  class=\"level-card p-8 group-row pointer\" layout=\"row\" layout-align=\"space-between stretch\">\r\n                <span ivh-treeview-twistie ivh-treeview-toggle layout=\"row\" layout-align=\"center center\"></span>\r\n                <div class=\"item\"  flex id=\"treeview-group-{{node.id_sitemap}}\" layout=\"row\" layout-align=\"start center\">\r\n                    <span fill-width class=\"item-lang\" ng-if=\"node.lang_name\" layout=\"row\" layout-align=\"start center\">\r\n                            <div  layout=\"column\" >\r\n                                <img class=\"flag img-flag mr-10\" ng-src=\"assets/images/flags/{{node.flag_code.toLowerCase()}}.svg\">\r\n                            </div>\r\n                            <div  layout=\"column\">\r\n                                <span class=\"title \" translate=\"{{ \'SITEMAP.\' + node.lang_name.toUpperCase() | translate}}\"></span>\r\n                                <span >/{{node.label.toLowerCase()}}</span>\r\n                            </div>\r\n                            <span class=\"ml-auto\">\r\n                                <md-checkbox ng-if=\"!$root.isseosection\" ng-checked=\"node.checked\"  id=\"{{node.id_lang}}\" qiu-sitemap-on-toggle-click class=\"no-label\" aria-label=\"check\"></md-checkbox>\r\n                            </span>\r\n                    </span>\r\n                    <span ng-if =\"!node.lang_name\" layout=\"row\" layout-align=\"start center\" flex=\"100\" qiu-sitemap-on-click item=\"{{node.id_sitemap}}\" rowid=\"{{node.id_sitemap}}\">\r\n                        <span  layout=\"row\" layout-align=\"start center\" flex=\"100\" class=\"mr-5\">\r\n                                <div  layout=\"column\" layout-align=\"start\">\r\n                                    <md-icon class=\"grey-folder ml-0 mr-10\" ng-if =\"!node.external_url && node.extension !== \'json\' && (node.children && node.children.length > 0)\"\r\n                                        md-font-icon=\"icon-folder\"\r\n                                        aria-hidden=\"true\" >\r\n                                    </md-icon>\r\n                                    <md-icon class=\"grey-folder ml-0 mr-10\" ng-if =\"!node.external_url && node.extension !== \'json\' && (!node.children || node.children.length == 0)\"\r\n                                        md-font-icon=\"icon-document\"\r\n                                        aria-hidden=\"true\" >\r\n                                    </md-icon>\r\n                                    <md-icon class=\"grey-folder ml-0 mr-10\" ng-if =\"!node.external_url && node.extension == \'json\'\"\r\n                                        md-font-icon=\"icon-code-braces\"\r\n                                        aria-hidden=\"true\" >\r\n                                    </md-icon>\r\n                                    <md-icon class=\"grey-folder ml-0 mr-10\" ng-if =\"node.external_url\"\r\n                                        md-font-icon=\"icon-link-variant\"\r\n                                        aria-hidden=\"true\" >\r\n                                    </md-icon>\r\n                                </div>\r\n                                <div  layout=\"column\" layout-align=\"start\">\r\n                                        <span class=\"title word-break-word\">{{node.label.toUpperCase()}}</span>\r\n                                        <a ng-click=\"previewURL(location)\" class=\"grey-fg word-break-word\" ng-if =\"!node.external_url\" >{{node.url}}<span ng-if=\"node.extension\">.{{node.extension}}</span> </a>\r\n                                        <a href=\"{{node.external_url}}\" target=\"_blank\" class=\"grey-fg word-break-word\" ng-if =\"node.external_url\" >{{node.external_url}}</a>\r\n                                </div>\r\n                        </span>\r\n                        <span layout=\"row\" layout-align=\"end center\">\r\n                            <button ng-if=\"node.menu===1\" class=\"md-icon-button mr-10\">\r\n                                <md-icon md-font-icon=\"icon-laptop\" class=\"s24\"></md-icon>\r\n                            </button>\r\n                            <span qiu-sitemap-on-toggle-click item=\"{{node.id_sitemap}}\" rowid=\"{{node.id_sitemap}}\"class=\"mr-10\" layout=\"row\" layout-align=\"end center\">\r\n\r\n                                    <button ng-if=\"node.onoff===1\" class=\"md-icon-button \">\r\n                                        <md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\"></md-icon>\r\n                                    </button>\r\n                                    <button ng-if=\"node.onoff!==1\" class=\"md-icon-button \">\r\n                                        <md-icon md-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\"></md-icon>\r\n                                    </button>\r\n\r\n                            </span>\r\n                            <span>\r\n                                <md-checkbox ng-if=\"!$root.isseosection\" ng-checked=\"node.checked\" ng-click=\"node.checked = !node.checked;  $event.stopPropagation()\" aria-label=\"check\" class=\"no-label\"></md-checkbox>\r\n                            </span>\r\n                        </span>\r\n                    </span>\r\n\r\n                </div>\r\n            </div>\r\n            <div class=\"children\" ivh-treeview-children>  </div>\n</script></div></div></div>");
$templateCache.put("app/main/apps/sitemap/views/list/nosplit-view.html","<div class=\"content-wrapper\" flex=\"\" layout=\"row\"><div class=\"content thread-list mail-list-pane\" id=\"thread-list\" \nflex ng-if=\"!vm.currentSitemap && (!vm.showQiuGroupsSidenav || (vm.showQiuGroupsSidenav && vm.selectedGroup))\" \nng-include=\"\'app/main/apps/sitemap/views/list/list-view.html\'\"></div><div class=\"content thread-detail mail-read-pane\" \nid=\"thread-detail\" flex ng-if=\"vm.currentSitemap\" ms-scroll=\"vm.msScrollOptions\" layout=\"column\" \nng-include=\"\'app/main/apps/sitemap/views/edit/edit-view.html\'\"></div></div>");
$templateCache.put("app/main/apps/sitemap/views/list/split-view.html","<div class=\"content-wrapper\" flex=\"\" layout=\"row\"><div class=\"content thread-list mail-list-pane\" \nng-class=\"{\'flex-70\': (!vm.collapsedSidenav && !vm.showByRow),\'flex-30\': (!vm.collapsedSidenav && vm.showByRow), \'flex-0\': vm.collapsedSidenav}\" \nid=\"thread-list\" ng-include=\"\'app/main/apps/sitemap/views/list/list-view.html\'\"></div><div ng-if=\"!vm.islite\" \nclass=\"content thread-detail mail-read-pane\" \nng-class=\"{\'flex-70\': (!vm.collapsedSidenav && vm.showByRow),  \'flex-100\' : vm.collapsedSidenav}\" id=\"thread-detail\" \nms-scroll=\"vm.msScrollOptions\" layout=\"column\" ng-include=\"\'app/main/apps/sitemap/views/edit/edit-view.html\'\"></div>\n<div ng-if=\"vm.islite\" class=\"content thread-detail mail-read-pane flex\" id=\"thread-detail\" \nms-scroll=\"vm.msScrollOptions\" layout=\"column\" ng-include=\"\'app/main/apps/sitemap/views/edit/edit-view-lite.html\'\">\n</div></div>");
$templateCache.put("app/main/apps/sitemap/views/list/toolbar.html","<div layout=\"row\" ng-if=\"vm.showSearch\" flex=\"100\" class=\"search-bar\"><md-icon ng-click=\"vm.showSearchToggle()\" \nid=\"ms-search-bar-expander\" md-font-icon=\"icon-magnify\" class=\"md-icon-button md-button\"><md-tooltip hide show-gt-xs>\n<span translate=\"TOOLBAR.SEARCH\">Search</span></md-tooltip></md-icon><input style=\"background: #fafafa\" \nid=\"ms-search-bar-input\" type=\"text\" ng-model=\"vm.searchQuery\" placeholder=\"Search\" md-autofocus translate \ntranslate-attr-placeholder=\"TOOLBAR.SEARCH\" flex><md-icon id=\"ms-search-bar-collapser\" \nng-click=\"vm.showSearch= false; vm.searchQuery= \'\';\" md-font-icon=\"icon-close\" class=\"icon s24 pointer\"></md-icon>\n</div><div flex layout=\"row\" ng-if=\"!vm.showSearch\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button close-thread\" aria-label=\"Back\" ng-click=\"vm.closeSitemap()\" \nng-if=\"vm.currentView==\'nosplit\' && vm.currentSitemap\" translate translate-attr-aria-label=\"CONTENT.BACK\"><md-icon \nmd-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><md-button aria-label=\"ADD NEW\" \nclass=\"md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme\" hide show-gt-sm \nng-click=\"vm.newSitemap()\" translate=\"CONTENT.ADD\" type=\"button\">Add new</md-button><md-button aria-label=\"ADD NEW\" \nclass=\"md-fab md-mini md-accent green-500-bg md-raised md-ink-ripple md-default-theme\" ng-if=\"!vm.currentSitemap\" \nhide-gt-sm ng-click=\"vm.newSitemap()\" type=\"button\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><div \nlayout=\"row\" layout-align=\"start center\" ng-if=\"vm.currentView==\'nosplit\' && !vm.currentSitemap\"><div \nclass=\"divider-vertical\"></div><label for=\"ms-search-bar-input\"><md-icon ng-click=\"vm.showSearch= true;\" \nid=\"ms-search-bar-expander\" md-font-icon=\"icon-magnify\" class=\"md-icon-button md-button\"><md-tooltip hide show-gt-xs>\n<span translate=\"TOOLBAR.SEARCH\">Search</span></md-tooltip></md-icon></label><div class=\"divider-vertical\"></div>\n<md-button ng-click=\"vm.toggleMenuItems()\" class=\"md-icon-button md-buttom mr-10 ml-10\"><md-icon \nmd-font-icon=\"icon-laptop\" class=\"s24\" ng-style=\"{\'opacity\': vm.onlyMenu ? 1 : 0.3}\"><md-tooltip hide show-gt-xs>\n{{\'SITEMAP.ONLY_ITEMS_IN_MENU\' | translate}}</md-tooltip></md-icon></md-button><div class=\"divider-vertical\"></div>\n</div><div layout=\"row\" layout-align=\"start center\" ng-if=\"vm.currentView!=\'nosplit\'\"><div class=\"divider-vertical\">\n</div><label for=\"ms-search-bar-input\"><md-icon ng-click=\"vm.showSearchToggle()\" id=\"ms-search-bar-expander\" \nmd-font-icon=\"icon-magnify\" class=\"md-icon-button md-button\"><md-tooltip hide show-gt-xs><span \ntranslate=\"TOOLBAR.SEARCH\">Search</span></md-tooltip></md-icon></label><div class=\"divider-vertical\"></div><md-button \nng-click=\"vm.toggleMenuItems()\" class=\"md-icon-button md-buttom mr-10 ml-10\"><md-icon md-font-icon=\"icon-laptop\" \nclass=\"s24\" ng-style=\"{\'opacity\': vm.onlyMenu ? 1 : 0.3}\"><md-tooltip>{{\'SITEMAP.ONLY_ITEMS_IN_MENU\' | translate}}\n</md-tooltip></md-icon></md-button><div class=\"divider-vertical\"></div></div><div layout=\"row\" \nlayout-align=\"end center\" style=\"margin-left: auto\"><div ng-if=\"vm.currentSitemap\" hide show-gt-sm><md-button \ntype=\"submit\" ng-click=\"vm.saveSitemap(vm.currentSitemap, true)\" class=\"send-button md-accent md-raised\" \naria-label=\"SAVE\" translate=\"SITEMAP.SAVE\" translate-attr-aria-label=\"SITEMAP.SAVE\">SAVE</md-button><md-button \ntype=\"button\" ng-click=\"vm.closeSitemap()\" class=\"md-raised md-warn\" aria-label=\"Cancel\" translate=\"SITEMAP.CANCEL\" \ntranslate-attr-aria-label=\"SITEMAP.CANCEL\">Cancel</md-button></div><div ng-if=\"vm.currentSitemap\" hide-gt-sm><md-button\n type=\"submit\" ng-click=\"vm.saveSitemap(vm.currentSitemap, true)\" \nclass=\"md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme\" aria-label=\"SAVE\"><md-icon \nmd-font-icon=\"icon-check\" ng-hide=\"vm.savingProcess\"></md-icon><md-progress-circular md-mode=\"indeterminate\" \nng-if=\"vm.savingProcess\"></md-progress-circular><md-tooltip hide show-gt-xs><span translate=\"SITEMAP.SAVE\">Save</span>\n</md-tooltip></md-button><md-button type=\"button\" ng-click=\"vm.closeSitemap()\" \nclass=\"md-warn md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme\" aria-label=\"Cancel\"><md-icon \nmd-font-icon=\"icon-window-close\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"SITEMAP.CANCEL\">Cancel</span>\n</md-tooltip></md-button></div><md-menu-bar class=\"pr-0 pl-0\" ng-if=\"vm.currentSitemap\"><md-menu class=\"settings-menu\">\n<md-button aria-label=\"Settings\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" translate=\"\" \ntranslate-attr-aria-label=\"SITEMAP.ACTIONS\"><md-icon md-font-icon=\"icon-cog\"></md-icon></md-button><md-menu-content>\n<md-menu-item><md-button aria-label=\"Duplicate\" translate-attr-aria-label=\"SITEMAP.COPY\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-content-copy\"></md-icon><span class=\"mr-10\" \ntranslate=\"SITEMAP.COPY\"></span> <img class=\"flag img-flag mr-10\" ng-src=\"assets/images/flags/en.svg\" \nsrc=\"assets/images/flags/es.svg\"></div></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Duplicate\" \ntranslate-attr-aria-label=\"SITEMAP.DUPLICATE\"><md-icon md-font-icon=\"icon-content-duplicate\"></md-icon><span \ntranslate=\"SITEMAP.DUPLICATE\"></span></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Delete\" \ntranslate-aria-label=\"SITEMAP.DELETE\" class=\"red-fg\"><md-icon md-font-icon=\"icon-delete\" class=\"red-fg\"></md-icon><span\n translate=\"SITEMAP.DELETE\"></span></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div></div>");
$templateCache.put("app/main/apps/store/sidenavs/main/main-sidenav.html","<md-toolbar class=\"md-theme-light md-default-theme md-light-blue-bg\"><h2 class=\"md-toolbar-tools\" aria-label=\"Filters\" \nlayout=\"row\" layout-align=\"space-between center\"><span translate-attr-aria-label=\"CONTENT.FILTERS\" \ntranslate=\"CONTENT.FILTERS\">Filters</span> <button class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'main-sidenav\')\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></button></h2></md-toolbar><md-content ms-scroll class=\"content\" flex><div\n class=\"navigation-simple\" layout=\"column\"><div ng-repeat=\"filterable in refFilterables track by $index\"><md-menu flex \nlayout=\"row\"><md-menu-item flex><md-button aria-label=\"Label\" translate ng-show=\"filterable.values.length>0\" \ntranslate-attr-aria-label=\"SB.LABEL\" ng-click=\"$mdMenu.open($event)\"><div layout=\"row\" layout-align=\"start start\"><span\n class=\"title text-left\" flex>{{filterable.name}}</span><md-icon md-font-icon=\"icon-chevron-down\"></md-icon></div>\n</md-button></md-menu-item><md-menu-content class=\"labels-menu-content\" width=\"4\"><md-menu-item \nclass=\"search-bar border-bottom\" ng-if=\"filterable.values.length>10\"><div layout=\"row\" layout-align=\"start center\" \nclass=\"pl-10 pr-15\"><md-icon md-font-icon=\"icon-magnify\" class=\"md-icon-button ml-0 mr-10\" aria-label=\"Search\" \nrole=\"img\"></md-icon><input placeholder=\"Search labels...\" type=\"text\" flex class=\"font-size-14\" \nng-model=\"vm.filterSearchText[filterable.field]\" autocomplete=\"off\" translate-attr-palceholder=\"SB.SEARCH_LABELS\">\n</div></md-menu-item><div ms-scroll ng-class=\"{\'mt-48\': filterable.values.length>10}\"><md-menu-item class=\"label\" \nng-repeat=\"label in filterable.values | filter: vm.filterSearchText[filterable.field] track by $index\"><md-button \nclass=\"label-toggle-button p-0\" ng-class=\"\'md-\'+label.color+\'-bg\'\" \nng-click=\"vm.toggleInArray(label.value, refFilterables[filterable.field].selected)\" aria-label=\"Toggle Label\" \ntranslate translate-attr-aria-label=\"SB.TOGGLE_LABEL\"><div layout=\"row\" layout-align=\"space-between center\"><span>\n{{vm.translate(\'SHIPPING.\' + label.name)}}</span> <i \nng-if=\"vm.exists(label.value, refFilterables[filterable.field].selected)\" class=\"icon-check s16\"></i></div></md-button>\n</md-menu-item></div><md-divider></md-divider></md-menu-content></md-menu><div \nng-show=\"refFilterables[filterable.field].selected.length>0\"><md-chips class=\"md-chips md-removable close-chip\">\n<md-chip ng-repeat=\"label in filterable.values | filterInArray:filterable.selected:\'value\' track by $index\" \nclass=\"md-accent-bg md-chip\"><div class=\"md-chip-content\">{{label.name}}</div><div class=\"md-chip-remove-container\">\n<button class=\"md-chip-remove\" ng-click=\"vm.toggleInArray(label.value, refFilterables[filterable.field].selected)\" \nmd-chip-remove><md-icon md-font-icon=\"icon-close\"></md-icon></button></div></md-chip></md-chips></div></div></div>\n</md-content>");
$templateCache.put("app/main/apps/store/sidenavs/main/sidenav.html","<md-toolbar class=\"md-theme-light md-default-theme md-light-blue-bg\"><h2 class=\"md-toolbar-tools\" aria-label=\"Filters\" \nlayout=\"row\" layout-align=\"space-between center\"><span translate-attr-aria-label=\"CONTENT.FILTERS\" \ntranslate=\"CONTENT.FILTERS\">Filters</span>asdasdasd <button class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'main-sidenav\')\"><md-icon md-font-icon=\"icon-close\"></md-icon></button></h2></md-toolbar>\n<md-content ms-scroll class=\"content\" flex><div class=\"navigation-simple\" layout=\"column\"><div \nng-repeat=\"filterable in refFilterables\"><md-menu flex layout=\"row\"><md-menu-item flex><md-button aria-label=\"Label\" \ntranslate ng-show=\"filterable.values.length>0\" translate-attr-aria-label=\"SB.LABEL\" ng-click=\"$mdMenu.open($event)\">\n<div layout=\"row\" layout-align=\"start start\"><span class=\"title text-left\" flex>{{filterable.name}}</span><md-icon \nmd-font-icon=\"icon-chevron-down\"></md-icon></div></md-button></md-menu-item><md-menu-content \nclass=\"labels-menu-content\" width=\"4\"><md-menu-item class=\"search-bar border-bottom\" \nng-if=\"filterable.values.length>10\"><div layout=\"row\" layout-align=\"start center\" class=\"pl-10 pr-15\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"md-icon-button ml-0 mr-10\" aria-label=\"Search\" role=\"img\"></md-icon><input \nplaceholder=\"Search labels...\" type=\"text\" flex class=\"font-size-14\" ng-model=\"vm.filterSearchText[filterable.field]\" \nautocomplete=\"off\" translate-attr-palceholder=\"SB.SEARCH_LABELS\"></div></md-menu-item><div ms-scroll \nng-class=\"{\'mt-48\': filterable.values.length>10}\"><md-menu-item class=\"label\" \nng-repeat=\"label in filterable.values | filter: vm.filterSearchText[filterable.field]\"><md-button \nclass=\"label-toggle-button\" ng-class=\"\'md-\'+label.color+\'-bg\'\" \nng-click=\"vm.toggleInArray(label.value, refFilterables[filterable.field].selected)\" aria-label=\"Toggle Label\" \ntranslate translate-attr-aria-label=\"SB.TOGGLE_LABEL\"><div layout=\"row\" layout-align=\"space-between center\"><span>\n{{label.name}}</span> <i ng-if=\"vm.exists(label.value, refFilterables[filterable.field].selected)\" \nclass=\"icon-check s16\"></i></div></md-button></md-menu-item></div><md-divider></md-divider></md-menu-content></md-menu>\n<div ng-show=\"refFilterables[filterable.field].selected.length>0\"><md-chips class=\"md-chips md-removable close-chip\">\n<md-chip ng-repeat=\"label in filterable.values | filterInArray:filterable.selected:\'value\'\" \nclass=\"md-accent-bg md-chip\"><div class=\"md-chip-content\">{{label.name}}</div><div class=\"md-chip-remove-container\">\n<button class=\"md-chip-remove\" ng-click=\"vm.toggleInArray(label.value, refFilterables[filterable.field].selected)\" \nmd-chip-remove><md-icon md-font-icon=\"icon-close\"></md-icon></button></div></md-chip></md-chips></div></div></div>\n</md-content>");
$templateCache.put("app/main/apps/tasks/dialogs/groups/edit-group.html","<md-dialog class=\"small compose-dialog\" aria-label=\"Edit Group\"><form class=\"md-inline-form\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><a class=\"md-button grey-A100-fg\" type=\"import\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-folder\" class=\"s18 mr-5 ml-0 md-font material-icons\" \nrole=\"img\" aria-label=\"icon-folder\"></md-icon><span class=\"title\" ng-if=\"!(vm.group | isEmptyObject)\" \ntranslate=\"GROUP.EDIT\"></span> <span class=\"title\" ng-if=\"vm.group | isEmptyObject\" translate=\"GROUP.CREATE\"></span>\n</a></div><div layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\" translate-aria-label=\"GROUP.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></div></md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-block\"><label \ntranslate=\"GROUP.NAME\"></label><input ng-model=\"vm.groupName\" type=\"text\" required></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"GROUP.TYPE\"></label><md-select ng-model=\"vm.groupTypeId\">\n<md-option ng-value=\"type.id_group_type\" ng-repeat=\"type in vm.groupTypes\">{{ type.name }}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block on-off\"><label translate=\"GROUP.MOVE_TO\"></label><md-menu>\n<button class=\"mr-0 width-percent-100 pb-5 pt-5 button-select\" ng-click=\"$mdMenu.open($event)\" aria-label=\"group-menu\" \nlayout=\"row\" layout-align=\"space-between center\"><span ng-if=\"vm.groupParentName\" class=\"font-size-14\">\n{{vm.groupParentName}}</span> <span ng-if=\"!vm.groupParentName\" class=\"font-size-14\">Root</span><md-icon \nmd-font-icon=\"icon-menu-down\" class=\"grey-600-fg ml-10 mr-0\" aria-hidden=\"true\"></md-icon></button><md-menu-content \nclass=\"md-block groups-tree\"><div ng-if=\"!vm.isQiuRestricted\" ng-click=\"vm.selectParentGroupRoot()\" \nclass=\"level-card p-8 group-row ng-scope\" layout=\"row\" layout-align=\"space-between stretch\"><div flex \nclass=\"layout-align-start-center layout-row flex\"><md-icon md-font-icon=\"icon-folder-multiple\" \nclass=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 ng-scope md-default-theme md-font material-icons icon-folder-multiple\" \naria-hidden=\"true\"></md-icon><span translate=\"GROUP.ROOT\"></span></div></div><div ng-click=\"$mdCloseMenu($event)\" \nng-if=\"vm.groups\" ivh-treeview=\"vm.groups\" class=\"ivh-treeview-folder small\" ivh-treeview-label-attribute=\"\'name\'\">\n<script type=\"text/ng-template\">\n<div class=\"level-card p-8 group-row select-parent-group-row\" layout=\"row\" layout-align=\"space-between stretch\">\r\n                        <span ivh-treeview-twistie ivh-treeview-toggle layout=\"row\" layout-align=\"center center\"></span>\r\n                        <div qiu-on-click-select-parent-group flex id=\"treeview-group-{{node.id_group}}\" data-group-node={{node}} layout=\"row\" layout-align=\"start center\">\r\n                            <md-icon ng-if =\"!node.children && node.id_group_type == 1\" \r\n                            md-font-icon=\"icon-folder\" \r\n                            class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon ng-if =\"!node.children && node.id_group_type == 2\" \r\n                            md-font-icon=\"qiu-icon-file-usermailing\" \r\n                            class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon \r\n                            ng-if =\"node.children && node.id_group_type == 2\" \r\n                            md-svg-src=\"/assets/icons/svg/icon-folder-mail-multiple.svg\"\r\n                            class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon ng-if =\"!node.children && node.id_group_type == 3\" \r\n                            md-font-icon=\"qiu-icon-file-usermediacenter\" \r\n                            class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon \r\n                            ng-if =\"node.children && node.id_group_type == 3\" \r\n                            md-svg-src=\"/assets/icons/svg/icon-folder-play-multiple.svg\"\r\n                            class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon ng-if =\"!node.children && node.id_group_type == 4\" \r\n                            md-font-icon=\"qiu-icon-file-usersegment\" \r\n                            class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon \r\n                            ng-if =\"node.children && node.id_group_type == 4\" \r\n                            md-svg-src=\"/assets/icons/svg/icon-folder-share-multiple.svg\"\r\n                            class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon ng-if =\"!node.children && node.id_group_type == 5\" \r\n                            md-font-icon=\"qiu-icon-file-userstore\" \r\n                            class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon \r\n                            ng-if =\"node.children && node.id_group_type == 5\" \r\n                            md-svg-src=\"/assets/icons/svg/icon-folder-shop-multiple.svg\"\r\n                            class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon ng-if =\"!node.children && node.id_group_type == 6\" \r\n                            md-font-icon=\"qiu-icon-file-useracreditation\" \r\n                            class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon \r\n                            ng-if =\"node.children && node.id_group_type == 6\" \r\n                            md-svg-src=\"/assets/icons/svg/icon-folder-board-multiple.svg\"\r\n                            class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon ng-if =\"!node.children && node.id_group_type == 7\" \r\n                            md-svg-src=\"/assets/icons/svg/icon-folder-chat.svg\"\r\n                            class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon \r\n                            ng-if =\"node.children && node.id_group_type == 7\" \r\n                            md-svg-src=\"/assets/icons/svg/icon-folder-chat-multiple.svg\"\r\n                            class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon ng-if =\"!node.children && node.id_group_type == 8\" \r\n                            md-font-icon=\"icon-folder-remove\" \r\n                            class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon \r\n                            ng-if =\"node.children && node.id_group_type == 8\" \r\n                            md-font-icon=\"icon-folder-multiple\" \r\n                            class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                            aria-hidden=\"true\" >\r\n                        </md-icon> \r\n                        <md-icon \r\n                            ng-if =\"node.children && node.id_group_type == 1\" \r\n                            md-font-icon=\"icon-folder-multiple\" \r\n                            class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                            aria-hidden=\"true\" >\r\n                        </md-icon> \r\n                            <span class=\"ivh-treeview-node-label ng-binding\">{{trvw.label(node)}}</span>\r\n                        </div>\r\n                      </div>\r\n                    <div ivh-treeview-children></div>\n</script></div></md-menu-content></md-menu></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nng-click=\"delete(vm.group)\" class=\"md-icon-button\" aria-label=\"Delete\" ng-if=\"!(vm.group | isEmptyObject)\" \ntranslate-attr-aria-label=\"GROUP.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip hide show-gt-xs>\n<span translate=\"GROUP.DELETE\"></span></md-tooltip></md-button></div><div layout=\"row\" layout-align=\"end center\">\n<md-button ng-click=\"save(vm.group)\" class=\"send-button md-accent md-raised\" aria-label=\"Save\" translate=\"GROUP.SAVE\" \ntranslate-attr-aria-label=\"GROUP.SAVE\"></md-button><md-button ng-click=\"cancel()\" \nclass=\"send-button md-warn md-raised\" aria-label=\"Cancel\" translate=\"GROUP.CANCEL\" \ntranslate-attr-aria-label=\"GROUP.CANCEL\"></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/tasks/dialogs/groups/tree-view.html","<div ng-if=\"vm.usersGroups\" ivh-treeview=\"vm.usersGroups\" class=\"treeview\" \nivh-treeview-on-cb-change=\"vm.checkGroup(ivhNode, ivhIsSelected, ivhTree)\"><script type=\"text/ng-template\">\n<div class=\"level-card p-8 group-row\" layout=\"row\" layout-align=\"space-between stretch\">\r\n            <span ivh-treeview-twistie ivh-treeview-toggle layout=\"row\" layout-align=\"center center\"></span>\r\n            <div flex id=\"treeview-group-{{node.id_group}}\" qiu-on-click-load-users-by-groups data-group-node={{node}} layout=\"row\" layout-align=\"start center\">\r\n                \r\n                <md-icon ng-if =\"!node.children && node.id_group_type == 1\" \r\n                            md-font-icon=\"icon-folder\" \r\n                            class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon ng-if =\"!node.children && node.id_group_type == 2\" \r\n                            md-font-icon=\"qiu-icon-file-usermailing\" \r\n                            class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon \r\n                            ng-if =\"node.children && node.id_group_type == 2\" \r\n                            md-svg-src=\"/assets/icons/svg/icon-folder-mail-multiple.svg\"\r\n                            class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon ng-if =\"!node.children && node.id_group_type == 3\" \r\n                            md-font-icon=\"qiu-icon-file-usermediacenter\" \r\n                            class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon \r\n                            ng-if =\"node.children && node.id_group_type == 3\" \r\n                            md-svg-src=\"/assets/icons/svg/icon-folder-play-multiple.svg\"\r\n                            class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon ng-if =\"!node.children && node.id_group_type == 4\" \r\n                            md-font-icon=\"qiu-icon-file-usersegment\" \r\n                            class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon \r\n                            ng-if =\"node.children && node.id_group_type == 4\" \r\n                            md-svg-src=\"/assets/icons/svg/icon-folder-share-multiple.svg\"\r\n                            class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon ng-if =\"!node.children && node.id_group_type == 5\" \r\n                            md-font-icon=\"qiu-icon-file-userstore\" \r\n                            class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon \r\n                            ng-if =\"node.children && node.id_group_type == 5\" \r\n                            md-svg-src=\"/assets/icons/svg/icon-folder-shop-multiple.svg\"\r\n                            class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon ng-if =\"!node.children && node.id_group_type == 6\" \r\n                            md-font-icon=\"qiu-icon-file-useracreditation\" \r\n                            class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon \r\n                            ng-if =\"node.children && node.id_group_type == 6\" \r\n                            md-svg-src=\"/assets/icons/svg/icon-folder-board-multiple.svg\"\r\n                            class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon ng-if =\"!node.children && node.id_group_type == 7\" \r\n                            md-svg-src=\"/assets/icons/svg/icon-folder-chat.svg\"\r\n                            class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon \r\n                            ng-if =\"node.children && node.id_group_type == 7\" \r\n                            md-svg-src=\"/assets/icons/svg/icon-folder-chat-multiple.svg\"\r\n                            class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon ng-if =\"!node.children && node.id_group_type == 8\" \r\n                            md-font-icon=\"icon-folder-remove\" \r\n                            class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon \r\n                            ng-if =\"node.children && node.id_group_type == 8\" \r\n                            md-font-icon=\"icon-folder-multiple\" \r\n                            class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                            aria-hidden=\"true\" >\r\n                        </md-icon> \r\n                        <md-icon \r\n                            ng-if =\"node.children && node.id_group_type == 1\" \r\n                            md-font-icon=\"icon-folder-multiple\" \r\n                            class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 \" \r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                <span class=\"ivh-treeview-node-label\" ivh-treeview-toggle>{{trvw.label(node)}}</span>\r\n            </div>\r\n            <div layout=\"row\" layout-align=\"end center\">\r\n                <md-select\r\n                    qiu-on-change-set-in-group-status\r\n                    ng-model=\"idIngroupStatus\"\r\n                    placeholder=\"Select a status\"\r\n                    class=\"mr-10\">\r\n                    <md-option\r\n                        ng-value=\"status.id_ingroup_status\"\r\n                        ng-selected=\"status.id_ingroup_status == node.id_ingroup_status\"\r\n                        ng-repeat=\"status in node.ingroup_status\"\r\n                        translate=\"USERS.INGROUP.STATUS.{{status.name | uppercase}}\" />\r\n                </md-select>\r\n                <md-checkbox\r\n                    aria-label=\"assign group\"\r\n                    qiu-on-check-toggle-assigned-group\r\n                    class=\"ml-5 mb-0\" />\r\n            </div>\r\n        </div>\r\n        <div ivh-treeview-children />\n</script></div>");
$templateCache.put("app/main/apps/tasks/dialogs/groups/users-groups-view.html","<md-dialog class=\"attachment-dialog add-media\" aria-label=\"New Message\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate \ntranslate-aria-label=\"CONTENT.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></div>\n</md-toolbar><md-dialog-content id=\"site-mailing\" ms-scroll flex class=\"content-card\" ng-include=\"vm.viewUsersGroup\">\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"end center\"><md-button ng-click=\"vm.save()\" class=\"send-button md-accent md-raised\" aria-label=\"Save\">\nSAVE</md-button><md-button ng-click=\"vm.closeDialog()\" class=\"cancel-button md-accent md-raised\" aria-label=\"Cancel\">\nCANCEL</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/store/views/dashboard/dashboard.html","<div id=\"dashboard-ecommerce\" class=\"page-layout blank\" layout=\"row\"><div class=\"center\" flex ms-scroll><div \nclass=\"content\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><md-select class=\"simplified font-size-16\" \nng-model=\"vm.widget1.currentRange\" aria-label=\"Change range\"><md-option ng-repeat=\"(key, range) in vm.widget1.ranges\" \nvalue=\"{{key}}\">{{range}}</md-option></md-select><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open()\" \naria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\">\n<md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item>\n</md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"light-blue-fg font-size-72 line-height-72\">{{vm.widget1.data.count[vm.widget1.currentRange]}}%</div><div \nclass=\"h3 secondary-text font-weight-500\">{{vm.widget1.data.label}}</div></div><div class=\"p-16 grey-50-bg border-top\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{vm.widget1.data.extra.label}}:\n</span> <span class=\"h4 ml-8\">{{vm.widget1.data.extra.count[vm.widget1.currentRange]}}</span></div></ms-widget-front>\n<ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><div>{{vm.widget1.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget2.title}}</div><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" \naria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" \naria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div \nclass=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div class=\"red-fg font-size-72 line-height-72\">\n${{vm.widget2.data.count}}</div><div class=\"h3 secondary-text font-weight-500\">{{vm.widget2.data.label}}</div></div>\n<div class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 secondary-text text-truncate\">{{vm.widget2.data.extra.label}}:</span> <span class=\"h4 ml-8\">\n${{vm.widget2.data.extra.count}}</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div \nclass=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>{{vm.widget2.detail}}</div></ms-widget-back>\n</ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{vm.widget3.title}}</div><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open()\" aria-label=\"more\">\n<md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu>\n</div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"orange-fg font-size-72 line-height-72\">{{vm.widget3.data.count}}</div><div \nclass=\"h3 secondary-text font-weight-500\">{{vm.widget3.data.label}}</div></div><div class=\"p-16 grey-50-bg border-top\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{vm.widget3.data.extra.label}}:\n</span> <span class=\"h4 ml-8\">{{vm.widget3.data.extra.count}}</span></div></ms-widget-front><ms-widget-back \nclass=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>\n{{vm.widget3.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{vm.widget4.title}}</div><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" \naria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" \naria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div \nclass=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div class=\"blue-grey-fg font-size-72 line-height-72\">\n${{vm.widget4.data.count}}</div><div class=\"h3 secondary-text font-weight-500\">{{vm.widget4.data.label}}</div></div>\n<div class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 secondary-text text-truncate\">{{vm.widget4.data.extra.label}}:</span> <span class=\"h4 ml-8\">\n${{vm.widget4.data.extra.count}}</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div \nclass=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>{{vm.widget4.detail}}</div></ms-widget-back>\n</ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\">\n<ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">{{vm.widget5.title}}</div><div class=\"pv-8\" \nlayout=\"row\" layout-align=\"start center\" layout-align-sm=\"end\" flex-sm=\"100\"><md-button class=\"ph-16\" \nng-repeat=\"(key, range) in vm.widget5.ranges\" ng-click=\"vm.widget5.changeRange(key)\" \nng-disabled=\"vm.widget5.currentRange == key\">{{range}}</md-button></div></div><div class=\"p-16\"><nvd3 \nclass=\"h-420 remove-x-lines\" config=\"vm.widget5.mainChart.config\" options=\"vm.widget5.mainChart.options\" \ndata=\"vm.widget5.mainChart.data\"></nvd3></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{vm.widget6.title}}</div><div class=\"pv-16\"><md-select class=\"simplified\" ng-model=\"vm.widget6.currentRange\" \nng-change=\"vm.widget6.changeRange(vm.widget6.currentRange)\" aria-label=\"Change range\"><md-option \nng-repeat=\"(key, range) in vm.widget6.ranges\" value=\"{{key}}\">{{range}}</md-option></md-select></div></div><div \nclass=\"p-16\"><nvd3 class=\"h-400\" config=\"vm.widget6.mainChart.config\" options=\"vm.widget6.mainChart.options\" \ndata=\"vm.widget6.mainChart.data\"></nvd3></div><div class=\"pv-8 mh-16 border-top\" layout=\"row\" \nlayout-align=\"start center\" layout-wrap><div class=\"pv-8 border-right\" layout=\"column\" layout-align=\"center center\" \nflex=\"100\" flex-gt-xs=\"50\"><span class=\"font-size-32\">{{vm.widget6.footerLeft.count[vm.widget6.currentRange]}}</span> \n<span class=\"h4\">{{vm.widget6.footerLeft.title}}</span></div><div class=\"pv-8\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\" flex-gt-xs=\"50\"><span class=\"font-size-32\">\n{{vm.widget6.footerRight.count[vm.widget6.currentRange]}}</span> <span class=\"h4\">{{vm.widget6.footerRight.title}}\n</span></div></div></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front\n class=\"white-bg\"><div class=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{vm.widget7.title}}</div><div class=\"pv-16\"><md-select class=\"simplified\" ng-model=\"vm.widget7.currentRange\" \naria-label=\"Change range\"><md-option ng-repeat=\"(key, range) in vm.widget7.ranges\" value=\"{{key}}\">{{range}}\n</md-option></md-select></div></div><div class=\"p-16\" layout=\"row\" layout-align=\"space-between center\" \nng-repeat=\"customer in vm.widget7.customers[vm.widget7.currentRange]\"><div><div class=\"h3\">{{customer.name}}</div><span\n ng-if=\"customer.location\">{{customer.location}}</span></div><md-button class=\"md-icon-button\" \naria-label=\"More information\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div></ms-widget-front>\n</ms-widget></div></div></div></div>");
$templateCache.put("app/main/apps/store/views/order/order.html","<div class=\"mail-content file-details scrollable grey-50-bg\" ms-scroll=\"vm.msScrollOptions\"><md-list \nng-if=\"vm.orderView == \'details\'\"><md-list-item ng-if=\"vm.order.id_order\" class=\"main-item\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex><div layout=\"row\" layout-align=\"start center\"><div class=\"main-read\"><div \nclass=\"avatar-container\"><div ng-if=\"(vm.order.user.avatar == \'\' || !vm.order.user.avatar)\" class=\"avatar purple-bg\" \nng-bind=\"vm.order.user.firstname | capitalizeFirstLetter\"></div></div></div><div class=\"main-read\"><h2 class=\"name\">\n<strong ng-bind-html=\"vm.order.user.firstname\"></strong> <strong ng-bind-html=\"vm.order.user.lastname\"></strong></h2>\n<p><a href=\"mailto:{{vm.order.user.email}}\"><span class=\"font-size-15\" ng-bind-html=\"vm.order.user.email\"></span></a> -\n<md-icon md-font-icon=\"icon-phone\" class=\"m-0\"></md-icon><span class=\"font-size-15\" ng-if=\"vm.order.user.phone\" \nng-bind-html=\"vm.order.user.phone\"></span></p></div></div><div layout=\"row\" layout-align=\"end center\"><div \nclass=\"main-read\"><h3 class=\"text-right name\"><strong \nng-bind-html=\"vm.translate(\'STORE.ORDER\')+\' #\'+vm.order.id_order\"></strong></h3><p ng-if=\"vm.loginUrl\"><a \nng-click=\"vm.loginToWebsite(vm.order.user)\"><md-icon md-font-icon=\"icon-web\" class=\"m-0\"></md-icon><span \nclass=\"font-size-15\" translate=\"GLOBAL.LOGIN_TO_WEBSITE\"></span></a></p></div></div></div></md-list-item><div \nclass=\"order-detail-form-container md-whiteframe-1dp white-bg mh-25 mb-30\"><h3 class=\"grey-700-fg md-toolbar-tools\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-cart\" class=\"m-0 mr-10\"></md-icon><span \ntranslate=\"STORE.ORDER_ITEMS\"></span></h3><table class=\"simple invoice-table\" ms-responsive-table><thead><th \ntranslate=\"STORE.INVOICE_PRODUCT\">PRODUCT</th><th class=\"text-right\" translate=\"STORE.INVOICE_PRICE\">PRICE</th><th \nclass=\"text-center\" translate=\"STORE.INVOICE_QUANTITY\">QUANTITY</th><th class=\"text-right\" \ntranslate=\"STORE.INVOICE_TOTAL\">TOTAL</th></thead><tbody><tr ng-repeat=\"product in vm.order.items\"><td><div \nclass=\"title\">{{product.product_description}} <span ng-if=\"product.is_subscription\">({{product.subscription_name}})\n</span></div></td><td class=\"text-right\">{{vm.order.currency}} {{product.price_unit}}</td><td class=\"text-center\">\n{{product.qty}}</td><td class=\"text-right\">{{vm.order.currency}} {{product.price_total}}</td></tr><tr><td \ntranslate=\"STORE.INVOICE_TOTAL\"></td><td></td><td></td><td class=\"text-right\">\n{{vm.order.currency}} {{vm.order.price_total}}</td></tr></tbody></table></div><div \nclass=\"order-detail-form-container md-whiteframe-1dp white-bg mh-25 mb-30\"><h3 class=\"grey-700-fg md-toolbar-tools\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-clock\" class=\"m-0 mr-10\"></md-icon><span \ntranslate=\"STORE.ORDER_STATUS\"></span></h3><table class=\"simple\" ms-responsive-table><thead><tr><th \ntranslate=\"STORE.STATUS\">Status</th><th translate=\"STORE.UPDATED_ON\">Updated On</th><th translate=\"STORE.PAYMENT\">\nPayment</th></tr></thead><tbody><tr><td><span class=\"status {{vm.order.status.color}}\" \ntranslate=\"SHIPPING.{{vm.order.status.status_name}}\"></span></td><td><span><md-tooltip>\n{{vm.showDate(vm.order.updated_at)}}</md-tooltip>{{vm.showFromNow(vm.order.updated_at)}}</span></td><td><div \nng-repeat=\"payment in vm.order.payments|limitTo:1\"><span ng-if=\"payment.payment_reference.startsWith(\'ch_\')\"><a \ntarget=\"_blank\" href=\"https://dashboard.stripe.com/payments/{{payment.payment_reference}}\">STRIPE </a></span><span \nng-if=\"payment.payment_reference.startsWith(\'in_\')\"><a target=\"_blank\" \nhref=\"https://dashboard.stripe.com/invoices/{{payment.payment_reference}}\">STRIPE </a></span><span \nng-if=\"!(payment.payment_reference.startsWith(\'ch_\') || payment.payment_reference.startsWith(\'in_\'))\">\n{{payment.payment_reference}}</span></div></td></tr><tr ng-if=\"refFilterables.status\"><td colspan=\"3\"><div \nclass=\"update-status\" layout=\"row\" layout-align=\"start center\"><md-input-container class=\"mb-0 mt-0\" flex><md-select \nng-model=\"vm.newStatus\" placeholder=\"{{vm.translate(\'STORE.MODIFY_STATUS\')}}\"><md-option \nng-repeat=\"status in refFilterables.status.values\" value=\"{{status.value}}\" translate=\"SHIPPING.{{status.name}}\">\n{{status.name}}</md-option></md-select></md-input-container><md-button class=\"md-raised md-accent mr-0\" \nng-click=\"vm.updateOrderStatus(vm.newStatus)\" ng-disabled=\"!vm.newStatus\">{{vm.translate(\'STORE.UPDATE\')}}</md-button>\n</div></td></tr></tbody></table></div><div class=\"order-detail-form-container mh-25 mb-30 md-whiteframe-1dp white-bg\" \nng-if=\"vm.order.billing_address\"><h3 class=\"grey-700-fg md-toolbar-tools border-bottom\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-account\" class=\"m-0 mr-10\"></md-icon><span \ntranslate=\"STORE.BILLING_ADDRESS\"></span></h3><table class=\"simple\" ms-responsive-table><tbody><tr><td><div \nclass=\"address\"><strong ng-if=\"vm.order.billing_address.address_name\">{{vm.order.billing_address.address_name}}:<br>\n</strong><span ng-bind-html=\"vm.order.billing_address.address\" ng-if=\"vm.order.billing_address.address\"></span> <span \nng-bind-html=\"vm.order.billing_address.address2\" ng-if=\"vm.order.billing_address.address2\"></span><br><span \nng-bind-html=\"vm.order.billing_address.city_name\" ng-if=\"vm.order.billing_address.city_name\"></span> <span \nng-bind-html=\"\' (\'+vm.order.billing_address.postalcode+\')\'\" ng-if=\"vm.order.billing_address.postalcode\"></span> <span \nng-bind-html=\"vm.order.billing_address.state_name\" ng-if=\"vm.order.billing_address.state_name\"></span> <span \nng-bind-html=\"vm.order.billing_address.country_name\" ng-if=\"vm.order.billing_address.country_name\"></span></div></td>\n</tr></tbody></table></div><div class=\"shipping order-detail-form-container mh-25 mb-30 md-whiteframe-1dp white-bg\" \nng-if=\"vm.order.shipping_address\"><h3 class=\"grey-700-fg md-toolbar-tools border-bottom\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-truck\" class=\"m-0 mr-10\"></md-icon><span \ntranslate=\"STORE.SHIPPING\"></span></h3><table class=\"simple\" ms-responsive-table><thead><tr><th \ntranslate=\"STORE.SHIPPING_MAP\">Map</th><th translate=\"STORE.SHIPPING_ADDRESS\" ng-if=\"vm.order.shipping_address\">Address\n</th><th translate=\"STORE.SHIPPING_DELIVERY\">Delivert</th></tr></thead><tbody><tr><td><div \nlayout-align=\"center center\"><md-button aria-label=\"Google Maps\" class=\"md-icon-button map-marker-btn\" \nng-click=\"vm.openUrl(\'https://www.google.com/maps/search/?api=1&query=\'+vm.order.shipping_address.address+\'+\'+vm.order.shipping_address.address2+\'+\'+vm.order.shipping_address.city_name+\'+\'+vm.order.shipping_address.country_name)\" \ntranslate=\"\" translate-attr-aria-label=\"Google Maps\"><md-icon class=\"s40\" md-font-icon=\"icon-map-marker \"></md-icon>\n<md-tooltip hide show-gt-xs><span translate=\"Google Maps\"></span></md-tooltip></md-button></div></td><td><div \nclass=\"address\"><strong ng-if=\"vm.order.shipping_address.address_name\">{{vm.order.shipping_address.address_name}}:<br>\n</strong><span ng-bind-html=\"vm.order.shipping_address.address\" ng-if=\"vm.order.shipping_address.address\"></span> <span\n ng-bind-html=\"vm.order.shipping_address.address2\" ng-if=\"vm.order.shipping_address.address2\"></span><br><span \nng-bind-html=\"vm.order.shipping_address.city_name\" ng-if=\"vm.order.shipping_address.city_name\"></span> <span \nng-bind-html=\"\' (\'+vm.order.shipping_address.postalcode+\')\'\" ng-if=\"vm.order.shipping_address.postalcode\"></span> <span\n ng-bind-html=\"vm.order.shipping_address.state_name\" ng-if=\"vm.order.shipping_address.state_name\"></span> <span \nng-bind-html=\"vm.order.shipping_address.country_name\" ng-if=\"vm.order.shipping_address.country_name\"></span></div></td>\n<td ng-repeat=\"shipping in vm.order.shippings|limitTo:1\"><mdp-date-picker mdp-placeholder=\"\" \nmdp-format=\"{{vm.dateFormat}}\" mdp-open-on-click=\"false\" ng-model=\"shipping.deliveryFormatted\" \nng-change=\"vm.saveShippingDate(shipping)\" mdp-clear-on-cancel=\"false\"></mdp-date-picker><div><md-icon \nmd-font-icon=\"icon-clock\" class=\"icon-clock md-icon-button md-button\"></md-icon><span>{{shipping.delivery_hours}}\n</span></div></td></tr></tbody></table><table class=\"simple\" ms-responsive-table><thead><tr><th \ntranslate=\"STORE.SHIPPING_STATUS\">Status</th><th translate=\"STORE.UPDATED_ON\">Updated</th></tr></thead><tbody><tr \nng-repeat=\"shipping in vm.order.shippings\"><td><span class=\"status\" translate=\"SHIPPING.{{shipping.shipping_status}}\">\n</span></td><td><span><md-tooltip>{{vm.showDate(shipping.updated_at)}}</md-tooltip>\n{{vm.showFromNow(shipping.updated_at)}}</span></td></tr></tbody></table></div></md-list><div \nng-if=\"vm.orderView == \'invoice\'\"><div ng-if=\"vm.order.id_order\" class=\"main-item\"><div id=\"invoice\" \nclass=\"compact md-whiteframe-4dp\" flex><div class=\"invoice-container\"><div class=\"card white-bg\" \nng-repeat=\"invoices in vm.order.invoices\"><div class=\"header grey-100-bg\"><div class=\"invoice-date\">\n{{invoices.created_at}}</div><div layout=\"row\" layout-align=\"space-between stretch\"><div layout=\"column\" \nlayout-align=\"center start\" flex class=\"client\"><div class=\"invoice-number mb-8\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"title\" translate=\"INVOICE.INVOICE\">INVOICE</span> <span class=\"number\">\n#{{invoices.id_invoice}}</span></div><div class=\"info\"><div class=\"name\">\n{{vm.order.user.firstname}} {{vm.order.user.lastname}}</div><div class=\"email\">{{vm.order.user.email}}</div></div>\n</div><div class=\"issuer\" layout=\"row\" layout-align=\"start center\" flex><div class=\"logo\" layout=\"row\" \nlayout-align=\"center center\"><img class=\"avatar mb-20\" ng-src=\"/assets/images/logos/sites/{{site_operative.icon}}\">\n</div><div class=\"info\"><div class=\"title\">{{vm.storeSettings.company_name}}</div><div class=\"address\" \nng-bind-html=\"vm.storeSettings.company_address\"></div><div class=\"phone\">{{vm.storeSettings.company_phone}}</div><div \nclass=\"email\">{{vm.storeSettings.company_email}}</div><div class=\"website\">{{vm.storeSettings.company_website}}</div>\n</div></div></div></div><div class=\"content\"><div class=\"client\" layout=\"row\" layout-align=\"space-between start\"><div \nclass=\"info\" layout=\"column\" layout-align=\"center start\" ng-if=\"vm.order.billing_address\" flex><div layout=\"row\" \nlayout-align=\"start center\" class=\"mb-10\"><md-icon md-font-icon=\"icon-account\" class=\"m-0 mr-5 s16\"></md-icon><span \ntranslate=\"STORE.BILLING_ADDRESS\"></span></div><div class=\"name\"><strong>{{vm.order.billing_address.address_name}}\n</strong></div><div class=\"address\">{{vm.order.billing_address.address}}</div><div class=\"address\">\n{{vm.order.billing_address.address2}}</div><div class=\"address\">\n{{vm.order.billing_address.postalcode}} - {{vm.order.billing_address.city_name}}</div><div class=\"address\">\n{{vm.order.billing_address.country_name}}</div><div class=\"phone\">{{vm.order.billing_address.phone}}</div></div><div \nclass=\"info\" layout=\"column\" layout-align=\"center start\" ng-if=\"vm.order.shipping_address\" flex><div layout=\"row\" \nlayout-align=\"start center\" class=\"mb-10\"><md-icon md-font-icon=\"icon-truck\" class=\"m-0 mr-5 s16\"></md-icon><span \ntranslate=\"STORE.SHIPPING_ADDRESS\"></span></div><div class=\"name\"><strong>{{vm.order.shipping_address.address_name}}\n</strong></div><div class=\"address\">{{vm.order.shipping_address.address}}</div><div class=\"address\">\n{{vm.order.shipping_address.address2}}</div><div class=\"address\">\n{{vm.order.shipping_address.postalcode}} - {{vm.order.shipping_address.city_name}}</div><div class=\"address\">\n{{vm.order.shipping_address.country_name}}</div><div class=\"phone\">{{vm.order.shipping_address.phone}}</div></div>\n</div><table class=\"simple invoice-table\" ms-responsive-table><thead><th translate=\"STORE.INVOICE_PRODUCT\">PRODUCT</th>\n<th class=\"text-right\" translate=\"STORE.INVOICE_PRICE\">PRICE</th><th translate=\"STORE.INVOICE_QUANTITY\">QUANTITY</th>\n<th class=\"text-right\" translate=\"STORE.INVOICE_TOTAL\">TOTAL</th></thead><tbody><tr \nng-repeat=\"product in vm.order.items\"><td><div class=\"title\">{{product.product_description}} <span \nng-if=\"product.is_subscription\">({{product.subscription_name}})</span></div></td><td class=\"text-right\">\n{{vm.order.currency}} {{product.price_unit}}</td><td>{{product.qty}}</td><td class=\"text-right\">\n{{vm.order.currency}} {{product.price_total}}</td></tr></tbody></table><table class=\"simple invoice-table-footer\">\n<tbody><tr class=\"subtotal\"><td translate=\"STORE.INVOICE_SUBTOTAL\">SUBTOTAL</td><td>\n{{vm.order.currency}} {{vm.order.price_subtotal}}</td></tr><tr class=\"tax\" ng-if=\"price_tax_percent > 0\"><td \ntranslate=\"STORE.INVOICE_TAX\">TAX {{vm.order.price_tax_percent}}</td><td>{{vm.order.currency}} {{vm.order.price_tax}}\n</td></tr><tr class=\"total\"><td translate=\"STORE.INVOICE_TOTAL\">TOTAL</td><td>\n{{vm.order.currency}} {{vm.order.price_total}}</td></tr></tbody></table></div><div class=\"footer\"><div layout=\"row\" \nlayout-align=\"start start\"><div class=\"logo\" layout=\"row\" layout-align=\"center center\"><img \nng-src=\"/assets/images/logos/sites/{{site_operative.icon}}\"></div><div class=\"small-note\">\nIn condimentum malesuada efficitur. Mauris volutpat placerat auctor. Ut ac congue dolor. Quisque scelerisque lacus sed feugiat fermentum. Cras aliquet facilisis pellentesque. Nunc hendrerit quam at leo commodo, a suscipit tellus dapibus. Etiam at felis volutpat est mollis lacinia. Mauris placerat sem sit amet velit mollis, in porttitor ex finibus. Proin eu nibh id libero tincidunt lacinia et eget eros.\n</div></div></div></div><div class=\"page-break\"></div></div></div></div></div><div ng-if=\"vm.orderView == \'history\'\" \nclass=\"mail-content file-details scrollable grey-50-bg\" ms-scroll=\"vm.msScrollOptions\"><md-list><md-list-item \nng-if=\"vm.order.id_order\" ng-repeat=\"order in vm.order.history\"><div id=\"history\" class=\"md-whiteframe-4dp content\" \nflex><div layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" flex><div layout=\"row\" \nlayout-align=\"start center\"><div layout=\"column\"><span class=\"title\"><strong translate=\"STORE.DATE\"></strong>: <span \nclass=\"invoice-date\" ng-bind=\"vm.showDate(order.created_at, \'DD/MM/YYYY HH:mm\')\"></span> </span><span class=\"title\">\n<strong><span translate=\"STORE.SUBSCRIPTION.SUBSCRIPTION\"></span></strong>: <span><a \nui-sref=\"app.site_overview.store.section.detail({id: order.id_subscription, section: \'subscriptions\'})\">\n#{{order.id_subscription}}</a></span> </span><span class=\"title\"><strong><span translate=\"STORE.ORDER\"></span></strong>\n: <span><a ui-sref=\"app.site_overview.store.section.detail({id: order.id_order, section: \'orders\'})\">\n#{{order.id_order}}</a></span> </span><span class=\"title\" ng-if=\"order.items.length\"><strong>\n{{vm.translate(\'STORE.PRODUCTS\')}}: </strong><span ng-repeat=\"item in order.items track by $index\" \nng-if=\"item.id_product != null\"><span ng-if=\"$index != 0\">+ </span>{{item.product_description}}</span></span></div>\n</div></div><div layout=\"column\" layout-align=\"center end\"><span class=\"status {{order.status.color}}\" \ntranslate=\"SHIPPING.{{order.status.status_name}}\"></span></div></div><div class=\"page-break\"></div></div>\n</md-list-item></md-list></div></div>");
$templateCache.put("app/main/apps/store/views/orders/list-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-show=\"isLoading\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nclass=\"mail-list-item filter-selected\" ng-if=\"sortField\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\" flex><div class=\"info\" ng-if=\"sortField\"><div class=\"name\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-sort-ascending\" class=\"s20 mr-5 ml-0 mb-0\" \nng-if=\"sortDir === \'ASC\'\"></md-icon><md-icon md-font-icon=\"icon-sort-descending\" class=\"s20 mr-5 ml-0 mb-0\" \nng-if=\"sortDir === \'DESC\'\"></md-icon><div class=\"title text-truncate\" layout=\"row\" layout-align=\"start center\">\nOrdered by \'{{sortField}}\'</div></div></div></div><div class=\"buttons\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-close s20\" ng-click=\"pagination_resetOrderBy()\" class=\"ml-10\"><md-tooltip hide show-gt-xs>\n<span translate=\"CONTENT.REMOVE\">Remove</span></md-tooltip></md-icon></div></div><div class=\"no-threads\" \nng-if=\"!isLoading && vm.threads.length === 0\" ng-hide=\"isLoading\">There are no items!</div><div id=\"list-content-data\" \nng-style=\"{\'opacity\' : isLoading ? 0.2 : 1}\" ms-scroll=\"vm.msScrollOptions\" \nng-class=\"{\'group-filter\': vm.selectedGroup,\'other-filter\':sortField}\" class=\"scrollable\" \nng-if=\"vm.threads.length > 0\"><div ng-if=\"vm.currentLabelsFilter\" class=\"labels\"><form novalidate><div><div \nng-repeat=\"item in vm.currentLabelsFilter track by $index\" class=\"tag\" fxlayout=\"row\" fxlayoutalign=\"start center\"><div\n class=\"tag-label\">{{item.label}}<md-icon ng-click=\"vm.deleteTargetFilter(item.id, $index)\" md-font-icon=\"icon-close\" \nclass=\"s24 pointer\"></md-icon></div></div></div></form></div><div class=\"mail-list-item {{thread.status}}\" \nng-repeat=\"thread in vm.threads | filter: vm.search | filter: global.search\" md-no-ink ng-init=\"parentIndex = $index\" \nng-click=\"vm.openOrder(thread)\" \nng-class=\"{\'starred\': thread.starred, \'selected\': vm.selectedContentID === thread.id_order, \'checked\': vm.isChecked(thread)}\">\n<div layout=\"row\" layout-align=\"space-between center\"><md-checkbox class=\"no-label\" ng-checked=\"vm.isSelected(thread)\" \nng-click=\"vm.toggleSelectThread(thread, $event)\" aria-label=\"{{vm.isSelected(thread) ? \'Deselect\' : \'Select\'}}\">\n</md-checkbox><div class=\"info\" layout=\"row\" layout-align=\"space-between center\" flex><div flex layout=\"column\" \nclass=\"mr-10\"><div class=\"name\" layout=\"row\" layout-align=\"start center\"><div class=\"user-name\"><span \nng-bind=\"thread.user.firstname\" ng-if=\"thread.user.firstname\"></span> <span ng-bind=\"thread.user.lastname\" \nng-if=\"thread.user.lastname\"></span> (<span class=\"\" ng-bind=\"thread.user.email\"></span>)</div></div><div \nclass=\"details\" layout=\"column\" layout-align=\"start start\"><span class=\"title\"><strong>{{vm.translate(\'STORE.DATE\')}}: \n</strong><span ng-bind=\"vm.showDate(thread.created_at, \'DD/MM/YYYY HH:mm\')\"></span> <strong>\n{{vm.translate(\'STORE.SHIPPING\')}}: </strong><span \nng-bind=\"vm.showDate(thread.shippings[0].delivery_date, \'DD/MM/YYYY\')\"></span> </span><span class=\"title\"><strong>\n{{vm.translate(\'STORE.ORDER\')}}: </strong><span class=\"title\" ng-bind=\"\'#\'+thread.id_order\"></span> <strong>\n{{vm.translate(\'STORE.PRODUCTS\')}}: </strong><span ng-repeat=\"item in thread.items track by $index\" \nng-if=\"item.id_product != null\"><span ng-if=\"$index != 0\">+ </span>{{item.product_description}}</span></span></div>\n</div><div class=\"details\" layout-gt-md=\"row\" layout-align-gt-md=\"end center\" layout=\"column\" \nlayout-align=\"center end\"><div class=\"title mr-30\"><span ng-bind=\"thread.currency + \' \' + thread.price_total\"></span>\n</div><div class=\"status-wrapper text-right w-140\"><span class=\"text-center status {{thread.status.color}}\">\n{{vm.translate(\'SHIPPING.\' + thread.status.status_name)}}</span></div></div></div></div></div><div class=\"toolbar\" \nlayout=\"row\" layout-align=\"end center\"><div layout=\"row\" layout-align=\"center center\" \nng-style=\"{\'display\' : isLoading ? \'none\' : \'block\'}\"><span class=\"page-info\">{{pagination_totalItems}} items found.\n</span><md-button aria-label=\"Previous\" class=\"md-icon-button arrow\" ng-click=\"pagination_prevPage()\" \nng-disabled=\"pagination_firstPage()\" translate=\"\" translate-attr-aria-label=\"CONTENT.PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span translate=\"CONTENT.PREVIOUS\">Previous</span></md-tooltip>\n</md-button><span class=\"page-info\">{{pagination_page}} / {{pagination_total_pages}}</span><md-button \naria-label=\"Next\" class=\"md-icon-button arrow\" ng-click=\"pagination_nextPage()\" \nng-disabled=\"pagination_morePages() || pagination_total_pages === pagination_page\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span \ntranslate=\"CONTENT.NEXT\">Next</span></md-tooltip></md-button></div></div></div>");
$templateCache.put("app/main/apps/store/views/orders/nosplit-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/store/views/orders/toolbar.html\'\" ng-hide=\"vm.selectedThread\"></div><div \nclass=\"content-wrapper\" flex=\"\" layout=\"row\"><div class=\"content thread-list mail-list-pane\" flex=\"\" id=\"thread-list\" \nng-if=\"!vm.selectedThread\" ng-include=\"\'app/main/apps/store/views/orders/list-view.html\'\"></div><div \nclass=\"content thread-detail mail-read-pane\" flex=\"\" id=\"thread-detail\" layout=\"column\" ng-if=\"vm.selectedThread\" \nng-include=\"\'app/main/apps/store/views/orders/order.html\'\"></div></div>");
$templateCache.put("app/main/apps/store/views/orders/order.html","<div flex layout=\"column\" layout-align=\"center center\" ng-show=\"vm.loadingThread\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div ng-if=\"!vm.order\"><div\n class=\"mail-content ng-scope layout-align-center-center layout-column\" layout=\"column\" layout-align=\"center center\" \nng-if=\"!vm.selectedThread && !vm.loadingThread\"><div class=\"content layout-align-start-center layout-column\" \nlayout=\"column\" layout-align=\"top center\"><md-icon md-font-icon=\"icon-store\" class=\"s120 grey-400-fg\"></md-icon><div \nclass=\"message ng-scope\" translate=\"STORE.SELECT_ORDER_FOR_DETAILS\"></div></div></div></div><div \nng-show=\"!vm.loadingThread && vm.order\"><div class=\"toolbar grey-100-bg colored-bg\" layout=\"row\" \nlayout-align=\"space-between center\" scroll=\"\"><div layout=\"row\" layout-align=\"start center\" ng-if=\"vm.order.id_order\">\n<md-button class=\"md-icon-button close-thread\" aria-label=\"Back\" ng-click=\"vm.closeThread()\" translate \ntranslate-attr-aria-label=\"ACCOUNTS.BACK\" ng-if=\"vm.order && vm.currentView == \'nosplit\'\"><md-icon \nmd-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><md-button aria-label=\"Edit\" class=\"md-icon-button\" \nng-click=\"vm.orderViewDetails()\" translate=\"\" ng-class=\"{\'md-accent\':vm.orderView == \'details\'}\" \ntranslate-attr-aria-label=\"STORE.ORDER_DETAILS\"><md-icon md-font-icon=\"icon-clipboard-text\"></md-icon><md-tooltip><span\n translate=\"STORE.ORDER_DETAILS\"></span></md-tooltip></md-button><div class=\"divider-vertical\" hide=\"\" show-gt-sm=\"\">\n</div><md-button aria-label=\"Edit\" class=\"md-icon-button\" ng-click=\"vm.orderViewInvoice()\" translate=\"\" \nng-class=\"{\'md-accent\':vm.orderView == \'invoice\'}\" translate-attr-aria-label=\"STORE.INVOICE\"><md-icon \nmd-font-icon=\"icon-file-outline\"></md-icon><md-tooltip><span translate=\"STORE.INVOICE\"></span></md-tooltip></md-button>\n<div class=\"divider-vertical\" hide=\"\" show-gt-sm=\"\"></div><md-button aria-label=\"Edit\" class=\"md-icon-button\" \nng-click=\"vm.orderViewHistory()\" translate=\"\" ng-class=\"{\'md-accent\':vm.orderView == \'history\'}\" \ntranslate-attr-aria-label=\"STORE.HISTORY\"><md-icon md-font-icon=\"icon-history\"></md-icon><md-tooltip><span \ntranslate=\"STORE.HISTORY\"></span></md-tooltip></md-button></div><div layout=\"row\" layout-align=\"end center\" \nng-if=\"vm.order\" hide show-gt-sm><md-button type=\"button\" ng-click=\"vm.closeThread()\" class=\"md-raised md-warn\" \naria-label=\"Cancel\" translate=\"ACCOUNTS.CANCEL\" translate-attr-aria-label=\"ACCOUNTS.CANCEL\">Cancel</md-button></div>\n<div layout=\"row\" layout-align=\"end center\" ng-if=\"vm.order\" hide-gt-sm></div></div><form name=\"vm.basicForm\" \nclass=\"md-inline-form\" novalidate><md-content ng-if=\"vm.order\" \nng-include=\"\'app/main/apps/store/views/order/order.html\'\" class=\"scrollable\"></md-content></form></div>");
$templateCache.put("app/main/apps/store/views/orders/split-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/store/views/orders/toolbar.html\'\"></div><div class=\"content-wrapper\" flex=\"\" layout=\"row\">\n<div class=\"content thread-list mail-list-pane\" flex-gt-md=\"50\" flex=\"40\" id=\"thread-list\" \nng-include=\"\'app/main/apps/store/views/orders/list-view.html\'\"></div><div class=\"content thread-detail mail-read-pane\" \nflex-gt-md=\"50\" flex=\"60\" id=\"thread-detail\" layout=\"column\" \nng-include=\"\'app/main/apps/store/views/orders/order.html\'\"></div></div>");
$templateCache.put("app/main/apps/store/views/orders/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-label\" \naria-label=\"{{vm.selectedThreads.length > 0 ? \'Deselect All\' : \'Select All\'}}\" \nng-checked=\"vm.selectedThreads.length > 0\" ng-click=\"vm.toggleSelectThreads()\"></md-checkbox><div \nclass=\"divider-vertical\" hide show-gt-xs></div><div aria-hidden=\"false\" \nclass=\"action-buttons hide show-gt-xs layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\" \nng-show=\"vm.selectedThreads.length > 0\"></div><ms-search-bar debounce=\"300\" \nmodel-search=\"$root.pagination_searchquery\" on-result-click=\"vm.searchResultClick(item)\" on-search=\"vm.search(query)\" \nlayout=\"row\" layout-align=\"start center\"></ms-search-bar><md-button ng-click=\"$root.pagination_resetquery()\" \naria-label=\"view type\" class=\"md-icon-button\" translate=\"\" translate-attr-aria-label=\"ACCOUNTS.RESET_SEARCH\" \nclass=\"md-icon-button\" ng-if=\"$root.pagination_searchquery\"><md-icon md-font-icon=\"icon-filter-remove-outline\">\n</md-icon><md-tooltip hide show-gt-xs><span translate=\"ACCOUNTS.RESET_SEARCH\"></span></md-tooltip></md-button>\n<md-button aria-label=\"view type\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'main-sidenav\')\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.FILTERS\"><md-icon md-font-icon=\"icon-filter\"></md-icon><md-tooltip hide show-gt-xs>\n<span translate=\"CONTENT.FILTERS\"></span></md-tooltip></md-button><div class=\"divider-vertical\" hide show-gt-xs></div>\n<md-button aria-label=\"Sort Direction\" class=\"md-icon-button\" ng-click=\"vm.setSortOrder(\'ASC\')\" \nng-disabled=\"!sortField\" ng-if=\"sortDir !== \'ASC\'\" translate translate-attr-aria-label=\"TODO.SORT_DIRECTION\"><md-icon \nmd-font-icon=\"icon-sort-ascending\" ng-if=\"sortDir !== \'ASC\'\"></md-icon><md-icon md-font-icon=\"icon-sort-descending\" \nng-if=\"sortDir === \'ASC\'\"></md-icon></md-button><md-button aria-label=\"Sort Direction\" class=\"md-icon-button\" \nng-click=\"vm.setSortOrder(\'DESC\')\" ng-disabled=\"!sortField\" ng-if=\"sortDir === \'ASC\'\" translate \ntranslate-attr-aria-label=\"TODO.SORT_DIRECTION\"><md-icon md-font-icon=\"icon-sort-ascending\" ng-if=\"sortDir !== \'ASC\'\">\n</md-icon><md-icon md-font-icon=\"icon-sort-descending\" ng-if=\"sortDir === \'ASC\'\"></md-icon></md-button><div \nclass=\"divider-vertical\" hide show-gt-xs></div><md-input-container><label>Date</label><md-select \nng-model=\"vm.filterDateField\" ng-change=\"vm.setFilterDates()\"><md-option value=\"delivery\">Shipping</md-option>\n<md-option value=\"create\">Create</md-option></md-select></md-input-container><md-datepicker \nng-model=\"vm.filterDateFrom\" ng-change=\"vm.setFilterDates()\" md-placeholder=\"Date Start\"></md-datepicker><md-datepicker\n ng-model=\"vm.filterDateTo\" ng-change=\"vm.setFilterDates()\" md-placeholder=\"Date End\"></md-datepicker><button \nclass=\"md-icon-button\" ng-click=\"vm.unsetFilterDates()\"><md-icon id=\"ms-search-bar-collapser\" \nmd-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></button></div><div layout=\"row\" layout-align=\"start center\" \ntranslate-attr-aria-label=\"ACCOUNTS.REFRESH\"><span class=\"page-info\" hide show-gt-xs>\n{{pagination_totalItems}} items found.</span><md-button aria-label=\"Previous\" class=\"md-icon-button arrow\" hide \nng-click=\"pagination_prevPage()\" ng-disabled=\"pagination_firstPage()\" show-gt-xs translate \ntranslate-attr-aria-label=\"CONTENT.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span \ntranslate=\"ACCOUNTS.PREVIOUS\">Previous</span></md-tooltip></md-button><span class=\"page-info\" hide show-gt-xs>\n{{pagination_page}} / {{pagination_total_pages}}</span><md-button aria-label=\"Next\" class=\"md-icon-button arrow\" hide \nng-click=\"pagination_nextPage()\" ng-disabled=\"pagination_morePages()\" show-gt-xs translate \ntranslate-attr-aria-label=\"CONTENT.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span \ntranslate=\"ACCOUNTS.NEXT\">Next</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.changeView(\'nosplit\')\" ng-if=\"vm.currentView !== \'nosplit\'\" hide aria-label=\"noSplit\" show-gt-sm><md-icon \nmd-font-icon=\"icon-view-list\" ng-if=\"vm.currentView !== \'nosplit\'\"></md-icon><md-icon class=\"md-accent\" \nmd-font-icon=\"icon-checkbox-marked\" ng-if=\"vm.currentView === \'nosplit\'\"></md-icon><md-tooltip><span \ntranslate=\"ACCOUNTS.NOSPLIT_VIEW\">No split</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.changeView(\'split\')\" ng-if=\"vm.currentView !== \'split\'\" hide aria-label=\"Split\" show-gt-sm><md-icon \nmd-font-icon=\"icon-view-quilt\" ng-if=\"vm.currentView !== \'split\'\"></md-icon><md-icon class=\"md-accent\" \nmd-font-icon=\"icon-checkbox-marked\" ng-if=\"vm.currentView === \'split\'\"></md-icon><md-tooltip><span \ntranslate=\"ACCOUNTS.SPLIT_VIEW\">split</span></md-tooltip></md-button><md-menu class=\"settings-menu\" hide-gt-xs \nng-show=\"vm.selectedThreads.length > 0\"><md-button aria-label=\"Settings\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\" translate translate-attr-aria-label=\"CONTENT.SETTINGS\"><md-icon \nmd-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content><md-menu-item><md-menu-item><md-button \nng-click=\"vm.massActions(\'delete\')\" aria-label=\"Delete\" translate-aria-label=\"CONTENT.DELETE\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><span translate=\"CONTENT.DELETE\">Delete </span><span translate=\"CONTENT.SELECTED\">\nSelected</span></md-button></md-menu-item></md-menu-item></md-menu-content></md-menu></div>");
$templateCache.put("app/main/apps/store/views/products/products.html","<div id=\"store-products\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-cube-outline\"></md-icon><span translate=\"STORE.PRODUCTS\">Products</span></div><div \nclass=\"product-count secondary-text\"><span translate=\"STORE.TOTAL_PRODUCTS\">Total products:</span> <span>\n{{vm.products.length}}</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"store-products-search\" \nclass=\"search-input\" type=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"STORE.SEARCH\" flex></div>\n</div><div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex>\n<table class=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead>\n<tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">ID</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Image</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Category</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Price</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Quantity</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Active</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actions</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"product in ::vm.products\"><td>{{product.id}}</td><td><img class=\"product-image\" \nng-src=\"{{product.image}}\"></td><td>{{product.name}}</td><td>{{product.category}}</td><td>{{product.price}}</td><td>\n{{product.quantity}}</td><td>{{product.active}}</td><td><md-button class=\"edit-button md-icon-button\" \nng-click=\"vm.gotoProductDetail(product.id)\" aria-label=\"Product details\" translate \ntranslate-attr-aria-label=\"STORE.PRODUCT_DETAILS\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon>\n</md-button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/apps/store/views/orders-old/orders.html","<div id=\"store-orders\" class=\"page-layout carded left-sidenav\" layout=\"row\" md-no-ink><md-sidenav class=\"sidenav\" \nmd-component-id=\"main-sidenav\" ng-include=\"\'app/main/apps/store/views/orders/sidenav.html\'\" ms-scroll \nms-sidenav-helper md-no-ink></md-sidenav><div class=\"center\" layout=\"column\" flex><div class=\"content-card\" \nlayout=\"column\" flex md-no-ink><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><ms-search-bar-custom debounce=\"300\" model-search=\"vm.orderSearchQuery\" \nsearch-click=\"vm.orderSearch\" search-clear=\"vm.orderSearchClear\" layout=\"row\" layout-align=\"start center\">\n</ms-search-bar-custom><md-button ng-click=\"$root.pagination_resetquery()\" aria-label=\"view type\" \nclass=\"md-icon-button\" translate=\"\" translate-attr-aria-label=\"STORE.FILTERS\" class=\"md-icon-button\" \nng-if=\"$root.pagination_searchquery==true\"><md-icon md-font-icon=\"icon-filter-remove-outline\"></md-icon><md-tooltip \nhide show-gt-xs><span>Reset search</span></md-tooltip></md-button><div class=\"divider-vertical\" hide=\"\" show-gt-xs=\"\">\n</div><md-button aria-label=\"view type\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'main-sidenav\')\" \ntranslate=\"\" translate-attr-aria-label=\"STORE.FILTERS\"><md-icon md-font-icon=\"icon-filter\"></md-icon><md-tooltip hide \nshow-gt-xs><span>Filters</span></md-tooltip></md-button></div><div layout=\"row\" layout-align=\"start center\" \ntranslate-attr-aria-label=\"STORE.REFRESH\"><span class=\"page-info\" hide=\"\" show-gt-xs=\"\">\n{{vm.pagination.recordsTotal}} items found.</span><md-button aria-label=\"Previous\" class=\"md-icon-button arrow\" \nhide=\"\" ng-click=\"vm.setPageOrder(\'previous\')\" ng-disabled=\"vm.pagination_firstPage()\" show-gt-xs=\"\" translate=\"\" \ntranslate-attr-aria-label=\"STORE.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip hide \nshow-gt-xs><span translate=\"STORE.PREVIOUS\">Previous</span></md-tooltip></md-button><span class=\"page-info\" hide=\"\" \nshow-gt-xs=\"\">{{vm.pagination.page+1}} / {{vm.pagination.pages}}</span><md-button aria-label=\"Next\" \nid=\"orders-table_next\" class=\"md-icon-button arrow\" hide=\"\" ng-click=\"vm.setPageOrder(\'next\')\" \nng-disabled=\"vm.pagination_morePages()\" show-gt-xs=\"\" translate=\"\" translate-attr-aria-label=\"STORE.NEXT\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"STORE.NEXT\">Next</span>\n</md-tooltip></md-button></div></div><div class=\"content-wrapper\" flex=\"\" layout=\"row\"><div layout=\"column\" flex \nmd-no-ink><div flex layout=\"column\" layout-align=\"center center\" ng-if=\"vm.isLoading\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"30\"></md-progress-circular></div><div class=\"no-threads\" \nng-if=\"!vm.isLoading && vm.orders.length === 0\" ng-hide=\"vm.isLoading\">There are no items!</div><div \nid=\"list-content-dataaa\" ng-if=\"!vm.isLoading\" ng-style=\"{\'opacity\' : isLoading ? 0.2 : 1}\"><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><table id=\"orders-table\" class=\"dataTable row-border hover\" \ndatatable=\"ng\" dt-instance=\"vm.dtInstanceOrders\" dt-options=\"vm.dtOptionsOrders\"><thead><tr><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\">ID</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"STORE.CUSTOMER\">Customer</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"STORE.INVOICE_TOTAL\">Total\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"STORE.ORDER_STATUS\">Status</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"STORE.SHIPPING_DATE\">Delivery Date</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"STORE.CREATED_AT\">Created At</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actions</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"order in ::vm.orders\"><td>{{order.id_order}}</td><td>\n{{order.user.firstname}} {{order.user.lastname}}</td><td>{{order.currency}} {{order.price_total}}</td><td>\n{{order.status}}</td><td class=\"date\">{{vm.showDate(order.shippings[0].delivery_date, \'DD/MM/YYYY\')}}</td><td \nclass=\"date\">{{vm.showDate(order.created_at, \'DD/MM/YYYY HH:mm\')}}</td><td><md-button \nclass=\"edit-button md-icon-button\" ng-click=\"vm.gotoOrderDetail(order.id_order)\" aria-label=\"Order details\" translate \ntranslate-attr-aria-label=\"STORE.ORDER_DETAILS\"><md-icon md-font-icon=\"icon-dots-horizontal\" class=\"s16\"></md-icon>\n</md-button></td></tr></tbody></table></div><div class=\"toolbar ng-scope layout-align-end-center layout-row\" \nlayout=\"row\" layout-align=\"end center\"><div layout=\"row\" layout-align=\"start center\" \ntranslate-attr-aria-label=\"STORE.REFRESH\"><span class=\"page-info\" hide=\"\" show-gt-xs=\"\">\n{{vm.pagination.recordsTotal}} items found.</span><md-button aria-label=\"Previous\" class=\"md-icon-button arrow\" \nhide=\"\" ng-click=\"vm.setPageOrder(\'previous\')\" ng-disabled=\"vm.pagination_firstPage()\" show-gt-xs=\"\" translate=\"\" \ntranslate-attr-aria-label=\"STORE.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip hide \nshow-gt-xs><span translate=\"STORE.PREVIOUS\">Previous</span></md-tooltip></md-button><span class=\"page-info\" hide=\"\" \nshow-gt-xs=\"\">{{vm.pagination.page+1}} / {{vm.pagination.pages}}</span><md-button aria-label=\"Next\" \nid=\"orders-table_next\" class=\"md-icon-button arrow\" hide=\"\" ng-click=\"vm.setPageOrder(\'next\')\" \nng-disabled=\"vm.pagination_morePages()\" show-gt-xs=\"\" translate=\"\" translate-attr-aria-label=\"STORE.NEXT\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"STORE.NEXT\">Next</span>\n</md-tooltip></md-button></div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/apps/store/views/orders-old/sidenav.html","<md-toolbar class=\"md-theme-light md-default-theme md-light-blue-bg\"><h2 class=\"md-toolbar-tools\" aria-label=\"Filters\" \nlayout=\"row\" layout-align=\"space-between center\"><span translate-attr-aria-label=\"STORE.FILTERS\" \ntranslate=\"STORE.FILTERS\">Filters</span> <button class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'main-sidenav\')\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></button></h2></md-toolbar><md-content ms-scroll class=\"content\" flex><div\n class=\"navigation-simple\" layout=\"column\"><div ng-repeat=\"filterable in refFilterables\"><md-menu flex layout=\"row\">\n<md-menu-item flex><md-button aria-label=\"Label\" translate ng-show=\"filterable.values.length>0\" \ntranslate-attr-aria-label=\"SB.LABEL\" ng-click=\"$mdMenu.open($event)\"><div layout=\"row\" layout-align=\"start start\"><span\n class=\"title text-left\" flex>{{filterable.name}}</span><md-icon md-font-icon=\"icon-chevron-down\"></md-icon></div>\n</md-button></md-menu-item><md-menu-content class=\"labels-menu-content\" width=\"4\"><md-menu-item \nclass=\"search-bar border-bottom\" ng-if=\"filterable.values.length>10\"><div layout=\"row\" layout-align=\"start center\" \nclass=\"pl-10 pr-15\"><md-icon md-font-icon=\"icon-magnify\" class=\"md-icon-button ml-0 mr-10\" aria-label=\"Search\" \nrole=\"img\"></md-icon><input placeholder=\"Search labels...\" type=\"text\" flex class=\"font-size-14\" \nng-model=\"vm.filterSearchText[filterable.field]\" autocomplete=\"off\" translate-attr-palceholder=\"SB.SEARCH_LABELS\">\n</div></md-menu-item><div ms-scroll ng-class=\"{\'mt-48\': filterable.values.length>10}\"><md-menu-item class=\"label\" \nng-repeat=\"label in filterable.values | filter: vm.filterSearchText[filterable.field]\"><md-button \nclass=\"label-toggle-button\" ng-class=\"\'md-\'+label.color+\'-bg\'\" \nng-click=\"vm.toggleInArray(label.value, refFilterables[filterable.field].selected)\" aria-label=\"Toggle Label\" \ntranslate translate-attr-aria-label=\"SB.TOGGLE_LABEL\"><div layout=\"row\" layout-align=\"space-between center\"><span>\n{{label.name}}</span> <i ng-if=\"vm.exists(label.value, refFilterables[filterable.field].selected)\" \nclass=\"icon-check s16\"></i></div></md-button></md-menu-item></div><md-divider></md-divider></md-menu-content></md-menu>\n<div ng-show=\"refFilterables[filterable.field].selected.length>0\"><md-chips class=\"md-chips md-removable close-chip\">\n<md-chip ng-repeat=\"label in filterable.values | filterInArray:filterable.selected:\'value\'\" \nclass=\"md-accent-bg md-chip\"><div class=\"md-chip-content\">{{label.name}}</div><div class=\"md-chip-remove-container\">\n<button class=\"md-chip-remove\" ng-click=\"vm.toggleInArray(label.value, refFilterables[filterable.field].selected)\" \nmd-chip-remove><md-icon md-font-icon=\"icon-close\"></md-icon></button></div></md-chip></md-chips></div></div></div>\n</md-content>");
$templateCache.put("app/main/apps/store/views/product/product.html","<div id=\"store-product\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button\n class=\"goto-products-button md-icon-button\" aria-label=\"Go to products\" ng-click=\"vm.gotoProducts()\" translate \ntranslate-attr-aria-label=\"STORE.GO_TO_PRODUCTS\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div \nlayout=\"row\" layout-align=\"start center\"><div class=\"product-image\" hide-xs><img ng-src=\"{{vm.product.images[0].url}}\">\n</div><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">{{vm.product.name}}</div><div \nclass=\"subtitle secondary-text\"><span translate=\"STORE.PRODUCT_DETAIL\">Product Detail</span></div></div></div></div>\n<div><md-button class=\"md-raised md-background\"><span translate=\"STORE.SAVE\">SAVE</span></md-button></div></div><div \nclass=\"content\"><md-tabs md-dynamic-height><md-tab><md-tab-label><span translate=\"STORE.BASIC_INFO\">Basic Info</span>\n</md-tab-label><md-tab-body><div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form>\n<md-input-container class=\"md-block\"><label translate=\"STORE.PRODUCT_NAME\">Product Name</label><input type=\"text\" \nng-model=\"vm.product.name\"></md-input-container><h3 class=\"secondary-text\" translate=\"STORE.PRODUCT_DESCRIPTION\">\nProduct Description</h3><text-angular ta-toolbar=\"vm.taToolbar\" ng-model=\"vm.product.description\"></text-angular>\n<md-input-container class=\"md-block\"><label translate=\"STORE.CATEGORIES\">Categories</label><md-select \nng-model=\"vm.product.categories\" md-on-open=\"vm.onCategoriesSelectorOpen()\" \nmd-on-close=\"vm.onCategoriesSelectorClose()\" multiple=\"multiple\"><md-select-header><input type=\"search\" \nclass=\"md-text\" ng-model=\"vm.categoriesSelectFilter\" placeholder=\"Search for a category\"></md-select-header>\n<md-optgroup><md-option ng-value=\"category\" \nng-repeat=\"category in vm.product.categories | filter:vm.categoriesSelectFilter\">{{category}}</md-option></md-optgroup>\n</md-select></md-input-container><h3 class=\"tags secondary-text\" translate=\"STORE.TAGS\">Tags</h3><md-chips \nng-model=\"vm.product.tags\" placeholder=\"Enter a tag\" delete-button-label=\"Remove Tag\" \ndelete-hint=\"Press delete to remove tag\" secondary-placeholder=\"+Tag\" class=\"close-chip\"><button md-chip-remove \nclass=\"md-primary\"><md-icon md-font-icon=\"icon-close\"></md-icon></button></md-chips></form></div></md-tab-body>\n</md-tab><md-tab><md-tab-label><span translate=\"STORE.PRODUCT_IMAGES\">Product Images</span></md-tab-label><md-tab-body>\n<div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><div id=\"product-image-uploader\" \nflow-init=\"vm.ngFlowOptions\" flow-name=\"vm.ngFlow.flow\" flow-files-submitted=\"vm.upload()\" \nflow-file-added=\"vm.fileAdded($file)\" flow-file-success=\"vm.fileSuccess($file, $message)\" \nflow-complete=\"vm.uploadComplete()\" flow-drop flow-drag-enter=\"vm.dropping=true\" flow-drag-leave=\"vm.dropping=false\" \nng-class=\"{\'dropping\':vm.dropping}\"><div class=\"drop-text hint-text\" layout=\"row\" layout-align=\"center center\"><span \ntranslate=\"STORE.DROP_TO_UPLOAD\">Drop to upload</span></div><div class=\"upload-button\" layout=\"column\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" flow-btn>Upload</md-button><span \nclass=\"secondary-text mt-8\">You can also drop images here to upload. Only PNG, JPG - Max. 8MB</span></div><div \nlayout=\"row\" layout-align=\"start start\" layout-wrap><div ng-repeat=\"image in vm.product.images\" ng-switch=\"image.type\">\n<div class=\"product-image uploading\" ng-switch-when=\"uploading\" layout=\"row\" layout-align=\"center center\"><div \nclass=\"overlay\" layout=\"column\" layout-align=\"center center\"><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{image.file.progress() * 100}}\"></md-progress-linear></div><img class=\"media\" flow-img=\"image.file\"></div><div \nclass=\"product-image\" ng-switch-when=\"image\" layout=\"row\" layout-align=\"center center\"><img class=\"media\" \nng-src=\"{{image.url}}\"></div></div></div></div></div></md-tab-body></md-tab><md-tab><md-tab-label><span \ntranslate=\"STORE.PRICING\">Pricing</span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form><md-input-container \nclass=\"md-block md-icon-float\"><label translate=\"STORE.TAX_EXCL_PRICE\">Tax Excluded Price</label><md-icon \nmd-font-icon=\"icon icon-currency-usd\"></md-icon><input type=\"number\" step=\"0.01\" ng-model=\"vm.product.priceTaxExcl\">\n</md-input-container><md-input-container class=\"md-block md-icon-float\"><label translate=\"STORE.TAX_INCL_PRICE\">\nTax Included Price</label><md-icon md-font-icon=\"icon icon-currency-usd\"></md-icon><input type=\"number\" step=\"0.01\" \nng-model=\"vm.product.priceTaxIncl\"></md-input-container><md-input-container class=\"md-block md-icon-float\"><label \ntranslate=\"STORE.TAX_RATE\">Tax Rate</label><md-icon md-font-icon=\"icon icon-percent\"></md-icon><input type=\"number\" \nstep=\"0.01\" ng-model=\"vm.product.taxRate\"></md-input-container><md-input-container class=\"md-block md-icon-float\">\n<label translate=\"STORE.COMPARED_PRICE\">Compared Price</label><md-icon md-font-icon=\"icon icon-currency-usd\"></md-icon>\n<input type=\"number\" step=\"0.01\" ng-model=\"vm.product.comparedPrice\"><div class=\"input-hint\">\nAdd a compare price to show next to the real price</div></md-input-container></form></div></md-tab-body></md-tab>\n<md-tab><md-tab-label><span translate=\"STORE.INVENTORY\">Inventory</span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form><md-input-container class=\"md-block\">\n<label translate=\"STORE.SKU\">SKU</label><input type=\"text\" ng-model=\"vm.product.sku\"></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"STORE.BARCODE\">Barcode</label><input type=\"text\" \nng-model=\"vm.product.barcode\"></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"STORE.QUANTITY\">Quantity</label><input type=\"number\" step=\"1\" ng-model=\"vm.product.quantity\">\n</md-input-container></form></div></md-tab-body></md-tab><md-tab><md-tab-label><span translate=\"STORE.SHIPPING\">\nShipping</span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form><div layout-gt-sm=\"row\" \nlayout-align=\"start center\"><md-input-container class=\"md-block\" flex-gt-sm><label translate=\"STORE.WIDTH\">Width\n</label><input type=\"text\" ng-model=\"vm.product.width\"></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm><label translate=\"STORE.HEIGHT\">Height</label><input type=\"text\" ng-model=\"vm.product.height\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label translate=\"STORE.DEPTH\">Depth</label><input\n type=\"text\" ng-model=\"vm.product.depth\"></md-input-container></div><md-input-container class=\"md-block\"><label \ntranslate=\"STORE.WEIGHT\">Weight</label><input type=\"text\" ng-model=\"vm.product.weight\"></md-input-container>\n<md-input-container class=\"md-block md-icon-float\"><label translate=\"STORE.EXTRA_SHIPPING_FEE\">Extra Shipping Fee\n</label><md-icon md-font-icon=\"icon icon-currency-usd\"></md-icon><input type=\"text\" \nng-model=\"vm.product.extraShippingFee\"></md-input-container></form></div></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/apps/store/views/subscription/subscription.html","<div ng-if=\"vm.subscriptionView == \'details\'\" class=\"mail-content file-details scrollable grey-50-bg\" \nms-scroll=\"vm.msScrollOptions\"><md-list><md-list-item ng-if=\"vm.subscription.id_subscription\" class=\"main-item\"><div \nlayout=\"row\" layout-align=\"space-between center\" flex><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"main-read\"><div class=\"avatar-container\"><div \nng-if=\"(vm.subscription.user.avatar == \'\' || !vm.subscription.user.avatar)\" class=\"avatar purple-bg\" \nng-bind=\"vm.subscription.user.firstname | capitalizeFirstLetter\"></div></div></div><div class=\"main-read\"><h2 \nclass=\"name\"><strong ng-bind-html=\"vm.subscription.user.firstname\"></strong> <strong \nng-bind-html=\"vm.subscription.user.lastname\"></strong></h2><p><a href=\"mailto:{{vm.subscription.user.email}}\"><span \nclass=\"font-size-15\" ng-bind-html=\"vm.subscription.user.email\"></span></a> <span class=\"font-size-15\" \nng-if=\"vm.subscription.user.phone\" \nng-bind-html=\"\'- \'+vm.translate(\'STORE.PHONE_SMALL\')+\'. \'+vm.subscription.user.phone\"></span></p><p \nng-if=\"vm.loginUrl\"><a ng-click=\"vm.loginToWebsite(vm.subscription.user)\"><md-icon md-font-icon=\"icon-web\" class=\"m-0\">\n</md-icon><span class=\"font-size-15\" translate=\"GLOBAL.LOGIN_TO_WEBSITE\"></span></a></p></div></div><div \nlayout=\"column\"><h3 class=\"text-right\"><strong \nng-bind-html=\"vm.translate(\'STORE.SUBSCRIPTION.SUBSCRIPTION\')+\' #\'+vm.subscription.id_subscription\"></strong></h3><div \nclass=\"status-wrapper text-center\"><span ng-if=\"vm.subscription.is_paused == 1\"><span class=\"status md-orange-500-bg\">\n{{vm.translate(\'SHIPPING.is_paused\')}}</span> </span><span ng-if=\"vm.subscription.date_finished\"><span \nclass=\"status md-red-900-bg\">{{vm.translate(\'SHIPPING.is_finished\')}}</span> </span><span \nng-if=\"!vm.subscription.date_finished && !vm.subscription.is_paused\"><span class=\"status md-green-500-bg\">\n{{vm.translate(\'SHIPPING.is_active\')}}</span></span></div></div></div></md-list-item><div layout=\"column\" \nlayout-align=\"stretch center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"space-between start\" \nng-if=\"vm.subscription.shipping_address || vm.subscription.billing_address\" \nclass=\"ph-15 pb-30 order-detail-form-container\"><div flex \nclass=\"order-detail-form-container mh-10 md-whiteframe-1dp white-bg\" ng-if=\"vm.subscription.billing_address\"><h3 \nclass=\"grey-700-fg md-toolbar-tools border-bottom\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-account\" class=\"m-0 mr-10\"></md-icon><span translate=\"STORE.BILLING_ADDRESS\"></span></h3><table \nclass=\"simple\" ms-responsive-table><tbody><tr><td><div class=\"address\"><strong \nng-if=\"vm.subscription.billing_address.address_name\">{{vm.subscription.billing_address.address_name}}:<br></strong>\n<span ng-bind-html=\"vm.subscription.billing_address.address\" ng-if=\"vm.subscription.billing_address.address\"></span> \n<span ng-bind-html=\"vm.subscription.billing_address.address2\" ng-if=\"vm.subscription.billing_address.address2\"></span>\n<br><span ng-bind-html=\"vm.subscription.billing_address.city_name\" ng-if=\"vm.subscription.billing_address.city_name\">\n</span> <span ng-bind-html=\"\' (\'+vm.subscription.billing_address.postalcode+\')\'\" \nng-if=\"vm.subscription.billing_address.postalcode\"></span><br><span \nng-bind-html=\"vm.subscription.billing_address.state_name\" ng-if=\"vm.subscription.billing_address.state_name\"></span> \n<span ng-bind-html=\"vm.subscription.billing_address.country_name\" ng-if=\"vm.subscription.billing_address.country_name\">\n</span></div></td></tr></tbody></table></div><div flex \nclass=\"order-detail-form-container mh-10 md-whiteframe-1dp white-bg\" ng-if=\"vm.subscription.shipping_address\"><h3 \nclass=\"grey-700-fg md-toolbar-tools border-bottom\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-truck\" class=\"m-0 mr-10\"></md-icon><span translate=\"STORE.SHIPPING_ADDRESS\"></span></h3><table \nclass=\"simple\" ms-responsive-table><tbody><tr><td><div class=\"address\"><strong \nng-if=\"vm.subscription.shipping_address.address_name\">{{vm.subscription.shipping_address.address_name}}:<br></strong>\n<span ng-bind-html=\"vm.subscription.shipping_address.address\" ng-if=\"vm.subscription.shipping_address.address\"></span> \n<span ng-bind-html=\"vm.subscription.shipping_address.address2\" ng-if=\"vm.subscription.shipping_address.address2\">\n</span><br><span ng-bind-html=\"vm.subscription.shipping_address.city_name\" \nng-if=\"vm.subscription.shipping_address.city_name\"></span> <span \nng-bind-html=\"\' (\'+vm.subscription.shipping_address.postalcode+\')\'\" \nng-if=\"vm.subscription.shipping_address.postalcode\"></span><br><span \nng-bind-html=\"vm.subscription.shipping_address.state_name\" ng-if=\"vm.subscription.shipping_address.state_name\"></span> \n<span ng-bind-html=\"vm.subscription.shipping_address.country_name\" \nng-if=\"vm.subscription.shipping_address.country_name\"></span></div></td></tr></tbody></table></div></div><div \nlayout=\"column\" layout-align=\"stretch center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"space-between start\" \nng-if=\"vm.subscription.cycle\" class=\"ph-15 pb-30 order-detail-form-container\"><div flex \nclass=\"order-detail-form-container mh-10 md-whiteframe-1dp white-bg\"><h3 \nclass=\"grey-700-fg md-toolbar-tools border-bottom\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-account\" class=\"m-0 mr-10\"></md-icon><span translate=\"STORE.SUBSCRIPTION.CYCLE\"></span></h3><table \nclass=\"simple\" ms-responsive-table><tbody><tr><td><div class=\"address\"><span translate=\"STORE.SUBSCRIPTION.CYCLE\">\n</span>: <strong ng-bind=\"vm.subscription.cycle_description\" ng-if=\"vm.subscription.cycle_description\"></strong><br>\n<span translate=\"STORE.SUBSCRIPTION.CYCLE_START\"></span>: <span ng-bind=\"vm.subscription.current_cycle_start\" \nng-if=\"vm.subscription.current_cycle_start\"></span><br><span translate=\"STORE.SUBSCRIPTION.CYCLE_END\"></span>: <span \nng-bind=\"vm.subscription.current_cycle_end\" ng-if=\"vm.subscription.current_cycle_end\"></span></div></td></tr></tbody>\n</table></div></div><div layout=\"column\" layout-align=\"stretch center\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"space-between start\" ng-if=\"vm.subscription.cycle\" class=\"ph-15 pb-30 order-detail-form-container\">\n<div flex class=\"order-detail-form-container mh-10 md-whiteframe-1dp white-bg\"><h3 \nclass=\"grey-700-fg md-toolbar-tools border-bottom\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-account\" class=\"m-0 mr-10\"></md-icon><span translate=\"STORE.SUBSCRIPTION.PRODUCT\"></span></h3><table\n class=\"simple\" ms-responsive-table><tbody><tr><td><div class=\"address\"><span translate=\"STORE.SUBSCRIPTION.PRODUCT\">\n</span>: <strong ng-bind=\"vm.subscription.product_description\" ng-if=\"vm.subscription.product_description\"></strong>\n<br><span translate=\"STORE.SUBSCRIPTION.PRICE_UNIT\"></span>: EUR<span ng-bind=\"vm.subscription.price_unit\" \nng-if=\"vm.subscription.price_unit\"></span><br><span translate=\"STORE.SUBSCRIPTION.UNITS\"></span>: <span \nng-bind=\"vm.subscription.qty\" ng-if=\"vm.subscription.qty\"></span><br><span translate=\"STORE.SUBSCRIPTION.TOTAL_PRICE\" \nng-if=\"vm.subscription.price_total\"></span>: <strong>EUR</strong><strong ng-bind=\"vm.subscription.price_total\" \nng-if=\"vm.subscription.price_total\"></strong></div></td></tr></tbody></table></div></div></md-list></div><div \nng-if=\"vm.subscriptionView == \'history\'\" class=\"mail-content file-details scrollable grey-50-bg\" \nms-scroll=\"vm.msScrollOptions\"><md-list><md-list-item ng-if=\"vm.subscription.id_subscription\" \nng-repeat=\"order in vm.subscription.history\"><div id=\"history\" class=\"md-whiteframe-4dp content\" flex><div \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" flex><div layout=\"row\" \nlayout-align=\"start center\"><div layout=\"column\"><span class=\"title\"><strong translate=\"STORE.DATE\"></strong>: <span \nclass=\"invoice-date\" ng-bind=\"vm.showDate(order.created_at, \'DD/MM/YYYY HH:mm\')\"></span> </span><span class=\"title\">\n<strong><span translate=\"STORE.SUBSCRIPTION.SUBSCRIPTION\"></span></strong>: <span><a \nui-sref=\"app.site_overview.store.section.detail({id: order.id_subscription, section: \'subscriptions\'})\">\n#{{order.id_subscription}}</a></span> </span><span class=\"title\"><strong><span translate=\"STORE.ORDER\"></span></strong>\n: <span><a ui-sref=\"app.site_overview.store.section.detail({id: order.id_order, section: \'orders\'})\">\n#{{order.id_order}}</a></span> </span><span class=\"title\" ng-if=\"order.items.length\"><strong>\n{{vm.translate(\'STORE.PRODUCTS\')}}: </strong><span ng-repeat=\"item in order.items track by $index\" \nng-if=\"item.id_product != null\"><span ng-if=\"$index != 0\">+ </span>{{item.product_description}}</span></span></div>\n</div></div><div layout=\"column\" layout-align=\"center end\"><span class=\"status {{order.status.color}}\" \ntranslate=\"SHIPPING.{{order.status.status_name}}\"></span></div></div><div class=\"page-break\"></div></div>\n</md-list-item></md-list></div>");
$templateCache.put("app/main/apps/store/views/subscriptions/list-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-show=\"isLoading\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nclass=\"mail-list-item filter-selected\" ng-if=\"sortField\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\" flex><div class=\"info\" ng-if=\"sortField\"><div class=\"name\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-sort-ascending\" class=\"s20 mr-5 ml-0 mb-0\" \nng-if=\"sortDir === \'ASC\'\"></md-icon><md-icon md-font-icon=\"icon-sort-descending\" class=\"s20 mr-5 ml-0 mb-0\" \nng-if=\"sortDir === \'DESC\'\"></md-icon><div class=\"title text-truncate\" layout=\"row\" layout-align=\"start center\">\nOrdered by \'{{sortField}}\'</div></div></div></div><div class=\"buttons\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-close s20\" ng-click=\"pagination_resetOrderBy()\" class=\"ml-10\"><md-tooltip hide show-gt-xs>\n<span translate=\"CONTENT.REMOVE\">Remove</span></md-tooltip></md-icon></div></div><div class=\"no-threads\" \nng-if=\"!isLoading && vm.threads.length === 0\" ng-hide=\"isLoading\">There are no items!</div><div id=\"list-content-data\" \nng-style=\"{\'opacity\' : isLoading ? 0.2 : 1}\" ms-scroll=\"vm.msScrollOptions\" \nng-class=\"{\'group-filter\': vm.selectedGroup,\'other-filter\':sortField}\" class=\"scrollable\" \nng-if=\"vm.threads.length > 0\"><div ng-if=\"vm.currentLabelsFilter\" class=\"labels\"><form novalidate><div><div \nng-repeat=\"item in vm.currentLabelsFilter track by $index\" class=\"tag\" fxlayout=\"row\" fxlayoutalign=\"start center\"><div\n class=\"tag-label\">{{item.label}}<md-icon ng-click=\"vm.deleteTargetFilter(item.id, $index)\" md-font-icon=\"icon-close\" \nclass=\"s24 pointer\"></md-icon></div></div></div></form></div><div class=\"mail-list-item {{thread.status}}\" \nng-repeat=\"thread in vm.threads | filter: vm.search | filter: global.search\" md-no-ink ng-init=\"parentIndex = $index\" \nng-click=\"vm.openSubscription(thread)\" \nng-class=\"{\'starred\': thread.starred, \'selected\': vm.selectedContentID === thread.id_subscription, \'checked\': vm.isChecked(thread)}\">\n<div layout=\"row\" layout-align=\"space-between center\"><md-checkbox class=\"no-label\" ng-checked=\"vm.isSelected(thread)\" \nng-click=\"vm.toggleSelectThread(thread, $event)\" aria-label=\"{{vm.isSelected(thread) ? \'Deselect\' : \'Select\'}}\">\n</md-checkbox><div class=\"info\" layout=\"row\" layout-align=\"space-between center\" flex><div flex layout=\"column\" \nclass=\"mr-10\"><div class=\"name\" layout=\"row\" layout-align=\"start center\"><div class=\"user-name\"><span \nng-bind=\"thread.user.firstname\" ng-if=\"thread.user.firstname\"></span> <span ng-bind=\"thread.user.lastname\" \nng-if=\"thread.user.lastname\"></span> (<span class=\"\" ng-bind=\"thread.user.email\"></span>)</div></div><div \nclass=\"details\" layout=\"column\" layout-align=\"start start\"><span class=\"title\"><strong>{{vm.translate(\'STORE.DATE\')}}: \n</strong><span ng-bind=\"vm.showDate(thread.created_at, \'DD/MM/YYYY HH:mm\')\"></span> <strong>\n{{vm.translate(\'STORE.NEXT_DELIVERY\')}}: </strong><span ng-bind=\"vm.showDate(thread.next_delivery, \'DD/MM/YYYY\')\">\n</span> </span><span class=\"title\"><strong>{{vm.translate(\'STORE.SUBSCRIPTION.SUBSCRIPTION\')}}: </strong><span \nclass=\"title\" ng-bind=\"\'#\'+thread.id_subscription\"></span> <strong>{{vm.translate(\'STORE.SUBSCRIPTION.PRODUCT\')}}: \n</strong><span class=\"title\" ng-bind=\"thread.product_description\"></span></span></div></div><div class=\"details\" \nlayout-gt-md=\"row\" layout-align-gt-md=\"end center\" layout=\"column\" layout-align=\"center end\"><div \nclass=\"status-wrapper text-center w-100\"><span ng-if=\"thread.is_paused == 1\"><span class=\"status md-orange-500-bg\">\n{{vm.translate(\'SHIPPING.is_paused\')}}</span> </span><span ng-if=\"thread.date_finished\"><span \nclass=\"status md-red-900-bg\">{{vm.translate(\'SHIPPING.is_finished\')}}</span> </span><span \nng-if=\"!thread.date_finished && !thread.is_paused\"><span class=\"status md-green-500-bg\">\n{{vm.translate(\'SHIPPING.is_active\')}}</span></span></div></div></div></div></div><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"end center\"><div layout=\"row\" layout-align=\"center center\" \nng-style=\"{\'display\' : isLoading ? \'none\' : \'block\'}\"><span class=\"page-info\">{{pagination_totalItems}} items found.\n</span><md-button aria-label=\"Previous\" class=\"md-icon-button arrow\" ng-click=\"pagination_prevPage()\" \nng-disabled=\"pagination_firstPage()\" translate=\"\" translate-attr-aria-label=\"CONTENT.PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span translate=\"CONTENT.PREVIOUS\">Previous</span></md-tooltip>\n</md-button><span class=\"page-info\">{{pagination_page}} / {{pagination_total_pages}}</span><md-button \naria-label=\"Next\" class=\"md-icon-button arrow\" ng-click=\"pagination_nextPage()\" \nng-disabled=\"pagination_morePages() || pagination_total_pages === pagination_page\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span \ntranslate=\"CONTENT.NEXT\">Next</span></md-tooltip></md-button></div></div></div>");
$templateCache.put("app/main/apps/store/views/subscriptions/nosplit-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/store/views/subscriptions/toolbar.html\'\" ng-hide=\"vm.selectedThread\"></div><div \nclass=\"content-wrapper\" flex=\"\" layout=\"row\"><div class=\"content thread-list mail-list-pane\" flex=\"\" id=\"thread-list\" \nng-if=\"!vm.selectedThread\" ng-include=\"\'app/main/apps/store/views/subscriptions/list-view.html\'\"></div><div \nclass=\"content thread-detail mail-read-pane\" flex=\"\" id=\"thread-detail\" layout=\"column\" ng-if=\"vm.selectedThread\" \nng-include=\"\'app/main/apps/store/views/subscriptions/subscription.html\'\"></div></div>");
$templateCache.put("app/main/apps/store/views/subscriptions/split-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/store/views/subscriptions/toolbar.html\'\"></div><div class=\"content-wrapper\" flex=\"\" \nlayout=\"row\"><div class=\"content thread-list mail-list-pane\" flex-gt-md=\"50\" flex=\"40\" id=\"thread-list\" \nng-include=\"\'app/main/apps/store/views/subscriptions/list-view.html\'\"></div><div \nclass=\"content thread-detail mail-read-pane\" flex-gt-md=\"50\" flex=\"60\" id=\"thread-detail\" layout=\"column\" \nng-include=\"\'app/main/apps/store/views/subscriptions/subscription.html\'\"></div></div>");
$templateCache.put("app/main/apps/store/views/subscriptions/subscription.html","<div flex layout=\"column\" layout-align=\"center center\" ng-show=\"vm.loadingThread\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nng-if=\"!vm.subscription\"><div class=\"mail-content ng-scope layout-align-center-center layout-column\" layout=\"column\" \nlayout-align=\"center center\" ng-if=\"!vm.selectedThread && !vm.loadingThread\"><div \nclass=\"content layout-align-start-center layout-column\" layout=\"column\" layout-align=\"top center\"><md-icon \nmd-font-icon=\"icon-store\" class=\"s120 grey-400-fg\"></md-icon><div class=\"message ng-scope\" \ntranslate=\"STORE.SELECT_SUBSCRIPTION_FOR_DETAILS\"></div></div></div></div><div \nng-show=\"!vm.loadingThread && vm.subscription\"><div class=\"toolbar grey-100-bg colored-bg\" layout=\"row\" \nlayout-align=\"space-between center\" scroll=\"\"><div layout=\"row\" layout-align=\"start center\" \nng-if=\"vm.subscription.id_subscription\"><md-button class=\"md-icon-button close-thread\" aria-label=\"Back\" \nng-click=\"vm.closeThread()\" translate translate-attr-aria-label=\"ACCOUNTS.BACK\" \nng-if=\"vm.subscription && vm.currentView == \'nosplit\'\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon>\n</md-button><md-button aria-label=\"Edit\" class=\"md-icon-button\" ng-click=\"vm.subscriptionViewDetails()\" translate=\"\" \nng-class=\"{\'md-accent\':vm.subscriptionView == \'details\'}\" translate-attr-aria-label=\"STORE.ORDER_DETAILS\"><md-icon \nmd-font-icon=\"icon-clipboard-text\"></md-icon><md-tooltip><span translate=\"STORE.ORDER_DETAILS\"></span></md-tooltip>\n</md-button><div class=\"divider-vertical\" hide=\"\" show-gt-sm=\"\"></div><md-button aria-label=\"Edit\" \nclass=\"md-icon-button\" ng-click=\"vm.subscriptionViewHistory()\" translate=\"\" \nng-class=\"{\'md-accent\':vm.subscriptionView == \'history\'}\" translate-attr-aria-label=\"STORE.HISTORY\"><md-icon \nmd-font-icon=\"icon-history\"></md-icon><md-tooltip><span translate=\"STORE.HISTORY\"></span></md-tooltip></md-button>\n</div><div layout=\"row\" layout-align=\"end center\" ng-if=\"vm.subscription\" hide show-gt-sm><md-button type=\"button\" \nng-click=\"vm.closeThread()\" class=\"md-raised md-warn\" aria-label=\"Cancel\" translate=\"ACCOUNTS.CANCEL\" \ntranslate-attr-aria-label=\"ACCOUNTS.CANCEL\">Cancel</md-button></div><div layout=\"row\" layout-align=\"end center\" \nng-if=\"vm.subscription\" hide-gt-sm></div></div><form name=\"vm.basicForm\" class=\"md-inline-form\" novalidate><md-content \nng-if=\"vm.subscription\" ng-include=\"\'app/main/apps/store/views/subscription/subscription.html\'\" class=\"scrollable\">\n</md-content></form></div>");
$templateCache.put("app/main/apps/store/views/subscriptions/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-label\" \naria-label=\"{{vm.selectedThreads.length > 0 ? \'Deselect All\' : \'Select All\'}}\" \nng-checked=\"vm.selectedThreads.length > 0\" ng-click=\"vm.toggleSelectThreads()\"></md-checkbox><div \nclass=\"divider-vertical\" hide show-gt-xs></div><div aria-hidden=\"false\" \nclass=\"action-buttons hide show-gt-xs layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\" \nng-show=\"vm.selectedThreads.length > 0\"></div><ms-search-bar debounce=\"300\" \nmodel-search=\"$root.pagination_searchquery\" on-result-click=\"vm.searchResultClick(item)\" on-search=\"vm.search(query)\" \nlayout=\"row\" layout-align=\"start center\"></ms-search-bar><md-button ng-click=\"$root.pagination_resetquery()\" \naria-label=\"view type\" class=\"md-icon-button\" translate=\"\" translate-attr-aria-label=\"ACCOUNTS.RESET_SEARCH\" \nclass=\"md-icon-button\" ng-if=\"$root.pagination_searchquery\"><md-icon md-font-icon=\"icon-filter-remove-outline\">\n</md-icon><md-tooltip hide show-gt-xs><span translate=\"ACCOUNTS.RESET_SEARCH\"></span></md-tooltip></md-button>\n<md-button aria-label=\"view type\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'main-sidenav\')\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.FILTERS\"><md-icon md-font-icon=\"icon-filter\"></md-icon><md-tooltip hide show-gt-xs>\n<span translate=\"CONTENT.FILTERS\"></span></md-tooltip></md-button><div class=\"divider-vertical\" hide show-gt-xs></div>\n<md-button aria-label=\"Sort Direction\" class=\"md-icon-button\" ng-click=\"vm.setSortOrder(\'ASC\')\" \nng-disabled=\"!sortField\" ng-if=\"sortDir !== \'ASC\'\" translate translate-attr-aria-label=\"TODO.SORT_DIRECTION\"><md-icon \nmd-font-icon=\"icon-sort-ascending\" ng-if=\"sortDir !== \'ASC\'\"></md-icon><md-icon md-font-icon=\"icon-sort-descending\" \nng-if=\"sortDir === \'ASC\'\"></md-icon></md-button><md-button aria-label=\"Sort Direction\" class=\"md-icon-button\" \nng-click=\"vm.setSortOrder(\'DESC\')\" ng-disabled=\"!sortField\" ng-if=\"sortDir === \'ASC\'\" translate \ntranslate-attr-aria-label=\"TODO.SORT_DIRECTION\"><md-icon md-font-icon=\"icon-sort-ascending\" ng-if=\"sortDir !== \'ASC\'\">\n</md-icon><md-icon md-font-icon=\"icon-sort-descending\" ng-if=\"sortDir === \'ASC\'\"></md-icon></md-button><div \nclass=\"divider-vertical\" hide show-gt-xs></div><md-input-container><label>Date</label><md-select \nng-model=\"vm.filterDateField\" ng-change=\"vm.setFilterDates()\"><md-option value=\"delivery\">Shipping</md-option>\n<md-option value=\"create\">Create</md-option></md-select></md-input-container><md-datepicker \nng-model=\"vm.filterDateFrom\" ng-change=\"vm.setFilterDates()\" md-placeholder=\"Date Start\"></md-datepicker><md-datepicker\n ng-model=\"vm.filterDateTo\" ng-change=\"vm.setFilterDates()\" md-placeholder=\"Date End\"></md-datepicker><button \nclass=\"md-icon-button\" ng-click=\"vm.unsetFilterDates()\"><md-icon id=\"ms-search-bar-collapser\" \nmd-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></button></div><div layout=\"row\" layout-align=\"start center\" \ntranslate-attr-aria-label=\"ACCOUNTS.REFRESH\"><span class=\"page-info\" hide show-gt-xs>\n{{pagination_totalItems}} items found.</span><md-button aria-label=\"Previous\" class=\"md-icon-button arrow\" hide \nng-click=\"pagination_prevPage()\" ng-disabled=\"pagination_firstPage()\" show-gt-xs translate \ntranslate-attr-aria-label=\"CONTENT.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span \ntranslate=\"ACCOUNTS.PREVIOUS\">Previous</span></md-tooltip></md-button><span class=\"page-info\" hide show-gt-xs>\n{{pagination_page}} / {{pagination_total_pages}}</span><md-button aria-label=\"Next\" class=\"md-icon-button arrow\" hide \nng-click=\"pagination_nextPage()\" ng-disabled=\"pagination_morePages()\" show-gt-xs translate \ntranslate-attr-aria-label=\"CONTENT.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span \ntranslate=\"ACCOUNTS.NEXT\">Next</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.changeView(\'nosplit\')\" ng-if=\"vm.currentView !== \'nosplit\'\" hide aria-label=\"noSplit\" show-gt-sm><md-icon \nmd-font-icon=\"icon-view-list\" ng-if=\"vm.currentView !== \'nosplit\'\"></md-icon><md-icon class=\"md-accent\" \nmd-font-icon=\"icon-checkbox-marked\" ng-if=\"vm.currentView === \'nosplit\'\"></md-icon><md-tooltip><span \ntranslate=\"ACCOUNTS.NOSPLIT_VIEW\">No split</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.changeView(\'split\')\" ng-if=\"vm.currentView !== \'split\'\" hide aria-label=\"Split\" show-gt-sm><md-icon \nmd-font-icon=\"icon-view-quilt\" ng-if=\"vm.currentView !== \'split\'\"></md-icon><md-icon class=\"md-accent\" \nmd-font-icon=\"icon-checkbox-marked\" ng-if=\"vm.currentView === \'split\'\"></md-icon><md-tooltip><span \ntranslate=\"ACCOUNTS.SPLIT_VIEW\">split</span></md-tooltip></md-button><md-menu class=\"settings-menu\" hide-gt-xs \nng-show=\"vm.selectedThreads.length > 0\"><md-button aria-label=\"Settings\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\" translate translate-attr-aria-label=\"CONTENT.SETTINGS\"><md-icon \nmd-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content><md-menu-item><md-menu-item><md-button \nng-click=\"vm.massActions(\'delete\')\" aria-label=\"Delete\" translate-aria-label=\"CONTENT.DELETE\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><span translate=\"CONTENT.DELETE\">Delete </span><span translate=\"CONTENT.SELECTED\">\nSelected</span></md-button></md-menu-item></md-menu-item></md-menu-content></md-menu></div>");
$templateCache.put("app/main/apps/tasks/views/grid/grid-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/tasks/views/list/toolbar.html\'\"></div><div class=\"content-wrapper\" flex=\"\" layout=\"row\"><div\n class=\"mail-tabs-grid\" flex=\"\" md-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"content mail-list-pane-grid\" \nflex=\"\" ms-scroll=\"\"><md-progress-circular md-mode=\"indeterminate\" ng-if=\"isLoading\"></md-progress-circular><div \nclass=\"no-threads\" ng-hide=\"isLoading\" ng-if=\"!isLoading && vm.inbox.length === 0\">There are no items!</div><ms-card \nng-model=\"mail\" ng-repeat=\"thread in vm.threads | filter: vm.search | filter: global.search\" \ntemplate=\"\'app/main/apps/tasks/views/grid/template-grid-1.html\'\"></ms-card></div></div></div>");
$templateCache.put("app/main/apps/tasks/views/grid/template-grid-1.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"space-between center\" flex><div \nlayout=\"column\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-attachment\" class=\"has-attachment s24\" \nng-if=\"thread.Thumbnail.length>0\"></md-icon><button ng-if=\"thread.onoff===1\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\"></md-icon></button> <button \nng-if=\"thread.onoff!==1\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-blank-circle-outline\" \nclass=\"off red-fg s24\"></md-icon></button></div><div layout=\"column\" layout-align=\"start center\"><md-checkbox \nclass=\"no-label\" ng-checked=\"vm.isChecked(mail)\" ng-click=\"vm.toggleCheck(mail, $event)\" \naria-label=\"{{vm.isChecked(mail)? \'Uncheck\':\'check\'}}\"></md-checkbox><div ng-if=\"vm.refcolumnsgrouped.main\"><div \nclass=\"subject text-truncate\"><span ng-repeat=\"field in vm.refcolumnsgrouped.header | orderBy: \'list-sort\'\" \nng-bind=\"thread.{{field.title}}\"></span></div></div></div></div><div class=\"media\" flex layout=\"row\" \nlayout-align=\"center center\">{{vm.refcolumnsgrouped | json}}<div \nng-repeat=\"field in vm.refcolumnsgrouped.left_center | orderBy:\'list_sort\'\" \nng-if=\"field.type == \'thumbnail_square\' || field.type == \'thumbnail_\'\"><img class=\"avatar square ng-scope\" \nalt=\"{{listImage.filename}}\" ng-if=\"thread.Thumbnail.length>0\" \nng-src=\"{{listImage.cropstatus[0].container.view_url}}{{listImage.cropstatus[0].fileName}}\" \nng-repeat=\"listImage in thread.Thumbnail | filter: {\'id_zone\':field.showtype} | limitTo:1\"> <img \nclass=\"avatar square ng-scope\" alt=\"No Image\" ng-if=\"(thread.Thumbnail|filter:{\'id_zone\':field.showtype}).length == 0\" \nng-src=\"assets/images/common/no_image_available_10.png\"></div><img class=\"image\" \nng-src=\"{{card.Thumbnail[0].crop_status[0].urlformed}}\" alt=\"{{card.media.image.alt}}\" imageonloadcontrol></div><div \nclass=\"header p-16\" layout=\"row\" layout-align=\"start\"><div class=\"info\" flex layout=\"column\"><div \nng-if=\"vm.refcolumnsgrouped.main\"><div class=\"name text-truncate\" layout=\"row\" layout-align=\"start center\"><span \nng-repeat=\"field in vm.refcolumnsgrouped.main\"><span ng-bind=\"thread.{{field.title}}\"></span>&nbsp;</span></div></div>\n<div><div class=\"name text-truncate\" layout=\"row\" layout-align=\"start center\"><span><span>Title</span></span></div>\n</div><div><div class=\"details\" layout=\"row\" layout-align=\"start start\"><div layout=\"column\"><span class=\"title\">label\n</span></div><div layout=\"column\" class=\"text-truncate\"><span class=\"detail\">name</span></div></div></div><div \nng-repeat=\"field in vm.refcolumnsgrouped.secondary | orderBy:\'list_sort\'\"><div \nng-if=\"(field.type!==\'date\' && field.type!==\'dateHm\') && field.primary!==1\" class=\"details\" layout=\"row\" \nlayout-align=\"start start\"><div layout=\"column\"><span class=\"title\" ng-bind=\"field.title\"></span></div><div \nlayout=\"column\" class=\"text-truncate\"><span class=\"detail\" ng-bind=\"thread.{{field.title}}\"></span></div></div></div>\n</div></div></div>");
$templateCache.put("app/main/apps/tasks/views/grid/template-grid.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s20\" ng-if=\"card.onoff===1\"></md-icon><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s20\" ng-if=\"card.onoff===0\"></md-icon><div \nclass=\"info\"><div class=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.Thumbnail[0].crop_status[0].urlformed}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.Thumbnail[0].crop_status[0]\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/main/apps/tasks/views/list/list-table-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-if=\"isLoading\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nclass=\"mail-list-item filter-selected\" ng-if=\"vm.selectedGroup\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"info\" flex><div class=\"name\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-folder\" \nclass=\"s20 mr-8 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><div class=\"title text-truncate\" layout=\"row\" \nlayout-align=\"start center\">{{vm.selectedGroup.name}} ({{pagination_totalItems | number}})</div></div></div><div \nclass=\"buttons\" layout=\"row\" layout-align=\"start center\"><div><md-switch class=\"no-label\" \nng-checked=\"vm.includeSubgroups\" ng-click=\"vm.toggleIncludeSubgroups($event)\" \naria-label=\"{{vm.includeSubgroups ? \'Uncheck\':\'check\'}}\"></md-switch><md-tooltip><span \ntranslate=\"CONTENT.INCLUDE_SUBGROUPS\">Include subgroups</span></md-tooltip></div><md-icon \nng-if=\"!vm.selectedGroup.is_qiu_restricted\" md-font-icon=\"icon-close s20\" ng-click=\"vm.unselectGroups()\" class=\"ml-10\">\n<md-tooltip hide show-gt-xs><span translate=\"CONTENT.DESELECT_GROUP\">Deselect group</span></md-tooltip></md-icon></div>\n</div><div class=\"mail-list-item filter-selected\" ng-if=\"vm.fieldOrder != undefined || vm.groupBy != undefined\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"info\" \nng-if=\"vm.groupBy != undefined\"><div class=\"name\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"s20 mr-5 ml-0 mb-0\"></md-icon><div class=\"title text-truncate\" \nlayout=\"row\" layout-align=\"start center\">Grouped by \'{{vm.groupBy}}\'</div></div></div><div class=\"info\" \nng-if=\"vm.fieldOrder != undefined\"><div class=\"name\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-sort-ascending\" class=\"s20 mr-5 ml-0 mb-0\" ng-if=\"sortDir === \'ASC\'\"></md-icon><md-icon \nmd-font-icon=\"icon-sort-descending\" class=\"s20 mr-5 ml-0 mb-0\" ng-if=\"sortDir === \'DESC\'\"></md-icon><div \nclass=\"title text-truncate\" layout=\"row\" layout-align=\"start center\">Ordered by \'{{vm.fieldOrder}}\'</div></div></div>\n</div><div class=\"buttons\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-close s20\" \nng-click=\"vm.resetSortField()\" class=\"ml-10\"><md-tooltip hide show-gt-xs><span translate=\"CONTENT.REMOVE\">Remove</span>\n</md-tooltip></md-icon></div></div><div class=\"no-threads\" ng-if=\"!isLoading && vm.threads.length === 0\" \nng-hide=\"isLoading\">There are no items!</div><div id=\"list-content-data\" ng-style=\"{\'opacity\' : isLoading ? 0.2 : 1}\" \nng-class=\"{\'group-filter\': vm.selectedGroup,\'other-filter\':vm.fieldOrder != undefined || vm.groupBy != undefined}\" \nclass=\"scrollable\" ng-if=\"vm.threads.length > 0\"><table class=\"row-border hover simple\" ms-responsive-table><thead><tr>\n<th class=\"mini\"></th><th \nng-class=\"{\'large\': vm.isLarge(column.title), \'medium\' : vm.isMedium(column.title), \'small\' : vm.isSmall(column.title), \'mini\': vm.isMini(column.title)}\" \nng-repeat=\"column in vm.refcolumns | filter: { table_list_position: \'main\'} | orderBy: \'table_list_sort\'\" \nng-if=\"column.title !== \'lastname\'\" ng-switch=\"column.title\"><span ng-switch-when=\"firstname\" translate=\"USERS.NAME\">\n</span> <span ng-switch-default ng-bind=\"column.field_name\"></span></th><th class=\"small\"><md-menu-bar><md-menu>\n<md-button class=\"md-icon-button\" aria-label=\"Actions\" ng-click=\"$mdMenu.open($event)\" layout=\"row\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-cog\"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate=\"USERS.EDIT_COLUMNS\">Edit columns</span></md-tooltip></md-button><md-menu-content><md-menu-item \nng-repeat=\"column in vm.refcolumns | orderBy: \'table_list_sort\' | filter: { table_list_position: \'\'}\"><md-button \nmd-prevent-menu-close=\"md-prevent-menu-close\" \nng-click=\"column.table_list_position == \'main\' ? column.table_list_position = \'secondary\' : column.table_list_position = \'main\'; $event.stopPropagation();\">\n<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start between\"><span \nng-bind=\"column.field_name\"></span></div><i ng-if=\"column.table_list_position == \'main\'\" class=\"icon-check s16\"></i>\n</div></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></th></tr></thead><tbody \nms-scroll=\"vm.msScrollOptions\" class=\"scrollable\"><tr ng-click=\"vm.openThread(thread)\" \nng-repeat=\"thread in vm.threads | filter: vm.search | filter: global.search | groupByUser:[vm.groupBy]\" \nng-class=\"{\'starred\': thread.starred, \'selected\': vm.selectedContentID === thread.id_user, \'checked\': vm.isChecked(thread)}\" \nclass=\"{{thread.status}}\"><td class=\"mini\"><md-checkbox class=\"no-label\" ng-checked=\"vm.isSelected(thread)\" \nng-click=\"vm.toggleSelectThread(thread, $event)\" aria-label=\"{{vm.isSelected(thread) ? \'Deselect\' : \'Select\'}}\">\n</md-checkbox></td><td \nng-class=\"{\'large\': vm.isLarge(column.title), \'medium\' : vm.isMedium(column.title), \'small\' : vm.isSmall(column.title), \'mini\': vm.isMini(column.title)}\" \nng-repeat=\"column in vm.refcolumns | filter: { table_list_position: \'main\'} | orderBy: \'table_list_sort\'\" \nng-if=\"column.title !== \'lastname\'\" ng-switch=\"column.title\"><a ng-switch-when=\"email\" title=\"{{thread.email}}\" \nhref=\"mailto:{{thread.email}}\">{{thread[column.title]}}</a> <span ng-switch-when=\"media\"><div \nng-if=\"(!thread.avatar) && thread[vm.refcolumnsgrouped.main[0].title]\" class=\"avatar\" \nng-bind=\"thread[vm.refcolumnsgrouped.main[0].title] | capitalizeFirstLetter\" ms-random-class=\"vm.colors\"></div><media \nng-if=\"thread.avatar\" attachment=\"thread.avatar\" class=\"avatar\"></media></span><span title=\"# {{thread.id_user}}\" \nclass=\"grey-500-fg\" ng-switch-when=\"id_user\">#{{thread.id_user}}</span> <span class=\"large\" ng-switch-when=\"firstname\">\n<strong title=\"{{thread.firstname}} {{thread.lastname}}\">{{thread.firstname}} {{thread.lastname}}</strong> </span><span\n class=\"mini\" ng-switch-when=\"status\"><button ng-if=\"thread.status===0\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\" \nng-click=\"vm.toggleItemStatus(thread, $event, $index)\"></md-icon></button> <button ng-if=\"thread.status===1\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-minus-circle\" class=\"on amber-400-fg s24\" \nng-click=\"vm.toggleItemStatus(thread, $event, $index)\"></md-icon></button> <button ng-if=\"thread.status===2\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\" \nng-click=\"vm.toggleItemStatus(thread, $event, $index)\"></md-icon></button> <button \nng-if=\"thread.status!==0 && thread.status!==1 && thread.status!==2\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle\" class=\"on grey-fg s24\" \nng-click=\"vm.toggleItemStatus(thread, $event, $index)\"></md-icon></button> </span><span \ntitle=\"{{vm.getCountryById(thread.country).name}}\" ng-switch-when=\"country\">{{vm.getCountryById(thread.country).name}}\n</span> <span title=\"{{thread[column.title]}}\" ng-switch-default>{{thread[column.title]}}</span></td><td class=\"small\">\n</td></tr></tbody></table><div class=\"toolbar border-top\" style=\"padding-bottom: 18px\" layout=\"row\" \nlayout-align=\"end center\"><div layout=\"row\" layout-align=\"center center\" \nng-style=\"{\'display\' : isLoading ? \'none\' : \'block\'}\"><span class=\"page-info\">{{pagination_totalItems}} items found.\n</span><md-button aria-label=\"Previous\" class=\"md-icon-button arrow\" ng-click=\"pagination_prevPage()\" \nng-disabled=\"pagination_firstPage()\" translate=\"\" translate-attr-aria-label=\"CONTENT.PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.PREVIOUS\">Previous\n</span></md-tooltip></md-button><span class=\"page-info\">{{pagination_page}} / {{pagination_total_pages}}</span>\n<md-button aria-label=\"Next\" class=\"md-icon-button arrow\" ng-click=\"pagination_nextPage()\" \nng-disabled=\"pagination_morePages() || pagination_total_pages === pagination_page\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip hide \nshow-gt-xs><span translate=\"CONTENT.NEXT\">Next</span></md-tooltip></md-button></div></div></div>");
$templateCache.put("app/main/apps/tasks/views/list/list-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-if=\"isLoading\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nclass=\"mail-list-item filter-selected\" ng-if=\"vm.selectedGroup\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"info\" flex><div class=\"name\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-folder\" \nclass=\"s20 mr-8 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><div class=\"title text-truncate\" layout=\"row\" \nlayout-align=\"start center\">{{vm.selectedGroup.name}} ({{pagination_totalItems | number}})</div></div></div><div \nclass=\"buttons\" layout=\"row\" layout-align=\"start center\"><div><md-switch class=\"no-label\" \nng-checked=\"vm.includeSubgroups\" ng-click=\"vm.toggleIncludeSubgroups($event)\" \naria-label=\"{{vm.includeSubgroups ? \'Uncheck\':\'check\'}}\"></md-switch><md-tooltip><span \ntranslate=\"CONTENT.INCLUDE_SUBGROUPS\">Include subgroups</span></md-tooltip></div><md-icon \nng-if=\"!vm.selectedGroup.is_qiu_restricted\" md-font-icon=\"icon-close s20\" ng-click=\"vm.unselectGroups()\" class=\"ml-10\">\n<md-tooltip hide show-gt-xs><span translate=\"CONTENT.DESELECT_GROUP\">Deselect group</span></md-tooltip></md-icon></div>\n</div><div class=\"mail-list-item filter-selected\" ng-if=\"vm.fieldOrder != undefined || vm.groupBy != undefined\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"info\" \nng-if=\"vm.groupBy != undefined\"><div class=\"name\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"s20 mr-5 ml-0 mb-0\"></md-icon><div class=\"title text-truncate\" \nlayout=\"row\" layout-align=\"start center\">Grouped by \'{{vm.groupBy}}\'</div></div></div><div class=\"info\" \nng-if=\"vm.fieldOrder != undefined\"><div class=\"name\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-sort-ascending\" class=\"s20 mr-5 ml-0 mb-0\" ng-if=\"sortDir === \'ASC\'\"></md-icon><md-icon \nmd-font-icon=\"icon-sort-descending\" class=\"s20 mr-5 ml-0 mb-0\" ng-if=\"sortDir === \'DESC\'\"></md-icon><div \nclass=\"title text-truncate\" layout=\"row\" layout-align=\"start center\">Ordered by \'{{vm.fieldOrder}}\'</div></div></div>\n</div><div class=\"buttons\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-close s20\" \nng-click=\"vm.resetSortField()\" class=\"ml-10\"><md-tooltip hide show-gt-xs><span translate=\"CONTENT.REMOVE\">Remove</span>\n</md-tooltip></md-icon></div></div><div class=\"no-threads\" ng-if=\"!isLoading && vm.threads.length === 0\" \nng-hide=\"isLoading\">There are no items!</div><div id=\"list-content-data\" ng-style=\"{\'opacity\' : isLoading ? 0.2 : 1}\" \nms-scroll=\"vm.msScrollOptions\" \nng-class=\"{\'group-filter\': vm.selectedGroup,\'other-filter\':vm.fieldOrder != undefined || vm.groupBy != undefined}\" \nclass=\"scrollable\" ng-if=\"vm.threads.length > 0\"><div ng-if=\"vm.currentLabelsFilter\" class=\"labels\"><form novalidate>\n<div><div ng-repeat=\"item in vm.currentLabelsFilter track by $index\" class=\"tag\" fxlayout=\"row\" \nfxlayoutalign=\"start center\"><div class=\"tag-label\">{{item.label}}<md-icon \nng-click=\"vm.deleteTargetFilter(item.id, $index)\" md-font-icon=\"icon-close\" class=\"s24 pointer\"></md-icon></div></div>\n</div></form></div><div class=\"todo-items\" ng-sortable=\"vm.sortableOptions\"><div class=\"todo-item {{thread.status}}\" \nmd-ink-ripple layout=\"row\" layout-align=\"start center\" ng-click=\"vm.openThread(thread)\" \nng-repeat=\"thread in vm.threads  | filter: vm.search | filter: global.search | groupByUser:[vm.groupBy] \" \nng-class=\"{\'starred\': thread.starred, \'selected\': vm.selectedContentID === thread.id, \'checked\': vm.isChecked(thread)}\">\n<md-icon md-font-icon=\"icon-drag-horizontal\" style=\"margin: 0 10px 0 0;cursor: move\"></md-icon><div \nclass=\"groupBy-separator\" ng-show=\"thread.group_by_CHANGED\"><h2 ng-if=\"thread.firstname[0]\" \nclass=\"groupBy-title uppercase\">{{thread.firstname[0]}}</h2><h2 ng-if=\"!thread.firstname[0]\" class=\"groupBy-title\">\n(without name)</h2></div><div layout=\"row\" layout-align=\"start center\" style=\"width: 100%\"><div \nng-repeat=\"field in vm.refcolumnsgrouped.left_center | orderBy:\'list_sort\'\"><div ng-if=\"field.type == \'user_status\'\">\n<button ng-if=\"thread.status===0\" class=\"md-icon-button md-button\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\" \nng-click=\"vm.toggleItemStatus(thread, $event, $index)\"></md-icon></button> <button ng-if=\"thread.status===1\" \nclass=\"md-icon-button md-button\"><md-icon md-font-icon=\"icon-minus-circle\" class=\"on amber-400-fg s24\" \nng-click=\"vm.toggleItemStatus(thread, $event, $index)\"></md-icon></button> <button ng-if=\"thread.status===2\" \nclass=\"md-icon-button md-button\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\" \nng-click=\"vm.toggleItemStatus(thread, $event, $index)\"></md-icon></button> <button \nng-if=\"thread.status!==0 && thread.status!==1 && thread.status!==2\" class=\"md-icon-button md-button\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle\" class=\"on grey-fg s24\" \nng-click=\"vm.toggleItemStatus(thread, $event, $index)\"></md-icon></button></div><div ng-if=\"field.type == \'language\'\" \nlayout=\"row\" layout-align=\"center center\"><img class=\"img-flag ng-scope\" \nalt=\"{{vm.siteLanguages(thread[field.title])[lang_name]}}\" \nng-src=\"assets/images/flags/{{vm.siteLanguages()[thread[field.title]].flag_code|lowercase}}.svg\"></div><div \nng-if=\"field.type == \'thumbnail\'\"><media attachment=\"listImage\" thumbnail=\"1\" crop-format=\"{{field.id_cropformats}}\" \nclass=\"avatar ng-scope\" alt=\"{{listImage.filename}}\" \nng-repeat=\"listImage in thread.Thumbnail | filter: {\'id_zone\':field.id_zone} | limitTo:1\"></media></div><div \nng-if=\"field.type == \'thumbnail_square\'\"><media attachment=\"listImage\" thumbnail=\"1\" \ncrop-format=\"{{field.id_cropformats}}\" class=\"avatar square ng-scope\" alt=\"{{listImage.filename}}\" \nng-repeat=\"listImage in thread.Thumbnail | filter: {\'id_zone\':field.id_zone} | limitTo:1\"></media></div><md-icon \nmd-font-icon=\"icon-alert-circle\" class=\"is-important red-600-fg\" ng-if=\"field.type == \'important\' && task.important\">\n</md-icon><md-icon md-font-icon=\"icon-attachment\" class=\"has-attachment s24\" \nng-if=\"field.type == \'attachments\' && thread.Thumbnail.length > 0\"></md-icon></div><div class=\"info\" flex><div \nclass=\"name\" layout=\"row\" layout-align=\"start center\"><div \nng-if=\"(!thread.avatar) && thread[vm.refcolumnsgrouped.main[0].title]\" class=\"avatar\" \nng-bind=\"thread[vm.refcolumnsgrouped.main[0].title] | capitalizeFirstLetter\" ms-random-class=\"vm.colors\"></div><media \nng-if=\"thread.avatar\" attachment=\"thread.avatar\" class=\"avatar\"></media><div class=\"user-name\" layout=\"column\" \nlayout-align=\"start start\"><div ng-if=\"vm.refcolumnsgrouped.main\"><span ng-repeat=\"field in vm.refcolumnsgrouped.main\">\n<span ng-bind=\"thread.{{field.title}}\"></span>&nbsp;</span></div><div ng-if=\"vm.refcolumnsgrouped.main\" \nclass=\"user-header text-truncate grey-500-fg\"><span \nng-repeat=\"field in vm.refcolumnsgrouped.header | orderBy: \'list_sort\'\"><span ng-if=\"field.type == \'id\'\">#</span> <span\n ng-if=\"field.type == \'dateHm\' || field.type == \'date\'\" ng-bind=\"vm.showDate(thread[field.title])\"></span> <span \nng-if=\"field.type != \'dateHm\' && field.type != \'date\'\" ng-bind=\"thread.{{field.title}}\"></span></span></div></div>\n</div></div><div layout=\"column\" layout-align=\"space-between end\"></div></div><div title=\"Company Id\">\n{{thread.id_crm_my_company}}</div><div><button ng-if=\"thread.status===1\" class=\"md-icon-button md-button\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"off green-fg s24\"></md-icon></button> <button \nng-if=\"thread.status===0\" class=\"md-icon-button md-button\"><md-icon md-font-icon=\"icon-minus-circle\" \nclass=\"on amber-400-fg s24\"></md-icon></button></div></div></div><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"end center\"><div layout=\"row\" layout-align=\"center center\" \nng-style=\"{\'display\' : isLoading ? \'none\' : \'block\'}\"><span class=\"page-info\">{{pagination_totalItems}} items found.\n</span><md-button aria-label=\"Previous\" class=\"md-icon-button arrow\" ng-click=\"pagination_prevPage()\" \nng-disabled=\"pagination_firstPage()\" translate=\"\" translate-attr-aria-label=\"CONTENT.PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.PREVIOUS\">Previous\n</span></md-tooltip></md-button><span class=\"page-info\">{{pagination_page}} / {{pagination_total_pages}}</span>\n<md-button aria-label=\"Next\" class=\"md-icon-button arrow\" ng-click=\"pagination_nextPage()\" \nng-disabled=\"pagination_morePages() || pagination_total_pages === pagination_page\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip hide \nshow-gt-xs><span translate=\"CONTENT.NEXT\">Next</span></md-tooltip></md-button></div></div></div>");
$templateCache.put("app/main/apps/tasks/views/list/nosplit-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/tasks/views/list/toolbar.html\'\" ng-hide=\"vm.currentThread || vm.currentThread_Edit\"></div>\n<div class=\"content-wrapper\" flex=\"\" layout=\"row\"><div class=\"content thread-detail mail-read-pane\" flex=\"\" \nid=\"thread-detail\" ms-scroll=\"vm.msScrollOptions\" ng-if=\"vm.currentThread || vm.currentThread_Edit\" \nng-include=\"\'app/main/apps/tasks/views/read/read-view-nosplit.html\'\"></div><div \nclass=\"content thread-list mail-list-pane\" flex id=\"thread-list\" ng-if=\"!vm.currentThread && !vm.currentThread_Edit\" \nng-include=\"\'app/main/apps/tasks/views/list/list-view.html\'\"></div></div>");
$templateCache.put("app/main/apps/tasks/views/list/split-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/tasks/views/list/toolbar.html\'\"></div><div class=\"content-wrapper\" flex=\"\" layout=\"row\"><div\n class=\"content thread-list mail-list-pane\" flex=\"50\" id=\"thread-list\" \nng-include=\"\'app/main/apps/tasks/views/list/list-view.html\'\"></div><div class=\"content thread-detail mail-read-pane\" \nflex=\"50\" id=\"thread-detail\" layout=\"column\" ng-include=\"\'app/main/apps/tasks/views/read/read-view.html\'\"></div></div>");
$templateCache.put("app/main/apps/tasks/views/list/table-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/tasks/views/list/toolbar.html\'\"></div><div class=\"content-wrapper\" flex=\"\" layout=\"row\"><div\n class=\"content thread-list mail-list-pane\" flex=\"100\" id=\"thread-list\" \nng-include=\"\'app/main/apps/tasks/views/list/list-table-view.html\'\"></div><div \nclass=\"content thread-detail mail-read-pane edit-pane-users\" id=\"thread-detail\" layout=\"column\" \nng-include=\"\'app/main/apps/tasks/views/read/read-view.html\'\" ng-class=\"{selected:vm.selectedContent}\"></div></div>");
$templateCache.put("app/main/apps/tasks/views/list/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button close-thread\" aria-label=\"Back\" \nng-click=\"vm.closeUsers()\" ng-if=\"vm.currentView==\'nosplit\' && vm.groupsView\" translate \ntranslate-attr-aria-label=\"CONTENT.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button>\n<md-checkbox class=\"no-label\" aria-label=\"{{vm.selectedThreads.length > 0 ? \'Deselect All\' : \'Select All\'}}\" \nng-checked=\"vm.selectedThreads.length > 0\" ng-click=\"vm.toggleSelectThreads()\"></md-checkbox><div \nclass=\"divider-vertical\" hide=\"\" show-gt-xs=\"\"></div><md-button aria-label=\"ADD NEW\" \nclass=\"md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme\" hide show-gt-sm \nng-click=\"vm.newThread()\" translate=\"CONTENT.ADD\" type=\"button\">Add new</md-button><md-button aria-label=\"ADD NEW\" \nclass=\"md-fab md-mini md-accent green-500-bg md-raised md-ink-ripple md-default-theme\" hide-gt-sm \nng-click=\"vm.newThread()\" type=\"button\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><div \nclass=\"divider-vertical\" hide=\"\" show-gt-xs=\"\"></div><div layout=\"row\" layout-align=\"start center\" \nclass=\"groups-trigger\"><button aria-label=\"view group\" class=\"md-button md-icon-button\" \nng-click=\"vm.toggleSidenav(\'groups-sidenav\')\" translate translate-attr-aria-label=\"CONTENT.FILTERS\"><md-icon \nmd-font-icon=\"icon-folder-multiple\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.VIEW_GROUPS\">\nView Groups</span></md-tooltip></button></div><div class=\"divider-vertical\" hide=\"\" show-gt-xs=\"\"></div><ms-search-bar \ndebounce=\"300\" model-search=\"$root.pagination_searchquery\" on-result-click=\"vm.searchResultClick(item)\" \non-search=\"vm.search(query)\" layout=\"row\" layout-align=\"start center\"></ms-search-bar><md-button \nng-if=\"$root.pagination_searchquery==true\" ng-click=\"vm.resetFilters()\" aria-label=\"view type\" class=\"md-icon-button\" \ntranslate=\"\" translate-attr-aria-label=\"CONTENT.FILTERS\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-filter-remove-outline\"></md-icon><md-tooltip hide show-gt-xs><span>Reset search</span></md-tooltip>\n</md-button><md-button ng-if=\"!vm.groupsView\" aria-label=\"view type\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'filters-sidenav\')\" translate=\"\" translate-attr-aria-label=\"CONTENT.FILTERS\"><md-icon \nmd-font-icon=\"icon-filter\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.FILTERS\">Filters</span>\n</md-tooltip></md-button><div class=\"divider-vertical\" hide=\"\" show-gt-xs=\"\"></div><md-menu-bar class=\"pr-0 pl-0\" hide \nshow-gt-xs><md-menu><md-button class=\"menu-button-custom\" aria-label=\"Actions\" ng-click=\"$mdMenu.open($event)\" \nlayout=\"row\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-cog\" class=\"mr-5\"></md-icon><span \nclass=\"text-capitalized grey-600-fg\">Actions</span></md-button><md-menu-content><md-menu-item><md-menu><md-button \naria-label=\"Filters\" ng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-format-list-bulleted\"></md-icon><span>\nGroup by</span></md-button><md-menu-content><md-menu-item ng-if=\"vm.groupBy != undefined\"><md-button \nng-click=\"vm.resetGroupby()\"><md-icon md-font-icon=\"icon-close\"></md-icon><span translate=\"CONTENT.REMOVE_GROUP_BY\">\nRemove group by</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.setGroupBy(\'firstname\')\">\nFirstname</md-button></md-menu-item></md-menu-content></md-menu></md-menu-item><md-menu-item><md-menu><md-button \naria-label=\"Filters\" ng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-sort\"></md-icon><span \ntranslate=\"CONTENT.ORDER_BY\">Order by</span></md-button><md-menu-content><md-menu-item \nng-if=\"vm.fieldOrder != undefined\"><md-button ng-click=\"vm.resetSortField()\"><md-icon md-font-icon=\"icon-close\">\n</md-icon><span translate=\"CONTENT.REMOVE_ORDER\">Remove order</span></md-button></md-menu-item><md-menu-item \nng-repeat=\"field in vm.refcolumns\" ng-if=\"field.sortable === 1\"><md-button ng-click=\"vm.setSortField(field.title)\"><div\n layout=\"row\" layout-align=\"space-between center\"><span>{{field.field_name}}</span> <i class=\"icon-check s16\" \nng-if=\"vm.fieldOrder === field.field_name\"></i></div></md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.setSortOrder(\'ASC\')\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start between\"><md-icon \nmd-font-icon=\"icon-sort-ascending\"></md-icon><span translate=\"CONTENT.DIRECTION_A_Z\">Order A-Z</span></div><i \nclass=\"icon-check s16\" ng-if=\"sortDir === \'ASC\'\"></i></div></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.setSortOrder(\'DESC\')\"><div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start between\"><md-icon md-font-icon=\"icon-sort-descending\"></md-icon><span \ntranslate=\"CONTENT.DIRECTION_Z_A\">Order Z-A</span></div><i class=\"icon-check s16\" ng-if=\"sortDir === \'DESC\'\"></i></div>\n</md-button></md-menu-item><div hide-gt-md><md-menu-item><md-button ng-disabled=\"vm.selectedThreads.length == 0\" \naria-label=\"SUBSCRIPTIONS\"><md-icon md-font-icon=\"icon-telegram\"></md-icon><span \ntranslate=\"USERS.ADD_REMOVE_SUBSCRIPTIONS\">Add/Remove subscriptions</span></md-button></md-menu-item><md-menu-item \nng-if=\"!vm.selectedGroup\"><md-button ng-click=\"vm.addUsersToGroupsDialog($event)\" \nng-disabled=\"vm.selectedThreads.length == 0\" aria-label=\"Add to group\"><md-icon md-font-icon=\"icon-folder-account\">\n</md-icon><span translate=\"USERS.ADD_TO_GROUPS\"></span></md-button></md-menu-item><md-menu-item \nng-if=\"vm.selectedGroup\"><md-button ng-click=\"vm.removeUsersFromGroupDialog($event)\" \nng-disabled=\"vm.selectedThreads.length == 0 || vm.includeSubgroups\" aria-label=\"Remove from group\"><md-icon \nmd-font-icon=\"icon-folder-remove\"></md-icon><span translate=\"USERS.REMOVE_FROM_GROUP\"></span></md-button>\n</md-menu-item></div><div hide-gt-md><md-menu-item><md-button ng-disabled=\"vm.selectedThreads.length == 0\" \naria-label=\"EXPORT\"><md-icon md-font-icon=\"icon-export\"></md-icon><span translate=\"CONTENT.EXPORT\">EXPORT</span>\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.deleteThread()\" \nng-disabled=\"vm.selectedThreads.length == 0\" aria-label=\"DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span \ntranslate=\"CONTENT.DELETE\">DELETE</span></md-button></md-menu-item></div></md-menu-content></md-menu></md-menu-bar><div\n class=\"divider-vertical\" hide show-gt-xs></div><div aria-hidden=\"false\" class=\"action-buttons\" hide show-gt-md \nlayout=\"row\" layout-align=\"start center\" ng-show=\"vm.selectedThreads.length > 0\"><md-button aria-label=\"Subscriptions\" \nclass=\"md-icon-button\" translate=\"\" translate-attr-aria-label=\"USERS.ADD_REMOVE_SUBSCRIPTIONS\"><md-icon \nmd-font-icon=\"icon-telegram\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"USERS.ADD_REMOVE_SUBSCRIPTIONS\">\nAdd/Remove subscriptions</span></md-tooltip></md-button><md-button ng-if=\"!vm.selectedGroup\" \nng-click=\"vm.addUsersToGroupsDialog($event)\" aria-label=\"Add\" class=\"md-icon-button\" translate=\"\" \ntranslate-attr-aria-label=\"USERS.ADD_TO_GROUPS\"><md-icon md-font-icon=\"icon-folder-account\"></md-icon><md-tooltip hide \nshow-gt-xs><span translate=\"USERS.ADD_TO_GROUPS\"></span></md-tooltip></md-button><md-button ng-if=\"vm.selectedGroup\" \nng-click=\"vm.removeUsersFromGroupDialog($event)\" ng-disabled=\"vm.selectedThreads.length == 0 || vm.includeSubgroups\" \naria-label=\"Remove\" class=\"md-icon-button\" translate=\"\" translate-attr-aria-label=\"USERS.REMOVE_FROM_GROUP\"><md-icon \nmd-font-icon=\"icon-folder-remove\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"USERS.REMOVE_FROM_GROUP\">\n</span></md-tooltip></md-button><md-button aria-label=\"Export\" class=\"md-icon-button\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.EXPORT\"><md-icon md-font-icon=\"icon-export\"></md-icon><md-tooltip hide show-gt-xs>\n<span translate=\"CONTENT.EXPORT\">Export</span></md-tooltip></md-button><md-button ng-click=\"vm.deleteThread()\" \naria-label=\"Delete\" class=\"md-icon-button\" translate=\"\" translate-attr-aria-label=\"CONTENT.DELETE\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.DELETE\">Delete</span>\n</md-tooltip></md-button><div class=\"divider-vertical\"></div></div><md-button aria-label=\"view type\" \nclass=\"md-icon-button\" hide=\"\" ng-click=\"vm.changeView(\'split\')\" ng-if=\"vm.currentView === \'grid\'\" show-gt-sm=\"\" \ntranslate=\"\" translate-attr-aria-label=\"CONTENT.LIST_VIEW\"><md-icon md-font-icon=\"icon-view-headline\"></md-icon>\n<md-tooltip hide show-gt-xs><span translate=\"CONTENT.LIST_VIEW\">List View</span></md-tooltip></md-button></div><div \nng-if=\"!vm.groupsView\" layout=\"row\" layout-align=\"start center\" translate-attr-aria-label=\"CONTENT.REFRESH\">\n<md-menu-bar class=\"pr-0 pl-0\" hide-gt-xs><md-menu><md-button class=\"md-icon-button\" aria-label=\"Actions\" \nng-click=\"$mdMenu.open($event)\" layout=\"row\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"mr-5\"></md-icon></md-button><md-menu-content><md-menu-item><md-menu><md-button aria-label=\"Filters\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-format-list-bulleted\"></md-icon><span>Group by</span>\n</md-button><md-menu-content><md-menu-item ng-if=\"vm.groupBy != undefined\"><md-button ng-click=\"vm.resetGroupby()\">\n<md-icon md-font-icon=\"icon-close\"></md-icon><span translate=\"CONTENT.REMOVE_GROUP_BY\">Remove group by</span>\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.setGroupBy(\'firstname\')\">Firstname</md-button>\n</md-menu-item></md-menu-content></md-menu></md-menu-item><md-menu-item><md-menu><md-button aria-label=\"Filters\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-sort\"></md-icon><span translate=\"CONTENT.ORDER_BY\">Order by\n</span></md-button><md-menu-content><md-menu-item ng-if=\"vm.fieldOrder != undefined\"><md-button \nng-click=\"vm.resetSortField()\"><md-icon md-font-icon=\"icon-close\"></md-icon><span translate=\"CONTENT.REMOVE_ORDER\">\nRemove order</span></md-button></md-menu-item><md-menu-item ng-repeat=\"field in vm.refcolumns\" \nng-if=\"field.sortable === 1\"><md-button ng-click=\"vm.setSortField(field.title)\"><div layout=\"row\" \nlayout-align=\"space-between center\"><span>{{field.field_name}}</span> <i class=\"icon-check s16\" \nng-if=\"vm.fieldOrder === field.field_name\"></i></div></md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.setSortOrder(\'ASC\')\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start between\"><md-icon \nmd-font-icon=\"icon-sort-ascending\"></md-icon><span translate=\"CONTENT.DIRECTION_A_Z\">Order A-Z</span></div><i \nclass=\"icon-check s16\" ng-if=\"sortDir === \'ASC\'\"></i></div></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.setSortOrder(\'DESC\')\"><div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start between\"><md-icon md-font-icon=\"icon-sort-descending\"></md-icon><span \ntranslate=\"CONTENT.DIRECTION_Z_A\">Order Z-Z</span></div><i class=\"icon-check s16\" ng-if=\"sortDir === \'DESC\'\"></i></div>\n</md-button></md-menu-item><div hide-gt-md><md-menu-item><md-button ng-disabled=\"vm.selectedThreads.length == 0\" \naria-label=\"SUBSCRIPTIONS\"><md-icon md-font-icon=\"icon-telegram\"></md-icon><span \ntranslate=\"USERS.ADD_REMOVE_SUBSCRIPTIONS\">Add/Remove subscriptions</span></md-button></md-menu-item><md-menu-item \nng-if=\"!vm.selectedGroup\"><md-button ng-click=\"vm.addUsersToGroupsDialog($event)\" \nng-disabled=\"vm.selectedThreads.length == 0\" aria-label=\"Add to groups\"><md-icon md-font-icon=\"icon-folder-account\">\n</md-icon><span translate=\"USERS.ADD_TO_GROUPS\"></span></md-button></md-menu-item><md-menu-item \nng-if=\"vm.selectedGroup\"><md-button ng-click=\"vm.removeUsersFromGroupDialog($event)\" class=\"md-icon-button\" \nng-disabled=\"vm.selectedThreads.length == 0 || vm.includeSubgroups\" aria-label=\"Remove from group\"><md-icon \nmd-font-icon=\"icon-folder-remove\"></md-icon><span translate=\"USERS.REMOVE_FROM_GROUP\"></span></md-button>\n</md-menu-item></div><div hide-gt-md><md-menu-item><md-button ng-disabled=\"vm.selectedThreads.length == 0\" \naria-label=\"EXPORT\"><md-icon md-font-icon=\"icon-export\"></md-icon><span translate=\"CONTENT.EXPORT\">EXPORT</span>\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.deleteThread()\" \nng-disabled=\"vm.selectedThreads.length == 0\" aria-label=\"DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span \ntranslate=\"CONTENT.DELETE\">DELETE</span></md-button></md-menu-item></div></md-menu-content></md-menu></md-menu-bar>\n<span class=\"page-info\" hide=\"\" show-gt-xs=\"\">{{pagination_totalItems}} items.</span><md-button aria-label=\"Previous\" \nclass=\"md-icon-button arrow\" hide=\"\" ng-click=\"pagination_prevPage()\" ng-disabled=\"pagination_firstPage()\" \nshow-gt-xs=\"\" translate=\"\" translate-attr-aria-label=\"CONTENT.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.PREVIOUS\">Previous</span></md-tooltip></md-button><span \nclass=\"page-info\" hide=\"\" show-gt-xs=\"\">{{pagination_page}} / {{pagination_total_pages}}</span><md-button \naria-label=\"Next\" class=\"md-icon-button arrow\" hide=\"\" ng-click=\"pagination_nextPage()\" \nng-disabled=\"pagination_morePages()\" show-gt-xs=\"\" translate=\"\" translate-attr-aria-label=\"CONTENT.NEXT\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.NEXT\">Next</span>\n</md-tooltip></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button class=\"md-icon-button\" \nng-click=\"vm.changeView(\'split\')\" ng-if=\"vm.currentView !== \'split\'\" hide show-gt-sm aria-label=\"Split\"><md-icon \nmd-font-icon=\"icon-view-list\" ng-if=\"vm.currentView !== \'split\'\"></md-icon><md-icon class=\"md-accent\" \nmd-font-icon=\"icon-checkbox-marked\" ng-if=\"vm.currentView === \'split\'\"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate=\"CONTENT.SIMPLE_LIST\">split</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.changeView(\'table\')\" ng-if=\"vm.currentView !== \'table\'\" hide show-gt-sm><md-icon \nmd-font-icon=\"icon-view-module\" ng-if=\"vm.currentView !== \'table\'\"></md-icon><md-icon class=\"md-accent\" \nmd-font-icon=\"icon-checkbox-marked\" ng-if=\"vm.currentView === \'table\'\"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate=\"CONTENT.TABLE_VIEW\">table</span></md-tooltip></md-button></div>");
$templateCache.put("app/main/apps/tasks/views/read/edit-preview.html","<div id=\"users-edit\" class=\"page-layout simple fullwidth mail-content content-edit\" layout=\"column\"><md-tabs><md-tab \nlabel=\"Edit\"><div layout=\"row\" ng-include=\"\'app/main/apps/tasks/views/read/tab-edit.html\'\"></div></md-tab><md-tab \nlabel=\"Media\"><div ng-include=\"\'app/main/apps/tasks/views/read/tab-media.html\'\"></div></md-tab><md-tab \nlabel=\"{{ \'USERS.USERS_GROUPS\' | translate}}\"><div ng-include=\"\'app/main/apps/tasks/views/read/tab-users-groups.html\'\">\n</div></md-tab><md-tab label=\"SEO\" ng-if=\"vm.ActiveSection.seo\"><div \nng-include=\"\'app/main/apps/tasks/views/read/tab-seo.html\'\"></div></md-tab><md-tab \nlabel=\"{{ \'USERS.ACTIVITY\' | translate}}\" ng-if=\"vm.ActiveSection.activity\"><div \nng-include=\"\'app/main/apps/tasks/views/read/tab-activity.html\'\"></div></md-tab></md-tabs></div>");
$templateCache.put("app/main/apps/tasks/views/read/edit-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-if=\"vm.loadingReadPane\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nng-show=\"!vm.loadingReadPane\"><div class=\"mail-content\" layout=\"column\" layout-align=\"center center\" \nng-if=\"!vm.selectedContent\"><div class=\"content\" layout=\"column\" layout-align=\"top center\"><div class=\"message\">\nPlease select an item to show in this panel</div></div></div><div class=\"toolbar grey-100-bg colored-bg\" layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"vm.selectedContent\" scroll=\"\"><div layout=\"row\" layout-align=\"start center\">\n<md-button class=\"md-icon-button close-thread\" aria-label=\"Back\" ng-click=\"vm.closeThread()\" translate \ntranslate-attr-aria-label=\"CONTENT.BACK\"><md-icon md-font-icon=\"icon-arrow-right\"></md-icon></md-button></div><div \nlayout=\"row\" layout-align=\"end center\" ng-if=\"vm.currentThread_Edit\"><md-button type=\"submit\" \nng-click=\"vm.saveItem(vm.currentThread_Edit)\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.basicForm.$invalid || vm.basicForm.$pristine\" aria-label=\"SAVE\" translate=\"CONTENT.SAVE\" \ntranslate-attr-aria-label=\"CONTENT.SAVE\">SAVE</md-button><md-button type=\"button\" ng-click=\"vm.closeThreadEdit()\" \nclass=\"md-raised md-warn\" aria-label=\"Cancel\">Cancel</md-button></div></div><md-content ng-if=\"vm.selectedContent\" \nng-include=\"\'app/main/apps/tasks/views/read/edit-preview.html\'\" class=\"scrollable\"></md-content></div>");
$templateCache.put("app/main/apps/tasks/views/read/item-context-menu.html","<md-menu md-offset=\"0 -5\" id=\"context-menu\"><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"ctrl.openMenu($mdMenu.open, $event)\"><md-icon md-menu-origin md-svg-icon=\"call:ring-volume\"></md-icon>\n</md-button><md-menu-content width=\"4\"><md-menu-item ng-repeat=\"item in [1, 2, 3]\"><md-button \nng-click=\"ctrl.announceClick($index)\"><span md-menu-align-target>Option</span> {{item}}</md-button></md-menu-item>\n</md-menu-content></md-menu>");
$templateCache.put("app/main/apps/tasks/views/read/read-view-nosplit.html","<div flex layout=\"column\" layout-align=\"center center\" ng-if=\"vm.loadingReadPane\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"30\"></md-progress-circular></div><div \nng-show=\"!vm.loadingReadPane\"><div class=\"mail-content\" layout=\"column\" layout-align=\"center center\" \nng-if=\"!vm.selectedContent\"><div class=\"content\" layout=\"column\" layout-align=\"top center\"><div class=\"message\">\nPlease select an item to show in this panel</div></div></div><div class=\"toolbar grey-100-bg colored-bg\" layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"vm.selectedContent\" scroll=\"\"><div layout=\"row\" layout-align=\"start center\">\n<md-button class=\"md-icon-button close-thread\" aria-label=\"Back\" ng-click=\"vm.closeThread()\" \nng-if=\"vm.currentThread && (vm.currentView==\'nosplit\' || vm.currentView==\'table\')\" translate \ntranslate-attr-aria-label=\"CONTENT.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><div \nclass=\"divider-vertical\" hide=\"\" ng-if=\"vm.activeMailPaneIndex === 1\" show-gt-sm=\"\"></div><md-button \naria-label=\"Preview\" class=\"md-icon-button\" ng-click=\"vm.viewPreview()\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.PREVIEW\"><md-icon md-font-icon=\"icon-eye\"></md-icon><md-tooltip hide show-gt-xs>\n<span translate=\"CONTENT.PREVIEW\">Preview</span></md-tooltip></md-button><div class=\"divider-vertical\" hide=\"\" \nshow-gt-sm=\"\"></div><md-button aria-label=\"Edit\" class=\"md-icon-button\" ng-click=\"vm.viewEditInline()\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.EDIT\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip hide show-gt-xs>\n<span translate=\"CONTENT.EDIT\">Edit</span></md-tooltip></md-button></div><div layout=\"row\" layout-align=\"end center\" \nng-if=\"vm.currentThread_Edit\" hide show-gt-xs><md-button type=\"submit\" ng-click=\"vm.saveItem(vm.currentThread_Edit)\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"vm.basicForm.$invalid || vm.basicForm.$pristine\" \naria-label=\"SAVE\" translate=\"CONTENT.SAVE\" translate-attr-aria-label=\"CONTENT.SAVE\">SAVE</md-button><md-button \ntype=\"button\" ng-click=\"vm.closeThreadEdit()\" class=\"md-raised md-warn\" aria-label=\"Cancel\">Cancel</md-button></div>\n<div layout=\"row\" layout-align=\"end center\" ng-if=\"vm.currentThread_Edit\" hide-gt-xs><md-button type=\"submit\" \nng-click=\"vm.saveItem(vm.currentThread_Edit)\" \nclass=\"md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme\" \nng-disabled=\"vm.basicForm.$invalid || vm.basicForm.$pristine\" aria-label=\"SAVE\"><md-icon md-font-icon=\"icon-check\" \nng-hide=\"vm.savingProcess\"></md-icon><md-progress-circular md-mode=\"indeterminate\" ng-if=\"vm.savingProcess\">\n</md-progress-circular><md-tooltip hide show-gt-xs><span translate=\"CONTENT.SAVE\">Save</span></md-tooltip></md-button>\n<md-button type=\"button\" ng-click=\"vm.closeThreadEdit()\" \nclass=\"md-warn md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme\" aria-label=\"Cancel\"><md-icon \nmd-font-icon=\"icon-window-close\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.CANCEL\">Cancel</span>\n</md-tooltip></md-button></div></div><md-content flex=\"\" ng-show=\"vm.selectedContent && !vm.editInline\"><div \nclass=\"mail-content file-details scrollable\" ms-scroll=\"vm.msScrollOptions\"><md-list><md-list-item class=\"info\" \nng-if=\"vm.selectedContent_refgrouped.header[0]\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\" \nlayout-align=\"start start\"><div ng-repeat=\"field in vm.selectedContent_refgrouped.header | orderBy:\'preview_sort\' \" \nclass=\"header-element\" layout=\"row\" layout-align=\"center center\"><div><span ng-if=\"field.type==\'user_status\'\"><button \nng-if=\"vm.selectedContent[field.title]===0\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\"></md-icon></button> <button \nng-if=\"vm.selectedContent[field.title]===1\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-minus-circle\" \nclass=\"on amber-400-fg s24\"></md-icon></button> <button ng-if=\"vm.selectedContent[field.title]===2\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\"></md-icon></button> \n<button \nng-if=\"vm.selectedContent[field.title]!==0 && vm.selectedContent[field.title]!==1 && vm.selectedContent[field.title]!==2\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"on grey-fg s24\"></md-icon></button> \n</span><span ng-if=\"field.type==\'dateHm\' || field.type==\'date\'\"><span>{{vm.selectedContent[field.title].dateShow}}\n</span> </span><span ng-if=\"field.type==\'language\'\" layout=\"row\" layout-align=\"center center\"><img \nclass=\"img-flag ng-scope\" alt=\"{{vm.siteLanguages(vm.selectedContent[field.title])[lang_name]}}\" \nng-src=\"assets/images/flags/{{vm.siteLanguages()[vm.selectedContent[field.title]].flag_code|lowercase}}.svg\"> </span>\n<span ng-if=\"field.type==\'id_subsec\' && vm.selectedContent[field.title].length!=0\"><span class=\"grey-500-fg\">\n{{field.field_name}} </span><span \nng-bind=\"vm.getReferencesSections(\'subsection\', field.type, vm.selectedContent[field.title])\"></span> </span><span \nng-if=\"field.type==\'id_cat\' && vm.selectedContent[field.title].length!=0\"><span class=\"grey-500-fg\">\n{{field.field_name}} </span><span \nng-bind=\"vm.getReferencesSections(\'cat\', field.type, vm.selectedContent[field.title])\"></span> </span><span \nng-if=\"field.type==\'id_subcat\' && vm.selectedContent[field.title].length!=0\"><span class=\"grey-500-fg\">\n{{field.field_name}} </span><span \nng-bind=\"vm.getReferencesSections(\'subcat\', field.type, vm.selectedContent[field.title])\"></span></span></div></div>\n</div></md-list-item><md-list-item class=\"main-item\"><div class=\"main-read\"><div class=\"avatar-container\"><div \nng-if=\"vm.selectedContent.avatar == \'\' || !vm.selectedContent.avatar\" class=\"avatar\" \nng-bind=\"vm.selectedContent[\'firstname\'] | capitalizeFirstLetter\" ms-random-class=\"vm.colors\"></div><media \nng-if=\"vm.selectedContent.avatar !== \'\'\" attachment=\"vm.selectedContent.avatar\" class=\"avatar fix\"></media><div \nng-repeat=\"field in vm.selectedContent_refgrouped.user_status | orderBy:\'preview_sort\' \" class=\"status\"><span \nng-if=\"field.type==\'user_status\'\"><button ng-if=\"vm.selectedContent[field.title]===0\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\"></md-icon></button> <button \nng-if=\"vm.selectedContent[field.title]===1\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-minus-circle\" \nclass=\"on amber-400-fg s24\"></md-icon></button> <button ng-if=\"vm.selectedContent[field.title]===2\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\"></md-icon></button> \n<button \nng-if=\"vm.selectedContent[field.title]!==0 && vm.selectedContent[field.title]!==1 && vm.selectedContent[field.title]!==2\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"on grey-fg s24\"></md-icon></button>\n</span></div></div></div><div class=\"main-read\" layout=\"column\" layout-align=\"center start \"><div \nng-repeat=\"field in vm.selectedContent_refgrouped.header_main | orderBy:\'preview_sort\' \" class=\"header-element\" \nlayout=\"row\" layout-align=\"center center\"><p ng-if=\"field.type==\'id\'\" class=\"font-size-14\"><span class=\"grey-500-fg\">\nID # </span><span class=\"grey-500-fg\" ng-bind=\"vm.selectedContent[field.title]\"></span></p></div><h1 class=\"name\">\n<strong ng-repeat=\"field in vm.selectedContent_refgrouped.main | orderBy:\'preview_sort\' \" \nng-bind=\"vm.selectedContent[field.title]\" class=\"mr-10\"></strong></h1></div><md-divider></md-divider></md-list-item>\n<div ng-repeat=\"field in vm.selectedContent_refgrouped.secondary | orderBy:\'preview_sort\' \"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg\" ng-if=\"field.type==\'label\'\"><h3 class=\"grey-700-fg\" ng-bind=\"field.field_name\">\n</h3><md-divider></md-divider></md-list-item><md-list-item flex=\"100\" ng-if=\"field.type!==\'label\'\" ng-switch=\"\" \non=\"field.type\"><div class=\"text-truncate\" ng-switch-when=\"html\"><div class=\"field\"><p \nclass=\"grey-500-fg font-size-14\" ng-bind=\"field.field_name\"></p><span class=\"font-size-16 text-truncate\" \nng-bind-html=\"vm.selectedContent[field.title]\"></span><br></div><md-divider></md-divider></div><div \nclass=\"text-truncate\" ng-switch-when=\"status\"><div class=\"field\"><p class=\"grey-500-fg font-size-14\" \nng-bind=\"field.field_name\"></p><span class=\"font-size-16 text-truncate {{vm.selectedContent[field.title]|yesNo}}\" \nng-bind-html=\"vm.selectedContent[field.title]|yesNo\"></span><br></div><md-divider></md-divider></div><div \nclass=\"text-truncate\" flex=\"100\" ng-switch-default=\"\"><div class=\"field\"><p class=\"grey-500-fg font-size-14\" \nng-bind=\"field.field_name\"></p><span \nng-if=\"field.category!=\'input_related\' && vm.isNumber(vm.selectedContent[field.title])\" \nclass=\"font-size-16 text-truncate\" ng-bind-html=\"vm.selectedContent[field.title]\"></span> <span \nng-if=\"field.category!=\'input_related\' && !vm.isNumber(vm.selectedContent[field.title])\" \nclass=\"font-size-16 text-truncate\" ng-bind-html=\"vm.selectedContent[field.title]| autoLinkerFilter\"></span> <span \nng-if=\"field.category==\'input_related\'\" class=\"font-size-16 text-truncate\">\n{{vm.getInArray(\'id_\'+field.config,field.values, vm.selectedContent[field.title], field.config)}}</span><br></div>\n<md-divider></md-divider></div></md-list-item></div><div ng-if=\"vm.selectedContent.tags\"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg\"><h3 class=\"grey-700-fg\" translate=\"CONTENT.ATTACHMENTS\">\nTags ({{vm.selectedContent.tags.length}})</h3><md-divider></md-divider></md-list-item><md-list-item><md-chips \nname=\"tag_name\" ng-model=\"vm.selectedContent.tags\" readonly=\"true\"><md-chip-template><span>\n{{$chip.tag_name}} #{{$chip.id_tag}}</span></md-chip-template></md-chips><md-divider></md-divider></md-list-item></div>\n<div ng-if=\"vm.selectedContent.Thumbnail\"><md-list-item class=\"md-toolbar-tools grey-100-bg\"><h3 class=\"grey-700-fg\" \ntranslate=\"CONTENT.ATTACHMENTS\">Attachments ({{vm.selectedContent.Thumbnail.length}})</h3><md-divider></md-divider>\n</md-list-item><md-list-item ng-repeat=\"zone in vm.mediaZones\" ng-if=\"vm.mediaZones\"><div class=\"attachments\"><div \nclass=\"field\"><p class=\"grey-500-fg font-size-14\">{{ zone.title }}</p><div class=\"attachment-list md-list-item-text\" \nlayout=\"row\" layout-wrap=\"\" layout-align=\"start start\"><div class=\"attachment\" \nng-repeat=\"attachment in vm.selectedContent.Thumbnail | filter: {\'id_zone\':zone.id_zone}\"><div \nclass=\"preview document\" layout=\"row\" layout-align=\"start center\" extension-class=\"{{attachment.filename}}\" \nng-href=\"{{attachment.permalink}}\" ng-if=\"attachment.media_type==3\" target=\"_blank\"><media attachment=\"attachment\">\n</media><a class=\"grey-1000-fg font-size-16\" ng-href=\"{{attachment.permalink}}\" target=\"_blank\"><span \nng-if=\"attachment.title\">{{attachment.title}} </span><span ng-if=\"attachment.filename\">{{attachment.filename}}</span>\n</a></div><div class=\"preview document\" layout=\"row\" layout-align=\"start center\" \nextension-class=\"{{attachment.filename}}\" ng-href=\"{{attachment.permalink}}\" ng-if=\"attachment.media_type==4\" \ntarget=\"_blank\"><media attachment=\"attachment\"></media><a class=\"grey-1000-fg font-size-16\" \nng-href=\"{{attachment.permalink}}\" target=\"_blank\"><span ng-if=\"attachment.filename\">{{attachment.filename}}</span></a>\n</div><div ng-if=\"attachment.media_type==1 || attachment.media_type==2\"><div class=\"ms-card\" flex \nmd-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"ms-card-content-wrapper\"><div class=\"template-9\"><div \nclass=\"media media-attachment\" flex layout=\"row\" layout-align=\"center center\"><div flex \nng-click=\"vm.openImageDialog($event, vm.selectedContent.Thumbnail, attachment)\"><media attachment=\"attachment\" \ncrop-format=\"{{zone.id_cropformats}}\"></media></div></div><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"size block\" layout=\"row\" layout-align=\"start center\"><strong \nclass=\"mr-5\">#{{attachment.id_media}}</strong> <span class=\"grey-500-fg\">| <span ng-if=\"attachment.filename\">\n{{attachment.filename}}</span> <span ng-if=\"attachment.title\">{{attachment.title}}</span></span></div><md-icon \nmd-font-icon=\"icon-eye\" class=\"s16 ml-10\" href=\"#\" \nng-click=\"vm.openImageDialog($event, vm.selectedContent.Thumbnail, attachment)\"></md-icon></div></div></div></div>\n</div></div></div></div></div></md-list-item><md-list-item ng-if=\"!vm.mediaZones\"><div class=\"attachments\"><div \nclass=\"field\"><p class=\"grey-500-fg font-size-14\" translate=\"CONTENT.NO_ZONE\"></p><div \nclass=\"attachment-list md-list-item-text\" layout=\"row\" layout-wrap=\"\" layout-align=\"start start\"><div \nclass=\"attachment\" ng-repeat=\"attachment in vm.selectedContent.Thumbnail | filter: {\'id_zone\':\'!\'}\"><div \nclass=\"preview document\" layout=\"row\" layout-align=\"start center\" extension-class=\"{{attachment.filename}}\" \nng-href=\"{{attachment.permalink}}\" ng-if=\"attachment.media_type==3\" target=\"_blank\"><media attachment=\"attachment\">\n</media><a class=\"grey-1000-fg font-size-16\" ng-href=\"{{attachment.permalink}}\" target=\"_blank\"><span \nng-if=\"attachment.title\">{{attachment.title}} </span><span ng-if=\"attachment.filename\">{{attachment.filename}}</span>\n</a></div><div class=\"preview document\" layout=\"row\" layout-align=\"start center\" \nextension-class=\"{{attachment.filename}}\" ng-href=\"{{attachment.permalink}}\" ng-if=\"attachment.media_type==4\" \ntarget=\"_blank\"><media attachment=\"attachment\"></media><a class=\"grey-1000-fg font-size-16\" \nng-href=\"{{attachment.permalink}}\" target=\"_blank\"><span ng-if=\"attachment.filename\">{{attachment.filename}}</span></a>\n</div><div ng-if=\"attachment.media_type==1 || attachment.media_type==2\"><div class=\"ms-card\" flex \nmd-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"ms-card-content-wrapper\"><div class=\"template-9\"><div \nclass=\"media media-attachment\" flex layout=\"row\" layout-align=\"center center\"><div flex \nng-click=\"vm.openImageDialog($event, vm.selectedContent.Thumbnail, attachment)\"><media attachment=\"attachment\" \ncrop-format=\"{{zone.id_cropformats}}\"></media></div></div><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"size block\" layout=\"row\" layout-align=\"start center\"><strong \nclass=\"mr-5\">#{{attachment.id_media}}</strong> <span class=\"grey-500-fg\">| <span ng-if=\"attachment.filename\">\n{{attachment.filename}}</span> <span ng-if=\"attachment.title\">{{attachment.title}}</span></span></div><md-icon \nmd-font-icon=\"icon-eye\" class=\"s16 ml-10\" href=\"#\" \nng-click=\"vm.openImageDialog($event, vm.selectedContent.Thumbnail, attachment)\"></md-icon></div></div></div></div>\n</div></div></div></div></div><md-divider></md-divider></md-list-item></div><md-list-item \nclass=\"md-toolbar-tools grey-100-bg\"><h3 class=\"grey-700-fg\" translate=\"CONTENT.LATESTACTIVITY\">Latest Activity</h3>\n<md-divider></md-divider></md-list-item><div class=\"activities\"><div class=\"activity\" layout=\"row\" \nlayout-align=\"start center\" ng-repeat=\"activity in vm.log | limitTo: vm.paginationLimit()\"><img \nalt=\"{{content.from.name}}\" class=\"avatar\" ng-if=\"activity.user.avatar\" ng-src=\"{{activity.username}}\"><div \nclass=\"avatar\" ng-if=\"!activity.user.avatar\" ng-style=\"{\'background-color\':activity.user.profile_color}\">\n{{activity.user.firstname[0] | capitalize}}</div><div layout=\"column\"><div><span class=\"username md-accent-color\" \nng-if=\"activity.user.firstname.length>0 || activity.user.lastname.length>0\">\n{{activity.user.firstname}} {{activity.user.lastname}} </span><span class=\"message\">{{activity.message}}</span></div>\n<span class=\"time secondary-text\">{{activity.date}}</span></div></div><button \nclass=\"md-raised md-button md-default-theme md-ink-ripple\" ng-click=\"vm.showMoreItems()\" \nng-show=\"vm.hasMoreItemsToShow()\"><span>Show more</span></button></div></md-list></div></md-content><md-content \nng-if=\"vm.editInline && vm.selectedContent\" ng-include=\"\'app/main/apps/tasks/views/read/edit-preview.html\'\" \nclass=\"scrollable\"></md-content></div>");
$templateCache.put("app/main/apps/tasks/views/read/read-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-if=\"vm.loadingReadPane\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nng-show=\"!vm.loadingReadPane\"><div class=\"mail-content\" layout=\"column\" layout-align=\"center center\" \nng-if=\"!vm.selectedContent\"><div class=\"content\" layout=\"column\" layout-align=\"top center\"><div class=\"message\">\n<md-icon md-font-icon=\"icon-email\" style=\"font-size: 50px\" \nclass=\"ng-scope md-default-theme md-font material-icons icon-email\" role=\"img\" aria-hidden=\"true\"></md-icon><br><hr \nstyle=\"color: white; border: 0\"><span style=\"margin-left: 20px; font-size: 20px; color: rgb(207, 204, 204)\">\nSelect a message to read</span></div></div></div><div class=\"toolbar grey-100-bg colored-bg\" layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"vm.selectedContent\" scroll=\"\"><div layout=\"row\" layout-align=\"start center\">\n<md-button class=\"md-icon-button close-thread\" aria-label=\"Back\" ng-click=\"vm.closeThread()\" \nng-if=\"vm.currentThread && (vm.currentView==\'nosplit\' || vm.groupsView) \" translate \ntranslate-attr-aria-label=\"CONTENT.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button>\n<md-button class=\"md-icon-button close-thread\" ng-if=\"vm.currentView === \'table\'\" aria-label=\"Back\" \nng-click=\"vm.closeThread()\" translate translate-attr-aria-label=\"CONTENT.BACK\"><md-icon \nmd-font-icon=\"icon-arrow-right\"></md-icon></md-button><div class=\"divider-vertical\" hide=\"\" \nng-if=\"vm.activeMailPaneIndex === 1 || vm.currentView === \'table\'\" show-gt-sm=\"\"></div><md-button aria-label=\"Preview\" \nclass=\"md-icon-button\" ng-click=\"vm.viewPreview()\" translate=\"\" translate-attr-aria-label=\"CONTENT.PREVIEW\"><md-icon \nmd-font-icon=\"icon-eye\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.PREVIEW\">Preview</span>\n</md-tooltip></md-button><div class=\"divider-vertical\" hide=\"\" show-gt-sm=\"\"></div><md-button aria-label=\"Edit\" \nclass=\"md-icon-button\" ng-class=\"{\'md-accent\':vm.currentTab == \'edit\'}\" ng-click=\"vm.viewEditInline();\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.EDIT\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip hide show-gt-xs>\n<span translate=\"CONTENT.EDIT\">Edit</span></md-tooltip></md-button><div class=\"divider-vertical\" hide=\"\" show-gt-sm=\"\">\n</div><md-button aria-label=\"Activity\" class=\"md-icon-button\" ng-class=\"{\'md-accent\':vm.currentTab == \'activity\'}\" \nng-click=\"vm.currentTab = \'activity\'\" translate=\"\" translate-attr-aria-label=\"Activities\"><md-icon \nmd-font-icon=\"icon-run\"></md-icon><md-tooltip><span translate=\"ACCOUNTS.ACTIVITY\"></span></md-tooltip></md-button><div \nng-if=\"vm.loginUrl\" class=\"divider-vertical\" hide=\"\" show-gt-sm=\"\"></div><md-button ng-if=\"vm.loginUrl\" \naria-label=\"Login to website\" class=\"md-icon-button\" ng-click=\"vm.loginToWebsite(vm.selectedContent)\" translate=\"\" \ntranslate-attr-aria-label=\"GLOBAL.LOGIN_TO_WEBSITE\"><md-icon md-font-icon=\"icon-web\"></md-icon><md-tooltip><span \ntranslate=\"GLOBAL.LOGIN_TO_WEBSITE\"></span></md-tooltip><p ng-if=\"vm.loginUrl\"><a \nng-click=\"vm.loginToWebsite(vm.selectedContent)\"><md-icon md-font-icon=\"icon-web\" class=\"m-0\"></md-icon><span \nclass=\"font-size-15\" translate=\"GLOBAL.LOGIN_TO_WEBSITE\"></span></a></p></md-button></div><div layout=\"row\" \nlayout-align=\"end center\" ng-if=\"vm.currentThread_Edit && vm.currentTab !== \'activity\'\"><md-button type=\"submit\" \nng-click=\"vm.saveItem(vm.currentThread_Edit)\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.basicForm.$invalid || vm.basicForm.$pristine\" aria-label=\"SAVE\" translate=\"CONTENT.SAVE\" \ntranslate-attr-aria-label=\"CONTENT.SAVE\">SAVE</md-button><md-button type=\"button\" ng-click=\"vm.closeThreadEdit()\" \nclass=\"md-raised md-warn\" aria-label=\"Cancel\">Cancel</md-button></div></div><md-content flex=\"\" \nng-show=\"vm.selectedContent && !vm.editInline && vm.currentTab === \'edit\'\"><div \nclass=\"mail-content file-details scrollable\" ms-scroll=\"vm.msScrollOptions\"><md-list><md-list-item class=\"main-item\" \nstyle=\"padding: 20px 100px 20px 26px;position: relative\"><div class=\"main-read\" layout=\"column\" \nlayout-align=\"center start \"><div \nng-repeat=\"field in vm.selectedContent_refgrouped.header_main | orderBy:\'preview_sort\' \" class=\"header-element\" \nlayout=\"row\" layout-align=\"center center\"><p ng-if=\"field.type==\'id\'\" class=\"font-size-14\"><span class=\"grey-500-fg\">\nID # </span><span class=\"grey-500-fg\" ng-bind=\"vm.selectedContent[field.title]\"></span></p></div><h1 class=\"name\">\n<strong ng-repeat=\"field in vm.selectedContent_refgrouped.main | orderBy:\'preview_sort\' \" \nng-bind=\"vm.selectedContent[field.title]\" class=\"mr-10\"></strong></h1><div class=\"main-read\" \nng-repeat=\"field in vm.selectedContent_refgrouped.secondary\"><span \nng-if=\"field.type==\'due_date\' || field.type==\'date\'\"><span>{{dateTime}}</span></span></div></div><div \nclass=\"main-read\" style=\"margin: -10px 0 0 0;position: absolute;right: 10px\"><span><span>{{vm.selectedContent.status}}\n</span> </span><span></span> <button ng-if=\"vm.selectedContent.status===1\" class=\"md-icon-button md-button\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"off green-fg s24\"></md-icon></button> <button \nng-if=\"vm.selectedContent.status===0\" class=\"md-icon-button md-button\"><md-icon md-font-icon=\"icon-minus-circle\" \nclass=\"on amber-400-fg s24\"></md-icon></button></div><md-divider></md-divider></md-list-item><md-list-item flex=\"100\" \nng-if=\"field.type!==\'label\'\" ng-switch=\"\" on=\"field.type\"><div class=\"text-truncate\" flex=\"100\"><div \nclass=\"avatar-container\"><div class=\"main-read\" layout=\"column\" layout-align=\"center start\" \nstyle=\"position: relative; height: 60px;\r\n                            margin-top: 10px\"><div \nng-if=\"vm.taskUser.avatar == \'\' || !vm.taskUser.avatar\" class=\"avatar {{vm.selectedColor}}\" \nstyle=\"position:  absolute\" ng-bind=\"vm.taskUser[\'first_name\'] | capitalizeFirstLetter\"></div><div \nng-if=\"vm.taskUser.avatar\" class=\"avatar {{vm.selectedColor}}\" style=\"position:  absolute\"><img \nsrc=\"{{vm.taskUser.avatar}}\"></div><div class=\"author-name\" style=\"display: inline-block; padding-left: 66px\"><strong \nclass=\"mr-10\">{{vm.taskUser.first_name}} {{vm.taskUser.last_name}} </strong><br><span class=\"font-size-12\" \nng-bind-html=\"vm.timeAgo(vm.tasksMessages.data[0].date)\"></span></div></div><div style=\"overflow: auto; height: 200px\">\n<div style=\"clear: both\" \nng-repeat=\"msg in vm.tasksMessages.data | orderBy: \'-\' | limitTo: vm.tasksMessages.data.length - 1\"><span \nclass=\"message-new text-truncate\" style=\"font-size: 16px; margin: 20px 0\">{{msg.message}}</span><div \nng-repeat=\"images in msg.Thumbnail\" class=\"text-truncate\" \nstyle=\"float: left; width: 100px; margin-right: 15px; margin-bottom: 20px\"><span \nng-repeat=\"image in images.cropstatus\"><h6 style=\"margin-bottom:12px; margin-top: 0\"><strong>\n{{$parent.$index == 0 ? \'Attachments (\'+ msg.Thumbnail.length+\')\':\'&nbsp;\' }}</strong></h6><img \nstyle=\"margin-bottom: 10px; height:  100px; width: auto\" src=\"{{image.container.view_url}}{{image.fileName}}\" \nwidth=\"auto\" height=\"auto\"> <a style=\"font-size:14px; font-weight: normal\" \nhref=\"{{image.container.view_url}}{{image.fileName}}\" target=\"_blank\">View</a><br><a \nstyle=\"font-size:14px; font-weight: normal\" href=\"#\">Download </a><br><p \nstyle=\"font-size:12px; font-weight: normal; margin-top: 0px\">(1.1Mb)</p></span></div><hr \nstyle=\"clear: both; margin-right: 2%;border: 0.5px solid; height: 1px ;border-color:#DEDEDE\"></div><div \nstyle=\"clear: both\"><p style=\"font-size: 16px\"><strong>{{vm.tasksMessages.data[0].message}}</strong></p><div \nng-repeat=\"images in vm.tasksMessages.data[0].Thumbnail\" class=\"text-truncate\" \nstyle=\"width: 100px; margin-right: 15px; margin-bottom: 20px; float: left\"><span \nng-repeat=\"image in images.cropstatus\"><h6 style=\"margin-bottom:12px; margin-top: 0\"><strong>\n{{$parent.$index == 0 ? \'Attachments (\'+ vm.tasksMessages.data[0].Thumbnail.length+\')\':\'&nbsp;\' }}</strong></h6><img \nstyle=\"margin-bottom: 10px; height:  100px; width: auto\" src=\"{{image.container.view_url}}{{image.fileName}}\" \nwidth=\"auto\" height=\"auto\"> <a style=\"font-size:14px; font-weight: normal\" \nhref=\"{{image.container.view_url}}{{image.fileName}}\" target=\"_blank\">View</a><br><a id=\"alink\" \nstyle=\"font-size:14px; font-weight: normal\" href=\"#\">Download</a><br><p \nstyle=\"font-size:12px; font-weight: normal; margin-top: 0px\">(1.1Mb)</p></span></div></div></div>&nbsp;</div></div>\n</md-list-item><md-list-item style=\"position: fixed;  bottom: 0; width: 48%\"><div \nclass=\"form-group has-success has-feedback\" \nstyle=\"position: fixed; bottom: 0; left: 0; width: 100%;height: auto;border-radius: 35px;box-shadow: inset 2px -2px rgba(0,0,0,0.3);padding: 12px 60px 14px 30px;position: relative\">\n<input id=\"textMessage\" name=\"textMessage\" ng-model=\"vm.textMessage\" type=\"text\" class=\"form-control\" \nplaceholder=\"Type your message\" style=\"width:100%\"><md-icon md-font-icon=\"icon-send\" \nstyle=\"font-size: 24px; position: absolute; right: 22px; top:8px\" \nclass=\"form-control-feedback ng-scope md-default-theme md-font material-icons icon-send form-control-feedback\" \nrole=\"img\" aria-hidden=\"true\" ng-click=\"vm.send(vm.textMessage, vm.selectedContent[\'id_crm_tasks\'])\"></md-icon><md-icon\n md-font-icon=\"icon-attachment\" style=\"font-size: 24px; position: absolute; right: 56px; top:8px\" \nclass=\"form-control-feedback ng-scope md-default-theme md-font material-icons icon-attachment form-control-feedback\" \nrole=\"img\" aria-hidden=\"true\" ng-click=\"vm.attach($event, \'\', vm.tasksMessages.data[0])\"></md-icon></div>\n</md-list-item><div ng-if=\"vm.selectedContent.Thumbnail\"><md-list-item ng-repeat=\"zone in vm.mediaZones\" \nng-if=\"vm.mediaZones\"><div class=\"attachments\"><div class=\"field\"><p class=\"grey-500-fg font-size-14\">{{ zone.title }}\n</p><div class=\"attachment-list md-list-item-text\" layout=\"row\" layout-wrap=\"\" layout-align=\"start start\"><div \nclass=\"attachment\" ng-repeat=\"attachment in vm.selectedContent.Thumbnail | filter: {\'id_zone\':zone.id_zone}\"><div \nclass=\"preview document\" layout=\"row\" layout-align=\"start center\" extension-class=\"{{attachment.filename}}\" \nng-href=\"{{attachment.permalink}}\" ng-if=\"attachment.media_type==3\" target=\"_blank\"><media attachment=\"attachment\">\n</media><a class=\"grey-1000-fg font-size-16\" ng-href=\"{{attachment.permalink}}\" target=\"_blank\"><span \nng-if=\"attachment.title\">{{attachment.title}} </span><span ng-if=\"attachment.filename\">{{attachment.filename}}</span>\n</a></div><div class=\"preview document\" layout=\"row\" layout-align=\"start center\" \nextension-class=\"{{attachment.filename}}\" ng-href=\"{{attachment.permalink}}\" ng-if=\"attachment.media_type==4\" \ntarget=\"_blank\"><media attachment=\"attachment\"></media><a class=\"grey-1000-fg font-size-16\" \nng-href=\"{{attachment.permalink}}\" target=\"_blank\"><span ng-if=\"attachment.filename\">{{attachment.filename}}</span></a>\n</div><div ng-if=\"attachment.media_type==1 || attachment.media_type==2\"><div class=\"ms-card\" flex \nmd-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"ms-card-content-wrapper\"><div class=\"template-9\"><div \nclass=\"media media-attachment\" flex layout=\"row\" layout-align=\"center center\"><div flex \nng-click=\"vm.openImageDialog($event, vm.selectedContent.Thumbnail, attachment)\"><media attachment=\"attachment\" \ncrop-format=\"{{zone.id_cropformats}}\"></media></div></div><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"size block\" layout=\"row\" layout-align=\"start center\"><strong \nclass=\"mr-5\">#{{attachment.id_media}}</strong> <span class=\"grey-500-fg\">| <span ng-if=\"attachment.filename\">\n{{attachment.filename}}</span> <span ng-if=\"attachment.title\">{{attachment.title}}</span></span></div><md-icon \nmd-font-icon=\"icon-eye\" class=\"s16 ml-10\" href=\"#\" \nng-click=\"vm.openImageDialog($event, vm.selectedContent.Thumbnail, attachment)\"></md-icon></div></div></div></div>\n</div></div></div></div></div></md-list-item><md-list-item ng-if=\"!vm.mediaZones\"><div class=\"attachments\"><div \nclass=\"field\"><p class=\"grey-500-fg font-size-14\" translate=\"CONTENT.NO_ZONE\"></p><div \nclass=\"attachment-list md-list-item-text\" layout=\"row\" layout-wrap=\"\" layout-align=\"start start\"><div \nclass=\"attachment\" ng-repeat=\"attachment in vm.selectedContent.Thumbnail | filter: {\'id_zone\':\'!\'}\"><div \nclass=\"preview document\" layout=\"row\" layout-align=\"start center\" extension-class=\"{{attachment.filename}}\" \nng-href=\"{{attachment.permalink}}\" ng-if=\"attachment.media_type==3\" target=\"_blank\"><media attachment=\"attachment\">\n</media><a class=\"grey-1000-fg font-size-16\" ng-href=\"{{attachment.permalink}}\" target=\"_blank\"><span \nng-if=\"attachment.title\">{{attachment.title}} </span><span ng-if=\"attachment.filename\">{{attachment.filename}}</span>\n</a></div><div class=\"preview document\" layout=\"row\" layout-align=\"start center\" \nextension-class=\"{{attachment.filename}}\" ng-href=\"{{attachment.permalink}}\" ng-if=\"attachment.media_type==4\" \ntarget=\"_blank\"><media attachment=\"attachment\"></media><a class=\"grey-1000-fg font-size-16\" \nng-href=\"{{attachment.permalink}}\" target=\"_blank\"><span ng-if=\"attachment.filename\">{{attachment.filename}}</span></a>\n</div><div ng-if=\"attachment.media_type==1 || attachment.media_type==2\"><div class=\"ms-card\" flex \nmd-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"ms-card-content-wrapper\"><div class=\"template-9\"><div \nclass=\"media media-attachment\" flex layout=\"row\" layout-align=\"center center\"><div flex \nng-click=\"vm.openImageDialog($event, vm.selectedContent.Thumbnail, attachment)\"><media attachment=\"attachment\" \ncrop-format=\"{{zone.id_cropformats}}\"></media></div></div><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"size block\" layout=\"row\" layout-align=\"start center\"><strong \nclass=\"mr-5\">#{{attachment.id_media}}</strong> <span class=\"grey-500-fg\">| <span ng-if=\"attachment.filename\">\n{{attachment.filename}}</span> <span ng-if=\"attachment.title\">{{attachment.title}}</span></span></div><md-icon \nmd-font-icon=\"icon-eye\" class=\"s16 ml-10\" href=\"#\" \nng-click=\"vm.openImageDialog($event, vm.selectedContent.Thumbnail, attachment)\"></md-icon></div></div></div></div>\n</div></div></div></div></div><md-divider></md-divider></md-list-item></div><div class=\"activities\"><div \nclass=\"activity\" layout=\"row\" layout-align=\"start center\" \nng-repeat=\"activity in vm.log | limitTo: vm.paginationLimit()\"><img alt=\"{{content.from.name}}\" class=\"avatar\" \nng-if=\"activity.user.avatar\" ng-src=\"{{activity.username}}\"><div class=\"avatar\" ng-if=\"!activity.user.avatar\" \nng-style=\"{\'background-color\':activity.user.profile_color}\">{{activity.user.firstname[0] | capitalize}}</div><div \nlayout=\"column\"><div><span class=\"username md-accent-color\" \nng-if=\"activity.user.firstname.length>0 || activity.user.lastname.length>0\">\n{{activity.user.firstname}} {{activity.user.lastname}} </span><span class=\"message\">{{activity.message}}</span></div>\n<span class=\"time secondary-text\">{{activity.date}}</span></div></div><button \nclass=\"md-raised md-button md-default-theme md-ink-ripple\" ng-click=\"vm.showMoreItems()\" \nng-show=\"vm.hasMoreItemsToShow()\"><span>Show more</span></button></div></md-list></div></md-content><md-content \nng-if=\"vm.editInline && vm.selectedContent && vm.currentTab === \'edit\'\" \nng-include=\"\'app/main/apps/tasks/views/read/edit-preview.html\'\" class=\"scrollable\"></md-content><md-content \nng-if=\"vm.currentTab === \'activity\'\" ng-include=\"\'app/main/apps/tasks/views/read/timeline.html\'\"></md-content></div>");
$templateCache.put("app/main/apps/tasks/views/read/tab-edit.html","<div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><form name=\"vm.basicForm\" class=\"md-inline-form\" novalidate><div\n ng-repeat=\"fields in vm.currentThread_ref\"><md-list-item class=\"md-toolbar-tools grey-100-bg\" \nng-if=\"fields.type==\'label\'\"><h3 class=\"grey-700-fg\" ng-bind=\"fields.field_name\"></h3></md-list-item>\n<md-input-container class=\"md-block\" ng-if=\"fields.type==\'id_subsec\'\" flex><label ng-bind=\"fields.field_name\"></label>\n<md-select ng-model=\"vm.currentThread_Edit[fields.type]\" placeholder=\"{{vm.currentThread_Edit[fields.field_name]}}\">\n<md-option value=\"\">---</md-option><md-option ng-repeat=\"opt in vm.getValuesReferencesSections(\'subsection\')\" \nvalue=\"{{opt.id_subsec}}\">{{opt.subsec}}</md-option></md-select><div class=\"md-errors-spacer\"></div>\n</md-input-container><md-input-container class=\"md-block\" ng-if=\"fields.type==\'id_cat\'\" flex><label \nng-bind=\"fields.field_name\"></label><md-select ng-model=\"vm.currentThread_Edit[fields.type]\" \nplaceholder=\"{{vm.currentThread_Edit[fields.field_name]}}\"><md-option value=\"\">---</md-option><md-option \nng-repeat=\"opt in vm.getValuesReferencesSections(\'cat\')\" value=\"{{opt.id_cat}}\">{{opt.cat}}</md-option></md-select><div\n class=\"md-errors-spacer\"></div></md-input-container><md-input-container class=\"md-block\" \nng-if=\"fields.type==\'id_subcat\'\" flex><label ng-bind=\"fields.field_name\"></label><md-select \nng-model=\"vm.currentThread_Edit[fields.type]\" placeholder=\"{{vm.currentThread_Edit[fields.field_name]}}\"><md-option \nvalue=\"\">---</md-option><md-option ng-repeat=\"opt in vm.getValuesReferencesSections(\'subcat\')\" \nvalue=\"{{opt.id_subcat}}\">{{opt.subcat}}</md-option></md-select><div class=\"md-errors-spacer\"></div>\n</md-input-container><md-input-container class=\"md-block\" ng-if=\"fields.category==\'input_related\'\" flex><label \nng-bind=\"fields.field_name\"></label><md-select ng-model=\"vm.currentThread_Edit[fields.title]\" \nplaceholder=\"{{vm.currentThread_Edit[fields.field_name]}}\"><md-option value=\"\">---</md-option><md-option \nng-repeat=\"opt in fields.values\" ng-value=\"opt.id_{{fields.config}}\">{{opt[fields.config]}}</md-option></md-select><div\n class=\"md-errors-spacer\"></div></md-input-container><md-input-container class=\"md-block\" ng-if=\"fields.type==\'text\'\" \nflex><label ng-bind=\"fields.field_name\"></label><textarea ng-model=\"vm.currentThread_Edit[fields.title]\" columns=\"1\" \nrows=\"1\"></textarea></md-input-container><div ng-if=\"fields.type==\'user_status\'\" class=\"ml-10\"><md-button \nng-if=\"vm.selectedContent[fields.title]===0\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\"></md-icon></md-button><md-button \nng-if=\"vm.selectedContent[fields.title]===1\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-minus-circle\" \nclass=\"on amber-400-fg s24\"></md-icon></md-button><md-button ng-if=\"vm.selectedContent[fields.title]===2\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\"></md-icon>\n</md-button><md-button \nng-if=\"vm.selectedContent[fields.title]!==0 && vm.selectedContent[fields.title]!==1 && vm.selectedContent[fields.title]!==2\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"on grey-fg s24\"></md-icon></md-button>\n</div><md-input-container class=\"md-block\" ng-if=\"fields.type==\'status\'\" flex><md-checkbox class=\"no-label\" \naria-label=\"{{fields.field_name}}\" ng-model=\"vm.currentThread_Edit[fields.title]\" ng-true-value=\"1\" ng-false-value=\"0\">\n{{fields.field_name}}</md-checkbox></md-input-container><md-input-container class=\"md-block on-off\" \nng-if=\"fields.type==\'onoff\'\" flex><button ng-if=\"vm.currentThread_Edit[fields.title] ===1\" \nclass=\"md-icon-button md-button\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\" \nng-click=\"vm.toggleItemStatusEdit(fields.title)\"></md-icon></button> <button \nng-if=\"vm.currentThread_Edit[fields.title] !==1\" class=\"md-icon-button md-button\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\" \nng-click=\"vm.toggleItemStatusEdit(fields.title)\"></md-icon></button></md-input-container><md-input-container \nclass=\"md-block\" ng-if=\"fields.type==\'language\'\" flex><label ng-bind=\"fields.field_name\"></label><md-select \nng-model=\"vm.currentThread_Edit[fields.title]\" placeholder=\"{{vm.currentThread_Edit[fields.field_name]}}\"><md-option \nvalue=\"\">---</md-option><md-option ng-repeat=\"opt in vm.siteLanguages()\" value=\"{{opt.id_lang}}\">{{opt.lang_name}}\n</md-option></md-select><div class=\"md-errors-spacer\"></div></md-input-container><md-input-container class=\"md-block\" \nng-if=\"fields.type==\'single\'\"><label ng-bind=\"fields.field_name\"></label><input type=\"text\" name=\"{{fields.title}}\" \nng-disabled=\"fields.edit_editable != 1\" ng-model=\"vm.currentThread_Edit[fields.title]\" \nplaceholder=\"{{fields.field_name}}\"></md-input-container><div layout=\"column\" layout-gt-sm=\"column\" \nclass=\"date-time-picker\" ng-if=\"fields.type==\'dateHm\' || fields.type==\'date\'\"><div flex><label \nng-bind=\"fields.field_name\"></label></div><div layout=\"column\" layout-gt-sm=\"row\"><div flex class=\"date-container\">\n<fieldset ng-disabled=\"fields.edit_editable != 1\"><mdp-date-picker mdp-placeholder=\"Date\" \nmdp-format=\"{{vm.dateFormat}}\" mdp-open-on-click=\"true\" ng-model=\"vm.currentThread_Edit[fields.title].date\" \nng-change=\"vm.updateDatePicker(fields.title)\"></mdp-date-picker></fieldset></div><div flex class=\"date-container\">\n<fieldset ng-disabled=\"fields.edit_editable != 1\"><mdp-time-picker mdp-placeholder=\"Time\" mdp-auto-switch=\"true\" \nmdp-open-on-click=\"true\" ng-model=\"vm.currentThread_Edit[fields.title].date\" ng-disabled=\"fields.edit_editable != 1\" \nng-change=\"vm.updateDatePicker(fields.title)\"></mdp-time-picker></fieldset></div><div flex class=\"date-container\">\n<md-input-container class=\"md-block\"><label>UTC Date</label><input type=\"text\" ng-disabled=\"fields.edit_editable != 1\" \nng-model=\"vm.currentThread_Edit[fields.title].utcShow\" disabled=\"disabled\"></md-input-container></div></div></div>\n<md-input-container class=\"md-block\" flex ng-if=\"fields.type==\'country\'\"><label ng-bind=\"fields.field_name\"></label>\n<md-select ng-model=\"vm.currentThread_Edit.country\" placeholder=\"{{fields.field_name}}\"><md-option value=\"\">---\n</md-option><md-option ng-repeat=\"country in vm.countriesWithStates\" ng-bind=\"country.name\" ng-value=\"country.id\" \nng-selected=\"country.id == vm.currentThread_Edit.country\"></md-option></md-select><div class=\"md-errors-spacer\"></div>\n</md-input-container><md-input-container class=\"md-block\" flex ng-if=\"fields.type==\'state\'\"><label \nng-bind=\"fields.field_name\"></label><md-select ng-model=\"vm.currentThread_Edit.state\" \nplaceholder=\"{{fields.field_name}}\" ng-disabled=\"!vm.currentThread_Edit.country\"><md-option value=\"\">---</md-option>\n<md-option ng-repeat=\"state in vm.statesWithCities\" ng-bind=\"state.name\" ng-value=\"state.id\" \nng-selected=\"state.id == vm.currentThread_Edit.state\"></md-option></md-select><div class=\"md-errors-spacer\"></div>\n</md-input-container><md-input-container class=\"md-block\" flex ng-if=\"fields.type==\'city\'\"><label \nng-bind=\"fields.field_name\"></label><md-select ng-model=\"vm.currentThread_Edit.city\" \nplaceholder=\"{{fields.field_name}}\" ng-disabled=\"!vm.currentThread_Edit.state\"><md-option value=\"\">---</md-option>\n<md-option ng-repeat=\"city in vm.cities\" ng-bind=\"city.city\" ng-value=\"city.id_city\" \nng-selected=\"city.id_city == vm.currentThread_Edit.city\"></md-option></md-select><div class=\"md-errors-spacer\"></div>\n</md-input-container><md-input-container flex class=\"md-block md-input-has-value\" ng-if=\"fields.type==\'html\'\"><label \nng-bind=\"fields.field_name\"></label><textarea ui-tinymce=\"vm.tinymceOptions\" \nng-model=\"vm.currentThread_Edit[fields.title]\" aria-label=\"{{fields.title}}\"></textarea></md-input-container></div><div\n layout=\"row\"><md-list flex=\"100\" class=\"md-toolbar-tools grey-100-bg\" layout=\"row\" layout-align=\"end center\"><div>\n<md-button type=\"submit\" ng-if=\"vm.currentThread_Edit\" ng-click=\"vm.saveItem(vm.currentThread_Edit)\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"vm.basicForm.$invalid || vm.basicForm.$pristine\" \naria-label=\"SAVE\" translate=\"CONTENT.SAVE\" translate-attr-aria-label=\"CONTENT.SAVE\">SAVE</md-button><md-button \ntype=\"button\" ng-click=\"vm.closeThreadEdit()\" class=\"md-raised md-warn\" aria-label=\"Cancel\">Cancel</md-button></div>\n</md-list></div></form></div>");
$templateCache.put("app/main/apps/tasks/views/read/tab-media.html","<md-list-item class=\"list-media-item attachment-edit\"><div class=\"attachments\"><div class=\"field\"><p \nclass=\"grey-500-fg ml-8\">Avatar</p><div class=\"attachment-list sortable md-list-item-text\"><div class=\"attachment\" \nlayout=\"column\" ng-show=\"vm.currentThread_Edit.avatar\"><div class=\"preview document\" layout=\"row\" \nlayout-align=\"start center\" extension-class=\"{{vm.currentThread_Edit.avatar.filename}}\" \nng-href=\"{{vm.currentThread_Edit.avatar.permalink}}\" ng-if=\"vm.currentThread_Edit.avatar.media_type==3\" \ntarget=\"_blank\"><a class=\"grey-1000-fg font-size-16\" ng-href=\"{{vm.currentThread_Edit.avatar.permalink}}\" \ntarget=\"_blank\"><span ng-if=\"vm.currentThread_Edit.avatar.title\">{{vm.currentThread_Edit.avatar.title}}</span> <span \nng-if=\"vm.currentThread_Edit.avatar.filename\">{{vm.currentThread_Edit.avatar.filename}}</span></a></div><div \nng-if=\"vm.currentThread_Edit.avatar.media_type==1 || vm.currentThread_Edit.avatar.media_type==2 || vm.currentThread_Edit.avatar.media_type==4\">\n<div class=\"ms-card\" flex md-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"ms-card-content-wrapper\"><div \nclass=\"template-9\"><div class=\"media\" flex layout=\"row\" layout-align=\"center center\" \nng-if=\"vm.currentThread_Edit.avatar.media_type==1 || vm.currentThread_Edit.avatar.media_type==2\"><media \nattachment=\"vm.currentThread_Edit.avatar\" class=\"image\" ng-click=\"vm.openImageDialog($event, mediazone, $index)\">\n</media></div><div flex layout=\"column\" layout-align=\"center center\" class=\"media\" \nng-if=\"vm.currentThread_Edit.avatar.media_type==4\"><qiu-icon mediafile=\"vm.currentThread_Edit.avatar.filename\" \nclassextra=\"s56\"></qiu-icon><br><span class=\"grey-500-fg\" layout=\"column\" layout-align=\"center center\"><span \nng-if=\"vm.currentThread_Edit.avatar.title\"><strong>{{vm.currentThread_Edit.avatar.title}}</strong> </span><span \nng-if=\"vm.currentThread_Edit.avatar.filename\">{{vm.currentThread_Edit.avatar.filename}}</span></span></div><div \nclass=\"header\" layout=\"row\" layout-align=\"space-between center\"><div class=\"size block\" layout=\"row\" \nlayout-align=\"start center\"><strong class=\"mr-5\">#{{vm.currentThread_Edit.avatar.id_media}}</strong> <span \nclass=\"grey-500-fg\" ng-if=\"vm.currentThread_Edit.avatar.media_type==1 || vm.currentThread_Edit.avatar.media_type==2\">\n{{vm.currentThread_Edit.avatar.filename}}</span></div><md-menu><button class=\"md-icon-button\" aria-label=\"More\" \ntranslate translate-attr-aria-label=\"TODO.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\" \nng-click=\"$mdMenu.open($event)\"></md-icon></button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-if=\"vm.currentThread_Edit.avatar.media_type==1 || vm.currentThread_Edit.avatar.media_type==2\" \nng-click=\"vm.openImageDialog($event, mediazone, $index)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.PREVIEW\"><md-icon md-font-icon=\"icon-eye\" class=\"ml-10\" href=\"#\" \nng-click=\"vm.openImageDialog($event, mediazone, $index)\"></md-icon><span translate=\"CONTENT.PREVIEW\">Preview</span>\n</md-button><md-button ng-if=\"vm.currentThread_Edit.avatar.media_type==4\" \nng-click=\"vm.openUrl(vm.currentThread_Edit.avatar.permalink)\" target=\"_blank\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.PREVIEW\"><md-icon md-font-icon=\"icon-open-in-new\" class=\"ml-10\"></md-icon><span \ntranslate=\"CONTENT.OPEN\">Open</span></md-button></md-menu-item><md-menu-item \nng-if=\"vm.currentThread_Edit.avatar.media_type==1\"><md-button ng-click=\"vm.openFocalPoint($event, mediazone, $index)\" \naria-label=\"Toggle done\" translate-attr-aria-label=\"CONTENT.SET_FOCAL_POINT\"><md-icon \nmd-font-icon=\"icon-image-filter-center-focus\" class=\"s18\"></md-icon><span translate=\"CONTENT.SET_FOCAL_POINT\">\nSet Focal point</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.openMediaItemMetadata($event, mediazone, $index)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.MEDIA_ITEM_EDIT_METADATA\"><md-icon md-font-icon=\"icon-message-image\" class=\"s18\">\n</md-icon><span translate=\"CONTENT.MEDIA_ITEM_EDIT_METADATA\">Edit Metadata</span></md-button></md-menu-item>\n<md-menu-item ng-if=\"vm.currentThread_Edit.avatar.media_type==1\"><md-button \nng-click=\"vm.MediaItemRecrop(vm.currentThread_Edit.avatar,mediazone, $index)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.MEDIA_ITEM_RECROP\"><md-icon md-font-icon=\"icon-image\" class=\"s18\"></md-icon><span \ntranslate=\"CONTENT.MEDIA_ITEM_RECROP\">Recrop Image</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.deleteAttachment(mediazone, $index)\" aria-label=\"Toggle done\" translate-attr-aria-label=\"CONTENT.REMOVE\">\n<md-icon md-font-icon=\"icon-close\" class=\"s18\"></md-icon><span translate=\"CONTENT.REMOVE\">Remove</span></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></div></div></div><md-button \nclass=\"add-event-button no-sort md-fab md-warn\" ng-click=\"vm.mediaDialog($event, mediazone, vm.currentThread_Edit)\" \naria-label=\"Add event\" translate translate-attr-aria-label=\"CALENDAR.ADD_EVENT\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon></md-button></div></div><md-divider></md-divider></md-list-item>");
$templateCache.put("app/main/apps/tasks/views/read/tab-users-groups.html","<form novalidate><div class=\"group-form\"><div ng-repeat=\"item in vm.currentLabelsEdit track by $index\" class=\"tag\" \nfxlayout=\"row\" fxlayoutalign=\"start center\"><div class=\"tag-label\">{{item.label}}<md-icon \nng-click=\"vm.deleteTargetEdit(item.group, $index)\" md-font-icon=\"icon-close\" class=\"s24 pointer\"></md-icon></div></div>\n</div></form><form class=\"md-inline-form\" novalidate><div class=\"group-form\"><md-button \nng-click=\"vm.openUsersGroupsDialog()\" class=\"add-event-button md-fab md-warn\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon></md-button><span></span></div></form>");
$templateCache.put("app/main/apps/tasks/views/read/timeline.html","<div id=\"users-activity\" class=\"page-layout simple fullwidth mail-content content-edit scrollable\" layout=\"column\">\n<md-list-item class=\"main-item\"><div class=\"main-read\"><div class=\"avatar-container\"><div \nng-if=\"vm.selectedContent.avatar == \'\' || !vm.selectedContent.avatar\" class=\"avatar {{vm.selectedColor}}\" \nng-bind=\"vm.selectedContent[\'firstname\'] | capitalizeFirstLetter\"></div><media \nng-if=\"vm.selectedContent.avatar !== \'\'\" attachment=\"vm.selectedContent.avatar\" class=\"avatar fix\"></media><div \nng-repeat=\"field in vm.selectedContent_refgrouped.user_status | orderBy:\'preview_sort\' \" class=\"status\"><span \nng-if=\"field.type==\'user_status\'\"><button ng-if=\"vm.selectedContent[field.title]===0\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\"></md-icon></button> <button \nng-if=\"vm.selectedContent[field.title]===1\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-minus-circle\" \nclass=\"on amber-400-fg s24\"></md-icon></button> <button ng-if=\"vm.selectedContent[field.title]===2\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\"></md-icon></button> \n<button \nng-if=\"vm.selectedContent[field.title]!==0 && vm.selectedContent[field.title]!==1 && vm.selectedContent[field.title]!==2\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"on grey-fg s24\"></md-icon></button>\n</span></div></div></div><div class=\"main-read\" layout=\"column\" layout-align=\"center start \"><div \nng-repeat=\"field in vm.selectedContent_refgrouped.header_main | orderBy:\'preview_sort\' \" class=\"header-element\" \nlayout=\"row\" layout-align=\"center center\"><p ng-if=\"field.type==\'id\'\" class=\"font-size-14\"><span class=\"grey-500-fg\">\nID # </span><span class=\"grey-500-fg\" ng-bind=\"vm.selectedContent[field.title]\"></span></p></div><h1 class=\"name\">\n<strong ng-repeat=\"field in vm.selectedContent_refgrouped.main | orderBy:\'preview_sort\' \" \nng-bind=\"vm.selectedContent[field.title]\" class=\"mr-10\"></strong></h1></div><md-divider></md-divider></md-list-item>\n<div ng-if=\"vm.userAuditTrailEvents.length > 0\" \nng-repeat=\"(key, value) in vm.userAuditTrailEvents | groupBy: \'dateWithoutHours\'\"><div class=\"date\">{{ key }}</div><div\n id=\"timeline\" ng-repeat=\"event in value\" class=\"timeline-left ms-timeline\"><div class=\"ms-timeline-item\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><div \nclass=\"timeline-point md-accent-bg\"><md-icon md-font-icon=\"icon-telegram\"></md-icon></div><div class=\"timeline-detail\" \nlayout=\"row\" layout-align=\"start center\"><h3 class=\"name mt-0 mb-0 ml-5\" flex-xs=\"80\"><div class=\"event\">\n{{vm.translate(\'USERS.\'+event.action_id.toUpperCase())}} <a target=\"_blank\" href=\"{{event.action_brief.link}}\">\n{{event.action_brief.name}}</a></div></h3><div class=\"timeline-detail\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"time\" ng-bind-html=\"vm.timeAgo(event.date)\"></div></div></div></div></div></div><div \nng-if=\"vm.userAuditTrailEvents.length === 0\" class=\"content\" layout=\"column\" layout-align=\"top center\"><div \nclass=\"message\" translate=\"USERS.NO_ACTIVITY\"></div></div></div>");
$templateCache.put("app/main/apps/tags/views/list/list-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-show=\"isLoading\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nclass=\"mail-list-item filter-selected\" id=\"list-view1\" layout=\"row\" layout-align=\"start center\"><div class=\"info\" flex>\n<div class=\"name\" layout=\"row\" layout-align=\"start center\"><md-icon \nng-if=\"!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 1\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-font-icon=\"icon-folder\" aria-hidden=\"true\"></md-icon>\n<md-icon ng-if=\"vm.selectedGroup.children && vm.selectedGroup.id_group_type == 1\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-font-icon=\"icon-folder-multiple\" aria-hidden=\"true\">\n</md-icon><md-icon ng-if=\"!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 2\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-font-icon=\"qiu-icon-file-usermailing\" aria-hidden=\"true\">\n</md-icon><md-icon ng-if=\"vm.selectedGroup.children && vm.selectedGroup.id_group_type == 2\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-svg-src=\"/assets/icons/svg/icon-folder-mail-multiple.svg\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 3\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-font-icon=\"qiu-icon-file-usermediacenter\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"vm.selectedGroup.children && vm.selectedGroup.id_group_type == 3\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-svg-src=\"/assets/icons/svg/icon-folder-play-multiple.svg\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 4\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-font-icon=\"qiu-icon-file-usersegment\" aria-hidden=\"true\">\n</md-icon><md-icon ng-if=\"vm.selectedGroup.children && vm.selectedGroup.id_group_type == 4\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-svg-src=\"/assets/icons/svg/icon-folder-share-multiple.svg\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 5\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-font-icon=\"qiu-icon-file-userstore\" aria-hidden=\"true\">\n</md-icon><md-icon ng-if=\"vm.selectedGroup.children && vm.selectedGroup.id_group_type == 5\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-svg-src=\"/assets/icons/svg/icon-folder-shop-multiple.svg\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 6\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-font-icon=\"qiu-icon-file-useracreditation\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"vm.selectedGroup.children && vm.selectedGroup.id_group_type == 6\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-svg-src=\"/assets/icons/svg/icon-folder-board-multiple.svg\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 7\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-svg-src=\"/assets/icons/svg/icon-folder-chat.svg\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"vm.selectedGroup.children && vm.selectedGroup.id_group_type == 7\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-svg-src=\"/assets/icons/svg/icon-folder-chat-multiple.svg\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 8\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-font-icon=\"icon-folder-remove\" aria-hidden=\"true\">\n</md-icon><md-icon ng-if=\"vm.selectedGroup.children && vm.selectedGroup.id_group_type == 8\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-font-icon=\"icon-folder-multiple\" aria-hidden=\"true\">\n</md-icon><div class=\"title text-truncate\" layout=\"row\" layout-align=\"start center\">{{vm.selectedGroup.name}} <span \nng-if=\"!isLoading\">({{pagination_totalItems | number}}<span ng-if=\"vm.selectedGroup.raw_settings.max_allowed_users\">\n {{ \'USERS.OF\' | translate}} {{vm.selectedGroup.raw_settings.max_allowed_users}}</span>)</span></div></div></div><div \nlayout=\"row\" class=\"mr-20 in-group-status-filter\" layout-align=\"start center\"><md-select \nng-model=\"vm.selectedTagFilter\" ng-change=\"vm.changeSelectedFilterTag()\" placeholder=\"Tag type filter\"><md-option \nvalue=\"0\">Tag filter</md-option><md-option ng-repeat=\"type in vm.tagsTypes\" value=\"{{type.name}}\" \nng-style=\"{\'background\': status.color || \'\'}\">{{type.name}}</md-option></md-select></div><div layout=\"row\" \nclass=\"mr-20 in-group-status-filter\" layout-align=\"start center\"><md-select ng-model=\"vm.statusFilter\" \nng-change=\"vm.changeStatusFilter()\" placeholder=\"Status filter\"><md-option value=\"null\">Status filter</md-option>\n<md-option value=\"{{status.status}}\" ng-repeat=\"status in vm.verifyStatus\">{{status.name}}</md-option></md-select>\n</div><md-icon ng-if=\"vm.selectedGroup\" md-font-icon=\"icon-close s20\" ng-click=\"vm.unselectGroups()\" class=\"ml-10\">\n<md-tooltip hide show-gt-xs><span translate=\"CONTENT.DESELECT_GROUP\">Deselect group</span></md-tooltip></md-icon></div>\n<div class=\"mail-list-item filter-selected\" \nng-if=\"(vm.selectedGroupsAcc && vm.selectedGroupsAcc.length > 0) || (vm.selectedGroupsAccSub && vm.selectedGroupsAccSub.length > 0)\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"info\" flex><div class=\"name\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"title text-truncate\" layout=\"row\" layout-align=\"start center\">\n{{vm.selectedGroupsAcc[0].name}} <span \nng-if=\"!isLoading && (!vm.selectedGroupsAccSub || !vm.selectedGroupsAccSub.length > 0)\">\n({{pagination_totalItems | number}}<span ng-if=\"vm.selectedGroupsAcc[0].raw_settings.max_allowed_users\">\n {{ \'USERS.OF\' | translate}} {{vm.selectedGroupsAcc[0].raw_settings.max_allowed_users}}</span>)</span></div><div \nclass=\"title text-truncate\" layout=\"row\" layout-align=\"start center\"><span class=\"ml-5\" \nng-if=\"vm.selectedGroupsAcc && vm.selectedGroupsAcc.length > 0 && vm.selectedGroupsAccSub && vm.selectedGroupsAccSub.length > 0\">\n> </span><span>{{vm.selectedGroupsAccSub[0].name}} <span \nng-if=\"!isLoading && vm.selectedGroupsAccSub && vm.selectedGroupsAccSub.length > 0\">({{pagination_totalItems | number}}\n<span ng-if=\"vm.selectedGroupsAcc[0].raw_settings.max_allowed_users\">\n {{ \'USERS.OF\' | translate}} {{vm.selectedGroupsAcc[0].raw_settings.max_allowed_users}}</span>)</span></span></div>\n</div></div><div ng-if=\"!vm.selectedGroupsAcc[0].parent\" layout=\"row\" class=\"mr-20 in-group-status-filter\" \nlayout-align=\"start center\"><md-select ng-model=\"vm.selectedIngroupStatus\" \nng-change=\"vm.changeSelectedIngroupStatus()\" placeholder=\"Status filter\"><md-option value=\"0\" \ntranslate=\"USERS.INGROUP.STATUS.ALL\"></md-option><md-option ng-repeat=\"status in vm.ingroupStatus\" \nng-if=\"vm.showStatus(status)\" value=\"{{status.id_ingroup_status}}\" \ntranslate=\"USERS.INGROUP.STATUS.{{status.name | uppercase}}\" ng-style=\"{\'background\': status.color || \'\'}\"></md-option>\n</md-select></div><div class=\"buttons\" layout=\"row\" layout-align=\"start center\"><md-icon \nng-if=\"!vm.selectedGroupsAccSub[0].is_qiu_restricted\" md-font-icon=\"icon-close s20\" ng-click=\"vm.unselectGroups()\" \nclass=\"ml-10\"><md-tooltip hide show-gt-xs><span translate=\"CONTENT.DESELECT_GROUP\">Deselect group</span></md-tooltip>\n</md-icon></div></div><div class=\"mail-list-item filter-selected\" ng-if=\"sortField\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"info\" \nng-if=\"sortField\"><div class=\"name\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-sort-ascending\" class=\"s20 mr-5 ml-0 mb-0\" ng-if=\"sortDir === \'ASC\'\"></md-icon><md-icon \nmd-font-icon=\"icon-sort-descending\" class=\"s20 mr-5 ml-0 mb-0\" ng-if=\"sortDir === \'DESC\'\"></md-icon><div \nclass=\"title text-truncate\" layout=\"row\" layout-align=\"start center\"><span translate=\"CONTENT.ORDER_BY\"></span>\n \'{{sortField}}\'</div></div></div></div><div class=\"buttons\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-close s20\" ng-click=\"pagination_resetOrderBy()\" class=\"ml-10\"><md-tooltip hide show-gt-xs><span \ntranslate=\"CONTENT.REMOVE\"></span></md-tooltip></md-icon></div></div><div class=\"mail-list-item filter-selected\" \nng-if=\"$root.pagination_searchquery==true\" layout=\"row\" layout-align=\"start center\"><div class=\"info\" flex><div \nclass=\"name\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-filter\" class=\"s20 mr-8 ml-0 mb-0\" \naria-hidden=\"true\"></md-icon><div class=\"title\" layout=\"row\" layout-align=\"start center\"><div \nng-repeat=\"filterable in refFilterables track by $index\" class=\"inline-block\"><div \nng-repeat=\"label in filterable.values | filterInArray:filterable.selected:\'value\' track by $index\" \nclass=\"mr-5 tag-list inline-block\"><span class=\"grey-50-fg\">{{label.name}}</span></div></div></div><div \nclass=\"title text-truncate pl-10\" layout=\"row\" layout-align=\"start center\" ng-if=\"$root.modelSearch\">\n{{$root.modelSearch}}</div></div></div><div class=\"buttons\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-close s20\" ng-click=\"$root.pagination_resetquery()\" class=\"ml-10\"><md-tooltip hide show-gt-xs><span \ntranslate=\"CONTENT.REMOVE_FILTERS\">Remove filters</span></md-tooltip></md-icon></div></div><div class=\"no-threads\" \nng-if=\"!isLoading && vm.threads.length === 0\" ng-hide=\"isLoading\">There are no items!</div><div id=\"list-content-data\" \nng-style=\"{\'opacity\' : isLoading ? 0.2 : 1}\"><div class=\"mail-list-item {{thread.status}}\" \nng-repeat=\"thread in vm.threads | filter: vm.search | filter: global.search\" md-no-ink \nng-click=\"vm.openThread(thread)\" \nng-class=\"{\'starred\': thread.starred, \'selected\': vm.selectedContentID === thread.id_tag, \'checked\': vm.isChecked(thread)}\">\n<div layout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-label\" ng-checked=\"vm.isSelected(thread)\" \nng-click=\"vm.toggleSelectThread(thread, $event)\" aria-label=\"{{vm.isSelected(thread) ? \'Deselect\' : \'Select\'}}\">\n</md-checkbox><div class=\"info\" flex layout=\"column\"><div ng-if=\"refcolumnsgrouped.main\"><div \nclass=\"subject text-truncate grey-500-fg\"><span ng-repeat=\"field in refcolumnsgrouped.header | orderBy: \'list_sort\'\">\n<span ng-if=\"field.type == \'id\'\">#</span> <span ng-if=\"field.type == \'dateHm\' || field.type == \'date\'\" \nng-bind=\"vm.showDate(tag[field.titleId])\"></span> <span ng-if=\"field.type != \'dateHm\' && field.type != \'date\'\" \nng-bind=\"tag.{{field.titleId}}\"></span></span></div></div><div ng-if=\"refcolumnsgrouped.main\"><div \nclass=\"name text-truncate\" layout=\"row\" layout-align=\"start center\"><span ng-repeat=\"field in refcolumnsgrouped.main\">\n<span ng-bind=\"thread.{{field.titleId}}\"></span>&nbsp;</span></div></div><span \nclass=\"name text-truncate layout-align-start-center layout-row\" ng-bind=\"thread.tag_name\"></span></div><div \nclass=\"buttons\" layout=\"row\" layout-align=\"start center\"><div><button ng-if=\"thread.verify===0\" class=\"md-icon-button\" \nng-click=\"vm.updateTagStatus($event, thread, 1)\"><md-icon md-font-icon=\"icon-checkbox-blank-circle-outline\" \nclass=\"off red-fg s24\"></md-icon><md-tooltip><span translate=\"TAGS.VERIFY_0\">UNVERIFIED</span></md-tooltip></button> \n<button ng-if=\"thread.verify===1\" class=\"md-icon-button\" ng-click=\"vm.updateTagStatus($event, thread, 2)\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\"></md-icon><md-tooltip><span \ntranslate=\"TAGS.VERIFY_1\">VERIFIED</span></md-tooltip></button> <button ng-if=\"thread.verify===2\" \nclass=\"md-icon-button\" ng-click=\"vm.updateTagStatus($event, thread, 0)\"><md-icon md-font-icon=\"icon-close-circle\" \nclass=\"on grey-600-fg s24\"></md-icon><md-tooltip><span translate=\"TAGS.VERIFY_2\">REJECTED</span></md-tooltip></button>\n</div></div></div></div><div class=\"toolbar\" layout=\"row\" layout-align=\"end center\"><div layout=\"row\" \nlayout-align=\"center center\" ng-style=\"{\'display\' : isLoading ? \'none\' : \'block\'}\"><span class=\"page-info\">\n{{pagination_totalItems}} items found.</span><md-button aria-label=\"Previous\" class=\"md-icon-button arrow\" \nng-click=\"pagination_prevPage()\" ng-disabled=\"pagination_firstPage()\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span \ntranslate=\"CONTENT.PREVIOUS\">Previous</span></md-tooltip></md-button><span class=\"page-info\">\n{{pagination_page}} / {{pagination_total_pages}}</span><md-button aria-label=\"Next\" class=\"md-icon-button arrow\" \nng-click=\"pagination_nextPage()\" ng-disabled=\"pagination_morePages()\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span \ntranslate=\"CONTENT.NEXT\">Next</span></md-tooltip></md-button></div></div></div>");
$templateCache.put("app/main/apps/tags/views/list/nosplit-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/tags/views/list/toolbar.html\'\" ng-hide=\"vm.currentThread || vm.currentThread_Edit\"></div>\n<div class=\"content-wrapper\" flex=\"\" layout=\"row\"><div class=\"content thread-detail mail-read-pane\" flex=\"\" \nid=\"thread-detail\" ms-scroll=\"vm.msScrollOptions\" ng-if=\"vm.currentThread || vm.currentThread_Edit\" \nng-include=\"\'app/main/apps/tags/views/read/read-view-nosplit.html\'\"></div><div \nclass=\"content thread-list mail-list-pane scrollable\" flex=\"\" ms-scroll=\"vm.msScrollOptions\" id=\"thread-list\" \nng-if=\"!vm.currentThread && !vm.currentThread_Edit\" ng-include=\"\'app/main/apps/tags/views/list/list-view.html\'\"></div>\n</div>");
$templateCache.put("app/main/apps/tags/views/list/split-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/tags/views/list/toolbar.html\'\"></div><div class=\"content-wrapper\" flex=\"\" layout=\"row\"><div \nclass=\"content thread-list mail-list-pane scrollable\" flex=\"50\" id=\"thread-list\" ms-scroll=\"vm.msScrollOptions\" \nng-include=\"\'app/main/apps/tags/views/list/list-view.html\'\"></div><div class=\"content thread-detail mail-read-pane\" \nflex=\"50\" id=\"thread-detail\" layout=\"column\" ng-include=\"\'app/main/apps/tags/views/read/read-view.html\'\"></div></div>");
$templateCache.put("app/main/apps/tags/views/list/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-label\" \naria-label=\"{{vm.selectedThreads.length > 0 ? \'Deselect All\' : \'Select All\'}}\" \nng-checked=\"vm.selectedThreads.length > 0\" ng-click=\"vm.toggleSelectThreads()\"></md-checkbox><div \nclass=\"divider-vertical\" hide=\"\" show-gt-xs=\"\"></div><md-button aria-label=\"ADD NEW\" \nclass=\"md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme\" hide show-gt-sm \nng-click=\"vm.newThread()\" translate=\"CONTENT.ADD\" type=\"button\">Add new</md-button><md-button aria-label=\"ADD NEW\" \nclass=\"md-fab md-mini md-accent green-500-bg md-raised md-ink-ripple md-default-theme\" hide-gt-sm \nng-click=\"vm.newThread()\" type=\"button\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><div \nng-if=\"!vm.showQiuGroupsSidenav\" class=\"divider-vertical\" hide show-gt-xs></div><button \nng-if=\"!vm.showQiuGroupsSidenav\" aria-label=\"view group\" class=\"md-button md-icon-button\" \nng-click=\"vm.toggleQiuGroupsSidenav()\" translate translate-attr-aria-label=\"CONTENT.VIEW_GROUPS\"><md-icon \nmd-font-icon=\"icon-folder-multiple\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.VIEW_GROUPS\">\nView Groups</span></md-tooltip></button><md-button ng-if=\"!vm.selectedGroup && vm.showAddToGroupsButton()\" \nqiu-groups-add-selected-items-dialog qiu-groups-membership-id-field=\"\'id_social_account\'\" \nqiu-groups-membership-selected-items=\"[]\" qiu-groups-nested=\"vm.groups\" \nqiu-groups-membership-mass-insert=\"vm.massInsertIntoGroups\" class=\"md-icon-button\" aria-label=\"Add\" \ntranslate-attr-aria-label=\"QIU_GROUPS.ADD_TO_GROUPS\"><md-icon md-font-icon=\"icon-folder-account\"></md-icon><md-tooltip \nhide show-gt-xs><span translate=\"QIU_GROUPS.ADD_TO_GROUPS\"></span></md-tooltip></md-button><md-button \nng-if=\"vm.selectedGroup && vm.showRemoveFromGroupsButton() && !vm.selectedGroup.is_qiu_restricted_root\" \nqiu-groups-remove-selected-items-dialog qiu-groups-membership-id-field=\"\'id_social_account\'\" \nqiu-groups-membership-selected-items=\"vm.selectedThreads\" qiu-groups-membership-selected-group=\"vm.selectedGroup\" \nqiu-groups-membership-remove=\"vm.removeFromGroup\" class=\"md-icon-button\" aria-label=\"Remove\" \ntranslate-attr-aria-label=\"QIU_GROUPS.REMOVE_FROM_GROUP\"><md-icon md-font-icon=\"icon-folder-remove\"></md-icon>\n<md-tooltip hide show-gt-xs><span translate=\"QIU_GROUPS.REMOVE_FROM_GROUP\"></span></md-tooltip></md-button><div \nclass=\"divider-vertical\" hide=\"\" show-gt-xs=\"\"></div><div aria-hidden=\"false\" \nclass=\"action-buttons hide show-gt-xs layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\" \nng-show=\"vm.selectedThreads.length > 0\"><md-button ng-click=\"vm.massActions(\'duplicate\')\" aria-label=\"Duplicate\" \nclass=\"md-icon-button\" hide=\"\" show-gt-sm=\"\" translate=\"\" translate-attr-aria-label=\"CONTENT.DUPLICATE\"><md-icon \nmd-font-icon=\"icon-content-duplicate\"></md-icon><md-tooltip><span translate=\"CONTENT.DUPLICATE\">Duplicate</span>\n</md-tooltip></md-button><md-button ng-click=\"vm.massActions(\'delete\')\" aria-label=\"Delete\" class=\"md-icon-button\" \nhide=\"\" show-gt-sm=\"\" translate=\"\" translate-attr-aria-label=\"CONTENT.DELETE\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon><md-tooltip><span translate=\"CONTENT.DELETE\">Delete</span></md-tooltip></md-button><div \nclass=\"divider-vertical\" hide=\"\" show-gt-xs=\"\"></div></div><ms-search-bar debounce=\"300\" \nmodel-search=\"$root.pagination_searchquery\" on-result-click=\"vm.searchResultClick(item)\" on-search=\"vm.search(query)\" \nlayout=\"row\" layout-align=\"start center\"></ms-search-bar><md-button aria-label=\"view type\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'main-sidenav\')\" translate=\"\" translate-attr-aria-label=\"CONTENT.FILTERS\"><md-icon \nmd-font-icon=\"icon-filter\"></md-icon><md-tooltip><span translate=\"CONTENT.FILTERS\">Filters</span></md-tooltip>\n</md-button><div class=\"divider-vertical\" hide=\"\" show-gt-xs=\"\"></div><md-button aria-label=\"Sort Direction\" \nclass=\"md-icon-button\" hide=\"\" ng-click=\"sortable.order == \'DESC\' ? sortable.order =\'ASC\' : sortable.order = \'DESC\'\" \nng-disabled=\"!sortable\" show-gt-xs=\"\" translate=\"\" translate-attr-aria-label=\"TODO.SORT_DIRECTION\"><md-icon \nmd-font-icon=\"icon-sort-ascending\" ng-if=\"sortable.order !== \'ASC\'\"></md-icon><md-icon \nmd-font-icon=\"icon-sort-descending\" ng-if=\"sortable.order === \'ASC\'\"></md-icon></md-button><md-menu hide=\"\" \nshow-gt-xs=\"\"><button aria-label=\"Filters\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" show-gt-xs=\"\" \ntranslate=\"\" translate-attr-aria-label=\"CONTENT.FILTERS\"><md-icon md-font-icon=\"icon-chevron-down\"><md-tooltip><span \ntranslate=\"CONTENT.ORDER_BY\">Order</span></md-tooltip></md-icon></button><md-menu-content width=\"4\"><md-menu-item \nng-repeat=\"sortfield in refSortables\"><md-button aria-label=\"All\" ng-click=\"pagination_setOrderBy(sortfield)\"><div \nlayout=\"row\" layout-align=\"space-between center\"><span>Order by {{sortfield.name}} </span><i class=\"icon-check s16\" \nng-if=\"sortfield.titleId == sortable.titleId\"></i></div></md-button></md-menu-item><md-menu-divider ng-if=\"sortable\">\n</md-menu-divider><md-menu-item ng-if=\"sortable\"><md-button aria-label=\"Remove sort\" \nng-click=\"pagination_resetOrderBy()\"><md-icon md-font-icon=\"icon-close \"></md-icon><span>Remove order</span>\n</md-button></md-menu-item></md-menu-content></md-menu><md-button aria-label=\"view type\" class=\"md-icon-button\" \nhide=\"\" ng-click=\"vm.changeView(\'split\')\" ng-if=\"vm.currentView === \'grid\'\" show-gt-sm=\"\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.LIST_VIEW\"><md-icon md-font-icon=\"icon-view-headline\"></md-icon><md-tooltip><span \ntranslate=\"CONTENT.LIST_VIEW\">List View</span></md-tooltip></md-button></div><div layout=\"row\" \nlayout-align=\"start center\" translate-attr-aria-label=\"CONTENT.REFRESH\"><span class=\"page-info\" hide=\"\" show-gt-xs=\"\">\n{{pagination_totalItems}} items found.</span><md-button aria-label=\"Previous\" class=\"md-icon-button arrow\" hide=\"\" \nng-click=\"pagination_prevPage()\" ng-disabled=\"pagination_firstPage()\" show-gt-xs=\"\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span \ntranslate=\"CONTENT.PREVIOUS\">Previous</span></md-tooltip></md-button><span class=\"page-info\" hide=\"\" show-gt-xs=\"\">\n{{pagination_page}} / {{pagination_total_pages}}</span><md-button aria-label=\"Next\" class=\"md-icon-button arrow\" \nhide=\"\" ng-click=\"pagination_nextPage()\" ng-disabled=\"pagination_morePages()\" show-gt-xs=\"\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span \ntranslate=\"CONTENT.NEXT\">Next</span></md-tooltip></md-button><md-menu class=\"settings-menu\" hide-gt-xs \nng-show=\"vm.selectedThreads.length > 0\"><md-button aria-label=\"Settings\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\" translate=\"\" translate-attr-aria-label=\"CONTENT.SETTINGS\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content><md-menu-item \nshow=\"vm.selectedMail.length > 0 || vm.allChecked\"><md-button ng-click=\"vm.massActions(\'duplicate\')\" \naria-label=\"Duplicate\" translate-attr-aria-label=\"CONTENT.DUPLICATE\"><md-icon md-font-icon=\"icon-content-duplicate\">\n</md-icon><span translate=\"CONTENT.DUPLICATE\">Duplicate </span><span translate=\"CONTENT.SELECTED\">Selected</span>\n</md-button></md-menu-item><md-menu-item show=\"vm.selectedMail.length > 0 || vm.allChecked\"><md-button \nng-click=\"vm.massActions(\'delete\')\" aria-label=\"Delete\" translate-aria-label=\"CONTENT.DELETE\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><span translate=\"CONTENT.DELETE\">Delete </span><span translate=\"CONTENT.SELECTED\">\nSelected</span></md-button></md-menu-item></md-menu-content></md-menu></div>");
$templateCache.put("app/main/apps/tags/views/grid/grid-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/tags/views/list/toolbar.html\'\"></div><div class=\"content-wrapper\" flex=\"\" layout=\"row\"><div \nclass=\"mail-tabs-grid\" flex=\"\" md-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"content mail-list-pane-grid\" \nflex=\"\" ms-scroll=\"\"><md-progress-circular md-mode=\"indeterminate\" ng-if=\"isLoading\"></md-progress-circular><div \nclass=\"no-threads\" ng-hide=\"isLoading\" ng-if=\"!isLoading && vm.inbox.length === 0\">There are no items!</div><ms-card \nng-model=\"mail\" ng-repeat=\"thread in vm.threads | filter: vm.search | filter: global.search\" \ntemplate=\"\'app/main/apps/tags/views/grid/template-grid-1.html\'\"></ms-card></div></div></div>");
$templateCache.put("app/main/apps/tags/views/grid/template-grid-1.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"space-between center\" flex><div \nlayout=\"column\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-attachment\" class=\"has-attachment s24\" \nng-if=\"thread.Thumbnail.length>0\"></md-icon><button ng-if=\"thread.onoff===1\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\"></md-icon></button> <button \nng-if=\"thread.onoff!==1\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-blank-circle-outline\" \nclass=\"off red-fg s24\"></md-icon></button></div><div layout=\"column\" layout-align=\"start center\"><md-checkbox \nclass=\"no-label\" ng-checked=\"vm.isChecked(mail)\" ng-click=\"vm.toggleCheck(mail, $event)\" \naria-label=\"{{vm.isChecked(mail)? \'Uncheck\':\'check\'}}\"></md-checkbox><div ng-if=\"refcolumnsgrouped.main\"><div \nclass=\"subject text-truncate\"><span ng-repeat=\"field in refcolumnsgrouped.header | orderBy: \'list-sort\'\" \nng-bind=\"thread.{{field.titleId}}\"></span></div></div></div></div><div class=\"media\" flex layout=\"row\" \nlayout-align=\"center center\">{{refcolumnsgrouped | json}}<div \nng-repeat=\"field in refcolumnsgrouped.left_center | orderBy:\'list_sort\'\" \nng-if=\"field.type == \'thumbnail_square\' || field.type == \'thumbnail_\'\"><img class=\"avatar square ng-scope\" \nalt=\"{{listImage.filename}}\" ng-if=\"thread.Thumbnail.length>0\" \nng-src=\"{{listImage.cropstatus[0].container.view_url}}{{listImage.cropstatus[0].fileName}}\" \nng-repeat=\"listImage in thread.Thumbnail | filter: {\'id_zone\':field.showtype} | limitTo:1\"> <img \nclass=\"avatar square ng-scope\" alt=\"No Image\" ng-if=\"(thread.Thumbnail|filter:{\'id_zone\':field.showtype}).length == 0\" \nng-src=\"assets/images/common/no_image_available_10.png\"></div><img class=\"image\" \nng-src=\"{{card.Thumbnail[0].crop_status[0].urlformed}}\" alt=\"{{card.media.image.alt}}\" imageonloadcontrol></div><div \nclass=\"header p-16\" layout=\"row\" layout-align=\"start\"><div class=\"info\" flex layout=\"column\"><div \nng-if=\"refcolumnsgrouped.main\"><div class=\"name text-truncate\" layout=\"row\" layout-align=\"start center\"><span \nng-repeat=\"field in refcolumnsgrouped.main\"><span ng-bind=\"thread.{{field.titleId}}\"></span>&nbsp;</span></div></div>\n<div><div class=\"name text-truncate\" layout=\"row\" layout-align=\"start center\"><span><span>Title</span></span></div>\n</div><div><div class=\"details\" layout=\"row\" layout-align=\"start start\"><div layout=\"column\"><span class=\"title\">label\n</span></div><div layout=\"column\" class=\"text-truncate\"><span class=\"detail\">name</span></div></div></div><div \nng-repeat=\"field in refcolumnsgrouped.secondary | orderBy:\'list_sort\'\"><div \nng-if=\"(field.type!==\'date\' && field.type!==\'dateHm\') && field.primary!==1\" class=\"details\" layout=\"row\" \nlayout-align=\"start start\"><div layout=\"column\"><span class=\"title\" ng-bind=\"field.title\"></span></div><div \nlayout=\"column\" class=\"text-truncate\"><span class=\"detail\" ng-bind=\"thread.{{field.titleId}}\"></span></div></div></div>\n</div></div></div>");
$templateCache.put("app/main/apps/tags/views/grid/template-grid.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s20\" ng-if=\"card.onoff===1\"></md-icon><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s20\" ng-if=\"card.onoff===0\"></md-icon><div \nclass=\"info\"><div class=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.Thumbnail[0].crop_status[0].urlformed}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.Thumbnail[0].crop_status[0]\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/main/apps/users/dialogs/export/export-dialog.html","<md-dialog class=\"export-dialog\" aria-label=\"New Message\"><form class=\"md-inline-form\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between\"><h1 class=\"title\" \ntranslate=\"USERS.EXPORT_USERS\"></h1><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll flex><div layout=\"row\" layout-align=\"start center\"><md-select flex placeholder=\"Select template\" \nclass=\"ph-15\" ng-model=\"vm.templateSelected\"><md-option value=\"\">--</md-option><md-option \nng-repeat=\"template in vm.templates\" ng-value=\"template\">{{template.name}}</md-option></md-select><md-button \nng-disabled=\"!vm.templateSelected\" type=\"submit\" class=\"send-button md-accent md-raised\" \nng-click=\"vm.loadTemplate($event)\" translate=\"USERS.LOAD_TEMPLATE\"></md-button></div><div class=\"list-item-header\" \nlayout=\"row\" layout-align=\"start center\"><h3 class=\"pl-15\" ng-if=\"vm.isFullGroup && !vm.isMultipleGroup()\">\n{{ \'USERS.GROUPS_TO_EXPORT\' | translate}}: {{ vm.selectedGroup.name}}</h3><h3 class=\"pl-15\" \nng-if=\"vm.isFullGroup && vm.isMultipleGroup()\">{{ \'USERS.GROUPS_TO_EXPORT\' | translate}}:<div class=\"ml-5\" \nng-repeat=\"group in vm.selectedGroup\">{{ group.name}}</div></h3><h3 class=\"pl-15\" ng-if=\"vm.allUsers\">\n{{ \'USERS.TOTAL_USERS_TO_EXPORT\' | translate}}: {{vm.totalItems}}</h3><h3 class=\"pl-15\" \nng-if=\"!vm.isFullGroup && !vm.allUsers\">{{ \'USERS.TOTAL_USERS_TO_EXPORT\' | translate}}: {{vm.usersToExport.length}}\n</h3></div><div class=\"list-item\" layout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-label\" \naria-label=\"{{vm.selectedFields.length> 0 ? \'Deselect All\' : \'Select All\'}}\" ng-checked=\"vm.selectedFields.length > 0\" \nng-click=\"vm.toggleSelectFields()\"></md-checkbox><div class=\"text-left\" translate=\"USERS.SELECT_FIELDS_TO_EXPORT\">\n</div></div><div dragula=\"\'fields\'\" dragula-model=\"vm.refcolumns\"><div class=\"list-item drag-export\" \nng-repeat=\"field in vm.refcolumns\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-checkbox class=\"no-label\" ng-checked=\"vm.isSelected(field)\" \nng-click=\"vm.toggleSelectField(field, $event)\" aria-label=\"{{vm.isSelected(field) ? \'Deselect\' : \'Select\'}}\">\n</md-checkbox><div ng-bind=\"field.field_name\"></div><md-icon style=\"margin-right: 0px\" class=\"drag icon-equal\" \naria-label=\"DRAG\"></md-icon></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"!vm.loading\"><div flex layout=\"row\" layout-align=\"start center\"><md-button \nng-disabled=\"vm.selectedFields.length == 0\" type=\"submit\" class=\"send-button md-accent md-raised\" \nng-click=\"vm.saveTemplate($event)\" translate=\"USERS.SAVE_TEMPLATE\"></md-button></div><div flex layout=\"row\" \nlayout-align=\"end center\"><md-button type=\"button\" class=\"md-raised md-warn\" ng-click=\"vm.closeDialog()\" \ntranslate=\"GROUP.CANCEL\"></md-button><md-button ng-disabled=\"vm.selectedFields.length == 0\" type=\"submit\" \nclass=\"send-button md-accent md-raised\" ng-click=\"vm.exportAndCloseDialog()\" translate=\"USERS.EXPORT\"></md-button>\n</div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/tags/views/read/edit-preview.html","<div id=\"tags-edit\" class=\"page-layout simple fullwidth mail-content content-edit\" layout=\"column\"><md-tabs><md-tab \nlabel=\"Edit\"><div layout=\"row\" ng-include=\"\'app/main/apps/tags/views/read/tab-edit.html\'\"></div></md-tab></md-tabs>\n</div>");
$templateCache.put("app/main/apps/tags/views/read/item-context-menu.html","<md-menu md-offset=\"0 -5\" id=\"context-menu\"><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"ctrl.openMenu($mdMenu.open, $event)\"><md-icon md-menu-origin md-svg-icon=\"call:ring-volume\"></md-icon>\n</md-button><md-menu-content width=\"4\"><md-menu-item ng-repeat=\"item in [1, 2, 3]\"><md-button \nng-click=\"ctrl.announceClick($index)\"><span md-menu-align-target>Option</span> {{item}}</md-button></md-menu-item>\n</md-menu-content></md-menu>");
$templateCache.put("app/main/apps/tags/views/read/read-view-nosplit.html","<div flex layout=\"column\" layout-align=\"center center\" ng-if=\"vm.loadingReadPane\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"30\"></md-progress-circular></div><div \nng-show=\"!vm.loadingReadPane\"><div class=\"mail-content\" layout=\"column\" layout-align=\"center center\" \nng-if=\"!vm.selectedContent\"><div class=\"content\" layout=\"column\" layout-align=\"top center\"><div class=\"message\">\nPlease select an item to show in this panel</div></div></div><div class=\"toolbar grey-100-bg colored-bg\" layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"vm.selectedContent\" scroll=\"\"><div layout=\"row\" layout-align=\"start center\">\n<md-button class=\"md-icon-button close-thread\" aria-label=\"Back\" ng-click=\"vm.closeThread()\" \nng-if=\"vm.currentThread && vm.currentView==\'nosplit\'\" translate translate-attr-aria-label=\"CONTENT.BACK\"><md-icon \nmd-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><div class=\"divider-vertical\" hide=\"\" \nng-if=\"vm.activeMailPaneIndex === 1\" show-gt-sm=\"\"></div><md-button aria-label=\"Preview\" class=\"md-icon-button\" \nng-click=\"vm.viewPreview()\" translate=\"\" translate-attr-aria-label=\"CONTENT.PREVIEW\"><md-icon md-font-icon=\"icon-eye\">\n</md-icon><md-tooltip><span translate=\"CONTENT.PREVIEW\">Preview</span></md-tooltip></md-button><div \nclass=\"divider-vertical\" hide=\"\" show-gt-sm=\"\"></div><md-button aria-label=\"Edit\" class=\"md-icon-button\" \nng-click=\"vm.viewEditInline()\" translate=\"\" translate-attr-aria-label=\"CONTENT.EDIT\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon><md-tooltip><span translate=\"CONTENT.EDIT\">Edit</span></md-tooltip></md-button>\n<div class=\"divider-vertical\" hide=\"\" show-gt-sm=\"\"></div><md-button aria-label=\"Spam\" class=\"md-icon-button\" \nng-click=\"\" translate=\"\" translate-attr-aria-label=\"CONTENT.LIVE\" ng-if=\"vm.ActiveSection.web_preview\"><md-icon \nmd-font-icon=\"icon-web\"></md-icon><md-tooltip><span translate=\"CONTENT.LIVE\">Live Preview</span></md-tooltip>\n</md-button><md-menu hide=\"\"><md-button aria-label=\"Mail Actions\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\" translate=\"\" translate-attr-aria-label=\"CONTENT.ACTIONS\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \naria-label=\"Archive\" translate-attr-aria-label=\"CONTENT.ARCHIVE\"><md-icon md-font-icon=\"icon-archive\"></md-icon><span \ntranslate=\"CONTENT.ARCHIVE\">Archive</span></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Spam\" \ntranslate-attr-aria-label=\"CONTENT.SPAM\"><md-icon md-font-icon=\"icon-alert-octagon\"></md-icon><span \ntranslate=\"CONTENT.SPAM\">Spam</span></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Delete\" \ntranslate-aria-label=\"CONTENT.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span translate=\"CONTENT.DELETE\">\nDelete</span></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Move To\" \ntranslate-attr-aria-label=\"CONTENT.MOVE_TO\"><md-icon md-font-icon=\"icon-folder-move\"></md-icon><span \ntranslate=\"CONTENT.MOVE_TO\">Move To</span></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Labels\" \ntranslate-attr-aria-label=\"CONTENT.LABELS\"><md-icon md-font-icon=\"icon-label\"></md-icon><span \ntranslate=\"CONTENT.LABELS\">Labels</span></md-button></md-menu-item></md-menu-content></md-menu></div><div layout=\"row\" \nlayout-align=\"end center\" ng-if=\"vm.currentThread_Edit\"><md-button type=\"submit\" \nng-click=\"vm.saveItem(vm.currentThread_Edit)\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.basicForm.$invalid || vm.basicForm.$pristine\" aria-label=\"SAVE\" translate=\"CONTENT.SAVE\" \ntranslate-attr-aria-label=\"CONTENT.SAVE\">SAVE</md-button><md-button type=\"button\" ng-click=\"vm.closeThreadEdit()\" \nclass=\"md-raised md-warn\" aria-label=\"Cancel\">Cancel</md-button></div></div><md-content flex=\"\" \nng-show=\"vm.selectedContent && !vm.editInline\"><div class=\"mail-content file-details scrollable\" \nms-scroll=\"vm.msScrollOptions\"><md-list><md-list-item class=\"info\" layout=\"row\" layout-align=\"start center\"><div \nlayout=\"row\" layout-align=\"start start\"><div><span><span class=\"grey-500-fg\">ID # </span><span \nng-bind=\"vm.selectedContent.id_tag\"></span></span></div></div></md-list-item><md-list-item><div><h1 class=\"name\">\n<strong ng-bind=\"vm.selectedContent.verify\"></strong></h1><md-divider></md-divider></div></md-list-item><md-list-item>\n<div><h1 class=\"name\"><strong ng-bind=\"vm.selectedContent.tag_name\"></strong></h1><md-divider></md-divider></div>\n</md-list-item><md-list-item class=\"md-toolbar-tools grey-100-bg\"><h3 class=\"grey-700-fg\" \ntranslate=\"CONTENT.LATESTACTIVITY\">Latest Activity</h3><md-divider></md-divider></md-list-item><div class=\"activities\">\n<div class=\"activity\" layout=\"row\" layout-align=\"start center\" \nng-repeat=\"activity in vm.log | limitTo: vm.paginationLimit()\"><img alt=\"{{content.from.name}}\" class=\"avatar\" \nng-if=\"activity.user.avatar\" ng-src=\"{{activity.username}}\"><div class=\"avatar\" ng-if=\"!activity.user.avatar\" \nng-style=\"{\'background-color\':activity.user.profile_color}\">{{activity.user.firstname[0] | capitalize}}</div><div \nlayout=\"column\"><div><span class=\"username md-accent-color\" \nng-if=\"activity.user.firstname.length>0 || activity.user.lastname.length>0\">\n{{activity.user.firstname}} {{activity.user.lastname}} </span><span class=\"message\">{{activity.message}}</span></div>\n<span class=\"time secondary-text\">{{activity.date}}</span></div></div><button \nclass=\"md-raised md-button md-default-theme md-ink-ripple\" ng-click=\"vm.showMoreItems()\" \nng-show=\"vm.hasMoreItemsToShow()\"><span>Show more</span></button></div></md-list></div></md-content><md-content \nng-if=\"vm.editInline && vm.selectedContent\" class=\"scrollable\"><div id=\"content-edit\" \nclass=\"nosplited page-layout simple fullwidth mail-content content-edit\" layout=\"row\" hide show-gt-sm><md-tabs \nflex=\"50\" ms-scroll=\"vm.msScrollOptions\" class=\"scrollable\"><md-tab label=\"Edit\"><div layout=\"row\" \nng-include=\"\'app/main/apps/tags/views/read/tab-edit.html\'\"></div></md-tab></md-tabs><md-tabs flex=\"50\" \nms-scroll=\"vm.msScrollOptions\" class=\"scrollable\"><md-tab label=\"Media\" ng-if=\"vm.ActiveSection.media\"><div \nng-include=\"\'app/main/apps/tags/views/read/tab-media.html\'\"></div></md-tab><md-tab label=\"SEO\" \nng-if=\"vm.ActiveSection.seo\"><div ng-include=\"\'app/main/apps/tags/views/read/tab-seo.html\'\"></div></md-tab><md-tab \nlabel=\"Activity\" ng-if=\"vm.ActiveSection.activity\"><div ng-include=\"\'app/main/apps/tags/views/read/tab-activity.html\'\">\n</div></md-tab></md-tabs></div><div id=\"content-edit-mobile\" \nclass=\"page-layout simple fullwidth mail-content content-edit\" layout=\"row\" hide-gt-sm><md-tabs \nms-scroll=\"vm.msScrollOptions\" class=\"scrollable\"><md-tab label=\"Edit\"><div layout=\"row\" \nng-include=\"\'app/main/apps/tags/views/read/tab-edit.html\'\"></div></md-tab><md-tab label=\"Media\" \nng-if=\"vm.ActiveSection.media\"><div ng-include=\"\'app/main/apps/tags/views/read/tab-media.html\'\"></div></md-tab><md-tab \nlabel=\"SEO\" ng-if=\"vm.ActiveSection.seo\"><div ng-include=\"\'app/main/apps/tags/views/read/tab-seo.html\'\"></div></md-tab>\n<md-tab label=\"Activity\" ng-if=\"vm.ActiveSection.activity\"><div \nng-include=\"\'app/main/apps/tags/views/read/tab-activity.html\'\"></div></md-tab></md-tabs></div></md-content></div>");
$templateCache.put("app/main/apps/tags/views/read/read-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-show=\"vm.loadingReadPane\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nng-show=\"!vm.loadingReadPane\"><div class=\"mail-content\" layout=\"column\" layout-align=\"center center\" \nng-if=\"!vm.selectedContent\"><div class=\"content\" layout=\"column\" layout-align=\"top center\"><div class=\"message\" \ntranslate=\"CONTENT.NO_ITEM_SELECTED_PANEL\"></div></div></div><div class=\"toolbar grey-100-bg colored-bg\" layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"vm.selectedContent\" scroll=\"\"><div layout=\"row\" layout-align=\"start center\">\n<md-button class=\"md-icon-button close-thread\" aria-label=\"Back\" ng-click=\"vm.closeThread()\" \nng-if=\"vm.currentThread && vm.currentView==\'nosplit\'\" translate translate-attr-aria-label=\"CONTENT.BACK\"><md-icon \nmd-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><div class=\"divider-vertical\" hide=\"\" \nng-if=\"vm.activeMailPaneIndex === 1\" show-gt-sm=\"\"></div><md-button aria-label=\"Preview\" class=\"md-icon-button\" \nng-click=\"vm.viewPreview()\" translate=\"\" translate-attr-aria-label=\"CONTENT.PREVIEW\"><md-icon md-font-icon=\"icon-eye\">\n</md-icon><md-tooltip><span translate=\"CONTENT.PREVIEW\">Preview</span></md-tooltip></md-button><div \nclass=\"divider-vertical\" hide=\"\" show-gt-sm=\"\"></div><md-button aria-label=\"Edit\" class=\"md-icon-button\" \nng-click=\"vm.viewEditInline()\" translate=\"\" translate-attr-aria-label=\"CONTENT.EDIT\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon><md-tooltip><span translate=\"CONTENT.EDIT\">Edit</span></md-tooltip></md-button>\n<div class=\"divider-vertical\" hide=\"\" show-gt-sm=\"\"></div><md-button aria-label=\"Spam\" class=\"md-icon-button\" \nng-click=\"\" translate=\"\" translate-attr-aria-label=\"CONTENT.LIVE\" ng-if=\"vm.ActiveSection.web_preview\"><md-icon \nmd-font-icon=\"icon-web\"></md-icon><md-tooltip><span translate=\"CONTENT.LIVE\">Live Preview</span></md-tooltip>\n</md-button><md-menu hide=\"\"><md-button aria-label=\"Mail Actions\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\" translate=\"\" translate-attr-aria-label=\"CONTENT.ACTIONS\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \naria-label=\"Archive\" translate-attr-aria-label=\"CONTENT.ARCHIVE\"><md-icon md-font-icon=\"icon-archive\"></md-icon><span \ntranslate=\"CONTENT.ARCHIVE\">Archive</span></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Spam\" \ntranslate-attr-aria-label=\"CONTENT.SPAM\"><md-icon md-font-icon=\"icon-alert-octagon\"></md-icon><span \ntranslate=\"CONTENT.SPAM\">Spam</span></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Delete\" \ntranslate-aria-label=\"CONTENT.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span translate=\"CONTENT.DELETE\">\nDelete</span></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Move To\" \ntranslate-attr-aria-label=\"CONTENT.MOVE_TO\"><md-icon md-font-icon=\"icon-folder-move\"></md-icon><span \ntranslate=\"CONTENT.MOVE_TO\">Move To</span></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Labels\" \ntranslate-attr-aria-label=\"CONTENT.LABELS\"><md-icon md-font-icon=\"icon-label\"></md-icon><span \ntranslate=\"CONTENT.LABELS\">Labels</span></md-button></md-menu-item></md-menu-content></md-menu></div><div layout=\"row\" \nlayout-align=\"end center\" ng-if=\"vm.currentThread_Edit\"><md-button type=\"submit\" \nng-click=\"vm.saveItem(vm.currentThread_Edit)\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.basicForm.$invalid || vm.basicForm.$pristine\" aria-label=\"SAVE\" translate=\"CONTENT.SAVE\" \ntranslate-attr-aria-label=\"CONTENT.SAVE\">SAVE</md-button><md-button type=\"button\" ng-click=\"vm.closeThreadEdit()\" \nclass=\"md-raised md-warn\" aria-label=\"Cancel\">Cancel</md-button></div></div><md-content flex=\"\" \nng-show=\"vm.selectedContent && !vm.editInline\"><div class=\"mail-content file-details scrollable\" \nms-scroll=\"vm.msScrollOptions\"><md-list><md-list-item class=\"info\" layout=\"row\" layout-align=\"start center\"><div \nlayout=\"row\" layout-align=\"start start\"><div layout=\"row\" layout-align=\"center center\" class=\"header-element\"><span>\n<button ng-if=\"vm.selectedContent.verify===0\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\"></md-icon></button> <button \nng-if=\"vm.selectedContent.verify===1\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" \nclass=\"on green-fg s24\"></md-icon></button> <button ng-if=\"vm.selectedContent.verify===2\" class=\"md-icon-button\">\n<md-icon md-font-icon=\"icon-close-circle\" class=\"on grey-600-fg s24\"></md-icon></button></span></div><div layout=\"row\" \nlayout-align=\"center center\" class=\"header-element\"><span><span class=\"grey-500-fg\">ID # </span><span \nng-bind=\"vm.selectedContent.id_tag\"></span></span></div></div></md-list-item><md-list-item><div><h1 class=\"name\">\n<strong ng-bind=\"vm.selectedContent.tag_name\"></strong></h1><md-divider></md-divider></div></md-list-item><md-list-item\n flex=\"100\"><div class=\"text-truncate\" flex=\"100\"><div class=\"field\"><p class=\"grey-500-fg font-size-14\">Tag alternate\n</p><span class=\"font-size-16 text-truncate\" ng-if=\"vm.selectedContent.tag_alternate\" \nng-bind-html=\"vm.selectedContent.tag_alternate\"></span> <span class=\"font-size-16 text-truncate\" \nng-if=\"!vm.selectedContent.tag_alternate\">-</span><br></div><md-divider class=\"md-default-theme\"></md-divider></div>\n<div class=\"md-secondary-container\"></div></md-list-item><md-list-item flex=\"100\" \nng-if=\"vm.tagsTypes && vm.tagsTypes.length\"><div class=\"text-truncate\" flex=\"100\"><div class=\"field\"><p \nclass=\"grey-500-fg font-size-14\">Tag type</p><span class=\"font-size-16 text-truncate\" \nng-if=\"!vm.selectedContent.id_type || !vm.tagsTypes || vm.tagsTypes.length === 0\">-</span> <span \nclass=\"font-size-16 text-truncate\" ng-if=\"vm.selectedContent.id_type\">\n{{(vm.tagsTypes | filter: { id_type: vm.selectedContent.id_type })[0].name || \'-\'}}</span><br></div><md-divider \nclass=\"md-default-theme\"></md-divider></div><div class=\"md-secondary-container\"></div></md-list-item><md-list-item \nflex=\"100\" ng-if=\"vm.selectedContent.use\"><div class=\"text-truncate\" flex=\"100\"><div class=\"field\"><p \nclass=\"grey-500-fg font-size-14\">Tag usages</p><div ng-repeat=\"(key, value) in vm.selectedContent.use\"><span>\n{{key | capitalize}} - {{value.length}}</span></div><br></div><md-divider class=\"md-default-theme\"></md-divider></div>\n<div class=\"md-secondary-container\"></div></md-list-item><md-list-item class=\"md-toolbar-tools grey-100-bg\"><h3 \nclass=\"grey-700-fg\" translate=\"CONTENT.LATESTACTIVITY\">Latest Activity</h3><md-divider></md-divider></md-list-item><div\n class=\"activities\"><div class=\"activity\" layout=\"row\" layout-align=\"start center\" \nng-repeat=\"activity in vm.log | limitTo: vm.paginationLimit()\"><img alt=\"{{content.from.name}}\" class=\"avatar\" \nng-if=\"activity.user.avatar\" ng-src=\"{{activity.username}}\"><div class=\"avatar\" ng-if=\"!activity.user.avatar\" \nng-style=\"{\'background-color\':activity.user.profile_color}\">{{activity.user.firstname[0] | capitalize}}</div><div \nlayout=\"column\"><div><span class=\"username md-accent-color\" \nng-if=\"activity.user.firstname.length>0 || activity.user.lastname.length>0\">\n{{activity.user.firstname}} {{activity.user.lastname}} </span><span class=\"message\">{{activity.message}}</span></div>\n<span class=\"time secondary-text\">{{activity.date}}</span></div></div><button \nclass=\"md-raised md-button md-default-theme md-ink-ripple\" ng-click=\"vm.showMoreItems()\" \nng-show=\"vm.hasMoreItemsToShow()\"><span>Show more</span></button></div></md-list></div></md-content><md-content \nng-if=\"vm.editInline && vm.selectedContent\" ng-include=\"\'app/main/apps/tags/views/read/edit-preview.html\'\" \nclass=\"scrollable\"></md-content></div>");
$templateCache.put("app/main/apps/tags/views/read/tab-edit.html","<div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><form name=\"vm.basicForm\" class=\"md-inline-form\" novalidate>\n<div><md-input-container class=\"md-block\" flex><label translate=\"TAGS.STATUS\"></label><md-menu-bar layout=\"row\" \nlayout-align=\"stretch center\" class=\"p-0\"><md-menu flex><button class=\"mr-0 width-percent-100 pt-5 pb-5 button-select\" \nng-click=\"$mdMenu.open($event)\" aria-label=\"group-menu\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" \nclass=\"on green-fg s24 mr-10 ml-0\" ng-if=\"vm.currentThread_Edit.verify ===1\"></md-icon><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"on red-fg s24 mr-10 ml-0\" \nng-if=\"vm.currentThread_Edit.verify ===0\"></md-icon><md-icon md-font-icon=\"icon-close-circle\" \nclass=\"on grey-600-fg s24 mr-10 ml-0\" ng-if=\"vm.currentThread_Edit.verify ===2\"></md-icon><span \nng-if=\"vm.currentThread_Edit.verify ===1\" translate=\"TAGS.STATUS_CHECKED\">Checked</span> <span \nng-if=\"vm.currentThread_Edit.verify ===0\" translate=\"TAGS.STATUS_UNCHECKED\">Unchecked</span> <span \nng-if=\"vm.currentThread_Edit.verify ===2\" translate=\"TAGS.STATUS_BLACKLIST\">Blacklist</span> <span \nng-if=\"vm.currentThread_Edit.verify !== 0 && vm.currentThread_Edit.verify !== 1 &&  vm.currentThread_Edit.verify !== 2\" \ntranslate=\"TAGS.STATUS_SELECT\">Select</span></div><md-icon md-font-icon=\"icon-menu-down\" \nclass=\"grey-600-fg ml-10 mr-0\" aria-hidden=\"true\"></md-icon></button><md-menu-content class=\"md-block\" width=\"4\">\n<md-menu-item><button class=\"pl-10 pr-10\" layout=\"row\" layout-align=\"start center\" \nng-click=\"vm.setItemStatus(\'verify\',1)\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" \nclass=\"on green-fg s24 mr-10 ml-0\"></md-icon><span class=\"font-size-14\" translate=\"TAGS.STATUS_CHECKED\">Checked</span>\n</button></md-menu-item><md-menu-item><button class=\"pl-10 pr-10\" layout=\"row\" layout-align=\"start center\" \nng-click=\"vm.setItemStatus(\'verify\',0)\"><md-icon md-font-icon=\"icon-checkbox-blank-circle-outline\" \nclass=\"on red-fg s24 mr-10 ml-0\"></md-icon><span class=\"font-size-14\" translate=\"TAGS.STATUS_UNCHECKED\">Unchecked\n</span></button></md-menu-item><md-menu-item><button class=\"pl-10 pr-10\" layout=\"row\" layout-align=\"start center\" \nng-click=\"vm.setItemStatus(\'verify\',2)\"><md-icon md-font-icon=\"icon-close-circle\" class=\"on grey-fg s24 mr-10 ml-0\">\n</md-icon><span class=\"font-size-14\" translate=\"TAGS.STATUS_BLACKLIST\">Blacklist</span></button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar></md-input-container><md-input-container class=\"md-block\" flex><label \ntranslate=\"TAGS.NAME\">Name</label><textarea ng-model=\"vm.currentThread_Edit.tag_name\" columns=\"1\" rows=\"1\" \nplaceholder=\"{{vm.translate(\'TAGS.NAME\')}}\"></textarea></md-input-container><md-input-container class=\"md-block\" flex>\n<label translate=\"TAGS.ALTERNATE\">Tag alternate</label><textarea ng-model=\"vm.currentThread_Edit.tag_alternate\" \ncolumns=\"1\" rows=\"1\" placeholder=\"{{vm.translate(\'TAGS.ALTERNATE\')}}\"></textarea></md-input-container>\n<md-input-container class=\"md-block\" ng-if=\"vm.tagsTypes && vm.tagsTypes.length\"><label translate=\"TAGS.TYPE\"></label>\n<md-select ng-model=\"vm.currentThread_Edit.id_type\" md-on-close=\"searchTagType = \'\'\" \nmd-container-class=\"md-select-mini md-select-search\"><md-select-header class=\"select-header-search\"><input autofocus \nng-model=\"searchTagType\" type=\"search\" onkeydown=\"event.stopPropagation()\" placeholder=\"Search...\" \nclass=\"demo-header-searchbox md-text\"></md-select-header><md-option ng-value=\"null\"></md-option><md-option \nng-value=\"type.id_type\" ng-repeat=\"type in vm.tagsTypes | filter: { name: searchTagType }\">{{type.name}}</md-option>\n</md-select></md-input-container><div layout=\"row\"><md-list flex=\"100\" class=\"md-toolbar-tools grey-100-bg\" \nlayout=\"row\" layout-align=\"end center\"><div><md-button type=\"submit\" ng-if=\"vm.currentThread_Edit\" \nng-click=\"vm.saveItem(vm.currentThread_Edit)\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.basicForm.$invalid || vm.basicForm.$pristine\" aria-label=\"SAVE\" translate=\"CONTENT.SAVE\" \ntranslate-attr-aria-label=\"CONTENT.SAVE\">SAVE</md-button><md-button type=\"button\" ng-click=\"vm.closeThreadEdit()\" \nclass=\"md-raised md-warn\" aria-label=\"Cancel\">Cancel</md-button></div></md-list></div></div></form></div>");
$templateCache.put("app/main/apps/tags/views/read/tab-media.html","<md-list-item ng-repeat=\"mediazone in vm.mediaZones\" ng-if=\"vm.mediaZones\" class=\"list-media-item attachment-edit\"><div\n class=\"attachments\"><div class=\"field\"><p class=\"grey-500-fg ml-8\">{{ mediazone.title }}</p><div \nclass=\"attachment-list sortable md-list-item-text\" ng-sortable=\"vm.mediaSortable\"><div class=\"attachment\" \nlayout=\"column\" ng-repeat=\"attachment in vm.thumbnails_Edit[mediazone.id_zone]\"><div class=\"preview document\" \nlayout=\"row\" layout-align=\"start center\" extension-class=\"{{attachment.filename}}\" ng-href=\"{{attachment.permalink}}\" \nng-if=\"attachment.media_type==3\" target=\"_blank\"><qiu-icon mediafile=\"attachment.filename\" class=\"mr-10\"></qiu-icon><a \nclass=\"grey-1000-fg font-size-16\" ng-href=\"{{attachment.permalink}}\" target=\"_blank\"><span ng-if=\"attachment.title\">\n{{attachment.title}}</span> <span ng-if=\"attachment.filename\">{{attachment.filename}}</span></a></div><div \nclass=\"preview document\" layout=\"row\" layout-align=\"start center\" extension-class=\"{{attachment.filename}}\" \nng-href=\"{{attachment.permalink}}\" ng-if=\"attachment.media_type==4\" target=\"_blank\"><qiu-icon \nmediafile=\"attachment.filename\"></qiu-icon><a class=\"grey-1000-fg font-size-16\" ng-href=\"{{attachment.permalink}}\" \ntarget=\"_blank\"><span ng-if=\"attachment.filename\">{{attachment.filename}}</span></a></div><div \nng-if=\"attachment.media_type==1 || attachment.media_type==2\"><div class=\"ms-card\" flex \nmd-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"ms-card-content-wrapper\"><div class=\"template-9\"><div \nclass=\"media\" flex layout=\"row\" layout-align=\"center center\"><img class=\"image\" \nng-click=\"vm.openImageDialog($event, vm.currentThread_Edit.Thumbnail, attachment)\" \nng-repeat=\"crop in attachment.cropstatus | limitTo: 1\" ng-if=\"attachment.media_type==1\"><div flex \nng-click=\"vm.openImageDialog($event, vm.currentThread_Edit.Thumbnail, attachment)\"><media attachment=\"attachment\" \ncrop-format=\"{{mediazone.id_cropformats}}\"></media></div></div><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"size block\" layout=\"row\" layout-align=\"start center\"><strong \nclass=\"mr-5\">#{{attachment.id_media}}</strong> <span class=\"grey-500-fg\">{{attachment.filename}}</span></div><md-menu>\n<button class=\"md-icon-button\" aria-label=\"More\" translate translate-attr-aria-label=\"TODO.MORE\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" ng-click=\"$mdMenu.open($event)\"></md-icon></button><md-menu-content width=\"3\">\n<md-menu-item><md-button ng-click=\"vm.openImageDialog($event, vm.currentThread_Edit.Thumbnail, attachment)\" \naria-label=\"Toggle done\" translate-attr-aria-label=\"CONTENT.PREVIEW\"><md-icon md-font-icon=\"icon-eye\" \nclass=\"s16 ml-10\" href=\"#\" ng-click=\"vm.openImageDialog($event, vm.selectedMail.Thumbnail, attachment)\"></md-icon><span\n translate=\"CONTENT.PREVIEW\">Preview</span></md-button></md-menu-item><md-menu-item ng-if=\"attachment.media_type==1\">\n<md-button ng-click=\"vm.openFocalPoint($event, attachment)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.SET_FOCAL_POINT\"><md-icon md-font-icon=\"icon-image-filter-center-focus\" class=\"s18\">\n</md-icon><span translate=\"CONTENT.SET_FOCAL_POINT\">Set Focal point</span></md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"vm.deleteAttachment(attachment)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.REMOVE\"><md-icon md-font-icon=\"icon-close\" class=\"s18\"></md-icon><span \ntranslate=\"CONTENT.REMOVE\">Remove</span></md-button></md-menu-item></md-menu-content></md-menu></div></div></div></div>\n</div></div></div><md-button class=\"add-event-button no-sort md-fab md-warn\" \nng-click=\"vm.mediaDialog($event, mediazone, vm.currentThread_Edit)\" aria-label=\"Add event\" translate \ntranslate-attr-aria-label=\"CALENDAR.ADD_EVENT\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div>\n<md-divider></md-divider></md-list-item><md-list-item \nng-repeat=\"(key, value) in vm.currentThread_Edit.Thumbnail | filter: {\'zone_name\':null} | groupBy: \'zone_name\'\" \nng-right-click=\"vm.selectOrUnselect(null, $event)\" class=\"list-media-item attachment-edit\"><div class=\"attachments\">\n<div class=\"field\"><p class=\"grey-500-fg\">No Zone {{attachment.zone_name}} {{attachment.id_zone}}</p><div \nclass=\"attachment-list md-list-item-text\" layout=\"row\" layout-wrap=\"\" layout-align=\"start start\"><div \nclass=\"attachment\" layout=\"column\" ng-repeat=\"attachment in value\"><div class=\"preview document\" layout=\"row\" \nlayout-align=\"start center\" extension-class=\"{{attachment.filename}}\" ng-href=\"{{attachment.permalink}}\" \nng-if=\"attachment.media_type==3\" target=\"_blank\"><qiu-icon mediafile=\"attachment.filename\" class=\"mr-10\"></qiu-icon><a \nclass=\"grey-1000-fg font-size-16\" ng-href=\"{{attachment.permalink}}\" target=\"_blank\"><span ng-if=\"attachment.title\">\n{{attachment.title}} </span><span ng-if=\"attachment.filename\">{{attachment.filename}}</span></a></div><div \nclass=\"preview document\" layout=\"row\" layout-align=\"start center\" extension-class=\"{{attachment.filename}}\" \nng-href=\"{{attachment.permalink}}\" ng-if=\"attachment.media_type==4\" target=\"_blank\"><qiu-icon \nmediafile=\"attachment.filename\"></qiu-icon><a class=\"grey-1000-fg font-size-16\" ng-href=\"{{attachment.permalink}}\" \ntarget=\"_blank\"><span ng-if=\"attachment.filename\">{{attachment.filename}} </span></a><a href=\"#\" \nclass=\"md-accent-color link\" translate=\"CONTENT.DOWNLOAD\">Download</a></div><div \nng-if=\"attachment.media_type==1 || attachment.media_type==2\"><div class=\"ms-card\" flex \nmd-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"ms-card-content-wrapper\"><div class=\"template-9\"><div \nclass=\"media\" flex layout=\"row\" layout-align=\"center center\"><img class=\"image\" \nng-click=\"vm.openImageDialog($event, vm.currentThread_Edit.Thumbnail, attachment)\" \nng-repeat=\"crop in attachment.cropstatus | limitTo: 1\" ng-src=\"{{crop.container.view_url}}{{crop.fileName}}\"></div><div\n class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div class=\"size block\" layout=\"row\" \nlayout-align=\"start center\"><strong class=\"mr-5\">#{{attachment.id_media}}</strong><span class=\"grey-500-fg\">\n {{attachment.filename}}</span></div><md-menu><button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"TODO.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\" ng-click=\"$mdMenu.open($event)\">\n</md-icon></button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.openImageDialog($event, vm.currentThread_Edit.Thumbnail, attachment)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.PREVIEW\"><md-icon md-font-icon=\"icon-eye\" class=\"s16 ml-10\" href=\"#\" \nng-click=\"vm.openImageDialog($event, vm.selectedMail.Thumbnail, attachment)\"></md-icon><span \ntranslate=\"CONTENT.PREVIEW\">Preview</span></md-button></md-menu-item><md-menu-item ng-if=\"attachment.media_type==1\">\n<md-button ng-click=\"vm.openFocalPoint($event, attachment)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.SET_FOCAL_POINT\"><md-icon md-font-icon=\"icon-image-filter-center-focus\" class=\"s18\">\n</md-icon><span translate=\"CONTENT.SET_FOCAL_POINT\">Set Focal point</span></md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"vm.deleteAttachment(attachment)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.REMOVE\"><md-icon md-font-icon=\"icon-close\" class=\"s18\"></md-icon><span \ntranslate=\"CONTENT.REMOVE\">Remove</span></md-button></md-menu-item></md-menu-content></md-menu></div></div></div></div>\n</div></div><md-button class=\"add-event-button md-fab md-warn\" \nng-click=\"vm.mediaDialog($event, mediazone, vm.currentThread_Edit)\" aria-label=\"Add event\" translate \ntranslate-attr-aria-label=\"CALENDAR.ADD_EVENT\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div>\n</div><md-divider></md-divider></md-list-item>");
$templateCache.put("app/main/apps/users/dialogs/grid-groups/grid-groups.html","<md-dialog class=\"add-users-togroup mvg-groups-dialog\" aria-label=\"Grupos del usuario\"><form class=\"md-inline-form\">\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<h1 class=\"title\"><span translate=\"GROUP.GROUP\"></span> <span class=\"mvg-groups-dialog-user\">\n— {{vm.user.firstname}} {{vm.user.lastname}}</span></h1><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content id=\"site-mailing\" ms-scroll flex class=\"content-card\"><div layout=\"row\" \nlayout-align=\"center center\" ng-hide=\"vm.treeIsLoaded\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\" \nclass=\"m-20\"></md-progress-circular></div><div ng-include=\"vm.viewUsersGroup\"></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button type=\"button\" class=\"md-raised md-warn\" \nng-click=\"vm.closeDialog()\" ng-disabled=\"vm.saving\" translate=\"GROUP.CANCEL\"></md-button><md-button type=\"submit\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"vm.saving\" ng-click=\"vm.save()\"><span ng-if=\"!vm.saving\" \ntranslate=\"USERS.SAVE\"></span><md-progress-circular ng-if=\"vm.saving\" md-mode=\"indeterminate\" md-diameter=\"20\">\n</md-progress-circular></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/users/dialogs/import/import-dialog.html","<md-dialog class=\"import-dialog\" aria-label=\"New Message\"><form class=\"md-inline-form\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between\"><h1 class=\"title\" \ntranslate=\"USERS.IMPORT_USERS\"></h1><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nng-if=\"!vm.importFinished && !vm.importError\" ms-scroll flex class=\"content-card\" ng-class=\"vm.currentView\"><div \nng-if=\"!vm.fileInfo\" ngf-drop \nng-class=\"{\'disabled\' : vm.optionsDefault.delimiter.length == 0 || vm.optionsDefault.escape.length == 0 || vm.primaryKey.length == 0}\" \nng-disabled=\"vm.optionsDefault.delimiter.length == 0 || vm.optionsDefault.escape.length == 0 || vm.primaryKey.length == 0\" \nngf-select ng-model=\"vm.files\" class=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"false\" \nngf-allow-dir=\"true\" accept=\".csv\" ngf-pattern=\"\'.csv\'\"><div layout=\"column\"><div flex \ntranslate=\"USERS.DROP_OR_UPLOAD\"></div><div flex translate=\"USERS.OR\"></div><div flex><md-button \nclass=\"send-button md-accent md-raised\" aria-label=\"Select files\" translate=\"USERS.SELECT_FROM_COMPUTER_CSV\">\n</md-button></div></div><div ng-repeat=\"f in vm.files\" class=\"ms-card\" flex><div \nclass=\"ms-card-content-wrapper imported-files\"><div class=\"template-9\"><div class=\"media\" flex layout=\"row\" \nlayout-align=\"center center\"><img ngf-thumbnail=\"!f.$error && f\" class=\"image\"></div><div class=\"header p-16\" flex><div\n layout=\"row\" layout-align=\"space-between center\" flex><div class=\"size\" layout=\"row\" layout-align=\"start left\"><strong\n class=\"mr-5\" ng-if=\"f.id\">#{{f.id}}</strong> <span class=\"grey-500-fg\"><span ng-if=\"f.name\">{{f.name}}</span></span>\n</div></div></div><md-progress-linear md-mode=\"determinate\" value=\"{{f.progress}}\" ng-show=\"f.progress < 100\">\n</md-progress-linear></div></div></div></div><div ngf-no-file-drop>File Drag/Drop is not supported for this browser\n</div><div ng-if=\"!vm.fileInfo\" layout=\"row\" class=\"form-especials\"><md-input-container flex-xs=\"100\" flex-gt-sm=\"25\">\n<label for=\"primaryKey\" translate=\"USERS.PRIMARY_KEY\"></label><input type=\"text\" ng-model=\"vm.primaryKey\" \nname=\"primaryKey\" translate-placeholder=\"USERS.PRIMARY_KEY\"></md-input-container><md-input-container flex-xs=\"100\" \nflex-gt-sm=\"25\"><label for=\"delimiter\" translate=\"USERS.DELIMITER\"></label><input \nng-model=\"vm.optionsDefault.delimiter\" type=\"text\" name=\"delimiter\" translate-placeholder=\"USERS.DELIMITER\">\n</md-input-container><md-input-container flex-xs=\"100\" flex-gt-sm=\"25\"><label for=\"enclosure\" \ntranslate=\"USERS.ENCLOUSURE\"></label><input ng-model=\"vm.optionsDefault.enclosure\" type=\"text\" name=\"enclosure\" \ntranslate-placeholder=\"USERS.ENCLOUSURE\"></md-input-container><md-input-container flex-xs=\"100\" flex-gt-sm=\"25\"><label \nfor=\"escape\" translate=\"USERS.ESCAPE\"></label><input type=\"text\" ng-model=\"vm.optionsDefault.escape\" name=\"escape\" \ntranslate-placeholder=\"USERS.ESCAPE\"></md-input-container></div><div ng-if=\"!vm.fileInfo\" layout=\"row\" \nclass=\"form-especials\"><md-input-container flex-xs=\"100\" flex-gt-sm=\"20\"><md-checkbox class=\"no-label\" \ntranslate-aria-label=\"USERS.UPDATE_DUPLICATES\" ng-checked=\"vm.udpateDuplicates\" ng-model=\"vm.udpateDuplicates\">\n{{vm.translate(\'USERS.UPDATE_DUPLICATES\')}}</md-checkbox></md-input-container><md-input-container flex-xs=\"100\" \nflex-gt-sm=\"80\"><md-checkbox class=\"no-label\" translate-aria-label=\"USERS.INCLUDE_FIRST_ROW\" \nng-checked=\"vm.optionsDefault.includeFirstRow\" ng-model=\"vm.optionsDefault.includeFirstRow\">\n{{vm.translate(\'USERS.INCLUDE_FIRST_ROW\')}}</md-checkbox></md-input-container></div><div flex layout=\"column\" \nlayout-align=\"center center\" ng-if=\"vm.isLoading\" class=\"loading-container\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nng-style=\"{\'opacity\' : vm.isLoading ? 0.2 : 1}\" ng-if=\"vm.fileInfo\" class=\"info-result\"><div layout=\"row\" \nclass=\"p-15 group-selector\"><md-input-container class=\"md-block on-off\" flex-xs=\"100\" flex-gt-sm=\"33\"><label \ntranslate=\"USERS.ADD_TO_GROUP\"></label><md-menu><button class=\"mr-0 width-percent-100 pb-5 pt-5 button-select\" \nng-click=\"$mdMenu.open($event)\" aria-label=\"group-menu\" layout=\"row\" layout-align=\"space-between center\"><span \nng-if=\"vm.groupSelectedName\" class=\"font-size-14\">{{vm.groupSelectedName}}</span> <span \nng-if=\"!vm.groupSelectedName && vm.usersGroupsFilters.length == 0\" class=\"font-size-14\">Root</span> <span \nng-if=\"!vm.groupSelectedName && vm.usersGroupsFilters.length > 0\" class=\"font-size-14\" translate=\"USERS.SELECT_GROUP\">\n</span><md-icon md-font-icon=\"icon-menu-down\" class=\"grey-600-fg ml-10 mr-0\" aria-hidden=\"true\"></md-icon></button>\n<md-menu-content class=\"md-block groups-tree\"><div class=\"level-card p-8 group-row ng-scope grey-100-bg\" layout=\"row\">\n<label for=\"search-bar-input\"><md-icon ng-show=\"!vm.treeSearch\" md-font-icon=\"icon-magnify\" \nclass=\"grey-600-fg md-icon-button md-button\"><md-tooltip hide show-gt-xs><span translate=\"TOOLBAR.SEARCH\">Search</span>\n</md-tooltip></md-icon><md-icon ng-show=\"vm.treeSearch\" md-font-icon=\"icon-close-circle\" \nclass=\"grey-600-fg md-icon-button md-button\" ng-click=\"vm.treeSearch = null\"></md-icon></label><input type=\"text\" \nid=\"search-bar-input\" class=\"grey-600-fg grey-100-bg\" ng-model=\"vm.treeSearch\" placeholder=\"Search\" md-autofocus \ntranslate translate-attr-placeholder=\"TOOLBAR.SEARCH\" flex></div><div ng-if=\"!vm.rootGroup\" \nng-click=\"vm.selectParentGroupRoot()\" class=\"level-card p-8 group-row ng-scope\" layout=\"row\" \nlayout-align=\"space-between stretch\"><div flex class=\"layout-align-start-center layout-row flex\"><md-icon \nmd-font-icon=\"icon-folder-multiple\" \nclass=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 ng-scope md-default-theme md-font material-icons icon-folder-multiple\" \naria-hidden=\"true\"></md-icon><span translate=\"GROUP.ROOT\"></span></div></div><div ng-click=\"$mdCloseMenu($event)\" \nng-if=\"vm.groups\" ivh-treeview=\"vm.groups\" ivh-treeview-filter=\"vm.treeSearch\" class=\"ivh-treeview-folder small\" \nivh-treeview-label-attribute=\"\'label\'\"><script type=\"text/ng-template\">\n<div class=\"level-card p-8 group-row select-parent-group-row\" layout=\"row\" layout-align=\"space-between stretch\">\r\n                                        <span ivh-treeview-twistie ivh-treeview-toggle layout=\"row\" layout-align=\"center center\"></span>\r\n                                        <div qiu-on-select-parent-users-group flex id=\"treeview-group-{{node.id_group}}\" data-group-node={{node}} layout=\"row\" layout-align=\"start center\">\r\n                                            <div ng-if=\"node.group_type.icon\">\r\n                                                <md-icon ng-if=\"node.group_type.icon\"\r\n                                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                                    md-font-icon=\"{{node.group_type.icon}}\"\r\n                                                    aria-hidden=\"true\" >\r\n                                                </md-icon>\r\n                                            </div>\r\n                                            <div ng-if=\"!node.group_type.icon\">\r\n                                                <md-icon ng-if=\"!node.children && node.id_group_type == 1\"\r\n                                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                                    md-font-icon=\"icon-folder\"\r\n                                                    aria-hidden=\"true\" >\r\n                                                </md-icon>\r\n                                                <md-icon\r\n                                                    ng-if=\"node.children && node.id_group_type == 1\"\r\n                                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                                    md-font-icon=\"icon-folder-multiple\"\r\n                                                    aria-hidden=\"true\" >\r\n                                                </md-icon>\r\n                                                <md-icon ng-if=\"!node.children && node.id_group_type == 2\"\r\n                                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                                    md-font-icon=\"qiu-icon-file-usermailing\"\r\n                                                    aria-hidden=\"true\" >\r\n                                                </md-icon>\r\n                                                <md-icon\r\n                                                    ng-if=\"node.children && node.id_group_type == 2\"\r\n                                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                                    md-svg-src=\"/assets/icons/svg/icon-folder-mail-multiple.svg\"\r\n                                                    aria-hidden=\"true\" >\r\n                                                </md-icon>\r\n                                                <md-icon ng-if=\"!node.children && node.id_group_type == 3\"\r\n                                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                                    md-font-icon=\"qiu-icon-file-usermediacenter\"\r\n                                                    aria-hidden=\"true\" >\r\n                                                </md-icon>\r\n                                                <md-icon\r\n                                                    ng-if=\"node.children && node.id_group_type == 3\"\r\n                                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                                    md-svg-src=\"/assets/icons/svg/icon-folder-play-multiple.svg\"\r\n                                                    aria-hidden=\"true\" >\r\n                                                </md-icon>\r\n                                                <md-icon ng-if=\"!node.children && node.id_group_type == 4\"\r\n                                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                                    md-font-icon=\"qiu-icon-file-usersegment\"\r\n                                                    aria-hidden=\"true\" >\r\n                                                </md-icon>\r\n                                                <md-icon\r\n                                                    ng-if=\"node.children && node.id_group_type == 4\"\r\n                                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                                    md-svg-src=\"/assets/icons/svg/icon-folder-share-multiple.svg\"\r\n                                                    aria-hidden=\"true\" >\r\n                                                </md-icon>\r\n                                                <md-icon ng-if=\"!node.children && node.id_group_type == 5\"\r\n                                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                                    md-font-icon=\"qiu-icon-file-userstore\"\r\n                                                    aria-hidden=\"true\" >\r\n                                                </md-icon>\r\n                                                <md-icon\r\n                                                    ng-if=\"node.children && node.id_group_type == 5\"\r\n                                                    md-svg-src=\"/assets/icons/svg/icon-folder-shop-multiple.svg\"\r\n                                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                                    aria-hidden=\"true\" >\r\n                                                </md-icon>\r\n                                                <md-icon ng-if=\"!node.children && node.id_group_type == 6\"\r\n                                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                                    md-font-icon=\"qiu-icon-file-useracreditation\"\r\n                                                    aria-hidden=\"true\" >\r\n                                                </md-icon>\r\n                                                <md-icon\r\n                                                    ng-if=\"node.children && node.id_group_type == 6\"\r\n                                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                                    md-svg-src=\"/assets/icons/svg/icon-folder-board-multiple.svg\"\r\n                                                    aria-hidden=\"true\" >\r\n                                                </md-icon>\r\n                                                <md-icon ng-if=\"!node.children && node.id_group_type == 7\"\r\n                                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                                    md-svg-src=\"/assets/icons/svg/icon-folder-chat.svg\"\r\n                                                    aria-hidden=\"true\" >\r\n                                                </md-icon>\r\n                                                <md-icon\r\n                                                    ng-if=\"node.children && node.id_group_type == 7\"\r\n                                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                                    md-svg-src=\"/assets/icons/svg/icon-folder-chat-multiple.svg\"\r\n                                                    aria-hidden=\"true\" >\r\n                                                </md-icon>\r\n                                                <md-icon ng-if=\"!node.children && node.id_group_type == 8\"\r\n                                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                                    md-font-icon=\"icon-folder-remove\"\r\n                                                    aria-hidden=\"true\" >\r\n                                                </md-icon>\r\n                                                <md-icon\r\n                                                    ng-if=\"node.children && node.id_group_type == 8\"\r\n                                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                                    md-font-icon=\"icon-folder-multiple\"\r\n                                                    aria-hidden=\"true\" >\r\n                                                </md-icon>\r\n                                            </div>\r\n                                           <span class=\"ivh-treeview-node-label ng-binding\">{{node.name}}</span>\r\n                                        </div>\r\n                                      </div>\r\n                                    <div ivh-treeview-children></div>\n</script></div></md-menu-content></md-menu></md-input-container></div><table class=\"table row-border hover simple\" \nms-responsive-table><thead><tr><th>{{vm.translate(\'USERS.CVS_FIELD\')}}</th><th \nng-repeat=\"record in vm.fileInfo.file.sampleRecords |limitTo:3\">{{vm.translate(\'USERS.SAMPLE\')}} {{$index + 1 }}</th>\n<th class=\"big\">{{vm.translate(\'USERS.BBDD_FIELD\')}}</th></tr></thead><tbody><tr ng-init=\"indexParent = $index\" \nng-repeat=\"header in vm.fileInfo.file.headers track by $index\"><td>{{header}}</td><td \nng-repeat=\"record in vm.fileInfo.file.sampleRecords |limitTo:3\">{{record[indexParent]}}</td><td class=\"big\"><div \nlayout=\"row\"><md-input-container flex=\"85\" class=\"md-block m-0\"><label translate=\"USERS.FIELD_BBDD\"></label><md-select \nng-model=\"vm.mapping[header]\"><md-option ng-value=\"\"></md-option><md-option \nng-repeat=\"fieldDB in vm.fileInfo.db.availableFields track by $index\" ng-value=\"fieldDB\" \nng-selected=\"vm.isHeaderMatch(fieldDB, header)\">{{fieldDB}}</md-option></md-select></md-input-container><md-button \nflex=\"15\" ng-if=\"vm.mapping[header]\" class=\"md-icon-button\" ng-click=\"vm.mapping[header] = null;\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></td></tr></tbody></table></div>\n</md-dialog-content><md-dialog-content ng-if=\"vm.importFinished && !vm.importError\" ms-scroll flex \nclass=\"content-card results\" ng-class=\"vm.currentView\"><div ng-if=\"!vm.contentImporter\" layout=\"row\" layout-padding \nlayout-wrap layout-fill style=\"padding-bottom: 32px\" ng-cloak><span flex-xs=\"100\" flex-gt-xs=\"33\" layout \nlayout-align=\"center center\"><md-whiteframe class=\"md-whiteframe-1dp\"><label translate=\"USERS.CREATED_NEWS\"></label>\n<div class=\"value-result\">{{vm.resultImport.users.new}}</div></md-whiteframe></span><span flex-xs=\"100\" \nflex-gt-xs=\"33\" layout layout-align=\"center center\"><md-whiteframe class=\"md-whiteframe-2dp\"><label>\n{{ \'USERS.ADDED_TO_GROUP\' | translate }}: {{vm.groupSelectedName}}</label><div class=\"value-result\">\n{{vm.resultImport.in_group.new}}</div></md-whiteframe></span><span flex-xs=\"100\" flex-gt-xs=\"33\" layout \nlayout-align=\"center center\"><md-whiteframe class=\"md-whiteframe-2dp\"><label translate=\"USERS.UPDATED\"></label><div \nclass=\"value-result\">{{vm.resultImport.users.updated}}</div></md-whiteframe></span><span flex-xs=\"100\" flex-gt-xs=\"33\" \nlayout layout-align=\"center center\"><md-whiteframe class=\"md-whiteframe-2dp\"><label translate=\"USERS.ALREADY_IMPORTED\">\n</label><div class=\"value-result\">{{vm.resultImport.users.skipped}}</div></md-whiteframe></span><span flex-xs=\"100\" \nflex-gt-xs=\"33\" layout layout-align=\"center center\"><md-whiteframe class=\"md-whiteframe-2dp\"><label \ntranslate=\"USERS.INVALID\"></label><div class=\"value-result\">{{vm.resultImport.users.invalid}}</div></md-whiteframe>\n</span><span flex-xs=\"100\" flex-gt-xs=\"33\" layout layout-align=\"center center\"><md-whiteframe \nclass=\"md-whiteframe-2dp\"><label translate=\"USERS.TOTAL\"></label><div class=\"value-result\">\n{{vm.resultImport.users.total}}</div></md-whiteframe></span><div fill-width class=\"text-center\" \nng-if=\"vm.resultImport.invalid_data.length > 0\"><h2 translate=\"USERS.INVALID_ADDRESSES\"></h2></div><div fill-width \nclass=\"text-center\" ng-if=\"vm.resultImport.invalid_data.length > 0\"><div \nng-repeat=\"emailInvalid in vm.resultImport.invalid_data track by $index\"><span>{{emailInvalid}}</span></div></div>\n</div><div ng-if=\"vm.contentImporter\" layout=\"row\" layout-padding layout-wrap layout-fill style=\"padding-bottom: 32px\" \nng-cloak><span flex-xs=\"100\" flex-gt-xs=\"33\" layout layout-align=\"center center\"><md-whiteframe \nclass=\"md-whiteframe-1dp\"><label translate=\"USERS.CREATED_NEWS\"></label><div class=\"value-result\">\n{{vm.resultImport.records.new}}</div></md-whiteframe></span><span flex-xs=\"100\" flex-gt-xs=\"33\" layout \nlayout-align=\"center center\"><md-whiteframe class=\"md-whiteframe-2dp\"><label translate=\"USERS.UPDATED\"></label><div \nclass=\"value-result\">{{vm.resultImport.records.updated}}</div></md-whiteframe></span><span flex-xs=\"100\" \nflex-gt-xs=\"33\" layout layout-align=\"center center\"><md-whiteframe class=\"md-whiteframe-2dp\"><label \ntranslate=\"USERS.ALREADY_IMPORTED\"></label><div class=\"value-result\">{{vm.resultImport.records.skipped}}</div>\n</md-whiteframe></span><span flex-xs=\"100\" flex-gt-xs=\"33\" layout layout-align=\"center center\"><md-whiteframe \nclass=\"md-whiteframe-2dp\"><label translate=\"USERS.INVALID\"></label><div class=\"value-result\">\n{{vm.resultImport.records.invalid}}</div></md-whiteframe></span><span flex-xs=\"100\" flex-gt-xs=\"33\" layout \nlayout-align=\"center center\"><md-whiteframe class=\"md-whiteframe-2dp\"><label translate=\"USERS.TOTAL\"></label><div \nclass=\"value-result\">{{vm.resultImport.records.total}}</div></md-whiteframe></span><div fill-width class=\"text-center\" \nng-if=\"vm.resultImport.invalid_data.length > 0\"><h2 translate=\"USERS.INVALID_ADDRESSES\"></h2></div><div fill-width \nclass=\"text-center\" ng-if=\"vm.resultImport.invalid_data.length > 0\"><div \nng-repeat=\"emailInvalid in vm.resultImport.invalid_data track by $index\"><span>{{emailInvalid}}</span></div></div>\n</div></md-dialog-content><md-dialog-content ng-if=\"vm.importError\"><p class=\"import-error\">{{vm.importError}}</p>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\" ng-if=\"!vm.loading\"><div \nng-if=\"!vm.contentImporter\" flex layout=\"row\" layout-align=\"start center\"><h3 class=\"m-0\">\n{{ \'USERS.MAX_USERS_IMPORT\' | translate}}</h3></div><div flex layout=\"row\" layout-align=\"end center\"><md-button \nng-if=\"vm.importFinished\" type=\"submit\" class=\"send-button md-accent md-raised\" ng-click=\"vm.closeDialogAndUpdate()\" \ntranslate=\"USERS.ACCEPT\"></md-button><md-button ng-if=\"!vm.importFinished\" type=\"button\" class=\"md-raised md-warn\" \nng-click=\"vm.closeDialog()\" translate=\"GROUP.CANCEL\"></md-button><md-button ng-if=\"!vm.importFinished\" type=\"submit\" \nclass=\"send-button md-accent md-raised\" ng-click=\"vm.resetForm()\" translate=\"USERS.RESET\"></md-button><md-button \nng-if=\"!vm.importFinished\" ng-disabled=\"!vm.files || (vm.isQiuRestricted && !vm.groupSelectedId)\" type=\"submit\" \nclass=\"send-button md-accent md-raised\" ng-click=\"vm.importUsers()\" translate=\"USERS.IMPORT\"></md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/users/dialogs/groups/edit-group-advanced.html","<div ng-if=\"!vm.groupTypeFields.length\"><div class=\"md-warm pv-10 ph-20\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-alert-circle\" class=\"red-fg ml-0 mr-10\"></md-icon><strong \ntranslate=\"WIDGETS.JSON_ALERT_MESSAGE\" class=\"red-fg\"></strong></div><md-input-container flex=\"100\" \nclass=\"md-block mb-0 mh-20\"><label translate=\"WIDGETS.JSON\"></label><textarea name=\"groupRawSettings\" \nng-model=\"vm.groupRawSettings\" ng-keyup=\"vm.setValid(basicForm)\"></textarea><div \nng-messages=\"basicForm.groupRawSettings.$error\" md-auto-hide=\"false\"><div ng-message=\"validJson\" \ntranslate=\"GROUP.INVALID_JSON\"></div></div></md-input-container></div><div ng-if=\"vm.groupTypeFields.length\" \nng-repeat=\"field in vm.groupTypeFields\"><qiu-field field=\"field\" ng-model=\"vm.groupRawSettings\"></div>");
$templateCache.put("app/main/apps/users/dialogs/groups/edit-group.html","<md-dialog class=\"small compose-dialog\" aria-label=\"Edit Group\"><form class=\"md-inline-form\" name=\"basicForm\">\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"row\" layout-align=\"start center\"><a class=\"md-button grey-A100-fg\" type=\"import\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-folder\" class=\"s18 mr-5 ml-0 md-font material-icons\" \nrole=\"img\" aria-label=\"icon-folder\"></md-icon><span class=\"title\" ng-if=\"!(vm.group | isEmptyObject)\" \ntranslate=\"GROUP.EDIT\"></span> <span class=\"title\" ng-if=\"vm.group | isEmptyObject\" translate=\"GROUP.CREATE\"></span>\n</a></div><div layout=\"row\" layout-align=\"end center\"><md-button \nng-if=\"!vm.isAdvancedSettingsShowing && vm.hasAdvancedSettingsAccess\" class=\"md-icon-button\" \nng-click=\"vm.showSettingsAdvanced()\" translate-aria-label=\"GROUP.OPEN_SETTINGS_ADVANCED\"><md-icon \nmd-font-icon=\"icon-cog\"></md-icon><md-tooltip md-autohide=\"true\"><span translate=\"GROUP.OPEN_SETTINGS_ADVANCED\"></span>\n</md-tooltip></md-button><md-button ng-if=\"vm.isAdvancedSettingsShowing\" class=\"md-icon-button\" \nng-click=\"vm.showSettings()\" translate-aria-label=\"GROUP.OPEN_SETTINGS\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>\n<md-tooltip md-autohide=\"true\"><span translate=\"GROUP.OPEN_SETTINGS\"></span></md-tooltip></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" translate-aria-label=\"GROUP.CLOSE_DIALOG\"><md-icon\n md-font-icon=\"icon-close\"></md-icon></md-button></div></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"form-wrapper pt-20 ph-0 json-editor\" ng-show=\"!vm.isAdvancedSettingsShowing\"><md-input-container \nclass=\"md-block\"><label translate=\"GROUP.NAME\"></label><input ng-model=\"vm.groupName\" type=\"text\" required><div \nstyle=\"position: absolute;right: 0px;top: -19px;font-weight: 500;color: grey\">ID: {{vm.group.id_group}}</div>\n</md-input-container><md-input-container class=\"p-0 mb-40 md-block on-off\"><label translate=\"GROUP.STATUS\"></label>\n<md-menu-bar layout=\"row\" layout-align=\"stretch center\" class=\"p-0\"><md-menu flex><button \nclass=\"mr-0 width-percent-100 pt-5 pb-5 button-select\" ng-click=\"$mdMenu.open($event)\" aria-label=\"group-menu\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24 mr-10 ml-0\" ng-if=\"vm.groupStatusId ===1\"></md-icon>\n<md-icon md-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"on red-fg s24 mr-10 ml-0\" \nng-if=\"vm.groupStatusId ===2\"></md-icon><md-icon md-font-icon=\"icon-checkbox-blank-circle-outline\" \nclass=\"on grey-fg s24 mr-10 ml-0\" ng-if=\"vm.groupStatusId !==1 && vm.groupStatusId !==2\"></md-icon><span \nng-if=\"vm.groupStatusId ===1\" translate=\"GROUP.STATUS_PUBLIC\">Public</span> <span ng-if=\"vm.groupStatusId ===2\" \ntranslate=\"GROUP.STATUS_PRIVATE\">Private</span> <span ng-if=\"vm.groupStatusId !==1 && vm.groupStatusId !==2\" \ntranslate=\"GROUP.SELECT_STATUS\">Select</span></div><md-icon md-font-icon=\"icon-menu-down\" \nclass=\"grey-600-fg ml-10 mr-0\" aria-hidden=\"true\"></md-icon></button><md-menu-content class=\"md-block\" width=\"4\">\n<md-menu-item><button class=\"pl-10 pr-10\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.setItemStatus(1)\">\n<md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24 mr-10 ml-0\"></md-icon><span \nclass=\"font-size-14\" translate=\"GROUP.STATUS_PUBLIC\">Public</span></button></md-menu-item><md-menu-item><button \nclass=\"pl-10 pr-10\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.setItemStatus(2)\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"on red-fg s24 mr-10 ml-0\"></md-icon><span \nclass=\"font-size-14\" translate=\"GROUP.STATUS_PRIVATE\">Private</span></button></md-menu-item></md-menu-content>\n</md-menu></md-menu-bar></md-input-container><md-input-container class=\"md-block\"><label translate=\"GROUP.TYPE\">\n</label><md-select ng-model=\"vm.groupTypeId\"><md-option ng-value=\"type.id_group_type\" \nng-repeat=\"type in vm.groupTypes\">{{ type.name }}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\"><label translate=\"GROUP.SORT\"></label><input type=\"number\" ng-model=\"vm.groupSort\">\n</md-input-container><md-input-container class=\"md-block on-off\"><label translate=\"GROUP.MOVE_TO\"></label><md-menu>\n<button class=\"mr-0 width-percent-100 pb-5 pt-5 button-select\" ng-click=\"$mdMenu.open($event)\" aria-label=\"group-menu\" \nlayout=\"row\" layout-align=\"space-between center\"><span ng-if=\"vm.groupParentName\" class=\"font-size-14\">\n{{vm.groupParentName}}</span> <span ng-if=\"!vm.groupParentName\" class=\"font-size-14\">Root</span><md-icon \nmd-font-icon=\"icon-menu-down\" class=\"grey-600-fg ml-10 mr-0\" aria-hidden=\"true\"></md-icon></button><md-menu-content \nclass=\"md-block groups-tree\"><div class=\"level-card p-8 group-row ng-scope grey-100-bg\" layout=\"row\"><label \nfor=\"search-bar-input\"><md-icon ng-show=\"!vm.treeSearch\" md-font-icon=\"icon-magnify\" \nclass=\"grey-600-fg md-icon-button md-button\"><md-tooltip hide show-gt-xs><span translate=\"TOOLBAR.SEARCH\">Search</span>\n</md-tooltip></md-icon><md-icon ng-show=\"vm.treeSearch\" md-font-icon=\"icon-close-circle\" \nclass=\"grey-600-fg md-icon-button md-button\" ng-click=\"vm.treeSearch= null\"></md-icon></label><input type=\"text\" \nid=\"search-bar-input\" class=\"grey-600-fg grey-100-bg\" ng-model=\"vm.treeSearch\" placeholder=\"Search\" md-autofocus \ntranslate translate-attr-placeholder=\"TOOLBAR.SEARCH\" flex></div><div ng-if=\"!vm.isQiuRestricted\" \nng-click=\"vm.selectParentGroupRoot()\" class=\"level-card p-8 group-row ng-scope\" layout=\"row\" \nlayout-align=\"space-between stretch\"><div flex class=\"layout-align-start-center layout-row flex\"><md-icon \nmd-font-icon=\"icon-folder-multiple\" \nclass=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 ng-scope md-default-theme md-font material-icons icon-folder-multiple\" \naria-hidden=\"true\"></md-icon><span translate=\"GROUP.ROOT\"></span></div></div><div ng-click=\"$mdCloseMenu($event)\" \nng-if=\"vm.groups\" ivh-treeview=\"vm.groups\" ivh-treeview-filter=\"vm.treeSearch\" class=\"ivh-treeview-folder small\" \nivh-treeview-label-attribute=\"\'label\'\"><script type=\"text/ng-template\">\n<div class=\"level-card p-8 group-row select-parent-group-row\" layout=\"row\" layout-align=\"space-between stretch\">\r\n                        <span ivh-treeview-twistie ivh-treeview-toggle layout=\"row\" layout-align=\"center center\"></span>\r\n                        <div qiu-users-on-click-select-parent-group flex id=\"treeview-group-{{node.id_group}}\" data-group-node={{node}} layout=\"row\" layout-align=\"start center\">\r\n                            <div ng-if=\"node.group_type.icon\">\r\n                                <md-icon ng-if=\"node.group_type.icon\"\r\n                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                    md-font-icon=\"{{node.group_type.icon}}\"\r\n                                    aria-hidden=\"true\" >\r\n                                </md-icon>\r\n                            </div>\r\n                            <div ng-if=\"!node.group_type.icon\">\r\n                              <md-icon ng-if=\"!node.children && node.id_group_type == 1\"\r\n                                  class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                  md-font-icon=\"icon-folder\"\r\n                                  aria-hidden=\"true\" >\r\n                              </md-icon>\r\n                              <md-icon\r\n                                  ng-if=\"node.children && node.id_group_type == 1\"\r\n                                  class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                  md-font-icon=\"icon-folder-multiple\"\r\n                                  aria-hidden=\"true\" >\r\n                              </md-icon>\r\n                              <md-icon ng-if=\"!node.children && node.id_group_type == 2\"\r\n                                  class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                  md-font-icon=\"qiu-icon-file-usermailing\"\r\n                                  aria-hidden=\"true\" >\r\n                              </md-icon>\r\n                              <md-icon\r\n                                  ng-if=\"node.children && node.id_group_type == 2\"\r\n                                  class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                  md-svg-src=\"/assets/icons/svg/icon-folder-mail-multiple.svg\"\r\n                                  aria-hidden=\"true\" >\r\n                              </md-icon>\r\n                              <md-icon ng-if=\"!node.children && node.id_group_type == 3\"\r\n                                  class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                  md-font-icon=\"qiu-icon-file-usermediacenter\"\r\n                                  aria-hidden=\"true\" >\r\n                              </md-icon>\r\n                              <md-icon\r\n                                  ng-if=\"node.children && node.id_group_type == 3\"\r\n                                  class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                  md-svg-src=\"/assets/icons/svg/icon-folder-play-multiple.svg\"\r\n                                  aria-hidden=\"true\" >\r\n                              </md-icon>\r\n                              <md-icon ng-if=\"!node.children && node.id_group_type == 4\"\r\n                                  class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                  md-font-icon=\"qiu-icon-file-usersegment\"\r\n                                  aria-hidden=\"true\" >\r\n                              </md-icon>\r\n                              <md-icon\r\n                                  ng-if=\"node.children && node.id_group_type == 4\"\r\n                                  class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                  md-svg-src=\"/assets/icons/svg/icon-folder-share-multiple.svg\"\r\n                                  aria-hidden=\"true\" >\r\n                              </md-icon>\r\n                              <md-icon ng-if=\"!node.children && node.id_group_type == 5\"\r\n                                  class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                  md-font-icon=\"qiu-icon-file-userstore\"\r\n                                  aria-hidden=\"true\" >\r\n                              </md-icon>\r\n                              <md-icon\r\n                                  ng-if=\"node.children && node.id_group_type == 5\"\r\n                                  class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                  md-svg-src=\"/assets/icons/svg/icon-folder-shop-multiple.svg\"\r\n                                  aria-hidden=\"true\" >\r\n                              </md-icon>\r\n                              <md-icon ng-if=\"!node.children && node.id_group_type == 6\"\r\n                                  class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                  md-font-icon=\"qiu-icon-file-useracreditation\"\r\n                                  aria-hidden=\"true\" >\r\n                              </md-icon>\r\n                              <md-icon\r\n                                  ng-if=\"node.children && node.id_group_type == 6\"\r\n                                  class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                  md-svg-src=\"/assets/icons/svg/icon-folder-board-multiple.svg\"\r\n                                  aria-hidden=\"true\" >\r\n                              </md-icon>\r\n                              <md-icon ng-if=\"!node.children && node.id_group_type == 7\"\r\n                                  class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                  md-svg-src=\"/assets/icons/svg/icon-folder-chat.svg\"\r\n                                  aria-hidden=\"true\" >\r\n                              </md-icon>\r\n                              <md-icon\r\n                                  ng-if=\"node.children && node.id_group_type == 7\"\r\n                                  class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                  md-svg-src=\"/assets/icons/svg/icon-folder-chat-multiple.svg\"\r\n                                  aria-hidden=\"true\" >\r\n                              </md-icon>\r\n                              <md-icon ng-if=\"!node.children && node.id_group_type == 8\"\r\n                                  class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                  md-font-icon=\"icon-folder-remove\"\r\n                                  aria-hidden=\"true\" >\r\n                              </md-icon>\r\n                              <md-icon\r\n                                  ng-if=\"node.children && node.id_group_type == 8\"\r\n                                  class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                  md-font-icon=\"icon-folder-multiple\"\r\n                                  aria-hidden=\"true\" >\r\n                              </md-icon>\r\n                            </div>\r\n                            <span class=\"ivh-treeview-node-label ng-binding\">{{node.name}}</span>\r\n                        </div>\r\n                      </div>\r\n                    <div ivh-treeview-children></div>\n</script></div></md-menu-content></md-menu></md-input-container></div><div class=\"form-wrapper pt-20 ph-0 json-editor\" \nng-show=\"vm.isAdvancedSettingsShowing && vm.hasAdvancedSettingsAccess\" \nng-include=\"\'app/main/apps/users/dialogs/groups/edit-group-advanced.html\'\"></div></md-dialog-content><md-dialog-actions\n layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nng-click=\"delete(vm.group)\" class=\"md-icon-button\" aria-label=\"Delete\" ng-if=\"!(vm.group | isEmptyObject)\" \ntranslate-attr-aria-label=\"GROUP.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip hide show-gt-xs>\n<span translate=\"GROUP.DELETE\"></span></md-tooltip></md-button></div><div layout=\"row\" layout-align=\"end center\">\n<md-button ng-click=\"cancel()\" class=\"send-button md-warn md-raised\" aria-label=\"Cancel\" translate=\"GROUP.CANCEL\" \ntranslate-attr-aria-label=\"GROUP.CANCEL\"></md-button><md-button ng-click=\"save(vm.group)\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Save\" translate=\"GROUP.SAVE\" \ntranslate-attr-aria-label=\"GROUP.SAVE\" ng-disabled=\"basicForm.$invalid\"></md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/apps/users/dialogs/groups/users-groups-view.html","<md-dialog class=\"add-users-togroup\" aria-label=\"New Message\"><form class=\"md-inline-form\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><h1 \nclass=\"title\" translate=\"USERS.ADD_TO_GROUPS\"></h1><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content id=\"site-mailing\" ms-scroll flex class=\"content-card\"><div layout=\"row\" \nlayout-align=\"center center\" ng-hide=\"vm.treeIsLoaded\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\" \nclass=\"m-20\"></md-progress-circular></div><div ng-include=\"vm.viewUsersGroup\"></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\" ng-if=\"!vm.loading\"><md-input-container flex \nlayout=\"row\" layout-align=\"end center\" class=\"m-0\"><md-button type=\"button\" class=\"md-raised md-warn\" \nng-click=\"vm.closeDialog()\" translate=\"GROUP.CANCEL\"></md-button><md-button \nng-disabled=\"vm.selectedFields.length == 0\" type=\"submit\" class=\"send-button md-accent md-raised\" ng-click=\"vm.save()\" \ntranslate=\"USERS.SAVE\"></md-button></md-input-container></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/users/dialogs/priority/change-priority.html","<md-dialog class=\"copy-move-togroup\" style=\"width: 90%;max-width: 600px;min-width: 320px\" aria-label=\"New Message\">\n<form class=\"md-inline-form\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><h1 class=\"title\" translate=\"USERS.COPY_TO_GROUPS\" \nng-if=\"vm.selectedAction == vm.actionCopy\"></h1><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll flex class=\"content-card pl-15 pr-15 pt-15\"><div ng-if=\"vm.selectedThreads.length\"><h2 \ntranslate=\"USERS.CHANGE_PRIORITY_USERS\" class=\"mt-0 mb-0 pb-10\">Users</h2><span ng-repeat=\"user in vm.selectedThreads\">\n{{user.email}},</span></div><div ng-if=\"!vm.selectedThreads.length\"><h2 translate=\"USERS.CHANGE_PRIORITY_GROUPS\" \nclass=\"mt-0 mb-0 pb-10\">Groups</h2><span ng-repeat=\"group in vm.groups\">{{group.name}},</span></div><md-input-container\n class=\"md-block\" flex><md-select ng-model=\"vm.selectedPriority\" placeholder=\"Mailing priority\"><md-option \nng-repeat=\"prior in vm.mailingPriorities\" ng-bind=\"prior.name\" ng-value=\"prior.default\"></md-option></md-select><div \nclass=\"md-errors-spacer\"></div></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container flex layout=\"row\" layout-align=\"end center\" class=\"m-0\">\n<md-button type=\"button\" class=\"md-raised md-warn\" ng-click=\"vm.cancel()\" translate=\"GROUP.CANCEL\"></md-button>\n<md-button type=\"submit\" ng-disabled=\"vm.selectedPriority == undefined\" class=\"send-button md-accent md-raised\" \nng-click=\"vm.save()\" translate=\"USERS.ACCEPT\"></md-button></md-input-container></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/users/dialogs/users/change-in-group-status.html","<md-dialog id=\"site-users\" class=\"edit-status-dialog\" aria-label=\"EDIT\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between\"><h1 \nclass=\"mr-0 flex-100 title ng-binding layout-column layout-align-center-start\" style=\"line-height: 1\"><span \ntranslate=\"GROUP.EDIT_STATUS_FOR\">Edit status </span><strong class=\"opacity-8 mt-5 font-size-14\">\n{{vm.selectedUser.email}}</strong></h1><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div \nclass=\"form-wrapper\"><div ng-if=\"vm.isLoading\" class=\"loading-container\" flex layout=\"column\" \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular>\n</div><form ng-style=\"{\'opacity\' : (vm.isLoading) ? 0.2 : 1}\"><div style=\"overflow:auto\"><md-input-container \nclass=\"md-block status-radio\"><md-radio-group ng-model=\"vm.currentIngroupStatusId\" ng-change=\"vm.updateActions()\">\n<md-radio-button ng-repeat=\"status in vm.ingroupStatus\" ng-if=\"status.id_group_type == vm.selectedGroup.id_group_type\" \nng-value=\"status.id_ingroup_status\" class=\"{{status.name}} status\" aria-label=\"{{status.name}}\"><span \ntranslate=\"USERS.INGROUP.STATUS.{{status.name | uppercase}}\"></span></md-radio-button></md-radio-group>\n</md-input-container></div><div hide class=\"ph-24 pv-15 grey-100-bg border-top\" ng-if=\"vm.formActions != null\"><h4 \nclass=\"m-0\"><strong translate=\"USERS.OPTIONAL_ACTIONS\">Optional actions</strong></h4></div><div hide \nng-repeat=\"(name, action) in vm.formActions\" layout=\"column\" style=\"overflow:auto\" class=\"ph-24 border-top\"><div \nlayout=\"row\" layout-align=\"space-between center\" class=\"status-action\" ng-switch=\"action.field_type\" \nng-style=\"{\'opacity\' : vm.isLoading ? 0.2 : 1}\"><md-input-container ng-switch-when=\"checkbox\" class=\"mr-10\">\n<md-checkbox ng-model=\"action.formValue\" aria-label=\"{{action.name}}\" ng-true-value=\"true\" ng-false-value=\"false\" \nclass=\"md-accent md-align-center-left font-size-14\" flex>{{action.name}}</md-checkbox></md-input-container>\n<md-input-container ng-switch-when=\"checkbox\"><md-select ng-model=\"action.formLang\" \nplaceholder=\"{{vm.translate(\'GROUP.LANGUAGE\')}}\"><md-option ng-repeat=\"lang in action.languages\" \nng-selected=\"lang.isDefault\" ng-value=\"lang.value\">{{lang.name}}</md-option></md-select></md-input-container></div><div\n ng-if=\"action.formValue && action.children && child.language == action.formLang\" ng-repeat=\"child in action.children\">\n<h4 class=\"mb-0\" ng-if=\"$first\">{{action.childrenLabel}}</h4><div ng-switch=\"child.field_type\" layout=\"row\" \nclass=\"status-child\"><md-input-container ng-switch-when=\"text\" flex class=\"mb-0\"><label for=\"{{child.field}}\">\n{{child.name}}</label><input type=\"text\" id=\"{{child.field}}\" ng-model=\"child.formValue\" aria-label=\"{{child.name}}\" \nclass=\"md-accent md-align-center-left font-size-14\" flex placeholder=\"{{child.placeholder}}\"></md-input-container>\n<md-input-container ng-switch-when=\"checkbox\" flex class=\"mb-0\"><md-checkbox ng-model=\"child.formValue\" \naria-label=\"{{child.name}}\" ng-true-value=\"true\" ng-false-value=\"false\" \nclass=\"md-accent md-align-center-left font-size-14\" flex>{{child.name}}</md-checkbox></md-input-container></div></div>\n</div></form></div></md-dialog-content><md-dialog-actions><md-button class=\"send-button md-raised\" \ntranslate=\"USERS.CANCEL\" aria-label=\"CANCEL\" ng-click=\"vm.cancel()\"></md-button><md-button \nclass=\"send-button md-accent md-raised\" translate=\"USERS.SAVE\" aria-label=\"SAVE\" ng-click=\"vm.save()\"></md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/users/dialogs/users/delete-users.html","<md-dialog class=\"delete-dialog compose-dialog\" aria-label=\"DELETE\"><md-dialog-content><div ng-if=\"vm.isLoading\" \nclass=\"loading-container\" flex layout=\"column\" layout-align=\"center center\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div><h2 ng-if=\"vm.selectedThreads.length == 1\" \ntranslate=\"USERS.SURE_DELETE_SINGULAR\" class=\"mt-0 mb-0 pb-10\"></h2><h2 ng-if=\"vm.selectedThreads.length > 1\" \ntranslate=\"USERS.SURE_DELETE_PLURAL\" class=\"mt-0 mb-0 pb-10\"></h2></div></md-dialog-content><md-dialog-actions>\n<md-button class=\"send-button md-raised\" translate=\"USERS.CANCEL\" aria-label=\"CANCEL\" ng-click=\"vm.cancel()\">\n</md-button><md-button class=\"send-button md-warn md-raised\" translate=\"USERS.DELETE\" aria-label=\"DELETE\" \nng-click=\"vm.delete()\"></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/users/dialogs/save-template-export-dialog/save-template-export-dialog.html","<md-dialog class=\"save-template-export-dialog\" aria-label=\"New Message\"><form class=\"md-inline-form\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between\"><h1 class=\"title\" \ntranslate=\"USERS.SAVE_TEMPLATE\"></h1><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll flex><div class=\"ph-25\" layout=\"row\" layout-aling=\"start center\"><md-input-container flex><label \ntranslate=\"USERS.NAME\"></label><input ng-model=\"vm.name\"></md-input-container></div><div class=\"ph-25\" layout=\"row\" \nlayout-aling=\"start center\"><md-input-container flex class=\"m-0\"><label translate=\"USERS.DESCRIPTION\"></label><input \nng-model=\"vm.description\"></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"!vm.loading\"><div flex layout=\"row\" layout-align=\"end center\"><md-button \ntype=\"button\" class=\"md-raised md-warn\" ng-click=\"vm.closeDialog()\" translate=\"GROUP.CANCEL\"></md-button><md-button \nng-disabled=\"vm.name.length == 0 || vm.saving\" type=\"submit\" class=\"send-button md-accent md-raised\" \nng-click=\"vm.saveTemplate()\" translate=\"USERS.SAVE_TEMPLATE\"></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/users/users-blacklist/dialogs/delete-users.html","<md-dialog class=\"delete-dialog compose-dialog\" aria-label=\"DELETE\"><md-dialog-content><div ng-if=\"vm.isLoading\" \nclass=\"loading-container\" flex layout=\"column\" layout-align=\"center center\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div><h2 ng-if=\"vm.selectedThreads.length == 1\" \ntranslate=\"USERS.SURE_DELETE_SINGULAR\" class=\"mt-0 mb-0 pb-10\"></h2><h2 ng-if=\"vm.selectedThreads.length > 1\" \ntranslate=\"USERS.SURE_DELETE_PLURAL\" class=\"mt-0 mb-0 pb-10\"></h2></div></md-dialog-content><md-dialog-actions>\n<md-button class=\"send-button md-raised\" translate=\"USERS.CANCEL\" aria-label=\"CANCEL\" ng-click=\"vm.cancel()\">\n</md-button><md-button class=\"send-button md-warn md-raised\" translate=\"USERS.DELETE\" aria-label=\"DELETE\" \nng-click=\"vm.delete()\"></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/users/views/grid/grid-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/users/views/list/toolbar.html\'\"></div><div class=\"content-wrapper\" flex=\"\" layout=\"row\"><div\n class=\"mail-tabs-grid\" flex=\"\" md-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"content mail-list-pane-grid\" \nflex=\"\" ms-scroll=\"\"><md-progress-circular md-mode=\"indeterminate\" ng-if=\"isLoading\"></md-progress-circular><div \nclass=\"no-threads\" ng-hide=\"isLoading\" ng-if=\"!isLoading && vm.inbox.length === 0\">There are no items!</div><ms-card \nng-model=\"mail\" ng-repeat=\"thread in vm.threads | filter: vm.search | filter: global.search\" \ntemplate=\"\'app/main/apps/users/views/grid/template-grid-1.html\'\"></ms-card></div></div></div>");
$templateCache.put("app/main/apps/users/views/grid/template-grid-1.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"space-between center\" flex><div \nlayout=\"column\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-attachment\" class=\"has-attachment s24\" \nng-if=\"thread.Thumbnail.length>0\"></md-icon><button ng-if=\"thread.onoff===1\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\"></md-icon></button> <button \nng-if=\"thread.onoff!==1\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-blank-circle-outline\" \nclass=\"off red-fg s24\"></md-icon></button></div><div layout=\"column\" layout-align=\"start center\"><md-checkbox \nclass=\"no-label\" ng-checked=\"vm.isChecked(mail)\" ng-click=\"vm.toggleCheck(mail, $event)\" \naria-label=\"{{vm.isChecked(mail)? \'Uncheck\':\'check\'}}\"></md-checkbox><div ng-if=\"vm.refcolumnsgrouped.main\"><div \nclass=\"subject text-truncate\"><span ng-repeat=\"field in vm.refcolumnsgrouped.header | orderBy: \'list-sort\'\" \nng-bind=\"thread.{{field.title}}\"></span></div></div></div></div><div class=\"media\" flex layout=\"row\" \nlayout-align=\"center center\">{{vm.refcolumnsgrouped | json}}<div \nng-repeat=\"field in vm.refcolumnsgrouped.left_center | orderBy:\'list_sort\'\" \nng-if=\"field.type == \'thumbnail_square\' || field.type == \'thumbnail_\'\"><img class=\"avatar square ng-scope\" \nalt=\"{{listImage.filename}}\" ng-if=\"thread.Thumbnail.length>0\" \nng-src=\"{{listImage.cropstatus[0].container.view_url}}{{listImage.cropstatus[0].fileName}}\" \nng-repeat=\"listImage in thread.Thumbnail | filter: {\'id_zone\':field.showtype} | limitTo:1\"> <img \nclass=\"avatar square ng-scope\" alt=\"No Image\" ng-if=\"(thread.Thumbnail|filter:{\'id_zone\':field.showtype}).length == 0\" \nng-src=\"assets/images/common/no_image_available_10.png\"></div><img class=\"image\" \nng-src=\"{{card.Thumbnail[0].crop_status[0].urlformed}}\" alt=\"{{card.media.image.alt}}\" imageonloadcontrol></div><div \nclass=\"header p-16\" layout=\"row\" layout-align=\"start\"><div class=\"info\" flex layout=\"column\"><div \nng-if=\"vm.refcolumnsgrouped.main\"><div class=\"name text-truncate\" layout=\"row\" layout-align=\"start center\"><span \nng-repeat=\"field in vm.refcolumnsgrouped.main\"><span ng-bind=\"thread.{{field.title}}\"></span>&nbsp;</span></div></div>\n<div><div class=\"name text-truncate\" layout=\"row\" layout-align=\"start center\"><span><span>Title</span></span></div>\n</div><div><div class=\"details\" layout=\"row\" layout-align=\"start start\"><div layout=\"column\"><span class=\"title\">label\n</span></div><div layout=\"column\" class=\"text-truncate\"><span class=\"detail\">name</span></div></div></div><div \nng-repeat=\"field in vm.refcolumnsgrouped.secondary | orderBy:\'list_sort\'\"><div \nng-if=\"(field.type!==\'date\' && field.type!==\'dateHm\') && field.primary!==1\" class=\"details\" layout=\"row\" \nlayout-align=\"start start\"><div layout=\"column\"><span class=\"title\" ng-bind=\"field.title\"></span></div><div \nlayout=\"column\" class=\"text-truncate\"><span class=\"detail\" ng-bind=\"thread.{{field.title}}\"></span></div></div></div>\n</div></div></div>");
$templateCache.put("app/main/apps/users/views/grid/template-grid.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s20\" ng-if=\"card.onoff===1\"></md-icon><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s20\" ng-if=\"card.onoff===0\"></md-icon><div \nclass=\"info\"><div class=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.Thumbnail[0].crop_status[0].urlformed}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.Thumbnail[0].crop_status[0]\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/main/apps/users/views/read/edit-preview.html","<div id=\"users-edit\" class=\"page-layout simple fullwidth mail-content content-edit\" layout=\"column\"><md-tabs><md-tab \nlabel=\"{{ \'USERS.EDIT\' | translate}}\"><div layout=\"row\" style=\"padding-bottom: 0px\" \nng-include=\"\'app/main/apps/users/views/read/tab-edit.html\'\"></div></md-tab><md-tab label=\"Media\" \nng-if=\"!vm.isAccreditations\"><div ng-include=\"\'app/main/apps/users/views/read/tab-media.html\'\"></div></md-tab><md-tab \nlabel=\"{{ \'USERS.USERS_GROUPS\' | translate}}\" ng-if=\"!vm.isAccreditations\"><div \nng-include=\"\'app/main/apps/users/views/read/tab-users-groups.html\'\"></div></md-tab><md-tab label=\"SEO\" \nng-if=\"vm.ActiveSection.seo && !vm.isAccreditations\"><div ng-include=\"\'app/main/apps/users/views/read/tab-seo.html\'\">\n</div></md-tab><md-tab label=\"{{ \'USERS.ACTIVITY\' | translate}}\" \nng-if=\"vm.ActiveSection.activity && !vm.isAccreditations\"><div \nng-include=\"\'app/main/apps/users/views/read/tab-activity.html\'\"></div></md-tab></md-tabs></div>");
$templateCache.put("app/main/apps/users/views/read/edit-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-if=\"vm.loadingReadPane\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nng-show=\"!vm.loadingReadPane\"><div class=\"mail-content\" layout=\"column\" layout-align=\"center center\" \nng-if=\"!vm.selectedContent\"><div class=\"content\" layout=\"column\" layout-align=\"top center\"><div class=\"message\">\nPlease select an item to show in this panel</div></div></div><div class=\"toolbar grey-100-bg colored-bg\" layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"vm.selectedContent\" scroll=\"\"><div layout=\"row\" layout-align=\"start center\">\n<md-button class=\"md-icon-button close-thread\" aria-label=\"Back\" ng-click=\"vm.closeThread()\" translate \ntranslate-attr-aria-label=\"CONTENT.BACK\"><md-icon md-font-icon=\"icon-arrow-right\"></md-icon></md-button></div><div \nlayout=\"row\" layout-align=\"end center\" ng-if=\"vm.currentThread_Edit\"><md-button type=\"submit\" \nng-click=\"vm.saveItem(vm.currentThread_Edit)\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.basicForm.$invalid || vm.basicForm.$pristine\" aria-label=\"SAVE\" translate=\"CONTENT.SAVE\" \ntranslate-attr-aria-label=\"CONTENT.SAVE\">SAVE</md-button><md-button type=\"button\" ng-click=\"vm.closeThreadEdit()\" \nclass=\"md-raised md-warn\" aria-label=\"Cancel\">Cancel</md-button></div></div><md-content ng-if=\"vm.selectedContent\" \nng-include=\"\'app/main/apps/users/views/read/edit-preview.html\'\" class=\"scrollable\"></md-content></div>");
$templateCache.put("app/main/apps/users/views/read/item-context-menu.html","<md-menu md-offset=\"0 -5\" id=\"context-menu\"><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"ctrl.openMenu($mdMenu.open, $event)\"><md-icon md-menu-origin md-svg-icon=\"call:ring-volume\"></md-icon>\n</md-button><md-menu-content width=\"4\"><md-menu-item ng-repeat=\"item in [1, 2, 3]\"><md-button \nng-click=\"ctrl.announceClick($index)\"><span md-menu-align-target>Option</span> {{item}}</md-button></md-menu-item>\n</md-menu-content></md-menu>");
$templateCache.put("app/main/apps/users/views/read/mailing.html","<div id=\"users-activity\" class=\"page-layout simple fullwidth mail-content content-edit scrollable\" layout=\"column\" \nms-scroll=\"vm.msScrollOptions\"><md-list-item class=\"main-item\"><div class=\"main-read\"><div class=\"avatar-container\">\n<div ng-if=\"vm.selectedContent.avatar == \'\' || !vm.selectedContent.avatar\" class=\"avatar {{vm.selectedColor}}\" \nng-bind=\"vm.selectedContent[\'firstname\'] | capitalizeFirstLetter\"></div><media \nng-if=\"vm.selectedContent.avatar !== \'\' && vm.selectedContent.avatar\" attachment=\"vm.selectedContent.avatar\" \nclass=\"avatar fix\"></media><div \nng-repeat=\"field in vm.selectedContent_refgrouped.user_status | orderBy:\'preview_sort\'\" class=\"status\"><span \nng-if=\"field.type==\'user_status\'\"><button ng-if=\"vm.selectedContent[field.title]===0\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\"></md-icon></button> <button \nng-if=\"vm.selectedContent[field.title]===1\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-minus-circle\" \nclass=\"on amber-400-fg s24\"></md-icon></button> <button ng-if=\"vm.selectedContent[field.title]===2\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\"></md-icon></button> \n<button \nng-if=\"vm.selectedContent[field.title]!==0 && vm.selectedContent[field.title]!==1 && vm.selectedContent[field.title]!==2\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"on grey-fg s24\"></md-icon></button>\n</span></div></div></div><div class=\"main-read\" layout=\"column\" layout-align=\"center start\"><div \nng-repeat=\"field in vm.selectedContent_refgrouped.header_main | orderBy:\'preview_sort\'\" class=\"header-element\" \nlayout=\"row\" layout-align=\"center center\"><p ng-if=\"field.type==\'id\'\" class=\"font-size-14\"><span class=\"grey-500-fg\">\nID # </span><span class=\"grey-500-fg\" ng-bind=\"vm.selectedContent[field.title]\"></span></p></div><h1 class=\"name\">\n<strong ng-repeat=\"field in vm.selectedContent_refgrouped.main | orderBy:\'preview_sort\'\" \nng-bind=\"vm.selectedContent[field.title]\" class=\"mr-10\"></strong></h1></div><md-divider></md-divider></md-list-item>\n<div ng-if=\"vm.logs.length > 0\" flex=\"100\"><div class=\"grey-100-bg border-bottom text-center toolbar-log\" layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"40\" flex-gt-xs=\"60\"></div><div flex=\"10\" layout=\"row\" \nlayout-align=\"center center\"><h3 class=\"grey-700-fg font-size-14\">{{ \'USERS.MAIL.SENT\' | translate}}</h3></div><div \nflex=\"10\" layout=\"row\" layout-align=\"center center\"><h3 class=\"grey-700-fg font-size-14\">\n{{ \'USERS.MAIL.DELIVERED\' | translate}}</h3></div><div flex=\"40\" flex-gt-xs=\"20\" layout=\"row\" \nlayout-align=\"end center\"></div></div><md-list class=\"pt-0\" ng-style=\"{\'opacity\' : vm.loadingLogsReadPane ? 0.2 : 1}\">\n<md-list-item class=\"border-bottom text-center item-log\" ng-repeat=\"log in vm.logs\"><div flex layout=\"row\"><div \nflex=\"40\" flex-gt-xs=\"60\" class=\"text-left word-break-word pl-20\" layout=\"column\"><p \nclass=\"m-0 subject text-truncate grey-500-fg\" ng-bind=\"log.scheduled_at\"></p><h4 class=\"m-0 font-weight-500\" \nng-bind=\"log.mailing_content.subject\"></h4></div><div flex=\"10\" layout=\"row\" layout-align=\"center center\"><md-icon \nng-if=\"log.sent_at\" md-font-icon=\"icon-checkbox-marked-circle green-fg\" class=\"s24\"><md-tooltip md-autohide=\"true\">\n{{log.sent_at}}</md-tooltip></md-icon><md-icon ng-if=\"!log.sent_at\" md-font-icon=\"icon-window-close red-fg\" \nclass=\"s24\"></md-icon></div><div flex=\"10\" layout=\"row\" layout-align=\"center center\"><md-icon ng-if=\"log.delivered_at\" \nmd-font-icon=\"icon-checkbox-marked-circle green-fg\" class=\"s24\"><md-tooltip md-autohide=\"true\">{{log.delivered_at}}\n</md-tooltip></md-icon><md-icon ng-if=\"!log.delivered_at\" md-font-icon=\"icon-window-close red-fg\" class=\"s24\">\n</md-icon></div><div flex=\"40\" flex-gt-xs=\"20\" layout-align=\"end center\" layout=\"row\" class=\"pr-20\"><div \nng-if=\"log.clicked_at\" layout=\"column\" layout-align=\"center center\" class=\"ml-5\"><button \nclass=\"status green-300-bg pill\">{{\'USERS.MAIL.CLICKED\' | translate}}<md-tooltip md-autohide=\"true\">\n{{vm.getDateFormat(log.clicked_at)}}</md-tooltip></button></div><div ng-if=\"log.opened_at\" layout=\"column\" \nlayout-align=\"center center\" class=\"ml-5\"><button class=\"status green-700-bg pill\">{{\'USERS.MAIL.OPEN\' | translate}}\n<md-tooltip md-autohide=\"true\">{{vm.getDateFormat(log.opened_at)}}</md-tooltip></button></div><div \nng-if=\"log.bounced_at && log.bounceType == \'Permanent\'\" layout=\"column\" layout-align=\"center center\" class=\"ml-5\">\n<button class=\"status pill red-bg white-fg\">{{\'USERS.MAIL.HARD_BOUNCE\' | translate}}<md-tooltip md-autohide=\"true\">\n{{vm.getDateFormat(log.bounced_at)}}</md-tooltip></button></div><div \nng-if=\"log.bounced_at && log.bounceType == \'Transient\'\" layout=\"column\" layout-align=\"center center\" class=\"ml-5\">\n<button class=\"status pill amber-bg white-fg\">{{\'USERS.MAIL.SOFT_BOUNCE\' | translate}}<md-tooltip md-autohide=\"true\">\n{{vm.getDateFormat(log.bounced_at)}}</md-tooltip></button></div><div \nng-if=\"log.bounced_at && log.bounceType != \'Transient\' && log.bounceType != \'Permanent\'\" layout=\"column\" \nlayout-align=\"center center\" class=\"ml-5\"><button class=\"status pill grey-bg white-fg\">\n{{\'USERS.MAIL.UNDEFINED\' | translate}}<md-tooltip md-autohide=\"true\">{{vm.getDateFormat(log.bounced_at)}}</md-tooltip>\n</button></div><div ng-if=\"log.suppressed_at\" layout=\"column\" layout-align=\"center center\" class=\"ml-5\"><button \nclass=\"status pill grey-bg white-fg\">{{\'USERS.MAIL.SUPPRESSED\' | translate}}<md-tooltip md-autohide=\"true\">\n{{vm.getDateFormat(log.suppressed_at)}}</md-tooltip></button></div><div ng-if=\"log.rejected_at\" layout=\"column\" \nlayout-align=\"center center\" class=\"ml-5\"><button class=\"status pill grey-bg white-fg\">\n{{\'USERS.MAIL.REJECTED\' | translate}}<md-tooltip md-autohide=\"true\">{{vm.getDateFormat(log.rejected_at)}}</md-tooltip>\n</button></div><div ng-if=\"log.complained_at\" layout=\"column\" layout-align=\"center center\" class=\"ml-5\"><button \nclass=\"status pill grey-bg white-fg\">{{\'USERS.MAIL.COMPLAINED\' | translate}}<md-tooltip md-autohide=\"true\">\n{{vm.getDateFormat(log.complained_at)}}</md-tooltip></button></div><div ng-if=\"log.is_blacklisted\" layout=\"column\" \nlayout-align=\"center center\" class=\"ml-5\"><button class=\"status pill brown-600-bg white-fg\">\n{{\'USERS.MAIL.UNSUSCRIBED\' | translate}}</button></div></div></div></md-list-item><div \nng-if=\"!isLoading && vm.pagination_total_log_pages> vm.pagination_log_page && vm.logs.length > 0\" \nclass=\"load-more white p-30\" layout=\"row\" layout-sm=\"column\" layout-align=\"center center\" layout-wrap=\"\"><md-button \nng-click=\"vm.getLogs(vm.selectedContent.email, vm.nextPageLog)\" class=\"md-raised\">{{\'GLOBAL.LOAD_MORE\' | translate}}\n</md-button></div><div class=\"white p-30\"></div></md-list></div><div ng-if=\"vm.logs.length === 0\" \nclass=\"load-more white p-30\" layout=\"row\" layout-sm=\"column\" layout-align=\"center center\" layout-wrap=\"\"><div \nclass=\"message\" translate=\"USERS.NO_RESULTS\"></div></div></div>");
$templateCache.put("app/main/apps/users/views/read/parent-group.html","<parent-group flex ng-if=\"vm.parent.parentGroup\" parent=\"vm.parent.parentGroup\"></parent-group><md-icon \nng-if=\"vm.parent.id_group_type == 1\" md-font-icon=\"icon-folder\" class=\"{{vm.parent.color}}-fg s24 mt-0 ml-0 mb-0\" \naria-hidden=\"true\"><md-tooltip>{{vm.parent.name}}</md-tooltip></md-icon><md-icon ng-if=\"vm.parent.id_group_type == 2\" \nmd-font-icon=\"qiu-icon-file-usermailing\" class=\"{{vm.parent.color}}-fg s24 mt-0 ml-0 mb-0\" aria-hidden=\"true\">\n<md-tooltip>{{vm.parent.name}}</md-tooltip></md-icon><md-icon ng-if=\"vm.parent.id_group_type == 3\" \nmd-font-icon=\"qiu-icon-file-usermediacenter\" class=\"{{vm.parent.color}}-fg s24 mt-0 ml-0 mb-0\" aria-hidden=\"true\">\n<md-tooltip>{{vm.parent.name}}</md-tooltip></md-icon><md-icon ng-if=\"vm.parent.id_group_type == 4\" \nmd-font-icon=\"qiu-icon-file-usersegment\" class=\"{{vm.parent.color}}-fg s24 mt-0 ml-0 mb-0\" aria-hidden=\"true\">\n<md-tooltip>{{vm.parent.name}}</md-tooltip></md-icon><md-icon ng-if=\"vm.parent.id_group_type == 5\" \nmd-font-icon=\"qiu-icon-file-userstore\" class=\"{{vm.parent.color}}-fg s24 mt-0 ml-0 mb-0\" aria-hidden=\"true\">\n<md-tooltip>{{vm.parent.name}}</md-tooltip></md-icon><md-icon ng-if=\"vm.parent.id_group_type == 6\" \nmd-font-icon=\"qiu-icon-file-useracreditation\" class=\"{{vm.parent.color}}-fg s24 mt-0 ml-0 mb-0\" aria-hidden=\"true\">\n<md-tooltip>{{vm.parent.name}}</md-tooltip></md-icon><md-icon ng-if=\"vm.parent.id_group_type == 7\" \nmd-svg-src=\"/assets/icons/svg/icon-folder-chat.svg\" class=\"{{vm.parent.color}}-fg s24 mt-0 ml-0 mb-0\" \naria-hidden=\"true\"><md-tooltip>{{vm.parent.name}}</md-tooltip></md-icon><md-icon ng-if=\"vm.parent.id_group_type == 8\" \nmd-font-icon=\"icon-folder-remove\" class=\"{{vm.parent.color}}-fg s24 mt-0 ml-0 mb-0\" aria-hidden=\"true\"><md-tooltip>\n{{vm.parent.name}}</md-tooltip></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"mr-5\"></md-icon>");
$templateCache.put("app/main/apps/users/views/read/read-view-accreditations.html","<div flex layout=\"column\" layout-align=\"center center\" ng-if=\"vm.loadingReadPane\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nng-show=\"vm.selectedContent\" hide-gt-sm \nclass=\"border-bottom accreditations-toolbar white-bg h-40 pv-10 p-relative ph-10\" layout=\"row\" \nlayout-align=\"end center\" scroll=\"\"><md-icon ng-click=\"vm.hideAcc()\" md-font-icon=\"icon-close\" class=\"m-0\" role=\"img\" \naria-hidden=\"true\"></md-icon></div><div id=\"read-view-accreditations\" ng-show=\"!vm.loadingReadPane\"><div \nclass=\"mail-content\" layout=\"column\" layout-align=\"center center\" ng-if=\"!vm.selectedContent\"><div class=\"content\" \nlayout=\"column\" layout-align=\"top center\"><div class=\"message\">Please select an item to show in this panel</div></div>\n</div><div class=\"toolbar grey-100-bg colored-bg\" layout=\"row\" layout-align=\"space-between center\" \nng-if=\"vm.selectedContent\" scroll=\"\"><div layout=\"row\" layout-align=\"start center\"><md-button aria-label=\"Preview\" \nclass=\"md-icon-button\" ng-class=\"{\'md-accent\':vm.currentTab == \'preview\'}\" ng-click=\"vm.viewPreview()\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.PREVIEW\" ng-if=\"vm.selectedContent.id_user\"><md-icon md-font-icon=\"icon-eye\">\n</md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.PREVIEW\">Preview</span></md-tooltip></md-button><div \nclass=\"divider-vertical\" hide=\"\" show-gt-sm=\"\" ng-if=\"vm.selectedContent.id_user\"></div><md-button aria-label=\"Edit\" \nclass=\"md-icon-button\" ng-class=\"{\'md-accent\':vm.currentTab == \'edit\'}\" ng-click=\"vm.viewEditInline();\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.EDIT\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip hide show-gt-xs>\n<span translate=\"CONTENT.EDIT\">Edit</span></md-tooltip></md-button><div \nng-if=\"vm.selectedContent.id_user && vm.selectedGroupsAcc && vm.userInvitationUrlIndividual\" class=\"divider-vertical\" \nhide=\"\" show-gt-sm=\"\"></div><md-button \nng-if=\"vm.selectedContent.id_user && vm.selectedGroupsAcc && vm.userInvitationUrlIndividual\" \naria-label=\"Invite to Group\" class=\"md-icon-button\" \nng-click=\"vm.inviteToGroupIndividual(vm.selectedContent, vm.selectedGroupsAcc)\" translate=\"\" \ntranslate-attr-aria-label=\"USERS.INVITE_TO_GROUP\"><md-icon md-font-icon=\"icon-email\"></md-icon><md-tooltip><span \ntranslate=\"USERS.INVITE_TO_GROUP\"></span></md-tooltip><p ng-if=\"vm.loginUrl\"><a \nng-click=\"vm.inviteToGroupIndividual(vm.selectedContent, vm.selectedGroupsAcc)\"><md-icon \nmd-font-icon=\"icon-person-plus\" class=\"m-0\"></md-icon><span class=\"font-size-15\" translate=\"USERS.INVITE_TO_GROUP\">\n</span></a></p></md-button><div \nng-if=\"vm.selectedContent.id_user && vm.selectedGroupsAcc && vm.userInvitationUrlPreview\" class=\"divider-vertical\" \nhide=\"\" show-gt-sm=\"\"></div><md-button \nng-if=\"vm.selectedContent.id_user && vm.selectedGroupsAcc && vm.userInvitationUrlPreview\" \naria-label=\"Preview invitation\" class=\"md-icon-button\" \nng-click=\"vm.inviteToGroupPreview(vm.selectedContent, vm.selectedGroupsAcc)\" translate=\"\" \ntranslate-attr-aria-label=\"USERS.INVITE_TO_GROUP\"><md-icon md-font-icon=\"icon-email-open\"></md-icon><md-tooltip><span \ntranslate=\"USERS.PREVIEW_INVITATION_TO_GROUP\"></span></md-tooltip><p ng-if=\"vm.loginUrl\"><a \nng-click=\"vm.inviteToGroupPreview(vm.selectedContent, vm.selectedGroupsAcc)\"><md-icon md-font-icon=\"icon-person-plus\" \nclass=\"m-0\"></md-icon><span class=\"font-size-15\" translate=\"USERS.PREVIEW_INVITATION_TO_GROUP\"></span></a></p>\n</md-button></div><div layout=\"row\" layout-align=\"end center\" \nng-if=\"vm.currentThread_Edit && vm.currentTab !== \'activity\' && vm.currentTab !== \'preview\'\"><md-button type=\"submit\" \nng-click=\"vm.saveItem(vm.currentThread_Edit)\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.basicForm.$invalid || vm.basicForm.$pristine\" aria-label=\"SAVE\" translate=\"CONTENT.SAVE\" \ntranslate-attr-aria-label=\"CONTENT.SAVE\">SAVE</md-button><md-button type=\"button\" ng-click=\"vm.closeThreadEdit()\" \nclass=\"md-raised md-warn\" aria-label=\"Cancel\">Cancel</md-button></div></div><md-content flex=\"\" \nng-show=\"vm.selectedContent && vm.currentTab === \'preview\'\"><div class=\"mail-content file-details scrollable\" \nms-scroll=\"vm.msScrollOptions\"><div class=\"main-read pv-48\" layout=\"row\" layout-align=\"start center\" flex=\"100\"><div \nclass=\"avatar-container ph-10\" flex=\"45\" flex-gt-md=\"40\" flex-gt-lg=\"30\" layout=\"row\" layout-align=\"end center\"><div \nng-if=\"vm.selectedContent.avatar == \'\' || !vm.selectedContent.avatar\" class=\"avatar {{vm.selectedColor}}\" \nng-bind=\"vm.selectedContent[\'firstname\'] | capitalizeFirstLetter\"></div><div \nng-if=\"vm.selectedContent.avatar && vm.selectedContent.avatar !== \'\'\" class=\"avatar\"><img \nng-src=\"{{vm.selectedContent.avatar}}\" alt=\"\"></div><span class=\"status-item\" hide><button \nng-if=\"vm.selectedContent.status===0\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\"></md-icon></button> <button \nng-if=\"vm.selectedContent.status===1\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-minus-circle\" \nclass=\"on amber-400-fg s24\"></md-icon></button> <button ng-if=\"vm.selectedContent.status===2\" class=\"md-icon-button\">\n<md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\"></md-icon></button> <button \nng-if=\"vm.selectedContent.status!==0 && vm.selectedContent.status!==1 && vm.selectedContent.status!==2\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"on grey-fg s24\"></md-icon></button>\n</span></div><div class=\"ph-10\" layout=\"column\" layout-align=\"center start\" flex=\"55\" flex-gt-md=\"60\" flex-gt-lg=\"70\">\n<span ng-repeat=\"field in vm.selectedContent_refgrouped.header_main | orderBy:\'preview_sort\'\"><div \nng-if=\"field.field_name !==\'lastname\'\" class=\"header-element\" layout=\"row\" layout-align=\"center center\"><p \nng-if=\"field.type==\'id\'\" class=\"font-size-14\"><span class=\"grey-500-fg\">ID # </span><span class=\"grey-500-fg\" \nng-bind=\"vm.selectedContent[field.title]\"></span></p><h1 ng-if=\"field.field_name ==\'firstname\'\" class=\"name\" \nlayout-xs=\"column\"><strong ng-bind=\"vm.selectedContent.firstname\" class=\"mr-10\"></strong> <strong \nng-bind=\"vm.selectedContent.lastname\" class=\"mr-10\"></strong></h1><p \nng-if=\"field.type!==\'id\' && field.field_name !== \'firstname\' && field.field_name !== \'lastname\'\" class=\"font-size-14\">\n<span class=\"grey-500-fg\" ng-bind=\"vm.selectedContent[field.title]\"></span></p></div></span></div></div><div \nclass=\"main-read secondary\" layout=\"column\" layout-align=\"start space-between\" flex=\"100\"><div class=\"field\" \nlayout=\"row\" ng-repeat=\"field in vm.selectedContent_refgrouped.main | orderBy:\'preview_sort\'\" flex=\"100\"><p flex=\"50\" \nflex-gt-md=\"40\" flex-gt-lg=\"30\" class=\"grey-500-fg font-size-16 text-right ph-10 pv-5 m-0\" ng-bind=\"field.field_name\">\n</p><div class=\"ph-10 pv-5\" flex=\"55\" flex-gt-md=\"60\" flex-gt-lg=\"70\" ng-switch=\"\" on=\"field.type\"><p \nclass=\"font-size-16\" ng-switch-when=\"html\" ng-bind-html=\"vm.selectedContent[field.title]\"></p><p \nclass=\"font-size-16 {{vm.selectedContent[field.title]|yesNo}}\" ng-bind-html=\"vm.selectedContent[field.title]|yesNo\" \nng-switch-when=\"status\"></p><p ng-switch-when=\"country\" \nng-if=\"vm.getCountryById(vm.selectedContent[field.title]).name\" class=\"font-size-16\" \nng-bind-html=\"vm.getCountryById(vm.selectedContent[field.title]).name\"></p><p ng-switch-when=\"country\" \nng-if=\"!vm.getCountryById(vm.selectedContent[field.title]).name\" class=\"font-size-16\">-</p><p ng-switch-when=\"state\" \nng-if=\"vm.selectedContent.related_state.name\" class=\"font-size-16\" \nng-bind-html=\"vm.selectedContent.related_state.name\"></p><p ng-switch-when=\"state\" \nng-if=\"!vm.selectedContent.related_state.name\" class=\"font-size-16\">-</p><p ng-switch-when=\"city\" \nng-if=\"vm.selectedContent.related_city.city\" class=\"font-size-16\" ng-bind-html=\"vm.selectedContent.related_city.city\">\n</p><p ng-switch-when=\"city\" ng-if=\"!vm.selectedContent.related_city.city\" class=\"font-size-16\">-</p><p \nng-switch-default=\"\" ng-if=\"field.category!=\'input_related\' && vm.isNumber(vm.selectedContent[field.title])\" \nclass=\"font-size-16\" ng-bind-html=\"vm.selectedContent[field.title]\"></p><p ng-switch-default=\"\" \nng-if=\"field.category!=\'input_related\' && vm.hasDateShow(vm.selectedContent[field.title])\" class=\"font-size-16\" \nng-bind-html=\"vm.hasDateShow(vm.selectedContent[field.title])\"></p><p ng-switch-default=\"\" \nng-if=\"field.category!=\'input_related\' && !vm.isNumber(vm.selectedContent[field.title]) && !vm.hasDateShow(vm.selectedContent[field.title]) && vm.selectedContent[field.title]\" \nclass=\"font-size-16\" ng-bind-html=\"vm.selectedContent[field.title]| autoLinkerFilter\"></p><p ng-switch-default=\"\" \nng-if=\"field.category!=\'input_related\' && !vm.isNumber(vm.selectedContent[field.title]) && !vm.selectedContent[field.title]\" \nclass=\"font-size-16\">-</p><p ng-switch-default=\"\" ng-if=\"field.category==\'input_related\'\" class=\"font-size-16\">\n{{vm.getInArray(\'id_\'+field.config,field.values, vm.selectedContent[field.title], field.config)}}</p></div></div></div>\n<div ng-if=\"vm.viewFullProfileAcc\" \nng-repeat=\"field in vm.selectedContent_refgrouped.secondary | orderBy:\'preview_sort\'\" flex=\"100\"><div flex=\"100\" \nclass=\"grey-50-bg grey-500-fg ph-0 mv-10 pv-5\" ng-if=\"field.type==\'label\'\"><p flex=\"100\" flex-gt-md=\"80\" \nflex-gt-lg=\"60\" ng-if=\"field.type==\'label\'\" class=\"mv-5 pv-5 ph-10 font-size-16 bold black-fg text-center\" \nng-bind=\"field.field_name\"></p></div><div flex=\"100\" ng-if=\"field.type!==\'label\'\" ng-switch=\"\" on=\"field.type\"><div \nclass=\"\" ng-switch-when=\"html\"><div class=\"field\" layout=\"row\"><p flex=\"50\" flex-gt-md=\"40\" flex-gt-lg=\"30\" \nclass=\"grey-500-fg font-size-16 text-right ph-10 pv-5 m-0\" ng-bind=\"field.field_name\"></p><p flex=\"50\" flex-gt-md=\"60\" \nflex-gt-lg=\"70\" class=\"font-size-16 ph-10 pv-5 m-0\" ng-bind-html=\"vm.selectedContent[field.title]\"></p></div></div><div\n class=\"\" ng-switch-when=\"status\"><div class=\"field\" layout=\"row\"><p flex=\"50\" flex-gt-md=\"40\" flex-gt-lg=\"30\" \nclass=\"grey-500-fg font-size-16 text-right ph-10 pv-5 m-0\" ng-bind=\"field.field_name\"></p><p flex=\"50\" flex-gt-md=\"60\" \nflex-gt-lg=\"70\" class=\"font-size-16 {{vm.selectedContent[field.title]|yesNo}} ph-10 pv-5 m-0\" \nng-bind-html=\"vm.selectedContent[field.title]|yesNo\"></p></div></div><div class=\"\" ng-switch-when=\"country\"><div \nclass=\"field\" layout=\"row\"><p flex=\"50\" flex-gt-md=\"40\" flex-gt-lg=\"30\" \nclass=\"grey-500-fg font-size-16 text-right ph-10 pv-5 m-0\" ng-bind=\"field.field_name\"></p><p flex=\"50\" flex-gt-md=\"60\" \nflex-gt-lg=\"70\" ng-if=\"vm.getCountryById(vm.selectedContent[field.title]).name\" class=\"font-size-16 ph-10 pv-5 m-0\" \nng-bind-html=\"vm.getCountryById(vm.selectedContent[field.title]).name\"></p><p flex=\"50\" flex-gt-md=\"60\" \nflex-gt-lg=\"70\" ng-if=\"!vm.getCountryById(vm.selectedContent[field.title]).name\" class=\"font-size-16 ph-10 pv-5 m-0\">-\n</p></div></div><div class=\"\" ng-switch-when=\"state\"><div class=\"field\" layout=\"row\"><p flex=\"50\" flex-gt-md=\"40\" \nflex-gt-lg=\"30\" class=\"grey-500-fg font-size-16 text-right ph-10 pv-5 m-0\" ng-bind=\"field.field_name\"></p><p flex=\"50\" \nflex-gt-md=\"60\" flex-gt-lg=\"70\" ng-if=\"vm.selectedContent.related_state.name\" class=\"font-size-16 ph-10 pv-5 m-0\" \nng-bind-html=\"vm.selectedContent.related_state.name\"></p><p flex=\"50\" flex-gt-md=\"60\" flex-gt-lg=\"70\" \nng-if=\"!vm.selectedContent.related_state.name\" class=\"font-size-16 ph-10 pv-5 m-0\">-</p></div></div><div class=\"\" \nng-switch-when=\"city\"><div class=\"field\" layout=\"row\"><p flex=\"50\" flex-gt-md=\"40\" flex-gt-lg=\"30\" \nclass=\"grey-500-fg font-size-16 text-right ph-10 pv-5 m-0\" ng-bind=\"field.field_name\"></p><p flex=\"50\" flex-gt-md=\"60\" \nflex-gt-lg=\"70\" ng-if=\"vm.selectedContent.related_city.city\" class=\"font-size-16 ph-10 pv-5 m-0\" \nng-bind-html=\"vm.selectedContent.related_city.city\"></p><p flex=\"50\" flex-gt-md=\"60\" flex-gt-lg=\"70\" \nng-if=\"!vm.selectedContent.related_city.city\" class=\"font-size-16 ph-10 pv-5 m-0\">-</p></div></div><div class=\"\" \nng-switch-when=\"files\"><div \nng-if=\"vm.selectedContent.files[field.title] && vm.selectedContent.files[field.title].length> 0\" layout=\"column\"><div \nclass=\"mail-list-item attachment mv-5 pointer\" ng-repeat=\"document in vm.selectedContent.files[field.title]\" \ndata-id=\"{{document.id}}\"><a style=\"text-decoration: none\" href=\"{{document.url}}\" target=\"_blank\"><div layout=\"row\" \nlayout-align=\"start center\"><div fill-width layout=\"row\" layout-align=\"start center\"><div flex=\"50\" flex-gt-md=\"40\" \nflex-gt-lg=\"30\" class=\"media photos text-right pv-5 m-0\" layout=\"row\" layout-align=\"end center\"><qiu-icon \nmediafile=\"document.filename\" class=\"mr-10\"></qiu-icon><img ng-src=\"{{document.url}}\" alt=\"\"></div><div flex=\"50\" \nflex-gt-md=\"60\" flex-gt-lg=\"70\" class=\"info ph-10 pv-5 m-0\" style=\"padding: 0px 10px\" flex layout=\"column\"><div \nclass=\"subject grey-500-fg\" layout=\"row\" layout-align=\"start center\"><span>{{vm.showDate(document.date_uploaded) }}\n</span></div><div class=\"name\" layout=\"row\" layout-align=\"start center\"><span ng-if=\"document.filename\">\n{{document.filename}}</span></div></div></div></div></a></div></div></div><div class=\"text-truncate\" \nng-switch-when=\"button\"><div class=\"field\" ng-init=\"fieldRaw = field.raw_settings\"><md-button type=\"button\" \nng-click=\"vm.buttonClick($event, fieldRaw, vm.selectedContent)\" \nclass=\"{{ fieldRaw.font_icon ? \'md-icon-button\' : \'md-raised\' }} {{ fieldRaw.background_color ? fieldRaw.background_color+\'-bg\' : \'\' }} {{ fieldRaw.foreground_color ? fieldRaw.foreground_color+\'-fg\' : \'\' }}\" \naria-label=\"{{field.field_name}}\" ng-disabled=\"vm.isSending\" translate-attr-aria-label=\"GENERIC.BUTTON.RUN\"><span \nng-if=\"!fieldRaw.font_icon\">{{field.field_name}}</span><md-icon ng-if=\"fieldRaw.font_icon\" \nmd-font-icon=\"icon-{{fieldRaw.font_icon}}\" class=\"s24 mr-20\" \nng-style=\"fieldRaw.foreground_color && {\'color\': fieldRaw.foreground_color}\"></md-icon><md-tooltip><span>\n{{field.field_name}}</span></md-tooltip></md-button></div><md-divider></md-divider></div><div class=\"\" flex=\"100\" \nng-switch-default=\"\"><div class=\"field\" layout=\"row\"><p flex=\"50\" flex-gt-md=\"40\" flex-gt-lg=\"30\" \nclass=\"grey-500-fg font-size-16 text-right ph-10 pv-5 m-0\" ng-bind=\"field.field_name\"></p><p flex=\"50\" flex-gt-md=\"60\" \nflex-gt-lg=\"70\" ng-if=\"field.category!=\'input_related\' && vm.isNumber(vm.selectedContent[field.title])\" \nclass=\"font-size-16 ph-10 pv-5 m-0\" ng-bind-html=\"vm.selectedContent[field.title]\"></p><p flex=\"50\" flex-gt-md=\"60\" \nflex-gt-lg=\"70\" ng-if=\"field.category!=\'input_related\' && vm.hasDateShow(vm.selectedContent[field.title])\" \nclass=\"font-size-16 ph-10 pv-5 m-0\" ng-bind-html=\"vm.hasDateShow(vm.selectedContent[field.title])\"></p><p flex=\"50\" \nflex-gt-md=\"60\" flex-gt-lg=\"70\" \nng-if=\"field.category!=\'input_related\' && !vm.isNumber(vm.selectedContent[field.title]) && !vm.hasDateShow(vm.selectedContent[field.title]) && vm.selectedContent[field.title]\" \nclass=\"font-size-16 ph-10 pv-5 m-0\" ng-bind-html=\"vm.selectedContent[field.title]| autoLinkerFilter\"></p><p flex=\"50\" \nflex-gt-md=\"60\" flex-gt-lg=\"70\" \nng-if=\"field.category!=\'input_related\' && !vm.isNumber(vm.selectedContent[field.title]) && !vm.selectedContent[field.title]\" \nclass=\"font-size-16 ph-10 pv-5 m-0\">-</p><p flex=\"50\" flex-gt-md=\"60\" flex-gt-lg=\"70\" \nng-if=\"field.category==\'input_related\'\" class=\"font-size-16 ph-10 pv-5 m-0\">\n{{vm.getInArray(\'id_\'+field.config,field.values, vm.selectedContent[field.title], field.config)}}</p></div></div></div>\n</div><div class=\"ml-5 mv-40\" layout=\"row\" layout-align=\"start center\" flex=\"100\"><div layout=\"row\" flex=\"100\" \nflex-gt-md=\"80\" flex-gt-lg=\"60\" class=\"ph-10 text-center\" layout-align=\"center center\"><a \nclass=\"md-button md-rounded send-button border md-accent md-link md-default-theme\" ng-if=\"!vm.viewFullProfileAcc\" \nng-click=\"vm.viewFullProfileAcc= true\"><md-icon md-font-icon=\"icon-account-plus\" class=\"mr-5\"></md-icon><span \ntranslate=\"USERS.VIEW_FULL_PROFILE\"></span> </a><a \nclass=\"md-button md-rounded send-button border md-accent md-link md-default-theme\" ng-if=\"vm.viewFullProfileAcc\" \nng-click=\"vm.viewFullProfileAcc= false\"><md-icon md-font-icon=\"icon-account-minus\" class=\"mr-5\"></md-icon><span \ntranslate=\"USERS.HIDE_FULL_PROFILE\"></span></a></div></div><div class=\"relative border-top\"><md-tabs md-dynamic-height \nflex=\"100\"><md-tab ng-repeat=\"groupParent in vm.acreditationsGroups\"><md-tab-label>{{ groupParent.label }}\n</md-tab-label><md-tab-body><div class=\"p-15\"><div ng-repeat=\"status in vm.ingroupStatus\"><span \nng-click=\"vm.changeInGroupStatusDialog($event, vm.selectedContent, groupParent, status, true)\" \nng-if=\"vm.isShowingLabelGroupTab(vm.selectedContent, status, groupParent)\" \nclass=\"{{status.name}} status pointer ml-10 mt-10 mb-20\" translate=\"USERS.INGROUP.STATUS.{{status.name | uppercase}}\" \nlayout=\"row\" layout-align=\"center center\"></span></div><div class=\"acc-list mt-20\" layout=\"column\" layout-gt-xs=\"row\" \nlayout-align=\"start start\" layout-align-gt-xs=\"start start\" flex=\"100\"><div \nng-repeat=\"refItem in vm.selectedContent_refgrouped.show_groups_inprofile | orderBy:\'preview_sort\'\" layout=\"column\" \nlayout-align=\"start start\" flex=\"35\" class=\"ph-10 text-left mv-20\"><div class=\"mb-15 bold\">{{refItem.field_name}}</div>\n<div ng-repeat=\"group in refItem.groups | filter: {\'parent\': groupParent.id_group} | orderBy:\'sort\'\" \nng-click=\"!vm.isActiveGroupUser(group) ? vm.addToGroup(group, groupParent) : vm.removeFromGroup(group, groupParent)\" \nclass=\"group pointer pv-5\" ng-class=\"{\'active\' : vm.isActiveGroupUser(group)}\" layout=\"row\"><span><md-icon \nng-if=\"group.group_type.icon\" md-font-icon=\"{{group.group_type.icon}}\" class=\"s24 mr-10 mt-0 ml-0 mb-0\" \naria-hidden=\"true\" \nng-class=\"{\'orange-300-fg\' : vm.isActiveGroupUser(group),\'grey-400-fg\' : !vm.isActiveGroupUser(group) }\"></md-icon>\n</span><span class=\"name\">{{group.name}}</span></div></div></div></div></md-tab-body></md-tab><md-tab><md-tab-label>\n<md-icon class=\"messages-icon\" md-font-icon=\"icon-message-text-outline\"></md-icon></md-tab-label><md-tab-body><div \nclass=\"chat\" layout=\"column\" flex><md-content id=\"chat-content\" flex ms-scroll><div class=\"chat-messages\"><div \nlayout=\"row\" ng-repeat=\"message in vm.selectedContent.conversations[\'accreditations\']\" class=\"md-padding message-row\" \nng-class=\"{\'user\': message.user_id}\"><img ng-if=\"dialog.who ===\'contact\'\" \nng-src=\"{{vm.contacts.getById(vm.chatContactId).avatar}}\" class=\"avatar\" \nalt=\"{{vm.contacts.getById(vm.chatContactId).name}}\"> <img ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" \nng-src=\"{{vm.user.avatar}}\"><div class=\"bubble\"><div layout=\"row\" layout-align=\"space-between\"><div \nclass=\"secondary-text\" flex>{{message.username}}</div><div class=\"secondary-text text-right\" flex>\n{{vm.showDate(message.date_created)}}</div><div class=\"secondary-text text-right\" flex=\"1\"><md-menu \nmd-position-mode=\"target-right target\"><md-button ng-click=\"$mdMenu.open()\" aria-label=\"more\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.deleteConversationMessage(\'accreditations\', $index)\" translate=\"USERS.DELETE_COMMENT\">Delete message\n</md-button></md-menu-item></md-menu-content></md-menu></div></div><div class=\"message\">{{message.message}}</div></div>\n</div></div></md-content><div class=\"chat-footer flex-noshrink\" layout=\"row\" layout-align=\"center center\"><form \nng-submit=\"vm.sendConversationMessage(\'accreditations\')\" flex class=\"reply-form\" layout=\"row\" \nlayout-align=\"start center\"><md-input-container flex md-no-float><textarea md-no-autogrow \nng-model=\"vm.conversationMessage[\'accreditations\']\" placeholder=\"Type and hit enter to send message\" translate \ntranslate-attr-placeholder=\"USERS.WRITE_COMMENT\">\r\n                              </textarea></md-input-container>\n<md-button class=\"md-fab\" type=\"submit\" aria-label=\"Send comment\" translate \nng-disabled=\"vm.conversationMessage[\'accreditations\'].length < 1\" translate-attr-aria-label=\"USERS.SEND_COMMENT\">\n<md-icon md-font-icon=\"icon-send\"></md-icon></md-button></form></div></div></md-tab-body></md-tab></md-tabs><md-button \nng-click=\"vm.inviteToGroupMultiple($event)\" ng-disabled=\"vm.selectedThreads.length == 0\" aria-label=\"Invite to group\">\n<md-icon md-font-icon=\"icon-email\"></md-icon><span translate=\"USERS.INVITE_TO_GROUP\"></span></md-button></div></div>\n</md-content><md-content ng-style=\"{\'top\': vm.$mdMedia(\'gt-sm\') ? \'0px\' : \'40px\'}\" flex=\"\" \nng-show=\"vm.selectedContent && vm.currentTab === \'edit\'\" \nng-include=\"\'app/main/apps/users/views/read/edit-preview.html\'\" class=\"scrollable\"></md-content></div>");
$templateCache.put("app/main/apps/users/views/read/read-view-nosplit.html","<div flex layout=\"column\" layout-align=\"center center\" ng-if=\"vm.loadingReadPane\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"30\"></md-progress-circular></div><div \nng-show=\"!vm.loadingReadPane\"><div class=\"mail-content\" layout=\"column\" layout-align=\"center center\" \nng-if=\"!vm.selectedContent\"><div class=\"content\" layout=\"column\" layout-align=\"top center\"><div class=\"message\">\nPlease select an item to show in this panel</div></div></div><div class=\"toolbar grey-100-bg colored-bg\" layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"vm.selectedContent\" scroll=\"\"><div layout=\"row\" layout-align=\"start center\">\n<md-button class=\"md-icon-button close-thread\" ng-if=\"vm.currentView === \'table\'\" aria-label=\"Back\" \nng-click=\"vm.closeThread()\" translate translate-attr-aria-label=\"CONTENT.BACK\"><md-icon \nmd-font-icon=\"icon-arrow-right\"></md-icon></md-button><div class=\"divider-vertical\" hide=\"\" \nng-if=\"vm.activeMailPaneIndex === 1 || vm.currentView === \'table\'\" show-gt-sm=\"\"></div><md-button aria-label=\"Preview\" \nclass=\"md-icon-button\" ng-class=\"{\'md-accent\':vm.currentTab == \'preview\'}\" ng-click=\"vm.viewPreview()\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.PREVIEW\"><md-icon md-font-icon=\"icon-eye\"></md-icon><md-tooltip hide show-gt-xs>\n<span translate=\"CONTENT.PREVIEW\">Preview</span></md-tooltip></md-button><div class=\"divider-vertical\" hide=\"\" \nshow-gt-sm=\"\"></div><md-button aria-label=\"Edit\" class=\"md-icon-button\" \nng-class=\"{\'md-accent\':vm.currentTab == \'edit\'}\" ng-click=\"vm.viewEditInline();\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.EDIT\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip hide show-gt-xs>\n<span translate=\"CONTENT.EDIT\">Edit</span></md-tooltip></md-button><div class=\"divider-vertical\" hide=\"\" show-gt-sm=\"\">\n</div><md-button aria-label=\"Activity\" class=\"md-icon-button\" ng-class=\"{\'md-accent\':vm.currentTab == \'activity\'}\" \nng-click=\"vm.currentTab = \'activity\'\" translate=\"\" translate-attr-aria-label=\"Activities\"><md-icon \nmd-font-icon=\"icon-run\"></md-icon><md-tooltip><span translate=\"ACCOUNTS.ACTIVITY\"></span></md-tooltip></md-button><div \nclass=\"divider-vertical\" hide=\"\" show-gt-sm=\"\"></div><md-button ng-if=\"vm.selectedContentID != \'new\'\" \naria-label=\"Activity\" class=\"md-icon-button\" ng-class=\"{\'md-accent\':vm.currentTab == \'mailing\'}\" \nng-click=\"vm.currentTab = \'mailing\'\" translate=\"\" translate-attr-aria-label=\"Mailing\"><md-icon \nmd-font-icon=\"icon-telegram\"></md-icon><md-tooltip><span translate=\"USERS.MAILING\"></span></md-tooltip></md-button><div\n ng-if=\"vm.loginUrl\" class=\"divider-vertical\" hide=\"\" show-gt-sm=\"\"></div><md-button \nng-if=\"vm.selectedGroup && vm.userInvitationUrlIndividual\" aria-label=\"Invite to Group\" class=\"md-icon-button\" \nng-click=\"vm.inviteToGroupIndividual(vm.selectedContent, vm.selectedGroup)\" translate=\"\" \ntranslate-attr-aria-label=\"USERS.INVITE_TO_GROUP\"><md-icon md-font-icon=\"icon-email\"></md-icon><md-tooltip><span \ntranslate=\"USERS.INVITE_TO_GROUP\"></span></md-tooltip><p ng-if=\"vm.loginUrl\"><a \nng-click=\"vm.inviteToGroupIndividual(vm.selectedContent, vm.selectedGroup)\"><md-icon md-font-icon=\"icon-person-plus\" \nclass=\"m-0\"></md-icon><span class=\"font-size-15\" translate=\"USERS.INVITE_TO_GROUP\"></span></a></p></md-button>\n<md-button ng-if=\"vm.selectedGroup && vm.userInvitationUrlPreview\" aria-label=\"Preview Invitation\" \nclass=\"md-icon-button\" ng-click=\"vm.inviteToGroupPreview(vm.selectedContent, vm.selectedGroup)\" translate=\"\" \ntranslate-attr-aria-label=\"USERS.PREVIEW_INVITATION_TO_GROUP\"><md-icon md-font-icon=\"icon-email-open\"></md-icon>\n<md-tooltip><span translate=\"USERS.PREVIEW_INVITATION_TO_GROUP\"></span></md-tooltip><p ng-if=\"vm.loginUrl\"><a \nng-click=\"vm.inviteToGroupPreview(vm.selectedContent, vm.selectedGroup)\"><md-icon md-font-icon=\"icon-person-plus\" \nclass=\"m-0\"></md-icon><span class=\"font-size-15\" translate=\"USERS.PREVIEW_INVITATION_TO_GROUP\"></span></a></p>\n</md-button><div ng-if=\"vm.loginUrl\" class=\"divider-vertical\" hide=\"\" show-gt-sm=\"\"></div><md-button \nng-if=\"vm.loginUrl\" aria-label=\"Login to website\" class=\"md-icon-button\" \nng-click=\"vm.loginToWebsite(vm.selectedContent)\" translate=\"\" translate-attr-aria-label=\"GLOBAL.LOGIN_TO_WEBSITE\">\n<md-icon md-font-icon=\"icon-web\"></md-icon><md-tooltip><span translate=\"GLOBAL.LOGIN_TO_WEBSITE\"></span></md-tooltip><p\n ng-if=\"vm.loginUrl\"><a ng-click=\"vm.loginToWebsite(vm.selectedContent)\"><md-icon md-font-icon=\"icon-web\" class=\"m-0\">\n</md-icon><span class=\"font-size-15\" translate=\"GLOBAL.LOGIN_TO_WEBSITE\"></span></a></p></md-button></div><div \nlayout=\"row\" layout-align=\"end center\" ng-if=\"vm.currentThread_Edit\" hide show-gt-xs><md-button type=\"submit\" \nng-click=\"vm.saveItem(vm.currentThread_Edit)\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.basicForm.$invalid || vm.basicForm.$pristine\" aria-label=\"SAVE\" translate=\"CONTENT.SAVE\" \ntranslate-attr-aria-label=\"CONTENT.SAVE\">SAVE</md-button><md-button type=\"button\" ng-click=\"vm.closeThreadEdit()\" \nclass=\"md-raised md-warn\" aria-label=\"Cancel\">Cancel</md-button></div><div layout=\"row\" layout-align=\"end center\" \nng-if=\"vm.currentThread_Edit\" hide-gt-xs><md-button type=\"submit\" ng-click=\"vm.saveItem(vm.currentThread_Edit)\" \nclass=\"md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme\" \nng-disabled=\"vm.basicForm.$invalid || vm.basicForm.$pristine\" aria-label=\"SAVE\"><md-icon md-font-icon=\"icon-check\" \nng-hide=\"vm.savingProcess\"></md-icon><md-progress-circular md-mode=\"indeterminate\" ng-if=\"vm.savingProcess\">\n</md-progress-circular><md-tooltip hide show-gt-xs><span translate=\"CONTENT.SAVE\">Save</span></md-tooltip></md-button>\n<md-button type=\"button\" ng-click=\"vm.closeThreadEdit()\" \nclass=\"md-warn md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme\" aria-label=\"Cancel\"><md-icon \nmd-font-icon=\"icon-window-close\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.CANCEL\">Cancel</span>\n</md-tooltip></md-button></div></div><md-content flex=\"\" ng-show=\"vm.selectedContent && !vm.editInline\"><div \nclass=\"mail-content file-details scrollable\" ms-scroll=\"vm.msScrollOptions\"><md-list><md-list-item class=\"info\" \nng-if=\"vm.selectedContent_refgrouped.header[0]\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\" \nlayout-align=\"start start\"><div ng-repeat=\"field in vm.selectedContent_refgrouped.header | orderBy:\'preview_sort\' \" \nclass=\"header-element\" layout=\"row\" layout-align=\"center center\"><div><span ng-if=\"field.type==\'user_status\'\"><button \nng-if=\"vm.selectedContent[field.title]===0\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\"></md-icon></button> <button \nng-if=\"vm.selectedContent[field.title]===1\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-minus-circle\" \nclass=\"on amber-400-fg s24\"></md-icon></button> <button ng-if=\"vm.selectedContent[field.title]===2\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\"></md-icon></button> \n<button \nng-if=\"vm.selectedContent[field.title]!==0 && vm.selectedContent[field.title]!==1 && vm.selectedContent[field.title]!==2\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"on grey-fg s24\"></md-icon></button> \n</span><span ng-if=\"field.type==\'dateHm\' || field.type==\'date\'\"><span>{{vm.selectedContent[field.title].dateShow}}\n</span> </span><span ng-if=\"field.type==\'language\'\" layout=\"row\" layout-align=\"center center\"><img \nclass=\"img-flag ng-scope\" alt=\"{{vm.siteLanguages(vm.selectedContent[field.title])[lang_name]}}\" \nng-src=\"assets/images/flags/{{vm.siteLanguages()[vm.selectedContent[field.title]].flag_code|lowercase}}.svg\"> </span>\n<span ng-if=\"field.type==\'id_subsec\' && vm.selectedContent[field.title].length!=0\"><span class=\"grey-500-fg\">\n{{field.field_name}} </span><span \nng-bind=\"vm.getReferencesSections(\'subsection\', field.type, vm.selectedContent[field.title])\"></span> </span><span \nng-if=\"field.type==\'id_cat\' && vm.selectedContent[field.title].length!=0\"><span class=\"grey-500-fg\">\n{{field.field_name}} </span><span \nng-bind=\"vm.getReferencesSections(\'cat\', field.type, vm.selectedContent[field.title])\"></span> </span><span \nng-if=\"field.type==\'id_subcat\' && vm.selectedContent[field.title].length!=0\"><span class=\"grey-500-fg\">\n{{field.field_name}} </span><span \nng-bind=\"vm.getReferencesSections(\'subcat\', field.type, vm.selectedContent[field.title])\"></span></span></div></div>\n</div></md-list-item><md-list-item class=\"main-item\"><div class=\"main-read\"><div class=\"avatar-container\"><div \nng-if=\"vm.selectedContent.avatar == \'\' || !vm.selectedContent.avatar\" class=\"avatar {{vm.selectedColor}}\" \nng-bind=\"vm.selectedContent[\'firstname\'] | capitalizeFirstLetter\"></div><media \nng-if=\"vm.selectedContent.avatar && vm.selectedContent.avatar !== \'\'\" attachment=\"vm.selectedContent.avatar\" \nclass=\"avatar fix\"></media><div \nng-repeat=\"field in vm.selectedContent_refgrouped.user_status | orderBy:\'preview_sort\' \" class=\"status\"><span \nng-if=\"field.type==\'user_status\'\"><button ng-if=\"vm.selectedContent[field.title]===0\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\"></md-icon></button> <button \nng-if=\"vm.selectedContent[field.title]===1\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-minus-circle\" \nclass=\"on amber-400-fg s24\"></md-icon></button> <button ng-if=\"vm.selectedContent[field.title]===2\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\"></md-icon></button> \n<button \nng-if=\"vm.selectedContent[field.title]!==0 && vm.selectedContent[field.title]!==1 && vm.selectedContent[field.title]!==2\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"on grey-fg s24\"></md-icon></button>\n</span></div></div></div><div class=\"main-read\" layout=\"column\" layout-align=\"center start \"><div \nng-repeat=\"field in vm.selectedContent_refgrouped.header_main | orderBy:\'preview_sort\' \" class=\"header-element\" \nlayout=\"row\" layout-align=\"center center\"><p ng-if=\"field.type==\'id\'\" class=\"font-size-14\"><span class=\"grey-500-fg\">\nID # </span><span class=\"grey-500-fg\" ng-bind=\"vm.selectedContent[field.title]\"></span></p></div><h1 class=\"name\">\n<strong ng-repeat=\"field in vm.selectedContent_refgrouped.main | orderBy:\'preview_sort\' \" \nng-bind=\"vm.selectedContent[field.title]\" class=\"mr-10\"></strong></h1></div><md-divider></md-divider></md-list-item>\n<div ng-repeat=\"field in vm.selectedContent_refgrouped.secondary | orderBy:\'preview_sort\' \"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg\" ng-if=\"field.type==\'label\'\"><h3 class=\"grey-700-fg\" ng-bind=\"field.field_name\">\n</h3><md-divider></md-divider></md-list-item><md-list-item flex=\"100\" ng-if=\"field.type!==\'label\'\" ng-switch=\"\" \non=\"field.type\"><div class=\"text-truncate\" ng-switch-when=\"html\"><div class=\"field\"><p \nclass=\"grey-500-fg font-size-14\" ng-bind=\"field.field_name\"></p><span class=\"font-size-16 text-truncate\" \nng-bind-html=\"vm.selectedContent[field.title]\"></span><br></div><md-divider></md-divider></div><div \nclass=\"text-truncate\" ng-switch-when=\"status\"><div class=\"field\"><p class=\"grey-500-fg font-size-14\" \nng-bind=\"field.field_name\"></p><span class=\"font-size-16 text-truncate {{vm.selectedContent[field.title]|yesNo}}\" \nng-bind-html=\"vm.selectedContent[field.title]|yesNo\"></span><br></div><md-divider></md-divider></div><div \nclass=\"text-truncate\" ng-switch-when=\"country\"><div class=\"field\"><p class=\"grey-500-fg font-size-14 ng-binding\" \nng-bind=\"field.field_name\"></p><span ng-if=\"vm.getCountryById(vm.selectedContent[field.title]).name\" \nclass=\"font-size-16 text-truncate\" ng-bind-html=\"vm.getCountryById(vm.selectedContent[field.title]).name\"></span> <span\n ng-if=\"!vm.getCountryById(vm.selectedContent[field.title]).name\" class=\"font-size-16 text-truncate\">-</span><br></div>\n<md-divider></md-divider></div><div class=\"text-truncate\" ng-switch-when=\"state\"><div class=\"field\"><p \nclass=\"grey-500-fg font-size-14 ng-binding\" ng-bind=\"field.field_name\"></p><span \nng-if=\"vm.selectedContent.related_state.name\" class=\"font-size-16 text-truncate\" \nng-bind-html=\"vm.selectedContent.related_state.name\"></span> <span ng-if=\"!vm.selectedContent.related_state.name\" \nclass=\"font-size-16 text-truncate\">-</span><br></div><md-divider></md-divider></div><div class=\"text-truncate\" \nng-switch-when=\"city\"><div class=\"field\"><p class=\"grey-500-fg font-size-14 ng-binding\" ng-bind=\"field.field_name\"></p>\n<span ng-if=\"vm.selectedContent.related_city.city\" class=\"font-size-16 text-truncate\" \nng-bind-html=\"vm.selectedContent.related_city.city\"></span> <span ng-if=\"!vm.selectedContent.related_city.city\" \nclass=\"font-size-16 text-truncate\">-</span><br></div><md-divider></md-divider></div><div class=\"files\" \nng-switch-when=\"files\"><div \nng-if=\"vm.selectedContent.files[field.title] && vm.selectedContent.files[field.title].length> 0\" layout=\"column\"><div \nclass=\"mail-list-item attachment mv-5 pointer\" ng-repeat=\"document in vm.selectedContent.files[field.title]\" \ndata-id=\"{{document.id}}\"><a style=\"text-decoration: none\" href=\"{{document.url}}\" target=\"_blank\"><div layout=\"row\" \nlayout-align=\"start center\"><div fill-width layout=\"row\" layout-align=\"start center\"><div flex=\"20\" flex-xs=\"20\" \nflex-gt-md=\"20\" flex-gt-lg=\"20\" class=\"media photos text-right pv-5 m-0\" layout=\"row\" layout-align=\"start center\">\n<qiu-icon mediafile=\"document.filename\" class=\"mr-10\"></qiu-icon></div><div flex=\"80\" flex-gt-md=\"80\" flex-gt-lg=\"80\" \nclass=\"info ph-10 pv-5 m-0\" style=\"padding: 0px 0px\" flex layout=\"column\"><p \nclass=\"grey-500-fg font-size-16 ng-binding mb-5 mt-0\" ng-bind=\"field.field_name\"></p><div class=\"subject grey-500-fg\" \nlayout=\"row\" layout-align=\"start center\"><span>{{vm.showDate(document.date_uploaded)}}</span></div><div class=\"name\" \nlayout=\"row\" layout-align=\"start center\"><span ng-if=\"document.filename\">{{document.filename}}</span></div><div \nclass=\"name\" layout=\"row\" layout-align=\"start center\"><span ng-if=\"document.filename\">{{document.field}}</span></div>\n</div></div></div></a></div></div></div><div class=\"text-truncate\" ng-switch-when=\"button\"><div class=\"field\" \nng-init=\"fieldRaw = field.raw_settings\"><md-button type=\"button\" \nng-click=\"vm.buttonClick($event, fieldRaw, vm.selectedContent)\" \nclass=\"{{ fieldRaw.font_icon ? \'md-icon-button\' : \'md-raised\' }} {{ fieldRaw.background_color ? fieldRaw.background_color+\'-bg\' : \'\' }} {{ fieldRaw.foreground_color ? fieldRaw.foreground_color+\'-fg\' : \'\' }}\" \naria-label=\"{{field.field_name}}\" ng-disabled=\"vm.isSending\" translate-attr-aria-label=\"GENERIC.BUTTON.RUN\"><span \nng-if=\"!fieldRaw.font_icon\">{{field.field_name}}</span><md-icon ng-if=\"fieldRaw.font_icon\" \nmd-font-icon=\"icon-{{fieldRaw.font_icon}}\" class=\"s24 mr-20\" \nng-style=\"fieldRaw.foreground_color && {\'color\': fieldRaw.foreground_color}\"></md-icon><md-tooltip><span>\n{{field.field_name}}</span></md-tooltip></md-button><md-divider></md-divider></div></div><div class=\"text-truncate\" \nflex=\"100\" ng-switch-default=\"\"><div class=\"field\"><p class=\"grey-500-fg font-size-14\" ng-bind=\"field.field_name\"></p>\n<span ng-if=\"field.category!=\'input_related\' && vm.isNumber(vm.selectedContent[field.title])\" \nclass=\"font-size-16 text-truncate\" ng-bind-html=\"vm.selectedContent[field.title]\"></span> <span \nng-if=\"field.category!=\'input_related\' && !vm.isNumber(vm.selectedContent[field.title])\" \nclass=\"font-size-16 text-truncate\" ng-bind-html=\"vm.selectedContent[field.title]| autoLinkerFilter\"></span> <span \nng-if=\"field.category==\'input_related\'\" class=\"font-size-16 text-truncate\">\n{{vm.getInArray(\'id_\'+field.config,field.values, vm.selectedContent[field.title], field.config)}}</span><br></div>\n<md-divider></md-divider></div></md-list-item></div><div ng-if=\"vm.selectedContent.tags\"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg\"><h3 class=\"grey-700-fg\" translate=\"CONTENT.ATTACHMENTS\">\nTags ({{vm.selectedContent.tags.length}})</h3><md-divider></md-divider></md-list-item><md-list-item><md-chips \nname=\"tag_name\" ng-model=\"vm.selectedContent.tags\" readonly=\"true\"><md-chip-template><span>\n{{$chip.tag_name}} #{{$chip.id_tag}}</span></md-chip-template></md-chips><md-divider></md-divider></md-list-item></div>\n<div ng-if=\"vm.selectedContent.Thumbnail\"><md-list-item class=\"md-toolbar-tools grey-100-bg\"><h3 class=\"grey-700-fg\" \ntranslate=\"CONTENT.ATTACHMENTS\">Attachments ({{vm.selectedContent.Thumbnail.length}})</h3><md-divider></md-divider>\n</md-list-item><md-list-item ng-repeat=\"zone in vm.mediaZones\" ng-if=\"vm.mediaZones\"><div class=\"attachments\"><div \nclass=\"field\"><p class=\"grey-500-fg font-size-14\">{{ zone.title }}</p><div class=\"attachment-list md-list-item-text\" \nlayout=\"row\" layout-wrap=\"\" layout-align=\"start start\"><div class=\"attachment\" \nng-repeat=\"attachment in vm.selectedContent.Thumbnail | filter: {\'id_zone\':zone.id_zone}\"><div \nclass=\"preview document\" layout=\"row\" layout-align=\"start center\" extension-class=\"{{attachment.filename}}\" \nng-href=\"{{attachment.permalink}}\" ng-if=\"attachment.media_type==3\" target=\"_blank\"><media attachment=\"attachment\">\n</media><a class=\"grey-1000-fg font-size-16\" ng-href=\"{{attachment.permalink}}\" target=\"_blank\"><span \nng-if=\"attachment.title\">{{attachment.title}} </span><span ng-if=\"attachment.filename\">{{attachment.filename}}</span>\n</a></div><div class=\"preview document\" layout=\"row\" layout-align=\"start center\" \nextension-class=\"{{attachment.filename}}\" ng-href=\"{{attachment.permalink}}\" ng-if=\"attachment.media_type==4\" \ntarget=\"_blank\"><media attachment=\"attachment\"></media><a class=\"grey-1000-fg font-size-16\" \nng-href=\"{{attachment.permalink}}\" target=\"_blank\"><span ng-if=\"attachment.filename\">{{attachment.filename}}</span></a>\n</div><div ng-if=\"attachment.media_type==1 || attachment.media_type==2\"><div class=\"ms-card\" flex \nmd-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"ms-card-content-wrapper\"><div class=\"template-9\"><div \nclass=\"media media-attachment\" flex layout=\"row\" layout-align=\"center center\"><div flex \nng-click=\"vm.openImageDialog($event, vm.selectedContent.Thumbnail, attachment)\"><media attachment=\"attachment\" \ncrop-format=\"{{zone.id_cropformats}}\"></media></div></div><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"size block\" layout=\"row\" layout-align=\"start center\"><strong \nclass=\"mr-5\">#{{attachment.id_media}}</strong> <span class=\"grey-500-fg\">| <span ng-if=\"attachment.filename\">\n{{attachment.filename}}</span> <span ng-if=\"attachment.title\">{{attachment.title}}</span></span></div><md-icon \nmd-font-icon=\"icon-eye\" class=\"s16 ml-10\" href=\"#\" \nng-click=\"vm.openImageDialog($event, vm.selectedContent.Thumbnail, attachment)\"></md-icon></div></div></div></div>\n</div></div></div></div></div></md-list-item><md-list-item ng-if=\"!vm.mediaZones\"><div class=\"attachments\"><div \nclass=\"field\"><p class=\"grey-500-fg font-size-14\" translate=\"CONTENT.NO_ZONE\"></p><div \nclass=\"attachment-list md-list-item-text\" layout=\"row\" layout-wrap=\"\" layout-align=\"start start\"><div \nclass=\"attachment\" ng-repeat=\"attachment in vm.selectedContent.Thumbnail | filter: {\'id_zone\':\'!\'}\"><div \nclass=\"preview document\" layout=\"row\" layout-align=\"start center\" extension-class=\"{{attachment.filename}}\" \nng-href=\"{{attachment.permalink}}\" ng-if=\"attachment.media_type==3\" target=\"_blank\"><media attachment=\"attachment\">\n</media><a class=\"grey-1000-fg font-size-16\" ng-href=\"{{attachment.permalink}}\" target=\"_blank\"><span \nng-if=\"attachment.title\">{{attachment.title}} </span><span ng-if=\"attachment.filename\">{{attachment.filename}}</span>\n</a></div><div class=\"preview document\" layout=\"row\" layout-align=\"start center\" \nextension-class=\"{{attachment.filename}}\" ng-href=\"{{attachment.permalink}}\" ng-if=\"attachment.media_type==4\" \ntarget=\"_blank\"><media attachment=\"attachment\"></media><a class=\"grey-1000-fg font-size-16\" \nng-href=\"{{attachment.permalink}}\" target=\"_blank\"><span ng-if=\"attachment.filename\">{{attachment.filename}}</span></a>\n</div><div ng-if=\"attachment.media_type==1 || attachment.media_type==2\"><div class=\"ms-card\" flex \nmd-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"ms-card-content-wrapper\"><div class=\"template-9\"><div \nclass=\"media media-attachment\" flex layout=\"row\" layout-align=\"center center\"><div flex \nng-click=\"vm.openImageDialog($event, vm.selectedContent.Thumbnail, attachment)\"><media attachment=\"attachment\" \ncrop-format=\"{{zone.id_cropformats}}\"></media></div></div><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"size block\" layout=\"row\" layout-align=\"start center\"><strong \nclass=\"mr-5\">#{{attachment.id_media}}</strong> <span class=\"grey-500-fg\">| <span ng-if=\"attachment.filename\">\n{{attachment.filename}}</span> <span ng-if=\"attachment.title\">{{attachment.title}}</span></span></div><md-icon \nmd-font-icon=\"icon-eye\" class=\"s16 ml-10\" href=\"#\" \nng-click=\"vm.openImageDialog($event, vm.selectedContent.Thumbnail, attachment)\"></md-icon></div></div></div></div>\n</div></div></div></div></div><md-divider></md-divider></md-list-item></div><md-list-item \nclass=\"md-toolbar-tools grey-100-bg\"><h3 class=\"grey-700-fg\" translate=\"CONTENT.LATESTACTIVITY\">Latest Activity</h3>\n<md-divider></md-divider></md-list-item><div class=\"activities\"><div class=\"activity\" layout=\"row\" \nlayout-align=\"start center\" ng-repeat=\"activity in vm.log | limitTo: vm.paginationLimit()\"><img \nalt=\"{{content.from.name}}\" class=\"avatar\" ng-if=\"activity.user.avatar\" ng-src=\"{{activity.username}}\"><div \nclass=\"avatar\" ng-if=\"!activity.user.avatar\" ng-style=\"{\'background-color\':activity.user.profile_color}\">\n{{activity.user.firstname[0] | capitalize}}</div><div layout=\"column\"><div><span class=\"username md-accent-color\" \nng-if=\"activity.user.firstname.length>0 || activity.user.lastname.length>0\">\n{{activity.user.firstname}} {{activity.user.lastname}} </span><span class=\"message\">{{activity.message}}</span></div>\n<span class=\"time secondary-text\">{{activity.date}}</span></div></div><button \nclass=\"md-raised md-button md-default-theme md-ink-ripple\" ng-click=\"vm.showMoreItems()\" \nng-show=\"vm.hasMoreItemsToShow()\"><span>Show more</span></button></div></md-list></div></md-content><md-content \nng-if=\"vm.editInline && vm.selectedContent\" ng-include=\"\'app/main/apps/users/views/read/edit-preview.html\'\" \nclass=\"scrollable\"></md-content><md-content ng-if=\"vm.currentTab === \'activity\'\" \nng-include=\"\'app/main/apps/users/views/read/timeline.html\'\"></md-content><md-content \nng-if=\"vm.currentTab === \'mailing\'\" ng-include=\"\'app/main/apps/users/views/read/mailing.html\'\"></md-content></div>");
$templateCache.put("app/main/apps/users/views/read/read-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-if=\"vm.loadingReadPane\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nng-show=\"!vm.loadingReadPane\"><div style=\"z-index: 99; background-color: white\" class=\"mail-content\" layout=\"column\" \nlayout-align=\"center center\" ng-if=\"!vm.selectedContent\"><div class=\"content\" layout=\"column\" \nlayout-align=\"top center\"><div class=\"message\">Please select an item to show in this panel</div></div></div><div \nclass=\"toolbar grey-100-bg colored-bg\" layout=\"row\" layout-align=\"space-between center\" ng-if=\"vm.selectedContent\" \nscroll=\"\"><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button close-thread\" \naria-label=\"Back\" ng-click=\"vm.closeThread()\" \nng-if=\"vm.currentThread && (vm.currentView==\'nosplit\' || vm.groupsView) \" translate \ntranslate-attr-aria-label=\"CONTENT.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button>\n<md-button class=\"md-icon-button close-thread\" ng-if=\"vm.currentView === \'table\'\" aria-label=\"Back\" \nng-click=\"vm.closeThread()\" translate translate-attr-aria-label=\"CONTENT.BACK\"><md-icon \nmd-font-icon=\"icon-arrow-right\"></md-icon></md-button><div class=\"divider-vertical\" hide=\"\" \nng-if=\"vm.activeMailPaneIndex === 1 || vm.currentView === \'table\'\" show-gt-sm=\"\"></div><md-button aria-label=\"Preview\" \nclass=\"md-icon-button\" ng-class=\"{\'md-accent\':vm.currentTab == \'preview\'}\" ng-click=\"vm.viewPreview()\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.PREVIEW\"><md-icon md-font-icon=\"icon-eye\"></md-icon><md-tooltip hide show-gt-xs>\n<span translate=\"CONTENT.PREVIEW\">Preview</span></md-tooltip></md-button><div class=\"divider-vertical\" hide=\"\" \nshow-gt-sm=\"\"></div><md-button aria-label=\"Edit\" class=\"md-icon-button\" \nng-class=\"{\'md-accent\':vm.currentTab == \'edit\'}\" ng-click=\"vm.viewEditInline();\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.EDIT\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip hide show-gt-xs>\n<span translate=\"CONTENT.EDIT\">Edit</span></md-tooltip></md-button><div class=\"divider-vertical\" hide=\"\" show-gt-sm=\"\">\n</div><md-button aria-label=\"Activity\" class=\"md-icon-button\" ng-class=\"{\'md-accent\':vm.currentTab == \'activity\'}\" \nng-click=\"vm.currentTab = \'activity\'\" translate=\"\" translate-attr-aria-label=\"Activities\"><md-icon \nmd-font-icon=\"icon-run\"></md-icon><md-tooltip><span translate=\"ACCOUNTS.ACTIVITY\"></span></md-tooltip></md-button><div \nclass=\"divider-vertical\" hide=\"\" show-gt-sm=\"\"></div><md-button ng-if=\"vm.selectedContentID != \'new\'\" \naria-label=\"Activity\" class=\"md-icon-button\" ng-class=\"{\'md-accent\':vm.currentTab == \'mailing\'}\" \nng-click=\"vm.currentTab = \'mailing\'\" translate=\"\" translate-attr-aria-label=\"Mailing\"><md-icon \nmd-font-icon=\"icon-telegram\"></md-icon><md-tooltip><span translate=\"USERS.MAILING\"></span></md-tooltip></md-button><div\n class=\"divider-vertical\" hide=\"\" show-gt-sm=\"\"></div><md-button \nng-if=\"vm.selectedGroup && vm.userInvitationUrlIndividual\" aria-label=\"Invite to Group\" class=\"md-icon-button\" \nng-click=\"vm.inviteToGroupIndividual(vm.selectedContent, vm.selectedGroup)\" translate=\"\" \ntranslate-attr-aria-label=\"USERS.INVITE_TO_GROUP\"><md-icon md-font-icon=\"icon-email\"></md-icon><md-tooltip><span \ntranslate=\"USERS.INVITE_TO_GROUP\"></span></md-tooltip><p ng-if=\"vm.loginUrl\"><a \nng-click=\"vm.inviteToGroupIndividual(vm.selectedContent, vm.selectedGroup)\"><md-icon md-font-icon=\"icon-person-plus\" \nclass=\"m-0\"></md-icon><span class=\"font-size-15\" translate=\"USERS.INVITE_TO_GROUP\"></span></a></p></md-button>\n<md-button ng-if=\"vm.selectedGroup && vm.userInvitationUrlIndividual\" aria-label=\"Preview Invitation\" \nclass=\"md-icon-button\" ng-click=\"vm.inviteToGroupPreview(vm.selectedContent, vm.selectedGroup)\" translate=\"\" \ntranslate-attr-aria-label=\"USERS.PREVIEW_INVITATION_TO_GROUP\"><md-icon md-font-icon=\"icon-email-open\"></md-icon>\n<md-tooltip><span translate=\"USERS.PREVIEW_INVITATION_TO_GROUP\"></span></md-tooltip><p ng-if=\"vm.loginUrl\"><a \nng-click=\"vm.inviteToGroupPrevbiew(vm.selectedContent, vm.selectedGroup)\"><md-icon md-font-icon=\"icon-person-plus\" \nclass=\"m-0\"></md-icon><span class=\"font-size-15\" translate=\"USERS.PREVIEW_INVITATION_TO_GROUP\"></span></a></p>\n</md-button><div ng-if=\"vm.loginUrl\" class=\"divider-vertical\" hide=\"\" show-gt-sm=\"\"></div><md-button \nng-if=\"vm.loginUrl\" aria-label=\"Login to website\" class=\"md-icon-button\" \nng-click=\"vm.loginToWebsite(vm.selectedContent)\" translate=\"\" translate-attr-aria-label=\"GLOBAL.LOGIN_TO_WEBSITE\">\n<md-icon md-font-icon=\"icon-web\"></md-icon><md-tooltip><span translate=\"GLOBAL.LOGIN_TO_WEBSITE\"></span></md-tooltip><p\n ng-if=\"vm.loginUrl\"><a ng-click=\"vm.loginToWebsite(vm.selectedContent)\"><md-icon md-font-icon=\"icon-web\" class=\"m-0\">\n</md-icon><span class=\"font-size-15\" translate=\"GLOBAL.LOGIN_TO_WEBSITE\"></span></a></p></md-button></div><div \nlayout=\"row\" layout-align=\"end center\" \nng-if=\"vm.currentThread_Edit && vm.currentTab !== \'activity\' && vm.currentTab !== \'preview\'\"><md-button type=\"submit\" \nng-click=\"vm.saveItem(vm.currentThread_Edit)\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.basicForm.$invalid || vm.basicForm.$pristine\" aria-label=\"SAVE\" translate=\"CONTENT.SAVE\" \ntranslate-attr-aria-label=\"CONTENT.SAVE\">SAVE</md-button><md-button type=\"button\" ng-click=\"vm.closeThreadEdit()\" \nclass=\"md-raised md-warn\" aria-label=\"Cancel\">Cancel</md-button></div></div><md-content flex=\"\" \nng-show=\"vm.selectedContent && !vm.editInline && vm.currentTab === \'preview\'\"><div \nclass=\"mail-content file-details scrollable\" ms-scroll=\"vm.msScrollOptions\"><md-list><md-list-item class=\"info\" \nng-if=\"vm.selectedContent_refgrouped.header[0]\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\" \nlayout-align=\"start start\"><div ng-repeat=\"field in vm.selectedContent_refgrouped.header | orderBy:\'preview_sort\' \" \nclass=\"header-element\" layout=\"row\" layout-align=\"center center\"><div><span ng-if=\"field.type==\'user_status\'\"><button \nng-if=\"vm.selectedContent[field.title]===0\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\"></md-icon></button> <button \nng-if=\"vm.selectedContent[field.title]===1\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-minus-circle\" \nclass=\"on amber-400-fg s24\"></md-icon></button> <button ng-if=\"vm.selectedContent[field.title]===2\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\"></md-icon></button> \n<button ng-if=\"vm.selectedContent[field.title]===99\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle\" class=\"on black-fg s24\"></md-icon></button> <button \nng-if=\"vm.selectedContent[field.title]!==0 && vm.selectedContent[field.title]!==1 && vm.selectedContent[field.title]!==2 && vm.selectedContent[field.title]!==99\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"on grey-fg s24\"></md-icon></button> \n</span><span ng-if=\"field.type==\'dateHm\' || field.type==\'date\'\"><span>{{vm.selectedContent[field.title].dateShow}}\n</span> </span><span ng-if=\"field.type==\'language\'\" layout=\"row\" layout-align=\"center center\"><img \nclass=\"img-flag ng-scope\" alt=\"{{vm.siteLanguages(vm.selectedContent[field.title])[lang_name]}}\" \nng-src=\"assets/images/flags/{{vm.siteLanguages()[vm.selectedContent[field.title]].flag_code|lowercase}}.svg\"> </span>\n<span ng-if=\"field.type==\'id_subsec\' && vm.selectedContent[field.title].length!=0\"><span class=\"grey-500-fg\">\n{{field.field_name}} </span><span \nng-bind=\"vm.getReferencesSections(\'subsection\', field.type, vm.selectedContent[field.title])\"></span> </span><span \nng-if=\"field.type==\'id_cat\' && vm.selectedContent[field.title].length!=0\"><span class=\"grey-500-fg\">\n{{field.field_name}} </span><span \nng-bind=\"vm.getReferencesSections(\'cat\', field.type, vm.selectedContent[field.title])\"></span> </span><span \nng-if=\"field.type==\'id_subcat\' && vm.selectedContent[field.title].length!=0\"><span class=\"grey-500-fg\">\n{{field.field_name}} </span><span \nng-bind=\"vm.getReferencesSections(\'subcat\', field.type, vm.selectedContent[field.title])\"></span></span></div></div>\n</div></md-list-item><md-list-item class=\"main-item\"><div class=\"main-read\"><div class=\"avatar-container\"><div \nng-if=\"vm.selectedContent.avatar == \'\' || !vm.selectedContent.avatar\" class=\"avatar {{vm.selectedColor}}\" \nng-bind=\"vm.selectedContent[\'firstname\'] | capitalizeFirstLetter\"></div><div \nng-if=\"vm.selectedContent.avatar && vm.selectedContent.avatar !== \'\'\" class=\"avatar\"><img \nng-src=\"{{vm.selectedContent.avatar}}\" alt=\"\"></div><div \nng-repeat=\"field in vm.selectedContent_refgrouped.user_status | orderBy:\'preview_sort\' \" class=\"status\"><span \nng-if=\"field.type==\'user_status\'\"><button ng-if=\"vm.selectedContent[field.title]===0\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\"></md-icon></button> <button \nng-if=\"vm.selectedContent[field.title]===1\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-minus-circle\" \nclass=\"on amber-400-fg s24\"></md-icon></button> <button ng-if=\"vm.selectedContent[field.title]===2\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\"></md-icon></button> \n<button ng-if=\"vm.selectedContent[field.title]===99\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle\" class=\"on black-fg s24\"></md-icon></button> <button \nng-if=\"vm.selectedContent[field.title]!==0 && vm.selectedContent[field.title]!==1 && vm.selectedContent[field.title]!==2 && vm.selectedContent[field.title]!==99\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"on grey-fg s24\"></md-icon></button>\n</span></div></div></div><div class=\"main-read\" layout=\"column\" layout-align=\"center start \"><div \nng-repeat=\"field in vm.selectedContent_refgrouped.header_main | orderBy:\'preview_sort\' \" class=\"header-element\" \nlayout=\"row\" layout-align=\"center center\"><p ng-if=\"field.type==\'id\'\" class=\"font-size-14\"><span class=\"grey-500-fg\">\nID # </span><span class=\"grey-500-fg\" ng-bind=\"vm.selectedContent[field.title]\"></span></p></div><h1 class=\"name\">\n<strong ng-repeat=\"field in vm.selectedContent_refgrouped.main | orderBy:\'preview_sort\' \" \nng-bind=\"vm.selectedContent[field.title]\" class=\"mr-10\"></strong></h1></div><md-divider></md-divider></md-list-item>\n<div ng-repeat=\"field in vm.selectedContent_refgrouped.secondary | orderBy:\'preview_sort\' \"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg\" ng-if=\"field.type==\'label\'\"><h3 class=\"grey-700-fg\" ng-bind=\"field.field_name\">\n</h3><md-divider></md-divider></md-list-item><md-list-item class=\"md-toolbar-tools\" \nng-if=\"field.category == \'show_groups_as_field\'\"><div class=\"text-truncate\"><div class=\"field\"><p \nclass=\"grey-500-fg font-size-14\" ng-bind=\"field.field_name\"></p><span style=\"white-space: nowrap\" \nclass=\"font-size-16 text-truncate\">{{vm.getGroupNames(field)}}</span><br></div><md-divider></md-divider></div>\n</md-list-item><md-list-item flex=\"100\" \nng-if=\"field.type!==\'label\' && field.category !== \'show_groups_as_field\' && !(field.hide_if_empty && !vm.selectedContent[field.title])\" \nng-switch=\"\" on=\"field.type\"><div class=\"text-truncate\" ng-switch-when=\"html\"><div class=\"field\"><p \nclass=\"grey-500-fg font-size-14\" ng-bind=\"field.field_name\"></p><span class=\"font-size-16 text-truncate\" \nng-bind-html=\"vm.selectedContent[field.title]\"></span><br></div><md-divider></md-divider></div><div \nclass=\"text-truncate\" ng-switch-when=\"status\"><div class=\"field\"><p class=\"grey-500-fg font-size-14\" \nng-bind=\"field.field_name\"></p><span class=\"font-size-16 text-truncate {{vm.selectedContent[field.title]|yesNo}}\" \nng-bind-html=\"vm.selectedContent[field.title]|yesNo\"></span><br></div><md-divider></md-divider></div><div \nclass=\"text-truncate\" ng-switch-when=\"country\"><div class=\"field\"><p class=\"grey-500-fg font-size-14 ng-binding\" \nng-bind=\"field.field_name\"></p><span ng-if=\"vm.getCountryById(vm.selectedContent[field.title]).name\" \nclass=\"font-size-16 text-truncate\" ng-bind-html=\"vm.getCountryById(vm.selectedContent[field.title]).name\"></span> <span\n ng-if=\"!vm.getCountryById(vm.selectedContent[field.title]).name\" class=\"font-size-16 text-truncate\">-</span><br></div>\n<md-divider></md-divider></div><div class=\"text-truncate\" ng-switch-when=\"state\"><div class=\"field\"><p \nclass=\"grey-500-fg font-size-14 ng-binding\" ng-bind=\"field.field_name\"></p><span \nng-if=\"vm.selectedContent.related_state.name\" class=\"font-size-16 text-truncate\" \nng-bind-html=\"vm.selectedContent.related_state.name\"></span> <span ng-if=\"!vm.selectedContent.related_state.name\" \nclass=\"font-size-16 text-truncate\">-</span><br></div><md-divider></md-divider></div><div class=\"text-truncate\" \nng-switch-when=\"city\"><div class=\"field\"><p class=\"grey-500-fg font-size-14 ng-binding\" ng-bind=\"field.field_name\"></p>\n<span ng-if=\"vm.selectedContent.related_city.city\" class=\"font-size-16 text-truncate\" \nng-bind-html=\"vm.selectedContent.related_city.city\"></span> <span ng-if=\"!vm.selectedContent.related_city.city\" \nclass=\"font-size-16 text-truncate\">-</span><br></div><md-divider></md-divider></div><div class=\"text-truncate\" \nng-switch-when=\"mailing_priority\"><div class=\"field\"><p class=\"grey-500-fg font-size-14 ng-binding\" \nng-bind=\"field.field_name\"></p><span class=\"font-size-16 text-truncate\" ng-repeat=\"prior in vm.mailingPriority\" \nng-bind=\"prior.name\" \nng-if=\"vm.selectedContent.mailing_priority >= prior.min && vm.selectedContent.mailing_priority <= prior.max\" \nclass=\"font-size-16 text-truncate\"></span><br></div><md-divider></md-divider></div><div class=\"files\" \nng-switch-when=\"files\"><div \nng-if=\"vm.selectedContent.files[field.title] && vm.selectedContent.files[field.title].length> 0\" layout=\"column\"><div \nclass=\"mail-list-item attachment mv-5 pointer\" ng-repeat=\"document in vm.selectedContent.files[field.title]\" \ndata-id=\"{{document.id}}\"><a style=\"text-decoration: none\" href=\"{{document.url}}\" target=\"_blank\"><div layout=\"row\" \nlayout-align=\"start center\"><div fill-width layout=\"row\" layout-align=\"start center\"><div flex=\"20\" flex-gt-md=\"20\" \nflex-gt-lg=\"20\" class=\"media photos text-right pv-5\" layout=\"row\" layout-align=\"start center\"><qiu-icon \nmediafile=\"document.filename\" class=\"mr-10\"></qiu-icon></div><div flex=\"80\" flex-gt-md=\"80\" flex-gt-lg=\"80\" \nclass=\"info ph-10 pv-5 m-0\" style=\"padding: 0px\" flex layout=\"column\"><p \nclass=\"grey-500-fg font-size-16 ng-binding mb-5 mt-0\" ng-bind=\"field.field_name\"></p><div class=\"subject grey-500-fg\" \nlayout=\"row\" layout-align=\"start center\"><span>{{vm.showDate(document.date_uploaded)}}</span></div><div class=\"name\" \nlayout=\"row\" layout-align=\"start center\"><span ng-if=\"document.filename\">{{document.filename}}</span></div><div \nclass=\"name\" layout=\"row\" layout-align=\"start center\"><span ng-if=\"document.filename\">{{document.field}}</span></div>\n</div></div></div></a></div></div></div><div class=\"text-truncate\" ng-switch-when=\"button\"><div class=\"field\" \nng-init=\"fieldRaw = field.raw_settings\"><md-button type=\"button\" \nng-click=\"vm.buttonClick($event, fieldRaw, vm.selectedContent)\" \nclass=\"{{ fieldRaw.font_icon ? \'md-icon-button\' : \'md-raised\' }} {{ fieldRaw.background_color ? fieldRaw.background_color+\'-bg\' : \'\' }} {{ fieldRaw.foreground_color ? fieldRaw.foreground_color+\'-fg\' : \'\' }}\" \naria-label=\"{{field.field_name}}\" ng-disabled=\"vm.isSending\" translate-attr-aria-label=\"GENERIC.BUTTON.RUN\"><span \nng-if=\"!fieldRaw.font_icon\">{{field.field_name}}</span><md-icon ng-if=\"fieldRaw.font_icon\" \nmd-font-icon=\"icon-{{fieldRaw.font_icon}}\" class=\"s24 mr-20\" \nng-style=\"fieldRaw.foreground_color && {\'color\': fieldRaw.foreground_color}\"></md-icon><md-tooltip><span>\n{{field.field_name}}</span></md-tooltip></md-button></div><md-divider></md-divider></div><div class=\"text-truncate\" \nflex=\"100\" ng-switch-default=\"\"><div class=\"field\"><p class=\"grey-500-fg font-size-14\" ng-bind=\"field.field_name\"></p>\n<span \nng-if=\"field.category!=\'input_related\' && field.category!=\'childs\' && vm.isNumber(vm.selectedContent[field.title])\" \nclass=\"font-size-16 text-truncate\" ng-bind-html=\"vm.selectedContent[field.title]\"></span> <span \nng-if=\"field.category!=\'input_related\' && field.category!=\'childs\' && vm.hasDateShow(vm.selectedContent[field.title])\" \nclass=\"font-size-16 text-truncate\" ng-bind-html=\"vm.hasDateShow(vm.selectedContent[field.title])\"></span> <span \nng-if=\"field.category!=\'input_related\' && field.category!=\'childs\' && !vm.isNumber(vm.selectedContent[field.title]) && !vm.hasDateShow(vm.selectedContent[field.title]) && vm.selectedContent[field.title]\" \nclass=\"font-size-16 text-truncate\" ng-bind-html=\"vm.selectedContent[field.title]| autoLinkerFilter\"></span> <span \nng-if=\"field.category==\'childs\'\">{{vm.selectedContent.childs}}</span> <span \nng-if=\"field.category!=\'input_related\' && field.category != \'childs\' && !vm.isNumber(vm.selectedContent[field.title]) && !vm.selectedContent[field.title]\" \nclass=\"font-size-16 text-truncate\">-</span> <span ng-if=\"field.category==\'input_related\'\" \nclass=\"font-size-16 text-truncate\">\n{{vm.getInArray(\'id_\'+field.config,field.values, vm.selectedContent[field.title], field.config)}}</span><br></div>\n<md-divider></md-divider></div></md-list-item></div><div ng-if=\"vm.selectedContent.tags\"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg\"><h3 class=\"grey-700-fg\" translate=\"CONTENT.ATTACHMENTS\">\nTags ({{vm.selectedContent.tags.length}})</h3><md-divider></md-divider></md-list-item><md-list-item><md-chips \nname=\"tag_name\" ng-model=\"vm.selectedContent.tags\" readonly=\"true\"><md-chip-template><span>\n{{$chip.tag_name}} #{{$chip.id_tag}}</span></md-chip-template></md-chips><md-divider></md-divider></md-list-item></div>\n<div ng-if=\"vm.selectedContent.Thumbnail\"><md-list-item class=\"md-toolbar-tools grey-100-bg\"><h3 class=\"grey-700-fg\" \ntranslate=\"CONTENT.ATTACHMENTS\">Attachments ({{vm.selectedContent.Thumbnail.length}})</h3><md-divider></md-divider>\n</md-list-item><md-list-item ng-repeat=\"zone in vm.mediaZones\" ng-if=\"vm.mediaZones\"><div class=\"attachments\"><div \nclass=\"field\"><p class=\"grey-500-fg font-size-14\">{{ zone.title }}</p><div class=\"attachment-list md-list-item-text\" \nlayout=\"row\" layout-wrap=\"\" layout-align=\"start start\"><div class=\"attachment\" \nng-repeat=\"attachment in vm.selectedContent.Thumbnail | filter: {\'id_zone\':zone.id_zone}\"><div \nclass=\"preview document\" layout=\"row\" layout-align=\"start center\" extension-class=\"{{attachment.filename}}\" \nng-href=\"{{attachment.permalink}}\" ng-if=\"attachment.media_type==3\" target=\"_blank\"><media attachment=\"attachment\">\n</media><a class=\"grey-1000-fg font-size-16\" ng-href=\"{{attachment.permalink}}\" target=\"_blank\"><span \nng-if=\"attachment.title\">{{attachment.title}} </span><span ng-if=\"attachment.filename\">{{attachment.filename}}</span>\n</a></div><div class=\"preview document\" layout=\"row\" layout-align=\"start center\" \nextension-class=\"{{attachment.filename}}\" ng-href=\"{{attachment.permalink}}\" ng-if=\"attachment.media_type==4\" \ntarget=\"_blank\"><media attachment=\"attachment\"></media><a class=\"grey-1000-fg font-size-16\" \nng-href=\"{{attachment.permalink}}\" target=\"_blank\"><span ng-if=\"attachment.filename\">{{attachment.filename}}</span></a>\n</div><div ng-if=\"attachment.media_type==1 || attachment.media_type==2\"><div class=\"ms-card\" flex \nmd-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"ms-card-content-wrapper\"><div class=\"template-9\"><div \nclass=\"media media-attachment\" flex layout=\"row\" layout-align=\"center center\"><div flex \nng-click=\"vm.openImageDialog($event, vm.selectedContent.Thumbnail, attachment)\"><media attachment=\"attachment\" \ncrop-format=\"{{zone.id_cropformats}}\"></media></div></div><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"size block\" layout=\"row\" layout-align=\"start center\"><strong \nclass=\"mr-5\">#{{attachment.id_media}}</strong> <span class=\"grey-500-fg\">| <span ng-if=\"attachment.filename\">\n{{attachment.filename}}</span> <span ng-if=\"attachment.title\">{{attachment.title}}</span></span></div><md-icon \nmd-font-icon=\"icon-eye\" class=\"s16 ml-10\" href=\"#\" \nng-click=\"vm.openImageDialog($event, vm.selectedContent.Thumbnail, attachment)\"></md-icon></div></div></div></div>\n</div></div></div></div></div></md-list-item><md-list-item ng-if=\"!vm.mediaZones\"><div class=\"attachments\"><div \nclass=\"field\"><p class=\"grey-500-fg font-size-14\" translate=\"CONTENT.NO_ZONE\"></p><div \nclass=\"attachment-list md-list-item-text\" layout=\"row\" layout-wrap=\"\" layout-align=\"start start\"><div \nclass=\"attachment\" ng-repeat=\"attachment in vm.selectedContent.Thumbnail | filter: {\'id_zone\':\'!\'}\"><div \nclass=\"preview document\" layout=\"row\" layout-align=\"start center\" extension-class=\"{{attachment.filename}}\" \nng-href=\"{{attachment.permalink}}\" ng-if=\"attachment.media_type==3\" target=\"_blank\"><media attachment=\"attachment\">\n</media><a class=\"grey-1000-fg font-size-16\" ng-href=\"{{attachment.permalink}}\" target=\"_blank\"><span \nng-if=\"attachment.title\">{{attachment.title}} </span><span ng-if=\"attachment.filename\">{{attachment.filename}}</span>\n</a></div><div class=\"preview document\" layout=\"row\" layout-align=\"start center\" \nextension-class=\"{{attachment.filename}}\" ng-href=\"{{attachment.permalink}}\" ng-if=\"attachment.media_type==4\" \ntarget=\"_blank\"><media attachment=\"attachment\"></media><a class=\"grey-1000-fg font-size-16\" \nng-href=\"{{attachment.permalink}}\" target=\"_blank\"><span ng-if=\"attachment.filename\">{{attachment.filename}}</span></a>\n</div><div ng-if=\"attachment.media_type==1 || attachment.media_type==2\"><div class=\"ms-card\" flex \nmd-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"ms-card-content-wrapper\"><div class=\"template-9\"><div \nclass=\"media media-attachment\" flex layout=\"row\" layout-align=\"center center\"><div flex \nng-click=\"vm.openImageDialog($event, vm.selectedContent.Thumbnail, attachment)\"><media attachment=\"attachment\" \ncrop-format=\"{{zone.id_cropformats}}\"></media></div></div><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"size block\" layout=\"row\" layout-align=\"start center\"><strong \nclass=\"mr-5\">#{{attachment.id_media}}</strong> <span class=\"grey-500-fg\">| <span ng-if=\"attachment.filename\">\n{{attachment.filename}}</span> <span ng-if=\"attachment.title\">{{attachment.title}}</span></span></div><md-icon \nmd-font-icon=\"icon-eye\" class=\"s16 ml-10\" href=\"#\" \nng-click=\"vm.openImageDialog($event, vm.selectedContent.Thumbnail, attachment)\"></md-icon></div></div></div></div>\n</div></div></div></div></div><md-divider></md-divider></md-list-item></div><md-list-item \nclass=\"md-toolbar-tools grey-100-bg\"><h3 class=\"grey-700-fg\">{{ \'USERS.USERS_GROUPS\' | translate}}</h3><md-divider>\n</md-divider></md-list-item><md-list-item class=\"p-0\" ng-if=\"vm.groupTypesWithCurrentLabelsEdit\"><div \nclass=\"content-wrapper users-edit-group\" flex layout=\"column\"><div \nclass=\"content thread-list mail-list-pane flex-100 border-bottom\"><div \nng-repeat=\"groupType in vm.groupTypesWithCurrentLabelsEdit\" ng-if=\"groupType.labelsEdit\" class=\"user-type-group\"><h3 \nclass=\"m-0 ph-24 pv-10 grey-100-bg\"><strong>{{groupType.name}}</strong></h3><div \nng-repeat=\"item in groupType.labelsEdit track by $index\" class=\"mail-list-item\" role=\"button\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"info\" flex layout=\"row\" layout-align=\"space-between center\"><div class=\"name\" \nlayout=\"row\" layout-align=\"start center\" flex=\"100\"><div class=\"group-name\" layout=\"row\" layout-align=\"start center\" \nflex=\"100\"><parent-group ng-if=\"item.group.parentGroup\" parent=\"item.group.parentGroup\"></parent-group><md-icon \nclass=\"{{item.group.color}}-fg icon-folder md-font-icon mr-10 s24 mt-0 ml-0 mb-0\" \nng-class=\"{\'icon-folder\':item.group.id_group_type == 1, \'qiu-icon-file-usermailing\':item.group.id_group_type == 2,\'qiu-icon-file-usermediacenter\':item.group.id_group_type == 3,\'qiu-icon-file-usersegment\':item.group.id_group_type == 4,\'qiu-icon-file-userstore\':item.group.id_group_type == 5,\'qiu-icon-file-useracreditation\':item.group.id_group_type == 6,\'icon-folder\':item.group.id_group_type == 7,\'icon-folder-remove\':item.group.id_group_type == 8}\" \naria-hidden=\"true\"></md-icon><span>{{item.label}}</span></div></div><div class=\"buttons\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"status-wrapper text-center\" layout=\"row\" layout-align=\"end center\" \nng-repeat=\"i in item.group.ingroup_status | filter: {\'id_ingroup_status\' : item.group.id_ingroup_status} : true\"><div>\n<span class=\"{{i.name}} status\" layout=\"row\" layout-align=\"center center\">{{i.name}}</span></div></div></div></div>\n</div></div></div></div></div><md-divider></md-divider></md-list-item><md-list-item \nclass=\"md-toolbar-tools grey-100-bg\"><h3 class=\"grey-700-fg\" translate=\"CONTENT.LATESTACTIVITY\">Latest Activity</h3>\n<md-divider></md-divider></md-list-item><div class=\"activities\"><div class=\"activity\" layout=\"row\" \nlayout-align=\"start center\" ng-repeat=\"activity in vm.log | limitTo: vm.paginationLimit()\"><img \nalt=\"{{content.from.name}}\" class=\"avatar\" ng-if=\"activity.user.avatar\" ng-src=\"{{activity.username}}\"><div \nclass=\"avatar\" ng-if=\"!activity.user.avatar\" ng-style=\"{\'background-color\':activity.user.profile_color}\">\n{{activity.user.firstname[0] | capitalize}}</div><div layout=\"column\"><div><span class=\"username md-accent-color\" \nng-if=\"activity.user.firstname.length>0 || activity.user.lastname.length>0\">\n{{activity.user.firstname}} {{activity.user.lastname}} </span><span class=\"message\">{{activity.message}}</span></div>\n<span class=\"time secondary-text\">{{activity.date}}</span></div></div><button \nclass=\"md-raised md-button md-default-theme md-ink-ripple\" ng-click=\"vm.showMoreItems()\" \nng-show=\"vm.hasMoreItemsToShow()\"><span>Show more</span></button></div></md-list></div></md-content><md-content \nng-if=\"vm.currentTab === \'edit\'\" ng-include=\"\'app/main/apps/users/views/read/edit-preview.html\'\" class=\"scrollable\">\n</md-content><md-content ng-if=\"vm.currentTab === \'activity\'\" \nng-include=\"\'app/main/apps/users/views/read/timeline.html\'\"></md-content><md-content \nng-if=\"vm.currentTab === \'mailing\'\" ng-include=\"\'app/main/apps/users/views/read/mailing.html\'\"></md-content></div>");
$templateCache.put("app/main/apps/users/views/read/tab-edit.html","<div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><form name=\"vm.basicForm\" class=\"md-inline-form\" novalidate><div\n ng-repeat=\"fields in vm.currentThread_ref\" ng-init=\"tempValue = vm.currentThread_Edit[fields.title]\" \nng-hide=\"(fields.hide_if_empty && !tempValue) || fields.hide_edit\"><md-list-item class=\"md-toolbar-tools grey-100-bg\" \nng-if=\"fields.type==\'label\'\"><h3 class=\"grey-700-fg\" ng-bind=\"fields.field_name\"></h3></md-list-item>\n<md-input-container class=\"md-block\" ng-if=\"fields.type==\'id_subsec\'\" flex><label ng-bind=\"fields.field_name\"></label>\n<md-select ng-model=\"vm.currentThread_Edit[fields.type]\" placeholder=\"{{vm.currentThread_Edit[fields.field_name]}}\">\n<md-option value=\"\">---</md-option><md-option ng-repeat=\"opt in vm.getValuesReferencesSections(\'subsection\')\" \nvalue=\"{{opt.id_subsec}}\">{{opt.subsec}}</md-option></md-select><div class=\"md-errors-spacer\"></div>\n</md-input-container><md-input-container class=\"md-block\" ng-if=\"fields.type==\'id_cat\'\" flex><label \nng-bind=\"fields.field_name\"></label><md-select ng-model=\"vm.currentThread_Edit[fields.type]\" \nplaceholder=\"{{vm.currentThread_Edit[fields.field_name]}}\"><md-option value=\"\">---</md-option><md-option \nng-repeat=\"opt in vm.getValuesReferencesSections(\'cat\')\" value=\"{{opt.id_cat}}\">{{opt.cat}}</md-option></md-select><div\n class=\"md-errors-spacer\"></div></md-input-container><md-input-container class=\"md-block\" \nng-if=\"fields.type==\'id_subcat\'\" flex><label ng-bind=\"fields.field_name\"></label><md-select \nng-model=\"vm.currentThread_Edit[fields.type]\" placeholder=\"{{vm.currentThread_Edit[fields.field_name]}}\"><md-option \nvalue=\"\">---</md-option><md-option ng-repeat=\"opt in vm.getValuesReferencesSections(\'subcat\')\" \nvalue=\"{{opt.id_subcat}}\">{{opt.subcat}}</md-option></md-select><div class=\"md-errors-spacer\"></div>\n</md-input-container><md-input-container class=\"md-block\" ng-if=\"fields.category==\'input_related\'\" flex><label \nng-bind=\"fields.field_name\"></label><md-select ng-model=\"vm.currentThread_Edit[fields.title]\" \nplaceholder=\"{{vm.currentThread_Edit[fields.field_name]}}\"><md-option value=\"\">---</md-option><md-option \nng-repeat=\"opt in fields.values\" ng-value=\"opt.id_{{fields.config}}\">{{opt[fields.config]}}</md-option></md-select><div\n class=\"md-errors-spacer\"></div></md-input-container><md-input-container class=\"md-block\" ng-if=\"fields.type==\'text\'\" \nflex><label ng-bind=\"fields.field_name\"></label><textarea ng-model=\"vm.currentThread_Edit[fields.title]\" columns=\"1\" \nrows=\"1\"></textarea></md-input-container><div ng-if=\"fields.type==\'user_status\'\" class=\"ml-10\"><md-button \nng-if=\"vm.selectedContent[fields.title]===0\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\"></md-icon></md-button><md-button \nng-if=\"vm.selectedContent[fields.title]===1\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-minus-circle\" \nclass=\"on amber-400-fg s24\"></md-icon></md-button><md-button ng-if=\"vm.selectedContent[fields.title]===2\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\"></md-icon>\n</md-button><md-button ng-if=\"vm.selectedContent[fields.title]===99\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle\" class=\"on black-fg s24\"></md-icon></md-button><md-button \nng-if=\"vm.selectedContent[fields.title]!==0 && vm.selectedContent[fields.title]!==1 && vm.selectedContent[fields.title]!==2 && vm.selectedContent[fields.title]!==99\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"on grey-fg s24\"></md-icon></md-button>\n</div><md-input-container class=\"md-block\" ng-if=\"fields.type==\'status\'\" flex><md-checkbox class=\"no-label\" \naria-label=\"{{fields.field_name}}\" ng-model=\"vm.currentThread_Edit[fields.title]\" ng-true-value=\"true || 1\" \nng-false-value=\"false || 0\">{{fields.field_name}}</md-checkbox></md-input-container><md-input-container \nclass=\"md-block on-off\" ng-if=\"fields.type==\'onoff\'\" flex><button ng-if=\"vm.currentThread_Edit[fields.title] ===1\" \nclass=\"md-icon-button md-button\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\" \nng-click=\"vm.toggleItemStatusEdit(fields.title)\"></md-icon></button> <button \nng-if=\"vm.currentThread_Edit[fields.title] !==1\" class=\"md-icon-button md-button\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\" \nng-click=\"vm.toggleItemStatusEdit(fields.title)\"></md-icon></button></md-input-container><md-input-container \nclass=\"md-block\" ng-if=\"fields.type==\'language\'\" flex><label ng-bind=\"fields.field_name\"></label><md-select \nng-model=\"vm.currentThread_Edit[fields.title]\" placeholder=\"{{vm.currentThread_Edit[fields.field_name]}}\"><md-option \nvalue=\"\">---</md-option><md-option ng-repeat=\"opt in vm.siteLanguages()\" value=\"{{opt.id_lang}}\">{{opt.lang_name}}\n</md-option></md-select><div class=\"md-errors-spacer\"></div></md-input-container><md-input-container class=\"md-block\" \nng-if=\"fields.type==\'single\'\"><label ng-bind=\"fields.field_name\"></label><input type=\"text\" name=\"{{fields.title}}\" \nng-disabled=\"fields.edit_editable != 1\" ng-model=\"vm.currentThread_Edit[fields.title]\" \nplaceholder=\"{{fields.field_name}}\"></md-input-container><md-input-container class=\"md-block\" \nng-if=\"fields.type==\'password\'\"><label ng-bind=\"fields.field_name\"></label><input type=\"password\" \nname=\"{{fields.title}}\" ng-disabled=\"fields.edit_editable != 1\" ng-model=\"vm.currentThread_Edit[fields.title]\" \nplaceholder=\"{{fields.field_name}}\"></md-input-container><div layout=\"column\" layout-gt-sm=\"column\" \nclass=\"date-time-picker\" ng-if=\"fields.type==\'dateHm\' || fields.type==\'date\'\"><div flex><label \nng-bind=\"fields.field_name\"></label></div><div layout=\"column\" layout-gt-sm=\"row\"><div flex class=\"date-container\">\n<fieldset ng-disabled=\"fields.edit_editable != 1\"><mdp-date-picker mdp-placeholder=\"Date\" \nmdp-format=\"{{vm.dateFormat}}\" mdp-open-on-click=\"true\" ng-model=\"vm.currentThread_Edit[fields.title].date\" \nng-change=\"vm.updateDatePicker(fields.title)\"></mdp-date-picker></fieldset></div><div flex class=\"date-container\">\n<fieldset ng-disabled=\"fields.edit_editable != 1\"><mdp-time-picker mdp-placeholder=\"Time\" mdp-auto-switch=\"true\" \nmdp-open-on-click=\"true\" ng-model=\"vm.currentThread_Edit[fields.title].date\" ng-disabled=\"fields.edit_editable != 1\" \nng-change=\"vm.updateDatePicker(fields.title)\"></mdp-time-picker></fieldset></div><div flex class=\"date-container\">\n<md-input-container class=\"md-block\"><label>UTC Date</label><input type=\"text\" ng-disabled=\"fields.edit_editable != 1\" \nng-model=\"vm.currentThread_Edit[fields.title].utcShow\" disabled=\"disabled\"></md-input-container></div></div></div><div \nng-if=\"fields.category==\'show_groups_as_field\' && fields.type == \'dropdown_multiple\'\" class=\"ph-25\"><nested-select \non-change=\"vm.updateModelShowGroupsAsField($event, fields)\" flex options=\"fields.groups_as_field\" \nplaceholder=\"Search groups\" label=\"{{fields.field_name}}\" multiple=\"multiple\" collapsible show-selection \nallow-select-all></nested-select></div><div \nng-if=\"fields.category==\'show_groups_as_field\' && fields.type == \'dropdown_single\'\" class=\"ph-25\"><nested-select \non-change=\"vm.updateModelShowGroupsAsField($event, fields)\" flex options=\"fields.groups_as_field\" \nplaceholder=\"Search groups\" label=\"{{fields.field_name}}\" collapsible show-selection allow-select-all></nested-select>\n</div><md-input-container class=\"md-block\" flex ng-if=\"fields.type==\'country\'\"><label ng-bind=\"fields.field_name\">\n</label><md-select ng-model=\"vm.currentThread_Edit.country\" placeholder=\"{{fields.field_name}}\"><md-option value=\"\">---\n</md-option><md-option ng-repeat=\"country in vm.countriesWithStates\" ng-bind=\"country.name\" ng-value=\"country.id\" \nng-selected=\"country.id == vm.currentThread_Edit.country\"></md-option></md-select><div class=\"md-errors-spacer\"></div>\n</md-input-container><md-input-container class=\"md-block\" flex ng-if=\"fields.type==\'state\'\"><label \nng-bind=\"fields.field_name\"></label><md-select ng-model=\"vm.currentThread_Edit.state\" \nplaceholder=\"{{fields.field_name}}\" ng-disabled=\"!vm.currentThread_Edit.country\"><md-option value=\"\">---</md-option>\n<md-option ng-repeat=\"state in vm.statesWithCities\" ng-bind=\"state.name\" ng-value=\"state.id\" \nng-selected=\"state.id == vm.currentThread_Edit.state\"></md-option></md-select><div class=\"md-errors-spacer\"></div>\n</md-input-container><md-input-container class=\"md-block\" flex ng-if=\"fields.type==\'city\'\"><label \nng-bind=\"fields.field_name\"></label><md-select ng-model=\"vm.currentThread_Edit.city\" \nplaceholder=\"{{fields.field_name}}\" ng-disabled=\"!vm.currentThread_Edit.state\"><md-option value=\"\">---</md-option>\n<md-option ng-repeat=\"city in vm.cities\" ng-bind=\"city.city\" ng-value=\"city.id_city\" \nng-selected=\"city.id_city == vm.currentThread_Edit.city\"></md-option></md-select><div class=\"md-errors-spacer\"></div>\n</md-input-container><md-input-container class=\"md-block\" flex ng-show=\"fields.type==\'mailing_priority\'\"><label \nng-bind=\"fields.field_name\"></label><md-select ng-model=\"vm.currentThread_Edit.mailing_priority\" \nplaceholder=\"{{fields.field_name}}\"><md-option value=\"\">---</md-option><md-option \nng-repeat=\"prior in vm.mailingPriority\" ng-bind=\"prior.name\" ng-value=\"prior.default\" \nng-selected=\"vm.currentThread_Edit.mailing_priority >= prior.min && vm.currentThread_Edit.mailing_priority <= prior.max\">\n</md-option></md-select><div class=\"md-errors-spacer\"></div></md-input-container><md-input-container flex \nclass=\"md-block md-input-has-value\" ng-if=\"fields.type==\'html\'\"><label ng-bind=\"fields.field_name\"></label><textarea \nui-tinymce=\"vm.tinymceOptions\" ng-model=\"vm.currentThread_Edit[fields.title]\" aria-label=\"{{fields.title}}\"></textarea>\n</md-input-container></div><div layout=\"row\"><md-list flex=\"100\" class=\"md-toolbar-tools grey-100-bg\" layout=\"row\" \nlayout-align=\"end center\"><div><md-button type=\"submit\" ng-if=\"vm.currentThread_Edit\" \nng-click=\"vm.saveItem(vm.currentThread_Edit)\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.basicForm.$invalid || vm.basicForm.$pristine\" aria-label=\"SAVE\" translate=\"CONTENT.SAVE\" \ntranslate-attr-aria-label=\"CONTENT.SAVE\">SAVE</md-button><md-button type=\"button\" ng-click=\"vm.closeThreadEdit()\" \nclass=\"md-raised md-warn\" aria-label=\"Cancel\">Cancel</md-button></div></md-list></div></form></div>");
$templateCache.put("app/main/apps/users/views/read/tab-media.html","<md-list-item class=\"list-media-item attachment-edit\"><div class=\"attachments\"><div class=\"field\"><p \nclass=\"grey-500-fg ml-8\">Avatar</p><div class=\"attachment-list sortable md-list-item-text\"><div class=\"attachment\" \nlayout=\"column\" ng-show=\"vm.currentThread_Edit.avatar\"><div class=\"preview document\" layout=\"row\" \nlayout-align=\"start center\" extension-class=\"{{vm.currentThread_Edit.avatar.filename}}\" \nng-href=\"{{vm.currentThread_Edit.avatar.permalink}}\" ng-if=\"vm.currentThread_Edit.avatar.media_type==3\" \ntarget=\"_blank\"><a class=\"grey-1000-fg font-size-16\" ng-href=\"{{vm.currentThread_Edit.avatar.permalink}}\" \ntarget=\"_blank\"><span ng-if=\"vm.currentThread_Edit.avatar.title\">{{vm.currentThread_Edit.avatar.title}}</span> <span \nng-if=\"vm.currentThread_Edit.avatar.filename\">{{vm.currentThread_Edit.avatar.filename}}</span></a></div><div \nng-if=\"vm.currentThread_Edit.avatar.media_type==1 || vm.currentThread_Edit.avatar.media_type==2 || vm.currentThread_Edit.avatar.media_type==4\">\n<div class=\"ms-card\" flex md-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"ms-card-content-wrapper\"><div \nclass=\"template-9\"><div class=\"media\" flex layout=\"row\" layout-align=\"center center\" \nng-if=\"vm.currentThread_Edit.avatar.media_type==1 || vm.currentThread_Edit.avatar.media_type==2\"><media \nattachment=\"vm.currentThread_Edit.avatar\" class=\"image\" ng-click=\"vm.openImageDialog($event, mediazone, $index)\">\n</media></div><div flex layout=\"column\" layout-align=\"center center\" class=\"media\" \nng-if=\"vm.currentThread_Edit.avatar.media_type==4\"><qiu-icon mediafile=\"vm.currentThread_Edit.avatar.filename\" \nclassextra=\"s56\"></qiu-icon><br><span class=\"grey-500-fg\" layout=\"column\" layout-align=\"center center\"><span \nng-if=\"vm.currentThread_Edit.avatar.title\"><strong>{{vm.currentThread_Edit.avatar.title}}</strong> </span><span \nng-if=\"vm.currentThread_Edit.avatar.filename\">{{vm.currentThread_Edit.avatar.filename}}</span></span></div><div \nclass=\"header\" layout=\"row\" layout-align=\"space-between center\"><div class=\"size block\" layout=\"row\" \nlayout-align=\"start center\"><strong class=\"mr-5\">#{{vm.currentThread_Edit.avatar.id_media}}</strong> <span \nclass=\"grey-500-fg\" ng-if=\"vm.currentThread_Edit.avatar.media_type==1 || vm.currentThread_Edit.avatar.media_type==2\">\n{{vm.currentThread_Edit.avatar.filename}}</span></div><md-menu><button class=\"md-icon-button\" aria-label=\"More\" \ntranslate translate-attr-aria-label=\"TODO.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\" \nng-click=\"$mdMenu.open($event)\"></md-icon></button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-if=\"vm.currentThread_Edit.avatar.media_type==1 || vm.currentThread_Edit.avatar.media_type==2\" \nng-click=\"vm.openImageDialog($event, mediazone, $index)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.PREVIEW\"><md-icon md-font-icon=\"icon-eye\" class=\"ml-10\" href=\"#\" \nng-click=\"vm.openImageDialog($event, mediazone, $index)\"></md-icon><span translate=\"CONTENT.PREVIEW\">Preview</span>\n</md-button><md-button ng-if=\"vm.currentThread_Edit.avatar.media_type==4\" \nng-click=\"vm.openUrl(vm.currentThread_Edit.avatar.permalink)\" target=\"_blank\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.PREVIEW\"><md-icon md-font-icon=\"icon-open-in-new\" class=\"ml-10\"></md-icon><span \ntranslate=\"CONTENT.OPEN\">Open</span></md-button></md-menu-item><md-menu-item \nng-if=\"vm.currentThread_Edit.avatar.media_type==1\"><md-button ng-click=\"vm.openFocalPoint($event, mediazone, $index)\" \naria-label=\"Toggle done\" translate-attr-aria-label=\"CONTENT.SET_FOCAL_POINT\"><md-icon \nmd-font-icon=\"icon-image-filter-center-focus\" class=\"s18\"></md-icon><span translate=\"CONTENT.SET_FOCAL_POINT\">\nSet Focal point</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.openMediaItemMetadata($event, mediazone, $index)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.MEDIA_ITEM_EDIT_METADATA\"><md-icon md-font-icon=\"icon-message-image\" class=\"s18\">\n</md-icon><span translate=\"CONTENT.MEDIA_ITEM_EDIT_METADATA\">Edit Metadata</span></md-button></md-menu-item>\n<md-menu-item ng-if=\"vm.currentThread_Edit.avatar.media_type==1\"><md-button \nng-click=\"vm.MediaItemRecrop(vm.currentThread_Edit.avatar,mediazone, $index)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.MEDIA_ITEM_RECROP\"><md-icon md-font-icon=\"icon-image\" class=\"s18\"></md-icon><span \ntranslate=\"CONTENT.MEDIA_ITEM_RECROP\">Recrop Image</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.deleteAttachment(mediazone, $index)\" aria-label=\"Toggle done\" translate-attr-aria-label=\"CONTENT.REMOVE\">\n<md-icon md-font-icon=\"icon-close\" class=\"s18\"></md-icon><span translate=\"CONTENT.REMOVE\">Remove</span></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></div></div></div><md-button \nclass=\"add-event-button no-sort md-fab md-warn\" ng-click=\"vm.mediaDialog($event, mediazone, vm.currentThread_Edit)\" \naria-label=\"Add event\" translate translate-attr-aria-label=\"CALENDAR.ADD_EVENT\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon></md-button></div></div><md-divider></md-divider></md-list-item>");
$templateCache.put("app/main/apps/users/views/read/tab-users-groups.html","<form novalidate><div class=\"content-wrapper users-edit-group mb-20\" flex layout=\"column\"><div \nclass=\"content thread-list mail-list-pane flex-100 border-bottom\"><div \nng-repeat=\"groupType in vm.groupTypesWithCurrentLabelsEdit\" ng-if=\"groupType.labelsEdit\" class=\"user-type-group\"><h3 \nclass=\"m-0 ph-24 pv-10 grey-100-bg\"><strong>{{groupType.name}}</strong></h3><div \nng-repeat=\"item in groupType.labelsEdit track by $index\" class=\"mail-list-item\" role=\"button\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"info\" flex layout=\"row\" layout-align=\"space-between center\"><div class=\"name\" \nlayout=\"row\" layout-align=\"start center\" flex=\"100\"><div class=\"group-name\" layout=\"row\" layout-align=\"start center\" \nflex=\"100\"><parent-group ng-if=\"item.group.parentGroup\" parent=\"item.group.parentGroup\"></parent-group><md-icon \nclass=\"{{item.group.color}}-fg icon-folder md-font-icon mr-10 s24 mt-0 ml-0 mb-0\" \nng-class=\"{\'icon-folder\':item.group.id_group_type == 1, \'qiu-icon-file-usermailing\':item.group.id_group_type == 2,\'qiu-icon-file-usermediacenter\':item.group.id_group_type == 3,\'qiu-icon-file-usersegment\':item.group.id_group_type == 4,\'qiu-icon-file-userstore\':item.group.id_group_type == 5,\'qiu-icon-file-useracreditation\':item.group.id_group_type == 6,\'icon-folder\':item.group.id_group_type == 7,\'icon-folder-remove\':item.group.id_group_type == 8}\" \naria-hidden=\"true\"></md-icon><span>{{item.label}}</span></div></div><div class=\"buttons\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"status-wrapper text-center\" layout=\"row\" layout-align=\"end center\" \nng-repeat=\"i in item.group.ingroup_status | filter: {\'id_ingroup_status\' : item.group.id_ingroup_status} : true\"><div>\n<span class=\"{{i.name}} status\" layout=\"row\" layout-align=\"center center\">{{i.name}}</span></div></div><div \nclass=\"ml-15\"><button class=\"md-icon-button ng-scope\" aria-label=\"Email validated\"><md-icon md-font-icon=\"icon-close\" \nclass=\"s24 md-default-theme md-font material-icons\" role=\"button\" ng-click=\"vm.deleteTargetEdit(item.group, $index)\">\n</md-icon></button></div></div></div></div></div></div></div></div></form><form class=\"md-inline-form\" novalidate><div \nclass=\"group-form\" layout=\"row\" layout-align=\"center center\"><md-button ng-click=\"vm.openUsersGroupsDialog()\" \nclass=\"add-event-button md-fab md-warn\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><span></span></div>\n</form>");
$templateCache.put("app/main/apps/users/views/read/timeline.html","<div id=\"users-activity\" class=\"page-layout simple fullwidth mail-content content-edit scrollable\" layout=\"column\" \nms-scroll=\"vm.msScrollOptions\"><md-list-item class=\"main-item\"><div class=\"main-read\"><div class=\"avatar-container\">\n<div ng-if=\"vm.selectedContent.avatar == \'\' || !vm.selectedContent.avatar\" class=\"avatar {{vm.selectedColor}}\" \nng-bind=\"vm.selectedContent[\'firstname\'] | capitalizeFirstLetter\"></div><media \nng-if=\"vm.selectedContent.avatar !== \'\' && vm.selectedContent.avatar\" attachment=\"vm.selectedContent.avatar\" \nclass=\"avatar fix\"></media><div \nng-repeat=\"field in vm.selectedContent_refgrouped.user_status | orderBy:\'preview_sort\' \" class=\"status\"><span \nng-if=\"field.type==\'user_status\'\"><button ng-if=\"vm.selectedContent[field.title]===0\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\"></md-icon></button> <button \nng-if=\"vm.selectedContent[field.title]===1\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-minus-circle\" \nclass=\"on amber-400-fg s24\"></md-icon></button> <button ng-if=\"vm.selectedContent[field.title]===2\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\"></md-icon></button> \n<button \nng-if=\"vm.selectedContent[field.title]!==0 && vm.selectedContent[field.title]!==1 && vm.selectedContent[field.title]!==2\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"on grey-fg s24\"></md-icon></button>\n</span></div></div></div><div class=\"main-read\" layout=\"column\" layout-align=\"center start \"><div \nng-repeat=\"field in vm.selectedContent_refgrouped.header_main | orderBy:\'preview_sort\' \" class=\"header-element\" \nlayout=\"row\" layout-align=\"center center\"><p ng-if=\"field.type==\'id\'\" class=\"font-size-14\"><span class=\"grey-500-fg\">\nID # </span><span class=\"grey-500-fg\" ng-bind=\"vm.selectedContent[field.title]\"></span></p></div><h1 class=\"name\">\n<strong ng-repeat=\"field in vm.selectedContent_refgrouped.main | orderBy:\'preview_sort\' \" \nng-bind=\"vm.selectedContent[field.title]\" class=\"mr-10\"></strong></h1></div><md-divider></md-divider></md-list-item>\n<div id=\"timeline\" class=\"timeline-left ms-timeline\"><div ng-if=\"vm.userAuditTrailEvents.length > 0\" \nng-repeat=\"(key, value) in vm.userAuditTrailEvents | groupBy: \'dateWithoutHours\'\" class=\"day\"><div class=\"date\">\n{{ key }}</div><div class=\"ms-timeline-item\" layout=\"column\" layout-align=\"center center\" layout-gt-xs=\"row\" \nng-repeat=\"event in value\" layout-align-gt-xs=\"start center\"><div class=\"timeline-point md-accent-bg\"><md-icon \nmd-font-icon=\"icon-tumblr-reblog\" ng-if=\"event.action_id == \'load-in\'\"></md-icon><md-icon md-font-icon=\"icon-logout\" \nng-if=\"event.action_id == \'logged-out\'\"></md-icon><md-icon md-font-icon=\"icon-folder-plus\" \nng-if=\"event.action_id == \'media-added-to-light-box\'\"></md-icon><md-icon md-font-icon=\"icon-folder-remove\" \nng-if=\"event.action_id == \'media-removed-from-light-box\'\"></md-icon><md-icon md-font-icon=\"icon-login\" \nng-if=\"event.action_id == \'succesfull-login\'\"></md-icon><md-icon md-font-icon=\"icon-cloud-download\" \nng-if=\"event.action_id == \'user-download-media\'\"></md-icon><md-icon md-font-icon=\"icon-cloud-download\" \nng-if=\"event.action_id == \'user-download-media-with-crop\'\"></md-icon></div><div class=\"timeline-detail\" layout=\"row\" \nlayout-align=\"start center\"><h3 class=\"name mt-0 mb-0 ml-5\" flex-xs=\"80\"><div class=\"event\">\n{{vm.translate(\'USERS.\'+event.action_id.toUpperCase())}} <a class=\"pointer\" \nng-click=\"vm.openImageDialog($event, event.action_brief.link, false, false, true)\" target=\"_blank\">\n{{event.action_brief.name}}</a></div></h3><div class=\"timeline-detail\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"time\" ng-bind-html=\"vm.timeAgo(event.date)\"></div></div></div></div></div></div><div \nng-if=\"vm.userAuditTrailEvents.length === 0\" class=\"content\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"message\" translate=\"USERS.NO_ACTIVITY\"></div></div></div>");
$templateCache.put("app/main/apps/users/views/list/grid-cells.html","<span ng-if=\"host.cellKind(col) === \'avatar\'\" class=\"mvg-avatar\" \nng-style=\"{\'background-color\': host.avatarColor(row)}\">{{host.avatarText(row)}}</span><span \nng-if=\"host.cellKind(col) === \'readonly\'\" class=\"mvg-readonly\" title=\"{{host.cellDisplay(row, col)}}\">\n{{host.cellDisplay(row, col)}}</span><button ng-if=\"host.cellKind(col) === \'complex\'\" type=\"button\" \nclass=\"mvg-complex-btn md-button md-icon-button\" ng-click=\"host.editComplexCell(row, col, $event)\" \ntitle=\"{{ \'USERS.EDIT_IN_FORM\' | translate }}\"><md-icon md-font-icon=\"icon-pencil-box-outline\" class=\"s18\"></md-icon>\n</button><div ng-if=\"host.cellKind(col) === \'checkbox\'\" class=\"mvg-editor\"><button type=\"button\" class=\"mvg-toggle\" \nng-class=\"{\'is-on\': row[col.title] == 1}\" aria-label=\"{{col.field_name}}\" \nng-click=\"row[col.title] = (row[col.title] == 1 ? 0 : 1); host.saveRow(row)\"><md-icon \nmd-font-icon=\"{{ row[col.title] == 1 ? \'icon-check\' : \'icon-close\' }}\" class=\"s16\"></md-icon></button></div><div \nng-if=\"host.cellKind(col) === \'userstatus\'\" class=\"mvg-editor\"><md-select class=\"mvg-select\" ng-model=\"row[col.title]\" \nng-change=\"host.saveRow(row)\" aria-label=\"{{col.field_name}}\"><md-option ng-repeat=\"opt in host.userStatusOptions\" \nng-value=\"opt.value\"><span class=\"mvg-status-dot\" ng-style=\"{\'background-color\': opt.dot}\"></span>\n{{opt.label | translate}}</md-option></md-select></div><div ng-if=\"host.cellKind(col) === \'date\'\" class=\"mvg-editor\">\n<input type=\"date\" class=\"mvg-input mvg-date-input\" ng-model=\"row[\'$d_\' + col.title]\" \nng-change=\"host.onGridDateChange(row, col)\" max=\"9999-12-31\"></div><div ng-if=\"host.cellKind(col) === \'language\'\" \nclass=\"mvg-editor\"><md-select class=\"mvg-select\" ng-model=\"row[col.title]\" ng-change=\"host.saveRow(row)\" \naria-label=\"{{col.field_name}}\"><md-option ng-repeat=\"opt in host.siteLanguages()\" value=\"{{opt.id_lang}}\">\n{{opt.lang_name}}</md-option></md-select></div><div ng-if=\"host.cellKind(col) === \'related\'\" class=\"mvg-editor\">\n<md-select class=\"mvg-select\" ng-model=\"row[col.title]\" ng-change=\"host.saveRow(row)\" aria-label=\"{{col.field_name}}\">\n<md-option ng-repeat=\"opt in col.values\" ng-value=\"opt[\'id_\' + col.config]\">{{opt[col.config]}}</md-option></md-select>\n</div><div ng-if=\"host.cellKind(col) === \'country\'\" class=\"mvg-editor\"><md-select class=\"mvg-select\" \nng-model=\"row[col.title]\" placeholder=\"—\" md-on-close=\"q.term = \'\'\" ng-change=\"host.onGridGeoChange(row, \'country\')\" \naria-label=\"{{col.field_name}}\"><md-select-header class=\"mvg-select-header\"><input class=\"mvg-select-search\" \ntype=\"search\" ng-model=\"q.term\" placeholder=\"Buscar país…\" ng-click=\"$event.stopPropagation()\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-option value=\"\">—</md-option><md-option \nng-repeat=\"c in host.gridCountries() | filter: {name: q.term}\" ng-value=\"c.id\">{{c.name}}</md-option></md-select></div>\n<div ng-if=\"host.cellKind(col) === \'state\'\" class=\"mvg-editor\"><md-select class=\"mvg-select\" ng-model=\"row[col.title]\" \nplaceholder=\"—\" ng-disabled=\"!row.country\" md-on-close=\"q.term = \'\'\" ng-change=\"host.onGridGeoChange(row, \'state\')\" \naria-label=\"{{col.field_name}}\"><md-select-header class=\"mvg-select-header\"><input class=\"mvg-select-search\" \ntype=\"search\" ng-model=\"q.term\" placeholder=\"Buscar…\" ng-click=\"$event.stopPropagation()\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-option value=\"\">—</md-option><md-option \nng-repeat=\"s in host.gridStatesFor(row.country) | filter: {name: q.term}\" ng-value=\"s.id\">{{s.name}}</md-option>\n</md-select></div><div ng-if=\"host.cellKind(col) === \'city\'\" class=\"mvg-editor\"><md-select class=\"mvg-select\" \nng-model=\"row[col.title]\" placeholder=\"—\" ng-disabled=\"!row.state\" md-on-close=\"q.term = \'\'\" \nng-change=\"host.onGridGeoChange(row, \'city\')\" aria-label=\"{{col.field_name}}\"><md-select-header \nclass=\"mvg-select-header\"><input class=\"mvg-select-search\" type=\"search\" ng-model=\"q.term\" placeholder=\"Buscar…\" \nng-click=\"$event.stopPropagation()\" ng-keydown=\"$event.stopPropagation()\"></md-select-header><md-option value=\"\">—\n</md-option><md-option ng-repeat=\"ci in host.gridCitiesFor(row.country, row.state) | filter: {city: q.term}\" \nng-value=\"ci.id_city\">{{ci.city}}</md-option></md-select></div><textarea ng-if=\"host.cellKind(col) === \'textarea\'\" \nclass=\"mvg-textarea\" rows=\"1\" ng-model=\"row[col.title]\" ng-blur=\"host.saveRow(row)\"></textarea><input \nng-if=\"host.cellKind(col) === \'password\'\" class=\"mvg-input\" type=\"password\" ng-model=\"row[col.title]\" \nng-blur=\"host.saveRow(row)\" placeholder=\"{{col.field_name}}\"> <input ng-if=\"host.cellKind(col) === \'text\'\" \nclass=\"mvg-input\" type=\"text\" ng-model=\"row[col.title]\" ng-blur=\"host.saveRow(row)\" placeholder=\"{{col.field_name}}\">");
$templateCache.put("app/main/apps/users/views/list/grid-groups-cell.html","<div class=\"mvg-groups-inner\" ng-click=\"host.editRowGroups(row, $event)\" title=\"{{ \'GROUP.GROUP\' | translate }}\"><span \nclass=\"mvg-group-chip\" ng-repeat=\"g in row.groups | limitTo:3 track by g.id_group\">\n{{g.name || g.label || (\'#\' + g.id_group)}}</span> <span class=\"mvg-group-more\" ng-if=\"row.groups.length > 3\">\n+{{row.groups.length - 3}}</span> <span class=\"mvg-group-empty\" ng-if=\"!row.groups.length\">—</span><md-icon \nmd-font-icon=\"icon-pencil-box-outline\" class=\"mvg-groups-edit s18\"></md-icon></div>");
$templateCache.put("app/main/apps/users/views/list/list-table-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-if=\"isLoading\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nclass=\"mail-list-item filter-selected\" ng-if=\"vm.selectedGroup\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"info\" flex><div class=\"name\" layout=\"row\" layout-align=\"start center\"><md-icon \nng-if=\"!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 1\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-font-icon=\"icon-folder\" aria-hidden=\"true\"></md-icon>\n<md-icon ng-if=\"!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 2\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-font-icon=\"qiu-icon-file-usermailing\" aria-hidden=\"true\">\n</md-icon><md-icon ng-if=\"vm.selectedGroup.children && vm.selectedGroup.id_group_type == 2\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-svg-src=\"/assets/icons/svg/icon-folder-mail-multiple.svg\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 3\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-font-icon=\"qiu-icon-file-usermediacenter\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"vm.selectedGroup.children && vm.selectedGroup.id_group_type == 3\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-svg-src=\"/assets/icons/svg/icon-folder-play-multiple.svg\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 4\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-font-icon=\"qiu-icon-file-usersegment\" aria-hidden=\"true\">\n</md-icon><md-icon ng-if=\"vm.selectedGroup.children && vm.selectedGroup.id_group_type == 4\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-svg-src=\"/assets/icons/svg/icon-folder-share-multiple.svg\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 5\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-font-icon=\"qiu-icon-file-userstore\" aria-hidden=\"true\">\n</md-icon><md-icon ng-if=\"vm.selectedGroup.children && vm.selectedGroup.id_group_type == 5\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-svg-src=\"/assets/icons/svg/icon-folder-shop-multiple.svg\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 6\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-font-icon=\"qiu-icon-file-useracreditation\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"vm.selectedGroup.children && vm.selectedGroup.id_group_type == 6\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-svg-src=\"/assets/icons/svg/icon-folder-board-multiple.svg\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 7\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-svg-src=\"/assets/icons/svg/icon-folder-chat.svg\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"vm.selectedGroup.children && vm.selectedGroup.id_group_type == 7\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-svg-src=\"/assets/icons/svg/icon-folder-chat-multiple.svg\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 8\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-font-icon=\"icon-folder-remove\" aria-hidden=\"true\">\n</md-icon><md-icon ng-if=\"vm.selectedGroup.children && vm.selectedGroup.id_group_type == 8\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-font-icon=\"icon-folder-multiple\" aria-hidden=\"true\">\n</md-icon><md-icon ng-if=\"vm.selectedGroup.children && vm.selectedGroup.id_group_type == 1\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-font-icon=\"icon-folder-multiple\" aria-hidden=\"true\">\n</md-icon><div class=\"title text-truncate\" layout=\"row\" layout-align=\"start center\">{{vm.selectedGroup.name}} <span \nng-if=\"!isLoading\">({{pagination_totalItems | number}})</span></div></div></div><div class=\"buttons\" layout=\"row\" \nlayout-align=\"start center\"><div><md-switch class=\"no-label\" ng-checked=\"vm.includeSubgroups\" \nng-click=\"vm.toggleIncludeSubgroups($event)\" aria-label=\"{{vm.includeSubgroups ? \'Uncheck\':\'check\'}}\"></md-switch>\n<md-tooltip><span translate=\"CONTENT.INCLUDE_SUBGROUPS\">Include subgroups</span></md-tooltip></div><md-icon \nng-if=\"!vm.selectedGroup.is_qiu_restricted\" md-font-icon=\"icon-close s20\" ng-click=\"vm.unselectGroups()\" class=\"ml-10\">\n<md-tooltip hide show-gt-xs><span translate=\"CONTENT.DESELECT_GROUP\">Deselect group</span></md-tooltip></md-icon></div>\n</div><div class=\"mail-list-item filter-selected\" ng-if=\"vm.fieldOrder != undefined || vm.groupBy != undefined\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"info\" \nng-if=\"vm.groupBy != undefined\"><div class=\"name\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"s20 mr-5 ml-0 mb-0\"></md-icon><div class=\"title text-truncate\" \nlayout=\"row\" layout-align=\"start center\">Grouped by \'{{vm.groupBy}}\'</div></div></div><div class=\"info\" \nng-if=\"vm.fieldOrder != undefined\"><div class=\"name\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-sort-ascending\" class=\"s20 mr-5 ml-0 mb-0\" ng-if=\"sortDir === \'ASC\'\"></md-icon><md-icon \nmd-font-icon=\"icon-sort-descending\" class=\"s20 mr-5 ml-0 mb-0\" ng-if=\"sortDir === \'DESC\'\"></md-icon><div \nclass=\"title text-truncate\" layout=\"row\" layout-align=\"start center\">Ordered by \'{{vm.fieldOrder}}\'</div></div></div>\n</div><div class=\"buttons\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-close s20\" \nng-click=\"vm.resetSortField()\" class=\"ml-10\"><md-tooltip hide show-gt-xs><span translate=\"CONTENT.REMOVE\">Remove</span>\n</md-tooltip></md-icon></div></div><div class=\"no-threads\" \nng-if=\"!isLoading && vm.threads.length === 0 && !vm.pleaseSelectGroup\" ng-hide=\"isLoading\" translate=\"USERS.NO_ITEMS\">\n</div><div class=\"no-threads\" ng-if=\"!isLoading && vm.threads.length === 0 && vm.pleaseSelectGroup\" \nng-hide=\"isLoading\" translate=\"USERS.SELECT_GROUP\"></div><div id=\"list-content-data\" \nng-style=\"{\'opacity\' : isLoading ? 0.2 : 1}\" \nng-class=\"{\'group-filter\': vm.selectedGroup,\'other-filter\':vm.fieldOrder != undefined || vm.groupBy != undefined}\" \nclass=\"scrollable\" ng-if=\"vm.threads.length > 0\"><table class=\"table-scrollable row-border hover simple\" \nms-responsive-table><thead><tr><th class=\"mini\"></th><th \nng-class=\"{\'large\': vm.isLarge(column.title), \'medium\' : vm.isMedium(column.title), \'small\' : vm.isSmall(column.title), \'mini\': vm.isMini(column.title)}\" \nng-repeat=\"column in vm.refcolumns | filter: { table_list_position: \'main\'} | orderBy: vm.orderByTableListSort\" \nng-if=\"column.title !== \'lastname\'\" ng-switch=\"column.title\"><span ng-switch-when=\"firstname\" translate=\"USERS.NAME\">\n</span> <span ng-switch-default ng-bind=\"column.field_name\"></span></th><th class=\"group\" \nng-repeat=\"column in vm.flatGroups | filter: { table_list_position: \'main\'}\"><span translate=\"GROUP.GROUP\"></span><br>\n<span>\"{{column.name}}\"</span></th><th class=\"small\"><md-menu-bar><md-menu><md-button class=\"md-icon-button\" \naria-label=\"Actions\" ng-click=\"$mdMenu.open($event)\" layout=\"row\" layout-align=\"center center\"><md-icon \nmd-font-icon=\"icon-cog\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"USERS.EDIT_COLUMNS\">Edit columns</span>\n</md-tooltip></md-button><md-menu-content><md-menu-item \nng-repeat=\"column in vm.refcolumns | orderBy: vm.orderByTableListSort | filter: vm.filterIsMainOrSecondaryTableListPosition\">\n<md-button md-prevent-menu-close=\"md-prevent-menu-close\" \nng-click=\"column.table_list_position == \'main\' ? column.table_list_position = \'secondary\' : column.table_list_position = \'main\'; $event.stopPropagation();\" \naria-label=\"{{column.field_name}}\"><div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start between\"><span ng-bind=\"column.field_name\"></span></div><i \nng-if=\"column.table_list_position == \'main\'\" class=\"icon-check s16\"></i></div></md-button></md-menu-item><md-menu-item \nng-repeat=\"column in vm.flatGroups\"><md-button md-prevent-menu-close=\"md-prevent-menu-close\" \nng-click=\"column.table_list_position == \'main\' ? column.table_list_position = \'secondary\' : column.table_list_position = \'main\'; $event.stopPropagation();\">\n<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start between\"><span \ntranslate=\"GROUP.GROUP\"></span> <span>\"{{column.name}}\"</span></div><i ng-if=\"column.table_list_position == \'main\'\" \nclass=\"icon-check s16\"></i></div></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></th></tr>\n</thead><tbody><tr ng-click=\"vm.openThread(thread)\" \nng-repeat=\"thread in vm.threads | filter: vm.search | filter: global.search | groupByUser:[vm.groupBy]\" \nng-class=\"{\'starred\': thread.starred, \'selected\': vm.selectedContentID === thread.id_user, \'checked\': vm.isChecked(thread)}\" \nclass=\"{{thread.status}}\"><td class=\"mini\"><md-checkbox class=\"no-label\" ng-checked=\"vm.isSelected(thread)\" \nng-click=\"vm.toggleSelectThread(thread, $event)\" aria-label=\"{{vm.isSelected(thread) ? \'Deselect\' : \'Select\'}}\">\n</md-checkbox></td><td \nng-class=\"{\'large\': vm.isLarge(column.title), \'medium\' : vm.isMedium(column.title), \'small\' : vm.isSmall(column.title), \'mini\': vm.isMini(column.title)}\" \nng-repeat=\"column in vm.refcolumns | filter: { table_list_position: \'main\'} | orderBy: vm.orderByTableListSort\" \nng-if=\"column.title !== \'lastname\'\" ng-switch=\"column.title\"><a ng-switch-when=\"email\" title=\"{{thread.email}}\" \nhref=\"mailto:{{thread.email}}\">{{thread[column.title]}}</a> <span ng-switch-when=\"media\"><div \nng-if=\"(!thread.avatar) && thread[vm.refcolumnsgrouped.main[0].title]\" class=\"avatar\" \nng-bind=\"thread[vm.refcolumnsgrouped.main[0].title] | capitalizeFirstLetter\" ms-random-class=\"vm.colors\"></div><media \nng-if=\"thread.avatar\" attachment=\"thread.avatar\" class=\"avatar\"></media></span><span title=\"# {{thread.id_user}}\" \nclass=\"grey-500-fg\" ng-switch-when=\"id_user\">#{{thread.id_user}}</span> <span class=\"large\" ng-switch-when=\"firstname\">\n<strong title=\"{{thread.firstname}} {{thread.lastname}}\">{{thread.firstname}} {{thread.lastname}}</strong> </span><span\n class=\"mini\" ng-switch-when=\"status\"><button ng-if=\"thread.status===0\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\" \nng-click=\"vm.toggleItemStatus(thread, $event, $index)\"></md-icon><md-tooltip><span \ntranslate=\"USERS.EMAIL_STATUS.IMPORTED\">Email imported</span></md-tooltip></button> <button ng-if=\"thread.status===1\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-minus-circle\" class=\"on amber-400-fg s24\" \nng-click=\"vm.toggleItemStatus(thread, $event, $index)\"></md-icon><md-tooltip><span \ntranslate=\"USERS.EMAIL_STATUS.NOT_VALIDATED\">Email not validated</span></md-tooltip></button> <button \nng-if=\"thread.status===2\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" \nclass=\"on green-fg s24\" ng-click=\"vm.toggleItemStatus(thread, $event, $index)\"></md-icon><md-tooltip><span \ntranslate=\"USERS.EMAIL_STATUS.VALIDATED\">Email validated</span></md-tooltip></button> <button \nng-if=\"thread.status!==0 && thread.status!==1 && thread.status!==2\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle\" class=\"on grey-fg s24\" \nng-click=\"vm.toggleItemStatus(thread, $event, $index)\"></md-icon></button> </span><span class=\"mini\" \nng-switch-when=\"ingroup_status\"><div ng-if=\"thread.groups.length\" class=\"status-wrapper text-center\" layout=\"row\" \nlayout-align=\"end center\"><div ng-repeat=\"status in vm.ingroupStatus\"><span \nng-click=\"vm.changeInGroupStatusDialog($event, thread, vm.selectedGroup, status)\" \nng-if=\"vm.isShowingLabelGroup(thread, status)\" class=\"{{status.name}} status\" \ntranslate=\"USERS.INGROUP.STATUS.{{status.name | uppercase}}\" layout=\"row\" layout-align=\"center center\" \nng-style=\"{\'background\': status.color || \'\'}\"></span></div></div></span><span \ntitle=\"{{thread.related_country.country}}\" ng-switch-when=\"country\">{{thread.related_country.country}}</span> <span \ntitle=\"{{thread.related_state.state}}\" ng-switch-when=\"state\">{{thread.related_state.state}}</span> <span \ntitle=\"{{thread.related_city.city}}\" ng-switch-when=\"city\">{{thread.related_city.city}}</span> <span \ntitle=\"{{thread.childs}}\" ng-switch-when=\"childs\">{{thread.childs}}</span> <span title=\"{{thread[column.title]}}\" \nng-switch-default>{{column.category == \'json\' ? vm.JSONparse(thread.user_params)[column.title] : thread[column.title]}}\n</span></td><td class=\"group\" ng-repeat=\"column in vm.flatGroups | filter: { table_list_position: \'main\'}\"><md-checkbox\n ng-disabled=\"true\" class=\"no-label\" ng-checked=\"(thread.groups|filter:{\'id_group\':column.id_group}).length > 0\" \naria-label=\"{{vm.isSelected(thread) ? \'Deselect\' : \'Select\'}}\"></md-checkbox></td><td class=\"small\"></td></tr></tbody>\n</table><div class=\"toolbar border-top\" style=\"padding-bottom: 18px\" layout=\"row\" layout-align=\"end center\"><div \nlayout=\"row\" layout-align=\"center center\" ng-style=\"{\'display\' : isLoading ? \'none\' : \'block\'}\"><span \nclass=\"page-info\">{{pagination_totalItems}} items found.</span><md-button aria-label=\"Previous\" \nclass=\"md-icon-button arrow\" ng-click=\"pagination_prevPage()\" ng-disabled=\"pagination_firstPage()\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip hide \nshow-gt-xs><span translate=\"CONTENT.PREVIOUS\">Previous</span></md-tooltip></md-button><span class=\"page-info\">\n{{pagination_page}} / {{pagination_total_pages}}</span><md-button aria-label=\"Next\" class=\"md-icon-button arrow\" \nng-click=\"pagination_nextPage()\" ng-disabled=\"pagination_morePages() || pagination_total_pages === pagination_page\" \ntranslate=\"\" translate-attr-aria-label=\"CONTENT.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip \nhide show-gt-xs><span translate=\"CONTENT.NEXT\">Next</span></md-tooltip></md-button></div></div></div>");
$templateCache.put("app/main/apps/users/views/list/list-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-if=\"isLoading\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nclass=\"mail-list-item filter-selected\" id=\"list-view1\" \nng-if=\"vm.selectedGroup && !vm.selectedGroupsAcc && !vm.selectedGroupsAccSub\" layout=\"row\" layout-align=\"start center\">\n<div class=\"info\" flex><div class=\"name\" layout=\"row\" layout-align=\"start center\"><md-icon \nng-if=\"!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 1\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-font-icon=\"icon-folder\" aria-hidden=\"true\"></md-icon>\n<md-icon ng-if=\"vm.selectedGroup.children && vm.selectedGroup.id_group_type == 1\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-font-icon=\"icon-folder-multiple\" aria-hidden=\"true\">\n</md-icon><md-icon ng-if=\"!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 2\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-font-icon=\"qiu-icon-file-usermailing\" aria-hidden=\"true\">\n</md-icon><md-icon ng-if=\"vm.selectedGroup.children && vm.selectedGroup.id_group_type == 2\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-svg-src=\"/assets/icons/svg/icon-folder-mail-multiple.svg\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 3\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-font-icon=\"qiu-icon-file-usermediacenter\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"vm.selectedGroup.children && vm.selectedGroup.id_group_type == 3\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-svg-src=\"/assets/icons/svg/icon-folder-play-multiple.svg\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 4\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-font-icon=\"qiu-icon-file-usersegment\" aria-hidden=\"true\">\n</md-icon><md-icon ng-if=\"vm.selectedGroup.children && vm.selectedGroup.id_group_type == 4\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-svg-src=\"/assets/icons/svg/icon-folder-share-multiple.svg\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 5\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-font-icon=\"qiu-icon-file-userstore\" aria-hidden=\"true\">\n</md-icon><md-icon ng-if=\"vm.selectedGroup.children && vm.selectedGroup.id_group_type == 5\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-svg-src=\"/assets/icons/svg/icon-folder-shop-multiple.svg\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 6\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-font-icon=\"qiu-icon-file-useracreditation\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"vm.selectedGroup.children && vm.selectedGroup.id_group_type == 6\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-svg-src=\"/assets/icons/svg/icon-folder-board-multiple.svg\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 7\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-svg-src=\"/assets/icons/svg/icon-folder-chat.svg\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"vm.selectedGroup.children && vm.selectedGroup.id_group_type == 7\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-svg-src=\"/assets/icons/svg/icon-folder-chat-multiple.svg\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 8\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-font-icon=\"icon-folder-remove\" aria-hidden=\"true\">\n</md-icon><md-icon ng-if=\"vm.selectedGroup.children && vm.selectedGroup.id_group_type == 8\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-font-icon=\"icon-folder-multiple\" aria-hidden=\"true\">\n</md-icon><div class=\"title text-truncate\" layout=\"row\" layout-align=\"start center\">{{vm.selectedGroup.name}} <span \nng-if=\"!isLoading\">({{pagination_totalItems | number}}<span ng-if=\"vm.selectedGroup.raw_settings.max_allowed_users\">\n {{ \'USERS.OF\' | translate}} {{vm.selectedGroup.raw_settings.max_allowed_users}}</span>)</span></div></div></div><div \nlayout=\"row\" class=\"mr-20 in-group-status-filter\" layout-align=\"start center\"><md-select \nng-model=\"vm.selectedIngroupStatus\" ng-change=\"vm.changeSelectedIngroupStatus()\" placeholder=\"Status filter\"><md-option\n value=\"0\" translate=\"USERS.INGROUP.STATUS.ALL\"></md-option><md-option ng-repeat=\"status in vm.ingroupStatus\" \nng-if=\"status.id_group_type == vm.selectedGroup.id_group_type\" value=\"{{status.id_ingroup_status}}\" \ntranslate=\"USERS.INGROUP.STATUS.{{status.name | uppercase}}\" ng-style=\"{\'background\': status.color || \'\'}\"></md-option>\n</md-select></div><div class=\"buttons\" layout=\"row\" layout-align=\"start center\"><div \nng-if=\"!vm.selectedGroup.is_qiu_restricted\"><md-switch class=\"no-label\" ng-checked=\"vm.includeSubgroups\" \nng-click=\"vm.toggleIncludeSubgroups($event)\" aria-label=\"{{vm.includeSubgroups ? \'Uncheck\':\'check\'}}\"></md-switch>\n<md-tooltip><span translate=\"CONTENT.INCLUDE_SUBGROUPS\">Include subgroups</span></md-tooltip></div><md-icon \nng-if=\"!vm.selectedGroup.is_qiu_restricted\" md-font-icon=\"icon-close s20\" ng-click=\"vm.unselectGroups(); \" \nclass=\"ml-10\"><md-tooltip hide show-gt-xs><span translate=\"CONTENT.DESELECT_GROUP\">Deselect group</span></md-tooltip>\n</md-icon></div></div><div class=\"mail-list-item filter-selected\" \nng-if=\"(vm.selectedGroupsAcc && vm.selectedGroupsAcc.length > 0) || (vm.selectedGroupsAccSub && vm.selectedGroupsAccSub.length > 0)\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"info\" flex><div class=\"name\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"title text-truncate\" layout=\"row\" layout-align=\"start center\">\n{{vm.selectedGroupsAcc[0].name}} <span \nng-if=\"!isLoading && (!vm.selectedGroupsAccSub || !vm.selectedGroupsAccSub.length > 0)\">\n({{pagination_totalItems | number}}<span ng-if=\"vm.selectedGroupsAcc[0].raw_settings.max_allowed_users\">\n {{ \'USERS.OF\' | translate}} {{vm.selectedGroupsAcc[0].raw_settings.max_allowed_users}}</span>)</span></div><div \nclass=\"title text-truncate\" layout=\"row\" layout-align=\"start center\"><span class=\"ml-5\" \nng-if=\"vm.selectedGroupsAcc && vm.selectedGroupsAcc.length > 0 && vm.selectedGroupsAccSub && vm.selectedGroupsAccSub.length > 0\">\n> </span><span>{{vm.selectedGroupsAccSub[0].name}} <span \nng-if=\"!isLoading && vm.selectedGroupsAccSub && vm.selectedGroupsAccSub.length > 0\">({{pagination_totalItems | number}}\n<span ng-if=\"vm.selectedGroupsAcc[0].raw_settings.max_allowed_users\">\n {{ \'USERS.OF\' | translate}} {{vm.selectedGroupsAcc[0].raw_settings.max_allowed_users}}</span>)</span></span></div>\n</div></div><div ng-if=\"!vm.selectedGroupsAcc[0].parent\" layout=\"row\" class=\"mr-20 in-group-status-filter\" \nlayout-align=\"start center\"><md-select ng-model=\"vm.selectedIngroupStatus\" \nng-change=\"vm.changeSelectedIngroupStatus()\" placeholder=\"Status filter\"><md-option value=\"0\" \ntranslate=\"USERS.INGROUP.STATUS.ALL\"></md-option><md-option ng-repeat=\"status in vm.ingroupStatus\" \nng-if=\"vm.showStatus(status)\" value=\"{{status.id_ingroup_status}}\" \ntranslate=\"USERS.INGROUP.STATUS.{{status.name | uppercase}}\" ng-style=\"{\'background\': status.color || \'\'}\"></md-option>\n</md-select></div><div class=\"buttons\" layout=\"row\" layout-align=\"start center\"><md-icon \nng-if=\"!vm.selectedGroupsAccSub[0].is_qiu_restricted\" md-font-icon=\"icon-close s20\" ng-click=\"vm.unselectGroups()\" \nclass=\"ml-10\"><md-tooltip hide show-gt-xs><span translate=\"CONTENT.DESELECT_GROUP\">Deselect group</span></md-tooltip>\n</md-icon></div></div><div class=\"mail-list-item filter-selected\" \nng-if=\"vm.fieldOrder != undefined || vm.groupBy != undefined\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\" flex><div class=\"info\" ng-if=\"vm.groupBy != undefined\"><div class=\"name\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"s20 mr-5 ml-0 mb-0\">\n</md-icon><div class=\"title text-truncate\" layout=\"row\" layout-align=\"start center\">Grouped by \'{{vm.groupBy}}\'</div>\n</div></div><div class=\"info\" ng-if=\"vm.fieldOrder != undefined\"><div class=\"name\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-sort-ascending\" class=\"s20 mr-5 ml-0 mb-0\" \nng-if=\"sortDir === \'ASC\'\"></md-icon><md-icon md-font-icon=\"icon-sort-descending\" class=\"s20 mr-5 ml-0 mb-0\" \nng-if=\"sortDir === \'DESC\'\"></md-icon><div class=\"title text-truncate\" layout=\"row\" layout-align=\"start center\">\nOrdered by \'{{vm.fieldOrder}}\'</div></div></div></div><div class=\"buttons\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-close s20\" ng-click=\"vm.resetSortField()\" class=\"ml-10\"><md-tooltip hide show-gt-xs><span \ntranslate=\"CONTENT.REMOVE\">Remove</span></md-tooltip></md-icon></div></div><div class=\"no-threads\" \nng-if=\"!validSelection\" ng-hide=\"isLoading\"><div class=\"message\" translate=\"USERS.NO_ITEMS\"></div></div><div \nclass=\"no-threads message\" ng-if=\"!isLoading && vm.threads.length === 0 && !vm.pleaseSelectGroup\" ng-hide=\"isLoading\">\n<div class=\"message\" translate=\"USERS.NO_ITEMS\"></div></div><div class=\"no-threads message\" \nng-if=\"vm.pleaseSelectGroup\" ng-hide=\"isLoading\"><div class=\"message\" translate=\"USERS.SELECT_GROUP\"></div></div><div \nid=\"list-content-data\" ng-style=\"{\'opacity\' : isLoading ? 0.2 : 1}\" ms-scroll=\"vm.msScrollOptions\" \nng-class=\"{\'group-filter\': vm.selectedGroup || vm.selectedGroupsAcc || vm.selectedGroupsAccSub,\'other-filter\':vm.fieldOrder != undefined || vm.groupBy != undefined}\" \nclass=\"scrollable\" ng-if=\"vm.threads.length > 0 && validSelection && !vm.pleaseSelectGroup\"><div \nng-if=\"vm.currentLabelsFilter\" class=\"labels\"><form novalidate><div><div \nng-repeat=\"item in vm.currentLabelsFilter track by $index\" class=\"tag\" fxlayout=\"row\" fxlayoutalign=\"start center\"><div\n class=\"tag-label\">{{item.label}}<md-icon ng-click=\"vm.deleteTargetFilter(item.id, $index)\" md-font-icon=\"icon-close\" \nclass=\"s24 pointer\"></md-icon></div></div></div></form></div><div class=\"mail-list-item {{thread.status}}\" \nng-repeat=\"thread in vm.threads | filter: vm.search | filter: global.search | groupByUser:[vm.groupBy]\" md-no-ink \nng-click=\"vm.openThread(thread)\" \nng-class=\"{\'starred\': thread.starred, \'selected\': vm.selectedContentID === thread.id_user, \'checked\': vm.isChecked(thread)}\">\n<div class=\"groupBy-separator\" ng-show=\"thread.group_by_CHANGED\"><h2 ng-if=\"thread.firstname[0]\" \nclass=\"groupBy-title uppercase\">{{thread.firstname[0]}}</h2><h2 ng-if=\"!thread.firstname[0]\" class=\"groupBy-title\">\n(without name)</h2></div><div layout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-label\" \nng-checked=\"vm.isSelected(thread)\" ng-click=\"vm.toggleSelectThread(thread, $event)\" \naria-label=\"{{vm.isSelected(thread) ? \'Deselect\' : \'Select\'}}\"></md-checkbox><div \nng-repeat=\"field in vm.refcolumnsgrouped.left_center | orderBy:\'list_sort\'\"><div ng-if=\"field.type == \'user_status\'\">\n<button ng-if=\"thread.status===0\" class=\"md-icon-button md-button\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\" \nng-click=\"vm.toggleItemStatus(thread, $event, $index)\"></md-icon><md-tooltip><span \ntranslate=\"USERS.STATUS_NAMES.DISABLED\"></span></md-tooltip></button> <button ng-if=\"thread.status===1\" \nclass=\"md-icon-button md-button\"><md-icon md-font-icon=\"icon-minus-circle\" class=\"on amber-400-fg s24\" \nng-click=\"vm.toggleItemStatus(thread, $event, $index)\"></md-icon><md-tooltip><span \ntranslate=\"USERS.STATUS_NAMES.NOT_CONFIRMED\"></span></md-tooltip></button> <button ng-if=\"thread.status===2\" \nclass=\"md-icon-button md-button\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\" \nng-click=\"vm.toggleItemStatus(thread, $event, $index)\"></md-icon><md-tooltip><span \ntranslate=\"USERS.STATUS_NAMES.VALIDATED\"></span></md-tooltip></button> <button ng-if=\"thread.status===99\" \nclass=\"md-icon-button md-button\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"on black-fg s24\" \nng-click=\"vm.toggleItemStatus(thread, $event, $index)\"></md-icon><md-tooltip><span \ntranslate=\"USERS.STATUS_NAMES.BLOCKED\"></span></md-tooltip></button> <button \nng-if=\"thread.status!==0 && thread.status!==1 && thread.status!==2 && thread.status!==99\" \nclass=\"md-icon-button md-button\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"on grey-fg s24\" \nng-click=\"vm.toggleItemStatus(thread, $event, $index)\"></md-icon></button></div><div ng-if=\"field.type == \'language\'\" \nlayout=\"row\" layout-align=\"center center\"><img class=\"img-flag ng-scope\" \nalt=\"{{vm.siteLanguages(thread[field.title])[lang_name]}}\" \nng-src=\"assets/images/flags/{{vm.siteLanguages()[thread[field.title]].flag_code|lowercase}}.svg\"></div><div \nng-if=\"field.type == \'thumbnail\'\"><media attachment=\"listImage\" thumbnail=\"1\" crop-format=\"{{field.id_cropformats}}\" \nclass=\"avatar ng-scope\" alt=\"{{listImage.filename}}\" \nng-repeat=\"listImage in thread.Thumbnail | filter: {\'id_zone\':field.id_zone} | limitTo:1\"></media></div><div \nng-if=\"field.type == \'thumbnail_square\'\"><media attachment=\"listImage\" thumbnail=\"1\" \ncrop-format=\"{{field.id_cropformats}}\" class=\"avatar square ng-scope\" alt=\"{{listImage.filename}}\" \nng-repeat=\"listImage in thread.Thumbnail | filter: {\'id_zone\':field.id_zone} | limitTo:1\"></media></div><md-icon \nmd-font-icon=\"icon-alert-circle\" class=\"is-important red-600-fg\" ng-if=\"field.type == \'important\' && task.important\">\n</md-icon><md-icon md-font-icon=\"icon-attachment\" class=\"has-attachment s24\" \nng-if=\"field.type == \'attachments\' && thread.Thumbnail.length > 0\"></md-icon></div><div class=\"info\" flex><div \nclass=\"name\" layout=\"row\" layout-align=\"start center\"><div \nng-if=\"(!thread.avatar) && thread[vm.refcolumnsgrouped.main[0].title]\" class=\"avatar\" \nng-bind=\"thread[vm.refcolumnsgrouped.main[0].title] | capitalizeFirstLetter\" ms-random-class=\"vm.colors\"></div><div \nng-if=\"thread.avatar && thread.avatar !== \'\'\" class=\"avatar\"><img ng-src=\"{{thread.avatar}}\" alt=\"\"></div><div \nclass=\"user-name\" layout=\"column\" layout-align=\"start start\"><div ng-if=\"vm.refcolumnsgrouped.main\" \nclass=\"user-header text-truncate grey-500-fg\"><span \nng-repeat=\"field in vm.refcolumnsgrouped.header | orderBy: \'list_sort\'\"><span ng-if=\"field.type == \'id\'\">#</span> <span\n ng-if=\"field.type == \'dateHm\' || field.type == \'date\'\" ng-bind=\"vm.showDate(thread[field.title])\"></span> <span \nng-if=\"field.type != \'dateHm\' && field.type != \'date\'\" ng-bind=\"thread.{{field.title}}\"></span></span></div><div \nng-if=\"vm.refcolumnsgrouped.main\"><span ng-repeat=\"field in vm.refcolumnsgrouped.main\"><span \nng-bind=\"thread.{{field.title}}\"></span>&nbsp;</span></div><div \nng-repeat=\"field in vm.refcolumnsgrouped.secondary | orderBy:\'list_sort\'\" class=\"width-percent-100\"><div \nng-if=\"(field.category!==\'show_groups_as_field\' && field.category!==\'show_groups_inlist\' && field.type!==\'id_subcat\' && field.type!==\'id_cat\' && field.type!==\'id_subsec\'\r\n                    && field.type!==\'date\' && field.type!==\'dateHm\') && field.primary!==1\" \nclass=\"details text-truncate\"><span class=\"title\" ng-bind=\"thread.{{field.title}}\"></span></div><div \nng-if=\"field.type==\'id_subsec\'\" class=\"details\" layout=\"row\" layout-align=\"start start\"><span \nclass=\"title grey-500-fg\" ng-bind=\"field.field_name\"></span> <span class=\"detail text-truncate\" \nng-bind=\"vm.getReferencesSections(\'subsection\', field.type, thread.{{field.title}})\"></span></div><div \nng-if=\"field.type==\'id_cat\'\" class=\"details\" layout=\"row\" layout-align=\"start start\"><span class=\"title grey-500-fg\" \nng-bind=\"field.field_name\"></span> <span class=\"detail text-truncate\" \nng-bind=\"vm.getReferencesSections(\'cat\', field.type, thread.{{field.title}})\"></span></div><div \nng-if=\"field.type==\'id_subcat\'\" class=\"details\" layout=\"row\" layout-align=\"start start\"><span \nclass=\"title grey-500-fg\" ng-bind=\"field.field_name\"></span> <span class=\"detail text-truncate\" \nng-bind=\"vm.getReferencesSections(\'subcat\', field.type, thread.{{field.title}})\"></span></div><div \nng-if=\"field.category==\'show_groups_inlist\'\" class=\"details\" layout=\"row\" layout-align=\"start start\"><div \nclass=\"acc-list width-percent-100\" layout=\"row\" layout-align=\"start start\"><div \nng-repeat=\"group in thread.groups | filter:vm.filterActiveTypes(field.title)\" class=\"group pointer active\" \nstyle=\"margin-left: -4px\" layout=\"row\" layout-align=\"start center\"><md-icon ng-if=\"vm.getGroupIcon(group)\" \nclass=\"s16 mr-5 mt-0 ml-0 mb-0 {{group.color}}-fg\" md-font-icon=\"{{vm.getGroupIcon(group)}}\" aria-hidden=\"true\">\n</md-icon><span class=\"name\">{{group.name}}</span></div></div></div><div \nng-if=\"field.category==\'show_groups_as_field\'\" class=\"details\" layout=\"row\" layout-align=\"start start\"></div><div \nng-if=\"field.category==\'json\'\" class=\"details\" layout=\"row\" layout-align=\"start start\"><span class=\"title grey-500-fg\" \nng-bind=\"field.field_name\"></span> <span class=\"detail text-truncate\" \nng-bind=\"vm.JSONparse(thread.user_params)[field.title]\"></span></div></div></div></div></div><div class=\"buttons\" \nlayout=\"row\" layout-align=\"start center\"><div \nng-repeat=\"field in vm.refcolumnsgrouped.right_center | orderBy:\'list_sort\'\"><div \nng-if=\"field.type == \'ingroup_status\' && thread.groups.length && !vm.isAccreditations\" \nclass=\"status-wrapper text-center\" layout=\"row\" layout-align=\"end center\"><div ng-repeat=\"status in vm.ingroupStatus\">\n<span ng-click=\"vm.changeInGroupStatusDialog($event, thread, vm.selectedGroup, status)\" \nng-if=\"vm.isShowingLabelGroup(thread, status)\" class=\"{{status.name}} status\" \ntranslate=\"USERS.INGROUP.STATUS.{{status.name | uppercase}}\" layout=\"row\" layout-align=\"center center\" \nng-style=\"{\'background\': status.color || \'\'}\"></span></div></div><div \nng-if=\"field.type == \'ingroup_status\' && thread.groups.length && vm.isAccreditations\" \nclass=\"status-wrapper text-center\" layout=\"row\" layout-align=\"end center\"><div ng-repeat=\"status in vm.ingroupStatus\">\n<span ng-click=\"vm.changeInGroupStatusDialog($event, thread, group, status)\" \nng-if=\"vm.isShowingLabelGroup(thread, status)\" class=\"{{status.name}} status\" \ntranslate=\"USERS.INGROUP.STATUS.{{status.name | uppercase}}\" layout=\"row\" layout-align=\"center center\" \nng-style=\"{\'background\': status.color || \'\'}\"></span></div></div><div class=\"grey-500-fg ml-10\" \nng-if=\"field.type == \'id\'\" ng-bind=\"\'# \'+thread.{{field.title}}\"></div><div class=\"grey-500-fg\" \nng-if=\"field.type == \'dateHm\' || field.type == \'date\'\" ng-bind=\"vm.showDate(thread[field.title])\"></div><div \nclass=\"grey-500-fg\" \nng-if=\"field.type != \'dateHm\' && field.type != \'date\' && field.type != \'user_status\' && field.type != \'id\' && field.type != \'ingroup_status\'\" \nng-bind=\"thread.{{field.title}}\"></div><div ng-if=\"field.type == \'user_status\'\" class=\"ml-10\"><button \nng-if=\"thread.status===0\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-blank-circle-outline\" \nclass=\"off red-fg s24\" ng-click=\"vm.toggleItemStatus(thread, $event, $index)\"></md-icon><md-tooltip><span \ntranslate=\"USERS.STATUS_NAMES.DISABLED\"></span></md-tooltip></button> <button ng-if=\"thread.status===1\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-minus-circle\" class=\"on amber-400-fg s24\" \nng-click=\"vm.toggleItemStatus(thread, $event, $index)\"></md-icon><md-tooltip><span \ntranslate=\"USERS.STATUS_NAMES.NOT_VALIDATED\"></span></md-tooltip></button> <button ng-if=\"thread.status===2\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\" \nng-click=\"vm.toggleItemStatus(thread, $event, $index)\"></md-icon><md-tooltip><span \ntranslate=\"USERS.STATUS_NAMES.VALIDATED\"></span></md-tooltip></button> <button ng-if=\"thread.status===99\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"on black-fg s24\" \nng-click=\"vm.toggleItemStatus(thread, $event, $index)\"></md-icon><md-tooltip><span \ntranslate=\"USERS.STATUS_NAMES.BLOCKED\"></span></md-tooltip></button> <button \nng-if=\"thread.status!==0 && thread.status!==1 && thread.status!==2 && thread.status!==99\" class=\"md-icon-button\">\n<md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"on grey-fg s24\" \nng-click=\"vm.toggleItemStatus(thread, $event, $index)\"></md-icon></button></div><div ng-if=\"field.type == \'language\'\">\n<img class=\"square ng-scope\" alt=\"{{vm.siteLanguages(thread[field.title])[lang_name]}}\" \nng-src=\"assets/images/flags/{{vm.siteLanguages()[thread[field.title]].flag_code|lowercase}}.png\"></div><div \nng-if=\"field.type == \'thumbnail\'\"><media attachment=\"listImage\" thumbnail=\"1\" crop-format=\"{{field.id_cropformats}}\" \nclass=\"avatar ng-scope\" alt=\"{{listImage.filename}}\" \nng-repeat=\"listImage in thread.Thumbnail | filter: {\'id_zone\':field.id_zone} | limitTo:1\"></media></div><div \nng-if=\"field.type == \'thumbnail_square\'\"><media attachment=\"listImage\" thumbnail=\"1\" \ncrop-format=\"{{field.id_cropformats}}\" class=\"avatar square ng-scope\" alt=\"{{listImage.filename}}\" \nng-repeat=\"listImage in thread.Thumbnail | filter: {\'id_zone\':field.id_zone} | limitTo:1\"></media></div><md-icon \nmd-font-icon=\"icon-alert-circle\" class=\"is-important red-600-fg\" ng-if=\"field.type == \'important\' && task.important\">\n</md-icon><md-icon md-font-icon=\"icon-attachment\" class=\"has-attachment s24\" \nng-if=\"field.type == \'attachments\' && thread.Thumbnail.length > 0\"></md-icon></div></div><div layout=\"column\" \nlayout-align=\"space-between end\"></div></div></div><div \nng-if=\"!isLoading && pagination_total_pages > pagination_page && vm.threads.length > 0\" class=\"load-more white p-30\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center center\" layout-wrap=\"\"><md-button \nng-click=\"pagination_nextPage(true)\" class=\"md-raised\">{{ \'USERS.LOAD_MORE\' | translate}}</md-button></div></div>");
$templateCache.put("app/main/apps/users/views/list/nosplit-view-activity.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/users/views/list/toolbar-activity.html\'\"></div><div ng-if=\"vm.userAuditTrailEvents\" \nclass=\"content-wrapper\" flex=\"\" layout=\"row\"><div class=\"thread-list mail-list-pane\" flex id=\"thread-list\"><div \nid=\"users-activity\" ms-scroll=\"vm.msScrollOptions\" class=\"page-layout simple fullwidth mail-content content-edit\" \nng-class=\"{\'pb-100\' : pagination_total_pages == vm.page}\" layout=\"column\"><div id=\"timeline\" \nclass=\"timeline-left ms-timeline\"><div ng-if=\"vm.userAuditTrailEvents.length > 0\" \nng-repeat=\"(key, value) in vm.userAuditTrailEvents | groupBy: \'dateWithoutHours\'\" class=\"day\"><div class=\"date\">\n{{ key }}</div><div class=\"ms-timeline-item\" layout=\"row\" layout-align-gt-xs=\"start center\" ng-repeat=\"event in value\">\n<div ng-if=\"(event.user.avatar == \'\' || !event.user.avatar)\" flex-xs=\"20\" class=\"avatar\" \nng-bind=\"event.user.firstname | capitalizeFirstLetter\" ms-random-class=\"vm.colors\"></div><div class=\"avatar-wrapper\" \nng-if=\"event.user.avatar\" flex-xs=\"20\" attachment=\"event.user.avatar\"><img class=\"avatar\" \nng-src=\"{{event.user.avatar}}\" imageonload></div><h3 class=\"name mt-0 mb-0 ml-5\" flex-xs=\"80\"><strong \nng-bind-html=\"event.user.firstname + \' \' + event.user.lastname\"></strong><div class=\"event\">\n{{vm.translate(\'USERS.\'+event.action_id.toUpperCase())}} <a class=\"pointer\" \nng-click=\"vm.openImageDialog($event, event.action_brief.link, false, false, true)\" target=\"_blank\">\n{{event.action_brief.name}}</a></div></h3><div class=\"timeline-detail\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"time\" ng-bind-html=\"vm.timeAgo(event.date)\"></div></div></div></div></div><div \nng-if=\"pagination_total_pages > vm.page &&  !vm.isLoading && vm.userAuditTrailEvents.length > 0\" class=\"load-more\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center center\" layout-wrap=\"\"><md-button ng-click=\"vm.loadMore()\" \nclass=\"md-raised ph-10\">{{ \'USERS.LOAD_MORE\' | translate}}</md-button></div><div \nng-if=\"!isLoading && pagination_total_pages== vm.page\" class=\"content font-2rem\" layout=\"column\" \nlayout-align=\"top center\"><div class=\"message\" translate=\"USERS.NO_MORE_ACTIVITY\"></div></div><div \nng-if=\"!isLoading && vm.userAuditTrailEvents.length === 0\" class=\"content font-2rem\" layout=\"column\" \nlayout-align=\"top center\"><div class=\"message\" translate=\"USERS.NO_ACTIVITY\"></div></div></div></div></div>");
$templateCache.put("app/main/apps/users/views/list/nosplit-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/users/views/list/toolbar.html\'\"></div><div class=\"content-wrapper\" flex=\"\" layout=\"row\"><div\n class=\"content thread-detail mail-read-pane\" flex=\"\" id=\"thread-detail\" ms-scroll=\"vm.msScrollOptions\" \nng-if=\"(vm.currentThread || vm.currentThread_Edit) && !vm.isAccreditations \" \nng-include=\"\'app/main/apps/users/views/read/read-view-nosplit.html\'\"></div><div \nclass=\"content thread-detail mail-read-pane\" flex=\"\" id=\"thread-detail\" ms-scroll=\"vm.msScrollOptions\" \nng-if=\"(vm.currentThread || vm.currentThread_Edit) && vm.isAccreditations\" \nng-include=\"\'app/main/apps/users/views/read/read-view-accreditations.html\'\"></div><div \nclass=\"content thread-list mail-list-pane\" flex id=\"thread-list\" layout=\"column\" \nng-if=\"!vm.currentThread && !vm.currentThread_Edit\" ng-include=\"\'app/main/apps/users/views/list/list-view.html\'\"></div>\n</div>");
$templateCache.put("app/main/apps/users/views/list/split-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/users/views/list/toolbar.html\'\"></div><div class=\"content-wrapper\" flex=\"\" layout=\"row\"><div\n class=\"content thread-list mail-list-pane\" flex=\"40\" id=\"list-view2\" layout=\"column\" id=\"thread-list\" \nng-include=\"\'app/main/apps/users/views/list/list-view.html\'\"></div><div ng-if=\"!vm.isAccreditations\" \nclass=\"content thread-detail mail-read-pane\" flex=\"60\" id=\"thread-detail\" layout=\"column\" \nng-include=\"\'app/main/apps/users/views/read/read-view.html\'\"></div><div ng-if=\"vm.isAccreditations\" \nclass=\"content thread-detail mail-read-pane\" flex=\"60\" id=\"thread-detail\" layout=\"column\" \nng-include=\"\'app/main/apps/users/views/read/read-view-accreditations.html\'\"></div></div>");
$templateCache.put("app/main/apps/users/views/list/spreadsheet-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/users/views/list/toolbar.html\'\"></div><mv-grid flex rows=\"vm.threads\" \ncolumns=\"vm.refcolumns\" host=\"vm\" loading=\"isLoading\" settings-key=\"{{vm.settingsSection}}\" \nsort-field=\"table_list_sort\" cell-template=\"app/main/apps/users/views/list/grid-cells.html\" \nfixed-columns=\"vm.gridFixedColumns\" column-width=\"vm.gridColumnWidth(col)\" row-init=\"vm.ensureGridRow(row)\" \nis-selected=\"vm.isSelected(row)\" on-toggle-select=\"vm.toggleSelectThread(row, $event)\" api=\"vm.gridApi\" \nnew-row-init=\"vm.gridNewRowDefaults()\" on-new-row-save=\"vm.gridCreateRow(row)\" empty-text=\"USERS.NO_RESULTS\"></mv-grid>");
$templateCache.put("app/main/apps/users/views/list/table-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/users/views/list/toolbar.html\'\"></div><div class=\"content-wrapper\" flex=\"\" layout=\"row\"><div\n class=\"content thread-list mail-list-pane\" flex=\"100\" id=\"thread-list\" \nng-include=\"\'app/main/apps/users/views/list/list-table-view.html\'\"></div><div ng-if=\"!vm.isAccreditations\" \nclass=\"content thread-detail mail-read-pane edit-pane-users\" id=\"thread-detail\" layout=\"column\" \nng-include=\"\'app/main/apps/users/views/read/read-view.html\'\" ng-class=\"{selected:vm.selectedContent}\"></div><div \nng-if=\"vm.isAccreditations\" class=\"content thread-detail mail-read-pane edit-pane-users\" id=\"thread-detail\" \nlayout=\"column\" ng-include=\"\'app/main/apps/users/views/read/read-view-accreditations.html\'\" \nng-class=\"{selected:vm.selectedContent}\"></div></div>");
$templateCache.put("app/main/apps/users/views/list/toolbar-activity.html","<div fullwidth class=\"pr-15\" layout=\"row\" layout-align=\"start center\" flex=\"100\"><div class=\"info\" flex \nlayout=\"column\"><div class=\"name\" layout=\"row\"><div layout=\"row\" layout-align=\"start center\" flex=\"100\"><ms-search-bar \ndebounce=\"300\" model-search=\"$root.pagination_searchquery\" on-result-click=\"vm.searchResultClick(item)\" \non-search=\"vm.search(query)\" layout=\"row\" layout-align=\"start center\"></ms-search-bar></div><div layout=\"row\" \nlayout-align=\"end center\" flex=\"100\"><span class=\"page-info font-weight-500\">\n{{ \'USERS.DISPLAYING\' | translate}} {{vm.userAuditTrailEvents.length}} {{ \'USERS.OF\' | translate}} {{total_items}} {{ \'USERS.ITEMS\' | translate}}.\n</span></div></div></div></div>");
$templateCache.put("app/main/apps/users/views/list/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button close-thread\" aria-label=\"Back\" \nng-click=\"vm.closeUsers()\" ng-if=\"vm.currentView==\'nosplit\' && vm.groupsView\" translate \ntranslate-attr-aria-label=\"CONTENT.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button>\n<md-checkbox class=\"no-label\" aria-label=\"{{vm.selectedThreads.length > 1 ? \'Deselect All\' : \'Select All\'}}\" \nng-checked=\"vm.selectedThreads.length > 1\" ng-click=\"vm.toggleSelectThreads()\"></md-checkbox><div \nng-if=\"!vm.isAccreditations\" class=\"divider-vertical\" hide=\"\" show-gt-xs=\"\"></div><md-button aria-label=\"ADD NEW\" \nclass=\"md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme\" hide show-gt-sm \nng-click=\"vm.newThread()\" translate=\"CONTENT.ADD\" type=\"button\">Add new</md-button><md-button aria-label=\"ADD NEW\" \nclass=\"md-fab md-mini md-accent green-500-bg md-raised md-ink-ripple md-default-theme\" hide-gt-sm \nng-click=\"vm.newThread()\" type=\"button\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><div \nclass=\"divider-vertical\" hide=\"\" show-gt-xs=\"\" ng-if=\"!vm.isOpenSidenavGroups\"></div><div layout=\"row\" \nlayout-align=\"start center\" class=\"groups-trigger\"><button aria-label=\"view group\" class=\"md-button md-icon-button\" \nng-click=\"vm.toggleSidenav(\'groups-sidenav\')\" ng-if=\"!vm.isOpenSidenavGroups\" translate \ntranslate-attr-aria-label=\"CONTENT.FILTERS\"><md-icon md-font-icon=\"icon-folder-multiple\"></md-icon><md-tooltip hide \nshow-gt-xs><span translate=\"CONTENT.VIEW_GROUPS\">View Groups</span></md-tooltip></button></div><div \nng-if=\"!vm.isAccreditations || !vm.pleaseSelectGroup\" class=\"divider-vertical\" hide=\"\" show-gt-xs=\"\"></div>\n<ms-search-bar ng-if=\"!vm.isAccreditations || !vm.pleaseSelectGroup\" debounce=\"300\" \nmodel-search=\"$root.pagination_searchquery\" on-result-click=\"vm.searchResultClick(item)\" on-search=\"vm.search(query)\" \nlayout=\"row\" layout-align=\"start center\"></ms-search-bar><md-button ng-if=\"$root.pagination_searchquery==true\" \nng-click=\"vm.resetFilters()\" aria-label=\"view type\" class=\"md-icon-button\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.FILTERS\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-filter-remove-outline\">\n</md-icon><md-tooltip hide show-gt-xs><span>Reset search</span></md-tooltip></md-button><div class=\"divider-vertical\" \nhide=\"\" show-gt-xs=\"\"></div><md-menu-bar class=\"pr-0 pl-0\" hide show-gt-xs><md-menu><md-button \nclass=\"menu-button-custom\" aria-label=\"Actions\" ng-click=\"$mdMenu.open($event)\" layout=\"row\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-cog\" class=\"mr-5\"></md-icon><span \nclass=\"text-uppercase grey-600-fg\">{{\'USERS.ACTIONS\' | translate}}</span></md-button><md-menu-content><md-menu-item>\n<md-menu><md-button aria-label=\"Filters\" ng-click=\"$mdMenu.open($event)\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\"></md-icon><span>{{\'USERS.GROUP_BY\' | translate}}</span></md-button>\n<md-menu-content><md-menu-item ng-if=\"vm.groupBy != undefined\"><md-button ng-click=\"vm.resetGroupby()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon><span translate=\"CONTENT.REMOVE_GROUP_BY\">Remove group by</span></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.setGroupBy(\'firstname\')\">{{\'USERS.FIRSTNAME\' | translate}}\n</md-button></md-menu-item></md-menu-content></md-menu></md-menu-item><md-menu-item><md-menu><md-button \naria-label=\"Filters\" ng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-sort\"></md-icon><span \ntranslate=\"CONTENT.ORDER_BY\">Order by</span></md-button><md-menu-content><md-menu-item \nng-if=\"vm.fieldOrder != undefined\"><md-button ng-click=\"vm.resetSortField()\"><md-icon md-font-icon=\"icon-close\">\n</md-icon><span translate=\"CONTENT.REMOVE_ORDER\">Remove order</span></md-button></md-menu-item><md-menu-item \nng-repeat=\"field in vm.refcolumns\" ng-if=\"field.sortable === 1\"><md-button ng-click=\"vm.setSortField(field.title)\"><div\n layout=\"row\" layout-align=\"space-between center\"><span>{{field.field_name}}</span> <i class=\"icon-check s16\" \nng-if=\"vm.fieldOrder === field.field_name\"></i></div></md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.setSortOrder(\'ASC\')\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start between\"><md-icon \nmd-font-icon=\"icon-sort-ascending\"></md-icon><span translate=\"CONTENT.DIRECTION_A_Z\">Order A-Z</span></div><i \nclass=\"icon-check s16\" ng-if=\"vm.getSettingValue(vm.settingsSection, \'sortDir\', sortDir) === \'ASC\'\"></i></div>\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.setSortOrder(\'DESC\')\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start between\"><md-icon \nmd-font-icon=\"icon-sort-descending\"></md-icon><span translate=\"CONTENT.DIRECTION_Z_A\">Order Z-A</span></div><i \nclass=\"icon-check s16\" ng-if=\"vm.getSettingValue(vm.settingsSection, \'sortDir\', sortDir) === \'DESC\'\"></i></div>\n</md-button></md-menu-item><div hide-gt-md><md-menu-item hide><md-button ng-disabled=\"vm.selectedThreads.length == 0\" \naria-label=\"SUBSCRIPTIONS\"><md-icon md-font-icon=\"icon-telegram\"></md-icon><span \ntranslate=\"USERS.ADD_REMOVE_SUBSCRIPTIONS\">Add/Remove subscriptions</span></md-button></md-menu-item><md-menu-item \nng-if=\"vm.selectedGroup && vm.userInvitationUrlMultiple\"><md-button \nng-click=\"vm.inviteToGroupMultiple($event, vm.selectedGroup)\" ng-disabled=\"vm.selectedThreads.length == 0\" \naria-label=\"Invite to group\"><md-icon md-font-icon=\"icon-email\"></md-icon><span translate=\"USERS.INVITE_TO_GROUP\">\n</span></md-button></md-menu-item><md-menu-item ng-if=\"vm.selectedGroupsAcc && vm.userInvitationUrlMultiple\"><md-button\n ng-click=\"vm.inviteToGroupMultiple($event, vm.selectedGroupsAcc)\" ng-disabled=\"vm.selectedThreads.length == 0\" \naria-label=\"Invite to group\"><md-icon md-font-icon=\"icon-email\"></md-icon><span translate=\"USERS.INVITE_TO_GROUP\">\n</span></md-button></md-menu-item><md-menu-item ng-if=\"!vm.selectedGroup\"><md-button \nng-click=\"vm.addUsersToGroupsDialog($event)\" ng-disabled=\"vm.selectedThreads.length == 0\" aria-label=\"Add to group\">\n<md-icon md-font-icon=\"icon-folder-account\"></md-icon><span translate=\"USERS.ADD_TO_GROUPS\"></span></md-button>\n</md-menu-item><md-menu-item ng-if=\"vm.selectedGroup\"><md-button ng-click=\"vm.removeUsersFromGroupDialog($event)\" \nng-disabled=\"vm.selectedThreads.length == 0 || vm.includeSubgroups || (vm.isQiuRestricted && vm.selectedGroup.is_qiu_restricted_root)\" \naria-label=\"Remove from group\"><md-icon md-font-icon=\"icon-folder-remove\"></md-icon><span \ntranslate=\"USERS.REMOVE_FROM_GROUP\"></span></md-button></md-menu-item></div><div hide-gt-md><md-menu-item><md-button \nng-click=\"vm.deleteThread()\" ng-disabled=\"vm.selectedThreads.length == 0\" aria-label=\"DELETE\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><span translate=\"CONTENT.DELETE\">DELETE</span></md-button></md-menu-item></div>\n<md-menu-item><md-button ng-click=\"vm.openImportDialog($event)\" aria-label=\"IMPORT\"><md-icon \nmd-font-icon=\"icon-cloud-upload\"></md-icon><span translate=\"USERS.IMPORT\">IMPORT</span></md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.openExportDialog($event)\" aria-label=\"IMPEXPORTORT\"><md-icon \nmd-font-icon=\"icon-cloud-download\"></md-icon><span translate=\"USERS.EXPORT\">EXPORT</span></md-button></md-menu-item>\n<md-menu-item ng-if=\"vm.selectedGroup\"><md-button ng-click=\"vm.openCopyMoveDialog($event, \'COPY\')\" aria-label=\"COPY\">\n<md-icon md-font-icon=\"icon-account-multiple-plus\"></md-icon><span translate=\"USERS.COPY\">COPY</span></md-button>\n</md-menu-item><md-menu-item \nng-if=\"vm.selectedGroup && !(vm.isQiuRestricted && vm.selectedGroup.is_qiu_restricted_root)\"><md-button \nng-click=\"vm.openCopyMoveDialog($event, \'MOVE\')\" aria-label=\"MOVE\"><md-icon md-font-icon=\"icon-account-switch\">\n</md-icon><span translate=\"USERS.MOVE\">MOVE</span></md-button></md-menu-item><md-menu-item \nng-if=\"vm.userCustomActions.length > 0 && (vm.selectedGroup || vm.selectedGroupsAcc)\"><md-menu><md-button \naria-label=\"Filters\" ng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-more\"></md-icon><span>Extra</span>\n</md-button><md-menu-content><md-menu-item ng-repeat=\"axn in vm.userCustomActions\"><md-button \nng-click=\"vm.customActionEvent(axn, $event)\" aria-label=\"{{axn.title}}\"><md-icon md-font-icon=\"{{axn.icon}}\"></md-icon>\n<span ng-bind-html=\"axn.title\"></span></md-button></md-menu-item></md-menu-content></md-menu></md-menu-item>\n<md-menu-item ng-if=\"vm.selectedGroup || vm.selectedThreads.length > 0\"><md-button ng-click=\"vm.changeGroupPriority()\" \naria-label=\"Users priority\"><md-icon md-font-icon=\"icon-account-switch\"></md-icon><span translate=\"USERS.PRIORITY\">\nCHANGE PRIORITY</span></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><div \nclass=\"divider-vertical\" show-gt-xs></div><div aria-hidden=\"false\" class=\"action-buttons\" show-gt-md layout=\"row\" \nlayout-align=\"start center\" ng-show=\"vm.selectedThreads.length > 0\"><div aria-hidden=\"false\" class=\"action-buttons\" \nhide show-gt-md layout=\"row\" layout-align=\"start center\" ng-show=\"vm.selectedThreads.length > 0\"><md-button hide \naria-label=\"Subscriptions\" class=\"md-icon-button\" translate=\"\" \ntranslate-attr-aria-label=\"USERS.ADD_REMOVE_SUBSCRIPTIONS\"><md-icon md-font-icon=\"icon-telegram\"></md-icon><md-tooltip \nshow-gt-xs><span translate=\"USERS.ADD_REMOVE_SUBSCRIPTIONS\">Add/Remove subscriptions</span></md-tooltip></md-button>\n<md-button ng-if=\"vm.selectedGroup && vm.selectedThreads.length > 0\" \nng-click=\"vm.inviteToGroupMultiple($event, vm.selectedGroup)\" aria-label=\"Invite\" class=\"md-icon-button\" translate=\"\" \ntranslate-attr-aria-label=\"USERS.INVITE_TO_GROUP\"><md-icon md-font-icon=\"icon-email\"></md-icon><md-tooltip hide \nshow-gt-xs><span translate=\"USERS.INVITE_TO_GROUP\"></span></md-tooltip></md-button><md-button \nng-if=\"vm.selectedGroupsAcc && vm.selectedThreads.length > 0\" \nng-click=\"vm.inviteToGroupMultiple($event, vm.selectedGroupsAcc)\" aria-label=\"Invite\" class=\"md-icon-button\" \ntranslate=\"\" translate-attr-aria-label=\"USERS.INVITE_TO_GROUP\"><md-icon md-font-icon=\"icon-email\"></md-icon><md-tooltip\n hide show-gt-xs><span translate=\"USERS.INVITE_TO_GROUP\"></span></md-tooltip></md-button><md-button \nng-click=\"vm.addUsersToGroupsDialog($event)\" aria-label=\"Add\" class=\"md-icon-button\" translate=\"\" \ntranslate-attr-aria-label=\"USERS.ADD_TO_GROUPS\"><md-icon md-font-icon=\"icon-folder-account\"></md-icon><md-tooltip hide \nshow-gt-xs><span translate=\"USERS.ADD_TO_GROUPS\"></span></md-tooltip></md-button><md-button ng-if=\"vm.selectedGroup\" \nng-click=\"vm.removeUsersFromGroupDialog($event)\" \nng-disabled=\"vm.selectedThreads.length == 0 || vm.includeSubgroups || (vm.isQiuRestricted && vm.selectedGroup.is_qiu_restricted_root)\" \naria-label=\"Remove\" class=\"md-icon-button\" translate=\"\" translate-attr-aria-label=\"USERS.REMOVE_FROM_GROUP\"><md-icon \nmd-font-icon=\"icon-folder-remove\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"USERS.REMOVE_FROM_GROUP\">\n</span></md-tooltip></md-button><md-button ng-click=\"vm.deleteThread()\" aria-label=\"Delete\" class=\"md-icon-button\" \ntranslate=\"\" translate-attr-aria-label=\"CONTENT.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip hide \nshow-gt-xs><span translate=\"CONTENT.DELETE\">Delete</span></md-tooltip></md-button><div class=\"divider-vertical\"></div>\n</div></div><div ng-if=\"!vm.groupsView\" layout=\"row\" layout-align=\"start center\" \ntranslate-attr-aria-label=\"CONTENT.REFRESH\"><md-menu-bar class=\"pr-0 pl-0\" hide-gt-xs><md-menu><md-button \nclass=\"md-icon-button\" aria-label=\"Actions\" ng-click=\"$mdMenu.open($event)\" layout=\"row\" layout-align=\"center center\">\n<md-icon md-font-icon=\"icon-cog\" class=\"mr-5\"></md-icon></md-button><md-menu-content><md-menu-item><md-menu><md-button \naria-label=\"Filters\" ng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-format-list-bulleted\"></md-icon><span>\nGroup by</span></md-button><md-menu-content><md-menu-item ng-if=\"vm.groupBy != undefined\"><md-button \nng-click=\"vm.resetGroupby()\"><md-icon md-font-icon=\"icon-close\"></md-icon><span translate=\"CONTENT.REMOVE_GROUP_BY\">\nRemove group by</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.setGroupBy(\'firstname\')\">\nFirstname</md-button></md-menu-item></md-menu-content></md-menu></md-menu-item><md-menu-item><md-menu><md-button \naria-label=\"Filters\" ng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-sort\"></md-icon><span \ntranslate=\"CONTENT.ORDER_BY\">Order by</span></md-button><md-menu-content><md-menu-item \nng-if=\"vm.fieldOrder != undefined\"><md-button ng-click=\"vm.resetSortField()\"><md-icon md-font-icon=\"icon-close\">\n</md-icon><span translate=\"CONTENT.REMOVE_ORDER\">Remove order</span></md-button></md-menu-item><md-menu-item \nng-repeat=\"field in vm.refcolumns\" ng-if=\"field.sortable === 1\"><md-button ng-click=\"vm.setSortField(field.title)\"><div\n layout=\"row\" layout-align=\"space-between center\"><span>{{field.field_name}}</span> <i class=\"icon-check s16\" \nng-if=\"vm.fieldOrder === field.field_name\"></i></div></md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.setSortOrder(\'ASC\')\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start between\"><md-icon \nmd-font-icon=\"icon-sort-ascending\"></md-icon><span translate=\"CONTENT.DIRECTION_A_Z\">Order A-Z</span></div><i \nclass=\"icon-check s16\" ng-if=\"sortDir === \'ASC\'\"></i></div></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.setSortOrder(\'DESC\')\"><div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start between\"><md-icon md-font-icon=\"icon-sort-descending\"></md-icon><span \ntranslate=\"CONTENT.DIRECTION_Z_A\">Order Z-Z</span></div><i class=\"icon-check s16\" ng-if=\"sortDir === \'DESC\'\"></i></div>\n</md-button></md-menu-item><div hide-gt-md><md-menu-item hide><md-button ng-disabled=\"vm.selectedThreads.length == 0\" \naria-label=\"SUBSCRIPTIONS\"><md-icon md-font-icon=\"icon-telegram\"></md-icon><span \ntranslate=\"USERS.ADD_REMOVE_SUBSCRIPTIONS\">Add/Remove subscriptions</span></md-button></md-menu-item><md-menu-item \nng-if=\"!vm.selectedGroup\"><md-button ng-click=\"vm.addUsersToGroupsDialog($event)\" \nng-disabled=\"vm.selectedThreads.length == 0\" aria-label=\"Add to groups\"><md-icon md-font-icon=\"icon-folder-account\">\n</md-icon><span translate=\"USERS.ADD_TO_GROUPS\"></span></md-button></md-menu-item><md-menu-item \nng-if=\"vm.selectedGroup\"><md-button ng-click=\"vm.removeUsersFromGroupDialog($event)\" class=\"md-icon-button\" \nng-disabled=\"vm.selectedThreads.length == 0 || vm.includeSubgroups\" aria-label=\"Remove from group\"><md-icon \nmd-font-icon=\"icon-folder-remove\"></md-icon><span translate=\"USERS.REMOVE_FROM_GROUP\"></span></md-button>\n</md-menu-item></div><div hide-gt-md><md-menu-item><md-button ng-click=\"vm.deleteThread()\" \nng-disabled=\"vm.selectedThreads.length == 0\" aria-label=\"DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span \ntranslate=\"CONTENT.DELETE\">DELETE</span></md-button></md-menu-item></div><md-menu-item><md-button \nng-click=\"vm.openImportDialog($event)\" aria-label=\"IMPORT\"><md-icon md-font-icon=\"icon-cloud-upload\"></md-icon><span \ntranslate=\"USERS.IMPORT\">IMPORT</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.openExportDialog($event)\" aria-label=\"EXPORT\"><md-icon md-font-icon=\"icon-cloud-download\"></md-icon><span \ntranslate=\"USERS.EXPORT\">EXPORT</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"pagination_reload()\" aria-label=\"REFRESH\"><md-icon md-font-icon=\"icon-refresh\"></md-icon><span \ntranslate=\"USERS.REFRESH\">REFRESH</span></md-button></md-menu-item><md-menu-item ng-if=\"vm.selectedGroup\"><md-button \nng-click=\"vm.openCopyMoveDialog($event, \'COPY\')\" aria-label=\"COPY\"><md-icon md-font-icon=\"icon-account-multiple-plus\">\n</md-icon><span translate=\"USERS.COPY\">COPY</span></md-button></md-menu-item><md-menu-item \nng-if=\"vm.selectedGroup && !(vm.isQiuRestricted && vm.selectedGroup.is_qiu_restricted_root)\"><md-button \nng-click=\"vm.openCopyMoveDialog($event, \'MOVE\')\" aria-label=\"MOVE\"><md-icon md-font-icon=\"icon-account-switch\">\n</md-icon><span translate=\"USERS.MOVE\">MOVE</span></md-button></md-menu-item><md-menu-item \nng-if=\"vm.userCustomActions.length > 0 && (vm.selectedGroup || vm.selectedGroupsAcc)\"><md-menu><md-button \naria-label=\"Filters\" ng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-more\"></md-icon><span>Extra</span>\n</md-button><md-menu-content><md-menu-item ng-repeat=\"axn in vm.userCustomActions\"><md-button \nng-click=\"vm.customActionEvent(axn, $event)\" aria-label=\"{{axn.title}}\"><md-icon md-font-icon=\"{{axn.icon}}\"></md-icon>\n<span ng-bind-html=\"axn.title\"></span></md-button></md-menu-item></md-menu-content></md-menu></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar></div></div><div layout=\"row\" layout-align=\"start center\"><div \nng-if=\"!vm.groupsView\" layout=\"row\" layout-align=\"start center\" translate-attr-aria-label=\"CONTENT.REFRESH\"><span \nng-if=\"!isLoading && vm.currentView !== \'table\'\" class=\"page-info font-weight-500\">\n{{vm.threads.length}} {{ \'USERS.OF\' | translate}} {{pagination_totalItems}} </span><span \nng-if=\"!isLoading && vm.currentView === \'table\'\" class=\"page-info font-weight-500\">{{pagination_totalItems}}</span>\n<md-button ng-if=\"vm.currentView === \'table\'\" aria-label=\"Previous\" class=\"md-icon-button arrow\" hide=\"\" \nng-click=\"pagination_prevPage()\" ng-disabled=\"pagination_firstPage()\" show-gt-xs=\"\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip hide \nshow-gt-xs><span translate=\"CONTENT.PREVIOUS\">Previous</span></md-tooltip></md-button><span \nng-if=\"vm.currentView === \'table\'\" class=\"page-info\" hide=\"\" show-gt-xs=\"\">\n{{pagination_page}} / {{pagination_total_pages}}</span><md-button ng-if=\"vm.currentView === \'table\'\" aria-label=\"Next\" \nclass=\"md-icon-button arrow\" hide=\"\" ng-click=\"pagination_nextPage()\" ng-disabled=\"pagination_morePages()\" \nshow-gt-xs=\"\" translate=\"\" translate-attr-aria-label=\"CONTENT.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\">\n</md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.NEXT\">Next</span></md-tooltip></md-button><div \nclass=\"divider-vertical\" hide show-gt-sm></div><md-button aria-label=\"Refresh\" class=\"md-icon-button\" hide=\"\" \nshow-gt-xs=\"\" ng-click=\"pagination_reload()\" translate=\"\" translate-attr-aria-label=\"USERS.REFRESH\"><md-icon \nmd-font-icon=\"icon-refresh\" show-gt-xs></md-icon></md-button><div class=\"divider-vertical\" hide show-gt-sm></div>\n<md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" aria-label=\"View\" hide show-gt-sm><md-icon \nmd-font-icon=\"icon-view-dashboard\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.VIEW\">View</span>\n</md-tooltip></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.changeView(\'split\')\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-view-list\" class=\"mr-8\"></md-icon><span translate=\"CONTENT.SIMPLE_LIST\">Split</span></div><md-icon \nng-if=\"vm.currentView === \'split\'\" md-font-icon=\"icon-check\" class=\"md-accent\"></md-icon></div></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.changeView(\'table\')\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-view-module\" class=\"mr-8\"></md-icon><span translate=\"CONTENT.TABLE_VIEW\">Table</span></div><md-icon \nng-if=\"vm.currentView === \'table\'\" md-font-icon=\"icon-check\" class=\"md-accent\"></md-icon></div></md-button>\n</md-menu-item><md-menu-item ng-if=\"vm.usersGridEnabled\"><md-button ng-click=\"vm.changeView(\'spreadsheet\')\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-table-edit\" class=\"mr-8\"></md-icon><span translate=\"USERS.SPREADSHEET_VIEW\">Spreadsheet</span></div>\n<md-icon ng-if=\"vm.currentView === \'spreadsheet\'\" md-font-icon=\"icon-check\" class=\"md-accent\"></md-icon></div>\n</md-button></md-menu-item></md-menu-content></md-menu></div></div>");
$templateCache.put("app/main/dialogs/media/views/templates/photo.html","<div class=\"ms-card-content-wrapper ng-scope\"><div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" \nlayout-align=\"start center\"><div ng-if=\"photo.avatar\"><img class=\"avatar mr-16\" ng-src=\"{{photo.avatar.src}}\" \nalt=\"{{photo.avatar.alt}}\"></div><div class=\"info\"><div class=\"title\">{{photo.title}}</div><div \nclass=\"subtitle secondary-text\" ng-if=\"photo.subtitle\">{{photo.subtitle}}</div></div></div><div \nclass=\"text ph-16 pb-16\" ng-if=\"photo.text\">{{photo.text}}</div><div class=\"media\" flex><img \nng-src=\"{{photo.crop_status[0].urlformed}}\" class=\"image\"></div><div class=\"buttons m-8\"><md-button \nclass=\"md-icon-button mr-16\" aria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\">\n</md-icon></md-button><md-checkbox ng-checked=\"vm.alreadySelectedbyZone(vm.selectedContacts, photo)\" \nng-click=\"vm.toggleSelectContact(photo, $event)\" \naria-label=\"{{vm.alreadySelectedbyZone(vm.selectedContacts, photo) ? \'Deselect\' : \'Select\'}}\"></md-checkbox></div>\n</div></div>");
$templateCache.put("app/main/dialogs/media/views/templates/toolbar-search-gallery.html","<md-toolbar><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><ms-search-bar-none flex \nclass=\"expanded ms-search-bar\" debounce=\"300\" layout=\"row\" layout-align=\"start center\"><div flex layout=\"row\" \nlayout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-icon id=\"ms-search-bar-expander\" \nmd-font-icon=\"icon-magnify\" class=\"md-icon-button md-button search\"><md-tooltip><span translate=\"TOOLBAR.FILTER\">\n</span></md-tooltip></md-icon></label><input id=\"ms-search-bar-input\" type=\"text\" ng-model=\"vm.modelFilter\" \nplaceholder=\"Search\" md-autofocus translate translate-attr-placeholder=\"TOOLBAR.FILTER\" flex \nng-enter=\"vm.pagination_search(vm.modelSearch)\"></div></ms-search-bar-none></div></md-toolbar>");
$templateCache.put("app/main/dialogs/media/views/templates/toolbar-search.html","<md-toolbar ng-if=\"vm.showSearchAndPaginator\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><div><button aria-label=\"view group\" class=\"md-button md-icon-button search\" \nng-click=\"vm.toggleMediaDialogSidenav(\'media-dialog-galleries-sidenav\')\" translate \ntranslate-attr-aria-label=\"CONTENT.FILTERS\"><md-icon \nng-class=\"{\'icon-folder-multiple-image\':vm.media_type == 1, \'qiu-icon-video-gallery\':vm.media_type == 2,\'qiu-icon-audio-gallery\':vm.media_type == 3, \'qiu-icon-file-gallery\':vm.media_type == 4, \'icon-folder-multiple\':vm.media_type != 1 && vm.media_type != 2 && vm.media_type != 3 && vm.media_type != 4 }\">\n</md-icon><md-tooltip hide show-gt-xs><span translate=\"GALLERY.VIEW_GALLERIES\">View Groups</span></md-tooltip></button>\n</div><ms-search-bar-none flex class=\"expanded ms-search-bar\" debounce=\"300\" model-search=\"vm.searchStringFilter\" \non-search=\"vm.searchMedia()\" layout=\"row\" layout-align=\"start center\"><div flex layout=\"row\" \nlayout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-icon id=\"ms-search-bar-expander\" \nmd-font-icon=\"icon-magnify\" class=\"md-icon-button md-button search\"><md-tooltip><span translate=\"TOOLBAR.SEARCH\">\n</span></md-tooltip></md-icon></label><md-button ng-click=\"vm.modelSearch = \'\';vm.pagination_search(vm.modelSearch)\" \naria-label=\"view type\" class=\"md-icon-button\" translate=\"\" translate-attr-aria-label=\"CONTENT.FILTERS\" \nclass=\"md-icon-button\" id=\"ms-filters-cleaner\" ng-if=\"vm.modelSearch != \'\'\"><md-icon md-font-icon=\"icon-close-circle\">\n</md-icon><md-tooltip><span translate=\"TOOLBAR.RESET_SEARCH\"></span></md-tooltip></md-button><input \nid=\"ms-search-bar-input\" type=\"text\" ng-model=\"vm.modelSearch\" placeholder=\"Search\" md-autofocus translate \ntranslate-attr-placeholder=\"TOOLBAR.SEARCH\" flex ng-enter=\"vm.pagination_search(vm.modelSearch)\"><md-icon \nid=\"ms-search-bar-collapser\" md-font-icon=\"icon-close-circle\" class=\"icon s24\"></md-icon><md-button hide show-gt-xs \nid=\"ms-search-bar-button\" class=\"md-accent md-raised search\" ng-click=\"vm.pagination_search(vm.modelSearch)\" \naria-label=\"description\" md-no-ink=\"true\" md-ripple-size=\"auto\" translate=\"TOOLBAR.SEARCH\"></md-button><md-button hide \nshow-xs id=\"ms-search-bar-button\" class=\"md-accent md-raised md-icon-button search\" \nng-click=\"vm.pagination_search(vm.modelSearch)\" ng-disabled=\"!vm.modelSearch\" aria-label=\"description\" \nmd-no-ink=\"true\" md-ripple-size=\"auto\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>\n</ms-search-bar-none></div></md-toolbar>");
$templateCache.put("app/main/apps/accounts/dialogs/tabs-select/views/edit-media-view.html","<img ng-src=\"{{vm.image.imageUrl}}\" src=\"{{vm.image.imageUrl}}\" alt=\"\" focus-point x=\"{{vm.image.imageCenterRatioX}}\" \ny=\"{{vm.image.imageCenterRatioY}}\" data-method=\"vm.ctrlFn\">");
$templateCache.put("app/main/apps/ai/views/grid/tabs/all-media.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/ai/views/toolbar.html\'\"></div><div flex layout=\"column\" layout-align=\"center center\" \nng-if=\"vm.isLoading\" class=\"loading-container\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</div><div class=\"faces-upload-container\"><div ng-hide=\"vm.isLoading\" ng-if=\"!vm.isLoading && vm.threads.length === 0\" \nlayout=\"column\" layout-align=\"center center\" class=\"no-threads full-height\"><h1 translate=\"AI.NO_ITEMS\"></h1></div><div\n ng-if=\"vm.threads.length > 0\" style=\"max-height: calc(100vh - 180px)\" ms-scroll=\"\"><div class=\"grid-view\" md-cols=\"5\" \nmd-row-height=\"250\" md-gutter=\"12px\" md-gutter-gt-sm=\"8px\" ng-style=\"{\'opacity\' : vm.isLoading ? 0.2 : 1}\"><div \nng-repeat=\"mediaItem in vm.threads\" class=\"grid-element\" \nng-click=\"vm.openImageDialog($event, mediaItem.tags, mediaItem.cropstatus, mediaItem, true)\"><md-card \nmd-theme=\"default\" md-theme-watch style=\"background: white\"><div class=\"media\"><media attachment=\"mediaItem\" class=\"\">\n</media></div><div class=\"ml-15 mr-15\"><md-card-title><md-card-title-text flex layout=\"column\" \nstyle=\"min-height: 20px\"><span layout=\"row\" layout-align=\"start center\" class=\"mt-10\" style=\"\">#{{mediaItem.id_media}}\n</span><md-chips ng-init=\"filteredTags = vm.filterRunnerOrNumberTag(mediaItem.tags)\" ng-model=\"filteredTags\" \nreadonly=\"true\" md-removable=\"false\"><md-chip-template><span>{{$chip.tag_name}} #{{$chip.id_tag}}</span>\n</md-chip-template></md-chips></md-card-title-text></md-card-title></div><md-card-actions layout=\"column\" \nlayout-align=\"end center\"></md-card-actions></md-card></div></div></div></div>");
$templateCache.put("app/main/apps/ai/views/grid/tabs/recognized-media.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/ai/views/toolbar.html\'\"></div><div flex layout=\"column\" layout-align=\"center center\" \nng-if=\"vm.isLoading\" class=\"loading-container\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</div><div class=\"faces-upload-container\"><div ng-hide=\"vm.isLoading\" ng-if=\"!vm.isLoading && vm.threads.length === 0\" \nlayout=\"column\" layout-align=\"center center\" class=\"no-threads full-height\"><h1 translate=\"AI.NO_ITEMS\"></h1></div><div\n ng-if=\"vm.threads.length > 0\" style=\"max-height: calc(100vh - 180px)\" ms-scroll=\"\"><div class=\"grid-view\" md-cols=\"5\" \nmd-row-height=\"250\" md-gutter=\"12px\" md-gutter-gt-sm=\"8px\" ng-style=\"{\'opacity\' : vm.isLoading ? 0.2 : 1}\"><div \nng-repeat=\"mediaItem in vm.threads\" class=\"grid-element\" \nng-click=\"vm.openImageDialog($event, mediaItem.tags, mediaItem.cropstatus, mediaItem, true)\"><md-card \nmd-theme=\"default\" md-theme-watch style=\"background: white\"><div class=\"media\"><media attachment=\"mediaItem\" class=\"\">\n</media></div><div class=\"ml-15 mr-15\"><md-card-title><md-card-title-text flex layout=\"column\" \nstyle=\"min-height: 20px\"><span layout=\"row\" layout-align=\"start center\" class=\"mt-10\" style=\"\">#{{mediaItem.id_media}}\n</span><md-chips ng-init=\"filteredTags = vm.filterRunnerOrNumberTag(mediaItem.tags)\" ng-model=\"filteredTags\" \nreadonly=\"true\" md-removable=\"false\"><md-chip-template><span>{{$chip.tag_name}} #{{$chip.id_tag}}</span>\n</md-chip-template></md-chips></md-card-title-text></md-card-title></div><md-card-actions layout=\"column\" \nlayout-align=\"end center\"></md-card-actions></md-card></div></div></div></div>");
$templateCache.put("app/main/apps/ai/views/grid/tabs/recognized-profiles.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/ai/views/toolbar.html\'\"></div><div class=\"content-wrapper\" flex=\"\" layout=\"row\" \nng-if=\"vm.currentView == \'split\'\"><div class=\"content thread-list mail-list-pane\" \nflex=\"{{vm.selectedFace ? \'25\' : \'100\'}}\" id=\"thread-list\" ng-include=\"\'app/main/apps/ai/views/list/list-view.html\'\">\n</div><div class=\"content thread-detail mail-read-pane\" flex=\"{{vm.selectedFace ? \'75\' : \'0\'}}\" id=\"thread-detail\" \nlayout=\"column\" ng-include=\"\'app/main/apps/ai/views/read/read-view.html\'\"></div></div><div class=\"content-wrapper\" \nflex=\"\" layout=\"row\" ng-if=\"vm.currentView == \'nosplit\'\"><div class=\"content thread-detail mail-read-pane\" flex=\"\" \nid=\"thread-detail\" ms-scroll=\"vm.msScrollOptions\" ng-if=\"vm.selectedFace || vm.currentThread_Edit\" \nng-include=\"\'app/main/apps/ai/views/read/read-view.html\'\"></div><div class=\"content thread-list mail-list-pane\" flex \nid=\"thread-list\" ng-if=\"!vm.selectedFace && !vm.currentThread_Edit\" \nng-include=\"\'app/main/apps/ai/views/list/list-view.html\'\"></div></div>");
$templateCache.put("app/main/apps/ai/views/grid/tabs/unrecognized-media.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/ai/views/toolbar.html\'\"></div><div flex layout=\"column\" layout-align=\"center center\" \nng-if=\"vm.isLoading\" class=\"loading-container\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</div><div class=\"faces-upload-container\"><div ng-hide=\"vm.isLoading\" ng-if=\"!vm.isLoading && vm.threads.length === 0\" \nlayout=\"column\" layout-align=\"center center\" class=\"no-threads full-height\"><h1 translate=\"AI.NO_ITEMS\"></h1></div><div\n ng-if=\"vm.threads.length > 0\" style=\"max-height: calc(100vh - 180px)\" ms-scroll=\"vm.msScrollOptions\"><div \nng-if=\"vm.threads.length > 0\" class=\"grid-view\" md-cols=\"5\" md-row-height=\"250\" md-gutter=\"12px\" md-gutter-gt-sm=\"8px\" \nng-style=\"{\'opacity\' : vm.isLoading ? 0.2 : 1}\"><div ng-repeat=\"mediaItem in vm.threads\" class=\"grid-element\"><md-card \nmd-theme=\"default\" md-theme-watch style=\"background: white\"><div class=\"media\" \nng-style=\"{\'opacity\': mediaItem.confirmed ? 0.5 : 1}\" \nng-click=\"vm.openImageDialog($event, false, mediaItem.cropstatus, mediaItem, true)\"><media attachment=\"mediaItem\" \nclass=\"\"></media></div><div class=\"ml-15 mr-15\" ng-style=\"{\'opacity\': mediaItem.confirmed ? 0.5 : 1}\"><md-card-title>\n<md-card-title-text flex layout=\"column\" style=\"min-height: 128px\"><span layout=\"row\" layout-align=\"end center\" \nclass=\"mt-10\" style=\"color: lightgray\">#{{mediaItem.id_media}}</span><md-chips \nclass=\"label-chips close-chip unrecognized-chips\" ng-model=\"mediaItem.filteredTags\" md-autocomplete-snap \nmd-require-match=\"true\"><md-autocomplete md-min-length=\"1\" md-selected-item=\"selectedTag\" \nmd-selected-item-change=\" vm.selectedItemChange(selectedTag, mediaItem); searchTagText = null;\" \nmd-search-text=\"searchTagText\" md-items=\"tag in vm.tagsSearch(searchTagText, mediaItem)\" md-item-text=\"tag.tag_name\" \nmd-no-cache=\"true\" placeholder=\"{{vm.translate(\'GLOBAL.SEARCH_FOR_TAG\')}}\" ng-model-options=\"{debounce: 500}\" \nmd-dropdown-items=\"10\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\" \nclass=\"tag-not-found-bg border-bottom\"><span ng-if=\"!tag.tag_name\">{{vm.searchRunnerTagText}}</span> <span \nmd-highlight-text=\"vm.searchRunnerTagText\" ng-if=\"tag.tag_name\">{{tag.tag_name}}</span></div></md-autocomplete>\n<md-chip-template><div class=\"md-chip-content\"><span ng-if=\"$chip.color\" class=\"color\" \nng-style=\"{\'background-color\':$chip.color}\"></span> <span>{{$chip.tag_name}} #{{$chip.id_tag}}</span></div>\n</md-chip-template><button md-chip-remove class=\"md-primary\" layout=\"row\" layout-align=\"center center\" \nng-click=\"vm.removeTag(mediaItem, $chip)\"><md-icon md-font-icon=\"icon-close\"></md-icon></button></md-chips><div hide \nlayout=\"row\" flex=\"100\" layout-align=\"space-between center\" class=\"\"><div flex></div><div flex layout=\"row\" \nlayout-align=\"center center\"><span class=\"md-headline\" ng-if=\"mediaItem.numberTag\">{{mediaItem.numberTag.tag_name}}\n</span></div><div flex layout=\"row\" layout-align=\"end center\"><button ng-if=\"mediaItem.numberTag\" class=\"md-primary\" \nng-click=\"mediaItem.numberTag = null; mediaItem.runnerTag = null\"><md-icon md-font-icon=\"icon-close\" class=\"s18\">\n</md-icon></button></div><md-autocomplete flex=\"100\" ng-if=\"!mediaItem.numberTag\" md-min-length=\"1\" \nmd-selected-item=\"mediaItem.numberTag\" md-selected-item-change=\"searchTagText = null\" md-search-text=\"searchTagText\" \nmd-items=\"tag in vm.labelQuerySearch(searchTagText, [vm.idTagTypeNumber])\" md-item-text=\"tag.tag_name\" \nmd-no-cache=\"true\" md-floating-label=\"{{vm.translate(\'AI.SEARCH_NUMBER\')}}\" md-dropdown-items=\"10\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"100\" class=\"tag-not-found-bg border-bottom\"><span ng-if=\"!tag.tag_name\">\n{{vm.searchTagText}}</span> <span md-highlight-text=\"vm.searchTagText\" ng-if=\"tag.tag_name\">{{tag.tag_name}}</span>\n</div></md-autocomplete></div><div hide layout=\"row\" flex=\"100\" layout-align=\"space-between center\" class=\"\"><div \nng-if=\"mediaItem.runnerTag\" flex=\"80\" layout=\"row\" layout-align=\"center center\"><span>{{mediaItem.runnerTag.tag_name}}\n</span></div><div ng-if=\"mediaItem.runnerTag\" flex=\"20\" layout=\"row\" layout-align=\"end center\"><button \nclass=\"md-primary\" ng-click=\"mediaItem.runnerTag = null\"><md-icon md-font-icon=\"icon-close\" class=\"s14\"></md-icon>\n</button></div><md-autocomplete flex=\"100\" ng-if=\"!mediaItem.runnerTag\" md-min-length=\"2\" \nmd-selected-item=\"mediaItem.runnerTag\" \nmd-selected-item-change=\"searchTagText = null; mediaItem.numberTag = vm.getTagByIdAndType(mediaItem.runnerTag.id_parent, vm.idTagTypeNumber);\" \nmd-search-text=\"searchTagText\" md-items=\"tag in vm.labelQuerySearch(searchTagText, [vm.idTagTypeRunner])\" \nmd-item-text=\"tag.tag_name\" md-no-cache=\"true\" md-floating-label=\"{{vm.translate(\'AI.SEARCH_RUNNER\')}}\" \nmd-dropdown-items=\"10\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\" \nclass=\"tag-not-found-bg border-bottom\"><span ng-if=\"!tag.tag_name\">{{vm.searchTagText}}</span> <span \nmd-highlight-text=\"vm.searchTagText\" ng-if=\"tag.tag_name\">{{tag.tag_name}}</span></div></md-autocomplete></div>\n</md-card-title-text></md-card-title></div><md-card-actions layout=\"column\" layout-align=\"end center\"><md-button \nng-if=\"!mediaItem.confirmed\" type=\"button\" class=\"md-raised md-accent white-fg\" translate=\"AI.CORRECT\" \nng-click=\"vm.confirmMedia(mediaItem)\" ng-disabled=\"!mediaItem.filteredTags || mediaItem.filteredTags.length == 0\">\n</md-button><md-icon ng-if=\"mediaItem.confirmed\" md-font-icon=\"icon-checkbox-marked-circle\" class=\"green-500-fg s48\">\n</md-icon></md-card-actions></md-card></div></div></div></div>");
$templateCache.put("app/main/apps/ai/views/grid/tabs/unrecognized-profiles.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/ai/views/toolbar.html\'\"></div><div flex layout=\"column\" layout-align=\"center center\" \nng-if=\"vm.isLoading\" class=\"loading-container\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</div><div class=\"faces-upload-container\"><div ng-hide=\"vm.isLoading\" ng-if=\"!vm.isLoading && vm.threads.length === 0\" \nlayout=\"column\" layout-align=\"center center\" class=\"no-threads full-height\"><h1 translate=\"AI.NO_ITEMS\"></h1></div><div\n ng-if=\"vm.threads.length > 0\" style=\"max-height: calc(100vh - 180px)\" ms-scroll=\"vm.msScrollOptions\"><div \nng-if=\"vm.threads.length > 0\" class=\"grid-view\" md-cols=\"5\" md-row-height=\"250\" md-gutter=\"12px\" md-gutter-gt-sm=\"8px\" \nng-style=\"{\'opacity\' : vm.isLoading ? 0.2 : 1}\"><div ng-repeat=\"profile in vm.threads\" class=\"grid-element\"><md-card \nmd-theme=\"default\" md-theme-watch style=\"background: white\"><div class=\"media\" \nng-style=\"{\'opacity\': profile.confirmed ? 0.5 : 1}\" \nng-click=\"vm.openImageDialog($event, false, profile.cropstatus, profile, true)\"><media attachment=\"profile\" class=\"\">\n</media></div><div class=\"ml-15 mr-15\" ng-style=\"{\'opacity\': profile.confirmed ? 0.5 : 1}\"><md-card-title>\n<md-card-title-text flex layout=\"column\" style=\"min-height: 128px\"><span layout=\"row\" layout-align=\"end center\" \nclass=\"mt-10\" style=\"color: lightgray\">#{{profile.id_media}}</span><div layout=\"row\" flex=\"100\" \nlayout-align=\"space-between center\" class=\"\"><div flex></div><div flex layout=\"row\" layout-align=\"center center\"><span \nclass=\"md-headline\" ng-if=\"profile.numberTag\">{{profile.numberTag.tag_name}}</span></div><div flex layout=\"row\" \nlayout-align=\"end center\"><button ng-if=\"profile.numberTag\" class=\"md-primary\" \nng-click=\"profile.numberTag = null; profile.runnerTag = null;\"><md-icon md-font-icon=\"icon-close\" class=\"s18\">\n</md-icon></button></div><md-autocomplete flex=\"100\" ng-if=\"!profile.numberTag\" md-min-length=\"1\" \nmd-selected-item=\"profile.numberTag\" md-selected-item-change=\"vm.setRunnerTagsOptions(profile); searchTagText = null;\" \nmd-search-text=\"searchTagText\" md-items=\"tag in vm.labelQuerySearch(searchTagText, [vm.idTagTypeNumber])\" \nmd-item-text=\"tag.tag_name\" md-no-cache=\"true\" md-floating-label=\"{{vm.translate(\'AI.SEARCH_NUMBER\')}}\" \nmd-dropdown-items=\"10\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\" \nclass=\"tag-not-found-bg border-bottom\"><span ng-if=\"!tag.tag_name\">{{vm.searchTagText}}</span> <span \nmd-highlight-text=\"vm.searchTagText\" ng-if=\"tag.tag_name\">{{tag.tag_name}}</span></div></md-autocomplete></div><div \nlayout=\"row\" flex=\"100\" layout-align=\"space-between center\" class=\"\"><div ng-if=\"profile.runnerTag\" flex=\"80\" \nlayout=\"row\" layout-align=\"center center\"><span>{{profile.runnerTag.tag_name}}</span></div><div \nng-if=\"profile.runnerTag\" flex=\"20\" layout=\"row\" layout-align=\"end center\"><button class=\"md-primary\" \nng-click=\"profile.runnerTag = null\"><md-icon md-font-icon=\"icon-close\" class=\"s14\"></md-icon></button></div>\n<md-autocomplete flex=\"100\" ng-if=\"!profile.runnerTag && !profile.runnerTagsOptions\" md-min-length=\"2\" \nmd-selected-item=\"profile.runnerTag\" \nmd-selected-item-change=\"searchTagText = null; profile.numberTag = vm.getTagByIdAndType(profile.runnerTag.id_parent, vm.idTagTypeNumber);\" \nmd-search-text=\"searchTagText\" md-items=\"tag in vm.labelQuerySearch(searchTagText, [vm.idTagTypeRunner])\" \nmd-item-text=\"tag.tag_name\" md-no-cache=\"true\" md-floating-label=\"{{vm.translate(\'AI.SEARCH_RUNNER\')}}\" \nmd-dropdown-items=\"10\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\" \nclass=\"tag-not-found-bg border-bottom\"><span ng-if=\"!tag.tag_name\">{{vm.searchTagText}}</span> <span \nmd-highlight-text=\"vm.searchTagText\" ng-if=\"tag.tag_name\">{{tag.tag_name}}</span></div></md-autocomplete>\n<md-input-container class=\"md-block\" flex=\"100\" ng-if=\"!profile.runnerTag && profile.runnerTagsOptions\"><label \ntranslate=\"AI.SELECT_RUNNER\">Select Runner</label><md-select ng-model=\"profile.runnerTag\" \nng-change=\"profile.numberTag = vm.getTagByIdAndType(profile.runnerTag.id_parent, vm.idTagTypeNumber)\"><md-optgroup \nlabel=\"Runner\"><md-option ng-repeat=\"item in profile.runnerTagsOptions\" ng-value=\"item\">{{item.tag_name}}</md-option>\n</md-optgroup></md-select></md-input-container></div></md-card-title-text></md-card-title></div><md-card-actions \nlayout=\"column\" layout-align=\"center center\"><md-button ng-if=\"!profile.confirmed && !profile.isLoading\" type=\"button\" \nclass=\"md-raised md-accent white-fg\" translate=\"AI.CORRECT\" ng-click=\"vm.confirmProfile(profile)\" \nng-disabled=\"!profile.runnerTag || !profile.numberTag\"></md-button><md-progress-circular ng-if=\"profile.isLoading\" \nmd-mode=\"indeterminate\"></md-progress-circular><md-icon ng-if=\"profile.confirmed\" \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"green-500-fg s48\"></md-icon></md-card-actions></md-card></div></div>\n</div></div>");
$templateCache.put("app/main/apps/content/views/list/subviews/photos-view.html","<div class=\"attachment\" layout=\"column\" ng-repeat=\"attachment in item.media\"><div \nng-if=\"attachment.media_type==1 || attachment.media_type==2 || attachment.media_type==4\"><div class=\"ms-card\" flex \nmd-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"ms-card-content-wrapper\"><div class=\"template-9\"><div \nclass=\"media\" flex layout=\"row\" layout-align=\"center center\" \nng-if=\"attachment.media_type==1 || attachment.media_type==2\"><media attachment=\"attachment\" class-img=\"image\" \nng-click=\"vm.openImageDialog($event, item.media, attachment)\"></media></div><div flex layout=\"column\" \nlayout-align=\"center center\" class=\"media\" ng-if=\"attachment.media_type==4\"><qiu-icon mediafile=\"attachment.filename\" \nclassextra=\"s56\"></qiu-icon><br><span class=\"grey-500-fg\" layout=\"column\" layout-align=\"center center\"><span \nng-if=\"attachment.title\"><strong>{{attachment.title}}</strong> </span><span ng-if=\"attachment.filename\">\n{{attachment.filename}}</span></span></div><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"size block mr-5\" layout=\"row\" layout-align=\"start center\"><strong class=\"mb-5 block\">#{{attachment.id_media}}\n</strong> <span class=\"grey-500-fg\" ng-if=\"attachment.media_type==1 || attachment.media_type==2\"><span \nng-if=\"attachment.title && !attachment.filename\" class=\"word-break-all\">{{attachment.title}}</span> <span \nng-if=\"attachment.filename && !attachment.title\" class=\"word-break-all\">{{attachment.filename}}</span></span></div>\n<md-menu><button class=\"md-icon-button\" aria-label=\"More\" translate translate-attr-aria-label=\"TODO.MORE\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" ng-click=\"$mdMenu.open($event)\"></md-icon></button><md-menu-content width=\"3\">\n<md-menu-item><md-button ng-click=\"vm.selectMedia($event, item)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.EDIT\"><md-icon md-font-icon=\"icon-pencil\" class=\"s18\"></md-icon><span \ntranslate=\"CONTENT.EDIT\"></span></md-button></md-menu-item><md-menu-item><md-button \nng-if=\"attachment.media_type==1 || attachment.media_type==2\" \nng-click=\"vm.openImageDialog($event, item.media, attachment)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.PREVIEW\"><md-icon md-font-icon=\"icon-eye\" class=\"ml-10\" href=\"#\" \nng-click=\"vm.openImageDialog($event, item.media, attachment)\"></md-icon><span translate=\"CONTENT.PREVIEW\">Preview\n</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.deleteMedia($event, item)\" \naria-label=\"Toggle done\" translate-attr-aria-label=\"CONTENT.REMOVE\"><md-icon md-font-icon=\"icon-close\" class=\"s18\">\n</md-icon><span translate=\"CONTENT.REMOVE\"></span></md-button></md-menu-item></md-menu-content></md-menu></div></div>\n</div></div></div></div>");
$templateCache.put("app/main/apps/gantt-chart/dialogs/add-edit/views/row-form-view.html","<div class=\"row\" layout=\"column\"><form name=\"rowForm\" ng-submit=\"vm.dialogType === \'add\'?vm.addNewRow():vm.saveRow();\">\n<div class=\"form-content\"><div layout=\"row\"><div flex class=\"input-block\"><md-input-container flex class=\"row-name\">\n<label>Row Name</label><input name=\"name\" ng-model=\"vm.row.name\" required></md-input-container></div></div><div \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex>\n<label>Parent Row:</label><md-select ng-model=\"vm.row.parent\"><md-option value=\"\">No Parent</md-option><md-option \nng-repeat=\"row in vm.chartData\" ng-value=\"row.id\">{{row.name}}</md-option></md-select></md-input-container></div><div \nclass=\"input-block\" flex layout=\"row\" layout-align=\"space-between center\"><label>Sortable:</label><md-switch \nng-model=\"vm.row.sortable\" aria-label=\"Sortable\"></md-switch></div></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start center\"><div class=\"input-block\" flex layout=\"row\" layout-align=\"space-between center\"><label>\nRow Color:</label><ms-material-color-picker ng-model=\"vm.row.classes[1]\"></ms-material-color-picker></div><div flex \nclass=\"input-block\"><md-input-container flex layout=\"row\" layout-align=\"space-between center\"><label>Extra Class\n</label><input name=\"name\" ng-model=\"vm.row.classes[0]\"></md-input-container></div></div></div><md-dialog-actions>\n<md-button ng-if=\"vm.dialogType === \'edit\'\" class=\"md-icon-button\" ng-click=\"vm.removeRow()\" aria-label=\"Remove\">\n<md-icon md-font-icon=\"icon-delete\"></md-icon></md-button><md-button type=\"submit\" class=\"md-accent md-raised\" \nng-disabled=\"rowForm.$invalid || rowForm.$pristine\" aria-label=\"Save\"><span ng-if=\"vm.dialogType === \'add\'\">Add</span> \n<span ng-if=\"vm.dialogType === \'edit\'\">Save</span></md-button></md-dialog-actions></form></div>");
$templateCache.put("app/main/apps/gantt-chart/dialogs/add-edit/views/task-form-view.html","<div class=\"task\" layout=\"column\"><form name=\"taskForm\" \nng-submit=\"vm.dialogType === \'add\'?vm.addNewTask():vm.saveTask();\"><div class=\"form-content\"><div layout=\"row\"><div \nflex class=\"input-block\"><md-input-container flex class=\"task-name\"><label>Task Name</label><input name=\"name\" \nng-model=\"vm.task.name\" required></md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex layout=\"row\" layout-align=\"space-between center\"><label>From:\n</label><md-datepicker name=\"fromDate\" ms-datepicker-fix ng-model=\"vm.task.from\" md-placeholder=\"Select Date\" \nng-required></md-datepicker></div><div class=\"input-block\" flex layout=\"row\" layout-align=\"space-between center\">\n<label>To:</label><md-datepicker name=\"toDate\" ms-datepicker-fix ng-model=\"vm.task.to\" md-placeholder=\"Select Date\" \nng-required></md-datepicker></div></div><div ng-if=\"vm.dialogType === \'add\'\" layout=\"row\" layout-align=\"start start\">\n<div flex class=\"input-block\"><md-input-container><label>Row:</label><md-select name=\"rowId\" ng-model=\"vm.taskRowId\" \nrequired><md-option ng-repeat=\"row in vm.chartData\" ng-value=\"row.id\">{{row.name}}</md-option></md-select>\n</md-input-container></div></div><div layout=\"row\" layout-align=\"start center\" class=\"input-block\"><label flex=\"25\">\nProgress: <small>{{vm.task.progress}}</small></label><md-slider flex ng-model=\"vm.task.progress\" step=\"1\" min=\"0\" \nmax=\"100\" aria-label=\"Progress\"></md-slider></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start center\">\n<div class=\"input-block\" flex layout=\"row\" layout-align=\"space-between center\"><label>Task Color:</label>\n<ms-material-color-picker ng-model=\"vm.task.classes[1]\"></ms-material-color-picker></div><div flex class=\"input-block\">\n<md-input-container flex layout=\"row\" layout-align=\"space-between center\"><label>Extra Class</label><input name=\"name\" \nng-model=\"vm.task.classes[0]\"></md-input-container></div></div></div><md-dialog-actions><md-button \nng-if=\"vm.dialogType === \'edit\'\" class=\"md-icon-button\" ng-click=\"vm.removeTask()\" aria-label=\"Remove\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon></md-button><md-button class=\"md-accent md-raised\" type=\"submit\" \nng-disabled=\"taskForm.$invalid || taskForm.$pristine\" aria-label=\"Save\"><span ng-if=\"vm.dialogType === \'add\'\">Add\n</span> <span ng-if=\"vm.dialogType === \'edit\'\">Save</span></md-button></md-dialog-actions></form></div>");
$templateCache.put("app/main/apps/mailing/views/communications/read/templates-read-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-if=\"vm.loadingReadPane\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nng-show=\"!vm.loadingReadPane\"><div class=\"mail-content\" layout=\"column\" layout-align=\"center center\" \nng-if=\"!vm.currentThread_Edit\"><div class=\"content\" layout=\"column\" layout-align=\"top center\"><div class=\"message\">\nPlease select an item to show in this panel</div></div></div><div class=\"toolbar grey-100-bg colored-bg\" layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"vm.currentThread_Edit\" scroll=\"\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button close-thread\" aria-label=\"Back\" \nng-click=\"vm.closeThread()\" translate translate-attr-aria-label=\"CONTENT.BACK\" ng-if=\"vm.currentView === \'nosplit\'\">\n<md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button></div><div layout=\"row\" layout-align=\"end center\" \nng-if=\"vm.currentThread_Edit\" hide show-gt-sm><md-button type=\"submit\" ng-click=\"vm.saveItem(vm.currentThread_Edit)\" \nclass=\"send-button md-accent md-raised\" \nng-disabled=\"vm.basicForm.$invalid || vm.basicForm.$pristine && vm.noexistchangues\" aria-label=\"SAVE\" \ntranslate=\"CONTENT.SAVE\" translate-attr-aria-label=\"CONTENT.SAVE\">SAVE</md-button><md-button type=\"button\" \nng-click=\"vm.closeThreadEdit()\" class=\"md-raised md-warn\" aria-label=\"Cancel\">Cancel</md-button></div><div \nlayout=\"row\" layout-align=\"end center\" ng-if=\"vm.currentThread_Edit\" hide-gt-sm><md-button type=\"submit\" \nng-click=\"vm.saveItem(vm.currentThread_Edit)\" \nclass=\"md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme\" \nng-disabled=\"vm.basicForm.$invalid || vm.basicForm.$pristine && vm.noexistchangues\" aria-label=\"SAVE\"><md-icon \nmd-font-icon=\"icon-check\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.SAVE\">Save</span></md-tooltip>\n</md-button><md-button type=\"button\" ng-click=\"vm.closeThreadEdit()\" \nclass=\"md-warn md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme\" aria-label=\"Cancel\"><md-icon \nmd-font-icon=\"icon-window-close\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.CANCEL\">Cancel</span>\n</md-tooltip></md-button></div></div><div id=\"content-edit\" \nclass=\"page-layout simple fullwidth mail-content content-edit\" layout=\"column\" ng-if=\"vm.currentThread_Edit\"><md-tabs \nmd-selected=\"vm.selectedIndexTab\"><md-tab label=\"Edit\" ng-if=\"vm.ActiveSection.edit\"><div layout=\"row\" \nng-include=\"\'app/main/apps/mailing/views/communications/read/templates-tab-edit.html\'\"></div></md-tab></md-tabs></div>\n</div>");
$templateCache.put("app/main/apps/mailing/views/communications/read/templates-tab-edit.html","<div class=\"form-wrapper\" flex=\"100\"><form><div><md-input-container class=\"md-block\" flex><label \ntranslate=\"MAILING.TEMPLATE_NAME\"></label><textarea ng-model=\"vm.currentThread_Edit.name\" columns=\"1\" rows=\"1\" \nplaceholder=\"{{vm.translate(\'MAILING.TEMPLATE_NAME\')}}\"></textarea></md-input-container><md-input-container \nclass=\"md-block\" flex><label translate=\"MAILING.FROM_NAME\"></label><textarea \nng-model=\"vm.currentThread_Edit.from_name\" columns=\"1\" rows=\"1\" placeholder=\"{{vm.translate(\'MAILING.FROM_NAME\')}}\">\n</textarea></md-input-container><md-input-container class=\"md-block\" flex><label translate=\"MAILING.FROM_EMAIL\">\n</label><textarea ng-model=\"vm.currentThread_Edit.from_email\" columns=\"1\" rows=\"1\" \nplaceholder=\"{{vm.translate(\'MAILING.FROM_EMAIL\')}}\"></textarea></md-input-container><md-input-container \nclass=\"md-block\" flex><label translate=\"MAILING.SUBJECT\"></label><textarea ng-model=\"vm.currentThread_Edit.subject\" \ncolumns=\"1\" rows=\"1\" placeholder=\"{{vm.translate(\'MAILING.SUBJECT\')}}\"></textarea></md-input-container></div><div \nclass=\"border-bottom\"><div class=\"md-toolbar-tools grey-100-bg border-bottom border-top\" role=\"listitem\"><h3 \nclass=\"grey-700-fg\" translate=\"MAILING.TEMPLATE_DESIGN\"></h3></div><md-input-container layout=\"row\" \nlayout-align=\"start center\" flex><md-button ng-click=\"vm.showDesignView()\" \nclass=\"add-event-button md-fab md-warn ml-0\" aria-label=\"ADD\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>\n</md-button><span class=\"font-size-16 grey-500-fg ml-5\" translate=\"MAILING.EDIT_DESIGN\"></span></md-input-container>\n</div><div class=\"form-wrapper\" flex=\"100\"><div><md-input-container class=\"md-block mb-0 chips\"><md-chips \nid=\"md-chips-email\" ng-model=\"vm.currentThread_Edit.to_emails_json\" readonly=\"false\" md-removable=\"true\" \nplaceholder=\"{{vm.translate(\'MAILING.ADD_EMAILS\')}}\" delete-button-label=\"{{vm.translate(\'MAILING.REMOVE_EMAILS\')}}\" \ndelete-hint=\"{{vm.translate(\'MAILING.DELETE_REMOVE_EMAILS\')}}\" \nsecondary-placeholder=\" {{vm.translate(\'MAILING.ADD_EMAILS\')}}\" md-enable-chip-edit=\"true\" md-separator-keys=\"vm.keys\" \nng-enter=\"validateEmail(vm.currentThread_Edit.to_emails_json)\" \nmd-transform-chip=\"addChips($chip,vm.currentThread_Edit.to_emails_json)\" ng-required=\"true\" class=\"close-chip\"><button \nmd-chip-remove class=\"md-primary\"><md-icon md-font-icon=\"icon-close\"></md-icon></button></md-chips>\n</md-input-container><md-input-container class=\"md-block mt-0\"><p class=\"grey-500-fg\" style=\"word-break: break-word\" \ntranslate=\"MAILING.TO_EMAILS_COMMENT\"></p></md-input-container></div></div></form></div>");
$templateCache.put("app/main/apps/mailing/dialogs/users-ingroup/list/list-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-if=\"vm.isLoading\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nng-style=\"{\'opacity\' : vm.isLoading ? 0.2 : 1}\" f lex layout=\"row\" layout-align=\"space-between center\" \nclass=\"search-bar pv-5\"><label for=\"search-bar-input\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"md-icon-button md-button\"><md-tooltip><span translate=\"TOOLBAR.SEARCH\">Search</span></md-tooltip></md-icon>\n</label><input id=\"search-bar-input\" type=\"text\" ng-model=\"vm.searchString\" placeholder=\"Search\" md-autofocus \ntranslate translate-attr-placeholder=\"TOOLBAR.SEARCH\" flex><md-icon md-font-icon=\"icon-close-circle\" class=\"icon s24\" \nng-if=\"vm.searchString\" ng-click=\"vm.reload();\"></md-icon><md-button class=\"md-accent md-raised\" \nng-click=\"vm.search()\" aria-label=\"search\" md-no-ink=\"true\" md-ripple-size=\"auto\">Search</md-button></div><md-tabs \nmd-dynamic-height><md-tab><md-tab-label><span translate=\"GLOBAL.ALL_USERS\">All users</span></md-tab-label><md-tab-body>\n<div ng-style=\"{\'opacity\' : vm.isLoading ? 0.2 : 1}\" ms-scroll=\"vm.msScrollOptions\" \nclass=\"scrollable list-content-data\"><div class=\"no-threads\" ng-hide=\"vm.isLoading\" \nng-if=\"!vm.isLoading && vm.threads.length === 0\">There are no items!</div><div \nclass=\"mail-list-item {{thread.status}}\" ng-repeat=\"thread in vm.threads\" md-no-ink ng-if=\"vm.threads.length> 0\"><div \nlayout=\"row\" layout-align=\"start center\"><div class=\"info\" flex><div class=\"name\" layout=\"row\" \nlayout-align=\"start center\"><div ng-if=\"(!thread.avatar) && thread[vm.refcolumnsgrouped.main[0].title]\" class=\"avatar\" \nng-bind=\"thread[vm.refcolumnsgrouped.main[0].title] | capitalizeFirstLetter\" ms-random-class=\"vm.colors\"></div><media \nng-if=\"thread.avatar\" attachment=\"thread.avatar\" class=\"avatar\"></media><div class=\"user-name\" layout=\"column\" \nlayout-align=\"start start\"><div ng-if=\"vm.refcolumnsgrouped.header\" class=\"user-header text-truncate grey-500-fg\"><span\n ng-repeat=\"field in vm.refcolumnsgrouped.header | orderBy: \'list_sort\'\" ng-if=\"field.title.charAt(0) != \'[\'\"><span \nng-if=\"field.type == \'id\'\">#</span> <span ng-if=\"field.type == \'dateHm\' || field.type == \'date\'\" \nng-bind=\"vm.showDate(thread[field.title])\"></span> <span ng-if=\"field.type != \'dateHm\' && field.type != \'date\'\" \nng-bind=\"thread.{{field.title}}\"></span></span></div><div \nng-if=\"vm.refcolumnsgrouped.main && thread[vm.refcolumnsgrouped.main[0].title]\"><span \nng-repeat=\"field in vm.refcolumnsgrouped.main\" ng-if=\"field.title.charAt(0) != \'[\'\"><span \nng-bind=\"thread.{{field.title}}\"></span>&nbsp;</span></div><div \nng-repeat=\"field in vm.refcolumnsgrouped.secondary | orderBy:\'list_sort\'\" ng-if=\"field.title.charAt(0) != \'[\'\"><div \nng-if=\"(field.type!==\'id_subcat\' && field.type!==\'id_cat\' && field.type!==\'id_subsec\' && field.type!==\'date\' && field.type!==\'dateHm\') && field.primary!==1\" \nclass=\"details text-truncate\"><span class=\"title\" ng-bind=\"thread.{{field.title}}\"></span></div><div \nng-if=\"field.type==\'id_subsec\'\" class=\"details\" layout=\"row\" layout-align=\"start start\"><span \nclass=\"title grey-500-fg\" ng-bind=\"field.field_name\"></span> <span class=\"detail text-truncate\" \nng-bind=\"vm.getReferencesSections(\'subsection\', field.type, thread.{{field.title}})\"></span></div><div \nng-if=\"field.type==\'id_cat\'\" class=\"details\" layout=\"row\" layout-align=\"start start\"><span class=\"title grey-500-fg\" \nng-bind=\"field.field_name\"></span> <span class=\"detail text-truncate\" \nng-bind=\"vm.getReferencesSections(\'cat\', field.type, thread.{{field.title}})\"></span></div><div \nng-if=\"field.type==\'id_subcat\'\" class=\"details\" layout=\"row\" layout-align=\"start start\"><span \nclass=\"title grey-500-fg\" ng-bind=\"field.field_name\"></span> <span class=\"detail text-truncate\" \nng-bind=\"vm.getReferencesSections(\'subcat\', field.type, thread.{{field.title}})\"></span></div></div></div></div></div>\n<div class=\"buttons\" layout=\"row\" layout-align=\"start center\"><div \nng-repeat=\"field in vm.refcolumnsgrouped.right_center | orderBy:\'list_sort\'\" ng-if=\"field.title.charAt(0) != \'[\'\"><div \nng-if=\"field.type == \'ingroup_status\' && thread.groups.length\" class=\"status-wrapper text-center\" layout=\"row\" \nlayout-align=\"end center\"><div ng-repeat=\"group in thread.groups\"><div ng-repeat=\"status in vm.ingroupStatus\"><span \nng-if=\"group.id_group == vm.selectedGroupId && status.id_ingroup_status == group.users_ingroup.id_ingroup_status\" \nclass=\"{{status.name}} status\" translate=\"USERS.INGROUP.STATUS.{{status.name | uppercase}}\" layout=\"row\" \nlayout-align=\"center center\"></span></div></div></div><div class=\"grey-500-fg ml-10\" ng-if=\"field.type == \'id\'\" \nng-bind=\"\'# \'+thread.{{field.title}}\"></div><div class=\"grey-500-fg\" \nng-if=\"field.type == \'dateHm\' || field.type == \'date\'\" ng-bind=\"vm.showDate(thread[field.title])\"></div><div \nclass=\"grey-500-fg\" \nng-if=\"field.type != \'dateHm\' && field.type != \'date\' && field.type != \'user_status\' && field.type != \'id\' && field.type != \'ingroup_status\'\" \nng-bind=\"thread.{{field.title}}\"></div></div></div></div></div><div \nng-if=\"!vm.isLoading && vm.paginationTotalPages> vm.paginationPage && vm.threads.length > 0\" \nclass=\"load-more white p-30\" layout=\"row\" layout-sm=\"column\" layout-align=\"center center\" layout-wrap=\"\"><md-button \nng-click=\"vm.loadMore()\" class=\"md-raised\">{{ \'USERS.LOAD_MORE\' | translate}}</md-button></div></div></md-tab-body>\n</md-tab><md-tab><md-tab-label><span translate=\"MAILING.SUBSCRIBED\">SUBSCRIBED</span></md-tab-label><md-tab-body><div \nng-style=\"{\'opacity\' : vm.isLoading ? 0.2 : 1}\" ms-scroll=\"vm.msScrollOptions\" class=\"scrollable list-content-data\">\n<div class=\"no-threads\" ng-hide=\"vm.isLoading\" ng-if=\"!vm.isLoading && vm.threads.length === 0\">There are no items!\n</div><div class=\"mail-list-item {{thread.status}}\" ng-repeat=\"thread in vm.threads | filter: filterByStatusSub\" \nmd-no-ink ng-if=\"vm.threads.length> 0\"><div layout=\"row\" layout-align=\"start center\"><div class=\"info\" flex><div \nclass=\"name\" layout=\"row\" layout-align=\"start center\"><div \nng-if=\"(!thread.avatar) && thread[vm.refcolumnsgrouped.main[0].title]\" class=\"avatar\" \nng-bind=\"thread[vm.refcolumnsgrouped.main[0].title] | capitalizeFirstLetter\" ms-random-class=\"vm.colors\"></div><media \nng-if=\"thread.avatar\" attachment=\"thread.avatar\" class=\"avatar\"></media><div class=\"user-name\" layout=\"column\" \nlayout-align=\"start start\"><div ng-if=\"vm.refcolumnsgrouped.header\" class=\"user-header text-truncate grey-500-fg\"><span\n ng-repeat=\"field in vm.refcolumnsgrouped.header | orderBy: \'list_sort\'\" ng-if=\"field.title.charAt(0) != \'[\'\"><span \nng-if=\"field.type == \'id\'\">#</span> <span ng-if=\"field.type == \'dateHm\' || field.type == \'date\'\" \nng-bind=\"vm.showDate(thread[field.title])\"></span> <span ng-if=\"field.type != \'dateHm\' && field.type != \'date\'\" \nng-bind=\"thread.{{field.title}}\"></span></span></div><div \nng-if=\"vm.refcolumnsgrouped.main && thread[vm.refcolumnsgrouped.main[0].title]\"><span \nng-repeat=\"field in vm.refcolumnsgrouped.main\" ng-if=\"field.title.charAt(0) != \'[\'\"><span \nng-bind=\"thread.{{field.title}}\"></span>&nbsp;</span></div><div \nng-repeat=\"field in vm.refcolumnsgrouped.secondary | orderBy:\'list_sort\'\" ng-if=\"field.title.charAt(0) != \'[\'\"><div \nng-if=\"(field.type!==\'id_subcat\' && field.type!==\'id_cat\' && field.type!==\'id_subsec\' && field.type!==\'date\' && field.type!==\'dateHm\') && field.primary!==1\" \nclass=\"details text-truncate\"><span class=\"title\" ng-bind=\"thread.{{field.title}}\"></span></div><div \nng-if=\"field.type==\'id_subsec\'\" class=\"details\" layout=\"row\" layout-align=\"start start\"><span \nclass=\"title grey-500-fg\" ng-bind=\"field.field_name\"></span> <span class=\"detail text-truncate\" \nng-bind=\"vm.getReferencesSections(\'subsection\', field.type, thread.{{field.title}})\"></span></div><div \nng-if=\"field.type==\'id_cat\'\" class=\"details\" layout=\"row\" layout-align=\"start start\"><span class=\"title grey-500-fg\" \nng-bind=\"field.field_name\"></span> <span class=\"detail text-truncate\" \nng-bind=\"vm.getReferencesSections(\'cat\', field.type, thread.{{field.title}})\"></span></div><div \nng-if=\"field.type==\'id_subcat\'\" class=\"details\" layout=\"row\" layout-align=\"start start\"><span \nclass=\"title grey-500-fg\" ng-bind=\"field.field_name\"></span> <span class=\"detail text-truncate\" \nng-bind=\"vm.getReferencesSections(\'subcat\', field.type, thread.{{field.title}})\"></span></div></div></div></div></div>\n<div class=\"buttons\" layout=\"row\" layout-align=\"start center\"><div \nng-repeat=\"field in vm.refcolumnsgrouped.right_center | orderBy:\'list_sort\'\" ng-if=\"field.title.charAt(0) != \'[\'\"><div \nng-if=\"field.type == \'ingroup_status\' && thread.groups.length\" class=\"status-wrapper text-center\" layout=\"row\" \nlayout-align=\"end center\"><div ng-repeat=\"group in thread.groups\"><div ng-repeat=\"status in vm.ingroupStatus\"><span \nng-if=\"group.id_group == vm.selectedGroupId && status.id_ingroup_status == group.users_ingroup.id_ingroup_status\" \nclass=\"{{status.name}} status\" translate=\"USERS.INGROUP.STATUS.{{status.name | uppercase}}\" layout=\"row\" \nlayout-align=\"center center\"></span></div></div></div><div class=\"grey-500-fg ml-10\" ng-if=\"field.type == \'id\'\" \nng-bind=\"\'# \'+thread.{{field.title}}\"></div><div class=\"grey-500-fg\" \nng-if=\"field.type == \'dateHm\' || field.type == \'date\'\" ng-bind=\"vm.showDate(thread[field.title])\"></div><div \nclass=\"grey-500-fg\" \nng-if=\"field.type != \'dateHm\' && field.type != \'date\' && field.type != \'user_status\' && field.type != \'id\' && field.type != \'ingroup_status\'\" \nng-bind=\"thread.{{field.title}}\"></div></div></div></div></div><div \nng-if=\"!vm.isLoading && vm.paginationTotalPages> vm.paginationPage && vm.threads.length > 0\" \nclass=\"load-more white p-30\" layout=\"row\" layout-sm=\"column\" layout-align=\"center center\" layout-wrap=\"\"><md-button \nng-click=\"vm.loadMore()\" class=\"md-raised\">{{ \'USERS.LOAD_MORE\' | translate}}</md-button></div></div></md-tab-body>\n</md-tab><md-tab><md-tab-label><span translate=\"MAILING.UNSUBSCRIBED\">UNSUBSCRIBED</span></md-tab-label><md-tab-body>\n<div ng-style=\"{\'opacity\' : vm.isLoading ? 0.2 : 1}\" ms-scroll=\"vm.msScrollOptions\" \nclass=\"scrollable list-content-data\"><div class=\"no-threads\" ng-hide=\"vm.isLoading\" \nng-if=\"!vm.isLoading && vm.threads.length === 0\">There are no items!</div><div \nclass=\"mail-list-item {{thread.status}}\" ng-repeat=\"thread in vm.threads | filter:filterByStatusUnSub\" md-no-ink \nng-if=\"vm.threads.length> 0\"><div layout=\"row\" layout-align=\"start center\"><div class=\"info\" flex><div class=\"name\" \nlayout=\"row\" layout-align=\"start center\"><div ng-if=\"(!thread.avatar) && thread[vm.refcolumnsgrouped.main[0].title]\" \nclass=\"avatar\" ng-bind=\"thread[vm.refcolumnsgrouped.main[0].title] | capitalizeFirstLetter\" \nms-random-class=\"vm.colors\"></div><media ng-if=\"thread.avatar\" attachment=\"thread.avatar\" class=\"avatar\"></media><div \nclass=\"user-name\" layout=\"column\" layout-align=\"start start\"><div ng-if=\"vm.refcolumnsgrouped.header\" \nclass=\"user-header text-truncate grey-500-fg\"><span \nng-repeat=\"field in vm.refcolumnsgrouped.header | orderBy: \'list_sort\'\" ng-if=\"field.title.charAt(0) != \'[\'\"><span \nng-if=\"field.type == \'id\'\">#</span> <span ng-if=\"field.type == \'dateHm\' || field.type == \'date\'\" \nng-bind=\"vm.showDate(thread[field.title])\"></span> <span ng-if=\"field.type != \'dateHm\' && field.type != \'date\'\" \nng-bind=\"thread.{{field.title}}\"></span></span></div><div \nng-if=\"vm.refcolumnsgrouped.main && thread[vm.refcolumnsgrouped.main[0].title]\"><span \nng-repeat=\"field in vm.refcolumnsgrouped.main\" ng-if=\"field.title.charAt(0) != \'[\'\"><span \nng-bind=\"thread.{{field.title}}\"></span>&nbsp;</span></div><div \nng-repeat=\"field in vm.refcolumnsgrouped.secondary | orderBy:\'list_sort\'\" ng-if=\"field.title.charAt(0) != \'[\'\"><div \nng-if=\"(field.type!==\'id_subcat\' && field.type!==\'id_cat\' && field.type!==\'id_subsec\' && field.type!==\'date\' && field.type!==\'dateHm\') && field.primary!==1\" \nclass=\"details text-truncate\"><span class=\"title\" ng-bind=\"thread.{{field.title}}\"></span></div><div \nng-if=\"field.type==\'id_subsec\'\" class=\"details\" layout=\"row\" layout-align=\"start start\"><span \nclass=\"title grey-500-fg\" ng-bind=\"field.field_name\"></span> <span class=\"detail text-truncate\" \nng-bind=\"vm.getReferencesSections(\'subsection\', field.type, thread.{{field.title}})\"></span></div><div \nng-if=\"field.type==\'id_cat\'\" class=\"details\" layout=\"row\" layout-align=\"start start\"><span class=\"title grey-500-fg\" \nng-bind=\"field.field_name\"></span> <span class=\"detail text-truncate\" \nng-bind=\"vm.getReferencesSections(\'cat\', field.type, thread.{{field.title}})\"></span></div><div \nng-if=\"field.type==\'id_subcat\'\" class=\"details\" layout=\"row\" layout-align=\"start start\"><span \nclass=\"title grey-500-fg\" ng-bind=\"field.field_name\"></span> <span class=\"detail text-truncate\" \nng-bind=\"vm.getReferencesSections(\'subcat\', field.type, thread.{{field.title}})\"></span></div></div></div></div></div>\n<div class=\"buttons\" layout=\"row\" layout-align=\"start center\"><div \nng-repeat=\"field in vm.refcolumnsgrouped.right_center | orderBy:\'list_sort\'\" ng-if=\"field.title.charAt(0) != \'[\'\"><div \nng-if=\"field.type == \'ingroup_status\' && thread.groups.length\" class=\"status-wrapper text-center\" layout=\"row\" \nlayout-align=\"end center\"><div ng-repeat=\"group in thread.groups\"><div ng-repeat=\"status in vm.ingroupStatus\"><span \nng-if=\"group.id_group == vm.selectedGroupId && status.id_ingroup_status == group.users_ingroup.id_ingroup_status\" \nclass=\"{{status.name}} status\" translate=\"USERS.INGROUP.STATUS.{{status.name | uppercase}}\" layout=\"row\" \nlayout-align=\"center center\"></span></div></div></div><div class=\"grey-500-fg ml-10\" ng-if=\"field.type == \'id\'\" \nng-bind=\"\'# \'+thread.{{field.title}}\"></div><div class=\"grey-500-fg\" \nng-if=\"field.type == \'dateHm\' || field.type == \'date\'\" ng-bind=\"vm.showDate(thread[field.title])\"></div><div \nclass=\"grey-500-fg\" \nng-if=\"field.type != \'dateHm\' && field.type != \'date\' && field.type != \'user_status\' && field.type != \'id\' && field.type != \'ingroup_status\'\" \nng-bind=\"thread.{{field.title}}\"></div></div></div></div></div><div \nng-if=\"!vm.isLoading && vm.paginationTotalPages> vm.paginationPage && vm.threads.length > 0\" \nclass=\"load-more white p-30\" layout=\"row\" layout-sm=\"column\" layout-align=\"center center\" layout-wrap=\"\"><md-button \nng-click=\"vm.loadMore()\" class=\"md-raised\">{{ \'USERS.LOAD_MORE\' | translate}}</md-button></div></div></md-tab-body>\n</md-tab></md-tabs>");
$templateCache.put("app/main/apps/mailing/views/content/list/list-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-if=\"isLoading\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nclass=\"mail-list-item filter-selected\" ng-if=\"sortField\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\" flex><div class=\"info\" ng-if=\"sortField\"><div class=\"name\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-sort-ascending\" class=\"s20 mr-5 ml-0 mb-0\" \nng-if=\"sortDir === \'ASC\'\"></md-icon><md-icon md-font-icon=\"icon-sort-descending\" class=\"s20 mr-5 ml-0 mb-0\" \nng-if=\"sortDir === \'DESC\'\"></md-icon><div class=\"title text-truncate\" layout=\"row\" layout-align=\"start center\">\nOrdered by \'{{sortField}}\'</div></div></div></div><div class=\"buttons\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-close s20\" ng-click=\"pagination_resetOrderBy()\" class=\"ml-10\"><md-tooltip hide show-gt-xs>\n<span translate=\"CONTENT.REMOVE\">Remove</span></md-tooltip></md-icon></div></div><div class=\"no-threads\" \nng-if=\"!isLoading && vm.contents.length === 0\" ng-hide=\"isLoading\">There are no items!</div><div \nid=\"list-content-data\" ng-style=\"{\'opacity\' : isLoading ? 0.2 : 1}\" ms-scroll=\"vm.msScrollOptions\" \nng-class=\"{\'group-filter\': vm.selectedGroup,\'other-filter\':sortField}\" class=\"scrollable\" \nng-if=\"vm.contents.length> 0\"><div class=\"mail-list-item {{contentTemplate.status}}\" \nng-repeat=\"contentTemplate in vm.contents | filter: vm.search | filter: global.search\" ng-init=\"parentIndex= $index\" \nmd-no-ink ng-click=\"vm.openContent(contentTemplate.id_mailing_content)\" \nng-class=\"{\'starred\': contentTemplate.starred,\r\n        \'selected\': vm.selectedContentID === contentTemplate.id_mailing_content, \'checked\': vm.isChecked(contentTemplate)}\">\n<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\" flex><md-checkbox \nclass=\"no-label\" ng-checked=\"vm.isSelected(contentTemplate)\" ng-click=\"vm.toggleSelectThread(contentTemplate, $event)\" \naria-label=\"{{vm.isSelected(contentTemplate) ? \'Deselect\' : \'Select\'}}\"></md-checkbox><div \nclass=\"info layout-column flex\" flex=\"\" layout=\"column\"><div class=\"name text-truncate\" layout=\"row\" \nlayout-align=\"start center\"><span>{{contentTemplate.subject}}</span></div><div class=\"details\" layout=\"column\" \nlayout-gt-md=\"row\" layout-align=\"start start\"><div layout=\"row\" class=\"mr-10 mb-5 text-truncate\" \nng-if=\"contentTemplate.mailing_template.name\"><span class=\"title grey-500-fg\">Template </span><span \nng-bind=\"contentTemplate.mailing_template.name\"></span></div><div layout=\"row\" class=\"mr-10 mb-5\" \nng-if=\"vm.isSent(contentTemplate)\"><span class=\"title grey-500-fg\">Sent </span><span \nng-bind-html=\"vm.timeAgo(contentTemplate.sent_at)\"></span></div><div layout=\"row\" \nng-if=\"contentTemplate.scheduled_at && !contentTemplate.sent_at\"><span class=\"title grey-500-fg\">Scheduled </span><span\n ng-bind-html=\"vm.getDateFormat(contentTemplate.scheduled_at)\"></span></div></div><div layout=\"row\" \nclass=\"mr-10 mb-5 text-truncate\"><span ng-if=\"!contentTemplate.sent_from_address\"><span class=\"title grey-500-fg\">\n{{\'MAILING.FROM\' | translate}}: </span><span>{{contentTemplate.mailing_template.from_email}}</span> </span><span \nng-if=\"contentTemplate.sent_from_address\"><span class=\"title grey-500-fg\">{{\'MAILING.FROM\' | translate}}: </span><span>\n{{contentTemplate.sent_from_address}}</span></span></div></div></div><div class=\"status-wrapper text-center\" \nlayout=\"row\" layout-align=\"end center\"><div class=\"status grey-300-bg ml-10\" layout=\"row\" layout-align=\"center center\" \nng-if=\"contentTemplate.id_mailing_status <2\"><span translate=\"MAILING.STATUSES.UNSENT\">Unsent</span></div><div \nclass=\"status blue-500-bg ml-10\" layout=\"row\" layout-align=\"center center\" \nng-if=\"contentTemplate.id_mailing_status == 2 || (contentTemplate.id_mailing_status == 3 && contentTemplate.scheduled_at)\">\n<span translate=\"MAILING.STATUSES.SCHEDULED\">Scheduled</span></div><div class=\"status blue-500-bg ml-10\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"contentTemplate.id_mailing_status == 3 && !contentTemplate.scheduled_at\"><span \ntranslate=\"MAILING.STATUSES.PROCESSING\">Processing</span></div><div class=\"status blue-500-bg ml-10\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"contentTemplate.id_mailing_status == 4\"><span translate=\"MAILING.STATUSES.SENDING\">\nSending</span></div><div class=\"status green-bg ml-10\" layout=\"row\" layout-align=\"center center\" \nng-if=\"contentTemplate.id_mailing_status == 5\"><span translate=\"MAILING.STATUSES.SENT\">Sent</span></div></div></div>\n</div><div class=\"toolbar\" layout=\"row\" layout-align=\"end center\"><div layout=\"row\" layout-align=\"center center\" \nng-style=\"{\'display\' : isLoading ? \'none\' : \'block\'}\"><span class=\"page-info\">{{pagination_totalItems}} items found.\n</span><md-button aria-label=\"Previous\" class=\"md-icon-button arrow\" ng-click=\"pagination_prevPage()\" \nng-disabled=\"pagination_firstPage()\" translate=\"\" translate-attr-aria-label=\"CONTENT.PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><span class=\"page-info\">\n{{pagination_page}} / {{pagination_total_pages}}</span><md-button aria-label=\"Next\" class=\"md-icon-button arrow\" \nng-click=\"pagination_nextPage()\" ng-disabled=\"pagination_morePages()\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div>\n</div>");
$templateCache.put("app/main/apps/mailing/views/content/list/nosplit-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/mailing/views/content/list/toolbar.html\'\" ng-hide=\"vm.loadTemplates || vm.isUpdateContent\">\n</div><div class=\"content-wrapper\" flex=\"\" layout=\"row\"><div class=\"content thread-detail mail-read-pane\" flex \nid=\"thread-detail\" ms-scroll=\"vm.msScrollOptions\" ng-if=\"vm.loadTemplates || vm.isUpdateContent\" \nng-include=\"\'app/main/apps/mailing/views/content/read/content-read-view.html\'\"></div><div \nclass=\"content thread-list mail-list-pane\" flex id=\"thread-list\" ng-if=\"!vm.loadTemplates && !vm.isUpdateContent\" \nng-include=\"\'app/main/apps/mailing/views/content/list/list-view.html\'\"></div><div ng-if=\"vm.tabSelected == \'details\'\" \nclass=\"pane-mailing\" ng-class=\"{\'selected\' : vm.selectedUser}\" \nng-include=\"\'app/main/apps/mailing/views/content/read/content-user-mailing.html\'\"></div></div>");
$templateCache.put("app/main/apps/mailing/views/content/list/split-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/mailing/views/content/list/toolbar.html\'\"></div><div class=\"content-wrapper\" flex=\"\" \nlayout=\"row\"><div ng-if=\"vm.tabSelected != \'details\'\" class=\"content thread-list mail-list-pane\" flex=\"40\" \nid=\"thread-list\" ng-include=\"\'app/main/apps/mailing/views/content/list/list-view.html\'\"></div><div hide show-gt-md \nng-if=\"vm.tabSelected == \'details\'\" class=\"content thread-list mail-read-pane\" flex=\"30\" id=\"thread-detail\" \nlayout=\"column\"><div ng-include=\"\'app/main/apps/mailing/views/content/read/content-read-info.html\'\"></div></div><div \nhide show-gt-md class=\"content thread-detail mail-read-pane\" flex=\"{{vm.tabSelected != \'details\' ? \'60\' : \'70\' }}\" \nid=\"thread-detail\" layout=\"column\" ng-include=\"\'app/main/apps/mailing/views/content/read/content-read-view.html\'\">\n</div><div hide-gt-md class=\"content thread-detail mail-read-pane\" flex=\"100\" id=\"thread-detail\" layout=\"column\" \nng-include=\"\'app/main/apps/mailing/views/content/read/content-read-view.html\'\"></div><div \nng-if=\"vm.tabSelected == \'details\'\" class=\"pane-mailing\" ng-class=\"{\'selected\' : vm.selectedUser}\" \nng-include=\"\'app/main/apps/mailing/views/content/read/content-user-mailing.html\'\"></div></div>");
$templateCache.put("app/main/apps/mailing/views/content/list/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-label\" \naria-label=\"{{vm.selectedThreads.length > 0 ? \'Deselect All\' : \'Select All\'}}\" \nng-checked=\"vm.selectedThreads.length > 0\" ng-click=\"vm.toggleSelectThreads(vm.selectedThreads, vm.contents)\">\n</md-checkbox><div class=\"divider-vertical\" hide=\"\" show-gt-xs=\"\"></div><md-button \nclass=\"md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme\" hide show-gt-sm \nng-click=\"vm.newContent()\" translate=\"CONTENT.ADD\" type=\"button\" aria-label=\"NEW\"></md-button><md-button \naria-label=\"ADD NEW\" class=\"md-fab md-mini md-accent green-500-bg md-raised md-ink-ripple md-default-theme\" hide-gt-sm \nng-click=\"vm.newContent()\" type=\"button\" aria-label=\"NEW\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><div \nclass=\"divider-vertical\" hide=\"\" show-gt-xs=\"\"></div><div aria-hidden=\"false\" \nclass=\"action-buttons hide show-gt-xs layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\" \nng-show=\"vm.selectedThreads.length > 0\"><md-button ng-click=\"vm.duplicateContent()\" aria-label=\"Duplicate\" \nclass=\"md-icon-button\" hide=\"\" show-gt-xs=\"\" translate=\"\" translate-attr-aria-label=\"CONTENT.DUPLICATE\"><md-icon \nmd-font-icon=\"icon-content-duplicate\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.DUPLICATE\">\nDuplicate</span></md-tooltip></md-button><md-button ng-show=\"vm.selectedThreads.length > 0\" \nng-click=\"vm.deleteContent()\" aria-label=\"Delete\" class=\"md-icon-button\" hide=\"\" show-gt-xs=\"\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip hide show-gt-xs>\n<span translate=\"CONTENT.DELETE\">Delete</span></md-tooltip></md-button><div class=\"divider-vertical\" hide=\"\" \nshow-gt-xs=\"\"></div></div><ms-search-bar debounce=\"300\" model-search=\"$root.pagination_searchquery\" \non-result-click=\"vm.searchResultClick(item)\" on-search=\"vm.search(query)\" layout=\"row\" layout-align=\"start center\">\n</ms-search-bar><md-button ng-click=\"$root.pagination_resetquery()\" aria-label=\"view type\" class=\"md-icon-button\" \ntranslate=\"\" translate-attr-aria-label=\"CONTENT.FILTERS\" class=\"md-icon-button\" \nng-if=\"$root.pagination_searchquery==true\"><md-icon md-font-icon=\"icon-filter-remove-outline\"></md-icon><md-tooltip \nhide show-gt-xs><span>Reset search</span></md-tooltip></md-button><div class=\"divider-vertical\" hide=\"\" show-gt-xs=\"\">\n</div><md-button aria-label=\"Sort Direction\" class=\"md-icon-button\" ng-click=\"vm.setSortOrder(\'ASC\')\" \nng-disabled=\"!sortField\" ng-if=\"sortDir !== \'ASC\'\" translate=\"\" translate-attr-aria-label=\"TODO.SORT_DIRECTION\">\n<md-icon md-font-icon=\"icon-sort-ascending\"></md-icon></md-button><md-button aria-label=\"Sort Direction\" \nclass=\"md-icon-button\" ng-click=\"vm.setSortOrder(\'DESC\')\" ng-disabled=\"!sortField\" ng-if=\"sortDir === \'ASC\'\" \ntranslate=\"\" translate-attr-aria-label=\"TODO.SORT_DIRECTION\"><md-icon md-font-icon=\"icon-sort-descending\"></md-icon>\n</md-button><md-menu><button aria-label=\"Filters\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" show-gt-xs=\"\" \ntranslate=\"\" translate-attr-aria-label=\"CONTENT.FILTERS\"><md-icon md-font-icon=\"icon-chevron-down\"><md-tooltip><span \ntranslate=\"CONTENT.ORDER_BY\">Order</span></md-tooltip></md-icon></button><md-menu-content width=\"1\"><md-menu-item>\n<md-button ng-click=\"vm.setSortField(\'id_mailing_content\')\">ID</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.setSortField(\'created_at\')\">Creation date</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.setSortField(\'updated_at\')\">Update date</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.setSortField(\'subject\')\">Subject</md-button></md-menu-item></md-menu-content></md-menu><md-menu hide=\"\" \nshow-gt-xs=\"\" ng-if=\"refGroupables.length>0\"><button aria-label=\"Filters\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\" show-gt-xs=\"\" translate=\"\" translate-attr-aria-label=\"CONTENT.FILTERS\"><md-icon \nmd-font-icon=\"icon-chevron-down\"><md-tooltip hide show-gt-xs><span translate=\"CONTENT.GROUP_BY\">Group</span>\n</md-tooltip></md-icon></button><md-menu-content width=\"4\"><md-menu-item ng-repeat=\"sortfield in refGroupables\">\n<md-button aria-label=\"All\" ng-click=\"pagination_setOrderBy(sortfield)\"><div layout=\"row\" \nlayout-align=\"space-between center\"><span>Group by {{sortfield.name}} </span><i class=\"icon-check s16\" \nng-if=\"sortfield.titleId == sortable.titleId\"></i></div></md-button></md-menu-item><md-menu-divider ng-if=\"groupable\">\n</md-menu-divider><md-menu-item ng-if=\"groupable\"><md-button aria-label=\"Remove group\" \nng-click=\"pagination_resetOrderBy()\"><md-icon md-font-icon=\"icon-close \"></md-icon><span>Remove order</span>\n</md-button></md-menu-item></md-menu-content></md-menu></div><div layout=\"row\" layout-align=\"start center\" \ntranslate-attr-aria-label=\"CONTENT.REFRESH\"><span class=\"page-info\" hide=\"\" show-gt-xs=\"\">\n{{pagination_totalItems}} items found.</span><md-button aria-label=\"Previous\" class=\"md-icon-button arrow\" hide=\"\" \nng-click=\"pagination_prevPage()\" ng-disabled=\"pagination_firstPage()\" show-gt-xs=\"\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip hide \nshow-gt-xs><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-tooltip></md-button><span class=\"page-info\" \nhide=\"\" show-gt-xs=\"\">{{pagination_page}} / {{pagination_total_pages}}</span><md-button aria-label=\"Next\" \nclass=\"md-icon-button arrow\" hide=\"\" ng-click=\"pagination_nextPage()\" ng-disabled=\"pagination_morePages()\" \nshow-gt-xs=\"\" translate=\"\" translate-attr-aria-label=\"CONTENT.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\">\n</md-icon><md-tooltip hide show-gt-xs><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-tooltip></md-button>\n<div class=\"divider-vertical\" hide hide show-gt-sm></div><md-button class=\"md-icon-button\" \nng-click=\"vm.changeView(\'nosplit\')\" ng-if=\"vm.currentView !== \'nosplit\' && !vm.basicForm\" hide show-gt-sm \naria-label=\"noSplit\"><md-icon md-font-icon=\"icon-view-list\" ng-if=\"vm.currentView !== \'nosplit\'\"></md-icon><md-icon \nclass=\"md-accent\" md-font-icon=\"icon-checkbox-marked\" ng-if=\"vm.currentView === \'nosplit\'\"></md-icon><md-tooltip hide \nshow-gt-xs><span translate=\"CONTENT.NOSPLIT_VIEW\">No split</span></md-tooltip></md-button><md-button \nng-if=\"vm.currentView !== \'nosplit\' && vm.basicForm\" hide show-gt-sm class=\"md-icon-button\" aria-label=\"noSplit\">\n<md-icon md-font-icon=\"icon-view-list\" ng-if=\"vm.currentView !== \'nosplit\'\" class=\"disabled\"></md-icon><md-icon \nclass=\"md-accent disabled\" md-font-icon=\"icon-checkbox-marked\" ng-if=\"vm.currentView === \'nosplit\'\"></md-icon>\n<md-tooltip ng-if=\"vm.currentView !== \'nosplit\' && vm.basicForm\" hide show-gt-sm><span \ntranslate=\"CONTENT.CANT_CHANGE_WHILE_EDITING\"></span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.changeView(\'split\')\" ng-if=\"vm.currentView !== \'split\'\" hide show-gt-sm aria-label=\"Split\" \nng-disabled=\"vm.basicForm.$pristine\"><md-icon md-font-icon=\"icon-view-quilt\" ng-if=\"vm.currentView !== \'split\'\">\n</md-icon><md-icon class=\"md-accent\" md-font-icon=\"icon-checkbox-marked\" ng-if=\"vm.currentView === \'split\'\"></md-icon>\n<md-tooltip hide show-gt-xs><span translate=\"CONTENT.SPLIT_VIEW\">split</span></md-tooltip></md-button><md-menu \nclass=\"settings-menu\" hide-gt-xs ng-show=\"vm.selectedThreads.length > 0\"><md-button aria-label=\"Settings\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" translate=\"\" translate-attr-aria-label=\"CONTENT.SETTINGS\">\n<md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content><md-menu-item \nshow=\"vm.selectedMail.length > 0 || vm.allChecked\"><md-button ng-click=\"vm.duplicateContent()\" aria-label=\"Duplicate\" \ntranslate-attr-aria-label=\"CONTENT.DUPLICATE\"><md-icon md-font-icon=\"icon-content-duplicate\"></md-icon><span \ntranslate=\"CONTENT.DUPLICATE\">Duplicate </span><span translate=\"CONTENT.SELECTED\">Selected</span></md-button>\n</md-menu-item><md-menu-item show=\"vm.selectedMail.length > 0 || vm.allChecked\"><md-button \nng-click=\"vm.deleteContent()\" aria-label=\"Delete\" translate-aria-label=\"CONTENT.DELETE\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><span translate=\"CONTENT.DELETE\">Delete </span><span translate=\"CONTENT.SELECTED\">\nSelected</span></md-button></md-menu-item></md-menu-content></md-menu></div>");
$templateCache.put("app/main/apps/mailing/views/content/read/content-read-info.html","<div class=\"md-block ph-24 pv-24 border-bottom\" flex><h1 class=\"mb-5 mt-0\"><strong>{{vm.currentContent.subject}}\n</strong></h1><div class=\"font-size-16\" layout=\"column\" layout-align=\"center start\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"start center\" ng-if=\"!vm.detailsTabActive\"><span ng-bind=\"vm.currentContent.mailing_template.name\" \nng-if=\"vm.currentContent.mailing_template.name\"></span><div layout=\"row\"><strong class=\"mh-10\" \nng-if=\"vm.isSent(vm.currentContent) || vm.currentContent.scheduled_at\" hide-xs>·</strong> <span \nng-if=\"vm.isSent(vm.currentContent)\">Sent on</span> <span ng-if=\"vm.isSent(vm.currentContent)\" class=\"ml-10\" \nng-bind=\"vm.getDateFormat(vm.currentContent.sent_at)\"></span></div></div><div class=\"font-size-16\" layout=\"column\" \nlayout-gt-xs=\"row\" layout-gt-md=\"column\" layout-align=\"center start \" layout-align-gt-xs=\"start center \" \nlayout-align-gt-md=\"center start \" ng-if=\"vm.detailsTabActive\"><span ng-bind=\"vm.currentContent.mailing_template.name\" \nng-if=\"vm.currentContent.mailing_template.name\"></span><div layout=\"row\"><strong class=\"mh-10\" \nng-if=\"vm.isSent(vm.currentContent) || vm.currentContent.scheduled_at\" hide-gt-md hide-xs>·</strong> <span \nng-if=\"vm.isSent(vm.currentContent)\">Sent on</span> <span ng-if=\"vm.isSent(vm.currentContent)\" class=\"ml-10\" \nng-bind=\"vm.getDateFormat(vm.currentContent.sent_at)\"></span></div></div></div><div flex=\"100\" hide show-gt-md \nng-if=\"vm.detailsTabActive\" ms-scroll=\"vm.msScrollOptions\" \nclass=\"scrollable p-absolute width-percent-100 height-percent-100\"><div layout=\"column\" class=\"pb-100 pt-20\"><div \nlayout=\"row\" layout-align=\"center center\" class=\"mb-20\" hide><md-button class=\"md-icon-button\" type=\"button\" \naria-label=\"Circles\" ng-click=\"vm.openStatsView(\'bars\')\" ng-class=\"{\'md-accent\':vm.currentStatsView == \'bars\'}\">\n<md-icon md-font-icon=\"icon-chart-bar\" class=\"\"></md-icon></md-button><div class=\"divider-vertical\"></div><md-button \nclass=\"md-icon-button\" type=\"button\" aria-label=\"Circles\" ng-click=\"vm.openStatsView(\'circles\')\" \nng-class=\"{\'md-accent\':vm.currentStatsView == \'circles\'}\"><md-icon md-font-icon=\"icon-source-fork\" class=\"\"></md-icon>\n</md-button></div><div ng-if=\"vm.currentStatsView == \'circles\'\" hide><div class=\"text-center grey-fg\" \ntranslate=\"MAILING.MOUSE_OVER_EXPLAIN\" hide show-gt-xs>Mouse over the circles for more info</div><div \nclass=\"text-center grey-fg\" translate=\"MAILING.CLICK_EXPLAIN\" hide-gt-xs>Click on the circles for more info</div><div \nlayout=\"column\" class=\"circles-container\"><div layout=\"column\" layout-align=\"center start\" layout-gt-sm=\"row\" \nlayout-wrap class=\"pt-20 pb-20\"><div class=\"p-relative\"><h3 class=\"text-center donut-title\"><strong \ntranslate=\"MAILING.TOTAL\"></strong></h3><nvd3 options=\"vm.statsCharts.options.donut_total\" \ndata=\"vm.statsCharts.data.donut_total\"></nvd3><md-tooltip md-autohide=\"true\" md-direction=\"top\" \nstyle=\"height: auto !important\"><div class=\"font-size-14 pv-5\">The total count of emails that willbe queued<br>\nfor sending before any processing is done.</div></md-tooltip></div><div class=\"p-relative\"><h3 \nclass=\"text-center donut-title\"><strong translate=\"MAILING.SENT_STAT\"></strong></h3><nvd3 \noptions=\"vm.statsCharts.options.donut_sent\" data=\"vm.statsCharts.data.donut_sent\"></nvd3><md-tooltip \nmd-autohide=\"true\" md-direction=\"top\" style=\"height: auto !important\"><div class=\"font-size-14 pv-5\">\nA sent status means that we\'ve handed the email over to Amazon<br>\nand now it\'s up to them to evaluate whether they can send it or not.<br>Tests are not taken account in this statistic.\n</div></md-tooltip></div></div><div layout=\"row\" layout-align=\"start start\" layout-align-gt-md=\"center start\" \nlayout-wrap class=\"pt-20 top-h-line\"><div class=\"p-relative\"><h3 class=\"text-center donut-title\"><strong \ntranslate=\"MAILING.DELIVERED\"></strong></h3><nvd3 options=\"vm.statsCharts.options.donut_delivered\" \ndata=\"vm.statsCharts.data.donut_delivered\"></nvd3><md-tooltip md-autohide=\"true\" md-direction=\"top\" \nstyle=\"height: auto !important\"><div class=\"font-size-14 pv-5\">\nA message is marked as delivered when Amazon successfully contacts the<br>\ndestination mail server and it in turn accepts the email. This does not mean that the user<br>\nhas received it as there are many reasons why a mail server will accept an email but not deliver it.<br>\nSome of these include, but are not limited to:</div><div class=\"font-size-14 pv-5\">\n- The receiving mail server find a virus or marks it as SPAM.</div><div class=\"font-size-14 pv-5\">\n- The user has a full mailbox.</div><div class=\"font-size-14 pv-5\">\n- The user has configured an out-of-office responder.</div><div class=\"font-size-14 pv-5\">\nTests are not taken account in this statistic.</div></md-tooltip></div></div><div layout=\"row\" \nlayout-align=\"center start\" layout-align-gt-sm=\"start start\" layout-align-gt-md=\"center start\"><div layout=\"column\" \nlayout-align=\"center start\" layout-gt-sm=\"row\" layout-wrap class=\"pt-10 pb-40\"><div class=\"mh-5 p-relative\"><h3 \nclass=\"text-center donut-title\"><strong translate=\"MAILING.OPEN\"></strong></h3><nvd3 \noptions=\"vm.statsCharts.options.donut_opened\" data=\"vm.statsCharts.data.donut_opened\"></nvd3><md-tooltip \nmd-autohide=\"true\" md-direction=\"top\" style=\"height: auto !important\"><div class=\"font-size-14 pv-5\">\nEmails are marked as open when an invisible 1x1 tracking pixel is displayed<br>\nto the user by the email client usually when the user attempts to open an email message.<br>\nSome email clients like Gmail do not show inline images unless specifically asked to do so by the user.<br><br>\nIn cases like this, the user will open the email but the tracking pixel will not trigger so the open<br><br>\ncount will be a little lower than the real count of users who have actually opened the email.<br><br>\nTests are not taken account in this statistic.</div></md-tooltip></div><div class=\"mh-5 p-relative\"><h3 \nclass=\"text-center donut-title\"><strong translate=\"MAILING.CLICK\">Clicked</strong></h3><nvd3 \noptions=\"vm.statsCharts.options.donut_clicked\" data=\"vm.statsCharts.data.donut_clicked\"></nvd3><md-tooltip \nmd-autohide=\"true\" md-direction=\"top\" style=\"height: auto !important\"><div class=\"font-size-14 pv-5\">\nThe amount of users who clicked on a link. If a user clicks on a link multiple times, each click<br>\nis individually tracked and aggregated into this result. Click tracks are tracked up to 60 days after<br>\nan email is sent. Tests are not taken account in this statistic.</div></md-tooltip></div><div class=\"mh-5 p-relative\">\n<h3 class=\"text-center donut-title\"><strong translate=\"MAILING.COMPLAINED\"></strong></h3><nvd3 \noptions=\"vm.statsCharts.options.donut_complained\" data=\"vm.statsCharts.data.donut_complained\"></nvd3><md-tooltip \nmd-autohide=\"true\" md-direction=\"top\" style=\"height: auto !important\"><div class=\"font-size-14 pv-5\">\nSome email providers have a mechanism to report when a user marks a particular email as spam or<br>\nthat it contains a virus that Amazon didn\'t detect as it was sending it. These reports count<br>\ntowards the complained count. Tests are not taken account in this statistic but as a general<br>\nrule it is not recommended to mark an email as SPAM just to see if this works. Marking an email<br>\nas SPAM will trigger different mechanisms, some of which have consequences that cannot be<br>\neasily undone. Your overall complain rate should be below 0.1% or your account might be at risk<br>of being suspended.\n</div></md-tooltip></div></div></div><div layout=\"row\" layout-align=\"start start\" layout-align-gt-md=\"center start\" \nlayout-wrap class=\"pt-20 top-h-line\"><div class=\"p-relative\"><h3 class=\"text-center donut-title\"><strong \ntranslate=\"MAILING.NOT_DELIVERED\"></strong></h3><nvd3 options=\"vm.statsCharts.options.donut_not_delivered\" \ndata=\"vm.statsCharts.data.donut_not_delivered\"></nvd3></div></div><div layout=\"column\" layout-align=\"center center\" \nlayout-wrap class=\"pt-10\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"mh-5 p-relative\"><h3 \nclass=\"text-center donut-title\"><strong translate=\"MAILING.BOUNCED\"></strong></h3><nvd3 \noptions=\"vm.statsCharts.options.donut_bounced\" data=\"vm.statsCharts.data.donut_bounced\"></nvd3><md-tooltip \nmd-autohide=\"true\" md-direction=\"top\" style=\"height: auto !important\"><div class=\"font-size-14 pv-5\">\nThese are messages that were delivered to the destination mail servers but bounced back because<br>\nof a transient reason (also known as soft bounces). Depending on the type of bounce, Amazon<br>\nwill attempt to re-send these up to three times in a reasonable time interval. Reasons an email<br>\nmay soft-bounce is because a mailbox may be full, or the user configured an out-of-office<br>\nresponse, or a temporary delivery problem in the receiving end. Your bounce rate should be<br>\nbelow 5% or your account might be at risk of being suspended. Tests are not taken account in<br>this statistic.</div>\n</md-tooltip></div><div class=\"mh-5 p-relative\"><h3 class=\"text-center donut-title\"><strong \ntranslate=\"MAILING.REJECTED\"></strong></h3><nvd3 options=\"vm.statsCharts.options.donut_rejected\" \ndata=\"vm.statsCharts.data.donut_rejected\"></nvd3><md-tooltip md-autohide=\"true\" md-direction=\"top\" \nstyle=\"height: auto !important\"><div class=\"font-size-14 pv-5\">\nRejections happen because of two reasons. The first one being that Amazon detected a virus on<br>\nthe email contents and rejected if before even sending it.<br>\nThe second one is that Amazon rejected the email because the address was invalid.</div></md-tooltip></div></div><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"mh-5 p-relative\"><h3 class=\"text-center donut-title\">\n<strong translate=\"MAILING.SUPPRESSED\"></strong></h3><nvd3 options=\"vm.statsCharts.options.donut_suppressed\" \ndata=\"vm.statsCharts.data.donut_suppressed\"></nvd3><md-tooltip md-autohide=\"true\" md-direction=\"top\" \nstyle=\"height: auto !important\"><div class=\"font-size-14 pv-5\">\nThese are emails that Amazon has already marked as having had hard bounces previously. Qiu<br>\nsystem will automatically ignore suppressed email addresses even if you attempt to send<br>\nmessages to them. Tests are not taken account in this statistic.</div></md-tooltip></div><div class=\"mh-5 p-relative\">\n<h3 class=\"text-center donut-title\"><strong translate=\"MAILING.PROCESSING\"></strong></h3><nvd3 \noptions=\"vm.statsCharts.options.donut_not_delivered_processing\" \ndata=\"vm.statsCharts.data.donut_not_delivered_processing\"></nvd3><md-tooltip md-autohide=\"true\" md-direction=\"top\" \nstyle=\"height: auto !important\"><div class=\"font-size-14 pv-5\">\nThese are emails that the system has not yet received any response from its servers.<br>\nAfter a while this number will reach zero and all these emails will be correctly marked.</div></md-tooltip></div></div>\n</div><div layout=\"row\" layout-align=\"center start\" layout-wrap class=\"pt-20 mt-20 pb-50 top-h-line\"><div \nclass=\"p-relative\"><h3 class=\"text-center donut-title\"><strong translate=\"MAILING.BLACKLISTED\"></strong></h3><nvd3 \noptions=\"vm.statsCharts.options.donut_blacklisted\" data=\"vm.statsCharts.data.donut_blacklisted\"></nvd3><md-tooltip \nmd-autohide=\"true\" md-direction=\"top\" style=\"height: auto !important\"><div class=\"font-size-14 pv-5\">\nUnsubscribed users and hard bounced emails<br>(after 3 attempts of delivery) end up in a blacklist.<br>\nThe system won\'t send any communications to these accounts.</div></md-tooltip></div></div></div></div><div \nclass=\"mb-40\"><div layout=\"column\" hide><div layout=\"row\" layout-align=\"space-between center\" class=\"pv-20\"><div \nflex=\"50\" class=\"font-size-36 text-right pr-10\"><strong>{{vm.currentContent.total_count}}</strong></div><span \nflex=\"50\" class=\"pl-10\">Total emails in the list</span></div><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"pv-20\"><div flex=\"50\" class=\"font-size-36 text-right pr-10\"><strong>{{vm.currentContent.sent_count}}</strong>\n</div><span flex=\"50\" class=\"pl-10\">Sent to the server for delivery</span></div><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"pv-20\"><div flex=\"50\" class=\"font-size-36 text-right pr-10\"><strong>\n{{vm.currentContent.delivered_count}}</strong></div><span flex=\"50\" class=\"pl-10\">Emails delivered</span></div><div \nlayout=\"row\" layout-align=\"space-between center\" class=\"pv-20\"><div flex=\"50\" class=\"font-size-36 text-right pr-10\">\n<strong>{{vm.currentContent.open_count}}</strong></div><span flex=\"50\" class=\"pl-10\">Opened emails</span></div><div \nlayout=\"row\" layout-align=\"space-between center\" class=\"pv-20\"><div flex=\"50\" class=\"font-size-36 text-right pr-10\">\n<strong>{{vm.currentContent.clicked_count}}</strong></div><span flex=\"50\" class=\"pl-10\">Clicked emails</span></div><div\n layout=\"row\" layout-align=\"space-between center\" class=\"pv-20\"><div flex=\"50\" class=\"font-size-36 text-right pr-10\">\n<strong>{{vm.currentContent.not_delivered_count}}</strong></div><span flex=\"50\" class=\"pl-10\">Emails not delivered\n</span></div><div layout=\"row\" layout-align=\"space-between center\" class=\"pv-20\"><div flex=\"50\" \nclass=\"font-size-36 text-right pr-10\"><strong>{{vm.currentContent.blacklisted_count}}</strong></div><span flex=\"50\" \nclass=\"pl-10\">Ignored emails due to blacklisted status</span></div></div><nvd3 \noptions=\"vm.statsCharts.options.all_vertical\" data=\"vm.statsCharts.data.all\" class=\"bars-graph\" layout=\"row\" \nlayout-align=\"center center\"></nvd3></div></div></div>");
$templateCache.put("app/main/apps/mailing/views/content/read/content-read-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-if=\"vm.loadingReadPane\" class=\"loading-container\" \nstyle=\"z-index: 2\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nng-if=\"!vm.templateSelected\"><div class=\"mail-content\" layout=\"column\" layout-align=\"center center\" \nng-if=\"!vm.loadTemplates\"><div class=\"content\" layout=\"column\" layout-align=\"top center\"><div class=\"message\" \ntranslate=\"MAILING.SELECT_ITEM_TO_SHOW\"></div></div></div><div \nclass=\"md-toolbar-tools grey-100-bg colored-bg border-bottom\" layout=\"row\" layout-align=\"space-between center\" \nscroll=\"\" ng-if=\"vm.loadTemplates\"><div layout=\"row\" layout-align=\"start center\"><h3 class=\"grey-700-fg pl-10\" \ntranslate=\"MAILING.SELECT_TEMPLATE\"></h3></div><div layout=\"row\" layout-align=\"end center\"><button \nclass=\"md-raised md-warn md-button md-default-theme\" type=\"button\" ng-click=\"vm.disableTemplates()\" \naria-label=\"Cancel\" translate=\"CONTENT.CANCEL\">Cancel</button></div></div><div flex layout=\"row\" \nlayout-align=\"start center\" class=\"search\" ng-if=\"vm.loadTemplates\"><label for=\"ms-search-bar-input\"><md-icon \nid=\"ms-search-bar-expander\" md-font-icon=\"icon-magnify\" class=\"md-icon-button md-button\"></md-icon></label><input \nid=\"ms-search-bar-input\" type=\"text\" ng-model=\"vm.query\" placeholder=\"Search\" md-autofocus translate \ntranslate-attr-placeholder=\"TOOLBAR.SEARCH\" flex ng-enter=\"\"></div><md-list id=\"list-content-data\" \nng-style=\"{\'opacity\' : isLoading ? 0.2 : 1}\" ng-if=\"vm.loadTemplates\" class=\"pv-0 scrollable templates-list\" \nms-scroll=\"vm.msScrollOptions\"><md-list-item class=\"mail-list-item border-bottom\" \nng-repeat=\"thread in vm.templates | filter: vm.search | filter: vm.query\" ng-init=\"parentIndex= $index\" md-no-ink \nng-class=\"{\'starred\': thread.starred}\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><div \nclass=\"font-size-16\" flex layout=\"column\"><div class=\"mb-5\" layout=\"row\" layout-align=\"start center\"><strong>\n{{thread.name}}</strong></div><div class=\"font-size-12\" layout=\"row\" layout-align=\"start start\"><span \nclass=\"title grey-500-fg mr-5\" translate=\"MAILING.FROM\" hide show-gt-sm></span><div layout-sm=\"column\" \nlayout-xs=\"column\"><span ng-bind=\"thread.from_name\" class=\"mr-5\"></span> <span hide show-gt-sm class=\"mr-5\">-</span> \n<span ng-bind=\"thread.from_email\"></span></div></div></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.previewTemplate($event, thread)\"><md-icon md-font-icon=\"icon-eye\"><md-tooltip hide \nshow-gt-xs><span translate=\"MAILING.PREVIEW\"></span></md-tooltip></md-icon></md-button><md-button hide show-gt-xs \naria-label=\"MAILING.SELECT\" class=\"white-fg md-small green-500-bg mh-0\" ng-click=\"vm.openTemplate(thread, true)\"><span \ntranslate=\"MAILING.SELECT\"></span></md-button><md-button hide-gt-xs aria-label=\"MAILING.SELECT\" \nclass=\"md-icon-button md-mini md-fab green-500-bg\" ng-click=\"vm.openTemplate(thread, true)\"><md-icon \nmd-font-icon=\"icon-check\"></md-icon></md-button></div></div></md-list-item></md-list></div><div \nng-if=\"vm.templateSelected\" class=\"form-wrapper\"><form name=\"vm.basicForm\" class=\"md-inline-form\" novalidate><div \nclass=\"toolbar grey-100-bg colored-bg\" layout=\"row\" layout-align=\"space-between center\" scroll=\"\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button close-thread\" aria-label=\"Back\" \nng-click=\"vm.closeTemplate()\" translate translate-attr-aria-label=\"CONTENT.BACK\" ng-if=\"vm.currentView !== \'split\'\">\n<md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><md-button ng-if=\"vm.isSent(vm.currentContent)\" \naria-label=\"Stats\" class=\"md-icon-button\" \nng-class=\"{\'md-accent\':vm.currentContentView == \'stats\' || vm.isSent(vm.currentContent) && vm.currentContentView != \'send\'}\" \nng-click=\"vm.openContentView(\'stats\');\" translate=\"\" translate-attr-aria-label=\"MAILING.STATS\"><md-icon \nmd-font-icon=\"icon-chart-line\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"MAILING.STATS\"></span>\n</md-tooltip></md-button><md-button aria-label=\"Content\" class=\"md-icon-button\" \nng-class=\"{\'md-accent\':vm.currentContentView == \'content\'}\" ng-click=\"vm.openContentView(\'content\')\" translate=\"\" \ntranslate-attr-aria-label=\"MAILING.CONTENT\" ng-if=\"!vm.isSent(vm.currentContent)\"><md-icon md-font-icon=\"icon-pencil\">\n</md-icon><md-tooltip hide show-gt-xs><span translate=\"MAILING.EDIT\"></span></md-tooltip></md-button><div \nclass=\"divider-vertical\" hide show-gt-sm></div><md-button aria-label=\"Send\" class=\"md-icon-button\" \nng-click=\"vm.openPreview(); vm.tabSelected= \'null\';\" translate=\"\" translate-attr-aria-label=\"MAILING.PREVIEW\" \nng-disabled=\"!vm.currentContent.structure_mjml\"><md-icon md-font-icon=\"icon-web\"></md-icon><md-tooltip hide show-gt-xs>\n<span translate=\"MAILING.PREVIEW\"></span></md-tooltip></md-button><div class=\"divider-vertical\" hide show-gt-sm \nng-if=\"vm.mailingPreviewUrl\"></div><md-button aria-label=\"Send\" class=\"md-icon-button\" \nng-click=\"vm.openExternalPreview(); vm.tabSelected= \'null\';\" translate=\"\" translate-attr-aria-label=\"MAILING.PREVIEW\" \nng-disabled=\"!vm.currentContent.structure_mjml\" ng-if=\"vm.mailingPreviewUrl\"><md-icon md-font-icon=\"icon-link\">\n</md-icon><md-tooltip hide show-gt-xs><span translate=\"MAILING.PUBLIC_PREVIEW\"></span></md-tooltip></md-button><div \nclass=\"divider-vertical\" hide show-gt-sm></div><md-button aria-label=\"Send\" class=\"md-icon-button\" \nng-class=\"{\'md-accent\':vm.currentContentView == \'send\'}\" \nng-click=\"vm.openContentView(\'send\'); vm.tabSelected= \'null\';\" translate=\"\" translate-attr-aria-label=\"MAILING.SEND\" \nng-disabled=\"vm.basicForm.$dirty || !vm.currentContent.unique_id\" aria-disabled=\"true\" \ntranslate-attr-aria-disabled=\"MAILING-SAVE_BEFORE\"><md-icon md-font-icon=\"icon-telegram\"><md-tooltip hide show-gt-xs \nng-if=\"vm.basicForm.$dirty\"><span translate=\"MAILING.SEND_ALERT\"></span></md-tooltip></md-icon><md-tooltip hide \nshow-gt-xs><span translate=\"MAILING.SEND\"></span></md-tooltip></md-button><div class=\"divider-vertical\" hide \nshow-gt-sm></div><md-button aria-label=\"Send\" class=\"md-icon-button\" \nng-click=\"vm.openExternalPDF(); vm.tabSelected= \'null\';\" translate=\"\" translate-attr-aria-label=\"MAILING.PDF_FILE\" \nng-disabled=\"!vm.currentContent.structure_mjml || vm.isLoadingPDF\" ng-if=\"vm.mailingPreviewUrl\"><md-icon \nmd-font-icon=\"icon-file-pdf-box\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"MAILING.PDF_FILE\"></span>\n</md-tooltip></md-button></div><div ng-if=\"vm.detailsTabActive\" layout=\"row\" layout-align=\"end center\"><button \nclass=\"mr-15\" ng-click=\"vm.onTabSelected(\'graphs\'); vm.detailsTabActive= false; vm.selectedIndex= 0;\" md-chip-remove>\n<md-icon md-font-icon=\"icon-close\"></md-icon></button></div><div layout=\"row\" layout-align=\"end center\" hide \nshow-gt-sm \nng-if=\"!vm.isSent(vm.currentContent) && (vm.currentContentView == \'content\' || vm.currentContentView == \'send\')\">\n<md-button ng-click=\"vm.saveContent()\" class=\"send-button md-accent md-raised\" aria-label=\"SAVE\" \ntranslate=\"MAILING.SAVE\" translate-attr-aria-label=\"MAILING.SAVE\"></md-button><md-button type=\"button\" \nng-click=\"vm.closeTemplate()\" class=\"md-raised md-warn\" aria-label=\"Cancel\" translate=\"MAILING.CANCEL\" \ntranslate-attr-aria-label=\"MAILING.CANCEL\"></md-button></div><div layout=\"row\" layout-align=\"end center\" hide-gt-sm \nng-if=\"!vm.isSent(vm.currentContent) && (vm.currentContentView == \'content\' || vm.currentContentView == \'send\')\">\n<md-button ng-click=\"vm.saveContent()\" class=\"md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme\" \naria-label=\"SAVE\"><md-icon md-font-icon=\"icon-check\"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate=\"MAILINT.SAVE\"></span></md-tooltip></md-button><md-button type=\"button\" ng-click=\"vm.closeTemplate()\" \nclass=\"md-warn md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme\" aria-label=\"Cancel\"><md-icon \nmd-font-icon=\"icon-window-close\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"MAILING.CANCEL\"></span>\n</md-tooltip></md-button></div></div><div id=\"content-stats\" ms-scroll=\"vm.msScrollOptions\" \nclass=\"scrollable page-layout simple fullwidth mail-content content-edit content-send\" layout=\"column\" \nng-if=\"vm.currentContentView == \'stats\' || vm.isSent(vm.currentContent) && vm.currentContentView != \'send\'\"><div \nclass=\"form-wrapper\" flex=\"100\"><div hide-gt-md \nng-include=\"\'app/main/apps/mailing/views/content/read/content-read-info.html\'\"></div><md-menu-bar class=\"pr-0 pl-0\" \nid=\"log-menu\" ng-if=\"vm.detailsTabActive==true\"><md-menu><md-button class=\"menu-button-custom md-icon-button\" \naria-label=\"Actions\" ng-click=\"$mdMenu.open($event)\" layout=\"row\" layout-align=\"center center\"><md-icon \nmd-font-icon=\"icon-cog\"></md-icon></md-button><md-menu-content><md-menu-item><md-button aria-label=\"EXPORTALL\" \nng-click=\"vm.exportMailingLogByMailingContentId(vm.currentContent.id_mailing_content)\"><md-icon \nmd-font-icon=\"icon-cloud-download\"></md-icon><span translate=\"MAILING.DOWNLOAD_LIST\">DOWNLOAD LIST</span></md-button>\n</md-menu-item><md-menu-item><md-button aria-label=\"ISOLATE ALL BOUNCES\" \nng-click=\"vm.isolateBounces(vm.currentContent.id_mailing_content)\"><md-icon md-font-icon=\"icon-folder-remove\">\n</md-icon><span translate=\"MAILING.ISOLATE_ALL_BOUNCES\">MOVE ALL BOUNCES</span></md-button></md-menu-item>\n<md-menu-item><md-button aria-label=\"ISOLATE HARD BOUNCES\" \nng-click=\"vm.isolateBounces(vm.currentContent.id_mailing_content, \'permanent\')\"><md-icon \nmd-font-icon=\"icon-folder-remove\"></md-icon><span translate=\"MAILING.ISOLATE_HARD_BOUNCES\">MOVE HARD BOUNCES</span>\n</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><md-tabs md-selected=\"vm.selectedIndex\" \nmd-dynamic-height md-stretch-tabs=\"never\"><md-tab \nmd-on-select=\"vm.onTabSelected(\'graphs\'); vm.detailsTabActive= false;\" label=\"{{vm.translate(\'MAILING.GRAPHS\')}}\"><div \nlayout=\"row\" ng-include=\"\'app/main/apps/mailing/views/content/read/content-tab-graphs.html\'\"></div></md-tab><md-tab \nmd-on-select=\"vm.onTabSelected(\'details\'); vm.detailsTabActive= true;\" label=\"{{vm.translate(\'MAILING.DETAILS\')}}\"><div\n layout=\"row\" ng-include=\"\'app/main/apps/mailing/views/content/read/content-tab-details.html\'\"></div></md-tab>\n</md-tabs></div></div><div id=\"content-edit\" ms-scroll=\"vm.msScrollOptions\" \nclass=\"scrollable page-layout simple fullwidth mail-content content-edit\" layout=\"column\" \nng-if=\"vm.currentContentView == \'content\' && !vm.isSent(vm.currentContent)\"><div layout=\"row\" \nng-include=\"\'app/main/apps/mailing/views/content/read/content-tab-edit.html\'\"></div></div><div id=\"content-send\" \nms-scroll=\"vm.msScrollOptions\" class=\"scrollable page-layout simple fullwidth mail-content content-edit content-send\" \nlayout=\"column\" ng-if=\"vm.currentContentView == \'send\'\"><div class=\"form-wrapper\" flex=\"100\"><div \nclass=\"md-block ph-24 pv-20 border-bottom\" flex><h1 class=\"mb-5 mt-0\"><strong>{{vm.currentContent.subject}}</strong>\n</h1><div class=\"font-size-16\" layout=\"row\" layout-align=\"start center\"><span \nng-bind=\"vm.currentContent.mailing_template.name\" ng-if=\"vm.currentContent.mailing_template.name\"></span><div \nlayout=\"row\"><strong class=\"mh-10\" ng-if=\"vm.isSent(vm.currentContent) || vm.currentContent.scheduled_at\">·</strong> \n<span ng-if=\"vm.isSent(vm.currentContent)\">Sent on</span> <span ng-if=\"vm.isSent(vm.currentContent)\" class=\"ml-10\" \nng-bind=\"vm.getDateFormat(vm.currentContent.sent_at)\"></span> <span \nng-if=\"vm.currentContent.id_mailing_status == 2 || (vm.currentContent.id_mailing_status == 3 && vm.currentContent.scheduled_at)\">\nScheduled for</span> <span \nng-if=\"vm.currentContent.id_mailing_status == 2 || (vm.currentContent.id_mailing_status == 3 && vm.currentContent.scheduled_at)\" \nclass=\"ml-5\" ng-bind=\"vm.getDateFormat(vm.currentContent.scheduled_at)\"></span></div></div></div><md-tabs \nmd-dynamic-height><md-tab label=\"{{vm.translate(\'MAILING.SEND_TEST\')}}\"><div layout=\"row\" \nng-include=\"\'app/main/apps/mailing/views/content/read/content-tab-send-test.html\'\"></div></md-tab><md-tab \nlabel=\"{{vm.translate(\'MAILING.SEND\')}}\" ng-if=\"!vm.isSent(vm.currentContent)\"><div layout=\"row\" \nng-include=\"\'app/main/apps/mailing/views/content/read/content-tab-send.html\'\"></div></md-tab></md-tabs></div></div>\n</form></div>");
$templateCache.put("app/main/apps/mailing/views/content/read/content-tab-details.html","<div class=\"form-wrapper\" flex=\"100\"><div><div class=\"grey-100-bg border-bottom item-log toolbar-log\" hide><button \nflex class=\"status pill\" ng-click=\"vm.filter= \'\';vm.activateFilter(true)\" \nng-class=\"{\'md-accent-bg\': vm.filter=== \'\' || !vm.filter}\">{{ \'MAILING.ALL\' | translate}}</button> <button flex \nclass=\"status pill\" ng-click=\"vm.filter= \'opened\'; vm.activateFilter(true)\" \nng-class=\"{\'md-accent-bg\':vm.filter=== \'opened\'}\">{{ \'MAILING.OPEN\' | translate}}</button> <button flex \nclass=\"status pill\" ng-click=\"vm.filter= \'clicked\'; vm.activateFilter(true)\" \nng-class=\"{\'md-accent-bg\':vm.filter=== \'clicked\'}\">{{ \'MAILING.CLICK\' | translate}}</button> <button flex \nclass=\"status pill\" ng-click=\"vm.filter= \'bounced\'; vm.activateFilter(true)\" \nng-class=\"{\'md-accent-bg\':vm.filter=== \'bounced\'}\">{{ \'MAILING.BOUNCED\' | translate}}</button> <button flex \nclass=\"status pill\" ng-click=\"vm.filter= \'rejected\'; vm.activateFilter(true)\" \nng-class=\"{\'md-accent-bg\':vm.filter=== \'rejected\'}\">{{ \'MAILING.REJECTED\' | translate}}</button> <button flex \nclass=\"status pill\" ng-click=\"vm.filter= \'complained\'; vm.activateFilter(true)\" \nng-class=\"{\'md-accent-bg\':vm.filter=== \'complained\'}\">{{ \'MAILING.COMPLAINED\' | translate}}</button> <button flex \nclass=\"status pill\" ng-click=\"vm.filter= \'suppressed\'; vm.activateFilter(true)\" \nng-class=\"{\'md-accent-bg\':vm.filter=== \'suppressed\'}\">{{ \'MAILING.SUPPRESSED\' | translate}}</button> <button flex \nclass=\"status pill\" ng-click=\"vm.filter= \'unsubscribed\'; vm.activateFilter(true)\" \nng-class=\"{\'md-accent-bg\':vm.filter=== \'unsubscribed\'}\">{{ \'MAILING.UNSUBSCRIBED\' | translate}}</button></div><div \nhide-gt-xs class=\"grey-100-bg text-center toolbar-log\" layout=\"row\" layout-align=\"space-between center\"><div \nflex=\"100\" ng-style=\"{\'opacity\' : vm.isLoading ? 0.2 : 1}\" flex layout=\"row\" layout-align=\"space-between center\" \nclass=\"search-bar pv-5 mr-0\"><label for=\"search-bar-input\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"md-icon-button md-button\" ng-click=\"vm.activateFilter(true);\"><md-tooltip><span translate=\"TOOLBAR.SEARCH\">\nSearch</span></md-tooltip></md-icon></label><input id=\"search-bar-input\" type=\"text\" ng-model=\"vm.searchString\" \nplaceholder=\"Search\" md-autofocus ng-enter=\"vm.activateFilter(true)\" translate \ntranslate-attr-placeholder=\"TOOLBAR.SEARCH\" flex><md-icon md-font-icon=\"icon-close-circle\" class=\"icon s24 pt-0\" \nng-if=\"vm.searchString\" ng-click=\"vm.searchString= \'\'; vm.activateFilter(true)\"></md-icon></div></div><div \nclass=\"grey-100-bg border-bottom text-center toolbar-log\" layout=\"row\" layout-align=\"space-between center\"><div \nflex=\"40\" flex-gt-xs=\"60\" layout=\"row\" layout-align=\"start center\"><div hide show-gt-xs flex=\"45\" \nng-style=\"{\'opacity\' : vm.isLoading ? 0.2 : 1}\" flex layout=\"row\" layout-align=\"space-between center\" \nclass=\"search-bar pv-5 mr-0\"><label for=\"search-bar-input\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"md-icon-button md-button\" ng-click=\"vm.activateFilter(true);\"><md-tooltip><span translate=\"TOOLBAR.SEARCH\">\nSearch</span></md-tooltip></md-icon></label><input id=\"search-bar-input\" type=\"text\" ng-model=\"vm.searchString\" \nplaceholder=\"Search\" md-autofocus ng-enter=\"vm.activateFilter(true)\" translate \ntranslate-attr-placeholder=\"TOOLBAR.SEARCH\" flex><md-icon md-font-icon=\"icon-close-circle\" class=\"icon s24 pt-0\" \nng-if=\"vm.searchString\" ng-click=\"vm.searchString= \'\'; vm.activateFilter(true)\"></md-icon></div><md-button \nstyle=\"width: 50px\" aria-label=\"Filter by groups\" class=\"md-icon-button\" translate=\"\" \ntranslate-attr-aria-label=\"MAILING.FILTER_BY_GROUPS\"><md-icon ng-if=\"!vm.groupFiltered\" \nng-click=\"vm.openGroupsDialog()\" md-font-icon=\"icon-filter-outline\" \nclass=\"md-default-theme md-font material-icons icon-filter-multiple\" role=\"img\" aria-hidden=\"true\"><md-tooltip><span \ntranslate=\"MAILING.FILTER_BY_GROUPS\"></span></md-tooltip></md-icon><md-icon \nng-click=\"vm.groupFiltered= null; vm.activateFilter(true);\" ng-if=\"vm.groupFiltered\" \nmd-font-icon=\"icon-filter-remove-outline\" class=\"md-default-theme md-font material-icons icon-filter-remove-outline\" \nrole=\"img\" aria-hidden=\"true\"><md-tooltip><span translate=\"MAILING.REMOVE_FILTERS\"></span></md-tooltip></md-icon>\n</md-button><div flex=\"30\"></div></div><div flex=\"10\" layout=\"row\" layout-align=\"center center\"><h3 \nclass=\"grey-700-fg font-size-14 text-truncate\">{{ \'USERS.MAIL.SENT\' | translate}}</h3></div><div flex=\"10\" \nlayout=\"row\" layout-align=\"center center\"><h3 class=\"grey-700-fg font-size-14 text-truncate\">\n{{ \'USERS.MAIL.DELIVERED\' | translate}}</h3></div><div flex=\"40\" flex-gt-xs=\"20\" layout=\"row\" \nlayout-align=\"end center \"><md-select ng-model=\"vm.filters\" md-selected-text=\"vm.filterName\" class=\"status pill\" \nng-class=\"{\'md-accent-bg\': vm.filter=== \'\' || !vm.filter, \'green-700-bg\':vm.filter=== \'opened\', \'green-300-bg\':vm.filter=== \'clicked\',\'amber-bg\':vm.filter=== \'bounced\', \'green-700-bg\':vm.filter=== \'opened\', \'grey-bg\':vm.filter=== \'suppressed\', \'grey-bg\':vm.filter=== \'rejected\', \'grey-bg\':vm.filter=== \'complained\', \'brown-600-bg\':vm.filter=== \'unsubscribed\'}\">\n<md-option ng-value=\"all\" ng-click=\"vm.filter= \'\';vm.filterName= \'All\';vm.activateFilter(true)\">\n{{ \'MAILING.ALL\' | translate}}</md-option><md-option ng-value=\"opened\" \nng-click=\"vm.filter= \'opened\';vm.filterName= \'opened\'; vm.activateFilter(true)\">{{ \'MAILING.OPEN\' | translate}}\n</md-option><md-option ng-value=\"clicked\" \nng-click=\"vm.filter= \'clicked\';vm.filterName= \'clicked\';vm.activateFilter(true)\">{{ \'MAILING.CLICK\' | translate}}\n</md-option><md-option ng-value=\"bounced\" \nng-click=\"vm.filter= \'bounced\';vm.filterName= \'bounced\'; vm.activateFilter(true)\">{{ \'MAILING.BOUNCED\' | translate}}\n</md-option><md-option ng-value=\"rejected\" \nng-click=\"vm.filter= \'rejected\';vm.filterName= \'rejected\';vm.activateFilter(true)\">{{ \'MAILING.REJECTED\' | translate}}\n</md-option><md-option ng-value=\"complained\" \nng-click=\"vm.filter= \'complained\';vm.filterName= \'complained\'; vm.activateFilter(true)\">\n{{ \'MAILING.COMPLAINED\' | translate}}</md-option><md-option ng-value=\"suppressed\" \nng-click=\"vm.filter= \'suppressed\';vm.filterName= \'suppressed\';vm.activateFilter(true)\">\n{{ \'MAILING.SUPPRESSED\' | translate}}</md-option><md-option ng-value=\"unsubscribed\" \nng-click=\"vm.filter= \'unsubscribed\';vm.filterName= \'unsubscribed\'; vm.activateFilter(true)\">\n{{ \'MAILING.UNSUBSCRIBED\' | translate}}</md-option></md-select></div></div><md-list class=\"pt-0\" \nng-style=\"{\'opacity\' : vm.loadingReadPane ? 0.2 : 1}\"><md-list-item class=\"border-bottom text-center item-log\" \nstyle=\"padding-left: 0px!important; padding-right: 0px!important\" ng-repeat=\"log in vm.logs | filter: vm.searchEmails\">\n<div ng-click=\"vm.selectUser(log.email)\" class=\"text-left word-break-word pl-20\" flex=\"40\" flex-gt-xs=\"60\" \nng-bind=\"log.email\"></div><div flex=\"10\" layout=\"row\" layout-align=\"center center\"><md-icon ng-if=\"log.sent_at\" \nmd-font-icon=\"icon-checkbox-marked-circle green-fg\" class=\"s24\"><md-tooltip md-autohide=\"true\">\n{{vm.getDateFormat(log.sent_at)}}</md-tooltip></md-icon><md-icon ng-if=\"!log.sent_at\" \nmd-font-icon=\"icon-window-close red-fg\" class=\"s24\"></md-icon></div><div flex=\"10\" layout=\"row\" \nlayout-align=\"center center\"><md-icon ng-if=\"log.delivered_at\" md-font-icon=\"icon-checkbox-marked-circle green-fg\" \nclass=\"s24\"><md-tooltip md-autohide=\"true\">{{vm.getDateFormat(log.delivered_at)}}</md-tooltip></md-icon><md-icon \nng-if=\"!log.delivered_at\" md-font-icon=\"icon-window-close red-fg\" class=\"s24\"></md-icon></div><div layout=\"row\" \nlayout-align=\"end center\" flex=\"40\" flex-gt-xs=\"20\" class=\"pr-20\"><div ng-if=\"log.clicked_at\" layout=\"column\" \nlayout-align=\"center center\"><button class=\"status green-300-bg pill\">{{\'USERS.MAIL.CLICKED\' | translate}}<md-tooltip \nmd-autohide=\"true\">{{vm.getDateFormat(log.clicked_at)}}</md-tooltip></button></div><div ng-if=\"log.opened_at\" \nlayout=\"column\" layout-align=\"center center\"><button class=\"status green-700-bg pill\">{{\'USERS.MAIL.OPEN\' | translate}}\n<md-tooltip md-autohide=\"true\">{{vm.getDateFormat(log.opened_at)}}</md-tooltip></button></div><div \nng-if=\"log.bounced_at && log.bounceType == \'Permanent\'\" layout=\"column\" layout-align=\"center center\"><button \nclass=\"status pill red-bg white-fg\">{{\'USERS.MAIL.HARD_BOUNCE\' | translate}}<md-tooltip md-autohide=\"true\">\n{{vm.getDateFormat(log.bounced_at)}}</md-tooltip></button></div><div \nng-if=\"log.bounced_at && log.bounceType == \'Transient\'\" layout=\"column\" layout-align=\"center center\"><button \nclass=\"status pill amber-bg white-fg\">{{\'USERS.MAIL.SOFT_BOUNCE\' | translate}}<md-tooltip md-autohide=\"true\">\n{{vm.getDateFormat(log.bounced_at)}}</md-tooltip></button></div><div \nng-if=\"log.bounced_at && log.bounceType != \'Transient\' && log.bounceType != \'Permanent\'\" layout=\"column\" \nlayout-align=\"center center\"><button class=\"status pill grey-bg white-fg\">{{\'USERS.MAIL.UNDEFINED\' | translate}}\n<md-tooltip md-autohide=\"true\">{{vm.getDateFormat(log.bounced_at)}}</md-tooltip></button></div><div \nng-if=\"log.suppressed_at\" layout=\"column\" layout-align=\"center center\"><button class=\"status pill grey-bg white-fg\">\n{{\'USERS.MAIL.SUPPRESSED\' | translate}}<md-tooltip md-autohide=\"true\">{{vm.getDateFormat(log.suppressed_at)}}\n</md-tooltip></button></div><div ng-if=\"log.rejected_at\" layout=\"column\" layout-align=\"center center\"><button \nclass=\"status pill grey-bg white-fg\">{{\'USERS.MAIL.REJECTED\' | translate}}<md-tooltip md-autohide=\"true\">\n{{vm.getDateFormat(log.rejected_at)}}</md-tooltip></button></div><div ng-if=\"log.complained_at\" layout=\"column\" \nlayout-align=\"center center\"><button class=\"status pill grey-bg white-fg\">{{\'USERS.MAIL.COMPLAINED\' | translate}}\n<md-tooltip md-autohide=\"true\">{{vm.getDateFormat(log.complained_at)}}</md-tooltip></button></div><div \nng-if=\"log.is_blacklisted\" layout=\"column\" layout-align=\"center center\"><button \nclass=\"status pill brown-600-bg white-fg\">{{\'USERS.MAIL.UNSUSCRIBED\' | translate}}</button></div></div></md-list-item>\n<div ng-if=\"!isLoading && vm.pagination_total_log_pages> vm.pagination_log_page && vm.logs.length > 0\" \nclass=\"load-more white p-30\" layout=\"row\" layout-sm=\"column\" layout-align=\"center center\" layout-wrap=\"\"><md-button \nng-click=\"vm.nextPageLog+ 1; vm.activateFilter();\" class=\"md-raised\">{{ \'GLOBAL.LOAD_MORE\' | translate}}</md-button>\n</div><div ng-if=\"vm.pagination_total_log_pages == vm.pagination_log_page\" class=\"load-more white p-30\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center center\" layout-wrap=\"\"><div class=\"message\" translate=\"MAILING.NO_MORE_LOGS\">\n</div></div></md-list></div></div>");
$templateCache.put("app/main/apps/mailing/views/content/read/content-tab-edit.html","<div class=\"form-wrapper\" flex=\"100\"><div><md-input-container class=\"md-block\" flex><label class=\"item\">Subject</label>\n<input data-ng-model=\"vm.currentContent.subject\" required></md-input-container></div><div><md-input-container \nclass=\"md-block\" flex><div class=\"item grey-500-fg\" translate=\"MAILING.TEMPLATE\"></div><div layout=\"row\" \nlayout-align=\"start center\"><div ng-bind-html=\"vm.currentContent.mailing_template.name\" class=\"mb-5 font-size-16\">\n</div><button class=\"md-icon-button md-button\" ng-click=\"vm.changeMailingTemplate()\"><md-icon \nmd-font-icon=\"icon-border-color\" class=\"s20\"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate=\"MAILING.CHANGE_TEMPLATE\"></span></md-tooltip></button></div></md-input-container></div><div \nclass=\"border-bottom\"><div class=\"md-toolbar-tools grey-100-bg border-bottom border-top\" role=\"listitem\"><h3 \nclass=\"grey-700-fg\" translate=\"MAILING.CONTENT_DESIGN\"></h3></div><md-input-container layout=\"row\" \nlayout-align=\"space-between center\" flex><div layout=\"row\" layout-align=\"start center\" flex><md-button \nng-disabled=\"!vm.currentContent.unique_id\" aria-disabled=\"true\" translate-attr-aria-disabled=\"MAILING-SAVE_BEFORE\" \nng-click=\"vm.showEdit()\" class=\"add-event-button md-fab md-warn ml-0\" aria-label=\"ADD\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></md-button><span class=\"font-size-16 grey-500-fg ml-5\" \ntranslate=\"MAILING.EDIT_DESIGN\"></span></div><div ng-if=\"vm.mailingToContent.length > 0\" layout=\"row\" \nlayout-align=\"end center\" flex><md-button ng-disabled=\"!vm.currentContent.unique_id\" aria-disabled=\"true\" \ntranslate-attr-aria-disabled=\"MAILING-SAVE_BEFORE\" ng-click=\"vm.templateToCases()\" \nclass=\"cancel-button md-accent green-500-bg md-raised\" aria-label=\"Save\"><span translate=\"MAILING.COPY_TO_CASES\" \nng-if=\"!vm.isSaving\">COPY_TO_CASES</span><div flex layout=\"column\" layout-align=\"center center\" ng-if=\"vm.isSaving\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"25\"></md-progress-circular></div></md-button><md-button \nng-if=\"vm.mailingToContentUnified\" ng-disabled=\"!vm.currentContent.unique_id\" aria-disabled=\"true\" \ntranslate-attr-aria-disabled=\"MAILING-SAVE_BEFORE\" ng-click=\"vm.templateToContentUnified()\" \nclass=\"cancel-button md-accent md-raised\" aria-label=\"Convert unified\"><span \ntranslate=\"MAILING.COPY_TO_CONTENT_UNIFIED\" ng-if=\"!vm.isSaving\">COPY_TO_CONTENT_UNIFIED</span><div flex \nlayout=\"column\" layout-align=\"center center\" ng-if=\"vm.isSaving\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"25\"></md-progress-circular></div></md-button></div></md-input-container></div></div>");
$templateCache.put("app/main/apps/mailing/views/content/read/content-tab-graphs.html","<div flex=\"100\"><div ng-if=\"vm.mailingToContent.length > 0\" layout=\"row\" layout-align=\"end center\" flex><md-button \nng-click=\"vm.templateToCases()\" class=\"cancel-button md-accent green-500-bg md-raised\" aria-label=\"Save\"><span \ntranslate=\"MAILING.COPY_TO_CASES\" ng-if=\"!vm.isSaving\">COPY_TO_CASES</span><div flex layout=\"column\" \nlayout-align=\"center center\" ng-if=\"vm.isSaving\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"25\">\n</md-progress-circular></div></md-button><md-button ng-if=\"vm.mailingToContentUnified\" \nng-click=\"vm.templateToContentUnified()\" class=\"cancel-button md-accent md-raised\" aria-label=\"Convert unified\"><span \ntranslate=\"MAILING.COPY_TO_CONTENT_UNIFIED\" ng-if=\"!vm.isSaving\">COPY_TO_CONTENT_UNIFIED</span><div flex \nlayout=\"column\" layout-align=\"center center\" ng-if=\"vm.isSaving\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"25\"></md-progress-circular></div></md-button></div><div layout=\"column\" layout-align=\"center center\" \nlayout-gt-md=\"row\" layout-align-gt-md=\"space-between start\"><div flex=\"50\" class=\"ph-20 pt-20\"><h2 class=\"text-center\">\n<strong>Sent to {{vm.currentContent.total_count}} emails</strong></h2><nvd3 class=\"pie width-percent-100\" \noptions=\"vm.statsCharts.options.sent\" data=\"vm.statsCharts.data.sent\" layout=\"row\" layout-align=\"center center\"></nvd3>\n</div><div flex=\"50\" class=\"ph-20 pt-20\" layout=\"column\" layout-align=\"center stretch\"><div class=\"mh-20 p-relative\">\n<h2 class=\"text-center\"><strong translate=\"MAILING.OPENS\">Opens</strong></h2><nvd3 class=\"pie\" \noptions=\"vm.statsCharts.options.open\" data=\"vm.statsCharts.data.open\"></nvd3></div><div class=\"mh-20 p-relative\"><h2 \nclass=\"text-center\"><strong translate=\"MAILING.CLICKS\">Clicks</strong></h2><nvd3 class=\"pie\" \noptions=\"vm.statsCharts.options.click\" data=\"vm.statsCharts.data.click\"></nvd3></div></div></div><div layout=\"column\">\n<div layout=\"row\" layout-align=\"center center\" class=\"mb-20\"><md-button class=\"md-icon-button\" type=\"button\" \naria-label=\"Circles\" ng-click=\"vm.openStatsView(\'bars\')\" ng-class=\"{\'md-accent\':vm.currentStatsView == \'bars\'}\">\n<md-icon md-font-icon=\"icon-chart-bar\" class=\"\"></md-icon></md-button><div class=\"divider-vertical\"></div><md-button \nclass=\"md-icon-button\" type=\"button\" aria-label=\"Circles\" ng-click=\"vm.openStatsView(\'circles\')\" \nng-class=\"{\'md-accent\':vm.currentStatsView == \'circles\'}\"><md-icon md-font-icon=\"icon-source-fork\" class=\"\"></md-icon>\n</md-button></div><div ng-if=\"vm.currentStatsView == \'circles\'\"><div class=\"text-center grey-fg\" \ntranslate=\"MAILING.MOUSE_OVER_EXPLAIN\" hide show-gt-xs>Mouse over the circles for more info</div><div \nclass=\"text-center grey-fg\" translate=\"MAILING.CLICK_EXPLAIN\" hide-gt-xs>Click on the circles for more info</div><div \nlayout=\"column\" class=\"circles-container\"><div layout=\"row\" layout-align=\"center start\" layout-wrap class=\"pt-20\"><div \nclass=\"p-relative\"><h3 class=\"text-center donut-title\"><strong translate=\"MAILING.TOTAL\"></strong></h3><nvd3 \noptions=\"vm.statsCharts.options.donut_total\" data=\"vm.statsCharts.data.donut_total\"></nvd3><md-tooltip \nmd-autohide=\"true\" md-direction=\"top\" style=\"height: auto !important\"><div class=\"font-size-14 pv-5\">\nThe total count of emails that willbe queued<br>for sending before any processing is done.</div></md-tooltip></div>\n</div><div layout=\"row\" layout-align=\"center start\" layout-wrap class=\"pt-20\"><div class=\"p-relative diag-left\"><h3 \nclass=\"text-center donut-title\"><strong translate=\"MAILING.SENT_STAT\"></strong></h3><nvd3 \noptions=\"vm.statsCharts.options.donut_sent\" data=\"vm.statsCharts.data.donut_sent\"></nvd3><md-tooltip \nmd-autohide=\"true\" md-direction=\"top\" style=\"height: auto !important\"><div class=\"font-size-14 pv-5\">\nA sent status means that we\'ve handed the email over to Amazon<br>\nand now it\'s up to them to evaluate whether they can send it or not.<br>Tests are not taken account in this statistic.\n</div></md-tooltip></div><div class=\"p-relative w-70\"></div><div class=\"p-relative diag-right\"><h3 \nclass=\"text-center donut-title\"><strong translate=\"MAILING.BLACKLISTED\"></strong></h3><nvd3 \noptions=\"vm.statsCharts.options.donut_blacklisted\" data=\"vm.statsCharts.data.donut_blacklisted\"></nvd3><md-tooltip \nmd-autohide=\"true\" md-direction=\"top\" style=\"height: auto !important\"><div class=\"font-size-14 pv-5\">\nUnsubscribed users and hard bounced emails<br>(after 3 attempts of delivery) end up in a blacklist.<br>\nThe system won\'t send any communications to these accounts.</div></md-tooltip></div></div><div layout=\"row\" \nlayout-align=\"start start\" layout-align-gt-md=\"center start\" layout-wrap class=\"pt-20\"><div \nclass=\"p-relative diag-left bottom-line long-line\"><h3 class=\"text-center donut-title\"><strong \ntranslate=\"MAILING.DELIVERED\"></strong></h3><nvd3 options=\"vm.statsCharts.options.donut_delivered\" \ndata=\"vm.statsCharts.data.donut_delivered\"></nvd3><md-tooltip md-autohide=\"true\" md-direction=\"top\" \nstyle=\"height: auto !important\"><div class=\"font-size-14 pv-5\">\nA message is marked as delivered when Amazon successfully contacts the<br>\ndestination mail server and it in turn accepts the email. This does not mean that the user<br>\nhas received it as there are many reasons why a mail server will accept an email but not deliver it.<br>\nSome of these include, but are not limited to:</div><div class=\"font-size-14 pv-5\">\n- The receiving mail server find a virus or marks it as SPAM.</div><div class=\"font-size-14 pv-5\">\n- The user has a full mailbox.</div><div class=\"font-size-14 pv-5\">\n- The user has configured an out-of-office responder.</div><div class=\"font-size-14 pv-5\">\nTests are not taken account in this statistic.</div></md-tooltip></div><div class=\"p-relative w-70\"></div><div \nclass=\"p-relative diag-right bottom-line\"><h3 class=\"text-center donut-title\"><strong \ntranslate=\"MAILING.NOT_DELIVERED\"></strong></h3><nvd3 options=\"vm.statsCharts.options.donut_not_delivered\" \ndata=\"vm.statsCharts.data.donut_not_delivered\"></nvd3></div><div class=\"p-relative w-220\"></div></div><div \nlayout=\"row\" layout-align=\"center start\" layout-align-gt-sm=\"start start\" layout-align-gt-md=\"center start\"><div \nlayout=\"column\" layout-align=\"center start\" layout-wrap class=\"pt-20 pb-40\"><div class=\"mh-5 p-relative\"><h3 \nclass=\"text-center donut-title\"><strong translate=\"MAILING.OPEN\"></strong></h3><nvd3 \noptions=\"vm.statsCharts.options.donut_opened\" data=\"vm.statsCharts.data.donut_opened\"></nvd3><md-tooltip \nmd-autohide=\"true\" md-direction=\"top\" style=\"height: auto !important\"><div class=\"font-size-14 pv-5\">\nEmails are marked as open when an invisible 1x1 tracking pixel is displayed<br>\nto the user by the email client usually when the user attempts to open an email message.<br>\nSome email clients like Gmail do not show inline images unless specifically asked to do so by the user.<br><br>\nIn cases like this, the user will open the email but the tracking pixel will not trigger so the open<br><br>\ncount will be a little lower than the real count of users who have actually opened the email.<br><br>\nTests are not taken account in this statistic.</div></md-tooltip></div><div class=\"mh-5 p-relative\"><h3 \nclass=\"text-center donut-title\"><strong translate=\"MAILING.CLICK\">Clicked</strong></h3><nvd3 \noptions=\"vm.statsCharts.options.donut_clicked\" data=\"vm.statsCharts.data.donut_clicked\"></nvd3><md-tooltip \nmd-autohide=\"true\" md-direction=\"top\" style=\"height: auto !important\"><div class=\"font-size-14 pv-5\">\nThe amount of users who clicked on a link. If a user clicks on a link multiple times, each click<br>\nis individually tracked and aggregated into this result. Click tracks are tracked up to 60 days after<br>\nan email is sent. Tests are not taken account in this statistic.</div></md-tooltip></div><div \nclass=\"mh-5 p-relative top-h-line mt-10 pt-10\"><h3 class=\"text-center donut-title\"><strong \ntranslate=\"MAILING.COMPLAINED\"></strong></h3><nvd3 options=\"vm.statsCharts.options.donut_complained\" \ndata=\"vm.statsCharts.data.donut_complained\"></nvd3><md-tooltip md-autohide=\"true\" md-direction=\"top\" \nstyle=\"height: auto !important\"><div class=\"font-size-14 pv-5\">\nSome email providers have a mechanism to report when a user marks a particular email as spam or<br>\nthat it contains a virus that Amazon didn\'t detect as it was sending it. These reports count<br>\ntowards the complained count. Tests are not taken account in this statistic but as a general<br>\nrule it is not recommended to mark an email as SPAM just to see if this works. Marking an email<br>\nas SPAM will trigger different mechanisms, some of which have consequences that cannot be<br>\neasily undone. Your overall complain rate should be below 0.1% or your account might be at risk<br>of being suspended.\n</div></md-tooltip></div></div><div class=\"w-30\"></div><div layout=\"column\" layout-align=\"center center\" layout-wrap \nclass=\"pt-20 top-h-line\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"mh-5 p-relative\"><h3 \nclass=\"text-center donut-title\"><strong translate=\"MAILING.BOUNCED\"></strong></h3><nvd3 \noptions=\"vm.statsCharts.options.donut_bounced\" data=\"vm.statsCharts.data.donut_bounced\"></nvd3><md-tooltip \nmd-autohide=\"true\" md-direction=\"top\" style=\"height: auto !important\"><div class=\"font-size-14 pv-5\">\nThese are messages that were delivered to the destination mail servers but bounced back because<br>\nof a transient reason (also known as soft bounces). Depending on the type of bounce, Amazon<br>\nwill attempt to re-send these up to three times in a reasonable time interval. Reasons an email<br>\nmay soft-bounce is because a mailbox may be full, or the user configured an out-of-office<br>\nresponse, or a temporary delivery problem in the receiving end. Your bounce rate should be<br>\nbelow 5% or your account might be at risk of being suspended. Tests are not taken account in<br>this statistic.</div>\n</md-tooltip></div><div class=\"mh-5 p-relative\"><h3 class=\"text-center donut-title\"><strong \ntranslate=\"MAILING.REJECTED\"></strong></h3><nvd3 options=\"vm.statsCharts.options.donut_rejected\" \ndata=\"vm.statsCharts.data.donut_rejected\"></nvd3><md-tooltip md-autohide=\"true\" md-direction=\"top\" \nstyle=\"height: auto !important\"><div class=\"font-size-14 pv-5\">\nRejections happen because of two reasons. The first one being that Amazon detected a virus on<br>\nthe email contents and rejected if before even sending it.<br>\nThe second one is that Amazon rejected the email because the address was invalid.</div></md-tooltip></div></div><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"mh-5 p-relative\"><h3 class=\"text-center donut-title\">\n<strong translate=\"MAILING.SUPPRESSED\"></strong></h3><nvd3 options=\"vm.statsCharts.options.donut_suppressed\" \ndata=\"vm.statsCharts.data.donut_suppressed\"></nvd3><md-tooltip md-autohide=\"true\" md-direction=\"top\" \nstyle=\"height: auto !important\"><div class=\"font-size-14 pv-5\">\nThese are emails that Amazon has already marked as having had hard bounces previously. Qiu<br>\nsystem will automatically ignore suppressed email addresses even if you attempt to send<br>\nmessages to them. Tests are not taken account in this statistic.</div></md-tooltip></div><div class=\"mh-5 p-relative\">\n<h3 class=\"text-center donut-title\"><strong translate=\"MAILING.PROCESSING\"></strong></h3><nvd3 \noptions=\"vm.statsCharts.options.donut_not_delivered_processing\" \ndata=\"vm.statsCharts.data.donut_not_delivered_processing\"></nvd3><md-tooltip md-autohide=\"true\" md-direction=\"top\" \nstyle=\"height: auto !important\"><div class=\"font-size-14 pv-5\">\nThese are emails that the system has not yet received any response from its servers.<br>\nAfter a while this number will reach zero and all these emails will be correctly marked.</div></md-tooltip></div></div>\n</div><div class=\"w-150\"></div></div></div></div><div ng-if=\"vm.currentStatsView == \'bars\'\" class=\"mb-40\"><nvd3 \noptions=\"vm.statsCharts.options.all\" data=\"vm.statsCharts.data.all\" class=\"bars-graph\" layout=\"row\" \nlayout-align=\"center center\"></nvd3></div></div></div>");
$templateCache.put("app/main/apps/mailing/views/content/read/content-tab-preview.html","");
$templateCache.put("app/main/apps/mailing/views/content/read/content-tab-send-scheduled.html","");
$templateCache.put("app/main/apps/mailing/views/content/read/content-tab-send-test.html","<div class=\"form-wrapper\" flex=\"100\"><form name=\"vm.sentTestForm\" class=\"md-inline-form\" novalidate><div><div \nclass=\"md-toolbar-tools grey-100-bg border-bottom pl-25\" role=\"listitem\"><h3 class=\"grey-700-fg ng-scope\" \ntranslate=\"MAILING.TEST_EMAILS_TEMPLATE\">Test emails</h3></div><md-input-container class=\"md-block chips\"><md-chips \nng-model=\"vm.currentContent.mailing_template.test_emails_json\" readonly=\"true\" md-removable=\"false\" \nmd-separator-keys=\"vm.keys\"></md-chips></md-input-container><div \nclass=\"md-toolbar-tools grey-100-bg border-bottom border-top pl-25\" role=\"listitem\"><h3 class=\"grey-700-fg ng-scope\" \ntranslate=\"MAILING.TEST_EMAILS_CUSTOM\">Test emails</h3></div><md-input-container class=\"md-block mb-0 chips\"><md-chips \nid=\"md-chips-email\" ng-model=\"vm.currentContent.test_emails_json\" readonly=\"false\" md-removable=\"true\" \nplaceholder=\"{{vm.translate(\'MAILING.ADD_EMAILS\')}}\" delete-button-label=\"{{vm.translate(\'MAILING.REMOVE_EMAILS\')}}\" \ndelete-hint=\"{{vm.translate(\'MAILING.DELETE_REMOVE_EMAILS\')}}\" \nsecondary-placeholder=\"{{vm.translate(\'MAILING.ADD_EMAILS\')}}\" md-enable-chip-edit=\"true\" md-separator-keys=\"vm.keys\" \nng-enter=\"validateEmail(vm.currentContent.test_emails_json)\" \nmd-transform-chip=\"addChips($chip,vm.currentContent.test_emails_json)\" ng-required=\"true\" class=\"close-chip\"><button \nmd-chip-remove class=\"md-primary\" ng-click=\"vm.testEmailsChanged = true\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</button></md-chips></md-input-container><md-input-container class=\"md-block mt-0\"><p class=\"grey-500-fg\" \nstyle=\"word-break: break-word\" translate=\"MAILING.TEST_EMAILS_COMMENT\"></p></md-input-container><md-input-container \nlayout=\"row\" layout-align=\"start center\" flex class=\"border-top\"><md-button type=\"submit\" \nng-disabled=\"vm.basicForm.$dirty || vm.testEmailsChanged || vm.testEmails.length == 0\" ng-click=\"vm.sendTest()\" \nclass=\"ml-0 no-shadow send-button md-accent md-raised md-rounded md-large\" aria-label=\"MAILING.SEND_TEST\" translate=\"\" \ntranslate-attr-aria-label=\"MAILING.SEND_TEST\" layout=\"row\" layout-align=\"start center\"><span><md-tooltip \nng-if=\"vm.basicForm.$dirty || vm.testEmailsChanged\"><span translate=\"MAILING.SEND_ALERT\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-telegram\" role=\"icon\" aria-hidden=\"true\"></md-icon><span translate=\"MAILING.SEND_TEST\"></span>\n</span></md-button></md-input-container></div></form></div>");
$templateCache.put("app/main/apps/mailing/views/content/read/content-tab-send.html","<div class=\"form-wrapper\" flex=\"100\"><form name=\"vm.sendForm\" class=\"md-inline-form\" novalidate><div><div \nclass=\"md-toolbar-tools grey-100-bg border-bottom pl-25\" role=\"listitem\"><h3 class=\"grey-700-fg ng-scope\" \ntranslate=\"MAILING.SEND_TO\">Send to</h3></div><md-input-container class=\"md-block\" flex><md-radio-group flex \nlayout=\"column\" ng-model=\"vm.currentContent.segment_group\"><strong class=\"mb-20\" \ntranslate=\"MAILING.DEFAULT_SUBSCRIPTION\"></strong><md-progress-circular ng-if=\"vm.loadingDefaultSubscriptionGroup\" \nmd-mode=\"indeterminate\" md-diameter=\"25\"></md-progress-circular><div ng-if=\"!vm.loadingDefaultSubscriptionGroup\" \nlayout=\"row\" layout-align=\"start center\"><md-radio-button \nng-value=\"vm.currentContent.mailing_template.subscription_group_object.id_group\" aria-label=\"...\" layout=\"row\" \nlayout-align=\"start center\">{{vm.currentContent.mailing_template.subscription_group_object.name}}</md-radio-button>\n<md-progress-circular ng-if=\"vm.loadingUsersCount\" md-mode=\"indeterminate\" md-diameter=\"25\" class=\"ml-10\">\n</md-progress-circular><div \nng-click=\"vm.usersInGroupDialog(vm.currentContent.mailing_template.subscription_group_object.id_group, vm.currentContent.mailing_template.subscription_group_object.name)\" \nclass=\"ml-10 status pill w-auto cursor-pointer\" \nng-if=\"vm.currentContent.mailing_template.subscription_group_object.totalUsers\">\n{{vm.currentContent.mailing_template.subscription_group_object.totalUsers}} users<md-tooltip hide show-gt-xs><span \ntranslate=\"MAILING.VIEW_USERS_LIST\"></span></md-tooltip></div></div><div layout=\"row\" layout-align=\"start center\" flex \nclass=\"pt-20\"><md-button ng-click=\"vm.changeGroupSubscriptionDialog($event)\" \nclass=\"ml-0 green-500-bg no-shadow md-accent no-shadow md-raised md-rounded\" aria-label=\"MAILING.SEGMENT\" translate=\"\" \ntranslate-attr-aria-label=\"MAILING.SEGMENT\" layout=\"row\" layout-align=\"center center\"><span \ntranslate=\"MAILING.CHANGE_SUBSCRIPTION\"></span><md-tooltip><span translate=\"MAILING.CHANGE_SUBSCRIPTION\"></span>\n</md-tooltip></md-button></div><strong class=\"mb-20 mt-30\" translate=\"MAILING.SEGMENTS\" \nng-if=\"vm.selectedContentSegmentGroups.length> 0\"></strong><md-progress-circular ng-if=\"vm.loadingSegmentsGroups\" \nmd-mode=\"indeterminate\" md-diameter=\"25\"></md-progress-circular><div ng-if=\"!vm.loadingSegmentsGroups\" \nng-repeat=\"segment in vm.selectedContentSegmentGroups\" layout=\"row\" layout-align=\"start center\"><md-radio-button \nng-if=\"vm.selectedContentSegmentGroups.length> 0 && segment.id_group != vm.currentContent.mailing_template.subscription_group_object.id_group\" \nng-value=\"segment.id_group\" aria-label=\"...\" layout=\"row\" layout-align=\"start center\">{{segment.name}}\n</md-radio-button><div ng-click=\"vm.usersInGroupDialog(segment.id_group, segment.name)\" \nclass=\"ml-10 status pill w-auto cursor-pointer\" ng-if=\"segment.totalUsers\">{{segment.totalUsers}} users<md-tooltip \nhide show-gt-xs><span translate=\"MAILING.VIEW_USERS_LIST\"></span></md-tooltip></div></div></md-radio-group><div \nlayout=\"row\" layout-align=\"start center\" flex class=\"pt-20\"><md-button ng-click=\"vm.segmentGroupDialogNew()\" \nclass=\"ml-0 green-500-bg no-shadow md-accent no-shadow md-raised md-rounded\" aria-label=\"MAILING.SEGMENT\" translate=\"\" \ntranslate-attr-aria-label=\"MAILING.SEGMENT\" layout=\"row\" layout-align=\"center center\"><md-icon \nmd-font-icon=\"icon-account-multiple-plus\" role=\"icon\" aria-hidden=\"true\" class=\"mr-10\"></md-icon><span \ntranslate=\"MAILING.CREATE_SEGMENT\"></span><md-tooltip><span translate=\"MAILING.CREATE_SEGMENT_TEXT\"></span>\n</md-tooltip></md-button></div></md-input-container><md-input-container layout=\"column\" layout-gt-xs=\"row\" \nlayout-align=\"start start\" layout-align-gt-xs=\"start center\" flex class=\"border-top\"><md-button \nng-if=\"!vm.currentContent.scheduled_at\" type=\"submit\" ng-click=\"vm.sendFull()\" \nclass=\"ml-0 mb-20 send-button md-accent no-shadow md-raised md-rounded md-large\" aria-label=\"MAILING.SEND\" \ntranslate=\"\" translate-attr-aria-label=\"MAILING.SEND_NOW\" layout=\"row\" \nlayout-align=\"start\r\n                    center\" \nng-disabled=\"vm.basicForm.$dirty ||\r\n                    vm.currentContent.id_mailing_status> 1 || \r\n                    vm.loadingSegmentsGroups ||\r\n                    vm.loadingDefaultSubscriptionGroup\">\n<span><md-tooltip ng-if=\"vm.basicForm.$dirty\"><span translate=\"MAILING.SEND_ALERT\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-telegram\" role=\"icon\" aria-hidden=\"true\"></md-icon><span translate=\"MAILING.SEND_NOW\" \nng-if=\"vm.currentContent.id_mailing_status == 1\"></span> <span translate=\"MAILING.STATUSES.PROCESSING\" \nng-if=\"vm.currentContent.id_mailing_status == 3\"></span> <span translate=\"MAILING.STATUSES.SENDING\" \nng-if=\"vm.currentContent.id_mailing_status == 4\"></span></span></md-button><md-button \nng-if=\"!vm.currentContent.scheduled_at && vm.currentContent.id_mailing_status == 1\" type=\"submit\" \nng-click=\"vm.sendLaterDialog()\" class=\"border ml-0 mb-20 send-button no-shadow md-accent md-link md-rounded md-large\" \naria-label=\"MAILING.SEND_LATER\" translate=\"\" translate-attr-aria-label=\"MAILING.SEND_LATER\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-calendar-clock\" role=\"icon\" aria-hidden=\"true\"></md-icon><span \ntranslate=\"MAILING.SEND_LATER\"></span></md-button><md-button hide ng-if=\"vm.currentContent.scheduled_at\" type=\"submit\" \nng-click=\"\" class=\"ml-0 mb-20 send-button no-shadow md-raised md-warn md-rounded md-large\" \naria-label=\"MAILING.SEND_LATER\" translate=\"\" translate-attr-aria-label=\"MAILING.CANCEL\" layout=\"row\" \nlayout-align=\"start center\"><span translate=\"MAILING.CANCEL\"></span></md-button><md-button \nng-if=\"vm.currentContent.scheduled_at\" type=\"submit\" ng-click=\"vm.sendLaterDialog()\" \nclass=\"border ml-0 mb-20 send-button no-shadow md-accent md-link md-rounded md-large\" aria-label=\"MAILING.SEND_LATER\" \ntranslate=\"\" translate-attr-aria-label=\"MAILING.SEND_SCHEDULED\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-calendar-clock\" role=\"icon\" aria-hidden=\"true\"></md-icon><span translate=\"MAILING.SEND_SCHEDULED\" \nclass=\"text-capitalized mr-5\"></span> {{vm.getDateFormat(vm.currentContent.scheduled_at)}}</md-button>\n</md-input-container></div></form></div>");
$templateCache.put("app/main/apps/mailing/views/content/read/content-tab-stats.html","<div class=\"form-wrapper\" flex=\"100\"><div><div class=\"mh-25 p-15 mt-25 stats-section\" layout=\"row\" layout-sm=\"column\">\n<div flex><span><strong translate=\"MAILING.TOTAL\"></strong></span><span class=\"ml-15\" \nng-bind=\"vm.currentContent.total_count\"></span><md-icon md-font-icon=\"icon-information-outline\"><md-tooltip \nstyle=\"height: auto!important\" md-autohide=\"true\"><p>\nThe total count of emails that will be queued for sending before any processing is done.</p></md-tooltip></md-icon>\n</div><div flex><span><strong translate=\"MAILING.SENT_STAT\"></strong></span><span class=\"ml-15\" \nng-bind=\"vm.currentContent.sent_count\"></span><md-icon md-font-icon=\"icon-information-outline\"></md-icon><md-tooltip \nstyle=\"height: auto!important\" md-autohide=\"true\"><p>\nA sent status means that we\'ve handed the email over to Amazon and now it\'s up to them to evaluate whether they can send it or not.\n<br>Tests are not taken account in this statistic.</p></md-tooltip></div></div><div class=\"mh-25 p-15 stats-section\" \nlayout=\"row\" layout-sm=\"column\"><div flex><span><strong translate=\"MAILING.DELIVERED\"></strong></span><span \nclass=\"ml-15\" ng-bind=\"vm.currentContent.delivered_count\"></span><md-icon md-font-icon=\"icon-information-outline\">\n</md-icon><md-tooltip style=\"height: auto!important\" md-autohide=\"true\"><p>\nA message is marked as delivered when Amazon successfully contacts the<br>\ndestination mail server and it in turn accepts the email. This does not mean that the user<br>\nhas received it as there are many reasons why a mail server will accept an email but not deliver it.<br>\nSome of these include, but are not limited to:</p><p>- The receiving mail server find a virus or marks it as SPAM.</p>\n<p>- The user has a full mailbox.</p><p>- The user has configured an out-of-office responder.</p><p>\nTests are not taken account in this statistic.</p></md-tooltip></div><div flex><span><strong translate=\"MAILING.OPEN\">\n</strong></span><span class=\"ml-15\" ng-bind=\"vm.currentContent.open_count\"></span><md-icon \nmd-font-icon=\"icon-information-outline\"></md-icon><md-tooltip style=\"height: auto!important\" md-autohide=\"true\"><p>\nEmails are marked as open when an invisible 1x1 tracking pixel is displayed<br>\nto the user by the email client usually when the user attempts to open an email message.<br>\nSome email clients like Gmail do not show inline images unless specifically asked to do so by the user.</p><br><p>\nIn cases like this, the user will open the email but the tracking pixel will not trigger so the open<br>\ncount will be a little lower than the real count of users who have actually opened theemail.</p><p>\nTests are not taken account in this statistic.</p></md-tooltip></div></div><div class=\"mh-25 p-15 stats-section\" \nlayout=\"row\" layout-sm=\"column\"><div flex><span><strong translate=\"MAILING.CLICK\">Clicked</strong></span><span \nclass=\"ml-15\" ng-bind=\"vm.currentContent.clicked_count\"></span><md-icon md-font-icon=\"icon-information-outline\">\n</md-icon><md-tooltip style=\"height: auto!important\" md-autohide=\"true\"><p>\nThe amount of users who clicked on a link. If a user clicks on a link multiple times, each click<br>\nis individually tracked and aggregated into this result. Click tracks are tracked up to 60 days after<br>\nan email is sent. Tests are not taken account in this statistic.</p></md-tooltip></div><div flex><span><strong \ntranslate=\"MAILING.REJECTED\"></strong></span><span class=\"ml-15\" ng-bind=\"vm.currentContent.rejected_count\"></span>\n<md-icon md-font-icon=\"icon-information-outline\"></md-icon><md-tooltip style=\"height: auto!important\" \nmd-autohide=\"true\"><p>Rejections happen because of two reasons. The first one being that Amazon detected a virus on<br>\nthe email contents and rejected if before even sending it.<br>\nThe second one is that Amazon rejected the email because the address was invalid.</p></md-tooltip></div></div><div \nclass=\"mh-25 p-15 stats-section\" layout=\"row\" layout-sm=\"column\"><div flex><span><strong translate=\"MAILING.BOUNCED\">\n</strong></span><span class=\"ml-15\" ng-bind=\"vm.currentContent.bounced_count\"></span><md-icon \nmd-font-icon=\"icon-information-outline\"></md-icon><md-tooltip style=\"height: auto!important\" md-autohide=\"true\"><p>\nThese are messages that were delivered to the destination mail servers but bounced back because<br>\nof a transient reason (also known as soft bounces). Depending on the type of bounce, Amazon<br>\nwill attempt to re-send these up to three times in a reasonable time interval. Reasons an email<br>\nmay soft-bounce is because a mailbox may be full, or the user configured an out-of-office<br>\nresponse, or a temporary delivery problem in the receiving end. Your bounce rate should be<br>\nbelow 5% or your account might be at risk of being suspended. Tests are not taken account in<br>this statistic.</p>\n</md-tooltip></div><div flex><span><strong translate=\"MAILING.COMPLAINED\"></strong></span><span class=\"ml-15\" \nng-bind=\"vm.currentContent.complained_count\"></span><md-icon md-font-icon=\"icon-information-outline\"></md-icon>\n<md-tooltip style=\"height: auto!important\" md-autohide=\"true\"><p>\nSome email providers have a mechanism to report when a user marks a particular email as spam or<br>\nthat it contains a virus that Amazon didn\'t detect as it was sending it. These reports count<br>\ntowards the complained count. Tests are not taken account in this statistic but as a general<br>\nrule it is not recommended to mark an email as SPAM just to see if this works. Marking an email<br>\nas SPAM will trigger different mechanisms, some of which have consequences that cannot be<br>\neasily undone. Your overall complain rate should be below 0.1% or your account might be at risk<br>of being suspended.\n</p></md-tooltip></div></div><div class=\"mh-25 p-15 stats-section\" layout=\"row\" layout-sm=\"column\"><div flex><span>\n<strong translate=\"MAILING.SUPPRESSED\"></strong></span><span class=\"ml-15\" \nng-bind=\"vm.currentContent.suppressed_count\"></span><md-icon md-font-icon=\"icon-information-outline\"></md-icon>\n<md-tooltip style=\"height: auto!important\" style=\"height: auto!important\" md-autohide=\"true\"><p>\nThese are emails that Amazon has already marked as having had hard bounces previously. Qiu<br>\nsystem will automatically ignore suppressed email addresses even if you attempt to send<br>\nmessages to them. Tests are not taken account in this statistic.</p></md-tooltip></div></div></div></div>");
$templateCache.put("app/main/apps/mailing/views/content/read/content-tab-test-users.html","<div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><form class=\"md-inline-form\" novalidate><div class=\"sortable\">\n<md-input-container class=\"md-block\"><label class=\"item\">Test users</label><textarea ng-model=\"test\" \nmd-maxlength=\"250\" rows=\"3\" md-select-on-focus></textarea></md-input-container></div></form></div>");
$templateCache.put("app/main/apps/mailing/views/content/read/content-tab-user-groups.html","<form novalidate><div class=\"group-form\"><div ng-repeat=\"item in vm.currentLabels track by $index\" class=\"tag\" \nfxlayout=\"row\" fxlayoutalign=\"start center\"><div class=\"tag-label\">{{item.label}}<md-icon \nng-click=\"vm.deleteTarget(item.id, $index)\" md-font-icon=\"icon-close\" class=\"s24 pointer\"></md-icon></div></div></div>\n</form><form class=\"md-inline-form\" novalidate><div class=\"group-form\"><md-button \nng-click=\"vm.openUsersGroupsDialog()\" class=\"add-event-button md-fab md-warn\" aria-label=\"ADD\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button><span></span></div></form>");
$templateCache.put("app/main/apps/mailing/views/content/read/content-tab-visual-edit.html","");
$templateCache.put("app/main/apps/mailing/views/content/read/content-user-mailing.html","<div class=\"toolbar grey-100-bg colored-bg\" layout=\"row\" layout-align=\"space-between center\" scroll=\"\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button close-thread\" aria-label=\"Back\" \nng-click=\"vm.closeUser()\" translate translate-attr-aria-label=\"CONTENT.BACK\"><md-icon \nmd-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button></div><div layout=\"row\" layout-align=\"end center\"><div \nclass=\"text-left font-size-16 pr-20\" hide-gt-xs><strong>{{vm.selectedUser}}</strong></div></div></div><md-content \nstyle=\"height: calc(100% - 65px)\"><div id=\"users-activity\" \nclass=\"page-layout simple fullwidth mail-content content-edit scrollable\" layout=\"column\" \nms-scroll=\"vm.msScrollOptions\"><div flex layout=\"column\" layout-align=\"center center\" ng-if=\"vm.loadingReadPaneUser\" \nclass=\"loading-container\" style=\"z-index: 2\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\">\n</md-progress-circular></div><div ng-if=\"vm.logsUserSelected.length> 0\" flex=\"100\"><md-list-item \nclass=\"grey-100-bg border-bottom text-center toolbar-log\" layout=\"row\" layout-align=\"space-between center\"><div \nflex=\"40\" flex-gt-xs=\"50\" class=\"text-left font-size-16 pl-20\"><strong hide show-gt-xs>{{vm.selectedUser}}</strong>\n</div><div flex=\"10\" layout=\"row\" layout-align=\"center center\"><h3 class=\"grey-700-fg font-size-14\">\n{{ \'USERS.MAIL.SENT\' | translate}}</h3></div><div flex=\"10\" layout=\"row\" layout-align=\"center center\"><h3 \nclass=\"grey-700-fg font-size-14\">{{ \'USERS.MAIL.DELIVERED\' | translate}}</h3></div><div flex=\"40\" flex-gt-xs=\"30\" \nlayout=\"row\" layout-align=\"end center\"></div></md-list-item><md-list class=\"pt-0\" \nng-style=\"{\'opacity\' : vm.loadingReadPaneUser ? 0.2 : 1}\"><md-list-item class=\"border-bottom text-center item-log\" \nng-repeat=\"log in vm.logsUserSelected\"><div flex layout=\"row\"><div flex=\"40\" flex-gt-xs=\"50\" \nclass=\"text-left word-break-word pl-20\" layout=\"column\"><p class=\"m-0 subject text-truncate grey-500-fg\" \nng-bind=\"vm.getDateFormat(log.scheduled_at)\"></p><h4 class=\"m-0 font-weight-500\" ng-bind=\"log.mailing_content.subject\">\n</h4></div><div flex=\"10\" layout=\"row\" layout-align=\"center center\"><md-icon ng-if=\"log.sent_at\" \nmd-font-icon=\"icon-checkbox-marked-circle green-fg\" class=\"s24\"><md-tooltip md-autohide=\"true\">\n{{vm.getDateFormat(log.sent_at)}}</md-tooltip></md-icon></div><div flex=\"10\" layout=\"row\" layout-align=\"center center\">\n<md-icon ng-if=\"log.delivered_at\" md-font-icon=\"icon-checkbox-marked-circle green-fg\" class=\"s24\"><md-tooltip \nmd-autohide=\"true\">{{vm.getDateFormat(log.delivered_at)}}</md-tooltip></md-icon></div><div flex=\"40\" flex-gt-xs=\"30\" \nlayout-align=\"end center\" layout=\"row\" class=\"pr-20\"><div ng-if=\"log.clicked_at\" layout=\"column\" \nlayout-align=\"center center\"><button class=\"status green-300-bg pill\">{{\'USERS.MAIL.CLICKED\' | translate}}<md-tooltip \nmd-autohide=\"true\">{{vm.getDateFormat(log.clicked_at)}}</md-tooltip></button></div><div ng-if=\"log.opened_at\" \nlayout=\"column\" layout-align=\"center center\"><button class=\"status green-700-bg pill\">{{\'USERS.MAIL.OPEN\' | translate}}\n<md-tooltip md-autohide=\"true\">{{vm.getDateFormat(log.opened_at)}}</md-tooltip></button></div><div \nng-if=\"log.bounced_at && log.bounceType == \'Permanent\'\" layout=\"column\" layout-align=\"center center\"><button \nclass=\"status pill red-bg white-fg\">{{\'USERS.MAIL.HARD_BOUNCE\'\' | translate}}<md-tooltip md-autohide=\"true\">\n{{vm.getDateFormat(log.bounced_at)}}</md-tooltip></button></div><div \nng-if=\"log.bounced_at && log.bounceType == \'Transient\'\" layout=\"column\" layout-align=\"center center\"><button \nclass=\"status pill amber-bg white-fg\">{{\'USERS.MAIL.SOFT_BOUNCE\' | translate}}<md-tooltip md-autohide=\"true\">\n{{vm.getDateFormat(log.bounced_at)}}</md-tooltip></button></div><div \nng-if=\"log.bounced_at && log.bounceType != \'Transient\' && log.bounceType != \'Permanent\'\" layout=\"column\" \nlayout-align=\"center center\"><button class=\"status pill grey-bg white-fg\">{{\'USERS.MAIL.UNDEFINED\' | translate}}\n<md-tooltip md-autohide=\"true\">{{vm.getDateFormat(log.bounced_at)}}</md-tooltip></button></div><div \nng-if=\"log.suppressed_at\" layout=\"column\" layout-align=\"center center\"><button class=\"status pill grey-bg white-fg\">\n{{\'USERS.MAIL.SUPPRESSED\' | translate}}<md-tooltip md-autohide=\"true\">{{vm.getDateFormat(log.suppressed_at)}}\n</md-tooltip></button></div><div ng-if=\"log.rejected_at\" layout=\"column\" layout-align=\"center center\"><button \nclass=\"status pill grey-bg white-fg\">{{\'USERS.MAIL.REJECTED\' | translate}}<md-tooltip md-autohide=\"true\">\n{{vm.getDateFormat(log.rejected_at)}}</md-tooltip></button></div><div ng-if=\"log.complained_at\" layout=\"column\" \nlayout-align=\"center center\"><button class=\"status pill grey-bg white-fg\">{{\'USERS.MAIL.COMPLAINED\' | translate}}\n<md-tooltip md-autohide=\"true\">{{vm.getDateFormat(log.complained_at)}}</md-tooltip></button></div><div \nng-if=\"log.is_blacklisted\" layout=\"column\" layout-align=\"center center\"><button \nclass=\"status pill brown-600-bg white-fg\">{{\'USERS.MAIL.UNSUSCRIBED\' | translate}}</button></div></div></div>\n</md-list-item><div \nng-if=\"!vm.loadingReadPaneUser && vm.pagination_total_log_pages_user> vm.pagination_log_page_user && vm.logsUserSelected.length > 0\" \nclass=\"load-more white p-30\" layout=\"row\" layout-sm=\"column\" layout-align=\"center center\" layout-wrap=\"\"><md-button \nng-click=\"vm.getLogs(vm.selectedUser, vm.nextPageLogUser)\" class=\"md-raised\">{{\'GLOBAL.LOAD_MORE\' | translate}}\n</md-button></div><div class=\"white p-30\"></div></md-list></div><div ng-if=\"vm.logsUserSelected.length === 0\" \nclass=\"load-more white p-30\" layout=\"row\" layout-sm=\"column\" layout-align=\"center center\" layout-wrap=\"\"><div \nclass=\"message\" translate=\"USERS.NO_RESULTS\"></div></div></div></md-content>");
$templateCache.put("app/main/apps/mailing/views/communications/list/list-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-if=\"isLoading\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nclass=\"mail-list-item filter-selected\" ng-if=\"vm.selectedGroup\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"info\" flex><div class=\"name\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-folder\" \nclass=\"s20 mr-8 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><div class=\"title text-truncate\" layout=\"row\" \nlayout-align=\"start center\">{{vm.selectedGroup.name}} ({{pagination_totalItems | number}})</div></div></div><div \nclass=\"buttons\" layout=\"row\" layout-align=\"start center\"><div><md-switch class=\"no-label\" \nng-checked=\"vm.filterGroups.includeSubgroups\" ng-click=\"vm.toggleIncludeSubgroups($event)\" \naria-label=\"{{vm.filterGroups.includeSubgroups ? \'Uncheck\':\'check\'}}\"></md-switch><md-tooltip><span \ntranslate=\"CONTENT.INCLUDE_SUBGROUPS\">Include subgroups</span></md-tooltip></div><md-icon \nmd-font-icon=\"icon-close s20\" ng-click=\"vm.unselectGroups()\" class=\"ml-10\"><md-tooltip hide show-gt-xs><span \ntranslate=\"CONTENT.DESELECT_GROUP\">Deselect group</span></md-tooltip></md-icon></div></div><div \nclass=\"mail-list-item filter-selected\" ng-if=\"sortField\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\" flex><div class=\"info\" ng-if=\"sortField\"><div class=\"name\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-sort-ascending\" class=\"s20 mr-5 ml-0 mb-0\" \nng-if=\"sortDir === \'ASC\'\"></md-icon><md-icon md-font-icon=\"icon-sort-descending\" class=\"s20 mr-5 ml-0 mb-0\" \nng-if=\"sortDir === \'DESC\'\"></md-icon><div class=\"title text-truncate\" layout=\"row\" layout-align=\"start center\">\nOrdered by \'{{sortField}}\'</div></div></div></div><div class=\"buttons\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-close s20\" ng-click=\"pagination_resetOrderBy()\" class=\"ml-10\"><md-tooltip hide show-gt-xs>\n<span translate=\"CONTENT.REMOVE\">Remove</span></md-tooltip></md-icon></div></div><div class=\"no-threads\" \nng-if=\"!isLoading && vm.threads.length === 0\" ng-hide=\"isLoading\">There are no items!</div><div id=\"list-content-data\" \nng-style=\"{\'opacity\' : isLoading ? 0.2 : 1}\" ms-scroll=\"vm.msScrollOptions\" \nng-class=\"{\'group-filter\': vm.selectedGroup,\'other-filter\':sortField}\" class=\"scrollable\" \nng-if=\"vm.threads.length > 0\"><div class=\"mail-list-item {{thread.status}}\" \nng-repeat=\"thread in vm.threads | filter: vm.search | filter: global.search\" ng-init=\"parentIndex = $index\" md-no-ink \nng-click=\"vm.openCommunication(thread)\" \nng-class=\"{\'starred\': thread.starred, \'selected\': vm.selectedContentID === thread.id_mailing_communications, \'checked\': vm.isChecked(thread)}\">\n<div layout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-label\" ng-checked=\"vm.isSelected(thread)\" \nng-click=\"vm.toggleSelectThread(thread, $event)\" aria-label=\"{{vm.isSelected(thread) ? \'Deselect\' : \'Select\'}}\">\n</md-checkbox><div class=\"info\" flex layout=\"column\"><div class=\"name text-truncate\" layout=\"row\" \nlayout-align=\"start center\"><span>{{thread.name}}</span></div><div class=\"details\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"title grey-500-fg\" translate=\"MAILING.SUBJECT\"></span> <span \nng-bind=\"thread.subject\" class=\"detail mr-10\"></span></div></div><div class=\"buttons\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"detail mr-10\"># {{thread.id_mailing_communications}}</span></div></div></div>\n<div class=\"toolbar\" layout=\"row\" layout-align=\"end center\"><div layout=\"row\" layout-align=\"center center\" \nng-style=\"{\'display\' : isLoading ? \'none\' : \'block\'}\"><span class=\"page-info\">{{pagination_totalItems}} items found.\n</span><md-button aria-label=\"Previous\" class=\"md-icon-button arrow\" ng-click=\"pagination_prevPage()\" \nng-disabled=\"pagination_firstPage()\" translate=\"\" translate-attr-aria-label=\"CONTENT.PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><span class=\"page-info\">\n{{pagination_page}} / {{pagination_total_pages}}</span><md-button aria-label=\"Next\" class=\"md-icon-button arrow\" \nng-click=\"pagination_nextPage()\" ng-disabled=\"pagination_morePages()\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div>\n</div>");
$templateCache.put("app/main/apps/mailing/views/communications/list/nosplit-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/mailing/views/communications/list/toolbar.html\'\" \nng-hide=\"vm.currentThread || vm.currentThread_Edit\"></div><div class=\"content-wrapper\" flex=\"\" layout=\"row\"><div \nclass=\"content thread-detail mail-read-pane\" flex id=\"thread-detail\" ng-if=\"vm.currentThread || vm.currentThread_Edit\" \nng-include=\"\'app/main/apps/mailing/views/communications/read/templates-read-view.html\'\"></div><div \nclass=\"content thread-list mail-list-pane\" flex id=\"thread-list\" ng-if=\"!vm.currentThread && !vm.currentThread_Edit\" \nng-include=\"\'app/main/apps/mailing/views/communications/list/list-view.html\'\"></div></div>");
$templateCache.put("app/main/apps/mailing/views/communications/list/split-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/mailing/views/communications/list/toolbar.html\'\"></div><div class=\"content-wrapper\" flex=\"\" \nlayout=\"row\"><div class=\"content thread-list mail-list-pane\" flex=\"50\" id=\"thread-list\" \nng-include=\"\'app/main/apps/mailing/views/communications/list/list-view.html\'\"></div><div \nclass=\"content thread-detail mail-read-pane\" flex=\"50\" id=\"thread-detail\" layout=\"column\" \nng-include=\"\'app/main/apps/mailing/views/communications/read/templates-read-view.html\'\"></div></div>");
$templateCache.put("app/main/apps/mailing/views/communications/list/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-label\" \naria-label=\"{{vm.selectedThreads.length > 0 ? \'Deselect All\' : \'Select All\'}}\" \nng-checked=\"vm.selectedThreads.length > 0\" ng-click=\"vm.toggleSelectThreads()\"></md-checkbox><div \nclass=\"divider-vertical\" hide=\"\" show-gt-xs=\"\"></div><md-button aria-label=\"ADD NEW\" \nclass=\"md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme\" hide show-gt-sm \nng-click=\"vm.newCommunication()\" translate=\"CONTENT.ADD\" type=\"button\">Add new</md-button><md-button \naria-label=\"ADD NEW\" class=\"md-fab md-mini md-accent green-500-bg md-raised md-ink-ripple md-default-theme\" hide-gt-sm \nng-click=\"vm.newCommunication()\" type=\"button\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><div \nclass=\"divider-vertical\" hide=\"\" show-gt-xs=\"\"></div><ms-search-bar debounce=\"300\" \nmodel-search=\"$root.pagination_searchquery\" on-result-click=\"vm.searchResultClick(item)\" on-search=\"vm.search(query)\" \nlayout=\"row\" layout-align=\"start center\"></ms-search-bar><md-button ng-click=\"$root.pagination_resetquery()\" \naria-label=\"view type\" class=\"md-icon-button\" translate=\"\" translate-attr-aria-label=\"CONTENT.FILTERS\" \nclass=\"md-icon-button\" ng-if=\"$root.pagination_searchquery==true\"><md-icon md-font-icon=\"icon-filter-remove-outline\">\n</md-icon><md-tooltip hide show-gt-xs><span>Reset search</span></md-tooltip></md-button><div class=\"divider-vertical\" \nhide=\"\" show-gt-xs=\"\"></div><md-button aria-label=\"Sort Direction\" class=\"md-icon-button\" \nng-click=\"vm.setSortOrder(\'ASC\')\" ng-if=\"sortDir !== \'ASC\'\" translate=\"\" \ntranslate-attr-aria-label=\"TODO.SORT_DIRECTION\"><md-icon md-font-icon=\"icon-sort-ascending\" ng-if=\"sortDir !== \'ASC\'\">\n</md-icon><md-icon md-font-icon=\"icon-sort-descending\" ng-if=\"sortDir === \'ASC\'\"></md-icon></md-button><md-button \naria-label=\"Sort Direction\" class=\"md-icon-button\" ng-click=\"vm.setSortOrder(\'DESC\')\" ng-if=\"sortDir === \'ASC\'\" \ntranslate=\"\" translate-attr-aria-label=\"TODO.SORT_DIRECTION\"><md-icon md-font-icon=\"icon-sort-ascending\" \nng-if=\"sortDir !== \'ASC\'\"></md-icon><md-icon md-font-icon=\"icon-sort-descending\" ng-if=\"sortDir === \'ASC\'\"></md-icon>\n</md-button><md-menu><button aria-label=\"Filters\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" show-gt-xs=\"\" \ntranslate=\"\" translate-attr-aria-label=\"CONTENT.FILTERS\"><md-icon md-font-icon=\"icon-chevron-down\"><md-tooltip><span \ntranslate=\"CONTENT.ORDER_BY\">Order</span></md-tooltip></md-icon></button><md-menu-content width=\"1\"><md-menu-item>\n<md-button ng-click=\"vm.setSortField(\'id_mailing_communications\')\">ID</md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"vm.setSortField(\'created_at\')\">Creation date</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.setSortField(\'updated_at\')\">Update date</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.setSortField(\'name\')\">Name</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.setSortField(\'subject\')\">Subject</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.setSortField(\'from_name\')\">From name</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.setSortField(\'from_email\')\">From email</md-button></md-menu-item></md-menu-content></md-menu><md-menu \nhide=\"\" show-gt-xs=\"\" ng-if=\"refGroupables.length>0\"><button aria-label=\"Filters\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\" show-gt-xs=\"\" translate=\"\" translate-attr-aria-label=\"CONTENT.FILTERS\"><md-icon \nmd-font-icon=\"icon-chevron-down\"><md-tooltip hide show-gt-xs><span translate=\"CONTENT.GROUP_BY\">Group</span>\n</md-tooltip></md-icon></button><md-menu-content width=\"4\"><md-menu-item ng-repeat=\"sortfield in refGroupables\">\n<md-button aria-label=\"All\" ng-click=\"pagination_setOrderBy(sortfield)\"><div layout=\"row\" \nlayout-align=\"space-between center\"><span>Group by {{sortfield.name}} </span><i class=\"icon-check s16\" \nng-if=\"sortfield.titleId == sortable.titleId\"></i></div></md-button></md-menu-item><md-menu-divider ng-if=\"groupable\">\n</md-menu-divider><md-menu-item ng-if=\"groupable\"><md-button aria-label=\"Remove group\" \nng-click=\"pagination_resetOrderBy()\"><md-icon md-font-icon=\"icon-close \"></md-icon><span>Remove order</span>\n</md-button></md-menu-item></md-menu-content></md-menu><div aria-hidden=\"false\" \nclass=\"action-buttons hide show-gt-xs layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\" \nng-show=\"vm.selectedThreads.length > 0\"><div class=\"divider-vertical\" hide=\"\" show-gt-xs=\"\"></div><md-button \nng-click=\"vm.duplicateCommunication()\" aria-label=\"Duplicate\" class=\"md-icon-button\" hide=\"\" show-gt-xs=\"\" \ntranslate=\"\" translate-attr-aria-label=\"CONTENT.DUPLICATE\"><md-icon md-font-icon=\"icon-content-duplicate\"></md-icon>\n<md-tooltip hide show-gt-xs><span translate=\"CONTENT.DUPLICATE\">Duplicate</span></md-tooltip></md-button><md-button \nng-click=\"vm.deleteThread()\" aria-label=\"Delete\" class=\"md-icon-button\" hide=\"\" show-gt-xs=\"\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip hide show-gt-xs>\n<span translate=\"CONTENT.DELETE\">Delete</span></md-tooltip></md-button><div class=\"divider-vertical\" hide=\"\" \nshow-gt-xs=\"\"></div></div></div><div layout=\"row\" layout-align=\"start center\" \ntranslate-attr-aria-label=\"CONTENT.REFRESH\"><span class=\"page-info\" hide=\"\" show-gt-xs=\"\">\n{{pagination_totalItems}} items found.</span><md-button aria-label=\"Previous\" class=\"md-icon-button arrow\" hide=\"\" \nng-click=\"pagination_prevPage()\" ng-disabled=\"pagination_firstPage()\" show-gt-xs=\"\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip hide \nshow-gt-xs><span translate=\"CONTENT.PREVIOUS\">Previous</span></md-tooltip></md-button><span class=\"page-info\" hide=\"\" \nshow-gt-xs=\"\">{{pagination_page}} / {{pagination_total_pages}}</span><md-button aria-label=\"Next\" \nclass=\"md-icon-button arrow\" hide=\"\" ng-click=\"pagination_nextPage()\" ng-disabled=\"pagination_morePages()\" \nshow-gt-xs=\"\" translate=\"\" translate-attr-aria-label=\"CONTENT.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\">\n</md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.NEXT\">Next</span></md-tooltip></md-button><div \nclass=\"divider-vertical\" hide hide show-gt-sm></div><md-button class=\"md-icon-button\" \nng-click=\"vm.changeView(\'nosplit\')\" ng-if=\"vm.currentView !== \'nosplit\'\" hide show-gt-sm aria-label=\"noSplit\"><md-icon \nmd-font-icon=\"icon-view-list\" ng-if=\"vm.currentView !== \'nosplit\'\"></md-icon><md-icon class=\"md-accent\" \nmd-font-icon=\"icon-checkbox-marked\" ng-if=\"vm.currentView === \'nosplit\'\"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate=\"CONTENT.NOSPLIT_VIEW\">No split</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.changeView(\'split\')\" ng-if=\"vm.currentView !== \'split\'\" hide show-gt-sm aria-label=\"Split\"><md-icon \nmd-font-icon=\"icon-view-quilt\" ng-if=\"vm.currentView !== \'split\'\"></md-icon><md-icon class=\"md-accent\" \nmd-font-icon=\"icon-checkbox-marked\" ng-if=\"vm.currentView === \'split\'\"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate=\"CONTENT.SPLIT_VIEW\">split</span></md-tooltip></md-button><md-menu class=\"settings-menu\" hide-gt-xs \nng-show=\"vm.selectedThreads.length > 0\"><md-button aria-label=\"Settings\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\" translate=\"\" translate-attr-aria-label=\"CONTENT.SETTINGS\"><md-icon \nmd-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content><md-menu-item \nshow=\"vm.selectedMail.length > 0 || vm.allChecked\"><md-button ng-click=\"vm.massActions(\'duplicate\')\" \naria-label=\"Duplicate\" translate-attr-aria-label=\"CONTENT.DUPLICATE\"><md-icon md-font-icon=\"icon-content-duplicate\">\n</md-icon><span translate=\"CONTENT.DUPLICATE\">Duplicate </span><span translate=\"CONTENT.SELECTED\">Selected</span>\n</md-button></md-menu-item><md-menu-item show=\"vm.selectedMail.length > 0 || vm.allChecked\"><md-button \nng-click=\"vm.massActions(\'delete\')\" aria-label=\"Delete\" translate-aria-label=\"CONTENT.DELETE\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><span translate=\"CONTENT.DELETE\">Delete </span><span translate=\"CONTENT.SELECTED\">\nSelected</span></md-button></md-menu-item></md-menu-content></md-menu></div>");
$templateCache.put("app/main/apps/mailing/views/content-plus/list/list-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-if=\"isLoading\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div class=\"no-threads\" \nng-if=\"!isLoading && vm.contents.length === 0\" ng-hide=\"isLoading\">There are no items!</div><div \nid=\"list-content-data\" ng-style=\"{\'opacity\': isLoading ? 0.2 : 1}\" ms-scroll=\"vm.msScrollOptions\" \nng-class=\"{\'other-filter\': sortField}\" class=\"scrollable\" ng-if=\"vm.contents.length > 0\"><div \nclass=\"mail-list-item {{contentTemplate.status}}\" \nng-repeat=\"contentTemplate in vm.contents | filter: vm.search | filter: global.search\" ng-init=\"parentIndex=$index\" \nmd-no-ink ng-click=\"vm.openContent(contentTemplate.id_mailing_content, $event)\" \nng-class=\"{\'selected\': vm.selectedContentID === contentTemplate.id_mailing_content, \'checked\': vm.isChecked(contentTemplate)}\">\n<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\" flex><md-checkbox \nclass=\"no-label\" ng-checked=\"vm.isSelected(contentTemplate)\" ng-click=\"vm.toggleSelectThread(contentTemplate, $event)\" \naria-label=\"{{vm.isSelected(contentTemplate) ? \'Deselect\' : \'Select\'}}\"></md-checkbox><div \nclass=\"info layout-column flex\" flex layout=\"column\"><div class=\"name text-truncate\" layout=\"row\" \nlayout-align=\"start center\"><span>{{contentTemplate.subject}}</span></div><div class=\"details\" layout=\"column\" \nlayout-gt-md=\"row\" layout-align=\"start start\"><div layout=\"row\" class=\"mr-10 mb-5 text-truncate\" \nng-if=\"contentTemplate.mailing_template.name\"><span class=\"title grey-500-fg\">Template </span><span \nng-bind=\"contentTemplate.mailing_template.name\"></span></div><div layout=\"row\" class=\"mr-10 mb-5\" \nng-if=\"vm.isSent(contentTemplate)\"><span class=\"title grey-500-fg\">Sent </span><span \nng-bind-html=\"vm.timeAgo(contentTemplate.sent_at)\"></span></div><div layout=\"row\" \nng-if=\"contentTemplate.scheduled_at && !contentTemplate.sent_at\"><span class=\"title grey-500-fg\">Scheduled </span><span\n ng-bind-html=\"vm.getDateFormat(contentTemplate.scheduled_at)\"></span></div></div><div layout=\"row\" \nclass=\"mr-10 mb-5 text-truncate\"><span ng-if=\"!contentTemplate.sent_from_address\"><span class=\"title grey-500-fg\">\n{{\'MAILING.FROM\' | translate}}: </span><span>{{contentTemplate.mailing_template.from_email}}</span> </span><span \nng-if=\"contentTemplate.sent_from_address\"><span class=\"title grey-500-fg\">{{\'MAILING.FROM\' | translate}}: </span><span>\n{{contentTemplate.sent_from_address}}</span></span></div></div></div><div class=\"status-wrapper text-center\" \nlayout=\"row\" layout-align=\"end center\"><div class=\"status grey-300-bg ml-10\" layout=\"row\" layout-align=\"center center\" \nng-if=\"contentTemplate.id_mailing_status < 2\"><span translate=\"MAILING.STATUSES.UNSENT\">Unsent</span></div><div \nclass=\"status blue-500-bg ml-10\" layout=\"row\" layout-align=\"center center\" \nng-if=\"contentTemplate.id_mailing_status == 2 || (contentTemplate.id_mailing_status == 3 && contentTemplate.scheduled_at)\">\n<span translate=\"MAILING.STATUSES.SCHEDULED\">Scheduled</span></div><div class=\"status blue-500-bg ml-10\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"contentTemplate.id_mailing_status == 3 && !contentTemplate.scheduled_at\"><span \ntranslate=\"MAILING.STATUSES.PROCESSING\">Processing</span></div><div class=\"status blue-500-bg ml-10\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"contentTemplate.id_mailing_status == 4\"><span translate=\"MAILING.STATUSES.SENDING\">\nSending</span></div><div class=\"status green-bg ml-10\" layout=\"row\" layout-align=\"center center\" \nng-if=\"contentTemplate.id_mailing_status == 5\"><span translate=\"MAILING.STATUSES.SENT\">Sent</span></div></div></div>\n</div><div class=\"toolbar\" layout=\"row\" layout-align=\"end center\"><div layout=\"row\" layout-align=\"center center\" \nng-style=\"{\'display\': isLoading ? \'none\' : \'block\'}\"><span class=\"page-info\">{{pagination_totalItems}} items found.\n</span><md-button aria-label=\"Previous\" class=\"md-icon-button arrow\" ng-click=\"pagination_prevPage()\" \nng-disabled=\"pagination_firstPage()\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button><span \nclass=\"page-info\">{{pagination_page}} / {{pagination_total_pages}}</span><md-button aria-label=\"Next\" \nclass=\"md-icon-button arrow\" ng-click=\"pagination_nextPage()\" ng-disabled=\"pagination_morePages()\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div></div>");
$templateCache.put("app/main/apps/mailing/views/content-plus/list/nosplit-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/mailing/views/content-plus/list/toolbar.html\'\"></div><div class=\"content-wrapper\" flex \nlayout=\"row\"><div class=\"content thread-list mail-list-pane\" flex=\"40\" id=\"thread-list\" \nng-include=\"\'app/main/apps/mailing/views/content-plus/list/list-view.html\'\"></div><div hide show-gt-md \nclass=\"content thread-detail mail-read-pane\" flex=\"60\" id=\"thread-detail\" layout=\"column\" \nng-include=\"\'app/main/apps/mailing/views/content-plus/read/content-read-view.html\'\"></div><div hide-gt-md \nclass=\"content thread-detail mail-read-pane\" flex=\"100\" id=\"thread-detail\" layout=\"column\" \nng-if=\"vm.selectedContentID\" ng-include=\"\'app/main/apps/mailing/views/content-plus/read/content-read-view.html\'\"></div>\n</div>");
$templateCache.put("app/main/apps/mailing/views/content-plus/list/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-accent green-500-bg md-raised\" hide show-gt-sm \nng-click=\"vm.newContent($event)\" type=\"button\" aria-label=\"NEW\" translate=\"CONTENT.ADD\"></md-button><md-button \naria-label=\"ADD NEW\" class=\"md-fab md-mini md-accent green-500-bg md-raised\" hide-gt-sm \nng-click=\"vm.newContent($event)\" type=\"button\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><div \nclass=\"divider-vertical\" hide show-gt-xs></div><div \nclass=\"action-buttons hide show-gt-xs layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\" \nng-show=\"vm.selectedThreads.length > 0\"><md-button ng-click=\"vm.duplicateContent()\" aria-label=\"Duplicate\" \nclass=\"md-icon-button\" hide show-gt-xs><md-icon md-font-icon=\"icon-content-duplicate\"></md-icon><md-tooltip hide \nshow-gt-xs><span translate=\"CONTENT.DUPLICATE\"></span></md-tooltip></md-button><md-button \nng-show=\"vm.selectedThreads.length > 0\" ng-click=\"vm.deleteContent()\" aria-label=\"Delete\" class=\"md-icon-button\" hide \nshow-gt-xs><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.DELETE\">\n</span></md-tooltip></md-button><div class=\"divider-vertical\" hide show-gt-xs></div></div><ms-search-bar \ndebounce=\"300\" model-search=\"$root.pagination_searchquery\" on-result-click=\"vm.searchResultClick(item)\" \non-search=\"vm.search(query)\" layout=\"row\" layout-align=\"start center\"></ms-search-bar><md-button \nng-click=\"$root.pagination_resetquery()\" aria-label=\"reset\" class=\"md-icon-button\" \nng-if=\"$root.pagination_searchquery==true\"><md-icon md-font-icon=\"icon-filter-remove-outline\"></md-icon></md-button>\n<div class=\"divider-vertical\" hide show-gt-xs></div><md-button aria-label=\"Sort ASC\" class=\"md-icon-button\" \nng-click=\"vm.setSortOrder(\'ASC\')\" ng-if=\"sortDir !== \'ASC\'\"><md-icon md-font-icon=\"icon-sort-ascending\"></md-icon>\n</md-button><md-button aria-label=\"Sort DESC\" class=\"md-icon-button\" ng-click=\"vm.setSortOrder(\'DESC\')\" \nng-if=\"sortDir === \'ASC\'\"><md-icon md-font-icon=\"icon-sort-descending\"></md-icon></md-button><md-menu><button \naria-label=\"Order\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" show-gt-xs><md-icon \nmd-font-icon=\"icon-chevron-down\"><md-tooltip><span translate=\"CONTENT.ORDER_BY\">Order</span></md-tooltip></md-icon>\n</button><md-menu-content width=\"1\"><md-menu-item><md-button ng-click=\"vm.setSortField(\'id_mailing_content\')\">ID\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.setSortField(\'created_at\')\">Creation date</md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.setSortField(\'updated_at\')\">Update date</md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.setSortField(\'subject\')\">Subject</md-button></md-menu-item></md-menu-content>\n</md-menu></div><div layout=\"row\" layout-align=\"start center\"><span class=\"page-info\" hide show-gt-xs>\n{{pagination_totalItems}} items found.</span><md-button aria-label=\"Previous\" class=\"md-icon-button arrow\" hide \nng-click=\"pagination_prevPage()\" ng-disabled=\"pagination_firstPage()\" show-gt-xs><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><span class=\"page-info\" hide show-gt-xs>\n{{pagination_page}} / {{pagination_total_pages}}</span><md-button aria-label=\"Next\" class=\"md-icon-button arrow\" hide \nng-click=\"pagination_nextPage()\" ng-disabled=\"pagination_morePages()\" show-gt-xs><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>");
$templateCache.put("app/main/apps/mailing/views/massive-messages/list/list-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-if=\"vm.showLoader\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nclass=\"mail-list-item filter-selected\" ng-if=\"sortField\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\" flex><div class=\"info\" ng-if=\"sortField\"><div class=\"name\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-sort-ascending\" class=\"s20 mr-5 ml-0 mb-0\" \nng-if=\"sortDir === \'ASC\'\"></md-icon><md-icon md-font-icon=\"icon-sort-descending\" class=\"s20 mr-5 ml-0 mb-0\" \nng-if=\"sortDir === \'DESC\'\"></md-icon><div class=\"title text-truncate\" layout=\"row\" layout-align=\"start center\">\nOrdered by \'{{sortField}}\'</div></div></div></div><div class=\"buttons\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-close s20\" ng-click=\"pagination_resetOrderBy()\" class=\"ml-10\"><md-tooltip hide show-gt-xs>\n<span translate=\"CONTENT.REMOVE\">Remove</span></md-tooltip></md-icon></div></div><div class=\"no-threads\" \nng-if=\"!isLoading && vm.massive.length === 0\" ng-hide=\"isLoading\">There are no items!</div><div id=\"list-content-data\" \nng-style=\"{\'opacity\' : isLoading ? 0.2 : 1}\" ms-scroll=\"vm.msScrollOptions\" \nng-class=\"{\'group-filter\': vm.selectedGroup,\'other-filter\':sortField}\" class=\"scrollable\" ng-if=\"vm.massive.length> 0\">\n<div class=\"mail-list-item {{contentTemplate.status}}\" \nng-repeat=\"contentTemplate in vm.massive | filter: vm.search | filter: global.search\" ng-init=\"parentIndex= $index\" \nmd-no-ink ng-click=\"vm.openContent(contentTemplate.id_message)\" \nng-class=\"{\'starred\': contentTemplate.starred,\r\n        \'selected\': vm.selectedContentID === contentTemplate.id_message, \'checked\': vm.isChecked(contentTemplate)}\">\n<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\" flex><md-checkbox \nclass=\"no-label\" ng-checked=\"vm.isSelected(contentTemplate)\" ng-click=\"vm.toggleSelectThread(contentTemplate, $event)\" \naria-label=\"{{vm.isSelected(contentTemplate) ? \'Deselect\' : \'Select\'}}\"></md-checkbox><img class=\"img-flag ng-scope\" \nng-if=\"contentTemplate.lang\" alt=\"{{vm.siteLanguages()[contentTemplate.lang]}}\" \nng-src=\"assets/images/flags/{{vm.siteLanguages()[contentTemplate.lang].flag_code|lowercase}}.svg\"><div \nclass=\"info layout-column flex\" flex=\"\" layout=\"column\"><div class=\"name text-truncate\" layout=\"row\" \nlayout-align=\"start center\"><span>{{contentTemplate.subject}}</span></div><div class=\"details\" layout=\"column\" \nlayout-gt-md=\"row\" layout-align=\"start start\"><div layout=\"row\" class=\"mr-10 mb-5 text-truncate\" \nng-if=\"contentTemplate.mailing_template.name\"><span class=\"title grey-500-fg\">Template </span><span \nng-bind=\"contentTemplate.mailing_template.name\"></span></div><div layout=\"row\" class=\"mr-10 mb-5\" \nng-if=\"vm.isSent(contentTemplate)\"><span class=\"title grey-500-fg\">Sent</span></div><div layout=\"row\" \nng-if=\"contentTemplate.scheduled_at && !contentTemplate.sent_at\"><span class=\"title grey-500-fg\">Scheduled </span><span\n ng-bind-html=\"vm.getDateFormat(contentTemplate.scheduled_at)\"></span></div></div><div layout=\"row\" \nclass=\"mr-10 mb-5 text-truncate\"><span ng-if=\"!contentTemplate.sent_from_address\"><span class=\"title grey-500-fg\">\n{{\'MAILING.FROM\' | translate}}: </span><span>{{contentTemplate.mailing_template.from_email}}</span> </span><span \nng-if=\"contentTemplate.sent_from_address\"><span class=\"title grey-500-fg\">{{\'MAILING.FROM\' | translate}}: </span><span>\n{{contentTemplate.sent_from_address}}</span></span></div></div></div><div class=\"status-wrapper text-center\" \nlayout=\"row\" layout-align=\"end center\"><div class=\"status grey-300-bg ml-10\" layout=\"row\" layout-align=\"center center\" \nng-if=\"contentTemplate.id_message_status <2\"><span translate=\"MAILING.STATUSES.UNSENT\">Unsent</span></div><div \nclass=\"status blue-500-bg ml-10\" layout=\"row\" layout-align=\"center center\" \nng-if=\"contentTemplate.id_message_status == 2 || (contentTemplate.id_message_status == 3 && contentTemplate.scheduled_at)\">\n<span translate=\"MAILING.STATUSES.SCHEDULED\">Scheduled</span></div><div class=\"status blue-500-bg ml-10\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"contentTemplate.id_message_status == 3 && !contentTemplate.scheduled_at\"><span \ntranslate=\"MAILING.STATUSES.PROCESSING\">Processing</span></div><div class=\"status blue-500-bg ml-10\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"contentTemplate.id_message_status == 4\"><span translate=\"MAILING.STATUSES.SENDING\">\nSending</span></div><div class=\"status green-bg ml-10\" layout=\"row\" layout-align=\"center center\" \nng-if=\"contentTemplate.id_message_status == 5\"><span translate=\"MAILING.STATUSES.SENT\">Sent</span></div><div \nclass=\"status blue-500-bg ml-10\" layout=\"row\" layout-align=\"center center\" \nng-if=\"contentTemplate.id_message_status == 6\"><span translate=\"MAILING.STATUSES.WORKING\">Working</span></div></div>\n</div></div><div class=\"toolbar\" layout=\"row\" layout-align=\"end center\"><div layout=\"row\" layout-align=\"center center\" \nng-style=\"{\'display\' : isLoading ? \'none\' : \'block\'}\"><span class=\"page-info\">{{pagination_totalItems}} items found.\n</span><md-button aria-label=\"Previous\" class=\"md-icon-button arrow\" ng-click=\"pagination_prevPage()\" \nng-disabled=\"pagination_firstPage()\" translate=\"\" translate-attr-aria-label=\"CONTENT.PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><span class=\"page-info\">\n{{pagination_page}} / {{pagination_total_pages}}</span><md-button aria-label=\"Next\" class=\"md-icon-button arrow\" \nng-click=\"pagination_nextPage()\" ng-disabled=\"pagination_morePages()\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div>\n</div>");
$templateCache.put("app/main/apps/mailing/views/massive-messages/list/nosplit-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/mailing/views/massive-messages/list/toolbar.html\'\" \nng-hide=\"vm.loadTemplates || vm.isUpdateContent\"></div><div class=\"content-wrapper\" flex=\"\" layout=\"row\"><div \nclass=\"content thread-detail mail-read-pane\" flex id=\"thread-detail\" ms-scroll=\"vm.msScrollOptions\" \nng-if=\"!vm.isChannel && (vm.loadTemplates || vm.isUpdateContent)\" \nng-include=\"\'app/main/apps/mailing/views/massive-messages/read/content-read-view.html\'\"></div><div \nclass=\"content thread-detail mail-read-pane\" flex id=\"thread-detail\" ms-scroll=\"vm.msScrollOptions\" \nng-if=\"vm.isChannel\" ng-include=\"\'app/main/apps/mailing/views/massive-messages/read/content-select-channel.html\'\">\n</div><div class=\"content thread-list mail-list-pane\" flex id=\"thread-list\" \nng-if=\"!vm.loadTemplates && !vm.isUpdateContent && !vm.isChannel\" \nng-include=\"\'app/main/apps/mailing/views/massive-messages/list/list-view.html\'\"></div><div \nng-if=\"vm.tabSelected == \'details\'\" class=\"pane-mailing\" ng-class=\"{\'selected\' : vm.selectedUser}\" \nng-include=\"\'app/main/apps/mailing/views/massive-messages/read/content-user-mailing.html\'\"></div></div>");
$templateCache.put("app/main/apps/mailing/views/massive-messages/list/split-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/mailing/views/massive-messages/list/toolbar.html\'\"></div><div class=\"content-wrapper\" \nflex=\"\" layout=\"row\"><div ng-if=\"vm.tabSelected != \'details\'\" class=\"content thread-list mail-list-pane\" flex=\"40\" \nid=\"thread-list\" ng-include=\"\'app/main/apps/mailing/views/massive-messages/list/list-view.html\'\"></div><div hide \nshow-gt-md ng-if=\"vm.tabSelected == \'details\'\" class=\"content thread-list mail-read-pane\" flex=\"30\" id=\"thread-detail\" \nlayout=\"column\"><div ng-include=\"\'app/main/apps/mailing/views/massive-messages/read/content-read-info.html\'\"></div>\n</div><div hide show-gt-md class=\"content thread-detail mail-read-pane\" \nng-if=\"!vm.isChannel && (vm.loadTemplates || vm.isUpdateContent)\" \nflex=\"{{vm.tabSelected != \'details\' ? \'60\' : \'70\' }}\" id=\"thread-detail\" layout=\"column\" \nng-include=\"\'app/main/apps/mailing/views/massive-messages/read/content-read-view.html\'\"></div><div hide show-gt-md \nclass=\"content thread-detail mail-read-pane\" ng-if=\"vm.isChannel\" \nflex=\"{{vm.tabSelected != \'details\' ? \'60\' : \'70\' }}\" id=\"thread-detail\" layout=\"column\" \nng-include=\"\'app/main/apps/mailing/views/massive-messages/read/content-select-channel.html\'\"></div><div hide-gt-md \nclass=\"content thread-detail mail-read-pane\" flex=\"100\" id=\"thread-detail\" layout=\"column\" \nng-if=\"!vm.isChannel && (vm.loadTemplates || vm.isUpdateContent)\" \nng-include=\"\'app/main/apps/mailing/views/massive-messages/read/content-read-view.html\'\"></div><div hide-gt-md \nclass=\"content thread-detail mail-read-pane\" flex=\"100\" id=\"thread-detail\" layout=\"column\" ng-if=\"vm.isChannel\" \nng-include=\"\'app/main/apps/mailing/views/massive-messages/read/content-select-channel.html\'\"></div><div \nng-if=\"vm.tabSelected == \'details\'\" class=\"pane-mailing\" ng-class=\"{\'selected\' : vm.selectedUser}\" \nng-include=\"\'app/main/apps/mailing/views/massive-messages/read/content-user-mailing.html\'\"></div></div>");
$templateCache.put("app/main/apps/mailing/views/massive-messages/list/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-label\" \naria-label=\"{{vm.selectedThreads.length > 0 ? \'Deselect All\' : \'Select All\'}}\" \nng-checked=\"vm.selectedThreads.length > 0\" ng-click=\"vm.toggleSelectThreads(vm.selectedThreads, vm.massive)\">\n</md-checkbox><div class=\"divider-vertical\" hide=\"\" show-gt-xs=\"\"></div><md-button \nclass=\"md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme\" hide show-gt-sm \nng-click=\"vm.newChannel()\" translate=\"CONTENT.ADD\" type=\"button\" aria-label=\"NEW\"></md-button><md-button \naria-label=\"ADD NEW\" class=\"md-fab md-mini md-accent green-500-bg md-raised md-ink-ripple md-default-theme\" hide-gt-sm \nng-click=\"vm.newChannel()\" type=\"button\" aria-label=\"NEW\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><div \nclass=\"divider-vertical\" hide=\"\" show-gt-xs=\"\"></div><div aria-hidden=\"false\" \nclass=\"action-buttons hide show-gt-xs layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\" \nng-show=\"vm.selectedThreads.length > 0\"><md-button ng-click=\"vm.duplicateContent()\" aria-label=\"Duplicate\" \nclass=\"md-icon-button\" hide=\"\" show-gt-xs=\"\" translate=\"\" translate-attr-aria-label=\"CONTENT.DUPLICATE\"><md-icon \nmd-font-icon=\"icon-content-duplicate\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.DUPLICATE\">\nDuplicate</span></md-tooltip></md-button><md-button ng-click=\"vm.deleteContent()\" aria-label=\"Delete\" \nclass=\"md-icon-button\" hide=\"\" show-gt-xs=\"\" translate=\"\" translate-attr-aria-label=\"CONTENT.DELETE\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.DELETE\">Delete</span>\n</md-tooltip></md-button><div class=\"divider-vertical\" hide=\"\" show-gt-xs=\"\"></div></div><ms-search-bar debounce=\"300\" \nmodel-search=\"$root.pagination_searchquery\" on-result-click=\"vm.searchResultClick(item)\" on-search=\"vm.search(query)\" \nlayout=\"row\" layout-align=\"start center\"></ms-search-bar><md-button ng-click=\"$root.pagination_resetquery()\" \naria-label=\"view type\" class=\"md-icon-button\" translate=\"\" translate-attr-aria-label=\"CONTENT.FILTERS\" \nclass=\"md-icon-button\" ng-if=\"$root.pagination_searchquery==true\"><md-icon md-font-icon=\"icon-filter-remove-outline\">\n</md-icon><md-tooltip hide show-gt-xs><span>Reset search</span></md-tooltip></md-button><div class=\"divider-vertical\" \nhide=\"\" show-gt-xs=\"\"></div><md-button aria-label=\"Sort Direction\" class=\"md-icon-button\" \nng-click=\"vm.setSortOrder(\'ASC\')\" ng-disabled=\"!sortField\" ng-if=\"sortDir !== \'ASC\'\" translate=\"\" \ntranslate-attr-aria-label=\"TODO.SORT_DIRECTION\"><md-icon md-font-icon=\"icon-sort-ascending\"></md-icon></md-button>\n<md-button aria-label=\"Sort Direction\" class=\"md-icon-button\" ng-click=\"vm.setSortOrder(\'DESC\')\" \nng-disabled=\"!sortField\" ng-if=\"sortDir === \'ASC\'\" translate=\"\" translate-attr-aria-label=\"TODO.SORT_DIRECTION\">\n<md-icon md-font-icon=\"icon-sort-descending\"></md-icon></md-button><md-menu><button aria-label=\"Filters\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" show-gt-xs=\"\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.FILTERS\"><md-icon md-font-icon=\"icon-chevron-down\"><md-tooltip><span \ntranslate=\"CONTENT.ORDER_BY\">Order</span></md-tooltip></md-icon></button><md-menu-content width=\"1\"><md-menu-item>\n<md-button ng-click=\"vm.setSortField(\'id_message\')\">ID</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.setSortField(\'created_at\')\">Creation date</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.setSortField(\'updated_at\')\">Update date</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.setSortField(\'subject\')\">Subject</md-button></md-menu-item></md-menu-content></md-menu><md-menu hide=\"\" \nshow-gt-xs=\"\" ng-if=\"refGroupables.length>0\"><button aria-label=\"Filters\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\" show-gt-xs=\"\" translate=\"\" translate-attr-aria-label=\"CONTENT.FILTERS\"><md-icon \nmd-font-icon=\"icon-chevron-down\"><md-tooltip hide show-gt-xs><span translate=\"CONTENT.GROUP_BY\">Group</span>\n</md-tooltip></md-icon></button><md-menu-content width=\"4\"><md-menu-item ng-repeat=\"sortfield in refGroupables\">\n<md-button aria-label=\"All\" ng-click=\"pagination_setOrderBy(sortfield)\"><div layout=\"row\" \nlayout-align=\"space-between center\"><span>Group by {{sortfield.name}} </span><i class=\"icon-check s16\" \nng-if=\"sortfield.titleId == sortable.titleId\"></i></div></md-button></md-menu-item><md-menu-divider ng-if=\"groupable\">\n</md-menu-divider><md-menu-item ng-if=\"groupable\"><md-button aria-label=\"Remove group\" \nng-click=\"pagination_resetOrderBy()\"><md-icon md-font-icon=\"icon-close \"></md-icon><span>Remove order</span>\n</md-button></md-menu-item></md-menu-content></md-menu></div><div layout=\"row\" layout-align=\"start center\" \ntranslate-attr-aria-label=\"CONTENT.REFRESH\"><span class=\"page-info\" hide=\"\" show-gt-xs=\"\">\n{{pagination_totalItems}} items found.</span><md-button aria-label=\"Previous\" class=\"md-icon-button arrow\" hide=\"\" \nng-click=\"pagination_prevPage()\" ng-disabled=\"pagination_firstPage()\" show-gt-xs=\"\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip hide \nshow-gt-xs><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-tooltip></md-button><span class=\"page-info\" \nhide=\"\" show-gt-xs=\"\">{{pagination_page}} / {{pagination_total_pages}}</span><md-button aria-label=\"Next\" \nclass=\"md-icon-button arrow\" hide=\"\" ng-click=\"pagination_nextPage()\" ng-disabled=\"pagination_morePages()\" \nshow-gt-xs=\"\" translate=\"\" translate-attr-aria-label=\"CONTENT.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\">\n</md-icon><md-tooltip hide show-gt-xs><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-tooltip></md-button>\n<div class=\"divider-vertical\" hide hide show-gt-sm></div><md-button class=\"md-icon-button\" \nng-click=\"vm.changeView(\'nosplit\')\" ng-if=\"vm.currentView !== \'nosplit\' && !vm.basicForm\" hide show-gt-sm \naria-label=\"noSplit\"><md-icon md-font-icon=\"icon-view-list\" ng-if=\"vm.currentView !== \'nosplit\'\"></md-icon><md-icon \nclass=\"md-accent\" md-font-icon=\"icon-checkbox-marked\" ng-if=\"vm.currentView === \'nosplit\'\"></md-icon><md-tooltip hide \nshow-gt-xs><span translate=\"CONTENT.NOSPLIT_VIEW\">No split</span></md-tooltip></md-button><md-button \nng-if=\"vm.currentView !== \'nosplit\' && vm.basicForm\" hide show-gt-sm class=\"md-icon-button\" aria-label=\"noSplit\">\n<md-icon md-font-icon=\"icon-view-list\" ng-if=\"vm.currentView !== \'nosplit\'\" class=\"disabled\"></md-icon><md-icon \nclass=\"md-accent disabled\" md-font-icon=\"icon-checkbox-marked\" ng-if=\"vm.currentView === \'nosplit\'\"></md-icon>\n<md-tooltip ng-if=\"vm.currentView !== \'nosplit\' && vm.basicForm\" hide show-gt-sm><span \ntranslate=\"CONTENT.CANT_CHANGE_WHILE_EDITING\"></span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.changeView(\'split\')\" ng-if=\"vm.currentView !== \'split\'\" hide show-gt-sm aria-label=\"Split\" \nng-disabled=\"vm.basicForm.$pristine\"><md-icon md-font-icon=\"icon-view-quilt\" ng-if=\"vm.currentView !== \'split\'\">\n</md-icon><md-icon class=\"md-accent\" md-font-icon=\"icon-checkbox-marked\" ng-if=\"vm.currentView === \'split\'\"></md-icon>\n<md-tooltip hide show-gt-xs><span translate=\"CONTENT.SPLIT_VIEW\">split</span></md-tooltip></md-button><md-menu \nclass=\"settings-menu\" hide-gt-xs ng-show=\"vm.selectedThreads.length > 0\"><md-button aria-label=\"Settings\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" translate=\"\" translate-attr-aria-label=\"CONTENT.SETTINGS\">\n<md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content><md-menu-item \nshow=\"vm.selectedMail.length > 0 || vm.allChecked\"><md-button ng-click=\"vm.massActions(\'duplicate\')\" \naria-label=\"Duplicate\" translate-attr-aria-label=\"CONTENT.DUPLICATE\"><md-icon md-font-icon=\"icon-content-duplicate\">\n</md-icon><span translate=\"CONTENT.DUPLICATE\">Duplicate </span><span translate=\"CONTENT.SELECTED\">Selected</span>\n</md-button></md-menu-item><md-menu-item show=\"vm.selectedMail.length > 0 || vm.allChecked\"><md-button \nng-click=\"vm.massActions(\'delete\')\" aria-label=\"Delete\" translate-aria-label=\"CONTENT.DELETE\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><span translate=\"CONTENT.DELETE\">Delete </span><span translate=\"CONTENT.SELECTED\">\nSelected</span></md-button></md-menu-item></md-menu-content></md-menu></div>");
$templateCache.put("app/main/apps/mailing/views/content-plus/dialogs/editor-dialog.html","<md-dialog id=\"content-plus-editor-dialog\"><div class=\"cp-dialog-header\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"cp-dialog-title\">✉️ Content Plus — {{vm.contentTitle}}</span>\n<md-button class=\"md-icon-button cp-dialog-close\" ng-click=\"vm.close()\" aria-label=\"Cerrar\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><div class=\"cp-dialog-body\"><iframe ng-src=\"{{vm.iframeSrc}}\" \nclass=\"cp-iframe\" frameborder=\"0\" id=\"content-plus-iframe\"></iframe></div></md-dialog>");
$templateCache.put("app/main/apps/mailing/views/content-plus/read/content-read-view.html","<div class=\"mail-content cp-empty-state\" layout=\"column\" layout-align=\"center center\" ng-if=\"!vm.currentContent\"><div \nclass=\"content\" layout=\"column\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-email-open\" \nclass=\"cp-empty-state-icon\"></md-icon><p class=\"grey-400-fg mt-16\" translate=\"MAILING.SELECT_ITEM_TO_SHOW\">\nSelect an item to show</p></div></div><div ng-if=\"vm.currentContent\" class=\"form-wrapper\"><form name=\"vm.basicForm\" \nclass=\"md-inline-form\" novalidate><div class=\"toolbar grey-100-bg colored-bg\" layout=\"row\" \nlayout-align=\"space-between center\" scroll><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button\" ng-class=\"{\'md-accent\': vm.currentContentView == \'content\'}\" \nng-click=\"vm.openContentView(\'content\')\" translate translate-attr-aria-label=\"MAILING.CONTENT\" \nng-if=\"!vm.isSent(vm.currentContent)\" aria-label=\"Contenido\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip \nhide show-gt-xs><span translate=\"MAILING.EDIT\"></span></md-tooltip></md-button><div class=\"divider-vertical\" hide \nshow-gt-sm></div><md-button class=\"md-icon-button\" ng-click=\"vm.openPreview($event)\" translate \ntranslate-attr-aria-label=\"MAILING.PREVIEW\" ng-disabled=\"!vm.currentContent.structure_mjml\" aria-label=\"Previsualizar\">\n<md-icon md-font-icon=\"icon-web\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"MAILING.PREVIEW\"></span>\n</md-tooltip></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button class=\"md-icon-button\" \nng-class=\"{\'md-accent\': vm.currentContentView == \'send\'}\" ng-click=\"vm.openContentView(\'send\')\" translate \ntranslate-attr-aria-label=\"MAILING.SEND\" ng-disabled=\"vm.basicForm.$dirty || !vm.currentContent.unique_id\" \naria-label=\"Enviar\"><md-icon md-font-icon=\"icon-telegram\"><md-tooltip hide show-gt-xs ng-if=\"vm.basicForm.$dirty\"><span\n translate=\"MAILING.SEND_ALERT\"></span></md-tooltip></md-icon><md-tooltip hide show-gt-xs><span \ntranslate=\"MAILING.SEND\"></span></md-tooltip></md-button><div class=\"divider-vertical\" hide show-gt-sm></div></div><div\n layout=\"row\" layout-align=\"end center\" hide show-gt-sm \nng-if=\"!vm.isSent(vm.currentContent) && vm.currentContentView == \'content\'\"><md-button ng-click=\"vm.saveContent()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"SAVE\" translate=\"MAILING.SAVE\" \ntranslate-attr-aria-label=\"MAILING.SAVE\"></md-button><md-button type=\"button\" ng-click=\"vm.closeDetail()\" \nclass=\"md-raised md-warn\" aria-label=\"Cancel\" translate=\"MAILING.CANCEL\" translate-attr-aria-label=\"MAILING.CANCEL\">\n</md-button></div><div layout=\"row\" layout-align=\"end center\" hide-gt-sm \nng-if=\"!vm.isSent(vm.currentContent) && vm.currentContentView == \'content\'\"><md-button ng-click=\"vm.saveContent()\" \nclass=\"md-fab md-mini md-accent md-raised\" aria-label=\"SAVE\"><md-icon md-font-icon=\"icon-check\"></md-icon></md-button>\n<md-button type=\"button\" ng-click=\"vm.closeDetail()\" class=\"md-warn md-fab md-mini md-accent md-raised\" \naria-label=\"Cancel\"><md-icon md-font-icon=\"icon-window-close\"></md-icon></md-button></div></div><div id=\"content-edit\" \nms-scroll=\"vm.msScrollOptions\" class=\"scrollable page-layout simple fullwidth mail-content content-edit\" \nlayout=\"column\" ng-if=\"vm.currentContentView == \'content\' && !vm.isSent(vm.currentContent)\"><div layout=\"row\" \nng-include=\"\'app/main/apps/mailing/views/content-plus/read/content-tab-edit.html\'\"></div></div><div id=\"content-send\" \nms-scroll=\"vm.msScrollOptions\" class=\"scrollable page-layout simple fullwidth mail-content content-edit content-send\" \nlayout=\"column\" ng-if=\"vm.currentContentView == \'send\'\"><div class=\"form-wrapper\" flex=\"100\"><div \nclass=\"md-block ph-24 pv-20 border-bottom\" flex><h1 class=\"mb-5 mt-0\"><strong>{{vm.currentContent.subject}}</strong>\n</h1></div><md-tabs md-dynamic-height><md-tab label=\"{{vm.translate(\'MAILING.SEND_TEST\')}}\"><div layout=\"row\" \nng-include=\"\'app/main/apps/mailing/views/content-plus/read/content-tab-send-test.html\'\"></div></md-tab><md-tab \nlabel=\"{{vm.translate(\'MAILING.SEND\')}}\" ng-if=\"!vm.isSent(vm.currentContent)\"><div layout=\"row\" \nng-include=\"\'app/main/apps/mailing/views/content/read/content-tab-send.html\'\"></div></md-tab></md-tabs></div></div>\n</form></div>");
$templateCache.put("app/main/apps/mailing/views/content-plus/read/content-tab-edit.html","<div class=\"form-wrapper\" flex=\"100\"><div><md-input-container class=\"md-block\" flex><div class=\"item grey-500-fg\" \ntranslate=\"MAILING.SUBJECT\">Subject</div><input data-ng-model=\"vm.currentContent.subject\" required>\n</md-input-container></div><div><md-input-container class=\"md-block\" flex><div class=\"item grey-500-fg\" \ntranslate=\"MAILING.TEMPLATE\"></div><div layout=\"row\" layout-align=\"start center\"><div \nng-bind-html=\"vm.currentContent.mailing_template.name\" class=\"mb-5 font-size-16\"></div><button \nclass=\"md-icon-button md-button\" ng-click=\"vm.changeMailingTemplate($event)\"><md-icon md-font-icon=\"icon-border-color\" \nclass=\"s20\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"MAILING.CHANGE_TEMPLATE\"></span></md-tooltip>\n</button></div></md-input-container></div><div class=\"border-bottom\"><div \nclass=\"md-toolbar-tools grey-100-bg border-bottom border-top\" role=\"listitem\"><h3 class=\"grey-700-fg\" \ntranslate=\"MAILING.CONTENT_DESIGN\"></h3></div><md-input-container layout=\"row\" layout-align=\"space-between center\" \nflex><div layout=\"row\" layout-align=\"start center\" flex><md-button ng-disabled=\"!vm.currentContent.unique_id\" \nng-click=\"vm.openEditor($event)\" class=\"add-event-button md-fab md-warn ml-0\" aria-label=\"Edit design\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></md-button><span class=\"font-size-16 grey-500-fg ml-5\" \ntranslate=\"MAILING.EDIT_DESIGN\"></span></div></md-input-container></div></div>");
$templateCache.put("app/main/apps/mailing/views/content-plus/read/content-tab-send-test.html","<div class=\"form-wrapper\" flex=\"100\"><form name=\"vm.sentTestForm\" class=\"md-inline-form\" novalidate><div><div \nclass=\"md-toolbar-tools grey-100-bg border-bottom pl-25\" role=\"listitem\" \nng-if=\"vm.currentContent.mailing_template.test_emails_json.length\"><h3 class=\"grey-700-fg ng-scope\" \ntranslate=\"MAILING.TEST_EMAILS_TEMPLATE\">Test emails</h3></div><div class=\"ph-25 pt-10\" \nng-if=\"vm.currentContent.mailing_template.test_emails_json.length\"><span \nng-repeat=\"email in vm.currentContent.mailing_template.test_emails_json\" class=\"md-chip grey-300-bg\" \nstyle=\"display:inline-block;padding:4px 12px;margin:0 6px 6px 0;border-radius:16px;font-size:13px\">{{email}}</span>\n</div><div class=\"md-toolbar-tools grey-100-bg border-bottom border-top pl-25\" role=\"listitem\"><h3 \nclass=\"grey-700-fg ng-scope\" translate=\"MAILING.TEST_EMAILS_CUSTOM\">Test emails</h3></div><div class=\"ph-25 pt-10\">\n<span ng-repeat=\"email in vm.currentContent.test_emails_json\" class=\"md-chip md-accent-bg\" \nstyle=\"display:inline-block;padding:4px 8px 4px 12px;margin:0 6px 6px 0;border-radius:16px;font-size:13px;color:#fff\">\n<span>{{email}}</span> <button type=\"button\" class=\"md-icon-button\" \nstyle=\"width:22px;height:22px;line-height:22px;min-height:22px;margin:0 0 0 4px;padding:0;vertical-align:middle\" \nng-click=\"vm.removeTestEmail($index)\" aria-label=\"Remove\"><md-icon md-font-icon=\"icon-close\" \nstyle=\"color:#fff;font-size:16px;line-height:22px;height:22px;width:22px\"></md-icon></button></span></div><div \nlayout=\"row\" layout-align=\"start center\" class=\"ph-25 pb-10\"><md-input-container class=\"md-block mb-0\" flex><input \ntype=\"email\" ng-model=\"vm.testEmailInput\" ng-keydown=\"vm.testEmailKeydown($event)\" \nplaceholder=\"{{vm.translate(\'MAILING.ADD_EMAILS\')}}\"></md-input-container><md-button class=\"md-icon-button md-accent\" \nng-click=\"vm.addTestEmail()\" aria-label=\"Add\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip hide show-gt-xs>\n<span translate=\"CONTENT.ADD\"></span></md-tooltip></md-button></div><md-input-container class=\"md-block mt-0\"><p \nclass=\"grey-500-fg\" style=\"word-break: break-word\" translate=\"MAILING.TEST_EMAILS_COMMENT\"></p></md-input-container>\n<md-input-container layout=\"row\" layout-align=\"start center\" flex class=\"border-top\"><md-button type=\"button\" \nng-disabled=\"vm.isSaving || (!vm.currentContent.test_emails_json.length && !(vm.currentContent.mailing_template && vm.currentContent.mailing_template.test_emails_json.length))\" \nng-click=\"vm.sendTest()\" class=\"ml-0 no-shadow send-button md-accent md-raised md-rounded md-large\" \naria-label=\"MAILING.SEND_TEST\" translate-attr-aria-label=\"MAILING.SEND_TEST\" layout=\"row\" layout-align=\"start center\">\n<span><md-icon md-font-icon=\"icon-telegram\" role=\"icon\" aria-hidden=\"true\"></md-icon><span \ntranslate=\"MAILING.SEND_TEST\"></span></span></md-button></md-input-container></div></form></div>");
$templateCache.put("app/main/apps/mailing/views/massive-messages/read/content-read-info.html","<div class=\"md-block ph-24 pv-24 border-bottom\" flex><h1 class=\"mb-5 mt-0\"><strong>{{vm.currentContent.subject}}\n</strong></h1><div class=\"font-size-16\" layout=\"column\" layout-align=\"center start\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"start center\" ng-if=\"!vm.detailsTabActive\"><span ng-bind=\"vm.currentContent.mailing_template.name\" \nng-if=\"vm.currentContent.mailing_template.name\"></span><div layout=\"row\"><strong class=\"mh-10\" \nng-if=\"vm.isSent(vm.currentContent) || vm.currentContent.scheduled_at\" hide-xs>·</strong> <span \nng-if=\"vm.isSent(vm.currentContent)\">Sent on</span> <span ng-if=\"vm.isSent(vm.currentContent)\" class=\"ml-10\" \nng-bind=\"vm.getDateFormat(vm.currentContent.sent_at)\"></span></div></div><div class=\"font-size-16\" layout=\"column\" \nlayout-gt-xs=\"row\" layout-gt-md=\"column\" layout-align=\"center start \" layout-align-gt-xs=\"start center \" \nlayout-align-gt-md=\"center start \" ng-if=\"vm.detailsTabActive\"><span ng-bind=\"vm.currentContent.mailing_template.name\" \nng-if=\"vm.currentContent.mailing_template.name\"></span><div layout=\"row\"><strong class=\"mh-10\" \nng-if=\"vm.isSent(vm.currentContent) || vm.currentContent.scheduled_at\" hide-gt-md hide-xs>·</strong> <span \nng-if=\"vm.isSent(vm.currentContent)\">Sent on</span> <span ng-if=\"vm.isSent(vm.currentContent)\" class=\"ml-10\" \nng-bind=\"vm.getDateFormat(vm.currentContent.sent_at)\"></span></div></div></div><div flex=\"100\" hide show-gt-md \nng-if=\"vm.detailsTabActive\" ms-scroll=\"vm.msScrollOptions\" \nclass=\"scrollable p-absolute width-percent-100 height-percent-100\"><div layout=\"column\" class=\"pb-100 pt-20\"><div \nlayout=\"row\" layout-align=\"center center\" class=\"mb-20\" hide><md-button class=\"md-icon-button\" type=\"button\" \naria-label=\"Circles\" ng-click=\"vm.openStatsView(\'bars\')\" ng-class=\"{\'md-accent\':vm.currentStatsView == \'bars\'}\">\n<md-icon md-font-icon=\"icon-chart-bar\" class=\"\"></md-icon></md-button><div class=\"divider-vertical\"></div><md-button \nclass=\"md-icon-button\" type=\"button\" aria-label=\"Circles\" ng-click=\"vm.openStatsView(\'circles\')\" \nng-class=\"{\'md-accent\':vm.currentStatsView == \'circles\'}\"><md-icon md-font-icon=\"icon-source-fork\" class=\"\"></md-icon>\n</md-button></div><div ng-if=\"vm.currentStatsView == \'circles\'\" hide><div class=\"text-center grey-fg\" \ntranslate=\"MAILING.MOUSE_OVER_EXPLAIN\" hide show-gt-xs>Mouse over the circles for more info</div><div \nclass=\"text-center grey-fg\" translate=\"MAILING.CLICK_EXPLAIN\" hide-gt-xs>Click on the circles for more info</div><div \nlayout=\"column\" class=\"circles-container\"><div layout=\"column\" layout-align=\"center start\" layout-gt-sm=\"row\" \nlayout-wrap class=\"pt-20 pb-20\"><div class=\"p-relative\"><h3 class=\"text-center donut-title\"><strong \ntranslate=\"MAILING.TOTAL\"></strong></h3><nvd3 options=\"vm.statsCharts.options.donut_total\" \ndata=\"vm.statsCharts.data.donut_total\"></nvd3><md-tooltip md-autohide=\"true\" md-direction=\"top\" \nstyle=\"height: auto !important\"><div class=\"font-size-14 pv-5\">The total count of emails that willbe queued<br>\nfor sending before any processing is done.</div></md-tooltip></div><div class=\"p-relative\"><h3 \nclass=\"text-center donut-title\"><strong translate=\"MAILING.SENT_STAT\"></strong></h3><nvd3 \noptions=\"vm.statsCharts.options.donut_sent\" data=\"vm.statsCharts.data.donut_sent\"></nvd3><md-tooltip \nmd-autohide=\"true\" md-direction=\"top\" style=\"height: auto !important\"><div class=\"font-size-14 pv-5\">\nA sent status means that we\'ve handed the email over to Amazon<br>\nand now it\'s up to them to evaluate whether they can send it or not.<br>Tests are not taken account in this statistic.\n</div></md-tooltip></div></div><div layout=\"row\" layout-align=\"start start\" layout-align-gt-md=\"center start\" \nlayout-wrap class=\"pt-20 top-h-line\"><div class=\"p-relative\"><h3 class=\"text-center donut-title\"><strong \ntranslate=\"MAILING.DELIVERED\"></strong></h3><nvd3 options=\"vm.statsCharts.options.donut_delivered\" \ndata=\"vm.statsCharts.data.donut_delivered\"></nvd3><md-tooltip md-autohide=\"true\" md-direction=\"top\" \nstyle=\"height: auto !important\"><div class=\"font-size-14 pv-5\">\nA message is marked as delivered when Amazon successfully contacts the<br>\ndestination mail server and it in turn accepts the email. This does not mean that the user<br>\nhas received it as there are many reasons why a mail server will accept an email but not deliver it.<br>\nSome of these include, but are not limited to:</div><div class=\"font-size-14 pv-5\">\n- The receiving mail server find a virus or marks it as SPAM.</div><div class=\"font-size-14 pv-5\">\n- The user has a full mailbox.</div><div class=\"font-size-14 pv-5\">\n- The user has configured an out-of-office responder.</div><div class=\"font-size-14 pv-5\">\nTests are not taken account in this statistic.</div></md-tooltip></div></div><div layout=\"row\" \nlayout-align=\"center start\" layout-align-gt-sm=\"start start\" layout-align-gt-md=\"center start\"><div layout=\"column\" \nlayout-align=\"center start\" layout-gt-sm=\"row\" layout-wrap class=\"pt-10 pb-40\"><div class=\"mh-5 p-relative\"><h3 \nclass=\"text-center donut-title\"><strong translate=\"MAILING.OPEN\"></strong></h3><nvd3 \noptions=\"vm.statsCharts.options.donut_opened\" data=\"vm.statsCharts.data.donut_opened\"></nvd3><md-tooltip \nmd-autohide=\"true\" md-direction=\"top\" style=\"height: auto !important\"><div class=\"font-size-14 pv-5\">\nEmails are marked as open when an invisible 1x1 tracking pixel is displayed<br>\nto the user by the email client usually when the user attempts to open an email message.<br>\nSome email clients like Gmail do not show inline images unless specifically asked to do so by the user.<br><br>\nIn cases like this, the user will open the email but the tracking pixel will not trigger so the open<br><br>\ncount will be a little lower than the real count of users who have actually opened the email.<br><br>\nTests are not taken account in this statistic.</div></md-tooltip></div><div class=\"mh-5 p-relative\"><h3 \nclass=\"text-center donut-title\"><strong translate=\"MAILING.CLICK\">Clicked</strong></h3><nvd3 \noptions=\"vm.statsCharts.options.donut_clicked\" data=\"vm.statsCharts.data.donut_clicked\"></nvd3><md-tooltip \nmd-autohide=\"true\" md-direction=\"top\" style=\"height: auto !important\"><div class=\"font-size-14 pv-5\">\nThe amount of users who clicked on a link. If a user clicks on a link multiple times, each click<br>\nis individually tracked and aggregated into this result. Click tracks are tracked up to 60 days after<br>\nan email is sent. Tests are not taken account in this statistic.</div></md-tooltip></div><div class=\"mh-5 p-relative\">\n<h3 class=\"text-center donut-title\"><strong translate=\"MAILING.COMPLAINED\"></strong></h3><nvd3 \noptions=\"vm.statsCharts.options.donut_complained\" data=\"vm.statsCharts.data.donut_complained\"></nvd3><md-tooltip \nmd-autohide=\"true\" md-direction=\"top\" style=\"height: auto !important\"><div class=\"font-size-14 pv-5\">\nSome email providers have a mechanism to report when a user marks a particular email as spam or<br>\nthat it contains a virus that Amazon didn\'t detect as it was sending it. These reports count<br>\ntowards the complained count. Tests are not taken account in this statistic but as a general<br>\nrule it is not recommended to mark an email as SPAM just to see if this works. Marking an email<br>\nas SPAM will trigger different mechanisms, some of which have consequences that cannot be<br>\neasily undone. Your overall complain rate should be below 0.1% or your account might be at risk<br>of being suspended.\n</div></md-tooltip></div></div></div><div layout=\"row\" layout-align=\"start start\" layout-align-gt-md=\"center start\" \nlayout-wrap class=\"pt-20 top-h-line\"><div class=\"p-relative\"><h3 class=\"text-center donut-title\"><strong \ntranslate=\"MAILING.NOT_DELIVERED\"></strong></h3><nvd3 options=\"vm.statsCharts.options.donut_not_delivered\" \ndata=\"vm.statsCharts.data.donut_not_delivered\"></nvd3></div></div><div layout=\"column\" layout-align=\"center center\" \nlayout-wrap class=\"pt-10\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"mh-5 p-relative\"><h3 \nclass=\"text-center donut-title\"><strong translate=\"MAILING.BOUNCED\"></strong></h3><nvd3 \noptions=\"vm.statsCharts.options.donut_bounced\" data=\"vm.statsCharts.data.donut_bounced\"></nvd3><md-tooltip \nmd-autohide=\"true\" md-direction=\"top\" style=\"height: auto !important\"><div class=\"font-size-14 pv-5\">\nThese are messages that were delivered to the destination mail servers but bounced back because<br>\nof a transient reason (also known as soft bounces). Depending on the type of bounce, Amazon<br>\nwill attempt to re-send these up to three times in a reasonable time interval. Reasons an email<br>\nmay soft-bounce is because a mailbox may be full, or the user configured an out-of-office<br>\nresponse, or a temporary delivery problem in the receiving end. Your bounce rate should be<br>\nbelow 5% or your account might be at risk of being suspended. Tests are not taken account in<br>this statistic.</div>\n</md-tooltip></div><div class=\"mh-5 p-relative\"><h3 class=\"text-center donut-title\"><strong \ntranslate=\"MAILING.REJECTED\"></strong></h3><nvd3 options=\"vm.statsCharts.options.donut_rejected\" \ndata=\"vm.statsCharts.data.donut_rejected\"></nvd3><md-tooltip md-autohide=\"true\" md-direction=\"top\" \nstyle=\"height: auto !important\"><div class=\"font-size-14 pv-5\">\nRejections happen because of two reasons. The first one being that Amazon detected a virus on<br>\nthe email contents and rejected if before even sending it.<br>\nThe second one is that Amazon rejected the email because the address was invalid.</div></md-tooltip></div></div><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"mh-5 p-relative\"><h3 class=\"text-center donut-title\">\n<strong translate=\"MAILING.SUPPRESSED\"></strong></h3><nvd3 options=\"vm.statsCharts.options.donut_suppressed\" \ndata=\"vm.statsCharts.data.donut_suppressed\"></nvd3><md-tooltip md-autohide=\"true\" md-direction=\"top\" \nstyle=\"height: auto !important\"><div class=\"font-size-14 pv-5\">\nThese are emails that Amazon has already marked as having had hard bounces previously. Qiu<br>\nsystem will automatically ignore suppressed email addresses even if you attempt to send<br>\nmessages to them. Tests are not taken account in this statistic.</div></md-tooltip></div><div class=\"mh-5 p-relative\">\n<h3 class=\"text-center donut-title\"><strong translate=\"MAILING.PROCESSING\"></strong></h3><nvd3 \noptions=\"vm.statsCharts.options.donut_not_delivered_processing\" \ndata=\"vm.statsCharts.data.donut_not_delivered_processing\"></nvd3><md-tooltip md-autohide=\"true\" md-direction=\"top\" \nstyle=\"height: auto !important\"><div class=\"font-size-14 pv-5\">\nThese are emails that the system has not yet received any response from its servers.<br>\nAfter a while this number will reach zero and all these emails will be correctly marked.</div></md-tooltip></div></div>\n</div><div layout=\"row\" layout-align=\"center start\" layout-wrap class=\"pt-20 mt-20 pb-50 top-h-line\"><div \nclass=\"p-relative\"><h3 class=\"text-center donut-title\"><strong translate=\"MAILING.BLACKLISTED\"></strong></h3><nvd3 \noptions=\"vm.statsCharts.options.donut_blacklisted\" data=\"vm.statsCharts.data.donut_blacklisted\"></nvd3><md-tooltip \nmd-autohide=\"true\" md-direction=\"top\" style=\"height: auto !important\"><div class=\"font-size-14 pv-5\">\nUnsubscribed users and hard bounced emails<br>(after 3 attempts of delivery) end up in a blacklist.<br>\nThe system won\'t send any communications to these accounts.</div></md-tooltip></div></div></div></div><div \nclass=\"mb-40\"><div layout=\"column\" hide><div layout=\"row\" layout-align=\"space-between center\" class=\"pv-20\"><div \nflex=\"50\" class=\"font-size-36 text-right pr-10\"><strong>{{vm.currentContent.total_count}}</strong></div><span \nflex=\"50\" class=\"pl-10\">Total emails in the list</span></div><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"pv-20\"><div flex=\"50\" class=\"font-size-36 text-right pr-10\"><strong>{{vm.currentContent.sent_count}}</strong>\n</div><span flex=\"50\" class=\"pl-10\">Sent to the server for delivery</span></div><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"pv-20\"><div flex=\"50\" class=\"font-size-36 text-right pr-10\"><strong>\n{{vm.currentContent.delivered_count}}</strong></div><span flex=\"50\" class=\"pl-10\">Emails delivered</span></div><div \nlayout=\"row\" layout-align=\"space-between center\" class=\"pv-20\"><div flex=\"50\" class=\"font-size-36 text-right pr-10\">\n<strong>{{vm.currentContent.open_count}}</strong></div><span flex=\"50\" class=\"pl-10\">Opened emails</span></div><div \nlayout=\"row\" layout-align=\"space-between center\" class=\"pv-20\"><div flex=\"50\" class=\"font-size-36 text-right pr-10\">\n<strong>{{vm.currentContent.clicked_count}}</strong></div><span flex=\"50\" class=\"pl-10\">Clicked emails</span></div><div\n layout=\"row\" layout-align=\"space-between center\" class=\"pv-20\"><div flex=\"50\" class=\"font-size-36 text-right pr-10\">\n<strong>{{vm.currentContent.not_delivered_count}}</strong></div><span flex=\"50\" class=\"pl-10\">Emails not delivered\n</span></div><div layout=\"row\" layout-align=\"space-between center\" class=\"pv-20\"><div flex=\"50\" \nclass=\"font-size-36 text-right pr-10\"><strong>{{vm.currentContent.blacklisted_count}}</strong></div><span flex=\"50\" \nclass=\"pl-10\">Ignored emails due to blacklisted status</span></div></div><nvd3 \noptions=\"vm.statsCharts.options.all_vertical\" data=\"vm.statsCharts.data.all\" class=\"bars-graph\" layout=\"row\" \nlayout-align=\"center center\"></nvd3></div></div></div>");
$templateCache.put("app/main/apps/mailing/views/massive-messages/read/content-read-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-if=\"vm.loadingReadPane\" class=\"loading-container\" \nstyle=\"z-index: 2\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nng-if=\"!vm.templateSelected\"><div class=\"mail-content\" layout=\"column\" layout-align=\"center center\" \nng-if=\"!vm.loadTemplates\"><div class=\"content\" layout=\"column\" layout-align=\"top center\"><div class=\"message\" \ntranslate=\"MAILING.SELECT_ITEM_TO_SHOW\"></div></div></div><div \nclass=\"md-toolbar-tools grey-100-bg colored-bg border-bottom\" layout=\"row\" layout-align=\"space-between center\" \nscroll=\"\" ng-if=\"vm.loadTemplates\"><div layout=\"row\" layout-align=\"start center\"><h3 class=\"grey-700-fg pl-10\" \ntranslate=\"MAILING.SELECT_TEMPLATE\"></h3></div><div layout=\"row\" layout-align=\"end center\"><button \nclass=\"md-raised md-warn md-button md-default-theme\" type=\"button\" ng-click=\"vm.disableTemplates()\" \naria-label=\"Cancel\" translate=\"CONTENT.CANCEL\">Cancel</button></div></div><div flex layout=\"row\" \nlayout-align=\"start center\" class=\"search\" ng-if=\"vm.loadTemplates\"><label for=\"ms-search-bar-input\"><md-icon \nid=\"ms-search-bar-expander\" md-font-icon=\"icon-magnify\" class=\"md-icon-button md-button\"></md-icon></label><input \nid=\"ms-search-bar-input\" type=\"text\" ng-model=\"vm.query\" placeholder=\"Search\" md-autofocus translate \ntranslate-attr-placeholder=\"TOOLBAR.SEARCH\" flex ng-enter=\"\"></div><md-list id=\"list-content-data\" \nng-style=\"{\'opacity\' : isLoading ? 0.2 : 1}\" ng-if=\"vm.loadTemplates\" class=\"pv-0 scrollable templates-list\" \nms-scroll=\"vm.msScrollOptions\"><md-list-item class=\"mail-list-item border-bottom\" \nng-repeat=\"thread in vm.templates | filter: vm.search | filter: vm.query\" ng-init=\"parentIndex= $index\" md-no-ink \nng-class=\"{\'starred\': thread.starred}\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><div \nclass=\"font-size-16\" flex layout=\"column\"><div class=\"mb-5\" layout=\"row\" layout-align=\"start center\"><strong>\n{{thread.name}}</strong></div><div class=\"font-size-12\" layout=\"row\" layout-align=\"start start\"><span \nclass=\"title grey-500-fg mr-5\" translate=\"MAILING.FROM\" hide show-gt-sm></span><div layout-sm=\"column\" \nlayout-xs=\"column\"><span ng-bind=\"thread.from_name\" class=\"mr-5\"></span> <span hide show-gt-sm class=\"mr-5\">-</span> \n<span ng-bind=\"thread.from_email\"></span></div></div></div><div layout=\"row\" layout-align=\"end center\"><img \nclass=\"img-flag ng-scope\" ng-if=\"thread.lang\" alt=\"{{vm.siteLanguages()[thread.lang]}}\" \nng-src=\"assets/images/flags/{{vm.siteLanguages()[thread.lang].flag_code|lowercase}}.svg\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.previewTemplate($event, thread)\"><md-icon md-font-icon=\"icon-eye\"><md-tooltip hide \nshow-gt-xs><span translate=\"MAILING.PREVIEW\"></span></md-tooltip></md-icon></md-button><md-button hide show-gt-xs \naria-label=\"MAILING.SELECT\" class=\"white-fg md-small green-500-bg mh-0\" ng-click=\"vm.openTemplate(thread, true)\"><span \ntranslate=\"MAILING.SELECT\"></span></md-button><md-button hide-gt-xs aria-label=\"MAILING.SELECT\" \nclass=\"md-icon-button md-mini md-fab green-500-bg\" ng-click=\"vm.openTemplate(thread, true)\"><md-icon \nmd-font-icon=\"icon-check\"></md-icon></md-button></div></div></md-list-item></md-list></div><div \nng-if=\"vm.templateSelected\" class=\"form-wrapper\"><form name=\"vm.basicForm\" class=\"md-inline-form\" novalidate><div \nclass=\"toolbar grey-100-bg colored-bg\" layout=\"row\" layout-align=\"space-between center\" scroll=\"\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button close-thread\" aria-label=\"Back\" \nng-click=\"vm.closeTemplate()\" translate translate-attr-aria-label=\"CONTENT.BACK\" ng-if=\"vm.currentView !== \'split\'\">\n<md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><md-button ng-if=\"vm.isSent(vm.currentContent)\" \naria-label=\"Stats\" class=\"md-icon-button\" \nng-class=\"{\'md-accent\':vm.currentContentView == \'stats\' || vm.isSent(vm.currentContent) && vm.currentContentView != \'send\'}\" \nng-click=\"vm.openContentView(\'stats\');\" translate=\"\" translate-attr-aria-label=\"MAILING.STATS\"><md-icon \nmd-font-icon=\"icon-chart-line\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"MAILING.STATS\"></span>\n</md-tooltip></md-button><md-button aria-label=\"Content\" class=\"md-icon-button\" \nng-class=\"{\'md-accent\':vm.currentContentView == \'massive-messages\'}\" ng-click=\"vm.openContentView(\'massive-messages\')\" \ntranslate=\"\" translate-attr-aria-label=\"MAILING.CONTENT\" ng-if=\"!vm.isSent(vm.currentContent)\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"MAILING.EDIT\"></span></md-tooltip>\n</md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button aria-label=\"Send\" class=\"md-icon-button\" \nng-click=\"vm.openPreview(); vm.tabSelected= \'null\';\" translate=\"\" translate-attr-aria-label=\"MAILING.PREVIEW\" \nng-disabled=\"!vm.currentContent.structure_mjml\"><md-icon md-font-icon=\"icon-web\"></md-icon><md-tooltip hide show-gt-xs>\n<span translate=\"MAILING.PREVIEW\"></span></md-tooltip></md-button><div class=\"divider-vertical\" hide show-gt-sm \nng-if=\"vm.mailingPreviewUrl\"></div><md-button aria-label=\"Send\" class=\"md-icon-button\" \nng-click=\"vm.openExternalPreview(); vm.tabSelected= \'null\';\" translate=\"\" translate-attr-aria-label=\"MAILING.PREVIEW\" \nng-disabled=\"!vm.currentContent.structure_mjml\" ng-if=\"vm.mailingPreviewUrl\"><md-icon md-font-icon=\"icon-link\">\n</md-icon><md-tooltip hide show-gt-xs><span translate=\"MAILING.PUBLIC_PREVIEW\"></span></md-tooltip></md-button><div \nclass=\"divider-vertical\" hide show-gt-sm></div><md-button aria-label=\"Send\" class=\"md-icon-button\" \nng-class=\"{\'md-accent\':vm.currentContentView == \'send\'}\" \nng-click=\"vm.openContentView(\'send\'); vm.tabSelected= \'null\';\" translate=\"\" translate-attr-aria-label=\"CMAILING.SEND\" \nng-disabled=\"vm.basicForm.$dirty\"><md-icon md-font-icon=\"icon-telegram\"><md-tooltip hide show-gt-xs \nng-if=\"vm.basicForm.$dirty\"><span translate=\"MAILING.SEND_ALERT\"></span></md-tooltip></md-icon><md-tooltip hide \nshow-gt-xs><span translate=\"MAILING.SEND\"></span></md-tooltip></md-button><div class=\"divider-vertical\" hide \nshow-gt-sm></div><md-button aria-label=\"Send\" class=\"md-icon-button\" \nng-click=\"vm.openExternalPDF(); vm.tabSelected= \'null\';\" translate=\"\" translate-attr-aria-label=\"MAILING.PDF_FILE\" \nng-disabled=\"!vm.currentContent.structure_mjml || vm.isLoadingPDF\" ng-if=\"vm.mailingPreviewUrl\"><md-icon \nmd-font-icon=\"icon-file-pdf-box\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"MAILING.PDF_FILE\"></span>\n</md-tooltip></md-button></div><div ng-if=\"vm.detailsTabActive\" layout=\"row\" layout-align=\"end center\"><button \nclass=\"mr-15\" ng-click=\"vm.onTabSelected(\'graphs\'); vm.detailsTabActive= false; vm.selectedIndex= 0;\" md-chip-remove>\n<md-icon md-font-icon=\"icon-close\"></md-icon></button></div><div layout=\"row\" layout-align=\"end center\" hide \nshow-gt-sm \nng-if=\"!vm.isSent(vm.currentContent) && (vm.currentContentView == \'massive-messages\' || vm.currentContentView == \'send\')\">\n<md-button ng-click=\"vm.saveContent()\" class=\"send-button md-accent md-raised\" aria-label=\"SAVE\" \ntranslate=\"MAILING.SAVE\" translate-attr-aria-label=\"MAILING.SAVE\"></md-button><md-button type=\"button\" \nng-click=\"vm.closeTemplate()\" class=\"md-raised md-warn\" aria-label=\"Cancel\" translate=\"MAILING.CANCEL\" \ntranslate-attr-aria-label=\"MAILING.CANCEL\"></md-button></div><div layout=\"row\" layout-align=\"end center\" hide-gt-sm \nng-if=\"!vm.isSent(vm.currentContent) && (vm.currentContentView == \'massive-messages\' || vm.currentContentView == \'send\')\">\n<md-button ng-click=\"vm.saveContent()\" class=\"md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme\" \naria-label=\"SAVE\"><md-icon md-font-icon=\"icon-check\"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate=\"MAILINT.SAVE\"></span></md-tooltip></md-button><md-button type=\"button\" ng-click=\"vm.closeTemplate()\" \nclass=\"md-warn md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme\" aria-label=\"Cancel\"><md-icon \nmd-font-icon=\"icon-window-close\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"MAILING.CANCEL\"></span>\n</md-tooltip></md-button></div></div><div id=\"content-stats\" ms-scroll=\"vm.msScrollOptions\" \nclass=\"scrollable page-layout simple fullwidth mail-content content-edit content-send\" layout=\"column\" \nng-if=\"vm.currentContentView == \'stats\' || vm.isSent(vm.currentContent) && vm.currentContentView != \'send\'\"><div \nclass=\"form-wrapper\" flex=\"100\"><div hide-gt-md \nng-include=\"\'app/main/apps/mailing/views/massive-messages/read/content-read-info.html\'\"></div><md-menu-bar \nclass=\"pr-0 pl-0\" id=\"log-menu\" ng-if=\"vm.detailsTabActive==true\"><md-menu><md-button \nclass=\"menu-button-custom md-icon-button\" aria-label=\"Actions\" ng-click=\"$mdMenu.open($event)\" layout=\"row\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-cog\"></md-icon></md-button><md-menu-content><md-menu-item>\n<md-button aria-label=\"EXPORTALL\" ng-click=\"vm.exportMailingLogByMailingContentId(vm.currentContent.id_message)\">\n<md-icon md-font-icon=\"icon-cloud-download\"></md-icon><span translate=\"MAILING.DOWNLOAD_LIST\">DOWNLOAD LIST</span>\n</md-button></md-menu-item><md-menu-item><md-button aria-label=\"ISOLATE ALL BOUNCES\" \nng-click=\"vm.isolateBounces(vm.currentContent.id_message)\"><md-icon md-font-icon=\"icon-folder-remove\"></md-icon><span \ntranslate=\"MAILING.ISOLATE_ALL_BOUNCES\">MOVE ALL BOUNCES</span></md-button></md-menu-item><md-menu-item><md-button \naria-label=\"ISOLATE HARD BOUNCES\" ng-click=\"vm.isolateBounces(vm.currentContent.id_message, \'permanent\')\"><md-icon \nmd-font-icon=\"icon-folder-remove\"></md-icon><span translate=\"MAILING.ISOLATE_HARD_BOUNCES\">MOVE HARD BOUNCES</span>\n</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><md-tabs md-selected=\"vm.selectedIndex\" \nmd-dynamic-height md-stretch-tabs=\"never\"><md-tab \nmd-on-select=\"vm.onTabSelected(\'graphs\'); vm.detailsTabActive= false;\" label=\"{{vm.translate(\'MAILING.GRAPHS\')}}\"><div \nlayout=\"row\" ng-include=\"\'app/main/apps/mailing/views/massive-messages/read/content-tab-graphs.html\'\"></div></md-tab>\n<md-tab md-on-select=\"vm.onTabSelected(\'details\'); vm.detailsTabActive= true;\" \nlabel=\"{{vm.translate(\'MAILING.DETAILS\')}}\"><div layout=\"row\" \nng-include=\"\'app/main/apps/mailing/views/massive-messages/read/content-tab-details.html\'\"></div></md-tab><md-tab \nmd-on-select=\"vm.onTabSelected(\'details\'); vm.detailsTabActive= true;\" label=\"{{vm.translate(\'MAILING.CLICKS\')}}\"><div \nlayout=\"row\" ng-include=\"\'app/main/apps/mailing/views/massive-messages/read/content-tab-clicks.html\'\"></div></md-tab>\n</md-tabs></div></div><div id=\"content-edit\" ms-scroll=\"vm.msScrollOptions\" \nclass=\"scrollable page-layout simple fullwidth mail-content content-edit\" layout=\"column\" \nng-if=\"vm.currentContentView == \'massive-messages\' && !vm.isSent(vm.currentContent)\"><div layout=\"row\" \nng-include=\"\'app/main/apps/mailing/views/massive-messages/read/content-tab-edit.html\'\"></div></div><div \nid=\"content-send\" ms-scroll=\"vm.msScrollOptions\" \nclass=\"scrollable page-layout simple fullwidth mail-content content-edit content-send\" layout=\"column\" \nng-if=\"vm.currentContentView == \'send\'\"><div class=\"form-wrapper\" flex=\"100\"><div \nclass=\"md-block ph-24 pv-20 border-bottom\" flex><h1 class=\"mb-5 mt-0\"><strong>{{vm.currentContent.subject}}</strong>\n</h1><div class=\"font-size-16\" layout=\"row\" layout-align=\"start center\"><span \nng-bind=\"vm.currentContent.mailing_template.name\" ng-if=\"vm.currentContent.mailing_template.name\"></span><div \nlayout=\"row\"><strong class=\"mh-10\" ng-if=\"vm.isSent(vm.currentContent) || vm.currentContent.scheduled_at\">·</strong> \n<span ng-if=\"vm.isSent(vm.currentContent)\">Sent on</span> <span ng-if=\"vm.isSent(vm.currentContent)\" class=\"ml-10\" \nng-bind=\"vm.getDateFormat(vm.currentContent.sent_at)\"></span> <span \nng-if=\"vm.currentContent.id_message_status == 2 || (vm.currentContent.id_message_status == 3 && vm.currentContent.scheduled_at)\">\nScheduled for</span> <span \nng-if=\"vm.currentContent.id_message_status == 2 || (vm.currentContent.id_message_status == 3 && vm.currentContent.scheduled_at)\" \nclass=\"ml-5\" ng-bind=\"vm.getDateFormat(vm.currentContent.scheduled_at)\"></span></div></div></div><md-tabs \nmd-dynamic-height><md-tab label=\"{{vm.translate(\'MAILING.SEND_TEST\')}}\"><div layout=\"row\" \nng-include=\"\'app/main/apps/mailing/views/massive-messages/read/content-tab-send-test.html\'\"></div></md-tab><md-tab \nlabel=\"{{vm.translate(\'MAILING.SEND\')}}\" ng-if=\"!vm.isSent(vm.currentContent)\"><div layout=\"row\" \nng-include=\"\'app/main/apps/mailing/views/massive-messages/read/content-tab-send.html\'\"></div></md-tab></md-tabs></div>\n</div></form></div>");
$templateCache.put("app/main/apps/mailing/views/massive-messages/read/content-select-channel.html","<div flex layout=\"column\" layout-align=\"center center\" ng-if=\"vm.loadingReadPane\" class=\"loading-container\" \nstyle=\"z-index: 2\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nng-if=\"!vm.templateSelected\"><div class=\"mail-content\" layout=\"column\" layout-align=\"center center\" \nng-if=\"!vm.loadChannels\"><div class=\"content\" layout=\"column\" layout-align=\"top center\"><div class=\"message\" \ntranslate=\"MAILING.SELECT_ITEM_TO_SHOW\"></div></div></div><div \nclass=\"md-toolbar-tools grey-100-bg colored-bg border-bottom\" layout=\"row\" layout-align=\"space-between center\" \nscroll=\"\" ng-if=\"vm.loadChannels\"><div layout=\"row\" layout-align=\"start center\"><h3 class=\"grey-700-fg pl-10\" \ntranslate=\"MAILING.SELECT_CHANNEL\"></h3></div></div><div flex layout=\"row\" layout-align=\"start center\" class=\"search\" \nng-if=\"vm.loadChannels\"><label for=\"ms-search-bar-input\"><md-icon id=\"ms-search-bar-expander\" \nmd-font-icon=\"icon-magnify\" class=\"md-icon-button md-button\"></md-icon></label><input id=\"ms-search-bar-input\" \ntype=\"text\" ng-model=\"vm.query\" placeholder=\"Search\" md-autofocus translate \ntranslate-attr-placeholder=\"TOOLBAR.SEARCH\" flex ng-enter=\"\"></div><md-list id=\"list-content-data\" \nng-style=\"{\'opacity\' : isLoading ? 0.2 : 1}\" ng-if=\"vm.loadChannels\" class=\"pv-0 scrollable channels-list\" \nms-scroll=\"vm.msScrollOptions\"><md-list-item class=\"mail-list-item border-bottom\" \nng-repeat=\"thread in vm.channels | filter: vm.search | filter: vm.query\" ng-init=\"parentIndex= $index\" md-no-ink \nng-class=\"{\'starred\': thread.starred}\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><div \nclass=\"font-size-16\" flex layout=\"column\"><div class=\"mb-5\" layout=\"row\" layout-align=\"start center\"><strong \nng-bind=\"thread.type\"></strong></div><div class=\"font-size-12\" layout=\"row\" layout-align=\"start start\"><div \nlayout-sm=\"column\" layout-xs=\"column\"></div></div></div><div layout=\"row\" layout-align=\"end center\"><md-button hide \nshow-gt-xs aria-label=\"MAILING.SELECT\" class=\"white-fg md-small green-500-bg mh-0\" ng-click=\"vm.newContent()\"><span \ntranslate=\"MAILING.SELECT\"></span></md-button></div></div></md-list-item></md-list></div><div \nng-if=\"vm.templateSelected\" class=\"form-wrapper\"><form name=\"vm.basicForm\" class=\"md-inline-form\" novalidate><div \nclass=\"toolbar grey-100-bg colored-bg\" layout=\"row\" layout-align=\"space-between center\" scroll=\"\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button close-thread\" aria-label=\"Back\" \nng-click=\"vm.closeTemplate()\" translate translate-attr-aria-label=\"CONTENT.BACK\" ng-if=\"vm.currentView !== \'split\'\">\n<md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><md-button ng-if=\"vm.isSent(vm.currentContent)\" \naria-label=\"Stats\" class=\"md-icon-button\" \nng-class=\"{\'md-accent\':vm.currentContentView == \'stats\' || vm.isSent(vm.currentContent) && vm.currentContentView != \'send\'}\" \nng-click=\"vm.openContentView(\'stats\');\" translate=\"\" translate-attr-aria-label=\"MAILING.STATS\"><md-icon \nmd-font-icon=\"icon-chart-line\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"MAILING.STATS\"></span>\n</md-tooltip></md-button><md-button aria-label=\"Content\" class=\"md-icon-button\" \nng-class=\"{\'md-accent\':vm.currentContentView == \'content\'}\" ng-click=\"vm.openContentView(\'massive-messages\')\" \ntranslate=\"\" translate-attr-aria-label=\"MAILING.CONTENT\" ng-if=\"!vm.isSent(vm.currentContent)\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"MAILING.EDIT\"></span></md-tooltip>\n</md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button aria-label=\"Send\" class=\"md-icon-button\" \nng-click=\"vm.openPreview(); vm.tabSelected= \'null\';\" translate=\"\" translate-attr-aria-label=\"MAILING.PREVIEW\" \nng-disabled=\"!vm.currentContent.structure_mjml\"><md-icon md-font-icon=\"icon-web\"></md-icon><md-tooltip hide show-gt-xs>\n<span translate=\"MAILING.PREVIEW\"></span></md-tooltip></md-button><div class=\"divider-vertical\" hide show-gt-sm \nng-if=\"vm.mailingPreviewUrl\"></div><md-button aria-label=\"Send\" class=\"md-icon-button\" \nng-click=\"vm.openExternalPreview(); vm.tabSelected= \'null\';\" translate=\"\" translate-attr-aria-label=\"MAILING.PREVIEW\" \nng-disabled=\"!vm.currentContent.structure_mjml\" ng-if=\"vm.mailingPreviewUrl\"><md-icon md-font-icon=\"icon-link\">\n</md-icon><md-tooltip hide show-gt-xs><span translate=\"MAILING.PUBLIC_PREVIEW\"></span></md-tooltip></md-button><div \nclass=\"divider-vertical\" hide show-gt-sm></div><md-button aria-label=\"Send\" class=\"md-icon-button\" \nng-class=\"{\'md-accent\':vm.currentContentView == \'send\'}\" \nng-click=\"vm.openContentView(\'send\'); vm.tabSelected= \'null\';\" translate=\"\" translate-attr-aria-label=\"CMAILING.SEND\" \nng-disabled=\"vm.basicForm.$dirty\"><md-icon md-font-icon=\"icon-telegram\"><md-tooltip hide show-gt-xs \nng-if=\"vm.basicForm.$dirty\"><span translate=\"MAILING.SEND_ALERT\"></span></md-tooltip></md-icon><md-tooltip hide \nshow-gt-xs><span translate=\"MAILING.SEND\"></span></md-tooltip></md-button><div class=\"divider-vertical\" hide \nshow-gt-sm></div><md-button aria-label=\"Send\" class=\"md-icon-button\" \nng-click=\"vm.openExternalPDF(); vm.tabSelected= \'null\';\" translate=\"\" translate-attr-aria-label=\"MAILING.PDF_FILE\" \nng-disabled=\"!vm.currentContent.structure_mjml || vm.isLoadingPDF\" ng-if=\"vm.mailingPreviewUrl\"><md-icon \nmd-font-icon=\"icon-file-pdf-box\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"MAILING.PDF_FILE\"></span>\n</md-tooltip></md-button></div><div ng-if=\"vm.detailsTabActive\" layout=\"row\" layout-align=\"end center\"><button \nclass=\"mr-15\" ng-click=\"vm.onTabSelected(\'graphs\'); vm.detailsTabActive= false; vm.selectedIndex= 0;\" md-chip-remove>\n<md-icon md-font-icon=\"icon-close\"></md-icon></button></div><div layout=\"row\" layout-align=\"end center\" hide \nshow-gt-sm \nng-if=\"!vm.isSent(vm.currentContent) && (vm.currentContentView == \'content\' || vm.currentContentView == \'send\')\">\n<md-button ng-click=\"vm.saveContent()\" class=\"send-button md-accent md-raised\" aria-label=\"SAVE\" \ntranslate=\"MAILING.SAVE\" translate-attr-aria-label=\"MAILING.SAVE\"></md-button><md-button type=\"button\" \nng-click=\"vm.closeTemplate()\" class=\"md-raised md-warn\" aria-label=\"Cancel\" translate=\"MAILING.CANCEL\" \ntranslate-attr-aria-label=\"MAILING.CANCEL\"></md-button></div><div layout=\"row\" layout-align=\"end center\" hide-gt-sm \nng-if=\"!vm.isSent(vm.currentContent) && (vm.currentContentView == \'content\' || vm.currentContentView == \'send\')\">\n<md-button ng-click=\"vm.saveContent()\" class=\"md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme\" \naria-label=\"SAVE\"><md-icon md-font-icon=\"icon-check\"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate=\"MAILINT.SAVE\"></span></md-tooltip></md-button><md-button type=\"button\" ng-click=\"vm.closeTemplate()\" \nclass=\"md-warn md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme\" aria-label=\"Cancel\"><md-icon \nmd-font-icon=\"icon-window-close\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"MAILING.CANCEL\"></span>\n</md-tooltip></md-button></div></div><div id=\"content-stats\" ms-scroll=\"vm.msScrollOptions\" \nclass=\"scrollable page-layout simple fullwidth mail-content content-edit content-send\" layout=\"column\" \nng-if=\"vm.currentContentView == \'stats\' || vm.isSent(vm.currentContent) && vm.currentContentView != \'send\'\"><div \nclass=\"form-wrapper\" flex=\"100\"><div hide-gt-md \nng-include=\"\'app/main/apps/mailing/views/massive-messages/read/content-read-info.html\'\"></div><md-menu-bar \nclass=\"pr-0 pl-0\" id=\"log-menu\" ng-if=\"vm.detailsTabActive==true\"><md-menu><md-button \nclass=\"menu-button-custom md-icon-button\" aria-label=\"Actions\" ng-click=\"$mdMenu.open($event)\" layout=\"row\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-cog\"></md-icon></md-button><md-menu-content><md-menu-item>\n<md-button aria-label=\"EXPORTALL\" \nng-click=\"vm.exportMailingLogByMailingContentId(vm.currentContent.id_mailing_content)\"><md-icon \nmd-font-icon=\"icon-cloud-download\"></md-icon><span translate=\"MAILING.DOWNLOAD_LIST\">DOWNLOAD LIST</span></md-button>\n</md-menu-item><md-menu-item><md-button aria-label=\"ISOLATE ALL BOUNCES\" \nng-click=\"vm.isolateBounces(vm.currentContent.id_mailing_content)\"><md-icon md-font-icon=\"icon-folder-remove\">\n</md-icon><span translate=\"MAILING.ISOLATE_ALL_BOUNCES\">MOVE ALL BOUNCES</span></md-button></md-menu-item>\n<md-menu-item><md-button aria-label=\"ISOLATE HARD BOUNCES\" \nng-click=\"vm.isolateBounces(vm.currentContent.id_mailing_content, \'permanent\')\"><md-icon \nmd-font-icon=\"icon-folder-remove\"></md-icon><span translate=\"MAILING.ISOLATE_HARD_BOUNCES\">MOVE HARD BOUNCES</span>\n</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><md-tabs md-selected=\"vm.selectedIndex\" \nmd-dynamic-height md-stretch-tabs=\"never\"><md-tab \nmd-on-select=\"vm.onTabSelected(\'graphs\'); vm.detailsTabActive= false;\" label=\"{{vm.translate(\'MAILING.GRAPHS\')}}\"><div \nlayout=\"row\" ng-include=\"\'app/main/apps/mailing/views/massive-messages/read/content-tab-graphs.html\'\"></div></md-tab>\n<md-tab md-on-select=\"vm.onTabSelected(\'details\'); vm.detailsTabActive= true;\" \nlabel=\"{{vm.translate(\'MAILING.DETAILS\')}}\"><div layout=\"row\" \nng-include=\"\'app/main/apps/mailing/views/massive-messages/read/content-tab-details.html\'\"></div></md-tab></md-tabs>\n</div></div><div id=\"content-edit\" ms-scroll=\"vm.msScrollOptions\" \nclass=\"scrollable page-layout simple fullwidth mail-content content-edit\" layout=\"column\" \nng-if=\"vm.currentContentView == \'content\' && !vm.isSent(vm.currentContent)\"><div layout=\"row\" \nng-include=\"\'app/main/apps/mailing/views/massive-messages/read/content-tab-edit.html\'\"></div></div><div \nid=\"content-send\" ms-scroll=\"vm.msScrollOptions\" \nclass=\"scrollable page-layout simple fullwidth mail-content content-edit content-send\" layout=\"column\" \nng-if=\"vm.currentContentView == \'send\'\"><div class=\"form-wrapper\" flex=\"100\"><div \nclass=\"md-block ph-24 pv-20 border-bottom\" flex><h1 class=\"mb-5 mt-0\"><strong>{{vm.currentContent.subject}}</strong>\n</h1><div class=\"font-size-16\" layout=\"row\" layout-align=\"start center\"><span \nng-bind=\"vm.currentContent.mailing_template.name\" ng-if=\"vm.currentContent.mailing_template.name\"></span><div \nlayout=\"row\"><strong class=\"mh-10\" ng-if=\"vm.isSent(vm.currentContent) || vm.currentContent.scheduled_at\">·</strong> \n<span ng-if=\"vm.isSent(vm.currentContent)\">Sent on</span> <span ng-if=\"vm.isSent(vm.currentContent)\" class=\"ml-10\" \nng-bind=\"vm.getDateFormat(vm.currentContent.sent_at)\"></span> <span \nng-if=\"vm.currentContent.id_message_status == 2 || (vm.currentContent.id_message_status == 3 && vm.currentContent.scheduled_at)\">\nScheduled for</span> <span \nng-if=\"vm.currentContent.id_message_status == 2 || (vm.currentContent.id_message_status == 3 && vm.currentContent.scheduled_at)\" \nclass=\"ml-5\" ng-bind=\"vm.getDateFormat(vm.currentContent.scheduled_at)\"></span></div></div></div><md-tabs \nmd-dynamic-height><md-tab label=\"{{vm.translate(\'MAILING.SEND_TEST\')}}\"><div layout=\"row\" \nng-include=\"\'app/main/apps/mailing/views/massive-messages/read/content-tab-send-test.html\'\"></div></md-tab><md-tab \nlabel=\"{{vm.translate(\'MAILING.SEND\')}}\" ng-if=\"!vm.isSent(vm.currentContent)\"><div layout=\"row\" \nng-include=\"\'app/main/apps/mailing/views/massive-messages/read/content-tab-send.html\'\"></div></md-tab></md-tabs></div>\n</div></form></div>");
$templateCache.put("app/main/apps/mailing/views/massive-messages/read/content-tab-clicks.html","<div class=\"form-wrapper\" flex=\"100\"><div><div class=\"grey-100-bg border-bottom item-log toolbar-log\" hide><button \nflex class=\"status pill\" ng-click=\"vm.filter= \'\';vm.activateFilter(true)\" \nng-class=\"{\'md-accent-bg\': vm.filter=== \'\' || !vm.filter}\">{{ \'MAILING.ALL\' | translate}}</button> <button flex \nclass=\"status pill\" ng-click=\"vm.filter= \'clicked\'; vm.activateFilter(true)\" \nng-class=\"{\'md-accent-bg\':vm.filter=== \'clicked\'}\">{{ \'MAILING.CLICK\' | translate}}</button></div><md-list \nclass=\"pt-0\" ng-style=\"{\'opacity\' : vm.loadingReadPane ? 0.2 : 1}\"><md-list-item \nng-repeat=\"(link, count) in vm.clickCount\" class=\"border-bottom text-center item-log\" \nstyle=\"padding-left: 0px!important; padding-right: 0px!important\"><md-list-item><div \nclass=\"text-left word-break-word pl-20\" flex=\"40\" flex-gt-xs=\"90\">{{ link }}</div><button \nclass=\"status green-300-bg pill\">{{ count }} {{ \'MAILING.CLICKS\' | translate}}</button></md-list-item></md-list-item>\n<div ng-if=\"!isLoading && vm.pagination_total_log_pages> vm.pagination_log_page && vm.logs.length > 0\" \nclass=\"load-more white p-30\" layout=\"row\" layout-sm=\"column\" layout-align=\"center center\" layout-wrap=\"\"><md-button \nng-click=\"vm.nextPageLog+ 1; vm.activateFilter();\" class=\"md-raised\">{{ \'GLOBAL.LOAD_MORE\' | translate}}</md-button>\n</div></md-list></div></div>");
$templateCache.put("app/main/apps/mailing/views/massive-messages/read/content-tab-details.html","<div class=\"form-wrapper\" flex=\"100\"><div><div class=\"grey-100-bg border-bottom item-log toolbar-log\" hide><button \nflex class=\"status pill\" ng-click=\"vm.filter= \'\';vm.activateFilter(true)\" \nng-class=\"{\'md-accent-bg\': vm.filter=== \'\' || !vm.filter}\">{{ \'MAILING.ALL\' | translate}}</button> <button flex \nclass=\"status pill\" ng-click=\"vm.filter= \'opened\'; vm.activateFilter(true)\" \nng-class=\"{\'md-accent-bg\':vm.filter=== \'opened\'}\">{{ \'MAILING.OPEN\' | translate}}</button> <button flex \nclass=\"status pill\" ng-click=\"vm.filter= \'clicked\'; vm.activateFilter(true)\" \nng-class=\"{\'md-accent-bg\':vm.filter=== \'clicked\'}\">{{ \'MAILING.CLICK\' | translate}}</button> <button flex \nclass=\"status pill\" ng-click=\"vm.filter= \'bounced\'; vm.activateFilter(true)\" \nng-class=\"{\'md-accent-bg\':vm.filter=== \'bounced\'}\">{{ \'MAILING.BOUNCED\' | translate}}</button> <button flex \nclass=\"status pill\" ng-click=\"vm.filter= \'rejected\'; vm.activateFilter(true)\" \nng-class=\"{\'md-accent-bg\':vm.filter=== \'rejected\'}\">{{ \'MAILING.REJECTED\' | translate}}</button> <button flex \nclass=\"status pill\" ng-click=\"vm.filter= \'complained\'; vm.activateFilter(true)\" \nng-class=\"{\'md-accent-bg\':vm.filter=== \'complained\'}\">{{ \'MAILING.COMPLAINED\' | translate}}</button> <button flex \nclass=\"status pill\" ng-click=\"vm.filter= \'suppressed\'; vm.activateFilter(true)\" \nng-class=\"{\'md-accent-bg\':vm.filter=== \'suppressed\'}\">{{ \'MAILING.SUPPRESSED\' | translate}}</button> <button flex \nclass=\"status pill\" ng-click=\"vm.filter= \'unsubscribed\'; vm.activateFilter(true)\" \nng-class=\"{\'md-accent-bg\':vm.filter=== \'unsubscribed\'}\">{{ \'MAILING.UNSUBSCRIBED\' | translate}}</button></div><div \nhide-gt-xs class=\"grey-100-bg text-center toolbar-log\" layout=\"row\" layout-align=\"space-between center\"><div \nflex=\"100\" ng-style=\"{\'opacity\' : vm.isLoading ? 0.2 : 1}\" flex layout=\"row\" layout-align=\"space-between center\" \nclass=\"search-bar pv-5 mr-0\"><label for=\"search-bar-input\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"md-icon-button md-button\" ng-click=\"vm.activateFilter(true);\"><md-tooltip><span translate=\"TOOLBAR.SEARCH\">\nSearch</span></md-tooltip></md-icon></label><input id=\"search-bar-input\" type=\"text\" ng-model=\"vm.searchString\" \nplaceholder=\"Search\" md-autofocus ng-enter=\"vm.activateFilter(true)\" translate \ntranslate-attr-placeholder=\"TOOLBAR.SEARCH\" flex><md-icon md-font-icon=\"icon-close-circle\" class=\"icon s24 pt-0\" \nng-if=\"vm.searchString\" ng-click=\"vm.searchString= \'\'; vm.activateFilter(true)\"></md-icon></div></div><div \nclass=\"grey-100-bg border-bottom text-center toolbar-log\" layout=\"row\" layout-align=\"space-between center\"><div \nflex=\"40\" flex-gt-xs=\"60\" layout=\"row\" layout-align=\"start center\"><div hide show-gt-xs flex=\"45\" \nng-style=\"{\'opacity\' : vm.isLoading ? 0.2 : 1}\" flex layout=\"row\" layout-align=\"space-between center\" \nclass=\"search-bar pv-5 mr-0\"><label for=\"search-bar-input\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"md-icon-button md-button\" ng-click=\"vm.activateFilter(true);\"><md-tooltip><span translate=\"TOOLBAR.SEARCH\">\nSearch</span></md-tooltip></md-icon></label><input id=\"search-bar-input\" type=\"text\" ng-model=\"vm.searchString\" \nplaceholder=\"Search\" md-autofocus ng-enter=\"vm.activateFilter(true)\" translate \ntranslate-attr-placeholder=\"TOOLBAR.SEARCH\" flex><md-icon md-font-icon=\"icon-close-circle\" class=\"icon s24 pt-0\" \nng-if=\"vm.searchString\" ng-click=\"vm.searchString= \'\'; vm.activateFilter(true)\"></md-icon></div><md-button \nstyle=\"width: 50px\" aria-label=\"Filter by groups\" class=\"md-icon-button\" translate=\"\" \ntranslate-attr-aria-label=\"MAILING.FILTER_BY_GROUPS\"><md-icon ng-if=\"!vm.groupFiltered\" \nng-click=\"vm.openGroupsDialog()\" md-font-icon=\"icon-filter-outline\" \nclass=\"md-default-theme md-font material-icons icon-filter-multiple\" role=\"img\" aria-hidden=\"true\"><md-tooltip><span \ntranslate=\"MAILING.FILTER_BY_GROUPS\"></span></md-tooltip></md-icon><md-icon \nng-click=\"vm.groupFiltered= null; vm.activateFilter(true);\" ng-if=\"vm.groupFiltered\" \nmd-font-icon=\"icon-filter-remove-outline\" class=\"md-default-theme md-font material-icons icon-filter-remove-outline\" \nrole=\"img\" aria-hidden=\"true\"><md-tooltip><span translate=\"MAILING.REMOVE_FILTERS\"></span></md-tooltip></md-icon>\n</md-button><div flex=\"30\"></div></div><div flex=\"10\" layout=\"row\" layout-align=\"center center\"><h3 \nclass=\"grey-700-fg font-size-14 text-truncate\">{{ \'USERS.MAIL.SENT\' | translate}}</h3></div><div flex=\"10\" \nlayout=\"row\" layout-align=\"center center\"><h3 class=\"grey-700-fg font-size-14 text-truncate\">\n{{ \'USERS.MAIL.DELIVERED\' | translate}}</h3></div><div flex=\"40\" flex-gt-xs=\"20\" layout=\"row\" \nlayout-align=\"end center \"><md-select ng-model=\"vm.filters\" md-selected-text=\"vm.filterName\" class=\"status pill\" \nng-class=\"{\'md-accent-bg\': vm.filter=== \'\' || !vm.filter, \'green-700-bg\':vm.filter=== \'opened\', \'green-300-bg\':vm.filter=== \'clicked\',\'amber-bg\':vm.filter=== \'bounced\', \'green-700-bg\':vm.filter=== \'opened\', \'grey-bg\':vm.filter=== \'suppressed\', \'grey-bg\':vm.filter=== \'rejected\', \'grey-bg\':vm.filter=== \'complained\', \'brown-600-bg\':vm.filter=== \'unsubscribed\'}\">\n<md-option ng-value=\"all\" ng-click=\"vm.filter= \'\';vm.filterName= \'All\';vm.activateFilter(true)\">\n{{ \'MAILING.ALL\' | translate}}</md-option><md-option ng-value=\"opened\" \nng-click=\"vm.filter= \'opened\';vm.filterName= \'opened\'; vm.activateFilter(true)\">{{ \'MAILING.OPEN\' | translate}}\n</md-option><md-option ng-value=\"clicked\" \nng-click=\"vm.filter= \'clicked\';vm.filterName= \'clicked\';vm.activateFilter(true)\">{{ \'MAILING.CLICK\' | translate}}\n</md-option><md-option ng-value=\"bounced\" \nng-click=\"vm.filter= \'bounced\';vm.filterName= \'bounced\'; vm.activateFilter(true)\">{{ \'MAILING.BOUNCED\' | translate}}\n</md-option><md-option ng-value=\"rejected\" \nng-click=\"vm.filter= \'rejected\';vm.filterName= \'rejected\';vm.activateFilter(true)\">{{ \'MAILING.REJECTED\' | translate}}\n</md-option><md-option ng-value=\"complained\" \nng-click=\"vm.filter= \'complained\';vm.filterName= \'complained\'; vm.activateFilter(true)\">\n{{ \'MAILING.COMPLAINED\' | translate}}</md-option><md-option ng-value=\"suppressed\" \nng-click=\"vm.filter= \'suppressed\';vm.filterName= \'suppressed\';vm.activateFilter(true)\">\n{{ \'MAILING.SUPPRESSED\' | translate}}</md-option><md-option ng-value=\"unsubscribed\" \nng-click=\"vm.filter= \'unsubscribed\';vm.filterName= \'unsubscribed\'; vm.activateFilter(true)\">\n{{ \'MAILING.UNSUBSCRIBED\' | translate}}</md-option></md-select></div></div><md-list class=\"pt-0\" \nng-style=\"{\'opacity\' : vm.loadingReadPane ? 0.2 : 1}\"><md-list-item class=\"border-bottom text-center item-log\" \nstyle=\"padding-left: 0px!important; padding-right: 0px!important\" ng-repeat=\"log in vm.logs | filter: vm.searchEmails\">\n<div style=\"width: 100%\"><div style=\"display: flex\"><div ng-click=\"vm.selectUser(log.destination[\'S\'])\" \nclass=\"text-left word-break-word pl-20\" flex=\"40\" flex-gt-xs=\"60\" ng-bind=\"log.destination[\'S\']\"></div><div flex=\"10\" \nlayout=\"row\" layout-align=\"center center\"><md-icon ng-if=\"log.sent_at[\'S\']\" \nmd-font-icon=\"icon-checkbox-marked-circle green-fg\" class=\"s24\"><md-tooltip md-autohide=\"true\">\n{{vm.getDateFormat(log.sent_at[\'S\'])}}</md-tooltip></md-icon><md-icon ng-if=\"!log.sent_at\" \nmd-font-icon=\"icon-window-close red-fg\" class=\"s24\"></md-icon></div><div flex=\"10\" layout=\"row\" \nlayout-align=\"center center\"><md-icon ng-if=\"log.delivered_at[\'S\']\" \nmd-font-icon=\"icon-checkbox-marked-circle green-fg\" class=\"s24\"><md-tooltip md-autohide=\"true\">\n{{vm.getDateFormat(log.delivered_at[\'S\'])}}</md-tooltip></md-icon><md-icon ng-if=\"!log.delivered_at\" \nmd-font-icon=\"icon-window-close red-fg\" class=\"s24\"></md-icon></div><div layout=\"row\" layout-align=\"end center\" \nflex=\"40\" flex-gt-xs=\"20\" class=\"pr-20\"><div ng-if=\"log.click_at[\'S\']\" layout=\"column\" layout-align=\"center center\">\n<button class=\"status green-300-bg pill\" ng-click=\"vm.toggleDropdown(log)\">{{\'USERS.MAIL.CLICKED\' | translate}}<div \nclass=\"count-badge-container\"><span class=\"count-badge\">{{ vm.totalClickCount[log.destination[\'S\']] }}</span></div>\n</button></div><div ng-if=\"log.open_at[\'S\']\" layout=\"column\" layout-align=\"center center\"><button \nclass=\"status green-700-bg pill\">{{\'USERS.MAIL.OPEN\' | translate}}<md-tooltip md-autohide=\"true\">\n{{vm.getDateFormat(log.opened_at[\'S\'])}}</md-tooltip></button></div><div \nng-if=\"log.softbounce_at && log.bounce[\'M\'][\'bounce_type\'][\'S\'] == \'Permanent\'\" layout=\"column\" \nlayout-align=\"center center\"><button class=\"status pill red-bg white-fg\">{{\'USERS.MAIL.HARD_BOUNCE\' | translate}}\n<md-tooltip md-autohide=\"true\">{{vm.getDateFormat(log.bounced_at[\'S\'])}}</md-tooltip></button></div><div \nng-if=\"log.softbounce_at && log.bounce[\'M\'][\'bounce_type\'][\'S\'] == \'Transient\'\" layout=\"column\" \nlayout-align=\"center center\"><button class=\"status pill amber-bg white-fg\">{{\'USERS.MAIL.SOFT_BOUNCE\' | translate}}\n<md-tooltip md-autohide=\"true\">{{vm.getDateFormat(log.bounced_at[\'S\'])}}</md-tooltip></button></div><div \nng-if=\"log.softbounce_at && log.bounce[\'M\'][\'bounce_type\'][\'S\'] != \'Transient\' && log.bounce[\'M\'][\'bounce_type\'][\'S\'] != \'Permanent\'\" \nlayout=\"column\" layout-align=\"center center\"><button class=\"status pill grey-bg white-fg\">\n{{\'USERS.MAIL.UNDEFINED\' | translate}}<md-tooltip md-autohide=\"true\">{{vm.getDateFormat(log.bounced_at[\'S\'])}}\n</md-tooltip></button></div><div ng-if=\"log.hardbounced_at[\'S\']\" layout=\"column\" layout-align=\"center center\"><button \nclass=\"status pill grey-bg white-fg\">{{\'USERS.MAIL.SUPPRESSED\' | translate}}<md-tooltip md-autohide=\"true\">\n{{vm.getDateFormat(log.suppressed_at[\'S\'])}}</md-tooltip></button></div><div ng-if=\"log.rejected_at[\'S\']\" \nlayout=\"column\" layout-align=\"center center\"><button class=\"status pill grey-bg white-fg\">\n{{\'USERS.MAIL.REJECTED\' | translate}}<md-tooltip md-autohide=\"true\">{{vm.getDateFormat(log.rejected_at[\'S\'])}}\n</md-tooltip></button></div><div ng-if=\"log.complaint_at[\'S\']\" layout=\"column\" layout-align=\"center center\"><button \nclass=\"status pill grey-bg white-fg\">{{\'USERS.MAIL.COMPLAINED\' | translate}}<md-tooltip md-autohide=\"true\">\n{{vm.getDateFormat(log.complaint_at[\'S\'])}}</md-tooltip></button></div><div ng-if=\"log.is_blacklisted[\'S\']\" \nlayout=\"column\" layout-align=\"center center\"><button class=\"status pill brown-600-bg white-fg\">\n{{\'USERS.MAIL.UNSUSCRIBED\' | translate}}</button></div></div></div><div style=\"display: flex\"><div \nng-show=\"log.showDropdown\" class=\"dropdown-content\" style=\"margin-left: 20px; text-align: left\"><div \nng-repeat=\"(link, count) in vm.clickCountInfo[log.destination[\'S\']]\"><p>{{vm.getDateFormat(log.click_at[\'S\'])}}</p>\n</div></div><div ng-show=\"log.showDropdown\" class=\"dropdown-content\" style=\"margin-left: 80px; text-align: left\"><div \nng-repeat=\"(link, count) in vm.clickCountInfo[log.destination[\'S\']]\"><p>{{ link }}</p></div></div></div></div>\n</md-list-item><div ng-if=\"!isLoading && vm.pagination_total_log_pages> vm.pagination_log_page && vm.logs.length > 0\" \nclass=\"load-more white p-30\" layout=\"row\" layout-sm=\"column\" layout-align=\"center center\" layout-wrap=\"\"><md-button \nng-click=\"vm.nextPageLog+ 1; vm.activateFilter();\" class=\"md-raised\">{{ \'GLOBAL.LOAD_MORE\' | translate}}</md-button>\n</div></md-list></div></div>");
$templateCache.put("app/main/apps/mailing/views/massive-messages/read/content-tab-edit.html","<div class=\"form-wrapper\" flex=\"100\"><div><md-input-container class=\"md-block\" flex><label class=\"item\">Subject</label>\n<input data-ng-model=\"vm.currentContent.subject\" required></md-input-container></div><div><md-input-container \nclass=\"md-block\" flex><div class=\"item grey-500-fg\" translate=\"MAILING.TEMPLATE\"></div><div layout=\"row\" \nlayout-align=\"start center\"><div ng-bind-html=\"vm.currentContent.mailing_template.name\" class=\"mb-5 font-size-16\">\n</div><button class=\"md-icon-button md-button\" ng-click=\"vm.changeMailingTemplate()\"><md-icon \nmd-font-icon=\"icon-border-color\" class=\"s20\"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate=\"MAILING.CHANGE_TEMPLATE\"></span></md-tooltip></button></div></md-input-container></div><div \nclass=\"border-bottom\"><div class=\"md-toolbar-tools grey-100-bg border-bottom border-top\" role=\"listitem\"><h3 \nclass=\"grey-700-fg\" translate=\"MAILING.CONTENT_DESIGN\"></h3></div><md-input-container layout=\"row\" \nlayout-align=\"start center\" flex><md-button ng-click=\"vm.showEdit()\" class=\"add-event-button md-fab md-warn ml-0\" \naria-label=\"ADD\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button><span class=\"font-size-16 grey-500-fg ml-5\" \ntranslate=\"MAILING.EDIT_DESIGN\"></span></md-input-container></div></div>");
$templateCache.put("app/main/apps/mailing/views/massive-messages/read/content-tab-graphs.html","<div flex=\"100\"><div layout=\"column\" layout-align=\"center center\" layout-gt-md=\"row\" \nlayout-align-gt-md=\"space-between start\"><div flex=\"50\" class=\"ph-20 pt-20\"><h2 class=\"text-center\"><strong>\nSent to {{vm.currentContent.total_count}} emails</strong></h2><nvd3 class=\"pie width-percent-100\" \noptions=\"vm.statsCharts.options.sent\" data=\"vm.statsCharts.data.sent\" layout=\"row\" layout-align=\"center center\"></nvd3>\n</div><div flex=\"50\" class=\"ph-20 pt-20\" layout=\"column\" layout-align=\"center stretch\"><div class=\"mh-20 p-relative\">\n<h2 class=\"text-center\"><strong translate=\"MAILING.OPENS\">Opens</strong></h2><nvd3 class=\"pie\" \noptions=\"vm.statsCharts.options.open\" data=\"vm.statsCharts.data.open\"></nvd3></div><div class=\"mh-20 p-relative\"><h2 \nclass=\"text-center\"><strong translate=\"MAILING.CLICKS\">Clicks</strong></h2><nvd3 class=\"pie\" \noptions=\"vm.statsCharts.options.click\" data=\"vm.statsCharts.data.click\"></nvd3></div></div></div><div layout=\"column\">\n<div layout=\"row\" layout-align=\"center center\" class=\"mb-20\"><md-button class=\"md-icon-button\" type=\"button\" \naria-label=\"Circles\" ng-click=\"vm.openStatsView(\'bars\')\" ng-class=\"{\'md-accent\':vm.currentStatsView == \'bars\'}\">\n<md-icon md-font-icon=\"icon-chart-bar\" class=\"\"></md-icon></md-button><div class=\"divider-vertical\"></div><md-button \nclass=\"md-icon-button\" type=\"button\" aria-label=\"Circles\" ng-click=\"vm.openStatsView(\'circles\')\" \nng-class=\"{\'md-accent\':vm.currentStatsView == \'circles\'}\"><md-icon md-font-icon=\"icon-source-fork\" class=\"\"></md-icon>\n</md-button></div><div ng-if=\"vm.currentStatsView == \'circles\'\"><div class=\"text-center grey-fg\" \ntranslate=\"MAILING.MOUSE_OVER_EXPLAIN\" hide show-gt-xs>Mouse over the circles for more info</div><div \nclass=\"text-center grey-fg\" translate=\"MAILING.CLICK_EXPLAIN\" hide-gt-xs>Click on the circles for more info</div><div \nlayout=\"column\" class=\"circles-container\"><div layout=\"row\" layout-align=\"center start\" layout-wrap class=\"pt-20\"><div \nclass=\"p-relative\"><h3 class=\"text-center donut-title\"><strong translate=\"MAILING.TOTAL\"></strong></h3><nvd3 \noptions=\"vm.statsCharts.options.donut_total\" data=\"vm.statsCharts.data.donut_total\"></nvd3><md-tooltip \nmd-autohide=\"true\" md-direction=\"top\" style=\"height: auto !important\"><div class=\"font-size-14 pv-5\">\nThe total count of emails that willbe queued<br>for sending before any processing is done.</div></md-tooltip></div>\n</div><div layout=\"row\" layout-align=\"center start\" layout-wrap class=\"pt-20\"><div class=\"p-relative diag-left\"><h3 \nclass=\"text-center donut-title\"><strong translate=\"MAILING.SENT_STAT\"></strong></h3><nvd3 \noptions=\"vm.statsCharts.options.donut_sent\" data=\"vm.statsCharts.data.donut_sent\"></nvd3><md-tooltip \nmd-autohide=\"true\" md-direction=\"top\" style=\"height: auto !important\"><div class=\"font-size-14 pv-5\">\nA sent status means that we\'ve handed the email over to Amazon<br>\nand now it\'s up to them to evaluate whether they can send it or not.<br>Tests are not taken account in this statistic.\n</div></md-tooltip></div><div class=\"p-relative w-70\"></div><div class=\"p-relative diag-right\"><h3 \nclass=\"text-center donut-title\"><strong translate=\"MAILING.BLACKLISTED\"></strong></h3><nvd3 \noptions=\"vm.statsCharts.options.donut_blacklisted\" data=\"vm.statsCharts.data.donut_blacklisted\"></nvd3><md-tooltip \nmd-autohide=\"true\" md-direction=\"top\" style=\"height: auto !important\"><div class=\"font-size-14 pv-5\">\nUnsubscribed users and hard bounced emails<br>(after 3 attempts of delivery) end up in a blacklist.<br>\nThe system won\'t send any communications to these accounts.</div></md-tooltip></div></div><div layout=\"row\" \nlayout-align=\"start start\" layout-align-gt-md=\"center start\" layout-wrap class=\"pt-20\"><div \nclass=\"p-relative diag-left bottom-line long-line\"><h3 class=\"text-center donut-title\"><strong \ntranslate=\"MAILING.DELIVERED\"></strong></h3><nvd3 options=\"vm.statsCharts.options.donut_delivered\" \ndata=\"vm.statsCharts.data.donut_delivered\"></nvd3><md-tooltip md-autohide=\"true\" md-direction=\"top\" \nstyle=\"height: auto !important\"><div class=\"font-size-14 pv-5\">\nA message is marked as delivered when Amazon successfully contacts the<br>\ndestination mail server and it in turn accepts the email. This does not mean that the user<br>\nhas received it as there are many reasons why a mail server will accept an email but not deliver it.<br>\nSome of these include, but are not limited to:</div><div class=\"font-size-14 pv-5\">\n- The receiving mail server find a virus or marks it as SPAM.</div><div class=\"font-size-14 pv-5\">\n- The user has a full mailbox.</div><div class=\"font-size-14 pv-5\">\n- The user has configured an out-of-office responder.</div><div class=\"font-size-14 pv-5\">\nTests are not taken account in this statistic.</div></md-tooltip></div><div class=\"p-relative w-70\"></div><div \nclass=\"p-relative diag-right bottom-line\"><h3 class=\"text-center donut-title\"><strong \ntranslate=\"MAILING.NOT_DELIVERED\"></strong></h3><nvd3 options=\"vm.statsCharts.options.donut_not_delivered\" \ndata=\"vm.statsCharts.data.donut_not_delivered\"></nvd3></div><div class=\"p-relative w-220\"></div></div><div \nlayout=\"row\" layout-align=\"center start\" layout-align-gt-sm=\"start start\" layout-align-gt-md=\"center start\"><div \nlayout=\"column\" layout-align=\"center start\" layout-wrap class=\"pt-20 pb-40\"><div class=\"mh-5 p-relative\"><h3 \nclass=\"text-center donut-title\"><strong translate=\"MAILING.OPEN\"></strong></h3><nvd3 \noptions=\"vm.statsCharts.options.donut_opened\" data=\"vm.statsCharts.data.donut_opened\"></nvd3><md-tooltip \nmd-autohide=\"true\" md-direction=\"top\" style=\"height: auto !important\"><div class=\"font-size-14 pv-5\">\nEmails are marked as open when an invisible 1x1 tracking pixel is displayed<br>\nto the user by the email client usually when the user attempts to open an email message.<br>\nSome email clients like Gmail do not show inline images unless specifically asked to do so by the user.<br><br>\nIn cases like this, the user will open the email but the tracking pixel will not trigger so the open<br><br>\ncount will be a little lower than the real count of users who have actually opened the email.<br><br>\nTests are not taken account in this statistic.</div></md-tooltip></div><div class=\"mh-5 p-relative\"><h3 \nclass=\"text-center donut-title\"><strong translate=\"MAILING.CLICK\">Clicked</strong></h3><nvd3 \noptions=\"vm.statsCharts.options.donut_clicked\" data=\"vm.statsCharts.data.donut_clicked\"></nvd3><md-tooltip \nmd-autohide=\"true\" md-direction=\"top\" style=\"height: auto !important\"><div class=\"font-size-14 pv-5\">\nThe amount of users who clicked on a link. If a user clicks on a link multiple times, each click<br>\nis individually tracked and aggregated into this result. Click tracks are tracked up to 60 days after<br>\nan email is sent. Tests are not taken account in this statistic.</div></md-tooltip></div><div \nclass=\"mh-5 p-relative top-h-line mt-10 pt-10\"><h3 class=\"text-center donut-title\"><strong \ntranslate=\"MAILING.COMPLAINED\"></strong></h3><nvd3 options=\"vm.statsCharts.options.donut_complained\" \ndata=\"vm.statsCharts.data.donut_complained\"></nvd3><md-tooltip md-autohide=\"true\" md-direction=\"top\" \nstyle=\"height: auto !important\"><div class=\"font-size-14 pv-5\">\nSome email providers have a mechanism to report when a user marks a particular email as spam or<br>\nthat it contains a virus that Amazon didn\'t detect as it was sending it. These reports count<br>\ntowards the complained count. Tests are not taken account in this statistic but as a general<br>\nrule it is not recommended to mark an email as SPAM just to see if this works. Marking an email<br>\nas SPAM will trigger different mechanisms, some of which have consequences that cannot be<br>\neasily undone. Your overall complain rate should be below 0.1% or your account might be at risk<br>of being suspended.\n</div></md-tooltip></div></div><div class=\"w-30\"></div><div layout=\"column\" layout-align=\"center center\" layout-wrap \nclass=\"pt-20 top-h-line\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"mh-5 p-relative\"><h3 \nclass=\"text-center donut-title\"><strong translate=\"MAILING.BOUNCED\"></strong></h3><nvd3 \noptions=\"vm.statsCharts.options.donut_bounced\" data=\"vm.statsCharts.data.donut_bounced\"></nvd3><md-tooltip \nmd-autohide=\"true\" md-direction=\"top\" style=\"height: auto !important\"><div class=\"font-size-14 pv-5\">\nThese are messages that were delivered to the destination mail servers but bounced back because<br>\nof a transient reason (also known as soft bounces). Depending on the type of bounce, Amazon<br>\nwill attempt to re-send these up to three times in a reasonable time interval. Reasons an email<br>\nmay soft-bounce is because a mailbox may be full, or the user configured an out-of-office<br>\nresponse, or a temporary delivery problem in the receiving end. Your bounce rate should be<br>\nbelow 5% or your account might be at risk of being suspended. Tests are not taken account in<br>this statistic.</div>\n</md-tooltip></div><div class=\"mh-5 p-relative\"><h3 class=\"text-center donut-title\"><strong \ntranslate=\"MAILING.REJECTED\"></strong></h3><nvd3 options=\"vm.statsCharts.options.donut_rejected\" \ndata=\"vm.statsCharts.data.donut_rejected\"></nvd3><md-tooltip md-autohide=\"true\" md-direction=\"top\" \nstyle=\"height: auto !important\"><div class=\"font-size-14 pv-5\">\nRejections happen because of two reasons. The first one being that Amazon detected a virus on<br>\nthe email contents and rejected if before even sending it.<br>\nThe second one is that Amazon rejected the email because the address was invalid.</div></md-tooltip></div></div><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"mh-5 p-relative\"><h3 class=\"text-center donut-title\">\n<strong translate=\"MAILING.SUPPRESSED\"></strong></h3><nvd3 options=\"vm.statsCharts.options.donut_suppressed\" \ndata=\"vm.statsCharts.data.donut_suppressed\"></nvd3><md-tooltip md-autohide=\"true\" md-direction=\"top\" \nstyle=\"height: auto !important\"><div class=\"font-size-14 pv-5\">\nThese are emails that Amazon has already marked as having had hard bounces previously. Qiu<br>\nsystem will automatically ignore suppressed email addresses even if you attempt to send<br>\nmessages to them. Tests are not taken account in this statistic.</div></md-tooltip></div><div class=\"mh-5 p-relative\">\n<h3 class=\"text-center donut-title\"><strong translate=\"MAILING.PROCESSING\"></strong></h3><nvd3 \noptions=\"vm.statsCharts.options.donut_not_delivered_processing\" \ndata=\"vm.statsCharts.data.donut_not_delivered_processing\"></nvd3><md-tooltip md-autohide=\"true\" md-direction=\"top\" \nstyle=\"height: auto !important\"><div class=\"font-size-14 pv-5\">\nThese are emails that the system has not yet received any response from its servers.<br>\nAfter a while this number will reach zero and all these emails will be correctly marked.</div></md-tooltip></div></div>\n</div><div class=\"w-150\"></div></div></div></div><div ng-if=\"vm.currentStatsView == \'bars\'\" class=\"mb-40\"><nvd3 \noptions=\"vm.statsCharts.options.all\" data=\"vm.statsCharts.data.all\" class=\"bars-graph\" layout=\"row\" \nlayout-align=\"center center\"></nvd3></div></div></div>");
$templateCache.put("app/main/apps/mailing/views/massive-messages/read/content-tab-preview.html","");
$templateCache.put("app/main/apps/mailing/views/massive-messages/read/content-tab-send-scheduled.html","");
$templateCache.put("app/main/apps/mailing/views/massive-messages/read/content-tab-send-test.html","<div class=\"form-wrapper\" flex=\"100\"><form name=\"vm.sentTestForm\" class=\"md-inline-form\" novalidate><div><div \nclass=\"md-toolbar-tools grey-100-bg border-bottom pl-25\" role=\"listitem\"><h3 class=\"grey-700-fg ng-scope\" \ntranslate=\"MAILING.TEST_EMAILS_TEMPLATE\">Test emails</h3></div><md-input-container class=\"md-block chips\"><md-chips \nng-model=\"vm.currentContent.mailing_template.test_emails_json\" readonly=\"true\" md-removable=\"false\" \nmd-separator-keys=\"vm.keys\"></md-chips></md-input-container><div \nclass=\"md-toolbar-tools grey-100-bg border-bottom border-top pl-25\" role=\"listitem\"><h3 class=\"grey-700-fg ng-scope\" \ntranslate=\"MAILING.TEST_EMAILS_CUSTOM\">Test emails</h3></div><md-input-container class=\"md-block mb-0 chips\"><md-chips \nid=\"md-chips-email\" ng-model=\"vm.currentContent.test_emails_json\" readonly=\"false\" md-removable=\"true\" \nplaceholder=\"{{vm.translate(\'MAILING.ADD_EMAILS\')}}\" delete-button-label=\"{{vm.translate(\'MAILING.REMOVE_EMAILS\')}}\" \ndelete-hint=\"{{vm.translate(\'MAILING.DELETE_REMOVE_EMAILS\')}}\" \nsecondary-placeholder=\"{{vm.translate(\'MAILING.ADD_EMAILS\')}}\" md-enable-chip-edit=\"true\" md-separator-keys=\"vm.keys\" \nng-enter=\"validateEmail(vm.currentContent.test_emails_json)\" \nmd-transform-chip=\"addChips($chip,vm.currentContent.test_emails_json)\" ng-required=\"true\" class=\"close-chip\"><button \nmd-chip-remove class=\"md-primary\"><md-icon md-font-icon=\"icon-close\"></md-icon></button></md-chips>\n</md-input-container><md-input-container class=\"md-block mt-0\"><p class=\"grey-500-fg\" style=\"word-break: break-word\" \ntranslate=\"MAILING.TEST_EMAILS_COMMENT\"></p></md-input-container><md-input-container layout=\"row\" \nlayout-align=\"start center\" flex class=\"border-top\"><md-button type=\"submit\" ng-disabled=\"vm.basicForm.$dirty\" \nng-click=\"vm.sendTest()\" class=\"ml-0 no-shadow send-button md-accent md-raised md-rounded md-large\" \nng-disabled=\"vm.testEmails.length == 0\" aria-label=\"MAILING.SEND_TEST\" translate=\"\" \ntranslate-attr-aria-label=\"MAILING.SEND_TEST\" layout=\"row\" layout-align=\"start center\"><span><md-tooltip \nng-if=\"vm.basicForm.$dirty\"><span translate=\"MAILING.SEND_ALERT\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-telegram\" role=\"icon\" aria-hidden=\"true\"></md-icon><span translate=\"MAILING.SEND_TEST\"></span>\n</span></md-button></md-input-container></div></form></div>");
$templateCache.put("app/main/apps/mailing/views/massive-messages/read/content-tab-send.html","<div class=\"form-wrapper\" flex=\"100\"><form name=\"vm.sendForm\" class=\"md-inline-form\" novalidate><div><div \nclass=\"md-toolbar-tools grey-100-bg border-bottom pl-25\" role=\"listitem\"><h3 class=\"grey-700-fg ng-scope\" \ntranslate=\"MAILING.SEND_TO\">Send to</h3></div><md-input-container class=\"md-block\" flex><md-radio-group flex \nlayout=\"column\" ng-model=\"vm.currentContent.segment_group\"><strong class=\"mb-20\" \ntranslate=\"MAILING.DEFAULT_SUBSCRIPTION\"></strong><div layout=\"row\" layout-align=\"start center\"><md-radio-button \nng-value=\"vm.currentContent.mailing_template.subscription_group_object.id_group\" aria-label=\"...\" layout=\"row\" \nlayout-align=\"start center\">{{vm.currentContent.mailing_template.subscription_group_object.name}}</md-radio-button>\n<md-progress-circular ng-if=\"vm.loadingUsersCount\" md-mode=\"indeterminate\" md-diameter=\"25\" class=\"ml-10\">\n</md-progress-circular><div \nng-click=\"vm.usersInGroupDialog(vm.currentContent.mailing_template.subscription_group_object.id_group, vm.currentContent.mailing_template.subscription_group_object.name)\" \nclass=\"ml-10 status pill w-auto cursor-pointer\" \nng-if=\"vm.currentContent.mailing_template.subscription_group_object.totalUsers\">\n{{vm.currentContent.mailing_template.subscription_group_object.totalUsers}} users<md-tooltip hide show-gt-xs><span \ntranslate=\"MAILING.VIEW_USERS_LIST\"></span></md-tooltip></div></div><div layout=\"row\" layout-align=\"start center\" flex \nclass=\"pt-20\"><md-button ng-click=\"vm.changeGroupSubscriptionDialog($event)\" \nclass=\"ml-0 green-500-bg no-shadow md-accent no-shadow md-raised md-rounded\" aria-label=\"MAILING.SEGMENT\" translate=\"\" \ntranslate-attr-aria-label=\"MAILING.SEGMENT\" layout=\"row\" layout-align=\"center center\"><span \ntranslate=\"MAILING.CHANGE_SUBSCRIPTION\"></span><md-tooltip><span translate=\"MAILING.CHANGE_SUBSCRIPTION\"></span>\n</md-tooltip></md-button></div><strong class=\"mb-20 mt-30\" translate=\"MAILING.SEGMENTS\" \nng-if=\"vm.selectedContentSegmentGroups.length> 0\"></strong><div ng-repeat=\"segment in vm.selectedContentSegmentGroups\" \nlayout=\"row\" layout-align=\"start center\"><md-radio-button \nng-if=\"vm.selectedContentSegmentGroups.length> 0 && segment.id_group != vm.currentContent.mailing_template.subscription_group_object.id_group\" \nng-value=\"segment.id_group\" aria-label=\"...\" layout=\"row\" layout-align=\"start center\">{{segment.name}}\n</md-radio-button><div ng-click=\"vm.usersInGroupDialog(segment.id_group, segment.name)\" \nclass=\"ml-10 status pill w-auto cursor-pointer\" ng-if=\"segment.totalUsers\">{{segment.totalUsers}} users<md-tooltip \nhide show-gt-xs><span translate=\"MAILING.VIEW_USERS_LIST\"></span></md-tooltip></div></div></md-radio-group><div \nlayout=\"row\" layout-align=\"start center\" flex class=\"pt-20\"><md-button ng-click=\"vm.segmentGroupDialogNew()\" \nclass=\"ml-0 green-500-bg no-shadow md-accent no-shadow md-raised md-rounded\" aria-label=\"MAILING.SEGMENT\" translate=\"\" \ntranslate-attr-aria-label=\"MAILING.SEGMENT\" layout=\"row\" layout-align=\"center center\"><md-icon \nmd-font-icon=\"icon-account-multiple-plus\" role=\"icon\" aria-hidden=\"true\" class=\"mr-10\"></md-icon><span \ntranslate=\"MAILING.CREATE_SEGMENT\"></span><md-tooltip><span translate=\"MAILING.CREATE_SEGMENT_TEXT\"></span>\n</md-tooltip></md-button></div></md-input-container><md-input-container layout=\"column\" layout-gt-xs=\"row\" \nlayout-align=\"start start\" layout-align-gt-xs=\"start center\" flex class=\"border-top\"><md-button \nng-if=\"!vm.currentContent.scheduled_at\" type=\"submit\" ng-click=\"vm.sendFull()\" \nclass=\"ml-0 mb-20 send-button md-accent no-shadow md-raised md-rounded md-large\" aria-label=\"MAILING.SEND\" \ntranslate=\"\" translate-attr-aria-label=\"MAILING.SEND_NOW\" layout=\"row\" \nlayout-align=\"start\r\n                    center\" \nng-disabled=\"vm.basicForm.$dirty ||\r\n                    vm.currentContent.id_message_status> 1\"><span><md-tooltip \nng-if=\"vm.basicForm.$dirty\"><span translate=\"MAILING.SEND_ALERT\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-telegram\" role=\"icon\" aria-hidden=\"true\"></md-icon><span translate=\"MAILING.SEND_NOW\" \nng-if=\"vm.currentContent.id_message_status == 1\"></span> <span translate=\"MAILING.STATUSES.PROCESSING\" \nng-if=\"vm.currentContent.id_message_status == 3\"></span> <span translate=\"MAILING.STATUSES.SENDING\" \nng-if=\"vm.currentContent.id_message_status == 4\"></span></span></md-button><md-button \nng-if=\"!vm.currentContent.scheduled_at && vm.currentContent.id_message_status == 1\" type=\"submit\" \nng-click=\"vm.sendLaterDialog()\" class=\"border ml-0 mb-20 send-button no-shadow md-accent md-link md-rounded md-large\" \naria-label=\"MAILING.SEND_LATER\" translate=\"\" translate-attr-aria-label=\"MAILING.SEND_LATER\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-calendar-clock\" role=\"icon\" aria-hidden=\"true\"></md-icon><span \ntranslate=\"MAILING.SEND_LATER\"></span></md-button><md-button hide ng-if=\"vm.currentContent.scheduled_at\" type=\"submit\" \nng-click=\"\" class=\"ml-0 mb-20 send-button no-shadow md-raised md-warn md-rounded md-large\" \naria-label=\"MAILING.SEND_LATER\" translate=\"\" translate-attr-aria-label=\"MAILING.CANCEL\" layout=\"row\" \nlayout-align=\"start center\"><span translate=\"MAILING.CANCEL\"></span></md-button><md-button \nng-if=\"vm.currentContent.scheduled_at\" type=\"submit\" ng-click=\"vm.sendLaterDialog()\" \nclass=\"border ml-0 mb-20 send-button no-shadow md-accent md-link md-rounded md-large\" aria-label=\"MAILING.SEND_LATER\" \ntranslate=\"\" translate-attr-aria-label=\"MAILING.SEND_SCHEDULED\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-calendar-clock\" role=\"icon\" aria-hidden=\"true\"></md-icon><span translate=\"MAILING.SEND_SCHEDULED\" \nclass=\"text-capitalized mr-5\"></span> {{vm.getDateFormat(vm.currentContent.scheduled_at)}}</md-button>\n</md-input-container></div></form></div>");
$templateCache.put("app/main/apps/mailing/views/massive-messages/read/content-tab-stats.html","<div class=\"form-wrapper\" flex=\"100\"><div><div class=\"mh-25 p-15 mt-25 stats-section\" layout=\"row\" layout-sm=\"column\">\n<div flex><span><strong translate=\"MAILING.TOTAL\"></strong></span><span class=\"ml-15\" \nng-bind=\"vm.currentContent.total_count\"></span><md-icon md-font-icon=\"icon-information-outline\"><md-tooltip \nstyle=\"height: auto!important\" md-autohide=\"true\"><p>\nThe total count of emails that will be queued for sending before any processing is done.</p></md-tooltip></md-icon>\n</div><div flex><span><strong translate=\"MAILING.SENT_STAT\"></strong></span><span class=\"ml-15\" \nng-bind=\"vm.currentContent.sent_count\"></span><md-icon md-font-icon=\"icon-information-outline\"></md-icon><md-tooltip \nstyle=\"height: auto!important\" md-autohide=\"true\"><p>\nA sent status means that we\'ve handed the email over to Amazon and now it\'s up to them to evaluate whether they can send it or not.\n<br>Tests are not taken account in this statistic.</p></md-tooltip></div></div><div class=\"mh-25 p-15 stats-section\" \nlayout=\"row\" layout-sm=\"column\"><div flex><span><strong translate=\"MAILING.DELIVERED\"></strong></span><span \nclass=\"ml-15\" ng-bind=\"vm.currentContent.delivered_count\"></span><md-icon md-font-icon=\"icon-information-outline\">\n</md-icon><md-tooltip style=\"height: auto!important\" md-autohide=\"true\"><p>\nA message is marked as delivered when Amazon successfully contacts the<br>\ndestination mail server and it in turn accepts the email. This does not mean that the user<br>\nhas received it as there are many reasons why a mail server will accept an email but not deliver it.<br>\nSome of these include, but are not limited to:</p><p>- The receiving mail server find a virus or marks it as SPAM.</p>\n<p>- The user has a full mailbox.</p><p>- The user has configured an out-of-office responder.</p><p>\nTests are not taken account in this statistic.</p></md-tooltip></div><div flex><span><strong translate=\"MAILING.OPEN\">\n</strong></span><span class=\"ml-15\" ng-bind=\"vm.currentContent.open_count\"></span><md-icon \nmd-font-icon=\"icon-information-outline\"></md-icon><md-tooltip style=\"height: auto!important\" md-autohide=\"true\"><p>\nEmails are marked as open when an invisible 1x1 tracking pixel is displayed<br>\nto the user by the email client usually when the user attempts to open an email message.<br>\nSome email clients like Gmail do not show inline images unless specifically asked to do so by the user.</p><br><p>\nIn cases like this, the user will open the email but the tracking pixel will not trigger so the open<br>\ncount will be a little lower than the real count of users who have actually opened theemail.</p><p>\nTests are not taken account in this statistic.</p></md-tooltip></div></div><div class=\"mh-25 p-15 stats-section\" \nlayout=\"row\" layout-sm=\"column\"><div flex><span><strong translate=\"MAILING.CLICK\">Clicked</strong></span><span \nclass=\"ml-15\" ng-bind=\"vm.currentContent.clicked_count\"></span><md-icon md-font-icon=\"icon-information-outline\">\n</md-icon><md-tooltip style=\"height: auto!important\" md-autohide=\"true\"><p>\nThe amount of users who clicked on a link. If a user clicks on a link multiple times, each click<br>\nis individually tracked and aggregated into this result. Click tracks are tracked up to 60 days after<br>\nan email is sent. Tests are not taken account in this statistic.</p></md-tooltip></div><div flex><span><strong \ntranslate=\"MAILING.REJECTED\"></strong></span><span class=\"ml-15\" ng-bind=\"vm.currentContent.rejected_count\"></span>\n<md-icon md-font-icon=\"icon-information-outline\"></md-icon><md-tooltip style=\"height: auto!important\" \nmd-autohide=\"true\"><p>Rejections happen because of two reasons. The first one being that Amazon detected a virus on<br>\nthe email contents and rejected if before even sending it.<br>\nThe second one is that Amazon rejected the email because the address was invalid.</p></md-tooltip></div></div><div \nclass=\"mh-25 p-15 stats-section\" layout=\"row\" layout-sm=\"column\"><div flex><span><strong translate=\"MAILING.BOUNCED\">\n</strong></span><span class=\"ml-15\" ng-bind=\"vm.currentContent.bounced_count\"></span><md-icon \nmd-font-icon=\"icon-information-outline\"></md-icon><md-tooltip style=\"height: auto!important\" md-autohide=\"true\"><p>\nThese are messages that were delivered to the destination mail servers but bounced back because<br>\nof a transient reason (also known as soft bounces). Depending on the type of bounce, Amazon<br>\nwill attempt to re-send these up to three times in a reasonable time interval. Reasons an email<br>\nmay soft-bounce is because a mailbox may be full, or the user configured an out-of-office<br>\nresponse, or a temporary delivery problem in the receiving end. Your bounce rate should be<br>\nbelow 5% or your account might be at risk of being suspended. Tests are not taken account in<br>this statistic.</p>\n</md-tooltip></div><div flex><span><strong translate=\"MAILING.COMPLAINED\"></strong></span><span class=\"ml-15\" \nng-bind=\"vm.currentContent.complained_count\"></span><md-icon md-font-icon=\"icon-information-outline\"></md-icon>\n<md-tooltip style=\"height: auto!important\" md-autohide=\"true\"><p>\nSome email providers have a mechanism to report when a user marks a particular email as spam or<br>\nthat it contains a virus that Amazon didn\'t detect as it was sending it. These reports count<br>\ntowards the complained count. Tests are not taken account in this statistic but as a general<br>\nrule it is not recommended to mark an email as SPAM just to see if this works. Marking an email<br>\nas SPAM will trigger different mechanisms, some of which have consequences that cannot be<br>\neasily undone. Your overall complain rate should be below 0.1% or your account might be at risk<br>of being suspended.\n</p></md-tooltip></div></div><div class=\"mh-25 p-15 stats-section\" layout=\"row\" layout-sm=\"column\"><div flex><span>\n<strong translate=\"MAILING.SUPPRESSED\"></strong></span><span class=\"ml-15\" \nng-bind=\"vm.currentContent.suppressed_count\"></span><md-icon md-font-icon=\"icon-information-outline\"></md-icon>\n<md-tooltip style=\"height: auto!important\" style=\"height: auto!important\" md-autohide=\"true\"><p>\nThese are emails that Amazon has already marked as having had hard bounces previously. Qiu<br>\nsystem will automatically ignore suppressed email addresses even if you attempt to send<br>\nmessages to them. Tests are not taken account in this statistic.</p></md-tooltip></div></div></div></div>");
$templateCache.put("app/main/apps/mailing/views/massive-messages/read/content-tab-test-users.html","<div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><form class=\"md-inline-form\" novalidate><div class=\"sortable\">\n<md-input-container class=\"md-block\"><label class=\"item\">Test users</label><textarea ng-model=\"test\" \nmd-maxlength=\"250\" rows=\"3\" md-select-on-focus></textarea></md-input-container></div></form></div>");
$templateCache.put("app/main/apps/mailing/views/massive-messages/read/content-tab-user-groups.html","<form novalidate><div class=\"group-form\"><div ng-repeat=\"item in vm.currentLabels track by $index\" class=\"tag\" \nfxlayout=\"row\" fxlayoutalign=\"start center\"><div class=\"tag-label\">{{item.label}}<md-icon \nng-click=\"vm.deleteTarget(item.id, $index)\" md-font-icon=\"icon-close\" class=\"s24 pointer\"></md-icon></div></div></div>\n</form><form class=\"md-inline-form\" novalidate><div class=\"group-form\"><md-button \nng-click=\"vm.openUsersGroupsDialog()\" class=\"add-event-button md-fab md-warn\" aria-label=\"ADD\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button><span></span></div></form>");
$templateCache.put("app/main/apps/mailing/views/massive-messages/read/content-tab-visual-edit.html","");
$templateCache.put("app/main/apps/mailing/views/massive-messages/read/content-user-mailing.html","<div class=\"toolbar grey-100-bg colored-bg\" layout=\"row\" layout-align=\"space-between center\" scroll=\"\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button close-thread\" aria-label=\"Back\" \nng-click=\"vm.closeUser()\" translate translate-attr-aria-label=\"CONTENT.BACK\"><md-icon \nmd-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button></div><div layout=\"row\" layout-align=\"end center\"><div \nclass=\"text-left font-size-16 pr-20\" hide-gt-xs><strong>{{vm.selectedUser}}</strong></div></div></div><md-content \nstyle=\"height: calc(100% - 65px)\"><div id=\"users-activity\" \nclass=\"page-layout simple fullwidth mail-content content-edit scrollable\" layout=\"column\" \nms-scroll=\"vm.msScrollOptions\"><div flex layout=\"column\" layout-align=\"center center\" ng-if=\"vm.loadingReadPaneUser\" \nclass=\"loading-container\" style=\"z-index: 2\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\">\n</md-progress-circular></div><div ng-if=\"vm.logsUserSelected.length> 0\" flex=\"100\"><md-list-item \nclass=\"grey-100-bg border-bottom text-center toolbar-log\" layout=\"row\" layout-align=\"space-between center\"><div \nflex=\"40\" flex-gt-xs=\"50\" class=\"text-left font-size-16 pl-20\"><strong hide show-gt-xs>{{vm.selectedUser}}</strong>\n</div><div flex=\"10\" layout=\"row\" layout-align=\"center center\"><h3 class=\"grey-700-fg font-size-14\">\n{{ \'USERS.MAIL.SENT\' | translate}}</h3></div><div flex=\"10\" layout=\"row\" layout-align=\"center center\"><h3 \nclass=\"grey-700-fg font-size-14\">{{ \'USERS.MAIL.DELIVERED\' | translate}}</h3></div><div flex=\"40\" flex-gt-xs=\"30\" \nlayout=\"row\" layout-align=\"end center\"></div></md-list-item><md-list class=\"pt-0\" \nng-style=\"{\'opacity\' : vm.loadingReadPaneUser ? 0.2 : 1}\"><md-list-item class=\"border-bottom text-center item-log\" \nng-repeat=\"log in vm.logsUserSelected\"><div flex layout=\"row\"><div flex=\"40\" flex-gt-xs=\"50\" \nclass=\"text-left word-break-word pl-20\" layout=\"column\"><p class=\"m-0 subject text-truncate grey-500-fg\" \nng-bind=\"vm.getDateFormat(log.scheduled_at)\"></p><h4 class=\"m-0 font-weight-500\" ng-bind=\"log.mailing_content.subject\">\n</h4></div><div flex=\"10\" layout=\"row\" layout-align=\"center center\"><md-icon ng-if=\"log.sent_at\" \nmd-font-icon=\"icon-checkbox-marked-circle green-fg\" class=\"s24\"><md-tooltip md-autohide=\"true\">\n{{vm.getDateFormat(log.sent_at)}}</md-tooltip></md-icon></div><div flex=\"10\" layout=\"row\" layout-align=\"center center\">\n<md-icon ng-if=\"log.delivered_at\" md-font-icon=\"icon-checkbox-marked-circle green-fg\" class=\"s24\"><md-tooltip \nmd-autohide=\"true\">{{vm.getDateFormat(log.delivered_at)}}</md-tooltip></md-icon></div><div flex=\"40\" flex-gt-xs=\"30\" \nlayout-align=\"end center\" layout=\"row\" class=\"pr-20\"><div ng-if=\"log.clicked_at\" layout=\"column\" \nlayout-align=\"center center\"><button class=\"status green-300-bg pill\">{{\'USERS.MAIL.CLICKED\' | translate}}<md-tooltip \nmd-autohide=\"true\">{{vm.getDateFormat(log.clicked_at)}}</md-tooltip></button></div><div ng-if=\"log.opened_at\" \nlayout=\"column\" layout-align=\"center center\"><button class=\"status green-700-bg pill\">{{\'USERS.MAIL.OPEN\' | translate}}\n<md-tooltip md-autohide=\"true\">{{vm.getDateFormat(log.opened_at)}}</md-tooltip></button></div><div \nng-if=\"log.bounced_at && log.bounceType == \'Permanent\'\" layout=\"column\" layout-align=\"center center\"><button \nclass=\"status pill red-bg white-fg\">{{\'USERS.MAIL.HARD_BOUNCE\'\' | translate}}<md-tooltip md-autohide=\"true\">\n{{vm.getDateFormat(log.bounced_at)}}</md-tooltip></button></div><div \nng-if=\"log.bounced_at && log.bounceType == \'Transient\'\" layout=\"column\" layout-align=\"center center\"><button \nclass=\"status pill amber-bg white-fg\">{{\'USERS.MAIL.SOFT_BOUNCE\' | translate}}<md-tooltip md-autohide=\"true\">\n{{vm.getDateFormat(log.bounced_at)}}</md-tooltip></button></div><div \nng-if=\"log.bounced_at && log.bounceType != \'Transient\' && log.bounceType != \'Permanent\'\" layout=\"column\" \nlayout-align=\"center center\"><button class=\"status pill grey-bg white-fg\">{{\'USERS.MAIL.UNDEFINED\' | translate}}\n<md-tooltip md-autohide=\"true\">{{vm.getDateFormat(log.bounced_at)}}</md-tooltip></button></div><div \nng-if=\"log.suppressed_at\" layout=\"column\" layout-align=\"center center\"><button class=\"status pill grey-bg white-fg\">\n{{\'USERS.MAIL.SUPPRESSED\' | translate}}<md-tooltip md-autohide=\"true\">{{vm.getDateFormat(log.suppressed_at)}}\n</md-tooltip></button></div><div ng-if=\"log.rejected_at\" layout=\"column\" layout-align=\"center center\"><button \nclass=\"status pill grey-bg white-fg\">{{\'USERS.MAIL.REJECTED\' | translate}}<md-tooltip md-autohide=\"true\">\n{{vm.getDateFormat(log.rejected_at)}}</md-tooltip></button></div><div ng-if=\"log.complained_at\" layout=\"column\" \nlayout-align=\"center center\"><button class=\"status pill grey-bg white-fg\">{{\'USERS.MAIL.COMPLAINED\' | translate}}\n<md-tooltip md-autohide=\"true\">{{vm.getDateFormat(log.complained_at)}}</md-tooltip></button></div><div \nng-if=\"log.is_blacklisted\" layout=\"column\" layout-align=\"center center\"><button \nclass=\"status pill brown-600-bg white-fg\">{{\'USERS.MAIL.UNSUSCRIBED\' | translate}}</button></div></div></div>\n</md-list-item><div \nng-if=\"!vm.loadingReadPaneUser && vm.pagination_total_log_pages_user> vm.pagination_log_page_user && vm.logsUserSelected.length > 0\" \nclass=\"load-more white p-30\" layout=\"row\" layout-sm=\"column\" layout-align=\"center center\" layout-wrap=\"\"><md-button \nng-click=\"vm.getLogs(vm.selectedUser, vm.nextPageLogUser)\" class=\"md-raised\">{{\'GLOBAL.LOAD_MORE\' | translate}}\n</md-button></div><div class=\"white p-30\"></div></md-list></div><div ng-if=\"vm.logsUserSelected.length === 0\" \nclass=\"load-more white p-30\" layout=\"row\" layout-sm=\"column\" layout-align=\"center center\" layout-wrap=\"\"><div \nclass=\"message\" translate=\"USERS.NO_RESULTS\"></div></div></div></md-content>");
$templateCache.put("app/main/apps/mailing/views/template/list/list-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-if=\"isLoading\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nclass=\"mail-list-item filter-selected\" ng-if=\"vm.selectedGroup\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"info\" flex><div class=\"name\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-folder\" \nclass=\"s20 mr-8 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><div class=\"title text-truncate\" layout=\"row\" \nlayout-align=\"start center\">{{vm.selectedGroup.name}} ({{pagination_totalItems | number}})</div></div></div><div \nclass=\"buttons\" layout=\"row\" layout-align=\"start center\"><div><md-switch class=\"no-label\" \nng-checked=\"vm.filterGroups.includeSubgroups\" ng-click=\"vm.toggleIncludeSubgroups($event)\" \naria-label=\"{{vm.filterGroups.includeSubgroups ? \'Uncheck\':\'check\'}}\"></md-switch><md-tooltip><span \ntranslate=\"CONTENT.INCLUDE_SUBGROUPS\">Include subgroups</span></md-tooltip></div><md-icon \nmd-font-icon=\"icon-close s20\" ng-click=\"vm.unselectGroups()\" class=\"ml-10\"><md-tooltip hide show-gt-xs><span \ntranslate=\"CONTENT.DESELECT_GROUP\">Deselect group</span></md-tooltip></md-icon></div></div><div \nclass=\"mail-list-item filter-selected\" ng-if=\"sortField\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\" flex><div class=\"info\" ng-if=\"sortField\"><div class=\"name\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-sort-ascending\" class=\"s20 mr-5 ml-0 mb-0\" \nng-if=\"sortDir === \'ASC\'\"></md-icon><md-icon md-font-icon=\"icon-sort-descending\" class=\"s20 mr-5 ml-0 mb-0\" \nng-if=\"sortDir === \'DESC\'\"></md-icon><div class=\"title text-truncate\" layout=\"row\" layout-align=\"start center\">\nOrdered by \'{{sortField}}\'</div></div></div></div><div class=\"buttons\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-close s20\" ng-click=\"pagination_resetOrderBy()\" class=\"ml-10\"><md-tooltip hide show-gt-xs>\n<span translate=\"CONTENT.REMOVE\">Remove</span></md-tooltip></md-icon></div></div><div class=\"no-threads\" \nng-if=\"!isLoading && vm.threads.length === 0\" ng-hide=\"isLoading\">There are no items!</div><div id=\"list-content-data\" \nng-style=\"{\'opacity\' : isLoading ? 0.2 : 1}\" ms-scroll=\"vm.msScrollOptions\" \nng-class=\"{\'group-filter\': vm.selectedGroup,\'other-filter\':sortField}\" class=\"scrollable\" \nng-if=\"vm.threads.length > 0\"><div class=\"mail-list-item {{thread.status}}\" \nng-repeat=\"thread in vm.threads | filter: vm.search | filter: global.search\" ng-init=\"parentIndex = $index\" md-no-ink \nng-click=\"vm.openTemplate(thread)\" \nng-class=\"{\'starred\': thread.starred, \'selected\': vm.selectedContentID === thread.id_mailing_templates, \'checked\': vm.isChecked(thread)}\">\n<div layout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-label\" ng-checked=\"vm.isSelected(thread)\" \nng-click=\"vm.toggleSelectThread(thread, $event)\" aria-label=\"{{vm.isSelected(thread) ? \'Deselect\' : \'Select\'}}\">\n</md-checkbox><div class=\"info\" flex layout=\"column\"><div class=\"name text-truncate\" layout=\"row\" \nlayout-align=\"start center\"><span>{{thread.name}}</span></div><div class=\"details\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"title grey-500-fg\" translate=\"MAILING.FROM\"></span> <span \nng-bind=\"thread.from_name\" class=\"detail mr-10\"></span> &lt;<span class=\"detail text-truncate\" \nng-bind=\"thread.from_email\"></span>&gt;</div></div><div class=\"buttons\" layout=\"row\" layout-align=\"start center\"></div>\n</div></div><div class=\"toolbar\" layout=\"row\" layout-align=\"end center\"><div layout=\"row\" layout-align=\"center center\" \nng-style=\"{\'display\' : isLoading ? \'none\' : \'block\'}\"><span class=\"page-info\">{{pagination_totalItems}} items found.\n</span><md-button aria-label=\"Previous\" class=\"md-icon-button arrow\" ng-click=\"pagination_prevPage()\" \nng-disabled=\"pagination_firstPage()\" translate=\"\" translate-attr-aria-label=\"CONTENT.PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><span class=\"page-info\">\n{{pagination_page}} / {{pagination_total_pages}}</span><md-button aria-label=\"Next\" class=\"md-icon-button arrow\" \nng-click=\"pagination_nextPage()\" ng-disabled=\"pagination_morePages()\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div>\n</div>");
$templateCache.put("app/main/apps/mailing/views/template/list/nosplit-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/mailing/views/template/list/toolbar.html\'\" \nng-hide=\"vm.currentThread || vm.currentThread_Edit\"></div><div class=\"content-wrapper\" flex=\"\" layout=\"row\"><div \nclass=\"content thread-detail mail-read-pane\" flex id=\"thread-detail\" ng-if=\"vm.currentThread || vm.currentThread_Edit\" \nng-include=\"\'app/main/apps/mailing/views/template/read/templates-read-view.html\'\"></div><div \nclass=\"content thread-list mail-list-pane\" flex id=\"thread-list\" ng-if=\"!vm.currentThread && !vm.currentThread_Edit\" \nng-include=\"\'app/main/apps/mailing/views/template/list/list-view.html\'\"></div></div>");
$templateCache.put("app/main/apps/mailing/views/template/list/split-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/mailing/views/template/list/toolbar.html\'\"></div><div class=\"content-wrapper\" flex=\"\" \nlayout=\"row\"><div class=\"content thread-list mail-list-pane\" flex=\"50\" id=\"thread-list\" \nng-include=\"\'app/main/apps/mailing/views/template/list/list-view.html\'\"></div><div \nclass=\"content thread-detail mail-read-pane\" flex=\"50\" id=\"thread-detail\" layout=\"column\" \nng-include=\"\'app/main/apps/mailing/views/template/read/templates-read-view.html\'\"></div></div>");
$templateCache.put("app/main/apps/mailing/views/template/list/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-label\" \naria-label=\"{{vm.selectedThreads.length > 0 ? \'Deselect All\' : \'Select All\'}}\" \nng-checked=\"vm.selectedThreads.length > 0\" ng-click=\"vm.toggleSelectThreads()\"></md-checkbox><div \nclass=\"divider-vertical\" hide=\"\" show-gt-xs=\"\"></div><md-button aria-label=\"ADD NEW\" \nclass=\"md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme\" hide show-gt-sm \nng-click=\"vm.newTemplate()\" translate=\"CONTENT.ADD\" type=\"button\">Add new</md-button><md-button aria-label=\"ADD NEW\" \nclass=\"md-fab md-mini md-accent green-500-bg md-raised md-ink-ripple md-default-theme\" hide-gt-sm \nng-click=\"vm.newTemplate()\" type=\"button\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><div \nclass=\"divider-vertical\" hide=\"\" show-gt-xs=\"\"></div><ms-search-bar debounce=\"300\" \nmodel-search=\"$root.pagination_searchquery\" on-result-click=\"vm.searchResultClick(item)\" on-search=\"vm.search(query)\" \nlayout=\"row\" layout-align=\"start center\"></ms-search-bar><md-button ng-click=\"$root.pagination_resetquery()\" \naria-label=\"view type\" class=\"md-icon-button\" translate=\"\" translate-attr-aria-label=\"CONTENT.FILTERS\" \nclass=\"md-icon-button\" ng-if=\"$root.pagination_searchquery==true\"><md-icon md-font-icon=\"icon-filter-remove-outline\">\n</md-icon><md-tooltip hide show-gt-xs><span>Reset search</span></md-tooltip></md-button><div class=\"divider-vertical\" \nhide=\"\" show-gt-xs=\"\"></div><md-button aria-label=\"Sort Direction\" class=\"md-icon-button\" \nng-click=\"vm.setSortOrder(\'ASC\')\" ng-if=\"sortDir !== \'ASC\'\" translate=\"\" \ntranslate-attr-aria-label=\"TODO.SORT_DIRECTION\"><md-icon md-font-icon=\"icon-sort-ascending\" ng-if=\"sortDir !== \'ASC\'\">\n</md-icon><md-icon md-font-icon=\"icon-sort-descending\" ng-if=\"sortDir === \'ASC\'\"></md-icon></md-button><md-button \naria-label=\"Sort Direction\" class=\"md-icon-button\" ng-click=\"vm.setSortOrder(\'DESC\')\" ng-if=\"sortDir === \'ASC\'\" \ntranslate=\"\" translate-attr-aria-label=\"TODO.SORT_DIRECTION\"><md-icon md-font-icon=\"icon-sort-ascending\" \nng-if=\"sortDir !== \'ASC\'\"></md-icon><md-icon md-font-icon=\"icon-sort-descending\" ng-if=\"sortDir === \'ASC\'\"></md-icon>\n</md-button><md-menu><button aria-label=\"Filters\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" show-gt-xs=\"\" \ntranslate=\"\" translate-attr-aria-label=\"CONTENT.FILTERS\"><md-icon md-font-icon=\"icon-chevron-down\"><md-tooltip><span \ntranslate=\"CONTENT.ORDER_BY\">Order</span></md-tooltip></md-icon></button><md-menu-content width=\"1\"><md-menu-item>\n<md-button ng-click=\"vm.setSortField(\'id_mailing_templates\')\">ID</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.setSortField(\'created_at\')\">Creation date</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.setSortField(\'updated_at\')\">Update date</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.setSortField(\'name\')\">Name</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.setSortField(\'from_name\')\">From name</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.setSortField(\'from_email\')\">From email</md-button></md-menu-item></md-menu-content></md-menu><md-menu \nhide=\"\" show-gt-xs=\"\" ng-if=\"refGroupables.length>0\"><button aria-label=\"Filters\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\" show-gt-xs=\"\" translate=\"\" translate-attr-aria-label=\"CONTENT.FILTERS\"><md-icon \nmd-font-icon=\"icon-chevron-down\"><md-tooltip hide show-gt-xs><span translate=\"CONTENT.GROUP_BY\">Group</span>\n</md-tooltip></md-icon></button><md-menu-content width=\"4\"><md-menu-item ng-repeat=\"sortfield in refGroupables\">\n<md-button aria-label=\"All\" ng-click=\"pagination_setOrderBy(sortfield)\"><div layout=\"row\" \nlayout-align=\"space-between center\"><span>Group by {{sortfield.name}} </span><i class=\"icon-check s16\" \nng-if=\"sortfield.titleId == sortable.titleId\"></i></div></md-button></md-menu-item><md-menu-divider ng-if=\"groupable\">\n</md-menu-divider><md-menu-item ng-if=\"groupable\"><md-button aria-label=\"Remove group\" \nng-click=\"pagination_resetOrderBy()\"><md-icon md-font-icon=\"icon-close \"></md-icon><span>Remove order</span>\n</md-button></md-menu-item></md-menu-content></md-menu><div aria-hidden=\"false\" \nclass=\"action-buttons hide show-gt-xs layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\" \nng-show=\"vm.selectedThreads.length > 0\"><div class=\"divider-vertical\" hide=\"\" show-gt-xs=\"\"></div><md-button \nng-click=\"vm.duplicateTemplate()\" aria-label=\"Duplicate\" class=\"md-icon-button\" hide=\"\" show-gt-xs=\"\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.DUPLICATE\"><md-icon md-font-icon=\"icon-content-duplicate\"></md-icon><md-tooltip \nhide show-gt-xs><span translate=\"CONTENT.DUPLICATE\">Duplicate</span></md-tooltip></md-button><md-button \nng-click=\"vm.deleteThread()\" aria-label=\"Delete\" class=\"md-icon-button\" hide=\"\" show-gt-xs=\"\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip hide show-gt-xs>\n<span translate=\"CONTENT.DELETE\">Delete</span></md-tooltip></md-button><div class=\"divider-vertical\" hide=\"\" \nshow-gt-xs=\"\"></div></div></div><div layout=\"row\" layout-align=\"start center\" \ntranslate-attr-aria-label=\"CONTENT.REFRESH\"><span class=\"page-info\" hide=\"\" show-gt-xs=\"\">\n{{pagination_totalItems}} items found.</span><md-button aria-label=\"Previous\" class=\"md-icon-button arrow\" hide=\"\" \nng-click=\"pagination_prevPage()\" ng-disabled=\"pagination_firstPage()\" show-gt-xs=\"\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip hide \nshow-gt-xs><span translate=\"CONTENT.PREVIOUS\">Previous</span></md-tooltip></md-button><span class=\"page-info\" hide=\"\" \nshow-gt-xs=\"\">{{pagination_page}} / {{pagination_total_pages}}</span><md-button aria-label=\"Next\" \nclass=\"md-icon-button arrow\" hide=\"\" ng-click=\"pagination_nextPage()\" ng-disabled=\"pagination_morePages()\" \nshow-gt-xs=\"\" translate=\"\" translate-attr-aria-label=\"CONTENT.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\">\n</md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.NEXT\">Next</span></md-tooltip></md-button><div \nclass=\"divider-vertical\" hide hide show-gt-sm></div><md-button class=\"md-icon-button\" \nng-click=\"vm.changeView(\'nosplit\')\" ng-if=\"vm.currentView !== \'nosplit\'\" hide show-gt-sm aria-label=\"noSplit\"><md-icon \nmd-font-icon=\"icon-view-list\" ng-if=\"vm.currentView !== \'nosplit\'\"></md-icon><md-icon class=\"md-accent\" \nmd-font-icon=\"icon-checkbox-marked\" ng-if=\"vm.currentView === \'nosplit\'\"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate=\"CONTENT.NOSPLIT_VIEW\">No split</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.changeView(\'split\')\" ng-if=\"vm.currentView !== \'split\'\" hide show-gt-sm aria-label=\"Split\"><md-icon \nmd-font-icon=\"icon-view-quilt\" ng-if=\"vm.currentView !== \'split\'\"></md-icon><md-icon class=\"md-accent\" \nmd-font-icon=\"icon-checkbox-marked\" ng-if=\"vm.currentView === \'split\'\"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate=\"CONTENT.SPLIT_VIEW\">split</span></md-tooltip></md-button><md-menu class=\"settings-menu\" hide-gt-xs \nng-show=\"vm.selectedThreads.length > 0\"><md-button aria-label=\"Settings\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\" translate=\"\" translate-attr-aria-label=\"CONTENT.SETTINGS\"><md-icon \nmd-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content><md-menu-item \nshow=\"vm.selectedMail.length > 0 || vm.allChecked\"><md-button ng-click=\"vm.massActions(\'duplicate\')\" \naria-label=\"Duplicate\" translate-attr-aria-label=\"CONTENT.DUPLICATE\"><md-icon md-font-icon=\"icon-content-duplicate\">\n</md-icon><span translate=\"CONTENT.DUPLICATE\">Duplicate </span><span translate=\"CONTENT.SELECTED\">Selected</span>\n</md-button></md-menu-item><md-menu-item show=\"vm.selectedMail.length > 0 || vm.allChecked\"><md-button \nng-click=\"vm.massActions(\'delete\')\" aria-label=\"Delete\" translate-aria-label=\"CONTENT.DELETE\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><span translate=\"CONTENT.DELETE\">Delete </span><span translate=\"CONTENT.SELECTED\">\nSelected</span></md-button></md-menu-item></md-menu-content></md-menu></div>");
$templateCache.put("app/main/apps/mailing/views/template/read/templates-read-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-if=\"vm.loadingReadPane\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nng-show=\"!vm.loadingReadPane\"><div class=\"mail-content\" layout=\"column\" layout-align=\"center center\" \nng-if=\"!vm.currentThread_Edit\"><div class=\"content\" layout=\"column\" layout-align=\"top center\"><div class=\"message\">\nPlease select an item to show in this panel</div></div></div><div class=\"toolbar grey-100-bg colored-bg\" layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"vm.currentThread_Edit\" scroll=\"\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button close-thread\" aria-label=\"Back\" \nng-click=\"vm.closeThread()\" translate translate-attr-aria-label=\"CONTENT.BACK\" ng-if=\"vm.currentView === \'nosplit\'\">\n<md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div class=\"divider-vertical\" \nng-if=\"vm.currentView !== \'split\'\"></div><md-button aria-label=\"Content\" class=\"md-icon-button\" \nng-class=\"{\'md-accent\':vm.currentTemplateView == \'edit\'}\" ng-click=\"vm.openTemplateView(\'edit\')\" translate=\"\" \ntranslate-attr-aria-label=\"MAILING.CONTENT\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip hide show-gt-xs>\n<span translate=\"MAILING.EDIT\"></span></md-tooltip></md-button><div class=\"divider-vertical\" hide show-gt-sm></div>\n<md-button aria-label=\"Content\" class=\"md-icon-button\" ng-class=\"{\'md-accent\':vm.currentTemplateView == \'test-users\'}\" \nng-click=\"vm.openTemplateView(\'test-users\')\" translate=\"\" translate-attr-aria-label=\"MAILING.TEST_USERS\"><md-icon \nmd-font-icon=\"icon-account-multiple\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"MAILING.TEST_USERS\"></span>\n</md-tooltip></md-button></div><div layout=\"row\" layout-align=\"end center\" ng-if=\"vm.currentThread_Edit\" hide \nshow-gt-sm><md-button type=\"submit\" ng-click=\"vm.saveItem(vm.currentThread_Edit)\" \nclass=\"send-button md-accent md-raised\" \nng-disabled=\"vm.basicForm.$invalid || vm.basicForm.$pristine && vm.noexistchangues\" aria-label=\"SAVE\" \ntranslate=\"CONTENT.SAVE\" translate-attr-aria-label=\"CONTENT.SAVE\">SAVE</md-button><md-button type=\"button\" \nng-click=\"vm.closeThreadEdit()\" class=\"md-raised md-warn\" aria-label=\"Cancel\">Cancel</md-button></div><div \nlayout=\"row\" layout-align=\"end center\" ng-if=\"vm.currentThread_Edit\" hide-gt-sm><md-button type=\"submit\" \nng-click=\"vm.saveItem(vm.currentThread_Edit)\" \nclass=\"md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme\" \nng-disabled=\"vm.basicForm.$invalid || vm.basicForm.$pristine && vm.noexistchangues\" aria-label=\"SAVE\"><md-icon \nmd-font-icon=\"icon-check\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.SAVE\">Save</span></md-tooltip>\n</md-button><md-button type=\"button\" ng-click=\"vm.closeThreadEdit()\" \nclass=\"md-warn md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme\" aria-label=\"Cancel\"><md-icon \nmd-font-icon=\"icon-window-close\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.CANCEL\">Cancel</span>\n</md-tooltip></md-button></div></div><div id=\"content-edit\" ms-scroll=\"vm.msScrollOptions\" \nclass=\"scrollable page-layout simple fullwidth mail-content content-edit\" layout=\"column\" \nng-if=\"vm.currentThread_Edit\"><div ng-if=\"vm.currentTemplateView == \'edit\'\" layout=\"row\" \nng-include=\"\'app/main/apps/mailing/views/template/read/templates-tab-edit.html\'\"></div><div \nng-if=\"vm.currentTemplateView == \'test-users\'\" \nng-include=\"\'app/main/apps/mailing/views/template/read/templates-tab-test-users.html\'\"></div></div></div>");
$templateCache.put("app/main/apps/mailing/views/template/read/templates-tab-advanced-config.html","<div class=\"form-wrapper\" flex=\"100\"><form><div><md-input-container class=\"md-block\" flex><label \ntranslate=\"MAILING.ADDRESS_TEXT\"></label><textarea ui-tinymce=\"vm.tinymceOptions\" ng-model=\"formItem.defaultValue\" \ncolumns=\"1\" rows=\"1\"></textarea></md-input-container><md-input-container class=\"md-block\" flex><label \ntranslate=\"MAILING.SEND_TO_TEXT\"></label><textarea ui-tinymce=\"vm.tinymceOptions\" ng-model=\"formItem.defaultValue\" \ncolumns=\"1\" rows=\"1\"></textarea></md-input-container><md-input-container class=\"md-block\" flex><label \ntranslate=\"MAILING.UNSUBSCRIBE_TEXT\"></label><textarea ui-tinymce=\"vm.tinymceOptions\" ng-model=\"formItem.defaultValue\" \ncolumns=\"1\" rows=\"1\"></textarea></md-input-container><md-input-container class=\"md-block\" flex><label \ntranslate=\"MAILING.BACKGROUND_IMAGE\"></label><textarea columns=\"1\" rows=\"1\" \nplaceholder=\"{{vm.translate(\'MAILING.BACKGROUND_IMAGE\')}}\"></textarea></md-input-container><div \nclass=\"md-block ml-10 mr-10 mb-20 md-block\" layout=\"row\" layout-align=\"space-between center\"><div \nmd-color-picker-custom ng-model=\"formItem.backgroundColor\" default=\"#dddddd\" md-color-generic-palette=\"false\" \nmd-color-hsl=\"false\" md-color-rgb=\"false\" md-color-history=\"false\" \nlabel=\"{{vm.translate(\'MAILING.BACKGROUND_COLOR\')}}\" flex=\"33\"></div><div md-color-picker-custom \nng-model=\"formItem.bodyBackgroundColor\" default=\"#dddddd\" md-color-generic-palette=\"false\" md-color-hsl=\"false\" \nmd-color-rgb=\"false\" md-color-history=\"false\" label=\"{{vm.translate(\'MAILING.BODY_BACKGROUND_COLOR\')}}\" flex=\"33\">\n</div><div md-color-picker-custom ng-model=\"formItem.bodyBorderColor\" default=\"#dddddd\" \nmd-color-generic-palette=\"false\" md-color-hsl=\"false\" md-color-rgb=\"false\" md-color-history=\"false\" \nlabel=\"{{vm.translate(\'MAILING.BODY_BORDER_COLOR\')}}\" flex=\"33\"></div></div><md-input-container class=\"md-block\" \nflex=\"50\"><label translate=\"MAILING.ALIGN\"></label><md-select ng-model=\"formItem.defaultValue\" \nplaceholder=\"{{vm.translate(\'MAILING.ALIGN\')}}\"><md-option value=\"left\">{{vm.translate(\'MAILING.FORMAT_ALIGN_LEFT\')}}\n</md-option><md-option value=\"right\">{{vm.translate(\'MAILING.FORMAT_ALIGN_RIGHT\')}}</md-option><md-option \nvalue=\"center\">{{vm.translate(\'MAILING.FORMAT_ALIGN_CENTER\')}}</md-option></md-select></md-input-container></div>\n</form></div>");
$templateCache.put("app/main/apps/mailing/views/template/read/templates-tab-edit.html","<div class=\"form-wrapper\" flex=\"100\"><form><div><md-input-container class=\"md-block\" flex><label \ntranslate=\"MAILING.TEMPLATE_NAME\"></label><textarea ng-model=\"vm.currentThread_Edit.name\" columns=\"1\" rows=\"1\" \nplaceholder=\"{{vm.translate(\'MAILING.TEMPLATE_NAME\')}}\"></textarea></md-input-container><div layout=\"row\" \nlayout-align=\"center end\"><md-input-container class=\"md-block\" flex=\"50\"><label translate=\"MAILING.FROM_NAME\"></label>\n<textarea ng-model=\"vm.currentThread_Edit.from_name\" columns=\"1\" rows=\"1\" \nplaceholder=\"{{vm.translate(\'MAILING.FROM_NAME\')}}\"></textarea></md-input-container><md-input-container \nclass=\"md-block\" flex=\"50\"><label translate=\"MAILING.TEMPLATE_FLAGS\"></label><md-select \nng-model=\"vm.currentThread_Edit.lang\" placeholder=\"{{vm.translate(\'MAILING.TEMPLATE_FLAGS\')}}\" ng-required=\"false\">\n<md-option value=\"\">---</md-option><md-option ng-repeat=\"opt in vm.siteLanguages()\" value=\"{{opt.id_lang}}\">\n{{opt.lang_name}}</md-option></md-select><div class=\"md-errors-spacer\"></div></md-input-container></div><div \nlayout=\"row\" layout-align=\"center end\"><md-input-container class=\"md-block mr-0\" flex=\"30\"><label \ntranslate=\"MAILING.FROM_EMAIL\"></label><textarea ng-model=\"vm.currentThread_Edit.from_email_nodomain\" columns=\"1\" \nrows=\"1\"></textarea></md-input-container><md-input-container class=\"md-block mr-0 ml-0\"><span>@</span>\n</md-input-container><md-input-container class=\"md-block ml-0\" flex=\"70\"><md-select \nng-model=\"vm.currentThread_Edit.id_mailing_domain\"><div ng-repeat=\"domain in vm.mailingOptions.domains\" \nlayout=\"column\"><md-option value=\"{{domain.id_mailing_domain}}\">{{domain.domain_name}}</md-option></div></md-select>\n</md-input-container></div></div><div><div class=\"md-toolbar-tools grey-100-bg border-bottom border-top\" \nrole=\"listitem\"><h3 class=\"grey-700-fg\" translate=\"MAILING.SUBSCRIPTION_GROUP\"></h3></div><md-input-container \nclass=\"md-block\" flex=\"50\"><label translate=\"MAILING.SUBSCRIPTION_GROUP\"></label><md-select \nng-model=\"vm.currentThread_Edit.subscription_group\" placeholder=\"{{vm.translate(\'GLOBAL.SELECT_ONE\')}}\"><div \nng-repeat=\"userGroup in vm.usersGroups\" ng-if=\"!userGroup.parent\" layout=\"column\"><md-option \nvalue=\"{{userGroup.id_group}}\" ng-disabled=\"!userGroup.allow_users\"><md-icon md-font-icon=\"icon-folder-multiple\" \nclass=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon>{{userGroup.name}}</md-option><div \nng-repeat=\"ug in userGroup.children\" layout=\"column\"><md-option class=\"child-option\" value=\"{{ug.id_group}}\"><md-icon \nng-if=\"ug.id_group_type == 1\" md-font-icon=\"icon-folder\" class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"ug.id_group_type == 2\" md-font-icon=\"qiu-icon-file-usermailing\" \nclass=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon ng-if=\"ug.id_group_type == 3\" \nmd-font-icon=\"qiu-icon-file-usermediacenter\" class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\">\n</md-icon><md-icon ng-if=\"ug.id_group_type == 4\" md-font-icon=\"qiu-icon-file-usersegment\" \nclass=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon ng-if=\"ug.id_group_type == 5\" \nmd-font-icon=\"qiu-icon-file-userstore\" class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon>\n<md-icon ng-if=\"ug.id_group_type == 6\" md-font-icon=\"qiu-icon-file-useracreditation\" \nclass=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon ng-if=\"ug.id_group_type == 7\" \nmd-svg-src=\"/assets/icons/svg/icon-folder-chat.svg\" class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\">\n</md-icon><md-icon ng-if=\"ug.id_group_type == 8\" md-font-icon=\"icon-folder-remove\" \nclass=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon>{{ug.name}}</md-option><div \nng-repeat=\"ug2 in ug.children\" layout=\"column\"><md-option class=\"child-option subchild-option\" \nvalue=\"{{ug2.id_group}}\"><md-icon ng-if=\"ug2.id_group_type == 1\" md-font-icon=\"icon-folder\" \nclass=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon ng-if=\"ug2.id_group_type == 2\" \nmd-font-icon=\"qiu-icon-file-usermailing\" class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon>\n<md-icon ng-if=\"ug2.id_group_type == 3\" md-font-icon=\"qiu-icon-file-usermediacenter\" \nclass=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon ng-if=\"ug2.id_group_type == 4\" \nmd-font-icon=\"qiu-icon-file-usersegment\" class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon>\n<md-icon ng-if=\"ug2.id_group_type == 5\" md-font-icon=\"qiu-icon-file-userstore\" \nclass=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon ng-if=\"ug2.id_group_type == 6\" \nmd-font-icon=\"qiu-icon-file-useracreditation\" class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\">\n</md-icon><md-icon ng-if=\"ug2.id_group_type == 7\" md-svg-src=\"/assets/icons/svg/icon-folder-chat.svg\" \nclass=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon ng-if=\"ug2.id_group_type == 8\" \nmd-font-icon=\"icon-folder-remove\" class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon>\n{{ug2.name}}</md-option><div ng-repeat=\"ug3 in ug2.children\" layout=\"column\"><md-option \nclass=\"child-option subchild-option\" value=\"{{ug3.id_group}}\"><md-icon ng-if=\"ug3.id_group_type == 1\" \nmd-font-icon=\"icon-folder\" class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"ug3.id_group_type == 2\" md-font-icon=\"qiu-icon-file-usermailing\" class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"ug3.id_group_type == 3\" md-font-icon=\"qiu-icon-file-usermediacenter\" \nclass=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon ng-if=\"ug3.id_group_type == 4\" \nmd-font-icon=\"qiu-icon-file-usersegment\" class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon>\n<md-icon ng-if=\"ug3.id_group_type == 5\" md-font-icon=\"qiu-icon-file-userstore\" \nclass=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon ng-if=\"ug3.id_group_type == 6\" \nmd-font-icon=\"qiu-icon-file-useracreditation\" class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\">\n</md-icon><md-icon ng-if=\"ug3.id_group_type == 7\" md-svg-src=\"/assets/icons/svg/icon-folder-chat.svg\" \nclass=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon ng-if=\"ug3.id_group_type == 8\" \nmd-font-icon=\"icon-folder-remove\" class=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon>\n{{ug3.name}}</md-option></div></div></div></div></md-select></md-input-container></div><div class=\"border-bottom\"><div \nclass=\"md-toolbar-tools grey-100-bg border-bottom border-top\" role=\"listitem\"><h3 class=\"grey-700-fg\" \ntranslate=\"MAILING.TEMPLATE_DESIGN\"></h3></div><md-input-container layout=\"row\" layout-align=\"start center\" flex>\n<md-button ng-click=\"vm.showDesignView()\" class=\"add-event-button md-fab md-warn ml-0\" aria-label=\"ADD\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></md-button><span class=\"font-size-16 grey-500-fg ml-5\" \ntranslate=\"MAILING.EDIT_DESIGN\"></span><md-button ng-click=\"vm.showTemplatePlus($event)\" \nclass=\"add-event-button md-fab md-accent ml-16\" aria-label=\"TEMPLATE PLUS\"><md-icon md-font-icon=\"icon-star\"></md-icon>\n</md-button><span class=\"font-size-16 grey-500-fg ml-5\">Template Plus</span></md-input-container></div></form></div>");
$templateCache.put("app/main/apps/mailing/views/template/read/templates-tab-media.html","<md-list-item ng-repeat=\"mediazone in vm.mediaZones\" ng-if=\"vm.mediaZones\" class=\"list-media-item attachment-edit\"><div\n ng-include=\"\'app/main/apps/mailing/views/editors/editors-add-media.html\'\"></div><md-divider></md-divider>\n</md-list-item>");
$templateCache.put("app/main/apps/mailing/views/template/read/templates-tab-test-users.html","<div class=\"form-wrapper\" flex=\"100\"><form name=\"vm.sentTestForm\" class=\"md-inline-form\" novalidate><div><div \nclass=\"md-toolbar-tools grey-100-bg border-bottom\" role=\"listitem\"><h3 class=\"grey-700-fg\" \ntranslate=\"MAILING.TEST_USERS\"></h3></div><div layout=\"column\" layout-padding><md-list class=\"p-0\" \nng-if=\"vm.currentThread_Edit.test_emails_json.length > 0\"><md-list-item \nng-repeat=\"email in vm.currentThread_Edit.test_emails_json track by $index\" class=\"border-bottom\"><md-icon \nmd-font-icon=\"icon-email\" class=\"md-avatar-icon\"></md-icon><p>{{email}}</p><md-button \nclass=\"md-secondary md-icon-button md-warn\" ng-click=\"vm.currentThread_Edit.test_emails_json.splice($index, 1)\" \naria-label=\"Remove email\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-list-item></md-list><div \nlayout=\"row\" layout-align=\"start center\" ng-if=\"vm.isAddingEmail\" class=\"grey-50-bg\" \nstyle=\"border-radius: 4px; padding: 10px; margin: 15px 0\"><md-input-container class=\"md-block m-0\" flex><label \ntranslate=\"MAILING.ADD_EMAIL\"></label><input type=\"email\" name=\"newTestEmail\" ng-model=\"vm.newTestEmail\" \nng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-if=\"vm.currentThread_Edit.test_emails_json && vm.currentThread_Edit.test_emails_json.indexOf(vm.newTestEmail) !== -1\" \nclass=\"md-caption\" style=\"color: rgb(244,67,54); margin-top: 5px\" translate=\"MAILING.EMAIL_ALREADY_EXISTS\">\nEl email usado ya existe</div></md-input-container><md-button class=\"md-icon-button md-accent\" \nng-click=\"vm.currentThread_Edit.test_emails_json = vm.currentThread_Edit.test_emails_json || []; vm.currentThread_Edit.test_emails_json.push(vm.newTestEmail); vm.newTestEmail = \'\'; vm.isAddingEmail = false\" \nng-disabled=\"vm.sentTestForm.newTestEmail.$invalid || !vm.newTestEmail || (vm.currentThread_Edit.test_emails_json && vm.currentThread_Edit.test_emails_json.indexOf(vm.newTestEmail) !== -1)\" \naria-label=\"Accept\"><md-icon md-font-icon=\"icon-check\"></md-icon></md-button><md-button class=\"md-icon-button md-warn\" \nng-click=\"vm.isAddingEmail = false; vm.newTestEmail = \'\'\" aria-label=\"Cancel\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div><div layout=\"row\" ng-if=\"!vm.isAddingEmail\" style=\"margin-top: 15px\"><md-button \nclass=\"md-primary md-raised m-0\" ng-click=\"vm.isAddingEmail = true\"><md-icon md-font-icon=\"icon-plus\"></md-icon><span \ntranslate=\"MAILING.ADD_EMAIL\"></span></md-button></div></div></div></form></div>");
$templateCache.put("app/main/apps/mailing/views/template-plus/list/list-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-if=\"isLoading\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div class=\"no-threads\" \nng-if=\"!isLoading && vm.templates.length === 0\" ng-hide=\"isLoading\">There are no items!</div><div \nid=\"list-content-data\" ng-style=\"{\'opacity\': isLoading ? 0.2 : 1}\" ms-scroll=\"vm.msScrollOptions\" \nng-class=\"{\'other-filter\': sortField}\" class=\"scrollable\" ng-if=\"vm.templates.length > 0\"><div \nclass=\"mail-list-item {{tpl.status}}\" ng-repeat=\"tpl in vm.templates | filter: vm.search | filter: global.search\" \nng-init=\"parentIndex=$index\" md-no-ink ng-click=\"vm.openTemplate(tpl, $event)\" \nng-class=\"{\'selected\': vm.selectedTemplateID === tpl.id_mailing_templates, \'checked\': vm.isChecked(tpl)}\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\" flex><md-checkbox \nclass=\"no-label\" ng-checked=\"vm.isSelected(tpl)\" ng-click=\"vm.toggleSelectThread(tpl, $event)\" \naria-label=\"{{vm.isSelected(tpl) ? \'Deselect\' : \'Select\'}}\"></md-checkbox><div class=\"info layout-column flex\" flex \nlayout=\"column\"><div class=\"name text-truncate\" layout=\"row\" layout-align=\"start center\"><span>{{tpl.name}}</span>\n</div><div class=\"details\" layout=\"column\" layout-gt-md=\"row\" layout-align=\"start start\"><div layout=\"row\" \nclass=\"mr-10 mb-5 text-truncate\" ng-if=\"tpl.from_name || tpl.from_email\"><span class=\"title grey-500-fg\">\n{{\'MAILING.FROM\' | translate}}: </span><span ng-bind=\"tpl.from_name\" class=\"mr-5\"></span> <span ng-if=\"tpl.from_email\" \nclass=\"grey-500-fg\">&lt;{{tpl.from_email}}&gt;</span></div></div></div></div><div class=\"status-wrapper text-center\" \nlayout=\"row\" layout-align=\"end center\"><div class=\"status grey-300-bg ml-10\" layout=\"row\" layout-align=\"center center\">\n<span>#{{tpl.id_mailing_templates}}</span></div></div></div></div><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"end center\"><div layout=\"row\" layout-align=\"center center\" \nng-style=\"{\'display\': isLoading ? \'none\' : \'block\'}\"><span class=\"page-info\">{{pagination_totalItems}} items found.\n</span><md-button aria-label=\"Previous\" class=\"md-icon-button arrow\" ng-click=\"pagination_prevPage()\" \nng-disabled=\"pagination_firstPage()\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button><span \nclass=\"page-info\">{{pagination_page}} / {{pagination_total_pages}}</span><md-button aria-label=\"Next\" \nclass=\"md-icon-button arrow\" ng-click=\"pagination_nextPage()\" ng-disabled=\"pagination_morePages()\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div></div>");
$templateCache.put("app/main/apps/mailing/views/template-plus/list/nosplit-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/mailing/views/template-plus/list/toolbar.html\'\"></div><div class=\"content-wrapper\" flex \nlayout=\"row\"><div class=\"content thread-list mail-list-pane\" flex=\"40\" id=\"thread-list\" \nng-include=\"\'app/main/apps/mailing/views/template-plus/list/list-view.html\'\"></div><div hide show-gt-md \nclass=\"content thread-detail mail-read-pane\" flex=\"60\" id=\"thread-detail\" layout=\"column\" \nng-include=\"\'app/main/apps/mailing/views/template-plus/read/template-read-view.html\'\"></div><div hide-gt-md \nclass=\"content thread-detail mail-read-pane\" flex=\"100\" id=\"thread-detail\" layout=\"column\" \nng-if=\"vm.selectedTemplateID\" ng-include=\"\'app/main/apps/mailing/views/template-plus/read/template-read-view.html\'\">\n</div></div>");
$templateCache.put("app/main/apps/mailing/views/template-plus/list/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-accent green-500-bg md-raised\" hide show-gt-sm \nng-click=\"vm.newTemplate($event)\" type=\"button\" aria-label=\"NEW\" translate=\"CONTENT.ADD\"></md-button><md-button \naria-label=\"ADD NEW\" class=\"md-fab md-mini md-accent green-500-bg md-raised\" hide-gt-sm \nng-click=\"vm.newTemplate($event)\" type=\"button\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><div \nclass=\"divider-vertical\" hide show-gt-xs></div><div \nclass=\"action-buttons hide show-gt-xs layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\" \nng-show=\"vm.selectedThreads.length > 0\"><md-button ng-click=\"vm.duplicateTemplate()\" aria-label=\"Duplicate\" \nclass=\"md-icon-button\" hide show-gt-xs><md-icon md-font-icon=\"icon-content-duplicate\"></md-icon><md-tooltip hide \nshow-gt-xs><span translate=\"CONTENT.DUPLICATE\"></span></md-tooltip></md-button><md-button \nng-show=\"vm.selectedThreads.length > 0\" ng-click=\"vm.deleteTemplate()\" aria-label=\"Delete\" class=\"md-icon-button\" hide \nshow-gt-xs><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.DELETE\">\n</span></md-tooltip></md-button><div class=\"divider-vertical\" hide show-gt-xs></div></div><ms-search-bar \ndebounce=\"300\" model-search=\"$root.pagination_searchquery\" on-result-click=\"vm.searchResultClick(item)\" \non-search=\"vm.search(query)\" layout=\"row\" layout-align=\"start center\"></ms-search-bar><md-button \nng-click=\"$root.pagination_resetquery()\" aria-label=\"reset\" class=\"md-icon-button\" \nng-if=\"$root.pagination_searchquery==true\"><md-icon md-font-icon=\"icon-filter-remove-outline\"></md-icon></md-button>\n<div class=\"divider-vertical\" hide show-gt-xs></div><md-button aria-label=\"Sort ASC\" class=\"md-icon-button\" \nng-click=\"vm.setSortOrder(\'ASC\')\" ng-if=\"sortDir !== \'ASC\'\"><md-icon md-font-icon=\"icon-sort-ascending\"></md-icon>\n</md-button><md-button aria-label=\"Sort DESC\" class=\"md-icon-button\" ng-click=\"vm.setSortOrder(\'DESC\')\" \nng-if=\"sortDir === \'ASC\'\"><md-icon md-font-icon=\"icon-sort-descending\"></md-icon></md-button><md-menu><button \naria-label=\"Order\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" show-gt-xs><md-icon \nmd-font-icon=\"icon-chevron-down\"><md-tooltip><span translate=\"CONTENT.ORDER_BY\">Order</span></md-tooltip></md-icon>\n</button><md-menu-content width=\"1\"><md-menu-item><md-button ng-click=\"vm.setSortField(\'id_mailing_templates\')\">ID\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.setSortField(\'created_at\')\">Creation date</md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.setSortField(\'updated_at\')\">Update date</md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.setSortField(\'name\')\">Name</md-button></md-menu-item></md-menu-content></md-menu>\n</div><div layout=\"row\" layout-align=\"start center\"><span class=\"page-info\" hide show-gt-xs>\n{{pagination_totalItems}} items found.</span><md-button aria-label=\"Previous\" class=\"md-icon-button arrow\" hide \nng-click=\"pagination_prevPage()\" ng-disabled=\"pagination_firstPage()\" show-gt-xs><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><span class=\"page-info\" hide show-gt-xs>\n{{pagination_page}} / {{pagination_total_pages}}</span><md-button aria-label=\"Next\" class=\"md-icon-button arrow\" hide \nng-click=\"pagination_nextPage()\" ng-disabled=\"pagination_morePages()\" show-gt-xs><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>");
$templateCache.put("app/main/apps/mailing/views/template-plus/read/template-read-view.html","<div class=\"mail-content cp-empty-state\" layout=\"column\" layout-align=\"center center\" ng-if=\"!vm.currentTemplate\"><div \nclass=\"content\" layout=\"column\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-email-open\" \nclass=\"cp-empty-state-icon\"></md-icon><p class=\"grey-400-fg mt-16\" translate=\"MAILING.SELECT_ITEM_TO_SHOW\">\nSelect an item to show</p></div></div><div ng-if=\"vm.currentTemplate\" class=\"form-wrapper\"><form name=\"vm.basicForm\" \nclass=\"md-inline-form\" novalidate><div class=\"toolbar grey-100-bg colored-bg\" layout=\"row\" \nlayout-align=\"space-between center\" scroll><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.openEditor($event)\" translate translate-attr-aria-label=\"MAILING.EDIT\" \naria-label=\"Editar\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate=\"MAILING.EDIT\"></span></md-tooltip></md-button><div class=\"divider-vertical\" hide show-gt-sm></div><md-button\n class=\"md-icon-button\" ng-click=\"vm.openPreview($event)\" translate translate-attr-aria-label=\"MAILING.PREVIEW\" \nng-disabled=\"!vm.currentTemplate.structure_mjml\" aria-label=\"Previsualizar\"><md-icon md-font-icon=\"icon-web\"></md-icon>\n<md-tooltip hide show-gt-xs><span translate=\"MAILING.PREVIEW\"></span></md-tooltip></md-button><div \nclass=\"divider-vertical\" hide show-gt-sm></div></div><div layout=\"row\" layout-align=\"end center\" hide show-gt-sm>\n<md-button ng-click=\"vm.saveTemplate()\" class=\"send-button md-accent md-raised\" aria-label=\"SAVE\" \ntranslate=\"MAILING.SAVE\" translate-attr-aria-label=\"MAILING.SAVE\"></md-button><md-button type=\"button\" \nng-click=\"vm.closeDetail()\" class=\"md-raised md-warn\" aria-label=\"Cancel\" translate=\"MAILING.CANCEL\" \ntranslate-attr-aria-label=\"MAILING.CANCEL\"></md-button></div><div layout=\"row\" layout-align=\"end center\" hide-gt-sm>\n<md-button ng-click=\"vm.saveTemplate()\" class=\"md-fab md-mini md-accent md-raised\" aria-label=\"SAVE\"><md-icon \nmd-font-icon=\"icon-check\"></md-icon></md-button><md-button type=\"button\" ng-click=\"vm.closeDetail()\" \nclass=\"md-warn md-fab md-mini md-accent md-raised\" aria-label=\"Cancel\"><md-icon md-font-icon=\"icon-window-close\">\n</md-icon></md-button></div></div><div id=\"content-edit\" ms-scroll=\"vm.msScrollOptions\" \nclass=\"scrollable page-layout simple fullwidth mail-content content-edit\" layout=\"column\"><div layout=\"row\" \nng-include=\"\'app/main/apps/mailing/views/template-plus/read/template-tab-edit.html\'\"></div></div></form></div>");
$templateCache.put("app/main/apps/mailing/views/template-plus/read/template-tab-edit.html","<div class=\"form-wrapper\" flex=\"100\"><div><md-input-container class=\"md-block\" flex><div class=\"item grey-500-fg\" \ntranslate=\"MAILING.NAME\">Name</div><input data-ng-model=\"vm.currentTemplate.name\" required></md-input-container></div>\n<div layout=\"row\" layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex><div class=\"item grey-500-fg\" \ntranslate=\"MAILING.FROM_NAME\">From name</div><input data-ng-model=\"vm.currentTemplate.from_name\"></md-input-container>\n<md-input-container class=\"md-block\" flex><div class=\"item grey-500-fg\" translate=\"MAILING.FROM_EMAIL\">From email</div>\n<input data-ng-model=\"vm.currentTemplate.from_email\"></md-input-container></div><div class=\"border-bottom\"><div \nclass=\"md-toolbar-tools grey-100-bg border-bottom border-top\" role=\"listitem\"><h3 class=\"grey-700-fg\" \ntranslate=\"MAILING.CONTENT_DESIGN\">Design</h3></div><md-input-container layout=\"row\" \nlayout-align=\"space-between center\" flex><div layout=\"row\" layout-align=\"start center\" flex><md-button \nng-click=\"vm.openEditor($event)\" class=\"add-event-button md-fab md-warn ml-0\" aria-label=\"Edit design\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></md-button><span class=\"font-size-16 grey-500-fg ml-5\" \ntranslate=\"MAILING.EDIT_DESIGN\">Edit design with Template Plus</span></div></md-input-container></div></div>");
$templateCache.put("app/main/apps/match-center/views/list/tabs/tab-matches.html","<div class=\"mb-15 mr-16\" layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"add-event-button no-sort md-fab md-warn\" ng-click=\"vm.newMatch()\" aria-label=\"Add\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div><div class=\"border-top\"><div \nclass=\"template flex team-row drag-item\" layout=\"row\" ng-repeat=\"match in vm.matches track by $index\" \nlayout-align=\"space-between center\" \nng-include=\"\'app/main/apps/match-center/views/list/sports-templates/\'+vm.sport+\'/match-template.html\'\"></div></div>");
$templateCache.put("app/main/apps/match-center/views/list/tabs/tab-settings.html","<form id=\"tab-settings\" class=\"tab-settings\" name=\"vm.basicForm\"><div class=\"p-15\"><md-input-container \nclass=\"md-block\"><label translate=\"MATCH_CENTER.TITLE\"></label><input \nng-model=\"vm.currentCompetitionSeason.reference_name\" type=\"text\" required></md-input-container><md-input-container \nng-if=\"!vm.currentCompetitionSeason.has_subcompetitions\" class=\"md-block\"><label translate=\"MATCH_CENTER.TYPE_MATCH\">\n</label><md-select ng-model=\"vm.currentCompetitionSeason.match_type\" \nplaceholder=\"{{vm.translate(\'MATCH_CENTER.TYPE_MATCH\')}}\"><md-option value=\"\">---</md-option><md-option \nng-repeat=\"comp in vm.typesMatch\" value=\"{{comp.id}}\">{{comp.name | translate}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\"><label translate=\"MATCH_CENTER.CLASIFICATION_TYPE\"></label>\n<md-select ng-model=\"vm.currentCompetitionSeason.result_type\" placeholder=\"Clasification type\"><md-option value=\"\">---\n</md-option><md-option ng-repeat=\"comp in vm.typesClasification\" value=\"{{comp.id}}\">{{vm.translate(comp.name)}}\n</md-option></md-select></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"MATCH_CENTER.GROUP\"></label><md-select ng-model=\"vm.currentCompetitionSeason.group\" \nplaceholder=\"{{vm.translate(\'MATCH_CENTER.GROUP\')}}\"><md-option value=\"\">---</md-option><md-option \nng-repeat=\"group in vm.groups\" value=\"{{group.id}}\">{{vm.translate(group.group_name)}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\"><label translate=\"MATCH_CENTER.PHASE\"></label><md-select \nng-model=\"vm.currentCompetitionSeason.phase\" placeholder=\"{{vm.translate(\'MATCH_CENTER.PHASE\')}}\"><md-option value=\"\">\n---</md-option><md-option ng-repeat=\"phase in vm.phases\" value=\"{{phase.id}}\">{{vm.translate(phase.phase_name)}}\n</md-option></md-select></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"MATCH_CENTER.SERIE\"></label><md-select ng-model=\"vm.currentCompetitionSeason.serie\" \nplaceholder=\"{{vm.translate(\'MATCH_CENTER.SERIE\')}}\"><md-option value=\"\">---</md-option><md-option \nng-repeat=\"s in vm.serie\" value=\"{{s.id}}\">{{vm.translate(s.serie_name)}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"MATCH_CENTER.CLASS\"></label><md-select \nng-model=\"vm.currentCompetitionSeason.class\" placeholder=\"{{vm.translate(\'MATCH_CENTER.CLASS\')}}\"><md-option value=\"\">\n---</md-option><md-option ng-repeat=\"class in vm.classes\" value=\"{{class.id}}\">{{vm.translate(class.class_name)}}\n</md-option></md-select></md-input-container><md-input-container class=\"md-block m-0\"><label \ntranslate=\"MATCH_CENTER.SECTION_ORIGIN\"></label><input \nng-model=\"vm.currentCompetitionSeason.teams_section_data.sectionTeams\" type=\"text\" required></md-input-container>\n<md-input-container class=\"md-block m-0\"><label translate=\"MATCH_CENTER.SECTION_ORIGIN_ID\"></label><input \nng-model=\"vm.currentCompetitionSeason.teams_section_data.sectionTeamsId\" type=\"text\" required></md-input-container>\n<md-input-container class=\"md-block m-0\"><label translate=\"MATCH_CENTER.SECTION_ORIGIN_NAME\"></label><input \nng-model=\"vm.currentCompetitionSeason.teams_section_data.sectionTeamsName\" type=\"text\" required></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"MATCH_CENTER.STANDINGS_SORT\"></label><md-select \nng-model=\"vm.currentCompetitionSeason.result_sort\" placeholder=\"{{vm.translate(\'MATCH_CENTER.STANDINGS_SORT\')}}\">\n<md-option value=\"\">---</md-option><md-option value=\"DESC\">DESC</md-option><md-option value=\"ASC\">ASC</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\"><md-checkbox class=\"no-label\" \nng-model=\"vm.currentCompetitionSeason.live_results\" ng-true-value=\"1\" ng-false-value=\"0\">\n{{vm.translate(\'MATCH_CENTER.LIVE_RESULTS\')}}</md-checkbox></md-input-container></div></form><div \nclass=\"toolbar grey-100-bg colored-bg\" flex layout=\"row\" layout-align=\"space-between center\" scroll=\"\"><div flex \nlayout=\"row\" layout-align=\"end center\"><md-button type=\"button\" ng-click=\"vm.closeCompetitionSeason()\" \nclass=\"md-raised md-warn\" aria-label=\"Cancel\">Cancel</md-button><md-button type=\"submit\" \nng-click=\"vm.saveCompetitionSeason()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.basicForm.$invalid || vm.basicForm.$pristine\" aria-label=\"SAVE\" translate=\"CONTENT.SAVE\" \ntranslate-attr-aria-label=\"CONTENT.SAVE\">SAVE</md-button></div></div>");
$templateCache.put("app/main/apps/match-center/views/list/tabs/tab-standings.html","<div ng-include=\"\'app/main/apps/match-center/views/list/sports-templates/\'+vm.sport+\'/standings-template.html\'\"></div>");
$templateCache.put("app/main/apps/match-center/views/list/tabs/tab-teams.html","<div class=\"mb-15 mr-16\" layout=\"row\" layout-align=\"end center\"><md-button class=\"send-button md-accent md-raised\" \nng-click=\"vm.openImportDialog($event)\" aria-label=\"Add\" translate=\"FORMS.IMPORT\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"md-default-theme md-font material-icons icon-update\">IMPORT</md-icon></md-button><md-button \nclass=\"send-button md-accent md-raised\" ng-click=\"vm.updateTeams()\" aria-label=\"Add\" translate=\"FORMS.UPDATE\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-default-theme md-font material-icons icon-update\">UPDATE</md-icon></md-button>\n<md-button \nng-disabled=\"vm.currentCompetitionSeason.teams && vm.currentCompetitionSeason.teams.length >= vm.currentSettings.max_teams\" \nclass=\"add-event-button no-sort md-fab md-warn\" ng-click=\"vm.seeUpdate = false;vm.openTeamsDialog($event)\" \naria-label=\"Add\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div class=\"border-top\"><div \nclass=\"template flex team-row drag-item\" layout=\"row\" \nng-repeat=\"team in vm.currentCompetitionSeason.teams track by $index\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><img ng-if=\"team.media\" class=\"avatar team-avatar\" ng-src=\"{{team.media}}\" \nalt=\"\"> <img ng-if=\"!team.media\" class=\"avatar team-avatar\" ng-src=\"assets/images/common/no_image_available_10.png\" \nimageonload><div class=\"field ml-10N\" layout=\"column\"><div><span class=\"font-size-16 grey-700-fg\" \nng-bind=\"team.team_name\"></span></div></div></div><div layout=\"row\" layout-align=\"end center\"><div class=\"pointer\" \nng-if=\"vm.currentCompetitionSeason.result_type == 2 || vm.currentCompetitionSeason.result_type == 3\"><md-icon \nng-click=\"team.hidestandings= true;\" ng-if=\"!team.hidestandings\" md-font-icon=\"icon-eye\"></md-icon><md-tooltip \nng-if=\"!team.hidestandings\" md-autohide=\"true\">{{\'MATCH_CENTER.HIDE_STANDINGS\' | translate}}</md-tooltip><md-icon \nng-click=\"team.hidestandings= false;\" ng-if=\"team.hidestandings\" md-font-icon=\"icon-eye-off\"></md-icon><md-tooltip \nng-if=\"team.hidestandings\" md-autohide=\"true\">{{\'MATCH_CENTER.SHOW_STANDINGS\' | translate}}</md-tooltip></div><md-menu>\n<md-button class=\"md-icon-button\" aria-label=\"More\" ng-click=\"vm.openMenu($mdMenu, $event)\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/more_vert.svg\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button ng-click=\"vm.deleteTeam($index, $event)\" aria-label=\"Delete\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-default-theme md-font material-icons icon-delete\"></md-icon>Remove</md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div>");
$templateCache.put("app/main/apps/match-center/views/list/tabs/tab-venues.html","<div class=\"mb-15 mr-16\" layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"add-event-button no-sort md-fab md-warn\" ng-click=\"vm.openVenuesDialog($event)\" aria-label=\"Add\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div><div class=\"border-top\"><div \nclass=\"template flex team-row drag-item\" layout=\"row\" \nng-repeat=\"venue in vm.currentCompetitionSeason.venues track by $index\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><img ng-if=\"venue.media\" class=\"avatar\" ng-src=\"{{venue.media}}\" alt=\"\"> <img \nng-if=\"!venue.media\" class=\"avatar\" ng-src=\"assets/images/common/no_image_available_10.png\" imageonload><div \nclass=\"field ml-10\" layout=\"column\"><div><span class=\"font-size-16 grey-700-fg\" ng-bind=\"venue.title\"></span></div>\n</div></div><div layout=\"row\" layout-align=\"end center\"><md-menu><md-button class=\"md-icon-button\" aria-label=\"More\" \nng-click=\"vm.openMenu($mdMenu, $event)\"><md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/more_vert.svg\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"vm.currentCompetitionSeason.venues.splice($index, 1); vm.saveCompetitionSeason() \" aria-label=\"Delete\">\n<md-icon md-font-icon=\"icon-delete\" class=\"md-default-theme md-font material-icons icon-delete\"></md-icon>Remove\n</md-button></md-menu-item></md-menu-content></md-menu></div></div></div>");
$templateCache.put("app/main/apps/match-center/views/list/templates/tab-clips-list.html","<md-tabs md-dynamic-height flex=\"100\"><md-tab><md-tab-label>{{ vm.translate(\'MATCH_CENTER.RAW\')}}</md-tab-label>\n<md-tab-body><md-list-item class=\"list-media-item attachment-edit\"><div class=\"attachments\"><div class=\"field\"><div \nclass=\"attachment-list md-list-item-text\" layout=\"row\" layout-wrap=\"\" layout-align=\"start start\" \nng-sortable=\"vm.mediaSortable\"><div class=\"attachment\" ng-class=\"{\'new\' : clip.isNew}\" layout=\"column\" \nng-repeat=\"clip in vm.clips | filter: {\'id_zone\': 1} | orderBy:\'-id_media\'\"><div><div class=\"ms-card\" flex \nmd-dynamic-height=\"{{vm.dynamicHeight}}\"><div ng-if=\"clip.isNew\" \nclass=\"new-clip layout-row layout-align-center-space-between\"><md-icon md-font-icon=\"icon-movie\" \nclass=\"white-fg s16 mr-5\" role=\"img\" aria-label=\"icon-movie\"></md-icon><span class=\"ml-5\">NEW</span></div><div \nclass=\"ms-card-content-wrapper\"><div class=\"template-9\"><div class=\"media\" flex layout=\"row\" \nlayout-align=\"center center\"><media attachment=\"clip\" class-img=\"image\" \nng-click=\"vm.openImageDialog($event, clip, false, false, true)\"></media></div><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"size block mr-5\" layout=\"row\" layout-align=\"start center\" \nng-if=\"clip.media_type\"><strong class=\"mr-5\">#{{clip.id_media}}</strong> <span class=\"grey-500-fg word-break-all\">\n{{clip.title ? clip.title : clip.filename}}</span></div><md-menu><button class=\"md-icon-button\" aria-label=\"More\" \ntranslate translate-attr-aria-label=\"TODO.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\" \nng-click=\"$mdMenu.open($event)\"></md-icon></button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.editClipApi($event,clip)\" aria-label=\"Toggle done\" translate-attr-aria-label=\"CONTENT.EDIT\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"s18 ml-10\" href=\"#\"></md-icon><span translate=\"CONTENT.EDIT\"></span></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.openPreview($event, clip)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"MATCH_CENTER.SHARE\"><md-icon md-font-icon=\"icon-share-variant\" class=\"s18 ml-10\" href=\"#\">\n</md-icon><span translate=\"MATCH_CENTER.SHARE\"></span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.joinClipsWindow($event, clip, vm.clips)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"MATCH_CENTER.JOIN_CLIP\"><md-icon md-font-icon=\"icon-view-week\" class=\"s18 ml-10\" href=\"#\">\n</md-icon><span translate=\"MATCH_CENTER.JOIN_CLIP\"></span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.downloadClip(clip.embed.split(\'|\')[1])\"><md-icon md-font-icon=\"icon-cloud-download\" class=\"s18 ml-10\">\n</md-icon><span translate=\"MATCH_CENTER.DOWNLOAD\"></span></md-button></md-menu-item></md-menu-content></md-menu></div>\n</div></div></div></div></div></div></div></div><md-divider></md-divider></md-list-item></md-tab-body></md-tab><md-tab>\n<md-tab-label>{{ vm.translate(\'MATCH_CENTER.EDITED\')}}</md-tab-label><md-tab-body><md-list-item \nclass=\"list-media-item attachment-edit\"><div class=\"attachments\"><div class=\"field\"><div \nclass=\"attachment-list md-list-item-text\" layout=\"row\" layout-wrap=\"\" layout-align=\"start start\" \nng-sortable=\"vm.mediaSortable\"><div class=\"attachment\" ng-class=\"{\'new\' : clip.isNew}\" layout=\"column\" \nng-repeat=\"clip in vm.clips | filter: {\'id_zone\': 2} | orderBy:\'-id_media\'\"><div><div class=\"ms-card\" flex \nmd-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"ms-card-content-wrapper\"><div class=\"template-9\"><div \nng-if=\"clip.isNew\" class=\"new-clip\">{{ \"MATCH_CENTER.IS_NEW_CLIP\" | translate}}</div><div class=\"media\" flex \nlayout=\"row\" layout-align=\"center center\"><media attachment=\"clip\" class-img=\"image\" \nng-click=\"vm.openImageDialog($event, clip, false, false, true)\"></media></div><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"size block mr-5\" layout=\"row\" layout-align=\"start center\" \nng-if=\"clip.media_type\"><strong class=\"mr-5\">#{{clip.id_media}}</strong> <span class=\"grey-500-fg word-break-all\">\n{{clip.title ? clip.title : clip.filename}}</span></div><md-menu><button class=\"md-icon-button\" aria-label=\"More\" \ntranslate translate-attr-aria-label=\"TODO.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\" \nng-click=\"$mdMenu.open($event)\"></md-icon></button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.openPreview($event, clip)\" aria-label=\"Toggle done\" translate-attr-aria-label=\"MATCH_CENTER.SHARE\">\n<md-icon md-font-icon=\"icon-share-variant\" class=\"s18 ml-10\" href=\"#\"></md-icon><span translate=\"MATCH_CENTER.SHARE\">\n</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.joinClipsWindow($event, clip, vm.clips)\" \naria-label=\"Toggle done\" translate-attr-aria-label=\"MATCH_CENTER.JOIN_CLIP\"><md-icon md-font-icon=\"icon-view-week\" \nclass=\"s18 ml-10\" href=\"#\"></md-icon><span translate=\"MATCH_CENTER.JOIN_CLIP\"></span></md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.downloadClip(clip.embed.split(\'|\')[1])\"><md-icon \nmd-font-icon=\"icon-cloud-download\" class=\"s18 ml-10\"></md-icon><span translate=\"MATCH_CENTER.DOWNLOAD\"></span>\n</md-button></md-menu-item></md-menu-content></md-menu></div></div></div></div></div></div></div></div></div>\n<md-divider></md-divider></md-list-item></md-tab-body></md-tab></md-tabs>");
$templateCache.put("app/main/apps/media/dialogs/add-media-galleries/views/add-media-galleries.html","<md-toolbar class=\"md-default-theme grey-100-bg grey-600-fg pr-16 pl-16\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\"><label for=\"search-bar-input\"><md-icon ng-if=\"!vm.treeSearch\" \nmd-font-icon=\"icon-magnify\" class=\"grey-600-fg md-icon-button md-button search\"><md-tooltip hide show-gt-xs><span \ntranslate=\"TOOLBAR.SEARCH\">Search</span></md-tooltip></md-icon><md-icon layout-align=\"end center\" \nmd-font-icon=\"icon-close-circle\" class=\"grey-600-fg md-icon-button md-button\" ng-if=\"vm.treeSearch\" \nng-click=\"vm.treeSearch = null\"></md-icon></label><input type=\"text\" id=\"search-bar-input\" \nclass=\"grey-600-fg grey-100-bg\" ng-model=\"vm.treeSearch\" placeholder=\"Search\" md-autofocus translate \ntranslate-attr-placeholder=\"TOOLBAR.SEARCH\" flex></div></md-toolbar><md-content ms-scroll class=\"\" flex><div flex \nlayout=\"column\" layout-align=\"center center\" ng-show=\"vm.isLoading\" class=\"loading-container\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nclass=\"navigation-simple groups-tree pt-20 pb-20\" layout=\"column\" ng-style=\"{\'opacity\' : vm.isLoading ? 0.2 : 1}\"><div \nng-if=\"vm.CleanMediaGalleries\" ivh-treeview=\"vm.CleanMediaGalleries\" ivh-treeview-label-attribute=\"\'gallery_name\'\" \nivh-treeview-filter=\"vm.treeSearch\" ivh-treeview-expand-to-depth=\"0\" class=\"ivh-treeview-folder small\"><script \ntype=\"text/ng-template\">\n<div class=\"level-card p-8 gallery-row\" layout=\"row\" layout-align=\"space-between stretch\">\r\n                    <span ivh-treeview-twistie ivh-treeview-toggle layout=\"row\" layout-align=\"center center\"></span>\r\n                    <div flex layout=\"row\" layout-align=\"start center\">\r\n                        <md-icon\r\n                            ng-if=\"!node.children && node.gallery_type == 0\"\r\n                            md-font-icon=\"icon-folder\"\r\n                            class=\"s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon\r\n                            ng-if=\"!node.children && node.gallery_type == 1\"\r\n                            md-font-icon=\"icon-folder-image\"\r\n                            class=\"s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon\r\n                            ng-if=\"!node.children && node.gallery_type == 2\"\r\n                            md-font-icon=\"qiu-icon-video-folder\"\r\n                            class=\"s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon\r\n                            ng-if=\"!node.children && node.gallery_type == 3\"\r\n                            md-font-icon=\"qiu-icon-audio-folder\"\r\n                            class=\"s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon\r\n                            ng-if=\"!node.children && node.gallery_type == 4\" \r\n                            md-font-icon=\"qiu-icon-file-folder\"\r\n                            class=\"s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon\r\n                            ng-if=\"node.children && node.gallery_type == 0\"\r\n                            md-font-icon=\"icon-folder-multiple\"\r\n                            class=\"s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon\r\n                            ng-if=\"node.children && node.gallery_type == 1\"\r\n                            md-font-icon=\"icon-folder-multiple-image\"\r\n                            class=\"s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon\r\n                            ng-if=\"node.children && node.gallery_type == 2\"\r\n                            md-font-icon=\"qiu-icon-video-gallery\"\r\n                            class=\"s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon\r\n                            ng-if=\"node.children && node.gallery_type == 3\"\r\n                            md-font-icon=\"qiu-icon-audio-gallery\"\r\n                            class=\"s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon\r\n                            ng-if=\"node.children && node.gallery_type == 4\"\r\n                            md-font-icon=\"qiu-icon-file-gallery\"\r\n                            class=\"s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <span class=\"ivh-treeview-node-label ng-binding\">{{node.gallery_name}}</span>\r\n\r\n                    </div>\r\n                    <div layout=\"row\" layout-align=\"end center\">\r\n                        <md-checkbox\r\n                            ng-disabled=\"node.is_qiu_restricted_root || node.no_files_allowed\"\r\n                            ng-checked=\"node.assigned_gallery\"\r\n                            class=\"ml-5 mb-0\"\r\n                            aria-label=\"{{node.assigned_gallery ? \'Deselect\' : \'Select\'}}\"\r\n                            ng-click=\"node.assigned_gallery = !node.assigned_gallery\"\r\n                        ></md-checkbox>\r\n                    </div>\r\n                </div>\r\n                <div ivh-treeview-children></div>\n</script></div></div></md-content>");
$templateCache.put("app/main/apps/match-center/views/list/tabs-match/tab-comments.html","<div id=\"comments\" class=\"content\"><div ng-if=\"!vm.showFormAddComment && !vm.loadingAddComment\" layout=\"row\" \nlayout-align=\"end center\"><md-button ng-disabled=\"!vm.currentMatch.id\" class=\"add-event-button no-sort md-fab md-warn\" \nng-click=\"vm.showFormAddComment = true\" aria-label=\"Add\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div>\n<div ng-if=\"vm.showFormAddComment\"><div layout=\"row\" layout-=\"start\"><md-input-container flex=\"100\"><label>\n{{\'MATCH_CENTER.LANGUAGE\' | translate}}</label><md-select ng-model=\"vm.dataComment.langSelected\" \nmd-container-class=\"md-select-mini md-select-search\"><md-optgroup label=\"{{\'MATCH_CENTER.LANGUAGE\' | translate}}\">\n<md-option ng-value=\"language.value\" ng-repeat=\"language in vm.languages\">{{language.name}}</md-option></md-optgroup>\n</md-select></md-input-container></div><div layout=\"row\" layout-=\"start\"><md-input-container flex-gt-sm layout=\"row\" \nlayout-align=\"start center\" flex=\"100\"><label>{{ \'MATCH_CENTER.COMMENT\' | translate}}</label><input type=\"text\" \nng-model=\"vm.dataComment.comment\" placeholder=\"{{ \'MATCH_CENTER.COMMENT\' | translate}}\" md-autofocus \nautocomplete=\"off\"></md-input-container></div><div layout=\"row\" layout-=\"start\"><md-input-container flex-gt-sm \nlayout=\"row\" layout-align=\"start center\" flex=\"100\"><label>Time</label><md-select fill-width \nng-model=\"vm.dataComment.time\" md-on-close=\"searchTime = \'\'\" md-container-class=\"md-select-mini md-select-search\">\n<md-select-header class=\"select-header-search\"><input autofocus ng-model=\"searchTime\" type=\"search\" \nonkeydown=\"event.stopPropagation()\" placeholder=\"Search...\" class=\"demo-header-searchbox md-text\"></md-select-header>\n<md-optgroup ng-repeat=\"category in vm.categoriesTime.categories\" label=\"{{vm.translate(category.name)}}\"><md-option \nng-value=\"option\" \nng-repeat=\"option in  vm.categoriesTime.options | filter: {category: category.value, name: searchTime }\"><span \nng-if=\"category.value != 0\">Min.</span> {{option.name}} <span ng-if=\"category.value != 0\">\n({{vm.translate(category.name)}})</span></md-option></md-optgroup></md-select></md-input-container></div><div flex \nlayout=\"row\" layout-align=\"end center\" scroll=\"\"><div><md-button ng-disabled=\"!vm.dataComment.comment\" type=\"submit\" \nclass=\"send-button md-accent md-raised\" ng-click=\"vm.addComment(vm.dataComment)\" aria-label=\"PUBLISH\" \ntranslate=\"MATCH_CENTER.PUBLISH\" translate-attr-aria-label=\"MATCH_CENTER.PUBLISH\"></md-button><md-button type=\"button\" \nclass=\"md-raised md-warn\" ng-click=\"vm.cancelAddComment()\" aria-label=\"Cancel\" translate=\"MATCH_CENTER.CANCEL\" \ntranslate-attr-aria-label=\"MATCH_CENTER.CANCEL\"></md-button></div></div></div><div class=\"content-list\"><div flex \nlayout=\"column\" layout-align=\"center center\" ng-if=\"vm.loadingCommentsPane\" class=\"loading-container mt-100\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nclass=\"order-row text-left grey-100-bg\"><md-button ng-if=\"vm.languageFilter\" class=\"md-icon-button\" \nng-click=\"vm.languageFilter = null\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button>\n<md-input-container style=\"min-width: 200px\" class=\"m-0\" flex=\"100\"><label>\n{{\'MATCH_CENTER.FILTER_BY_LANGUAGE\' | translate}}</label><md-select ng-model=\"vm.languageFilter\" \nmd-container-class=\"md-select-mini md-select-search\"><md-optgroup label=\"{{\'MATCH_CENTER.LANGUAGE\' | translate}}\">\n<md-option ng-value=\"language.value\" ng-repeat=\"language in vm.languages\">{{language.name}}</md-option></md-optgroup>\n</md-select></md-input-container></div><div \nng-repeat=\"comment in vm.matchComments  | filter: {lang: vm.languageFilter ? vm.languageFilter : \'\' } | orderBy:\'datetime\':true\" \nclass=\"row-comment\"><div layout=\"row\" layout-align=\"start center\"><div flex layout=\"column\"><div><div class=\"name\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"avatar\" ms-random-class=\"vm.colors\" \nng-bind=\"comment.author | capitalizeFirstLetter\"></div><div class=\"user-name text-truncate\"><span \nng-bind=\"comment.author\"></span><div class=\"details\" layout=\"row\" layout-align=\"start start\"><span \nclass=\"text-truncate title\" ng-bind=\"vm.timeAgo(comment.datetime)\"></span><span ng-if=\"comment.time\">\n(Min. {{comment.time}})</span></div></div></div></div></div><div><button ng-if=\"comment.onoff===1\" \nclass=\"md-icon-button md-button\" ng-click=\"vm.toggleItemStatusComment(comment, $event)\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\"></md-icon></button> <button \nng-if=\"comment.onoff!==1\" class=\"md-icon-button md-button\" ng-click=\"vm.toggleItemStatusComment(comment, $event)\">\n<md-icon md-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\"></md-icon></button></div><div>\n<md-icon class=\"pointer\" ng-click=\"vm.removeComment(comment)\" md-font-icon=\"icon-delete \"></md-icon></div><div \nlayout=\"column\" layout-align=\"space-between end\"></div></div><div class=\"details ml-50\" layout-align=\"start start\"><p \nflex ng-bind=\"comment.comment\"></p></div></div></div></div>");
$templateCache.put("app/main/apps/match-center/views/list/tabs-match/tab-events.html","<div id=\"events\" class=\"content\"><div ng-if=\"!vm.showFormAddEvent && !vm.loadingAddEvent\" layout=\"row\" \nlayout-align=\"end center\"><md-button ng-disabled=\"!vm.currentMatch.id\" class=\"add-event-button no-sort md-fab md-warn\" \nng-click=\"vm.showFormAddEvent = true\" aria-label=\"Add\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div>\n<div ng-if=\"vm.showFormAddEvent\"><div layout=\"row\" layout-=\"start\"><md-input-container flex=\"25\" \nng-if=\"vm.sport != \'sailing\'\"><label>{{ vm.getTranslateBySport(\'TIME\') | translate}}</label><md-select \nng-model=\"vm.dataEvent.timeSelected\" md-on-close=\"searchTime = \'\'\" \nmd-container-class=\"md-select-mini md-select-search\"><md-select-header class=\"select-header-search\"><input autofocus \nng-model=\"searchTime\" type=\"search\" onkeydown=\"event.stopPropagation()\" placeholder=\"Search...\" \nclass=\"demo-header-searchbox md-text\"></md-select-header><md-optgroup \nng-repeat=\"category in vm.categoriesTime.categories\" label=\"{{vm.translate(category.name)}}\"><md-option \nng-value=\"option\" \nng-repeat=\"option in  vm.categoriesTime.options | filter: {category: category.value, name: searchTime }\"><span \nng-if=\"category.value != 0\">Min.</span> {{option.name}} <span ng-if=\"category.value != 0\">\n({{vm.translate(category.name)}})</span></md-option></md-optgroup></md-select></md-input-container>{{searchAction}}\n<md-input-container flex=\"25\"><label>Action</label><md-select md-container-class=\"md-select-mini md-select-search\" \nmd-on-close=\"searchAction = \'\'\" ng-model=\"vm.dataEvent.actionSelected\"><md-select-header class=\"select-header-search\">\n<input autofocus ng-model=\"searchAction\" type=\"search\" onkeydown=\"event.stopPropagation()\" placeholder=\"Search...\" \nclass=\"demo-header-searchbox md-text\"></md-select-header><md-option ng-value=\"option\" \nng-repeat=\"option in vm.matches_events_actions | filter: { action_name : searchAction} | orderBy:\'action_name\':false:localeSensitiveComparator\">\n{{option.action_name}}</md-option></md-select></md-input-container><md-input-container flex=\"25\"><label>\n{{ vm.getTranslateBySport(\'TEAM\') | translate}}</label><md-select md-container-class=\"md-select-mini md-select-search\" \nmd-on-close=\"searchTeam = \'\'\" ng-model=\"vm.dataEvent.teamSelected\"><md-select-header class=\"select-header-search\">\n<input autofocus ng-model=\"searchTeam\" type=\"search\" onkeydown=\"event.stopPropagation()\" placeholder=\"Search...\" \nclass=\"demo-header-searchbox md-text\"></md-select-header><md-optgroup label=\"Name\"><md-option ng-value=\"team\" \nng-repeat=\"team in vm.currentMatch.teams_data | filter: { team_name : searchTeam}\">{{team.team_name}}</md-option>\n</md-optgroup></md-select></md-input-container><md-input-container \nng-if=\"vm.sport != \'cars\' && (vm.sport != \'tennis\' || false)\" flex=\"25\"><label>Player</label><md-select \nmd-container-class=\"md-select-mini md-select-search\" md-on-close=\"searchPlayer = \'\'\" \nng-model=\"vm.dataEvent.playerSelected\"><md-select-header class=\"select-header-search\"><input autofocus \nng-model=\"searchPlayer\" type=\"search\" onkeydown=\"event.stopPropagation()\" placeholder=\"Search...\" \nclass=\"demo-header-searchbox md-text\"></md-select-header><md-option ng-value=\"player\" \nng-repeat=\"player in  vm.getTeamsPeople(vm.dataEvent.teamSelected) |  filter:criteriaMatch(searchPlayer) | orderBy:\'name\':false:localeSensitiveComparator\">\n{{player.name}}</md-option></md-select></md-input-container></div><div flex layout=\"row\" layout-align=\"end center\" \nscroll=\"\"><div><md-button ng-disabled=\"!vm.dataEvent.timeSelected || !vm.dataEvent.actionSelected\" type=\"submit\" \nclass=\"send-button md-accent md-raised\" ng-click=\"vm.addEvent(vm.dataEvent)\" aria-label=\"PUBLISH\" \ntranslate=\"MATCH_CENTER.PUBLISH\" translate-attr-aria-label=\"MATCH_CENTER.PUBLISH\"></md-button><md-button \nng-disabled=\"!vm.dataEvent.timeSelected || !vm.dataEvent.actionSelected\" type=\"submit\" \nclass=\"send-button md-accent md-raised\" ng-click=\"vm.addEvent(vm.dataEvent, 1)\" aria-label=\"PUBLISH_AND_SEND\" \ntranslate=\"MATCH_CENTER.PUBLISH_AND_SEND\" translate-attr-aria-label=\"MATCH_CENTER.PUBLISH_AND_SEND\"></md-button>\n<md-button type=\"button\" class=\"md-raised md-warn\" ng-click=\"vm.cancelAddEvent()\" aria-label=\"Cancel\" \ntranslate=\"MATCH_CENTER.CANCEL\" translate-attr-aria-label=\"MATCH_CENTER.CANCEL\"></md-button></div></div></div><div \nclass=\"content-list\"><div flex layout=\"column\" layout-align=\"center center\" ng-if=\"vm.loadingEventsPane\" \nclass=\"loading-container mt-100\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular>\n</div><div class=\"order-row grey-100-bg\"><md-icon ng-click=\"vm.sortEvents =\'reverse\'\" \nmd-font-icon=\"icon-sort-ascending\" class=\"s20 mr-5 ml-0 mb-0\" ng-if=\"vm.sortEvents === \'\'\"></md-icon><md-icon \nng-click=\"vm.sortEvents =\'\'\" md-font-icon=\"icon-sort-descending\" class=\"s20 mr-5 ml-0 mb-0\" \nng-if=\"vm.sortEvents === \'reverse\'\"></md-icon></div><div class=\"list\"><md-list-item \nng-style=\"{\'opacity\' :  (event.time === vm.timeSorting ? \'0.4\' : \'1\') }\" \nng-repeat=\"event in vm.matchEvents | orderBy:[\'time_category\', \'time\',\'sort\']:vm.sortEvents  track by $index\" \nid=\"{{$index}}\"><div class=\"{{vm.getActionClass(event.id_action)}}\" flex=\"100\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\" flex=\"55\"><h3 \nclass=\"text-center w-32 mr-5\"><strong>{{event.time}}\'</strong></h3><div class=\"mr-10\"><md-icon \nmd-font-icon=\"icon-match-{{vm.getActionClass(event.id_action)}}\" class=\"s32\"><md-tooltip hide show-gt-xs>\n{{event.action}}</md-tooltip></md-icon></div><div layout=\"column\"><h4 flex \nng-if=\"event.name_player || event.name_team\"><strong ng-if=\"event.name_player\">{{event.name_player}}</strong> <span \nclass=\"grey-fg\" ng-if=\"event.name_team\">// {{event.name_team}}</span></h4><h4 class=\"grey-fg\" flex \nng-bind=\"event.action\" ng-if=\"!event.name_player && !event.name_team && event.action\"></h4></div></div><h4 flex=\"30\" \nclass=\"grey-fg text-right\" ng-hide=\"!event.name_player && !event.name_team\">{{event.action}}</h4><md-icon \nclass=\"pointer\" ng-click=\"vm.sortEvent(-1, $index)\" md-font-icon=\"icon-arrow-up\" ng-if=\"vm.isSortableUpEvent($index)\">\n<md-tooltip hide show-gt-xs>Move up</md-tooltip></md-icon><md-icon class=\"pointer\" ng-click=\"vm.sortEvent(1, $index)\" \nmd-font-icon=\"icon-arrow-down\" ng-if=\"vm.isSortableDownEvent($index)\"></md-icon><md-tooltip hide show-gt-xs>Move down\n</md-tooltip><div flex=\"30\" layout=\"column\" ng-if=\"event.datetime\"><h4 class=\"grey-800-fg\" flex \nng-bind=\"event.datetime\"></h4></div><div layout=\"row\" flex=\"10\" flex-align=\"end center\"><md-icon \nmd-font-icon=\"icon-cellphone-iphone\" ng-if=\"event.send_push == 1\"><md-tooltip hide show-gt-xs>\n{{vm.translate(\'MATCH_CENTER.PUSH_SENT\')}}</md-tooltip></md-icon><md-icon md-font-icon=\"icon-cellphone-iphone\" \nng-if=\"event.send_push != 1\" class=\"grey-200-fg\"><md-tooltip hide show-gt-xs>\n{{vm.translate(\'MATCH_CENTER.PUSH_NOT_SENT\')}}</md-tooltip></md-icon><md-icon class=\"pointer\" \nng-click=\"vm.removeEvent(event)\" md-font-icon=\"icon-delete \"></md-icon></div></div></md-list-item></div></div></div>");
$templateCache.put("app/main/apps/match-center/views/list/tabs-match/tab-live-clips.html","<div fill-width layout=\"column\"><div layout=\"row\" \nng-include=\"\'app/main/apps/match-center/views/list/templates/tab-clips-list.html\'\"></div></div>");
$templateCache.put("app/main/apps/match-center/views/list/tabs-match/tab-live.html","<div ng-if=\"vm.matchLivesUrl\" fill-width layout=\"column\" class=\"black-bg white-fg height-percent-100\"><div \nlayout=\"row\"><player tags=\"vm.clipsData\" on-emit-create-mark=\"vm.createMark(start, end,title, edit, $event)\" \non-emit-create-api=\"vm.createClipApi(start, end,title, edit, $event)\" \non-emit-create=\"vm.createClip(start, end, $event)\" url=\"vm.matchLivesUrl\" class=\"player\"></player></div><div \nng-if=\"!vm.existTabClips\" layout=\"row\"><p class=\"mh-25 grey-500-fg\">Clips</p></div><div ng-if=\"!vm.existTabClips\" \nlayout=\"row\" ng-include=\"\'app/main/apps/match-center/views/list/templates/tab-clips-list.html\'\"></div></div>");
$templateCache.put("app/main/apps/match-center/views/list/tabs-match/tab-match.html","<div id=\"match\" class=\"content form-wrapper\"><form class=\"layout-wrap layout-row data\"><div flex=\"100\" flex-gt-md=\"33\">\n<md-input-container class=\"md-block\"><label translate=\"MATCH_CENTER.COMPETITION\"></label><input ng-disabled=\"true\" \nng-value=\"vm.currentCompetitionSeason.competition.title+ \', \'+vm.currentCompetitionSeason.reference_name\"><md-tooltip \nhide show-gt-xs><span>\n{{vm.currentCompetitionSeason.competition.title+ \', \'+vm.currentCompetitionSeason.reference_name}}</span></md-tooltip>\n</md-input-container></div><div flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"33\"><md-input-container class=\"md-block\"><label>\n{{vm.getTranslateBySport(\'MATCH\') | translate}}</label><input ng-model=\"vm.currentMatch.match_name\">\n</md-input-container></div><div flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"33\"><md-input-container class=\"md-block\"><label \ntranslate=\"MATCH_CENTER.ROUND\"></label><input type=\"number\" min=\"1\" ng-model=\"vm.currentMatch.round\">\n</md-input-container></div><div flex=\"100\" layout=\"column\" layout-gt-md=\"row\"><div flex><md-input-container \nclass=\"md-block\"><label class=\"opacity-0\">//</label><md-checkbox ng-checked=\"vm.currentMatch.date == null\" \nng-click=\"vm.setUndefindedDate()\" class=\"no-label\" \naria-label=\"{{vm.translate(\'MATCH_CENTER.NO_DEFINED_DATE\') | translate}}\">\n{{vm.translate(\'MATCH_CENTER.NO_DEFINED_DATE\') | translate}}</md-checkbox></md-input-container></div><div flex \nclass=\"date-container\" ng-if=\"vm.currentMatch.date !=  null\"><mdp-date-picker mdp-placeholder=\"Date\" \nmdp-format=\"{{vm.dateFormat}}\" mdp-open-on-click=\"true\" ng-model=\"vm.currentMatch.date\" \nng-change=\"vm.updateDatePicker()\" class=\"date-time-picker\"></mdp-date-picker></div><div flex class=\"date-container\" \nng-if=\"vm.currentMatch.date !=  null\"><mdp-time-picker mdp-placeholder=\"Time\" ng-model=\"vm.currentMatch.date\" \nng-change=\"vm.updateDatePicker()\" class=\"date-time-picker\"></mdp-time-picker></div><div flex class=\"date-container\" \nng-if=\"vm.currentMatch.date !=  null\"><md-input-container class=\"md-block\"><label>UTC Date</label><input type=\"text\" \nng-model=\"vm.currentMatch.utcShow\" disabled=\"disabled\"></md-input-container></div></div><div \nng-if=\"vm.currentCompetitionSeason.venues\" flex=\"100\" flex-gt-md=\"33\"><md-input-container class=\"md-block\"><label \ntranslate=\"MATCH_CENTER.VENUE\"></label><md-select ng-model=\"vm.currentMatch.id_venue\"><md-option \nng-repeat=\"venue in vm.currentCompetitionSeason.venues\" ng-value=\"venue.id_venues\">{{venue.title}}</md-option>\n</md-select></md-input-container></div><div flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"33\"><md-input-container \nclass=\"md-block\"><label translate=\"MATCH_CENTER.MATCH_STATUS\"></label><md-select ng-model=\"vm.currentMatch.status\">\n<md-option ng-repeat=\"status in vm.match_statuses\" ng-value=\"status.id\">{{vm.translate(status.name)}}</md-option>\n</md-select></md-input-container></div><div flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"33\" ng-if=\"vm.sport != \'sailing\'\">\n<md-input-container class=\"md-block\"><label translate=\"MATCH_CENTER.FINAL_TYPE\"></label><md-select \nng-model=\"vm.currentMatch.results_data.final_type\"><md-option ng-repeat=\"type in vm.final_types\" ng-value=\"type.id\">\n{{vm.translate(type.name)}}</md-option></md-select></md-input-container></div><div flex=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"33\"><md-input-container class=\"md-block\"><label translate=\"MATCH_CENTER.RESULT_TYPE\"></label><md-select \nng-model=\"vm.currentMatch.results_data.result_type\"><md-option ng-repeat=\"type in vm.result_types\" ng-value=\"type.id\">\n{{vm.translate(type.name)}}</md-option></md-select></md-input-container></div><div flex=\"100\"><md-input-container \nclass=\"md-block\"><label>{{ \'MATCH_CENTER.COMMENT\' | translate}}</label><input type=\"text\" \nng-model=\"vm.currentMatch.comment\" placeholder=\"{{ \'MATCH_CENTER.COMMENT\' | translate}}\" md-autofocus \nautocomplete=\"off\"></md-input-container></div><div flex=\"100\"><md-input-container class=\"md-block\"><label \nclass=\"opacity-0\">//</label><md-checkbox ng-checked=\"vm.currentMatch.active == \'1\'\" \nng-click=\"vm.currentMatch.active = (vm.currentMatch.active == \'1\') ? \'0\' : \'1\'\" class=\"no-label\" \naria-label=\"{{vm.translate(\'MATCH_CENTER.ACTIVE\') | translate}}\">{{vm.translate(\'MATCH_CENTER.ACTIVE\') | translate}}\n</md-checkbox></md-input-container></div></form><div id=\"jury\"><md-list-item class=\"md-toolbar-tools fix grey-100-bg\">\n<div class=\"mr-5\" layout=\"row\" layout-align=\"end start\"><md-icon ng-if=\"vm.showJury === false\" \nng-click=\"vm.showJury = true\" md-font-icon=\"icon-chevron-down pointer\"></md-icon><md-icon ng-if=\"vm.showJury === true\" \nng-click=\"vm.showJury = false\" md-font-icon=\"icon-chevron-up pointer\"></md-icon></div><h3 class=\"grey-700-fg\" \ntranslate=\"MATCH_CENTER.JURY\"></h3><md-divider></md-divider></md-list-item><div ng-if=\"vm.showJury\" \nng-sortable=\"vm.templateSortable\"><div class=\"template flex team-row drag-item\" layout=\"row\" \nng-repeat=\"jury in vm.currentMatch.jury_data track by $index\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon class=\"drag icon-equal\" aria-label=\"DRAG\"></md-icon><img ng-if=\"jury.media\" \nclass=\"avatar\" ng-src=\"{{jury.media}}\" alt=\"\"> <img ng-if=\"!jury.media\" class=\"avatar\" \nng-src=\"assets/images/common/no_image_available_10.png\" imageonload><div class=\"field ml-10\" layout=\"column\"><div><span\n class=\"font-size-16 grey-700-fg\" ng-bind=\"jury.name\"></span></div></div></div><div layout=\"row\" \nlayout-align=\"end center\"><md-menu><md-button class=\"md-icon-button\" aria-label=\"More\" \nng-click=\"vm.openMenu($mdMenu, $event)\"><md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/more_vert.svg\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"vm.currentMatch.jury_data.splice($index, 1)\" aria-label=\"Delete\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"md-default-theme md-font material-icons icon-delete\"></md-icon>Remove</md-button></md-menu-item>\n</md-menu-content></md-menu></div></div></div><div ng-if=\"vm.showJury\" class=\"mt-15 mb-15 mr-16\" layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"add-event-button no-sort md-fab md-warn\" \nng-click=\"vm.openJuryDialog($event)\" aria-label=\"Add\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div>\n</div><div id=\"teams\"><div class=\"teams-container {{vm.sport}}\"><md-list-item class=\"md-toolbar-tools fix grey-100-bg\">\n<div class=\"mr-5\" layout=\"row\" layout-align=\"end start\"><md-icon ng-if=\"vm.showTeams === false\" \nng-click=\"vm.showTeams = true\" md-font-icon=\"icon-chevron-down pointer\"></md-icon><md-icon \nng-if=\"vm.showTeams === true\" ng-click=\"vm.showTeams = false\" md-font-icon=\"icon-chevron-up pointer\"></md-icon></div>\n<h3 class=\"grey-700-fg\" translate=\"MATCH_CENTER.TEAMS\"></h3><div flex layout=\"row\" layout-align=\"end center\" \nclass=\"mr-55\" ng-if=\"vm.sport == \'sailing\' || vm.sport == \'cars\'\"><span class=\"score-box\"><div \nstyle=\"min-width: 60px; text-align: center\"><span class=\"score font-size-14 grey-700-fg mr-5\" \nng-bind=\"vm.translate(\'MATCH_CENTER.POINTS\')\"></span></div></span><span class=\"score-box\"><div \nstyle=\"min-width: 80px; text-align: center\"><span class=\"score font-size-14 grey-700-fg mr-5\" \nng-bind=\"vm.translate(\'MATCH_CENTER.STATUS\')\"></span></div></span><span class=\"score-box\"><div \nstyle=\"min-width: 80px; text-align: center\"><span class=\"score font-size-14 grey-700-fg mr-5\" \nng-bind=\"vm.translate(\'MATCH_CENTER.EXTRA\')\"></span></div></span><span class=\"score-box big\"><div \nstyle=\"min-width: 80px; text-align: center\"><span class=\"score font-size-14 grey-700-fg mr-5\" \nng-bind=\"vm.translate(\'MATCH_CENTER.START_TIME\')\"></span></div></span><span class=\"score-box big\"><div \nstyle=\"min-width: 80px; text-align: center\"><span class=\"score font-size-14 grey-700-fg mr-5\" \nng-bind=\"vm.translate(\'MATCH_CENTER.FINAL_TIME\')\"></span></div></span><span class=\"score-box big\"><div \nstyle=\"min-width: 80px; text-align: center\"><span class=\"score font-size-14 grey-700-fg mr-5\" \nng-bind=\"vm.translate(\'MATCH_CENTER.ELAPSED_TIME\')\"></span></div></span><span class=\"score-box big\"><div \nstyle=\"min-width: 80px; text-align: center\"><span class=\"score font-size-14 grey-700-fg mr-5\" \nng-bind=\"vm.translate(\'MATCH_CENTER.DELTA\')\"></span></div></span></div><div flex layout=\"row\" \nlayout-align=\"end center\" class=\"mr-55\" ng-if=\"vm.sport == \'football\'\"><span ng-if=\"vm.sport == \'football\'\" \nclass=\"score-box\"><div style=\"min-width: 60px; text-align: center\"><span class=\"score font-size-14 grey-700-fg mr-5\" \nng-bind=\"vm.translate(\'MATCH_CENTER.SCORE\')\"></span></div></span><span \nng-if=\"vm.currentMatch.results_data.final_type == 3 && vm.sport == \'football\'\" class=\"score-box\"><div \nstyle=\"min-width: 60px; text-align: center\"><span class=\"score font-size-14 grey-700-fg mr-5\" \nng-bind=\"vm.translate(\'MATCH_CENTER.PENALTIES\')\"></span></div></span></div><md-divider></md-divider></md-list-item><div\n ng-include=\"\'app/main/apps/match-center/views/list/sports-templates/\'+vm.sport+\'/team-template.html\'\"></div></div><div\n ng-if=\"vm.showTeams && (vm.currentMatch.teams_data.length < vm.getMaxTeams() || !vm.getMaxTeams() )\" class=\"mt-15\" \nlayout=\"row\" layout-align=\"end center\"><md-button class=\"add-event-button no-sort md-fab md-warn\" \nng-click=\"vm.openTeamMatchDialog($event)\" aria-label=\"Add\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>\n</div></div></div>");
$templateCache.put("app/main/apps/match-center/views/list/tabs-match/tab-media.html","<div class=\"white-bg width-percent-100\"><md-list-item ng-repeat=\"mediazone in vm.mediaZones\" ng-if=\"vm.mediaZones\" \nclass=\"list-media-item attachment-edit\"><div class=\"attachments\"><div class=\"field\"><p class=\"grey-500-fg ml-8\">\n{{ mediazone.title }}</p><div class=\"attachment-list sortable md-list-item-text\" ng-sortable=\"vm.mediaSortable\"><div \nclass=\"attachment\" layout=\"column\" ng-repeat=\"attachment in vm.thumbnails_Edit[mediazone.id_zone]\"><div \nclass=\"preview document\" layout=\"row\" layout-align=\"start center\" extension-class=\"{{attachment.filename}}\" \nng-href=\"{{attachment.permalink}}\" ng-if=\"attachment.media_type==3\" target=\"_blank\"><qiu-icon \nmediafile=\"attachment.filename\" class=\"mr-10\"></qiu-icon><a class=\"grey-1000-fg font-size-16\" \nng-href=\"{{attachment.permalink}}\" target=\"_blank\"><span ng-if=\"attachment.title\">{{attachment.title}}</span> <span \nng-if=\"attachment.filename\">{{attachment.filename}}</span></a></div><div \nng-if=\"attachment.media_type==1 || attachment.media_type==2 || attachment.media_type==4\"><div class=\"ms-card\" flex \nmd-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"ms-card-content-wrapper\"><div class=\"template-9\"><div \nclass=\"media\" flex layout=\"row\" layout-align=\"center center\" \nng-if=\"attachment.media_type==1 || attachment.media_type==2\"><media attachment=\"attachment\" class-img=\"image\" \nng-click=\"vm.openImageDialog($event, vm.currentMatch.Thumbnail, attachment)\"></media></div><div flex layout=\"column\" \nlayout-align=\"center center\" class=\"media\" ng-if=\"attachment.media_type==4\"><qiu-icon mediafile=\"attachment.filename\" \nclassextra=\"s56\"></qiu-icon><br><span class=\"grey-500-fg\" layout=\"column\" layout-align=\"center center\"><span \nng-if=\"attachment.title\"><strong>{{attachment.title}}</strong></span> <span ng-if=\"attachment.filename\">\n{{attachment.filename}}</span></span></div><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"size block mr-5\" layout=\"row\" layout-align=\"start center\"><strong class=\"mr-5\">#{{attachment.id_media}}</strong>\n <span class=\"grey-500-fg\" ng-if=\"attachment.media_type==1 || attachment.media_type==2\"><span \nng-if=\"attachment.title && !attachment.filename\">{{attachment.title}}</span> <span \nng-if=\"attachment.filename && !attachment.title\" class=\"word-break-all\">{{attachment.filename}}</span></span></div>\n<md-menu><button class=\"md-icon-button\" aria-label=\"More\" translate translate-attr-aria-label=\"TODO.MORE\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" ng-click=\"$mdMenu.open($event)\"></md-icon></button><md-menu-content width=\"3\">\n<md-menu-item><md-button ng-if=\"attachment.media_type==1 || attachment.media_type==2\" \nng-click=\"vm.openImageDialog($event, vm.currentMatch.Thumbnail, attachment)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.PREVIEW\"><md-icon md-font-icon=\"icon-eye\" class=\"ml-10\" href=\"#\" \nng-click=\"vm.openImageDialog($event, vm.selectedMail.Thumbnail, attachment)\"></md-icon><span \ntranslate=\"CONTENT.PREVIEW\">Preview</span></md-button><md-button ng-if=\"attachment.media_type==4\" \nng-click=\"vm.openUrl(attachment.permalink)\" target=\"_blank\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.PREVIEW\"><md-icon md-font-icon=\"icon-open-in-new\" class=\"ml-10\"></md-icon><span \ntranslate=\"MEDIA.OPEN\"></span></md-button></md-menu-item><md-menu-item ng-if=\"attachment.media_type==1\"><md-button \nng-click=\"vm.openFocalPoint($event, attachment)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.SET_FOCAL_POINT\"><md-icon md-font-icon=\"icon-image-filter-center-focus\" class=\"s18\">\n</md-icon><span translate=\"MEDIA.SET_FOCAL_POINT\"></span></md-button></md-menu-item><md-menu-item \nng-if=\"attachment.media_type==1\"><md-button ng-click=\"vm.openMediaItemMetadata($event, attachment)\" \naria-label=\"Toggle done\" translate-attr-aria-label=\"CONTENT.MEDIA_ITEM_EDIT_METADATA\"><md-icon \nmd-font-icon=\"icon-message-image\" class=\"s18\"></md-icon><span translate=\"MEDIA.MEDIA_ITEM_EDIT_METADATA\"></span>\n</md-button></md-menu-item><md-menu-item ng-if=\"attachment.media_type==1\"><md-button \nng-click=\"vm.MediaItemRecrop(attachment)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.MEDIA_ITEM_RECROP\"><md-icon md-font-icon=\"icon-image\" class=\"s18\"></md-icon><span \ntranslate=\"MEDIA.MEDIA_ITEM_RECROP\"></span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.downloadMediaOriginal(attachment)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.DOWNLOAD_ORIGINAL\"><md-icon md-font-icon=\"icon-image\" class=\"s18\"></md-icon><span \ntranslate=\"MEDIA.DOWNLOAD_ORIGINAL\"></span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.deleteAttachment(attachment)\" aria-label=\"Toggle done\" translate-attr-aria-label=\"CONTENT.REMOVE\"><md-icon\n md-font-icon=\"icon-close\" class=\"s18\"></md-icon><span translate=\"MEDIA.REMOVE\"></span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></div></div></div></div><div ng-if=\"attachment.id_gallery\"><div class=\"ms-card\" flex \nmd-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"ms-card-content-wrapper\"><div class=\"template-9\"><div flex \nlayout=\"column\" layout-align=\"center center\" class=\"media\"><md-icon class=\"s56 mr-5 ml-10\" \nmd-font-icon=\"icon-folder-multiple-image\"></md-icon><br><span class=\"grey-500-fg\" layout=\"column\" \nlayout-align=\"center center\"><span ng-if=\"attachment.gallery_name\"><strong>{{attachment.gallery_name}}</strong></span>\n</span></div><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div class=\"size block\" layout=\"row\" \nlayout-align=\"start center\"><strong class=\"mr-5\">#{{attachment.id_gallery}}</strong> <span class=\"grey-500-fg\">\n{{attachment.gallery_name}}</span></div><md-menu><button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"TODO.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\" ng-click=\"$mdMenu.open($event)\">\n</md-icon></button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.deleteAttachment(attachment)\" \naria-label=\"Delete gallery\" translate-attr-aria-label=\"CONTENT.REMOVE\"><md-icon md-font-icon=\"icon-close\" class=\"s18\">\n</md-icon><span translate=\"MEDIA.REMOVE\"></span></md-button></md-menu-item></md-menu-content></md-menu></div></div>\n</div></div></div></div></div><md-button class=\"add-event-button no-sort md-fab md-warn\" \nng-click=\"vm.mediaDialog($event, mediazone, vm.currentMatch)\" aria-label=\"Add\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon></md-button></div></div><md-divider></md-divider></md-list-item><md-list-item \nng-right-click=\"vm.selectOrUnselect(null, $event)\" class=\"list-media-item attachment-edit\" ng-if=\"!vm.mediaZones\"><div \nclass=\"attachments\"><div class=\"field\"><p class=\"grey-500-fg\" translate=\"CONTENT.NO_ZONE\"></p><div \nclass=\"attachment-list md-list-item-text\" layout=\"row\" layout-wrap=\"\" layout-align=\"start start\" \nng-sortable=\"vm.mediaSortable\"><div class=\"attachment\" layout=\"column\" \nng-repeat=\"attachment in vm.currentMatch.Thumbnail\"><div class=\"preview document\" layout=\"row\" \nlayout-align=\"start center\" extension-class=\"{{attachment.filename}}\" ng-href=\"{{attachment.permalink}}\" \nng-if=\"attachment.media_type==3\" target=\"_blank\"><qiu-icon mediafile=\"attachment.filename\" class=\"mr-10\"></qiu-icon><a \nclass=\"grey-1000-fg font-size-16\" ng-href=\"{{attachment.permalink}}\" target=\"_blank\"><span ng-if=\"attachment.title\">\n{{attachment.title}} </span><span ng-if=\"attachment.filename\">{{attachment.filename}}</span></a></div><div \nng-if=\"attachment.media_type==1 || attachment.media_type==2 || attachment.media_type==4\"><div class=\"ms-card\" flex \nmd-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"ms-card-content-wrapper\"><div class=\"template-9\"><div \nclass=\"media\" flex layout=\"row\" layout-align=\"center center\" \nng-if=\"attachment.media_type==1 || attachment.media_type==2\"><media attachment=\"attachment\" class-img=\"image\" \nng-click=\"vm.openImageDialog($event, vm.currentMatch.Thumbnail, attachment)\"></media></div><div flex layout=\"column\" \nlayout-align=\"center center\" class=\"media\" ng-if=\"attachment.media_type==4\"><qiu-icon mediafile=\"attachment.filename\" \nclassextra=\"s56\"></qiu-icon><br><span class=\"grey-500-fg\" layout=\"column\" layout-align=\"center center\"><span \nng-if=\"attachment.title\"><strong>{{attachment.title}}</strong></span> <span ng-if=\"attachment.filename\">\n{{attachment.filename}}</span></span></div><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"size block mr-5\" layout=\"row\" layout-align=\"start center\" ng-if=\"attachment.media_type\"><strong class=\"mr-5\">\n#{{attachment.id_media}}</strong> <span class=\"grey-500-fg word-break-all\">{{attachment.filename}}</span></div>\n<md-menu><button class=\"md-icon-button\" aria-label=\"More\" translate translate-attr-aria-label=\"TODO.MORE\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" ng-click=\"$mdMenu.open($event)\"></md-icon></button><md-menu-content width=\"3\">\n<md-menu-item><md-button ng-click=\"vm.openImageDialog($event, vm.currentMatch.Thumbnail, attachment)\" \naria-label=\"Toggle done\" translate-attr-aria-label=\"CONTENT.PREVIEW\"><md-icon md-font-icon=\"icon-eye\" \nclass=\"s16 ml-10\" href=\"#\" ng-click=\"vm.openImageDialog($event, vm.selectedMail.Thumbnail, attachment)\"></md-icon><span\n translate=\"MEDIA.PREVIEW\"></span></md-button></md-menu-item><md-menu-item ng-if=\"attachment.media_type==1\"><md-button \nng-click=\"vm.openFocalPoint($event, attachment)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.SET_FOCAL_POINT\"><md-icon md-font-icon=\"icon-image-filter-center-focus\" class=\"s18\">\n</md-icon><span translate=\"MEDIA.SET_FOCAL_POINT\"></span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.openMediaItemMetadata($event, attachment)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.MEDIA_ITEM_EDIT_METADATA\"><md-icon md-font-icon=\"icon-message-image\" class=\"s18\">\n</md-icon><span translate=\"MEDIA.MEDIA_ITEM_EDIT_METADATA\"></span></md-button></md-menu-item><md-menu-item \nng-if=\"attachment.media_type==1\"><md-button ng-click=\"vm.MediaItemRecrop(attachment)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.MEDIA_ITEM_RECROP\"><md-icon md-font-icon=\"icon-image\" class=\"s18\"></md-icon><span \ntranslate=\"MEDIA.MEDIA_ITEM_RECROP\"></span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.downloadMediaOriginal(attachment)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"CONTENT.DOWNLOAD_ORIGINAL\"><md-icon md-font-icon=\"icon-image\" class=\"s18\"></md-icon><span \ntranslate=\"MEDIA.DOWNLOAD_ORIGINAL\"></span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.deleteAttachment(attachment)\" aria-label=\"Toggle done\" translate-attr-aria-label=\"CONTENT.REMOVE\"><md-icon\n md-font-icon=\"icon-close\" class=\"s18\"></md-icon><span translate=\"MEDIA.REMOVE\"></span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></div></div></div></div><div ng-if=\"attachment.id_gallery\"><div class=\"ms-card\" flex \nmd-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"ms-card-content-wrapper\"><div class=\"template-9\"><div flex \nlayout=\"column\" layout-align=\"center center\" class=\"media\"><md-icon class=\"s56 mr-5 ml-10\" \nmd-font-icon=\"icon-folder-multiple-image\"></md-icon><br><span class=\"grey-500-fg\" layout=\"column\" \nlayout-align=\"center center\"><span ng-if=\"attachment.gallery_name\"><strong>{{attachment.gallery_name}}</strong></span>\n</span></div><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div class=\"size block mr-5\" \nlayout=\"row\" layout-align=\"start center\"><strong class=\"mr-5\">#{{attachment.id_gallery}}</strong> <span \nclass=\"grey-500-fg\">{{attachement.gallery_name}}</span></div><md-menu><button class=\"md-icon-button\" aria-label=\"More\" \ntranslate translate-attr-aria-label=\"TODO.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\" \nng-click=\"$mdMenu.open($event)\"></md-icon></button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.deleteAttachment(attachment)\" aria-label=\"Delete gallery\" translate-attr-aria-label=\"CONTENT.REMOVE\">\n<md-icon md-font-icon=\"icon-close\" class=\"s18\"></md-icon><span translate=\"MEDIA.REMOVE\"></span></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></div></div></div><md-button \nclass=\"add-event-button md-fab md-warn\" ng-click=\"vm.mediaDialog($event, \'\', vm.currentMatch)\" aria-label=\"Add\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div><md-divider></md-divider></md-list-item></div>");
$templateCache.put("app/main/apps/match-center/views/list/tabs-match/tab-notifications.html","<div fill-width layout=\"column\" class=\"mt-25\"><div layout=\"row\"><div flex=\"50\" class=\"ph-25\"><md-select \nng-model=\"typeNotification\"><md-option value=\"push\">Push Notification</md-option><md-option value=\"web\">\nWeb Push Notification</md-option><md-option value=\"sms\">SMS</md-option></md-select></div><div flex=\"50\" class=\"ph-25\">\n<md-select ng-model=\"typeUsers\"><md-option value=\"English\">English users</md-option><md-option value=\"Spanish\">\nSpanish users</md-option></md-select></div></div><div layout=\"row\"><div flex=\"100\" class=\"ph-25\"><md-input-container \nfill-width><label>Message</label><input type=\"text\"></md-input-container></div></div><div class=\"mb-50\" layout=\"row\" \nlayout-align=\"center center\"><md-button type=\"submit\" class=\"send-button md-accent md-raised\" \nng-click=\"vm.closeDialogAndUpdate()\">SEND NOW</md-button></div><div layout=\"row\"><div fill-width layout=\"column\">\n<md-list-item class=\"md-toolbar-tools fix grey-100-bg md-no-proxy bb\"><h3 class=\"grey-700-fg ng-scope\">Sent messages\n</h3></md-list-item><div class=\"pt-15 ph-15 bb\"><div layout=\"row\" layout-align=\"start center\"><div flex \nlayout=\"column\"><div><div class=\"name\" layout=\"row\" layout-align=\"start center\"><div class=\"avatar\" \nms-random-class=\"vm.colors\">G</div><div class=\"user-name text-truncate\"><span>Gabriel Macri</span><div class=\"details\" \nlayout=\"row\" layout-align=\"start start\"><span class=\"text-truncate title\"></span><span>a few seconds ago</span></div>\n</div></div></div></div><div><button class=\"md-icon-button md-button\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\"></md-icon></button></div><div><md-icon \nclass=\"pointer\" md-font-icon=\"icon-delete\"></md-icon></div><div layout=\"column\" layout-align=\"space-between end\"></div>\n</div><div class=\"details ml-50\" layout-align=\"start start\"><p flex>En Directo - The Ocean Race Alicante comienza en 1h\n</p></div></div><div class=\"pt-15 ph-15 bb\"><div layout=\"row\" layout-align=\"start center\"><div flex layout=\"column\">\n<div><div class=\"name\" layout=\"row\" layout-align=\"start center\"><div class=\"avatar\" ms-random-class=\"vm.colors\">G</div>\n<div class=\"user-name text-truncate\"><span>Gabriel Macri</span><div class=\"details\" layout=\"row\" \nlayout-align=\"start start\"><span class=\"text-truncate title\"></span><span>two hours ago</span></div></div></div></div>\n</div><div><button class=\"md-icon-button md-button\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" \nclass=\"on green-fg s24\"></md-icon></button></div><div><md-icon class=\"pointer\" md-font-icon=\"icon-delete\"></md-icon>\n</div><div layout=\"column\" layout-align=\"space-between end\"></div></div><div class=\"details ml-50\" \nlayout-align=\"start start\"><p flex>Live now - The Ocean Race Alicante starts in 2h</p></div></div></div></div></div>");
$templateCache.put("app/main/apps/match-center/views/list/tabs-match/tab-social-post.html","<ms-social-list fill-width service=\"\'content\'\" section=\"\'livestream\'\" idcontent=\"vm.idLiveStream\"></ms-social-list>");
$templateCache.put("app/main/apps/media/dialogs/edit-multiple-fields/views/set-geolocation.html","<div class=\"content-wrapper\" flex=\"\" layout-gt-sm=\"row\" layout=\"column\"><div flex-gt-sm=\"40\" flex=\"100\" \nclass=\"white-box sections\"><form name=\"searchForm\" novalidate ng-submit=\"vm.searchLatLon()\"><div \nclass=\"md-block mt-20 pb-20\"><ng-map id=\"mapa\" centered=\"true\" center=\"{{center}}\" zoom=\"1\" \non-click=\"vm.getpos($event)\"><marker position=\"{{vm.latlng}}\" on-dragend=\"vm.getpos($event)\" \nanimation=\"Animation.BOUNCE\" animation=\"DROP\" draggable=\"true\"></marker></ng-map><md-toolbar><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"expanded ms-search-bar layout-align-start-center layout-row flex\" layout=\"row\" layout-align=\"start center\" flex>\n<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-icon \nid=\"ms-search-bar-expander\" md-font-icon=\"icon-magnify\" class=\"md-icon-button md-button\"><md-tooltip hide show-gt-xs>\n<span translate=\"TOOLBAR.SEARCH\">Search</span></md-tooltip></md-icon></label><input places-auto-complete types=\"[]\" \non-place-changed=\"vm.placeMarker()\" id=\"ms-search-bar-input\" type=\"text\" style=\"width: 100%\"><md-icon \nid=\"ms-search-bar-collapser\" md-font-icon=\"icon-close-circle\" class=\"icon s24\"></md-icon></div></div></div>\n</md-toolbar></div><md-input-container class=\"md-block\"><label translate=\"CONTENT.GEOLAT\">Latitud</label><input \nname=\"resLat\" type=\"text\" class=\"form-control\" ng-model=\"vm.fields.geoLat\" required></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"CONTENT.GEOLON\">Longitud</label><input name=\"resLng\" \ntype=\"text\" class=\"form-control\" ng-model=\"vm.fields.geoLon\" required></md-input-container></form></div><div \nflex-gt-sm=\"60\" flex=\"100\" class=\"white-box sections\"><div class=\"section\"><md-input-container class=\"md-block\"><label \ntranslate=\"CONTENT.TITLE\">Title</label><textarea ng-model=\"vm.fields.title\" columns=\"1\" rows=\"1\"></textarea>\n</md-input-container><md-input-container class=\"md-block\"><label translate=\"CONTENT.PHOTOGRAPHER\">Photographer</label>\n<input ng-model=\"vm.fields.photographer\" type=\"text\"></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"CONTENT.CREDITS\">Credits</label><input ng-model=\"vm.fields.credits\" type=\"text\"></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"CONTENT.OWNER\">Owner</label><input ng-model=\"vm.fields.owner\" \ntype=\"text\"></md-input-container><md-input-container class=\"md-block\"><label translate=\"CONTENT.CAPTION\">Caption\n</label><textarea ng-model=\"vm.fields.caption\" columns=\"1\" rows=\"1\"></textarea></md-input-container><md-input-container\n class=\"md-block\"><label translate=\"CONTENT.CITY\">City</label><input ng-model=\"vm.fields.city\" type=\"text\">\n</md-input-container><md-input-container class=\"md-block\"><label translate=\"CONTENT.COUNTRY\">Country</label><input \nng-model=\"vm.fields.country\" type=\"text\"></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"CONTENT.USE\">Use</label><input ng-model=\"vm.fields.uses\" type=\"text\"></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"CONTENT.EXTRAS\">Extras</label><input ng-model=\"vm.fields.extra\" \ntype=\"text\"></md-input-container><md-input-container class=\"md-block md-input-focused\"><label \ntranslate=\"CONTENT.RATING\">Rating</label><qiu-rating-stars max-rating=\"5\" rating=\"vm.fields.rating\" \nread-only=\"ctrl.readOnly\" on-rating=\"ctrl.onRating(rating)\"></qiu-rating-stars></md-input-container><div class=\"tags\">\n<md-input-container class=\"md-block\"><label translate=\"GLOBAL.SEARCH_FOR_TAG\">Tags</label><md-chips \nclass=\"label-chips close-chip\" ng-model=\"vm.currentTags\" md-autocomplete-snap md-require-match=\"true\"><md-autocomplete \nmd-min-length=\"3\" md-selected-item=\"vm.selectedTag\" md-selected-item-change=\"vm.selectedItemChange()\" \nmd-search-text=\"vm.searchTagText\" md-items=\"tag in vm.labelQuerySearch(vm.searchTagText) | orderBy:\'-order\'\" \nmd-item-text=\"tag.tag_name\" md-no-cache=\"true\" placeholder=\"{{vm.translate(\'GLOBAL.SEARCH_FOR_TAG\')}}\" \nng-model-options=\"{debounce: 500}\" md-dropdown-items=\"10\"><div layout=\"row\" layout-align=\"space-between center\" \nflex=\"100\" class=\"tag-not-found-bg border-bottom\"><span ng-if=\"!tag.tag_name\">{{vm.searchTagText}}</span> <span \nmd-highlight-text=\"vm.searchTagText\" ng-if=\"tag.tag_name\">{{tag.tag_name}}</span><md-buttton ng-if=\"!tag.tag_name\" \nng-click=\"vm.newTag(vm.searchTagText)\" class=\"md-accent green-500-bg white-fg md-button m-0\"><span \ntranslate=\"CONTENT.TAGADD\"></span></md-buttton></div><md-not-found><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"100\" class=\"tag-not-found-bg\"><span>{{vm.searchTagText}}</span><md-buttton \nng-click=\"vm.newTag(vm.searchTagText)\" class=\"md-accent green-500-bg white-fg md-button m-0\"><span \ntranslate=\"CONTENT.TAGADD\"></span></md-buttton></div></md-not-found></md-autocomplete><md-chip-template><div \nclass=\"md-chip-content\"><span ng-if=\"$chip.color\" class=\"color\" ng-style=\"{\'background-color\':$chip.color}\"></span> \n<span>{{$chip.tag_name}} #{{$chip.id_tag}}</span></div></md-chip-template><button md-chip-remove class=\"md-primary\" \nlayout=\"row\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-close\"></md-icon></button></md-chips>\n</md-input-container></div></div></div></div>");
$templateCache.put("app/main/apps/media/dialogs/galleries/views/duplicate-gallery.html","<md-input-container class=\"md-block\"><md-checkbox ng-model=\"vm.duplicateWithMedia\" aria-label=\"Duplicate with media\">\n<span translate=\"GALLERY.DUPLICATE_WITH_MEDIA\">Duplicate with media</span></md-checkbox></md-input-container>\n<md-input-container class=\"md-block on-off\"><label translate=\"GALLERY.DUPLICATE_TO\"></label><md-menu><button \nclass=\"mr-0 width-percent-100 pt-5 pb-5 button-select\" ng-click=\"$mdMenu.open($event)\" aria-label=\"group-menu\" \nlayout=\"row\" layout-align=\"space-between center\"><span ng-if=\"vm.duplicatedGalleryParentName\" class=\"font-size-14\">\n{{vm.duplicatedGalleryParentName}}</span> <span ng-if=\"!vm.duplicatedGalleryParentName\" class=\"font-size-14\" \ntranslate=\"GALLERY.ROOT\"></span><md-icon md-font-icon=\"icon-menu-down\" class=\"grey-600-fg ml-10 mr-0\" \naria-hidden=\"true\"></md-icon></button><md-menu-content class=\"md-block groups-tree w-440\"><div \nclass=\"level-card p-8 group-row ng-scope\" layout=\"row\"><label for=\"search-bar-input\"><md-icon ng-show=\"!vm.treeSearch\" \nmd-font-icon=\"icon-magnify\" class=\"grey-600-fg search-bar-input md-icon-button md-button\"><md-tooltip hide show-gt-xs>\n<span translate=\"TOOLBAR.SEARCH\">Search</span></md-tooltip></md-icon><md-icon ng-show=\"vm.treeSearch\" \nmd-font-icon=\"icon-close-circle\" class=\"grey-600-fg md-icon-button md-button\" ng-click=\"vm.treeSearch= null\"></md-icon>\n</label><input type=\"text\" id=\"search-bar-input\" class=\"grey-600-fg grey-100-bg\" ng-model=\"vm.treeSearch\" translate \ntranslate-attr-placeholder=\"TOOLBAR.SEARCH\" flex></div><div ng-if=\"!vm.isQiuRestricted\" \nng-click=\"vm.selectParentGalleryRoot()\" class=\"level-card p-8 gallery-row ng-scope\" layout=\"row\" \nlayout-align=\"space-between stretch\"><div flex=\"\" class=\"layout-align-start-center layout-row flex\"><md-icon \nmd-font-icon=\"icon-folder-multiple-image\" class=\"s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><span \ntranslate=\"GALLERY.ROOT\"></span></div></div><qiu-tree iscombo=\"true\" \non-select=\"vm.selectParentGallery(item, vm.galleriesFiltered); $mdMenu.close()\" ng-if=\"vm.galleriesFiltered\" \ntree=\"vm.galleriesFiltered\"></qiu-tree></md-menu-content></md-menu></md-input-container><md-input-container \nclass=\"md-block\"><label translate=\"GALLERY.NAME\"></label><input ng-model=\"vm.duplicatedGallery.gallery_name\" \ntype=\"text\" required></md-input-container><md-input-container class=\"md-block\"><label translate=\"GALLERY.SHORTTEXT\">\n</label><input ng-model=\"vm.duplicatedGallery.short_text\" type=\"text\"></md-input-container><md-input-container \nclass=\"p-0 mb-40 md-block on-off\"><label translate=\"GALLERY.STATUS\"></label><md-menu-bar layout=\"row\" \nlayout-align=\"stretch center\" class=\"p-0\"><md-menu flex><button class=\"mr-0 width-percent-100 pt-5 pb-5 button-select\" \nng-click=\"$mdMenu.open($event)\" aria-label=\"group-menu\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" \nclass=\"on green-fg s24 mr-10 ml-0\" ng-if=\"vm.duplicatedGallery.status ===1\"></md-icon><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"on red-fg s24 mr-10 ml-0\" \nng-if=\"vm.duplicatedGallery.status ===0\"></md-icon><md-icon md-font-icon=\"icon-checkbox-blank-circle-outline\" \nclass=\"on grey-fg s24 mr-10 ml-0\" ng-if=\"vm.duplicatedGallery.status !==1 && vm.duplicatedGallery.status !==0\">\n</md-icon><span ng-if=\"vm.duplicatedGallery.status ===0\" translate=\"GALLERY.STATUS_PRIVATE\">Private</span> <span \nng-if=\"vm.duplicatedGallery.status ===1\" translate=\"GALLERY.STATUS_PUBLIC\">Public</span> <span \nng-if=\"vm.duplicatedGallery.status ===2\" translate=\"GALLERY.STATUS_PUBLIC_LOGIN_REQUIRED\">Public (login required)\n</span> <span ng-if=\"vm.duplicatedGallery.status !==1 && vm.duplicatedGallery.status !==0\" \ntranslate=\"GALLERY.SELECT_STATUS\">Select</span></div><md-icon md-font-icon=\"icon-menu-down\" \nclass=\"grey-600-fg ml-10 mr-0\" aria-hidden=\"true\"></md-icon></button><md-menu-content class=\"md-block\" width=\"4\">\n<md-menu-item><button class=\"pl-10 pr-10\" layout=\"row\" layout-align=\"start center\" \nng-click=\"vm.duplicatedGallery.status = 0\"><md-icon md-font-icon=\"icon-checkbox-blank-circle-outline\" \nclass=\"on red-fg s24 mr-10 ml-0\"></md-icon><span class=\"font-size-14\" translate=\"GALLERY.STATUS_PRIVATE\">Private</span>\n</button></md-menu-item><md-menu-item><button class=\"pl-10 pr-10\" layout=\"row\" layout-align=\"start center\" \nng-click=\"vm.duplicatedGallery.status = 1\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" \nclass=\"on green-fg s24 mr-10 ml-0\"></md-icon><span class=\"font-size-14\" translate=\"GALLERY.STATUS_PUBLIC\">Published\n</span></button></md-menu-item><md-menu-item><button class=\"pl-10 pr-10\" layout=\"row\" layout-align=\"start center\" \nng-click=\"vm.duplicatedGallery.status = 2\"><md-icon md-font-icon=\"icon-lock\" class=\"on orange-fg s24 mr-10 ml-0\">\n</md-icon><span class=\"font-size-14\" translate=\"GALLERY.STATUS_PUBLIC_LOGIN_REQUIRED\">Public (login required)</span>\n</button></md-menu-item></md-menu-content></md-menu></md-menu-bar></md-input-container><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start start\"><mdp-date-picker mdp-placeholder=\"Date\" mdp-open-on-click=\"true\" \nmdp-format=\"DD/MM/YYYY\" ng-init=\"dateGallery = vm.duplicatedGallery.date ? (vm.duplicatedGallery.date | toDate) : \'\'\" \nng-model=\"dateGallery\" ng-change=\"vm.duplicatedGallery.date= (dateGallery | date:\'yyyy-MM-dd\')\"></mdp-date-picker>\n</div><label translate=\"GALLERY.COVER\"></label><md-input-container class=\"md-block\"><div class=\"mail-list-item\" \nlayout=\"row\" class=\"md-block\"><div class=\"template-9\" layout=\"column\" layout-align=\"space-between stretch\"><div \nclass=\"media photos\" layout-align=\"center center\" layout=\"row\" flex><media attachment=\"vm.duplicatedGalleryCover\" \nclass-img=\"image\" ng-click=\"vm.selectCover($event)\"></media></div></div></div></md-input-container>");
$templateCache.put("app/main/apps/media/dialogs/galleries/views/edit-gallery-main.html","<md-input-container class=\"md-block\"><label translate=\"GALLERY.NAME\"></label><input ng-model=\"vm.galleryName\" \ntype=\"text\" required><div style=\"position: absolute;right: 0px;top: -19px;font-weight: 500;color: grey\">\nID: {{vm.gallery.id_gallery}}</div></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"GALLERY.SHORTTEXT\"></label><input ng-model=\"vm.galleryShortText\" type=\"text\"></md-input-container>\n<md-input-container class=\"p-0 mb-40 md-block on-off\"><label translate=\"GALLERY.STATUS\"></label><md-menu-bar \nlayout=\"row\" layout-align=\"stretch center\" class=\"p-0\"><md-menu flex><button \nclass=\"mr-0 width-percent-100 pt-5 pb-5 button-select\" ng-click=\"$mdMenu.open($event)\" aria-label=\"group-menu\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24 mr-10 ml-0\" ng-if=\"vm.galleryStatus ===1\"></md-icon>\n<md-icon md-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"on red-fg s24 mr-10 ml-0\" \nng-if=\"vm.galleryStatus ===0\"></md-icon><md-icon md-font-icon=\"icon-checkbox-blank-circle-outline\" \nclass=\"on grey-fg s24 mr-10 ml-0\" ng-if=\"vm.galleryStatus !==1 && vm.galleryStatus !==0\"></md-icon><span \nng-if=\"vm.galleryStatus ===0\" translate=\"GALLERY.STATUS_PRIVATE\">Private</span> <span ng-if=\"vm.galleryStatus ===1\" \ntranslate=\"GALLERY.STATUS_PUBLIC\">Public</span> <span ng-if=\"vm.galleryStatus ===2\" \ntranslate=\"GALLERY.STATUS_PUBLIC_LOGIN_REQUIRED\">Public (login required)</span> <span \nng-if=\"vm.galleryStatus !==1 && vm.galleryStatus !==0\" translate=\"GALLERY.SELECT_STATUS\">Select</span></div><md-icon \nmd-font-icon=\"icon-menu-down\" class=\"grey-600-fg ml-10 mr-0\" aria-hidden=\"true\"></md-icon></button><md-menu-content \nclass=\"md-block\" width=\"4\"><md-menu-item><button class=\"pl-10 pr-10\" layout=\"row\" layout-align=\"start center\" \nng-click=\"vm.setItemStatus(0)\"><md-icon md-font-icon=\"icon-checkbox-blank-circle-outline\" \nclass=\"on red-fg s24 mr-10 ml-0\"></md-icon><span class=\"font-size-14\" translate=\"GALLERY.STATUS_PRIVATE\">Private</span>\n</button></md-menu-item><md-menu-item><button class=\"pl-10 pr-10\" layout=\"row\" layout-align=\"start center\" \nng-click=\"vm.setItemStatus(1)\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24 mr-10 ml-0\">\n</md-icon><span class=\"font-size-14\" translate=\"GALLERY.STATUS_PUBLIC\">Published</span></button></md-menu-item>\n<md-menu-item><button class=\"pl-10 pr-10\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.setItemStatus(2)\">\n<md-icon md-font-icon=\"icon-lock\" class=\"on orange-fg s24 mr-10 ml-0\"></md-icon><span class=\"font-size-14\" \ntranslate=\"GALLERY.STATUS_PUBLIC_LOGIN_REQUIRED\">Public (login required)</span></button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar></md-input-container><div id=\"dynamic_container\" layout=\"column\" \nlayout-align=\"space-between start\"><div id=\"dynamic_button_container\"><md-checkbox ng-model=\"vm.isdynamic\" \naria-label=\"dynamic\" ng-true-value=\"1\" ng-false-value=\"0\"><span translate=\"GALLERY.DYNAMIC\">Dynamic</span>\n</md-checkbox></div><div id=\"dynamic-checkbox-container\" layout=\"row\" layout-align=\"space-around center\" \nng-if=\"vm.isdynamic\"><md-checkbox ng-model=\"vm.dateDynamic\" aria-label=\"dateDynamic\" ng-true-value=\"1\" \nng-false-value=\"0\"><span translate=\"GALLERY.DYNAMIC_DATE\">Date dynamic</span></md-checkbox><md-checkbox \nng-model=\"vm.ratingDynamic\" aria-label=\"ratingDynamic\" ng-true-value=\"1\" ng-false-value=\"0\"><span \ntranslate=\"GALLERY.DYNAMIC_RATING\">Rating dynamic</span></md-checkbox><md-checkbox ng-model=\"vm.labelDynamic\" \naria-label=\"labelDynamic\" ng-true-value=\"1\" ng-false-value=\"0\"><span translate=\"GALLERY.DYNAMIC_LABEL\">Label dynamic\n</span></md-checkbox><md-checkbox ng-model=\"vm.keywordsDynamic\" aria-label=\"keywordsDynamic\" ng-true-value=\"1\" \nng-false-value=\"0\"><span translate=\"GALLERY.DYNAMIC_KEYWORDS\">Keywords dynamic</span></md-checkbox></div><div \nid=\"dynamic-date-container\" class=\"dynamic-field-container\" ng-if=\"vm.dateDynamic && vm.isdynamic\"><label \ntranslate=\"GALLERY.DYNAMIC_DATE\"></label><div layout=\"row\" layout-align=\"space-around center\"><label><input \ntype=\"radio\" value=\"Date created\" ng-model=\"vm.dateFilterType\" checked=\"checked\"> <span \ntranslate=\"GALLERY.DYNAMIC_DATE_CREATED\">Date created</span></label><label><input type=\"radio\" value=\"Date uploaded\" \nng-model=\"vm.dateFilterType\"> <span translate=\"GALLERY.DYNAMIC_DATE_UPLOADED\">Date uploaded</span></label></div><div \nlayout=\"column\" layout-gt-sm=\"column\" layout-align=\"start start\"><div layout=\"row\"><mdp-date-picker \nmdp-placeholder=\"From\" mdp-open-on-click=\"true\" mdp-format=\"DD/MM/YYYY\" \nng-init=\"fromDateGallery= vm.fromGalleryDate ? (vm.fromGalleryDate | toDate) : \'\'\" ng-model=\"fromDateGallery\" \nng-change=\"vm.fromGalleryDate= (fromDateGallery | date:\'yyyy-MM-dd\')\"></mdp-date-picker><mdp-time-picker \nmdp-placeholder=\"{{vm.timeFromDateGallery}}\" mdp-auto-switch=\"true\" mdp-open-on-click=\"true\" \nng-model=\"vm.timeFromDateGallery\" ng-change=\"vm.setHour(\'from\', vm.timeFromDateGallery | date:\'HH:mm:00\')\" \nng-if=\"fromDateGallery\"></mdp-time-picker></div><div layout=\"row\"><mdp-date-picker mdp-placeholder=\"To\" \nmdp-open-on-click=\"true\" mdp-format=\"DD/MM/YYYY\" \nng-init=\"toDateGallery= vm.toGalleryDate ? (vm.toGalleryDate | toDate) : \'\'\" ng-model=\"toDateGallery\" \nng-change=\"vm.toGalleryDate= (toDateGallery | date:\'yyyy-MM-dd\')\"></mdp-date-picker><mdp-time-picker \nmdp-placeholder=\"{{vm.timeToDateGallery}}\" mdp-auto-switch=\"true\" mdp-open-on-click=\"true\" \nng-model=\"vm.timeToDateGallery\" ng-change=\"vm.setHour(\'to\', vm.timeToDateGallery | date:\'HH:mm:00\')\" \nng-if=\"toDateGallery\"></mdp-time-picker></div></div></div><div layout=\"column\" id=\"dynamic-rating-container\" \nclass=\"dynamic-field-container\" ng-if=\"vm.ratingDynamic && vm.isdynamic\"><label translate=\"GALLERY.DYNAMIC_RATING\">\n</label><md-input-container class=\"md-block\"><md-select ng-model=\"vm.mediaRating\"><md-option \nng-value=\"rating.media_rating\" ng-repeat=\"rating in vm.mediaRatings\">{{ rating.name }}</md-option></md-select>\n</md-input-container></div><div id=\"dynamic-tags-container\" class=\"dynamic-field-container\" layout=\"row\" \nng-if=\"vm.labelDynamic\"><label translate=\"GALLERY.DYNAMIC_LABEL\"></label><div layout=\"row\" \nlayout-align=\"space-around center\"><label><input type=\"radio\" value=\"Match all tags\" ng-model=\"vm.tagFilterType\" \nchecked=\"checked\"> <span translate=\"GALLERY.DYNAMIC_MATCH_ALL_TAGS\">Match all tags</span></label><label><input \ntype=\"radio\" value=\"Match at least one tag\" ng-model=\"vm.tagFilterType\"> <span \ntranslate=\"GALLERY.DYNAMIC_MATCH_ONE_TAG\">Match at least one tag</span></label></div><div flex=\"100\" class=\"tags\">\n<md-input-container class=\"md-block\"><md-chips class=\"label-chips close-chip\" ng-model=\"vm.dynamicTags\" \nmd-autocomplete-snap md-require-match=\"true\"><md-autocomplete md-min-length=\"3\" md-selected-item=\"vm.selectedTag\" \nmd-selected-item-change=\"vm.selectedItemChange()\" md-search-text=\"vm.searchTagText\" \nmd-items=\"tag in vm.labelQuerySearch(vm.searchTagText) | orderBy:\'-order\'\" md-item-text=\"tag.tag_name\" \nmd-no-cache=\"true\" placeholder=\"{{vm.translate(\'GLOBAL.SEARCH_FOR_TAG\')}}\" ng-model-options=\"{debounce: 500}\" \nmd-dropdown-items=\"10\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\" \nclass=\"tag-not-found-bg border-bottom\"><span ng-if=\"!tag.tag_name\">{{vm.searchTagText}}</span> <span \nmd-highlight-text=\"vm.searchTagText\" ng-if=\"tag.tag_name\">{{tag.tag_name}}</span><md-buttton ng-if=\"!tag.tag_name\" \nng-click=\"vm.newTag(vm.searchTagText)\" class=\"md-accent green-500-bg white-fg md-button m-0\"><span \ntranslate=\"CONTENT.TAGADD\"></span></md-buttton></div><md-not-found><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"100\" class=\"tag-not-found-bg\"><span>{{vm.searchTagText}}</span><md-buttton \nng-click=\"vm.newTag(vm.searchTagText)\" class=\"md-accent green-500-bg white-fg md-button m-0\"><span \ntranslate=\"CONTENT.TAGADD\"></span></md-buttton></div></md-not-found></md-autocomplete><md-chip-template><div \nclass=\"md-chip-content\"><span ng-if=\"$chip.color\" class=\"color\" ng-style=\"{\'background-color\':$chip.color}\"></span> \n<span>{{$chip.tag_name}} #{{$chip.id_tag}}</span></div></md-chip-template><button md-chip-remove class=\"md-primary\" \nlayout=\"row\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-close\"></md-icon></button></md-chips>\n</md-input-container></div></div><div layout=\"column\" id=\"dynamic-keywords-container\" class=\"dynamic-field-container\" \nng-if=\"vm.keywordsDynamic && vm.isdynamic\"><label translate=\"GALLERY.DYNAMIC_KEYWORDS\"></label><div \nclass=\"key-container\"><div ng-repeat=\"key in vm.keyWords\"><div><span>{{key}}</span></div><button \nng-click=\"vm.removeKeywordFilter(key)\" layout=\"row\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></button></div></div><div layout=\"column\" layout=\"row\"><md-input-container class=\"md-block\"><md-select \nplaceholder=\"Filter field\" ng-model=\"vm.filterWordField\"><md-option ng-value=\"filter\" \nng-repeat=\"filter in vm.wordFilters\">{{ filter }}</md-option></md-select></md-input-container></div><div \nid=\"input-container\" layout=\"row\" layout-algin=\"end end\"><input id=\"keywordInput\" ng-model=\"vm.keywordFilter\" \ntype=\"text\"> <button ng-disabled=\"!vm.keywordFilter\" class=\"md-accent green-500-bg white-fg md-button m-0\" \nng-click=\"vm.addKeywordFilter(vm.keywordFilter)\">ADD</button></div></div></div><md-input-container class=\"md-block\">\n<label translate=\"GALLERY.TYPE\"></label><md-select ng-model=\"vm.galleryType\" required><md-option \nng-value=\"type.id_gallery_type\" ng-repeat=\"type in vm.galleryTypes\">{{ type.name }}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block on-off\"><label translate=\"GALLERY.MOVE_TO\"></label><md-menu>\n<button class=\"mr-0 width-percent-100 pt-5 pb-5 button-select\" ng-click=\"$mdMenu.open($event)\" aria-label=\"group-menu\" \nlayout=\"row\" layout-align=\"space-between center\"><span ng-if=\"vm.galleryParentName\" class=\"font-size-14\">\n{{vm.galleryParentName}}</span> <span ng-if=\"!vm.galleryParentName\" class=\"font-size-14\" translate=\"GALLERY.ROOT\">\n</span><md-icon md-font-icon=\"icon-menu-down\" class=\"grey-600-fg ml-10 mr-0\" aria-hidden=\"true\"></md-icon></button>\n<md-menu-content class=\"md-block groups-tree w-440\"><div class=\"level-card p-8 group-row ng-scope\" layout=\"row\"><label \nfor=\"search-bar-input\"><md-icon ng-show=\"!vm.treeSearch\" md-font-icon=\"icon-magnify\" \nclass=\"grey-600-fg search-bar-input md-icon-button md-button\"><md-tooltip hide show-gt-xs><span \ntranslate=\"TOOLBAR.SEARCH\">Search</span></md-tooltip></md-icon><md-icon ng-show=\"vm.treeSearch\" \nmd-font-icon=\"icon-close-circle\" class=\"grey-600-fg md-icon-button md-button\" ng-click=\"vm.treeSearch= null\"></md-icon>\n</label><input type=\"text\" id=\"search-bar-input\" class=\"grey-600-fg grey-100-bg\" ng-model=\"vm.treeSearch\" translate \ntranslate-attr-placeholder=\"TOOLBAR.SEARCH\" flex></div><div ng-if=\"!vm.isQiuRestricted\" \nng-click=\"vm.selectParentGalleryRoot()\" class=\"level-card p-8 gallery-row ng-scope\" layout=\"row\" \nlayout-align=\"space-between stretch\"><div flex=\"\" class=\"layout-align-start-center layout-row flex\"><md-icon \nmd-font-icon=\"icon-folder-multiple-image\" class=\"s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><span \ntranslate=\"GALLERY.ROOT\"></span></div></div><qiu-tree iscombo=\"true\" \non-select=\"vm.selectParentGallery(item, vm.galleriesFiltered); $mdMenu.close()\" ng-if=\"vm.galleriesFiltered\" \ntree=\"vm.galleriesFiltered\"></qiu-tree></md-menu-content></md-menu></md-input-container><md-input-container \nng-if=\"vm.partnerAreaGallery\" class=\"md-block on-off\"><label translate=\"GALLERY.ADD_USER_GROUP\"></label><md-menu>\n<button class=\"mr-0 width-percent-100 pt-5 pb-5 button-select\" ng-click=\"$mdMenu.open($event)\" aria-label=\"group-menu\" \nl layout=\"row\" layout-align=\"space-between center\"><span ng-if=\"vm.selectedGroup\" class=\"font-size-14\">\n{{vm.selectedGroup.name}}</span><md-icon md-font-icon=\"icon-menu-down\" class=\"grey-600-fg ml-10 mr-0\" \naria-hidden=\"true\"></md-icon></button><md-menu-content class=\"md-block groups-tree\"><div \nclass=\"level-card p-8 group-row ng-scope\" layout=\"row\"><label for=\"search-bar-input\"><md-icon \nng-show=\"!vm.treeGroupsSearch\" md-font-icon=\"icon-magnify\" \nclass=\"grey-600-fg search-bar-input md-icon-button md-button\"><md-tooltip hide show-gt-xs><span \ntranslate=\"TOOLBAR.SEARCH\">Search</span></md-tooltip></md-icon><md-icon ng-show=\"vm.treeGroupsSearch\" \nmd-font-icon=\"icon-close-circle\" class=\"grey-600-fg md-icon-button md-button\" ng-click=\"vm.treeGroupsSearch= null\">\n</md-icon></label><input type=\"text\" id=\"search-bar-input\" class=\"grey-600-fg grey-100-bg\" \nng-model=\"vm.treeGroupsSearch\" translate translate-attr-placeholder=\"TOOLBAR.SEARCH\" flex></div><qiu-tree \niscombo=\"true\" on-select=\"vm.selectGroup(item); $mdMenu.close()\" ng-if=\"vm.groupsFiltered\" tree=\"vm.groupsFiltered\">\n</qiu-tree></md-menu-content></md-menu></md-input-container><md-input-container class=\"md-block on-off\" \nng-if=\"vm.searchFilteredGroups()\"><label translate=\"GALLERY.FILTER_GALLERY_BY_USER_GROUPS\"></label><md-menu><button \nclass=\"mr-0 width-percent-100 pt-5 pb-5 button-select\" ng-click=\"$mdMenu.open($event)\" aria-label=\"group-menu\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"font-size-14\">{{vm.stringifySelectedUserGroups()}}</span>\n<md-icon md-font-icon=\"icon-menu-down\" class=\"grey-600-fg ml-10 mr-0\" aria-hidden=\"true\"></md-icon></button>\n<md-menu-content class=\"md-block groups-tree\"><div class=\"level-card p-8 group-row ng-scope\" layout=\"row\"><label \nfor=\"search-bar-input\"><md-icon ng-show=\"!vm.treeGroupsSearch\" md-font-icon=\"icon-magnify\" \nclass=\"grey-600-fg search-bar-input md-icon-button md-button\"><md-tooltip hide show-gt-xs><span \ntranslate=\"TOOLBAR.SEARCH\">Search</span></md-tooltip></md-icon><md-icon ng-show=\"vm.treeGroupsSearch\" \nmd-font-icon=\"icon-close-circle\" class=\"grey-600-fg md-icon-button md-button\" ng-click=\"vm.treeGroupsSearch= null\">\n</md-icon></label><input type=\"text\" id=\"search-bar-input\" class=\"grey-600-fg grey-100-bg\" \nng-model=\"vm.treeGroupsSearch\" translate translate-attr-placeholder=\"TOOLBAR.SEARCH\" flex></div><qiu-tree \niscombo=\"true\" on-select=\"vm.toggleGroupSelection(item, \'id_group\')\" selected-ids=\"vm.selectedGroupIds\" \nng-if=\"vm.searchFilteredGroups()\" tree=\"vm.searchFilteredGroups()\"></qiu-tree></md-menu-content></md-menu>\n</md-input-container><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><mdp-date-picker \nmdp-placeholder=\"Date\" mdp-open-on-click=\"true\" mdp-format=\"DD/MM/YYYY\" \nng-init=\"dateGallery= vm.galleryDate ? (vm.galleryDate | toDate) : \'\'\" ng-model=\"dateGallery\" \nng-change=\"vm.galleryDate= (dateGallery | date:\'yyyy-MM-dd\')\"></mdp-date-picker></div><md-input-container \nclass=\"md-block\" ng-if=\"!vm.isdynamic\"><md-checkbox name=\"filesAllowed\" \nng-disabled=\"vm.isQiuRestrictedRootSelected || vm.disabledFilesAllowed\" ng-model=\"vm.filesAllowed\" \nng-checked=\"vm.filesAllowed\" ng-change=\"vm.filesAllowedChange()\" aria-label=\"Files Allowed?\"><span \ntranslate=\"GALLERY.QUESTION_FILES_ALLOWED\"></span><div ng-messages=\"vm.basicForm.filesAllowed.$error\" \nstyle=\"float: left !important; font-size: smaller\" md-auto-hide=\"false\" class=\"md-errors-spacer\"><div \nng-message=\"gallery_must_be_empty\" translate=\"GALLERY.GALLERY_CONTAINS_FILES_ALERT\"></div></div></md-checkbox>\n</md-input-container><label translate=\"GALLERY.COVER\"></label><md-input-container class=\"md-block\"><div \nclass=\"mail-list-item\" layout=\"row\" class=\"md-block\"><div class=\"template-9\" layout=\"column\" \nlayout-align=\"space-between stretch\"><div class=\"media photos\" layout-align=\"center center\" layout=\"row\" flex><media \nattachment=\"vm.galleryCover\" class-img=\"image\" ng-click=\"vm.selectCover($event)\"></media></div></div></div>\n</md-input-container>");
$templateCache.put("app/main/apps/media/dialogs/galleries/views/edit-gallery-users-groups-lightbox.html","<h2 translate=\"MEDIA.LIGHTBOX.OWNER\"></h2><md-autocomplete md-no-cache=\"true\" md-input-name=\"lightboxOwner\" \nmd-selected-item=\"vm.selectedOwnerLightbox\" md-search-text=\"vm.searchQueryOwner\" \nmd-selected-item-change=\"vm.selectedOwnerChange(item)\" md-items=\"item in vm.usersSearch(vm.searchQueryOwner)\" \nmd-item-text=\"item.email\" md-min-length=\"3\" required flex placeholder=\"{{ \'GALLERY.SEARCH_OWNER\' | translate}}\" \ninput-aria-labelledby=\"ownerLabel\"><md-item-template><div display=\"column\"><span display=\"row\" flex-100 \nclass=\"grey-fg\">#{{item.id_user}}</span><br><span display=\"row\" flex-100 md-highlight-text=\"vm.searchQueryOwner\" \nmd-highlight-flags=\"i\">{{item.email}}</span><br><span display=\"row\" flex-100 md-highlight-text=\"vm.searchQueryOwner\" \nmd-highlight-flags=\"i\">{{item.firstname}} {{item.lastname}}</span></div></md-item-template><md-not-found \ntranslate=\"GALLERY.NO_MATCH_FOUND\"></md-not-found></md-autocomplete><span class=\"red-fg\" \nng-if=\"!vm.selectedOwnerLightbox\" translate=\"GALLERY.VALUE_REQUIRED\"></span><h2 translate=\"MEDIA.LIGHTBOX.USERS\"></h2>\n<md-chips ng-model=\"vm.selectedUsersLightbox\" name=\"userLightbox\" input-aria-label=\"Selected Users\" \nmd-on-remove=\"vm.deselectUser($chip)\" readonly=\"true\" md-removable=\"true\"><md-chip-template><strong>{{$chip.email}}\n</strong></md-chip-template></md-chips><md-autocomplete md-no-cache=\"true\" md-search-text=\"vm.searchQueryUser\" \nmd-selected-item-change=\"vm.selectedUserChange(item)\" md-items=\"item in vm.usersSearch(vm.searchQueryUser)\" \nmd-item-text=\"item.email\" md-min-length=\"3\" placeholder=\"{{ \'GALLERY.SEARCH_USER\' | translate}}\" \ninput-aria-labelledby=\"usersLabel\"><md-item-template><div display=\"column\"><span display=\"row\" flex-100 \nclass=\"grey-fg\">#{{item.id_user}}</span><br><span display=\"row\" flex-100 md-highlight-text=\"vm.searchQueryUser\" \nmd-highlight-flags=\"i\">{{item.email}}</span><br><span display=\"row\" flex-100 md-highlight-text=\"vm.searchQueryUser\" \nmd-highlight-flags=\"i\">{{item.firstname}} {{item.lastname}}</span></div></md-item-template><md-not-found \ntranslate=\"GALLERY.NO_MATCH_FOUND\"></md-not-found></md-autocomplete><h2 translate=\"MEDIA.LIGHTBOX.USERS_GROUPS\"></h2>\n<md-chips ng-model=\"vm.selectedUsersGroupsLightbox\" name=\"groupName\" input-aria-label=\"Selected Users Groups\" \nmd-on-remove=\"vm.deselectGroup($chip)\" readonly=\"true\" md-removable=\"true\"><md-chip-template><strong>{{$chip.name}}\n</strong></md-chip-template></md-chips><div class=\"pt-20\"><md-button ng-click=\"vm.openGroupTree(\'lightbox\')\" \nclass=\"add-event-button md-icon-button md-fab md-warn\"><md-icon md-font-icon=\"icon-plus-circle\" class=\"\" \naria-label=\"ADD\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"GROUP.ADD_USERS_GROUPS\">ADD GROUP</span>\n</md-tooltip></md-button></div>");
$templateCache.put("app/main/apps/media/dialogs/galleries/views/edit-gallery-users-groups-mediacenter.html","<md-chips ng-model=\"vm.selectedUsersGroupsMediacenter\" name=\"groupName\" input-aria-label=\"Selected Users Groups\" \nmd-on-remove=\"vm.deselectGroup($chip)\" readonly=\"true\" md-removable=\"true\"><md-chip-template><strong>{{$chip.name}}\n</strong></md-chip-template></md-chips><div class=\"pt-20\"><md-button ng-click=\"vm.openGroupTree(\'mediacenter\')\" \nclass=\"add-event-button md-icon-button md-fab md-warn\"><md-icon md-font-icon=\"icon-plus-circle\" class=\"\" \naria-label=\"ADD\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"GROUP.ADD_USERS_GROUPS\">ADD GROUP</span>\n</md-tooltip></md-button></div>");
$templateCache.put("app/main/apps/media/dialogs/media/views/audios-view.html","<div class=\"content-wrapper\" flex=\"\" layout=\"row\"><div class=\"mail-tabs-grid\" flex \nmd-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"content mail-list-pane-grid\" flex ms-scroll><div \nng-repeat=\"item in vm.items\" class=\"ms-card\" flex><div class=\"ms-card-content-wrapper\"><div class=\"template-9\"><div \nclass=\"media\" flex layout=\"row\" layout-align=\"center center\"><div flex layout=\"column\" layout-align=\"center center\" \nclass=\"media\"><qiu-icon mediafile=\"item.filename\"></qiu-icon><br><span class=\"grey-500-fg\" layout=\"column\" \nlayout-align=\"center center\"><span ng-if=\"item.title\"><strong>{{item.title}}</strong></span> <span \nng-if=\"item.filename\">{{item.filename}}</span></span></div></div><div class=\"header p-16\" flex><div layout=\"row\" \nlayout-align=\"space-between center\" flex><div class=\"size block\" layout=\"row\" layout-align=\"start left\"><strong \nclass=\"mr-5\">#{{item.id_media}}</strong> <span class=\"grey-500-fg\"><span ng-if=\"item.date_uploaded\">\n{{item.date_uploaded}}</span></span></div><md-checkbox \nng-checked=\"vm.alreadySelectedbyZone(vm.selectedContacts, item)\" ng-click=\"vm.toggleSelectContact(item, $event)\" \naria-label=\"{{vm.alreadySelectedbyZone(vm.selectedContacts, item) ? \'Deselect\' : \'Select\'}}\" class=\"ml-5\">\n</md-checkbox></div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/apps/media/dialogs/media/views/files-view.html","<div class=\"content-wrapper\" flex=\"\" layout=\"row\"><div class=\"mail-tabs-grid\" flex=\"\"><div \nclass=\"content mail-list-pane-grid\" flex=\"\" ms-scroll=\"\"><div ng-repeat=\"photo in vm.items\" class=\"ms-card\" flex><div \nclass=\"ms-card-content-wrapper\"><div class=\"template-9\"><div class=\"media\" flex layout=\"row\" \nlayout-align=\"center center\"><div flex layout=\"column\" layout-align=\"center center\" class=\"media\"><qiu-icon \nmediafile=\"photo.filename\"></qiu-icon><br><span class=\"grey-500-fg\" layout=\"column\" layout-align=\"center center\"><span \nng-if=\"photo.title\"><strong>{{photo.title}}</strong></span> <span ng-if=\"photo.filename\">{{photo.filename}}</span>\n</span></div></div><div class=\"header p-16\" flex><div layout=\"row\" layout-align=\"space-between center\" flex><div \nclass=\"size text-truncate\" layout=\"row\" layout-align=\"start left\"><strong class=\"mr-5\">#{{photo.id_media}}</strong>\n</div><md-checkbox ng-checked=\"vm.alreadySelectedbyZone(vm.selectedContacts, photo)\" \nng-click=\"vm.toggleSelectContact(photo, $event)\" \naria-label=\"{{vm.alreadySelectedbyZone(vm.selectedContacts, photo) ? \'Deselect\' : \'Select\'}}\" class=\"ml-5\">\n</md-checkbox></div><md-tooltip md-direction=\"top\" hide show-gt-xs ng-if=\"photo.filename\"><span>{{photo.filename}}\n</span></md-tooltip></div></div></div></div></div></div></div><div layout=\"column\" layout-align=\"center center\"></div>");
$templateCache.put("app/main/apps/media/dialogs/media/views/import-view.html","<div class=\"content-wrapper\" flex layout=\"column\"><div class=\"content\"><div class=\"drop-box\"><md-input-container \nclass=\"md-block\"><label translate=\"MEDIA.PASTE_URL_HERE\"></label><input type=\"text\" name=\"import_field\" \nng-model=\"vm.import_field\" placeholder=\"{{vm.translate(\'MEDIA.PASTE_URL_HERE\')}}\" ng-disabled=\"vm.import_disabled\">\n</md-input-container><div ng-if=\"vm.imported\" class=\"alert-message success-message\" translate=\"CONTENT.SUCCESSIMPORT\">\nImported successfully</div></div><treasure-overlay-spinner active=\"vm.importing\"><div layout=\"row\" \nlayout-align=\"center start\" ng-if=\"vm.importPreview\" class=\"white-box sections\"><div flex-gt-sm=\"50\" flex=\"100\"><div \nclass=\"section\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><span class=\"section-title\">\nPREVIEW</span></div><div class=\"media\" flex layout=\"row\" layout-align=\"center center\" \nng-bind-html=\"vm.importPreview.embedCodeSafe\"></div></div><div class=\"header p-16\" flex><div layout=\"row\" \nlayout-align=\"space-between center\" flex><div class=\"size text-truncate\" layout=\"row\" layout-align=\"start left\"><span \nclass=\"grey-500-fg\"><span ng-if=\"vm.importPreview.title\">Title: {{vm.importPreview.title}}</span></span></div></div>\n<div layout=\"row\" layout-align=\"space-between center\" flex><div class=\"size\" layout=\"row\" layout-align=\"start left\">\n<span class=\"grey-500-fg\"><span ng-if=\"vm.importPreview.caption\">Description: {{vm.importPreview.caption}}</span>\n</span></div></div></div><md-button class=\"send-button md-accent md-raised\" ng-click=\"vm.importConfirm(1)\" \ntranslate=\"CONTENT.IMPORT\">Import</md-button></div></div><div ng-repeat=\"f in vm.importedFiles\" class=\"ms-card\" flex>\n<div class=\"ms-card-content-wrapper\"><div class=\"template-9\"><div class=\"media\" flex layout=\"row\" \nlayout-align=\"center center\"><img ng-src=\"{{f.embed_thumb}}\" class=\"image\"></div><div class=\"header p-16\" flex><div \nlayout=\"row\" layout-align=\"space-between center\" flex><div class=\"size block\" layout=\"row\" layout-align=\"start left\">\n<strong class=\"mr-5\">#{{f.id_media}}</strong> <span class=\"grey-500-fg\"><span ng-if=\"f.filename\">{{f.filename}}</span> \n<span ng-if=\"f.title\">{{f.title}}</span></span></div><md-checkbox \nng-checked=\"vm.alreadySelectedbyZone(vm.selectedContacts, f)\" ng-click=\"vm.toggleSelectContact(f, $event)\" \naria-label=\"{{vm.alreadySelectedbyZone(vm.selectedContacts, f) ? \'Deselect\' : \'Select\'}}\"></md-checkbox></div></div>\n</div></div></div></treasure-overlay-spinner></div></div>");
$templateCache.put("app/main/apps/media/dialogs/media/views/photos-view.html","<div class=\"content-wrapper\" flex layout=\"row\"><div class=\"mail-tabs-grid\" flex \nmd-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"content mail-list-pane-grid\" flex><div \nng-repeat=\"photo in vm.items\" class=\"ms-card\" flex><div class=\"ms-card-content-wrapper\"><div class=\"template-9\"><div \nclass=\"media\" flex layout=\"row\" layout-align=\"center center\"><img \nng-src=\"{{photo.cropstatus[0].container.view_url}}{{photo.cropstatus[0].fileName}}\" class=\"image\"></div><div \nclass=\"header p-16\" flex><div layout=\"row\" layout-align=\"space-between center\" flex><div class=\"size block\" \nlayout=\"row\" layout-align=\"start left\"><strong class=\"mr-5\">#{{photo.id_media}}</strong> <span class=\"grey-500-fg\">\n<span ng-if=\"photo.filename\">{{photo.filename}}</span></span></div><md-checkbox \nng-checked=\"vm.alreadySelectedbyZone(vm.selectedContacts, photo)\" ng-click=\"vm.toggleSelectContact(photo, $event)\" \naria-label=\"{{vm.alreadySelectedbyZone(vm.selectedContacts, photo) ? \'Deselect\' : \'Select\'}}\" class=\"ml-5\">\n</md-checkbox></div><md-tooltip md-direction=\"top\" hide show-gt-xs ng-if=\"photo.filename\"><span>{{photo.filename}}\n</span></md-tooltip></div></div></div></div></div></div></div>");
$templateCache.put("app/main/apps/media/dialogs/media/views/template-grid.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"space-between center\" flex><div \nlayout=\"column\" layout-align=\"start center\"><md-checkbox class=\"no-label\" ng-checked=\"vm.isChecked(mail)\" \nng-click=\"vm.toggleCheck(mail, $event)\" aria-label=\"{{vm.isChecked(mail)? \'Uncheck\':\'check\'}}\"></md-checkbox><div \nng-if=\"refcolumnsgrouped.main\"><div class=\"subject text-truncate\"><span \nng-repeat=\"field in refcolumnsgrouped.header | orderBy: \'list-sort\'\" ng-bind=\"thread.{{field.titleId}}\"></span></div>\n</div></div><div layout=\"column\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-attachment\" \nclass=\"has-attachment s24\" ng-if=\"thread.Thumbnail.length>0\"></md-icon><button ng-if=\"thread.onoff===1\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\"></md-icon></button> \n<button ng-if=\"thread.onoff!==1\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-blank-circle-outline\" \nclass=\"off red-fg s24\"></md-icon></button></div></div><div class=\"media\" flex layout=\"row\" \nlayout-align=\"center center\"><img class=\"image\" ng-src=\"{{card.Thumbnail[0].crop_status[0].urlformed}}\" \nalt=\"{{card.media.image.alt}}\" imageonloadcontrol></div><div class=\"header p-16\" layout=\"row\" layout-align=\"start\"><div\n class=\"info\"><div ng-if=\"refcolumnsgrouped.main\"><div class=\"name text-truncate\" layout=\"row\" \nlayout-align=\"start center\"><span ng-repeat=\"field in refcolumnsgrouped.main\"><span ng-bind=\"thread.{{field.titleId}}\">\n</span>&nbsp;</span></div></div><div ng-repeat=\"field in refcolumnsgrouped.secondary | orderBy:\'list_sort\'\"><div \nng-if=\"(field.type!==\'date\' && field.type!==\'dateHm\') && field.primary!==1\" class=\"details\" layout=\"row\" \nlayout-align=\"start start\"><div layout=\"column\"><span class=\"title\" ng-bind=\"field.title\"></span></div><div \nlayout=\"column\" class=\"text-truncate\"><span class=\"detail\" ng-bind=\"thread.{{field.titleId}}\"></span></div></div></div>\n</div></div></div>");
$templateCache.put("app/main/apps/media/dialogs/media/views/tiny-attached.html","<div class=\"content-wrapper\" flex layout=\"row\"><div class=\"mail-tabs-grid\" flex \nmd-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"content mail-list-pane-grid\" flex><div \nng-repeat=\"item in vm.selectedContacts\" class=\"ms-card\" flex><div class=\"ms-card-content-wrapper\" \nng-if=\"item.media_type == 1\"><div class=\"template-9\"><div class=\"media\" flex layout=\"row\" layout-align=\"center center\">\n<img ng-src=\"{{item.cropstatus[0].container.view_url}}{{item.cropstatus[0].fileName}}\" class=\"image\"></div><div \nclass=\"header p-16\" flex><div layout=\"row\" layout-align=\"space-between center\" flex><div class=\"size block\" \nlayout=\"row\" layout-align=\"start left\"><strong class=\"mr-5\">#{{item.id_media}}</strong> <span class=\"grey-500-fg\"><span\n ng-if=\"item.filename\">{{item.filename}}</span></span></div><md-button ng-click=\"vm.selectMediaTiny(item)\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Select\" translate=\"CONTENT.SELECT\" \ntranslate-attr-aria-label=\"CONTENT.SELECT\">SELECT</md-button></div></div></div></div><div \nclass=\"ms-card-content-wrapper\" ng-if=\"item.media_type == 2\"><div class=\"template-9\"><div class=\"media\" flex \nlayout=\"row\" layout-align=\"center center\"><img ng-src=\"{{item.embed_thumb}}\" class=\"image\"></div><div \nclass=\"header p-16\" flex><div layout=\"row\" layout-align=\"space-between center\" flex><div class=\"size block\" \nlayout=\"row\" layout-align=\"start left\"><strong class=\"mr-5\">#{{item.id_media}}</strong> <span class=\"grey-500-fg\"><span\n ng-if=\"item.filename\">{{item.filename}}</span> <span ng-if=\"item.title\">{{item.title}}</span></span></div><md-button \nng-click=\"vm.selectMediaTiny(item)\" class=\"send-button md-accent md-raised\" aria-label=\"Select\" \ntranslate=\"CONTENT.SELECT\" translate-attr-aria-label=\"CONTENT.SELECT\">SELECT</md-button></div></div></div></div></div>\n</div></div></div>");
$templateCache.put("app/main/apps/media/dialogs/media/views/tiny-properties.html","<div class=\"ontent-wrapper\" flex=\"\" layout=\"column\"><div class=\"content\"><div class=\"ms-card\" flex><div \nclass=\"ms-card-content-wrapper\"><div class=\"template-9\"><div class=\"media\" flex layout=\"row\" \nlayout-align=\"center center\" ng-if=\"vm.selectedMediaTiny.media_type == 1\"><img \nng-src=\"{{vm.selectedMediaTiny.cropstatus[0].container.view_url}}{{vm.selectedMediaTiny.cropstatus[0].fileName}}\" \nclass=\"image\"></div><div class=\"media\" flex layout=\"row\" layout-align=\"center center\" \nng-if=\"vm.selectedMediaTiny.media_type == 2\"><img ng-src=\"{{vm.selectedMediaTiny.embed_thumb}}\" class=\"image\"></div>\n<div class=\"header p-16\" flex><div layout=\"row\" layout-align=\"space-between center\" flex><div class=\"size block\" \nlayout=\"row\" layout-align=\"start left\"><strong class=\"mr-5\">#{{vm.selectedMediaTiny.id_media}}</strong> <span \nclass=\"grey-500-fg\"><span ng-if=\"vm.selectedMediaTiny.filename\">{{vm.selectedMediaTiny.filename}}</span></span></div>\n</div></div></div></div></div><div class=\"sections white-box\"><div class=\"section\"><md-input-container \nclass=\"md-block\" flex><label translate=\"CONTENT.ALIGN\" translate-attr-aria-label=\"CONTENT.ALIGN\">Align:</label>\n<md-select ng-model=\"vm.tinyProperties.align\" placeholder=\"Align\"><md-option value=\"\">---</md-option><md-option \nng-repeat=\"opt in vm.tinyOptions.align\" value=\"{{opt.value}}\">{{opt.text}}</md-option></md-select><div \nclass=\"md-errors-spacer\"></div></md-input-container><md-input-container class=\"md-block\" flex><label \ntranslate=\"CONTENT.SIZE\" translate-attr-aria-label=\"CONTENT.SIZE\">Size:</label><md-select \nng-model=\"vm.tinyProperties.size\" placeholder=\"Size\"><md-option value=\"\">---</md-option><md-option \nng-repeat=\"opt in vm.tinyOptions.size\" value=\"{{opt.value}}\">{{opt.text}}</md-option></md-select><div \nclass=\"md-errors-spacer\"></div></md-input-container></div></div></div></div>");
$templateCache.put("app/main/apps/media/dialogs/media/views/upload-view.html","<div class=\"content-wrapper\" flex=\"\" layout=\"column\"><div class=\"content\"><div ngf-drop ngf-select ng-model=\"vm.files\" \nclass=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"true\" ngf-allow-dir=\"true\" \naccept=\"video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz,.json,.xml,.csv,.ttf,.eps,.ai,.psd,.aep,.indd,.idll,.heic,.mkv,.gpx\" \nngf-pattern=\"\'video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz,.json,.xml,.csv,.ttf,.eps,.ai,.psd,.aep,.indd,.idll,.heic,.mkv,.gpx\'\">\n<div layout=\"column\"><div flex>Drop here or click to upload</div><div flex>or</div><div flex><md-button \nclass=\"send-button md-accent md-raised\" aria-label=\"Select files\">Select Files from your computer</md-button></div>\n</div></div><div ngf-no-file-drop>File Drag/Drop is not supported for this browser</div><div \nng-repeat=\"f in vm.uploadFiles\" class=\"ms-card\" flex><div class=\"ms-card-content-wrapper\"><div class=\"template-9\"><div \nclass=\"media\" flex layout=\"row\" layout-align=\"center center\"><img ngf-thumbnail=\"!f.$error && f\" class=\"image\"></div>\n<div class=\"header p-16\" flex><div layout=\"row\" layout-align=\"space-between center\" flex><div class=\"size\" \nlayout=\"row\" layout-align=\"start left\"><strong class=\"mr-5\" ng-if=\"f.id\">#{{f.id}}</strong> <span class=\"grey-500-fg\">\n<span ng-if=\"f.name\">{{f.name}}</span></span></div></div></div><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{f.progress}}\" ng-show=\"f.progress < 100 && !f.processed\"></md-progress-linear></div></div></div><md-list-item \nclass=\"file-name-item md-white-bg\" md-ink-ripple ng-repeat=\"f in vm.uploadFiles\"><p \nclass=\"text-truncate font-weight-600\">{{f.name}} {{f.$error}} {{f.$errorParam}}</p></md-list-item>Upload Log:<pre>\n{{log}}</pre></div></div>");
$templateCache.put("app/main/apps/media/dialogs/media/views/videos-view.html","<div class=\"content-wrapper\" flex layout=\"row\"><div class=\"mail-tabs-grid\" flex><div \nclass=\"content mail-list-pane-grid\" flex><div ng-repeat=\"item in vm.items\" class=\"ms-card\" flex><div \nclass=\"ms-card-content-wrapper\"><div class=\"template-9\"><div class=\"media\" flex layout=\"row\" \nlayout-align=\"center center\"><img ng-src=\"{{item.embed_thumb}}\" class=\"image\" ng-if=\"item.media_children.length===0\"> \n<img \nng-src=\"{{item.media_children[0].cropstatus[0].container.view_url}}{{item.media_children[0].cropstatus[0].fileName}}\" \nng-if=\"item.media_children!==undefined\" class=\"image\"></div><div class=\"header p-16\" flex><div layout=\"row\" \nlayout-align=\"space-between center\" flex><div class=\"size block\" layout=\"row\" layout-align=\"start left\"><strong \nclass=\"mr-5\">#{{item.id_media}}</strong> <span class=\"grey-500-fg\"><span ng-if=\"item.filename\">{{item.filename}}</span>\n <span ng-if=\"item.title\">{{item.title}}</span></span></div><md-checkbox \nng-checked=\"vm.alreadySelectedbyZone(vm.selectedContacts, item)\" ng-click=\"vm.toggleSelectContact(item, $event)\" \naria-label=\"{{vm.alreadySelectedbyZone(vm.selectedContacts, item) ? \'Deselect\' : \'Select\'}}\"></md-checkbox></div>\n<md-tooltip md-direction=\"top\" hide show-gt-xs ng-if=\"item.title\"><span>{{item.title}}</span></md-tooltip></div></div>\n</div></div></div></div></div>");
$templateCache.put("app/main/apps/mediahub/dialogs/galleries/views/duplicate-gallery.html","<md-input-container class=\"md-block\"><md-checkbox ng-model=\"vm.duplicateWithMedia\" aria-label=\"Duplicate with media\">\n<span translate=\"GALLERY.DUPLICATE_WITH_MEDIA\">Duplicate with media</span></md-checkbox></md-input-container>\n<md-input-container class=\"md-block on-off\"><label translate=\"GALLERY.DUPLICATE_TO\"></label><md-menu><button \nclass=\"mr-0 width-percent-100 pt-5 pb-5 button-select\" ng-click=\"$mdMenu.open($event)\" aria-label=\"group-menu\" \nlayout=\"row\" layout-align=\"space-between center\"><span ng-if=\"vm.duplicatedGalleryParentName\" class=\"font-size-14\">\n{{vm.duplicatedGalleryParentName}}</span> <span ng-if=\"!vm.duplicatedGalleryParentName\" class=\"font-size-14\" \ntranslate=\"GALLERY.ROOT\"></span><md-icon md-font-icon=\"icon-menu-down\" class=\"grey-600-fg ml-10 mr-0\" \naria-hidden=\"true\"></md-icon></button><md-menu-content class=\"md-block groups-tree w-440\"><div \nclass=\"level-card p-8 group-row ng-scope\" layout=\"row\"><label for=\"search-bar-input\"><md-icon ng-show=\"!vm.treeSearch\" \nmd-font-icon=\"icon-magnify\" class=\"grey-600-fg search-bar-input md-icon-button md-button\"><md-tooltip hide show-gt-xs>\n<span translate=\"TOOLBAR.SEARCH\">Search</span></md-tooltip></md-icon><md-icon ng-show=\"vm.treeSearch\" \nmd-font-icon=\"icon-close-circle\" class=\"grey-600-fg md-icon-button md-button\" ng-click=\"vm.treeSearch= null\"></md-icon>\n</label><input type=\"text\" id=\"search-bar-input\" class=\"grey-600-fg grey-100-bg\" ng-model=\"vm.treeSearch\" translate \ntranslate-attr-placeholder=\"TOOLBAR.SEARCH\" flex></div><div ng-if=\"!vm.isQiuRestricted\" \nng-click=\"vm.selectParentGalleryRoot()\" class=\"level-card p-8 gallery-row ng-scope\" layout=\"row\" \nlayout-align=\"space-between stretch\"><div flex=\"\" class=\"layout-align-start-center layout-row flex\"><md-icon \nmd-font-icon=\"icon-folder-multiple-image\" class=\"s24 mr-10 mt-0 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><span \ntranslate=\"GALLERY.ROOT\"></span></div></div><qiu-tree iscombo=\"true\" \non-select=\"vm.selectParentGallery(item, vm.galleriesFiltered); $mdMenu.close()\" ng-if=\"vm.galleriesFiltered\" \ntree=\"vm.galleriesFiltered\"></qiu-tree></md-menu-content></md-menu></md-input-container><md-input-container \nclass=\"md-block\"><label translate=\"GALLERY.NAME\"></label><input ng-model=\"vm.duplicatedGallery.gallery_name\" \ntype=\"text\" required></md-input-container><md-input-container class=\"md-block\"><label translate=\"GALLERY.SHORTTEXT\">\n</label><input ng-model=\"vm.duplicatedGallery.short_text\" type=\"text\"></md-input-container><md-input-container \nclass=\"p-0 mb-40 md-block on-off\"><label translate=\"GALLERY.STATUS\"></label><md-menu-bar layout=\"row\" \nlayout-align=\"stretch center\" class=\"p-0\"><md-menu flex><button class=\"mr-0 width-percent-100 pt-5 pb-5 button-select\" \nng-click=\"$mdMenu.open($event)\" aria-label=\"group-menu\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" \nclass=\"on green-fg s24 mr-10 ml-0\" ng-if=\"vm.duplicatedGallery.status ===1\"></md-icon><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"on red-fg s24 mr-10 ml-0\" \nng-if=\"vm.duplicatedGallery.status ===0\"></md-icon><md-icon md-font-icon=\"icon-checkbox-blank-circle-outline\" \nclass=\"on grey-fg s24 mr-10 ml-0\" ng-if=\"vm.duplicatedGallery.status !==1 && vm.duplicatedGallery.status !==0\">\n</md-icon><span ng-if=\"vm.duplicatedGallery.status ===0\" translate=\"GALLERY.STATUS_PRIVATE\">Private</span> <span \nng-if=\"vm.duplicatedGallery.status ===1\" translate=\"GALLERY.STATUS_PUBLIC\">Public</span> <span \nng-if=\"vm.duplicatedGallery.status ===2\" translate=\"GALLERY.STATUS_PUBLIC_LOGIN_REQUIRED\">Public (login required)\n</span> <span ng-if=\"vm.duplicatedGallery.status !==1 && vm.duplicatedGallery.status !==0\" \ntranslate=\"GALLERY.SELECT_STATUS\">Select</span></div><md-icon md-font-icon=\"icon-menu-down\" \nclass=\"grey-600-fg ml-10 mr-0\" aria-hidden=\"true\"></md-icon></button><md-menu-content class=\"md-block\" width=\"4\">\n<md-menu-item><button class=\"pl-10 pr-10\" layout=\"row\" layout-align=\"start center\" \nng-click=\"vm.duplicatedGallery.status = 0\"><md-icon md-font-icon=\"icon-checkbox-blank-circle-outline\" \nclass=\"on red-fg s24 mr-10 ml-0\"></md-icon><span class=\"font-size-14\" translate=\"GALLERY.STATUS_PRIVATE\">Private</span>\n</button></md-menu-item><md-menu-item><button class=\"pl-10 pr-10\" layout=\"row\" layout-align=\"start center\" \nng-click=\"vm.duplicatedGallery.status = 1\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" \nclass=\"on green-fg s24 mr-10 ml-0\"></md-icon><span class=\"font-size-14\" translate=\"GALLERY.STATUS_PUBLIC\">Published\n</span></button></md-menu-item><md-menu-item><button class=\"pl-10 pr-10\" layout=\"row\" layout-align=\"start center\" \nng-click=\"vm.duplicatedGallery.status = 2\"><md-icon md-font-icon=\"icon-lock\" class=\"on orange-fg s24 mr-10 ml-0\">\n</md-icon><span class=\"font-size-14\" translate=\"GALLERY.STATUS_PUBLIC_LOGIN_REQUIRED\">Public (login required)</span>\n</button></md-menu-item></md-menu-content></md-menu></md-menu-bar></md-input-container><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start start\"><mdp-date-picker mdp-placeholder=\"Date\" mdp-open-on-click=\"true\" \nmdp-format=\"DD/MM/YYYY\" ng-init=\"dateGallery = vm.duplicatedGallery.date ? (vm.duplicatedGallery.date | toDate) : \'\'\" \nng-model=\"dateGallery\" ng-change=\"vm.duplicatedGallery.date= (dateGallery | date:\'yyyy-MM-dd\')\"></mdp-date-picker>\n</div><label translate=\"GALLERY.COVER\"></label><md-input-container class=\"md-block\"><div class=\"mail-list-item\" \nlayout=\"row\" class=\"md-block\"><div class=\"template-9\" layout=\"column\" layout-align=\"space-between stretch\"><div \nclass=\"media photos\" layout-align=\"center center\" layout=\"row\" flex><media attachment=\"vm.duplicatedGalleryCover\" \nclass-img=\"image\" ng-click=\"vm.selectCover($event)\"></media></div></div></div></md-input-container>");
$templateCache.put("app/main/apps/mediahub/dialogs/galleries/views/edit-gallery-dynamic.html","<div layout=\"column\" class=\"gallery-dynamic mb-16 mt-8\"><md-switch ng-model=\"vm.dynamic.enabled\" \nng-change=\"vm.onDynamicToggle()\" class=\"m-0 mb-8\" aria-label=\"{{ \'GALLERY.DYNAMIC_ENABLE\' | translate }}\"><span \ntranslate=\"GALLERY.DYNAMIC_ENABLE\">Dynamic gallery</span></md-switch><div class=\"md-caption grey-600-fg mb-16\" \ntranslate=\"GALLERY.DYNAMIC_EXPLAIN\">Its contents come from these filters instead of photos added by hand.</div><div \nclass=\"dynamic-notice mb-16\" ng-if=\"vm.isEditMode && vm.dynamic.enabled && !vm.wasDynamic\" layout=\"row\" \nlayout-align=\"start start\"><md-icon md-font-icon=\"icon-information-outline\" class=\"s18 mr-8\"></md-icon><span \ntranslate=\"GALLERY.DYNAMIC_CONVERT_WARNING\">\nPhotos added by hand stop showing while the gallery is dynamic. They are not deleted.</span></div><div \nclass=\"dynamic-notice mb-16\" ng-if=\"vm.isEditMode && !vm.dynamic.enabled && vm.wasDynamic\" layout=\"row\" \nlayout-align=\"start start\"><md-icon md-font-icon=\"icon-information-outline\" class=\"s18 mr-8\"></md-icon><span \ntranslate=\"GALLERY.DYNAMIC_REVERT_WARNING\">\nOn save it stops being dynamic and shows only the photos added to it by hand.</span></div><div layout=\"column\" \nng-if=\"vm.dynamic.enabled\"><div layout=\"column\" ng-if=\"!vm.hasVertex\"><label class=\"md-subhead grey-600-fg mb-8\" \ntranslate=\"GALLERY.DYNAMIC_DATE_RANGE\">File date</label><div layout=\"row\" layout-align=\"start center\" \nclass=\"mb-8 dynamic-dates\"><md-datepicker ng-model=\"vm.dynamic.from\" md-max-date=\"vm.dynamic.to\" \nmd-placeholder=\"{{ \'GALLERY.DYNAMIC_FROM\' | translate }}\" class=\"mh-gallery-datepicker\"></md-datepicker><md-datepicker \nng-model=\"vm.dynamic.to\" md-min-date=\"vm.dynamic.from\" md-placeholder=\"{{ \'GALLERY.DYNAMIC_TO\' | translate }}\" \nclass=\"mh-gallery-datepicker\"></md-datepicker></div><div class=\"md-caption red-fg mb-8\" \nng-if=\"vm.dynamicRangeInvalid()\" translate=\"GALLERY.DYNAMIC_RANGE_INVALID\">The start date is after the end date.</div>\n<md-input-container class=\"md-block mt-16 mb-8\"><label translate=\"GALLERY.DYNAMIC_MIN_RATING\">Minimum rating</label>\n<md-select ng-model=\"vm.dynamic.minRating\" aria-label=\"Minimum rating\"><md-option ng-value=\"null\"><span \ntranslate=\"GALLERY.DYNAMIC_ANY_RATING\">Any</span></md-option><md-option ng-repeat=\"r in vm.ratingOptions track by r\" \nng-value=\"r\"><span translate=\"GALLERY.DYNAMIC_RATING_OR_MORE\" translate-values=\"{ rating: r }\">{{ r }} or more</span>\n</md-option></md-select></md-input-container></div><label class=\"md-subhead grey-600-fg mb-8\" \ntranslate=\"GALLERY.DYNAMIC_TAGS\">Tags</label><md-chips ng-model=\"vm.dynamic.tags\" md-autocomplete-snap \nmd-require-match=\"false\" md-transform-chip=\"vm.transformTextChip($chip)\" md-removable=\"true\" class=\"mb-8\">\n<md-autocomplete md-selected-item=\"vm.tagSelected\" md-search-text=\"vm.tagSearchText\" \nmd-items=\"tagName in vm.searchFilterTags(vm.tagSearchText)\" md-item-text=\"tagName\" md-min-length=\"1\" \nmd-no-cache=\"true\" placeholder=\"{{ \'GALLERY.DYNAMIC_TAGS_PLACEHOLDER\' | translate }}\"><span \nmd-highlight-text=\"vm.tagSearchText\" md-highlight-flags=\"i\">{{ tagName }}</span></md-autocomplete></md-chips>\n<md-radio-group ng-model=\"vm.dynamic.tagsMode\" layout=\"row\" class=\"mb-16\" ng-if=\"vm.dynamic.tags.length > 1\">\n<md-radio-button value=\"any\" class=\"mr-16\"><span translate=\"GALLERY.DYNAMIC_TAGS_ANY\">Any of these tags</span>\n</md-radio-button><md-radio-button value=\"all\"><span translate=\"GALLERY.DYNAMIC_TAGS_ALL\">All of these tags</span>\n</md-radio-button></md-radio-group><div ng-if=\"vm.hasVertex\" layout=\"column\" class=\"mt-8\"><label \nclass=\"md-subhead grey-600-fg mb-8\" translate=\"GALLERY.DYNAMIC_WORDS\">Words</label><md-chips \nng-model=\"vm.dynamic.words\" md-transform-chip=\"vm.transformTextChip($chip)\" md-removable=\"true\" \nplaceholder=\"{{ \'GALLERY.DYNAMIC_WORDS_PLACEHOLDER\' | translate }}\" \nsecondary-placeholder=\"{{ \'GALLERY.DYNAMIC_WORDS_PLACEHOLDER\' | translate }}\"></md-chips></div><div \nclass=\"md-caption red-fg mt-16\" ng-if=\"!vm.dynamicHasConstraint()\" translate=\"GALLERY.DYNAMIC_NEEDS_CONSTRAINT\">\nSet at least one filter.</div><div class=\"md-caption grey-600-fg mt-16\" translate=\"GALLERY.DYNAMIC_NO_MANUAL_ADD\">\nPhotos cannot be added to a dynamic gallery by hand.</div></div></div>");
$templateCache.put("app/main/apps/mediahub/dialogs/galleries/views/edit-gallery-main.html","<div layout=\"column\" class=\"gallery-details p-16 pl-24 pr-24\" flex><div layout=\"column\" flex><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"mb-8\"><span class=\"gallery-id-text\">ID: {{vm.galleryId}}</span><md-switch \nng-model=\"vm.gallery.onoff\" ng-true-value=\"1\" ng-false-value=\"0\" aria-label=\"Active\" class=\"active-switch\"><span \nng-if=\"vm.gallery.onoff\" class=\"green-fg\">Active</span> <span ng-if=\"!vm.gallery.onoff\" class=\"red-fg\">Inactive</span>\n</md-switch></div><md-input-container class=\"md-block mb-8\"><label translate=\"GALLERY.NAME\">Name</label><input \nname=\"name\" ng-model=\"vm.gallery.name\" required md-autofocus><div ng-messages=\"vm.basicForm.name.$error\"><div \nng-message=\"required\" translate=\"GALLERY.ERRORS.NAME_REQUIRED\">Name is required</div></div></md-input-container><div \nclass=\"mb-16 mt-8\" layout=\"column\"><label class=\"md-subhead mb-8 grey-600-fg\" translate=\"GALLERY.DATE\">Date</label>\n<md-datepicker ng-model=\"vm.gallery.date\" md-placeholder=\"Date\" class=\"mh-gallery-datepicker\"></md-datepicker></div>\n<div ng-include=\"vm.views[\'edit_gallery_dynamic\']\"></div><div class=\"mb-16 mt-8\" layout=\"column\" \nng-if=\"!vm.isSortHidden()\"><md-checkbox ng-model=\"vm.gallery.useCustomSort\" ng-change=\"vm.onUseCustomSortChange()\" \nclass=\"m-0 mb-8\" aria-label=\"Gallery order\"><span translate=\"GALLERY.CUSTOM_SORT\">Gallery order</span></md-checkbox>\n<div layout=\"row\" layout-align=\"start center\" layout-gap=\"8\" ng-if=\"vm.gallery.useCustomSort\"><md-input-container \nclass=\"md-block m-0\" flex><md-select ng-model=\"vm.gallery.sortField\" ng-change=\"vm.onSortFieldChange()\" \naria-label=\"Sort field\"><md-option ng-repeat=\"f in vm.availableSortFields track by $index\" ng-value=\"f.value\">\n{{ f.label }}</md-option></md-select></md-input-container><md-input-container class=\"md-block m-0\" flex><md-select \nng-model=\"vm.gallery.sortDirection\" aria-label=\"Sort direction\"><md-option \nng-repeat=\"d in vm.sortDirections track by $index\" ng-value=\"d.value\">{{ d.label }}</md-option></md-select>\n</md-input-container></div><div class=\"md-caption grey-600-fg\" \nng-if=\"vm.gallery.useCustomSort && vm.isDynamicGallery()\" translate=\"GALLERY.DEFAULT_SORT_DYNAMIC_HINT\">\nOrdering by the order added is not available: this gallery\'s contents come from filters.</div></div><div \nclass=\"md-caption grey-600-fg mb-16\" ng-if=\"vm.descendants.length\" translate=\"GALLERY.PROPAGATE_HINT\" \ntranslate-values=\"{ count: vm.descendants.length }\"></div><div class=\"parent-gallery-select mb-16\"><label \nclass=\"md-subhead\">Parent Gallery</label><div class=\"selected-parent\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"md-body-1 selected-parent-text\">Selected: &nbsp;</span><div layout=\"column\" flex><span \nng-if=\"!vm.gallery.parentId\">Root</span> <span ng-if=\"vm.gallery.parentId\" class=\"text-truncate\" \ntitle=\"{{vm.galleryParentName}}\">{{vm.galleryParentName}}</span></div><md-button \nclass=\"md-icon-button md-warn parent-clear-btn\" ng-click=\"vm.selectParentGalleryRoot()\" ng-if=\"vm.gallery.parentId\" \naria-label=\"Clear parent\"><md-icon md-font-icon=\"icon-close\" class=\"s18\"></md-icon></md-button></div>\n<md-input-container class=\"md-block search-parent-input\"><label>Search Parent Gallery</label><input \nng-model=\"searchParent\" type=\"text\"></md-input-container><div class=\"gallery-tree-container\" ms-scroll><script \ntype=\"text/ng-template\" id=\"parent_gallery_recursive.html\">\n<div class=\"tree-row\" layout=\"row\" layout-align=\"start center\" ng-class=\"{\'blue-50-bg\': vm.gallery.parentId == (node.id || node.id_gallery)}\">\r\n            <!-- Chevron expand/collapse -->\r\n            <md-icon ng-if=\"node.children && node.children.length > 0 && !node._expanded\"\r\n              ng-click=\"node._expanded = true; $event.stopPropagation();\"\r\n              md-font-icon=\"icon-chevron-right\" class=\"s18 grey-500-fg tree-arrow\"></md-icon>\r\n            <md-icon ng-if=\"node.children && node.children.length > 0 && node._expanded\"\r\n              ng-click=\"node._expanded = false; $event.stopPropagation();\"\r\n              md-font-icon=\"icon-chevron-down\" class=\"s18 grey-500-fg tree-arrow\"></md-icon>\r\n            <span ng-if=\"!node.children || !node.children.length\" class=\"tree-arrow-placeholder\"></span>\r\n            <!-- Folder icon (grey) -->\r\n            <md-icon ng-if=\"node.children && node.children.length > 0\" md-font-icon=\"icon-folder-multiple\" class=\"mr-8 s18 grey-600-fg\" ng-click=\"vm.selectParentGallery(node)\"></md-icon>\r\n            <md-icon ng-if=\"!node.children || !node.children.length\" md-font-icon=\"icon-folder\" class=\"mr-8 s18 grey-600-fg\" ng-click=\"vm.selectParentGallery(node)\"></md-icon>\r\n            <span ng-bind=\"node.name || node.gallery_name\" ng-click=\"vm.selectParentGallery(node)\" class=\"text-truncate\" title=\"{{node.name || node.gallery_name}}\"></span>\r\n          </div>\r\n          <ul ng-if=\"node.children && node.children.length > 0 && node._expanded\" class=\"tree-subtree\">\r\n              <li ng-repeat=\"node in node.children | filter:searchParent\" ng-include=\"\'parent_gallery_recursive.html\'\"></li>\r\n          </ul>\n</script><ul class=\"tree-list\"><li ng-click=\"vm.selectParentGalleryRoot()\" \nng-class=\"{\'blue-50-bg\': !vm.gallery.parentId}\"><div class=\"tree-row\" layout=\"row\" layout-align=\"start center\"><md-icon\n md-font-icon=\"icon-folder-outline\" class=\"mr-8 s18 grey-600-fg\"></md-icon><span class=\"text-truncate\">Root</span>\n</div></li><li ng-repeat=\"node in vm.galleriesFiltered | filter:searchParent\" \nng-include=\"\'parent_gallery_recursive.html\'\"></li></ul></div></div><div class=\"gallery-cover-select mt-8\"><label \nclass=\"md-subhead\" translate=\"GALLERY.COVER\">Cover</label><div ng-if=\"!vm.gallery.coverId\" layout=\"row\" \nlayout-align=\"start center\" class=\"mt-8\"><md-button class=\"md-raised md-primary select-cover-btn\" \nng-click=\"vm.selectCover($event)\"><span translate=\"GALLERY.SELECT_COVER\">Select Cover</span></md-button></div><div \nng-if=\"vm.gallery.coverId\" layout=\"row\" layout-align=\"start center\" class=\"mt-8\"><img \nng-if=\"vm.coverMedia.imageUrl && vm.coverMedia.media_type == 1\" ng-src=\"{{vm.coverMedia.imageUrl}}\" \nclass=\"cover-img-inline\"><md-icon ng-if=\"vm.coverMedia.media_type == 2\" md-font-icon=\"icon-video\" \nclass=\"s40 grey-500-fg mr-8\"></md-icon><md-icon ng-if=\"vm.coverMedia.media_type == 3\" md-font-icon=\"icon-music-note\" \nclass=\"s40 grey-500-fg mr-8\"></md-icon><md-icon \nng-if=\"!vm.coverMedia || (vm.coverMedia.media_type != 1 && vm.coverMedia.media_type != 2 && vm.coverMedia.media_type != 3)\" \nmd-font-icon=\"icon-image\" class=\"s40 grey-400-fg mr-8\"></md-icon><md-button class=\"md-icon-button\" \nng-click=\"vm.selectCover($event)\" aria-label=\"Change cover\"><md-icon md-font-icon=\"icon-pencil\" class=\"s18\"></md-icon>\n</md-button><md-button class=\"md-icon-button md-warn\" ng-click=\"vm.removeCover()\" aria-label=\"Remove cover\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s18\"></md-icon></md-button></div></div></div></div>");
$templateCache.put("app/main/apps/mediahub/dialogs/galleries/views/edit-gallery-users-groups-mediacenter.html","<div layout=\"column\" class=\"p-16\"><div ng-if=\"vm.loadingGroups\" layout=\"row\" layout-align=\"center center\" \nclass=\"pv-32\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"40\"></md-progress-circular></div><div \nng-if=\"!vm.loadingGroups\"><div ng-if=\"vm.presets.length > 0\" layout=\"row\" layout-align=\"space-between center\" \nclass=\"mb-16 pb-16 border-bottom\"><md-input-container class=\"md-block mb-0\" flex><label>Apply Permission Preset</label>\n<md-select ng-model=\"vm.selectedPreset\" ng-change=\"vm.applyPreset()\" placeholder=\"Select a preset\"><md-option \nng-repeat=\"preset in vm.presets\" ng-value=\"preset\">{{preset.name}}</md-option></md-select></md-input-container></div>\n<div layout=\"row\" layout-align=\"start center\" class=\"mb-16 pb-16 border-bottom\"><md-checkbox \nng-checked=\"vm.isAllSelected()\" ng-click=\"vm.toggleAllGroups()\" aria-label=\"Select All\"><span class=\"font-weight-600\">\nSelect All</span></md-checkbox></div><div ng-repeat=\"group in vm.mediahubGroups\" class=\"mb-8\"><md-checkbox \nng-checked=\"vm.isGroupSelected(group)\" ng-click=\"vm.toggleGroupSelection(group)\" aria-label=\"{{group.name}}\">\n{{group.name}}</md-checkbox></div><div ng-if=\"vm.mediahubGroups.length === 0\" class=\"grey-500-fg italic\" \ntranslate=\"GALLERY.NO_GROUPS_AVAILABLE\">No groups available for this section.</div></div></div>");
$templateCache.put("app/main/apps/mediahub/dialogs/edit-multiple-fields/views/set-geolocation.html","<div class=\"map-container mb-24\"><ng-map id=\"mapa-mediahub\" centered=\"true\" \ncenter=\"{{vm.mediaData.geoLat ? vm.mediaData.geoLat + \',\' + vm.mediaData.geoLon : \'40.416775,-3.703790\'}}\" zoom=\"2\" \non-click=\"vm.getpos($event)\"><marker position=\"[{{vm.mediaData.geoLat}}, {{vm.mediaData.geoLon}}]\" \non-dragend=\"vm.getpos($event)\" animation=\"DROP\" draggable=\"true\" ng-if=\"vm.mediaData.geoLat && vm.mediaData.geoLon\">\n</marker></ng-map><md-toolbar><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"expanded ms-search-bar layout-align-start-center layout-row flex\" layout=\"row\" layout-align=\"start center\" flex>\n<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-icon \nid=\"ms-search-bar-expander\" md-font-icon=\"icon-magnify\" class=\"md-icon-button md-button\"><md-tooltip hide show-gt-xs>\n<span translate=\"TOOLBAR.SEARCH\">Search</span></md-tooltip></md-icon></label><input places-auto-complete types=\"[]\" \non-place-changed=\"vm.placeMarker(this.getPlace())\" id=\"ms-search-bar-input\" type=\"text\" \nstyle=\"width: 100%; border: none; background: transparent; outline: none; padding-left: 8px\" \nplaceholder=\"Search location...\"></div></div></div></md-toolbar></div>");
$templateCache.put("app/main/apps/media/views/list/subviews/audios-view.html","<div class=\"ms-card-content-wrapper\"><div class=\"template-9\"><div class=\"media\" flex layout=\"row\" \nlayout-align=\"center center\"><div flex layout=\"column\" layout-align=\"center center\"><media attachment=\"mediaItem\" \nclass-img=\"image\" embed=\"true\"></media><br><span class=\"grey-500-fg\" layout=\"column\" layout-align=\"center center\"><span\n ng-if=\"mediaItem.title\"><strong>{{mediaItem.title}}</strong></span> <span ng-if=\"mediaItem.filename\">\n{{mediaItem.filename}}</span></span></div></div><div class=\"header p-16\" flex><div layout=\"row\" \nlayout-align=\"space-between center\" flex><div class=\"size block\" layout=\"row\" layout-align=\"start left\"><strong \nclass=\"mr-5\">#{{mediaItem.id_media}}</strong> <span class=\"grey-500-fg\"><span ng-if=\"mediaItem.date_uploaded\">\n{{mediaItem.date_uploaded}}</span></span></div><md-checkbox ng-checked=\"vm.isSelected(mediaItem)\" \nng-click=\"vm.toggleSelectThread(mediaItem, $event)\" aria-label=\"{{vm.isSelected(mediaItem) ? \'Deselect\' : \'Select\'}}\" \nclass=\"ml-5\"></md-checkbox></div></div></div></div>");
$templateCache.put("app/main/apps/media/views/list/subviews/files-view.html","<div class=\"ms-card-content-wrapper\"><div class=\"template-9\"><div class=\"media\" flex layout=\"row\" \nlayout-align=\"center center\"><div flex layout=\"column\" layout-align=\"center center\"><media attachment=\"mediaItem\" \nclass-img=\"image\" embed=\"true\"></media><br><span class=\"grey-500-fg\" layout=\"column\" layout-align=\"center center\"><span\n ng-if=\"mediaItem.title\"><strong>{{mediaItem.title}}</strong></span> <span ng-if=\"mediaItem.filename\">\n{{mediaItem.filename}}</span></span></div></div><div class=\"header p-16\" flex><div layout=\"row\" \nlayout-align=\"space-between center\" flex><div class=\"size text-truncate\" layout=\"row\" layout-align=\"start left\"><strong\n class=\"mr-5\">#{{mediaItem.id_media}}</strong></div><md-checkbox ng-checked=\"vm.isSelected(mediaItem)\" \nng-click=\"vm.toggleSelectThread(mediaItem, $event)\" aria-label=\"{{vm.isSelected(mediaItem) ? \'Deselect\' : \'Select\'}}\" \nclass=\"ml-5\"></md-checkbox></div></div></div></div>");
$templateCache.put("app/main/apps/media/views/list/subviews/import-view.html","<div class=\"content-wrapper\" flex layout=\"column\"><div class=\"content\"><div class=\"drop-box\"><md-input-container \nclass=\"md-block\"><label>Paste the url to import:</label><input type=\"text\" name=\"import_field\" \nng-model=\"vm.import_field\" placeholder=\"\" ng-disabled=\"vm.import_disabled\"></md-input-container><div \nng-if=\"vm.imported\" class=\"alert-message success-message\" translate=\"CONTENT.SUCCESSIMPORT\">Imported successfully</div>\n</div><treasure-overlay-spinner active=\"vm.importing\"><div layout=\"row\" layout-align=\"center start\" \nng-if=\"vm.importPreview\" class=\"white-box sections\"><div flex-gt-sm=\"50\" flex=\"100\"><div class=\"section\"><div \nclass=\"section-header\" layout=\"row\" layout-align=\"start center\"><span class=\"section-title\">PREVIEW</span></div><div \nclass=\"media\" flex layout=\"row\" layout-align=\"center center\" ng-bind-html=\"vm.importPreview.embedCodeSafe\"></div></div>\n<div class=\"header p-16\" flex><div layout=\"row\" layout-align=\"space-between center\" flex><div \nclass=\"size text-truncate\" layout=\"row\" layout-align=\"start left\"><span class=\"grey-500-fg\"><span \nng-if=\"vm.importPreview.title\">Title: {{vm.importPreview.title}}</span></span></div></div><div layout=\"row\" \nlayout-align=\"space-between center\" flex><div class=\"size\" layout=\"row\" layout-align=\"start left\"><span \nclass=\"grey-500-fg\"><span ng-if=\"vm.importPreview.caption\">Description: {{vm.importPreview.caption}}</span></span>\n</div></div></div><md-button class=\"send-button md-accent md-raised\" ng-click=\"vm.importConfirm(1)\" \ntranslate=\"CONTENT.IMPORT\">Import</md-button></div></div><div ng-repeat=\"f in vm.importedFiles\" class=\"ms-card\" flex>\n<div class=\"ms-card-content-wrapper\"><div class=\"template-9\"><div class=\"media\" flex layout=\"row\" \nlayout-align=\"center center\"><img ng-src=\"{{f.embed_thumb}}\" class=\"image\"></div><div class=\"header p-16\" flex><div \nlayout=\"row\" layout-align=\"space-between center\" flex><div class=\"size block\" layout=\"row\" layout-align=\"start left\">\n<strong class=\"mr-5\">#{{f.id_media}}</strong> <span class=\"grey-500-fg\"><span ng-if=\"f.filename\">{{f.filename}}</span> \n<span ng-if=\"f.title\">{{f.title}}</span></span></div><md-checkbox \nng-checked=\"vm.alreadySelectedbyZone(vm.selectedContacts, f)\" ng-click=\"vm.toggleSelectContact(f, $event)\" \naria-label=\"{{vm.alreadySelectedbyZone(vm.selectedContacts, f) ? \'Deselect\' : \'Select\'}}\"></md-checkbox></div></div>\n</div></div></div></treasure-overlay-spinner></div></div>");
$templateCache.put("app/main/apps/media/views/list/subviews/list-view.html","<div layout=\"row\" layout-align=\"start center\"><md-checkbox ng-checked=\"vm.isSelected(mediaItem)\" \nng-click=\"vm.toggleSelectThread(mediaItem, $event)\" aria-label=\"{{vm.isSelected(mediaItem) ? \'Deselect\' : \'Select\'}}\" \nclass=\"mb-0\"></md-checkbox><div class=\"media photos\" layout=\"row\" layout-align=\"center center\" \nng-if=\"mediaItem.media_type == 1 || mediaItem.media_type == 2 || mediaItem.media_type == 3 || mediaItem.media_type == 4\">\n<media attachment=\"mediaItem\" class-img=\"image\"></media></div><div class=\"info\" flex layout=\"column\"><div \nclass=\"subject text-truncate grey-500-fg\" layout=\"row\" layout-align=\"start center\"><span>\nDate uploaded: {{mediaItem.date_uploaded}}</span></div><div class=\"name\" layout=\"row\" layout-align=\"start center\"><span\n ng-bind=\"mediaItem.filename\" ng-if=\"mediaItem.filename\"></span> <span ng-bind=\"mediaItem.title\" \nng-if=\"mediaItem.title && !mediaItem.filename\"></span></div><div class=\"details\" \nng-if=\"mediaItem.filename && mediaItem.title\"><span class=\"title grey-500-fg\">Title</span> <span class=\"detail\">\n{{mediaItem.title}}</span></div><div class=\"details\" ng-if=\"mediaItem.caption\"><span class=\"title grey-500-fg\">Caption\n</span> <span class=\"detail\">{{mediaItem.caption}}</span></div></div><div \nclass=\"subject buttons text-truncate grey-500-fg\" layout=\"row\" layout-align=\"start center\"><span>\n#{{mediaItem.id_media}}</span></div></div>");
$templateCache.put("app/main/apps/media/views/list/subviews/media-children.html","<div ng-click=\"vm.selectMediaFile(child)\" class=\"ms-card pointer\"><div class=\"ms-card-content-wrapper\"><div \nclass=\"template-9\" layout=\"column\" layout-align=\"space-between stretch\"><div class=\"media\" flex layout=\"row\" \nlayout-align=\"center center\"><media attachment=\"child\" class-img=\"image\"></media></div><div class=\"header p-16\" flex>\n<div layout=\"row\" layout-align=\"space-between center\" flex><div ng-if=\"vm.media_type_name != \'Image Rekognition\'\" \nclass=\"size block mr-5\" layout=\"row\" layout-align=\"start left\"><strong class=\"mr-5\">#{{child.id_media}}</strong> <span \nclass=\"grey-500-fg word-break-all\"><span ng-if=\"child.filename\" class=\"filename\">{{child.filename}}</span></span></div>\n<md-menu ng-if=\"selectedTab == \'children\'\"><md-icon class=\"pointer mr-10\" ng-click=\"$mdMenu.open($event)\" \nmd-font-icon=\"icon-dots-vertical\"></md-icon><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"vm.deleteMediaChild(child)\" aria-label=\"Refresh widget\" translate=\"MEDIA.DELETE\"></md-button></md-menu-item>\n</md-menu-content></md-menu></div></div></div></div></div>");
$templateCache.put("app/main/apps/media/views/list/subviews/photos-view.html","<div class=\"ms-card-content-wrapper\"><div class=\"template-9\" layout=\"column\" layout-align=\"space-between stretch\"><div \nclass=\"media\" flex layout=\"row\" layout-align=\"center center\"><media attachment=\"mediaItem\" class-img=\"image\"></media>\n</div><div class=\"header p-16\" flex><div layout=\"row\" layout-align=\"space-between center\" flex><div \nng-if=\"vm.media_type_name != \'Image Rekognition\'\" class=\"size block mr-5\" layout=\"row\" layout-align=\"start left\">\n<strong class=\"mr-5\">#{{mediaItem.id_media}}</strong> <span class=\"grey-500-fg word-break-all\"><span \nng-if=\"mediaItem.filename\" class=\"filename\">{{mediaItem.filename}}</span></span></div><div \nng-if=\"vm.media_type_name == \'Image Rekognition\'\" class=\"size block\" layout=\"row\" layout-align=\"start left\"><strong \nng-if=\"!vm.isProcessingItem(mediaItem)\"><span \nng-repeat=\"text in mediaItem.meta_analyses.rekognition_detect_text.TextDetectionsUnique | filter: filterByNumNotCurrentYears track by $index\">\n{{text.DetectedText}}<span ng-if=\"!$last\">,</span></span> </strong><strong style=\"color: red; font-weight: bold\" \nng-if=\"vm.isProcessingItem(mediaItem)\">PROCESANDO</strong></div><md-checkbox ng-checked=\"vm.isSelected(mediaItem)\" \nng-click=\"vm.toggleSelectThread(mediaItem, $event)\" aria-label=\"{{vm.isSelected(mediaItem) ? \'Deselect\' : \'Select\'}}\" \nclass=\"ml-5\"></md-checkbox></div></div></div></div>");
$templateCache.put("app/main/apps/media/views/list/subviews/template-grid.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"space-between center\" flex><div \nlayout=\"column\" layout-align=\"start center\"><md-checkbox class=\"no-label\" ng-checked=\"vm.isChecked(mail)\" \nng-click=\"vm.toggleCheck(mail, $event)\" aria-label=\"{{vm.isChecked(mail)? \'Uncheck\':\'check\'}}\"></md-checkbox><div \nng-if=\"refcolumnsgrouped.main\"><div class=\"subject text-truncate\"><span \nng-repeat=\"field in refcolumnsgrouped.header | orderBy: \'list-sort\'\" ng-bind=\"thread.{{field.titleId}}\"></span></div>\n</div></div><div layout=\"column\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-attachment\" \nclass=\"has-attachment s24\" ng-if=\"thread.Thumbnail.length>0\"></md-icon><button ng-if=\"thread.onoff===1\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\"></md-icon></button> \n<button ng-if=\"thread.onoff!==1\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-blank-circle-outline\" \nclass=\"off red-fg s24\"></md-icon></button></div></div><div class=\"media\" flex layout=\"row\" \nlayout-align=\"center center\"><img class=\"image\" ng-src=\"{{card.Thumbnail[0].crop_status[0].urlformed}}\" \nalt=\"{{card.media.image.alt}}\" imageonloadcontrol></div><div class=\"header p-16\" layout=\"row\" layout-align=\"start\"><div\n class=\"info\"><div ng-if=\"refcolumnsgrouped.main\"><div class=\"name text-truncate\" layout=\"row\" \nlayout-align=\"start center\"><span ng-repeat=\"field in refcolumnsgrouped.main\"><span ng-bind=\"thread.{{field.titleId}}\">\n</span>&nbsp;</span></div></div><div ng-repeat=\"field in refcolumnsgrouped.secondary | orderBy:\'list_sort\'\"><div \nng-if=\"(field.type!==\'date\' && field.type!==\'dateHm\') && field.primary!==1\" class=\"details\" layout=\"row\" \nlayout-align=\"start start\"><div layout=\"column\"><span class=\"title\" ng-bind=\"field.title\"></span></div><div \nlayout=\"column\" class=\"text-truncate\"><span class=\"detail\" ng-bind=\"thread.{{field.titleId}}\"></span></div></div></div>\n</div></div></div>");
$templateCache.put("app/main/apps/media/views/list/subviews/tiny-attached.html","<div class=\"content-wrapper\" flex layout=\"row\"><div class=\"mail-tabs-grid\" flex \nmd-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"content mail-list-pane-grid\" flex><div \nng-repeat=\"item in vm.selectedContacts\" class=\"ms-card\" flex><div class=\"ms-card-content-wrapper\" \nng-if=\"item.media_type == 1\"><div class=\"template-9\"><div class=\"media\" flex layout=\"row\" layout-align=\"center center\">\n<img ng-src=\"{{item.cropstatus[0].container.view_url}}{{item.cropstatus[0].fileName}}\" class=\"image\"></div><div \nclass=\"header p-16\" flex><div layout=\"row\" layout-align=\"space-between center\" flex><div class=\"size block\" \nlayout=\"row\" layout-align=\"start left\"><strong class=\"mr-5\">#{{item.id_media}}</strong> <span class=\"grey-500-fg\"><span\n ng-if=\"item.filename\">{{item.filename}}</span></span></div><md-button ng-click=\"vm.selectMediaTiny(item)\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Select\" translate=\"CONTENT.SELECT\" \ntranslate-attr-aria-label=\"CONTENT.SELECT\">SELECT</md-button></div></div></div></div><div \nclass=\"ms-card-content-wrapper\" ng-if=\"item.media_type == 2\"><div class=\"template-9\"><div class=\"media\" flex \nlayout=\"row\" layout-align=\"center center\"><img ng-src=\"{{item.embed_thumb}}\" class=\"image\"></div><div \nclass=\"header p-16\" flex><div layout=\"row\" layout-align=\"space-between center\" flex><div class=\"size block\" \nlayout=\"row\" layout-align=\"start left\"><strong class=\"mr-5\">#{{item.id_media}}</strong> <span class=\"grey-500-fg\"><span\n ng-if=\"item.filename\">{{item.filename}}</span> <span ng-if=\"item.title\">{{item.title}}</span></span></div><md-button \nng-click=\"vm.selectMediaTiny(item)\" class=\"send-button md-accent md-raised\" aria-label=\"Select\" \ntranslate=\"CONTENT.SELECT\" translate-attr-aria-label=\"CONTENT.SELECT\">SELECT</md-button></div></div></div></div></div>\n</div></div></div>");
$templateCache.put("app/main/apps/media/views/list/subviews/tiny-properties.html","<div class=\"ontent-wrapper\" flex=\"\" layout=\"column\"><div class=\"content\"><div class=\"ms-card\" flex><div \nclass=\"ms-card-content-wrapper\"><div class=\"template-9\"><div class=\"media\" flex layout=\"row\" \nlayout-align=\"center center\" ng-if=\"vm.selectedMediaTiny.media_type == 1\"><img \nng-src=\"{{vm.selectedMediaTiny.cropstatus[0].container.view_url}}{{vm.selectedMediaTiny.cropstatus[0].fileName}}\" \nclass=\"image\"></div><div class=\"media\" flex layout=\"row\" layout-align=\"center center\" \nng-if=\"vm.selectedMediaTiny.media_type == 2\"><img ng-src=\"{{vm.selectedMediaTiny.embed_thumb}}\" class=\"image\"></div>\n<div class=\"header p-16\" flex><div layout=\"row\" layout-align=\"space-between center\" flex><div class=\"size block\" \nlayout=\"row\" layout-align=\"start left\"><strong class=\"mr-5\">#{{vm.selectedMediaTiny.id_media}}</strong> <span \nclass=\"grey-500-fg\"><span ng-if=\"vm.selectedMediaTiny.filename\">{{vm.selectedMediaTiny.filename}}</span></span></div>\n</div></div></div></div></div><div class=\"sections white-box\"><div class=\"section\"><md-input-container \nclass=\"md-block\" flex><label translate=\"CONTENT.ALIGN\" translate-attr-aria-label=\"CONTENT.ALIGN\">Align:</label>\n<md-select ng-model=\"vm.tinyProperties.align\" placeholder=\"Align\"><md-option value=\"\">---</md-option><md-option \nng-repeat=\"opt in vm.tinyOptions.align\" value=\"{{opt.value}}\">{{opt.text}}</md-option></md-select><div \nclass=\"md-errors-spacer\"></div></md-input-container><md-input-container class=\"md-block\" flex><label \ntranslate=\"CONTENT.SIZE\" translate-attr-aria-label=\"CONTENT.SIZE\">Size:</label><md-select \nng-model=\"vm.tinyProperties.size\" placeholder=\"Size\"><md-option value=\"\">---</md-option><md-option \nng-repeat=\"opt in vm.tinyOptions.size\" value=\"{{opt.value}}\">{{opt.text}}</md-option></md-select><div \nclass=\"md-errors-spacer\"></div></md-input-container></div></div></div></div>");
$templateCache.put("app/main/apps/media/views/list/subviews/upload-view.html","<div class=\"content-wrapper\" flex=\"\" layout=\"column\"><div class=\"content\"><div ngf-drop ngf-select ng-model=\"vm.files\" \nclass=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"true\" ngf-allow-dir=\"true\" \naccept=\"video/*,image/*,application/pdf\" ngf-pattern=\"\'video/*,image/*,application/pdf\'\"><div layout=\"column\"><div \nflex>Drop here or click to upload</div><div flex>or</div><div flex><md-button class=\"send-button md-accent md-raised\" \naria-label=\"Select files\">Select Files from your computer</md-button></div></div></div><div ngf-no-file-drop>\nFile Drag/Drop is not supported for this browser</div><div ng-repeat=\"f in vm.files\" class=\"ms-card\" flex><div \nclass=\"ms-card-content-wrapper\"><div class=\"template-9\"><div class=\"media\" flex layout=\"row\" \nlayout-align=\"center center\"><img ngf-thumbnail=\"!f.$error && f\" class=\"image\"></div><div class=\"header p-16\" flex><div\n layout=\"row\" layout-align=\"space-between center\" flex><div class=\"size\" layout=\"row\" layout-align=\"start left\"><strong\n class=\"mr-5\" ng-if=\"f.id\">#{{f.id}}</strong> <span class=\"grey-500-fg\"><span ng-if=\"f.name\">{{f.name}}</span></span>\n</div></div></div><md-progress-linear md-mode=\"determinate\" value=\"{{f.progress}}\" ng-show=\"f.progress < 100\">\n</md-progress-linear></div></div></div><md-list-item class=\"file-name-item md-white-bg\" md-ink-ripple \nng-repeat=\"f in vm.files\"><p class=\"text-truncate font-weight-600\">{{f.name}} {{f.$error}} {{f.$errorParam}}</p>\n</md-list-item>Upload Log:<pre>{{log}}</pre></div></div>");
$templateCache.put("app/main/apps/media/views/list/subviews/videos-view.html","<div class=\"ms-card-content-wrapper\"><div class=\"template-9\"><div class=\"media\" flex layout=\"row\" \nlayout-align=\"center center\"><media attachment=\"mediaItem\" class-img=\"image\"></media></div><div class=\"header p-16\" \nflex><div layout=\"row\" layout-align=\"space-between center\" flex><div class=\"size block mr-5\" layout=\"row\" \nlayout-align=\"start left\"><strong class=\"mr-5\">#{{mediaItem.id_media}} <span ng-if=\"mediaItem.duration\"><md-icon \nmd-font-icon=\"icon-clock\" class=\"s16 text-right\" aria-hidden=\"true\"></md-icon>\n{{(mediaItem.duration*1000) | amDateFormat:\'mm:ss\'}} </span></strong><span class=\"grey-500-fg word-break-all\" \nng-if=\"mediaItem.filename\"><span>{{mediaItem.filename}}</span> </span><span class=\"grey-500-fg word-break-word\" \nng-if=\"mediaItem.title\"><span>{{mediaItem.title}}</span></span></div><md-checkbox \nng-checked=\"vm.isSelected(mediaItem)\" ng-click=\"vm.toggleSelectThread(mediaItem, $event)\" \naria-label=\"{{vm.isSelected(mediaItem) ? \'Deselect\' : \'Select\'}}\" class=\"ml-5\"></md-checkbox></div></div></div></div>");
$templateCache.put("app/main/apps/mediahub/dialogs/add-media-galleries/views/add-media-galleries.html","<md-toolbar class=\"md-default-theme grey-100-bg grey-600-fg pr-16 pl-16\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\"><label for=\"search-bar-input\"><md-icon ng-if=\"!vm.treeSearch\" \nmd-font-icon=\"icon-magnify\" class=\"grey-600-fg md-icon-button md-button search\"><md-tooltip hide show-gt-xs><span \ntranslate=\"TOOLBAR.SEARCH\">Search</span></md-tooltip></md-icon><md-icon layout-align=\"end center\" \nmd-font-icon=\"icon-close-circle\" class=\"grey-600-fg md-icon-button md-button\" ng-if=\"vm.treeSearch\" \nng-click=\"vm.treeSearch = null\"></md-icon></label><input type=\"text\" id=\"search-bar-input\" \nclass=\"grey-600-fg grey-100-bg\" ng-model=\"vm.treeSearch\" placeholder=\"Search\" md-autofocus translate \ntranslate-attr-placeholder=\"TOOLBAR.SEARCH\" flex></div></md-toolbar><md-content ms-scroll class=\"\" flex><div flex \nlayout=\"column\" layout-align=\"center center\" ng-show=\"vm.isLoading\" class=\"loading-container\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nclass=\"navigation-simple groups-tree pt-20 pb-20\" layout=\"column\" ng-style=\"{\'opacity\' : vm.isLoading ? 0.2 : 1}\"><div \nng-if=\"vm.CleanMediaGalleries\" ivh-treeview=\"vm.CleanMediaGalleries\" ivh-treeview-label-attribute=\"\'name\'\" \nivh-treeview-filter=\"vm.treeSearch\" ivh-treeview-expand-to-depth=\"0\" class=\"ivh-treeview-folder small\"><script \ntype=\"text/ng-template\">\n<div class=\"level-card p-8 gallery-row\" layout=\"row\" layout-align=\"space-between stretch\">\r\n                    <span ivh-treeview-twistie ivh-treeview-toggle layout=\"row\" layout-align=\"center center\"></span>\r\n                    <div flex layout=\"row\" layout-align=\"start center\">\r\n                        <md-icon\r\n                            ng-if=\"!node.children && node.gallery_type == 0\"\r\n                            md-font-icon=\"icon-folder\"\r\n                            class=\"s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon\r\n                            ng-if=\"!node.children && node.gallery_type == 1\"\r\n                            md-font-icon=\"icon-folder-image\"\r\n                            class=\"s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon\r\n                            ng-if=\"!node.children && node.gallery_type == 2\"\r\n                            md-font-icon=\"qiu-icon-video-folder\"\r\n                            class=\"s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon\r\n                            ng-if=\"!node.children && node.gallery_type == 3\"\r\n                            md-font-icon=\"qiu-icon-audio-folder\"\r\n                            class=\"s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon\r\n                            ng-if=\"!node.children && node.gallery_type == 4\" \r\n                            md-font-icon=\"qiu-icon-file-folder\"\r\n                            class=\"s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon\r\n                            ng-if=\"node.children && node.gallery_type == 0\"\r\n                            md-font-icon=\"icon-folder-multiple\"\r\n                            class=\"s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon\r\n                            ng-if=\"node.children && node.gallery_type == 1\"\r\n                            md-font-icon=\"icon-folder-multiple-image\"\r\n                            class=\"s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon\r\n                            ng-if=\"node.children && node.gallery_type == 2\"\r\n                            md-font-icon=\"qiu-icon-video-gallery\"\r\n                            class=\"s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon\r\n                            ng-if=\"node.children && node.gallery_type == 3\"\r\n                            md-font-icon=\"qiu-icon-audio-gallery\"\r\n                            class=\"s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <md-icon\r\n                            ng-if=\"node.children && node.gallery_type == 4\"\r\n                            md-font-icon=\"qiu-icon-file-gallery\"\r\n                            class=\"s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                            aria-hidden=\"true\" >\r\n                        </md-icon>\r\n                        <span class=\"ivh-treeview-node-label ng-binding\">{{node.name}}</span>\r\n\r\n                    </div>\r\n                    <div layout=\"row\" layout-align=\"end center\">\r\n                        <md-checkbox\r\n                            ng-disabled=\"node.is_qiu_restricted_root || node.no_files_allowed\"\r\n                            ng-checked=\"node.assigned_gallery\"\r\n                            class=\"ml-5 mb-0\"\r\n                            aria-label=\"{{node.assigned_gallery ? \'Deselect\' : \'Select\'}}\"\r\n                            ng-click=\"node.assigned_gallery = !node.assigned_gallery\"\r\n                        ></md-checkbox>\r\n                    </div>\r\n                </div>\r\n                <div ivh-treeview-children></div>\n</script></div></div></md-content>");
$templateCache.put("app/main/apps/mediahub/dialogs/media-show/views/fotorama-view-with-tags.html","<div class=\"content-wrapper\" flex layout=\"row\"><div class=\"mail-tabs-grid\" flex \nmd-dynamic-height=\"{{vm.dynamicHeight}}\"><div id=\"tags-to-show\"><p ng-repeat=\"tag in vm.tagsToShow\">{{tag}}</p></div>\n<div id=\"tags-to-edit\" ng-if=\"vm.showTagsEdit\"><div flex=\"100\" class=\"tags\"><md-input-container \nclass=\"md-block tags-to-edit-container\"><label translate=\"GLOBAL.SEARCH_FOR_TAG\">Tags</label><md-chips \nclass=\"label-chips close-chip\" ng-model=\"vm.currentItem.tags\" md-autocomplete-snap md-require-match=\"true\">\n<md-autocomplete md-min-length=\"1\" md-selected-item=\"vm.selectedTag\" md-selected-item-change=\"vm.selectedItemChange()\" \nmd-search-text=\"vm.searchTagText\" md-items=\"tag in vm.labelQuerySearch(vm.searchTagText) | orderBy:\'-order\'\" \nmd-item-text=\"tag.tag_name\" md-no-cache=\"true\" placeholder=\"{{vm.translate(\'GLOBAL.SEARCH_FOR_TAG\')}}\" \nng-model-options=\"{debounce: 500}\" md-dropdown-items=\"10\"><div layout=\"row\" layout-align=\"space-between center\" \nflex=\"100\" class=\"tag-not-found-bg border-bottom\"><span ng-if=\"!tag.tag_name\">{{vm.searchTagText}}</span> <span \nmd-highlight-text=\"vm.searchTagText\" ng-if=\"tag.tag_name\">{{tag.tag_name}}</span></div></md-autocomplete>\n<md-chip-template><div class=\"md-chip-content\"><span ng-if=\"$chip.color\" class=\"color\" \nng-style=\"{\'background-color\':$chip.color}\"></span> <span>{{$chip.tag_name}} #{{$chip.id_tag}}</span></div>\n</md-chip-template><button md-chip-remove class=\"md-primary\" layout=\"row\" layout-align=\"center center\" \nng-click=\"vm.removeTag(vm.currentItem, $chip, $event)\"><md-icon md-font-icon=\"icon-close\"></md-icon></button>\n</md-chips></md-input-container></div></div><fotorama options=\"vm.fotoramaoptions\" items=\"vm.dataFotorama\" \nid=\"fotorama\" class=\"fotorama\"></fotorama></div></div>");
$templateCache.put("app/main/apps/mediahub/dialogs/media-show/views/fotorama-view.html","<div class=\"content-wrapper\" flex layout=\"row\"><div class=\"mail-tabs-grid\" flex \nmd-dynamic-height=\"{{vm.dynamicHeight}}\"><fotorama options=\"vm.fotoramaoptions\" items=\"vm.dataFotorama\" id=\"fotorama\">\n</fotorama></div></div>");
$templateCache.put("app/main/apps/mediahub/dialogs/media/views/audios-view.html","<div class=\"content-wrapper\" flex=\"\" layout=\"row\"><div class=\"mail-tabs-grid\" flex \nmd-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"content mail-list-pane-grid\" flex ms-scroll><div \nng-repeat=\"item in vm.items\" class=\"ms-card\" flex><div class=\"ms-card-content-wrapper\"><div class=\"template-9\"><div \nclass=\"media\" flex layout=\"row\" layout-align=\"center center\"><div flex layout=\"column\" layout-align=\"center center\" \nclass=\"media\"><qiu-icon mediafile=\"item.filename\"></qiu-icon><br><span class=\"grey-500-fg\" layout=\"column\" \nlayout-align=\"center center\"><span ng-if=\"item.title\"><strong>{{item.title}}</strong></span> <span \nng-if=\"item.filename\">{{item.filename}}</span></span></div></div><div class=\"header p-16\" flex><div layout=\"row\" \nlayout-align=\"space-between center\" flex><div class=\"size block\" layout=\"row\" layout-align=\"start left\"><strong \nclass=\"mr-5\">#{{item.id_media}}</strong> <span class=\"grey-500-fg\"><span ng-if=\"item.date_uploaded\">\n{{item.date_uploaded}}</span></span></div><md-checkbox \nng-checked=\"vm.alreadySelectedbyZone(vm.selectedContacts, item)\" ng-click=\"vm.toggleSelectContact(item, $event)\" \naria-label=\"{{vm.alreadySelectedbyZone(vm.selectedContacts, item) ? \'Deselect\' : \'Select\'}}\" class=\"ml-5\">\n</md-checkbox></div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/apps/mediahub/dialogs/media/views/files-view.html","<div class=\"content-wrapper\" flex=\"\" layout=\"row\"><div class=\"mail-tabs-grid\" flex=\"\"><div \nclass=\"content mail-list-pane-grid\" flex=\"\" ms-scroll=\"\"><div ng-repeat=\"photo in vm.items\" class=\"ms-card\" flex><div \nclass=\"ms-card-content-wrapper\"><div class=\"template-9\"><div class=\"media\" flex layout=\"row\" \nlayout-align=\"center center\"><div flex layout=\"column\" layout-align=\"center center\" class=\"media\"><qiu-icon \nmediafile=\"photo.filename\"></qiu-icon><br><span class=\"grey-500-fg\" layout=\"column\" layout-align=\"center center\"><span \nng-if=\"photo.title\"><strong>{{photo.title}}</strong></span> <span ng-if=\"photo.filename\">{{photo.filename}}</span>\n</span></div></div><div class=\"header p-16\" flex><div layout=\"row\" layout-align=\"space-between center\" flex><div \nclass=\"size text-truncate\" layout=\"row\" layout-align=\"start left\"><strong class=\"mr-5\">#{{photo.id_media}}</strong>\n</div><md-checkbox ng-checked=\"vm.alreadySelectedbyZone(vm.selectedContacts, photo)\" \nng-click=\"vm.toggleSelectContact(photo, $event)\" \naria-label=\"{{vm.alreadySelectedbyZone(vm.selectedContacts, photo) ? \'Deselect\' : \'Select\'}}\" class=\"ml-5\">\n</md-checkbox></div><md-tooltip md-direction=\"top\" hide show-gt-xs ng-if=\"photo.filename\"><span>{{photo.filename}}\n</span></md-tooltip></div></div></div></div></div></div></div><div layout=\"column\" layout-align=\"center center\"></div>");
$templateCache.put("app/main/apps/mediahub/dialogs/media/views/import-view.html","<div class=\"content-wrapper\" flex layout=\"column\"><div class=\"content\"><div class=\"drop-box\"><md-input-container \nclass=\"md-block\"><label translate=\"MEDIA.PASTE_URL_HERE\"></label><input type=\"text\" name=\"import_field\" \nng-model=\"vm.import_field\" placeholder=\"{{vm.translate(\'MEDIA.PASTE_URL_HERE\')}}\" ng-disabled=\"vm.import_disabled\">\n</md-input-container><div ng-if=\"vm.imported\" class=\"alert-message success-message\" translate=\"CONTENT.SUCCESSIMPORT\">\nImported successfully</div></div><treasure-overlay-spinner active=\"vm.importing\"><div layout=\"row\" \nlayout-align=\"center start\" ng-if=\"vm.importPreview\" class=\"white-box sections\"><div flex-gt-sm=\"50\" flex=\"100\"><div \nclass=\"section\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><span class=\"section-title\">\nPREVIEW</span></div><div class=\"media\" flex layout=\"row\" layout-align=\"center center\" \nng-bind-html=\"vm.importPreview.embedCodeSafe\"></div></div><div class=\"header p-16\" flex><div layout=\"row\" \nlayout-align=\"space-between center\" flex><div class=\"size text-truncate\" layout=\"row\" layout-align=\"start left\"><span \nclass=\"grey-500-fg\"><span ng-if=\"vm.importPreview.title\">Title: {{vm.importPreview.title}}</span></span></div></div>\n<div layout=\"row\" layout-align=\"space-between center\" flex><div class=\"size\" layout=\"row\" layout-align=\"start left\">\n<span class=\"grey-500-fg\"><span ng-if=\"vm.importPreview.caption\">Description: {{vm.importPreview.caption}}</span>\n</span></div></div></div><md-button class=\"send-button md-accent md-raised\" ng-click=\"vm.importConfirm(1)\" \ntranslate=\"CONTENT.IMPORT\">Import</md-button></div></div><div ng-repeat=\"f in vm.importedFiles\" class=\"ms-card\" flex>\n<div class=\"ms-card-content-wrapper\"><div class=\"template-9\"><div class=\"media\" flex layout=\"row\" \nlayout-align=\"center center\"><img ng-src=\"{{f.embed_thumb}}\" class=\"image\"></div><div class=\"header p-16\" flex><div \nlayout=\"row\" layout-align=\"space-between center\" flex><div class=\"size block\" layout=\"row\" layout-align=\"start left\">\n<strong class=\"mr-5\">#{{f.id_media}}</strong> <span class=\"grey-500-fg\"><span ng-if=\"f.filename\">{{f.filename}}</span> \n<span ng-if=\"f.title\">{{f.title}}</span></span></div><md-checkbox \nng-checked=\"vm.alreadySelectedbyZone(vm.selectedContacts, f)\" ng-click=\"vm.toggleSelectContact(f, $event)\" \naria-label=\"{{vm.alreadySelectedbyZone(vm.selectedContacts, f) ? \'Deselect\' : \'Select\'}}\"></md-checkbox></div></div>\n</div></div></div></treasure-overlay-spinner></div></div>");
$templateCache.put("app/main/apps/mediahub/dialogs/media/views/photos-view.html","<div class=\"content-wrapper\" flex layout=\"row\"><div class=\"mail-tabs-grid\" flex \nmd-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"content mail-list-pane-grid\" flex><div \nng-repeat=\"photo in vm.items\" class=\"ms-card\" flex><div class=\"ms-card-content-wrapper\"><div class=\"template-9\"><div \nclass=\"media\" flex layout=\"row\" layout-align=\"center center\"><img \nng-src=\"{{photo.cropstatus[0].container.view_url}}{{photo.cropstatus[0].fileName}}\" class=\"image\"></div><div \nclass=\"header p-16\" flex><div layout=\"row\" layout-align=\"space-between center\" flex><div class=\"size block\" \nlayout=\"row\" layout-align=\"start left\"><strong class=\"mr-5\">#{{photo.id_media}}</strong> <span class=\"grey-500-fg\">\n<span ng-if=\"photo.filename\">{{photo.filename}}</span></span></div><md-checkbox \nng-checked=\"vm.alreadySelectedbyZone(vm.selectedContacts, photo)\" ng-click=\"vm.toggleSelectContact(photo, $event)\" \naria-label=\"{{vm.alreadySelectedbyZone(vm.selectedContacts, photo) ? \'Deselect\' : \'Select\'}}\" class=\"ml-5\">\n</md-checkbox></div><md-tooltip md-direction=\"top\" hide show-gt-xs ng-if=\"photo.filename\"><span>{{photo.filename}}\n</span></md-tooltip></div></div></div></div></div></div></div>");
$templateCache.put("app/main/apps/mediahub/dialogs/media/views/template-grid.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"space-between center\" flex><div \nlayout=\"column\" layout-align=\"start center\"><md-checkbox class=\"no-label\" ng-checked=\"vm.isChecked(mail)\" \nng-click=\"vm.toggleCheck(mail, $event)\" aria-label=\"{{vm.isChecked(mail)? \'Uncheck\':\'check\'}}\"></md-checkbox><div \nng-if=\"refcolumnsgrouped.main\"><div class=\"subject text-truncate\"><span \nng-repeat=\"field in refcolumnsgrouped.header | orderBy: \'list-sort\'\" ng-bind=\"thread.{{field.titleId}}\"></span></div>\n</div></div><div layout=\"column\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-attachment\" \nclass=\"has-attachment s24\" ng-if=\"thread.Thumbnail.length>0\"></md-icon><button ng-if=\"thread.onoff===1\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\"></md-icon></button> \n<button ng-if=\"thread.onoff!==1\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-blank-circle-outline\" \nclass=\"off red-fg s24\"></md-icon></button></div></div><div class=\"media\" flex layout=\"row\" \nlayout-align=\"center center\"><img class=\"image\" ng-src=\"{{card.Thumbnail[0].crop_status[0].urlformed}}\" \nalt=\"{{card.media.image.alt}}\" imageonloadcontrol></div><div class=\"header p-16\" layout=\"row\" layout-align=\"start\"><div\n class=\"info\"><div ng-if=\"refcolumnsgrouped.main\"><div class=\"name text-truncate\" layout=\"row\" \nlayout-align=\"start center\"><span ng-repeat=\"field in refcolumnsgrouped.main\"><span ng-bind=\"thread.{{field.titleId}}\">\n</span>&nbsp;</span></div></div><div ng-repeat=\"field in refcolumnsgrouped.secondary | orderBy:\'list_sort\'\"><div \nng-if=\"(field.type!==\'date\' && field.type!==\'dateHm\') && field.primary!==1\" class=\"details\" layout=\"row\" \nlayout-align=\"start start\"><div layout=\"column\"><span class=\"title\" ng-bind=\"field.title\"></span></div><div \nlayout=\"column\" class=\"text-truncate\"><span class=\"detail\" ng-bind=\"thread.{{field.titleId}}\"></span></div></div></div>\n</div></div></div>");
$templateCache.put("app/main/apps/mediahub/dialogs/media/views/tiny-attached.html","<div class=\"content-wrapper\" flex layout=\"row\"><div class=\"mail-tabs-grid\" flex \nmd-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"content mail-list-pane-grid\" flex><div \nng-repeat=\"item in vm.selectedContacts\" class=\"ms-card\" flex><div class=\"ms-card-content-wrapper\" \nng-if=\"item.media_type == 1\"><div class=\"template-9\"><div class=\"media\" flex layout=\"row\" layout-align=\"center center\">\n<img ng-src=\"{{item.cropstatus[0].container.view_url}}{{item.cropstatus[0].fileName}}\" class=\"image\"></div><div \nclass=\"header p-16\" flex><div layout=\"row\" layout-align=\"space-between center\" flex><div class=\"size block\" \nlayout=\"row\" layout-align=\"start left\"><strong class=\"mr-5\">#{{item.id_media}}</strong> <span class=\"grey-500-fg\"><span\n ng-if=\"item.filename\">{{item.filename}}</span></span></div><md-button ng-click=\"vm.selectMediaTiny(item)\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Select\" translate=\"CONTENT.SELECT\" \ntranslate-attr-aria-label=\"CONTENT.SELECT\">SELECT</md-button></div></div></div></div><div \nclass=\"ms-card-content-wrapper\" ng-if=\"item.media_type == 2\"><div class=\"template-9\"><div class=\"media\" flex \nlayout=\"row\" layout-align=\"center center\"><img ng-src=\"{{item.embed_thumb}}\" class=\"image\"></div><div \nclass=\"header p-16\" flex><div layout=\"row\" layout-align=\"space-between center\" flex><div class=\"size block\" \nlayout=\"row\" layout-align=\"start left\"><strong class=\"mr-5\">#{{item.id_media}}</strong> <span class=\"grey-500-fg\"><span\n ng-if=\"item.filename\">{{item.filename}}</span> <span ng-if=\"item.title\">{{item.title}}</span></span></div><md-button \nng-click=\"vm.selectMediaTiny(item)\" class=\"send-button md-accent md-raised\" aria-label=\"Select\" \ntranslate=\"CONTENT.SELECT\" translate-attr-aria-label=\"CONTENT.SELECT\">SELECT</md-button></div></div></div></div></div>\n</div></div></div>");
$templateCache.put("app/main/apps/mediahub/dialogs/media/views/tiny-properties.html","<div class=\"ontent-wrapper\" flex=\"\" layout=\"column\"><div class=\"content\"><div class=\"ms-card\" flex><div \nclass=\"ms-card-content-wrapper\"><div class=\"template-9\"><div class=\"media\" flex layout=\"row\" \nlayout-align=\"center center\" ng-if=\"vm.selectedMediaTiny.media_type == 1\"><img \nng-src=\"{{vm.selectedMediaTiny.cropstatus[0].container.view_url}}{{vm.selectedMediaTiny.cropstatus[0].fileName}}\" \nclass=\"image\"></div><div class=\"media\" flex layout=\"row\" layout-align=\"center center\" \nng-if=\"vm.selectedMediaTiny.media_type == 2\"><img ng-src=\"{{vm.selectedMediaTiny.embed_thumb}}\" class=\"image\"></div>\n<div class=\"header p-16\" flex><div layout=\"row\" layout-align=\"space-between center\" flex><div class=\"size block\" \nlayout=\"row\" layout-align=\"start left\"><strong class=\"mr-5\">#{{vm.selectedMediaTiny.id_media}}</strong> <span \nclass=\"grey-500-fg\"><span ng-if=\"vm.selectedMediaTiny.filename\">{{vm.selectedMediaTiny.filename}}</span></span></div>\n</div></div></div></div></div><div class=\"sections white-box\"><div class=\"section\"><md-input-container \nclass=\"md-block\" flex><label translate=\"CONTENT.ALIGN\" translate-attr-aria-label=\"CONTENT.ALIGN\">Align:</label>\n<md-select ng-model=\"vm.tinyProperties.align\" placeholder=\"Align\"><md-option value=\"\">---</md-option><md-option \nng-repeat=\"opt in vm.tinyOptions.align\" value=\"{{opt.value}}\">{{opt.text}}</md-option></md-select><div \nclass=\"md-errors-spacer\"></div></md-input-container><md-input-container class=\"md-block\" flex><label \ntranslate=\"CONTENT.SIZE\" translate-attr-aria-label=\"CONTENT.SIZE\">Size:</label><md-select \nng-model=\"vm.tinyProperties.size\" placeholder=\"Size\"><md-option value=\"\">---</md-option><md-option \nng-repeat=\"opt in vm.tinyOptions.size\" value=\"{{opt.value}}\">{{opt.text}}</md-option></md-select><div \nclass=\"md-errors-spacer\"></div></md-input-container></div></div></div></div>");
$templateCache.put("app/main/apps/mediahub/dialogs/media/views/upload-view.html","<div class=\"content-wrapper\" flex=\"\" layout=\"column\"><div class=\"content\"><div ngf-drop ngf-select ng-model=\"vm.files\" \nclass=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"true\" ngf-allow-dir=\"true\" \naccept=\"video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz,.json,.xml,.csv,.ttf,.eps,.ai,.psd,.aep,.indd,.idll,.heic,.mkv,.gpx\" \nngf-pattern=\"\'video/*,image/*,application/pdf,audio/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.tgz,.json,.xml,.csv,.ttf,.eps,.ai,.psd,.aep,.indd,.idll,.heic,.mkv,.gpx\'\">\n<div layout=\"column\"><div flex>Drop here or click to upload</div><div flex>or</div><div flex><md-button \nclass=\"send-button md-accent md-raised\" aria-label=\"Select files\">Select Files from your computer</md-button></div>\n</div></div><div ngf-no-file-drop>File Drag/Drop is not supported for this browser</div><div \nng-repeat=\"f in vm.uploadFiles\" class=\"ms-card\" flex><div class=\"ms-card-content-wrapper\"><div class=\"template-9\"><div \nclass=\"media\" flex layout=\"row\" layout-align=\"center center\"><img ngf-thumbnail=\"!f.$error && f\" class=\"image\"></div>\n<div class=\"header p-16\" flex><div layout=\"row\" layout-align=\"space-between center\" flex><div class=\"size\" \nlayout=\"row\" layout-align=\"start left\"><strong class=\"mr-5\" ng-if=\"f.id\">#{{f.id}}</strong> <span class=\"grey-500-fg\">\n<span ng-if=\"f.name\">{{f.name}}</span></span></div></div></div><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{f.progress}}\" ng-show=\"f.progress < 100 && !f.processed\"></md-progress-linear></div></div></div><md-list-item \nclass=\"file-name-item md-white-bg\" md-ink-ripple ng-repeat=\"f in vm.uploadFiles\"><p \nclass=\"text-truncate font-weight-600\">{{f.name}} {{f.$error}} {{f.$errorParam}}</p></md-list-item>Upload Log:<pre>\n{{log}}</pre></div></div>");
$templateCache.put("app/main/apps/mediahub/dialogs/media/views/videos-view.html","<div class=\"content-wrapper\" flex layout=\"row\"><div class=\"mail-tabs-grid\" flex><div \nclass=\"content mail-list-pane-grid\" flex><div ng-repeat=\"item in vm.items\" class=\"ms-card\" flex><div \nclass=\"ms-card-content-wrapper\"><div class=\"template-9\"><div class=\"media\" flex layout=\"row\" \nlayout-align=\"center center\"><img ng-src=\"{{item.embed_thumb}}\" class=\"image\" ng-if=\"item.media_children.length===0\"> \n<img \nng-src=\"{{item.media_children[0].cropstatus[0].container.view_url}}{{item.media_children[0].cropstatus[0].fileName}}\" \nng-if=\"item.media_children!==undefined\" class=\"image\"></div><div class=\"header p-16\" flex><div layout=\"row\" \nlayout-align=\"space-between center\" flex><div class=\"size block\" layout=\"row\" layout-align=\"start left\"><strong \nclass=\"mr-5\">#{{item.id_media}}</strong> <span class=\"grey-500-fg\"><span ng-if=\"item.filename\">{{item.filename}}</span>\n <span ng-if=\"item.title\">{{item.title}}</span></span></div><md-checkbox \nng-checked=\"vm.alreadySelectedbyZone(vm.selectedContacts, item)\" ng-click=\"vm.toggleSelectContact(item, $event)\" \naria-label=\"{{vm.alreadySelectedbyZone(vm.selectedContacts, item) ? \'Deselect\' : \'Select\'}}\"></md-checkbox></div>\n<md-tooltip md-direction=\"top\" hide show-gt-xs ng-if=\"item.title\"><span>{{item.title}}</span></md-tooltip></div></div>\n</div></div></div></div></div>");
$templateCache.put("app/main/apps/runtag/commercial/views/templates/commercial-template-v2.html","<div id=\"rs-full-container\" class=\"pb-50 commercial-v2\"><div ng-if=\"!vm.yearsLoaded\" \nclass=\"loading-years-container mt-10\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"30\">\n</md-progress-circular></div><div ng-if=\"vm.yearsLoaded\" class=\"calendar-selector mt-20\"><button \nng-click=\"vm.toggleCalendar()\" class=\"calendar-button\"><span class=\"material-symbols-outlined\">calendar_month </span>\n<span>{{ (\'RUNTAG.MONTHS.\' + vm.selectedMonth.name) | translate }}</span></button><div class=\"calendar-dropdown\" \nng-show=\"vm.calendarOpen\"><div class=\"year-selector\"><label translate=\"RUNTAG.SELECT_YEAR\"></label><ul><li \nng-repeat=\"year in vm.years | keys\" ng-class=\"{\'selected\': vm.selectedYear == year}\" ng-click=\"vm.selectYear(year)\">\n{{ year }}</li></ul></div><div class=\"month-selector\"><label translate=\"RUNTAG.SELECT_MONTH\"></label><ul><li \nng-repeat=\"month in vm.years[vm.selectedYear]\" \nng-class=\"{\'disabled\': month.disabled, \'selected\': vm.selectedMonth === month}\" \nng-click=\"!month.disabled && vm.selectMonth(month)\">{{ \'RUNTAG.MONTHS.\' + month.name | translate }}</li></ul></div>\n</div></div><header ng-if=\"vm.yearsLoaded\" id=\"rs-full-header\" class=\"mt-10 mb-10\"><md-input-container><md-select \nplaceholder=\"{{\'RUNTAG.SELECT_CLIENT\' | translate}}\" ng-model=\"vm.selectedClient\" \nng-change=\"vm.filterClientsAndEvents()\"><md-select-header class=\"rs-select-header\" layout=\"row\"><span \nclass=\"material-symbols-outlined\">search </span><input ng-model=\"vm.clientSearch\" type=\"search\" \nonkeydown=\"event.stopPropagation()\" class=\"md-text\" aria-label=\"search client\"></md-select-header><md-option \nng-value=\"client.id_clients\" ng-repeat=\"client in vm.filteredClients | filter:vm.clientSearch\" \nng-bind-html=\"client.client_name\"></md-option></md-select><span ng-if=\"vm.selectedClient\" \nng-click=\"vm.filterClientsAndEvents(\'selectedClient\')\" class=\"material-symbols-outlined cancel\">cancel</span>\n</md-input-container><div class=\"empty\"></div><md-input-container><md-select \nplaceholder=\"{{\'RUNTAG.SELECT_AN_EVENT\' | translate}}\" ng-model=\"vm.selectedEvent\" \nng-change=\"vm.filterClientsAndEvents()\"><md-select-header class=\"rs-select-header\" layout=\"row\"><span \nclass=\"material-symbols-outlined\">search </span><input ng-model=\"vm.eventSearch\" type=\"search\" \nonkeydown=\"event.stopPropagation()\" class=\"md-text\" aria-label=\"search event\"></md-select-header><md-option \nng-value=\"event.id_events\" ng-repeat=\"event in vm.filteredEvents | filter:vm.eventSearch\" \nng-bind-html=\"event.event_name\"></md-option></md-select><span ng-if=\"vm.selectedEvent\" \nng-click=\"vm.filterClientsAndEvents(\'selectedEvent\')\" class=\"material-symbols-outlined cancel\">cancel</span>\n</md-input-container></header><div class=\"graphs-container gap-20 mb-50 mt-20\" layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap><div flex=\"100\" flex-gt-sm=\"45\" layout=\"column\" \nclass=\"graph-card commercial\"><div class=\"left\"><div class=\"title-container\"><span \nclass=\"material-symbols-outlined icon\">payments </span><span translate=\"RUNTAG.COMMERCIAL_COMMISSION\" \nclass=\"title text-uppercase\">COMMERCIAL COMMISSION</span></div><div class=\"content-container\"><span class=\"text-xl\">\n{{(vm.totals.payment_breakdown.commercial_commision_payment_due_usd || 0) | number:2}} <span class=\"font-size-14\">USD\n</span></span><md-progress-circular ng-show=\"vm.loadingPayments\" md-mode=\"indeterminate\" md-diameter=\"30\">\n</md-progress-circular></div></div></div><div flex=\"100\" flex-gt-sm=\"45\" layout=\"column\" class=\"graph-card status\"><div\n class=\"left\"><div class=\"title-container\"><span class=\"material-symbols-outlined icon\">trending_up </span><span \ntranslate=\"RUNTAG.TOTAL_SALES_PERIOD\" class=\"title text-uppercase\">TOTAL SALES PERIOD</span></div><div \nclass=\"content-container\"><span class=\"text-xl\">{{(vm.totals.payment_breakdown.total_sales_usd || 0) | number:2}} <span\n class=\"font-size-14\">USD</span></span></div></div></div></div><div class=\"filters-v2-container mb-20\" layout=\"row\" \nlayout-align=\"start center\" layout-wrap><div layout=\"row\" layout-align=\"start center\" flex=\"100\" flex-gt-xs=\"50\">\n<md-icon md-font-icon=\"icon-filter-variant\" class=\"mr-10\"></md-icon><md-input-container \nclass=\"m-0 md-no-underline flex\"><label translate=\"RUNTAG.STATUS\">Status</label><md-select \nng-model=\"vm.paymentSelectedStatus\" ng-change=\"vm.getPaymentBreakdown(true)\" aria-label=\"status filter\"><md-option \ntranslate=\"RUNTAG.VIEW_ALL\" ng-value=\"0\">All</md-option><md-option ng-value=\"status.id_subsec\" \nng-repeat=\"status in vm.sectionOptions.payments_breakdown.subsection\">{{status.subsec}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" layout-align=\"start center\" flex=\"100\" flex-gt-xs=\"50\"><md-icon \nmd-font-icon=\"icon-sort\" class=\"mr-10\"></md-icon><md-input-container class=\"m-0 md-no-underline flex\"><label \ntranslate=\"RUNTAG.ORDER\">Order</label><md-select ng-model=\"vm.paymentSelectedOrder\" \nng-change=\"vm.updatePaymentsPeriods(vm.payments)\" aria-label=\"order by\"><md-option translate=\"RUNTAG.DATE\" \nvalue=\"date\">Date</md-option><md-option translate=\"RUNTAG.EVENT\" value=\"event\">Event</md-option><md-option \ntranslate=\"RUNTAG.STATUS\" value=\"status\">Status</md-option></md-select></md-input-container></div></div><div \nclass=\"tables-container\"><table class=\"mb-50\"><tbody><tr class=\"table-title-head commercial\"><td \nclass=\"table-icon center\"><span class=\"material-symbols-outlined icon\">handshake</span></td><td colspan=\"7\" \nclass=\"left\"><span translate=\"RUNTAG.COMMERCIAL_BREAKDOWN\" class=\"title text-uppercase bold\">COMMERCIAL BREAKDOWN\n</span></td><td class=\"right pd-20\"><md-input-container class=\"m-0 md-no-underline white-text-select\"><md-select \nng-model=\"vm.paymentSelectedPaid\" ng-change=\"vm.getPaymentBreakdown(true)\" placeholder=\"Payment Status\" \naria-label=\"paid status\"><md-option translate=\"RUNTAG.PAID\" value=\"1\">Paid</md-option><md-option \ntranslate=\"RUNTAG.NOT_PAID\" value=\"0\">Not paid</md-option><md-option translate=\"RUNTAG.VIEW_ALL\" value=\"2\">All\n</md-option></md-select></md-input-container></td></tr><tr class=\"table-info-header\"><td></td><td class=\"left\" \ntranslate=\"RUNTAG.EVENT\">EVENT</td><td translate=\"RUNTAG.ORDERS\">ORDERS</td><td translate=\"RUNTAG.TOTAL_SALES\">\nTOTAL SALES</td><td translate=\"RUNTAG.PAYMENT_TO_RUNTAG\">TO RUNTAG</td><td translate=\"RUNTAG.COMMERCIAL_COST_TOTAL\">\nCOMM. COST</td><td translate=\"RUNTAG.SUBTOTAL\">SUBTOTAL</td><td class=\"center\">%</td><td class=\"right\" \ntranslate=\"RUNTAG.COMMERCIAL\">COMMERCIAL</td></tr><tr class=\"table-items-body\" \nng-if=\"vm.getLengthOfObject(vm.paymentPeriods) === 0 && !vm.loadingPayments\"><td colspan=\"9\" \nclass=\"center bold font-size-18 py-40\" translate=\"RUNTAG.NOT_PAYMENTS_BREAKDOWN\">NO PAYMENT BREAKDOWNS FOUND</td></tr>\n<tr ng-repeat-start=\"item in vm.tableArray\" ng-if=\"item.type === \'key\'\" class=\"table-items-body grouped\"><td></td><td \ncolspan=\"8\" class=\"left\"><span class=\"bold color-accent\" ng-if=\"vm.paymentSelectedOrder === \'date\'\">\n{{ item.value.split(\'-\')[0] }} al {{ item.value.split(\'-\')[1] }} </span><span class=\"bold color-accent\" \nng-if=\"vm.paymentSelectedOrder === \'event\'\" ng-bind-html=\"item.value\"></span> <span class=\"bold color-accent\" \nng-if=\"vm.paymentSelectedOrder === \'status\'\">{{ item.value }}</span></td></tr><tr ng-repeat-end \nng-if=\"item.type === \'object\'\" class=\"table-items-body\"><td class=\"center\"><div ng-if=\"item.value.id_subsec != 1\" \nclass=\"pay-check {{vm.checkPays(item.value, \'commercial_payment_date\')}}\"></div><span \nng-if=\"item.value.id_subsec === 1\" class=\"material-symbols-outlined color-warn\">hourglass_empty</span></td><td \nclass=\"left\"><div layout=\"column\"><span class=\"bold\">{{vm.searchEventName(item.value.id_event)}}</span> <span \nclass=\"font-size-12 opacity-60\">{{vm.searchClientName(item.value.id_client)}} / {{item.value.id_event}}</span></div>\n</td><td class=\"center\">{{item.value.orders}}</td><td class=\"center\">{{item.value.total_sales_usd | number:2}} <span \nclass=\"currency-code\">USD</span></td><td class=\"center\">{{item.value.payment_due_usd | number:2}} <span \nclass=\"currency-code\">USD</span></td><td class=\"center\">{{item.value.commercial_cost_total | number:2}} <span \nclass=\"currency-code\">USD</span></td><td class=\"center bold\">{{vm.getSubTotal(item)}} <span class=\"currency-code\">USD\n</span></td><td class=\"center\"><span ng-if=\"vm.getSubTotal(item) >= 0\">{{item.value.commercial_commision_percentage}}%\n</span> <span ng-if=\"vm.getSubTotal(item) < 0\">--</span></td><td class=\"right bold pd-20\">\n{{item.value.commercial_commision_payment_due_usd | number:2}} <span class=\"currency-code\">USD</span></td></tr><tr \nclass=\"table-items-footer\" ng-if=\"vm.morePayments\"><td colspan=\"9\" class=\"p-0\"><div layout=\"row\" \nlayout-align=\"center center\" class=\"py-20 cursor-pointer hover-bg\" ng-click=\"vm.getPaymentBreakdown()\">\n<md-progress-circular ng-if=\"vm.loadingPayments\" md-mode=\"indeterminate\" md-diameter=\"25\"></md-progress-circular><div \nng-if=\"!vm.loadingPayments\" layout=\"row\" layout-align=\"center center\"><span class=\"material-symbols-outlined mr-10\">\nexpand_circle_down</span> <span class=\"text-uppercase bold\" translate=\"RUNTAG.LOAD_MORE\">LOAD MORE</span></div></div>\n</td></tr><tr class=\"table-items-footer\"><td></td><td class=\"left bold\" translate=\"RUNTAG.TOTAL\">TOTAL</td><td \ncolspan=\"6\"></td><td class=\"right bold pd-20 font-size-16\">\n{{vm.totals.payment_breakdown.commercial_commision_payment_due_usd | number:2}} <span class=\"currency-code\">USD</span>\n</td></tr></tbody></table></div></div>");
$templateCache.put("app/main/apps/mediahub/tags/views/list/list-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-show=\"vm.isLoading\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nclass=\"mail-list-item filter-selected\" ng-if=\"vm.filterType || vm.filterVerify || vm.searchQuery\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"info\" flex><div class=\"name\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-filter\" class=\"s20 mr-8 ml-0 mb-0\"></md-icon><div class=\"title text-truncate\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"filter-chip\" ng-if=\"vm.filterType\">{{ vm.filterType }}</span> <span \nclass=\"filter-chip\" ng-if=\"vm.filterVerify === \'true\'\" translate=\"MH_TAGS.VERIFIED\"></span> <span class=\"filter-chip\" \nng-if=\"vm.filterVerify === \'false\'\" translate=\"MH_TAGS.UNVERIFIED\"></span> <span class=\"filter-chip\" \nng-if=\"vm.searchQuery\">\"{{ vm.searchQuery }}\"</span></div></div></div><div class=\"buttons\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-close\" class=\"s20 ml-10\" ng-click=\"vm.resetFilters()\">\n<md-tooltip hide show-gt-xs><span translate=\"MH_TAGS.REMOVE_FILTERS\">Remove filters</span></md-tooltip></md-icon></div>\n</div><div class=\"no-threads\" ng-if=\"!vm.isLoading && vm.filteredCount === 0\"><span ng-if=\"vm.allTags.length\" \ntranslate=\"MH_TAGS.NO_MATCHES\">No tag matches these filters</span> <span ng-if=\"!vm.allTags.length\" \ntranslate=\"MH_TAGS.EMPTY\">There are no tags yet</span></div><div id=\"mh-tags-list-data\" class=\"scrollable\" ms-scroll \nng-class=\"{ \'other-filter\': vm.filterType || vm.filterVerify || vm.searchQuery }\" \nng-style=\"{ \'opacity\': vm.isLoading ? 0.2 : 1 }\" ng-if=\"vm.filteredCount > 0\"><div class=\"mail-list-item\" \nng-repeat=\"thread in vm.visibleTags track by thread.tagName\" ng-click=\"vm.openThread(thread)\" md-no-ink \nng-class=\"{ \'selected\': vm.selectedContent && vm.selectedContent.tagName === thread.tagName, \'checked\': vm.isChecked(thread) }\" \nlayout=\"row\"><div class=\"mail-list-item-content\" layout=\"row\" layout-align=\"start center\"><md-checkbox \nclass=\"no-label\" ng-checked=\"vm.isSelected(thread)\" ng-click=\"vm.toggleSelectThread(thread, $event)\" \naria-label=\"{{ thread.tagName }}\"></md-checkbox><div class=\"info\" flex layout=\"column\"><div \nclass=\"subject text-truncate grey-500-fg\"><span ng-bind=\"thread.tagType || \'—\'\"></span> <span ng-if=\"thread.createdAt\">\n{{ thread.createdAt | date:\'dd/MM/yyyy HH:mm\' }}</span></div><div class=\"name\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"text-truncate\" ng-bind=\"thread.tagName\"></span></div><div \nclass=\"details text-truncate\" ng-if=\"thread.parentTag\"><span class=\"title grey-500-fg\" translate=\"MH_TAGS.ALTERNATIVE\">\nAlternative tag</span> <span class=\"detail\" ng-bind=\"thread.parentTag\"></span></div><div class=\"details text-truncate\" \nng-if=\"thread.faceExternalId\"><span class=\"title grey-500-fg\" translate=\"MH_TAGS.FACE_ID\">Face external ID</span> <span\n class=\"detail\" ng-bind=\"thread.faceExternalId\"></span></div></div><div class=\"buttons\" layout=\"row\" \nlayout-align=\"start center\"><button ng-if=\"thread.verify\" class=\"md-icon-button\" \nng-click=\"vm.toggleVerify($event, thread)\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\">\n</md-icon><md-tooltip hide show-gt-xs><span translate=\"MH_TAGS.CLICK_TO_UNVERIFY\"></span></md-tooltip></button> <button\n ng-if=\"!thread.verify\" class=\"md-icon-button\" ng-click=\"vm.toggleVerify($event, thread)\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate=\"MH_TAGS.CLICK_TO_VERIFY\"></span></md-tooltip></button></div></div></div></div><div class=\"tags-list-footer\" \nlayout=\"row\" layout-align=\"end center\" ng-if=\"vm.filteredCount > 0\"><span class=\"page-info\" \ntranslate=\"MH_TAGS.ITEMS_FOUND\" translate-values=\"{ total: (vm.filteredCount | number) }\"></span><md-button \naria-label=\"{{ \'MH_TAGS.PREVIOUS\' | translate }}\" class=\"md-icon-button arrow\" ng-click=\"vm.prevPage()\" \nng-disabled=\"vm.page <= 1\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button><span class=\"page-info\">\n{{ vm.page }} / {{ vm.totalPages }}</span><md-button aria-label=\"{{ \'MH_TAGS.NEXT\' | translate }}\" \nclass=\"md-icon-button arrow\" ng-click=\"vm.nextPage()\" ng-disabled=\"vm.page >= vm.totalPages\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>");
$templateCache.put("app/main/apps/mediahub/tags/views/list/split-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/mediahub/tags/views/list/toolbar.html\'\"></div><div class=\"content-wrapper\" flex \nlayout=\"row\"><div class=\"content thread-list mail-list-pane\" flex=\"50\" id=\"mh-tags-thread-list\" \nng-include=\"\'app/main/apps/mediahub/tags/views/list/list-view.html\'\"></div><div \nclass=\"content thread-detail mail-read-pane\" flex=\"50\" id=\"mh-tags-thread-detail\" layout=\"column\" \nng-include=\"\'app/main/apps/mediahub/tags/views/read/read-view.html\'\"></div></div>");
$templateCache.put("app/main/apps/mediahub/tags/views/list/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-label\" \naria-label=\"{{ \'MH_TAGS.SELECT_PAGE\' | translate }}\" ng-checked=\"vm.selectedThreads.length > 0\" \nng-click=\"vm.toggleSelectThreads()\"></md-checkbox><div class=\"divider-vertical\" hide show-gt-xs></div><md-button \naria-label=\"{{ \'MH_TAGS.ADD\' | translate }}\" class=\"md-accent green-500-bg md-raised\" hide show-gt-sm \nng-click=\"vm.newThread()\" type=\"button\"><span translate=\"MH_TAGS.ADD\">New</span></md-button><md-button \naria-label=\"{{ \'MH_TAGS.ADD\' | translate }}\" class=\"md-fab md-mini md-accent green-500-bg md-raised\" hide-gt-sm \nng-click=\"vm.newThread()\" type=\"button\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><div \nclass=\"divider-vertical\" hide show-gt-xs></div><div class=\"tags-search\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-magnify\" class=\"s24\"></md-icon><input type=\"text\" ng-model=\"vm.searchQuery\" \nng-model-options=\"{ debounce: 250 }\" ng-change=\"vm.search(vm.searchQuery)\" \nplaceholder=\"{{ \'MH_TAGS.SEARCH\' | translate }}\" aria-label=\"{{ \'MH_TAGS.SEARCH\' | translate }}\"><md-icon \nmd-font-icon=\"icon-close-circle\" class=\"s18 tags-search-reset\" ng-if=\"vm.searchQuery\" ng-click=\"vm.search(\'\')\">\n</md-icon></div><md-menu><md-button aria-label=\"{{ \'MH_TAGS.FILTERS\' | translate }}\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\" ng-class=\"{ \'md-accent\': vm.filterType || vm.filterVerify }\"><md-icon \nmd-font-icon=\"icon-filter\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"MH_TAGS.FILTERS\">Filters</span>\n</md-tooltip></md-button><md-menu-content width=\"4\" class=\"mh-tags-filter-menu\"><md-menu-item><md-button \nng-click=\"vm.setVerifyFilter(null)\"><div layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"MH_TAGS.ALL_STATUSES\">All statuses</span> <i class=\"icon-check s16\" ng-if=\"!vm.filterVerify\"></i></div>\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.setVerifyFilter(\'true\')\"><div layout=\"row\" \nlayout-align=\"space-between center\"><span translate=\"MH_TAGS.VERIFIED\">Verified</span> <i class=\"icon-check s16\" \nng-if=\"vm.filterVerify === \'true\'\"></i></div></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.setVerifyFilter(\'false\')\"><div layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"MH_TAGS.UNVERIFIED\">Unverified</span> <i class=\"icon-check s16\" ng-if=\"vm.filterVerify === \'false\'\"></i>\n</div></md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button \nng-click=\"vm.setTypeFilter(null)\"><div layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"MH_TAGS.ALL_TYPES\">All types</span> <i class=\"icon-check s16\" ng-if=\"!vm.filterType\"></i></div></md-button>\n</md-menu-item><md-menu-item ng-repeat=\"t in vm.tagTypes track by t.type\"><md-button \nng-click=\"vm.setTypeFilter(t.type)\"><div layout=\"row\" layout-align=\"space-between center\"><span>{{ t.type }} <span \nclass=\"grey-500-fg\">({{ t.count | number }})</span></span> <i class=\"icon-check s16\" ng-if=\"vm.filterType === t.type\">\n</i></div></md-button></md-menu-item></md-menu-content></md-menu><div class=\"divider-vertical\" hide show-gt-xs></div>\n<md-button hide show-gt-xs aria-label=\"{{ \'MH_TAGS.SORT\' | translate }}\" class=\"md-icon-button\" \nng-click=\"vm.setSortDir(vm.sortDir === \'ASC\' ? \'DESC\' : \'ASC\')\"><md-icon md-font-icon=\"icon-sort-ascending\" \nng-if=\"vm.sortDir === \'ASC\'\"></md-icon><md-icon md-font-icon=\"icon-sort-descending\" ng-if=\"vm.sortDir === \'DESC\'\">\n</md-icon><md-tooltip hide show-gt-xs><span ng-if=\"vm.sortDir === \'ASC\'\" translate=\"MH_TAGS.SORT_ASC\">A → Z</span> \n<span ng-if=\"vm.sortDir === \'DESC\'\" translate=\"MH_TAGS.SORT_DESC\">Z → A</span></md-tooltip></md-button><div \nclass=\"action-buttons\" layout=\"row\" layout-align=\"start center\" ng-show=\"vm.selectedThreads.length > 0\"><div \nclass=\"divider-vertical\" hide show-gt-xs></div><md-button ng-click=\"vm.massDelete($event)\" \naria-label=\"{{ \'MH_TAGS.DELETE_SELECTED\' | translate }}\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon><md-tooltip hide show-gt-xs><span translate=\"MH_TAGS.DELETE_SELECTED\">Delete selected</span></md-tooltip>\n</md-button><div class=\"divider-vertical\" hide show-gt-xs></div></div></div><div layout=\"row\" \nlayout-align=\"start center\" class=\"qiu-pagination\" ng-hide=\"vm.isLoading\"><span class=\"page-info\" hide show-gt-xs \ntranslate=\"MH_TAGS.ITEMS_FOUND\" translate-values=\"{ total: (vm.filteredCount | number) }\"></span><md-button \naria-label=\"{{ \'MH_TAGS.PREVIOUS\' | translate }}\" class=\"md-icon-button arrow\" hide show-gt-xs \nng-click=\"vm.prevPage()\" ng-disabled=\"vm.page <= 1\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button>\n<div hide show-gt-xs><md-select ng-model=\"vm.page\" ng-change=\"vm.goToPage(vm.page)\" \naria-label=\"{{ \'MH_TAGS.PAGE\' | translate }}\" class=\"toolbar-item\"><md-option \nng-repeat=\"n in vm.pageNumbers() track by n\" ng-value=\"n\">{{ n }}</md-option></md-select></div><span \nclass=\"page-info ml-10\" hide show-gt-xs>/ <span class=\"ml-5\">{{ vm.totalPages }}</span></span><md-button \naria-label=\"{{ \'MH_TAGS.NEXT\' | translate }}\" class=\"md-icon-button arrow\" hide show-gt-xs ng-click=\"vm.nextPage()\" \nng-disabled=\"vm.page >= vm.totalPages\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button><div \nclass=\"divider-vertical\" hide show-gt-sm></div><md-button aria-label=\"{{ \'MH_TAGS.REFRESH\' | translate }}\" \nclass=\"md-icon-button\" ng-click=\"vm.loadTags()\"><md-icon md-font-icon=\"icon-refresh\"></md-icon><md-tooltip hide \nshow-gt-xs><span translate=\"MH_TAGS.REFRESH\">Refresh</span></md-tooltip></md-button></div>");
$templateCache.put("app/main/apps/mediahub/tags/views/read/edit-preview.html","<div class=\"form-wrapper tag-edit\" layout=\"column\"><form name=\"vm.basicForm\" class=\"md-inline-form\" novalidate>\n<md-input-container class=\"md-block\" ng-if=\"vm.isNewThread\"><label translate=\"MH_TAGS.NAME\">Name</label><input \nname=\"tagName\" ng-model=\"vm.currentThread_Edit.tagName\" required md-autofocus></md-input-container><h1 class=\"name\" \nng-if=\"!vm.isNewThread\"><strong ng-bind=\"vm.currentThread_Edit.tagName\"></strong></h1><md-input-container \nclass=\"md-block\"><label translate=\"MH_TAGS.TYPE\">Type</label><md-select name=\"tagType\" \nng-model=\"vm.currentThread_Edit.tagType\"><md-option ng-repeat=\"t in vm.editTypeOptions() track by t\" ng-value=\"t\" \nng-disabled=\"vm.editableTagTypes.indexOf(t) === -1\">{{ t }}</md-option></md-select><div class=\"hint\" \nng-if=\"!vm.isNewThread && vm.editableTagTypes.indexOf(vm.currentThread_Edit._originalType) === -1\" \ntranslate=\"MH_TAGS.TYPE_READONLY_HINT\"></div></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"MH_TAGS.ALTERNATIVE\">Alternative tag</label><input name=\"parentTag\" \nng-model=\"vm.currentThread_Edit.parentTag\"></md-input-container><md-input-container class=\"md-block\" \nng-if=\"vm.currentThread_Edit.tagType === \'people\'\"><label translate=\"MH_TAGS.FACE_ID\">Face external ID</label><input \nname=\"faceExternalId\" ng-model=\"vm.currentThread_Edit.faceExternalId\"></md-input-container><md-switch \nng-model=\"vm.currentThread_Edit.verify\" class=\"m-0\" aria-label=\"{{ \'MH_TAGS.VERIFIED\' | translate }}\"><span \ntranslate=\"MH_TAGS.VERIFIED\">Verified</span></md-switch></form></div>");
$templateCache.put("app/main/apps/mediahub/tags/views/read/read-view.html","<div class=\"mail-content\" layout=\"column\" layout-align=\"center center\" ng-if=\"!vm.selectedContent\"><div \nclass=\"content\" layout=\"column\" layout-align=\"top center\"><div class=\"message\" translate=\"MH_TAGS.NO_SELECTION\">\nSelect a tag to see it in the panel</div></div></div><div class=\"toolbar grey-100-bg colored-bg\" layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"vm.selectedContent\"><div layout=\"row\" layout-align=\"start center\"><md-button\n aria-label=\"{{ \'MH_TAGS.INFORMATION\' | translate }}\" class=\"md-icon-button\" ng-if=\"!vm.isNewThread\" \nng-click=\"vm.viewPreview()\" ng-class=\"{ \'md-accent\': !vm.editInline }\"><md-icon \nmd-font-icon=\"icon-information-outline\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"MH_TAGS.INFORMATION\">\nInformation</span></md-tooltip></md-button><div class=\"divider-vertical\" hide show-gt-sm ng-if=\"!vm.isNewThread\"></div>\n<md-button aria-label=\"{{ \'MH_TAGS.EDIT\' | translate }}\" class=\"md-icon-button\" \nng-click=\"vm.isNewThread || vm.viewEditInline()\" ng-class=\"{ \'md-accent\': vm.editInline }\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"MH_TAGS.EDIT\">Edit</span>\n</md-tooltip></md-button><div class=\"divider-vertical\" hide show-gt-sm ng-if=\"!vm.isNewThread\"></div><md-button \naria-label=\"{{ \'MH_TAGS.DELETE\' | translate }}\" class=\"md-icon-button\" ng-if=\"!vm.isNewThread\" \nng-click=\"vm.deleteTag(vm.selectedContent, $event)\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip hide \nshow-gt-xs><span translate=\"MH_TAGS.DELETE\">Delete</span></md-tooltip></md-button></div><div layout=\"row\" \nlayout-align=\"end center\"><md-button type=\"button\" ng-if=\"vm.editInline\" ng-click=\"vm.saveItem(vm.currentThread_Edit)\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"vm.basicForm.$invalid || vm.basicForm.$pristine\" \naria-label=\"{{ \'MH_TAGS.SAVE\' | translate }}\"><span translate=\"MH_TAGS.SAVE\">Save</span></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"{{ \'MH_TAGS.CLOSE\' | translate }}\" ng-click=\"vm.closeThread()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"MH_TAGS.CLOSE\">Close</span>\n</md-tooltip></md-button></div></div><md-content flex class=\"scrollable\" ng-if=\"vm.selectedContent && !vm.editInline\">\n<md-list class=\"tag-read\"><md-list-item class=\"info\"><div class=\"header-element\" layout=\"row\" \nlayout-align=\"start center\"><md-icon ng-if=\"vm.selectedContent.verify\" md-font-icon=\"icon-checkbox-marked-circle\" \nclass=\"on green-fg s24\"></md-icon><md-icon ng-if=\"!vm.selectedContent.verify\" \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\"></md-icon><span class=\"ml-8\" \nng-if=\"vm.selectedContent.verify\" translate=\"MH_TAGS.VERIFIED\"></span> <span class=\"ml-8\" \nng-if=\"!vm.selectedContent.verify\" translate=\"MH_TAGS.UNVERIFIED\"></span></div></md-list-item><md-list-item><div \nflex=\"100\"><h1 class=\"name\"><strong ng-bind=\"vm.selectedContent.tagName\"></strong></h1><md-divider></md-divider></div>\n</md-list-item><md-list-item><div flex=\"100\"><div class=\"field\"><p class=\"grey-500-fg font-size-14\" \ntranslate=\"MH_TAGS.TYPE\">Type</p><span class=\"font-size-16\" ng-bind=\"vm.selectedContent.tagType || \'—\'\"></span></div>\n<md-divider></md-divider></div></md-list-item><md-list-item><div flex=\"100\"><div class=\"field\"><p \nclass=\"grey-500-fg font-size-14\" translate=\"MH_TAGS.ALTERNATIVE\">Alternative tag</p><span class=\"font-size-16\" \nng-bind=\"vm.selectedContent.parentTag || \'—\'\"></span></div><md-divider></md-divider></div></md-list-item><md-list-item \nng-if=\"vm.selectedContent.tagType === \'people\'\"><div flex=\"100\"><div class=\"field\"><p class=\"grey-500-fg font-size-14\" \ntranslate=\"MH_TAGS.FACE_ID\">Face external ID</p><span class=\"font-size-16\" \nng-bind=\"vm.selectedContent.faceExternalId || \'—\'\"></span></div><md-divider></md-divider></div></md-list-item>\n<md-list-item ng-if=\"vm.selectedContent.createdAt\"><div flex=\"100\"><div class=\"field\"><p \nclass=\"grey-500-fg font-size-14\" translate=\"MH_TAGS.CREATED\">Created</p><span class=\"font-size-16\">\n{{ vm.selectedContent.createdAt | date:\'dd/MM/yyyy HH:mm\' }}</span></div><md-divider></md-divider></div></md-list-item>\n<md-list-item ng-if=\"vm.tagUsage && vm.tagUsage.tagName === vm.selectedContent.tagName\"><div flex=\"100\"><div \nclass=\"field\"><p class=\"grey-500-fg font-size-14\" translate=\"MH_TAGS.USAGE\">Used in</p><div \nng-if=\"vm.tagUsage.loading\" layout=\"row\" layout-align=\"start center\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"18\"></md-progress-circular></div><span class=\"font-size-16\" ng-if=\"vm.tagUsage.error\" \ntranslate=\"MH_TAGS.USAGE_ERROR\"></span> <span class=\"font-size-16\" ng-if=\"!vm.tagUsage.loading && !vm.tagUsage.error\" \ntranslate=\"MH_TAGS.USAGE_COUNT\" translate-values=\"{ count: (vm.tagUsage.total | number) }\"></span><div \nclass=\"tag-usage-thumbs\" layout=\"row\" layout-wrap ng-if=\"!vm.tagUsage.loading && vm.tagUsage.items.length\"><img \nng-repeat=\"m in vm.tagUsage.items track by m.id\" ng-src=\"{{ m.thumbnailUrl }}\" ng-if=\"m.thumbnailUrl\" \nalt=\"{{ m.title }}\" title=\"{{ m.title }}\"></div><p class=\"hint\" translate=\"MH_TAGS.USAGE_HINT\"></p></div><md-divider>\n</md-divider></div></md-list-item></md-list></md-content><md-content flex class=\"scrollable\" \nng-if=\"vm.editInline && vm.selectedContent\" ng-include=\"\'app/main/apps/mediahub/tags/views/read/edit-preview.html\'\">\n</md-content>");
$templateCache.put("app/main/apps/mediahub/views/list/subviews/audios-view.html","<div class=\"ms-card-content-wrapper\"><div class=\"template-9\"><div class=\"media\" flex layout=\"row\" \nlayout-align=\"center center\"><media attachment=\"mediaItem\"></media></div><div class=\"header p-16\" flex><div \nlayout=\"row\" layout-align=\"space-between center\" flex><div class=\"size block\" layout=\"row\" layout-align=\"start left\">\n<strong class=\"mr-5\">#{{mediaItem.id_media}}</strong> <span class=\"grey-500-fg\"><span ng-if=\"mediaItem.date_uploaded\">\n{{mediaItem.date_uploaded.utcShow | date:\'dd/MM/yyyy HH:mm\'}}</span></span></div><md-checkbox \nng-checked=\"vm.isSelected(mediaItem)\" ng-click=\"vm.toggleSelectThread(mediaItem, $event)\" \naria-label=\"{{vm.isSelected(mediaItem) ? \'Deselect\' : \'Select\'}}\" class=\"ml-5\"></md-checkbox></div></div></div></div>");
$templateCache.put("app/main/apps/mediahub/views/list/subviews/files-view.html","<div class=\"ms-card-content-wrapper\"><div class=\"template-9\"><div class=\"media\" flex layout=\"row\" \nlayout-align=\"center center\"><img ng-if=\"mediaItem.thumbnailUrl || mediaItem.imageUrl\" \nng-src=\"{{mediaItem.thumbnailUrl || mediaItem.imageUrl}}\" style=\"max-width: 100%; max-height: 100%\"><md-icon \nng-if=\"!mediaItem.thumbnailUrl && !mediaItem.imageUrl\" \nmd-font-icon=\"{{vm.getExtensionIcon(mediaItem.filename || mediaItem.fileName)}}\" class=\"s56\" style=\"color: #999\">\n</md-icon></div><div class=\"header p-16\" flex><div layout=\"row\" layout-align=\"space-between center\" flex><div \nclass=\"size text-truncate\" layout=\"row\" layout-align=\"start left\"><strong class=\"mr-5\">#{{mediaItem.id_media}}</strong>\n</div><md-checkbox ng-checked=\"vm.isSelected(mediaItem)\" ng-click=\"vm.toggleSelectThread(mediaItem, $event)\" \naria-label=\"{{vm.isSelected(mediaItem) ? \'Deselect\' : \'Select\'}}\" class=\"ml-5\"></md-checkbox></div></div></div></div>");
$templateCache.put("app/main/apps/mediahub/views/list/subviews/import-view.html","<div class=\"content-wrapper\" flex layout=\"column\"><div class=\"content\"><div class=\"drop-box\"><md-input-container \nclass=\"md-block\"><label>Paste the url to import:</label><input type=\"text\" name=\"import_field\" \nng-model=\"vm.import_field\" placeholder=\"\" ng-disabled=\"vm.import_disabled\"></md-input-container><div \nng-if=\"vm.imported\" class=\"alert-message success-message\" translate=\"CONTENT.SUCCESSIMPORT\">Imported successfully</div>\n</div><treasure-overlay-spinner active=\"vm.importing\"><div layout=\"row\" layout-align=\"center start\" \nng-if=\"vm.importPreview\" class=\"white-box sections\"><div flex-gt-sm=\"50\" flex=\"100\"><div class=\"section\"><div \nclass=\"section-header\" layout=\"row\" layout-align=\"start center\"><span class=\"section-title\">PREVIEW</span></div><div \nclass=\"media\" flex layout=\"row\" layout-align=\"center center\" ng-bind-html=\"vm.importPreview.embedCodeSafe\"></div></div>\n<div class=\"header p-16\" flex><div layout=\"row\" layout-align=\"space-between center\" flex><div \nclass=\"size text-truncate\" layout=\"row\" layout-align=\"start left\"><span class=\"grey-500-fg\"><span \nng-if=\"vm.importPreview.title\">Title: {{vm.importPreview.title}}</span></span></div></div><div layout=\"row\" \nlayout-align=\"space-between center\" flex><div class=\"size\" layout=\"row\" layout-align=\"start left\"><span \nclass=\"grey-500-fg\"><span ng-if=\"vm.importPreview.caption\">Description: {{vm.importPreview.caption}}</span></span>\n</div></div></div><md-button class=\"send-button md-accent md-raised\" ng-click=\"vm.importConfirm(1)\" \ntranslate=\"CONTENT.IMPORT\">Import</md-button></div></div><div ng-repeat=\"f in vm.importedFiles\" class=\"ms-card\" flex>\n<div class=\"ms-card-content-wrapper\"><div class=\"template-9\"><div class=\"media\" flex layout=\"row\" \nlayout-align=\"center center\"><img ng-src=\"{{f.embed_thumb}}\" class=\"image\"></div><div class=\"header p-16\" flex><div \nlayout=\"row\" layout-align=\"space-between center\" flex><div class=\"size block\" layout=\"row\" layout-align=\"start left\">\n<strong class=\"mr-5\">#{{f.id_media}}</strong> <span class=\"grey-500-fg\"><span ng-if=\"f.filename\">{{f.filename}}</span> \n<span ng-if=\"f.title\">{{f.title}}</span></span></div><md-checkbox \nng-checked=\"vm.alreadySelectedbyZone(vm.selectedContacts, f)\" ng-click=\"vm.toggleSelectContact(f, $event)\" \naria-label=\"{{vm.alreadySelectedbyZone(vm.selectedContacts, f) ? \'Deselect\' : \'Select\'}}\"></md-checkbox></div></div>\n</div></div></div></treasure-overlay-spinner></div></div>");
$templateCache.put("app/main/apps/mediahub/views/list/subviews/list-view.html","<div layout=\"row\" layout-align=\"start center\"><md-checkbox ng-checked=\"vm.isSelected(mediaItem)\" \nng-click=\"vm.toggleSelectThread(mediaItem, $event)\" aria-label=\"{{vm.isSelected(mediaItem) ? \'Deselect\' : \'Select\'}}\" \nclass=\"mb-0\"></md-checkbox><div class=\"media photos\" layout=\"row\" layout-align=\"center center\" \nng-if=\"mediaItem.mediaType == 1 || mediaItem.mediaType == 2 || mediaItem.mediaType == 3 || mediaItem.mediaType == 4\">\n<img ng-src=\"{{mediaItem.thumbnailUrl || mediaItem.imageUrl}}\" class=\"image\" style=\"max-height: 100%; max-width: 100%\" \nng-if=\"mediaItem.thumbnailUrl || mediaItem.imageUrl\"><md-icon ng-if=\"!mediaItem.thumbnailUrl && !mediaItem.imageUrl\" \nmd-font-icon=\"{{vm.getExtensionIcon(mediaItem.filename)}}\" class=\"s40\"></md-icon></div><div class=\"info\" flex \nlayout=\"column\"><div class=\"subject text-truncate grey-500-fg\" layout=\"row\" layout-align=\"start center\"><span>\nDate uploaded: {{mediaItem.date_uploaded.utcShow | date:\'dd/MM/yyyy HH:mm\'}}</span></div><div class=\"name\" \nlayout=\"row\" layout-align=\"start center\"><span ng-bind=\"mediaItem.filename\" ng-if=\"mediaItem.filename\"></span> <span \nng-bind=\"mediaItem.title\" ng-if=\"mediaItem.title && !mediaItem.filename\"></span></div><div class=\"details\" \nng-if=\"mediaItem.filename && mediaItem.title\"><span class=\"title grey-500-fg\">Title</span> <span class=\"detail\">\n{{mediaItem.title}}</span></div><div class=\"details\" ng-if=\"mediaItem.caption\"><span class=\"title grey-500-fg\">Caption\n</span> <span class=\"detail\">{{mediaItem.caption}}</span></div></div><div \nclass=\"subject buttons text-truncate grey-500-fg\" layout=\"row\" layout-align=\"start center\"><span>\n#{{mediaItem.id_media}}</span></div></div>");
$templateCache.put("app/main/apps/mediahub/views/list/subviews/media-children.html","<div ng-click=\"vm.selectMediaFile(child)\" class=\"ms-card pointer\"><div class=\"ms-card-content-wrapper\"><div \nclass=\"template-9\" layout=\"column\" layout-align=\"space-between stretch\"><div class=\"media\" flex layout=\"row\" \nlayout-align=\"center center\"><img ng-src=\"{{child.imageUrl}}\" class=\"image\" style=\"max-height: 100%; max-width: 100%\">\n</div><div class=\"header p-16\" flex><div layout=\"row\" layout-align=\"space-between center\" flex><div \nclass=\"size block mr-5\" layout=\"row\" layout-align=\"start left\"><strong class=\"mr-5\">#{{child.id_media}}</strong> <span \nclass=\"grey-500-fg word-break-all\"><span ng-if=\"child.originalFileName\" class=\"filename\">{{child.originalFileName}}\n</span></span></div><md-menu ng-if=\"selectedTab == \'children\'\"><md-icon class=\"pointer mr-10\" \nng-click=\"$mdMenu.open($event)\" md-font-icon=\"icon-dots-vertical\"></md-icon><md-menu-content width=\"2\"><md-menu-item>\n<md-button ng-click=\"vm.deleteMediaChild(child)\" aria-label=\"Refresh widget\" translate=\"MEDIA.DELETE\"></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></div>");
$templateCache.put("app/main/apps/mediahub/views/list/subviews/photos-view.html","<div class=\"ms-card-content-wrapper\"><div class=\"template-9\" layout=\"column\" layout-align=\"space-between stretch\"><div \nclass=\"media\" flex layout=\"row\" layout-align=\"center center\"><img ng-if=\"mediaItem.thumbnailUrl || mediaItem.imageUrl\" \nng-src=\"{{mediaItem.thumbnailUrl || mediaItem.imageUrl}}\" style=\"max-width: 100%; max-height: 100%\"><md-icon \nng-if=\"!mediaItem.thumbnailUrl && !mediaItem.imageUrl\" \nmd-font-icon=\"{{vm.getExtensionIcon(mediaItem.filename || mediaItem.fileName)}}\" class=\"s56\" style=\"color: #999\">\n</md-icon></div><div class=\"header p-16\" flex><div layout=\"row\" layout-align=\"space-between center\" flex><div \nclass=\"size block mr-5\" layout=\"row\" layout-align=\"start left\"><strong class=\"mr-5\">#{{mediaItem.id_media}}</strong> \n<span class=\"grey-500-fg word-break-all\"><span ng-if=\"mediaItem.originalFileName\" class=\"filename\">\n{{mediaItem.originalFileName}}</span></span></div><md-checkbox ng-checked=\"vm.isSelected(mediaItem)\" \nng-click=\"vm.toggleSelectThread(mediaItem, $event)\" aria-label=\"{{vm.isSelected(mediaItem) ? \'Deselect\' : \'Select\'}}\" \nclass=\"ml-5\"></md-checkbox></div></div></div></div>");
$templateCache.put("app/main/apps/mediahub/views/list/subviews/template-grid.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"space-between center\" flex><div \nlayout=\"column\" layout-align=\"start center\"><md-checkbox class=\"no-label\" ng-checked=\"vm.isChecked(mail)\" \nng-click=\"vm.toggleCheck(mail, $event)\" aria-label=\"{{vm.isChecked(mail)? \'Uncheck\':\'check\'}}\"></md-checkbox><div \nng-if=\"refcolumnsgrouped.main\"><div class=\"subject text-truncate\"><span \nng-repeat=\"field in refcolumnsgrouped.header | orderBy: \'list-sort\'\" ng-bind=\"thread.{{field.titleId}}\"></span></div>\n</div></div><div layout=\"column\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-attachment\" \nclass=\"has-attachment s24\" ng-if=\"thread.Thumbnail.length>0\"></md-icon><button ng-if=\"thread.onoff===1\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\"></md-icon></button> \n<button ng-if=\"thread.onoff!==1\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-blank-circle-outline\" \nclass=\"off red-fg s24\"></md-icon></button></div></div><div class=\"media\" flex layout=\"row\" \nlayout-align=\"center center\"><img class=\"image\" ng-src=\"{{card.Thumbnail[0].crop_status[0].urlformed}}\" \nalt=\"{{card.media.image.alt}}\" imageonloadcontrol></div><div class=\"header p-16\" layout=\"row\" layout-align=\"start\"><div\n class=\"info\"><div ng-if=\"refcolumnsgrouped.main\"><div class=\"name text-truncate\" layout=\"row\" \nlayout-align=\"start center\"><span ng-repeat=\"field in refcolumnsgrouped.main\"><span ng-bind=\"thread.{{field.titleId}}\">\n</span>&nbsp;</span></div></div><div ng-repeat=\"field in refcolumnsgrouped.secondary | orderBy:\'list_sort\'\"><div \nng-if=\"(field.type!==\'date\' && field.type!==\'dateHm\') && field.primary!==1\" class=\"details\" layout=\"row\" \nlayout-align=\"start start\"><div layout=\"column\"><span class=\"title\" ng-bind=\"field.title\"></span></div><div \nlayout=\"column\" class=\"text-truncate\"><span class=\"detail\" ng-bind=\"thread.{{field.titleId}}\"></span></div></div></div>\n</div></div></div>");
$templateCache.put("app/main/apps/mediahub/views/list/subviews/tiny-attached.html","<div class=\"content-wrapper\" flex layout=\"row\"><div class=\"mail-tabs-grid\" flex \nmd-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"content mail-list-pane-grid\" flex><div \nng-repeat=\"item in vm.selectedContacts\" class=\"ms-card\" flex><div class=\"ms-card-content-wrapper\" \nng-if=\"item.media_type == 1\"><div class=\"template-9\"><div class=\"media\" flex layout=\"row\" layout-align=\"center center\">\n<img ng-src=\"{{item.cropstatus[0].container.view_url}}{{item.cropstatus[0].fileName}}\" class=\"image\"></div><div \nclass=\"header p-16\" flex><div layout=\"row\" layout-align=\"space-between center\" flex><div class=\"size block\" \nlayout=\"row\" layout-align=\"start left\"><strong class=\"mr-5\">#{{item.id_media}}</strong> <span class=\"grey-500-fg\"><span\n ng-if=\"item.filename\">{{item.filename}}</span></span></div><md-button ng-click=\"vm.selectMediaTiny(item)\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Select\" translate=\"CONTENT.SELECT\" \ntranslate-attr-aria-label=\"CONTENT.SELECT\">SELECT</md-button></div></div></div></div><div \nclass=\"ms-card-content-wrapper\" ng-if=\"item.media_type == 2\"><div class=\"template-9\"><div class=\"media\" flex \nlayout=\"row\" layout-align=\"center center\"><img ng-src=\"{{item.embed_thumb}}\" class=\"image\"></div><div \nclass=\"header p-16\" flex><div layout=\"row\" layout-align=\"space-between center\" flex><div class=\"size block\" \nlayout=\"row\" layout-align=\"start left\"><strong class=\"mr-5\">#{{item.id_media}}</strong> <span class=\"grey-500-fg\"><span\n ng-if=\"item.filename\">{{item.filename}}</span> <span ng-if=\"item.title\">{{item.title}}</span></span></div><md-button \nng-click=\"vm.selectMediaTiny(item)\" class=\"send-button md-accent md-raised\" aria-label=\"Select\" \ntranslate=\"CONTENT.SELECT\" translate-attr-aria-label=\"CONTENT.SELECT\">SELECT</md-button></div></div></div></div></div>\n</div></div></div>");
$templateCache.put("app/main/apps/mediahub/views/list/subviews/tiny-properties.html","<div class=\"ontent-wrapper\" flex=\"\" layout=\"column\"><div class=\"content\"><div class=\"ms-card\" flex><div \nclass=\"ms-card-content-wrapper\"><div class=\"template-9\"><div class=\"media\" flex layout=\"row\" \nlayout-align=\"center center\" ng-if=\"vm.selectedMediaTiny.media_type == 1\"><img \nng-src=\"{{vm.selectedMediaTiny.cropstatus[0].container.view_url}}{{vm.selectedMediaTiny.cropstatus[0].fileName}}\" \nclass=\"image\"></div><div class=\"media\" flex layout=\"row\" layout-align=\"center center\" \nng-if=\"vm.selectedMediaTiny.media_type == 2\"><img ng-src=\"{{vm.selectedMediaTiny.embed_thumb}}\" class=\"image\"></div>\n<div class=\"header p-16\" flex><div layout=\"row\" layout-align=\"space-between center\" flex><div class=\"size block\" \nlayout=\"row\" layout-align=\"start left\"><strong class=\"mr-5\">#{{vm.selectedMediaTiny.id_media}}</strong> <span \nclass=\"grey-500-fg\"><span ng-if=\"vm.selectedMediaTiny.filename\">{{vm.selectedMediaTiny.filename}}</span></span></div>\n</div></div></div></div></div><div class=\"sections white-box\"><div class=\"section\"><md-input-container \nclass=\"md-block\" flex><label translate=\"CONTENT.ALIGN\" translate-attr-aria-label=\"CONTENT.ALIGN\">Align:</label>\n<md-select ng-model=\"vm.tinyProperties.align\" placeholder=\"Align\"><md-option value=\"\">---</md-option><md-option \nng-repeat=\"opt in vm.tinyOptions.align\" value=\"{{opt.value}}\">{{opt.text}}</md-option></md-select><div \nclass=\"md-errors-spacer\"></div></md-input-container><md-input-container class=\"md-block\" flex><label \ntranslate=\"CONTENT.SIZE\" translate-attr-aria-label=\"CONTENT.SIZE\">Size:</label><md-select \nng-model=\"vm.tinyProperties.size\" placeholder=\"Size\"><md-option value=\"\">---</md-option><md-option \nng-repeat=\"opt in vm.tinyOptions.size\" value=\"{{opt.value}}\">{{opt.text}}</md-option></md-select><div \nclass=\"md-errors-spacer\"></div></md-input-container></div></div></div></div>");
$templateCache.put("app/main/apps/mediahub/views/list/subviews/upload-view.html","<div class=\"content-wrapper\" flex=\"\" layout=\"column\"><div class=\"content\"><div ngf-drop ngf-select ng-model=\"vm.files\" \nclass=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"true\" ngf-allow-dir=\"true\" \naccept=\"video/*,image/*,application/pdf\" ngf-pattern=\"\'video/*,image/*,application/pdf\'\"><div layout=\"column\"><div \nflex>Drop here or click to upload</div><div flex>or</div><div flex><md-button class=\"send-button md-accent md-raised\" \naria-label=\"Select files\">Select Files from your computer</md-button></div></div></div><div ngf-no-file-drop>\nFile Drag/Drop is not supported for this browser</div><div ng-repeat=\"f in vm.files\" class=\"ms-card\" flex><div \nclass=\"ms-card-content-wrapper\"><div class=\"template-9\"><div class=\"media\" flex layout=\"row\" \nlayout-align=\"center center\"><img ngf-thumbnail=\"!f.$error && f\" class=\"image\"></div><div class=\"header p-16\" flex><div\n layout=\"row\" layout-align=\"space-between center\" flex><div class=\"size\" layout=\"row\" layout-align=\"start left\"><strong\n class=\"mr-5\" ng-if=\"f.id\">#{{f.id}}</strong> <span class=\"grey-500-fg\"><span ng-if=\"f.name\">{{f.name}}</span></span>\n</div></div></div><md-progress-linear md-mode=\"determinate\" value=\"{{f.progress}}\" ng-show=\"f.progress < 100\">\n</md-progress-linear></div></div></div><md-list-item class=\"file-name-item md-white-bg\" md-ink-ripple \nng-repeat=\"f in vm.files\"><p class=\"text-truncate font-weight-600\">{{f.name}} {{f.$error}} {{f.$errorParam}}</p>\n</md-list-item>Upload Log:<pre>{{log}}</pre></div></div>");
$templateCache.put("app/main/apps/mediahub/views/list/subviews/videos-view.html","<div class=\"ms-card-content-wrapper\"><div class=\"template-9\"><div class=\"media\" flex layout=\"row\" \nlayout-align=\"center center\"><media attachment=\"mediaItem\"></media></div><div class=\"header p-16\" flex><div \nlayout=\"row\" layout-align=\"space-between center\" flex><div class=\"size block mr-5\" layout=\"row\" \nlayout-align=\"start left\"><strong class=\"mr-5\">#{{mediaItem.id_media}} <span ng-if=\"mediaItem.duration\"><md-icon \nmd-font-icon=\"icon-clock\" class=\"s16 text-right\" aria-hidden=\"true\"></md-icon>\n{{(mediaItem.duration*1000) | amDateFormat:\'mm:ss\'}} </span></strong><span class=\"grey-500-fg word-break-all\" \nng-if=\"mediaItem.filename\"><span>{{mediaItem.filename}}</span> </span><span class=\"grey-500-fg word-break-word\" \nng-if=\"mediaItem.title\"><span>{{mediaItem.title}}</span></span></div><md-checkbox \nng-checked=\"vm.isSelected(mediaItem)\" ng-click=\"vm.toggleSelectThread(mediaItem, $event)\" \naria-label=\"{{vm.isSelected(mediaItem) ? \'Deselect\' : \'Select\'}}\" class=\"ml-5\"></md-checkbox></div></div></div></div>");
$templateCache.put("app/main/apps/runtag/event/views/list/events-list-content.html","<div layout=\"row\" layout-align=\"space-between\" id=\"query-search-container\"><input type=\"search\" translate \ntranslate-attr-placeholder=\"RUNTAG.SEARCH_USER_PLACEHOLDER\" ng-model=\"vm.querySearch\" class=\"input-query\" \nng-enter=\"vm.filterUsers()\"><md-button aria-label=\"Filter Users\" class=\"submit-button\" type=\"submit\" \ntranslate=\"USERS.SEARCH\" ng-click=\"vm.filterUsers()\"></md-button></div><div id=\"list-content-data\" \nclass=\"scrollable ms-scroll ps-container ps-theme-default ps-active-y\"><div class=\"mail-list-item\" \nng-repeat=\"user in vm.filteredUsers\" md-no-ink ng-click=\"vm.selectUser(user)\" role=\"button\"><div layout=\"row\" \nlayout-align=\"start center\"><div><media ng-if=\"!user.avatar\" class-img=\"avatar\" force-class use-default></media><img \nng-if=\"user.avatar\" ng-src=\"{{user.avatar}}\" class=\"avatar\"></div><div layout=\"column\"><span><strong>\n{{user.firstname}} {{user.lastname}} <span ng-if=\"vm.getUserNumber(user.user_params, user.current_number)\">\n#{{vm.getUserNumber(user.user_params, user.current_number)}}</span></strong></span> <span>{{user.email}}</span> <span>\n{{user.eventNumber}}</span><span class=\"matched-profile\" \nng-if=\"user.matchedProfileNumber && user.matchedProfileNumber != user.eventNumber\"><span \ntranslate=\"RUNTAG.PROFILE_MATCH\">Perfil</span>: {{user.matchedProfileNumber}}</span></div><div layout=\"column\"><span>\n{{user.files.length}}</span> <span>{{user.conversations.length}}</span></div></div></div></div>");
$templateCache.put("app/main/apps/runtag/event/views/list/events-list.html","<div class=\"content-card\" layout=\"column\" flex md-no-ink style=\"height: 100%\"><div class=\"content-wrapper\" flex \nlayout=\"row\"><div class=\"content thread-list mail-list-pane\" id=\"thread-list\" \nng-class=\"{\'mobile-hide\': !!vm.selectedUser}\" \nng-include=\"\'app/main/apps/runtag/event/views/list/events-list-content.html\'\"></div><div \nclass=\"content thread-detail mail-name\" ng-class=\"{\'mobile-hide\': !vm.selectedUser}\" flex=\"100\" id=\"thread-detail\" \nlayout=\"column\" ng-include=\"\'app/main/apps/runtag/event/views/templates/events-selected-user.html\'\"></div></div></div>");
$templateCache.put("app/main/apps/runtag/event/dialogs/event/change-subsec-event.html","<md-dialog class=\"change-subsec-modal\"><md-toolbar><div class=\"md-toolbar-tools px-20\"><h2 \ntranslate=\"RUNTAG.CHANGE_STATUS\">Change status</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div ng-repeat=\"state in vm.eventsSubsecs\"><md-radio-group \nng-model=\"vm.selectedSubsec\"><md-radio-button ng-value=\"state.id_subsec\">\n{{ state.translations[vm.selectedLanguage] || state.subsec }}</md-radio-button></md-radio-group></div>\n</md-dialog-content><md-dialog-actions><md-button ng-click=\"vm.closeDialog()\" class=\"md-raised md-warn\" \ntranslate=\"CONTENT.CANCEL\">CANCEL</md-button><md-button ng-click=\"vm.saveDialog()\" class=\"md-raised md-accent\" \ntranslate=\"CONTENT.UPDATE\">UPDATE</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/runtag/event/dialogs/event/new-event-modal.html","<md-dialog aria-label=\"Add Event\" layout=\"column\" \nclass=\"new-event-dialog max-w-full overflow-hidden sm:h-[80vh] sm:w-[95vw]\"><div class=\"processing-container\" \nng-if=\"vm.loadingRegex\"><div class=\"content\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\">\n</md-progress-circular><span translate=\"RUNTAG.PROCESSING_REGEX\"></span></div></div><div class=\"processing-container\" \nng-if=\"vm.loadingImage\"><div class=\"content\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\">\n</md-progress-circular><span translate=\"RUNTAG.UPLOADING_IMAGE\"></span></div></div><md-toolbar><div \nclass=\"md-toolbar-tools px-20\"><span class=\"material-symbols-outlined icon\">directions_run</span><h2 \ntranslate=\"RUNTAG.NEW_EVENT\">Add New Event</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"flex-1 overflow-auto\"><div class=\"h-full\"><div ng-if=\"!vm.created\" \nclass=\"px-20 py-12\" layout=\"row\" layout-align=\"start center\"><md-icon class=\"mr-8\">info</md-icon><span \ntranslate=\"RUNTAG.EVENT_FORM.SAVE_FIRST_HINT\">Guardá el evento para habilitar el resto de pestañas.</span></div>\n<md-tabs md-selected=\"vm.selectedTab\" md-border-bottom md-stretch-tabs=\"never\" class=\"h-full\"><md-tab label=\"Event\">\n<ng-include src=\"\'app/main/apps/runtag/event/dialogs/event/tabs/tab-event.html\'\" class=\"h-full display-block\">\n</ng-include></md-tab><md-tab ng-disabled=\"!vm.created\" label=\"Product\"><ng-include \nsrc=\"\'app/main/apps/runtag/event/dialogs/event/tabs/tab-product.html\'\" class=\"h-full display-block\"></ng-include>\n</md-tab><md-tab ng-disabled=\"!vm.created\" label=\"Photographer\"><ng-include \nsrc=\"\'app/main/apps/runtag/event/dialogs/event/tabs/tab-photographer.html\'\" class=\"h-full display-block\"></ng-include>\n</md-tab><md-tab ng-disabled=\"!vm.created\" label=\"Location\"><ng-include \nsrc=\"\'app/main/apps/runtag/event/dialogs/event/tabs/tab-location.html\'\" class=\"h-full display-block\"></ng-include>\n</md-tab><md-tab ng-disabled=\"!vm.created\" label=\"Dorsals\"><ng-include \nsrc=\"\'app/main/apps/runtag/event/dialogs/event/tabs/tab-dorsals.html\'\" class=\"h-full display-block\"></ng-include>\n</md-tab><md-tab ng-disabled=\"!vm.created || vm.loadingDiscountCodes\" label=\"Discount Codes\"><ng-include \nsrc=\"\'app/main/apps/runtag/event/dialogs/event/tabs/tab-discount-codes.html\'\" class=\"h-full display-block\">\n</ng-include></md-tab></md-tabs></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/runtag/event/views/sidenavs/events-sidenav.html","<div ng-if=\"!isLoadingGroups\" layout=\"row\" class=\"container\"><div class=\"selected-event-toolbar\" ng-if=\"vm.isFiltered\" \nflex=\"100\" layout=\"row\" layout-align=\"center center\"><button class=\"md-raised md-accent md-button md-default-theme\" \ntype=\"button\" aria-label=\"Back\" translate=\"USERS.BACK\" translate-attr-aria-label=\"USERS.BACK\" ng-click=\"vm.reset()\">\nback</button></div></div>");
$templateCache.put("app/main/apps/runtag/event/views/templates/archive-list.html","<article id=\"archive-container-list\" class=\"mt-50 mb-50\"><div class=\"re-table archive-table\"><table><tbody><tr \nid=\"archive-list-header\" class=\"table-title-head archive\"><td class=\"table-icon center btlr\"><span \nclass=\"material-symbols-outlined\">archive</span></td><td class=\"btrr\" colspan=\"7\"><span class=\"bold text-uppercase\" \ntranslate=\"RUNTAG.ARCHIVE_REQUESTS\">ARCHIVE REQUESTS</span></td></tr><tr class=\"table-info-header\"><td></td><td \ntranslate=\"RUNTAG.USERS\" class=\"bold text-uppercase\">USUARIO</td><td colspan=\"2\"></td><td translate=\"RUNTAG.PENDING\" \nclass=\"bold text-uppercase center\">PENDING</td><td translate=\"RUNTAG.RESTORED\" class=\"bold text-uppercase center\">\nRESTORED</td><td translate=\"RUNTAG.UNKNOWN\" class=\"bold text-uppercase center\">UNKNOWN</td><td></td></tr><tr \nng-repeat-start=\"user in vm.archiveItems\" class=\"table-items-body runners-rows cursor-pointer\" \nng-click=\"user.__open = !user.__open\"><td class=\"table-avatar\"></td><td><div layout=\"column\" class=\"pt-5 pb-5\"><span \nclass=\"capitalize\" ng-if=\"user.contact\">{{user.contact.firstname}} {{user.contact.lastname}}</span> <span \nng-if=\"!user.contact\">Admin ID# {{user.userId}}</span></div></td><td class=\"center\" colspan=\"2\"></td><td \nng-if=\"user.itemsByStatus.PENDING\" class=\"center\">{{user.itemsByStatus.PENDING.length}}</td><td \nng-if=\"!user.itemsByStatus.PENDING\" class=\"center\">0</td><td ng-if=\"user.itemsByStatus.RESTORED\" class=\"center\">\n{{user.itemsByStatus.RESTORED.length}}</td><td ng-if=\"!user.itemsByStatus.RESTORED\" class=\"center\">0</td><td \nng-if=\"user.itemsByStatus.UNKNOWN\" class=\"center\">{{user.itemsByStatus.UNKNOWN.length}}</td><td \nng-if=\"!user.itemsByStatus.UNKNOWN\" class=\"center\">0</td><td class=\"center\"><button type=\"button\" \nclass=\"btn btn-small btn-icon\" aria-label=\"Toggle details\" ng-disabled=\"!(user.items && user.items.length)\" \nng-click=\"$event.stopPropagation(); (user.items && user.items.length) && (user.__open = !user.__open)\"><span \nclass=\"material-symbols-outlined\" ng-if=\"!user.__open\">keyboard_arrow_down</span> <span \nclass=\"material-symbols-outlined\" ng-if=\"user.__open\">keyboard_arrow_up</span></button></td></tr><tr ng-repeat-end \nclass=\"table-items-body archive-detail-row\" ng-if=\"user.__open\"><td colspan=\"8\" class=\"p-0\"><div \nclass=\"archive-detail-wrapper\"><table ng-if=\"user.itemsByStatus.PENDING && user.itemsByStatus.PENDING.length\" \nclass=\"archive-detail-table\" style=\"width:100%; border-collapse: collapse\"><thead><tr class=\"table-info-header\"><th \nclass=\"text-left\">PENDING ({{user.itemsByStatus.PENDING.length}})</th><th class=\"text-left\">Filename</th><th \nclass=\"text-left\">Requested</th><th class=\"text-left\">Restored</th><th class=\"center\">Image</th></tr></thead><tbody><tr\n ng-repeat=\"it in user.itemsByStatus.PENDING | orderBy:\'-requestedAt\'\"><td></td><td><div class=\"bold\">\n{{ it.mediaId || it.filekey }}</div></td><td>\n{{ (it.requestedAt || (it.usersIdRequestedDate && it.usersIdRequestedDate[0] && it.usersIdRequestedDate[0].requestedAt)) | date:\'yyyy-MM-dd HH:mm\' }}\n</td><td>—</td><td class=\"center\"><img ng-src=\"{{ it.thumbUrl }}\" alt=\"\" ng-if=\"it.thumbUrl\"> <span \nng-if=\"!it.thumbUrl\">—</span></td></tr></tbody></table><table \nng-if=\"user.itemsByStatus.RESTORED && user.itemsByStatus.RESTORED.length\" class=\"archive-detail-table\" \nstyle=\"width:100%; border-collapse: collapse\"><thead><tr class=\"table-info-header\"><th class=\"text-left\">\nRESTORED ({{user.itemsByStatus.RESTORED.length}})</th><th class=\"text-left\">Filename</th><th class=\"text-left\">\nRequested</th><th class=\"text-left\">Restored</th><th class=\"center\">Image</th></tr></thead><tbody><tr \nng-repeat=\"it in user.itemsByStatus.RESTORED | orderBy:\'-restoredAt\'\"><td></td><td><div class=\"bold\">\n{{ it.mediaId || it.filekey }}</div></td><td>\n{{ (it.requestedAt || (it.usersIdRequestedDate && it.usersIdRequestedDate[0] && it.usersIdRequestedDate[0].requestedAt)) | date:\'yyyy-MM-dd HH:mm\' }}\n</td><td>{{ it.restoredAt | date:\'yyyy-MM-dd HH:mm\' }}</td><td class=\"center\"><img ng-src=\"{{ it.thumbUrl }}\" alt=\"\" \nng-if=\"it.thumbUrl\"> <span ng-if=\"!it.thumbUrl\">—</span></td></tr></tbody></table><table \nng-if=\"user.itemsByStatus.UNKNOWN && user.itemsByStatus.UNKNOWN.length\" class=\"archive-detail-table\" \nstyle=\"width:100%; border-collapse: collapse\"><thead><tr class=\"table-info-header\"><th class=\"text-left\">\nUNKNOWN ({{user.itemsByStatus.UNKNOWN.length}})</th><th class=\"text-left\">Filename</th><th class=\"text-left\">Requested\n</th><th class=\"text-left\">Restored</th><th class=\"center\">Image</th></tr></thead><tbody><tr \nng-repeat=\"it in user.itemsByStatus.UNKNOWN | orderBy:\'-restoredAt\'\"><td></td><td><div class=\"bold\">\n{{ it.mediaId || it.filekey }}</div></td><td>\n{{ (it.requestedAt || (it.usersIdRequestedDate && it.usersIdRequestedDate[0] && it.usersIdRequestedDate[0].requestedAt)) | date:\'yyyy-MM-dd HH:mm\' }}\n</td><td>{{ it.restoredAt | date:\'yyyy-MM-dd HH:mm\' }}</td><td class=\"center\"><img ng-src=\"{{ it.thumbUrl }}\" alt=\"\" \nng-if=\"it.thumbUrl\"> <span ng-if=\"!it.thumbUrl\">—</span></td></tr></tbody></table><div \nng-if=\"(!user.itemsByStatus.PENDING || !user.itemsByStatus.PENDING.length) &&\r\n                                        (!user.itemsByStatus.RESTORED || !user.itemsByStatus.RESTORED.length) &&\r\n                                        (!user.itemsByStatus.UNKNOWN || !user.itemsByStatus.UNKNOWN.length)\">\nNo files for this user.</div></div></td></tr><tr class=\"table-items-footer\"><td class=\"bblr bbrr\" colspan=\"8\"><div \nlayout=\"row\" layout-align=\"center center\" class=\"re-load-more font-size-15 bold cursor-pointer\" \nng-if=\"vm.archivePagingKey && !vm.isLoadingArchiveItems\" ng-click=\"vm.getEventArchiveItems(true)\"><span \nclass=\"material-symbols-outlined\">expand_circle_down</span> <span class=\"text-uppercase\" translate=\"RUNTAG.LOAD_MORE\">\nLOAD MORE</span></div><div layout=\"row\" layout-align=\"center center\" class=\"p-10\" \nng-if=\"vm.isLoadingArchiveItems && vm.archiveItems.length > 0\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"30\"></md-progress-circular></div></td></tr></tbody></table></div></article>");
$templateCache.put("app/main/apps/runtag/event/views/templates/events-add-prebuys.html","<script src=\"https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.17.3/xlsx.full.min.js\"></script><div id=\"prebuy_panel\"><div \nid=\"header\"><span translate=\"USERS.PREBUY_TITLE\">Prebuys panel</span><md-button class=\"close-button md-icon-button\" \nng-click=\"vm.closePrebuyPanel()\" aria-label=\"Close dialog\" tranlate translate-aria-label=\"CONTENT.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div id=\"body\"><div \nng-if=\"vm.prebuyProducts.length > 1\"><md-input-container class=\"md-block\" flex><label \ntranslate=\"USERS.PREBUY_SELECT_PRODUCT\"></label><md-select ng-model=\"vm.prebuySelectedProduct\" ng-required=\"true\">\n<md-option value=\"{{opt}}\" ng-repeat=\"opt in vm.prebuyProducts\">{{opt.product}}</md-option></md-select><div \nclass=\"md-errors-spacer\"></div></md-input-container></div><div id=\"info\" ng-if=\"vm.prebuyProducts.length == 1\"><span \nclass=\"text\" translate=\"USERS.PREBUY_ADD_INFO\">You will add buys with this product:</span><span class=\"product\">\n {{vm.prebuyProducts[0].product}}</span></div><div id=\"mail-input\"><md-input-container class=\"md-block mb-0 chips\">\n<md-chips id=\"md-chips-email\" ng-model=\"vm.prebuyEmails\" readonly=\"false\" md-removable=\"true\" \nplaceholder=\"{{vm.translate(\'MAILING.ADD_EMAILS\')}}\" delete-button-label=\"{{vm.translate(\'MAILING.REMOVE_EMAILS\')}}\" \ndelete-hint=\"{{vm.translate(\'MAILING.DELETE_REMOVE_EMAILS\')}}\" \nsecondary-placeholder=\" {{vm.translate(\'MAILING.ADD_EMAILS\')}}\" md-enable-chip-edit=\"true\" md-separator-keys=\"vm.keys\" \nng-enter=\"vm.validateEmail(vm.prebuyEmails)\" md-transform-chip=\"vm.addChips($chip,vm.prebuyEmails)\" ng-required=\"true\" \nclass=\"close-chip\"><button md-chip-remove class=\"md-primary\"><md-icon md-font-icon=\"icon-close\"></md-icon></button>\n</md-chips></md-input-container></div></div><div class=\"mb-50\" layout=\"column\" layout-align=\"center center\"><input \nng-if=\"!vm.loadingExcel && vm.excelPrebuyEmails.length === 0\" type=\"file\" id=\"prebuy-file-input\" \nonchange=\"angular.element(this).scope().handleFile()\"><div ng-if=\"vm.loadingExcel\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"30\"></md-progress-circular></div><div layout=\"row\" layout-align=\"center center\" \nng-if=\"!vm.loadingExcel && vm.excelPrebuyEmails.length > 0\"><span>You added {{vm.excelPrebuyEmails.length}} emails.\n</span> <span ng-click=\"vm.cancelExcelPrebuyEmails()\" class=\"cursor-pointer material-symbols-outlined\">cancel</span>\n</div></div><div id=\"footer\"><md-button type=\"submit\" ng-click=\"vm.createPrebuys()\" \nclass=\"send-button md-accent md-raised\" \nng-disabled=\"(!vm.prebuyEmails.length && !vm.excelPrebuyEmails.length) || !vm.prebuySelectedProduct || vm.creatingOrders\">\n<span aria-label=\"SAVE\" translate=\"CONTENT.SAVE\" translate-attr-aria-label=\"CONTENT.SAVE\" ng-hide=\"vm.creatingOrders\">\nSAVE</span> <span ng-show=\"vm.creatingOrders\">Saving...</span></md-button></div></div>");
$templateCache.put("app/main/apps/runtag/event/views/templates/events-all-media.html","<div><div class=\"toolbar\"><div class=\"tools-container\"><md-button ng-disabled=\"vm.loadingMore\" \nng-click=\"vm.getBackAllMedia()\" class=\"rounded-20 send-button md-accent md-raised\" aria-label=\"save\"><span \nclass=\"text\">Return</span></md-button><div class=\"search-container\" layout=\"row\" layout-align=\"space-between\"><input \ntype=\"search\" translate translate-attr-placeholder=\"USERS.SEARCH_BY_FILENAME\" ng-model=\"vm.querySearch\" \nclass=\"input-query\" ng-disabled=\"vm.loadingMore\" ng-enter=\"vm.filterByMediaId()\"><md-button class=\"submit-button\" \ntype=\"submit\" translate=\"USERS.SEARCH\" aria-label=\"search\" ng-disabled=\"vm.loadingMore\" \nng-click=\"vm.filterByMediaId()\"></md-button></div><div class=\"search-face-container\" layout=\"row\" \nlayout-align=\"space-between\"><md-button class=\"submit-button\" type=\"submit\" translate=\"USERS.SEARCH_BY_FACE\" \naria-label=\"search\" ng-click=\"vm.openSearchFaceModal()\"></md-button></div></div><div class=\"paginator-container\">\n<md-button class=\"md-icon-button assign-bulk\" aria-label=\"Assign images\" ng-click=\"vm.initAssignBulk()\" translate=\"\" \ntranslate-attr-aria-label=\"USERS.USER-ASSIGN-IMAGES\" ng-if=\"vm.selectedMedias.length > 0\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"USERS.USER-ASSIGN-IMAGES\">\nAssign images</span></md-tooltip></md-button><md-select aria-label=\"Change Sort\" ng-change=\"vm.changeSort()\" \nng-model=\"vm.sort\"><md-option value=\"asc\">ASC</md-option><md-option value=\"desc\">DESC</md-option></md-select><md-select\n aria-label=\"Change Limit Per Page\" ng-change=\"vm.changeLimit()\" ng-model=\"vm.limitPerPage\"><md-option \nng-repeat=\"limit in vm.limitMenu\" ng-value=\"limit\">{{limit}}</md-option></md-select><div class=\"pagination-toolbar\" \nlayout=\"row\" layout-align=\"center center\"><md-button \nng-disabled=\"vm.loadingMore || vm.mediaPagination.currentIndex === 0\" ng-click=\"vm.prevPage()\" class=\"md-icon-button\" \naria-label=\"Previous Page\"><span class=\"material-symbols-outlined\">chevron_left</span></md-button><span \nclass=\"page-info\">{{vm.mediaPagination.currentIndex + 1}}</span><md-button \nng-disabled=\"vm.loadingMore || !vm.mediaPagination.hasNext\" ng-click=\"vm.nextPage()\" class=\"md-icon-button\" \naria-label=\"Next Page\"><span class=\"material-symbols-outlined\">chevron_right</span></md-button></div></div></div><div \nng-if=\"vm.loadingMore\" class=\"media-list-loading\" layout=\"column\" layout-align=\"center center\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"48\"></md-progress-circular><span class=\"loading-text\">Loading media...</span>\n</div><md-list-item ng-if=\"!vm.loadingMore && vm.items.length > 0 && !vm.searchedItems.length\" id=\"images-container\" \nclass=\"all-media\"><ng-content ng-if=\"!vm.eventVersion\" \nng-include=\"\'app/main/apps/runtag/event/views/templates/item-list-events.html\'\"></ng-content><ng-content \nng-if=\"vm.eventVersion == \'v2\' || vm.eventVersion == \'v3\'\" \nng-include=\"\'app/main/apps/runtag/event/views/templates/item-list-events-v2.html\'\"></ng-content><div \nclass=\"pagination-footer\" layout=\"row\" layout-align=\"center center\"><md-button \nng-disabled=\"vm.loadingMore || vm.mediaPagination.currentIndex === 0\" ng-click=\"vm.prevPage()\" \nclass=\"md-accent md-raised\" aria-label=\"Previous Page\"><span class=\"material-symbols-outlined\">chevron_left</span> \n<span translate=\"USERS.PREVIOUS\">PREVIOUS</span></md-button><span class=\"page-info text-bold\">\n{{vm.mediaPagination.currentIndex + 1}}</span><md-button ng-disabled=\"vm.loadingMore || !vm.mediaPagination.hasNext\" \nng-click=\"vm.nextPage()\" class=\"md-accent md-raised\" aria-label=\"Next Page\"><span translate=\"USERS.NEXT\">NEXT</span> \n<span class=\"material-symbols-outlined\">chevron_right</span></md-button></div></md-list-item><div \nng-if=\"!vm.loadingMore && vm.items.length === 0 && !vm.searchedItems.length\" class=\"no-media-placeholder\" \nlayout=\"column\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-image-off\" class=\"placeholder-icon\"></md-icon>\n<span class=\"placeholder-text\">There are no items to display</span><md-button ng-click=\"vm.getBackAllMedia()\" \nclass=\"md-accent\">Return to dashboard</md-button></div><md-list-item id=\"images-container\" class=\"all-media\" \nng-if=\"!vm.loadingMore && vm.searchedItems.length\"><div class=\"toolbar-container\"><span>\nBusqueda por concidencias faciales</span><span class=\"close-button\" ng-click=\"vm.resetSearchByFace()\">X</span></div>\n<div ng-repeat=\"mediaItem in vm.searchedItems | filter:mediaSearch | orderBy: \'id_media\'\" class=\"image-container\">\n<ng-container ng-include=\"\'app/main/apps/runtag/event/views/templates/item-media-unified.html\'\" \nng-init=\"galleryList = vm.searchedItems; isSearch = true\"></ng-container></div></md-list-item><div \nng-if=\"vm.addUserBulk\" id=\"modal-add-user-bulk\"><div class=\"content\"><div class=\"toolbar\" layout=\"row\"><md-button \nclass=\"close-button md-icon-button\" ng-click=\"vm.closeAssignBulk()\" aria-label=\"Close dialog\" tranlate \ntranslate-aria-label=\"CONTENT.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div \nclass=\"search\" ng-if=\"vm.usersToAdd.length == 0\"><div layout=\"row\" layout-align=\"space-between\"><input type=\"search\" \ntranslate translate-attr-placeholder=\"USERS.SEARCH_USER_PLACEHOLDER\" ng-model=\"vm.userSearchString\" \nclass=\"input-query\" ng-enter=\"vm.searchAssignUser()\"><md-button class=\"submit-button\" type=\"submit\" \ntranslate=\"USERS.SEARCH\" ng-click=\"vm.searchAssignUser()\"></md-button></div></div><div class=\"list\" \nng-if=\"vm.usersToAdd.length > 0\"><md-button class=\"return-button md-icon-button\" ng-click=\"vm.returnToSearch()\" \naria-label=\"Return to search\" tranlate translate-aria-label=\"CONTENT.RETURN\"><md-icon md-font-icon=\"icon-arrow-left\">\n</md-icon></md-button><div class=\"list-content\"><div class=\"user\" ng-repeat=\"user in vm.usersToAdd\" \nng-click=\"vm.userBulk(user)\"><div layout=\"row\" layout-align=\"start center\"><div><media ng-if=\"!user.avatar\" \nclass-img=\"avatar\" force-class use-default></media><img ng-if=\"user.avatar\" ng-src=\"{{user.avatar}}\" class=\"avatar\">\n</div><div layout=\"column\"><span><strong>{{user.firstname}} {{user.lastname}}</strong></span> <span>{{user.email}}\n</span> <span>{{user.eventNumber}}</span></div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/apps/runtag/event/views/templates/events-detail.html","<article id=\"events-container-detail\"><div layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\" \nclass=\"event-title mt-50\"><div layout=\"row\" layout-align=\"end center\" show-xs hide-gt-xs class=\"mb-10 ml-auto\"><button \nlayout=\"row\" layout-align=\"start center\" ng-if=\"vm.selectedGroup\" ng-click=\"vm.editEvent()\" mat-icon-button \nclass=\"close-event mr-20 gap-10\">Editar <span class=\"material-icons\">settings</span></button> <button layout=\"row\" \nlayout-align=\"start center\" ng-if=\"vm.selectedGroup\" ng-click=\"vm.deselectGroup()\" mat-icon-button \nclass=\"close-event gap-10\">Cerrar <span class=\"material-icons\">cancel</span></button></div><div layout=\"row\" \nlayout-align=\"start center\" layout-align-xs=\"space-between center\" class=\"gap-20 width-percent-100\"><h1 class=\"m-0\" \nng-bind-html=\"vm.eventName\"></h1><span class=\"event-badge text-uppercase\" \nstyle=\"background-color: {{ vm.eventStateColor }}; color: #FFFFFF\">{{vm.eventStateName}}</span></div><div layout=\"row\" \nlayout-align=\"end center\" hide-xs><button layout=\"row\" layout-align=\"start center\" ng-if=\"vm.selectedGroup\" \nng-click=\"vm.editEvent()\" mat-icon-button class=\"close-event mr-20 gap-10\">Edit <span class=\"material-icons\">settings\n</span></button> <button layout=\"row\" layout-align=\"start center\" ng-if=\"vm.selectedGroup\" \nng-click=\"vm.deselectGroup()\" mat-icon-button class=\"close-event gap-10\">Cerrar <span class=\"material-icons\">cancel\n</span></button></div></div><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"search-container desktop mt-50 py-5 px-10\"><input type=\"search\" translate \ntranslate-attr-placeholder=\"RUNTAG.SEARCH_USER_PLACEHOLDER\" ng-model=\"vm.querySearch\" ng-enter=\"vm.setFilter()\" \nclass=\"font-size-15 pl-30\"><md-input-container><md-select ng-model=\"vm.typeOfSearch\" aria-label=\"type of search\">\n<md-option translate=\"RUNTAG.SEARCH_BY_USERS\" value=\"users\">Buscar por usuarios</md-option><md-option \ntranslate=\"RUNTAG.SEARCH_BY_PHOTOGRAPHERS\" value=\"photographers\">Buscar por fotografos</md-option></md-select>\n</md-input-container><md-button aria-label=\"search\" ng-disabled=\"!vm.selectedGroup || vm.isSearching\" type=\"submit\" \nng-class=\"{\'is-searching\': vm.isSearching}\" ng-click=\"vm.setFilter()\"><span class=\"search-button-content\">\n<md-progress-circular ng-if=\"vm.isSearching\" md-mode=\"indeterminate\" md-diameter=\"18\"></md-progress-circular><span \nng-if=\"!vm.isSearching\" translate=\"RUNTAG.SEARCH\">Buscar</span> <span ng-if=\"vm.isSearching\" \ntranslate=\"RUNTAG.SEARCHING\">Buscando…</span></span></md-button></div><p class=\"search-help desktop\"><span \nng-if=\"vm.typeOfSearch == \'users\'\" translate=\"RUNTAG.SEARCH_USER_HELP\"></span></p><md-input-container \nclass=\"mobile mt-50 type-of-search-selector\"><md-select ng-model=\"vm.typeOfSearch\" aria-label=\"type of search\">\n<md-option translate=\"RUNTAG.SEARCH_BY_USERS\" value=\"users\">Buscar por usuarios</md-option><md-option \ntranslate=\"RUNTAG.SEARCH_BY_PHOTOGRAPHERS\" value=\"photographers\">Buscar por fotografos</md-option></md-select>\n</md-input-container><div layout=\"row\" layout-align=\"space-between center\" class=\"search-container mobile py-5 px-10\">\n<input type=\"search\" translate translate-attr-placeholder=\"RUNTAG.SEARCH_USER_PLACEHOLDER\" ng-model=\"vm.querySearch\" \nng-enter=\"vm.setFilter()\" class=\"font-size-15 pl-30\"><md-button aria-label=\"search\" \nng-disabled=\"!vm.selectedGroup || vm.isSearching\" type=\"submit\" ng-class=\"{\'is-searching\': vm.isSearching}\" \nng-click=\"vm.setFilter()\"><span class=\"search-button-content\"><md-progress-circular ng-if=\"vm.isSearching\" \nmd-mode=\"indeterminate\" md-diameter=\"18\"></md-progress-circular><span ng-if=\"!vm.isSearching\" \ntranslate=\"RUNTAG.SEARCH\">Buscar</span> <span ng-if=\"vm.isSearching\" translate=\"RUNTAG.SEARCHING\">Buscando…</span>\n</span></md-button></div><p class=\"search-help mobile\"><span ng-if=\"vm.typeOfSearch == \'users\'\" \ntranslate=\"RUNTAG.SEARCH_USER_HELP\"></span></p><div class=\"graphs-container gap-20 mb-50\" layout=\"row\" \nlayout-align=\"space-between start\"><div layout=\"column\" class=\"graph-card runners\"><div class=\"icon\"><span \nclass=\"material-symbols-outlined\">directions_run</span></div><div class=\"text\"><span translate=\"RUNTAG.RUNNERS\" \nclass=\"title text-uppercase\">RUNNERS</span></div><div class=\"empty\"></div><div class=\"empty\"></div><div class=\"count\">\n<md-progress-circular ng-if=\"vm.isLoadingTotalRunners\" md-mode=\"indeterminate\" md-diameter=\"30\"></md-progress-circular>\n<span ng-if=\"!vm.isLoadingTotalRunners\">{{vm.totalRunners | number:0}}</span></div><div class=\"button\" \nng-click=\"vm.scrollTo(\'full-runners-container\')\"><a ng-if=\"vm.selectedGroup\" translate=\"RUNTAG.VIEW_ALL\" \nclass=\"text-uppercase\">View all</a></div><div class=\"icon\"><span class=\"material-symbols-outlined\">login</span></div>\n<div class=\"text\"><span translate=\"RUNTAG.ACCESS\" class=\"title text-uppercase\">ACCESS</span></div><div class=\"empty\">\n</div><div class=\"empty\"></div><div class=\"count\"><md-progress-circular ng-if=\"vm.isLoadingTotalAccess\" \nmd-mode=\"indeterminate\" md-diameter=\"30\"></md-progress-circular><span ng-if=\"!vm.isLoadingTotalAccess\">\n{{vm.totalAccess | number:0}}</span></div><div class=\"button\" ng-click=\"vm.openImportDialog($event)\"><a \nng-if=\"vm.selectedGroup\" translate=\"RUNTAG.IMPORT\" class=\"text-uppercase\">Import</a></div></div><div \nclass=\"graph-card photos\" ng-class=\"{ \'is-expanded\': vm.photosDetailsExpanded }\"><div class=\"graph-card__top\"><div \nclass=\"icon\"><span class=\"material-symbols-outlined\">photo_camera</span></div><div class=\"text\"><span \ntranslate=\"RUNTAG.PHOTOS\" class=\"title text-uppercase\">PHOTOS</span></div><div class=\"empty\"></div><div class=\"empty\">\n</div><div class=\"count\"><md-progress-circular ng-if=\"vm.isLoadingTotalPhotos\" md-mode=\"indeterminate\" \nmd-diameter=\"30\"></md-progress-circular><span ng-if=\"!vm.isLoadingTotalPhotos\">{{ vm.totalPhotos | number:0 }}</span>\n</div><div class=\"button\" ng-click=\"vm.showAllMedia()\"><a ng-if=\"vm.selectedGroup\" translate=\"RUNTAG.VIEW_ALL\" \nclass=\"text-uppercase\">View all</a></div><div class=\"icon\"><span class=\"material-symbols-outlined\">humidity_percentage\n</span></div><div class=\"text\"><span translate=\"RUNTAG.DOWNLOADS\" class=\"title text-uppercase\">DOWNLOADS</span></div>\n<div class=\"text\"><span translate=\"RUNTAG.RECOGNIZED_PHOTOS\" class=\"title text-uppercase\">RECOGNIZED PHOTOS</span>\n</div><div class=\"empty\"></div><div class=\"count\"><md-progress-circular ng-if=\"vm.isLoadingDownloads\" \nmd-mode=\"indeterminate\" md-diameter=\"30\"></md-progress-circular><span ng-if=\"!vm.isLoadingDownloads\">\n{{ vm.sumFields(vm.selectedGroup.photographers, \'downloads\') | number:0 }}</span></div><div class=\"count\">\n<md-progress-circular ng-if=\"vm.isLoadingRecognizedPhotos\" md-mode=\"indeterminate\" md-diameter=\"30\">\n</md-progress-circular><span ng-if=\"!vm.isLoadingRecognizedPhotos\">{{ vm.recognizedPhotos | number:0 }}</span></div>\n</div><div class=\"graph-card__toggle\" ng-click=\"vm.photosDetailsExpanded = !vm.photosDetailsExpanded\" \nng-if=\"vm.uploadedPhotos != null || \r\n                        vm.notRecognizedPhotos != null || \r\n                        vm.ai_pending != null || \r\n                        vm.crop_failed != null ||\r\n                        vm.crop_failed != null ||\r\n                        vm.metadata_error != null ||\r\n                        vm.repeated != null ||\r\n                        vm.unknown_failure != null\" \nrole=\"button\" tabindex=\"0\" aria-expanded=\"{{ vm.photosDetailsExpanded ? \'true\' : \'false\' }}\"><span \nclass=\"material-symbols-outlined chevron\" ng-class=\"{ \'is-rotated\': vm.photosDetailsExpanded }\">expand_more</span>\n</div><div class=\"graph-card__details\" ng-if=\"vm.photosDetailsExpanded\"><div class=\"details-grid\"><div \nng-if=\"vm.uploadedPhotos != null\" class=\"detail\"><div class=\"label text-uppercase\" translate=\"RUNTAG.UPLOADED\">SUBIDAS\n</div><div class=\"value\">{{ vm.uploadedPhotos | number:0 }}</div></div><div ng-if=\"vm.notRecognizedPhotos != null\" \nclass=\"detail\" ng-click=\"vm.isAdmin ? vm.getUnrecognizedPhotos() : null\"><div class=\"label text-uppercase\" \ntranslate=\"RUNTAG.NOT_RECOGNIZED\">SIN RECONOCER</div><div class=\"value\" ng-class=\"{\'pill\': vm.isAdmin}\">\n{{ vm.notRecognizedPhotos | number:0 }}</div></div><div ng-if=\"vm.repeated != null\" \nng-click=\"vm.reprocessPhotos(\'reprocess_repeated\')\" class=\"detail\"><div class=\"label text-uppercase\" \ntranslate=\"RUNTAG.DUPLICATED\">DUPLICADAS</div><div class=\"value pill\">{{ vm.repeated | number:0 }}</div></div><div \nng-if=\"vm.ai_pending != null\" class=\"detail\"><div class=\"label text-uppercase\" translate=\"RUNTAG.AI_PENDING\">\nPENDIENTES DE IA</div><div class=\"value\">{{ vm.ai_pending | number:0 }}</div></div><div ng-if=\"vm.crop_failed != null\" \nclass=\"detail\"><div class=\"label text-uppercase\" translate=\"RUNTAG.CROP_FAILED\">FALLO EN EL CROP</div><div \nclass=\"value\">{{ vm.crop_failed | number:0 }}</div></div><div ng-if=\"vm.metadata_error != null\" class=\"detail\"><div \nclass=\"label text-uppercase\" translate=\"RUNTAG.METADATA_ERROR\">ERROR EN EL METADATA</div><div class=\"value\">\n{{ vm.metadata_error | number:0 }}</div></div><div ng-if=\"vm.unknown_failure != null\" \nng-click=\"vm.reprocessPhotos(\'unknown_failure\')\" class=\"detail\"><div class=\"label text-uppercase\" \ntranslate=\"RUNTAG.UNKNOWN_FAILURE\">ERROR DESCONOCIDO</div><div class=\"value pill\">{{ vm.unknown_failure | number:0 }}\n</div></div><div ng-if=\"vm.ai_failed != null\" class=\"detail\"><div class=\"label text-uppercase\" \ntranslate=\"RUNTAG.AI_FAILED\">FALLO EN LA IA</div><div class=\"value\">{{ vm.ai_failed | number:0 }}</div></div></div>\n</div></div><div layout=\"column\" class=\"graph-card orders\"><div class=\"icon\"><span class=\"material-symbols-outlined\">\nshopping_bag</span></div><div class=\"text\"><span translate=\"RUNTAG.ORDERS\" class=\"title text-uppercase\">ORDERS</span>\n</div><div class=\"empty\"></div><div class=\"empty\"></div><div class=\"count\"><md-progress-circular \nng-if=\"vm.isLoadingTotalOrders\" md-mode=\"indeterminate\" md-diameter=\"30\"></md-progress-circular><span \nng-if=\"!vm.isLoadingTotalOrders\">{{vm.totalOrders | number:0}}</span></div><div class=\"button\" \nng-click=\"vm.openPrebuyPanel()\"><a ng-if=\"vm.selectedGroup\" translate=\"RUNTAG.ADD_PRESALES\" class=\"text-uppercase\">\nAdd prebuys</a></div><div class=\"icon\"><span class=\"material-symbols-outlined\">monetization_on</span></div><div \nclass=\"text\"><span class=\"title\">{{vm.selectedGroup ? vm.selectedGroup.local_currency : \'USD\'}}</span></div><div \nng-if=\"vm.selectedGroup.international_currency\" class=\"text\"><span class=\"title\">\n{{vm.selectedGroup.international_currency}}</span></div><div class=\"empty\"></div><div \nng-if=\"!vm.selectedGroup || (vm.selectedGroup && !vm.selectedGroup.international_currency)\" class=\"empty\"></div><div \nclass=\"count count-currency\"><md-progress-circular ng-if=\"vm.isLoadingCurrencys\" md-mode=\"indeterminate\" \nmd-diameter=\"30\"></md-progress-circular><span ng-if=\"!vm.isLoadingCurrencys\">\n{{vm.findTotalCurrency(vm.selectedGroup.local_currency) | number:2}}<md-tooltip md-direction=\"top\">\n{{vm.findTotalCurrency(vm.selectedGroup.local_currency) | number:2}} {{vm.selectedGroup.local_currency}}</md-tooltip>\n</span></div><div class=\"count count-currency\"><md-progress-circular ng-if=\"vm.isLoadingCurrencys\" \nmd-mode=\"indeterminate\" md-diameter=\"30\"></md-progress-circular><span \nng-if=\"vm.selectedGroup.international_currency && !vm.isLoadingCurrencys\">{{vm.totalOrdersUSD | number:2}}<md-tooltip \nmd-direction=\"top\">{{vm.totalOrdersUSD | number:2}} {{vm.selectedGroup.international_currency}}</md-tooltip></span>\n</div></div></div><div class=\"mb-50 re-table\"><table><tbody><tr ng-if=\"vm.loadingProducts && !vm.cartEnabled\"><td \ncolspan=\"15\" class=\"center py-30\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"40\" class=\"m-auto\">\n</md-progress-circular></td></tr><tr ng-if=\"!vm.loadingProducts && !vm.cartEnabled\" class=\"table-title-head sales\"><td \nclass=\"table-icon center btlr\"><span class=\"material-symbols-outlined\">shopping_bag</span></td><td \nclass=\"btrr sales-select\" colspan=\"14\"><span class=\"bold text-uppercase\" \nng-class=\"{ active: vm.activeSalesTableMode === \'sales\' }\" ng-click=\"vm.setSalesTableMode(\'sales\')\" \ntranslate=\"RUNTAG.SALES\">SALES</span> <span class=\"bold text-uppercase\" \nng-class=\"{ active: vm.activeSalesTableMode === \'orders\' }\" ng-click=\"vm.setSalesTableMode(\'orders\')\" \ntranslate=\"RUNTAG.ORDER_DETAIL\">ORDER DETAIL</span></td></tr><tr \nng-if=\"!vm.loadingProducts && !vm.cartEnabled && vm.activeSalesTableMode === \'sales\'\" class=\"table-info-header\"><td>\n</td><td colspan=\"4\" translate=\"RUNTAG.PRODUCT\" class=\"bold text-uppercase\">PRODUCT</td><td class=\"empty\"></td><td \ncolspan=\"2\" translate=\"RUNTAG.ORDERS\" class=\"bold text-uppercase center\">ORDERS</td><td class=\"empty\"></td><td \ncolspan=\"3\" translate=\"RUNTAG.SALES\" class=\"bold text-uppercase right\">SALES</td><td class=\"empty\"></td><td \ntranslate=\"RUNTAG.USD_CONVERSION\" colspan=\"2\" class=\"bold text-uppercase right\">USD CONVERSION</td></tr><tr \nng-repeat=\"product in vm.products\" \nng-if=\"!vm.loadingProducts && product.totalOrders > 0 && !vm.cartEnabled && vm.activeSalesTableMode === \'sales\'\" \nclass=\"table-items-body\"><td></td><td colspan=\"4\" class=\"product_product\" ng-bind-html=\"product.product\"></td><td></td>\n<td colspan=\"2\" class=\"product_orders center\">{{product.totalOrders | number:0}}</td><td></td><td colspan=\"3\" \nclass=\"product_price right\">{{product.totalPrice.split(\' \')[0] | number:2}} {{product.totalPrice.split(\' \')[1]}}</td>\n<td></td><td class=\"product_usd right\" colspan=\"2\">{{vm.findTotalUSDproduct(product.id) | number:2}} USD</td></tr><tr \nng-if=\"!vm.loadingProducts && !vm.cartEnabled && vm.activeSalesTableMode === \'sales\'\" class=\"table-items-footer\"><td \nclass=\"bblr\"></td><td colspan=\"4\" class=\"bold text-uppercase\" translate=\"RUNTAG.TOTAL\">TOTAL</td><td></td><td \ncolspan=\"2\" class=\"bold center\">{{vm.totalOrders}}</td><td></td><td colspan=\"3\" class=\"bold right\">\n{{vm.findTotalCurrency(vm.selectedGroup.local_currency) | number:2}} {{vm.selectedGroup.local_currency}} | {{vm.findTotalCurrency(vm.selectedGroup.international_currency) | number:2}} {{vm.selectedGroup.international_currency}}\n</td><td></td><td class=\"bold right bbrr\" colspan=\"2\">{{vm.totalOrdersUSD | number:2}} USD</td></tr><tr \nng-if=\"!vm.cartEnabled && vm.activeSalesTableMode === \'sales\'\" class=\"table-divider\"></tr><tr \nng-if=\"vm.cartEnabled && vm.loadingCartSales\"><td colspan=\"15\" class=\"center py-30\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"40\" class=\"m-auto\"></md-progress-circular></td></tr><tr \nng-if=\"vm.cartEnabled && !vm.loadingCartSales && vm.cartSales\" class=\"table-title-head sales\"><td \nclass=\"table-icon center btlr\"><span class=\"material-symbols-outlined\">shopping_bag</span></td><td \nclass=\"btrr sales-select\" colspan=\"14\"><span class=\"bold text-uppercase\" \nng-class=\"{ active: vm.activeSalesTableMode === \'sales\' }\" ng-click=\"vm.setSalesTableMode(\'sales\')\" \ntranslate=\"RUNTAG.SALES\">SALES</span> <span class=\"bold text-uppercase\" \nng-class=\"{ active: vm.activeSalesTableMode === \'orders\' }\" ng-click=\"vm.setSalesTableMode(\'orders\')\" \ntranslate=\"RUNTAG.ORDER_DETAIL\">ORDER DETAIL</span></td></tr><tr \nng-if=\"vm.cartEnabled && !vm.loadingCartSales && vm.cartSales && vm.activeSalesTableMode === \'sales\'\" \nclass=\"table-info-header\"><td></td><td colspan=\"4\" translate=\"RUNTAG.PRODUCT\" class=\"bold text-uppercase\">PRODUCT</td>\n<td class=\"empty\"></td><td colspan=\"2\" translate=\"RUNTAG.UNITS\" class=\"bold text-uppercase center\">UNITS</td><td \nclass=\"empty\"></td><td colspan=\"3\" translate=\"RUNTAG.SALES\" class=\"bold text-uppercase right\">SALES</td><td \nclass=\"empty\"></td><td translate=\"RUNTAG.USD_CONVERSION\" colspan=\"2\" class=\"bold text-uppercase right\">USD CONVERSION\n</td></tr><tr ng-repeat=\"row in vm.cartSales.rows\" \nng-if=\"vm.cartEnabled && !vm.loadingCartSales && vm.activeSalesTableMode === \'sales\'\" class=\"table-items-body\"><td>\n</td><td colspan=\"4\" class=\"product_product\"><span ng-bind-html=\"row.label\"></span><span ng-if=\"row.inactive\" \nclass=\"product-inactive\" translate=\"RUNTAG.PRODUCT_INACTIVE\">inactivo</span></td><td></td><td colspan=\"2\" \nclass=\"product_orders center\">{{row.units | number:0}}</td><td></td><td colspan=\"3\" class=\"product_price right\">\n{{row.revenue | number:2}} {{row.currency}}</td><td></td><td colspan=\"2\" class=\"product_usd right\">\n{{row.usd | number:2}} USD</td></tr><tr \nng-if=\"vm.cartEnabled && !vm.loadingCartSales && vm.cartSales.anomalies.orders > 0 && vm.activeSalesTableMode === \'sales\'\" \nclass=\"table-items-body\"><td></td><td colspan=\"4\" class=\"product_product\" translate=\"RUNTAG.CART_SALES_OTHER\">\nOther / unclassified</td><td></td><td colspan=\"2\" class=\"product_orders center\">\n{{vm.cartSales.anomalies.orders | number:0}}</td><td></td><td colspan=\"3\" class=\"product_price right\">\n{{vm.cartSales.anomalies.revenue | number:2}} {{vm.cartSales.currency}}</td><td></td><td colspan=\"2\" \nclass=\"product_usd right\">{{vm.cartSales.anomalies.usd | number:2}} USD</td></tr><tr \nng-if=\"vm.cartEnabled && !vm.loadingCartSales && vm.cartSales.manual && vm.activeSalesTableMode === \'sales\'\" \nclass=\"table-items-body\"><td></td><td colspan=\"4\" class=\"product_product\" translate=\"RUNTAG.MANUAL\">Manual</td><td>\n</td><td colspan=\"2\" class=\"product_orders center\">{{vm.cartSales.manual.orders | number:0}}</td><td></td><td \ncolspan=\"3\" class=\"product_price right\">{{vm.cartSales.manual.revenue | number:2}} {{vm.cartSales.currency}}</td><td>\n</td><td colspan=\"2\" class=\"product_usd right\">{{vm.cartSales.manual.usd | number:2}} USD</td></tr><tr \nng-if=\"vm.cartEnabled && !vm.loadingCartSales && vm.cartSales && vm.activeSalesTableMode === \'sales\'\" \nclass=\"table-items-footer\"><td class=\"bblr\"></td><td colspan=\"4\" class=\"bold text-uppercase\" translate=\"RUNTAG.TOTAL\">\nTOTAL</td><td></td><td colspan=\"2\" class=\"bold center\">{{vm.cartSales.totalUnits | number:0}}</td><td></td><td \ncolspan=\"3\" class=\"bold right\">{{vm.cartSales.totalRevenue | number:2}} {{vm.cartSales.currency}}</td><td></td><td \nclass=\"bold right bbrr\" colspan=\"2\">{{vm.cartSales.totalUsd | number:2}} USD</td></tr><tr \nng-if=\"vm.cartEnabled && vm.cartSales && vm.activeSalesTableMode === \'sales\'\" class=\"table-divider\"></tr><tr \nng-if=\"vm.activeSalesTableMode === \'orders\'\" class=\"table-info-header order-detail-tools\"><td></td><td colspan=\"8\"><div\n layout=\"row\" layout-align=\"start center\" class=\"order-detail-search\"><span class=\"material-symbols-outlined\">search\n</span> <input type=\"search\" ng-model=\"vm.orderDetail.search\" ng-change=\"vm.onOrderDetailSearch()\" translate \ntranslate-attr-placeholder=\"RUNTAG.ORDER_SEARCH_PLACEHOLDER\"></div></td><td colspan=\"6\" class=\"right\"><span \nclass=\"order-detail-chip\" ng-class=\"{ active: vm.orderDetail.status === \'all\' }\" \nng-click=\"vm.setOrderDetailStatus(\'all\')\" translate=\"RUNTAG.ORDER_FILTER_ALL\">ALL</span> <span \nclass=\"order-detail-chip\" ng-class=\"{ active: vm.orderDetail.status === \'paid\' }\" \nng-click=\"vm.setOrderDetailStatus(\'paid\')\" translate=\"RUNTAG.ORDER_FILTER_PAID\">PAID</span> <span \nclass=\"order-detail-chip\" ng-class=\"{ active: vm.orderDetail.status === \'pending\' }\" \nng-click=\"vm.setOrderDetailStatus(\'pending\')\" translate=\"RUNTAG.ORDER_FILTER_PENDING\">PENDING</span> <span \nclass=\"order-detail-chip\" ng-class=\"{ active: vm.orderDetail.status === \'failed\' }\" \nng-click=\"vm.setOrderDetailStatus(\'failed\')\" translate=\"RUNTAG.ORDER_FILTER_REJECTED\">REJECTED</span></td></tr><tr \nng-if=\"vm.activeSalesTableMode === \'orders\' && vm.orderDetail.loading\"><td colspan=\"15\" class=\"center py-30\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"40\" class=\"m-auto\"></md-progress-circular></td></tr><tr \nng-if=\"vm.activeSalesTableMode === \'orders\' && !vm.orderDetail.loading\" class=\"table-info-header\"><td></td><td \ncolspan=\"2\" translate=\"RUNTAG.ORDER_NUMBER\" class=\"bold text-uppercase\">ORDER</td><td colspan=\"2\" \ntranslate=\"RUNTAG.DATE\" class=\"bold text-uppercase\">DATE</td><td colspan=\"3\" translate=\"RUNTAG.CUSTOMER\" \nclass=\"bold text-uppercase\">CUSTOMER</td><td translate=\"RUNTAG.NUMBER\" class=\"bold text-uppercase center\">NUMBER</td>\n<td colspan=\"2\" translate=\"RUNTAG.PRODUCT\" class=\"bold text-uppercase\">PRODUCT</td><td \ntranslate=\"RUNTAG.PAYMENT_METHOD\" class=\"bold text-uppercase\">PAYMENT</td><td translate=\"RUNTAG.STATUS\" \nclass=\"bold text-uppercase\">STATUS</td><td colspan=\"2\" translate=\"RUNTAG.AMOUNT\" class=\"bold text-uppercase right\">\nAMOUNT</td></tr><tr ng-repeat-start=\"order in vm.visibleOrderRows()\" class=\"table-items-body order-detail-row\"><td \nclass=\"center\"><button class=\"order-detail-edit\" ng-click=\"vm.editOrderFromList($event, order)\" \nng-disabled=\"vm.orderDetail.loadingProfilesFor === order.id_orders\" title=\"{{ \'CONTENT.EDIT\' | translate }}\" \naria-label=\"{{ \'CONTENT.EDIT\' | translate }}\"><span class=\"material-symbols-outlined\" \nng-if=\"vm.orderDetail.loadingProfilesFor !== order.id_orders\">edit</span><md-progress-circular \nng-if=\"vm.orderDetail.loadingProfilesFor === order.id_orders\" md-mode=\"indeterminate\" md-diameter=\"16\">\n</md-progress-circular></button></td><td colspan=\"2\" class=\"order_number\"><button class=\"order-detail-toggle\" \nng-click=\"vm.toggleOrderRelated(order)\" title=\"{{ \'RUNTAG.ORDER_RELATED\' | translate }}\" \naria-label=\"{{ \'RUNTAG.ORDER_RELATED\' | translate }}\" ng-class=\"{ \'is-open\': order._expanded }\"><span \nclass=\"material-symbols-outlined\">expand_more</span></button> #{{order.id_orders}}</td><td colspan=\"2\" \nclass=\"order_date\">{{order._createdAt | date:\'d MMM y\'}} <span class=\"order-detail-soft\">\n{{order._createdAt | date:\'HH:mm\'}}</span></td><td colspan=\"3\" class=\"order_customer\"><a class=\"order-detail-link\" \nng-if=\"order.user_id\" ng-click=\"vm.goToUserFromOrder(order)\">{{order.user_name || order.user_email}}</a> <span \nng-if=\"!order.user_id\">{{order.user_name || \'—\'}}</span> <span class=\"order-detail-soft\">{{order.user_email}}</span>\n</td><td class=\"center\"><a ng-if=\"order._dorsal && order.user_id\" class=\"order-detail-dorsal is-link\" \nng-click=\"vm.goToUserFromOrder(order)\">{{order._dorsal}}</a> <span ng-if=\"order._dorsal && !order.user_id\" \nclass=\"order-detail-dorsal\">{{order._dorsal}}</span> <span ng-if=\"!order._dorsal\" class=\"order-detail-soft\">—</span>\n</td><td colspan=\"2\" class=\"order_product\"><span ng-bind-html=\"order._productName\"></span> <span \nclass=\"order-detail-soft\" ng-if=\"order._items\">{{order._items}}</span></td><td class=\"order_payment\">\n{{order._paymentName}} <span class=\"order-detail-soft\" ng-if=\"order.discount_code\">{{order.discount_code}}</span></td>\n<td><span class=\"order-detail-badge\" ng-class=\"vm.orderDetailStatusClass(order)\">{{vm.orderDetailStatusLabel(order)}}\n</span></td><td colspan=\"2\" class=\"order_amount right\">{{order.price | number:2}} {{order.currency_code}} <span \nclass=\"order-detail-soft\" ng-if=\"order.usd\">≈ {{order.usd | number:2}} USD</span></td></tr><tr \nng-if=\"order._expanded && order._relatedLoading\" class=\"table-items-body order-detail-related\"><td></td><td \ncolspan=\"14\" class=\"py-10\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\"></md-progress-circular></td>\n</tr><tr ng-repeat=\"rel in order._related\" ng-if=\"order._expanded\" class=\"table-items-body order-detail-related\" \nng-class=\"{ \'is-current\': rel._isCurrent }\"><td class=\"center\"><button class=\"order-detail-edit\" \nng-click=\"vm.editOrderFromList($event, rel)\" ng-disabled=\"vm.orderDetail.loadingProfilesFor === rel.id_orders\" \ntitle=\"{{ \'CONTENT.EDIT\' | translate }}\" aria-label=\"{{ \'CONTENT.EDIT\' | translate }}\"><span \nclass=\"material-symbols-outlined\" ng-if=\"vm.orderDetail.loadingProfilesFor !== rel.id_orders\">edit</span>\n<md-progress-circular ng-if=\"vm.orderDetail.loadingProfilesFor === rel.id_orders\" md-mode=\"indeterminate\" \nmd-diameter=\"16\"></md-progress-circular></button></td><td colspan=\"2\" class=\"order_number\">#{{rel.id_orders}} <span \nclass=\"order-detail-soft\" ng-if=\"rel._isCurrent\" translate=\"RUNTAG.ORDER_THIS_ONE\">esta</span></td><td colspan=\"2\" \nclass=\"order_date\">{{rel._createdAt | date:\'d MMM y\'}} <span class=\"order-detail-soft\">\n{{rel._createdAt | date:\'HH:mm\'}}</span></td><td colspan=\"3\"></td><td class=\"center\"><span ng-if=\"rel._dorsal\" \nclass=\"order-detail-dorsal\">{{rel._dorsal}}</span> <span ng-if=\"!rel._dorsal\" class=\"order-detail-soft\">—</span></td>\n<td colspan=\"2\" class=\"order_product\"><span ng-bind-html=\"rel._productName\"></span> <span class=\"order-detail-soft\" \nng-if=\"rel._items\">{{rel._items}}</span></td><td class=\"order_payment\">{{rel._paymentName}}</td><td><span \nclass=\"order-detail-badge\" ng-class=\"vm.orderDetailStatusClass(rel)\">{{vm.orderDetailStatusLabel(rel)}}</span></td><td \ncolspan=\"2\" class=\"order_amount right\">{{rel.price | number:2}} {{rel.currency_code}} <span class=\"order-detail-soft\" \nng-if=\"rel.usd\">≈ {{rel.usd | number:2}} USD</span></td></tr><tr ng-repeat-end \nng-if=\"order._expanded && !order._relatedLoading && order._related && !order._related.length\" \nclass=\"table-items-body order-detail-related\"><td></td><td colspan=\"14\" class=\"order-detail-soft\" \ntranslate=\"RUNTAG.ORDER_NO_RELATED\">Sin otras compras de este corredor</td></tr><tr \nng-if=\"vm.activeSalesTableMode === \'orders\' && !vm.orderDetail.loading && !vm.orderDetail.rows.length\" \nclass=\"table-items-body\"><td colspan=\"15\" class=\"center py-30\"><span ng-if=\"vm.orderDetail.search\" \ntranslate=\"RUNTAG.ORDER_NO_MATCHES\">No orders match the search</span> <span ng-if=\"!vm.orderDetail.search\" \ntranslate=\"RUNTAG.ORDER_NONE\">No orders in this event</span></td></tr><tr \nng-if=\"vm.activeSalesTableMode === \'orders\' && !vm.orderDetail.loading && vm.orderDetail.rows.length\" \nclass=\"table-items-footer\"><td class=\"bblr bbrr center\" colspan=\"15\" \nng-class=\"{ \'cursor-pointer\': vm.orderDetail.hasMore && !vm.orderDetail.loadingMore }\" \nng-click=\"vm.loadOrderDetail(true)\"><div ng-if=\"vm.orderDetail.hasMore && !vm.orderDetail.loadingMore\" layout=\"row\" \nlayout-align=\"center center\" class=\"re-load-more re-load-more-sales font-size-15 bold\"><span \nclass=\"material-symbols-outlined\">expand_circle_down</span> <span class=\"text-uppercase\" translate=\"RUNTAG.LOAD_MORE\">\nLOAD MORE</span></div><div ng-if=\"vm.orderDetail.loadingMore\" layout=\"row\" layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\"></md-progress-circular></div><div \nclass=\"order-detail-soft\">{{vm.orderDetail.rows.length | number:0}} / {{vm.orderDetail.total | number:0}} <span \ntranslate=\"RUNTAG.ORDERS\" class=\"text-lowercase\">orders</span></div></td></tr><tr \nng-if=\"vm.activeSalesTableMode === \'orders\'\" class=\"table-divider\"></tr><tr class=\"table-title-head photographers\"><td \nclass=\"table-icon center btlr\"><span class=\"material-symbols-outlined\">photo_camera</span></td><td \nclass=\"btrr photographers-select\" colspan=\"14\"><span class=\"bold text-uppercase\" \nng-class=\"{ active: vm.activePhotographersTableMode === \'photographers\' }\" \nng-click=\"vm.setPhotographersTableMode(\'photographers\')\" translate=\"RUNTAG.PHOTOGRAPHERS\">PHOTOGRAPHERS </span><span \nclass=\"bold text-uppercase\" ng-class=\"{ active: vm.activePhotographersTableMode === \'statuses_photos\' }\" \nng-click=\"vm.setPhotographersTableMode(\'statuses_photos\')\" translate=\"RUNTAG.STATUSES_PHOTOS\">STATUSES PHOTOS</span>\n</td></tr><tr class=\"table-info-header\"><td></td><td translate=\"RUNTAG.NAME\" class=\"bold text-uppercase\">NAME</td><td \nng-if=\"vm.activePhotographersTableMode === \'photographers\'\" class=\"empty\"></td><td \nng-if=\"vm.activePhotographersTableMode === \'photographers\'\" translate=\"RUNTAG.PHOTOS\" \nclass=\"bold text-uppercase center\">PHOTOS</td><td ng-if=\"vm.activePhotographersTableMode === \'photographers\'\" \nclass=\"empty\"></td><td ng-if=\"vm.activePhotographersTableMode === \'photographers\'\" \ntranslate=\"RUNTAG.RECOGNIZED_PHOTOS\" class=\"bold text-uppercase center\">RECOGNIZED</td><td \nng-if=\"vm.activePhotographersTableMode === \'photographers\'\" class=\"empty\"></td><td \nng-if=\"vm.activePhotographersTableMode === \'photographers\'\" translate=\"RUNTAG.NOT_RECOGNIZED_PHOTOS\" \nclass=\"bold text-uppercase center\">NOT RECOGNIZED</td><td ng-if=\"vm.activePhotographersTableMode === \'photographers\'\" \nclass=\"empty\"></td><td ng-if=\"vm.activePhotographersTableMode === \'photographers\'\" translate=\"RUNTAG.DOWNLOADS\" \nclass=\"bold text-uppercase center\">DOWNLOADS</td><td ng-if=\"vm.activePhotographersTableMode === \'photographers\'\" \nclass=\"empty\"></td><td ng-if=\"vm.activePhotographersTableMode === \'photographers\'\" translate=\"RUNTAG.DOWNLOADS_UNIQUE\" \nclass=\"bold text-uppercase center\">DOWNLOADS UNIQUE</td><td \nng-if=\"vm.activePhotographersTableMode === \'photographers\'\" class=\"empty\"></td><td \nng-if=\"vm.activePhotographersTableMode === \'photographers\'\" translate=\"RUNTAG.DOWNLOADS_PERCENTAGE\" \nclass=\"bold text-uppercase center\">DOWNLOADS PERCENTAGE</td><td \nng-if=\"vm.activePhotographersTableMode === \'photographers\'\" class=\"empty\"></td><td \nng-if=\"vm.activePhotographersTableMode === \'statuses_photos\'\" translate=\"RUNTAG.UPLOADED\" \nclass=\"bold text-uppercase center\">UPLOADED</td><td ng-if=\"vm.activePhotographersTableMode === \'statuses_photos\'\" \ntranslate=\"RUNTAG.PROCESSED_OK\" class=\"bold text-uppercase center\">PROCESSED</td><td \nng-if=\"vm.activePhotographersTableMode === \'statuses_photos\'\" translate=\"RUNTAG.REPEATED\" \nclass=\"bold text-uppercase center\">REPEATED</td><td ng-if=\"vm.activePhotographersTableMode === \'statuses_photos\'\" \ntranslate=\"RUNTAG.AI_PENDING\" class=\"bold text-uppercase center text-nowrap\">AI PENDING</td><td \nng-if=\"vm.activePhotographersTableMode === \'statuses_photos\'\" translate=\"RUNTAG.AI_FAILED\" \nclass=\"bold text-uppercase center text-nowrap\">AI FAILED</td><td \nng-if=\"vm.activePhotographersTableMode === \'statuses_photos\'\" translate=\"RUNTAG.UNKNOWN_FAILURE\" \nclass=\"bold text-uppercase center text-nowrap\">WRONG FILES</td><td \nng-if=\"vm.activePhotographersTableMode === \'statuses_photos\'\" translate=\"RUNTAG.METADATA_ERROR\" \nclass=\"bold text-uppercase center text-nowrap\">METADATA ERROR</td><td \nng-if=\"vm.activePhotographersTableMode === \'statuses_photos\'\" translate=\"RUNTAG.CROP_FAILED\" \nclass=\"bold text-uppercase center text-nowrap\">CROP ERROR</td><td \nng-if=\"vm.activePhotographersTableMode === \'statuses_photos\'\" colspan=\"5\" class=\"empty\"></td></tr><tr \nng-repeat=\"photographer in vm.selectedGroup.photographers track by $index\" class=\"table-items-body\"><td></td><td \nclass=\"link\" ng-click=\"vm.filterPhotographers(photographer)\">{{photographer.name}}</td><td \nng-if=\"vm.activePhotographersTableMode === \'photographers\'\"></td><td \nng-if=\"vm.activePhotographersTableMode === \'photographers\'\" class=\"center\">{{photographer.photos | number:0}}</td><td \nng-if=\"vm.activePhotographersTableMode === \'photographers\'\"></td><td \nng-if=\"vm.activePhotographersTableMode === \'photographers\'\" class=\"center\">{{photographer.recognizedPhotos | number:0}}\n</td><td ng-if=\"vm.activePhotographersTableMode === \'photographers\'\"></td><td \nng-if=\"vm.activePhotographersTableMode === \'photographers\'\" class=\"center\" ng-class=\"{\'link\': vm.isAdmin}\" \nng-click=\"vm.isAdmin ? vm.getUnrecognizedPhotos(photographer) : null\">{{photographer.unrecognizedPhotos | number:0}}\n</td><td ng-if=\"vm.activePhotographersTableMode === \'photographers\'\"></td><td \nng-if=\"vm.activePhotographersTableMode === \'photographers\'\" class=\"center\">{{photographer.downloads | number:0}}</td>\n<td ng-if=\"vm.activePhotographersTableMode === \'photographers\'\"></td><td \nng-if=\"vm.activePhotographersTableMode === \'photographers\'\" class=\"center\">{{photographer.downloadsUnique | number:0}}\n</td><td ng-if=\"vm.activePhotographersTableMode === \'photographers\'\"></td><td \nng-if=\"vm.activePhotographersTableMode === \'photographers\'\" class=\"center\">\n{{photographer.downloadRatio || 0 | number:1}}%</td><td ng-if=\"vm.activePhotographersTableMode === \'photographers\'\">\n</td><td ng-if=\"vm.activePhotographersTableMode === \'statuses_photos\'\" class=\"center\">\n{{photographer.uploadedPhotos | number:0}}</td><td ng-if=\"vm.activePhotographersTableMode === \'statuses_photos\'\" \nclass=\"center\">{{photographer.processedPhotos | number:0}}</td><td \nng-if=\"vm.activePhotographersTableMode === \'statuses_photos\'\" class=\"center\">{{photographer.repeatedPhotos | number:0}}\n</td><td ng-if=\"vm.activePhotographersTableMode === \'statuses_photos\'\" class=\"center\">\n{{photographer.aiPending | number:0}}</td><td ng-if=\"vm.activePhotographersTableMode === \'statuses_photos\'\" \nclass=\"center\">{{photographer.aiFailed | number:0}}</td><td \nng-if=\"vm.activePhotographersTableMode === \'statuses_photos\'\" class=\"center\">{{photographer.wrongFiles | number:0}}\n</td><td ng-if=\"vm.activePhotographersTableMode === \'statuses_photos\'\" class=\"center\">\n{{photographer.metadataError | number:0}}</td><td ng-if=\"vm.activePhotographersTableMode === \'statuses_photos\'\" \nclass=\"center\">{{photographer.cropError | number:0}}</td><td \nng-if=\"vm.activePhotographersTableMode === \'statuses_photos\'\" colspan=\"5\"></td></tr><tr class=\"table-items-footer\"><td \nclass=\"bblr\"></td><td class=\"bold text-uppercase\" translate=\"RUNTAG.TOTAL\">TOTAL</td><td \nng-if=\"vm.activePhotographersTableMode === \'photographers\'\"></td><td \nng-if=\"vm.activePhotographersTableMode === \'photographers\'\" class=\"bold center\">\n{{vm.sumFields(vm.selectedGroup.photographers, \'photos\') | number:0}}</td><td \nng-if=\"vm.activePhotographersTableMode === \'photographers\'\"></td><td \nng-if=\"vm.activePhotographersTableMode === \'photographers\'\" class=\"bold center\">\n{{vm.sumFields(vm.selectedGroup.photographers, \'recognizedPhotos\') | number:0}}</td><td \nng-if=\"vm.activePhotographersTableMode === \'photographers\'\"></td><td \nng-if=\"vm.activePhotographersTableMode === \'photographers\'\" class=\"bold center\" ng-class=\"{\'link\': vm.isAdmin}\" \nng-click=\"vm.isAdmin ? vm.getUnrecognizedPhotos() : null\">\n{{vm.sumFields(vm.selectedGroup.photographers, \'unrecognizedPhotos\') | number:0}}</td><td \nng-if=\"vm.activePhotographersTableMode === \'photographers\'\"></td><td \nng-if=\"vm.activePhotographersTableMode === \'photographers\'\" class=\"bold center\">\n{{vm.sumFields(vm.selectedGroup.photographers, \'downloads\') | number:0}}</td><td \nng-if=\"vm.activePhotographersTableMode === \'photographers\'\"></td><td \nng-if=\"vm.activePhotographersTableMode === \'photographers\'\" class=\"bold center\">\n{{vm.sumFields(vm.selectedGroup.photographers, \'downloadsUnique\') | number:0}}</td><td \nng-if=\"vm.activePhotographersTableMode === \'photographers\'\"></td><td \nng-if=\"vm.activePhotographersTableMode === \'photographers\'\" class=\"bold center\">\n{{vm.sumFields(vm.selectedGroup.photographers, \'downloadRatio\') / vm.getAvailableDividerPhotographers() | number:1}}%\n</td><td ng-if=\"vm.activePhotographersTableMode === \'photographers\'\" class=\"bbrr\"></td><td \nng-if=\"vm.activePhotographersTableMode === \'statuses_photos\'\" class=\"bold center\">\n{{vm.sumFields(vm.selectedGroup.photographers, \'uploadedPhotos\') | number:0}}</td><td \nng-if=\"vm.activePhotographersTableMode === \'statuses_photos\'\" class=\"bold center\">\n{{vm.sumFields(vm.selectedGroup.photographers, \'processedPhotos\') | number:0}}</td><td \nng-if=\"vm.activePhotographersTableMode === \'statuses_photos\'\" class=\"bold center\">\n{{vm.sumFields(vm.selectedGroup.photographers, \'repeatedPhotos\') | number:0}}</td><td \nng-if=\"vm.activePhotographersTableMode === \'statuses_photos\'\" class=\"bold center\">\n{{vm.sumFields(vm.selectedGroup.photographers, \'aiPending\') | number:0}}</td><td \nng-if=\"vm.activePhotographersTableMode === \'statuses_photos\'\" class=\"bold center\">\n{{vm.sumFields(vm.selectedGroup.photographers, \'aiFailed\') | number:0}}</td><td \nng-if=\"vm.activePhotographersTableMode === \'statuses_photos\'\" class=\"bold center\">\n{{vm.sumFields(vm.selectedGroup.photographers, \'wrongFiles\') | number:0}}</td><td \nng-if=\"vm.activePhotographersTableMode === \'statuses_photos\'\" class=\"bold center\">\n{{vm.sumFields(vm.selectedGroup.photographers, \'metadataError\') | number:0}}</td><td \nng-if=\"vm.activePhotographersTableMode === \'statuses_photos\'\" class=\"bold center\">\n{{vm.sumFields(vm.selectedGroup.photographers, \'cropError\') | number:0}}</td><td \nng-if=\"vm.activePhotographersTableMode === \'statuses_photos\'\" colspan=\"5\" class=\"bbrr\"></td></tr><tr \nclass=\"table-divider\"></tr><tr ng-if=\"vm.selectedGroup.locations.length > 0\" class=\"table-title-head locations\"><td \nclass=\"table-icon center btlr\"><span class=\"material-symbols-outlined\">location_on</span></td><td class=\"btrr\" \ncolspan=\"14\"><span class=\"bold text-uppercase\" translate=\"RUNTAG.LOCATIONS\">LOCATIONS</span></td></tr><tr \nng-if=\"vm.selectedGroup.locations.length > 0\" class=\"table-info-header\"><td></td><td colspan=\"8\" \ntranslate=\"RUNTAG.NAME\" class=\"bold text-uppercase\">NAME</td><td class=\"empty\"></td><td colspan=\"5\" \ntranslate=\"RUNTAG.TOTAL\" class=\"bold text-uppercase center\">TOTAL</td></tr><tr \nng-if=\"vm.selectedGroup.locations.length > 0\" ng-repeat=\"location in vm.selectedGroup.locations\" \nclass=\"table-items-body\"><td></td><td colspan=\"8\" class=\"link\" ng-click=\"vm.showAllMedia(location)\">{{location.name}}\n</td><td></td><td colspan=\"5\" class=\"center\">{{location.photos | number:0}}</td></tr><tr \nng-if=\"vm.selectedGroup.locations.length > 0\" class=\"table-items-footer\"><td class=\"bblr\"></td><td colspan=\"8\"></td>\n<td></td><td colspan=\"5\" class=\"bbrr\"></td></tr><tr ng-if=\"vm.selectedGroup.locations.length > 0\" \nclass=\"table-divider\"></tr><tr id=\"full-runners-container\" class=\"table-title-head runners\"><td \nclass=\"table-icon center btlr\"><span class=\"material-symbols-outlined\">directions_run</span></td><td \ncolspan=\"{{ (vm.isAdmin ? 12 : 11) - (vm.eventVersion === \'v2\' ? 1 : 0) }}\"><span class=\"bold text-uppercase\" \ntranslate=\"RUNTAG.RUNNERS\">RUNNERS</span></td><td><md-input-container><label translate=\"RUNTAG.ORDER\">Order</label>\n<md-select ng-model=\"vm.usersOrder\" ng-change=\"vm.getUsers(true)\"><md-option translate=\"RUNTAG.NAME\" value=\"firstname\">\nName</md-option><md-option value=\"email\">Email</md-option><md-option translate=\"RUNTAG.LAST_ACCESS\" \nvalue=\"last_login_at\">Status</md-option></md-select></md-input-container></td><td class=\"btrr\"><md-input-container>\n<label translate=\"RUNTAG.ORDER\">Order</label><md-select ng-model=\"vm.usersSort\" ng-change=\"vm.getUsers(true)\">\n<md-option value=\"ASC\">ASC</md-option><md-option value=\"DESC\">DESC</md-option></md-select></md-input-container></td>\n</tr><tr class=\"table-info-header\"><td></td><td colspan=\"4\" translate=\"RUNTAG.NAME\" class=\"bold text-uppercase\">NAME\n</td><td ng-if=\"!vm.cartEnabled\" translate=\"RUNTAG.NUMBER\" class=\"bold text-uppercase center\">NUMBER</td><td \nng-if=\"vm.cartEnabled\" translate=\"RUNTAG.PROFILES.COLUMN_HEADER\" class=\"bold text-uppercase center\">Perfiles</td><td \nng-if=\"vm.eventVersion !== \'v2\'\" translate=\"RUNTAG.PHOTOS\" class=\"bold text-uppercase center\">FOTOS</td><td \ncolspan=\"4\" class=\"bold\">EMAIL</td><td translate=\"RUNTAG.SHOPPING\" class=\"bold text-uppercase center\">COMPRAS</td><td \ncolspan=\"2\" translate=\"RUNTAG.LAST_ACCESS\" class=\"bold text-uppercase\">LAST ACCESS</td><td \ntranslate=\"RUNTAG.DOWNLOADS\" class=\"bold text-uppercase\">DOWNLOADS</td></tr><tr ng-repeat=\"user in vm.usersArray\" \nng-click=\"vm.selectUserFromEventList(user)\" class=\"table-items-body runners-rows cursor-pointer\"><td \nclass=\"table-avatar\"></td><td colspan=\"4\">{{user.firstname}} {{user.lastname}}</td><td class=\"center\"><span \nng-if=\"!vm.cartEnabled\">{{vm.getUserNumber(user.user_params, user.current_number)}}</span><div ng-if=\"vm.cartEnabled\" \nclass=\"number-profiles\"><span ng-repeat=\"prof in vm.getUserProfiles(user)\" class=\"profile-badge\">{{prof}}</span> <span \nng-if=\"!vm.getUserProfiles(user).length\">{{vm.getUserNumber(user.user_params, user.current_number)}}</span></div></td>\n<td ng-if=\"vm.eventVersion !== \'v2\'\" class=\"center\">{{user.totalPhotos || 0 | number:0}}</td><td colspan=\"4\">\n{{user.email}}</td><td class=\"center\"><div layout=\"row\" layout-align=\"center center\" flex><div \nng-repeat=\"(statusId, count) in vm.checkUserOrders(user)\" style=\"position: relative; margin: 0 4px\"><span \nclass=\"material-symbols-outlined\" ng-class=\"vm.getOrderStatusColor(statusId)\" style=\"font-size: 20px\">\n{{vm.getOrderIcon(statusId)}}<md-tooltip md-direction=\"top\">{{vm.getOrderStatusName(statusId)}}: {{count}}</md-tooltip>\n</span><span \nstyle=\"position: absolute; top: -7px; right: -7px; background: #444; color: white; border-radius: 50%; width: 14px; height: 14px; font-size: 9px; display: flex; align-items: center; justify-content: center; font-weight: bold; border: 1px solid white\">\n{{count}}</span></div></div></td><td colspan=\"2\"><span ng-if=\"user.last_login_at\">\n{{vm.formatDate(user.last_login_at, \'dd MMM HH:mm\')}}</span> <span ng-if=\"!user.last_login_at\">Never logged</span></td>\n<td class=\"center\" ng-class=\"{\'user-downloads\': user.user_downloads.length > 0}\"><span \nng-if=\"user.user_downloads.length > 0\" ng-bind-html=\"user.user_downloads.length\"></span></td></tr><tr \nclass=\"table-items-footer\"><td class=\"bblr bbrr\" ng-if=\"vm.loadingMoreUsers\" \ncolspan=\"{{ (vm.isAdmin ? 15 : 14) - (vm.eventVersion === \'v2\' ? 1 : 0) }}\"><div layout=\"row\" \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"30\"></md-progress-circular>\n</div></td><td class=\"bblr bbrr cursor-pointer center\" ng-click=\"vm.getUsers()\" \nng-if=\"vm.moreUsersParams && !vm.loadingMoreUsers\" \ncolspan=\"{{ (vm.isAdmin ? 15 : 14) - (vm.eventVersion === \'v2\' ? 1 : 0) }}\"><div layout=\"row\" \nlayout-align=\"center center\" class=\"re-load-more font-size-15 bold\"><span class=\"material-symbols-outlined\">\nexpand_circle_down</span> <span class=\"text-uppercase\" translate=\"RUNTAG.LOAD_MORE\">LOAD MORE</span></div></td><td \nclass=\"bblr bbrr\" ng-if=\"!vm.moreUsersParams\" \ncolspan=\"{{ (vm.isAdmin ? 15 : 14) - (vm.eventVersion === \'v2\' ? 1 : 0) }}\"></td></tr></tbody></table></div><div \nng-if=\"vm.isAdmin && vm.archiveItems.length > 0\" \nng-include=\"\'app/main/apps/runtag/event/views/templates/archive-list.html\'\"></div></article>");
$templateCache.put("app/main/apps/runtag/event/views/templates/events-download-card.html","<div ng-click=\"mediaItem.unassignedDownload || vm.openImageDialog($event, mediaItem, mediaCollection)\" class=\"media\">\n<media ng-if=\"!mediaItem.unassignedDownload\" attachment=\"mediaItem.preview\"></media><div \nng-if=\"mediaItem.unassignedDownload\" class=\"unassigned-thumb\" layout=\"column\" layout-align=\"center center\"><md-icon \nclass=\"material-icons grey-400-fg\">image_not_supported</md-icon></div></div><div class=\"ml-auto mr-auto pb-50 info\">\n<span layout=\"row\" layout-align=\"start center\" class=\"mt-10\">#{{mediaItem.mediaId}}</span> <span \nng-if=\"!mediaItem.unassignedDownload\" layout=\"row\" layout-align=\"start center\" class=\"mt-10\">\n{{mediaItem.createdAtTransform | date: \'dd/MM/yyyy hh:mm:ss\'}}</span><md-chips ng-if=\"!mediaItem.unassignedDownload\" \nng-model=\"mediaItem.tags\" readonly=\"true\" md-removable=\"false\"><md-chip-template qiu-chip \nqiu-chip-reason=\"{{$chip.reason? $chip.reason : $chip.type}}\" \nqiu-chip-low-sharpness=\"{{vm.isAdmin && ( ($chip.face.quality.sharpness || $chip.quality.sharpness) < 2)}}\" \nqiu-chip-runner=\"{{vm.selectedUser.eventNumber === ($chip.runnerNumber ? $chip.runnerNumber.detectedText : null) ||\r\n                                            vm.selectedUser.eventNumber === $chip.detectedText ? \'current\' : \'other\'}}\" \ncontroller-vm=\"vm\"><span ng-if=\"$chip.type != \'unmatchedNumber\'\">{{$chip.runnerNumber.detectedText}}</span> <span \nng-if=\"$chip.type == \'unmatchedNumber\'\">{{$chip.detectedText}}</span></md-chip-template></md-chips><div \nng-if=\"!mediaItem.unassignedDownload\" class=\"download-container\"><md-button \nng-if=\"mediaItem.archiveStatus && mediaItem.archiveStatus !== \'UNARCHIVED\'\" \naria-label=\"{{ \'RUNTAG.RESTORE_FROM_ARCHIVE\' | translate }}\" class=\"md-button archive-restore-button\" \nng-class=\"{\r\n                \'status-archived\': mediaItem.archiveStatus === \'ARCHIVED\',\r\n                \'status-pending\':  mediaItem.archiveStatus === \'PENDING\',\r\n                \'status-restored\': mediaItem.archiveStatus === \'RESTORED\',\r\n                \'status-loading\':  mediaItem.archiveStatus === \'LOADING\'\r\n            }\" \nng-disabled=\"mediaItem.archiveStatus === \'LOADING\'\" ng-click=\"vm.onArchiveRestoreClick($event, mediaItem)\">\n<md-progress-circular ng-if=\"mediaItem.archiveStatus === \'LOADING\'\" md-mode=\"indeterminate\" md-diameter=\"20\">\n</md-progress-circular><span ng-if=\"mediaItem.archiveStatus === \'ARCHIVED\'\" translate=\"RUNTAG.RESTORE_FROM_ARCHIVE\">\nRestore from archive </span><span ng-if=\"mediaItem.archiveStatus === \'PENDING\'\" translate=\"RUNTAG.RESTORE_PENDING\">\nRestore pending </span><span ng-if=\"mediaItem.archiveStatus === \'RESTORED\'\" translate=\"RUNTAG.RESTORED\">Restored</span>\n<md-tooltip hide show-gt-xs ng-if=\"mediaItem.archiveStatus !== \'LOADING\'\"><span \nng-if=\"mediaItem.archiveStatus === \'ARCHIVED\'\" translate=\"RUNTAG.RESTORE_FROM_ARCHIVE\">Restore from archive </span>\n<span ng-if=\"mediaItem.archiveStatus === \'PENDING\'\" translate=\"RUNTAG.RESTORE_PENDING\">Restore pending </span><span \nng-if=\"mediaItem.archiveStatus === \'RESTORED\'\" translate=\"RUNTAG.RESTORED\">Restored</span></md-tooltip></md-button>\n<md-button aria-label=\"Set profile image\" class=\"md-icon-button set-image-button\" \nng-click=\"vm.setProfileImage(mediaItem)\"><md-icon md-font-icon=\"icon-account-circle\"></md-icon><md-tooltip hide \nshow-gt-xs><span>Set profile image</span></md-tooltip></md-button><md-button aria-label=\"Download\" \nclass=\"md-icon-button download-button\" ng-click=\"vm.downloadImage(mediaItem)\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.DOWNLOAD\"><md-icon md-font-icon=\"icon-box-download\"></md-icon><md-tooltip hide \nshow-gt-xs><span translate=\"CONTENT.DOWNLOAD\">Download</span></md-tooltip></md-button></div></div>");
$templateCache.put("app/main/apps/runtag/event/views/templates/events-downloads.html","<md-list-item id=\"images-container\"><div \nng-repeat=\"mediaItem in vm.userDownloads | filter:mediaSearch | orderBy: \'createdAtTransform\'\" \nng-init=\"mediaCollection = vm.userDownloads\" class=\"image-container\" \nng-include=\"\'app/main/apps/runtag/event/views/templates/events-download-card.html\'\"></div></md-list-item><div \nng-if=\"vm.userZipDownloads.length > 0\" class=\"zip-downloads-images\"><div class=\"zip-section-separator\"><span \nclass=\"zip-section-title\">Descargas en ZIP</span></div><div ng-repeat=\"zip in vm.userZipDownloads\" class=\"zip-pack\">\n<div class=\"zip-pack-header\"><md-icon class=\"material-icons blue-500-fg mr-10\">folder_zip</md-icon><span \nclass=\"font-size-14 bold grey-800-fg\">Pack #{{vm.userZipDownloads.length - $index}}</span> <span \nclass=\"font-size-12 grey-600-fg ml-10\">{{zip.created_at | date:\'dd/MM/yyyy HH:mm\'}} · {{zip.file_count}} fotos</span>\n</div><div class=\"zip-pack-grid\"><div ng-repeat=\"mediaItem in zip.images\" ng-init=\"mediaCollection = zip.images\" \nclass=\"image-container\" ng-include=\"\'app/main/apps/runtag/event/views/templates/events-download-card.html\'\"></div>\n</div></div></div>");
$templateCache.put("app/main/apps/runtag/event/views/templates/events-info-edit.html","<div id=\"data\" layout=\"column\" class=\"mail-list-pane\"><div layout=\"row\" class=\"mail-list-item\"><span \nclass=\"grey-500-fg font-size-14\" translate=\"USERS.NAME\">Name</span> <span class=\"font-size-16\"><input type=\"text\" \nng-model=\"vm.userCopy.firstname\"></span></div><div layout=\"row\" class=\"mail-list-item\"><span \nclass=\"grey-500-fg font-size-14\" translate=\"USERS.LAST_NAME\">Last name</span> <span class=\"font-size-16\"><input \ntype=\"text\" ng-model=\"vm.userCopy.lastname\"></span></div><div layout=\"row\" class=\"mail-list-item\"><span \nclass=\"grey-500-fg font-size-14\" translate=\"USERS.EMAIL\">Email</span> <span class=\"font-size-16\"><input type=\"text\" \nng-model=\"vm.userCopy.email\"></span></div><div layout=\"row\" class=\"mail-list-item\"><span \nclass=\"grey-500-fg font-size-14\" translate=\"USERS.DORSAL\">Dorsal</span> <span class=\"font-size-16\"><input type=\"text\" \nng-model=\"vm.userCopy.eventNumber\"></span></div><div layout=\"row\" class=\"mail-list-item\"><span \nclass=\"grey-500-fg font-size-14\" translate=\"USERS.COUNTRY\">Country</span> <span class=\"font-size-16 text-truncate\">\n<md-select ng-model=\"vm.userCopy.country\"><md-option ng-value=\"country.id_country\" ng-repeat=\"country in vm.countries\">\n{{country.country}}</md-option></md-select></span></div><div layout=\"row\" class=\"mail-list-item\"><span \nclass=\"grey-500-fg font-size-14\" translate=\"RUNTAG.AVAILABLE_ASSIGNS\">Available assign</span> <span \nclass=\"font-size-16\"><input type=\"number\" ng-model=\"vm.availableDownloads.avaliable_assign\"></span></div><div \nlayout=\"row\" class=\"mail-list-item\"><span class=\"grey-500-fg font-size-14\" translate=\"USERS.PASSWORD\">Password</span> \n<span class=\"font-size-16\"><input type=\"password\" ng-model=\"vm.userCopy.password\"></span></div></div><div layout=\"row\">\n<md-list flex=\"100\" layout=\"row\" layout-align=\"end center\" role=\"list\" class=\"md-toolbar-tools grey-100-bg\"><div>\n<md-button type=\"submit\" ng-click=\"vm.saveUser()\" class=\"send-button md-accent md-raised\" aria-label=\"SAVE\" \ntranslate=\"CONTENT.SAVE\" translate-attr-aria-label=\"CONTENT.SAVE\">SAVE</md-button><md-button type=\"button\" \nng-click=\"vm.cancelEditUser()\" class=\"md-raised md-warn\" aria-label=\"Cancel\" \ntranslate-attr-aria-label=\"CONTENT.CANCEL\" translate=\"CONTENT.CANCEL\">Cancel</md-button></div></md-list></div>");
$templateCache.put("app/main/apps/runtag/event/views/templates/events-info-preview.html","<div id=\"data\" layout=\"column\" class=\"mail-list-pane\"><div layout=\"row\" class=\"mail-list-item\"><span \nclass=\"grey-500-fg font-size-14\">Email</span> <span class=\"font-size-16 text-truncate\"><a \nhref=\"mailto:{{vm.selectedUser.email}}\">{{vm.selectedUser.email}}</a></span></div><div layout=\"row\" \nclass=\"mail-list-item\"><span class=\"grey-500-fg font-size-14\" translate=\"USERS.DORSAL\">Dorsal</span> <span \nclass=\"font-size-16 text-truncate\">{{vm.selectedUser.eventNumber}}</span></div><div layout=\"row\" \nclass=\"mail-list-item\"><span class=\"grey-500-fg font-size-14\" translate=\"USERS.COUNTRY\">Country</span> <span \nclass=\"font-size-16 text-truncate\" ng-repeat=\"country in vm.countries\" \nng-if=\"country.id_country == vm.selectedUser.country\">{{country.country}}</span></div><div layout=\"row\" \nclass=\"mail-list-item\"><span class=\"grey-500-fg font-size-14\" translate=\"RUNTAG.AVAILABLE_ASSIGNS\">Available assigns\n</span> <span class=\"font-size-16 text-truncate\">\n{{ vm.availableDownloads? vm.availableDownloads.avaliable_assign : 0 }}</span></div></div><div id=\"conexion\" \nlayout=\"column\" class=\"mail-list-pane\"><div class=\"md-toolbar-tools grey-100-bg connect-title mail-list-item\" \nlayout=\"row\"><span class=\"grey-700-fg\" translate=\"USERS.CONEXION\">Conexion</span></div><div layout=\"column\" \nclass=\"connect-container\"><div layout=\"row\" class=\"mail-list-item\"><span class=\"grey-500-fg font-size-14\" \ntranslate=\"USERS.LAST_LOGIN\">Last login</span> <span class=\"font-size-16 text-truncate\">\n{{vm.selectedUser.last_login_at}}</span></div><div layout=\"row\" class=\"mail-list-item\"><span \nclass=\"grey-500-fg font-size-14\" translate=\"USERS.CREATED_AT\">Created at</span> <span \nclass=\"font-size-16 text-truncate\">{{vm.selectedUser.created_at}}</span></div><div layout=\"row\" class=\"mail-list-item\">\n<span class=\"grey-500-fg font-size-14\" translate=\"USERS.UPDATED_AT\">Updated at</span> <span \nclass=\"font-size-16 text-truncate\">{{vm.selectedUser.updated_at}}</span></div></div></div>");
$templateCache.put("app/main/apps/runtag/event/views/templates/events-info.html","<div class=\"toolbar grey-100-bg colored-bg\" layout=\"row\" layout-align=\"space-between center\" scroll style><div \nlayout=\"row\" layout-align=\"start center\"><md-button aria-label=\"Preview\" class=\"md-icon-button\" \nng-class=\"{\'md-accent\':vm.currentTab == \'preview\'}\" ng-click=\"vm.infoUserView(\'preview\')\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.PREVIEW\"><md-icon md-font-icon=\"icon-eye\"></md-icon><md-tooltip hide show-gt-xs>\n<span translate=\"CONTENT.PREVIEW\">Preview</span></md-tooltip></md-button><div class=\"divider-vertical\" hide=\"\" \nshow-gt-sm=\"\"></div><md-button aria-label=\"Edit\" class=\"md-icon-button\" \nng-class=\"{\'md-accent\':vm.currentTab == \'edit\'}\" ng-click=\"vm.infoUserView(\'edit\');\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.EDIT\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip hide show-gt-xs>\n<span translate=\"CONTENT.EDIT\">Edit</span></md-tooltip></md-button><div class=\"divider-vertical\" hide show-gt-sm></div>\n</div></div><div ng-if=\"vm.currentTab == \'preview\'\" \nng-include=\"\'app/main/apps/runtag/event/views/templates/events-info-preview.html\'\"></div><div \nng-if=\"vm.currentTab == \'edit\'\" ng-include=\"\'app/main/apps/runtag/event/views/templates/events-info-edit.html\'\"></div>");
$templateCache.put("app/main/apps/runtag/event/views/templates/events-list.html","<article id=\"events-container-list\" class=\"mt-50 mb-50\"><div class=\"re-table events-table\"><div layout=\"row\" \nlayout-align=\"start center\" class=\"mb-20\"><md-button aria-label=\"ADD NEW\" \nclass=\"md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme\" hide show-gt-sm \nng-click=\"vm.openNewEventModal()\" translate=\"CONTENT.ADD\" type=\"button\">Add new</md-button><md-button \naria-label=\"ADD NEW\" class=\"md-fab md-mini md-accent green-500-bg md-raised md-ink-ripple md-default-theme\" hide-gt-sm \nng-click=\"vm.openNewEventModal()\" type=\"button\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div \nlayout=\"row\" layout-align=\"space-between center\" class=\"search-container mb-50 mt-0 py-5 px-10\"><input type=\"search\" \ntranslate translate-attr-placeholder=\"RUNTAG.SEARCH_EVENT_PLACEHOLDER\" ng-model=\"vm.eventsQuerySearch\" \nng-enter=\"vm.getEventsStats(true)\" class=\"font-size-15 pl-30\" placeholder=\"Buscar por nombre del evento\"><md-button \naria-label=\"search\" type=\"submit\" translate=\"RUNTAG.SEARCH\" ng-click=\"vm.getEventsStats(true)\">Buscar</md-button></div>\n<table><tbody><tr id=\"event-list-header\" class=\"table-title-head events\"><td class=\"table-icon center btlr\"><span \nclass=\"material-symbols-outlined\">event</span></td><td colspan=\"3\"><span class=\"bold text-uppercase\" \ntranslate=\"RUNTAG.EVENTS\">Events</span></td><td><md-input-container><label translate=\"RUNTAG.CLIENT\">Client</label>\n<md-select ng-model=\"vm.selectedClientId\" ng-change=\"vm.getEventsStats(true)\"><md-option value=\"all\"><span \ntranslate=\"RUNTAG.ALL_CLIENTS\">All Clients</span></md-option><md-option ng-repeat=\"client in vm.clients\" \nvalue=\"{{client.id}}\">{{client.client_name}}</md-option></md-select></md-input-container></td><td><md-input-container>\n<label translate=\"RUNTAG.STATE\">State</label><md-select ng-model=\"vm.selectedState\" \nng-change=\"vm.getEventsStats(true)\"><md-option value=\"all\"><span class=\"text-uppercase\">All States</span></md-option>\n<md-option class=\"text-uppercase\" ng-repeat=\"state in vm.eventsStates\" value=\"{{state.id_subsec}}\">\n{{ state.translations[vm.selectedLanguage] || state.subsec }}</md-option></md-select></md-input-container></td><td>\n<md-input-container><label translate=\"RUNTAG.ORDER\">Order</label><md-select ng-model=\"vm.eventsSortDir\" \nng-change=\"vm.getEventsStats(true)\"><md-option value=\"ASC\">ASC</md-option><md-option value=\"DESC\">DESC</md-option>\n</md-select></md-input-container></td><td class=\"btrr\"><md-button aria-label=\"reset\" translate=\"RUNTAG.RESET_FILTERS\" \nng-click=\"vm.resetFilters()\" class=\"font-size-10\">Resetear</md-button></td></tr><tr class=\"table-info-header\"><td></td>\n<td translate=\"RUNTAG.EVENT\" class=\"bold text-uppercase\">EVENT</td><td translate=\"RUNTAG.RUNNERS\" \nclass=\"bold text-uppercase center\">RUNNERS</td><td translate=\"RUNTAG.PHOTOS\" class=\"bold text-uppercase center\">PHOTOS\n</td><td translate=\"RUNTAG.ORDERS\" class=\"bold text-uppercase center\">ORDERS</td><td translate=\"RUNTAG.LOCAL\" \nclass=\"bold text-uppercase center\">LOCAL</td><td class=\"bold text-uppercase center\">USD TOTAL</td><td \ntranslate=\"RUNTAG.STATE\" class=\"bold text-uppercase center\">STATE</td></tr><tr ng-repeat=\"event in vm.eventsGroup\" \nng-click=\"vm.selectEvent(event)\" class=\"table-items-body runners-rows cursor-pointer\"><td class=\"table-avatar\"><img \nng-if=\"!event.imageError\" ng-src=\"{{ event.event_thumbnail }}\" alt=\"Event Image\"> <span ng-if=\"event.imageError\">\n{{ event.event_name.charAt(0) }}</span></td><td><div layout=\"column\" class=\"pt-5 pb-5\"><span \nclass=\"font-size-10 whitespace-nowrap\">{{vm.formatDate(event.event_date, \'dd MMMM yyyy\')}} </span><span \nng-bind-html=\"event.event_name\" class=\"bold font-size-13\"></span> <span>{{event.event_client_name}}</span></div></td>\n<td class=\"center\">{{event.event_total_runners}}</td><td class=\"center\"><span translate=\"RUNTAG.LOADING\" \nng-if=\"event.totalPhotos === undefined || event.totalPhotos === null\">Cargando... </span><span \ntranslate=\"RUNTAG.NO_DATA\" ng-if=\"event.totalPhotos === \'No hay datos\'\">No data </span><span \nng-if=\"event.totalPhotos && event.totalPhotos !== \'No hay datos\'\">{{event.totalPhotos}}</span></td><td class=\"center\">\n{{event.event_total_orders}}</td><td class=\"center\"><span \nng-if=\"event.event_sales_per_currency && event.event_sales_per_currency.length > 0\"><span \nng-repeat=\"currency in event.event_sales_per_currency\">{{ currency.amount }} {{ currency.currency_code }}<br></span>\n</span><span translate=\"RUNTAG.NO_SALES\" \nng-if=\"!event.event_sales_per_currency || event.event_sales_per_currency.length === 0\">No sales</span></td><td \nclass=\"center\"><span ng-if=\"event.event_total_sales_usd\">{{event.event_total_sales_usd}} USD</span> <span \ntranslate=\"RUNTAG.NO_SALES\" ng-if=\"!event.event_total_sales_usd\">No sales</span></td><td class=\"center\" \nng-click=\"vm.changeSubsec(event, $event)\"><span class=\"event-badge text-uppercase\" \nstyle=\"background-color: {{ event.event_state_color }}; color: #FFFFFF\">{{ event.event_state_name }}</span></td></tr>\n<tr class=\"table-items-footer\"><td class=\"bblr bbrr\" ng-if=\"vm.isLoadingMoreEvents\" colspan=\"8\"><div layout=\"row\" \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"30\"></md-progress-circular>\n</div></td><td class=\"bblr bbrr cursor-pointer center\" ng-click=\"vm.getEventsStats(false)\" \nng-if=\"vm.moreEventsParams && !vm.isLoadingMoreEvents\" colspan=\"8\"><div layout=\"row\" layout-align=\"center center\" \nclass=\"re-load-more font-size-15 bold\"><span class=\"material-symbols-outlined\">expand_circle_down</span> <span \nclass=\"text-uppercase\" translate=\"RUNTAG.LOAD_MORE\">LOAD MORE</span></div></td><td class=\"bblr bbrr\" \nng-if=\"!vm.moreEventsParams\" colspan=\"8\"></td></tr></tbody></table></div></article>");
$templateCache.put("app/main/apps/runtag/event/views/templates/events-media.html","<div class=\"processing-container\" ng-if=\"vm.searchAssignBulkSaving\"><div class=\"content\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"48\"></md-progress-circular><span>\nAsignando fotos al perfil… {{ vm.searchAssignBulkDone || 0 }} / {{ vm.searchAssignBulkTotal || 0 }}</span></div></div>\n<div class=\"toolbar-wrapper\" layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start stretch\" \nlayout-align-gt-sm=\"space-between center\"><div class=\"user-media-toolbar\" layout=\"row\" layout-align=\"start center\" \nflex><div class=\"search\" layout=\"row\" layout-align=\"start center\" ng-if=\"!vm.searchedItems.length\"><input type=\"text\" \ntranslate translate-attr-placeholder=\"RUNTAG.SEARCH\" ng-model=\"vm.mediaSearch\" class=\"input-query\" \nng-enter=\"vm.filterUserMedia()\" \nstyle=\"border: none; background: transparent; flex: 1; font-size: 15px; outline: none; height: 100%\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.clearMediaSearch()\" ng-if=\"vm.mediaSearch\" aria-label=\"Clear Search\" \nstyle=\"width: 30px; height: 30px; min-height: 30px; margin: 0 4px; padding: 0\"><md-icon \nmd-font-icon=\"icon-close-circle\" style=\"font-size: 20px; color: rgba(0,0,0,0.4)\"></md-icon><md-tooltip><span \ntranslate=\"RUNTAG.CLEAR_SEARCH\">Clear search</span></md-tooltip></md-button><md-button class=\"md-raised\" \nng-click=\"vm.filterUserMedia()\" aria-label=\"Search\" \nstyle=\"border-radius: 20px; min-height: 34px; height: 34px; line-height: 34px; margin: 0; background-color: #039BE5; color: white; text-transform: none; padding: 0 20px; font-weight: 600; box-shadow: 0 2px 4px rgba(3, 155, 229, 0.3)\">\n<md-icon md-font-icon=\"icon-magnify\" style=\"color: white; font-size: 20px; margin-right: 8px\"></md-icon><span \ntranslate=\"RUNTAG.SEARCH\" hide-xs>Search</span></md-button></div><div layout=\"row\" layout-align=\"start center\" \nng-if=\"vm.searchedItems.length\"><md-checkbox ng-checked=\"vm.isAllSearchedItemsSelected()\" \nng-click=\"vm.toggleSelectAllSearchedItems()\" aria-label=\"Select all searched items\" class=\"m-0 mr-10\"></md-checkbox>\n<span class=\"mr-10 font-weight-300\">Seleccionar todo</span> <span class=\"font-weight-600\">\nBusqueda por concidencias faciales</span></div></div><div layout=\"row\" layout-align=\"end center\" class=\"ml-auto\"><span \nclass=\"close-button mr-10\" ng-click=\"vm.resetSearchByFace()\" ng-if=\"vm.searchedItems.length\" \nstyle=\"cursor: pointer; background: rgba(0,0,0,0.1); border-radius: 50%; width: 20px; height: 20px; display: flex; align-items: center; justify-content: center; color: red; font-size: 12px; font-weight: bold\">\nX</span><div class=\"download-container mr-10\" ng-if=\"vm.selectedGroup.id_subsec === 6\"><md-button \nclass=\"md-button archive-restore-button status-archived\" ng-click=\"vm.restoreRunnerFiles()\" \nng-disabled=\"!vm.hasArchivedPhotos()\" aria-label=\"Restore all photos from archive\"><span \ntranslate=\"RUNTAG.RESTORE_ALL\">Restore all</span></md-button></div><span \nclass=\"toolbar-text mr-20 font-size-12 secondary-text\" ng-if=\"!vm.searchedItems.length\"><span \ntranslate=\"RUNTAG.PHOTOS\">Photos</span>: <span class=\"bold\">{{vm.mediaPagination.total || 0}}</span></span><md-select \naria-label=\"Change Sort\" ng-change=\"vm.changeSort()\" ng-model=\"vm.sort\" ng-if=\"!vm.searchedItems.length\"><md-option \nvalue=\"asc\">ASC</md-option><md-option value=\"desc\">DESC</md-option></md-select><md-select class=\"ml-10\" \naria-label=\"Change Limit Per Page\" ng-change=\"vm.changeLimit()\" ng-model=\"vm.limitPerPage\" \nng-if=\"!vm.searchedItems.length\"><md-option ng-repeat=\"limit in vm.limitMenu\" ng-value=\"limit\">{{limit}}</md-option>\n</md-select><div class=\"pagination-toolbar\" layout=\"row\" layout-align=\"center center\" ng-if=\"!vm.searchedItems.length\">\n<md-button ng-disabled=\"vm.loadingMore || vm.mediaPagination.currentIndex === 0\" ng-click=\"vm.prevPage()\" \nclass=\"md-icon-button\" aria-label=\"Previous Page\"><span class=\"material-symbols-outlined\">chevron_left</span>\n</md-button><span class=\"page-info\">{{vm.mediaPagination.currentIndex + 1}}</span><md-button \nng-disabled=\"vm.loadingMore || !vm.mediaPagination.hasNext\" ng-click=\"vm.nextPage()\" class=\"md-icon-button\" \naria-label=\"Next Page\"><span class=\"material-symbols-outlined\">chevron_right</span></md-button></div><md-button \nclass=\"md-icon-button download-photos\" aria-label=\"Search photos by avatar\" ng-click=\"vm.searchByAvatar()\" \ntranslate=\"\" translate-attr-aria-label=\"USERS.USER-SEARCH-BY-AVATAR\" ng-if=\"!vm.searchedItems.length\"><md-icon \nmd-font-icon=\"icon-account-search\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"USERS.USER-SEARCH-BY-AVATAR\">\nSearch photos by avatar</span></md-tooltip></md-button><md-button class=\"md-icon-button download-photos\" \naria-label=\"Download all images to app\" ng-click=\"vm.downloadImage(\'all\')\" translate=\"\" \ntranslate-attr-aria-label=\"USERS.USER-DOWNLOAD-MEDIA\" ng-if=\"!vm.searchedItems.length\"><md-icon \nmd-font-icon=\"icon-download\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"USERS.USER-DOWNLOAD-MEDIA\">\nDownload all media</span></md-tooltip></md-button><md-button class=\"md-icon-button download-photos\" \naria-label=\"Unassign images\" ng-click=\"vm.deleteSelectedMedias()\" translate=\"\" \ntranslate-attr-aria-label=\"USERS.USER-UNASSIGN-IMAGES\" ng-if=\"vm.selectedMedias.length > 0\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"USERS.USER-UNASSIGN-IMAGES\">\nUnassign images</span></md-tooltip></md-button><md-button class=\"md-icon-button assign-bulk\" \naria-label=\"Assign images\" ng-click=\"vm.initAssignBulk()\" translate=\"\" \ntranslate-attr-aria-label=\"USERS.USER-ASSIGN-IMAGES\" ng-if=\"vm.selectedMedias.length > 0\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"USERS.USER-ASSIGN-IMAGES\">\nAssign images</span></md-tooltip></md-button><md-menu \nng-if=\"vm.cartEnabled && vm.runnerProfiles.length && vm.selectedMedias.length > 0\"><md-button \nclass=\"md-icon-button assign-bulk-profile\" ng-click=\"$mdMenu.open($event)\" ng-disabled=\"vm.searchAssignBulkSaving\" \naria-label=\"Asignar seleccionadas a perfil\"><md-icon class=\"material-icons\">badge</md-icon><md-tooltip hide show-gt-xs>\nAsignar seleccionadas a perfil</md-tooltip></md-button><md-menu-content><md-menu-item \nng-repeat=\"p in vm.runnerProfiles\"><md-button ng-click=\"vm.assignSelectedSearchToProfile(p)\">\n{{ vm.runnerProfileLabel(p) }} ({{vm.selectedMedias.length}})</md-button></md-menu-item></md-menu-content></md-menu>\n</div></div><div ng-if=\"vm.loadingMore\" class=\"media-list-loading\" layout=\"column\" layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"48\"></md-progress-circular><span class=\"loading-text\">\nLoading media...</span></div><md-list-item ng-if=\"!vm.loadingMore && vm.items.length > 0 && !vm.searchedItems.length\" \nid=\"images-container\"><div ng-repeat=\"mediaItem in vm.items | orderBy: \'createdAtTransform\'\" \nng-if=\"mediaItem.location != \'generic\'\" class=\"image-container\"><ng-container \nng-include=\"\'app/main/apps/runtag/event/views/templates/item-media-unified.html\'\" \nng-init=\"galleryList = vm.items; isSearch = false\"></ng-container></div><div class=\"pagination-footer\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!vm.searchedItems.length\"><md-button \nng-disabled=\"vm.loadingMore || vm.mediaPagination.currentIndex === 0\" ng-click=\"vm.prevPage()\" \nclass=\"md-accent md-raised\" aria-label=\"Previous Page\"><span class=\"material-symbols-outlined\">chevron_left</span> \n<span translate=\"USERS.PREVIOUS\">PREVIOUS</span></md-button><span class=\"page-info text-bold\">\n{{vm.mediaPagination.currentIndex + 1}}</span><md-button ng-disabled=\"vm.loadingMore || !vm.mediaPagination.hasNext\" \nng-click=\"vm.nextPage()\" class=\"md-accent md-raised\" aria-label=\"Next Page\"><span translate=\"USERS.NEXT\">NEXT</span> \n<span class=\"material-symbols-outlined\">chevron_right</span></md-button></div></md-list-item><div \nng-if=\"!vm.loadingMore && vm.items.length === 0 && !vm.searchedItems.length\" class=\"no-media-placeholder\" \nlayout=\"column\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-image-off\" class=\"placeholder-icon\"></md-icon>\n<span class=\"placeholder-text\">There are no items to display</span></div><div id=\"images-container\" \nng-if=\"!vm.loadingMore && vm.searchedItems.length\" class=\"all-media\"><div layout=\"row\" layout-wrap \nlayout-align=\"start stretch\"><div \nng-repeat=\"mediaItem in vm.searchedItems | filter:vm.mediaSearch | orderBy: \'id_media\'\" class=\"image-container\">\n<ng-container ng-include=\"\'app/main/apps/runtag/event/views/templates/item-media-unified.html\'\" \nng-init=\"galleryList = vm.searchedItems; isSearch = true\"></ng-container></div></div></div><div ng-if=\"vm.addUserBulk\" \nid=\"modal-add-user-bulk\"><div class=\"content\"><div class=\"toolbar\" layout=\"row\"><md-button \nclass=\"close-button md-icon-button\" ng-click=\"vm.closeAssignBulk()\" aria-label=\"Close dialog\" tranlate \ntranslate-aria-label=\"CONTENT.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div \nclass=\"search\" ng-if=\"vm.usersToAdd.length == 0\"><div layout=\"row\" layout-align=\"space-between\"><input type=\"search\" \ntranslate translate-attr-placeholder=\"USERS.SEARCH_USER_PLACEHOLDER\" ng-model=\"vm.userSearchString\" \nclass=\"input-query\" ng-enter=\"vm.searchAssignUser()\"><md-button class=\"submit-button\" type=\"submit\" \ntranslate=\"USERS.SEARCH\" ng-click=\"vm.searchAssignUser()\"></md-button></div></div><div class=\"list\" \nng-if=\"vm.usersToAdd.length > 0\"><md-button class=\"return-button md-icon-button\" ng-click=\"vm.returnToSearch()\" \naria-label=\"Return to search\" tranlate translate-aria-label=\"CONTENT.RETURN\"><md-icon md-font-icon=\"icon-arrow-left\">\n</md-icon></md-button><div class=\"list-content\"><div class=\"user\" ng-repeat=\"user in vm.usersToAdd\" \nng-click=\"vm.userBulk(user)\"><div layout=\"row\" layout-align=\"start center\"><div><media ng-if=\"!user.avatar\" \nclass-img=\"avatar\" force-class use-default></media><img ng-if=\"user.avatar\" ng-src=\"{{user.avatar}}\" class=\"avatar\">\n</div><div layout=\"column\"><span><strong>{{user.firstname}} {{user.lastname}}</strong></span> <span>{{user.email}}\n</span> <span>{{user.eventNumber}}</span></div></div></div></div></div></div></div>");
$templateCache.put("app/main/apps/runtag/event/views/templates/events-profiles.html","<div id=\"runner-profiles-tab\" class=\"runner-profiles-tab\"><div class=\"profiles-toolbar\" layout=\"row\" \nlayout-align=\"start center\"><md-menu><md-button class=\"md-raised md-primary add-profile-btn\" \nng-click=\"$mdMenu.open($event)\" ng-disabled=\"vm.runnerProfilesLoading\" \naria-label=\"{{ \'RUNTAG.PROFILES.ADD\' | translate }}\"><md-icon class=\"material-icons\">add</md-icon></md-button>\n<md-menu-content><md-menu-item><md-button ng-click=\"vm.addRunnerProfileByDorsal($event)\" \ntranslate=\"RUNTAG.PROFILES.ADD_BY_DORSAL\">Por dorsal</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.addRunnerProfileByFace($event)\" translate=\"RUNTAG.PROFILES.ADD_BY_FACE\">Por cara (subir foto)</md-button>\n</md-menu-item></md-menu-content></md-menu><div ng-if=\"vm.runnerProfiles.length\" class=\"profile-subtabs\" layout=\"row\">\n<div ng-repeat=\"p in vm.runnerProfiles\" ng-click=\"vm.selectRunnerProfile($index)\" class=\"profile-subtab\" \nng-class=\"{\'active\': vm.runnerProfileIndex === $index}\"><md-icon ng-if=\"p.is_face || p.face_only\" \nclass=\"material-icons\">face</md-icon><span>{{vm.runnerProfileLabel(p)}}</span> <span ng-if=\"p.dorsalNumber\" \nclass=\"profile-subtab-dorsal\">· Dorsal {{p.dorsalNumber}}</span> <span>({{p.items_total}})</span></div></div></div><div\n ng-if=\"vm.runnerProfilesError\" translate=\"RUNTAG.PROFILES.LOAD_ERROR\">\nNo se pudieron cargar los perfiles. Pulsa recargar para reintentar.</div><div \nng-if=\"!vm.runnerProfilesLoading && !vm.runnerProfilesError && vm.runnerProfiles.length === 0\" \ntranslate=\"RUNTAG.PROFILES.EMPTY\">Este usuario no tiene perfiles en el evento.</div><div \nng-repeat=\"p in vm.runnerProfiles\" ng-if=\"vm.runnerProfileIndex === $index\" class=\"profile-panel\"><div \nclass=\"profile-info\" layout=\"row\" layout-align=\"space-between center\" layout-wrap><div><div class=\"h3\">\n{{vm.runnerProfileLabel(p)}}</div><div ng-if=\"!p.is_face && p.dorsal\" translate=\"RUNTAG.PROFILES.DORSAL\" \ntranslate-values=\"{dorsal: p.dorsal}\"></div></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button download-photos\" ng-click=\"vm.downloadProfilePhotos(p)\" \nng-disabled=\"vm.generatingZip || !p.photos.length\" aria-label=\"Descarga de archivo\" translate \ntranslate-attr-aria-label=\"USERS.USER-DOWNLOAD-MEDIA\"><md-icon md-font-icon=\"icon-download\"></md-icon></md-button>\n<md-button ng-if=\"!p.face_only\" class=\"md-raised\" ng-click=\"vm.renameRunnerProfile(p, $event)\" \ntranslate=\"RUNTAG.PROFILES.RENAME\">Renombrar</md-button><md-button ng-if=\"!p.face_only\" class=\"md-raised md-warn\" \nng-click=\"vm.deleteRunnerProfile(p, $event)\" translate=\"RUNTAG.PROFILES.DELETE\">Borrar</md-button></div></div><div \nng-if=\"p.recognitionFaces.length\" class=\"recognition-faces\"><div class=\"recognition-faces-title\"><span>\n{{ \'RUNTAG.PROFILES.RECOGNITION_FACES\' | translate }} ({{p.recognitionFaces.length}})</span></div><div \nclass=\"recognition-faces-grid\" layout=\"row\" layout-wrap layout-align=\"start start\"><div \nng-repeat=\"rf in p.recognitionFaces\" class=\"recognition-face\"><div class=\"recognition-face-thumb\" \nng-class=\"{\'is-clickable\': rf.sourceMedia}\" \nng-click=\"rf.sourceMedia && vm.openImageDialog($event, rf.sourceMedia, [rf.sourceMedia])\"><img ng-if=\"rf.cropUrl\" \nng-src=\"{{rf.cropUrl}}\" alt=\"\"><media ng-if=\"!rf.cropUrl && rf.preview\" attachment=\"rf.preview\"></media>\n<md-progress-circular ng-if=\"!rf.cropUrl && !rf.preview && rf.loadingThumb\" md-mode=\"indeterminate\" md-diameter=\"20\">\n</md-progress-circular><md-icon ng-if=\"!rf.cropUrl && !rf.preview && !rf.loadingThumb\" \nclass=\"material-icons grey-400-fg\">face</md-icon><md-tooltip ng-if=\"rf.sourceMediaId\">Ver foto: #{{rf.sourceMediaId}}\n</md-tooltip></div><div class=\"recognition-face-src\" ng-if=\"rf.sourceMediaId\">#{{rf.sourceMediaId}}</div></div></div>\n</div><div class=\"profile-loader\" ng-if=\"p.loadingPhotos\" layout=\"row\" layout-align=\"start center\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"22\"></md-progress-circular><span \ntranslate=\"RUNTAG.PROFILES.LOADING_PHOTOS\">Cargando fotos…</span></div><div ng-if=\"!p.loadingPhotos && p.photos\"><div \nng-if=\"p.photosTruncated\" class=\"profile-truncated-warning\" layout=\"column\" layout-align=\"center center\"><md-icon \nclass=\"material-icons\">warning</md-icon><span translate=\"RUNTAG.PROFILES.PHOTOS_TRUNCATED\">\nEste dorsal tiene demasiadas fotos: se muestran solo las más recientes.</span></div><div \nng-if=\"p.removedPhotos.length\" class=\"removed-photos-section\"><div class=\"removed-photos-header\" \nng-click=\"vm.toggleRemoved(p)\"><span>{{ \'RUNTAG.PROFILES.REMOVED_SECTION\' | translate }} ({{p.removedPhotos.length}})\n</span><md-icon class=\"material-icons\">{{ p._showRemoved ? \'expand_less\' : \'expand_more\' }}</md-icon></div><div \nid=\"images-container\" class=\"all-media\" ng-if=\"p._showRemoved\"><div layout=\"row\" layout-wrap \nlayout-align=\"start stretch\"><div ng-repeat=\"mediaItem in p.removedPhotos | limitTo: (p._removedShown || 0)\" \nclass=\"image-container removed\"><ng-container \nng-include=\"\'app/main/apps/runtag/event/views/templates/item-media-unified.html\'\" \nng-init=\"galleryList = p.removedPhotos; isSearch = false; hideSetProfileImg = true\"></ng-container><button \ntype=\"button\" class=\"profile-restore-photo\" ng-click=\"vm.restorePhotoToProfile(p, mediaItem, $event)\"><md-icon \nclass=\"material-icons\">restore</md-icon><span translate=\"RUNTAG.PROFILES.RESTORE\">Restaurar</span></button></div></div>\n<div layout=\"row\" layout-align=\"center center\" class=\"removed-load-more\" \nng-if=\"(p._removedShown || 0) < p.removedPhotos.length\"><md-button class=\"md-raised\" ng-click=\"vm.showMoreRemoved(p)\">\n{{ \'RUNTAG.PROFILES.LOAD_MORE\' | translate }} ({{ p.removedPhotos.length - (p._removedShown || 0) }})</md-button></div>\n</div></div><div class=\"profile-photos-header\"><span>{{ \'RUNTAG.PROFILES.PROFILE_PHOTOS\' | translate }}</span></div>\n<div><span ng-if=\"p.no_order\" translate=\"RUNTAG.PROFILES.OWN_NO_COLLECTION\">— dorsal propio, sin colección propia\n</span></div><div ng-if=\"p.photos.length === 0\" translate=\"RUNTAG.PROFILES.NO_PHOTOS\">Sin fotos.</div><div \nid=\"images-container\" class=\"all-media\" ng-if=\"p.photos.length\"><div layout=\"row\" layout-wrap \nlayout-align=\"start stretch\"><div ng-repeat=\"mediaItem in p.photos | limitTo: (p._photosShown || 0)\" \nclass=\"image-container\"><button type=\"button\" class=\"profile-remove-photo\" \nng-click=\"vm.unassignPhotoFromProfile(p, mediaItem, $event)\" \naria-label=\"{{ \'RUNTAG.PROFILES.REMOVE_PHOTO\' | translate }}\"><md-icon md-font-icon=\"icon-close\"></md-icon></button>\n<ng-container ng-include=\"\'app/main/apps/runtag/event/views/templates/item-media-unified.html\'\" \nng-init=\"galleryList = p.photos; isSearch = false; hideSetProfileImg = true\"></ng-container></div></div><div \nlayout=\"row\" layout-align=\"center center\" class=\"removed-load-more\" ng-if=\"(p._photosShown || 0) < p.photos.length\">\n<md-button class=\"md-raised\" ng-click=\"vm.showMorePhotos(p)\">\n{{ \'RUNTAG.PROFILES.LOAD_MORE\' | translate }} ({{ p.photos.length - (p._photosShown || 0) }})</md-button></div></div>\n</div></div></div>");
$templateCache.put("app/main/apps/runtag/event/views/templates/events-search-media.html","<div><div class=\"toolbar\"><div class=\"tools-container\"><md-button ng-disabled=\"vm.loadingMore\" \nng-click=\"vm.getBackAllMedia()\" class=\"rounded-20 send-button md-accent md-raised\" aria-label=\"save\"><span \nclass=\"text\">Return</span></md-button></div><div class=\"paginator-container\"><md-button \nclass=\"md-icon-button assign-bulk\" aria-label=\"Assign images\" ng-click=\"vm.initAssignBulk()\" translate=\"\" \ntranslate-attr-aria-label=\"USERS.USER-ASSIGN-IMAGES\" ng-if=\"vm.selectedMedias.length > 0\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"USERS.USER-ASSIGN-IMAGES\">\nAssign images</span></md-tooltip></md-button><md-select aria-label=\"Change Sort\" ng-change=\"vm.changeSort()\" \nng-model=\"vm.sort\"><md-option value=\"asc\">ASC</md-option><md-option value=\"desc\">DESC</md-option></md-select><md-select\n aria-label=\"Change Limit Per Page\" ng-change=\"vm.changeLimit()\" ng-model=\"vm.limitPerPage\"><md-option \nng-repeat=\"limit in vm.limitMenu\" ng-value=\"limit\">{{limit}}</md-option></md-select><div class=\"pagination-toolbar\" \nlayout=\"row\" layout-align=\"center center\"><md-button \nng-disabled=\"vm.loadingMore || vm.mediaPagination.currentIndex === 0\" ng-click=\"vm.prevPage()\" class=\"md-icon-button\" \naria-label=\"Previous Page\"><span class=\"material-symbols-outlined\">chevron_left</span></md-button><span \nclass=\"page-info\">{{vm.mediaPagination.currentIndex + 1}}</span><md-button \nng-disabled=\"vm.loadingMore || !vm.mediaPagination.hasNext\" ng-click=\"vm.nextPage()\" class=\"md-icon-button\" \naria-label=\"Next Page\"><span class=\"material-symbols-outlined\">chevron_right</span></md-button></div></div></div><div \nng-if=\"vm.loadingMore\" class=\"media-list-loading\" layout=\"column\" layout-align=\"center center\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"48\"></md-progress-circular><span class=\"loading-text\">Loading media...</span>\n</div><div ng-if=\"!vm.loadingMore\"><md-list-item ng-if=\"vm.items.length > 0 && !vm.searchedItems.length\" \nid=\"images-container\" class=\"all-media\"><ng-content ng-if=\"!vm.eventVersion\" \nng-include=\"\'app/main/apps/runtag/event/views/templates/item-list-events.html\'\"></ng-content><ng-content \nng-if=\"vm.eventVersion == \'v2\' || vm.eventVersion == \'v3\'\" \nng-include=\"\'app/main/apps/runtag/event/views/templates/item-list-events-v2.html\'\"></ng-content><div \nclass=\"pagination-footer\" layout=\"row\" layout-align=\"center center\"><md-button \nng-disabled=\"vm.loadingMore || vm.mediaPagination.currentIndex === 0\" ng-click=\"vm.prevPage()\" \nclass=\"md-accent md-raised\" aria-label=\"Previous Page\"><span class=\"material-symbols-outlined\">chevron_left</span> \n<span translate=\"USERS.PREVIOUS\">PREVIOUS</span></md-button><span class=\"page-info text-bold\">\n{{vm.mediaPagination.currentIndex + 1}}</span><md-button ng-disabled=\"vm.loadingMore || !vm.mediaPagination.hasNext\" \nng-click=\"vm.nextPage()\" class=\"md-accent md-raised\" aria-label=\"Next Page\"><span translate=\"USERS.NEXT\">NEXT</span> \n<span class=\"material-symbols-outlined\">chevron_right</span></md-button></div></md-list-item><div \nng-if=\"vm.items.length === 0 && !vm.searchedItems.length\" class=\"no-media-placeholder\" layout=\"column\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-image-off\" class=\"placeholder-icon\"></md-icon><span \nclass=\"placeholder-text\">There are no items to display</span><md-button ng-click=\"vm.getBackAllMedia()\" \nclass=\"md-accent\">Return to dashboard</md-button></div><md-list-item id=\"images-container\" class=\"all-media\" \nng-if=\"vm.searchedItems.length\"><div class=\"toolbar-container\"><span>Busqueda por concidencias faciales</span><span \nclass=\"close-button\" ng-click=\"vm.resetSearchByFace()\">X</span></div><div \nng-repeat=\"mediaItem in vm.searchedItems | filter:mediaSearch | orderBy: \'id_media\'\" class=\"image-container\">\n<ng-container ng-include=\"\'app/main/apps/runtag/event/views/templates/item-media-unified.html\'\" \nng-init=\"galleryList = vm.searchedItems; isSearch = true\"></ng-container></div></md-list-item></div><div \nng-if=\"vm.addUserBulk\" id=\"modal-add-user-bulk\"><div class=\"content\"><div class=\"toolbar\" layout=\"row\"><md-button \nclass=\"close-button md-icon-button\" ng-click=\"vm.closeAssignBulk()\" aria-label=\"Close dialog\" tranlate \ntranslate-aria-label=\"CONTENT.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div \nclass=\"search\" ng-if=\"vm.usersToAdd.length == 0\"><div layout=\"row\" layout-align=\"space-between\"><input type=\"search\" \ntranslate translate-attr-placeholder=\"USERS.SEARCH_USER_PLACEHOLDER\" ng-model=\"vm.userSearchString\" \nclass=\"input-query\" ng-enter=\"vm.searchAssignUser()\"><md-button class=\"submit-button\" type=\"submit\" \ntranslate=\"USERS.SEARCH\" ng-click=\"vm.searchAssignUser()\"></md-button></div></div><div class=\"list\" \nng-if=\"vm.usersToAdd.length > 0\"><md-button class=\"return-button md-icon-button\" ng-click=\"vm.returnToSearch()\" \naria-label=\"Return to search\" tranlate translate-aria-label=\"CONTENT.RETURN\"><md-icon md-font-icon=\"icon-arrow-left\">\n</md-icon></md-button><div class=\"list-content\"><div class=\"user\" ng-repeat=\"user in vm.usersToAdd\" \nng-click=\"vm.userBulk(user)\"><div layout=\"row\" layout-align=\"start center\"><div><media ng-if=\"!user.avatar\" \nclass-img=\"avatar\" force-class use-default></media><img ng-if=\"user.avatar\" ng-src=\"{{user.avatar}}\" class=\"avatar\">\n</div><div layout=\"column\"><span><strong>{{user.firstname}} {{user.lastname}}</strong></span> <span>{{user.email}}\n</span> <span>{{user.eventNumber}}</span></div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/apps/runtag/event/views/templates/events-seeker.html","<div id=\"nav\"><ul layout=\"row\"><li><a ng-click=\"vm.changeMediaTemplate(\'face\')\" \nng-class=\"vm.mediaTemplate == \'face\' ? \'active\' : \'\'\" class=\"grey-700-fg\" translate=\"USERS.BY_FACE\">By face</a></li>\n<li><a ng-click=\"vm.changeMediaTemplate(\'text\')\" ng-class=\"vm.mediaTemplate == \'text\' ? \'active\' : \'\'\" \nclass=\"grey-700-fg\" translate=\"USERS.BY_CURRENT_NUMBER\">By text</a></li></ul></div><div flex layout=\"column\" \nlayout-align=\"center center\" ng-show=\"vm.isLoadingDetectedText || vm.isLoadingDetectedFace\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nng-if=\"!vm.isLoadingDetectedText && vm.mediaTemplate == \'text\'\"><md-list-item ng-if=\"vm.mediaDetectedText.length > 0\" \nid=\"images-container\"><div ng-repeat=\"mediaItem in vm.mediaDetectedText | filter:mediaSearch | orderBy: \'id_media\'\" \nclass=\"image-container\"><div ng-click=\"vm.openImageDialog($event, mediaItem, vm.mediaDetectedText)\" class=\"media\">\n<media attachment=\"mediaItem\"></media></div><div class=\"ml-15 mr-15\"><span layout=\"row\" layout-align=\"start center\" \nclass=\"mt-10\" style=\"\">#{{mediaItem.id_media}}</span><md-chips ng-model=\"mediaItem.tags\" readonly=\"true\" \nmd-removable=\"false\"><md-chip-template qiu-chip qiu-chip-reason=\"{{$chip.reason? $chip.reason : $chip.type}}\" \nqiu-chip-low-sharpness=\"{{vm.isAdmin && ( ($chip.face.quality.sharpness || $chip.quality.sharpness) < 2)}}\" \nqiu-chip-runner=\"{{vm.selectedUser.eventNumber === ($chip.runnerNumber ? $chip.runnerNumber.detectedText : null) || \r\n                                                         vm.selectedUser.eventNumber === $chip.detectedText ? \'current\' : \'other\'}}\" \ncontroller-vm=\"vm\"><span>{{$chip.number}}</span></md-chip-template></md-chips><div class=\"download-container\">\n<md-button aria-label=\"Download\" class=\"md-icon-button download-button\" ng-click=\"vm.downloadImage($event, mediaItem)\" \ntranslate=\"\" translate-attr-aria-label=\"CONTENT.DOWNLOAD\"><md-icon md-font-icon=\"icon-box-download\"></md-icon>\n<md-tooltip hide show-gt-xs><span translate=\"CONTENT.DOWNLOAD\">Download</span></md-tooltip></md-button></div></div>\n</div></md-list-item><md-list-item class=\"no-matches\" ng-if=\"vm.mediaDetectedText.length == 0\"><h3>\nNo se ecnontrarón coincidencias</h3></md-list-item></div><div \nng-if=\"!vm.isLoadingDetectedFace && vm.mediaTemplate == \'face\'\"><md-list-item ng-if=\"vm.mediaDetectedFace.length > 0\" \nid=\"images-container\"><div ng-repeat=\"mediaItem in vm.mediaDetectedFace | filter:mediaSearch | orderBy: \'id_media\'\" \nclass=\"image-container\"><div ng-click=\"vm.openImageDialog($event, mediaItem, vm.mediaDetectedFace)\" class=\"media\">\n<media attachment=\"mediaItem\"></media></div><div class=\"ml-15 mr-15\"><span layout=\"row\" layout-align=\"start center\" \nclass=\"mt-10\" style=\"\">#{{mediaItem.id_media}}</span><md-chips ng-model=\"mediaItem.tags\" readonly=\"true\" \nmd-removable=\"false\"><md-chip-template qiu-chip qiu-chip-reason=\"{{$chip.reason? $chip.reason : $chip.type}}\" \nqiu-chip-low-sharpness=\"{{vm.isAdmin && ( ($chip.face.quality.sharpness || $chip.quality.sharpness) < 2)}}\" \nqiu-chip-runner=\"{{vm.selectedUser.eventNumber === ($chip.runnerNumber ? $chip.runnerNumber.detectedText : null) || \r\n                                                         vm.selectedUser.eventNumber === $chip.detectedText ? \'current\' : \'other\'}}\" \ncontroller-vm=\"vm\"><span>{{$chip.number}}</span></md-chip-template></md-chips><div class=\"download-container\">\n<md-button aria-label=\"Download\" class=\"md-icon-button download-button\" ng-click=\"vm.downloadImage($event, mediaItem)\" \ntranslate=\"\" translate-attr-aria-label=\"CONTENT.DOWNLOAD\"><md-icon md-font-icon=\"icon-box-download\"></md-icon>\n<md-tooltip hide show-gt-xs><span translate=\"CONTENT.DOWNLOAD\">Download</span></md-tooltip></md-button></div></div>\n</div></md-list-item><md-list-item class=\"no-matches\" ng-if=\"vm.mediaDetectedFace.length == 0\"><h3>\nNo se ecnontrarón coincidencias</h3></md-list-item></div>");
$templateCache.put("app/main/apps/runtag/event/views/templates/events-selected-user.html","<div layout=\"row\" flex class=\"content-wrapper\" id=\"filtered-container\"><div id=\"selected-user-container\"><div \nid=\"not-selected-user\" ng-if=\"!vm.selectedUser\"><h3 translate=\"USERS.SELECT_USER\">PLEASE, SELECT A USER</h3></div><div \nid=\"selected-user\" ng-if=\"vm.selectedUser\"><div><div class=\"close-container\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button ng-disabled=\"vm.loadingMore\" ng-click=\"vm.getBackAllMedia()\" \nclass=\"rounded-20 send-button md-accent md-raised\" aria-label=\"return\"><span class=\"text\" translate=\"USERS.RETURN\">\nReturn to dashboard</span></md-button><md-button aria-label=\"Close\" class=\"md-icon-button\" \nng-click=\"vm.selectedUser = undefined\" translate=\"\" translate-attr-aria-label=\"CONTENT.CLOSE\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.CLOSE\">Close</span>\n</md-tooltip></md-button></div><div id=\"header\" layout=\"row\" layout-align=\"center start\"><div layout=\"column\" \nlayout-align=\"center center\"><div ng-if=\"vm.getUserEventProfilePhoto(vm.selectedUser).faceCount > 0\" \nclass=\"user-face-badge\"><md-icon class=\"material-icons\">face</md-icon><span \nng-if=\"vm.getUserEventProfilePhoto(vm.selectedUser).isFaceCrop\" translate=\"RUNTAG.PROFILE_FACE_SELECTED\">\nCara seleccionada</span> <span ng-if=\"!vm.getUserEventProfilePhoto(vm.selectedUser).isFaceCrop\" \ntranslate=\"RUNTAG.PROFILE_FACE_UPLOADED\">Foto de perfil subida</span><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"RUNTAG.PROFILE_FACE_HINT\">Sus fotos se cargan por reconocimiento facial, no por el dorsal</span>\n</md-tooltip></div><img ng-if=\"vm.getUserEventProfilePhoto(vm.selectedUser)\" \nng-src=\"{{vm.getUserEventProfilePhoto(vm.selectedUser).url}}\" class=\"avatar\"><media \nng-if=\"!vm.getUserEventProfilePhoto(vm.selectedUser) && !vm.selectedUser.avatar\" class-img=\"avatar\" force-class \nuse-default></media><img ng-if=\"!vm.getUserEventProfilePhoto(vm.selectedUser) && vm.selectedUser.avatar\" \nng-src=\"{{vm.selectedUser.avatar}}\" class=\"avatar\"><div class=\"user-number\">{{vm.selectedUser.eventNumber}}</div></div>\n<div layout=\"column\" id=\"header-info\"><span><strong>{{vm.selectedUser.firstname}} {{vm.selectedUser.lastname}} <span \nng-if=\"vm.getUserNumber(vm.selectedUser.user_params, vm.selectedUser.current_number)\">\n#{{vm.getUserNumber(vm.selectedUser.user_params, vm.selectedUser.current_number)}}</span></strong></span> <span>\n{{vm.selectedUser.email}}</span></div><md-button aria-label=\"Close\" class=\"md-icon-button self-start\" \nng-click=\"vm.openSettings($event)\" translate=\"\" translate-attr-aria-label=\"CONTENT.SETTINGS\"><md-icon \nclass=\"material-icons\">settings</md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.SETTINGS\">Settings</span>\n</md-tooltip></md-button></div><div id=\"nav\"><ul layout=\"row\"><li><a ng-click=\"vm.changeTemplate(\'info\')\" \nng-class=\"vm.filteredUserTemplate == \'info\' ? \'active\' : \'\'\" class=\"grey-700-fg\" translate=\"USERS.INFO\">Info</a></li>\n<li ng-if=\"!vm.cartEnabled\"><a ng-click=\"vm.changeTemplate(\'media\')\" \nng-class=\"vm.filteredUserTemplate == \'media\' ? \'active\' : \'\'\" class=\"grey-700-fg\" translate=\"USERS.MEDIA\">Media</a>\n</li><li ng-if=\"vm.cartEnabled\"><a ng-click=\"vm.changeTemplate(\'profiles\')\" \nng-class=\"vm.filteredUserTemplate == \'profiles\' ? \'active\' : \'\'\" class=\"grey-700-fg\">Perfiles</a></li><li><a \nng-click=\"vm.changeTemplate(\'shopping\')\" ng-class=\"vm.filteredUserTemplate == \'shopping\' ? \'active\' : \'\'\" \nclass=\"grey-700-fg\" translate=\"USERS.ORDERS\">Orders</a></li><li><a ng-click=\"vm.changeTemplate(\'downloads\')\" \nng-class=\"vm.filteredUserTemplate == \'downloads\' ? \'active\' : \'\'\" class=\"grey-700-fg\" translate=\"USERS.DOWNLOADS\">\nDownloads</a></li><li><a ng-click=\"vm.changeTemplate(\'zip\')\" \nng-class=\"vm.filteredUserTemplate == \'zip\' ? \'active\' : \'\'\" class=\"grey-700-fg\">ZIP</a></li></ul></div><div \nid=\"selected-user-content\"><div id=\"info\" ng-if=\"vm.filteredUserTemplate == \'info\'\" \nng-include=\"\'app/main/apps/runtag/event/views/templates/events-info.html\'\"></div><div id=\"media\" \nng-if=\"vm.filteredUserTemplate == \'media\'\" layout=\"column\" \nng-include=\"\'app/main/apps/runtag/event/views/templates/events-media.html\'\"></div><div id=\"shopping\" \nng-if=\"vm.filteredUserTemplate == \'shopping\'\" class=\"mail-list-pane\" \nng-include=\"\'app/main/apps/runtag/event/views/templates/events-shopping.html\'\"></div><div id=\"downloads\" \nng-if=\"vm.filteredUserTemplate == \'downloads\'\" class=\"mail-list-pane\" \nng-include=\"\'app/main/apps/runtag/event/views/templates/events-downloads.html\'\"></div><div id=\"zip\" \nng-if=\"vm.filteredUserTemplate == \'zip\'\" class=\"mail-list-pane\" \nng-include=\"\'app/main/apps/runtag/event/views/templates/events-zip.html\'\"></div><div id=\"profiles\" \nng-if=\"vm.filteredUserTemplate == \'profiles\'\" \nng-include=\"\'app/main/apps/runtag/event/views/templates/events-profiles.html\'\"></div><div id=\"messages\" \nng-if=\"vm.filteredUserTemplate == \'messages\'\" \nng-include=\"\'app/main/apps/runtag/event/views/templates/events-messages.html\'\"></div><div id=\"seeker\" \nng-if=\"vm.filteredUserTemplate == \'seeker\'\" \nng-include=\"\'app/main/apps/runtag/event/views/templates/events-seeker.html\'\"></div></div></div></div></div></div>");
$templateCache.put("app/main/apps/runtag/event/views/templates/events-shopping.html","<div><md-input-container layout=\"row\" layout-align=\"start center\" flex=\"\" class=\"pr-15\"><button \nclass=\"md-accent green-500-bg md-raised md-button\" aria-label=\"ADD NEW\" show-gt-s \nng-click=\"vm.openShoppingDialog($event, vm.selectedUser)\" translate=\"CONTENT.ADD\">Add new</button></md-input-container>\n</div><div ng-if=\"vm.cartEnabled\"><div ng-if=\"vm.runnerProfilesLoading\" class=\"content-container mail-list-item\"><span \nclass=\"grey-500-fg font-size-14\">Cargando compras…</span></div><div \nng-if=\"!vm.runnerProfilesLoading && vm.shoppingOrders.length === 0\" class=\"content-container mail-list-item\"><span \nclass=\"grey-500-fg font-size-14\">Este usuario no tiene compras en este evento.</span></div><div \nng-repeat=\"shop in vm.shoppingOrders\" ng-if=\"!shop.isFailed\" class=\"shop-order\"><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"md-toolbar-tools grey-100-bg content-container mail-list-item\"><span \nclass=\"grey-500-fg font-size-14\">ID: <strong>#{{shop.id}}</strong> <span \nng-if=\"shop.isPresale && !shop.isPresaleUnassigned\" class=\"shop-presale-badge\">{{\'RUNTAG.PRESALE_BADGE\' | translate}}\n</span> <span ng-if=\"shop.isPresaleUnassigned\" class=\"shop-presale-badge shop-presale-badge--unassigned\">\n{{\'RUNTAG.PRESALE_UNASSIGNED\' | translate}}</span> </span><span class=\"grey-500-fg font-size-14\"><span \ntranslate=\"USERS.ORDER_STATUS\">Status:</span> <strong ng-class=\"{\'green-600-fg\': shop.id_subsec === 2}\">\n{{shop.statusName}}</strong> </span><span class=\"font-size-14\"><strong>{{shop.price}} {{shop.currency_code}}</strong>\n</span> <button class=\"md-accent green-500-bg md-raised md-button\" aria-label=\"EDIT\" show-gt-s \nng-click=\"vm.openShoppingDialog($event, vm.selectedUser, shop.raw)\">\n{{ (shop.isPresaleUnassigned ? \'RUNTAG.PRESALE_ASSIGN\' : (shop.isPresale ? \'RUNTAG.PRESALE_REASSIGN\' : \'CONTENT.EDIT\')) | translate }}\n</button></div><div class=\"content-container mail-list-item shop-meta\"><span class=\"grey-500-fg font-size-12\"><span \ntranslate=\"USERS.CREATED_AT\">Created at</span>: {{shop.created_at}} <span ng-if=\"shop.name_payment_method\">\n· {{shop.name_payment_method}}</span></span></div><div ng-if=\"!shop.hasCoverage\" \nclass=\"content-container mail-list-item\"><span class=\"orange-700-fg font-size-13\">\n⚠ Compra sin fotos ni perfiles asignados.</span></div><div ng-repeat=\"cov in shop.coverage\" \nclass=\"content-container mail-list-item shop-coverage\"><div layout=\"row\" layout-align=\"start center\" \nclass=\"shop-coverage-head\"><span class=\"shop-profile-label font-size-14\"><strong>{{cov.label}}</strong></span> <span \nng-if=\"cov.dorsalNumber\" class=\"shop-dorsal font-size-12\">Dorsal {{cov.dorsalNumber}}</span> <span \nng-if=\"cov.allPhotos\" class=\"shop-badge-all\">Todas las fotos</span> <span ng-if=\"!cov.allPhotos\" \nclass=\"grey-500-fg font-size-13\">{{cov.count}} foto(s)</span></div><div ng-if=\"cov.thumbs.length\" class=\"shop-thumbs\" \nlayout=\"row\" layout-wrap><div ng-repeat=\"t in cov.thumbs\" class=\"shop-thumb\"><img ng-if=\"t.thumb\" ng-src=\"{{t.thumb}}\" \nalt=\"foto comprada\"><div ng-if=\"!t.thumb\" class=\"shop-thumb-empty\"><md-icon class=\"material-icons\">image</md-icon>\n</div></div></div></div></div><div ng-if=\"vm.shoppingFailedCount > 0\"><div \nclass=\"md-toolbar-tools grey-100-bg mail-list-item\" layout=\"row\" ng-click=\"showFailed = !showFailed\"><span \nclass=\"grey-500-fg font-size-14\"><strong translate=\"USERS.FAILED_TRANSACTION\">\nFailed transactions ({{vm.shoppingFailedCount}})</strong> <button><md-icon role=\"img\" aria-hidden=\"true\" \nng-class=\"{\'icon-chevron-up\' : !showFailed,\'icon-chevron-down\' : showFailed}\" class=\"md-font-icon\"></md-icon></button>\n</span></div><div ng-if=\"showFailed\"><div ng-repeat=\"shop in vm.shoppingOrders\" ng-if=\"shop.isFailed\" \nclass=\"shop-order shop-order-failed\"><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"md-toolbar-tools grey-100-bg content-container mail-list-item\"><span class=\"grey-500-fg font-size-14\">ID: \n<strong>#{{shop.id}}</strong></span> <span class=\"grey-500-fg font-size-14\"><strong>{{shop.statusName}}</strong></span>\n <span class=\"font-size-14\">{{shop.price}} {{shop.currency_code}}</span> <button \nclass=\"md-accent green-500-bg md-raised md-button\" aria-label=\"EDIT\" show-gt-s \nng-click=\"vm.openShoppingDialog($event, vm.selectedUser, shop.raw)\" translate=\"CONTENT.EDIT\">Edit</button></div><div \nng-repeat=\"cov in shop.coverage\" class=\"content-container mail-list-item shop-coverage\"><span \nclass=\"shop-profile-label font-size-14\"><strong>{{cov.label}}</strong></span> <span ng-if=\"cov.dorsalNumber\" \nclass=\"shop-dorsal font-size-12\">Dorsal {{cov.dorsalNumber}}</span> <span ng-if=\"cov.allPhotos\" class=\"shop-badge-all\">\nTodas las fotos</span> <span ng-if=\"!cov.allPhotos\" class=\"grey-500-fg font-size-13\">{{cov.count}} foto(s)</span></div>\n</div></div></div></div><div ng-if=\"!vm.cartEnabled && vm.userShoppings.length > 0\"><div \nng-repeat=\"shop in vm.userShoppings\" ng-if=\"shop.id_subsec == 1 || shop.id_subsec == 2 || shop.id_subsec == 5\"><div \nid=\"info\" layout=\"column\"><div layout=\"row\" class=\"md-toolbar-tools grey-100-bg content-container mail-list-item\"><span\n class=\"grey-500-fg font-size-14\">ID: <strong>#{{shop.id}} </strong></span><span class=\"grey-500-fg font-size-14\"><span\n translate=\"USERS.ORDER_STATUS\">Status:</span> <strong ng-if=\"shop.id_subsec == 1\" translate=\"USERS.GENERATED\">\nGENERATED</strong> <strong ng-if=\"shop.id_subsec == 2\" translate=\"USERS.PAID\">PAID</strong> <strong \nng-if=\"shop.id_subsec == 5\">PENDING</strong> <button class=\"md-accent green-500-bg md-raised md-button\" \naria-label=\"EDIT\" show-gt-s ng-click=\"vm.openShoppingDialog($event, vm.selectedUser, shop)\" translate=\"CONTENT.EDIT\">\nEdit</button></span></div></div><div><div layout=\"row\" class=\"content-container mail-list-item\"><span \nclass=\"grey-500-fg font-size-14\" translate=\"USERS.CREATED_AT\">Created at</span> <span \nclass=\"font-size-16 text-truncate\">{{shop.created_at}}</span></div><div layout=\"row\" \nclass=\"content-container mail-list-item\"><span class=\"grey-500-fg font-size-14\" translate=\"USERS.NAME_OF_SUPLIER\">\nName of suplier</span> <span class=\"font-size-16 text-truncate\">{{shop.name_payment_method}}</span></div><div \nlayout=\"row\" class=\"content-container mail-list-item\"><span class=\"grey-500-fg font-size-14\" translate=\"USERS.TOTAL\">\nTotal</span> <span class=\"font-size-16 text-truncate\">{{shop.price}} {{shop.currency_code}}</span></div></div></div>\n<div ng-if=\"vm.failedTransactions > 0\"><div class=\"md-toolbar-tools grey-100-bg mail-list-item\" layout=\"row\" \nng-click=\"showFailed = !showFailed\"><span class=\"grey-500-fg font-size-14\"><strong \ntranslate=\"USERS.FAILED_TRANSACTION\">Failed transactions ({{vm.failedTransactions}})</strong> <button><md-icon \nrole=\"img\" aria-hidden=\"true\" style ng-class=\"{\'icon-chevron-up\' : !showFailed,\'icon-chevron-down\' : showFailed}\" \nclass=\"md-font-icon\"></md-icon></button></span></div><div ng-if=\"showFailed\"><div ng-repeat=\"shop in vm.userShoppings\" \nng-if=\"shop.id_subsec == 3 || shop.id_subsec == 4\"><div id=\"info\" layout=\"column\"><div layout=\"row\" \nclass=\"md-toolbar-tools grey-100-bg content-container mail-list-item\"><span class=\"grey-500-fg font-size-14\">ID: \n<strong>#{{shop.id}} </strong></span><span class=\"grey-500-fg font-size-14\"><span translate=\"USERS.ORDER_STATUS\">\nStatus:</span> <strong ng-if=\"shop.id_subsec == 3\" translate=\"USERS.REJECTED\">REJECTED</strong> <strong \nng-if=\"shop.id_subsec == 4\" translate=\"USERS.CANCELED\">CANCELED</strong> <button \nclass=\"md-accent green-500-bg md-raised md-button\" aria-label=\"EDIT\" show-gt-s \nng-click=\"vm.openShoppingDialog($event, vm.selectedUser, shop)\" translate=\"CONTENT.EDIT\">Edit</button></span></div>\n</div><div><div layout=\"row\" class=\"content-container mail-list-item\"><span class=\"grey-500-fg font-size-14\" \ntranslate=\"USERS.CREATED_AT\">Created at</span> <span class=\"font-size-16 text-truncate\">{{shop.created_at}}</span>\n</div><div layout=\"row\" class=\"content-container mail-list-item\"><span class=\"grey-500-fg font-size-14\" \ntranslate=\"USERS.NAME_OF_SUPLIER\">Name of suplier</span> <span class=\"font-size-16 text-truncate\">\n{{shop.name_payment_method}}</span></div><div layout=\"row\" class=\"content-container mail-list-item\"><span \nclass=\"grey-500-fg font-size-14\" translate=\"USERS.TOTAL\">Total</span> <span class=\"font-size-16 text-truncate\">\n{{shop.price}} {{shop.currency_code}}</span></div></div></div></div></div></div>");
$templateCache.put("app/main/apps/runtag/event/views/templates/events-template-v2.html","<div ng-if=\"vm.isLoadingGroups\" class=\"full-loader\" flex layout=\"column\" layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><section \nid=\"events-container\" ng-if=\"!vm.isLoadingGroups\"><div ng-if=\"!vm.selectedGroup\" \nng-include=\"\'app/main/apps/runtag/event/views/templates/events-list.html\'\"></div><div \nng-if=\"!vm.selectedGroup && vm.isAdmin\" ng-include=\"\'app/main/apps/runtag/event/views/templates/archive-list.html\'\">\n</div><div ng-if=\"vm.selectedGroup\" ng-include=\"\'app/main/apps/runtag/event/views/templates/events-detail.html\'\"></div>\n</section><div id=\"prebuy-container\" ng-if=\"vm.addPrebuys\" \nng-include=\"\'app/main/apps/runtag/event/views/templates/events-add-prebuys.html\'\"></div>");
$templateCache.put("app/main/apps/runtag/event/views/templates/events-zip.html","<div class=\"mail-list-pane\" layout=\"column\"><div ng-if=\"vm.loadingZipDownloads\" layout=\"row\" \nlayout-align=\"center center\" class=\"p-40\" style=\"min-height: 200px\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"40\"></md-progress-circular></div><div \nng-if=\"!vm.loadingZipDownloads && (!vm.userZipDownloads || vm.userZipDownloads.length === 0)\" \nclass=\"p-40 center grey-600-fg\"><md-icon class=\"material-icons font-size-48 grey-400-fg mb-10\">folder_off</md-icon><p \nclass=\"font-size-16\" translate=\"USERS.NO_ZIP_DOWNLOADS\">No se han encontrado descargas ZIP para este usuario.</p></div>\n<div ng-if=\"!vm.loadingZipDownloads && vm.userZipDownloads.length > 0\" class=\"zip-downloads-container p-20\"><h3 \nclass=\"mb-20 text-uppercase grey-700-fg font-size-14 bold\">Packs de descarga (ZIP)</h3><div layout=\"column\" \nclass=\"gap-15\"><div ng-repeat=\"zip in vm.userZipDownloads\" \nclass=\"zip-item p-15 border-radius-8 border grey-100-bg transition-all\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"icon-container p-10 mr-15 border-radius-percent-50 blue-50-bg\"><md-icon class=\"material-icons blue-500-fg\">\nfolder_zip</md-icon></div><div layout=\"column\"><span class=\"font-size-14 bold grey-800-fg\">\nPack #{{vm.userZipDownloads.length - $index}}</span> <span class=\"font-size-12 grey-600-fg\">\nGenerado el {{zip.created_at | date:\'dd/MM/yyyy HH:mm\'}}</span> <span class=\"font-size-12 grey-500-fg\">\n{{zip.file_count}} fotos</span></div></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-raised md-accent rounded-20 px-20\" ng-href=\"{{zip.url}}\" target=\"_blank\" aria-label=\"Download ZIP\"><md-icon \nclass=\"material-icons font-size-18 mr-5\">download</md-icon><span class=\"font-size-13 text-uppercase\">Descargar</span>\n</md-button></div></div></div></div></div>");
$templateCache.put("app/main/apps/runtag/event/views/templates/item-list-events-v2.html","<div ng-repeat=\"mediaItem in vm.items | filter:mediaSearch | orderBy: \'idMedia\'\" class=\"image-container\"><div \nng-click=\"vm.openImageDialog($event, mediaItem, vm.items)\" class=\"media\"><media attachment=\"mediaItem.preview\"></media>\n</div><div class=\"ml-15 mr-15 pb-50\"><span layout=\"row\" layout-align=\"start center\" class=\"bold mt-10\">\n#{{mediaItem.mediaId}}</span> <span layout=\"row\" layout-align=\"start center\" class=\"bold mt-10\">\n{{mediaItem.createdAtTransform | date: \'dd/MM/yyyy hh:mm:ss\'}}</span><md-chips ng-model=\"mediaItem.tags\" \nreadonly=\"true\" md-removable=\"false\" \nmd-chip-class=\"vm.isAdmin && ( ($chip.face.quality.sharpness || $chip.quality.sharpness) < 2 ) ? \'low-sharpness\' : \'\'\">\n<md-chip-template qiu-chip qiu-chip-reason=\"{{$chip.reason? $chip.reason : $chip.type}}\" qiu-chip-runner=\"other\" \nqiu-chip-low-sharpness=\"{{vm.isAdmin && ( ($chip.face.quality.sharpness || $chip.quality.sharpness) < 2)}}\" \ncontroller-vm=\"vm\"><span ng-if=\"$chip.type != \'unmatchedNumber\'\">{{$chip.runnerNumber.detectedText}}</span> <span \nng-if=\"$chip.type == \'unmatchedNumber\'\">{{$chip.detectedText}}</span></md-chip-template></md-chips><div \nclass=\"download-container\"><md-button aria-label=\"Download\" class=\"md-icon-button download-button\" \nng-click=\"vm.downloadImage(mediaItem)\" translate=\"\" translate-attr-aria-label=\"CONTENT.DOWNLOAD\"><md-icon \nmd-font-icon=\"icon-box-download\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.DOWNLOAD\">Download\n</span></md-tooltip></md-button><md-checkbox aria-label=\"Select Media Item\" class=\"no-label\" \nng-click=\"vm.selectMediaItem(mediaItem)\"></md-checkbox></div></div></div>");
$templateCache.put("app/main/apps/runtag/event/views/templates/item-list-events.html","<div ng-repeat=\"mediaItem in vm.items | filter:mediaSearch | orderBy: \'id_media\'\" class=\"image-container\"><div \nng-click=\"vm.openImageDialog($event, mediaItem, vm.items)\" class=\"media\"><media attachment=\"mediaItem.preview\"></media>\n</div><div class=\"ml-15 mr-15 pb-50\"><span layout=\"row\" layout-align=\"start center\" class=\"mt-10\">\n#{{mediaItem.media_id}}</span> <span layout=\"row\" layout-align=\"start center\" class=\"mt-10\">\n{{mediaItem.createdAtTransform | date: \'dd/MM/yyyy hh:mm:ss\'}}</span><md-chips ng-model=\"mediaItem.tags\" \nreadonly=\"true\" md-removable=\"false\" \nmd-chip-class=\"vm.isAdmin && ($chip.face.quality.sharpness > 2 || $chip.quality.sharpness > 2) ? \'low-sharpness\' : \'\'\">\n<md-chip-template qiu-chip qiu-chip-reason=\"{{$chip.reason? $chip.reason : $chip.type}}\" \nqiu-chip-runner=\"{{vm.selectedUser.eventNumber === ($chip.runnerNumber ? $chip.runnerNumber.detectedText : null) || \r\n                                                 vm.selectedUser.eventNumber === $chip.detectedText ? \'current\' : \'other\'}}\" \nqiu-chip-low-sharpness=\"{{vm.isAdmin && ( ($chip.face.quality.sharpness || $chip.quality.sharpness) < 2)}}\" \ncontroller-vm=\"vm\"><span ng-if=\"$chip.runner_number\">{{$chip.runner_number}}</span> <span ng-if=\"$chip.runnerNumber\">\n{{$chip.runnerNumber.DetectedText}}</span></md-chip-template></md-chips></div></div>");
$templateCache.put("app/main/apps/runtag/event/views/templates/item-media-unified.html","<div ng-click=\"vm.openImageDialog($event, mediaItem, galleryList)\" class=\"media\" \nng-class=\"{\'ml-auto mr-auto\': vm.eventVersion}\"><media attachment=\"mediaItem.preview\"></media><span \nclass=\"purchased-badge\" ng-if=\"mediaItem.purchased\" aria-label=\"{{ \'RUNTAG.PURCHASED\' | translate }}\"><md-icon \nclass=\"material-icons\">shopping_bag</md-icon><span translate=\"RUNTAG.PURCHASED\">Comprada</span></span></div><div \nclass=\"ml-auto mr-auto info\"><span layout=\"row\" layout-align=\"start center\" class=\"mt-10\">\n#{{mediaItem.mediaId || mediaItem.media_id}}</span> <span layout=\"row\" layout-align=\"start center\" class=\"mt-10\">\n{{mediaItem.createdAtTransform | date: \'dd/MM/yyyy hh:mm:ss\'}}</span><md-chips ng-model=\"mediaItem.tags\" \nreadonly=\"true\" md-removable=\"!!vm.eventVersion || isSearch\"><md-chip-template qiu-chip \nqiu-chip-reason=\"{{$chip.reason? $chip.reason: $chip.type}}\" \nqiu-chip-low-sharpness=\"{{vm.isAdmin && ( ($chip.face.quality.sharpness || $chip.quality.sharpness) < 2)}}\" \nqiu-chip-runner=\"{{vm.selectedUser.eventNumber === ($chip.runnerNumber ? $chip.runnerNumber.detectedText : null) || \r\n                               vm.selectedUser.eventNumber === $chip.detectedText ? \'current\' : \'other\'}}\" \ncontroller-vm=\"vm\"><span ng-if=\"!vm.eventVersion && !isSearch\"><span ng-if=\"$chip.runner_number\">\n{{$chip.runner_number}}</span> <span ng-if=\"$chip.runnerNumber\">{{$chip.runnerNumber.DetectedText}}</span> </span><span\n ng-if=\"vm.eventVersion || isSearch\"><span ng-if=\"$chip.type != \'unmatchedNumber\'\">{{$chip.runnerNumber.detectedText}}\n</span> <span ng-if=\"$chip.type == \'unmatchedNumber\'\">{{$chip.detectedText}}</span></span></md-chip-template><button \nng-if=\"vm.eventVersion || isSearch\" ng-disabled=\"$chip.rejected\" md-chip-remove class=\"md-primary remove\" \nng-click=\"vm.deleteChip($chip, mediaItem)\"><md-icon md-font-icon=\"icon-close\"></md-icon></button></md-chips><div \nclass=\"download-container\"><md-button \nng-if=\"mediaItem.archiveStatus && mediaItem.archiveStatus !== \'UNARCHIVED\' && vm.eventVersion\" \naria-label=\"{{ \'RUNTAG.RESTORE_FROM_ARCHIVE\' | translate }}\" class=\"md-button archive-restore-button\" \nng-class=\"{\r\n                \'status-archived\': mediaItem.archiveStatus === \'ARCHIVED\',\r\n                \'status-pending\':  mediaItem.archiveStatus === \'PENDING\',\r\n                \'status-restored\': mediaItem.archiveStatus === \'RESTORED\',\r\n                \'status-loading\':  mediaItem.archiveStatus === \'LOADING\'\r\n            }\" \nng-disabled=\"mediaItem.archiveStatus === \'LOADING\'\" ng-click=\"vm.onArchiveRestoreClick($event, mediaItem)\">\n<md-progress-circular ng-if=\"mediaItem.archiveStatus === \'LOADING\'\" md-mode=\"indeterminate\" md-diameter=\"20\">\n</md-progress-circular><span ng-if=\"mediaItem.archiveStatus === \'ARCHIVED\'\" translate=\"RUNTAG.RESTORE_FROM_ARCHIVE\">\nRestore from archive </span><span ng-if=\"mediaItem.archiveStatus === \'PENDING\'\" translate=\"RUNTAG.RESTORE_PENDING\">\nRestore pending </span><span ng-if=\"mediaItem.archiveStatus === \'RESTORED\'\" translate=\"RUNTAG.RESTORED\">Restored</span>\n<md-tooltip hide show-gt-xs \nng-if=\"mediaItem.archiveStatus === \'ARCHIVED\' || mediaItem.archiveStatus === \'PENDING\' || mediaItem.archiveStatus === \'RESTORED\'\">\n<span ng-if=\"mediaItem.archiveStatus === \'ARCHIVED\'\" translate=\"RUNTAG.RESTORE_FROM_ARCHIVE\">Restore from archive \n</span><span ng-if=\"mediaItem.archiveStatus === \'PENDING\'\" translate=\"RUNTAG.RESTORE_PENDING\">Restore pending </span>\n<span ng-if=\"mediaItem.archiveStatus === \'RESTORED\'\" translate=\"RUNTAG.RESTORED\">Restored</span></md-tooltip>\n</md-button><md-button ng-if=\"!isSearch && !hideSetProfileImg\" aria-label=\"Set profile image\" \nclass=\"md-icon-button set-image-button\" ng-click=\"vm.setProfileImage(mediaItem)\"><md-icon \nmd-font-icon=\"icon-account-circle\"></md-icon><md-tooltip hide show-gt-xs><span>Set profile image</span></md-tooltip>\n</md-button><md-button ng-if=\"!isSearch\" aria-label=\"Download\" class=\"md-icon-button download-button\" \nng-click=\"vm.downloadImage(mediaItem)\" translate=\"\" translate-attr-aria-label=\"CONTENT.DOWNLOAD\"><md-icon \nmd-font-icon=\"icon-box-download\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.DOWNLOAD\">Download\n</span></md-tooltip></md-button><md-menu ng-if=\"isSearch && vm.cartEnabled && vm.runnerProfiles.length\"><md-button \nclass=\"md-icon-button assign-to-profile\" ng-click=\"$mdMenu.open($event)\" \nng-disabled=\"vm.searchAssignSaving[mediaItem.mediaId || mediaItem.media_id]\" aria-label=\"Asignar a perfil\">\n<md-progress-circular ng-if=\"vm.searchAssignSaving[mediaItem.mediaId || mediaItem.media_id]\" md-mode=\"indeterminate\" \nmd-diameter=\"18\"></md-progress-circular><md-icon \nng-if=\"!vm.searchAssignSaving[mediaItem.mediaId || mediaItem.media_id]\" class=\"material-icons\">badge</md-icon>\n<md-tooltip hide show-gt-xs>Asignar a perfil</md-tooltip></md-button><md-menu-content><md-menu-item \nng-repeat=\"p in vm.runnerProfiles\"><md-button ng-click=\"vm.assignSearchResultToProfile(mediaItem, p)\">\n{{ vm.runnerProfileLabel(p) }}</md-button></md-menu-item></md-menu-content></md-menu><md-checkbox \nng-if=\"vm.eventVersion || isSearch\" aria-label=\"Select Media Item\" class=\"no-label\" \nng-checked=\"vm.selectedMedias.includes(mediaItem)\" ng-click=\"vm.selectMediaItem(mediaItem)\"></md-checkbox></div></div>");
$templateCache.put("app/main/apps/runtag/event/views/templates/item-user-media-in-events-v2.html","<div ng-click=\"vm.openImageDialog($event, mediaItem, vm.selectedUser.newMedia)\" class=\"media ml-auto mr-auto\"><media \nattachment=\"mediaItem.preview\"></media></div><div class=\"ml-auto mr-auto pb-20 info\"><span layout=\"row\" \nlayout-align=\"start center\" class=\"mt-10\">#{{mediaItem.mediaId}}</span> <span layout=\"row\" layout-align=\"start center\" \nclass=\"mt-10\">{{mediaItem.createdAtTransform | date: \'dd/MM/yyyy hh:mm:ss\'}}</span><md-chips ng-model=\"mediaItem.tags\" \nreadonly=\"true\" md-removable=\"true\"><md-chip-template qiu-chip \nqiu-chip-reason=\"{{$chip.reason? $chip.reason: $chip.type}}\" \nqiu-chip-low-sharpness=\"{{vm.isAdmin && ( ($chip.face.quality.sharpness || $chip.quality.sharpness) > 2)}}\" \nqiu-chip-runner=\"{{vm.selectedUser.eventNumber === ($chip.runnerNumber ? $chip.runnerNumber.detectedText : null) || \r\n                               vm.selectedUser.eventNumber === $chip.detectedText ? \'current\' : \'other\'}}\">\n<span ng-if=\"$chip.type != \'unmatchedNumber\'\">{{$chip.runnerNumber.detectedText}}</span> <span \nng-if=\"$chip.type == \'unmatchedNumber\'\">{{$chip.detectedText}}</span></md-chip-template><button \nng-disabled=\"$chip.rejected\" md-chip-remove class=\"md-primary remove\" ng-click=\"vm.deleteChip($chip, mediaItem)\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></button></md-chips><div class=\"download-container\"><md-button \nng-if=\"mediaItem.archiveStatus && mediaItem.archiveStatus !== \'UNARCHIVED\'\" \naria-label=\"{{ \'RUNTAG.RESTORE_FROM_ARCHIVE\' | translate }}\" class=\"md-button archive-restore-button\" \nng-class=\"{\r\n                \'status-archived\': mediaItem.archiveStatus === \'ARCHIVED\',\r\n                \'status-pending\':  mediaItem.archiveStatus === \'PENDING\',\r\n                \'status-restored\': mediaItem.archiveStatus === \'RESTORED\',\r\n                \'status-loading\':  mediaItem.archiveStatus === \'LOADING\'\r\n            }\" \nng-disabled=\"mediaItem.archiveStatus === \'LOADING\'\" ng-click=\"vm.onArchiveRestoreClick($event, mediaItem)\">\n<md-progress-circular ng-if=\"mediaItem.archiveStatus === \'LOADING\'\" md-mode=\"indeterminate\" md-diameter=\"20\">\n</md-progress-circular><span ng-if=\"mediaItem.archiveStatus === \'ARCHIVED\'\" translate=\"RUNTAG.RESTORE_FROM_ARCHIVE\">\nRestore from archive </span><span ng-if=\"mediaItem.archiveStatus === \'PENDING\'\" translate=\"RUNTAG.RESTORE_PENDING\">\nRestore pending </span><span ng-if=\"mediaItem.archiveStatus === \'RESTORED\'\" translate=\"RUNTAG.RESTORED\">Restored</span>\n<md-tooltip hide show-gt-xs ng-if=\"mediaItem.archiveStatus !== \'LOADING\'\"><span \nng-if=\"mediaItem.archiveStatus === \'ARCHIVED\'\" translate=\"RUNTAG.RESTORE_FROM_ARCHIVE\">Restore from archive </span>\n<span ng-if=\"mediaItem.archiveStatus === \'PENDING\'\" translate=\"RUNTAG.RESTORE_PENDING\">Restore pending </span><span \nng-if=\"mediaItem.archiveStatus === \'RESTORED\'\" translate=\"RUNTAG.RESTORED\">Restored</span></md-tooltip></md-button>\n<md-button aria-label=\"Set profile image\" class=\"md-icon-button set-image-button\" \nng-click=\"vm.setProfileImage(mediaItem)\"><md-icon md-font-icon=\"icon-account-circle\"></md-icon><md-tooltip hide \nshow-gt-xs><span>Set profile image</span></md-tooltip></md-button><md-button aria-label=\"Download\" \nclass=\"md-icon-button download-button\" ng-click=\"vm.downloadImage(mediaItem)\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.DOWNLOAD\"><md-icon md-font-icon=\"icon-box-download\"></md-icon><md-tooltip hide \nshow-gt-xs><span translate=\"CONTENT.DOWNLOAD\">Download</span></md-tooltip></md-button><md-checkbox \naria-label=\"Select Media Item\" class=\"no-label\" ng-click=\"vm.selectMediaItem(mediaItem)\"></md-checkbox></div></div>");
$templateCache.put("app/main/apps/runtag/event/views/templates/item-user-media-in-events.html","<div ng-click=\"vm.openImageDialog($event, mediaItem, vm.selectedUser.newMedia)\" class=\"media\"><media \nattachment=\"mediaItem.preview\"></media></div><div class=\"ml-auto mr-auto pb-50 info\"><span layout=\"row\" \nlayout-align=\"start center\" class=\"mt-10\">#{{mediaItem.media_id}}</span> <span layout=\"row\" \nlayout-align=\"start center\" class=\"mt-10\">{{mediaItem.createdAtTransform | date: \'dd/MM/yyyy hh:mm:ss\'}}</span>\n<md-chips ng-model=\"mediaItem.tags\" readonly=\"true\" md-removable=\"false\"><md-chip-template qiu-chip \nqiu-chip-reason=\"{{$chip.reason? $chip.reason : $chip.type}}\" \nqiu-chip-low-sharpness=\"{{vm.isAdmin && ( ($chip.face.quality.sharpness || $chip.quality.sharpness) > 2)}}\" \nqiu-chip-runner=\"{{vm.selectedUser.eventNumber === ($chip.runnerNumber ? $chip.runnerNumber.detectedText : null) || \r\n                                             vm.selectedUser.eventNumber === $chip.detectedText ? \'current\' : \'other\'}}\" \ncontroller-vm=\"vm\"><span ng-if=\"$chip.runner_number\">{{$chip.runner_number}}</span> <span ng-if=\"$chip.runnerNumber\">\n{{$chip.runnerNumber.DetectedText}}</span></md-chip-template></md-chips><div class=\"download-container\"><md-button \naria-label=\"Set profile image\" class=\"md-icon-button set-image-button\" ng-click=\"vm.setProfileImage(mediaItem)\">\n<md-icon md-font-icon=\"icon-account-circle\"></md-icon><md-tooltip hide show-gt-xs><span>Set profile image</span>\n</md-tooltip></md-button><md-button aria-label=\"Download\" class=\"md-icon-button download-button\" \nng-click=\"vm.downloadImage(mediaItem)\" translate=\"\" translate-attr-aria-label=\"CONTENT.DOWNLOAD\"><md-icon \nmd-font-icon=\"icon-box-download\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.DOWNLOAD\">Download\n</span></md-tooltip></md-button></div></div>");
$templateCache.put("app/main/apps/runtag/event/views/templates/search-mediaItem.html","<div ng-click=\"vm.openImageDialog($event, mediaItem, vm.searchedItems)\" class=\"media\"><media \nattachment=\"mediaItem.preview\"></media></div><div class=\"ml-auto mr-auto pb-50 info\"><span layout=\"row\" \nlayout-align=\"start center\" class=\"mt-10\">#{{mediaItem.mediaId}}</span> <span layout=\"row\" layout-align=\"start center\" \nclass=\"mt-10\">{{mediaItem.createdAtTransform | date: \'dd/MM/yyyy hh:mm:ss\'}}</span><md-chips ng-model=\"mediaItem.tags\" \nreadonly=\"true\" md-removable=\"true\"><md-chip-template qiu-chip \nqiu-chip-reason=\"{{$chip.reason? $chip.reason : $chip.type}}\" \nqiu-chip-low-sharpness=\"{{vm.isAdmin && ( ($chip.face.quality.sharpness || $chip.quality.sharpness) < 2)}}\" \nqiu-chip-runner=\"{{vm.selectedUser.eventNumber === ($chip.runnerNumber ? $chip.runnerNumber.detectedText : null) || \r\n                               vm.selectedUser.eventNumber === $chip.detectedText ? \'current\' : \'other\'}}\">\n<span ng-if=\"$chip.type != \'unmatchedNumber\'\">{{$chip.runnerNumber.detectedText}}</span> <span \nng-if=\"$chip.type == \'unmatchedNumber\'\">{{$chip.detectedText}}</span></md-chip-template><button \nng-disabled=\"$chip.rejected\" md-chip-remove class=\"md-primary remove\" ng-click=\"vm.deleteChip($chip, mediaItem)\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></button></md-chips><div class=\"download-container\"><md-checkbox \naria-label=\"Select Media Item\" class=\"no-label\" ng-click=\"vm.selectMediaItem(mediaItem)\"></md-checkbox></div></div>");
$templateCache.put("app/main/apps/runtag/event/dialogs/event-numbers/event-numbers-dialog.html","<md-dialog aria-label=\"Event Numbers\" class=\"w-11/12 md:w-2/3 rounded-xl\"><md-toolbar><div class=\"md-toolbar-tools\">\n<h2>Event Numbers</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"dlg.cancel()\" aria-label=\"Close\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-dialog-content\"><div layout=\"column\" layout-padding><md-list><md-list-item class=\"py-2\" \nng-repeat=\"it in dlg.items track by $index\" ng-if=\"!it._delete\"><div layout=\"row\" layout-align=\"center center\" \nclass=\"en-row\"><md-input-container class=\"md-block en-input\" flex><label>Number</label><input type=\"text\" \nng-model=\"it.number\" required></md-input-container><div class=\"en-actions\" layout=\"row\" layout-align=\"center center\">\n<md-button ng-disabled=\"dlg.items.length === 1\" class=\"md-icon-button\" ng-click=\"dlg.remove($index)\" \naria-label=\"Delete\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div></div></md-list-item></md-list>\n</div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"dlg.cancel()\">\nCancel</md-button><md-button class=\"md-primary md-raised\" ng-click=\"dlg.save()\">Save</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/apps/runtag/event/dialogs/import/import-dialog.html","<md-dialog class=\"import-dialog\" aria-label=\"New Message\"><form class=\"md-inline-form\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between\"><h1 class=\"title\" \ntranslate=\"USERS.IMPORT_USERS\"></h1><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nng-if=\"!vm.importFinished && !vm.importError\" ms-scroll flex class=\"content-card\" ng-class=\"vm.currentView\"><div \nng-if=\"!vm.fileInfo\" ngf-drop \nng-class=\"{\'disabled\' : vm.optionsDefault.delimiter.length == 0 || vm.optionsDefault.escape.length == 0 || vm.primaryKey.length == 0}\" \nng-disabled=\"vm.optionsDefault.delimiter.length == 0 || vm.optionsDefault.escape.length == 0 || vm.primaryKey.length == 0\" \nngf-select ng-model=\"vm.files\" class=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"false\" \nngf-allow-dir=\"true\" accept=\".csv\" ngf-pattern=\"\'.csv\'\"><div layout=\"column\"><div flex \ntranslate=\"USERS.DROP_OR_UPLOAD\"></div><div flex translate=\"USERS.OR\"></div><div flex><md-button \nclass=\"send-button md-accent md-raised\" aria-label=\"Select files\" translate=\"USERS.SELECT_FROM_COMPUTER_CSV\">\n</md-button></div></div><div ng-repeat=\"f in vm.files\" class=\"ms-card\" flex><div \nclass=\"ms-card-content-wrapper imported-files\"><div class=\"template-9\"><div class=\"media\" flex layout=\"row\" \nlayout-align=\"center center\"><img ngf-thumbnail=\"!f.$error && f\" class=\"image\"></div><div class=\"header p-16\" flex><div\n layout=\"row\" layout-align=\"space-between center\" flex><div class=\"size\" layout=\"row\" layout-align=\"start left\"><strong\n class=\"mr-5\" ng-if=\"f.id\">#{{f.id}}</strong> <span class=\"grey-500-fg\"><span ng-if=\"f.name\">{{f.name}}</span></span>\n</div></div></div><md-progress-linear md-mode=\"determinate\" value=\"{{f.progress}}\" ng-show=\"f.progress < 100\">\n</md-progress-linear></div></div></div></div><div ngf-no-file-drop>File Drag/Drop is not supported for this browser\n</div><div flex layout=\"column\" layout-align=\"center center\" ng-if=\"vm.isLoading\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nng-style=\"{\'opacity\' : vm.isLoading ? 0.2 : 1}\" ng-if=\"vm.fileInfo\" class=\"info-result\"><div layout=\"row\" \nclass=\"p-15 group-selector\"><md-input-container class=\"md-block on-off\" flex-xs=\"100\" flex-gt-sm=\"33\"><label \ntranslate=\"USERS.ADD_TO_GROUP\"></label><md-menu><button class=\"mr-0 width-percent-100 pb-5 pt-5 button-select\" \nng-click=\"$mdMenu.open($event)\" aria-label=\"group-menu\" layout=\"row\" layout-align=\"space-between center\"><span \nng-if=\"vm.groupSelectedName\" class=\"font-size-14\">{{vm.groupSelectedName}}</span> <span \nng-if=\"!vm.groupSelectedName && vm.usersGroupsFilters.length == 0\" class=\"font-size-14\">Root</span> <span \nng-if=\"!vm.groupSelectedName && vm.usersGroupsFilters.length > 0\" class=\"font-size-14\" translate=\"USERS.SELECT_GROUP\">\n</span><md-icon md-font-icon=\"icon-menu-down\" class=\"grey-600-fg ml-10 mr-0\" aria-hidden=\"true\"></md-icon></button>\n<md-menu-content class=\"md-block groups-tree\"><div class=\"level-card p-8 group-row ng-scope grey-100-bg\" layout=\"row\">\n<label for=\"search-bar-input\"><md-icon ng-show=\"!vm.treeSearch\" md-font-icon=\"icon-magnify\" \nclass=\"grey-600-fg md-icon-button md-button\"><md-tooltip hide show-gt-xs><span translate=\"TOOLBAR.SEARCH\">Search</span>\n</md-tooltip></md-icon><md-icon ng-show=\"vm.treeSearch\" md-font-icon=\"icon-close-circle\" \nclass=\"grey-600-fg md-icon-button md-button\" ng-click=\"vm.treeSearch = null\"></md-icon></label><input type=\"text\" \nid=\"search-bar-input\" class=\"grey-600-fg grey-100-bg\" ng-model=\"vm.treeSearch\" placeholder=\"Search\" md-autofocus \ntranslate translate-attr-placeholder=\"TOOLBAR.SEARCH\" flex></div><div ng-if=\"!vm.rootGroup\" \nng-click=\"vm.selectParentGroupRoot()\" class=\"level-card p-8 group-row ng-scope\" layout=\"row\" \nlayout-align=\"space-between stretch\"><div flex class=\"layout-align-start-center layout-row flex\"><md-icon \nmd-font-icon=\"icon-folder-multiple\" \nclass=\"orange-300-fg s24 mr-10 mt-0 ml-0 mb-0 ng-scope md-default-theme md-font material-icons icon-folder-multiple\" \naria-hidden=\"true\"></md-icon><span translate=\"GROUP.ROOT\"></span></div></div><div ng-click=\"$mdCloseMenu($event)\" \nng-if=\"vm.groups\" ivh-treeview=\"vm.groups\" ivh-treeview-filter=\"vm.treeSearch\" class=\"ivh-treeview-folder small\" \nivh-treeview-label-attribute=\"\'label\'\"><script type=\"text/ng-template\">\n<div class=\"level-card p-8 group-row select-parent-group-row\" layout=\"row\" layout-align=\"space-between stretch\">\r\n                                        <span ivh-treeview-twistie ivh-treeview-toggle layout=\"row\" layout-align=\"center center\"></span>\r\n                                        <div qiu-on-select-parent-users-group flex id=\"treeview-group-{{node.id_group}}\" data-group-node={{node}} layout=\"row\" layout-align=\"start center\">\r\n                                            <div ng-if=\"node.group_type.icon\">\r\n                                                <md-icon ng-if=\"node.group_type.icon\"\r\n                                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                                    md-font-icon=\"{{node.group_type.icon}}\"\r\n                                                    aria-hidden=\"true\" >\r\n                                                </md-icon>\r\n                                            </div>\r\n                                            <div ng-if=\"!node.group_type.icon\">\r\n                                                <md-icon ng-if=\"!node.children && node.id_group_type == 1\"\r\n                                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                                    md-font-icon=\"icon-folder\"\r\n                                                    aria-hidden=\"true\" >\r\n                                                </md-icon>\r\n                                                <md-icon\r\n                                                    ng-if=\"node.children && node.id_group_type == 1\"\r\n                                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                                    md-font-icon=\"icon-folder-multiple\"\r\n                                                    aria-hidden=\"true\" >\r\n                                                </md-icon>\r\n                                                <md-icon ng-if=\"!node.children && node.id_group_type == 2\"\r\n                                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                                    md-font-icon=\"qiu-icon-file-usermailing\"\r\n                                                    aria-hidden=\"true\" >\r\n                                                </md-icon>\r\n                                                <md-icon\r\n                                                    ng-if=\"node.children && node.id_group_type == 2\"\r\n                                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                                    md-svg-src=\"/assets/icons/svg/icon-folder-mail-multiple.svg\"\r\n                                                    aria-hidden=\"true\" >\r\n                                                </md-icon>\r\n                                                <md-icon ng-if=\"!node.children && node.id_group_type == 3\"\r\n                                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                                    md-font-icon=\"qiu-icon-file-usermediacenter\"\r\n                                                    aria-hidden=\"true\" >\r\n                                                </md-icon>\r\n                                                <md-icon\r\n                                                    ng-if=\"node.children && node.id_group_type == 3\"\r\n                                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                                    md-svg-src=\"/assets/icons/svg/icon-folder-play-multiple.svg\"\r\n                                                    aria-hidden=\"true\" >\r\n                                                </md-icon>\r\n                                                <md-icon ng-if=\"!node.children && node.id_group_type == 4\"\r\n                                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                                    md-font-icon=\"qiu-icon-file-usersegment\"\r\n                                                    aria-hidden=\"true\" >\r\n                                                </md-icon>\r\n                                                <md-icon\r\n                                                    ng-if=\"node.children && node.id_group_type == 4\"\r\n                                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                                    md-svg-src=\"/assets/icons/svg/icon-folder-share-multiple.svg\"\r\n                                                    aria-hidden=\"true\" >\r\n                                                </md-icon>\r\n                                                <md-icon ng-if=\"!node.children && node.id_group_type == 5\"\r\n                                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                                    md-font-icon=\"qiu-icon-file-userstore\"\r\n                                                    aria-hidden=\"true\" >\r\n                                                </md-icon>\r\n                                                <md-icon\r\n                                                    ng-if=\"node.children && node.id_group_type == 5\"\r\n                                                    md-svg-src=\"/assets/icons/svg/icon-folder-shop-multiple.svg\"\r\n                                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                                    aria-hidden=\"true\" >\r\n                                                </md-icon>\r\n                                                <md-icon ng-if=\"!node.children && node.id_group_type == 6\"\r\n                                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                                    md-font-icon=\"qiu-icon-file-useracreditation\"\r\n                                                    aria-hidden=\"true\" >\r\n                                                </md-icon>\r\n                                                <md-icon\r\n                                                    ng-if=\"node.children && node.id_group_type == 6\"\r\n                                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                                    md-svg-src=\"/assets/icons/svg/icon-folder-board-multiple.svg\"\r\n                                                    aria-hidden=\"true\" >\r\n                                                </md-icon>\r\n                                                <md-icon ng-if=\"!node.children && node.id_group_type == 7\"\r\n                                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                                    md-svg-src=\"/assets/icons/svg/icon-folder-chat.svg\"\r\n                                                    aria-hidden=\"true\" >\r\n                                                </md-icon>\r\n                                                <md-icon\r\n                                                    ng-if=\"node.children && node.id_group_type == 7\"\r\n                                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                                    md-svg-src=\"/assets/icons/svg/icon-folder-chat-multiple.svg\"\r\n                                                    aria-hidden=\"true\" >\r\n                                                </md-icon>\r\n                                                <md-icon ng-if=\"!node.children && node.id_group_type == 8\"\r\n                                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                                    md-font-icon=\"icon-folder-remove\"\r\n                                                    aria-hidden=\"true\" >\r\n                                                </md-icon>\r\n                                                <md-icon\r\n                                                    ng-if=\"node.children && node.id_group_type == 8\"\r\n                                                    class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                                                    md-font-icon=\"icon-folder-multiple\"\r\n                                                    aria-hidden=\"true\" >\r\n                                                </md-icon>\r\n                                            </div>\r\n                                           <span class=\"ivh-treeview-node-label ng-binding\">{{node.name}}</span>\r\n                                        </div>\r\n                                      </div>\r\n                                    <div ivh-treeview-children></div>\n</script></div></md-menu-content></md-menu></md-input-container></div><table class=\"table row-border hover simple\" \nms-responsive-table><thead><tr><th>{{vm.translate(\'USERS.CVS_FIELD\')}}</th><th \nng-repeat=\"record in vm.fileInfo.file.sampleRecords |limitTo:3\">{{vm.translate(\'USERS.SAMPLE\')}} {{$index + 1 }}</th>\n<th class=\"big\">{{vm.translate(\'USERS.BBDD_FIELD\')}}</th></tr></thead><tbody><tr ng-init=\"indexParent = $index\" \nng-repeat=\"header in vm.fileInfo.file.headers track by $index\"><td>{{header}}</td><td \nng-repeat=\"record in vm.fileInfo.file.sampleRecords |limitTo:3\">{{record[indexParent]}}</td><td class=\"big\"><div \nlayout=\"row\"><md-input-container flex=\"85\" class=\"md-block m-0\"><label translate=\"USERS.FIELD_BBDD\"></label><md-select \nng-model=\"vm.mapping[header]\"><md-option ng-value=\"\"></md-option><md-option \nng-repeat=\"fieldDB in vm.fileInfo.db.availableFields track by $index\" ng-value=\"fieldDB\" \nng-selected=\"vm.isHeaderMatch(fieldDB, header)\">{{fieldDB}}</md-option></md-select></md-input-container><md-button \nflex=\"15\" ng-if=\"vm.mapping[header]\" class=\"md-icon-button\" ng-click=\"vm.mapping[header] = null;\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></td></tr></tbody></table></div>\n</md-dialog-content><md-dialog-content ng-if=\"vm.importFinished && !vm.importError\" ms-scroll flex \nclass=\"content-card results\" ng-class=\"vm.currentView\"><div ng-if=\"!vm.contentImporter\" layout=\"row\" layout-padding \nlayout-wrap layout-fill style=\"padding-bottom: 32px\" ng-cloak><span flex-xs=\"100\" flex-gt-xs=\"33\" layout \nlayout-align=\"center center\"><md-whiteframe class=\"md-whiteframe-1dp\"><label translate=\"USERS.CREATED_NEWS\"></label>\n<div class=\"value-result\">{{vm.resultImport.users.new}}</div></md-whiteframe></span><span flex-xs=\"100\" \nflex-gt-xs=\"33\" layout layout-align=\"center center\"><md-whiteframe class=\"md-whiteframe-2dp\"><label>\n{{ \'USERS.ADDED_TO_GROUP\' | translate }}: {{vm.groupSelectedName}}</label><div class=\"value-result\">\n{{vm.resultImport.in_group.new}}</div></md-whiteframe></span><span flex-xs=\"100\" flex-gt-xs=\"33\" layout \nlayout-align=\"center center\"><md-whiteframe class=\"md-whiteframe-2dp\"><label translate=\"USERS.UPDATED\"></label><div \nclass=\"value-result\">{{vm.resultImport.users.updated}}</div></md-whiteframe></span><span flex-xs=\"100\" flex-gt-xs=\"33\" \nlayout layout-align=\"center center\"><md-whiteframe class=\"md-whiteframe-2dp\"><label translate=\"USERS.ALREADY_IMPORTED\">\n</label><div class=\"value-result\">{{vm.resultImport.users.skipped}}</div></md-whiteframe></span><span flex-xs=\"100\" \nflex-gt-xs=\"33\" layout layout-align=\"center center\"><md-whiteframe class=\"md-whiteframe-2dp\"><label \ntranslate=\"USERS.INVALID\"></label><div class=\"value-result\">{{vm.resultImport.users.invalid}}</div></md-whiteframe>\n</span><span flex-xs=\"100\" flex-gt-xs=\"33\" layout layout-align=\"center center\"><md-whiteframe \nclass=\"md-whiteframe-2dp\"><label translate=\"USERS.TOTAL\"></label><div class=\"value-result\">\n{{vm.resultImport.users.total}}</div></md-whiteframe></span><div fill-width class=\"text-center\" \nng-if=\"vm.resultImport.invalid_data.length > 0\"><h2 translate=\"USERS.INVALID_ADDRESSES\"></h2></div><div fill-width \nclass=\"text-center\" ng-if=\"vm.resultImport.invalid_data.length > 0\"><div \nng-repeat=\"emailInvalid in vm.resultImport.invalid_data track by $index\"><span>{{emailInvalid}}</span></div></div>\n</div><div ng-if=\"vm.contentImporter\" layout=\"row\" layout-padding layout-wrap layout-fill style=\"padding-bottom: 32px\" \nng-cloak><span flex-xs=\"100\" flex-gt-xs=\"33\" layout layout-align=\"center center\"><md-whiteframe \nclass=\"md-whiteframe-1dp\"><label translate=\"USERS.CREATED_NEWS\"></label><div class=\"value-result\">\n{{vm.resultImport.records.new}}</div></md-whiteframe></span><span flex-xs=\"100\" flex-gt-xs=\"33\" layout \nlayout-align=\"center center\"><md-whiteframe class=\"md-whiteframe-2dp\"><label translate=\"USERS.UPDATED\"></label><div \nclass=\"value-result\">{{vm.resultImport.records.updated}}</div></md-whiteframe></span><span flex-xs=\"100\" \nflex-gt-xs=\"33\" layout layout-align=\"center center\"><md-whiteframe class=\"md-whiteframe-2dp\"><label \ntranslate=\"USERS.ALREADY_IMPORTED\"></label><div class=\"value-result\">{{vm.resultImport.records.skipped}}</div>\n</md-whiteframe></span><span flex-xs=\"100\" flex-gt-xs=\"33\" layout layout-align=\"center center\"><md-whiteframe \nclass=\"md-whiteframe-2dp\"><label translate=\"USERS.INVALID\"></label><div class=\"value-result\">\n{{vm.resultImport.records.invalid}}</div></md-whiteframe></span><span flex-xs=\"100\" flex-gt-xs=\"33\" layout \nlayout-align=\"center center\"><md-whiteframe class=\"md-whiteframe-2dp\"><label translate=\"USERS.TOTAL\"></label><div \nclass=\"value-result\">{{vm.resultImport.records.total}}</div></md-whiteframe></span><div fill-width class=\"text-center\" \nng-if=\"vm.resultImport.invalid_data.length > 0\"><h2 translate=\"USERS.INVALID_ADDRESSES\"></h2></div><div fill-width \nclass=\"text-center\" ng-if=\"vm.resultImport.invalid_data.length > 0\"><div \nng-repeat=\"emailInvalid in vm.resultImport.invalid_data track by $index\"><span>{{emailInvalid}}</span></div></div>\n</div></md-dialog-content><md-dialog-content ng-if=\"vm.importError\"><p class=\"import-error\">{{vm.importError}}</p>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\" ng-if=\"!vm.loading\"><div \nng-if=\"!vm.contentImporter\" flex layout=\"row\" layout-align=\"start center\"><h3 class=\"m-0\">\n{{ \'RUNTAG.MAX_USERS_IMPORT\' | translate}}</h3></div><div flex layout=\"row\" layout-align=\"end center\"><md-button \nng-if=\"vm.importFinished\" type=\"submit\" class=\"send-button md-accent md-raised\" ng-click=\"vm.closeDialogAndUpdate()\" \ntranslate=\"USERS.ACCEPT\"></md-button><md-button ng-if=\"!vm.importFinished\" type=\"button\" class=\"md-raised md-warn\" \nng-click=\"vm.closeDialog()\" translate=\"GROUP.CANCEL\"></md-button><md-button ng-if=\"!vm.importFinished\" type=\"submit\" \nclass=\"send-button md-accent md-raised\" ng-click=\"vm.resetForm()\" translate=\"USERS.RESET\"></md-button><md-button \nng-if=\"!vm.importFinished\" ng-disabled=\"!vm.files || (vm.isQiuRestricted && !vm.groupSelectedId)\" type=\"submit\" \nclass=\"send-button md-accent md-raised\" ng-click=\"vm.importUsers()\" translate=\"USERS.IMPORT\"></md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/runtag/event/dialogs/media/edit-user-media-dialog.html","<div layout=\"row\"><md-button class=\"close-button md-icon-button\" ng-click=\"vm.closeEditUser()\" \naria-label=\"Close dialog\" tranlate translate-aria-label=\"CONTENT.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div><div layout=\"row\" layout-align=\"space-between\" ng-if=\"!vm.assignPicker\"><input \ntype=\"search\" translate translate-attr-placeholder=\"USERS.SEARCH_USER_PLACEHOLDER\" ng-model=\"vm.querySearch\" \nclass=\"input-query\" ng-enter=\"vm.searchEditUser()\"><md-button class=\"submit-button\" type=\"submit\" \ntranslate=\"USERS.SEARCH\" ng-click=\"vm.searchEditUser()\"></md-button></div><div \nng-if=\"vm.searchingUsers && !vm.assignPicker\" layout=\"row\" layout-align=\"center center\" class=\"edit-user-loading\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"28\"></md-progress-circular></div><div id=\"search-container\" \nng-if=\"!vm.assignPicker && !vm.searchingUsers\"><div ng-if=\"vm.editType == \'edit\'\" class=\"user\" \nng-repeat=\"user in vm.usersToEdit\" ng-click=\"vm.changeUserRecognized(user)\"><div layout=\"row\" \nlayout-align=\"start center\"><div><media ng-if=\"!user.avatar\" class-img=\"avatar\" force-class use-default></media><img \nng-if=\"user.avatar\" ng-src=\"{{user.avatar}}\" class=\"avatar\"></div><div layout=\"column\"><span><strong>\n{{user.firstname}} {{user.lastname}}</strong></span> <span>{{user.email}}</span> <span>{{user.eventNumber}}</span>\n</div></div></div><div ng-if=\"vm.editType == \'add\' || !vm.editType\" class=\"user\" ng-repeat=\"user in vm.usersToEdit\" \nng-click=\"vm.selectUserForAdd(user)\"><div layout=\"row\" layout-align=\"start center\"><div><media ng-if=\"!user.avatar\" \nclass-img=\"avatar\" force-class use-default></media><img ng-if=\"user.avatar\" ng-src=\"{{user.avatar}}\" class=\"avatar\">\n</div><div layout=\"column\"><span><strong>{{user.firstname}} {{user.lastname}}</strong></span> <span>{{user.email}}\n</span> <span>{{user.eventNumber}}</span></div></div></div></div><div id=\"assign-profile-picker\" \nng-if=\"vm.assignPicker\"><div layout=\"row\" layout-align=\"start center\" class=\"assign-picker-header\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeProfilePicker()\" aria-label=\"Volver\"><md-icon md-font-icon=\"icon-arrow-left\">\n</md-icon></md-button><span><strong>{{vm.assignPicker.user.firstname}} {{vm.assignPicker.user.lastname}}</strong>\n — elige perfil</span></div><div ng-if=\"vm.assignPicker.loading\" layout=\"row\" layout-align=\"start center\" \nclass=\"assign-picker-loading\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"22\"></md-progress-circular>\n<span>Cargando perfiles…</span></div><div ng-if=\"vm.assignPicker.error\" class=\"assign-picker-msg\">\nNo se pudieron cargar los perfiles.</div><div \nng-if=\"!vm.assignPicker.loading && !vm.assignPicker.error && vm.assignPicker.profiles.length === 0\" \nclass=\"assign-picker-msg\">Este usuario no tiene perfiles en el evento.</div><div \nng-if=\"!vm.assignPicker.loading && vm.assignPicker.profiles.length\"><div class=\"user assign-profile-item\" \nng-repeat=\"p in vm.assignPicker.profiles\" ng-click=\"vm.pickProfileForAssign(p)\" \nng-class=\"{\'assign-disabled\': vm.assignPicker.saving}\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nng-if=\"p.is_face\" md-font-icon=\"icon-face\"></md-icon><div layout=\"column\"><span><strong>\n{{ p.name || (p.is_face ? \'Perfil por cara\' : (\'Dorsal \' + p.dorsal)) }}</strong></span> <span ng-if=\"!p.is_face\">\nDorsal {{p.dorsal}}<span ng-if=\"p.is_primary\"> (propio)</span></span></div></div></div></div></div>");
$templateCache.put("app/main/apps/runtag/event/dialogs/media/media-dialog-v2.html","<md-dialog id=\"users-in-events-media-dialog\" class=\"large attachment-dialog\"><md-toolbar \nclass=\"md-accent md-hue-2 md-default-theme\"><div layout=\"row\" class=\"md-toolbar-tools\"><div layout=\"row\" \nclass=\"info-container\"><div ng-if=\"vm.selectedUser\"><media ng-if=\"!vm.selectedUser.avatar\" class-img=\"avatar\" \nforce-class use-default></media><img ng-if=\"vm.selectedUser.avatar\" ng-src=\"{{vm.selectedUser.avatar}}\" class=\"avatar\">\n</div><div layout=\"column\" id=\"header-info\"><span><strong>{{vm.selectedUser.firstname}} {{vm.selectedUser.lastname}}\n</strong> {{vm.selectedUser.eventNumber}} </span><span>{{vm.selectedUser.email}}</span></div></div><span flex>\n{{vm.imagesToShow.indexOf(vm.imageToShow) + 1}} - {{vm.imagesToShow.length}}</span><div layout=\"row\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate \ntranslate-aria-label=\"CONTENT.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></div>\n<md-dialog-content id=\"dialogContent_users-in-events-media-dialog\" class=\"mediadialog-content\" layout-fill=\"\"><div \nng-if=\"!vm.imageToShow\" id=\"runtag-downloaded-spinner-container\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"30\"></md-progress-circular></div><div ng-if=\"vm.imageToShow\" id=\"image-container\"><div \nclass=\"arrow arrow-left\" ng-click=\"vm.changeImage(\'previous\')\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon>\n</div><div id=\"image-wrapper\" ng-style=\"vm.wrapperStyle\"><img id=\"image-to-show\" \nng-class=\"{\'full-screen\' : vm.fullScreen}\" ng-src=\"{{vm.imageToShow.urlImage}}\"><div ng-if=\"!vm.fullScreen\" \nclass=\"fotorama__fullscreen-icon\" tabindex=\"0\" role=\"button\" ng-click=\"vm.fullScreen = true\"></div><div \nng-if=\"vm.fullScreen\" ng-class=\"{\'full-screen\' : vm.fullScreen}\" class=\"fotorama__fullscreen-icon\" tabindex=\"0\" \nrole=\"button\" ng-click=\"vm.fullScreen = false\"></div><span ng-repeat=\"tag in vm.imageToShow.labels.persons\" \ntitle=\"{{ tag.runnerNumber.detectedText }}\" \nng-if=\"vm.showBoundingBoxes && tag.face && !vm.fullScreen && vm.isLegendVisible(tag, false)\" class=\"label-mark\" \nng-click=\"vm.editPerson(tag)\" \nng-class=\"{\'approved\' : !tag.rejected, \'rejected\' : tag.rejected, \'low-sharpness\' : vm.isAdmin && (tag.face.quality.sharpness || tag.quality.sharpness) < 2}\" \nstyle=\"top: {{tag.face.boundingBox.top*100}}%; \r\n                                left: {{tag.face.boundingBox.left*100}}%; \r\n                                width: {{tag.face.boundingBox.width*100}}%; \r\n                                height: {{tag.face.boundingBox.height*100}}%\" \nrole=\"button\"><span class=\"number\">{{tag.runnerNumber.detectedText}}</span> </span><span \nng-repeat=\"tag in vm.imageToShow.labels.unknownFaces\" ng-click=\"vm.editPerson(tag)\" class=\"label-mark\" \nng-class=\"{\'rejected\' : tag.reason == \'IT_IS_NOT_ME\', \'ignored\': tag.reason != \'IT_IS_NOT_ME\'}\" \nng-if=\"vm.showBoundingBoxes && vm.imageToShow.labels.unknownFaces && !vm.fullScreen && vm.isLegendVisible(tag, true)\" \nstyle=\"top:    {{tag.face.boundingBox.top*100}}%;\r\n                                width:  {{tag.face.boundingBox.width*100}}%; \r\n                                left:   {{tag.face.boundingBox.left*100}}%; \r\n                                height: {{tag.face.boundingBox.height*100}}%\" \nrole=\"button\"><span ng-if=\"!tag.reason\">No reason</span> <span ng-if=\"tag.reason != \'IT_IS_NOT_ME\'\" \ntranslate=\"RUNTAG.{{tag.reason}}\">{{tag.reason}}</span> <span ng-if=\"tag.reason == \'IT_IS_NOT_ME\'\">rejected</span> \n</span><span ng-repeat=\"tag in vm.imageToShow.labels.lowQualityFaces\" \nng-if=\"vm.showBoundingBoxes && vm.imageToShow.labels.lowQualityFaces && tag.face && !vm.fullScreen && vm.isSharpnessTierVisible(tag)\" \nclass=\"label-mark\" ng-class=\"vm.lowQualitySharpnessClass(tag)\" ng-click=\"vm.editPerson(tag)\" \ntitle=\"{{ \'RUNTAG.LOW_SHARPNESS\' | translate }}\" \nstyle=\"top:    {{tag.face.boundingBox.top*100}}%;\r\n                                width:  {{tag.face.boundingBox.width*100}}%;\r\n                                left:   {{tag.face.boundingBox.left*100}}%;\r\n                                height: {{tag.face.boundingBox.height*100}}%\" \nrole=\"button\"></span> <span ng-repeat=\"tag in vm.imageToShow.labels.unmatchedNumbers\" ng-click=\"vm.editPerson(tag)\" \nclass=\"label-mark unmatched-number\" \nng-if=\"vm.imageToShow.labels.unmatchedNumbers && !vm.fullScreen && vm.legendVisible.unmatchedNumber\" \nstyle=\"top:    {{tag.boundingBox.top*100}}%;\r\n                                width:  {{tag.boundingBox.width*100}}%;\r\n                                left:   {{tag.boundingBox.left*100}}%;\r\n                                height: {{tag.boundingBox.height*100}}%\" \nrole=\"button\"><span>Unmatched {{tag.detectedText}}</span> </span><svg \nng-if=\"vm.showSegments && vm.imageToShow.aiSegmentation && vm.imageToShow.aiSegmentation.length && !vm.fullScreen\" \nclass=\"segments-svg-overlay\" viewBox=\"0 0 100 100\" preserveAspectRatio=\"none\"><g \nng-repeat=\"seg in vm.imageToShow.aiSegmentation\" ng-mouseenter=\"vm.hoverSegment(seg)\" \nng-mouseleave=\"vm.clearHoveredSegment()\" \nng-style=\"{\'opacity\': vm.hoveredSegment && vm.hoveredSegment !== seg ? 0 : 1, \'transition\': \'opacity 0.15s\'}\"><polygon \nng-if=\"seg.polygon\" ng-attr-points=\"{{vm.getPolygonPoints(seg.polygon)}}\" class=\"segment-polygon\" \nng-attr-style=\"stroke: {{vm.getSegmentColor($index, vm.imageToShow.aiSegmentation.length)}}; fill: {{vm.getSegmentColor($index, vm.imageToShow.aiSegmentation.length)}}; fill-opacity: 0.18; stroke-width: 0.5;\"/>\n<rect ng-if=\"seg.boundingBox\" ng-attr-x=\"{{seg.boundingBox.left * 100}}\" ng-attr-y=\"{{seg.boundingBox.top * 100}}\" \nng-attr-width=\"{{seg.boundingBox.width * 100}}\" ng-attr-height=\"{{seg.boundingBox.height * 100}}\" class=\"segment-bbox\" \nng-attr-style=\"stroke: {{vm.getSegmentColor($index, vm.imageToShow.aiSegmentation.length)}}; fill: none; stroke-width: 0.5;\"/>\n</g></svg><div \nng-if=\"vm.showSegments && vm.imageToShow.aiSegmentation && vm.imageToShow.aiSegmentation.length && !vm.fullScreen\"><div\n ng-repeat=\"seg in vm.imageToShow.aiSegmentation\" ng-mouseenter=\"vm.hoverSegment(seg)\" \nng-mouseleave=\"vm.clearHoveredSegment()\" \nng-style=\"{\'opacity\': vm.hoveredSegment && vm.hoveredSegment !== seg ? 0 : 1, \'transition\': \'opacity 0.15s\'}\"><div \nng-repeat=\"kp in seg.keypointList\" class=\"keypoint-dot\" title=\"{{kp.name}}\" \nng-style=\"{\r\n                                     left:             (kp.x * 100) + \'%\',\r\n                                     top:              (kp.y * 100) + \'%\',\r\n                                     \'background-color\': vm.getSegmentColor($parent.$index, vm.imageToShow.aiSegmentation.length)\r\n                                 }\">\n</div></div></div><div class=\"segment-tooltip\" ng-if=\"vm.showSegments && vm.hoveredSegment\"><span \nclass=\"segment-tooltip-label\">Confidence</span> <span class=\"segment-tooltip-value\">\n{{(vm.hoveredSegment.confidence * 100) | number:2}}%</span></div></div><div class=\"arrow arrow-right\" \nng-click=\"vm.changeImage(\'next\')\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></div></div><div \nid=\"info-container\" ng-if=\"!vm.fullScreen\"><div layout=\"column\" layout-align=\"start start\" style=\"margin-top: 8px\"><div\n layout=\"row\" layout-align=\"start center\"><md-button class=\"download-image-button md-raised-button\" \nng-click=\"vm.downloadImage()\" aria-label=\"Download image\"><md-icon md-font-icon=\"icon-download\"></md-icon><span \ntranslate=\"RUNTAG.DOWNLOAD_IMAGE\">Download image</span></md-button><md-button class=\"cog-button md-icon-button\" \nng-click=\"vm.openJSON()\" aria-label=\"Open JSON\" tranlate translate-aria-label=\"CONTENT.OPEN_JSON\"><md-icon \nmd-font-icon=\"icon-cog\"></md-icon></md-button></div><md-button class=\"segments-toggle-button md-raised-button\" \nng-class=\"{\'active\': vm.showSegments}\" \nng-disabled=\"!vm.imageToShow.aiSegmentation || !vm.imageToShow.aiSegmentation.length\" ng-click=\"vm.toggleSegments()\" \naria-label=\"Toggle segments\"><md-icon md-font-icon=\"icon-layers\"></md-icon><span translate=\"RUNTAG.TOGGLE_SEGMENTS\">\nSegments</span></md-button><md-button class=\"segments-toggle-button bboxes-toggle-button md-raised-button\" \nng-class=\"{\'active\': vm.showBoundingBoxes}\" ng-click=\"vm.toggleBoundingBoxes()\" \naria-label=\"Toggle face bounding boxes\"><md-icon md-font-icon=\"icon-tag-faces\"></md-icon><span \ntranslate=\"RUNTAG.TOGGLE_BBOXES\">Faces</span></md-button></div><md-chips ng-model=\"vm.imageToShow.tags\" \nreadonly=\"true\" md-removable=\"true\" \nmd-chip-class=\"vm.isAdmin && ( ($chip.face.quality.sharpness || $chip.quality.sharpness) < 2 ) ? \'low-sharpness\' : \'\'\">\n<md-chip-template qiu-chip qiu-chip-reason=\"{{$chip.reason? $chip.reason : $chip.type}}\" \nqiu-chip-runner=\"{{vm.selectedUser.eventNumber === ($chip.runnerNumber ? $chip.runnerNumber.detectedText : null) || \r\n                                       vm.selectedUser.eventNumber === $chip.detectedText ? \'current\' : \'other\'}}\" \nqiu-chip-low-sharpness=\"{{vm.isAdmin && ( ($chip.face.quality.sharpness || $chip.quality.sharpness) < 2)}}\" \ncontroller-vm=\"vm\"><span ng-if=\"$chip.type != \'unmatchedNumber\'\">{{$chip.runnerNumber.detectedText}}</span> <span \nng-if=\"$chip.type == \'unmatchedNumber\'\">{{$chip.detectedText}}</span></md-chip-template><button \nng-disabled=\"$chip.rejected\" md-chip-remove class=\"md-primary remove\" ng-click=\"vm.deleteChip($chip)\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></button></md-chips><md-button ng-click=\"vm.openEditUser()\" aria-label=\"Add\" \nclass=\"md-icon-button add-user-button\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><div \nid=\"media-download-container\"><span id=\"downloads-title\" \nng-if=\"!vm.loadingDownloads && vm.imageToShow.downloads && vm.imageToShow.downloads.length > 0\" \ntranslate=\"RUNTAG.DOWNLOADS\"></span> <span id=\"downloads-title\" \nng-if=\"!vm.loadingDownloads && vm.imageToShow.downloads && vm.imageToShow.downloads.length === 0\" \ntranslate=\"RUNTAG.NO_DOWNLOADS\"></span><md-progress-circular ng-show=\"vm.loadingDownloads\" md-mode=\"indeterminate\" \nmd-diameter=\"30\"></md-progress-circular><div ng-repeat=\"download in vm.imageToShow.downloads\" class=\"download-text\">\n<span class=\"download-date\">\n{{ download.downloaded_at ? vm.formatDate(download.downloaded_at, \'d MMM HH:mm\') : \'Fecha no disponible\' }}</span> \n<span class=\"download-dorsal\">{{ download.runner_number ? download.runner_number : \'Dorsal no disponible\' }}</span> \n<span class=\"download-email\">({{ download.email ? download.email : \'Email no disponible\' }})</span></div></div><div \nid=\"legend-container\"><span ng-if=\"vm.imageToShow.photographer || vm.imageToShow.fields.photographer\" \ntranslate=\"RUNTAG.PHOTOGRAPHER\">Photographer</span><div \nng-if=\"vm.imageToShow.photographer || vm.imageToShow.fields.photographer\" layout=\"row\" layout-align=\"start center\" \nstyle=\"margin-bottom: 15px\"><span style=\"text-transform: capitalize\">\n{{vm.imageToShow.photographer || vm.imageToShow.fields.photographer}}</span></div><span \ntranslate=\"RUNTAG.ARTIFICIAL_INTELLIGENCE\">Artificial_intelligence</span><div id=\"approved\" role=\"button\" \nng-click=\"vm.toggleLegend(\'approved\')\" ng-class=\"{\'tier-hidden\': !vm.legendVisible.approved}\"><div class=\"identifier\">\n</div><span translate=\"RUNTAG.RECOGN_IA\">Recognized user</span></div><div id=\"ignored\" role=\"button\" \nng-click=\"vm.toggleLegend(\'ignored\')\" ng-class=\"{\'tier-hidden\': !vm.legendVisible.ignored}\"><div class=\"identifier\">\n</div><span translate=\"RUNTAG.IGNORED_USER\">Ignored person</span></div><span translate=\"RUNTAG.USER_ACTIONS\">\nAcciones Usuario</span><div id=\"rejected\" role=\"button\" ng-click=\"vm.toggleLegend(\'rejected\')\" \nng-class=\"{\'tier-hidden\': !vm.legendVisible.rejected}\"><div class=\"identifier\"></div><span \ntranslate=\"RUNTAG.REJECTED_BY_USER\">Rejected by user</span></div><div id=\"USER_CLAIM\" role=\"button\" \nng-click=\"vm.toggleLegend(\'USER_CLAIM\')\" ng-class=\"{\'tier-hidden\': !vm.legendVisible.USER_CLAIM}\"><div \nclass=\"identifier\"></div><span translate=\"RUNTAG.ADDED_BY_USER\">Added by user</span></div><div id=\"ADMIN_CLAIM\" \nrole=\"button\" ng-click=\"vm.toggleLegend(\'ADMIN_CLAIM\')\" ng-class=\"{\'tier-hidden\': !vm.legendVisible.ADMIN_CLAIM}\"><div \nclass=\"identifier\"></div><span translate=\"RUNTAG.ADDED_BY_ADMIN\">Added by admin</span></div><div id=\"unmatched-number\" \nrole=\"button\" ng-click=\"vm.toggleLegend(\'unmatchedNumber\')\" \nng-class=\"{\'tier-hidden\': !vm.legendVisible.unmatchedNumber}\"><div class=\"identifier\"></div><span \ntranslate=\"RUNTAG.UNMATCHED_NUMBER\">Unmatched number</span></div><div id=\"low-sharpness-t0\" ng-if=\"vm.isAdmin\" \nrole=\"button\" ng-click=\"vm.toggleSharpnessTier(\'t0\')\" ng-class=\"{\'tier-hidden\': !vm.sharpnessTierVisible.t0}\"><div \nclass=\"identifier\"></div><span translate=\"RUNTAG.LOW_SHARPNESS\">Low sharpness</span>&nbsp;&le;&nbsp;1</div><div \nid=\"low-sharpness-t1\" ng-if=\"vm.isAdmin\" role=\"button\" ng-click=\"vm.toggleSharpnessTier(\'t1\')\" \nng-class=\"{\'tier-hidden\': !vm.sharpnessTierVisible.t1}\"><div class=\"identifier\"></div><span \ntranslate=\"RUNTAG.LOW_SHARPNESS\">Low sharpness</span>&nbsp;1–2</div><div id=\"low-sharpness-t2\" ng-if=\"vm.isAdmin\" \nrole=\"button\" ng-click=\"vm.toggleSharpnessTier(\'t2\')\" ng-class=\"{\'tier-hidden\': !vm.sharpnessTierVisible.t2}\"><div \nclass=\"identifier\"></div><span translate=\"RUNTAG.LOW_SHARPNESS\">Low sharpness</span>&nbsp;2–10</div><div \nid=\"low-sharpness-t3\" ng-if=\"vm.isAdmin\" role=\"button\" ng-click=\"vm.toggleSharpnessTier(\'t3\')\" \nng-class=\"{\'tier-hidden\': !vm.sharpnessTierVisible.t3}\"><div class=\"identifier\"></div><span \ntranslate=\"RUNTAG.LOW_SHARPNESS\">Low sharpness</span>&nbsp;10–20</div><div id=\"low-sharpness-t4\" ng-if=\"vm.isAdmin\" \nrole=\"button\" ng-click=\"vm.toggleSharpnessTier(\'t4\')\" ng-class=\"{\'tier-hidden\': !vm.sharpnessTierVisible.t4}\"><div \nclass=\"identifier\"></div><span translate=\"RUNTAG.LOW_SHARPNESS\">Low sharpness</span>&nbsp;&gt;&nbsp;20</div></div>\n</div><div ng-if=\"vm.tagToEdit && !vm.editUserDialog && !vm.showJSON && !vm.showingFaceInfo\" id=\"edit-user-container\">\n<md-button class=\"close-button md-icon-button\" ng-click=\"vm.closeEditUser()\" aria-label=\"Close dialog\" tranlate \ntranslate-aria-label=\"CONTENT.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button><div \nclass=\"nav-item\"><nav ng-if=\"!vm.loadingSearchFaceId\"><ul><li \nng-if=\"vm.selectedUser && !vm.tagToEdit.rejected && vm.tagToEdit.runnerNumber == vm.selectedUser.eventNumber\" \nng-click=\"vm.itsNotMe(vm.tagToEdit, true)\"><a translate=\"USERS.ITS_NOT_ME\">Its not me</a></li><li \nng-if=\"vm.tagToEdit.type != \'unmatchedNumber\' && ((vm.tagToEdit.current_number && vm.tagToEdit.current_number != \'unknown\') || (vm.tagToEdit.runner_number && vm.tagToEdit.runner_number != \'unknown\') ||  vm.tagToEdit.runnerNumber)\" \nng-click=\"vm.openEditUser(\'\', \'edit\')\"><a translate=\"USERS.EDIT_USER\">Change person</a></li><li \nng-if=\"vm.tagToEdit.type != \'unmatchedNumber\' && ((vm.tagToEdit.current_number && vm.tagToEdit.current_number == \'unknown\') || (vm.tagToEdit.runner_number && vm.tagToEdit.runner_number == \'unknown\') || (!vm.tagToEdit.runnerNumber && !vm.tagToEdit.runner_number))\" \nng-click=\"vm.openEditUser()\"><a translate=\"USERS.EDIT_USER\">Change person</a></li><li \nng-if=\"vm.tagToEdit.face_id || vm.tagToEdit.faceId || vm.tagToEdit.id_user_face || vm.tagToEdit.face && vm.tagToEdit.face.faceId\" \nng-click=\"vm.searchByFace()\"><a translate=\"USERS.SEARCH_BY_FACE\">Search by face</a></li><li \nng-if=\"vm.tagToEdit.type == \'unmatchedNumber\'\" ng-click=\"vm.removeUnmatchedNumber()\"><a \ntranslate=\"USERS.REMOVE_UNMATCHED_NUMBER\">Remove unmatched number</a></li><li \nng-if=\"vm.tagToEdit.type == \'unmatchedNumber\'\" ng-click=\"vm.addUnmatchedNumber()\"><a \ntranslate=\"USERS.ADD_UNMATCHED_NUMBER\">Add number {{vm.tagToEdit.detectedText}} to image</a></li><li \nng-if=\"vm.tagToEdit.face && vm.tagToEdit.face.faceId\" ng-click=\"vm.showFaceInfo()\"><a \ntranslate=\"RUNTAG.SHOW_FACE_DATA\">Show face data</a></li></ul></nav><div class=\"loading-container\" \nng-if=\"vm.loadingSearchFaceId\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular>\n</div></div></div><div ng-if=\"vm.tagToEdit && vm.showingFaceInfo\" id=\"edit-user-container\"><md-button \nclass=\"close-button md-icon-button\" ng-click=\"vm.closeEditUser()\" aria-label=\"Close dialog\" tranlate \ntranslate-aria-label=\"CONTENT.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button><div \nclass=\"face-info-panel\"><div class=\"face-info-row\"><span class=\"face-info-label\">Reason</span><span \nclass=\"face-info-value\">{{vm.tagToEdit.reason}}</span></div><div class=\"face-info-row\"><span class=\"face-info-label\">\nFace ID</span><span class=\"face-info-value\">{{vm.tagToEdit.face.faceId}}</span></div><div class=\"face-info-row\"><span \nclass=\"face-info-label\">Confidence</span><span class=\"face-info-value\">{{vm.tagToEdit.face.confidence | number:2}}%\n</span></div><div class=\"face-info-row\"><span class=\"face-info-label\">Sharpness</span><span class=\"face-info-value\">\n{{vm.tagToEdit.face.quality.sharpness | number:2}}</span></div><div class=\"face-info-row\"><span \nclass=\"face-info-label\">Brightness</span><span class=\"face-info-value\">\n{{vm.tagToEdit.face.quality.brightness | number:2}}</span></div><div class=\"face-info-row\"><span \nclass=\"face-info-label\">BBox top</span><span class=\"face-info-value\">{{vm.tagToEdit.face.boundingBox.top | number:4}}\n</span></div><div class=\"face-info-row\"><span class=\"face-info-label\">BBox left</span><span class=\"face-info-value\">\n{{vm.tagToEdit.face.boundingBox.left | number:4}}</span></div><div class=\"face-info-row\"><span class=\"face-info-label\">\nBBox width</span><span class=\"face-info-value\">{{vm.tagToEdit.face.boundingBox.width | number:4}}</span></div><div \nclass=\"face-info-row\"><span class=\"face-info-label\">BBox height</span><span class=\"face-info-value\">\n{{vm.tagToEdit.face.boundingBox.height | number:4}}</span></div></div></div><div ng-if=\"vm.editUserDialog\" \nid=\"edit-user-search-container\" ng-include=\"\'app/main/apps/runtag/event/dialogs/media/edit-user-media-dialog.html\'\">\n</div><div ng-if=\"vm.showJSON\" id=\"show-json-container\" \nng-include=\"\'app/main/apps/runtag/event/dialogs/media/show-json.html\'\"></div></md-dialog-content></md-toolbar>\n</md-dialog>");
$templateCache.put("app/main/apps/runtag/event/dialogs/media/media-dialog.html","<md-dialog id=\"users-in-events-media-dialog\" class=\"large attachment-dialog\"><md-toolbar \nclass=\"md-accent md-hue-2 md-default-theme\"><div class=\"md-toolbar-tools\"><div layout=\"row\" class=\"info-container\">\n<div><media ng-if=\"!vm.selectedUser.avatar\" class-img=\"avatar\" force-class use-default></media><img \nng-if=\"vm.selectedUser.avatar\" ng-src=\"{{vm.selectedUser.avatar}}\" class=\"avatar\"></div><div layout=\"column\" \nid=\"header-info\"><span><strong>{{vm.selectedUser.firstname}} {{vm.selectedUser.lastname}}</strong>\n {{vm.selectedUser.eventNumber}} </span><span>{{vm.selectedUser.email}}</span></div></div><span flex>\n{{vm.imagesToShow.indexOf(vm.imageToShow) + 1}} - {{vm.imagesToShow.length}}</span><div layout=\"row\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate \ntranslate-aria-label=\"CONTENT.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></div>\n<md-dialog-content id=\"dialogContent_users-in-events-media-dialog\" class=\"mediadialog-content\" layout-fill=\"\"><div \nid=\"image-container\"><div class=\"arrow arrow-left\" ng-click=\"vm.changeImage(\'previous\')\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></div><img id=\"image-to-show\" ng-class=\"{\'full-screen\' : vm.fullScreen}\" \nng-src=\"{{vm.imageToShow.urlImage}}\"><div ng-if=\"!vm.fullScreen\" class=\"fotorama__fullscreen-icon\" tabindex=\"0\" \nrole=\"button\" ng-click=\"vm.fullScreen = true\"></div><div ng-if=\"vm.fullScreen\" \nng-class=\"{\'full-screen\' : vm.fullScreen}\" class=\"fotorama__fullscreen-icon\" tabindex=\"0\" role=\"button\" \nng-click=\"vm.fullScreen = false\"></div><span ng-repeat=\"tag in vm.imageToShow.labels.persons\" \ntitle=\"{{ tag.runner_number }}\" ng-if=\"tag.label.BoundingBox && !vm.fullScreen\" class=\"label-mark\" \nng-click=\"vm.editPerson(tag)\" ng-class=\"{\'approved\' : !tag.rejected, \'rejected\' : tag.rejected}\" \nstyle=\"top: {{tag.label.BoundingBox.Top*100}}%; \r\n                            left: {{tag.label.BoundingBox.Left*100}}%; \r\n                            width: {{tag.label.BoundingBox.Width*100}}%; \r\n                            height: {{tag.label.BoundingBox.Height*100}}%\" \nrole=\"button\"><span class=\"number\">{{tag.runner_number}}</span> </span><span \nng-repeat=\"tag in vm.imageToShow.labels.persons\" title=\"{{ tag.runnerNumber.DetectedText }}\" \nng-if=\"tag.face && !vm.fullScreen\" class=\"label-mark\" ng-click=\"vm.editPerson(tag)\" \nng-class=\"{\'approved\' : !tag.rejected, \'rejected\' : tag.rejected}\" \nstyle=\"top: {{tag.face.BoundingBox.Top*100}}%; \r\n                            left: {{tag.face.BoundingBox.Left*100}}%; \r\n                            width: {{tag.face.BoundingBox.Width*100}}%; \r\n                            height: {{tag.face.BoundingBox.Height*100}}%\" \nrole=\"button\"><span class=\"number\">{{tag.runnerNumber.DetectedText}}</span> </span><span \nng-repeat=\"tag in vm.imageToShow.labels.persons\" title=\"{{ tag.runnerNumber.DetectedText }}\" \nng-if=\"tag.runnerNumber && !vm.fullScreen\" class=\"label-mark\" ng-click=\"vm.editPerson(tag)\" \nng-class=\"{\'approved\' : !tag.rejected, \'rejected\' : tag.rejected}\" \nstyle=\"top: {{tag.runnerNumber.BoundingBox.Top*100}}%; \r\n                            left: {{tag.runnerNumber.BoundingBox.Left*100}}%; \r\n                            width: {{tag.runnerNumber.BoundingBox.Width*100}}%; \r\n                            height: {{tag.runnerNumber.BoundingBox.Height*100}}%\" \nrole=\"button\"></span> <span ng-repeat=\"tag in vm.imageToShow.labels.unknown_persons\" ng-click=\"vm.editPerson(tag)\" \nclass=\"label-mark\" ng-class=\"{\'rejected\' : tag.reason == \'IT_IS_NOT_ME\', \'ignored\': tag.reason != \'IT_IS_NOT_ME\'}\" \nng-if=\"vm.imageToShow.labels.unknown_persons && !vm.fullScreen\" \nstyle=\"top:    {{tag.label.BoundingBox.Top*100}}%; \r\n                            left:   {{tag.label.BoundingBox.Left*100}}%; \r\n                            width:  {{tag.label.BoundingBox.Width*100}}%; \r\n                            height: {{tag.label.BoundingBox.Height*100}}%\" \nrole=\"button\"><span ng-if=\"tag.reason != \'IT_IS_NOT_ME\'\">ignored</span> <span ng-if=\"tag.reason == \'IT_IS_NOT_ME\'\">\nrejected</span> </span><span ng-repeat=\"tag in vm.imageToShow.labels.unknownFaces\" ng-click=\"vm.editPerson(tag)\" \nclass=\"label-mark\" ng-class=\"{\'rejected\' : tag.reason == \'IT_IS_NOT_ME\', \'ignored\': tag.reason != \'IT_IS_NOT_ME\'}\" \nng-if=\"vm.imageToShow.labels.unknownFaces && !vm.fullScreen\" \nstyle=\"top:    {{tag.BoundingBox.Top*100}}%; \r\n                            width:  {{tag.BoundingBox.Width*100}}%; \r\n                            left:   {{tag.BoundingBox.Left*100}}%; \r\n                            height: {{tag.BoundingBox.Height*100}}%\" \nrole=\"button\"><span ng-if=\"tag.reason != \'IT_IS_NOT_ME\'\">ignored</span> <span ng-if=\"tag.reason == \'IT_IS_NOT_ME\'\">\nrejected</span> </span><span ng-repeat=\"tag in vm.imageToShow.labels.lowQualityFaces\" \nng-if=\"vm.imageToShow.labels.lowQualityFaces && tag.face && !vm.fullScreen\" class=\"label-mark low-sharpness\" \nstyle=\"top:    {{tag.face.boundingBox.top*100}}%;\r\n                            width:  {{tag.face.boundingBox.width*100}}%;\r\n                            left:   {{tag.face.boundingBox.left*100}}%;\r\n                            height: {{tag.face.boundingBox.height*100}}%\" \nrole=\"button\"><span translate=\"RUNTAG.LOW_SHARPNESS\">Low quality</span> </span><span \nng-repeat=\"tag in vm.imageToShow.labels.unmatchedNumbers\" ng-click=\"vm.editPerson(tag)\" \nclass=\"label-mark unmatched-number\" ng-if=\"vm.imageToShow.labels.unmatchedNumbers && !vm.fullScreen\" \nstyle=\"top:    {{tag.BoundingBox.Top*100}}%;\r\n                            width:  {{tag.BoundingBox.Width*100}}%;\r\n                            left:   {{tag.BoundingBox.Left*100}}%;\r\n                            height: {{tag.BoundingBox.Height*100}}%\" \nrole=\"button\"><span>unmatched</span></span><div class=\"arrow arrow-right\" ng-click=\"vm.changeImage(\'next\')\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon></div></div><div id=\"info-container\" ng-if=\"!vm.fullScreen\"><md-chips \nng-model=\"vm.imageToShow.labels.persons\" readonly=\"true\" md-removable=\"true\"><md-chip-template qiu-chip \nqiu-chip-reason=\"{{$chip.reason? $chip.reason : $chip.type}}\" \nqiu-chip-low-sharpness=\"{{vm.isAdmin && ( ($chip.face.quality.sharpness || $chip.quality.sharpness) < 2)}}\" \nqiu-chip-runner=\"{{vm.selectedUser.eventNumber === ($chip.runnerNumber ? $chip.runnerNumber.detectedText : null) || \r\n                                                     vm.selectedUser.eventNumber === $chip.detectedText ? \'current\' : \'other\'}}\" \ncontroller-vm=\"vm\"><span ng-if=\"$chip.runner_number \">{{$chip.runner_number}}</span> <span ng-if=\"$chip.runnerNumber\">\n{{$chip.runnerNumber.DetectedText}}</span></md-chip-template><button ng-disabled=\"$chip.rejected\" md-chip-remove \nclass=\"md-primary remove\" ng-click=\"vm.itsNotMe($chip, true)\"><md-icon md-font-icon=\"icon-close\"></md-icon></button>\n</md-chips><md-button ng-click=\"vm.openEditUser()\" aria-label=\"Add\" class=\"md-icon-button add-user-button\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button><div id=\"legend-container\"><span>Accesos Inteligencia Artificial</span>\n<div id=\"approved\"><span>Recognized user</span></div><div id=\"ignored\"><span>Ignored person</span></div><span>\nAcciones Usuario</span><div id=\"rejected\"><span>Rejected by user</span></div><div id=\"USER_CLAIM\"><span>Added by user\n</span></div><div id=\"ADMIN_CLAIM\"><span>Added by admin</span></div></div><div><md-button \nclass=\"cog-button md-icon-button\" ng-click=\"vm.openJSON()\" aria-label=\"Open JSON\" tranlate \ntranslate-aria-label=\"CONTENT.OPEN_JSON\"><md-icon md-font-icon=\"icon-cog\"></md-icon></md-button></div></div><div \nng-if=\"vm.tagToEdit && !vm.editUserDialog && !vm.showJSON\" id=\"edit-user-container\"><md-button \nclass=\"close-button md-icon-button\" ng-click=\"vm.closeEditUser()\" aria-label=\"Close dialog\" tranlate \ntranslate-aria-label=\"CONTENT.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button><div \nclass=\"nav-item\"><nav><ul><li \nng-if=\"vm.selectedUser && !vm.tagToEdit.rejected && vm.tagToEdit.runner_number == vm.selectedUser.eventNumber\" \nng-click=\"vm.itsNotMe(vm.tagToEdit, true)\"><a translate=\"USERS.ITS_NOT_ME\">Its not me</a></li><li \nng-if=\"vm.tagToEdit.type != \'unmatchedNumber\' && ((vm.tagToEdit.current_number && vm.tagToEdit.current_number != \'unknown\') || (vm.tagToEdit.runner_number && vm.tagToEdit.runner_number != \'unknown\') ||  vm.tagToEdit.runnerNumber)\" \nng-click=\"vm.openEditUser(\'\', \'edit\')\"><a translate=\"USERS.EDIT_USER\">Change person</a></li><li \nng-if=\"vm.tagToEdit.type != \'unmatchedNumber\' && ((vm.tagToEdit.current_number && vm.tagToEdit.current_number == \'unknown\') || (vm.tagToEdit.runner_number && vm.tagToEdit.runner_number == \'unknown\') || (!vm.tagToEdit.runnerNumber && !vm.tagToEdit.runner_number))\" \nng-click=\"vm.openEditUser()\"><a translate=\"USERS.EDIT_USER\">Change person</a></li><li \nng-if=\"vm.tagToEdit.face_id || vm.tagToEdit.faceId || vm.tagToEdit.id_user_face\" ng-click=\"vm.searchByFace()\"><a \ntranslate=\"USERS.SEARCH_BY_FACE\">Search by face</a></li><li ng-if=\"vm.tagToEdit.type == \'unmatchedNumber\'\" \nng-click=\"vm.removeUnmatchedNumber()\"><a translate=\"USERS.REMOVE_UNMATCHED_NUMBER\">Remove unmatched number</a></li>\n</ul></nav></div></div><div ng-if=\"vm.editUserDialog\" id=\"edit-user-search-container\" \nng-include=\"\'app/main/apps/runtag/event/dialogs/media/edit-user-media-dialog.html\'\"></div><div ng-if=\"vm.showJSON\" \nid=\"show-json-container\" ng-include=\"\'app/main/apps/runtag/event/dialogs/media/show-json.html\'\"></div>\n</md-dialog-content></md-toolbar></md-dialog>");
$templateCache.put("app/main/apps/runtag/event/dialogs/media/search-by-face-modal.html","<md-dialog id=\"search-by-face-dialog\"><md-toolbar flex layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"USERS.SEARCH_BY_FACE\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" tranlate translate-aria-label=\"CONTENT.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></md-toolbar><md-dialog-content><div ng-if=\"!vm.facesFound && !vm.searching\" ngf-drop ngf-select \nng-model=\"vm.file\" class=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\" accept=\"image/*\" ngf-pattern=\"\'image/*\'\" \nid=\"upload-photo-form\"><div layout=\"column\" layout-align=\"center center\"><div class=\"upload-image-container\" \nng-if=\"!vm.file\"><img src=\"https://web.runtag.app/assets/img/upload-image-ico-grey.svg\" class=\"upload-icon\"><div flex \ntranslate=\"MEDIA.DROP_HERE\" hide show-gt-sm></div><div flex translate=\"MEDIA.DROP_OR\" hide show-gt-sm></div><div flex>\n<md-button class=\"send-button md-accent md-raised\" aria-label=\"Select files\" translate=\"MEDIA.SELECT_FILES\">\n</md-button></div></div><div class=\"image-uploading\" ng-if=\"vm.file && !vm.facesFound\"><div class=\"loading-container\" \nng-if=\"vm.uploading || vm.recognizing\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular><div \nclass=\"loading-text\" ng-if=\"vm.uploading\">Enviando foto...</div><div class=\"loading-text\" ng-if=\"vm.recognizing\">\nReconociendo caras...</div></div><img ngf-thumbnail=\"vm.file\" class=\"upload-preview\" \nng-class=\"{\'blur\': vm.uploading || vm.recognizing}\"></div><div class=\"error-container\" \nng-if=\"vm.error && !vm.facesFound\"><md-icon md-font-icon=\"icon-alert-circle\" class=\"error-icon\"></md-icon><div \nclass=\"error-text\">{{vm.error}}</div><md-button class=\"md-raised\" ng-click=\"vm.reset()\">Reintentar</md-button></div>\n</div></div><div ng-if=\"vm.noResults && !vm.searching\" class=\"error-container\"><md-icon \nmd-font-icon=\"icon-alert-circle\" class=\"error-icon\"></md-icon><div class=\"error-text\">\nNo se han encontrado coincidencias.</div><md-button class=\"md-raised\" ng-click=\"vm.reset()\">Subir otra foto</md-button>\n</div><div ng-if=\"vm.facesFound && !vm.searching && !vm.noResults\" class=\"faces-selection-section\"><div \nclass=\"faces-selection-container\"><h3 class=\"selection-title\">\nSe han encontrado {{vm.facesFound.length}} personas. Selecciona la correcta:</h3><div class=\"faces-canvas-container\">\n<canvas id=\"facesCanvas\" class=\"faces-canvas\" ng-click=\"vm.handleCanvasClick($event)\"></canvas></div><div \nclass=\"faces-info\"><p class=\"info-text\">Haz click en la cara que deseas buscar</p></div><md-button class=\"md-warn\" \nng-click=\"vm.reset()\">Subir otra foto</md-button></div></div><div ng-if=\"vm.searching\" class=\"searching-section\"><div \nclass=\"searching-container\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular><div \nclass=\"loading-text\">Buscando fotos similares...</div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/runtag/event/dialogs/media/show-json.html","<div layout=\"row\"><md-button class=\"close-button md-icon-button\" ng-click=\"vm.openJSON()\" aria-label=\"Close dialog\" \ntranlate translate-aria-label=\"CONTENT.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n<div id=\"json-container\"><qiu-json-tree value=\"vm.imageToShow\"></qiu-json-tree></div>");
$templateCache.put("app/main/apps/runtag/event/dialogs/reprocess/reprocess-modal.html","<md-dialog aria-label=\"Add Event\" layout=\"column\" \nclass=\"reprocess-dialog max-w-full overflow-hidden sm:h-[40vh] sm:w-[55vw]\"><md-toolbar><div \nclass=\"md-toolbar-tools px-20\"><h2 translate=\"RUNTAG.REPROCESS_PHOTOS\">Reprocess Photos</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog(false)\" aria-label=\"Close\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"flex-1 overflow-auto\"><div\n class=\"h-full\"><span class=\"pre-line\" ng-if=\"vm.status === \'repeated\'\" translate=\"RUNTAG.REPROCESS_REPEATED_MESSAGE\">\n</span> <span class=\"pre-line\" ng-if=\"vm.status === \'unknown_failure\'\" \ntranslate=\"RUNTAG.REPROCESS_UNKNOWN_FAILURE_MESSAGE\"></span></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"end center\"><md-button ng-click=\"vm.closeDialog(false)\" translate=\"RUNTAG.CANCEL\">Cancelar</md-button>\n<md-button class=\"md-primary\" ng-click=\"vm.closeDialog(true)\" translate=\"RUNTAG.PROCESS_NOW\">Aceptar</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/runtag/event/dialogs/shopping/add-transaction.html","<md-dialog id=\"edit-gallery-dialog\" class=\"small compose-dialog tx-dialog\" aria-label=\"Edit Gallery\"><form \nclass=\"md-inline-form\" name=\"vm.basicForm\"><div class=\"tx-dialog__head\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"tx-dialog__title\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"tx-dialog__dot\"></span><div layout=\"column\"><span class=\"tx-dialog__heading\"><span ng-if=\"!vm.order\" \ntranslate=\"RUNTAG.ORDER_NEW\">Nueva compra</span> <span ng-if=\"vm.order\"><span translate=\"RUNTAG.ORDER_EDIT_TITLE\">\nEditar compra</span> #{{vm.order.id || vm.order.id_orders}} </span></span><span class=\"tx-dialog__sub\">\n{{vm.user.firstname + \" \" + vm.user.lastname}}</span></div></div><button type=\"button\" class=\"tx-dialog__close\" \nng-click=\"vm.cancelAddTransaction()\" title=\"{{ \'CONTENT.CLOSE\' | translate }}\" \naria-label=\"{{ \'CONTENT.CLOSE\' | translate }}\"><span class=\"material-symbols-outlined\">close</span></button></div>\n<md-dialog-content ng-if=\"!vm.order && !vm.cartEnabled\" ms-scroll><div class=\"ph-0 json-editor\"><div layout=\"column\">\n<md-input-container><label>Seleccione producto:</label><md-select placeholder=\"Select product\" ng-model=\"vm.product\">\n<md-option ng-value=\"product\" ng-repeat=\"product in vm.products\" ng-if=\"product.onoff == 1\" \nng-bind-html=\"product.product\"></md-option></md-select></md-input-container><md-input-container><label>Estado:</label>\n<md-select name=\"status\" ng-model=\"vm.selectedSubsec\"><md-option value=\"1\" translate=\"USERS.GENERATED\">GENERATED\n</md-option><md-option value=\"2\" translate=\"USERS.PAID\">PAID</md-option><md-option value=\"5\">PENDING</md-option>\n<md-option value=\"3\" translate=\"USERS.REJECTED\">REJECTED</md-option><md-option value=\"4\" translate=\"USERS.CANCELED\">\nCANCELED</md-option></md-select></md-input-container></div></div></md-dialog-content><md-dialog-content \nng-if=\"vm.cartEnabled\" ms-scroll><div class=\"ph-0 json-editor cart-purchase\"><div layout=\"column\"><md-input-container>\n<label>Producto (precio/moneda):</label><md-select placeholder=\"Seleccione producto\" ng-model=\"vm.product\" \nng-change=\"vm.onCartProductChange()\"><md-option ng-value=\"product\" ng-repeat=\"product in vm.products\" \nng-if=\"product.onoff == 1\" ng-bind-html=\"product.product\"></md-option></md-select></md-input-container><md-checkbox \nng-model=\"vm.cartUnassigned\" class=\"cart-unassigned-check\">No asignar a un perfil (compra suelta — se asigna después)\n</md-checkbox><div ng-if=\"vm.cartUnassigned\" class=\"font-size-12 grey-500-fg cart-unassigned-hint\">La compra queda \n<strong>sin asignar</strong>\n (como una preventa de todas las fotos): el corredor podrá asignarla a un perfil desde la web, o el admin desde aquí.\n</div><md-input-container ng-if=\"!vm.cartUnassigned\"><label>Perfil del usuario:</label><md-select \nplaceholder=\"Seleccione perfil\" ng-model=\"vm.cartProfile\" ng-change=\"vm.onCartProfileChange()\"><md-option \nng-value=\"prof\" ng-repeat=\"prof in vm.cartProfiles\">{{prof.label}}<span ng-if=\"prof.dorsalNumber\">\n · Dorsal {{prof.dorsalNumber}}</span></md-option></md-select></md-input-container><div \nng-if=\"!vm.cartUnassigned && vm.cartProfile\" layout=\"column\" class=\"cart-mode\"><label>¿Qué se compra?</label>\n<md-radio-group ng-model=\"vm.cartMode\" ng-change=\"vm.onCartModeChange()\"><md-radio-button value=\"all\">\nTodas las fotos del perfil</md-radio-button><md-radio-button value=\"photos\">Fotos concretas</md-radio-button>\n</md-radio-group></div><div ng-if=\"!vm.cartUnassigned && vm.cartProfile && vm.cartMode === \'photos\'\" layout=\"column\" \nclass=\"cart-photos-block\"><div ng-if=\"vm.cartPhotosLoading\" class=\"cart-photos-loading\"><md-progress-circular \nmd-diameter=\"24\"></md-progress-circular><span class=\"font-size-13\">Cargando fotos…</span></div><div \nng-if=\"!vm.cartPhotosLoading && vm.cartPhotos.length === 0\" class=\"font-size-13 grey-500-fg\">\nEste perfil no tiene fotos.</div><div ng-if=\"!vm.cartPhotosLoading && vm.cartPhotos.length\" \nclass=\"font-size-13 grey-500-fg cart-photos-count\">{{vm.cartSelectedCount()}} de {{vm.cartPhotos.length}} seleccionadas\n</div><div class=\"cart-photos-grid\" layout=\"row\" layout-wrap><div ng-repeat=\"p in vm.cartPhotos\" class=\"cart-photo\" \nng-class=\"{\'selected\': p.selected}\" ng-click=\"vm.toggleCartPhoto(p)\" role=\"button\"><img ng-if=\"p.thumb\" \nng-src=\"{{p.thumb}}\" alt=\"foto\"><div ng-if=\"!p.thumb\" class=\"cart-photo-empty\"><md-icon class=\"material-icons\">image\n</md-icon></div><md-icon ng-if=\"p.selected\" class=\"material-icons cart-photo-check\">check_circle</md-icon></div></div>\n</div><md-input-container><label>Estado:</label><md-select name=\"status\" ng-model=\"vm.selectedSubsec\"><md-option \nvalue=\"1\" translate=\"USERS.GENERATED\">GENERATED</md-option><md-option value=\"2\" translate=\"USERS.PAID\">PAID</md-option>\n<md-option value=\"5\">PENDING</md-option><md-option value=\"3\" translate=\"USERS.REJECTED\">REJECTED</md-option><md-option \nvalue=\"4\" translate=\"USERS.CANCELED\">CANCELED</md-option></md-select></md-input-container><md-input-container><label>\nPrecio ({{vm.product.currency_code}}):</label><input name=\"cartPrice\" type=\"number\" min=\"0\" ng-model=\"vm.cartPrice\" \nng-disabled=\"!vm.product\"></md-input-container><span class=\"font-size-12 grey-500-fg\">Solo las compras en estado \n<strong>PAGADO</strong> habilitan la descarga y hacen visible el perfil.</span></div></div></md-dialog-content>\n<md-dialog-content ng-if=\"vm.order && !vm.cartEnabled\" ms-scroll><div class=\"ph-0 json-editor shops-edit-container\">\n<div layout=\"column\"><div><label for=\"status\">Estado</label><md-select name=\"status\" ng-model=\"vm.order.id_subsec\" \nclass=\"md-no-underline\"><md-option value=\"1\" translate=\"USERS.GENERATED\">GENERATED</md-option><md-option value=\"2\" \ntranslate=\"USERS.PAID\">PAID</md-option><md-option value=\"5\">PENDING</md-option><md-option value=\"3\" \ntranslate=\"USERS.REJECTED\">REJECTED</md-option><md-option value=\"4\" translate=\"USERS.CANCELED\">CANCELED</md-option>\n</md-select></div><div><label for=\"paymentMethods\">Método de pago</label><md-select name=\"paymentMethods\" \nng-model=\"vm.order.id_payment_method\" class=\"md-no-underline\"><md-option ng-repeat=\"method in vm.paymentMethods\" \nvalue=\"{{method.id}}\">{{method.name}}</md-option></md-select></div><div ng-if=\"vm.isAdmin\" layout=\"column\"><label \nfor=\"price\">Precio</label><input name=\"price\" type=\"number\" min=\"0\" ng-model=\"vm.order.price\"></div></div></div>\n</md-dialog-content><md-dialog-actions ng-switch=\"vm.selectedView\"><div ng-switch-default layout=\"row\" flex \nlayout-align=\"flex-end center\"><div layout=\"row\" layout-align=\"end center\" class=\"tx-dialog__actions\"><button \ntype=\"button\" class=\"tx-btn tx-btn--ghost\" ng-click=\"vm.cancelAddTransaction()\" translate=\"CONTENT.CANCEL\">Cancelar\n</button> <button type=\"button\" class=\"tx-btn tx-btn--primary\" ng-click=\"vm.saveAddTransaction()\" \nng-disabled=\"vm.cartEnabled ? !vm.cartCanSave() : (vm.order ? false : !vm.product)\" translate=\"CONTENT.SAVE\">Guardar\n</button></div></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/runtag/organizer/views/templates/organizer-template.html","<div id=\"ro-full-container\" class=\"pb-50\"><header id=\"ro-full-header\" class=\"mt-50 mb-50\"><md-input-container \nclass=\"select-event\"><md-select placeholder=\"{{\'RUNTAG.SELECT_AN_EVENT\' | translate}}\" ng-model=\"vm.selectedEvent\" \nng-change=\"vm.reFilter()\"><md-select-header class=\"ro-select-header\" layout=\"row\"><span \nclass=\"material-symbols-outlined\">search </span><input ng-model=\"vm.eventSearch\" type=\"search\" \nonkeydown=\"event.stopPropagation()\" class=\"md-text\" aria-label=\"search event\"></md-select-header><md-option \nng-value=\"event\" ng-repeat=\"event in vm.filteredEvents | filter:vm.eventSearch track by $index\" \nng-bind-html=\"event.event_name\"></md-option></md-select><span ng-if=\"vm.selectedEvent\" \nng-click=\"vm.reFilter(\'selectedEvent\')\" class=\"material-symbols-outlined cancel\">cancel</span></md-input-container>\n</header><div class=\"mb-50\" ng-if=\"vm.selectedEvent && vm.loadingTotals\" layout=\"row\" layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"30\"></md-progress-circular></div><div \nng-if=\"vm.selectedEvent && !vm.loadingTotals\" class=\"graphs-container gap-20 mb-50\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"column\" class=\"graph-card runners\"><div class=\"icon\"><span \nclass=\"material-symbols-outlined\">directions_run</span></div><div class=\"text\"><span translate=\"RUNTAG.RUNNERS\" \nclass=\"title text-uppercase\">RUNNERS</span></div><div class=\"empty\"></div><div class=\"empty\"></div><div class=\"count\">\n<span ng-if=\"!vm.isLoadingTotalRunners\">{{vm.totalRunners | number:0}}</span></div><div class=\"empty\"></div><div \nclass=\"icon\"><span class=\"material-symbols-outlined\">login</span></div><div class=\"text\"><span \ntranslate=\"RUNTAG.ACCESS\" class=\"title text-uppercase\">ACCESS</span></div><div class=\"empty\"></div><div class=\"empty\">\n</div><div class=\"count\"><span ng-if=\"!vm.isLoadingTotalAccess\">{{vm.totalAccess | number:0}}</span></div></div><div \nlayout=\"column\" class=\"graph-card photos\"><div class=\"icon\"><span class=\"material-symbols-outlined\">photo_camera</span>\n</div><div class=\"text\"><span translate=\"RUNTAG.PHOTOS\" class=\"title text-uppercase\">PHOTOS</span></div><div \nclass=\"empty\"></div><div class=\"empty\"></div><div class=\"count\"><span ng-if=\"!vm.isLoadingTotalPhotos\">\n{{vm.totalPhotos | number:0}}</span></div><div class=\"empty\"></div><div class=\"icon\"><span \nclass=\"material-symbols-outlined\">humidity_percentage</span></div><div class=\"text\"><span \ntranslate=\"RUNTAG.AVERAGE_PHOTOS\" class=\"title text-uppercase\">AVERAGE PHOTOS</span></div><div class=\"text\"><span \ntranslate=\"RUNTAG.RECOGNIZED_PHOTOS\" class=\"title text-uppercase\">RECOGNIZED PHOTOS</span></div><div class=\"empty\">\n</div><div class=\"count\"><span ng-if=\"!vm.isLoadingAveragePhotos\">{{vm.averagePhotos | number:0}}</span></div><div \nclass=\"count\"><span ng-if=\"!vm.isLoadingRecognizedPhotos\">{{vm.recognizedPhotos | number:0}}</span></div></div><div \nlayout=\"column\" class=\"graph-card orders\"><div class=\"icon\"><span class=\"material-symbols-outlined\">shopping_bag</span>\n</div><div class=\"text\"><span translate=\"RUNTAG.ORDERS\" class=\"title text-uppercase\">ORDERS</span></div><div \nclass=\"empty\"></div><div class=\"empty\"></div><div class=\"count\"><span ng-if=\"!vm.isLoadingTotalOrders\">\n{{vm.totals.orders.total | number:0}}</span></div><div class=\"empty\"></div><div class=\"icon\"><span \nclass=\"material-symbols-outlined\">monetization_on</span></div><div class=\"text\"><span class=\"title\">\n{{vm.selectedEvent.local_currency}}</span></div><div class=\"text\"><span \nng-if=\"vm.selectedEvent.international_currency\" class=\"title\">{{vm.selectedEvent.international_currency}}</span></div>\n<div class=\"empty\"></div><div class=\"count\"><span>{{vm.createPaymentsTotals(false, vm.selectedEvent.local_currency)}}\n</span></div><div ng-if=\"vm.selectedEvent.international_currency\" class=\"count\"><span>\n{{vm.createPaymentsTotals(false, vm.selectedEvent.international_currency)}}</span></div></div></div><div \nclass=\"mb-50 re-table\"><table><tbody><tr class=\"table-title-head sales\"><td class=\"table-icon center btlr\"><span \nclass=\"material-symbols-outlined\">shopping_bag</span></td><td class=\"btrr\" colspan=\"7\"><span \nclass=\"bold text-uppercase\" translate=\"RUNTAG.SALES\">SALES</span></td></tr><tr class=\"table-info-header\"><td></td><td \nclass=\"bold text-uppercase\" translate=\"RUNTAG.EVENT\">EVENT</td><td ng-if=\"!vm.showCommissions\"></td><td \nclass=\"bold text-uppercase center\" translate=\"RUNTAG.ORDERS\">ORDERS</td><td class=\"bold text-uppercase center\" \ntranslate=\"RUNTAG.LOCAL_SALES\">LOCAL_SALES</td><td class=\"bold text-uppercase center\" \ntranslate=\"RUNTAG.INTERNATIONAL_SALES\">INTERNATIONAL_SALES</td><td class=\"bold text-uppercase center\" \ntranslate=\"RUNTAG.TOTAL_SALES\">TOTAL_SALES</td><td ng-if=\"vm.showCommissions\" class=\"bold center\">%</td><td \nng-if=\"vm.showCommissions\" class=\"bold text-uppercase center\" translate=\"RUNTAG.ORGANIZER\">ORGANIZER</td><td \nng-if=\"!vm.showCommissions\"></td></tr><tr class=\"table-items-body\" \nng-if=\"vm.getLengthOfObject(vm.paymentPeriods) === 0 && !vm.loadingPayments\"><td colspan=\"8\" \nclass=\"center bold font-size-20\" translate=\"RUNTAG.NOT_PAYMENTS_BREAKDOWN\">TEHERE ARE NOT PAYMENT BREAKDOWNS</td></tr>\n<tr class=\"table-items-body\" ng-repeat=\"item in vm.tableArray\" ng-class=\"{\'grouped\': item.type === \'key\'}\"><td \nng-if=\"item.type === \'key\'\"></td><td ng-if=\"item.type === \'key\' && vm.showCommissions\" colspan=\"7\"><span class=\"bold\" \nng-if=\"vm.paymentSelectedOrder === \'date\'\">{{ item.value.split(\'-\')[0] }} al {{ item.value.split(\'-\')[1] }} </span>\n<span class=\"bold\" ng-if=\"vm.paymentSelectedOrder === \'event\'\" ng-bind-html=\"item.value\"></span> <span class=\"bold\" \nng-if=\"vm.paymentSelectedOrder === \'status\'\">{{ item.value }}</span></td><td \nng-if=\"item.type === \'key\' && !vm.showCommissions\" colspan=\"5\"><span class=\"bold\" \nng-if=\"vm.paymentSelectedOrder === \'date\'\">{{ item.value.split(\'-\')[0] }} al {{ item.value.split(\'-\')[1] }} </span>\n<span class=\"bold\" ng-if=\"vm.paymentSelectedOrder === \'event\'\" ng-bind-html=\"item.value\"></span> <span class=\"bold\" \nng-if=\"vm.paymentSelectedOrder === \'status\'\">{{ item.value }}</span></td><td class=\"center\" \nng-if=\"item.type === \'object\'\"><div ng-if=\"item.value.id_subsec != 1\" \nclass=\"pay-check {{vm.checkPays(item.value, \'payment_date\')}}\"></div><span ng-if=\"item.value.id_subsec === 1\" \nclass=\"material-symbols-outlined payment-open\">directions_run</span></td><td ng-if=\"item.type === \'object\'\"><span \nclass=\"bold\">{{vm.searchEventName(item.value.id_event)}} ({{item.value.id_event}})</span><br><span>\n{{vm.searchClientName(item.value.id_client)}} <span ng-if=\"vm.paymentSelectedOrder != \'date\'\">\n/ {{vm.formatDate(item.value.date_from, \'dd MMM yyyy\')}} al {{vm.formatDate(item.value.date_to, \'dd MMM yyyy\')}}</span>\n</span></td><td ng-if=\"!vm.showCommissions\"></td><td ng-if=\"item.type === \'object\'\" class=\"center\">\n{{item.value.orders}}</td><td ng-if=\"item.type === \'object\'\" class=\"center\">\n{{item.value.sales_local | number:2}} {{item.value.currency_local}}</td><td ng-if=\"item.type === \'object\'\" \nclass=\"center\">{{item.value.sales_international | number:2}} USD</td><td ng-if=\"item.type === \'object\'\" class=\"center\">\n{{item.value.total_sales_usd | number:2}} USD</td><td ng-if=\"item.type === \'object\' && vm.showCommissions\" \nclass=\"center\">{{item.value.organizer_commision_percentage}}%</td><td \nng-if=\"item.type === \'object\' && vm.showCommissions\" ng-class=\"{\'cursor-pointer\': vm.calcPayment(item.value)}\" \nclass=\"center span-with-overlay\">{{item.value.organizer_commision_payment_due_usd | number:2}} USD <span \nclass=\"overlay p-5\" ng-if=\"vm.calcPayment(item.value)\">\nPhotos: {{item.value.total_photos}} * {{item.value.prices_per_photo_usd}} + Fee: {{item.value.prices_fee_usd}} = {{item.value.payment_due_usd}}\n</span></td><td ng-if=\"!vm.showCommissions\"></td></tr><tr class=\"table-items-footer\" ng-if=\"vm.morePayments\"><td \nng-if=\"vm.loadingPayments\" colspan=\"8\"><div layout=\"row\" layout-align=\"center center\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"30\"></md-progress-circular></div></td><td class=\"cursor-pointer center\" \nng-click=\"vm.getPaymentBreakdown()\" ng-if=\"vm.getLengthOfObject(vm.paymentPeriods) != 0 && !vm.loadingPayments\" \ncolspan=\"8\"><div layout=\"row\" layout-align=\"center center\" class=\"re-load-more font-size-15 bold\"><span \nclass=\"material-symbols-outlined\">expand_circle_down </span><span class=\"text-uppercase\" translate=\"RUNTAG.LOAD_MORE\">\nLOAD MORE</span></div></td></tr><tr class=\"table-items-footer\"><td class=\"bblr\"></td><td class=\"bold text-uppercase\" \ntranslate=\"RUNTAG.TOTAL\">TOTAL</td><td ng-if=\"!vm.showCommissions\"></td><td></td><td class=\"bold center\">\n{{vm.totals.payment_breakdown.sales_local.sum | number:2}} {{vm.totals.payment_breakdown.sales_local.currency_local}}\n</td><td class=\"bold center\">{{vm.totals.payment_breakdown.sales_international | number:2}} USD</td><td \nclass=\"bold center\">{{vm.totals.payment_breakdown.total_sales_usd | number:2}} USD</td><td ng-if=\"vm.showCommissions\">\n</td><td ng-if=\"vm.showCommissions\" class=\"bold center bbrr\">\n{{vm.totals.payment_breakdown.organizer_commision_payment_due_usd | number:2}} USD</td><td ng-if=\"!vm.showCommissions\" \nclass=\"bbrr\"></td></tr><tr class=\"table-divider\"></tr><tr class=\"table-title-head orders\"><td \nclass=\"table-icon center btlr\"><span class=\"material-symbols-outlined\">shopping_bag</span></td><td class=\"btrr\" \ncolspan=\"7\"><span class=\"bold text-uppercase\" translate=\"RUNTAG.ORDERS\">ORDERS</span></td></tr><tr \nclass=\"table-info-header\"><td></td><td class=\"text-uppercase bold\" translate=\"RUNTAG.USER\" colspan=\"2\">USER</td><td \nclass=\"text-uppercase bold center\" translate=\"RUNTAG.DATE\">DATE</td><td class=\"text-uppercase bold\" \ntranslate=\"RUNTAG.EVENT\">EVENT</td><td class=\"text-uppercase bold center\" translate=\"RUNTAG.PHOTOS\">PHOTOS</td><td \nclass=\"text-uppercase bold center\" translate=\"RUNTAG.PAYMENTS\">PAYMENTS</td><td class=\"text-uppercase bold center\" \ntranslate=\"RUNTAG.USD_CONVERSION\">USD_CONVERSION</td></tr><tr class=\"table-items-body\" \nng-if=\"vm.orders.length === 0 && !vm.loadingOrders\"><td colspan=\"8\" translate=\"RUNTAG.NOT_ORDERS\">THERE ARE NOT ORDERS\n</td></tr><tr class=\"table-items-body\" ng-repeat=\"order in vm.orders\"><td></td><td colspan=\"2\"><div layout=\"column\">\n<span class=\"bold\">{{order.user_name}}</span> <span>{{order.user_email}}</span></div></td><td class=\"center\">\n{{vm.formatDate(order.created_at, \'dd MMM HH:mm\')}}</td><td ng-bind-html=\"vm.searchEventName(order.id_event)\"></td><td \nclass=\"center\"><span ng-if=\"order.items_total\">{{order.items_total}}</span> <span ng-if=\"!order.items_total\">All</span>\n</td><td class=\"center\">{{order.price | number:2}} {{order.currency_code}}</td><td class=\"center\"><span \nng-if=\"order.usd\">{{order.usd | number:2}} USD</span> <span ng-if=\"!order.usd\" translate=\"RUNTAG.NOT_AVALIABLE_YET\">\nNot avaliable yet</span></td></tr><tr class=\"table-items-footer\" ng-if=\"vm.moreOrders\"><td ng-if=\"vm.loadingOrders\" \ncolspan=\"8\"><div layout=\"row\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"30\"></md-progress-circular></div></td><td ng-if=\"vm.loadingOrders\" colspan=\"8\"><div layout=\"row\" \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"30\"></md-progress-circular>\n</div></td><td class=\"cursor-pointer center\" ng-click=\"vm.getOrders()\" ng-if=\"vm.moreOrders && !vm.loadingOrders\" \ncolspan=\"8\"><div layout=\"row\" layout-align=\"center center\" class=\"re-load-more font-size-15 bold\"><span \nclass=\"material-symbols-outlined\">expand_circle_down </span><span class=\"text-uppercase\" translate=\"RUNTAG.LOAD_MORE\">\nLOAD MORE</span></div></td></tr><tr class=\"table-items-footer\"><td class=\"bblr\"></td><td colspan=\"3\" \nclass=\"bold left text-uppercase\" translate=\"RUNTAG.TOTAL\">TOTAL</td><td class=\"bold left\">{{vm.totals.orders.total}}\n</td><td></td><td class=\"bold center\">{{vm.createPaymentsTotals(true)}}</td><td class=\"bold center bbrr\">\n{{vm.totals.orders.usd | number:2}} USD</td></tr></tbody></table></div></div>");
$templateCache.put("app/main/apps/runtag/sales/views/templates/sales-template-v2.html","<div id=\"rs-full-container\" class=\"pb-50 sales-v2\"><div ng-if=\"!vm.yearsLoaded\" class=\"loading-years-container mt-10\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"30\"></md-progress-circular></div><div \nng-if=\"vm.yearsLoaded\" class=\"calendar-selector mt-20\"><button ng-click=\"vm.toggleCalendar()\" class=\"calendar-button\">\n<span class=\"material-symbols-outlined\">calendar_month </span><span>\n{{ (\'RUNTAG.MONTHS.\' + vm.selectedMonth.name) | translate }}</span></button><div class=\"calendar-dropdown\" \nng-show=\"vm.calendarOpen\"><div class=\"year-selector\"><label translate=\"RUNTAG.SELECT_YEAR\"></label><ul><li \nng-repeat=\"year in vm.years | keys\" ng-class=\"{\'selected\': vm.selectedYear == year}\" ng-click=\"vm.selectYear(year)\">\n{{ year }}</li></ul></div><div class=\"month-selector\"><label translate=\"RUNTAG.SELECT_MONTH\"></label><ul><li \nng-repeat=\"month in vm.years[vm.selectedYear]\" \nng-class=\"{\'disabled\': month.disabled, \'selected\': vm.selectedMonth === month}\" \nng-click=\"!month.disabled && vm.selectMonth(month)\">{{ \'RUNTAG.MONTHS.\' + month.name | translate }}</li></ul></div>\n</div></div><header ng-if=\"vm.yearsLoaded\" id=\"rs-full-header\" class=\"mt-10 mb-10\"><md-input-container><md-select \nplaceholder=\"{{\'RUNTAG.SELECT_CLIENT\' | translate}}\" ng-model=\"vm.selectedClient\" \nng-change=\"vm.filterClientsAndEvents()\"><md-select-header class=\"rs-select-header\" layout=\"row\"><span \nclass=\"material-symbols-outlined\">search </span><input ng-model=\"vm.clientSearch\" type=\"search\" \nonkeydown=\"event.stopPropagation()\" class=\"md-text\" aria-label=\"search client\"></md-select-header><md-option \nng-value=\"client.id_clients\" ng-repeat=\"client in vm.filteredClients | filter:vm.clientSearch\" \nng-bind-html=\"client.client_name\"></md-option></md-select><span ng-if=\"vm.selectedClient\" \nng-click=\"vm.filterClientsAndEvents(\'selectedClient\')\" class=\"material-symbols-outlined cancel\">cancel</span>\n</md-input-container><div class=\"empty\"></div><md-input-container><md-select \nplaceholder=\"{{\'RUNTAG.SELECT_AN_EVENT\' | translate}}\" ng-model=\"vm.selectedEvent\" \nng-change=\"vm.filterClientsAndEvents()\"><md-select-header class=\"rs-select-header\" layout=\"row\"><span \nclass=\"material-symbols-outlined\">search </span><input ng-model=\"vm.eventSearch\" type=\"search\" \nonkeydown=\"event.stopPropagation()\" class=\"md-text\" aria-label=\"search event\"></md-select-header><md-option \nng-value=\"event.id_events\" ng-repeat=\"event in vm.filteredEvents | filter:vm.eventSearch track by $index\" \nng-bind-html=\"event.event_name\"></md-option></md-select><span ng-if=\"vm.selectedEvent\" \nng-click=\"vm.filterClientsAndEvents(\'selectedEvent\')\" class=\"material-symbols-outlined cancel\">cancel</span>\n</md-input-container></header><div class=\"graphs-container gap-20 mb-50 mt-20\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"column\" class=\"graph-card orders\"><div class=\"left\"><div \nclass=\"title-container\"><span class=\"material-symbols-outlined icon\">shopping_bag </span><span \ntranslate=\"RUNTAG.SALES\" class=\"title text-uppercase\">SALES </span><span>(USD)</span></div><div \nclass=\"content-container\"><span class=\"text-xl\">\n{{vm.salesPerCurrency? vm.salesPerCurrency.total.amount : 0 | number:2}}</span><md-progress-circular \nng-show=\"vm.loadingOrders\" md-mode=\"indeterminate\" md-diameter=\"30\"></md-progress-circular></div></div><div \nclass=\"right\"><div class=\"title-container\"><span class=\"material-symbols-outlined icon\">monetization_on </span><span \ntranslate=\"RUNTAG.SALES_PER_CURRENCY\" class=\"title text-uppercase\">SALES PER CURRENCY</span></div><div \nclass=\"content-container\"><div ng-if=\"vm.salesPerCurrency\" class=\"currencies-container\"><div class=\"currency\" \nng-repeat=\"currency in vm.salesPerCurrency.currencies\"><span class=\"code\">{{currency.currency_code}} </span><span \nclass=\"amount\">{{currency.amount | number:2}}</span></div></div></div></div></div><div layout=\"column\" \nclass=\"graph-card fees\"><div class=\"left\"><div class=\"title-container\"><span class=\"material-symbols-outlined icon\">\ndirections_run </span><span translate=\"RUNTAG.FEE_IN_USD\" class=\"title text-uppercase\">RUNTAG FEE IN USD</span></div>\n<div ng-if=\"vm.totalFee\" class=\"content-container\"><span class=\"text-xl\">{{vm.totalFee | number:2}}</span></div></div>\n<div class=\"right\"><div class=\"title-container\"><span translate=\"RUNTAG.PAYMENT\" class=\"title text-uppercase\">PAYMENT\n</span></div></div></div></div><div class=\"tables-container\"><table class=\"mb-50\" ng-if=\"vm.eventsSales.length > 0\">\n<tbody><tr class=\"table-title-head sales\"><td class=\"table-icon center\"><span class=\"material-symbols-outlined icon\">\nshopping_bag</span></td><td colspan=\"6\" class=\"left\"><span translate=\"RUNTAG.SALES_BY_EVENT\" \nclass=\"title text-uppercase\">SALES BY EVENT</span></td><td></td></tr><tr class=\"table-info-header\"><td></td><td \nclass=\"left\" translate=\"RUNTAG.EVENT\">EVENT</td><td translate=\"RUNTAG.ORDERS\">ORDERS</td><td \ntranslate=\"RUNTAG.PRESALE\">PRESALE</td><td translate=\"RUNTAG.MANUAL\">MANUAL</td><td class=\"currency\" \nng-repeat=\"currency in vm.getEventsCurrencies()\"><span translate=\"RUNTAG.CURRENCY\"></span> {{currency}}</td><td \nclass=\"currency\" translate=\"RUNTAG.CONVERSION\">CONVERSION</td><td class=\"currency\"></td></tr><tr \nng-repeat=\"event in vm.eventsSales\" class=\"table-items-body\"><td></td><td class=\"left\" ng-bind-html=\"event.event_name\">\n</td><td ng-bind-html=\"event.orders\"></td><td ng-bind-html=\"event.presale\"></td><td ng-bind-html=\"event.manual\"></td>\n<td class=\"currency right\" ng-repeat=\"currency in vm.getEventsCurrencies()\">\n{{event[\"sales_amount_\"+currency] | number:2}}<span class=\"currency-code\">{{currency}}</span></td><td \nclass=\"currency right\">{{event.sales_amount_total_usd | number:2}}<span class=\"currency-code\">USD</span></td><td \nclass=\"currency\"></td></tr><tr class=\"table-items-footer\"><td></td><td class=\"left\">TOTAL</td><td \nng-bind=\"vm.getEventsTotals(\'orders\')\"></td><td ng-bind=\"vm.getEventsTotals(\'presale\')\"></td><td \nng-bind=\"vm.getEventsTotals(\'manual\')\"></td><td class=\"right\" ng-repeat=\"currency in vm.getEventsCurrencies()\">\n{{vm.getEventsTotals(\'sales_amount_\'+currency) | number:2}}<span class=\"currency-code\">{{currency}}</span></td><td \nclass=\"right\">{{vm.getEventsTotals(\'sales_amount_total_usd\') | number:2}}<span class=\"currency-code\">USD</span></td>\n<td></td></tr></tbody></table><table ng-if=\"vm.runnerSales.length > 0\"><tbody><tr class=\"table-title-head sales\"><td \nclass=\"table-icon center\"><span class=\"material-symbols-outlined icon\">directions_run</span></td><td colspan=\"7\" \nclass=\"left\"><span translate=\"RUNTAG.SALES_BY_RUNNERS\" class=\"title text-uppercase\">SALES BY RUNNERS</span></td><td>\n</td></tr><tr class=\"table-search-header\"><td></td><td colspan=\"4\"><div class=\"search-container\"><input type=\"search\" \ntranslate translate-attr-placeholder=\"RUNTAG.SEARCH_USER_PLACEHOLDER\" ng-model=\"vm.searchUsersString\" \nng-enter=\"vm.searchUsers()\"> <button ng-if=\"vm.inUserSearch\" ng-click=\"vm.resetUserSearch()\" class=\"cancel\">X</button> \n<button class=\"search\" ng-click=\"vm.searchUsers()\" translate=\"CONTENT.SEARCH\">Search</button></div></td><td \ncolspan=\"4\"></td><td></td></tr><tr class=\"table-info-header\"><td></td><td class=\"left cursor-pointer\" \nng-click=\"vm.toggleRunnerSort(\'created_at\')\"><span translate=\"RUNTAG.DAY\">DAY</span> <span \nclass=\"material-symbols-outlined font-size-12\" ng-if=\"vm.runnerSortField === \'created_at\'\">\n{{vm.runnerSortDir === \'ASC\' ? \'arrow_upward\' : \'arrow_downward\'}}</span></td><td class=\"left\" translate=\"RUNTAG.NAME\">\nNAME</td><td class=\"left\">EMAIL</td><td class=\"left\" translate=\"RUNTAG.EVENT\">EVENT</td><td translate=\"RUNTAG.PRICE\">\nPRICE</td><td translate=\"RUNTAG.CONVERSION\">CONVERSION</td><td class=\"left\" translate=\"RUNTAG.METHOD\">METHOD</td><td>\n</td><td></td></tr><tr ng-if=\"vm.loadingOrders\"><td class=\"user-loader\" colspan=\"10\"><div><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"30\"></md-progress-circular></div></td></tr><tr ng-if=\"!vm.loadingOrders\" \nng-repeat=\"runner in vm.runnerSales\" class=\"table-items-body\"><td></td><td class=\"left\" \nng-bind-html=\"vm.formatDate(runner.created_at, \'dd MMM HH:mm\')\"></td><td class=\"left\" ng-bind-html=\"runner.user_name\">\n</td><td class=\"left\" ng-bind-html=\"runner.user_email\"></td><td class=\"left\" ng-bind-html=\"runner.event_name\"></td><td \nng-bind-html=\"runner.price\"></td><td ng-bind-html=\"runner.price_converted\"></td><td class=\"left\" \nng-bind-html=\"runner.payment_name\"></td><td class=\"cursor-pointer\" ng-click=\"vm.openModalRevision(runner)\"><span \nclass=\"material-symbols-outlined icon\" ng-class=\"{\'revision\': runner.requires_revision}\">warning</span></td><td></td>\n</tr><tr class=\"table-items-footer\"><td></td><td>{{vm.loadMoreRunners.current}} <span translate=\"RUNTAG.SALES_OF\">\nSALES OF</span> {{vm.loadMoreRunners.total}}</td><td ng-click=\"vm.getMoreRunners()\" class=\"cursor-pointer center\" \nng-if=\"vm.loadMoreRunners.total != vm.loadMoreRunners.current\" colspan=\"7\"><div layout=\"row\" \nlayout-align=\"center center\" class=\"font-size-15 bold\"><span class=\"material-symbols-outlined\">expand_circle_down \n</span><span class=\"text-uppercase\" translate=\"RUNTAG.LOAD_MORE\">LOAD MORE</span></div></td><td \nng-if=\"vm.loadMoreRunners.total == vm.loadMoreRunners.current\" colspan=\"7\"></td><td></td></tr></tbody></table></div>\n</div><div class=\"modalRevision\" ng-show=\"vm.requiredRevisionRunner\"><div class=\"modal-content\"><div class=\"toolbar\">\n<h2 translate=\"RUNTAG.ADD_NOTE\">ADD NOTE</h2><md-button class=\"md-icon-button\" ng-click=\"vm.closeModalRevision()\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div class=\"content\"><textarea \nng-model=\"vm.revisionNote\" rows=\"5\" placeholder=\"Escribe tu nota aquí...\"></textarea></div><div class=\"actions\">\n<md-button ng-if=\"vm.requiredRevisionRunner.requires_revision\" class=\"md-raised md-warn\" traslate=\"CONTENT.DELETE\" \nng-click=\"vm.closeModalRevision(true)\">DELETE</md-button><md-button class=\"md-raised md-warn\" \ntraslate=\"CONTENT.CANCEL\" ng-click=\"vm.closeModalRevision()\">CANCEL</md-button><md-button class=\"md-raised md-accent\" \ntraslate=\"CONTENT.SAVE\" ng-click=\"vm.saveModalRevision()\">SAVE</md-button></div></div></div>");
$templateCache.put("app/main/apps/runtag/sales/views/templates/sales-template.html","<div id=\"rs-full-container\" class=\"pb-50\"><header id=\"rs-full-header\" class=\"mt-50 mb-50\"><md-input-container>\n<md-select placeholder=\"{{\'RUNTAG.SELECT_CLIENT\' | translate}}\" ng-model=\"vm.selectedClient\" \nng-change=\"vm.reFilter(\'selectedEvent\')\"><md-select-header class=\"rs-select-header\" layout=\"row\"><span \nclass=\"material-symbols-outlined\">search </span><input ng-model=\"vm.clientSearch\" type=\"search\" \nonkeydown=\"event.stopPropagation()\" class=\"md-text\" aria-label=\"search client\"></md-select-header><md-option \nng-value=\"client\" ng-repeat=\"client in vm.clients | filter:vm.clientSearch\" ng-bind-html=\"client.client_name\">\n</md-option></md-select><span ng-if=\"vm.selectedClient\" ng-click=\"vm.reFilter(\'selectedClient\')\" \nclass=\"material-symbols-outlined cancel\">cancel</span></md-input-container><div class=\"empty\"></div>\n<md-input-container><md-select placeholder=\"{{\'RUNTAG.SELECT_AN_EVENT\' | translate}}\" ng-model=\"vm.selectedEvent\" \nng-change=\"vm.reFilter()\"><md-select-header class=\"rs-select-header\" layout=\"row\"><span \nclass=\"material-symbols-outlined\">search </span><input ng-model=\"vm.eventSearch\" type=\"search\" \nonkeydown=\"event.stopPropagation()\" class=\"md-text\" aria-label=\"search event\"></md-select-header><md-option \nng-value=\"event\" ng-repeat=\"event in vm.filteredEvents | filter:vm.eventSearch track by $index\" \nng-bind-html=\"event.event_name\"></md-option></md-select><span ng-if=\"vm.selectedEvent\" \nng-click=\"vm.reFilter(\'selectedEvent\')\" class=\"material-symbols-outlined cancel\">cancel</span></md-input-container><div\n layout=\"column\" id=\"new-payment-container\"><md-button ng-if=\"vm.isAdmin\" ng-click=\"vm.newPaymentBreakdown = true\" \nclass=\"md-raised md-primary\">Create new payment breakdown</md-button><div layout=\"column\" \nng-if=\"vm.newPaymentBreakdown\"><div layout=\"row\"><md-datepicker ng-model=\"vm.createdPaymentBreakdown.date_from\" \nmd-placeholder=\"Start date\" input-aria-describedby=\"datepicker-description\" input-aria-labelledby=\"datepicker-header \">\n</md-datepicker><md-datepicker ng-model=\"vm.createdPaymentBreakdown.date_to\" md-placeholder=\"End date\" \ninput-aria-describedby=\"datepicker-description\" input-aria-labelledby=\"datepicker-header \"></md-datepicker></div><div>\n<md-checkbox md-no-ink aria-label=\"Checkbox No Ink\" ng-model=\"vm.createdPaymentBreakdown.first_settlement\" \nclass=\"md-primary\">First settlement</md-checkbox></div><div><md-select \nplaceholder=\"{{\'RUNTAG.SELECT_CLIENT\' | translate}}\" ng-model=\"vm.createdPaymentBreakdown.id_client\" \nng-change=\"vm.filterCreatePaymentBreakdown()\"><md-select-header class=\"rs-select-header\" layout=\"row\"><span \nclass=\"material-symbols-outlined\">search </span><input ng-model=\"vm.paymentClient\" type=\"search\" \nonkeydown=\"event.stopPropagation()\" class=\"md-text\" aria-label=\"search client\"></md-select-header><md-option \nng-value=\"client.id_clients\" ng-repeat=\"client in vm.clients | filter:vm.paymentClient\" \nng-bind-html=\"client.client_name\"></md-option></md-select><md-select \nplaceholder=\"{{\'RUNTAG.SELECT_AN_EVENT\' | translate}}\" ng-model=\"vm.createdPaymentBreakdown.id_event\"><md-select-header\n class=\"rs-select-header\" layout=\"row\"><span class=\"material-symbols-outlined\">search </span><input \nng-model=\"vm.paymentEvent\" type=\"search\" onkeydown=\"event.stopPropagation()\" class=\"md-text\" \naria-label=\"search client\"></md-select-header><md-option ng-value=\"event.id_events\" \nng-repeat=\"event in vm.filteredPaymentEvents | filter:vm.paymentEvent track by $index\" ng-bind-html=\"event.event_name\">\n</md-option></md-select></div><div layout=\"row\" layout-align=\"end center\"><md-button \nng-click=\"vm.saveCreatedPaymentBreakdown()\" class=\"md-raised md-primary\">Create</md-button><md-button \nng-click=\"vm.resetCreatedPaymentBreakdown()\" class=\"md-raised md-warn\">Cancel</md-button></div></div></div></header>\n<div class=\"mb-50 re-table\"><table><tbody><tr class=\"table-title-head sales\"><td class=\"table-icon center btlr\"><span \nclass=\"material-symbols-outlined\">shopping_bag</span></td><td colspan=\"4\"><span class=\"bold text-uppercase\" \ntranslate=\"RUNTAG.SALES\">SALES</span></td><td><md-input-container><label translate=\"RUNTAG.PAID_LABEL\">PAID_LABEL\n</label><md-select ng-model=\"vm.paymentSelectedPaid\" ng-change=\"vm.getPaymentBreakdown(true)\"><md-option \ntranslate=\"RUNTAG.PAID\" value=\"1\">Paid</md-option><md-option translate=\"RUNTAG.NOT_PAID\" value=\"0\">Not paid</md-option>\n</md-select></md-input-container></td><td><md-input-container><label translate=\"RUNTAG.ORDER\">Order</label><md-select \nng-model=\"vm.paymentSelectedOrder\" ng-change=\"vm.updatePaymentsPeriods(vm.payments)\"><md-option \ntranslate=\"RUNTAG.DATE\" value=\"date\">Date</md-option><md-option translate=\"RUNTAG.EVENT\" value=\"event\">Event\n</md-option><md-option translate=\"RUNTAG.STATUS\" value=\"status\">Status</md-option></md-select></md-input-container>\n</td><td class=\"btrr\"><md-input-container><label translate=\"RUNTAG.STATUS\">Status</label><md-select \nng-model=\"vm.paymentSelectedStatus\" ng-change=\"vm.getPaymentBreakdown(true)\"><md-option translate=\"RUNTAG.VIEW_ALL\" \nng-value=\"0\">All</md-option><md-option ng-value=\"status.id_subsec\" \nng-repeat=\"status in vm.sectionOptions.payments_breakdown.subsection\">{{status.subsec}}</md-option></md-select>\n</md-input-container></td></tr><tr class=\"table-info-header\"><td></td><td class=\"bold text-uppercase\" \ntranslate=\"RUNTAG.EVENT\">EVENT</td><td class=\"bold text-uppercase center\" translate=\"RUNTAG.ORDERS\">ORDERS</td><td \nclass=\"bold text-uppercase center\" translate=\"RUNTAG.LOCAL_SALES\">LOCAL_SALES</td><td \nclass=\"bold text-uppercase center\" translate=\"RUNTAG.INTERNATIONAL_SALES\">INTERNATIONAL_SALES</td><td \nclass=\"bold text-uppercase center\" translate=\"RUNTAG.TOTAL_SALES\">TOTAL_SALES</td><td class=\"bold center\">%</td><td \nclass=\"bold text-uppercase center\" translate=\"RUNTAG.PAYMENT_TO_RUNTAG\">PAYMENT_TO_RUNTAG</td></tr><tr \nclass=\"table-items-body\" ng-if=\"vm.getLengthOfObject(vm.paymentPeriods) === 0 && !vm.loadingPayments\"><td colspan=\"8\" \nclass=\"center bold font-size-20\" translate=\"RUNTAG.NOT_PAYMENTS_BREAKDOWN\">TEHERE ARE NOT PAYMENT BREAKDOWNS</td></tr>\n<tr class=\"table-items-body\" ng-repeat=\"item in vm.tableArray\" ng-class=\"{\'grouped\': item.type === \'key\'}\"><td \nng-if=\"item.type === \'key\'\"></td><td ng-if=\"item.type === \'key\'\" colspan=\"7\"><span class=\"bold\" \nng-if=\"vm.paymentSelectedOrder === \'date\'\">{{ item.value.split(\'-\')[0] }} al {{ item.value.split(\'-\')[1] }} </span>\n<span class=\"bold\" ng-if=\"vm.paymentSelectedOrder === \'event\'\" ng-bind-html=\"item.value\"></span> <span class=\"bold\" \nng-if=\"vm.paymentSelectedOrder === \'status\'\">{{ item.value }}</span></td><td class=\"center\" \nng-if=\"item.type === \'object\'\"><div ng-if=\"item.value.id_subsec != 1\" \nclass=\"pay-check {{vm.checkPays(item.value, \'payment_date\')}}\"></div><span ng-if=\"item.value.id_subsec === 1\" \nclass=\"material-symbols-outlined payment-open\">directions_run</span></td><td ng-if=\"item.type === \'object\'\"><span \nclass=\"bold\">{{vm.searchEventName(item.value.id_event)}} ({{item.value.id_event}})</span><br><span>\n{{vm.searchClientName(item.value.id_client)}} <span ng-if=\"vm.paymentSelectedOrder != \'date\'\">\n/ {{vm.formatDate(item.value.date_from, \'dd MMM yyyy\')}} al {{vm.formatDate(item.value.date_to, \'dd MMM yyyy\')}}</span>\n</span></td><td ng-if=\"item.type === \'object\'\" class=\"center\">{{item.value.orders}}</td><td \nng-if=\"item.type === \'object\'\" class=\"center\">{{item.value.sales_local | number:2}} {{item.value.currency_local}}</td>\n<td ng-if=\"item.type === \'object\'\" class=\"center\">{{item.value.sales_international | number:2}} USD</td><td \nng-if=\"item.type === \'object\'\" class=\"center\">{{item.value.total_sales_usd | number:2}} USD</td><td \nng-if=\"item.type === \'object\'\" class=\"center\">{{item.value.commision_percentage}}%</td><td \nng-if=\"item.type === \'object\'\" ng-class=\"{\'cursor-pointer\': vm.calcPayment(item.value)}\" \nclass=\"center span-with-overlay\">{{item.value.payment_due_usd}} USD <span class=\"overlay p-5\" \nng-if=\"vm.calcPayment(item.value)\">\nPhotos: {{item.value.total_photos}} * {{item.value.prices_per_photo_usd}} + Fee: {{item.value.prices_fee_usd}} = {{item.value.payment_due_usd}}\n</span></td></tr><tr class=\"table-items-footer\" ng-if=\"vm.morePayments\"><td ng-if=\"vm.loadingPayments\" colspan=\"8\"><div\n layout=\"row\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"30\">\n</md-progress-circular></div></td><td class=\"cursor-pointer center\" ng-click=\"vm.getPaymentBreakdown()\" \nng-if=\"vm.getLengthOfObject(vm.paymentPeriods) != 0 && !vm.loadingPayments\" colspan=\"8\"><div layout=\"row\" \nlayout-align=\"center center\" class=\"re-load-more font-size-15 bold\"><span class=\"material-symbols-outlined\">\nexpand_circle_down </span><span class=\"text-uppercase\" translate=\"RUNTAG.LOAD_MORE\">LOAD MORE</span></div></td></tr><tr\n class=\"table-items-footer\"><td class=\"bblr\"></td><td class=\"bold text-uppercase\" translate=\"RUNTAG.TOTAL\">TOTAL</td>\n<td></td><td class=\"bold center\">\n{{vm.totals.payment_breakdown.sales_local.sum | number:2}} {{vm.totals.payment_breakdown.sales_local.currency_local}}\n</td><td class=\"bold center\">{{vm.totals.payment_breakdown.sales_international | number:2}} USD</td><td \nclass=\"bold center\">{{vm.totals.payment_breakdown.total_sales_usd | number:2}} USD</td><td></td><td \nclass=\"bold center bbrr\">{{vm.totals.payment_breakdown.payment_due_usd | number:2}} USD</td></tr><tr \nclass=\"table-divider\"></tr><tr class=\"table-title-head orders\"><td class=\"table-icon center btlr\"><span \nclass=\"material-symbols-outlined\">shopping_bag</span></td><td class=\"btrr\" colspan=\"7\"><span \nclass=\"bold text-uppercase\" translate=\"RUNTAG.ORDERS\">ORDERS</span></td></tr><tr class=\"table-info-header\"><td></td><td\n class=\"text-uppercase bold\" translate=\"RUNTAG.USER\" colspan=\"2\">USER</td><td class=\"text-uppercase bold center\" \ntranslate=\"RUNTAG.DATE\">DATE</td><td class=\"text-uppercase bold\" translate=\"RUNTAG.EVENT\">EVENT</td><td \nclass=\"text-uppercase bold center\" translate=\"RUNTAG.PHOTOS\">PHOTOS</td><td class=\"text-uppercase bold center\" \ntranslate=\"RUNTAG.PAYMENTS\">PAYMENTS</td><td class=\"text-uppercase bold center\" translate=\"RUNTAG.USD_CONVERSION\">\nUSD_CONVERSION</td></tr><tr class=\"table-items-body\" ng-if=\"vm.orders.length === 0 && !vm.loadingOrders\"><td \ncolspan=\"8\" translate=\"RUNTAG.NOT_ORDERS\">THERE ARE NOT ORDERS</td></tr><tr class=\"table-items-body\" \nng-repeat=\"order in vm.orders\"><td></td><td colspan=\"2\"><div layout=\"column\"><span class=\"bold\">{{order.user_name}}\n</span> <span>{{order.user_email}}</span></div></td><td class=\"center\">\n{{vm.formatDate(order.created_at, \'dd MMM HH:mm\')}}</td><td ng-bind-html=\"vm.searchEventName(order.id_event)\"></td><td \nclass=\"center\"><span ng-if=\"order.items_total\">{{order.items_total}}</span> <span ng-if=\"!order.items_total\">All</span>\n</td><td class=\"center\">{{order.price | number:2}} {{order.currency_code}}</td><td class=\"center\"><span \nng-if=\"order.usd\">{{order.usd | number:2}} USD</span> <span ng-if=\"!order.usd\" translate=\"RUNTAG.NOT_AVALIABLE_YET\">\nNot avaliable yet</span></td></tr><tr class=\"table-items-footer\" ng-if=\"vm.moreOrders\"><td ng-if=\"vm.loadingOrders\" \ncolspan=\"8\"><div layout=\"row\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"30\"></md-progress-circular></div></td><td class=\"cursor-pointer center\" ng-click=\"vm.getOrders()\" \nng-if=\"vm.moreOrders && !vm.loadingOrders\" colspan=\"8\"><div layout=\"row\" layout-align=\"center center\" \nclass=\"re-load-more font-size-15 bold\"><span class=\"material-symbols-outlined\">expand_circle_down </span><span \nclass=\"text-uppercase\" translate=\"RUNTAG.LOAD_MORE\">LOAD MORE</span></div></td></tr><tr class=\"table-items-footer\"><td \nclass=\"bblr\"></td><td colspan=\"2\"></td><td class=\"bold center text-uppercase\" translate=\"RUNTAG.TOTAL\">TOTAL</td><td \nclass=\"bold left\">{{vm.totals.orders.total}}</td><td colspan=\"2\"></td><td class=\"bold center bbrr\">\n{{vm.totals.orders.usd | number:2}} USD</td></tr></tbody></table></div></div>");
$templateCache.put("app/main/apps/sitemap/layoutV2/components/layout-v2-block/layout-v2-block.html","");
$templateCache.put("app/main/apps/sitemap/layoutV2/components/layout-v2-canvas/layout-v2-button-dialog.html","<md-dialog class=\"layout-v2-button-dialog\"><md-dialog-content layout=\"column\" layout-padding><h2 class=\"md-title\">\nButton settings</h2><md-input-container class=\"md-block\"><label>Label</label><input ng-model=\"vm.form.text\">\n</md-input-container><md-input-container class=\"md-block\"><label>Link (href)</label><input ng-model=\"vm.form.href\">\n</md-input-container><md-input-container class=\"md-block\"><label>Target</label><md-select ng-model=\"vm.form.target\">\n<md-option value=\"_self\">Same tab (_self)</md-option><md-option value=\"_blank\">New tab (_blank)</md-option></md-select>\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button \nng-click=\"vm.cancel()\">Cancel</md-button><md-button class=\"md-primary\" ng-click=\"vm.save()\">Save</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/sitemap/layoutV2/components/layout-v2-canvas/layout-v2-canvas.html","<div class=\"layout-v2-canvas\" layout=\"column\" flex><div class=\"layout-v2-canvas__device-toggle\"><span \nng-class=\"{ \'is-active\': $ctrl.device === \'desktop\' }\">Desktop</span> <span \nng-class=\"{ \'is-active\': $ctrl.device === \'tablet\' }\">Tablet</span> <span \nng-class=\"{ \'is-active\': $ctrl.device === \'phone\' }\">Phone</span></div><div class=\"layout-v2-canvas__theme\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"layout-v2-canvas__theme-field\"><label \nclass=\"layout-v2-canvas__theme-label\">Background</label><input type=\"color\" class=\"layout-v2-canvas__theme-input\" \nng-model=\"$ctrl.theme.background\"></div><div class=\"layout-v2-canvas__theme-field\"><label \nclass=\"layout-v2-canvas__theme-label\">Primary</label><input type=\"color\" class=\"layout-v2-canvas__theme-input\" \nng-model=\"$ctrl.theme.primary\"></div><div class=\"layout-v2-canvas__theme-field\"><label \nclass=\"layout-v2-canvas__theme-label\">Secondary</label><input type=\"color\" class=\"layout-v2-canvas__theme-input\" \nng-model=\"$ctrl.theme.secondary\"></div><div class=\"layout-v2-canvas__theme-field\"><label \nclass=\"layout-v2-canvas__theme-label\">Tertiary</label><input type=\"color\" class=\"layout-v2-canvas__theme-input\" \nng-model=\"$ctrl.theme.tertiary\"></div></div><div class=\"layout-v2-canvas__frame\" flex><div \nclass=\"layout-v2-canvas__region layout-v2-canvas__region--header\" drop-region=\"\'header\'\" accept-types=\"[\'layout\']\" \non-drop=\"$ctrl.handleDrop($event)\" ng-attr-style=\"--region-bg: {{$ctrl.theme.background}}\"><div \nclass=\"layout-v2-canvas__region-label\">+ ADD HEADER LAYOUT</div><div class=\"layout-v2-canvas__blocks\" \nng-if=\"$ctrl.getBlocksForRegion(\'header\').length\"><div class=\"layout-v2-canvas__block\" \nng-repeat=\"block in $ctrl.getBlocksForRegion(\'header\') track by block.id || $index\"><div \nng-if=\"block.kind === \'layout\'\"><div class=\"layout-v2-canvas__layout-row\"><div class=\"layout-v2-canvas__layout-col\" \nng-repeat=\"col in block.columns track by col.id\"><div class=\"layout-v2-canvas__layout-col-label\">{{ col.span }}/12\n</div><div class=\"layout-v2-canvas__layout-col-empty\">(Widgets not supported in header yet)</div></div></div></div><div\n ng-if=\"block.kind !== \'layout\'\">{{ block.label }} ({{ block.kind }})</div></div></div></div><div \nclass=\"layout-v2-canvas__region layout-v2-canvas__region--content\" layout-v2-droppable drop-region=\"\'content\'\" \naccept-types=\"[\'layout\']\" on-drop=\"$ctrl.handleDrop($event)\" ng-attr-style=\"--region-bg: {{$ctrl.theme.background}}\">\n<div class=\"layout-v2-canvas__region-label\">+ ADD CONTENT LAYOUT</div><div class=\"layout-v2-canvas__blocks\" \nng-if=\"$ctrl.getBlocksForRegion(\'content\').length\"><div class=\"layout-v2-canvas__block\" \nng-repeat=\"block in $ctrl.getBlocksForRegion(\'content\') track by block.id || $index\"><div \nng-if=\"block.kind === \'layout\'\" class=\"layout-v2-canvas__block-header\"><div class=\"layout-v2-canvas__block-actions\">\n<button type=\"button\" class=\"layout-v2-layout-move-btn\" \nng-click=\"$ctrl.onMoveLayout({region: \'content\', index: $index, offset: -1})\">↑</button> <button type=\"button\" \nclass=\"layout-v2-layout-move-btn\" ng-click=\"$ctrl.onMoveLayout({region: \'content\', index: $index, offset: 1})\">↓\n</button> <button type=\"button\" class=\"layout-v2-layout-delete-btn\" \nng-click=\"$ctrl.handleDrop({ region:\'content\', deleteLayoutId: block.id })\">✕</button></div></div><div \nng-if=\"block.kind === \'layout\'\"><div class=\"layout-v2-canvas__layout-row\"><div class=\"layout-v2-canvas__layout-col\" \nng-repeat=\"col in block.columns track by col.id\" \nng-style=\"{\r\n                  \'flex-grow\': col.span,\r\n                  \'flex-basis\': \'0\'\r\n                }\" \nlayout-v2-droppable drop-region=\"\'content\'\" drop-column-id=\"col.id\" accept-types=\"[\'widget\',\'element\',\'template\']\" \non-drop=\"$ctrl.handleDrop($event)\"><div class=\"layout-v2-canvas__layout-col-widgets\" \nng-if=\"col.widgets && col.widgets.length\" layout-v2-sortable items=\"col.widgets\" \non-reorder=\"$ctrl.handleDrop({ region:\'content\', columnId: col.id, items: items })\"><div \nclass=\"layout-v2-canvas__widget\" layout-v2-sortable-item sortable-index=\"$index\" \nng-repeat=\"w in col.widgets track by w.id\"><div class=\"layout-v2-canvas__widget-inner\" \nng-attr-style=\"\r\n                          --widget-bg: {{$ctrl.resolveWidgetBg(w)}};\r\n                          --widget-color: {{$ctrl.resolveWidgetColor(w)}};\r\n                          --widget-width: {{(w.style && w.style.width) || 100}}%;\r\n                          --widget-align-self: {{(w.style && w.style.align) || \'left\'}};\r\n                          --widget-margin: {{$ctrl.serializeBox(w.style && w.style.margin)}};\r\n                          --widget-padding: {{$ctrl.serializeBox(w.style && w.style.padding)}};\r\n                        \">\n<div class=\"layout-v2-canvas__widget-main\"><div class=\"layout-v2-canvas__widget-content\" ng-switch=\"w.sourceId\"><div \nng-switch-when=\"element-button\"><button type=\"button\" class=\"layout-v2-preview-btn\">\n{{ (w.config && w.config.text) || \'Button\' }}</button></div><div ng-switch-default>{{ w.label }} ({{ w.kind }})</div>\n</div></div></div><div class=\"layout-v2-canvas__widget-actions\"><button type=\"button\" \nclass=\"layout-v2-widget-edit-btn\" ng-click=\"$ctrl.editWidget(w)\">✎</button> <button type=\"button\" \nclass=\"layout-v2-widget-delete-btn\" \nng-click=\"$ctrl.handleDrop({ region:\'content\', columnId: col.id, deleteId: w.id })\">✕</button></div></div></div><div \nclass=\"layout-v2-canvas__layout-col-empty\" ng-if=\"!col.widgets || !col.widgets.length\">Drop widgets / elements here\n</div></div></div></div><div ng-if=\"block.kind !== \'layout\'\">{{ block.label }} ({{ block.kind }})</div></div></div>\n</div><div class=\"layout-v2-canvas__region layout-v2-canvas__region--footer\" drop-region=\"\'footer\'\" \naccept-types=\"[\'layout\']\" on-drop=\"$ctrl.handleDrop($event)\" ng-attr-style=\"--region-bg: {{$ctrl.theme.background}}\">\n<div class=\"layout-v2-canvas__region-label\">+ ADD FOOTER LAYOUT</div><div class=\"layout-v2-canvas__blocks\" \nng-if=\"$ctrl.getBlocksForRegion(\'footer\').length\"><div class=\"layout-v2-canvas__block\" \nng-repeat=\"block in $ctrl.getBlocksForRegion(\'footer\') track by block.id || $index\">\n{{ block.label }} ({{ block.kind }})</div></div></div></div></div>");
$templateCache.put("app/main/apps/sitemap/layoutV2/components/layout-v2-canvas/layout-v2-widget-style-dialog.html","<md-dialog class=\"layout-v2-widget-style-dialog\"><md-dialog-content layout=\"column\" layout-padding><h2 \nclass=\"md-title\">Element style</h2><md-input-container class=\"md-block\"><label>Background</label><md-select \nng-model=\"vm.form.bg\"><md-option value=\"\">None</md-option><md-option value=\"primary\">Primary</md-option><md-option \nvalue=\"secondary\">Secondary</md-option><md-option value=\"tertiary\">Tertiary</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\"><label>Text color</label><md-select ng-model=\"vm.form.color\">\n<md-option value=\"\">Default</md-option><md-option value=\"primary\">Primary</md-option><md-option value=\"secondary\">\nSecondary</md-option><md-option value=\"tertiary\">Tertiary</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\"><label>Width (%)</label><input type=\"number\" min=\"1\" max=\"100\" \nng-model=\"vm.form.width\"></md-input-container><div layout=\"row\" layout-wrap><div flex=\"50\"><md-input-container \nclass=\"md-block\"><label>Margin top (px)</label><input type=\"number\" ng-model=\"vm.form.margin.top\"></md-input-container>\n</div><div flex=\"50\"><md-input-container class=\"md-block\"><label>Margin bottom (px)</label><input type=\"number\" \nng-model=\"vm.form.margin.bottom\"></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>\nMargin left (px)</label><input type=\"number\" ng-model=\"vm.form.margin.left\"></md-input-container></div><div flex=\"50\">\n<md-input-container class=\"md-block\"><label>Margin right (px)</label><input type=\"number\" \nng-model=\"vm.form.margin.right\"></md-input-container></div></div><div layout=\"row\" layout-wrap><div flex=\"50\">\n<md-input-container class=\"md-block\"><label>Padding top (px)</label><input type=\"number\" \nng-model=\"vm.form.padding.top\"></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>\nPadding bottom (px)</label><input type=\"number\" ng-model=\"vm.form.padding.bottom\"></md-input-container></div><div \nflex=\"50\"><md-input-container class=\"md-block\"><label>Padding left (px)</label><input type=\"number\" \nng-model=\"vm.form.padding.left\"></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label>\nPadding right (px)</label><input type=\"number\" ng-model=\"vm.form.padding.right\"></md-input-container></div></div>\n<md-input-container class=\"md-block\"><label>Alignment</label><md-select ng-model=\"vm.form.align\"><md-option \nvalue=\"start\">Left</md-option><md-option value=\"center\">Center</md-option><md-option value=\"end\">Right</md-option>\n</md-select></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\">\n<md-button ng-click=\"vm.cancel()\">Cancel</md-button><md-button class=\"md-primary\" ng-click=\"vm.save()\">Save</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/sitemap/layoutV2/components/layout-v2-region/layout-v2-region.html","");
$templateCache.put("app/main/apps/sitemap/views/edit/tabs/tab-basic.html","<div class=\"ph-15 pt-20 pb-10\" layout=\"column\" layout-gt-md=\"row\" ng-if=\"vm.nolayout == false\"><md-input-container \nflex class=\"md-block mh-5\"><label translate=\"SITEMAP.LAYOUT\"></label><md-select ng-change=\"vm.changeLayout()\" \nplaceholder=\"{{vm.translate(\'SITEMAP.LAYOUT\')}}\" ng-model=\"vm.layoutSelected\"><md-option value=\"\">---</md-option>\n<md-option ng-repeat=\"opt in vm.currentOptions.layouts track by $index\" value=\"{{opt.id_layout}}\">{{opt.name}}\n</md-option></md-select></md-input-container><md-input-container flex class=\"md-block mh-5\"><label \ntranslate=\"SITEMAP.HEADER_SITEMAP\"></label><input type=\"text\" ng-model=\"vm.currentSitemap.header_sitemap\" \nplaceholder=\"{{vm.translate(\'SITEMAP.HEADER_SITEMAP\')}}\"></md-input-container><md-input-container flex \nclass=\"md-block mh-5\"><label translate=\"SITEMAP.FOOTER\"></label><md-select \nplaceholder=\"{{vm.translate(\'SITEMAP.FOOTER\')}}\" ng-model=\"vm.currentSitemap.id_footer\"><md-option value=\"\">---\n</md-option><md-option ng-repeat=\"opt in vm.currentOptions.footers track by $index\" value=\"{{opt.id_footer}}\">\n{{opt.name}}</md-option></md-select></md-input-container></div><div class=\"form-wrapper\" flex=\"100\"><form \nname=\"vm.basicForm\" layout=\"column\"><div class=\"ph-15\" flex=\"100\" layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex=\"100\" flex-gt-xs=\"50\" class=\"md-block mh-5\"><label translate=\"SITEMAP.TYPE\"></label><md-select\n ng-change=\"vm.cleanValues()\" ng-model=\"vm.currentSitemap.type\" placeholder=\"{{vm.translate(\'SITEMAP.TYPE\')}}\">\n<md-option value=\"\">---</md-option><md-option ng-repeat=\"opt in vm.typesSitemap\" value=\"{{opt}}\">{{opt}}</md-option>\n</md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"40\" class=\"md-block mh-5\"><label \ntranslate=\"SITEMAP.PARENT\"></label><input ng-disabled=\"true\" type=\"text\" ng-model=\"vm.parentSitemap.name\"><md-icon \nng-click=\"vm.editParentDialog($event)\" class=\"edit-parent-icon md-font-icon icon-pencil\"><md-tooltip hide show-gt-xs>\n{{\'SITEMAP.EDIT_PARENT\' | translate}}</md-tooltip></md-icon><md-icon \nng-click=\"vm.currentSitemap.parent_sitemap= null; vm.parentSitemap= null;\" \nclass=\"delete-parent-icon md-font-icon icon-delete\"><md-tooltip hide show-gt-xs>{{\'SITEMAP.DELETE_PARENT\' | translate}}\n</md-tooltip></md-icon></md-input-container></div><div class=\"ph-15 pb-15\" flex=\"100\" layout=\"column\" \nlayout-gt-md=\"row\" layout-align-gt-md=\"space-between start\"><div \nng-if=\"vm.currentSitemap.type == \'dynamic\' || vm.currentSitemap.type == \'static\' || vm.currentSitemap.type == \'redirect\'\" \nflex=\"100\" flex-gt-xs=\"50\" class=\"md-block mh-5\"><div layout=\"row\" layout-align=\"start start\"><md-input-container \nflex=\"70\" class=\"md-block\"><label translate=\"SITEMAP.URL\"></label><input type=\"text\" ng-model=\"vm.currentSitemap.url\" \nplaceholder=\"{{vm.translate(\'SITEMAP.URL\')}}\"></md-input-container><md-input-container flex=\"30\" class=\"md-block\">\n<label translate=\"SITEMAP.EXTENSION\"></label><input type=\"text\" ng-model=\"vm.currentSitemap.extension\" \nplaceholder=\"{{vm.translate(\'SITEMAP.EXTENSION\')}}\"></md-input-container></div></div><div \nng-if=\"vm.currentSitemap.type == \'external\' || vm.currentSitemap.type == \'redirect\'\" flex=\"100\" flex-gt-xs=\"50\" \nclass=\"md-block mh-5\"><div layout=\"row\" layout-align=\"start start\"><md-input-container flex=\"50\" class=\"md-block\">\n<label translate=\"SITEMAP.URL\"></label><input type=\"text\" ng-model=\"vm.currentSitemap.url\" \nplaceholder=\"{{vm.translate(\'SITEMAP.URL\')}}\"></md-input-container><md-input-container flex=\"50\" class=\"md-block\">\n<label translate=\"SITEMAP.EXTERNAL_URL\"></label><input type=\"text\" ng-model=\"vm.currentSitemap.external_url\" \nplaceholder=\"{{vm.translate(\'SITEMAP.EXTERNAL_URL\')}}\"></md-input-container></div></div><md-input-container \nng-if=\"vm.currentSitemap.type == \'dynamic\' || vm.currentSitemap.type == \'static\' || vm.currentSitemap.type == \'redirect\'\" \nclass=\"md-block mh-5\"><label translate=\"SITEMAP.TTL\"></label><input type=\"text\" \nng-model=\"vm.currentSitemap.cache_timeout\" placeholder=\"{{vm.translate(\'SITEMAP.TTL\')}}\"></md-input-container>\n<md-input-container ng-if=\"vm.currentSitemap.type == \'dynamic\'\" class=\"md-block mh-5\"><label \ntranslate=\"SITEMAP.DYNAMIC_URL_STRUCTURE\"></label><md-select ng-model=\"vm.currentSitemap.sub_item\" \nplaceholder=\"{{vm.translate(\'SITEMAP.DYNAMIC_URL_STRUCTURE\')}}\"><md-option value=\"\">---</md-option><md-option \nng-repeat=\"opt in vm.dynamicStructures\" value=\"{{opt.value}}\">{{opt.structure}}</md-option></md-select>\n</md-input-container></div><div class=\"md-toolbar-tools ph-20 grey-100-bg\"><div layout=\"row\" \nlayout-align=\"start center\" class=\"flex-50\"><h3 class=\"grey-700-fg\" translate=\"SITEMAP.MENU\"></h3></div></div><div \nflex=\"100\" layout=\"row\" class=\"ph-15 pt-20\"><md-input-container flex=\"100\" class=\"md-block mh-5 mb-0\"><label \ntranslate=\"SITEMAP.NICKNAME\"></label><input type=\"text\" ng-model=\"vm.currentSitemap.display_name\" \nplaceholder=\"{{vm.translate(\'SITEMAP.NICKNAME\')}}\"></md-input-container></div><div layout=\"column\" layout-gt-md=\"row\" \nflex=\"100\" class=\"ph-15 pt-20\"><md-input-container class=\"md-block mh-5\" flex><md-checkbox \nng-model=\"vm.currentSitemap.isHome\" \nng-click=\"vm.currentSitemap.home == 1 ? vm.currentSitemap.home= 0 : vm.currentSitemap.home= 1;\" class=\"no-label\">\n{{vm.translate(\'SITEMAP.HOME\')}}</md-checkbox></md-input-container><md-input-container class=\"md-block mh-5\" flex>\n<md-checkbox ng-model=\"vm.currentSitemap.isMenu\" \nng-click=\"vm.currentSitemap.menu == 1 ? vm.currentSitemap.menu= 0 : vm.currentSitemap.menu= 1;\" class=\"no-label\">\n{{vm.translate(\'SITEMAP.MENU\')}}</md-checkbox></md-input-container><md-input-container class=\"md-block mh-5\" flex>\n<md-checkbox ng-model=\"vm.currentSitemap.isMenuSecondary\" \nng-click=\"vm.currentSitemap.menu_secondary == 1 ? vm.currentSitemap.menu_secondary= 0 : vm.currentSitemap.menu_secondary= 1;\" \nclass=\"no-label\">{{vm.translate(\'SITEMAP.MENU_SECONDARY\')}}</md-checkbox></md-input-container></div><div \nlayout=\"column\" layout-gt-md=\"row\" flex=\"100\" class=\"ph-15 pt-20 pb-10\"><md-input-container flex class=\"md-block mh-5\">\n<label translate=\"SITEMAP.SORT\"></label><md-select ng-model=\"vm.currentSitemap.sort\" \nplaceholder=\"{{vm.translate(\'SITEMAP.SORT\')}}\"><md-option value=\"\">---</md-option><md-option \nng-repeat=\"opt in [].constructor(101) track by $index\" value=\"{{$index}}\">{{$index}}</md-option></md-select>\n</md-input-container><md-input-container flex class=\"md-block mh-5\"><label translate=\"SITEMAP.SUB_MENU\"></label>\n<md-select class=\"sub-menu-selector\" ng-model=\"vm.currentSitemap.sub_menu\" \nplaceholder=\"{{vm.translate(\'SITEMAP.SUB_MENU\')}}\"><md-select-header class=\"sub-menu-selector\"><input autofocus \nng-model=\"subMenuSearch\" type=\"search\" onkeydown=\"event.stopPropagation()\" placeholder=\"Search...\" \nclass=\"demo-header-searchbox md-text\"></md-select-header><md-option value=\"\">---</md-option><md-option \nng-repeat=\"opt in vm.currentOptions.sub_menu_options | filter:{name: subMenuSearch}| orderBy: \'name\'\" \nvalue=\"{{opt.id_sitemap}}\">{{opt.name}}</md-option></md-select></md-input-container></div><div \nclass=\"md-toolbar-tools ph-20 grey-100-bg\"><div layout=\"row\" layout-align=\"start center\" class=\"flex-50\"><h3 \nclass=\"grey-700-fg\" translate=\"SITEMAP.CALLBACKS\"></h3></div><div layout=\"row\" layout-align=\"end center\" \nclass=\"flex-50\"><md-button class=\"md-icon-button\"><md-icon md-font-icon=\"icon-help-circle\"></md-icon><md-tooltip hide \nshow-gt-xs><span translate=\"SITEMAP.CALLBACKS_TEXT\">\nWhen saving items with these conditions this sitemap will be updated</span></md-tooltip></md-button></div></div><div \nclass=\"ph-15 pt-20 pb-10\" layout=\"column\" layout-gt-md=\"row\"><md-input-container flex class=\"md-block mh-5\"><label \ntranslate=\"SITEMAP.SECTION\"></label><md-select placeholder=\"{{vm.translate(\'SITEMAP.SECTION\')}}\" \nng-model=\"vm.currentSitemap.id_section\" ng-change=\"vm.loadSectionReferences()\" multiple=\"multiple\"><md-option \nng-repeat=\"opt in vm.sections\" value=\"{{opt.id}}\">{{opt.name}}</md-option></md-select></md-input-container>\n<md-input-container flex class=\"md-block mh-5\"><label translate=\"SITEMAP.SUBSECTION\"></label><md-select \nplaceholder=\"{{vm.translate(\'SITEMAP.SUBSECTION\')}}\" ng-model=\"vm.currentSitemap.id_subsec\" multiple=\"multiple\">\n<md-option ng-repeat=\"opt in vm.subsections\" value=\"{{opt.id_subsec}}\">{{opt.subsec}}</md-option></md-select>\n</md-input-container><md-input-container flex class=\"md-block mh-5\"><label translate=\"SITEMAP.CATEGORY\"></label>\n<md-select placeholder=\"{{vm.translate(\'SITEMAP.CATEGORY\')}}\" ng-model=\"vm.currentSitemap.id_cat\"><md-option value=\"\">\n---</md-option><md-option ng-repeat=\"opt in vm.categories\" value=\"{{opt.id_cat}}\">{{opt.cat}}</md-option></md-select>\n</md-input-container><md-input-container flex class=\"md-block mh-5\"><label translate=\"SITEMAP.SUBCATEGORY\"></label>\n<md-select placeholder=\"{{vm.translate(\'SITEMAP.SUBCATEGORY\')}}\" ng-model=\"vm.currentSitemap.id_subcat\"><md-option \nvalue=\"\">---</md-option><md-option ng-repeat=\"opt in vm.subcategories\" value=\"{{opt.id_subcat}}\">{{opt.subcat}}\n</md-option></md-select></md-input-container><md-input-container class=\"md-block mh-5\"><label \ntranslate=\"SITEMAP.ID_ITEM\"></label><input type=\"text\" placeholder=\"{{vm.translate(\'SITEMAP.ID_ITEM\')}}\">\n</md-input-container></div><div class=\"md-toolbar-tools ph-20 grey-100-bg\"><h3 class=\"grey-700-fg\" \ntranslate=\"SITEMAP.MORE\"></h3></div><div class=\"ph-15\" flex=\"33\" layout=\"row\" layout-gt-xs=\"row\"><md-input-container \nflex=\"33\" class=\"md-block mh-5\"><label translate=\"SITEMAP.SHOW_COOKIESBAR\"></label><md-select \nplaceholder=\"{{vm.translate(\'SITEMAP.SHOW_COOKIESBAR\')}}\" ng-model=\"vm.currentSitemap.show_cookiesbar\"><md-option \nvalue=\"0\">---</md-option><md-option value=\"1\">1</md-option><md-option value=\"2\">2</md-option></md-select>\n</md-input-container></div></form></div>");
$templateCache.put("app/main/apps/sitemap/views/edit/tabs/tab-layout-v2.html","");
$templateCache.put("app/main/apps/sitemap/views/edit/tabs/tab-layout.html","<div class=\"form-wrapper sitemap-layout\" flex=\"100\"><form name=\"vm.seoForm\" layout=\"column\" class=\"border white-bg\">\n<div class=\"md-toolbar-tools ph-20 grey-100-bg\"><div layout=\"row\" layout-align=\"start center\" class=\"flex-50\"><h3 \nclass=\"grey-700-fg\" translate=\"SITEMAP.SETTINGS\"></h3></div><div layout=\"row\" layout-align=\"end center\" \nclass=\"flex-50\"><md-input-container class=\"font-size-14\"><md-checkbox ng-change=\"vm.updateNoLayout()\" \nng-model=\"vm.nolayout\" class=\"no-label\">{{vm.translate(\'SITEMAP.NO_LAYOUT\')}}</md-checkbox></md-input-container></div>\n</div><div><md-content ng-include=\"\'app/main/apps/sitemap/views/edit/tabs/layout-sections/layout-settings.html\'\">\n</md-content><md-content ng-if=\"vm.currentSitemap.type != \'external\'\" \nng-include=\"\'app/main/apps/sitemap/views/edit/tabs/layout-sections/layout-toolbar.html\'\"></md-content><md-content \nng-if=\"vm.currentSitemap.type != \'external\'\" \nng-include=\"\'app/main/apps/sitemap/views/edit/tabs/layout-sections/layout-body.html\'\"></md-content><div \nng-if=\"vm.editMode == true && vm.nolayout == false && vm.currentSitemap.type != \'external\'\" layout=\"column\" \nclass=\"pb-5 grey-200-bg\"><div layout=\"column\" layout-align=\"center center\" flex=\"100\" \nclass=\"white-bg mh-15 mv-5 border\"><div class=\"content\" layout=\"column\" layout-align=\"top center\"><div class=\"message\">\n<md-button class=\"add-event-button md-fab md-warn ml-0\" aria-label=\"ADD\" \nng-click=\"vm.closeSidenav(\'widgets-sidenav\'); vm.toggleSidenav(\'layout-sidenav\')\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon></md-button><span class=\"font-size-16 grey-500-fg\" translate=\"SITEMAP.ADD_ROW\"></span></div><div \nclass=\"message\" translate=\"SITEMAP.NO_PREVIEW_AVAILABLE\" ng-if=\"vm.editMode == false\"></div></div></div></div></div>\n</form></div>");
$templateCache.put("app/main/apps/sitemap/views/edit/tabs/tab-menu.html","<div class=\"ph-15 pt-20 pb-10\" flex=\"100\" layout=\"column\" layout-gt-lg=\"row\"><div flex=\"100\" layout=\"row\">\n<md-input-container flex=\"100\" class=\"md-block mh-5 mb-0\"><label translate=\"SITEMAP.NICKNAME\"></label><input \ntype=\"text\" ng-model=\"vm.currentSitemap.display_name\" placeholder=\"{{vm.translate(\'SITEMAP.NICKNAME\')}}\">\n</md-input-container></div><div layout=\"column\" layout-gt-md=\"row\" flex=\"100\"><md-input-container \nclass=\"md-block mh-5\" flex><md-checkbox ng-model=\"vm.currentSitemap.isHome\" \nng-click=\"vm.currentSitemap.home == 1 ? vm.currentSitemap.home= 0 : vm.currentSitemap.home= 1;\" class=\"no-label\">\n{{vm.translate(\'SITEMAP.HOME\')}}</md-checkbox></md-input-container><md-input-container class=\"md-block mh-5\" flex>\n<md-checkbox ng-model=\"vm.currentSitemap.isMenu\" \nng-click=\"vm.currentSitemap.menu == 1 ? vm.currentSitemap.menu= 0 : vm.currentSitemap.menu= 1;\" class=\"no-label\">\n{{vm.translate(\'SITEMAP.MENU\')}}</md-checkbox></md-input-container><md-input-container class=\"md-block mh-5\" flex>\n<md-checkbox ng-model=\"vm.currentSitemap.isMenuSecondary\" \nng-click=\"vm.currentSitemap.menu_secondary == 1 ? vm.currentSitemap.menu_secondary= 0 : vm.currentSitemap.menu_secondary= 1;\" \nclass=\"no-label\">{{vm.translate(\'SITEMAP.MENU_SECONDARY\')}}</md-checkbox></md-input-container></div><div \nlayout=\"column\" layout-gt-md=\"row\" flex=\"100\"><md-input-container flex class=\"md-block mh-5\"><label \ntranslate=\"SITEMAP.SORT\"></label><md-select ng-model=\"vm.currentSitemap.sort\" \nplaceholder=\"{{vm.translate(\'SITEMAP.SORT\')}}\"><md-option value=\"\">---</md-option><md-option \nng-repeat=\"opt in [].constructor(101) track by $index\" value=\"{{$index}}\">{{$index}}</md-option></md-select>\n</md-input-container><md-input-container flex class=\"md-block mh-5\"><label translate=\"SITEMAP.SUB_MENU\"></label>\n<md-select ng-model=\"vm.currentSitemap.sub_menu\" placeholder=\"{{vm.translate(\'SITEMAP.SUB_MENU\')}}\"><md-option \nvalue=\"\">---</md-option><md-option ng-repeat=\"opt in vm.currentOptions.sub_menu_options\" value=\"{{opt.id_sitemap}}\">\n{{opt.name}}</md-option></md-select></md-input-container></div></div>");
$templateCache.put("app/main/apps/sitemap/views/edit/tabs/tab-seo.html","<div class=\"form-wrapper\" flex=\"100\"><style>\n.sc-editor{max-width:560px;margin:0 20px 8px;padding:18px 20px;border:1px solid #e3e8ef;border-radius:12px;background:#fafbfc}\r\n        .sc-editor h3{font-size:16px;font-weight:700;margin:0}\r\n        .sc-editor .sc-sub{font-size:12.5px;color:#68727f;margin:3px 0 16px}\r\n        .sc-prev{position:relative;width:100%;aspect-ratio:1200/630;border-radius:10px;overflow:hidden;\r\n            display:flex;flex-direction:column;padding:7% 6.6%;color:#fff;background:#141820}\r\n        .sc-prev .sc-glow{position:absolute;right:-8%;bottom:-24%;width:60%;padding-top:60%;border-radius:50%;filter:blur(44px);opacity:.55}\r\n        .sc-prev .sc-ov{position:absolute;top:0;left:0;right:0;bottom:0;pointer-events:none}\r\n        .sc-prev .sc-bar{position:absolute;left:0;right:0;bottom:0;height:2%}\r\n        .sc-prev .sc-eb{position:relative;font-size:11px;font-weight:700;letter-spacing:.09em;opacity:.62;text-transform:uppercase}\r\n        .sc-prev .sc-logo{position:relative;margin-top:2.5%;font-size:30px;font-weight:800;letter-spacing:.12em;line-height:1}\r\n        .sc-prev .sc-logoimg{position:relative;margin-top:2.5%;height:44px;width:auto;max-width:52%;object-fit:contain;object-position:left center;align-self:flex-start}\r\n        .sc-prev .sc-title{position:relative;margin-top:3.5%;font-size:26px;font-weight:800;line-height:1.12;max-width:88%;\r\n            overflow:hidden;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical}\r\n        .sc-row{margin-top:18px}\r\n        .sc-lab{display:block;font-size:11px;font-weight:600;letter-spacing:.04em;text-transform:uppercase;color:#68727f;margin-bottom:8px}\r\n        .sc-seg{display:inline-flex;background:#eef1f5;border-radius:9px;padding:3px;gap:3px}\r\n        .sc-seg button{font:inherit;font-size:13px;font-weight:600;cursor:pointer;border:0;background:transparent;color:#68727f;padding:7px 14px;border-radius:6px}\r\n        .sc-seg button.sc-on{background:#fff;color:#1c2430;box-shadow:0 1px 3px rgba(0,0,0,.14)}\r\n        .sc-sw{display:flex;flex-wrap:wrap;align-items:center;gap:9px}\r\n        .sc-swatch{width:30px;height:30px;border-radius:50%;cursor:pointer;border:2px solid transparent;padding:0;box-shadow:inset 0 0 0 1px rgba(0,0,0,.12)}\r\n        .sc-swatch.sc-selc{border-color:#1c2430;box-shadow:0 0 0 2px #fafbfc,0 0 0 4px #2e5bff}\r\n        .sc-color{width:34px;height:30px;padding:0;border:1px solid #cdd6e2;border-radius:7px;cursor:pointer;background:#fff}\r\n        .sc-hex{width:100px;font:inherit;font-size:13px;color:#1c2430;background:#fff;border:1px solid #e3e8ef;border-radius:8px;padding:7px 10px}\r\n        .sc-media{font:inherit;font-size:13px;font-weight:600;cursor:pointer;color:#2e5bff;background:#fff;border:1px solid #cdd6e2;border-radius:8px;padding:8px 14px}\r\n        .sc-url{display:block;width:100%;max-width:420px;margin-top:9px;font:inherit;font-size:13px;color:#1c2430;background:#fff;border:1px solid #e3e8ef;border-radius:8px;padding:8px 11px}\r\n        .sc-hint{font-size:12px;color:#8a94a2;margin:7px 0 0}\r\n        .sc-designs{display:flex;flex-wrap:wrap;gap:10px}\r\n        .sc-design{display:flex;flex-direction:column;gap:5px;width:96px;padding:0;background:0;border:0;cursor:pointer;text-align:center}\r\n        .sc-design-thumb{position:relative;width:96px;height:50px;border-radius:8px;overflow:hidden;background-size:cover;background-position:center;box-shadow:inset 0 0 0 1px rgba(0,0,0,.1);border:2px solid transparent}\r\n        .sc-design-bar{position:absolute;left:0;right:0;bottom:0;height:4px}\r\n        .sc-design-on .sc-design-thumb{border-color:#2e5bff;box-shadow:0 0 0 2px #fafbfc,0 0 0 4px #2e5bff}\r\n        .sc-design-name{font-size:11.5px;color:#68727f;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:96px}\r\n        .sc-design-on .sc-design-name{color:#1c2430;font-weight:600}\r\n        .sc-design-thumb-custom{display:flex;align-items:center;justify-content:center;background:#eef1f5;color:#8a94a2;font-size:20px}\r\n        /* editor reutilizado (<share-card-editor>): aire respecto al selector de cards. Es un\r\n           elemento custom -> necesita display:block para que el margen aplique. Además anulamos\r\n           su padding lateral propio, porque .sc-editor ya aporta el suyo y si no se indentaría\r\n           20px más que el resto del bloque. */\r\n        .sc-editor share-card-editor{display:block;margin-top:24px}\r\n        .sc-editor share-card-editor .share-card-editor{padding-left:0;padding-right:0}\n</style><div class=\"sc-editor\" ng-if=\"vm.currentSitemap.seo.fields\"><h3 translate=\"SITEMAP.CARD_TITLE\"></h3><p \nclass=\"sc-sub\" translate=\"SITEMAP.CARD_SUBTITLE\"></p><p class=\"sc-sub\" ng-if=\"!vm.hasCardConfig()\" \ntranslate=\"SITEMAP.CARD_NONE_HINT\"></p><div class=\"sc-prev\" ng-if=\"vm.selectedCardDesign()\" \nng-style=\"vm.cardPreviewStyle()\"><span class=\"sc-glow\" ng-style=\"vm.cardGlowStyle()\"></span> <span class=\"sc-ov\" \nng-style=\"vm.cardOverlayStyle()\"></span> <img class=\"sc-logoimg\" ng-if=\"vm.cardEffLogo()\" \nng-src=\"{{ vm.cardEffLogo() }}\" alt=\"\"> <span class=\"sc-logo\" ng-if=\"!vm.cardEffLogo()\">LOGO</span> <span \nclass=\"sc-title\">{{ vm.cardTitlePreview() || (\'SITEMAP.CARD_TITLE_PH\' | translate) }}</span> <span class=\"sc-bar\" \nng-style=\"vm.cardBarStyle()\"></span></div><div class=\"sc-row\" ng-if=\"vm.cardDesigns.length\"><label class=\"sc-lab\" \ntranslate=\"SITEMAP.CARD_DESIGN\"></label><div class=\"sc-designs\"><button type=\"button\" class=\"sc-design\" \nng-class=\"{\'sc-design-on\': !vm.hasCardConfig()}\" ng-click=\"vm.clearCard()\"><span \nclass=\"sc-design-thumb sc-design-thumb-custom\"><span>&#8212;</span></span> <span class=\"sc-design-name\" \ntranslate=\"SITEMAP.CARD_NONE\"></span></button> <button type=\"button\" class=\"sc-design\" ng-repeat=\"d in vm.cardDesigns\" \nng-class=\"{\'sc-design-on\': vm.cardDesignId()==d.id}\" ng-click=\"vm.pickCardDesign(d)\"><span class=\"sc-design-thumb\" \nng-style=\"d.style==\'image\' && d.background ? {\'background-image\':\'url(\\\'\' + d.background + \'\\\')\'} : {\'background\': d.color}\">\n<span class=\"sc-design-bar\" ng-style=\"{\'background\': d.color}\"></span> </span><span class=\"sc-design-name\">\n{{ d.title }}</span></button> <button type=\"button\" class=\"sc-design sc-design-custom\" \nng-class=\"{\'sc-design-on\': !vm.selectedCardDesign() && vm.hasCardConfig()}\" ng-click=\"vm.pickCardCustom()\"><span \nclass=\"sc-design-thumb sc-design-thumb-custom\"><span>✎</span></span> <span class=\"sc-design-name\" \ntranslate=\"SITEMAP.CARD_CUSTOM\"></span></button></div></div><share-card-editor \nng-if=\"!vm.selectedCardDesign() && vm.hasCardConfig()\" record=\"vm.cardRecord\" hide-name \ntitle-text=\"vm.cardPreviewTitle()\"></share-card-editor></div><form name=\"vm.seoForm\" layout=\"column\"><div \nlayout=\"column\"><md-input-container ng-repeat=\"field in vm.currentSitemap.seo.fields | filter:vm.notCardField\" \nflex=\"100\" flex-gt-xs=\"50\" class=\"md-block p-0\"><label class=\"mh-20\" ng-if=\"field.type !=\'separator\'\">{{field.title}}\n</label><input class=\"mh-20\" ng-if=\"field.type==\'text\'\" ng-model=\"field.value\" type=\"text\" \nplaceholder=\"{{field.title}}\"><md-select class=\"mh-20\" ng-if=\"field.type==\'select\'\" ng-model=\"field.value\" \nplaceholder=\"{{field.title}}\"><md-option value=\"\">---</md-option><md-option ng-repeat=\"opt in field.options\" \nvalue=\"{{opt}}\">{{opt}}</md-option></md-select><div ng-if=\"field.type==\'separator\'\" \nclass=\"md-toolbar-tools grey-100-bg\"><h3 class=\"grey-700-fg\">{{field.title | translate}}</h3></div>\n</md-input-container></div></form></div>");
$templateCache.put("app/main/apps/sitemap/views/edit/tabs/tab-wizard.html","<div class=\"form-wrapper wizard-container\" flex=\"100\" layout=\"column\" layout-align=\"center center\"><form \nms-vertical-stepper name=\"stepper\"><div><h2 class=\"text-center grey-600-fg md-display-1\">What would you like to create?\n</h2><div layout=\"row\" layout-align=\"center stretch\" class=\"mt-40\"><div md-whiteframe=\"1\" layput=\"column\" \nlayout-align=\"start center\" class=\"wiz-item mh-10 brad-6 border\"><div class=\"text-center pt-10 ph-10\"><md-icon \nclass=\"grey-400-fg s80\" md-font-icon=\"icon-document\"></md-icon></div><div \nclass=\"bold text-center pb-20 ph-20 pt-10 grey-400-fg\">HTML PAGE</div></div><div md-whiteframe=\"1\" layput=\"column\" \nlayout-align=\"start center\" class=\"wiz-item mh-10 brad-6 border\"><div class=\"text-center pt-10 ph-10\"><md-icon \nclass=\"grey-400-fg s80\" md-font-icon=\"icon-directions\"></md-icon></div><div \nclass=\"bold text-center pb-20 ph-20 pt-10 grey-400-fg\">REDIRECTION</div></div><div md-whiteframe=\"1\" layput=\"column\" \nlayout-align=\"start center\" class=\"wiz-item mh-10 brad-6 border\"><div class=\"text-center pt-10 ph-10\"><md-icon \nclass=\"grey-400-fg s80\" md-font-icon=\"icon-pencil-box\"></md-icon></div><div \nclass=\"bold text-center pb-20 ph-20 pt-10 grey-400-fg\">FROM SCRATCH</div></div></div></div></form></div>");
$templateCache.put("app/main/apps/sitemap/layoutV2/components/sitemap-layout-v2/sitemap-layout-v2.html","<div class=\"layout-v2-root\" layout=\"row\" flex><div class=\"layout-v2-sidebar-wrapper\" flex=\"30\"><layout-v2-sidebar \nlibrary=\"$ctrl.library\" on-apply-template=\"$ctrl.handleApplyTemplate(template)\" \non-drop-on-canvas=\"$ctrl.handleDropOnCanvas($event)\"></layout-v2-sidebar></div><div class=\"layout-v2-canvas-wrapper\" \nflex><layout-v2-canvas model=\"$ctrl.model\" device=\"$ctrl.device\" on-drop=\"$ctrl.handleDropOnCanvas($event)\" \non-move-layout=\"$ctrl.moveLayout(region, index, offset)\"></layout-v2-canvas></div></div>");
$templateCache.put("app/main/apps/sitemap/layoutV2/components/layout-v2-sidebar/layout-v2-sidebar.html","<div class=\"layout-v2-sidebar\" layout=\"column\" flex><div class=\"layout-v2-sidebar__tabs\" layout=\"row\"><button \ntype=\"button\" class=\"layout-v2-sidebar__tab\" \nng-class=\"{ \'layout-v2-sidebar__tab--active\': $ctrl.isActiveTab(tab.id) }\" ng-repeat=\"tab in $ctrl.tabs\" \nng-click=\"$ctrl.setActiveTab(tab.id)\">{{ tab.label }}</button></div><div class=\"layout-v2-sidebar__search\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><input type=\"text\" \nng-model=\"$ctrl.searchText\" placeholder=\"Search\" class=\"layout-v2-sidebar__search-input\"></div><div \nclass=\"layout-v2-sidebar__list\" flex layout=\"column\"><div class=\"layout-v2-sidebar__empty\" \nng-if=\"!$ctrl.filteredItems().length\">No items available for this tab.</div><div class=\"layout-v2-sidebar__item\" \nng-repeat=\"item in $ctrl.filteredItems() track by item.id || item.name || $index\" layout=\"row\" \nlayout-align=\"start center\" layout-padding layout-margin layout-v2-draggable drag-data=\"item\"><div \nclass=\"layout-v2-sidebar__item-thumb\"></div><div class=\"layout-v2-sidebar__item-text\" flex><div \nclass=\"layout-v2-sidebar__item-title\">{{ item.label || item.name || (\'Item \' + ($index + 1)) }}</div><div \nclass=\"layout-v2-sidebar__item-subtitle\" ng-if=\"item.description\">{{ item.description }}</div></div><md-button \nclass=\"md-primary md-raised layout-v2-sidebar__apply-btn\" ng-if=\"$ctrl.activeTab === \'templates\'\" \nng-click=\"$ctrl.applyTemplate(item); $event.stopPropagation();\">Use</md-button></div></div></div>");
$templateCache.put("app/main/apps/social/social-accounts/views/read/read-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-show=\"vm.loadingReadPane\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nng-show=\"!vm.loadingReadPane\"><div class=\"mail-content\" layout=\"column\" layout-align=\"center center\" \nng-if=\"!vm.selectedContent\"><div class=\"content\" layout=\"column\" layout-align=\"top center\"><div class=\"message\" \ntranslate=\"FORMS.NO_ITEM_SELECTED_PANEL\"></div></div></div><div class=\"toolbar grey-100-bg colored-bg\" layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"vm.selectedContent\" scroll=\"\"><div layout=\"row\" layout-align=\"start center\">\n<md-button class=\"md-icon-button close-thread\" aria-label=\"Back\" ng-click=\"vm.closeThread()\" translate \ntranslate-attr-aria-label=\"FORMS.BACK\" ng-if=\"vm.currentView === \'nosplit\'\"><md-icon md-font-icon=\"icon-arrow-left\">\n</md-icon></md-button></div><div layout=\"row\" layout-align=\"end center\" ng-if=\"vm.selectedContent\" hide show-gt-sm>\n<md-button type=\"submit\" ng-click=\"vm.saveItem(vm.selectedContent)\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.basicForm.$invalid || vm.basicForm.$pristine && vm.noexistchangues\" aria-label=\"SAVE\" \ntranslate=\"FORMS.SAVE\" translate-attr-aria-label=\"FORMS.SAVE\">SAVE</md-button><md-button type=\"button\" \nng-click=\"vm.closeThreadEdit()\" class=\"md-raised md-warn\" aria-label=\"Cancel\">Cancel</md-button></div><div \nlayout=\"row\" layout-align=\"end center\" ng-if=\"vm.selectedContent\" hide-gt-sm><md-button type=\"submit\" \nng-click=\"vm.saveItem(vm.selectedContent)\" class=\"md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme\" \nng-disabled=\"vm.basicForm.$invalid || vm.basicForm.$pristine && vm.noexistchangues\" aria-label=\"SAVE\"><md-icon \nmd-font-icon=\"icon-check\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"FORMS.SAVE\">Save</span></md-tooltip>\n</md-button><md-button type=\"button\" ng-click=\"vm.closeThreadEdit()\" \nclass=\"md-warn md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme\" aria-label=\"Cancel\"><md-icon \nmd-font-icon=\"icon-window-close\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"FORMS.CANCEL\">Cancel</span>\n</md-tooltip></md-button></div></div><form name=\"vm.basicForm\" class=\"md-inline-form\" novalidate><md-content flex=\"\" \nng-if=\"vm.selectedContent && !vm.editInline\"><div class=\"mail-content file-details scrollable\" \nms-scroll=\"vm.msScrollOptions\"><md-list class=\"pb-0\"><md-list-item class=\"info\" layout=\"row\" \nlayout-align=\"start center\"><div layout=\"row\" layout-align=\"start start\"><div class=\"header-element\" layout=\"row\" \nlayout-align=\"center center\"><div><span class=\"grey-500-fg\">ID # </span><span ng-bind=\"vm.selectedContent.id\"></span>\n</div></div></div></md-list-item><md-list-item><md-input-container fill-width class=\"md-block margin-0\"><label \ntranslate=\"FORMS.TITLE\"></label><textarea ng-model=\"vm.selectedContent.title\" columns=\"1\" rows=\"1\"></textarea>\n</md-input-container></md-list-item></md-list><md-list><md-list-item \nclass=\"md-toolbar-tools grey-100-bg md-no-proxy _md\" role=\"listitem\" style=\"border-top: 1px solid gainsboro\"><h3 \nclass=\"grey-700-fg\" translate=\"FORMS.FIELDS\"></h3><md-divider></md-divider></md-list-item></md-list><md-list \ndragula=\"\'element\'\" dragula-model=\"vm.selectedContent.form_data.fields\"><md-list-item \nng-show=\"field.type !== \'media_footer\' && field.type !== \'media_header\'\" \nng-repeat=\"field in vm.selectedContent.form_data.fields track by $index\" class=\"md-block structure\" \nng-class=\"(!field.temporary && !field.editing) ? \'md-block structure\' : \'structure-edited\'\"><div layout=\"column\" \nlayout-align=\"center space-between\" flex><div ng-include=\"\'app/main/apps/forms/views/editors/editors-view.html\'\"></div>\n<div ng-include=\"\'app/main/apps/forms/views/editors/editors-editing.html\'\"></div></div><md-divider \nclass=\"md-default-theme\"></md-divider></md-list-item></md-list><md-input-container layout=\"row\" \nlayout-align=\"end center\" flex=\"\" class=\"pr-15\" ng-click=\"vm.addNewStructureField()\"><button \nclass=\"add-event-button md-fab md-warn md-button md-default-theme\" type=\"button\" aria-label=\"ADD\"><md-icon \nmd-font-icon=\"icon-plus\" role=\"img\" aria-hidden=\"true\"></md-icon></button></md-input-container></div></md-content>\n</form></div>");
$templateCache.put("app/main/apps/social/social-accounts/views/list/list-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-show=\"isLoading\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nclass=\"mail-list-item filter-selected\" ng-if=\"sortField\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\" flex><div class=\"info\" ng-if=\"sortField\"><div class=\"name\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-sort-ascending\" class=\"s20 mr-5 ml-0 mb-0\" \nng-if=\"sortDir === \'ASC\'\"></md-icon><md-icon md-font-icon=\"icon-sort-descending\" class=\"s20 mr-5 ml-0 mb-0\" \nng-if=\"sortDir === \'DESC\'\"></md-icon><div class=\"title text-truncate\" layout=\"row\" layout-align=\"start center\">\nOrdered by \'{{sortField}}\'</div></div></div></div><div class=\"buttons\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-close s20\" ng-click=\"pagination_resetOrderBy()\" class=\"ml-10\"><md-tooltip hide show-gt-xs>\n<span translate=\"FORMS.REMOVE\">Remove</span></md-tooltip></md-icon></div></div><div class=\"no-threads\" \nng-if=\"!isLoading && vm.threads.length === 0\" ng-hide=\"isLoading\" translate=\"FORMS.NO_ITEMS\">There are no items!</div>\n<div id=\"list-content-data\" ng-style=\"{\'opacity\' : isLoading ? 0.2 : 1}\" ms-scroll=\"vm.msScrollOptions\" \nng-class=\"{\'group-filter\': vm.selectedGroup,\'other-filter\':sortField}\" class=\"scrollable\" ng-if=\"vm.threads.length> 0\">\n<div layout=\"row\" layout-align=\"end center\" class=\"p-20 bb\"><span class=\"check-row font-weight-700\">CAN POST</span> \n<span class=\"check-row font-weight-700\">AVAILABLE TO ALL</span> <span class=\"check-row font-weight-700\">\nSOCIAL STREAM ENABLED</span></div><div class=\"mail-list-item {{thread.status}}\" \nng-repeat=\"thread in vm.threads | filter: vm.search | filter: global.search\" md-no-ink ng-init=\"parentIndex= $index\" \nng-click=\"vm.openThread(thread)\" \nng-class=\"{\'starred\': thread.starred, \'selected\': vm.selectedContentID === thread.id_social_account, \'checked\': vm.isChecked(thread)}\">\n<div layout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-label\" ng-checked=\"vm.isSelected(thread)\" \nng-click=\"vm.toggleSelectThread(thread, $event)\" aria-label=\"{{vm.isSelected(thread) ? \'Deselect\' : \'Select\'}}\">\n</md-checkbox><div layout=\"column\"><md-icon ng-if=\"thread.provider == \'google\'\" md-font-icon=\"icon-youtube\"></md-icon>\n<md-icon ng-if=\"thread.provider == \'youtube\'\" md-font-icon=\"icon-youtube\"></md-icon><md-icon \nng-if=\"thread.provider == \'linkedin\'\" md-font-icon=\"icon-linkedin\"></md-icon><md-icon \nng-if=\"thread.provider == \'twitter\' || thread.provider == \'x\'\" aria-label=\"X\"><svg viewBox=\"0 0 24 24\" \nfill=\"currentColor\" style=\"width: .75em; height: .75em; vertical-align: middle\"><path \nd=\"M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z\"/>\n</svg></md-icon><md-icon ng-if=\"thread.provider == \'facebook\'\" md-font-icon=\"icon-facebook\"></md-icon></div><div \nclass=\"info\" flex layout=\"column\"><div layout=\"row\"><div class=\"name\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"user-name text-truncate\"><span ng-bind=\"thread.name\" ng-if=\"thread.name\"></span><div layout=\"row\" \nclass=\"mr-10 mb-5 text-truncate\"><span class=\"title grey-500-fg\">{{\'SOCIAL.EXPIRES\' | translate}} </span><span>\n{{thread.expires_at}}</span></div></div></div><div layout=\"row\" layout-align=\"end center\" class=\"flex\"><span \nclass=\"check-row font-weight-700\"><md-checkbox class=\"no-label\" ng-checked=\"thread.can_post\" ng-disabled=\"true\" \naria-label=\"Can post\"></md-checkbox></span><span class=\"check-row font-weight-700\"><md-checkbox class=\"no-label\" \nng-checked=\"thread.available_to_all\" ng-disabled=\"true\" aria-label=\"Available all\"></md-checkbox></span><span \nclass=\"check-row font-weight-700\"><md-checkbox class=\"no-label\" ng-checked=\"thread.social_stream_enabled\" \nng-disabled=\"true\" aria-label=\"Social Stream enabled\"></md-checkbox></span></div></div></div><div layout=\"column\" \nlayout-align=\"space-between end\"></div></div></div><div class=\"toolbar\" layout=\"row\" layout-align=\"end center\"><div \nlayout=\"row\" layout-align=\"center center\" ng-style=\"{\'display\' : isLoading ? \'none\' : \'block\'}\"><span \nclass=\"page-info\">{{pagination_totalItems}} items found.</span><md-button aria-label=\"Previous\" \nclass=\"md-icon-button arrow\" ng-click=\"pagination_prevPage()\" ng-disabled=\"pagination_firstPage()\" translate=\"\" \ntranslate-attr-aria-label=\"FORMS.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span \ntranslate=\"FORMS.PREVIOUS\">Previous</span></md-tooltip></md-button><span class=\"page-info\">\n{{pagination_page}} / {{pagination_total_pages}}</span><md-button aria-label=\"Next\" class=\"md-icon-button arrow\" \nng-click=\"pagination_nextPage()\" ng-disabled=\"pagination_morePages() || pagination_total_pages === pagination_page\" \ntranslate=\"\" translate-attr-aria-label=\"FORMS.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip>\n<span translate=\"FORMS.NEXT\">Next</span></md-tooltip></md-button></div></div></div>");
$templateCache.put("app/main/apps/social/social-accounts/views/list/nosplit-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/social/social-accounts/views/list/toolbar.html\'\"></div><div class=\"content-wrapper\" flex=\"\" \nlayout=\"row\"><div class=\"content thread-list mail-list-pane\" flex=\"\" id=\"thread-list\" \nng-include=\"\'app/main/apps/social/social-accounts/views/list/list-view.html\'\"></div></div>");
$templateCache.put("app/main/apps/social/social-accounts/views/list/split-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/social/social-accounts/views/list/toolbar.html\'\"></div><div class=\"content-wrapper\" flex=\"\" \nlayout=\"row\"><div class=\"content thread-list mail-list-pane\" flex=\"40\" layout=\"column\" id=\"thread-list\" \nng-include=\"\'app/main/apps/social/social-accounts/views/list/list-view.html\'\"></div><div ng-if=\"!vm.isAccreditations\" \nclass=\"content thread-detail mail-read-pane\" flex=\"60\" id=\"thread-detail\" layout=\"column\" \nng-include=\"\'app/main/apps/social/social-accounts/views/read/read-view.html\'\"></div><div ng-if=\"vm.isAccreditations\" \nclass=\"content thread-detail mail-read-pane\" flex=\"60\" id=\"thread-detail\" layout=\"column\" \nng-include=\"\'app/main/apps/social/social-accounts/views/read/read-view-accreditations.html\'\"></div></div>");
$templateCache.put("app/main/apps/social/social-accounts/views/list/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-label\" \naria-label=\"{{vm.selectedThreads.length > 0 ? \'Deselect All\' : \'Select All\'}}\" \nng-checked=\"vm.selectedThreads.length > 0\" ng-click=\"vm.toggleSelectThreads()\"></md-checkbox><div \nclass=\"divider-vertical\" hide show-gt-xs></div><md-button aria-label=\"ADD NEW\" \nclass=\"md-accent green-500-bg md-raised md-button ng-scope md-ink-ripple md-default-theme\" hide show-gt-sm \nng-click=\"vm.addSocialNetworkPage()\" translate=\"FORMS.ADD_NEW\" type=\"button\">Add new</md-button><md-button \naria-label=\"ADD NEW\" class=\"md-fab md-mini md-accent green-500-bg md-raised md-ink-ripple md-default-theme\" hide-gt-sm \nng-click=\"vm.addSocialNetworkPage()\" type=\"button\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><div \nclass=\"divider-vertical\" hide show-gt-xs></div><button ng-if=\"!vm.showQiuGroupsSidenav\" aria-label=\"view group\" \nclass=\"md-button md-icon-button\" ng-click=\"vm.toggleQiuGroupsSidenav()\" translate \ntranslate-attr-aria-label=\"CONTENT.VIEW_GROUPS\"><md-icon md-font-icon=\"icon-folder-multiple\"></md-icon><md-tooltip \nhide show-gt-xs><span translate=\"CONTENT.VIEW_GROUPS\">View Groups</span></md-tooltip></button><md-button \nng-if=\"!vm.selectedGroup && vm.selectedThreads.length > 0\" qiu-groups-add-selected-items-dialog \nqiu-groups-membership-id-field=\"\'id_social_account\'\" qiu-groups-membership-selected-items=\"vm.selectedThreads\" \nqiu-groups-nested=\"vm.groups\" qiu-groups-membership-mass-insert=\"vm.massInsertIntoGroups\" class=\"md-icon-button\" \naria-label=\"Add\" translate-attr-aria-label=\"QIU_GROUPS.ADD_TO_GROUPS\"><md-icon md-font-icon=\"icon-folder-account\">\n</md-icon><md-tooltip hide show-gt-xs><span translate=\"QIU_GROUPS.ADD_TO_GROUPS\"></span></md-tooltip></md-button>\n<md-button ng-if=\"vm.selectedGroup && vm.selectedThreads.length > 0 && !vm.selectedGroup.is_qiu_restricted_root\" \nqiu-groups-remove-selected-items-dialog qiu-groups-membership-id-field=\"\'id_social_account\'\" \nqiu-groups-membership-selected-items=\"vm.selectedThreads\" qiu-groups-membership-selected-group=\"vm.selectedGroup\" \nqiu-groups-membership-remove=\"vm.removeFromGroup\" class=\"md-icon-button\" aria-label=\"Remove\" \ntranslate-attr-aria-label=\"QIU_GROUPS.REMOVE_FROM_GROUP\"><md-icon md-font-icon=\"icon-folder-remove\"></md-icon>\n<md-tooltip hide show-gt-xs><span translate=\"QIU_GROUPS.REMOVE_FROM_GROUP\"></span></md-tooltip></md-button><div \nng-if=\"!vm.showQiuGroupsSidenav\" class=\"divider-vertical\" hide show-gt-xs></div><div aria-hidden=\"false\" \nclass=\"action-buttons hide show-gt-xs layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\" \nng-show=\"vm.selectedThreads.length > 0\"><md-button ng-click=\"vm.massActions(\'delete\')\" aria-label=\"Delete\" \nclass=\"md-icon-button\" hide show-gt-sm translate translate-attr-aria-label=\"FORMS.DELETE\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"FORMS.DELETE\">Delete</span></md-tooltip></md-button>\n<div class=\"divider-vertical\" hide show-gt-xs></div></div><ms-search-bar debounce=\"300\" \nmodel-search=\"$root.pagination_searchquery\" on-result-click=\"vm.searchResultClick(item)\" on-search=\"vm.search(query)\" \nlayout=\"row\" layout-align=\"start center\"></ms-search-bar><md-button ng-click=\"$root.pagination_resetquery()\" \naria-label=\"view type\" class=\"md-icon-button\" translate=\"\" translate-attr-aria-label=\"FORMS.RESET_SEARCH\" \nclass=\"md-icon-button\" ng-if=\"$root.pagination_searchquery==true\"><md-icon md-font-icon=\"icon-filter-remove-outline\">\n</md-icon><md-tooltip hide show-gt-xs><span translate=\"FORMS.RESET_SEARCH\"></span></md-tooltip></md-button></div><div \nlayout=\"row\" layout-align=\"start center\" translate-attr-aria-label=\"FORMS.REFRESH\"><span class=\"page-info\" hide \nshow-gt-xs>{{pagination_totalItems}} items found.</span><md-button aria-label=\"Previous\" class=\"md-icon-button arrow\" \nhide ng-click=\"pagination_prevPage()\" ng-disabled=\"pagination_firstPage()\" show-gt-xs translate \ntranslate-attr-aria-label=\"FORMS.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span \ntranslate=\"FORMS.PREVIOUS\">Previous</span></md-tooltip></md-button><span class=\"page-info\" hide show-gt-xs>\n{{pagination_page}} / {{pagination_total_pages}}</span><md-button aria-label=\"Next\" class=\"md-icon-button arrow\" hide \nng-click=\"pagination_nextPage()\" ng-disabled=\"pagination_morePages()\" show-gt-xs translate \ntranslate-attr-aria-label=\"FORMS.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span \ntranslate=\"FORMS.NEXT\">Next</span></md-tooltip></md-button><md-menu class=\"settings-menu\" hide-gt-xs \nng-show=\"vm.selectedThreads.length > 0\"><md-button aria-label=\"Settings\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\" translate translate-attr-aria-label=\"FORMS.SETTINGS\"><md-icon \nmd-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content><md-menu-item><md-menu-item><md-button \nng-click=\"vm.massActions(\'delete\')\" aria-label=\"Delete\" translate-aria-label=\"FORMS.DELETE\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><span translate=\"FORMS.DELETE\">Delete </span><span translate=\"FORMS.SELECTED\">\nSelected</span></md-button></md-menu-item></md-menu-item></md-menu-content></md-menu></div>");
$templateCache.put("app/main/apps/users/analytics/views/list/list-table-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-if=\"isLoading\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nclass=\"mail-list-item filter-selected\" ng-if=\"vm.fieldOrder != undefined || vm.groupBy != undefined\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"info\" \nng-if=\"vm.groupBy != undefined\"><div class=\"name\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"s20 mr-5 ml-0 mb-0\"></md-icon><div class=\"title text-truncate\" \nlayout=\"row\" layout-align=\"start center\">Grouped by \'{{vm.groupBy}}\'</div></div></div><div class=\"info\" \nng-if=\"vm.fieldOrder != undefined\"><div class=\"name\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-sort-ascending\" class=\"s20 mr-5 ml-0 mb-0\" ng-if=\"sortDir === \'ASC\'\"></md-icon><md-icon \nmd-font-icon=\"icon-sort-descending\" class=\"s20 mr-5 ml-0 mb-0\" ng-if=\"sortDir === \'DESC\'\"></md-icon><div \nclass=\"title text-truncate\" layout=\"row\" layout-align=\"start center\">Ordered by \'{{vm.fieldOrder}}\'</div></div></div>\n</div><div class=\"buttons\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-close s20\" \nng-click=\"vm.resetSortField()\" class=\"ml-10\"><md-tooltip hide show-gt-xs><span translate=\"CONTENT.REMOVE\">Remove</span>\n</md-tooltip></md-icon></div></div><div class=\"no-threads\" \nng-if=\"!isLoading && vm.threads.length === 0 && !vm.pleaseSelectGroup\" ng-hide=\"isLoading\" translate=\"USERS.NO_ITEMS\">\n</div><div class=\"no-threads\" ng-if=\"!isLoading && vm.threads.length === 0 && vm.pleaseSelectGroup\" \nng-hide=\"isLoading\" translate=\"USERS.SELECT_GROUP\"></div><div id=\"list-content-data\" \nng-style=\"{\'opacity\' : isLoading ? 0.2 : 1}\" \nng-class=\"{\'group-filter\': vm.selectedGroup,\'other-filter\':vm.fieldOrder != undefined || vm.groupBy != undefined}\" \nclass=\"scrollable\" ng-if=\"vm.threads.length > 0\"><div class=\"mail-list-item filter-selected\" \nng-if=\"vm.threads.length > 0\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\"><div class=\"name\" \nlayout=\"row\" layout-align=\"end center\"><div class=\"title text-truncate\" layout=\"row\" layout-align=\"start center\">\n<strong>{{(vm.threads | filter: vm.tenantsFilter | filter: vm.searchQuery).length}} Results found</strong></div></div>\n</div></div><table class=\"table-scrollable row-border hover simple\" ms-responsive-table><thead \nstyle=\"padding-right: 15px\"><tr><th \nng-class=\"{\'large\': vm.isLarge(column.field_name), \'medium\' : vm.isMedium(column.field_name), \'small\' : vm.isSmall(column.field_name), \'mini\': vm.isMini(column.field_name)}\" \nng-repeat=\"column in vm.refcolumns | orderBy: vm.orderByTableListSort | filter: { table_list_position: \'main\'}\"><span \nng-bind=\"column.title\"></span></th><th \nng-class=\"{\'large\': vm.isLarge(column.field_name), \'medium\' : vm.isMedium(column.field_name), \'small\' : vm.isSmall(column.field_name), \'mini\': vm.isMini(column.field_name)}\" \nng-repeat=\"column in vm.filterColumnsRaces\"><span ng-bind=\"column.title\"></span></th><th class=\"small\"><md-menu-bar>\n<md-menu><md-button class=\"md-icon-button\" aria-label=\"Actions\" ng-click=\"$mdMenu.open($event)\" layout=\"row\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-cog\"></md-icon><md-tooltip hide show-gt-xs><span \ntranslate=\"USERS.EDIT_COLUMNS\">Edit columns</span></md-tooltip></md-button><md-menu-content><md-menu-item \nng-repeat=\"column in vm.refcolumns | orderBy: vm.orderByTableListSort | filter: vm.filterIsMainOrSecondaryTableListPosition\">\n<md-button md-prevent-menu-close=\"md-prevent-menu-close\" \nng-click=\"column.table_list_position == \'main\' ? column.table_list_position = \'secondary\' : column.table_list_position = \'main\'; $event.stopPropagation();\" \naria-label=\"{{column.field_name}}\"><div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start between\"><span ng-bind=\"column.title\"></span></div><i ng-if=\"column.table_list_position == \'main\'\" \nclass=\"icon-check s16\"></i></div></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></th></tr>\n</thead><tbody><tr ng-click=\"vm.openThread(thread)\" \nng-repeat=\"thread in vm.threads | filter: vm.tenantsFilter | filter: vm.searchQuery | orderBy: vm.fieldOrder : vm.sortOrder===\'DESC\'  \" \nng-class=\"{\'starred\': thread.starred, \'selected\': vm.selectedContentID === thread.id_user, \'checked\': vm.isChecked(thread)}\" \nclass=\"{{thread.status}}\"><td \nng-class=\"{\'large\': vm.isLarge(column.field_name), \'medium\' : vm.isMedium(column.field_name), \'small\' : vm.isSmall(column.field_name), \'mini\': vm.isMini(column.field_name)}\" \nng-repeat=\"column in vm.refcolumns | orderBy: vm.orderByTableListSort | filter: { table_list_position: \'main\'}\" \nng-if=\"column.field_name !== \'lastname\'\" ng-switch=\"column.field_name\"><span ng-switch-when=\"id_user\" \ntitle=\"# {{thread.id_user}}\" class=\"grey-500-fg\">#{{thread.id_user}}</span> <span ng-switch-when=\"firstname\" \nclass=\"large\"><strong title=\"{{thread.firstname}} {{thread.lastname}}\">{{thread.firstname}} {{thread.lastname}}\n</strong> </span><span ng-switch-default title=\"{{thread[column.field_name]}}\">{{thread[column.field_name]}}</span>\n</td><td \nng-class=\"{\'large\': vm.isLarge(column.field_name), \'medium\' : vm.isMedium(column.field_name), \'small\' : vm.isSmall(column.field_name), \'mini\': vm.isMini(column.field_name)}\" \nng-repeat=\"column in vm.filterColumnsRaces\"><span title=\"{{thread[column.field_name]}}\">\n{{vm.formatSeconds(thread.extra[column.field_name])}}</span></td><td class=\"small\"></td></tr></tbody></table></div>");
$templateCache.put("app/main/apps/users/analytics/views/list/split-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/users/analytics/views/list/toolbar.html\'\"></div><div class=\"content-wrapper\" flex=\"\" \nlayout=\"row\"><div class=\"content thread-list mail-list-pane\" flex=\"40\" layout=\"column\" id=\"thread-list\" \nng-include=\"\'app/main/apps/users/analytics/views/list/list-view.html\'\"></div><div \nclass=\"content thread-detail mail-read-pane\" flex=\"60\" id=\"thread-detail\" layout=\"column\" \nng-include=\"\'app/main/apps/users/analytics/views/read/read-view.html\'\"></div></div>");
$templateCache.put("app/main/apps/users/analytics/views/list/table-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/users/analytics/views/list/toolbar.html\'\"></div><div class=\"content-wrapper\" flex=\"\" \nlayout=\"row\"><div class=\"content thread-list mail-list-pane\" flex=\"100\" id=\"thread-list\" \nng-include=\"\'app/main/apps/users/analytics/views/list/list-table-view.html\'\"></div><div \nclass=\"content thread-detail mail-read-pane edit-pane-users\" id=\"thread-detail\" layout=\"column\" \nng-include=\"\'app/main/apps/users/analytics/views/read/read-view.html\'\" ng-class=\"{selected:vm.selectedContent}\"></div>\n</div>");
$templateCache.put("app/main/apps/users/analytics/views/list/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button close-thread\" aria-label=\"Back\" \nng-click=\"vm.closeUsers()\" ng-if=\"vm.currentView==\'nosplit\' && vm.groupsView\" translate \ntranslate-attr-aria-label=\"CONTENT.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><div \nlayout=\"row\" class=\"search-bar\"><md-icon ng-click=\"vm.showSearch = true;\" id=\"ms-search-bar-expander\" \nmd-font-icon=\"icon-magnify\" class=\"md-icon-button md-button\"><md-tooltip hide show-gt-xs><span>\n{{\'TOOLBAR.SEARCH_NAME\' | translate}}</span></md-tooltip></md-icon><input id=\"ms-search-bar-input\" type=\"text\" \nng-model=\"vm.searchQuery\" placeholder=\"Search\" md-autofocus translate translate-attr-placeholder=\"TOOLBAR.SEARCH_NAME\" \nflex ng-enter=\"vm.searchLocal(vm.searchQuery)\"><md-icon id=\"ms-search-bar-collapser\" \nng-click=\"vm.showSearch = false; vm.searchQuery = \'\';\" md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></div>\n<md-menu-bar class=\"pr-0 pl-0\" hide show-gt-xs><md-menu><md-button class=\"menu-button-custom\" aria-label=\"Actions\" \nng-click=\"$mdMenu.open($event)\" layout=\"row\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"mr-5\"></md-icon><span class=\"text-uppercase grey-600-fg\">{{\'USERS.ACTIONS\' | translate}}</span></md-button>\n<md-menu-content><md-menu-item><md-menu><md-button aria-label=\"Filters\" ng-click=\"$mdMenu.open($event)\"><md-icon \nmd-font-icon=\"icon-sort\"></md-icon><span translate=\"CONTENT.ORDER_BY\">Order by</span></md-button><md-menu-content>\n<md-menu-item ng-if=\"vm.fieldOrder != undefined\"><md-button ng-click=\"vm.resetSortField()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon><span translate=\"CONTENT.REMOVE_ORDER\">Remove order</span></md-button>\n</md-menu-item><md-menu-item ng-repeat=\"field in vm.refcolumns\"><md-button \nng-click=\"vm.setSortField(field.field_name)\"><div layout=\"row\" layout-align=\"space-between center\"><span>\n{{field.title}}</span> <i class=\"icon-check s16\" ng-if=\"vm.fieldOrder === field.field_name\"></i></div></md-button>\n</md-menu-item></md-menu-content></md-menu></md-menu-item><md-menu-item><md-button ng-click=\"vm.setSortOrder(\'ASC\')\">\n<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start between\"><md-icon \nmd-font-icon=\"icon-sort-ascending\"></md-icon><span translate=\"CONTENT.DIRECTION_A_Z\">Order A-Z</span></div><i \nclass=\"icon-check s16\" ng-if=\"vm.getSettingValue(vm.settingsSection, \'sortDir\', sortDir) === \'ASC\'\"></i></div>\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.setSortOrder(\'DESC\')\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start between\"><md-icon \nmd-font-icon=\"icon-sort-descending\"></md-icon><span translate=\"CONTENT.DIRECTION_Z_A\">Order Z-A</span></div><i \nclass=\"icon-check s16\" ng-if=\"vm.getSettingValue(vm.settingsSection, \'sortDir\', sortDir) === \'DESC\'\"></i></div>\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.exportAnalytics()\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start between\"><md-icon md-font-icon=\"icon-export\">\n</md-icon><span translate=\"USERS.EXPORT\">Export</span></div></div></md-button></md-menu-item></md-menu-content>\n</md-menu></md-menu-bar><md-input-container><label>Races</label><md-select ng-model=\"vm.selectedRaces\" \nmultiple=\"multiple\"><md-option ng-value=\"opt\" ng-repeat=\"opt in vm.refFiltersGrouped.race\">{{opt.field_name}}\n</md-option></md-select></md-input-container><md-input-container ng-if=\"!vm.qiuRestrictedTenantGroup\"><label>Tenants\n</label><md-select ng-model=\"vm.selectedTenants\" multiple=\"multiple\"><md-option ng-value=\"opt.title\" \nng-repeat=\"opt in vm.refFiltersGrouped.tenant\">{{opt.field_name}}</md-option></md-select></md-input-container>\n<md-datepicker ng-model=\"vm.fromDate\" md-placeholder=\"From\"></md-datepicker><md-datepicker ng-model=\"vm.toDate\" \nmd-placeholder=\"To\"></md-datepicker><div layout=\"row\" layout-align=\"start center\" \ntranslate-attr-aria-label=\"CONTENT.REFRESH\"><md-menu-bar class=\"pr-0 pl-0\" hide-gt-xs><md-menu><md-button \nclass=\"md-icon-button\" aria-label=\"Actions\" ng-click=\"$mdMenu.open($event)\" layout=\"row\" layout-align=\"center center\">\n<md-icon md-font-icon=\"icon-cog\" class=\"mr-5\"></md-icon></md-button><md-menu-content><md-menu-item><md-menu><md-button \naria-label=\"Filters\" ng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-format-list-bulleted\"></md-icon><span>\nGroup by</span></md-button><md-menu-content><md-menu-item ng-if=\"vm.groupBy != undefined\"><md-button \nng-click=\"vm.resetGroupby()\"><md-icon md-font-icon=\"icon-close\"></md-icon><span translate=\"CONTENT.REMOVE_GROUP_BY\">\nRemove group by</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.setGroupBy(\'firstname\')\">\nFirstname</md-button></md-menu-item></md-menu-content></md-menu></md-menu-item><md-menu-item><md-menu><md-button \naria-label=\"Filters\" ng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-sort\"></md-icon><span \ntranslate=\"CONTENT.ORDER_BY\">Order by</span></md-button><md-menu-content><md-menu-item \nng-if=\"vm.fieldOrder != undefined\"><md-button ng-click=\"vm.resetSortField()\"><md-icon md-font-icon=\"icon-close\">\n</md-icon><span translate=\"CONTENT.REMOVE_ORDER\">Remove order</span></md-button></md-menu-item><md-menu-item \nng-repeat=\"field in vm.refcolumns\"><md-button ng-click=\"vm.setSortField(field.title)\"><div layout=\"row\" \nlayout-align=\"space-between center\"><span>{{field.field_name}}</span> <i class=\"icon-check s16\" \nng-if=\"vm.fieldOrder === field.field_name\"></i></div></md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.setSortOrder(\'ASC\')\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start between\"><md-icon \nmd-font-icon=\"icon-sort-ascending\"></md-icon><span translate=\"CONTENT.DIRECTION_A_Z\">Order A-Z</span></div><i \nclass=\"icon-check s16\" ng-if=\"sortDir === \'ASC\'\"></i></div></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.setSortOrder(\'DESC\')\"><div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start between\"><md-icon md-font-icon=\"icon-sort-descending\"></md-icon><span \ntranslate=\"CONTENT.DIRECTION_Z_A\">Order Z-Z</span></div><i class=\"icon-check s16\" ng-if=\"sortDir === \'DESC\'\"></i></div>\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.exportAnalytics()\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start between\"><md-icon \nmd-font-icon=\"icon-sort-descending\"></md-icon><span translate=\"USERS.EXPORT\">Export</span></div></div></md-button>\n</md-menu-item></md-menu-content></md-menu></md-menu-bar></div></div>");
$templateCache.put("app/main/apps/social/social-posts/views/list/list-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-show=\"isLoading\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nclass=\"mail-list-item filter-selected\" ng-if=\"sortField\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\" flex><div class=\"info\" ng-if=\"sortField\"><div class=\"name\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-sort-ascending\" class=\"s20 mr-5 ml-0 mb-0\" \nng-if=\"sortDir === \'ASC\'\"></md-icon><md-icon md-font-icon=\"icon-sort-descending\" class=\"s20 mr-5 ml-0 mb-0\" \nng-if=\"sortDir === \'DESC\'\"></md-icon><div class=\"title text-truncate\" layout=\"row\" layout-align=\"start center\">\nOrdered by \'{{sortField}}\'</div></div></div></div><div class=\"buttons\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-close s20\" ng-click=\"pagination_resetOrderBy()\" class=\"ml-10\"><md-tooltip hide show-gt-xs>\n<span translate=\"FORMS.REMOVE\">Remove</span></md-tooltip></md-icon></div></div><div class=\"no-threads\" \nng-if=\"!isLoading && vm.threads.length === 0\" ng-hide=\"isLoading\" translate=\"FORMS.NO_ITEMS\">There are no items!</div>\n<div id=\"list-content-data\" ng-style=\"{\'opacity\' : isLoading ? 0.2 : 1}\" ms-scroll=\"vm.msScrollOptions\" \nng-class=\"{\'group-filter\': vm.selectedGroup,\'other-filter\':sortField}\" class=\"scrollable\" ng-if=\"vm.threads.length> 0\">\n<div with=\"vm.threads\" as=\"socialPosts\" ng-include=\"\'app/core/directives/ms-social-list/social-posts-template.html\'\">\n</div><div class=\"toolbar\" layout=\"row\" layout-align=\"end center\"><div layout=\"row\" layout-align=\"center center\" \nng-style=\"{\'display\' : isLoading ? \'none\' : \'block\'}\"><span class=\"page-info\">{{pagination_totalItems}} items found.\n</span><md-button aria-label=\"Previous\" class=\"md-icon-button arrow\" ng-click=\"pagination_prevPage()\" \nng-disabled=\"pagination_firstPage()\" translate=\"\" translate-attr-aria-label=\"FORMS.PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span translate=\"FORMS.PREVIOUS\">Previous</span></md-tooltip>\n</md-button><span class=\"page-info\">{{pagination_page}} / {{pagination_total_pages}}</span><md-button \naria-label=\"Next\" class=\"md-icon-button arrow\" ng-click=\"pagination_nextPage()\" \nng-disabled=\"pagination_morePages() || pagination_total_pages === pagination_page\" translate=\"\" \ntranslate-attr-aria-label=\"FORMS.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span \ntranslate=\"FORMS.NEXT\">Next</span></md-tooltip></md-button></div></div></div>");
$templateCache.put("app/main/apps/social/social-posts/views/list/nosplit-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/social/social-posts/views/list/toolbar.html\'\"></div><div class=\"content-wrapper\" flex=\"\" \nlayout=\"row\"><div class=\"content thread-list mail-list-pane\" flex=\"\" id=\"thread-list\" \nng-include=\"\'app/main/apps/social/social-posts/views/list/list-view.html\'\"></div></div>");
$templateCache.put("app/main/apps/social/social-posts/views/list/toolbar.html","<div layout=\"row\" layout-align=\"start center\"></div><div layout=\"row\" layout-align=\"start center\" \ntranslate-attr-aria-label=\"FORMS.REFRESH\"><span class=\"page-info\" hide show-gt-xs>\n{{pagination_totalItems}} items found.</span><md-button aria-label=\"Previous\" class=\"md-icon-button arrow\" hide \nng-click=\"pagination_prevPage()\" ng-disabled=\"pagination_firstPage()\" show-gt-xs translate \ntranslate-attr-aria-label=\"FORMS.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span \ntranslate=\"FORMS.PREVIOUS\">Previous</span></md-tooltip></md-button><span class=\"page-info\" hide show-gt-xs>\n{{pagination_page}} / {{pagination_total_pages}}</span><md-button aria-label=\"Next\" class=\"md-icon-button arrow\" hide \nng-click=\"pagination_nextPage()\" ng-disabled=\"pagination_morePages()\" show-gt-xs translate \ntranslate-attr-aria-label=\"FORMS.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span \ntranslate=\"FORMS.NEXT\">Next</span></md-tooltip></md-button><md-menu class=\"settings-menu\" hide-gt-xs \nng-show=\"vm.selectedThreads.length > 0\"><md-button aria-label=\"Settings\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\" translate translate-attr-aria-label=\"FORMS.SETTINGS\"><md-icon \nmd-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content><md-menu-item><md-menu-item><md-button \nng-click=\"vm.massActions(\'delete\')\" aria-label=\"Delete\" translate-aria-label=\"FORMS.DELETE\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><span translate=\"FORMS.DELETE\">Delete </span><span translate=\"FORMS.SELECTED\">\nSelected</span></md-button></md-menu-item></md-menu-item></md-menu-content></md-menu></div>");
$templateCache.put("app/main/apps/users/analytics/views/read/read-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-if=\"vm.loadingReadPane\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nng-show=\"!vm.loadingReadPane\"><div style=\"z-index: 99; background-color: white\" class=\"mail-content\" layout=\"column\" \nlayout-align=\"center center\" ng-if=\"!vm.selectedContent\"><div class=\"content\" layout=\"column\" \nlayout-align=\"top center\"><div class=\"message\">Please select an item to show in this panel</div></div></div><div \nclass=\"toolbar grey-100-bg colored-bg\" layout=\"row\" layout-align=\"space-between center\" ng-if=\"vm.selectedContent\" \nscroll=\"\"><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button close-thread\" \naria-label=\"Back\" ng-click=\"vm.closeThread()\" \nng-if=\"vm.currentThread && (vm.currentView==\'nosplit\' || vm.groupsView) \" translate \ntranslate-attr-aria-label=\"CONTENT.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button>\n<md-button class=\"md-icon-button close-thread\" ng-if=\"vm.currentView === \'table\'\" aria-label=\"Back\" \nng-click=\"vm.closeThread()\" translate translate-attr-aria-label=\"CONTENT.BACK\"><md-icon \nmd-font-icon=\"icon-arrow-right\"></md-icon></md-button><div class=\"divider-vertical\" hide=\"\" \nng-if=\"vm.activeMailPaneIndex === 1 || vm.currentView === \'table\'\" show-gt-sm=\"\"></div><md-button aria-label=\"Preview\" \nclass=\"md-icon-button\" ng-class=\"{\'md-accent\':vm.currentTab == \'preview\'}\" ng-click=\"vm.viewPreview()\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.PREVIEW\"><md-icon md-font-icon=\"icon-eye\"></md-icon><md-tooltip hide show-gt-xs>\n<span translate=\"CONTENT.PREVIEW\">Preview</span></md-tooltip></md-button></div><div layout=\"row\" \nlayout-align=\"end center\" ng-if=\"vm.currentThread_Edit && vm.currentTab !== \'activity\' && vm.currentTab !== \'preview\'\">\n<md-button type=\"submit\" ng-click=\"vm.saveItem(vm.currentThread_Edit)\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.basicForm.$invalid || vm.basicForm.$pristine\" aria-label=\"SAVE\" translate=\"CONTENT.SAVE\" \ntranslate-attr-aria-label=\"CONTENT.SAVE\">SAVE</md-button><md-button type=\"button\" ng-click=\"vm.closeThreadEdit()\" \nclass=\"md-raised md-warn\" aria-label=\"Cancel\">Cancel</md-button></div></div><md-content flex=\"\" \nng-show=\"vm.selectedContent && !vm.editInline && vm.currentTab === \'preview\'\"><div \nclass=\"mail-content file-details scrollable\" ms-scroll=\"vm.msScrollOptions\"><md-list><md-list-item class=\"info\" \nng-if=\"vm.selectedContent_refgrouped.header[0]\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\" \nlayout-align=\"start start\"><div ng-repeat=\"field in vm.selectedContent_refgrouped.header | orderBy:\'preview_sort\' \" \nclass=\"header-element\" layout=\"row\" layout-align=\"center center\"><div><span ng-if=\"field.type==\'user_status\'\"><button \nng-if=\"vm.selectedContent[field.title]===0\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\"></md-icon></button> <button \nng-if=\"vm.selectedContent[field.title]===1\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-minus-circle\" \nclass=\"on amber-400-fg s24\"></md-icon></button> <button ng-if=\"vm.selectedContent[field.title]===2\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\"></md-icon></button> \n<button ng-if=\"vm.selectedContent[field.title]===99\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle\" class=\"on black-fg s24\"></md-icon></button> <button \nng-if=\"vm.selectedContent[field.title]!==0 && vm.selectedContent[field.title]!==1 && vm.selectedContent[field.title]!==2 && vm.selectedContent[field.title]!==99\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"on grey-fg s24\"></md-icon></button> \n</span><span ng-if=\"field.type==\'dateHm\' || field.type==\'date\'\"><span>{{vm.selectedContent[field.title].dateShow}}\n</span> </span><span ng-if=\"field.type==\'language\'\" layout=\"row\" layout-align=\"center center\"><img \nclass=\"img-flag ng-scope\" alt=\"{{vm.siteLanguages(vm.selectedContent[field.title])[lang_name]}}\" \nng-src=\"assets/images/flags/{{vm.siteLanguages()[vm.selectedContent[field.title]].flag_code|lowercase}}.svg\"> </span>\n<span ng-if=\"field.type==\'id_subsec\' && vm.selectedContent[field.title].length!=0\"><span class=\"grey-500-fg\">\n{{field.field_name}} </span><span \nng-bind=\"vm.getReferencesSections(\'subsection\', field.type, vm.selectedContent[field.title])\"></span> </span><span \nng-if=\"field.type==\'id_cat\' && vm.selectedContent[field.title].length!=0\"><span class=\"grey-500-fg\">\n{{field.field_name}} </span><span \nng-bind=\"vm.getReferencesSections(\'cat\', field.type, vm.selectedContent[field.title])\"></span> </span><span \nng-if=\"field.type==\'id_subcat\' && vm.selectedContent[field.title].length!=0\"><span class=\"grey-500-fg\">\n{{field.field_name}} </span><span \nng-bind=\"vm.getReferencesSections(\'subcat\', field.type, vm.selectedContent[field.title])\"></span></span></div></div>\n</div></md-list-item><md-list-item class=\"main-item\"><div class=\"main-read\"><div class=\"avatar-container\"><div \nng-if=\"vm.selectedContent.avatar == \'\' || !vm.selectedContent.avatar\" class=\"avatar {{vm.selectedColor}}\" \nng-bind=\"vm.selectedContent[\'firstname\'] | capitalizeFirstLetter\"></div><div \nng-if=\"vm.selectedContent.avatar && vm.selectedContent.avatar !== \'\'\" class=\"avatar\"><img \nng-src=\"{{vm.selectedContent.avatar}}\" alt=\"\"></div><div \nng-repeat=\"field in vm.selectedContent_refgrouped.user_status | orderBy:\'preview_sort\' \" class=\"status\"><span \nng-if=\"field.type==\'user_status\'\"><button ng-if=\"vm.selectedContent[field.title]===0\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\"></md-icon></button> <button \nng-if=\"vm.selectedContent[field.title]===1\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-minus-circle\" \nclass=\"on amber-400-fg s24\"></md-icon></button> <button ng-if=\"vm.selectedContent[field.title]===2\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\"></md-icon></button> \n<button ng-if=\"vm.selectedContent[field.title]===99\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle\" class=\"on black-fg s24\"></md-icon></button> <button \nng-if=\"vm.selectedContent[field.title]!==0 && vm.selectedContent[field.title]!==1 && vm.selectedContent[field.title]!==2 && vm.selectedContent[field.title]!==99\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"on grey-fg s24\"></md-icon></button>\n</span></div></div></div><div class=\"main-read\" layout=\"column\" layout-align=\"center start \"><div \nng-repeat=\"field in vm.selectedContent_refgrouped.header_main | orderBy:\'preview_sort\' \" class=\"header-element\" \nlayout=\"row\" layout-align=\"center center\"><p ng-if=\"field.type==\'id\'\" class=\"font-size-14\"><span class=\"grey-500-fg\">\nID # </span><span class=\"grey-500-fg\" ng-bind=\"vm.selectedContent[field.field_name]\"></span></p></div><h1 class=\"name\">\n<strong ng-repeat=\"field in vm.selectedContent_refgrouped.main | orderBy:\'preview_sort\' \" \nng-bind=\"vm.selectedContent[field.field_name]\" class=\"mr-10\"></strong></h1></div><md-divider></md-divider>\n</md-list-item><div ng-repeat=\"field in vm.selectedContent_refgrouped.secondary | orderBy:\'preview_sort\' \">\n<md-list-item class=\"md-toolbar-tools grey-100-bg\" ng-if=\"field.type==\'label\'\"><h3 class=\"grey-700-fg\" \nng-bind=\"field.field_name\"></h3><md-divider></md-divider></md-list-item><md-list-item class=\"md-toolbar-tools\" \nng-if=\"field.category == \'show_groups_as_field\'\"><div class=\"text-truncate\"><div class=\"field\"><p \nclass=\"grey-500-fg font-size-14\" ng-bind=\"field.field_name\"></p><span style=\"white-space: nowrap\" \nclass=\"font-size-16 text-truncate\">{{vm.getGroupNames(field)}}</span><br></div><md-divider></md-divider></div>\n</md-list-item><md-list-item flex=\"100\" \nng-if=\"field.type!==\'label\' && field.category !== \'show_groups_as_field\' && !(field.hide_if_empty && !vm.selectedContent[field.field_name])\">\n<div class=\"text-truncate\" flex=\"100\"><div class=\"field\"><p class=\"grey-500-fg font-size-14\" \nng-bind=\"field.field_name\"></p><span \nng-if=\"field.category!=\'input_related\' && vm.isNumber(vm.selectedContent[field.field_name])\" \nclass=\"font-size-16 text-truncate\" ng-bind-html=\"vm.selectedContent[field.field_name]\"></span> <span \nng-if=\"field.category!=\'input_related\' && vm.hasDateShow(vm.selectedContent[field.field_name])\" \nclass=\"font-size-16 text-truncate\" ng-bind-html=\"vm.hasDateShow(vm.selectedContent[field.field_name])\"></span> <span \nng-if=\"field.category!=\'input_related\' && !vm.isNumber(vm.selectedContent[field.field_name]) && !vm.hasDateShow(vm.selectedContent[field.field_name]) && vm.selectedContent[field.field_name]\" \nclass=\"font-size-16 text-truncate\" ng-bind-html=\"vm.selectedContent[field.field_name]\"></span> <span \nng-if=\"field.category!=\'input_related\' && !vm.isNumber(vm.selectedContent[field.field_name]) && !vm.selectedContent[field.field_name]\" \nclass=\"font-size-16 text-truncate\">-</span> <span ng-if=\"field.category==\'input_related\'\" \nclass=\"font-size-16 text-truncate\">\n{{vm.getInArray(\'id_\'+field.config,field.values, vm.selectedContent[field.field_name], field.config)}}</span><br></div>\n<md-divider></md-divider></div></md-list-item></div><div ng-repeat=\"eventsGroup in vm.eventsGrouped\"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg\" ng-if=\"eventsGroup.events.length > 0\"><h3 class=\"grey-700-fg\" \nng-bind=\"eventsGroup.name\"></h3><md-divider></md-divider></md-list-item><md-list-item flex=\"100\" \nng-repeat=\"event in eventsGroup.events\" class=\"events\"><div class=\"text-truncate\" flex=\"100\"><div class=\"event\"><p \nclass=\"grey-500-fg font-size-14\" ng-bind=\"event.date | date: \'HH:mm:ss\'\"></p><span class=\"font-size-16 text-truncate\">\n{{event.pathName}}</span> <span class=\"grey-500-fg font-size-16 pl-30 text-truncate\" ng-if=\"event.extra\">\n{{vm.showExtra(event.extra)}}</span><br></div><md-divider></md-divider></div></md-list-item></div></md-list></div>\n</md-content></div>");
$templateCache.put("app/main/apps/social/social-posts/views/read/read-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-show=\"vm.loadingReadPane\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nng-show=\"!vm.loadingReadPane\"><div class=\"mail-content\" layout=\"column\" layout-align=\"center center\" \nng-if=\"!vm.selectedContent\"><div class=\"content\" layout=\"column\" layout-align=\"top center\"><div class=\"message\" \ntranslate=\"FORMS.NO_ITEM_SELECTED_PANEL\"></div></div></div><div class=\"toolbar grey-100-bg colored-bg\" layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"vm.selectedContent\" scroll=\"\"><div layout=\"row\" layout-align=\"start center\">\n<md-button class=\"md-icon-button close-thread\" aria-label=\"Back\" ng-click=\"vm.closeThread()\" translate \ntranslate-attr-aria-label=\"FORMS.BACK\" ng-if=\"vm.currentView === \'nosplit\'\"><md-icon md-font-icon=\"icon-arrow-left\">\n</md-icon></md-button></div><div layout=\"row\" layout-align=\"end center\" ng-if=\"vm.selectedContent\" hide show-gt-sm>\n<md-button type=\"submit\" ng-click=\"vm.saveItem(vm.selectedContent)\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.basicForm.$invalid || vm.basicForm.$pristine && vm.noexistchangues\" aria-label=\"SAVE\" \ntranslate=\"FORMS.SAVE\" translate-attr-aria-label=\"FORMS.SAVE\">SAVE</md-button><md-button type=\"button\" \nng-click=\"vm.closeThreadEdit()\" class=\"md-raised md-warn\" aria-label=\"Cancel\">Cancel</md-button></div><div \nlayout=\"row\" layout-align=\"end center\" ng-if=\"vm.selectedContent\" hide-gt-sm><md-button type=\"submit\" \nng-click=\"vm.saveItem(vm.selectedContent)\" class=\"md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme\" \nng-disabled=\"vm.basicForm.$invalid || vm.basicForm.$pristine && vm.noexistchangues\" aria-label=\"SAVE\"><md-icon \nmd-font-icon=\"icon-check\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"FORMS.SAVE\">Save</span></md-tooltip>\n</md-button><md-button type=\"button\" ng-click=\"vm.closeThreadEdit()\" \nclass=\"md-warn md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme\" aria-label=\"Cancel\"><md-icon \nmd-font-icon=\"icon-window-close\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"FORMS.CANCEL\">Cancel</span>\n</md-tooltip></md-button></div></div><form name=\"vm.basicForm\" class=\"md-inline-form\" novalidate><md-content flex=\"\" \nng-if=\"vm.selectedContent && !vm.editInline\"><div class=\"mail-content file-details scrollable\" \nms-scroll=\"vm.msScrollOptions\"><md-list class=\"pb-0\"><md-list-item class=\"info\" layout=\"row\" \nlayout-align=\"start center\"><div layout=\"row\" layout-align=\"start start\"><div class=\"header-element\" layout=\"row\" \nlayout-align=\"center center\"><div><span class=\"grey-500-fg\">ID # </span><span ng-bind=\"vm.selectedContent.id\"></span>\n</div></div></div></md-list-item><md-list-item><md-input-container fill-width class=\"md-block margin-0\"><label \ntranslate=\"FORMS.TITLE\"></label><textarea ng-model=\"vm.selectedContent.title\" columns=\"1\" rows=\"1\"></textarea>\n</md-input-container></md-list-item></md-list><md-list><md-list-item \nclass=\"md-toolbar-tools grey-100-bg md-no-proxy _md\" role=\"listitem\" style=\"border-top: 1px solid gainsboro\"><h3 \nclass=\"grey-700-fg\" translate=\"FORMS.FIELDS\"></h3><md-divider></md-divider></md-list-item></md-list><md-list \ndragula=\"\'element\'\" dragula-model=\"vm.selectedContent.form_data.fields\"><md-list-item \nng-show=\"field.type !== \'media_footer\' && field.type !== \'media_header\'\" \nng-repeat=\"field in vm.selectedContent.form_data.fields track by $index\" class=\"md-block structure\" \nng-class=\"(!field.temporary && !field.editing) ? \'md-block structure\' : \'structure-edited\'\"><div layout=\"column\" \nlayout-align=\"center space-between\" flex><div ng-include=\"\'app/main/apps/forms/views/editors/editors-view.html\'\"></div>\n<div ng-include=\"\'app/main/apps/forms/views/editors/editors-editing.html\'\"></div></div><md-divider \nclass=\"md-default-theme\"></md-divider></md-list-item></md-list><md-input-container layout=\"row\" \nlayout-align=\"end center\" flex=\"\" class=\"pr-15\" ng-click=\"vm.addNewStructureField()\"><button \nclass=\"add-event-button md-fab md-warn md-button md-default-theme\" type=\"button\" aria-label=\"ADD\"><md-icon \nmd-font-icon=\"icon-plus\" role=\"img\" aria-hidden=\"true\"></md-icon></button></md-input-container></div></md-content>\n</form></div>");
$templateCache.put("app/main/apps/users/dialogs/in-groups/copy-move-to-group-dialog/copy-move-to-group-dialog.html","<md-dialog class=\"copy-move-togroup\" style=\"width: 90%;max-width: 600px;min-width: 320px\" aria-label=\"New Message\">\n<form class=\"md-inline-form\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><h1 class=\"title\" translate=\"USERS.COPY_TO_GROUPS\" \nng-if=\"vm.selectedAction == vm.actionCopy\"></h1><h1 class=\"title\" translate=\"USERS.MOVE_TO_GROUPS\" \nng-if=\"vm.selectedAction == vm.actionMove\"></h1><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><div flex layout=\"column\" \nlayout-align=\"center center\" ng-if=\"vm.loading\" class=\"loading-container\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><md-dialog-content \nng-style=\"{\'opacity\' : vm.loading ? 0.2 : 1}\" id=\"site-mailing\" ms-scroll flex class=\"content-card\" \nng-include=\"vm.viewUsersGroup\"></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\">\n<md-input-container flex layout=\"row\" layout-align=\"end center\" class=\"m-0\"><md-button type=\"button\" \nclass=\"md-raised md-warn\" ng-click=\"vm.closeDialog()\" translate=\"GROUP.CANCEL\"></md-button><md-button \nng-if=\"vm.selectedAction == vm.actionCopy\" ng-disabled=\"vm.loading\" type=\"submit\" \nclass=\"send-button md-accent md-raised\" ng-click=\"vm.runAction()\" translate=\"USERS.COPY\"></md-button><md-button \nng-if=\"vm.selectedAction == vm.actionMove\" ng-disabled=\"vm.loading\" type=\"submit\" \nclass=\"send-button md-accent md-raised\" ng-click=\"vm.runAction()\" translate=\"USERS.MOVE\"></md-button>\n</md-input-container></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/users/dialogs/groups/views/tree-view.html","<md-toolbar class=\"md-default-theme grey-100-bg grey-600-fg\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\"><label for=\"search-bar-input\"><md-icon ng-if=\"!vm.treeSearch\" md-font-icon=\"icon-magnify\" \nstyle=\"padding-top: 20px\" class=\"grey-600-fg md-icon-button md-button\"><md-tooltip hide show-gt-xs><span \ntranslate=\"TOOLBAR.SEARCH\">Search</span></md-tooltip></md-icon></label><md-icon layout-align=\"center center\" \nmd-font-icon=\"icon-close-circle\" class=\"grey-600-fg md-icon-button md-button\" ng-if=\"vm.treeSearch\" \nng-click=\"vm.treeSearch = null\"></md-icon><input type=\"text\" id=\"search-bar-input\" class=\"grey-600-fg grey-100-bg\" \nng-model=\"vm.treeSearch\" placeholder=\"Search\" md-autofocus translate translate-attr-placeholder=\"TOOLBAR.SEARCH\" flex>\n</div></md-toolbar><div ng-if=\"vm.usersGroups\" ivh-treeview=\"vm.usersGroups\" class=\"treeview groups\" \nivh-treeview-filter=\"vm.treeSearch\" ivh-treeview-on-cb-change=\"vm.checkGroup(ivhNode, ivhIsSelected, ivhTree)\" \nng-init=\"vm.treeIsLoaded = true\"><script type=\"text/ng-template\">\n<div class=\"level-card ph-8 group-row\" style=\"padding-top: 10px;padding-bottom: 10px;\" layout=\"row\" layout-align=\"space-between stretch\">\r\n            <span ivh-treeview-twistie ivh-treeview-toggle layout=\"row\" layout-align=\"center center\" class=\"mr-8\"></span>\r\n            <div flex id=\"treeview-group-{{node.id_group}}\" qiu-users-on-click-load-users-by-groups data-group-node={{node}} layout=\"row\" layout-align=\"start center\">\r\n                <div ng-if=\"node.group_type.icon\">\r\n                    <md-icon ng-if=\"node.group_type.icon\"\r\n                        class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                        md-font-icon=\"{{node.group_type.icon}}\"\r\n                        aria-hidden=\"true\" >\r\n                    </md-icon>\r\n                </div>\r\n                <div ng-if=\"!node.group_type.icon\">\r\n                    <md-icon ng-if=\"!node.children && node.id_group_type == 1\"\r\n                        class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                        md-font-icon=\"icon-folder\"\r\n                        aria-hidden=\"true\" >\r\n                    </md-icon>\r\n                    <md-icon\r\n                        ng-if=\"node.children && node.id_group_type == 1\"\r\n                        class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                        md-font-icon=\"icon-folder-multiple\"\r\n                        aria-hidden=\"true\" >\r\n                    </md-icon>\r\n                    <md-icon ng-if=\"!node.children && node.id_group_type == 2\"\r\n                        class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                        md-font-icon=\"qiu-icon-file-usermailing\"\r\n                        aria-hidden=\"true\" >\r\n                    </md-icon>\r\n                    <md-icon\r\n                        ng-if=\"node.children && node.id_group_type == 2\"\r\n                        class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                        md-svg-src=\"/assets/icons/svg/icon-folder-mail-multiple.svg\"\r\n                        aria-hidden=\"true\" >\r\n                    </md-icon>\r\n                    <md-icon ng-if=\"!node.children && node.id_group_type == 3\"\r\n                        class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                        md-font-icon=\"qiu-icon-file-usermediacenter\"\r\n                        aria-hidden=\"true\" >\r\n                    </md-icon>\r\n                    <md-icon\r\n                        ng-if=\"node.children && node.id_group_type == 3\"\r\n                        class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                        md-svg-src=\"/assets/icons/svg/icon-folder-play-multiple.svg\"\r\n                        aria-hidden=\"true\" >\r\n                    </md-icon>\r\n                    <md-icon ng-if=\"!node.children && node.id_group_type == 4\"\r\n                        class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                        md-font-icon=\"qiu-icon-file-usersegment\"\r\n                        aria-hidden=\"true\" >\r\n                    </md-icon>\r\n                    <md-icon\r\n                        ng-if=\"node.children && node.id_group_type == 4\"\r\n                        class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                        md-svg-src=\"/assets/icons/svg/icon-folder-share-multiple.svg\"\r\n                        aria-hidden=\"true\" >\r\n                    </md-icon>\r\n                    <md-icon ng-if=\"!node.children && node.id_group_type == 5\"\r\n                        class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                        md-font-icon=\"qiu-icon-file-userstore\"\r\n                        aria-hidden=\"true\" >\r\n                    </md-icon>\r\n                    <md-icon\r\n                        ng-if=\"node.children && node.id_group_type == 5\"\r\n                        class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                        md-svg-src=\"/assets/icons/svg/icon-folder-shop-multiple.svg\"\r\n                        aria-hidden=\"true\" >\r\n                    </md-icon>\r\n                    <md-icon ng-if=\"!node.children && node.id_group_type == 6\"\r\n                        class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                        md-font-icon=\"qiu-icon-file-useracreditation\"\r\n                        aria-hidden=\"true\" >\r\n                    </md-icon>\r\n                    <md-icon\r\n                        ng-if=\"node.children && node.id_group_type == 6\"\r\n                        class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                        md-svg-src=\"/assets/icons/svg/icon-folder-board-multiple.svg\"\r\n                        aria-hidden=\"true\" >\r\n                    </md-icon>\r\n                    <md-icon ng-if=\"!node.children && node.id_group_type == 7\"\r\n                        class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                        md-svg-src=\"/assets/icons/svg/icon-folder-chat.svg\"\r\n                        aria-hidden=\"true\" >\r\n                    </md-icon>\r\n                    <md-icon\r\n                        ng-if=\"node.children && node.id_group_type == 7\"\r\n                        class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                        md-svg-src=\"/assets/icons/svg/icon-folder-chat-multiple.svg\"\r\n                        aria-hidden=\"true\" >\r\n                    </md-icon>\r\n                    <md-icon ng-if=\"!node.children && node.id_group_type == 8\"\r\n                        class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                        md-font-icon=\"icon-folder-remove\"\r\n                        aria-hidden=\"true\" >\r\n                    </md-icon>\r\n                    <md-icon\r\n                        ng-if=\"node.children && node.id_group_type == 8\"\r\n                        class=\"{{node.color}}-fg s24 mr-10 mt-0 ml-0 mb-0 \"\r\n                        md-font-icon=\"icon-folder-multiple\"\r\n                        aria-hidden=\"true\" >\r\n                    </md-icon>\r\n                </div>\r\n                <span class=\"ivh-treeview-node-label\" ivh-treeview-toggle>{{node.name}}</span>\r\n            </div>\r\n            <div layout=\"row\" layout-align=\"end center\" class=\"ml-10\">\r\n                <md-select\r\n                    qiu-users-on-change-set-in-group-status\r\n                    ng-model=\"idIngroupStatus\"\r\n                    placeholder=\"Select a status\"\r\n                    ng-hide=\"!node.ingroup_status\"\r\n                    class=\"mr-10 mv-0\"\r\n                    hide show-gt-xs>\r\n                    <md-option\r\n                        ng-value=\"status.id_ingroup_status\"\r\n                        ng-selected=\"status.id_ingroup_status == node.id_ingroup_status\"\r\n                        ng-repeat=\"status in node.ingroup_status\"\r\n                        translate=\"USERS.INGROUP.STATUS.{{status.name | uppercase}}\" />\r\n                </md-select>\r\n                <md-select\r\n                    qiu-users-on-change-set-in-group-status\r\n                    ng-model=\"idIngroupStatus\"\r\n                    placeholder=\"Status\"\r\n                    ng-hide=\"!node.ingroup_status\"\r\n                    class=\"mr-10 mv-0\"\r\n                    hide-gt-xs>\r\n                    <md-option\r\n                        ng-value=\"status.id_ingroup_status\"\r\n                        ng-selected=\"status.id_ingroup_status == node.id_ingroup_status\"\r\n                        ng-repeat=\"status in node.ingroup_status\"\r\n                        translate=\"USERS.INGROUP.STATUS.{{status.name | uppercase}}\" />\r\n                </md-select>\r\n                <md-checkbox\r\n                    aria-label=\"assign group\"\r\n                    qiu-users-on-check-toggle-assigned-group\r\n                    class=\"ml-5 mb-0\" />\r\n            </div>\r\n        </div>\r\n        <div ivh-treeview-children />\n</script></div>");
$templateCache.put("app/main/apps/users/users-temporary/views/list/list-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-if=\"isLoading\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nclass=\"mail-list-item filter-selected\" ng-if=\"vm.selectedGroup\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"info\" flex><div class=\"name\" layout=\"row\" layout-align=\"start center\"><md-icon \nng-if=\"!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 1\" md-font-icon=\"icon-folder\" \nclass=\"orange-300-fg s20 mr-8 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 2\" md-font-icon=\"qiu-icon-file-usermailing\" \nclass=\"orange-300-fg s20 mr-8 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"vm.selectedGroup.children && vm.selectedGroup.id_group_type == 2\" \nmd-svg-src=\"/assets/icons/svg/icon-folder-mail-multiple.svg\" class=\"orange-300-fg s20 mr-8 ml-0 mb-0\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 3\" \nmd-font-icon=\"qiu-icon-file-usermediacenter\" class=\"orange-300-fg s20 mr-8 ml-0 mb-0\" aria-hidden=\"true\"></md-icon>\n<md-icon ng-if=\"vm.selectedGroup.children && vm.selectedGroup.id_group_type == 3\" \nmd-svg-src=\"/assets/icons/svg/icon-folder-play-multiple.svg\" class=\"orange-300-fg s20 mr-8 ml-0 mb-0\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 4\" \nmd-font-icon=\"qiu-icon-file-usersegment\" class=\"orange-300-fg s20 mr-8 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon\n ng-if=\"vm.selectedGroup.children && vm.selectedGroup.id_group_type == 4\" \nmd-svg-src=\"/assets/icons/svg/icon-folder-share-multiple.svg\" class=\"orange-300-fg s20 mr-8 ml-0 mb-0\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 5\" \nmd-font-icon=\"qiu-icon-file-userstore\" class=\"orange-300-fg s20 mr-8 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"vm.selectedGroup.children && vm.selectedGroup.id_group_type == 5\" \nmd-svg-src=\"/assets/icons/svg/icon-folder-shop-multiple.svg\" class=\"orange-300-fg s20 mr-8 ml-0 mb-0\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 6\" \nmd-font-icon=\"qiu-icon-file-useracreditation\" class=\"orange-300-fg s20 mr-8 ml-0 mb-0\" aria-hidden=\"true\"></md-icon>\n<md-icon ng-if=\"vm.selectedGroup.children && vm.selectedGroup.id_group_type == 6\" \nmd-svg-src=\"/assets/icons/svg/icon-folder-board-multiple.svg\" class=\"orange-300-fg s20 mr-8 ml-0 mb-0\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 7\" \nmd-svg-src=\"/assets/icons/svg/icon-folder-chat.svg\" class=\"orange-300-fg s20 mr-8 ml-0 mb-0\" aria-hidden=\"true\">\n</md-icon><md-icon ng-if=\"vm.selectedGroup.children && vm.selectedGroup.id_group_type == 7\" \nmd-svg-src=\"/assets/icons/svg/icon-folder-chat-multiple.svg\" class=\"orange-300-fg s20 mr-8 ml-0 mb-0\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 8\" \nmd-font-icon=\"icon-folder-remove\" class=\"orange-300-fg s20 mr-8 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"vm.selectedGroup.children && vm.selectedGroup.id_group_type == 8\" md-font-icon=\"icon-folder-multiple\" \nclass=\"orange-300-fg s20 mr-8 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><md-icon \nng-if=\"vm.selectedGroup.children && vm.selectedGroup.id_group_type == 1\" md-font-icon=\"icon-folder-multiple\" \nclass=\"orange-300-fg s20 mr-8 ml-0 mb-0\" aria-hidden=\"true\"></md-icon><div class=\"title text-truncate\" layout=\"row\" \nlayout-align=\"start center\">{{vm.selectedGroup.name}} <span ng-if=\"!isLoading\">({{pagination_totalItems | number}})\n</span></div></div></div><div layout=\"row\" class=\"mr-20 in-group-status-filter\" layout-align=\"start center\"><md-select \nng-model=\"vm.selectedIngroupStatus\" ng-change=\"vm.changeSelectedIngroupStatus()\" placeholder=\"Status filter\"><md-option\n value=\"0\" translate=\"USERS.INGROUP.STATUS.ALL\"></md-option><md-option ng-repeat=\"status in vm.ingroupStatus\" \nng-if=\"status.id_group_type == vm.selectedGroup.id_group_type\" value=\"{{status.id_ingroup_status}}\" \ntranslate=\"USERS.INGROUP.STATUS.{{status.name | uppercase}}\"></md-option></md-select></div><div class=\"buttons\" \nlayout=\"row\" layout-align=\"start center\"><div><md-switch class=\"no-label\" ng-checked=\"vm.includeSubgroups\" \nng-click=\"vm.toggleIncludeSubgroups($event)\" aria-label=\"{{vm.includeSubgroups ? \'Uncheck\':\'check\'}}\"></md-switch>\n<md-tooltip><span translate=\"CONTENT.INCLUDE_SUBGROUPS\">Include subgroups</span></md-tooltip></div><md-icon \nmd-font-icon=\"icon-close s20\" ng-click=\"vm.unselectGroups();\" class=\"ml-10\"><md-tooltip hide show-gt-xs><span \ntranslate=\"CONTENT.DESELECT_GROUP\">Deselect group</span></md-tooltip></md-icon></div></div><div \nclass=\"mail-list-item filter-selected\" \nng-if=\"(vm.selectedGroupsAcc && vm.selectedGroupsAcc.length> 0) || (vm.selectedGroupsAccSub && vm.selectedGroupsAccSub.length > 0)\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"info\" flex><div class=\"name\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"title text-truncate\" layout=\"row\" layout-align=\"start center\">\n{{vm.selectedGroupsAcc[0].name}} <span \nng-if=\"!isLoading && (!vm.selectedGroupsAccSub || !vm.selectedGroupsAccSub.length> 0)\">\n({{pagination_totalItems | number}})</span></div><div class=\"title text-truncate\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"ml-5\" \nng-if=\"vm.selectedGroupsAcc && vm.selectedGroupsAcc.length> 0 && vm.selectedGroupsAccSub && vm.selectedGroupsAccSub.length > 0\">\n> </span><span>{{vm.selectedGroupsAccSub[0].name}} <span \nng-if=\"!isLoading && vm.selectedGroupsAccSub && vm.selectedGroupsAccSub.length>\r\n                        0\">\n({{pagination_totalItems | number}})</span></span></div></div></div><div ng-if=\"!vm.selectedGroupsAcc[0].parent\" \nlayout=\"row\" class=\"mr-20 in-group-status-filter\" layout-align=\"start center\"><md-select \nng-model=\"vm.selectedIngroupStatus\" ng-change=\"vm.changeSelectedIngroupStatus()\" placeholder=\"Status filter\"><md-option\n value=\"0\" translate=\"USERS.INGROUP.STATUS.ALL\"></md-option><md-option ng-repeat=\"status in vm.ingroupStatus\" \nng-if=\"vm.showStatus(status)\" value=\"{{status.id_ingroup_status}}\" \ntranslate=\"USERS.INGROUP.STATUS.{{status.name | uppercase}}\"></md-option></md-select></div><div class=\"buttons\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-close s20\" ng-click=\"vm.unselectGroups()\" \nclass=\"ml-10\"><md-tooltip hide show-gt-xs><span translate=\"CONTENT.DESELECT_GROUP\">Deselect group</span></md-tooltip>\n</md-icon></div></div><div class=\"mail-list-item filter-selected\" \nng-if=\"vm.fieldOrder != undefined || vm.groupBy != undefined\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\" flex><div class=\"info\" ng-if=\"vm.groupBy != undefined\"><div class=\"name\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"s20 mr-5 ml-0 mb-0\">\n</md-icon><div class=\"title text-truncate\" layout=\"row\" layout-align=\"start center\">Grouped by \'{{vm.groupBy}}\'</div>\n</div></div><div class=\"info\" ng-if=\"vm.fieldOrder != undefined\"><div class=\"name\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-sort-ascending\" class=\"s20 mr-5 ml-0 mb-0\" \nng-if=\"sortDir === \'ASC\'\"></md-icon><md-icon md-font-icon=\"icon-sort-descending\" class=\"s20 mr-5 ml-0 mb-0\" \nng-if=\"sortDir === \'DESC\'\"></md-icon><div class=\"title text-truncate\" layout=\"row\" layout-align=\"start center\">\nOrdered by \'{{vm.fieldOrder}}\'</div></div></div></div><div class=\"buttons\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-close s20\" ng-click=\"vm.resetSortField()\" class=\"ml-10\"><md-tooltip hide show-gt-xs><span \ntranslate=\"CONTENT.REMOVE\">Remove</span></md-tooltip></md-icon></div></div><div class=\"no-threads\" \nng-if=\"!validSelection\" ng-hide=\"isLoading\"><div class=\"message\" translate=\"USERS.NO_ITEMS\"></div></div><div \nclass=\"no-threads message\" ng-if=\"!isLoading && vm.threads.length === 0 && !vm.pleaseSelectGroup\" ng-hide=\"isLoading\">\n<div class=\"message\" translate=\"USERS.NO_ITEMS\"></div></div><div class=\"no-threads message\" \nng-if=\"vm.pleaseSelectGroup\" ng-hide=\"isLoading\"><div class=\"message\" translate=\"USERS.SELECT_GROUP\"></div></div><div \nid=\"list-content-data\" ng-style=\"{\'opacity\' : isLoading ? 0.2 : 1}\" ms-scroll=\"vm.msScrollOptions\" class=\"scrollable\" \nng-if=\"vm.threads.length> 0 && validSelection && !vm.pleaseSelectGroup && !isLoading\"><div \nng-if=\"vm.currentLabelsFilter\" class=\"labels\"><form novalidate><div><div \nng-repeat=\"item in vm.currentLabelsFilter track by $index\" class=\"tag\" fxlayout=\"row\" fxlayoutalign=\"start center\"><div\n class=\"tag-label\">{{item.label}}<md-icon ng-click=\"vm.deleteTargetFilter(item.id, $index)\" md-font-icon=\"icon-close\" \nclass=\"s24 pointer\"></md-icon></div></div></div></form></div><div class=\"mail-list-item {{thread.status}}\" \nng-repeat=\"thread in vm.threads | filter: vm.search | filter: global.search | groupByUser:[vm.groupBy]\" md-no-ink \nng-click=\"vm.openThread(thread, thread.id)\" \nng-class=\"{\'starred\': thread.starred, \'selected\': vm.selectedUser.id_user_temp === thread.id_user_temp, \'checked\': vm.isChecked(thread)}\">\n<div class=\"groupBy-separator\" ng-show=\"thread.group_by_CHANGED\"><h2 ng-if=\"thread.firstname[0]\" \nclass=\"groupBy-title uppercase\">{{thread.firstname[0]}}</h2><h2 ng-if=\"!thread.firstname[0]\" class=\"groupBy-title\">\n(without name)</h2></div><div layout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-label\" \nng-checked=\"vm.isSelected(thread)\" ng-click=\"vm.toggleSelectThread(thread, $event)\" \naria-label=\"{{vm.isSelected(thread) ? \'Deselect\' : \'Select\'}}\"></md-checkbox><div \nng-repeat=\"field in vm.refcolumnsgrouped.left_center | orderBy:\'list_sort\'\"><div ng-if=\"field.type == \'user_status\'\">\n<button ng-if=\"thread.status===0\" class=\"md-icon-button md-button\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\" \nng-click=\"vm.toggleItemStatus(thread, $event, $index)\"></md-icon><md-tooltip><span \ntranslate=\"USERS.EMAIL_STATUS.IMPORTED\">Email imported</span></md-tooltip></button> <button ng-if=\"thread.status===1\" \nclass=\"md-icon-button md-button\"><md-icon md-font-icon=\"icon-minus-circle\" class=\"on amber-400-fg s24\" \nng-click=\"vm.toggleItemStatus(thread, $event, $index)\"></md-icon><md-tooltip><span \ntranslate=\"USERS.EMAIL_STATUS.NOT_VALIDATED\">Email not validated</span></md-tooltip></button> <button \nng-if=\"thread.status===2\" class=\"md-icon-button md-button\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" \nclass=\"on green-fg s24\" ng-click=\"vm.toggleItemStatus(thread, $event, $index)\"></md-icon><md-tooltip><span \ntranslate=\"USERS.EMAIL_STATUS.VALIDATED\">Email validated</span></md-tooltip></button> <button \nng-if=\"thread.status!==0 && thread.status!==1 && thread.status!==2\" class=\"md-icon-button md-button\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle\" class=\"on grey-fg s24\" \nng-click=\"vm.toggleItemStatus(thread, $event, $index)\"></md-icon></button></div><div ng-if=\"field.type == \'language\'\" \nlayout=\"row\" layout-align=\"center center\"><img class=\"img-flag ng-scope\" \nalt=\"{{vm.siteLanguages(thread[field.title])[lang_name]}}\" \nng-src=\"assets/images/flags/{{vm.siteLanguages()[thread[field.title]].flag_code|lowercase}}.svg\"></div><div \nng-if=\"field.type == \'thumbnail\'\"><media attachment=\"listImage\" thumbnail=\"1\" crop-format=\"{{field.id_cropformats}}\" \nclass=\"avatar ng-scope\" alt=\"{{listImage.filename}}\" \nng-repeat=\"listImage in thread.Thumbnail | filter: {\'id_zone\':field.id_zone} | limitTo:1\"></media></div><div \nng-if=\"field.type == \'thumbnail_square\'\"><media attachment=\"listImage\" thumbnail=\"1\" \ncrop-format=\"{{field.id_cropformats}}\" class=\"avatar square ng-scope\" alt=\"{{listImage.filename}}\" \nng-repeat=\"listImage in thread.Thumbnail | filter: {\'id_zone\':field.id_zone} | limitTo:1\"></media></div><md-icon \nmd-font-icon=\"icon-alert-circle\" class=\"is-important red-600-fg\" ng-if=\"field.type == \'important\' && task.important\">\n</md-icon><md-icon md-font-icon=\"icon-attachment\" class=\"has-attachment s24\" \nng-if=\"field.type == \'attachments\' && thread.Thumbnail.length> 0\"></md-icon></div><div class=\"info\" flex><div \nclass=\"name\" layout=\"row\" layout-align=\"start center\"><div \nng-if=\"(!thread.avatar) && thread[vm.refcolumnsgrouped.main[0].title]\" class=\"avatar\" \nng-bind=\"thread[vm.refcolumnsgrouped.main[0].title] | capitalizeFirstLetter\" ms-random-class=\"vm.colors\"></div><div \nng-if=\"thread.avatar && thread.avatar !== \'\'\" class=\"avatar\"><img ng-src=\"{{thread.avatar}}\" alt=\"\"></div><div \nclass=\"user-name\" layout=\"column\" layout-align=\"start start\"><div ng-if=\"vm.refcolumnsgrouped.main\" \nclass=\"user-header text-truncate grey-500-fg\"><span \nng-repeat=\"field in vm.refcolumnsgrouped.header | orderBy: \'list_sort\'\"><span ng-if=\"field.type == \'id\'\">#</span> <span\n ng-if=\"field.type == \'dateHm\' || field.type == \'date\'\" ng-bind=\"vm.showDate(thread[field.title])\"></span> <span \nng-if=\"field.type != \'dateHm\' && field.type != \'date\'\" ng-bind=\"thread.{{field.title}}\"></span></span></div><div \nng-if=\"vm.refcolumnsgrouped.main\"><span ng-repeat=\"field in vm.refcolumnsgrouped.main\"><span \nng-bind=\"thread.{{field.title}}\"></span>&nbsp;</span></div><div \nng-repeat=\"field in vm.refcolumnsgrouped.secondary | orderBy:\'list_sort\'\" class=\"width-percent-100\"><div \nng-if=\"(field.category!==\'show_groups_as_field\' && field.category!==\'show_groups_inlist\' && field.type!==\'id_subcat\' && field.type!==\'id_cat\' && field.type!==\'id_subsec\'\r\n                            && field.type!==\'date\' && field.type!==\'dateHm\') && field.primary!==1\" \nclass=\"details text-truncate\"><span class=\"title\" ng-bind=\"thread.{{field.title}}\"></span></div><div \nng-if=\"field.type==\'id_subsec\'\" class=\"details\" layout=\"row\" layout-align=\"start start\"><span \nclass=\"title grey-500-fg\" ng-bind=\"field.field_name\"></span> <span class=\"detail text-truncate\" \nng-bind=\"vm.getReferencesSections(\'subsection\', field.type, thread.{{field.title}})\"></span></div><div \nng-if=\"field.type==\'id_cat\'\" class=\"details\" layout=\"row\" layout-align=\"start start\"><span class=\"title grey-500-fg\" \nng-bind=\"field.field_name\"></span> <span class=\"detail text-truncate\" \nng-bind=\"vm.getReferencesSections(\'cat\', field.type, thread.{{field.title}})\"></span></div><div \nng-if=\"field.type==\'id_subcat\'\" class=\"details\" layout=\"row\" layout-align=\"start start\"><span \nclass=\"title grey-500-fg\" ng-bind=\"field.field_name\"></span> <span class=\"detail text-truncate\" \nng-bind=\"vm.getReferencesSections(\'subcat\', field.type, thread.{{field.title}})\"></span></div><div \nng-if=\"field.category==\'show_groups_inlist\'\" class=\"details\" layout=\"row\" layout-align=\"start start\"><div \nclass=\"acc-list width-percent-100\" layout=\"row\" layout-align=\"start start\"><div \nng-repeat=\"group in thread.groups | filter:vm.filterActiveTypes(field.title)\" class=\"group pointer active\" \nstyle=\"margin-left: -4px\" layout=\"row\" layout-align=\"start center\"><md-icon ng-if=\"vm.getGroupIcon(group)\" \nmd-font-icon=\"{{vm.getGroupIcon(group)}}\" class=\"s16 mr-5 mt-0 ml-0 mb-0 orange-300-fg\" aria-hidden=\"true\"></md-icon>\n<span class=\"name\">{{group.name}}</span></div></div></div><div ng-if=\"field.category==\'show_groups_as_field\'\" \nclass=\"details\" layout=\"row\" layout-align=\"start start\"></div></div></div></div></div><div class=\"buttons\" \nlayout=\"row\" layout-align=\"start center\"><div \nng-repeat=\"field in vm.refcolumnsgrouped.right_center | orderBy:\'list_sort\'\"></div><div ng-if=\"thread.confirm_link\">\n<md-button ng-click=\"vm.confirmWindow(thread.confirm_link)\" \nclass=\"md-accent green-500-bg md-raised md-button md-ink-ripple\">Confirm user</md-button></div></div><div \nlayout=\"column\" layout-align=\"space-between end\"></div></div></div><div \nng-if=\"!isLoading && pagination_total_pages> pagination_page && vm.threads.length > 0\" class=\"load-more white p-30\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center center\" layout-wrap=\"\"><md-button \nng-click=\"pagination_nextPage(true)\" class=\"md-raised\">{{ \'USERS.LOAD_MORE\' | translate}}</md-button></div></div>");
$templateCache.put("app/main/apps/users/users-temporary/views/list/nosplit-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/users/users-temporary/views/list/toolbar.html\'\"></div><div class=\"content-wrapper\" flex=\"\" \nlayout=\"row\"><div class=\"content thread-detail mail-read-pane\" flex=\"\" id=\"thread-detail\" \nms-scroll=\"vm.msScrollOptions\" ng-if=\"(vm.currentThread || vm.currentThread_Edit)\" \nng-include=\"\'app/main/apps/users/users-temporary/views/read/read-view-nosplit.html\'\"></div><div \nclass=\"content thread-list mail-list-pane\" flex id=\"thread-list\" layout=\"column\" \nng-if=\"!vm.currentThread && !vm.currentThread_Edit\" \nng-include=\"\'app/main/apps/users/users-temporary/views/list/list-view.html\'\"></div></div>");
$templateCache.put("app/main/apps/users/users-temporary/views/list/split-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/users/users-temporary/views/list/toolbar.html\'\"></div><div class=\"content-wrapper\" flex=\"\" \nlayout=\"row\"><div class=\"content thread-list mail-list-pane\" flex=\"40\" layout=\"column\" id=\"thread-list\" \nng-include=\"\'app/main/apps/users/users-temporary/views/list/list-view.html\'\"></div><div \nclass=\"content thread-detail mail-read-pane\" flex=\"60\" id=\"thread-detail\" layout=\"column\" \nng-include=\"\'app/main/apps/users/users-temporary/views/read/read-view.html\'\"></div></div>");
$templateCache.put("app/main/apps/users/users-temporary/views/list/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button close-thread\" aria-label=\"Back\" \nng-click=\"vm.closeUsers()\" ng-if=\"vm.currentView==\'nosplit\' && vm.groupsView\" translate \ntranslate-attr-aria-label=\"CONTENT.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button>\n<md-checkbox class=\"no-label\" aria-label=\"{{vm.selectedThreads.length > 1 ? \'Deselect All\' : \'Select All\'}}\" \nng-checked=\"vm.selectedThreads.length > 1\" ng-click=\"vm.toggleSelectThreads()\"></md-checkbox><ms-search-bar \ndebounce=\"300\" model-search=\"$root.pagination_searchquery\" on-result-click=\"vm.searchResultClick(item)\" \non-search=\"vm.search(query)\" layout=\"row\" layout-align=\"start center\"></ms-search-bar><md-button \nng-if=\"$root.pagination_searchquery==true\" ng-click=\"vm.resetFilters()\" aria-label=\"view type\" class=\"md-icon-button\" \ntranslate=\"\" translate-attr-aria-label=\"CONTENT.FILTERS\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-filter-remove-outline\"></md-icon><md-tooltip hide show-gt-xs><span>Reset search</span></md-tooltip>\n</md-button><div class=\"divider-vertical\" hide=\"\" show-gt-xs=\"\"></div></div><div layout=\"row\" \nlayout-align=\"start center\"><div ng-if=\"!vm.groupsView\" layout=\"row\" layout-align=\"start center\" \ntranslate-attr-aria-label=\"CONTENT.REFRESH\"><span ng-if=\"!isLoading \" class=\"page-info font-weight-500\">\n{{vm.threads.length}} {{ \'USERS.OF\' | translate}} {{pagination_totalItems}}</span><div class=\"divider-vertical\" hide \nshow-gt-sm></div></div></div>");
$templateCache.put("app/main/apps/users/users-temporary/views/read/read-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-if=\"vm.loadingReadPane\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nng-show=\"!vm.loadingReadPane\"><div style=\"z-index: 99; background-color: white\" class=\"mail-content\" layout=\"column\" \nlayout-align=\"center center\" ng-if=\"!vm.selectedContent\"><div class=\"content\" layout=\"column\" \nlayout-align=\"top center\"><div class=\"message\">Please select an item to show in this panel</div></div></div><md-content\n flex=\"\" ng-show=\"vm.selectedContent && !vm.editInline && vm.currentTab === \'preview\'\"><div \nclass=\"mail-content file-details scrollable\" ms-scroll=\"vm.msScrollOptions\" style=\"margin-top: 0px\"><md-list>\n<md-list-item class=\"info\" ng-if=\"vm.selectedContent_refgrouped.header[0]\" layout=\"row\" layout-align=\"start center\">\n<div layout=\"row\" layout-align=\"start start\"><div \nng-repeat=\"field in vm.selectedContent_refgrouped.header | orderBy:\'preview_sort\' \" class=\"header-element\" \nlayout=\"row\" layout-align=\"center center\"><div><span ng-if=\"field.type==\'user_status\'\"><button \nng-if=\"vm.selectedContent[field.title]===0\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\"></md-icon></button> <button \nng-if=\"vm.selectedContent[field.title]===1\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-minus-circle\" \nclass=\"on amber-400-fg s24\"></md-icon></button> <button ng-if=\"vm.selectedContent[field.title]===2\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\"></md-icon></button> \n<button \nng-if=\"vm.selectedContent[field.title]!==0 && vm.selectedContent[field.title]!==1 && vm.selectedContent[field.title]!==2\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"on grey-fg s24\"></md-icon></button> \n</span><span ng-if=\"field.type==\'dateHm\' || field.type==\'date\'\"><span>{{vm.selectedContent[field.title].dateShow}}\n</span> </span><span ng-if=\"field.type==\'language\'\" layout=\"row\" layout-align=\"center center\"><img \nclass=\"img-flag ng-scope\" alt=\"{{vm.siteLanguages(vm.selectedContent[field.title])[lang_name]}}\" \nng-src=\"assets/images/flags/{{vm.siteLanguages()[vm.selectedContent[field.title]].flag_code|lowercase}}.svg\"> </span>\n<span ng-if=\"field.type==\'id_subsec\' && vm.selectedContent[field.title].length!=0\"><span class=\"grey-500-fg\">\n{{field.field_name}} </span><span \nng-bind=\"vm.getReferencesSections(\'subsection\', field.type, vm.selectedContent[field.title])\"></span> </span><span \nng-if=\"field.type==\'id_cat\' && vm.selectedContent[field.title].length!=0\"><span class=\"grey-500-fg\">\n{{field.field_name}} </span><span \nng-bind=\"vm.getReferencesSections(\'cat\', field.type, vm.selectedContent[field.title])\"></span> </span><span \nng-if=\"field.type==\'id_subcat\' && vm.selectedContent[field.title].length!=0\"><span class=\"grey-500-fg\">\n{{field.field_name}} </span><span \nng-bind=\"vm.getReferencesSections(\'subcat\', field.type, vm.selectedContent[field.title])\"></span></span></div></div>\n</div></md-list-item><md-list-item class=\"main-item\"><div class=\"main-read\"><div class=\"avatar-container\"><div \nng-if=\"vm.selectedContent.avatar == \'\' || !vm.selectedContent.avatar\" class=\"avatar {{vm.selectedColor}}\" \nng-bind=\"vm.selectedContent[\'firstname\'] | capitalizeFirstLetter\"></div><div \nng-if=\"vm.selectedContent.avatar && vm.selectedContent.avatar !== \'\'\" class=\"avatar\"><img \nng-src=\"{{vm.selectedContent.avatar}}\" alt=\"\"></div><div \nng-repeat=\"field in vm.selectedContent_refgrouped.user_status | orderBy:\'preview_sort\' \" class=\"status\"><span \nng-if=\"field.type==\'user_status\'\"><button ng-if=\"vm.selectedContent[field.title]===0\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\"></md-icon></button> <button \nng-if=\"vm.selectedContent[field.title]===1\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-minus-circle\" \nclass=\"on amber-400-fg s24\"></md-icon></button> <button ng-if=\"vm.selectedContent[field.title]===2\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\"></md-icon></button> \n<button \nng-if=\"vm.selectedContent[field.title]!==0 && vm.selectedContent[field.title]!==1 && vm.selectedContent[field.title]!==2\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"on grey-fg s24\"></md-icon></button>\n</span></div></div></div><div class=\"main-read\" layout=\"column\" layout-align=\"center start \"><div \nng-repeat=\"field in vm.selectedContent_refgrouped.header_main | orderBy:\'preview_sort\' \" class=\"header-element\" \nlayout=\"row\" layout-align=\"center center\"><p ng-if=\"field.type==\'id\'\" class=\"font-size-14\"><span class=\"grey-500-fg\">\nID # </span><span class=\"grey-500-fg\" ng-bind=\"vm.selectedContent[field.title]\"></span></p></div><h1 class=\"name\">\n<strong ng-repeat=\"field in vm.selectedContent_refgrouped.main | orderBy:\'preview_sort\' \" \nng-bind=\"vm.selectedContent[field.title]\" class=\"mr-10\"></strong></h1></div><md-divider></md-divider></md-list-item>\n<div ng-repeat=\"field in vm.selectedContent_refgrouped.secondary | orderBy:\'preview_sort\' \"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg\" ng-if=\"field.type==\'label\'\"><h3 class=\"grey-700-fg\" ng-bind=\"field.field_name\">\n</h3><md-divider></md-divider></md-list-item><md-list-item class=\"md-toolbar-tools\" \nng-if=\"field.category == \'show_groups_as_field\'\"><div class=\"text-truncate\"><div class=\"field\"><p \nclass=\"grey-500-fg font-size-14\" ng-bind=\"field.field_name\"></p><span style=\"white-space: nowrap\" \nclass=\"font-size-16 text-truncate\">{{vm.getGroupNames(field)}}</span><br></div><md-divider></md-divider></div>\n</md-list-item><md-list-item flex=\"100\" ng-if=\"field.type!==\'label\' && field.category !== \'show_groups_as_field\'\" \nng-switch=\"\" on=\"field.type\"><div class=\"text-truncate\" ng-switch-when=\"html\"><div class=\"field\"><p \nclass=\"grey-500-fg font-size-14\" ng-bind=\"field.field_name\"></p><span class=\"font-size-16 text-truncate\" \nng-bind-html=\"vm.selectedContent[field.title]\"></span><br></div><md-divider></md-divider></div><div \nclass=\"text-truncate\" ng-switch-when=\"status\"><div class=\"field\"><p class=\"grey-500-fg font-size-14\" \nng-bind=\"field.field_name\"></p><span class=\"font-size-16 text-truncate {{vm.selectedContent[field.title]|yesNo}}\" \nng-bind-html=\"vm.selectedContent[field.title]|yesNo\"></span><br></div><md-divider></md-divider></div><div \nclass=\"text-truncate\" ng-switch-when=\"country\"><div class=\"field\"><p class=\"grey-500-fg font-size-14 ng-binding\" \nng-bind=\"field.field_name\"></p><span ng-if=\"vm.getCountryById(vm.selectedContent[field.title]).name\" \nclass=\"font-size-16 text-truncate\" ng-bind-html=\"vm.getCountryById(vm.selectedContent[field.title]).name\"></span> <span\n ng-if=\"!vm.getCountryById(vm.selectedContent[field.title]).name\" class=\"font-size-16 text-truncate\">-</span><br></div>\n<md-divider></md-divider></div><div class=\"text-truncate\" ng-switch-when=\"state\"><div class=\"field\"><p \nclass=\"grey-500-fg font-size-14 ng-binding\" ng-bind=\"field.field_name\"></p><span \nng-if=\"vm.selectedContent.related_state.name\" class=\"font-size-16 text-truncate\" \nng-bind-html=\"vm.selectedContent.related_state.name\"></span> <span ng-if=\"!vm.selectedContent.related_state.name\" \nclass=\"font-size-16 text-truncate\">-</span><br></div><md-divider></md-divider></div><div class=\"text-truncate\" \nng-switch-when=\"city\"><div class=\"field\"><p class=\"grey-500-fg font-size-14 ng-binding\" ng-bind=\"field.field_name\"></p>\n<span ng-if=\"vm.selectedContent.related_city.city\" class=\"font-size-16 text-truncate\" \nng-bind-html=\"vm.selectedContent.related_city.city\"></span> <span ng-if=\"!vm.selectedContent.related_city.city\" \nclass=\"font-size-16 text-truncate\">-</span><br></div><md-divider></md-divider></div><div class=\"\" \nng-switch-when=\"files\"><div \nng-if=\"vm.selectedContent.files[field.title] && vm.selectedContent.files[field.title].length> 0\" layout=\"column\"><div \nclass=\"mail-list-item attachment mv-5 pointer\" ng-repeat=\"document in vm.selectedContent.files[field.title]\" \ndata-id=\"{{document.id}}\"><a style=\"text-decoration: none\" href=\"{{document.url}}\" target=\"_blank\"><div layout=\"row\" \nlayout-align=\"start center\"><div fill-width layout=\"row\" layout-align=\"start center\"><div flex=\"50\" flex-gt-md=\"40\" \nflex-gt-lg=\"30\" class=\"media photos text-right pv-5 m-0\" layout=\"row\" layout-align=\"end center\"><qiu-icon \nmediafile=\"document.filename\" class=\"mr-10\"></qiu-icon><img ng-src=\"{{document.url}}\" alt=\"\"></div><div flex=\"50\" \nflex-gt-md=\"60\" flex-gt-lg=\"70\" class=\"info ph-10 pv-5 m-0\" style=\"padding: 0px 10px\" flex layout=\"column\"><div \nclass=\"subject grey-500-fg\" layout=\"row\" layout-align=\"start center\"><span>{{vm.showDate(document.date_uploaded) }}\n</span></div><div class=\"name\" layout=\"row\" layout-align=\"start center\"><span ng-if=\"document.filename\">\n{{document.filename}}</span></div></div></div></div></a></div></div></div><div class=\"text-truncate\" flex=\"100\" \nng-switch-default=\"\"><div class=\"field\"><p class=\"grey-500-fg font-size-14\" ng-bind=\"field.field_name\"></p><span \nng-if=\"field.category!=\'input_related\' && vm.isNumber(vm.selectedContent[field.title])\" \nclass=\"font-size-16 text-truncate\" ng-bind-html=\"vm.selectedContent[field.title]\"></span> <span \nng-if=\"field.category!=\'input_related\' && vm.hasDateShow(vm.selectedContent[field.title])\" \nclass=\"font-size-16 text-truncate\" ng-bind-html=\"vm.hasDateShow(vm.selectedContent[field.title])\"></span> <span \nng-if=\"field.category!=\'input_related\' && !vm.isNumber(vm.selectedContent[field.title]) && !vm.hasDateShow(vm.selectedContent[field.title]) && vm.selectedContent[field.title]\" \nclass=\"font-size-16 text-truncate\" ng-bind-html=\"vm.selectedContent[field.title]| autoLinkerFilter\"></span> <span \nng-if=\"field.category!=\'input_related\' && !vm.isNumber(vm.selectedContent[field.title]) && !vm.selectedContent[field.title]\" \nclass=\"font-size-16 text-truncate\">-</span> <span ng-if=\"field.category==\'input_related\'\" \nclass=\"font-size-16 text-truncate\">\n{{vm.getInArray(\'id_\'+field.config,field.values, vm.selectedContent[field.title], field.config)}}</span><br></div>\n<md-divider></md-divider></div></md-list-item></div><div ng-if=\"vm.selectedContent.tags\"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg\"><h3 class=\"grey-700-fg\" translate=\"CONTENT.ATTACHMENTS\">\nTags ({{vm.selectedContent.tags.length}})</h3><md-divider></md-divider></md-list-item><md-list-item><md-chips \nname=\"tag_name\" ng-model=\"vm.selectedContent.tags\" readonly=\"true\"><md-chip-template><span>\n{{$chip.tag_name}} #{{$chip.id_tag}}</span></md-chip-template></md-chips><md-divider></md-divider></md-list-item></div>\n<div ng-if=\"vm.selectedContent.Thumbnail\"><md-list-item class=\"md-toolbar-tools grey-100-bg\"><h3 class=\"grey-700-fg\" \ntranslate=\"CONTENT.ATTACHMENTS\">Attachments ({{vm.selectedContent.Thumbnail.length}})</h3><md-divider></md-divider>\n</md-list-item><md-list-item ng-repeat=\"zone in vm.mediaZones\" ng-if=\"vm.mediaZones\"><div class=\"attachments\"><div \nclass=\"field\"><p class=\"grey-500-fg font-size-14\">{{ zone.title }}</p><div class=\"attachment-list md-list-item-text\" \nlayout=\"row\" layout-wrap=\"\" layout-align=\"start start\"><div class=\"attachment\" \nng-repeat=\"attachment in vm.selectedContent.Thumbnail | filter: {\'id_zone\':zone.id_zone}\"><div \nclass=\"preview document\" layout=\"row\" layout-align=\"start center\" extension-class=\"{{attachment.filename}}\" \nng-href=\"{{attachment.permalink}}\" ng-if=\"attachment.media_type==3\" target=\"_blank\"><media attachment=\"attachment\">\n</media><a class=\"grey-1000-fg font-size-16\" ng-href=\"{{attachment.permalink}}\" target=\"_blank\"><span \nng-if=\"attachment.title\">{{attachment.title}} </span><span ng-if=\"attachment.filename\">{{attachment.filename}}</span>\n</a></div><div class=\"preview document\" layout=\"row\" layout-align=\"start center\" \nextension-class=\"{{attachment.filename}}\" ng-href=\"{{attachment.permalink}}\" ng-if=\"attachment.media_type==4\" \ntarget=\"_blank\"><media attachment=\"attachment\"></media><a class=\"grey-1000-fg font-size-16\" \nng-href=\"{{attachment.permalink}}\" target=\"_blank\"><span ng-if=\"attachment.filename\">{{attachment.filename}}</span></a>\n</div><div ng-if=\"attachment.media_type==1 || attachment.media_type==2\"><div class=\"ms-card\" flex \nmd-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"ms-card-content-wrapper\"><div class=\"template-9\"><div \nclass=\"media media-attachment\" flex layout=\"row\" layout-align=\"center center\"><div flex \nng-click=\"vm.openImageDialog($event, vm.selectedContent.Thumbnail, attachment)\"><media attachment=\"attachment\" \ncrop-format=\"{{zone.id_cropformats}}\"></media></div></div><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"size block\" layout=\"row\" layout-align=\"start center\"><strong \nclass=\"mr-5\">#{{attachment.id_media}}</strong> <span class=\"grey-500-fg\">| <span ng-if=\"attachment.filename\">\n{{attachment.filename}}</span> <span ng-if=\"attachment.title\">{{attachment.title}}</span></span></div><md-icon \nmd-font-icon=\"icon-eye\" class=\"s16 ml-10\" href=\"#\" \nng-click=\"vm.openImageDialog($event, vm.selectedContent.Thumbnail, attachment)\"></md-icon></div></div></div></div>\n</div></div></div></div></div></md-list-item><md-list-item ng-if=\"!vm.mediaZones\"><div class=\"attachments\"><div \nclass=\"field\"><p class=\"grey-500-fg font-size-14\" translate=\"CONTENT.NO_ZONE\"></p><div \nclass=\"attachment-list md-list-item-text\" layout=\"row\" layout-wrap=\"\" layout-align=\"start start\"><div \nclass=\"attachment\" ng-repeat=\"attachment in vm.selectedContent.Thumbnail | filter: {\'id_zone\':\'!\'}\"><div \nclass=\"preview document\" layout=\"row\" layout-align=\"start center\" extension-class=\"{{attachment.filename}}\" \nng-href=\"{{attachment.permalink}}\" ng-if=\"attachment.media_type==3\" target=\"_blank\"><media attachment=\"attachment\">\n</media><a class=\"grey-1000-fg font-size-16\" ng-href=\"{{attachment.permalink}}\" target=\"_blank\"><span \nng-if=\"attachment.title\">{{attachment.title}} </span><span ng-if=\"attachment.filename\">{{attachment.filename}}</span>\n</a></div><div class=\"preview document\" layout=\"row\" layout-align=\"start center\" \nextension-class=\"{{attachment.filename}}\" ng-href=\"{{attachment.permalink}}\" ng-if=\"attachment.media_type==4\" \ntarget=\"_blank\"><media attachment=\"attachment\"></media><a class=\"grey-1000-fg font-size-16\" \nng-href=\"{{attachment.permalink}}\" target=\"_blank\"><span ng-if=\"attachment.filename\">{{attachment.filename}}</span></a>\n</div><div ng-if=\"attachment.media_type==1 || attachment.media_type==2\"><div class=\"ms-card\" flex \nmd-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"ms-card-content-wrapper\"><div class=\"template-9\"><div \nclass=\"media media-attachment\" flex layout=\"row\" layout-align=\"center center\"><div flex \nng-click=\"vm.openImageDialog($event, vm.selectedContent.Thumbnail, attachment)\"><media attachment=\"attachment\" \ncrop-format=\"{{zone.id_cropformats}}\"></media></div></div><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"size block\" layout=\"row\" layout-align=\"start center\"><strong \nclass=\"mr-5\">#{{attachment.id_media}}</strong> <span class=\"grey-500-fg\">| <span ng-if=\"attachment.filename\">\n{{attachment.filename}}</span> <span ng-if=\"attachment.title\">{{attachment.title}}</span></span></div><md-icon \nmd-font-icon=\"icon-eye\" class=\"s16 ml-10\" href=\"#\" \nng-click=\"vm.openImageDialog($event, vm.selectedContent.Thumbnail, attachment)\"></md-icon></div></div></div></div>\n</div></div></div></div></div><md-divider></md-divider></md-list-item></div><md-list-item \nclass=\"md-toolbar-tools grey-100-bg\"><h3 class=\"grey-700-fg\">{{ \'USERS.USERS_GROUPS\' | translate}}</h3><md-divider>\n</md-divider></md-list-item><md-list-item class=\"p-0\" ng-if=\"vm.groupTypesWithCurrentLabelsEdit\"><div \nclass=\"content-wrapper users-edit-group\" flex layout=\"column\"><div \nclass=\"content thread-list mail-list-pane flex-100 border-bottom\"><div \nng-repeat=\"groupType in vm.groupTypesWithCurrentLabelsEdit\" ng-if=\"groupType.labelsEdit\" class=\"user-type-group\"><h3 \nclass=\"m-0 ph-24 pv-10 grey-100-bg\"><strong>{{groupType.name}}</strong></h3><div \nng-repeat=\"item in groupType.labelsEdit track by $index\" class=\"mail-list-item\" role=\"button\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"info\" flex layout=\"row\" layout-align=\"space-between center\"><div class=\"name\" \nlayout=\"row\" layout-align=\"start center\" flex=\"100\"><div class=\"group-name\" layout=\"row\" layout-align=\"start center\" \nflex=\"100\"><parent-group ng-if=\"item.group.parentGroup\" parent=\"item.group.parentGroup\"></parent-group><md-icon \nclass=\"{{item.group.color}}-fg icon-folder md-font-icon mr-10 s24 mt-0 ml-0 mb-0\" \nng-class=\"{\'icon-folder\':item.group.id_group_type == 1, \'qiu-icon-file-usermailing\':item.group.id_group_type == 2,\'qiu-icon-file-usermediacenter\':item.group.id_group_type == 3,\'qiu-icon-file-usersegment\':item.group.id_group_type == 4,\'qiu-icon-file-userstore\':item.group.id_group_type == 5,\'qiu-icon-file-useracreditation\':item.group.id_group_type == 6,\'icon-folder\':item.group.id_group_type == 7,\'icon-folder-remove\':item.group.id_group_type == 8}\" \naria-hidden=\"true\"></md-icon><span>{{item.label}}</span></div></div><div class=\"buttons\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"status-wrapper text-center\" layout=\"row\" layout-align=\"end center\" \nng-repeat=\"i in item.group.ingroup_status | filter: {\'id_ingroup_status\' : item.group.id_ingroup_status} : true\"><div>\n<span class=\"{{i.name}} status\" layout=\"row\" layout-align=\"center center\">{{i.name}}</span></div></div></div></div>\n</div></div></div></div></div><md-divider></md-divider></md-list-item><md-list-item \nclass=\"md-toolbar-tools grey-100-bg\"><h3 class=\"grey-700-fg\" translate=\"CONTENT.LATESTACTIVITY\">Latest Activity</h3>\n<md-divider></md-divider></md-list-item><div class=\"activities\"><div class=\"activity\" layout=\"row\" \nlayout-align=\"start center\" ng-repeat=\"activity in vm.log | limitTo: vm.paginationLimit()\"><img \nalt=\"{{content.from.name}}\" class=\"avatar\" ng-if=\"activity.user.avatar\" ng-src=\"{{activity.username}}\"><div \nclass=\"avatar\" ng-if=\"!activity.user.avatar\" ng-style=\"{\'background-color\':activity.user.profile_color}\">\n{{activity.user.firstname[0] | capitalize}}</div><div layout=\"column\"><div><span class=\"username md-accent-color\" \nng-if=\"activity.user.firstname.length>0 || activity.user.lastname.length>0\">\n{{activity.user.firstname}} {{activity.user.lastname}} </span><span class=\"message\">{{activity.message}}</span></div>\n<span class=\"time secondary-text\">{{activity.date}}</span></div></div><button \nclass=\"md-raised md-button md-default-theme md-ink-ripple\" ng-click=\"vm.showMoreItems()\" \nng-show=\"vm.hasMoreItemsToShow()\"><span>Show more</span></button></div></md-list></div></md-content><md-content \nng-if=\"vm.currentTab === \'edit\'\" ng-include=\"\'app/main/apps/users/views/read/edit-preview.html\'\" class=\"scrollable\">\n</md-content><md-content ng-if=\"vm.currentTab === \'activity\'\" \nng-include=\"\'app/main/apps/users/views/read/timeline.html\'\"></md-content><md-content \nng-if=\"vm.currentTab === \'mailing\'\" ng-include=\"\'app/main/apps/users/views/read/mailing.html\'\"></md-content></div>");
$templateCache.put("app/main/apps/users/users-blacklist/views/grid/grid-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/users/users-blacklist/views/list/toolbar.html\'\"></div><div class=\"content-wrapper\" flex=\"\" \nlayout=\"row\"><div class=\"mail-tabs-grid\" flex=\"\" md-dynamic-height=\"{{vm.dynamicHeight}}\"><div \nclass=\"content mail-list-pane-grid\" flex=\"\" ms-scroll=\"\"><md-progress-circular md-mode=\"indeterminate\" \nng-if=\"isLoading\"></md-progress-circular><div class=\"no-threads\" ng-hide=\"isLoading\" \nng-if=\"!isLoading && vm.inbox.length === 0\">There are no items!</div><ms-card ng-model=\"mail\" \nng-repeat=\"thread in vm.threads | filter: vm.search | filter: global.search\" \ntemplate=\"\'app/main/apps/users/users-blacklist/views/grid/template-grid-1.html\'\"></ms-card></div></div></div>");
$templateCache.put("app/main/apps/users/users-blacklist/views/grid/template-grid-1.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"space-between center\" flex><div \nlayout=\"column\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-attachment\" class=\"has-attachment s24\" \nng-if=\"thread.Thumbnail.length>0\"></md-icon><button ng-if=\"thread.onoff===1\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\"></md-icon></button> <button \nng-if=\"thread.onoff!==1\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-blank-circle-outline\" \nclass=\"off red-fg s24\"></md-icon></button></div><div layout=\"column\" layout-align=\"start center\"><md-checkbox \nclass=\"no-label\" ng-checked=\"vm.isChecked(mail)\" ng-click=\"vm.toggleCheck(mail, $event)\" \naria-label=\"{{vm.isChecked(mail)? \'Uncheck\':\'check\'}}\"></md-checkbox><div ng-if=\"vm.refcolumnsgrouped.main\"><div \nclass=\"subject text-truncate\"><span ng-repeat=\"field in vm.refcolumnsgrouped.header | orderBy: \'list-sort\'\" \nng-bind=\"thread.{{field.title}}\"></span></div></div></div></div><div class=\"media\" flex layout=\"row\" \nlayout-align=\"center center\">{{vm.refcolumnsgrouped | json}}<div \nng-repeat=\"field in vm.refcolumnsgrouped.left_center | orderBy:\'list_sort\'\" \nng-if=\"field.type == \'thumbnail_square\' || field.type == \'thumbnail_\'\"><img class=\"avatar square ng-scope\" \nalt=\"{{listImage.filename}}\" ng-if=\"thread.Thumbnail.length>0\" \nng-src=\"{{listImage.cropstatus[0].container.view_url}}{{listImage.cropstatus[0].fileName}}\" \nng-repeat=\"listImage in thread.Thumbnail | filter: {\'id_zone\':field.showtype} | limitTo:1\"> <img \nclass=\"avatar square ng-scope\" alt=\"No Image\" ng-if=\"(thread.Thumbnail|filter:{\'id_zone\':field.showtype}).length == 0\" \nng-src=\"assets/images/common/no_image_available_10.png\"></div><img class=\"image\" \nng-src=\"{{card.Thumbnail[0].crop_status[0].urlformed}}\" alt=\"{{card.media.image.alt}}\" imageonloadcontrol></div><div \nclass=\"header p-16\" layout=\"row\" layout-align=\"start\"><div class=\"info\" flex layout=\"column\"><div \nng-if=\"vm.refcolumnsgrouped.main\"><div class=\"name text-truncate\" layout=\"row\" layout-align=\"start center\"><span \nng-repeat=\"field in vm.refcolumnsgrouped.main\"><span ng-bind=\"thread.{{field.title}}\"></span>&nbsp;</span></div></div>\n<div><div class=\"name text-truncate\" layout=\"row\" layout-align=\"start center\"><span><span>Title</span></span></div>\n</div><div><div class=\"details\" layout=\"row\" layout-align=\"start start\"><div layout=\"column\"><span class=\"title\">label\n</span></div><div layout=\"column\" class=\"text-truncate\"><span class=\"detail\">name</span></div></div></div><div \nng-repeat=\"field in vm.refcolumnsgrouped.secondary | orderBy:\'list_sort\'\"><div \nng-if=\"(field.type!==\'date\' && field.type!==\'dateHm\') && field.primary!==1\" class=\"details\" layout=\"row\" \nlayout-align=\"start start\"><div layout=\"column\"><span class=\"title\" ng-bind=\"field.title\"></span></div><div \nlayout=\"column\" class=\"text-truncate\"><span class=\"detail\" ng-bind=\"thread.{{field.title}}\"></span></div></div></div>\n</div></div></div>");
$templateCache.put("app/main/apps/users/users-blacklist/views/grid/template-grid.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s20\" ng-if=\"card.onoff===1\"></md-icon><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s20\" ng-if=\"card.onoff===0\"></md-icon><div \nclass=\"info\"><div class=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.Thumbnail[0].crop_status[0].urlformed}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.Thumbnail[0].crop_status[0]\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/main/apps/users/users-blacklist/views/list/list-table-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-if=\"isLoading\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nclass=\"mail-list-item filter-selected\" ng-if=\"vm.selectedGroup\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"info\" flex><div class=\"name\" layout=\"row\" layout-align=\"start center\"><md-icon \nng-if=\"!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 1\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-font-icon=\"icon-folder\" aria-hidden=\"true\"></md-icon>\n<md-icon ng-if=\"!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 2\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-font-icon=\"qiu-icon-file-usermailing\" aria-hidden=\"true\">\n</md-icon><md-icon ng-if=\"vm.selectedGroup.children && vm.selectedGroup.id_group_type == 2\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-svg-src=\"/assets/icons/svg/icon-folder-mail-multiple.svg\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 3\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-font-icon=\"qiu-icon-file-usermediacenter\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"vm.selectedGroup.children && vm.selectedGroup.id_group_type == 3\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-svg-src=\"/assets/icons/svg/icon-folder-play-multiple.svg\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 4\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-font-icon=\"qiu-icon-file-usersegment\" aria-hidden=\"true\">\n</md-icon><md-icon ng-if=\"vm.selectedGroup.children && vm.selectedGroup.id_group_type == 4\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-svg-src=\"/assets/icons/svg/icon-folder-share-multiple.svg\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 5\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-font-icon=\"qiu-icon-file-userstore\" aria-hidden=\"true\">\n</md-icon><md-icon ng-if=\"vm.selectedGroup.children && vm.selectedGroup.id_group_type == 5\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-svg-src=\"/assets/icons/svg/icon-folder-shop-multiple.svg\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 6\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-font-icon=\"qiu-icon-file-useracreditation\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"vm.selectedGroup.children && vm.selectedGroup.id_group_type == 6\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-svg-src=\"/assets/icons/svg/icon-folder-board-multiple.svg\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 7\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-svg-src=\"/assets/icons/svg/icon-folder-chat.svg\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"vm.selectedGroup.children && vm.selectedGroup.id_group_type == 7\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-svg-src=\"/assets/icons/svg/icon-folder-chat-multiple.svg\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 8\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-font-icon=\"icon-folder-remove\" aria-hidden=\"true\">\n</md-icon><md-icon ng-if=\"vm.selectedGroup.children && vm.selectedGroup.id_group_type == 8\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-font-icon=\"icon-folder-multiple\" aria-hidden=\"true\">\n</md-icon><md-icon ng-if=\"vm.selectedGroup.children && vm.selectedGroup.id_group_type == 1\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-font-icon=\"icon-folder-multiple\" aria-hidden=\"true\">\n</md-icon><div class=\"title text-truncate\" layout=\"row\" layout-align=\"start center\">{{vm.selectedGroup.name}} <span \nng-if=\"!isLoading\">({{pagination_totalItems | number}})</span></div></div></div><div class=\"buttons\" layout=\"row\" \nlayout-align=\"start center\"><div><md-switch class=\"no-label\" ng-checked=\"vm.includeSubgroups\" \nng-click=\"vm.toggleIncludeSubgroups($event)\" aria-label=\"{{vm.includeSubgroups ? \'Uncheck\':\'check\'}}\"></md-switch>\n<md-tooltip><span translate=\"CONTENT.INCLUDE_SUBGROUPS\">Include subgroups</span></md-tooltip></div><md-icon \nng-if=\"!vm.selectedGroup.is_qiu_restricted\" md-font-icon=\"icon-close s20\" ng-click=\"vm.unselectGroups()\" class=\"ml-10\">\n<md-tooltip hide show-gt-xs><span translate=\"CONTENT.DESELECT_GROUP\">Deselect group</span></md-tooltip></md-icon></div>\n</div><div class=\"mail-list-item filter-selected\" ng-if=\"vm.fieldOrder != undefined || vm.groupBy != undefined\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"info\" \nng-if=\"vm.groupBy != undefined\"><div class=\"name\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"s20 mr-5 ml-0 mb-0\"></md-icon><div class=\"title text-truncate\" \nlayout=\"row\" layout-align=\"start center\">Grouped by \'{{vm.groupBy}}\'</div></div></div><div class=\"info\" \nng-if=\"vm.fieldOrder != undefined\"><div class=\"name\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-sort-ascending\" class=\"s20 mr-5 ml-0 mb-0\" ng-if=\"sortDir === \'ASC\'\"></md-icon><md-icon \nmd-font-icon=\"icon-sort-descending\" class=\"s20 mr-5 ml-0 mb-0\" ng-if=\"sortDir === \'DESC\'\"></md-icon><div \nclass=\"title text-truncate\" layout=\"row\" layout-align=\"start center\">Ordered by \'{{vm.fieldOrder}}\'</div></div></div>\n</div><div class=\"buttons\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-close s20\" \nng-click=\"vm.resetSortField()\" class=\"ml-10\"><md-tooltip hide show-gt-xs><span translate=\"CONTENT.REMOVE\">Remove</span>\n</md-tooltip></md-icon></div></div><div class=\"no-threads\" \nng-if=\"!isLoading && vm.threads.length === 0 && !vm.pleaseSelectGroup\" ng-hide=\"isLoading\" translate=\"USERS.NO_ITEMS\">\n</div><div class=\"no-threads\" ng-if=\"!isLoading && vm.threads.length === 0 && vm.pleaseSelectGroup\" \nng-hide=\"isLoading\" translate=\"USERS.SELECT_GROUP\"></div><div id=\"list-content-data\" \nng-style=\"{\'opacity\' : isLoading ? 0.2 : 1}\" \nng-class=\"{\'group-filter\': vm.selectedGroup,\'other-filter\':vm.fieldOrder != undefined || vm.groupBy != undefined}\" \nclass=\"scrollable\" ng-if=\"vm.threads.length > 0\"><table class=\"table-scrollable row-border hover simple\" \nms-responsive-table><thead><tr><th class=\"mini\"></th><th \nng-class=\"{\'large\': vm.isLarge(column.title), \'medium\' : vm.isMedium(column.title), \'small\' : vm.isSmall(column.title), \'mini\': vm.isMini(column.title)}\" \nng-repeat=\"column in vm.refcolumns | filter: { table_list_position: \'main\'} | orderBy: vm.orderByTableListSort\" \nng-if=\"column.title !== \'lastname\'\" ng-switch=\"column.title\"><span ng-switch-when=\"firstname\" translate=\"USERS.NAME\">\n</span> <span ng-switch-default ng-bind=\"column.field_name\"></span></th><th class=\"group\" \nng-repeat=\"column in vm.flatGroups | filter: { table_list_position: \'main\'}\"><span translate=\"GROUP.GROUP\"></span><br>\n<span>\"{{column.name}}\"</span></th><th class=\"small\"><md-menu-bar><md-menu><md-button class=\"md-icon-button\" \naria-label=\"Actions\" ng-click=\"$mdMenu.open($event)\" layout=\"row\" layout-align=\"center center\"><md-icon \nmd-font-icon=\"icon-cog\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"USERS.EDIT_COLUMNS\">Edit columns</span>\n</md-tooltip></md-button><md-menu-content><md-menu-item \nng-repeat=\"column in vm.refcolumns | orderBy: vm.orderByTableListSort | filter: vm.filterIsMainOrSecondaryTableListPosition\">\n<md-button md-prevent-menu-close=\"md-prevent-menu-close\" \nng-click=\"column.table_list_position == \'main\' ? column.table_list_position = \'secondary\' : column.table_list_position = \'main\'; $event.stopPropagation();\" \naria-label=\"{{column.field_name}}\"><div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start between\"><span ng-bind=\"column.field_name\"></span></div><i \nng-if=\"column.table_list_position == \'main\'\" class=\"icon-check s16\"></i></div></md-button></md-menu-item><md-menu-item \nng-repeat=\"column in vm.flatGroups\"><md-button md-prevent-menu-close=\"md-prevent-menu-close\" \nng-click=\"column.table_list_position == \'main\' ? column.table_list_position = \'secondary\' : column.table_list_position = \'main\'; $event.stopPropagation();\">\n<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start between\"><span \ntranslate=\"GROUP.GROUP\"></span> <span>\"{{column.name}}\"</span></div><i ng-if=\"column.table_list_position == \'main\'\" \nclass=\"icon-check s16\"></i></div></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></th></tr>\n</thead><tbody><tr ng-click=\"vm.openThread(thread)\" \nng-repeat=\"thread in vm.threads | filter: vm.search | filter: global.search | groupByUser:[vm.groupBy]\" \nng-class=\"{\'starred\': thread.starred, \'selected\': vm.selectedContentID === thread.id_user, \'checked\': vm.isChecked(thread)}\" \nclass=\"{{thread.status}}\"><td class=\"mini\"><md-checkbox class=\"no-label\" ng-checked=\"vm.isSelected(thread)\" \nng-click=\"vm.toggleSelectThread(thread, $event)\" aria-label=\"{{vm.isSelected(thread) ? \'Deselect\' : \'Select\'}}\">\n</md-checkbox></td><td \nng-class=\"{\'large\': vm.isLarge(column.title), \'medium\' : vm.isMedium(column.title), \'small\' : vm.isSmall(column.title), \'mini\': vm.isMini(column.title)}\" \nng-repeat=\"column in vm.refcolumns | filter: { table_list_position: \'main\'} | orderBy: vm.orderByTableListSort\" \nng-if=\"column.title !== \'lastname\'\" ng-switch=\"column.title\"><a ng-switch-when=\"email\" title=\"{{thread.email}}\" \nhref=\"mailto:{{thread.email}}\">{{thread[column.title]}}</a> <span ng-switch-when=\"media\"><div \nng-if=\"(!thread.avatar) && thread[vm.refcolumnsgrouped.main[0].title]\" class=\"avatar\" \nng-bind=\"thread[vm.refcolumnsgrouped.main[0].title] | capitalizeFirstLetter\" ms-random-class=\"vm.colors\"></div><media \nng-if=\"thread.avatar\" attachment=\"thread.avatar\" class=\"avatar\"></media></span><span title=\"# {{thread.id_user}}\" \nclass=\"grey-500-fg\" ng-switch-when=\"id_user\">#{{thread.id_user}}</span> <span class=\"large\" ng-switch-when=\"firstname\">\n<strong title=\"{{thread.firstname}} {{thread.lastname}}\">{{thread.firstname}} {{thread.lastname}}</strong> </span><span\n class=\"mini\" ng-switch-when=\"status\"><button ng-if=\"thread.status===0\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\" \nng-click=\"vm.toggleItemStatus(thread, $event, $index)\"></md-icon><md-tooltip><span \ntranslate=\"USERS.EMAIL_STATUS.IMPORTED\">Email imported</span></md-tooltip></button> <button ng-if=\"thread.status===1\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-minus-circle\" class=\"on amber-400-fg s24\" \nng-click=\"vm.toggleItemStatus(thread, $event, $index)\"></md-icon><md-tooltip><span \ntranslate=\"USERS.EMAIL_STATUS.NOT_VALIDATED\">Email not validated</span></md-tooltip></button> <button \nng-if=\"thread.status===2\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" \nclass=\"on green-fg s24\" ng-click=\"vm.toggleItemStatus(thread, $event, $index)\"></md-icon><md-tooltip><span \ntranslate=\"USERS.EMAIL_STATUS.VALIDATED\">Email validated</span></md-tooltip></button> <button \nng-if=\"thread.status!==0 && thread.status!==1 && thread.status!==2\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle\" class=\"on grey-fg s24\" \nng-click=\"vm.toggleItemStatus(thread, $event, $index)\"></md-icon></button> </span><span class=\"mini\" \nng-switch-when=\"ingroup_status\"><div ng-if=\"thread.groups.length\" class=\"status-wrapper text-center\" layout=\"row\" \nlayout-align=\"end center\"><div ng-repeat=\"status in vm.ingroupStatus\"><span \nng-click=\"vm.changeInGroupStatusDialog($event, thread, vm.selectedGroup, status)\" \nng-if=\"vm.isShowingLabelGroup(thread, status)\" class=\"{{status.name}} status\" \ntranslate=\"USERS.INGROUP.STATUS.{{status.name | uppercase}}\" layout=\"row\" layout-align=\"center center\" \nng-style=\"{\'background\': status.color || \'\'}\"></span></div></div></span><span \ntitle=\"{{thread.related_country.country}}\" ng-switch-when=\"country\">{{thread.related_country.country}}</span> <span \ntitle=\"{{thread.related_state.state}}\" ng-switch-when=\"state\">{{thread.related_state.state}}</span> <span \ntitle=\"{{thread.related_city.city}}\" ng-switch-when=\"city\">{{thread.related_city.city}}</span> <span \ntitle=\"{{thread[column.title]}}\" ng-switch-default>\n{{column.category == \'json\' ? vm.JSONparse(thread.user_params)[column.title] : thread[column.title]}}</span></td><td \nclass=\"group\" ng-repeat=\"column in vm.flatGroups | filter: { table_list_position: \'main\'}\"><md-checkbox \nng-disabled=\"true\" class=\"no-label\" ng-checked=\"(thread.groups|filter:{\'id_group\':column.id_group}).length > 0\" \naria-label=\"{{vm.isSelected(thread) ? \'Deselect\' : \'Select\'}}\"></md-checkbox></td><td class=\"small\"></td></tr></tbody>\n</table><div class=\"toolbar border-top\" style=\"padding-bottom: 18px\" layout=\"row\" layout-align=\"end center\"><div \nlayout=\"row\" layout-align=\"center center\" ng-style=\"{\'display\' : isLoading ? \'none\' : \'block\'}\"><span \nclass=\"page-info\">{{pagination_totalItems}} items found.</span><md-button aria-label=\"Previous\" \nclass=\"md-icon-button arrow\" ng-click=\"pagination_prevPage()\" ng-disabled=\"pagination_firstPage()\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip hide \nshow-gt-xs><span translate=\"CONTENT.PREVIOUS\">Previous</span></md-tooltip></md-button><span class=\"page-info\">\n{{pagination_page}} / {{pagination_total_pages}}</span><md-button aria-label=\"Next\" class=\"md-icon-button arrow\" \nng-click=\"pagination_nextPage()\" ng-disabled=\"pagination_morePages() || pagination_total_pages === pagination_page\" \ntranslate=\"\" translate-attr-aria-label=\"CONTENT.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip \nhide show-gt-xs><span translate=\"CONTENT.NEXT\">Next</span></md-tooltip></md-button></div></div></div>");
$templateCache.put("app/main/apps/users/users-blacklist/views/list/list-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-if=\"isLoading\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nclass=\"mail-list-item filter-selected\" id=\"list-view1\" \nng-if=\"vm.selectedGroup && !vm.selectedGroupsAcc && !vm.selectedGroupsAccSub\" layout=\"row\" layout-align=\"start center\">\n<div class=\"info\" flex><div class=\"name\" layout=\"row\" layout-align=\"start center\"><md-icon \nng-if=\"!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 1\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-font-icon=\"icon-folder\" aria-hidden=\"true\"></md-icon>\n<md-icon ng-if=\"vm.selectedGroup.children && vm.selectedGroup.id_group_type == 1\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-font-icon=\"icon-folder-multiple\" aria-hidden=\"true\">\n</md-icon><md-icon ng-if=\"!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 2\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-font-icon=\"qiu-icon-file-usermailing\" aria-hidden=\"true\">\n</md-icon><md-icon ng-if=\"vm.selectedGroup.children && vm.selectedGroup.id_group_type == 2\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-svg-src=\"/assets/icons/svg/icon-folder-mail-multiple.svg\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 3\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-font-icon=\"qiu-icon-file-usermediacenter\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"vm.selectedGroup.children && vm.selectedGroup.id_group_type == 3\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-svg-src=\"/assets/icons/svg/icon-folder-play-multiple.svg\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 4\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-font-icon=\"qiu-icon-file-usersegment\" aria-hidden=\"true\">\n</md-icon><md-icon ng-if=\"vm.selectedGroup.children && vm.selectedGroup.id_group_type == 4\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-svg-src=\"/assets/icons/svg/icon-folder-share-multiple.svg\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 5\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-font-icon=\"qiu-icon-file-userstore\" aria-hidden=\"true\">\n</md-icon><md-icon ng-if=\"vm.selectedGroup.children && vm.selectedGroup.id_group_type == 5\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-svg-src=\"/assets/icons/svg/icon-folder-shop-multiple.svg\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 6\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-font-icon=\"qiu-icon-file-useracreditation\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"vm.selectedGroup.children && vm.selectedGroup.id_group_type == 6\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-svg-src=\"/assets/icons/svg/icon-folder-board-multiple.svg\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 7\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-svg-src=\"/assets/icons/svg/icon-folder-chat.svg\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"vm.selectedGroup.children && vm.selectedGroup.id_group_type == 7\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-svg-src=\"/assets/icons/svg/icon-folder-chat-multiple.svg\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"!vm.selectedGroup.children && vm.selectedGroup.id_group_type == 8\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-font-icon=\"icon-folder-remove\" aria-hidden=\"true\">\n</md-icon><md-icon ng-if=\"vm.selectedGroup.children && vm.selectedGroup.id_group_type == 8\" \nclass=\"{{vm.selectedGroup.color}}-fg s20 mr-8 ml-0 mb-0\" md-font-icon=\"icon-folder-multiple\" aria-hidden=\"true\">\n</md-icon><div class=\"title text-truncate\" layout=\"row\" layout-align=\"start center\">{{vm.selectedGroup.name}} <span \nng-if=\"!isLoading\">({{pagination_totalItems | number}}<span ng-if=\"vm.selectedGroup.raw_settings.max_allowed_users\">\n {{ \'USERS.OF\' | translate}} {{vm.selectedGroup.raw_settings.max_allowed_users}}</span>)</span></div></div></div><div \nlayout=\"row\" class=\"mr-20 in-group-status-filter\" layout-align=\"start center\"><md-select \nng-model=\"vm.selectedIngroupStatus\" ng-change=\"vm.changeSelectedIngroupStatus()\" placeholder=\"Status filter\"><md-option\n value=\"0\" translate=\"USERS.INGROUP.STATUS.ALL\"></md-option><md-option ng-repeat=\"status in vm.ingroupStatus\" \nng-if=\"status.id_group_type == vm.selectedGroup.id_group_type\" value=\"{{status.id_ingroup_status}}\" \ntranslate=\"USERS.INGROUP.STATUS.{{status.name | uppercase}}\" ng-style=\"{\'background\': status.color || \'\'}\"></md-option>\n</md-select></div><div class=\"buttons\" layout=\"row\" layout-align=\"start center\"><div \nng-if=\"!vm.selectedGroup.is_qiu_restricted\"><md-switch class=\"no-label\" ng-checked=\"vm.includeSubgroups\" \nng-click=\"vm.toggleIncludeSubgroups($event)\" aria-label=\"{{vm.includeSubgroups ? \'Uncheck\':\'check\'}}\"></md-switch>\n<md-tooltip><span translate=\"CONTENT.INCLUDE_SUBGROUPS\">Include subgroups</span></md-tooltip></div><md-icon \nng-if=\"!vm.selectedGroup.is_qiu_restricted\" md-font-icon=\"icon-close s20\" ng-click=\"vm.unselectGroups(); \" \nclass=\"ml-10\"><md-tooltip hide show-gt-xs><span translate=\"CONTENT.DESELECT_GROUP\">Deselect group</span></md-tooltip>\n</md-icon></div></div><div class=\"mail-list-item filter-selected\" \nng-if=\"(vm.selectedGroupsAcc && vm.selectedGroupsAcc.length > 0) || (vm.selectedGroupsAccSub && vm.selectedGroupsAccSub.length > 0)\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"info\" flex><div class=\"name\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"title text-truncate\" layout=\"row\" layout-align=\"start center\">\n{{vm.selectedGroupsAcc[0].name}} <span \nng-if=\"!isLoading && (!vm.selectedGroupsAccSub || !vm.selectedGroupsAccSub.length > 0)\">\n({{pagination_totalItems | number}}<span ng-if=\"vm.selectedGroupsAcc[0].raw_settings.max_allowed_users\">\n {{ \'USERS.OF\' | translate}} {{vm.selectedGroupsAcc[0].raw_settings.max_allowed_users}}</span>)</span></div><div \nclass=\"title text-truncate\" layout=\"row\" layout-align=\"start center\"><span class=\"ml-5\" \nng-if=\"vm.selectedGroupsAcc && vm.selectedGroupsAcc.length > 0 && vm.selectedGroupsAccSub && vm.selectedGroupsAccSub.length > 0\">\n> </span><span>{{vm.selectedGroupsAccSub[0].name}} <span \nng-if=\"!isLoading && vm.selectedGroupsAccSub && vm.selectedGroupsAccSub.length > 0\">({{pagination_totalItems | number}}\n<span ng-if=\"vm.selectedGroupsAcc[0].raw_settings.max_allowed_users\">\n {{ \'USERS.OF\' | translate}} {{vm.selectedGroupsAcc[0].raw_settings.max_allowed_users}}</span>)</span></span></div>\n</div></div><div ng-if=\"!vm.selectedGroupsAcc[0].parent\" layout=\"row\" class=\"mr-20 in-group-status-filter\" \nlayout-align=\"start center\"><md-select ng-model=\"vm.selectedIngroupStatus\" \nng-change=\"vm.changeSelectedIngroupStatus()\" placeholder=\"Status filter\"><md-option value=\"0\" \ntranslate=\"USERS.INGROUP.STATUS.ALL\"></md-option><md-option ng-repeat=\"status in vm.ingroupStatus\" \nng-if=\"vm.showStatus(status)\" value=\"{{status.id_ingroup_status}}\" \ntranslate=\"USERS.INGROUP.STATUS.{{status.name | uppercase}}\" ng-style=\"{\'background\': status.color || \'\'}\"></md-option>\n</md-select></div><div class=\"buttons\" layout=\"row\" layout-align=\"start center\"><md-icon \nng-if=\"!vm.selectedGroupsAccSub[0].is_qiu_restricted\" md-font-icon=\"icon-close s20\" ng-click=\"vm.unselectGroups()\" \nclass=\"ml-10\"><md-tooltip hide show-gt-xs><span translate=\"CONTENT.DESELECT_GROUP\">Deselect group</span></md-tooltip>\n</md-icon></div></div><div class=\"mail-list-item filter-selected\" \nng-if=\"vm.fieldOrder != undefined || vm.groupBy != undefined\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\" flex><div class=\"info\" ng-if=\"vm.groupBy != undefined\"><div class=\"name\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"s20 mr-5 ml-0 mb-0\">\n</md-icon><div class=\"title text-truncate\" layout=\"row\" layout-align=\"start center\">Grouped by \'{{vm.groupBy}}\'</div>\n</div></div><div class=\"info\" ng-if=\"vm.fieldOrder != undefined\"><div class=\"name\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-sort-ascending\" class=\"s20 mr-5 ml-0 mb-0\" \nng-if=\"sortDir === \'ASC\'\"></md-icon><md-icon md-font-icon=\"icon-sort-descending\" class=\"s20 mr-5 ml-0 mb-0\" \nng-if=\"sortDir === \'DESC\'\"></md-icon><div class=\"title text-truncate\" layout=\"row\" layout-align=\"start center\">\nOrdered by \'{{vm.fieldOrder}}\'</div></div></div></div><div class=\"buttons\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-close s20\" ng-click=\"vm.resetSortField()\" class=\"ml-10\"><md-tooltip hide show-gt-xs><span \ntranslate=\"CONTENT.REMOVE\">Remove</span></md-tooltip></md-icon></div></div><div class=\"no-threads\" \nng-if=\"!validSelection\" ng-hide=\"isLoading\"><div class=\"message\" translate=\"USERS.NO_ITEMS\"></div></div><div \nclass=\"no-threads message\" ng-if=\"!isLoading && vm.threads.length === 0 && !vm.pleaseSelectGroup\" ng-hide=\"isLoading\">\n<div class=\"message\" translate=\"USERS.NO_ITEMS\"></div></div><div class=\"no-threads message\" \nng-if=\"vm.pleaseSelectGroup\" ng-hide=\"isLoading\"><div class=\"message\" translate=\"USERS.SELECT_GROUP\"></div></div><div \nid=\"list-content-data\" ng-style=\"{\'opacity\' : isLoading ? 0.2 : 1}\" ms-scroll=\"vm.msScrollOptions\" \nng-class=\"{\'group-filter\': vm.selectedGroup || vm.selectedGroupsAcc || vm.selectedGroupsAccSub,\'other-filter\':vm.fieldOrder != undefined || vm.groupBy != undefined}\" \nclass=\"scrollable\" ng-if=\"vm.threads.length > 0 && validSelection && !vm.pleaseSelectGroup\"><div \nng-if=\"vm.currentLabelsFilter\" class=\"labels\"><form novalidate><div><div \nng-repeat=\"item in vm.currentLabelsFilter track by $index\" class=\"tag\" fxlayout=\"row\" fxlayoutalign=\"start center\"><div\n class=\"tag-label\">{{item.label}}<md-icon ng-click=\"vm.deleteTargetFilter(item.id, $index)\" md-font-icon=\"icon-close\" \nclass=\"s24 pointer\"></md-icon></div></div></div></form></div><div \nclass=\"mail-list-item {{thread.status}} blacklisted-item\" \nng-repeat=\"thread in vm.threads | filter: vm.search | filter: global.search\" md-no-ink \nng-class=\"{\'starred\': thread.starred, \'checked\': vm.isChecked(thread)}\"><div class=\"groupBy-separator\" \nng-show=\"thread.group_by_CHANGED\"><h2 ng-if=\"thread.firstname[0]\" class=\"groupBy-title uppercase\">\n{{thread.firstname[0]}}</h2><h2 ng-if=\"!thread.firstname[0]\" class=\"groupBy-title\">(without name)</h2></div><div \nlayout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-label\" ng-checked=\"vm.isSelected(thread)\" \nng-click=\"vm.toggleSelectThread(thread, $event)\" aria-label=\"{{vm.isSelected(thread) ? \'Deselect\' : \'Select\'}}\">\n</md-checkbox><div ng-repeat=\"field in vm.refcolumnsgrouped.left_center | orderBy:\'list_sort\'\"><div \nng-if=\"field.type == \'user_status\'\"><button ng-if=\"thread.status===0\" class=\"md-icon-button md-button\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\" \nng-click=\"vm.toggleItemStatus(thread, $event, $index)\"></md-icon><md-tooltip><span \ntranslate=\"USERS.STATUS_NAMES.DISABLED\"></span></md-tooltip></button> <button ng-if=\"thread.status===1\" \nclass=\"md-icon-button md-button\"><md-icon md-font-icon=\"icon-minus-circle\" class=\"on amber-400-fg s24\" \nng-click=\"vm.toggleItemStatus(thread, $event, $index)\"></md-icon><md-tooltip><span \ntranslate=\"USERS.STATUS_NAMES.NOT_CONFIRMED\"></span></md-tooltip></button> <button ng-if=\"thread.status===2\" \nclass=\"md-icon-button md-button\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\" \nng-click=\"vm.toggleItemStatus(thread, $event, $index)\"></md-icon><md-tooltip><span \ntranslate=\"USERS.STATUS_NAMES.VALIDATED\"></span></md-tooltip></button> <button ng-if=\"thread.status===99\" \nclass=\"md-icon-button md-button\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"on black-fg s24\" \nng-click=\"vm.toggleItemStatus(thread, $event, $index)\"></md-icon><md-tooltip><span \ntranslate=\"USERS.STATUS_NAMES.BLOCKED\"></span></md-tooltip></button> <button \nng-if=\"thread.status!==0 && thread.status!==1 && thread.status!==2 && thread.status!==99\" \nclass=\"md-icon-button md-button\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"on grey-fg s24\" \nng-click=\"vm.toggleItemStatus(thread, $event, $index)\"></md-icon></button></div><div ng-if=\"field.type == \'language\'\" \nlayout=\"row\" layout-align=\"center center\"><img class=\"img-flag ng-scope\" \nalt=\"{{vm.siteLanguages(thread[field.title])[lang_name]}}\" \nng-src=\"assets/images/flags/{{vm.siteLanguages()[thread[field.title]].flag_code|lowercase}}.svg\"></div><div \nng-if=\"field.type == \'thumbnail\'\"><media attachment=\"listImage\" thumbnail=\"1\" crop-format=\"{{field.id_cropformats}}\" \nclass=\"avatar ng-scope\" alt=\"{{listImage.filename}}\" \nng-repeat=\"listImage in thread.Thumbnail | filter: {\'id_zone\':field.id_zone} | limitTo:1\"></media><img \nclass=\"avatar ng-scope\" alt=\"{{listImage.filename}}\" ng-if=\"thread.Thumbnail.length>0\" \nng-src=\"{{listImage.cropstatus[0].container.view_url}}{{listImage.cropstatus[0].fileName}}\" \nng-repeat=\"listImage in thread.Thumbnail | filter: {\'id_zone\':field.showtype} | limitTo:1\"> <img \nclass=\"avatar ng-scope\" alt=\"No Image\" ng-if=\"(thread.Thumbnail|filter:{\'id_zone\':field.showtype}).length == 0\" \nng-src=\"assets/images/common/no_image_available_10.png\"></div><div ng-if=\"field.type == \'thumbnail_square\'\"><media \nattachment=\"listImage\" thumbnail=\"1\" crop-format=\"{{field.id_cropformats}}\" class=\"avatar square ng-scope\" \nalt=\"{{listImage.filename}}\" ng-repeat=\"listImage in thread.Thumbnail | filter: {\'id_zone\':field.id_zone} | limitTo:1\">\n</media></div><md-icon md-font-icon=\"icon-alert-circle\" class=\"is-important red-600-fg\" \nng-if=\"field.type == \'important\' && task.important\"></md-icon><md-icon md-font-icon=\"icon-attachment\" \nclass=\"has-attachment s24\" ng-if=\"field.type == \'attachments\' && thread.Thumbnail.length > 0\"></md-icon></div><div \nclass=\"info\" flex><div class=\"name\" layout=\"row\" layout-align=\"start center\"><div \nng-if=\"(!thread.avatar) && thread[vm.refcolumnsgrouped.main[0].title]\" class=\"avatar\" \nng-bind=\"thread[vm.refcolumnsgrouped.main[0].title] | capitalizeFirstLetter\" ms-random-class=\"vm.colors\"></div><div \nng-if=\"thread.avatar && thread.avatar !== \'\'\" class=\"avatar\"><img ng-src=\"{{thread.avatar}}\" alt=\"\"></div><div \nclass=\"user-name\" layout=\"column\" layout-align=\"start start\"><div ng-if=\"vm.refcolumnsgrouped.main\" \nclass=\"user-header text-truncate grey-500-fg\"><span \nng-repeat=\"field in vm.refcolumnsgrouped.header | orderBy: \'list_sort\'\"><span ng-if=\"field.type == \'id\'\">#</span> <span\n ng-if=\"field.type == \'dateHm\' || field.type == \'date\'\" ng-bind=\"vm.showDate(thread[field.title])\"></span> <span \nng-if=\"field.type != \'dateHm\' && field.type != \'date\'\" ng-bind=\"thread.{{field.title}}\"></span></span></div><div \nng-if=\"vm.refcolumnsgrouped.main\"><span ng-repeat=\"field in vm.refcolumnsgrouped.main\"><span \nng-bind=\"thread.{{field.title}}\"></span>&nbsp;</span></div><div class=\"blacklisted-content\"><span><strong>\n{{thread.email}}</strong></span><br><span class=\"title\" ng-bind-html=\"vm.timeAgo(thread.created_at)\"></span></div><div \nng-repeat=\"field in vm.refcolumnsgrouped.secondary | orderBy:\'list_sort\'\" class=\"width-percent-100\"><div \nng-if=\"(field.category!==\'show_groups_as_field\' && field.category!==\'show_groups_inlist\' && field.type!==\'id_subcat\' && field.type!==\'id_cat\' && field.type!==\'id_subsec\'\r\n                    && field.type!==\'date\' && field.type!==\'dateHm\') && field.primary!==1\" \nclass=\"details text-truncate\"><span class=\"title\" ng-bind=\"thread.{{field.title}}\"></span></div><div \nng-if=\"field.type==\'id_subsec\'\" class=\"details\" layout=\"row\" layout-align=\"start start\"><span \nclass=\"title grey-500-fg\" ng-bind=\"field.field_name\"></span> <span class=\"detail text-truncate\" \nng-bind=\"vm.getReferencesSections(\'subsection\', field.type, thread.{{field.title}})\"></span></div><div \nng-if=\"field.type==\'id_cat\'\" class=\"details\" layout=\"row\" layout-align=\"start start\"><span class=\"title grey-500-fg\" \nng-bind=\"field.field_name\"></span> <span class=\"detail text-truncate\" \nng-bind=\"vm.getReferencesSections(\'cat\', field.type, thread.{{field.title}})\"></span></div><div \nng-if=\"field.type==\'id_subcat\'\" class=\"details\" layout=\"row\" layout-align=\"start start\"><span \nclass=\"title grey-500-fg\" ng-bind=\"field.field_name\"></span> <span class=\"detail text-truncate\" \nng-bind=\"vm.getReferencesSections(\'subcat\', field.type, thread.{{field.title}})\"></span></div><div \nng-if=\"field.category==\'show_groups_inlist\'\" class=\"details\" layout=\"row\" layout-align=\"start start\"><div \nclass=\"acc-list width-percent-100\" layout=\"row\" layout-align=\"start start\"><div \nng-repeat=\"group in thread.groups | filter:vm.filterActiveTypes(field.title)\" class=\"group pointer active\" \nstyle=\"margin-left: -4px\" layout=\"row\" layout-align=\"start center\"><md-icon ng-if=\"vm.getGroupIcon(group)\" \nclass=\"s16 mr-5 mt-0 ml-0 mb-0 {{group.color}}-fg\" md-font-icon=\"{{vm.getGroupIcon(group)}}\" aria-hidden=\"true\">\n</md-icon><span class=\"name\">{{group.name}}</span></div></div></div><div \nng-if=\"field.category==\'show_groups_as_field\'\" class=\"details\" layout=\"row\" layout-align=\"start start\"></div><div \nng-if=\"field.category==\'json\'\" class=\"details\" layout=\"row\" layout-align=\"start start\"><span class=\"title grey-500-fg\" \nng-bind=\"field.field_name\"></span> <span class=\"detail text-truncate\" \nng-bind=\"vm.JSONparse(thread.user_params)[field.title]\"></span></div></div></div><div class=\"reason\"><div \nng-if=\"thread.reason\" class=\"blacklist-reason\"><span class=\"reason\">{{thread.reason}}</span></div><div \nng-if=\"thread.reason == null\" class=\"blacklist-reason\"><span class=\"reason\">unsubscribed</span></div></div></div></div>\n<div class=\"buttons\" layout=\"row\" layout-align=\"start center\"><div \nng-repeat=\"field in vm.refcolumnsgrouped.right_center | orderBy:\'list_sort\'\"><div \nng-if=\"field.type == \'ingroup_status\' && thread.groups.length && !vm.isAccreditations\" \nclass=\"status-wrapper text-center\" layout=\"row\" layout-align=\"end center\"><div ng-repeat=\"status in vm.ingroupStatus\">\n<span ng-click=\"vm.changeInGroupStatusDialog($event, thread, vm.selectedGroup, status)\" \nng-if=\"vm.isShowingLabelGroup(thread, status)\" class=\"{{status.name}} status\" \ntranslate=\"USERS.INGROUP.STATUS.{{status.name | uppercase}}\" layout=\"row\" layout-align=\"center center\" \nng-style=\"{\'background\': status.color || \'\'}\"></span></div></div><div \nng-if=\"field.type == \'ingroup_status\' && thread.groups.length && vm.isAccreditations\" \nclass=\"status-wrapper text-center\" layout=\"row\" layout-align=\"end center\"><div ng-repeat=\"status in vm.ingroupStatus\">\n<span ng-click=\"vm.changeInGroupStatusDialog($event, thread, group, status)\" \nng-if=\"vm.isShowingLabelGroup(thread, status)\" class=\"{{status.name}} status\" \ntranslate=\"USERS.INGROUP.STATUS.{{status.name | uppercase}}\" layout=\"row\" layout-align=\"center center\" \nng-style=\"{\'background\': status.color || \'\'}\"></span></div></div><div class=\"grey-500-fg ml-10\" \nng-if=\"field.type == \'id\'\" ng-bind=\"\'# \'+thread.{{field.title}}\"></div><div class=\"grey-500-fg\" \nng-if=\"field.type == \'dateHm\' || field.type == \'date\'\" ng-bind=\"vm.showDate(thread[field.title])\"></div><div \nclass=\"grey-500-fg\" \nng-if=\"field.type != \'dateHm\' && field.type != \'date\' && field.type != \'user_status\' && field.type != \'id\' && field.type != \'ingroup_status\'\" \nng-bind=\"thread.{{field.title}}\"></div><div ng-if=\"field.type == \'user_status\'\" class=\"ml-10\"><button \nng-if=\"thread.status===0\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-blank-circle-outline\" \nclass=\"off red-fg s24\" ng-click=\"vm.toggleItemStatus(thread, $event, $index)\"></md-icon><md-tooltip><span \ntranslate=\"USERS.STATUS_NAMES.DISABLED\"></span></md-tooltip></button> <button ng-if=\"thread.status===1\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-minus-circle\" class=\"on amber-400-fg s24\" \nng-click=\"vm.toggleItemStatus(thread, $event, $index)\"></md-icon><md-tooltip><span \ntranslate=\"USERS.STATUS_NAMES.NOT_VALIDATED\"></span></md-tooltip></button> <button ng-if=\"thread.status===2\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\" \nng-click=\"vm.toggleItemStatus(thread, $event, $index)\"></md-icon><md-tooltip><span \ntranslate=\"USERS.STATUS_NAMES.VALIDATED\"></span></md-tooltip></button> <button ng-if=\"thread.status===99\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"on black-fg s24\" \nng-click=\"vm.toggleItemStatus(thread, $event, $index)\"></md-icon><md-tooltip><span \ntranslate=\"USERS.STATUS_NAMES.BLOCKED\"></span></md-tooltip></button> <button \nng-if=\"thread.status!==0 && thread.status!==1 && thread.status!==2 && thread.status!==99\" class=\"md-icon-button\">\n<md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"on grey-fg s24\" \nng-click=\"vm.toggleItemStatus(thread, $event, $index)\"></md-icon></button></div><div ng-if=\"field.type == \'language\'\">\n<img class=\"square ng-scope\" alt=\"{{vm.siteLanguages(thread[field.title])[lang_name]}}\" \nng-src=\"assets/images/flags/{{vm.siteLanguages()[thread[field.title]].flag_code|lowercase}}.png\"></div><div \nng-if=\"field.type == \'thumbnail\'\"><media attachment=\"listImage\" thumbnail=\"1\" crop-format=\"{{field.id_cropformats}}\" \nclass=\"avatar ng-scope\" alt=\"{{listImage.filename}}\" \nng-repeat=\"listImage in thread.Thumbnail | filter: {\'id_zone\':field.id_zone} | limitTo:1\"></media></div><div \nng-if=\"field.type == \'thumbnail_square\'\"><media attachment=\"listImage\" thumbnail=\"1\" \ncrop-format=\"{{field.id_cropformats}}\" class=\"avatar square ng-scope\" alt=\"{{listImage.filename}}\" \nng-repeat=\"listImage in thread.Thumbnail | filter: {\'id_zone\':field.id_zone} | limitTo:1\"></media></div><md-icon \nmd-font-icon=\"icon-alert-circle\" class=\"is-important red-600-fg\" ng-if=\"field.type == \'important\' && task.important\">\n</md-icon><md-icon md-font-icon=\"icon-attachment\" class=\"has-attachment s24\" \nng-if=\"field.type == \'attachments\' && thread.Thumbnail.length > 0\"></md-icon></div></div><div layout=\"column\" \nlayout-align=\"space-between end\"></div></div></div><div \nng-if=\"!isLoading && pagination_total_pages > pagination_page && vm.threads.length > 0\" class=\"load-more white p-30\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center center\" layout-wrap=\"\"><md-button \nng-click=\"pagination_nextPage(true)\" class=\"md-raised\">{{ \'USERS.LOAD_MORE\' | translate}}</md-button></div></div>");
$templateCache.put("app/main/apps/users/users-blacklist/views/list/nosplit-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/users/users-blacklist/views/list/toolbar.html\'\"></div><div class=\"content-wrapper\" flex=\"\" \nlayout=\"row\"><div class=\"content thread-detail mail-read-pane\" flex=\"\" id=\"thread-detail\" \nms-scroll=\"vm.msScrollOptions\" ng-if=\"(vm.currentThread || vm.currentThread_Edit) && !vm.isAccreditations \" \nng-include=\"\'app/main/apps/users/users-blacklist/views/read/read-view-nosplit.html\'\"></div><div \nclass=\"content thread-list mail-list-pane\" flex id=\"thread-list\" layout=\"column\" \nng-if=\"!vm.currentThread && !vm.currentThread_Edit\" \nng-include=\"\'app/main/apps/users/users-blacklist/views/list/list-view.html\'\"></div></div>");
$templateCache.put("app/main/apps/users/users-blacklist/views/list/split-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/users/users-blacklist/views/list/toolbar.html\'\"></div><div class=\"content-wrapper\" flex=\"\" \nlayout=\"row\"><div class=\"content thread-list mail-list-pane\" flex=\"100\" id=\"list-view2\" layout=\"column\" \nid=\"thread-list\" ng-include=\"\'app/main/apps/users/users-blacklist/views/list/list-view.html\'\"></div></div>");
$templateCache.put("app/main/apps/users/users-blacklist/views/list/table-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/apps/users/users-blacklist/views/list/toolbar.html\'\"></div><div class=\"content-wrapper\" flex=\"\" \nlayout=\"row\"><div class=\"content thread-list mail-list-pane\" flex=\"100\" id=\"thread-list\" \nng-include=\"\'app/main/apps/users/users-blacklist/views/list/list-table-view.html\'\"></div><div \nng-if=\"!vm.isAccreditations\" class=\"content thread-detail mail-read-pane edit-pane-users\" id=\"thread-detail\" \nlayout=\"column\" ng-include=\"\'app/main/apps/users/users-blacklist/views/read/read-view.html\'\" \nng-class=\"{selected:vm.selectedContent}\"></div><div ng-if=\"vm.isAccreditations\" \nclass=\"content thread-detail mail-read-pane edit-pane-users\" id=\"thread-detail\" layout=\"column\" \nng-include=\"\'app/main/apps/users/users-blacklist/views/read/read-view-accreditations.html\'\" \nng-class=\"{selected:vm.selectedContent}\"></div></div>");
$templateCache.put("app/main/apps/users/users-blacklist/views/list/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button close-thread\" aria-label=\"Back\" \nng-click=\"vm.closeUsers()\" ng-if=\"vm.currentView==\'nosplit\' && vm.groupsView\" translate \ntranslate-attr-aria-label=\"CONTENT.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button>\n<md-checkbox class=\"no-label\" aria-label=\"{{vm.selectedThreads.length > 1 ? \'Deselect All\' : \'Select All\'}}\" \nng-checked=\"vm.selectedThreads.length > 1\" ng-click=\"vm.toggleSelectThreads()\"></md-checkbox><div layout=\"row\" \nlayout-align=\"start center\" class=\"groups-trigger\"></div><ms-search-bar \nng-if=\"!vm.isAccreditations || !vm.pleaseSelectGroup\" debounce=\"300\" model-search=\"$root.pagination_searchquery\" \non-result-click=\"vm.searchResultClick(item)\" on-search=\"vm.search(query)\" layout=\"row\" layout-align=\"start center\">\n</ms-search-bar><md-button ng-if=\"$root.pagination_searchquery==true\" ng-click=\"vm.resetFilters()\" \naria-label=\"view type\" class=\"md-icon-button\" translate=\"\" translate-attr-aria-label=\"CONTENT.FILTERS\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-filter-remove-outline\"></md-icon><md-tooltip hide show-gt-xs><span>\nReset search</span></md-tooltip></md-button><div aria-hidden=\"false\" class=\"action-buttons\" show-gt-md layout=\"row\" \nlayout-align=\"start center\" ng-show=\"vm.selectedThreads.length > 0\"><div aria-hidden=\"false\" class=\"action-buttons\" \nhide show-gt-md layout=\"row\" layout-align=\"start center\" ng-show=\"vm.selectedThreads.length > 0\"><md-button hide \naria-label=\"Subscriptions\" class=\"md-icon-button\" translate=\"\" \ntranslate-attr-aria-label=\"USERS.ADD_REMOVE_SUBSCRIPTIONS\"><md-icon md-font-icon=\"icon-telegram\"></md-icon><md-tooltip \nshow-gt-xs><span translate=\"USERS.ADD_REMOVE_SUBSCRIPTIONS\">Add/Remove subscriptions</span></md-tooltip></md-button>\n<md-button ng-if=\"vm.selectedGroup && vm.selectedThreads.length > 0\" \nng-click=\"vm.inviteToGroupMultiple($event, vm.selectedGroup)\" aria-label=\"Invite\" class=\"md-icon-button\" translate=\"\" \ntranslate-attr-aria-label=\"USERS.INVITE_TO_GROUP\"><md-icon md-font-icon=\"icon-email\"></md-icon><md-tooltip hide \nshow-gt-xs><span translate=\"USERS.INVITE_TO_GROUP\"></span></md-tooltip></md-button><md-button \nng-if=\"vm.selectedGroupsAcc && vm.selectedThreads.length > 0\" \nng-click=\"vm.inviteToGroupMultiple($event, vm.selectedGroupsAcc)\" aria-label=\"Invite\" class=\"md-icon-button\" \ntranslate=\"\" translate-attr-aria-label=\"USERS.INVITE_TO_GROUP\"><md-icon md-font-icon=\"icon-email\"></md-icon><md-tooltip\n hide show-gt-xs><span translate=\"USERS.INVITE_TO_GROUP\"></span></md-tooltip></md-button><md-button \nng-if=\"vm.selectedGroup\" ng-click=\"vm.removeUsersFromGroupDialog($event)\" \nng-disabled=\"vm.selectedThreads.length == 0 || vm.includeSubgroups || (vm.isQiuRestricted && vm.selectedGroup.is_qiu_restricted_root)\" \naria-label=\"Remove\" class=\"md-icon-button\" translate=\"\" translate-attr-aria-label=\"USERS.REMOVE_FROM_GROUP\"><md-icon \nmd-font-icon=\"icon-folder-remove\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"USERS.REMOVE_FROM_GROUP\">\n</span></md-tooltip></md-button><md-button ng-click=\"vm.deleteThread()\" aria-label=\"Delete\" class=\"md-icon-button\" \ntranslate=\"\" translate-attr-aria-label=\"CONTENT.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip hide \nshow-gt-xs><span translate=\"CONTENT.DELETE\">Delete</span></md-tooltip></md-button></div><md-button \naria-label=\"view type\" class=\"md-icon-button\" hide=\"\" ng-click=\"vm.changeView(\'split\')\" \nng-if=\"vm.currentView === \'grid\'\" show-gt-sm=\"\" translate=\"\" translate-attr-aria-label=\"CONTENT.LIST_VIEW\"><md-icon \nmd-font-icon=\"icon-view-headline\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.LIST_VIEW\">List View\n</span></md-tooltip></md-button></div><div ng-if=\"!vm.groupsView\" layout=\"row\" layout-align=\"start center\" \ntranslate-attr-aria-label=\"CONTENT.REFRESH\"><md-menu-bar class=\"pr-0 pl-0\" hide-gt-xs><md-menu><md-button \nclass=\"md-icon-button\" aria-label=\"Actions\" ng-click=\"$mdMenu.open($event)\" layout=\"row\" layout-align=\"center center\">\n<md-icon md-font-icon=\"icon-cog\" class=\"mr-5\"></md-icon></md-button><md-menu-content><md-menu-item><md-menu><md-button \naria-label=\"Filters\" ng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-format-list-bulleted\"></md-icon><span>\nGroup by</span></md-button><md-menu-content><md-menu-item ng-if=\"vm.groupBy != undefined\"><md-button \nng-click=\"vm.resetGroupby()\"><md-icon md-font-icon=\"icon-close\"></md-icon><span translate=\"CONTENT.REMOVE_GROUP_BY\">\nRemove group by</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.setGroupBy(\'firstname\')\">\nFirstname</md-button></md-menu-item></md-menu-content></md-menu></md-menu-item><md-menu-item><md-menu><md-button \naria-label=\"Filters\" ng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-sort\"></md-icon><span \ntranslate=\"CONTENT.ORDER_BY\">Order by</span></md-button><md-menu-content><md-menu-item \nng-if=\"vm.fieldOrder != undefined\"><md-button ng-click=\"vm.resetSortField()\"><md-icon md-font-icon=\"icon-close\">\n</md-icon><span translate=\"CONTENT.REMOVE_ORDER\">Remove order</span></md-button></md-menu-item><md-menu-item \nng-repeat=\"field in vm.refcolumns\" ng-if=\"field.sortable === 1\"><md-button ng-click=\"vm.setSortField(field.title)\"><div\n layout=\"row\" layout-align=\"space-between center\"><span>{{field.field_name}}</span> <i class=\"icon-check s16\" \nng-if=\"vm.fieldOrder === field.field_name\"></i></div></md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.setSortOrder(\'ASC\')\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start between\"><md-icon \nmd-font-icon=\"icon-sort-ascending\"></md-icon><span translate=\"CONTENT.DIRECTION_A_Z\">Order A-Z</span></div><i \nclass=\"icon-check s16\" ng-if=\"sortDir === \'ASC\'\"></i></div></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.setSortOrder(\'DESC\')\"><div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start between\"><md-icon md-font-icon=\"icon-sort-descending\"></md-icon><span \ntranslate=\"CONTENT.DIRECTION_Z_A\">Order Z-Z</span></div><i class=\"icon-check s16\" ng-if=\"sortDir === \'DESC\'\"></i></div>\n</md-button></md-menu-item><div hide-gt-md><md-menu-item hide><md-button ng-disabled=\"vm.selectedThreads.length == 0\" \naria-label=\"SUBSCRIPTIONS\"><md-icon md-font-icon=\"icon-telegram\"></md-icon><span \ntranslate=\"USERS.ADD_REMOVE_SUBSCRIPTIONS\">Add/Remove subscriptions</span></md-button></md-menu-item><md-menu-item \nng-if=\"!vm.selectedGroup\"><md-button ng-click=\"vm.addUsersToGroupsDialog($event)\" \nng-disabled=\"vm.selectedThreads.length == 0\" aria-label=\"Add to groups\"><md-icon md-font-icon=\"icon-folder-account\">\n</md-icon><span translate=\"USERS.ADD_TO_GROUPS\"></span></md-button></md-menu-item><md-menu-item \nng-if=\"vm.selectedGroup\"><md-button ng-click=\"vm.removeUsersFromGroupDialog($event)\" class=\"md-icon-button\" \nng-disabled=\"vm.selectedThreads.length == 0 || vm.includeSubgroups\" aria-label=\"Remove from group\"><md-icon \nmd-font-icon=\"icon-folder-remove\"></md-icon><span translate=\"USERS.REMOVE_FROM_GROUP\"></span></md-button>\n</md-menu-item></div><div hide-gt-md><md-menu-item><md-button ng-click=\"vm.deleteThread()\" \nng-disabled=\"vm.selectedThreads.length == 0\" aria-label=\"DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span \ntranslate=\"CONTENT.DELETE\">DELETE</span></md-button></md-menu-item></div><md-menu-item><md-button \nng-click=\"vm.openImportDialog($event)\" aria-label=\"IMPORT\"><md-icon md-font-icon=\"icon-cloud-upload\"></md-icon><span \ntranslate=\"USERS.IMPORT\">IMPORT</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.openExportDialog($event)\" aria-label=\"EXPORT\"><md-icon md-font-icon=\"icon-cloud-download\"></md-icon><span \ntranslate=\"USERS.EXPORT\">EXPORT</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"pagination_reload()\" aria-label=\"REFRESH\"><md-icon md-font-icon=\"icon-refresh\"></md-icon><span \ntranslate=\"USERS.REFRESH\">REFRESH</span></md-button></md-menu-item><md-menu-item ng-if=\"vm.selectedGroup\"><md-button \nng-click=\"vm.openCopyMoveDialog($event, \'COPY\')\" aria-label=\"COPY\"><md-icon md-font-icon=\"icon-account-multiple-plus\">\n</md-icon><span translate=\"USERS.COPY\">COPY</span></md-button></md-menu-item><md-menu-item \nng-if=\"vm.selectedGroup && !(vm.isQiuRestricted && vm.selectedGroup.is_qiu_restricted_root)\"><md-button \nng-click=\"vm.openCopyMoveDialog($event, \'MOVE\')\" aria-label=\"MOVE\"><md-icon md-font-icon=\"icon-account-switch\">\n</md-icon><span translate=\"USERS.MOVE\">MOVE</span></md-button></md-menu-item><md-menu-item \nng-if=\"vm.userCustomActions.length > 0 && (vm.selectedGroup || vm.selectedGroupsAcc)\"><md-menu><md-button \naria-label=\"Filters\" ng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-more\"></md-icon><span>Extra</span>\n</md-button><md-menu-content><md-menu-item ng-repeat=\"axn in vm.userCustomActions\"><md-button \nng-click=\"vm.customActionEvent(axn, $event)\" aria-label=\"{{axn.title}}\"><md-icon md-font-icon=\"{{axn.icon}}\"></md-icon>\n<span ng-bind-html=\"axn.title\"></span></md-button></md-menu-item></md-menu-content></md-menu></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar></div></div><div layout=\"row\" layout-align=\"start center\"><div \nng-if=\"!vm.groupsView\" layout=\"row\" layout-align=\"start center\" translate-attr-aria-label=\"CONTENT.REFRESH\"><span \nng-if=\"!isLoading && vm.currentView !== \'table\'\" class=\"page-info font-weight-500\">\n{{vm.threads.length}} {{ \'USERS.OF\' | translate}} {{pagination_totalItems}} </span><span \nng-if=\"!isLoading && vm.currentView === \'table\'\" class=\"page-info font-weight-500\">{{pagination_totalItems}}</span>\n<md-button ng-if=\"vm.currentView === \'table\'\" aria-label=\"Previous\" class=\"md-icon-button arrow\" hide=\"\" \nng-click=\"pagination_prevPage()\" ng-disabled=\"pagination_firstPage()\" show-gt-xs=\"\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip hide \nshow-gt-xs><span translate=\"CONTENT.PREVIOUS\">Previous</span></md-tooltip></md-button><span \nng-if=\"vm.currentView === \'table\'\" class=\"page-info\" hide=\"\" show-gt-xs=\"\">\n{{pagination_page}} / {{pagination_total_pages}}</span><md-button ng-if=\"vm.currentView === \'table\'\" aria-label=\"Next\" \nclass=\"md-icon-button arrow\" hide=\"\" ng-click=\"pagination_nextPage()\" ng-disabled=\"pagination_morePages()\" \nshow-gt-xs=\"\" translate=\"\" translate-attr-aria-label=\"CONTENT.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\">\n</md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.NEXT\">Next</span></md-tooltip></md-button><div \nclass=\"divider-vertical\" hide show-gt-sm></div><md-button aria-label=\"Refresh\" class=\"md-icon-button\" hide=\"\" \nshow-gt-xs=\"\" ng-click=\"pagination_reload()\" translate=\"\" translate-attr-aria-label=\"USERS.REFRESH\"><md-icon \nmd-font-icon=\"icon-refresh\" show-gt-xs></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.changeView(\'split\')\" ng-if=\"vm.currentView !== \'split\'\" hide show-gt-sm aria-label=\"Split\"><md-icon \nmd-font-icon=\"icon-view-list\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.SIMPLE_LIST\">split</span>\n</md-tooltip></md-button></div></div>");
$templateCache.put("app/main/apps/users/users-blacklist/views/read/edit-preview.html","<div id=\"users-edit\" class=\"page-layout simple fullwidth mail-content content-edit\" layout=\"column\"><md-tabs><md-tab \nlabel=\"{{ \'USERS.EDIT\' | translate}}\"><div layout=\"row\" style=\"padding-bottom: 0px\" \nng-include=\"\'app/main/apps/users/views/read/tab-edit.html\'\"></div></md-tab><md-tab label=\"Media\" \nng-if=\"!vm.isAccreditations\"><div ng-include=\"\'app/main/apps/users/views/read/tab-media.html\'\"></div></md-tab><md-tab \nlabel=\"{{ \'USERS.USERS_GROUPS\' | translate}}\" ng-if=\"!vm.isAccreditations\"><div \nng-include=\"\'app/main/apps/users/views/read/tab-users-groups.html\'\"></div></md-tab><md-tab label=\"SEO\" \nng-if=\"vm.ActiveSection.seo && !vm.isAccreditations\"><div ng-include=\"\'app/main/apps/users/views/read/tab-seo.html\'\">\n</div></md-tab><md-tab label=\"{{ \'USERS.ACTIVITY\' | translate}}\" \nng-if=\"vm.ActiveSection.activity && !vm.isAccreditations\"><div \nng-include=\"\'app/main/apps/users/views/read/tab-activity.html\'\"></div></md-tab></md-tabs></div>");
$templateCache.put("app/main/apps/users/users-blacklist/views/read/edit-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-if=\"vm.loadingReadPane\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nng-show=\"!vm.loadingReadPane\"><div class=\"mail-content\" layout=\"column\" layout-align=\"center center\" \nng-if=\"!vm.selectedContent\"><div class=\"content\" layout=\"column\" layout-align=\"top center\"><div class=\"message\">\nPlease select an item to show in this panel</div></div></div><div class=\"toolbar grey-100-bg colored-bg\" layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"vm.selectedContent\" scroll=\"\"><div layout=\"row\" layout-align=\"start center\">\n<md-button class=\"md-icon-button close-thread\" aria-label=\"Back\" ng-click=\"vm.closeThread()\" translate \ntranslate-attr-aria-label=\"CONTENT.BACK\"><md-icon md-font-icon=\"icon-arrow-right\"></md-icon></md-button></div><div \nlayout=\"row\" layout-align=\"end center\" ng-if=\"vm.currentThread_Edit\"><md-button type=\"submit\" \nng-click=\"vm.saveItem(vm.currentThread_Edit)\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.basicForm.$invalid || vm.basicForm.$pristine\" aria-label=\"SAVE\" translate=\"CONTENT.SAVE\" \ntranslate-attr-aria-label=\"CONTENT.SAVE\">SAVE</md-button><md-button type=\"button\" ng-click=\"vm.closeThreadEdit()\" \nclass=\"md-raised md-warn\" aria-label=\"Cancel\">Cancel</md-button></div></div><md-content ng-if=\"vm.selectedContent\" \nng-include=\"\'app/main/apps/users/views/read/edit-preview.html\'\" class=\"scrollable\"></md-content></div>");
$templateCache.put("app/main/apps/users/users-blacklist/views/read/mailing.html","<div id=\"users-activity\" class=\"page-layout simple fullwidth mail-content content-edit scrollable\" layout=\"column\" \nms-scroll=\"vm.msScrollOptions\"><md-list-item class=\"main-item\"><div class=\"main-read\"><div class=\"avatar-container\">\n<div ng-if=\"vm.selectedContent.avatar == \'\' || !vm.selectedContent.avatar\" class=\"avatar {{vm.selectedColor}}\" \nng-bind=\"vm.selectedContent[\'firstname\'] | capitalizeFirstLetter\"></div><media \nng-if=\"vm.selectedContent.avatar !== \'\' && vm.selectedContent.avatar\" attachment=\"vm.selectedContent.avatar\" \nclass=\"avatar fix\"></media><div \nng-repeat=\"field in vm.selectedContent_refgrouped.user_status | orderBy:\'preview_sort\'\" class=\"status\"><span \nng-if=\"field.type==\'user_status\'\"><button ng-if=\"vm.selectedContent[field.title]===0\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\"></md-icon></button> <button \nng-if=\"vm.selectedContent[field.title]===1\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-minus-circle\" \nclass=\"on amber-400-fg s24\"></md-icon></button> <button ng-if=\"vm.selectedContent[field.title]===2\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\"></md-icon></button> \n<button \nng-if=\"vm.selectedContent[field.title]!==0 && vm.selectedContent[field.title]!==1 && vm.selectedContent[field.title]!==2\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"on grey-fg s24\"></md-icon></button>\n</span></div></div></div><div class=\"main-read\" layout=\"column\" layout-align=\"center start\"><div \nng-repeat=\"field in vm.selectedContent_refgrouped.header_main | orderBy:\'preview_sort\'\" class=\"header-element\" \nlayout=\"row\" layout-align=\"center center\"><p ng-if=\"field.type==\'id\'\" class=\"font-size-14\"><span class=\"grey-500-fg\">\nID # </span><span class=\"grey-500-fg\" ng-bind=\"vm.selectedContent[field.title]\"></span></p></div><h1 class=\"name\">\n<strong ng-repeat=\"field in vm.selectedContent_refgrouped.main | orderBy:\'preview_sort\'\" \nng-bind=\"vm.selectedContent[field.title]\" class=\"mr-10\"></strong></h1></div><md-divider></md-divider></md-list-item>\n<div ng-if=\"vm.logs.length > 0\" flex=\"100\"><div class=\"grey-100-bg border-bottom text-center toolbar-log\" layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"40\" flex-gt-xs=\"60\"></div><div flex=\"10\" layout=\"row\" \nlayout-align=\"center center\"><h3 class=\"grey-700-fg font-size-14\">{{ \'USERS.MAIL.SENT\' | translate}}</h3></div><div \nflex=\"10\" layout=\"row\" layout-align=\"center center\"><h3 class=\"grey-700-fg font-size-14\">\n{{ \'USERS.MAIL.DELIVERED\' | translate}}</h3></div><div flex=\"40\" flex-gt-xs=\"20\" layout=\"row\" \nlayout-align=\"end center\"></div></div><md-list class=\"pt-0\" ng-style=\"{\'opacity\' : vm.loadingLogsReadPane ? 0.2 : 1}\">\n<md-list-item class=\"border-bottom text-center item-log\" ng-repeat=\"log in vm.logs\"><div flex layout=\"row\"><div \nflex=\"40\" flex-gt-xs=\"60\" class=\"text-left word-break-word pl-20\" layout=\"column\"><p \nclass=\"m-0 subject text-truncate grey-500-fg\" ng-bind=\"log.scheduled_at\"></p><h4 class=\"m-0 font-weight-500\" \nng-bind=\"log.mailing_content.subject\"></h4></div><div flex=\"10\" layout=\"row\" layout-align=\"center center\"><md-icon \nng-if=\"log.sent_at\" md-font-icon=\"icon-checkbox-marked-circle green-fg\" class=\"s24\"><md-tooltip md-autohide=\"true\">\n{{log.sent_at}}</md-tooltip></md-icon><md-icon ng-if=\"!log.sent_at\" md-font-icon=\"icon-window-close red-fg\" \nclass=\"s24\"></md-icon></div><div flex=\"10\" layout=\"row\" layout-align=\"center center\"><md-icon ng-if=\"log.delivered_at\" \nmd-font-icon=\"icon-checkbox-marked-circle green-fg\" class=\"s24\"><md-tooltip md-autohide=\"true\">{{log.delivered_at}}\n</md-tooltip></md-icon><md-icon ng-if=\"!log.delivered_at\" md-font-icon=\"icon-window-close red-fg\" class=\"s24\">\n</md-icon></div><div flex=\"40\" flex-gt-xs=\"20\" layout-align=\"end center\" layout=\"row\" class=\"pr-20\"><div \nng-if=\"log.clicked_at\" layout=\"column\" layout-align=\"center center\" class=\"ml-5\"><button \nclass=\"status green-300-bg pill\">{{\'USERS.MAIL.CLICKED\' | translate}}<md-tooltip md-autohide=\"true\">\n{{vm.getDateFormat(log.clicked_at)}}</md-tooltip></button></div><div ng-if=\"log.opened_at\" layout=\"column\" \nlayout-align=\"center center\" class=\"ml-5\"><button class=\"status green-700-bg pill\">{{\'USERS.MAIL.OPEN\' | translate}}\n<md-tooltip md-autohide=\"true\">{{vm.getDateFormat(log.opened_at)}}</md-tooltip></button></div><div \nng-if=\"log.bounced_at && log.bounceType == \'Permanent\'\" layout=\"column\" layout-align=\"center center\" class=\"ml-5\">\n<button class=\"status pill red-bg white-fg\">{{\'USERS.MAIL.HARD_BOUNCE\' | translate}}<md-tooltip md-autohide=\"true\">\n{{vm.getDateFormat(log.bounced_at)}}</md-tooltip></button></div><div \nng-if=\"log.bounced_at && log.bounceType == \'Transient\'\" layout=\"column\" layout-align=\"center center\" class=\"ml-5\">\n<button class=\"status pill amber-bg white-fg\">{{\'USERS.MAIL.SOFT_BOUNCE\' | translate}}<md-tooltip md-autohide=\"true\">\n{{vm.getDateFormat(log.bounced_at)}}</md-tooltip></button></div><div \nng-if=\"log.bounced_at && log.bounceType != \'Transient\' && log.bounceType != \'Permanent\'\" layout=\"column\" \nlayout-align=\"center center\" class=\"ml-5\"><button class=\"status pill grey-bg white-fg\">\n{{\'USERS.MAIL.UNDEFINED\' | translate}}<md-tooltip md-autohide=\"true\">{{vm.getDateFormat(log.bounced_at)}}</md-tooltip>\n</button></div><div ng-if=\"log.suppressed_at\" layout=\"column\" layout-align=\"center center\" class=\"ml-5\"><button \nclass=\"status pill grey-bg white-fg\">{{\'USERS.MAIL.SUPPRESSED\' | translate}}<md-tooltip md-autohide=\"true\">\n{{vm.getDateFormat(log.suppressed_at)}}</md-tooltip></button></div><div ng-if=\"log.rejected_at\" layout=\"column\" \nlayout-align=\"center center\" class=\"ml-5\"><button class=\"status pill grey-bg white-fg\">\n{{\'USERS.MAIL.REJECTED\' | translate}}<md-tooltip md-autohide=\"true\">{{vm.getDateFormat(log.rejected_at)}}</md-tooltip>\n</button></div><div ng-if=\"log.complained_at\" layout=\"column\" layout-align=\"center center\" class=\"ml-5\"><button \nclass=\"status pill grey-bg white-fg\">{{\'USERS.MAIL.COMPLAINED\' | translate}}<md-tooltip md-autohide=\"true\">\n{{vm.getDateFormat(log.complained_at)}}</md-tooltip></button></div><div ng-if=\"log.is_blacklisted\" layout=\"column\" \nlayout-align=\"center center\" class=\"ml-5\"><button class=\"status pill brown-600-bg white-fg\">\n{{\'USERS.MAIL.UNSUSCRIBED\' | translate}}</button></div></div></div></md-list-item><div \nng-if=\"!isLoading && vm.pagination_total_log_pages> vm.pagination_log_page && vm.logs.length > 0\" \nclass=\"load-more white p-30\" layout=\"row\" layout-sm=\"column\" layout-align=\"center center\" layout-wrap=\"\"><md-button \nng-click=\"vm.getLogs(vm.selectedContent.email, vm.nextPageLog)\" class=\"md-raised\">{{\'GLOBAL.LOAD_MORE\' | translate}}\n</md-button></div><div class=\"white p-30\"></div></md-list></div><div ng-if=\"vm.logs.length === 0\" \nclass=\"load-more white p-30\" layout=\"row\" layout-sm=\"column\" layout-align=\"center center\" layout-wrap=\"\"><div \nclass=\"message\" translate=\"USERS.NO_RESULTS\"></div></div></div>");
$templateCache.put("app/main/apps/users/users-blacklist/views/read/parent-group.html","<parent-group flex ng-if=\"vm.parent.parentGroup\" parent=\"vm.parent.parentGroup\"></parent-group><md-icon \nng-if=\"vm.parent.id_group_type == 1\" md-font-icon=\"icon-folder\" class=\"{{vm.parent.color}}-fg s24 mt-0 ml-0 mb-0\" \naria-hidden=\"true\"><md-tooltip>{{vm.parent.name}}</md-tooltip></md-icon><md-icon ng-if=\"vm.parent.id_group_type == 2\" \nmd-font-icon=\"qiu-icon-file-usermailing\" class=\"{{vm.parent.color}}-fg s24 mt-0 ml-0 mb-0\" aria-hidden=\"true\">\n<md-tooltip>{{vm.parent.name}}</md-tooltip></md-icon><md-icon ng-if=\"vm.parent.id_group_type == 3\" \nmd-font-icon=\"qiu-icon-file-usermediacenter\" class=\"{{vm.parent.color}}-fg s24 mt-0 ml-0 mb-0\" aria-hidden=\"true\">\n<md-tooltip>{{vm.parent.name}}</md-tooltip></md-icon><md-icon ng-if=\"vm.parent.id_group_type == 4\" \nmd-font-icon=\"qiu-icon-file-usersegment\" class=\"{{vm.parent.color}}-fg s24 mt-0 ml-0 mb-0\" aria-hidden=\"true\">\n<md-tooltip>{{vm.parent.name}}</md-tooltip></md-icon><md-icon ng-if=\"vm.parent.id_group_type == 5\" \nmd-font-icon=\"qiu-icon-file-userstore\" class=\"{{vm.parent.color}}-fg s24 mt-0 ml-0 mb-0\" aria-hidden=\"true\">\n<md-tooltip>{{vm.parent.name}}</md-tooltip></md-icon><md-icon ng-if=\"vm.parent.id_group_type == 6\" \nmd-font-icon=\"qiu-icon-file-useracreditation\" class=\"{{vm.parent.color}}-fg s24 mt-0 ml-0 mb-0\" aria-hidden=\"true\">\n<md-tooltip>{{vm.parent.name}}</md-tooltip></md-icon><md-icon ng-if=\"vm.parent.id_group_type == 7\" \nmd-svg-src=\"/assets/icons/svg/icon-folder-chat.svg\" class=\"{{vm.parent.color}}-fg s24 mt-0 ml-0 mb-0\" \naria-hidden=\"true\"><md-tooltip>{{vm.parent.name}}</md-tooltip></md-icon><md-icon ng-if=\"vm.parent.id_group_type == 8\" \nmd-font-icon=\"icon-folder-remove\" class=\"{{vm.parent.color}}-fg s24 mt-0 ml-0 mb-0\" aria-hidden=\"true\"><md-tooltip>\n{{vm.parent.name}}</md-tooltip></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"mr-5\"></md-icon>");
$templateCache.put("app/main/apps/users/users-blacklist/views/read/read-view-nosplit.html","<div flex layout=\"column\" layout-align=\"center center\" ng-if=\"vm.loadingReadPane\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"30\"></md-progress-circular></div><div \nng-show=\"!vm.loadingReadPane\"><div class=\"mail-content\" layout=\"column\" layout-align=\"center center\" \nng-if=\"!vm.selectedContent\"><div class=\"content\" layout=\"column\" layout-align=\"top center\"><div class=\"message\">\nPlease select an item to show in this panel</div></div></div><div class=\"toolbar grey-100-bg colored-bg\" layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"vm.selectedContent\" scroll=\"\"><div layout=\"row\" layout-align=\"start center\">\n<md-button class=\"md-icon-button close-thread\" ng-if=\"vm.currentView === \'table\'\" aria-label=\"Back\" \nng-click=\"vm.closeThread()\" translate translate-attr-aria-label=\"CONTENT.BACK\"><md-icon \nmd-font-icon=\"icon-arrow-right\"></md-icon></md-button><div class=\"divider-vertical\" hide=\"\" \nng-if=\"vm.activeMailPaneIndex === 1 || vm.currentView === \'table\'\" show-gt-sm=\"\"></div><md-button aria-label=\"Preview\" \nclass=\"md-icon-button\" ng-class=\"{\'md-accent\':vm.currentTab == \'preview\'}\" ng-click=\"vm.viewPreview()\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.PREVIEW\"><md-icon md-font-icon=\"icon-eye\"></md-icon><md-tooltip hide show-gt-xs>\n<span translate=\"CONTENT.PREVIEW\">Preview</span></md-tooltip></md-button><div class=\"divider-vertical\" hide=\"\" \nshow-gt-sm=\"\"></div><md-button aria-label=\"Edit\" class=\"md-icon-button\" \nng-class=\"{\'md-accent\':vm.currentTab == \'edit\'}\" ng-click=\"vm.viewEditInline();\" translate=\"\" \ntranslate-attr-aria-label=\"CONTENT.EDIT\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip hide show-gt-xs>\n<span translate=\"CONTENT.EDIT\">Edit</span></md-tooltip></md-button><div class=\"divider-vertical\" hide=\"\" show-gt-sm=\"\">\n</div><md-button aria-label=\"Activity\" class=\"md-icon-button\" ng-class=\"{\'md-accent\':vm.currentTab == \'activity\'}\" \nng-click=\"vm.currentTab = \'activity\'\" translate=\"\" translate-attr-aria-label=\"Activities\"><md-icon \nmd-font-icon=\"icon-run\"></md-icon><md-tooltip><span translate=\"ACCOUNTS.ACTIVITY\"></span></md-tooltip></md-button><div \nclass=\"divider-vertical\" hide=\"\" show-gt-sm=\"\"></div><md-button ng-if=\"vm.selectedContentID != \'new\'\" \naria-label=\"Activity\" class=\"md-icon-button\" ng-class=\"{\'md-accent\':vm.currentTab == \'mailing\'}\" \nng-click=\"vm.currentTab = \'mailing\'\" translate=\"\" translate-attr-aria-label=\"Mailing\"><md-icon \nmd-font-icon=\"icon-telegram\"></md-icon><md-tooltip><span translate=\"USERS.MAILING\"></span></md-tooltip></md-button><div\n ng-if=\"vm.loginUrl\" class=\"divider-vertical\" hide=\"\" show-gt-sm=\"\"></div><md-button \nng-if=\"vm.selectedGroup && vm.userInvitationUrlIndividual\" aria-label=\"Invite to Group\" class=\"md-icon-button\" \nng-click=\"vm.inviteToGroupIndividual(vm.selectedContent, vm.selectedGroup)\" translate=\"\" \ntranslate-attr-aria-label=\"USERS.INVITE_TO_GROUP\"><md-icon md-font-icon=\"icon-email\"></md-icon><md-tooltip><span \ntranslate=\"USERS.INVITE_TO_GROUP\"></span></md-tooltip><p ng-if=\"vm.loginUrl\"><a \nng-click=\"vm.inviteToGroupIndividual(vm.selectedContent, vm.selectedGroup)\"><md-icon md-font-icon=\"icon-person-plus\" \nclass=\"m-0\"></md-icon><span class=\"font-size-15\" translate=\"USERS.INVITE_TO_GROUP\"></span></a></p></md-button>\n<md-button ng-if=\"vm.selectedGroup && vm.userInvitationUrlPreview\" aria-label=\"Preview Invitation\" \nclass=\"md-icon-button\" ng-click=\"vm.inviteToGroupPreview(vm.selectedContent, vm.selectedGroup)\" translate=\"\" \ntranslate-attr-aria-label=\"USERS.PREVIEW_INVITATION_TO_GROUP\"><md-icon md-font-icon=\"icon-email-open\"></md-icon>\n<md-tooltip><span translate=\"USERS.PREVIEW_INVITATION_TO_GROUP\"></span></md-tooltip><p ng-if=\"vm.loginUrl\"><a \nng-click=\"vm.inviteToGroupPreview(vm.selectedContent, vm.selectedGroup)\"><md-icon md-font-icon=\"icon-person-plus\" \nclass=\"m-0\"></md-icon><span class=\"font-size-15\" translate=\"USERS.PREVIEW_INVITATION_TO_GROUP\"></span></a></p>\n</md-button><div ng-if=\"vm.loginUrl\" class=\"divider-vertical\" hide=\"\" show-gt-sm=\"\"></div><md-button \nng-if=\"vm.loginUrl\" aria-label=\"Login to website\" class=\"md-icon-button\" \nng-click=\"vm.loginToWebsite(vm.selectedContent)\" translate=\"\" translate-attr-aria-label=\"GLOBAL.LOGIN_TO_WEBSITE\">\n<md-icon md-font-icon=\"icon-web\"></md-icon><md-tooltip><span translate=\"GLOBAL.LOGIN_TO_WEBSITE\"></span></md-tooltip><p\n ng-if=\"vm.loginUrl\"><a ng-click=\"vm.loginToWebsite(vm.selectedContent)\"><md-icon md-font-icon=\"icon-web\" class=\"m-0\">\n</md-icon><span class=\"font-size-15\" translate=\"GLOBAL.LOGIN_TO_WEBSITE\"></span></a></p></md-button></div><div \nlayout=\"row\" layout-align=\"end center\" ng-if=\"vm.currentThread_Edit\" hide show-gt-xs><md-button type=\"submit\" \nng-click=\"vm.saveItem(vm.currentThread_Edit)\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.basicForm.$invalid || vm.basicForm.$pristine\" aria-label=\"SAVE\" translate=\"CONTENT.SAVE\" \ntranslate-attr-aria-label=\"CONTENT.SAVE\">SAVE</md-button><md-button type=\"button\" ng-click=\"vm.closeThreadEdit()\" \nclass=\"md-raised md-warn\" aria-label=\"Cancel\">Cancel</md-button></div><div layout=\"row\" layout-align=\"end center\" \nng-if=\"vm.currentThread_Edit\" hide-gt-xs><md-button type=\"submit\" ng-click=\"vm.saveItem(vm.currentThread_Edit)\" \nclass=\"md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme\" \nng-disabled=\"vm.basicForm.$invalid || vm.basicForm.$pristine\" aria-label=\"SAVE\"><md-icon md-font-icon=\"icon-check\" \nng-hide=\"vm.savingProcess\"></md-icon><md-progress-circular md-mode=\"indeterminate\" ng-if=\"vm.savingProcess\">\n</md-progress-circular><md-tooltip hide show-gt-xs><span translate=\"CONTENT.SAVE\">Save</span></md-tooltip></md-button>\n<md-button type=\"button\" ng-click=\"vm.closeThreadEdit()\" \nclass=\"md-warn md-fab md-mini md-accent md-raised md-ink-ripple md-default-theme\" aria-label=\"Cancel\"><md-icon \nmd-font-icon=\"icon-window-close\"></md-icon><md-tooltip hide show-gt-xs><span translate=\"CONTENT.CANCEL\">Cancel</span>\n</md-tooltip></md-button></div></div><md-content flex=\"\" ng-show=\"vm.selectedContent && !vm.editInline\"><div \nclass=\"mail-content file-details scrollable\" ms-scroll=\"vm.msScrollOptions\"><md-list><md-list-item class=\"info\" \nng-if=\"vm.selectedContent_refgrouped.header[0]\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\" \nlayout-align=\"start start\"><div ng-repeat=\"field in vm.selectedContent_refgrouped.header | orderBy:\'preview_sort\' \" \nclass=\"header-element\" layout=\"row\" layout-align=\"center center\"><div><span ng-if=\"field.type==\'user_status\'\"><button \nng-if=\"vm.selectedContent[field.title]===0\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\"></md-icon></button> <button \nng-if=\"vm.selectedContent[field.title]===1\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-minus-circle\" \nclass=\"on amber-400-fg s24\"></md-icon></button> <button ng-if=\"vm.selectedContent[field.title]===2\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\"></md-icon></button> \n<button \nng-if=\"vm.selectedContent[field.title]!==0 && vm.selectedContent[field.title]!==1 && vm.selectedContent[field.title]!==2\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"on grey-fg s24\"></md-icon></button> \n</span><span ng-if=\"field.type==\'dateHm\' || field.type==\'date\'\"><span>{{vm.selectedContent[field.title].dateShow}}\n</span> </span><span ng-if=\"field.type==\'language\'\" layout=\"row\" layout-align=\"center center\"><img \nclass=\"img-flag ng-scope\" alt=\"{{vm.siteLanguages(vm.selectedContent[field.title])[lang_name]}}\" \nng-src=\"assets/images/flags/{{vm.siteLanguages()[vm.selectedContent[field.title]].flag_code|lowercase}}.svg\"> </span>\n<span ng-if=\"field.type==\'id_subsec\' && vm.selectedContent[field.title].length!=0\"><span class=\"grey-500-fg\">\n{{field.field_name}} </span><span \nng-bind=\"vm.getReferencesSections(\'subsection\', field.type, vm.selectedContent[field.title])\"></span> </span><span \nng-if=\"field.type==\'id_cat\' && vm.selectedContent[field.title].length!=0\"><span class=\"grey-500-fg\">\n{{field.field_name}} </span><span \nng-bind=\"vm.getReferencesSections(\'cat\', field.type, vm.selectedContent[field.title])\"></span> </span><span \nng-if=\"field.type==\'id_subcat\' && vm.selectedContent[field.title].length!=0\"><span class=\"grey-500-fg\">\n{{field.field_name}} </span><span \nng-bind=\"vm.getReferencesSections(\'subcat\', field.type, vm.selectedContent[field.title])\"></span></span></div></div>\n</div></md-list-item><md-list-item class=\"main-item\"><div class=\"main-read\"><div class=\"avatar-container\"><div \nng-if=\"vm.selectedContent.avatar == \'\' || !vm.selectedContent.avatar\" class=\"avatar {{vm.selectedColor}}\" \nng-bind=\"vm.selectedContent[\'firstname\'] | capitalizeFirstLetter\"></div><media \nng-if=\"vm.selectedContent.avatar && vm.selectedContent.avatar !== \'\'\" attachment=\"vm.selectedContent.avatar\" \nclass=\"avatar fix\"></media><div \nng-repeat=\"field in vm.selectedContent_refgrouped.user_status | orderBy:\'preview_sort\' \" class=\"status\"><span \nng-if=\"field.type==\'user_status\'\"><button ng-if=\"vm.selectedContent[field.title]===0\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\"></md-icon></button> <button \nng-if=\"vm.selectedContent[field.title]===1\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-minus-circle\" \nclass=\"on amber-400-fg s24\"></md-icon></button> <button ng-if=\"vm.selectedContent[field.title]===2\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\"></md-icon></button> \n<button \nng-if=\"vm.selectedContent[field.title]!==0 && vm.selectedContent[field.title]!==1 && vm.selectedContent[field.title]!==2\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"on grey-fg s24\"></md-icon></button>\n</span></div></div></div><div class=\"main-read\" layout=\"column\" layout-align=\"center start \"><div \nng-repeat=\"field in vm.selectedContent_refgrouped.header_main | orderBy:\'preview_sort\' \" class=\"header-element\" \nlayout=\"row\" layout-align=\"center center\"><p ng-if=\"field.type==\'id\'\" class=\"font-size-14\"><span class=\"grey-500-fg\">\nID # </span><span class=\"grey-500-fg\" ng-bind=\"vm.selectedContent[field.title]\"></span></p></div><h1 class=\"name\">\n<strong ng-repeat=\"field in vm.selectedContent_refgrouped.main | orderBy:\'preview_sort\' \" \nng-bind=\"vm.selectedContent[field.title]\" class=\"mr-10\"></strong></h1></div><md-divider></md-divider></md-list-item>\n<div ng-repeat=\"field in vm.selectedContent_refgrouped.secondary | orderBy:\'preview_sort\' \"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg\" ng-if=\"field.type==\'label\'\"><h3 class=\"grey-700-fg\" ng-bind=\"field.field_name\">\n</h3><md-divider></md-divider></md-list-item><md-list-item flex=\"100\" ng-if=\"field.type!==\'label\'\" ng-switch=\"\" \non=\"field.type\"><div class=\"text-truncate\" ng-switch-when=\"html\"><div class=\"field\"><p \nclass=\"grey-500-fg font-size-14\" ng-bind=\"field.field_name\"></p><span class=\"font-size-16 text-truncate\" \nng-bind-html=\"vm.selectedContent[field.title]\"></span><br></div><md-divider></md-divider></div><div \nclass=\"text-truncate\" ng-switch-when=\"status\"><div class=\"field\"><p class=\"grey-500-fg font-size-14\" \nng-bind=\"field.field_name\"></p><span class=\"font-size-16 text-truncate {{vm.selectedContent[field.title]|yesNo}}\" \nng-bind-html=\"vm.selectedContent[field.title]|yesNo\"></span><br></div><md-divider></md-divider></div><div \nclass=\"text-truncate\" ng-switch-when=\"country\"><div class=\"field\"><p class=\"grey-500-fg font-size-14 ng-binding\" \nng-bind=\"field.field_name\"></p><span ng-if=\"vm.getCountryById(vm.selectedContent[field.title]).name\" \nclass=\"font-size-16 text-truncate\" ng-bind-html=\"vm.getCountryById(vm.selectedContent[field.title]).name\"></span> <span\n ng-if=\"!vm.getCountryById(vm.selectedContent[field.title]).name\" class=\"font-size-16 text-truncate\">-</span><br></div>\n<md-divider></md-divider></div><div class=\"text-truncate\" ng-switch-when=\"state\"><div class=\"field\"><p \nclass=\"grey-500-fg font-size-14 ng-binding\" ng-bind=\"field.field_name\"></p><span \nng-if=\"vm.selectedContent.related_state.name\" class=\"font-size-16 text-truncate\" \nng-bind-html=\"vm.selectedContent.related_state.name\"></span> <span ng-if=\"!vm.selectedContent.related_state.name\" \nclass=\"font-size-16 text-truncate\">-</span><br></div><md-divider></md-divider></div><div class=\"text-truncate\" \nng-switch-when=\"city\"><div class=\"field\"><p class=\"grey-500-fg font-size-14 ng-binding\" ng-bind=\"field.field_name\"></p>\n<span ng-if=\"vm.selectedContent.related_city.city\" class=\"font-size-16 text-truncate\" \nng-bind-html=\"vm.selectedContent.related_city.city\"></span> <span ng-if=\"!vm.selectedContent.related_city.city\" \nclass=\"font-size-16 text-truncate\">-</span><br></div><md-divider></md-divider></div><div class=\"files\" \nng-switch-when=\"files\"><div \nng-if=\"vm.selectedContent.files[field.title] && vm.selectedContent.files[field.title].length> 0\" layout=\"column\"><div \nclass=\"mail-list-item attachment mv-5 pointer\" ng-repeat=\"document in vm.selectedContent.files[field.title]\" \ndata-id=\"{{document.id}}\"><a style=\"text-decoration: none\" href=\"{{document.url}}\" target=\"_blank\"><div layout=\"row\" \nlayout-align=\"start center\"><div fill-width layout=\"row\" layout-align=\"start center\"><div flex=\"20\" flex-xs=\"20\" \nflex-gt-md=\"20\" flex-gt-lg=\"20\" class=\"media photos text-right pv-5 m-0\" layout=\"row\" layout-align=\"start center\">\n<qiu-icon mediafile=\"document.filename\" class=\"mr-10\"></qiu-icon></div><div flex=\"80\" flex-gt-md=\"80\" flex-gt-lg=\"80\" \nclass=\"info ph-10 pv-5 m-0\" style=\"padding: 0px 0px\" flex layout=\"column\"><p \nclass=\"grey-500-fg font-size-16 ng-binding mb-5 mt-0\" ng-bind=\"field.field_name\"></p><div class=\"subject grey-500-fg\" \nlayout=\"row\" layout-align=\"start center\"><span>{{vm.showDate(document.date_uploaded)}}</span></div><div class=\"name\" \nlayout=\"row\" layout-align=\"start center\"><span ng-if=\"document.filename\">{{document.filename}}</span></div><div \nclass=\"name\" layout=\"row\" layout-align=\"start center\"><span ng-if=\"document.filename\">{{document.field}}</span></div>\n</div></div></div></a></div></div></div><div class=\"text-truncate\" ng-switch-when=\"button\"><div class=\"field\" \nng-init=\"fieldRaw = field.raw_settings\"><md-button type=\"button\" \nng-click=\"vm.buttonClick($event, fieldRaw, vm.selectedContent)\" \nclass=\"{{ fieldRaw.font_icon ? \'md-icon-button\' : \'md-raised\' }} {{ fieldRaw.background_color ? fieldRaw.background_color+\'-bg\' : \'\' }} {{ fieldRaw.foreground_color ? fieldRaw.foreground_color+\'-fg\' : \'\' }}\" \naria-label=\"{{field.field_name}}\" ng-disabled=\"vm.isSending\" translate-attr-aria-label=\"GENERIC.BUTTON.RUN\"><span \nng-if=\"!fieldRaw.font_icon\">{{field.field_name}}</span><md-icon ng-if=\"fieldRaw.font_icon\" \nmd-font-icon=\"icon-{{fieldRaw.font_icon}}\" class=\"s24 mr-20\" \nng-style=\"fieldRaw.foreground_color && {\'color\': fieldRaw.foreground_color}\"></md-icon><md-tooltip><span>\n{{field.field_name}}</span></md-tooltip></md-button><md-divider></md-divider></div></div><div class=\"text-truncate\" \nflex=\"100\" ng-switch-default=\"\"><div class=\"field\"><p class=\"grey-500-fg font-size-14\" ng-bind=\"field.field_name\"></p>\n<span ng-if=\"field.category!=\'input_related\' && vm.isNumber(vm.selectedContent[field.title])\" \nclass=\"font-size-16 text-truncate\" ng-bind-html=\"vm.selectedContent[field.title]\"></span> <span \nng-if=\"field.category!=\'input_related\' && !vm.isNumber(vm.selectedContent[field.title])\" \nclass=\"font-size-16 text-truncate\" ng-bind-html=\"vm.selectedContent[field.title]| autoLinkerFilter\"></span> <span \nng-if=\"field.category==\'input_related\'\" class=\"font-size-16 text-truncate\">\n{{vm.getInArray(\'id_\'+field.config,field.values, vm.selectedContent[field.title], field.config)}}</span><br></div>\n<md-divider></md-divider></div></md-list-item></div><div ng-if=\"vm.selectedContent.tags\"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg\"><h3 class=\"grey-700-fg\" translate=\"CONTENT.ATTACHMENTS\">\nTags ({{vm.selectedContent.tags.length}})</h3><md-divider></md-divider></md-list-item><md-list-item><md-chips \nname=\"tag_name\" ng-model=\"vm.selectedContent.tags\" readonly=\"true\"><md-chip-template><span>\n{{$chip.tag_name}} #{{$chip.id_tag}}</span></md-chip-template></md-chips><md-divider></md-divider></md-list-item></div>\n<div ng-if=\"vm.selectedContent.Thumbnail\"><md-list-item class=\"md-toolbar-tools grey-100-bg\"><h3 class=\"grey-700-fg\" \ntranslate=\"CONTENT.ATTACHMENTS\">Attachments ({{vm.selectedContent.Thumbnail.length}})</h3><md-divider></md-divider>\n</md-list-item><md-list-item ng-repeat=\"zone in vm.mediaZones\" ng-if=\"vm.mediaZones\"><div class=\"attachments\"><div \nclass=\"field\"><p class=\"grey-500-fg font-size-14\">{{ zone.title }}</p><div class=\"attachment-list md-list-item-text\" \nlayout=\"row\" layout-wrap=\"\" layout-align=\"start start\"><div class=\"attachment\" \nng-repeat=\"attachment in vm.selectedContent.Thumbnail | filter: {\'id_zone\':zone.id_zone}\"><div \nclass=\"preview document\" layout=\"row\" layout-align=\"start center\" extension-class=\"{{attachment.filename}}\" \nng-href=\"{{attachment.permalink}}\" ng-if=\"attachment.media_type==3\" target=\"_blank\"><media attachment=\"attachment\">\n</media><a class=\"grey-1000-fg font-size-16\" ng-href=\"{{attachment.permalink}}\" target=\"_blank\"><span \nng-if=\"attachment.title\">{{attachment.title}} </span><span ng-if=\"attachment.filename\">{{attachment.filename}}</span>\n</a></div><div class=\"preview document\" layout=\"row\" layout-align=\"start center\" \nextension-class=\"{{attachment.filename}}\" ng-href=\"{{attachment.permalink}}\" ng-if=\"attachment.media_type==4\" \ntarget=\"_blank\"><media attachment=\"attachment\"></media><a class=\"grey-1000-fg font-size-16\" \nng-href=\"{{attachment.permalink}}\" target=\"_blank\"><span ng-if=\"attachment.filename\">{{attachment.filename}}</span></a>\n</div><div ng-if=\"attachment.media_type==1 || attachment.media_type==2\"><div class=\"ms-card\" flex \nmd-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"ms-card-content-wrapper\"><div class=\"template-9\"><div \nclass=\"media media-attachment\" flex layout=\"row\" layout-align=\"center center\"><div flex \nng-click=\"vm.openImageDialog($event, vm.selectedContent.Thumbnail, attachment)\"><media attachment=\"attachment\" \ncrop-format=\"{{zone.id_cropformats}}\"></media></div></div><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"size block\" layout=\"row\" layout-align=\"start center\"><strong \nclass=\"mr-5\">#{{attachment.id_media}}</strong> <span class=\"grey-500-fg\">| <span ng-if=\"attachment.filename\">\n{{attachment.filename}}</span> <span ng-if=\"attachment.title\">{{attachment.title}}</span></span></div><md-icon \nmd-font-icon=\"icon-eye\" class=\"s16 ml-10\" href=\"#\" \nng-click=\"vm.openImageDialog($event, vm.selectedContent.Thumbnail, attachment)\"></md-icon></div></div></div></div>\n</div></div></div></div></div></md-list-item><md-list-item ng-if=\"!vm.mediaZones\"><div class=\"attachments\"><div \nclass=\"field\"><p class=\"grey-500-fg font-size-14\" translate=\"CONTENT.NO_ZONE\"></p><div \nclass=\"attachment-list md-list-item-text\" layout=\"row\" layout-wrap=\"\" layout-align=\"start start\"><div \nclass=\"attachment\" ng-repeat=\"attachment in vm.selectedContent.Thumbnail | filter: {\'id_zone\':\'!\'}\"><div \nclass=\"preview document\" layout=\"row\" layout-align=\"start center\" extension-class=\"{{attachment.filename}}\" \nng-href=\"{{attachment.permalink}}\" ng-if=\"attachment.media_type==3\" target=\"_blank\"><media attachment=\"attachment\">\n</media><a class=\"grey-1000-fg font-size-16\" ng-href=\"{{attachment.permalink}}\" target=\"_blank\"><span \nng-if=\"attachment.title\">{{attachment.title}} </span><span ng-if=\"attachment.filename\">{{attachment.filename}}</span>\n</a></div><div class=\"preview document\" layout=\"row\" layout-align=\"start center\" \nextension-class=\"{{attachment.filename}}\" ng-href=\"{{attachment.permalink}}\" ng-if=\"attachment.media_type==4\" \ntarget=\"_blank\"><media attachment=\"attachment\"></media><a class=\"grey-1000-fg font-size-16\" \nng-href=\"{{attachment.permalink}}\" target=\"_blank\"><span ng-if=\"attachment.filename\">{{attachment.filename}}</span></a>\n</div><div ng-if=\"attachment.media_type==1 || attachment.media_type==2\"><div class=\"ms-card\" flex \nmd-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"ms-card-content-wrapper\"><div class=\"template-9\"><div \nclass=\"media media-attachment\" flex layout=\"row\" layout-align=\"center center\"><div flex \nng-click=\"vm.openImageDialog($event, vm.selectedContent.Thumbnail, attachment)\"><media attachment=\"attachment\" \ncrop-format=\"{{zone.id_cropformats}}\"></media></div></div><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"size block\" layout=\"row\" layout-align=\"start center\"><strong \nclass=\"mr-5\">#{{attachment.id_media}}</strong> <span class=\"grey-500-fg\">| <span ng-if=\"attachment.filename\">\n{{attachment.filename}}</span> <span ng-if=\"attachment.title\">{{attachment.title}}</span></span></div><md-icon \nmd-font-icon=\"icon-eye\" class=\"s16 ml-10\" href=\"#\" \nng-click=\"vm.openImageDialog($event, vm.selectedContent.Thumbnail, attachment)\"></md-icon></div></div></div></div>\n</div></div></div></div></div><md-divider></md-divider></md-list-item></div><md-list-item \nclass=\"md-toolbar-tools grey-100-bg\"><h3 class=\"grey-700-fg\" translate=\"CONTENT.LATESTACTIVITY\">Latest Activity</h3>\n<md-divider></md-divider></md-list-item><div class=\"activities\"><div class=\"activity\" layout=\"row\" \nlayout-align=\"start center\" ng-repeat=\"activity in vm.log | limitTo: vm.paginationLimit()\"><img \nalt=\"{{content.from.name}}\" class=\"avatar\" ng-if=\"activity.user.avatar\" ng-src=\"{{activity.username}}\"><div \nclass=\"avatar\" ng-if=\"!activity.user.avatar\" ng-style=\"{\'background-color\':activity.user.profile_color}\">\n{{activity.user.firstname[0] | capitalize}}</div><div layout=\"column\"><div><span class=\"username md-accent-color\" \nng-if=\"activity.user.firstname.length>0 || activity.user.lastname.length>0\">\n{{activity.user.firstname}} {{activity.user.lastname}} </span><span class=\"message\">{{activity.message}}</span></div>\n<span class=\"time secondary-text\">{{activity.date}}</span></div></div><button \nclass=\"md-raised md-button md-default-theme md-ink-ripple\" ng-click=\"vm.showMoreItems()\" \nng-show=\"vm.hasMoreItemsToShow()\"><span>Show more</span></button></div></md-list></div></md-content><md-content \nng-if=\"vm.editInline && vm.selectedContent\" ng-include=\"\'app/main/apps/users/views/read/edit-preview.html\'\" \nclass=\"scrollable\"></md-content><md-content ng-if=\"vm.currentTab === \'activity\'\" \nng-include=\"\'app/main/apps/users/views/read/timeline.html\'\"></md-content><md-content \nng-if=\"vm.currentTab === \'mailing\'\" ng-include=\"\'app/main/apps/users/views/read/mailing.html\'\"></md-content></div>");
$templateCache.put("app/main/apps/users/users-blacklist/views/read/read-view.html","<div flex layout=\"column\" layout-align=\"center center\" ng-if=\"vm.loadingReadPane\" class=\"loading-container\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div><div \nng-show=\"!vm.loadingReadPane\"><div style=\"z-index: 99; background-color: white\" class=\"mail-content\" layout=\"column\" \nlayout-align=\"center center\" ng-if=\"!vm.selectedContent\"><div class=\"content\" layout=\"column\" \nlayout-align=\"top center\"><div class=\"message\">Please select an item to show in this panel</div></div></div><div \nclass=\"toolbar grey-100-bg colored-bg\" layout=\"row\" layout-align=\"space-between center\" ng-if=\"vm.selectedContent\" \nscroll=\"\"><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button close-thread\" \naria-label=\"Back\" ng-click=\"vm.closeThread()\" \nng-if=\"vm.currentThread && (vm.currentView==\'nosplit\' || vm.groupsView) \" translate \ntranslate-attr-aria-label=\"CONTENT.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button>\n<md-button class=\"md-icon-button close-thread\" ng-if=\"vm.currentView === \'table\'\" aria-label=\"Back\" \nng-click=\"vm.closeThread()\" translate translate-attr-aria-label=\"CONTENT.BACK\"><md-icon \nmd-font-icon=\"icon-arrow-right\"></md-icon></md-button><div class=\"divider-vertical\" hide=\"\" \nng-if=\"vm.activeMailPaneIndex === 1 || vm.currentView === \'table\'\" show-gt-sm=\"\"></div><md-button \nng-if=\"vm.selectedContentID != \'new\'\" aria-label=\"Activity\" class=\"md-icon-button\" \nng-class=\"{\'md-accent\':vm.currentTab == \'mailing\'}\" ng-click=\"vm.currentTab = \'mailing\'\" translate=\"\" \ntranslate-attr-aria-label=\"Mailing\"><md-icon md-font-icon=\"icon-telegram\"></md-icon><md-tooltip><span \ntranslate=\"USERS.MAILING\"></span></md-tooltip></md-button><div class=\"divider-vertical\" hide=\"\" show-gt-sm=\"\"></div>\n<md-button ng-if=\"vm.selectedGroup && vm.userInvitationUrlIndividual\" aria-label=\"Invite to Group\" \nclass=\"md-icon-button\" ng-click=\"vm.inviteToGroupIndividual(vm.selectedContent, vm.selectedGroup)\" translate=\"\" \ntranslate-attr-aria-label=\"USERS.INVITE_TO_GROUP\"><md-icon md-font-icon=\"icon-email\"></md-icon><md-tooltip><span \ntranslate=\"USERS.INVITE_TO_GROUP\"></span></md-tooltip><p ng-if=\"vm.loginUrl\"><a \nng-click=\"vm.inviteToGroupIndividual(vm.selectedContent, vm.selectedGroup)\"><md-icon md-font-icon=\"icon-person-plus\" \nclass=\"m-0\"></md-icon><span class=\"font-size-15\" translate=\"USERS.INVITE_TO_GROUP\"></span></a></p></md-button>\n<md-button ng-if=\"vm.selectedGroup && vm.userInvitationUrlIndividual\" aria-label=\"Preview Invitation\" \nclass=\"md-icon-button\" ng-click=\"vm.inviteToGroupPreview(vm.selectedContent, vm.selectedGroup)\" translate=\"\" \ntranslate-attr-aria-label=\"USERS.PREVIEW_INVITATION_TO_GROUP\"><md-icon md-font-icon=\"icon-email-open\"></md-icon>\n<md-tooltip><span translate=\"USERS.PREVIEW_INVITATION_TO_GROUP\"></span></md-tooltip><p ng-if=\"vm.loginUrl\"><a \nng-click=\"vm.inviteToGroupPrevbiew(vm.selectedContent, vm.selectedGroup)\"><md-icon md-font-icon=\"icon-person-plus\" \nclass=\"m-0\"></md-icon><span class=\"font-size-15\" translate=\"USERS.PREVIEW_INVITATION_TO_GROUP\"></span></a></p>\n</md-button><div ng-if=\"vm.loginUrl\" class=\"divider-vertical\" hide=\"\" show-gt-sm=\"\"></div><md-button \nng-if=\"vm.loginUrl\" aria-label=\"Login to website\" class=\"md-icon-button\" \nng-click=\"vm.loginToWebsite(vm.selectedContent)\" translate=\"\" translate-attr-aria-label=\"GLOBAL.LOGIN_TO_WEBSITE\">\n<md-icon md-font-icon=\"icon-web\"></md-icon><md-tooltip><span translate=\"GLOBAL.LOGIN_TO_WEBSITE\"></span></md-tooltip><p\n ng-if=\"vm.loginUrl\"><a ng-click=\"vm.loginToWebsite(vm.selectedContent)\"><md-icon md-font-icon=\"icon-web\" class=\"m-0\">\n</md-icon><span class=\"font-size-15\" translate=\"GLOBAL.LOGIN_TO_WEBSITE\"></span></a></p></md-button></div></div>\n<md-content flex=\"\" ng-show=\"vm.selectedContent && !vm.editInline && vm.currentTab === \'preview\'\"><div \nclass=\"mail-content file-details scrollable\" ms-scroll=\"vm.msScrollOptions\"><md-list><md-list-item class=\"info\" \nng-if=\"vm.selectedContent_refgrouped.header[0]\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\" \nlayout-align=\"start start\"><div ng-repeat=\"field in vm.selectedContent_refgrouped.header | orderBy:\'preview_sort\' \" \nclass=\"header-element\" layout=\"row\" layout-align=\"center center\"><div><span ng-if=\"field.type==\'user_status\'\"><button \nng-if=\"vm.selectedContent[field.title]===0\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\"></md-icon></button> <button \nng-if=\"vm.selectedContent[field.title]===1\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-minus-circle\" \nclass=\"on amber-400-fg s24\"></md-icon></button> <button ng-if=\"vm.selectedContent[field.title]===2\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\"></md-icon></button> \n<button ng-if=\"vm.selectedContent[field.title]===99\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle\" class=\"on black-fg s24\"></md-icon></button> <button \nng-if=\"vm.selectedContent[field.title]!==0 && vm.selectedContent[field.title]!==1 && vm.selectedContent[field.title]!==2 && vm.selectedContent[field.title]!==99\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"on grey-fg s24\"></md-icon></button> \n</span><span ng-if=\"field.type==\'dateHm\' || field.type==\'date\'\"><span>{{vm.selectedContent[field.title].dateShow}}\n</span> </span><span ng-if=\"field.type==\'language\'\" layout=\"row\" layout-align=\"center center\"><img \nclass=\"img-flag ng-scope\" alt=\"{{vm.siteLanguages(vm.selectedContent[field.title])[lang_name]}}\" \nng-src=\"assets/images/flags/{{vm.siteLanguages()[vm.selectedContent[field.title]].flag_code|lowercase}}.svg\"> </span>\n<span ng-if=\"field.type==\'id_subsec\' && vm.selectedContent[field.title].length!=0\"><span class=\"grey-500-fg\">\n{{field.field_name}} </span><span \nng-bind=\"vm.getReferencesSections(\'subsection\', field.type, vm.selectedContent[field.title])\"></span> </span><span \nng-if=\"field.type==\'id_cat\' && vm.selectedContent[field.title].length!=0\"><span class=\"grey-500-fg\">\n{{field.field_name}} </span><span \nng-bind=\"vm.getReferencesSections(\'cat\', field.type, vm.selectedContent[field.title])\"></span> </span><span \nng-if=\"field.type==\'id_subcat\' && vm.selectedContent[field.title].length!=0\"><span class=\"grey-500-fg\">\n{{field.field_name}} </span><span \nng-bind=\"vm.getReferencesSections(\'subcat\', field.type, vm.selectedContent[field.title])\"></span></span></div></div>\n</div></md-list-item><md-list-item class=\"main-item\"><div class=\"main-read\"><div class=\"avatar-container\"><div \nng-if=\"vm.selectedContent.avatar == \'\' || !vm.selectedContent.avatar\" class=\"avatar {{vm.selectedColor}}\" \nng-bind=\"vm.selectedContent[\'firstname\'] | capitalizeFirstLetter\"></div><div \nng-if=\"vm.selectedContent.avatar && vm.selectedContent.avatar !== \'\'\" class=\"avatar\"><img \nng-src=\"{{vm.selectedContent.avatar}}\" alt=\"\"></div><div \nng-repeat=\"field in vm.selectedContent_refgrouped.user_status | orderBy:\'preview_sort\' \" class=\"status\"><span \nng-if=\"field.type==\'user_status\'\"><button ng-if=\"vm.selectedContent[field.title]===0\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\"></md-icon></button> <button \nng-if=\"vm.selectedContent[field.title]===1\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-minus-circle\" \nclass=\"on amber-400-fg s24\"></md-icon></button> <button ng-if=\"vm.selectedContent[field.title]===2\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\"></md-icon></button> \n<button ng-if=\"vm.selectedContent[field.title]===99\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle\" class=\"on black-fg s24\"></md-icon></button> <button \nng-if=\"vm.selectedContent[field.title]!==0 && vm.selectedContent[field.title]!==1 && vm.selectedContent[field.title]!==2 && vm.selectedContent[field.title]!==99\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"on grey-fg s24\"></md-icon></button>\n</span></div></div></div><div class=\"main-read\" layout=\"column\" layout-align=\"center start \"><div \nng-repeat=\"field in vm.selectedContent_refgrouped.header_main | orderBy:\'preview_sort\' \" class=\"header-element\" \nlayout=\"row\" layout-align=\"center center\"><p ng-if=\"field.type==\'id\'\" class=\"font-size-14\"><span class=\"grey-500-fg\">\nID # </span><span class=\"grey-500-fg\" ng-bind=\"vm.selectedContent[field.title]\"></span></p></div><h1 class=\"name\">\n<strong ng-repeat=\"field in vm.selectedContent_refgrouped.main | orderBy:\'preview_sort\' \" \nng-bind=\"vm.selectedContent[field.title]\" class=\"mr-10\"></strong></h1></div><md-divider></md-divider></md-list-item>\n<div ng-repeat=\"field in vm.selectedContent_refgrouped.secondary | orderBy:\'preview_sort\' \"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg\" ng-if=\"field.type==\'label\'\"><h3 class=\"grey-700-fg\" ng-bind=\"field.field_name\">\n</h3><md-divider></md-divider></md-list-item><md-list-item class=\"md-toolbar-tools\" \nng-if=\"field.category == \'show_groups_as_field\'\"><div class=\"text-truncate\"><div class=\"field\"><p \nclass=\"grey-500-fg font-size-14\" ng-bind=\"field.field_name\"></p><span style=\"white-space: nowrap\" \nclass=\"font-size-16 text-truncate\">{{vm.getGroupNames(field)}}</span><br></div><md-divider></md-divider></div>\n</md-list-item><md-list-item flex=\"100\" \nng-if=\"field.type!==\'label\' && field.category !== \'show_groups_as_field\' && !(field.hide_if_empty && !vm.selectedContent[field.title])\" \nng-switch=\"\" on=\"field.type\"><div class=\"text-truncate\" ng-switch-when=\"html\"><div class=\"field\"><p \nclass=\"grey-500-fg font-size-14\" ng-bind=\"field.field_name\"></p><span class=\"font-size-16 text-truncate\" \nng-bind-html=\"vm.selectedContent[field.title]\"></span><br></div><md-divider></md-divider></div><div \nclass=\"text-truncate\" ng-switch-when=\"status\"><div class=\"field\"><p class=\"grey-500-fg font-size-14\" \nng-bind=\"field.field_name\"></p><span class=\"font-size-16 text-truncate {{vm.selectedContent[field.title]|yesNo}}\" \nng-bind-html=\"vm.selectedContent[field.title]|yesNo\"></span><br></div><md-divider></md-divider></div><div \nclass=\"text-truncate\" ng-switch-when=\"country\"><div class=\"field\"><p class=\"grey-500-fg font-size-14 ng-binding\" \nng-bind=\"field.field_name\"></p><span ng-if=\"vm.getCountryById(vm.selectedContent[field.title]).name\" \nclass=\"font-size-16 text-truncate\" ng-bind-html=\"vm.getCountryById(vm.selectedContent[field.title]).name\"></span> <span\n ng-if=\"!vm.getCountryById(vm.selectedContent[field.title]).name\" class=\"font-size-16 text-truncate\">-</span><br></div>\n<md-divider></md-divider></div><div class=\"text-truncate\" ng-switch-when=\"state\"><div class=\"field\"><p \nclass=\"grey-500-fg font-size-14 ng-binding\" ng-bind=\"field.field_name\"></p><span \nng-if=\"vm.selectedContent.related_state.name\" class=\"font-size-16 text-truncate\" \nng-bind-html=\"vm.selectedContent.related_state.name\"></span> <span ng-if=\"!vm.selectedContent.related_state.name\" \nclass=\"font-size-16 text-truncate\">-</span><br></div><md-divider></md-divider></div><div class=\"text-truncate\" \nng-switch-when=\"city\"><div class=\"field\"><p class=\"grey-500-fg font-size-14 ng-binding\" ng-bind=\"field.field_name\"></p>\n<span ng-if=\"vm.selectedContent.related_city.city\" class=\"font-size-16 text-truncate\" \nng-bind-html=\"vm.selectedContent.related_city.city\"></span> <span ng-if=\"!vm.selectedContent.related_city.city\" \nclass=\"font-size-16 text-truncate\">-</span><br></div><md-divider></md-divider></div><div class=\"text-truncate\" \nng-switch-when=\"mailing_priority\"><div class=\"field\"><p class=\"grey-500-fg font-size-14 ng-binding\" \nng-bind=\"field.field_name\"></p><span class=\"font-size-16 text-truncate\" ng-repeat=\"prior in vm.mailingPriority\" \nng-bind=\"prior.name\" \nng-if=\"vm.selectedContent.mailing_priority >= prior.min && vm.selectedContent.mailing_priority <= prior.max\" \nclass=\"font-size-16 text-truncate\"></span><br></div><md-divider></md-divider></div><div class=\"files\" \nng-switch-when=\"files\"><div \nng-if=\"vm.selectedContent.files[field.title] && vm.selectedContent.files[field.title].length> 0\" layout=\"column\"><div \nclass=\"mail-list-item attachment mv-5 pointer\" ng-repeat=\"document in vm.selectedContent.files[field.title]\" \ndata-id=\"{{document.id}}\"><a style=\"text-decoration: none\" href=\"{{document.url}}\" target=\"_blank\"><div layout=\"row\" \nlayout-align=\"start center\"><div fill-width layout=\"row\" layout-align=\"start center\"><div flex=\"20\" flex-gt-md=\"20\" \nflex-gt-lg=\"20\" class=\"media photos text-right pv-5\" layout=\"row\" layout-align=\"start center\"><qiu-icon \nmediafile=\"document.filename\" class=\"mr-10\"></qiu-icon></div><div flex=\"80\" flex-gt-md=\"80\" flex-gt-lg=\"80\" \nclass=\"info ph-10 pv-5 m-0\" style=\"padding: 0px\" flex layout=\"column\"><p \nclass=\"grey-500-fg font-size-16 ng-binding mb-5 mt-0\" ng-bind=\"field.field_name\"></p><div class=\"subject grey-500-fg\" \nlayout=\"row\" layout-align=\"start center\"><span>{{vm.showDate(document.date_uploaded)}}</span></div><div class=\"name\" \nlayout=\"row\" layout-align=\"start center\"><span ng-if=\"document.filename\">{{document.filename}}</span></div><div \nclass=\"name\" layout=\"row\" layout-align=\"start center\"><span ng-if=\"document.filename\">{{document.field}}</span></div>\n</div></div></div></a></div></div></div><div class=\"text-truncate\" ng-switch-when=\"button\"><div class=\"field\" \nng-init=\"fieldRaw = field.raw_settings\"><md-button type=\"button\" \nng-click=\"vm.buttonClick($event, fieldRaw, vm.selectedContent)\" \nclass=\"{{ fieldRaw.font_icon ? \'md-icon-button\' : \'md-raised\' }} {{ fieldRaw.background_color ? fieldRaw.background_color+\'-bg\' : \'\' }} {{ fieldRaw.foreground_color ? fieldRaw.foreground_color+\'-fg\' : \'\' }}\" \naria-label=\"{{field.field_name}}\" ng-disabled=\"vm.isSending\" translate-attr-aria-label=\"GENERIC.BUTTON.RUN\"><span \nng-if=\"!fieldRaw.font_icon\">{{field.field_name}}</span><md-icon ng-if=\"fieldRaw.font_icon\" \nmd-font-icon=\"icon-{{fieldRaw.font_icon}}\" class=\"s24 mr-20\" \nng-style=\"fieldRaw.foreground_color && {\'color\': fieldRaw.foreground_color}\"></md-icon><md-tooltip><span>\n{{field.field_name}}</span></md-tooltip></md-button></div><md-divider></md-divider></div><div class=\"text-truncate\" \nflex=\"100\" ng-switch-default=\"\"><div class=\"field\"><p class=\"grey-500-fg font-size-14\" ng-bind=\"field.field_name\"></p>\n<span ng-if=\"field.category!=\'input_related\' && vm.isNumber(vm.selectedContent[field.title])\" \nclass=\"font-size-16 text-truncate\" ng-bind-html=\"vm.selectedContent[field.title]\"></span> <span \nng-if=\"field.category!=\'input_related\' && vm.hasDateShow(vm.selectedContent[field.title])\" \nclass=\"font-size-16 text-truncate\" ng-bind-html=\"vm.hasDateShow(vm.selectedContent[field.title])\"></span> <span \nng-if=\"field.category!=\'input_related\' && !vm.isNumber(vm.selectedContent[field.title]) && !vm.hasDateShow(vm.selectedContent[field.title]) && vm.selectedContent[field.title]\" \nclass=\"font-size-16 text-truncate\" ng-bind-html=\"vm.selectedContent[field.title]| autoLinkerFilter\"></span> <span \nng-if=\"field.category!=\'input_related\' && !vm.isNumber(vm.selectedContent[field.title]) && !vm.selectedContent[field.title]\" \nclass=\"font-size-16 text-truncate\">-</span> <span ng-if=\"field.category==\'input_related\'\" \nclass=\"font-size-16 text-truncate\">\n{{vm.getInArray(\'id_\'+field.config,field.values, vm.selectedContent[field.title], field.config)}}</span><br></div>\n<md-divider></md-divider></div></md-list-item></div><div ng-if=\"vm.selectedContent.tags\"><md-list-item \nclass=\"md-toolbar-tools grey-100-bg\"><h3 class=\"grey-700-fg\" translate=\"CONTENT.ATTACHMENTS\">\nTags ({{vm.selectedContent.tags.length}})</h3><md-divider></md-divider></md-list-item><md-list-item><md-chips \nname=\"tag_name\" ng-model=\"vm.selectedContent.tags\" readonly=\"true\"><md-chip-template><span>\n{{$chip.tag_name}} #{{$chip.id_tag}}</span></md-chip-template></md-chips><md-divider></md-divider></md-list-item></div>\n<div ng-if=\"vm.selectedContent.Thumbnail\"><md-list-item class=\"md-toolbar-tools grey-100-bg\"><h3 class=\"grey-700-fg\" \ntranslate=\"CONTENT.ATTACHMENTS\">Attachments ({{vm.selectedContent.Thumbnail.length}})</h3><md-divider></md-divider>\n</md-list-item><md-list-item ng-repeat=\"zone in vm.mediaZones\" ng-if=\"vm.mediaZones\"><div class=\"attachments\"><div \nclass=\"field\"><p class=\"grey-500-fg font-size-14\">{{ zone.title }}</p><div class=\"attachment-list md-list-item-text\" \nlayout=\"row\" layout-wrap=\"\" layout-align=\"start start\"><div class=\"attachment\" \nng-repeat=\"attachment in vm.selectedContent.Thumbnail | filter: {\'id_zone\':zone.id_zone}\"><div \nclass=\"preview document\" layout=\"row\" layout-align=\"start center\" extension-class=\"{{attachment.filename}}\" \nng-href=\"{{attachment.permalink}}\" ng-if=\"attachment.media_type==3\" target=\"_blank\"><media attachment=\"attachment\">\n</media><a class=\"grey-1000-fg font-size-16\" ng-href=\"{{attachment.permalink}}\" target=\"_blank\"><span \nng-if=\"attachment.title\">{{attachment.title}} </span><span ng-if=\"attachment.filename\">{{attachment.filename}}</span>\n</a></div><div class=\"preview document\" layout=\"row\" layout-align=\"start center\" \nextension-class=\"{{attachment.filename}}\" ng-href=\"{{attachment.permalink}}\" ng-if=\"attachment.media_type==4\" \ntarget=\"_blank\"><media attachment=\"attachment\"></media><a class=\"grey-1000-fg font-size-16\" \nng-href=\"{{attachment.permalink}}\" target=\"_blank\"><span ng-if=\"attachment.filename\">{{attachment.filename}}</span></a>\n</div><div ng-if=\"attachment.media_type==1 || attachment.media_type==2\"><div class=\"ms-card\" flex \nmd-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"ms-card-content-wrapper\"><div class=\"template-9\"><div \nclass=\"media media-attachment\" flex layout=\"row\" layout-align=\"center center\"><div flex \nng-click=\"vm.openImageDialog($event, vm.selectedContent.Thumbnail, attachment)\"><media attachment=\"attachment\" \ncrop-format=\"{{zone.id_cropformats}}\"></media></div></div><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"size block\" layout=\"row\" layout-align=\"start center\"><strong \nclass=\"mr-5\">#{{attachment.id_media}}</strong> <span class=\"grey-500-fg\">| <span ng-if=\"attachment.filename\">\n{{attachment.filename}}</span> <span ng-if=\"attachment.title\">{{attachment.title}}</span></span></div><md-icon \nmd-font-icon=\"icon-eye\" class=\"s16 ml-10\" href=\"#\" \nng-click=\"vm.openImageDialog($event, vm.selectedContent.Thumbnail, attachment)\"></md-icon></div></div></div></div>\n</div></div></div></div></div></md-list-item><md-list-item ng-if=\"!vm.mediaZones\"><div class=\"attachments\"><div \nclass=\"field\"><p class=\"grey-500-fg font-size-14\" translate=\"CONTENT.NO_ZONE\"></p><div \nclass=\"attachment-list md-list-item-text\" layout=\"row\" layout-wrap=\"\" layout-align=\"start start\"><div \nclass=\"attachment\" ng-repeat=\"attachment in vm.selectedContent.Thumbnail | filter: {\'id_zone\':\'!\'}\"><div \nclass=\"preview document\" layout=\"row\" layout-align=\"start center\" extension-class=\"{{attachment.filename}}\" \nng-href=\"{{attachment.permalink}}\" ng-if=\"attachment.media_type==3\" target=\"_blank\"><media attachment=\"attachment\">\n</media><a class=\"grey-1000-fg font-size-16\" ng-href=\"{{attachment.permalink}}\" target=\"_blank\"><span \nng-if=\"attachment.title\">{{attachment.title}} </span><span ng-if=\"attachment.filename\">{{attachment.filename}}</span>\n</a></div><div class=\"preview document\" layout=\"row\" layout-align=\"start center\" \nextension-class=\"{{attachment.filename}}\" ng-href=\"{{attachment.permalink}}\" ng-if=\"attachment.media_type==4\" \ntarget=\"_blank\"><media attachment=\"attachment\"></media><a class=\"grey-1000-fg font-size-16\" \nng-href=\"{{attachment.permalink}}\" target=\"_blank\"><span ng-if=\"attachment.filename\">{{attachment.filename}}</span></a>\n</div><div ng-if=\"attachment.media_type==1 || attachment.media_type==2\"><div class=\"ms-card\" flex \nmd-dynamic-height=\"{{vm.dynamicHeight}}\"><div class=\"ms-card-content-wrapper\"><div class=\"template-9\"><div \nclass=\"media media-attachment\" flex layout=\"row\" layout-align=\"center center\"><div flex \nng-click=\"vm.openImageDialog($event, vm.selectedContent.Thumbnail, attachment)\"><media attachment=\"attachment\" \ncrop-format=\"{{zone.id_cropformats}}\"></media></div></div><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"size block\" layout=\"row\" layout-align=\"start center\"><strong \nclass=\"mr-5\">#{{attachment.id_media}}</strong> <span class=\"grey-500-fg\">| <span ng-if=\"attachment.filename\">\n{{attachment.filename}}</span> <span ng-if=\"attachment.title\">{{attachment.title}}</span></span></div><md-icon \nmd-font-icon=\"icon-eye\" class=\"s16 ml-10\" href=\"#\" \nng-click=\"vm.openImageDialog($event, vm.selectedContent.Thumbnail, attachment)\"></md-icon></div></div></div></div>\n</div></div></div></div></div><md-divider></md-divider></md-list-item></div><md-list-item \nclass=\"md-toolbar-tools grey-100-bg\"><h3 class=\"grey-700-fg\">{{ \'USERS.USERS_GROUPS\' | translate}}</h3><md-divider>\n</md-divider></md-list-item><md-list-item class=\"p-0\" ng-if=\"vm.groupTypesWithCurrentLabelsEdit\"><div \nclass=\"content-wrapper users-edit-group\" flex layout=\"column\"><div \nclass=\"content thread-list mail-list-pane flex-100 border-bottom\"><div \nng-repeat=\"groupType in vm.groupTypesWithCurrentLabelsEdit\" ng-if=\"groupType.labelsEdit\" class=\"user-type-group\"><h3 \nclass=\"m-0 ph-24 pv-10 grey-100-bg\"><strong>{{groupType.name}}</strong></h3><div \nng-repeat=\"item in groupType.labelsEdit track by $index\" class=\"mail-list-item\" role=\"button\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"info\" flex layout=\"row\" layout-align=\"space-between center\"><div class=\"name\" \nlayout=\"row\" layout-align=\"start center\" flex=\"100\"><div class=\"group-name\" layout=\"row\" layout-align=\"start center\" \nflex=\"100\"><parent-group ng-if=\"item.group.parentGroup\" parent=\"item.group.parentGroup\"></parent-group><md-icon \nclass=\"{{item.group.color}}-fg icon-folder md-font-icon mr-10 s24 mt-0 ml-0 mb-0\" \nng-class=\"{\'icon-folder\':item.group.id_group_type == 1, \'qiu-icon-file-usermailing\':item.group.id_group_type == 2,\'qiu-icon-file-usermediacenter\':item.group.id_group_type == 3,\'qiu-icon-file-usersegment\':item.group.id_group_type == 4,\'qiu-icon-file-userstore\':item.group.id_group_type == 5,\'qiu-icon-file-useracreditation\':item.group.id_group_type == 6,\'icon-folder\':item.group.id_group_type == 7,\'icon-folder-remove\':item.group.id_group_type == 8}\" \naria-hidden=\"true\"></md-icon><span>{{item.label}}</span></div></div><div class=\"buttons\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"status-wrapper text-center\" layout=\"row\" layout-align=\"end center\" \nng-repeat=\"i in item.group.ingroup_status | filter: {\'id_ingroup_status\' : item.group.id_ingroup_status} : true\"><div>\n<span class=\"{{i.name}} status\" layout=\"row\" layout-align=\"center center\">{{i.name}}</span></div></div></div></div>\n</div></div></div></div></div><md-divider></md-divider></md-list-item><md-list-item \nclass=\"md-toolbar-tools grey-100-bg\"><h3 class=\"grey-700-fg\" translate=\"CONTENT.LATESTACTIVITY\">Latest Activity</h3>\n<md-divider></md-divider></md-list-item><div class=\"activities\"><div class=\"activity\" layout=\"row\" \nlayout-align=\"start center\" ng-repeat=\"activity in vm.log | limitTo: vm.paginationLimit()\"><img \nalt=\"{{content.from.name}}\" class=\"avatar\" ng-if=\"activity.user.avatar\" ng-src=\"{{activity.username}}\"><div \nclass=\"avatar\" ng-if=\"!activity.user.avatar\" ng-style=\"{\'background-color\':activity.user.profile_color}\">\n{{activity.user.firstname[0] | capitalize}}</div><div layout=\"column\"><div><span class=\"username md-accent-color\" \nng-if=\"activity.user.firstname.length>0 || activity.user.lastname.length>0\">\n{{activity.user.firstname}} {{activity.user.lastname}} </span><span class=\"message\">{{activity.message}}</span></div>\n<span class=\"time secondary-text\">{{activity.date}}</span></div></div><button \nclass=\"md-raised md-button md-default-theme md-ink-ripple\" ng-click=\"vm.showMoreItems()\" \nng-show=\"vm.hasMoreItemsToShow()\"><span>Show more</span></button></div></md-list></div></md-content><md-content \nng-if=\"vm.currentTab === \'edit\'\" ng-include=\"\'app/main/apps/users/views/read/edit-preview.html\'\" class=\"scrollable\">\n</md-content><md-content ng-if=\"vm.currentTab === \'activity\'\" \nng-include=\"\'app/main/apps/users/views/read/timeline.html\'\"></md-content><md-content \nng-if=\"vm.currentTab === \'mailing\'\" ng-include=\"\'app/main/apps/users/users-blacklist/views/read/mailing.html\'\">\n</md-content></div>");
$templateCache.put("app/main/apps/match-center/views/list/sports-templates/football/match-template.html","<div class=\"field\" flex layout=\"row\"><div ng-if=\"match.teams_data.length !== 2\" flex><span ng-if=\"match.match_name\" \nclass=\"font-size-16 grey-700-fg\" ng-bind=\"match.match_name\"></span> <span ng-if=\"!match.match_name\" \nclass=\"font-size-16 grey-700-fg\">Incomplete information</span></div><div ng-if=\"match.teams_data.length == 2\" \nlayout=\"row\" layout-align=\"center center\" flex><div layout=\"row\" flex style=\"line-height: 40px\" \nclass=\"font-size-16 grey-700-fg match-football-content\"><span flex=\"35\" layout=\"column\" layout-gt-xs=\"row\" \nlayout-align=\"center center\" layout-align-gt-xs=\"end center\" class=\"team-a\"><strong class=\"text-center\">\n{{match.teams_data[0].team_name}}</strong> <img ng-if=\"match.teams_data[0].media\" class=\"avatar no-border mh-15\" \nng-src=\"{{match.teams_data[0].media}}\" alt=\"\"> <img \nng-if=\"!match.teams_data[0].media && (!match.teams_data[0].Thumbnail || match.teams_data[0].Thumbnail.length == 0)\" \nclass=\"avatar mh-15\" ng-src=\"assets/images/common/no_image_available_10.png\" imageonload> </span><span flex=\"30\" \nlayout=\"row\" layout-align=\"center center\" class=\"status mh-10\"><span \nng-if=\"match.status > 3 || !match.status || !match.date\"><strong \nng-if=\"match.teams_data[0].penalties > 0 || match.teams_data[1].penalties > 0\">({{match.teams_data[0].penalties}})\n</strong> <strong>{{match.teams_data[0].score}}</strong> - <strong>{{match.teams_data[1].score}}</strong> <strong \nng-if=\"match.teams_data[0].penalties > 0 || match.teams_data[1].penalties > 0\">({{match.teams_data[1].penalties}})\n</strong> </span><span ng-if=\"match.status <= 3  && match.date && match.status\">\n{{match.date | amDateFormat:\'DD MMM YYYY\'}} </span></span><span flex=\"35\" layout=\"column\" layout-gt-xs=\"row\" \nlayout-align=\"center center\" layout-align-gt-xs=\"start center\" class=\"team-b\"><img ng-if=\"match.teams_data[1].media\" \nclass=\"avatar no-border mh-15\" ng-src=\"{{match.teams_data[1].media}}\" alt=\"\"> <img \nng-if=\"!match.teams_data[1].media && (!match.teams_data[1].Thumbnail || match.teams_data[1].Thumbnail.length == 0)\" \nclass=\"avatar mh-15\" ng-src=\"assets/images/common/no_image_available_10.png\" imageonload> <strong class=\"text-center\">\n{{match.teams_data[1].team_name}}</strong></span></div></div></div><div layout=\"row\" layout-align=\"end center\"><div>\n<button ng-if=\"match.onoff===1\" class=\"md-icon-button md-button\" ng-click=\"vm.toggleItemStatusMatch(match, $event)\">\n<md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\"></md-icon></button> <button \nng-if=\"match.onoff!==1\" class=\"md-icon-button md-button\" ng-click=\"vm.toggleItemStatusMatch(match, $event)\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\"></md-icon></button></div><md-menu><md-button \nclass=\"md-icon-button\" aria-label=\"More\" ng-click=\"vm.openMenu($mdMenu, $event)\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/more_vert.svg\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button ng-click=\"vm.seeUpdate = false;vm.openMatch($event, vm.matches[$index].id)\" aria-label=\"Edit\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon><span translate=\"MATCH_CENTER.EDIT\"></span></md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.seeUpdate = false;vm.deleteMatch($event, $index)\" aria-label=\"Delete\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-default-theme md-font material-icons icon-delete\"></md-icon>Remove</md-button>\n</md-menu-item></md-menu-content></md-menu></div>");
$templateCache.put("app/main/apps/match-center/views/list/sports-templates/football/standings-template.html","<div id=\"standings\" class=\"simple-table-container md-whiteframe-4dp\"><div class=\"ms-responsive-table-wrapper\"><table \nclass=\"simple\" ms-responsive-table=\"\"><thead><tr><th></th><th translate=\"MATCH_CENTER.TEAMS\"></th><th>PT</th><th>PJ\n</th><th>PG</th><th>PE</th><th>PP</th><th>GF</th><th>GC</th><th></th></tr></thead><tfoot><tr><td></td></tr></tfoot>\n<tbody ng-sortable=\"vm.templateSortable\"><tr class=\"template flex standings-row drag-item\" \nng-repeat=\"row in vm.currentCompetitionSeason.results track by $index\"><td>{{row.position}}</td><td>{{row.name}}</td>\n<td>{{row.pt}}</td><td>{{row.pj}}</td><td>{{row.pg}}</td><td>{{row.pe}}</td><td>{{row.pp}}</td><td>{{row.gf}}</td><td>\n{{row.gc}}</td><td><md-icon class=\"drag icon-equal\" aria-label=\"DRAG\"></md-icon></td></tr></tbody></table></div></div>");
$templateCache.put("app/main/apps/match-center/views/list/sports-templates/football/team-template.html","<div ng-if=\"vm.showTeams\" ng-sortable=\"vm.templateSortable\"><div class=\"template flex team-row drag-item\" layout=\"row\" \nng-repeat=\"team in vm.currentMatch.teams_data track by $index\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon class=\"drag icon-equal\" aria-label=\"DRAG\"></md-icon><img ng-if=\"team.media\" \nclass=\"avatar\" ng-src=\"{{team.media}}\" alt=\"\"> <img ng-if=\"!team.media\" class=\"avatar\" \nng-src=\"assets/images/common/no_image_available_10.png\" imageonload><div class=\"field ml-10\" layout=\"column\"><div>\n<strong class=\"font-size-16 grey-700-fg\" ng-bind=\"team.team_name\"></strong></div></div></div><div layout=\"row\" \nlayout-align=\"end center\"><span class=\"score-box\"><div style=\"min-width: 70px; text-align: center\" \nng-show=\"!editModeScore\"><span class=\"score font-size-16 grey-700-fg mr-5\" ng-hide=\"editModeScore\">{{team.score}}\n</span><md-icon ng-click=\"editModeScore=true\" md-font-icon=\"icon-pencil pointer\"></md-icon></div><div \nclass=\"edit-mode\" ng-show=\"editModeScore\"><md-input-container style=\"margin: 0px\"><input \non-enter=\"editModeScore=false\" on-esc=\"editModeScore=false\" ng-model=\"team.score\" aria-label=\"Edit Mode\">\n</md-input-container><md-icon ng-click=\"editModeScore=false\" md-font-icon=\"icon-check pointer\"></md-icon></div></span>\n<span ng-if=\"vm.currentMatch.results_data.final_type == 3\" class=\"score-box\"><div \nstyle=\"min-width: 70px; text-align: center\" ng-show=\"!editPenalties\"><span class=\"score font-size-16 grey-700-fg mr-5\" \nng-hide=\"editPenalties\">{{team.penalties}}</span><md-icon ng-click=\"editPenalties=true\" \nmd-font-icon=\"icon-pencil pointer\"></md-icon></div><div class=\"edit-mode\" ng-show=\"editPenalties\"><md-input-container \nstyle=\"margin: 0px\"><input on-enter=\"editPenalties=false\" on-esc=\"editPenalties=false\" ng-model=\"team.penalties\">\n</md-input-container><md-icon ng-click=\"editPenalties=false\" md-font-icon=\"icon-check pointer\"></md-icon></div></span>\n<md-menu><md-button class=\"md-icon-button\" aria-label=\"More\" ng-click=\"vm.openMenu($mdMenu, $event)\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/more_vert.svg\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button ng-click=\"vm.openTeamEditDialog($event, $index)\" aria-label=\"Edit\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon><span translate=\"MATCH_CENTER.EDIT_SQUAD\"></span></md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.deleteTeamMatch($index)\" aria-label=\"Delete\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon><span translate=\"GLOBAL.DELETE\"></span></md-button></md-menu-item></md-menu-content></md-menu></div></div>\n</div>");
$templateCache.put("app/main/apps/match-center/views/list/sports-templates/cars/match-template.html","<div class=\"field\" flex layout=\"row\"><div flex><span ng-if=\"match.match_name\" class=\"font-size-16 grey-700-fg\" \nng-bind=\"match.match_name\"></span> <span ng-if=\"!match.match_name\" class=\"font-size-16 grey-700-fg\">\nIncomplete information</span></div></div><div layout=\"row\" layout-align=\"end center\"><div><button \nng-if=\"match.onoff===1\" class=\"md-icon-button md-button\" ng-click=\"vm.toggleItemStatusMatch(match, $event)\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\"></md-icon></button> <button ng-if=\"match.onoff!==1\" \nclass=\"md-icon-button md-button\" ng-click=\"vm.toggleItemStatusMatch(match, $event)\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\"></md-icon></button></div><md-menu><md-button \nclass=\"md-icon-button\" aria-label=\"More\" ng-click=\"vm.openMenu($mdMenu, $event)\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/more_vert.svg\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button ng-click=\"vm.seeUpdate = false;vm.openMatch($event,vm.matches[$index].id)\" aria-label=\"Edit\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon><span translate=\"MATCH_CENTER.EDIT\"></span></md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.seeUpdate = false;vm.deleteMatch($event, $index)\" aria-label=\"Delete\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-default-theme md-font material-icons icon-delete\"></md-icon>Remove</md-button>\n</md-menu-item></md-menu-content></md-menu></div>");
$templateCache.put("app/main/apps/match-center/views/list/sports-templates/cars/standings-template.html","<div style=\"min-height: 45px\" layout=\"row\" class=\"tabs\"><div class=\"tab\" \nng-class=\"{\'active\' : vm.activeTabStandings == \'drivers\'}\" ng-click=\"vm.activeTabStandings= \'drivers\'\">\n{{ \'CARS.DRIVERS\' | translate}}</div><div class=\"tab\" ng-class=\"{\'active\' : vm.activeTabStandings == \'teams\'}\" \nng-if=\"vm.currentCompetitionSeason.result_type == 2\" ng-click=\"vm.activeTabStandings= \'teams\'\">\n{{ \'CARS.TEAMS\' | translate}}</div></div><div ng-if=\"vm.activeTabStandings == \'drivers\'\" id=\"standings\" \nclass=\"simple-table-container md-whiteframe-4dp\"><div class=\"ms-responsive-table-wrapper\"><table \nng-if=\"vm.currentCompetitionSeason.results && vm.currentCompetitionSeason.results.length> 0\" class=\"simple\" \nms-responsive-table=\"\"><thead><tr><th></th><th translate=\"CARS.TEAM\"></th><th translate=\"MATCH_CENTER.ELAPSED_TIME\">\n</th><th class=\"col-sancion\" translate=\"CARS.PENALTIES\"></th><th class=\"col-sancion\" translate=\"CARS.REPRIMANDS\"></th>\n<th translate=\"MATCH_CENTER.TOTAL\"></th><th></th></tr></thead><tfoot><tr><td></td></tr></tfoot><tbody \nng-sortable=\"vm.templateSortable\"><tr class=\"template flex standings-row drag-item\" \nng-repeat=\"row in vm.currentCompetitionSeason.results track by $index\"><td>{{row.position}}</td><td>{{row.team_name}}\n</td><td>{{row.elapsed_time}}</td><td class=\"col-sancion\"><input type=\"number\" step=\"1\" min=\"0\" class=\"input-sancion\" \nng-model=\"row._penalizacion\" ng-change=\"vm.recalcularSanciones()\" ng-blur=\"vm.guardarSanciones()\" \naria-label=\"{{ \'CARS.PENALTIES\' | translate }}\"></td><td class=\"col-sancion\"><input type=\"number\" step=\"1\" min=\"0\" \nclass=\"input-sancion\" ng-model=\"row.reprimands\" ng-blur=\"vm.guardarSanciones()\" \naria-label=\"{{ \'CARS.REPRIMANDS\' | translate }}\"></td><td><span>{{row.points}}</span> <span class=\"puntos-brutos\" \nng-if=\"row._penalizacion\">({{ \'CARS.GROSS_POINTS\' | translate }}: {{row._puntosBrutos}})</span></td><td><md-icon \nclass=\"drag icon-equal\" aria-label=\"DRAG\"></md-icon></td></tr></tbody></table></div></div><div \nng-if=\"vm.activeTabStandings == \'teams\'\" id=\"standings\" class=\"simple-table-container md-whiteframe-4dp\"><div \nclass=\"ms-responsive-table-wrapper\"><table \nng-if=\"vm.currentCompetitionSeason.resultsGrouped && vm.currentCompetitionSeason.resultsGrouped.length> 0\" \nclass=\"simple\" ms-responsive-table=\"\"><thead><tr><th></th><th translate=\"MATCH_CENTER.TEAMS\"></th><th \nng-repeat=\"race in vm.currentCompetitionSeason.resultsGrouped[0].races\">{{race.race}}</th><th \ntranslate=\"MATCH_CENTER.TOTAL\"></th></tr></thead><tfoot><tr><td></td></tr></tfoot><tbody \nng-sortable=\"vm.templateSortable\"><tr class=\"template flex standings-row drag-item\" \nng-repeat=\"row in vm.currentCompetitionSeason.resultsGrouped track by $index\"><td>{{$index + 1}}</td><td>\n{{row.constructor}}</td><td ng-repeat=\"race in row.races\">{{race.points}} <span ng-if=\"race.extra\">({{race.extra}})\n</span></td><td>{{row.total}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/main/apps/match-center/views/list/sports-templates/cars/team-template.html","<div ng-if=\"vm.showTeams\" ng-sortable=\"vm.templateSortable\"><div class=\"template flex team-row drag-item\" layout=\"row\" \nng-repeat=\"team in vm.currentMatch.teams_data track by $index\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon class=\"drag icon-equal mr-5\" aria-label=\"DRAG\"></md-icon><img ng-if=\"team.media\" \nclass=\"avatar\" ng-src=\"{{team.media}}\" alt=\"\"> <img ng-if=\"!team.media\" class=\"avatar\" \nng-src=\"assets/images/common/no_image_available_10.png\" imageonload><div class=\"field\" layout=\"column\"><div><strong \nclass=\"font-size-16 grey-700-fg\" ng-bind=\"team.team_name\"></strong></div></div></div><div layout=\"row\" \nlayout-align=\"end center\"><div class=\"score-box\"><div style=\"min-width: 60px; text-align: center\" \nng-show=\"!editModeScore\"><span class=\"score font-size-14 grey-700-fg mr-5\" ng-hide=\"editModeScore\">{{team.points}}\n</span><md-icon ng-click=\"editModeScore=true\" md-font-icon=\"icon-pencil pointer\"></md-icon></div><div \nclass=\"edit-mode\" ng-show=\"editModeScore\"><md-input-container style=\"margin: 0px\"><input \non-enter=\"editModeScore=false\" on-esc=\"editModeScore=false\" ng-model=\"team.points\" aria-label=\"Team Points\">\n</md-input-container><md-icon ng-click=\"editModeScore=false\" md-font-icon=\"icon-check pointer\"></md-icon></div></div>\n<div class=\"score-box\"><div style=\"min-width: 80px; text-align: center\" ng-show=\"!editModeStatus\"><span \nclass=\"score font-size-16 grey-700-fg mr-5\" ng-hide=\"editModeStatus\">{{team.status.value}}</span><md-icon \nng-click=\"vm.openTeamEditStatusDialog($event, $index)\" md-font-icon=\"icon-pencil pointer\"></md-icon></div></div><div \nclass=\"score-box\"><div style=\"min-width: 80px; text-align: center\" ng-show=\"!editExtra\"><span \nclass=\"score font-size-16 grey-700-fg mr-5\" ng-hide=\"editExtra\">{{team.extra}}</span><md-icon \nng-click=\"editExtra=true\" md-font-icon=\"icon-pencil pointer\"></md-icon></div><div class=\"edit-mode\" \nng-show=\"editExtra\"><md-input-container style=\"margin: 0px\"><input on-enter=\"editExtra=false\" on-esc=\"editExtra=false\" \nng-model=\"team.extra\" aria-label=\"Team Extra\"></md-input-container><md-icon ng-click=\"editExtra=false\" \nmd-font-icon=\"icon-check pointer\"></md-icon></div></div><div class=\"score-box big\"><div \nclass=\"time-picker-inline-table\"><mdp-time-picker mdp-placeholder=\"--:--:--\" mdp-format=\"HH:mm:ss\" \nng-model=\"team.start_time\" class=\"date-time-picker\"></mdp-time-picker></div></div><div class=\"score-box big\"><div \nclass=\"time-picker-inline-table\"><mdp-time-picker mdp-placeholder=\"--:--:--\" mdp-format=\"HH:mm:ss\" \nng-model=\"team.end_time\" class=\"date-time-picker\"></mdp-time-picker></div></div><div class=\"score-box big\">\n<md-input-container style=\"margin: 0px\"><input ng-model=\"team.elapsed_time\" aria-label=\"Elapsed time\">\n</md-input-container></div><div class=\"score-box big\"><md-input-container style=\"margin: 0px\"><input \nng-model=\"team.delta\" aria-label=\"Delta\"></md-input-container></div><md-menu><md-button class=\"md-icon-button\" \naria-label=\"More\" ng-click=\"vm.openMenu($mdMenu, $event)\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/more_vert.svg\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button ng-click=\"vm.openTeamEditDialog($event, $index)\" aria-label=\"Edit\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon><span translate=\"MATCH_CENTER.EDIT_SQUAD\"></span></md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.deleteTeamMatch($index)\" aria-label=\"Delete\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon><span translate=\"GLOBAL.DELETE\"></span></md-button></md-menu-item></md-menu-content></md-menu></div></div>\n</div>");
$templateCache.put("app/main/apps/match-center/views/list/sports-templates/tennis/match-template.html","<div class=\"field\" flex layout=\"row\"><div flex><span ng-if=\"match.match_name\" class=\"font-size-16 grey-700-fg\" \nng-bind=\"match.match_name\"></span> <span ng-if=\"!match.match_name\" class=\"font-size-16 grey-700-fg\">\nIncomplete information</span></div></div><div layout=\"row\" layout-align=\"end center\"><div><button \nng-if=\"match.onoff===1\" class=\"md-icon-button md-button\" ng-click=\"vm.toggleItemStatusMatch(match, $event)\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\"></md-icon></button> <button ng-if=\"match.onoff!==1\" \nclass=\"md-icon-button md-button\" ng-click=\"vm.toggleItemStatusMatch(match, $event)\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\"></md-icon></button></div><md-menu><md-button \nclass=\"md-icon-button\" aria-label=\"More\" ng-click=\"vm.openMenu($mdMenu, $event)\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/more_vert.svg\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button ng-click=\"vm.seeUpdate = false;vm.openMatch($event,vm.matches[$index].id)\" aria-label=\"Edit\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon><span translate=\"MATCH_CENTER.EDIT\"></span></md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.seeUpdate = false;vm.deleteMatch($event, $index)\" aria-label=\"Delete\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-default-theme md-font material-icons icon-delete\"></md-icon>Remove</md-button>\n</md-menu-item></md-menu-content></md-menu></div>");
$templateCache.put("app/main/apps/match-center/views/list/sports-templates/tennis/standings-template.html","<div style=\"min-height: 45px\" layout=\"row\" class=\"tabs\"><div class=\"tab\" \nng-class=\"{\'active\' : vm.activeTabStandings == \'drivers\'}\" ng-click=\"vm.activeTabStandings= \'drivers\'\">\n{{ \'CARS.DRIVERS\' | translate}}</div><div class=\"tab\" ng-class=\"{\'active\' : vm.activeTabStandings == \'teams\'}\" \nng-if=\"vm.currentCompetitionSeason.result_type == 2\" ng-click=\"vm.activeTabStandings= \'teams\'\">\n{{ \'CARS.TEAMS\' | translate}}</div></div><div ng-if=\"vm.activeTabStandings == \'drivers\'\" id=\"standings\" \nclass=\"simple-table-container md-whiteframe-4dp\"><div class=\"ms-responsive-table-wrapper\"><table \nng-if=\"vm.currentCompetitionSeason.results && vm.currentCompetitionSeason.results.length> 0\" class=\"simple\" \nms-responsive-table=\"\"><thead><tr><th></th><th translate=\"CARS.DRIVERS\"></th><th \nng-repeat=\"race in vm.currentCompetitionSeason.results[0].races\">{{race.race}}</th><th translate=\"MATCH_CENTER.TOTAL\">\n</th></tr></thead><tfoot><tr><td></td></tr></tfoot><tbody ng-sortable=\"vm.templateSortable\"><tr \nclass=\"template flex standings-row drag-item\" ng-repeat=\"row in vm.currentCompetitionSeason.results track by $index\">\n<td>{{row.position}}</td><td>{{row.team_name}}</td><td ng-repeat=\"race in row.races\">{{race.points}} <span \nng-if=\"race.extra\">({{race.extra}})</span></td><td>{{row.total}}</td></tr></tbody></table></div></div><div \nng-if=\"vm.activeTabStandings == \'teams\'\" id=\"standings\" class=\"simple-table-container md-whiteframe-4dp\"><div \nclass=\"ms-responsive-table-wrapper\"><table \nng-if=\"vm.currentCompetitionSeason.resultsGrouped && vm.currentCompetitionSeason.resultsGrouped.length> 0\" \nclass=\"simple\" ms-responsive-table=\"\"><thead><tr><th></th><th translate=\"MATCH_CENTER.TEAMS\"></th><th \nng-repeat=\"race in vm.currentCompetitionSeason.resultsGrouped[0].races\">{{race.race}}</th><th \ntranslate=\"MATCH_CENTER.TOTAL\"></th></tr></thead><tfoot><tr><td></td></tr></tfoot><tbody \nng-sortable=\"vm.templateSortable\"><tr class=\"template flex standings-row drag-item\" \nng-repeat=\"row in vm.currentCompetitionSeason.resultsGrouped track by $index\"><td>{{$index + 1}}</td><td>\n{{row.constructor}}</td><td ng-repeat=\"race in row.races\">{{race.points}} <span ng-if=\"race.extra\">({{race.extra}})\n</span></td><td>{{row.total}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/main/apps/match-center/views/list/sports-templates/tennis/team-template.html","<div ng-if=\"vm.showTeams\" ng-sortable=\"vm.templateSortable\"><div class=\"template flex team-row drag-item\" layout=\"row\" \nng-repeat=\"team in vm.currentMatch.teams_data track by $index\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon class=\"drag icon-equal mr-5\" aria-label=\"DRAG\"></md-icon><img ng-if=\"team.media\" \nclass=\"avatar\" ng-src=\"{{team.media}}\" alt=\"\"> <img ng-if=\"!team.media\" class=\"avatar\" \nng-src=\"assets/images/common/no_image_available_10.png\" imageonload><div class=\"field\" layout=\"column\"><div><strong \nclass=\"font-size-16 grey-700-fg\" ng-bind=\"team.team_name\"></strong></div></div></div><div layout=\"row\" \nlayout-align=\"end center\"><div ng-repeat=\"set in vm.getArrayOfSets() track by $index\" class=\"score-box\"><div \nstyle=\"min-width: 60px; text-align: center\" ng-show=\"!editModeScore\"><span class=\"score font-size-14 grey-700-fg mr-5\" \nng-hide=\"editModeScore\">{{team.points[$index]}}</span><md-icon ng-click=\"editModeScore=true\" \nmd-font-icon=\"icon-pencil pointer\"></md-icon></div><div class=\"edit-mode\" ng-show=\"editModeScore\"><md-input-container \nstyle=\"margin: 0px\"><input on-enter=\"editModeScore=false\" on-esc=\"editModeScore=false\" ng-model=\"team.points[$index]\" \naria-label=\"Team Points\"></md-input-container><md-icon ng-click=\"editModeScore=false\" \nmd-font-icon=\"icon-check pointer\"></md-icon></div></div><div><span class=\"vert-separator\"></span></div><div \nclass=\"score-box current\"><div style=\"min-width: 60px; text-align: center\" ng-show=\"!editModeScore\"><span \nclass=\"score font-size-14 grey-700-fg mr-5\" ng-hide=\"editModeScore\">{{team.currentpoints}}</span><md-icon \nng-click=\"editModeScore=true\" md-font-icon=\"icon-pencil pointer\"></md-icon></div><div class=\"edit-mode\" \nng-show=\"editModeScore\"><md-input-container style=\"margin: 0px\"><input on-enter=\"editModeScore=false\" \non-esc=\"editModeScore=false\" ng-model=\"team.currentpoints\"></md-input-container><md-icon \nng-click=\"editModeScore=false\" md-font-icon=\"icon-check pointer\"></md-icon></div></div><md-menu><md-button \nclass=\"md-icon-button\" aria-label=\"More\" ng-click=\"vm.openMenu($mdMenu, $event)\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/more_vert.svg\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button ng-click=\"vm.deleteTeamMatch($index)\" aria-label=\"Delete\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon><span translate=\"GLOBAL.DELETE\"></span></md-button></md-menu-item></md-menu-content></md-menu></div></div>\n</div>");
$templateCache.put("app/main/apps/match-center/views/list/sports-templates/sailing/match-template.html","<div class=\"field\" flex layout=\"row\" ng-if=\"vm.currentCompetitionSeason.match_type == 1\"><div \nng-if=\"match.teams_data.length !== 2\" flex><span ng-if=\"match.match_name\" class=\"font-size-16 grey-700-fg\" \nng-bind=\"match.match_name\"></span> <span ng-if=\"!match.match_name\" class=\"font-size-16 grey-700-fg\">\nIncomplete information</span></div><div ng-if=\"match.teams_data.length == 2\" layout=\"row\" layout-align=\"center center\" \nflex><div layout=\"row\" flex style=\"line-height: 40px\" class=\"font-size-16 grey-700-fg match-football-content\"><span \nflex=\"40\" layout=\"column\" layout-gt-xs=\"row\" layout-align=\"center center\" layout-align-gt-xs=\"end center\" \nclass=\"team-a\"><strong class=\"text-center\">{{match.teams_data[0].team_name}}</strong> <img \nng-if=\"match.teams_data[0].media\" class=\"avatar no-border mh-15\" ng-src=\"{{match.teams_data[0].media}}\" alt=\"\"> <img \nng-if=\"!match.teams_data[0].media && (!match.teams_data[0].Thumbnail || match.teams_data[0].Thumbnail.length == 0)\" \nclass=\"avatar mh-15\" ng-src=\"assets/images/common/no_image_available_10.png\" imageonload> </span><span flex=\"20\" \nlayout=\"row\" layout-align=\"center center\" class=\"status mh-10\" style=\"background-color: white\"><span \nng-if=\"match.status> 3 || !match.status || !match.date\"><strong>{{match.teams_data[0].points}}</strong> - <strong>\n{{match.teams_data[1].points}}</strong> </span><span ng-if=\"match.status <= 3 && match.date && match.status\">\n{{match.date | amDateFormat:\'DD MMM YYYY\'}} </span></span><span flex=\"40\" layout=\"column\" layout-gt-xs=\"row\" \nlayout-align=\"center center\" layout-align-gt-xs=\"start center\" class=\"team-b\"><img ng-if=\"match.teams_data[1].media\" \nclass=\"avatar no-border mh-15\" ng-src=\"{{match.teams_data[1].media}}\" alt=\"\"> <img \nng-if=\"!match.teams_data[1].media && (!match.teams_data[1].Thumbnail || match.teams_data[1].Thumbnail.length == 0)\" \nclass=\"avatar mh-15\" ng-src=\"assets/images/common/no_image_available_10.png\" imageonload> <strong class=\"text-center\">\n{{match.teams_data[1].team_name}}</strong></span></div></div><div layout=\"row\" layout-align=\"end center\"><div><button \nng-if=\"match.onoff===1\" class=\"md-icon-button md-button\" ng-click=\"vm.toggleItemStatusMatch(match, $event)\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\"></md-icon></button> <button ng-if=\"match.onoff!==1\" \nclass=\"md-icon-button md-button\" ng-click=\"vm.toggleItemStatusMatch(match, $event)\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"off red-fg s24\"></md-icon></button></div><md-menu><md-button \nclass=\"md-icon-button\" aria-label=\"More\" ng-click=\"vm.openMenu($mdMenu, $event)\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/more_vert.svg\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button ng-click=\"vm.openMatch($event, vm.matches[$index].id)\" aria-label=\"Edit\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon><span translate=\"MATCH_CENTER.EDIT\"></span></md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.deleteMatch($event, $index)\" aria-label=\"Delete\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-default-theme md-font material-icons icon-delete\"></md-icon>Remove</md-button>\n</md-menu-item></md-menu-content></md-menu></div></div><div class=\"field\" flex layout=\"row\" \nng-if=\"vm.currentCompetitionSeason.match_type != 1\"><div class=\"field\" flex layout=\"row\"><div \nng-if=\"match.teams_data.length !== 2\" flex><span ng-if=\"match.match_name\" class=\"font-size-16 grey-700-fg\" \nng-bind=\"match.match_name\"></span> <span ng-if=\"!match.match_name\" class=\"font-size-16 grey-700-fg\">\nIncomplete information</span></div><div ng-if=\"match.teams_data.length == 2\" layout=\"row\" layout-align=\"center center\" \nflex><div layout=\"row\" flex style=\"line-height: 40px\" class=\"font-size-16 grey-700-fg match-football-content\"><span \nflex=\"40\" layout=\"column\" layout-gt-xs=\"row\" layout-align=\"center center\" layout-align-gt-xs=\"end center\" \nclass=\"team-a\"><strong class=\"text-center\">{{match.teams_data[0].team_name}}</strong> <img \nng-if=\"match.teams_data[0].media\" class=\"avatar no-border mh-15\" ng-src=\"{{match.teams_data[0].media}}\" alt=\"\"> <img \nng-if=\"!match.teams_data[0].media && (!match.teams_data[0].Thumbnail || match.teams_data[0].Thumbnail.length == 0)\" \nclass=\"avatar mh-15\" ng-src=\"assets/images/common/no_image_available_10.png\" imageonload> </span><span flex=\"30\" \nlayout=\"column\" layout-align=\"center center\" class=\"status mh-10\" style=\"background-color: white\"><span \nng-if=\"match.status > 3 || !match.status || !match.date\"><strong \nng-if=\"match.teams_data[0].penalties > 0 || match.teams_data[1].penalties > 0\">({{match.teams_data[0].penalties}})\n</strong> <strong>{{match.teams_data[0].points}}</strong> - <strong>{{match.teams_data[1].points}}</strong> <strong \nng-if=\"match.teams_data[0].penalties > 0 || match.teams_data[1].penalties > 0\">({{match.teams_data[1].penalties}})\n</strong> </span><span ng-if=\"match.status <= 3  && match.date && match.status\">\n{{match.date | amDateFormat:\'DD MMM YYYY\'}} </span><span ng-if=\"match.status <= 3  && match.date && match.status\" \nshow-xs hide-gt-xs>{{ match.date | amUtc | amLocal | amDateFormat:\'HH:mm\' }}</span><div layout=\"row\" \nlayout-align=\"end center\" show-xs hide-gt-xs><span class=\"status\" ng-class=\"vm.getMatchClass(match)\" \nng-bind-html=\"vm.getMatchesStatus(match)\"></span></div></span><span flex=\"40\" layout=\"column\" layout-gt-xs=\"row\" \nlayout-align=\"center center\" layout-align-gt-xs=\"start center\" class=\"team-b\"><img ng-if=\"match.teams_data[1].media\" \nclass=\"avatar no-border mh-15\" ng-src=\"{{match.teams_data[1].media}}\" alt=\"\"> <img \nng-if=\"!match.teams_data[1].media && (!match.teams_data[1].Thumbnail || match.teams_data[1].Thumbnail.length == 0)\" \nclass=\"avatar mh-15\" ng-src=\"assets/images/common/no_image_available_10.png\" imageonload> <strong class=\"text-center\">\n{{match.teams_data[1].team_name}}</strong></span></div></div><div class=\"mr-15\" layout=\"column\" \nlayout-align=\"center center\" hide-xs show-gt-xs><span class=\"status\" ng-class=\"vm.getMatchClass(match)\" \nng-bind-html=\"vm.getMatchesStatus(match)\"></span> <span ng-if=\"match.status <= 3  && match.date && match.status\">\n{{ match.date | amUtc | amLocal | amDateFormat:\'HH:mm\' }}</span></div></div><div layout=\"row\" \nlayout-align=\"end center\"><div><button ng-if=\"match.onoff===1\" class=\"md-icon-button md-button\" \nng-click=\"vm.toggleItemStatusMatch(match, $event)\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" \nclass=\"on green-fg s24\"></md-icon></button> <button ng-if=\"match.onoff!==1\" class=\"md-icon-button md-button\" \nng-click=\"vm.toggleItemStatusMatch(match, $event)\"><md-icon md-font-icon=\"icon-checkbox-blank-circle-outline\" \nclass=\"off red-fg s24\"></md-icon></button></div><md-menu><md-button class=\"md-icon-button\" aria-label=\"More\" \nng-click=\"vm.openMenu($mdMenu, $event)\"><md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/more_vert.svg\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"vm.seeUpdate = false;vm.openMatch($event, vm.matches[$index].id)\" aria-label=\"Edit\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon><span translate=\"MATCH_CENTER.EDIT\"></span></md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.seeUpdate = false;vm.deleteMatch($event, $index)\" aria-label=\"Delete\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"md-default-theme md-font material-icons icon-delete\"></md-icon>Remove</md-button>\n</md-menu-item></md-menu-content></md-menu></div></div>");
$templateCache.put("app/main/apps/match-center/views/list/sports-templates/sailing/standings-template.html","<div ng-if=\"vm.currentCompetitionSeason.match_type == 2\" id=\"standings\" \nclass=\"simple-table-container md-whiteframe-4dp\"><div class=\"ms-responsive-table-wrapper\"><table \nng-if=\"vm.currentCompetitionSeason.results && vm.currentCompetitionSeason.results.length> 0\" class=\"simple\" \nms-responsive-table=\"\"><thead><tr><th></th><th translate=\"MATCH_CENTER.TEAMS\"></th><th \nng-repeat=\"race in vm.currentCompetitionSeason.results[0].races\">{{race.race}}</th><th translate=\"MATCH_CENTER.TOTAL\">\n</th><th></th></tr></thead><tfoot><tr><td></td></tr></tfoot><tbody ng-sortable=\"vm.templateSortable\"><tr \nclass=\"template flex standings-row drag-item\" ng-repeat=\"row in vm.currentCompetitionSeason.results track by $index\">\n<td>{{row.position}}</td><td>{{row.name}}</td><td ng-repeat=\"race in row.races\">{{race.points}} <span \nng-if=\"race.extra\">({{race.extra}})</span></td><td>{{row.total}}</td><td><md-icon class=\"drag icon-equal\" \naria-label=\"DRAG\"></md-icon></td></tr></tbody></table></div></div><div \nng-if=\"vm.currentCompetitionSeason.match_type == 1\" id=\"standings\" class=\"simple-table-container md-whiteframe-4dp\">\n<div class=\"ms-responsive-table-wrapper\"><table class=\"simple\" ms-responsive-table=\"\"><thead><tr><th></th><th \ntranslate=\"MATCH_CENTER.TEAMS\"></th><th class=\"text-center\">PT</th><th class=\"text-center\">PJ</th><th \nclass=\"text-center\">WINS</th><th class=\"text-center\">LOSSES</th><th></th></tr></thead><tfoot><tr><td></td></tr></tfoot>\n<tbody ng-sortable=\"vm.templateSortable\"><tr class=\"template flex standings-row drag-item\" \nng-repeat=\"row in vm.currentCompetitionSeason.results track by $index\"><td>{{row.position}}</td><td>{{row.name}}</td>\n<td class=\"text-center\">{{row.points}}</td><td class=\"text-center\">{{row.pj}}</td><td class=\"text-center\">{{row.pg}}\n</td><td class=\"text-center\">{{row.pp}}</td><td><md-icon class=\"drag icon-equal\" aria-label=\"DRAG\"></md-icon></td></tr>\n</tbody></table></div></div>");
$templateCache.put("app/main/apps/match-center/views/list/sports-templates/sailing/team-template.html","<div ng-if=\"vm.showTeams\" ng-sortable=\"vm.templateSortable\"><div class=\"template flex team-row match-drag-item\" \nlayout=\"row\" ng-repeat=\"team in vm.currentMatch.teams_data track by $index\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-icon class=\"drag icon-equal mr-5\" aria-label=\"DRAG\"></md-icon><img \nng-if=\"team.media\" class=\"avatar\" ng-src=\"{{team.media}}\" alt=\"\"> <img ng-if=\"!team.media\" class=\"avatar\" \nng-src=\"assets/images/common/no_image_available_10.png\" imageonload><div class=\"field\" layout=\"column\"><div><strong \nclass=\"font-size-16 grey-700-fg\" ng-bind=\"team.team_name\"></strong></div></div></div><div layout=\"row\" \nlayout-align=\"end center\"><div class=\"score-box\"><div style=\"min-width: 60px; text-align: center\" \nng-show=\"!editModeScore\"><span class=\"score font-size-14 grey-700-fg mr-5\" ng-hide=\"editModeScore\">{{team.points}}\n</span><md-icon ng-click=\"editModeScore=true\" md-font-icon=\"icon-pencil pointer\"></md-icon></div><div \nclass=\"edit-mode\" ng-show=\"editModeScore\"><md-input-container style=\"margin: 0px\"><input ng-model=\"team.points\" \nng-change=\"vm.normalizeDecimal(team)\" ng-model-options=\"{ allowInvalid: true }\" ng-blur=\"vm.finalizePoints(team)\" \non-enter=\"vm.finalizePoints(team); editModeScore=false\" on-esc=\"editModeScore=false\" aria-label=\"Team Points\">\n</md-input-container><md-icon ng-click=\"editModeScore=false\" md-font-icon=\"icon-check pointer\"></md-icon></div></div>\n<div class=\"score-box\"><div style=\"min-width: 80px; text-align: center\" ng-show=\"!editModeStatus\"><span \nclass=\"score font-size-16 grey-700-fg mr-5\" ng-hide=\"editModeStatus\">{{team.status.value}}</span><md-icon \nng-click=\"vm.openTeamEditStatusDialog($event, $index)\" md-font-icon=\"icon-pencil pointer\"></md-icon></div></div><div \nng-if=\"vm.sport == \'sailing\'\" class=\"score-box\"><div style=\"min-width: 80px; text-align: center\" ng-show=\"!editExtra\">\n<span class=\"score font-size-16 grey-700-fg mr-5\" ng-hide=\"editExtra\">{{team.extra}}</span><md-icon \nng-click=\"editExtra=true\" md-font-icon=\"icon-pencil pointer\"></md-icon></div><div class=\"edit-mode\" \nng-show=\"editExtra\"><md-input-container style=\"margin: 0px\"><input on-enter=\"editExtra=false\" on-esc=\"editExtra=false\" \nng-model=\"team.extra\" aria-label=\"Team Extra\"></md-input-container><md-icon ng-click=\"editExtra=false\" \nmd-font-icon=\"icon-check pointer\"></md-icon></div></div><div class=\"score-box big\"><div \nclass=\"time-picker-inline-table\"><mdp-time-picker mdp-placeholder=\"--:--:--\" mdp-format=\"HH:mm:ss\" \nng-model=\"team.start_time\" class=\"date-time-picker\"></mdp-time-picker></div></div><div class=\"score-box big\"><div \nclass=\"time-picker-inline-table\"><mdp-time-picker mdp-placeholder=\"--:--:--\" mdp-format=\"HH:mm:ss\" \nng-model=\"team.end_time\" class=\"date-time-picker\"></mdp-time-picker></div></div><div class=\"score-box big\">\n<md-input-container style=\"margin: 0px\"><input ng-model=\"team.elapsed_time\" aria-label=\"Elapsed time\">\n</md-input-container></div><div class=\"score-box big\"><md-input-container style=\"margin: 0px\"><input \nng-model=\"team.delta\" aria-label=\"Delta\"></md-input-container></div><md-menu><md-button class=\"md-icon-button\" \naria-label=\"More\" ng-click=\"vm.openMenu($mdMenu, $event)\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/more_vert.svg\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button ng-click=\"vm.openTeamEditDialog($event, $index)\" aria-label=\"Edit\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon><span translate=\"MATCH_CENTER.EDIT_SQUAD\"></span></md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.deleteTeamMatch($index)\" aria-label=\"Delete\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon><span translate=\"GLOBAL.DELETE\"></span></md-button></md-menu-item></md-menu-content></md-menu></div></div>\n</div>");
$templateCache.put("app/main/apps/media/views/list/subviews/templates/photo.html","<div class=\"ms-card-content-wrapper ng-scope\"><div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" \nlayout-align=\"start center\"><div ng-if=\"photo.avatar\"><img class=\"avatar mr-16\" ng-src=\"{{photo.avatar.src}}\" \nalt=\"{{photo.avatar.alt}}\"></div><div class=\"info\"><div class=\"title\">{{photo.title}}</div><div \nclass=\"subtitle secondary-text\" ng-if=\"photo.subtitle\">{{photo.subtitle}}</div></div></div><div \nclass=\"text ph-16 pb-16\" ng-if=\"photo.text\">{{photo.text}}</div><div class=\"media\" flex><img \nng-src=\"{{photo.crop_status[0].urlformed}}\" class=\"image\"></div><div class=\"buttons m-8\"><md-button \nclass=\"md-icon-button mr-16\" aria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\">\n</md-icon></md-button><md-checkbox ng-checked=\"vm.alreadySelectedbyZone(vm.selectedContacts, photo)\" \nng-click=\"vm.toggleSelectContact(photo, $event)\" \naria-label=\"{{vm.alreadySelectedbyZone(vm.selectedContacts, photo) ? \'Deselect\' : \'Select\'}}\"></md-checkbox></div>\n</div></div>");
$templateCache.put("app/main/apps/media/views/list/subviews/templates/toolbar-search.html","<md-toolbar ng-if=\"vm.showSearchAndPaginator\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><div><md-button ng-click=\"vm.resetSearch()\" aria-label=\"view type\" \nclass=\"md-icon-button\" translate=\"\" translate-attr-aria-label=\"CONTENT.FILTERS\" class=\"md-icon-button\" \nid=\"ms-filters-cleaner\" ng-if=\"vm.searchQuery == true\"><md-icon md-font-icon=\"icon-filter-remove-outline\"></md-icon>\n<md-tooltip hide show-gt-xs><span>Reset search</span></md-tooltip></md-button></div><ms-search-bar-custom flex \nclass=\"expanded ms-search-bar\" debounce=\"300\" model-search=\"vm.searchStringFilter\" on-search=\"vm.searchMedia(query)\" \nlayout=\"row\" layout-align=\"start center\"><div flex layout=\"row\" layout-align=\"start center\"><label \nfor=\"ms-search-bar-input\"><md-icon id=\"ms-search-bar-expander\" md-font-icon=\"icon-magnify\" \nclass=\"md-icon-button md-button\"><md-tooltip hide show-gt-xs><span translate=\"TOOLBAR.SEARCH\">Search</span>\n</md-tooltip></md-icon></label><input id=\"ms-search-bar-input\" type=\"text\" ng-model=\"vm.modelSearch\" \nplaceholder=\"Search\" md-autofocus translate translate-attr-placeholder=\"TOOLBAR.SEARCH\" flex \nng-enter=\"vm.pagination_search(vm.modelSearch)\"><md-icon id=\"ms-search-bar-collapser\" md-font-icon=\"icon-close-circle\" \nclass=\"icon s24\"></md-icon><md-button hide show-gt-xs id=\"ms-search-bar-button\" class=\"md-accent md-raised\" \nng-click=\"vm.pagination_search(vm.modelSearch)\" aria-label=\"description\" md-no-ink=\"true\" md-ripple-size=\"auto\">Search\n</md-button><md-button hide show-xs id=\"ms-search-bar-button\" class=\"md-accent md-raised md-icon-button\" \nng-click=\"vm.pagination_search(vm.modelSearch)\" ng-disabled=\"!vm.modelSearch\" aria-label=\"description\" \nmd-no-ink=\"true\" md-ripple-size=\"auto\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>\n</ms-search-bar-custom></div></md-toolbar>");
$templateCache.put("app/main/apps/media/dialogs/media/views/templates/photo.html","<div class=\"ms-card-content-wrapper ng-scope\"><div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" \nlayout-align=\"start center\"><div ng-if=\"photo.avatar\"><img class=\"avatar mr-16\" ng-src=\"{{photo.avatar.src}}\" \nalt=\"{{photo.avatar.alt}}\"></div><div class=\"info\"><div class=\"title\">{{photo.title}}</div><div \nclass=\"subtitle secondary-text\" ng-if=\"photo.subtitle\">{{photo.subtitle}}</div></div></div><div \nclass=\"text ph-16 pb-16\" ng-if=\"photo.text\">{{photo.text}}</div><div class=\"media\" flex><img \nng-src=\"{{photo.crop_status[0].urlformed}}\" class=\"image\"></div><div class=\"buttons m-8\"><md-button \nclass=\"md-icon-button mr-16\" aria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\">\n</md-icon></md-button><md-checkbox ng-checked=\"vm.alreadySelectedbyZone(vm.selectedContacts, photo)\" \nng-click=\"vm.toggleSelectContact(photo, $event)\" \naria-label=\"{{vm.alreadySelectedbyZone(vm.selectedContacts, photo) ? \'Deselect\' : \'Select\'}}\"></md-checkbox></div>\n</div></div>");
$templateCache.put("app/main/apps/media/dialogs/media/views/templates/toolbar-search.html","<md-toolbar ng-if=\"vm.showSearchAndPaginator\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><div><md-button ng-click=\"vm.resetSearch()\" aria-label=\"view type\" \nclass=\"md-icon-button\" translate=\"\" translate-attr-aria-label=\"CONTENT.FILTERS\" class=\"md-icon-button\" \nid=\"ms-filters-cleaner\" ng-if=\"vm.searchQuery == true\"><md-icon md-font-icon=\"icon-filter-remove-outline\"></md-icon>\n<md-tooltip hide show-gt-xs><span>Reset search</span></md-tooltip></md-button></div><ms-search-bar-custom flex \nclass=\"expanded ms-search-bar\" debounce=\"300\" model-search=\"vm.searchStringFilter\" on-search=\"vm.searchMedia(query)\" \nlayout=\"row\" layout-align=\"start center\"><div flex layout=\"row\" layout-align=\"start center\"><label \nfor=\"ms-search-bar-input\"><md-icon id=\"ms-search-bar-expander\" md-font-icon=\"icon-magnify\" \nclass=\"md-icon-button md-button\"><md-tooltip hide show-gt-xs><span translate=\"TOOLBAR.SEARCH\">Search</span>\n</md-tooltip></md-icon></label><input id=\"ms-search-bar-input\" type=\"text\" ng-model=\"vm.modelSearch\" \nplaceholder=\"Search\" md-autofocus translate translate-attr-placeholder=\"TOOLBAR.SEARCH\" flex \nng-enter=\"vm.pagination_search(vm.modelSearch)\"><md-icon id=\"ms-search-bar-collapser\" md-font-icon=\"icon-close-circle\" \nclass=\"icon s24\"></md-icon><md-button hide show-gt-xs id=\"ms-search-bar-button\" class=\"md-accent md-raised\" \nng-click=\"vm.pagination_search(vm.modelSearch)\" aria-label=\"description\" md-no-ink=\"true\" md-ripple-size=\"auto\">Search\n</md-button><md-button hide show-xs id=\"ms-search-bar-button\" class=\"md-accent md-raised md-icon-button\" \nng-click=\"vm.pagination_search(vm.modelSearch)\" ng-disabled=\"!vm.modelSearch\" aria-label=\"description\" \nmd-no-ink=\"true\" md-ripple-size=\"auto\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>\n</ms-search-bar-custom></div></md-toolbar>");
$templateCache.put("app/main/apps/mediahub/views/list/subviews/templates/photo.html","<div class=\"ms-card-content-wrapper ng-scope\"><div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" \nlayout-align=\"start center\"><div ng-if=\"photo.avatar\"><img class=\"avatar mr-16\" ng-src=\"{{photo.avatar.src}}\" \nalt=\"{{photo.avatar.alt}}\"></div><div class=\"info\"><div class=\"title\">{{photo.title}}</div><div \nclass=\"subtitle secondary-text\" ng-if=\"photo.subtitle\">{{photo.subtitle}}</div></div></div><div \nclass=\"text ph-16 pb-16\" ng-if=\"photo.text\">{{photo.text}}</div><div class=\"media\" flex><img \nng-src=\"{{photo.crop_status[0].urlformed}}\" class=\"image\"></div><div class=\"buttons m-8\"><md-button \nclass=\"md-icon-button mr-16\" aria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\">\n</md-icon></md-button><md-checkbox ng-checked=\"vm.alreadySelectedbyZone(vm.selectedContacts, photo)\" \nng-click=\"vm.toggleSelectContact(photo, $event)\" \naria-label=\"{{vm.alreadySelectedbyZone(vm.selectedContacts, photo) ? \'Deselect\' : \'Select\'}}\"></md-checkbox></div>\n</div></div>");
$templateCache.put("app/main/apps/mediahub/views/list/subviews/templates/toolbar-search.html","<md-toolbar ng-if=\"vm.showSearchAndPaginator\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><div><md-button ng-click=\"vm.resetSearch()\" aria-label=\"view type\" \nclass=\"md-icon-button\" translate=\"\" translate-attr-aria-label=\"CONTENT.FILTERS\" class=\"md-icon-button\" \nid=\"ms-filters-cleaner\" ng-if=\"vm.searchQuery == true\"><md-icon md-font-icon=\"icon-filter-remove-outline\"></md-icon>\n<md-tooltip hide show-gt-xs><span>Reset search</span></md-tooltip></md-button></div><mh-search-bar flex \nclass=\"expanded mh-search-bar\" debounce=\"300\" model-search=\"vm.modelSearch\" on-search=\"vm.pagination_search(query)\" \nlayout=\"row\" layout-align=\"start center\"></mh-search-bar></div></md-toolbar>");
$templateCache.put("app/main/apps/mediahub/dialogs/media/views/templates/photo.html","<div class=\"ms-card-content-wrapper ng-scope\"><div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" \nlayout-align=\"start center\"><div ng-if=\"photo.avatar\"><img class=\"avatar mr-16\" ng-src=\"{{photo.avatar.src}}\" \nalt=\"{{photo.avatar.alt}}\"></div><div class=\"info\"><div class=\"title\">{{photo.title}}</div><div \nclass=\"subtitle secondary-text\" ng-if=\"photo.subtitle\">{{photo.subtitle}}</div></div></div><div \nclass=\"text ph-16 pb-16\" ng-if=\"photo.text\">{{photo.text}}</div><div class=\"media\" flex><img \nng-src=\"{{photo.crop_status[0].urlformed}}\" class=\"image\"></div><div class=\"buttons m-8\"><md-button \nclass=\"md-icon-button mr-16\" aria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\">\n</md-icon></md-button><md-checkbox ng-checked=\"vm.alreadySelectedbyZone(vm.selectedContacts, photo)\" \nng-click=\"vm.toggleSelectContact(photo, $event)\" \naria-label=\"{{vm.alreadySelectedbyZone(vm.selectedContacts, photo) ? \'Deselect\' : \'Select\'}}\"></md-checkbox></div>\n</div></div>");
$templateCache.put("app/main/apps/mediahub/dialogs/media/views/templates/toolbar-search.html","<md-toolbar ng-if=\"vm.showSearchAndPaginator\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><div><md-button ng-click=\"vm.resetSearch()\" aria-label=\"view type\" \nclass=\"md-icon-button\" translate=\"\" translate-attr-aria-label=\"CONTENT.FILTERS\" class=\"md-icon-button\" \nid=\"ms-filters-cleaner\" ng-if=\"vm.searchQuery == true\"><md-icon md-font-icon=\"icon-filter-remove-outline\"></md-icon>\n<md-tooltip hide show-gt-xs><span>Reset search</span></md-tooltip></md-button></div><ms-search-bar-custom flex \nclass=\"expanded ms-search-bar\" debounce=\"300\" model-search=\"vm.searchStringFilter\" on-search=\"vm.searchMedia(query)\" \nlayout=\"row\" layout-align=\"start center\"><div flex layout=\"row\" layout-align=\"start center\"><label \nfor=\"ms-search-bar-input\"><md-icon id=\"ms-search-bar-expander\" md-font-icon=\"icon-magnify\" \nclass=\"md-icon-button md-button\"><md-tooltip hide show-gt-xs><span translate=\"TOOLBAR.SEARCH\">Search</span>\n</md-tooltip></md-icon></label><input id=\"ms-search-bar-input\" type=\"text\" ng-model=\"vm.modelSearch\" \nplaceholder=\"Search\" md-autofocus translate translate-attr-placeholder=\"TOOLBAR.SEARCH\" flex \nng-enter=\"vm.pagination_search(vm.modelSearch)\"><md-icon id=\"ms-search-bar-collapser\" md-font-icon=\"icon-close-circle\" \nclass=\"icon s24\"></md-icon><md-button hide show-gt-xs id=\"ms-search-bar-button\" class=\"md-accent md-raised\" \nng-click=\"vm.pagination_search(vm.modelSearch)\" aria-label=\"description\" md-no-ink=\"true\" md-ripple-size=\"auto\">Search\n</md-button><md-button hide show-xs id=\"ms-search-bar-button\" class=\"md-accent md-raised md-icon-button\" \nng-click=\"vm.pagination_search(vm.modelSearch)\" ng-disabled=\"!vm.modelSearch\" aria-label=\"description\" \nmd-no-ink=\"true\" md-ripple-size=\"auto\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>\n</ms-search-bar-custom></div></md-toolbar>");
$templateCache.put("app/main/apps/runtag/event/dialogs/event/tabs/tab-discount-codes.html","<div class=\"scroll-with-actions\"><md-content class=\"p-0 discount-codes-tab h-full\" novalidate layout-padding \nlayout=\"row\" layout-xs=\"column\"><div flex=\"50\" flex-xs=\"100\" layout=\"column\" class=\"discount-list border-right p-0\">\n<div layout=\"row\" layout-align=\"start center\" class=\"add-discount-button py-20 px-25 border-bottom\"><md-button \nclass=\"md-fab md-mini md-primary\" ng-click=\"vm.selectDiscountCode(\'new\')\"><md-icon>add</md-icon></md-button><span \ntranslate=\"RUNTAG.DISCOUNT_CODES.CREATE_NEW_CODE\">Crear nuevo Código</span></div><div \nng-repeat=\"code in vm.discountCodes\" ng-click=\"vm.selectDiscountCode(code)\" \nclass=\"discount-item border-bottom px-25 py-10\" layout=\"row\" layout-align=\"space-between center\"><div><p><strong>\n{{code.name}} ({{code.code}})</strong></p><p><span translate=\"RUNTAG.DISCOUNT_CODES.VALUE\">Valor</span>: <span \nclass=\"bold\">{{code.coupon_value}}%</span></p><p class=\"text-small\"><span translate=\"RUNTAG.DISCOUNT_CODES.USED_CODES\">\nUsados</span>: {{code.used_codes}} / {{code.total_codes}}</p></div><span ng-if=\"code.onoff == 0\" \nclass=\"status-inactive\" translate=\"RUNTAG.DISCOUNT_CODES.INACTIVE\">Inactivo</span></div></div><form flex=\"50\" \nflex-xs=\"100\" name=\"addDiscountCodeForm\" novalidate layout=\"column\" ng-if=\"vm.selectedDiscountCode\" \nclass=\"p-25 mobile-position-form\"><div layout=\"row\" layout-align=\"space-between center\" class=\"mb-20\"><span \nclass=\"md-title\">\n{{ vm.discountCodeData.id ? (\'RUNTAG.DISCOUNT_CODES.EDIT_CODE\' | translate) : (\'RUNTAG.DISCOUNT_CODES.NEW_CODE\' | translate) }}\n</span><md-switch ng-model=\"vm.discountCodeData.onoff\" aria-label=\"Estado activo\" class=\"m-0\"><strong>\n{{ vm.discountCodeData.onoff ? (\'RUNTAG.DISCOUNT_CODES.ACTIVE\' | translate) : (\'RUNTAG.DISCOUNT_CODES.INACTIVE\' | translate) }}\n</strong></md-switch></div><md-input-container class=\"md-block\"><label translate=\"RUNTAG.DISCOUNT_CODES.NAME\">\nNombre (Descripción)</label><input type=\"text\" ng-model=\"vm.discountCodeData.name\" required></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"RUNTAG.DISCOUNT_CODES.CODE\">Código (Texto a canjear)</label>\n<input type=\"text\" ng-model=\"vm.discountCodeData.code\" required style=\"text-transform: uppercase\"></md-input-container>\n<div layout=\"row\" layout-align=\"space-between center\" layout-wrap><md-input-container class=\"md-block\" flex=\"45\"><label\n translate=\"RUNTAG.DISCOUNT_CODES.VALUE\">Valor (%)</label><input type=\"number\" \nng-model=\"vm.discountCodeData.coupon_value\" required min=\"0\" max=\"100\"></md-input-container><md-input-container \nclass=\"md-block\" flex=\"45\"><label translate=\"RUNTAG.DISCOUNT_CODES.TOTAL_USES\">Total de usos permitidos</label><input \ntype=\"number\" ng-model=\"vm.discountCodeData.total_codes\" required min=\"1\"></md-input-container></div><div \nng-if=\"vm.discountCodeData.id\" class=\"info-box p-10 bg-gray-100 mb-20\" style=\"border-radius: 4px\"><p class=\"m-0\">\n<strong><span translate=\"RUNTAG.DISCOUNT_CODES.USED_CODES\">Códigos usados</span>:</strong>\n {{ vm.discountCodeData.used_codes || 0 }}</p></div></form><div flex=\"50\" flex-xs=\"100\" layout=\"column\" \nlayout-align=\"center center\" ng-if=\"!vm.selectedDiscountCode\" \nclass=\"text-center p-25 text-gray-500 placeholder-container\"><md-icon class=\"s48 mb-10 text-gray-300\">local_offer\n</md-icon><p translate=\"RUNTAG.DISCOUNT_CODES.SELECT_PLACEHOLDER\">Selecciona un código de descuento o crea uno nuevo.\n</p></div></md-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><div layout=\"row\" \nlayout-align=\"end center\" class=\"action-buttons\" ng-if=\"vm.selectedDiscountCode\"><md-button class=\"md-raised md-warn\" \nng-click=\"vm.cancelDiscountCode()\" translate=\"RUNTAG.DISCOUNT_CODES.CANCEL\">CANCELAR</md-button><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.saveDiscountCode()\" ng-disabled=\"addDiscountCodeForm.$invalid\" \ntranslate=\"RUNTAG.DISCOUNT_CODES.SAVE\">GUARDAR</md-button></div></md-dialog-actions></div>");
$templateCache.put("app/main/apps/runtag/event/dialogs/event/tabs/tab-dorsals.html","<div class=\"scroll-with-actions\"><md-content class=\"p-0 dorsals-tab h-full\" novalidate layout=\"column\"><div \nlayout=\"column\" class=\"prefix-pool p-15 border-bottom\"><div layout=\"row\" layout-align=\"start center\"><label \nclass=\"font-bold text-uppercase\" flex>Prefijos Disponibles (Letras)</label><md-button class=\"md-raised md-accent\" \nng-click=\"vm.saveEvent()\">ACTUALIZAR PREFIJOS</md-button></div><md-chips ng-model=\"vm.eventData.prefix_number\" \nplaceholder=\"Nueva letra...\" secondary-placeholder=\"+ Letra (o separa por ,)\" delete-button-label=\"Quitar Letra\" \ndelete-hint=\"Presiona delete para quitar la letra\" md-separator-keys=\"vm.prefixSeparatorKeys\" \nmd-transform-chip=\"vm.transformPrefixChip($chip)\"></md-chips><p class=\"md-caption mt-10\">\nAgrega las letras que se podrán seleccionar como prefijos (ej: A, B, C). Puedes separar por comas.</p></div><div \nlayout=\"row\" layout-xs=\"column\" flex><div layout=\"column\" class=\"regex-list p-0 border-right\" flex=\"50\" flex-xs=\"100\">\n<div layout=\"row\" layout-align=\"space-between center\" class=\"regex-buttons py-20 px-25 border-bottom\"><div \nlayout=\"row\" layout-align=\"start center\" class=\"gap-10\"><md-button class=\"md-fab md-mini md-primary add-regex-option\" \nng-click=\"vm.editRegex(\'new\')\"><md-icon>add</md-icon></md-button><span>Crear nueva Opción</span></div><div \nlayout=\"row\" layout-align=\"start center\" class=\"gap-10\"><md-button class=\"md-fab md-mini md-primary generate-regex\" \nng-click=\"vm.generateRegex()\"><md-icon>check</md-icon></md-button><span class=\"pr-2\">Generar Regex</span></div></div>\n<div class=\"regex-item border-bottom py-10 px-25\" ng-class=\"option.exclude? \'exclude\' : \'include\'\" layout=\"row\" \nlayout-align=\"space-between center\" ng-repeat=\"(index, option) in vm.regexOptions\" \nng-click=\"vm.editRegex(option, index)\"><p>{{option.prefix}}{{option.start}}<span ng-if=\"option.end\">\n - {{option.prefix}}{{option.end}}</span></p></div><div class=\"generated-regex-container p-20 border-top mt-auto\" \nng-if=\"vm.config.regexConfig.fullMatch\" style=\"background-color: #f9f9f9\"><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"mb-10\"><label class=\"font-bold text-uppercase secondary-text\" \nstyle=\"font-size: 11px; letter-spacing: 0.5px\">Regex Final Generado</label><md-button class=\"md-icon-button md-accent\" \nng-click=\"vm.copyToClipboard(vm.config.regexConfig.fullMatch)\" \nstyle=\"width: 32px; height: 32px; min-height: 32px; margin: 0\"><md-icon style=\"font-size: 18px; color: #FFFFFF\">\ncontent_copy</md-icon><md-tooltip>Copiar al portapapeles</md-tooltip></md-button></div><div \nclass=\"regex-code p-15 border bg-white shadow-1\" \nstyle=\"font-family: \'Consolas\', \'Monaco\', \'Courier New\', monospace; font-size: 13px; color: #1e1e1e; word-break: break-all; line-height: 1.5\">\n{{vm.config.regexConfig.fullMatch}}</div></div></div><div ng-if=\"vm.activeRegex\" flex=\"50\" flex-xs=\"100\" \nclass=\"p-25 mobile-position-form\"><form name=\"addRegexForm\" novalidate layout=\"column\"><div \nclass=\"selection-type mb-20\" layout=\"row\" layout-align=\"space-between\"><label><input type=\"radio\" \nng-model=\"vm.activeRegex.type\" value=\"single\"> Selección Única</label><label><input type=\"radio\" \nng-model=\"vm.activeRegex.type\" value=\"range\"> Selección de Rango</label><label><input type=\"checkbox\" \nng-model=\"vm.activeRegex.exclude\"> Excluir</label></div><div class=\"range-selector-container\" layout=\"row\">\n<md-input-container class=\"md-block\"><label>Prefix</label><md-select ng-model=\"vm.activeRegex.prefix\"><md-option \nng-value=\"undefined\"><em>Ninguno</em></md-option><md-option ng-repeat=\"prefix in vm.eventData.prefix_number\" \nng-value=\"prefix\">{{prefix}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\"><label>\nFrom</label><input type=\"text\" ng-model=\"vm.activeRegex.start\" ng-pattern=\"/^\\d*$/\" maxlength=\"10\" \nplaceholder=\"Solo números\"></md-input-container><md-input-container ng-show=\"vm.activeRegex.type === \'range\'\" \nclass=\"md-block\"><label>To</label><input type=\"text\" ng-model=\"vm.activeRegex.end\" ng-pattern=\"/^\\d*$/\" maxlength=\"10\" \nplaceholder=\"Solo números\"></md-input-container></div></form></div></div></md-content><md-dialog-actions layout=\"row\" \nlayout-align=\"end center\"><div layout=\"row\" layout-align=\"end center\" class=\"action-buttons\" ng-if=\"vm.activeRegex\">\n<md-button ng-if=\"vm.activeRegex.index != undefined\" class=\"md-raised md-warn\" ng-click=\"vm.deleteRegexOption()\">BORRAR\n</md-button><md-button class=\"md-raised md-warn\" ng-click=\"vm.cancelRegexOption()\">CANCELAR</md-button><md-button \nclass=\"md-raised md-primary\" ng-click=\"vm.saveRegexOption()\">GUARDAR</md-button></div></md-dialog-actions></div>");
$templateCache.put("app/main/apps/runtag/event/dialogs/event/tabs/tab-event-photo-form.html","<fieldset class=\"mb-20 photo-form-builder\"><legend translate=\"RUNTAG.PHOTO_FORM.TITLE\">\nFormulario antes de entregar las fotos</legend><p class=\"photo-form-hint\" translate=\"RUNTAG.PHOTO_FORM.HINT\"></p>\n<md-checkbox ng-model=\"vm.photoForm.enabled\"><span translate=\"RUNTAG.PHOTO_FORM.ENABLED\">\nPedir un formulario antes de entregar las fotos</span></md-checkbox><div ng-if=\"vm.photoForm.enabled\" \nclass=\"photo-form-body\"><div class=\"photo-form-screen\"><h4 translate=\"RUNTAG.PHOTO_FORM.INTRO\">Pantalla inicial</h4>\n<md-input-container class=\"md-block\"><label translate=\"RUNTAG.PHOTO_FORM.SCREEN_TITLE\">Título</label><input \ntype=\"text\" ng-model=\"vm.photoForm.screens.intro.title[vm.photoForm.defaultLanguage]\"></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"RUNTAG.PHOTO_FORM.SCREEN_TEXT\">Texto</label><textarea rows=\"2\" \nng-model=\"vm.photoForm.screens.intro.text[vm.photoForm.defaultLanguage]\"></textarea></md-input-container></div><h4 \ntranslate=\"RUNTAG.PHOTO_FORM.QUESTIONS\">Preguntas</h4><p ng-if=\"!vm.photoForm.questions.length\" \nclass=\"photo-form-hint\" translate=\"RUNTAG.PHOTO_FORM.NO_QUESTIONS\"></p><div class=\"photo-form-questions\" \nng-sortable=\"vm.photoFormSortable\"><div class=\"photo-form-question\" \nng-repeat=\"question in vm.photoForm.questions track by question.id\" \nng-class=\"{\'has-error\': vm.photoFormConditionError(question)}\"><div class=\"photo-form-question-header\" layout=\"row\" \nlayout-align=\"start center\"><md-icon class=\"photo-form-handle\">drag_indicator</md-icon><span \nclass=\"photo-form-question-number\">{{ $index + 1 }}</span> <span class=\"photo-form-type\">\n{{ (\'RUNTAG.PHOTO_FORM.TYPES.\' + (question.type | uppercase)) | translate }} </span><span flex></span><md-button \nclass=\"md-icon-button\" ng-disabled=\"$first\" aria-label=\"Up\" ng-click=\"vm.movePhotoFormQuestion($index, -1)\"><md-icon>\narrow_upward</md-icon></md-button><md-button class=\"md-icon-button\" ng-disabled=\"$last\" aria-label=\"Down\" \nng-click=\"vm.movePhotoFormQuestion($index, 1)\"><md-icon>arrow_downward</md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Delete\" ng-click=\"vm.removePhotoFormQuestion($index)\"><md-icon>delete</md-icon>\n</md-button></div><md-input-container class=\"md-block\"><label translate=\"RUNTAG.PHOTO_FORM.QUESTION_LABEL\">Pregunta\n</label><input type=\"text\" ng-model=\"question.label[vm.photoForm.defaultLanguage]\"></md-input-container>\n<md-input-container class=\"md-block\" ng-if=\"vm.photoFormService.isText(question.type)\"><label \ntranslate=\"RUNTAG.PHOTO_FORM.PLACEHOLDER\">Texto de ayuda dentro del campo (opcional)</label><input type=\"text\" \nng-model=\"question.placeholder[vm.photoForm.defaultLanguage]\"></md-input-container><div \nng-if=\"vm.photoFormService.isChoice(question.type)\" class=\"photo-form-options\"><div class=\"photo-form-option\" \nlayout=\"row\" layout-align=\"start center\" ng-repeat=\"option in question.options track by option.id\"><md-icon \nclass=\"photo-form-option-icon\">\n{{ question.type === \'single_choice\' ? \'radio_button_unchecked\' : \'check_box_outline_blank\' }}</md-icon>\n<md-input-container flex class=\"md-block\"><label>{{ \'RUNTAG.PHOTO_FORM.OPTION_N\' | translate:{n: $index + 1} }}</label>\n<input type=\"text\" ng-model=\"option.label[vm.photoForm.defaultLanguage]\"></md-input-container><md-button \nclass=\"md-icon-button\" aria-label=\"Remove option\" ng-click=\"vm.removePhotoFormOption(question, $index)\"><md-icon>close\n</md-icon></md-button></div><md-button class=\"photo-form-add-option\" ng-click=\"vm.addPhotoFormOption(question)\">\n<md-icon>add</md-icon><span translate=\"RUNTAG.PHOTO_FORM.ADD_OPTION\">Añadir opción</span></md-button><md-checkbox \nng-model=\"question.allowOther\"><span translate=\"RUNTAG.PHOTO_FORM.ALLOW_OTHER\">Añadir \"Otros\" con texto libre</span>\n</md-checkbox><md-input-container class=\"md-block secondary\" ng-if=\"question.allowOther\"><label \ntranslate=\"RUNTAG.PHOTO_FORM.OTHER_LABEL\">Texto de la opción \"Otros\"</label><input type=\"text\" \nng-model=\"question.otherLabel[vm.photoForm.defaultLanguage]\"></md-input-container></div><md-checkbox \nng-if=\"question.type === \'email\'\" ng-model=\"question.useForDelivery\"><span \ntranslate=\"RUNTAG.PHOTO_FORM.USE_FOR_DELIVERY\">Enviar las fotos a este email</span></md-checkbox><md-checkbox \nng-model=\"question.required\"><span translate=\"RUNTAG.PHOTO_FORM.REQUIRED\">Obligatoria</span></md-checkbox><md-checkbox \nng-model=\"question.hasCondition\" ng-change=\"vm.onPhotoFormConditionToggle(question)\" \nng-disabled=\"!question.hasCondition && !vm.photoFormConditionSources(question).length\"><span \ntranslate=\"RUNTAG.PHOTO_FORM.CONDITION\">Mostrar solo según una respuesta anterior</span></md-checkbox><div \nng-if=\"question.hasCondition\" layout=\"row\" layout-xs=\"column\" class=\"photo-form-fields photo-form-condition secondary\">\n<md-input-container flex=\"60\" flex-xs=\"100\"><label translate=\"RUNTAG.PHOTO_FORM.CONDITION_QUESTION\">Si en la pregunta…\n</label><md-select ng-model=\"question.showIf.questionId\" ng-change=\"question.showIf.value = null\"><md-option \nng-repeat=\"source in vm.photoFormConditionSources(question) track by source.id\" ng-value=\"source.id\">\n{{ vm.photoForm.questions.indexOf(source) + 1 }}. {{ source.label[vm.photoForm.defaultLanguage] }}</md-option>\n</md-select></md-input-container><md-input-container flex ng-if=\"question.showIf.questionId\"><label \ntranslate=\"RUNTAG.PHOTO_FORM.CONDITION_VALUE\">…respondió</label><md-select ng-model=\"question.showIf.value\"><md-option \nng-repeat=\"item in vm.photoFormConditionValues(question) track by item.value\" ng-value=\"item.value\">{{ item.label }}\n</md-option></md-select></md-input-container></div><p ng-if=\"vm.photoFormConditionError(question)\" \nclass=\"photo-form-card-error secondary\"><md-icon>error_outline</md-icon><span>\n{{ vm.photoFormConditionError(question) }}</span></p></div></div><md-menu><md-button \nclass=\"md-raised photo-form-add-question\" ng-click=\"$mdMenu.open($event)\"><md-icon>add</md-icon><span \ntranslate=\"RUNTAG.PHOTO_FORM.ADD_QUESTION\">Añadir pregunta</span></md-button><md-menu-content width=\"4\"><md-menu-item \nng-repeat=\"t in vm.photoFormService.QUESTION_TYPES\"><md-button ng-click=\"vm.addPhotoFormQuestion(t.type)\"><md-icon>\n{{ t.icon }}</md-icon>{{ (\'RUNTAG.PHOTO_FORM.TYPES.\' + (t.type | uppercase)) | translate }}</md-button></md-menu-item>\n</md-menu-content></md-menu><div class=\"photo-form-screen\"><h4 translate=\"RUNTAG.PHOTO_FORM.OUTRO\">Pantalla final</h4>\n<md-input-container class=\"md-block\"><label translate=\"RUNTAG.PHOTO_FORM.SCREEN_TITLE\">Título</label><input \ntype=\"text\" ng-model=\"vm.photoForm.screens.outro.title[vm.photoForm.defaultLanguage]\"></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"RUNTAG.PHOTO_FORM.SCREEN_TEXT\">Texto</label><textarea rows=\"2\" \nng-model=\"vm.photoForm.screens.outro.text[vm.photoForm.defaultLanguage]\"></textarea></md-input-container><div \nlayout=\"row\" layout-xs=\"column\" class=\"photo-form-fields\"><md-input-container flex><label \ntranslate=\"RUNTAG.PHOTO_FORM.LINK_URL\">Enlace (opcional)</label><input type=\"url\" \nng-model=\"vm.photoForm.screens.outro.linkUrl\"></md-input-container><md-input-container flex><label \ntranslate=\"RUNTAG.PHOTO_FORM.LINK_LABEL\">Texto del enlace</label><input type=\"text\" \nng-model=\"vm.photoForm.screens.outro.linkLabel[vm.photoForm.defaultLanguage]\"></md-input-container></div></div><div \nclass=\"photo-form-result\"><md-button class=\"md-raised\" ng-click=\"vm.logPhotoForm()\"><md-icon>data_object</md-icon><span\n translate=\"RUNTAG.PHOTO_FORM.SHOW_RESULT\">Ver resultado</span></md-button><div ng-if=\"vm.photoFormResult\"><p \nclass=\"photo-form-hint\" translate=\"RUNTAG.PHOTO_FORM.RESULT_HINT\"></p><ul ng-if=\"vm.photoFormResult.issues.length\" \nclass=\"photo-form-issues\"><li ng-repeat=\"issue in vm.photoFormResult.issues\">{{ issue }}</li></ul><pre \nclass=\"photo-form-json\">{{ vm.photoFormResult.text }}</pre></div></div></div></fieldset>");
$templateCache.put("app/main/apps/runtag/event/dialogs/event/tabs/tab-event.html","<div class=\"scroll-with-actions\"><md-content class=\"p-0 event-tab h-full\" novalidate layout-padding layout=\"row\" \nlayout-xs=\"column\"><form name=\"addEventForm\" class=\"p-30\" flex=\"50\" flex-xs=\"100\" novalidate layout=\"column\" \nlayout-xs=\"column\"><md-input-container ng-if=\"vm.clients.length > 1\" class=\"w-full\"><label \ntranslate=\"RUNTAG.EVENT_FORM.CLIENT\">Cliente</label><md-select required ng-model=\"vm.eventData.id_client\"><md-option \nng-click=\"vm.changeClient(client)\" ng-value=\"client.id_clients\" ng-repeat=\"client in vm.clients\">{{client.client_name}}\n</md-option></md-select></md-input-container><md-input-container ng-if=\"vm.organizers.length > 1\" class=\"w-full\"><label\n translate=\"RUNTAG.EVENT_FORM.ORGANIZER\">Organizador</label><md-select ng-model=\"vm.eventData.id_organizer\"><md-option \nng-value=\"organizer.id_organizer\" ng-repeat=\"organizer in vm.organizers\">{{organizer.organizer_name}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\"><label translate=\"RUNTAG.EVENT_FORM.EVENT_NAME\">\nNombre del evento</label><input type=\"text\" name=\"eventName\" ng-model=\"vm.eventData.event_name\" \nplaceholder=\"{{ \'RUNTAG.EVENT_FORM.EVENT_NAME\' | translate }}\" required></md-input-container><div layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap class=\"event-date\"><md-input-container><md-datepicker \nng-model=\"vm.eventData.date\" placeholder=\"{{ \'RUNTAG.EVENT_FORM.DATE_FROM\' | translate }}\" required></md-datepicker>\n</md-input-container><md-input-container><md-datepicker ng-model=\"vm.eventData.end_date\" \nplaceholder=\"{{ \'RUNTAG.EVENT_FORM.DATE_TO\' | translate }}\" required></md-datepicker></md-input-container></div>\n<md-input-container class=\"w-full\"><label translate=\"RUNTAG.EVENT_FORM.STATUS\">Estado del evento</label><md-select \nng-model=\"vm.eventData.id_subsec\"><md-option value=\"1\">{{ \'RUNTAG.EVENT_FORM.STATUS_UNPUBLISHED\' | translate }}\n</md-option><md-option value=\"2\">{{ \'RUNTAG.EVENT_FORM.STATUS_PRESALE\' | translate }}</md-option><md-option value=\"3\">\n{{ \'RUNTAG.EVENT_FORM.STATUS_NO_PHOTOS\' | translate }}</md-option><md-option value=\"4\">\n{{ \'RUNTAG.EVENT_FORM.STATUS_UPLOADING\' | translate }}</md-option><md-option value=\"5\">\n{{ \'RUNTAG.EVENT_FORM.STATUS_READY\' | translate }}</md-option><md-option value=\"6\">\n{{ \'RUNTAG.EVENT_FORM.STATUS_ARCHIVED\' | translate }}</md-option><md-option value=\"7\">\n{{ \'RUNTAG.EVENT_FORM.STATUS_CLOSED\' | translate }}</md-option></md-select></md-input-container><fieldset \nclass=\"mb-20\"><legend translate=\"RUNTAG.EVENT_FORM.RECOGNITION_OPTIONS\">Opciones de reconocimiento</legend><md-checkbox\n ng-model=\"vm.eventData.allow_searchby_face\" ng-checked=\"!!vm.eventData.allow_searchby_face\"><span \ntranslate=\"RUNTAG.EVENT_FORM.FACE_RECOGNITION\">Reconocimiento Facial</span></md-checkbox><md-checkbox \nng-model=\"vm.eventData.allow_searchby_number\" ng-checked=\"!!vm.eventData.allow_searchby_number\"><span \ntranslate=\"RUNTAG.EVENT_FORM.NUMBER_RECOGNITION\">Reconocimiento Dorsal</span></md-checkbox><md-checkbox \nclass=\"secondary\" ng-if=\"vm.eventData.allow_searchby_number\" ng-checked=\"!!vm.eventData.allow_no_dorsal\" \nng-model=\"vm.eventData.allow_no_dorsal\"><span translate=\"RUNTAG.EVENT_FORM.ALLOW_NO_DORSAL\">\nPermite a los usuarios registrarse sin dorsal</span></md-checkbox><md-checkbox class=\"secondary\" \nng-if=\"vm.eventData.allow_searchby_number\" ng-checked=\"!!vm.eventData.ignore_letter\" \nng-model=\"vm.eventData.ignore_letter\"><span translate=\"RUNTAG.EVENT_FORM.IGNORE_LETTER\">\nIgnorar las letras del dorsal (buscar solo por números)</span></md-checkbox><md-checkbox \nng-model=\"vm.eventData.profile_face_selection\" ng-checked=\"!!vm.eventData.profile_face_selection\"><span \ntranslate=\"RUNTAG.EVENT_FORM.PROFILE_FACE_SELECTION\">Permitir elegir la foto de perfil entre las fotos asignadas</span>\n</md-checkbox><md-input-container class=\"secondary\" ng-if=\"vm.eventData.profile_face_selection\"><label \ntranslate=\"RUNTAG.EVENT_FORM.PROFILE_FACE_MAX\">Número máximo de caras a elegir (0 = sin límite)</label><input \ntype=\"number\" name=\"profileFaceMax\" min=\"0\" step=\"1\" ng-model=\"vm.eventData.profile_face_max\" \nplaceholder=\"{{ \'RUNTAG.EVENT_FORM.PROFILE_FACE_MAX\' | translate }}\"></md-input-container></fieldset>\n<md-input-container ng-if=\"vm.eventData.allow_searchby_face && vm.eventData.allow_searchby_number\" class=\"w-full\">\n<label translate=\"RUNTAG.EVENT_FORM.SEARCH_ORDER\">Orden de búsqueda</label><md-select \nng-model=\"vm.eventData.searchby_order\"><md-option value=\"number\">\n{{ \'RUNTAG.EVENT_FORM.SEARCH_ORDER_NUMBER\' | translate }}</md-option><md-option value=\"face\">\n{{ \'RUNTAG.EVENT_FORM.SEARCH_ORDER_FACE\' | translate }}</md-option></md-select></md-input-container><fieldset \nclass=\"mb-20\"><legend translate=\"RUNTAG.EVENT_FORM.ADDITIONAL_SETTINGS\">Configuración adicional</legend><md-checkbox \nng-if=\"!vm.eventData.allow_searchby_number\" ng-model=\"vm.eventData.without_dorsal\" \nng-checked=\"!!vm.eventData.without_dorsal\"><span translate=\"RUNTAG.EVENT_FORM.WITHOUT_DORSAL\">Evento sin dorsal</span>\n</md-checkbox><md-checkbox ng-model=\"vm.eventData.allow_event_code\" ng-checked=\"!!vm.eventData.allow_event_code\"><span \ntranslate=\"RUNTAG.EVENT_FORM.REQUIRE_ACCESS_CODE\">Requiere código de acceso</span></md-checkbox><md-checkbox \nng-model=\"vm.eventData.all_free\" ng-checked=\"!!vm.eventData.all_free\"><span translate=\"RUNTAG.EVENT_FORM.ALL_FREE\">\nTodas las fotos gratis</span></md-checkbox><md-checkbox ng-model=\"vm.eventData.longtime_event\" \nng-checked=\"!!vm.eventData.longtime_event\"><span translate=\"RUNTAG.EVENT_FORM.LONGTIME_EVENT\">Evento de larga duración\n</span></md-checkbox><md-checkbox ng-model=\"vm.eventData.show_locations\" ng-checked=\"!!vm.eventData.show_locations\">\n<span translate=\"RUNTAG.EVENT_FORM.SHOW_LOCATIONS\">Mostrar locaciones</span></md-checkbox></fieldset><ng-include \nng-if=\"vm.eventData.all_free\" src=\"\'app/main/apps/runtag/event/dialogs/event/tabs/tab-event-photo-form.html\'\">\n</ng-include><fieldset class=\"mb-20\"><legend translate=\"RUNTAG.EVENT_FORM.CART_SETTINGS\">Carrito</legend><md-checkbox \nng-model=\"vm.eventData.cart_enabled\" ng-checked=\"!!vm.eventData.cart_enabled\"><span \ntranslate=\"RUNTAG.EVENT_FORM.CART_ENABLED\">Evento de carrito</span></md-checkbox><md-checkbox class=\"secondary\" \nng-if=\"vm.eventData.cart_enabled\" ng-model=\"vm.eventData.buy_all_requires_face\" \nng-checked=\"!!vm.eventData.buy_all_requires_face\"><span translate=\"RUNTAG.EVENT_FORM.BUY_ALL_REQUIRES_FACE\">\nComprar todas solo con cara de perfil</span></md-checkbox></fieldset><md-input-container class=\"md-block\"><label \ntranslate=\"RUNTAG.EVENT_FORM.ASSIGN_LIMIT\">Límite de fotos a asignar</label><input type=\"number\" \nname=\"limitAssignImages\" ng-model=\"vm.eventData.limit_assign_images\" \nplaceholder=\"{{ \'RUNTAG.EVENT_FORM.ASSIGN_LIMIT\' | translate }}\"></md-input-container><md-input-container \nclass=\"md-block\" ng-if=\"!vm.eventData.all_free\"><label translate=\"RUNTAG.EVENT_FORM.FREE_IMAGES\">Número de fotos gratis\n</label><input type=\"number\" name=\"freeImages\" ng-model=\"vm.eventData.free_images\" \nplaceholder=\"{{ \'RUNTAG.EVENT_FORM.FREE_IMAGES\' | translate }}\"></md-input-container><md-input-container \nclass=\"md-block\"><label translate=\"RUNTAG.EVENT_FORM.SEO_DESC\">Descripción SEO</label><textarea \nng-model=\"vm.eventData.seo_desc\" rows=\"3\"></textarea></md-input-container></form><div flex=\"50\" flex-xs=\"100\" \nlayout=\"column\" class=\"images border-left\"><div class=\"w-full\"><label translate=\"RUNTAG.EVENT_FORM.LOGO\">\nLogo del evento</label><div class=\"upload-container\" layout=\"column\" layout-align=\"center center\"><input type=\"file\" \nid=\"fileInput-logo\" accept=\"image/*\" style=\"display: none\" onchange=\"angular.element(this).scope().fileChanged(this)\"> \n<img ng-click=\"vm.triggerFileInput(\'logo\')\" ng-if=\"vm.imagePreview.logo\" ng-src=\"{{ vm.imagePreview.logo }}\" \nalt=\"Vista previa\" style=\"max-width: 200px; margin-top: 10px; border-radius: 10px\"><md-button \nng-if=\"!vm.imagePreview.logo\" ng-click=\"vm.triggerFileInput(\'logo\')\" class=\"md-fab md-mini md-primary\"><md-icon>add\n</md-icon></md-button><p translate=\"RUNTAG.EVENT_FORM.UPLOAD_LOGO_HINT\">Subir imagen: Tamaño recomendado 300 × 300 px\n</p></div></div><div class=\"w-full\"><label translate=\"RUNTAG.EVENT_FORM.IMAGE\">Imagen del evento</label><div \nclass=\"upload-container\" layout=\"column\" layout-align=\"center center\"><input type=\"file\" id=\"fileInput-image\" \naccept=\"image/*\" style=\"display: none\" onchange=\"angular.element(this).scope().fileChanged(this)\"> <img \nng-click=\"vm.triggerFileInput(\'image\')\" ng-if=\"vm.imagePreview.image\" ng-src=\"{{ vm.imagePreview.image }}\" \nalt=\"Vista previa\" style=\"max-width: 200px; margin-top: 10px; border-radius: 10px\"><md-button \nng-if=\"!vm.imagePreview.image\" ng-click=\"vm.triggerFileInput(\'image\')\" class=\"md-fab md-mini md-primary\"><md-icon>add\n</md-icon></md-button><p translate=\"RUNTAG.EVENT_FORM.UPLOAD_IMAGE_HINT\">Subir imagen: Tamaño recomendado 746 × 488 px\n</p></div></div><div class=\"w-full\"><label translate=\"RUNTAG.EVENT_FORM.WATERMARK\">Marca de agua del evento</label><div\n class=\"upload-container mb-40\" layout=\"column\" layout-align=\"center center\"><input type=\"file\" \nid=\"fileInput-watermark\" accept=\"image/*\" style=\"display: none\" \nonchange=\"angular.element(this).scope().fileChanged(this)\"> <img ng-click=\"vm.triggerFileInput(\'watermark\')\" \nng-if=\"vm.imagePreview.watermark\" ng-src=\"{{ vm.imagePreview.watermark }}\" alt=\"Vista previa\" \nstyle=\"max-width: 200px; margin-top: 10px; border-radius: 10px\"><md-button \nng-if=\"!vm.imagePreview.watermark && vm.eventData.id_client\" ng-click=\"vm.triggerFileInput(\'watermark\')\" \nclass=\"md-fab md-mini md-primary\"><md-icon>add</md-icon></md-button><p ng-if=\"!vm.eventData.id_client\" \nclass=\"text-center text-gray-500\" translate=\"RUNTAG.EVENT_FORM.WATERMARK_SELECT_CLIENT\">\nSeleccioná primero un cliente para configurar la marca de agua.</p></div></div></div></md-content><md-dialog-actions \nlayout=\"row\" layout-align=\"end center\"><div class=\"button-container\"><md-button ng-if=\"!vm.created\" \nng-disabled=\"addEventForm.$invalid\" class=\"md-raised md-accent\" ng-click=\"vm.saveEvent()\" translate=\"CONTENT.SAVE\">SAVE\n</md-button><md-button ng-if=\"vm.created\" ng-disabled=\"addEventForm.$invalid\" class=\"md-raised md-accent\" \nng-click=\"vm.saveEvent()\" translate=\"CONTENT.UPDATE\">UPDATE</md-button></div></md-dialog-actions></div>");
$templateCache.put("app/main/apps/runtag/event/dialogs/event/tabs/tab-location.html","<div class=\"scroll-with-actions\"><md-content class=\"p-0 locations-tab h-full\" novalidate layout-padding layout=\"row\" \nlayout-xs=\"column\"><div layout=\"column\" class=\"location-list p-0 border-right\" flex=\"50\" flex-xs=\"100\"><div \nlayout=\"row\" layout-align=\"start center\" class=\"add-location-button border-bottom py-20 px-25 gap-10\"><md-button \nclass=\"md-fab md-mini md-primary\" ng-click=\"vm.selectLocation(\'new\')\"><md-icon>add</md-icon></md-button><span>\nCrear nueva localización</span></div><div ng-repeat=\"location in vm.locations\" ng-click=\"vm.selectLocation(location)\" \nclass=\"location-item border-bottom py-10 px-25\" layout=\"row\" layout-align=\"space-between center\"><div><p><strong>\n{{location.name}}</strong></p></div><md-button class=\"md-icon-button md-warn\" \nng-click=\"vm.deleteLocation(location.reference_name, $event)\"><md-icon>delete</md-icon></md-button></div></div><form \nname=\"addLocationForm\" novalidate layout=\"column\" flex=\"50\" flex-xs=\"100\" ng-if=\"vm.selectedLocation\" \nclass=\"p-25 mobile-position-form\"><md-input-container class=\"md-block\"><label>Nombre Localización</label><input \nname=\"folder_name\" ng-disabled=\"vm.selectedLocation != \'new\'\" type=\"text\" ng-model=\"vm.locationData.name\" required><div\n ng-messages=\"addLocationForm.folder_name.$error\" ng-if=\"addLocationForm.folder_name.$touched\"><div \nng-message=\"required\">Este campo es obligatorio.</div></div></md-input-container><md-input-container class=\"md-block\">\n<label>Nombre Carpeta</label><input name=\"reference_name\" ng-disabled=\"vm.selectedLocation != \'new\'\" type=\"text\" \nng-model=\"vm.locationData.reference_name\" ng-pattern=\"/^[a-zA-Z0-9]+$/\" ng-trim=\"true\" required><div \nng-messages=\"addLocationForm.reference_name.$error\" ng-if=\"addLocationForm.reference_name.$touched\"><div \nng-message=\"required\">Este campo es obligatorio.</div><div ng-message=\"pattern\">\nSolo se permiten letras y números, sin espacios ni caracteres especiales.</div></div></md-input-container></form>\n</md-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><div layout=\"row\" layout-align=\"end center\" \nclass=\"action-buttons\" ng-if=\"vm.selectedLocation\"><md-button ng-if=\"vm.selectedLocation === \'new\'\" \nclass=\"md-raised md-primary\" ng-click=\"vm.saveLocation()\">GUARDAR</md-button><md-button class=\"md-raised md-warn\" \nng-click=\"vm.cancelLocation()\">CANCELAR</md-button><md-button class=\"md-raised md-warn\" ng-click=\"vm.deleteLocation()\">\nBORRAR</md-button></div></md-dialog-actions></div>");
$templateCache.put("app/main/apps/runtag/event/dialogs/event/tabs/tab-photographer.html","<div class=\"scroll-with-actions\"><md-content class=\"p-0 h-full\" novalidate layout-padding layout=\"row\" \nlayout-xs=\"column\"><div layout=\"column\" class=\"photographer-list p-0 border-right\" flex=\"50\" flex-xs=\"100\"><div \nlayout=\"row\" layout-align=\"start center\" class=\"add-photographer-button border-bottom py-20 px-25 gap-10\"><md-button \nclass=\"md-fab md-mini md-primary\" ng-click=\"vm.selectPhotographer(\'new\')\"><md-icon>add</md-icon></md-button><span>\nCrear nuevo Fotografo</span></div><div ng-repeat=\"photographer in vm.photographers\" \nng-click=\"vm.selectPhotographer(photographer)\" class=\"photographer-item border-bottom px-25 py-10\" layout=\"row\" \nlayout-align=\"space-between center\"><div><p><strong>{{photographer.name}}</strong></p></div><md-button \nclass=\"md-icon-button md-warn\" ng-click=\"vm.deletePhotographer(photographer.id_photographer, $event)\"><md-icon>delete\n</md-icon></md-button></div><md-button ng-disabled=\"vm.photographers.length < 1\" \nclass=\"md-primary md-raised mt-10 ml-25 mr-25\" ng-click=\"vm.downloadPhotographerData()\">Descargar datos de fotógrafos\n</md-button></div><form name=\"addPhotographerForm\" novalidate layout=\"column\" flex=\"50\" flex-xs=\"100\" \nng-if=\"vm.selectedPhotographer\" class=\"p-25 mobile-position-form\"><md-input-container \nng-if=\"vm.dbPhotographers && vm.dbPhotographers.length > 0 && (vm.selectedPhotographer === \'new\' || !vm.notInEventPhotographers())\" \nclass=\"w-full mt-0\"><label>Selecciona un fotógrafo</label><md-select ng-model=\"vm.photographerData\" \nmd-on-open=\"vm.focusSearchInput()\" md-on-close=\"vm.clearSearch()\"><md-select-header class=\"photographer-select-header\">\n<input id=\"search-photographer-input\" type=\"text\" ng-model=\"vm.searchPhotographer\" placeholder=\"Buscar fotógrafo...\" \nclass=\"md-text\" aria-label=\"Buscar fotógrafo\" ng-keydown=\"$event.stopPropagation()\"></md-select-header><md-option \nng-value=\"{}\" ng-click=\"vm.selectPhotographer(\'new\')\">+ Nuevo fotógrafo</md-option><md-option ng-value=\"photographer\" \nng-repeat=\"photographer in vm.filteredPhotographers(vm.searchPhotographer)\" \nng-click=\"vm.selectPhotographer(photographer)\">{{photographer.name}} ({{photographer.camera_name}})</md-option>\n</md-select></md-input-container><span ng-if=\"vm.selectedPhotographer === \'new\' || !vm.notInEventPhotographers()\" \nclass=\"text-center\">o cree un nuevo fotógrafo:</span><md-input-container class=\"md-block\"><label>Nombre Fotógrafo\n</label><input name=\"photographer_name\" ng-disabled=\"vm.selectedPhotographer != \'new\'\" type=\"text\" \nng-model=\"vm.photographerData.name\" required><div ng-messages=\"addPhotographerForm.photographer_name.$error\" \nng-if=\"addPhotographerForm.photographer_name.$touched\"><div ng-message=\"required\">Este campo es obligatorio.</div>\n</div></md-input-container><md-input-container class=\"md-block\"><label>Email Fotógrafo</label><input \nname=\"photographer_email\" ng-disabled=\"vm.selectedPhotographer != \'new\'\" type=\"text\" \nng-model=\"vm.photographerData.email\"></md-input-container><md-input-container class=\"md-block\"><label>Nombre Carpeta\n</label><input name=\"camera_name\" ng-disabled=\"vm.selectedPhotographer != \'new\'\" type=\"text\" \nng-model=\"vm.photographerData.camera_name\" ng-pattern=\"/^[a-zA-Z0-9]+$/\" ng-trim=\"true\" required><div \nng-messages=\"addPhotographerForm.camera_name.$error\" ng-if=\"addPhotographerForm.camera_name.$touched\"><div \nng-message=\"required\">Este campo es obligatorio.</div><div ng-message=\"pattern\">\nSolo se permiten letras y números, sin espacios ni caracteres especiales.</div></div></md-input-container><div \nlayout=\"column\" class=\"gap-4\" ng-if=\"vm.selectedPhotographer && vm.selectedPhotographer != \'new\'\"><div class=\"mb-10\">\n<strong>Credenciales:</strong></div><div class=\"cred-item\"><span><strong>Usuario:</strong>\n {{ vm.photographerData.aws_access_key }}</span><md-icon class=\"copy-icon cursor-pointer ml-2\" \nmd-font-icon=\"icon-content-copy\" ng-click=\"vm.copyToClipboard(vm.photographerData.aws_access_key)\" \naria-label=\"Copiar usuario\"></md-icon></div><div class=\"cred-item\"><span><strong>Contraseña:</strong>\n {{ vm.photographerData.aws_secret_key }}</span><md-icon class=\"copy-icon cursor-pointer ml-2\" \nmd-font-icon=\"icon-content-copy\" ng-click=\"vm.copyToClipboard(vm.photographerData.aws_secret_key)\" \naria-label=\"Copiar contraseña\"></md-icon></div><div class=\"cred-item\"><span><strong>Ruta:</strong>\n {{ vm.generateFolderPath() }}</span><md-icon class=\"copy-icon cursor-pointer ml-2\" md-font-icon=\"icon-content-copy\" \nng-click=\"vm.copyToClipboard(vm.generateFolderPath())\" aria-label=\"Copiar ruta\"></md-icon></div></div></form>\n</md-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><div layout=\"row\" layout-align=\"end center\" \nclass=\"action-buttons\" ng-if=\"vm.selectedPhotographer\"><md-button \nng-if=\"vm.selectedPhotographer === \'new\' || !vm.notInEventPhotographers()\" class=\"md-raised md-primary\" \nng-click=\"vm.savePhotographer()\" ng-disabled=\"addPhotographerForm.$invalid\">GUARDAR</md-button><md-button \nclass=\"md-raised md-warn\" ng-click=\"vm.cancelPhotographer()\">CANCELAR</md-button><md-button \nng-if=\"vm.selectedPhotographer != \'new\' && vm.notInEventPhotographers()\" class=\"md-raised md-warn\" \nng-click=\"vm.deletePhotographer()\">BORRAR</md-button></div></md-dialog-actions></div>");
$templateCache.put("app/main/apps/runtag/event/dialogs/event/tabs/tab-product.html","<div class=\"scroll-with-actions\"><md-content class=\"p-0 products-tab h-full\" novalidate layout-padding layout=\"row\" \nlayout-xs=\"column\"><div flex=\"50\" flex-xs=\"100\" layout=\"column\" class=\"product-list border-right p-0\"><div \nlayout=\"row\" layout-align=\"start center\" class=\"add-product-button py-20 px-25 border-bottom gap-10\"><md-button \nclass=\"md-fab md-mini md-primary\" ng-click=\"vm.selectProduct(\'new\')\"><md-icon>add</md-icon></md-button><span>\nCrear nuevo Pack</span></div><div ng-repeat=\"product in vm.products\" ng-click=\"vm.selectProduct(product)\" \nclass=\"product-item border-bottom px-25 py-10\" layout=\"row\" layout-align=\"space-between center\"><div><p><strong><span \nng-if=\"product.product_label\">{{product.product_label}} ({{vm.stripHtml(product.product)}})</span> <span \nng-if=\"!product.product_label\" ng-bind-html=\"product.product\"></span>\n - {{product.price_total}} {{product.currency_code}}</strong></p><p>Método de Pago: <span class=\"bold\">\n{{ product.payment_method_name }}</span></p></div><span ng-if=\"product.onoff == false\">Inactivo</span></div></div><form\n flex=\"50\" flex-xs=\"100\" name=\"addProductForm\" novalidate layout=\"column\" ng-if=\"vm.selectedProduct\" \nclass=\"p-25 mobile-position-form\"><md-input-container \nng-if=\"vm.defaultProducts && vm.defaultProducts.length > 0 && (vm.selectedProduct === \'new\' || !vm.notInEventProduct())\" \nclass=\"w-full\"><label>Selecciona un producto</label><md-select ng-model=\"vm.selectedProduct\" \nng-change=\"vm.selectProduct(vm.selectedProduct)\"><md-option ng-value=\"{}\">+ Nuevo producto</md-option><md-option \nng-value=\"product\" ng-repeat=\"product in vm.defaultProducts\"><span ng-if=\"product.product_label\">\n{{product.product_label}} ({{vm.stripHtml(product.product)}})</span> <span ng-if=\"!product.product_label\" \nng-bind-html=\"product.product\"></span></md-option></md-select></md-input-container><md-switch \nng-model=\"vm.productData.onoff\"><strong>{{ vm.productData.onoff ? \'Activo\' : \'Inactivo\' }}</strong></md-switch>\n<md-input-container class=\"md-block\"><label>Etiqueta Producto</label><input type=\"text\" \nng-model=\"vm.productData.product_label\"></md-input-container><md-input-container class=\"md-block\"><label>\nNombre referencia</label><input type=\"text\" ng-model=\"vm.productData.product\" required></md-input-container><div \nlayout=\"row\" layout-align=\"space-between center\" layout-wrap><md-input-container class=\"md-block\" flex=\"60\"><label>\nPrecio</label><input type=\"number\" ng-model=\"vm.productData.price_total\" required></md-input-container>\n<md-input-container class=\"md-block\" flex=\"35\"><label>Moneda</label><md-select ng-model=\"vm.productData.currency_code\" \nrequired><md-option ng-repeat=\"c in vm.arrayCurrencies\" ng-value=\"c\">{{c}}</md-option></md-select></md-input-container>\n</div><md-input-container class=\"md-block\"><label>Método de pago</label><md-select \nng-model=\"vm.productData.id_payment_method\"><md-option ng-repeat=\"method in vm.paymentMethods\" ng-value=\"method.id\">\n{{method.name}}</md-option></md-select></md-input-container><fieldset class=\"mb-20\"><legend>Opciones</legend>\n<md-checkbox ng-model=\"vm.productData.default_products\">Producto predeterminado</md-checkbox></fieldset>\n<md-input-container class=\"md-block\"><label>Países donde se aplica</label><textarea \nng-model=\"vm.productData.countries\" rows=\"3\"></textarea></md-input-container></form></md-content><md-dialog-actions \nlayout=\"row\" layout-align=\"end center\"><div layout=\"row\" layout-align=\"end center\" class=\"action-buttons\" \nng-if=\"vm.selectedProduct\"><md-button class=\"md-raised md-warn\" ng-click=\"vm.cancelProduct()\">CANCELAR</md-button>\n<md-button class=\"md-raised md-accent\" ng-click=\"vm.saveProduct()\">GUARDAR</md-button></div></md-dialog-actions></div>");
$templateCache.put("app/main/apps/scrumboard/views/calendar/dialogs/event/event-dialog.html","<md-dialog class=\"event-calendar-dialog\" aria-label=\"Event Dialog\" ng-cloak><md-toolbar class=\"md-accent\" \nng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><h2 class=\"title\">\n{{vm.dueDate | date:\'mediumDate\':\'UTC\'}}</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"close dialog\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-tabs md-dynamic-height><md-tab><md-tab-label>\n<span translate=\"SB.ADD_A_CARD\">Add a card</span></md-tab-label><md-tab-body><div class=\"new-card\" layout=\"column\">\n<form name=\"newCardForm\" novalidate><md-input-container class=\"new-card-name md-block\" md-no-float><input name=\"name\" \nng-model=\"vm.newCard.name\" placeholder=\"Card name\" required><div ng-messages=\"newCardForm.name.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"SB.ERRORS.TITLE_REQUIRED\">Title field is required</span></div></div>\n</md-input-container><div class=\"lists\"><p>Select a list:</p><md-radio-group ng-model=\"vm.newCard.listId\" required>\n<md-radio-button ng-repeat=\"list in vm.board.lists\" ng-value=\"list.id\">{{list.name}}</md-radio-button></md-radio-group>\n</div><md-dialog-actions><md-button class=\"md-accent md-raised\" ng-click=\"vm.addNewCard()\" \nng-disabled=\"newCardForm.$invalid || newCardForm.$pristine\">Add</md-button></md-dialog-actions></form></div>\n</md-tab-body></md-tab><md-tab><md-tab-label><span translate=\"SB.ASSIGN_THE_DATE_TO_CARDS\">Assign the date to cards\n</span></md-tab-label><md-tab-body><div class=\"assign-due-date\"><md-list class=\"cards\"><md-content \nclass=\"cards-content\" flex ms-scroll><md-list-item class=\"card\" ng-repeat=\"card in vm.board.cards\" \nng-click=\"vm.toggleInArray(card.id, vm.selectedCards)\" aria-label=\"card\"><p layout=\"column\" layout-align=\"start start\">\n<span class=\"card-name\">{{card.name}}</span> <span ng-if=\"card.due\" class=\"card-date\">{{card.due | date}}</span></p>\n<md-checkbox ng-checked=\"vm.exists(card.id, vm.selectedCards)\" ng-click=\"vm.toggleInArray(card.id, vm.selectedCards)\" \nclass=\"md-secondary\" aria-label=\"card\"></md-checkbox></md-list-item></md-content></md-list><md-dialog-actions>\n<md-button ng-disabled=\"!vm.selectedCards[0]\" ng-click=\"vm.assignDueDate()\" class=\"md-accent md-raised\">Assign\n</md-button></md-dialog-actions></div></md-tab-body></md-tab></md-tabs></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/scrumboard/sidenavs/settings/menus/labels/labels-menu.html","<md-list><md-subheader class=\"md-no-sticky\">Add New Label</md-subheader><md-list-item class=\"label\"><div layout=\"row\" \nlayout-align=\"start center\"><md-menu md-offset=\"0 52px\"><md-button class=\"md-icon-button label-color-button\" \nng-click=\"$mdMenu.open($event)\" aria-label=\"label color\"><md-icon md-font-icon=\"icon-label\" \nng-class=\"vm.newLabelColor+\'-fg\'\" class=\"label-icon\"></md-icon></md-button><md-menu-content \nclass=\"labels-settings-menu-content\" width=\"3\"><div class=\"new-label-color-pick\" layout=\"row\" layout-wrap><label \nclass=\"color\" ng-repeat=\"(palette, hues) in vm.palettes\" \nng-style=\"{\'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1)}\" layout=\"column\" \nlayout-align=\"center center\"><input class=\"ng-hide\" type=\"radio\" ng-model=\"vm.newLabelColor\" ng-value=\"palette\" \naria-label=\"{{palette}}\" ng-click=\"$mdMenu.hide()\"> <i class=\"icon-check s18\" ng-if=\"label.color === palette\"></i>\n</label></div></md-menu-content></md-menu><span editable-text=\"vm.newLabelName\" e-form=\"newLabelForm\" \nonaftersave=\"vm.addNewLabel()\"></span><p flex class=\"title new-label-form-button\" ng-click=\"newLabelForm.$show()\" \nng-hide=\"newLabelForm.$visible\">Enter New Label Name</p></div></md-list-item><md-divider></md-divider><md-list-item \nclass=\"label\" ng-repeat=\"label in vm.board.labels\"><div layout=\"row\" layout-align=\"start center\"><md-menu \nmd-offset=\"0 52px\"><md-button class=\"md-icon-button label-color-button\" ng-click=\"$mdMenu.open($event)\" \naria-label=\"label color\"><md-icon md-font-icon=\"icon-label\" ng-class=\"label.color+\'-fg\'\" class=\"label-icon\"></md-icon>\n</md-button><md-menu-content class=\"labels-settings-menu-content\" width=\"3\"><div class=\"new-label-color-pick\" \nlayout=\"row\" layout-wrap><label class=\"color\" ng-repeat=\"(palette, hues) in vm.palettes\" \nng-style=\"{\'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1)}\" layout=\"column\" \nlayout-align=\"center center\"><input class=\"ng-hide\" type=\"radio\" ng-model=\"label.color\" ng-value=\"palette\" \naria-label=\"{{palette}}\" ng-click=\"$mdMenu.hide()\"> <i class=\"icon-check s18\" ng-if=\"label.color === palette\"></i>\n</label></div></md-menu-content></md-menu><p flex class=\"title\" editable-text=\"label.name\">{{label.name}}</p><md-button\n ng-click=\"vm.removeLabel($event, label.id);\" class=\"remove-button md-icon-button\" aria-label=\"remove\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon></md-button></div></md-list-item></md-list>");
$templateCache.put("app/main/apps/scrumboard/sidenavs/settings/menus/color/color-menu.html","<div class=\"header md-whiteframe-2dp\"><md-list><md-list-item class=\"selected-color\"><p class=\"title\" flex>\nSelected Color:</p><div ng-if=\"!vm.board.settings.color\" class=\"preview md-background-bg md-hue-1\"></div><div \nng-if=\"vm.board.settings.color\" class=\"preview\" ng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\">\n{{vm.board.settings.color}}</div><md-button class=\"md-icon-button\" ng-click=\"vm.board.settings.color = \'\'\" \naria-label=\"Default Color\"><md-icon md-font-icon=\"icon-close-circle\"></md-icon></md-button></md-list-item></md-list>\n</div><div flex class=\"content\" ms-scroll ms-sidenav-helper><md-list><md-list-item class=\"color\" \nng-repeat=\"(paletteName, palette) in vm.palettes\" ng-click=\"vm.board.settings.color = paletteName\" \nng-class=\"\'md-\'+paletteName+\'-bg\'\" aria-label=\"color select\"><p flex>{{paletteName}}</p><i class=\"icon-check s16\" \nng-if=\"paletteName === vm.board.settings.color\"></i></md-list-item></md-list></div>");
$templateCache.put("app/main/apps/scrumboard/sidenavs/settings/menus/members/members-menu.html","<md-list><md-subheader class=\"md-no-sticky\">Add New Member</md-subheader><md-list-item class=\"add-new-member\"><form \nng-submit=\"vm.newMember()\" layout=\"row\" layout-align=\"start center\"><input flex placeholder=\"Type Member Name\" \ntype=\"text\" ng-model=\"vm.newMemberSearchInput\"><md-button type=\"submit\" class=\"md-accent md-raised\" \naria-label=\"Add New Member\">Add</md-button></form></md-list-item><md-divider></md-divider><md-list-item class=\"member\" \nng-repeat=\"member in vm.board.members\"><img alt=\"{{ member.name }}\" ng-src=\"{{ member.avatar }}\" class=\"md-avatar\"><p \nclass=\"member-name\">{{ member.name }}</p><md-button ng-click=\"vm.removeMember($event, member.id);\" \nclass=\"remove-button md-icon-button\" aria-label=\"remove\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button>\n</md-list-item></md-list>");
$templateCache.put("app/main/apps/scrumboard/views/calendar/sidenavs/scheduled-tasks/scheduled-tasks-sidenav.html","<div class=\"md-title sidenav-title\">Scheduled Cards</div><div class=\"cards\"><div ng-if=\"vm.cards.length <= 0\"><span \ntranslate=\"SB.NO_SCHEDULED_CARD\">There is no scheduled card.</span></div><div class=\"card\" layout=\"row\" \nng-repeat=\"card in vm.cards\"><md-button class=\"md-raised card-date\" ng-click=\"vm.goToDate(card.start)\"><div \nclass=\"day-in-week\">{{card.due | date:\'EEEE\'}}</div><div class=\"day\">{{card.due | date:\'d\' }}</div><div \nclass=\"month-year\">{{card.due | date:\'MMM yyyy\'}}</div></md-button><div class=\"card-title\" flex layout=\"column\" \nlayout-align=\"center start\" ng-click=\"vm.openCardDialog($event, card.idCard)\"><span>{{card.title}}</span></div></div>\n</div>");
$templateCache.put("app/main/apps/sitemap/views/edit/tabs/layout-sections/layout-body.html","<div ng-init=\"\" layout=\"column\" class=\"pb-5 grey-200-bg row-container\" dragula=\"\'zone\'\" \ndragula-model=\"vm.currentSitemap.sitemap_data\" dragula-scope=\"vm.ctrlScope\"><div \nng-repeat=\"row in vm.currentSitemap.sitemap_data\" layout=\"row\" layout-align=\"space-between center\" flex=\"100\" \nclass=\"zone-row pl-5 pr-5\" ng-class=\"{\'opacity-4\':row.is_hidden == 0}\"><div ng-if=\"row.type_layout == \'full-width\'\" \nflex=\"100\" layout=\"row\" layout-align=\"space-between start\" class=\"zone-content\"><div with=\"row.zones[0].widgets\" \nas=\"widgets\" class=\"zone white-bg m-10 p-20\" layout=\"column\" flex=\"100\"><div class=\"grey-600-fg zone-name\" \nlayout=\"row\" layout-align=\"space-between center\"><span><span ng-if=\"row.label\">{{row.label}} (</span>FULL WIDTH<span \nng-if=\"row.label\">)</span></span><md-button ng-click=\"row.collapse = !row.collapse\" aria-label=\"Collapse\"><md-icon \nmd-font-icon=\"icon-content-duplicate\"></md-icon></md-button></div><div id=\"zone-{{$index}}-0\" ng-hide=\"!row.collapse\" \nng-include=\"\'app/main/apps/sitemap/views/edit/tabs/layout-sections/widget-list.html\'\" \nclass=\"widgets-container dragula-container sort-widgets\" layout=\"column\" flex \nng-class=\"{\'dashed\': widgets.length == 0}\"></div></div></div><div ng-if=\"row.type_layout == \'ajax-content\'\" flex=\"100\" \nlayout=\"row\" layout-align=\"space-between start\" class=\"zone-content\"><div with=\"row.zones[0].widgets\" as=\"widgets\" \nclass=\"zone white-bg m-10 p-20\" layout=\"column\" flex=\"100\"><div class=\"grey-600-fg zone-name\" layout=\"row\" \nlayout-align=\"space-between center\"><span><span ng-if=\"row.label\">{{row.label}} (</span>AJAX-CONTENT (NO LAYOUT)<span \nng-if=\"row.label\">)</span></span><md-button ng-click=\"row.collapse = !row.collapse\" aria-label=\"Collapse\"><md-icon \nmd-font-icon=\"icon-content-duplicate\"></md-icon></md-button></div><div id=\"zone-{{$index}}-0\" ng-hide=\"!row.collapse\" \nng-include=\"\'app/main/apps/sitemap/views/edit/tabs/layout-sections/widget-list.html\'\" \nclass=\"widgets-container dragula-container sort-widgets\" layout=\"column\" flex \nng-class=\"{\'dashed\': widgets.length == 0}\"></div></div></div><div ng-if=\"row.type_layout == \'primary\'\" layout=\"row\" \nflex=\"100\"><div class=\"zone-content\" flex=\"100\" layout=\"row\" layout-align=\"space-between start\"><div \nwith=\"row.zones[0].widgets\" as=\"widgets\" class=\"zone white-bg m-10 p-20\" layout=\"column\" flex=\"60\"><div \nclass=\"grey-600-fg zone-name\" layout=\"row\" layout-align=\"space-between center\"><span><span ng-if=\"row.label\">\n{{row.label}} (</span>PRIMARY CONTENT<span ng-if=\"row.label\">)</span></span><md-button \nng-click=\"row.collapse = !row.collapse\" aria-label=\"Collapse\"><md-icon md-font-icon=\"icon-content-duplicate\"></md-icon>\n</md-button></div><div id=\"zone-{{$index}}-0\" ng-hide=\"!row.collapse\" \nng-include=\"\'app/main/apps/sitemap/views/edit/tabs/layout-sections/widget-list.html\'\" \nclass=\"widgets-container dragula-container sort-widgets\" layout=\"column\" flex \nng-class=\"{\'dashed\': widgets.length == 0}\"></div></div><div with=\"row.zones[1].widgets\" as=\"widgets\" \nclass=\"zone white-bg m-10 p-20\" layout=\"column\" flex=\"40\"><div class=\"grey-600-fg zone-name\" layout=\"row\" \nlayout-align=\"space-between center\"><span><span ng-if=\"row.label\">{{row.label}} (</span>RELATED CONTENT<span \nng-if=\"row.label\">)</span></span><md-button ng-click=\"row.collapse = !row.collapse\" aria-label=\"Collapse\"><md-icon \nmd-font-icon=\"icon-content-duplicate\"></md-icon></md-button></div><div id=\"zone-{{$index}}-1\" ng-hide=\"!row.collapse\" \nng-include=\"\'app/main/apps/sitemap/views/edit/tabs/layout-sections/widget-list.html\'\" \nclass=\"widgets-container dragula-container sort-widgets\" layout=\"column\" flex \nng-class=\"{\'dashed\': widgets.length == 0}\"></div></div></div></div><div ng-if=\"row.type_layout == \'secondary\'\" \nlayout=\"row\" flex=\"100\"><div class=\"zone-content\" flex=\"100\" layout=\"row\" layout-align=\"space-between start\"><div \nwith=\"row.zones[0].widgets\" as=\"widgets\" class=\"zone white-bg m-10 p-20\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\">\n<div class=\"grey-600-fg zone-name\" layout=\"row\" layout-align=\"space-between center\"><span><span ng-if=\"row.label\">\n{{row.label}} (</span>SECONDARY CONTENT<span ng-if=\"row.label\">)</span></span><md-button \nng-click=\"row.collapse = !row.collapse\" aria-label=\"Collapse\"><md-icon md-font-icon=\"icon-content-duplicate\"></md-icon>\n</md-button></div><div id=\"zone-{{$index}}-0\" ng-hide=\"!row.collapse\" \nng-include=\"\'app/main/apps/sitemap/views/edit/tabs/layout-sections/widget-list.html\'\" \nclass=\"widgets-container dragula-container sort-widgets\" layout=\"column\" flex \nng-class=\"{\'dashed\': widgets.length == 0}\"></div></div><div with=\"row.zones[1].widgets\" as=\"widgets\" \nclass=\"zone white-bg m-10 p-20\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\"><div class=\"grey-600-fg zone-name\" \nlayout=\"row\" layout-align=\"space-between center\"><span><span ng-if=\"row.label\">{{row.label}} (</span>SECONDARY CONTENT\n<span ng-if=\"row.label\">)</span></span><md-button ng-click=\"row.collapse = !row.collapse\" aria-label=\"Collapse\">\n<md-icon md-font-icon=\"icon-content-duplicate\"></md-icon></md-button></div><div id=\"zone-{{$index}}-1\" \nng-hide=\"!row.collapse\" ng-include=\"\'app/main/apps/sitemap/views/edit/tabs/layout-sections/widget-list.html\'\" \nclass=\"widgets-container dragula-container sort-widgets\" layout=\"column\" flex \nng-class=\"{\'dashed\': widgets.length == 0}\"></div></div></div></div><div ng-if=\"row.type_layout == \'threecols\'\" \nlayout=\"row\" flex=\"100\"><div class=\"zone-content\" flex=\"100\" layout=\"row\" layout-align=\"space-between start\"><div \nwith=\"row.zones[0].widgets\" as=\"widgets\" class=\"zone white-bg m-10 p-20\" layout=\"column\" flex=\"100\" flex-gt-xs=\"33\">\n<div class=\"grey-600-fg zone-name\" layout=\"row\" layout-align=\"space-between center\"><span><span ng-if=\"row.label\">\n{{row.label}} (</span>3 COLUMNS<span ng-if=\"row.label\">)</span></span><md-button \nng-click=\"row.collapse = !row.collapse\" aria-label=\"Collapse\"><md-icon md-font-icon=\"icon-content-duplicate\"></md-icon>\n</md-button></div><div id=\"zone-{{$index}}-0\" ng-hide=\"!row.collapse\" \nng-include=\"\'app/main/apps/sitemap/views/edit/tabs/layout-sections/widget-list.html\'\" \nclass=\"widgets-container dragula-container sort-widgets\" layout=\"column\" flex \nng-class=\"{\'dashed\': widgets.length == 0}\"></div></div><div with=\"row.zones[1].widgets\" as=\"widgets\" \nclass=\"zone white-bg m-10 p-20\" layout=\"column\" flex=\"100\" flex-gt-xs=\"33\"><div class=\"grey-600-fg zone-name\" \nlayout=\"row\" layout-align=\"space-between center\"><span><span ng-if=\"row.label\">{{row.label}} (</span>3 COLUMNS<span \nng-if=\"row.label\">)</span></span><md-button ng-click=\"row.collapse = !row.collapse\" aria-label=\"Collapse\"><md-icon \nmd-font-icon=\"icon-content-duplicate\"></md-icon></md-button></div><div id=\"zone-{{$index}}-1\" ng-hide=\"!row.collapse\" \nng-include=\"\'app/main/apps/sitemap/views/edit/tabs/layout-sections/widget-list.html\'\" \nclass=\"widgets-container dragula-container sort-widgets\" layout=\"column\" flex \nng-class=\"{\'dashed\': widgets.length == 0}\"></div></div><div with=\"row.zones[2].widgets\" as=\"widgets\" \nclass=\"zone white-bg m-10 p-20\" layout=\"column\" flex=\"100\" flex-gt-xs=\"33\"><div class=\"grey-600-fg zone-name\" \nlayout=\"row\" layout-align=\"space-between center\"><span><span ng-if=\"row.label\">{{row.label}} (</span>3 COLUMNS<span \nng-if=\"row.label\">)</span></span><md-button ng-click=\"row.collapse = !row.collapse\" aria-label=\"Collapse\"><md-icon \nmd-font-icon=\"icon-content-duplicate\"></md-icon></md-button></div><div id=\"zone-{{$index}}-2\" ng-hide=\"!row.collapse\" \nng-include=\"\'app/main/apps/sitemap/views/edit/tabs/layout-sections/widget-list.html\'\" \nclass=\"widgets-container dragula-container sort-widgets\" layout=\"column\" flex \nng-class=\"{\'dashed\': widgets.length == 0}\"></div></div></div></div><div \nng-if=\"vm.editMode == true && vm.nolayout == false\" class=\"tools\" layout=\"column\" layout-align=\"center center\"><md-icon\n ng-click=\"row.is_hidden= 1;\" ng-if=\"row.is_hidden == 0\" md-font-icon=\"icon-checkbox-blank-circle-outline\" \nclass=\"off red-fg s24\"></md-icon><md-icon ng-click=\"row.is_hidden= 0;\" ng-if=\"row.is_hidden !== 0\" \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\"></md-icon><md-menu><md-button \nclass=\"md-icon-button\" aria-label=\"More\" ng-click=\"vm.openMenu($mdMenu, $event)\"><md-icon md-font-icon=\"icon-cog\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"vm.addRowLayout(\'duplicate\',row )\" \naria-label=\"Duplicate\"><md-icon md-font-icon=\"icon-content-duplicate\"></md-icon><span translate=\"SITEMAP.DUPLICATE\">\n</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.currentSitemap.sitemap_data.splice($index, 1)\" \naria-label=\"Delete\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span translate=\"SITEMAP.DELETE\"></span></md-button>\n</md-menu-item><md-menu-item><md-button \nng-click=\"vm.editSitemapLayout($event, vm.currentSitemap.sitemap_data, $index)\" aria-label=\"Delete\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon><span translate=\"SITEMAP.EDIT\"></span></md-button></md-menu-item>\n</md-menu-content></md-menu><md-icon class=\"dragZ icon-equal\" aria-label=\"DRAG\"></md-icon></div></div></div>");
$templateCache.put("app/main/apps/sitemap/views/edit/tabs/layout-sections/layout-footer.html","<div layout=\"column\" class=\"pb-5 grey-100-bg row-container border-top\" dragula=\"\'zone\'\" \ndragula-model=\"vm.currentSitemap.sitemap_data\" dragula-scope=\"vm.ctrlScope\" \nng-class=\"{\'active grey-200-bg\':toggleFooter}\"><div class=\"md-toolbar-tools pl-20 pr-5\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><h3 class=\"grey-700-fg\" \ntranslate=\"SITEMAP.FOOTER\"></h3></div><div layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" \nng-click=\"toggleFooter= !toggleFooter\"><md-icon md-font-icon=\"icon-chevron-down\" class=\"s24\" \nng-class=\"{\'icon-chevron-up\':toggleFooter}\"></md-icon></md-button></div></div><div \nng-repeat=\"row in vm.currentSitemap.sitemap_data\" layout=\"row\" layout-align=\"space-between center\" flex=\"100\" \nclass=\"zone-row pl-5 pr-5\" ng-class=\"{\'opacity-4\':row.is_hidden == 0}\" ng-if=\"toggleFooter\"><div \nng-if=\"row.type_layout == \'full-width\'\" flex=\"100\" layout=\"row\" layout-align=\"space-between start\"><div \nwith=\"row.zones[0].widgets\" as=\"widgets\" class=\"zone white-bg m-10 p-20\" layout=\"column\" flex=\"100\"><div \nclass=\"grey-600-fg zone-name\" layout=\"row\" layout-align=\"space-between center\"><span>FULL WIDTH</span></div><div \nng-include=\"\'app/main/apps/sitemap/views/edit/tabs/layout-sections/widget-list.html\'\" dragula=\"\'widget\'\" \ndragula-model=\"row.zones[0].widgets\" dragula-scope=\"vm.ctrlScope\" \nclass=\"widgets-container dragula-container sort-widgets\" layout=\"column\" flex></div></div></div><div \nng-if=\"row.type_layout == \'primary\'\" layout=\"row\" flex=\"100\"><div class=\"zone-content\" flex=\"100\" layout=\"row\" \nlayout-align=\"space-between start\"><div with=\"row.zones[0].widgets\" as=\"widgets\" class=\"zone white-bg m-10 p-20\" \nlayout=\"column\" flex=\"60\"><div class=\"grey-600-fg zone-name\" layout=\"row\" layout-align=\"space-between center\"><span>\nPRIMARY CONTENT</span></div><div ng-include=\"\'app/main/apps/sitemap/views/edit/tabs/layout-sections/widget-list.html\'\" \ndragula=\"\'widget\'\" dragula-model=\"row.zones[0].widgets\" dragula-scope=\"vm.ctrlScope\" \nclass=\"widgets-container dragula-container sort-widgets\" layout=\"column\" flex></div></div><div \nwith=\"row.zones[1].widgets\" as=\"widgets\" class=\"zone white-bg m-10 p-20\" layout=\"column\" flex=\"40\"><div \nclass=\"grey-600-fg zone-name\" layout=\"row\" layout-align=\"space-between center\"><span>RELATED CONTENT</span></div><div \nng-include=\"\'app/main/apps/sitemap/views/edit/tabs/layout-sections/widget-list.html\'\" dragula=\"\'widget\'\" \ndragula-model=\"row.zones[1].widgets\" dragula-scope=\"vm.ctrlScope\" \nclass=\"widgets-container dragula-container sort-widgets\" layout=\"column\" flex></div></div></div></div><div \nng-if=\"row.type_layout == \'secondary\'\" layout=\"row\" flex=\"100\"><div class=\"zone-content\" flex=\"100\" layout=\"row\" \nlayout-align=\"space-between start\"><div with=\"row.zones[0].widgets\" as=\"widgets\" class=\"zone white-bg m-10 p-20\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\"><div class=\"grey-600-fg zone-name\" layout=\"row\" \nlayout-align=\"space-between center\"><span>SECONDARY CONTENT</span></div><div \nng-include=\"\'app/main/apps/sitemap/views/edit/tabs/layout-sections/widget-list.html\'\" dragula=\"\'widget\'\" \ndragula-model=\"row.zones[0].widgets\" dragula-scope=\"vm.ctrlScope\" \nclass=\"widgets-container dragula-container sort-widgets\" layout=\"column\" flex></div></div><div \nwith=\"row.zones[1].widgets\" as=\"widgets\" class=\"zone white-bg m-10 p-20\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\">\n<div class=\"grey-600-fg zone-name\" layout=\"row\" layout-align=\"space-between center\"><span>SECONDARY CONTENT</span>\n</div><div ng-include=\"\'app/main/apps/sitemap/views/edit/tabs/layout-sections/widget-list.html\'\" dragula=\"\'widget\'\" \ndragula-model=\"row.zones[1].widgets\" dragula-scope=\"vm.ctrlScope\" \nclass=\"widgets-container dragula-container sort-widgets\" layout=\"column\" flex></div></div></div></div><div \nng-if=\"row.type_layout == \'threecols\'\" layout=\"row\" flex=\"100\"><div class=\"zone-content\" flex=\"100\" layout=\"row\" \nlayout-align=\"space-between start\"><div with=\"row.zones[0].widgets\" as=\"widgets\" class=\"zone white-bg m-10 p-20\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"33\"><div class=\"grey-600-fg zone-name\" layout=\"row\" \nlayout-align=\"space-between center\"><span>3 COLUMNS</span></div><div \nng-include=\"\'app/main/apps/sitemap/views/edit/tabs/layout-sections/widget-list.html\'\" dragula=\"\'widget\'\" \ndragula-model=\"row.zones[0].widgets\" dragula-scope=\"vm.ctrlScope\" \nclass=\"widgets-container dragula-container sort-widgets\" layout=\"column\" flex></div></div><div \nwith=\"row.zones[1].widgets\" as=\"widgets\" class=\"zone white-bg m-10 p-20\" layout=\"column\" flex=\"100\" flex-gt-xs=\"33\">\n<div class=\"grey-600-fg zone-name\" layout=\"row\" layout-align=\"space-between center\"><span>3 COLUMNS</span></div><div \nng-include=\"\'app/main/apps/sitemap/views/edit/tabs/layout-sections/widget-list.html\'\" dragula=\"\'widget\'\" \ndragula-model=\"row.zones[1].widgets\" dragula-scope=\"vm.ctrlScope\" \nclass=\"widgets-container dragula-container sort-widgets\" layout=\"column\" flex></div></div><div \nwith=\"row.zones[2].widgets\" as=\"widgets\" class=\"zone white-bg m-10 p-20\" layout=\"column\" flex=\"100\" flex-gt-xs=\"33\">\n<div class=\"grey-600-fg zone-name\" layout=\"row\" layout-align=\"space-between center\"><span>3 COLUMNS</span></div><div \nng-include=\"\'app/main/apps/sitemap/views/edit/tabs/layout-sections/widget-list.html\'\" dragula=\"\'widget\'\" \ndragula-model=\"row.zones[2].widgets\" dragula-scope=\"vm.ctrlScope\" \nclass=\"widgets-container dragula-container sort-widgets\" layout=\"column\" flex></div></div></div></div><div \nng-if=\"vm.editMode == true && vm.nolayout == false\" class=\"tools\" layout=\"column\" layout-align=\"center center\"><md-icon\n ng-click=\"row.is_hidden= 1;\" ng-if=\"row.is_hidden == 0\" md-font-icon=\"icon-checkbox-blank-circle-outline\" \nclass=\"off red-fg s24\"></md-icon><md-icon ng-click=\"row.is_hidden= 0;\" ng-if=\"row.is_hidden !== 0\" \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\"></md-icon><md-menu><md-button \nclass=\"md-icon-button\" aria-label=\"More\" ng-click=\"vm.openMenu($mdMenu, $event)\"><md-icon md-font-icon=\"icon-cog\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"vm.addRowLayout(\'duplicate\',row )\" \naria-label=\"Duplicate\"><md-icon md-font-icon=\"icon-content-duplicate\"></md-icon><span translate=\"SITEMAP.DUPLICATE\">\n</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.currentSitemap.sitemap_data.splice($index, 1)\" \naria-label=\"Delete\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span translate=\"SITEMAP.DELETE\"></span></md-button>\n</md-menu-item></md-menu-content></md-menu><md-icon class=\"dragZ icon-equal\" aria-label=\"DRAG\"></md-icon></div></div>\n<div ng-if=\"vm.editMode == true && vm.nolayout == false && toggleFooter\" layout=\"column\" class=\"pb-5\"><div \nlayout=\"column\" layout-align=\"center center\" flex=\"100\" class=\"white-bg mh-15 mv-5 border\"><div class=\"content\" \nlayout=\"column\" layout-align=\"top center\"><div class=\"message\"><md-button class=\"add-event-button md-fab md-warn ml-0\" \naria-label=\"ADD\" ng-click=\"vm.closeSidenav(\'widgets-sidenav\'); vm.toggleSidenav(\'layout-sidenav\')\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button><span class=\"font-size-16 grey-500-fg\" translate=\"SITEMAP.ADD_ROW\">\n</span></div><div class=\"message\" translate=\"SITEMAP.NO_PREVIEW_AVAILABLE\" ng-if=\"vm.editMode == false\"></div></div>\n</div></div></div>");
$templateCache.put("app/main/apps/sitemap/views/edit/tabs/layout-sections/layout-header.html","<div layout=\"column\" class=\"pb-5 grey-100-bg row-container border-top\" dragula=\"\'zone\'\" \ndragula-model=\"vm.currentSitemap.sitemap_data\" dragula-scope=\"vm.ctrlScope\" \nng-class=\"{\'active grey-200-bg\':toggleHeader}\"><div class=\"md-toolbar-tools pl-20 pr-5\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><h3 class=\"grey-700-fg\" \ntranslate=\"SITEMAP.HEADER\"></h3></div><div layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" \nng-click=\"toggleHeader= !toggleHeader\"><md-icon md-font-icon=\"icon-chevron-down\" class=\"s24\" \nng-class=\"{\'icon-chevron-up\':toggleHeader}\"></md-icon></md-button></div></div><div \nng-repeat=\"row in vm.currentSitemap.sitemap_data\" layout=\"row\" layout-align=\"space-between center\" flex=\"100\" \nclass=\"zone-row pl-5 pr-5\" ng-class=\"{\'opacity-4\':row.is_hidden == 0}\" ng-if=\"toggleHeader\"><div \nng-if=\"row.type_layout==\'full-width\'\" flex=\"100\" layout=\"row\" layout-align=\"space-between start\"><div \nwith=\"row.zones[0].widgets\" as=\"widgets\" class=\"zone white-bg m-10 p-20\" layout=\"column\" flex=\"100\"><div \nclass=\"grey-600-fg zone-name\" layout=\"row\" layout-align=\"space-between center\"><span>FULL WIDTH</span></div><div \nng-include=\"\'app/main/apps/sitemap/views/edit/tabs/layout-sections/widget-list.html\'\" dragula=\"\'widget\'\" \ndragula-model=\"row.zones[0].widgets\" dragula-scope=\"vm.ctrlScope\" \nclass=\"widgets-container dragula-container sort-widgets\" layout=\"column\" flex></div></div></div><div \nng-if=\"row.type_layout==\'primary\'\" layout=\"row\" flex=\"100\"><div class=\"zone-content\" flex=\"100\" layout=\"row\" \nlayout-align=\"space-between start\"><div with=\"row.zones[0].widgets\" as=\"widgets\" class=\"zone white-bg m-10 p-20\" \nlayout=\"column\" flex=\"60\"><div class=\"grey-600-fg zone-name\" layout=\"row\" layout-align=\"space-between center\"><span>\nPRIMARY CONTENT</span></div><div ng-include=\"\'app/main/apps/sitemap/views/edit/tabs/layout-sections/widget-list.html\'\" \ndragula=\"\'widget\'\" dragula-model=\"row.zones[0].widgets\" dragula-scope=\"vm.ctrlScope\" \nclass=\"widgets-container dragula-container sort-widgets\" layout=\"column\" flex></div></div><div \nwith=\"row.zones[1].widgets\" as=\"widgets\" class=\"zone white-bg m-10 p-20\" layout=\"column\" flex=\"40\"><div \nclass=\"grey-600-fg zone-name\" layout=\"row\" layout-align=\"space-between center\"><span>RELATED CONTENT</span></div><div \nng-include=\"\'app/main/apps/sitemap/views/edit/tabs/layout-sections/widget-list.html\'\" dragula=\"\'widget\'\" \ndragula-model=\"row.zones[1].widgets\" dragula-scope=\"vm.ctrlScope\" \nclass=\"widgets-container dragula-container sort-widgets\" layout=\"column\" flex></div></div></div></div><div \nng-if=\"row.type_layout==\'secondary\'\" layout=\"row\" flex=\"100\"><div class=\"zone-content\" flex=\"100\" layout=\"row\" \nlayout-align=\"space-between start\"><div with=\"row.zones[0].widgets\" as=\"widgets\" class=\"zone white-bg m-10 p-20\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\"><div class=\"grey-600-fg zone-name\" layout=\"row\" \nlayout-align=\"space-between center\"><span>SECONDARY CONTENT</span></div><div \nng-include=\"\'app/main/apps/sitemap/views/edit/tabs/layout-sections/widget-list.html\'\" dragula=\"\'widget\'\" \ndragula-model=\"row.zones[0].widgets\" dragula-scope=\"vm.ctrlScope\" \nclass=\"widgets-container dragula-container sort-widgets\" layout=\"column\" flex></div></div><div \nwith=\"row.zones[1].widgets\" as=\"widgets\" class=\"zone white-bg m-10 p-20\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\">\n<div class=\"grey-600-fg zone-name\" layout=\"row\" layout-align=\"space-between center\"><span>SECONDARY CONTENT</span>\n</div><div ng-include=\"\'app/main/apps/sitemap/views/edit/tabs/layout-sections/widget-list.html\'\" dragula=\"\'widget\'\" \ndragula-model=\"row.zones[1].widgets\" dragula-scope=\"vm.ctrlScope\" \nclass=\"widgets-container dragula-container sort-widgets\" layout=\"column\" flex></div></div></div></div><div \nng-if=\"row.type_layout==\'threecols\'\" layout=\"row\" flex=\"100\"><div class=\"zone-content\" flex=\"100\" layout=\"row\" \nlayout-align=\"space-between start\"><div with=\"row.zones[0].widgets\" as=\"widgets\" class=\"zone white-bg m-10 p-20\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"33\"><div class=\"grey-600-fg zone-name\" layout=\"row\" \nlayout-align=\"space-between center\"><span>3 COLUMNS</span></div><div \nng-include=\"\'app/main/apps/sitemap/views/edit/tabs/layout-sections/widget-list.html\'\" dragula=\"\'widget\'\" \ndragula-model=\"row.zones[0].widgets\" dragula-scope=\"vm.ctrlScope\" \nclass=\"widgets-container dragula-container sort-widgets\" layout=\"column\" flex></div></div><div \nwith=\"row.zones[1].widgets\" as=\"widgets\" class=\"zone white-bg m-10 p-20\" layout=\"column\" flex=\"100\" flex-gt-xs=\"33\">\n<div class=\"grey-600-fg zone-name\" layout=\"row\" layout-align=\"space-between center\"><span>3 COLUMNS</span></div><div \nng-include=\"\'app/main/apps/sitemap/views/edit/tabs/layout-sections/widget-list.html\'\" dragula=\"\'widget\'\" \ndragula-model=\"row.zones[1].widgets\" dragula-scope=\"vm.ctrlScope\" \nclass=\"widgets-container dragula-container sort-widgets\" layout=\"column\" flex></div></div><div \nwith=\"row.zones[2].widgets\" as=\"widgets\" class=\"zone white-bg m-10 p-20\" layout=\"column\" flex=\"100\" flex-gt-xs=\"33\">\n<div class=\"grey-600-fg zone-name\" layout=\"row\" layout-align=\"space-between center\"><span>3 COLUMNS</span></div><div \nng-include=\"\'app/main/apps/sitemap/views/edit/tabs/layout-sections/widget-list.html\'\" dragula=\"\'widget\'\" \ndragula-model=\"row.zones[2].widgets\" dragula-scope=\"vm.ctrlScope\" \nclass=\"widgets-container dragula-container sort-widgets\" layout=\"column\" flex></div></div></div></div><div \nng-if=\"vm.editMode == true && vm.nolayout == false\" class=\"tools\" layout=\"column\" layout-align=\"center center\"><md-icon\n ng-click=\"row.is_hidden= 1;\" ng-if=\"row.is_hidden == 0\" md-font-icon=\"icon-checkbox-blank-circle-outline\" \nclass=\"off red-fg s24\"></md-icon><md-icon ng-click=\"row.is_hidden= 0;\" ng-if=\"row.is_hidden !== 0\" \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s24\"></md-icon><md-menu><md-button \nclass=\"md-icon-button\" aria-label=\"More\" ng-click=\"vm.openMenu($mdMenu, $event)\"><md-icon md-font-icon=\"icon-cog\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"vm.addRowLayout(\'duplicate\',row )\" \naria-label=\"Duplicate\"><md-icon md-font-icon=\"icon-content-duplicate\"></md-icon><span translate=\"SITEMAP.DUPLICATE\">\n</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.currentSitemap.sitemap_data.splice($index, 1)\" \naria-label=\"Delete\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span translate=\"SITEMAP.DELETE\"></span></md-button>\n</md-menu-item></md-menu-content></md-menu><md-icon class=\"dragZ icon-equal\" aria-label=\"DRAG\"></md-icon></div></div>\n<div ng-if=\"vm.editMode == true && vm.nolayout == false && toggleHeader\" layout=\"column\" class=\"pb-5\"><div \nlayout=\"column\" layout-align=\"center center\" flex=\"100\" class=\"white-bg mh-15 mv-5 border\"><div class=\"content\" \nlayout=\"column\" layout-align=\"top center\"><div class=\"message\"><md-button class=\"add-event-button md-fab md-warn ml-0\" \naria-label=\"ADD\" ng-click=\"vm.closeSidenav(\'widgets-sidenav\'); vm.toggleSidenav(\'layout-sidenav\')\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button><span class=\"font-size-16 grey-500-fg\" translate=\"SITEMAP.ADD_ROW\">\n</span></div><div class=\"message\" translate=\"SITEMAP.NO_PREVIEW_AVAILABLE\" ng-if=\"vm.editMode == false\"></div></div>\n</div></div></div>");
$templateCache.put("app/main/apps/sitemap/views/edit/tabs/layout-sections/layout-settings.html","<div class=\"ph-15 pt-20 pb-10\" layout=\"column\" layout-gt-md=\"row\" ng-if=\"vm.nolayout == false\"><md-input-container \nflex class=\"md-block mh-5\"><label translate=\"SITEMAP.HEADER\"></label><md-select \nplaceholder=\"{{vm.translate(\'SITEMAP.HEADER\')}}\" ng-model=\"vm.currentSitemap.id_header\"><md-option value=\"\">---\n</md-option><md-option ng-repeat=\"opt in vm.currentOptions.headers track by $index\" value=\"{{opt.id_header}}\">\n{{opt.name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block mh-5 flex\"><label \ntranslate=\"SITEMAP.BODY_CLASS\"></label><input type=\"text\" ng-model=\"vm.currentSitemap.body_class\" \nplaceholder=\"{{vm.translate(\'SITEMAP.BODY_CLASS\')}}\"></md-input-container></div>");
$templateCache.put("app/main/apps/sitemap/views/edit/tabs/layout-sections/layout-toolbar.html","<div class=\"md-toolbar-tools pl-20 pr-5 grey-200-bg border-top\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><h3 class=\"grey-700-fg\" translate=\"SITEMAP.LAYOUT\"></h3></div><div \nlayout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" ng-class=\"{\'md-accent\':vm.editMode == true}\" \nng-style=\"{\'opacity\': vm.editMode ? 1 : 0.3}\"><md-icon md-font-icon=\"icon-pencil\" class=\"s24\"></md-icon><md-tooltip>\n{{\'SITEMAP.EDIT_MODE\' | translate}}</md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-class=\"{\'md-accent\':vm.editMode == false}\" ng-style=\"{\'opacity\': !vm.editMode ? 1 : 0.3}\"><md-icon \nmd-font-icon=\"icon-eye\" class=\"s24\"></md-icon><md-tooltip>{{\'SITEMAP.PREVIEW_MODE\' | translate}}</md-tooltip>\n</md-button><div hide show-gt-xs class=\"divider-vertical\"></div><md-button hide show-gt-xs \nclass=\"md-accent md-raised md-button\" type=\"button\" aria-label=\"Actions\" \nng-click=\"vm.closeSidenav(\'layout-sidenav\'); vm.toggleSidenav(\'widgets-sidenav\')\" layout=\"row\" \nlayout-align=\"center-center\"><md-icon md-font-icon=\"icon-view-dashboard\" class=\"mr-5\" role=\"img\" aria-hidden=\"true\">\n</md-icon><span class=\"text-capitalized\">{{\'WIDGETS.WIDGETS\' | translate}}</span></md-button><md-button hide-gt-xs \nclass=\"md-accent md-mini md-raised md-fab md-button\" type=\"button\" aria-label=\"Actions\" \nng-click=\"vm.closeSidenav(\'layout-sidenav\'); vm.toggleSidenav(\'widgets-sidenav\')\" layout=\"row\" \nlayout-align=\"center-center\"><md-icon md-font-icon=\"icon-view-dashboard\" role=\"img\" aria-hidden=\"true\"></md-icon>\n</md-button><div hide show-gt-xs class=\"divider-vertical\"></div><md-button class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-fullscreen\" class=\"s24\"></md-icon><md-tooltip>{{\'SITEMAP.FULLSCREEN\' | translate}}</md-tooltip>\n</md-button></div></div>");
$templateCache.put("app/main/apps/sitemap/views/edit/tabs/layout-sections/widget-content.html","<div class=\"left-content\" layout=\"row\" layout-align=\"start center\"><button class=\"md-icon-button mr-10\"><md-icon \nng-click=\"widget.onoff= 1;\" ng-if=\"widget.onoff !== 1\" md-font-icon=\"icon-checkbox-blank-circle-outline\" \nclass=\"off red-fg s22\"></md-icon><md-icon ng-click=\"widget.onoff= 0;\" ng-if=\"widget.onoff == 1\" \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"on green-fg s22\"></md-icon></button><div \nng-if=\"widget.data.reference_name.length\" class=\"grey-600-fg widget-name\">\n{{widget.data.reference_name}} ({{widget.title}})</div><div ng-if=\"!widget.data.reference_name.length\" \nclass=\"grey-600-fg widget-name\">{{widget.title}}</div></div><div class=\"tools\" layout=\"row\"><div layout=\"row\"><md-icon \nmd-font-icon=\"icon-content-duplicate\" class=\"s18 opacity-4\" aria-label=\"SUBW\" ng-click=\"widget.showSub=1;\" \nng-if=\"widget.showSub !== 1\"><md-tooltip hide show-gt-xs><span>Show subwidgets</span></md-tooltip></md-icon><md-icon \nmd-font-icon=\"icon-content-duplicate\" class=\"s18 opacity-10\" aria-label=\"SUBW\" ng-click=\"widget.showSub=0;\" \nng-if=\"widget.showSub == 1\"><md-tooltip hide show-gt-xs><span>Hide subwidgets</span></md-tooltip></md-icon><div \nclass=\"bold text-center md-accent-bg rounded p-absolute sub-dot\" ng-click=\"widget.showSub=1;\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"widget.children.length !== 0 && widget.showSub !== 1\">{{widget.children.length}}\n</div></div><md-menu><md-button class=\"md-icon-button\" aria-label=\"More\" ng-click=\"vm.openMenu($mdMenu, $event)\">\n<md-icon md-font-icon=\"icon-cog\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \naria-label=\"Edit\" ng-click=\"vm.editWidgetDialog($event, widgets, widget, \'\')\"><md-icon md-font-icon=\"icon-pencil\">\n</md-icon><span translate=\"SITEMAP.EDIT\"></span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.duplicateWidget(widgets, widget)\" aria-label=\"Duplicate\"><md-icon md-font-icon=\"icon-content-duplicate\">\n</md-icon><span translate=\"SITEMAP.DUPLICATE\"></span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.saveWidgetAsTemplate(widget)\" aria-label=\"Edit\"><md-icon md-font-icon=\"icon-book-multiple-variant\">\n</md-icon><span translate=\"SITEMAP.SAVE_AS_TEMPLATE\"></span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"widgets.splice($index, 1)\" aria-label=\"Delete\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span \ntranslate=\"SITEMAP.DELETE\"></span></md-button></md-menu-item></md-menu-content></md-menu><md-icon \nclass=\"drag icon-equal\" aria-label=\"DRAG\"></md-icon></div>");
$templateCache.put("app/main/apps/sitemap/views/edit/tabs/layout-sections/widget-list.html","<md-button class=\"md-link md-button ml-auto mr-auto grey-400-fg\" type=\"button\" aria-label=\"Actions\" \nng-click=\"vm.closeSidenav(\'layout-sidenav\'); vm.toggleSidenav(\'widgets-sidenav\')\" layout=\"row\" \nlayout-align=\"center-center\" ng-if=\"widgets.length == 0\"><md-icon md-font-icon=\"icon-plus-circle\" \nclass=\"mr-5 grey-400-fg\" role=\"img\" aria-hidden=\"true\"></md-icon><span class=\"text-capitalized\">\n{{\'WIDGETS.WIDGETS\' | translate}}</span></md-button><div ng-repeat=\"widget in widgets\" class=\"widget-item p-10\" \nng-class=\"{\'off\' : widget.onoff !== 1,\'on\' : widget.onoff == 1,\'subwidgets\' : widget.showSub == 1 }\" layout=\"column\" \nlayout-align=\"center stretch\" flex=\"100\"><div class=\"widget-item-content\" layout=\"row\" \nlayout-align=\"space-between center\" flex=\"100\" \nng-include=\"\'app/main/apps/sitemap/views/edit/tabs/layout-sections/widget-content.html\'\"></div><div \nclass=\"widget-item-children\" with=\"widget.children\" as=\"widgets\" \nng-class=\"{\'empty\' : widget.children.length == 0,\'empty\' : widget.showSub !== 1}\"><div \nid=\"children-{{widget.$$hashKey}}\" ng-init=\"vm.initArray(widgets)\" ng-class=\"{\'dashed\': widgets.length == 0}\" \nclass=\"container-drag-children sort-widgets dragula-container\" \nng-include=\"\'app/main/apps/sitemap/views/edit/tabs/layout-sections/widget-list.html\'\"></div></div></div>");}]);